
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire10c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire10c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7B2bR", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $587db01302e19550$export$ffb0004e005737fa, (v) => $587db01302e19550$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $587db01302e19550$export$34b9dba7ce09269b, (v) => $587db01302e19550$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $587db01302e19550$export$25062201e9e25d76, (v) => $587db01302e19550$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $587db01302e19550$export$ffb0004e005737fa;
var $587db01302e19550$export$34b9dba7ce09269b;
var $587db01302e19550$export$25062201e9e25d76;
"use strict";

(function() {
    function getComponentNameFromType(type) {
        if (null == type) return null;
        if ("function" === typeof type) return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
        if ("string" === typeof type) return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
            case REACT_ACTIVITY_TYPE:
                return "Activity";
        }
        if ("object" === typeof type) switch("number" === typeof type.tag && console.error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), type.$$typeof){
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_CONTEXT_TYPE:
                return type.displayName || "Context";
            case REACT_CONSUMER_TYPE:
                return (type._context.displayName || "Context") + ".Consumer";
            case REACT_FORWARD_REF_TYPE:
                var innerType = type.render;
                type = type.displayName;
                type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
                return type;
            case REACT_MEMO_TYPE:
                return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                innerType = type._payload;
                type = type._init;
                try {
                    return getComponentNameFromType(type(innerType));
                } catch (x) {}
        }
        return null;
    }
    function testStringCoercion(value) {
        return "" + value;
    }
    function checkKeyStringCoercion(value) {
        try {
            testStringCoercion(value);
            var JSCompiler_inline_result = !1;
        } catch (e) {
            JSCompiler_inline_result = !0;
        }
        if (JSCompiler_inline_result) {
            JSCompiler_inline_result = console;
            var JSCompiler_temp_const = JSCompiler_inline_result.error;
            var JSCompiler_inline_result$jscomp$0 = "function" === typeof Symbol && Symbol.toStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
            JSCompiler_temp_const.call(JSCompiler_inline_result, "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.", JSCompiler_inline_result$jscomp$0);
            return testStringCoercion(value);
        }
    }
    function getTaskName(type) {
        if (type === REACT_FRAGMENT_TYPE) return "<>";
        if ("object" === typeof type && null !== type && type.$$typeof === REACT_LAZY_TYPE) return "<...>";
        try {
            var name = getComponentNameFromType(type);
            return name ? "<" + name + ">" : "<...>";
        } catch (x) {
            return "<...>";
        }
    }
    function getOwner() {
        var dispatcher = ReactSharedInternals.A;
        return null === dispatcher ? null : dispatcher.getOwner();
    }
    function UnknownOwner() {
        return Error("react-stack-top-frame");
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) return !1;
        }
        return void 0 !== config.key;
    }
    function defineKeyPropWarningGetter(props, displayName) {
        function warnAboutAccessingKey() {
            specialPropKeyWarningShown || (specialPropKeyWarningShown = !0, console.error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)", displayName));
        }
        warnAboutAccessingKey.isReactWarning = !0;
        Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: !0
        });
    }
    function elementRefGetterWithDeprecationWarning() {
        var componentName = getComponentNameFromType(this.type);
        didWarnAboutElementRef[componentName] || (didWarnAboutElementRef[componentName] = !0, console.error("Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."));
        componentName = this.props.ref;
        return void 0 !== componentName ? componentName : null;
    }
    function ReactElement(type, key, props, owner, debugStack, debugTask) {
        var refProp = props.ref;
        type = {
            $$typeof: REACT_ELEMENT_TYPE,
            type: type,
            key: key,
            props: props,
            _owner: owner
        };
        null !== (void 0 !== refProp ? refProp : null) ? Object.defineProperty(type, "ref", {
            enumerable: !1,
            get: elementRefGetterWithDeprecationWarning
        }) : Object.defineProperty(type, "ref", {
            enumerable: !1,
            value: null
        });
        type._store = {};
        Object.defineProperty(type._store, "validated", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: 0
        });
        Object.defineProperty(type, "_debugInfo", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: null
        });
        Object.defineProperty(type, "_debugStack", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: debugStack
        });
        Object.defineProperty(type, "_debugTask", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: debugTask
        });
        Object.freeze && (Object.freeze(type.props), Object.freeze(type));
        return type;
    }
    function jsxDEVImpl(type, config, maybeKey, isStaticChildren, debugStack, debugTask) {
        var children = config.children;
        if (void 0 !== children) {
            if (isStaticChildren) {
                if (isArrayImpl(children)) {
                    for(isStaticChildren = 0; isStaticChildren < children.length; isStaticChildren++)validateChildKeys(children[isStaticChildren]);
                    Object.freeze && Object.freeze(children);
                } else console.error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            } else validateChildKeys(children);
        }
        if (hasOwnProperty.call(config, "key")) {
            children = getComponentNameFromType(type);
            var keys = Object.keys(config).filter(function(k) {
                return "key" !== k;
            });
            isStaticChildren = 0 < keys.length ? "{key: someKey, " + keys.join(": ..., ") + ": ...}" : "{key: someKey}";
            didWarnAboutKeySpread[children + isStaticChildren] || (keys = 0 < keys.length ? "{" + keys.join(": ..., ") + ": ...}" : "{}", console.error('A props object containing a "key" prop is being spread into JSX:\n  let props = %s;\n  <%s {...props} />\nReact keys must be passed directly to JSX without using spread:\n  let props = %s;\n  <%s key={someKey} {...props} />', isStaticChildren, children, keys, children), didWarnAboutKeySpread[children + isStaticChildren] = !0);
        }
        children = null;
        void 0 !== maybeKey && (checkKeyStringCoercion(maybeKey), children = "" + maybeKey);
        hasValidKey(config) && (checkKeyStringCoercion(config.key), children = "" + config.key);
        if ("key" in config) {
            maybeKey = {};
            for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
        } else maybeKey = config;
        children && defineKeyPropWarningGetter(maybeKey, "function" === typeof type ? type.displayName || type.name || "Unknown" : type);
        return ReactElement(type, children, maybeKey, getOwner(), debugStack, debugTask);
    }
    function validateChildKeys(node) {
        isValidElement(node) ? node._store && (node._store.validated = 1) : "object" === typeof node && null !== node && node.$$typeof === REACT_LAZY_TYPE && ("fulfilled" === node._payload.status ? isValidElement(node._payload.value) && node._payload.value._store && (node._payload.value._store.validated = 1) : node._store && (node._store.validated = 1));
    }
    function isValidElement(object) {
        return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    var React = (parcelRequire("acw62")), REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference"), ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, hasOwnProperty = Object.prototype.hasOwnProperty, isArrayImpl = Array.isArray, createTask = console.createTask ? console.createTask : function() {
        return null;
    };
    React = {
        react_stack_bottom_frame: function(callStackForError) {
            return callStackForError();
        }
    };
    var specialPropKeyWarningShown;
    var didWarnAboutElementRef = {};
    var unknownOwnerDebugStack = React.react_stack_bottom_frame.bind(React, UnknownOwner)();
    var unknownOwnerDebugTask = createTask(getTaskName(UnknownOwner));
    var didWarnAboutKeySpread = {};
    $587db01302e19550$export$ffb0004e005737fa = REACT_FRAGMENT_TYPE;
    $587db01302e19550$export$34b9dba7ce09269b = function(type, config, maybeKey) {
        var trackActualOwner = 1e4 > ReactSharedInternals.recentlyCreatedOwnerStacks++;
        return jsxDEVImpl(type, config, maybeKey, !1, trackActualOwner ? Error("react-stack-top-frame") : unknownOwnerDebugStack, trackActualOwner ? createTask(getTaskName(type)) : unknownOwnerDebugTask);
    };
    $587db01302e19550$export$25062201e9e25d76 = function(type, config, maybeKey) {
        var trackActualOwner = 1e4 > ReactSharedInternals.recentlyCreatedOwnerStacks++;
        return jsxDEVImpl(type, config, maybeKey, !0, trackActualOwner ? Error("react-stack-top-frame") : unknownOwnerDebugStack, trackActualOwner ? createTask(getTaskName(type)) : unknownOwnerDebugTask);
    };
})();

});
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jWQW9"));

});
parcelRegister("jWQW9", function(module, exports) {
/**
 * @license React
 * react.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
(function() {
    function defineDeprecationWarning(methodName, info) {
        Object.defineProperty(Component.prototype, methodName, {
            get: function() {
                console.warn("%s(...) is deprecated in plain JavaScript React classes. %s", info[0], info[1]);
            }
        });
    }
    function getIteratorFn(maybeIterable) {
        if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
        maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
        return "function" === typeof maybeIterable ? maybeIterable : null;
    }
    function warnNoop(publicInstance, callerName) {
        publicInstance = (publicInstance = publicInstance.constructor) && (publicInstance.displayName || publicInstance.name) || "ReactClass";
        var warningKey = publicInstance + "." + callerName;
        didWarnStateUpdateForUnmountedComponent[warningKey] || (console.error("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", callerName, publicInstance), didWarnStateUpdateForUnmountedComponent[warningKey] = !0);
    }
    function Component(props, context, updater) {
        this.props = props;
        this.context = context;
        this.refs = emptyObject;
        this.updater = updater || ReactNoopUpdateQueue;
    }
    function ComponentDummy() {}
    function PureComponent(props, context, updater) {
        this.props = props;
        this.context = context;
        this.refs = emptyObject;
        this.updater = updater || ReactNoopUpdateQueue;
    }
    function noop() {}
    function testStringCoercion(value) {
        return "" + value;
    }
    function checkKeyStringCoercion(value) {
        try {
            testStringCoercion(value);
            var JSCompiler_inline_result = !1;
        } catch (e) {
            JSCompiler_inline_result = !0;
        }
        if (JSCompiler_inline_result) {
            JSCompiler_inline_result = console;
            var JSCompiler_temp_const = JSCompiler_inline_result.error;
            var JSCompiler_inline_result$jscomp$0 = "function" === typeof Symbol && Symbol.toStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
            JSCompiler_temp_const.call(JSCompiler_inline_result, "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.", JSCompiler_inline_result$jscomp$0);
            return testStringCoercion(value);
        }
    }
    function getComponentNameFromType(type) {
        if (null == type) return null;
        if ("function" === typeof type) return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
        if ("string" === typeof type) return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
            case REACT_ACTIVITY_TYPE:
                return "Activity";
        }
        if ("object" === typeof type) switch("number" === typeof type.tag && console.error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), type.$$typeof){
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_CONTEXT_TYPE:
                return type.displayName || "Context";
            case REACT_CONSUMER_TYPE:
                return (type._context.displayName || "Context") + ".Consumer";
            case REACT_FORWARD_REF_TYPE:
                var innerType = type.render;
                type = type.displayName;
                type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
                return type;
            case REACT_MEMO_TYPE:
                return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                innerType = type._payload;
                type = type._init;
                try {
                    return getComponentNameFromType(type(innerType));
                } catch (x) {}
        }
        return null;
    }
    function getTaskName(type) {
        if (type === REACT_FRAGMENT_TYPE) return "<>";
        if ("object" === typeof type && null !== type && type.$$typeof === REACT_LAZY_TYPE) return "<...>";
        try {
            var name = getComponentNameFromType(type);
            return name ? "<" + name + ">" : "<...>";
        } catch (x) {
            return "<...>";
        }
    }
    function getOwner() {
        var dispatcher = ReactSharedInternals.A;
        return null === dispatcher ? null : dispatcher.getOwner();
    }
    function UnknownOwner() {
        return Error("react-stack-top-frame");
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) return !1;
        }
        return void 0 !== config.key;
    }
    function defineKeyPropWarningGetter(props, displayName) {
        function warnAboutAccessingKey() {
            specialPropKeyWarningShown || (specialPropKeyWarningShown = !0, console.error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)", displayName));
        }
        warnAboutAccessingKey.isReactWarning = !0;
        Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: !0
        });
    }
    function elementRefGetterWithDeprecationWarning() {
        var componentName = getComponentNameFromType(this.type);
        didWarnAboutElementRef[componentName] || (didWarnAboutElementRef[componentName] = !0, console.error("Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."));
        componentName = this.props.ref;
        return void 0 !== componentName ? componentName : null;
    }
    function ReactElement(type, key, props, owner, debugStack, debugTask) {
        var refProp = props.ref;
        type = {
            $$typeof: REACT_ELEMENT_TYPE,
            type: type,
            key: key,
            props: props,
            _owner: owner
        };
        null !== (void 0 !== refProp ? refProp : null) ? Object.defineProperty(type, "ref", {
            enumerable: !1,
            get: elementRefGetterWithDeprecationWarning
        }) : Object.defineProperty(type, "ref", {
            enumerable: !1,
            value: null
        });
        type._store = {};
        Object.defineProperty(type._store, "validated", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: 0
        });
        Object.defineProperty(type, "_debugInfo", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: null
        });
        Object.defineProperty(type, "_debugStack", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: debugStack
        });
        Object.defineProperty(type, "_debugTask", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: debugTask
        });
        Object.freeze && (Object.freeze(type.props), Object.freeze(type));
        return type;
    }
    function cloneAndReplaceKey(oldElement, newKey) {
        newKey = ReactElement(oldElement.type, newKey, oldElement.props, oldElement._owner, oldElement._debugStack, oldElement._debugTask);
        oldElement._store && (newKey._store.validated = oldElement._store.validated);
        return newKey;
    }
    function validateChildKeys(node) {
        isValidElement(node) ? node._store && (node._store.validated = 1) : "object" === typeof node && null !== node && node.$$typeof === REACT_LAZY_TYPE && ("fulfilled" === node._payload.status ? isValidElement(node._payload.value) && node._payload.value._store && (node._payload.value._store.validated = 1) : node._store && (node._store.validated = 1));
    }
    function isValidElement(object) {
        return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function escape(key) {
        var escaperLookup = {
            "=": "=0",
            ":": "=2"
        };
        return "$" + key.replace(/[=:]/g, function(match) {
            return escaperLookup[match];
        });
    }
    function getElementKey(element, index) {
        return "object" === typeof element && null !== element && null != element.key ? (checkKeyStringCoercion(element.key), escape("" + element.key)) : index.toString(36);
    }
    function resolveThenable(thenable) {
        switch(thenable.status){
            case "fulfilled":
                return thenable.value;
            case "rejected":
                throw thenable.reason;
            default:
                switch("string" === typeof thenable.status ? thenable.then(noop, noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                    "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
                }, function(error) {
                    "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
                })), thenable.status){
                    case "fulfilled":
                        return thenable.value;
                    case "rejected":
                        throw thenable.reason;
                }
        }
        throw thenable;
    }
    function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
        var type = typeof children;
        if ("undefined" === type || "boolean" === type) children = null;
        var invokeCallback = !1;
        if (null === children) invokeCallback = !0;
        else switch(type){
            case "bigint":
            case "string":
            case "number":
                invokeCallback = !0;
                break;
            case "object":
                switch(children.$$typeof){
                    case REACT_ELEMENT_TYPE:
                    case REACT_PORTAL_TYPE:
                        invokeCallback = !0;
                        break;
                    case REACT_LAZY_TYPE:
                        return invokeCallback = children._init, mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
                }
        }
        if (invokeCallback) {
            invokeCallback = children;
            callback = callback(invokeCallback);
            var childKey = "" === nameSoFar ? "." + getElementKey(invokeCallback, 0) : nameSoFar;
            isArrayImpl(callback) ? (escapedPrefix = "", null != childKey && (escapedPrefix = childKey.replace(userProvidedKeyEscapeRegex, "$&/") + "/"), mapIntoArray(callback, array, escapedPrefix, "", function(c) {
                return c;
            })) : null != callback && (isValidElement(callback) && (null != callback.key && (invokeCallback && invokeCallback.key === callback.key || checkKeyStringCoercion(callback.key)), escapedPrefix = cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || invokeCallback && invokeCallback.key === callback.key ? "" : ("" + callback.key).replace(userProvidedKeyEscapeRegex, "$&/") + "/") + childKey), "" !== nameSoFar && null != invokeCallback && isValidElement(invokeCallback) && null == invokeCallback.key && invokeCallback._store && !invokeCallback._store.validated && (escapedPrefix._store.validated = 2), callback = escapedPrefix), array.push(callback));
            return 1;
        }
        invokeCallback = 0;
        childKey = "" === nameSoFar ? "." : nameSoFar + ":";
        if (isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = childKey + getElementKey(nameSoFar, i), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
        else if (i = getIteratorFn(children), "function" === typeof i) for(i === children.entries && (didWarnAboutMaps || console.warn("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), didWarnAboutMaps = !0), children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = childKey + getElementKey(nameSoFar, i++), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
        else if ("object" === type) {
            if ("function" === typeof children.then) return mapIntoArray(resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
            array = String(children);
            throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
        }
        return invokeCallback;
    }
    function mapChildren(children, func, context) {
        if (null == children) return children;
        var result = [], count = 0;
        mapIntoArray(children, result, "", "", function(child) {
            return func.call(context, child, count++);
        });
        return result;
    }
    function lazyInitializer(payload) {
        if (-1 === payload._status) {
            var ioInfo = payload._ioInfo;
            null != ioInfo && (ioInfo.start = ioInfo.end = performance.now());
            ioInfo = payload._result;
            var thenable = ioInfo();
            thenable.then(function(moduleObject) {
                if (0 === payload._status || -1 === payload._status) {
                    payload._status = 1;
                    payload._result = moduleObject;
                    var _ioInfo = payload._ioInfo;
                    null != _ioInfo && (_ioInfo.end = performance.now());
                    void 0 === thenable.status && (thenable.status = "fulfilled", thenable.value = moduleObject);
                }
            }, function(error) {
                if (0 === payload._status || -1 === payload._status) {
                    payload._status = 2;
                    payload._result = error;
                    var _ioInfo2 = payload._ioInfo;
                    null != _ioInfo2 && (_ioInfo2.end = performance.now());
                    void 0 === thenable.status && (thenable.status = "rejected", thenable.reason = error);
                }
            });
            ioInfo = payload._ioInfo;
            if (null != ioInfo) {
                ioInfo.value = thenable;
                var displayName = thenable.displayName;
                "string" === typeof displayName && (ioInfo.name = displayName);
            }
            -1 === payload._status && (payload._status = 0, payload._result = thenable);
        }
        if (1 === payload._status) return ioInfo = payload._result, void 0 === ioInfo && console.error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))\n\nDid you accidentally put curly braces around the import?", ioInfo), "default" in ioInfo || console.error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))", ioInfo), ioInfo.default;
        throw payload._result;
    }
    function resolveDispatcher() {
        var dispatcher = ReactSharedInternals.H;
        null === dispatcher && console.error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.");
        return dispatcher;
    }
    function releaseAsyncTransition() {
        ReactSharedInternals.asyncTransitions--;
    }
    function enqueueTask(task) {
        if (null === enqueueTaskImpl) try {
            var requireString = ("require" + Math.random()).slice(0, 7);
            enqueueTaskImpl = (module && module[requireString]).call(module, "timers").setImmediate;
        } catch (_err) {
            enqueueTaskImpl = function(callback) {
                !1 === didWarnAboutMessageChannel && (didWarnAboutMessageChannel = !0, "undefined" === typeof MessageChannel && console.error("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning."));
                var channel = new MessageChannel();
                channel.port1.onmessage = callback;
                channel.port2.postMessage(void 0);
            };
        }
        return enqueueTaskImpl(task);
    }
    function aggregateErrors(errors) {
        return 1 < errors.length && "function" === typeof AggregateError ? new AggregateError(errors) : errors[0];
    }
    function popActScope(prevActQueue, prevActScopeDepth) {
        prevActScopeDepth !== actScopeDepth - 1 && console.error("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. ");
        actScopeDepth = prevActScopeDepth;
    }
    function recursivelyFlushAsyncActWork(returnValue, resolve, reject) {
        var queue = ReactSharedInternals.actQueue;
        if (null !== queue) {
            if (0 !== queue.length) try {
                flushActQueue(queue);
                enqueueTask(function() {
                    return recursivelyFlushAsyncActWork(returnValue, resolve, reject);
                });
                return;
            } catch (error) {
                ReactSharedInternals.thrownErrors.push(error);
            }
            else ReactSharedInternals.actQueue = null;
        }
        0 < ReactSharedInternals.thrownErrors.length ? (queue = aggregateErrors(ReactSharedInternals.thrownErrors), ReactSharedInternals.thrownErrors.length = 0, reject(queue)) : resolve(returnValue);
    }
    function flushActQueue(queue) {
        if (!isFlushing) {
            isFlushing = !0;
            var i = 0;
            try {
                for(; i < queue.length; i++){
                    var callback = queue[i];
                    do {
                        ReactSharedInternals.didUsePromise = !1;
                        var continuation = callback(!1);
                        if (null !== continuation) {
                            if (ReactSharedInternals.didUsePromise) {
                                queue[i] = callback;
                                queue.splice(0, i);
                                return;
                            }
                            callback = continuation;
                        } else break;
                    }while (1);
                }
                queue.length = 0;
            } catch (error) {
                queue.splice(0, i + 1), ReactSharedInternals.thrownErrors.push(error);
            } finally{
                isFlushing = !1;
            }
        }
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), MAYBE_ITERATOR_SYMBOL = Symbol.iterator, didWarnStateUpdateForUnmountedComponent = {}, ReactNoopUpdateQueue = {
        isMounted: function() {
            return !1;
        },
        enqueueForceUpdate: function(publicInstance) {
            warnNoop(publicInstance, "forceUpdate");
        },
        enqueueReplaceState: function(publicInstance) {
            warnNoop(publicInstance, "replaceState");
        },
        enqueueSetState: function(publicInstance) {
            warnNoop(publicInstance, "setState");
        }
    }, assign = Object.assign, emptyObject = {};
    Object.freeze(emptyObject);
    Component.prototype.isReactComponent = {};
    Component.prototype.setState = function(partialState, callback) {
        if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, partialState, callback, "setState");
    };
    Component.prototype.forceUpdate = function(callback) {
        this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
    };
    var deprecatedAPIs = {
        isMounted: [
            "isMounted",
            "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."
        ],
        replaceState: [
            "replaceState",
            "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."
        ]
    };
    for(fnName in deprecatedAPIs)deprecatedAPIs.hasOwnProperty(fnName) && defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    ComponentDummy.prototype = Component.prototype;
    deprecatedAPIs = PureComponent.prototype = new ComponentDummy();
    deprecatedAPIs.constructor = PureComponent;
    assign(deprecatedAPIs, Component.prototype);
    deprecatedAPIs.isPureReactComponent = !0;
    var isArrayImpl = Array.isArray, REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference"), ReactSharedInternals = {
        H: null,
        A: null,
        T: null,
        S: null,
        actQueue: null,
        asyncTransitions: 0,
        isBatchingLegacy: !1,
        didScheduleLegacyUpdate: !1,
        didUsePromise: !1,
        thrownErrors: [],
        getCurrentStack: null,
        recentlyCreatedOwnerStacks: 0
    }, hasOwnProperty = Object.prototype.hasOwnProperty, createTask = console.createTask ? console.createTask : function() {
        return null;
    };
    deprecatedAPIs = {
        react_stack_bottom_frame: function(callStackForError) {
            return callStackForError();
        }
    };
    var specialPropKeyWarningShown, didWarnAboutOldJSXRuntime;
    var didWarnAboutElementRef = {};
    var unknownOwnerDebugStack = deprecatedAPIs.react_stack_bottom_frame.bind(deprecatedAPIs, UnknownOwner)();
    var unknownOwnerDebugTask = createTask(getTaskName(UnknownOwner));
    var didWarnAboutMaps = !1, userProvidedKeyEscapeRegex = /\/+/g, reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
        if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
            var event = new window.ErrorEvent("error", {
                bubbles: !0,
                cancelable: !0,
                message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
                error: error
            });
            if (!window.dispatchEvent(event)) return;
        }
        console.error(error);
    }, didWarnAboutMessageChannel = !1, enqueueTaskImpl = null, actScopeDepth = 0, didWarnNoAwaitAct = !1, isFlushing = !1, queueSeveralMicrotasks = "function" === typeof queueMicrotask ? function(callback) {
        queueMicrotask(function() {
            return queueMicrotask(callback);
        });
    } : enqueueTask;
    deprecatedAPIs = Object.freeze({
        __proto__: null,
        c: function(size) {
            return resolveDispatcher().useMemoCache(size);
        }
    });
    var fnName = {
        map: mapChildren,
        forEach: function(children, forEachFunc, forEachContext) {
            mapChildren(children, function() {
                forEachFunc.apply(this, arguments);
            }, forEachContext);
        },
        count: function(children) {
            var n = 0;
            mapChildren(children, function() {
                n++;
            });
            return n;
        },
        toArray: function(children) {
            return mapChildren(children, function(child) {
                return child;
            }) || [];
        },
        only: function(children) {
            if (!isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
            return children;
        }
    };
    exports.Activity = REACT_ACTIVITY_TYPE;
    exports.Children = fnName;
    exports.Component = Component;
    exports.Fragment = REACT_FRAGMENT_TYPE;
    exports.Profiler = REACT_PROFILER_TYPE;
    exports.PureComponent = PureComponent;
    exports.StrictMode = REACT_STRICT_MODE_TYPE;
    exports.Suspense = REACT_SUSPENSE_TYPE;
    exports.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = ReactSharedInternals;
    exports.__COMPILER_RUNTIME = deprecatedAPIs;
    exports.act = function(callback) {
        var prevActQueue = ReactSharedInternals.actQueue, prevActScopeDepth = actScopeDepth;
        actScopeDepth++;
        var queue = ReactSharedInternals.actQueue = null !== prevActQueue ? prevActQueue : [], didAwaitActCall = !1;
        try {
            var result = callback();
        } catch (error) {
            ReactSharedInternals.thrownErrors.push(error);
        }
        if (0 < ReactSharedInternals.thrownErrors.length) throw popActScope(prevActQueue, prevActScopeDepth), callback = aggregateErrors(ReactSharedInternals.thrownErrors), ReactSharedInternals.thrownErrors.length = 0, callback;
        if (null !== result && "object" === typeof result && "function" === typeof result.then) {
            var thenable = result;
            queueSeveralMicrotasks(function() {
                didAwaitActCall || didWarnNoAwaitAct || (didWarnNoAwaitAct = !0, console.error("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);"));
            });
            return {
                then: function(resolve, reject) {
                    didAwaitActCall = !0;
                    thenable.then(function(returnValue) {
                        popActScope(prevActQueue, prevActScopeDepth);
                        if (0 === prevActScopeDepth) {
                            try {
                                flushActQueue(queue), enqueueTask(function() {
                                    return recursivelyFlushAsyncActWork(returnValue, resolve, reject);
                                });
                            } catch (error$0) {
                                ReactSharedInternals.thrownErrors.push(error$0);
                            }
                            if (0 < ReactSharedInternals.thrownErrors.length) {
                                var _thrownError = aggregateErrors(ReactSharedInternals.thrownErrors);
                                ReactSharedInternals.thrownErrors.length = 0;
                                reject(_thrownError);
                            }
                        } else resolve(returnValue);
                    }, function(error) {
                        popActScope(prevActQueue, prevActScopeDepth);
                        0 < ReactSharedInternals.thrownErrors.length ? (error = aggregateErrors(ReactSharedInternals.thrownErrors), ReactSharedInternals.thrownErrors.length = 0, reject(error)) : reject(error);
                    });
                }
            };
        }
        var returnValue$jscomp$0 = result;
        popActScope(prevActQueue, prevActScopeDepth);
        0 === prevActScopeDepth && (flushActQueue(queue), 0 !== queue.length && queueSeveralMicrotasks(function() {
            didAwaitActCall || didWarnNoAwaitAct || (didWarnNoAwaitAct = !0, console.error("A component suspended inside an `act` scope, but the `act` call was not awaited. When testing React components that depend on asynchronous data, you must await the result:\n\nawait act(() => ...)"));
        }), ReactSharedInternals.actQueue = null);
        if (0 < ReactSharedInternals.thrownErrors.length) throw callback = aggregateErrors(ReactSharedInternals.thrownErrors), ReactSharedInternals.thrownErrors.length = 0, callback;
        return {
            then: function(resolve, reject) {
                didAwaitActCall = !0;
                0 === prevActScopeDepth ? (ReactSharedInternals.actQueue = queue, enqueueTask(function() {
                    return recursivelyFlushAsyncActWork(returnValue$jscomp$0, resolve, reject);
                })) : resolve(returnValue$jscomp$0);
            }
        };
    };
    exports.cache = function(fn) {
        return function() {
            return fn.apply(null, arguments);
        };
    };
    exports.cacheSignal = function() {
        return null;
    };
    exports.captureOwnerStack = function() {
        var getCurrentStack = ReactSharedInternals.getCurrentStack;
        return null === getCurrentStack ? null : getCurrentStack();
    };
    exports.cloneElement = function(element, config, children) {
        if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
        var props = assign({}, element.props), key = element.key, owner = element._owner;
        if (null != config) {
            var JSCompiler_inline_result;
            a: {
                if (hasOwnProperty.call(config, "ref") && (JSCompiler_inline_result = Object.getOwnPropertyDescriptor(config, "ref").get) && JSCompiler_inline_result.isReactWarning) {
                    JSCompiler_inline_result = !1;
                    break a;
                }
                JSCompiler_inline_result = void 0 !== config.ref;
            }
            JSCompiler_inline_result && (owner = getOwner());
            hasValidKey(config) && (checkKeyStringCoercion(config.key), key = "" + config.key);
            for(propName in config)!hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
        }
        var propName = arguments.length - 2;
        if (1 === propName) props.children = children;
        else if (1 < propName) {
            JSCompiler_inline_result = Array(propName);
            for(var i = 0; i < propName; i++)JSCompiler_inline_result[i] = arguments[i + 2];
            props.children = JSCompiler_inline_result;
        }
        props = ReactElement(element.type, key, props, owner, element._debugStack, element._debugTask);
        for(key = 2; key < arguments.length; key++)validateChildKeys(arguments[key]);
        return props;
    };
    exports.createContext = function(defaultValue) {
        defaultValue = {
            $$typeof: REACT_CONTEXT_TYPE,
            _currentValue: defaultValue,
            _currentValue2: defaultValue,
            _threadCount: 0,
            Provider: null,
            Consumer: null
        };
        defaultValue.Provider = defaultValue;
        defaultValue.Consumer = {
            $$typeof: REACT_CONSUMER_TYPE,
            _context: defaultValue
        };
        defaultValue._currentRenderer = null;
        defaultValue._currentRenderer2 = null;
        return defaultValue;
    };
    exports.createElement = function(type, config, children) {
        for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i]);
        i = {};
        var key = null;
        if (null != config) for(propName in didWarnAboutOldJSXRuntime || !("__self" in config) || "key" in config || (didWarnAboutOldJSXRuntime = !0, console.warn("Your app (or one of its dependencies) is using an outdated JSX transform. Update to the modern JSX transform for faster performance: https://react.dev/link/new-jsx-transform")), hasValidKey(config) && (checkKeyStringCoercion(config.key), key = "" + config.key), config)hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (i[propName] = config[propName]);
        var childrenLength = arguments.length - 2;
        if (1 === childrenLength) i.children = children;
        else if (1 < childrenLength) {
            for(var childArray = Array(childrenLength), _i = 0; _i < childrenLength; _i++)childArray[_i] = arguments[_i + 2];
            Object.freeze && Object.freeze(childArray);
            i.children = childArray;
        }
        if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === i[propName] && (i[propName] = childrenLength[propName]);
        key && defineKeyPropWarningGetter(i, "function" === typeof type ? type.displayName || type.name || "Unknown" : type);
        var propName = 1e4 > ReactSharedInternals.recentlyCreatedOwnerStacks++;
        return ReactElement(type, key, i, getOwner(), propName ? Error("react-stack-top-frame") : unknownOwnerDebugStack, propName ? createTask(getTaskName(type)) : unknownOwnerDebugTask);
    };
    exports.createRef = function() {
        var refObject = {
            current: null
        };
        Object.seal(refObject);
        return refObject;
    };
    exports.forwardRef = function(render) {
        null != render && render.$$typeof === REACT_MEMO_TYPE ? console.error("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).") : "function" !== typeof render ? console.error("forwardRef requires a render function but was given %s.", null === render ? "null" : typeof render) : 0 !== render.length && 2 !== render.length && console.error("forwardRef render functions accept exactly two parameters: props and ref. %s", 1 === render.length ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined.");
        null != render && null != render.defaultProps && console.error("forwardRef render functions do not support defaultProps. Did you accidentally pass a React component?");
        var elementType = {
            $$typeof: REACT_FORWARD_REF_TYPE,
            render: render
        }, ownName;
        Object.defineProperty(elementType, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name;
                render.name || render.displayName || (Object.defineProperty(render, "name", {
                    value: name
                }), render.displayName = name);
            }
        });
        return elementType;
    };
    exports.isValidElement = isValidElement;
    exports.lazy = function(ctor) {
        ctor = {
            _status: -1,
            _result: ctor
        };
        var lazyType = {
            $$typeof: REACT_LAZY_TYPE,
            _payload: ctor,
            _init: lazyInitializer
        }, ioInfo = {
            name: "lazy",
            start: -1,
            end: -1,
            value: null,
            owner: null,
            debugStack: Error("react-stack-top-frame"),
            debugTask: console.createTask ? console.createTask("lazy()") : null
        };
        ctor._ioInfo = ioInfo;
        lazyType._debugInfo = [
            {
                awaited: ioInfo
            }
        ];
        return lazyType;
    };
    exports.memo = function(type, compare) {
        null == type && console.error("memo: The first argument must be a component. Instead received: %s", null === type ? "null" : typeof type);
        compare = {
            $$typeof: REACT_MEMO_TYPE,
            type: type,
            compare: void 0 === compare ? null : compare
        };
        var ownName;
        Object.defineProperty(compare, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name;
                type.name || type.displayName || (Object.defineProperty(type, "name", {
                    value: name
                }), type.displayName = name);
            }
        });
        return compare;
    };
    exports.startTransition = function(scope) {
        var prevTransition = ReactSharedInternals.T, currentTransition = {};
        currentTransition._updatedFibers = new Set();
        ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = scope(), onStartTransitionFinish = ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && (ReactSharedInternals.asyncTransitions++, returnValue.then(releaseAsyncTransition, releaseAsyncTransition), returnValue.then(noop, reportGlobalError));
        } catch (error) {
            reportGlobalError(error);
        } finally{
            null === prevTransition && currentTransition._updatedFibers && (scope = currentTransition._updatedFibers.size, currentTransition._updatedFibers.clear(), 10 < scope && console.warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.")), null !== prevTransition && null !== currentTransition.types && (null !== prevTransition.types && prevTransition.types !== currentTransition.types && console.error("We expected inner Transitions to have transferred the outer types set and that you cannot add to the outer Transition while inside the inner.This is a bug in React."), prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition;
        }
    };
    exports.unstable_useCacheRefresh = function() {
        return resolveDispatcher().useCacheRefresh();
    };
    exports.use = function(usable) {
        return resolveDispatcher().use(usable);
    };
    exports.useActionState = function(action, initialState, permalink) {
        return resolveDispatcher().useActionState(action, initialState, permalink);
    };
    exports.useCallback = function(callback, deps) {
        return resolveDispatcher().useCallback(callback, deps);
    };
    exports.useContext = function(Context) {
        var dispatcher = resolveDispatcher();
        Context.$$typeof === REACT_CONSUMER_TYPE && console.error("Calling useContext(Context.Consumer) is not supported and will cause bugs. Did you mean to call useContext(Context) instead?");
        return dispatcher.useContext(Context);
    };
    exports.useDebugValue = function(value, formatterFn) {
        return resolveDispatcher().useDebugValue(value, formatterFn);
    };
    exports.useDeferredValue = function(value, initialValue) {
        return resolveDispatcher().useDeferredValue(value, initialValue);
    };
    exports.useEffect = function(create, deps) {
        null == create && console.warn("React Hook useEffect requires an effect callback. Did you forget to pass a callback to the hook?");
        return resolveDispatcher().useEffect(create, deps);
    };
    exports.useEffectEvent = function(callback) {
        return resolveDispatcher().useEffectEvent(callback);
    };
    exports.useId = function() {
        return resolveDispatcher().useId();
    };
    exports.useImperativeHandle = function(ref, create, deps) {
        return resolveDispatcher().useImperativeHandle(ref, create, deps);
    };
    exports.useInsertionEffect = function(create, deps) {
        null == create && console.warn("React Hook useInsertionEffect requires an effect callback. Did you forget to pass a callback to the hook?");
        return resolveDispatcher().useInsertionEffect(create, deps);
    };
    exports.useLayoutEffect = function(create, deps) {
        null == create && console.warn("React Hook useLayoutEffect requires an effect callback. Did you forget to pass a callback to the hook?");
        return resolveDispatcher().useLayoutEffect(create, deps);
    };
    exports.useMemo = function(create, deps) {
        return resolveDispatcher().useMemo(create, deps);
    };
    exports.useOptimistic = function(passthrough, reducer) {
        return resolveDispatcher().useOptimistic(passthrough, reducer);
    };
    exports.useReducer = function(reducer, initialArg, init) {
        return resolveDispatcher().useReducer(reducer, initialArg, init);
    };
    exports.useRef = function(initialValue) {
        return resolveDispatcher().useRef(initialValue);
    };
    exports.useState = function(initialState) {
        return resolveDispatcher().useState(initialState);
    };
    exports.useSyncExternalStore = function(subscribe, getSnapshot, getServerSnapshot) {
        return resolveDispatcher().useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    };
    exports.useTransition = function() {
        return resolveDispatcher().useTransition();
    };
    exports.version = "19.2.3";
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
})();

});



parcelRegister("lkeHb", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $f866dd6f6995409f$export$882461b6382ed46c, (v) => $f866dd6f6995409f$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $f866dd6f6995409f$export$757ceba2d55c277e, (v) => $f866dd6f6995409f$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $f866dd6f6995409f$export$83d89fbfd8236492, (v) => $f866dd6f6995409f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $f866dd6f6995409f$export$882461b6382ed46c;
var $f866dd6f6995409f$export$757ceba2d55c277e;
var $f866dd6f6995409f$export$83d89fbfd8236492;
"use strict";



(function() {
    function findHook(fiber, id) {
        for(fiber = fiber.memoizedState; null !== fiber && 0 < id;)fiber = fiber.next, id--;
        return fiber;
    }
    function copyWithSetImpl(obj, path, index, value) {
        if (index >= path.length) return value;
        var key = path[index], updated = isArrayImpl(obj) ? obj.slice() : assign({}, obj);
        updated[key] = copyWithSetImpl(obj[key], path, index + 1, value);
        return updated;
    }
    function copyWithRename(obj, oldPath, newPath) {
        if (oldPath.length !== newPath.length) console.warn("copyWithRename() expects paths of the same length");
        else {
            for(var i = 0; i < newPath.length - 1; i++)if (oldPath[i] !== newPath[i]) {
                console.warn("copyWithRename() expects paths to be the same except for the deepest key");
                return;
            }
            return copyWithRenameImpl(obj, oldPath, newPath, 0);
        }
    }
    function copyWithRenameImpl(obj, oldPath, newPath, index) {
        var oldKey = oldPath[index], updated = isArrayImpl(obj) ? obj.slice() : assign({}, obj);
        index + 1 === oldPath.length ? (updated[newPath[index]] = updated[oldKey], isArrayImpl(updated) ? updated.splice(oldKey, 1) : delete updated[oldKey]) : updated[oldKey] = copyWithRenameImpl(obj[oldKey], oldPath, newPath, index + 1);
        return updated;
    }
    function copyWithDeleteImpl(obj, path, index) {
        var key = path[index], updated = isArrayImpl(obj) ? obj.slice() : assign({}, obj);
        if (index + 1 === path.length) return isArrayImpl(updated) ? updated.splice(key, 1) : delete updated[key], updated;
        updated[key] = copyWithDeleteImpl(obj[key], path, index + 1);
        return updated;
    }
    function shouldSuspendImpl() {
        return !1;
    }
    function shouldErrorImpl() {
        return null;
    }
    function warnInvalidHookAccess() {
        console.error("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://react.dev/link/rules-of-hooks");
    }
    function warnInvalidContextAccess() {
        console.error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
    }
    function noop() {}
    function warnForMissingKey() {}
    function setToSortedString(set) {
        var array = [];
        set.forEach(function(value) {
            array.push(value);
        });
        return array.sort().join(", ");
    }
    function createFiber(tag, pendingProps, key, mode) {
        return new FiberNode(tag, pendingProps, key, mode);
    }
    function scheduleRoot(root, element) {
        root.context === emptyContextObject && (updateContainerImpl(root.current, 2, element, root, null, null), flushSyncWork$1());
    }
    function scheduleRefresh(root, update) {
        if (null !== resolveFamily) {
            var staleFamilies = update.staleFamilies;
            update = update.updatedFamilies;
            flushPendingEffects();
            scheduleFibersWithFamiliesRecursively(root.current, update, staleFamilies);
            flushSyncWork$1();
        }
    }
    function setRefreshHandler(handler) {
        resolveFamily = handler;
    }
    function isValidContainer(node) {
        return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
    }
    function getNearestMountedFiber(fiber) {
        var node = fiber, nearestMounted = fiber;
        if (fiber.alternate) for(; node.return;)node = node.return;
        else {
            fiber = node;
            do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
            while (fiber);
        }
        return 3 === node.tag ? nearestMounted : null;
    }
    function getSuspenseInstanceFromFiber(fiber) {
        if (13 === fiber.tag) {
            var suspenseState = fiber.memoizedState;
            null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
            if (null !== suspenseState) return suspenseState.dehydrated;
        }
        return null;
    }
    function getActivityInstanceFromFiber(fiber) {
        if (31 === fiber.tag) {
            var activityState = fiber.memoizedState;
            null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
            if (null !== activityState) return activityState.dehydrated;
        }
        return null;
    }
    function assertIsMounted(fiber) {
        if (getNearestMountedFiber(fiber) !== fiber) throw Error("Unable to find node on an unmounted component.");
    }
    function findCurrentFiberUsingSlowPath(fiber) {
        var alternate = fiber.alternate;
        if (!alternate) {
            alternate = getNearestMountedFiber(fiber);
            if (null === alternate) throw Error("Unable to find node on an unmounted component.");
            return alternate !== fiber ? null : fiber;
        }
        for(var a = fiber, b = alternate;;){
            var parentA = a.return;
            if (null === parentA) break;
            var parentB = parentA.alternate;
            if (null === parentB) {
                b = parentA.return;
                if (null !== b) {
                    a = b;
                    continue;
                }
                break;
            }
            if (parentA.child === parentB.child) {
                for(parentB = parentA.child; parentB;){
                    if (parentB === a) return assertIsMounted(parentA), fiber;
                    if (parentB === b) return assertIsMounted(parentA), alternate;
                    parentB = parentB.sibling;
                }
                throw Error("Unable to find node on an unmounted component.");
            }
            if (a.return !== b.return) a = parentA, b = parentB;
            else {
                for(var didFindChild = !1, _child = parentA.child; _child;){
                    if (_child === a) {
                        didFindChild = !0;
                        a = parentA;
                        b = parentB;
                        break;
                    }
                    if (_child === b) {
                        didFindChild = !0;
                        b = parentA;
                        a = parentB;
                        break;
                    }
                    _child = _child.sibling;
                }
                if (!didFindChild) {
                    for(_child = parentB.child; _child;){
                        if (_child === a) {
                            didFindChild = !0;
                            a = parentB;
                            b = parentA;
                            break;
                        }
                        if (_child === b) {
                            didFindChild = !0;
                            b = parentB;
                            a = parentA;
                            break;
                        }
                        _child = _child.sibling;
                    }
                    if (!didFindChild) throw Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
                }
            }
            if (a.alternate !== b) throw Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
        }
        if (3 !== a.tag) throw Error("Unable to find node on an unmounted component.");
        return a.stateNode.current === a ? fiber : alternate;
    }
    function findCurrentHostFiberImpl(node) {
        var tag = node.tag;
        if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
        for(node = node.child; null !== node;){
            tag = findCurrentHostFiberImpl(node);
            if (null !== tag) return tag;
            node = node.sibling;
        }
        return null;
    }
    function getIteratorFn(maybeIterable) {
        if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
        maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
        return "function" === typeof maybeIterable ? maybeIterable : null;
    }
    function getComponentNameFromType(type) {
        if (null == type) return null;
        if ("function" === typeof type) return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
        if ("string" === typeof type) return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
            case REACT_ACTIVITY_TYPE:
                return "Activity";
        }
        if ("object" === typeof type) switch("number" === typeof type.tag && console.error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), type.$$typeof){
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_CONTEXT_TYPE:
                return type.displayName || "Context";
            case REACT_CONSUMER_TYPE:
                return (type._context.displayName || "Context") + ".Consumer";
            case REACT_FORWARD_REF_TYPE:
                var innerType = type.render;
                type = type.displayName;
                type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
                return type;
            case REACT_MEMO_TYPE:
                return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                innerType = type._payload;
                type = type._init;
                try {
                    return getComponentNameFromType(type(innerType));
                } catch (x) {}
        }
        return null;
    }
    function getComponentNameFromOwner(owner) {
        return "number" === typeof owner.tag ? getComponentNameFromFiber(owner) : "string" === typeof owner.name ? owner.name : null;
    }
    function getComponentNameFromFiber(fiber) {
        var type = fiber.type;
        switch(fiber.tag){
            case 31:
                return "Activity";
            case 24:
                return "Cache";
            case 9:
                return (type._context.displayName || "Context") + ".Consumer";
            case 10:
                return type.displayName || "Context";
            case 18:
                return "DehydratedFragment";
            case 11:
                return fiber = type.render, fiber = fiber.displayName || fiber.name || "", type.displayName || ("" !== fiber ? "ForwardRef(" + fiber + ")" : "ForwardRef");
            case 7:
                return "Fragment";
            case 26:
            case 27:
            case 5:
                return type;
            case 4:
                return "Portal";
            case 3:
                return "Root";
            case 6:
                return "Text";
            case 16:
                return getComponentNameFromType(type);
            case 8:
                return type === REACT_STRICT_MODE_TYPE ? "StrictMode" : "Mode";
            case 22:
                return "Offscreen";
            case 12:
                return "Profiler";
            case 21:
                return "Scope";
            case 13:
                return "Suspense";
            case 19:
                return "SuspenseList";
            case 25:
                return "TracingMarker";
            case 1:
            case 0:
            case 14:
            case 15:
                if ("function" === typeof type) return type.displayName || type.name || null;
                if ("string" === typeof type) return type;
                break;
            case 29:
                type = fiber._debugInfo;
                if (null != type) {
                    for(var i = type.length - 1; 0 <= i; i--)if ("string" === typeof type[i].name) return type[i].name;
                }
                if (null !== fiber.return) return getComponentNameFromFiber(fiber.return);
        }
        return null;
    }
    function createCursor(defaultValue) {
        return {
            current: defaultValue
        };
    }
    function pop(cursor, fiber) {
        0 > index$jscomp$0 ? console.error("Unexpected pop.") : (fiber !== fiberStack[index$jscomp$0] && console.error("Unexpected Fiber popped."), cursor.current = valueStack[index$jscomp$0], valueStack[index$jscomp$0] = null, fiberStack[index$jscomp$0] = null, index$jscomp$0--);
    }
    function push(cursor, value, fiber) {
        index$jscomp$0++;
        valueStack[index$jscomp$0] = cursor.current;
        fiberStack[index$jscomp$0] = fiber;
        cursor.current = value;
    }
    function requiredContext(c) {
        null === c && console.error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
        return c;
    }
    function pushHostContainer(fiber, nextRootInstance) {
        push(rootInstanceStackCursor, nextRootInstance, fiber);
        push(contextFiberStackCursor, fiber, fiber);
        push(contextStackCursor, null, fiber);
        var nextRootContext = nextRootInstance.nodeType;
        switch(nextRootContext){
            case 9:
            case 11:
                nextRootContext = 9 === nextRootContext ? "#document" : "#fragment";
                nextRootInstance = (nextRootInstance = nextRootInstance.documentElement) ? (nextRootInstance = nextRootInstance.namespaceURI) ? getOwnHostContext(nextRootInstance) : HostContextNamespaceNone : HostContextNamespaceNone;
                break;
            default:
                if (nextRootContext = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = getOwnHostContext(nextRootInstance), nextRootInstance = getChildHostContextProd(nextRootInstance, nextRootContext);
                else switch(nextRootContext){
                    case "svg":
                        nextRootInstance = HostContextNamespaceSvg;
                        break;
                    case "math":
                        nextRootInstance = HostContextNamespaceMath;
                        break;
                    default:
                        nextRootInstance = HostContextNamespaceNone;
                }
        }
        nextRootContext = nextRootContext.toLowerCase();
        nextRootContext = updatedAncestorInfoDev(null, nextRootContext);
        nextRootContext = {
            context: nextRootInstance,
            ancestorInfo: nextRootContext
        };
        pop(contextStackCursor, fiber);
        push(contextStackCursor, nextRootContext, fiber);
    }
    function popHostContainer(fiber) {
        pop(contextStackCursor, fiber);
        pop(contextFiberStackCursor, fiber);
        pop(rootInstanceStackCursor, fiber);
    }
    function getHostContext() {
        return requiredContext(contextStackCursor.current);
    }
    function pushHostContext(fiber) {
        null !== fiber.memoizedState && push(hostTransitionProviderCursor, fiber, fiber);
        var context = requiredContext(contextStackCursor.current);
        var type = fiber.type;
        var nextContext = getChildHostContextProd(context.context, type);
        type = updatedAncestorInfoDev(context.ancestorInfo, type);
        nextContext = {
            context: nextContext,
            ancestorInfo: type
        };
        context !== nextContext && (push(contextFiberStackCursor, fiber, fiber), push(contextStackCursor, nextContext, fiber));
    }
    function popHostContext(fiber) {
        contextFiberStackCursor.current === fiber && (pop(contextStackCursor, fiber), pop(contextFiberStackCursor, fiber));
        hostTransitionProviderCursor.current === fiber && (pop(hostTransitionProviderCursor, fiber), HostTransitionContext._currentValue = NotPendingTransition);
    }
    function disabledLog() {}
    function disableLogs() {
        if (0 === disabledDepth) {
            prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd;
            var props = {
                configurable: !0,
                enumerable: !0,
                value: disabledLog,
                writable: !0
            };
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (0 === disabledDepth) {
            var props = {
                configurable: !0,
                enumerable: !0,
                writable: !0
            };
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        }
        0 > disabledDepth && console.error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    function formatOwnerStack(error) {
        var prevPrepareStackTrace = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        error = error.stack;
        Error.prepareStackTrace = prevPrepareStackTrace;
        error.startsWith("Error: react-stack-top-frame\n") && (error = error.slice(29));
        prevPrepareStackTrace = error.indexOf("\n");
        -1 !== prevPrepareStackTrace && (error = error.slice(prevPrepareStackTrace + 1));
        prevPrepareStackTrace = error.indexOf("react_stack_bottom_frame");
        -1 !== prevPrepareStackTrace && (prevPrepareStackTrace = error.lastIndexOf("\n", prevPrepareStackTrace));
        if (-1 !== prevPrepareStackTrace) error = error.slice(0, prevPrepareStackTrace);
        else return "";
        return error;
    }
    function describeBuiltInComponentFrame(name) {
        if (void 0 === prefix) try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
            suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
        }
        return "\n" + prefix + name + suffix;
    }
    function describeNativeComponentFrame(fn, construct) {
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (void 0 !== frame) return frame;
        reentry = !0;
        frame = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var previousDispatcher = null;
        previousDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = null;
        disableLogs();
        try {
            var RunInRootFrame = {
                DetermineComponentFrameRoot: function() {
                    try {
                        if (construct) {
                            var Fake = function() {
                                throw Error();
                            };
                            Object.defineProperty(Fake.prototype, "props", {
                                set: function() {
                                    throw Error();
                                }
                            });
                            if ("object" === typeof Reflect && Reflect.construct) {
                                try {
                                    Reflect.construct(Fake, []);
                                } catch (x) {
                                    var control = x;
                                }
                                Reflect.construct(fn, [], Fake);
                            } else {
                                try {
                                    Fake.call();
                                } catch (x$0) {
                                    control = x$0;
                                }
                                fn.call(Fake.prototype);
                            }
                        } else {
                            try {
                                throw Error();
                            } catch (x$1) {
                                control = x$1;
                            }
                            (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                        }
                    } catch (sample) {
                        if (sample && control && "string" === typeof sample.stack) return [
                            sample.stack,
                            control.stack
                        ];
                    }
                    return [
                        null,
                        null
                    ];
                }
            };
            RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
            var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
            namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
                value: "DetermineComponentFrameRoot"
            });
            var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
            if (sampleStack && controlStack) {
                var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
                for(_RunInRootFrame$Deter = namePropDescriptor = 0; namePropDescriptor < sampleLines.length && !sampleLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
                for(; _RunInRootFrame$Deter < controlLines.length && !controlLines[_RunInRootFrame$Deter].includes("DetermineComponentFrameRoot");)_RunInRootFrame$Deter++;
                if (namePropDescriptor === sampleLines.length || _RunInRootFrame$Deter === controlLines.length) for(namePropDescriptor = sampleLines.length - 1, _RunInRootFrame$Deter = controlLines.length - 1; 1 <= namePropDescriptor && 0 <= _RunInRootFrame$Deter && sampleLines[namePropDescriptor] !== controlLines[_RunInRootFrame$Deter];)_RunInRootFrame$Deter--;
                for(; 1 <= namePropDescriptor && 0 <= _RunInRootFrame$Deter; namePropDescriptor--, _RunInRootFrame$Deter--)if (sampleLines[namePropDescriptor] !== controlLines[_RunInRootFrame$Deter]) {
                    if (1 !== namePropDescriptor || 1 !== _RunInRootFrame$Deter) {
                        do if (namePropDescriptor--, _RunInRootFrame$Deter--, 0 > _RunInRootFrame$Deter || sampleLines[namePropDescriptor] !== controlLines[_RunInRootFrame$Deter]) {
                            var _frame = "\n" + sampleLines[namePropDescriptor].replace(" at new ", " at ");
                            fn.displayName && _frame.includes("<anonymous>") && (_frame = _frame.replace("<anonymous>", fn.displayName));
                            "function" === typeof fn && componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                        while (1 <= namePropDescriptor && 0 <= _RunInRootFrame$Deter);
                    }
                    break;
                }
            }
        } finally{
            reentry = !1, ReactSharedInternals.H = previousDispatcher, reenableLogs(), Error.prepareStackTrace = frame;
        }
        sampleLines = (sampleLines = fn ? fn.displayName || fn.name : "") ? describeBuiltInComponentFrame(sampleLines) : "";
        "function" === typeof fn && componentFrameCache.set(fn, sampleLines);
        return sampleLines;
    }
    function describeFiber(fiber, childFiber) {
        switch(fiber.tag){
            case 26:
            case 27:
            case 5:
                return describeBuiltInComponentFrame(fiber.type);
            case 16:
                return describeBuiltInComponentFrame("Lazy");
            case 13:
                return fiber.child !== childFiber && null !== childFiber ? describeBuiltInComponentFrame("Suspense Fallback") : describeBuiltInComponentFrame("Suspense");
            case 19:
                return describeBuiltInComponentFrame("SuspenseList");
            case 0:
            case 15:
                return describeNativeComponentFrame(fiber.type, !1);
            case 11:
                return describeNativeComponentFrame(fiber.type.render, !1);
            case 1:
                return describeNativeComponentFrame(fiber.type, !0);
            case 31:
                return describeBuiltInComponentFrame("Activity");
            default:
                return "";
        }
    }
    function getStackByFiberInDevAndProd(workInProgress) {
        try {
            var info = "", previous = null;
            do {
                info += describeFiber(workInProgress, previous);
                var debugInfo = workInProgress._debugInfo;
                if (debugInfo) for(var i = debugInfo.length - 1; 0 <= i; i--){
                    var entry = debugInfo[i];
                    if ("string" === typeof entry.name) {
                        var JSCompiler_temp_const = info;
                        a: {
                            var name = entry.name, env = entry.env, location = entry.debugLocation;
                            if (null != location) {
                                var childStack = formatOwnerStack(location), idx = childStack.lastIndexOf("\n"), lastLine = -1 === idx ? childStack : childStack.slice(idx + 1);
                                if (-1 !== lastLine.indexOf(name)) {
                                    var JSCompiler_inline_result = "\n" + lastLine;
                                    break a;
                                }
                            }
                            JSCompiler_inline_result = describeBuiltInComponentFrame(name + (env ? " [" + env + "]" : ""));
                        }
                        info = JSCompiler_temp_const + JSCompiler_inline_result;
                    }
                }
                previous = workInProgress;
                workInProgress = workInProgress.return;
            }while (workInProgress);
            return info;
        } catch (x) {
            return "\nError generating stack: " + x.message + "\n" + x.stack;
        }
    }
    function describeFunctionComponentFrameWithoutLineNumber(fn) {
        return (fn = fn ? fn.displayName || fn.name : "") ? describeBuiltInComponentFrame(fn) : "";
    }
    function getCurrentFiberOwnerNameInDevOrNull() {
        if (null === current) return null;
        var owner = current._debugOwner;
        return null != owner ? getComponentNameFromOwner(owner) : null;
    }
    function getCurrentFiberStackInDev() {
        if (null === current) return "";
        var workInProgress = current;
        try {
            var info = "";
            6 === workInProgress.tag && (workInProgress = workInProgress.return);
            switch(workInProgress.tag){
                case 26:
                case 27:
                case 5:
                    info += describeBuiltInComponentFrame(workInProgress.type);
                    break;
                case 13:
                    info += describeBuiltInComponentFrame("Suspense");
                    break;
                case 19:
                    info += describeBuiltInComponentFrame("SuspenseList");
                    break;
                case 31:
                    info += describeBuiltInComponentFrame("Activity");
                    break;
                case 30:
                case 0:
                case 15:
                case 1:
                    workInProgress._debugOwner || "" !== info || (info += describeFunctionComponentFrameWithoutLineNumber(workInProgress.type));
                    break;
                case 11:
                    workInProgress._debugOwner || "" !== info || (info += describeFunctionComponentFrameWithoutLineNumber(workInProgress.type.render));
            }
            for(; workInProgress;)if ("number" === typeof workInProgress.tag) {
                var fiber = workInProgress;
                workInProgress = fiber._debugOwner;
                var debugStack = fiber._debugStack;
                if (workInProgress && debugStack) {
                    var formattedStack = formatOwnerStack(debugStack);
                    "" !== formattedStack && (info += "\n" + formattedStack);
                }
            } else if (null != workInProgress.debugStack) {
                var ownerStack = workInProgress.debugStack;
                (workInProgress = workInProgress.owner) && ownerStack && (info += "\n" + formatOwnerStack(ownerStack));
            } else break;
            var JSCompiler_inline_result = info;
        } catch (x) {
            JSCompiler_inline_result = "\nError generating stack: " + x.message + "\n" + x.stack;
        }
        return JSCompiler_inline_result;
    }
    function runWithFiberInDEV(fiber, callback, arg0, arg1, arg2, arg3, arg4) {
        var previousFiber = current;
        setCurrentFiber(fiber);
        try {
            return null !== fiber && fiber._debugTask ? fiber._debugTask.run(callback.bind(null, arg0, arg1, arg2, arg3, arg4)) : callback(arg0, arg1, arg2, arg3, arg4);
        } finally{
            setCurrentFiber(previousFiber);
        }
        throw Error("runWithFiberInDEV should never be called in production. This is a bug in React.");
    }
    function setCurrentFiber(fiber) {
        ReactSharedInternals.getCurrentStack = null === fiber ? null : getCurrentFiberStackInDev;
        isRendering = !1;
        current = fiber;
    }
    function typeName(value) {
        return "function" === typeof Symbol && Symbol.toStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
    }
    function willCoercionThrow(value) {
        try {
            return testStringCoercion(value), !1;
        } catch (e) {
            return !0;
        }
    }
    function testStringCoercion(value) {
        return "" + value;
    }
    function checkAttributeStringCoercion(value, attributeName) {
        if (willCoercionThrow(value)) return console.error("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before using it here.", attributeName, typeName(value)), testStringCoercion(value);
    }
    function checkCSSPropertyStringCoercion(value, propName) {
        if (willCoercionThrow(value)) return console.error("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before using it here.", propName, typeName(value)), testStringCoercion(value);
    }
    function checkFormFieldValueStringCoercion(value) {
        if (willCoercionThrow(value)) return console.error("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before using it here.", typeName(value)), testStringCoercion(value);
    }
    function injectInternals(internals) {
        if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
        var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (hook.isDisabled) return !0;
        if (!hook.supportsFiber) return console.error("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://react.dev/link/react-devtools"), !0;
        try {
            rendererID = hook.inject(internals), injectedHook = hook;
        } catch (err) {
            console.error("React instrumentation encountered an error: %o.", err);
        }
        return hook.checkDCE ? !0 : !1;
    }
    function setIsStrictModeForDevtools(newIsStrictMode) {
        "function" === typeof log$1 && unstable_setDisableYieldValue(newIsStrictMode);
        if (injectedHook && "function" === typeof injectedHook.setStrictMode) try {
            injectedHook.setStrictMode(rendererID, newIsStrictMode);
        } catch (err) {
            hasLoggedError || (hasLoggedError = !0, console.error("React instrumentation encountered an error: %o", err));
        }
    }
    function clz32Fallback(x) {
        x >>>= 0;
        return 0 === x ? 32 : 31 - (log(x) / LN2 | 0) | 0;
    }
    function getHighestPriorityLanes(lanes) {
        var pendingSyncLanes = lanes & 42;
        if (0 !== pendingSyncLanes) return pendingSyncLanes;
        switch(lanes & -lanes){
            case 1:
                return 1;
            case 2:
                return 2;
            case 4:
                return 4;
            case 8:
                return 8;
            case 16:
                return 16;
            case 32:
                return 32;
            case 64:
                return 64;
            case 128:
                return 128;
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
                return lanes & 261888;
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
                return lanes & 3932160;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
                return lanes & 62914560;
            case 67108864:
                return 67108864;
            case 134217728:
                return 134217728;
            case 268435456:
                return 268435456;
            case 536870912:
                return 536870912;
            case 1073741824:
                return 0;
            default:
                return console.error("Should have found matching lanes. This is a bug in React."), lanes;
        }
    }
    function getNextLanes(root, wipLanes, rootHasPendingCommit) {
        var pendingLanes = root.pendingLanes;
        if (0 === pendingLanes) return 0;
        var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
        root = root.warmLanes;
        var nonIdlePendingLanes = pendingLanes & 134217727;
        0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))));
        return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
    }
    function checkIfRootIsPrerendering(root, renderLanes) {
        return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
    }
    function computeExpirationTime(lane, currentTime) {
        switch(lane){
            case 1:
            case 2:
            case 4:
            case 8:
            case 64:
                return currentTime + 250;
            case 16:
            case 32:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
                return currentTime + 5e3;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
                return -1;
            case 67108864:
            case 134217728:
            case 268435456:
            case 536870912:
            case 1073741824:
                return -1;
            default:
                return console.error("Should have found matching lanes. This is a bug in React."), -1;
        }
    }
    function claimNextRetryLane() {
        var lane = nextRetryLane;
        nextRetryLane <<= 1;
        0 === (nextRetryLane & 62914560) && (nextRetryLane = 4194304);
        return lane;
    }
    function createLaneMap(initial) {
        for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
        return laneMap;
    }
    function markRootUpdated$1(root, updateLane) {
        root.pendingLanes |= updateLane;
        268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
    }
    function markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
        var previouslyPendingLanes = root.pendingLanes;
        root.pendingLanes = remainingLanes;
        root.suspendedLanes = 0;
        root.pingedLanes = 0;
        root.warmLanes = 0;
        root.expiredLanes &= remainingLanes;
        root.entangledLanes &= remainingLanes;
        root.errorRecoveryDisabledLanes &= remainingLanes;
        root.shellSuspendCounter = 0;
        var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
        for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
            var index = 31 - clz32(remainingLanes), lane = 1 << index;
            entanglements[index] = 0;
            expirationTimes[index] = -1;
            var hiddenUpdatesForLane = hiddenUpdates[index];
            if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index] = null, index = 0; index < hiddenUpdatesForLane.length; index++){
                var update = hiddenUpdatesForLane[index];
                null !== update && (update.lane &= -536870913);
            }
            remainingLanes &= ~lane;
        }
        0 !== spawnedLane && markSpawnedDeferredLane(root, spawnedLane, 0);
        0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
    }
    function markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
        root.pendingLanes |= spawnedLane;
        root.suspendedLanes &= ~spawnedLane;
        var spawnedLaneIndex = 31 - clz32(spawnedLane);
        root.entangledLanes |= spawnedLane;
        root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
    }
    function markRootEntangled(root, entangledLanes) {
        var rootEntangledLanes = root.entangledLanes |= entangledLanes;
        for(root = root.entanglements; rootEntangledLanes;){
            var index = 31 - clz32(rootEntangledLanes), lane = 1 << index;
            lane & entangledLanes | root[index] & entangledLanes && (root[index] |= entangledLanes);
            rootEntangledLanes &= ~lane;
        }
    }
    function getBumpedLaneForHydration(root, renderLanes) {
        var renderLane = renderLanes & -renderLanes;
        renderLane = 0 !== (renderLane & 42) ? 1 : getBumpedLaneForHydrationByLane(renderLane);
        return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
    }
    function getBumpedLaneForHydrationByLane(lane) {
        switch(lane){
            case 2:
                lane = 1;
                break;
            case 8:
                lane = 4;
                break;
            case 32:
                lane = 16;
                break;
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
                lane = 128;
                break;
            case 268435456:
                lane = 134217728;
                break;
            default:
                lane = 0;
        }
        return lane;
    }
    function addFiberToLanesMap(root, fiber, lanes) {
        if (isDevToolsPresent) for(root = root.pendingUpdatersLaneMap; 0 < lanes;){
            var index = 31 - clz32(lanes), lane = 1 << index;
            root[index].add(fiber);
            lanes &= ~lane;
        }
    }
    function movePendingFibersToMemoized(root, lanes) {
        if (isDevToolsPresent) for(var pendingUpdatersLaneMap = root.pendingUpdatersLaneMap, memoizedUpdaters = root.memoizedUpdaters; 0 < lanes;){
            var index = 31 - clz32(lanes);
            root = 1 << index;
            index = pendingUpdatersLaneMap[index];
            0 < index.size && (index.forEach(function(fiber) {
                var alternate = fiber.alternate;
                null !== alternate && memoizedUpdaters.has(alternate) || memoizedUpdaters.add(fiber);
            }), index.clear());
            lanes &= ~root;
        }
    }
    function lanesToEventPriority(lanes) {
        lanes &= -lanes;
        return 0 !== DiscreteEventPriority && DiscreteEventPriority < lanes ? 0 !== ContinuousEventPriority && ContinuousEventPriority < lanes ? 0 !== (lanes & 134217727) ? DefaultEventPriority : IdleEventPriority : ContinuousEventPriority : DiscreteEventPriority;
    }
    function resolveUpdatePriority() {
        var updatePriority = ReactDOMSharedInternals.p;
        if (0 !== updatePriority) return updatePriority;
        updatePriority = window.event;
        return void 0 === updatePriority ? DefaultEventPriority : getEventPriority(updatePriority.type);
    }
    function runWithPriority(priority, fn) {
        var previousPriority = ReactDOMSharedInternals.p;
        try {
            return ReactDOMSharedInternals.p = priority, fn();
        } finally{
            ReactDOMSharedInternals.p = previousPriority;
        }
    }
    function detachDeletedInstance(node) {
        delete node[internalInstanceKey];
        delete node[internalPropsKey];
        delete node[internalEventHandlersKey];
        delete node[internalEventHandlerListenersKey];
        delete node[internalEventHandlesSetKey];
    }
    function getClosestInstanceFromNode(targetNode) {
        var targetInst = targetNode[internalInstanceKey];
        if (targetInst) return targetInst;
        for(var parentNode = targetNode.parentNode; parentNode;){
            if (targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey]) {
                parentNode = targetInst.alternate;
                if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = getParentHydrationBoundary(targetNode); null !== targetNode;){
                    if (parentNode = targetNode[internalInstanceKey]) return parentNode;
                    targetNode = getParentHydrationBoundary(targetNode);
                }
                return targetInst;
            }
            targetNode = parentNode;
            parentNode = targetNode.parentNode;
        }
        return null;
    }
    function getInstanceFromNode(node) {
        if (node = node[internalInstanceKey] || node[internalContainerInstanceKey]) {
            var tag = node.tag;
            if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
        }
        return null;
    }
    function getNodeFromInstance(inst) {
        var tag = inst.tag;
        if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
        throw Error("getNodeFromInstance: Invalid argument.");
    }
    function getResourcesFromRoot(root) {
        var resources = root[internalRootNodeResourcesKey];
        resources || (resources = root[internalRootNodeResourcesKey] = {
            hoistableStyles: new Map(),
            hoistableScripts: new Map()
        });
        return resources;
    }
    function markNodeAsHoistable(node) {
        node[internalHoistableMarker] = !0;
    }
    function registerTwoPhaseEvent(registrationName, dependencies) {
        registerDirectEvent(registrationName, dependencies);
        registerDirectEvent(registrationName + "Capture", dependencies);
    }
    function registerDirectEvent(registrationName, dependencies) {
        registrationNameDependencies[registrationName] && console.error("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", registrationName);
        registrationNameDependencies[registrationName] = dependencies;
        var lowerCasedName = registrationName.toLowerCase();
        possibleRegistrationNames[lowerCasedName] = registrationName;
        "onDoubleClick" === registrationName && (possibleRegistrationNames.ondblclick = registrationName);
        for(registrationName = 0; registrationName < dependencies.length; registrationName++)allNativeEvents.add(dependencies[registrationName]);
    }
    function checkControlledValueProps(tagName, props) {
        hasReadOnlyValue[props.type] || props.onChange || props.onInput || props.readOnly || props.disabled || null == props.value || ("select" === tagName ? console.error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set `onChange`.") : console.error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."));
        props.onChange || props.readOnly || props.disabled || null == props.checked || console.error("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function isAttributeNameSafe(attributeName) {
        if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) return !0;
        if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return !1;
        if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return validatedAttributeNameCache[attributeName] = !0;
        illegalAttributeNameCache[attributeName] = !0;
        console.error("Invalid attribute name: `%s`", attributeName);
        return !1;
    }
    function getValueForAttributeOnCustomComponent(node, name, expected) {
        if (isAttributeNameSafe(name)) {
            if (!node.hasAttribute(name)) {
                switch(typeof expected){
                    case "symbol":
                    case "object":
                        return expected;
                    case "function":
                        return expected;
                    case "boolean":
                        if (!1 === expected) return expected;
                }
                return void 0 === expected ? void 0 : null;
            }
            node = node.getAttribute(name);
            if ("" === node && !0 === expected) return !0;
            checkAttributeStringCoercion(expected, name);
            return node === "" + expected ? expected : node;
        }
    }
    function setValueForAttribute(node, name, value) {
        if (isAttributeNameSafe(name)) {
            if (null === value) node.removeAttribute(name);
            else {
                switch(typeof value){
                    case "undefined":
                    case "function":
                    case "symbol":
                        node.removeAttribute(name);
                        return;
                    case "boolean":
                        var prefix = name.toLowerCase().slice(0, 5);
                        if ("data-" !== prefix && "aria-" !== prefix) {
                            node.removeAttribute(name);
                            return;
                        }
                }
                checkAttributeStringCoercion(value, name);
                node.setAttribute(name, "" + value);
            }
        }
    }
    function setValueForKnownAttribute(node, name, value) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                case "boolean":
                    node.removeAttribute(name);
                    return;
            }
            checkAttributeStringCoercion(value, name);
            node.setAttribute(name, "" + value);
        }
    }
    function setValueForNamespacedAttribute(node, namespace, name, value) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                case "boolean":
                    node.removeAttribute(name);
                    return;
            }
            checkAttributeStringCoercion(value, name);
            node.setAttributeNS(namespace, name, "" + value);
        }
    }
    function getToStringValue(value) {
        switch(typeof value){
            case "bigint":
            case "boolean":
            case "number":
            case "string":
            case "undefined":
                return value;
            case "object":
                return checkFormFieldValueStringCoercion(value), value;
            default:
                return "";
        }
    }
    function isCheckable(elem) {
        var type = elem.type;
        return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
    }
    function trackValueOnNode(node, valueField, currentValue) {
        var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
        if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
            var get = descriptor.get, set = descriptor.set;
            Object.defineProperty(node, valueField, {
                configurable: !0,
                get: function() {
                    return get.call(this);
                },
                set: function(value) {
                    checkFormFieldValueStringCoercion(value);
                    currentValue = "" + value;
                    set.call(this, value);
                }
            });
            Object.defineProperty(node, valueField, {
                enumerable: descriptor.enumerable
            });
            return {
                getValue: function() {
                    return currentValue;
                },
                setValue: function(value) {
                    checkFormFieldValueStringCoercion(value);
                    currentValue = "" + value;
                },
                stopTracking: function() {
                    node._valueTracker = null;
                    delete node[valueField];
                }
            };
        }
    }
    function track(node) {
        if (!node._valueTracker) {
            var valueField = isCheckable(node) ? "checked" : "value";
            node._valueTracker = trackValueOnNode(node, valueField, "" + node[valueField]);
        }
    }
    function updateValueIfChanged(node) {
        if (!node) return !1;
        var tracker = node._valueTracker;
        if (!tracker) return !0;
        var lastValue = tracker.getValue();
        var value = "";
        node && (value = isCheckable(node) ? node.checked ? "true" : "false" : node.value);
        node = value;
        return node !== lastValue ? (tracker.setValue(node), !0) : !1;
    }
    function getActiveElement(doc) {
        doc = doc || ("undefined" !== typeof document ? document : void 0);
        if ("undefined" === typeof doc) return null;
        try {
            return doc.activeElement || doc.body;
        } catch (e) {
            return doc.body;
        }
    }
    function escapeSelectorAttributeValueInsideDoubleQuotes(value) {
        return value.replace(escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
            return "\\" + ch.charCodeAt(0).toString(16) + " ";
        });
    }
    function validateInputProps(element, props) {
        void 0 === props.checked || void 0 === props.defaultChecked || didWarnCheckedDefaultChecked || (console.error("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component", props.type), didWarnCheckedDefaultChecked = !0);
        void 0 === props.value || void 0 === props.defaultValue || didWarnValueDefaultValue$1 || (console.error("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component", props.type), didWarnValueDefaultValue$1 = !0);
    }
    function updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
        element.name = "";
        null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? (checkAttributeStringCoercion(type, "type"), element.type = type) : element.removeAttribute("type");
        if (null != value) {
            if ("number" === type) {
                if (0 === value && "" === element.value || element.value != value) element.value = "" + getToStringValue(value);
            } else element.value !== "" + getToStringValue(value) && (element.value = "" + getToStringValue(value));
        } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
        null != value ? setDefaultValue(element, type, getToStringValue(value)) : null != defaultValue ? setDefaultValue(element, type, getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
        null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
        null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
        null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? (checkAttributeStringCoercion(name, "name"), element.name = "" + getToStringValue(name)) : element.removeAttribute("name");
    }
    function initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
        null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (checkAttributeStringCoercion(type, "type"), element.type = type);
        if (null != value || null != defaultValue) {
            if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
                track(element);
                return;
            }
            defaultValue = null != defaultValue ? "" + getToStringValue(defaultValue) : "";
            value = null != value ? "" + getToStringValue(value) : defaultValue;
            isHydrating || value === element.value || (element.value = value);
            element.defaultValue = value;
        }
        checked = null != checked ? checked : defaultChecked;
        checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
        element.checked = isHydrating ? element.checked : !!checked;
        element.defaultChecked = !!checked;
        null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (checkAttributeStringCoercion(name, "name"), element.name = name);
        track(element);
    }
    function setDefaultValue(node, type, value) {
        "number" === type && getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
    }
    function validateOptionProps(element, props) {
        null == props.value && ("object" === typeof props.children && null !== props.children ? React.Children.forEach(props.children, function(child) {
            null == child || "string" === typeof child || "number" === typeof child || "bigint" === typeof child || didWarnInvalidChild || (didWarnInvalidChild = !0, console.error("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>."));
        }) : null == props.dangerouslySetInnerHTML || didWarnInvalidInnerHTML || (didWarnInvalidInnerHTML = !0, console.error("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.")));
        null == props.selected || didWarnSelectedSetOnOption || (console.error("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), didWarnSelectedSetOnOption = !0);
    }
    function getDeclarationErrorAddendum() {
        var ownerName = getCurrentFiberOwnerNameInDevOrNull();
        return ownerName ? "\n\nCheck the render method of `" + ownerName + "`." : "";
    }
    function updateOptions(node, multiple, propValue, setDefaultSelected) {
        node = node.options;
        if (multiple) {
            multiple = {};
            for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
            for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
        } else {
            propValue = "" + getToStringValue(propValue);
            multiple = null;
            for(i = 0; i < node.length; i++){
                if (node[i].value === propValue) {
                    node[i].selected = !0;
                    setDefaultSelected && (node[i].defaultSelected = !0);
                    return;
                }
                null !== multiple || node[i].disabled || (multiple = node[i]);
            }
            null !== multiple && (multiple.selected = !0);
        }
    }
    function validateSelectProps(element, props) {
        for(element = 0; element < valuePropNames.length; element++){
            var propName = valuePropNames[element];
            if (null != props[propName]) {
                var propNameIsArray = isArrayImpl(props[propName]);
                props.multiple && !propNameIsArray ? console.error("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", propName, getDeclarationErrorAddendum()) : !props.multiple && propNameIsArray && console.error("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", propName, getDeclarationErrorAddendum());
            }
        }
        void 0 === props.value || void 0 === props.defaultValue || didWarnValueDefaultValue || (console.error("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://react.dev/link/controlled-components"), didWarnValueDefaultValue = !0);
    }
    function validateTextareaProps(element, props) {
        void 0 === props.value || void 0 === props.defaultValue || didWarnValDefaultVal || (console.error("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://react.dev/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component"), didWarnValDefaultVal = !0);
        null != props.children && null == props.value && console.error("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
    }
    function updateTextarea(element, value, defaultValue) {
        if (null != value && (value = "" + getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
            element.defaultValue !== value && (element.defaultValue = value);
            return;
        }
        element.defaultValue = null != defaultValue ? "" + getToStringValue(defaultValue) : "";
    }
    function initTextarea(element, value, defaultValue, children) {
        if (null == value) {
            if (null != children) {
                if (null != defaultValue) throw Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
                if (isArrayImpl(children)) {
                    if (1 < children.length) throw Error("<textarea> can only have at most one child.");
                    children = children[0];
                }
                defaultValue = children;
            }
            null == defaultValue && (defaultValue = "");
            value = defaultValue;
        }
        defaultValue = getToStringValue(value);
        element.defaultValue = defaultValue;
        children = element.textContent;
        children === defaultValue && "" !== children && null !== children && (element.value = children);
        track(element);
    }
    function findNotableNode(node, indent) {
        return void 0 === node.serverProps && 0 === node.serverTail.length && 1 === node.children.length && 3 < node.distanceFromLeaf && node.distanceFromLeaf > 15 - indent ? findNotableNode(node.children[0], indent) : node;
    }
    function indentation(indent) {
        return "  " + "  ".repeat(indent);
    }
    function added(indent) {
        return "+ " + "  ".repeat(indent);
    }
    function removed(indent) {
        return "- " + "  ".repeat(indent);
    }
    function describeFiberType(fiber) {
        switch(fiber.tag){
            case 26:
            case 27:
            case 5:
                return fiber.type;
            case 16:
                return "Lazy";
            case 31:
                return "Activity";
            case 13:
                return "Suspense";
            case 19:
                return "SuspenseList";
            case 0:
            case 15:
                return fiber = fiber.type, fiber.displayName || fiber.name || null;
            case 11:
                return fiber = fiber.type.render, fiber.displayName || fiber.name || null;
            case 1:
                return fiber = fiber.type, fiber.displayName || fiber.name || null;
            default:
                return null;
        }
    }
    function describeTextNode(content, maxLength) {
        return needsEscaping.test(content) ? (content = JSON.stringify(content), content.length > maxLength - 2 ? 8 > maxLength ? '{"..."}' : "{" + content.slice(0, maxLength - 7) + '..."}' : "{" + content + "}") : content.length > maxLength ? 5 > maxLength ? '{"..."}' : content.slice(0, maxLength - 3) + "..." : content;
    }
    function describeTextDiff(clientText, serverProps, indent) {
        var maxLength = 120 - 2 * indent;
        if (null === serverProps) return added(indent) + describeTextNode(clientText, maxLength) + "\n";
        if ("string" === typeof serverProps) {
            for(var firstDiff = 0; firstDiff < serverProps.length && firstDiff < clientText.length && serverProps.charCodeAt(firstDiff) === clientText.charCodeAt(firstDiff); firstDiff++);
            firstDiff > maxLength - 8 && 10 < firstDiff && (clientText = "..." + clientText.slice(firstDiff - 8), serverProps = "..." + serverProps.slice(firstDiff - 8));
            return added(indent) + describeTextNode(clientText, maxLength) + "\n" + removed(indent) + describeTextNode(serverProps, maxLength) + "\n";
        }
        return indentation(indent) + describeTextNode(clientText, maxLength) + "\n";
    }
    function objectName(object) {
        return Object.prototype.toString.call(object).replace(/^\[object (.*)\]$/, function(m, p0) {
            return p0;
        });
    }
    function describeValue(value, maxLength) {
        switch(typeof value){
            case "string":
                return value = JSON.stringify(value), value.length > maxLength ? 5 > maxLength ? '"..."' : value.slice(0, maxLength - 4) + '..."' : value;
            case "object":
                if (null === value) return "null";
                if (isArrayImpl(value)) return "[...]";
                if (value.$$typeof === REACT_ELEMENT_TYPE) return (maxLength = getComponentNameFromType(value.type)) ? "<" + maxLength + ">" : "<...>";
                var name = objectName(value);
                if ("Object" === name) {
                    name = "";
                    maxLength -= 2;
                    for(var propName in value)if (value.hasOwnProperty(propName)) {
                        var jsonPropName = JSON.stringify(propName);
                        jsonPropName !== '"' + propName + '"' && (propName = jsonPropName);
                        maxLength -= propName.length - 2;
                        jsonPropName = describeValue(value[propName], 15 > maxLength ? maxLength : 15);
                        maxLength -= jsonPropName.length;
                        if (0 > maxLength) {
                            name += "" === name ? "..." : ", ...";
                            break;
                        }
                        name += ("" === name ? "" : ",") + propName + ":" + jsonPropName;
                    }
                    return "{" + name + "}";
                }
                return name;
            case "function":
                return (maxLength = value.displayName || value.name) ? "function " + maxLength : "function";
            default:
                return String(value);
        }
    }
    function describePropValue(value, maxLength) {
        return "string" !== typeof value || needsEscaping.test(value) ? "{" + describeValue(value, maxLength - 2) + "}" : value.length > maxLength - 2 ? 5 > maxLength ? '"..."' : '"' + value.slice(0, maxLength - 5) + '..."' : '"' + value + '"';
    }
    function describeExpandedElement(type, props, rowPrefix) {
        var remainingRowLength = 120 - rowPrefix.length - type.length, properties = [], propName;
        for(propName in props)if (props.hasOwnProperty(propName) && "children" !== propName) {
            var propValue = describePropValue(props[propName], 120 - rowPrefix.length - propName.length - 1);
            remainingRowLength -= propName.length + propValue.length + 2;
            properties.push(propName + "=" + propValue);
        }
        return 0 === properties.length ? rowPrefix + "<" + type + ">\n" : 0 < remainingRowLength ? rowPrefix + "<" + type + " " + properties.join(" ") + ">\n" : rowPrefix + "<" + type + "\n" + rowPrefix + "  " + properties.join("\n" + rowPrefix + "  ") + "\n" + rowPrefix + ">\n";
    }
    function describePropertiesDiff(clientObject, serverObject, indent) {
        var properties = "", remainingServerProperties = assign({}, serverObject), propName;
        for(propName in clientObject)if (clientObject.hasOwnProperty(propName)) {
            delete remainingServerProperties[propName];
            var maxLength = 120 - 2 * indent - propName.length - 2, clientPropValue = describeValue(clientObject[propName], maxLength);
            serverObject.hasOwnProperty(propName) ? (maxLength = describeValue(serverObject[propName], maxLength), properties += added(indent) + propName + ": " + clientPropValue + "\n", properties += removed(indent) + propName + ": " + maxLength + "\n") : properties += added(indent) + propName + ": " + clientPropValue + "\n";
        }
        for(var _propName in remainingServerProperties)remainingServerProperties.hasOwnProperty(_propName) && (clientObject = describeValue(remainingServerProperties[_propName], 120 - 2 * indent - _propName.length - 2), properties += removed(indent) + _propName + ": " + clientObject + "\n");
        return properties;
    }
    function describeElementDiff(type, clientProps, serverProps, indent) {
        var content = "", serverPropNames = new Map();
        for(propName$jscomp$0 in serverProps)serverProps.hasOwnProperty(propName$jscomp$0) && serverPropNames.set(propName$jscomp$0.toLowerCase(), propName$jscomp$0);
        if (1 === serverPropNames.size && serverPropNames.has("children")) content += describeExpandedElement(type, clientProps, indentation(indent));
        else {
            for(var _propName2 in clientProps)if (clientProps.hasOwnProperty(_propName2) && "children" !== _propName2) {
                var maxLength$jscomp$0 = 120 - 2 * (indent + 1) - _propName2.length - 1, serverPropName = serverPropNames.get(_propName2.toLowerCase());
                if (void 0 !== serverPropName) {
                    serverPropNames.delete(_propName2.toLowerCase());
                    var propName$jscomp$0 = clientProps[_propName2];
                    serverPropName = serverProps[serverPropName];
                    var clientPropValue = describePropValue(propName$jscomp$0, maxLength$jscomp$0);
                    maxLength$jscomp$0 = describePropValue(serverPropName, maxLength$jscomp$0);
                    "object" === typeof propName$jscomp$0 && null !== propName$jscomp$0 && "object" === typeof serverPropName && null !== serverPropName && "Object" === objectName(propName$jscomp$0) && "Object" === objectName(serverPropName) && (2 < Object.keys(propName$jscomp$0).length || 2 < Object.keys(serverPropName).length || -1 < clientPropValue.indexOf("...") || -1 < maxLength$jscomp$0.indexOf("...")) ? content += indentation(indent + 1) + _propName2 + "={{\n" + describePropertiesDiff(propName$jscomp$0, serverPropName, indent + 2) + indentation(indent + 1) + "}}\n" : (content += added(indent + 1) + _propName2 + "=" + clientPropValue + "\n", content += removed(indent + 1) + _propName2 + "=" + maxLength$jscomp$0 + "\n");
                } else content += indentation(indent + 1) + _propName2 + "=" + describePropValue(clientProps[_propName2], maxLength$jscomp$0) + "\n";
            }
            serverPropNames.forEach(function(propName) {
                if ("children" !== propName) {
                    var maxLength = 120 - 2 * (indent + 1) - propName.length - 1;
                    content += removed(indent + 1) + propName + "=" + describePropValue(serverProps[propName], maxLength) + "\n";
                }
            });
            content = "" === content ? indentation(indent) + "<" + type + ">\n" : indentation(indent) + "<" + type + "\n" + content + indentation(indent) + ">\n";
        }
        type = serverProps.children;
        clientProps = clientProps.children;
        if ("string" === typeof type || "number" === typeof type || "bigint" === typeof type) {
            serverPropNames = "";
            if ("string" === typeof clientProps || "number" === typeof clientProps || "bigint" === typeof clientProps) serverPropNames = "" + clientProps;
            content += describeTextDiff(serverPropNames, "" + type, indent + 1);
        } else if ("string" === typeof clientProps || "number" === typeof clientProps || "bigint" === typeof clientProps) content = null == type ? content + describeTextDiff("" + clientProps, null, indent + 1) : content + describeTextDiff("" + clientProps, void 0, indent + 1);
        return content;
    }
    function describeSiblingFiber(fiber, indent) {
        var type = describeFiberType(fiber);
        if (null === type) {
            type = "";
            for(fiber = fiber.child; fiber;)type += describeSiblingFiber(fiber, indent), fiber = fiber.sibling;
            return type;
        }
        return indentation(indent) + "<" + type + ">\n";
    }
    function describeNode(node, indent) {
        var skipToNode = findNotableNode(node, indent);
        if (skipToNode !== node && (1 !== node.children.length || node.children[0] !== skipToNode)) return indentation(indent) + "...\n" + describeNode(skipToNode, indent + 1);
        skipToNode = "";
        var debugInfo = node.fiber._debugInfo;
        if (debugInfo) for(var i = 0; i < debugInfo.length; i++){
            var serverComponentName = debugInfo[i].name;
            "string" === typeof serverComponentName && (skipToNode += indentation(indent) + "<" + serverComponentName + ">\n", indent++);
        }
        debugInfo = "";
        i = node.fiber.pendingProps;
        if (6 === node.fiber.tag) debugInfo = describeTextDiff(i, node.serverProps, indent), indent++;
        else if (serverComponentName = describeFiberType(node.fiber), null !== serverComponentName) {
            if (void 0 === node.serverProps) {
                debugInfo = indent;
                var maxLength = 120 - 2 * debugInfo - serverComponentName.length - 2, content = "";
                for(propName in i)if (i.hasOwnProperty(propName) && "children" !== propName) {
                    var propValue = describePropValue(i[propName], 15);
                    maxLength -= propName.length + propValue.length + 2;
                    if (0 > maxLength) {
                        content += " ...";
                        break;
                    }
                    content += " " + propName + "=" + propValue;
                }
                debugInfo = indentation(debugInfo) + "<" + serverComponentName + content + ">\n";
                indent++;
            } else null === node.serverProps ? (debugInfo = describeExpandedElement(serverComponentName, i, added(indent)), indent++) : "string" === typeof node.serverProps ? console.error("Should not have matched a non HostText fiber to a Text node. This is a bug in React.") : (debugInfo = describeElementDiff(serverComponentName, i, node.serverProps, indent), indent++);
        }
        var propName = "";
        i = node.fiber.child;
        for(serverComponentName = 0; i && serverComponentName < node.children.length;)maxLength = node.children[serverComponentName], maxLength.fiber === i ? (propName += describeNode(maxLength, indent), serverComponentName++) : propName += describeSiblingFiber(i, indent), i = i.sibling;
        i && 0 < node.children.length && (propName += indentation(indent) + "...\n");
        i = node.serverTail;
        null === node.serverProps && indent--;
        for(node = 0; node < i.length; node++)serverComponentName = i[node], propName = "string" === typeof serverComponentName ? propName + (removed(indent) + describeTextNode(serverComponentName, 120 - 2 * indent) + "\n") : propName + describeExpandedElement(serverComponentName.type, serverComponentName.props, removed(indent));
        return skipToNode + debugInfo + propName;
    }
    function describeDiff(rootNode) {
        try {
            return "\n\n" + describeNode(rootNode, 0);
        } catch (x) {
            return "";
        }
    }
    function describeAncestors(ancestor, child, props) {
        for(var fiber = child, node = null, distanceFromLeaf = 0; fiber;)fiber === ancestor && (distanceFromLeaf = 0), node = {
            fiber: fiber,
            children: null !== node ? [
                node
            ] : [],
            serverProps: fiber === child ? props : fiber === ancestor ? null : void 0,
            serverTail: [],
            distanceFromLeaf: distanceFromLeaf
        }, distanceFromLeaf++, fiber = fiber.return;
        return null !== node ? describeDiff(node).replaceAll(/^[+-]/gm, ">") : "";
    }
    function updatedAncestorInfoDev(oldInfo, tag) {
        var ancestorInfo = assign({}, oldInfo || emptyAncestorInfoDev), info = {
            tag: tag
        };
        -1 !== inScopeTags.indexOf(tag) && (ancestorInfo.aTagInScope = null, ancestorInfo.buttonTagInScope = null, ancestorInfo.nobrTagInScope = null);
        -1 !== buttonScopeTags.indexOf(tag) && (ancestorInfo.pTagInButtonScope = null);
        -1 !== specialTags.indexOf(tag) && "address" !== tag && "div" !== tag && "p" !== tag && (ancestorInfo.listItemTagAutoclosing = null, ancestorInfo.dlItemTagAutoclosing = null);
        ancestorInfo.current = info;
        "form" === tag && (ancestorInfo.formTag = info);
        "a" === tag && (ancestorInfo.aTagInScope = info);
        "button" === tag && (ancestorInfo.buttonTagInScope = info);
        "nobr" === tag && (ancestorInfo.nobrTagInScope = info);
        "p" === tag && (ancestorInfo.pTagInButtonScope = info);
        "li" === tag && (ancestorInfo.listItemTagAutoclosing = info);
        if ("dd" === tag || "dt" === tag) ancestorInfo.dlItemTagAutoclosing = info;
        "#document" === tag || "html" === tag ? ancestorInfo.containerTagInScope = null : ancestorInfo.containerTagInScope || (ancestorInfo.containerTagInScope = info);
        null !== oldInfo || "#document" !== tag && "html" !== tag && "body" !== tag ? !0 === ancestorInfo.implicitRootScope && (ancestorInfo.implicitRootScope = !1) : ancestorInfo.implicitRootScope = !0;
        return ancestorInfo;
    }
    function isTagValidWithParent(tag, parentTag, implicitRootScope) {
        switch(parentTag){
            case "select":
                return "hr" === tag || "option" === tag || "optgroup" === tag || "script" === tag || "template" === tag || "#text" === tag;
            case "optgroup":
                return "option" === tag || "#text" === tag;
            case "option":
                return "#text" === tag;
            case "tr":
                return "th" === tag || "td" === tag || "style" === tag || "script" === tag || "template" === tag;
            case "tbody":
            case "thead":
            case "tfoot":
                return "tr" === tag || "style" === tag || "script" === tag || "template" === tag;
            case "colgroup":
                return "col" === tag || "template" === tag;
            case "table":
                return "caption" === tag || "colgroup" === tag || "tbody" === tag || "tfoot" === tag || "thead" === tag || "style" === tag || "script" === tag || "template" === tag;
            case "head":
                return "base" === tag || "basefont" === tag || "bgsound" === tag || "link" === tag || "meta" === tag || "title" === tag || "noscript" === tag || "noframes" === tag || "style" === tag || "script" === tag || "template" === tag;
            case "html":
                if (implicitRootScope) break;
                return "head" === tag || "body" === tag || "frameset" === tag;
            case "frameset":
                return "frame" === tag;
            case "#document":
                if (!implicitRootScope) return "html" === tag;
        }
        switch(tag){
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
                return "h1" !== parentTag && "h2" !== parentTag && "h3" !== parentTag && "h4" !== parentTag && "h5" !== parentTag && "h6" !== parentTag;
            case "rp":
            case "rt":
                return -1 === impliedEndTags.indexOf(parentTag);
            case "caption":
            case "col":
            case "colgroup":
            case "frameset":
            case "frame":
            case "tbody":
            case "td":
            case "tfoot":
            case "th":
            case "thead":
            case "tr":
                return null == parentTag;
            case "head":
                return implicitRootScope || null === parentTag;
            case "html":
                return implicitRootScope && "#document" === parentTag || null === parentTag;
            case "body":
                return implicitRootScope && ("#document" === parentTag || "html" === parentTag) || null === parentTag;
        }
        return !0;
    }
    function findInvalidAncestorForTag(tag, ancestorInfo) {
        switch(tag){
            case "address":
            case "article":
            case "aside":
            case "blockquote":
            case "center":
            case "details":
            case "dialog":
            case "dir":
            case "div":
            case "dl":
            case "fieldset":
            case "figcaption":
            case "figure":
            case "footer":
            case "header":
            case "hgroup":
            case "main":
            case "menu":
            case "nav":
            case "ol":
            case "p":
            case "section":
            case "summary":
            case "ul":
            case "pre":
            case "listing":
            case "table":
            case "hr":
            case "xmp":
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
                return ancestorInfo.pTagInButtonScope;
            case "form":
                return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
            case "li":
                return ancestorInfo.listItemTagAutoclosing;
            case "dd":
            case "dt":
                return ancestorInfo.dlItemTagAutoclosing;
            case "button":
                return ancestorInfo.buttonTagInScope;
            case "a":
                return ancestorInfo.aTagInScope;
            case "nobr":
                return ancestorInfo.nobrTagInScope;
        }
        return null;
    }
    function findAncestor(parent, tagName) {
        for(; parent;){
            switch(parent.tag){
                case 5:
                case 26:
                case 27:
                    if (parent.type === tagName) return parent;
            }
            parent = parent.return;
        }
        return null;
    }
    function validateDOMNesting(childTag, ancestorInfo) {
        ancestorInfo = ancestorInfo || emptyAncestorInfoDev;
        var parentInfo = ancestorInfo.current;
        ancestorInfo = (parentInfo = isTagValidWithParent(childTag, parentInfo && parentInfo.tag, ancestorInfo.implicitRootScope) ? null : parentInfo) ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
        ancestorInfo = parentInfo || ancestorInfo;
        if (!ancestorInfo) return !0;
        var ancestorTag = ancestorInfo.tag;
        ancestorInfo = String(!!parentInfo) + "|" + childTag + "|" + ancestorTag;
        if (didWarn[ancestorInfo]) return !1;
        didWarn[ancestorInfo] = !0;
        var ancestor = (ancestorInfo = current) ? findAncestor(ancestorInfo.return, ancestorTag) : null, ancestorDescription = null !== ancestorInfo && null !== ancestor ? describeAncestors(ancestor, ancestorInfo, null) : "", tagDisplayName = "<" + childTag + ">";
        parentInfo ? (parentInfo = "", "table" === ancestorTag && "tr" === childTag && (parentInfo += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), console.error("In HTML, %s cannot be a child of <%s>.%s\nThis will cause a hydration error.%s", tagDisplayName, ancestorTag, parentInfo, ancestorDescription)) : console.error("In HTML, %s cannot be a descendant of <%s>.\nThis will cause a hydration error.%s", tagDisplayName, ancestorTag, ancestorDescription);
        ancestorInfo && (childTag = ancestorInfo.return, null === ancestor || null === childTag || ancestor === childTag && childTag._debugOwner === ancestorInfo._debugOwner || runWithFiberInDEV(ancestor, function() {
            console.error("<%s> cannot contain a nested %s.\nSee this log for the ancestor stack trace.", ancestorTag, tagDisplayName);
        }));
        return !1;
    }
    function validateTextNesting(childText, parentTag, implicitRootScope) {
        if (implicitRootScope || isTagValidWithParent("#text", parentTag, !1)) return !0;
        implicitRootScope = "#text|" + parentTag;
        if (didWarn[implicitRootScope]) return !1;
        didWarn[implicitRootScope] = !0;
        var ancestor = (implicitRootScope = current) ? findAncestor(implicitRootScope, parentTag) : null;
        implicitRootScope = null !== implicitRootScope && null !== ancestor ? describeAncestors(ancestor, implicitRootScope, 6 !== implicitRootScope.tag ? {
            children: null
        } : null) : "";
        /\S/.test(childText) ? console.error("In HTML, text nodes cannot be a child of <%s>.\nThis will cause a hydration error.%s", parentTag, implicitRootScope) : console.error("In HTML, whitespace text nodes cannot be a child of <%s>. Make sure you don't have any extra whitespace between tags on each line of your source code.\nThis will cause a hydration error.%s", parentTag, implicitRootScope);
        return !1;
    }
    function setTextContent(node, text) {
        if (text) {
            var firstChild = node.firstChild;
            if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
                firstChild.nodeValue = text;
                return;
            }
        }
        node.textContent = text;
    }
    function camelize(string) {
        return string.replace(hyphenPattern, function(_, character) {
            return character.toUpperCase();
        });
    }
    function setValueForStyle(style, styleName, value) {
        var isCustomProperty = 0 === styleName.indexOf("--");
        isCustomProperty || (-1 < styleName.indexOf("-") ? warnedStyleNames.hasOwnProperty(styleName) && warnedStyleNames[styleName] || (warnedStyleNames[styleName] = !0, console.error("Unsupported style property %s. Did you mean %s?", styleName, camelize(styleName.replace(msPattern, "ms-")))) : badVendoredStyleNamePattern.test(styleName) ? warnedStyleNames.hasOwnProperty(styleName) && warnedStyleNames[styleName] || (warnedStyleNames[styleName] = !0, console.error("Unsupported vendor-prefixed style property %s. Did you mean %s?", styleName, styleName.charAt(0).toUpperCase() + styleName.slice(1))) : !badStyleValueWithSemicolonPattern.test(value) || warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value] || (warnedStyleValues[value] = !0, console.error('Style property values shouldn\'t contain a semicolon. Try "%s: %s" instead.', styleName, value.replace(badStyleValueWithSemicolonPattern, ""))), "number" === typeof value && (isNaN(value) ? warnedForNaNValue || (warnedForNaNValue = !0, console.error("`NaN` is an invalid value for the `%s` css style property.", styleName)) : isFinite(value) || warnedForInfinityValue || (warnedForInfinityValue = !0, console.error("`Infinity` is an invalid value for the `%s` css style property.", styleName))));
        null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : (checkCSSPropertyStringCoercion(value, styleName), style[styleName] = ("" + value).trim()) : style[styleName] = value + "px";
    }
    function setValueForStyles(node, styles, prevStyles) {
        if (null != styles && "object" !== typeof styles) throw Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
        styles && Object.freeze(styles);
        node = node.style;
        if (null != prevStyles) {
            if (styles) {
                var expandedUpdates = {};
                if (prevStyles) {
                    for(var key in prevStyles)if (prevStyles.hasOwnProperty(key) && !styles.hasOwnProperty(key)) for(var longhands = shorthandToLonghand[key] || [
                        key
                    ], i = 0; i < longhands.length; i++)expandedUpdates[longhands[i]] = key;
                }
                for(var _key in styles)if (styles.hasOwnProperty(_key) && (!prevStyles || prevStyles[_key] !== styles[_key])) for(key = shorthandToLonghand[_key] || [
                    _key
                ], longhands = 0; longhands < key.length; longhands++)expandedUpdates[key[longhands]] = _key;
                _key = {};
                for(var key$jscomp$0 in styles)for(key = shorthandToLonghand[key$jscomp$0] || [
                    key$jscomp$0
                ], longhands = 0; longhands < key.length; longhands++)_key[key[longhands]] = key$jscomp$0;
                key$jscomp$0 = {};
                for(var _key2 in expandedUpdates)if (key = expandedUpdates[_key2], (longhands = _key[_key2]) && key !== longhands && (i = key + "," + longhands, !key$jscomp$0[i])) {
                    key$jscomp$0[i] = !0;
                    i = console;
                    var value = styles[key];
                    i.error.call(i, "%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", null == value || "boolean" === typeof value || "" === value ? "Removing" : "Updating", key, longhands);
                }
            }
            for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
            for(var _styleName in styles)_key2 = styles[_styleName], styles.hasOwnProperty(_styleName) && prevStyles[_styleName] !== _key2 && setValueForStyle(node, _styleName, _key2);
        } else for(expandedUpdates in styles)styles.hasOwnProperty(expandedUpdates) && setValueForStyle(node, expandedUpdates, styles[expandedUpdates]);
    }
    function isCustomElement(tagName) {
        if (-1 === tagName.indexOf("-")) return !1;
        switch(tagName){
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
                return !1;
            default:
                return !0;
        }
    }
    function getAttributeAlias(name) {
        return aliases.get(name) || name;
    }
    function validateProperty$1(tagName, name) {
        if (hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) return !0;
        if (rARIACamel$1.test(name)) {
            tagName = "aria-" + name.slice(4).toLowerCase();
            tagName = ariaProperties.hasOwnProperty(tagName) ? tagName : null;
            if (null == tagName) return console.error("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", name), warnedProperties$1[name] = !0;
            if (name !== tagName) return console.error("Invalid ARIA attribute `%s`. Did you mean `%s`?", name, tagName), warnedProperties$1[name] = !0;
        }
        if (rARIA$1.test(name)) {
            tagName = name.toLowerCase();
            tagName = ariaProperties.hasOwnProperty(tagName) ? tagName : null;
            if (null == tagName) return warnedProperties$1[name] = !0, !1;
            name !== tagName && (console.error("Unknown ARIA attribute `%s`. Did you mean `%s`?", name, tagName), warnedProperties$1[name] = !0);
        }
        return !0;
    }
    function validateProperties$2(type, props) {
        var invalidProps = [], key;
        for(key in props)validateProperty$1(type, key) || invalidProps.push(key);
        props = invalidProps.map(function(prop) {
            return "`" + prop + "`";
        }).join(", ");
        1 === invalidProps.length ? console.error("Invalid aria prop %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props", props, type) : 1 < invalidProps.length && console.error("Invalid aria props %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props", props, type);
    }
    function validateProperty(tagName, name, value, eventRegistry) {
        if (hasOwnProperty.call(warnedProperties, name) && warnedProperties[name]) return !0;
        var lowerCasedName = name.toLowerCase();
        if ("onfocusin" === lowerCasedName || "onfocusout" === lowerCasedName) return console.error("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), warnedProperties[name] = !0;
        if ("function" === typeof value && ("form" === tagName && "action" === name || "input" === tagName && "formAction" === name || "button" === tagName && "formAction" === name)) return !0;
        if (null != eventRegistry) {
            tagName = eventRegistry.possibleRegistrationNames;
            if (eventRegistry.registrationNameDependencies.hasOwnProperty(name)) return !0;
            eventRegistry = tagName.hasOwnProperty(lowerCasedName) ? tagName[lowerCasedName] : null;
            if (null != eventRegistry) return console.error("Invalid event handler property `%s`. Did you mean `%s`?", name, eventRegistry), warnedProperties[name] = !0;
            if (EVENT_NAME_REGEX.test(name)) return console.error("Unknown event handler property `%s`. It will be ignored.", name), warnedProperties[name] = !0;
        } else if (EVENT_NAME_REGEX.test(name)) return INVALID_EVENT_NAME_REGEX.test(name) && console.error("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", name), warnedProperties[name] = !0;
        if (rARIA.test(name) || rARIACamel.test(name)) return !0;
        if ("innerhtml" === lowerCasedName) return console.error("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), warnedProperties[name] = !0;
        if ("aria" === lowerCasedName) return console.error("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), warnedProperties[name] = !0;
        if ("is" === lowerCasedName && null !== value && void 0 !== value && "string" !== typeof value) return console.error("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof value), warnedProperties[name] = !0;
        if ("number" === typeof value && isNaN(value)) return console.error("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", name), warnedProperties[name] = !0;
        if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
            if (lowerCasedName = possibleStandardNames[lowerCasedName], lowerCasedName !== name) return console.error("Invalid DOM property `%s`. Did you mean `%s`?", name, lowerCasedName), warnedProperties[name] = !0;
        } else if (name !== lowerCasedName) return console.error("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", name, lowerCasedName), warnedProperties[name] = !0;
        switch(name){
            case "dangerouslySetInnerHTML":
            case "children":
            case "style":
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
            case "defaultValue":
            case "defaultChecked":
            case "innerHTML":
            case "ref":
                return !0;
            case "innerText":
            case "textContent":
                return !0;
        }
        switch(typeof value){
            case "boolean":
                switch(name){
                    case "autoFocus":
                    case "checked":
                    case "multiple":
                    case "muted":
                    case "selected":
                    case "contentEditable":
                    case "spellCheck":
                    case "draggable":
                    case "value":
                    case "autoReverse":
                    case "externalResourcesRequired":
                    case "focusable":
                    case "preserveAlpha":
                    case "allowFullScreen":
                    case "async":
                    case "autoPlay":
                    case "controls":
                    case "default":
                    case "defer":
                    case "disabled":
                    case "disablePictureInPicture":
                    case "disableRemotePlayback":
                    case "formNoValidate":
                    case "hidden":
                    case "loop":
                    case "noModule":
                    case "noValidate":
                    case "open":
                    case "playsInline":
                    case "readOnly":
                    case "required":
                    case "reversed":
                    case "scoped":
                    case "seamless":
                    case "itemScope":
                    case "capture":
                    case "download":
                    case "inert":
                        return !0;
                    default:
                        lowerCasedName = name.toLowerCase().slice(0, 5);
                        if ("data-" === lowerCasedName || "aria-" === lowerCasedName) return !0;
                        value ? console.error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', value, name, name, value, name) : console.error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
                        return warnedProperties[name] = !0;
                }
            case "function":
            case "symbol":
                return warnedProperties[name] = !0, !1;
            case "string":
                if ("false" === value || "true" === value) {
                    switch(name){
                        case "checked":
                        case "selected":
                        case "multiple":
                        case "muted":
                        case "allowFullScreen":
                        case "async":
                        case "autoPlay":
                        case "controls":
                        case "default":
                        case "defer":
                        case "disabled":
                        case "disablePictureInPicture":
                        case "disableRemotePlayback":
                        case "formNoValidate":
                        case "hidden":
                        case "loop":
                        case "noModule":
                        case "noValidate":
                        case "open":
                        case "playsInline":
                        case "readOnly":
                        case "required":
                        case "reversed":
                        case "scoped":
                        case "seamless":
                        case "itemScope":
                        case "inert":
                            break;
                        default:
                            return !0;
                    }
                    console.error("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", value, name, "false" === value ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
                    warnedProperties[name] = !0;
                }
        }
        return !0;
    }
    function warnUnknownProperties(type, props, eventRegistry) {
        var unknownProps = [], key;
        for(key in props)validateProperty(type, key, props[key], eventRegistry) || unknownProps.push(key);
        props = unknownProps.map(function(prop) {
            return "`" + prop + "`";
        }).join(", ");
        1 === unknownProps.length ? console.error("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://react.dev/link/attribute-behavior ", props, type) : 1 < unknownProps.length && console.error("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://react.dev/link/attribute-behavior ", props, type);
    }
    function sanitizeURL(url) {
        return isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
    }
    function noop$1() {}
    function getEventTarget(nativeEvent) {
        nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
        nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
        return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
    }
    function restoreStateOfTarget(target) {
        var internalInstance = getInstanceFromNode(target);
        if (internalInstance && (target = internalInstance.stateNode)) {
            var props = target[internalPropsKey] || null;
            a: switch(target = internalInstance.stateNode, internalInstance.type){
                case "input":
                    updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                    internalInstance = props.name;
                    if ("radio" === props.type && null != internalInstance) {
                        for(props = target; props.parentNode;)props = props.parentNode;
                        checkAttributeStringCoercion(internalInstance, "name");
                        props = props.querySelectorAll('input[name="' + escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                        for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                            var otherNode = props[internalInstance];
                            if (otherNode !== target && otherNode.form === target.form) {
                                var otherProps = otherNode[internalPropsKey] || null;
                                if (!otherProps) throw Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
                                updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                            }
                        }
                        for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && updateValueIfChanged(otherNode);
                    }
                    break a;
                case "textarea":
                    updateTextarea(target, props.value, props.defaultValue);
                    break a;
                case "select":
                    internalInstance = props.value, null != internalInstance && updateOptions(target, !!props.multiple, internalInstance, !1);
            }
        }
    }
    function batchedUpdates$1(fn, a, b) {
        if (isInsideEventHandler) return fn(a, b);
        isInsideEventHandler = !0;
        try {
            var JSCompiler_inline_result = fn(a);
            return JSCompiler_inline_result;
        } finally{
            if (isInsideEventHandler = !1, null !== restoreTarget || null !== restoreQueue) {
                if (flushSyncWork$1(), restoreTarget && (a = restoreTarget, fn = restoreQueue, restoreQueue = restoreTarget = null, restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)restoreStateOfTarget(fn[a]);
            }
        }
    }
    function getListener(inst, registrationName) {
        var stateNode = inst.stateNode;
        if (null === stateNode) return null;
        var props = stateNode[internalPropsKey] || null;
        if (null === props) return null;
        stateNode = props[registrationName];
        a: switch(registrationName){
            case "onClick":
            case "onClickCapture":
            case "onDoubleClick":
            case "onDoubleClickCapture":
            case "onMouseDown":
            case "onMouseDownCapture":
            case "onMouseMove":
            case "onMouseMoveCapture":
            case "onMouseUp":
            case "onMouseUpCapture":
            case "onMouseEnter":
                (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
                inst = !props;
                break a;
            default:
                inst = !1;
        }
        if (inst) return null;
        if (stateNode && "function" !== typeof stateNode) throw Error("Expected `" + registrationName + "` listener to be a function, instead got a value of `" + typeof stateNode + "` type.");
        return stateNode;
    }
    function getData() {
        if (fallbackText) return fallbackText;
        var start, startValue = startText, startLength = startValue.length, end, endValue = "value" in root ? root.value : root.textContent, endLength = endValue.length;
        for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
        var minEnd = startLength - start;
        for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
        return fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
    }
    function getEventCharCode(nativeEvent) {
        var keyCode = nativeEvent.keyCode;
        "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
        10 === nativeEvent && (nativeEvent = 13);
        return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
    }
    function functionThatReturnsTrue() {
        return !0;
    }
    function functionThatReturnsFalse() {
        return !1;
    }
    function createSyntheticEvent(Interface) {
        function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
            this._reactName = reactName;
            this._targetInst = targetInst;
            this.type = reactEventType;
            this.nativeEvent = nativeEvent;
            this.target = nativeEventTarget;
            this.currentTarget = null;
            for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
            this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? functionThatReturnsTrue : functionThatReturnsFalse;
            this.isPropagationStopped = functionThatReturnsFalse;
            return this;
        }
        assign(SyntheticBaseEvent.prototype, {
            preventDefault: function() {
                this.defaultPrevented = !0;
                var event = this.nativeEvent;
                event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = functionThatReturnsTrue);
            },
            stopPropagation: function() {
                var event = this.nativeEvent;
                event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = functionThatReturnsTrue);
            },
            persist: function() {},
            isPersistent: functionThatReturnsTrue
        });
        return SyntheticBaseEvent;
    }
    function modifierStateGetter(keyArg) {
        var nativeEvent = this.nativeEvent;
        return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
    }
    function getEventModifierState() {
        return modifierStateGetter;
    }
    function isFallbackCompositionEnd(domEventName, nativeEvent) {
        switch(domEventName){
            case "keyup":
                return -1 !== END_KEYCODES.indexOf(nativeEvent.keyCode);
            case "keydown":
                return nativeEvent.keyCode !== START_KEYCODE;
            case "keypress":
            case "mousedown":
            case "focusout":
                return !0;
            default:
                return !1;
        }
    }
    function getDataFromCustomEvent(nativeEvent) {
        nativeEvent = nativeEvent.detail;
        return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
    }
    function getNativeBeforeInputChars(domEventName, nativeEvent) {
        switch(domEventName){
            case "compositionend":
                return getDataFromCustomEvent(nativeEvent);
            case "keypress":
                if (nativeEvent.which !== SPACEBAR_CODE) return null;
                hasSpaceKeypress = !0;
                return SPACEBAR_CHAR;
            case "textInput":
                return domEventName = nativeEvent.data, domEventName === SPACEBAR_CHAR && hasSpaceKeypress ? null : domEventName;
            default:
                return null;
        }
    }
    function getFallbackBeforeInputChars(domEventName, nativeEvent) {
        if (isComposing) return "compositionend" === domEventName || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = getData(), fallbackText = startText = root = null, isComposing = !1, domEventName) : null;
        switch(domEventName){
            case "paste":
                return null;
            case "keypress":
                if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                    if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                    if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
                }
                return null;
            case "compositionend":
                return useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
            default:
                return null;
        }
    }
    function isTextInputElement(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        return "input" === nodeName ? !!supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
    }
    function isEventSupported(eventNameSuffix) {
        if (!canUseDOM) return !1;
        eventNameSuffix = "on" + eventNameSuffix;
        var isSupported = eventNameSuffix in document;
        isSupported || (isSupported = document.createElement("div"), isSupported.setAttribute(eventNameSuffix, "return;"), isSupported = "function" === typeof isSupported[eventNameSuffix]);
        return isSupported;
    }
    function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
        restoreTarget ? restoreQueue ? restoreQueue.push(target) : restoreQueue = [
            target
        ] : restoreTarget = target;
        inst = accumulateTwoPhaseListeners(inst, "onChange");
        0 < inst.length && (nativeEvent = new SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
            event: nativeEvent,
            listeners: inst
        }));
    }
    function runEventInBatch(dispatchQueue) {
        processDispatchQueue(dispatchQueue, 0);
    }
    function getInstIfValueChanged(targetInst) {
        var targetNode = getNodeFromInstance(targetInst);
        if (updateValueIfChanged(targetNode)) return targetInst;
    }
    function getTargetInstForChangeEvent(domEventName, targetInst) {
        if ("change" === domEventName) return targetInst;
    }
    function stopWatchingForValueChange() {
        activeElement$1 && (activeElement$1.detachEvent("onpropertychange", handlePropertyChange), activeElementInst$1 = activeElement$1 = null);
    }
    function handlePropertyChange(nativeEvent) {
        if ("value" === nativeEvent.propertyName && getInstIfValueChanged(activeElementInst$1)) {
            var dispatchQueue = [];
            createAndAccumulateChangeEvent(dispatchQueue, activeElementInst$1, nativeEvent, getEventTarget(nativeEvent));
            batchedUpdates$1(runEventInBatch, dispatchQueue);
        }
    }
    function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
        "focusin" === domEventName ? (stopWatchingForValueChange(), activeElement$1 = target, activeElementInst$1 = targetInst, activeElement$1.attachEvent("onpropertychange", handlePropertyChange)) : "focusout" === domEventName && stopWatchingForValueChange();
    }
    function getTargetInstForInputEventPolyfill(domEventName) {
        if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return getInstIfValueChanged(activeElementInst$1);
    }
    function getTargetInstForClickEvent(domEventName, targetInst) {
        if ("click" === domEventName) return getInstIfValueChanged(targetInst);
    }
    function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
        if ("input" === domEventName || "change" === domEventName) return getInstIfValueChanged(targetInst);
    }
    function is(x, y) {
        return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
    }
    function shallowEqual(objA, objB) {
        if (objectIs(objA, objB)) return !0;
        if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
        var keysA = Object.keys(objA), keysB = Object.keys(objB);
        if (keysA.length !== keysB.length) return !1;
        for(keysB = 0; keysB < keysA.length; keysB++){
            var currentKey = keysA[keysB];
            if (!hasOwnProperty.call(objB, currentKey) || !objectIs(objA[currentKey], objB[currentKey])) return !1;
        }
        return !0;
    }
    function getLeafNode(node) {
        for(; node && node.firstChild;)node = node.firstChild;
        return node;
    }
    function getNodeForCharacterOffset(root, offset) {
        var node = getLeafNode(root);
        root = 0;
        for(var nodeEnd; node;){
            if (3 === node.nodeType) {
                nodeEnd = root + node.textContent.length;
                if (root <= offset && nodeEnd >= offset) return {
                    node: node,
                    offset: offset - root
                };
                root = nodeEnd;
            }
            a: {
                for(; node;){
                    if (node.nextSibling) {
                        node = node.nextSibling;
                        break a;
                    }
                    node = node.parentNode;
                }
                node = void 0;
            }
            node = getLeafNode(node);
        }
    }
    function containsNode(outerNode, innerNode) {
        return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
    }
    function getActiveElementDeep(containerInfo) {
        containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
        for(var element = getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
            try {
                var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
            } catch (err) {
                JSCompiler_inline_result = !1;
            }
            if (JSCompiler_inline_result) containerInfo = element.contentWindow;
            else break;
            element = getActiveElement(containerInfo.document);
        }
        return element;
    }
    function hasSelectionCapabilities(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
    }
    function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
        var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
        mouseDown || null == activeElement || activeElement !== getActiveElement(doc) || (doc = activeElement, "selectionStart" in doc && hasSelectionCapabilities(doc) ? doc = {
            start: doc.selectionStart,
            end: doc.selectionEnd
        } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
            anchorNode: doc.anchorNode,
            anchorOffset: doc.anchorOffset,
            focusNode: doc.focusNode,
            focusOffset: doc.focusOffset
        }), lastSelection && shallowEqual(lastSelection, doc) || (lastSelection = doc, doc = accumulateTwoPhaseListeners(activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
            event: nativeEvent,
            listeners: doc
        }), nativeEvent.target = activeElement)));
    }
    function makePrefixMap(styleProp, eventName) {
        var prefixes = {};
        prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
        prefixes["Webkit" + styleProp] = "webkit" + eventName;
        prefixes["Moz" + styleProp] = "moz" + eventName;
        return prefixes;
    }
    function getVendorPrefixedEventName(eventName) {
        if (prefixedEventNames[eventName]) return prefixedEventNames[eventName];
        if (!vendorPrefixes[eventName]) return eventName;
        var prefixMap = vendorPrefixes[eventName], styleProp;
        for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) return prefixedEventNames[eventName] = prefixMap[styleProp];
        return eventName;
    }
    function registerSimpleEvent(domEventName, reactName) {
        topLevelEventsToReactNames.set(domEventName, reactName);
        registerTwoPhaseEvent(reactName, [
            domEventName
        ]);
    }
    function getArrayKind(array) {
        for(var kind = EMPTY_ARRAY, i = 0; i < array.length; i++){
            var value = array[i];
            if ("object" === typeof value && null !== value) {
                if (isArrayImpl(value) && 2 === value.length && "string" === typeof value[0]) {
                    if (kind !== EMPTY_ARRAY && kind !== ENTRIES_ARRAY) return COMPLEX_ARRAY;
                    kind = ENTRIES_ARRAY;
                } else return COMPLEX_ARRAY;
            } else {
                if ("function" === typeof value || "string" === typeof value && 50 < value.length || kind !== EMPTY_ARRAY && kind !== PRIMITIVE_ARRAY) return COMPLEX_ARRAY;
                kind = PRIMITIVE_ARRAY;
            }
        }
        return kind;
    }
    function addObjectToProperties(object, properties, indent, prefix) {
        for(var key in object)hasOwnProperty.call(object, key) && "_" !== key[0] && addValueToProperties(key, object[key], properties, indent, prefix);
    }
    function addValueToProperties(propertyName, value, properties, indent, prefix) {
        switch(typeof value){
            case "object":
                if (null === value) {
                    value = "null";
                    break;
                } else {
                    if (value.$$typeof === REACT_ELEMENT_TYPE) {
                        var typeName = getComponentNameFromType(value.type) || "\u2026", key = value.key;
                        value = value.props;
                        var propsKeys = Object.keys(value), propsLength = propsKeys.length;
                        if (null == key && 0 === propsLength) {
                            value = "<" + typeName + " />";
                            break;
                        }
                        if (3 > indent || 1 === propsLength && "children" === propsKeys[0] && null == key) {
                            value = "<" + typeName + " \u2026 />";
                            break;
                        }
                        properties.push([
                            prefix + "\u00a0\u00a0".repeat(indent) + propertyName,
                            "<" + typeName
                        ]);
                        null !== key && addValueToProperties("key", key, properties, indent + 1, prefix);
                        propertyName = !1;
                        for(var propKey in value)"children" === propKey ? null != value.children && (!isArrayImpl(value.children) || 0 < value.children.length) && (propertyName = !0) : hasOwnProperty.call(value, propKey) && "_" !== propKey[0] && addValueToProperties(propKey, value[propKey], properties, indent + 1, prefix);
                        properties.push([
                            "",
                            propertyName ? ">\u2026</" + typeName + ">" : "/>"
                        ]);
                        return;
                    }
                    typeName = Object.prototype.toString.call(value);
                    typeName = typeName.slice(8, typeName.length - 1);
                    if ("Array" === typeName) {
                        if (propKey = getArrayKind(value), propKey === PRIMITIVE_ARRAY || propKey === EMPTY_ARRAY) {
                            value = JSON.stringify(value);
                            break;
                        } else if (propKey === ENTRIES_ARRAY) {
                            properties.push([
                                prefix + "\u00a0\u00a0".repeat(indent) + propertyName,
                                ""
                            ]);
                            for(propertyName = 0; propertyName < value.length; propertyName++)typeName = value[propertyName], addValueToProperties(typeName[0], typeName[1], properties, indent + 1, prefix);
                            return;
                        }
                    }
                    if ("Promise" === typeName) {
                        if ("fulfilled" === value.status) {
                            if (typeName = properties.length, addValueToProperties(propertyName, value.value, properties, indent, prefix), properties.length > typeName) {
                                properties = properties[typeName];
                                properties[1] = "Promise<" + (properties[1] || "Object") + ">";
                                return;
                            }
                        } else if ("rejected" === value.status && (typeName = properties.length, addValueToProperties(propertyName, value.reason, properties, indent, prefix), properties.length > typeName)) {
                            properties = properties[typeName];
                            properties[1] = "Rejected Promise<" + properties[1] + ">";
                            return;
                        }
                        properties.push([
                            "\u00a0\u00a0".repeat(indent) + propertyName,
                            "Promise"
                        ]);
                        return;
                    }
                    "Object" === typeName && (propKey = Object.getPrototypeOf(value)) && "function" === typeof propKey.constructor && (typeName = propKey.constructor.name);
                    properties.push([
                        prefix + "\u00a0\u00a0".repeat(indent) + propertyName,
                        "Object" === typeName ? 3 > indent ? "" : "\u2026" : typeName
                    ]);
                    3 > indent && addObjectToProperties(value, properties, indent + 1, prefix);
                    return;
                }
            case "function":
                value = "" === value.name ? "() => {}" : value.name + "() {}";
                break;
            case "string":
                value = value === OMITTED_PROP_ERROR ? "\u2026" : JSON.stringify(value);
                break;
            case "undefined":
                value = "undefined";
                break;
            case "boolean":
                value = value ? "true" : "false";
                break;
            default:
                value = String(value);
        }
        properties.push([
            prefix + "\u00a0\u00a0".repeat(indent) + propertyName,
            value
        ]);
    }
    function addObjectDiffToProperties(prev, next, properties, indent) {
        var isDeeplyEqual = !0;
        for(key in prev)key in next || (properties.push([
            REMOVED + "\u00a0\u00a0".repeat(indent) + key,
            "\u2026"
        ]), isDeeplyEqual = !1);
        for(var _key in next)if (_key in prev) {
            var key = prev[_key];
            var nextValue = next[_key];
            if (key !== nextValue) {
                if (0 === indent && "children" === _key) isDeeplyEqual = "\u00a0\u00a0".repeat(indent) + _key, properties.push([
                    REMOVED + isDeeplyEqual,
                    "\u2026"
                ], [
                    ADDED + isDeeplyEqual,
                    "\u2026"
                ]);
                else {
                    if (!(3 <= indent)) {
                        if ("object" === typeof key && "object" === typeof nextValue && null !== key && null !== nextValue && key.$$typeof === nextValue.$$typeof) {
                            if (nextValue.$$typeof === REACT_ELEMENT_TYPE) {
                                if (key.type === nextValue.type && key.key === nextValue.key) {
                                    key = getComponentNameFromType(nextValue.type) || "\u2026";
                                    isDeeplyEqual = "\u00a0\u00a0".repeat(indent) + _key;
                                    key = "<" + key + " \u2026 />";
                                    properties.push([
                                        REMOVED + isDeeplyEqual,
                                        key
                                    ], [
                                        ADDED + isDeeplyEqual,
                                        key
                                    ]);
                                    isDeeplyEqual = !1;
                                    continue;
                                }
                            } else {
                                var prevKind = Object.prototype.toString.call(key), nextKind = Object.prototype.toString.call(nextValue);
                                if (prevKind === nextKind && ("[object Object]" === nextKind || "[object Array]" === nextKind)) {
                                    prevKind = [
                                        UNCHANGED + "\u00a0\u00a0".repeat(indent) + _key,
                                        "[object Array]" === nextKind ? "Array" : ""
                                    ];
                                    properties.push(prevKind);
                                    nextKind = properties.length;
                                    addObjectDiffToProperties(key, nextValue, properties, indent + 1) ? nextKind === properties.length && (prevKind[1] = "Referentially unequal but deeply equal objects. Consider memoization.") : isDeeplyEqual = !1;
                                    continue;
                                }
                            }
                        } else if ("function" === typeof key && "function" === typeof nextValue && key.name === nextValue.name && key.length === nextValue.length && (prevKind = Function.prototype.toString.call(key), nextKind = Function.prototype.toString.call(nextValue), prevKind === nextKind)) {
                            key = "" === nextValue.name ? "() => {}" : nextValue.name + "() {}";
                            properties.push([
                                UNCHANGED + "\u00a0\u00a0".repeat(indent) + _key,
                                key + " Referentially unequal function closure. Consider memoization."
                            ]);
                            continue;
                        }
                    }
                    addValueToProperties(_key, key, properties, indent, REMOVED);
                    addValueToProperties(_key, nextValue, properties, indent, ADDED);
                }
                isDeeplyEqual = !1;
            }
        } else properties.push([
            ADDED + "\u00a0\u00a0".repeat(indent) + _key,
            "\u2026"
        ]), isDeeplyEqual = !1;
        return isDeeplyEqual;
    }
    function setCurrentTrackFromLanes(lanes) {
        currentTrack = lanes & 63 ? "Blocking" : lanes & 64 ? "Gesture" : lanes & 4194176 ? "Transition" : lanes & 62914560 ? "Suspense" : lanes & 2080374784 ? "Idle" : "Other";
    }
    function logComponentTrigger(fiber, startTime, endTime, trigger) {
        supportsUserTiming && (reusableComponentOptions.start = startTime, reusableComponentOptions.end = endTime, reusableComponentDevToolDetails.color = "warning", reusableComponentDevToolDetails.tooltipText = trigger, reusableComponentDevToolDetails.properties = null, (fiber = fiber._debugTask) ? fiber.run(performance.measure.bind(performance, trigger, reusableComponentOptions)) : performance.measure(trigger, reusableComponentOptions));
    }
    function logComponentReappeared(fiber, startTime, endTime) {
        logComponentTrigger(fiber, startTime, endTime, "Reconnect");
    }
    function logComponentRender(fiber, startTime, endTime, wasHydrated, committedLanes) {
        var name = getComponentNameFromFiber(fiber);
        if (null !== name && supportsUserTiming) {
            var alternate = fiber.alternate, selfTime = fiber.actualDuration;
            if (null === alternate || alternate.child !== fiber.child) for(var child = fiber.child; null !== child; child = child.sibling)selfTime -= child.actualDuration;
            wasHydrated = 0.5 > selfTime ? wasHydrated ? "tertiary-light" : "primary-light" : 10 > selfTime ? wasHydrated ? "tertiary" : "primary" : 100 > selfTime ? wasHydrated ? "tertiary-dark" : "primary-dark" : "error";
            var props = fiber.memoizedProps;
            selfTime = fiber._debugTask;
            null !== props && null !== alternate && alternate.memoizedProps !== props ? (child = [
                resuableChangedPropsEntry
            ], props = addObjectDiffToProperties(alternate.memoizedProps, props, child, 0), 1 < child.length && (props && !alreadyWarnedForDeepEquality && 0 === (alternate.lanes & committedLanes) && 100 < fiber.actualDuration ? (alreadyWarnedForDeepEquality = !0, child[0] = reusableDeeplyEqualPropsEntry, reusableComponentDevToolDetails.color = "warning", reusableComponentDevToolDetails.tooltipText = DEEP_EQUALITY_WARNING) : (reusableComponentDevToolDetails.color = wasHydrated, reusableComponentDevToolDetails.tooltipText = name), reusableComponentDevToolDetails.properties = child, reusableComponentOptions.start = startTime, reusableComponentOptions.end = endTime, null != selfTime ? selfTime.run(performance.measure.bind(performance, "\u200b" + name, reusableComponentOptions)) : performance.measure("\u200b" + name, reusableComponentOptions))) : null != selfTime ? selfTime.run(console.timeStamp.bind(console, name, startTime, endTime, COMPONENTS_TRACK, void 0, wasHydrated)) : console.timeStamp(name, startTime, endTime, COMPONENTS_TRACK, void 0, wasHydrated);
        }
    }
    function logComponentErrored(fiber, startTime, endTime, errors) {
        if (supportsUserTiming) {
            var name = getComponentNameFromFiber(fiber);
            if (null !== name) {
                for(var debugTask = null, properties = [], i = 0; i < errors.length; i++){
                    var capturedValue = errors[i];
                    null == debugTask && null !== capturedValue.source && (debugTask = capturedValue.source._debugTask);
                    capturedValue = capturedValue.value;
                    properties.push([
                        "Error",
                        "object" === typeof capturedValue && null !== capturedValue && "string" === typeof capturedValue.message ? String(capturedValue.message) : String(capturedValue)
                    ]);
                }
                null !== fiber.key && addValueToProperties("key", fiber.key, properties, 0, "");
                null !== fiber.memoizedProps && addObjectToProperties(fiber.memoizedProps, properties, 0, "");
                null == debugTask && (debugTask = fiber._debugTask);
                fiber = {
                    start: startTime,
                    end: endTime,
                    detail: {
                        devtools: {
                            color: "error",
                            track: COMPONENTS_TRACK,
                            tooltipText: 13 === fiber.tag ? "Hydration failed" : "Error boundary caught an error",
                            properties: properties
                        }
                    }
                };
                debugTask ? debugTask.run(performance.measure.bind(performance, "\u200b" + name, fiber)) : performance.measure("\u200b" + name, fiber);
            }
        }
    }
    function logComponentEffect(fiber, startTime, endTime, selfTime, errors) {
        if (null !== errors) {
            if (supportsUserTiming) {
                var name = getComponentNameFromFiber(fiber);
                if (null !== name) {
                    selfTime = [];
                    for(var i = 0; i < errors.length; i++){
                        var error = errors[i].value;
                        selfTime.push([
                            "Error",
                            "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error)
                        ]);
                    }
                    null !== fiber.key && addValueToProperties("key", fiber.key, selfTime, 0, "");
                    null !== fiber.memoizedProps && addObjectToProperties(fiber.memoizedProps, selfTime, 0, "");
                    startTime = {
                        start: startTime,
                        end: endTime,
                        detail: {
                            devtools: {
                                color: "error",
                                track: COMPONENTS_TRACK,
                                tooltipText: "A lifecycle or effect errored",
                                properties: selfTime
                            }
                        }
                    };
                    (fiber = fiber._debugTask) ? fiber.run(performance.measure.bind(performance, "\u200b" + name, startTime)) : performance.measure("\u200b" + name, startTime);
                }
            }
        } else name = getComponentNameFromFiber(fiber), null !== name && supportsUserTiming && (errors = 1 > selfTime ? "secondary-light" : 100 > selfTime ? "secondary" : 500 > selfTime ? "secondary-dark" : "error", (fiber = fiber._debugTask) ? fiber.run(console.timeStamp.bind(console, name, startTime, endTime, COMPONENTS_TRACK, void 0, errors)) : console.timeStamp(name, startTime, endTime, COMPONENTS_TRACK, void 0, errors));
    }
    function logRenderPhase(startTime, endTime, lanes, debugTask) {
        if (supportsUserTiming && !(endTime <= startTime)) {
            var color = (lanes & 738197653) === lanes ? "tertiary-dark" : "primary-dark";
            lanes = (lanes & 536870912) === lanes ? "Prepared" : (lanes & 201326741) === lanes ? "Hydrated" : "Render";
            debugTask ? debugTask.run(console.timeStamp.bind(console, lanes, startTime, endTime, currentTrack, LANES_TRACK_GROUP, color)) : console.timeStamp(lanes, startTime, endTime, currentTrack, LANES_TRACK_GROUP, color);
        }
    }
    function logSuspendedRenderPhase(startTime, endTime, lanes, debugTask) {
        !supportsUserTiming || endTime <= startTime || (lanes = (lanes & 738197653) === lanes ? "tertiary-dark" : "primary-dark", debugTask ? debugTask.run(console.timeStamp.bind(console, "Prewarm", startTime, endTime, currentTrack, LANES_TRACK_GROUP, lanes)) : console.timeStamp("Prewarm", startTime, endTime, currentTrack, LANES_TRACK_GROUP, lanes));
    }
    function logSuspendedWithDelayPhase(startTime, endTime, lanes, debugTask) {
        !supportsUserTiming || endTime <= startTime || (lanes = (lanes & 738197653) === lanes ? "tertiary-dark" : "primary-dark", debugTask ? debugTask.run(console.timeStamp.bind(console, "Suspended", startTime, endTime, currentTrack, LANES_TRACK_GROUP, lanes)) : console.timeStamp("Suspended", startTime, endTime, currentTrack, LANES_TRACK_GROUP, lanes));
    }
    function logRecoveredRenderPhase(startTime, endTime, lanes, recoverableErrors, hydrationFailed, debugTask) {
        if (supportsUserTiming && !(endTime <= startTime)) {
            lanes = [];
            for(var i = 0; i < recoverableErrors.length; i++){
                var error = recoverableErrors[i].value;
                lanes.push([
                    "Recoverable Error",
                    "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error)
                ]);
            }
            startTime = {
                start: startTime,
                end: endTime,
                detail: {
                    devtools: {
                        color: "primary-dark",
                        track: currentTrack,
                        trackGroup: LANES_TRACK_GROUP,
                        tooltipText: hydrationFailed ? "Hydration Failed" : "Recovered after Error",
                        properties: lanes
                    }
                }
            };
            debugTask ? debugTask.run(performance.measure.bind(performance, "Recovered", startTime)) : performance.measure("Recovered", startTime);
        }
    }
    function logErroredRenderPhase(startTime, endTime, lanes, debugTask) {
        !supportsUserTiming || endTime <= startTime || (debugTask ? debugTask.run(console.timeStamp.bind(console, "Errored", startTime, endTime, currentTrack, LANES_TRACK_GROUP, "error")) : console.timeStamp("Errored", startTime, endTime, currentTrack, LANES_TRACK_GROUP, "error"));
    }
    function logSuspendedCommitPhase(startTime, endTime, reason, debugTask) {
        !supportsUserTiming || endTime <= startTime || (debugTask ? debugTask.run(console.timeStamp.bind(console, reason, startTime, endTime, currentTrack, LANES_TRACK_GROUP, "secondary-light")) : console.timeStamp(reason, startTime, endTime, currentTrack, LANES_TRACK_GROUP, "secondary-light"));
    }
    function logCommitErrored(startTime, endTime, errors, passive, debugTask) {
        if (supportsUserTiming && !(endTime <= startTime)) {
            for(var properties = [], i = 0; i < errors.length; i++){
                var error = errors[i].value;
                properties.push([
                    "Error",
                    "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error)
                ]);
            }
            startTime = {
                start: startTime,
                end: endTime,
                detail: {
                    devtools: {
                        color: "error",
                        track: currentTrack,
                        trackGroup: LANES_TRACK_GROUP,
                        tooltipText: passive ? "Remaining Effects Errored" : "Commit Errored",
                        properties: properties
                    }
                }
            };
            debugTask ? debugTask.run(performance.measure.bind(performance, "Errored", startTime)) : performance.measure("Errored", startTime);
        }
    }
    function logAnimatingPhase(startTime, endTime, debugTask) {
        !supportsUserTiming || endTime <= startTime || (debugTask ? debugTask.run(console.timeStamp.bind(console, "Animating", startTime, endTime, currentTrack, LANES_TRACK_GROUP, "secondary-dark")) : console.timeStamp("Animating", startTime, endTime, currentTrack, LANES_TRACK_GROUP, "secondary-dark"));
    }
    function finishQueueingConcurrentUpdates() {
        for(var endIndex = concurrentQueuesIndex, i = concurrentlyUpdatedLanes = concurrentQueuesIndex = 0; i < endIndex;){
            var fiber = concurrentQueues[i];
            concurrentQueues[i++] = null;
            var queue = concurrentQueues[i];
            concurrentQueues[i++] = null;
            var update = concurrentQueues[i];
            concurrentQueues[i++] = null;
            var lane = concurrentQueues[i];
            concurrentQueues[i++] = null;
            if (null !== queue && null !== update) {
                var pending = queue.pending;
                null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
                queue.pending = update;
            }
            0 !== lane && markUpdateLaneFromFiberToRoot(fiber, update, lane);
        }
    }
    function enqueueUpdate$1(fiber, queue, update, lane) {
        concurrentQueues[concurrentQueuesIndex++] = fiber;
        concurrentQueues[concurrentQueuesIndex++] = queue;
        concurrentQueues[concurrentQueuesIndex++] = update;
        concurrentQueues[concurrentQueuesIndex++] = lane;
        concurrentlyUpdatedLanes |= lane;
        fiber.lanes |= lane;
        fiber = fiber.alternate;
        null !== fiber && (fiber.lanes |= lane);
    }
    function enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
        enqueueUpdate$1(fiber, queue, update, lane);
        return getRootForUpdatedFiber(fiber);
    }
    function enqueueConcurrentRenderForLane(fiber, lane) {
        enqueueUpdate$1(fiber, null, null, lane);
        return getRootForUpdatedFiber(fiber);
    }
    function markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
        sourceFiber.lanes |= lane;
        var alternate = sourceFiber.alternate;
        null !== alternate && (alternate.lanes |= lane);
        for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & OffscreenVisible || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
        return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
            update
        ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
    }
    function getRootForUpdatedFiber(sourceFiber) {
        if (nestedUpdateCount > NESTED_UPDATE_LIMIT) throw nestedPassiveUpdateCount = nestedUpdateCount = 0, rootWithPassiveNestedUpdates = rootWithNestedUpdates = null, Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
        nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT && (nestedPassiveUpdateCount = 0, rootWithPassiveNestedUpdates = null, console.error("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."));
        null === sourceFiber.alternate && 0 !== (sourceFiber.flags & 4098) && warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
        for(var node = sourceFiber, parent = node.return; null !== parent;)null === node.alternate && 0 !== (node.flags & 4098) && warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber), node = parent, parent = node.return;
        return 3 === node.tag ? node.stateNode : null;
    }
    function resolveFunctionForHotReloading(type) {
        if (null === resolveFamily) return type;
        var family = resolveFamily(type);
        return void 0 === family ? type : family.current;
    }
    function resolveForwardRefForHotReloading(type) {
        if (null === resolveFamily) return type;
        var family = resolveFamily(type);
        return void 0 === family ? null !== type && void 0 !== type && "function" === typeof type.render && (family = resolveFunctionForHotReloading(type.render), type.render !== family) ? (family = {
            $$typeof: REACT_FORWARD_REF_TYPE,
            render: family
        }, void 0 !== type.displayName && (family.displayName = type.displayName), family) : type : family.current;
    }
    function isCompatibleFamilyForHotReloading(fiber, element) {
        if (null === resolveFamily) return !1;
        var prevType = fiber.elementType;
        element = element.type;
        var needsCompareFamilies = !1, $$typeofNextType = "object" === typeof element && null !== element ? element.$$typeof : null;
        switch(fiber.tag){
            case 1:
                "function" === typeof element && (needsCompareFamilies = !0);
                break;
            case 0:
                "function" === typeof element ? needsCompareFamilies = !0 : $$typeofNextType === REACT_LAZY_TYPE && (needsCompareFamilies = !0);
                break;
            case 11:
                $$typeofNextType === REACT_FORWARD_REF_TYPE ? needsCompareFamilies = !0 : $$typeofNextType === REACT_LAZY_TYPE && (needsCompareFamilies = !0);
                break;
            case 14:
            case 15:
                $$typeofNextType === REACT_MEMO_TYPE ? needsCompareFamilies = !0 : $$typeofNextType === REACT_LAZY_TYPE && (needsCompareFamilies = !0);
                break;
            default:
                return !1;
        }
        return needsCompareFamilies && (fiber = resolveFamily(prevType), void 0 !== fiber && fiber === resolveFamily(element)) ? !0 : !1;
    }
    function markFailedErrorBoundaryForHotReloading(fiber) {
        null !== resolveFamily && "function" === typeof WeakSet && (null === failedBoundaries && (failedBoundaries = new WeakSet()), failedBoundaries.add(fiber));
    }
    function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
        do {
            var _fiber = fiber, alternate = _fiber.alternate, child = _fiber.child, sibling = _fiber.sibling, tag = _fiber.tag;
            _fiber = _fiber.type;
            var candidateType = null;
            switch(tag){
                case 0:
                case 15:
                case 1:
                    candidateType = _fiber;
                    break;
                case 11:
                    candidateType = _fiber.render;
            }
            if (null === resolveFamily) throw Error("Expected resolveFamily to be set during hot reload.");
            var needsRender = !1;
            _fiber = !1;
            null !== candidateType && (candidateType = resolveFamily(candidateType), void 0 !== candidateType && (staleFamilies.has(candidateType) ? _fiber = !0 : updatedFamilies.has(candidateType) && (1 === tag ? _fiber = !0 : needsRender = !0)));
            null !== failedBoundaries && (failedBoundaries.has(fiber) || null !== alternate && failedBoundaries.has(alternate)) && (_fiber = !0);
            _fiber && (fiber._debugNeedsRemount = !0);
            if (_fiber || needsRender) alternate = enqueueConcurrentRenderForLane(fiber, 2), null !== alternate && scheduleUpdateOnFiber(alternate, fiber, 2);
            null === child || _fiber || scheduleFibersWithFamiliesRecursively(child, updatedFamilies, staleFamilies);
            if (null === sibling) break;
            fiber = sibling;
        }while (1);
    }
    function FiberNode(tag, pendingProps, key, mode) {
        this.tag = tag;
        this.key = key;
        this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
        this.index = 0;
        this.refCleanup = this.ref = null;
        this.pendingProps = pendingProps;
        this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
        this.mode = mode;
        this.subtreeFlags = this.flags = 0;
        this.deletions = null;
        this.childLanes = this.lanes = 0;
        this.alternate = null;
        this.actualDuration = -0;
        this.actualStartTime = -1.1;
        this.treeBaseDuration = this.selfBaseDuration = -0;
        this._debugTask = this._debugStack = this._debugOwner = this._debugInfo = null;
        this._debugNeedsRemount = !1;
        this._debugHookTypes = null;
        hasBadMapPolyfill || "function" !== typeof Object.preventExtensions || Object.preventExtensions(this);
    }
    function shouldConstruct(Component) {
        Component = Component.prototype;
        return !(!Component || !Component.isReactComponent);
    }
    function createWorkInProgress(current, pendingProps) {
        var workInProgress = current.alternate;
        null === workInProgress ? (workInProgress = createFiber(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress._debugOwner = current._debugOwner, workInProgress._debugStack = current._debugStack, workInProgress._debugTask = current._debugTask, workInProgress._debugHookTypes = current._debugHookTypes, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.actualDuration = -0, workInProgress.actualStartTime = -1.1);
        workInProgress.flags = current.flags & 65011712;
        workInProgress.childLanes = current.childLanes;
        workInProgress.lanes = current.lanes;
        workInProgress.child = current.child;
        workInProgress.memoizedProps = current.memoizedProps;
        workInProgress.memoizedState = current.memoizedState;
        workInProgress.updateQueue = current.updateQueue;
        pendingProps = current.dependencies;
        workInProgress.dependencies = null === pendingProps ? null : {
            lanes: pendingProps.lanes,
            firstContext: pendingProps.firstContext,
            _debugThenableState: pendingProps._debugThenableState
        };
        workInProgress.sibling = current.sibling;
        workInProgress.index = current.index;
        workInProgress.ref = current.ref;
        workInProgress.refCleanup = current.refCleanup;
        workInProgress.selfBaseDuration = current.selfBaseDuration;
        workInProgress.treeBaseDuration = current.treeBaseDuration;
        workInProgress._debugInfo = current._debugInfo;
        workInProgress._debugNeedsRemount = current._debugNeedsRemount;
        switch(workInProgress.tag){
            case 0:
            case 15:
                workInProgress.type = resolveFunctionForHotReloading(current.type);
                break;
            case 1:
                workInProgress.type = resolveFunctionForHotReloading(current.type);
                break;
            case 11:
                workInProgress.type = resolveForwardRefForHotReloading(current.type);
        }
        return workInProgress;
    }
    function resetWorkInProgress(workInProgress, renderLanes) {
        workInProgress.flags &= 65011714;
        var current = workInProgress.alternate;
        null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null, workInProgress.selfBaseDuration = 0, workInProgress.treeBaseDuration = 0) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
            lanes: renderLanes.lanes,
            firstContext: renderLanes.firstContext,
            _debugThenableState: renderLanes._debugThenableState
        }, workInProgress.selfBaseDuration = current.selfBaseDuration, workInProgress.treeBaseDuration = current.treeBaseDuration);
        return workInProgress;
    }
    function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
        var fiberTag = 0, resolvedType = type;
        if ("function" === typeof type) shouldConstruct(type) && (fiberTag = 1), resolvedType = resolveFunctionForHotReloading(resolvedType);
        else if ("string" === typeof type) fiberTag = getHostContext(), fiberTag = isHostHoistableType(type, pendingProps, fiberTag) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
        else a: switch(type){
            case REACT_ACTIVITY_TYPE:
                return key = createFiber(31, pendingProps, key, mode), key.elementType = REACT_ACTIVITY_TYPE, key.lanes = lanes, key;
            case REACT_FRAGMENT_TYPE:
                return createFiberFromFragment(pendingProps.children, mode, lanes, key);
            case REACT_STRICT_MODE_TYPE:
                fiberTag = 8;
                mode |= StrictLegacyMode;
                mode |= StrictEffectsMode;
                break;
            case REACT_PROFILER_TYPE:
                return type = pendingProps, owner = mode, "string" !== typeof type.id && console.error('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof type.id), key = createFiber(12, type, key, owner | ProfileMode), key.elementType = REACT_PROFILER_TYPE, key.lanes = lanes, key.stateNode = {
                    effectDuration: 0,
                    passiveEffectDuration: 0
                }, key;
            case REACT_SUSPENSE_TYPE:
                return key = createFiber(13, pendingProps, key, mode), key.elementType = REACT_SUSPENSE_TYPE, key.lanes = lanes, key;
            case REACT_SUSPENSE_LIST_TYPE:
                return key = createFiber(19, pendingProps, key, mode), key.elementType = REACT_SUSPENSE_LIST_TYPE, key.lanes = lanes, key;
            default:
                if ("object" === typeof type && null !== type) switch(type.$$typeof){
                    case REACT_CONTEXT_TYPE:
                        fiberTag = 10;
                        break a;
                    case REACT_CONSUMER_TYPE:
                        fiberTag = 9;
                        break a;
                    case REACT_FORWARD_REF_TYPE:
                        fiberTag = 11;
                        resolvedType = resolveForwardRefForHotReloading(resolvedType);
                        break a;
                    case REACT_MEMO_TYPE:
                        fiberTag = 14;
                        break a;
                    case REACT_LAZY_TYPE:
                        fiberTag = 16;
                        resolvedType = null;
                        break a;
                }
                resolvedType = "";
                if (void 0 === type || "object" === typeof type && null !== type && 0 === Object.keys(type).length) resolvedType += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
                null === type ? pendingProps = "null" : isArrayImpl(type) ? pendingProps = "array" : void 0 !== type && type.$$typeof === REACT_ELEMENT_TYPE ? (pendingProps = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />", resolvedType = " Did you accidentally export a JSX literal instead of a component?") : pendingProps = typeof type;
                (fiberTag = owner ? getComponentNameFromOwner(owner) : null) && (resolvedType += "\n\nCheck the render method of `" + fiberTag + "`.");
                fiberTag = 29;
                pendingProps = Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (pendingProps + "." + resolvedType));
                resolvedType = null;
        }
        key = createFiber(fiberTag, pendingProps, key, mode);
        key.elementType = type;
        key.type = resolvedType;
        key.lanes = lanes;
        key._debugOwner = owner;
        return key;
    }
    function createFiberFromElement(element, mode, lanes) {
        mode = createFiberFromTypeAndProps(element.type, element.key, element.props, element._owner, mode, lanes);
        mode._debugOwner = element._owner;
        mode._debugStack = element._debugStack;
        mode._debugTask = element._debugTask;
        return mode;
    }
    function createFiberFromFragment(elements, mode, lanes, key) {
        elements = createFiber(7, elements, key, mode);
        elements.lanes = lanes;
        return elements;
    }
    function createFiberFromText(content, mode, lanes) {
        content = createFiber(6, content, null, mode);
        content.lanes = lanes;
        return content;
    }
    function createFiberFromDehydratedFragment(dehydratedNode) {
        var fiber = createFiber(18, null, null, NoMode);
        fiber.stateNode = dehydratedNode;
        return fiber;
    }
    function createFiberFromPortal(portal, mode, lanes) {
        mode = createFiber(4, null !== portal.children ? portal.children : [], portal.key, mode);
        mode.lanes = lanes;
        mode.stateNode = {
            containerInfo: portal.containerInfo,
            pendingChildren: null,
            implementation: portal.implementation
        };
        return mode;
    }
    function createCapturedValueAtFiber(value, source) {
        if ("object" === typeof value && null !== value) {
            var existing = CapturedStacks.get(value);
            if (void 0 !== existing) return existing;
            source = {
                value: value,
                source: source,
                stack: getStackByFiberInDevAndProd(source)
            };
            CapturedStacks.set(value, source);
            return source;
        }
        return {
            value: value,
            source: source,
            stack: getStackByFiberInDevAndProd(source)
        };
    }
    function pushTreeFork(workInProgress, totalChildren) {
        warnIfNotHydrating();
        forkStack[forkStackIndex++] = treeForkCount;
        forkStack[forkStackIndex++] = treeForkProvider;
        treeForkProvider = workInProgress;
        treeForkCount = totalChildren;
    }
    function pushTreeId(workInProgress, totalChildren, index) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextProvider = workInProgress;
        var baseIdWithLeadingBit = treeContextId;
        workInProgress = treeContextOverflow;
        var baseLength = 32 - clz32(baseIdWithLeadingBit) - 1;
        baseIdWithLeadingBit &= ~(1 << baseLength);
        index += 1;
        var length = 32 - clz32(totalChildren) + baseLength;
        if (30 < length) {
            var numberOfOverflowBits = baseLength - baseLength % 5;
            length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
            baseIdWithLeadingBit >>= numberOfOverflowBits;
            baseLength -= numberOfOverflowBits;
            treeContextId = 1 << 32 - clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
            treeContextOverflow = length + workInProgress;
        } else treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, treeContextOverflow = workInProgress;
    }
    function pushMaterializedTreeId(workInProgress) {
        warnIfNotHydrating();
        null !== workInProgress.return && (pushTreeFork(workInProgress, 1), pushTreeId(workInProgress, 1, 0));
    }
    function popTreeContext(workInProgress) {
        for(; workInProgress === treeForkProvider;)treeForkProvider = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null, treeForkCount = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null;
        for(; workInProgress === treeContextProvider;)treeContextProvider = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextOverflow = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextId = idStack[--idStackIndex], idStack[idStackIndex] = null;
    }
    function getSuspendedTreeContext() {
        warnIfNotHydrating();
        return null !== treeContextProvider ? {
            id: treeContextId,
            overflow: treeContextOverflow
        } : null;
    }
    function restoreSuspendedTreeContext(workInProgress, suspendedContext) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextId = suspendedContext.id;
        treeContextOverflow = suspendedContext.overflow;
        treeContextProvider = workInProgress;
    }
    function warnIfNotHydrating() {
        isHydrating || console.error("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    function buildHydrationDiffNode(fiber, distanceFromLeaf) {
        if (null === fiber.return) {
            if (null === hydrationDiffRootDEV) hydrationDiffRootDEV = {
                fiber: fiber,
                children: [],
                serverProps: void 0,
                serverTail: [],
                distanceFromLeaf: distanceFromLeaf
            };
            else {
                if (hydrationDiffRootDEV.fiber !== fiber) throw Error("Saw multiple hydration diff roots in a pass. This is a bug in React.");
                hydrationDiffRootDEV.distanceFromLeaf > distanceFromLeaf && (hydrationDiffRootDEV.distanceFromLeaf = distanceFromLeaf);
            }
            return hydrationDiffRootDEV;
        }
        var siblings = buildHydrationDiffNode(fiber.return, distanceFromLeaf + 1).children;
        if (0 < siblings.length && siblings[siblings.length - 1].fiber === fiber) return siblings = siblings[siblings.length - 1], siblings.distanceFromLeaf > distanceFromLeaf && (siblings.distanceFromLeaf = distanceFromLeaf), siblings;
        distanceFromLeaf = {
            fiber: fiber,
            children: [],
            serverProps: void 0,
            serverTail: [],
            distanceFromLeaf: distanceFromLeaf
        };
        siblings.push(distanceFromLeaf);
        return distanceFromLeaf;
    }
    function warnIfHydrating() {
        isHydrating && console.error("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function warnNonHydratedInstance(fiber, rejectedCandidate) {
        didSuspendOrErrorDEV || (fiber = buildHydrationDiffNode(fiber, 0), fiber.serverProps = null, null !== rejectedCandidate && (rejectedCandidate = describeHydratableInstanceForDevWarnings(rejectedCandidate), fiber.serverTail.push(rejectedCandidate)));
    }
    function throwOnHydrationMismatch(fiber) {
        var fromText = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : !1, diff = "", diffRoot = hydrationDiffRootDEV;
        null !== diffRoot && (hydrationDiffRootDEV = null, diff = describeDiff(diffRoot));
        queueHydrationError(createCapturedValueAtFiber(Error("Hydration failed because the server rendered " + (fromText ? "text" : "HTML") + " didn't match the client. As a result this tree will be regenerated on the client. This can happen if a SSR-ed Client Component used:\n\n- A server/client branch `if (typeof window !== 'undefined')`.\n- Variable input such as `Date.now()` or `Math.random()` which changes each time it's called.\n- Date formatting in a user's locale which doesn't match the server.\n- External changing data without sending a snapshot of it along with the HTML.\n- Invalid HTML tag nesting.\n\nIt can also happen if the client has a browser extension installed which messes with the HTML before React loaded.\n\nhttps://react.dev/link/hydration-mismatch" + diff), fiber));
        throw HydrationMismatchException;
    }
    function prepareToHydrateHostInstance(fiber) {
        var didHydrate = fiber.stateNode;
        var type = fiber.type, props = fiber.memoizedProps;
        didHydrate[internalInstanceKey] = fiber;
        didHydrate[internalPropsKey] = props;
        validatePropertiesInDevelopment(type, props);
        switch(type){
            case "dialog":
                listenToNonDelegatedEvent("cancel", didHydrate);
                listenToNonDelegatedEvent("close", didHydrate);
                break;
            case "iframe":
            case "object":
            case "embed":
                listenToNonDelegatedEvent("load", didHydrate);
                break;
            case "video":
            case "audio":
                for(type = 0; type < mediaEventTypes.length; type++)listenToNonDelegatedEvent(mediaEventTypes[type], didHydrate);
                break;
            case "source":
                listenToNonDelegatedEvent("error", didHydrate);
                break;
            case "img":
            case "image":
            case "link":
                listenToNonDelegatedEvent("error", didHydrate);
                listenToNonDelegatedEvent("load", didHydrate);
                break;
            case "details":
                listenToNonDelegatedEvent("toggle", didHydrate);
                break;
            case "input":
                checkControlledValueProps("input", props);
                listenToNonDelegatedEvent("invalid", didHydrate);
                validateInputProps(didHydrate, props);
                initInput(didHydrate, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
                break;
            case "option":
                validateOptionProps(didHydrate, props);
                break;
            case "select":
                checkControlledValueProps("select", props);
                listenToNonDelegatedEvent("invalid", didHydrate);
                validateSelectProps(didHydrate, props);
                break;
            case "textarea":
                checkControlledValueProps("textarea", props), listenToNonDelegatedEvent("invalid", didHydrate), validateTextareaProps(didHydrate, props), initTextarea(didHydrate, props.value, props.defaultValue, props.children);
        }
        type = props.children;
        "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || didHydrate.textContent === "" + type || !0 === props.suppressHydrationWarning || checkForUnmatchedText(didHydrate.textContent, type) ? (null != props.popover && (listenToNonDelegatedEvent("beforetoggle", didHydrate), listenToNonDelegatedEvent("toggle", didHydrate)), null != props.onScroll && listenToNonDelegatedEvent("scroll", didHydrate), null != props.onScrollEnd && listenToNonDelegatedEvent("scrollend", didHydrate), null != props.onClick && (didHydrate.onclick = noop$1), didHydrate = !0) : didHydrate = !1;
        didHydrate || throwOnHydrationMismatch(fiber, !0);
    }
    function popToNextHostParent(fiber) {
        for(hydrationParentFiber = fiber.return; hydrationParentFiber;)switch(hydrationParentFiber.tag){
            case 5:
            case 31:
            case 13:
                rootOrSingletonContext = !1;
                return;
            case 27:
            case 3:
                rootOrSingletonContext = !0;
                return;
            default:
                hydrationParentFiber = hydrationParentFiber.return;
        }
    }
    function popHydrationState(fiber) {
        if (fiber !== hydrationParentFiber) return !1;
        if (!isHydrating) return popToNextHostParent(fiber), isHydrating = !0, !1;
        var tag = fiber.tag, JSCompiler_temp;
        if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
            if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || shouldSetTextContent(fiber.type, fiber.memoizedProps);
            JSCompiler_temp = !JSCompiler_temp;
        }
        if (JSCompiler_temp && nextHydratableInstance) {
            for(JSCompiler_temp = nextHydratableInstance; JSCompiler_temp;){
                var diffNode = buildHydrationDiffNode(fiber, 0), description = describeHydratableInstanceForDevWarnings(JSCompiler_temp);
                diffNode.serverTail.push(description);
                JSCompiler_temp = "Suspense" === description.type ? getNextHydratableInstanceAfterHydrationBoundary(JSCompiler_temp) : getNextHydratable(JSCompiler_temp.nextSibling);
            }
            throwOnHydrationMismatch(fiber);
        }
        popToNextHostParent(fiber);
        if (13 === tag) {
            fiber = fiber.memoizedState;
            fiber = null !== fiber ? fiber.dehydrated : null;
            if (!fiber) throw Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
            nextHydratableInstance = getNextHydratableInstanceAfterHydrationBoundary(fiber);
        } else if (31 === tag) {
            fiber = fiber.memoizedState;
            fiber = null !== fiber ? fiber.dehydrated : null;
            if (!fiber) throw Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
            nextHydratableInstance = getNextHydratableInstanceAfterHydrationBoundary(fiber);
        } else 27 === tag ? (tag = nextHydratableInstance, isSingletonScope(fiber.type) ? (fiber = previousHydratableOnEnteringScopedSingleton, previousHydratableOnEnteringScopedSingleton = null, nextHydratableInstance = fiber) : nextHydratableInstance = tag) : nextHydratableInstance = hydrationParentFiber ? getNextHydratable(fiber.stateNode.nextSibling) : null;
        return !0;
    }
    function resetHydrationState() {
        nextHydratableInstance = hydrationParentFiber = null;
        didSuspendOrErrorDEV = isHydrating = !1;
    }
    function upgradeHydrationErrorsToRecoverable() {
        var queuedErrors = hydrationErrors;
        null !== queuedErrors && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = queuedErrors : workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, queuedErrors), hydrationErrors = null);
        return queuedErrors;
    }
    function queueHydrationError(error) {
        null === hydrationErrors ? hydrationErrors = [
            error
        ] : hydrationErrors.push(error);
    }
    function emitPendingHydrationWarnings() {
        var diffRoot = hydrationDiffRootDEV;
        if (null !== diffRoot) {
            hydrationDiffRootDEV = null;
            for(var diff = describeDiff(diffRoot); 0 < diffRoot.children.length;)diffRoot = diffRoot.children[0];
            runWithFiberInDEV(diffRoot.fiber, function() {
                console.error("A tree hydrated but some attributes of the server rendered HTML didn't match the client properties. This won't be patched up. This can happen if a SSR-ed Client Component used:\n\n- A server/client branch `if (typeof window !== 'undefined')`.\n- Variable input such as `Date.now()` or `Math.random()` which changes each time it's called.\n- Date formatting in a user's locale which doesn't match the server.\n- External changing data without sending a snapshot of it along with the HTML.\n- Invalid HTML tag nesting.\n\nIt can also happen if the client has a browser extension installed which messes with the HTML before React loaded.\n\n%s%s", "https://react.dev/link/hydration-mismatch", diff);
            });
        }
    }
    function resetContextDependencies() {
        lastContextDependency = currentlyRenderingFiber$1 = null;
        isDisallowedContextReadInDEV = !1;
    }
    function pushProvider(providerFiber, context, nextValue) {
        push(valueCursor, context._currentValue, providerFiber);
        context._currentValue = nextValue;
        push(rendererCursorDEV, context._currentRenderer, providerFiber);
        void 0 !== context._currentRenderer && null !== context._currentRenderer && context._currentRenderer !== rendererSigil && console.error("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
        context._currentRenderer = rendererSigil;
    }
    function popProvider(context, providerFiber) {
        context._currentValue = valueCursor.current;
        var currentRenderer = rendererCursorDEV.current;
        pop(rendererCursorDEV, providerFiber);
        context._currentRenderer = currentRenderer;
        pop(valueCursor, providerFiber);
    }
    function scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
        for(; null !== parent;){
            var alternate = parent.alternate;
            (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
            if (parent === propagationRoot) break;
            parent = parent.return;
        }
        parent !== propagationRoot && console.error("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
        var fiber = workInProgress.child;
        null !== fiber && (fiber.return = workInProgress);
        for(; null !== fiber;){
            var list = fiber.dependencies;
            if (null !== list) {
                var nextFiber = fiber.child;
                list = list.firstContext;
                a: for(; null !== list;){
                    var dependency = list;
                    list = fiber;
                    for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                        list.lanes |= renderLanes;
                        dependency = list.alternate;
                        null !== dependency && (dependency.lanes |= renderLanes);
                        scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                        forcePropagateEntireTree || (nextFiber = null);
                        break a;
                    }
                    list = dependency.next;
                }
            } else if (18 === fiber.tag) {
                nextFiber = fiber.return;
                if (null === nextFiber) throw Error("We just came from a parent so we must have had a parent. This is a bug in React.");
                nextFiber.lanes |= renderLanes;
                list = nextFiber.alternate;
                null !== list && (list.lanes |= renderLanes);
                scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
                nextFiber = null;
            } else nextFiber = fiber.child;
            if (null !== nextFiber) nextFiber.return = fiber;
            else for(nextFiber = fiber; null !== nextFiber;){
                if (nextFiber === workInProgress) {
                    nextFiber = null;
                    break;
                }
                fiber = nextFiber.sibling;
                if (null !== fiber) {
                    fiber.return = nextFiber.return;
                    nextFiber = fiber;
                    break;
                }
                nextFiber = nextFiber.return;
            }
            fiber = nextFiber;
        }
    }
    function propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
        current = null;
        for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
            if (!isInsidePropagationBailout) {
                if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
                else if (0 !== (parent.flags & 262144)) break;
            }
            if (10 === parent.tag) {
                var currentParent = parent.alternate;
                if (null === currentParent) throw Error("Should have a current fiber. This is a bug in React.");
                currentParent = currentParent.memoizedProps;
                if (null !== currentParent) {
                    var context = parent.type;
                    objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                        context
                    ]);
                }
            } else if (parent === hostTransitionProviderCursor.current) {
                currentParent = parent.alternate;
                if (null === currentParent) throw Error("Should have a current fiber. This is a bug in React.");
                currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push(HostTransitionContext) : current = [
                    HostTransitionContext
                ]);
            }
            parent = parent.return;
        }
        null !== current && propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
        workInProgress.flags |= 262144;
    }
    function checkIfContextChanged(currentDependencies) {
        for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
            if (!objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
            currentDependencies = currentDependencies.next;
        }
        return !1;
    }
    function prepareToReadContext(workInProgress) {
        currentlyRenderingFiber$1 = workInProgress;
        lastContextDependency = null;
        workInProgress = workInProgress.dependencies;
        null !== workInProgress && (workInProgress.firstContext = null);
    }
    function readContext(context) {
        isDisallowedContextReadInDEV && console.error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
        return readContextForConsumer(currentlyRenderingFiber$1, context);
    }
    function readContextDuringReconciliation(consumer, context) {
        null === currentlyRenderingFiber$1 && prepareToReadContext(consumer);
        return readContextForConsumer(consumer, context);
    }
    function readContextForConsumer(consumer, context) {
        var value = context._currentValue;
        context = {
            context: context,
            memoizedValue: value,
            next: null
        };
        if (null === lastContextDependency) {
            if (null === consumer) throw Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
            lastContextDependency = context;
            consumer.dependencies = {
                lanes: 0,
                firstContext: context,
                _debugThenableState: null
            };
            consumer.flags |= 524288;
        } else lastContextDependency = lastContextDependency.next = context;
        return value;
    }
    function createCache() {
        return {
            controller: new AbortControllerLocal(),
            data: new Map(),
            refCount: 0
        };
    }
    function retainCache(cache) {
        cache.controller.signal.aborted && console.warn("A cache instance was retained after it was already freed. This likely indicates a bug in React.");
        cache.refCount++;
    }
    function releaseCache(cache) {
        cache.refCount--;
        0 > cache.refCount && console.warn("A cache instance was released after it was already freed. This likely indicates a bug in React.");
        0 === cache.refCount && scheduleCallback$2(NormalPriority, function() {
            cache.controller.abort();
        });
    }
    function startUpdateTimerByLane(lane, method, fiber) {
        if (0 !== (lane & 127)) 0 > blockingUpdateTime && (blockingUpdateTime = now(), blockingUpdateTask = createTask(method), blockingUpdateMethodName = method, null != fiber && (blockingUpdateComponentName = getComponentNameFromFiber(fiber)), (executionContext & (RenderContext | CommitContext)) !== NoContext && (componentEffectSpawnedUpdate = !0, blockingUpdateType = SPAWNED_UPDATE), lane = resolveEventTimeStamp(), method = resolveEventType(), lane !== blockingEventRepeatTime || method !== blockingEventType ? blockingEventRepeatTime = -1.1 : null !== method && (blockingUpdateType = SPAWNED_UPDATE), blockingEventTime = lane, blockingEventType = method);
        else if (0 !== (lane & 4194048) && 0 > transitionUpdateTime && (transitionUpdateTime = now(), transitionUpdateTask = createTask(method), transitionUpdateMethodName = method, null != fiber && (transitionUpdateComponentName = getComponentNameFromFiber(fiber)), 0 > transitionStartTime)) {
            lane = resolveEventTimeStamp();
            method = resolveEventType();
            if (lane !== transitionEventRepeatTime || method !== transitionEventType) transitionEventRepeatTime = -1.1;
            transitionEventTime = lane;
            transitionEventType = method;
        }
    }
    function startHostActionTimer(fiber) {
        if (0 > blockingUpdateTime) {
            blockingUpdateTime = now();
            blockingUpdateTask = null != fiber._debugTask ? fiber._debugTask : null;
            (executionContext & (RenderContext | CommitContext)) !== NoContext && (blockingUpdateType = SPAWNED_UPDATE);
            var newEventTime = resolveEventTimeStamp(), newEventType = resolveEventType();
            newEventTime !== blockingEventRepeatTime || newEventType !== blockingEventType ? blockingEventRepeatTime = -1.1 : null !== newEventType && (blockingUpdateType = SPAWNED_UPDATE);
            blockingEventTime = newEventTime;
            blockingEventType = newEventType;
        }
        if (0 > transitionUpdateTime && (transitionUpdateTime = now(), transitionUpdateTask = null != fiber._debugTask ? fiber._debugTask : null, 0 > transitionStartTime)) {
            fiber = resolveEventTimeStamp();
            newEventTime = resolveEventType();
            if (fiber !== transitionEventRepeatTime || newEventTime !== transitionEventType) transitionEventRepeatTime = -1.1;
            transitionEventTime = fiber;
            transitionEventType = newEventTime;
        }
    }
    function pushNestedEffectDurations() {
        var prevEffectDuration = profilerEffectDuration;
        profilerEffectDuration = 0;
        return prevEffectDuration;
    }
    function popNestedEffectDurations(prevEffectDuration) {
        var elapsedTime = profilerEffectDuration;
        profilerEffectDuration = prevEffectDuration;
        return elapsedTime;
    }
    function bubbleNestedEffectDurations(prevEffectDuration) {
        var elapsedTime = profilerEffectDuration;
        profilerEffectDuration += prevEffectDuration;
        return elapsedTime;
    }
    function resetComponentEffectTimers() {
        componentEffectEndTime = componentEffectStartTime = -1.1;
    }
    function pushComponentEffectStart() {
        var prevEffectStart = componentEffectStartTime;
        componentEffectStartTime = -1.1;
        return prevEffectStart;
    }
    function popComponentEffectStart(prevEffectStart) {
        0 <= prevEffectStart && (componentEffectStartTime = prevEffectStart);
    }
    function pushComponentEffectDuration() {
        var prevEffectDuration = componentEffectDuration;
        componentEffectDuration = -0;
        return prevEffectDuration;
    }
    function popComponentEffectDuration(prevEffectDuration) {
        0 <= prevEffectDuration && (componentEffectDuration = prevEffectDuration);
    }
    function pushComponentEffectErrors() {
        var prevErrors = componentEffectErrors;
        componentEffectErrors = null;
        return prevErrors;
    }
    function pushComponentEffectDidSpawnUpdate() {
        var prev = componentEffectSpawnedUpdate;
        componentEffectSpawnedUpdate = !1;
        return prev;
    }
    function startProfilerTimer(fiber) {
        profilerStartTime = now();
        0 > fiber.actualStartTime && (fiber.actualStartTime = profilerStartTime);
    }
    function stopProfilerTimerIfRunningAndRecordDuration(fiber) {
        if (0 <= profilerStartTime) {
            var elapsedTime = now() - profilerStartTime;
            fiber.actualDuration += elapsedTime;
            fiber.selfBaseDuration = elapsedTime;
            profilerStartTime = -1;
        }
    }
    function stopProfilerTimerIfRunningAndRecordIncompleteDuration(fiber) {
        if (0 <= profilerStartTime) {
            var elapsedTime = now() - profilerStartTime;
            fiber.actualDuration += elapsedTime;
            profilerStartTime = -1;
        }
    }
    function recordEffectDuration() {
        if (0 <= profilerStartTime) {
            var endTime = now(), elapsedTime = endTime - profilerStartTime;
            profilerStartTime = -1;
            profilerEffectDuration += elapsedTime;
            componentEffectDuration += elapsedTime;
            componentEffectEndTime = endTime;
        }
    }
    function recordEffectError(errorInfo) {
        null === componentEffectErrors && (componentEffectErrors = []);
        componentEffectErrors.push(errorInfo);
        null === commitErrors && (commitErrors = []);
        commitErrors.push(errorInfo);
    }
    function startEffectTimer() {
        profilerStartTime = now();
        0 > componentEffectStartTime && (componentEffectStartTime = profilerStartTime);
    }
    function transferActualDuration(fiber) {
        for(var child = fiber.child; child;)fiber.actualDuration += child.actualDuration, child = child.sibling;
    }
    function entangleAsyncAction(transition, thenable) {
        if (null === currentEntangledListeners) {
            var entangledListeners = currentEntangledListeners = [];
            currentEntangledPendingCount = 0;
            currentEntangledLane = requestTransitionLane();
            currentEntangledActionThenable = {
                status: "pending",
                value: void 0,
                then: function(resolve) {
                    entangledListeners.push(resolve);
                }
            };
        }
        currentEntangledPendingCount++;
        thenable.then(pingEngtangledActionScope, pingEngtangledActionScope);
        return thenable;
    }
    function pingEngtangledActionScope() {
        if (0 === --currentEntangledPendingCount && (-1 < transitionUpdateTime || (transitionStartTime = -1.1), null !== currentEntangledListeners)) {
            null !== currentEntangledActionThenable && (currentEntangledActionThenable.status = "fulfilled");
            var listeners = currentEntangledListeners;
            currentEntangledListeners = null;
            currentEntangledLane = 0;
            currentEntangledActionThenable = null;
            for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
        }
    }
    function chainThenableValue(thenable, result) {
        var listeners = [], thenableWithOverride = {
            status: "pending",
            value: null,
            reason: null,
            then: function(resolve) {
                listeners.push(resolve);
            }
        };
        thenable.then(function() {
            thenableWithOverride.status = "fulfilled";
            thenableWithOverride.value = result;
            for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
        }, function(error) {
            thenableWithOverride.status = "rejected";
            thenableWithOverride.reason = error;
            for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
        });
        return thenableWithOverride;
    }
    function peekCacheFromPool() {
        var cacheResumedFromPreviousRender = resumedCache.current;
        return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : workInProgressRoot.pooledCache;
    }
    function pushTransition(offscreenWorkInProgress, prevCachePool) {
        null === prevCachePool ? push(resumedCache, resumedCache.current, offscreenWorkInProgress) : push(resumedCache, prevCachePool.pool, offscreenWorkInProgress);
    }
    function getSuspendedCache() {
        var cacheFromPool = peekCacheFromPool();
        return null === cacheFromPool ? null : {
            parent: CacheContext._currentValue,
            pool: cacheFromPool
        };
    }
    function createThenableState() {
        return {
            didWarnAboutUncachedPromise: !1,
            thenables: []
        };
    }
    function isThenableResolved(thenable) {
        thenable = thenable.status;
        return "fulfilled" === thenable || "rejected" === thenable;
    }
    function trackUsedThenable(thenableState, thenable, index) {
        null !== ReactSharedInternals.actQueue && (ReactSharedInternals.didUsePromise = !0);
        var trackedThenables = thenableState.thenables;
        index = trackedThenables[index];
        void 0 === index ? trackedThenables.push(thenable) : index !== thenable && (thenableState.didWarnAboutUncachedPromise || (thenableState.didWarnAboutUncachedPromise = !0, console.error("A component was suspended by an uncached promise. Creating promises inside a Client Component or hook is not yet supported, except via a Suspense-compatible library or framework.")), thenable.then(noop$1, noop$1), thenable = index);
        if (void 0 === thenable._debugInfo) {
            thenableState = performance.now();
            trackedThenables = thenable.displayName;
            var ioInfo = {
                name: "string" === typeof trackedThenables ? trackedThenables : "Promise",
                start: thenableState,
                end: thenableState,
                value: thenable
            };
            thenable._debugInfo = [
                {
                    awaited: ioInfo
                }
            ];
            "fulfilled" !== thenable.status && "rejected" !== thenable.status && (thenableState = function() {
                ioInfo.end = performance.now();
            }, thenable.then(thenableState, thenableState));
        }
        switch(thenable.status){
            case "fulfilled":
                return thenable.value;
            case "rejected":
                throw thenableState = thenable.reason, checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            default:
                if ("string" === typeof thenable.status) thenable.then(noop$1, noop$1);
                else {
                    thenableState = workInProgressRoot;
                    if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error("An unknown Component is an async Client Component. Only Server Components can be async at the moment. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server.");
                    thenableState = thenable;
                    thenableState.status = "pending";
                    thenableState.then(function(fulfilledValue) {
                        if ("pending" === thenable.status) {
                            var fulfilledThenable = thenable;
                            fulfilledThenable.status = "fulfilled";
                            fulfilledThenable.value = fulfilledValue;
                        }
                    }, function(error) {
                        if ("pending" === thenable.status) {
                            var rejectedThenable = thenable;
                            rejectedThenable.status = "rejected";
                            rejectedThenable.reason = error;
                        }
                    });
                }
                switch(thenable.status){
                    case "fulfilled":
                        return thenable.value;
                    case "rejected":
                        throw thenableState = thenable.reason, checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
                }
                suspendedThenable = thenable;
                needsToResetSuspendedThenableDEV = !0;
                throw SuspenseException;
        }
    }
    function resolveLazy(lazyType) {
        try {
            return callLazyInitInDEV(lazyType);
        } catch (x) {
            if (null !== x && "object" === typeof x && "function" === typeof x.then) throw suspendedThenable = x, needsToResetSuspendedThenableDEV = !0, SuspenseException;
            throw x;
        }
    }
    function getSuspendedThenable() {
        if (null === suspendedThenable) throw Error("Expected a suspended thenable. This is a bug in React. Please file an issue.");
        var thenable = suspendedThenable;
        suspendedThenable = null;
        needsToResetSuspendedThenableDEV = !1;
        return thenable;
    }
    function checkIfUseWrappedInAsyncCatch(rejectedReason) {
        if (rejectedReason === SuspenseException || rejectedReason === SuspenseActionException) throw Error("Hooks are not supported inside an async component. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server.");
    }
    function pushDebugInfo(debugInfo) {
        var previousDebugInfo = currentDebugInfo;
        null != debugInfo && (currentDebugInfo = null === previousDebugInfo ? debugInfo : previousDebugInfo.concat(debugInfo));
        return previousDebugInfo;
    }
    function getCurrentDebugTask() {
        var debugInfo = currentDebugInfo;
        if (null != debugInfo) {
            for(var i = debugInfo.length - 1; 0 <= i; i--)if (null != debugInfo[i].name) {
                var debugTask = debugInfo[i].debugTask;
                if (null != debugTask) return debugTask;
            }
        }
        return null;
    }
    function validateFragmentProps(element, fiber, returnFiber) {
        for(var keys = Object.keys(element.props), i = 0; i < keys.length; i++){
            var key = keys[i];
            if ("children" !== key && "key" !== key) {
                null === fiber && (fiber = createFiberFromElement(element, returnFiber.mode, 0), fiber._debugInfo = currentDebugInfo, fiber.return = returnFiber);
                runWithFiberInDEV(fiber, function(erroredKey) {
                    console.error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", erroredKey);
                }, key);
                break;
            }
        }
    }
    function unwrapThenable(thenable) {
        var index = thenableIndexCounter$1;
        thenableIndexCounter$1 += 1;
        null === thenableState$1 && (thenableState$1 = createThenableState());
        return trackUsedThenable(thenableState$1, thenable, index);
    }
    function coerceRef(workInProgress, element) {
        element = element.props.ref;
        workInProgress.ref = void 0 !== element ? element : null;
    }
    function throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
        if (newChild.$$typeof === REACT_LEGACY_ELEMENT_TYPE) throw Error('A React Element from an older version of React was rendered. This is not supported. It can happen if:\n- Multiple copies of the "react" package is used.\n- A library pre-bundled an old copy of "react" or "react/jsx-runtime".\n- A compiler tries to "inline" JSX instead of using the runtime.');
        returnFiber = Object.prototype.toString.call(newChild);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber) + "). If you meant to render a collection of children, use an array instead.");
    }
    function throwOnInvalidObjectType(returnFiber, newChild) {
        var debugTask = getCurrentDebugTask();
        null !== debugTask ? debugTask.run(throwOnInvalidObjectTypeImpl.bind(null, returnFiber, newChild)) : throwOnInvalidObjectTypeImpl(returnFiber, newChild);
    }
    function warnOnFunctionTypeImpl(returnFiber, invalidChild) {
        var parentName = getComponentNameFromFiber(returnFiber) || "Component";
        ownerHasFunctionTypeWarning[parentName] || (ownerHasFunctionTypeWarning[parentName] = !0, invalidChild = invalidChild.displayName || invalidChild.name || "Component", 3 === returnFiber.tag ? console.error("Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.\n  root.render(%s)", invalidChild, invalidChild, invalidChild) : console.error("Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.\n  <%s>{%s}</%s>", invalidChild, invalidChild, parentName, invalidChild, parentName));
    }
    function warnOnFunctionType(returnFiber, invalidChild) {
        var debugTask = getCurrentDebugTask();
        null !== debugTask ? debugTask.run(warnOnFunctionTypeImpl.bind(null, returnFiber, invalidChild)) : warnOnFunctionTypeImpl(returnFiber, invalidChild);
    }
    function warnOnSymbolTypeImpl(returnFiber, invalidChild) {
        var parentName = getComponentNameFromFiber(returnFiber) || "Component";
        ownerHasSymbolTypeWarning[parentName] || (ownerHasSymbolTypeWarning[parentName] = !0, invalidChild = String(invalidChild), 3 === returnFiber.tag ? console.error("Symbols are not valid as a React child.\n  root.render(%s)", invalidChild) : console.error("Symbols are not valid as a React child.\n  <%s>%s</%s>", parentName, invalidChild, parentName));
    }
    function warnOnSymbolType(returnFiber, invalidChild) {
        var debugTask = getCurrentDebugTask();
        null !== debugTask ? debugTask.run(warnOnSymbolTypeImpl.bind(null, returnFiber, invalidChild)) : warnOnSymbolTypeImpl(returnFiber, invalidChild);
    }
    function createChildReconciler(shouldTrackSideEffects) {
        function deleteChild(returnFiber, childToDelete) {
            if (shouldTrackSideEffects) {
                var deletions = returnFiber.deletions;
                null === deletions ? (returnFiber.deletions = [
                    childToDelete
                ], returnFiber.flags |= 16) : deletions.push(childToDelete);
            }
        }
        function deleteRemainingChildren(returnFiber, currentFirstChild) {
            if (!shouldTrackSideEffects) return null;
            for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
            return null;
        }
        function mapRemainingChildren(currentFirstChild) {
            for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
            return existingChildren;
        }
        function useFiber(fiber, pendingProps) {
            fiber = createWorkInProgress(fiber, pendingProps);
            fiber.index = 0;
            fiber.sibling = null;
            return fiber;
        }
        function placeChild(newFiber, lastPlacedIndex, newIndex) {
            newFiber.index = newIndex;
            if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
            newIndex = newFiber.alternate;
            if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
            newFiber.flags |= 67108866;
            return lastPlacedIndex;
        }
        function placeSingleChild(newFiber) {
            shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
            return newFiber;
        }
        function updateTextNode(returnFiber, current, textContent, lanes) {
            if (null === current || 6 !== current.tag) return current = createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current._debugOwner = returnFiber, current._debugTask = returnFiber._debugTask, current._debugInfo = currentDebugInfo, current;
            current = useFiber(current, textContent);
            current.return = returnFiber;
            current._debugInfo = currentDebugInfo;
            return current;
        }
        function updateElement(returnFiber, current, element, lanes) {
            var elementType = element.type;
            if (elementType === REACT_FRAGMENT_TYPE) return current = updateFragment(returnFiber, current, element.props.children, lanes, element.key), validateFragmentProps(element, current, returnFiber), current;
            if (null !== current && (current.elementType === elementType || isCompatibleFamilyForHotReloading(current, element) || "object" === typeof elementType && null !== elementType && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), coerceRef(current, element), current.return = returnFiber, current._debugOwner = element._owner, current._debugInfo = currentDebugInfo, current;
            current = createFiberFromElement(element, returnFiber.mode, lanes);
            coerceRef(current, element);
            current.return = returnFiber;
            current._debugInfo = currentDebugInfo;
            return current;
        }
        function updatePortal(returnFiber, current, portal, lanes) {
            if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current._debugInfo = currentDebugInfo, current;
            current = useFiber(current, portal.children || []);
            current.return = returnFiber;
            current._debugInfo = currentDebugInfo;
            return current;
        }
        function updateFragment(returnFiber, current, fragment, lanes, key) {
            if (null === current || 7 !== current.tag) return current = createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current._debugOwner = returnFiber, current._debugTask = returnFiber._debugTask, current._debugInfo = currentDebugInfo, current;
            current = useFiber(current, fragment);
            current.return = returnFiber;
            current._debugInfo = currentDebugInfo;
            return current;
        }
        function createChild(returnFiber, newChild, lanes) {
            if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild._debugOwner = returnFiber, newChild._debugTask = returnFiber._debugTask, newChild._debugInfo = currentDebugInfo, newChild;
            if ("object" === typeof newChild && null !== newChild) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        return lanes = createFiberFromElement(newChild, returnFiber.mode, lanes), coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = pushDebugInfo(newChild._debugInfo), lanes._debugInfo = currentDebugInfo, currentDebugInfo = returnFiber, lanes;
                    case REACT_PORTAL_TYPE:
                        return newChild = createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild._debugInfo = currentDebugInfo, newChild;
                    case REACT_LAZY_TYPE:
                        var _prevDebugInfo = pushDebugInfo(newChild._debugInfo);
                        newChild = resolveLazy(newChild);
                        returnFiber = createChild(returnFiber, newChild, lanes);
                        currentDebugInfo = _prevDebugInfo;
                        return returnFiber;
                }
                if (isArrayImpl(newChild) || getIteratorFn(newChild)) return lanes = createFiberFromFragment(newChild, returnFiber.mode, lanes, null), lanes.return = returnFiber, lanes._debugOwner = returnFiber, lanes._debugTask = returnFiber._debugTask, returnFiber = pushDebugInfo(newChild._debugInfo), lanes._debugInfo = currentDebugInfo, currentDebugInfo = returnFiber, lanes;
                if ("function" === typeof newChild.then) return _prevDebugInfo = pushDebugInfo(newChild._debugInfo), returnFiber = createChild(returnFiber, unwrapThenable(newChild), lanes), currentDebugInfo = _prevDebugInfo, returnFiber;
                if (newChild.$$typeof === REACT_CONTEXT_TYPE) return createChild(returnFiber, readContextDuringReconciliation(returnFiber, newChild), lanes);
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            "function" === typeof newChild && warnOnFunctionType(returnFiber, newChild);
            "symbol" === typeof newChild && warnOnSymbolType(returnFiber, newChild);
            return null;
        }
        function updateSlot(returnFiber, oldFiber, newChild, lanes) {
            var key = null !== oldFiber ? oldFiber.key : null;
            if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
            if ("object" === typeof newChild && null !== newChild) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        return newChild.key === key ? (key = pushDebugInfo(newChild._debugInfo), returnFiber = updateElement(returnFiber, oldFiber, newChild, lanes), currentDebugInfo = key, returnFiber) : null;
                    case REACT_PORTAL_TYPE:
                        return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                    case REACT_LAZY_TYPE:
                        return key = pushDebugInfo(newChild._debugInfo), newChild = resolveLazy(newChild), returnFiber = updateSlot(returnFiber, oldFiber, newChild, lanes), currentDebugInfo = key, returnFiber;
                }
                if (isArrayImpl(newChild) || getIteratorFn(newChild)) {
                    if (null !== key) return null;
                    key = pushDebugInfo(newChild._debugInfo);
                    returnFiber = updateFragment(returnFiber, oldFiber, newChild, lanes, null);
                    currentDebugInfo = key;
                    return returnFiber;
                }
                if ("function" === typeof newChild.then) return key = pushDebugInfo(newChild._debugInfo), returnFiber = updateSlot(returnFiber, oldFiber, unwrapThenable(newChild), lanes), currentDebugInfo = key, returnFiber;
                if (newChild.$$typeof === REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, readContextDuringReconciliation(returnFiber, newChild), lanes);
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            "function" === typeof newChild && warnOnFunctionType(returnFiber, newChild);
            "symbol" === typeof newChild && warnOnSymbolType(returnFiber, newChild);
            return null;
        }
        function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
            if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
            if ("object" === typeof newChild && null !== newChild) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        return newIdx = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, existingChildren = pushDebugInfo(newChild._debugInfo), returnFiber = updateElement(returnFiber, newIdx, newChild, lanes), currentDebugInfo = existingChildren, returnFiber;
                    case REACT_PORTAL_TYPE:
                        return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                    case REACT_LAZY_TYPE:
                        var _prevDebugInfo7 = pushDebugInfo(newChild._debugInfo);
                        newChild = resolveLazy(newChild);
                        returnFiber = updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
                        currentDebugInfo = _prevDebugInfo7;
                        return returnFiber;
                }
                if (isArrayImpl(newChild) || getIteratorFn(newChild)) return newIdx = existingChildren.get(newIdx) || null, existingChildren = pushDebugInfo(newChild._debugInfo), returnFiber = updateFragment(returnFiber, newIdx, newChild, lanes, null), currentDebugInfo = existingChildren, returnFiber;
                if ("function" === typeof newChild.then) return _prevDebugInfo7 = pushDebugInfo(newChild._debugInfo), returnFiber = updateFromMap(existingChildren, returnFiber, newIdx, unwrapThenable(newChild), lanes), currentDebugInfo = _prevDebugInfo7, returnFiber;
                if (newChild.$$typeof === REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, readContextDuringReconciliation(returnFiber, newChild), lanes);
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            "function" === typeof newChild && warnOnFunctionType(returnFiber, newChild);
            "symbol" === typeof newChild && warnOnSymbolType(returnFiber, newChild);
            return null;
        }
        function warnOnInvalidKey(returnFiber, workInProgress, child, knownKeys) {
            if ("object" !== typeof child || null === child) return knownKeys;
            switch(child.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    warnForMissingKey(returnFiber, workInProgress, child);
                    var key = child.key;
                    if ("string" !== typeof key) break;
                    if (null === knownKeys) {
                        knownKeys = new Set();
                        knownKeys.add(key);
                        break;
                    }
                    if (!knownKeys.has(key)) {
                        knownKeys.add(key);
                        break;
                    }
                    runWithFiberInDEV(workInProgress, function() {
                        console.error("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted \u2014 the behavior is unsupported and could change in a future version.", key);
                    });
                    break;
                case REACT_LAZY_TYPE:
                    child = resolveLazy(child), warnOnInvalidKey(returnFiber, workInProgress, child, knownKeys);
            }
            return knownKeys;
        }
        function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
            for(var knownKeys = null, resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
                oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
                if (null === newFiber) {
                    null === oldFiber && (oldFiber = nextOldFiber);
                    break;
                }
                knownKeys = warnOnInvalidKey(returnFiber, newFiber, newChildren[newIdx], knownKeys);
                shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
                currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
                null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
            if (null === oldFiber) {
                for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (knownKeys = warnOnInvalidKey(returnFiber, oldFiber, newChildren[newIdx], knownKeys), currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
                isHydrating && pushTreeFork(returnFiber, newIdx);
                return resultingFirstChild;
            }
            for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (knownKeys = warnOnInvalidKey(returnFiber, nextOldFiber, newChildren[newIdx], knownKeys), shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
            shouldTrackSideEffects && oldFiber.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            isHydrating && pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
            if (null == newChildren) throw Error("An iterable object provided no iterator.");
            for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, knownKeys = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
                oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
                if (null === newFiber) {
                    null === oldFiber && (oldFiber = nextOldFiber);
                    break;
                }
                knownKeys = warnOnInvalidKey(returnFiber, newFiber, step.value, knownKeys);
                shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
                currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
                null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
            if (null === oldFiber) {
                for(; !step.done; newIdx++, step = newChildren.next())oldFiber = createChild(returnFiber, step.value, lanes), null !== oldFiber && (knownKeys = warnOnInvalidKey(returnFiber, oldFiber, step.value, knownKeys), currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
                isHydrating && pushTreeFork(returnFiber, newIdx);
                return resultingFirstChild;
            }
            for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== nextOldFiber && (knownKeys = warnOnInvalidKey(returnFiber, nextOldFiber, step.value, knownKeys), shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
            shouldTrackSideEffects && oldFiber.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            isHydrating && pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
            "object" === typeof newChild && null !== newChild && newChild.type === REACT_FRAGMENT_TYPE && null === newChild.key && (validateFragmentProps(newChild, null, returnFiber), newChild = newChild.props.children);
            if ("object" === typeof newChild && null !== newChild) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var prevDebugInfo = pushDebugInfo(newChild._debugInfo);
                        a: {
                            for(var key = newChild.key; null !== currentFirstChild;){
                                if (currentFirstChild.key === key) {
                                    key = newChild.type;
                                    if (key === REACT_FRAGMENT_TYPE) {
                                        if (7 === currentFirstChild.tag) {
                                            deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                            lanes = useFiber(currentFirstChild, newChild.props.children);
                                            lanes.return = returnFiber;
                                            lanes._debugOwner = newChild._owner;
                                            lanes._debugInfo = currentDebugInfo;
                                            validateFragmentProps(newChild, lanes, returnFiber);
                                            returnFiber = lanes;
                                            break a;
                                        }
                                    } else if (currentFirstChild.elementType === key || isCompatibleFamilyForHotReloading(currentFirstChild, newChild) || "object" === typeof key && null !== key && key.$$typeof === REACT_LAZY_TYPE && resolveLazy(key) === currentFirstChild.type) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props);
                                        coerceRef(lanes, newChild);
                                        lanes.return = returnFiber;
                                        lanes._debugOwner = newChild._owner;
                                        lanes._debugInfo = currentDebugInfo;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                } else deleteChild(returnFiber, currentFirstChild);
                                currentFirstChild = currentFirstChild.sibling;
                            }
                            newChild.type === REACT_FRAGMENT_TYPE ? (lanes = createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, lanes._debugOwner = returnFiber, lanes._debugTask = returnFiber._debugTask, lanes._debugInfo = currentDebugInfo, validateFragmentProps(newChild, lanes, returnFiber), returnFiber = lanes) : (lanes = createFiberFromElement(newChild, returnFiber.mode, lanes), coerceRef(lanes, newChild), lanes.return = returnFiber, lanes._debugInfo = currentDebugInfo, returnFiber = lanes);
                        }
                        returnFiber = placeSingleChild(returnFiber);
                        currentDebugInfo = prevDebugInfo;
                        return returnFiber;
                    case REACT_PORTAL_TYPE:
                        a: {
                            prevDebugInfo = newChild;
                            for(newChild = prevDebugInfo.key; null !== currentFirstChild;){
                                if (currentFirstChild.key === newChild) {
                                    if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === prevDebugInfo.containerInfo && currentFirstChild.stateNode.implementation === prevDebugInfo.implementation) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, prevDebugInfo.children || []);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    } else {
                                        deleteRemainingChildren(returnFiber, currentFirstChild);
                                        break;
                                    }
                                } else deleteChild(returnFiber, currentFirstChild);
                                currentFirstChild = currentFirstChild.sibling;
                            }
                            lanes = createFiberFromPortal(prevDebugInfo, returnFiber.mode, lanes);
                            lanes.return = returnFiber;
                            returnFiber = lanes;
                        }
                        return placeSingleChild(returnFiber);
                    case REACT_LAZY_TYPE:
                        return prevDebugInfo = pushDebugInfo(newChild._debugInfo), newChild = resolveLazy(newChild), returnFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes), currentDebugInfo = prevDebugInfo, returnFiber;
                }
                if (isArrayImpl(newChild)) return prevDebugInfo = pushDebugInfo(newChild._debugInfo), returnFiber = reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes), currentDebugInfo = prevDebugInfo, returnFiber;
                if (getIteratorFn(newChild)) {
                    prevDebugInfo = pushDebugInfo(newChild._debugInfo);
                    key = getIteratorFn(newChild);
                    if ("function" !== typeof key) throw Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
                    var newChildren = key.call(newChild);
                    if (newChildren === newChild) {
                        if (0 !== returnFiber.tag || "[object GeneratorFunction]" !== Object.prototype.toString.call(returnFiber.type) || "[object Generator]" !== Object.prototype.toString.call(newChildren)) didWarnAboutGenerators || console.error("Using Iterators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. You can also use an Iterable that can iterate multiple times over the same items."), didWarnAboutGenerators = !0;
                    } else newChild.entries !== key || didWarnAboutMaps || (console.error("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), didWarnAboutMaps = !0);
                    returnFiber = reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes);
                    currentDebugInfo = prevDebugInfo;
                    return returnFiber;
                }
                if ("function" === typeof newChild.then) return prevDebugInfo = pushDebugInfo(newChild._debugInfo), returnFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, unwrapThenable(newChild), lanes), currentDebugInfo = prevDebugInfo, returnFiber;
                if (newChild.$$typeof === REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, readContextDuringReconciliation(returnFiber, newChild), lanes);
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return prevDebugInfo = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, prevDebugInfo), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = createFiberFromText(prevDebugInfo, returnFiber.mode, lanes), lanes.return = returnFiber, lanes._debugOwner = returnFiber, lanes._debugTask = returnFiber._debugTask, lanes._debugInfo = currentDebugInfo, returnFiber = lanes), placeSingleChild(returnFiber);
            "function" === typeof newChild && warnOnFunctionType(returnFiber, newChild);
            "symbol" === typeof newChild && warnOnSymbolType(returnFiber, newChild);
            return deleteRemainingChildren(returnFiber, currentFirstChild);
        }
        return function(returnFiber, currentFirstChild, newChild, lanes) {
            var prevDebugInfo = currentDebugInfo;
            currentDebugInfo = null;
            try {
                thenableIndexCounter$1 = 0;
                var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
                thenableState$1 = null;
                return firstChildFiber;
            } catch (x) {
                if (x === SuspenseException || x === SuspenseActionException) throw x;
                var fiber = createFiber(29, x, null, returnFiber.mode);
                fiber.lanes = lanes;
                fiber.return = returnFiber;
                var debugInfo = fiber._debugInfo = currentDebugInfo;
                fiber._debugOwner = returnFiber._debugOwner;
                fiber._debugTask = returnFiber._debugTask;
                if (null != debugInfo) {
                    for(var i = debugInfo.length - 1; 0 <= i; i--)if ("string" === typeof debugInfo[i].stack) {
                        fiber._debugOwner = debugInfo[i];
                        fiber._debugTask = debugInfo[i].debugTask;
                        break;
                    }
                }
                return fiber;
            } finally{
                currentDebugInfo = prevDebugInfo;
            }
        };
    }
    function validateSuspenseListNestedChild(childSlot, index) {
        var isAnArray = isArrayImpl(childSlot);
        childSlot = !isAnArray && "function" === typeof getIteratorFn(childSlot);
        return isAnArray || childSlot ? (isAnArray = isAnArray ? "array" : "iterable", console.error("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", isAnArray, index, isAnArray), !1) : !0;
    }
    function initializeUpdateQueue(fiber) {
        fiber.updateQueue = {
            baseState: fiber.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
                pending: null,
                lanes: 0,
                hiddenCallbacks: null
            },
            callbacks: null
        };
    }
    function cloneUpdateQueue(current, workInProgress) {
        current = current.updateQueue;
        workInProgress.updateQueue === current && (workInProgress.updateQueue = {
            baseState: current.baseState,
            firstBaseUpdate: current.firstBaseUpdate,
            lastBaseUpdate: current.lastBaseUpdate,
            shared: current.shared,
            callbacks: null
        });
    }
    function createUpdate(lane) {
        return {
            lane: lane,
            tag: UpdateState,
            payload: null,
            callback: null,
            next: null
        };
    }
    function enqueueUpdate(fiber, update, lane) {
        var updateQueue = fiber.updateQueue;
        if (null === updateQueue) return null;
        updateQueue = updateQueue.shared;
        if (currentlyProcessingQueue === updateQueue && !didWarnUpdateInsideUpdate) {
            var componentName = getComponentNameFromFiber(fiber);
            console.error("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.\n\nPlease update the following component: %s", componentName);
            didWarnUpdateInsideUpdate = !0;
        }
        if ((executionContext & RenderContext) !== NoContext) return componentName = updateQueue.pending, null === componentName ? update.next = update : (update.next = componentName.next, componentName.next = update), updateQueue.pending = update, update = getRootForUpdatedFiber(fiber), markUpdateLaneFromFiberToRoot(fiber, null, lane), update;
        enqueueUpdate$1(fiber, updateQueue, update, lane);
        return getRootForUpdatedFiber(fiber);
    }
    function entangleTransitions(root, fiber, lane) {
        fiber = fiber.updateQueue;
        if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
            var queueLanes = fiber.lanes;
            queueLanes &= root.pendingLanes;
            lane |= queueLanes;
            fiber.lanes = lane;
            markRootEntangled(root, lane);
        }
    }
    function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
        var queue = workInProgress.updateQueue, current = workInProgress.alternate;
        if (null !== current && (current = current.updateQueue, queue === current)) {
            var newFirst = null, newLast = null;
            queue = queue.firstBaseUpdate;
            if (null !== queue) {
                do {
                    var clone = {
                        lane: queue.lane,
                        tag: queue.tag,
                        payload: queue.payload,
                        callback: null,
                        next: null
                    };
                    null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                    queue = queue.next;
                }while (null !== queue);
                null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
            } else newFirst = newLast = capturedUpdate;
            queue = {
                baseState: current.baseState,
                firstBaseUpdate: newFirst,
                lastBaseUpdate: newLast,
                shared: current.shared,
                callbacks: current.callbacks
            };
            workInProgress.updateQueue = queue;
            return;
        }
        workInProgress = queue.lastBaseUpdate;
        null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
        queue.lastBaseUpdate = capturedUpdate;
    }
    function suspendIfUpdateReadFromEntangledAsyncAction() {
        if (didReadFromEntangledAsyncAction) {
            var entangledActionThenable = currentEntangledActionThenable;
            if (null !== entangledActionThenable) throw entangledActionThenable;
        }
    }
    function processUpdateQueue(workInProgress, props, instance$jscomp$0, renderLanes) {
        didReadFromEntangledAsyncAction = !1;
        var queue = workInProgress.updateQueue;
        hasForceUpdate = !1;
        currentlyProcessingQueue = queue.shared;
        var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
        if (null !== pendingQueue) {
            queue.shared.pending = null;
            var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
            lastPendingUpdate.next = null;
            null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
            lastBaseUpdate = lastPendingUpdate;
            var current = workInProgress.alternate;
            null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
        }
        if (null !== firstBaseUpdate) {
            var newState = queue.baseState;
            lastBaseUpdate = 0;
            current = firstPendingUpdate = lastPendingUpdate = null;
            pendingQueue = firstBaseUpdate;
            do {
                var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
                if (isHiddenUpdate ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                    0 !== updateLane && updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction = !0);
                    null !== current && (current = current.next = {
                        lane: 0,
                        tag: pendingQueue.tag,
                        payload: pendingQueue.payload,
                        callback: null,
                        next: null
                    });
                    a: {
                        updateLane = workInProgress;
                        var partialState = pendingQueue;
                        var nextProps = props, instance = instance$jscomp$0;
                        switch(partialState.tag){
                            case ReplaceState:
                                partialState = partialState.payload;
                                if ("function" === typeof partialState) {
                                    isDisallowedContextReadInDEV = !0;
                                    var nextState = partialState.call(instance, newState, nextProps);
                                    if (updateLane.mode & StrictLegacyMode) {
                                        setIsStrictModeForDevtools(!0);
                                        try {
                                            partialState.call(instance, newState, nextProps);
                                        } finally{
                                            setIsStrictModeForDevtools(!1);
                                        }
                                    }
                                    isDisallowedContextReadInDEV = !1;
                                    newState = nextState;
                                    break a;
                                }
                                newState = partialState;
                                break a;
                            case CaptureUpdate:
                                updateLane.flags = updateLane.flags & -65537 | 128;
                            case UpdateState:
                                nextState = partialState.payload;
                                if ("function" === typeof nextState) {
                                    isDisallowedContextReadInDEV = !0;
                                    partialState = nextState.call(instance, newState, nextProps);
                                    if (updateLane.mode & StrictLegacyMode) {
                                        setIsStrictModeForDevtools(!0);
                                        try {
                                            nextState.call(instance, newState, nextProps);
                                        } finally{
                                            setIsStrictModeForDevtools(!1);
                                        }
                                    }
                                    isDisallowedContextReadInDEV = !1;
                                } else partialState = nextState;
                                if (null === partialState || void 0 === partialState) break a;
                                newState = assign({}, newState, partialState);
                                break a;
                            case ForceUpdate:
                                hasForceUpdate = !0;
                        }
                    }
                    updateLane = pendingQueue.callback;
                    null !== updateLane && (workInProgress.flags |= 64, isHiddenUpdate && (workInProgress.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                        updateLane
                    ] : isHiddenUpdate.push(updateLane));
                } else isHiddenUpdate = {
                    lane: updateLane,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: pendingQueue.callback,
                    next: null
                }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
                pendingQueue = pendingQueue.next;
                if (null === pendingQueue) {
                    if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                    else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
                }
            }while (1);
            null === current && (lastPendingUpdate = newState);
            queue.baseState = lastPendingUpdate;
            queue.firstBaseUpdate = firstPendingUpdate;
            queue.lastBaseUpdate = current;
            null === firstBaseUpdate && (queue.shared.lanes = 0);
            workInProgressRootSkippedLanes |= lastBaseUpdate;
            workInProgress.lanes = lastBaseUpdate;
            workInProgress.memoizedState = newState;
        }
        currentlyProcessingQueue = null;
    }
    function callCallback(callback, context) {
        if ("function" !== typeof callback) throw Error("Invalid argument passed as callback. Expected a function. Instead received: " + callback);
        callback.call(context);
    }
    function commitHiddenCallbacks(updateQueue, context) {
        var hiddenCallbacks = updateQueue.shared.hiddenCallbacks;
        if (null !== hiddenCallbacks) for(updateQueue.shared.hiddenCallbacks = null, updateQueue = 0; updateQueue < hiddenCallbacks.length; updateQueue++)callCallback(hiddenCallbacks[updateQueue], context);
    }
    function commitCallbacks(updateQueue, context) {
        var callbacks = updateQueue.callbacks;
        if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)callCallback(callbacks[updateQueue], context);
    }
    function pushHiddenContext(fiber, context) {
        var prevEntangledRenderLanes = entangledRenderLanes;
        push(prevEntangledRenderLanesCursor, prevEntangledRenderLanes, fiber);
        push(currentTreeHiddenStackCursor, context, fiber);
        entangledRenderLanes = prevEntangledRenderLanes | context.baseLanes;
    }
    function reuseHiddenContextOnStack(fiber) {
        push(prevEntangledRenderLanesCursor, entangledRenderLanes, fiber);
        push(currentTreeHiddenStackCursor, currentTreeHiddenStackCursor.current, fiber);
    }
    function popHiddenContext(fiber) {
        entangledRenderLanes = prevEntangledRenderLanesCursor.current;
        pop(currentTreeHiddenStackCursor, fiber);
        pop(prevEntangledRenderLanesCursor, fiber);
    }
    function pushPrimaryTreeSuspenseHandler(handler) {
        var current = handler.alternate;
        push(suspenseStackCursor, suspenseStackCursor.current & SubtreeSuspenseContextMask, handler);
        push(suspenseHandlerStackCursor, handler, handler);
        null === shellBoundary && (null === current || null !== currentTreeHiddenStackCursor.current ? shellBoundary = handler : null !== current.memoizedState && (shellBoundary = handler));
    }
    function pushDehydratedActivitySuspenseHandler(fiber) {
        push(suspenseStackCursor, suspenseStackCursor.current, fiber);
        push(suspenseHandlerStackCursor, fiber, fiber);
        null === shellBoundary && (shellBoundary = fiber);
    }
    function pushOffscreenSuspenseHandler(fiber) {
        22 === fiber.tag ? (push(suspenseStackCursor, suspenseStackCursor.current, fiber), push(suspenseHandlerStackCursor, fiber, fiber), null === shellBoundary && (shellBoundary = fiber)) : reuseSuspenseHandlerOnStack(fiber);
    }
    function reuseSuspenseHandlerOnStack(fiber) {
        push(suspenseStackCursor, suspenseStackCursor.current, fiber);
        push(suspenseHandlerStackCursor, suspenseHandlerStackCursor.current, fiber);
    }
    function popSuspenseHandler(fiber) {
        pop(suspenseHandlerStackCursor, fiber);
        shellBoundary === fiber && (shellBoundary = null);
        pop(suspenseStackCursor, fiber);
    }
    function findFirstSuspended(row) {
        for(var node = row; null !== node;){
            if (13 === node.tag) {
                var state = node.memoizedState;
                if (null !== state && (state = state.dehydrated, null === state || isSuspenseInstancePending(state) || isSuspenseInstanceFallback(state))) return node;
            } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
                if (0 !== (node.flags & 128)) return node;
            } else if (null !== node.child) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === row) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === row) return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return null;
    }
    function mountHookTypesDev() {
        var hookName = currentHookNameInDev;
        null === hookTypesDev ? hookTypesDev = [
            hookName
        ] : hookTypesDev.push(hookName);
    }
    function updateHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (null !== hookTypesDev && (hookTypesUpdateIndexDev++, hookTypesDev[hookTypesUpdateIndexDev] !== hookName)) {
            var componentName = getComponentNameFromFiber(currentlyRenderingFiber);
            if (!didWarnAboutMismatchedHooksForComponent.has(componentName) && (didWarnAboutMismatchedHooksForComponent.add(componentName), null !== hookTypesDev)) {
                for(var table = "", i = 0; i <= hookTypesUpdateIndexDev; i++){
                    var oldHookName = hookTypesDev[i], newHookName = i === hookTypesUpdateIndexDev ? hookName : oldHookName;
                    for(oldHookName = i + 1 + ". " + oldHookName; 30 > oldHookName.length;)oldHookName += " ";
                    oldHookName += newHookName + "\n";
                    table += oldHookName;
                }
                console.error("React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://react.dev/link/rules-of-hooks\n\n   Previous render            Next render\n   ------------------------------------------------------\n%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n", componentName, table);
            }
        }
    }
    function checkDepsAreArrayDev(deps) {
        void 0 === deps || null === deps || isArrayImpl(deps) || console.error("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", currentHookNameInDev, typeof deps);
    }
    function warnOnUseFormStateInDev() {
        var componentName = getComponentNameFromFiber(currentlyRenderingFiber);
        didWarnAboutUseFormState.has(componentName) || (didWarnAboutUseFormState.add(componentName), console.error("ReactDOM.useFormState has been renamed to React.useActionState. Please update %s to use React.useActionState.", componentName));
    }
    function throwInvalidHookError() {
        throw Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.");
    }
    function areHookInputsEqual(nextDeps, prevDeps) {
        if (ignorePreviousDependencies) return !1;
        if (null === prevDeps) return console.error("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", currentHookNameInDev), !1;
        nextDeps.length !== prevDeps.length && console.error("The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s", currentHookNameInDev, "[" + prevDeps.join(", ") + "]", "[" + nextDeps.join(", ") + "]");
        for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!objectIs(nextDeps[i], prevDeps[i])) return !1;
        return !0;
    }
    function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
        renderLanes = nextRenderLanes;
        currentlyRenderingFiber = workInProgress;
        hookTypesDev = null !== current ? current._debugHookTypes : null;
        hookTypesUpdateIndexDev = -1;
        ignorePreviousDependencies = null !== current && current.type !== workInProgress.type;
        if ("[object AsyncFunction]" === Object.prototype.toString.call(Component) || "[object AsyncGeneratorFunction]" === Object.prototype.toString.call(Component)) nextRenderLanes = getComponentNameFromFiber(currentlyRenderingFiber), didWarnAboutAsyncClientComponent.has(nextRenderLanes) || (didWarnAboutAsyncClientComponent.add(nextRenderLanes), console.error("%s is an async Client Component. Only Server Components can be async at the moment. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server.", null === nextRenderLanes ? "An unknown Component" : "<" + nextRenderLanes + ">"));
        workInProgress.memoizedState = null;
        workInProgress.updateQueue = null;
        workInProgress.lanes = 0;
        ReactSharedInternals.H = null !== current && null !== current.memoizedState ? HooksDispatcherOnUpdateInDEV : null !== hookTypesDev ? HooksDispatcherOnMountWithHookTypesInDEV : HooksDispatcherOnMountInDEV;
        shouldDoubleInvokeUserFnsInHooksDEV = nextRenderLanes = (workInProgress.mode & StrictLegacyMode) !== NoMode;
        var children = callComponentInDEV(Component, props, secondArg);
        shouldDoubleInvokeUserFnsInHooksDEV = !1;
        didScheduleRenderPhaseUpdateDuringThisPass && (children = renderWithHooksAgain(workInProgress, Component, props, secondArg));
        if (nextRenderLanes) {
            setIsStrictModeForDevtools(!0);
            try {
                children = renderWithHooksAgain(workInProgress, Component, props, secondArg);
            } finally{
                setIsStrictModeForDevtools(!1);
            }
        }
        finishRenderingHooks(current, workInProgress);
        return children;
    }
    function finishRenderingHooks(current, workInProgress) {
        workInProgress._debugHookTypes = hookTypesDev;
        null === workInProgress.dependencies ? null !== thenableState && (workInProgress.dependencies = {
            lanes: 0,
            firstContext: null,
            _debugThenableState: thenableState
        }) : workInProgress.dependencies._debugThenableState = thenableState;
        ReactSharedInternals.H = ContextOnlyDispatcher;
        var didRenderTooFewHooks = null !== currentHook && null !== currentHook.next;
        renderLanes = 0;
        hookTypesDev = currentHookNameInDev = workInProgressHook = currentHook = currentlyRenderingFiber = null;
        hookTypesUpdateIndexDev = -1;
        null !== current && (current.flags & 65011712) !== (workInProgress.flags & 65011712) && console.error("Internal React error: Expected static flag was missing. Please notify the React team.");
        didScheduleRenderPhaseUpdate = !1;
        thenableIndexCounter = 0;
        thenableState = null;
        if (didRenderTooFewHooks) throw Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
        null === current || didReceiveUpdate || (current = current.dependencies, null !== current && checkIfContextChanged(current) && (didReceiveUpdate = !0));
        needsToResetSuspendedThenableDEV ? (needsToResetSuspendedThenableDEV = !1, current = !0) : current = !1;
        current && (workInProgress = getComponentNameFromFiber(workInProgress) || "Unknown", didWarnAboutUseWrappedInTryCatch.has(workInProgress) || didWarnAboutAsyncClientComponent.has(workInProgress) || (didWarnAboutUseWrappedInTryCatch.add(workInProgress), console.error("`use` was called from inside a try/catch block. This is not allowed and can lead to unexpected behavior. To handle errors triggered by `use`, wrap your component in a error boundary.")));
    }
    function renderWithHooksAgain(workInProgress, Component, props, secondArg) {
        currentlyRenderingFiber = workInProgress;
        var numberOfReRenders = 0;
        do {
            didScheduleRenderPhaseUpdateDuringThisPass && (thenableState = null);
            thenableIndexCounter = 0;
            didScheduleRenderPhaseUpdateDuringThisPass = !1;
            if (numberOfReRenders >= RE_RENDER_LIMIT) throw Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
            numberOfReRenders += 1;
            ignorePreviousDependencies = !1;
            workInProgressHook = currentHook = null;
            if (null != workInProgress.updateQueue) {
                var children = workInProgress.updateQueue;
                children.lastEffect = null;
                children.events = null;
                children.stores = null;
                null != children.memoCache && (children.memoCache.index = 0);
            }
            hookTypesUpdateIndexDev = -1;
            ReactSharedInternals.H = HooksDispatcherOnRerenderInDEV;
            children = callComponentInDEV(Component, props, secondArg);
        }while (didScheduleRenderPhaseUpdateDuringThisPass);
        return children;
    }
    function TransitionAwareHostComponent() {
        var dispatcher = ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
        maybeThenable = "function" === typeof maybeThenable.then ? useThenable(maybeThenable) : maybeThenable;
        dispatcher = dispatcher.useState()[0];
        (null !== currentHook ? currentHook.memoizedState : null) !== dispatcher && (currentlyRenderingFiber.flags |= 1024);
        return maybeThenable;
    }
    function checkDidRenderIdHook() {
        var didRenderIdHook = 0 !== localIdCounter;
        localIdCounter = 0;
        return didRenderIdHook;
    }
    function bailoutHooks(current, workInProgress, lanes) {
        workInProgress.updateQueue = current.updateQueue;
        workInProgress.flags = (workInProgress.mode & StrictEffectsMode) !== NoMode ? workInProgress.flags & -402655237 : workInProgress.flags & -2053;
        current.lanes &= ~lanes;
    }
    function resetHooksOnUnwind(workInProgress) {
        if (didScheduleRenderPhaseUpdate) {
            for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
                var queue = workInProgress.queue;
                null !== queue && (queue.pending = null);
                workInProgress = workInProgress.next;
            }
            didScheduleRenderPhaseUpdate = !1;
        }
        renderLanes = 0;
        hookTypesDev = workInProgressHook = currentHook = currentlyRenderingFiber = null;
        hookTypesUpdateIndexDev = -1;
        currentHookNameInDev = null;
        didScheduleRenderPhaseUpdateDuringThisPass = !1;
        thenableIndexCounter = localIdCounter = 0;
        thenableState = null;
    }
    function mountWorkInProgressHook() {
        var hook = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
        };
        null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = hook : workInProgressHook = workInProgressHook.next = hook;
        return workInProgressHook;
    }
    function updateWorkInProgressHook() {
        if (null === currentHook) {
            var nextCurrentHook = currentlyRenderingFiber.alternate;
            nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
        } else nextCurrentHook = currentHook.next;
        var nextWorkInProgressHook = null === workInProgressHook ? currentlyRenderingFiber.memoizedState : workInProgressHook.next;
        if (null !== nextWorkInProgressHook) workInProgressHook = nextWorkInProgressHook, currentHook = nextCurrentHook;
        else {
            if (null === nextCurrentHook) {
                if (null === currentlyRenderingFiber.alternate) throw Error("Update hook called on initial render. This is likely a bug in React. Please file an issue.");
                throw Error("Rendered more hooks than during the previous render.");
            }
            currentHook = nextCurrentHook;
            nextCurrentHook = {
                memoizedState: currentHook.memoizedState,
                baseState: currentHook.baseState,
                baseQueue: currentHook.baseQueue,
                queue: currentHook.queue,
                next: null
            };
            null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = nextCurrentHook : workInProgressHook = workInProgressHook.next = nextCurrentHook;
        }
        return workInProgressHook;
    }
    function createFunctionComponentUpdateQueue() {
        return {
            lastEffect: null,
            events: null,
            stores: null,
            memoCache: null
        };
    }
    function useThenable(thenable) {
        var index = thenableIndexCounter;
        thenableIndexCounter += 1;
        null === thenableState && (thenableState = createThenableState());
        thenable = trackUsedThenable(thenableState, thenable, index);
        index = currentlyRenderingFiber;
        null === (null === workInProgressHook ? index.memoizedState : workInProgressHook.next) && (index = index.alternate, ReactSharedInternals.H = null !== index && null !== index.memoizedState ? HooksDispatcherOnUpdateInDEV : HooksDispatcherOnMountInDEV);
        return thenable;
    }
    function use(usable) {
        if (null !== usable && "object" === typeof usable) {
            if ("function" === typeof usable.then) return useThenable(usable);
            if (usable.$$typeof === REACT_CONTEXT_TYPE) return readContext(usable);
        }
        throw Error("An unsupported type was passed to use(): " + String(usable));
    }
    function useMemoCache(size) {
        var memoCache = null, updateQueue = currentlyRenderingFiber.updateQueue;
        null !== updateQueue && (memoCache = updateQueue.memoCache);
        if (null == memoCache) {
            var current = currentlyRenderingFiber.alternate;
            null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
                data: current.data.map(function(array) {
                    return array.slice();
                }),
                index: 0
            })));
        }
        null == memoCache && (memoCache = {
            data: [],
            index: 0
        });
        null === updateQueue && (updateQueue = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = updateQueue);
        updateQueue.memoCache = memoCache;
        updateQueue = memoCache.data[memoCache.index];
        if (void 0 === updateQueue || ignorePreviousDependencies) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = REACT_MEMO_CACHE_SENTINEL;
        else updateQueue.length !== size && console.error("Expected a constant size argument for each invocation of useMemoCache. The previous cache was allocated with size %s but size %s was requested.", updateQueue.length, size);
        memoCache.index++;
        return updateQueue;
    }
    function basicStateReducer(state, action) {
        return "function" === typeof action ? action(state) : action;
    }
    function mountReducer(reducer, initialArg, init) {
        var hook = mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if (shouldDoubleInvokeUserFnsInHooksDEV) {
                setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = dispatchReducerAction.bind(null, currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    }
    function updateReducer(reducer) {
        var hook = updateWorkInProgressHook();
        return updateReducerImpl(hook, currentHook, reducer);
    }
    function updateReducerImpl(hook, current, reducer) {
        var queue = hook.queue;
        if (null === queue) throw Error("Should have a queue. You are likely calling Hooks conditionally, which is not allowed. (https://react.dev/link/invalid-hook-call)");
        queue.lastRenderedReducer = reducer;
        var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
        if (null !== pendingQueue) {
            if (null !== baseQueue) {
                var baseFirst = baseQueue.next;
                baseQueue.next = pendingQueue.next;
                pendingQueue.next = baseFirst;
            }
            current.baseQueue !== baseQueue && console.error("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React.");
            current.baseQueue = baseQueue = pendingQueue;
            queue.pending = null;
        }
        pendingQueue = hook.baseState;
        if (null === baseQueue) hook.memoizedState = pendingQueue;
        else {
            current = baseQueue.next;
            var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction = !1;
            do {
                var updateLane = update.lane & -536870913;
                if (updateLane !== update.lane ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                    var revertLane = update.revertLane;
                    if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                        lane: 0,
                        revertLane: 0,
                        gesture: null,
                        action: update.action,
                        hasEagerState: update.hasEagerState,
                        eagerState: update.eagerState,
                        next: null
                    }), updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction = !0);
                    else if ((renderLanes & revertLane) === revertLane) {
                        update = update.next;
                        revertLane === currentEntangledLane && (didReadFromEntangledAsyncAction = !0);
                        continue;
                    } else updateLane = {
                        lane: 0,
                        revertLane: update.revertLane,
                        gesture: null,
                        action: update.action,
                        hasEagerState: update.hasEagerState,
                        eagerState: update.eagerState,
                        next: null
                    }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, currentlyRenderingFiber.lanes |= revertLane, workInProgressRootSkippedLanes |= revertLane;
                    updateLane = update.action;
                    shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                    pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
                } else revertLane = {
                    lane: updateLane,
                    revertLane: update.revertLane,
                    gesture: update.gesture,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, currentlyRenderingFiber.lanes |= updateLane, workInProgressRootSkippedLanes |= updateLane;
                update = update.next;
            }while (null !== update && update !== current);
            null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
            if (!objectIs(pendingQueue, hook.memoizedState) && (didReceiveUpdate = !0, didReadFromEntangledAsyncAction && (reducer = currentEntangledActionThenable, null !== reducer))) throw reducer;
            hook.memoizedState = pendingQueue;
            hook.baseState = baseFirst;
            hook.baseQueue = newBaseQueueLast;
            queue.lastRenderedState = pendingQueue;
        }
        null === baseQueue && (queue.lanes = 0);
        return [
            hook.memoizedState,
            queue.dispatch
        ];
    }
    function rerenderReducer(reducer) {
        var hook = updateWorkInProgressHook(), queue = hook.queue;
        if (null === queue) throw Error("Should have a queue. You are likely calling Hooks conditionally, which is not allowed. (https://react.dev/link/invalid-hook-call)");
        queue.lastRenderedReducer = reducer;
        var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
        if (null !== lastRenderPhaseUpdate) {
            queue.pending = null;
            var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
            do newState = reducer(newState, update.action), update = update.next;
            while (update !== lastRenderPhaseUpdate);
            objectIs(newState, hook.memoizedState) || (didReceiveUpdate = !0);
            hook.memoizedState = newState;
            null === hook.baseQueue && (hook.baseState = newState);
            queue.lastRenderedState = newState;
        }
        return [
            newState,
            dispatch
        ];
    }
    function mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber, hook = mountWorkInProgressHook();
        if (isHydrating) {
            if (void 0 === getServerSnapshot) throw Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
            var nextSnapshot = getServerSnapshot();
            didWarnUncachedGetSnapshot || nextSnapshot === getServerSnapshot() || (console.error("The result of getServerSnapshot should be cached to avoid an infinite loop"), didWarnUncachedGetSnapshot = !0);
        } else {
            nextSnapshot = getSnapshot();
            didWarnUncachedGetSnapshot || (getServerSnapshot = getSnapshot(), objectIs(nextSnapshot, getServerSnapshot) || (console.error("The result of getSnapshot should be cached to avoid an infinite loop"), didWarnUncachedGetSnapshot = !0));
            if (null === workInProgressRoot) throw Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
            0 !== (workInProgressRootRenderLanes & 127) || pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
        }
        hook.memoizedState = nextSnapshot;
        getServerSnapshot = {
            value: nextSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = getServerSnapshot;
        mountEffect(subscribeToStore.bind(null, fiber, getServerSnapshot, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        pushSimpleEffect(HasEffect | Passive, {
            destroy: void 0
        }, updateStoreInstance.bind(null, fiber, getServerSnapshot, nextSnapshot, getSnapshot), null);
        return nextSnapshot;
    }
    function updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber, hook = updateWorkInProgressHook(), isHydrating$jscomp$0 = isHydrating;
        if (isHydrating$jscomp$0) {
            if (void 0 === getServerSnapshot) throw Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
            getServerSnapshot = getServerSnapshot();
        } else if (getServerSnapshot = getSnapshot(), !didWarnUncachedGetSnapshot) {
            var cachedSnapshot = getSnapshot();
            objectIs(getServerSnapshot, cachedSnapshot) || (console.error("The result of getSnapshot should be cached to avoid an infinite loop"), didWarnUncachedGetSnapshot = !0);
        }
        if (cachedSnapshot = !objectIs((currentHook || hook).memoizedState, getServerSnapshot)) hook.memoizedState = getServerSnapshot, didReceiveUpdate = !0;
        hook = hook.queue;
        var create = subscribeToStore.bind(null, fiber, hook, subscribe);
        updateEffectImpl(2048, Passive, create, [
            subscribe
        ]);
        if (hook.getSnapshot !== getSnapshot || cachedSnapshot || null !== workInProgressHook && workInProgressHook.memoizedState.tag & HasEffect) {
            fiber.flags |= 2048;
            pushSimpleEffect(HasEffect | Passive, {
                destroy: void 0
            }, updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
            if (null === workInProgressRoot) throw Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
            isHydrating$jscomp$0 || 0 !== (renderLanes & 127) || pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        return getServerSnapshot;
    }
    function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
        fiber.flags |= 16384;
        fiber = {
            getSnapshot: getSnapshot,
            value: renderedSnapshot
        };
        getSnapshot = currentlyRenderingFiber.updateQueue;
        null === getSnapshot ? (getSnapshot = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
            fiber
        ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
            fiber
        ] : renderedSnapshot.push(fiber));
    }
    function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
        inst.value = nextSnapshot;
        inst.getSnapshot = getSnapshot;
        checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
    }
    function subscribeToStore(fiber, inst, subscribe) {
        return subscribe(function() {
            checkIfSnapshotChanged(inst) && (startUpdateTimerByLane(2, "updateSyncExternalStore()", fiber), forceStoreRerender(fiber));
        });
    }
    function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        inst = inst.value;
        try {
            var nextValue = latestGetSnapshot();
            return !objectIs(inst, nextValue);
        } catch (error) {
            return !0;
        }
    }
    function forceStoreRerender(fiber) {
        var root = enqueueConcurrentRenderForLane(fiber, 2);
        null !== root && scheduleUpdateOnFiber(root, fiber, 2);
    }
    function mountStateImpl(initialState) {
        var hook = mountWorkInProgressHook();
        if ("function" === typeof initialState) {
            var initialStateInitializer = initialState;
            initialState = initialStateInitializer();
            if (shouldDoubleInvokeUserFnsInHooksDEV) {
                setIsStrictModeForDevtools(!0);
                try {
                    initialStateInitializer();
                } finally{
                    setIsStrictModeForDevtools(!1);
                }
            }
        }
        hook.memoizedState = hook.baseState = initialState;
        hook.queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: initialState
        };
        return hook;
    }
    function mountState(initialState) {
        initialState = mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = dispatchSetState.bind(null, currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    }
    function mountOptimistic(passthrough) {
        var hook = mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = dispatchOptimisticSetState.bind(null, currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    }
    function updateOptimistic(passthrough, reducer) {
        var hook = updateWorkInProgressHook();
        return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
    }
    function updateOptimisticImpl(hook, current, passthrough, reducer) {
        hook.baseState = passthrough;
        return updateReducerImpl(hook, currentHook, "function" === typeof reducer ? reducer : basicStateReducer);
    }
    function rerenderOptimistic(passthrough, reducer) {
        var hook = updateWorkInProgressHook();
        if (null !== currentHook) return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    }
    function dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
        if (isRenderPhaseUpdate(fiber)) throw Error("Cannot update form state while rendering.");
        fiber = actionQueue.action;
        if (null !== fiber) {
            var actionNode = {
                payload: payload,
                action: fiber,
                next: null,
                isTransition: !0,
                status: "pending",
                value: null,
                reason: null,
                listeners: [],
                then: function(listener) {
                    actionNode.listeners.push(listener);
                }
            };
            null !== ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
            setState(actionNode);
            setPendingState = actionQueue.pending;
            null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
        }
    }
    function runActionStateAction(actionQueue, node) {
        var action = node.action, payload = node.payload, prevState = actionQueue.state;
        if (node.isTransition) {
            var prevTransition = ReactSharedInternals.T, currentTransition = {};
            currentTransition._updatedFibers = new Set();
            ReactSharedInternals.T = currentTransition;
            try {
                var returnValue = action(prevState, payload), onStartTransitionFinish = ReactSharedInternals.S;
                null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
                handleActionReturnValue(actionQueue, node, returnValue);
            } catch (error) {
                onActionError(actionQueue, node, error);
            } finally{
                null !== prevTransition && null !== currentTransition.types && (null !== prevTransition.types && prevTransition.types !== currentTransition.types && console.error("We expected inner Transitions to have transferred the outer types set and that you cannot add to the outer Transition while inside the inner.This is a bug in React."), prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition, null === prevTransition && currentTransition._updatedFibers && (actionQueue = currentTransition._updatedFibers.size, currentTransition._updatedFibers.clear(), 10 < actionQueue && console.warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."));
            }
        } else try {
            currentTransition = action(prevState, payload), handleActionReturnValue(actionQueue, node, currentTransition);
        } catch (error$4) {
            onActionError(actionQueue, node, error$4);
        }
    }
    function handleActionReturnValue(actionQueue, node, returnValue) {
        null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? (ReactSharedInternals.asyncTransitions++, returnValue.then(releaseAsyncTransition, releaseAsyncTransition), returnValue.then(function(nextState) {
            onActionSuccess(actionQueue, node, nextState);
        }, function(error) {
            return onActionError(actionQueue, node, error);
        }), node.isTransition || console.error("An async function with useActionState was called outside of a transition. This is likely not what you intended (for example, isPending will not update correctly). Either call the returned function inside startTransition, or pass it to an `action` or `formAction` prop.")) : onActionSuccess(actionQueue, node, returnValue);
    }
    function onActionSuccess(actionQueue, actionNode, nextState) {
        actionNode.status = "fulfilled";
        actionNode.value = nextState;
        notifyActionListeners(actionNode);
        actionQueue.state = nextState;
        actionNode = actionQueue.pending;
        null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, runActionStateAction(actionQueue, nextState)));
    }
    function onActionError(actionQueue, actionNode, error) {
        var last = actionQueue.pending;
        actionQueue.pending = null;
        if (null !== last) {
            last = last.next;
            do actionNode.status = "rejected", actionNode.reason = error, notifyActionListeners(actionNode), actionNode = actionNode.next;
            while (actionNode !== last);
        }
        actionQueue.action = null;
    }
    function notifyActionListeners(actionNode) {
        actionNode = actionNode.listeners;
        for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
    }
    function actionStateReducer(oldState, newState) {
        return newState;
    }
    function mountActionState(action, initialStateProp) {
        if (isHydrating) {
            var ssrFormState = workInProgressRoot.formState;
            if (null !== ssrFormState) {
                a: {
                    var isMatching = currentlyRenderingFiber;
                    if (isHydrating) {
                        if (nextHydratableInstance) {
                            b: {
                                var markerInstance = nextHydratableInstance;
                                for(var inRootOrSingleton = rootOrSingletonContext; 8 !== markerInstance.nodeType;){
                                    if (!inRootOrSingleton) {
                                        markerInstance = null;
                                        break b;
                                    }
                                    markerInstance = getNextHydratable(markerInstance.nextSibling);
                                    if (null === markerInstance) {
                                        markerInstance = null;
                                        break b;
                                    }
                                }
                                inRootOrSingleton = markerInstance.data;
                                markerInstance = inRootOrSingleton === FORM_STATE_IS_MATCHING || inRootOrSingleton === FORM_STATE_IS_NOT_MATCHING ? markerInstance : null;
                            }
                            if (markerInstance) {
                                nextHydratableInstance = getNextHydratable(markerInstance.nextSibling);
                                isMatching = markerInstance.data === FORM_STATE_IS_MATCHING;
                                break a;
                            }
                        }
                        throwOnHydrationMismatch(isMatching);
                    }
                    isMatching = !1;
                }
                isMatching && (initialStateProp = ssrFormState[0]);
            }
        }
        ssrFormState = mountWorkInProgressHook();
        ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
        isMatching = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: actionStateReducer,
            lastRenderedState: initialStateProp
        };
        ssrFormState.queue = isMatching;
        ssrFormState = dispatchSetState.bind(null, currentlyRenderingFiber, isMatching);
        isMatching.dispatch = ssrFormState;
        isMatching = mountStateImpl(!1);
        inRootOrSingleton = dispatchOptimisticSetState.bind(null, currentlyRenderingFiber, !1, isMatching.queue);
        isMatching = mountWorkInProgressHook();
        markerInstance = {
            state: initialStateProp,
            dispatch: null,
            action: action,
            pending: null
        };
        isMatching.queue = markerInstance;
        ssrFormState = dispatchActionState.bind(null, currentlyRenderingFiber, markerInstance, inRootOrSingleton, ssrFormState);
        markerInstance.dispatch = ssrFormState;
        isMatching.memoizedState = action;
        return [
            initialStateProp,
            ssrFormState,
            !1
        ];
    }
    function updateActionState(action) {
        var stateHook = updateWorkInProgressHook();
        return updateActionStateImpl(stateHook, currentHook, action);
    }
    function updateActionStateImpl(stateHook, currentStateHook, action) {
        currentStateHook = updateReducerImpl(stateHook, currentStateHook, actionStateReducer)[0];
        stateHook = updateReducer(basicStateReducer)[0];
        if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
            var state = useThenable(currentStateHook);
        } catch (x) {
            if (x === SuspenseException) throw SuspenseActionException;
            throw x;
        }
        else state = currentStateHook;
        currentStateHook = updateWorkInProgressHook();
        var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
        action !== currentStateHook.memoizedState && (currentlyRenderingFiber.flags |= 2048, pushSimpleEffect(HasEffect | Passive, {
            destroy: void 0
        }, actionStateActionEffect.bind(null, actionQueue, action), null));
        return [
            state,
            dispatch,
            stateHook
        ];
    }
    function actionStateActionEffect(actionQueue, action) {
        actionQueue.action = action;
    }
    function rerenderActionState(action) {
        var stateHook = updateWorkInProgressHook(), currentStateHook = currentHook;
        if (null !== currentStateHook) return updateActionStateImpl(stateHook, currentStateHook, action);
        updateWorkInProgressHook();
        stateHook = stateHook.memoizedState;
        currentStateHook = updateWorkInProgressHook();
        var dispatch = currentStateHook.queue.dispatch;
        currentStateHook.memoizedState = action;
        return [
            stateHook,
            dispatch,
            !1
        ];
    }
    function pushSimpleEffect(tag, inst, create, deps) {
        tag = {
            tag: tag,
            create: create,
            deps: deps,
            inst: inst,
            next: null
        };
        inst = currentlyRenderingFiber.updateQueue;
        null === inst && (inst = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = inst);
        create = inst.lastEffect;
        null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
        return tag;
    }
    function mountRef(initialValue) {
        var hook = mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    }
    function mountEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = mountWorkInProgressHook();
        currentlyRenderingFiber.flags |= fiberFlags;
        hook.memoizedState = pushSimpleEffect(HasEffect | hookFlags, {
            destroy: void 0
        }, create, void 0 === deps ? null : deps);
    }
    function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = updateWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var inst = hook.memoizedState.inst;
        null !== currentHook && null !== deps && areHookInputsEqual(deps, currentHook.memoizedState.deps) ? hook.memoizedState = pushSimpleEffect(hookFlags, inst, create, deps) : (currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = pushSimpleEffect(HasEffect | hookFlags, inst, create, deps));
    }
    function mountEffect(create, deps) {
        (currentlyRenderingFiber.mode & StrictEffectsMode) !== NoMode ? mountEffectImpl(276826112, Passive, create, deps) : mountEffectImpl(8390656, Passive, create, deps);
    }
    function useEffectEventImpl(payload) {
        currentlyRenderingFiber.flags |= 4;
        var componentUpdateQueue = currentlyRenderingFiber.updateQueue;
        if (null === componentUpdateQueue) componentUpdateQueue = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
            payload
        ];
        else {
            var events = componentUpdateQueue.events;
            null === events ? componentUpdateQueue.events = [
                payload
            ] : events.push(payload);
        }
    }
    function mountEvent(callback) {
        var hook = mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if ((executionContext & RenderContext) !== NoContext) throw Error("A function wrapped in useEffectEvent can't be called during rendering.");
            return ref.impl.apply(void 0, arguments);
        };
    }
    function updateEvent(callback) {
        var ref = updateWorkInProgressHook().memoizedState;
        useEffectEventImpl({
            ref: ref,
            nextImpl: callback
        });
        return function() {
            if ((executionContext & RenderContext) !== NoContext) throw Error("A function wrapped in useEffectEvent can't be called during rendering.");
            return ref.impl.apply(void 0, arguments);
        };
    }
    function mountLayoutEffect(create, deps) {
        var fiberFlags = 4194308;
        (currentlyRenderingFiber.mode & StrictEffectsMode) !== NoMode && (fiberFlags |= 134217728);
        return mountEffectImpl(fiberFlags, Layout, create, deps);
    }
    function imperativeHandleEffect(create, ref) {
        if ("function" === typeof ref) {
            create = create();
            var refCleanup = ref(create);
            return function() {
                "function" === typeof refCleanup ? refCleanup() : ref(null);
            };
        }
        if (null !== ref && void 0 !== ref) return ref.hasOwnProperty("current") || console.error("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(ref).join(", ") + "}"), create = create(), ref.current = create, function() {
            ref.current = null;
        };
    }
    function mountImperativeHandle(ref, create, deps) {
        "function" !== typeof create && console.error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", null !== create ? typeof create : "null");
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        var fiberFlags = 4194308;
        (currentlyRenderingFiber.mode & StrictEffectsMode) !== NoMode && (fiberFlags |= 134217728);
        mountEffectImpl(fiberFlags, Layout, imperativeHandleEffect.bind(null, create, ref), deps);
    }
    function updateImperativeHandle(ref, create, deps) {
        "function" !== typeof create && console.error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", null !== create ? typeof create : "null");
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        updateEffectImpl(4, Layout, imperativeHandleEffect.bind(null, create, ref), deps);
    }
    function mountCallback(callback, deps) {
        mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    }
    function updateCallback(callback, deps) {
        var hook = updateWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var prevState = hook.memoizedState;
        if (null !== deps && areHookInputsEqual(deps, prevState[1])) return prevState[0];
        hook.memoizedState = [
            callback,
            deps
        ];
        return callback;
    }
    function mountMemo(nextCreate, deps) {
        var hook = mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if (shouldDoubleInvokeUserFnsInHooksDEV) {
            setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    }
    function updateMemo(nextCreate, deps) {
        var hook = updateWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var prevState = hook.memoizedState;
        if (null !== deps && areHookInputsEqual(deps, prevState[1])) return prevState[0];
        prevState = nextCreate();
        if (shouldDoubleInvokeUserFnsInHooksDEV) {
            setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            prevState,
            deps
        ];
        return prevState;
    }
    function mountDeferredValue(value, initialValue) {
        var hook = mountWorkInProgressHook();
        return mountDeferredValueImpl(hook, value, initialValue);
    }
    function updateDeferredValue(value, initialValue) {
        var hook = updateWorkInProgressHook();
        return updateDeferredValueImpl(hook, currentHook.memoizedState, value, initialValue);
    }
    function rerenderDeferredValue(value, initialValue) {
        var hook = updateWorkInProgressHook();
        return null === currentHook ? mountDeferredValueImpl(hook, value, initialValue) : updateDeferredValueImpl(hook, currentHook.memoizedState, value, initialValue);
    }
    function mountDeferredValueImpl(hook, value, initialValue) {
        if (void 0 === initialValue || 0 !== (renderLanes & 1073741824) && 0 === (workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
        hook.memoizedState = initialValue;
        hook = requestDeferredLane();
        currentlyRenderingFiber.lanes |= hook;
        workInProgressRootSkippedLanes |= hook;
        return initialValue;
    }
    function updateDeferredValueImpl(hook, prevValue, value, initialValue) {
        if (objectIs(value, prevValue)) return value;
        if (null !== currentTreeHiddenStackCursor.current) return hook = mountDeferredValueImpl(hook, value, initialValue), objectIs(hook, prevValue) || (didReceiveUpdate = !0), hook;
        if (0 === (renderLanes & 42) || 0 !== (renderLanes & 1073741824) && 0 === (workInProgressRootRenderLanes & 261930)) return didReceiveUpdate = !0, hook.memoizedState = value;
        hook = requestDeferredLane();
        currentlyRenderingFiber.lanes |= hook;
        workInProgressRootSkippedLanes |= hook;
        return prevValue;
    }
    function releaseAsyncTransition() {
        ReactSharedInternals.asyncTransitions--;
    }
    function startTransition(fiber, queue, pendingState, finishedState, callback) {
        var previousPriority = ReactDOMSharedInternals.p;
        ReactDOMSharedInternals.p = 0 !== previousPriority && previousPriority < ContinuousEventPriority ? previousPriority : ContinuousEventPriority;
        var prevTransition = ReactSharedInternals.T, currentTransition = {};
        currentTransition._updatedFibers = new Set();
        ReactSharedInternals.T = currentTransition;
        dispatchOptimisticSetState(fiber, !1, queue, pendingState);
        try {
            var returnValue = callback(), onStartTransitionFinish = ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
                ReactSharedInternals.asyncTransitions++;
                returnValue.then(releaseAsyncTransition, releaseAsyncTransition);
                var thenableForFinishedState = chainThenableValue(returnValue, finishedState);
                dispatchSetStateInternal(fiber, queue, thenableForFinishedState, requestUpdateLane(fiber));
            } else dispatchSetStateInternal(fiber, queue, finishedState, requestUpdateLane(fiber));
        } catch (error) {
            dispatchSetStateInternal(fiber, queue, {
                then: function() {},
                status: "rejected",
                reason: error
            }, requestUpdateLane(fiber));
        } finally{
            ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (null !== prevTransition.types && prevTransition.types !== currentTransition.types && console.error("We expected inner Transitions to have transferred the outer types set and that you cannot add to the outer Transition while inside the inner.This is a bug in React."), prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition, null === prevTransition && currentTransition._updatedFibers && (fiber = currentTransition._updatedFibers.size, currentTransition._updatedFibers.clear(), 10 < fiber && console.warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."));
        }
    }
    function startHostTransition(formFiber, pendingState, action, formData) {
        if (5 !== formFiber.tag) throw Error("Expected the form instance to be a HostComponent. This is a bug in React.");
        var queue = ensureFormComponentIsStateful(formFiber).queue;
        startHostActionTimer(formFiber);
        startTransition(formFiber, queue, pendingState, NotPendingTransition, null === action ? noop : function() {
            requestFormReset$1(formFiber);
            return action(formData);
        });
    }
    function ensureFormComponentIsStateful(formFiber) {
        var existingStateHook = formFiber.memoizedState;
        if (null !== existingStateHook) return existingStateHook;
        existingStateHook = {
            memoizedState: NotPendingTransition,
            baseState: NotPendingTransition,
            baseQueue: null,
            queue: {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: basicStateReducer,
                lastRenderedState: NotPendingTransition
            },
            next: null
        };
        var initialResetState = {};
        existingStateHook.next = {
            memoizedState: initialResetState,
            baseState: initialResetState,
            baseQueue: null,
            queue: {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: basicStateReducer,
                lastRenderedState: initialResetState
            },
            next: null
        };
        formFiber.memoizedState = existingStateHook;
        formFiber = formFiber.alternate;
        null !== formFiber && (formFiber.memoizedState = existingStateHook);
        return existingStateHook;
    }
    function requestFormReset$1(formFiber) {
        null === ReactSharedInternals.T && console.error("requestFormReset was called outside a transition or action. To fix, move to an action, or wrap with startTransition.");
        var stateHook = ensureFormComponentIsStateful(formFiber);
        null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
        dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, requestUpdateLane(formFiber));
    }
    function mountTransition() {
        var stateHook = mountStateImpl(!1);
        stateHook = startTransition.bind(null, currentlyRenderingFiber, stateHook.queue, !0, !1);
        mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    }
    function updateTransition() {
        var booleanOrThenable = updateReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
            start
        ];
    }
    function rerenderTransition() {
        var booleanOrThenable = rerenderReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
            start
        ];
    }
    function useHostTransitionStatus() {
        return readContext(HostTransitionContext);
    }
    function mountId() {
        var hook = mountWorkInProgressHook(), identifierPrefix = workInProgressRoot.identifierPrefix;
        if (isHydrating) {
            var treeId = treeContextOverflow;
            var idWithLeadingBit = treeContextId;
            treeId = (idWithLeadingBit & ~(1 << 32 - clz32(idWithLeadingBit) - 1)).toString(32) + treeId;
            identifierPrefix = "_" + identifierPrefix + "R_" + treeId;
            treeId = localIdCounter++;
            0 < treeId && (identifierPrefix += "H" + treeId.toString(32));
            identifierPrefix += "_";
        } else treeId = globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + treeId.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    }
    function mountRefresh() {
        return mountWorkInProgressHook().memoizedState = refreshCache.bind(null, currentlyRenderingFiber);
    }
    function refreshCache(fiber, seedKey) {
        for(var provider = fiber.return; null !== provider;){
            switch(provider.tag){
                case 24:
                case 3:
                    var lane = requestUpdateLane(provider), refreshUpdate = createUpdate(lane), root = enqueueUpdate(provider, refreshUpdate, lane);
                    null !== root && (startUpdateTimerByLane(lane, "refresh()", fiber), scheduleUpdateOnFiber(root, provider, lane), entangleTransitions(root, provider, lane));
                    fiber = createCache();
                    null !== seedKey && void 0 !== seedKey && null !== root && console.error("The seed argument is not enabled outside experimental channels.");
                    refreshUpdate.payload = {
                        cache: fiber
                    };
                    return;
            }
            provider = provider.return;
        }
    }
    function dispatchReducerAction(fiber, queue, action) {
        var args = arguments;
        "function" === typeof args[3] && console.error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        args = requestUpdateLane(fiber);
        var update = {
            lane: args,
            revertLane: 0,
            gesture: null,
            action: action,
            hasEagerState: !1,
            eagerState: null,
            next: null
        };
        isRenderPhaseUpdate(fiber) ? enqueueRenderPhaseUpdate(queue, update) : (update = enqueueConcurrentHookUpdate(fiber, queue, update, args), null !== update && (startUpdateTimerByLane(args, "dispatch()", fiber), scheduleUpdateOnFiber(update, fiber, args), entangleTransitionUpdate(update, queue, args)));
    }
    function dispatchSetState(fiber, queue, action) {
        var args = arguments;
        "function" === typeof args[3] && console.error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        args = requestUpdateLane(fiber);
        dispatchSetStateInternal(fiber, queue, action, args) && startUpdateTimerByLane(args, "setState()", fiber);
    }
    function dispatchSetStateInternal(fiber, queue, action, lane) {
        var update = {
            lane: lane,
            revertLane: 0,
            gesture: null,
            action: action,
            hasEagerState: !1,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
        else {
            var alternate = fiber.alternate;
            if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) {
                var prevDispatcher = ReactSharedInternals.H;
                ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
                try {
                    var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
                    update.hasEagerState = !0;
                    update.eagerState = eagerState;
                    if (objectIs(eagerState, currentState)) return enqueueUpdate$1(fiber, queue, update, 0), null === workInProgressRoot && finishQueueingConcurrentUpdates(), !1;
                } catch (error) {} finally{
                    ReactSharedInternals.H = prevDispatcher;
                }
            }
            action = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
            if (null !== action) return scheduleUpdateOnFiber(action, fiber, lane), entangleTransitionUpdate(action, queue, lane), !0;
        }
        return !1;
    }
    function dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
        null === ReactSharedInternals.T && 0 === currentEntangledLane && console.error("An optimistic state update occurred outside a transition or action. To fix, move the update to an action, or wrap with startTransition.");
        action = {
            lane: 2,
            revertLane: requestTransitionLane(),
            gesture: null,
            action: action,
            hasEagerState: !1,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) {
            if (throwIfDuringRender) throw Error("Cannot update optimistic state while rendering.");
            console.error("Cannot call startTransition while rendering.");
        } else throwIfDuringRender = enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && (startUpdateTimerByLane(2, "setOptimistic()", fiber), scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2));
    }
    function isRenderPhaseUpdate(fiber) {
        var alternate = fiber.alternate;
        return fiber === currentlyRenderingFiber || null !== alternate && alternate === currentlyRenderingFiber;
    }
    function enqueueRenderPhaseUpdate(queue, update) {
        didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = !0;
        var pending = queue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        queue.pending = update;
    }
    function entangleTransitionUpdate(root, queue, lane) {
        if (0 !== (lane & 4194048)) {
            var queueLanes = queue.lanes;
            queueLanes &= root.pendingLanes;
            lane |= queueLanes;
            queue.lanes = lane;
            markRootEntangled(root, lane);
        }
    }
    function warnOnInvalidCallback(callback) {
        if (null !== callback && "function" !== typeof callback) {
            var key = String(callback);
            didWarnOnInvalidCallback.has(key) || (didWarnOnInvalidCallback.add(key), console.error("Expected the last optional `callback` argument to be a function. Instead received: %s.", callback));
        }
    }
    function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
        var prevState = workInProgress.memoizedState, partialState = getDerivedStateFromProps(nextProps, prevState);
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(!0);
            try {
                partialState = getDerivedStateFromProps(nextProps, prevState);
            } finally{
                setIsStrictModeForDevtools(!1);
            }
        }
        void 0 === partialState && (ctor = getComponentNameFromType(ctor) || "Component", didWarnAboutUndefinedDerivedState.has(ctor) || (didWarnAboutUndefinedDerivedState.add(ctor), console.error("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", ctor)));
        prevState = null === partialState || void 0 === partialState ? prevState : assign({}, prevState, partialState);
        workInProgress.memoizedState = prevState;
        0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = prevState);
    }
    function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
        var instance = workInProgress.stateNode;
        if ("function" === typeof instance.shouldComponentUpdate) {
            oldProps = instance.shouldComponentUpdate(newProps, newState, nextContext);
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(!0);
                try {
                    oldProps = instance.shouldComponentUpdate(newProps, newState, nextContext);
                } finally{
                    setIsStrictModeForDevtools(!1);
                }
            }
            void 0 === oldProps && console.error("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", getComponentNameFromType(ctor) || "Component");
            return oldProps;
        }
        return ctor.prototype && ctor.prototype.isPureReactComponent ? !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState) : !0;
    }
    function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
        var oldState = instance.state;
        "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
        "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
        instance.state !== oldState && (workInProgress = getComponentNameFromFiber(workInProgress) || "Component", didWarnAboutStateAssignmentForComponent.has(workInProgress) || (didWarnAboutStateAssignmentForComponent.add(workInProgress), console.error("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", workInProgress)), classComponentUpdater.enqueueReplaceState(instance, instance.state, null));
    }
    function resolveClassComponentProps(Component, baseProps) {
        var newProps = baseProps;
        if ("ref" in baseProps) {
            newProps = {};
            for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
        }
        if (Component = Component.defaultProps) {
            newProps === baseProps && (newProps = assign({}, newProps));
            for(var _propName in Component)void 0 === newProps[_propName] && (newProps[_propName] = Component[_propName]);
        }
        return newProps;
    }
    function defaultOnUncaughtError(error) {
        reportGlobalError(error);
        console.warn("%s\n\n%s\n", componentName ? "An error occurred in the <" + componentName + "> component." : "An error occurred in one of your React components.", "Consider adding an error boundary to your tree to customize error handling behavior.\nVisit https://react.dev/link/error-boundaries to learn more about error boundaries.");
    }
    function defaultOnCaughtError(error) {
        var componentNameMessage = componentName ? "The above error occurred in the <" + componentName + "> component." : "The above error occurred in one of your React components.", recreateMessage = "React will try to recreate this component tree from scratch using the error boundary you provided, " + ((errorBoundaryName || "Anonymous") + ".");
        if ("object" === typeof error && null !== error && "string" === typeof error.environmentName) {
            var JSCompiler_inline_result = error.environmentName;
            error = [
                "%o\n\n%s\n\n%s\n",
                error,
                componentNameMessage,
                recreateMessage
            ].slice(0);
            "string" === typeof error[0] ? error.splice(0, 1, badgeFormat + " " + error[0], badgeStyle, pad + JSCompiler_inline_result + pad, resetStyle) : error.splice(0, 0, badgeFormat, badgeStyle, pad + JSCompiler_inline_result + pad, resetStyle);
            error.unshift(console);
            JSCompiler_inline_result = bind.apply(console.error, error);
            JSCompiler_inline_result();
        } else console.error("%o\n\n%s\n\n%s\n", error, componentNameMessage, recreateMessage);
    }
    function defaultOnRecoverableError(error) {
        reportGlobalError(error);
    }
    function logUncaughtError(root, errorInfo) {
        try {
            componentName = errorInfo.source ? getComponentNameFromFiber(errorInfo.source) : null;
            errorBoundaryName = null;
            var error = errorInfo.value;
            if (null !== ReactSharedInternals.actQueue) ReactSharedInternals.thrownErrors.push(error);
            else {
                var onUncaughtError = root.onUncaughtError;
                onUncaughtError(error, {
                    componentStack: errorInfo.stack
                });
            }
        } catch (e$5) {
            setTimeout(function() {
                throw e$5;
            });
        }
    }
    function logCaughtError(root, boundary, errorInfo) {
        try {
            componentName = errorInfo.source ? getComponentNameFromFiber(errorInfo.source) : null;
            errorBoundaryName = getComponentNameFromFiber(boundary);
            var onCaughtError = root.onCaughtError;
            onCaughtError(errorInfo.value, {
                componentStack: errorInfo.stack,
                errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
            });
        } catch (e$6) {
            setTimeout(function() {
                throw e$6;
            });
        }
    }
    function createRootErrorUpdate(root, errorInfo, lane) {
        lane = createUpdate(lane);
        lane.tag = CaptureUpdate;
        lane.payload = {
            element: null
        };
        lane.callback = function() {
            runWithFiberInDEV(errorInfo.source, logUncaughtError, root, errorInfo);
        };
        return lane;
    }
    function createClassErrorUpdate(lane) {
        lane = createUpdate(lane);
        lane.tag = CaptureUpdate;
        return lane;
    }
    function initializeClassErrorUpdate(update, root, fiber, errorInfo) {
        var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
        if ("function" === typeof getDerivedStateFromError) {
            var error = errorInfo.value;
            update.payload = function() {
                return getDerivedStateFromError(error);
            };
            update.callback = function() {
                markFailedErrorBoundaryForHotReloading(fiber);
                runWithFiberInDEV(errorInfo.source, logCaughtError, root, fiber, errorInfo);
            };
        }
        var inst = fiber.stateNode;
        null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
            markFailedErrorBoundaryForHotReloading(fiber);
            runWithFiberInDEV(errorInfo.source, logCaughtError, root, fiber, errorInfo);
            "function" !== typeof getDerivedStateFromError && (null === legacyErrorBoundariesThatAlreadyFailed ? legacyErrorBoundariesThatAlreadyFailed = new Set([
                this
            ]) : legacyErrorBoundariesThatAlreadyFailed.add(this));
            callComponentDidCatchInDEV(this, errorInfo);
            "function" === typeof getDerivedStateFromError || 0 === (fiber.lanes & 2) && console.error("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", getComponentNameFromFiber(fiber) || "Unknown");
        });
    }
    function throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
        sourceFiber.flags |= 32768;
        isDevToolsPresent && restorePendingUpdaters(root, rootRenderLanes);
        if (null !== value && "object" === typeof value && "function" === typeof value.then) {
            returnFiber = sourceFiber.alternate;
            null !== returnFiber && propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
            isHydrating && (didSuspendOrErrorDEV = !0);
            sourceFiber = suspenseHandlerStackCursor.current;
            if (null !== sourceFiber) {
                switch(sourceFiber.tag){
                    case 31:
                    case 13:
                        return null === shellBoundary ? renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && workInProgressRootExitStatus === RootInProgress && (workInProgressRootExitStatus = RootSuspended), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                            value
                        ]) : returnFiber.add(value), attachPingListener(root, value, rootRenderLanes)), !1;
                    case 22:
                        return sourceFiber.flags |= 65536, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                            transitions: null,
                            markerInstances: null,
                            retryQueue: new Set([
                                value
                            ])
                        }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                            value
                        ]) : sourceFiber.add(value)), attachPingListener(root, value, rootRenderLanes)), !1;
                }
                throw Error("Unexpected Suspense handler tag (" + sourceFiber.tag + "). This is a bug in React.");
            }
            attachPingListener(root, value, rootRenderLanes);
            renderDidSuspendDelayIfPossible();
            return !1;
        }
        if (isHydrating) return didSuspendOrErrorDEV = !0, returnFiber = suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== HydrationMismatchException && queueHydrationError(createCapturedValueAtFiber(Error("There was an error while hydrating but React was able to recover by instead client rendering from the nearest Suspense boundary.", {
            cause: value
        }), sourceFiber))) : (value !== HydrationMismatchException && queueHydrationError(createCapturedValueAtFiber(Error("There was an error while hydrating but React was able to recover by instead client rendering the entire root.", {
            cause: value
        }), sourceFiber)), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = createRootErrorUpdate(root.stateNode, value, rootRenderLanes), enqueueCapturedUpdate(root, rootRenderLanes), workInProgressRootExitStatus !== RootSuspendedWithDelay && (workInProgressRootExitStatus = RootErrored)), !1;
        var error = createCapturedValueAtFiber(Error("There was an error during concurrent rendering but React was able to recover by instead synchronously rendering the entire root.", {
            cause: value
        }), sourceFiber);
        null === workInProgressRootConcurrentErrors ? workInProgressRootConcurrentErrors = [
            error
        ] : workInProgressRootConcurrentErrors.push(error);
        workInProgressRootExitStatus !== RootSuspendedWithDelay && (workInProgressRootExitStatus = RootErrored);
        if (null === returnFiber) return !0;
        value = createCapturedValueAtFiber(value, sourceFiber);
        sourceFiber = returnFiber;
        do {
            switch(sourceFiber.tag){
                case 3:
                    return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = createRootErrorUpdate(sourceFiber.stateNode, value, root), enqueueCapturedUpdate(sourceFiber, root), !1;
                case 1:
                    if (returnFiber = sourceFiber.type, error = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== error && "function" === typeof error.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(error)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = createClassErrorUpdate(rootRenderLanes), initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
            }
            sourceFiber = sourceFiber.return;
        }while (null !== sourceFiber);
        return !1;
    }
    function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
        workInProgress.child = null === current ? mountChildFibers(workInProgress, null, nextChildren, renderLanes) : reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
    }
    function updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
        Component = Component.render;
        var ref = workInProgress.ref;
        if ("ref" in nextProps) {
            var propsWithoutRef = {};
            for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
        } else propsWithoutRef = nextProps;
        prepareToReadContext(workInProgress);
        nextProps = renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
        key = checkDidRenderIdHook();
        if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        isHydrating && key && pushMaterializedTreeId(workInProgress);
        workInProgress.flags |= 1;
        reconcileChildren(current, workInProgress, nextProps, renderLanes);
        return workInProgress.child;
    }
    function updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (null === current) {
            var type = Component.type;
            if ("function" === typeof type && !shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return Component = resolveFunctionForHotReloading(type), workInProgress.tag = 15, workInProgress.type = Component, validateFunctionComponentInDev(workInProgress, type), updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes);
            current = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
            current.ref = workInProgress.ref;
            current.return = workInProgress;
            return workInProgress.child = current;
        }
        type = current.child;
        if (!checkScheduledUpdateOrContext(current, renderLanes)) {
            var prevProps = type.memoizedProps;
            Component = Component.compare;
            Component = null !== Component ? Component : shallowEqual;
            if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        workInProgress.flags |= 1;
        current = createWorkInProgress(type, nextProps);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (null !== current) {
            var prevProps = current.memoizedProps;
            if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref && workInProgress.type === current.type) {
                if (didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && (didReceiveUpdate = !0);
                else return workInProgress.lanes = current.lanes, bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            }
        }
        return updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
    }
    function updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
        var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
        null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
            _visibility: OffscreenVisible,
            _pendingMarkers: null,
            _retryCache: null,
            _transitions: null
        });
        if ("hidden" === nextProps.mode) {
            if (0 !== (workInProgress.flags & 128)) {
                prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
                if (null !== current) {
                    nextProps = workInProgress.child = current.child;
                    for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                    nextProps = nextChildren & ~prevState;
                } else nextProps = 0, workInProgress.child = null;
                return deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
            }
            if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
                baseLanes: 0,
                cachePool: null
            }, null !== current && pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? pushHiddenContext(workInProgress, prevState) : reuseHiddenContextOnStack(workInProgress), pushOffscreenSuspenseHandler(workInProgress);
            else return nextProps = workInProgress.lanes = 536870912, deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
        } else null !== prevState ? (pushTransition(workInProgress, prevState.cachePool), pushHiddenContext(workInProgress, prevState), reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && pushTransition(workInProgress, null), reuseHiddenContextOnStack(workInProgress), reuseSuspenseHandlerOnStack(workInProgress));
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function bailoutOffscreenComponent(current, workInProgress) {
        null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
            _visibility: OffscreenVisible,
            _pendingMarkers: null,
            _retryCache: null,
            _transitions: null
        });
        return workInProgress.sibling;
    }
    function deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
        var JSCompiler_inline_result = peekCacheFromPool();
        JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
            parent: CacheContext._currentValue,
            pool: JSCompiler_inline_result
        };
        workInProgress.memoizedState = {
            baseLanes: nextBaseLanes,
            cachePool: JSCompiler_inline_result
        };
        null !== current && pushTransition(workInProgress, null);
        reuseHiddenContextOnStack(workInProgress);
        pushOffscreenSuspenseHandler(workInProgress);
        null !== current && propagateParentContextChanges(current, workInProgress, renderLanes, !0);
        workInProgress.childLanes = remainingChildLanes;
        return null;
    }
    function mountActivityChildren(workInProgress, nextProps) {
        var hiddenProp = nextProps.hidden;
        void 0 !== hiddenProp && console.error('<Activity> doesn\'t accept a hidden prop. Use mode="hidden" instead.\n- <Activity %s>\n+ <Activity %s>', !0 === hiddenProp ? "hidden" : !1 === hiddenProp ? "hidden={false}" : "hidden={...}", hiddenProp ? 'mode="hidden"' : 'mode="visible"');
        nextProps = mountWorkInProgressOffscreenFiber({
            mode: nextProps.mode,
            children: nextProps.children
        }, workInProgress.mode);
        nextProps.ref = workInProgress.ref;
        workInProgress.child = nextProps;
        nextProps.return = workInProgress;
        return nextProps;
    }
    function retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
        reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        current = mountActivityChildren(workInProgress, workInProgress.pendingProps);
        current.flags |= 2;
        popSuspenseHandler(workInProgress);
        workInProgress.memoizedState = null;
        return current;
    }
    function updateActivityComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
        workInProgress.flags &= -129;
        if (null === current) {
            if (isHydrating) {
                if ("hidden" === nextProps.mode) return current = mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, bailoutOffscreenComponent(null, current);
                pushDehydratedActivitySuspenseHandler(workInProgress);
                (current = nextHydratableInstance) ? (renderLanes = canHydrateHydrationBoundary(current, rootOrSingletonContext), renderLanes = null !== renderLanes && renderLanes.data === ACTIVITY_START_DATA ? renderLanes : null, null !== renderLanes && (nextProps = {
                    dehydrated: renderLanes,
                    treeContext: getSuspendedTreeContext(),
                    retryLane: 536870912,
                    hydrationErrors: null
                }, workInProgress.memoizedState = nextProps, nextProps = createFiberFromDehydratedFragment(renderLanes), nextProps.return = workInProgress, workInProgress.child = nextProps, hydrationParentFiber = workInProgress, nextHydratableInstance = null)) : renderLanes = null;
                if (null === renderLanes) throw warnNonHydratedInstance(workInProgress, current), throwOnHydrationMismatch(workInProgress);
                workInProgress.lanes = 536870912;
                return null;
            }
            return mountActivityChildren(workInProgress, nextProps);
        }
        var prevState = current.memoizedState;
        if (null !== prevState) {
            var activityInstance = prevState.dehydrated;
            pushDehydratedActivitySuspenseHandler(workInProgress);
            if (didSuspend) {
                if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
                else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
                else throw Error("Client rendering an Activity suspended it again. This is a bug in React.");
            } else if (warnIfHydrating(), 0 !== (renderLanes & 536870912) && markRenderDerivedCause(workInProgress), didReceiveUpdate || propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), didReceiveUpdate || didSuspend) {
                nextProps = workInProgressRoot;
                if (null !== nextProps && (activityInstance = getBumpedLaneForHydration(nextProps, renderLanes), 0 !== activityInstance && activityInstance !== prevState.retryLane)) throw prevState.retryLane = activityInstance, enqueueConcurrentRenderForLane(current, activityInstance), scheduleUpdateOnFiber(nextProps, current, activityInstance), SelectiveHydrationException;
                renderDidSuspendDelayIfPossible();
                workInProgress = retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            } else current = prevState.treeContext, nextHydratableInstance = getNextHydratable(activityInstance.nextSibling), hydrationParentFiber = workInProgress, isHydrating = !0, hydrationErrors = null, didSuspendOrErrorDEV = !1, hydrationDiffRootDEV = null, rootOrSingletonContext = !1, null !== current && restoreSuspendedTreeContext(workInProgress, current), workInProgress = mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
            return workInProgress;
        }
        prevState = current.child;
        nextProps = {
            mode: nextProps.mode,
            children: nextProps.children
        };
        0 !== (renderLanes & 536870912) && 0 !== (renderLanes & current.lanes) && markRenderDerivedCause(workInProgress);
        current = createWorkInProgress(prevState, nextProps);
        current.ref = workInProgress.ref;
        workInProgress.child = current;
        current.return = workInProgress;
        return current;
    }
    function markRef(current, workInProgress) {
        var ref = workInProgress.ref;
        if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
        else {
            if ("function" !== typeof ref && "object" !== typeof ref) throw Error("Expected ref to be a function, an object returned by React.createRef(), or undefined/null.");
            if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
        }
    }
    function updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (Component.prototype && "function" === typeof Component.prototype.render) {
            var componentName = getComponentNameFromType(Component) || "Unknown";
            didWarnAboutBadClass[componentName] || (console.error("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", componentName, componentName), didWarnAboutBadClass[componentName] = !0);
        }
        workInProgress.mode & StrictLegacyMode && ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, null);
        null === current && (validateFunctionComponentInDev(workInProgress, workInProgress.type), Component.contextTypes && (componentName = getComponentNameFromType(Component) || "Unknown", didWarnAboutContextTypes[componentName] || (didWarnAboutContextTypes[componentName] = !0, console.error("%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with React.useContext() instead. (https://react.dev/link/legacy-context)", componentName))));
        prepareToReadContext(workInProgress);
        Component = renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
        nextProps = checkDidRenderIdHook();
        if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        isHydrating && nextProps && pushMaterializedTreeId(workInProgress);
        workInProgress.flags |= 1;
        reconcileChildren(current, workInProgress, Component, renderLanes);
        return workInProgress.child;
    }
    function replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
        prepareToReadContext(workInProgress);
        hookTypesUpdateIndexDev = -1;
        ignorePreviousDependencies = null !== current && current.type !== workInProgress.type;
        workInProgress.updateQueue = null;
        nextProps = renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
        finishRenderingHooks(current, workInProgress);
        Component = checkDidRenderIdHook();
        if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        isHydrating && Component && pushMaterializedTreeId(workInProgress);
        workInProgress.flags |= 1;
        reconcileChildren(current, workInProgress, nextProps, renderLanes);
        return workInProgress.child;
    }
    function updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
        switch(shouldErrorImpl(workInProgress)){
            case !1:
                var _instance = workInProgress.stateNode, state = new workInProgress.type(workInProgress.memoizedProps, _instance.context).state;
                _instance.updater.enqueueSetState(_instance, state, null);
                break;
            case !0:
                workInProgress.flags |= 128;
                workInProgress.flags |= 65536;
                _instance = Error("Simulated error coming from DevTools");
                var lane = renderLanes & -renderLanes;
                workInProgress.lanes |= lane;
                state = workInProgressRoot;
                if (null === state) throw Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
                lane = createClassErrorUpdate(lane);
                initializeClassErrorUpdate(lane, state, workInProgress, createCapturedValueAtFiber(_instance, workInProgress));
                enqueueCapturedUpdate(workInProgress, lane);
        }
        prepareToReadContext(workInProgress);
        if (null === workInProgress.stateNode) {
            state = emptyContextObject;
            _instance = Component.contextType;
            "contextType" in Component && null !== _instance && (void 0 === _instance || _instance.$$typeof !== REACT_CONTEXT_TYPE) && !didWarnAboutInvalidateContextType.has(Component) && (didWarnAboutInvalidateContextType.add(Component), lane = void 0 === _instance ? " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : "object" !== typeof _instance ? " However, it is set to a " + typeof _instance + "." : _instance.$$typeof === REACT_CONSUMER_TYPE ? " Did you accidentally pass the Context.Consumer instead?" : " However, it is set to an object with keys {" + Object.keys(_instance).join(", ") + "}.", console.error("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", getComponentNameFromType(Component) || "Component", lane));
            "object" === typeof _instance && null !== _instance && (state = readContext(_instance));
            _instance = new Component(nextProps, state);
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(!0);
                try {
                    _instance = new Component(nextProps, state);
                } finally{
                    setIsStrictModeForDevtools(!1);
                }
            }
            state = workInProgress.memoizedState = null !== _instance.state && void 0 !== _instance.state ? _instance.state : null;
            _instance.updater = classComponentUpdater;
            workInProgress.stateNode = _instance;
            _instance._reactInternals = workInProgress;
            _instance._reactInternalInstance = fakeInternalInstance;
            "function" === typeof Component.getDerivedStateFromProps && null === state && (state = getComponentNameFromType(Component) || "Component", didWarnAboutUninitializedState.has(state) || (didWarnAboutUninitializedState.add(state), console.error("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", state, null === _instance.state ? "null" : "undefined", state)));
            if ("function" === typeof Component.getDerivedStateFromProps || "function" === typeof _instance.getSnapshotBeforeUpdate) {
                var foundWillUpdateName = lane = state = null;
                "function" === typeof _instance.componentWillMount && !0 !== _instance.componentWillMount.__suppressDeprecationWarning ? state = "componentWillMount" : "function" === typeof _instance.UNSAFE_componentWillMount && (state = "UNSAFE_componentWillMount");
                "function" === typeof _instance.componentWillReceiveProps && !0 !== _instance.componentWillReceiveProps.__suppressDeprecationWarning ? lane = "componentWillReceiveProps" : "function" === typeof _instance.UNSAFE_componentWillReceiveProps && (lane = "UNSAFE_componentWillReceiveProps");
                "function" === typeof _instance.componentWillUpdate && !0 !== _instance.componentWillUpdate.__suppressDeprecationWarning ? foundWillUpdateName = "componentWillUpdate" : "function" === typeof _instance.UNSAFE_componentWillUpdate && (foundWillUpdateName = "UNSAFE_componentWillUpdate");
                if (null !== state || null !== lane || null !== foundWillUpdateName) {
                    _instance = getComponentNameFromType(Component) || "Component";
                    var newApiName = "function" === typeof Component.getDerivedStateFromProps ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
                    didWarnAboutLegacyLifecyclesAndDerivedState.has(_instance) || (didWarnAboutLegacyLifecyclesAndDerivedState.add(_instance), console.error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://react.dev/link/unsafe-component-lifecycles", _instance, newApiName, null !== state ? "\n  " + state : "", null !== lane ? "\n  " + lane : "", null !== foundWillUpdateName ? "\n  " + foundWillUpdateName : ""));
                }
            }
            _instance = workInProgress.stateNode;
            state = getComponentNameFromType(Component) || "Component";
            _instance.render || (Component.prototype && "function" === typeof Component.prototype.render ? console.error("No `render` method found on the %s instance: did you accidentally return an object from the constructor?", state) : console.error("No `render` method found on the %s instance: you may have forgotten to define `render`.", state));
            !_instance.getInitialState || _instance.getInitialState.isReactClassApproved || _instance.state || console.error("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", state);
            _instance.getDefaultProps && !_instance.getDefaultProps.isReactClassApproved && console.error("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", state);
            _instance.contextType && console.error("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", state);
            Component.childContextTypes && !didWarnAboutChildContextTypes.has(Component) && (didWarnAboutChildContextTypes.add(Component), console.error("%s uses the legacy childContextTypes API which was removed in React 19. Use React.createContext() instead. (https://react.dev/link/legacy-context)", state));
            Component.contextTypes && !didWarnAboutContextTypes$1.has(Component) && (didWarnAboutContextTypes$1.add(Component), console.error("%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with static contextType instead. (https://react.dev/link/legacy-context)", state));
            "function" === typeof _instance.componentShouldUpdate && console.error("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", state);
            Component.prototype && Component.prototype.isPureReactComponent && "undefined" !== typeof _instance.shouldComponentUpdate && console.error("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", getComponentNameFromType(Component) || "A pure component");
            "function" === typeof _instance.componentDidUnmount && console.error("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", state);
            "function" === typeof _instance.componentDidReceiveProps && console.error("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", state);
            "function" === typeof _instance.componentWillRecieveProps && console.error("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", state);
            "function" === typeof _instance.UNSAFE_componentWillRecieveProps && console.error("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", state);
            lane = _instance.props !== nextProps;
            void 0 !== _instance.props && lane && console.error("When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", state);
            _instance.defaultProps && console.error("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", state, state);
            "function" !== typeof _instance.getSnapshotBeforeUpdate || "function" === typeof _instance.componentDidUpdate || didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(Component) || (didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(Component), console.error("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", getComponentNameFromType(Component)));
            "function" === typeof _instance.getDerivedStateFromProps && console.error("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", state);
            "function" === typeof _instance.getDerivedStateFromError && console.error("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", state);
            "function" === typeof Component.getSnapshotBeforeUpdate && console.error("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", state);
            (lane = _instance.state) && ("object" !== typeof lane || isArrayImpl(lane)) && console.error("%s.state: must be set to an object or null", state);
            "function" === typeof _instance.getChildContext && "object" !== typeof Component.childContextTypes && console.error("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", state);
            _instance = workInProgress.stateNode;
            _instance.props = nextProps;
            _instance.state = workInProgress.memoizedState;
            _instance.refs = {};
            initializeUpdateQueue(workInProgress);
            state = Component.contextType;
            _instance.context = "object" === typeof state && null !== state ? readContext(state) : emptyContextObject;
            _instance.state === nextProps && (state = getComponentNameFromType(Component) || "Component", didWarnAboutDirectlyAssigningPropsToState.has(state) || (didWarnAboutDirectlyAssigningPropsToState.add(state), console.error("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", state)));
            workInProgress.mode & StrictLegacyMode && ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, _instance);
            ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(workInProgress, _instance);
            _instance.state = workInProgress.memoizedState;
            state = Component.getDerivedStateFromProps;
            "function" === typeof state && (applyDerivedStateFromProps(workInProgress, Component, state, nextProps), _instance.state = workInProgress.memoizedState);
            "function" === typeof Component.getDerivedStateFromProps || "function" === typeof _instance.getSnapshotBeforeUpdate || "function" !== typeof _instance.UNSAFE_componentWillMount && "function" !== typeof _instance.componentWillMount || (state = _instance.state, "function" === typeof _instance.componentWillMount && _instance.componentWillMount(), "function" === typeof _instance.UNSAFE_componentWillMount && _instance.UNSAFE_componentWillMount(), state !== _instance.state && (console.error("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", getComponentNameFromFiber(workInProgress) || "Component"), classComponentUpdater.enqueueReplaceState(_instance, _instance.state, null)), processUpdateQueue(workInProgress, nextProps, _instance, renderLanes), suspendIfUpdateReadFromEntangledAsyncAction(), _instance.state = workInProgress.memoizedState);
            "function" === typeof _instance.componentDidMount && (workInProgress.flags |= 4194308);
            (workInProgress.mode & StrictEffectsMode) !== NoMode && (workInProgress.flags |= 134217728);
            _instance = !0;
        } else if (null === current) {
            _instance = workInProgress.stateNode;
            var unresolvedOldProps = workInProgress.memoizedProps;
            lane = resolveClassComponentProps(Component, unresolvedOldProps);
            _instance.props = lane;
            var oldContext = _instance.context;
            foundWillUpdateName = Component.contextType;
            state = emptyContextObject;
            "object" === typeof foundWillUpdateName && null !== foundWillUpdateName && (state = readContext(foundWillUpdateName));
            newApiName = Component.getDerivedStateFromProps;
            foundWillUpdateName = "function" === typeof newApiName || "function" === typeof _instance.getSnapshotBeforeUpdate;
            unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
            foundWillUpdateName || "function" !== typeof _instance.UNSAFE_componentWillReceiveProps && "function" !== typeof _instance.componentWillReceiveProps || (unresolvedOldProps || oldContext !== state) && callComponentWillReceiveProps(workInProgress, _instance, nextProps, state);
            hasForceUpdate = !1;
            var oldState = workInProgress.memoizedState;
            _instance.state = oldState;
            processUpdateQueue(workInProgress, nextProps, _instance, renderLanes);
            suspendIfUpdateReadFromEntangledAsyncAction();
            oldContext = workInProgress.memoizedState;
            unresolvedOldProps || oldState !== oldContext || hasForceUpdate ? ("function" === typeof newApiName && (applyDerivedStateFromProps(workInProgress, Component, newApiName, nextProps), oldContext = workInProgress.memoizedState), (lane = hasForceUpdate || checkShouldComponentUpdate(workInProgress, Component, lane, nextProps, oldState, oldContext, state)) ? (foundWillUpdateName || "function" !== typeof _instance.UNSAFE_componentWillMount && "function" !== typeof _instance.componentWillMount || ("function" === typeof _instance.componentWillMount && _instance.componentWillMount(), "function" === typeof _instance.UNSAFE_componentWillMount && _instance.UNSAFE_componentWillMount()), "function" === typeof _instance.componentDidMount && (workInProgress.flags |= 4194308), (workInProgress.mode & StrictEffectsMode) !== NoMode && (workInProgress.flags |= 134217728)) : ("function" === typeof _instance.componentDidMount && (workInProgress.flags |= 4194308), (workInProgress.mode & StrictEffectsMode) !== NoMode && (workInProgress.flags |= 134217728), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), _instance.props = nextProps, _instance.state = oldContext, _instance.context = state, _instance = lane) : ("function" === typeof _instance.componentDidMount && (workInProgress.flags |= 4194308), (workInProgress.mode & StrictEffectsMode) !== NoMode && (workInProgress.flags |= 134217728), _instance = !1);
        } else {
            _instance = workInProgress.stateNode;
            cloneUpdateQueue(current, workInProgress);
            state = workInProgress.memoizedProps;
            foundWillUpdateName = resolveClassComponentProps(Component, state);
            _instance.props = foundWillUpdateName;
            newApiName = workInProgress.pendingProps;
            oldState = _instance.context;
            oldContext = Component.contextType;
            lane = emptyContextObject;
            "object" === typeof oldContext && null !== oldContext && (lane = readContext(oldContext));
            unresolvedOldProps = Component.getDerivedStateFromProps;
            (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof _instance.getSnapshotBeforeUpdate) || "function" !== typeof _instance.UNSAFE_componentWillReceiveProps && "function" !== typeof _instance.componentWillReceiveProps || (state !== newApiName || oldState !== lane) && callComponentWillReceiveProps(workInProgress, _instance, nextProps, lane);
            hasForceUpdate = !1;
            oldState = workInProgress.memoizedState;
            _instance.state = oldState;
            processUpdateQueue(workInProgress, nextProps, _instance, renderLanes);
            suspendIfUpdateReadFromEntangledAsyncAction();
            var newState = workInProgress.memoizedState;
            state !== newApiName || oldState !== newState || hasForceUpdate || null !== current && null !== current.dependencies && checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && (applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (foundWillUpdateName = hasForceUpdate || checkShouldComponentUpdate(workInProgress, Component, foundWillUpdateName, nextProps, oldState, newState, lane) || null !== current && null !== current.dependencies && checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof _instance.UNSAFE_componentWillUpdate && "function" !== typeof _instance.componentWillUpdate || ("function" === typeof _instance.componentWillUpdate && _instance.componentWillUpdate(nextProps, newState, lane), "function" === typeof _instance.UNSAFE_componentWillUpdate && _instance.UNSAFE_componentWillUpdate(nextProps, newState, lane)), "function" === typeof _instance.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof _instance.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof _instance.componentDidUpdate || state === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof _instance.getSnapshotBeforeUpdate || state === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), _instance.props = nextProps, _instance.state = newState, _instance.context = lane, _instance = foundWillUpdateName) : ("function" !== typeof _instance.componentDidUpdate || state === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof _instance.getSnapshotBeforeUpdate || state === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), _instance = !1);
        }
        lane = _instance;
        markRef(current, workInProgress);
        state = 0 !== (workInProgress.flags & 128);
        if (lane || state) {
            lane = workInProgress.stateNode;
            setCurrentFiber(workInProgress);
            if (state && "function" !== typeof Component.getDerivedStateFromError) Component = null, profilerStartTime = -1;
            else if (Component = callRenderInDEV(lane), workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(!0);
                try {
                    callRenderInDEV(lane);
                } finally{
                    setIsStrictModeForDevtools(!1);
                }
            }
            workInProgress.flags |= 1;
            null !== current && state ? (workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = reconcileChildFibers(workInProgress, null, Component, renderLanes)) : reconcileChildren(current, workInProgress, Component, renderLanes);
            workInProgress.memoizedState = lane.state;
            current = workInProgress.child;
        } else current = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        renderLanes = workInProgress.stateNode;
        _instance && renderLanes.props !== nextProps && (didWarnAboutReassigningProps || console.error("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", getComponentNameFromFiber(workInProgress) || "a component"), didWarnAboutReassigningProps = !0);
        return current;
    }
    function mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
        resetHydrationState();
        workInProgress.flags |= 256;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function validateFunctionComponentInDev(workInProgress, Component) {
        Component && Component.childContextTypes && console.error("childContextTypes cannot be defined on a function component.\n  %s.childContextTypes = ...", Component.displayName || Component.name || "Component");
        "function" === typeof Component.getDerivedStateFromProps && (workInProgress = getComponentNameFromType(Component) || "Unknown", didWarnAboutGetDerivedStateOnFunctionComponent[workInProgress] || (console.error("%s: Function components do not support getDerivedStateFromProps.", workInProgress), didWarnAboutGetDerivedStateOnFunctionComponent[workInProgress] = !0));
        "object" === typeof Component.contextType && null !== Component.contextType && (Component = getComponentNameFromType(Component) || "Unknown", didWarnAboutContextTypeOnFunctionComponent[Component] || (console.error("%s: Function components do not support contextType.", Component), didWarnAboutContextTypeOnFunctionComponent[Component] = !0));
    }
    function mountSuspenseOffscreenState(renderLanes) {
        return {
            baseLanes: renderLanes,
            cachePool: getSuspendedCache()
        };
    }
    function getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
        current = null !== current ? current.childLanes & ~renderLanes : 0;
        primaryTreeDidDefer && (current |= workInProgressDeferredLane);
        return current;
    }
    function updateSuspenseComponent(current, workInProgress, renderLanes) {
        var JSCompiler_object_inline_digest_2724;
        var JSCompiler_object_inline_stack_2725 = workInProgress.pendingProps;
        shouldSuspendImpl(workInProgress) && (workInProgress.flags |= 128);
        var JSCompiler_object_inline_message_2723 = !1;
        var didSuspend = 0 !== (workInProgress.flags & 128);
        (JSCompiler_object_inline_digest_2724 = didSuspend) || (JSCompiler_object_inline_digest_2724 = null !== current && null === current.memoizedState ? !1 : 0 !== (suspenseStackCursor.current & ForceSuspenseFallback));
        JSCompiler_object_inline_digest_2724 && (JSCompiler_object_inline_message_2723 = !0, workInProgress.flags &= -129);
        JSCompiler_object_inline_digest_2724 = 0 !== (workInProgress.flags & 32);
        workInProgress.flags &= -33;
        if (null === current) {
            if (isHydrating) {
                JSCompiler_object_inline_message_2723 ? pushPrimaryTreeSuspenseHandler(workInProgress) : reuseSuspenseHandlerOnStack(workInProgress);
                (current = nextHydratableInstance) ? (renderLanes = canHydrateHydrationBoundary(current, rootOrSingletonContext), renderLanes = null !== renderLanes && renderLanes.data !== ACTIVITY_START_DATA ? renderLanes : null, null !== renderLanes && (JSCompiler_object_inline_digest_2724 = {
                    dehydrated: renderLanes,
                    treeContext: getSuspendedTreeContext(),
                    retryLane: 536870912,
                    hydrationErrors: null
                }, workInProgress.memoizedState = JSCompiler_object_inline_digest_2724, JSCompiler_object_inline_digest_2724 = createFiberFromDehydratedFragment(renderLanes), JSCompiler_object_inline_digest_2724.return = workInProgress, workInProgress.child = JSCompiler_object_inline_digest_2724, hydrationParentFiber = workInProgress, nextHydratableInstance = null)) : renderLanes = null;
                if (null === renderLanes) throw warnNonHydratedInstance(workInProgress, current), throwOnHydrationMismatch(workInProgress);
                isSuspenseInstanceFallback(renderLanes) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
                return null;
            }
            var nextPrimaryChildren = JSCompiler_object_inline_stack_2725.children;
            JSCompiler_object_inline_stack_2725 = JSCompiler_object_inline_stack_2725.fallback;
            if (JSCompiler_object_inline_message_2723) {
                reuseSuspenseHandlerOnStack(workInProgress);
                var mode = workInProgress.mode;
                nextPrimaryChildren = mountWorkInProgressOffscreenFiber({
                    mode: "hidden",
                    children: nextPrimaryChildren
                }, mode);
                JSCompiler_object_inline_stack_2725 = createFiberFromFragment(JSCompiler_object_inline_stack_2725, mode, renderLanes, null);
                nextPrimaryChildren.return = workInProgress;
                JSCompiler_object_inline_stack_2725.return = workInProgress;
                nextPrimaryChildren.sibling = JSCompiler_object_inline_stack_2725;
                workInProgress.child = nextPrimaryChildren;
                JSCompiler_object_inline_stack_2725 = workInProgress.child;
                JSCompiler_object_inline_stack_2725.memoizedState = mountSuspenseOffscreenState(renderLanes);
                JSCompiler_object_inline_stack_2725.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_object_inline_digest_2724, renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return bailoutOffscreenComponent(null, JSCompiler_object_inline_stack_2725);
            }
            pushPrimaryTreeSuspenseHandler(workInProgress);
            return mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
        }
        var prevState = current.memoizedState;
        if (null !== prevState) {
            var JSCompiler_object_inline_componentStack_2726 = prevState.dehydrated;
            if (null !== JSCompiler_object_inline_componentStack_2726) {
                if (didSuspend) workInProgress.flags & 256 ? (pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? (reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : (reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = JSCompiler_object_inline_stack_2725.fallback, mode = workInProgress.mode, JSCompiler_object_inline_stack_2725 = mountWorkInProgressOffscreenFiber({
                    mode: "visible",
                    children: JSCompiler_object_inline_stack_2725.children
                }, mode), nextPrimaryChildren = createFiberFromFragment(nextPrimaryChildren, mode, renderLanes, null), nextPrimaryChildren.flags |= 2, JSCompiler_object_inline_stack_2725.return = workInProgress, nextPrimaryChildren.return = workInProgress, JSCompiler_object_inline_stack_2725.sibling = nextPrimaryChildren, workInProgress.child = JSCompiler_object_inline_stack_2725, reconcileChildFibers(workInProgress, current.child, null, renderLanes), JSCompiler_object_inline_stack_2725 = workInProgress.child, JSCompiler_object_inline_stack_2725.memoizedState = mountSuspenseOffscreenState(renderLanes), JSCompiler_object_inline_stack_2725.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_object_inline_digest_2724, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, workInProgress = bailoutOffscreenComponent(null, JSCompiler_object_inline_stack_2725));
                else if (pushPrimaryTreeSuspenseHandler(workInProgress), warnIfHydrating(), 0 !== (renderLanes & 536870912) && markRenderDerivedCause(workInProgress), isSuspenseInstanceFallback(JSCompiler_object_inline_componentStack_2726)) {
                    JSCompiler_object_inline_digest_2724 = JSCompiler_object_inline_componentStack_2726.nextSibling && JSCompiler_object_inline_componentStack_2726.nextSibling.dataset;
                    if (JSCompiler_object_inline_digest_2724) {
                        nextPrimaryChildren = JSCompiler_object_inline_digest_2724.dgst;
                        var message = JSCompiler_object_inline_digest_2724.msg;
                        mode = JSCompiler_object_inline_digest_2724.stck;
                        var componentStack = JSCompiler_object_inline_digest_2724.cstck;
                    }
                    JSCompiler_object_inline_message_2723 = message;
                    JSCompiler_object_inline_digest_2724 = nextPrimaryChildren;
                    JSCompiler_object_inline_stack_2725 = mode;
                    JSCompiler_object_inline_componentStack_2726 = componentStack;
                    nextPrimaryChildren = JSCompiler_object_inline_message_2723;
                    mode = JSCompiler_object_inline_componentStack_2726;
                    nextPrimaryChildren = nextPrimaryChildren ? Error(nextPrimaryChildren) : Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
                    nextPrimaryChildren.stack = JSCompiler_object_inline_stack_2725 || "";
                    nextPrimaryChildren.digest = JSCompiler_object_inline_digest_2724;
                    JSCompiler_object_inline_digest_2724 = void 0 === mode ? null : mode;
                    JSCompiler_object_inline_stack_2725 = {
                        value: nextPrimaryChildren,
                        source: null,
                        stack: JSCompiler_object_inline_digest_2724
                    };
                    "string" === typeof JSCompiler_object_inline_digest_2724 && CapturedStacks.set(nextPrimaryChildren, JSCompiler_object_inline_stack_2725);
                    queueHydrationError(JSCompiler_object_inline_stack_2725);
                    workInProgress = retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
                } else if (didReceiveUpdate || propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_object_inline_digest_2724 = 0 !== (renderLanes & current.childLanes), didReceiveUpdate || JSCompiler_object_inline_digest_2724) {
                    JSCompiler_object_inline_digest_2724 = workInProgressRoot;
                    if (null !== JSCompiler_object_inline_digest_2724 && (JSCompiler_object_inline_stack_2725 = getBumpedLaneForHydration(JSCompiler_object_inline_digest_2724, renderLanes), 0 !== JSCompiler_object_inline_stack_2725 && JSCompiler_object_inline_stack_2725 !== prevState.retryLane)) throw prevState.retryLane = JSCompiler_object_inline_stack_2725, enqueueConcurrentRenderForLane(current, JSCompiler_object_inline_stack_2725), scheduleUpdateOnFiber(JSCompiler_object_inline_digest_2724, current, JSCompiler_object_inline_stack_2725), SelectiveHydrationException;
                    isSuspenseInstancePending(JSCompiler_object_inline_componentStack_2726) || renderDidSuspendDelayIfPossible();
                    workInProgress = retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
                } else isSuspenseInstancePending(JSCompiler_object_inline_componentStack_2726) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, nextHydratableInstance = getNextHydratable(JSCompiler_object_inline_componentStack_2726.nextSibling), hydrationParentFiber = workInProgress, isHydrating = !0, hydrationErrors = null, didSuspendOrErrorDEV = !1, hydrationDiffRootDEV = null, rootOrSingletonContext = !1, null !== current && restoreSuspendedTreeContext(workInProgress, current), workInProgress = mountSuspensePrimaryChildren(workInProgress, JSCompiler_object_inline_stack_2725.children), workInProgress.flags |= 4096);
                return workInProgress;
            }
        }
        if (JSCompiler_object_inline_message_2723) return reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = JSCompiler_object_inline_stack_2725.fallback, mode = workInProgress.mode, componentStack = current.child, JSCompiler_object_inline_componentStack_2726 = componentStack.sibling, JSCompiler_object_inline_stack_2725 = createWorkInProgress(componentStack, {
            mode: "hidden",
            children: JSCompiler_object_inline_stack_2725.children
        }), JSCompiler_object_inline_stack_2725.subtreeFlags = componentStack.subtreeFlags & 65011712, null !== JSCompiler_object_inline_componentStack_2726 ? nextPrimaryChildren = createWorkInProgress(JSCompiler_object_inline_componentStack_2726, nextPrimaryChildren) : (nextPrimaryChildren = createFiberFromFragment(nextPrimaryChildren, mode, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, JSCompiler_object_inline_stack_2725.return = workInProgress, JSCompiler_object_inline_stack_2725.sibling = nextPrimaryChildren, workInProgress.child = JSCompiler_object_inline_stack_2725, bailoutOffscreenComponent(null, JSCompiler_object_inline_stack_2725), JSCompiler_object_inline_stack_2725 = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = mountSuspenseOffscreenState(renderLanes) : (mode = nextPrimaryChildren.cachePool, null !== mode ? (componentStack = CacheContext._currentValue, mode = mode.parent !== componentStack ? {
            parent: componentStack,
            pool: componentStack
        } : mode) : mode = getSuspendedCache(), nextPrimaryChildren = {
            baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
            cachePool: mode
        }), JSCompiler_object_inline_stack_2725.memoizedState = nextPrimaryChildren, JSCompiler_object_inline_stack_2725.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_object_inline_digest_2724, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, bailoutOffscreenComponent(current.child, JSCompiler_object_inline_stack_2725);
        null !== prevState && (renderLanes & 62914560) === renderLanes && 0 !== (renderLanes & current.lanes) && markRenderDerivedCause(workInProgress);
        pushPrimaryTreeSuspenseHandler(workInProgress);
        renderLanes = current.child;
        current = renderLanes.sibling;
        renderLanes = createWorkInProgress(renderLanes, {
            mode: "visible",
            children: JSCompiler_object_inline_stack_2725.children
        });
        renderLanes.return = workInProgress;
        renderLanes.sibling = null;
        null !== current && (JSCompiler_object_inline_digest_2724 = workInProgress.deletions, null === JSCompiler_object_inline_digest_2724 ? (workInProgress.deletions = [
            current
        ], workInProgress.flags |= 16) : JSCompiler_object_inline_digest_2724.push(current));
        workInProgress.child = renderLanes;
        workInProgress.memoizedState = null;
        return renderLanes;
    }
    function mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
        primaryChildren = mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: primaryChildren
        }, workInProgress.mode);
        primaryChildren.return = workInProgress;
        return workInProgress.child = primaryChildren;
    }
    function mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
        offscreenProps = createFiber(22, offscreenProps, null, mode);
        offscreenProps.lanes = 0;
        return offscreenProps;
    }
    function retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
        reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        current = mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
        current.flags |= 2;
        workInProgress.memoizedState = null;
        return current;
    }
    function scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
        fiber.lanes |= renderLanes;
        var alternate = fiber.alternate;
        null !== alternate && (alternate.lanes |= renderLanes);
        scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
    }
    function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
        var renderState = workInProgress.memoizedState;
        null === renderState ? workInProgress.memoizedState = {
            isBackwards: isBackwards,
            rendering: null,
            renderingStartTime: 0,
            last: lastContentRow,
            tail: tail,
            tailMode: tailMode,
            treeForkCount: treeForkCount
        } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
    }
    function updateSuspenseListComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail, newChildren = nextProps.children, suspenseContext = suspenseStackCursor.current;
        (nextProps = 0 !== (suspenseContext & ForceSuspenseFallback)) ? (suspenseContext = suspenseContext & SubtreeSuspenseContextMask | ForceSuspenseFallback, workInProgress.flags |= 128) : suspenseContext &= SubtreeSuspenseContextMask;
        push(suspenseStackCursor, suspenseContext, workInProgress);
        suspenseContext = null == revealOrder ? "null" : revealOrder;
        if ("forwards" !== revealOrder && "unstable_legacy-backwards" !== revealOrder && "together" !== revealOrder && "independent" !== revealOrder && !didWarnAboutRevealOrder[suspenseContext]) {
            if (didWarnAboutRevealOrder[suspenseContext] = !0, null == revealOrder) console.error('The default for the <SuspenseList revealOrder="..."> prop is changing. To be future compatible you must explictly specify either "independent" (the current default), "together", "forwards" or "legacy_unstable-backwards".');
            else if ("backwards" === revealOrder) console.error('The rendering order of <SuspenseList revealOrder="backwards"> is changing. To be future compatible you must specify revealOrder="legacy_unstable-backwards" instead.');
            else if ("string" === typeof revealOrder) switch(revealOrder.toLowerCase()){
                case "together":
                case "forwards":
                case "backwards":
                case "independent":
                    console.error('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                case "forward":
                case "backward":
                    console.error('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                default:
                    console.error('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "independent", "together", "forwards" or "backwards"?', revealOrder);
            }
            else console.error('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "independent", "together", "forwards" or "backwards"?', revealOrder);
        }
        suspenseContext = null == tailMode ? "null" : tailMode;
        if (!didWarnAboutTailOptions[suspenseContext]) {
            if (null == tailMode) {
                if ("forwards" === revealOrder || "backwards" === revealOrder || "unstable_legacy-backwards" === revealOrder) didWarnAboutTailOptions[suspenseContext] = !0, console.error('The default for the <SuspenseList tail="..."> prop is changing. To be future compatible you must explictly specify either "visible" (the current default), "collapsed" or "hidden".');
            } else "visible" !== tailMode && "collapsed" !== tailMode && "hidden" !== tailMode ? (didWarnAboutTailOptions[suspenseContext] = !0, console.error('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "visible", "collapsed" or "hidden"?', tailMode)) : "forwards" !== revealOrder && "backwards" !== revealOrder && "unstable_legacy-backwards" !== revealOrder && (didWarnAboutTailOptions[suspenseContext] = !0, console.error('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', tailMode));
        }
        a: if (("forwards" === revealOrder || "backwards" === revealOrder || "unstable_legacy-backwards" === revealOrder) && void 0 !== newChildren && null !== newChildren && !1 !== newChildren) {
            if (isArrayImpl(newChildren)) for(suspenseContext = 0; suspenseContext < newChildren.length; suspenseContext++){
                if (!validateSuspenseListNestedChild(newChildren[suspenseContext], suspenseContext)) break a;
            }
            else if (suspenseContext = getIteratorFn(newChildren), "function" === typeof suspenseContext) {
                if (suspenseContext = suspenseContext.call(newChildren)) for(var step = suspenseContext.next(), _i = 0; !step.done; step = suspenseContext.next()){
                    if (!validateSuspenseListNestedChild(step.value, _i)) break a;
                    _i++;
                }
            } else console.error('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', revealOrder);
        }
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        isHydrating ? (warnIfNotHydrating(), newChildren = treeForkCount) : newChildren = 0;
        if (!nextProps && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        switch(revealOrder){
            case "forwards":
                renderLanes = workInProgress.child;
                for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
                renderLanes = revealOrder;
                null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
                initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, newChildren);
                break;
            case "backwards":
            case "unstable_legacy-backwards":
                renderLanes = null;
                revealOrder = workInProgress.child;
                for(workInProgress.child = null; null !== revealOrder;){
                    current = revealOrder.alternate;
                    if (null !== current && null === findFirstSuspended(current)) {
                        workInProgress.child = revealOrder;
                        break;
                    }
                    current = revealOrder.sibling;
                    revealOrder.sibling = renderLanes;
                    renderLanes = revealOrder;
                    revealOrder = current;
                }
                initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, newChildren);
                break;
            case "together":
                initSuspenseListRenderState(workInProgress, !1, null, null, void 0, newChildren);
                break;
            default:
                workInProgress.memoizedState = null;
        }
        return workInProgress.child;
    }
    function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
        null !== current && (workInProgress.dependencies = current.dependencies);
        profilerStartTime = -1;
        workInProgressRootSkippedLanes |= workInProgress.lanes;
        if (0 === (renderLanes & workInProgress.childLanes)) {
            if (null !== current) {
                if (propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
            } else return null;
        }
        if (null !== current && workInProgress.child !== current.child) throw Error("Resuming work not yet implemented.");
        if (null !== workInProgress.child) {
            current = workInProgress.child;
            renderLanes = createWorkInProgress(current, current.pendingProps);
            workInProgress.child = renderLanes;
            for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
            renderLanes.sibling = null;
        }
        return workInProgress.child;
    }
    function checkScheduledUpdateOrContext(current, renderLanes) {
        if (0 !== (current.lanes & renderLanes)) return !0;
        current = current.dependencies;
        return null !== current && checkIfContextChanged(current) ? !0 : !1;
    }
    function attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
        switch(workInProgress.tag){
            case 3:
                pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                pushProvider(workInProgress, CacheContext, current.memoizedState.cache);
                resetHydrationState();
                break;
            case 27:
            case 5:
                pushHostContext(workInProgress);
                break;
            case 4:
                pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                break;
            case 10:
                pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
                break;
            case 12:
                0 !== (renderLanes & workInProgress.childLanes) && (workInProgress.flags |= 4);
                workInProgress.flags |= 2048;
                var stateNode = workInProgress.stateNode;
                stateNode.effectDuration = -0;
                stateNode.passiveEffectDuration = -0;
                break;
            case 31:
                if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, pushDehydratedActivitySuspenseHandler(workInProgress), null;
                break;
            case 13:
                stateNode = workInProgress.memoizedState;
                if (null !== stateNode) {
                    if (null !== stateNode.dehydrated) return pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                    if (0 !== (renderLanes & workInProgress.child.childLanes)) return updateSuspenseComponent(current, workInProgress, renderLanes);
                    pushPrimaryTreeSuspenseHandler(workInProgress);
                    current = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                    return null !== current ? current.sibling : null;
                }
                pushPrimaryTreeSuspenseHandler(workInProgress);
                break;
            case 19:
                var didSuspendBefore = 0 !== (current.flags & 128);
                stateNode = 0 !== (renderLanes & workInProgress.childLanes);
                stateNode || (propagateParentContextChanges(current, workInProgress, renderLanes, !1), stateNode = 0 !== (renderLanes & workInProgress.childLanes));
                if (didSuspendBefore) {
                    if (stateNode) return updateSuspenseListComponent(current, workInProgress, renderLanes);
                    workInProgress.flags |= 128;
                }
                didSuspendBefore = workInProgress.memoizedState;
                null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
                push(suspenseStackCursor, suspenseStackCursor.current, workInProgress);
                if (stateNode) break;
                else return null;
            case 22:
                return workInProgress.lanes = 0, updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
            case 24:
                pushProvider(workInProgress, CacheContext, current.memoizedState.cache);
        }
        return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    function beginWork(current, workInProgress, renderLanes) {
        if (workInProgress._debugNeedsRemount && null !== current) {
            renderLanes = createFiberFromTypeAndProps(workInProgress.type, workInProgress.key, workInProgress.pendingProps, workInProgress._debugOwner || null, workInProgress.mode, workInProgress.lanes);
            renderLanes._debugStack = workInProgress._debugStack;
            renderLanes._debugTask = workInProgress._debugTask;
            var returnFiber = workInProgress.return;
            if (null === returnFiber) throw Error("Cannot swap the root fiber.");
            current.alternate = null;
            workInProgress.alternate = null;
            renderLanes.index = workInProgress.index;
            renderLanes.sibling = workInProgress.sibling;
            renderLanes.return = workInProgress.return;
            renderLanes.ref = workInProgress.ref;
            renderLanes._debugInfo = workInProgress._debugInfo;
            if (workInProgress === returnFiber.child) returnFiber.child = renderLanes;
            else {
                var prevSibling = returnFiber.child;
                if (null === prevSibling) throw Error("Expected parent to have a child.");
                for(; prevSibling.sibling !== workInProgress;)if (prevSibling = prevSibling.sibling, null === prevSibling) throw Error("Expected to find the previous sibling.");
                prevSibling.sibling = renderLanes;
            }
            workInProgress = returnFiber.deletions;
            null === workInProgress ? (returnFiber.deletions = [
                current
            ], returnFiber.flags |= 16) : workInProgress.push(current);
            renderLanes.flags |= 2;
            return renderLanes;
        }
        if (null !== current) {
            if (current.memoizedProps !== workInProgress.pendingProps || workInProgress.type !== current.type) didReceiveUpdate = !0;
            else {
                if (!checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return didReceiveUpdate = !1, attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
                didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
            }
        } else {
            didReceiveUpdate = !1;
            if (returnFiber = isHydrating) warnIfNotHydrating(), returnFiber = 0 !== (workInProgress.flags & 1048576);
            returnFiber && (returnFiber = workInProgress.index, warnIfNotHydrating(), pushTreeId(workInProgress, treeForkCount, returnFiber));
        }
        workInProgress.lanes = 0;
        switch(workInProgress.tag){
            case 16:
                a: if (returnFiber = workInProgress.pendingProps, current = resolveLazy(workInProgress.elementType), workInProgress.type = current, "function" === typeof current) shouldConstruct(current) ? (returnFiber = resolveClassComponentProps(current, returnFiber), workInProgress.tag = 1, workInProgress.type = current = resolveFunctionForHotReloading(current), workInProgress = updateClassComponent(null, workInProgress, current, returnFiber, renderLanes)) : (workInProgress.tag = 0, validateFunctionComponentInDev(workInProgress, current), workInProgress.type = current = resolveFunctionForHotReloading(current), workInProgress = updateFunctionComponent(null, workInProgress, current, returnFiber, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        if (prevSibling = current.$$typeof, prevSibling === REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress.type = current = resolveForwardRefForHotReloading(current);
                            workInProgress = updateForwardRef(null, workInProgress, current, returnFiber, renderLanes);
                            break a;
                        } else if (prevSibling === REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = updateMemoComponent(null, workInProgress, current, returnFiber, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = "";
                    null !== current && "object" === typeof current && current.$$typeof === REACT_LAZY_TYPE && (workInProgress = " Did you wrap a component in React.lazy() more than once?");
                    renderLanes = getComponentNameFromType(current) || current;
                    throw Error("Element type is invalid. Received a promise that resolves to: " + renderLanes + ". Lazy element type must resolve to a class or function." + workInProgress);
                }
                return workInProgress;
            case 0:
                return updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            case 1:
                return returnFiber = workInProgress.type, prevSibling = resolveClassComponentProps(returnFiber, workInProgress.pendingProps), updateClassComponent(current, workInProgress, returnFiber, prevSibling, renderLanes);
            case 3:
                a: {
                    pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                    if (null === current) throw Error("Should have a current fiber. This is a bug in React.");
                    returnFiber = workInProgress.pendingProps;
                    var prevState = workInProgress.memoizedState;
                    prevSibling = prevState.element;
                    cloneUpdateQueue(current, workInProgress);
                    processUpdateQueue(workInProgress, returnFiber, null, renderLanes);
                    var nextState = workInProgress.memoizedState;
                    returnFiber = nextState.cache;
                    pushProvider(workInProgress, CacheContext, returnFiber);
                    returnFiber !== prevState.cache && propagateContextChanges(workInProgress, [
                        CacheContext
                    ], renderLanes, !0);
                    suspendIfUpdateReadFromEntangledAsyncAction();
                    returnFiber = nextState.element;
                    if (prevState.isDehydrated) {
                        if (prevState = {
                            element: returnFiber,
                            isDehydrated: !1,
                            cache: nextState.cache
                        }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                            workInProgress = mountHostRootWithoutHydrating(current, workInProgress, returnFiber, renderLanes);
                            break a;
                        } else if (returnFiber !== prevSibling) {
                            prevSibling = createCapturedValueAtFiber(Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), workInProgress);
                            queueHydrationError(prevSibling);
                            workInProgress = mountHostRootWithoutHydrating(current, workInProgress, returnFiber, renderLanes);
                            break a;
                        } else {
                            current = workInProgress.stateNode.containerInfo;
                            switch(current.nodeType){
                                case 9:
                                    current = current.body;
                                    break;
                                default:
                                    current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                            }
                            nextHydratableInstance = getNextHydratable(current.firstChild);
                            hydrationParentFiber = workInProgress;
                            isHydrating = !0;
                            hydrationErrors = null;
                            didSuspendOrErrorDEV = !1;
                            hydrationDiffRootDEV = null;
                            rootOrSingletonContext = !0;
                            renderLanes = mountChildFibers(workInProgress, null, returnFiber, renderLanes);
                            for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                        }
                    } else {
                        resetHydrationState();
                        if (returnFiber === prevSibling) {
                            workInProgress = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                            break a;
                        }
                        reconcileChildren(current, workInProgress, returnFiber, renderLanes);
                    }
                    workInProgress = workInProgress.child;
                }
                return workInProgress;
            case 26:
                return markRef(current, workInProgress), null === current ? (renderLanes = getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, returnFiber = requiredContext(rootInstanceStackCursor.current), returnFiber = getOwnerDocumentFromRootContainer(returnFiber).createElement(renderLanes), returnFiber[internalInstanceKey] = workInProgress, returnFiber[internalPropsKey] = current, setInitialProperties(returnFiber, renderLanes, current), markNodeAsHoistable(returnFiber), workInProgress.stateNode = returnFiber) : workInProgress.memoizedState = getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
            case 27:
                return pushHostContext(workInProgress), null === current && isHydrating && (returnFiber = requiredContext(rootInstanceStackCursor.current), prevSibling = getHostContext(), returnFiber = workInProgress.stateNode = resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, returnFiber, prevSibling, !1), didSuspendOrErrorDEV || (prevSibling = diffHydratedProperties(returnFiber, workInProgress.type, workInProgress.pendingProps, prevSibling), null !== prevSibling && (buildHydrationDiffNode(workInProgress, 0).serverProps = prevSibling)), hydrationParentFiber = workInProgress, rootOrSingletonContext = !0, prevSibling = nextHydratableInstance, isSingletonScope(workInProgress.type) ? (previousHydratableOnEnteringScopedSingleton = prevSibling, nextHydratableInstance = getNextHydratable(returnFiber.firstChild)) : nextHydratableInstance = prevSibling), reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
            case 5:
                return null === current && isHydrating && (prevState = getHostContext(), returnFiber = validateDOMNesting(workInProgress.type, prevState.ancestorInfo), prevSibling = nextHydratableInstance, (nextState = !prevSibling) || (nextState = canHydrateInstance(prevSibling, workInProgress.type, workInProgress.pendingProps, rootOrSingletonContext), null !== nextState ? (workInProgress.stateNode = nextState, didSuspendOrErrorDEV || (prevState = diffHydratedProperties(nextState, workInProgress.type, workInProgress.pendingProps, prevState), null !== prevState && (buildHydrationDiffNode(workInProgress, 0).serverProps = prevState)), hydrationParentFiber = workInProgress, nextHydratableInstance = getNextHydratable(nextState.firstChild), rootOrSingletonContext = !1, prevState = !0) : prevState = !1, nextState = !prevState), nextState && (returnFiber && warnNonHydratedInstance(workInProgress, prevSibling), throwOnHydrationMismatch(workInProgress))), pushHostContext(workInProgress), prevSibling = workInProgress.type, prevState = workInProgress.pendingProps, nextState = null !== current ? current.memoizedProps : null, returnFiber = prevState.children, shouldSetTextContent(prevSibling, prevState) ? returnFiber = null : null !== nextState && shouldSetTextContent(prevSibling, nextState) && (workInProgress.flags |= 32), null !== workInProgress.memoizedState && (prevSibling = renderWithHooks(current, workInProgress, TransitionAwareHostComponent, null, null, renderLanes), HostTransitionContext._currentValue = prevSibling), markRef(current, workInProgress), reconcileChildren(current, workInProgress, returnFiber, renderLanes), workInProgress.child;
            case 6:
                return null === current && isHydrating && (renderLanes = workInProgress.pendingProps, current = getHostContext(), returnFiber = current.ancestorInfo.current, renderLanes = null != returnFiber ? validateTextNesting(renderLanes, returnFiber.tag, current.ancestorInfo.implicitRootScope) : !0, current = nextHydratableInstance, (returnFiber = !current) || (returnFiber = canHydrateTextInstance(current, workInProgress.pendingProps, rootOrSingletonContext), null !== returnFiber ? (workInProgress.stateNode = returnFiber, hydrationParentFiber = workInProgress, nextHydratableInstance = null, returnFiber = !0) : returnFiber = !1, returnFiber = !returnFiber), returnFiber && (renderLanes && warnNonHydratedInstance(workInProgress, current), throwOnHydrationMismatch(workInProgress))), null;
            case 13:
                return updateSuspenseComponent(current, workInProgress, renderLanes);
            case 4:
                return pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), returnFiber = workInProgress.pendingProps, null === current ? workInProgress.child = reconcileChildFibers(workInProgress, null, returnFiber, renderLanes) : reconcileChildren(current, workInProgress, returnFiber, renderLanes), workInProgress.child;
            case 11:
                return updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            case 7:
                return reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
            case 8:
                return reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
            case 12:
                return workInProgress.flags |= 4, workInProgress.flags |= 2048, returnFiber = workInProgress.stateNode, returnFiber.effectDuration = -0, returnFiber.passiveEffectDuration = -0, reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
            case 10:
                return returnFiber = workInProgress.type, prevSibling = workInProgress.pendingProps, prevState = prevSibling.value, "value" in prevSibling || hasWarnedAboutUsingNoValuePropOnContextProvider || (hasWarnedAboutUsingNoValuePropOnContextProvider = !0, console.error("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?")), pushProvider(workInProgress, returnFiber, prevState), reconcileChildren(current, workInProgress, prevSibling.children, renderLanes), workInProgress.child;
            case 9:
                return prevSibling = workInProgress.type._context, returnFiber = workInProgress.pendingProps.children, "function" !== typeof returnFiber && console.error("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), prepareToReadContext(workInProgress), prevSibling = readContext(prevSibling), returnFiber = callComponentInDEV(returnFiber, prevSibling, void 0), workInProgress.flags |= 1, reconcileChildren(current, workInProgress, returnFiber, renderLanes), workInProgress.child;
            case 14:
                return updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            case 15:
                return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            case 19:
                return updateSuspenseListComponent(current, workInProgress, renderLanes);
            case 31:
                return updateActivityComponent(current, workInProgress, renderLanes);
            case 22:
                return updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
            case 24:
                return prepareToReadContext(workInProgress), returnFiber = readContext(CacheContext), null === current ? (prevSibling = peekCacheFromPool(), null === prevSibling && (prevSibling = workInProgressRoot, prevState = createCache(), prevSibling.pooledCache = prevState, retainCache(prevState), null !== prevState && (prevSibling.pooledCacheLanes |= renderLanes), prevSibling = prevState), workInProgress.memoizedState = {
                    parent: returnFiber,
                    cache: prevSibling
                }, initializeUpdateQueue(workInProgress), pushProvider(workInProgress, CacheContext, prevSibling)) : (0 !== (current.lanes & renderLanes) && (cloneUpdateQueue(current, workInProgress), processUpdateQueue(workInProgress, null, null, renderLanes), suspendIfUpdateReadFromEntangledAsyncAction()), prevSibling = current.memoizedState, prevState = workInProgress.memoizedState, prevSibling.parent !== returnFiber ? (prevSibling = {
                    parent: returnFiber,
                    cache: returnFiber
                }, workInProgress.memoizedState = prevSibling, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = prevSibling), pushProvider(workInProgress, CacheContext, returnFiber)) : (returnFiber = prevState.cache, pushProvider(workInProgress, CacheContext, returnFiber), returnFiber !== prevSibling.cache && propagateContextChanges(workInProgress, [
                    CacheContext
                ], renderLanes, !0))), reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
            case 29:
                throw workInProgress.pendingProps;
        }
        throw Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function markUpdate(workInProgress) {
        workInProgress.flags |= 4;
    }
    function preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
        if (type = (workInProgress.mode & SuspenseyImagesMode) !== NoMode) type = !1;
        if (type) {
            if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
                if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
                else if (shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
                else throw suspendedThenable = noopSuspenseyCommitThenable, SuspenseyCommitException;
            }
        } else workInProgress.flags &= -16777217;
    }
    function preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
        if ("stylesheet" !== resource.type || (resource.state.loading & Inserted) !== NotLoaded) workInProgress.flags &= -16777217;
        else if (workInProgress.flags |= 16777216, !preloadResource(resource)) {
            if (shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw suspendedThenable = noopSuspenseyCommitThenable, SuspenseyCommitException;
        }
    }
    function scheduleRetryEffect(workInProgress, retryQueue) {
        null !== retryQueue && (workInProgress.flags |= 4);
        workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, workInProgressSuspendedRetryLanes |= retryQueue);
    }
    function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
        if (!isHydrating) switch(renderState.tailMode){
            case "hidden":
                hasRenderedATailFallback = renderState.tail;
                for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
                null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
                break;
            case "collapsed":
                lastTailNode = renderState.tail;
                for(var _lastTailNode = null; null !== lastTailNode;)null !== lastTailNode.alternate && (_lastTailNode = lastTailNode), lastTailNode = lastTailNode.sibling;
                null === _lastTailNode ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : _lastTailNode.sibling = null;
        }
    }
    function bubbleProperties(completedWork) {
        var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
        if (didBailout) {
            if ((completedWork.mode & ProfileMode) !== NoMode) {
                for(var _treeBaseDuration = completedWork.selfBaseDuration, _child2 = completedWork.child; null !== _child2;)newChildLanes |= _child2.lanes | _child2.childLanes, subtreeFlags |= _child2.subtreeFlags & 65011712, subtreeFlags |= _child2.flags & 65011712, _treeBaseDuration += _child2.treeBaseDuration, _child2 = _child2.sibling;
                completedWork.treeBaseDuration = _treeBaseDuration;
            } else for(_treeBaseDuration = completedWork.child; null !== _treeBaseDuration;)newChildLanes |= _treeBaseDuration.lanes | _treeBaseDuration.childLanes, subtreeFlags |= _treeBaseDuration.subtreeFlags & 65011712, subtreeFlags |= _treeBaseDuration.flags & 65011712, _treeBaseDuration.return = completedWork, _treeBaseDuration = _treeBaseDuration.sibling;
        } else if ((completedWork.mode & ProfileMode) !== NoMode) {
            _treeBaseDuration = completedWork.actualDuration;
            _child2 = completedWork.selfBaseDuration;
            for(var child = completedWork.child; null !== child;)newChildLanes |= child.lanes | child.childLanes, subtreeFlags |= child.subtreeFlags, subtreeFlags |= child.flags, _treeBaseDuration += child.actualDuration, _child2 += child.treeBaseDuration, child = child.sibling;
            completedWork.actualDuration = _treeBaseDuration;
            completedWork.treeBaseDuration = _child2;
        } else for(_treeBaseDuration = completedWork.child; null !== _treeBaseDuration;)newChildLanes |= _treeBaseDuration.lanes | _treeBaseDuration.childLanes, subtreeFlags |= _treeBaseDuration.subtreeFlags, subtreeFlags |= _treeBaseDuration.flags, _treeBaseDuration.return = completedWork, _treeBaseDuration = _treeBaseDuration.sibling;
        completedWork.subtreeFlags |= subtreeFlags;
        completedWork.childLanes = newChildLanes;
        return didBailout;
    }
    function completeWork(current, workInProgress, renderLanes) {
        var newProps = workInProgress.pendingProps;
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case 16:
            case 15:
            case 0:
            case 11:
            case 7:
            case 8:
            case 12:
            case 9:
            case 14:
                return bubbleProperties(workInProgress), null;
            case 1:
                return bubbleProperties(workInProgress), null;
            case 3:
                renderLanes = workInProgress.stateNode;
                newProps = null;
                null !== current && (newProps = current.memoizedState.cache);
                workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
                popProvider(CacheContext, workInProgress);
                popHostContainer(workInProgress);
                renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
                if (null === current || null === current.child) popHydrationState(workInProgress) ? (emitPendingHydrationWarnings(), markUpdate(workInProgress)) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, upgradeHydrationErrorsToRecoverable());
                bubbleProperties(workInProgress);
                return null;
            case 26:
                var type = workInProgress.type, nextResource = workInProgress.memoizedState;
                null === current ? (markUpdate(workInProgress), null !== nextResource ? (bubbleProperties(workInProgress), preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : (bubbleProperties(workInProgress), preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? (markUpdate(workInProgress), bubbleProperties(workInProgress), preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : (bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && markUpdate(workInProgress), bubbleProperties(workInProgress), preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
                return null;
            case 27:
                popHostContext(workInProgress);
                renderLanes = requiredContext(rootInstanceStackCursor.current);
                type = workInProgress.type;
                if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
                else {
                    if (!newProps) {
                        if (null === workInProgress.stateNode) throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                        bubbleProperties(workInProgress);
                        return null;
                    }
                    current = getHostContext();
                    popHydrationState(workInProgress) ? prepareToHydrateHostInstance(workInProgress, current) : (current = resolveSingletonInstance(type, newProps, renderLanes, current, !0), workInProgress.stateNode = current, markUpdate(workInProgress));
                }
                bubbleProperties(workInProgress);
                return null;
            case 5:
                popHostContext(workInProgress);
                type = workInProgress.type;
                if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
                else {
                    if (!newProps) {
                        if (null === workInProgress.stateNode) throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                        bubbleProperties(workInProgress);
                        return null;
                    }
                    var _currentHostContext = getHostContext();
                    if (popHydrationState(workInProgress)) prepareToHydrateHostInstance(workInProgress, _currentHostContext);
                    else {
                        nextResource = requiredContext(rootInstanceStackCursor.current);
                        validateDOMNesting(type, _currentHostContext.ancestorInfo);
                        _currentHostContext = _currentHostContext.context;
                        nextResource = getOwnerDocumentFromRootContainer(nextResource);
                        switch(_currentHostContext){
                            case HostContextNamespaceSvg:
                                nextResource = nextResource.createElementNS(SVG_NAMESPACE, type);
                                break;
                            case HostContextNamespaceMath:
                                nextResource = nextResource.createElementNS(MATH_NAMESPACE, type);
                                break;
                            default:
                                switch(type){
                                    case "svg":
                                        nextResource = nextResource.createElementNS(SVG_NAMESPACE, type);
                                        break;
                                    case "math":
                                        nextResource = nextResource.createElementNS(MATH_NAMESPACE, type);
                                        break;
                                    case "script":
                                        nextResource = nextResource.createElement("div");
                                        nextResource.innerHTML = "<script>\x3c/script>";
                                        nextResource = nextResource.removeChild(nextResource.firstChild);
                                        break;
                                    case "select":
                                        nextResource = "string" === typeof newProps.is ? nextResource.createElement("select", {
                                            is: newProps.is
                                        }) : nextResource.createElement("select");
                                        newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                        break;
                                    default:
                                        nextResource = "string" === typeof newProps.is ? nextResource.createElement(type, {
                                            is: newProps.is
                                        }) : nextResource.createElement(type), -1 === type.indexOf("-") && (type !== type.toLowerCase() && console.error("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", type), "[object HTMLUnknownElement]" !== Object.prototype.toString.call(nextResource) || hasOwnProperty.call(warnedUnknownTags, type) || (warnedUnknownTags[type] = !0, console.error("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", type)));
                                }
                        }
                        nextResource[internalInstanceKey] = workInProgress;
                        nextResource[internalPropsKey] = newProps;
                        a: for(_currentHostContext = workInProgress.child; null !== _currentHostContext;){
                            if (5 === _currentHostContext.tag || 6 === _currentHostContext.tag) nextResource.appendChild(_currentHostContext.stateNode);
                            else if (4 !== _currentHostContext.tag && 27 !== _currentHostContext.tag && null !== _currentHostContext.child) {
                                _currentHostContext.child.return = _currentHostContext;
                                _currentHostContext = _currentHostContext.child;
                                continue;
                            }
                            if (_currentHostContext === workInProgress) break a;
                            for(; null === _currentHostContext.sibling;){
                                if (null === _currentHostContext.return || _currentHostContext.return === workInProgress) break a;
                                _currentHostContext = _currentHostContext.return;
                            }
                            _currentHostContext.sibling.return = _currentHostContext.return;
                            _currentHostContext = _currentHostContext.sibling;
                        }
                        workInProgress.stateNode = nextResource;
                        a: switch(setInitialProperties(nextResource, type, newProps), type){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                newProps = !!newProps.autoFocus;
                                break a;
                            case "img":
                                newProps = !0;
                                break a;
                            default:
                                newProps = !1;
                        }
                        newProps && markUpdate(workInProgress);
                    }
                }
                bubbleProperties(workInProgress);
                preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
                return null;
            case 6:
                if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
                else {
                    if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                    current = requiredContext(rootInstanceStackCursor.current);
                    renderLanes = getHostContext();
                    if (popHydrationState(workInProgress)) {
                        current = workInProgress.stateNode;
                        renderLanes = workInProgress.memoizedProps;
                        type = !didSuspendOrErrorDEV;
                        newProps = null;
                        nextResource = hydrationParentFiber;
                        if (null !== nextResource) switch(nextResource.tag){
                            case 3:
                                type && (type = diffHydratedTextForDevWarnings(current, renderLanes, newProps), null !== type && (buildHydrationDiffNode(workInProgress, 0).serverProps = type));
                                break;
                            case 27:
                            case 5:
                                newProps = nextResource.memoizedProps, type && (type = diffHydratedTextForDevWarnings(current, renderLanes, newProps), null !== type && (buildHydrationDiffNode(workInProgress, 0).serverProps = type));
                        }
                        current[internalInstanceKey] = workInProgress;
                        current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                        current || throwOnHydrationMismatch(workInProgress, !0);
                    } else type = renderLanes.ancestorInfo.current, null != type && validateTextNesting(newProps, type.tag, renderLanes.ancestorInfo.implicitRootScope), current = getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
                }
                bubbleProperties(workInProgress);
                return null;
            case 31:
                renderLanes = workInProgress.memoizedState;
                if (null === current || null !== current.memoizedState) {
                    newProps = popHydrationState(workInProgress);
                    if (null !== renderLanes) {
                        if (null === current) {
                            if (!newProps) throw Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
                            current = workInProgress.memoizedState;
                            current = null !== current ? current.dehydrated : null;
                            if (!current) throw Error("Expected to have a hydrated activity instance. This error is likely caused by a bug in React. Please file an issue.");
                            current[internalInstanceKey] = workInProgress;
                            bubbleProperties(workInProgress);
                            (workInProgress.mode & ProfileMode) !== NoMode && null !== renderLanes && (current = workInProgress.child, null !== current && (workInProgress.treeBaseDuration -= current.treeBaseDuration));
                        } else emitPendingHydrationWarnings(), resetHydrationState(), 0 === (workInProgress.flags & 128) && (renderLanes = workInProgress.memoizedState = null), workInProgress.flags |= 4, bubbleProperties(workInProgress), (workInProgress.mode & ProfileMode) !== NoMode && null !== renderLanes && (current = workInProgress.child, null !== current && (workInProgress.treeBaseDuration -= current.treeBaseDuration));
                        current = !1;
                    } else renderLanes = upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                    if (!current) {
                        if (workInProgress.flags & 256) return popSuspenseHandler(workInProgress), workInProgress;
                        popSuspenseHandler(workInProgress);
                        return null;
                    }
                    if (0 !== (workInProgress.flags & 128)) throw Error("Client rendering an Activity suspended it again. This is a bug in React.");
                }
                bubbleProperties(workInProgress);
                return null;
            case 13:
                newProps = workInProgress.memoizedState;
                if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                    type = newProps;
                    nextResource = popHydrationState(workInProgress);
                    if (null !== type && null !== type.dehydrated) {
                        if (null === current) {
                            if (!nextResource) throw Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
                            nextResource = workInProgress.memoizedState;
                            nextResource = null !== nextResource ? nextResource.dehydrated : null;
                            if (!nextResource) throw Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
                            nextResource[internalInstanceKey] = workInProgress;
                            bubbleProperties(workInProgress);
                            (workInProgress.mode & ProfileMode) !== NoMode && null !== type && (type = workInProgress.child, null !== type && (workInProgress.treeBaseDuration -= type.treeBaseDuration));
                        } else emitPendingHydrationWarnings(), resetHydrationState(), 0 === (workInProgress.flags & 128) && (type = workInProgress.memoizedState = null), workInProgress.flags |= 4, bubbleProperties(workInProgress), (workInProgress.mode & ProfileMode) !== NoMode && null !== type && (type = workInProgress.child, null !== type && (workInProgress.treeBaseDuration -= type.treeBaseDuration));
                        type = !1;
                    } else type = upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                    if (!type) {
                        if (workInProgress.flags & 256) return popSuspenseHandler(workInProgress), workInProgress;
                        popSuspenseHandler(workInProgress);
                        return null;
                    }
                }
                popSuspenseHandler(workInProgress);
                if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, (workInProgress.mode & ProfileMode) !== NoMode && transferActualDuration(workInProgress), workInProgress;
                renderLanes = null !== newProps;
                current = null !== current && null !== current.memoizedState;
                renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
                renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
                scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
                bubbleProperties(workInProgress);
                (workInProgress.mode & ProfileMode) !== NoMode && renderLanes && (current = workInProgress.child, null !== current && (workInProgress.treeBaseDuration -= current.treeBaseDuration));
                return null;
            case 4:
                return popHostContainer(workInProgress), null === current && listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), bubbleProperties(workInProgress), null;
            case 10:
                return popProvider(workInProgress.type, workInProgress), bubbleProperties(workInProgress), null;
            case 19:
                pop(suspenseStackCursor, workInProgress);
                newProps = workInProgress.memoizedState;
                if (null === newProps) return bubbleProperties(workInProgress), null;
                type = 0 !== (workInProgress.flags & 128);
                nextResource = newProps.rendering;
                if (null === nextResource) {
                    if (type) cutOffTailIfNeeded(newProps, !1);
                    else {
                        if (workInProgressRootExitStatus !== RootInProgress || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                            nextResource = findFirstSuspended(current);
                            if (null !== nextResource) {
                                workInProgress.flags |= 128;
                                cutOffTailIfNeeded(newProps, !1);
                                current = nextResource.updateQueue;
                                workInProgress.updateQueue = current;
                                scheduleRetryEffect(workInProgress, current);
                                workInProgress.subtreeFlags = 0;
                                current = renderLanes;
                                for(renderLanes = workInProgress.child; null !== renderLanes;)resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                                push(suspenseStackCursor, suspenseStackCursor.current & SubtreeSuspenseContextMask | ForceSuspenseFallback, workInProgress);
                                isHydrating && pushTreeFork(workInProgress, newProps.treeForkCount);
                                return workInProgress.child;
                            }
                            current = current.sibling;
                        }
                        null !== newProps.tail && now$1() > workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                    }
                } else {
                    if (!type) {
                        if (current = findFirstSuspended(nextResource), null !== current) {
                            if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, scheduleRetryEffect(workInProgress, current), cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !isHydrating) return bubbleProperties(workInProgress), null;
                        } else 2 * now$1() - newProps.renderingStartTime > workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                    }
                    newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
                }
                if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = now$1(), current.sibling = null, renderLanes = suspenseStackCursor.current, renderLanes = type ? renderLanes & SubtreeSuspenseContextMask | ForceSuspenseFallback : renderLanes & SubtreeSuspenseContextMask, push(suspenseStackCursor, renderLanes, workInProgress), isHydrating && pushTreeFork(workInProgress, newProps.treeForkCount), current;
                bubbleProperties(workInProgress);
                return null;
            case 22:
            case 23:
                return popSuspenseHandler(workInProgress), popHiddenContext(workInProgress), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && (bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && pop(resumedCache, workInProgress), null;
            case 24:
                return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), popProvider(CacheContext, workInProgress), bubbleProperties(workInProgress), null;
            case 25:
                return null;
            case 30:
                return null;
        }
        throw Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function unwindWork(current, workInProgress) {
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case 1:
                return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, (workInProgress.mode & ProfileMode) !== NoMode && transferActualDuration(workInProgress), workInProgress) : null;
            case 3:
                return popProvider(CacheContext, workInProgress), popHostContainer(workInProgress), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
            case 26:
            case 27:
            case 5:
                return popHostContext(workInProgress), null;
            case 31:
                if (null !== workInProgress.memoizedState) {
                    popSuspenseHandler(workInProgress);
                    if (null === workInProgress.alternate) throw Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
                    resetHydrationState();
                }
                current = workInProgress.flags;
                return current & 65536 ? (workInProgress.flags = current & -65537 | 128, (workInProgress.mode & ProfileMode) !== NoMode && transferActualDuration(workInProgress), workInProgress) : null;
            case 13:
                popSuspenseHandler(workInProgress);
                current = workInProgress.memoizedState;
                if (null !== current && null !== current.dehydrated) {
                    if (null === workInProgress.alternate) throw Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
                    resetHydrationState();
                }
                current = workInProgress.flags;
                return current & 65536 ? (workInProgress.flags = current & -65537 | 128, (workInProgress.mode & ProfileMode) !== NoMode && transferActualDuration(workInProgress), workInProgress) : null;
            case 19:
                return pop(suspenseStackCursor, workInProgress), null;
            case 4:
                return popHostContainer(workInProgress), null;
            case 10:
                return popProvider(workInProgress.type, workInProgress), null;
            case 22:
            case 23:
                return popSuspenseHandler(workInProgress), popHiddenContext(workInProgress), null !== current && pop(resumedCache, workInProgress), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, (workInProgress.mode & ProfileMode) !== NoMode && transferActualDuration(workInProgress), workInProgress) : null;
            case 24:
                return popProvider(CacheContext, workInProgress), null;
            case 25:
                return null;
            default:
                return null;
        }
    }
    function unwindInterruptedWork(current, interruptedWork) {
        popTreeContext(interruptedWork);
        switch(interruptedWork.tag){
            case 3:
                popProvider(CacheContext, interruptedWork);
                popHostContainer(interruptedWork);
                break;
            case 26:
            case 27:
            case 5:
                popHostContext(interruptedWork);
                break;
            case 4:
                popHostContainer(interruptedWork);
                break;
            case 31:
                null !== interruptedWork.memoizedState && popSuspenseHandler(interruptedWork);
                break;
            case 13:
                popSuspenseHandler(interruptedWork);
                break;
            case 19:
                pop(suspenseStackCursor, interruptedWork);
                break;
            case 10:
                popProvider(interruptedWork.type, interruptedWork);
                break;
            case 22:
            case 23:
                popSuspenseHandler(interruptedWork);
                popHiddenContext(interruptedWork);
                null !== current && pop(resumedCache, interruptedWork);
                break;
            case 24:
                popProvider(CacheContext, interruptedWork);
        }
    }
    function shouldProfile(current) {
        return (current.mode & ProfileMode) !== NoMode;
    }
    function commitHookLayoutEffects(finishedWork, hookFlags) {
        shouldProfile(finishedWork) ? (startEffectTimer(), commitHookEffectListMount(hookFlags, finishedWork), recordEffectDuration()) : commitHookEffectListMount(hookFlags, finishedWork);
    }
    function commitHookLayoutUnmountEffects(finishedWork, nearestMountedAncestor, hookFlags) {
        shouldProfile(finishedWork) ? (startEffectTimer(), commitHookEffectListUnmount(hookFlags, finishedWork, nearestMountedAncestor), recordEffectDuration()) : commitHookEffectListUnmount(hookFlags, finishedWork, nearestMountedAncestor);
    }
    function commitHookEffectListMount(flags, finishedWork) {
        try {
            var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
            if (null !== lastEffect) {
                var firstEffect = lastEffect.next;
                updateQueue = firstEffect;
                do {
                    if ((updateQueue.tag & flags) === flags && (lastEffect = void 0, (flags & Insertion) !== NoFlags && (isRunningInsertionEffect = !0), lastEffect = runWithFiberInDEV(finishedWork, callCreateInDEV, updateQueue), (flags & Insertion) !== NoFlags && (isRunningInsertionEffect = !1), void 0 !== lastEffect && "function" !== typeof lastEffect)) {
                        var hookName = void 0;
                        hookName = 0 !== (updateQueue.tag & Layout) ? "useLayoutEffect" : 0 !== (updateQueue.tag & Insertion) ? "useInsertionEffect" : "useEffect";
                        var addendum = void 0;
                        addendum = null === lastEffect ? " You returned null. If your effect does not require clean up, return undefined (or nothing)." : "function" === typeof lastEffect.then ? "\n\nIt looks like you wrote " + hookName + "(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:\n\n" + hookName + "(() => {\n  async function fetchData() {\n    // You can await here\n    const response = await MyAPI.getData(someId);\n    // ...\n  }\n  fetchData();\n}, [someId]); // Or [] if effect doesn't need props or state\n\nLearn more about data fetching with Hooks: https://react.dev/link/hooks-data-fetching" : " You returned: " + lastEffect;
                        runWithFiberInDEV(finishedWork, function(n, a) {
                            console.error("%s must not return anything besides a function, which is used for clean-up.%s", n, a);
                        }, hookName, addendum);
                    }
                    updateQueue = updateQueue.next;
                }while (updateQueue !== firstEffect);
            }
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor) {
        try {
            var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
            if (null !== lastEffect) {
                var firstEffect = lastEffect.next;
                updateQueue = firstEffect;
                do {
                    if ((updateQueue.tag & flags) === flags) {
                        var inst = updateQueue.inst, destroy = inst.destroy;
                        void 0 !== destroy && (inst.destroy = void 0, (flags & Insertion) !== NoFlags && (isRunningInsertionEffect = !0), lastEffect = finishedWork, runWithFiberInDEV(lastEffect, callDestroyInDEV, lastEffect, nearestMountedAncestor, destroy), (flags & Insertion) !== NoFlags && (isRunningInsertionEffect = !1));
                    }
                    updateQueue = updateQueue.next;
                }while (updateQueue !== firstEffect);
            }
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function commitHookPassiveMountEffects(finishedWork, hookFlags) {
        shouldProfile(finishedWork) ? (startEffectTimer(), commitHookEffectListMount(hookFlags, finishedWork), recordEffectDuration()) : commitHookEffectListMount(hookFlags, finishedWork);
    }
    function commitHookPassiveUnmountEffects(finishedWork, nearestMountedAncestor, hookFlags) {
        shouldProfile(finishedWork) ? (startEffectTimer(), commitHookEffectListUnmount(hookFlags, finishedWork, nearestMountedAncestor), recordEffectDuration()) : commitHookEffectListUnmount(hookFlags, finishedWork, nearestMountedAncestor);
    }
    function commitClassCallbacks(finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        if (null !== updateQueue) {
            var instance = finishedWork.stateNode;
            finishedWork.type.defaultProps || "ref" in finishedWork.memoizedProps || didWarnAboutReassigningProps || (instance.props !== finishedWork.memoizedProps && console.error("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance"), instance.state !== finishedWork.memoizedState && console.error("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance"));
            try {
                runWithFiberInDEV(finishedWork, commitCallbacks, updateQueue, instance);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
        }
    }
    function callGetSnapshotBeforeUpdates(instance, prevProps, prevState) {
        return instance.getSnapshotBeforeUpdate(prevProps, prevState);
    }
    function commitClassSnapshot(finishedWork, current) {
        var prevProps = current.memoizedProps, prevState = current.memoizedState;
        current = finishedWork.stateNode;
        finishedWork.type.defaultProps || "ref" in finishedWork.memoizedProps || didWarnAboutReassigningProps || (current.props !== finishedWork.memoizedProps && console.error("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance"), current.state !== finishedWork.memoizedState && console.error("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance"));
        try {
            var resolvedPrevProps = resolveClassComponentProps(finishedWork.type, prevProps);
            var snapshot = runWithFiberInDEV(finishedWork, callGetSnapshotBeforeUpdates, current, resolvedPrevProps, prevState);
            prevProps = didWarnAboutUndefinedSnapshotBeforeUpdate;
            void 0 !== snapshot || prevProps.has(finishedWork.type) || (prevProps.add(finishedWork.type), runWithFiberInDEV(finishedWork, function() {
                console.error("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", getComponentNameFromFiber(finishedWork));
            }));
            current.__reactInternalSnapshotBeforeUpdate = snapshot;
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
        instance.props = resolveClassComponentProps(current.type, current.memoizedProps);
        instance.state = current.memoizedState;
        shouldProfile(current) ? (startEffectTimer(), runWithFiberInDEV(current, callComponentWillUnmountInDEV, current, nearestMountedAncestor, instance), recordEffectDuration()) : runWithFiberInDEV(current, callComponentWillUnmountInDEV, current, nearestMountedAncestor, instance);
    }
    function commitAttachRef(finishedWork) {
        var ref = finishedWork.ref;
        if (null !== ref) {
            switch(finishedWork.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = finishedWork.stateNode;
                    break;
                case 30:
                    instanceToUse = finishedWork.stateNode;
                    break;
                default:
                    instanceToUse = finishedWork.stateNode;
            }
            if ("function" === typeof ref) {
                if (shouldProfile(finishedWork)) try {
                    startEffectTimer(), finishedWork.refCleanup = ref(instanceToUse);
                } finally{
                    recordEffectDuration();
                }
                else finishedWork.refCleanup = ref(instanceToUse);
            } else "string" === typeof ref ? console.error("String refs are no longer supported.") : ref.hasOwnProperty("current") || console.error("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", getComponentNameFromFiber(finishedWork)), ref.current = instanceToUse;
        }
    }
    function safelyAttachRef(current, nearestMountedAncestor) {
        try {
            runWithFiberInDEV(current, commitAttachRef, current);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    }
    function safelyDetachRef(current, nearestMountedAncestor) {
        var ref = current.ref, refCleanup = current.refCleanup;
        if (null !== ref) {
            if ("function" === typeof refCleanup) try {
                if (shouldProfile(current)) try {
                    startEffectTimer(), runWithFiberInDEV(current, refCleanup);
                } finally{
                    recordEffectDuration(current);
                }
                else runWithFiberInDEV(current, refCleanup);
            } catch (error) {
                captureCommitPhaseError(current, nearestMountedAncestor, error);
            } finally{
                current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
            }
            else if ("function" === typeof ref) try {
                if (shouldProfile(current)) try {
                    startEffectTimer(), runWithFiberInDEV(current, ref, null);
                } finally{
                    recordEffectDuration(current);
                }
                else runWithFiberInDEV(current, ref, null);
            } catch (error$7) {
                captureCommitPhaseError(current, nearestMountedAncestor, error$7);
            }
            else ref.current = null;
        }
    }
    function commitProfiler(finishedWork, current, commitStartTime, effectDuration) {
        var _finishedWork$memoize = finishedWork.memoizedProps, id = _finishedWork$memoize.id, onCommit = _finishedWork$memoize.onCommit;
        _finishedWork$memoize = _finishedWork$memoize.onRender;
        current = null === current ? "mount" : "update";
        currentUpdateIsNested && (current = "nested-update");
        "function" === typeof _finishedWork$memoize && _finishedWork$memoize(id, current, finishedWork.actualDuration, finishedWork.treeBaseDuration, finishedWork.actualStartTime, commitStartTime);
        "function" === typeof onCommit && onCommit(id, current, effectDuration, commitStartTime);
    }
    function commitProfilerPostCommitImpl(finishedWork, current, commitStartTime, passiveEffectDuration) {
        var _finishedWork$memoize2 = finishedWork.memoizedProps;
        finishedWork = _finishedWork$memoize2.id;
        _finishedWork$memoize2 = _finishedWork$memoize2.onPostCommit;
        current = null === current ? "mount" : "update";
        currentUpdateIsNested && (current = "nested-update");
        "function" === typeof _finishedWork$memoize2 && _finishedWork$memoize2(finishedWork, current, passiveEffectDuration, commitStartTime);
    }
    function commitHostMount(finishedWork) {
        var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
        try {
            runWithFiberInDEV(finishedWork, commitMount, instance, type, props, finishedWork);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function commitHostUpdate(finishedWork, newProps, oldProps) {
        try {
            runWithFiberInDEV(finishedWork, commitUpdate, finishedWork.stateNode, finishedWork.type, oldProps, newProps, finishedWork);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function isHostParent(fiber) {
        return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && isSingletonScope(fiber.type) || 4 === fiber.tag;
    }
    function getHostSibling(fiber) {
        a: for(;;){
            for(; null === fiber.sibling;){
                if (null === fiber.return || isHostParent(fiber.return)) return null;
                fiber = fiber.return;
            }
            fiber.sibling.return = fiber.return;
            for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
                if (27 === fiber.tag && isSingletonScope(fiber.type)) continue a;
                if (fiber.flags & 2) continue a;
                if (null === fiber.child || 4 === fiber.tag) continue a;
                else fiber.child.return = fiber, fiber = fiber.child;
            }
            if (!(fiber.flags & 2)) return fiber.stateNode;
        }
    }
    function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
        var tag = node.tag;
        if (5 === tag || 6 === tag) node = node.stateNode, before ? (warnForReactChildrenConflict(parent), (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before)) : (warnForReactChildrenConflict(parent), before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = noop$1));
        else if (4 !== tag && (27 === tag && isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for(insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
    }
    function insertOrAppendPlacementNode(node, before, parent) {
        var tag = node.tag;
        if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
        else if (4 !== tag && (27 === tag && isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for(insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
    }
    function commitPlacement(finishedWork) {
        for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
            if (isHostParent(parentFiber)) {
                hostParentFiber = parentFiber;
                break;
            }
            parentFiber = parentFiber.return;
        }
        if (null == hostParentFiber) throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        switch(hostParentFiber.tag){
            case 27:
                hostParentFiber = hostParentFiber.stateNode;
                parentFiber = getHostSibling(finishedWork);
                insertOrAppendPlacementNode(finishedWork, parentFiber, hostParentFiber);
                break;
            case 5:
                parentFiber = hostParentFiber.stateNode;
                hostParentFiber.flags & 32 && (resetTextContent(parentFiber), hostParentFiber.flags &= -33);
                hostParentFiber = getHostSibling(finishedWork);
                insertOrAppendPlacementNode(finishedWork, hostParentFiber, parentFiber);
                break;
            case 3:
            case 4:
                hostParentFiber = hostParentFiber.stateNode.containerInfo;
                parentFiber = getHostSibling(finishedWork);
                insertOrAppendPlacementNodeIntoContainer(finishedWork, parentFiber, hostParentFiber);
                break;
            default:
                throw Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
        }
    }
    function commitHostSingletonAcquisition(finishedWork) {
        var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
        try {
            runWithFiberInDEV(finishedWork, acquireSingletonInstance, finishedWork.type, props, singleton, finishedWork);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function isHydratingParent(current, finishedWork) {
        return 31 === finishedWork.tag ? (finishedWork = finishedWork.memoizedState, null !== current.memoizedState && null === finishedWork) : 13 === finishedWork.tag ? (current = current.memoizedState, finishedWork = finishedWork.memoizedState, null !== current && null !== current.dehydrated && (null === finishedWork || null === finishedWork.dehydrated)) : 3 === finishedWork.tag ? current.memoizedState.isDehydrated && 0 === (finishedWork.flags & 256) : !1;
    }
    function commitBeforeMutationEffects(root, firstChild) {
        root = root.containerInfo;
        eventsEnabled = _enabled;
        root = getActiveElementDeep(root);
        if (hasSelectionCapabilities(root)) {
            if ("selectionStart" in root) var JSCompiler_temp = {
                start: root.selectionStart,
                end: root.selectionEnd
            };
            else a: {
                JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
                var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
                if (selection && 0 !== selection.rangeCount) {
                    JSCompiler_temp = selection.anchorNode;
                    var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                    selection = selection.focusOffset;
                    try {
                        JSCompiler_temp.nodeType, focusNode.nodeType;
                    } catch (e$2) {
                        JSCompiler_temp = null;
                        break a;
                    }
                    var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                    b: for(;;){
                        for(var next;;){
                            node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                            node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                            3 === node.nodeType && (length += node.nodeValue.length);
                            if (null === (next = node.firstChild)) break;
                            parentNode = node;
                            node = next;
                        }
                        for(;;){
                            if (node === root) break b;
                            parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                            parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                            if (null !== (next = node.nextSibling)) break;
                            node = parentNode;
                            parentNode = node.parentNode;
                        }
                        node = next;
                    }
                    JSCompiler_temp = -1 === start || -1 === end ? null : {
                        start: start,
                        end: end
                    };
                } else JSCompiler_temp = null;
            }
            JSCompiler_temp = JSCompiler_temp || {
                start: 0,
                end: 0
            };
        } else JSCompiler_temp = null;
        selectionInformation = {
            focusedElem: root,
            selectionRange: JSCompiler_temp
        };
        _enabled = !1;
        for(nextEffect = firstChild; null !== nextEffect;)if (firstChild = nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, nextEffect = root;
        else for(; null !== nextEffect;){
            root = firstChild = nextEffect;
            JSCompiler_temp = root.alternate;
            anchorOffset = root.flags;
            switch(root.tag){
                case 0:
                    if (0 !== (anchorOffset & 4) && (root = root.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                    break;
                case 11:
                case 15:
                    break;
                case 1:
                    0 !== (anchorOffset & 1024) && null !== JSCompiler_temp && commitClassSnapshot(root, JSCompiler_temp);
                    break;
                case 3:
                    if (0 !== (anchorOffset & 1024)) {
                        if (root = root.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) clearContainerSparingly(root);
                        else if (1 === JSCompiler_temp) switch(root.nodeName){
                            case "HEAD":
                            case "HTML":
                            case "BODY":
                                clearContainerSparingly(root);
                                break;
                            default:
                                root.textContent = "";
                        }
                    }
                    break;
                case 5:
                case 26:
                case 27:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    if (0 !== (anchorOffset & 1024)) throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
            }
            root = firstChild.sibling;
            if (null !== root) {
                root.return = firstChild.return;
                nextEffect = root;
                break;
            }
            nextEffect = firstChild.return;
        }
    }
    function commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate(), flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                flags & 4 && commitHookLayoutEffects(finishedWork, Layout | HasEffect);
                break;
            case 1:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                if (flags & 4) {
                    if (finishedRoot = finishedWork.stateNode, null === current) finishedWork.type.defaultProps || "ref" in finishedWork.memoizedProps || didWarnAboutReassigningProps || (finishedRoot.props !== finishedWork.memoizedProps && console.error("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance"), finishedRoot.state !== finishedWork.memoizedState && console.error("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance")), shouldProfile(finishedWork) ? (startEffectTimer(), runWithFiberInDEV(finishedWork, callComponentDidMountInDEV, finishedWork, finishedRoot), recordEffectDuration()) : runWithFiberInDEV(finishedWork, callComponentDidMountInDEV, finishedWork, finishedRoot);
                    else {
                        var prevProps = resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                        current = current.memoizedState;
                        finishedWork.type.defaultProps || "ref" in finishedWork.memoizedProps || didWarnAboutReassigningProps || (finishedRoot.props !== finishedWork.memoizedProps && console.error("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance"), finishedRoot.state !== finishedWork.memoizedState && console.error("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance"));
                        shouldProfile(finishedWork) ? (startEffectTimer(), runWithFiberInDEV(finishedWork, callComponentDidUpdateInDEV, finishedWork, finishedRoot, prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate), recordEffectDuration()) : runWithFiberInDEV(finishedWork, callComponentDidUpdateInDEV, finishedWork, finishedRoot, prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    }
                }
                flags & 64 && commitClassCallbacks(finishedWork);
                flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 3:
                current = pushNestedEffectDurations();
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                if (flags & 64 && (flags = finishedWork.updateQueue, null !== flags)) {
                    prevProps = null;
                    if (null !== finishedWork.child) switch(finishedWork.child.tag){
                        case 27:
                        case 5:
                            prevProps = finishedWork.child.stateNode;
                            break;
                        case 1:
                            prevProps = finishedWork.child.stateNode;
                    }
                    try {
                        runWithFiberInDEV(finishedWork, commitCallbacks, flags, prevProps);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                finishedRoot.effectDuration += popNestedEffectDurations(current);
                break;
            case 27:
                null === current && flags & 4 && commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                if (null === current) {
                    if (flags & 4) commitHostMount(finishedWork);
                    else if (flags & 64) {
                        finishedRoot = finishedWork.type;
                        current = finishedWork.memoizedProps;
                        prevProps = finishedWork.stateNode;
                        try {
                            runWithFiberInDEV(finishedWork, commitHydratedInstance, prevProps, finishedRoot, current, finishedWork);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                    }
                }
                flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                if (flags & 4) {
                    flags = pushNestedEffectDurations();
                    recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                    finishedRoot = finishedWork.stateNode;
                    finishedRoot.effectDuration += bubbleNestedEffectDurations(flags);
                    try {
                        runWithFiberInDEV(finishedWork, commitProfiler, finishedWork, current, commitStartTime, finishedRoot.effectDuration);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                } else recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                break;
            case 31:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                flags & 4 && commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (flags = retryDehydratedSuspenseBoundary.bind(null, finishedWork), registerSuspenseInstanceRetry(finishedRoot, flags))));
                break;
            case 22:
                flags = null !== finishedWork.memoizedState || offscreenSubtreeIsHidden;
                if (!flags) {
                    current = null !== current && null !== current.memoizedState || offscreenSubtreeWasHidden;
                    prevProps = offscreenSubtreeIsHidden;
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                    offscreenSubtreeIsHidden = flags;
                    (offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? (recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)), (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentReappeared(finishedWork, componentEffectStartTime, componentEffectEndTime)) : recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                    offscreenSubtreeIsHidden = prevProps;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                }
                break;
            case 30:
                break;
            default:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
        }
        (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && ((componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(finishedWork, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors), null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate && 0.05 < componentEffectEndTime - componentEffectStartTime && (isHydratingParent(finishedWork.return.alternate, finishedWork.return) || logComponentTrigger(finishedWork, componentEffectStartTime, componentEffectEndTime, "Mount")));
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectErrors = prevEffectErrors;
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
    }
    function detachFiberAfterEffects(fiber) {
        var alternate = fiber.alternate;
        null !== alternate && (fiber.alternate = null, detachFiberAfterEffects(alternate));
        fiber.child = null;
        fiber.deletions = null;
        fiber.sibling = null;
        5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && detachDeletedInstance(alternate));
        fiber.stateNode = null;
        fiber._debugOwner = null;
        fiber.return = null;
        fiber.dependencies = null;
        fiber.memoizedProps = null;
        fiber.memoizedState = null;
        fiber.pendingProps = null;
        fiber.stateNode = null;
        fiber.updateQueue = null;
    }
    function recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
        for(parent = parent.child; null !== parent;)commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
    }
    function commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
        if (injectedHook && "function" === typeof injectedHook.onCommitFiberUnmount) try {
            injectedHook.onCommitFiberUnmount(rendererID, deletedFiber);
        } catch (err) {
            hasLoggedError || (hasLoggedError = !0, console.error("React instrumentation encountered an error: %o", err));
        }
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate();
        switch(deletedFiber.tag){
            case 26:
                offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (finishedRoot = deletedFiber.stateNode, finishedRoot.parentNode.removeChild(finishedRoot));
                break;
            case 27:
                offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
                var prevHostParent = hostParent, prevHostParentIsContainer = hostParentIsContainer;
                isSingletonScope(deletedFiber.type) && (hostParent = deletedFiber.stateNode, hostParentIsContainer = !1);
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                runWithFiberInDEV(deletedFiber, releaseSingletonInstance, deletedFiber.stateNode);
                hostParent = prevHostParent;
                hostParentIsContainer = prevHostParentIsContainer;
                break;
            case 5:
                offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
            case 6:
                prevHostParent = hostParent;
                prevHostParentIsContainer = hostParentIsContainer;
                hostParent = null;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = prevHostParent;
                hostParentIsContainer = prevHostParentIsContainer;
                if (null !== hostParent) {
                    if (hostParentIsContainer) try {
                        runWithFiberInDEV(deletedFiber, removeChildFromContainer, hostParent, deletedFiber.stateNode);
                    } catch (error) {
                        captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                    }
                    else try {
                        runWithFiberInDEV(deletedFiber, removeChild, hostParent, deletedFiber.stateNode);
                    } catch (error) {
                        captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                    }
                }
                break;
            case 18:
                null !== hostParent && (hostParentIsContainer ? (finishedRoot = hostParent, clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), retryIfBlockedOn(finishedRoot)) : clearHydrationBoundary(hostParent, deletedFiber.stateNode));
                break;
            case 4:
                prevHostParent = hostParent;
                prevHostParentIsContainer = hostParentIsContainer;
                hostParent = deletedFiber.stateNode.containerInfo;
                hostParentIsContainer = !0;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = prevHostParent;
                hostParentIsContainer = prevHostParentIsContainer;
                break;
            case 0:
            case 11:
            case 14:
            case 15:
                commitHookEffectListUnmount(Insertion, deletedFiber, nearestMountedAncestor);
                offscreenSubtreeWasHidden || commitHookLayoutUnmountEffects(deletedFiber, nearestMountedAncestor, Layout);
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                break;
            case 1:
                offscreenSubtreeWasHidden || (safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                break;
            case 21:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                break;
            case 22:
                offscreenSubtreeWasHidden = (prevHostParent = offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                offscreenSubtreeWasHidden = prevHostParent;
                break;
            default:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
        }
        (deletedFiber.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(deletedFiber, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors);
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectErrors = prevEffectErrors;
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
    }
    function commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
        if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
            finishedRoot = finishedRoot.dehydrated;
            try {
                runWithFiberInDEV(finishedWork, commitHydratedActivityInstance, finishedRoot);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
        }
    }
    function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
        if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
            runWithFiberInDEV(finishedWork, commitHydratedSuspenseInstance, finishedRoot);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function getRetryCache(finishedWork) {
        switch(finishedWork.tag){
            case 31:
            case 13:
            case 19:
                var retryCache = finishedWork.stateNode;
                null === retryCache && (retryCache = finishedWork.stateNode = new PossiblyWeakSet());
                return retryCache;
            case 22:
                return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new PossiblyWeakSet()), retryCache;
            default:
                throw Error("Unexpected Suspense handler tag (" + finishedWork.tag + "). This is a bug in React.");
        }
    }
    function attachSuspenseRetryListeners(finishedWork, wakeables) {
        var retryCache = getRetryCache(finishedWork);
        wakeables.forEach(function(wakeable) {
            if (!retryCache.has(wakeable)) {
                retryCache.add(wakeable);
                if (isDevToolsPresent) {
                    if (null !== inProgressLanes && null !== inProgressRoot) restorePendingUpdaters(inProgressRoot, inProgressLanes);
                    else throw Error("Expected finished root and lanes to be set. This is a bug in React.");
                }
                var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
                wakeable.then(retry, retry);
            }
        });
    }
    function recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
        var deletions = parentFiber.deletions;
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var root = root$jscomp$0, returnFiber = parentFiber, deletedFiber = deletions[i], prevEffectStart = pushComponentEffectStart(), parent = returnFiber;
            a: for(; null !== parent;){
                switch(parent.tag){
                    case 27:
                        if (isSingletonScope(parent.type)) {
                            hostParent = parent.stateNode;
                            hostParentIsContainer = !1;
                            break a;
                        }
                        break;
                    case 5:
                        hostParent = parent.stateNode;
                        hostParentIsContainer = !1;
                        break a;
                    case 3:
                    case 4:
                        hostParent = parent.stateNode.containerInfo;
                        hostParentIsContainer = !0;
                        break a;
                }
                parent = parent.return;
            }
            if (null === hostParent) throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
            commitDeletionEffectsOnFiber(root, returnFiber, deletedFiber);
            hostParent = null;
            hostParentIsContainer = !1;
            (deletedFiber.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentTrigger(deletedFiber, componentEffectStartTime, componentEffectEndTime, "Unmount");
            popComponentEffectStart(prevEffectStart);
            root = deletedFiber;
            returnFiber = root.alternate;
            null !== returnFiber && (returnFiber.return = null);
            root.return = null;
        }
        if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
    }
    function commitMutationEffectsOnFiber(finishedWork, root) {
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate(), current = finishedWork.alternate, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                flags & 4 && (commitHookEffectListUnmount(Insertion | HasEffect, finishedWork, finishedWork.return), commitHookEffectListMount(Insertion | HasEffect, finishedWork), commitHookLayoutUnmountEffects(finishedWork, finishedWork.return, Layout | HasEffect));
                break;
            case 1:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
                if (flags & 64 && offscreenSubtreeIsHidden && (flags = finishedWork.updateQueue, null !== flags && (current = flags.callbacks, null !== current))) {
                    var existingHiddenCallbacks = flags.shared.hiddenCallbacks;
                    flags.shared.hiddenCallbacks = null === existingHiddenCallbacks ? current : existingHiddenCallbacks.concat(current);
                }
                break;
            case 26:
                existingHiddenCallbacks = currentHoistableRoot;
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
                if (flags & 4) {
                    var currentResource = null !== current ? current.memoizedState : null;
                    flags = finishedWork.memoizedState;
                    if (null === current) {
                        if (null === flags) {
                            if (null === finishedWork.stateNode) {
                                a: {
                                    flags = finishedWork.type;
                                    current = finishedWork.memoizedProps;
                                    existingHiddenCallbacks = existingHiddenCallbacks.ownerDocument || existingHiddenCallbacks;
                                    b: switch(flags){
                                        case "title":
                                            currentResource = existingHiddenCallbacks.getElementsByTagName("title")[0];
                                            if (!currentResource || currentResource[internalHoistableMarker] || currentResource[internalInstanceKey] || currentResource.namespaceURI === SVG_NAMESPACE || currentResource.hasAttribute("itemprop")) currentResource = existingHiddenCallbacks.createElement(flags), existingHiddenCallbacks.head.insertBefore(currentResource, existingHiddenCallbacks.querySelector("head > title"));
                                            setInitialProperties(currentResource, flags, current);
                                            currentResource[internalInstanceKey] = finishedWork;
                                            markNodeAsHoistable(currentResource);
                                            flags = currentResource;
                                            break a;
                                        case "link":
                                            var maybeNodes = getHydratableHoistableCache("link", "href", existingHiddenCallbacks).get(flags + (current.href || ""));
                                            if (maybeNodes) {
                                                for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                    maybeNodes.splice(i, 1);
                                                    break b;
                                                }
                                            }
                                            currentResource = existingHiddenCallbacks.createElement(flags);
                                            setInitialProperties(currentResource, flags, current);
                                            existingHiddenCallbacks.head.appendChild(currentResource);
                                            break;
                                        case "meta":
                                            if (maybeNodes = getHydratableHoistableCache("meta", "content", existingHiddenCallbacks).get(flags + (current.content || ""))) {
                                                for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], checkAttributeStringCoercion(current.content, "content"), currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                    maybeNodes.splice(i, 1);
                                                    break b;
                                                }
                                            }
                                            currentResource = existingHiddenCallbacks.createElement(flags);
                                            setInitialProperties(currentResource, flags, current);
                                            existingHiddenCallbacks.head.appendChild(currentResource);
                                            break;
                                        default:
                                            throw Error('getNodesForType encountered a type it did not expect: "' + flags + '". This is a bug in React.');
                                    }
                                    currentResource[internalInstanceKey] = finishedWork;
                                    markNodeAsHoistable(currentResource);
                                    flags = currentResource;
                                }
                                finishedWork.stateNode = flags;
                            } else mountHoistable(existingHiddenCallbacks, finishedWork.type, finishedWork.stateNode);
                        } else finishedWork.stateNode = acquireResource(existingHiddenCallbacks, flags, finishedWork.memoizedProps);
                    } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? mountHoistable(existingHiddenCallbacks, finishedWork.type, finishedWork.stateNode) : acquireResource(existingHiddenCallbacks, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
                }
                break;
            case 27:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
                null !== current && flags & 4 && commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
                break;
            case 5:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
                if (finishedWork.flags & 32) {
                    existingHiddenCallbacks = finishedWork.stateNode;
                    try {
                        runWithFiberInDEV(finishedWork, resetTextContent, existingHiddenCallbacks);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                flags & 4 && null != finishedWork.stateNode && (existingHiddenCallbacks = finishedWork.memoizedProps, commitHostUpdate(finishedWork, existingHiddenCallbacks, null !== current ? current.memoizedProps : existingHiddenCallbacks));
                flags & 1024 && (needsFormReset = !0, "form" !== finishedWork.type && console.error("Unexpected host component type. Expected a form. This is a bug in React."));
                break;
            case 6:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & 4) {
                    if (null === finishedWork.stateNode) throw Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
                    flags = finishedWork.memoizedProps;
                    current = null !== current ? current.memoizedProps : flags;
                    existingHiddenCallbacks = finishedWork.stateNode;
                    try {
                        runWithFiberInDEV(finishedWork, commitTextUpdate, existingHiddenCallbacks, current, flags);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                break;
            case 3:
                existingHiddenCallbacks = pushNestedEffectDurations();
                tagCaches = null;
                currentResource = currentHoistableRoot;
                currentHoistableRoot = getHoistableRoot(root.containerInfo);
                recursivelyTraverseMutationEffects(root, finishedWork);
                currentHoistableRoot = currentResource;
                commitReconciliationEffects(finishedWork);
                if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                    runWithFiberInDEV(finishedWork, commitHydratedContainer, root.containerInfo);
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                needsFormReset && (needsFormReset = !1, recursivelyResetForms(finishedWork));
                root.effectDuration += popNestedEffectDurations(existingHiddenCallbacks);
                break;
            case 4:
                flags = currentHoistableRoot;
                currentHoistableRoot = getHoistableRoot(finishedWork.stateNode.containerInfo);
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                currentHoistableRoot = flags;
                break;
            case 12:
                flags = pushNestedEffectDurations();
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                finishedWork.stateNode.effectDuration += bubbleNestedEffectDurations(flags);
                break;
            case 31:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
                break;
            case 13:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && (globalMostRecentFallbackTime = now$1());
                flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
                break;
            case 22:
                existingHiddenCallbacks = null !== finishedWork.memoizedState;
                var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || existingHiddenCallbacks;
                offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
                recursivelyTraverseMutationEffects(root, finishedWork);
                offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
                wasHidden && !existingHiddenCallbacks && !prevOffscreenSubtreeIsHidden && !prevOffscreenSubtreeWasHidden && (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentReappeared(finishedWork, componentEffectStartTime, componentEffectEndTime);
                commitReconciliationEffects(finishedWork);
                if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = existingHiddenCallbacks ? root._visibility & ~OffscreenVisible : root._visibility | OffscreenVisible, !existingHiddenCallbacks || null === current || wasHidden || offscreenSubtreeIsHidden || offscreenSubtreeWasHidden || (recursivelyTraverseDisappearLayoutEffects(finishedWork), (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentTrigger(finishedWork, componentEffectStartTime, componentEffectEndTime, "Disconnect")), current = null, root = finishedWork;;){
                    if (5 === root.tag || 26 === root.tag) {
                        if (null === current) {
                            wasHidden = current = root;
                            try {
                                currentResource = wasHidden.stateNode, existingHiddenCallbacks ? runWithFiberInDEV(wasHidden, hideInstance, currentResource) : runWithFiberInDEV(wasHidden, unhideInstance, wasHidden.stateNode, wasHidden.memoizedProps);
                            } catch (error) {
                                captureCommitPhaseError(wasHidden, wasHidden.return, error);
                            }
                        }
                    } else if (6 === root.tag) {
                        if (null === current) {
                            wasHidden = root;
                            try {
                                maybeNodes = wasHidden.stateNode, existingHiddenCallbacks ? runWithFiberInDEV(wasHidden, hideTextInstance, maybeNodes) : runWithFiberInDEV(wasHidden, unhideTextInstance, maybeNodes, wasHidden.memoizedProps);
                            } catch (error) {
                                captureCommitPhaseError(wasHidden, wasHidden.return, error);
                            }
                        }
                    } else if (18 === root.tag) {
                        if (null === current) {
                            wasHidden = root;
                            try {
                                i = wasHidden.stateNode, existingHiddenCallbacks ? runWithFiberInDEV(wasHidden, hideDehydratedBoundary, i) : runWithFiberInDEV(wasHidden, unhideDehydratedBoundary, wasHidden.stateNode);
                            } catch (error) {
                                captureCommitPhaseError(wasHidden, wasHidden.return, error);
                            }
                        }
                    } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                        root.child.return = root;
                        root = root.child;
                        continue;
                    }
                    if (root === finishedWork) break a;
                    for(; null === root.sibling;){
                        if (null === root.return || root.return === finishedWork) break a;
                        current === root && (current = null);
                        root = root.return;
                    }
                    current === root && (current = null);
                    root.sibling.return = root.return;
                    root = root.sibling;
                }
                flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, attachSuspenseRetryListeners(finishedWork, current))));
                break;
            case 19:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
                break;
            case 30:
                break;
            case 21:
                break;
            default:
                recursivelyTraverseMutationEffects(root, finishedWork), commitReconciliationEffects(finishedWork);
        }
        (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && ((componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(finishedWork, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors), null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate && 0.05 < componentEffectEndTime - componentEffectStartTime && (isHydratingParent(finishedWork.return.alternate, finishedWork.return) || logComponentTrigger(finishedWork, componentEffectStartTime, componentEffectEndTime, "Mount")));
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectErrors = prevEffectErrors;
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
    }
    function commitReconciliationEffects(finishedWork) {
        var flags = finishedWork.flags;
        if (flags & 2) {
            try {
                runWithFiberInDEV(finishedWork, commitPlacement, finishedWork);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            finishedWork.flags &= -3;
        }
        flags & 4096 && (finishedWork.flags &= -4097);
    }
    function recursivelyResetForms(parentFiber) {
        if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
            var fiber = parentFiber;
            recursivelyResetForms(fiber);
            5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
            parentFiber = parentFiber.sibling;
        }
    }
    function recursivelyTraverseLayoutEffects(root, parentFiber) {
        if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
    }
    function disappearLayoutEffects(finishedWork) {
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate();
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                commitHookLayoutUnmountEffects(finishedWork, finishedWork.return, Layout);
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                runWithFiberInDEV(finishedWork, releaseSingletonInstance, finishedWork.stateNode);
            case 26:
            case 5:
                safelyDetachRef(finishedWork, finishedWork.return);
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(finishedWork, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors);
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectErrors = prevEffectErrors;
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
    }
    function recursivelyTraverseDisappearLayoutEffects(parentFiber) {
        for(parentFiber = parentFiber.child; null !== parentFiber;)disappearLayoutEffects(parentFiber), parentFiber = parentFiber.sibling;
    }
    function reappearLayoutEffects(finishedRoot, current, finishedWork, includeWorkInProgressEffects) {
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate(), flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                commitHookLayoutEffects(finishedWork, Layout);
                break;
            case 1:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork.stateNode;
                "function" === typeof current.componentDidMount && runWithFiberInDEV(finishedWork, callComponentDidMountInDEV, finishedWork, current);
                current = finishedWork.updateQueue;
                if (null !== current) {
                    finishedRoot = finishedWork.stateNode;
                    try {
                        runWithFiberInDEV(finishedWork, commitHiddenCallbacks, current, finishedRoot);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && commitClassCallbacks(finishedWork);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && commitHostMount(finishedWork);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                if (includeWorkInProgressEffects && flags & 4) {
                    flags = pushNestedEffectDurations();
                    recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                    includeWorkInProgressEffects = finishedWork.stateNode;
                    includeWorkInProgressEffects.effectDuration += bubbleNestedEffectDurations(flags);
                    try {
                        runWithFiberInDEV(finishedWork, commitProfiler, finishedWork, current, commitStartTime, includeWorkInProgressEffects.effectDuration);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                } else recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(finishedWork, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors);
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectErrors = prevEffectErrors;
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
    }
    function recursivelyTraverseReappearLayoutEffects(finishedRoot, parentFiber, includeWorkInProgressEffects) {
        includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
        for(parentFiber = parentFiber.child; null !== parentFiber;)reappearLayoutEffects(finishedRoot, parentFiber.alternate, parentFiber, includeWorkInProgressEffects), parentFiber = parentFiber.sibling;
    }
    function commitOffscreenPassiveMountEffects(current, finishedWork) {
        var previousCache = null;
        null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
        current = null;
        null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
        current !== previousCache && (null != current && retainCache(current), null != previousCache && releaseCache(previousCache));
    }
    function commitCachePassiveMountEffect(current, finishedWork) {
        current = null;
        null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
        finishedWork = finishedWork.memoizedState.cache;
        finishedWork !== current && (retainCache(finishedWork), null != current && releaseCache(current));
    }
    function recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions, endTime) {
        if (parentFiber.subtreeFlags & 10256 || 0 !== parentFiber.actualDuration && (null === parentFiber.alternate || parentFiber.alternate.child !== parentFiber.child)) for(parentFiber = parentFiber.child; null !== parentFiber;){
            var nextSibling = parentFiber.sibling;
            commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions, null !== nextSibling ? nextSibling.actualStartTime : endTime);
            parentFiber = nextSibling;
        }
    }
    function commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime) {
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate(), prevDeepEquality = alreadyWarnedForDeepEquality, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                (finishedWork.mode & ProfileMode) !== NoMode && 0 < finishedWork.actualStartTime && 0 !== (finishedWork.flags & 1) && logComponentRender(finishedWork, finishedWork.actualStartTime, endTime, inHydratedSubtree, committedLanes);
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
                flags & 2048 && commitHookPassiveMountEffects(finishedWork, Passive | HasEffect);
                break;
            case 1:
                (finishedWork.mode & ProfileMode) !== NoMode && 0 < finishedWork.actualStartTime && (0 !== (finishedWork.flags & 128) ? logComponentErrored(finishedWork, finishedWork.actualStartTime, endTime, []) : 0 !== (finishedWork.flags & 1) && logComponentRender(finishedWork, finishedWork.actualStartTime, endTime, inHydratedSubtree, committedLanes));
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
                break;
            case 3:
                var prevProfilerEffectDuration = pushNestedEffectDurations(), wasInHydratedSubtree = inHydratedSubtree;
                inHydratedSubtree = null !== finishedWork.alternate && finishedWork.alternate.memoizedState.isDehydrated && 0 === (finishedWork.flags & 256);
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
                inHydratedSubtree = wasInHydratedSubtree;
                flags & 2048 && (committedLanes = null, null !== finishedWork.alternate && (committedLanes = finishedWork.alternate.memoizedState.cache), committedTransitions = finishedWork.memoizedState.cache, committedTransitions !== committedLanes && (retainCache(committedTransitions), null != committedLanes && releaseCache(committedLanes)));
                finishedRoot.passiveEffectDuration += popNestedEffectDurations(prevProfilerEffectDuration);
                break;
            case 12:
                if (flags & 2048) {
                    flags = pushNestedEffectDurations();
                    recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
                    finishedRoot = finishedWork.stateNode;
                    finishedRoot.passiveEffectDuration += bubbleNestedEffectDurations(flags);
                    try {
                        runWithFiberInDEV(finishedWork, commitProfilerPostCommitImpl, finishedWork, finishedWork.alternate, commitStartTime, finishedRoot.passiveEffectDuration);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                } else recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
                break;
            case 31:
                flags = inHydratedSubtree;
                prevProfilerEffectDuration = null !== finishedWork.alternate ? finishedWork.alternate.memoizedState : null;
                wasInHydratedSubtree = finishedWork.memoizedState;
                null !== prevProfilerEffectDuration && null === wasInHydratedSubtree ? (wasInHydratedSubtree = finishedWork.deletions, null !== wasInHydratedSubtree && 0 < wasInHydratedSubtree.length && 18 === wasInHydratedSubtree[0].tag ? (inHydratedSubtree = !1, prevProfilerEffectDuration = prevProfilerEffectDuration.hydrationErrors, null !== prevProfilerEffectDuration && logComponentErrored(finishedWork, finishedWork.actualStartTime, endTime, prevProfilerEffectDuration)) : inHydratedSubtree = !0) : inHydratedSubtree = !1;
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
                inHydratedSubtree = flags;
                break;
            case 13:
                flags = inHydratedSubtree;
                prevProfilerEffectDuration = null !== finishedWork.alternate ? finishedWork.alternate.memoizedState : null;
                wasInHydratedSubtree = finishedWork.memoizedState;
                null === prevProfilerEffectDuration || null === prevProfilerEffectDuration.dehydrated || null !== wasInHydratedSubtree && null !== wasInHydratedSubtree.dehydrated ? inHydratedSubtree = !1 : (wasInHydratedSubtree = finishedWork.deletions, null !== wasInHydratedSubtree && 0 < wasInHydratedSubtree.length && 18 === wasInHydratedSubtree[0].tag ? (inHydratedSubtree = !1, prevProfilerEffectDuration = prevProfilerEffectDuration.hydrationErrors, null !== prevProfilerEffectDuration && logComponentErrored(finishedWork, finishedWork.actualStartTime, endTime, prevProfilerEffectDuration)) : inHydratedSubtree = !0);
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
                inHydratedSubtree = flags;
                break;
            case 23:
                break;
            case 22:
                wasInHydratedSubtree = finishedWork.stateNode;
                prevProfilerEffectDuration = finishedWork.alternate;
                null !== finishedWork.memoizedState ? wasInHydratedSubtree._visibility & OffscreenPassiveEffectsConnected ? recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime) : recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime) : wasInHydratedSubtree._visibility & OffscreenPassiveEffectsConnected ? recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime) : (wasInHydratedSubtree._visibility |= OffscreenPassiveEffectsConnected, recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || 0 !== finishedWork.actualDuration && (null === finishedWork.alternate || finishedWork.alternate.child !== finishedWork.child), endTime), (finishedWork.mode & ProfileMode) === NoMode || inHydratedSubtree || (finishedRoot = finishedWork.actualStartTime, 0 <= finishedRoot && 0.05 < endTime - finishedRoot && logComponentReappeared(finishedWork, finishedRoot, endTime), 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentReappeared(finishedWork, componentEffectStartTime, componentEffectEndTime)));
                flags & 2048 && commitOffscreenPassiveMountEffects(prevProfilerEffectDuration, finishedWork);
                break;
            case 24:
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
                flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
        }
        if ((finishedWork.mode & ProfileMode) !== NoMode) {
            if (finishedRoot = !inHydratedSubtree && null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate) committedLanes = finishedWork.actualStartTime, 0 <= committedLanes && 0.05 < endTime - committedLanes && logComponentTrigger(finishedWork, committedLanes, endTime, "Mount");
            0 <= componentEffectStartTime && 0 <= componentEffectEndTime && ((componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(finishedWork, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors), finishedRoot && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentTrigger(finishedWork, componentEffectStartTime, componentEffectEndTime, "Mount"));
        }
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectErrors = prevEffectErrors;
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
        alreadyWarnedForDeepEquality = prevDeepEquality;
    }
    function recursivelyTraverseReconnectPassiveEffects(finishedRoot, parentFiber, committedLanes, committedTransitions, includeWorkInProgressEffects, endTime) {
        includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || 0 !== parentFiber.actualDuration && (null === parentFiber.alternate || parentFiber.alternate.child !== parentFiber.child));
        for(parentFiber = parentFiber.child; null !== parentFiber;){
            var nextSibling = parentFiber.sibling;
            reconnectPassiveEffects(finishedRoot, parentFiber, committedLanes, committedTransitions, includeWorkInProgressEffects, null !== nextSibling ? nextSibling.actualStartTime : endTime);
            parentFiber = nextSibling;
        }
    }
    function reconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects, endTime) {
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate(), prevDeepEquality = alreadyWarnedForDeepEquality;
        includeWorkInProgressEffects && (finishedWork.mode & ProfileMode) !== NoMode && 0 < finishedWork.actualStartTime && 0 !== (finishedWork.flags & 1) && logComponentRender(finishedWork, finishedWork.actualStartTime, endTime, inHydratedSubtree, committedLanes);
        var flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects, endTime);
                commitHookPassiveMountEffects(finishedWork, Passive);
                break;
            case 23:
                break;
            case 22:
                var _instance2 = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? _instance2._visibility & OffscreenPassiveEffectsConnected ? recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects, endTime) : recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime) : (_instance2._visibility |= OffscreenPassiveEffectsConnected, recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects, endTime));
                includeWorkInProgressEffects && flags & 2048 && commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects, endTime);
                includeWorkInProgressEffects && flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects, endTime);
        }
        (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(finishedWork, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors);
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectErrors = prevEffectErrors;
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
        alreadyWarnedForDeepEquality = prevDeepEquality;
    }
    function recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, endTime$jscomp$0) {
        if (parentFiber.subtreeFlags & 10256 || 0 !== parentFiber.actualDuration && (null === parentFiber.alternate || parentFiber.alternate.child !== parentFiber.child)) for(var child = parentFiber.child; null !== child;){
            parentFiber = child.sibling;
            var finishedRoot = finishedRoot$jscomp$0, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, endTime = null !== parentFiber ? parentFiber.actualStartTime : endTime$jscomp$0, prevDeepEquality = alreadyWarnedForDeepEquality;
            (child.mode & ProfileMode) !== NoMode && 0 < child.actualStartTime && 0 !== (child.flags & 1) && logComponentRender(child, child.actualStartTime, endTime, inHydratedSubtree, committedLanes);
            var flags = child.flags;
            switch(child.tag){
                case 22:
                    recursivelyTraverseAtomicPassiveEffects(finishedRoot, child, committedLanes, committedTransitions, endTime);
                    flags & 2048 && commitOffscreenPassiveMountEffects(child.alternate, child);
                    break;
                case 24:
                    recursivelyTraverseAtomicPassiveEffects(finishedRoot, child, committedLanes, committedTransitions, endTime);
                    flags & 2048 && commitCachePassiveMountEffect(child.alternate, child);
                    break;
                default:
                    recursivelyTraverseAtomicPassiveEffects(finishedRoot, child, committedLanes, committedTransitions, endTime);
            }
            alreadyWarnedForDeepEquality = prevDeepEquality;
            child = parentFiber;
        }
    }
    function recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
        if (parentFiber.subtreeFlags & suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
    }
    function accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
        switch(fiber.tag){
            case 26:
                recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
                fiber.flags & suspenseyCommitFlag && null !== fiber.memoizedState && suspendResource(suspendedState, currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
                break;
            case 5:
                recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
                break;
            case 3:
            case 4:
                var previousHoistableRoot = currentHoistableRoot;
                currentHoistableRoot = getHoistableRoot(fiber.stateNode.containerInfo);
                recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
                currentHoistableRoot = previousHoistableRoot;
                break;
            case 22:
                null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = suspenseyCommitFlag, suspenseyCommitFlag = 16777216, recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), suspenseyCommitFlag = previousHoistableRoot) : recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
                break;
            default:
                recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
        }
    }
    function detachAlternateSiblings(parentFiber) {
        var previousFiber = parentFiber.alternate;
        if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
            previousFiber.child = null;
            do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
            while (null !== parentFiber);
        }
    }
    function recursivelyTraversePassiveUnmountEffects(parentFiber) {
        var deletions = parentFiber.deletions;
        if (0 !== (parentFiber.flags & 16)) {
            if (null !== deletions) for(var i = 0; i < deletions.length; i++){
                var childToDelete = deletions[i], prevEffectStart = pushComponentEffectStart();
                nextEffect = childToDelete;
                commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
                (childToDelete.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentTrigger(childToDelete, componentEffectStartTime, componentEffectEndTime, "Unmount");
                popComponentEffectStart(prevEffectStart);
            }
            detachAlternateSiblings(parentFiber);
        }
        if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
    }
    function commitPassiveUnmountOnFiber(finishedWork) {
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate();
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraversePassiveUnmountEffects(finishedWork);
                finishedWork.flags & 2048 && commitHookPassiveUnmountEffects(finishedWork, finishedWork.return, Passive | HasEffect);
                break;
            case 3:
                var prevProfilerEffectDuration = pushNestedEffectDurations();
                recursivelyTraversePassiveUnmountEffects(finishedWork);
                finishedWork.stateNode.passiveEffectDuration += popNestedEffectDurations(prevProfilerEffectDuration);
                break;
            case 12:
                prevProfilerEffectDuration = pushNestedEffectDurations();
                recursivelyTraversePassiveUnmountEffects(finishedWork);
                finishedWork.stateNode.passiveEffectDuration += bubbleNestedEffectDurations(prevProfilerEffectDuration);
                break;
            case 22:
                prevProfilerEffectDuration = finishedWork.stateNode;
                null !== finishedWork.memoizedState && prevProfilerEffectDuration._visibility & OffscreenPassiveEffectsConnected && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (prevProfilerEffectDuration._visibility &= ~OffscreenPassiveEffectsConnected, recursivelyTraverseDisconnectPassiveEffects(finishedWork), (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentTrigger(finishedWork, componentEffectStartTime, componentEffectEndTime, "Disconnect")) : recursivelyTraversePassiveUnmountEffects(finishedWork);
                break;
            default:
                recursivelyTraversePassiveUnmountEffects(finishedWork);
        }
        (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(finishedWork, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors);
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
        componentEffectErrors = prevEffectErrors;
    }
    function recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
        var deletions = parentFiber.deletions;
        if (0 !== (parentFiber.flags & 16)) {
            if (null !== deletions) for(var i = 0; i < deletions.length; i++){
                var childToDelete = deletions[i], prevEffectStart = pushComponentEffectStart();
                nextEffect = childToDelete;
                commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
                (childToDelete.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentTrigger(childToDelete, componentEffectStartTime, componentEffectEndTime, "Unmount");
                popComponentEffectStart(prevEffectStart);
            }
            detachAlternateSiblings(parentFiber);
        }
        for(parentFiber = parentFiber.child; null !== parentFiber;)disconnectPassiveEffect(parentFiber), parentFiber = parentFiber.sibling;
    }
    function disconnectPassiveEffect(finishedWork) {
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate();
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                commitHookPassiveUnmountEffects(finishedWork, finishedWork.return, Passive);
                recursivelyTraverseDisconnectPassiveEffects(finishedWork);
                break;
            case 22:
                var instance = finishedWork.stateNode;
                instance._visibility & OffscreenPassiveEffectsConnected && (instance._visibility &= ~OffscreenPassiveEffectsConnected, recursivelyTraverseDisconnectPassiveEffects(finishedWork));
                break;
            default:
                recursivelyTraverseDisconnectPassiveEffects(finishedWork);
        }
        (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(finishedWork, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors);
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
        componentEffectErrors = prevEffectErrors;
    }
    function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor$jscomp$0) {
        for(; null !== nextEffect;){
            var fiber = nextEffect, current = fiber, nearestMountedAncestor = nearestMountedAncestor$jscomp$0, prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate();
            switch(current.tag){
                case 0:
                case 11:
                case 15:
                    commitHookPassiveUnmountEffects(current, nearestMountedAncestor, Passive);
                    break;
                case 23:
                case 22:
                    null !== current.memoizedState && null !== current.memoizedState.cachePool && (nearestMountedAncestor = current.memoizedState.cachePool.pool, null != nearestMountedAncestor && retainCache(nearestMountedAncestor));
                    break;
                case 24:
                    releaseCache(current.memoizedState.cache);
            }
            (current.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(current, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors);
            popComponentEffectStart(prevEffectStart);
            popComponentEffectDuration(prevEffectDuration);
            componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
            componentEffectErrors = prevEffectErrors;
            current = fiber.child;
            if (null !== current) current.return = fiber, nextEffect = current;
            else a: for(fiber = deletedSubtreeRoot; null !== nextEffect;){
                current = nextEffect;
                prevEffectStart = current.sibling;
                prevEffectDuration = current.return;
                detachFiberAfterEffects(current);
                if (current === fiber) {
                    nextEffect = null;
                    break a;
                }
                if (null !== prevEffectStart) {
                    prevEffectStart.return = prevEffectDuration;
                    nextEffect = prevEffectStart;
                    break a;
                }
                nextEffect = prevEffectDuration;
            }
        }
    }
    function onCommitRoot() {
        commitHooks.forEach(function(commitHook) {
            return commitHook();
        });
    }
    function isConcurrentActEnvironment() {
        var isReactActEnvironmentGlobal = "undefined" !== typeof IS_REACT_ACT_ENVIRONMENT ? IS_REACT_ACT_ENVIRONMENT : void 0;
        isReactActEnvironmentGlobal || null === ReactSharedInternals.actQueue || console.error("The current testing environment is not configured to support act(...)");
        return isReactActEnvironmentGlobal;
    }
    function requestUpdateLane(fiber) {
        if ((executionContext & RenderContext) !== NoContext && 0 !== workInProgressRootRenderLanes) return workInProgressRootRenderLanes & -workInProgressRootRenderLanes;
        var transition = ReactSharedInternals.T;
        return null !== transition ? (transition._updatedFibers || (transition._updatedFibers = new Set()), transition._updatedFibers.add(fiber), requestTransitionLane()) : resolveUpdatePriority();
    }
    function requestDeferredLane() {
        if (0 === workInProgressDeferredLane) {
            if (0 === (workInProgressRootRenderLanes & 536870912) || isHydrating) {
                var lane = nextTransitionDeferredLane;
                nextTransitionDeferredLane <<= 1;
                0 === (nextTransitionDeferredLane & 3932160) && (nextTransitionDeferredLane = 262144);
                workInProgressDeferredLane = lane;
            } else workInProgressDeferredLane = 536870912;
        }
        lane = suspenseHandlerStackCursor.current;
        null !== lane && (lane.flags |= 32);
        return workInProgressDeferredLane;
    }
    function scheduleUpdateOnFiber(root, fiber, lane) {
        isRunningInsertionEffect && console.error("useInsertionEffect must not schedule updates.");
        isFlushingPassiveEffects && (didScheduleUpdateDuringPassiveEffects = !0);
        if (root === workInProgressRoot && (workInProgressSuspendedReason === SuspendedOnData || workInProgressSuspendedReason === SuspendedOnAction) || null !== root.cancelPendingCommit) prepareFreshStack(root, 0), markRootSuspended(root, workInProgressRootRenderLanes, workInProgressDeferredLane, !1);
        markRootUpdated$1(root, lane);
        if ((executionContext & RenderContext) !== NoContext && root === workInProgressRoot) {
            if (isRendering) switch(fiber.tag){
                case 0:
                case 11:
                case 15:
                    root = workInProgress && getComponentNameFromFiber(workInProgress) || "Unknown";
                    didWarnAboutUpdateInRenderForAnotherComponent.has(root) || (didWarnAboutUpdateInRenderForAnotherComponent.add(root), fiber = getComponentNameFromFiber(fiber) || "Unknown", console.error("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://react.dev/link/setstate-in-render", fiber, root, root));
                    break;
                case 1:
                    didWarnAboutUpdateInRender || (console.error("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), didWarnAboutUpdateInRender = !0);
            }
        } else isDevToolsPresent && addFiberToLanesMap(root, fiber, lane), warnIfUpdatesNotWrappedWithActDEV(fiber), root === workInProgressRoot && ((executionContext & RenderContext) === NoContext && (workInProgressRootInterleavedUpdatedLanes |= lane), workInProgressRootExitStatus === RootSuspendedWithDelay && markRootSuspended(root, workInProgressRootRenderLanes, workInProgressDeferredLane, !1)), ensureRootIsScheduled(root);
    }
    function performWorkOnRoot(root, lanes, forceSync) {
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw Error("Should not already be working.");
        if (0 !== workInProgressRootRenderLanes && null !== workInProgress) {
            var yieldedFiber = workInProgress, yieldEndTime = now$1();
            switch(yieldReason){
                case SuspendedOnImmediate:
                case SuspendedOnData:
                    var startTime = yieldStartTime;
                    supportsUserTiming && ((yieldedFiber = yieldedFiber._debugTask) ? yieldedFiber.run(console.timeStamp.bind(console, "Suspended", startTime, yieldEndTime, COMPONENTS_TRACK, void 0, "primary-light")) : console.timeStamp("Suspended", startTime, yieldEndTime, COMPONENTS_TRACK, void 0, "primary-light"));
                    break;
                case SuspendedOnAction:
                    startTime = yieldStartTime;
                    supportsUserTiming && ((yieldedFiber = yieldedFiber._debugTask) ? yieldedFiber.run(console.timeStamp.bind(console, "Action", startTime, yieldEndTime, COMPONENTS_TRACK, void 0, "primary-light")) : console.timeStamp("Action", startTime, yieldEndTime, COMPONENTS_TRACK, void 0, "primary-light"));
                    break;
                default:
                    supportsUserTiming && (yieldedFiber = yieldEndTime - yieldStartTime, 3 > yieldedFiber || console.timeStamp("Blocked", yieldStartTime, yieldEndTime, COMPONENTS_TRACK, void 0, 5 > yieldedFiber ? "primary-light" : 10 > yieldedFiber ? "primary" : 100 > yieldedFiber ? "primary-dark" : "error"));
            }
        }
        startTime = (forceSync = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root.expiredLanes) || checkIfRootIsPrerendering(root, lanes)) ? renderRootConcurrent(root, lanes) : renderRootSync(root, lanes, !0);
        var renderWasConcurrent = forceSync;
        do {
            if (startTime === RootInProgress) {
                workInProgressRootIsPrerendering && !forceSync && markRootSuspended(root, lanes, 0, !1);
                lanes = workInProgressSuspendedReason;
                yieldStartTime = now();
                yieldReason = lanes;
                break;
            } else {
                yieldedFiber = now$1();
                yieldEndTime = root.current.alternate;
                if (renderWasConcurrent && !isRenderConsistentWithExternalStores(yieldEndTime)) {
                    setCurrentTrackFromLanes(lanes);
                    yieldEndTime = renderStartTime;
                    startTime = yieldedFiber;
                    !supportsUserTiming || startTime <= yieldEndTime || (workInProgressUpdateTask ? workInProgressUpdateTask.run(console.timeStamp.bind(console, "Teared Render", yieldEndTime, startTime, currentTrack, LANES_TRACK_GROUP, "error")) : console.timeStamp("Teared Render", yieldEndTime, startTime, currentTrack, LANES_TRACK_GROUP, "error"));
                    finalizeRender(lanes, yieldedFiber);
                    startTime = renderRootSync(root, lanes, !1);
                    renderWasConcurrent = !1;
                    continue;
                }
                if (startTime === RootErrored) {
                    renderWasConcurrent = lanes;
                    if (root.errorRecoveryDisabledLanes & renderWasConcurrent) var errorRetryLanes = 0;
                    else errorRetryLanes = root.pendingLanes & -536870913, errorRetryLanes = 0 !== errorRetryLanes ? errorRetryLanes : errorRetryLanes & 536870912 ? 536870912 : 0;
                    if (0 !== errorRetryLanes) {
                        setCurrentTrackFromLanes(lanes);
                        logErroredRenderPhase(renderStartTime, yieldedFiber, lanes, workInProgressUpdateTask);
                        finalizeRender(lanes, yieldedFiber);
                        lanes = errorRetryLanes;
                        a: {
                            yieldedFiber = root;
                            startTime = renderWasConcurrent;
                            renderWasConcurrent = workInProgressRootConcurrentErrors;
                            var wasRootDehydrated = yieldedFiber.current.memoizedState.isDehydrated;
                            wasRootDehydrated && (prepareFreshStack(yieldedFiber, errorRetryLanes).flags |= 256);
                            errorRetryLanes = renderRootSync(yieldedFiber, errorRetryLanes, !1);
                            if (errorRetryLanes !== RootErrored) {
                                if (workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                    yieldedFiber.errorRecoveryDisabledLanes |= startTime;
                                    workInProgressRootInterleavedUpdatedLanes |= startTime;
                                    startTime = RootSuspendedWithDelay;
                                    break a;
                                }
                                yieldedFiber = workInProgressRootRecoverableErrors;
                                workInProgressRootRecoverableErrors = renderWasConcurrent;
                                null !== yieldedFiber && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = yieldedFiber : workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, yieldedFiber));
                            }
                            startTime = errorRetryLanes;
                        }
                        renderWasConcurrent = !1;
                        if (startTime !== RootErrored) continue;
                        else yieldedFiber = now$1();
                    }
                }
                if (startTime === RootFatalErrored) {
                    setCurrentTrackFromLanes(lanes);
                    logErroredRenderPhase(renderStartTime, yieldedFiber, lanes, workInProgressUpdateTask);
                    finalizeRender(lanes, yieldedFiber);
                    prepareFreshStack(root, 0);
                    markRootSuspended(root, lanes, 0, !0);
                    break;
                }
                a: {
                    forceSync = root;
                    switch(startTime){
                        case RootInProgress:
                        case RootFatalErrored:
                            throw Error("Root did not complete. This is a bug in React.");
                        case RootSuspendedWithDelay:
                            if ((lanes & 4194048) !== lanes) break;
                        case RootSuspendedAtTheShell:
                            setCurrentTrackFromLanes(lanes);
                            logSuspendedRenderPhase(renderStartTime, yieldedFiber, lanes, workInProgressUpdateTask);
                            finalizeRender(lanes, yieldedFiber);
                            yieldEndTime = lanes;
                            0 !== (yieldEndTime & 127) ? blockingSuspendedTime = yieldedFiber : 0 !== (yieldEndTime & 4194048) && (transitionSuspendedTime = yieldedFiber);
                            markRootSuspended(forceSync, lanes, workInProgressDeferredLane, !workInProgressRootDidSkipSuspendedSiblings);
                            break a;
                        case RootErrored:
                            workInProgressRootRecoverableErrors = null;
                            break;
                        case RootSuspended:
                        case RootCompleted:
                            break;
                        default:
                            throw Error("Unknown root exit status.");
                    }
                    if (null !== ReactSharedInternals.actQueue) commitRoot(forceSync, yieldEndTime, lanes, workInProgressRootRecoverableErrors, workInProgressTransitions, workInProgressRootDidIncludeRecursiveRenderUpdate, workInProgressDeferredLane, workInProgressRootInterleavedUpdatedLanes, workInProgressSuspendedRetryLanes, startTime, null, null, renderStartTime, yieldedFiber);
                    else {
                        if ((lanes & 62914560) === lanes && (renderWasConcurrent = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now$1(), 10 < renderWasConcurrent)) {
                            markRootSuspended(forceSync, lanes, workInProgressDeferredLane, !workInProgressRootDidSkipSuspendedSiblings);
                            if (0 !== getNextLanes(forceSync, 0, !0)) break a;
                            pendingEffectsLanes = lanes;
                            forceSync.timeoutHandle = scheduleTimeout(commitRootWhenReady.bind(null, forceSync, yieldEndTime, workInProgressRootRecoverableErrors, workInProgressTransitions, workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, workInProgressDeferredLane, workInProgressRootInterleavedUpdatedLanes, workInProgressSuspendedRetryLanes, workInProgressRootDidSkipSuspendedSiblings, startTime, "Throttled", renderStartTime, yieldedFiber), renderWasConcurrent);
                            break a;
                        }
                        commitRootWhenReady(forceSync, yieldEndTime, workInProgressRootRecoverableErrors, workInProgressTransitions, workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, workInProgressDeferredLane, workInProgressRootInterleavedUpdatedLanes, workInProgressSuspendedRetryLanes, workInProgressRootDidSkipSuspendedSiblings, startTime, null, renderStartTime, yieldedFiber);
                    }
                }
            }
            break;
        }while (1);
        ensureRootIsScheduled(root);
    }
    function commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
        root.timeoutHandle = noTimeout;
        var subtreeFlags = finishedWork.subtreeFlags, suspendedState = null;
        if (subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
            if (suspendedState = {
                stylesheets: null,
                count: 0,
                imgCount: 0,
                imgBytes: 0,
                suspenseyImages: [],
                waitingForImages: !0,
                waitingForViewTransition: !1,
                unsuspend: noop$1
            }, accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedState), subtreeFlags = (lanes & 62914560) === lanes ? globalMostRecentFallbackTime - now$1() : (lanes & 4194048) === lanes ? globalMostRecentTransitionTime - now$1() : 0, subtreeFlags = waitForCommitToBeReady(suspendedState, subtreeFlags), null !== subtreeFlags) {
                pendingEffectsLanes = lanes;
                root.cancelPendingCommit = subtreeFlags(commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedState, suspendedState.waitingForViewTransition ? "Waiting for the previous Animation" : 0 < suspendedState.count ? 0 < suspendedState.imgCount ? "Suspended on CSS and Images" : "Suspended on CSS" : 1 === suspendedState.imgCount ? "Suspended on an Image" : 0 < suspendedState.imgCount ? "Suspended on Images" : null, completedRenderStartTime, completedRenderEndTime));
                markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
                return;
            }
        }
        commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedState, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
    }
    function isRenderConsistentWithExternalStores(finishedWork) {
        for(var node = finishedWork;;){
            var tag = node.tag;
            if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
                var check = tag[i], getSnapshot = check.getSnapshot;
                check = check.value;
                try {
                    if (!objectIs(getSnapshot(), check)) return !1;
                } catch (error) {
                    return !1;
                }
            }
            tag = node.child;
            if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
            else {
                if (node === finishedWork) break;
                for(; null === node.sibling;){
                    if (null === node.return || node.return === finishedWork) return !0;
                    node = node.return;
                }
                node.sibling.return = node.return;
                node = node.sibling;
            }
        }
        return !0;
    }
    function markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
        suspendedLanes &= ~workInProgressRootPingedLanes;
        suspendedLanes &= ~workInProgressRootInterleavedUpdatedLanes;
        root.suspendedLanes |= suspendedLanes;
        root.pingedLanes &= ~suspendedLanes;
        didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
        didAttemptEntireTree = root.expirationTimes;
        for(var lanes = suspendedLanes; 0 < lanes;){
            var index = 31 - clz32(lanes), lane = 1 << index;
            didAttemptEntireTree[index] = -1;
            lanes &= ~lane;
        }
        0 !== spawnedLane && markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
    }
    function flushSyncWork$1() {
        return (executionContext & (RenderContext | CommitContext)) === NoContext ? (flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
    }
    function resetWorkInProgressStack() {
        if (null !== workInProgress) {
            if (workInProgressSuspendedReason === NotSuspended) var interruptedWork = workInProgress.return;
            else interruptedWork = workInProgress, resetContextDependencies(), resetHooksOnUnwind(interruptedWork), thenableState$1 = null, thenableIndexCounter$1 = 0, interruptedWork = workInProgress;
            for(; null !== interruptedWork;)unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
            workInProgress = null;
        }
    }
    function finalizeRender(lanes, finalizationTime) {
        0 !== (lanes & 127) && (blockingClampTime = finalizationTime);
        0 !== (lanes & 4194048) && (transitionClampTime = finalizationTime);
        0 !== (lanes & 62914560) && (retryClampTime = finalizationTime);
        0 !== (lanes & 2080374784) && (idleClampTime = finalizationTime);
    }
    function prepareFreshStack(root, lanes) {
        supportsUserTiming && (console.timeStamp("Blocking Track", 0.003, 0.003, "Blocking", LANES_TRACK_GROUP, "primary-light"), console.timeStamp("Transition Track", 0.003, 0.003, "Transition", LANES_TRACK_GROUP, "primary-light"), console.timeStamp("Suspense Track", 0.003, 0.003, "Suspense", LANES_TRACK_GROUP, "primary-light"), console.timeStamp("Idle Track", 0.003, 0.003, "Idle", LANES_TRACK_GROUP, "primary-light"));
        var previousRenderStartTime = renderStartTime;
        renderStartTime = now();
        if (0 !== workInProgressRootRenderLanes && 0 < previousRenderStartTime) {
            setCurrentTrackFromLanes(workInProgressRootRenderLanes);
            if (workInProgressRootExitStatus === RootSuspended || workInProgressRootExitStatus === RootSuspendedWithDelay) logSuspendedRenderPhase(previousRenderStartTime, renderStartTime, lanes, workInProgressUpdateTask);
            else {
                var endTime = renderStartTime, debugTask = workInProgressUpdateTask;
                if (supportsUserTiming && !(endTime <= previousRenderStartTime)) {
                    var color = (lanes & 738197653) === lanes ? "tertiary-dark" : "primary-dark", label = (lanes & 536870912) === lanes ? "Prewarm" : (lanes & 201326741) === lanes ? "Interrupted Hydration" : "Interrupted Render";
                    debugTask ? debugTask.run(console.timeStamp.bind(console, label, previousRenderStartTime, endTime, currentTrack, LANES_TRACK_GROUP, color)) : console.timeStamp(label, previousRenderStartTime, endTime, currentTrack, LANES_TRACK_GROUP, color);
                }
            }
            finalizeRender(workInProgressRootRenderLanes, renderStartTime);
        }
        previousRenderStartTime = workInProgressUpdateTask;
        workInProgressUpdateTask = null;
        if (0 !== (lanes & 127)) {
            workInProgressUpdateTask = blockingUpdateTask;
            debugTask = 0 <= blockingUpdateTime && blockingUpdateTime < blockingClampTime ? blockingClampTime : blockingUpdateTime;
            endTime = 0 <= blockingEventTime && blockingEventTime < blockingClampTime ? blockingClampTime : blockingEventTime;
            color = 0 <= endTime ? endTime : 0 <= debugTask ? debugTask : renderStartTime;
            0 <= blockingSuspendedTime ? (setCurrentTrackFromLanes(2), logSuspendedWithDelayPhase(blockingSuspendedTime, color, lanes, previousRenderStartTime)) : 0 !== (animatingLanes & 127) && (setCurrentTrackFromLanes(2), logAnimatingPhase(blockingClampTime, color, animatingTask));
            previousRenderStartTime = debugTask;
            var eventTime = endTime, eventType = blockingEventType, eventIsRepeat = 0 < blockingEventRepeatTime, isSpawnedUpdate = blockingUpdateType === SPAWNED_UPDATE, isPingedUpdate = blockingUpdateType === PINGED_UPDATE;
            debugTask = renderStartTime;
            endTime = blockingUpdateTask;
            color = blockingUpdateMethodName;
            label = blockingUpdateComponentName;
            if (supportsUserTiming) {
                currentTrack = "Blocking";
                0 < previousRenderStartTime ? previousRenderStartTime > debugTask && (previousRenderStartTime = debugTask) : previousRenderStartTime = debugTask;
                0 < eventTime ? eventTime > previousRenderStartTime && (eventTime = previousRenderStartTime) : eventTime = previousRenderStartTime;
                if (null !== eventType && previousRenderStartTime > eventTime) {
                    var color$jscomp$0 = eventIsRepeat ? "secondary-light" : "warning";
                    endTime ? endTime.run(console.timeStamp.bind(console, eventIsRepeat ? "Consecutive" : "Event: " + eventType, eventTime, previousRenderStartTime, currentTrack, LANES_TRACK_GROUP, color$jscomp$0)) : console.timeStamp(eventIsRepeat ? "Consecutive" : "Event: " + eventType, eventTime, previousRenderStartTime, currentTrack, LANES_TRACK_GROUP, color$jscomp$0);
                }
                debugTask > previousRenderStartTime && (eventTime = isSpawnedUpdate ? "error" : (lanes & 738197653) === lanes ? "tertiary-light" : "primary-light", isSpawnedUpdate = isPingedUpdate ? "Promise Resolved" : isSpawnedUpdate ? "Cascading Update" : 5 < debugTask - previousRenderStartTime ? "Update Blocked" : "Update", isPingedUpdate = [], null != label && isPingedUpdate.push([
                    "Component name",
                    label
                ]), null != color && isPingedUpdate.push([
                    "Method name",
                    color
                ]), previousRenderStartTime = {
                    start: previousRenderStartTime,
                    end: debugTask,
                    detail: {
                        devtools: {
                            properties: isPingedUpdate,
                            track: currentTrack,
                            trackGroup: LANES_TRACK_GROUP,
                            color: eventTime
                        }
                    }
                }, endTime ? endTime.run(performance.measure.bind(performance, isSpawnedUpdate, previousRenderStartTime)) : performance.measure(isSpawnedUpdate, previousRenderStartTime));
            }
            blockingUpdateTime = -1.1;
            blockingUpdateType = 0;
            blockingUpdateComponentName = blockingUpdateMethodName = null;
            blockingSuspendedTime = -1.1;
            blockingEventRepeatTime = blockingEventTime;
            blockingEventTime = -1.1;
            blockingClampTime = now();
        }
        0 !== (lanes & 4194048) && (workInProgressUpdateTask = transitionUpdateTask, debugTask = 0 <= transitionStartTime && transitionStartTime < transitionClampTime ? transitionClampTime : transitionStartTime, previousRenderStartTime = 0 <= transitionUpdateTime && transitionUpdateTime < transitionClampTime ? transitionClampTime : transitionUpdateTime, endTime = 0 <= transitionEventTime && transitionEventTime < transitionClampTime ? transitionClampTime : transitionEventTime, color = 0 <= endTime ? endTime : 0 <= previousRenderStartTime ? previousRenderStartTime : renderStartTime, 0 <= transitionSuspendedTime ? (setCurrentTrackFromLanes(256), logSuspendedWithDelayPhase(transitionSuspendedTime, color, lanes, workInProgressUpdateTask)) : 0 !== (animatingLanes & 4194048) && (setCurrentTrackFromLanes(256), logAnimatingPhase(transitionClampTime, color, animatingTask)), isPingedUpdate = endTime, eventTime = transitionEventType, eventType = 0 < transitionEventRepeatTime, eventIsRepeat = transitionUpdateType === PINGED_UPDATE, color = renderStartTime, endTime = transitionUpdateTask, label = transitionUpdateMethodName, isSpawnedUpdate = transitionUpdateComponentName, supportsUserTiming && (currentTrack = "Transition", 0 < previousRenderStartTime ? previousRenderStartTime > color && (previousRenderStartTime = color) : previousRenderStartTime = color, 0 < debugTask ? debugTask > previousRenderStartTime && (debugTask = previousRenderStartTime) : debugTask = previousRenderStartTime, 0 < isPingedUpdate ? isPingedUpdate > debugTask && (isPingedUpdate = debugTask) : isPingedUpdate = debugTask, debugTask > isPingedUpdate && null !== eventTime && (color$jscomp$0 = eventType ? "secondary-light" : "warning", endTime ? endTime.run(console.timeStamp.bind(console, eventType ? "Consecutive" : "Event: " + eventTime, isPingedUpdate, debugTask, currentTrack, LANES_TRACK_GROUP, color$jscomp$0)) : console.timeStamp(eventType ? "Consecutive" : "Event: " + eventTime, isPingedUpdate, debugTask, currentTrack, LANES_TRACK_GROUP, color$jscomp$0)), previousRenderStartTime > debugTask && (endTime ? endTime.run(console.timeStamp.bind(console, "Action", debugTask, previousRenderStartTime, currentTrack, LANES_TRACK_GROUP, "primary-dark")) : console.timeStamp("Action", debugTask, previousRenderStartTime, currentTrack, LANES_TRACK_GROUP, "primary-dark")), color > previousRenderStartTime && (debugTask = eventIsRepeat ? "Promise Resolved" : 5 < color - previousRenderStartTime ? "Update Blocked" : "Update", isPingedUpdate = [], null != isSpawnedUpdate && isPingedUpdate.push([
            "Component name",
            isSpawnedUpdate
        ]), null != label && isPingedUpdate.push([
            "Method name",
            label
        ]), previousRenderStartTime = {
            start: previousRenderStartTime,
            end: color,
            detail: {
                devtools: {
                    properties: isPingedUpdate,
                    track: currentTrack,
                    trackGroup: LANES_TRACK_GROUP,
                    color: "primary-light"
                }
            }
        }, endTime ? endTime.run(performance.measure.bind(performance, debugTask, previousRenderStartTime)) : performance.measure(debugTask, previousRenderStartTime))), transitionUpdateTime = transitionStartTime = -1.1, transitionUpdateType = 0, transitionSuspendedTime = -1.1, transitionEventRepeatTime = transitionEventTime, transitionEventTime = -1.1, transitionClampTime = now());
        0 !== (lanes & 62914560) && 0 !== (animatingLanes & 62914560) && (setCurrentTrackFromLanes(4194304), logAnimatingPhase(retryClampTime, renderStartTime, animatingTask));
        0 !== (lanes & 2080374784) && 0 !== (animatingLanes & 2080374784) && (setCurrentTrackFromLanes(268435456), logAnimatingPhase(idleClampTime, renderStartTime, animatingTask));
        previousRenderStartTime = root.timeoutHandle;
        previousRenderStartTime !== noTimeout && (root.timeoutHandle = noTimeout, cancelTimeout(previousRenderStartTime));
        previousRenderStartTime = root.cancelPendingCommit;
        null !== previousRenderStartTime && (root.cancelPendingCommit = null, previousRenderStartTime());
        pendingEffectsLanes = 0;
        resetWorkInProgressStack();
        workInProgressRoot = root;
        workInProgress = previousRenderStartTime = createWorkInProgress(root.current, null);
        workInProgressRootRenderLanes = lanes;
        workInProgressSuspendedReason = NotSuspended;
        workInProgressThrownValue = null;
        workInProgressRootDidSkipSuspendedSiblings = !1;
        workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root, lanes);
        workInProgressRootDidAttachPingListener = !1;
        workInProgressRootExitStatus = RootInProgress;
        workInProgressSuspendedRetryLanes = workInProgressDeferredLane = workInProgressRootPingedLanes = workInProgressRootInterleavedUpdatedLanes = workInProgressRootSkippedLanes = 0;
        workInProgressRootRecoverableErrors = workInProgressRootConcurrentErrors = null;
        workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
        0 !== (lanes & 8) && (lanes |= lanes & 32);
        endTime = root.entangledLanes;
        if (0 !== endTime) for(root = root.entanglements, endTime &= lanes; 0 < endTime;)debugTask = 31 - clz32(endTime), color = 1 << debugTask, lanes |= root[debugTask], endTime &= ~color;
        entangledRenderLanes = lanes;
        finishQueueingConcurrentUpdates();
        root = getCurrentTime();
        1e3 < root - lastResetTime && (ReactSharedInternals.recentlyCreatedOwnerStacks = 0, lastResetTime = root);
        ReactStrictModeWarnings.discardPendingWarnings();
        return previousRenderStartTime;
    }
    function handleThrow(root, thrownValue) {
        currentlyRenderingFiber = null;
        ReactSharedInternals.H = ContextOnlyDispatcher;
        ReactSharedInternals.getCurrentStack = null;
        isRendering = !1;
        current = null;
        thrownValue === SuspenseException || thrownValue === SuspenseActionException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = SuspendedOnImmediate) : thrownValue === SuspenseyCommitException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = SuspendedOnInstance) : workInProgressSuspendedReason = thrownValue === SelectiveHydrationException ? SuspendedOnHydration : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? SuspendedOnDeprecatedThrowPromise : SuspendedOnError;
        workInProgressThrownValue = thrownValue;
        var erroredWork = workInProgress;
        null === erroredWork ? (workInProgressRootExitStatus = RootFatalErrored, logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current))) : erroredWork.mode & ProfileMode && stopProfilerTimerIfRunningAndRecordDuration(erroredWork);
    }
    function shouldRemainOnPreviousScreen() {
        var handler = suspenseHandlerStackCursor.current;
        return null === handler ? !0 : (workInProgressRootRenderLanes & 4194048) === workInProgressRootRenderLanes ? null === shellBoundary ? !0 : !1 : (workInProgressRootRenderLanes & 62914560) === workInProgressRootRenderLanes || 0 !== (workInProgressRootRenderLanes & 536870912) ? handler === shellBoundary : !1;
    }
    function pushDispatcher() {
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = ContextOnlyDispatcher;
        return null === prevDispatcher ? ContextOnlyDispatcher : prevDispatcher;
    }
    function pushAsyncDispatcher() {
        var prevAsyncDispatcher = ReactSharedInternals.A;
        ReactSharedInternals.A = DefaultAsyncDispatcher;
        return prevAsyncDispatcher;
    }
    function markRenderDerivedCause(fiber) {
        null === workInProgressUpdateTask && (workInProgressUpdateTask = null == fiber._debugTask ? null : fiber._debugTask);
    }
    function renderDidSuspendDelayIfPossible() {
        workInProgressRootExitStatus = RootSuspendedWithDelay;
        workInProgressRootDidSkipSuspendedSiblings || (workInProgressRootRenderLanes & 4194048) !== workInProgressRootRenderLanes && null !== suspenseHandlerStackCursor.current || (workInProgressRootIsPrerendering = !0);
        0 === (workInProgressRootSkippedLanes & 134217727) && 0 === (workInProgressRootInterleavedUpdatedLanes & 134217727) || null === workInProgressRoot || markRootSuspended(workInProgressRoot, workInProgressRootRenderLanes, workInProgressDeferredLane, !1);
    }
    function renderRootSync(root, lanes, shouldYieldForPrerendering) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            if (isDevToolsPresent) {
                var memoizedUpdaters = root.memoizedUpdaters;
                0 < memoizedUpdaters.size && (restorePendingUpdaters(root, workInProgressRootRenderLanes), memoizedUpdaters.clear());
                movePendingFibersToMemoized(root, lanes);
            }
            workInProgressTransitions = null;
            prepareFreshStack(root, lanes);
        }
        lanes = !1;
        memoizedUpdaters = workInProgressRootExitStatus;
        a: do try {
            if (workInProgressSuspendedReason !== NotSuspended && null !== workInProgress) {
                var unitOfWork = workInProgress, thrownValue = workInProgressThrownValue;
                switch(workInProgressSuspendedReason){
                    case SuspendedOnHydration:
                        resetWorkInProgressStack();
                        memoizedUpdaters = RootSuspendedAtTheShell;
                        break a;
                    case SuspendedOnImmediate:
                    case SuspendedOnData:
                    case SuspendedOnAction:
                    case SuspendedOnDeprecatedThrowPromise:
                        null === suspenseHandlerStackCursor.current && (lanes = !0);
                        var reason = workInProgressSuspendedReason;
                        workInProgressSuspendedReason = NotSuspended;
                        workInProgressThrownValue = null;
                        throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                        if (shouldYieldForPrerendering && workInProgressRootIsPrerendering) {
                            memoizedUpdaters = RootInProgress;
                            break a;
                        }
                        break;
                    default:
                        reason = workInProgressSuspendedReason, workInProgressSuspendedReason = NotSuspended, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                }
            }
            workLoopSync();
            memoizedUpdaters = workInProgressRootExitStatus;
            break;
        } catch (thrownValue$8) {
            handleThrow(root, thrownValue$8);
        }
        while (1);
        lanes && root.shellSuspendCounter++;
        resetContextDependencies();
        executionContext = prevExecutionContext;
        ReactSharedInternals.H = prevDispatcher;
        ReactSharedInternals.A = prevAsyncDispatcher;
        null === workInProgress && (workInProgressRoot = null, workInProgressRootRenderLanes = 0, finishQueueingConcurrentUpdates());
        return memoizedUpdaters;
    }
    function workLoopSync() {
        for(; null !== workInProgress;)performUnitOfWork(workInProgress);
    }
    function renderRootConcurrent(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            if (isDevToolsPresent) {
                var memoizedUpdaters = root.memoizedUpdaters;
                0 < memoizedUpdaters.size && (restorePendingUpdaters(root, workInProgressRootRenderLanes), memoizedUpdaters.clear());
                movePendingFibersToMemoized(root, lanes);
            }
            workInProgressTransitions = null;
            workInProgressRootRenderTargetTime = now$1() + RENDER_TIMEOUT_MS;
            prepareFreshStack(root, lanes);
        } else workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root, lanes);
        a: do try {
            if (workInProgressSuspendedReason !== NotSuspended && null !== workInProgress) b: switch(lanes = workInProgress, memoizedUpdaters = workInProgressThrownValue, workInProgressSuspendedReason){
                case SuspendedOnError:
                    workInProgressSuspendedReason = NotSuspended;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, memoizedUpdaters, SuspendedOnError);
                    break;
                case SuspendedOnData:
                case SuspendedOnAction:
                    if (isThenableResolved(memoizedUpdaters)) {
                        workInProgressSuspendedReason = NotSuspended;
                        workInProgressThrownValue = null;
                        replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        workInProgressSuspendedReason !== SuspendedOnData && workInProgressSuspendedReason !== SuspendedOnAction || workInProgressRoot !== root || (workInProgressSuspendedReason = SuspendedAndReadyToContinue);
                        ensureRootIsScheduled(root);
                    };
                    memoizedUpdaters.then(lanes, lanes);
                    break a;
                case SuspendedOnImmediate:
                    workInProgressSuspendedReason = SuspendedAndReadyToContinue;
                    break a;
                case SuspendedOnInstance:
                    workInProgressSuspendedReason = SuspendedOnInstanceAndReadyToContinue;
                    break a;
                case SuspendedAndReadyToContinue:
                    isThenableResolved(memoizedUpdaters) ? (workInProgressSuspendedReason = NotSuspended, workInProgressThrownValue = null, replaySuspendedUnitOfWork(lanes)) : (workInProgressSuspendedReason = NotSuspended, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root, lanes, memoizedUpdaters, SuspendedAndReadyToContinue));
                    break;
                case SuspendedOnInstanceAndReadyToContinue:
                    var resource = null;
                    switch(workInProgress.tag){
                        case 26:
                            resource = workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = workInProgress;
                            if (resource ? preloadResource(resource) : hostFiber.stateNode.complete) {
                                workInProgressSuspendedReason = NotSuspended;
                                workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? (workInProgress = returnFiber, completeUnitOfWork(returnFiber)) : workInProgress = null;
                                }
                                break b;
                            }
                            break;
                        default:
                            console.error("Unexpected type of fiber triggered a suspensey commit. This is a bug in React.");
                    }
                    workInProgressSuspendedReason = NotSuspended;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, memoizedUpdaters, SuspendedOnInstanceAndReadyToContinue);
                    break;
                case SuspendedOnDeprecatedThrowPromise:
                    workInProgressSuspendedReason = NotSuspended;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, memoizedUpdaters, SuspendedOnDeprecatedThrowPromise);
                    break;
                case SuspendedOnHydration:
                    resetWorkInProgressStack();
                    workInProgressRootExitStatus = RootSuspendedAtTheShell;
                    break a;
                default:
                    throw Error("Unexpected SuspendedReason. This is a bug in React.");
            }
            null !== ReactSharedInternals.actQueue ? workLoopSync() : workLoopConcurrentByScheduler();
            break;
        } catch (thrownValue$9) {
            handleThrow(root, thrownValue$9);
        }
        while (1);
        resetContextDependencies();
        ReactSharedInternals.H = prevDispatcher;
        ReactSharedInternals.A = prevAsyncDispatcher;
        executionContext = prevExecutionContext;
        if (null !== workInProgress) return RootInProgress;
        workInProgressRoot = null;
        workInProgressRootRenderLanes = 0;
        finishQueueingConcurrentUpdates();
        return workInProgressRootExitStatus;
    }
    function workLoopConcurrentByScheduler() {
        for(; null !== workInProgress && !shouldYield();)performUnitOfWork(workInProgress);
    }
    function performUnitOfWork(unitOfWork) {
        var current = unitOfWork.alternate;
        (unitOfWork.mode & ProfileMode) !== NoMode ? (startProfilerTimer(unitOfWork), current = runWithFiberInDEV(unitOfWork, beginWork, current, unitOfWork, entangledRenderLanes), stopProfilerTimerIfRunningAndRecordDuration(unitOfWork)) : current = runWithFiberInDEV(unitOfWork, beginWork, current, unitOfWork, entangledRenderLanes);
        unitOfWork.memoizedProps = unitOfWork.pendingProps;
        null === current ? completeUnitOfWork(unitOfWork) : workInProgress = current;
    }
    function replaySuspendedUnitOfWork(unitOfWork) {
        var next = runWithFiberInDEV(unitOfWork, replayBeginWork, unitOfWork);
        unitOfWork.memoizedProps = unitOfWork.pendingProps;
        null === next ? completeUnitOfWork(unitOfWork) : workInProgress = next;
    }
    function replayBeginWork(unitOfWork) {
        var current = unitOfWork.alternate, isProfilingMode = (unitOfWork.mode & ProfileMode) !== NoMode;
        isProfilingMode && startProfilerTimer(unitOfWork);
        switch(unitOfWork.tag){
            case 15:
            case 0:
                current = replayFunctionComponent(current, unitOfWork, unitOfWork.pendingProps, unitOfWork.type, void 0, workInProgressRootRenderLanes);
                break;
            case 11:
                current = replayFunctionComponent(current, unitOfWork, unitOfWork.pendingProps, unitOfWork.type.render, unitOfWork.ref, workInProgressRootRenderLanes);
                break;
            case 5:
                resetHooksOnUnwind(unitOfWork);
            default:
                unwindInterruptedWork(current, unitOfWork), unitOfWork = workInProgress = resetWorkInProgress(unitOfWork, entangledRenderLanes), current = beginWork(current, unitOfWork, entangledRenderLanes);
        }
        isProfilingMode && stopProfilerTimerIfRunningAndRecordDuration(unitOfWork);
        return current;
    }
    function throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
        resetContextDependencies();
        resetHooksOnUnwind(unitOfWork);
        thenableState$1 = null;
        thenableIndexCounter$1 = 0;
        var returnFiber = unitOfWork.return;
        try {
            if (throwException(root, returnFiber, unitOfWork, thrownValue, workInProgressRootRenderLanes)) {
                workInProgressRootExitStatus = RootFatalErrored;
                logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current));
                workInProgress = null;
                return;
            }
        } catch (error) {
            if (null !== returnFiber) throw workInProgress = returnFiber, error;
            workInProgressRootExitStatus = RootFatalErrored;
            logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current));
            workInProgress = null;
            return;
        }
        if (unitOfWork.flags & 32768) {
            if (isHydrating || suspendedReason === SuspendedOnError) root = !0;
            else if (workInProgressRootIsPrerendering || 0 !== (workInProgressRootRenderLanes & 536870912)) root = !1;
            else if (workInProgressRootDidSkipSuspendedSiblings = root = !0, suspendedReason === SuspendedOnData || suspendedReason === SuspendedOnAction || suspendedReason === SuspendedOnImmediate || suspendedReason === SuspendedOnDeprecatedThrowPromise) suspendedReason = suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
            unwindUnitOfWork(unitOfWork, root);
        } else completeUnitOfWork(unitOfWork);
    }
    function completeUnitOfWork(unitOfWork) {
        var completedWork = unitOfWork;
        do {
            if (0 !== (completedWork.flags & 32768)) {
                unwindUnitOfWork(completedWork, workInProgressRootDidSkipSuspendedSiblings);
                return;
            }
            var current = completedWork.alternate;
            unitOfWork = completedWork.return;
            startProfilerTimer(completedWork);
            current = runWithFiberInDEV(completedWork, completeWork, current, completedWork, entangledRenderLanes);
            (completedWork.mode & ProfileMode) !== NoMode && stopProfilerTimerIfRunningAndRecordIncompleteDuration(completedWork);
            if (null !== current) {
                workInProgress = current;
                return;
            }
            completedWork = completedWork.sibling;
            if (null !== completedWork) {
                workInProgress = completedWork;
                return;
            }
            workInProgress = completedWork = unitOfWork;
        }while (null !== completedWork);
        workInProgressRootExitStatus === RootInProgress && (workInProgressRootExitStatus = RootCompleted);
    }
    function unwindUnitOfWork(unitOfWork, skipSiblings) {
        do {
            var next = unwindWork(unitOfWork.alternate, unitOfWork);
            if (null !== next) {
                next.flags &= 32767;
                workInProgress = next;
                return;
            }
            if ((unitOfWork.mode & ProfileMode) !== NoMode) {
                stopProfilerTimerIfRunningAndRecordIncompleteDuration(unitOfWork);
                next = unitOfWork.actualDuration;
                for(var child = unitOfWork.child; null !== child;)next += child.actualDuration, child = child.sibling;
                unitOfWork.actualDuration = next;
            }
            next = unitOfWork.return;
            null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
            if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
                workInProgress = unitOfWork;
                return;
            }
            workInProgress = unitOfWork = next;
        }while (null !== unitOfWork);
        workInProgressRootExitStatus = RootSuspendedAtTheShell;
        workInProgress = null;
    }
    function commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedState, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
        root.cancelPendingCommit = null;
        do flushPendingEffects();
        while (pendingEffectsStatus !== NO_PENDING_EFFECTS);
        ReactStrictModeWarnings.flushLegacyContextWarning();
        ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw Error("Should not already be working.");
        setCurrentTrackFromLanes(lanes);
        exitStatus === RootErrored ? logErroredRenderPhase(completedRenderStartTime, completedRenderEndTime, lanes, workInProgressUpdateTask) : null !== recoverableErrors ? logRecoveredRenderPhase(completedRenderStartTime, completedRenderEndTime, lanes, recoverableErrors, null !== finishedWork && null !== finishedWork.alternate && finishedWork.alternate.memoizedState.isDehydrated && 0 !== (finishedWork.flags & 256), workInProgressUpdateTask) : logRenderPhase(completedRenderStartTime, completedRenderEndTime, lanes, workInProgressUpdateTask);
        if (null !== finishedWork) {
            0 === lanes && console.error("finishedLanes should not be empty during a commit. This is a bug in React.");
            if (finishedWork === root.current) throw Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
            didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
            didIncludeRenderPhaseUpdate |= concurrentlyUpdatedLanes;
            markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
            root === workInProgressRoot && (workInProgress = workInProgressRoot = null, workInProgressRootRenderLanes = 0);
            pendingFinishedWork = finishedWork;
            pendingEffectsRoot = root;
            pendingEffectsLanes = lanes;
            pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
            pendingPassiveTransitions = transitions;
            pendingRecoverableErrors = recoverableErrors;
            pendingEffectsRenderEndTime = completedRenderEndTime;
            pendingSuspendedCommitReason = suspendedCommitReason;
            pendingDelayedCommitReason = IMMEDIATE_COMMIT;
            pendingSuspendedViewTransitionReason = null;
            0 !== finishedWork.actualDuration || 0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, scheduleCallback$1(NormalPriority$1, function() {
                schedulerEvent = window.event;
                pendingDelayedCommitReason === IMMEDIATE_COMMIT && (pendingDelayedCommitReason = DELAYED_PASSIVE_COMMIT);
                flushPassiveEffects();
                return null;
            })) : (root.callbackNode = null, root.callbackPriority = 0);
            commitErrors = null;
            commitStartTime = now();
            null !== suspendedCommitReason && logSuspendedCommitPhase(completedRenderEndTime, commitStartTime, suspendedCommitReason, workInProgressUpdateTask);
            recoverableErrors = 0 !== (finishedWork.flags & 13878);
            if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
                recoverableErrors = ReactSharedInternals.T;
                ReactSharedInternals.T = null;
                transitions = ReactDOMSharedInternals.p;
                ReactDOMSharedInternals.p = DiscreteEventPriority;
                spawnedLane = executionContext;
                executionContext |= CommitContext;
                try {
                    commitBeforeMutationEffects(root, finishedWork, lanes);
                } finally{
                    executionContext = spawnedLane, ReactDOMSharedInternals.p = transitions, ReactSharedInternals.T = recoverableErrors;
                }
            }
            pendingEffectsStatus = PENDING_MUTATION_PHASE;
            flushMutationEffects();
            flushLayoutEffects();
            flushSpawnedWork();
        }
    }
    function flushMutationEffects() {
        if (pendingEffectsStatus === PENDING_MUTATION_PHASE) {
            pendingEffectsStatus = NO_PENDING_EFFECTS;
            var root = pendingEffectsRoot, finishedWork = pendingFinishedWork, lanes = pendingEffectsLanes, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
            if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
                rootMutationHasEffect = ReactSharedInternals.T;
                ReactSharedInternals.T = null;
                var previousPriority = ReactDOMSharedInternals.p;
                ReactDOMSharedInternals.p = DiscreteEventPriority;
                var prevExecutionContext = executionContext;
                executionContext |= CommitContext;
                try {
                    inProgressLanes = lanes;
                    inProgressRoot = root;
                    resetComponentEffectTimers();
                    commitMutationEffectsOnFiber(finishedWork, root);
                    inProgressRoot = inProgressLanes = null;
                    lanes = selectionInformation;
                    var curFocusedElem = getActiveElementDeep(root.containerInfo), priorFocusedElem = lanes.focusedElem, priorSelectionRange = lanes.selectionRange;
                    if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                        if (null !== priorSelectionRange && hasSelectionCapabilities(priorFocusedElem)) {
                            var start = priorSelectionRange.start, end = priorSelectionRange.end;
                            void 0 === end && (end = start);
                            if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                            else {
                                var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                                if (win.getSelection) {
                                    var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                    !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                    var startMarker = getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                    if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                        var range = doc.createRange();
                                        range.setStart(startMarker.node, startMarker.offset);
                                        selection.removeAllRanges();
                                        start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                    }
                                }
                            }
                        }
                        doc = [];
                        for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                            element: selection,
                            left: selection.scrollLeft,
                            top: selection.scrollTop
                        });
                        "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                        for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                            var info = doc[priorFocusedElem];
                            info.element.scrollLeft = info.left;
                            info.element.scrollTop = info.top;
                        }
                    }
                    _enabled = !!eventsEnabled;
                    selectionInformation = eventsEnabled = null;
                } finally{
                    executionContext = prevExecutionContext, ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = rootMutationHasEffect;
                }
            }
            root.current = finishedWork;
            pendingEffectsStatus = PENDING_LAYOUT_PHASE;
        }
    }
    function flushLayoutEffects() {
        if (pendingEffectsStatus === PENDING_LAYOUT_PHASE) {
            pendingEffectsStatus = NO_PENDING_EFFECTS;
            var suspendedViewTransitionReason = pendingSuspendedViewTransitionReason;
            if (null !== suspendedViewTransitionReason) {
                commitStartTime = now();
                var startTime = commitEndTime, endTime = commitStartTime;
                !supportsUserTiming || endTime <= startTime || (animatingTask ? animatingTask.run(console.timeStamp.bind(console, suspendedViewTransitionReason, startTime, endTime, currentTrack, LANES_TRACK_GROUP, "secondary-light")) : console.timeStamp(suspendedViewTransitionReason, startTime, endTime, currentTrack, LANES_TRACK_GROUP, "secondary-light"));
            }
            suspendedViewTransitionReason = pendingEffectsRoot;
            startTime = pendingFinishedWork;
            endTime = pendingEffectsLanes;
            var rootHasLayoutEffect = 0 !== (startTime.flags & 8772);
            if (0 !== (startTime.subtreeFlags & 8772) || rootHasLayoutEffect) {
                rootHasLayoutEffect = ReactSharedInternals.T;
                ReactSharedInternals.T = null;
                var _previousPriority = ReactDOMSharedInternals.p;
                ReactDOMSharedInternals.p = DiscreteEventPriority;
                var _prevExecutionContext = executionContext;
                executionContext |= CommitContext;
                try {
                    inProgressLanes = endTime, inProgressRoot = suspendedViewTransitionReason, resetComponentEffectTimers(), commitLayoutEffectOnFiber(suspendedViewTransitionReason, startTime.alternate, startTime), inProgressRoot = inProgressLanes = null;
                } finally{
                    executionContext = _prevExecutionContext, ReactDOMSharedInternals.p = _previousPriority, ReactSharedInternals.T = rootHasLayoutEffect;
                }
            }
            suspendedViewTransitionReason = pendingEffectsRenderEndTime;
            startTime = pendingSuspendedCommitReason;
            commitEndTime = now();
            suspendedViewTransitionReason = null === startTime ? suspendedViewTransitionReason : commitStartTime;
            startTime = commitEndTime;
            endTime = pendingDelayedCommitReason === ABORTED_VIEW_TRANSITION_COMMIT;
            rootHasLayoutEffect = workInProgressUpdateTask;
            null !== commitErrors ? logCommitErrored(suspendedViewTransitionReason, startTime, commitErrors, !1, rootHasLayoutEffect) : !supportsUserTiming || startTime <= suspendedViewTransitionReason || (rootHasLayoutEffect ? rootHasLayoutEffect.run(console.timeStamp.bind(console, endTime ? "Commit Interrupted View Transition" : "Commit", suspendedViewTransitionReason, startTime, currentTrack, LANES_TRACK_GROUP, endTime ? "error" : "secondary-dark")) : console.timeStamp(endTime ? "Commit Interrupted View Transition" : "Commit", suspendedViewTransitionReason, startTime, currentTrack, LANES_TRACK_GROUP, endTime ? "error" : "secondary-dark"));
            pendingEffectsStatus = PENDING_AFTER_MUTATION_PHASE;
        }
    }
    function flushSpawnedWork() {
        if (pendingEffectsStatus === PENDING_SPAWNED_WORK || pendingEffectsStatus === PENDING_AFTER_MUTATION_PHASE) {
            if (pendingEffectsStatus === PENDING_SPAWNED_WORK) {
                var startViewTransitionStartTime = commitEndTime;
                commitEndTime = now();
                var endTime = commitEndTime, abortedViewTransition = pendingDelayedCommitReason === ABORTED_VIEW_TRANSITION_COMMIT;
                !supportsUserTiming || endTime <= startViewTransitionStartTime || (animatingTask ? animatingTask.run(console.timeStamp.bind(console, abortedViewTransition ? "Interrupted View Transition" : "Starting Animation", startViewTransitionStartTime, endTime, currentTrack, LANES_TRACK_GROUP, abortedViewTransition ? "error" : "secondary-light")) : console.timeStamp(abortedViewTransition ? "Interrupted View Transition" : "Starting Animation", startViewTransitionStartTime, endTime, currentTrack, LANES_TRACK_GROUP, abortedViewTransition ? " error" : "secondary-light"));
                pendingDelayedCommitReason !== ABORTED_VIEW_TRANSITION_COMMIT && (pendingDelayedCommitReason = ANIMATION_STARTED_COMMIT);
            }
            pendingEffectsStatus = NO_PENDING_EFFECTS;
            requestPaint();
            startViewTransitionStartTime = pendingEffectsRoot;
            var finishedWork = pendingFinishedWork;
            endTime = pendingEffectsLanes;
            abortedViewTransition = pendingRecoverableErrors;
            var rootDidHavePassiveEffects = 0 !== finishedWork.actualDuration || 0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256);
            rootDidHavePassiveEffects ? pendingEffectsStatus = PENDING_PASSIVE_PHASE : (pendingEffectsStatus = NO_PENDING_EFFECTS, pendingFinishedWork = pendingEffectsRoot = null, releaseRootPooledCache(startViewTransitionStartTime, startViewTransitionStartTime.pendingLanes), nestedPassiveUpdateCount = 0, rootWithPassiveNestedUpdates = null);
            var remainingLanes = startViewTransitionStartTime.pendingLanes;
            0 === remainingLanes && (legacyErrorBoundariesThatAlreadyFailed = null);
            rootDidHavePassiveEffects || commitDoubleInvokeEffectsInDEV(startViewTransitionStartTime);
            remainingLanes = lanesToEventPriority(endTime);
            finishedWork = finishedWork.stateNode;
            if (injectedHook && "function" === typeof injectedHook.onCommitFiberRoot) try {
                var didError = 128 === (finishedWork.current.flags & 128);
                switch(remainingLanes){
                    case DiscreteEventPriority:
                        var schedulerPriority = ImmediatePriority;
                        break;
                    case ContinuousEventPriority:
                        schedulerPriority = UserBlockingPriority;
                        break;
                    case DefaultEventPriority:
                        schedulerPriority = NormalPriority$1;
                        break;
                    case IdleEventPriority:
                        schedulerPriority = IdlePriority;
                        break;
                    default:
                        schedulerPriority = NormalPriority$1;
                }
                injectedHook.onCommitFiberRoot(rendererID, finishedWork, schedulerPriority, didError);
            } catch (err) {
                hasLoggedError || (hasLoggedError = !0, console.error("React instrumentation encountered an error: %o", err));
            }
            isDevToolsPresent && startViewTransitionStartTime.memoizedUpdaters.clear();
            onCommitRoot();
            if (null !== abortedViewTransition) {
                didError = ReactSharedInternals.T;
                schedulerPriority = ReactDOMSharedInternals.p;
                ReactDOMSharedInternals.p = DiscreteEventPriority;
                ReactSharedInternals.T = null;
                try {
                    var onRecoverableError = startViewTransitionStartTime.onRecoverableError;
                    for(finishedWork = 0; finishedWork < abortedViewTransition.length; finishedWork++){
                        var recoverableError = abortedViewTransition[finishedWork], errorInfo = makeErrorInfo(recoverableError.stack);
                        runWithFiberInDEV(recoverableError.source, onRecoverableError, recoverableError.value, errorInfo);
                    }
                } finally{
                    ReactSharedInternals.T = didError, ReactDOMSharedInternals.p = schedulerPriority;
                }
            }
            0 !== (pendingEffectsLanes & 3) && flushPendingEffects();
            ensureRootIsScheduled(startViewTransitionStartTime);
            remainingLanes = startViewTransitionStartTime.pendingLanes;
            0 !== (endTime & 261930) && 0 !== (remainingLanes & 42) ? (nestedUpdateScheduled = !0, startViewTransitionStartTime === rootWithNestedUpdates ? nestedUpdateCount++ : (nestedUpdateCount = 0, rootWithNestedUpdates = startViewTransitionStartTime)) : nestedUpdateCount = 0;
            rootDidHavePassiveEffects || finalizeRender(endTime, commitEndTime);
            flushSyncWorkAcrossRoots_impl(0, !1);
        }
    }
    function makeErrorInfo(componentStack) {
        componentStack = {
            componentStack: componentStack
        };
        Object.defineProperty(componentStack, "digest", {
            get: function() {
                console.error('You are accessing "digest" from the errorInfo object passed to onRecoverableError. This property is no longer provided as part of errorInfo but can be accessed as a property of the Error instance itself.');
            }
        });
        return componentStack;
    }
    function releaseRootPooledCache(root, remainingLanes) {
        0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, releaseCache(remainingLanes)));
    }
    function flushPendingEffects() {
        flushMutationEffects();
        flushLayoutEffects();
        flushSpawnedWork();
        return flushPassiveEffects();
    }
    function flushPassiveEffects() {
        if (pendingEffectsStatus !== PENDING_PASSIVE_PHASE) return !1;
        var root = pendingEffectsRoot, remainingLanes = pendingEffectsRemainingLanes;
        pendingEffectsRemainingLanes = 0;
        var renderPriority = lanesToEventPriority(pendingEffectsLanes), priority = 0 === DefaultEventPriority || DefaultEventPriority > renderPriority ? DefaultEventPriority : renderPriority;
        renderPriority = ReactSharedInternals.T;
        var previousPriority = ReactDOMSharedInternals.p;
        try {
            ReactDOMSharedInternals.p = priority;
            ReactSharedInternals.T = null;
            var transitions = pendingPassiveTransitions;
            pendingPassiveTransitions = null;
            priority = pendingEffectsRoot;
            var lanes = pendingEffectsLanes;
            pendingEffectsStatus = NO_PENDING_EFFECTS;
            pendingFinishedWork = pendingEffectsRoot = null;
            pendingEffectsLanes = 0;
            if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw Error("Cannot flush passive effects while already rendering.");
            setCurrentTrackFromLanes(lanes);
            isFlushingPassiveEffects = !0;
            didScheduleUpdateDuringPassiveEffects = !1;
            var passiveEffectStartTime = 0;
            commitErrors = null;
            passiveEffectStartTime = now$1();
            if (pendingDelayedCommitReason === ANIMATION_STARTED_COMMIT) logAnimatingPhase(commitEndTime, passiveEffectStartTime, animatingTask);
            else {
                var startTime = commitEndTime, endTime = passiveEffectStartTime, delayedUntilPaint = pendingDelayedCommitReason === DELAYED_PASSIVE_COMMIT;
                !supportsUserTiming || endTime <= startTime || (workInProgressUpdateTask ? workInProgressUpdateTask.run(console.timeStamp.bind(console, delayedUntilPaint ? "Waiting for Paint" : "Waiting", startTime, endTime, currentTrack, LANES_TRACK_GROUP, "secondary-light")) : console.timeStamp(delayedUntilPaint ? "Waiting for Paint" : "Waiting", startTime, endTime, currentTrack, LANES_TRACK_GROUP, "secondary-light"));
            }
            startTime = executionContext;
            executionContext |= CommitContext;
            var finishedWork = priority.current;
            resetComponentEffectTimers();
            commitPassiveUnmountOnFiber(finishedWork);
            var finishedWork$jscomp$0 = priority.current;
            finishedWork = pendingEffectsRenderEndTime;
            resetComponentEffectTimers();
            commitPassiveMountOnFiber(priority, finishedWork$jscomp$0, lanes, transitions, finishedWork);
            commitDoubleInvokeEffectsInDEV(priority);
            executionContext = startTime;
            var passiveEffectsEndTime = now$1();
            finishedWork$jscomp$0 = passiveEffectStartTime;
            finishedWork = workInProgressUpdateTask;
            null !== commitErrors ? logCommitErrored(finishedWork$jscomp$0, passiveEffectsEndTime, commitErrors, !0, finishedWork) : !supportsUserTiming || passiveEffectsEndTime <= finishedWork$jscomp$0 || (finishedWork ? finishedWork.run(console.timeStamp.bind(console, "Remaining Effects", finishedWork$jscomp$0, passiveEffectsEndTime, currentTrack, LANES_TRACK_GROUP, "secondary-dark")) : console.timeStamp("Remaining Effects", finishedWork$jscomp$0, passiveEffectsEndTime, currentTrack, LANES_TRACK_GROUP, "secondary-dark"));
            finalizeRender(lanes, passiveEffectsEndTime);
            flushSyncWorkAcrossRoots_impl(0, !1);
            didScheduleUpdateDuringPassiveEffects ? priority === rootWithPassiveNestedUpdates ? nestedPassiveUpdateCount++ : (nestedPassiveUpdateCount = 0, rootWithPassiveNestedUpdates = priority) : nestedPassiveUpdateCount = 0;
            didScheduleUpdateDuringPassiveEffects = isFlushingPassiveEffects = !1;
            if (injectedHook && "function" === typeof injectedHook.onPostCommitFiberRoot) try {
                injectedHook.onPostCommitFiberRoot(rendererID, priority);
            } catch (err) {
                hasLoggedError || (hasLoggedError = !0, console.error("React instrumentation encountered an error: %o", err));
            }
            var stateNode = priority.current.stateNode;
            stateNode.effectDuration = 0;
            stateNode.passiveEffectDuration = 0;
            return !0;
        } finally{
            ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = renderPriority, releaseRootPooledCache(root, remainingLanes);
        }
    }
    function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
        sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
        recordEffectError(sourceFiber);
        sourceFiber = createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
        rootFiber = enqueueUpdate(rootFiber, sourceFiber, 2);
        null !== rootFiber && (markRootUpdated$1(rootFiber, 2), ensureRootIsScheduled(rootFiber));
    }
    function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
        isRunningInsertionEffect = !1;
        if (3 === sourceFiber.tag) captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
        else {
            for(; null !== nearestMountedAncestor;){
                if (3 === nearestMountedAncestor.tag) {
                    captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
                    return;
                }
                if (1 === nearestMountedAncestor.tag) {
                    var instance = nearestMountedAncestor.stateNode;
                    if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                        sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
                        recordEffectError(sourceFiber);
                        error = createClassErrorUpdate(2);
                        instance = enqueueUpdate(nearestMountedAncestor, error, 2);
                        null !== instance && (initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), markRootUpdated$1(instance, 2), ensureRootIsScheduled(instance));
                        return;
                    }
                }
                nearestMountedAncestor = nearestMountedAncestor.return;
            }
            console.error("Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Potential causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.\n\nError message:\n\n%s", error);
        }
    }
    function attachPingListener(root, wakeable, lanes) {
        var pingCache = root.pingCache;
        if (null === pingCache) {
            pingCache = root.pingCache = new PossiblyWeakMap();
            var threadIDs = new Set();
            pingCache.set(wakeable, threadIDs);
        } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
        threadIDs.has(lanes) || (workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), pingCache = pingSuspendedRoot.bind(null, root, wakeable, lanes), isDevToolsPresent && restorePendingUpdaters(root, lanes), wakeable.then(pingCache, pingCache));
    }
    function pingSuspendedRoot(root, wakeable, pingedLanes) {
        var pingCache = root.pingCache;
        null !== pingCache && pingCache.delete(wakeable);
        root.pingedLanes |= root.suspendedLanes & pingedLanes;
        root.warmLanes &= ~pingedLanes;
        0 !== (pingedLanes & 127) ? 0 > blockingUpdateTime && (blockingClampTime = blockingUpdateTime = now(), blockingUpdateTask = createTask("Promise Resolved"), blockingUpdateType = PINGED_UPDATE) : 0 !== (pingedLanes & 4194048) && 0 > transitionUpdateTime && (transitionClampTime = transitionUpdateTime = now(), transitionUpdateTask = createTask("Promise Resolved"), transitionUpdateType = PINGED_UPDATE);
        isConcurrentActEnvironment() && null === ReactSharedInternals.actQueue && console.error("A suspended resource finished loading inside a test, but the event was not wrapped in act(...).\n\nWhen testing, code that resolves suspended data should be wrapped into act(...):\n\nact(() => {\n  /* finish loading suspended data */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://react.dev/link/wrap-tests-with-act");
        workInProgressRoot === root && (workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && (workInProgressRootRenderLanes & 62914560) === workInProgressRootRenderLanes && now$1() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS ? (executionContext & RenderContext) === NoContext && prepareFreshStack(root, 0) : workInProgressRootPingedLanes |= pingedLanes, workInProgressSuspendedRetryLanes === workInProgressRootRenderLanes && (workInProgressSuspendedRetryLanes = 0));
        ensureRootIsScheduled(root);
    }
    function retryTimedOutBoundary(boundaryFiber, retryLane) {
        0 === retryLane && (retryLane = claimNextRetryLane());
        boundaryFiber = enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
        null !== boundaryFiber && (markRootUpdated$1(boundaryFiber, retryLane), ensureRootIsScheduled(boundaryFiber));
    }
    function retryDehydratedSuspenseBoundary(boundaryFiber) {
        var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
        null !== suspenseState && (retryLane = suspenseState.retryLane);
        retryTimedOutBoundary(boundaryFiber, retryLane);
    }
    function resolveRetryWakeable(boundaryFiber, wakeable) {
        var retryLane = 0;
        switch(boundaryFiber.tag){
            case 31:
            case 13:
                var retryCache = boundaryFiber.stateNode;
                var suspenseState = boundaryFiber.memoizedState;
                null !== suspenseState && (retryLane = suspenseState.retryLane);
                break;
            case 19:
                retryCache = boundaryFiber.stateNode;
                break;
            case 22:
                retryCache = boundaryFiber.stateNode._retryCache;
                break;
            default:
                throw Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
        }
        null !== retryCache && retryCache.delete(wakeable);
        retryTimedOutBoundary(boundaryFiber, retryLane);
    }
    function recursivelyTraverseAndDoubleInvokeEffectsInDEV(root$jscomp$0, parentFiber, isInStrictMode) {
        if (0 !== (parentFiber.subtreeFlags & 67117056)) for(parentFiber = parentFiber.child; null !== parentFiber;){
            var root = root$jscomp$0, fiber = parentFiber, isStrictModeFiber = fiber.type === REACT_STRICT_MODE_TYPE;
            isStrictModeFiber = isInStrictMode || isStrictModeFiber;
            22 !== fiber.tag ? fiber.flags & 67108864 ? isStrictModeFiber && runWithFiberInDEV(fiber, doubleInvokeEffectsOnFiber, root, fiber) : recursivelyTraverseAndDoubleInvokeEffectsInDEV(root, fiber, isStrictModeFiber) : null === fiber.memoizedState && (isStrictModeFiber && fiber.flags & 8192 ? runWithFiberInDEV(fiber, doubleInvokeEffectsOnFiber, root, fiber) : fiber.subtreeFlags & 67108864 && runWithFiberInDEV(fiber, recursivelyTraverseAndDoubleInvokeEffectsInDEV, root, fiber, isStrictModeFiber));
            parentFiber = parentFiber.sibling;
        }
    }
    function doubleInvokeEffectsOnFiber(root, fiber) {
        setIsStrictModeForDevtools(!0);
        try {
            disappearLayoutEffects(fiber), disconnectPassiveEffect(fiber), reappearLayoutEffects(root, fiber.alternate, fiber, !1), reconnectPassiveEffects(root, fiber, 0, null, !1, 0);
        } finally{
            setIsStrictModeForDevtools(!1);
        }
    }
    function commitDoubleInvokeEffectsInDEV(root) {
        var doubleInvokeEffects = !0;
        root.current.mode & (StrictLegacyMode | StrictEffectsMode) || (doubleInvokeEffects = !1);
        recursivelyTraverseAndDoubleInvokeEffectsInDEV(root, root.current, doubleInvokeEffects);
    }
    function warnAboutUpdateOnNotYetMountedFiberInDEV(fiber) {
        if ((executionContext & RenderContext) === NoContext) {
            var tag = fiber.tag;
            if (3 === tag || 1 === tag || 0 === tag || 11 === tag || 14 === tag || 15 === tag) {
                tag = getComponentNameFromFiber(fiber) || "ReactComponent";
                if (null !== didWarnStateUpdateForNotYetMountedComponent) {
                    if (didWarnStateUpdateForNotYetMountedComponent.has(tag)) return;
                    didWarnStateUpdateForNotYetMountedComponent.add(tag);
                } else didWarnStateUpdateForNotYetMountedComponent = new Set([
                    tag
                ]);
                runWithFiberInDEV(fiber, function() {
                    console.error("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously tries to update the component. Move this work to useEffect instead.");
                });
            }
        }
    }
    function restorePendingUpdaters(root, lanes) {
        isDevToolsPresent && root.memoizedUpdaters.forEach(function(schedulingFiber) {
            addFiberToLanesMap(root, schedulingFiber, lanes);
        });
    }
    function scheduleCallback$1(priorityLevel, callback) {
        var actQueue = ReactSharedInternals.actQueue;
        return null !== actQueue ? (actQueue.push(callback), fakeActCallbackNode$1) : scheduleCallback$3(priorityLevel, callback);
    }
    function warnIfUpdatesNotWrappedWithActDEV(fiber) {
        isConcurrentActEnvironment() && null === ReactSharedInternals.actQueue && runWithFiberInDEV(fiber, function() {
            console.error("An update to %s inside a test was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://react.dev/link/wrap-tests-with-act", getComponentNameFromFiber(fiber));
        });
    }
    function ensureRootIsScheduled(root) {
        root !== lastScheduledRoot && null === root.next && (null === lastScheduledRoot ? firstScheduledRoot = lastScheduledRoot = root : lastScheduledRoot = lastScheduledRoot.next = root);
        mightHavePendingSyncWork = !0;
        null !== ReactSharedInternals.actQueue ? didScheduleMicrotask_act || (didScheduleMicrotask_act = !0, scheduleImmediateRootScheduleTask()) : didScheduleMicrotask || (didScheduleMicrotask = !0, scheduleImmediateRootScheduleTask());
    }
    function flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
        if (!isFlushingWork && mightHavePendingSyncWork) {
            isFlushingWork = !0;
            do {
                var didPerformSomeWork = !1;
                for(var root = firstScheduledRoot; null !== root;){
                    if (!onlyLegacy) {
                        if (0 !== syncTransitionLanes) {
                            var pendingLanes = root.pendingLanes;
                            if (0 === pendingLanes) var nextLanes = 0;
                            else {
                                var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
                                nextLanes = (1 << 31 - clz32(42 | syncTransitionLanes) + 1) - 1;
                                nextLanes &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                                nextLanes = nextLanes & 201326741 ? nextLanes & 201326741 | 1 : nextLanes ? nextLanes | 2 : 0;
                            }
                            0 !== nextLanes && (didPerformSomeWork = !0, performSyncWorkOnRoot(root, nextLanes));
                        } else nextLanes = workInProgressRootRenderLanes, nextLanes = getNextLanes(root, root === workInProgressRoot ? nextLanes : 0, null !== root.cancelPendingCommit || root.timeoutHandle !== noTimeout), 0 === (nextLanes & 3) || checkIfRootIsPrerendering(root, nextLanes) || (didPerformSomeWork = !0, performSyncWorkOnRoot(root, nextLanes));
                    }
                    root = root.next;
                }
            }while (didPerformSomeWork);
            isFlushingWork = !1;
        }
    }
    function processRootScheduleInImmediateTask() {
        schedulerEvent = window.event;
        processRootScheduleInMicrotask();
    }
    function processRootScheduleInMicrotask() {
        mightHavePendingSyncWork = didScheduleMicrotask_act = didScheduleMicrotask = !1;
        var syncTransitionLanes = 0;
        0 !== currentEventTransitionLane && shouldAttemptEagerTransition() && (syncTransitionLanes = currentEventTransitionLane);
        for(var currentTime = now$1(), prev = null, root = firstScheduledRoot; null !== root;){
            var next = root.next, nextLanes = scheduleTaskForRootDuringMicrotask(root, currentTime);
            if (0 === nextLanes) root.next = null, null === prev ? firstScheduledRoot = next : prev.next = next, null === next && (lastScheduledRoot = prev);
            else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) mightHavePendingSyncWork = !0;
            root = next;
        }
        pendingEffectsStatus !== NO_PENDING_EFFECTS && pendingEffectsStatus !== PENDING_PASSIVE_PHASE || flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
        0 !== currentEventTransitionLane && (currentEventTransitionLane = 0);
    }
    function scheduleTaskForRootDuringMicrotask(root, currentTime) {
        for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
            var index = 31 - clz32(lanes), lane = 1 << index, expirationTime = expirationTimes[index];
            if (-1 === expirationTime) {
                if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index] = computeExpirationTime(lane, currentTime);
            } else expirationTime <= currentTime && (root.expiredLanes |= lane);
            lanes &= ~lane;
        }
        currentTime = workInProgressRoot;
        suspendedLanes = workInProgressRootRenderLanes;
        suspendedLanes = getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || root.timeoutHandle !== noTimeout);
        pingedLanes = root.callbackNode;
        if (0 === suspendedLanes || root === currentTime && (workInProgressSuspendedReason === SuspendedOnData || workInProgressSuspendedReason === SuspendedOnAction) || null !== root.cancelPendingCommit) return null !== pingedLanes && cancelCallback(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
        if (0 === (suspendedLanes & 3) || checkIfRootIsPrerendering(root, suspendedLanes)) {
            currentTime = suspendedLanes & -suspendedLanes;
            if (currentTime !== root.callbackPriority || null !== ReactSharedInternals.actQueue && pingedLanes !== fakeActCallbackNode) cancelCallback(pingedLanes);
            else return currentTime;
            switch(lanesToEventPriority(suspendedLanes)){
                case DiscreteEventPriority:
                case ContinuousEventPriority:
                    suspendedLanes = UserBlockingPriority;
                    break;
                case DefaultEventPriority:
                    suspendedLanes = NormalPriority$1;
                    break;
                case IdleEventPriority:
                    suspendedLanes = IdlePriority;
                    break;
                default:
                    suspendedLanes = NormalPriority$1;
            }
            pingedLanes = performWorkOnRootViaSchedulerTask.bind(null, root);
            null !== ReactSharedInternals.actQueue ? (ReactSharedInternals.actQueue.push(pingedLanes), suspendedLanes = fakeActCallbackNode) : suspendedLanes = scheduleCallback$3(suspendedLanes, pingedLanes);
            root.callbackPriority = currentTime;
            root.callbackNode = suspendedLanes;
            return currentTime;
        }
        null !== pingedLanes && cancelCallback(pingedLanes);
        root.callbackPriority = 2;
        root.callbackNode = null;
        return 2;
    }
    function performWorkOnRootViaSchedulerTask(root, didTimeout) {
        nestedUpdateScheduled = currentUpdateIsNested = !1;
        schedulerEvent = window.event;
        if (pendingEffectsStatus !== NO_PENDING_EFFECTS && pendingEffectsStatus !== PENDING_PASSIVE_PHASE) return root.callbackNode = null, root.callbackPriority = 0, null;
        var originalCallbackNode = root.callbackNode;
        pendingDelayedCommitReason === IMMEDIATE_COMMIT && (pendingDelayedCommitReason = DELAYED_PASSIVE_COMMIT);
        if (flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
        var workInProgressRootRenderLanes$jscomp$0 = workInProgressRootRenderLanes;
        workInProgressRootRenderLanes$jscomp$0 = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || root.timeoutHandle !== noTimeout);
        if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
        performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
        scheduleTaskForRootDuringMicrotask(root, now$1());
        return null != root.callbackNode && root.callbackNode === originalCallbackNode ? performWorkOnRootViaSchedulerTask.bind(null, root) : null;
    }
    function performSyncWorkOnRoot(root, lanes) {
        if (flushPendingEffects()) return null;
        currentUpdateIsNested = nestedUpdateScheduled;
        nestedUpdateScheduled = !1;
        performWorkOnRoot(root, lanes, !0);
    }
    function cancelCallback(callbackNode) {
        callbackNode !== fakeActCallbackNode && null !== callbackNode && cancelCallback$1(callbackNode);
    }
    function scheduleImmediateRootScheduleTask() {
        null !== ReactSharedInternals.actQueue && ReactSharedInternals.actQueue.push(function() {
            processRootScheduleInMicrotask();
            return null;
        });
        scheduleMicrotask(function() {
            (executionContext & (RenderContext | CommitContext)) !== NoContext ? scheduleCallback$3(ImmediatePriority, processRootScheduleInImmediateTask) : processRootScheduleInMicrotask();
        });
    }
    function requestTransitionLane() {
        if (0 === currentEventTransitionLane) {
            var actionScopeLane = currentEntangledLane;
            0 === actionScopeLane && (actionScopeLane = nextTransitionUpdateLane, nextTransitionUpdateLane <<= 1, 0 === (nextTransitionUpdateLane & 261888) && (nextTransitionUpdateLane = 256));
            currentEventTransitionLane = actionScopeLane;
        }
        return currentEventTransitionLane;
    }
    function coerceFormActionProp(actionProp) {
        if (null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp) return null;
        if ("function" === typeof actionProp) return actionProp;
        checkAttributeStringCoercion(actionProp, "action");
        return sanitizeURL("" + actionProp);
    }
    function createFormDataWithSubmitter(form, submitter) {
        var temp = submitter.ownerDocument.createElement("input");
        temp.name = submitter.name;
        temp.value = submitter.value;
        form.id && temp.setAttribute("form", form.id);
        submitter.parentNode.insertBefore(temp, submitter);
        form = new FormData(form);
        temp.parentNode.removeChild(temp);
        return form;
    }
    function extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
        if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
            var action = coerceFormActionProp((nativeEventTarget[internalPropsKey] || null).action), submitter = nativeEvent.submitter;
            submitter && (domEventName = (domEventName = submitter[internalPropsKey] || null) ? coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
            var event = new SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: event,
                listeners: [
                    {
                        instance: null,
                        listener: function() {
                            if (nativeEvent.defaultPrevented) {
                                if (0 !== currentEventTransitionLane) {
                                    var formData = submitter ? createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), pendingState = {
                                        pending: !0,
                                        data: formData,
                                        method: nativeEventTarget.method,
                                        action: action
                                    };
                                    Object.freeze(pendingState);
                                    startHostTransition(maybeTargetInst, pendingState, null, formData);
                                }
                            } else "function" === typeof action && (event.preventDefault(), formData = submitter ? createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), pendingState = {
                                pending: !0,
                                data: formData,
                                method: nativeEventTarget.method,
                                action: action
                            }, Object.freeze(pendingState), startHostTransition(maybeTargetInst, pendingState, action, formData));
                        },
                        currentTarget: nativeEventTarget
                    }
                ]
            });
        }
    }
    function executeDispatch(event, listener, currentTarget) {
        event.currentTarget = currentTarget;
        try {
            listener(event);
        } catch (error) {
            reportGlobalError(error);
        }
        event.currentTarget = null;
    }
    function processDispatchQueue(dispatchQueue, eventSystemFlags) {
        eventSystemFlags = 0 !== (eventSystemFlags & 4);
        for(var i = 0; i < dispatchQueue.length; i++){
            var _dispatchQueue$i = dispatchQueue[i];
            a: {
                var previousInstance = void 0, event = _dispatchQueue$i.event;
                _dispatchQueue$i = _dispatchQueue$i.listeners;
                if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                    var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                    _dispatchListeners$i = _dispatchListeners$i.listener;
                    if (instance !== previousInstance && event.isPropagationStopped()) break a;
                    null !== instance ? runWithFiberInDEV(instance, executeDispatch, event, _dispatchListeners$i, currentTarget) : executeDispatch(event, _dispatchListeners$i, currentTarget);
                    previousInstance = instance;
                }
                else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                    _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                    instance = _dispatchListeners$i.instance;
                    currentTarget = _dispatchListeners$i.currentTarget;
                    _dispatchListeners$i = _dispatchListeners$i.listener;
                    if (instance !== previousInstance && event.isPropagationStopped()) break a;
                    null !== instance ? runWithFiberInDEV(instance, executeDispatch, event, _dispatchListeners$i, currentTarget) : executeDispatch(event, _dispatchListeners$i, currentTarget);
                    previousInstance = instance;
                }
            }
        }
    }
    function listenToNonDelegatedEvent(domEventName, targetElement) {
        nonDelegatedEvents.has(domEventName) || console.error('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', domEventName);
        var listenerSet = targetElement[internalEventHandlersKey];
        void 0 === listenerSet && (listenerSet = targetElement[internalEventHandlersKey] = new Set());
        var listenerSetKey = domEventName + "__bubble";
        listenerSet.has(listenerSetKey) || (addTrappedEventListener(targetElement, domEventName, 2, !1), listenerSet.add(listenerSetKey));
    }
    function listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
        nonDelegatedEvents.has(domEventName) && !isCapturePhaseListener && console.error('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', domEventName);
        var eventSystemFlags = 0;
        isCapturePhaseListener && (eventSystemFlags |= 4);
        addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
    }
    function listenToAllSupportedEvents(rootContainerElement) {
        if (!rootContainerElement[listeningMarker]) {
            rootContainerElement[listeningMarker] = !0;
            allNativeEvents.forEach(function(domEventName) {
                "selectionchange" !== domEventName && (nonDelegatedEvents.has(domEventName) || listenToNativeEvent(domEventName, !1, rootContainerElement), listenToNativeEvent(domEventName, !0, rootContainerElement));
            });
            var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
            null === ownerDocument || ownerDocument[listeningMarker] || (ownerDocument[listeningMarker] = !0, listenToNativeEvent("selectionchange", !1, ownerDocument));
        }
    }
    function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
        switch(getEventPriority(domEventName)){
            case DiscreteEventPriority:
                var listenerWrapper = dispatchDiscreteEvent;
                break;
            case ContinuousEventPriority:
                listenerWrapper = dispatchContinuousEvent;
                break;
            default:
                listenerWrapper = dispatchEvent;
        }
        eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
        listenerWrapper = void 0;
        !passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
        isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
            capture: !0,
            passive: listenerWrapper
        }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
            passive: listenerWrapper
        }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
    }
    function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
        var ancestorInst = targetInst$jscomp$0;
        if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
            if (null === targetInst$jscomp$0) return;
            var nodeTag = targetInst$jscomp$0.tag;
            if (3 === nodeTag || 4 === nodeTag) {
                var container = targetInst$jscomp$0.stateNode.containerInfo;
                if (container === targetContainer) break;
                if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                    var grandTag = nodeTag.tag;
                    if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                    nodeTag = nodeTag.return;
                }
                for(; null !== container;){
                    nodeTag = getClosestInstanceFromNode(container);
                    if (null === nodeTag) return;
                    grandTag = nodeTag.tag;
                    if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                        targetInst$jscomp$0 = ancestorInst = nodeTag;
                        continue a;
                    }
                    container = container.parentNode;
                }
            }
            targetInst$jscomp$0 = targetInst$jscomp$0.return;
        }
        batchedUpdates$1(function() {
            var targetInst = ancestorInst, nativeEventTarget = getEventTarget(nativeEvent), dispatchQueue = [];
            a: {
                var reactName = topLevelEventsToReactNames.get(domEventName);
                if (void 0 !== reactName) {
                    var SyntheticEventCtor = SyntheticEvent, reactEventType = domEventName;
                    switch(domEventName){
                        case "keypress":
                            if (0 === getEventCharCode(nativeEvent)) break a;
                        case "keydown":
                        case "keyup":
                            SyntheticEventCtor = SyntheticKeyboardEvent;
                            break;
                        case "focusin":
                            reactEventType = "focus";
                            SyntheticEventCtor = SyntheticFocusEvent;
                            break;
                        case "focusout":
                            reactEventType = "blur";
                            SyntheticEventCtor = SyntheticFocusEvent;
                            break;
                        case "beforeblur":
                        case "afterblur":
                            SyntheticEventCtor = SyntheticFocusEvent;
                            break;
                        case "click":
                            if (2 === nativeEvent.button) break a;
                        case "auxclick":
                        case "dblclick":
                        case "mousedown":
                        case "mousemove":
                        case "mouseup":
                        case "mouseout":
                        case "mouseover":
                        case "contextmenu":
                            SyntheticEventCtor = SyntheticMouseEvent;
                            break;
                        case "drag":
                        case "dragend":
                        case "dragenter":
                        case "dragexit":
                        case "dragleave":
                        case "dragover":
                        case "dragstart":
                        case "drop":
                            SyntheticEventCtor = SyntheticDragEvent;
                            break;
                        case "touchcancel":
                        case "touchend":
                        case "touchmove":
                        case "touchstart":
                            SyntheticEventCtor = SyntheticTouchEvent;
                            break;
                        case ANIMATION_END:
                        case ANIMATION_ITERATION:
                        case ANIMATION_START:
                            SyntheticEventCtor = SyntheticAnimationEvent;
                            break;
                        case TRANSITION_END:
                            SyntheticEventCtor = SyntheticTransitionEvent;
                            break;
                        case "scroll":
                        case "scrollend":
                            SyntheticEventCtor = SyntheticUIEvent;
                            break;
                        case "wheel":
                            SyntheticEventCtor = SyntheticWheelEvent;
                            break;
                        case "copy":
                        case "cut":
                        case "paste":
                            SyntheticEventCtor = SyntheticClipboardEvent;
                            break;
                        case "gotpointercapture":
                        case "lostpointercapture":
                        case "pointercancel":
                        case "pointerdown":
                        case "pointermove":
                        case "pointerout":
                        case "pointerover":
                        case "pointerup":
                            SyntheticEventCtor = SyntheticPointerEvent;
                            break;
                        case "toggle":
                        case "beforetoggle":
                            SyntheticEventCtor = SyntheticToggleEvent;
                    }
                    var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                    inCapturePhase = [];
                    for(var instance = targetInst, lastHostComponent; null !== instance;){
                        var _instance2 = instance;
                        lastHostComponent = _instance2.stateNode;
                        _instance2 = _instance2.tag;
                        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === lastHostComponent || null === reactEventName || (_instance2 = getListener(instance, reactEventName), null != _instance2 && inCapturePhase.push(createDispatchListener(instance, _instance2, lastHostComponent)));
                        if (accumulateTargetOnly) break;
                        instance = instance.return;
                    }
                    0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                        event: reactName,
                        listeners: inCapturePhase
                    }));
                }
            }
            if (0 === (eventSystemFlags & 7)) {
                a: {
                    reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                    SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                    if (reactName && nativeEvent !== currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && (getClosestInstanceFromNode(reactEventType) || reactEventType[internalContainerInstanceKey])) break a;
                    if (SyntheticEventCtor || reactName) {
                        reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                        if (SyntheticEventCtor) {
                            if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                        } else SyntheticEventCtor = null, reactEventType = targetInst;
                        if (SyntheticEventCtor !== reactEventType) {
                            inCapturePhase = SyntheticMouseEvent;
                            _instance2 = "onMouseLeave";
                            reactEventName = "onMouseEnter";
                            instance = "mouse";
                            if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = SyntheticPointerEvent, _instance2 = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                            accumulateTargetOnly = null == SyntheticEventCtor ? reactName : getNodeFromInstance(SyntheticEventCtor);
                            lastHostComponent = null == reactEventType ? reactName : getNodeFromInstance(reactEventType);
                            reactName = new inCapturePhase(_instance2, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                            reactName.target = accumulateTargetOnly;
                            reactName.relatedTarget = lastHostComponent;
                            _instance2 = null;
                            getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance2 = inCapturePhase);
                            accumulateTargetOnly = _instance2;
                            if (SyntheticEventCtor && reactEventType) b: {
                                inCapturePhase = getParent;
                                reactEventName = SyntheticEventCtor;
                                instance = reactEventType;
                                lastHostComponent = 0;
                                for(_instance2 = reactEventName; _instance2; _instance2 = inCapturePhase(_instance2))lastHostComponent++;
                                _instance2 = 0;
                                for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance2++;
                                for(; 0 < lastHostComponent - _instance2;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                                for(; 0 < _instance2 - lastHostComponent;)instance = inCapturePhase(instance), _instance2--;
                                for(; lastHostComponent--;){
                                    if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                        inCapturePhase = reactEventName;
                                        break b;
                                    }
                                    reactEventName = inCapturePhase(reactEventName);
                                    instance = inCapturePhase(instance);
                                }
                                inCapturePhase = null;
                            }
                            else inCapturePhase = null;
                            null !== SyntheticEventCtor && accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                            null !== reactEventType && null !== accumulateTargetOnly && accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                        }
                    }
                }
                a: {
                    reactName = targetInst ? getNodeFromInstance(targetInst) : window;
                    SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                    if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = getTargetInstForChangeEvent;
                    else if (isTextInputElement(reactName)) {
                        if (isInputEventSupported) getTargetInstFunc = getTargetInstForInputOrChangeEvent;
                        else {
                            getTargetInstFunc = getTargetInstForInputEventPolyfill;
                            var handleEventFunc = handleEventsForInputEventPolyfill;
                        }
                    } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && isCustomElement(targetInst.elementType) && (getTargetInstFunc = getTargetInstForChangeEvent) : getTargetInstFunc = getTargetInstForClickEvent;
                    if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                        createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                        break a;
                    }
                    handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                    "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && setDefaultValue(reactName, "number", reactName.value);
                }
                handleEventFunc = targetInst ? getNodeFromInstance(targetInst) : window;
                switch(domEventName){
                    case "focusin":
                        if (isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) activeElement = handleEventFunc, activeElementInst = targetInst, lastSelection = null;
                        break;
                    case "focusout":
                        lastSelection = activeElementInst = activeElement = null;
                        break;
                    case "mousedown":
                        mouseDown = !0;
                        break;
                    case "contextmenu":
                    case "mouseup":
                    case "dragend":
                        mouseDown = !1;
                        constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                        break;
                    case "selectionchange":
                        if (skipSelectionChangeEvent) break;
                    case "keydown":
                    case "keyup":
                        constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                }
                var fallbackData;
                if (canUseCompositionEvent) b: {
                    switch(domEventName){
                        case "compositionstart":
                            var eventType = "onCompositionStart";
                            break b;
                        case "compositionend":
                            eventType = "onCompositionEnd";
                            break b;
                        case "compositionupdate":
                            eventType = "onCompositionUpdate";
                            break b;
                    }
                    eventType = void 0;
                }
                else isComposing ? isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && nativeEvent.keyCode === START_KEYCODE && (eventType = "onCompositionStart");
                eventType && (useFallbackCompositionData && "ko" !== nativeEvent.locale && (isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && isComposing && (fallbackData = getData()) : (root = nativeEventTarget, startText = "value" in root ? root.value : root.textContent, isComposing = !0)), handleEventFunc = accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: eventType,
                    listeners: handleEventFunc
                }), fallbackData ? eventType.data = fallbackData : (fallbackData = getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
                if (fallbackData = canUseTextInputEvent ? getNativeBeforeInputChars(domEventName, nativeEvent) : getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new SyntheticInputEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: handleEventFunc,
                    listeners: eventType
                }), handleEventFunc.data = fallbackData);
                extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            }
            processDispatchQueue(dispatchQueue, eventSystemFlags);
        });
    }
    function createDispatchListener(instance, listener, currentTarget) {
        return {
            instance: instance,
            listener: listener,
            currentTarget: currentTarget
        };
    }
    function accumulateTwoPhaseListeners(targetFiber, reactName) {
        for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
            var _instance3 = targetFiber, stateNode = _instance3.stateNode;
            _instance3 = _instance3.tag;
            5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (_instance3 = getListener(targetFiber, captureName), null != _instance3 && listeners.unshift(createDispatchListener(targetFiber, _instance3, stateNode)), _instance3 = getListener(targetFiber, reactName), null != _instance3 && listeners.push(createDispatchListener(targetFiber, _instance3, stateNode)));
            if (3 === targetFiber.tag) return listeners;
            targetFiber = targetFiber.return;
        }
        return [];
    }
    function getParent(inst) {
        if (null === inst) return null;
        do inst = inst.return;
        while (inst && 5 !== inst.tag && 27 !== inst.tag);
        return inst ? inst : null;
    }
    function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
        for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
            var _instance4 = target, alternate = _instance4.alternate, stateNode = _instance4.stateNode;
            _instance4 = _instance4.tag;
            if (null !== alternate && alternate === common) break;
            5 !== _instance4 && 26 !== _instance4 && 27 !== _instance4 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = getListener(target, registrationName), null != stateNode && listeners.unshift(createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = getListener(target, registrationName), null != stateNode && listeners.push(createDispatchListener(target, stateNode, alternate))));
            target = target.return;
        }
        0 !== listeners.length && dispatchQueue.push({
            event: event,
            listeners: listeners
        });
    }
    function validatePropertiesInDevelopment(type, props) {
        validateProperties$2(type, props);
        "input" !== type && "textarea" !== type && "select" !== type || null == props || null !== props.value || didWarnValueNull || (didWarnValueNull = !0, "select" === type && props.multiple ? console.error("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", type) : console.error("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", type));
        var eventRegistry = {
            registrationNameDependencies: registrationNameDependencies,
            possibleRegistrationNames: possibleRegistrationNames
        };
        isCustomElement(type) || "string" === typeof props.is || warnUnknownProperties(type, props, eventRegistry);
        props.contentEditable && !props.suppressContentEditableWarning && null != props.children && console.error("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional.");
    }
    function warnForPropDifference(propName, serverValue, clientValue, serverDifferences) {
        serverValue !== clientValue && (clientValue = normalizeMarkupForTextOrAttribute(clientValue), normalizeMarkupForTextOrAttribute(serverValue) !== clientValue && (serverDifferences[propName] = serverValue));
    }
    function warnForExtraAttributes(domElement, attributeNames, serverDifferences) {
        attributeNames.forEach(function(attributeName) {
            serverDifferences[getPropNameFromAttributeName(attributeName)] = "style" === attributeName ? getStylesObjectFromElement(domElement) : domElement.getAttribute(attributeName);
        });
    }
    function warnForInvalidEventListener(registrationName, listener) {
        !1 === listener ? console.error("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", registrationName, registrationName, registrationName) : console.error("Expected `%s` listener to be a function, instead got a value of `%s` type.", registrationName, typeof listener);
    }
    function normalizeHTML(parent, html) {
        parent = parent.namespaceURI === MATH_NAMESPACE || parent.namespaceURI === SVG_NAMESPACE ? parent.ownerDocument.createElementNS(parent.namespaceURI, parent.tagName) : parent.ownerDocument.createElement(parent.tagName);
        parent.innerHTML = html;
        return parent.innerHTML;
    }
    function normalizeMarkupForTextOrAttribute(markup) {
        willCoercionThrow(markup) && (console.error("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before using it here.", typeName(markup)), testStringCoercion(markup));
        return ("string" === typeof markup ? markup : "" + markup).replace(NORMALIZE_NEWLINES_REGEX, "\n").replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
    }
    function checkForUnmatchedText(serverText, clientText) {
        clientText = normalizeMarkupForTextOrAttribute(clientText);
        return normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
    }
    function setProp(domElement, tag, key, value, props, prevValue) {
        switch(key){
            case "children":
                if ("string" === typeof value) validateTextNesting(value, tag, !1), "body" === tag || "textarea" === tag && "" === value || setTextContent(domElement, value);
                else if ("number" === typeof value || "bigint" === typeof value) validateTextNesting("" + value, tag, !1), "body" !== tag && setTextContent(domElement, "" + value);
                break;
            case "className":
                setValueForKnownAttribute(domElement, "class", value);
                break;
            case "tabIndex":
                setValueForKnownAttribute(domElement, "tabindex", value);
                break;
            case "dir":
            case "role":
            case "viewBox":
            case "width":
            case "height":
                setValueForKnownAttribute(domElement, key, value);
                break;
            case "style":
                setValueForStyles(domElement, value, prevValue);
                break;
            case "data":
                if ("object" !== tag) {
                    setValueForKnownAttribute(domElement, "data", value);
                    break;
                }
            case "src":
            case "href":
                if ("" === value && ("a" !== tag || "href" !== key)) {
                    "src" === key ? console.error('An empty string ("") was passed to the %s attribute. This may cause the browser to download the whole page again over the network. To fix this, either do not render the element at all or pass null to %s instead of an empty string.', key, key) : console.error('An empty string ("") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.', key, key);
                    domElement.removeAttribute(key);
                    break;
                }
                if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                    domElement.removeAttribute(key);
                    break;
                }
                checkAttributeStringCoercion(value, key);
                value = sanitizeURL("" + value);
                domElement.setAttribute(key, value);
                break;
            case "action":
            case "formAction":
                null != value && ("form" === tag ? "formAction" === key ? console.error("You can only pass the formAction prop to <input> or <button>. Use the action prop on <form>.") : "function" === typeof value && (null == props.encType && null == props.method || didWarnFormActionMethod || (didWarnFormActionMethod = !0, console.error("Cannot specify a encType or method for a form that specifies a function as the action. React provides those automatically. They will get overridden.")), null == props.target || didWarnFormActionTarget || (didWarnFormActionTarget = !0, console.error("Cannot specify a target for a form that specifies a function as the action. The function will always be executed in the same window."))) : "input" === tag || "button" === tag ? "action" === key ? console.error("You can only pass the action prop to <form>. Use the formAction prop on <input> or <button>.") : "input" !== tag || "submit" === props.type || "image" === props.type || didWarnFormActionType ? "button" !== tag || null == props.type || "submit" === props.type || didWarnFormActionType ? "function" === typeof value && (null == props.name || didWarnFormActionName || (didWarnFormActionName = !0, console.error('Cannot specify a "name" prop for a button that specifies a function as a formAction. React needs it to encode which action should be invoked. It will get overridden.')), null == props.formEncType && null == props.formMethod || didWarnFormActionMethod || (didWarnFormActionMethod = !0, console.error("Cannot specify a formEncType or formMethod for a button that specifies a function as a formAction. React provides those automatically. They will get overridden.")), null == props.formTarget || didWarnFormActionTarget || (didWarnFormActionTarget = !0, console.error("Cannot specify a formTarget for a button that specifies a function as a formAction. The function will always be executed in the same window."))) : (didWarnFormActionType = !0, console.error('A button can only specify a formAction along with type="submit" or no type.')) : (didWarnFormActionType = !0, console.error('An input can only specify a formAction along with type="submit" or type="image".')) : "action" === key ? console.error("You can only pass the action prop to <form>.") : console.error("You can only pass the formAction prop to <input> or <button>."));
                if ("function" === typeof value) {
                    domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                    break;
                } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && setProp(domElement, tag, "name", props.name, props, null), setProp(domElement, tag, "formEncType", props.formEncType, props, null), setProp(domElement, tag, "formMethod", props.formMethod, props, null), setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : (setProp(domElement, tag, "encType", props.encType, props, null), setProp(domElement, tag, "method", props.method, props, null), setProp(domElement, tag, "target", props.target, props, null)));
                if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                    domElement.removeAttribute(key);
                    break;
                }
                checkAttributeStringCoercion(value, key);
                value = sanitizeURL("" + value);
                domElement.setAttribute(key, value);
                break;
            case "onClick":
                null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), domElement.onclick = noop$1);
                break;
            case "onScroll":
                null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), listenToNonDelegatedEvent("scroll", domElement));
                break;
            case "onScrollEnd":
                null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), listenToNonDelegatedEvent("scrollend", domElement));
                break;
            case "dangerouslySetInnerHTML":
                if (null != value) {
                    if ("object" !== typeof value || !("__html" in value)) throw Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information.");
                    key = value.__html;
                    if (null != key) {
                        if (null != props.children) throw Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
                        domElement.innerHTML = key;
                    }
                }
                break;
            case "multiple":
                domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
                break;
            case "muted":
                domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
                break;
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
            case "defaultValue":
            case "defaultChecked":
            case "innerHTML":
            case "ref":
                break;
            case "autoFocus":
                break;
            case "xlinkHref":
                if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                    domElement.removeAttribute("xlink:href");
                    break;
                }
                checkAttributeStringCoercion(value, key);
                key = sanitizeURL("" + value);
                domElement.setAttributeNS(xlinkNamespace, "xlink:href", key);
                break;
            case "contentEditable":
            case "spellCheck":
            case "draggable":
            case "value":
            case "autoReverse":
            case "externalResourcesRequired":
            case "focusable":
            case "preserveAlpha":
                null != value && "function" !== typeof value && "symbol" !== typeof value ? (checkAttributeStringCoercion(value, key), domElement.setAttribute(key, "" + value)) : domElement.removeAttribute(key);
                break;
            case "inert":
                "" !== value || didWarnForNewBooleanPropsWithEmptyValue[key] || (didWarnForNewBooleanPropsWithEmptyValue[key] = !0, console.error("Received an empty string for a boolean attribute `%s`. This will treat the attribute as if it were false. Either pass `false` to silence this warning, or pass `true` if you used an empty string in earlier versions of React to indicate this attribute is true.", key));
            case "allowFullScreen":
            case "async":
            case "autoPlay":
            case "controls":
            case "default":
            case "defer":
            case "disabled":
            case "disablePictureInPicture":
            case "disableRemotePlayback":
            case "formNoValidate":
            case "hidden":
            case "loop":
            case "noModule":
            case "noValidate":
            case "open":
            case "playsInline":
            case "readOnly":
            case "required":
            case "reversed":
            case "scoped":
            case "seamless":
            case "itemScope":
                value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
                break;
            case "capture":
            case "download":
                !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? (checkAttributeStringCoercion(value, key), domElement.setAttribute(key, value)) : domElement.removeAttribute(key);
                break;
            case "cols":
            case "rows":
            case "size":
            case "span":
                null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? (checkAttributeStringCoercion(value, key), domElement.setAttribute(key, value)) : domElement.removeAttribute(key);
                break;
            case "rowSpan":
            case "start":
                null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : (checkAttributeStringCoercion(value, key), domElement.setAttribute(key, value));
                break;
            case "popover":
                listenToNonDelegatedEvent("beforetoggle", domElement);
                listenToNonDelegatedEvent("toggle", domElement);
                setValueForAttribute(domElement, "popover", value);
                break;
            case "xlinkActuate":
                setValueForNamespacedAttribute(domElement, xlinkNamespace, "xlink:actuate", value);
                break;
            case "xlinkArcrole":
                setValueForNamespacedAttribute(domElement, xlinkNamespace, "xlink:arcrole", value);
                break;
            case "xlinkRole":
                setValueForNamespacedAttribute(domElement, xlinkNamespace, "xlink:role", value);
                break;
            case "xlinkShow":
                setValueForNamespacedAttribute(domElement, xlinkNamespace, "xlink:show", value);
                break;
            case "xlinkTitle":
                setValueForNamespacedAttribute(domElement, xlinkNamespace, "xlink:title", value);
                break;
            case "xlinkType":
                setValueForNamespacedAttribute(domElement, xlinkNamespace, "xlink:type", value);
                break;
            case "xmlBase":
                setValueForNamespacedAttribute(domElement, xmlNamespace, "xml:base", value);
                break;
            case "xmlLang":
                setValueForNamespacedAttribute(domElement, xmlNamespace, "xml:lang", value);
                break;
            case "xmlSpace":
                setValueForNamespacedAttribute(domElement, xmlNamespace, "xml:space", value);
                break;
            case "is":
                null != prevValue && console.error('Cannot update the "is" prop after it has been initialized.');
                setValueForAttribute(domElement, "is", value);
                break;
            case "innerText":
            case "textContent":
                break;
            case "popoverTarget":
                didWarnPopoverTargetObject || null == value || "object" !== typeof value || (didWarnPopoverTargetObject = !0, console.error("The `popoverTarget` prop expects the ID of an Element as a string. Received %s instead.", value));
            default:
                !(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1] ? (key = getAttributeAlias(key), setValueForAttribute(domElement, key, value)) : registrationNameDependencies.hasOwnProperty(key) && null != value && "function" !== typeof value && warnForInvalidEventListener(key, value);
        }
    }
    function setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
        switch(key){
            case "style":
                setValueForStyles(domElement, value, prevValue);
                break;
            case "dangerouslySetInnerHTML":
                if (null != value) {
                    if ("object" !== typeof value || !("__html" in value)) throw Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information.");
                    key = value.__html;
                    if (null != key) {
                        if (null != props.children) throw Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
                        domElement.innerHTML = key;
                    }
                }
                break;
            case "children":
                "string" === typeof value ? setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && setTextContent(domElement, "" + value);
                break;
            case "onScroll":
                null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), listenToNonDelegatedEvent("scroll", domElement));
                break;
            case "onScrollEnd":
                null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), listenToNonDelegatedEvent("scrollend", domElement));
                break;
            case "onClick":
                null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), domElement.onclick = noop$1);
                break;
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
            case "innerHTML":
            case "ref":
                break;
            case "innerText":
            case "textContent":
                break;
            default:
                if (registrationNameDependencies.hasOwnProperty(key)) null != value && "function" !== typeof value && warnForInvalidEventListener(key, value);
                else a: {
                    if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                        "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                        domElement.addEventListener(tag, value, props);
                        break a;
                    }
                    key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : setValueForAttribute(domElement, key, value);
                }
        }
    }
    function setInitialProperties(domElement, tag, props) {
        validatePropertiesInDevelopment(tag, props);
        switch(tag){
            case "div":
            case "span":
            case "svg":
            case "path":
            case "a":
            case "g":
            case "p":
            case "li":
                break;
            case "img":
                listenToNonDelegatedEvent("error", domElement);
                listenToNonDelegatedEvent("load", domElement);
                var hasSrc = !1, hasSrcSet = !1, propKey;
                for(propKey in props)if (props.hasOwnProperty(propKey)) {
                    var propValue = props[propKey];
                    if (null != propValue) switch(propKey){
                        case "src":
                            hasSrc = !0;
                            break;
                        case "srcSet":
                            hasSrcSet = !0;
                            break;
                        case "children":
                        case "dangerouslySetInnerHTML":
                            throw Error(tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
                        default:
                            setProp(domElement, tag, propKey, propValue, props, null);
                    }
                }
                hasSrcSet && setProp(domElement, tag, "srcSet", props.srcSet, props, null);
                hasSrc && setProp(domElement, tag, "src", props.src, props, null);
                return;
            case "input":
                checkControlledValueProps("input", props);
                listenToNonDelegatedEvent("invalid", domElement);
                var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
                for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                    var _propValue = props[hasSrc];
                    if (null != _propValue) switch(hasSrc){
                        case "name":
                            hasSrcSet = _propValue;
                            break;
                        case "type":
                            propValue = _propValue;
                            break;
                        case "checked":
                            checked = _propValue;
                            break;
                        case "defaultChecked":
                            defaultChecked = _propValue;
                            break;
                        case "value":
                            propKey = _propValue;
                            break;
                        case "defaultValue":
                            defaultValue = _propValue;
                            break;
                        case "children":
                        case "dangerouslySetInnerHTML":
                            if (null != _propValue) throw Error(tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
                            break;
                        default:
                            setProp(domElement, tag, hasSrc, _propValue, props, null);
                    }
                }
                validateInputProps(domElement, props);
                initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
                return;
            case "select":
                checkControlledValueProps("select", props);
                listenToNonDelegatedEvent("invalid", domElement);
                hasSrc = propValue = propKey = null;
                for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                    case "value":
                        propKey = defaultValue;
                        break;
                    case "defaultValue":
                        propValue = defaultValue;
                        break;
                    case "multiple":
                        hasSrc = defaultValue;
                    default:
                        setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
                }
                validateSelectProps(domElement, props);
                tag = propKey;
                props = propValue;
                domElement.multiple = !!hasSrc;
                null != tag ? updateOptions(domElement, !!hasSrc, tag, !1) : null != props && updateOptions(domElement, !!hasSrc, props, !0);
                return;
            case "textarea":
                checkControlledValueProps("textarea", props);
                listenToNonDelegatedEvent("invalid", domElement);
                propKey = hasSrcSet = hasSrc = null;
                for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                    case "value":
                        hasSrc = defaultValue;
                        break;
                    case "defaultValue":
                        hasSrcSet = defaultValue;
                        break;
                    case "children":
                        propKey = defaultValue;
                        break;
                    case "dangerouslySetInnerHTML":
                        if (null != defaultValue) throw Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
                        break;
                    default:
                        setProp(domElement, tag, propValue, defaultValue, props, null);
                }
                validateTextareaProps(domElement, props);
                initTextarea(domElement, hasSrc, hasSrcSet, propKey);
                return;
            case "option":
                validateOptionProps(domElement, props);
                for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                    case "selected":
                        domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                        break;
                    default:
                        setProp(domElement, tag, checked, hasSrc, props, null);
                }
                return;
            case "dialog":
                listenToNonDelegatedEvent("beforetoggle", domElement);
                listenToNonDelegatedEvent("toggle", domElement);
                listenToNonDelegatedEvent("cancel", domElement);
                listenToNonDelegatedEvent("close", domElement);
                break;
            case "iframe":
            case "object":
                listenToNonDelegatedEvent("load", domElement);
                break;
            case "video":
            case "audio":
                for(hasSrc = 0; hasSrc < mediaEventTypes.length; hasSrc++)listenToNonDelegatedEvent(mediaEventTypes[hasSrc], domElement);
                break;
            case "image":
                listenToNonDelegatedEvent("error", domElement);
                listenToNonDelegatedEvent("load", domElement);
                break;
            case "details":
                listenToNonDelegatedEvent("toggle", domElement);
                break;
            case "embed":
            case "source":
            case "link":
                listenToNonDelegatedEvent("error", domElement), listenToNonDelegatedEvent("load", domElement);
            case "area":
            case "base":
            case "br":
            case "col":
            case "hr":
            case "keygen":
            case "meta":
            case "param":
            case "track":
            case "wbr":
            case "menuitem":
                for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error(tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
                    default:
                        setProp(domElement, tag, defaultChecked, hasSrc, props, null);
                }
                return;
            default:
                if (isCustomElement(tag)) {
                    for(_propValue in props)props.hasOwnProperty(_propValue) && (hasSrc = props[_propValue], void 0 !== hasSrc && setPropOnCustomElement(domElement, tag, _propValue, hasSrc, props, void 0));
                    return;
                }
        }
        for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && setProp(domElement, tag, defaultValue, hasSrc, props, null));
    }
    function updateProperties(domElement, tag, lastProps, nextProps) {
        validatePropertiesInDevelopment(tag, nextProps);
        switch(tag){
            case "div":
            case "span":
            case "svg":
            case "path":
            case "a":
            case "g":
            case "p":
            case "li":
                break;
            case "input":
                var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
                for(propKey in lastProps){
                    var lastProp = lastProps[propKey];
                    if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                        case "checked":
                            break;
                        case "value":
                            break;
                        case "defaultValue":
                            lastDefaultValue = lastProp;
                        default:
                            nextProps.hasOwnProperty(propKey) || setProp(domElement, tag, propKey, null, nextProps, lastProp);
                    }
                }
                for(var _propKey8 in nextProps){
                    var propKey = nextProps[_propKey8];
                    lastProp = lastProps[_propKey8];
                    if (nextProps.hasOwnProperty(_propKey8) && (null != propKey || null != lastProp)) switch(_propKey8){
                        case "type":
                            type = propKey;
                            break;
                        case "name":
                            name = propKey;
                            break;
                        case "checked":
                            checked = propKey;
                            break;
                        case "defaultChecked":
                            defaultChecked = propKey;
                            break;
                        case "value":
                            value = propKey;
                            break;
                        case "defaultValue":
                            defaultValue = propKey;
                            break;
                        case "children":
                        case "dangerouslySetInnerHTML":
                            if (null != propKey) throw Error(tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
                            break;
                        default:
                            propKey !== lastProp && setProp(domElement, tag, _propKey8, propKey, nextProps, lastProp);
                    }
                }
                tag = "checkbox" === lastProps.type || "radio" === lastProps.type ? null != lastProps.checked : null != lastProps.value;
                nextProps = "checkbox" === nextProps.type || "radio" === nextProps.type ? null != nextProps.checked : null != nextProps.value;
                tag || !nextProps || didWarnUncontrolledToControlled || (console.error("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://react.dev/link/controlled-components"), didWarnUncontrolledToControlled = !0);
                !tag || nextProps || didWarnControlledToUncontrolled || (console.error("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://react.dev/link/controlled-components"), didWarnControlledToUncontrolled = !0);
                updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
                return;
            case "select":
                propKey = value = defaultValue = _propKey8 = null;
                for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                    case "value":
                        break;
                    case "multiple":
                        propKey = lastDefaultValue;
                    default:
                        nextProps.hasOwnProperty(type) || setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
                }
                for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                    case "value":
                        _propKey8 = type;
                        break;
                    case "defaultValue":
                        defaultValue = type;
                        break;
                    case "multiple":
                        value = type;
                    default:
                        type !== lastDefaultValue && setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
                }
                nextProps = defaultValue;
                tag = value;
                lastProps = propKey;
                null != _propKey8 ? updateOptions(domElement, !!tag, _propKey8, !1) : !!lastProps !== !!tag && (null != nextProps ? updateOptions(domElement, !!tag, nextProps, !0) : updateOptions(domElement, !!tag, tag ? [] : "", !1));
                return;
            case "textarea":
                propKey = _propKey8 = null;
                for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                    case "value":
                        break;
                    case "children":
                        break;
                    default:
                        setProp(domElement, tag, defaultValue, null, nextProps, name);
                }
                for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                    case "value":
                        _propKey8 = name;
                        break;
                    case "defaultValue":
                        propKey = name;
                        break;
                    case "children":
                        break;
                    case "dangerouslySetInnerHTML":
                        if (null != name) throw Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
                        break;
                    default:
                        name !== type && setProp(domElement, tag, value, name, nextProps, type);
                }
                updateTextarea(domElement, _propKey8, propKey);
                return;
            case "option":
                for(var _propKey13 in lastProps)if (_propKey8 = lastProps[_propKey13], lastProps.hasOwnProperty(_propKey13) && null != _propKey8 && !nextProps.hasOwnProperty(_propKey13)) switch(_propKey13){
                    case "selected":
                        domElement.selected = !1;
                        break;
                    default:
                        setProp(domElement, tag, _propKey13, null, nextProps, _propKey8);
                }
                for(lastDefaultValue in nextProps)if (_propKey8 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && _propKey8 !== propKey && (null != _propKey8 || null != propKey)) switch(lastDefaultValue){
                    case "selected":
                        domElement.selected = _propKey8 && "function" !== typeof _propKey8 && "symbol" !== typeof _propKey8;
                        break;
                    default:
                        setProp(domElement, tag, lastDefaultValue, _propKey8, nextProps, propKey);
                }
                return;
            case "img":
            case "link":
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "keygen":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
            case "menuitem":
                for(var _propKey15 in lastProps)_propKey8 = lastProps[_propKey15], lastProps.hasOwnProperty(_propKey15) && null != _propKey8 && !nextProps.hasOwnProperty(_propKey15) && setProp(domElement, tag, _propKey15, null, nextProps, _propKey8);
                for(checked in nextProps)if (_propKey8 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && _propKey8 !== propKey && (null != _propKey8 || null != propKey)) switch(checked){
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != _propKey8) throw Error(tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
                        break;
                    default:
                        setProp(domElement, tag, checked, _propKey8, nextProps, propKey);
                }
                return;
            default:
                if (isCustomElement(tag)) {
                    for(var _propKey17 in lastProps)_propKey8 = lastProps[_propKey17], lastProps.hasOwnProperty(_propKey17) && void 0 !== _propKey8 && !nextProps.hasOwnProperty(_propKey17) && setPropOnCustomElement(domElement, tag, _propKey17, void 0, nextProps, _propKey8);
                    for(defaultChecked in nextProps)_propKey8 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || _propKey8 === propKey || void 0 === _propKey8 && void 0 === propKey || setPropOnCustomElement(domElement, tag, defaultChecked, _propKey8, nextProps, propKey);
                    return;
                }
        }
        for(var _propKey19 in lastProps)_propKey8 = lastProps[_propKey19], lastProps.hasOwnProperty(_propKey19) && null != _propKey8 && !nextProps.hasOwnProperty(_propKey19) && setProp(domElement, tag, _propKey19, null, nextProps, _propKey8);
        for(lastProp in nextProps)_propKey8 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || _propKey8 === propKey || null == _propKey8 && null == propKey || setProp(domElement, tag, lastProp, _propKey8, nextProps, propKey);
    }
    function getPropNameFromAttributeName(attrName) {
        switch(attrName){
            case "class":
                return "className";
            case "for":
                return "htmlFor";
            default:
                return attrName;
        }
    }
    function getStylesObjectFromElement(domElement) {
        var serverValueInObjectForm = {};
        domElement = domElement.style;
        for(var i = 0; i < domElement.length; i++){
            var styleName = domElement[i];
            serverValueInObjectForm[styleName] = domElement.getPropertyValue(styleName);
        }
        return serverValueInObjectForm;
    }
    function diffHydratedStyles(domElement, value$jscomp$0, serverDifferences) {
        if (null != value$jscomp$0 && "object" !== typeof value$jscomp$0) console.error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
        else {
            var clientValue;
            var delimiter = clientValue = "", styleName;
            for(styleName in value$jscomp$0)if (value$jscomp$0.hasOwnProperty(styleName)) {
                var value = value$jscomp$0[styleName];
                null != value && "boolean" !== typeof value && "" !== value && (0 === styleName.indexOf("--") ? (checkCSSPropertyStringCoercion(value, styleName), clientValue += delimiter + styleName + ":" + ("" + value).trim()) : "number" !== typeof value || 0 === value || unitlessNumbers.has(styleName) ? (checkCSSPropertyStringCoercion(value, styleName), clientValue += delimiter + styleName.replace(uppercasePattern, "-$1").toLowerCase().replace(msPattern$1, "-ms-") + ":" + ("" + value).trim()) : clientValue += delimiter + styleName.replace(uppercasePattern, "-$1").toLowerCase().replace(msPattern$1, "-ms-") + ":" + value + "px", delimiter = ";");
            }
            clientValue = clientValue || null;
            value$jscomp$0 = domElement.getAttribute("style");
            value$jscomp$0 !== clientValue && (clientValue = normalizeMarkupForTextOrAttribute(clientValue), normalizeMarkupForTextOrAttribute(value$jscomp$0) !== clientValue && (serverDifferences.style = getStylesObjectFromElement(domElement)));
        }
    }
    function hydrateAttribute(domElement, propKey, attributeName, value, extraAttributes, serverDifferences) {
        extraAttributes.delete(attributeName);
        domElement = domElement.getAttribute(attributeName);
        if (null === domElement) switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                return;
        }
        else if (null != value) switch(typeof value){
            case "function":
            case "symbol":
            case "boolean":
                break;
            default:
                if (checkAttributeStringCoercion(value, propKey), domElement === "" + value) return;
        }
        warnForPropDifference(propKey, domElement, value, serverDifferences);
    }
    function hydrateBooleanAttribute(domElement, propKey, attributeName, value, extraAttributes, serverDifferences) {
        extraAttributes.delete(attributeName);
        domElement = domElement.getAttribute(attributeName);
        if (null === domElement) {
            switch(typeof value){
                case "function":
                case "symbol":
                    return;
            }
            if (!value) return;
        } else switch(typeof value){
            case "function":
            case "symbol":
                break;
            default:
                if (value) return;
        }
        warnForPropDifference(propKey, domElement, value, serverDifferences);
    }
    function hydrateBooleanishAttribute(domElement, propKey, attributeName, value, extraAttributes, serverDifferences) {
        extraAttributes.delete(attributeName);
        domElement = domElement.getAttribute(attributeName);
        if (null === domElement) switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
                return;
        }
        else if (null != value) switch(typeof value){
            case "function":
            case "symbol":
                break;
            default:
                if (checkAttributeStringCoercion(value, attributeName), domElement === "" + value) return;
        }
        warnForPropDifference(propKey, domElement, value, serverDifferences);
    }
    function hydrateNumericAttribute(domElement, propKey, attributeName, value, extraAttributes, serverDifferences) {
        extraAttributes.delete(attributeName);
        domElement = domElement.getAttribute(attributeName);
        if (null === domElement) switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                return;
            default:
                if (isNaN(value)) return;
        }
        else if (null != value) switch(typeof value){
            case "function":
            case "symbol":
            case "boolean":
                break;
            default:
                if (!isNaN(value) && (checkAttributeStringCoercion(value, propKey), domElement === "" + value)) return;
        }
        warnForPropDifference(propKey, domElement, value, serverDifferences);
    }
    function hydrateSanitizedAttribute(domElement, propKey, attributeName, value, extraAttributes, serverDifferences) {
        extraAttributes.delete(attributeName);
        domElement = domElement.getAttribute(attributeName);
        if (null === domElement) switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                return;
        }
        else if (null != value) switch(typeof value){
            case "function":
            case "symbol":
            case "boolean":
                break;
            default:
                if (checkAttributeStringCoercion(value, propKey), attributeName = sanitizeURL("" + value), domElement === attributeName) return;
        }
        warnForPropDifference(propKey, domElement, value, serverDifferences);
    }
    function diffHydratedProperties(domElement, tag, props, hostContext) {
        for(var serverDifferences = {}, extraAttributes = new Set(), attributes = domElement.attributes, i = 0; i < attributes.length; i++)switch(attributes[i].name.toLowerCase()){
            case "value":
                break;
            case "checked":
                break;
            case "selected":
                break;
            default:
                extraAttributes.add(attributes[i].name);
        }
        if (isCustomElement(tag)) {
            for(var propKey in props)if (props.hasOwnProperty(propKey)) {
                var value = props[propKey];
                if (null != value) {
                    if (registrationNameDependencies.hasOwnProperty(propKey)) "function" !== typeof value && warnForInvalidEventListener(propKey, value);
                    else if (!0 !== props.suppressHydrationWarning) switch(propKey){
                        case "children":
                            "string" !== typeof value && "number" !== typeof value || warnForPropDifference("children", domElement.textContent, value, serverDifferences);
                            continue;
                        case "suppressContentEditableWarning":
                        case "suppressHydrationWarning":
                        case "defaultValue":
                        case "defaultChecked":
                        case "innerHTML":
                        case "ref":
                            continue;
                        case "dangerouslySetInnerHTML":
                            attributes = domElement.innerHTML;
                            value = value ? value.__html : void 0;
                            null != value && (value = normalizeHTML(domElement, value), warnForPropDifference(propKey, attributes, value, serverDifferences));
                            continue;
                        case "style":
                            extraAttributes.delete(propKey);
                            diffHydratedStyles(domElement, value, serverDifferences);
                            continue;
                        case "offsetParent":
                        case "offsetTop":
                        case "offsetLeft":
                        case "offsetWidth":
                        case "offsetHeight":
                        case "isContentEditable":
                        case "outerText":
                        case "outerHTML":
                            extraAttributes.delete(propKey.toLowerCase());
                            console.error("Assignment to read-only property will result in a no-op: `%s`", propKey);
                            continue;
                        case "className":
                            extraAttributes.delete("class");
                            attributes = getValueForAttributeOnCustomComponent(domElement, "class", value);
                            warnForPropDifference("className", attributes, value, serverDifferences);
                            continue;
                        default:
                            hostContext.context === HostContextNamespaceNone && "svg" !== tag && "math" !== tag ? extraAttributes.delete(propKey.toLowerCase()) : extraAttributes.delete(propKey), attributes = getValueForAttributeOnCustomComponent(domElement, propKey, value), warnForPropDifference(propKey, attributes, value, serverDifferences);
                    }
                }
            }
        } else for(value in props)if (props.hasOwnProperty(value) && (propKey = props[value], null != propKey)) {
            if (registrationNameDependencies.hasOwnProperty(value)) "function" !== typeof propKey && warnForInvalidEventListener(value, propKey);
            else if (!0 !== props.suppressHydrationWarning) switch(value){
                case "children":
                    "string" !== typeof propKey && "number" !== typeof propKey || warnForPropDifference("children", domElement.textContent, propKey, serverDifferences);
                    continue;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                case "value":
                case "checked":
                case "selected":
                case "defaultValue":
                case "defaultChecked":
                case "innerHTML":
                case "ref":
                    continue;
                case "dangerouslySetInnerHTML":
                    attributes = domElement.innerHTML;
                    propKey = propKey ? propKey.__html : void 0;
                    null != propKey && (propKey = normalizeHTML(domElement, propKey), attributes !== propKey && (serverDifferences[value] = {
                        __html: attributes
                    }));
                    continue;
                case "className":
                    hydrateAttribute(domElement, value, "class", propKey, extraAttributes, serverDifferences);
                    continue;
                case "tabIndex":
                    hydrateAttribute(domElement, value, "tabindex", propKey, extraAttributes, serverDifferences);
                    continue;
                case "style":
                    extraAttributes.delete(value);
                    diffHydratedStyles(domElement, propKey, serverDifferences);
                    continue;
                case "multiple":
                    extraAttributes.delete(value);
                    warnForPropDifference(value, domElement.multiple, propKey, serverDifferences);
                    continue;
                case "muted":
                    extraAttributes.delete(value);
                    warnForPropDifference(value, domElement.muted, propKey, serverDifferences);
                    continue;
                case "autoFocus":
                    extraAttributes.delete("autofocus");
                    warnForPropDifference(value, domElement.autofocus, propKey, serverDifferences);
                    continue;
                case "data":
                    if ("object" !== tag) {
                        extraAttributes.delete(value);
                        attributes = domElement.getAttribute("data");
                        warnForPropDifference(value, attributes, propKey, serverDifferences);
                        continue;
                    }
                case "src":
                case "href":
                    if (!("" !== propKey || "a" === tag && "href" === value || "object" === tag && "data" === value)) {
                        "src" === value ? console.error('An empty string ("") was passed to the %s attribute. This may cause the browser to download the whole page again over the network. To fix this, either do not render the element at all or pass null to %s instead of an empty string.', value, value) : console.error('An empty string ("") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.', value, value);
                        continue;
                    }
                    hydrateSanitizedAttribute(domElement, value, value, propKey, extraAttributes, serverDifferences);
                    continue;
                case "action":
                case "formAction":
                    attributes = domElement.getAttribute(value);
                    if ("function" === typeof propKey) {
                        extraAttributes.delete(value.toLowerCase());
                        "formAction" === value ? (extraAttributes.delete("name"), extraAttributes.delete("formenctype"), extraAttributes.delete("formmethod"), extraAttributes.delete("formtarget")) : (extraAttributes.delete("enctype"), extraAttributes.delete("method"), extraAttributes.delete("target"));
                        continue;
                    } else if (attributes === EXPECTED_FORM_ACTION_URL) {
                        extraAttributes.delete(value.toLowerCase());
                        warnForPropDifference(value, "function", propKey, serverDifferences);
                        continue;
                    }
                    hydrateSanitizedAttribute(domElement, value, value.toLowerCase(), propKey, extraAttributes, serverDifferences);
                    continue;
                case "xlinkHref":
                    hydrateSanitizedAttribute(domElement, value, "xlink:href", propKey, extraAttributes, serverDifferences);
                    continue;
                case "contentEditable":
                    hydrateBooleanishAttribute(domElement, value, "contenteditable", propKey, extraAttributes, serverDifferences);
                    continue;
                case "spellCheck":
                    hydrateBooleanishAttribute(domElement, value, "spellcheck", propKey, extraAttributes, serverDifferences);
                    continue;
                case "draggable":
                case "autoReverse":
                case "externalResourcesRequired":
                case "focusable":
                case "preserveAlpha":
                    hydrateBooleanishAttribute(domElement, value, value, propKey, extraAttributes, serverDifferences);
                    continue;
                case "allowFullScreen":
                case "async":
                case "autoPlay":
                case "controls":
                case "default":
                case "defer":
                case "disabled":
                case "disablePictureInPicture":
                case "disableRemotePlayback":
                case "formNoValidate":
                case "hidden":
                case "loop":
                case "noModule":
                case "noValidate":
                case "open":
                case "playsInline":
                case "readOnly":
                case "required":
                case "reversed":
                case "scoped":
                case "seamless":
                case "itemScope":
                    hydrateBooleanAttribute(domElement, value, value.toLowerCase(), propKey, extraAttributes, serverDifferences);
                    continue;
                case "capture":
                case "download":
                    a: {
                        i = domElement;
                        var attributeName = attributes = value, serverDifferences$jscomp$0 = serverDifferences;
                        extraAttributes.delete(attributeName);
                        i = i.getAttribute(attributeName);
                        if (null === i) switch(typeof propKey){
                            case "undefined":
                            case "function":
                            case "symbol":
                                break a;
                            default:
                                if (!1 === propKey) break a;
                        }
                        else if (null != propKey) switch(typeof propKey){
                            case "function":
                            case "symbol":
                                break;
                            case "boolean":
                                if (!0 === propKey && "" === i) break a;
                                break;
                            default:
                                if (checkAttributeStringCoercion(propKey, attributes), i === "" + propKey) break a;
                        }
                        warnForPropDifference(attributes, i, propKey, serverDifferences$jscomp$0);
                    }
                    continue;
                case "cols":
                case "rows":
                case "size":
                case "span":
                    a: {
                        i = domElement;
                        attributeName = attributes = value;
                        serverDifferences$jscomp$0 = serverDifferences;
                        extraAttributes.delete(attributeName);
                        i = i.getAttribute(attributeName);
                        if (null === i) switch(typeof propKey){
                            case "undefined":
                            case "function":
                            case "symbol":
                            case "boolean":
                                break a;
                            default:
                                if (isNaN(propKey) || 1 > propKey) break a;
                        }
                        else if (null != propKey) switch(typeof propKey){
                            case "function":
                            case "symbol":
                            case "boolean":
                                break;
                            default:
                                if (!(isNaN(propKey) || 1 > propKey) && (checkAttributeStringCoercion(propKey, attributes), i === "" + propKey)) break a;
                        }
                        warnForPropDifference(attributes, i, propKey, serverDifferences$jscomp$0);
                    }
                    continue;
                case "rowSpan":
                    hydrateNumericAttribute(domElement, value, "rowspan", propKey, extraAttributes, serverDifferences);
                    continue;
                case "start":
                    hydrateNumericAttribute(domElement, value, value, propKey, extraAttributes, serverDifferences);
                    continue;
                case "xHeight":
                    hydrateAttribute(domElement, value, "x-height", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xlinkActuate":
                    hydrateAttribute(domElement, value, "xlink:actuate", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xlinkArcrole":
                    hydrateAttribute(domElement, value, "xlink:arcrole", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xlinkRole":
                    hydrateAttribute(domElement, value, "xlink:role", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xlinkShow":
                    hydrateAttribute(domElement, value, "xlink:show", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xlinkTitle":
                    hydrateAttribute(domElement, value, "xlink:title", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xlinkType":
                    hydrateAttribute(domElement, value, "xlink:type", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xmlBase":
                    hydrateAttribute(domElement, value, "xml:base", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xmlLang":
                    hydrateAttribute(domElement, value, "xml:lang", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xmlSpace":
                    hydrateAttribute(domElement, value, "xml:space", propKey, extraAttributes, serverDifferences);
                    continue;
                case "inert":
                    "" !== propKey || didWarnForNewBooleanPropsWithEmptyValue[value] || (didWarnForNewBooleanPropsWithEmptyValue[value] = !0, console.error("Received an empty string for a boolean attribute `%s`. This will treat the attribute as if it were false. Either pass `false` to silence this warning, or pass `true` if you used an empty string in earlier versions of React to indicate this attribute is true.", value));
                    hydrateBooleanAttribute(domElement, value, value, propKey, extraAttributes, serverDifferences);
                    continue;
                default:
                    if (!(2 < value.length) || "o" !== value[0] && "O" !== value[0] || "n" !== value[1] && "N" !== value[1]) {
                        i = getAttributeAlias(value);
                        attributes = !1;
                        hostContext.context === HostContextNamespaceNone && "svg" !== tag && "math" !== tag ? extraAttributes.delete(i.toLowerCase()) : (attributeName = value.toLowerCase(), attributeName = possibleStandardNames.hasOwnProperty(attributeName) ? possibleStandardNames[attributeName] || null : null, null !== attributeName && attributeName !== value && (attributes = !0, extraAttributes.delete(attributeName)), extraAttributes.delete(i));
                        a: if (attributeName = domElement, serverDifferences$jscomp$0 = i, i = propKey, isAttributeNameSafe(serverDifferences$jscomp$0)) {
                            if (attributeName.hasAttribute(serverDifferences$jscomp$0)) attributeName = attributeName.getAttribute(serverDifferences$jscomp$0), checkAttributeStringCoercion(i, serverDifferences$jscomp$0), i = attributeName === "" + i ? i : attributeName;
                            else {
                                switch(typeof i){
                                    case "function":
                                    case "symbol":
                                        break a;
                                    case "boolean":
                                        if (attributeName = serverDifferences$jscomp$0.toLowerCase().slice(0, 5), "data-" !== attributeName && "aria-" !== attributeName) break a;
                                }
                                i = void 0 === i ? void 0 : null;
                            }
                        } else i = void 0;
                        attributes || warnForPropDifference(value, i, propKey, serverDifferences);
                    }
            }
        }
        0 < extraAttributes.size && !0 !== props.suppressHydrationWarning && warnForExtraAttributes(domElement, extraAttributes, serverDifferences);
        return 0 === Object.keys(serverDifferences).length ? null : serverDifferences;
    }
    function propNamesListJoin(list, combinator) {
        switch(list.length){
            case 0:
                return "";
            case 1:
                return list[0];
            case 2:
                return list[0] + " " + combinator + " " + list[1];
            default:
                return list.slice(0, -1).join(", ") + ", " + combinator + " " + list[list.length - 1];
        }
    }
    function isLikelyStaticResource(initiatorType) {
        switch(initiatorType){
            case "css":
            case "script":
            case "font":
            case "img":
            case "image":
            case "input":
            case "link":
                return !0;
            default:
                return !1;
        }
    }
    function estimateBandwidth() {
        if ("function" === typeof performance.getEntriesByType) {
            for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
                var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
                if (transferSize && duration && isLikelyStaticResource(initiatorType)) {
                    initiatorType = 0;
                    duration = entry.responseEnd;
                    for(i += 1; i < resourceEntries.length; i++){
                        var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                        if (overlapStartTime > duration) break;
                        var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                        overlapTransferSize && isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                    }
                    --i;
                    bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                    count++;
                    if (10 < count) break;
                }
            }
            if (0 < count) return bits / count / 1e6;
        }
        return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
    }
    function getOwnerDocumentFromRootContainer(rootContainerElement) {
        return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
    }
    function getOwnHostContext(namespaceURI) {
        switch(namespaceURI){
            case SVG_NAMESPACE:
                return HostContextNamespaceSvg;
            case MATH_NAMESPACE:
                return HostContextNamespaceMath;
            default:
                return HostContextNamespaceNone;
        }
    }
    function getChildHostContextProd(parentNamespace, type) {
        if (parentNamespace === HostContextNamespaceNone) switch(type){
            case "svg":
                return HostContextNamespaceSvg;
            case "math":
                return HostContextNamespaceMath;
            default:
                return HostContextNamespaceNone;
        }
        return parentNamespace === HostContextNamespaceSvg && "foreignObject" === type ? HostContextNamespaceNone : parentNamespace;
    }
    function shouldSetTextContent(type, props) {
        return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
    }
    function shouldAttemptEagerTransition() {
        var event = window.event;
        if (event && "popstate" === event.type) {
            if (event === currentPopstateTransitionEvent) return !1;
            currentPopstateTransitionEvent = event;
            return !0;
        }
        currentPopstateTransitionEvent = null;
        return !1;
    }
    function resolveEventType() {
        var event = window.event;
        return event && event !== schedulerEvent ? event.type : null;
    }
    function resolveEventTimeStamp() {
        var event = window.event;
        return event && event !== schedulerEvent ? event.timeStamp : -1.1;
    }
    function handleErrorInNextTick(error) {
        setTimeout(function() {
            throw error;
        });
    }
    function commitMount(domElement, type, newProps) {
        switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                newProps.autoFocus && domElement.focus();
                break;
            case "img":
                newProps.src ? domElement.src = newProps.src : newProps.srcSet && (domElement.srcset = newProps.srcSet);
        }
    }
    function commitHydratedInstance() {}
    function commitUpdate(domElement, type, oldProps, newProps) {
        updateProperties(domElement, type, oldProps, newProps);
        domElement[internalPropsKey] = newProps;
    }
    function resetTextContent(domElement) {
        setTextContent(domElement, "");
    }
    function commitTextUpdate(textInstance, oldText, newText) {
        textInstance.nodeValue = newText;
    }
    function warnForReactChildrenConflict(container) {
        if (!container.__reactWarnedAboutChildrenConflict) {
            var props = container[internalPropsKey] || null;
            if (null !== props) {
                var fiber = getInstanceFromNode(container);
                null !== fiber && ("string" === typeof props.children || "number" === typeof props.children ? (container.__reactWarnedAboutChildrenConflict = !0, runWithFiberInDEV(fiber, function() {
                    console.error('Cannot use a ref on a React element as a container to `createRoot` or `createPortal` if that element also sets "children" text content using React. It should be a leaf with no children. Otherwise it\'s ambiguous which children should be used.');
                })) : null != props.dangerouslySetInnerHTML && (container.__reactWarnedAboutChildrenConflict = !0, runWithFiberInDEV(fiber, function() {
                    console.error('Cannot use a ref on a React element as a container to `createRoot` or `createPortal` if that element also sets "dangerouslySetInnerHTML" using React. It should be a leaf with no children. Otherwise it\'s ambiguous which children should be used.');
                })));
            }
        }
    }
    function isSingletonScope(type) {
        return "head" === type;
    }
    function removeChild(parentInstance, child) {
        parentInstance.removeChild(child);
    }
    function removeChildFromContainer(container, child) {
        (9 === container.nodeType ? container.body : "HTML" === container.nodeName ? container.ownerDocument.body : container).removeChild(child);
    }
    function clearHydrationBoundary(parentInstance, hydrationInstance) {
        var node = hydrationInstance, depth = 0;
        do {
            var nextNode = node.nextSibling;
            parentInstance.removeChild(node);
            if (nextNode && 8 === nextNode.nodeType) {
                if (node = nextNode.data, node === SUSPENSE_END_DATA || node === ACTIVITY_END_DATA) {
                    if (0 === depth) {
                        parentInstance.removeChild(nextNode);
                        retryIfBlockedOn(hydrationInstance);
                        return;
                    }
                    depth--;
                } else if (node === SUSPENSE_START_DATA || node === SUSPENSE_PENDING_START_DATA || node === SUSPENSE_QUEUED_START_DATA || node === SUSPENSE_FALLBACK_START_DATA || node === ACTIVITY_START_DATA) depth++;
                else if (node === PREAMBLE_CONTRIBUTION_HTML) releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
                else if (node === PREAMBLE_CONTRIBUTION_HEAD) {
                    node = parentInstance.ownerDocument.head;
                    releaseSingletonInstance(node);
                    for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                        var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                        node$jscomp$0[internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                        node$jscomp$0 = nextNode$jscomp$0;
                    }
                } else node === PREAMBLE_CONTRIBUTION_BODY && releaseSingletonInstance(parentInstance.ownerDocument.body);
            }
            node = nextNode;
        }while (node);
        retryIfBlockedOn(hydrationInstance);
    }
    function hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
        var node = suspenseInstance;
        suspenseInstance = 0;
        do {
            var nextNode = node.nextSibling;
            1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
            if (nextNode && 8 === nextNode.nodeType) {
                if (node = nextNode.data, node === SUSPENSE_END_DATA) {
                    if (0 === suspenseInstance) break;
                    else suspenseInstance--;
                } else node !== SUSPENSE_START_DATA && node !== SUSPENSE_PENDING_START_DATA && node !== SUSPENSE_QUEUED_START_DATA && node !== SUSPENSE_FALLBACK_START_DATA || suspenseInstance++;
            }
            node = nextNode;
        }while (node);
    }
    function hideDehydratedBoundary(suspenseInstance) {
        hideOrUnhideDehydratedBoundary(suspenseInstance, !0);
    }
    function hideInstance(instance) {
        instance = instance.style;
        "function" === typeof instance.setProperty ? instance.setProperty("display", "none", "important") : instance.display = "none";
    }
    function hideTextInstance(textInstance) {
        textInstance.nodeValue = "";
    }
    function unhideDehydratedBoundary(dehydratedInstance) {
        hideOrUnhideDehydratedBoundary(dehydratedInstance, !1);
    }
    function unhideInstance(instance, props) {
        props = props[STYLE];
        props = void 0 !== props && null !== props && props.hasOwnProperty("display") ? props.display : null;
        instance.style.display = null == props || "boolean" === typeof props ? "" : ("" + props).trim();
    }
    function unhideTextInstance(textInstance, text) {
        textInstance.nodeValue = text;
    }
    function clearContainerSparingly(container) {
        var nextNode = container.firstChild;
        nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
        for(; nextNode;){
            var node = nextNode;
            nextNode = nextNode.nextSibling;
            switch(node.nodeName){
                case "HTML":
                case "HEAD":
                case "BODY":
                    clearContainerSparingly(node);
                    detachDeletedInstance(node);
                    continue;
                case "SCRIPT":
                case "STYLE":
                    continue;
                case "LINK":
                    if ("stylesheet" === node.rel.toLowerCase()) continue;
            }
            container.removeChild(node);
        }
    }
    function canHydrateInstance(instance, type, props, inRootOrSingleton) {
        for(; 1 === instance.nodeType;){
            var anyProps = props;
            if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
                if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
            } else if (!inRootOrSingleton) {
                if ("input" === type && "hidden" === instance.type) {
                    checkAttributeStringCoercion(anyProps.name, "name");
                    var name = null == anyProps.name ? null : "" + anyProps.name;
                    if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
                } else return instance;
            } else if (!instance[internalHoistableMarker]) switch(type){
                case "meta":
                    if (!instance.hasAttribute("itemprop")) break;
                    return instance;
                case "link":
                    name = instance.getAttribute("rel");
                    if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                    else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                    return instance;
                case "style":
                    if (instance.hasAttribute("data-precedence")) break;
                    return instance;
                case "script":
                    name = instance.getAttribute("src");
                    if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                    return instance;
                default:
                    return instance;
            }
            instance = getNextHydratable(instance.nextSibling);
            if (null === instance) break;
        }
        return null;
    }
    function canHydrateTextInstance(instance, text, inRootOrSingleton) {
        if ("" === text) return null;
        for(; 3 !== instance.nodeType;){
            if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
            instance = getNextHydratable(instance.nextSibling);
            if (null === instance) return null;
        }
        return instance;
    }
    function canHydrateHydrationBoundary(instance, inRootOrSingleton) {
        for(; 8 !== instance.nodeType;){
            if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
            instance = getNextHydratable(instance.nextSibling);
            if (null === instance) return null;
        }
        return instance;
    }
    function isSuspenseInstancePending(instance) {
        return instance.data === SUSPENSE_PENDING_START_DATA || instance.data === SUSPENSE_QUEUED_START_DATA;
    }
    function isSuspenseInstanceFallback(instance) {
        return instance.data === SUSPENSE_FALLBACK_START_DATA || instance.data === SUSPENSE_PENDING_START_DATA && instance.ownerDocument.readyState !== DOCUMENT_READY_STATE_LOADING;
    }
    function registerSuspenseInstanceRetry(instance, callback) {
        var ownerDocument = instance.ownerDocument;
        if (instance.data === SUSPENSE_QUEUED_START_DATA) instance._reactRetry = callback;
        else if (instance.data !== SUSPENSE_PENDING_START_DATA || ownerDocument.readyState !== DOCUMENT_READY_STATE_LOADING) callback();
        else {
            var listener = function() {
                callback();
                ownerDocument.removeEventListener("DOMContentLoaded", listener);
            };
            ownerDocument.addEventListener("DOMContentLoaded", listener);
            instance._reactRetry = listener;
        }
    }
    function getNextHydratable(node) {
        for(; null != node; node = node.nextSibling){
            var nodeType = node.nodeType;
            if (1 === nodeType || 3 === nodeType) break;
            if (8 === nodeType) {
                nodeType = node.data;
                if (nodeType === SUSPENSE_START_DATA || nodeType === SUSPENSE_FALLBACK_START_DATA || nodeType === SUSPENSE_PENDING_START_DATA || nodeType === SUSPENSE_QUEUED_START_DATA || nodeType === ACTIVITY_START_DATA || nodeType === FORM_STATE_IS_MATCHING || nodeType === FORM_STATE_IS_NOT_MATCHING) break;
                if (nodeType === SUSPENSE_END_DATA || nodeType === ACTIVITY_END_DATA) return null;
            }
        }
        return node;
    }
    function describeHydratableInstanceForDevWarnings(instance) {
        if (1 === instance.nodeType) {
            for(var JSCompiler_temp_const = instance.nodeName.toLowerCase(), serverDifferences = {}, attributes = instance.attributes, i = 0; i < attributes.length; i++){
                var attr = attributes[i];
                serverDifferences[getPropNameFromAttributeName(attr.name)] = "style" === attr.name.toLowerCase() ? getStylesObjectFromElement(instance) : attr.value;
            }
            return {
                type: JSCompiler_temp_const,
                props: serverDifferences
            };
        }
        return 8 === instance.nodeType ? instance.data === ACTIVITY_START_DATA ? {
            type: "Activity",
            props: {}
        } : {
            type: "Suspense",
            props: {}
        } : instance.nodeValue;
    }
    function diffHydratedTextForDevWarnings(textInstance, text, parentProps) {
        return null === parentProps || !0 !== parentProps[SUPPRESS_HYDRATION_WARNING] ? (textInstance.nodeValue === text ? textInstance = null : (text = normalizeMarkupForTextOrAttribute(text), textInstance = normalizeMarkupForTextOrAttribute(textInstance.nodeValue) === text ? null : textInstance.nodeValue), textInstance) : null;
    }
    function getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
        hydrationInstance = hydrationInstance.nextSibling;
        for(var depth = 0; hydrationInstance;){
            if (8 === hydrationInstance.nodeType) {
                var data = hydrationInstance.data;
                if (data === SUSPENSE_END_DATA || data === ACTIVITY_END_DATA) {
                    if (0 === depth) return getNextHydratable(hydrationInstance.nextSibling);
                    depth--;
                } else data !== SUSPENSE_START_DATA && data !== SUSPENSE_FALLBACK_START_DATA && data !== SUSPENSE_PENDING_START_DATA && data !== SUSPENSE_QUEUED_START_DATA && data !== ACTIVITY_START_DATA || depth++;
            }
            hydrationInstance = hydrationInstance.nextSibling;
        }
        return null;
    }
    function getParentHydrationBoundary(targetInstance) {
        targetInstance = targetInstance.previousSibling;
        for(var depth = 0; targetInstance;){
            if (8 === targetInstance.nodeType) {
                var data = targetInstance.data;
                if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA || data === SUSPENSE_QUEUED_START_DATA || data === ACTIVITY_START_DATA) {
                    if (0 === depth) return targetInstance;
                    depth--;
                } else data !== SUSPENSE_END_DATA && data !== ACTIVITY_END_DATA || depth++;
            }
            targetInstance = targetInstance.previousSibling;
        }
        return null;
    }
    function commitHydratedContainer(container) {
        retryIfBlockedOn(container);
    }
    function commitHydratedActivityInstance(activityInstance) {
        retryIfBlockedOn(activityInstance);
    }
    function commitHydratedSuspenseInstance(suspenseInstance) {
        retryIfBlockedOn(suspenseInstance);
    }
    function resolveSingletonInstance(type, props, rootContainerInstance, hostContext, validateDOMNestingDev) {
        validateDOMNestingDev && validateDOMNesting(type, hostContext.ancestorInfo);
        props = getOwnerDocumentFromRootContainer(rootContainerInstance);
        switch(type){
            case "html":
                type = props.documentElement;
                if (!type) throw Error("React expected an <html> element (document.documentElement) to exist in the Document but one was not found. React never removes the documentElement for any Document it renders into so the cause is likely in some other script running on this page.");
                return type;
            case "head":
                type = props.head;
                if (!type) throw Error("React expected a <head> element (document.head) to exist in the Document but one was not found. React never removes the head for any Document it renders into so the cause is likely in some other script running on this page.");
                return type;
            case "body":
                type = props.body;
                if (!type) throw Error("React expected a <body> element (document.body) to exist in the Document but one was not found. React never removes the body for any Document it renders into so the cause is likely in some other script running on this page.");
                return type;
            default:
                throw Error("resolveSingletonInstance was called with an element type that is not supported. This is a bug in React.");
        }
    }
    function acquireSingletonInstance(type, props, instance, internalInstanceHandle) {
        if (!instance[internalContainerInstanceKey] && getInstanceFromNode(instance)) {
            var tagName = instance.tagName.toLowerCase();
            console.error("You are mounting a new %s component when a previous one has not first unmounted. It is an error to render more than one %s component at a time and attributes and children of these components will likely fail in unpredictable ways. Please only render a single instance of <%s> and if you need to mount a new one, ensure any previous ones have unmounted first.", tagName, tagName, tagName);
        }
        switch(type){
            case "html":
            case "head":
            case "body":
                break;
            default:
                console.error("acquireSingletonInstance was called with an element type that is not supported. This is a bug in React.");
        }
        for(tagName = instance.attributes; tagName.length;)instance.removeAttributeNode(tagName[0]);
        setInitialProperties(instance, type, props);
        instance[internalInstanceKey] = internalInstanceHandle;
        instance[internalPropsKey] = props;
    }
    function releaseSingletonInstance(instance) {
        for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
        detachDeletedInstance(instance);
    }
    function getHoistableRoot(container) {
        return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
    }
    function preconnectAs(rel, href, crossOrigin) {
        var ownerDocument = globalDocument;
        if (ownerDocument && "string" === typeof href && href) {
            var limitedEscapedHref = escapeSelectorAttributeValueInsideDoubleQuotes(href);
            limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
            "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
            preconnectsSet.has(limitedEscapedHref) || (preconnectsSet.add(limitedEscapedHref), rel = {
                rel: rel,
                crossOrigin: crossOrigin,
                href: href
            }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), setInitialProperties(href, "link", rel), markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
        }
    }
    function getResource(type, currentProps, pendingProps, currentResource) {
        var resourceRoot = (resourceRoot = rootInstanceStackCursor.current) ? getHoistableRoot(resourceRoot) : null;
        if (!resourceRoot) throw Error('"resourceRoot" was expected to exist. This is a bug in React.');
        switch(type){
            case "meta":
            case "title":
                return null;
            case "style":
                return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (pendingProps = getStyleKey(pendingProps.href), currentProps = getResourcesFromRoot(resourceRoot).hoistableStyles, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                    type: "style",
                    instance: null,
                    count: 0,
                    state: null
                }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                    type: "void",
                    instance: null,
                    count: 0,
                    state: null
                };
            case "link":
                if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                    type = getStyleKey(pendingProps.href);
                    var _styles = getResourcesFromRoot(resourceRoot).hoistableStyles, _resource = _styles.get(type);
                    if (!_resource && (resourceRoot = resourceRoot.ownerDocument || resourceRoot, _resource = {
                        type: "stylesheet",
                        instance: null,
                        count: 0,
                        state: {
                            loading: NotLoaded,
                            preload: null
                        }
                    }, _styles.set(type, _resource), (_styles = resourceRoot.querySelector(getStylesheetSelectorFromKey(type))) && !_styles._p && (_resource.instance = _styles, _resource.state.loading = Loaded | Inserted), !preloadPropsMap.has(type))) {
                        var preloadProps = {
                            rel: "preload",
                            as: "style",
                            href: pendingProps.href,
                            crossOrigin: pendingProps.crossOrigin,
                            integrity: pendingProps.integrity,
                            media: pendingProps.media,
                            hrefLang: pendingProps.hrefLang,
                            referrerPolicy: pendingProps.referrerPolicy
                        };
                        preloadPropsMap.set(type, preloadProps);
                        _styles || preloadStylesheet(resourceRoot, type, preloadProps, _resource.state);
                    }
                    if (currentProps && null === currentResource) throw pendingProps = "\n\n  - " + describeLinkForResourceErrorDEV(currentProps) + "\n  + " + describeLinkForResourceErrorDEV(pendingProps), Error("Expected <link> not to update to be updated to a stylesheet with precedence. Check the `rel`, `href`, and `precedence` props of this component. Alternatively, check whether two different <link> components render in the same slot or share the same key." + pendingProps);
                    return _resource;
                }
                if (currentProps && null !== currentResource) throw pendingProps = "\n\n  - " + describeLinkForResourceErrorDEV(currentProps) + "\n  + " + describeLinkForResourceErrorDEV(pendingProps), Error("Expected stylesheet with precedence to not be updated to a different kind of <link>. Check the `rel`, `href`, and `precedence` props of this component. Alternatively, check whether two different <link> components render in the same slot or share the same key." + pendingProps);
                return null;
            case "script":
                return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (pendingProps = getScriptKey(pendingProps), currentProps = getResourcesFromRoot(resourceRoot).hoistableScripts, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                    type: "script",
                    instance: null,
                    count: 0,
                    state: null
                }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                    type: "void",
                    instance: null,
                    count: 0,
                    state: null
                };
            default:
                throw Error('getResource encountered a type it did not expect: "' + type + '". this is a bug in React.');
        }
    }
    function describeLinkForResourceErrorDEV(props) {
        var describedProps = 0, description = "<link";
        "string" === typeof props.rel ? (describedProps++, description += ' rel="' + props.rel + '"') : hasOwnProperty.call(props, "rel") && (describedProps++, description += ' rel="' + (null === props.rel ? "null" : "invalid type " + typeof props.rel) + '"');
        "string" === typeof props.href ? (describedProps++, description += ' href="' + props.href + '"') : hasOwnProperty.call(props, "href") && (describedProps++, description += ' href="' + (null === props.href ? "null" : "invalid type " + typeof props.href) + '"');
        "string" === typeof props.precedence ? (describedProps++, description += ' precedence="' + props.precedence + '"') : hasOwnProperty.call(props, "precedence") && (describedProps++, description += " precedence={" + (null === props.precedence ? "null" : "invalid type " + typeof props.precedence) + "}");
        Object.getOwnPropertyNames(props).length > describedProps && (description += " ...");
        return description + " />";
    }
    function getStyleKey(href) {
        return 'href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
    }
    function getStylesheetSelectorFromKey(key) {
        return 'link[rel="stylesheet"][' + key + "]";
    }
    function stylesheetPropsFromRawProps(rawProps) {
        return assign({}, rawProps, {
            "data-precedence": rawProps.precedence,
            precedence: null
        });
    }
    function preloadStylesheet(ownerDocument, key, preloadProps, state) {
        ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = Loaded : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
            return state.loading |= Loaded;
        }), key.addEventListener("error", function() {
            return state.loading |= Errored;
        }), setInitialProperties(key, "link", preloadProps), markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
    }
    function getScriptKey(src) {
        return '[src="' + escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
    }
    function getScriptSelectorFromKey(key) {
        return "script[async]" + key;
    }
    function acquireResource(hoistableRoot, resource, props) {
        resource.count++;
        if (null === resource.instance) switch(resource.type){
            case "style":
                var instance = hoistableRoot.querySelector('style[data-href~="' + escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
                if (instance) return resource.instance = instance, markNodeAsHoistable(instance), instance;
                var styleProps = assign({}, props, {
                    "data-href": props.href,
                    "data-precedence": props.precedence,
                    href: null,
                    precedence: null
                });
                instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
                markNodeAsHoistable(instance);
                setInitialProperties(instance, "style", styleProps);
                insertStylesheet(instance, props.precedence, hoistableRoot);
                return resource.instance = instance;
            case "stylesheet":
                styleProps = getStyleKey(props.href);
                var _instance = hoistableRoot.querySelector(getStylesheetSelectorFromKey(styleProps));
                if (_instance) return resource.state.loading |= Inserted, resource.instance = _instance, markNodeAsHoistable(_instance), _instance;
                instance = stylesheetPropsFromRawProps(props);
                (styleProps = preloadPropsMap.get(styleProps)) && adoptPreloadPropsForStylesheet(instance, styleProps);
                _instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
                markNodeAsHoistable(_instance);
                var linkInstance = _instance;
                linkInstance._p = new Promise(function(resolve, reject) {
                    linkInstance.onload = resolve;
                    linkInstance.onerror = reject;
                });
                setInitialProperties(_instance, "link", instance);
                resource.state.loading |= Inserted;
                insertStylesheet(_instance, props.precedence, hoistableRoot);
                return resource.instance = _instance;
            case "script":
                _instance = getScriptKey(props.src);
                if (styleProps = hoistableRoot.querySelector(getScriptSelectorFromKey(_instance))) return resource.instance = styleProps, markNodeAsHoistable(styleProps), styleProps;
                instance = props;
                if (styleProps = preloadPropsMap.get(_instance)) instance = assign({}, props), adoptPreloadPropsForScript(instance, styleProps);
                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                styleProps = hoistableRoot.createElement("script");
                markNodeAsHoistable(styleProps);
                setInitialProperties(styleProps, "link", instance);
                hoistableRoot.head.appendChild(styleProps);
                return resource.instance = styleProps;
            case "void":
                return null;
            default:
                throw Error('acquireResource encountered a resource type it did not expect: "' + resource.type + '". this is a bug in React.');
        }
        else "stylesheet" === resource.type && (resource.state.loading & Inserted) === NotLoaded && (instance = resource.instance, resource.state.loading |= Inserted, insertStylesheet(instance, props.precedence, hoistableRoot));
        return resource.instance;
    }
    function insertStylesheet(instance, precedence, root) {
        for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
            var node = nodes[i];
            if (node.dataset.precedence === precedence) prior = node;
            else if (prior !== last) break;
        }
        prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
    }
    function adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
        null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
        null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
        null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
    }
    function adoptPreloadPropsForScript(scriptProps, preloadProps) {
        null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
        null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
        null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
    }
    function getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
        if (null === tagCaches) {
            var cache = new Map();
            var caches = tagCaches = new Map();
            caches.set(ownerDocument, cache);
        } else caches = tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
        if (cache.has(type)) return cache;
        cache.set(type, null);
        ownerDocument = ownerDocument.getElementsByTagName(type);
        for(caches = 0; caches < ownerDocument.length; caches++){
            var node = ownerDocument[caches];
            if (!(node[internalHoistableMarker] || node[internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && node.namespaceURI !== SVG_NAMESPACE) {
                var nodeKey = node.getAttribute(keyAttribute) || "";
                nodeKey = type + nodeKey;
                var existing = cache.get(nodeKey);
                existing ? existing.push(node) : cache.set(nodeKey, [
                    node
                ]);
            }
        }
        return cache;
    }
    function mountHoistable(hoistableRoot, type, instance) {
        hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
        hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
    }
    function isHostHoistableType(type, props, hostContext) {
        var outsideHostContainerContext = !hostContext.ancestorInfo.containerTagInScope;
        if (hostContext.context === HostContextNamespaceSvg || null != props.itemProp) return !outsideHostContainerContext || null == props.itemProp || "meta" !== type && "title" !== type && "style" !== type && "link" !== type && "script" !== type || console.error("Cannot render a <%s> outside the main document if it has an `itemProp` prop. `itemProp` suggests the tag belongs to an `itemScope` which can appear anywhere in the DOM. If you were intending for React to hoist this <%s> remove the `itemProp` prop. Otherwise, try moving this tag into the <head> or <body> of the Document.", type, type), !1;
        switch(type){
            case "meta":
            case "title":
                return !0;
            case "style":
                if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) {
                    outsideHostContainerContext && console.error('Cannot render a <style> outside the main document without knowing its precedence and a unique href key. React can hoist and deduplicate <style> tags if you provide a `precedence` prop along with an `href` prop that does not conflict with the `href` values used in any other hoisted <style> or <link rel="stylesheet" ...> tags.  Note that hoisting <style> tags is considered an advanced feature that most will not use directly. Consider moving the <style> tag to the <head> or consider adding a `precedence="default"` and `href="some unique resource identifier"`.');
                    break;
                }
                return !0;
            case "link":
                if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) {
                    if ("stylesheet" === props.rel && "string" === typeof props.precedence) {
                        type = props.href;
                        var onError = props.onError, disabled = props.disabled;
                        hostContext = [];
                        props.onLoad && hostContext.push("`onLoad`");
                        onError && hostContext.push("`onError`");
                        null != disabled && hostContext.push("`disabled`");
                        onError = propNamesListJoin(hostContext, "and");
                        onError += 1 === hostContext.length ? " prop" : " props";
                        disabled = 1 === hostContext.length ? "an " + onError : "the " + onError;
                        hostContext.length && console.error('React encountered a <link rel="stylesheet" href="%s" ... /> with a `precedence` prop that also included %s. The presence of loading and error handlers indicates an intent to manage the stylesheet loading state from your from your Component code and React will not hoist or deduplicate this stylesheet. If your intent was to have React hoist and deduplciate this stylesheet using the `precedence` prop remove the %s, otherwise remove the `precedence` prop.', type, disabled, onError);
                    }
                    outsideHostContainerContext && ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href ? console.error("Cannot render a <link> outside the main document without a `rel` and `href` prop. Try adding a `rel` and/or `href` prop to this <link> or moving the link into the <head> tag") : (props.onError || props.onLoad) && console.error("Cannot render a <link> with onLoad or onError listeners outside the main document. Try removing onLoad={...} and onError={...} or moving it into the root <head> tag or somewhere in the <body>."));
                    break;
                }
                switch(props.rel){
                    case "stylesheet":
                        return type = props.precedence, props = props.disabled, "string" !== typeof type && outsideHostContainerContext && console.error('Cannot render a <link rel="stylesheet" /> outside the main document without knowing its precedence. Consider adding precedence="default" or moving it into the root <head> tag.'), "string" === typeof type && null == props;
                    default:
                        return !0;
                }
            case "script":
                type = props.async && "function" !== typeof props.async && "symbol" !== typeof props.async;
                if (!type || props.onLoad || props.onError || !props.src || "string" !== typeof props.src) {
                    outsideHostContainerContext && (type ? props.onLoad || props.onError ? console.error("Cannot render a <script> with onLoad or onError listeners outside the main document. Try removing onLoad={...} and onError={...} or moving it into the root <head> tag or somewhere in the <body>.") : console.error("Cannot render a <script> outside the main document without `async={true}` and a non-empty `src` prop. Ensure there is a valid `src` and either make the script async or move it into the root <head> tag or somewhere in the <body>.") : console.error('Cannot render a sync or defer <script> outside the main document without knowing its order. Try adding async="" or moving it into the root <head> tag.'));
                    break;
                }
                return !0;
            case "noscript":
            case "template":
                outsideHostContainerContext && console.error("Cannot render <%s> outside the main document. Try moving it into the root <head> tag.", type);
        }
        return !1;
    }
    function preloadResource(resource) {
        return "stylesheet" === resource.type && (resource.state.loading & Settled) === NotLoaded ? !1 : !0;
    }
    function suspendResource(state, hoistableRoot, resource, props) {
        if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && (resource.state.loading & Inserted) === NotLoaded) {
            if (null === resource.instance) {
                var key = getStyleKey(props.href), instance = hoistableRoot.querySelector(getStylesheetSelectorFromKey(key));
                if (instance) {
                    hoistableRoot = instance._p;
                    null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = onUnsuspend.bind(state), hoistableRoot.then(state, state));
                    resource.state.loading |= Inserted;
                    resource.instance = instance;
                    markNodeAsHoistable(instance);
                    return;
                }
                instance = hoistableRoot.ownerDocument || hoistableRoot;
                props = stylesheetPropsFromRawProps(props);
                (key = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(props, key);
                instance = instance.createElement("link");
                markNodeAsHoistable(instance);
                var linkInstance = instance;
                linkInstance._p = new Promise(function(resolve, reject) {
                    linkInstance.onload = resolve;
                    linkInstance.onerror = reject;
                });
                setInitialProperties(instance, "link", props);
                resource.instance = instance;
            }
            null === state.stylesheets && (state.stylesheets = new Map());
            state.stylesheets.set(resource, hoistableRoot);
            (hoistableRoot = resource.state.preload) && (resource.state.loading & Settled) === NotLoaded && (state.count++, resource = onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
        }
    }
    function waitForCommitToBeReady(state, timeoutOffset) {
        state.stylesheets && 0 === state.count && insertSuspendedStylesheets(state, state.stylesheets);
        return 0 < state.count || 0 < state.imgCount ? function(commit) {
            var stylesheetTimer = setTimeout(function() {
                state.stylesheets && insertSuspendedStylesheets(state, state.stylesheets);
                if (state.unsuspend) {
                    var unsuspend = state.unsuspend;
                    state.unsuspend = null;
                    unsuspend();
                }
            }, SUSPENSEY_STYLESHEET_TIMEOUT + timeoutOffset);
            0 < state.imgBytes && 0 === estimatedBytesWithinLimit && (estimatedBytesWithinLimit = 125 * estimateBandwidth() * SUSPENSEY_IMAGE_TIME_ESTIMATE);
            var imgTimer = setTimeout(function() {
                state.waitingForImages = !1;
                if (0 === state.count && (state.stylesheets && insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                    var unsuspend = state.unsuspend;
                    state.unsuspend = null;
                    unsuspend();
                }
            }, (state.imgBytes > estimatedBytesWithinLimit ? 50 : SUSPENSEY_IMAGE_TIMEOUT) + timeoutOffset);
            state.unsuspend = commit;
            return function() {
                state.unsuspend = null;
                clearTimeout(stylesheetTimer);
                clearTimeout(imgTimer);
            };
        } : null;
    }
    function onUnsuspend() {
        this.count--;
        if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
            if (this.stylesheets) insertSuspendedStylesheets(this, this.stylesheets);
            else if (this.unsuspend) {
                var unsuspend = this.unsuspend;
                this.unsuspend = null;
                unsuspend();
            }
        }
    }
    function insertSuspendedStylesheets(state, resources) {
        state.stylesheets = null;
        null !== state.unsuspend && (state.count++, precedencesByRoot = new Map(), resources.forEach(insertStylesheetIntoRoot, state), precedencesByRoot = null, onUnsuspend.call(state));
    }
    function insertStylesheetIntoRoot(root, resource) {
        if (!(resource.state.loading & Inserted)) {
            var precedences = precedencesByRoot.get(root);
            if (precedences) var last = precedences.get(LAST_PRECEDENCE);
            else {
                precedences = new Map();
                precedencesByRoot.set(root, precedences);
                for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                    var node = nodes[i];
                    if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
                }
                last && precedences.set(LAST_PRECEDENCE, last);
            }
            nodes = resource.instance;
            node = nodes.getAttribute("data-precedence");
            i = precedences.get(node) || last;
            i === last && precedences.set(LAST_PRECEDENCE, nodes);
            precedences.set(node, nodes);
            this.count++;
            last = onUnsuspend.bind(this);
            nodes.addEventListener("load", last);
            nodes.addEventListener("error", last);
            i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
            resource.state.loading |= Inserted;
        }
    }
    function FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
        this.tag = 1;
        this.containerInfo = containerInfo;
        this.pingCache = this.current = this.pendingChildren = null;
        this.timeoutHandle = noTimeout;
        this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
        this.callbackPriority = 0;
        this.expirationTimes = createLaneMap(-1);
        this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
        this.entanglements = createLaneMap(0);
        this.hiddenUpdates = createLaneMap(null);
        this.identifierPrefix = identifierPrefix;
        this.onUncaughtError = onUncaughtError;
        this.onCaughtError = onCaughtError;
        this.onRecoverableError = onRecoverableError;
        this.pooledCache = null;
        this.pooledCacheLanes = 0;
        this.formState = formState;
        this.incompleteTransitions = new Map();
        this.passiveEffectDuration = this.effectDuration = -0;
        this.memoizedUpdaters = new Set();
        containerInfo = this.pendingUpdatersLaneMap = [];
        for(tag = 0; 31 > tag; tag++)containerInfo.push(new Set());
        this._debugRootType = hydrate ? "hydrateRoot()" : "createRoot()";
    }
    function createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
        containerInfo = new FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
        tag = ConcurrentMode;
        !0 === isStrictMode && (tag |= StrictLegacyMode | StrictEffectsMode);
        tag |= ProfileMode;
        isStrictMode = createFiber(3, null, null, tag);
        containerInfo.current = isStrictMode;
        isStrictMode.stateNode = containerInfo;
        tag = createCache();
        retainCache(tag);
        containerInfo.pooledCache = tag;
        retainCache(tag);
        isStrictMode.memoizedState = {
            element: initialChildren,
            isDehydrated: hydrate,
            cache: tag
        };
        initializeUpdateQueue(isStrictMode);
        return containerInfo;
    }
    function getContextForSubtree(parentComponent) {
        if (!parentComponent) return emptyContextObject;
        parentComponent = emptyContextObject;
        return parentComponent;
    }
    function updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
        if (injectedHook && "function" === typeof injectedHook.onScheduleFiberRoot) try {
            injectedHook.onScheduleFiberRoot(rendererID, container, element);
        } catch (err) {
            hasLoggedError || (hasLoggedError = !0, console.error("React instrumentation encountered an error: %o", err));
        }
        parentComponent = getContextForSubtree(parentComponent);
        null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
        isRendering && null !== current && !didWarnAboutNestedUpdates && (didWarnAboutNestedUpdates = !0, console.error("Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.\n\nCheck the render method of %s.", getComponentNameFromFiber(current) || "Unknown"));
        container = createUpdate(lane);
        container.payload = {
            element: element
        };
        callback = void 0 === callback ? null : callback;
        null !== callback && ("function" !== typeof callback && console.error("Expected the last optional `callback` argument to be a function. Instead received: %s.", callback), container.callback = callback);
        element = enqueueUpdate(rootFiber, container, lane);
        null !== element && (startUpdateTimerByLane(lane, "root.render()", null), scheduleUpdateOnFiber(element, rootFiber, lane), entangleTransitions(element, rootFiber, lane));
    }
    function markRetryLaneImpl(fiber, retryLane) {
        fiber = fiber.memoizedState;
        if (null !== fiber && null !== fiber.dehydrated) {
            var a = fiber.retryLane;
            fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
        }
    }
    function markRetryLaneIfNotHydrated(fiber, retryLane) {
        markRetryLaneImpl(fiber, retryLane);
        (fiber = fiber.alternate) && markRetryLaneImpl(fiber, retryLane);
    }
    function attemptContinuousHydration(fiber) {
        if (13 === fiber.tag || 31 === fiber.tag) {
            var root = enqueueConcurrentRenderForLane(fiber, 67108864);
            null !== root && scheduleUpdateOnFiber(root, fiber, 67108864);
            markRetryLaneIfNotHydrated(fiber, 67108864);
        }
    }
    function attemptHydrationAtCurrentPriority(fiber) {
        if (13 === fiber.tag || 31 === fiber.tag) {
            var lane = requestUpdateLane(fiber);
            lane = getBumpedLaneForHydrationByLane(lane);
            var root = enqueueConcurrentRenderForLane(fiber, lane);
            null !== root && scheduleUpdateOnFiber(root, fiber, lane);
            markRetryLaneIfNotHydrated(fiber, lane);
        }
    }
    function getCurrentFiberForDevTools() {
        return current;
    }
    function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var prevTransition = ReactSharedInternals.T;
        ReactSharedInternals.T = null;
        var previousPriority = ReactDOMSharedInternals.p;
        try {
            ReactDOMSharedInternals.p = DiscreteEventPriority, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally{
            ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
        }
    }
    function dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var prevTransition = ReactSharedInternals.T;
        ReactSharedInternals.T = null;
        var previousPriority = ReactDOMSharedInternals.p;
        try {
            ReactDOMSharedInternals.p = ContinuousEventPriority, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally{
            ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
        }
    }
    function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (_enabled) {
            var blockedOn = findInstanceBlockingEvent(nativeEvent);
            if (null === blockedOn) dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer), clearIfContinuousEvent(domEventName, nativeEvent);
            else if (queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
            else if (clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < discreteReplayableEvents.indexOf(domEventName)) {
                for(; null !== blockedOn;){
                    var fiber = getInstanceFromNode(blockedOn);
                    if (null !== fiber) switch(fiber.tag){
                        case 3:
                            fiber = fiber.stateNode;
                            if (fiber.current.memoizedState.isDehydrated) {
                                var lanes = getHighestPriorityLanes(fiber.pendingLanes);
                                if (0 !== lanes) {
                                    var root = fiber;
                                    root.pendingLanes |= 2;
                                    for(root.entangledLanes |= 2; lanes;){
                                        var lane = 1 << 31 - clz32(lanes);
                                        root.entanglements[1] |= lane;
                                        lanes &= ~lane;
                                    }
                                    ensureRootIsScheduled(fiber);
                                    (executionContext & (RenderContext | CommitContext)) === NoContext && (workInProgressRootRenderTargetTime = now$1() + RENDER_TIMEOUT_MS, flushSyncWorkAcrossRoots_impl(0, !1));
                                }
                            }
                            break;
                        case 31:
                        case 13:
                            root = enqueueConcurrentRenderForLane(fiber, 2), null !== root && scheduleUpdateOnFiber(root, fiber, 2), flushSyncWork$1(), markRetryLaneIfNotHydrated(fiber, 2);
                    }
                    fiber = findInstanceBlockingEvent(nativeEvent);
                    null === fiber && dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
                    if (fiber === blockedOn) break;
                    blockedOn = fiber;
                }
                null !== blockedOn && nativeEvent.stopPropagation();
            } else dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
        }
    }
    function findInstanceBlockingEvent(nativeEvent) {
        nativeEvent = getEventTarget(nativeEvent);
        return findInstanceBlockingTarget(nativeEvent);
    }
    function findInstanceBlockingTarget(targetNode) {
        return_targetInst = null;
        targetNode = getClosestInstanceFromNode(targetNode);
        if (null !== targetNode) {
            var nearestMounted = getNearestMountedFiber(targetNode);
            if (null === nearestMounted) targetNode = null;
            else {
                var tag = nearestMounted.tag;
                if (13 === tag) {
                    targetNode = getSuspenseInstanceFromFiber(nearestMounted);
                    if (null !== targetNode) return targetNode;
                    targetNode = null;
                } else if (31 === tag) {
                    targetNode = getActivityInstanceFromFiber(nearestMounted);
                    if (null !== targetNode) return targetNode;
                    targetNode = null;
                } else if (3 === tag) {
                    if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                    targetNode = null;
                } else nearestMounted !== targetNode && (targetNode = null);
            }
        }
        return_targetInst = targetNode;
        return null;
    }
    function getEventPriority(domEventName) {
        switch(domEventName){
            case "beforetoggle":
            case "cancel":
            case "click":
            case "close":
            case "contextmenu":
            case "copy":
            case "cut":
            case "auxclick":
            case "dblclick":
            case "dragend":
            case "dragstart":
            case "drop":
            case "focusin":
            case "focusout":
            case "input":
            case "invalid":
            case "keydown":
            case "keypress":
            case "keyup":
            case "mousedown":
            case "mouseup":
            case "paste":
            case "pause":
            case "play":
            case "pointercancel":
            case "pointerdown":
            case "pointerup":
            case "ratechange":
            case "reset":
            case "resize":
            case "seeked":
            case "submit":
            case "toggle":
            case "touchcancel":
            case "touchend":
            case "touchstart":
            case "volumechange":
            case "change":
            case "selectionchange":
            case "textInput":
            case "compositionstart":
            case "compositionend":
            case "compositionupdate":
            case "beforeblur":
            case "afterblur":
            case "beforeinput":
            case "blur":
            case "fullscreenchange":
            case "focus":
            case "hashchange":
            case "popstate":
            case "select":
            case "selectstart":
                return DiscreteEventPriority;
            case "drag":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "mousemove":
            case "mouseout":
            case "mouseover":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "scroll":
            case "touchmove":
            case "wheel":
            case "mouseenter":
            case "mouseleave":
            case "pointerenter":
            case "pointerleave":
                return ContinuousEventPriority;
            case "message":
                switch(getCurrentPriorityLevel()){
                    case ImmediatePriority:
                        return DiscreteEventPriority;
                    case UserBlockingPriority:
                        return ContinuousEventPriority;
                    case NormalPriority$1:
                    case LowPriority:
                        return DefaultEventPriority;
                    case IdlePriority:
                        return IdleEventPriority;
                    default:
                        return DefaultEventPriority;
                }
            default:
                return DefaultEventPriority;
        }
    }
    function clearIfContinuousEvent(domEventName, nativeEvent) {
        switch(domEventName){
            case "focusin":
            case "focusout":
                queuedFocus = null;
                break;
            case "dragenter":
            case "dragleave":
                queuedDrag = null;
                break;
            case "mouseover":
            case "mouseout":
                queuedMouse = null;
                break;
            case "pointerover":
            case "pointerout":
                queuedPointers.delete(nativeEvent.pointerId);
                break;
            case "gotpointercapture":
            case "lostpointercapture":
                queuedPointerCaptures.delete(nativeEvent.pointerId);
        }
    }
    function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
            blockedOn: blockedOn,
            domEventName: domEventName,
            eventSystemFlags: eventSystemFlags,
            nativeEvent: nativeEvent,
            targetContainers: [
                targetContainer
            ]
        }, null !== blockedOn && (blockedOn = getInstanceFromNode(blockedOn), null !== blockedOn && attemptContinuousHydration(blockedOn)), existingQueuedEvent;
        existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
        blockedOn = existingQueuedEvent.targetContainers;
        null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
        return existingQueuedEvent;
    }
    function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        switch(domEventName){
            case "focusin":
                return queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
            case "dragenter":
                return queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
            case "mouseover":
                return queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
            case "pointerover":
                var pointerId = nativeEvent.pointerId;
                queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
                return !0;
            case "gotpointercapture":
                return pointerId = nativeEvent.pointerId, queuedPointerCaptures.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
        }
        return !1;
    }
    function attemptExplicitHydrationTarget(queuedTarget) {
        var targetInst = getClosestInstanceFromNode(queuedTarget.target);
        if (null !== targetInst) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (null !== nearestMounted) {
                if (targetInst = nearestMounted.tag, 13 === targetInst) {
                    if (targetInst = getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                        queuedTarget.blockedOn = targetInst;
                        runWithPriority(queuedTarget.priority, function() {
                            attemptHydrationAtCurrentPriority(nearestMounted);
                        });
                        return;
                    }
                } else if (31 === targetInst) {
                    if (targetInst = getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                        queuedTarget.blockedOn = targetInst;
                        runWithPriority(queuedTarget.priority, function() {
                            attemptHydrationAtCurrentPriority(nearestMounted);
                        });
                        return;
                    }
                } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                    queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                    return;
                }
            }
        }
        queuedTarget.blockedOn = null;
    }
    function attemptReplayContinuousQueuedEvent(queuedEvent) {
        if (null !== queuedEvent.blockedOn) return !1;
        for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
            var nextBlockedOn = findInstanceBlockingEvent(queuedEvent.nativeEvent);
            if (null === nextBlockedOn) {
                nextBlockedOn = queuedEvent.nativeEvent;
                var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn), event = nativeEventClone;
                null !== currentReplayingEvent && console.error("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue.");
                currentReplayingEvent = event;
                nextBlockedOn.target.dispatchEvent(nativeEventClone);
                null === currentReplayingEvent && console.error("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue.");
                currentReplayingEvent = null;
            } else return targetContainers = getInstanceFromNode(nextBlockedOn), null !== targetContainers && attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
            targetContainers.shift();
        }
        return !0;
    }
    function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
        attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
    }
    function replayUnblockedEvents() {
        hasScheduledReplayAttempt = !1;
        null !== queuedFocus && attemptReplayContinuousQueuedEvent(queuedFocus) && (queuedFocus = null);
        null !== queuedDrag && attemptReplayContinuousQueuedEvent(queuedDrag) && (queuedDrag = null);
        null !== queuedMouse && attemptReplayContinuousQueuedEvent(queuedMouse) && (queuedMouse = null);
        queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
        queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
    }
    function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
        queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, hasScheduledReplayAttempt || (hasScheduledReplayAttempt = !0, Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents)));
    }
    function scheduleReplayQueueIfNeeded(formReplayingQueue) {
        lastScheduledReplayQueue !== formReplayingQueue && (lastScheduledReplayQueue = formReplayingQueue, Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, function() {
            lastScheduledReplayQueue === formReplayingQueue && (lastScheduledReplayQueue = null);
            for(var i = 0; i < formReplayingQueue.length; i += 3){
                var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
                if ("function" !== typeof submitterOrAction) {
                    if (null === findInstanceBlockingTarget(submitterOrAction || form)) continue;
                    else break;
                }
                var formInst = getInstanceFromNode(form);
                null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, form = {
                    pending: !0,
                    data: formData,
                    method: form.method,
                    action: submitterOrAction
                }, Object.freeze(form), startHostTransition(formInst, form, submitterOrAction, formData));
            }
        }));
    }
    function retryIfBlockedOn(unblocked) {
        function unblock(queuedEvent) {
            return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
        }
        null !== queuedFocus && scheduleCallbackIfUnblocked(queuedFocus, unblocked);
        null !== queuedDrag && scheduleCallbackIfUnblocked(queuedDrag, unblocked);
        null !== queuedMouse && scheduleCallbackIfUnblocked(queuedMouse, unblocked);
        queuedPointers.forEach(unblock);
        queuedPointerCaptures.forEach(unblock);
        for(var i = 0; i < queuedExplicitHydrationTargets.length; i++){
            var queuedTarget = queuedExplicitHydrationTargets[i];
            queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
        }
        for(; 0 < queuedExplicitHydrationTargets.length && (i = queuedExplicitHydrationTargets[0], null === i.blockedOn);)attemptExplicitHydrationTarget(i), null === i.blockedOn && queuedExplicitHydrationTargets.shift();
        i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
        if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
            var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[internalPropsKey] || null;
            if ("function" === typeof submitterOrAction) formProps || scheduleReplayQueueIfNeeded(i);
            else if (formProps) {
                var action = null;
                if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                    if (form = submitterOrAction, formProps = submitterOrAction[internalPropsKey] || null) action = formProps.formAction;
                    else {
                        if (null !== findInstanceBlockingTarget(form)) continue;
                    }
                } else action = formProps.action;
                "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
                scheduleReplayQueueIfNeeded(i);
            }
        }
    }
    function defaultOnDefaultTransitionIndicator() {
        function handleNavigate(event) {
            event.canIntercept && "react-transition" === event.info && event.intercept({
                handler: function() {
                    return new Promise(function(resolve) {
                        return pendingResolve = resolve;
                    });
                },
                focusReset: "manual",
                scroll: "manual"
            });
        }
        function handleNavigateComplete() {
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
            isCancelled || setTimeout(startFakeNavigation, 20);
        }
        function startFakeNavigation() {
            if (!isCancelled && !navigation.transition) {
                var currentEntry = navigation.currentEntry;
                currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                    state: currentEntry.getState(),
                    info: "react-transition",
                    history: "replace"
                });
            }
        }
        if ("object" === typeof navigation) {
            var isCancelled = !1, pendingResolve = null;
            navigation.addEventListener("navigate", handleNavigate);
            navigation.addEventListener("navigatesuccess", handleNavigateComplete);
            navigation.addEventListener("navigateerror", handleNavigateComplete);
            setTimeout(startFakeNavigation, 100);
            return function() {
                isCancelled = !0;
                navigation.removeEventListener("navigate", handleNavigate);
                navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
                navigation.removeEventListener("navigateerror", handleNavigateComplete);
                null !== pendingResolve && (pendingResolve(), pendingResolve = null);
            };
        }
    }
    function ReactDOMRoot(internalRoot) {
        this._internalRoot = internalRoot;
    }
    function ReactDOMHydrationRoot(internalRoot) {
        this._internalRoot = internalRoot;
    }
    function warnIfReactDOMContainerInDEV(container) {
        container[internalContainerInstanceKey] && (container._reactRootContainer ? console.error("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.") : console.error("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."));
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var Scheduler = (parcelRequire("fO90s")), React = (parcelRequire("acw62")), ReactDOM = (parcelRequire("1u0KT")), assign = Object.assign, REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy");
    Symbol.for("react.scope");
    var REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
    Symbol.for("react.legacy_hidden");
    Symbol.for("react.tracing_marker");
    var REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
    Symbol.for("react.view_transition");
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator, REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference"), isArrayImpl = Array.isArray, ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, ReactDOMSharedInternals = ReactDOM.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, NotPending = Object.freeze({
        pending: !1,
        data: null,
        method: null,
        action: null
    }), valueStack = [];
    var fiberStack = [];
    var index$jscomp$0 = -1, contextStackCursor = createCursor(null), contextFiberStackCursor = createCursor(null), rootInstanceStackCursor = createCursor(null), hostTransitionProviderCursor = createCursor(null), disabledDepth = 0, prevLog, prevInfo, prevWarn, prevError, prevGroup, prevGroupCollapsed, prevGroupEnd;
    disabledLog.__reactDisabledLog = !0;
    var prefix, suffix, reentry = !1;
    var componentFrameCache = new ("function" === typeof WeakMap ? WeakMap : Map)();
    var current = null, isRendering = !1, hasOwnProperty = Object.prototype.hasOwnProperty, scheduleCallback$3 = Scheduler.unstable_scheduleCallback, cancelCallback$1 = Scheduler.unstable_cancelCallback, shouldYield = Scheduler.unstable_shouldYield, requestPaint = Scheduler.unstable_requestPaint, now$1 = Scheduler.unstable_now, getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel, ImmediatePriority = Scheduler.unstable_ImmediatePriority, UserBlockingPriority = Scheduler.unstable_UserBlockingPriority, NormalPriority$1 = Scheduler.unstable_NormalPriority, LowPriority = Scheduler.unstable_LowPriority, IdlePriority = Scheduler.unstable_IdlePriority, log$1 = Scheduler.log, unstable_setDisableYieldValue = Scheduler.unstable_setDisableYieldValue, rendererID = null, injectedHook = null, hasLoggedError = !1, isDevToolsPresent = "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__, clz32 = Math.clz32 ? Math.clz32 : clz32Fallback, log = Math.log, LN2 = Math.LN2, nextTransitionUpdateLane = 256, nextTransitionDeferredLane = 262144, nextRetryLane = 4194304, DiscreteEventPriority = 2, ContinuousEventPriority = 8, DefaultEventPriority = 32, IdleEventPriority = 268435456, randomKey = Math.random().toString(36).slice(2), internalInstanceKey = "__reactFiber$" + randomKey, internalPropsKey = "__reactProps$" + randomKey, internalContainerInstanceKey = "__reactContainer$" + randomKey, internalEventHandlersKey = "__reactEvents$" + randomKey, internalEventHandlerListenersKey = "__reactListeners$" + randomKey, internalEventHandlesSetKey = "__reactHandles$" + randomKey, internalRootNodeResourcesKey = "__reactResources$" + randomKey, internalHoistableMarker = "__reactMarker$" + randomKey, allNativeEvents = new Set(), registrationNameDependencies = {}, possibleRegistrationNames = {}, hasReadOnlyValue = {
        button: !0,
        checkbox: !0,
        image: !0,
        hidden: !0,
        radio: !0,
        reset: !0,
        submit: !0
    }, VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), illegalAttributeNameCache = {}, validatedAttributeNameCache = {}, escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g, didWarnValueDefaultValue$1 = !1, didWarnCheckedDefaultChecked = !1, didWarnSelectedSetOnOption = !1, didWarnInvalidChild = !1, didWarnInvalidInnerHTML = !1;
    var didWarnValueDefaultValue = !1;
    var valuePropNames = [
        "value",
        "defaultValue"
    ], didWarnValDefaultVal = !1, needsEscaping = /["'&<>\n\t]|^\s|\s$/, specialTags = "address applet area article aside base basefont bgsound blockquote body br button caption center col colgroup dd details dir div dl dt embed fieldset figcaption figure footer form frame frameset h1 h2 h3 h4 h5 h6 head header hgroup hr html iframe img input isindex li link listing main marquee menu menuitem meta nav noembed noframes noscript object ol p param plaintext pre script section select source style summary table tbody td template textarea tfoot th thead title tr track ul wbr xmp".split(" "), inScopeTags = "applet caption html table td th marquee object template foreignObject desc title".split(" "), buttonScopeTags = inScopeTags.concat([
        "button"
    ]), impliedEndTags = "dd dt li option optgroup p rp rt".split(" "), emptyAncestorInfoDev = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null,
        containerTagInScope: null,
        implicitRootScope: !1
    }, didWarn = {}, shorthandToLonghand = {
        animation: "animationDelay animationDirection animationDuration animationFillMode animationIterationCount animationName animationPlayState animationTimingFunction".split(" "),
        background: "backgroundAttachment backgroundClip backgroundColor backgroundImage backgroundOrigin backgroundPositionX backgroundPositionY backgroundRepeat backgroundSize".split(" "),
        backgroundPosition: [
            "backgroundPositionX",
            "backgroundPositionY"
        ],
        border: "borderBottomColor borderBottomStyle borderBottomWidth borderImageOutset borderImageRepeat borderImageSlice borderImageSource borderImageWidth borderLeftColor borderLeftStyle borderLeftWidth borderRightColor borderRightStyle borderRightWidth borderTopColor borderTopStyle borderTopWidth".split(" "),
        borderBlockEnd: [
            "borderBlockEndColor",
            "borderBlockEndStyle",
            "borderBlockEndWidth"
        ],
        borderBlockStart: [
            "borderBlockStartColor",
            "borderBlockStartStyle",
            "borderBlockStartWidth"
        ],
        borderBottom: [
            "borderBottomColor",
            "borderBottomStyle",
            "borderBottomWidth"
        ],
        borderColor: [
            "borderBottomColor",
            "borderLeftColor",
            "borderRightColor",
            "borderTopColor"
        ],
        borderImage: [
            "borderImageOutset",
            "borderImageRepeat",
            "borderImageSlice",
            "borderImageSource",
            "borderImageWidth"
        ],
        borderInlineEnd: [
            "borderInlineEndColor",
            "borderInlineEndStyle",
            "borderInlineEndWidth"
        ],
        borderInlineStart: [
            "borderInlineStartColor",
            "borderInlineStartStyle",
            "borderInlineStartWidth"
        ],
        borderLeft: [
            "borderLeftColor",
            "borderLeftStyle",
            "borderLeftWidth"
        ],
        borderRadius: [
            "borderBottomLeftRadius",
            "borderBottomRightRadius",
            "borderTopLeftRadius",
            "borderTopRightRadius"
        ],
        borderRight: [
            "borderRightColor",
            "borderRightStyle",
            "borderRightWidth"
        ],
        borderStyle: [
            "borderBottomStyle",
            "borderLeftStyle",
            "borderRightStyle",
            "borderTopStyle"
        ],
        borderTop: [
            "borderTopColor",
            "borderTopStyle",
            "borderTopWidth"
        ],
        borderWidth: [
            "borderBottomWidth",
            "borderLeftWidth",
            "borderRightWidth",
            "borderTopWidth"
        ],
        columnRule: [
            "columnRuleColor",
            "columnRuleStyle",
            "columnRuleWidth"
        ],
        columns: [
            "columnCount",
            "columnWidth"
        ],
        flex: [
            "flexBasis",
            "flexGrow",
            "flexShrink"
        ],
        flexFlow: [
            "flexDirection",
            "flexWrap"
        ],
        font: "fontFamily fontFeatureSettings fontKerning fontLanguageOverride fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontVariantAlternates fontVariantCaps fontVariantEastAsian fontVariantLigatures fontVariantNumeric fontVariantPosition fontWeight lineHeight".split(" "),
        fontVariant: "fontVariantAlternates fontVariantCaps fontVariantEastAsian fontVariantLigatures fontVariantNumeric fontVariantPosition".split(" "),
        gap: [
            "columnGap",
            "rowGap"
        ],
        grid: "gridAutoColumns gridAutoFlow gridAutoRows gridTemplateAreas gridTemplateColumns gridTemplateRows".split(" "),
        gridArea: [
            "gridColumnEnd",
            "gridColumnStart",
            "gridRowEnd",
            "gridRowStart"
        ],
        gridColumn: [
            "gridColumnEnd",
            "gridColumnStart"
        ],
        gridColumnGap: [
            "columnGap"
        ],
        gridGap: [
            "columnGap",
            "rowGap"
        ],
        gridRow: [
            "gridRowEnd",
            "gridRowStart"
        ],
        gridRowGap: [
            "rowGap"
        ],
        gridTemplate: [
            "gridTemplateAreas",
            "gridTemplateColumns",
            "gridTemplateRows"
        ],
        listStyle: [
            "listStyleImage",
            "listStylePosition",
            "listStyleType"
        ],
        margin: [
            "marginBottom",
            "marginLeft",
            "marginRight",
            "marginTop"
        ],
        marker: [
            "markerEnd",
            "markerMid",
            "markerStart"
        ],
        mask: "maskClip maskComposite maskImage maskMode maskOrigin maskPositionX maskPositionY maskRepeat maskSize".split(" "),
        maskPosition: [
            "maskPositionX",
            "maskPositionY"
        ],
        outline: [
            "outlineColor",
            "outlineStyle",
            "outlineWidth"
        ],
        overflow: [
            "overflowX",
            "overflowY"
        ],
        padding: [
            "paddingBottom",
            "paddingLeft",
            "paddingRight",
            "paddingTop"
        ],
        placeContent: [
            "alignContent",
            "justifyContent"
        ],
        placeItems: [
            "alignItems",
            "justifyItems"
        ],
        placeSelf: [
            "alignSelf",
            "justifySelf"
        ],
        textDecoration: [
            "textDecorationColor",
            "textDecorationLine",
            "textDecorationStyle"
        ],
        textEmphasis: [
            "textEmphasisColor",
            "textEmphasisStyle"
        ],
        transition: [
            "transitionDelay",
            "transitionDuration",
            "transitionProperty",
            "transitionTimingFunction"
        ],
        wordWrap: [
            "overflowWrap"
        ]
    }, uppercasePattern = /([A-Z])/g, msPattern$1 = /^ms-/, badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/, msPattern = /^-ms-/, hyphenPattern = /-(.)/g, badStyleValueWithSemicolonPattern = /;\s*$/, warnedStyleNames = {}, warnedStyleValues = {}, warnedForNaNValue = !1, warnedForInfinityValue = !1, unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" ")), MATH_NAMESPACE = "http://www.w3.org/1998/Math/MathML", SVG_NAMESPACE = "http://www.w3.org/2000/svg", aliases = new Map([
        [
            "acceptCharset",
            "accept-charset"
        ],
        [
            "htmlFor",
            "for"
        ],
        [
            "httpEquiv",
            "http-equiv"
        ],
        [
            "crossOrigin",
            "crossorigin"
        ],
        [
            "accentHeight",
            "accent-height"
        ],
        [
            "alignmentBaseline",
            "alignment-baseline"
        ],
        [
            "arabicForm",
            "arabic-form"
        ],
        [
            "baselineShift",
            "baseline-shift"
        ],
        [
            "capHeight",
            "cap-height"
        ],
        [
            "clipPath",
            "clip-path"
        ],
        [
            "clipRule",
            "clip-rule"
        ],
        [
            "colorInterpolation",
            "color-interpolation"
        ],
        [
            "colorInterpolationFilters",
            "color-interpolation-filters"
        ],
        [
            "colorProfile",
            "color-profile"
        ],
        [
            "colorRendering",
            "color-rendering"
        ],
        [
            "dominantBaseline",
            "dominant-baseline"
        ],
        [
            "enableBackground",
            "enable-background"
        ],
        [
            "fillOpacity",
            "fill-opacity"
        ],
        [
            "fillRule",
            "fill-rule"
        ],
        [
            "floodColor",
            "flood-color"
        ],
        [
            "floodOpacity",
            "flood-opacity"
        ],
        [
            "fontFamily",
            "font-family"
        ],
        [
            "fontSize",
            "font-size"
        ],
        [
            "fontSizeAdjust",
            "font-size-adjust"
        ],
        [
            "fontStretch",
            "font-stretch"
        ],
        [
            "fontStyle",
            "font-style"
        ],
        [
            "fontVariant",
            "font-variant"
        ],
        [
            "fontWeight",
            "font-weight"
        ],
        [
            "glyphName",
            "glyph-name"
        ],
        [
            "glyphOrientationHorizontal",
            "glyph-orientation-horizontal"
        ],
        [
            "glyphOrientationVertical",
            "glyph-orientation-vertical"
        ],
        [
            "horizAdvX",
            "horiz-adv-x"
        ],
        [
            "horizOriginX",
            "horiz-origin-x"
        ],
        [
            "imageRendering",
            "image-rendering"
        ],
        [
            "letterSpacing",
            "letter-spacing"
        ],
        [
            "lightingColor",
            "lighting-color"
        ],
        [
            "markerEnd",
            "marker-end"
        ],
        [
            "markerMid",
            "marker-mid"
        ],
        [
            "markerStart",
            "marker-start"
        ],
        [
            "overlinePosition",
            "overline-position"
        ],
        [
            "overlineThickness",
            "overline-thickness"
        ],
        [
            "paintOrder",
            "paint-order"
        ],
        [
            "panose-1",
            "panose-1"
        ],
        [
            "pointerEvents",
            "pointer-events"
        ],
        [
            "renderingIntent",
            "rendering-intent"
        ],
        [
            "shapeRendering",
            "shape-rendering"
        ],
        [
            "stopColor",
            "stop-color"
        ],
        [
            "stopOpacity",
            "stop-opacity"
        ],
        [
            "strikethroughPosition",
            "strikethrough-position"
        ],
        [
            "strikethroughThickness",
            "strikethrough-thickness"
        ],
        [
            "strokeDasharray",
            "stroke-dasharray"
        ],
        [
            "strokeDashoffset",
            "stroke-dashoffset"
        ],
        [
            "strokeLinecap",
            "stroke-linecap"
        ],
        [
            "strokeLinejoin",
            "stroke-linejoin"
        ],
        [
            "strokeMiterlimit",
            "stroke-miterlimit"
        ],
        [
            "strokeOpacity",
            "stroke-opacity"
        ],
        [
            "strokeWidth",
            "stroke-width"
        ],
        [
            "textAnchor",
            "text-anchor"
        ],
        [
            "textDecoration",
            "text-decoration"
        ],
        [
            "textRendering",
            "text-rendering"
        ],
        [
            "transformOrigin",
            "transform-origin"
        ],
        [
            "underlinePosition",
            "underline-position"
        ],
        [
            "underlineThickness",
            "underline-thickness"
        ],
        [
            "unicodeBidi",
            "unicode-bidi"
        ],
        [
            "unicodeRange",
            "unicode-range"
        ],
        [
            "unitsPerEm",
            "units-per-em"
        ],
        [
            "vAlphabetic",
            "v-alphabetic"
        ],
        [
            "vHanging",
            "v-hanging"
        ],
        [
            "vIdeographic",
            "v-ideographic"
        ],
        [
            "vMathematical",
            "v-mathematical"
        ],
        [
            "vectorEffect",
            "vector-effect"
        ],
        [
            "vertAdvY",
            "vert-adv-y"
        ],
        [
            "vertOriginX",
            "vert-origin-x"
        ],
        [
            "vertOriginY",
            "vert-origin-y"
        ],
        [
            "wordSpacing",
            "word-spacing"
        ],
        [
            "writingMode",
            "writing-mode"
        ],
        [
            "xmlnsXlink",
            "xmlns:xlink"
        ],
        [
            "xHeight",
            "x-height"
        ]
    ]), possibleStandardNames = {
        accept: "accept",
        acceptcharset: "acceptCharset",
        "accept-charset": "acceptCharset",
        accesskey: "accessKey",
        action: "action",
        allowfullscreen: "allowFullScreen",
        alt: "alt",
        as: "as",
        async: "async",
        autocapitalize: "autoCapitalize",
        autocomplete: "autoComplete",
        autocorrect: "autoCorrect",
        autofocus: "autoFocus",
        autoplay: "autoPlay",
        autosave: "autoSave",
        capture: "capture",
        cellpadding: "cellPadding",
        cellspacing: "cellSpacing",
        challenge: "challenge",
        charset: "charSet",
        checked: "checked",
        children: "children",
        cite: "cite",
        class: "className",
        classid: "classID",
        classname: "className",
        cols: "cols",
        colspan: "colSpan",
        content: "content",
        contenteditable: "contentEditable",
        contextmenu: "contextMenu",
        controls: "controls",
        controlslist: "controlsList",
        coords: "coords",
        crossorigin: "crossOrigin",
        dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
        data: "data",
        datetime: "dateTime",
        default: "default",
        defaultchecked: "defaultChecked",
        defaultvalue: "defaultValue",
        defer: "defer",
        dir: "dir",
        disabled: "disabled",
        disablepictureinpicture: "disablePictureInPicture",
        disableremoteplayback: "disableRemotePlayback",
        download: "download",
        draggable: "draggable",
        enctype: "encType",
        enterkeyhint: "enterKeyHint",
        fetchpriority: "fetchPriority",
        for: "htmlFor",
        form: "form",
        formmethod: "formMethod",
        formaction: "formAction",
        formenctype: "formEncType",
        formnovalidate: "formNoValidate",
        formtarget: "formTarget",
        frameborder: "frameBorder",
        headers: "headers",
        height: "height",
        hidden: "hidden",
        high: "high",
        href: "href",
        hreflang: "hrefLang",
        htmlfor: "htmlFor",
        httpequiv: "httpEquiv",
        "http-equiv": "httpEquiv",
        icon: "icon",
        id: "id",
        imagesizes: "imageSizes",
        imagesrcset: "imageSrcSet",
        inert: "inert",
        innerhtml: "innerHTML",
        inputmode: "inputMode",
        integrity: "integrity",
        is: "is",
        itemid: "itemID",
        itemprop: "itemProp",
        itemref: "itemRef",
        itemscope: "itemScope",
        itemtype: "itemType",
        keyparams: "keyParams",
        keytype: "keyType",
        kind: "kind",
        label: "label",
        lang: "lang",
        list: "list",
        loop: "loop",
        low: "low",
        manifest: "manifest",
        marginwidth: "marginWidth",
        marginheight: "marginHeight",
        max: "max",
        maxlength: "maxLength",
        media: "media",
        mediagroup: "mediaGroup",
        method: "method",
        min: "min",
        minlength: "minLength",
        multiple: "multiple",
        muted: "muted",
        name: "name",
        nomodule: "noModule",
        nonce: "nonce",
        novalidate: "noValidate",
        open: "open",
        optimum: "optimum",
        pattern: "pattern",
        placeholder: "placeholder",
        playsinline: "playsInline",
        poster: "poster",
        preload: "preload",
        profile: "profile",
        radiogroup: "radioGroup",
        readonly: "readOnly",
        referrerpolicy: "referrerPolicy",
        rel: "rel",
        required: "required",
        reversed: "reversed",
        role: "role",
        rows: "rows",
        rowspan: "rowSpan",
        sandbox: "sandbox",
        scope: "scope",
        scoped: "scoped",
        scrolling: "scrolling",
        seamless: "seamless",
        selected: "selected",
        shape: "shape",
        size: "size",
        sizes: "sizes",
        span: "span",
        spellcheck: "spellCheck",
        src: "src",
        srcdoc: "srcDoc",
        srclang: "srcLang",
        srcset: "srcSet",
        start: "start",
        step: "step",
        style: "style",
        summary: "summary",
        tabindex: "tabIndex",
        target: "target",
        title: "title",
        type: "type",
        usemap: "useMap",
        value: "value",
        width: "width",
        wmode: "wmode",
        wrap: "wrap",
        about: "about",
        accentheight: "accentHeight",
        "accent-height": "accentHeight",
        accumulate: "accumulate",
        additive: "additive",
        alignmentbaseline: "alignmentBaseline",
        "alignment-baseline": "alignmentBaseline",
        allowreorder: "allowReorder",
        alphabetic: "alphabetic",
        amplitude: "amplitude",
        arabicform: "arabicForm",
        "arabic-form": "arabicForm",
        ascent: "ascent",
        attributename: "attributeName",
        attributetype: "attributeType",
        autoreverse: "autoReverse",
        azimuth: "azimuth",
        basefrequency: "baseFrequency",
        baselineshift: "baselineShift",
        "baseline-shift": "baselineShift",
        baseprofile: "baseProfile",
        bbox: "bbox",
        begin: "begin",
        bias: "bias",
        by: "by",
        calcmode: "calcMode",
        capheight: "capHeight",
        "cap-height": "capHeight",
        clip: "clip",
        clippath: "clipPath",
        "clip-path": "clipPath",
        clippathunits: "clipPathUnits",
        cliprule: "clipRule",
        "clip-rule": "clipRule",
        color: "color",
        colorinterpolation: "colorInterpolation",
        "color-interpolation": "colorInterpolation",
        colorinterpolationfilters: "colorInterpolationFilters",
        "color-interpolation-filters": "colorInterpolationFilters",
        colorprofile: "colorProfile",
        "color-profile": "colorProfile",
        colorrendering: "colorRendering",
        "color-rendering": "colorRendering",
        contentscripttype: "contentScriptType",
        contentstyletype: "contentStyleType",
        cursor: "cursor",
        cx: "cx",
        cy: "cy",
        d: "d",
        datatype: "datatype",
        decelerate: "decelerate",
        descent: "descent",
        diffuseconstant: "diffuseConstant",
        direction: "direction",
        display: "display",
        divisor: "divisor",
        dominantbaseline: "dominantBaseline",
        "dominant-baseline": "dominantBaseline",
        dur: "dur",
        dx: "dx",
        dy: "dy",
        edgemode: "edgeMode",
        elevation: "elevation",
        enablebackground: "enableBackground",
        "enable-background": "enableBackground",
        end: "end",
        exponent: "exponent",
        externalresourcesrequired: "externalResourcesRequired",
        fill: "fill",
        fillopacity: "fillOpacity",
        "fill-opacity": "fillOpacity",
        fillrule: "fillRule",
        "fill-rule": "fillRule",
        filter: "filter",
        filterres: "filterRes",
        filterunits: "filterUnits",
        floodopacity: "floodOpacity",
        "flood-opacity": "floodOpacity",
        floodcolor: "floodColor",
        "flood-color": "floodColor",
        focusable: "focusable",
        fontfamily: "fontFamily",
        "font-family": "fontFamily",
        fontsize: "fontSize",
        "font-size": "fontSize",
        fontsizeadjust: "fontSizeAdjust",
        "font-size-adjust": "fontSizeAdjust",
        fontstretch: "fontStretch",
        "font-stretch": "fontStretch",
        fontstyle: "fontStyle",
        "font-style": "fontStyle",
        fontvariant: "fontVariant",
        "font-variant": "fontVariant",
        fontweight: "fontWeight",
        "font-weight": "fontWeight",
        format: "format",
        from: "from",
        fx: "fx",
        fy: "fy",
        g1: "g1",
        g2: "g2",
        glyphname: "glyphName",
        "glyph-name": "glyphName",
        glyphorientationhorizontal: "glyphOrientationHorizontal",
        "glyph-orientation-horizontal": "glyphOrientationHorizontal",
        glyphorientationvertical: "glyphOrientationVertical",
        "glyph-orientation-vertical": "glyphOrientationVertical",
        glyphref: "glyphRef",
        gradienttransform: "gradientTransform",
        gradientunits: "gradientUnits",
        hanging: "hanging",
        horizadvx: "horizAdvX",
        "horiz-adv-x": "horizAdvX",
        horizoriginx: "horizOriginX",
        "horiz-origin-x": "horizOriginX",
        ideographic: "ideographic",
        imagerendering: "imageRendering",
        "image-rendering": "imageRendering",
        in2: "in2",
        in: "in",
        inlist: "inlist",
        intercept: "intercept",
        k1: "k1",
        k2: "k2",
        k3: "k3",
        k4: "k4",
        k: "k",
        kernelmatrix: "kernelMatrix",
        kernelunitlength: "kernelUnitLength",
        kerning: "kerning",
        keypoints: "keyPoints",
        keysplines: "keySplines",
        keytimes: "keyTimes",
        lengthadjust: "lengthAdjust",
        letterspacing: "letterSpacing",
        "letter-spacing": "letterSpacing",
        lightingcolor: "lightingColor",
        "lighting-color": "lightingColor",
        limitingconeangle: "limitingConeAngle",
        local: "local",
        markerend: "markerEnd",
        "marker-end": "markerEnd",
        markerheight: "markerHeight",
        markermid: "markerMid",
        "marker-mid": "markerMid",
        markerstart: "markerStart",
        "marker-start": "markerStart",
        markerunits: "markerUnits",
        markerwidth: "markerWidth",
        mask: "mask",
        maskcontentunits: "maskContentUnits",
        maskunits: "maskUnits",
        mathematical: "mathematical",
        mode: "mode",
        numoctaves: "numOctaves",
        offset: "offset",
        opacity: "opacity",
        operator: "operator",
        order: "order",
        orient: "orient",
        orientation: "orientation",
        origin: "origin",
        overflow: "overflow",
        overlineposition: "overlinePosition",
        "overline-position": "overlinePosition",
        overlinethickness: "overlineThickness",
        "overline-thickness": "overlineThickness",
        paintorder: "paintOrder",
        "paint-order": "paintOrder",
        panose1: "panose1",
        "panose-1": "panose1",
        pathlength: "pathLength",
        patterncontentunits: "patternContentUnits",
        patterntransform: "patternTransform",
        patternunits: "patternUnits",
        pointerevents: "pointerEvents",
        "pointer-events": "pointerEvents",
        points: "points",
        pointsatx: "pointsAtX",
        pointsaty: "pointsAtY",
        pointsatz: "pointsAtZ",
        popover: "popover",
        popovertarget: "popoverTarget",
        popovertargetaction: "popoverTargetAction",
        prefix: "prefix",
        preservealpha: "preserveAlpha",
        preserveaspectratio: "preserveAspectRatio",
        primitiveunits: "primitiveUnits",
        property: "property",
        r: "r",
        radius: "radius",
        refx: "refX",
        refy: "refY",
        renderingintent: "renderingIntent",
        "rendering-intent": "renderingIntent",
        repeatcount: "repeatCount",
        repeatdur: "repeatDur",
        requiredextensions: "requiredExtensions",
        requiredfeatures: "requiredFeatures",
        resource: "resource",
        restart: "restart",
        result: "result",
        results: "results",
        rotate: "rotate",
        rx: "rx",
        ry: "ry",
        scale: "scale",
        security: "security",
        seed: "seed",
        shaperendering: "shapeRendering",
        "shape-rendering": "shapeRendering",
        slope: "slope",
        spacing: "spacing",
        specularconstant: "specularConstant",
        specularexponent: "specularExponent",
        speed: "speed",
        spreadmethod: "spreadMethod",
        startoffset: "startOffset",
        stddeviation: "stdDeviation",
        stemh: "stemh",
        stemv: "stemv",
        stitchtiles: "stitchTiles",
        stopcolor: "stopColor",
        "stop-color": "stopColor",
        stopopacity: "stopOpacity",
        "stop-opacity": "stopOpacity",
        strikethroughposition: "strikethroughPosition",
        "strikethrough-position": "strikethroughPosition",
        strikethroughthickness: "strikethroughThickness",
        "strikethrough-thickness": "strikethroughThickness",
        string: "string",
        stroke: "stroke",
        strokedasharray: "strokeDasharray",
        "stroke-dasharray": "strokeDasharray",
        strokedashoffset: "strokeDashoffset",
        "stroke-dashoffset": "strokeDashoffset",
        strokelinecap: "strokeLinecap",
        "stroke-linecap": "strokeLinecap",
        strokelinejoin: "strokeLinejoin",
        "stroke-linejoin": "strokeLinejoin",
        strokemiterlimit: "strokeMiterlimit",
        "stroke-miterlimit": "strokeMiterlimit",
        strokewidth: "strokeWidth",
        "stroke-width": "strokeWidth",
        strokeopacity: "strokeOpacity",
        "stroke-opacity": "strokeOpacity",
        suppresscontenteditablewarning: "suppressContentEditableWarning",
        suppresshydrationwarning: "suppressHydrationWarning",
        surfacescale: "surfaceScale",
        systemlanguage: "systemLanguage",
        tablevalues: "tableValues",
        targetx: "targetX",
        targety: "targetY",
        textanchor: "textAnchor",
        "text-anchor": "textAnchor",
        textdecoration: "textDecoration",
        "text-decoration": "textDecoration",
        textlength: "textLength",
        textrendering: "textRendering",
        "text-rendering": "textRendering",
        to: "to",
        transform: "transform",
        transformorigin: "transformOrigin",
        "transform-origin": "transformOrigin",
        typeof: "typeof",
        u1: "u1",
        u2: "u2",
        underlineposition: "underlinePosition",
        "underline-position": "underlinePosition",
        underlinethickness: "underlineThickness",
        "underline-thickness": "underlineThickness",
        unicode: "unicode",
        unicodebidi: "unicodeBidi",
        "unicode-bidi": "unicodeBidi",
        unicoderange: "unicodeRange",
        "unicode-range": "unicodeRange",
        unitsperem: "unitsPerEm",
        "units-per-em": "unitsPerEm",
        unselectable: "unselectable",
        valphabetic: "vAlphabetic",
        "v-alphabetic": "vAlphabetic",
        values: "values",
        vectoreffect: "vectorEffect",
        "vector-effect": "vectorEffect",
        version: "version",
        vertadvy: "vertAdvY",
        "vert-adv-y": "vertAdvY",
        vertoriginx: "vertOriginX",
        "vert-origin-x": "vertOriginX",
        vertoriginy: "vertOriginY",
        "vert-origin-y": "vertOriginY",
        vhanging: "vHanging",
        "v-hanging": "vHanging",
        videographic: "vIdeographic",
        "v-ideographic": "vIdeographic",
        viewbox: "viewBox",
        viewtarget: "viewTarget",
        visibility: "visibility",
        vmathematical: "vMathematical",
        "v-mathematical": "vMathematical",
        vocab: "vocab",
        widths: "widths",
        wordspacing: "wordSpacing",
        "word-spacing": "wordSpacing",
        writingmode: "writingMode",
        "writing-mode": "writingMode",
        x1: "x1",
        x2: "x2",
        x: "x",
        xchannelselector: "xChannelSelector",
        xheight: "xHeight",
        "x-height": "xHeight",
        xlinkactuate: "xlinkActuate",
        "xlink:actuate": "xlinkActuate",
        xlinkarcrole: "xlinkArcrole",
        "xlink:arcrole": "xlinkArcrole",
        xlinkhref: "xlinkHref",
        "xlink:href": "xlinkHref",
        xlinkrole: "xlinkRole",
        "xlink:role": "xlinkRole",
        xlinkshow: "xlinkShow",
        "xlink:show": "xlinkShow",
        xlinktitle: "xlinkTitle",
        "xlink:title": "xlinkTitle",
        xlinktype: "xlinkType",
        "xlink:type": "xlinkType",
        xmlbase: "xmlBase",
        "xml:base": "xmlBase",
        xmllang: "xmlLang",
        "xml:lang": "xmlLang",
        xmlns: "xmlns",
        "xml:space": "xmlSpace",
        xmlnsxlink: "xmlnsXlink",
        "xmlns:xlink": "xmlnsXlink",
        xmlspace: "xmlSpace",
        y1: "y1",
        y2: "y2",
        y: "y",
        ychannelselector: "yChannelSelector",
        z: "z",
        zoomandpan: "zoomAndPan"
    }, ariaProperties = {
        "aria-current": 0,
        "aria-description": 0,
        "aria-details": 0,
        "aria-disabled": 0,
        "aria-hidden": 0,
        "aria-invalid": 0,
        "aria-keyshortcuts": 0,
        "aria-label": 0,
        "aria-roledescription": 0,
        "aria-autocomplete": 0,
        "aria-checked": 0,
        "aria-expanded": 0,
        "aria-haspopup": 0,
        "aria-level": 0,
        "aria-modal": 0,
        "aria-multiline": 0,
        "aria-multiselectable": 0,
        "aria-orientation": 0,
        "aria-placeholder": 0,
        "aria-pressed": 0,
        "aria-readonly": 0,
        "aria-required": 0,
        "aria-selected": 0,
        "aria-sort": 0,
        "aria-valuemax": 0,
        "aria-valuemin": 0,
        "aria-valuenow": 0,
        "aria-valuetext": 0,
        "aria-atomic": 0,
        "aria-busy": 0,
        "aria-live": 0,
        "aria-relevant": 0,
        "aria-dropeffect": 0,
        "aria-grabbed": 0,
        "aria-activedescendant": 0,
        "aria-colcount": 0,
        "aria-colindex": 0,
        "aria-colspan": 0,
        "aria-controls": 0,
        "aria-describedby": 0,
        "aria-errormessage": 0,
        "aria-flowto": 0,
        "aria-labelledby": 0,
        "aria-owns": 0,
        "aria-posinset": 0,
        "aria-rowcount": 0,
        "aria-rowindex": 0,
        "aria-rowspan": 0,
        "aria-setsize": 0,
        "aria-braillelabel": 0,
        "aria-brailleroledescription": 0,
        "aria-colindextext": 0,
        "aria-rowindextext": 0
    }, warnedProperties$1 = {}, rARIA$1 = RegExp("^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), rARIACamel$1 = RegExp("^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), didWarnValueNull = !1, warnedProperties = {}, EVENT_NAME_REGEX = /^on./, INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/, rARIA = RegExp("^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), rARIACamel = RegExp("^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i, currentReplayingEvent = null, restoreTarget = null, restoreQueue = null, isInsideEventHandler = !1, canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), passiveBrowserEventsSupported = !1;
    if (canUseDOM) try {
        var options$jscomp$0 = {};
        Object.defineProperty(options$jscomp$0, "passive", {
            get: function() {
                passiveBrowserEventsSupported = !0;
            }
        });
        window.addEventListener("test", options$jscomp$0, options$jscomp$0);
        window.removeEventListener("test", options$jscomp$0, options$jscomp$0);
    } catch (e) {
        passiveBrowserEventsSupported = !1;
    }
    var root = null, startText = null, fallbackText = null, EventInterface = {
        eventPhase: 0,
        bubbles: 0,
        cancelable: 0,
        timeStamp: function(event) {
            return event.timeStamp || Date.now();
        },
        defaultPrevented: 0,
        isTrusted: 0
    }, SyntheticEvent = createSyntheticEvent(EventInterface), UIEventInterface = assign({}, EventInterface, {
        view: 0,
        detail: 0
    }), SyntheticUIEvent = createSyntheticEvent(UIEventInterface), lastMovementX, lastMovementY, lastMouseEvent, MouseEventInterface = assign({}, UIEventInterface, {
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        getModifierState: getEventModifierState,
        button: 0,
        buttons: 0,
        relatedTarget: function(event) {
            return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
        },
        movementX: function(event) {
            if ("movementX" in event) return event.movementX;
            event !== lastMouseEvent && (lastMouseEvent && "mousemove" === event.type ? (lastMovementX = event.screenX - lastMouseEvent.screenX, lastMovementY = event.screenY - lastMouseEvent.screenY) : lastMovementY = lastMovementX = 0, lastMouseEvent = event);
            return lastMovementX;
        },
        movementY: function(event) {
            return "movementY" in event ? event.movementY : lastMovementY;
        }
    }), SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface), DragEventInterface = assign({}, MouseEventInterface, {
        dataTransfer: 0
    }), SyntheticDragEvent = createSyntheticEvent(DragEventInterface), FocusEventInterface = assign({}, UIEventInterface, {
        relatedTarget: 0
    }), SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface), AnimationEventInterface = assign({}, EventInterface, {
        animationName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    }), SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface), ClipboardEventInterface = assign({}, EventInterface, {
        clipboardData: function(event) {
            return "clipboardData" in event ? event.clipboardData : window.clipboardData;
        }
    }), SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface), CompositionEventInterface = assign({}, EventInterface, {
        data: 0
    }), SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface), SyntheticInputEvent = SyntheticCompositionEvent, normalizeKey = {
        Esc: "Escape",
        Spacebar: " ",
        Left: "ArrowLeft",
        Up: "ArrowUp",
        Right: "ArrowRight",
        Down: "ArrowDown",
        Del: "Delete",
        Win: "OS",
        Menu: "ContextMenu",
        Apps: "ContextMenu",
        Scroll: "ScrollLock",
        MozPrintableKey: "Unidentified"
    }, translateToKey = {
        8: "Backspace",
        9: "Tab",
        12: "Clear",
        13: "Enter",
        16: "Shift",
        17: "Control",
        18: "Alt",
        19: "Pause",
        20: "CapsLock",
        27: "Escape",
        32: " ",
        33: "PageUp",
        34: "PageDown",
        35: "End",
        36: "Home",
        37: "ArrowLeft",
        38: "ArrowUp",
        39: "ArrowRight",
        40: "ArrowDown",
        45: "Insert",
        46: "Delete",
        112: "F1",
        113: "F2",
        114: "F3",
        115: "F4",
        116: "F5",
        117: "F6",
        118: "F7",
        119: "F8",
        120: "F9",
        121: "F10",
        122: "F11",
        123: "F12",
        144: "NumLock",
        145: "ScrollLock",
        224: "Meta"
    }, modifierKeyToProp = {
        Alt: "altKey",
        Control: "ctrlKey",
        Meta: "metaKey",
        Shift: "shiftKey"
    }, KeyboardEventInterface = assign({}, UIEventInterface, {
        key: function(nativeEvent) {
            if (nativeEvent.key) {
                var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
                if ("Unidentified" !== key) return key;
            }
            return "keypress" === nativeEvent.type ? (nativeEvent = getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
        },
        code: 0,
        location: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        repeat: 0,
        locale: 0,
        getModifierState: getEventModifierState,
        charCode: function(event) {
            return "keypress" === event.type ? getEventCharCode(event) : 0;
        },
        keyCode: function(event) {
            return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
        },
        which: function(event) {
            return "keypress" === event.type ? getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
        }
    }), SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface), PointerEventInterface = assign({}, MouseEventInterface, {
        pointerId: 0,
        width: 0,
        height: 0,
        pressure: 0,
        tangentialPressure: 0,
        tiltX: 0,
        tiltY: 0,
        twist: 0,
        pointerType: 0,
        isPrimary: 0
    }), SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface), TouchEventInterface = assign({}, UIEventInterface, {
        touches: 0,
        targetTouches: 0,
        changedTouches: 0,
        altKey: 0,
        metaKey: 0,
        ctrlKey: 0,
        shiftKey: 0,
        getModifierState: getEventModifierState
    }), SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface), TransitionEventInterface = assign({}, EventInterface, {
        propertyName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    }), SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface), WheelEventInterface = assign({}, MouseEventInterface, {
        deltaX: function(event) {
            return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
        },
        deltaY: function(event) {
            return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
        },
        deltaZ: 0,
        deltaMode: 0
    }), SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface), ToggleEventInterface = assign({}, EventInterface, {
        newState: 0,
        oldState: 0
    }), SyntheticToggleEvent = createSyntheticEvent(ToggleEventInterface), END_KEYCODES = [
        9,
        13,
        27,
        32
    ], START_KEYCODE = 229, canUseCompositionEvent = canUseDOM && "CompositionEvent" in window, documentMode = null;
    canUseDOM && "documentMode" in document && (documentMode = document.documentMode);
    var canUseTextInputEvent = canUseDOM && "TextEvent" in window && !documentMode, useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && 8 < documentMode && 11 >= documentMode), SPACEBAR_CODE = 32, SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE), hasSpaceKeypress = !1, isComposing = !1, supportedInputTypes = {
        color: !0,
        date: !0,
        datetime: !0,
        "datetime-local": !0,
        email: !0,
        month: !0,
        number: !0,
        password: !0,
        range: !0,
        search: !0,
        tel: !0,
        text: !0,
        time: !0,
        url: !0,
        week: !0
    }, activeElement$1 = null, activeElementInst$1 = null, isInputEventSupported = !1;
    canUseDOM && (isInputEventSupported = isEventSupported("input") && (!document.documentMode || 9 < document.documentMode));
    var objectIs = "function" === typeof Object.is ? Object.is : is, skipSelectionChangeEvent = canUseDOM && "documentMode" in document && 11 >= document.documentMode, activeElement = null, activeElementInst = null, lastSelection = null, mouseDown = !1, vendorPrefixes = {
        animationend: makePrefixMap("Animation", "AnimationEnd"),
        animationiteration: makePrefixMap("Animation", "AnimationIteration"),
        animationstart: makePrefixMap("Animation", "AnimationStart"),
        transitionrun: makePrefixMap("Transition", "TransitionRun"),
        transitionstart: makePrefixMap("Transition", "TransitionStart"),
        transitioncancel: makePrefixMap("Transition", "TransitionCancel"),
        transitionend: makePrefixMap("Transition", "TransitionEnd")
    }, prefixedEventNames = {}, style = {};
    canUseDOM && (style = document.createElement("div").style, "AnimationEvent" in window || (delete vendorPrefixes.animationend.animation, delete vendorPrefixes.animationiteration.animation, delete vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete vendorPrefixes.transitionend.transition);
    var ANIMATION_END = getVendorPrefixedEventName("animationend"), ANIMATION_ITERATION = getVendorPrefixedEventName("animationiteration"), ANIMATION_START = getVendorPrefixedEventName("animationstart"), TRANSITION_RUN = getVendorPrefixedEventName("transitionrun"), TRANSITION_START = getVendorPrefixedEventName("transitionstart"), TRANSITION_CANCEL = getVendorPrefixedEventName("transitioncancel"), TRANSITION_END = getVendorPrefixedEventName("transitionend"), topLevelEventsToReactNames = new Map(), simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
    simpleEventPluginEvents.push("scrollEnd");
    var lastResetTime = 0;
    if ("object" === typeof performance && "function" === typeof performance.now) {
        var localPerformance = performance;
        var getCurrentTime = function() {
            return localPerformance.now();
        };
    } else {
        var localDate = Date;
        getCurrentTime = function() {
            return localDate.now();
        };
    }
    var reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
        if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
            var event = new window.ErrorEvent("error", {
                bubbles: !0,
                cancelable: !0,
                message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
                error: error
            });
            if (!window.dispatchEvent(event)) return;
        }
        console.error(error);
    }, OMITTED_PROP_ERROR = "This object has been omitted by React in the console log to avoid sending too much data from the server. Try logging smaller or more specific objects.", EMPTY_ARRAY = 0, COMPLEX_ARRAY = 1, PRIMITIVE_ARRAY = 2, ENTRIES_ARRAY = 3, REMOVED = "\u2013\u00a0", ADDED = "+\u00a0", UNCHANGED = "\u2007\u00a0", supportsUserTiming = "undefined" !== typeof console && "function" === typeof console.timeStamp && "undefined" !== typeof performance && "function" === typeof performance.measure, COMPONENTS_TRACK = "Components \u269b", LANES_TRACK_GROUP = "Scheduler \u269b", currentTrack = "Blocking", alreadyWarnedForDeepEquality = !1, reusableComponentDevToolDetails = {
        color: "primary",
        properties: null,
        tooltipText: "",
        track: COMPONENTS_TRACK
    }, reusableComponentOptions = {
        start: -0,
        end: -0,
        detail: {
            devtools: reusableComponentDevToolDetails
        }
    }, resuableChangedPropsEntry = [
        "Changed Props",
        ""
    ], DEEP_EQUALITY_WARNING = "This component received deeply equal props. It might benefit from useMemo or the React Compiler in its owner.", reusableDeeplyEqualPropsEntry = [
        "Changed Props",
        DEEP_EQUALITY_WARNING
    ], OffscreenVisible = 1, OffscreenPassiveEffectsConnected = 2, concurrentQueues = [], concurrentQueuesIndex = 0, concurrentlyUpdatedLanes = 0, emptyContextObject = {};
    Object.freeze(emptyContextObject);
    var resolveFamily = null, failedBoundaries = null, NoMode = 0, ConcurrentMode = 1, ProfileMode = 2, StrictLegacyMode = 8, StrictEffectsMode = 16, SuspenseyImagesMode = 32;
    var hasBadMapPolyfill = !1;
    try {
        var nonExtensibleObject = Object.preventExtensions({});
        new Map([
            [
                nonExtensibleObject,
                null
            ]
        ]);
        new Set([
            nonExtensibleObject
        ]);
    } catch (e$3) {
        hasBadMapPolyfill = !0;
    }
    var CapturedStacks = new WeakMap(), forkStack = [], forkStackIndex = 0, treeForkProvider = null, treeForkCount = 0, idStack = [], idStackIndex = 0, treeContextProvider = null, treeContextId = 1, treeContextOverflow = "", hydrationParentFiber = null, nextHydratableInstance = null, isHydrating = !1, didSuspendOrErrorDEV = !1, hydrationDiffRootDEV = null, hydrationErrors = null, rootOrSingletonContext = !1, HydrationMismatchException = Error("Hydration Mismatch Exception: This is not a real error, and should not leak into userspace. If you're seeing this, it's likely a bug in React."), valueCursor = createCursor(null);
    var rendererCursorDEV = createCursor(null);
    var rendererSigil = {};
    var currentlyRenderingFiber$1 = null, lastContextDependency = null, isDisallowedContextReadInDEV = !1, AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
        var listeners = [], signal = this.signal = {
            aborted: !1,
            addEventListener: function(type, listener) {
                listeners.push(listener);
            }
        };
        this.abort = function() {
            signal.aborted = !0;
            listeners.forEach(function(listener) {
                return listener();
            });
        };
    }, scheduleCallback$2 = Scheduler.unstable_scheduleCallback, NormalPriority = Scheduler.unstable_NormalPriority, CacheContext = {
        $$typeof: REACT_CONTEXT_TYPE,
        Consumer: null,
        Provider: null,
        _currentValue: null,
        _currentValue2: null,
        _threadCount: 0,
        _currentRenderer: null,
        _currentRenderer2: null
    }, now = Scheduler.unstable_now, createTask = console.createTask ? console.createTask : function() {
        return null;
    }, SPAWNED_UPDATE = 1, PINGED_UPDATE = 2, renderStartTime = -0, commitStartTime = -0, commitEndTime = -0, commitErrors = null, profilerStartTime = -1.1, profilerEffectDuration = -0, componentEffectDuration = -0, componentEffectStartTime = -1.1, componentEffectEndTime = -1.1, componentEffectErrors = null, componentEffectSpawnedUpdate = !1, blockingClampTime = -0, blockingUpdateTime = -1.1, blockingUpdateTask = null, blockingUpdateType = 0, blockingUpdateMethodName = null, blockingUpdateComponentName = null, blockingEventTime = -1.1, blockingEventType = null, blockingEventRepeatTime = -1.1, blockingSuspendedTime = -1.1, transitionClampTime = -0, transitionStartTime = -1.1, transitionUpdateTime = -1.1, transitionUpdateType = 0, transitionUpdateTask = null, transitionUpdateMethodName = null, transitionUpdateComponentName = null, transitionEventTime = -1.1, transitionEventType = null, transitionEventRepeatTime = -1.1, transitionSuspendedTime = -1.1, retryClampTime = -0, idleClampTime = -0, animatingLanes = 0, animatingTask = null, yieldReason = 0, yieldStartTime = -1.1, currentUpdateIsNested = !1, nestedUpdateScheduled = !1, currentEntangledListeners = null, currentEntangledPendingCount = 0, currentEntangledLane = 0, currentEntangledActionThenable = null, prevOnStartTransitionFinish = ReactSharedInternals.S;
    ReactSharedInternals.S = function(transition, returnValue) {
        globalMostRecentTransitionTime = now$1();
        if ("object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then) {
            if (0 > transitionStartTime && 0 > transitionUpdateTime) {
                transitionStartTime = now();
                var newEventTime = resolveEventTimeStamp(), newEventType = resolveEventType();
                if (newEventTime !== transitionEventRepeatTime || newEventType !== transitionEventType) transitionEventRepeatTime = -1.1;
                transitionEventTime = newEventTime;
                transitionEventType = newEventType;
            }
            entangleAsyncAction(transition, returnValue);
        }
        null !== prevOnStartTransitionFinish && prevOnStartTransitionFinish(transition, returnValue);
    };
    var resumedCache = createCursor(null), ReactStrictModeWarnings = {
        recordUnsafeLifecycleWarnings: function() {},
        flushPendingUnsafeLifecycleWarnings: function() {},
        recordLegacyContextWarning: function() {},
        flushLegacyContextWarning: function() {},
        discardPendingWarnings: function() {}
    }, pendingComponentWillMountWarnings = [], pendingUNSAFE_ComponentWillMountWarnings = [], pendingComponentWillReceivePropsWarnings = [], pendingUNSAFE_ComponentWillReceivePropsWarnings = [], pendingComponentWillUpdateWarnings = [], pendingUNSAFE_ComponentWillUpdateWarnings = [], didWarnAboutUnsafeLifecycles = new Set();
    ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function(fiber, instance) {
        didWarnAboutUnsafeLifecycles.has(fiber.type) || ("function" === typeof instance.componentWillMount && !0 !== instance.componentWillMount.__suppressDeprecationWarning && pendingComponentWillMountWarnings.push(fiber), fiber.mode & StrictLegacyMode && "function" === typeof instance.UNSAFE_componentWillMount && pendingUNSAFE_ComponentWillMountWarnings.push(fiber), "function" === typeof instance.componentWillReceiveProps && !0 !== instance.componentWillReceiveProps.__suppressDeprecationWarning && pendingComponentWillReceivePropsWarnings.push(fiber), fiber.mode & StrictLegacyMode && "function" === typeof instance.UNSAFE_componentWillReceiveProps && pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber), "function" === typeof instance.componentWillUpdate && !0 !== instance.componentWillUpdate.__suppressDeprecationWarning && pendingComponentWillUpdateWarnings.push(fiber), fiber.mode & StrictLegacyMode && "function" === typeof instance.UNSAFE_componentWillUpdate && pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber));
    };
    ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function() {
        var componentWillMountUniqueNames = new Set();
        0 < pendingComponentWillMountWarnings.length && (pendingComponentWillMountWarnings.forEach(function(fiber) {
            componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
            didWarnAboutUnsafeLifecycles.add(fiber.type);
        }), pendingComponentWillMountWarnings = []);
        var UNSAFE_componentWillMountUniqueNames = new Set();
        0 < pendingUNSAFE_ComponentWillMountWarnings.length && (pendingUNSAFE_ComponentWillMountWarnings.forEach(function(fiber) {
            UNSAFE_componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
            didWarnAboutUnsafeLifecycles.add(fiber.type);
        }), pendingUNSAFE_ComponentWillMountWarnings = []);
        var componentWillReceivePropsUniqueNames = new Set();
        0 < pendingComponentWillReceivePropsWarnings.length && (pendingComponentWillReceivePropsWarnings.forEach(function(fiber) {
            componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
            didWarnAboutUnsafeLifecycles.add(fiber.type);
        }), pendingComponentWillReceivePropsWarnings = []);
        var UNSAFE_componentWillReceivePropsUniqueNames = new Set();
        0 < pendingUNSAFE_ComponentWillReceivePropsWarnings.length && (pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(function(fiber) {
            UNSAFE_componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
            didWarnAboutUnsafeLifecycles.add(fiber.type);
        }), pendingUNSAFE_ComponentWillReceivePropsWarnings = []);
        var componentWillUpdateUniqueNames = new Set();
        0 < pendingComponentWillUpdateWarnings.length && (pendingComponentWillUpdateWarnings.forEach(function(fiber) {
            componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
            didWarnAboutUnsafeLifecycles.add(fiber.type);
        }), pendingComponentWillUpdateWarnings = []);
        var UNSAFE_componentWillUpdateUniqueNames = new Set();
        0 < pendingUNSAFE_ComponentWillUpdateWarnings.length && (pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function(fiber) {
            UNSAFE_componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
            didWarnAboutUnsafeLifecycles.add(fiber.type);
        }), pendingUNSAFE_ComponentWillUpdateWarnings = []);
        if (0 < UNSAFE_componentWillMountUniqueNames.size) {
            var sortedNames = setToSortedString(UNSAFE_componentWillMountUniqueNames);
            console.error("Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n\nPlease update the following components: %s", sortedNames);
        }
        0 < UNSAFE_componentWillReceivePropsUniqueNames.size && (sortedNames = setToSortedString(UNSAFE_componentWillReceivePropsUniqueNames), console.error("Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://react.dev/link/derived-state\n\nPlease update the following components: %s", sortedNames));
        0 < UNSAFE_componentWillUpdateUniqueNames.size && (sortedNames = setToSortedString(UNSAFE_componentWillUpdateUniqueNames), console.error("Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n\nPlease update the following components: %s", sortedNames));
        0 < componentWillMountUniqueNames.size && (sortedNames = setToSortedString(componentWillMountUniqueNames), console.warn("componentWillMount has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", sortedNames));
        0 < componentWillReceivePropsUniqueNames.size && (sortedNames = setToSortedString(componentWillReceivePropsUniqueNames), console.warn("componentWillReceiveProps has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://react.dev/link/derived-state\n* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", sortedNames));
        0 < componentWillUpdateUniqueNames.size && (sortedNames = setToSortedString(componentWillUpdateUniqueNames), console.warn("componentWillUpdate has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", sortedNames));
    };
    var pendingLegacyContextWarning = new Map(), didWarnAboutLegacyContext = new Set();
    ReactStrictModeWarnings.recordLegacyContextWarning = function(fiber, instance) {
        var strictRoot = null;
        for(var node = fiber; null !== node;)node.mode & StrictLegacyMode && (strictRoot = node), node = node.return;
        null === strictRoot ? console.error("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.") : !didWarnAboutLegacyContext.has(fiber.type) && (node = pendingLegacyContextWarning.get(strictRoot), null != fiber.type.contextTypes || null != fiber.type.childContextTypes || null !== instance && "function" === typeof instance.getChildContext) && (void 0 === node && (node = [], pendingLegacyContextWarning.set(strictRoot, node)), node.push(fiber));
    };
    ReactStrictModeWarnings.flushLegacyContextWarning = function() {
        pendingLegacyContextWarning.forEach(function(fiberArray) {
            if (0 !== fiberArray.length) {
                var firstFiber = fiberArray[0], uniqueNames = new Set();
                fiberArray.forEach(function(fiber) {
                    uniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                    didWarnAboutLegacyContext.add(fiber.type);
                });
                var sortedNames = setToSortedString(uniqueNames);
                runWithFiberInDEV(firstFiber, function() {
                    console.error("Legacy context API has been detected within a strict-mode tree.\n\nThe old API will be supported in all 16.x releases, but applications using it should migrate to the new version.\n\nPlease update the following components: %s\n\nLearn more about this warning here: https://react.dev/link/legacy-context", sortedNames);
                });
            }
        });
    };
    ReactStrictModeWarnings.discardPendingWarnings = function() {
        pendingComponentWillMountWarnings = [];
        pendingUNSAFE_ComponentWillMountWarnings = [];
        pendingComponentWillReceivePropsWarnings = [];
        pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        pendingComponentWillUpdateWarnings = [];
        pendingUNSAFE_ComponentWillUpdateWarnings = [];
        pendingLegacyContextWarning = new Map();
    };
    var callComponent = {
        react_stack_bottom_frame: function(Component, props, secondArg) {
            var wasRendering = isRendering;
            isRendering = !0;
            try {
                return Component(props, secondArg);
            } finally{
                isRendering = wasRendering;
            }
        }
    }, callComponentInDEV = callComponent.react_stack_bottom_frame.bind(callComponent), callRender = {
        react_stack_bottom_frame: function(instance) {
            var wasRendering = isRendering;
            isRendering = !0;
            try {
                return instance.render();
            } finally{
                isRendering = wasRendering;
            }
        }
    }, callRenderInDEV = callRender.react_stack_bottom_frame.bind(callRender), callComponentDidMount = {
        react_stack_bottom_frame: function(finishedWork, instance) {
            try {
                instance.componentDidMount();
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
        }
    }, callComponentDidMountInDEV = callComponentDidMount.react_stack_bottom_frame.bind(callComponentDidMount), callComponentDidUpdate = {
        react_stack_bottom_frame: function(finishedWork, instance, prevProps, prevState, snapshot) {
            try {
                instance.componentDidUpdate(prevProps, prevState, snapshot);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
        }
    }, callComponentDidUpdateInDEV = callComponentDidUpdate.react_stack_bottom_frame.bind(callComponentDidUpdate), callComponentDidCatch = {
        react_stack_bottom_frame: function(instance, errorInfo) {
            var stack = errorInfo.stack;
            instance.componentDidCatch(errorInfo.value, {
                componentStack: null !== stack ? stack : ""
            });
        }
    }, callComponentDidCatchInDEV = callComponentDidCatch.react_stack_bottom_frame.bind(callComponentDidCatch), callComponentWillUnmount = {
        react_stack_bottom_frame: function(current, nearestMountedAncestor, instance) {
            try {
                instance.componentWillUnmount();
            } catch (error) {
                captureCommitPhaseError(current, nearestMountedAncestor, error);
            }
        }
    }, callComponentWillUnmountInDEV = callComponentWillUnmount.react_stack_bottom_frame.bind(callComponentWillUnmount), callCreate = {
        react_stack_bottom_frame: function(effect) {
            var create = effect.create;
            effect = effect.inst;
            create = create();
            return effect.destroy = create;
        }
    }, callCreateInDEV = callCreate.react_stack_bottom_frame.bind(callCreate), callDestroy = {
        react_stack_bottom_frame: function(current, nearestMountedAncestor, destroy) {
            try {
                destroy();
            } catch (error) {
                captureCommitPhaseError(current, nearestMountedAncestor, error);
            }
        }
    }, callDestroyInDEV = callDestroy.react_stack_bottom_frame.bind(callDestroy), callLazyInit = {
        react_stack_bottom_frame: function(lazy) {
            var init = lazy._init;
            return init(lazy._payload);
        }
    }, callLazyInitInDEV = callLazyInit.react_stack_bottom_frame.bind(callLazyInit), SuspenseException = Error("Suspense Exception: This is not a real error! It's an implementation detail of `use` to interrupt the current render. You must either rethrow it immediately, or move the `use` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary, or call the promise's `.catch` method and pass the result to `use`."), SuspenseyCommitException = Error("Suspense Exception: This is not a real error, and should not leak into userspace. If you're seeing this, it's likely a bug in React."), SuspenseActionException = Error("Suspense Exception: This is not a real error! It's an implementation detail of `useActionState` to interrupt the current render. You must either rethrow it immediately, or move the `useActionState` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary."), noopSuspenseyCommitThenable = {
        then: function() {
            console.error('Internal React error: A listener was unexpectedly attached to a "noop" thenable. This is a bug in React. Please file an issue.');
        }
    }, suspendedThenable = null, needsToResetSuspendedThenableDEV = !1, thenableState$1 = null, thenableIndexCounter$1 = 0, currentDebugInfo = null, didWarnAboutMaps;
    var didWarnAboutGenerators = didWarnAboutMaps = !1;
    var ownerHasKeyUseWarning = {};
    var ownerHasFunctionTypeWarning = {};
    var ownerHasSymbolTypeWarning = {};
    warnForMissingKey = function(returnFiber, workInProgress, child) {
        if (null !== child && "object" === typeof child && child._store && (!child._store.validated && null == child.key || 2 === child._store.validated)) {
            if ("object" !== typeof child._store) throw Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
            child._store.validated = 1;
            var componentName = getComponentNameFromFiber(returnFiber), componentKey = componentName || "null";
            if (!ownerHasKeyUseWarning[componentKey]) {
                ownerHasKeyUseWarning[componentKey] = !0;
                child = child._owner;
                returnFiber = returnFiber._debugOwner;
                var currentComponentErrorInfo = "";
                returnFiber && "number" === typeof returnFiber.tag && (componentKey = getComponentNameFromFiber(returnFiber)) && (currentComponentErrorInfo = "\n\nCheck the render method of `" + componentKey + "`.");
                currentComponentErrorInfo || componentName && (currentComponentErrorInfo = "\n\nCheck the top-level render call using <" + componentName + ">.");
                var childOwnerAppendix = "";
                null != child && returnFiber !== child && (componentName = null, "number" === typeof child.tag ? componentName = getComponentNameFromFiber(child) : "string" === typeof child.name && (componentName = child.name), componentName && (childOwnerAppendix = " It was passed a child from " + componentName + "."));
                runWithFiberInDEV(workInProgress, function() {
                    console.error('Each child in a list should have a unique "key" prop.%s%s See https://react.dev/link/warning-keys for more information.', currentComponentErrorInfo, childOwnerAppendix);
                });
            }
        }
    };
    var reconcileChildFibers = createChildReconciler(!0), mountChildFibers = createChildReconciler(!1), UpdateState = 0, ReplaceState = 1, ForceUpdate = 2, CaptureUpdate = 3, hasForceUpdate = !1;
    var didWarnUpdateInsideUpdate = !1;
    var currentlyProcessingQueue = null;
    var didReadFromEntangledAsyncAction = !1, currentTreeHiddenStackCursor = createCursor(null), prevEntangledRenderLanesCursor = createCursor(0), suspenseHandlerStackCursor = createCursor(null), shellBoundary = null, SubtreeSuspenseContextMask = 1, ForceSuspenseFallback = 2, suspenseStackCursor = createCursor(0), NoFlags = 0, HasEffect = 1, Insertion = 2, Layout = 4, Passive = 8, didWarnUncachedGetSnapshot;
    var didWarnAboutMismatchedHooksForComponent = new Set();
    var didWarnAboutUseWrappedInTryCatch = new Set();
    var didWarnAboutAsyncClientComponent = new Set();
    var didWarnAboutUseFormState = new Set();
    var renderLanes = 0, currentlyRenderingFiber = null, currentHook = null, workInProgressHook = null, didScheduleRenderPhaseUpdate = !1, didScheduleRenderPhaseUpdateDuringThisPass = !1, shouldDoubleInvokeUserFnsInHooksDEV = !1, localIdCounter = 0, thenableIndexCounter = 0, thenableState = null, globalClientIdCounter = 0, RE_RENDER_LIMIT = 25, currentHookNameInDev = null, hookTypesDev = null, hookTypesUpdateIndexDev = -1, ignorePreviousDependencies = !1, ContextOnlyDispatcher = {
        readContext: readContext,
        use: use,
        useCallback: throwInvalidHookError,
        useContext: throwInvalidHookError,
        useEffect: throwInvalidHookError,
        useImperativeHandle: throwInvalidHookError,
        useLayoutEffect: throwInvalidHookError,
        useInsertionEffect: throwInvalidHookError,
        useMemo: throwInvalidHookError,
        useReducer: throwInvalidHookError,
        useRef: throwInvalidHookError,
        useState: throwInvalidHookError,
        useDebugValue: throwInvalidHookError,
        useDeferredValue: throwInvalidHookError,
        useTransition: throwInvalidHookError,
        useSyncExternalStore: throwInvalidHookError,
        useId: throwInvalidHookError,
        useHostTransitionStatus: throwInvalidHookError,
        useFormState: throwInvalidHookError,
        useActionState: throwInvalidHookError,
        useOptimistic: throwInvalidHookError,
        useMemoCache: throwInvalidHookError,
        useCacheRefresh: throwInvalidHookError
    };
    ContextOnlyDispatcher.useEffectEvent = throwInvalidHookError;
    var HooksDispatcherOnMountInDEV = null, HooksDispatcherOnMountWithHookTypesInDEV = null, HooksDispatcherOnUpdateInDEV = null, HooksDispatcherOnRerenderInDEV = null, InvalidNestedHooksDispatcherOnMountInDEV = null, InvalidNestedHooksDispatcherOnUpdateInDEV = null, InvalidNestedHooksDispatcherOnRerenderInDEV = null;
    HooksDispatcherOnMountInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        use: use,
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            mountHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            mountEffectImpl(4, Insertion, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            mountHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            mountHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useDebugValue: function() {
            currentHookNameInDev = "useDebugValue";
            mountHookTypesDev();
        },
        useDeferredValue: function(value, initialValue) {
            currentHookNameInDev = "useDeferredValue";
            mountHookTypesDev();
            return mountDeferredValue(value, initialValue);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            mountHookTypesDev();
            return mountTransition();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            mountHookTypesDev();
            return mountId();
        },
        useFormState: function(action, initialState) {
            currentHookNameInDev = "useFormState";
            mountHookTypesDev();
            warnOnUseFormStateInDev();
            return mountActionState(action, initialState);
        },
        useActionState: function(action, initialState) {
            currentHookNameInDev = "useActionState";
            mountHookTypesDev();
            return mountActionState(action, initialState);
        },
        useOptimistic: function(passthrough) {
            currentHookNameInDev = "useOptimistic";
            mountHookTypesDev();
            return mountOptimistic(passthrough);
        },
        useHostTransitionStatus: useHostTransitionStatus,
        useMemoCache: useMemoCache,
        useCacheRefresh: function() {
            currentHookNameInDev = "useCacheRefresh";
            mountHookTypesDev();
            return mountRefresh();
        },
        useEffectEvent: function(callback) {
            currentHookNameInDev = "useEffectEvent";
            mountHookTypesDev();
            return mountEvent(callback);
        }
    };
    HooksDispatcherOnMountWithHookTypesInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        use: use,
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            mountEffectImpl(4, Insertion, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useDebugValue: function() {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
        },
        useDeferredValue: function(value, initialValue) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return mountDeferredValue(value, initialValue);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return mountTransition();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return mountId();
        },
        useActionState: function(action, initialState) {
            currentHookNameInDev = "useActionState";
            updateHookTypesDev();
            return mountActionState(action, initialState);
        },
        useFormState: function(action, initialState) {
            currentHookNameInDev = "useFormState";
            updateHookTypesDev();
            warnOnUseFormStateInDev();
            return mountActionState(action, initialState);
        },
        useOptimistic: function(passthrough) {
            currentHookNameInDev = "useOptimistic";
            updateHookTypesDev();
            return mountOptimistic(passthrough);
        },
        useHostTransitionStatus: useHostTransitionStatus,
        useMemoCache: useMemoCache,
        useCacheRefresh: function() {
            currentHookNameInDev = "useCacheRefresh";
            updateHookTypesDev();
            return mountRefresh();
        },
        useEffectEvent: function(callback) {
            currentHookNameInDev = "useEffectEvent";
            updateHookTypesDev();
            return mountEvent(callback);
        }
    };
    HooksDispatcherOnUpdateInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        use: use,
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            updateEffectImpl(2048, Passive, create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return updateEffectImpl(4, Insertion, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return updateEffectImpl(4, Layout, create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useRef: function() {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useState: function() {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(basicStateReducer);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useDebugValue: function() {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
        },
        useDeferredValue: function(value, initialValue) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return updateDeferredValue(value, initialValue);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return updateTransition();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useFormState: function(action) {
            currentHookNameInDev = "useFormState";
            updateHookTypesDev();
            warnOnUseFormStateInDev();
            return updateActionState(action);
        },
        useActionState: function(action) {
            currentHookNameInDev = "useActionState";
            updateHookTypesDev();
            return updateActionState(action);
        },
        useOptimistic: function(passthrough, reducer) {
            currentHookNameInDev = "useOptimistic";
            updateHookTypesDev();
            return updateOptimistic(passthrough, reducer);
        },
        useHostTransitionStatus: useHostTransitionStatus,
        useMemoCache: useMemoCache,
        useCacheRefresh: function() {
            currentHookNameInDev = "useCacheRefresh";
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useEffectEvent: function(callback) {
            currentHookNameInDev = "useEffectEvent";
            updateHookTypesDev();
            return updateEvent(callback);
        }
    };
    HooksDispatcherOnRerenderInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        use: use,
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            updateEffectImpl(2048, Passive, create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return updateEffectImpl(4, Insertion, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return updateEffectImpl(4, Layout, create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useRef: function() {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useState: function() {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderReducer(basicStateReducer);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useDebugValue: function() {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
        },
        useDeferredValue: function(value, initialValue) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return rerenderDeferredValue(value, initialValue);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return rerenderTransition();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useFormState: function(action) {
            currentHookNameInDev = "useFormState";
            updateHookTypesDev();
            warnOnUseFormStateInDev();
            return rerenderActionState(action);
        },
        useActionState: function(action) {
            currentHookNameInDev = "useActionState";
            updateHookTypesDev();
            return rerenderActionState(action);
        },
        useOptimistic: function(passthrough, reducer) {
            currentHookNameInDev = "useOptimistic";
            updateHookTypesDev();
            return rerenderOptimistic(passthrough, reducer);
        },
        useHostTransitionStatus: useHostTransitionStatus,
        useMemoCache: useMemoCache,
        useCacheRefresh: function() {
            currentHookNameInDev = "useCacheRefresh";
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useEffectEvent: function(callback) {
            currentHookNameInDev = "useEffectEvent";
            updateHookTypesDev();
            return updateEvent(callback);
        }
    };
    InvalidNestedHooksDispatcherOnMountInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        use: function(usable) {
            warnInvalidHookAccess();
            return use(usable);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            mountEffectImpl(4, Insertion, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useDebugValue: function() {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            mountHookTypesDev();
        },
        useDeferredValue: function(value, initialValue) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDeferredValue(value, initialValue);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountTransition();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountId();
        },
        useFormState: function(action, initialState) {
            currentHookNameInDev = "useFormState";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountActionState(action, initialState);
        },
        useActionState: function(action, initialState) {
            currentHookNameInDev = "useActionState";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountActionState(action, initialState);
        },
        useOptimistic: function(passthrough) {
            currentHookNameInDev = "useOptimistic";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountOptimistic(passthrough);
        },
        useMemoCache: function(size) {
            warnInvalidHookAccess();
            return useMemoCache(size);
        },
        useHostTransitionStatus: useHostTransitionStatus,
        useCacheRefresh: function() {
            currentHookNameInDev = "useCacheRefresh";
            mountHookTypesDev();
            return mountRefresh();
        },
        useEffectEvent: function(callback) {
            currentHookNameInDev = "useEffectEvent";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountEvent(callback);
        }
    };
    InvalidNestedHooksDispatcherOnUpdateInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        use: function(usable) {
            warnInvalidHookAccess();
            return use(usable);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            updateEffectImpl(2048, Passive, create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffectImpl(4, Insertion, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffectImpl(4, Layout, create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useRef: function() {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useState: function() {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(basicStateReducer);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useDebugValue: function() {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
        },
        useDeferredValue: function(value, initialValue) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDeferredValue(value, initialValue);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateTransition();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useFormState: function(action) {
            currentHookNameInDev = "useFormState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateActionState(action);
        },
        useActionState: function(action) {
            currentHookNameInDev = "useActionState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateActionState(action);
        },
        useOptimistic: function(passthrough, reducer) {
            currentHookNameInDev = "useOptimistic";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateOptimistic(passthrough, reducer);
        },
        useMemoCache: function(size) {
            warnInvalidHookAccess();
            return useMemoCache(size);
        },
        useHostTransitionStatus: useHostTransitionStatus,
        useCacheRefresh: function() {
            currentHookNameInDev = "useCacheRefresh";
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useEffectEvent: function(callback) {
            currentHookNameInDev = "useEffectEvent";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEvent(callback);
        }
    };
    InvalidNestedHooksDispatcherOnRerenderInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        use: function(usable) {
            warnInvalidHookAccess();
            return use(usable);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            updateEffectImpl(2048, Passive, create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffectImpl(4, Insertion, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffectImpl(4, Layout, create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useRef: function() {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useState: function() {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderReducer(basicStateReducer);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useDebugValue: function() {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
        },
        useDeferredValue: function(value, initialValue) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderDeferredValue(value, initialValue);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderTransition();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useFormState: function(action) {
            currentHookNameInDev = "useFormState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderActionState(action);
        },
        useActionState: function(action) {
            currentHookNameInDev = "useActionState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderActionState(action);
        },
        useOptimistic: function(passthrough, reducer) {
            currentHookNameInDev = "useOptimistic";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderOptimistic(passthrough, reducer);
        },
        useMemoCache: function(size) {
            warnInvalidHookAccess();
            return useMemoCache(size);
        },
        useHostTransitionStatus: useHostTransitionStatus,
        useCacheRefresh: function() {
            currentHookNameInDev = "useCacheRefresh";
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useEffectEvent: function(callback) {
            currentHookNameInDev = "useEffectEvent";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEvent(callback);
        }
    };
    var fakeInternalInstance = {};
    var didWarnAboutStateAssignmentForComponent = new Set();
    var didWarnAboutUninitializedState = new Set();
    var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
    var didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
    var didWarnAboutDirectlyAssigningPropsToState = new Set();
    var didWarnAboutUndefinedDerivedState = new Set();
    var didWarnAboutContextTypes$1 = new Set();
    var didWarnAboutChildContextTypes = new Set();
    var didWarnAboutInvalidateContextType = new Set();
    var didWarnOnInvalidCallback = new Set();
    Object.freeze(fakeInternalInstance);
    var classComponentUpdater = {
        enqueueSetState: function(inst, payload, callback) {
            inst = inst._reactInternals;
            var lane = requestUpdateLane(inst), update = createUpdate(lane);
            update.payload = payload;
            void 0 !== callback && null !== callback && (warnOnInvalidCallback(callback), update.callback = callback);
            payload = enqueueUpdate(inst, update, lane);
            null !== payload && (startUpdateTimerByLane(lane, "this.setState()", inst), scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
        },
        enqueueReplaceState: function(inst, payload, callback) {
            inst = inst._reactInternals;
            var lane = requestUpdateLane(inst), update = createUpdate(lane);
            update.tag = ReplaceState;
            update.payload = payload;
            void 0 !== callback && null !== callback && (warnOnInvalidCallback(callback), update.callback = callback);
            payload = enqueueUpdate(inst, update, lane);
            null !== payload && (startUpdateTimerByLane(lane, "this.replaceState()", inst), scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
        },
        enqueueForceUpdate: function(inst, callback) {
            inst = inst._reactInternals;
            var lane = requestUpdateLane(inst), update = createUpdate(lane);
            update.tag = ForceUpdate;
            void 0 !== callback && null !== callback && (warnOnInvalidCallback(callback), update.callback = callback);
            callback = enqueueUpdate(inst, update, lane);
            null !== callback && (startUpdateTimerByLane(lane, "this.forceUpdate()", inst), scheduleUpdateOnFiber(callback, inst, lane), entangleTransitions(callback, inst, lane));
        }
    }, componentName = null, errorBoundaryName = null, SelectiveHydrationException = Error("This is not a real error. It's an implementation detail of React's selective hydration feature. If this leaks into userspace, it's a bug in React. Please file an issue."), didReceiveUpdate = !1;
    var didWarnAboutBadClass = {};
    var didWarnAboutContextTypeOnFunctionComponent = {};
    var didWarnAboutContextTypes = {};
    var didWarnAboutGetDerivedStateOnFunctionComponent = {};
    var didWarnAboutReassigningProps = !1;
    var didWarnAboutRevealOrder = {};
    var didWarnAboutTailOptions = {};
    var SUSPENDED_MARKER = {
        dehydrated: null,
        treeContext: null,
        retryLane: 0,
        hydrationErrors: null
    }, hasWarnedAboutUsingNoValuePropOnContextProvider = !1, didWarnAboutUndefinedSnapshotBeforeUpdate = null;
    didWarnAboutUndefinedSnapshotBeforeUpdate = new Set();
    var offscreenSubtreeIsHidden = !1, offscreenSubtreeWasHidden = !1, needsFormReset = !1, PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, nextEffect = null, inProgressLanes = null, inProgressRoot = null, hostParent = null, hostParentIsContainer = !1, currentHoistableRoot = null, inHydratedSubtree = !1, suspenseyCommitFlag = 8192, DefaultAsyncDispatcher = {
        getCacheForType: function(resourceType) {
            var cache = readContext(CacheContext), cacheForType = cache.data.get(resourceType);
            void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
            return cacheForType;
        },
        cacheSignal: function() {
            return readContext(CacheContext).controller.signal;
        },
        getOwner: function() {
            return current;
        }
    };
    if ("function" === typeof Symbol && Symbol.for) {
        var symbolFor = Symbol.for;
        symbolFor("selector.component");
        symbolFor("selector.has_pseudo_class");
        symbolFor("selector.role");
        symbolFor("selector.test_id");
        symbolFor("selector.text");
    }
    var commitHooks = [], PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, NoContext = 0, RenderContext = 2, CommitContext = 4, RootInProgress = 0, RootFatalErrored = 1, RootErrored = 2, RootSuspended = 3, RootSuspendedWithDelay = 4, RootSuspendedAtTheShell = 6, RootCompleted = 5, executionContext = NoContext, workInProgressRoot = null, workInProgress = null, workInProgressRootRenderLanes = 0, NotSuspended = 0, SuspendedOnError = 1, SuspendedOnData = 2, SuspendedOnImmediate = 3, SuspendedOnInstance = 4, SuspendedOnInstanceAndReadyToContinue = 5, SuspendedOnDeprecatedThrowPromise = 6, SuspendedAndReadyToContinue = 7, SuspendedOnHydration = 8, SuspendedOnAction = 9, workInProgressSuspendedReason = NotSuspended, workInProgressThrownValue = null, workInProgressRootDidSkipSuspendedSiblings = !1, workInProgressRootIsPrerendering = !1, workInProgressRootDidAttachPingListener = !1, entangledRenderLanes = 0, workInProgressRootExitStatus = RootInProgress, workInProgressRootSkippedLanes = 0, workInProgressRootInterleavedUpdatedLanes = 0, workInProgressRootPingedLanes = 0, workInProgressDeferredLane = 0, workInProgressSuspendedRetryLanes = 0, workInProgressRootConcurrentErrors = null, workInProgressRootRecoverableErrors = null, workInProgressRootDidIncludeRecursiveRenderUpdate = !1, globalMostRecentFallbackTime = 0, globalMostRecentTransitionTime = 0, FALLBACK_THROTTLE_MS = 300, workInProgressRootRenderTargetTime = Infinity, RENDER_TIMEOUT_MS = 500, workInProgressTransitions = null, workInProgressUpdateTask = null, legacyErrorBoundariesThatAlreadyFailed = null, IMMEDIATE_COMMIT = 0, ABORTED_VIEW_TRANSITION_COMMIT = 1, DELAYED_PASSIVE_COMMIT = 2, ANIMATION_STARTED_COMMIT = 3, NO_PENDING_EFFECTS = 0, PENDING_MUTATION_PHASE = 1, PENDING_LAYOUT_PHASE = 2, PENDING_AFTER_MUTATION_PHASE = 3, PENDING_SPAWNED_WORK = 4, PENDING_PASSIVE_PHASE = 5, pendingEffectsStatus = 0, pendingEffectsRoot = null, pendingFinishedWork = null, pendingEffectsLanes = 0, pendingEffectsRemainingLanes = 0, pendingEffectsRenderEndTime = -0, pendingPassiveTransitions = null, pendingRecoverableErrors = null, pendingSuspendedCommitReason = null, pendingDelayedCommitReason = IMMEDIATE_COMMIT, pendingSuspendedViewTransitionReason = null, NESTED_UPDATE_LIMIT = 50, nestedUpdateCount = 0, rootWithNestedUpdates = null, isFlushingPassiveEffects = !1, didScheduleUpdateDuringPassiveEffects = !1, NESTED_PASSIVE_UPDATE_LIMIT = 50, nestedPassiveUpdateCount = 0, rootWithPassiveNestedUpdates = null, isRunningInsertionEffect = !1, didWarnStateUpdateForNotYetMountedComponent = null, didWarnAboutUpdateInRender = !1;
    var didWarnAboutUpdateInRenderForAnotherComponent = new Set();
    var fakeActCallbackNode$1 = {}, firstScheduledRoot = null, lastScheduledRoot = null, didScheduleMicrotask = !1, didScheduleMicrotask_act = !1, mightHavePendingSyncWork = !1, isFlushingWork = !1, currentEventTransitionLane = 0, fakeActCallbackNode = {};
    (function() {
        for(var i = 0; i < simpleEventPluginEvents.length; i++){
            var eventName = simpleEventPluginEvents[i], domEventName = eventName.toLowerCase();
            eventName = eventName[0].toUpperCase() + eventName.slice(1);
            registerSimpleEvent(domEventName, "on" + eventName);
        }
        registerSimpleEvent(ANIMATION_END, "onAnimationEnd");
        registerSimpleEvent(ANIMATION_ITERATION, "onAnimationIteration");
        registerSimpleEvent(ANIMATION_START, "onAnimationStart");
        registerSimpleEvent("dblclick", "onDoubleClick");
        registerSimpleEvent("focusin", "onFocus");
        registerSimpleEvent("focusout", "onBlur");
        registerSimpleEvent(TRANSITION_RUN, "onTransitionRun");
        registerSimpleEvent(TRANSITION_START, "onTransitionStart");
        registerSimpleEvent(TRANSITION_CANCEL, "onTransitionCancel");
        registerSimpleEvent(TRANSITION_END, "onTransitionEnd");
    })();
    registerDirectEvent("onMouseEnter", [
        "mouseout",
        "mouseover"
    ]);
    registerDirectEvent("onMouseLeave", [
        "mouseout",
        "mouseover"
    ]);
    registerDirectEvent("onPointerEnter", [
        "pointerout",
        "pointerover"
    ]);
    registerDirectEvent("onPointerLeave", [
        "pointerout",
        "pointerover"
    ]);
    registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
    registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
    registerTwoPhaseEvent("onBeforeInput", [
        "compositionend",
        "keypress",
        "textInput",
        "paste"
    ]);
    registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
    registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
    registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
    var mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(mediaEventTypes)), listeningMarker = "_reactListening" + Math.random().toString(36).slice(2), didWarnControlledToUncontrolled = !1, didWarnUncontrolledToControlled = !1, didWarnFormActionType = !1, didWarnFormActionName = !1, didWarnFormActionTarget = !1, didWarnFormActionMethod = !1, didWarnPopoverTargetObject = !1;
    var didWarnForNewBooleanPropsWithEmptyValue = {};
    var NORMALIZE_NEWLINES_REGEX = /\r\n?/g, NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g, xlinkNamespace = "http://www.w3.org/1999/xlink", xmlNamespace = "http://www.w3.org/XML/1998/namespace", EXPECTED_FORM_ACTION_URL = "javascript:throw new Error('React form unexpectedly submitted.')", SUPPRESS_HYDRATION_WARNING = "suppressHydrationWarning", ACTIVITY_START_DATA = "&", ACTIVITY_END_DATA = "/&", SUSPENSE_START_DATA = "$", SUSPENSE_END_DATA = "/$", SUSPENSE_PENDING_START_DATA = "$?", SUSPENSE_QUEUED_START_DATA = "$~", SUSPENSE_FALLBACK_START_DATA = "$!", PREAMBLE_CONTRIBUTION_HTML = "html", PREAMBLE_CONTRIBUTION_BODY = "body", PREAMBLE_CONTRIBUTION_HEAD = "head", FORM_STATE_IS_MATCHING = "F!", FORM_STATE_IS_NOT_MATCHING = "F", DOCUMENT_READY_STATE_LOADING = "loading", STYLE = "style", HostContextNamespaceNone = 0, HostContextNamespaceSvg = 1, HostContextNamespaceMath = 2, eventsEnabled = null, selectionInformation = null, warnedUnknownTags = {
        dialog: !0,
        webview: !0
    }, currentPopstateTransitionEvent = null, schedulerEvent = void 0, scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, noTimeout = -1, localPromise = "function" === typeof Promise ? Promise : void 0, scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof localPromise ? function(callback) {
        return localPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
    } : scheduleTimeout, previousHydratableOnEnteringScopedSingleton = null, NotLoaded = 0, Loaded = 1, Errored = 2, Settled = 3, Inserted = 4, preloadPropsMap = new Map(), preconnectsSet = new Set(), previousDispatcher = ReactDOMSharedInternals.d;
    ReactDOMSharedInternals.d = {
        f: function() {
            var previousWasRendering = previousDispatcher.f(), wasRendering = flushSyncWork$1();
            return previousWasRendering || wasRendering;
        },
        r: function(form) {
            var formInst = getInstanceFromNode(form);
            null !== formInst && 5 === formInst.tag && "form" === formInst.type ? requestFormReset$1(formInst) : previousDispatcher.r(form);
        },
        D: function(href) {
            previousDispatcher.D(href);
            preconnectAs("dns-prefetch", href, null);
        },
        C: function(href, crossOrigin) {
            previousDispatcher.C(href, crossOrigin);
            preconnectAs("preconnect", href, crossOrigin);
        },
        L: function(href, as, options) {
            previousDispatcher.L(href, as, options);
            var ownerDocument = globalDocument;
            if (ownerDocument && href && as) {
                var preloadSelector = 'link[rel="preload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
                "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
                var key = preloadSelector;
                switch(as){
                    case "style":
                        key = getStyleKey(href);
                        break;
                    case "script":
                        key = getScriptKey(href);
                }
                preloadPropsMap.has(key) || (href = assign({
                    rel: "preload",
                    href: "image" === as && options && options.imageSrcSet ? void 0 : href,
                    as: as
                }, options), preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector(getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector(getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), setInitialProperties(as, "link", href), markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
            }
        },
        m: function(href, options) {
            previousDispatcher.m(href, options);
            var ownerDocument = globalDocument;
            if (ownerDocument && href) {
                var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
                switch(as){
                    case "audioworklet":
                    case "paintworklet":
                    case "serviceworker":
                    case "sharedworker":
                    case "worker":
                    case "script":
                        key = getScriptKey(href);
                }
                if (!preloadPropsMap.has(key) && (href = assign({
                    rel: "modulepreload",
                    href: href
                }, options), preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
                    switch(as){
                        case "audioworklet":
                        case "paintworklet":
                        case "serviceworker":
                        case "sharedworker":
                        case "worker":
                        case "script":
                            if (ownerDocument.querySelector(getScriptSelectorFromKey(key))) return;
                    }
                    as = ownerDocument.createElement("link");
                    setInitialProperties(as, "link", href);
                    markNodeAsHoistable(as);
                    ownerDocument.head.appendChild(as);
                }
            }
        },
        X: function(src, options) {
            previousDispatcher.X(src, options);
            var ownerDocument = globalDocument;
            if (ownerDocument && src) {
                var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
                resource || (resource = ownerDocument.querySelector(getScriptSelectorFromKey(key)), resource || (src = assign({
                    src: src,
                    async: !0
                }, options), (options = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
                    type: "script",
                    instance: resource,
                    count: 1,
                    state: null
                }, scripts.set(key, resource));
            }
        },
        S: function(href, precedence, options) {
            previousDispatcher.S(href, precedence, options);
            var ownerDocument = globalDocument;
            if (ownerDocument && href) {
                var styles = getResourcesFromRoot(ownerDocument).hoistableStyles, key = getStyleKey(href);
                precedence = precedence || "default";
                var resource = styles.get(key);
                if (!resource) {
                    var state = {
                        loading: NotLoaded,
                        preload: null
                    };
                    if (resource = ownerDocument.querySelector(getStylesheetSelectorFromKey(key))) state.loading = Loaded | Inserted;
                    else {
                        href = assign({
                            rel: "stylesheet",
                            href: href,
                            "data-precedence": precedence
                        }, options);
                        (options = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(href, options);
                        var link = resource = ownerDocument.createElement("link");
                        markNodeAsHoistable(link);
                        setInitialProperties(link, "link", href);
                        link._p = new Promise(function(resolve, reject) {
                            link.onload = resolve;
                            link.onerror = reject;
                        });
                        link.addEventListener("load", function() {
                            state.loading |= Loaded;
                        });
                        link.addEventListener("error", function() {
                            state.loading |= Errored;
                        });
                        state.loading |= Inserted;
                        insertStylesheet(resource, precedence, ownerDocument);
                    }
                    resource = {
                        type: "stylesheet",
                        instance: resource,
                        count: 1,
                        state: state
                    };
                    styles.set(key, resource);
                }
            }
        },
        M: function(src, options) {
            previousDispatcher.M(src, options);
            var ownerDocument = globalDocument;
            if (ownerDocument && src) {
                var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
                resource || (resource = ownerDocument.querySelector(getScriptSelectorFromKey(key)), resource || (src = assign({
                    src: src,
                    async: !0,
                    type: "module"
                }, options), (options = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
                    type: "script",
                    instance: resource,
                    count: 1,
                    state: null
                }, scripts.set(key, resource));
            }
        }
    };
    var globalDocument = "undefined" === typeof document ? null : document, tagCaches = null, SUSPENSEY_STYLESHEET_TIMEOUT = 6e4, SUSPENSEY_IMAGE_TIMEOUT = 800, SUSPENSEY_IMAGE_TIME_ESTIMATE = 500, estimatedBytesWithinLimit = 0, LAST_PRECEDENCE = null, precedencesByRoot = null, NotPendingTransition = NotPending, HostTransitionContext = {
        $$typeof: REACT_CONTEXT_TYPE,
        Provider: null,
        Consumer: null,
        _currentValue: NotPendingTransition,
        _currentValue2: NotPendingTransition,
        _threadCount: 0
    }, badgeFormat = "%c%s%c", badgeStyle = "background: #e6e6e6;background: light-dark(rgba(0,0,0,0.1), rgba(255,255,255,0.25));color: #000000;color: light-dark(#000000, #ffffff);border-radius: 2px", resetStyle = "", pad = " ", bind = Function.prototype.bind;
    var didWarnAboutNestedUpdates = !1;
    var overrideHookState = null, overrideHookStateDeletePath = null, overrideHookStateRenamePath = null, overrideProps = null, overridePropsDeletePath = null, overridePropsRenamePath = null, scheduleUpdate = null, scheduleRetry = null, setErrorHandler = null, setSuspenseHandler = null;
    overrideHookState = function(fiber, id, path, value) {
        id = findHook(fiber, id);
        null !== id && (path = copyWithSetImpl(id.memoizedState, path, 0, value), id.memoizedState = path, id.baseState = path, fiber.memoizedProps = assign({}, fiber.memoizedProps), path = enqueueConcurrentRenderForLane(fiber, 2), null !== path && scheduleUpdateOnFiber(path, fiber, 2));
    };
    overrideHookStateDeletePath = function(fiber, id, path) {
        id = findHook(fiber, id);
        null !== id && (path = copyWithDeleteImpl(id.memoizedState, path, 0), id.memoizedState = path, id.baseState = path, fiber.memoizedProps = assign({}, fiber.memoizedProps), path = enqueueConcurrentRenderForLane(fiber, 2), null !== path && scheduleUpdateOnFiber(path, fiber, 2));
    };
    overrideHookStateRenamePath = function(fiber, id, oldPath, newPath) {
        id = findHook(fiber, id);
        null !== id && (oldPath = copyWithRename(id.memoizedState, oldPath, newPath), id.memoizedState = oldPath, id.baseState = oldPath, fiber.memoizedProps = assign({}, fiber.memoizedProps), oldPath = enqueueConcurrentRenderForLane(fiber, 2), null !== oldPath && scheduleUpdateOnFiber(oldPath, fiber, 2));
    };
    overrideProps = function(fiber, path, value) {
        fiber.pendingProps = copyWithSetImpl(fiber.memoizedProps, path, 0, value);
        fiber.alternate && (fiber.alternate.pendingProps = fiber.pendingProps);
        path = enqueueConcurrentRenderForLane(fiber, 2);
        null !== path && scheduleUpdateOnFiber(path, fiber, 2);
    };
    overridePropsDeletePath = function(fiber, path) {
        fiber.pendingProps = copyWithDeleteImpl(fiber.memoizedProps, path, 0);
        fiber.alternate && (fiber.alternate.pendingProps = fiber.pendingProps);
        path = enqueueConcurrentRenderForLane(fiber, 2);
        null !== path && scheduleUpdateOnFiber(path, fiber, 2);
    };
    overridePropsRenamePath = function(fiber, oldPath, newPath) {
        fiber.pendingProps = copyWithRename(fiber.memoizedProps, oldPath, newPath);
        fiber.alternate && (fiber.alternate.pendingProps = fiber.pendingProps);
        oldPath = enqueueConcurrentRenderForLane(fiber, 2);
        null !== oldPath && scheduleUpdateOnFiber(oldPath, fiber, 2);
    };
    scheduleUpdate = function(fiber) {
        var root = enqueueConcurrentRenderForLane(fiber, 2);
        null !== root && scheduleUpdateOnFiber(root, fiber, 2);
    };
    scheduleRetry = function(fiber) {
        var lane = claimNextRetryLane(), root = enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && scheduleUpdateOnFiber(root, fiber, lane);
    };
    setErrorHandler = function(newShouldErrorImpl) {
        shouldErrorImpl = newShouldErrorImpl;
    };
    setSuspenseHandler = function(newShouldSuspendImpl) {
        shouldSuspendImpl = newShouldSuspendImpl;
    };
    var _enabled = !0, return_targetInst = null, hasScheduledReplayAttempt = !1, queuedFocus = null, queuedDrag = null, queuedMouse = null, queuedPointers = new Map(), queuedPointerCaptures = new Map(), queuedExplicitHydrationTargets = [], discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" "), lastScheduledReplayQueue = null;
    ReactDOMHydrationRoot.prototype.render = ReactDOMRoot.prototype.render = function(children) {
        var root = this._internalRoot;
        if (null === root) throw Error("Cannot update an unmounted root.");
        var args = arguments;
        "function" === typeof args[1] ? console.error("does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().") : isValidContainer(args[1]) ? console.error("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.") : "undefined" !== typeof args[1] && console.error("You passed a second argument to root.render(...) but it only accepts one argument.");
        args = children;
        var current = root.current, lane = requestUpdateLane(current);
        updateContainerImpl(current, lane, args, root, null, null);
    };
    ReactDOMHydrationRoot.prototype.unmount = ReactDOMRoot.prototype.unmount = function() {
        var args = arguments;
        "function" === typeof args[0] && console.error("does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        args = this._internalRoot;
        if (null !== args) {
            this._internalRoot = null;
            var container = args.containerInfo;
            (executionContext & (RenderContext | CommitContext)) !== NoContext && console.error("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition.");
            updateContainerImpl(args.current, 2, null, args, null, null);
            flushSyncWork$1();
            container[internalContainerInstanceKey] = null;
        }
    };
    ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
        if (target) {
            var updatePriority = resolveUpdatePriority();
            target = {
                blockedOn: null,
                target: target,
                priority: updatePriority
            };
            for(var i = 0; i < queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < queuedExplicitHydrationTargets[i].priority; i++);
            queuedExplicitHydrationTargets.splice(i, 0, target);
            0 === i && attemptExplicitHydrationTarget(target);
        }
    };
    (function() {
        var isomorphicReactPackageVersion = React.version;
        if ("19.2.3" !== isomorphicReactPackageVersion) throw Error('Incompatible React versions: The "react" and "react-dom" packages must have the exact same version. Instead got:\n  - react:      ' + (isomorphicReactPackageVersion + "\n  - react-dom:  19.2.3\nLearn more: https://react.dev/warnings/version-mismatch"));
    })();
    "function" === typeof Map && null != Map.prototype && "function" === typeof Map.prototype.forEach && "function" === typeof Set && null != Set.prototype && "function" === typeof Set.prototype.clear && "function" === typeof Set.prototype.forEach || console.error("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://react.dev/link/react-polyfills");
    ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
        var fiber = componentOrElement._reactInternals;
        if (void 0 === fiber) {
            if ("function" === typeof componentOrElement.render) throw Error("Unable to find node on an unmounted component.");
            componentOrElement = Object.keys(componentOrElement).join(",");
            throw Error("Argument appears to not be a ReactComponent. Keys: " + componentOrElement);
        }
        componentOrElement = findCurrentFiberUsingSlowPath(fiber);
        componentOrElement = null !== componentOrElement ? findCurrentHostFiberImpl(componentOrElement) : null;
        componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
        return componentOrElement;
    };
    if (!function() {
        var internals = {
            bundleType: 1,
            version: "19.2.3",
            rendererPackageName: "react-dom",
            currentDispatcherRef: ReactSharedInternals,
            reconcilerVersion: "19.2.3"
        };
        internals.overrideHookState = overrideHookState;
        internals.overrideHookStateDeletePath = overrideHookStateDeletePath;
        internals.overrideHookStateRenamePath = overrideHookStateRenamePath;
        internals.overrideProps = overrideProps;
        internals.overridePropsDeletePath = overridePropsDeletePath;
        internals.overridePropsRenamePath = overridePropsRenamePath;
        internals.scheduleUpdate = scheduleUpdate;
        internals.scheduleRetry = scheduleRetry;
        internals.setErrorHandler = setErrorHandler;
        internals.setSuspenseHandler = setSuspenseHandler;
        internals.scheduleRefresh = scheduleRefresh;
        internals.scheduleRoot = scheduleRoot;
        internals.setRefreshHandler = setRefreshHandler;
        internals.getCurrentFiber = getCurrentFiberForDevTools;
        return injectInternals(internals);
    }() && canUseDOM && window.top === window.self && (-1 < navigator.userAgent.indexOf("Chrome") && -1 === navigator.userAgent.indexOf("Edge") || -1 < navigator.userAgent.indexOf("Firefox"))) {
        var protocol = window.location.protocol;
        /^(https?|file):$/.test(protocol) && console.info("%cDownload the React DevTools for a better development experience: https://react.dev/link/react-devtools" + ("file:" === protocol ? "\nYou might need to use a local HTTP server (instead of file://): https://react.dev/link/react-devtools-faq" : ""), "font-weight:bold");
    }
    $f866dd6f6995409f$export$882461b6382ed46c = function(container, options) {
        if (!isValidContainer(container)) throw Error("Target container is not a DOM element.");
        warnIfReactDOMContainerInDEV(container);
        var isStrictMode = !1, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError;
        null !== options && void 0 !== options && (options.hydrate ? console.warn("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.") : "object" === typeof options && null !== options && options.$$typeof === REACT_ELEMENT_TYPE && console.error("You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:\n\n  let root = createRoot(domContainer);\n  root.render(<App />);"), !0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
        options = createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, defaultOnDefaultTransitionIndicator);
        container[internalContainerInstanceKey] = options.current;
        listenToAllSupportedEvents(container);
        return new ReactDOMRoot(options);
    };
    $f866dd6f6995409f$export$757ceba2d55c277e = function(container, initialChildren, options) {
        if (!isValidContainer(container)) throw Error("Target container is not a DOM element.");
        warnIfReactDOMContainerInDEV(container);
        void 0 === initialChildren && console.error("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
        var isStrictMode = !1, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError, formState = null;
        null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
        initialChildren = createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, defaultOnDefaultTransitionIndicator);
        initialChildren.context = getContextForSubtree(null);
        options = initialChildren.current;
        isStrictMode = requestUpdateLane(options);
        isStrictMode = getBumpedLaneForHydrationByLane(isStrictMode);
        identifierPrefix = createUpdate(isStrictMode);
        identifierPrefix.callback = null;
        enqueueUpdate(options, identifierPrefix, isStrictMode);
        startUpdateTimerByLane(isStrictMode, "hydrateRoot()", null);
        options = isStrictMode;
        initialChildren.current.lanes = options;
        markRootUpdated$1(initialChildren, options);
        ensureRootIsScheduled(initialChildren);
        container[internalContainerInstanceKey] = initialChildren.current;
        listenToAllSupportedEvents(container);
        return new ReactDOMHydrationRoot(initialChildren);
    };
    $f866dd6f6995409f$export$83d89fbfd8236492 = "19.2.3";
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
})();

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("7jGsX"));

});
parcelRegister("7jGsX", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $553b3f9a1c62156e$export$c4744153514ff05d, (v) => $553b3f9a1c62156e$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $553b3f9a1c62156e$export$3e506c1ccc9cc1a7, (v) => $553b3f9a1c62156e$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $553b3f9a1c62156e$export$e26fe2ed2fa76875, (v) => $553b3f9a1c62156e$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $553b3f9a1c62156e$export$502329bbf4b505b1, (v) => $553b3f9a1c62156e$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $553b3f9a1c62156e$export$6e3807111c4874c4, (v) => $553b3f9a1c62156e$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $553b3f9a1c62156e$export$c27134553091fb3a, (v) => $553b3f9a1c62156e$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $553b3f9a1c62156e$export$33ee1acdc04fd2a2, (v) => $553b3f9a1c62156e$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $553b3f9a1c62156e$export$b00a404bbd5edef2, (v) => $553b3f9a1c62156e$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $553b3f9a1c62156e$export$d66a1c1c77bd778b, (v) => $553b3f9a1c62156e$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $553b3f9a1c62156e$export$d3dfb8e4810cb555, (v) => $553b3f9a1c62156e$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $553b3f9a1c62156e$export$72fdf0e06517287b, (v) => $553b3f9a1c62156e$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $553b3f9a1c62156e$export$816d2913ae6b83b1, (v) => $553b3f9a1c62156e$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $553b3f9a1c62156e$export$61bcfe829111a1d0, (v) => $553b3f9a1c62156e$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $553b3f9a1c62156e$export$7ee8c9beb337bc3f, (v) => $553b3f9a1c62156e$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $553b3f9a1c62156e$export$b5836b71941fa3ed, (v) => $553b3f9a1c62156e$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $553b3f9a1c62156e$export$cf845f2c119da08a, (v) => $553b3f9a1c62156e$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $553b3f9a1c62156e$export$c4744153514ff05d;
var $553b3f9a1c62156e$export$3e506c1ccc9cc1a7;
var $553b3f9a1c62156e$export$e26fe2ed2fa76875;
var $553b3f9a1c62156e$export$502329bbf4b505b1;
var $553b3f9a1c62156e$export$6e3807111c4874c4;
var $553b3f9a1c62156e$export$c27134553091fb3a;
var $553b3f9a1c62156e$export$33ee1acdc04fd2a2;
var $553b3f9a1c62156e$export$b00a404bbd5edef2;
var $553b3f9a1c62156e$export$d66a1c1c77bd778b;
var $553b3f9a1c62156e$export$d3dfb8e4810cb555;
var $553b3f9a1c62156e$export$72fdf0e06517287b;
var $553b3f9a1c62156e$export$816d2913ae6b83b1;
var $553b3f9a1c62156e$export$61bcfe829111a1d0;
var $553b3f9a1c62156e$export$7ee8c9beb337bc3f;
var $553b3f9a1c62156e$export$b5836b71941fa3ed;
var $553b3f9a1c62156e$export$cf845f2c119da08a;
"use strict";
(function() {
    function performWorkUntilDeadline() {
        needsPaint = !1;
        if (isMessageLoopRunning) {
            var currentTime = $553b3f9a1c62156e$export$c4744153514ff05d();
            startTime = currentTime;
            var hasMoreWork = !0;
            try {
                a: {
                    isHostCallbackScheduled = !1;
                    isHostTimeoutScheduled && (isHostTimeoutScheduled = !1, localClearTimeout(taskTimeoutID), taskTimeoutID = -1);
                    isPerformingWork = !0;
                    var previousPriorityLevel = currentPriorityLevel;
                    try {
                        b: {
                            advanceTimers(currentTime);
                            for(currentTask = peek(taskQueue); null !== currentTask && !(currentTask.expirationTime > currentTime && shouldYieldToHost());){
                                var callback = currentTask.callback;
                                if ("function" === typeof callback) {
                                    currentTask.callback = null;
                                    currentPriorityLevel = currentTask.priorityLevel;
                                    var continuationCallback = callback(currentTask.expirationTime <= currentTime);
                                    currentTime = $553b3f9a1c62156e$export$c4744153514ff05d();
                                    if ("function" === typeof continuationCallback) {
                                        currentTask.callback = continuationCallback;
                                        advanceTimers(currentTime);
                                        hasMoreWork = !0;
                                        break b;
                                    }
                                    currentTask === peek(taskQueue) && pop(taskQueue);
                                    advanceTimers(currentTime);
                                } else pop(taskQueue);
                                currentTask = peek(taskQueue);
                            }
                            if (null !== currentTask) hasMoreWork = !0;
                            else {
                                var firstTimer = peek(timerQueue);
                                null !== firstTimer && requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
                                hasMoreWork = !1;
                            }
                        }
                        break a;
                    } finally{
                        currentTask = null, currentPriorityLevel = previousPriorityLevel, isPerformingWork = !1;
                    }
                    hasMoreWork = void 0;
                }
            } finally{
                hasMoreWork ? schedulePerformWorkUntilDeadline() : isMessageLoopRunning = !1;
            }
        }
    }
    function push(heap, node) {
        var index = heap.length;
        heap.push(node);
        a: for(; 0 < index;){
            var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
            if (0 < compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
            else break a;
        }
    }
    function peek(heap) {
        return 0 === heap.length ? null : heap[0];
    }
    function pop(heap) {
        if (0 === heap.length) return null;
        var first = heap[0], last = heap.pop();
        if (last !== first) {
            heap[0] = last;
            a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
                var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
                if (0 > compare(left, last)) rightIndex < length && 0 > compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
                else if (rightIndex < length && 0 > compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
                else break a;
            }
        }
        return first;
    }
    function compare(a, b) {
        var diff = a.sortIndex - b.sortIndex;
        return 0 !== diff ? diff : a.id - b.id;
    }
    function advanceTimers(currentTime) {
        for(var timer = peek(timerQueue); null !== timer;){
            if (null === timer.callback) pop(timerQueue);
            else if (timer.startTime <= currentTime) pop(timerQueue), timer.sortIndex = timer.expirationTime, push(taskQueue, timer);
            else break;
            timer = peek(timerQueue);
        }
    }
    function handleTimeout(currentTime) {
        isHostTimeoutScheduled = !1;
        advanceTimers(currentTime);
        if (!isHostCallbackScheduled) {
            if (null !== peek(taskQueue)) isHostCallbackScheduled = !0, isMessageLoopRunning || (isMessageLoopRunning = !0, schedulePerformWorkUntilDeadline());
            else {
                var firstTimer = peek(timerQueue);
                null !== firstTimer && requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            }
        }
    }
    function shouldYieldToHost() {
        return needsPaint ? !0 : $553b3f9a1c62156e$export$c4744153514ff05d() - startTime < frameInterval ? !1 : !0;
    }
    function requestHostTimeout(callback, ms) {
        taskTimeoutID = localSetTimeout(function() {
            callback($553b3f9a1c62156e$export$c4744153514ff05d());
        }, ms);
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    $553b3f9a1c62156e$export$c4744153514ff05d = void 0;
    if ("object" === typeof performance && "function" === typeof performance.now) {
        var localPerformance = performance;
        $553b3f9a1c62156e$export$c4744153514ff05d = function() {
            return localPerformance.now();
        };
    } else {
        var localDate = Date, initialTime = localDate.now();
        $553b3f9a1c62156e$export$c4744153514ff05d = function() {
            return localDate.now() - initialTime;
        };
    }
    var taskQueue = [], timerQueue = [], taskIdCounter = 1, currentTask = null, currentPriorityLevel = 3, isPerformingWork = !1, isHostCallbackScheduled = !1, isHostTimeoutScheduled = !1, needsPaint = !1, localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null, isMessageLoopRunning = !1, taskTimeoutID = -1, frameInterval = 5, startTime = -1;
    if ("function" === typeof localSetImmediate) var schedulePerformWorkUntilDeadline = function() {
        localSetImmediate(performWorkUntilDeadline);
    };
    else if ("undefined" !== typeof MessageChannel) {
        var channel = new MessageChannel(), port = channel.port2;
        channel.port1.onmessage = performWorkUntilDeadline;
        schedulePerformWorkUntilDeadline = function() {
            port.postMessage(null);
        };
    } else schedulePerformWorkUntilDeadline = function() {
        localSetTimeout(performWorkUntilDeadline, 0);
    };
    $553b3f9a1c62156e$export$3e506c1ccc9cc1a7 = 5;
    $553b3f9a1c62156e$export$e26fe2ed2fa76875 = 1;
    $553b3f9a1c62156e$export$502329bbf4b505b1 = 4;
    $553b3f9a1c62156e$export$6e3807111c4874c4 = 3;
    $553b3f9a1c62156e$export$c27134553091fb3a = null;
    $553b3f9a1c62156e$export$33ee1acdc04fd2a2 = 2;
    $553b3f9a1c62156e$export$b00a404bbd5edef2 = function(task) {
        task.callback = null;
    };
    $553b3f9a1c62156e$export$d66a1c1c77bd778b = function(fps) {
        0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
    };
    $553b3f9a1c62156e$export$d3dfb8e4810cb555 = function() {
        return currentPriorityLevel;
    };
    $553b3f9a1c62156e$export$72fdf0e06517287b = function(eventHandler) {
        switch(currentPriorityLevel){
            case 1:
            case 2:
            case 3:
                var priorityLevel = 3;
                break;
            default:
                priorityLevel = currentPriorityLevel;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    };
    $553b3f9a1c62156e$export$816d2913ae6b83b1 = function() {
        needsPaint = !0;
    };
    $553b3f9a1c62156e$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
        switch(priorityLevel){
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            default:
                priorityLevel = 3;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    };
    $553b3f9a1c62156e$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
        var currentTime = $553b3f9a1c62156e$export$c4744153514ff05d();
        "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
        switch(priorityLevel){
            case 1:
                var timeout = -1;
                break;
            case 2:
                timeout = 250;
                break;
            case 5:
                timeout = 1073741823;
                break;
            case 4:
                timeout = 1e4;
                break;
            default:
                timeout = 5e3;
        }
        timeout = options + timeout;
        priorityLevel = {
            id: taskIdCounter++,
            callback: callback,
            priorityLevel: priorityLevel,
            startTime: options,
            expirationTime: timeout,
            sortIndex: -1
        };
        options > currentTime ? (priorityLevel.sortIndex = options, push(timerQueue, priorityLevel), null === peek(taskQueue) && priorityLevel === peek(timerQueue) && (isHostTimeoutScheduled ? (localClearTimeout(taskTimeoutID), taskTimeoutID = -1) : isHostTimeoutScheduled = !0, requestHostTimeout(handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, push(taskQueue, priorityLevel), isHostCallbackScheduled || isPerformingWork || (isHostCallbackScheduled = !0, isMessageLoopRunning || (isMessageLoopRunning = !0, schedulePerformWorkUntilDeadline())));
        return priorityLevel;
    };
    $553b3f9a1c62156e$export$b5836b71941fa3ed = shouldYieldToHost;
    $553b3f9a1c62156e$export$cf845f2c119da08a = function(callback) {
        var parentPriorityLevel = currentPriorityLevel;
        return function() {
            var previousPriorityLevel = currentPriorityLevel;
            currentPriorityLevel = parentPriorityLevel;
            try {
                return callback.apply(this, arguments);
            } finally{
                currentPriorityLevel = previousPriorityLevel;
            }
        };
    };
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
})();

});


parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    var err;
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
}

module.exports = (parcelRequire("3y30c"));

});
parcelRegister("3y30c", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $2956e04298bc31b1$export$69ce8ef3fe5cead0, (v) => $2956e04298bc31b1$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $2956e04298bc31b1$export$d39a5bbd09211389, (v) => $2956e04298bc31b1$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $2956e04298bc31b1$export$cd75ccfd720a3cd4, (v) => $2956e04298bc31b1$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $2956e04298bc31b1$export$a0816fa17a9e79be, (v) => $2956e04298bc31b1$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $2956e04298bc31b1$export$7292efcadded39f3, (v) => $2956e04298bc31b1$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $2956e04298bc31b1$export$da407abadb9b8f86, (v) => $2956e04298bc31b1$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $2956e04298bc31b1$export$314cfea32580671c, (v) => $2956e04298bc31b1$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $2956e04298bc31b1$export$513ccb98c53b8039, (v) => $2956e04298bc31b1$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $2956e04298bc31b1$export$dbca993bc2d264a, (v) => $2956e04298bc31b1$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $2956e04298bc31b1$export$4797a8006f0655d0, (v) => $2956e04298bc31b1$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $2956e04298bc31b1$export$c78a37762a8d58e1, (v) => $2956e04298bc31b1$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $2956e04298bc31b1$export$606f11b2eb45ecc6, (v) => $2956e04298bc31b1$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $2956e04298bc31b1$export$f7e8a0bf92324b1e, (v) => $2956e04298bc31b1$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $2956e04298bc31b1$export$83d89fbfd8236492, (v) => $2956e04298bc31b1$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2956e04298bc31b1$export$69ce8ef3fe5cead0;
var $2956e04298bc31b1$export$d39a5bbd09211389;
var $2956e04298bc31b1$export$cd75ccfd720a3cd4;
var $2956e04298bc31b1$export$a0816fa17a9e79be;
var $2956e04298bc31b1$export$7292efcadded39f3;
var $2956e04298bc31b1$export$da407abadb9b8f86;
var $2956e04298bc31b1$export$314cfea32580671c;
var $2956e04298bc31b1$export$513ccb98c53b8039;
var $2956e04298bc31b1$export$dbca993bc2d264a;
var $2956e04298bc31b1$export$4797a8006f0655d0;
var $2956e04298bc31b1$export$c78a37762a8d58e1;
var $2956e04298bc31b1$export$606f11b2eb45ecc6;
var $2956e04298bc31b1$export$f7e8a0bf92324b1e;
var $2956e04298bc31b1$export$83d89fbfd8236492;
"use strict";

(function() {
    function noop() {}
    function testStringCoercion(value) {
        return "" + value;
    }
    function createPortal$1(children, containerInfo, implementation) {
        var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
        try {
            testStringCoercion(key);
            var JSCompiler_inline_result = !1;
        } catch (e) {
            JSCompiler_inline_result = !0;
        }
        JSCompiler_inline_result && (console.error("The provided key is an unsupported type %s. This value must be coerced to a string before using it here.", "function" === typeof Symbol && Symbol.toStringTag && key[Symbol.toStringTag] || key.constructor.name || "Object"), testStringCoercion(key));
        return {
            $$typeof: REACT_PORTAL_TYPE,
            key: null == key ? null : "" + key,
            children: children,
            containerInfo: containerInfo,
            implementation: implementation
        };
    }
    function getCrossOriginStringAs(as, input) {
        if ("font" === as) return "";
        if ("string" === typeof input) return "use-credentials" === input ? input : "";
    }
    function getValueDescriptorExpectingObjectForWarning(thing) {
        return null === thing ? "`null`" : void 0 === thing ? "`undefined`" : "" === thing ? "an empty string" : 'something with type "' + typeof thing + '"';
    }
    function getValueDescriptorExpectingEnumForWarning(thing) {
        return null === thing ? "`null`" : void 0 === thing ? "`undefined`" : "" === thing ? "an empty string" : "string" === typeof thing ? JSON.stringify(thing) : "number" === typeof thing ? "`" + thing + "`" : 'something with type "' + typeof thing + '"';
    }
    function resolveDispatcher() {
        var dispatcher = ReactSharedInternals.H;
        null === dispatcher && console.error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.");
        return dispatcher;
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var React = (parcelRequire("acw62")), Internals = {
        d: {
            f: noop,
            r: function() {
                throw Error("Invalid form element. requestFormReset must be passed a form that was rendered by React.");
            },
            D: noop,
            C: noop,
            L: noop,
            m: noop,
            X: noop,
            S: noop,
            M: noop
        },
        p: 0,
        findDOMNode: null
    }, REACT_PORTAL_TYPE = Symbol.for("react.portal"), ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
    "function" === typeof Map && null != Map.prototype && "function" === typeof Map.prototype.forEach && "function" === typeof Set && null != Set.prototype && "function" === typeof Set.prototype.clear && "function" === typeof Set.prototype.forEach || console.error("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    $2956e04298bc31b1$export$69ce8ef3fe5cead0 = Internals;
    $2956e04298bc31b1$export$d39a5bbd09211389 = function(children, container) {
        var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
        if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error("Target container is not a DOM element.");
        return createPortal$1(children, container, null, key);
    };
    $2956e04298bc31b1$export$cd75ccfd720a3cd4 = function(fn) {
        var previousTransition = ReactSharedInternals.T, previousUpdatePriority = Internals.p;
        try {
            if (ReactSharedInternals.T = null, Internals.p = 2, fn) return fn();
        } finally{
            ReactSharedInternals.T = previousTransition, Internals.p = previousUpdatePriority, Internals.d.f() && console.error("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task.");
        }
    };
    $2956e04298bc31b1$export$a0816fa17a9e79be = function(href, options) {
        "string" === typeof href && href ? null != options && "object" !== typeof options ? console.error("ReactDOM.preconnect(): Expected the `options` argument (second) to be an object but encountered %s instead. The only supported option at this time is `crossOrigin` which accepts a string.", getValueDescriptorExpectingEnumForWarning(options)) : null != options && "string" !== typeof options.crossOrigin && console.error("ReactDOM.preconnect(): Expected the `crossOrigin` option (second argument) to be a string but encountered %s instead. Try removing this option or passing a string value instead.", getValueDescriptorExpectingObjectForWarning(options.crossOrigin)) : console.error("ReactDOM.preconnect(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.", getValueDescriptorExpectingObjectForWarning(href));
        "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, Internals.d.C(href, options));
    };
    $2956e04298bc31b1$export$7292efcadded39f3 = function(href) {
        if ("string" !== typeof href || !href) console.error("ReactDOM.prefetchDNS(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.", getValueDescriptorExpectingObjectForWarning(href));
        else if (1 < arguments.length) {
            var options = arguments[1];
            "object" === typeof options && options.hasOwnProperty("crossOrigin") ? console.error("ReactDOM.prefetchDNS(): Expected only one argument, `href`, but encountered %s as a second argument instead. This argument is reserved for future options and is currently disallowed. It looks like the you are attempting to set a crossOrigin property for this DNS lookup hint. Browsers do not perform DNS queries using CORS and setting this attribute on the resource hint has no effect. Try calling ReactDOM.prefetchDNS() with just a single string argument, `href`.", getValueDescriptorExpectingEnumForWarning(options)) : console.error("ReactDOM.prefetchDNS(): Expected only one argument, `href`, but encountered %s as a second argument instead. This argument is reserved for future options and is currently disallowed. Try calling ReactDOM.prefetchDNS() with just a single string argument, `href`.", getValueDescriptorExpectingEnumForWarning(options));
        }
        "string" === typeof href && Internals.d.D(href);
    };
    $2956e04298bc31b1$export$da407abadb9b8f86 = function(href, options) {
        "string" === typeof href && href ? null == options || "object" !== typeof options ? console.error("ReactDOM.preinit(): Expected the `options` argument (second) to be an object with an `as` property describing the type of resource to be preinitialized but encountered %s instead.", getValueDescriptorExpectingEnumForWarning(options)) : "style" !== options.as && "script" !== options.as && console.error('ReactDOM.preinit(): Expected the `as` property in the `options` argument (second) to contain a valid value describing the type of resource to be preinitialized but encountered %s instead. Valid values for `as` are "style" and "script".', getValueDescriptorExpectingEnumForWarning(options.as)) : console.error("ReactDOM.preinit(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.", getValueDescriptorExpectingObjectForWarning(href));
        if ("string" === typeof href && options && "string" === typeof options.as) {
            var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
            "style" === as ? Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
                crossOrigin: crossOrigin,
                integrity: integrity,
                fetchPriority: fetchPriority
            }) : "script" === as && Internals.d.X(href, {
                crossOrigin: crossOrigin,
                integrity: integrity,
                fetchPriority: fetchPriority,
                nonce: "string" === typeof options.nonce ? options.nonce : void 0
            });
        }
    };
    $2956e04298bc31b1$export$314cfea32580671c = function(href, options) {
        var encountered = "";
        "string" === typeof href && href || (encountered += " The `href` argument encountered was " + getValueDescriptorExpectingObjectForWarning(href) + ".");
        void 0 !== options && "object" !== typeof options ? encountered += " The `options` argument encountered was " + getValueDescriptorExpectingObjectForWarning(options) + "." : options && "as" in options && "script" !== options.as && (encountered += " The `as` option encountered was " + getValueDescriptorExpectingEnumForWarning(options.as) + ".");
        if (encountered) console.error("ReactDOM.preinitModule(): Expected up to two arguments, a non-empty `href` string and, optionally, an `options` object with a valid `as` property.%s", encountered);
        else switch(encountered = options && "string" === typeof options.as ? options.as : "script", encountered){
            case "script":
                break;
            default:
                encountered = getValueDescriptorExpectingEnumForWarning(encountered), console.error('ReactDOM.preinitModule(): Currently the only supported "as" type for this function is "script" but received "%s" instead. This warning was generated for `href` "%s". In the future other module types will be supported, aligning with the import-attributes proposal. Learn more here: (https://github.com/tc39/proposal-import-attributes)', encountered, href);
        }
        if ("string" === typeof href) {
            if ("object" === typeof options && null !== options) {
                if (null == options.as || "script" === options.as) encountered = getCrossOriginStringAs(options.as, options.crossOrigin), Internals.d.M(href, {
                    crossOrigin: encountered,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            } else null == options && Internals.d.M(href);
        }
    };
    $2956e04298bc31b1$export$513ccb98c53b8039 = function(href, options) {
        var encountered = "";
        "string" === typeof href && href || (encountered += " The `href` argument encountered was " + getValueDescriptorExpectingObjectForWarning(href) + ".");
        null == options || "object" !== typeof options ? encountered += " The `options` argument encountered was " + getValueDescriptorExpectingObjectForWarning(options) + "." : "string" === typeof options.as && options.as || (encountered += " The `as` option encountered was " + getValueDescriptorExpectingObjectForWarning(options.as) + ".");
        encountered && console.error('ReactDOM.preload(): Expected two arguments, a non-empty `href` string and an `options` object with an `as` property valid for a `<link rel="preload" as="..." />` tag.%s', encountered);
        if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
            encountered = options.as;
            var crossOrigin = getCrossOriginStringAs(encountered, options.crossOrigin);
            Internals.d.L(href, encountered, {
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                type: "string" === typeof options.type ? options.type : void 0,
                fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
                referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
                imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
                imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
                media: "string" === typeof options.media ? options.media : void 0
            });
        }
    };
    $2956e04298bc31b1$export$dbca993bc2d264a = function(href, options) {
        var encountered = "";
        "string" === typeof href && href || (encountered += " The `href` argument encountered was " + getValueDescriptorExpectingObjectForWarning(href) + ".");
        void 0 !== options && "object" !== typeof options ? encountered += " The `options` argument encountered was " + getValueDescriptorExpectingObjectForWarning(options) + "." : options && "as" in options && "string" !== typeof options.as && (encountered += " The `as` option encountered was " + getValueDescriptorExpectingObjectForWarning(options.as) + ".");
        encountered && console.error('ReactDOM.preloadModule(): Expected two arguments, a non-empty `href` string and, optionally, an `options` object with an `as` property valid for a `<link rel="modulepreload" as="..." />` tag.%s', encountered);
        "string" === typeof href && (options ? (encountered = getCrossOriginStringAs(options.as, options.crossOrigin), Internals.d.m(href, {
            as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
            crossOrigin: encountered,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0
        })) : Internals.d.m(href));
    };
    $2956e04298bc31b1$export$4797a8006f0655d0 = function(form) {
        Internals.d.r(form);
    };
    $2956e04298bc31b1$export$c78a37762a8d58e1 = function(fn, a) {
        return fn(a);
    };
    $2956e04298bc31b1$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
        return resolveDispatcher().useFormState(action, initialState, permalink);
    };
    $2956e04298bc31b1$export$f7e8a0bf92324b1e = function() {
        return resolveDispatcher().useHostTransitionStatus();
    };
    $2956e04298bc31b1$export$83d89fbfd8236492 = "19.2.3";
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
})();

});



parcelRegister("gd942", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcd4e42ca4163639$export$2e2bcd8739ae039);

var $9ffXE = parcelRequire("9ffXE");
// eslint-disable-next-line no-undef
var $bcd4e42ca4163639$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $bcd4e42ca4163639$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $9ffXE.default)(function(prop) {
    return $bcd4e42ca4163639$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});
parcelRegister("9ffXE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bb1e54ce1bc6efa$export$2e2bcd8739ae039);
function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("bknYF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Field", {
    enumerable: true,
    get: function get() {
        return $83f42963f197707d$var$_field["default"];
    }
});
Object.defineProperty(module.exports, "Control", {
    enumerable: true,
    get: function get() {
        return $83f42963f197707d$var$_control["default"];
    }
});
Object.defineProperty(module.exports, "Input", {
    enumerable: true,
    get: function get() {
        return $83f42963f197707d$var$_input["default"];
    }
});
Object.defineProperty(module.exports, "Label", {
    enumerable: true,
    get: function get() {
        return $83f42963f197707d$var$_label["default"];
    }
});
Object.defineProperty(module.exports, "Textarea", {
    enumerable: true,
    get: function get() {
        return $83f42963f197707d$var$_textarea["default"];
    }
});
Object.defineProperty(module.exports, "Select", {
    enumerable: true,
    get: function get() {
        return $83f42963f197707d$var$_select["default"];
    }
});
Object.defineProperty(module.exports, "Checkbox", {
    enumerable: true,
    get: function get() {
        return $83f42963f197707d$var$_checkbox["default"];
    }
});
Object.defineProperty(module.exports, "Radio", {
    enumerable: true,
    get: function get() {
        return $83f42963f197707d$var$_radio["default"];
    }
});
Object.defineProperty(module.exports, "Help", {
    enumerable: true,
    get: function get() {
        return $83f42963f197707d$var$_help["default"];
    }
});
Object.defineProperty(module.exports, "InputFile", {
    enumerable: true,
    get: function get() {
        return $83f42963f197707d$var$_inputFile["default"];
    }
});

var $83f42963f197707d$var$_field = $83f42963f197707d$var$_interopRequireDefault((parcelRequire("kCvkP")));

var $83f42963f197707d$var$_control = $83f42963f197707d$var$_interopRequireDefault((parcelRequire("8JUN1")));

var $83f42963f197707d$var$_input = $83f42963f197707d$var$_interopRequireDefault((parcelRequire("a67Qy")));

var $83f42963f197707d$var$_label = $83f42963f197707d$var$_interopRequireDefault((parcelRequire("49EnD")));

var $83f42963f197707d$var$_textarea = $83f42963f197707d$var$_interopRequireDefault((parcelRequire("8Ubxd")));

var $83f42963f197707d$var$_select = $83f42963f197707d$var$_interopRequireDefault((parcelRequire("1dCpp")));

var $83f42963f197707d$var$_checkbox = $83f42963f197707d$var$_interopRequireDefault((parcelRequire("2nHG2")));

var $83f42963f197707d$var$_radio = $83f42963f197707d$var$_interopRequireDefault((parcelRequire("iApg7")));

var $83f42963f197707d$var$_help = $83f42963f197707d$var$_interopRequireDefault((parcelRequire("jRzQB")));

var $83f42963f197707d$var$_inputFile = $83f42963f197707d$var$_interopRequireDefault((parcelRequire("lqmWk")));
function $83f42963f197707d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

});
parcelRegister("kCvkP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function get() {
        return $f02fa9bf27f41503$var$_field["default"];
    }
});

var $f02fa9bf27f41503$var$_field = $f02fa9bf27f41503$var$_interopRequireDefault((parcelRequire("9AFsB")));
function $f02fa9bf27f41503$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

});
parcelRegister("9AFsB", function(module, exports) {
"use strict";
function $6fb7a2fdcefa7624$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $6fb7a2fdcefa7624$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $6fb7a2fdcefa7624$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $6fb7a2fdcefa7624$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $6fb7a2fdcefa7624$var$_react = $6fb7a2fdcefa7624$var$_interopRequireDefault((parcelRequire("acw62")));

var $6fb7a2fdcefa7624$var$_propTypes = $6fb7a2fdcefa7624$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $6fb7a2fdcefa7624$var$_classnames2 = $6fb7a2fdcefa7624$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $6fb7a2fdcefa7624$var$_fieldLabel = $6fb7a2fdcefa7624$var$_interopRequireDefault((parcelRequire("cndiD")));

var $6fb7a2fdcefa7624$var$_fieldBody = $6fb7a2fdcefa7624$var$_interopRequireDefault((parcelRequire("ayiKt")));

var $6fb7a2fdcefa7624$var$_element = $6fb7a2fdcefa7624$var$_interopRequireDefault((parcelRequire("9rI5f")));

var $R5V3X = parcelRequire("R5V3X");

var $6fb7a2fdcefa7624$var$_context = $6fb7a2fdcefa7624$var$_interopRequireWildcard((parcelRequire("1cqxb")));
function $6fb7a2fdcefa7624$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $6fb7a2fdcefa7624$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $6fb7a2fdcefa7624$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || $6fb7a2fdcefa7624$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $6fb7a2fdcefa7624$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $6fb7a2fdcefa7624$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $6fb7a2fdcefa7624$var$_extends() {
    $6fb7a2fdcefa7624$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6fb7a2fdcefa7624$var$_extends.apply(this, arguments);
}
function $6fb7a2fdcefa7624$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6fb7a2fdcefa7624$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6fb7a2fdcefa7624$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $6fb7a2fdcefa7624$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $6fb7a2fdcefa7624$var$Field = function Field(_ref) {
    var _classnames;
    var className = _ref.className, align = _ref.align, multiline = _ref.multiline, horizontal = _ref.horizontal, kind = _ref.kind, size = _ref.size, props = $6fb7a2fdcefa7624$var$_objectWithoutProperties(_ref, [
        "className",
        "align",
        "multiline",
        "horizontal",
        "kind",
        "size"
    ]);
    var context = (0, $6fb7a2fdcefa7624$var$_context["default"])();
    var k = null;
    if (kind === 'addons') k = 'has-addons';
    else if (kind === 'group') k = 'is-grouped';
    return /*#__PURE__*/ $6fb7a2fdcefa7624$var$_react["default"].createElement($6fb7a2fdcefa7624$var$_context.FieldContext.Provider, {
        value: {
            size: size || context.size
        }
    }, /*#__PURE__*/ $6fb7a2fdcefa7624$var$_react["default"].createElement($6fb7a2fdcefa7624$var$_element["default"], $6fb7a2fdcefa7624$var$_extends({}, props, {
        className: (0, $6fb7a2fdcefa7624$var$_classnames2["default"])('field', className, (_classnames = {}, $6fb7a2fdcefa7624$var$_defineProperty(_classnames, "".concat(k), k), $6fb7a2fdcefa7624$var$_defineProperty(_classnames, "".concat(k, "-").concat((0, $R5V3X.normalizeAlign)(align)), k === 'is-grouped' && align), $6fb7a2fdcefa7624$var$_defineProperty(_classnames, "".concat(k, "-multiline"), k === 'is-grouped' && multiline), $6fb7a2fdcefa7624$var$_defineProperty(_classnames, 'is-horizontal', horizontal), _classnames))
    })));
};
$6fb7a2fdcefa7624$var$Field.Label = $6fb7a2fdcefa7624$var$_fieldLabel["default"];
$6fb7a2fdcefa7624$var$Field.Body = $6fb7a2fdcefa7624$var$_fieldBody["default"];
$6fb7a2fdcefa7624$var$Field.defaultProps = {};
var $6fb7a2fdcefa7624$var$_default = $6fb7a2fdcefa7624$var$Field;
module.exports["default"] = $6fb7a2fdcefa7624$var$_default;

});
parcelRegister("c9Z8w", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $k8nJx = parcelRequire("k8nJx");
// By explicitly using `prop-types` you are opting into new development behavior.
// http://fb.me/prop-types-in-prod
var $8da5bfbbed271cd7$var$throwOnDirectAccess = true;

module.exports = (parcelRequire("eGxWZ"))($k8nJx.isElement, $8da5bfbbed271cd7$var$throwOnDirectAccess);

});
parcelRegister("k8nJx", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9XjZK"));

});
parcelRegister("9XjZK", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $73f922543d406108$export$2b8d127b894957b9, (v) => $73f922543d406108$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $73f922543d406108$export$cea3a54a6425200c, (v) => $73f922543d406108$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $73f922543d406108$export$a7c73072b1a182ae, (v) => $73f922543d406108$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $73f922543d406108$export$9f27bc3417b4524d, (v) => $73f922543d406108$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $73f922543d406108$export$db77ccec0bb4ccac, (v) => $73f922543d406108$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $73f922543d406108$export$8392c0c9d3dcbd35, (v) => $73f922543d406108$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $73f922543d406108$export$ffb0004e005737fa, (v) => $73f922543d406108$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $73f922543d406108$export$b624eff549462981, (v) => $73f922543d406108$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $73f922543d406108$export$7897aa7841a5380c, (v) => $73f922543d406108$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $73f922543d406108$export$602eac185826482c, (v) => $73f922543d406108$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $73f922543d406108$export$e2c29f18771995cb, (v) => $73f922543d406108$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $73f922543d406108$export$5f8d39834fd61797, (v) => $73f922543d406108$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $73f922543d406108$export$74bf444e3cd11ea5, (v) => $73f922543d406108$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $73f922543d406108$export$92387174baf9b227, (v) => $73f922543d406108$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $73f922543d406108$export$ec112efeb987d9c6, (v) => $73f922543d406108$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $73f922543d406108$export$b706b080d889d2c9, (v) => $73f922543d406108$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $73f922543d406108$export$5be5a87408f70ddc, (v) => $73f922543d406108$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $73f922543d406108$export$45a5e7f76e0caa8d, (v) => $73f922543d406108$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $73f922543d406108$export$455c2e768291efa6, (v) => $73f922543d406108$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $73f922543d406108$export$9522e17588c12572, (v) => $73f922543d406108$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $73f922543d406108$export$2110ac352bb060b9, (v) => $73f922543d406108$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $73f922543d406108$export$56885ab8b9c456ab, (v) => $73f922543d406108$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $73f922543d406108$export$d927fcb6adf8f9de, (v) => $73f922543d406108$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $73f922543d406108$export$b82d16f27459e05a, (v) => $73f922543d406108$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $73f922543d406108$export$522c17b4f5e123e8, (v) => $73f922543d406108$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $73f922543d406108$export$1aabd8a0274ecfd6, (v) => $73f922543d406108$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $73f922543d406108$export$9b621391a187a31a, (v) => $73f922543d406108$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $73f922543d406108$export$f5bbd400c2f4426f, (v) => $73f922543d406108$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $73f922543d406108$export$2b8d127b894957b9;
var $73f922543d406108$export$cea3a54a6425200c;
var $73f922543d406108$export$a7c73072b1a182ae;
var $73f922543d406108$export$9f27bc3417b4524d;
var $73f922543d406108$export$db77ccec0bb4ccac;
var $73f922543d406108$export$8392c0c9d3dcbd35;
var $73f922543d406108$export$ffb0004e005737fa;
var $73f922543d406108$export$b624eff549462981;
var $73f922543d406108$export$7897aa7841a5380c;
var $73f922543d406108$export$602eac185826482c;
var $73f922543d406108$export$e2c29f18771995cb;
var $73f922543d406108$export$5f8d39834fd61797;
var $73f922543d406108$export$74bf444e3cd11ea5;
var $73f922543d406108$export$92387174baf9b227;
var $73f922543d406108$export$ec112efeb987d9c6;
var $73f922543d406108$export$b706b080d889d2c9;
var $73f922543d406108$export$5be5a87408f70ddc;
var $73f922543d406108$export$45a5e7f76e0caa8d;
var $73f922543d406108$export$455c2e768291efa6;
var $73f922543d406108$export$9522e17588c12572;
var $73f922543d406108$export$2110ac352bb060b9;
var $73f922543d406108$export$56885ab8b9c456ab;
var $73f922543d406108$export$d927fcb6adf8f9de;
var $73f922543d406108$export$b82d16f27459e05a;
var $73f922543d406108$export$522c17b4f5e123e8;
var $73f922543d406108$export$1aabd8a0274ecfd6;
var $73f922543d406108$export$9b621391a187a31a;
var $73f922543d406108$export$f5bbd400c2f4426f;
'use strict';
(function() {
    'use strict';
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === 'function' && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?
    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
    function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }
    function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_ASYNC_MODE_TYPE:
                        case REACT_CONCURRENT_MODE_TYPE:
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    } // AsyncMode is deprecated along with isAsyncMode
    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console['warn']("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }
    function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    $73f922543d406108$export$2b8d127b894957b9 = AsyncMode;
    $73f922543d406108$export$cea3a54a6425200c = ConcurrentMode;
    $73f922543d406108$export$a7c73072b1a182ae = ContextConsumer;
    $73f922543d406108$export$9f27bc3417b4524d = ContextProvider;
    $73f922543d406108$export$db77ccec0bb4ccac = Element;
    $73f922543d406108$export$8392c0c9d3dcbd35 = ForwardRef;
    $73f922543d406108$export$ffb0004e005737fa = Fragment;
    $73f922543d406108$export$b624eff549462981 = Lazy;
    $73f922543d406108$export$7897aa7841a5380c = Memo;
    $73f922543d406108$export$602eac185826482c = Portal;
    $73f922543d406108$export$e2c29f18771995cb = Profiler;
    $73f922543d406108$export$5f8d39834fd61797 = StrictMode;
    $73f922543d406108$export$74bf444e3cd11ea5 = Suspense;
    $73f922543d406108$export$92387174baf9b227 = isAsyncMode;
    $73f922543d406108$export$ec112efeb987d9c6 = isConcurrentMode;
    $73f922543d406108$export$b706b080d889d2c9 = isContextConsumer;
    $73f922543d406108$export$5be5a87408f70ddc = isContextProvider;
    $73f922543d406108$export$45a5e7f76e0caa8d = isElement;
    $73f922543d406108$export$455c2e768291efa6 = isForwardRef;
    $73f922543d406108$export$9522e17588c12572 = isFragment;
    $73f922543d406108$export$2110ac352bb060b9 = isLazy;
    $73f922543d406108$export$56885ab8b9c456ab = isMemo;
    $73f922543d406108$export$d927fcb6adf8f9de = isPortal;
    $73f922543d406108$export$b82d16f27459e05a = isProfiler;
    $73f922543d406108$export$522c17b4f5e123e8 = isStrictMode;
    $73f922543d406108$export$1aabd8a0274ecfd6 = isSuspense;
    $73f922543d406108$export$9b621391a187a31a = isValidElementType;
    $73f922543d406108$export$f5bbd400c2f4426f = typeOf;
})();

});


parcelRegister("eGxWZ", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $k8nJx = parcelRequire("k8nJx");

var $8coUR = parcelRequire("8coUR");

var $kZO5c = parcelRequire("kZO5c");

var $fQsEq = parcelRequire("fQsEq");

var $gwROR = parcelRequire("gwROR");
var $ab0f52c9db6f842e$var$printWarning = function() {};
$ab0f52c9db6f842e$var$printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
};
function $ab0f52c9db6f842e$var$emptyFunctionThatReturnsNull() {
    return null;
}
module.exports = function(isValidElement, throwOnDirectAccess) {
    /* global Symbol */ var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
    /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */ function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === 'function') return iteratorFn;
    }
    /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */ var ANONYMOUS = '<<anonymous>>';
    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
        array: createPrimitiveTypeChecker('array'),
        bigint: createPrimitiveTypeChecker('bigint'),
        bool: createPrimitiveTypeChecker('boolean'),
        func: createPrimitiveTypeChecker('function'),
        number: createPrimitiveTypeChecker('number'),
        object: createPrimitiveTypeChecker('object'),
        string: createPrimitiveTypeChecker('string'),
        symbol: createPrimitiveTypeChecker('symbol'),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
    };
    /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */ /*eslint-disable no-self-compare*/ function is(x, y) {
        // SameValue algorithm
        if (x === y) // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
        else // Step 6.a: NaN == NaN
        return x !== x && y !== y;
    }
    /*eslint-enable no-self-compare*/ /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */ function PropTypeError(message, data) {
        this.message = message;
        this.data = data && typeof data === 'object' ? data : {};
        this.stack = '';
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
            componentName = componentName || ANONYMOUS;
            propFullName = propFullName || propName;
            if (secret !== $kZO5c) {
                if (throwOnDirectAccess) {
                    // New behavior only for users of `prop-types` package
                    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                    err.name = 'Invariant Violation';
                    throw err;
                } else if (typeof console !== 'undefined') {
                    // Old behavior for people using React.PropTypes
                    var cacheKey = componentName + ':' + propName;
                    if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
                    manualPropTypeWarningCount < 3) {
                        $ab0f52c9db6f842e$var$printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
                        manualPropTypeCallCache[cacheKey] = true;
                        manualPropTypeWarningCount++;
                    }
                }
            }
            if (props[propName] == null) {
                if (isRequired) {
                    if (props[propName] === null) return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
                    return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
                }
                return null;
            } else return validate(props, propName, componentName, location, propFullName);
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== expectedType) {
                // `propValue` being instance of, say, date/regexp, pass the 'object'
                // check, but we can offer a more precise error message here rather than
                // 'of type `object`'.
                var preciseType = getPreciseType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
                    expectedType: expectedType
                });
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
        return createChainableTypeChecker($ab0f52c9db6f842e$var$emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== 'function') return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
            var propValue = props[propName];
            if (!Array.isArray(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
            }
            for(var i = 0; i < propValue.length; i++){
                var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', $kZO5c);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!isValidElement(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!$k8nJx.isValidElementType(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
            if (!(props[propName] instanceof expectedClass)) {
                var expectedClassName = expectedClass.name || ANONYMOUS;
                var actualClassName = getClassName(props[propName]);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
            {
                if (arguments.length > 1) $ab0f52c9db6f842e$var$printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
                else $ab0f52c9db6f842e$var$printWarning('Invalid argument supplied to oneOf, expected an array.');
            }
            return $ab0f52c9db6f842e$var$emptyFunctionThatReturnsNull;
        }
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            for(var i = 0; i < expectedValues.length; i++){
                if (is(propValue, expectedValues[i])) return null;
            }
            var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
                var type = getPreciseType(value);
                if (type === 'symbol') return String(value);
                return value;
            });
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
        }
        return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== 'function') return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
            for(var key in propValue)if ($fQsEq(propValue, key)) {
                var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, $kZO5c);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
            $ab0f52c9db6f842e$var$printWarning('Invalid argument supplied to oneOfType, expected an instance of array.');
            return $ab0f52c9db6f842e$var$emptyFunctionThatReturnsNull;
        }
        for(var i = 0; i < arrayOfTypeCheckers.length; i++){
            var checker = arrayOfTypeCheckers[i];
            if (typeof checker !== 'function') {
                $ab0f52c9db6f842e$var$printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
                return $ab0f52c9db6f842e$var$emptyFunctionThatReturnsNull;
            }
        }
        function validate(props, propName, componentName, location, propFullName) {
            var expectedTypes = [];
            for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                var checker = arrayOfTypeCheckers[i];
                var checkerResult = checker(props, propName, componentName, location, propFullName, $kZO5c);
                if (checkerResult == null) return null;
                if (checkerResult.data && $fQsEq(checkerResult.data, 'expectedType')) expectedTypes.push(checkerResult.data.expectedType);
            }
            var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
        }
        return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            if (!isNode(props[propName])) return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
        return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
    }
    function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
            for(var key in shapeTypes){
                var checker = shapeTypes[key];
                if (typeof checker !== 'function') return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, $kZO5c);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
            // We need to check all keys in case some are required but missing from props.
            var allKeys = $8coUR({}, props[propName], shapeTypes);
            for(var key in allKeys){
                var checker = shapeTypes[key];
                if ($fQsEq(shapeTypes, key) && typeof checker !== 'function') return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                if (!checker) return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, $kZO5c);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
        switch(typeof propValue){
            case 'number':
            case 'string':
            case 'undefined':
                return true;
            case 'boolean':
                return !propValue;
            case 'object':
                if (Array.isArray(propValue)) return propValue.every(isNode);
                if (propValue === null || isValidElement(propValue)) return true;
                var iteratorFn = getIteratorFn(propValue);
                if (iteratorFn) {
                    var iterator = iteratorFn.call(propValue);
                    var step;
                    if (iteratorFn !== propValue.entries) while(!(step = iterator.next()).done){
                        if (!isNode(step.value)) return false;
                    }
                    else // Iterator will provide entry [k,v] tuples rather than values.
                    while(!(step = iterator.next()).done){
                        var entry = step.value;
                        if (entry) {
                            if (!isNode(entry[1])) return false;
                        }
                    }
                } else return false;
                return true;
            default:
                return false;
        }
    }
    function isSymbol(propType, propValue) {
        // Native Symbol.
        if (propType === 'symbol') return true;
        // falsy value can't be a Symbol
        if (!propValue) return false;
        // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
        if (propValue['@@toStringTag'] === 'Symbol') return true;
        // Fallback for non-spec compliant Symbols which are polyfilled.
        if (typeof Symbol === 'function' && propValue instanceof Symbol) return true;
        return false;
    }
    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) return 'array';
        if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return 'object';
        if (isSymbol(propType, propValue)) return 'symbol';
        return propType;
    }
    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
        if (typeof propValue === 'undefined' || propValue === null) return '' + propValue;
        var propType = getPropType(propValue);
        if (propType === 'object') {
            if (propValue instanceof Date) return 'date';
            else if (propValue instanceof RegExp) return 'regexp';
        }
        return propType;
    }
    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch(type){
            case 'array':
            case 'object':
                return 'an ' + type;
            case 'boolean':
            case 'date':
            case 'regexp':
                return 'a ' + type;
            default:
                return type;
        }
    }
    // Returns class name of the object, if any.
    function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) return ANONYMOUS;
        return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = $gwROR;
    ReactPropTypes.resetWarningCache = $gwROR.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("8coUR", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $5f82c58e3d599bd6$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $5f82c58e3d599bd6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $5f82c58e3d599bd6$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $5f82c58e3d599bd6$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $5f82c58e3d599bd6$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $5f82c58e3d599bd6$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $5f82c58e3d599bd6$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($5f82c58e3d599bd6$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($5f82c58e3d599bd6$var$getOwnPropertySymbols) {
            symbols = $5f82c58e3d599bd6$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($5f82c58e3d599bd6$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $f4905a8b274aa381$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});

parcelRegister("fQsEq", function(module, exports) {
module.exports = Function.call.bind(Object.prototype.hasOwnProperty);

});

parcelRegister("gwROR", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $c08961ea4c03f601$var$printWarning = function() {};

var $kZO5c = parcelRequire("kZO5c");
var $c08961ea4c03f601$var$loggedTypeFailures = {};

var $fQsEq = parcelRequire("fQsEq");
$c08961ea4c03f601$var$printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
};
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */ function $c08961ea4c03f601$var$checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    for(var typeSpecName in typeSpecs)if ($fQsEq(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
            // This is intentionally an invariant that gets caught. It's the same
            // behavior as without this statement except with a better message.
            if (typeof typeSpecs[typeSpecName] !== 'function') {
                var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                err.name = 'Invariant Violation';
                throw err;
            }
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, $kZO5c);
        } catch (ex) {
            error = ex;
        }
        if (error && !(error instanceof Error)) $c08961ea4c03f601$var$printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        if (error instanceof Error && !(error.message in $c08961ea4c03f601$var$loggedTypeFailures)) {
            // Only monitor this failure once because there tends to be a lot of the
            // same error.
            $c08961ea4c03f601$var$loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : '';
            $c08961ea4c03f601$var$printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
    }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */ $c08961ea4c03f601$var$checkPropTypes.resetWarningCache = function() {
    $c08961ea4c03f601$var$loggedTypeFailures = {};
};
module.exports = $c08961ea4c03f601$var$checkPropTypes;

});



parcelRegister("8g1PZ", function(module, exports) {
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === 'string' || argType === 'number') classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === 'object') {
                if (arg.toString === Object.prototype.toString) {
                    for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
                } else classes.push(arg.toString());
            }
        }
        return classes.join(' ');
    }
    if (module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("cndiD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $9021f30a405919a0$var$_react = $9021f30a405919a0$var$_interopRequireDefault((parcelRequire("acw62")));

var $9021f30a405919a0$var$_propTypes = $9021f30a405919a0$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $9021f30a405919a0$var$_classnames2 = $9021f30a405919a0$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $9021f30a405919a0$var$_element = $9021f30a405919a0$var$_interopRequireDefault((parcelRequire("9rI5f")));

var $9021f30a405919a0$var$_context = $9021f30a405919a0$var$_interopRequireDefault((parcelRequire("1cqxb")));
function $9021f30a405919a0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $9021f30a405919a0$var$_extends() {
    $9021f30a405919a0$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9021f30a405919a0$var$_extends.apply(this, arguments);
}
function $9021f30a405919a0$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9021f30a405919a0$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $9021f30a405919a0$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $9021f30a405919a0$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $9021f30a405919a0$var$FieldLabel = function FieldLabel(_ref) {
    var className = _ref.className, size = _ref.size, props = $9021f30a405919a0$var$_objectWithoutProperties(_ref, [
        "className",
        "size"
    ]);
    var context = (0, $9021f30a405919a0$var$_context["default"])();
    return /*#__PURE__*/ $9021f30a405919a0$var$_react["default"].createElement($9021f30a405919a0$var$_element["default"], $9021f30a405919a0$var$_extends({}, props, {
        className: (0, $9021f30a405919a0$var$_classnames2["default"])('field-label', className, $9021f30a405919a0$var$_defineProperty({}, "is-".concat(size), size || context.size))
    }));
};
$9021f30a405919a0$var$FieldLabel.defaultProps = {};
var $9021f30a405919a0$var$_default = $9021f30a405919a0$var$FieldLabel;
module.exports["default"] = $9021f30a405919a0$var$_default;

});
parcelRegister("9rI5f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $6e08d4c6d5b3cc03$var$_element = $6e08d4c6d5b3cc03$var$_interopRequireDefault((parcelRequire("1Y63H")));
function $6e08d4c6d5b3cc03$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $6e08d4c6d5b3cc03$var$_default = $6e08d4c6d5b3cc03$var$_element["default"];
module.exports["default"] = $6e08d4c6d5b3cc03$var$_default;

});
parcelRegister("1Y63H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.useElementClassNames = void 0;

var $16f01826619a0222$var$_react = $16f01826619a0222$var$_interopRequireDefault((parcelRequire("acw62")));

var $16f01826619a0222$var$_propTypes = $16f01826619a0222$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $16f01826619a0222$var$_classnames3 = $16f01826619a0222$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $R5V3X = parcelRequire("R5V3X");
function $16f01826619a0222$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $16f01826619a0222$var$_extends() {
    $16f01826619a0222$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $16f01826619a0222$var$_extends.apply(this, arguments);
}
function $16f01826619a0222$var$_slicedToArray(arr, i) {
    return $16f01826619a0222$var$_arrayWithHoles(arr) || $16f01826619a0222$var$_iterableToArrayLimit(arr, i) || $16f01826619a0222$var$_unsupportedIterableToArray(arr, i) || $16f01826619a0222$var$_nonIterableRest();
}
function $16f01826619a0222$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $16f01826619a0222$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $16f01826619a0222$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $16f01826619a0222$var$_arrayLikeToArray(o, minLen);
}
function $16f01826619a0222$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $16f01826619a0222$var$_iterableToArrayLimit(arr, i) {
    var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $16f01826619a0222$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $16f01826619a0222$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $16f01826619a0222$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $16f01826619a0222$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $16f01826619a0222$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $16f01826619a0222$var$buildResponsiveness = function buildResponsiveness(currentViewport) {
    var _classnames;
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, display = _ref.display, textAlign = _ref.textAlign, textSize = _ref.textSize, only = _ref.only, invisible = _ref.invisible;
    var suffix = only ? '-only' : '';
    return (0, $16f01826619a0222$var$_classnames3["default"])((_classnames = {}, $16f01826619a0222$var$_defineProperty(_classnames, "is-".concat(display, "-").concat(currentViewport).concat(suffix), display), $16f01826619a0222$var$_defineProperty(_classnames, "has-text-".concat((0, $R5V3X.normalizeAlign)(textAlign), "-").concat(currentViewport).concat(suffix), textAlign), $16f01826619a0222$var$_defineProperty(_classnames, "is-size-".concat(textSize, "-").concat(currentViewport).concat(suffix), textSize), $16f01826619a0222$var$_defineProperty(_classnames, "is-invisible-".concat(currentViewport).concat(suffix), invisible), _classnames));
};
var $16f01826619a0222$var$useElementClassNames = function useElementClassNames(_ref2) {
    var _classnames2;
    var textColor = _ref2.textColor, backgroundColor = _ref2.backgroundColor, colorVariant = _ref2.colorVariant, flexDirection = _ref2.flexDirection, flexWrap = _ref2.flexWrap, justifyContent = _ref2.justifyContent, alignContent = _ref2.alignContent, alignItems = _ref2.alignItems, flexGrow = _ref2.flexGrow, ratio = _ref2.ratio, clearfix = _ref2.clearfix, paddingless = _ref2.paddingless, pull = _ref2.pull, marginless = _ref2.marginless, overlay = _ref2.overlay, clipped = _ref2.clipped, radiusless = _ref2.radiusless, shadowless = _ref2.shadowless, unselectable = _ref2.unselectable, invisible = _ref2.invisible, clickable = _ref2.clickable, srOnly = _ref2.srOnly, display = _ref2.display, m = _ref2.m, mt = _ref2.mt, mr = _ref2.mr, mb = _ref2.mb, ml = _ref2.ml, mx = _ref2.mx, my = _ref2.my, p = _ref2.p, pt = _ref2.pt, pr = _ref2.pr, pb = _ref2.pb, pl = _ref2.pl, px = _ref2.px, py = _ref2.py, textWeight = _ref2.textWeight, textTransform = _ref2.textTransform, italic = _ref2.italic, textSize = _ref2.textSize, textAlign = _ref2.textAlign, textFamily = _ref2.textFamily, mobile = _ref2.mobile, tablet = _ref2.tablet, desktop = _ref2.desktop, widescreen = _ref2.widescreen, fullhd = _ref2.fullhd, touch = _ref2.touch, untilWidescreen = _ref2.untilWidescreen, untilFullhd = _ref2.untilFullhd, props = $16f01826619a0222$var$_objectWithoutProperties(_ref2, [
        "textColor",
        "backgroundColor",
        "colorVariant",
        "flexDirection",
        "flexWrap",
        "justifyContent",
        "alignContent",
        "alignItems",
        "flexGrow",
        "ratio",
        "clearfix",
        "paddingless",
        "pull",
        "marginless",
        "overlay",
        "clipped",
        "radiusless",
        "shadowless",
        "unselectable",
        "invisible",
        "clickable",
        "srOnly",
        "display",
        "m",
        "mt",
        "mr",
        "mb",
        "ml",
        "mx",
        "my",
        "p",
        "pt",
        "pr",
        "pb",
        "pl",
        "px",
        "py",
        "textWeight",
        "textTransform",
        "italic",
        "textSize",
        "textAlign",
        "textFamily",
        "mobile",
        "tablet",
        "desktop",
        "widescreen",
        "fullhd",
        "touch",
        "untilWidescreen",
        "untilFullhd"
    ]);
    return [
        (0, $16f01826619a0222$var$_classnames3["default"])((_classnames2 = {}, $16f01826619a0222$var$_defineProperty(_classnames2, "has-text-".concat(textColor), textColor), $16f01826619a0222$var$_defineProperty(_classnames2, "has-background-".concat(backgroundColor), backgroundColor), $16f01826619a0222$var$_defineProperty(_classnames2, "is-".concat(colorVariant), colorVariant), $16f01826619a0222$var$_defineProperty(_classnames2, "is-flex-direction-".concat(flexDirection), flexDirection), $16f01826619a0222$var$_defineProperty(_classnames2, "is-flex-wrap-".concat(flexWrap), flexWrap), $16f01826619a0222$var$_defineProperty(_classnames2, "is-justify-content-".concat(justifyContent), justifyContent), $16f01826619a0222$var$_defineProperty(_classnames2, "is-align-content-".concat(alignContent), alignContent), $16f01826619a0222$var$_defineProperty(_classnames2, "is-align-items-".concat(alignItems), alignItems), $16f01826619a0222$var$_defineProperty(_classnames2, "is-flex-grow-".concat(flexGrow), flexGrow), $16f01826619a0222$var$_defineProperty(_classnames2, 'is-clearfix', clearfix), $16f01826619a0222$var$_defineProperty(_classnames2, "is-pulled-".concat(pull), pull), $16f01826619a0222$var$_defineProperty(_classnames2, 'is-marginless', marginless), $16f01826619a0222$var$_defineProperty(_classnames2, 'is-paddingless', paddingless), $16f01826619a0222$var$_defineProperty(_classnames2, 'is-overlay', overlay), $16f01826619a0222$var$_defineProperty(_classnames2, 'is-clipped', clipped), $16f01826619a0222$var$_defineProperty(_classnames2, 'is-radiusless', radiusless), $16f01826619a0222$var$_defineProperty(_classnames2, 'is-shadowless', shadowless), $16f01826619a0222$var$_defineProperty(_classnames2, 'is-unselectable', unselectable), $16f01826619a0222$var$_defineProperty(_classnames2, "is-".concat(display), display), $16f01826619a0222$var$_defineProperty(_classnames2, 'is-invisible', invisible), $16f01826619a0222$var$_defineProperty(_classnames2, 'is-sr-only', srOnly), $16f01826619a0222$var$_defineProperty(_classnames2, 'is-clickable', clickable), $16f01826619a0222$var$_defineProperty(_classnames2, "m-".concat(m), m), $16f01826619a0222$var$_defineProperty(_classnames2, "mt-".concat(mt), mt), $16f01826619a0222$var$_defineProperty(_classnames2, "mr-".concat(mr), mr), $16f01826619a0222$var$_defineProperty(_classnames2, "mb-".concat(mb), mb), $16f01826619a0222$var$_defineProperty(_classnames2, "ml-".concat(ml), ml), $16f01826619a0222$var$_defineProperty(_classnames2, "mx-".concat(mx), mx), $16f01826619a0222$var$_defineProperty(_classnames2, "my-".concat(my), my), $16f01826619a0222$var$_defineProperty(_classnames2, "p-".concat(p), p), $16f01826619a0222$var$_defineProperty(_classnames2, "pt-".concat(pt), pt), $16f01826619a0222$var$_defineProperty(_classnames2, "pr-".concat(pr), pr), $16f01826619a0222$var$_defineProperty(_classnames2, "pb-".concat(pb), pb), $16f01826619a0222$var$_defineProperty(_classnames2, "pl-".concat(pl), pl), $16f01826619a0222$var$_defineProperty(_classnames2, "px-".concat(px), px), $16f01826619a0222$var$_defineProperty(_classnames2, "py-".concat(py), py), $16f01826619a0222$var$_defineProperty(_classnames2, "has-text-".concat((0, $R5V3X.normalizeAlign)(textAlign)), textAlign), $16f01826619a0222$var$_defineProperty(_classnames2, "has-text-weight-".concat(textWeight), textWeight), $16f01826619a0222$var$_defineProperty(_classnames2, "is-size-".concat(textSize), textSize), $16f01826619a0222$var$_defineProperty(_classnames2, "is-".concat(textTransform), textTransform), $16f01826619a0222$var$_defineProperty(_classnames2, "is-family-".concat(textFamily), textFamily), $16f01826619a0222$var$_defineProperty(_classnames2, 'is-italic', italic), _classnames2), $16f01826619a0222$var$buildResponsiveness('mobile', mobile), $16f01826619a0222$var$buildResponsiveness('tablet', tablet), $16f01826619a0222$var$buildResponsiveness('desktop', desktop), $16f01826619a0222$var$buildResponsiveness('widescreen', widescreen), $16f01826619a0222$var$buildResponsiveness('fullhd', fullhd), $16f01826619a0222$var$buildResponsiveness('touch', touch), $16f01826619a0222$var$buildResponsiveness('until-widescreen', untilWidescreen), $16f01826619a0222$var$buildResponsiveness('until-fullhd', untilFullhd)),
        props
    ];
};
module.exports.useElementClassNames = $16f01826619a0222$var$useElementClassNames;
var $16f01826619a0222$var$Element = function Element(_ref3) {
    var className = _ref3.className, renderAs = _ref3.renderAs, domRef = _ref3.domRef, children = _ref3.children, allProps = $16f01826619a0222$var$_objectWithoutProperties(_ref3, [
        "className",
        "renderAs",
        "domRef",
        "children"
    ]);
    var RenderAs = renderAs;
    var _useElementClassNames = $16f01826619a0222$var$useElementClassNames(allProps), _useElementClassNames2 = $16f01826619a0222$var$_slicedToArray(_useElementClassNames, 2), classNames = _useElementClassNames2[0], props = _useElementClassNames2[1];
    return /*#__PURE__*/ $16f01826619a0222$var$_react["default"].createElement(RenderAs, $16f01826619a0222$var$_extends({
        ref: domRef,
        className: (0, $16f01826619a0222$var$_classnames3["default"])(className, classNames) || undefined
    }, props), children);
};
$16f01826619a0222$var$Element.defaultProps = {
    renderAs: 'div'
};
var $16f01826619a0222$var$_default = $16f01826619a0222$var$Element;
module.exports["default"] = $16f01826619a0222$var$_default;

});
parcelRegister("R5V3X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.normalizeStatus = module.exports.normalizeAlign = void 0;
var $09f98ad0b8e22377$var$normalizeAlign = function normalizeAlign(align) {
    var map = {
        justify: 'justifyed',
        center: 'centered'
    };
    return map[align] || align;
};
module.exports.normalizeAlign = $09f98ad0b8e22377$var$normalizeAlign;
var $09f98ad0b8e22377$var$normalizeStatus = function normalizeStatus(status) {
    var map = {
        focus: 'focused',
        hover: 'hovered',
        active: 'active'
    };
    return map[status] || status;
};
module.exports.normalizeStatus = $09f98ad0b8e22377$var$normalizeStatus;

});



parcelRegister("1cqxb", function(module, exports) {
"use strict";
function $0dfb7e96ce4ee13d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $0dfb7e96ce4ee13d$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $0dfb7e96ce4ee13d$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $0dfb7e96ce4ee13d$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.FieldContext = void 0;

var $0dfb7e96ce4ee13d$var$_react = $0dfb7e96ce4ee13d$var$_interopRequireWildcard((parcelRequire("acw62")));
function $0dfb7e96ce4ee13d$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $0dfb7e96ce4ee13d$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $0dfb7e96ce4ee13d$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || $0dfb7e96ce4ee13d$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $0dfb7e96ce4ee13d$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $0dfb7e96ce4ee13d$var$FieldContext = /*#__PURE__*/ $0dfb7e96ce4ee13d$var$_react["default"].createContext({
    size: undefined
});
module.exports.FieldContext = $0dfb7e96ce4ee13d$var$FieldContext;
var $0dfb7e96ce4ee13d$var$useFieldContext = function useFieldContext() {
    return (0, $0dfb7e96ce4ee13d$var$_react.useContext)($0dfb7e96ce4ee13d$var$FieldContext);
};
var $0dfb7e96ce4ee13d$var$_default = $0dfb7e96ce4ee13d$var$useFieldContext;
module.exports["default"] = $0dfb7e96ce4ee13d$var$_default;

});


parcelRegister("ayiKt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $7aeb9f74caf06c69$var$_react = $7aeb9f74caf06c69$var$_interopRequireDefault((parcelRequire("acw62")));

var $7aeb9f74caf06c69$var$_classnames = $7aeb9f74caf06c69$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $7aeb9f74caf06c69$var$_element = $7aeb9f74caf06c69$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $7aeb9f74caf06c69$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $7aeb9f74caf06c69$var$_extends() {
    $7aeb9f74caf06c69$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7aeb9f74caf06c69$var$_extends.apply(this, arguments);
}
function $7aeb9f74caf06c69$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $7aeb9f74caf06c69$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $7aeb9f74caf06c69$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $7aeb9f74caf06c69$var$FieldBody = function FieldBody(_ref) {
    var children = _ref.children, className = _ref.className, props = $7aeb9f74caf06c69$var$_objectWithoutProperties(_ref, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ $7aeb9f74caf06c69$var$_react["default"].createElement($7aeb9f74caf06c69$var$_element["default"], $7aeb9f74caf06c69$var$_extends({}, props, {
        className: (0, $7aeb9f74caf06c69$var$_classnames["default"])('field-body', className, {})
    }), children);
};
$7aeb9f74caf06c69$var$FieldBody.defaultProps = {};
var $7aeb9f74caf06c69$var$_default = $7aeb9f74caf06c69$var$FieldBody;
module.exports["default"] = $7aeb9f74caf06c69$var$_default;

});



parcelRegister("8JUN1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $65ce93f8a198e15c$var$_react = $65ce93f8a198e15c$var$_interopRequireDefault((parcelRequire("acw62")));

var $65ce93f8a198e15c$var$_propTypes = $65ce93f8a198e15c$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $65ce93f8a198e15c$var$_classnames = $65ce93f8a198e15c$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $65ce93f8a198e15c$var$_element = $65ce93f8a198e15c$var$_interopRequireDefault((parcelRequire("9rI5f")));

var $65ce93f8a198e15c$var$_icon = $65ce93f8a198e15c$var$_interopRequireDefault((parcelRequire("jlNIA")));

var $65ce93f8a198e15c$var$_context = $65ce93f8a198e15c$var$_interopRequireDefault((parcelRequire("1cqxb")));

var $65ce93f8a198e15c$var$_button = $65ce93f8a198e15c$var$_interopRequireDefault((parcelRequire("dcCpL")));
function $65ce93f8a198e15c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $65ce93f8a198e15c$var$_extends() {
    $65ce93f8a198e15c$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $65ce93f8a198e15c$var$_extends.apply(this, arguments);
}
function $65ce93f8a198e15c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $65ce93f8a198e15c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $65ce93f8a198e15c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $65ce93f8a198e15c$var$Control = function Control(_ref) {
    var children = _ref.children, className = _ref.className, fullwidth = _ref.fullwidth, loading = _ref.loading, iconType = _ref.iconType, props = $65ce93f8a198e15c$var$_objectWithoutProperties(_ref, [
        "children",
        "className",
        "fullwidth",
        "loading",
        "iconType"
    ]);
    var context = (0, $65ce93f8a198e15c$var$_context["default"])();
    var isIcon = function isIcon(child) {
        return child.type === (iconType || $65ce93f8a198e15c$var$_icon["default"]) && (child.props.align === 'left' || child.props.align === 'right');
    };
    var updatedChildren = $65ce93f8a198e15c$var$_react["default"].Children.map(children, function(child) {
        if (!child || !isIcon(child) && child.type !== $65ce93f8a198e15c$var$_button["default"]) return child;
        return /*#__PURE__*/ $65ce93f8a198e15c$var$_react["default"].cloneElement(child, {
            size: child.props.size || context.size
        });
    });
    var icons = $65ce93f8a198e15c$var$_react["default"].Children.toArray(updatedChildren).filter(isIcon).reduce(function(acc, icon) {
        return {
            iconLeft: acc.iconLeft || icon.props.align === 'left',
            iconRight: acc.iconRight || icon.props.align === 'right'
        };
    }, {
        iconLeft: false,
        iconRight: false
    });
    return /*#__PURE__*/ $65ce93f8a198e15c$var$_react["default"].createElement($65ce93f8a198e15c$var$_element["default"], $65ce93f8a198e15c$var$_extends({}, props, {
        className: (0, $65ce93f8a198e15c$var$_classnames["default"])('control', className, {
            'is-expanded': fullwidth,
            'has-icons-left': icons.iconLeft,
            'has-icons-right': icons.iconRight,
            'is-loading': loading
        })
    }), updatedChildren);
};
$65ce93f8a198e15c$var$Control.defaultProps = {};
var $65ce93f8a198e15c$var$_default = $65ce93f8a198e15c$var$Control;
module.exports["default"] = $65ce93f8a198e15c$var$_default;

});
parcelRegister("jlNIA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $e1668b765034b0fb$var$_icon = $e1668b765034b0fb$var$_interopRequireDefault((parcelRequire("3aHB0")));
function $e1668b765034b0fb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $e1668b765034b0fb$var$_default = $e1668b765034b0fb$var$_icon["default"];
module.exports["default"] = $e1668b765034b0fb$var$_default;

});
parcelRegister("3aHB0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $24f41f7b68c3274f$var$_react = $24f41f7b68c3274f$var$_interopRequireDefault((parcelRequire("acw62")));

var $24f41f7b68c3274f$var$_propTypes = $24f41f7b68c3274f$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $24f41f7b68c3274f$var$_classnames2 = $24f41f7b68c3274f$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $24f41f7b68c3274f$var$_text = $24f41f7b68c3274f$var$_interopRequireDefault((parcelRequire("751VQ")));

var $24f41f7b68c3274f$var$_element = $24f41f7b68c3274f$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $24f41f7b68c3274f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $24f41f7b68c3274f$var$_extends() {
    $24f41f7b68c3274f$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $24f41f7b68c3274f$var$_extends.apply(this, arguments);
}
function $24f41f7b68c3274f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $24f41f7b68c3274f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $24f41f7b68c3274f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $24f41f7b68c3274f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $24f41f7b68c3274f$var$Icon = function Icon(_ref) {
    var _classnames;
    var size = _ref.size, color = _ref.color, className = _ref.className, align = _ref.align, text = _ref.text, props = $24f41f7b68c3274f$var$_objectWithoutProperties(_ref, [
        "size",
        "color",
        "className",
        "align",
        "text"
    ]);
    if (text !== undefined) console.warn('[Deprecation] Text prop for Icon Component its deprecated, please use Icon.Text Component instead');
    return /*#__PURE__*/ $24f41f7b68c3274f$var$_react["default"].createElement($24f41f7b68c3274f$var$_element["default"], $24f41f7b68c3274f$var$_extends({}, props, {
        className: (0, $24f41f7b68c3274f$var$_classnames2["default"])(className, (_classnames = {
            icon: !text
        }, $24f41f7b68c3274f$var$_defineProperty(_classnames, "is-".concat(size), size), $24f41f7b68c3274f$var$_defineProperty(_classnames, "is-".concat(align), align), $24f41f7b68c3274f$var$_defineProperty(_classnames, "has-text-".concat(color), color), $24f41f7b68c3274f$var$_defineProperty(_classnames, 'icon-text', text), _classnames))
    }));
};
$24f41f7b68c3274f$var$Icon.defaultProps = {
    renderAs: 'span'
};
$24f41f7b68c3274f$var$Icon.Text = $24f41f7b68c3274f$var$_text["default"];
var $24f41f7b68c3274f$var$_default = $24f41f7b68c3274f$var$Icon;
module.exports["default"] = $24f41f7b68c3274f$var$_default;

});
parcelRegister("751VQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $527a7fa8a7fa487f$var$_text = $527a7fa8a7fa487f$var$_interopRequireDefault((parcelRequire("5TCUT")));
function $527a7fa8a7fa487f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $527a7fa8a7fa487f$var$_default = $527a7fa8a7fa487f$var$_text["default"];
module.exports["default"] = $527a7fa8a7fa487f$var$_default;

});
parcelRegister("5TCUT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $44b046d69058ffed$var$_react = $44b046d69058ffed$var$_interopRequireDefault((parcelRequire("acw62")));

var $44b046d69058ffed$var$_propTypes = $44b046d69058ffed$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $44b046d69058ffed$var$_classnames = $44b046d69058ffed$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $44b046d69058ffed$var$_element = $44b046d69058ffed$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $44b046d69058ffed$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $44b046d69058ffed$var$_extends() {
    $44b046d69058ffed$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $44b046d69058ffed$var$_extends.apply(this, arguments);
}
function $44b046d69058ffed$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $44b046d69058ffed$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $44b046d69058ffed$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $44b046d69058ffed$var$Text = function Text(_ref) {
    var className = _ref.className, props = $44b046d69058ffed$var$_objectWithoutProperties(_ref, [
        "className"
    ]);
    return /*#__PURE__*/ $44b046d69058ffed$var$_react["default"].createElement($44b046d69058ffed$var$_element["default"], $44b046d69058ffed$var$_extends({
        className: (0, $44b046d69058ffed$var$_classnames["default"])('icon-text', className)
    }, props));
};
$44b046d69058ffed$var$Text.defaultProps = {
    renderAs: 'span'
};
var $44b046d69058ffed$var$_default = $44b046d69058ffed$var$Text;
module.exports["default"] = $44b046d69058ffed$var$_default;

});




parcelRegister("dcCpL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $99ca31b06edccacd$var$_button = $99ca31b06edccacd$var$_interopRequireDefault((parcelRequire("fK8h6")));
function $99ca31b06edccacd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $99ca31b06edccacd$var$_default = $99ca31b06edccacd$var$_button["default"];
module.exports["default"] = $99ca31b06edccacd$var$_default;

});
parcelRegister("fK8h6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $b761921679c41ff1$var$_react = $b761921679c41ff1$var$_interopRequireDefault((parcelRequire("acw62")));

var $b761921679c41ff1$var$_propTypes = $b761921679c41ff1$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $b761921679c41ff1$var$_classnames2 = $b761921679c41ff1$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $b761921679c41ff1$var$_buttonGroup = $b761921679c41ff1$var$_interopRequireDefault((parcelRequire("6OJ4T")));

var $b761921679c41ff1$var$_element = $b761921679c41ff1$var$_interopRequireDefault((parcelRequire("9rI5f")));

var $R5V3X = parcelRequire("R5V3X");
function $b761921679c41ff1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $b761921679c41ff1$var$_extends() {
    $b761921679c41ff1$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b761921679c41ff1$var$_extends.apply(this, arguments);
}
function $b761921679c41ff1$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b761921679c41ff1$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b761921679c41ff1$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $b761921679c41ff1$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $b761921679c41ff1$var$Button = function Button(_ref) {
    var _classnames;
    var children = _ref.children, className = _ref.className, renderAs = _ref.renderAs, color = _ref.color, size = _ref.size, outlined = _ref.outlined, inverted = _ref.inverted, submit = _ref.submit, reset = _ref.reset, fullwidth = _ref.fullwidth, status = _ref.status, loading = _ref.loading, disabled = _ref.disabled, remove = _ref.remove, isSelected = _ref.isSelected, isStatic = _ref.isStatic, rounded = _ref.rounded, onClick = _ref.onClick, text = _ref.text, props = $b761921679c41ff1$var$_objectWithoutProperties(_ref, [
        "children",
        "className",
        "renderAs",
        "color",
        "size",
        "outlined",
        "inverted",
        "submit",
        "reset",
        "fullwidth",
        "status",
        "loading",
        "disabled",
        "remove",
        "isSelected",
        "isStatic",
        "rounded",
        "onClick",
        "text"
    ]);
    var otherProps = {};
    if (submit) otherProps = {
        type: 'submit',
        renderAs: 'button'
    };
    if (reset) otherProps = {
        type: 'reset',
        renderAs: 'button'
    };
    if (isStatic) otherProps = {
        renderAs: 'span'
    };
    return /*#__PURE__*/ $b761921679c41ff1$var$_react["default"].createElement($b761921679c41ff1$var$_element["default"], $b761921679c41ff1$var$_extends({
        tabIndex: disabled ? -1 : 0,
        renderAs: renderAs
    }, props, otherProps, {
        disabled: disabled,
        onClick: disabled ? undefined : onClick,
        className: (0, $b761921679c41ff1$var$_classnames2["default"])(className, (_classnames = {}, $b761921679c41ff1$var$_defineProperty(_classnames, "is-".concat(color), color), $b761921679c41ff1$var$_defineProperty(_classnames, "is-".concat(size), size), $b761921679c41ff1$var$_defineProperty(_classnames, 'is-selected', isSelected), $b761921679c41ff1$var$_defineProperty(_classnames, 'is-static', isStatic), $b761921679c41ff1$var$_defineProperty(_classnames, 'is-rounded', rounded), $b761921679c41ff1$var$_defineProperty(_classnames, 'is-outlined', outlined), $b761921679c41ff1$var$_defineProperty(_classnames, 'is-inverted', inverted), $b761921679c41ff1$var$_defineProperty(_classnames, 'is-fullwidth', fullwidth), $b761921679c41ff1$var$_defineProperty(_classnames, "is-".concat((0, $R5V3X.normalizeStatus)(status)), status), $b761921679c41ff1$var$_defineProperty(_classnames, 'is-loading', loading), $b761921679c41ff1$var$_defineProperty(_classnames, 'is-text', text), $b761921679c41ff1$var$_defineProperty(_classnames, "delete", remove), $b761921679c41ff1$var$_defineProperty(_classnames, "button", !remove), _classnames))
    }), children);
};
$b761921679c41ff1$var$Button.Group = $b761921679c41ff1$var$_buttonGroup["default"];
$b761921679c41ff1$var$Button.defaultProps = {
    renderAs: 'button'
};
var $b761921679c41ff1$var$_default = $b761921679c41ff1$var$Button;
module.exports["default"] = $b761921679c41ff1$var$_default;

});
parcelRegister("6OJ4T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $4f6a612385b6a567$var$_react = $4f6a612385b6a567$var$_interopRequireDefault((parcelRequire("acw62")));

var $4f6a612385b6a567$var$_propTypes = $4f6a612385b6a567$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $4f6a612385b6a567$var$_classnames2 = $4f6a612385b6a567$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $4f6a612385b6a567$var$_element = $4f6a612385b6a567$var$_interopRequireDefault((parcelRequire("9rI5f")));

var $R5V3X = parcelRequire("R5V3X");
function $4f6a612385b6a567$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $4f6a612385b6a567$var$_extends() {
    $4f6a612385b6a567$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4f6a612385b6a567$var$_extends.apply(this, arguments);
}
function $4f6a612385b6a567$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4f6a612385b6a567$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $4f6a612385b6a567$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $4f6a612385b6a567$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $4f6a612385b6a567$var$ButtonGroup = function ButtonGroup(_ref) {
    var _classnames;
    var className = _ref.className, hasAddons = _ref.hasAddons, align = _ref.align, size = _ref.size, props = $4f6a612385b6a567$var$_objectWithoutProperties(_ref, [
        "className",
        "hasAddons",
        "align",
        "size"
    ]);
    return /*#__PURE__*/ $4f6a612385b6a567$var$_react["default"].createElement($4f6a612385b6a567$var$_element["default"], $4f6a612385b6a567$var$_extends({}, props, {
        className: (0, $4f6a612385b6a567$var$_classnames2["default"])('buttons', className, (_classnames = {
            'has-addons': hasAddons
        }, $4f6a612385b6a567$var$_defineProperty(_classnames, "is-".concat([
            (0, $R5V3X.normalizeAlign)(align)
        ]), align), $4f6a612385b6a567$var$_defineProperty(_classnames, "are-".concat(size), size), _classnames))
    }));
};
$4f6a612385b6a567$var$ButtonGroup.defaultProps = {
    renderAs: 'div'
};
var $4f6a612385b6a567$var$_default = $4f6a612385b6a567$var$ButtonGroup;
module.exports["default"] = $4f6a612385b6a567$var$_default;

});




parcelRegister("a67Qy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $75a08d205f150658$var$_react = $75a08d205f150658$var$_interopRequireDefault((parcelRequire("acw62")));

var $75a08d205f150658$var$_propTypes = $75a08d205f150658$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $75a08d205f150658$var$_classnames2 = $75a08d205f150658$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $75a08d205f150658$var$_element = $75a08d205f150658$var$_interopRequireDefault((parcelRequire("9rI5f")));

var $75a08d205f150658$var$_context = $75a08d205f150658$var$_interopRequireDefault((parcelRequire("1cqxb")));

var $R5V3X = parcelRequire("R5V3X");
function $75a08d205f150658$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $75a08d205f150658$var$_extends() {
    $75a08d205f150658$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $75a08d205f150658$var$_extends.apply(this, arguments);
}
function $75a08d205f150658$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $75a08d205f150658$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $75a08d205f150658$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $75a08d205f150658$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $75a08d205f150658$var$Input = function Input(_ref) {
    var _classnames;
    var className = _ref.className, size = _ref.size, color = _ref.color, readOnly = _ref.readOnly, isStatic = _ref.isStatic, status = _ref.status, rounded = _ref.rounded, props = $75a08d205f150658$var$_objectWithoutProperties(_ref, [
        "className",
        "size",
        "color",
        "readOnly",
        "isStatic",
        "status",
        "rounded"
    ]);
    var context = (0, $75a08d205f150658$var$_context["default"])();
    var calculatedSize = size || context.size;
    return /*#__PURE__*/ $75a08d205f150658$var$_react["default"].createElement($75a08d205f150658$var$_element["default"], $75a08d205f150658$var$_extends({}, props, {
        readOnly: readOnly || isStatic,
        className: (0, $75a08d205f150658$var$_classnames2["default"])('input', className, (_classnames = {
            'is-static': isStatic
        }, $75a08d205f150658$var$_defineProperty(_classnames, "is-".concat((0, $R5V3X.normalizeStatus)(status)), status), $75a08d205f150658$var$_defineProperty(_classnames, 'is-rounded', rounded), $75a08d205f150658$var$_defineProperty(_classnames, "is-".concat(calculatedSize), calculatedSize), $75a08d205f150658$var$_defineProperty(_classnames, "is-".concat(color), color), _classnames))
    }));
};
$75a08d205f150658$var$Input.defaultProps = {
    renderAs: 'input'
};
var $75a08d205f150658$var$_default = $75a08d205f150658$var$Input;
module.exports["default"] = $75a08d205f150658$var$_default;

});

parcelRegister("49EnD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $306753604ea7fd4a$var$_react = $306753604ea7fd4a$var$_interopRequireDefault((parcelRequire("acw62")));

var $306753604ea7fd4a$var$_propTypes = $306753604ea7fd4a$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $306753604ea7fd4a$var$_classnames2 = $306753604ea7fd4a$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $306753604ea7fd4a$var$_element = $306753604ea7fd4a$var$_interopRequireDefault((parcelRequire("9rI5f")));

var $306753604ea7fd4a$var$_context = $306753604ea7fd4a$var$_interopRequireDefault((parcelRequire("1cqxb")));
function $306753604ea7fd4a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $306753604ea7fd4a$var$_extends() {
    $306753604ea7fd4a$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $306753604ea7fd4a$var$_extends.apply(this, arguments);
}
function $306753604ea7fd4a$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $306753604ea7fd4a$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $306753604ea7fd4a$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $306753604ea7fd4a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $306753604ea7fd4a$var$Label = function Label(_ref) {
    var children = _ref.children, className = _ref.className, size = _ref.size, props = $306753604ea7fd4a$var$_objectWithoutProperties(_ref, [
        "children",
        "className",
        "size"
    ]);
    var context = (0, $306753604ea7fd4a$var$_context["default"])();
    var calculatedSize = size || context.size;
    return /*#__PURE__*/ $306753604ea7fd4a$var$_react["default"].createElement($306753604ea7fd4a$var$_element["default"], $306753604ea7fd4a$var$_extends({}, props, {
        className: (0, $306753604ea7fd4a$var$_classnames2["default"])('label', className, $306753604ea7fd4a$var$_defineProperty({}, "is-".concat(calculatedSize), calculatedSize))
    }), children);
};
$306753604ea7fd4a$var$Label.defaultProps = {
    renderAs: 'label'
};
var $306753604ea7fd4a$var$_default = $306753604ea7fd4a$var$Label;
module.exports["default"] = $306753604ea7fd4a$var$_default;

});

parcelRegister("8Ubxd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $67bc80423195e765$var$_react = $67bc80423195e765$var$_interopRequireDefault((parcelRequire("acw62")));

var $67bc80423195e765$var$_propTypes = $67bc80423195e765$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $67bc80423195e765$var$_classnames2 = $67bc80423195e765$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $67bc80423195e765$var$_element = $67bc80423195e765$var$_interopRequireDefault((parcelRequire("9rI5f")));

var $67bc80423195e765$var$_context = $67bc80423195e765$var$_interopRequireDefault((parcelRequire("1cqxb")));

var $R5V3X = parcelRequire("R5V3X");
function $67bc80423195e765$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $67bc80423195e765$var$_extends() {
    $67bc80423195e765$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $67bc80423195e765$var$_extends.apply(this, arguments);
}
function $67bc80423195e765$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $67bc80423195e765$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $67bc80423195e765$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $67bc80423195e765$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $67bc80423195e765$var$Textarea = function Textarea(_ref) {
    var _classnames;
    var className = _ref.className, size = _ref.size, color = _ref.color, status = _ref.status, fixedSize = _ref.fixedSize, props = $67bc80423195e765$var$_objectWithoutProperties(_ref, [
        "className",
        "size",
        "color",
        "status",
        "fixedSize"
    ]);
    var context = (0, $67bc80423195e765$var$_context["default"])();
    var calculatedSize = size || context.size;
    return /*#__PURE__*/ $67bc80423195e765$var$_react["default"].createElement($67bc80423195e765$var$_element["default"], $67bc80423195e765$var$_extends({}, props, {
        className: (0, $67bc80423195e765$var$_classnames2["default"])('textarea', className, (_classnames = {}, $67bc80423195e765$var$_defineProperty(_classnames, "is-".concat((0, $R5V3X.normalizeStatus)(status)), status), $67bc80423195e765$var$_defineProperty(_classnames, 'has-fixed-size', fixedSize), $67bc80423195e765$var$_defineProperty(_classnames, "is-".concat(calculatedSize), calculatedSize), $67bc80423195e765$var$_defineProperty(_classnames, "is-".concat(color), color), _classnames))
    }));
};
$67bc80423195e765$var$Textarea.defaultProps = {
    renderAs: 'textarea'
};
var $67bc80423195e765$var$_default = $67bc80423195e765$var$Textarea;
module.exports["default"] = $67bc80423195e765$var$_default;

});

parcelRegister("1dCpp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $0e34cc8eee562b47$var$_react = $0e34cc8eee562b47$var$_interopRequireDefault((parcelRequire("acw62")));

var $0e34cc8eee562b47$var$_propTypes = $0e34cc8eee562b47$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $0e34cc8eee562b47$var$_classnames3 = $0e34cc8eee562b47$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $0e34cc8eee562b47$var$_element = $0e34cc8eee562b47$var$_interopRequireDefault((parcelRequire("9rI5f")));

var $0e34cc8eee562b47$var$_context = $0e34cc8eee562b47$var$_interopRequireDefault((parcelRequire("1cqxb")));

var $R5V3X = parcelRequire("R5V3X");
function $0e34cc8eee562b47$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $0e34cc8eee562b47$var$_extends() {
    $0e34cc8eee562b47$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0e34cc8eee562b47$var$_extends.apply(this, arguments);
}
function $0e34cc8eee562b47$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0e34cc8eee562b47$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $0e34cc8eee562b47$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $0e34cc8eee562b47$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $0e34cc8eee562b47$var$Select = function Select(_ref) {
    var _classnames;
    var className = _ref.className, rounded = _ref.rounded, style = _ref.style, size = _ref.size, color = _ref.color, loading = _ref.loading, status = _ref.status, disabled = _ref.disabled, value = _ref.value, multiple = _ref.multiple, children = _ref.children, name = _ref.name, domRef = _ref.domRef, fullwidth = _ref.fullwidth, props = $0e34cc8eee562b47$var$_objectWithoutProperties(_ref, [
        "className",
        "rounded",
        "style",
        "size",
        "color",
        "loading",
        "status",
        "disabled",
        "value",
        "multiple",
        "children",
        "name",
        "domRef",
        "fullwidth"
    ]);
    var context = (0, $0e34cc8eee562b47$var$_context["default"])();
    var calculatedSize = size || context.size;
    return /*#__PURE__*/ $0e34cc8eee562b47$var$_react["default"].createElement($0e34cc8eee562b47$var$_element["default"], {
        domRef: domRef,
        className: (0, $0e34cc8eee562b47$var$_classnames3["default"])('select', className, (_classnames = {}, $0e34cc8eee562b47$var$_defineProperty(_classnames, "is-".concat(calculatedSize), calculatedSize), $0e34cc8eee562b47$var$_defineProperty(_classnames, "is-".concat(color), color), $0e34cc8eee562b47$var$_defineProperty(_classnames, 'is-fullwidth', fullwidth), $0e34cc8eee562b47$var$_defineProperty(_classnames, 'is-loading', loading), $0e34cc8eee562b47$var$_defineProperty(_classnames, 'is-multiple', multiple), $0e34cc8eee562b47$var$_defineProperty(_classnames, 'is-rounded', rounded), _classnames)),
        style: style
    }, /*#__PURE__*/ $0e34cc8eee562b47$var$_react["default"].createElement($0e34cc8eee562b47$var$_element["default"], $0e34cc8eee562b47$var$_extends({}, props, {
        className: (0, $0e34cc8eee562b47$var$_classnames3["default"])($0e34cc8eee562b47$var$_defineProperty({}, "is-".concat((0, $R5V3X.normalizeStatus)(status)), status)),
        multiple: multiple,
        value: value,
        disabled: disabled,
        name: name
    }), children));
};
$0e34cc8eee562b47$var$Select.defaultProps = {
    renderAs: 'select'
};
var $0e34cc8eee562b47$var$_default = $0e34cc8eee562b47$var$Select;
module.exports["default"] = $0e34cc8eee562b47$var$_default;

});

parcelRegister("2nHG2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $1bbf9c1f0abcbec0$var$_react = $1bbf9c1f0abcbec0$var$_interopRequireDefault((parcelRequire("acw62")));

var $1bbf9c1f0abcbec0$var$_propTypes = $1bbf9c1f0abcbec0$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $1bbf9c1f0abcbec0$var$_classnames = $1bbf9c1f0abcbec0$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $1bbf9c1f0abcbec0$var$_element = $1bbf9c1f0abcbec0$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $1bbf9c1f0abcbec0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $1bbf9c1f0abcbec0$var$_extends() {
    $1bbf9c1f0abcbec0$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1bbf9c1f0abcbec0$var$_extends.apply(this, arguments);
}
function $1bbf9c1f0abcbec0$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $1bbf9c1f0abcbec0$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $1bbf9c1f0abcbec0$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $1bbf9c1f0abcbec0$var$Checkbox = function Checkbox(_ref) {
    var className = _ref.className, style = _ref.style, disabled = _ref.disabled, children = _ref.children, domRef = _ref.domRef, props = $1bbf9c1f0abcbec0$var$_objectWithoutProperties(_ref, [
        "className",
        "style",
        "disabled",
        "children",
        "domRef"
    ]);
    return /*#__PURE__*/ $1bbf9c1f0abcbec0$var$_react["default"].createElement($1bbf9c1f0abcbec0$var$_element["default"], {
        renderAs: "label",
        domRef: domRef,
        disabled: disabled,
        className: (0, $1bbf9c1f0abcbec0$var$_classnames["default"])('checkbox', className),
        style: style
    }, /*#__PURE__*/ $1bbf9c1f0abcbec0$var$_react["default"].createElement($1bbf9c1f0abcbec0$var$_element["default"], $1bbf9c1f0abcbec0$var$_extends({
        type: "checkbox",
        disabled: disabled
    }, props)), " ", children);
};
$1bbf9c1f0abcbec0$var$Checkbox.defaultProps = {
    renderAs: 'input'
};
var $1bbf9c1f0abcbec0$var$_default = $1bbf9c1f0abcbec0$var$Checkbox;
module.exports["default"] = $1bbf9c1f0abcbec0$var$_default;

});

parcelRegister("iApg7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $d87f2eb0e1cd93f7$var$_react = $d87f2eb0e1cd93f7$var$_interopRequireDefault((parcelRequire("acw62")));

var $d87f2eb0e1cd93f7$var$_propTypes = $d87f2eb0e1cd93f7$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $d87f2eb0e1cd93f7$var$_classnames = $d87f2eb0e1cd93f7$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $d87f2eb0e1cd93f7$var$_element = $d87f2eb0e1cd93f7$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $d87f2eb0e1cd93f7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $d87f2eb0e1cd93f7$var$_extends() {
    $d87f2eb0e1cd93f7$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d87f2eb0e1cd93f7$var$_extends.apply(this, arguments);
}
function $d87f2eb0e1cd93f7$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d87f2eb0e1cd93f7$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d87f2eb0e1cd93f7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $d87f2eb0e1cd93f7$var$Radio = function Radio(_ref) {
    var className = _ref.className, style = _ref.style, disabled = _ref.disabled, checked = _ref.checked, value = _ref.value, name = _ref.name, children = _ref.children, domRef = _ref.domRef, props = $d87f2eb0e1cd93f7$var$_objectWithoutProperties(_ref, [
        "className",
        "style",
        "disabled",
        "checked",
        "value",
        "name",
        "children",
        "domRef"
    ]);
    return /*#__PURE__*/ $d87f2eb0e1cd93f7$var$_react["default"].createElement($d87f2eb0e1cd93f7$var$_element["default"], {
        renderAs: "label",
        domRef: domRef,
        disabled: disabled,
        className: (0, $d87f2eb0e1cd93f7$var$_classnames["default"])('radio', className),
        style: style
    }, /*#__PURE__*/ $d87f2eb0e1cd93f7$var$_react["default"].createElement($d87f2eb0e1cd93f7$var$_element["default"], $d87f2eb0e1cd93f7$var$_extends({}, props, {
        name: name,
        checked: checked,
        type: "radio",
        value: value,
        disabled: disabled
    })), ' ', children);
};
$d87f2eb0e1cd93f7$var$Radio.defaultProps = {
    renderAs: 'input'
};
var $d87f2eb0e1cd93f7$var$_default = $d87f2eb0e1cd93f7$var$Radio;
module.exports["default"] = $d87f2eb0e1cd93f7$var$_default;

});

parcelRegister("jRzQB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $e75ec620c9bebf2d$var$_react = $e75ec620c9bebf2d$var$_interopRequireDefault((parcelRequire("acw62")));

var $e75ec620c9bebf2d$var$_propTypes = $e75ec620c9bebf2d$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $e75ec620c9bebf2d$var$_classnames2 = $e75ec620c9bebf2d$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $e75ec620c9bebf2d$var$_element = $e75ec620c9bebf2d$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $e75ec620c9bebf2d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $e75ec620c9bebf2d$var$_extends() {
    $e75ec620c9bebf2d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e75ec620c9bebf2d$var$_extends.apply(this, arguments);
}
function $e75ec620c9bebf2d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e75ec620c9bebf2d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e75ec620c9bebf2d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e75ec620c9bebf2d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $e75ec620c9bebf2d$var$Help = function Help(_ref) {
    var className = _ref.className, children = _ref.children, color = _ref.color, props = $e75ec620c9bebf2d$var$_objectWithoutProperties(_ref, [
        "className",
        "children",
        "color"
    ]);
    return /*#__PURE__*/ $e75ec620c9bebf2d$var$_react["default"].createElement($e75ec620c9bebf2d$var$_element["default"], $e75ec620c9bebf2d$var$_extends({}, props, {
        className: (0, $e75ec620c9bebf2d$var$_classnames2["default"])('help', className, $e75ec620c9bebf2d$var$_defineProperty({}, "is-".concat(color), color))
    }), children);
};
$e75ec620c9bebf2d$var$Help.defaultProps = {
    renderAs: 'p'
};
var $e75ec620c9bebf2d$var$_default = $e75ec620c9bebf2d$var$Help;
module.exports["default"] = $e75ec620c9bebf2d$var$_default;

});

parcelRegister("lqmWk", function(module, exports) {
"use strict";
function $f98dd2091a6b0289$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $f98dd2091a6b0289$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $f98dd2091a6b0289$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $f98dd2091a6b0289$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $f98dd2091a6b0289$var$_react = $f98dd2091a6b0289$var$_interopRequireWildcard((parcelRequire("acw62")));

var $f98dd2091a6b0289$var$_propTypes = $f98dd2091a6b0289$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $f98dd2091a6b0289$var$_classnames2 = $f98dd2091a6b0289$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $f98dd2091a6b0289$var$_element = $f98dd2091a6b0289$var$_interopRequireDefault((parcelRequire("9rI5f")));

var $f98dd2091a6b0289$var$_context = $f98dd2091a6b0289$var$_interopRequireDefault((parcelRequire("1cqxb")));

var $R5V3X = parcelRequire("R5V3X");
function $f98dd2091a6b0289$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $f98dd2091a6b0289$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $f98dd2091a6b0289$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $f98dd2091a6b0289$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || $f98dd2091a6b0289$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $f98dd2091a6b0289$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $f98dd2091a6b0289$var$_extends() {
    $f98dd2091a6b0289$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f98dd2091a6b0289$var$_extends.apply(this, arguments);
}
function $f98dd2091a6b0289$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f98dd2091a6b0289$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $f98dd2091a6b0289$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $f98dd2091a6b0289$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $f98dd2091a6b0289$var$InputFile = function InputFile(_ref) {
    var _classnames;
    var className = _ref.className, style = _ref.style, onChange = _ref.onChange, color = _ref.color, size = _ref.size, fullwidth = _ref.fullwidth, align = _ref.align, boxed = _ref.boxed, name = _ref.name, label = _ref.label, icon = _ref.icon, inputProps = _ref.inputProps, filename = _ref.filename, value = _ref.value, props = $f98dd2091a6b0289$var$_objectWithoutProperties(_ref, [
        "className",
        "style",
        "onChange",
        "color",
        "size",
        "fullwidth",
        "align",
        "boxed",
        "name",
        "label",
        "icon",
        "inputProps",
        "filename",
        "value"
    ]);
    var ref = (0, $f98dd2091a6b0289$var$_react.useRef)();
    var context = (0, $f98dd2091a6b0289$var$_context["default"])();
    var calculatedSize = size || context.size;
    (0, $f98dd2091a6b0289$var$_react.useEffect)(function() {
        if (!ref.current) return;
        if (value) ref.current.files = value;
        else ref.current.value = '';
    }, [
        value
    ]);
    return /*#__PURE__*/ $f98dd2091a6b0289$var$_react["default"].createElement($f98dd2091a6b0289$var$_element["default"], $f98dd2091a6b0289$var$_extends({
        style: style
    }, props, {
        className: (0, $f98dd2091a6b0289$var$_classnames2["default"])('file', className, (_classnames = {}, $f98dd2091a6b0289$var$_defineProperty(_classnames, "is-".concat(calculatedSize), calculatedSize), $f98dd2091a6b0289$var$_defineProperty(_classnames, "is-".concat(color), color), $f98dd2091a6b0289$var$_defineProperty(_classnames, "is-".concat((0, $R5V3X.normalizeAlign)(align)), align), $f98dd2091a6b0289$var$_defineProperty(_classnames, 'has-name', !!filename), $f98dd2091a6b0289$var$_defineProperty(_classnames, 'is-boxed', boxed), $f98dd2091a6b0289$var$_defineProperty(_classnames, 'is-fullwidth', fullwidth), _classnames))
    }), /*#__PURE__*/ $f98dd2091a6b0289$var$_react["default"].createElement("label", {
        className: "file-label"
    }, /*#__PURE__*/ $f98dd2091a6b0289$var$_react["default"].createElement("input", $f98dd2091a6b0289$var$_extends({}, inputProps, {
        name: name,
        type: "file",
        className: "file-input",
        onChange: onChange,
        ref: ref
    })), /*#__PURE__*/ $f98dd2091a6b0289$var$_react["default"].createElement("span", {
        className: "file-cta"
    }, icon && /*#__PURE__*/ $f98dd2091a6b0289$var$_react["default"].createElement("span", {
        className: "file-icon"
    }, icon), /*#__PURE__*/ $f98dd2091a6b0289$var$_react["default"].createElement("span", {
        className: "file-label"
    }, label)), filename && /*#__PURE__*/ $f98dd2091a6b0289$var$_react["default"].createElement("span", {
        className: "file-name"
    }, filename)));
};
$f98dd2091a6b0289$var$InputFile.defaultProps = {
    label: 'Choose a file...',
    inputProps: {}
};
var $f98dd2091a6b0289$var$_default = $f98dd2091a6b0289$var$InputFile;
module.exports["default"] = $f98dd2091a6b0289$var$_default;

});


parcelRegister("5ovFQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $3ed7c365b18dbcab$var$_box = $3ed7c365b18dbcab$var$_interopRequireDefault((parcelRequire("hUCTi")));
function $3ed7c365b18dbcab$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $3ed7c365b18dbcab$var$_default = $3ed7c365b18dbcab$var$_box["default"];
module.exports["default"] = $3ed7c365b18dbcab$var$_default;

});
parcelRegister("hUCTi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $d0a5d58b18018688$var$_react = $d0a5d58b18018688$var$_interopRequireDefault((parcelRequire("acw62")));

var $d0a5d58b18018688$var$_classnames = $d0a5d58b18018688$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $d0a5d58b18018688$var$_element = $d0a5d58b18018688$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $d0a5d58b18018688$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $d0a5d58b18018688$var$_extends() {
    $d0a5d58b18018688$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d0a5d58b18018688$var$_extends.apply(this, arguments);
}
function $d0a5d58b18018688$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d0a5d58b18018688$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d0a5d58b18018688$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $d0a5d58b18018688$var$Box = function Box(_ref) {
    var children = _ref.children, className = _ref.className, props = $d0a5d58b18018688$var$_objectWithoutProperties(_ref, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ $d0a5d58b18018688$var$_react["default"].createElement($d0a5d58b18018688$var$_element["default"], $d0a5d58b18018688$var$_extends({}, props, {
        className: (0, $d0a5d58b18018688$var$_classnames["default"])('box', className)
    }), children);
};
$d0a5d58b18018688$var$Box.defaultProps = {};
var $d0a5d58b18018688$var$_default = $d0a5d58b18018688$var$Box;
module.exports["default"] = $d0a5d58b18018688$var$_default;

});


parcelRegister("h0tYP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $c619b129fe1f81e4$var$_block = $c619b129fe1f81e4$var$_interopRequireDefault((parcelRequire("fakSQ")));
function $c619b129fe1f81e4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $c619b129fe1f81e4$var$_default = $c619b129fe1f81e4$var$_block["default"];
module.exports["default"] = $c619b129fe1f81e4$var$_default;

});
parcelRegister("fakSQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $b0a7fd3ee80338b9$var$_react = $b0a7fd3ee80338b9$var$_interopRequireDefault((parcelRequire("acw62")));

var $b0a7fd3ee80338b9$var$_classnames = $b0a7fd3ee80338b9$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $b0a7fd3ee80338b9$var$_element = $b0a7fd3ee80338b9$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $b0a7fd3ee80338b9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $b0a7fd3ee80338b9$var$_extends() {
    $b0a7fd3ee80338b9$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b0a7fd3ee80338b9$var$_extends.apply(this, arguments);
}
function $b0a7fd3ee80338b9$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b0a7fd3ee80338b9$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $b0a7fd3ee80338b9$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $b0a7fd3ee80338b9$var$Block = function Block(_ref) {
    var className = _ref.className, props = $b0a7fd3ee80338b9$var$_objectWithoutProperties(_ref, [
        "className"
    ]);
    return /*#__PURE__*/ $b0a7fd3ee80338b9$var$_react["default"].createElement($b0a7fd3ee80338b9$var$_element["default"], $b0a7fd3ee80338b9$var$_extends({}, props, {
        className: (0, $b0a7fd3ee80338b9$var$_classnames["default"])('block', className)
    }));
};
$b0a7fd3ee80338b9$var$Block.defaultProps = {};
var $b0a7fd3ee80338b9$var$_default = $b0a7fd3ee80338b9$var$Block;
module.exports["default"] = $b0a7fd3ee80338b9$var$_default;

});


parcelRegister("4H1Ps", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $36ac98c69b9ab745$var$_breadcrumb = $36ac98c69b9ab745$var$_interopRequireDefault((parcelRequire("hRALP")));
function $36ac98c69b9ab745$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $36ac98c69b9ab745$var$_default = $36ac98c69b9ab745$var$_breadcrumb["default"];
module.exports["default"] = $36ac98c69b9ab745$var$_default;

});
parcelRegister("hRALP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $035b28ea35143a1e$var$_react = $035b28ea35143a1e$var$_interopRequireDefault((parcelRequire("acw62")));

var $035b28ea35143a1e$var$_propTypes = $035b28ea35143a1e$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $035b28ea35143a1e$var$_classnames2 = $035b28ea35143a1e$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $035b28ea35143a1e$var$_element = $035b28ea35143a1e$var$_interopRequireDefault((parcelRequire("9rI5f")));

var $035b28ea35143a1e$var$_item = $035b28ea35143a1e$var$_interopRequireDefault((parcelRequire("1XP2d")));
function $035b28ea35143a1e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $035b28ea35143a1e$var$_extends() {
    $035b28ea35143a1e$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $035b28ea35143a1e$var$_extends.apply(this, arguments);
}
function $035b28ea35143a1e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $035b28ea35143a1e$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $035b28ea35143a1e$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $035b28ea35143a1e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $035b28ea35143a1e$var$Breadcrumb = function Breadcrumb(_ref) {
    var _classnames;
    var className = _ref.className, separator = _ref.separator, size = _ref.size, align = _ref.align, children = _ref.children, props = $035b28ea35143a1e$var$_objectWithoutProperties(_ref, [
        "className",
        "separator",
        "size",
        "align",
        "children"
    ]);
    return /*#__PURE__*/ $035b28ea35143a1e$var$_react["default"].createElement($035b28ea35143a1e$var$_element["default"], $035b28ea35143a1e$var$_extends({}, props, {
        className: (0, $035b28ea35143a1e$var$_classnames2["default"])('breadcrumb', className, (_classnames = {}, $035b28ea35143a1e$var$_defineProperty(_classnames, "has-".concat(separator, "-separator"), separator), $035b28ea35143a1e$var$_defineProperty(_classnames, "is-".concat(size), size), $035b28ea35143a1e$var$_defineProperty(_classnames, "is-".concat(align), align), _classnames))
    }), /*#__PURE__*/ $035b28ea35143a1e$var$_react["default"].createElement("ul", null, children));
};
$035b28ea35143a1e$var$Breadcrumb.Item = $035b28ea35143a1e$var$_item["default"];
$035b28ea35143a1e$var$Breadcrumb.defaultProps = {
    separator: undefined,
    renderAs: 'nav',
    size: undefined,
    align: undefined
};
var $035b28ea35143a1e$var$_default = $035b28ea35143a1e$var$Breadcrumb;
module.exports["default"] = $035b28ea35143a1e$var$_default;

});
parcelRegister("1XP2d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $16e2e38bff747038$var$_react = $16e2e38bff747038$var$_interopRequireDefault((parcelRequire("acw62")));

var $16e2e38bff747038$var$_propTypes = $16e2e38bff747038$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $16e2e38bff747038$var$_classnames = $16e2e38bff747038$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $16e2e38bff747038$var$_element = $16e2e38bff747038$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $16e2e38bff747038$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $16e2e38bff747038$var$_extends() {
    $16e2e38bff747038$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $16e2e38bff747038$var$_extends.apply(this, arguments);
}
function $16e2e38bff747038$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $16e2e38bff747038$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $16e2e38bff747038$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $16e2e38bff747038$var$BreadcrumbItem = function BreadcrumbItem(_ref) {
    var className = _ref.className, active = _ref.active, children = _ref.children, props = $16e2e38bff747038$var$_objectWithoutProperties(_ref, [
        "className",
        "active",
        "children"
    ]);
    return /*#__PURE__*/ $16e2e38bff747038$var$_react["default"].createElement($16e2e38bff747038$var$_element["default"], $16e2e38bff747038$var$_extends({}, props, {
        className: (0, $16e2e38bff747038$var$_classnames["default"])(className, {
            'is-active': active
        })
    }), children);
};
$16e2e38bff747038$var$BreadcrumbItem.defaultProps = {
    renderAs: 'li'
};
var $16e2e38bff747038$var$_default = $16e2e38bff747038$var$BreadcrumbItem;
module.exports["default"] = $16e2e38bff747038$var$_default;

});



parcelRegister("a9Mjo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $765038625f5b9c84$var$_card = $765038625f5b9c84$var$_interopRequireDefault((parcelRequire("eIDE4")));
function $765038625f5b9c84$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $765038625f5b9c84$var$_default = $765038625f5b9c84$var$_card["default"];
module.exports["default"] = $765038625f5b9c84$var$_default;

});
parcelRegister("eIDE4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $ab73ed7de7463b93$var$_react = $ab73ed7de7463b93$var$_interopRequireDefault((parcelRequire("acw62")));

var $ab73ed7de7463b93$var$_classnames = $ab73ed7de7463b93$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $ab73ed7de7463b93$var$_image = $ab73ed7de7463b93$var$_interopRequireDefault((parcelRequire("2qk6A")));

var $ab73ed7de7463b93$var$_content = $ab73ed7de7463b93$var$_interopRequireDefault((parcelRequire("5TJpz")));

var $ab73ed7de7463b93$var$_header = $ab73ed7de7463b93$var$_interopRequireDefault((parcelRequire("aYChW")));

var $ab73ed7de7463b93$var$_footer = $ab73ed7de7463b93$var$_interopRequireDefault((parcelRequire("7PRg3")));

var $ab73ed7de7463b93$var$_element = $ab73ed7de7463b93$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $ab73ed7de7463b93$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $ab73ed7de7463b93$var$_extends() {
    $ab73ed7de7463b93$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ab73ed7de7463b93$var$_extends.apply(this, arguments);
}
function $ab73ed7de7463b93$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ab73ed7de7463b93$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $ab73ed7de7463b93$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $ab73ed7de7463b93$var$Card = function Card(_ref) {
    var className = _ref.className, children = _ref.children, props = $ab73ed7de7463b93$var$_objectWithoutProperties(_ref, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ $ab73ed7de7463b93$var$_react["default"].createElement($ab73ed7de7463b93$var$_element["default"], $ab73ed7de7463b93$var$_extends({
        className: (0, $ab73ed7de7463b93$var$_classnames["default"])('card', className)
    }, props), children);
};
$ab73ed7de7463b93$var$Card.Image = $ab73ed7de7463b93$var$_image["default"];
$ab73ed7de7463b93$var$Card.Content = $ab73ed7de7463b93$var$_content["default"];
$ab73ed7de7463b93$var$Card.Header = $ab73ed7de7463b93$var$_header["default"];
$ab73ed7de7463b93$var$Card.Footer = $ab73ed7de7463b93$var$_footer["default"];
$ab73ed7de7463b93$var$Card.defaultProps = {};
var $ab73ed7de7463b93$var$_default = $ab73ed7de7463b93$var$Card;
module.exports["default"] = $ab73ed7de7463b93$var$_default;

});
parcelRegister("2qk6A", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $1c3d9af1b8625730$var$_react = $1c3d9af1b8625730$var$_interopRequireDefault((parcelRequire("acw62")));

var $1c3d9af1b8625730$var$_classnames = $1c3d9af1b8625730$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $1c3d9af1b8625730$var$_image = $1c3d9af1b8625730$var$_interopRequireDefault((parcelRequire("hJmz0")));

var $1c3d9af1b8625730$var$_element = $1c3d9af1b8625730$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $1c3d9af1b8625730$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $1c3d9af1b8625730$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $1c3d9af1b8625730$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $1c3d9af1b8625730$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $1c3d9af1b8625730$var$CardImage = function CardImage(_ref) {
    var className = _ref.className, domRef = _ref.domRef, props = $1c3d9af1b8625730$var$_objectWithoutProperties(_ref, [
        "className",
        "domRef"
    ]);
    return /*#__PURE__*/ $1c3d9af1b8625730$var$_react["default"].createElement($1c3d9af1b8625730$var$_element["default"], {
        domRef: domRef,
        className: (0, $1c3d9af1b8625730$var$_classnames["default"])('card-image', className)
    }, /*#__PURE__*/ $1c3d9af1b8625730$var$_react["default"].createElement($1c3d9af1b8625730$var$_image["default"], props));
};
$1c3d9af1b8625730$var$CardImage.defaultProps = {};
var $1c3d9af1b8625730$var$_default = $1c3d9af1b8625730$var$CardImage;
module.exports["default"] = $1c3d9af1b8625730$var$_default;

});
parcelRegister("hJmz0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $ce88244ec168c8f2$var$_image = $ce88244ec168c8f2$var$_interopRequireDefault((parcelRequire("4iq3I")));
function $ce88244ec168c8f2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $ce88244ec168c8f2$var$_default = $ce88244ec168c8f2$var$_image["default"];
module.exports["default"] = $ce88244ec168c8f2$var$_default;

});
parcelRegister("4iq3I", function(module, exports) {
"use strict";
function $320d0e9fdae07c32$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $320d0e9fdae07c32$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $320d0e9fdae07c32$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $320d0e9fdae07c32$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $320d0e9fdae07c32$var$_react = $320d0e9fdae07c32$var$_interopRequireWildcard((parcelRequire("acw62")));

var $320d0e9fdae07c32$var$_propTypes = $320d0e9fdae07c32$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $320d0e9fdae07c32$var$_classnames2 = $320d0e9fdae07c32$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $320d0e9fdae07c32$var$_element = $320d0e9fdae07c32$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $320d0e9fdae07c32$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $320d0e9fdae07c32$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $320d0e9fdae07c32$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $320d0e9fdae07c32$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || $320d0e9fdae07c32$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $320d0e9fdae07c32$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $320d0e9fdae07c32$var$_extends() {
    $320d0e9fdae07c32$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $320d0e9fdae07c32$var$_extends.apply(this, arguments);
}
function $320d0e9fdae07c32$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $320d0e9fdae07c32$var$_slicedToArray(arr, i) {
    return $320d0e9fdae07c32$var$_arrayWithHoles(arr) || $320d0e9fdae07c32$var$_iterableToArrayLimit(arr, i) || $320d0e9fdae07c32$var$_unsupportedIterableToArray(arr, i) || $320d0e9fdae07c32$var$_nonIterableRest();
}
function $320d0e9fdae07c32$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $320d0e9fdae07c32$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $320d0e9fdae07c32$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $320d0e9fdae07c32$var$_arrayLikeToArray(o, minLen);
}
function $320d0e9fdae07c32$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $320d0e9fdae07c32$var$_iterableToArrayLimit(arr, i) {
    var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $320d0e9fdae07c32$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $320d0e9fdae07c32$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $320d0e9fdae07c32$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $320d0e9fdae07c32$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $320d0e9fdae07c32$var$Image = function Image(_ref) {
    var _classnames;
    var className = _ref.className, alt = _ref.alt, size = _ref.size, fallback = _ref.fallback, rounded = _ref.rounded, src = _ref.src, fullwidth = _ref.fullwidth, props = $320d0e9fdae07c32$var$_objectWithoutProperties(_ref, [
        "className",
        "alt",
        "size",
        "fallback",
        "rounded",
        "src",
        "fullwidth"
    ]);
    var _useState = (0, $320d0e9fdae07c32$var$_react.useState)({
        src: src
    }), _useState2 = $320d0e9fdae07c32$var$_slicedToArray(_useState, 2), state = _useState2[0], setState = _useState2[1];
    (0, $320d0e9fdae07c32$var$_react.useEffect)(function() {
        setState({
            src: src
        });
    }, [
        src
    ]);
    var s = size;
    if (typeof size === 'number') s = "".concat(s, "x").concat(s);
    return /*#__PURE__*/ $320d0e9fdae07c32$var$_react["default"].createElement($320d0e9fdae07c32$var$_element["default"], $320d0e9fdae07c32$var$_extends({}, props, {
        className: (0, $320d0e9fdae07c32$var$_classnames2["default"])('image', className, (_classnames = {}, $320d0e9fdae07c32$var$_defineProperty(_classnames, "is-".concat(s), s), $320d0e9fdae07c32$var$_defineProperty(_classnames, 'is-fullwidth', fullwidth), _classnames))
    }), /*#__PURE__*/ $320d0e9fdae07c32$var$_react["default"].createElement("img", {
        className: (0, $320d0e9fdae07c32$var$_classnames2["default"])({
            'is-rounded': rounded
        }),
        onError: function onError() {
            return state.src !== fallback && setState({
                src: fallback
            });
        },
        src: state.src,
        alt: alt
    }));
};
$320d0e9fdae07c32$var$Image.defaultProps = {
    renderAs: 'figure'
};
var $320d0e9fdae07c32$var$_default = $320d0e9fdae07c32$var$Image;
module.exports["default"] = $320d0e9fdae07c32$var$_default;

});



parcelRegister("5TJpz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $44b550901d40beaa$var$_react = $44b550901d40beaa$var$_interopRequireDefault((parcelRequire("acw62")));

var $44b550901d40beaa$var$_classnames = $44b550901d40beaa$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $44b550901d40beaa$var$_element = $44b550901d40beaa$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $44b550901d40beaa$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $44b550901d40beaa$var$_extends() {
    $44b550901d40beaa$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $44b550901d40beaa$var$_extends.apply(this, arguments);
}
function $44b550901d40beaa$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $44b550901d40beaa$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $44b550901d40beaa$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $44b550901d40beaa$var$CardContent = function CardContent(_ref) {
    var className = _ref.className, props = $44b550901d40beaa$var$_objectWithoutProperties(_ref, [
        "className"
    ]);
    return /*#__PURE__*/ $44b550901d40beaa$var$_react["default"].createElement($44b550901d40beaa$var$_element["default"], $44b550901d40beaa$var$_extends({}, props, {
        className: (0, $44b550901d40beaa$var$_classnames["default"])('card-content', className)
    }));
};
$44b550901d40beaa$var$CardContent.defaultProps = {};
var $44b550901d40beaa$var$_default = $44b550901d40beaa$var$CardContent;
module.exports["default"] = $44b550901d40beaa$var$_default;

});

parcelRegister("aYChW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function get() {
        return $7fdd354284cf710c$var$_header["default"];
    }
});

var $7fdd354284cf710c$var$_header = $7fdd354284cf710c$var$_interopRequireDefault((parcelRequire("3Ttel")));
function $7fdd354284cf710c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

});
parcelRegister("3Ttel", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $2d5d2eaf3ba1d9fc$var$_react = $2d5d2eaf3ba1d9fc$var$_interopRequireDefault((parcelRequire("acw62")));

var $2d5d2eaf3ba1d9fc$var$_classnames = $2d5d2eaf3ba1d9fc$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $2d5d2eaf3ba1d9fc$var$_headerTitle = $2d5d2eaf3ba1d9fc$var$_interopRequireDefault((parcelRequire("cSszF")));

var $2d5d2eaf3ba1d9fc$var$_headerIcon = $2d5d2eaf3ba1d9fc$var$_interopRequireDefault((parcelRequire("bxxvB")));

var $2d5d2eaf3ba1d9fc$var$_element = $2d5d2eaf3ba1d9fc$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $2d5d2eaf3ba1d9fc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $2d5d2eaf3ba1d9fc$var$_extends() {
    $2d5d2eaf3ba1d9fc$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2d5d2eaf3ba1d9fc$var$_extends.apply(this, arguments);
}
function $2d5d2eaf3ba1d9fc$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $2d5d2eaf3ba1d9fc$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $2d5d2eaf3ba1d9fc$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $2d5d2eaf3ba1d9fc$var$CardHeader = function CardHeader(_ref) {
    var className = _ref.className, props = $2d5d2eaf3ba1d9fc$var$_objectWithoutProperties(_ref, [
        "className"
    ]);
    return /*#__PURE__*/ $2d5d2eaf3ba1d9fc$var$_react["default"].createElement($2d5d2eaf3ba1d9fc$var$_element["default"], $2d5d2eaf3ba1d9fc$var$_extends({}, props, {
        className: (0, $2d5d2eaf3ba1d9fc$var$_classnames["default"])('card-header', className)
    }));
};
$2d5d2eaf3ba1d9fc$var$CardHeader.Title = $2d5d2eaf3ba1d9fc$var$_headerTitle["default"];
$2d5d2eaf3ba1d9fc$var$CardHeader.Icon = $2d5d2eaf3ba1d9fc$var$_headerIcon["default"];
$2d5d2eaf3ba1d9fc$var$CardHeader.defaultProps = {};
var $2d5d2eaf3ba1d9fc$var$_default = $2d5d2eaf3ba1d9fc$var$CardHeader;
module.exports["default"] = $2d5d2eaf3ba1d9fc$var$_default;

});
parcelRegister("cSszF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $9600b16d4f83c7a0$var$_react = $9600b16d4f83c7a0$var$_interopRequireDefault((parcelRequire("acw62")));

var $9600b16d4f83c7a0$var$_classnames = $9600b16d4f83c7a0$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $9600b16d4f83c7a0$var$_element = $9600b16d4f83c7a0$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $9600b16d4f83c7a0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $9600b16d4f83c7a0$var$_extends() {
    $9600b16d4f83c7a0$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9600b16d4f83c7a0$var$_extends.apply(this, arguments);
}
function $9600b16d4f83c7a0$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $9600b16d4f83c7a0$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $9600b16d4f83c7a0$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $9600b16d4f83c7a0$var$CardHeaderTitle = function CardHeaderTitle(_ref) {
    var className = _ref.className, props = $9600b16d4f83c7a0$var$_objectWithoutProperties(_ref, [
        "className"
    ]);
    return /*#__PURE__*/ $9600b16d4f83c7a0$var$_react["default"].createElement($9600b16d4f83c7a0$var$_element["default"], $9600b16d4f83c7a0$var$_extends({}, props, {
        className: (0, $9600b16d4f83c7a0$var$_classnames["default"])('card-header-title', className)
    }));
};
$9600b16d4f83c7a0$var$CardHeaderTitle.defaultProps = {};
var $9600b16d4f83c7a0$var$_default = $9600b16d4f83c7a0$var$CardHeaderTitle;
module.exports["default"] = $9600b16d4f83c7a0$var$_default;

});

parcelRegister("bxxvB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $866cc4e34dfdea9a$var$_react = $866cc4e34dfdea9a$var$_interopRequireDefault((parcelRequire("acw62")));

var $866cc4e34dfdea9a$var$_classnames = $866cc4e34dfdea9a$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $866cc4e34dfdea9a$var$_element = $866cc4e34dfdea9a$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $866cc4e34dfdea9a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $866cc4e34dfdea9a$var$_extends() {
    $866cc4e34dfdea9a$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $866cc4e34dfdea9a$var$_extends.apply(this, arguments);
}
function $866cc4e34dfdea9a$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $866cc4e34dfdea9a$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $866cc4e34dfdea9a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $866cc4e34dfdea9a$var$CardHeaderIcon = function CardHeaderIcon(_ref) {
    var className = _ref.className, props = $866cc4e34dfdea9a$var$_objectWithoutProperties(_ref, [
        "className"
    ]);
    return /*#__PURE__*/ $866cc4e34dfdea9a$var$_react["default"].createElement($866cc4e34dfdea9a$var$_element["default"], $866cc4e34dfdea9a$var$_extends({}, props, {
        className: (0, $866cc4e34dfdea9a$var$_classnames["default"])('card-header-icon', className)
    }));
};
$866cc4e34dfdea9a$var$CardHeaderIcon.defaultProps = {};
var $866cc4e34dfdea9a$var$_default = $866cc4e34dfdea9a$var$CardHeaderIcon;
module.exports["default"] = $866cc4e34dfdea9a$var$_default;

});



parcelRegister("7PRg3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function get() {
        return $5b469bb771b768a4$var$_footer["default"];
    }
});

var $5b469bb771b768a4$var$_footer = $5b469bb771b768a4$var$_interopRequireDefault((parcelRequire("jjSJz")));
function $5b469bb771b768a4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

});
parcelRegister("jjSJz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $e10a3fae296295f9$var$_react = $e10a3fae296295f9$var$_interopRequireDefault((parcelRequire("acw62")));

var $e10a3fae296295f9$var$_classnames = $e10a3fae296295f9$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $e10a3fae296295f9$var$_footerItem = $e10a3fae296295f9$var$_interopRequireDefault((parcelRequire("6FJpm")));

var $e10a3fae296295f9$var$_element = $e10a3fae296295f9$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $e10a3fae296295f9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $e10a3fae296295f9$var$_extends() {
    $e10a3fae296295f9$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e10a3fae296295f9$var$_extends.apply(this, arguments);
}
function $e10a3fae296295f9$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e10a3fae296295f9$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e10a3fae296295f9$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $e10a3fae296295f9$var$CardFooter = function CardFooter(_ref) {
    var className = _ref.className, props = $e10a3fae296295f9$var$_objectWithoutProperties(_ref, [
        "className"
    ]);
    return /*#__PURE__*/ $e10a3fae296295f9$var$_react["default"].createElement($e10a3fae296295f9$var$_element["default"], $e10a3fae296295f9$var$_extends({}, props, {
        className: (0, $e10a3fae296295f9$var$_classnames["default"])('card-footer', className)
    }));
};
$e10a3fae296295f9$var$CardFooter.Item = $e10a3fae296295f9$var$_footerItem["default"];
$e10a3fae296295f9$var$CardFooter.defaultProps = {};
var $e10a3fae296295f9$var$_default = $e10a3fae296295f9$var$CardFooter;
module.exports["default"] = $e10a3fae296295f9$var$_default;

});
parcelRegister("6FJpm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $4db9cb7d65815a55$var$_react = $4db9cb7d65815a55$var$_interopRequireDefault((parcelRequire("acw62")));

var $4db9cb7d65815a55$var$_classnames = $4db9cb7d65815a55$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $4db9cb7d65815a55$var$_element = $4db9cb7d65815a55$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $4db9cb7d65815a55$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $4db9cb7d65815a55$var$_extends() {
    $4db9cb7d65815a55$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4db9cb7d65815a55$var$_extends.apply(this, arguments);
}
function $4db9cb7d65815a55$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $4db9cb7d65815a55$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $4db9cb7d65815a55$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $4db9cb7d65815a55$var$CardFooterItem = function CardFooterItem(_ref) {
    var className = _ref.className, props = $4db9cb7d65815a55$var$_objectWithoutProperties(_ref, [
        "className"
    ]);
    return /*#__PURE__*/ $4db9cb7d65815a55$var$_react["default"].createElement($4db9cb7d65815a55$var$_element["default"], $4db9cb7d65815a55$var$_extends({}, props, {
        className: (0, $4db9cb7d65815a55$var$_classnames["default"])('card-footer-item', className)
    }));
};
$4db9cb7d65815a55$var$CardFooterItem.defaultProps = {};
var $4db9cb7d65815a55$var$_default = $4db9cb7d65815a55$var$CardFooterItem;
module.exports["default"] = $4db9cb7d65815a55$var$_default;

});





parcelRegister("3l82Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $26e992d3f295623c$var$_columns = $26e992d3f295623c$var$_interopRequireDefault((parcelRequire("47EYt")));
function $26e992d3f295623c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $26e992d3f295623c$var$_default = $26e992d3f295623c$var$_columns["default"];
module.exports["default"] = $26e992d3f295623c$var$_default;

});
parcelRegister("47EYt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $300799873427f6ee$var$_react = $300799873427f6ee$var$_interopRequireDefault((parcelRequire("acw62")));

var $300799873427f6ee$var$_propTypes = $300799873427f6ee$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $300799873427f6ee$var$_classnames = $300799873427f6ee$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $300799873427f6ee$var$_column = $300799873427f6ee$var$_interopRequireDefault((parcelRequire("c1xmE")));

var $300799873427f6ee$var$_constants = $300799873427f6ee$var$_interopRequireDefault((parcelRequire("jpkQb")));

var $300799873427f6ee$var$_element = $300799873427f6ee$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $300799873427f6ee$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $300799873427f6ee$var$_extends() {
    $300799873427f6ee$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $300799873427f6ee$var$_extends.apply(this, arguments);
}
function $300799873427f6ee$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $300799873427f6ee$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $300799873427f6ee$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $300799873427f6ee$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $300799873427f6ee$var$Columns = function Columns(_ref) {
    var _classNames;
    var className = _ref.className, breakpoint = _ref.breakpoint, gap = _ref.gap, multiline = _ref.multiline, centered = _ref.centered, vCentered = _ref.vCentered, variableGap = _ref.variableGap, _ref$mobile = _ref.mobile, mobile = _ref$mobile === void 0 ? {} : _ref$mobile, _ref$tablet = _ref.tablet, tablet = _ref$tablet === void 0 ? {} : _ref$tablet, _ref$desktop = _ref.desktop, desktop = _ref$desktop === void 0 ? {} : _ref$desktop, _ref$widescreen = _ref.widescreen, widescreen = _ref$widescreen === void 0 ? {} : _ref$widescreen, _ref$fullhd = _ref.fullhd, fullhd = _ref$fullhd === void 0 ? {} : _ref$fullhd, _ref$touch = _ref.touch, touch = _ref$touch === void 0 ? {} : _ref$touch, props = $300799873427f6ee$var$_objectWithoutProperties(_ref, [
        "className",
        "breakpoint",
        "gap",
        "multiline",
        "centered",
        "vCentered",
        "variableGap",
        "mobile",
        "tablet",
        "desktop",
        "widescreen",
        "fullhd",
        "touch"
    ]);
    return /*#__PURE__*/ $300799873427f6ee$var$_react["default"].createElement($300799873427f6ee$var$_element["default"], $300799873427f6ee$var$_extends({}, props, {
        mobile: mobile,
        tablet: tablet,
        desktop: desktop,
        widescreen: widescreen,
        fullhd: fullhd,
        touch: touch,
        className: (0, $300799873427f6ee$var$_classnames["default"])(className, 'columns', (_classNames = {}, $300799873427f6ee$var$_defineProperty(_classNames, "is-".concat(breakpoint), breakpoint), $300799873427f6ee$var$_defineProperty(_classNames, "is-".concat(gap), gap !== undefined), $300799873427f6ee$var$_defineProperty(_classNames, 'is-multiline', multiline), $300799873427f6ee$var$_defineProperty(_classNames, 'is-centered', centered), $300799873427f6ee$var$_defineProperty(_classNames, 'is-vcentered', vCentered), $300799873427f6ee$var$_defineProperty(_classNames, 'is-variable', gap !== undefined || [
            touch,
            mobile,
            tablet,
            desktop,
            widescreen,
            fullhd
        ].find(function(b) {
            return b.gap !== undefined;
        })), $300799873427f6ee$var$_defineProperty(_classNames, "is-".concat(touch.gap, "-touch"), touch.gap !== undefined), $300799873427f6ee$var$_defineProperty(_classNames, "is-".concat(mobile.gap, "-mobile"), mobile.gap !== undefined), $300799873427f6ee$var$_defineProperty(_classNames, "is-".concat(tablet.gap, "-tablet"), tablet.gap !== undefined), $300799873427f6ee$var$_defineProperty(_classNames, "is-".concat(desktop.gap, "-desktop"), desktop.gap !== undefined), $300799873427f6ee$var$_defineProperty(_classNames, "is-".concat(widescreen.gap, "-widescreen"), widescreen.gap !== undefined), $300799873427f6ee$var$_defineProperty(_classNames, "is-".concat(fullhd.gap, "-fullhd"), fullhd.gap !== undefined), _classNames))
    }));
};
$300799873427f6ee$var$Columns.Column = $300799873427f6ee$var$_column["default"];
$300799873427f6ee$var$Columns.CONSTANTS = $300799873427f6ee$var$_constants["default"];
$300799873427f6ee$var$Columns.defaultProps = {
    multiline: true
};
var $300799873427f6ee$var$_default = $300799873427f6ee$var$Columns;
module.exports["default"] = $300799873427f6ee$var$_default;

});
parcelRegister("c1xmE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $8c0f757a26d62011$var$_react = $8c0f757a26d62011$var$_interopRequireDefault((parcelRequire("acw62")));

var $8c0f757a26d62011$var$_propTypes = $8c0f757a26d62011$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8c0f757a26d62011$var$_classnames = $8c0f757a26d62011$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $8c0f757a26d62011$var$_element = $8c0f757a26d62011$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $8c0f757a26d62011$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $8c0f757a26d62011$var$_extends() {
    $8c0f757a26d62011$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8c0f757a26d62011$var$_extends.apply(this, arguments);
}
function $8c0f757a26d62011$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8c0f757a26d62011$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $8c0f757a26d62011$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $8c0f757a26d62011$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $8c0f757a26d62011$var$Column = function Column(_ref) {
    var _classNames;
    var children = _ref.children, className = _ref.className, size = _ref.size, offset = _ref.offset, narrow = _ref.narrow, _ref$mobile = _ref.mobile, mobile = _ref$mobile === void 0 ? {} : _ref$mobile, _ref$tablet = _ref.tablet, tablet = _ref$tablet === void 0 ? {} : _ref$tablet, _ref$desktop = _ref.desktop, desktop = _ref$desktop === void 0 ? {} : _ref$desktop, _ref$widescreen = _ref.widescreen, widescreen = _ref$widescreen === void 0 ? {} : _ref$widescreen, _ref$fullhd = _ref.fullhd, fullhd = _ref$fullhd === void 0 ? {} : _ref$fullhd, _ref$touch = _ref.touch, touch = _ref$touch === void 0 ? {} : _ref$touch, props = $8c0f757a26d62011$var$_objectWithoutProperties(_ref, [
        "children",
        "className",
        "size",
        "offset",
        "narrow",
        "mobile",
        "tablet",
        "desktop",
        "widescreen",
        "fullhd",
        "touch"
    ]);
    return /*#__PURE__*/ $8c0f757a26d62011$var$_react["default"].createElement($8c0f757a26d62011$var$_element["default"], $8c0f757a26d62011$var$_extends({}, props, {
        mobile: mobile,
        tablet: tablet,
        desktop: desktop,
        widescreen: widescreen,
        fullhd: fullhd,
        touch: touch,
        className: (0, $8c0f757a26d62011$var$_classnames["default"])(className, 'column', (_classNames = {}, $8c0f757a26d62011$var$_defineProperty(_classNames, "is-".concat(size), size), $8c0f757a26d62011$var$_defineProperty(_classNames, "is-".concat(touch.size, "-mobile"), touch.size), $8c0f757a26d62011$var$_defineProperty(_classNames, "is-".concat(mobile.size, "-mobile"), mobile.size), $8c0f757a26d62011$var$_defineProperty(_classNames, "is-".concat(tablet.size, "-tablet"), tablet.size), $8c0f757a26d62011$var$_defineProperty(_classNames, "is-".concat(desktop.size, "-desktop"), desktop.size), $8c0f757a26d62011$var$_defineProperty(_classNames, "is-".concat(widescreen.size, "-widescreen"), widescreen.size), $8c0f757a26d62011$var$_defineProperty(_classNames, "is-".concat(fullhd.size, "-fullhd"), fullhd.size), $8c0f757a26d62011$var$_defineProperty(_classNames, "is-offset-".concat(touch.offset, "-mobile"), touch.offset), $8c0f757a26d62011$var$_defineProperty(_classNames, "is-offset-".concat(mobile.offset, "-mobile"), mobile.offset), $8c0f757a26d62011$var$_defineProperty(_classNames, "is-offset-".concat(tablet.offset, "-tablet"), tablet.offset), $8c0f757a26d62011$var$_defineProperty(_classNames, "is-offset-".concat(desktop.offset, "-desktop"), desktop.offset), $8c0f757a26d62011$var$_defineProperty(_classNames, "is-offset-".concat(widescreen.offset, "-widescreen"), widescreen.offset), $8c0f757a26d62011$var$_defineProperty(_classNames, "is-offset-".concat(fullhd.offset, "-fullhd"), fullhd.offset), $8c0f757a26d62011$var$_defineProperty(_classNames, "is-offset-".concat(offset), offset), $8c0f757a26d62011$var$_defineProperty(_classNames, 'is-narrow', narrow), $8c0f757a26d62011$var$_defineProperty(_classNames, 'is-narrow-touch', touch.narrow), $8c0f757a26d62011$var$_defineProperty(_classNames, 'is-narrow-mobile', mobile.narrow), $8c0f757a26d62011$var$_defineProperty(_classNames, 'is-narrow-tablet', tablet.narrow), $8c0f757a26d62011$var$_defineProperty(_classNames, 'is-narrow-desktop', desktop.narrow), $8c0f757a26d62011$var$_defineProperty(_classNames, 'is-narrow-widescreen', widescreen.narrow), $8c0f757a26d62011$var$_defineProperty(_classNames, 'is-narrow-fullhd', fullhd.narrow), _classNames))
    }), children);
};
$8c0f757a26d62011$var$Column.defaultProps = {};
var $8c0f757a26d62011$var$_default = $8c0f757a26d62011$var$Column;
module.exports["default"] = $8c0f757a26d62011$var$_default;

});

parcelRegister("jpkQb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
var $e210849ea38180c2$var$_default = {
    SIZES: {
        THREEQUARTERS: 'three-quarters',
        TWOTHIRDS: 'two-thirds',
        HALF: 'half',
        ONETHIRD: 'one-third',
        ONEQUARTER: 'one-quarter',
        ONEFIFTH: 'one-fifth',
        TWOFIFTHS: 'two-fifths',
        THREEFIFTHS: 'three-fifths',
        FOURFIFTHS: 'four-fifths'
    }
};
module.exports["default"] = $e210849ea38180c2$var$_default;

});



parcelRegister("2iRmO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $1ad6a8c5c6c049c1$var$_container = $1ad6a8c5c6c049c1$var$_interopRequireDefault((parcelRequire("tQRCp")));
function $1ad6a8c5c6c049c1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $1ad6a8c5c6c049c1$var$_default = $1ad6a8c5c6c049c1$var$_container["default"];
module.exports["default"] = $1ad6a8c5c6c049c1$var$_default;

});
parcelRegister("tQRCp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $059bb7336978160d$var$_react = $059bb7336978160d$var$_interopRequireDefault((parcelRequire("acw62")));

var $059bb7336978160d$var$_propTypes = $059bb7336978160d$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $059bb7336978160d$var$_classnames2 = $059bb7336978160d$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $059bb7336978160d$var$_element = $059bb7336978160d$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $059bb7336978160d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $059bb7336978160d$var$_extends() {
    $059bb7336978160d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $059bb7336978160d$var$_extends.apply(this, arguments);
}
function $059bb7336978160d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $059bb7336978160d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $059bb7336978160d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $059bb7336978160d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $059bb7336978160d$var$Container = function Container(_ref) {
    var children = _ref.children, max = _ref.max, breakpoint = _ref.breakpoint, className = _ref.className, props = $059bb7336978160d$var$_objectWithoutProperties(_ref, [
        "children",
        "max",
        "breakpoint",
        "className"
    ]);
    var canSetMax = [
        'desktop',
        'widescreen'
    ].includes(breakpoint);
    return /*#__PURE__*/ $059bb7336978160d$var$_react["default"].createElement($059bb7336978160d$var$_element["default"], $059bb7336978160d$var$_extends({}, props, {
        className: (0, $059bb7336978160d$var$_classnames2["default"])('container', className, $059bb7336978160d$var$_defineProperty({}, "is-".concat(canSetMax && max ? 'max-' : '').concat(breakpoint), breakpoint))
    }), children);
};
$059bb7336978160d$var$Container.defaultProps = {};
var $059bb7336978160d$var$_default = $059bb7336978160d$var$Container;
module.exports["default"] = $059bb7336978160d$var$_default;

});


parcelRegister("fjmVQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $b25a6b2ddd4433ec$var$_content = $b25a6b2ddd4433ec$var$_interopRequireDefault((parcelRequire("4YzPP")));
function $b25a6b2ddd4433ec$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $b25a6b2ddd4433ec$var$_default = $b25a6b2ddd4433ec$var$_content["default"];
module.exports["default"] = $b25a6b2ddd4433ec$var$_default;

});
parcelRegister("4YzPP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $39f8901d2ad17c4f$var$_react = $39f8901d2ad17c4f$var$_interopRequireDefault((parcelRequire("acw62")));

var $39f8901d2ad17c4f$var$_propTypes = $39f8901d2ad17c4f$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $39f8901d2ad17c4f$var$_classnames2 = $39f8901d2ad17c4f$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $39f8901d2ad17c4f$var$_element = $39f8901d2ad17c4f$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $39f8901d2ad17c4f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $39f8901d2ad17c4f$var$_extends() {
    $39f8901d2ad17c4f$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $39f8901d2ad17c4f$var$_extends.apply(this, arguments);
}
function $39f8901d2ad17c4f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $39f8901d2ad17c4f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $39f8901d2ad17c4f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $39f8901d2ad17c4f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $39f8901d2ad17c4f$var$Content = function Content(_ref) {
    var children = _ref.children, className = _ref.className, size = _ref.size, props = $39f8901d2ad17c4f$var$_objectWithoutProperties(_ref, [
        "children",
        "className",
        "size"
    ]);
    return /*#__PURE__*/ $39f8901d2ad17c4f$var$_react["default"].createElement($39f8901d2ad17c4f$var$_element["default"], $39f8901d2ad17c4f$var$_extends({}, props, {
        className: (0, $39f8901d2ad17c4f$var$_classnames2["default"])('content', className, $39f8901d2ad17c4f$var$_defineProperty({}, "is-".concat(size), size))
    }), children);
};
$39f8901d2ad17c4f$var$Content.defaultProps = {};
var $39f8901d2ad17c4f$var$_default = $39f8901d2ad17c4f$var$Content;
module.exports["default"] = $39f8901d2ad17c4f$var$_default;

});


parcelRegister("adbhe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $76f3dd9f6dddbfb3$var$_footer = $76f3dd9f6dddbfb3$var$_interopRequireDefault((parcelRequire("bLCq3")));
function $76f3dd9f6dddbfb3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $76f3dd9f6dddbfb3$var$_default = $76f3dd9f6dddbfb3$var$_footer["default"];
module.exports["default"] = $76f3dd9f6dddbfb3$var$_default;

});
parcelRegister("bLCq3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $8911e2c3d1608757$var$_react = $8911e2c3d1608757$var$_interopRequireDefault((parcelRequire("acw62")));

var $8911e2c3d1608757$var$_propTypes = $8911e2c3d1608757$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8911e2c3d1608757$var$_classnames = $8911e2c3d1608757$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $8911e2c3d1608757$var$_element = $8911e2c3d1608757$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $8911e2c3d1608757$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $8911e2c3d1608757$var$_extends() {
    $8911e2c3d1608757$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8911e2c3d1608757$var$_extends.apply(this, arguments);
}
function $8911e2c3d1608757$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $8911e2c3d1608757$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $8911e2c3d1608757$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $8911e2c3d1608757$var$Footer = function Footer(_ref) {
    var className = _ref.className, props = $8911e2c3d1608757$var$_objectWithoutProperties(_ref, [
        "className"
    ]);
    return /*#__PURE__*/ $8911e2c3d1608757$var$_react["default"].createElement($8911e2c3d1608757$var$_element["default"], $8911e2c3d1608757$var$_extends({}, props, {
        className: (0, $8911e2c3d1608757$var$_classnames["default"])('footer', className)
    }));
};
$8911e2c3d1608757$var$Footer.defaultProps = {
    renderAs: 'footer'
};
var $8911e2c3d1608757$var$_default = $8911e2c3d1608757$var$Footer;
module.exports["default"] = $8911e2c3d1608757$var$_default;

});


parcelRegister("d6xqU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $98a5c4fcbdbe0e68$var$_heading = $98a5c4fcbdbe0e68$var$_interopRequireDefault((parcelRequire("k6TE5")));
function $98a5c4fcbdbe0e68$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $98a5c4fcbdbe0e68$var$_default = $98a5c4fcbdbe0e68$var$_heading["default"];
module.exports["default"] = $98a5c4fcbdbe0e68$var$_default;

});
parcelRegister("k6TE5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $ea3f883c34043515$var$_react = $ea3f883c34043515$var$_interopRequireDefault((parcelRequire("acw62")));

var $ea3f883c34043515$var$_propTypes = $ea3f883c34043515$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $ea3f883c34043515$var$_classnames2 = $ea3f883c34043515$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $ea3f883c34043515$var$_element = $ea3f883c34043515$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $ea3f883c34043515$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $ea3f883c34043515$var$_extends() {
    $ea3f883c34043515$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ea3f883c34043515$var$_extends.apply(this, arguments);
}
function $ea3f883c34043515$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ea3f883c34043515$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ea3f883c34043515$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $ea3f883c34043515$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $ea3f883c34043515$var$Heading = function Heading(_ref) {
    var _classnames;
    var children = _ref.children, className = _ref.className, size = _ref.size, subtitle = _ref.subtitle, weight = _ref.weight, spaced = _ref.spaced, heading = _ref.heading, props = $ea3f883c34043515$var$_objectWithoutProperties(_ref, [
        "children",
        "className",
        "size",
        "subtitle",
        "weight",
        "spaced",
        "heading"
    ]);
    return /*#__PURE__*/ $ea3f883c34043515$var$_react["default"].createElement($ea3f883c34043515$var$_element["default"], $ea3f883c34043515$var$_extends({}, props, {
        className: (0, $ea3f883c34043515$var$_classnames2["default"])(className, (_classnames = {
            title: !subtitle && !heading,
            subtitle: subtitle,
            heading: heading
        }, $ea3f883c34043515$var$_defineProperty(_classnames, "is-".concat(size), size), $ea3f883c34043515$var$_defineProperty(_classnames, "has-text-weight-".concat(weight), weight), $ea3f883c34043515$var$_defineProperty(_classnames, 'is-spaced', spaced && !subtitle), _classnames))
    }), children);
};
$ea3f883c34043515$var$Heading.defaultProps = {
    renderAs: 'h1'
};
var $ea3f883c34043515$var$_default = $ea3f883c34043515$var$Heading;
module.exports["default"] = $ea3f883c34043515$var$_default;

});


parcelRegister("eTw4Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $ad7f1592160bb320$var$_hero = $ad7f1592160bb320$var$_interopRequireDefault((parcelRequire("dLZHz")));
function $ad7f1592160bb320$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $ad7f1592160bb320$var$_default = $ad7f1592160bb320$var$_hero["default"];
module.exports["default"] = $ad7f1592160bb320$var$_default;

});
parcelRegister("dLZHz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $a06f86cf2b533d82$var$_react = $a06f86cf2b533d82$var$_interopRequireDefault((parcelRequire("acw62")));

var $a06f86cf2b533d82$var$_propTypes = $a06f86cf2b533d82$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $a06f86cf2b533d82$var$_classnames2 = $a06f86cf2b533d82$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $a06f86cf2b533d82$var$_heroHeader = $a06f86cf2b533d82$var$_interopRequireDefault((parcelRequire("81gb3")));

var $a06f86cf2b533d82$var$_heroBody = $a06f86cf2b533d82$var$_interopRequireDefault((parcelRequire("f1baI")));

var $a06f86cf2b533d82$var$_heroFooter = $a06f86cf2b533d82$var$_interopRequireDefault((parcelRequire("aGhpF")));

var $a06f86cf2b533d82$var$_element = $a06f86cf2b533d82$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $a06f86cf2b533d82$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $a06f86cf2b533d82$var$_extends() {
    $a06f86cf2b533d82$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a06f86cf2b533d82$var$_extends.apply(this, arguments);
}
function $a06f86cf2b533d82$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a06f86cf2b533d82$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a06f86cf2b533d82$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a06f86cf2b533d82$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $a06f86cf2b533d82$var$Hero = function Hero(_ref) {
    var _classnames;
    var children = _ref.children, className = _ref.className, color = _ref.color, gradient = _ref.gradient, size = _ref.size, hasNavbar = _ref.hasNavbar, props = $a06f86cf2b533d82$var$_objectWithoutProperties(_ref, [
        "children",
        "className",
        "color",
        "gradient",
        "size",
        "hasNavbar"
    ]);
    return /*#__PURE__*/ $a06f86cf2b533d82$var$_react["default"].createElement($a06f86cf2b533d82$var$_element["default"], $a06f86cf2b533d82$var$_extends({}, props, {
        className: (0, $a06f86cf2b533d82$var$_classnames2["default"])('hero', className, (_classnames = {}, $a06f86cf2b533d82$var$_defineProperty(_classnames, "is-".concat(color), color), $a06f86cf2b533d82$var$_defineProperty(_classnames, "is-".concat(size), size && !hasNavbar), $a06f86cf2b533d82$var$_defineProperty(_classnames, 'is-bold', gradient), $a06f86cf2b533d82$var$_defineProperty(_classnames, 'is-fullheight-with-navbar', hasNavbar), _classnames))
    }), children);
};
$a06f86cf2b533d82$var$Hero.Header = $a06f86cf2b533d82$var$_heroHeader["default"];
$a06f86cf2b533d82$var$Hero.Body = $a06f86cf2b533d82$var$_heroBody["default"];
$a06f86cf2b533d82$var$Hero.Footer = $a06f86cf2b533d82$var$_heroFooter["default"];
$a06f86cf2b533d82$var$Hero.defaultProps = {
    renderAs: 'section'
};
var $a06f86cf2b533d82$var$_default = $a06f86cf2b533d82$var$Hero;
module.exports["default"] = $a06f86cf2b533d82$var$_default;

});
parcelRegister("81gb3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $5d6af7361420da4b$var$_react = $5d6af7361420da4b$var$_interopRequireDefault((parcelRequire("acw62")));

var $5d6af7361420da4b$var$_propTypes = $5d6af7361420da4b$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $5d6af7361420da4b$var$_classnames = $5d6af7361420da4b$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $5d6af7361420da4b$var$_element = $5d6af7361420da4b$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $5d6af7361420da4b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $5d6af7361420da4b$var$_extends() {
    $5d6af7361420da4b$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5d6af7361420da4b$var$_extends.apply(this, arguments);
}
function $5d6af7361420da4b$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $5d6af7361420da4b$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $5d6af7361420da4b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $5d6af7361420da4b$var$HeroHeader = function HeroHeader(_ref) {
    var className = _ref.className, props = $5d6af7361420da4b$var$_objectWithoutProperties(_ref, [
        "className"
    ]);
    return /*#__PURE__*/ $5d6af7361420da4b$var$_react["default"].createElement($5d6af7361420da4b$var$_element["default"], $5d6af7361420da4b$var$_extends({}, props, {
        className: (0, $5d6af7361420da4b$var$_classnames["default"])(className, 'hero-head')
    }));
};
$5d6af7361420da4b$var$HeroHeader.defaultProps = {
    renderAs: 'header'
};
var $5d6af7361420da4b$var$_default = $5d6af7361420da4b$var$HeroHeader;
module.exports["default"] = $5d6af7361420da4b$var$_default;

});

parcelRegister("f1baI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $aeef9d82a3037efc$var$_react = $aeef9d82a3037efc$var$_interopRequireDefault((parcelRequire("acw62")));

var $aeef9d82a3037efc$var$_propTypes = $aeef9d82a3037efc$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $aeef9d82a3037efc$var$_classnames = $aeef9d82a3037efc$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $aeef9d82a3037efc$var$_element = $aeef9d82a3037efc$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $aeef9d82a3037efc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $aeef9d82a3037efc$var$_extends() {
    $aeef9d82a3037efc$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $aeef9d82a3037efc$var$_extends.apply(this, arguments);
}
function $aeef9d82a3037efc$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $aeef9d82a3037efc$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $aeef9d82a3037efc$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $aeef9d82a3037efc$var$HeroBody = function HeroBody(_ref) {
    var className = _ref.className, props = $aeef9d82a3037efc$var$_objectWithoutProperties(_ref, [
        "className"
    ]);
    return /*#__PURE__*/ $aeef9d82a3037efc$var$_react["default"].createElement($aeef9d82a3037efc$var$_element["default"], $aeef9d82a3037efc$var$_extends({}, props, {
        className: (0, $aeef9d82a3037efc$var$_classnames["default"])(className, 'hero-body')
    }));
};
$aeef9d82a3037efc$var$HeroBody.defaultProps = {
    renderAs: 'div'
};
var $aeef9d82a3037efc$var$_default = $aeef9d82a3037efc$var$HeroBody;
module.exports["default"] = $aeef9d82a3037efc$var$_default;

});

parcelRegister("aGhpF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $7c6b5581633f8387$var$_react = $7c6b5581633f8387$var$_interopRequireDefault((parcelRequire("acw62")));

var $7c6b5581633f8387$var$_propTypes = $7c6b5581633f8387$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $7c6b5581633f8387$var$_classnames = $7c6b5581633f8387$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $7c6b5581633f8387$var$_element = $7c6b5581633f8387$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $7c6b5581633f8387$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $7c6b5581633f8387$var$_extends() {
    $7c6b5581633f8387$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7c6b5581633f8387$var$_extends.apply(this, arguments);
}
function $7c6b5581633f8387$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $7c6b5581633f8387$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $7c6b5581633f8387$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $7c6b5581633f8387$var$HeroFooter = function HeroFooter(_ref) {
    var className = _ref.className, props = $7c6b5581633f8387$var$_objectWithoutProperties(_ref, [
        "className"
    ]);
    return /*#__PURE__*/ $7c6b5581633f8387$var$_react["default"].createElement($7c6b5581633f8387$var$_element["default"], $7c6b5581633f8387$var$_extends({}, props, {
        className: (0, $7c6b5581633f8387$var$_classnames["default"])(className, 'hero-foot')
    }));
};
$7c6b5581633f8387$var$HeroFooter.defaultProps = {
    renderAs: 'footer'
};
var $7c6b5581633f8387$var$_default = $7c6b5581633f8387$var$HeroFooter;
module.exports["default"] = $7c6b5581633f8387$var$_default;

});



parcelRegister("hWHZF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $d109faa9b576386c$var$_level = $d109faa9b576386c$var$_interopRequireDefault((parcelRequire("2fyGS")));
function $d109faa9b576386c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $d109faa9b576386c$var$_default = $d109faa9b576386c$var$_level["default"];
module.exports["default"] = $d109faa9b576386c$var$_default;

});
parcelRegister("2fyGS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $1a37e451910cc5e7$var$_react = $1a37e451910cc5e7$var$_interopRequireDefault((parcelRequire("acw62")));

var $1a37e451910cc5e7$var$_propTypes = $1a37e451910cc5e7$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $1a37e451910cc5e7$var$_classnames2 = $1a37e451910cc5e7$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $1a37e451910cc5e7$var$_levelSide = $1a37e451910cc5e7$var$_interopRequireDefault((parcelRequire("3yjAI")));

var $1a37e451910cc5e7$var$_levelItem = $1a37e451910cc5e7$var$_interopRequireDefault((parcelRequire("f0B9p")));

var $1a37e451910cc5e7$var$_element = $1a37e451910cc5e7$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $1a37e451910cc5e7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $1a37e451910cc5e7$var$_extends() {
    $1a37e451910cc5e7$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1a37e451910cc5e7$var$_extends.apply(this, arguments);
}
function $1a37e451910cc5e7$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1a37e451910cc5e7$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $1a37e451910cc5e7$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $1a37e451910cc5e7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $1a37e451910cc5e7$var$Level = function Level(_ref) {
    var children = _ref.children, className = _ref.className, breakpoint = _ref.breakpoint, props = $1a37e451910cc5e7$var$_objectWithoutProperties(_ref, [
        "children",
        "className",
        "breakpoint"
    ]);
    return /*#__PURE__*/ $1a37e451910cc5e7$var$_react["default"].createElement($1a37e451910cc5e7$var$_element["default"], $1a37e451910cc5e7$var$_extends({}, props, {
        className: (0, $1a37e451910cc5e7$var$_classnames2["default"])('level', className, $1a37e451910cc5e7$var$_defineProperty({}, "is-".concat(breakpoint), breakpoint))
    }), children);
};
$1a37e451910cc5e7$var$Level.Side = $1a37e451910cc5e7$var$_levelSide["default"];
$1a37e451910cc5e7$var$Level.Item = $1a37e451910cc5e7$var$_levelItem["default"];
$1a37e451910cc5e7$var$Level.defaultProps = {
    renderAs: 'nav'
};
var $1a37e451910cc5e7$var$_default = $1a37e451910cc5e7$var$Level;
module.exports["default"] = $1a37e451910cc5e7$var$_default;

});
parcelRegister("3yjAI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $2963be75c97135cb$var$_react = $2963be75c97135cb$var$_interopRequireDefault((parcelRequire("acw62")));

var $2963be75c97135cb$var$_propTypes = $2963be75c97135cb$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $2963be75c97135cb$var$_classnames2 = $2963be75c97135cb$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $2963be75c97135cb$var$_element = $2963be75c97135cb$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $2963be75c97135cb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $2963be75c97135cb$var$_extends() {
    $2963be75c97135cb$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2963be75c97135cb$var$_extends.apply(this, arguments);
}
function $2963be75c97135cb$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2963be75c97135cb$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $2963be75c97135cb$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $2963be75c97135cb$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $2963be75c97135cb$var$LevelSide = function LevelSide(_ref) {
    var className = _ref.className, align = _ref.align, props = $2963be75c97135cb$var$_objectWithoutProperties(_ref, [
        "className",
        "align"
    ]);
    return /*#__PURE__*/ $2963be75c97135cb$var$_react["default"].createElement($2963be75c97135cb$var$_element["default"], $2963be75c97135cb$var$_extends({}, props, {
        className: (0, $2963be75c97135cb$var$_classnames2["default"])(className, $2963be75c97135cb$var$_defineProperty({}, "level-".concat(align), align))
    }));
};
$2963be75c97135cb$var$LevelSide.defaultProps = {
    align: 'left'
};
var $2963be75c97135cb$var$_default = $2963be75c97135cb$var$LevelSide;
module.exports["default"] = $2963be75c97135cb$var$_default;

});

parcelRegister("f0B9p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $aed3ac7d0bd2dfee$var$_react = $aed3ac7d0bd2dfee$var$_interopRequireDefault((parcelRequire("acw62")));

var $aed3ac7d0bd2dfee$var$_classnames = $aed3ac7d0bd2dfee$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $aed3ac7d0bd2dfee$var$_element = $aed3ac7d0bd2dfee$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $aed3ac7d0bd2dfee$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $aed3ac7d0bd2dfee$var$_extends() {
    $aed3ac7d0bd2dfee$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $aed3ac7d0bd2dfee$var$_extends.apply(this, arguments);
}
function $aed3ac7d0bd2dfee$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $aed3ac7d0bd2dfee$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $aed3ac7d0bd2dfee$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $aed3ac7d0bd2dfee$var$LevelItem = function LevelItem(_ref) {
    var children = _ref.children, className = _ref.className, props = $aed3ac7d0bd2dfee$var$_objectWithoutProperties(_ref, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ $aed3ac7d0bd2dfee$var$_react["default"].createElement($aed3ac7d0bd2dfee$var$_element["default"], $aed3ac7d0bd2dfee$var$_extends({}, props, {
        className: (0, $aed3ac7d0bd2dfee$var$_classnames["default"])('level-item', className, {})
    }), children);
};
var $aed3ac7d0bd2dfee$var$_default = $aed3ac7d0bd2dfee$var$LevelItem;
module.exports["default"] = $aed3ac7d0bd2dfee$var$_default;

});



parcelRegister("4193C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $2ece48005fec3383$var$_media = $2ece48005fec3383$var$_interopRequireDefault((parcelRequire("3EKTj")));
function $2ece48005fec3383$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $2ece48005fec3383$var$_default = $2ece48005fec3383$var$_media["default"];
module.exports["default"] = $2ece48005fec3383$var$_default;

});
parcelRegister("3EKTj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $2a997b23889104ae$var$_react = $2a997b23889104ae$var$_interopRequireDefault((parcelRequire("acw62")));

var $2a997b23889104ae$var$_propTypes = $2a997b23889104ae$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $2a997b23889104ae$var$_classnames = $2a997b23889104ae$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $2a997b23889104ae$var$_mediaItem = $2a997b23889104ae$var$_interopRequireDefault((parcelRequire("6veU4")));

var $2a997b23889104ae$var$_element = $2a997b23889104ae$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $2a997b23889104ae$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $2a997b23889104ae$var$_extends() {
    $2a997b23889104ae$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2a997b23889104ae$var$_extends.apply(this, arguments);
}
function $2a997b23889104ae$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $2a997b23889104ae$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $2a997b23889104ae$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $2a997b23889104ae$var$Media = function Media(_ref) {
    var children = _ref.children, className = _ref.className, props = $2a997b23889104ae$var$_objectWithoutProperties(_ref, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ $2a997b23889104ae$var$_react["default"].createElement($2a997b23889104ae$var$_element["default"], $2a997b23889104ae$var$_extends({}, props, {
        className: (0, $2a997b23889104ae$var$_classnames["default"])('media', className, {})
    }), children);
};
$2a997b23889104ae$var$Media.Item = $2a997b23889104ae$var$_mediaItem["default"];
$2a997b23889104ae$var$Media.defaultProps = {
    renderAs: 'article'
};
var $2a997b23889104ae$var$_default = $2a997b23889104ae$var$Media;
module.exports["default"] = $2a997b23889104ae$var$_default;

});
parcelRegister("6veU4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $4bc132d07ddd83e4$var$_react = $4bc132d07ddd83e4$var$_interopRequireDefault((parcelRequire("acw62")));

var $4bc132d07ddd83e4$var$_propTypes = $4bc132d07ddd83e4$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $4bc132d07ddd83e4$var$_classnames2 = $4bc132d07ddd83e4$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $4bc132d07ddd83e4$var$_element = $4bc132d07ddd83e4$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $4bc132d07ddd83e4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $4bc132d07ddd83e4$var$_extends() {
    $4bc132d07ddd83e4$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4bc132d07ddd83e4$var$_extends.apply(this, arguments);
}
function $4bc132d07ddd83e4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4bc132d07ddd83e4$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $4bc132d07ddd83e4$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $4bc132d07ddd83e4$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $4bc132d07ddd83e4$var$MediaItem = function MediaItem(_ref) {
    var children = _ref.children, className = _ref.className, align = _ref.align, props = $4bc132d07ddd83e4$var$_objectWithoutProperties(_ref, [
        "children",
        "className",
        "align"
    ]);
    var p = align === 'center' ? 'content' : align;
    return /*#__PURE__*/ $4bc132d07ddd83e4$var$_react["default"].createElement($4bc132d07ddd83e4$var$_element["default"], $4bc132d07ddd83e4$var$_extends({}, props, {
        className: (0, $4bc132d07ddd83e4$var$_classnames2["default"])(className, $4bc132d07ddd83e4$var$_defineProperty({}, "media-".concat(p), p))
    }), children);
};
$4bc132d07ddd83e4$var$MediaItem.defaultProps = {
    align: 'center'
};
var $4bc132d07ddd83e4$var$_default = $4bc132d07ddd83e4$var$MediaItem;
module.exports["default"] = $4bc132d07ddd83e4$var$_default;

});



parcelRegister("cpj6E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $0254c0945d43091b$var$_notification = $0254c0945d43091b$var$_interopRequireDefault((parcelRequire("cHX6I")));
function $0254c0945d43091b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $0254c0945d43091b$var$_default = $0254c0945d43091b$var$_notification["default"];
module.exports["default"] = $0254c0945d43091b$var$_default;

});
parcelRegister("cHX6I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $940759b003e9cfc2$var$_react = $940759b003e9cfc2$var$_interopRequireDefault((parcelRequire("acw62")));

var $940759b003e9cfc2$var$_propTypes = $940759b003e9cfc2$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $940759b003e9cfc2$var$_classnames2 = $940759b003e9cfc2$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $940759b003e9cfc2$var$_element = $940759b003e9cfc2$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $940759b003e9cfc2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $940759b003e9cfc2$var$_extends() {
    $940759b003e9cfc2$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $940759b003e9cfc2$var$_extends.apply(this, arguments);
}
function $940759b003e9cfc2$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $940759b003e9cfc2$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $940759b003e9cfc2$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $940759b003e9cfc2$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $940759b003e9cfc2$var$Notification = function Notification(_ref) {
    var _classnames;
    var className = _ref.className, color = _ref.color, light = _ref.light, props = $940759b003e9cfc2$var$_objectWithoutProperties(_ref, [
        "className",
        "color",
        "light"
    ]);
    return /*#__PURE__*/ $940759b003e9cfc2$var$_react["default"].createElement($940759b003e9cfc2$var$_element["default"], $940759b003e9cfc2$var$_extends({}, props, {
        className: (0, $940759b003e9cfc2$var$_classnames2["default"])('notification', (_classnames = {}, $940759b003e9cfc2$var$_defineProperty(_classnames, "is-".concat(color), color), $940759b003e9cfc2$var$_defineProperty(_classnames, 'is-light', light), _classnames), className)
    }));
};
var $940759b003e9cfc2$var$_default = $940759b003e9cfc2$var$Notification;
module.exports["default"] = $940759b003e9cfc2$var$_default;

});


parcelRegister("fd74O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $b12d8f2e57f6e0e5$var$_progress = $b12d8f2e57f6e0e5$var$_interopRequireDefault((parcelRequire("8C3lG")));
function $b12d8f2e57f6e0e5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $b12d8f2e57f6e0e5$var$_default = $b12d8f2e57f6e0e5$var$_progress["default"];
module.exports["default"] = $b12d8f2e57f6e0e5$var$_default;

});
parcelRegister("8C3lG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $6454784d6d6a519e$var$_react = $6454784d6d6a519e$var$_interopRequireDefault((parcelRequire("acw62")));

var $6454784d6d6a519e$var$_propTypes = $6454784d6d6a519e$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $6454784d6d6a519e$var$_classnames2 = $6454784d6d6a519e$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $6454784d6d6a519e$var$_element = $6454784d6d6a519e$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $6454784d6d6a519e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $6454784d6d6a519e$var$_extends() {
    $6454784d6d6a519e$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6454784d6d6a519e$var$_extends.apply(this, arguments);
}
function $6454784d6d6a519e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6454784d6d6a519e$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6454784d6d6a519e$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $6454784d6d6a519e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $6454784d6d6a519e$var$Progress = function Progress(_ref) {
    var _classnames;
    var className = _ref.className, value = _ref.value, max = _ref.max, color = _ref.color, size = _ref.size, props = $6454784d6d6a519e$var$_objectWithoutProperties(_ref, [
        "className",
        "value",
        "max",
        "color",
        "size"
    ]);
    return /*#__PURE__*/ $6454784d6d6a519e$var$_react["default"].createElement($6454784d6d6a519e$var$_element["default"], $6454784d6d6a519e$var$_extends({}, props, {
        value: value,
        max: max,
        className: (0, $6454784d6d6a519e$var$_classnames2["default"])('progress', className, (_classnames = {}, $6454784d6d6a519e$var$_defineProperty(_classnames, "is-".concat(color), color), $6454784d6d6a519e$var$_defineProperty(_classnames, "is-".concat(size), size), _classnames))
    }));
};
$6454784d6d6a519e$var$Progress.defaultProps = {
    renderAs: 'progress'
};
var $6454784d6d6a519e$var$_default = $6454784d6d6a519e$var$Progress;
module.exports["default"] = $6454784d6d6a519e$var$_default;

});


parcelRegister("5fxKp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $3d288805803460f7$var$_section = $3d288805803460f7$var$_interopRequireDefault((parcelRequire("4hPM7")));
function $3d288805803460f7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $3d288805803460f7$var$_default = $3d288805803460f7$var$_section["default"];
module.exports["default"] = $3d288805803460f7$var$_default;

});
parcelRegister("4hPM7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $31f0e966d43994c2$var$_react = $31f0e966d43994c2$var$_interopRequireDefault((parcelRequire("acw62")));

var $31f0e966d43994c2$var$_propTypes = $31f0e966d43994c2$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $31f0e966d43994c2$var$_classnames2 = $31f0e966d43994c2$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $31f0e966d43994c2$var$_element = $31f0e966d43994c2$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $31f0e966d43994c2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $31f0e966d43994c2$var$_extends() {
    $31f0e966d43994c2$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $31f0e966d43994c2$var$_extends.apply(this, arguments);
}
function $31f0e966d43994c2$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $31f0e966d43994c2$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $31f0e966d43994c2$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $31f0e966d43994c2$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $31f0e966d43994c2$var$Section = function Section(_ref) {
    var children = _ref.children, className = _ref.className, size = _ref.size, props = $31f0e966d43994c2$var$_objectWithoutProperties(_ref, [
        "children",
        "className",
        "size"
    ]);
    return /*#__PURE__*/ $31f0e966d43994c2$var$_react["default"].createElement($31f0e966d43994c2$var$_element["default"], $31f0e966d43994c2$var$_extends({}, props, {
        className: (0, $31f0e966d43994c2$var$_classnames2["default"])('section', className, $31f0e966d43994c2$var$_defineProperty({}, "is-".concat(size), size))
    }), children);
};
$31f0e966d43994c2$var$Section.defaultProps = {
    renderAs: 'section'
};
var $31f0e966d43994c2$var$_default = $31f0e966d43994c2$var$Section;
module.exports["default"] = $31f0e966d43994c2$var$_default;

});


parcelRegister("7GBox", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $59897678635dfa64$var$_tabs = $59897678635dfa64$var$_interopRequireDefault((parcelRequire("db56i")));
function $59897678635dfa64$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $59897678635dfa64$var$_default = $59897678635dfa64$var$_tabs["default"];
module.exports["default"] = $59897678635dfa64$var$_default;

});
parcelRegister("db56i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $9980424ac37f978f$var$_react = $9980424ac37f978f$var$_interopRequireDefault((parcelRequire("acw62")));

var $9980424ac37f978f$var$_propTypes = $9980424ac37f978f$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $9980424ac37f978f$var$_classnames2 = $9980424ac37f978f$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $9980424ac37f978f$var$_tab = $9980424ac37f978f$var$_interopRequireDefault((parcelRequire("4zdHp")));

var $9980424ac37f978f$var$_element = $9980424ac37f978f$var$_interopRequireDefault((parcelRequire("9rI5f")));

var $R5V3X = parcelRequire("R5V3X");
function $9980424ac37f978f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $9980424ac37f978f$var$_extends() {
    $9980424ac37f978f$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9980424ac37f978f$var$_extends.apply(this, arguments);
}
function $9980424ac37f978f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9980424ac37f978f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $9980424ac37f978f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $9980424ac37f978f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $9980424ac37f978f$var$Tabs = function Tabs(_ref) {
    var _classnames;
    var children = _ref.children, className = _ref.className, align = _ref.align, size = _ref.size, type = _ref.type, fullwidth = _ref.fullwidth, props = $9980424ac37f978f$var$_objectWithoutProperties(_ref, [
        "children",
        "className",
        "align",
        "size",
        "type",
        "fullwidth"
    ]);
    return /*#__PURE__*/ $9980424ac37f978f$var$_react["default"].createElement($9980424ac37f978f$var$_element["default"], $9980424ac37f978f$var$_extends({}, props, {
        className: (0, $9980424ac37f978f$var$_classnames2["default"])('tabs', className, (_classnames = {}, $9980424ac37f978f$var$_defineProperty(_classnames, "is-".concat((0, $R5V3X.normalizeAlign)(align)), align), $9980424ac37f978f$var$_defineProperty(_classnames, "is-".concat(size), size), $9980424ac37f978f$var$_defineProperty(_classnames, 'is-toggle', type === 'toggle-rounded'), $9980424ac37f978f$var$_defineProperty(_classnames, "is-".concat(type), type), $9980424ac37f978f$var$_defineProperty(_classnames, 'is-fullwidth', fullwidth), _classnames))
    }), /*#__PURE__*/ $9980424ac37f978f$var$_react["default"].createElement("ul", null, children));
};
$9980424ac37f978f$var$Tabs.Tab = $9980424ac37f978f$var$_tab["default"];
var $9980424ac37f978f$var$_default = $9980424ac37f978f$var$Tabs;
module.exports["default"] = $9980424ac37f978f$var$_default;

});
parcelRegister("4zdHp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $35350ea77ebcc28e$var$_react = $35350ea77ebcc28e$var$_interopRequireDefault((parcelRequire("acw62")));

var $35350ea77ebcc28e$var$_propTypes = $35350ea77ebcc28e$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $35350ea77ebcc28e$var$_classnames = $35350ea77ebcc28e$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $35350ea77ebcc28e$var$_element = $35350ea77ebcc28e$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $35350ea77ebcc28e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $35350ea77ebcc28e$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $35350ea77ebcc28e$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $35350ea77ebcc28e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $35350ea77ebcc28e$var$Tab = function Tab(_ref) {
    var children = _ref.children, className = _ref.className, style = _ref.style, active = _ref.active, domRef = _ref.domRef, props = $35350ea77ebcc28e$var$_objectWithoutProperties(_ref, [
        "children",
        "className",
        "style",
        "active",
        "domRef"
    ]);
    return /*#__PURE__*/ $35350ea77ebcc28e$var$_react["default"].createElement("li", {
        ref: domRef,
        style: style,
        className: (0, $35350ea77ebcc28e$var$_classnames["default"])(className, {
            'is-active': active
        })
    }, /*#__PURE__*/ $35350ea77ebcc28e$var$_react["default"].createElement($35350ea77ebcc28e$var$_element["default"], props, children));
};
$35350ea77ebcc28e$var$Tab.defaultProps = {
    renderAs: 'a'
};
var $35350ea77ebcc28e$var$_default = $35350ea77ebcc28e$var$Tab;
module.exports["default"] = $35350ea77ebcc28e$var$_default;

});



parcelRegister("a6WHJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $75c8005bb94020a3$var$_table = $75c8005bb94020a3$var$_interopRequireDefault((parcelRequire("bbTeP")));
function $75c8005bb94020a3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $75c8005bb94020a3$var$_default = $75c8005bb94020a3$var$_table["default"];
module.exports["default"] = $75c8005bb94020a3$var$_default;

});
parcelRegister("bbTeP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $825b91f4f7548398$var$_react = $825b91f4f7548398$var$_interopRequireDefault((parcelRequire("acw62")));

var $825b91f4f7548398$var$_propTypes = $825b91f4f7548398$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $825b91f4f7548398$var$_classnames2 = $825b91f4f7548398$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $825b91f4f7548398$var$_element = $825b91f4f7548398$var$_interopRequireDefault((parcelRequire("9rI5f")));

var $825b91f4f7548398$var$_container = $825b91f4f7548398$var$_interopRequireDefault((parcelRequire("6QJvP")));
function $825b91f4f7548398$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $825b91f4f7548398$var$_extends() {
    $825b91f4f7548398$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $825b91f4f7548398$var$_extends.apply(this, arguments);
}
function $825b91f4f7548398$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $825b91f4f7548398$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $825b91f4f7548398$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $825b91f4f7548398$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $825b91f4f7548398$var$Table = function Table(_ref) {
    var _classnames;
    var children = _ref.children, className = _ref.className, size = _ref.size, striped = _ref.striped, bordered = _ref.bordered, hoverable = _ref.hoverable, props = $825b91f4f7548398$var$_objectWithoutProperties(_ref, [
        "children",
        "className",
        "size",
        "striped",
        "bordered",
        "hoverable"
    ]);
    return /*#__PURE__*/ $825b91f4f7548398$var$_react["default"].createElement($825b91f4f7548398$var$_element["default"], $825b91f4f7548398$var$_extends({}, props, {
        renderAs: "table",
        className: (0, $825b91f4f7548398$var$_classnames2["default"])('table', className, (_classnames = {}, $825b91f4f7548398$var$_defineProperty(_classnames, "is-".concat(size), size), $825b91f4f7548398$var$_defineProperty(_classnames, 'is-bordered', bordered), $825b91f4f7548398$var$_defineProperty(_classnames, 'is-striped', striped), $825b91f4f7548398$var$_defineProperty(_classnames, 'is-hoverable', hoverable), _classnames))
    }), children);
};
$825b91f4f7548398$var$Table.defaultProps = {};
$825b91f4f7548398$var$Table.Container = $825b91f4f7548398$var$_container["default"];
var $825b91f4f7548398$var$_default = $825b91f4f7548398$var$Table;
module.exports["default"] = $825b91f4f7548398$var$_default;

});
parcelRegister("6QJvP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $4fcae7385a732292$var$_react = $4fcae7385a732292$var$_interopRequireDefault((parcelRequire("acw62")));

var $4fcae7385a732292$var$_classnames = $4fcae7385a732292$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $4fcae7385a732292$var$_element = $4fcae7385a732292$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $4fcae7385a732292$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $4fcae7385a732292$var$_extends() {
    $4fcae7385a732292$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4fcae7385a732292$var$_extends.apply(this, arguments);
}
function $4fcae7385a732292$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $4fcae7385a732292$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $4fcae7385a732292$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $4fcae7385a732292$var$TableContainer = function TableContainer(_ref) {
    var className = _ref.className, props = $4fcae7385a732292$var$_objectWithoutProperties(_ref, [
        "className"
    ]);
    return /*#__PURE__*/ $4fcae7385a732292$var$_react["default"].createElement($4fcae7385a732292$var$_element["default"], $4fcae7385a732292$var$_extends({}, props, {
        className: (0, $4fcae7385a732292$var$_classnames["default"])('table-container', className)
    }));
};
$4fcae7385a732292$var$TableContainer.defaultProps = {};
var $4fcae7385a732292$var$_default = $4fcae7385a732292$var$TableContainer;
module.exports["default"] = $4fcae7385a732292$var$_default;

});



parcelRegister("9mk3w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $6d05b9d11d3a6a47$var$_tag = $6d05b9d11d3a6a47$var$_interopRequireDefault((parcelRequire("VkLX6")));
function $6d05b9d11d3a6a47$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $6d05b9d11d3a6a47$var$_default = $6d05b9d11d3a6a47$var$_tag["default"];
module.exports["default"] = $6d05b9d11d3a6a47$var$_default;

});
parcelRegister("VkLX6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $0ac56ff4e976b67d$var$_react = $0ac56ff4e976b67d$var$_interopRequireDefault((parcelRequire("acw62")));

var $0ac56ff4e976b67d$var$_propTypes = $0ac56ff4e976b67d$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $0ac56ff4e976b67d$var$_classnames2 = $0ac56ff4e976b67d$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $0ac56ff4e976b67d$var$_tagGroup = $0ac56ff4e976b67d$var$_interopRequireDefault((parcelRequire("58pe7")));

var $0ac56ff4e976b67d$var$_element = $0ac56ff4e976b67d$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $0ac56ff4e976b67d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $0ac56ff4e976b67d$var$_extends() {
    $0ac56ff4e976b67d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0ac56ff4e976b67d$var$_extends.apply(this, arguments);
}
function $0ac56ff4e976b67d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0ac56ff4e976b67d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $0ac56ff4e976b67d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $0ac56ff4e976b67d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $0ac56ff4e976b67d$var$Tag = function Tag(_ref) {
    var _classnames;
    var children = _ref.children, className = _ref.className, color = _ref.color, size = _ref.size, rounded = _ref.rounded, remove = _ref.remove, props = $0ac56ff4e976b67d$var$_objectWithoutProperties(_ref, [
        "children",
        "className",
        "color",
        "size",
        "rounded",
        "remove"
    ]);
    return /*#__PURE__*/ $0ac56ff4e976b67d$var$_react["default"].createElement($0ac56ff4e976b67d$var$_element["default"], $0ac56ff4e976b67d$var$_extends({}, props, {
        className: (0, $0ac56ff4e976b67d$var$_classnames2["default"])('tag', className, (_classnames = {}, $0ac56ff4e976b67d$var$_defineProperty(_classnames, "is-".concat(size), size), $0ac56ff4e976b67d$var$_defineProperty(_classnames, "is-".concat(color), color), $0ac56ff4e976b67d$var$_defineProperty(_classnames, 'is-rounded', rounded), $0ac56ff4e976b67d$var$_defineProperty(_classnames, 'is-delete', remove), _classnames))
    }), !remove && children);
};
$0ac56ff4e976b67d$var$Tag.Group = $0ac56ff4e976b67d$var$_tagGroup["default"];
$0ac56ff4e976b67d$var$Tag.defaultProps = {
    renderAs: 'span'
};
var $0ac56ff4e976b67d$var$_default = $0ac56ff4e976b67d$var$Tag;
module.exports["default"] = $0ac56ff4e976b67d$var$_default;

});
parcelRegister("58pe7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $3bd144a175649393$var$_react = $3bd144a175649393$var$_interopRequireDefault((parcelRequire("acw62")));

var $3bd144a175649393$var$_propTypes = $3bd144a175649393$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $3bd144a175649393$var$_classnames = $3bd144a175649393$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $3bd144a175649393$var$_element = $3bd144a175649393$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $3bd144a175649393$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $3bd144a175649393$var$_extends() {
    $3bd144a175649393$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3bd144a175649393$var$_extends.apply(this, arguments);
}
function $3bd144a175649393$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $3bd144a175649393$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $3bd144a175649393$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $3bd144a175649393$var$TagGroup = function TagGroup(_ref) {
    var children = _ref.children, className = _ref.className, gapless = _ref.gapless, hasAddons = _ref.hasAddons, props = $3bd144a175649393$var$_objectWithoutProperties(_ref, [
        "children",
        "className",
        "gapless",
        "hasAddons"
    ]);
    return /*#__PURE__*/ $3bd144a175649393$var$_react["default"].createElement($3bd144a175649393$var$_element["default"], $3bd144a175649393$var$_extends({}, props, {
        className: (0, $3bd144a175649393$var$_classnames["default"])('tags', className, {
            'has-addons': gapless || hasAddons
        })
    }), children);
};
$3bd144a175649393$var$TagGroup.defaultProps = {
    renderAs: 'span'
};
var $3bd144a175649393$var$_default = $3bd144a175649393$var$TagGroup;
module.exports["default"] = $3bd144a175649393$var$_default;

});



parcelRegister("78A1j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $5325389ee5f4470c$var$_tile = $5325389ee5f4470c$var$_interopRequireDefault((parcelRequire("fQEq2")));
function $5325389ee5f4470c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $5325389ee5f4470c$var$_default = $5325389ee5f4470c$var$_tile["default"];
module.exports["default"] = $5325389ee5f4470c$var$_default;

});
parcelRegister("fQEq2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $b89b10b018f32428$var$_react = $b89b10b018f32428$var$_interopRequireDefault((parcelRequire("acw62")));

var $b89b10b018f32428$var$_propTypes = $b89b10b018f32428$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $b89b10b018f32428$var$_classnames2 = $b89b10b018f32428$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $b89b10b018f32428$var$_element = $b89b10b018f32428$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $b89b10b018f32428$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $b89b10b018f32428$var$_extends() {
    $b89b10b018f32428$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b89b10b018f32428$var$_extends.apply(this, arguments);
}
function $b89b10b018f32428$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b89b10b018f32428$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b89b10b018f32428$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $b89b10b018f32428$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $b89b10b018f32428$var$Tile = function Tile(_ref) {
    var _classnames;
    var children = _ref.children, className = _ref.className, kind = _ref.kind, vertical = _ref.vertical, size = _ref.size, color = _ref.color, props = $b89b10b018f32428$var$_objectWithoutProperties(_ref, [
        "children",
        "className",
        "kind",
        "vertical",
        "size",
        "color"
    ]);
    return /*#__PURE__*/ $b89b10b018f32428$var$_react["default"].createElement($b89b10b018f32428$var$_element["default"], $b89b10b018f32428$var$_extends({}, props, {
        className: (0, $b89b10b018f32428$var$_classnames2["default"])('tile', className, (_classnames = {}, $b89b10b018f32428$var$_defineProperty(_classnames, "is-".concat(kind), kind), $b89b10b018f32428$var$_defineProperty(_classnames, "is-".concat(size), size), $b89b10b018f32428$var$_defineProperty(_classnames, "is-".concat(color), color), $b89b10b018f32428$var$_defineProperty(_classnames, 'is-vertical', vertical), _classnames))
    }), children);
};
var $b89b10b018f32428$var$_default = $b89b10b018f32428$var$Tile;
module.exports["default"] = $b89b10b018f32428$var$_default;

});


parcelRegister("gxwfC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $c0a8bec7a94d4527$var$_modal = $c0a8bec7a94d4527$var$_interopRequireDefault((parcelRequire("dniwI")));
function $c0a8bec7a94d4527$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $c0a8bec7a94d4527$var$_default = $c0a8bec7a94d4527$var$_modal["default"];
module.exports["default"] = $c0a8bec7a94d4527$var$_default;

});
parcelRegister("dniwI", function(module, exports) {
"use strict";
function $9bcbcb5fa2822126$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $9bcbcb5fa2822126$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $9bcbcb5fa2822126$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $9bcbcb5fa2822126$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $9bcbcb5fa2822126$var$_react = $9bcbcb5fa2822126$var$_interopRequireWildcard((parcelRequire("acw62")));

var $9bcbcb5fa2822126$var$_reactDom = $9bcbcb5fa2822126$var$_interopRequireDefault((parcelRequire("1u0KT")));

var $9bcbcb5fa2822126$var$_propTypes = $9bcbcb5fa2822126$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $9bcbcb5fa2822126$var$_classnames = $9bcbcb5fa2822126$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $9bcbcb5fa2822126$var$_content = $9bcbcb5fa2822126$var$_interopRequireDefault((parcelRequire("4ORlK")));

var $9bcbcb5fa2822126$var$_card = $9bcbcb5fa2822126$var$_interopRequireDefault((parcelRequire("3LHZJ")));

var $5YTKA = parcelRequire("5YTKA");

var $9bcbcb5fa2822126$var$_element = $9bcbcb5fa2822126$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $9bcbcb5fa2822126$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $9bcbcb5fa2822126$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $9bcbcb5fa2822126$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $9bcbcb5fa2822126$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || $9bcbcb5fa2822126$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $9bcbcb5fa2822126$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $9bcbcb5fa2822126$var$_slicedToArray(arr, i) {
    return $9bcbcb5fa2822126$var$_arrayWithHoles(arr) || $9bcbcb5fa2822126$var$_iterableToArrayLimit(arr, i) || $9bcbcb5fa2822126$var$_unsupportedIterableToArray(arr, i) || $9bcbcb5fa2822126$var$_nonIterableRest();
}
function $9bcbcb5fa2822126$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9bcbcb5fa2822126$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9bcbcb5fa2822126$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9bcbcb5fa2822126$var$_arrayLikeToArray(o, minLen);
}
function $9bcbcb5fa2822126$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9bcbcb5fa2822126$var$_iterableToArrayLimit(arr, i) {
    var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $9bcbcb5fa2822126$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $9bcbcb5fa2822126$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $9bcbcb5fa2822126$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $9bcbcb5fa2822126$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $9bcbcb5fa2822126$var$KEYCODES = {
    ESCAPE: 27
};
var $9bcbcb5fa2822126$var$Modal = function Modal(_ref) {
    var domRef = _ref.domRef, children = _ref.children, className = _ref.className, show = _ref.show, closeOnBlur = _ref.closeOnBlur, showClose = _ref.showClose, onClose = _ref.onClose, closeOnEsc = _ref.closeOnEsc, props = $9bcbcb5fa2822126$var$_objectWithoutProperties(_ref, [
        "domRef",
        "children",
        "className",
        "show",
        "closeOnBlur",
        "showClose",
        "onClose",
        "closeOnEsc"
    ]);
    var ref = (0, $9bcbcb5fa2822126$var$_react.useRef)(domRef);
    var _useState = (0, $9bcbcb5fa2822126$var$_react.useState)(), _useState2 = $9bcbcb5fa2822126$var$_slicedToArray(_useState, 2), portalContainer = _useState2[0], setPortalContainer = _useState2[1];
    (0, $9bcbcb5fa2822126$var$_react.useEffect)(function() {
        if (!show) return undefined;
        var doc = props.document || document;
        var container = doc.createElement('div');
        container.setAttribute('class', 'modal-container');
        doc.body.appendChild(container);
        setPortalContainer(container);
        var handleKeydown = function handleKeydown(evt) {
            if (evt.keyCode === $9bcbcb5fa2822126$var$KEYCODES.ESCAPE && show) onClose();
        };
        if (closeOnEsc) doc.addEventListener('keydown', handleKeydown);
        return function() {
            doc.removeEventListener('keydown', handleKeydown);
            container.parentNode.removeChild(container);
        };
    }, [
        show
    ]);
    if (!portalContainer) return null;
    return /*#__PURE__*/ $9bcbcb5fa2822126$var$_reactDom["default"].createPortal(/*#__PURE__*/ $9bcbcb5fa2822126$var$_react["default"].createElement($5YTKA.ModalContext.Provider, {
        value: {
            onClose: onClose
        }
    }, /*#__PURE__*/ $9bcbcb5fa2822126$var$_react["default"].createElement($9bcbcb5fa2822126$var$_element["default"], {
        domRef: ref,
        className: (0, $9bcbcb5fa2822126$var$_classnames["default"])('modal', className, {
            'is-active': show
        })
    }, /*#__PURE__*/ $9bcbcb5fa2822126$var$_react["default"].createElement("div", {
        role: "presentation",
        className: "modal-background",
        onClick: closeOnBlur ? onClose : undefined
    }), children, showClose && /*#__PURE__*/ $9bcbcb5fa2822126$var$_react["default"].createElement("button", {
        type: "button",
        onClick: onClose,
        className: "modal-close is-large",
        "aria-label": "close"
    }))), portalContainer);
};
$9bcbcb5fa2822126$var$Modal.Content = $9bcbcb5fa2822126$var$_content["default"];
$9bcbcb5fa2822126$var$Modal.Card = $9bcbcb5fa2822126$var$_card["default"];
$9bcbcb5fa2822126$var$Modal.defaultProps = {
    closeOnEsc: true,
    showClose: true,
    // Expose mount point for testing
    document: undefined
};
var $9bcbcb5fa2822126$var$_default = $9bcbcb5fa2822126$var$Modal;
module.exports["default"] = $9bcbcb5fa2822126$var$_default;

});
parcelRegister("4ORlK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $3825371770dd956c$var$_react = $3825371770dd956c$var$_interopRequireDefault((parcelRequire("acw62")));

var $3825371770dd956c$var$_classnames = $3825371770dd956c$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $3825371770dd956c$var$_element = $3825371770dd956c$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $3825371770dd956c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $3825371770dd956c$var$_extends() {
    $3825371770dd956c$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3825371770dd956c$var$_extends.apply(this, arguments);
}
function $3825371770dd956c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $3825371770dd956c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $3825371770dd956c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $3825371770dd956c$var$ModalContent = function ModalContent(_ref) {
    var children = _ref.children, className = _ref.className, props = $3825371770dd956c$var$_objectWithoutProperties(_ref, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ $3825371770dd956c$var$_react["default"].createElement($3825371770dd956c$var$_element["default"], $3825371770dd956c$var$_extends({}, props, {
        className: (0, $3825371770dd956c$var$_classnames["default"])('modal-content', className)
    }), children);
};
var $3825371770dd956c$var$_default = $3825371770dd956c$var$ModalContent;
module.exports["default"] = $3825371770dd956c$var$_default;

});

parcelRegister("3LHZJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $2be7e355876d06c1$var$_card = $2be7e355876d06c1$var$_interopRequireDefault((parcelRequire("ly6tx")));
function $2be7e355876d06c1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $2be7e355876d06c1$var$_default = $2be7e355876d06c1$var$_card["default"];
module.exports["default"] = $2be7e355876d06c1$var$_default;

});
parcelRegister("ly6tx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $fb01cbd1c8f4f693$var$_react = $fb01cbd1c8f4f693$var$_interopRequireDefault((parcelRequire("acw62")));

var $fb01cbd1c8f4f693$var$_classnames = $fb01cbd1c8f4f693$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $fb01cbd1c8f4f693$var$_header = $fb01cbd1c8f4f693$var$_interopRequireDefault((parcelRequire("aL8zX")));

var $fb01cbd1c8f4f693$var$_body = $fb01cbd1c8f4f693$var$_interopRequireDefault((parcelRequire("82TQy")));

var $fb01cbd1c8f4f693$var$_footer = $fb01cbd1c8f4f693$var$_interopRequireDefault((parcelRequire("855fS")));

var $fb01cbd1c8f4f693$var$_title = $fb01cbd1c8f4f693$var$_interopRequireDefault((parcelRequire("epWTt")));

var $fb01cbd1c8f4f693$var$_element = $fb01cbd1c8f4f693$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $fb01cbd1c8f4f693$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $fb01cbd1c8f4f693$var$_extends() {
    $fb01cbd1c8f4f693$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fb01cbd1c8f4f693$var$_extends.apply(this, arguments);
}
function $fb01cbd1c8f4f693$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $fb01cbd1c8f4f693$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $fb01cbd1c8f4f693$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $fb01cbd1c8f4f693$var$ModalCard = function ModalCard(_ref) {
    var className = _ref.className, onClose = _ref.onClose, children = _ref.children, props = $fb01cbd1c8f4f693$var$_objectWithoutProperties(_ref, [
        "className",
        "onClose",
        "children"
    ]);
    return /*#__PURE__*/ $fb01cbd1c8f4f693$var$_react["default"].createElement($fb01cbd1c8f4f693$var$_element["default"], $fb01cbd1c8f4f693$var$_extends({}, props, {
        className: (0, $fb01cbd1c8f4f693$var$_classnames["default"])('modal-card', className)
    }), children);
};
$fb01cbd1c8f4f693$var$ModalCard.Header = $fb01cbd1c8f4f693$var$_header["default"];
$fb01cbd1c8f4f693$var$ModalCard.Body = $fb01cbd1c8f4f693$var$_body["default"];
$fb01cbd1c8f4f693$var$ModalCard.Footer = $fb01cbd1c8f4f693$var$_footer["default"];
$fb01cbd1c8f4f693$var$ModalCard.Title = $fb01cbd1c8f4f693$var$_title["default"];
$fb01cbd1c8f4f693$var$ModalCard.defaultProps = {};
var $fb01cbd1c8f4f693$var$_default = $fb01cbd1c8f4f693$var$ModalCard;
module.exports["default"] = $fb01cbd1c8f4f693$var$_default;

});
parcelRegister("aL8zX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $7d54f2c6e693d73a$var$_react = $7d54f2c6e693d73a$var$_interopRequireDefault((parcelRequire("acw62")));

var $7d54f2c6e693d73a$var$_propTypes = $7d54f2c6e693d73a$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $7d54f2c6e693d73a$var$_classnames = $7d54f2c6e693d73a$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $7d54f2c6e693d73a$var$_button = $7d54f2c6e693d73a$var$_interopRequireDefault((parcelRequire("dcCpL")));

var $7d54f2c6e693d73a$var$_element = $7d54f2c6e693d73a$var$_interopRequireDefault((parcelRequire("9rI5f")));

var $7d54f2c6e693d73a$var$_context = $7d54f2c6e693d73a$var$_interopRequireDefault((parcelRequire("5YTKA")));
function $7d54f2c6e693d73a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $7d54f2c6e693d73a$var$_extends() {
    $7d54f2c6e693d73a$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7d54f2c6e693d73a$var$_extends.apply(this, arguments);
}
function $7d54f2c6e693d73a$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $7d54f2c6e693d73a$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $7d54f2c6e693d73a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $7d54f2c6e693d73a$var$ModalCardHead = function ModalCardHead(_ref) {
    var children = _ref.children, className = _ref.className, showClose = _ref.showClose, props = $7d54f2c6e693d73a$var$_objectWithoutProperties(_ref, [
        "children",
        "className",
        "showClose"
    ]);
    var _useModalContext = (0, $7d54f2c6e693d73a$var$_context["default"])(), onClose = _useModalContext.onClose;
    return /*#__PURE__*/ $7d54f2c6e693d73a$var$_react["default"].createElement($7d54f2c6e693d73a$var$_element["default"], $7d54f2c6e693d73a$var$_extends({}, props, {
        className: (0, $7d54f2c6e693d73a$var$_classnames["default"])('modal-card-head', className)
    }), children, showClose && /*#__PURE__*/ $7d54f2c6e693d73a$var$_react["default"].createElement($7d54f2c6e693d73a$var$_button["default"], {
        remove: true,
        onClick: onClose
    }));
};
$7d54f2c6e693d73a$var$ModalCardHead.defaultProps = {
    showClose: true,
    renderAs: 'header'
};
var $7d54f2c6e693d73a$var$_default = $7d54f2c6e693d73a$var$ModalCardHead;
module.exports["default"] = $7d54f2c6e693d73a$var$_default;

});
parcelRegister("5YTKA", function(module, exports) {
"use strict";
function $45adcd37c4b1135e$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $45adcd37c4b1135e$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $45adcd37c4b1135e$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $45adcd37c4b1135e$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.ModalContext = void 0;

var $45adcd37c4b1135e$var$_react = $45adcd37c4b1135e$var$_interopRequireWildcard((parcelRequire("acw62")));
function $45adcd37c4b1135e$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $45adcd37c4b1135e$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $45adcd37c4b1135e$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || $45adcd37c4b1135e$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $45adcd37c4b1135e$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $45adcd37c4b1135e$var$ModalContext = /*#__PURE__*/ $45adcd37c4b1135e$var$_react["default"].createContext({
    onClose: function onClose() {}
});
module.exports.ModalContext = $45adcd37c4b1135e$var$ModalContext;
var $45adcd37c4b1135e$var$useModalContext = function useModalContext() {
    return (0, $45adcd37c4b1135e$var$_react.useContext)($45adcd37c4b1135e$var$ModalContext);
};
var $45adcd37c4b1135e$var$_default = $45adcd37c4b1135e$var$useModalContext;
module.exports["default"] = $45adcd37c4b1135e$var$_default;

});


parcelRegister("82TQy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $5db9d4a2b5962350$var$_react = $5db9d4a2b5962350$var$_interopRequireDefault((parcelRequire("acw62")));

var $5db9d4a2b5962350$var$_propTypes = $5db9d4a2b5962350$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $5db9d4a2b5962350$var$_classnames = $5db9d4a2b5962350$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $5db9d4a2b5962350$var$_element = $5db9d4a2b5962350$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $5db9d4a2b5962350$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $5db9d4a2b5962350$var$_extends() {
    $5db9d4a2b5962350$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5db9d4a2b5962350$var$_extends.apply(this, arguments);
}
function $5db9d4a2b5962350$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $5db9d4a2b5962350$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $5db9d4a2b5962350$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $5db9d4a2b5962350$var$ModalCardBody = function ModalCardBody(_ref) {
    var children = _ref.children, className = _ref.className, props = $5db9d4a2b5962350$var$_objectWithoutProperties(_ref, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ $5db9d4a2b5962350$var$_react["default"].createElement($5db9d4a2b5962350$var$_element["default"], $5db9d4a2b5962350$var$_extends({}, props, {
        className: (0, $5db9d4a2b5962350$var$_classnames["default"])('modal-card-body', className)
    }), children);
};
$5db9d4a2b5962350$var$ModalCardBody.defaultProps = {
    renderAs: 'section'
};
var $5db9d4a2b5962350$var$_default = $5db9d4a2b5962350$var$ModalCardBody;
module.exports["default"] = $5db9d4a2b5962350$var$_default;

});

parcelRegister("855fS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $5e22dde7e0d94a2f$var$_react = $5e22dde7e0d94a2f$var$_interopRequireDefault((parcelRequire("acw62")));

var $5e22dde7e0d94a2f$var$_propTypes = $5e22dde7e0d94a2f$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $5e22dde7e0d94a2f$var$_classnames = $5e22dde7e0d94a2f$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $5e22dde7e0d94a2f$var$_element = $5e22dde7e0d94a2f$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $5e22dde7e0d94a2f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $5e22dde7e0d94a2f$var$_extends() {
    $5e22dde7e0d94a2f$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5e22dde7e0d94a2f$var$_extends.apply(this, arguments);
}
function $5e22dde7e0d94a2f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $5e22dde7e0d94a2f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $5e22dde7e0d94a2f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $5e22dde7e0d94a2f$var$ModalCardFoot = function ModalCardFoot(_ref) {
    var children = _ref.children, className = _ref.className, props = $5e22dde7e0d94a2f$var$_objectWithoutProperties(_ref, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ $5e22dde7e0d94a2f$var$_react["default"].createElement($5e22dde7e0d94a2f$var$_element["default"], $5e22dde7e0d94a2f$var$_extends({}, props, {
        className: (0, $5e22dde7e0d94a2f$var$_classnames["default"])('modal-card-foot', className)
    }), children);
};
$5e22dde7e0d94a2f$var$ModalCardFoot.defaultProps = {
    renderAs: 'footer'
};
var $5e22dde7e0d94a2f$var$_default = $5e22dde7e0d94a2f$var$ModalCardFoot;
module.exports["default"] = $5e22dde7e0d94a2f$var$_default;

});

parcelRegister("epWTt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $a7f115892342d888$var$_react = $a7f115892342d888$var$_interopRequireDefault((parcelRequire("acw62")));

var $a7f115892342d888$var$_propTypes = $a7f115892342d888$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $a7f115892342d888$var$_classnames = $a7f115892342d888$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $a7f115892342d888$var$_element = $a7f115892342d888$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $a7f115892342d888$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $a7f115892342d888$var$_extends() {
    $a7f115892342d888$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a7f115892342d888$var$_extends.apply(this, arguments);
}
function $a7f115892342d888$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a7f115892342d888$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a7f115892342d888$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $a7f115892342d888$var$ModalCardTitle = function ModalCardTitle(_ref) {
    var children = _ref.children, className = _ref.className, props = $a7f115892342d888$var$_objectWithoutProperties(_ref, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ $a7f115892342d888$var$_react["default"].createElement($a7f115892342d888$var$_element["default"], $a7f115892342d888$var$_extends({}, props, {
        className: (0, $a7f115892342d888$var$_classnames["default"])('modal-card-title', className)
    }), children);
};
$a7f115892342d888$var$ModalCardTitle.defaultProps = {
    renderAs: 'p'
};
var $a7f115892342d888$var$_default = $a7f115892342d888$var$ModalCardTitle;
module.exports["default"] = $a7f115892342d888$var$_default;

});





parcelRegister("iK1sd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $da4da6a1522a71f4$var$_dropdown = $da4da6a1522a71f4$var$_interopRequireDefault((parcelRequire("f8ukn")));
function $da4da6a1522a71f4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $da4da6a1522a71f4$var$_default = $da4da6a1522a71f4$var$_dropdown["default"];
module.exports["default"] = $da4da6a1522a71f4$var$_default;

});
parcelRegister("f8ukn", function(module, exports) {
"use strict";
function $b04f20cf125306a5$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $b04f20cf125306a5$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $b04f20cf125306a5$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $b04f20cf125306a5$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $b04f20cf125306a5$var$_react = $b04f20cf125306a5$var$_interopRequireWildcard((parcelRequire("acw62")));

var $b04f20cf125306a5$var$_propTypes = $b04f20cf125306a5$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $b04f20cf125306a5$var$_classnames = $b04f20cf125306a5$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $b04f20cf125306a5$var$_item = $b04f20cf125306a5$var$_interopRequireDefault((parcelRequire("gmHq4")));

var $b04f20cf125306a5$var$_divider = $b04f20cf125306a5$var$_interopRequireDefault((parcelRequire("l2tJE")));

var $b04f20cf125306a5$var$_button = $b04f20cf125306a5$var$_interopRequireDefault((parcelRequire("dcCpL")));

var $b04f20cf125306a5$var$_element = $b04f20cf125306a5$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $b04f20cf125306a5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $b04f20cf125306a5$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $b04f20cf125306a5$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $b04f20cf125306a5$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || $b04f20cf125306a5$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $b04f20cf125306a5$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $b04f20cf125306a5$var$_extends() {
    $b04f20cf125306a5$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b04f20cf125306a5$var$_extends.apply(this, arguments);
}
function $b04f20cf125306a5$var$_slicedToArray(arr, i) {
    return $b04f20cf125306a5$var$_arrayWithHoles(arr) || $b04f20cf125306a5$var$_iterableToArrayLimit(arr, i) || $b04f20cf125306a5$var$_unsupportedIterableToArray(arr, i) || $b04f20cf125306a5$var$_nonIterableRest();
}
function $b04f20cf125306a5$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b04f20cf125306a5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b04f20cf125306a5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b04f20cf125306a5$var$_arrayLikeToArray(o, minLen);
}
function $b04f20cf125306a5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b04f20cf125306a5$var$_iterableToArrayLimit(arr, i) {
    var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $b04f20cf125306a5$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $b04f20cf125306a5$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b04f20cf125306a5$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $b04f20cf125306a5$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $b04f20cf125306a5$var$Dropdown = function Dropdown(_ref) {
    var className = _ref.className, children = _ref.children, value = _ref.value, color = _ref.color, align = _ref.align, right = _ref.right, up = _ref.up, hoverable = _ref.hoverable, label = _ref.label, onChange = _ref.onChange, closeOnSelect = _ref.closeOnSelect, icon = _ref.icon, domRef = _ref.domRef, disabled = _ref.disabled, props = $b04f20cf125306a5$var$_objectWithoutProperties(_ref, [
        "className",
        "children",
        "value",
        "color",
        "align",
        "right",
        "up",
        "hoverable",
        "label",
        "onChange",
        "closeOnSelect",
        "icon",
        "domRef",
        "disabled"
    ]);
    var ref = (0, $b04f20cf125306a5$var$_react.useRef)(domRef);
    var _useState = (0, $b04f20cf125306a5$var$_react.useState)(false), _useState2 = $b04f20cf125306a5$var$_slicedToArray(_useState, 2), isOpen = _useState2[0], setIsOpen = _useState2[1];
    var close = function close(evt) {
        // IDK yet how to test using the ref in enzime
        // istanbul ignore if
        if (hoverable || evt && ref && ref.current && ref.current.contains(evt.target)) return;
        if (ref.current) setIsOpen(false);
    };
    var onSelect = function onSelect(selectedValue) {
        return function() {
            if (onChange) onChange(selectedValue);
            if (closeOnSelect) close();
        };
    };
    (0, $b04f20cf125306a5$var$_react.useEffect)(function() {
        window.addEventListener('click', close);
        return function() {
            window.removeEventListener('click', close);
        };
    }, []);
    var current = label;
    var childrenArray = $b04f20cf125306a5$var$_react["default"].Children.map(children, function(child, i) {
        if (child.type === $b04f20cf125306a5$var$_item["default"] && (i === 0 && !label || child.props.value === value)) current = child.props.children;
        return /*#__PURE__*/ $b04f20cf125306a5$var$_react["default"].cloneElement(child, child.type === $b04f20cf125306a5$var$_item["default"] ? {
            active: child.props.value === value,
            onClick: onSelect(child.props.value)
        } : {});
    });
    return /*#__PURE__*/ $b04f20cf125306a5$var$_react["default"].createElement($b04f20cf125306a5$var$_element["default"], $b04f20cf125306a5$var$_extends({}, props, {
        domRef: ref,
        className: (0, $b04f20cf125306a5$var$_classnames["default"])('dropdown', className, {
            'is-active': isOpen,
            'is-up': up,
            'is-right': right || align === 'right',
            'is-hoverable': hoverable
        })
    }), /*#__PURE__*/ $b04f20cf125306a5$var$_react["default"].createElement("div", {
        className: "dropdown-trigger",
        role: "presentation",
        onClick: function onClick() {
            if (disabled) return;
            setIsOpen(function(open) {
                return !open;
            });
        }
    }, /*#__PURE__*/ $b04f20cf125306a5$var$_react["default"].createElement($b04f20cf125306a5$var$_button["default"], {
        disabled: disabled,
        color: color
    }, /*#__PURE__*/ $b04f20cf125306a5$var$_react["default"].createElement("span", null, current), icon)), /*#__PURE__*/ $b04f20cf125306a5$var$_react["default"].createElement("div", {
        className: "dropdown-menu",
        id: "dropdown-menu",
        role: "menu"
    }, /*#__PURE__*/ $b04f20cf125306a5$var$_react["default"].createElement("div", {
        className: "dropdown-content"
    }, childrenArray)));
};
$b04f20cf125306a5$var$Dropdown.Item = $b04f20cf125306a5$var$_item["default"];
$b04f20cf125306a5$var$Dropdown.Divider = $b04f20cf125306a5$var$_divider["default"];
$b04f20cf125306a5$var$Dropdown.defaultProps = {
    closeOnSelect: true
};
var $b04f20cf125306a5$var$_default = $b04f20cf125306a5$var$Dropdown;
module.exports["default"] = $b04f20cf125306a5$var$_default;

});
parcelRegister("gmHq4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $bea0619aad6913e6$var$_react = $bea0619aad6913e6$var$_interopRequireDefault((parcelRequire("acw62")));

var $bea0619aad6913e6$var$_propTypes = $bea0619aad6913e6$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $bea0619aad6913e6$var$_classnames = $bea0619aad6913e6$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $bea0619aad6913e6$var$_element = $bea0619aad6913e6$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $bea0619aad6913e6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $bea0619aad6913e6$var$_extends() {
    $bea0619aad6913e6$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bea0619aad6913e6$var$_extends.apply(this, arguments);
}
function $bea0619aad6913e6$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $bea0619aad6913e6$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $bea0619aad6913e6$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $bea0619aad6913e6$var$DropdownItem = function DropdownItem(_ref) {
    var active = _ref.active, children = _ref.children, value = _ref.value, className = _ref.className, props = $bea0619aad6913e6$var$_objectWithoutProperties(_ref, [
        "active",
        "children",
        "value",
        "className"
    ]);
    return /*#__PURE__*/ $bea0619aad6913e6$var$_react["default"].createElement($bea0619aad6913e6$var$_element["default"], $bea0619aad6913e6$var$_extends({
        title: value
    }, props, {
        role: "presentation",
        className: (0, $bea0619aad6913e6$var$_classnames["default"])(className, 'dropdown-item', {
            'is-active': active
        })
    }), children);
};
$bea0619aad6913e6$var$DropdownItem.defaultProps = {};
var $bea0619aad6913e6$var$_default = $bea0619aad6913e6$var$DropdownItem;
module.exports["default"] = $bea0619aad6913e6$var$_default;

});

parcelRegister("l2tJE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $f510d9aed2335ab4$var$_react = $f510d9aed2335ab4$var$_interopRequireDefault((parcelRequire("acw62")));

var $f510d9aed2335ab4$var$_classnames = $f510d9aed2335ab4$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $f510d9aed2335ab4$var$_element = $f510d9aed2335ab4$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $f510d9aed2335ab4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $f510d9aed2335ab4$var$_extends() {
    $f510d9aed2335ab4$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f510d9aed2335ab4$var$_extends.apply(this, arguments);
}
function $f510d9aed2335ab4$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $f510d9aed2335ab4$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $f510d9aed2335ab4$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $f510d9aed2335ab4$var$DropdownDivider = function DropdownDivider(_ref) {
    var className = _ref.className, props = $f510d9aed2335ab4$var$_objectWithoutProperties(_ref, [
        "className"
    ]);
    return /*#__PURE__*/ $f510d9aed2335ab4$var$_react["default"].createElement($f510d9aed2335ab4$var$_element["default"], $f510d9aed2335ab4$var$_extends({}, props, {
        className: (0, $f510d9aed2335ab4$var$_classnames["default"])('dropdown-divider', className)
    }));
};
$f510d9aed2335ab4$var$DropdownDivider.defaultProps = {
    renderAs: 'hr'
};
var $f510d9aed2335ab4$var$_default = $f510d9aed2335ab4$var$DropdownDivider;
module.exports["default"] = $f510d9aed2335ab4$var$_default;

});



parcelRegister("gckJY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $bcaddaf3701614bd$var$_loader = $bcaddaf3701614bd$var$_interopRequireDefault((parcelRequire("kzrx0")));
function $bcaddaf3701614bd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $bcaddaf3701614bd$var$_default = $bcaddaf3701614bd$var$_loader["default"];
module.exports["default"] = $bcaddaf3701614bd$var$_default;

});
parcelRegister("kzrx0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $ef9c6eb00b3b3686$var$_react = $ef9c6eb00b3b3686$var$_interopRequireDefault((parcelRequire("acw62")));

var $ef9c6eb00b3b3686$var$_classnames = $ef9c6eb00b3b3686$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $ef9c6eb00b3b3686$var$_element = $ef9c6eb00b3b3686$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $ef9c6eb00b3b3686$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $ef9c6eb00b3b3686$var$_extends() {
    $ef9c6eb00b3b3686$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ef9c6eb00b3b3686$var$_extends.apply(this, arguments);
}
function $ef9c6eb00b3b3686$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ef9c6eb00b3b3686$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $ef9c6eb00b3b3686$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $ef9c6eb00b3b3686$var$Loader = function Loader(_ref) {
    var children = _ref.children, className = _ref.className, props = $ef9c6eb00b3b3686$var$_objectWithoutProperties(_ref, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ $ef9c6eb00b3b3686$var$_react["default"].createElement($ef9c6eb00b3b3686$var$_element["default"], $ef9c6eb00b3b3686$var$_extends({}, props, {
        className: (0, $ef9c6eb00b3b3686$var$_classnames["default"])('loader', className)
    }), children);
};
var $ef9c6eb00b3b3686$var$_default = $ef9c6eb00b3b3686$var$Loader;
module.exports["default"] = $ef9c6eb00b3b3686$var$_default;

});


parcelRegister("27h0F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $18a96e016d0e7bea$var$_navbar = $18a96e016d0e7bea$var$_interopRequireDefault((parcelRequire("f6OOo")));
function $18a96e016d0e7bea$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $18a96e016d0e7bea$var$_default = $18a96e016d0e7bea$var$_navbar["default"];
module.exports["default"] = $18a96e016d0e7bea$var$_default;

});
parcelRegister("f6OOo", function(module, exports) {
"use strict";
function $affed4b62ec0871c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $affed4b62ec0871c$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $affed4b62ec0871c$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $affed4b62ec0871c$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $affed4b62ec0871c$var$_react = $affed4b62ec0871c$var$_interopRequireWildcard((parcelRequire("acw62")));

var $affed4b62ec0871c$var$_propTypes = $affed4b62ec0871c$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $affed4b62ec0871c$var$_classnames2 = $affed4b62ec0871c$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $affed4b62ec0871c$var$_brand = $affed4b62ec0871c$var$_interopRequireDefault((parcelRequire("jA5K2")));

var $affed4b62ec0871c$var$_burger = $affed4b62ec0871c$var$_interopRequireDefault((parcelRequire("aq0qA")));

var $affed4b62ec0871c$var$_menu = $affed4b62ec0871c$var$_interopRequireDefault((parcelRequire("5eMFx")));

var $affed4b62ec0871c$var$_item = $affed4b62ec0871c$var$_interopRequireDefault((parcelRequire("1cnbW")));

var $affed4b62ec0871c$var$_dropdown = $affed4b62ec0871c$var$_interopRequireDefault((parcelRequire("llqpD")));

var $affed4b62ec0871c$var$_divider = $affed4b62ec0871c$var$_interopRequireDefault((parcelRequire("exiNg")));

var $affed4b62ec0871c$var$_link = $affed4b62ec0871c$var$_interopRequireDefault((parcelRequire("al32h")));

var $affed4b62ec0871c$var$_container = $affed4b62ec0871c$var$_interopRequireDefault((parcelRequire("j3VVv")));

var $2jvo3 = parcelRequire("2jvo3");

var $affed4b62ec0871c$var$_element = $affed4b62ec0871c$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $affed4b62ec0871c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $affed4b62ec0871c$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $affed4b62ec0871c$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $affed4b62ec0871c$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || $affed4b62ec0871c$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $affed4b62ec0871c$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $affed4b62ec0871c$var$_extends() {
    $affed4b62ec0871c$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $affed4b62ec0871c$var$_extends.apply(this, arguments);
}
function $affed4b62ec0871c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $affed4b62ec0871c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $affed4b62ec0871c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $affed4b62ec0871c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $affed4b62ec0871c$var$Navbar = function Navbar(_ref) {
    var _classnames;
    var children = _ref.children, className = _ref.className, fixed = _ref.fixed, transparent = _ref.transparent, color = _ref.color, active = _ref.active, size = _ref.size, props = $affed4b62ec0871c$var$_objectWithoutProperties(_ref, [
        "children",
        "className",
        "fixed",
        "transparent",
        "color",
        "active",
        "size"
    ]);
    (0, $affed4b62ec0871c$var$_react.useEffect)(function() {
        var html = window.document.querySelector('html');
        if (!html.classList.contains("has-navbar-fixed-".concat(fixed))) {
            html.classList.remove('has-navbar-fixed-top');
            html.classList.remove('has-navbar-fixed-bottom');
        }
        if (fixed) html.classList.add("has-navbar-fixed-".concat(fixed));
        return function() {
            return window.document.querySelector('html').classList.remove("has-navbar-fixed-".concat(fixed));
        };
    }, [
        fixed
    ]);
    return /*#__PURE__*/ $affed4b62ec0871c$var$_react["default"].createElement($2jvo3.ShowContext.Provider, {
        value: active
    }, /*#__PURE__*/ $affed4b62ec0871c$var$_react["default"].createElement($affed4b62ec0871c$var$_element["default"], $affed4b62ec0871c$var$_extends({}, props, {
        role: "navigation",
        className: (0, $affed4b62ec0871c$var$_classnames2["default"])('navbar', className, (_classnames = {
            'is-transparent': transparent
        }, $affed4b62ec0871c$var$_defineProperty(_classnames, "is-fixed-".concat(fixed), fixed), $affed4b62ec0871c$var$_defineProperty(_classnames, "is-".concat(color), color), $affed4b62ec0871c$var$_defineProperty(_classnames, "is-spaced", size === 'large'), _classnames))
    }), children));
};
$affed4b62ec0871c$var$Navbar.defaultProps = {
    renderAs: 'nav'
};
$affed4b62ec0871c$var$Navbar.Brand = $affed4b62ec0871c$var$_brand["default"];
$affed4b62ec0871c$var$Navbar.Burger = $affed4b62ec0871c$var$_burger["default"];
$affed4b62ec0871c$var$Navbar.Menu = $affed4b62ec0871c$var$_menu["default"];
$affed4b62ec0871c$var$Navbar.Item = $affed4b62ec0871c$var$_item["default"];
$affed4b62ec0871c$var$Navbar.Dropdown = $affed4b62ec0871c$var$_dropdown["default"];
$affed4b62ec0871c$var$Navbar.Link = $affed4b62ec0871c$var$_link["default"];
$affed4b62ec0871c$var$Navbar.Divider = $affed4b62ec0871c$var$_divider["default"];
$affed4b62ec0871c$var$Navbar.Container = $affed4b62ec0871c$var$_container["default"];
var $affed4b62ec0871c$var$_default = $affed4b62ec0871c$var$Navbar;
module.exports["default"] = $affed4b62ec0871c$var$_default;

});
parcelRegister("jA5K2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $e415d53f7820f3c9$var$_react = $e415d53f7820f3c9$var$_interopRequireDefault((parcelRequire("acw62")));

var $e415d53f7820f3c9$var$_classnames = $e415d53f7820f3c9$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $e415d53f7820f3c9$var$_element = $e415d53f7820f3c9$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $e415d53f7820f3c9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $e415d53f7820f3c9$var$_extends() {
    $e415d53f7820f3c9$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e415d53f7820f3c9$var$_extends.apply(this, arguments);
}
function $e415d53f7820f3c9$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e415d53f7820f3c9$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e415d53f7820f3c9$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $e415d53f7820f3c9$var$NavbarBrand = function NavbarBrand(_ref) {
    var className = _ref.className, children = _ref.children, props = $e415d53f7820f3c9$var$_objectWithoutProperties(_ref, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ $e415d53f7820f3c9$var$_react["default"].createElement($e415d53f7820f3c9$var$_element["default"], $e415d53f7820f3c9$var$_extends({}, props, {
        className: (0, $e415d53f7820f3c9$var$_classnames["default"])('navbar-brand', className)
    }), children);
};
$e415d53f7820f3c9$var$NavbarBrand.defaultProps = {};
var $e415d53f7820f3c9$var$_default = $e415d53f7820f3c9$var$NavbarBrand;
module.exports["default"] = $e415d53f7820f3c9$var$_default;

});

parcelRegister("aq0qA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $795caa0d0b23f53a$var$_react = $795caa0d0b23f53a$var$_interopRequireDefault((parcelRequire("acw62")));

var $795caa0d0b23f53a$var$_classnames = $795caa0d0b23f53a$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $2jvo3 = parcelRequire("2jvo3");

var $795caa0d0b23f53a$var$_element = $795caa0d0b23f53a$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $795caa0d0b23f53a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $795caa0d0b23f53a$var$_extends() {
    $795caa0d0b23f53a$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $795caa0d0b23f53a$var$_extends.apply(this, arguments);
}
function $795caa0d0b23f53a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $795caa0d0b23f53a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $795caa0d0b23f53a$var$ownKeys(Object(source), true).forEach(function(key) {
            $795caa0d0b23f53a$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $795caa0d0b23f53a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $795caa0d0b23f53a$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $795caa0d0b23f53a$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $795caa0d0b23f53a$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $795caa0d0b23f53a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $795caa0d0b23f53a$var$NavbarBurger = function NavbarBurger(_ref) {
    var style = _ref.style, className = _ref.className, props = $795caa0d0b23f53a$var$_objectWithoutProperties(_ref, [
        "style",
        "className"
    ]);
    return /*#__PURE__*/ $795caa0d0b23f53a$var$_react["default"].createElement($2jvo3.ShowContext.Consumer, null, function(active) {
        return /*#__PURE__*/ $795caa0d0b23f53a$var$_react["default"].createElement($795caa0d0b23f53a$var$_element["default"], $795caa0d0b23f53a$var$_extends({
            role: "button",
            tabIndex: "0",
            style: $795caa0d0b23f53a$var$_objectSpread({
                outline: 'none'
            }, style),
            className: (0, $795caa0d0b23f53a$var$_classnames["default"])('navbar-burger', className, {
                'is-active': active
            })
        }, props), /*#__PURE__*/ $795caa0d0b23f53a$var$_react["default"].createElement("span", null), /*#__PURE__*/ $795caa0d0b23f53a$var$_react["default"].createElement("span", null), /*#__PURE__*/ $795caa0d0b23f53a$var$_react["default"].createElement("span", null));
    });
};
$795caa0d0b23f53a$var$NavbarBurger.defaultProps = {};
var $795caa0d0b23f53a$var$_default = $795caa0d0b23f53a$var$NavbarBurger;
module.exports["default"] = $795caa0d0b23f53a$var$_default;

});
parcelRegister("2jvo3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ShowContext = void 0;

var $1af5b3ea102c6995$var$_react = $1af5b3ea102c6995$var$_interopRequireDefault((parcelRequire("acw62")));
function $1af5b3ea102c6995$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $1af5b3ea102c6995$var$ShowContext = /*#__PURE__*/ $1af5b3ea102c6995$var$_react["default"].createContext(false);
module.exports.ShowContext = $1af5b3ea102c6995$var$ShowContext;

});


parcelRegister("5eMFx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $3d040336020bf7d6$var$_react = $3d040336020bf7d6$var$_interopRequireDefault((parcelRequire("acw62")));

var $3d040336020bf7d6$var$_classnames = $3d040336020bf7d6$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $2jvo3 = parcelRequire("2jvo3");

var $3d040336020bf7d6$var$_element = $3d040336020bf7d6$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $3d040336020bf7d6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $3d040336020bf7d6$var$_extends() {
    $3d040336020bf7d6$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3d040336020bf7d6$var$_extends.apply(this, arguments);
}
function $3d040336020bf7d6$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $3d040336020bf7d6$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $3d040336020bf7d6$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $3d040336020bf7d6$var$NavbarMenu = function NavbarMenu(_ref) {
    var className = _ref.className, children = _ref.children, props = $3d040336020bf7d6$var$_objectWithoutProperties(_ref, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ $3d040336020bf7d6$var$_react["default"].createElement($2jvo3.ShowContext.Consumer, null, function(active) {
        return /*#__PURE__*/ $3d040336020bf7d6$var$_react["default"].createElement($3d040336020bf7d6$var$_element["default"], $3d040336020bf7d6$var$_extends({}, props, {
            className: (0, $3d040336020bf7d6$var$_classnames["default"])('navbar-menu', className, {
                'is-active': active
            })
        }), children);
    });
};
$3d040336020bf7d6$var$NavbarMenu.defaultProps = {};
var $3d040336020bf7d6$var$_default = $3d040336020bf7d6$var$NavbarMenu;
module.exports["default"] = $3d040336020bf7d6$var$_default;

});

parcelRegister("1cnbW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $0df8e6cb85806010$var$_react = $0df8e6cb85806010$var$_interopRequireDefault((parcelRequire("acw62")));

var $0df8e6cb85806010$var$_propTypes = $0df8e6cb85806010$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $0df8e6cb85806010$var$_classnames = $0df8e6cb85806010$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $0df8e6cb85806010$var$_dropdown = $0df8e6cb85806010$var$_interopRequireDefault((parcelRequire("llqpD")));

var $0df8e6cb85806010$var$_element = $0df8e6cb85806010$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $0df8e6cb85806010$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $0df8e6cb85806010$var$_extends() {
    $0df8e6cb85806010$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0df8e6cb85806010$var$_extends.apply(this, arguments);
}
function $0df8e6cb85806010$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $0df8e6cb85806010$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $0df8e6cb85806010$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $0df8e6cb85806010$var$NavbarItem = function NavbarItem(_ref) {
    var _dropdown$props;
    var className = _ref.className, active = _ref.active, children = _ref.children, hoverable = _ref.hoverable, renderAs = _ref.renderAs, arrowless = _ref.arrowless, props = $0df8e6cb85806010$var$_objectWithoutProperties(_ref, [
        "className",
        "active",
        "children",
        "hoverable",
        "renderAs",
        "arrowless"
    ]);
    var as = renderAs;
    var dropdown = $0df8e6cb85806010$var$_react["default"].Children.toArray(children).find(function(child) {
        return child.type === $0df8e6cb85806010$var$_dropdown["default"];
    });
    if (dropdown && renderAs === 'a') as = 'div';
    return /*#__PURE__*/ $0df8e6cb85806010$var$_react["default"].createElement($0df8e6cb85806010$var$_element["default"], $0df8e6cb85806010$var$_extends({}, props, {
        renderAs: as,
        className: (0, $0df8e6cb85806010$var$_classnames["default"])('navbar-item', className, {
            'is-active': active,
            'has-dropdown': dropdown,
            'is-hoverable': hoverable,
            'has-dropdown-up': dropdown && ((_dropdown$props = dropdown.props) === null || _dropdown$props === void 0 ? void 0 : _dropdown$props.up),
            'is-arrowless': arrowless
        })
    }), children);
};
$0df8e6cb85806010$var$NavbarItem.defaultProps = {
    renderAs: 'a'
};
var $0df8e6cb85806010$var$_default = $0df8e6cb85806010$var$NavbarItem;
module.exports["default"] = $0df8e6cb85806010$var$_default;

});
parcelRegister("llqpD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $f8a00c180029f4ef$var$_react = $f8a00c180029f4ef$var$_interopRequireDefault((parcelRequire("acw62")));

var $f8a00c180029f4ef$var$_propTypes = $f8a00c180029f4ef$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $f8a00c180029f4ef$var$_classnames = $f8a00c180029f4ef$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $f8a00c180029f4ef$var$_element = $f8a00c180029f4ef$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $f8a00c180029f4ef$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $f8a00c180029f4ef$var$_extends() {
    $f8a00c180029f4ef$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f8a00c180029f4ef$var$_extends.apply(this, arguments);
}
function $f8a00c180029f4ef$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $f8a00c180029f4ef$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $f8a00c180029f4ef$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $f8a00c180029f4ef$var$NavbarDropdown = function NavbarDropdown(_ref) {
    var className = _ref.className, boxed = _ref.boxed, right = _ref.right, children = _ref.children, props = $f8a00c180029f4ef$var$_objectWithoutProperties(_ref, [
        "className",
        "boxed",
        "right",
        "children"
    ]);
    return /*#__PURE__*/ $f8a00c180029f4ef$var$_react["default"].createElement($f8a00c180029f4ef$var$_element["default"], $f8a00c180029f4ef$var$_extends({}, props, {
        className: (0, $f8a00c180029f4ef$var$_classnames["default"])('navbar-dropdown', className, {
            'is-boxed': boxed,
            'is-right': right
        })
    }), children);
};
$f8a00c180029f4ef$var$NavbarDropdown.defaultProps = {
    renderAs: 'div'
};
var $f8a00c180029f4ef$var$_default = $f8a00c180029f4ef$var$NavbarDropdown;
module.exports["default"] = $f8a00c180029f4ef$var$_default;

});


parcelRegister("exiNg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $a952b9c454f6b3de$var$_react = $a952b9c454f6b3de$var$_interopRequireDefault((parcelRequire("acw62")));

var $a952b9c454f6b3de$var$_propTypes = $a952b9c454f6b3de$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $a952b9c454f6b3de$var$_classnames = $a952b9c454f6b3de$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $a952b9c454f6b3de$var$_element = $a952b9c454f6b3de$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $a952b9c454f6b3de$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $a952b9c454f6b3de$var$_extends() {
    $a952b9c454f6b3de$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a952b9c454f6b3de$var$_extends.apply(this, arguments);
}
function $a952b9c454f6b3de$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a952b9c454f6b3de$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a952b9c454f6b3de$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $a952b9c454f6b3de$var$NavbarDivider = function NavbarDivider(_ref) {
    var className = _ref.className, props = $a952b9c454f6b3de$var$_objectWithoutProperties(_ref, [
        "className"
    ]);
    return /*#__PURE__*/ $a952b9c454f6b3de$var$_react["default"].createElement($a952b9c454f6b3de$var$_element["default"], $a952b9c454f6b3de$var$_extends({}, props, {
        className: (0, $a952b9c454f6b3de$var$_classnames["default"])('navbar-divider', className)
    }));
};
$a952b9c454f6b3de$var$NavbarDivider.defaultProps = {
    renderAs: 'hr'
};
var $a952b9c454f6b3de$var$_default = $a952b9c454f6b3de$var$NavbarDivider;
module.exports["default"] = $a952b9c454f6b3de$var$_default;

});

parcelRegister("al32h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $786e386487d8041a$var$_react = $786e386487d8041a$var$_interopRequireDefault((parcelRequire("acw62")));

var $786e386487d8041a$var$_propTypes = $786e386487d8041a$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $786e386487d8041a$var$_classnames = $786e386487d8041a$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $786e386487d8041a$var$_element = $786e386487d8041a$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $786e386487d8041a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $786e386487d8041a$var$_extends() {
    $786e386487d8041a$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $786e386487d8041a$var$_extends.apply(this, arguments);
}
function $786e386487d8041a$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $786e386487d8041a$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $786e386487d8041a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $786e386487d8041a$var$NavbarLink = function NavbarLink(_ref) {
    var className = _ref.className, children = _ref.children, arrowless = _ref.arrowless, props = $786e386487d8041a$var$_objectWithoutProperties(_ref, [
        "className",
        "children",
        "arrowless"
    ]);
    return /*#__PURE__*/ $786e386487d8041a$var$_react["default"].createElement($786e386487d8041a$var$_element["default"], $786e386487d8041a$var$_extends({}, props, {
        className: (0, $786e386487d8041a$var$_classnames["default"])('navbar-link', className, {
            'is-arrowless': arrowless
        })
    }), children);
};
$786e386487d8041a$var$NavbarLink.defaultProps = {
    renderAs: 'span'
};
var $786e386487d8041a$var$_default = $786e386487d8041a$var$NavbarLink;
module.exports["default"] = $786e386487d8041a$var$_default;

});

parcelRegister("j3VVv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $de0b3b24e2d12313$var$_react = $de0b3b24e2d12313$var$_interopRequireDefault((parcelRequire("acw62")));

var $de0b3b24e2d12313$var$_propTypes = $de0b3b24e2d12313$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $de0b3b24e2d12313$var$_classnames2 = $de0b3b24e2d12313$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $de0b3b24e2d12313$var$_element = $de0b3b24e2d12313$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $de0b3b24e2d12313$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $de0b3b24e2d12313$var$_extends() {
    $de0b3b24e2d12313$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $de0b3b24e2d12313$var$_extends.apply(this, arguments);
}
function $de0b3b24e2d12313$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $de0b3b24e2d12313$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $de0b3b24e2d12313$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $de0b3b24e2d12313$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $de0b3b24e2d12313$var$alignMapper = {
    left: 'start',
    right: 'end'
};
var $de0b3b24e2d12313$var$NavbarContainer = function NavbarContainer(_ref) {
    var className = _ref.className, children = _ref.children, align = _ref.align, props = $de0b3b24e2d12313$var$_objectWithoutProperties(_ref, [
        "className",
        "children",
        "align"
    ]);
    return /*#__PURE__*/ $de0b3b24e2d12313$var$_react["default"].createElement($de0b3b24e2d12313$var$_element["default"], $de0b3b24e2d12313$var$_extends({}, props, {
        className: (0, $de0b3b24e2d12313$var$_classnames2["default"])($de0b3b24e2d12313$var$_defineProperty({}, "navbar-".concat($de0b3b24e2d12313$var$alignMapper[align]), $de0b3b24e2d12313$var$alignMapper[align]), className)
    }), children);
};
$de0b3b24e2d12313$var$NavbarContainer.defaultProps = {
    align: 'left'
};
var $de0b3b24e2d12313$var$_default = $de0b3b24e2d12313$var$NavbarContainer;
module.exports["default"] = $de0b3b24e2d12313$var$_default;

});



parcelRegister("l0TYH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $f4c5051cb426a12f$var$_pagination = $f4c5051cb426a12f$var$_interopRequireDefault((parcelRequire("jefd4")));
function $f4c5051cb426a12f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $f4c5051cb426a12f$var$_default = $f4c5051cb426a12f$var$_pagination["default"];
module.exports["default"] = $f4c5051cb426a12f$var$_default;

});
parcelRegister("jefd4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $dffb1f77ad9b32f2$var$_react = $dffb1f77ad9b32f2$var$_interopRequireDefault((parcelRequire("acw62")));

var $dffb1f77ad9b32f2$var$_propTypes = $dffb1f77ad9b32f2$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $dffb1f77ad9b32f2$var$_classnames2 = $dffb1f77ad9b32f2$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $R5V3X = parcelRequire("R5V3X");

var $dffb1f77ad9b32f2$var$_element = $dffb1f77ad9b32f2$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $dffb1f77ad9b32f2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $dffb1f77ad9b32f2$var$_extends() {
    $dffb1f77ad9b32f2$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dffb1f77ad9b32f2$var$_extends.apply(this, arguments);
}
function $dffb1f77ad9b32f2$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $dffb1f77ad9b32f2$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $dffb1f77ad9b32f2$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $dffb1f77ad9b32f2$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $dffb1f77ad9b32f2$var$getFirstPage = function getFirstPage(current, last, delta) {
    if (current === 1) return 1;
    var minPage = last - delta * 2;
    var page = Math.min(current - delta, minPage);
    return page <= 0 ? 1 : page;
};
var $dffb1f77ad9b32f2$var$getLastPage = function getLastPage(current, total, delta) {
    if (current === total) return total;
    var maxPage = delta * 2 + 1;
    var page = Math.max(current + delta, maxPage);
    return page > total ? total : page;
};
var $dffb1f77ad9b32f2$var$Pagination = function Pagination(_ref) {
    var _classnames;
    var current = _ref.current, disabled = _ref.disabled, total = _ref.total, next = _ref.next, previous = _ref.previous, showPrevNext = _ref.showPrevNext, showFirstLast = _ref.showFirstLast, delta = _ref.delta, autoHide = _ref.autoHide, className = _ref.className, size = _ref.size, align = _ref.align, rounded = _ref.rounded, onChange = _ref.onChange, props = $dffb1f77ad9b32f2$var$_objectWithoutProperties(_ref, [
        "current",
        "disabled",
        "total",
        "next",
        "previous",
        "showPrevNext",
        "showFirstLast",
        "delta",
        "autoHide",
        "className",
        "size",
        "align",
        "rounded",
        "onChange"
    ]);
    if (total <= 1 && autoHide || current > total) return null;
    var lastPage = $dffb1f77ad9b32f2$var$getLastPage(current, total, delta);
    var firstPage = $dffb1f77ad9b32f2$var$getFirstPage(current, lastPage, delta);
    var prevDisabled = current === 1 || disabled;
    var nextDisabled = current === total || disabled;
    return /*#__PURE__*/ $dffb1f77ad9b32f2$var$_react["default"].createElement($dffb1f77ad9b32f2$var$_element["default"], $dffb1f77ad9b32f2$var$_extends({}, props, {
        className: (0, $dffb1f77ad9b32f2$var$_classnames2["default"])('pagination', className, (_classnames = {}, $dffb1f77ad9b32f2$var$_defineProperty(_classnames, "is-".concat(size), size), $dffb1f77ad9b32f2$var$_defineProperty(_classnames, "is-".concat((0, $R5V3X.normalizeAlign)(align)), align), $dffb1f77ad9b32f2$var$_defineProperty(_classnames, 'is-rounded', rounded), _classnames)),
        "aria-label": "pagination"
    }), showPrevNext && /*#__PURE__*/ $dffb1f77ad9b32f2$var$_react["default"].createElement($dffb1f77ad9b32f2$var$_react["default"].Fragment, null, /*#__PURE__*/ $dffb1f77ad9b32f2$var$_react["default"].createElement("a", {
        role: "button",
        tabIndex: 0,
        onClick: prevDisabled ? undefined : function() {
            return onChange(current - 1);
        },
        className: "pagination-previous",
        title: "This is the first page",
        disabled: prevDisabled
    }, previous), /*#__PURE__*/ $dffb1f77ad9b32f2$var$_react["default"].createElement("a", {
        role: "button",
        tabIndex: 0,
        onClick: nextDisabled ? undefined : function() {
            return onChange(current + 1);
        },
        className: "pagination-next",
        disabled: nextDisabled
    }, next)), delta > 0 && /*#__PURE__*/ $dffb1f77ad9b32f2$var$_react["default"].createElement($dffb1f77ad9b32f2$var$_react["default"].Fragment, null, /*#__PURE__*/ $dffb1f77ad9b32f2$var$_react["default"].createElement("ul", {
        className: "pagination-list"
    }, showFirstLast && current !== 1 && firstPage !== 1 && /*#__PURE__*/ $dffb1f77ad9b32f2$var$_react["default"].createElement($dffb1f77ad9b32f2$var$_react["default"].Fragment, null, /*#__PURE__*/ $dffb1f77ad9b32f2$var$_react["default"].createElement("li", {
        key: 1
    }, /*#__PURE__*/ $dffb1f77ad9b32f2$var$_react["default"].createElement("a", {
        role: "button",
        tabIndex: 0,
        className: "pagination-link",
        onClick: function onClick() {
            return onChange(1);
        },
        "aria-label": "Page 1",
        "aria-current": "page",
        disabled: disabled
    }, "1")), /*#__PURE__*/ $dffb1f77ad9b32f2$var$_react["default"].createElement("li", null, /*#__PURE__*/ $dffb1f77ad9b32f2$var$_react["default"].createElement("span", {
        className: "pagination-ellipsis"
    }, "\u2026"))), Array(lastPage - firstPage + 1).fill(0).map(function(_, i) {
        return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
        $dffb1f77ad9b32f2$var$_react["default"].createElement("li", {
            key: i + firstPage
        }, /*#__PURE__*/ $dffb1f77ad9b32f2$var$_react["default"].createElement("a", {
            role: "button",
            tabIndex: 0,
            className: (0, $dffb1f77ad9b32f2$var$_classnames2["default"])('pagination-link', {
                'is-current': current === i + firstPage
            }),
            onClick: current === firstPage + i ? undefined : function() {
                return onChange(firstPage + i);
            },
            "aria-label": "Page ".concat(i + firstPage),
            "aria-current": "page",
            disabled: disabled
        }, i + firstPage)));
    }), showFirstLast && current !== lastPage && total !== lastPage && /*#__PURE__*/ $dffb1f77ad9b32f2$var$_react["default"].createElement($dffb1f77ad9b32f2$var$_react["default"].Fragment, null, /*#__PURE__*/ $dffb1f77ad9b32f2$var$_react["default"].createElement("li", {
        key: total
    }, /*#__PURE__*/ $dffb1f77ad9b32f2$var$_react["default"].createElement("span", {
        className: "pagination-ellipsis"
    }, "\u2026")), /*#__PURE__*/ $dffb1f77ad9b32f2$var$_react["default"].createElement("li", null, /*#__PURE__*/ $dffb1f77ad9b32f2$var$_react["default"].createElement("a", {
        role: "button",
        tabIndex: 0,
        className: "pagination-link",
        onClick: function onClick() {
            return onChange(total);
        },
        "aria-label": "Page ".concat(total),
        "aria-current": "page",
        disabled: disabled
    }, total))))));
};
$dffb1f77ad9b32f2$var$Pagination.defaultProps = {
    total: 1,
    current: 1,
    delta: 1,
    next: 'Next',
    previous: 'Previous',
    renderAs: 'nav',
    showPrevNext: true,
    autoHide: true
};
var $dffb1f77ad9b32f2$var$_default = $dffb1f77ad9b32f2$var$Pagination;
module.exports["default"] = $dffb1f77ad9b32f2$var$_default;

});


parcelRegister("lkdWn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $f8664784e27cac5c$var$_menu = $f8664784e27cac5c$var$_interopRequireDefault((parcelRequire("1lexK")));
function $f8664784e27cac5c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $f8664784e27cac5c$var$_default = $f8664784e27cac5c$var$_menu["default"];
module.exports["default"] = $f8664784e27cac5c$var$_default;

});
parcelRegister("1lexK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $0fa308a0e1f2fbb9$var$_react = $0fa308a0e1f2fbb9$var$_interopRequireDefault((parcelRequire("acw62")));

var $0fa308a0e1f2fbb9$var$_propTypes = $0fa308a0e1f2fbb9$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $0fa308a0e1f2fbb9$var$_classnames = $0fa308a0e1f2fbb9$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $0fa308a0e1f2fbb9$var$_list = $0fa308a0e1f2fbb9$var$_interopRequireDefault((parcelRequire("2orFf")));

var $0fa308a0e1f2fbb9$var$_element = $0fa308a0e1f2fbb9$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $0fa308a0e1f2fbb9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $0fa308a0e1f2fbb9$var$_extends() {
    $0fa308a0e1f2fbb9$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0fa308a0e1f2fbb9$var$_extends.apply(this, arguments);
}
function $0fa308a0e1f2fbb9$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $0fa308a0e1f2fbb9$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $0fa308a0e1f2fbb9$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $0fa308a0e1f2fbb9$var$Menu = function Menu(_ref) {
    var className = _ref.className, props = $0fa308a0e1f2fbb9$var$_objectWithoutProperties(_ref, [
        "className"
    ]);
    return /*#__PURE__*/ $0fa308a0e1f2fbb9$var$_react["default"].createElement($0fa308a0e1f2fbb9$var$_element["default"], $0fa308a0e1f2fbb9$var$_extends({}, props, {
        className: (0, $0fa308a0e1f2fbb9$var$_classnames["default"])('menu', className)
    }));
};
$0fa308a0e1f2fbb9$var$Menu.List = $0fa308a0e1f2fbb9$var$_list["default"];
$0fa308a0e1f2fbb9$var$Menu.defaultProps = {
    renderAs: 'aside'
};
var $0fa308a0e1f2fbb9$var$_default = $0fa308a0e1f2fbb9$var$Menu;
module.exports["default"] = $0fa308a0e1f2fbb9$var$_default;

});
parcelRegister("2orFf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function get() {
        return $1be348319622520e$var$_list["default"];
    }
});

var $1be348319622520e$var$_list = $1be348319622520e$var$_interopRequireDefault((parcelRequire("7boy4")));
function $1be348319622520e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

});
parcelRegister("7boy4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $53ac9a4d1191e8b8$var$_react = $53ac9a4d1191e8b8$var$_interopRequireDefault((parcelRequire("acw62")));

var $53ac9a4d1191e8b8$var$_propTypes = $53ac9a4d1191e8b8$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $53ac9a4d1191e8b8$var$_classnames = $53ac9a4d1191e8b8$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $53ac9a4d1191e8b8$var$_item = $53ac9a4d1191e8b8$var$_interopRequireDefault((parcelRequire("6PEEP")));

var $53ac9a4d1191e8b8$var$_element = $53ac9a4d1191e8b8$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $53ac9a4d1191e8b8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $53ac9a4d1191e8b8$var$_extends() {
    $53ac9a4d1191e8b8$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $53ac9a4d1191e8b8$var$_extends.apply(this, arguments);
}
function $53ac9a4d1191e8b8$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $53ac9a4d1191e8b8$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $53ac9a4d1191e8b8$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $53ac9a4d1191e8b8$var$MenuList = function MenuList(_ref) {
    var className = _ref.className, title = _ref.title, props = $53ac9a4d1191e8b8$var$_objectWithoutProperties(_ref, [
        "className",
        "title"
    ]);
    return /*#__PURE__*/ $53ac9a4d1191e8b8$var$_react["default"].createElement($53ac9a4d1191e8b8$var$_react["default"].Fragment, null, title && /*#__PURE__*/ $53ac9a4d1191e8b8$var$_react["default"].createElement("p", {
        className: "menu-label"
    }, title), /*#__PURE__*/ $53ac9a4d1191e8b8$var$_react["default"].createElement($53ac9a4d1191e8b8$var$_element["default"], $53ac9a4d1191e8b8$var$_extends({
        className: (0, $53ac9a4d1191e8b8$var$_classnames["default"])('menu-list', className)
    }, props)));
};
$53ac9a4d1191e8b8$var$MenuList.Item = $53ac9a4d1191e8b8$var$_item["default"];
$53ac9a4d1191e8b8$var$MenuList.defaultProps = {
    renderAs: 'ul'
};
var $53ac9a4d1191e8b8$var$_default = $53ac9a4d1191e8b8$var$MenuList;
module.exports["default"] = $53ac9a4d1191e8b8$var$_default;

});
parcelRegister("6PEEP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $4f970b379d4dd85c$var$_react = $4f970b379d4dd85c$var$_interopRequireDefault((parcelRequire("acw62")));

var $4f970b379d4dd85c$var$_propTypes = $4f970b379d4dd85c$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $4f970b379d4dd85c$var$_classnames = $4f970b379d4dd85c$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $4f970b379d4dd85c$var$_list = $4f970b379d4dd85c$var$_interopRequireDefault((parcelRequire("7boy4")));

var $4f970b379d4dd85c$var$_element = $4f970b379d4dd85c$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $4f970b379d4dd85c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $4f970b379d4dd85c$var$_extends() {
    $4f970b379d4dd85c$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4f970b379d4dd85c$var$_extends.apply(this, arguments);
}
function $4f970b379d4dd85c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $4f970b379d4dd85c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $4f970b379d4dd85c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $4f970b379d4dd85c$var$MenuListItem = function MenuListItem(_ref) {
    var children = _ref.children, active = _ref.active, className = _ref.className, ref = _ref.domRef, props = $4f970b379d4dd85c$var$_objectWithoutProperties(_ref, [
        "children",
        "active",
        "className",
        "domRef"
    ]);
    if (typeof children !== 'string' && $4f970b379d4dd85c$var$_react["default"].Children.toArray(children).length === 1 && $4f970b379d4dd85c$var$_react["default"].Children.only(children).type === $4f970b379d4dd85c$var$_list["default"]) {
        var child = $4f970b379d4dd85c$var$_react["default"].Children.only(children);
        return /*#__PURE__*/ $4f970b379d4dd85c$var$_react["default"].createElement("li", {
            ref: ref
        }, /*#__PURE__*/ $4f970b379d4dd85c$var$_react["default"].createElement($4f970b379d4dd85c$var$_element["default"], $4f970b379d4dd85c$var$_extends({
            className: (0, $4f970b379d4dd85c$var$_classnames["default"])(className, {
                'is-active': active
            })
        }, props), child.props.title), /*#__PURE__*/ $4f970b379d4dd85c$var$_react["default"].cloneElement(child, {
            title: undefined
        }));
    }
    return /*#__PURE__*/ $4f970b379d4dd85c$var$_react["default"].createElement("li", {
        ref: ref
    }, /*#__PURE__*/ $4f970b379d4dd85c$var$_react["default"].createElement($4f970b379d4dd85c$var$_element["default"], $4f970b379d4dd85c$var$_extends({
        className: (0, $4f970b379d4dd85c$var$_classnames["default"])(className, {
            'is-active': active
        })
    }, props), children));
};
$4f970b379d4dd85c$var$MenuListItem.defaultProps = {
    renderAs: 'a'
};
var $4f970b379d4dd85c$var$_default = $4f970b379d4dd85c$var$MenuListItem;
module.exports["default"] = $4f970b379d4dd85c$var$_default;

});





parcelRegister("jcCo9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $dfacea7d0180b7d4$var$_message = $dfacea7d0180b7d4$var$_interopRequireDefault((parcelRequire("5JOcY")));
function $dfacea7d0180b7d4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $dfacea7d0180b7d4$var$_default = $dfacea7d0180b7d4$var$_message["default"];
module.exports["default"] = $dfacea7d0180b7d4$var$_default;

});
parcelRegister("5JOcY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $42d81a0b00e5fe33$var$_react = $42d81a0b00e5fe33$var$_interopRequireDefault((parcelRequire("acw62")));

var $42d81a0b00e5fe33$var$_propTypes = $42d81a0b00e5fe33$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $42d81a0b00e5fe33$var$_classnames2 = $42d81a0b00e5fe33$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $42d81a0b00e5fe33$var$_body = $42d81a0b00e5fe33$var$_interopRequireDefault((parcelRequire("ciE6e")));

var $42d81a0b00e5fe33$var$_header = $42d81a0b00e5fe33$var$_interopRequireDefault((parcelRequire("3qlZm")));

var $42d81a0b00e5fe33$var$_element = $42d81a0b00e5fe33$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $42d81a0b00e5fe33$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $42d81a0b00e5fe33$var$_extends() {
    $42d81a0b00e5fe33$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $42d81a0b00e5fe33$var$_extends.apply(this, arguments);
}
function $42d81a0b00e5fe33$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $42d81a0b00e5fe33$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $42d81a0b00e5fe33$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $42d81a0b00e5fe33$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $42d81a0b00e5fe33$var$Message = function Message(_ref) {
    var _classnames;
    var children = _ref.children, className = _ref.className, color = _ref.color, size = _ref.size, props = $42d81a0b00e5fe33$var$_objectWithoutProperties(_ref, [
        "children",
        "className",
        "color",
        "size"
    ]);
    return /*#__PURE__*/ $42d81a0b00e5fe33$var$_react["default"].createElement($42d81a0b00e5fe33$var$_element["default"], $42d81a0b00e5fe33$var$_extends({}, props, {
        className: (0, $42d81a0b00e5fe33$var$_classnames2["default"])('message', className, (_classnames = {}, $42d81a0b00e5fe33$var$_defineProperty(_classnames, "is-".concat(color), color), $42d81a0b00e5fe33$var$_defineProperty(_classnames, "is-".concat(size), size), _classnames))
    }), children);
};
$42d81a0b00e5fe33$var$Message.Body = $42d81a0b00e5fe33$var$_body["default"];
$42d81a0b00e5fe33$var$Message.Header = $42d81a0b00e5fe33$var$_header["default"];
$42d81a0b00e5fe33$var$Message.defaultProps = {
    renderAs: 'article'
};
var $42d81a0b00e5fe33$var$_default = $42d81a0b00e5fe33$var$Message;
module.exports["default"] = $42d81a0b00e5fe33$var$_default;

});
parcelRegister("ciE6e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $8f46456c89fa9bb1$var$_react = $8f46456c89fa9bb1$var$_interopRequireDefault((parcelRequire("acw62")));

var $8f46456c89fa9bb1$var$_classnames = $8f46456c89fa9bb1$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $8f46456c89fa9bb1$var$_element = $8f46456c89fa9bb1$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $8f46456c89fa9bb1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $8f46456c89fa9bb1$var$_extends() {
    $8f46456c89fa9bb1$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8f46456c89fa9bb1$var$_extends.apply(this, arguments);
}
function $8f46456c89fa9bb1$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $8f46456c89fa9bb1$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $8f46456c89fa9bb1$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $8f46456c89fa9bb1$var$MessageBody = function MessageBody(_ref) {
    var children = _ref.children, className = _ref.className, props = $8f46456c89fa9bb1$var$_objectWithoutProperties(_ref, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ $8f46456c89fa9bb1$var$_react["default"].createElement($8f46456c89fa9bb1$var$_element["default"], $8f46456c89fa9bb1$var$_extends({}, props, {
        className: (0, $8f46456c89fa9bb1$var$_classnames["default"])('message-body', className)
    }), children);
};
var $8f46456c89fa9bb1$var$_default = $8f46456c89fa9bb1$var$MessageBody;
module.exports["default"] = $8f46456c89fa9bb1$var$_default;

});

parcelRegister("3qlZm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $27e4db4d8b4eca8f$var$_react = $27e4db4d8b4eca8f$var$_interopRequireDefault((parcelRequire("acw62")));

var $27e4db4d8b4eca8f$var$_classnames = $27e4db4d8b4eca8f$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $27e4db4d8b4eca8f$var$_element = $27e4db4d8b4eca8f$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $27e4db4d8b4eca8f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $27e4db4d8b4eca8f$var$_extends() {
    $27e4db4d8b4eca8f$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $27e4db4d8b4eca8f$var$_extends.apply(this, arguments);
}
function $27e4db4d8b4eca8f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $27e4db4d8b4eca8f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $27e4db4d8b4eca8f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $27e4db4d8b4eca8f$var$MessageHeader = function MessageHeader(_ref) {
    var children = _ref.children, className = _ref.className, props = $27e4db4d8b4eca8f$var$_objectWithoutProperties(_ref, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ $27e4db4d8b4eca8f$var$_react["default"].createElement($27e4db4d8b4eca8f$var$_element["default"], $27e4db4d8b4eca8f$var$_extends({}, props, {
        className: (0, $27e4db4d8b4eca8f$var$_classnames["default"])('message-header', className)
    }), children);
};
var $27e4db4d8b4eca8f$var$_default = $27e4db4d8b4eca8f$var$MessageHeader;
module.exports["default"] = $27e4db4d8b4eca8f$var$_default;

});



parcelRegister("9Zgtx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $7456973ff38be1ff$var$_panel = $7456973ff38be1ff$var$_interopRequireDefault((parcelRequire("ePW5g")));
function $7456973ff38be1ff$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $7456973ff38be1ff$var$_default = $7456973ff38be1ff$var$_panel["default"];
module.exports["default"] = $7456973ff38be1ff$var$_default;

});
parcelRegister("ePW5g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $acd2e256a953710a$var$_react = $acd2e256a953710a$var$_interopRequireDefault((parcelRequire("acw62")));

var $acd2e256a953710a$var$_propTypes = $acd2e256a953710a$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $acd2e256a953710a$var$_classnames2 = $acd2e256a953710a$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $acd2e256a953710a$var$_block = $acd2e256a953710a$var$_interopRequireDefault((parcelRequire("18ps8")));

var $acd2e256a953710a$var$_header = $acd2e256a953710a$var$_interopRequireDefault((parcelRequire("klNTi")));

var $acd2e256a953710a$var$_icon = $acd2e256a953710a$var$_interopRequireDefault((parcelRequire("1VYOS")));

var $acd2e256a953710a$var$_tabs = $acd2e256a953710a$var$_interopRequireDefault((parcelRequire("1IXVq")));

var $acd2e256a953710a$var$_element = $acd2e256a953710a$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $acd2e256a953710a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $acd2e256a953710a$var$_extends() {
    $acd2e256a953710a$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $acd2e256a953710a$var$_extends.apply(this, arguments);
}
function $acd2e256a953710a$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $acd2e256a953710a$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $acd2e256a953710a$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $acd2e256a953710a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $acd2e256a953710a$var$Panel = function Panel(_ref) {
    var color = _ref.color, className = _ref.className, props = $acd2e256a953710a$var$_objectWithoutProperties(_ref, [
        "color",
        "className"
    ]);
    return /*#__PURE__*/ $acd2e256a953710a$var$_react["default"].createElement($acd2e256a953710a$var$_element["default"], $acd2e256a953710a$var$_extends({}, props, {
        className: (0, $acd2e256a953710a$var$_classnames2["default"])('panel', className, $acd2e256a953710a$var$_defineProperty({}, "is-".concat(color), color))
    }));
};
$acd2e256a953710a$var$Panel.Header = $acd2e256a953710a$var$_header["default"];
$acd2e256a953710a$var$Panel.Tabs = $acd2e256a953710a$var$_tabs["default"];
$acd2e256a953710a$var$Panel.Block = $acd2e256a953710a$var$_block["default"];
$acd2e256a953710a$var$Panel.Icon = $acd2e256a953710a$var$_icon["default"];
$acd2e256a953710a$var$Panel.defaultProps = {
    renderAs: 'nav'
};
var $acd2e256a953710a$var$_default = $acd2e256a953710a$var$Panel;
module.exports["default"] = $acd2e256a953710a$var$_default;

});
parcelRegister("18ps8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $0d3a482ffa842018$var$_react = $0d3a482ffa842018$var$_interopRequireDefault((parcelRequire("acw62")));

var $0d3a482ffa842018$var$_propTypes = $0d3a482ffa842018$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $0d3a482ffa842018$var$_classnames = $0d3a482ffa842018$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $0d3a482ffa842018$var$_element = $0d3a482ffa842018$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $0d3a482ffa842018$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $0d3a482ffa842018$var$_extends() {
    $0d3a482ffa842018$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0d3a482ffa842018$var$_extends.apply(this, arguments);
}
function $0d3a482ffa842018$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $0d3a482ffa842018$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $0d3a482ffa842018$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $0d3a482ffa842018$var$PanelBlock = function PanelBlock(_ref) {
    var className = _ref.className, active = _ref.active, props = $0d3a482ffa842018$var$_objectWithoutProperties(_ref, [
        "className",
        "active"
    ]);
    return /*#__PURE__*/ $0d3a482ffa842018$var$_react["default"].createElement($0d3a482ffa842018$var$_element["default"], $0d3a482ffa842018$var$_extends({}, props, {
        className: (0, $0d3a482ffa842018$var$_classnames["default"])('panel-block', className, {
            'is-active': active
        })
    }));
};
var $0d3a482ffa842018$var$_default = $0d3a482ffa842018$var$PanelBlock;
module.exports["default"] = $0d3a482ffa842018$var$_default;

});

parcelRegister("klNTi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $ed0c78200fc54bca$var$_react = $ed0c78200fc54bca$var$_interopRequireDefault((parcelRequire("acw62")));

var $ed0c78200fc54bca$var$_classnames = $ed0c78200fc54bca$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $ed0c78200fc54bca$var$_element = $ed0c78200fc54bca$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $ed0c78200fc54bca$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $ed0c78200fc54bca$var$_extends() {
    $ed0c78200fc54bca$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ed0c78200fc54bca$var$_extends.apply(this, arguments);
}
function $ed0c78200fc54bca$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ed0c78200fc54bca$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $ed0c78200fc54bca$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $ed0c78200fc54bca$var$PanelHeader = function PanelHeader(_ref) {
    var className = _ref.className, props = $ed0c78200fc54bca$var$_objectWithoutProperties(_ref, [
        "className"
    ]);
    return /*#__PURE__*/ $ed0c78200fc54bca$var$_react["default"].createElement($ed0c78200fc54bca$var$_element["default"], $ed0c78200fc54bca$var$_extends({}, props, {
        className: (0, $ed0c78200fc54bca$var$_classnames["default"])('panel-heading', className)
    }));
};
var $ed0c78200fc54bca$var$_default = $ed0c78200fc54bca$var$PanelHeader;
module.exports["default"] = $ed0c78200fc54bca$var$_default;

});

parcelRegister("1VYOS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $168a4ad09b2b7064$var$_react = $168a4ad09b2b7064$var$_interopRequireDefault((parcelRequire("acw62")));

var $168a4ad09b2b7064$var$_propTypes = $168a4ad09b2b7064$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $168a4ad09b2b7064$var$_classnames = $168a4ad09b2b7064$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $168a4ad09b2b7064$var$_element = $168a4ad09b2b7064$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $168a4ad09b2b7064$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $168a4ad09b2b7064$var$_extends() {
    $168a4ad09b2b7064$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $168a4ad09b2b7064$var$_extends.apply(this, arguments);
}
function $168a4ad09b2b7064$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $168a4ad09b2b7064$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $168a4ad09b2b7064$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $168a4ad09b2b7064$var$PanelIcon = function PanelIcon(_ref) {
    var className = _ref.className, props = $168a4ad09b2b7064$var$_objectWithoutProperties(_ref, [
        "className"
    ]);
    return /*#__PURE__*/ $168a4ad09b2b7064$var$_react["default"].createElement($168a4ad09b2b7064$var$_element["default"], $168a4ad09b2b7064$var$_extends({}, props, {
        className: (0, $168a4ad09b2b7064$var$_classnames["default"])('panel-icon', className)
    }));
};
$168a4ad09b2b7064$var$PanelIcon.defaultProps = {
    renderAs: 'span'
};
var $168a4ad09b2b7064$var$_default = $168a4ad09b2b7064$var$PanelIcon;
module.exports["default"] = $168a4ad09b2b7064$var$_default;

});

parcelRegister("1IXVq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function get() {
        return $14186264564b96ff$var$_tabs["default"];
    }
});

var $14186264564b96ff$var$_tabs = $14186264564b96ff$var$_interopRequireDefault((parcelRequire("90q7A")));
function $14186264564b96ff$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

});
parcelRegister("90q7A", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $68e8604de3faa83a$var$_react = $68e8604de3faa83a$var$_interopRequireDefault((parcelRequire("acw62")));

var $68e8604de3faa83a$var$_classnames = $68e8604de3faa83a$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $68e8604de3faa83a$var$_tab = $68e8604de3faa83a$var$_interopRequireDefault((parcelRequire("fXLwd")));

var $68e8604de3faa83a$var$_element = $68e8604de3faa83a$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $68e8604de3faa83a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $68e8604de3faa83a$var$_extends() {
    $68e8604de3faa83a$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $68e8604de3faa83a$var$_extends.apply(this, arguments);
}
function $68e8604de3faa83a$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $68e8604de3faa83a$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $68e8604de3faa83a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $68e8604de3faa83a$var$PanelTabs = function PanelTabs(_ref) {
    var className = _ref.className, props = $68e8604de3faa83a$var$_objectWithoutProperties(_ref, [
        "className"
    ]);
    return /*#__PURE__*/ $68e8604de3faa83a$var$_react["default"].createElement($68e8604de3faa83a$var$_element["default"], $68e8604de3faa83a$var$_extends({}, props, {
        className: (0, $68e8604de3faa83a$var$_classnames["default"])('panel-tabs', className)
    }));
};
$68e8604de3faa83a$var$PanelTabs.Tab = $68e8604de3faa83a$var$_tab["default"];
var $68e8604de3faa83a$var$_default = $68e8604de3faa83a$var$PanelTabs;
module.exports["default"] = $68e8604de3faa83a$var$_default;

});
parcelRegister("fXLwd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $b9f139e95eb6337d$var$_react = $b9f139e95eb6337d$var$_interopRequireDefault((parcelRequire("acw62")));

var $b9f139e95eb6337d$var$_propTypes = $b9f139e95eb6337d$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $b9f139e95eb6337d$var$_classnames = $b9f139e95eb6337d$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $b9f139e95eb6337d$var$_element = $b9f139e95eb6337d$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $b9f139e95eb6337d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $b9f139e95eb6337d$var$_extends() {
    $b9f139e95eb6337d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b9f139e95eb6337d$var$_extends.apply(this, arguments);
}
function $b9f139e95eb6337d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b9f139e95eb6337d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $b9f139e95eb6337d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $b9f139e95eb6337d$var$PanelTabsTab = function PanelTabsTab(_ref) {
    var className = _ref.className, active = _ref.active, props = $b9f139e95eb6337d$var$_objectWithoutProperties(_ref, [
        "className",
        "active"
    ]);
    return /*#__PURE__*/ $b9f139e95eb6337d$var$_react["default"].createElement($b9f139e95eb6337d$var$_element["default"], $b9f139e95eb6337d$var$_extends({}, props, {
        className: (0, $b9f139e95eb6337d$var$_classnames["default"])(className, {
            'is-active': active
        })
    }));
};
$b9f139e95eb6337d$var$PanelTabsTab.defaultProps = {
    renderAs: 'a'
};
var $b9f139e95eb6337d$var$_default = $b9f139e95eb6337d$var$PanelTabsTab;
module.exports["default"] = $b9f139e95eb6337d$var$_default;

});





parcelRegister("9lhjy", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $6cd3818014b55356$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $6cd3818014b55356$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
Object.defineProperty(module.exports, "useMaterialCSSVariables", {
    enumerable: true,
    get: function() {
        return $5LM2M.useMaterialCSSVariables;
    }
});

var $6cd3818014b55356$var$_extends2 = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $6cd3818014b55356$var$_objectWithoutPropertiesLoose2 = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("c05no")));

var $6cd3818014b55356$var$React = $6cd3818014b55356$require$_interopRequireWildcard((parcelRequire("acw62")));

var $6cd3818014b55356$var$_clsx = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("9QePP")));

var $6cd3818014b55356$var$_useForkRef = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $6cd3818014b55356$var$_useEventCallback = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $8xDHs = parcelRequire("8xDHs");

var $6cd3818014b55356$var$_Autocomplete = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("aBB4t")));

var $6cd3818014b55356$var$_Badge = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("lgIyK")));

var $6cd3818014b55356$var$_Checkbox = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("aGDqy")));

var $6cd3818014b55356$var$_Chip = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("6p5K7")));

var $6cd3818014b55356$var$_CircularProgress = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("1sBf1")));

var $6cd3818014b55356$var$_Divider = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("g6BeY")));

var $6cd3818014b55356$var$_InputBase = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("9MvHs")));

var $6cd3818014b55356$var$_Unstable_TrapFocus = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("c94Y8")));

var $6cd3818014b55356$var$_LinearProgress = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("2vsem")));

var $6cd3818014b55356$var$_ListItemIcon = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("2fe4K")));

var $6cd3818014b55356$var$_ListItemText = $6cd3818014b55356$require$_interopRequireWildcard((parcelRequire("djLZl")));

var $6cd3818014b55356$var$_MenuList = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("8qqwQ")));

var $6cd3818014b55356$var$_MenuItem = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("iZ4W7")));

var $6cd3818014b55356$var$_TextField = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("hABDe")));

var $6cd3818014b55356$var$_FormControl = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("iA4iQ")));

var $6cd3818014b55356$var$_FormControlLabel = $6cd3818014b55356$require$_interopRequireWildcard((parcelRequire("i48ne")));

var $6cd3818014b55356$var$_Select = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("dALxx")));

var $6cd3818014b55356$var$_Switch = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("5QQ7K")));

var $6cd3818014b55356$var$_Button = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("bBQKz")));

var $6cd3818014b55356$var$_IconButton = $6cd3818014b55356$require$_interopRequireWildcard((parcelRequire("825Zh")));

var $6cd3818014b55356$var$_InputAdornment = $6cd3818014b55356$require$_interopRequireWildcard((parcelRequire("9bswS")));

var $6cd3818014b55356$var$_Tooltip = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("tEWAm")));

var $6cd3818014b55356$var$_TablePagination = $6cd3818014b55356$require$_interopRequireWildcard((parcelRequire("b3HhA")));

var $6cd3818014b55356$var$_Popper = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("eWJe7")));

var $6cd3818014b55356$var$_ClickAwayListener = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("7Ke9B")));

var $6cd3818014b55356$var$_Grow = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("6dJ4n")));

var $6cd3818014b55356$var$_Paper = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("juRJQ")));

var $6cd3818014b55356$var$_InputLabel = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("k9xmz")));

var $6cd3818014b55356$var$_Skeleton = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("eTbCT")));

var $6cd3818014b55356$var$_Tabs = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("dKcJh")));

var $6cd3818014b55356$var$_Tab = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("90blG")));

var $6cd3818014b55356$var$_ToggleButton = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("xwCPt")));

var $fYxgT = parcelRequire("fYxgT");

var $6cd3818014b55356$var$_useId = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("hwliF")));

var $fWql6 = parcelRequire("fWql6");

var $i9HdC = parcelRequire("i9HdC");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");


var $ayMG0 = parcelRequire("ayMG0");

var $5LM2M = parcelRequire("5LM2M");
const $6cd3818014b55356$var$_excluded = [
    "id",
    "label",
    "labelId",
    "material",
    "disabled",
    "slotProps",
    "onChange",
    "onKeyDown",
    "onOpen",
    "onClose",
    "size",
    "style",
    "fullWidth"
], $6cd3818014b55356$var$_excluded2 = [
    "onRowsPerPageChange",
    "material",
    "disabled"
], $6cd3818014b55356$var$_excluded3 = [
    "material"
], $6cd3818014b55356$var$_excluded4 = [
    "autoFocus",
    "label",
    "fullWidth",
    "slotProps",
    "className",
    "material"
], $6cd3818014b55356$var$_excluded5 = [
    "material"
], $6cd3818014b55356$var$_excluded6 = [
    "material"
], $6cd3818014b55356$var$_excluded7 = [
    "material"
], $6cd3818014b55356$var$_excluded8 = [
    "material"
], $6cd3818014b55356$var$_excluded9 = [
    "material"
], $6cd3818014b55356$var$_excluded0 = [
    "material"
], $6cd3818014b55356$var$_excluded1 = [
    "material"
], $6cd3818014b55356$var$_excluded10 = [
    "material"
], $6cd3818014b55356$var$_excluded11 = [
    "material"
], $6cd3818014b55356$var$_excluded12 = [
    "material",
    "label",
    "className"
], $6cd3818014b55356$var$_excluded13 = [
    "material"
], $6cd3818014b55356$var$_excluded14 = [
    "inert",
    "iconStart",
    "iconEnd",
    "children",
    "material"
], $6cd3818014b55356$var$_excluded15 = [
    "slotProps",
    "material"
], $6cd3818014b55356$var$_excluded16 = [
    "id",
    "multiple",
    "freeSolo",
    "options",
    "getOptionLabel",
    "isOptionEqualToValue",
    "value",
    "onChange",
    "label",
    "placeholder",
    "slotProps",
    "material"
], $6cd3818014b55356$var$_excluded17 = [
    "key"
], $6cd3818014b55356$var$_excluded18 = [
    "inputProps",
    "InputProps",
    "InputLabelProps"
], $6cd3818014b55356$var$_excluded19 = [
    "slotProps",
    "material"
], $6cd3818014b55356$var$_excluded20 = [
    "ref",
    "open",
    "children",
    "className",
    "clickAwayTouchEvent",
    "clickAwayMouseEvent",
    "flip",
    "focusTrap",
    "onExited",
    "onClickAway",
    "onDidShow",
    "onDidHide",
    "id",
    "target",
    "transition",
    "placement",
    "material"
], $6cd3818014b55356$var$_excluded21 = [
    "native"
], $6cd3818014b55356$var$_excluded22 = [
    "children",
    "value",
    "active"
], $6cd3818014b55356$var$_excluded23 = [
    "items",
    "value",
    "material"
];
/* eslint-disable material-ui/disallow-react-api-in-server-components */ const $6cd3818014b55356$var$InputAdornment = (0, $8xDHs.styled)($6cd3818014b55356$var$_InputAdornment.default)(({ theme: theme })=>({
        [`&.${$6cd3818014b55356$var$_InputAdornment.inputAdornmentClasses.positionEnd} .${$6cd3818014b55356$var$_IconButton.iconButtonClasses.sizeSmall}`]: {
            marginRight: theme.spacing(-0.75)
        }
    }));
const $6cd3818014b55356$var$FormControlLabel = (0, $8xDHs.styled)($6cd3818014b55356$var$_FormControlLabel.default, {
    shouldForwardProp: (prop)=>prop !== 'fullWidth'
})(({ theme: theme })=>({
        gap: theme.spacing(0.5),
        margin: 0,
        overflow: 'hidden',
        [`& .${$6cd3818014b55356$var$_FormControlLabel.formControlLabelClasses.label}`]: {
            fontSize: theme.typography.pxToRem(14),
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        },
        variants: [
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            }
        ]
    }));
const $6cd3818014b55356$var$Checkbox = (0, $8xDHs.styled)($6cd3818014b55356$var$_Checkbox.default, {
    shouldForwardProp: (prop)=>prop !== 'density'
})(({ theme: theme })=>({
        variants: [
            {
                props: {
                    density: 'compact'
                },
                style: {
                    padding: theme.spacing(0.5)
                }
            }
        ]
    }));
const $6cd3818014b55356$var$ListItemText = (0, $8xDHs.styled)($6cd3818014b55356$var$_ListItemText.default)({
    [`& .${$6cd3818014b55356$var$_ListItemText.listItemTextClasses.primary}`]: {
        overflowX: 'clip',
        textOverflow: 'ellipsis',
        maxWidth: '300px'
    }
});
const $6cd3818014b55356$var$BaseSelect = (0, $fYxgT.forwardRef)(function BaseSelect(props, ref) {
    const { id: id, label: label, labelId: labelId, material: material, disabled: disabled, slotProps: slotProps, onChange: onChange, onKeyDown: onKeyDown, onOpen: onOpen, onClose: onClose, size: size, style: style, fullWidth: fullWidth } = props, other = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(props, $6cd3818014b55356$var$_excluded);
    const theme = (0, $8xDHs.useTheme)();
    const textFieldDefaults = theme.components?.MuiTextField?.defaultProps ?? {};
    const computedSize = size ?? textFieldDefaults.size;
    const computedVariant = textFieldDefaults.variant ?? 'outlined';
    const menuProps = {
        PaperProps: {
            onKeyDown: onKeyDown
        }
    };
    if (onClose) menuProps.onClose = onClose;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($6cd3818014b55356$var$_FormControl.default, {
        size: computedSize,
        fullWidth: fullWidth,
        style: style,
        disabled: disabled,
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_InputLabel.default, {
                id: labelId,
                htmlFor: id,
                shrink: true,
                variant: computedVariant,
                children: label
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_Select.default, (0, $6cd3818014b55356$var$_extends2.default)({
                id: id,
                labelId: labelId,
                label: label,
                displayEmpty: true,
                onChange: onChange,
                variant: computedVariant
            }, other, {
                inputProps: slotProps?.htmlInput,
                onOpen: onOpen,
                MenuProps: menuProps,
                size: computedSize
            }, material))
        ]
    });
});
$6cd3818014b55356$var$BaseSelect.displayName = "BaseSelect";
const $6cd3818014b55356$var$StyledPagination = (0, $8xDHs.styled)($6cd3818014b55356$var$_TablePagination.default)(({ theme: theme })=>({
        [`& .${$6cd3818014b55356$var$_TablePagination.tablePaginationClasses.selectLabel}`]: {
            display: 'none',
            [theme.breakpoints.up('sm')]: {
                display: 'block'
            }
        },
        [`& .${$6cd3818014b55356$var$_TablePagination.tablePaginationClasses.input}`]: {
            display: 'none',
            [theme.breakpoints.up('sm')]: {
                display: 'inline-flex'
            }
        }
    }));
const $6cd3818014b55356$var$BasePagination = (0, $fYxgT.forwardRef)(function BasePagination(props, ref) {
    const { onRowsPerPageChange: onRowsPerPageChange, material: material, disabled: disabled } = props, other = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(props, $6cd3818014b55356$var$_excluded2);
    const computedProps = $6cd3818014b55356$var$React.useMemo(()=>{
        if (!disabled) return undefined;
        return {
            backIconButtonProps: {
                disabled: true
            },
            nextIconButtonProps: {
                disabled: true
            }
        };
    }, [
        disabled
    ]);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const { estimatedRowCount: estimatedRowCount } = rootProps;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$StyledPagination, (0, $6cd3818014b55356$var$_extends2.default)({
        component: "div",
        onRowsPerPageChange: (0, $6cd3818014b55356$var$_useEventCallback.default)((event)=>{
            onRowsPerPageChange?.(Number(event.target.value));
        }),
        labelRowsPerPage: apiRef.current.getLocaleText('paginationRowsPerPage'),
        labelDisplayedRows: (params)=>apiRef.current.getLocaleText('paginationDisplayedRows')((0, $6cd3818014b55356$var$_extends2.default)({}, params, {
                estimated: estimatedRowCount
            })),
        getItemAriaLabel: apiRef.current.getLocaleText('paginationItemAriaLabel')
    }, computedProps, other, material, {
        ref: ref
    }));
});
$6cd3818014b55356$var$BasePagination.displayName = "BasePagination";
const $6cd3818014b55356$var$BaseBadge = (0, $fYxgT.forwardRef)(function BaseBadge(props, ref) {
    const { material: material } = props, other = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(props, $6cd3818014b55356$var$_excluded3);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_Badge.default, (0, $6cd3818014b55356$var$_extends2.default)({}, other, material, {
        ref: ref
    }));
});
$6cd3818014b55356$var$BaseBadge.displayName = "BaseBadge";
const $6cd3818014b55356$var$BaseCheckbox = (0, $fYxgT.forwardRef)(function BaseCheckbox(props, ref) {
    const { autoFocus: autoFocus, label: label, fullWidth: fullWidth, slotProps: slotProps, className: className, material: material } = props, other = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(props, $6cd3818014b55356$var$_excluded4);
    const elementRef = $6cd3818014b55356$var$React.useRef(null);
    const handleRef = (0, $6cd3818014b55356$var$_useForkRef.default)(elementRef, ref);
    const rippleRef = $6cd3818014b55356$var$React.useRef(null);
    $6cd3818014b55356$var$React.useEffect(()=>{
        if (autoFocus) {
            const input = elementRef.current?.querySelector('input');
            input?.focus({
                preventScroll: true
            });
        } else if (autoFocus === false && rippleRef.current) // Only available in @mui/material v5.4.1 or later
        // @ts-ignore
        rippleRef.current.stop({});
    }, [
        autoFocus
    ]);
    if (!label) return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$Checkbox, (0, $6cd3818014b55356$var$_extends2.default)({}, other, material, {
        className: (0, $6cd3818014b55356$var$_clsx.default)(className, material?.className),
        inputProps: slotProps?.htmlInput,
        ref: handleRef,
        touchRippleRef: rippleRef
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$FormControlLabel, {
        className: className,
        control: /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$Checkbox, (0, $6cd3818014b55356$var$_extends2.default)({}, other, material, {
            inputProps: slotProps?.htmlInput,
            ref: handleRef,
            touchRippleRef: rippleRef
        })),
        label: label,
        fullWidth: fullWidth
    });
});
$6cd3818014b55356$var$BaseCheckbox.displayName = "BaseCheckbox";
const $6cd3818014b55356$var$BaseCircularProgress = (0, $fYxgT.forwardRef)(function BaseCircularProgress(props, ref) {
    const { material: material } = props, other = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(props, $6cd3818014b55356$var$_excluded5);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_CircularProgress.default, (0, $6cd3818014b55356$var$_extends2.default)({}, other, material, {
        ref: ref
    }));
});
$6cd3818014b55356$var$BaseCircularProgress.displayName = "BaseCircularProgress";
const $6cd3818014b55356$var$BaseDivider = (0, $fYxgT.forwardRef)(function BaseDivider(props, ref) {
    const { material: material } = props, other = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(props, $6cd3818014b55356$var$_excluded6);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_Divider.default, (0, $6cd3818014b55356$var$_extends2.default)({}, other, material, {
        ref: ref
    }));
});
$6cd3818014b55356$var$BaseDivider.displayName = "BaseDivider";
const $6cd3818014b55356$var$BaseLinearProgress = (0, $fYxgT.forwardRef)(function BaseLinearProgress(props, ref) {
    const { material: material } = props, other = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(props, $6cd3818014b55356$var$_excluded7);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_LinearProgress.default, (0, $6cd3818014b55356$var$_extends2.default)({}, other, material, {
        ref: ref
    }));
});
$6cd3818014b55356$var$BaseLinearProgress.displayName = "BaseLinearProgress";
const $6cd3818014b55356$var$BaseButton = (0, $fYxgT.forwardRef)(function BaseButton(props, ref) {
    const { material: material } = props, other = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(props, $6cd3818014b55356$var$_excluded8);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_Button.default, (0, $6cd3818014b55356$var$_extends2.default)({}, other, material, {
        ref: ref
    }));
});
$6cd3818014b55356$var$BaseButton.displayName = "BaseButton";
const $6cd3818014b55356$var$StyledToggleButton = (0, $8xDHs.styled)($6cd3818014b55356$var$_ToggleButton.default)(({ theme: theme })=>({
        gap: theme.spacing(1),
        border: 0
    }));
const $6cd3818014b55356$var$BaseToggleButton = (0, $fYxgT.forwardRef)(function BaseToggleButton(props, ref) {
    const { material: material } = props, rest = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(props, $6cd3818014b55356$var$_excluded9);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$StyledToggleButton, (0, $6cd3818014b55356$var$_extends2.default)({
        size: "small",
        color: "primary"
    }, rest, material, {
        ref: ref
    }));
});
$6cd3818014b55356$var$BaseToggleButton.displayName = "BaseToggleButton";
const $6cd3818014b55356$var$BaseChip = (0, $fYxgT.forwardRef)(function BaseChip(props, ref) {
    const { material: material } = props, other = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(props, $6cd3818014b55356$var$_excluded0);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_Chip.default, (0, $6cd3818014b55356$var$_extends2.default)({}, other, material, {
        ref: ref
    }));
});
$6cd3818014b55356$var$BaseChip.displayName = "BaseChip";
const $6cd3818014b55356$var$BaseIconButton = (0, $fYxgT.forwardRef)(function BaseIconButton(props, ref) {
    const { material: material } = props, other = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(props, $6cd3818014b55356$var$_excluded1);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_IconButton.default, (0, $6cd3818014b55356$var$_extends2.default)({}, other, material, {
        ref: ref
    }));
});
$6cd3818014b55356$var$BaseIconButton.displayName = "BaseIconButton";
const $6cd3818014b55356$var$BaseTooltip = (0, $fYxgT.forwardRef)(function BaseTooltip(props, ref) {
    const { material: material } = props, other = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(props, $6cd3818014b55356$var$_excluded10);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_Tooltip.default, (0, $6cd3818014b55356$var$_extends2.default)({}, other, material, {
        ref: ref
    }));
});
$6cd3818014b55356$var$BaseTooltip.displayName = "BaseTooltip";
const $6cd3818014b55356$var$BaseSkeleton = (0, $fYxgT.forwardRef)(function BaseSkeleton(props, ref) {
    const { material: material } = props, other = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(props, $6cd3818014b55356$var$_excluded11);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_Skeleton.default, (0, $6cd3818014b55356$var$_extends2.default)({}, other, material, {
        ref: ref
    }));
});
$6cd3818014b55356$var$BaseSkeleton.displayName = "BaseSkeleton";
const $6cd3818014b55356$var$BaseSwitch = (0, $fYxgT.forwardRef)(function BaseSwitch(props, ref) {
    const { material: material, label: label, className: className } = props, other = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(props, $6cd3818014b55356$var$_excluded12);
    if (!label) return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_Switch.default, (0, $6cd3818014b55356$var$_extends2.default)({}, other, material, {
        className: className,
        ref: ref
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$FormControlLabel, {
        className: className,
        control: /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_Switch.default, (0, $6cd3818014b55356$var$_extends2.default)({}, other, material, {
            ref: ref
        })),
        label: label
    });
});
$6cd3818014b55356$var$BaseSwitch.displayName = "BaseSwitch";
const $6cd3818014b55356$var$BaseMenuList = (0, $fYxgT.forwardRef)(function BaseMenuList(props, ref) {
    const { material: material } = props, other = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(props, $6cd3818014b55356$var$_excluded13);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_MenuList.default, (0, $6cd3818014b55356$var$_extends2.default)({}, other, material, {
        ref: ref
    }));
});
$6cd3818014b55356$var$BaseMenuList.displayName = "BaseMenuList";
function $6cd3818014b55356$var$BaseMenuItem(props) {
    const { inert: inert, iconStart: iconStart, iconEnd: iconEnd, children: children, material: material } = props, other = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(props, $6cd3818014b55356$var$_excluded14);
    if (inert) other.disableRipple = true;
    return /*#__PURE__*/ $6cd3818014b55356$var$React.createElement($6cd3818014b55356$var$_MenuItem.default, (0, $6cd3818014b55356$var$_extends2.default)({}, other, material), [
        iconStart && /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_ListItemIcon.default, {
            children: iconStart
        }, "1"),
        /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$ListItemText, {
            children: children
        }, "2"),
        iconEnd && /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_ListItemIcon.default, {
            children: iconEnd
        }, "3")
    ]);
}
function $6cd3818014b55356$var$BaseTextField(props) {
    // MaterialUI v5 doesn't support slotProps, until we drop v5 support we need to
    // translate the pattern.
    const { slotProps: slotProps, material: material } = props, other = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(props, $6cd3818014b55356$var$_excluded15);
    const theme = (0, $8xDHs.useTheme)();
    const textFieldDefaults = theme.components?.MuiTextField?.defaultProps ?? {};
    const computedVariant = other.variant ?? textFieldDefaults.variant ?? 'outlined';
    const computedSize = other.size ?? textFieldDefaults.size;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_TextField.default, (0, $6cd3818014b55356$var$_extends2.default)({
        variant: computedVariant,
        size: computedSize
    }, other, material, {
        inputProps: slotProps?.htmlInput,
        InputProps: $6cd3818014b55356$var$transformInputProps(slotProps?.input),
        InputLabelProps: (0, $6cd3818014b55356$var$_extends2.default)({
            shrink: true
        }, slotProps?.inputLabel)
    }));
}
function $6cd3818014b55356$var$BaseAutocomplete(props) {
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const { id: id, multiple: multiple, freeSolo: freeSolo, options: options, getOptionLabel: getOptionLabel, isOptionEqualToValue: isOptionEqualToValue, value: value, onChange: onChange, label: label, placeholder: placeholder, slotProps: slotProps, material: material } = props, other = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(props, $6cd3818014b55356$var$_excluded16);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_Autocomplete.default, (0, $6cd3818014b55356$var$_extends2.default)({
        id: id,
        multiple: multiple,
        freeSolo: freeSolo,
        options: options,
        getOptionLabel: getOptionLabel,
        isOptionEqualToValue: isOptionEqualToValue,
        value: value,
        onChange: onChange,
        renderTags: (currentValue, getTagProps)=>currentValue.map((option, index)=>{
                const _getTagProps = getTagProps({
                    index: index
                }), { key: key } = _getTagProps, tagProps = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(_getTagProps, $6cd3818014b55356$var$_excluded17);
                return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_Chip.default, (0, $6cd3818014b55356$var$_extends2.default)({
                    variant: "outlined",
                    size: "small",
                    label: typeof option === 'string' ? option : getOptionLabel?.(option)
                }, tagProps), key);
            }),
        renderInput: (params)=>{
            const { inputProps: inputProps, InputProps: InputProps, InputLabelProps: InputLabelProps } = params, inputRest = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(params, $6cd3818014b55356$var$_excluded18);
            return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_TextField.default, (0, $6cd3818014b55356$var$_extends2.default)({}, inputRest, {
                label: label,
                placeholder: placeholder,
                inputProps: inputProps,
                InputProps: $6cd3818014b55356$var$transformInputProps(InputProps, false),
                InputLabelProps: (0, $6cd3818014b55356$var$_extends2.default)({
                    shrink: true
                }, InputLabelProps)
            }, slotProps?.textField, rootProps.slotProps?.baseTextField));
        }
    }, other, material));
}
function $6cd3818014b55356$var$BaseInput(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_InputBase.default, (0, $6cd3818014b55356$var$_extends2.default)({}, $6cd3818014b55356$var$transformInputProps(props)));
}
function $6cd3818014b55356$var$transformInputProps(props, wrapAdornments = true) {
    if (!props) return undefined;
    const { slotProps: slotProps, material: material } = props, other = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(props, $6cd3818014b55356$var$_excluded19);
    const result = other;
    if (wrapAdornments) {
        if (result.startAdornment) result.startAdornment = /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$InputAdornment, {
            position: "start",
            children: result.startAdornment
        });
        if (result.endAdornment) result.endAdornment = /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$InputAdornment, {
            position: "end",
            children: result.endAdornment
        });
    }
    for(const k in material)if (Object.hasOwn(material, k)) result[k] = material[k];
    if (slotProps?.htmlInput) {
        if (result.inputProps) result.inputProps = (0, $6cd3818014b55356$var$_extends2.default)({}, result.inputProps, slotProps?.htmlInput);
        else result.inputProps = slotProps?.htmlInput;
    }
    return result;
}
const $6cd3818014b55356$var$transformOrigin = {
    'bottom-start': 'top left',
    'bottom-end': 'top right'
};
function $6cd3818014b55356$var$BasePopper(props) {
    const { open: open, children: children, className: className, flip: flip, onExited: onExited, onDidShow: onDidShow, onDidHide: onDidHide, id: id, target: target, transition: transition, placement: placement, material: material } = props, other = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(props, $6cd3818014b55356$var$_excluded20);
    const modifiers = $6cd3818014b55356$var$React.useMemo(()=>{
        const result = [
            {
                name: 'preventOverflow',
                options: {
                    padding: 8
                }
            }
        ];
        if (flip) result.push({
            name: 'flip',
            enabled: true
        });
        if (onDidShow || onDidHide) result.push({
            name: 'isPlaced',
            enabled: true,
            phase: 'main',
            fn: ()=>{
                onDidShow?.();
            },
            effect: ()=>()=>{
                    onDidHide?.();
                }
        });
        return result;
    }, [
        flip,
        onDidShow,
        onDidHide
    ]);
    let content;
    if (!transition) content = $6cd3818014b55356$var$wrappers(props, children);
    else {
        const handleExited = (popperOnExited)=>(node)=>{
                if (popperOnExited) popperOnExited();
                if (onExited) onExited(node);
            };
        content = (p)=>$6cd3818014b55356$var$wrappers(props, /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_Grow.default, (0, $6cd3818014b55356$var$_extends2.default)({}, p.TransitionProps, {
                style: {
                    transformOrigin: $6cd3818014b55356$var$transformOrigin[p.placement]
                },
                onExited: handleExited(p.TransitionProps?.onExited),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_Paper.default, {
                    children: children
                })
            })));
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_Popper.default, (0, $6cd3818014b55356$var$_extends2.default)({
        id: id,
        className: className,
        open: open,
        anchorEl: target,
        transition: transition,
        placement: placement,
        modifiers: modifiers
    }, other, material, {
        children: content
    }));
}
function $6cd3818014b55356$var$wrappers(props, content) {
    return $6cd3818014b55356$var$focusTrapWrapper(props, $6cd3818014b55356$var$clickAwayWrapper(props, content));
}
function $6cd3818014b55356$var$clickAwayWrapper(props, content) {
    if (props.onClickAway === undefined) return content;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_ClickAwayListener.default, {
        onClickAway: props.onClickAway,
        touchEvent: props.clickAwayTouchEvent,
        mouseEvent: props.clickAwayMouseEvent,
        children: content
    });
}
function $6cd3818014b55356$var$focusTrapWrapper(props, content) {
    if (props.focusTrap === undefined) return content;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_Unstable_TrapFocus.default, {
        open: true,
        disableEnforceFocus: true,
        disableAutoFocus: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            tabIndex: -1,
            children: content
        })
    });
}
function $6cd3818014b55356$var$BaseSelectOption(_ref) {
    let { native: native } = _ref, props = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(_ref, $6cd3818014b55356$var$_excluded21);
    if (native) return /*#__PURE__*/ (0, $ayMG0.jsx)("option", (0, $6cd3818014b55356$var$_extends2.default)({}, props));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_MenuItem.default, (0, $6cd3818014b55356$var$_extends2.default)({}, props));
}
const $6cd3818014b55356$var$StyledTabs = (0, $8xDHs.styled)($6cd3818014b55356$var$_Tabs.default, {
    name: 'MuiDataGrid',
    slot: 'Tabs'
})(({ theme: theme })=>({
        borderBottom: `1px solid ${theme.palette.divider}`
    }));
const $6cd3818014b55356$var$StyledTab = (0, $8xDHs.styled)($6cd3818014b55356$var$_Tab.default, {
    name: 'MuiDataGrid',
    slot: 'Tab'
})({
    flex: 1,
    minWidth: 'fit-content'
});
const $6cd3818014b55356$var$StyledTabPanel = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'TabPanel'
})({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
});
function $6cd3818014b55356$var$TabPanel(props) {
    const { children: children, active: active } = props, other = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(props, $6cd3818014b55356$var$_excluded22);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$StyledTabPanel, (0, $6cd3818014b55356$var$_extends2.default)({
        role: "tabpanel",
        style: {
            display: active ? 'flex' : 'none'
        }
    }, other, {
        children: children
    }));
}
function $6cd3818014b55356$var$BaseTabs(_ref2) {
    let { items: items, value: value, material: material } = _ref2, props = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(_ref2, $6cd3818014b55356$var$_excluded23);
    const id = (0, $6cd3818014b55356$var$_useId.default)();
    const labelId = `${id}-tab-${value}`;
    const panelId = `${id}-tabpanel-${value}`;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($6cd3818014b55356$var$React.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$StyledTabs, (0, $6cd3818014b55356$var$_extends2.default)({}, props, {
                value: value,
                variant: "scrollable",
                scrollButtons: "auto"
            }, material, {
                children: items.map((item)=>/*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$StyledTab, {
                        value: item.value,
                        label: item.label,
                        id: labelId,
                        "aria-controls": panelId
                    }, item.value))
            })),
            items.map((item)=>/*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$TabPanel, {
                    value: item.value,
                    active: value === item.value,
                    id: panelId,
                    "aria-labelledby": labelId,
                    children: item.children
                }, item.value))
        ]
    });
}
const $6cd3818014b55356$var$iconSlots = {
    booleanCellTrueIcon: $fWql6.GridCheckIcon,
    booleanCellFalseIcon: $fWql6.GridCloseIcon,
    columnMenuIcon: $fWql6.GridTripleDotsVerticalIcon,
    openFilterButtonIcon: $fWql6.GridFilterListIcon,
    filterPanelDeleteIcon: $fWql6.GridCloseIcon,
    columnFilteredIcon: $fWql6.GridFilterAltIcon,
    columnSelectorIcon: $fWql6.GridColumnIcon,
    columnUnsortedIcon: $i9HdC.GridColumnUnsortedIcon,
    columnSortedAscendingIcon: $fWql6.GridArrowUpwardIcon,
    columnSortedDescendingIcon: $fWql6.GridArrowDownwardIcon,
    columnResizeIcon: $fWql6.GridSeparatorIcon,
    densityCompactIcon: $fWql6.GridViewHeadlineIcon,
    densityStandardIcon: $fWql6.GridTableRowsIcon,
    densityComfortableIcon: $fWql6.GridViewStreamIcon,
    exportIcon: $fWql6.GridDownloadIcon,
    moreActionsIcon: $fWql6.GridMoreVertIcon,
    treeDataCollapseIcon: $fWql6.GridExpandMoreIcon,
    treeDataExpandIcon: $fWql6.GridKeyboardArrowRight,
    groupingCriteriaCollapseIcon: $fWql6.GridExpandMoreIcon,
    groupingCriteriaExpandIcon: $fWql6.GridKeyboardArrowRight,
    detailPanelExpandIcon: $fWql6.GridAddIcon,
    detailPanelCollapseIcon: $fWql6.GridRemoveIcon,
    rowReorderIcon: $fWql6.GridDragIcon,
    quickFilterIcon: $fWql6.GridSearchIcon,
    quickFilterClearIcon: $fWql6.GridClearIcon,
    columnMenuHideIcon: $fWql6.GridVisibilityOffIcon,
    columnMenuSortAscendingIcon: $fWql6.GridArrowUpwardIcon,
    columnMenuSortDescendingIcon: $fWql6.GridArrowDownwardIcon,
    columnMenuUnsortIcon: null,
    columnMenuFilterIcon: $fWql6.GridFilterAltIcon,
    columnMenuManageColumnsIcon: $fWql6.GridViewColumnIcon,
    columnMenuClearIcon: $fWql6.GridClearIcon,
    loadIcon: $fWql6.GridLoadIcon,
    filterPanelAddIcon: $fWql6.GridAddIcon,
    filterPanelRemoveAllIcon: $fWql6.GridDeleteForeverIcon,
    columnReorderIcon: $fWql6.GridDragIcon,
    menuItemCheckIcon: $fWql6.GridCheckIcon
};
const $6cd3818014b55356$var$baseSlots = {
    baseAutocomplete: $6cd3818014b55356$var$BaseAutocomplete,
    baseBadge: $6cd3818014b55356$var$BaseBadge,
    baseCheckbox: $6cd3818014b55356$var$BaseCheckbox,
    baseChip: $6cd3818014b55356$var$BaseChip,
    baseCircularProgress: $6cd3818014b55356$var$BaseCircularProgress,
    baseDivider: $6cd3818014b55356$var$BaseDivider,
    baseInput: $6cd3818014b55356$var$BaseInput,
    baseLinearProgress: $6cd3818014b55356$var$BaseLinearProgress,
    baseMenuList: $6cd3818014b55356$var$BaseMenuList,
    baseMenuItem: $6cd3818014b55356$var$BaseMenuItem,
    baseTextField: $6cd3818014b55356$var$BaseTextField,
    baseButton: $6cd3818014b55356$var$BaseButton,
    baseIconButton: $6cd3818014b55356$var$BaseIconButton,
    baseToggleButton: $6cd3818014b55356$var$BaseToggleButton,
    baseTooltip: $6cd3818014b55356$var$BaseTooltip,
    baseTabs: $6cd3818014b55356$var$BaseTabs,
    basePagination: $6cd3818014b55356$var$BasePagination,
    basePopper: $6cd3818014b55356$var$BasePopper,
    baseSelect: $6cd3818014b55356$var$BaseSelect,
    baseSelectOption: $6cd3818014b55356$var$BaseSelectOption,
    baseSkeleton: $6cd3818014b55356$var$BaseSkeleton,
    baseSwitch: $6cd3818014b55356$var$BaseSwitch
};
const $6cd3818014b55356$var$materialSlots = (0, $6cd3818014b55356$var$_extends2.default)({}, $6cd3818014b55356$var$baseSlots, $6cd3818014b55356$var$iconSlots);
var $6cd3818014b55356$var$_default = module.exports.default = $6cd3818014b55356$var$materialSlots;

});
parcelRegister("1jnue", function(module, exports) {
function $0f49c8ba50dff6ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $0f49c8ba50dff6ee$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3pEGv", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $27c3440315f0d929$var$_typeof = $41YNz.default;
function $27c3440315f0d929$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (module.exports = $27c3440315f0d929$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != $27c3440315f0d929$var$_typeof(e) && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)(e, t);
}
module.exports = $27c3440315f0d929$var$_interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("41YNz", function(module, exports) {
function $2ef66ab8c52ac1c0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $2ef66ab8c52ac1c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $2ef66ab8c52ac1c0$var$_typeof(o);
}
module.exports = $2ef66ab8c52ac1c0$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("3p9rK", function(module, exports) {
function $27ab08c24269de64$var$_extends() {
    return module.exports = $27ab08c24269de64$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $27ab08c24269de64$var$_extends.apply(null, arguments);
}
module.exports = $27ab08c24269de64$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("c05no", function(module, exports) {
function $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("9QePP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "clsx", () => $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37);
$parcel$export(module.exports, "default", () => $f2ccb2ae3c8742b7$export$2e2bcd8739ae039);
function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;

});

parcelRegister("e4pKA", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a3e569e96d60bae8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $a3e569e96d60bae8$var$_useForkRef.default;
    }
});

var $a3e569e96d60bae8$var$_useForkRef = $a3e569e96d60bae8$require$_interopRequireDefault((parcelRequire("kv0Da")));

});
parcelRegister("kv0Da", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $eec73129f1331d63$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $eec73129f1331d63$var$useForkRef;

var $eec73129f1331d63$var$React = $eec73129f1331d63$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * Merges refs into a single memoized callback ref or `null`.
 *
 * ```tsx
 * const rootRef = React.useRef<Instance>(null);
 * const refFork = useForkRef(rootRef, props.ref);
 *
 * return (
 *   <Root {...props} ref={refFork} />
 * );
 * ```
 *
 * @param {Array<React.Ref<Instance> | undefined>} refs The ref array.
 * @returns {React.RefCallback<Instance> | null} The new ref callback.
 */ function $eec73129f1331d63$var$useForkRef(...refs) {
    const cleanupRef = $eec73129f1331d63$var$React.useRef(undefined);
    const refEffect = $eec73129f1331d63$var$React.useCallback((instance)=>{
        const cleanups = refs.map((ref)=>{
            if (ref == null) return null;
            if (typeof ref === 'function') {
                const refCallback = ref;
                const refCleanup = refCallback(instance);
                return typeof refCleanup === 'function' ? refCleanup : ()=>{
                    refCallback(null);
                };
            }
            ref.current = instance;
            return ()=>{
                ref.current = null;
            };
        });
        return ()=>{
            cleanups.forEach((refCleanup)=>refCleanup?.());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
    return $eec73129f1331d63$var$React.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            if (cleanupRef.current) {
                cleanupRef.current();
                cleanupRef.current = undefined;
            }
            if (value != null) cleanupRef.current = refEffect(value);
        };
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- intentionally ignoring that the dependency array must be an array literal
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}

});


parcelRegister("6Lbjo", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $4ebfe8299138c5c5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $4ebfe8299138c5c5$var$_useEventCallback.default;
    }
});

var $4ebfe8299138c5c5$var$_useEventCallback = $4ebfe8299138c5c5$require$_interopRequireDefault((parcelRequire("iDWdC")));

});
parcelRegister("iDWdC", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $d9290782162abf54$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $d9290782162abf54$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d9290782162abf54$var$React = $d9290782162abf54$require$_interopRequireWildcard((parcelRequire("acw62")));

var $d9290782162abf54$var$_useEnhancedEffect = $d9290782162abf54$require$_interopRequireDefault((parcelRequire("jdWO4")));
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $d9290782162abf54$var$useEventCallback(fn) {
    const ref = $d9290782162abf54$var$React.useRef(fn);
    (0, $d9290782162abf54$var$_useEnhancedEffect.default)(()=>{
        ref.current = fn;
    });
    return $d9290782162abf54$var$React.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $d9290782162abf54$var$_default = module.exports.default = $d9290782162abf54$var$useEventCallback;

});
parcelRegister("jdWO4", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $dfecd8f934112f3d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $dfecd8f934112f3d$var$_useEnhancedEffect.default;
    }
});

var $dfecd8f934112f3d$var$_useEnhancedEffect = $dfecd8f934112f3d$require$_interopRequireDefault((parcelRequire("89ISn")));

});
parcelRegister("89ISn", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $5f01f96cc9bd1b3c$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5f01f96cc9bd1b3c$var$React = $5f01f96cc9bd1b3c$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $5f01f96cc9bd1b3c$var$useEnhancedEffect = typeof window !== 'undefined' ? $5f01f96cc9bd1b3c$var$React.useLayoutEffect : $5f01f96cc9bd1b3c$var$React.useEffect;
var $5f01f96cc9bd1b3c$var$_default = module.exports.default = $5f01f96cc9bd1b3c$var$useEnhancedEffect;

});




parcelRegister("8xDHs", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $019ad789c5f8c324$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $019ad789c5f8c324$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $019ad789c5f8c324$var$_exportNames = {
    experimental_sx: true,
    THEME_ID: true,
    adaptV4Theme: true,
    hexToRgb: true,
    rgbToHex: true,
    hslToRgb: true,
    decomposeColor: true,
    recomposeColor: true,
    getContrastRatio: true,
    getLuminance: true,
    emphasize: true,
    alpha: true,
    darken: true,
    lighten: true,
    css: true,
    keyframes: true,
    StyledEngineProvider: true,
    unstable_createBreakpoints: true,
    createTheme: true,
    unstable_createMuiStrictModeTheme: true,
    createStyles: true,
    unstable_getUnit: true,
    unstable_toUnitless: true,
    responsiveFontSizes: true,
    createTransitions: true,
    duration: true,
    easing: true,
    createColorScheme: true,
    useTheme: true,
    useThemeProps: true,
    styled: true,
    ThemeProvider: true,
    makeStyles: true,
    withStyles: true,
    withTheme: true,
    extendTheme: true,
    experimental_extendTheme: true,
    getOverlayAlpha: true,
    shouldSkipGeneratingVar: true,
    private_createTypography: true,
    private_createMixins: true,
    private_excludeVariablesFromRoot: true
};
Object.defineProperty(module.exports, "StyledEngineProvider", {
    enumerable: true,
    get: function() {
        return $izOUK.StyledEngineProvider;
    }
});
Object.defineProperty(module.exports, "THEME_ID", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_identifier.default;
    }
});
Object.defineProperty(module.exports, "ThemeProvider", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_ThemeProvider.default;
    }
});
Object.defineProperty(module.exports, "adaptV4Theme", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_adaptV4Theme.default;
    }
});
Object.defineProperty(module.exports, "alpha", {
    enumerable: true,
    get: function() {
        return $izOUK.alpha;
    }
});
Object.defineProperty(module.exports, "createColorScheme", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_createColorScheme.default;
    }
});
Object.defineProperty(module.exports, "createStyles", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_createStyles.default;
    }
});
Object.defineProperty(module.exports, "createTheme", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_createTheme.default;
    }
});
Object.defineProperty(module.exports, "createTransitions", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_createTransitions.default;
    }
});
Object.defineProperty(module.exports, "css", {
    enumerable: true,
    get: function() {
        return $izOUK.css;
    }
});
Object.defineProperty(module.exports, "darken", {
    enumerable: true,
    get: function() {
        return $izOUK.darken;
    }
});
Object.defineProperty(module.exports, "decomposeColor", {
    enumerable: true,
    get: function() {
        return $izOUK.decomposeColor;
    }
});
Object.defineProperty(module.exports, "duration", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_createTransitions.duration;
    }
});
Object.defineProperty(module.exports, "easing", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_createTransitions.easing;
    }
});
Object.defineProperty(module.exports, "emphasize", {
    enumerable: true,
    get: function() {
        return $izOUK.emphasize;
    }
});
Object.defineProperty(module.exports, "experimental_extendTheme", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_experimental_extendTheme.default;
    }
});
module.exports.experimental_sx = $019ad789c5f8c324$var$experimental_sx;
Object.defineProperty(module.exports, "extendTheme", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_createThemeWithVars.default;
    }
});
Object.defineProperty(module.exports, "getContrastRatio", {
    enumerable: true,
    get: function() {
        return $izOUK.getContrastRatio;
    }
});
Object.defineProperty(module.exports, "getLuminance", {
    enumerable: true,
    get: function() {
        return $izOUK.getLuminance;
    }
});
Object.defineProperty(module.exports, "getOverlayAlpha", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_getOverlayAlpha.default;
    }
});
Object.defineProperty(module.exports, "hexToRgb", {
    enumerable: true,
    get: function() {
        return $izOUK.hexToRgb;
    }
});
Object.defineProperty(module.exports, "hslToRgb", {
    enumerable: true,
    get: function() {
        return $izOUK.hslToRgb;
    }
});
Object.defineProperty(module.exports, "keyframes", {
    enumerable: true,
    get: function() {
        return $izOUK.keyframes;
    }
});
Object.defineProperty(module.exports, "lighten", {
    enumerable: true,
    get: function() {
        return $izOUK.lighten;
    }
});
Object.defineProperty(module.exports, "makeStyles", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_makeStyles.default;
    }
});
Object.defineProperty(module.exports, "private_createMixins", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_createMixins.default;
    }
});
Object.defineProperty(module.exports, "private_createTypography", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_createTypography.default;
    }
});
Object.defineProperty(module.exports, "private_excludeVariablesFromRoot", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_excludeVariablesFromRoot.default;
    }
});
Object.defineProperty(module.exports, "recomposeColor", {
    enumerable: true,
    get: function() {
        return $izOUK.recomposeColor;
    }
});
Object.defineProperty(module.exports, "responsiveFontSizes", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_responsiveFontSizes.default;
    }
});
Object.defineProperty(module.exports, "rgbToHex", {
    enumerable: true,
    get: function() {
        return $izOUK.rgbToHex;
    }
});
Object.defineProperty(module.exports, "shouldSkipGeneratingVar", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_shouldSkipGeneratingVar.default;
    }
});
Object.defineProperty(module.exports, "styled", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_styled.default;
    }
});
Object.defineProperty(module.exports, "unstable_createBreakpoints", {
    enumerable: true,
    get: function() {
        return $68N2H.unstable_createBreakpoints;
    }
});
Object.defineProperty(module.exports, "unstable_createMuiStrictModeTheme", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_createMuiStrictModeTheme.default;
    }
});
Object.defineProperty(module.exports, "unstable_getUnit", {
    enumerable: true,
    get: function() {
        return $18jQK.getUnit;
    }
});
Object.defineProperty(module.exports, "unstable_toUnitless", {
    enumerable: true,
    get: function() {
        return $18jQK.toUnitless;
    }
});
Object.defineProperty(module.exports, "useTheme", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_useTheme.default;
    }
});
Object.defineProperty(module.exports, "useThemeProps", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_useThemeProps.default;
    }
});
Object.defineProperty(module.exports, "withStyles", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_withStyles.default;
    }
});
Object.defineProperty(module.exports, "withTheme", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_withTheme.default;
    }
});

var $019ad789c5f8c324$var$_formatMuiErrorMessage = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("4Z6Nd")));

var $019ad789c5f8c324$var$_identifier = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("4jPsi")));

var $019ad789c5f8c324$var$_adaptV4Theme = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("2baoW")));

var $izOUK = parcelRequire("izOUK");

var $68N2H = parcelRequire("68N2H");

var $019ad789c5f8c324$var$_createTheme = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("ijOKP")));

var $019ad789c5f8c324$var$_createMuiStrictModeTheme = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("5fr1m")));

var $019ad789c5f8c324$var$_createStyles = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("22wy2")));

var $18jQK = parcelRequire("18jQK");

var $019ad789c5f8c324$var$_responsiveFontSizes = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("eoBMT")));

var $019ad789c5f8c324$var$_createTransitions = $019ad789c5f8c324$require$_interopRequireWildcard((parcelRequire("bmoVh")));

var $019ad789c5f8c324$var$_createColorScheme = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("2JzIB")));

var $019ad789c5f8c324$var$_useTheme = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("14H9o")));

var $019ad789c5f8c324$var$_useThemeProps = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("6g9fa")));

var $019ad789c5f8c324$var$_styled = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("d8seH")));

var $019ad789c5f8c324$var$_ThemeProvider = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("gRp5N")));

var $019ad789c5f8c324$var$_makeStyles = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("kLL7M")));

var $019ad789c5f8c324$var$_withStyles = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("7i0uy")));

var $019ad789c5f8c324$var$_withTheme = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("lXubi")));

var $b0NgK = parcelRequire("b0NgK");
Object.keys($b0NgK).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($019ad789c5f8c324$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $b0NgK[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b0NgK[key];
        }
    });
});

var $019ad789c5f8c324$var$_createThemeWithVars = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("eLI0w")));

var $019ad789c5f8c324$var$_experimental_extendTheme = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("dj1n2")));

var $019ad789c5f8c324$var$_getOverlayAlpha = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("35vyj")));

var $019ad789c5f8c324$var$_shouldSkipGeneratingVar = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("fPRn6")));

var $019ad789c5f8c324$var$_createTypography = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("d6q8u")));

var $019ad789c5f8c324$var$_createMixins = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("6plKN")));

var $019ad789c5f8c324$var$_excludeVariablesFromRoot = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("kKEhy")));
// TODO: Remove this function in v6.
// eslint-disable-next-line @typescript-eslint/naming-convention
function $019ad789c5f8c324$var$experimental_sx() {
    throw new Error("MUI: The `experimental_sx` has been moved to `theme.unstable_sx`.For more details, see https://github.com/mui/material-ui/pull/35150.");
} // The legacy utilities from @mui/styles
 // These are just empty functions that throws when invoked
 // TODO: Remove in v7
 // Private methods for creating parts of the theme

});
parcelRegister("4Z6Nd", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3a1220d25e8f9182$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $3a1220d25e8f9182$var$_formatMuiErrorMessage.default;
    }
});

var $3a1220d25e8f9182$var$_formatMuiErrorMessage = $3a1220d25e8f9182$require$_interopRequireDefault((parcelRequire("3goXx")));

});
parcelRegister("3goXx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $26063a188a6d1521$var$formatMuiErrorMessage;
/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/interal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 * @param {number} code
 */ function $26063a188a6d1521$var$formatMuiErrorMessage(code, ...args) {
    const url = new URL(`https://mui.com/production-error/?code=${code}`);
    args.forEach((arg)=>url.searchParams.append('args[]', arg));
    return `Minified MUI error #${code}; visit ${url} for the full message.`;
}

});


parcelRegister("4jPsi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $3250d9bb994a2d02$var$_default = module.exports.default = '$$material';

});

parcelRegister("2baoW", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1964ad5a35c9e3e3$var$adaptV4Theme;

var $izOUK = parcelRequire("izOUK");
function $1964ad5a35c9e3e3$var$adaptV4Theme(inputTheme) {
    console.warn([
        'MUI: adaptV4Theme() is deprecated.',
        'Follow the upgrade guide on https://mui.com/r/migration-v4#theme.'
    ].join('\n'));
    const { defaultProps: defaultProps = {}, mixins: mixins = {}, overrides: overrides = {}, palette: palette = {}, props: props = {}, styleOverrides: styleOverrides = {}, ...other } = inputTheme;
    const theme = {
        ...other,
        components: {}
    };
    // default props
    Object.keys(defaultProps).forEach((component)=>{
        const componentValue = theme.components[component] || {};
        componentValue.defaultProps = defaultProps[component];
        theme.components[component] = componentValue;
    });
    Object.keys(props).forEach((component)=>{
        const componentValue = theme.components[component] || {};
        componentValue.defaultProps = props[component];
        theme.components[component] = componentValue;
    });
    // CSS overrides
    Object.keys(styleOverrides).forEach((component)=>{
        const componentValue = theme.components[component] || {};
        componentValue.styleOverrides = styleOverrides[component];
        theme.components[component] = componentValue;
    });
    Object.keys(overrides).forEach((component)=>{
        const componentValue = theme.components[component] || {};
        componentValue.styleOverrides = overrides[component];
        theme.components[component] = componentValue;
    });
    // theme.spacing
    theme.spacing = (0, $izOUK.createSpacing)(inputTheme.spacing);
    // theme.mixins.gutters
    const breakpoints = (0, $izOUK.createBreakpoints)(inputTheme.breakpoints || {});
    const spacing = theme.spacing;
    theme.mixins = {
        gutters: (styles = {})=>{
            return {
                paddingLeft: spacing(2),
                paddingRight: spacing(2),
                ...styles,
                [breakpoints.up('sm')]: {
                    paddingLeft: spacing(3),
                    paddingRight: spacing(3),
                    ...styles[breakpoints.up('sm')]
                }
            };
        },
        ...mixins
    };
    const { type: typeInput, mode: modeInput, ...paletteRest } = palette;
    const finalMode = modeInput || typeInput || 'light';
    theme.palette = {
        // theme.palette.text.hint
        text: {
            hint: finalMode === 'dark' ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.38)'
        },
        mode: finalMode,
        type: finalMode,
        ...paletteRest
    };
    return theme;
}

});
parcelRegister("izOUK", function(module, exports) {
/**
 * @mui/system v7.3.11
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $3pEGv = parcelRequire("3pEGv");
var $d862fd65d58a79bb$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $d862fd65d58a79bb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $d862fd65d58a79bb$var$_exportNames = {
    experimental_sx: true,
    css: true,
    keyframes: true,
    StyledEngineProvider: true,
    GlobalStyles: true,
    borders: true,
    breakpoints: true,
    handleBreakpoints: true,
    mergeBreakpointsInOrder: true,
    unstable_resolveBreakpointValues: true,
    cssContainerQueries: true,
    compose: true,
    display: true,
    flexbox: true,
    grid: true,
    palette: true,
    positions: true,
    shadows: true,
    sizing: true,
    spacing: true,
    style: true,
    getPath: true,
    getStyleValue: true,
    typography: true,
    unstable_styleFunctionSx: true,
    unstable_createStyleFunctionSx: true,
    unstable_extendSxProp: true,
    unstable_defaultSxConfig: true,
    unstable_getThemeValue: true,
    Box: true,
    createBox: true,
    createStyled: true,
    styled: true,
    createTheme: true,
    createBreakpoints: true,
    createSpacing: true,
    shape: true,
    useThemeProps: true,
    getThemeProps: true,
    useTheme: true,
    useThemeWithoutDefault: true,
    useMediaQuery: true,
    ThemeProvider: true,
    unstable_memoTheme: true,
    unstable_createCssVarsProvider: true,
    unstable_createGetCssVar: true,
    unstable_cssVarsParser: true,
    unstable_prepareCssVars: true,
    unstable_createCssVarsTheme: true,
    responsivePropType: true,
    RtlProvider: true,
    createContainer: true,
    Container: true,
    Grid: true,
    Stack: true
};
Object.defineProperty(module.exports, "Box", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_Box.default;
    }
});
Object.defineProperty(module.exports, "Container", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_Container.default;
    }
});
Object.defineProperty(module.exports, "GlobalStyles", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_GlobalStyles.default;
    }
});
Object.defineProperty(module.exports, "Grid", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_Grid.default;
    }
});
Object.defineProperty(module.exports, "RtlProvider", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_RtlProvider.default;
    }
});
Object.defineProperty(module.exports, "Stack", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_Stack.default;
    }
});
Object.defineProperty(module.exports, "StyledEngineProvider", {
    enumerable: true,
    get: function() {
        return $bOOlK.StyledEngineProvider;
    }
});
Object.defineProperty(module.exports, "ThemeProvider", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_ThemeProvider.default;
    }
});
Object.defineProperty(module.exports, "borders", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_borders.default;
    }
});
Object.defineProperty(module.exports, "breakpoints", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_breakpoints.default;
    }
});
Object.defineProperty(module.exports, "compose", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_compose.default;
    }
});
Object.defineProperty(module.exports, "createBox", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_createBox.default;
    }
});
Object.defineProperty(module.exports, "createBreakpoints", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_createBreakpoints.default;
    }
});
Object.defineProperty(module.exports, "createContainer", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_createContainer.default;
    }
});
Object.defineProperty(module.exports, "createSpacing", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_createSpacing.default;
    }
});
Object.defineProperty(module.exports, "createStyled", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_createStyled.default;
    }
});
Object.defineProperty(module.exports, "createTheme", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_createTheme.default;
    }
});
Object.defineProperty(module.exports, "css", {
    enumerable: true,
    get: function() {
        return $bOOlK.css;
    }
});
Object.defineProperty(module.exports, "cssContainerQueries", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_cssContainerQueries.default;
    }
});
Object.defineProperty(module.exports, "display", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_display.default;
    }
});
module.exports.experimental_sx = $d862fd65d58a79bb$var$experimental_sx;
Object.defineProperty(module.exports, "flexbox", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_flexbox.default;
    }
});
Object.defineProperty(module.exports, "getPath", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_style.getPath;
    }
});
Object.defineProperty(module.exports, "getStyleValue", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_style.getStyleValue;
    }
});
Object.defineProperty(module.exports, "getThemeProps", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_useThemeProps.getThemeProps;
    }
});
Object.defineProperty(module.exports, "grid", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_cssGrid.default;
    }
});
Object.defineProperty(module.exports, "handleBreakpoints", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_breakpoints.handleBreakpoints;
    }
});
Object.defineProperty(module.exports, "keyframes", {
    enumerable: true,
    get: function() {
        return $bOOlK.keyframes;
    }
});
Object.defineProperty(module.exports, "mergeBreakpointsInOrder", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_breakpoints.mergeBreakpointsInOrder;
    }
});
Object.defineProperty(module.exports, "palette", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_palette.default;
    }
});
Object.defineProperty(module.exports, "positions", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_positions.default;
    }
});
Object.defineProperty(module.exports, "responsivePropType", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_responsivePropType.default;
    }
});
Object.defineProperty(module.exports, "shadows", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_shadows.default;
    }
});
Object.defineProperty(module.exports, "shape", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_shape.default;
    }
});
Object.defineProperty(module.exports, "sizing", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_sizing.default;
    }
});
Object.defineProperty(module.exports, "spacing", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_spacing.default;
    }
});
Object.defineProperty(module.exports, "style", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_style.default;
    }
});
Object.defineProperty(module.exports, "styled", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_styled.default;
    }
});
Object.defineProperty(module.exports, "typography", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_typography.default;
    }
});
Object.defineProperty(module.exports, "unstable_createCssVarsProvider", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_createCssVarsProvider.default;
    }
});
Object.defineProperty(module.exports, "unstable_createCssVarsTheme", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_createCssVarsTheme.default;
    }
});
Object.defineProperty(module.exports, "unstable_createGetCssVar", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_createGetCssVar.default;
    }
});
Object.defineProperty(module.exports, "unstable_createStyleFunctionSx", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_styleFunctionSx.unstable_createStyleFunctionSx;
    }
});
Object.defineProperty(module.exports, "unstable_cssVarsParser", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_cssVarsParser.default;
    }
});
Object.defineProperty(module.exports, "unstable_defaultSxConfig", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_styleFunctionSx.unstable_defaultSxConfig;
    }
});
Object.defineProperty(module.exports, "unstable_extendSxProp", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_styleFunctionSx.extendSxProp;
    }
});
Object.defineProperty(module.exports, "unstable_getThemeValue", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_getThemeValue.default;
    }
});
Object.defineProperty(module.exports, "unstable_memoTheme", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_memoTheme.default;
    }
});
Object.defineProperty(module.exports, "unstable_prepareCssVars", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_prepareCssVars.default;
    }
});
Object.defineProperty(module.exports, "unstable_resolveBreakpointValues", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_breakpoints.resolveBreakpointValues;
    }
});
Object.defineProperty(module.exports, "unstable_styleFunctionSx", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_styleFunctionSx.default;
    }
});
Object.defineProperty(module.exports, "useMediaQuery", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_useMediaQuery.default;
    }
});
Object.defineProperty(module.exports, "useTheme", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_useTheme.default;
    }
});
Object.defineProperty(module.exports, "useThemeProps", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_useThemeProps.default;
    }
});
Object.defineProperty(module.exports, "useThemeWithoutDefault", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_useThemeWithoutDefault.default;
    }
});

var $d862fd65d58a79bb$var$_formatMuiErrorMessage = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("4Z6Nd")));

var $bOOlK = parcelRequire("bOOlK");

var $d862fd65d58a79bb$var$_GlobalStyles = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("fJztl")));

var $d862fd65d58a79bb$var$_borders = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("7G2Ky")));
Object.keys($d862fd65d58a79bb$var$_borders).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_borders[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_borders[key];
        }
    });
});

var $d862fd65d58a79bb$var$_breakpoints = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("9mzYC")));

var $d862fd65d58a79bb$var$_cssContainerQueries = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("18kGB")));

var $d862fd65d58a79bb$var$_compose = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("79Mi4")));

var $d862fd65d58a79bb$var$_display = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("9p2mw")));

var $d862fd65d58a79bb$var$_flexbox = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("fbcSN")));
Object.keys($d862fd65d58a79bb$var$_flexbox).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_flexbox[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_flexbox[key];
        }
    });
});

var $d862fd65d58a79bb$var$_cssGrid = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("bvdLQ")));
Object.keys($d862fd65d58a79bb$var$_cssGrid).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_cssGrid[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_cssGrid[key];
        }
    });
});

var $d862fd65d58a79bb$var$_palette = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("7Izgs")));
Object.keys($d862fd65d58a79bb$var$_palette).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_palette[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_palette[key];
        }
    });
});

var $d862fd65d58a79bb$var$_positions = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("9cp7R")));
Object.keys($d862fd65d58a79bb$var$_positions).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_positions[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_positions[key];
        }
    });
});

var $d862fd65d58a79bb$var$_shadows = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("euxvJ")));

var $d862fd65d58a79bb$var$_sizing = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("lk86k")));
Object.keys($d862fd65d58a79bb$var$_sizing).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_sizing[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_sizing[key];
        }
    });
});

var $d862fd65d58a79bb$var$_spacing = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("8ZgMs")));
Object.keys($d862fd65d58a79bb$var$_spacing).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_spacing[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_spacing[key];
        }
    });
});

var $d862fd65d58a79bb$var$_style = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("fuavR")));

var $d862fd65d58a79bb$var$_typography = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("6a6uc")));
Object.keys($d862fd65d58a79bb$var$_typography).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_typography[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_typography[key];
        }
    });
});

var $d862fd65d58a79bb$var$_styleFunctionSx = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("l6FST")));

var $d862fd65d58a79bb$var$_getThemeValue = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("fykTt")));

var $d862fd65d58a79bb$var$_Box = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("8XfTG")));
Object.keys($d862fd65d58a79bb$var$_Box).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_Box[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_Box[key];
        }
    });
});

var $d862fd65d58a79bb$var$_createBox = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("7SBe1")));

var $d862fd65d58a79bb$var$_createStyled = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("bbeCr")));
Object.keys($d862fd65d58a79bb$var$_createStyled).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_createStyled[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_createStyled[key];
        }
    });
});

var $d862fd65d58a79bb$var$_styled = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("kpukb")));

var $d862fd65d58a79bb$var$_createTheme = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("1dhnG")));

var $d862fd65d58a79bb$var$_createBreakpoints = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("hVW0x")));

var $d862fd65d58a79bb$var$_createSpacing = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("5pAhk")));

var $d862fd65d58a79bb$var$_shape = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("5H6wp")));

var $d862fd65d58a79bb$var$_useThemeProps = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("2LgDM")));

var $d862fd65d58a79bb$var$_useTheme = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("lywMB")));

var $d862fd65d58a79bb$var$_useThemeWithoutDefault = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("f18iq")));

var $d862fd65d58a79bb$var$_useMediaQuery = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("8h4LK")));

var $h61zw = parcelRequire("h61zw");
Object.keys($h61zw).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $h61zw[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $h61zw[key];
        }
    });
});

var $d862fd65d58a79bb$var$_ThemeProvider = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("ixP4k")));

var $d862fd65d58a79bb$var$_memoTheme = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("5Ts1H")));

var $d862fd65d58a79bb$var$_createCssVarsProvider = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("3Vfwq")));

var $d862fd65d58a79bb$var$_createGetCssVar = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("hKuOr")));

var $d862fd65d58a79bb$var$_cssVarsParser = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("ejFX8")));

var $d862fd65d58a79bb$var$_prepareCssVars = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("5magr")));

var $d862fd65d58a79bb$var$_createCssVarsTheme = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("73CWR")));

var $d862fd65d58a79bb$var$_responsivePropType = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("h7FAc")));

var $d862fd65d58a79bb$var$_RtlProvider = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("9uEev")));
Object.keys($d862fd65d58a79bb$var$_RtlProvider).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_RtlProvider[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_RtlProvider[key];
        }
    });
});

var $1RRq5 = parcelRequire("1RRq5");
Object.keys($1RRq5).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $1RRq5[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1RRq5[key];
        }
    });
});

var $d862fd65d58a79bb$var$_createContainer = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("689Qv")));

var $d862fd65d58a79bb$var$_Container = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("jYQTJ")));
Object.keys($d862fd65d58a79bb$var$_Container).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_Container[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_Container[key];
        }
    });
});

var $d862fd65d58a79bb$var$_Grid = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("dy2yf")));

var $gxueG = parcelRequire("gxueG");
Object.keys($gxueG).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $gxueG[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gxueG[key];
        }
    });
});

var $d862fd65d58a79bb$var$_Stack = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("kgIUX")));

var $106Hq = parcelRequire("106Hq");
Object.keys($106Hq).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $106Hq[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $106Hq[key];
        }
    });
});
// TODO: Remove this function in v6
// eslint-disable-next-line @typescript-eslint/naming-convention
function $d862fd65d58a79bb$var$experimental_sx() {
    throw new Error("MUI: The `experimental_sx` has been moved to `theme.unstable_sx`.For more details, see https://github.com/mui/material-ui/pull/35150.");
} /** ----------------- */  /** Layout components */ 

});
parcelRegister("bOOlK", function(module, exports) {
/**
 * @mui/styled-engine v7.3.10
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $89ab6b9e702438b4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "GlobalStyles", {
    enumerable: true,
    get: function() {
        return $89ab6b9e702438b4$var$_GlobalStyles.default;
    }
});
Object.defineProperty(module.exports, "StyledEngineProvider", {
    enumerable: true,
    get: function() {
        return $89ab6b9e702438b4$var$_StyledEngineProvider.default;
    }
});
Object.defineProperty(module.exports, "ThemeContext", {
    enumerable: true,
    get: function() {
        return $eP9YU.T;
    }
});
Object.defineProperty(module.exports, "css", {
    enumerable: true,
    get: function() {
        return $jjlaj.css;
    }
});
module.exports.default = $89ab6b9e702438b4$var$styled;
module.exports.internal_mutateStyles = $89ab6b9e702438b4$var$internal_mutateStyles;
module.exports.internal_serializeStyles = $89ab6b9e702438b4$var$internal_serializeStyles;
Object.defineProperty(module.exports, "keyframes", {
    enumerable: true,
    get: function() {
        return $jjlaj.keyframes;
    }
});

var $89ab6b9e702438b4$var$_styled = $89ab6b9e702438b4$require$_interopRequireDefault((parcelRequire("5rflj")));

var $8rteH = parcelRequire("8rteH");

var $jjlaj = parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");

var $89ab6b9e702438b4$var$_StyledEngineProvider = $89ab6b9e702438b4$require$_interopRequireDefault((parcelRequire("dDJuN")));

var $89ab6b9e702438b4$var$_GlobalStyles = $89ab6b9e702438b4$require$_interopRequireDefault((parcelRequire("gfxtG")));
function $89ab6b9e702438b4$var$styled(tag, options) {
    const stylesFactory = (0, $89ab6b9e702438b4$var$_styled.default)(tag, options);
    return (...styles)=>{
        const component = typeof tag === 'string' ? `"${tag}"` : 'component';
        if (styles.length === 0) console.error([
            `MUI: Seems like you called \`styled(${component})()\` without a \`style\` argument.`,
            'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'
        ].join('\n'));
        else if (styles.some((style)=>style === undefined)) console.error(`MUI: the styled(${component})(...args) API requires all its args to be defined.`);
        return stylesFactory(...styles);
    };
}
// eslint-disable-next-line @typescript-eslint/naming-convention
function $89ab6b9e702438b4$var$internal_mutateStyles(tag, processor) {
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
}
// Emotion only accepts an array, but we want to avoid allocations
const $89ab6b9e702438b4$var$wrapper = [];
// eslint-disable-next-line @typescript-eslint/naming-convention
function $89ab6b9e702438b4$var$internal_serializeStyles(styles) {
    $89ab6b9e702438b4$var$wrapper[0] = styles;
    return (0, $8rteH.serializeStyles)($89ab6b9e702438b4$var$wrapper);
}

});
parcelRegister("5rflj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3f5b60245567d758$export$2e2bcd8739ae039);

var $dAzjV = parcelRequire("dAzjV");
parcelRequire("3p9rK");

parcelRequire("8rteH");
parcelRequire("2lACw");
parcelRequire("8ajhZ");
parcelRequire("acw62");
parcelRequire("gd942");
var $3f5b60245567d758$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var $3f5b60245567d758$export$2e2bcd8739ae039 = (0, $dAzjV.default).bind(null);
$3f5b60245567d758$var$tags.forEach(function(tagName) {
    $3f5b60245567d758$export$2e2bcd8739ae039[tagName] = $3f5b60245567d758$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("dAzjV", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e4a09088fdc2ec0$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");
parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");

var $8rteH = parcelRequire("8rteH");

var $2lACw = parcelRequire("2lACw");

var $8ajhZ = parcelRequire("8ajhZ");

var $acw62 = parcelRequire("acw62");

var $gd942 = parcelRequire("gd942");
var $9e4a09088fdc2ec0$var$isBrowser = typeof document !== 'undefined';
var $9e4a09088fdc2ec0$var$isDevelopment = false;
var $9e4a09088fdc2ec0$var$testOmitPropsOnStringTag = (0, $gd942.default);
var $9e4a09088fdc2ec0$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $9e4a09088fdc2ec0$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $9e4a09088fdc2ec0$var$testOmitPropsOnStringTag : $9e4a09088fdc2ec0$var$testOmitPropsOnComponent;
};
var $9e4a09088fdc2ec0$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $9e4a09088fdc2ec0$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $8ajhZ.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $2lACw.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $8ajhZ.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$9e4a09088fdc2ec0$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $9e4a09088fdc2ec0$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $9e4a09088fdc2ec0$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $9e4a09088fdc2ec0$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $eP9YU.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $acw62.useContext((0, $eP9YU.T));
            }
            if (typeof props.className === 'string') className = (0, $8ajhZ.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $8rteH.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $9e4a09088fdc2ec0$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($9e4a09088fdc2ec0$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $acw62.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $9e4a09088fdc2ec0$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $8nd05.default)({}, options, nextOptions, {
                shouldForwardProp: $9e4a09088fdc2ec0$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("8nd05", function(module, exports) {

$parcel$export(module.exports, "default", () => $618a8e53233cd9fa$export$2e2bcd8739ae039);
function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("jjlaj", function(module, exports) {

$parcel$export(module.exports, "Global", () => $e0f035ab0866fe47$export$98f03c5d19621d70);
$parcel$export(module.exports, "css", () => $e0f035ab0866fe47$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $e0f035ab0866fe47$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("eP9YU")).T);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("eP9YU")).w);

var $eP9YU = parcelRequire("eP9YU");

var $acw62 = parcelRequire("acw62");

var $8ajhZ = parcelRequire("8ajhZ");

var $2lACw = parcelRequire("2lACw");

var $8rteH = parcelRequire("8rteH");
parcelRequire("a9M6v");
parcelRequire("3p9rK");
parcelRequire("iq6RI");

parcelRequire("9ORqK");
var $e0f035ab0866fe47$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $eP9YU.h).call(props, 'css')) return $acw62.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $eP9YU.E);
    createElementArgArray[1] = (0, $eP9YU.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $acw62.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($e0f035ab0866fe47$export$c8a8987d4410bf2d || ($e0f035ab0866fe47$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $e0f035ab0866fe47$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $eP9YU.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $8rteH.serializeStyles)([
        styles
    ], undefined, $acw62.useContext((0, $eP9YU.T)));
    if (!(0, $eP9YU.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $acw62.useRef();
    (0, $2lACw.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $2lACw.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $8ajhZ.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $e0f035ab0866fe47$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $8rteH.serializeStyles)(args);
}
function $e0f035ab0866fe47$export$d25ddfdf17c3ad3e() {
    var insertable = $e0f035ab0866fe47$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $e0f035ab0866fe47$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $e0f035ab0866fe47$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $8ajhZ.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $e0f035ab0866fe47$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $2lACw.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $8ajhZ.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $eP9YU.i) && res !== undefined) rules += res;
        }
        if (!(0, $eP9YU.i)) return rules;
    });
    if (!(0, $eP9YU.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $e0f035ab0866fe47$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $eP9YU.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $eP9YU.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $8rteH.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $8ajhZ.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $eP9YU.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $e0f035ab0866fe47$var$merge(cache.registered, css, $e0f035ab0866fe47$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $acw62.useContext((0, $eP9YU.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($e0f035ab0866fe47$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("eP9YU", function(module, exports) {

$parcel$export(module.exports, "a", () => $acad92301ef10c3f$export$407448d2b89b1813);
$parcel$export(module.exports, "i", () => $acad92301ef10c3f$export$23f2a1d2818174ef);
$parcel$export(module.exports, "C", () => $acad92301ef10c3f$export$e7094788287c5e9b);
$parcel$export(module.exports, "w", () => $acad92301ef10c3f$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $acad92301ef10c3f$export$971d5caa766a69d7);
$parcel$export(module.exports, "h", () => $acad92301ef10c3f$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "c", () => $acad92301ef10c3f$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $acad92301ef10c3f$export$a9c23c6ac3fc3eca);

var $acw62 = parcelRequire("acw62");

var $a9M6v = parcelRequire("a9M6v");

var $8nd05 = parcelRequire("8nd05");

var $iq6RI = parcelRequire("iq6RI");

var $apDLo = parcelRequire("apDLo");

var $8ajhZ = parcelRequire("8ajhZ");

var $8rteH = parcelRequire("8rteH");

var $2lACw = parcelRequire("2lACw");
var $acad92301ef10c3f$export$407448d2b89b1813 = false;
var $acad92301ef10c3f$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $acad92301ef10c3f$var$EmotionCacheContext = /* #__PURE__ */ $acw62.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $a9M6v.default)({
    key: 'css'
}) : null);
var $acad92301ef10c3f$export$e7094788287c5e9b = $acad92301ef10c3f$var$EmotionCacheContext.Provider;
var $acad92301ef10c3f$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
};
var $acad92301ef10c3f$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$acad92301ef10c3f$export$23f2a1d2818174ef) $acad92301ef10c3f$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $a9M6v.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $acad92301ef10c3f$export$971d5caa766a69d7 = /* #__PURE__ */ $acw62.createContext({});
var $acad92301ef10c3f$export$3b14a55fb2447963 = function useTheme() {
    return $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
};
var $acad92301ef10c3f$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $8nd05.default)({}, outerTheme, theme);
};
var $acad92301ef10c3f$var$createCacheWithTheme = /* #__PURE__ */ (0, $iq6RI.default)(function(outerTheme) {
    return (0, $iq6RI.default)(function(theme) {
        return $acad92301ef10c3f$var$getTheme(outerTheme, theme);
    });
});
var $acad92301ef10c3f$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $acad92301ef10c3f$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $acad92301ef10c3f$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $acw62.forwardRef(function render(props, ref) {
        var theme = $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
        return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $apDLo.default)(WithTheme, Component);
}
var $acad92301ef10c3f$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $acad92301ef10c3f$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $acad92301ef10c3f$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($acad92301ef10c3f$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$acad92301ef10c3f$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $acad92301ef10c3f$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $8ajhZ.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $2lACw.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $8ajhZ.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$acad92301ef10c3f$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $acad92301ef10c3f$var$Emotion = /* #__PURE__ */ $acad92301ef10c3f$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$acad92301ef10c3f$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $8ajhZ.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $8rteH.serializeStyles)(registeredStyles, undefined, $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($acad92301ef10c3f$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $acad92301ef10c3f$var$typePropName && !$acad92301ef10c3f$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $acw62.createElement(WrappedComponent, newProps));
});
var $acad92301ef10c3f$export$a9c23c6ac3fc3eca = $acad92301ef10c3f$var$Emotion;

});
parcelRegister("a9M6v", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $76500f1a9bc57c92$export$2e2bcd8739ae039);

var $jmRmf = parcelRequire("jmRmf");

var $fm8kz = parcelRequire("fm8kz");

var $iq6RI = parcelRequire("iq6RI");

var $9ffXE = parcelRequire("9ffXE");
var $76500f1a9bc57c92$var$isBrowser = typeof document !== 'undefined';
var $76500f1a9bc57c92$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $fm8kz.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $fm8kz.token)(character)) break;
        (0, $fm8kz.next)();
    }
    return (0, $fm8kz.slice)(begin, (0, $fm8kz.position));
};
var $76500f1a9bc57c92$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $fm8kz.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $fm8kz.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $76500f1a9bc57c92$var$identifierWithPointTracking((0, $fm8kz.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $fm8kz.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $fm8kz.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $fm8kz.from)(character);
    }
    while (character = (0, $fm8kz.next)());
    return parsed;
};
var $76500f1a9bc57c92$var$getRules = function getRules(value, points) {
    return (0, $fm8kz.dealloc)($76500f1a9bc57c92$var$toRules((0, $fm8kz.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $76500f1a9bc57c92$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $76500f1a9bc57c92$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$76500f1a9bc57c92$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $76500f1a9bc57c92$var$fixedElements.set(element, true);
    var points = [];
    var rules = $76500f1a9bc57c92$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $76500f1a9bc57c92$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $76500f1a9bc57c92$var$prefix(value, length) {
    switch((0, $fm8kz.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $fm8kz.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $fm8kz.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MOZ) + value + (0, $fm8kz.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + value + value;
        // order
        case 6165:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.replace)(value, /(\w+).+(:[^]+)/, (0, $fm8kz.WEBKIT) + 'box-$1$2' + (0, $fm8kz.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + 'flex-item-' + (0, $fm8kz.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + 'flex-line-pack' + (0, $fm8kz.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $fm8kz.WEBKIT) + 'box-' + (0, $fm8kz.replace)(value, '-grow', '') + (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $fm8kz.WEBKIT) + (0, $fm8kz.replace)(value, /([^-])(transform)/g, '$1' + (0, $fm8kz.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $fm8kz.replace)((0, $fm8kz.replace)((0, $fm8kz.replace)(value, /(zoom-|grab)/, (0, $fm8kz.WEBKIT) + '$1'), /(image-set)/, (0, $fm8kz.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $fm8kz.replace)(value, /(image-set\([^]*)/, (0, $fm8kz.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $fm8kz.replace)((0, $fm8kz.replace)(value, /(.+:)(flex-)?(.*)/, (0, $fm8kz.WEBKIT) + 'box-pack:$3' + (0, $fm8kz.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $fm8kz.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $fm8kz.replace)(value, /(.+)-inline(.+)/, (0, $fm8kz.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $fm8kz.strlen)(value) - 1 - length > 6) switch((0, $fm8kz.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $fm8kz.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $fm8kz.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $fm8kz.WEBKIT) + '$2-$3' + '$1' + (0, $fm8kz.MOZ) + ((0, $fm8kz.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $fm8kz.indexof)(value, 'stretch') ? $76500f1a9bc57c92$var$prefix((0, $fm8kz.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $fm8kz.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $fm8kz.charat)(value, (0, $fm8kz.strlen)(value) - 3 - (~(0, $fm8kz.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $fm8kz.replace)(value, ':', ':' + (0, $fm8kz.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $fm8kz.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $fm8kz.WEBKIT) + ((0, $fm8kz.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $fm8kz.WEBKIT) + '$2$3' + '$1' + (0, $fm8kz.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $fm8kz.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + value + value;
    }
    return value;
}
var $76500f1a9bc57c92$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $fm8kz.DECLARATION:
                element["return"] = $76500f1a9bc57c92$var$prefix(element.value, element.length);
                break;
            case 0, $fm8kz.KEYFRAMES:
                return (0, $fm8kz.serialize)([
                    (0, $fm8kz.copy)(element, {
                        value: (0, $fm8kz.replace)(element.value, '@', '@' + (0, $fm8kz.WEBKIT))
                    })
                ], callback);
            case 0, $fm8kz.RULESET:
                if (element.length) return (0, $fm8kz.combine)(element.props, function(value) {
                    switch((0, $fm8kz.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $fm8kz.serialize)([
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(read-\w+)/, ':' + (0, $fm8kz.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $fm8kz.serialize)([
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, ':' + (0, $fm8kz.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, ':' + (0, $fm8kz.MOZ) + '$1')
                                    ]
                                }),
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, (0, $fm8kz.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $76500f1a9bc57c92$var$getServerStylisCache = $76500f1a9bc57c92$var$isBrowser ? undefined : (0, $iq6RI.default)(function() {
    return (0, $9ffXE.default)(function() {
        return {};
    });
});
var $76500f1a9bc57c92$var$defaultStylisPlugins = [
    $76500f1a9bc57c92$var$prefixer
];
var $76500f1a9bc57c92$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($76500f1a9bc57c92$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $76500f1a9bc57c92$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($76500f1a9bc57c92$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $76500f1a9bc57c92$var$compat,
        $76500f1a9bc57c92$var$removeLabel
    ];
    if (!$76500f1a9bc57c92$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $fm8kz.stringify),
            (0, $fm8kz.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $fm8kz.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $fm8kz.serialize)((0, $fm8kz.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $fm8kz.stringify)
        ];
        var _serializer = (0, $fm8kz.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $fm8kz.serialize)((0, $fm8kz.compile)(styles), _serializer);
        };
        var serverStylisCache = $76500f1a9bc57c92$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $jmRmf.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("jmRmf", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $e19976245606d3d7$export$9d753cd7ae895cce);
var $e19976245606d3d7$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $e19976245606d3d7$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $e19976245606d3d7$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $e19976245606d3d7$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$e19976245606d3d7$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e19976245606d3d7$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $e19976245606d3d7$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("fm8kz", function(module, exports) {

$parcel$export(module.exports, "MS", () => $298fb931ed4fbf8b$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $298fb931ed4fbf8b$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $298fb931ed4fbf8b$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "RULESET", () => $298fb931ed4fbf8b$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $298fb931ed4fbf8b$export$527d108ccf083c2b);
$parcel$export(module.exports, "KEYFRAMES", () => $298fb931ed4fbf8b$export$b44a8529a35fcb60);
$parcel$export(module.exports, "from", () => $298fb931ed4fbf8b$export$6788812c4e6611e6);
$parcel$export(module.exports, "hash", () => $298fb931ed4fbf8b$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $298fb931ed4fbf8b$export$a9db5e087081082d);
$parcel$export(module.exports, "match", () => $298fb931ed4fbf8b$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $298fb931ed4fbf8b$export$f8e21b1e77979a08);
$parcel$export(module.exports, "strlen", () => $298fb931ed4fbf8b$export$36776f635604f274);
$parcel$export(module.exports, "combine", () => $298fb931ed4fbf8b$export$1be1fc439b849fdf);
$parcel$export(module.exports, "position", () => $298fb931ed4fbf8b$export$5880b8b5730aff45);
$parcel$export(module.exports, "copy", () => $298fb931ed4fbf8b$export$784d13d8ee351f07);
$parcel$export(module.exports, "next", () => $298fb931ed4fbf8b$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $298fb931ed4fbf8b$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "slice", () => $298fb931ed4fbf8b$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $298fb931ed4fbf8b$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $298fb931ed4fbf8b$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $298fb931ed4fbf8b$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $298fb931ed4fbf8b$export$410ac95b9ec204b8);
$parcel$export(module.exports, "compile", () => $298fb931ed4fbf8b$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $298fb931ed4fbf8b$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $298fb931ed4fbf8b$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $298fb931ed4fbf8b$export$38bcb760f1d4871c);
var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(j += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $298fb931ed4fbf8b$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $298fb931ed4fbf8b$export$36776f635604f274(j) - l) $298fb931ed4fbf8b$export$10d8903dec122b9d(p > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(y = $298fb931ed4fbf8b$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(e, y, y, n && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(j += $298fb931ed4fbf8b$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    v = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(g = j += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $298fb931ed4fbf8b$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $298fb931ed4fbf8b$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, v + 1, v = $298fb931ed4fbf8b$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, n), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(n, c, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(n, c)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span") ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(n) - 1 - c > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n, "stretch") ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, $298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                n.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (n.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("iq6RI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d68ffb0773f38e18$export$2e2bcd8739ae039);
var $d68ffb0773f38e18$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});


parcelRegister("apDLo", function(module, exports) {

$parcel$export(module.exports, "default", () => $794b155aeb6b00fd$export$2e2bcd8739ae039);

var $9ORqK = parcelRequire("9ORqK");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $794b155aeb6b00fd$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(targetComponent, sourceComponent);
};

});
parcelRegister("9ORqK", function(module, exports) {
'use strict';

var $2qzd6 = parcelRequire("2qzd6");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$2qzd6.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$2qzd6.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($2qzd6.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component['$$typeof']] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;

});
parcelRegister("2qzd6", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8Hm9c"));

});
parcelRegister("8Hm9c", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $655384e8331727f6$export$2b8d127b894957b9, (v) => $655384e8331727f6$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $655384e8331727f6$export$cea3a54a6425200c, (v) => $655384e8331727f6$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $655384e8331727f6$export$a7c73072b1a182ae, (v) => $655384e8331727f6$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $655384e8331727f6$export$9f27bc3417b4524d, (v) => $655384e8331727f6$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $655384e8331727f6$export$db77ccec0bb4ccac, (v) => $655384e8331727f6$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $655384e8331727f6$export$8392c0c9d3dcbd35, (v) => $655384e8331727f6$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $655384e8331727f6$export$ffb0004e005737fa, (v) => $655384e8331727f6$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $655384e8331727f6$export$b624eff549462981, (v) => $655384e8331727f6$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $655384e8331727f6$export$7897aa7841a5380c, (v) => $655384e8331727f6$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $655384e8331727f6$export$602eac185826482c, (v) => $655384e8331727f6$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $655384e8331727f6$export$e2c29f18771995cb, (v) => $655384e8331727f6$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $655384e8331727f6$export$5f8d39834fd61797, (v) => $655384e8331727f6$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $655384e8331727f6$export$74bf444e3cd11ea5, (v) => $655384e8331727f6$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $655384e8331727f6$export$92387174baf9b227, (v) => $655384e8331727f6$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $655384e8331727f6$export$ec112efeb987d9c6, (v) => $655384e8331727f6$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $655384e8331727f6$export$b706b080d889d2c9, (v) => $655384e8331727f6$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $655384e8331727f6$export$5be5a87408f70ddc, (v) => $655384e8331727f6$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $655384e8331727f6$export$45a5e7f76e0caa8d, (v) => $655384e8331727f6$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $655384e8331727f6$export$455c2e768291efa6, (v) => $655384e8331727f6$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $655384e8331727f6$export$9522e17588c12572, (v) => $655384e8331727f6$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $655384e8331727f6$export$2110ac352bb060b9, (v) => $655384e8331727f6$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $655384e8331727f6$export$56885ab8b9c456ab, (v) => $655384e8331727f6$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $655384e8331727f6$export$d927fcb6adf8f9de, (v) => $655384e8331727f6$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $655384e8331727f6$export$b82d16f27459e05a, (v) => $655384e8331727f6$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $655384e8331727f6$export$522c17b4f5e123e8, (v) => $655384e8331727f6$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $655384e8331727f6$export$1aabd8a0274ecfd6, (v) => $655384e8331727f6$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $655384e8331727f6$export$9b621391a187a31a, (v) => $655384e8331727f6$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $655384e8331727f6$export$f5bbd400c2f4426f, (v) => $655384e8331727f6$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $655384e8331727f6$export$2b8d127b894957b9;
var $655384e8331727f6$export$cea3a54a6425200c;
var $655384e8331727f6$export$a7c73072b1a182ae;
var $655384e8331727f6$export$9f27bc3417b4524d;
var $655384e8331727f6$export$db77ccec0bb4ccac;
var $655384e8331727f6$export$8392c0c9d3dcbd35;
var $655384e8331727f6$export$ffb0004e005737fa;
var $655384e8331727f6$export$b624eff549462981;
var $655384e8331727f6$export$7897aa7841a5380c;
var $655384e8331727f6$export$602eac185826482c;
var $655384e8331727f6$export$e2c29f18771995cb;
var $655384e8331727f6$export$5f8d39834fd61797;
var $655384e8331727f6$export$74bf444e3cd11ea5;
var $655384e8331727f6$export$92387174baf9b227;
var $655384e8331727f6$export$ec112efeb987d9c6;
var $655384e8331727f6$export$b706b080d889d2c9;
var $655384e8331727f6$export$5be5a87408f70ddc;
var $655384e8331727f6$export$45a5e7f76e0caa8d;
var $655384e8331727f6$export$455c2e768291efa6;
var $655384e8331727f6$export$9522e17588c12572;
var $655384e8331727f6$export$2110ac352bb060b9;
var $655384e8331727f6$export$56885ab8b9c456ab;
var $655384e8331727f6$export$d927fcb6adf8f9de;
var $655384e8331727f6$export$b82d16f27459e05a;
var $655384e8331727f6$export$522c17b4f5e123e8;
var $655384e8331727f6$export$1aabd8a0274ecfd6;
var $655384e8331727f6$export$9b621391a187a31a;
var $655384e8331727f6$export$f5bbd400c2f4426f;
'use strict';
(function() {
    'use strict';
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === 'function' && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?
    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
    function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }
    function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_ASYNC_MODE_TYPE:
                        case REACT_CONCURRENT_MODE_TYPE:
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    } // AsyncMode is deprecated along with isAsyncMode
    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console['warn']("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }
    function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    $655384e8331727f6$export$2b8d127b894957b9 = AsyncMode;
    $655384e8331727f6$export$cea3a54a6425200c = ConcurrentMode;
    $655384e8331727f6$export$a7c73072b1a182ae = ContextConsumer;
    $655384e8331727f6$export$9f27bc3417b4524d = ContextProvider;
    $655384e8331727f6$export$db77ccec0bb4ccac = Element;
    $655384e8331727f6$export$8392c0c9d3dcbd35 = ForwardRef;
    $655384e8331727f6$export$ffb0004e005737fa = Fragment;
    $655384e8331727f6$export$b624eff549462981 = Lazy;
    $655384e8331727f6$export$7897aa7841a5380c = Memo;
    $655384e8331727f6$export$602eac185826482c = Portal;
    $655384e8331727f6$export$e2c29f18771995cb = Profiler;
    $655384e8331727f6$export$5f8d39834fd61797 = StrictMode;
    $655384e8331727f6$export$74bf444e3cd11ea5 = Suspense;
    $655384e8331727f6$export$92387174baf9b227 = isAsyncMode;
    $655384e8331727f6$export$ec112efeb987d9c6 = isConcurrentMode;
    $655384e8331727f6$export$b706b080d889d2c9 = isContextConsumer;
    $655384e8331727f6$export$5be5a87408f70ddc = isContextProvider;
    $655384e8331727f6$export$45a5e7f76e0caa8d = isElement;
    $655384e8331727f6$export$455c2e768291efa6 = isForwardRef;
    $655384e8331727f6$export$9522e17588c12572 = isFragment;
    $655384e8331727f6$export$2110ac352bb060b9 = isLazy;
    $655384e8331727f6$export$56885ab8b9c456ab = isMemo;
    $655384e8331727f6$export$d927fcb6adf8f9de = isPortal;
    $655384e8331727f6$export$b82d16f27459e05a = isProfiler;
    $655384e8331727f6$export$522c17b4f5e123e8 = isStrictMode;
    $655384e8331727f6$export$1aabd8a0274ecfd6 = isSuspense;
    $655384e8331727f6$export$9b621391a187a31a = isValidElementType;
    $655384e8331727f6$export$f5bbd400c2f4426f = typeOf;
})();

});




parcelRegister("8ajhZ", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $5f1e384d41b6dbd9$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $5f1e384d41b6dbd9$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $5f1e384d41b6dbd9$export$6f077d94b33a01aa);
var $5f1e384d41b6dbd9$var$isBrowser = typeof document !== 'undefined';
function $5f1e384d41b6dbd9$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $5f1e384d41b6dbd9$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $5f1e384d41b6dbd9$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $5f1e384d41b6dbd9$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $5f1e384d41b6dbd9$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$5f1e384d41b6dbd9$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$5f1e384d41b6dbd9$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("8rteH", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $62578605b07c8dad$export$6321afa313b251b5);

var $4EiWM = parcelRequire("4EiWM");

var $cEIH4 = parcelRequire("cEIH4");

var $9ffXE = parcelRequire("9ffXE");
var $62578605b07c8dad$var$isDevelopment = false;
var $62578605b07c8dad$var$hyphenateRegex = /[A-Z]|^ms/g;
var $62578605b07c8dad$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $62578605b07c8dad$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $62578605b07c8dad$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $62578605b07c8dad$var$processStyleName = /* #__PURE__ */ (0, $9ffXE.default)(function(styleName) {
    return $62578605b07c8dad$var$isCustomProperty(styleName) ? styleName : styleName.replace($62578605b07c8dad$var$hyphenateRegex, '-$&').toLowerCase();
});
var $62578605b07c8dad$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($62578605b07c8dad$var$animationRegex, function(match, p1, p2) {
                $62578605b07c8dad$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $62578605b07c8dad$var$cursor
                };
                return p1;
            });
    }
    if ((0, $cEIH4.default)[key] !== 1 && !$62578605b07c8dad$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $62578605b07c8dad$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $62578605b07c8dad$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $62578605b07c8dad$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $62578605b07c8dad$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $62578605b07c8dad$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $62578605b07c8dad$var$cursor;
                var result = interpolation(mergedProps);
                $62578605b07c8dad$var$cursor = previousCursor;
                return $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($62578605b07c8dad$var$isProcessableValue(asString)) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $62578605b07c8dad$var$isDevelopment) throw new Error($62578605b07c8dad$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($62578605b07c8dad$var$isProcessableValue(value[_i])) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $62578605b07c8dad$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $62578605b07c8dad$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $62578605b07c8dad$var$cursor;
function $62578605b07c8dad$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $62578605b07c8dad$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $62578605b07c8dad$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $62578605b07c8dad$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $4EiWM.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $62578605b07c8dad$var$cursor
    };
}

});
parcelRegister("4EiWM", function(module, exports) {

$parcel$export(module.exports, "default", () => $3629985b3ecf741f$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3629985b3ecf741f$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("cEIH4", function(module, exports) {

$parcel$export(module.exports, "default", () => $936be3b045ab836e$export$2e2bcd8739ae039);
var $936be3b045ab836e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("2lACw", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $1b59f2f50af460c0$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $1b59f2f50af460c0$export$811a713a7276cb9d);

var $acw62 = parcelRequire("acw62");
var $1b59f2f50af460c0$var$isBrowser = typeof document !== 'undefined';
var $1b59f2f50af460c0$var$syncFallback = function syncFallback(create) {
    return create();
};
var $1b59f2f50af460c0$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : false;
var $1b59f2f50af460c0$export$db21c7ffa21794e7 = !$1b59f2f50af460c0$var$isBrowser ? $1b59f2f50af460c0$var$syncFallback : $1b59f2f50af460c0$var$useInsertionEffect || $1b59f2f50af460c0$var$syncFallback;
var $1b59f2f50af460c0$export$811a713a7276cb9d = $1b59f2f50af460c0$var$useInsertionEffect || $acw62.useLayoutEffect;

});





parcelRegister("dDJuN", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9ee2355c3bd069c6$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9ee2355c3bd069c6$var$_StyledEngineProvider.default;
    }
});

var $9ee2355c3bd069c6$var$_StyledEngineProvider = $9ee2355c3bd069c6$require$_interopRequireDefault((parcelRequire("2BuCw")));

});
parcelRegister("2BuCw", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $1e56ca0825dc344f$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $1e56ca0825dc344f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TEST_INTERNALS_DO_NOT_USE = void 0;
module.exports.default = $1e56ca0825dc344f$var$StyledEngineProvider;

var $1e56ca0825dc344f$var$React = $1e56ca0825dc344f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $1e56ca0825dc344f$var$_propTypes = $1e56ca0825dc344f$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $eP9YU = parcelRequire("eP9YU");

var $1e56ca0825dc344f$var$_cache = $1e56ca0825dc344f$require$_interopRequireDefault((parcelRequire("a9M6v")));

var $jmRmf = parcelRequire("jmRmf");

var $ayMG0 = parcelRequire("ayMG0");
// To fix [Jest performance](https://github.com/mui/material-ui/issues/45638).
const $1e56ca0825dc344f$var$cacheMap = new Map();
// Need to add a private variable to test the generated CSS from Emotion, this is the simplest way to do it.
// We can't test the CSS from `style` tag easily because the `speedy: true` (produce empty text content) is enabled by Emotion.
// Even if we disable it, JSDOM needs extra configuration to be able to parse `@layer` CSS.
const $1e56ca0825dc344f$var$TEST_INTERNALS_DO_NOT_USE = module.exports.TEST_INTERNALS_DO_NOT_USE = {
    /**
   * to intercept the generated CSS before inserting to the style tag, so that we can check the generated CSS.
   *
   * let rule;
   * TEST_INTERNALS_DO_NOT_USE.insert = (...args) => {
   *    rule = args[0];
   * };
   *
   * expect(rule).to.equal(...);
   */ insert: undefined
};
// We might be able to remove this when this issue is fixed:
// https://github.com/emotion-js/emotion/issues/2790
const $1e56ca0825dc344f$var$createEmotionCache = (options, CustomSheet)=>{
    const cache = (0, $1e56ca0825dc344f$var$_cache.default)(options);
    // Do the same as https://github.com/emotion-js/emotion/blob/main/packages/cache/src/index.js#L238-L245
    cache.sheet = new CustomSheet({
        key: cache.key,
        nonce: cache.sheet.nonce,
        container: cache.sheet.container,
        speedy: cache.sheet.isSpeedy,
        prepend: cache.sheet.prepend,
        insertionPoint: cache.sheet.insertionPoint
    });
    return cache;
};
let $1e56ca0825dc344f$var$insertionPoint;
if (typeof document === 'object') {
    // Use `insertionPoint` over `prepend`(deprecated) because it can be controlled for GlobalStyles injection order
    // For more information, see https://github.com/mui/material-ui/issues/44597
    $1e56ca0825dc344f$var$insertionPoint = document.querySelector('[name="emotion-insertion-point"]');
    if (!$1e56ca0825dc344f$var$insertionPoint) {
        $1e56ca0825dc344f$var$insertionPoint = document.createElement('meta');
        $1e56ca0825dc344f$var$insertionPoint.setAttribute('name', 'emotion-insertion-point');
        $1e56ca0825dc344f$var$insertionPoint.setAttribute('content', '');
        const head = document.querySelector('head');
        if (head) head.prepend($1e56ca0825dc344f$var$insertionPoint);
    }
}
function $1e56ca0825dc344f$var$getCache(injectFirst, enableCssLayer) {
    if (injectFirst || enableCssLayer) {
        /**
     * This is for client-side apps only.
     * A custom sheet is required to make the GlobalStyles API injected above the insertion point.
     * This is because the [sheet](https://github.com/emotion-js/emotion/blob/main/packages/react/src/global.js#L94-L99) does not consume the options.
     */ class MyStyleSheet extends $jmRmf.StyleSheet {
            insert(rule, options) {
                if ($1e56ca0825dc344f$var$TEST_INTERNALS_DO_NOT_USE.insert) return $1e56ca0825dc344f$var$TEST_INTERNALS_DO_NOT_USE.insert(rule, options);
                if (this.key && this.key.endsWith('global')) this.before = $1e56ca0825dc344f$var$insertionPoint;
                return super.insert(rule, options);
            }
        }
        const emotionCache = $1e56ca0825dc344f$var$createEmotionCache({
            key: 'css',
            insertionPoint: injectFirst ? $1e56ca0825dc344f$var$insertionPoint : undefined
        }, MyStyleSheet);
        if (enableCssLayer) {
            const prevInsert = emotionCache.insert;
            emotionCache.insert = (...args)=>{
                if (!args[1].styles.match(/^@layer\s+[^{]*$/)) // avoid nested @layer
                args[1].styles = `@layer mui {${args[1].styles}}`;
                return prevInsert(...args);
            };
        }
        return emotionCache;
    }
    return undefined;
}
function $1e56ca0825dc344f$var$StyledEngineProvider(props) {
    const { injectFirst: injectFirst, enableCssLayer: enableCssLayer, children: children } = props;
    const cache = $1e56ca0825dc344f$var$React.useMemo(()=>{
        const cacheKey = `${injectFirst}-${enableCssLayer}`;
        if (typeof document === 'object' && $1e56ca0825dc344f$var$cacheMap.has(cacheKey)) return $1e56ca0825dc344f$var$cacheMap.get(cacheKey);
        const fresh = $1e56ca0825dc344f$var$getCache(injectFirst, enableCssLayer);
        $1e56ca0825dc344f$var$cacheMap.set(cacheKey, fresh);
        return fresh;
    }, [
        injectFirst,
        enableCssLayer
    ]);
    return cache ? /*#__PURE__*/ (0, $ayMG0.jsx)($eP9YU.C, {
        value: cache,
        children: children
    }) : children;
}
$1e56ca0825dc344f$var$StyledEngineProvider.propTypes = {
    /**
   * Your component tree.
   */ children: $1e56ca0825dc344f$var$_propTypes.default.node,
    /**
   * If `true`, the styles are wrapped in `@layer mui`.
   * Learn more about [Cascade layers](https://developer.mozilla.org/en-US/docs/Learn_web_development/Core/Styling_basics/Cascade_layers).
   */ enableCssLayer: $1e56ca0825dc344f$var$_propTypes.default.bool,
    /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override MUI's styles, set this prop.
   */ injectFirst: $1e56ca0825dc344f$var$_propTypes.default.bool
};

});
parcelRegister("ayMG0", function(module, exports) {
'use strict';

module.exports = (parcelRequire("7B2bR"));

});



parcelRegister("gfxtG", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $bd48040d38052821$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $bd48040d38052821$var$_GlobalStyles.default;
    }
});

var $bd48040d38052821$var$_GlobalStyles = $bd48040d38052821$require$_interopRequireDefault((parcelRequire("bBbjn")));

});
parcelRegister("bBbjn", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $871beca1e2477cf0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $871beca1e2477cf0$var$GlobalStyles;

var $871beca1e2477cf0$var$_propTypes = $871beca1e2477cf0$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $jjlaj = parcelRequire("jjlaj");

var $ayMG0 = parcelRequire("ayMG0");
function $871beca1e2477cf0$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $871beca1e2477cf0$var$GlobalStyles(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($871beca1e2477cf0$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($jjlaj.Global, {
        styles: globalStyles
    });
}
$871beca1e2477cf0$var$GlobalStyles.propTypes = {
    defaultTheme: $871beca1e2477cf0$var$_propTypes.default.object,
    styles: $871beca1e2477cf0$var$_propTypes.default.oneOfType([
        $871beca1e2477cf0$var$_propTypes.default.array,
        $871beca1e2477cf0$var$_propTypes.default.string,
        $871beca1e2477cf0$var$_propTypes.default.object,
        $871beca1e2477cf0$var$_propTypes.default.func
    ])
};

});



parcelRegister("fJztl", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $b7469308f94dcda5$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $b7469308f94dcda5$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $b7469308f94dcda5$var$_GlobalStyles.default;
    }
});

var $b7469308f94dcda5$var$_GlobalStyles = $b7469308f94dcda5$require$_interopRequireWildcard((parcelRequire("csO1Z")));
Object.keys($b7469308f94dcda5$var$_GlobalStyles).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($b7469308f94dcda5$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $b7469308f94dcda5$var$_GlobalStyles[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b7469308f94dcda5$var$_GlobalStyles[key];
        }
    });
});

});
parcelRegister("csO1Z", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $912ee8b2b484e556$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $912ee8b2b484e556$var$_propTypes = $912ee8b2b484e556$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $bOOlK = parcelRequire("bOOlK");

var $912ee8b2b484e556$var$_useTheme = $912ee8b2b484e556$require$_interopRequireDefault((parcelRequire("lywMB")));

var $ayMG0 = parcelRequire("ayMG0");
function $912ee8b2b484e556$var$wrapGlobalLayer(styles) {
    const serialized = (0, $bOOlK.internal_serializeStyles)(styles);
    if (styles !== serialized && serialized.styles) {
        if (!serialized.styles.match(/^@layer\s+[^{]*$/)) // If the styles are not already wrapped in a layer, wrap them in a global layer.
        serialized.styles = `@layer global{${serialized.styles}}`;
        return serialized;
    }
    return styles;
}
function $912ee8b2b484e556$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $912ee8b2b484e556$var$_useTheme.default)(defaultTheme);
    const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
    let globalStyles = typeof styles === 'function' ? styles(resolvedTheme) : styles;
    if (resolvedTheme.modularCssLayers) {
        if (Array.isArray(globalStyles)) globalStyles = globalStyles.map((styleArg)=>{
            if (typeof styleArg === 'function') return $912ee8b2b484e556$var$wrapGlobalLayer(styleArg(resolvedTheme));
            return $912ee8b2b484e556$var$wrapGlobalLayer(styleArg);
        });
        else globalStyles = $912ee8b2b484e556$var$wrapGlobalLayer(globalStyles);
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($bOOlK.GlobalStyles, {
        styles: globalStyles
    });
}
$912ee8b2b484e556$var$GlobalStyles.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * @ignore
   */ defaultTheme: $912ee8b2b484e556$var$_propTypes.default.object,
    /**
   * @ignore
   */ styles: $912ee8b2b484e556$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $912ee8b2b484e556$var$_propTypes.default.array,
        $912ee8b2b484e556$var$_propTypes.default.func,
        $912ee8b2b484e556$var$_propTypes.default.number,
        $912ee8b2b484e556$var$_propTypes.default.object,
        $912ee8b2b484e556$var$_propTypes.default.string,
        $912ee8b2b484e556$var$_propTypes.default.bool
    ]),
    /**
   * @ignore
   */ themeId: $912ee8b2b484e556$var$_propTypes.default.string
};
var $912ee8b2b484e556$var$_default = module.exports.default = $912ee8b2b484e556$var$GlobalStyles;

});
parcelRegister("lywMB", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $fb1633f194eccc90$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $fb1633f194eccc90$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $fb1633f194eccc90$var$_useTheme.default;
    }
});

var $fb1633f194eccc90$var$_useTheme = $fb1633f194eccc90$require$_interopRequireWildcard((parcelRequire("cpDNV")));
Object.keys($fb1633f194eccc90$var$_useTheme).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($fb1633f194eccc90$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $fb1633f194eccc90$var$_useTheme[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fb1633f194eccc90$var$_useTheme[key];
        }
    });
});

});
parcelRegister("cpDNV", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $9096b21b03fc4ec3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.systemDefaultTheme = module.exports.default = void 0;

var $9096b21b03fc4ec3$var$_createTheme = $9096b21b03fc4ec3$require$_interopRequireDefault((parcelRequire("1dhnG")));

var $9096b21b03fc4ec3$var$_useThemeWithoutDefault = $9096b21b03fc4ec3$require$_interopRequireDefault((parcelRequire("f18iq")));
const $9096b21b03fc4ec3$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $9096b21b03fc4ec3$var$_createTheme.default)();
function $9096b21b03fc4ec3$var$useTheme(defaultTheme = $9096b21b03fc4ec3$var$systemDefaultTheme) {
    return (0, $9096b21b03fc4ec3$var$_useThemeWithoutDefault.default)(defaultTheme);
}
var $9096b21b03fc4ec3$var$_default = module.exports.default = $9096b21b03fc4ec3$var$useTheme;

});
parcelRegister("1dhnG", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0e247cd7faad5b27$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $0e247cd7faad5b27$var$_createTheme.default;
    }
});
Object.defineProperty(module.exports, "private_createBreakpoints", {
    enumerable: true,
    get: function() {
        return $0e247cd7faad5b27$var$_createBreakpoints.default;
    }
});
Object.defineProperty(module.exports, "unstable_applyStyles", {
    enumerable: true,
    get: function() {
        return $0e247cd7faad5b27$var$_applyStyles.default;
    }
});

var $0e247cd7faad5b27$var$_createTheme = $0e247cd7faad5b27$require$_interopRequireDefault((parcelRequire("i6Yz2")));

var $0e247cd7faad5b27$var$_createBreakpoints = $0e247cd7faad5b27$require$_interopRequireDefault((parcelRequire("hVW0x")));

var $0e247cd7faad5b27$var$_applyStyles = $0e247cd7faad5b27$require$_interopRequireDefault((parcelRequire("e1wfH")));

});
parcelRegister("i6Yz2", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d2f7c454ab1ec68c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d2f7c454ab1ec68c$var$_deepmerge = $d2f7c454ab1ec68c$require$_interopRequireDefault((parcelRequire("bQ4jM")));

var $d2f7c454ab1ec68c$var$_createBreakpoints = $d2f7c454ab1ec68c$require$_interopRequireDefault((parcelRequire("hVW0x")));

var $d2f7c454ab1ec68c$var$_cssContainerQueries = $d2f7c454ab1ec68c$require$_interopRequireDefault((parcelRequire("18kGB")));

var $d2f7c454ab1ec68c$var$_shape = $d2f7c454ab1ec68c$require$_interopRequireDefault((parcelRequire("5H6wp")));

var $d2f7c454ab1ec68c$var$_createSpacing = $d2f7c454ab1ec68c$require$_interopRequireDefault((parcelRequire("5pAhk")));

var $d2f7c454ab1ec68c$var$_styleFunctionSx = $d2f7c454ab1ec68c$require$_interopRequireDefault((parcelRequire("jUGyl")));

var $d2f7c454ab1ec68c$var$_defaultSxConfig = $d2f7c454ab1ec68c$require$_interopRequireDefault((parcelRequire("epNpO")));

var $d2f7c454ab1ec68c$var$_applyStyles = $d2f7c454ab1ec68c$require$_interopRequireDefault((parcelRequire("e1wfH")));
function $d2f7c454ab1ec68c$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {}, ...other } = options;
    const breakpoints = (0, $d2f7c454ab1ec68c$var$_createBreakpoints.default)(breakpointsInput);
    const spacing = (0, $d2f7c454ab1ec68c$var$_createSpacing.default)(spacingInput);
    let muiTheme = (0, $d2f7c454ab1ec68c$var$_deepmerge.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: {
            mode: 'light',
            ...paletteInput
        },
        spacing: spacing,
        shape: {
            ...$d2f7c454ab1ec68c$var$_shape.default,
            ...shapeInput
        }
    }, other);
    muiTheme = (0, $d2f7c454ab1ec68c$var$_cssContainerQueries.default)(muiTheme);
    muiTheme.applyStyles = $d2f7c454ab1ec68c$var$_applyStyles.default;
    muiTheme = args.reduce((acc, argument)=>(0, $d2f7c454ab1ec68c$var$_deepmerge.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = {
        ...$d2f7c454ab1ec68c$var$_defaultSxConfig.default,
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $d2f7c454ab1ec68c$var$_styleFunctionSx.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $d2f7c454ab1ec68c$var$_default = module.exports.default = $d2f7c454ab1ec68c$var$createTheme;

});
parcelRegister("bQ4jM", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $89e7e67df7bfe402$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $89e7e67df7bfe402$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $89e7e67df7bfe402$var$_deepmerge.default;
    }
});

var $89e7e67df7bfe402$var$_deepmerge = $89e7e67df7bfe402$require$_interopRequireWildcard((parcelRequire("7lnJD")));
Object.keys($89e7e67df7bfe402$var$_deepmerge).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($89e7e67df7bfe402$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $89e7e67df7bfe402$var$_deepmerge[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $89e7e67df7bfe402$var$_deepmerge[key];
        }
    });
});

});
parcelRegister("7lnJD", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $558ce7df2a941302$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $558ce7df2a941302$var$deepmerge;
module.exports.isPlainObject = $558ce7df2a941302$var$isPlainObject;

var $558ce7df2a941302$var$React = $558ce7df2a941302$require$_interopRequireWildcard((parcelRequire("acw62")));

var $4jPKB = parcelRequire("4jPKB");
// https://github.com/sindresorhus/is-plain-obj/blob/main/index.js
function $558ce7df2a941302$var$isPlainObject(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $558ce7df2a941302$var$deepClone(source) {
    if (/*#__PURE__*/ $558ce7df2a941302$var$React.isValidElement(source) || (0, $4jPKB.isValidElementType)(source) || !$558ce7df2a941302$var$isPlainObject(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $558ce7df2a941302$var$deepClone(source[key]);
    });
    return output;
}
/**
 * Merge objects deeply.
 * It will shallow copy React elements.
 *
 * If `options.clone` is set to `false` the source object will be merged directly into the target object.
 *
 * @example
 * ```ts
 * deepmerge({ a: { b: 1 }, d: 2 }, { a: { c: 2 }, d: 4 });
 * // => { a: { b: 1, c: 2 }, d: 4 }
 * ````
 *
 * @param target The target object.
 * @param source The source object.
 * @param options The merge options.
 * @param options.clone Set to `false` to merge the source object directly into the target object.
 * @returns The merged object.
 */ function $558ce7df2a941302$var$deepmerge(target, source, options = {
    clone: true
}) {
    const output = options.clone ? {
        ...target
    } : target;
    if ($558ce7df2a941302$var$isPlainObject(target) && $558ce7df2a941302$var$isPlainObject(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $558ce7df2a941302$var$React.isValidElement(source[key]) || (0, $4jPKB.isValidElementType)(source[key])) output[key] = source[key];
        else if ($558ce7df2a941302$var$isPlainObject(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $558ce7df2a941302$var$isPlainObject(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $558ce7df2a941302$var$deepmerge(target[key], source[key], options);
        else if (options.clone) output[key] = $558ce7df2a941302$var$isPlainObject(source[key]) ? $558ce7df2a941302$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});
parcelRegister("4jPKB", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hkVY4"));

});
parcelRegister("hkVY4", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $c9f145267881427c$export$a7c73072b1a182ae, (v) => $c9f145267881427c$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $c9f145267881427c$export$9f27bc3417b4524d, (v) => $c9f145267881427c$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $c9f145267881427c$export$db77ccec0bb4ccac, (v) => $c9f145267881427c$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $c9f145267881427c$export$8392c0c9d3dcbd35, (v) => $c9f145267881427c$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $c9f145267881427c$export$ffb0004e005737fa, (v) => $c9f145267881427c$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $c9f145267881427c$export$b624eff549462981, (v) => $c9f145267881427c$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $c9f145267881427c$export$7897aa7841a5380c, (v) => $c9f145267881427c$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $c9f145267881427c$export$602eac185826482c, (v) => $c9f145267881427c$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $c9f145267881427c$export$e2c29f18771995cb, (v) => $c9f145267881427c$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $c9f145267881427c$export$5f8d39834fd61797, (v) => $c9f145267881427c$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $c9f145267881427c$export$74bf444e3cd11ea5, (v) => $c9f145267881427c$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $c9f145267881427c$export$998bcd577473dd93, (v) => $c9f145267881427c$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isContextConsumer", () => $c9f145267881427c$export$b706b080d889d2c9, (v) => $c9f145267881427c$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $c9f145267881427c$export$5be5a87408f70ddc, (v) => $c9f145267881427c$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $c9f145267881427c$export$45a5e7f76e0caa8d, (v) => $c9f145267881427c$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $c9f145267881427c$export$455c2e768291efa6, (v) => $c9f145267881427c$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $c9f145267881427c$export$9522e17588c12572, (v) => $c9f145267881427c$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $c9f145267881427c$export$2110ac352bb060b9, (v) => $c9f145267881427c$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $c9f145267881427c$export$56885ab8b9c456ab, (v) => $c9f145267881427c$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $c9f145267881427c$export$d927fcb6adf8f9de, (v) => $c9f145267881427c$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $c9f145267881427c$export$b82d16f27459e05a, (v) => $c9f145267881427c$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $c9f145267881427c$export$522c17b4f5e123e8, (v) => $c9f145267881427c$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $c9f145267881427c$export$1aabd8a0274ecfd6, (v) => $c9f145267881427c$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $c9f145267881427c$export$3d6c20d97e46b957, (v) => $c9f145267881427c$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $c9f145267881427c$export$9b621391a187a31a, (v) => $c9f145267881427c$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $c9f145267881427c$export$f5bbd400c2f4426f, (v) => $c9f145267881427c$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c9f145267881427c$export$a7c73072b1a182ae;
var $c9f145267881427c$export$9f27bc3417b4524d;
var $c9f145267881427c$export$db77ccec0bb4ccac;
var $c9f145267881427c$export$8392c0c9d3dcbd35;
var $c9f145267881427c$export$ffb0004e005737fa;
var $c9f145267881427c$export$b624eff549462981;
var $c9f145267881427c$export$7897aa7841a5380c;
var $c9f145267881427c$export$602eac185826482c;
var $c9f145267881427c$export$e2c29f18771995cb;
var $c9f145267881427c$export$5f8d39834fd61797;
var $c9f145267881427c$export$74bf444e3cd11ea5;
var $c9f145267881427c$export$998bcd577473dd93;
var $c9f145267881427c$export$b706b080d889d2c9;
var $c9f145267881427c$export$5be5a87408f70ddc;
var $c9f145267881427c$export$45a5e7f76e0caa8d;
var $c9f145267881427c$export$455c2e768291efa6;
var $c9f145267881427c$export$9522e17588c12572;
var $c9f145267881427c$export$2110ac352bb060b9;
var $c9f145267881427c$export$56885ab8b9c456ab;
var $c9f145267881427c$export$d927fcb6adf8f9de;
var $c9f145267881427c$export$b82d16f27459e05a;
var $c9f145267881427c$export$522c17b4f5e123e8;
var $c9f145267881427c$export$1aabd8a0274ecfd6;
var $c9f145267881427c$export$3d6c20d97e46b957;
var $c9f145267881427c$export$9b621391a187a31a;
var $c9f145267881427c$export$f5bbd400c2f4426f;
"use strict";
(function() {
    function typeOf(object) {
        if ("object" === typeof object && null !== object) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    switch(object = object.type, object){
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                        case REACT_SUSPENSE_LIST_TYPE:
                        case REACT_VIEW_TRANSITION_TYPE:
                            return object;
                        default:
                            switch(object = object && object.$$typeof, object){
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                    return object;
                                case REACT_CONSUMER_TYPE:
                                    return object;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
    }
    var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
    $c9f145267881427c$export$a7c73072b1a182ae = REACT_CONSUMER_TYPE;
    $c9f145267881427c$export$9f27bc3417b4524d = REACT_CONTEXT_TYPE;
    $c9f145267881427c$export$db77ccec0bb4ccac = REACT_ELEMENT_TYPE;
    $c9f145267881427c$export$8392c0c9d3dcbd35 = REACT_FORWARD_REF_TYPE;
    $c9f145267881427c$export$ffb0004e005737fa = REACT_FRAGMENT_TYPE;
    $c9f145267881427c$export$b624eff549462981 = REACT_LAZY_TYPE;
    $c9f145267881427c$export$7897aa7841a5380c = REACT_MEMO_TYPE;
    $c9f145267881427c$export$602eac185826482c = REACT_PORTAL_TYPE;
    $c9f145267881427c$export$e2c29f18771995cb = REACT_PROFILER_TYPE;
    $c9f145267881427c$export$5f8d39834fd61797 = REACT_STRICT_MODE_TYPE;
    $c9f145267881427c$export$74bf444e3cd11ea5 = REACT_SUSPENSE_TYPE;
    $c9f145267881427c$export$998bcd577473dd93 = REACT_SUSPENSE_LIST_TYPE;
    $c9f145267881427c$export$b706b080d889d2c9 = function(object) {
        return typeOf(object) === REACT_CONSUMER_TYPE;
    };
    $c9f145267881427c$export$5be5a87408f70ddc = function(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    };
    $c9f145267881427c$export$45a5e7f76e0caa8d = function(object) {
        return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
    };
    $c9f145267881427c$export$455c2e768291efa6 = function(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    };
    $c9f145267881427c$export$9522e17588c12572 = function(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    };
    $c9f145267881427c$export$2110ac352bb060b9 = function(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    };
    $c9f145267881427c$export$56885ab8b9c456ab = function(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    };
    $c9f145267881427c$export$d927fcb6adf8f9de = function(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    };
    $c9f145267881427c$export$b82d16f27459e05a = function(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    };
    $c9f145267881427c$export$522c17b4f5e123e8 = function(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    };
    $c9f145267881427c$export$1aabd8a0274ecfd6 = function(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    };
    $c9f145267881427c$export$3d6c20d97e46b957 = function(object) {
        return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
    };
    $c9f145267881427c$export$9b621391a187a31a = function(type) {
        return "string" === typeof type || "function" === typeof type || type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_CONSUMER_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
    };
    $c9f145267881427c$export$f5bbd400c2f4426f = typeOf;
})();

});




parcelRegister("hVW0x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.breakpointKeys = void 0;
module.exports.default = $d0e4c1a921a97ae9$var$createBreakpoints;
// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const $d0e4c1a921a97ae9$var$breakpointKeys = module.exports.breakpointKeys = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $d0e4c1a921a97ae9$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return {
            ...acc,
            [obj.key]: obj.val
        };
    }, {});
};
// Keep in mind that @media is inclusive by the CSS specification.
function $d0e4c1a921a97ae9$var$createBreakpoints(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5, ...other } = breakpoints;
    const sortedValues = $d0e4c1a921a97ae9$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return {
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit,
        ...other
    };
}

});

parcelRegister("18kGB", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $0d3695a183c24848$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $0d3695a183c24848$var$_cssContainerQueries.default;
    }
});
Object.defineProperty(module.exports, "getContainerQuery", {
    enumerable: true,
    get: function() {
        return $0d3695a183c24848$var$_cssContainerQueries.getContainerQuery;
    }
});
Object.defineProperty(module.exports, "isCqShorthand", {
    enumerable: true,
    get: function() {
        return $0d3695a183c24848$var$_cssContainerQueries.isCqShorthand;
    }
});
Object.defineProperty(module.exports, "sortContainerQueries", {
    enumerable: true,
    get: function() {
        return $0d3695a183c24848$var$_cssContainerQueries.sortContainerQueries;
    }
});

var $0d3695a183c24848$var$_cssContainerQueries = $0d3695a183c24848$require$_interopRequireWildcard((parcelRequire("hkwSq")));

});
parcelRegister("hkwSq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c9ddce8fd7553cea$var$cssContainerQueries;
module.exports.getContainerQuery = $c9ddce8fd7553cea$var$getContainerQuery;
module.exports.isCqShorthand = $c9ddce8fd7553cea$var$isCqShorthand;
module.exports.sortContainerQueries = $c9ddce8fd7553cea$var$sortContainerQueries;
/**
 * For using in `sx` prop to sort the breakpoint from low to high.
 * Note: this function does not work and will not support multiple units.
 *       e.g. input: { '@container (min-width:300px)': '1rem', '@container (min-width:40rem)': '2rem' }
 *            output: { '@container (min-width:40rem)': '2rem', '@container (min-width:300px)': '1rem' } // since 40 < 300 even though 40rem > 300px
 */ function $c9ddce8fd7553cea$var$sortContainerQueries(theme, css) {
    if (!theme.containerQueries) return css;
    const sorted = Object.keys(css).filter((key)=>key.startsWith('@container')).sort((a, b)=>{
        const regex = /min-width:\s*([0-9.]+)/;
        return +(a.match(regex)?.[1] || 0) - +(b.match(regex)?.[1] || 0);
    });
    if (!sorted.length) return css;
    return sorted.reduce((acc, key)=>{
        const value = css[key];
        delete acc[key];
        acc[key] = value;
        return acc;
    }, {
        ...css
    });
}
function $c9ddce8fd7553cea$var$isCqShorthand(breakpointKeys, value) {
    return value === '@' || value.startsWith('@') && (breakpointKeys.some((key)=>value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function $c9ddce8fd7553cea$var$getContainerQuery(theme, shorthand) {
    const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
    if (!matches) throw /* minify-error */ new Error(`MUI: The provided shorthand ${`(${shorthand})`} is invalid. The format should be \`@<breakpoint | number>\` or \`@<breakpoint | number>/<container>\`.\n` + 'For example, `@sm` or `@600` or `@40rem/sidebar`.');
    const [, containerQuery, containerName] = matches;
    const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
    return theme.containerQueries(containerName).up(value);
}
function $c9ddce8fd7553cea$var$cssContainerQueries(themeInput) {
    const toContainerQuery = (mediaQuery, name)=>mediaQuery.replace('@media', name ? `@container ${name}` : '@container');
    function attachCq(node, name) {
        node.up = (...args)=>toContainerQuery(themeInput.breakpoints.up(...args), name);
        node.down = (...args)=>toContainerQuery(themeInput.breakpoints.down(...args), name);
        node.between = (...args)=>toContainerQuery(themeInput.breakpoints.between(...args), name);
        node.only = (...args)=>toContainerQuery(themeInput.breakpoints.only(...args), name);
        node.not = (...args)=>{
            const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
            if (result.includes('not all and')) // `@container` does not work with `not all and`, so need to invert the logic
            return result.replace('not all and ', '').replace('min-width:', 'width<').replace('max-width:', 'width>').replace('and', 'or');
            return result;
        };
    }
    const node = {};
    const containerQueries = (name)=>{
        attachCq(node, name);
        return node;
    };
    attachCq(containerQueries);
    return {
        ...themeInput,
        containerQueries: containerQueries
    };
}

});


parcelRegister("5H6wp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $425606f5c9c02d28$var$shape = {
    borderRadius: 4
};
var $425606f5c9c02d28$var$_default = module.exports.default = $425606f5c9c02d28$var$shape;

});

parcelRegister("5pAhk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3f0b6db0539d6afd$var$createSpacing;

var $8ZgMs = parcelRequire("8ZgMs");
// The different signatures imply different meaning for their arguments that can't be expressed structurally.
// We express the difference with variable names.
function $3f0b6db0539d6afd$var$createSpacing(spacingInput = 8, // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
transform = (0, $8ZgMs.createUnarySpacing)({
    spacing: spacingInput
})) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    const spacing = (...argsInput)=>{
        if (!(argsInput.length <= 4)) console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${argsInput.length}`);
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("8ZgMs", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $68b10981a323f192$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $68b10981a323f192$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $68b10981a323f192$var$_spacing.default;
    }
});

var $68b10981a323f192$var$_spacing = $68b10981a323f192$require$_interopRequireWildcard((parcelRequire("lJr29")));
Object.keys($68b10981a323f192$var$_spacing).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($68b10981a323f192$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $68b10981a323f192$var$_spacing[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $68b10981a323f192$var$_spacing[key];
        }
    });
});

});
parcelRegister("lJr29", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $fd22c53f9de5e49d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createUnarySpacing = $fd22c53f9de5e49d$var$createUnarySpacing;
module.exports.createUnaryUnit = $fd22c53f9de5e49d$var$createUnaryUnit;
module.exports.default = void 0;
module.exports.getStyleFromPropValue = $fd22c53f9de5e49d$var$getStyleFromPropValue;
module.exports.getValue = $fd22c53f9de5e49d$var$getValue;
module.exports.margin = $fd22c53f9de5e49d$var$margin;
module.exports.marginKeys = void 0;
module.exports.padding = $fd22c53f9de5e49d$var$padding;
module.exports.paddingKeys = void 0;

var $fd22c53f9de5e49d$var$_responsivePropType = $fd22c53f9de5e49d$require$_interopRequireDefault((parcelRequire("h7FAc")));

var $9mzYC = parcelRequire("9mzYC");

var $fuavR = parcelRequire("fuavR");

var $fd22c53f9de5e49d$var$_merge = $fd22c53f9de5e49d$require$_interopRequireDefault((parcelRequire("3naDD")));

var $fd22c53f9de5e49d$var$_memoize = $fd22c53f9de5e49d$require$_interopRequireDefault((parcelRequire("iaYJn")));
const $fd22c53f9de5e49d$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $fd22c53f9de5e49d$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $fd22c53f9de5e49d$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $fd22c53f9de5e49d$var$getCssProperties = (0, $fd22c53f9de5e49d$var$_memoize.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($fd22c53f9de5e49d$var$aliases[prop]) prop = $fd22c53f9de5e49d$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $fd22c53f9de5e49d$var$properties[a];
    const direction = $fd22c53f9de5e49d$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $fd22c53f9de5e49d$var$marginKeys = module.exports.marginKeys = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $fd22c53f9de5e49d$var$paddingKeys = module.exports.paddingKeys = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $fd22c53f9de5e49d$var$spacingKeys = [
    ...$fd22c53f9de5e49d$var$marginKeys,
    ...$fd22c53f9de5e49d$var$paddingKeys
];
function $fd22c53f9de5e49d$var$createUnaryUnit(theme, themeKey, defaultValue, propName) {
    const themeSpacing = (0, $fuavR.getPath)(theme, themeKey, true) ?? defaultValue;
    if (typeof themeSpacing === 'number' || typeof themeSpacing === 'string') return (val)=>{
        if (typeof val === 'string') return val;
        if (typeof val !== 'number') console.error(`MUI: Expected ${propName} argument to be a number or a string, got ${val}.`);
        if (typeof themeSpacing === 'string') {
            if (themeSpacing.startsWith('var(') && val === 0) return 0;
            if (themeSpacing.startsWith('var(') && val === 1) return themeSpacing;
            return `calc(${val} * ${themeSpacing})`;
        }
        return themeSpacing * val;
    };
    if (Array.isArray(themeSpacing)) return (val)=>{
        if (typeof val === 'string') return val;
        const abs = Math.abs(val);
        if (!Number.isInteger(abs)) console.error([
            `MUI: The \`theme.${themeKey}\` array type cannot be combined with non integer values.` + `You should either use an integer value that can be used as index, or define the \`theme.${themeKey}\` as a number.`
        ].join('\n'));
        else if (abs > themeSpacing.length - 1) console.error([
            `MUI: The value provided (${abs}) overflows.`,
            `The supported values are: ${JSON.stringify(themeSpacing)}.`,
            `${abs} > ${themeSpacing.length - 1}, you need to add the missing values.`
        ].join('\n'));
        const transformed = themeSpacing[abs];
        if (val >= 0) return transformed;
        if (typeof transformed === 'number') return -transformed;
        if (typeof transformed === 'string' && transformed.startsWith('var(')) return `calc(-1 * ${transformed})`;
        return `-${transformed}`;
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    console.error([
        `MUI: The \`theme.${themeKey}\` value (${themeSpacing}) is invalid.`,
        'It should be a number, an array or a function.'
    ].join('\n'));
    return ()=>undefined;
}
function $fd22c53f9de5e49d$var$createUnarySpacing(theme) {
    return $fd22c53f9de5e49d$var$createUnaryUnit(theme, 'spacing', 8, 'spacing');
}
function $fd22c53f9de5e49d$var$getValue(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    return transformer(propValue);
}
function $fd22c53f9de5e49d$var$getStyleFromPropValue(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $fd22c53f9de5e49d$var$getValue(transformer, propValue);
            return acc;
        }, {});
}
function $fd22c53f9de5e49d$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (!keys.includes(prop)) return null;
    const cssProperties = $fd22c53f9de5e49d$var$getCssProperties(prop);
    const styleFromPropValue = $fd22c53f9de5e49d$var$getStyleFromPropValue(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $9mzYC.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $fd22c53f9de5e49d$var$style(props, keys) {
    const transformer = $fd22c53f9de5e49d$var$createUnarySpacing(props.theme);
    return Object.keys(props).map((prop)=>$fd22c53f9de5e49d$var$resolveCssProperty(props, keys, prop, transformer)).reduce($fd22c53f9de5e49d$var$_merge.default, {});
}
function $fd22c53f9de5e49d$var$margin(props) {
    return $fd22c53f9de5e49d$var$style(props, $fd22c53f9de5e49d$var$marginKeys);
}
$fd22c53f9de5e49d$var$margin.propTypes = $fd22c53f9de5e49d$var$marginKeys.reduce((obj, key)=>{
    obj[key] = $fd22c53f9de5e49d$var$_responsivePropType.default;
    return obj;
}, {});
$fd22c53f9de5e49d$var$margin.filterProps = $fd22c53f9de5e49d$var$marginKeys;
function $fd22c53f9de5e49d$var$padding(props) {
    return $fd22c53f9de5e49d$var$style(props, $fd22c53f9de5e49d$var$paddingKeys);
}
$fd22c53f9de5e49d$var$padding.propTypes = $fd22c53f9de5e49d$var$paddingKeys.reduce((obj, key)=>{
    obj[key] = $fd22c53f9de5e49d$var$_responsivePropType.default;
    return obj;
}, {});
$fd22c53f9de5e49d$var$padding.filterProps = $fd22c53f9de5e49d$var$paddingKeys;
function $fd22c53f9de5e49d$var$spacing(props) {
    return $fd22c53f9de5e49d$var$style(props, $fd22c53f9de5e49d$var$spacingKeys);
}
$fd22c53f9de5e49d$var$spacing.propTypes = $fd22c53f9de5e49d$var$spacingKeys.reduce((obj, key)=>{
    obj[key] = $fd22c53f9de5e49d$var$_responsivePropType.default;
    return obj;
}, {});
$fd22c53f9de5e49d$var$spacing.filterProps = $fd22c53f9de5e49d$var$spacingKeys;
var $fd22c53f9de5e49d$var$_default = module.exports.default = $fd22c53f9de5e49d$var$spacing;

});
parcelRegister("h7FAc", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c773589584969aa7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $c773589584969aa7$var$_responsivePropType.default;
    }
});

var $c773589584969aa7$var$_responsivePropType = $c773589584969aa7$require$_interopRequireDefault((parcelRequire("aLDOi")));

});
parcelRegister("aLDOi", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $7d6d2ca3605e13f8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7d6d2ca3605e13f8$var$_propTypes = $7d6d2ca3605e13f8$require$_interopRequireDefault((parcelRequire("c9Z8w")));
const $7d6d2ca3605e13f8$var$responsivePropType = $7d6d2ca3605e13f8$var$_propTypes.default.oneOfType([
    $7d6d2ca3605e13f8$var$_propTypes.default.number,
    $7d6d2ca3605e13f8$var$_propTypes.default.string,
    $7d6d2ca3605e13f8$var$_propTypes.default.object,
    $7d6d2ca3605e13f8$var$_propTypes.default.array
]);
var $7d6d2ca3605e13f8$var$_default = module.exports.default = $7d6d2ca3605e13f8$var$responsivePropType;

});


parcelRegister("9mzYC", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $6d12135a7affaa27$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $6d12135a7affaa27$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $6d12135a7affaa27$var$_breakpoints.default;
    }
});

var $6d12135a7affaa27$var$_breakpoints = $6d12135a7affaa27$require$_interopRequireWildcard((parcelRequire("1D6M1")));
Object.keys($6d12135a7affaa27$var$_breakpoints).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($6d12135a7affaa27$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $6d12135a7affaa27$var$_breakpoints[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6d12135a7affaa27$var$_breakpoints[key];
        }
    });
});

});
parcelRegister("1D6M1", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $12feb01311e15547$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.computeBreakpointsBase = $12feb01311e15547$var$computeBreakpointsBase;
module.exports.createEmptyBreakpointObject = $12feb01311e15547$var$createEmptyBreakpointObject;
module.exports.default = void 0;
module.exports.handleBreakpoints = $12feb01311e15547$var$handleBreakpoints;
module.exports.mergeBreakpointsInOrder = $12feb01311e15547$var$mergeBreakpointsInOrder;
module.exports.removeUnusedBreakpoints = $12feb01311e15547$var$removeUnusedBreakpoints;
module.exports.resolveBreakpointValues = $12feb01311e15547$var$resolveBreakpointValues;
module.exports.values = void 0;

var $12feb01311e15547$var$_propTypes = $12feb01311e15547$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $12feb01311e15547$var$_deepmerge = $12feb01311e15547$require$_interopRequireDefault((parcelRequire("bQ4jM")));

var $12feb01311e15547$var$_merge = $12feb01311e15547$require$_interopRequireDefault((parcelRequire("3naDD")));

var $18kGB = parcelRequire("18kGB");
// The breakpoint **start** at this value.
// For instance with the first breakpoint xs: [xs, sm[.
const $12feb01311e15547$var$values = module.exports.values = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $12feb01311e15547$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$12feb01311e15547$var$values[key]}px)`
};
const $12feb01311e15547$var$defaultContainerQueries = {
    containerQueries: (containerName)=>({
            up: (key)=>{
                let result = typeof key === 'number' ? key : $12feb01311e15547$var$values[key] || key;
                if (typeof result === 'number') result = `${result}px`;
                return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
            }
        })
};
function $12feb01311e15547$var$handleBreakpoints(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $12feb01311e15547$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $12feb01311e15547$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            if ((0, $18kGB.isCqShorthand)(themeBreakpoints.keys, breakpoint)) {
                const containerKey = (0, $18kGB.getContainerQuery)(theme.containerQueries ? theme : $12feb01311e15547$var$defaultContainerQueries, breakpoint);
                if (containerKey) acc[containerKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else if (Object.keys(themeBreakpoints.values || $12feb01311e15547$var$values).includes(breakpoint)) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $12feb01311e15547$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $12feb01311e15547$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction({
                    theme: theme,
                    ...props[key]
                });
            }
            return acc;
        }, null);
        return (0, $12feb01311e15547$var$_merge.default)(base, extended);
    };
    newStyleFunction.propTypes = {
        ...styleFunction.propTypes,
        xs: $12feb01311e15547$var$_propTypes.default.object,
        sm: $12feb01311e15547$var$_propTypes.default.object,
        md: $12feb01311e15547$var$_propTypes.default.object,
        lg: $12feb01311e15547$var$_propTypes.default.object,
        xl: $12feb01311e15547$var$_propTypes.default.object
    };
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $12feb01311e15547$var$createEmptyBreakpointObject(breakpointsInput = {}) {
    const breakpointsInOrder = breakpointsInput.keys?.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $12feb01311e15547$var$removeUnusedBreakpoints(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $12feb01311e15547$var$mergeBreakpointsInOrder(breakpointsInput, ...styles) {
    const emptyBreakpoints = $12feb01311e15547$var$createEmptyBreakpointObject(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $12feb01311e15547$var$_deepmerge.default)(prev, next), {});
    return $12feb01311e15547$var$removeUnusedBreakpoints(Object.keys(emptyBreakpoints), mergedOutput);
}
// compute base for responsive values; e.g.,
// [1,2,3] => {xs: true, sm: true, md: true}
// {xs: 1, sm: 2, md: 3} => {xs: true, sm: true, md: true}
function $12feb01311e15547$var$computeBreakpointsBase(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $12feb01311e15547$var$resolveBreakpointValues({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $12feb01311e15547$var$computeBreakpointsBase(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $12feb01311e15547$var$_default = module.exports.default = $12feb01311e15547$var$breakpoints;

});
parcelRegister("3naDD", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $274bc59c460c5c83$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $274bc59c460c5c83$var$_merge.default;
    }
});

var $274bc59c460c5c83$var$_merge = $274bc59c460c5c83$require$_interopRequireDefault((parcelRequire("jb2Pw")));

});
parcelRegister("jb2Pw", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $df613d60ccca226b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $df613d60ccca226b$var$_deepmerge = $df613d60ccca226b$require$_interopRequireDefault((parcelRequire("bQ4jM")));
function $df613d60ccca226b$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $df613d60ccca226b$var$_deepmerge.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $df613d60ccca226b$var$_default = module.exports.default = $df613d60ccca226b$var$merge;

});




parcelRegister("fuavR", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $b461d00304dae97f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $b461d00304dae97f$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $b461d00304dae97f$var$_style.default;
    }
});

var $b461d00304dae97f$var$_style = $b461d00304dae97f$require$_interopRequireWildcard((parcelRequire("5Wz76")));
Object.keys($b461d00304dae97f$var$_style).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($b461d00304dae97f$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $b461d00304dae97f$var$_style[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b461d00304dae97f$var$_style[key];
        }
    });
});

});
parcelRegister("5Wz76", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $453d9b5a5bc206c2$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getPath = $453d9b5a5bc206c2$var$getPath;
module.exports.getStyleValue = $453d9b5a5bc206c2$var$getStyleValue;

var $453d9b5a5bc206c2$var$_capitalize = $453d9b5a5bc206c2$require$_interopRequireDefault((parcelRequire("4O6za")));

var $453d9b5a5bc206c2$var$_responsivePropType = $453d9b5a5bc206c2$require$_interopRequireDefault((parcelRequire("h7FAc")));

var $9mzYC = parcelRequire("9mzYC");
function $453d9b5a5bc206c2$var$getPath(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $453d9b5a5bc206c2$var$getStyleValue(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $453d9b5a5bc206c2$var$getPath(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $453d9b5a5bc206c2$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $453d9b5a5bc206c2$var$getPath(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $453d9b5a5bc206c2$var$getStyleValue(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $453d9b5a5bc206c2$var$getStyleValue(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $453d9b5a5bc206c2$var$_capitalize.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $9mzYC.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {
        [prop]: $453d9b5a5bc206c2$var$_responsivePropType.default
    };
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $453d9b5a5bc206c2$var$_default = module.exports.default = $453d9b5a5bc206c2$var$style;

});
parcelRegister("4O6za", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3800ecdd7c2cde61$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $3800ecdd7c2cde61$var$_capitalize.default;
    }
});

var $3800ecdd7c2cde61$var$_capitalize = $3800ecdd7c2cde61$require$_interopRequireDefault((parcelRequire("afs59")));

});
parcelRegister("afs59", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $776116989b0b93ea$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $776116989b0b93ea$var$capitalize;

var $776116989b0b93ea$var$_formatMuiErrorMessage = $776116989b0b93ea$require$_interopRequireDefault((parcelRequire("4Z6Nd")));
// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word in the sentence.
// We only handle the first word.
function $776116989b0b93ea$var$capitalize(string) {
    if (typeof string !== 'string') throw new Error('MUI: `capitalize(string)` expects a string argument.');
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});




parcelRegister("iaYJn", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d3b8450df3f074ab$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $d3b8450df3f074ab$var$_memoize.default;
    }
});

var $d3b8450df3f074ab$var$_memoize = $d3b8450df3f074ab$require$_interopRequireDefault((parcelRequire("9Z7Cd")));

});
parcelRegister("9Z7Cd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $744fb7d21d4e0357$var$memoize;
function $744fb7d21d4e0357$var$memoize(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});





parcelRegister("jUGyl", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e7f4416c1e9a283b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.unstable_createStyleFunctionSx = $e7f4416c1e9a283b$var$unstable_createStyleFunctionSx;

var $e7f4416c1e9a283b$var$_capitalize = $e7f4416c1e9a283b$require$_interopRequireDefault((parcelRequire("4O6za")));

var $e7f4416c1e9a283b$var$_merge = $e7f4416c1e9a283b$require$_interopRequireDefault((parcelRequire("3naDD")));

var $fuavR = parcelRequire("fuavR");

var $9mzYC = parcelRequire("9mzYC");

var $18kGB = parcelRequire("18kGB");

var $e7f4416c1e9a283b$var$_defaultSxConfig = $e7f4416c1e9a283b$require$_interopRequireDefault((parcelRequire("epNpO")));
function $e7f4416c1e9a283b$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $e7f4416c1e9a283b$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
// eslint-disable-next-line @typescript-eslint/naming-convention
function $e7f4416c1e9a283b$var$unstable_createStyleFunctionSx() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $fuavR.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $fuavR.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $fuavR.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $e7f4416c1e9a283b$var$_capitalize.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $9mzYC.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        const { sx: sx, theme: theme = {}, nested: nested } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = theme.unstable_sxConfig ?? $e7f4416c1e9a283b$var$_defaultSxConfig.default;
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $9mzYC.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $e7f4416c1e9a283b$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $e7f4416c1e9a283b$var$_merge.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $9mzYC.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($e7f4416c1e9a283b$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme,
                                nested: true
                            });
                            else css = (0, $e7f4416c1e9a283b$var$_merge.default)(css, breakpointsValues);
                        }
                    } else css = (0, $e7f4416c1e9a283b$var$_merge.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            if (!nested && theme.modularCssLayers) return {
                '@layer sx': (0, $18kGB.sortContainerQueries)(theme, (0, $9mzYC.removeUnusedBreakpoints)(breakpointsKeys, css))
            };
            return (0, $18kGB.sortContainerQueries)(theme, (0, $9mzYC.removeUnusedBreakpoints)(breakpointsKeys, css));
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $e7f4416c1e9a283b$var$styleFunctionSx = $e7f4416c1e9a283b$var$unstable_createStyleFunctionSx();
$e7f4416c1e9a283b$var$styleFunctionSx.filterProps = [
    'sx'
];
var $e7f4416c1e9a283b$var$_default = module.exports.default = $e7f4416c1e9a283b$var$styleFunctionSx;

});
parcelRegister("epNpO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8ZgMs = parcelRequire("8ZgMs");

var $7G2Ky = parcelRequire("7G2Ky");

var $bvdLQ = parcelRequire("bvdLQ");

var $7Izgs = parcelRequire("7Izgs");

var $lk86k = parcelRequire("lk86k");
const $a7e9bb596240d630$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: $7G2Ky.borderTransform
    },
    borderTop: {
        themeKey: 'borders',
        transform: $7G2Ky.borderTransform
    },
    borderRight: {
        themeKey: 'borders',
        transform: $7G2Ky.borderTransform
    },
    borderBottom: {
        themeKey: 'borders',
        transform: $7G2Ky.borderTransform
    },
    borderLeft: {
        themeKey: 'borders',
        transform: $7G2Ky.borderTransform
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: $7G2Ky.borderTransform
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: $7G2Ky.borderRadius
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: $7Izgs.paletteTransform
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: $7Izgs.paletteTransform
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: $7Izgs.paletteTransform
    },
    // spacing
    p: {
        style: $8ZgMs.padding
    },
    pt: {
        style: $8ZgMs.padding
    },
    pr: {
        style: $8ZgMs.padding
    },
    pb: {
        style: $8ZgMs.padding
    },
    pl: {
        style: $8ZgMs.padding
    },
    px: {
        style: $8ZgMs.padding
    },
    py: {
        style: $8ZgMs.padding
    },
    padding: {
        style: $8ZgMs.padding
    },
    paddingTop: {
        style: $8ZgMs.padding
    },
    paddingRight: {
        style: $8ZgMs.padding
    },
    paddingBottom: {
        style: $8ZgMs.padding
    },
    paddingLeft: {
        style: $8ZgMs.padding
    },
    paddingX: {
        style: $8ZgMs.padding
    },
    paddingY: {
        style: $8ZgMs.padding
    },
    paddingInline: {
        style: $8ZgMs.padding
    },
    paddingInlineStart: {
        style: $8ZgMs.padding
    },
    paddingInlineEnd: {
        style: $8ZgMs.padding
    },
    paddingBlock: {
        style: $8ZgMs.padding
    },
    paddingBlockStart: {
        style: $8ZgMs.padding
    },
    paddingBlockEnd: {
        style: $8ZgMs.padding
    },
    m: {
        style: $8ZgMs.margin
    },
    mt: {
        style: $8ZgMs.margin
    },
    mr: {
        style: $8ZgMs.margin
    },
    mb: {
        style: $8ZgMs.margin
    },
    ml: {
        style: $8ZgMs.margin
    },
    mx: {
        style: $8ZgMs.margin
    },
    my: {
        style: $8ZgMs.margin
    },
    margin: {
        style: $8ZgMs.margin
    },
    marginTop: {
        style: $8ZgMs.margin
    },
    marginRight: {
        style: $8ZgMs.margin
    },
    marginBottom: {
        style: $8ZgMs.margin
    },
    marginLeft: {
        style: $8ZgMs.margin
    },
    marginX: {
        style: $8ZgMs.margin
    },
    marginY: {
        style: $8ZgMs.margin
    },
    marginInline: {
        style: $8ZgMs.margin
    },
    marginInlineStart: {
        style: $8ZgMs.margin
    },
    marginInlineEnd: {
        style: $8ZgMs.margin
    },
    marginBlock: {
        style: $8ZgMs.margin
    },
    marginBlockStart: {
        style: $8ZgMs.margin
    },
    marginBlockEnd: {
        style: $8ZgMs.margin
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: $bvdLQ.gap
    },
    rowGap: {
        style: $bvdLQ.rowGap
    },
    columnGap: {
        style: $bvdLQ.columnGap
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: $lk86k.sizingTransform
    },
    maxWidth: {
        style: $lk86k.maxWidth
    },
    minWidth: {
        transform: $lk86k.sizingTransform
    },
    height: {
        transform: $lk86k.sizingTransform
    },
    maxHeight: {
        transform: $lk86k.sizingTransform
    },
    minHeight: {
        transform: $lk86k.sizingTransform
    },
    boxSizing: {},
    // typography
    font: {
        themeKey: 'font'
    },
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $a7e9bb596240d630$var$_default = module.exports.default = $a7e9bb596240d630$var$defaultSxConfig;

});
parcelRegister("7G2Ky", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $596e96b5ea46c9bd$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $596e96b5ea46c9bd$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $596e96b5ea46c9bd$var$_borders.default;
    }
});

var $596e96b5ea46c9bd$var$_borders = $596e96b5ea46c9bd$require$_interopRequireWildcard((parcelRequire("ey2Y4")));
Object.keys($596e96b5ea46c9bd$var$_borders).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($596e96b5ea46c9bd$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $596e96b5ea46c9bd$var$_borders[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $596e96b5ea46c9bd$var$_borders[key];
        }
    });
});

});
parcelRegister("ey2Y4", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a9768b07cfcbed12$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.borderTopColor = module.exports.borderTop = module.exports.borderRightColor = module.exports.borderRight = module.exports.borderRadius = module.exports.borderLeftColor = module.exports.borderLeft = module.exports.borderColor = module.exports.borderBottomColor = module.exports.borderBottom = module.exports.border = void 0;
module.exports.borderTransform = $a9768b07cfcbed12$var$borderTransform;
module.exports.outlineColor = module.exports.outline = module.exports.default = void 0;

var $a9768b07cfcbed12$var$_responsivePropType = $a9768b07cfcbed12$require$_interopRequireDefault((parcelRequire("h7FAc")));

var $a9768b07cfcbed12$var$_style = $a9768b07cfcbed12$require$_interopRequireDefault((parcelRequire("fuavR")));

var $a9768b07cfcbed12$var$_compose = $a9768b07cfcbed12$require$_interopRequireDefault((parcelRequire("79Mi4")));

var $8ZgMs = parcelRequire("8ZgMs");

var $9mzYC = parcelRequire("9mzYC");
function $a9768b07cfcbed12$var$borderTransform(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $a9768b07cfcbed12$var$createBorderStyle(prop, transform) {
    return (0, $a9768b07cfcbed12$var$_style.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $a9768b07cfcbed12$var$border = module.exports.border = $a9768b07cfcbed12$var$createBorderStyle('border', $a9768b07cfcbed12$var$borderTransform);
const $a9768b07cfcbed12$var$borderTop = module.exports.borderTop = $a9768b07cfcbed12$var$createBorderStyle('borderTop', $a9768b07cfcbed12$var$borderTransform);
const $a9768b07cfcbed12$var$borderRight = module.exports.borderRight = $a9768b07cfcbed12$var$createBorderStyle('borderRight', $a9768b07cfcbed12$var$borderTransform);
const $a9768b07cfcbed12$var$borderBottom = module.exports.borderBottom = $a9768b07cfcbed12$var$createBorderStyle('borderBottom', $a9768b07cfcbed12$var$borderTransform);
const $a9768b07cfcbed12$var$borderLeft = module.exports.borderLeft = $a9768b07cfcbed12$var$createBorderStyle('borderLeft', $a9768b07cfcbed12$var$borderTransform);
const $a9768b07cfcbed12$var$borderColor = module.exports.borderColor = $a9768b07cfcbed12$var$createBorderStyle('borderColor');
const $a9768b07cfcbed12$var$borderTopColor = module.exports.borderTopColor = $a9768b07cfcbed12$var$createBorderStyle('borderTopColor');
const $a9768b07cfcbed12$var$borderRightColor = module.exports.borderRightColor = $a9768b07cfcbed12$var$createBorderStyle('borderRightColor');
const $a9768b07cfcbed12$var$borderBottomColor = module.exports.borderBottomColor = $a9768b07cfcbed12$var$createBorderStyle('borderBottomColor');
const $a9768b07cfcbed12$var$borderLeftColor = module.exports.borderLeftColor = $a9768b07cfcbed12$var$createBorderStyle('borderLeftColor');
const $a9768b07cfcbed12$var$outline = module.exports.outline = $a9768b07cfcbed12$var$createBorderStyle('outline', $a9768b07cfcbed12$var$borderTransform);
const $a9768b07cfcbed12$var$outlineColor = module.exports.outlineColor = $a9768b07cfcbed12$var$createBorderStyle('outlineColor');
// false positive
// eslint-disable-next-line react/function-component-definition
const $a9768b07cfcbed12$var$borderRadius = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $8ZgMs.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $8ZgMs.getValue)(transformer, propValue)
            });
        return (0, $9mzYC.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
module.exports.borderRadius = $a9768b07cfcbed12$var$borderRadius;
$a9768b07cfcbed12$var$borderRadius.propTypes = {
    borderRadius: $a9768b07cfcbed12$var$_responsivePropType.default
};
$a9768b07cfcbed12$var$borderRadius.filterProps = [
    'borderRadius'
];
const $a9768b07cfcbed12$var$borders = (0, $a9768b07cfcbed12$var$_compose.default)($a9768b07cfcbed12$var$border, $a9768b07cfcbed12$var$borderTop, $a9768b07cfcbed12$var$borderRight, $a9768b07cfcbed12$var$borderBottom, $a9768b07cfcbed12$var$borderLeft, $a9768b07cfcbed12$var$borderColor, $a9768b07cfcbed12$var$borderTopColor, $a9768b07cfcbed12$var$borderRightColor, $a9768b07cfcbed12$var$borderBottomColor, $a9768b07cfcbed12$var$borderLeftColor, $a9768b07cfcbed12$var$borderRadius, $a9768b07cfcbed12$var$outline, $a9768b07cfcbed12$var$outlineColor);
var $a9768b07cfcbed12$var$_default = module.exports.default = $a9768b07cfcbed12$var$borders;

});
parcelRegister("79Mi4", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $535ed5230f7674fe$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $535ed5230f7674fe$var$_compose.default;
    }
});

var $535ed5230f7674fe$var$_compose = $535ed5230f7674fe$require$_interopRequireDefault((parcelRequire("8J1Q9")));

});
parcelRegister("8J1Q9", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $65a3f4214179460a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $65a3f4214179460a$var$_merge = $65a3f4214179460a$require$_interopRequireDefault((parcelRequire("3naDD")));
function $65a3f4214179460a$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $65a3f4214179460a$var$_merge.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = styles.reduce((acc, style)=>Object.assign(acc, style.propTypes), {});
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $65a3f4214179460a$var$_default = module.exports.default = $65a3f4214179460a$var$compose;

});




parcelRegister("bvdLQ", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $85fd458c5ff1d64f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $85fd458c5ff1d64f$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $85fd458c5ff1d64f$var$_cssGrid.default;
    }
});

var $85fd458c5ff1d64f$var$_cssGrid = $85fd458c5ff1d64f$require$_interopRequireWildcard((parcelRequire("guYP5")));
Object.keys($85fd458c5ff1d64f$var$_cssGrid).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($85fd458c5ff1d64f$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $85fd458c5ff1d64f$var$_cssGrid[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $85fd458c5ff1d64f$var$_cssGrid[key];
        }
    });
});

});
parcelRegister("guYP5", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c02ea0e0a59e3ff1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rowGap = module.exports.gridTemplateRows = module.exports.gridTemplateColumns = module.exports.gridTemplateAreas = module.exports.gridRow = module.exports.gridColumn = module.exports.gridAutoRows = module.exports.gridAutoFlow = module.exports.gridAutoColumns = module.exports.gridArea = module.exports.gap = module.exports.default = module.exports.columnGap = void 0;

var $c02ea0e0a59e3ff1$var$_style = $c02ea0e0a59e3ff1$require$_interopRequireDefault((parcelRequire("fuavR")));

var $c02ea0e0a59e3ff1$var$_compose = $c02ea0e0a59e3ff1$require$_interopRequireDefault((parcelRequire("79Mi4")));

var $8ZgMs = parcelRequire("8ZgMs");

var $9mzYC = parcelRequire("9mzYC");

var $c02ea0e0a59e3ff1$var$_responsivePropType = $c02ea0e0a59e3ff1$require$_interopRequireDefault((parcelRequire("h7FAc")));
// false positive
// eslint-disable-next-line react/function-component-definition
const $c02ea0e0a59e3ff1$var$gap = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $8ZgMs.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $8ZgMs.getValue)(transformer, propValue)
            });
        return (0, $9mzYC.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
module.exports.gap = $c02ea0e0a59e3ff1$var$gap;
$c02ea0e0a59e3ff1$var$gap.propTypes = {
    gap: $c02ea0e0a59e3ff1$var$_responsivePropType.default
};
$c02ea0e0a59e3ff1$var$gap.filterProps = [
    'gap'
];
// false positive
// eslint-disable-next-line react/function-component-definition
const $c02ea0e0a59e3ff1$var$columnGap = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $8ZgMs.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $8ZgMs.getValue)(transformer, propValue)
            });
        return (0, $9mzYC.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
module.exports.columnGap = $c02ea0e0a59e3ff1$var$columnGap;
$c02ea0e0a59e3ff1$var$columnGap.propTypes = {
    columnGap: $c02ea0e0a59e3ff1$var$_responsivePropType.default
};
$c02ea0e0a59e3ff1$var$columnGap.filterProps = [
    'columnGap'
];
// false positive
// eslint-disable-next-line react/function-component-definition
const $c02ea0e0a59e3ff1$var$rowGap = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $8ZgMs.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $8ZgMs.getValue)(transformer, propValue)
            });
        return (0, $9mzYC.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
module.exports.rowGap = $c02ea0e0a59e3ff1$var$rowGap;
$c02ea0e0a59e3ff1$var$rowGap.propTypes = {
    rowGap: $c02ea0e0a59e3ff1$var$_responsivePropType.default
};
$c02ea0e0a59e3ff1$var$rowGap.filterProps = [
    'rowGap'
];
const $c02ea0e0a59e3ff1$var$gridColumn = module.exports.gridColumn = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridColumn'
});
const $c02ea0e0a59e3ff1$var$gridRow = module.exports.gridRow = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridRow'
});
const $c02ea0e0a59e3ff1$var$gridAutoFlow = module.exports.gridAutoFlow = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridAutoFlow'
});
const $c02ea0e0a59e3ff1$var$gridAutoColumns = module.exports.gridAutoColumns = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridAutoColumns'
});
const $c02ea0e0a59e3ff1$var$gridAutoRows = module.exports.gridAutoRows = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridAutoRows'
});
const $c02ea0e0a59e3ff1$var$gridTemplateColumns = module.exports.gridTemplateColumns = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridTemplateColumns'
});
const $c02ea0e0a59e3ff1$var$gridTemplateRows = module.exports.gridTemplateRows = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridTemplateRows'
});
const $c02ea0e0a59e3ff1$var$gridTemplateAreas = module.exports.gridTemplateAreas = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridTemplateAreas'
});
const $c02ea0e0a59e3ff1$var$gridArea = module.exports.gridArea = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridArea'
});
const $c02ea0e0a59e3ff1$var$grid = (0, $c02ea0e0a59e3ff1$var$_compose.default)($c02ea0e0a59e3ff1$var$gap, $c02ea0e0a59e3ff1$var$columnGap, $c02ea0e0a59e3ff1$var$rowGap, $c02ea0e0a59e3ff1$var$gridColumn, $c02ea0e0a59e3ff1$var$gridRow, $c02ea0e0a59e3ff1$var$gridAutoFlow, $c02ea0e0a59e3ff1$var$gridAutoColumns, $c02ea0e0a59e3ff1$var$gridAutoRows, $c02ea0e0a59e3ff1$var$gridTemplateColumns, $c02ea0e0a59e3ff1$var$gridTemplateRows, $c02ea0e0a59e3ff1$var$gridTemplateAreas, $c02ea0e0a59e3ff1$var$gridArea);
var $c02ea0e0a59e3ff1$var$_default = module.exports.default = $c02ea0e0a59e3ff1$var$grid;

});


parcelRegister("7Izgs", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $59e7ff3bb6005a45$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $59e7ff3bb6005a45$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $59e7ff3bb6005a45$var$_palette.default;
    }
});

var $59e7ff3bb6005a45$var$_palette = $59e7ff3bb6005a45$require$_interopRequireWildcard((parcelRequire("hQFW7")));
Object.keys($59e7ff3bb6005a45$var$_palette).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($59e7ff3bb6005a45$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $59e7ff3bb6005a45$var$_palette[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $59e7ff3bb6005a45$var$_palette[key];
        }
    });
});

});
parcelRegister("hQFW7", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $cfe7d2b3f50e7c96$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.color = module.exports.bgcolor = module.exports.backgroundColor = void 0;
module.exports.paletteTransform = $cfe7d2b3f50e7c96$var$paletteTransform;

var $cfe7d2b3f50e7c96$var$_style = $cfe7d2b3f50e7c96$require$_interopRequireDefault((parcelRequire("fuavR")));

var $cfe7d2b3f50e7c96$var$_compose = $cfe7d2b3f50e7c96$require$_interopRequireDefault((parcelRequire("79Mi4")));
function $cfe7d2b3f50e7c96$var$paletteTransform(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $cfe7d2b3f50e7c96$var$color = module.exports.color = (0, $cfe7d2b3f50e7c96$var$_style.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $cfe7d2b3f50e7c96$var$paletteTransform
});
const $cfe7d2b3f50e7c96$var$bgcolor = module.exports.bgcolor = (0, $cfe7d2b3f50e7c96$var$_style.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $cfe7d2b3f50e7c96$var$paletteTransform
});
const $cfe7d2b3f50e7c96$var$backgroundColor = module.exports.backgroundColor = (0, $cfe7d2b3f50e7c96$var$_style.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $cfe7d2b3f50e7c96$var$paletteTransform
});
const $cfe7d2b3f50e7c96$var$palette = (0, $cfe7d2b3f50e7c96$var$_compose.default)($cfe7d2b3f50e7c96$var$color, $cfe7d2b3f50e7c96$var$bgcolor, $cfe7d2b3f50e7c96$var$backgroundColor);
var $cfe7d2b3f50e7c96$var$_default = module.exports.default = $cfe7d2b3f50e7c96$var$palette;

});


parcelRegister("lk86k", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $f861bfedd540c484$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $f861bfedd540c484$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $f861bfedd540c484$var$_sizing.default;
    }
});

var $f861bfedd540c484$var$_sizing = $f861bfedd540c484$require$_interopRequireWildcard((parcelRequire("8hW4G")));
Object.keys($f861bfedd540c484$var$_sizing).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($f861bfedd540c484$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $f861bfedd540c484$var$_sizing[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $f861bfedd540c484$var$_sizing[key];
        }
    });
});

});
parcelRegister("8hW4G", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $608cf5a5bac56020$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sizeWidth = module.exports.sizeHeight = module.exports.minWidth = module.exports.minHeight = module.exports.maxWidth = module.exports.maxHeight = module.exports.height = module.exports.default = module.exports.boxSizing = void 0;
module.exports.sizingTransform = $608cf5a5bac56020$var$sizingTransform;
module.exports.width = void 0;

var $608cf5a5bac56020$var$_style = $608cf5a5bac56020$require$_interopRequireDefault((parcelRequire("fuavR")));

var $608cf5a5bac56020$var$_compose = $608cf5a5bac56020$require$_interopRequireDefault((parcelRequire("79Mi4")));

var $9mzYC = parcelRequire("9mzYC");
function $608cf5a5bac56020$var$sizingTransform(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $608cf5a5bac56020$var$width = module.exports.width = (0, $608cf5a5bac56020$var$_style.default)({
    prop: 'width',
    transform: $608cf5a5bac56020$var$sizingTransform
});
const $608cf5a5bac56020$var$maxWidth = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            const breakpoint = props.theme?.breakpoints?.values?.[propValue] || $9mzYC.values[propValue];
            if (!breakpoint) return {
                maxWidth: $608cf5a5bac56020$var$sizingTransform(propValue)
            };
            if (props.theme?.breakpoints?.unit !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $9mzYC.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
module.exports.maxWidth = $608cf5a5bac56020$var$maxWidth;
$608cf5a5bac56020$var$maxWidth.filterProps = [
    'maxWidth'
];
const $608cf5a5bac56020$var$minWidth = module.exports.minWidth = (0, $608cf5a5bac56020$var$_style.default)({
    prop: 'minWidth',
    transform: $608cf5a5bac56020$var$sizingTransform
});
const $608cf5a5bac56020$var$height = module.exports.height = (0, $608cf5a5bac56020$var$_style.default)({
    prop: 'height',
    transform: $608cf5a5bac56020$var$sizingTransform
});
const $608cf5a5bac56020$var$maxHeight = module.exports.maxHeight = (0, $608cf5a5bac56020$var$_style.default)({
    prop: 'maxHeight',
    transform: $608cf5a5bac56020$var$sizingTransform
});
const $608cf5a5bac56020$var$minHeight = module.exports.minHeight = (0, $608cf5a5bac56020$var$_style.default)({
    prop: 'minHeight',
    transform: $608cf5a5bac56020$var$sizingTransform
});
const $608cf5a5bac56020$var$sizeWidth = module.exports.sizeWidth = (0, $608cf5a5bac56020$var$_style.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $608cf5a5bac56020$var$sizingTransform
});
const $608cf5a5bac56020$var$sizeHeight = module.exports.sizeHeight = (0, $608cf5a5bac56020$var$_style.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $608cf5a5bac56020$var$sizingTransform
});
const $608cf5a5bac56020$var$boxSizing = module.exports.boxSizing = (0, $608cf5a5bac56020$var$_style.default)({
    prop: 'boxSizing'
});
const $608cf5a5bac56020$var$sizing = (0, $608cf5a5bac56020$var$_compose.default)($608cf5a5bac56020$var$width, $608cf5a5bac56020$var$maxWidth, $608cf5a5bac56020$var$minWidth, $608cf5a5bac56020$var$height, $608cf5a5bac56020$var$maxHeight, $608cf5a5bac56020$var$minHeight, $608cf5a5bac56020$var$boxSizing);
var $608cf5a5bac56020$var$_default = module.exports.default = $608cf5a5bac56020$var$sizing;

});




parcelRegister("e1wfH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a35a2d48af09cdf6$var$applyStyles;
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/customization/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * With the styled function:
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * With the sx prop:
 * ✅ [{ background: '#e5e5e5' }, theme => theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme => theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={[
 *     { background: '#e5e5e5' },
 *     theme => theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $a35a2d48af09cdf6$var$applyStyles(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars) {
        if (!theme.colorSchemes?.[key] || typeof theme.getColorSchemeSelector !== 'function') return {};
        // If CssVarsProvider is used as a provider, returns '*:where({selector}) &'
        let selector = theme.getColorSchemeSelector(key);
        if (selector === '&') return styles;
        if (selector.includes('data-') || selector.includes('.')) // '*' is required as a workaround for Emotion issue (https://github.com/emotion-js/emotion/issues/2836)
        selector = `*:where(${selector.replace(/\s*&$/, '')}) &`;
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});



parcelRegister("f18iq", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $aeed627b69a58b85$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $aeed627b69a58b85$var$_useThemeWithoutDefault.default;
    }
});

var $aeed627b69a58b85$var$_useThemeWithoutDefault = $aeed627b69a58b85$require$_interopRequireDefault((parcelRequire("7zQRf")));

});
parcelRegister("7zQRf", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $5844cdc266ab80c7$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5844cdc266ab80c7$var$React = $5844cdc266ab80c7$require$_interopRequireWildcard((parcelRequire("acw62")));

var $bOOlK = parcelRequire("bOOlK");
function $5844cdc266ab80c7$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $5844cdc266ab80c7$var$useTheme(defaultTheme = null) {
    const contextTheme = $5844cdc266ab80c7$var$React.useContext($bOOlK.ThemeContext);
    return !contextTheme || $5844cdc266ab80c7$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $5844cdc266ab80c7$var$_default = module.exports.default = $5844cdc266ab80c7$var$useTheme;

});






parcelRegister("9p2mw", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $6d8847f8b6214b1a$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $6d8847f8b6214b1a$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $6d8847f8b6214b1a$var$_display.default;
    }
});

var $6d8847f8b6214b1a$var$_display = $6d8847f8b6214b1a$require$_interopRequireWildcard((parcelRequire("71hhb")));
Object.keys($6d8847f8b6214b1a$var$_display).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($6d8847f8b6214b1a$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $6d8847f8b6214b1a$var$_display[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6d8847f8b6214b1a$var$_display[key];
        }
    });
});

});
parcelRegister("71hhb", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $51c60716a78df046$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.whiteSpace = module.exports.visibility = module.exports.textOverflow = module.exports.overflow = module.exports.displayRaw = module.exports.displayPrint = module.exports.default = void 0;

var $51c60716a78df046$var$_style = $51c60716a78df046$require$_interopRequireDefault((parcelRequire("fuavR")));

var $51c60716a78df046$var$_compose = $51c60716a78df046$require$_interopRequireDefault((parcelRequire("79Mi4")));
const $51c60716a78df046$var$displayPrint = module.exports.displayPrint = (0, $51c60716a78df046$var$_style.default)({
    prop: 'displayPrint',
    cssProperty: false,
    transform: (value)=>({
            '@media print': {
                display: value
            }
        })
});
const $51c60716a78df046$var$displayRaw = module.exports.displayRaw = (0, $51c60716a78df046$var$_style.default)({
    prop: 'display'
});
const $51c60716a78df046$var$overflow = module.exports.overflow = (0, $51c60716a78df046$var$_style.default)({
    prop: 'overflow'
});
const $51c60716a78df046$var$textOverflow = module.exports.textOverflow = (0, $51c60716a78df046$var$_style.default)({
    prop: 'textOverflow'
});
const $51c60716a78df046$var$visibility = module.exports.visibility = (0, $51c60716a78df046$var$_style.default)({
    prop: 'visibility'
});
const $51c60716a78df046$var$whiteSpace = module.exports.whiteSpace = (0, $51c60716a78df046$var$_style.default)({
    prop: 'whiteSpace'
});
var $51c60716a78df046$var$_default = module.exports.default = (0, $51c60716a78df046$var$_compose.default)($51c60716a78df046$var$displayPrint, $51c60716a78df046$var$displayRaw, $51c60716a78df046$var$overflow, $51c60716a78df046$var$textOverflow, $51c60716a78df046$var$visibility, $51c60716a78df046$var$whiteSpace);

});


parcelRegister("fbcSN", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $b0d1e058eea97628$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $b0d1e058eea97628$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $b0d1e058eea97628$var$_flexbox.default;
    }
});

var $b0d1e058eea97628$var$_flexbox = $b0d1e058eea97628$require$_interopRequireWildcard((parcelRequire("44hET")));
Object.keys($b0d1e058eea97628$var$_flexbox).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($b0d1e058eea97628$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $b0d1e058eea97628$var$_flexbox[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b0d1e058eea97628$var$_flexbox[key];
        }
    });
});

});
parcelRegister("44hET", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $2f653bbfbf134bed$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.order = module.exports.justifySelf = module.exports.justifyItems = module.exports.justifyContent = module.exports.flexWrap = module.exports.flexShrink = module.exports.flexGrow = module.exports.flexDirection = module.exports.flexBasis = module.exports.flex = module.exports.default = module.exports.alignSelf = module.exports.alignItems = module.exports.alignContent = void 0;

var $2f653bbfbf134bed$var$_style = $2f653bbfbf134bed$require$_interopRequireDefault((parcelRequire("fuavR")));

var $2f653bbfbf134bed$var$_compose = $2f653bbfbf134bed$require$_interopRequireDefault((parcelRequire("79Mi4")));
const $2f653bbfbf134bed$var$flexBasis = module.exports.flexBasis = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'flexBasis'
});
const $2f653bbfbf134bed$var$flexDirection = module.exports.flexDirection = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'flexDirection'
});
const $2f653bbfbf134bed$var$flexWrap = module.exports.flexWrap = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'flexWrap'
});
const $2f653bbfbf134bed$var$justifyContent = module.exports.justifyContent = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'justifyContent'
});
const $2f653bbfbf134bed$var$alignItems = module.exports.alignItems = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'alignItems'
});
const $2f653bbfbf134bed$var$alignContent = module.exports.alignContent = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'alignContent'
});
const $2f653bbfbf134bed$var$order = module.exports.order = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'order'
});
const $2f653bbfbf134bed$var$flex = module.exports.flex = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'flex'
});
const $2f653bbfbf134bed$var$flexGrow = module.exports.flexGrow = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'flexGrow'
});
const $2f653bbfbf134bed$var$flexShrink = module.exports.flexShrink = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'flexShrink'
});
const $2f653bbfbf134bed$var$alignSelf = module.exports.alignSelf = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'alignSelf'
});
const $2f653bbfbf134bed$var$justifyItems = module.exports.justifyItems = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'justifyItems'
});
const $2f653bbfbf134bed$var$justifySelf = module.exports.justifySelf = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'justifySelf'
});
const $2f653bbfbf134bed$var$flexbox = (0, $2f653bbfbf134bed$var$_compose.default)($2f653bbfbf134bed$var$flexBasis, $2f653bbfbf134bed$var$flexDirection, $2f653bbfbf134bed$var$flexWrap, $2f653bbfbf134bed$var$justifyContent, $2f653bbfbf134bed$var$alignItems, $2f653bbfbf134bed$var$alignContent, $2f653bbfbf134bed$var$order, $2f653bbfbf134bed$var$flex, $2f653bbfbf134bed$var$flexGrow, $2f653bbfbf134bed$var$flexShrink, $2f653bbfbf134bed$var$alignSelf, $2f653bbfbf134bed$var$justifyItems, $2f653bbfbf134bed$var$justifySelf);
var $2f653bbfbf134bed$var$_default = module.exports.default = $2f653bbfbf134bed$var$flexbox;

});


parcelRegister("9cp7R", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $6b28b985c7e8e846$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $6b28b985c7e8e846$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $6b28b985c7e8e846$var$_positions.default;
    }
});

var $6b28b985c7e8e846$var$_positions = $6b28b985c7e8e846$require$_interopRequireWildcard((parcelRequire("ijOcq")));
Object.keys($6b28b985c7e8e846$var$_positions).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($6b28b985c7e8e846$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $6b28b985c7e8e846$var$_positions[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6b28b985c7e8e846$var$_positions[key];
        }
    });
});

});
parcelRegister("ijOcq", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d560f0ea711888c1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.zIndex = module.exports.top = module.exports.right = module.exports.position = module.exports.left = module.exports.default = module.exports.bottom = void 0;

var $d560f0ea711888c1$var$_style = $d560f0ea711888c1$require$_interopRequireDefault((parcelRequire("fuavR")));

var $d560f0ea711888c1$var$_compose = $d560f0ea711888c1$require$_interopRequireDefault((parcelRequire("79Mi4")));
const $d560f0ea711888c1$var$position = module.exports.position = (0, $d560f0ea711888c1$var$_style.default)({
    prop: 'position'
});
const $d560f0ea711888c1$var$zIndex = module.exports.zIndex = (0, $d560f0ea711888c1$var$_style.default)({
    prop: 'zIndex',
    themeKey: 'zIndex'
});
const $d560f0ea711888c1$var$top = module.exports.top = (0, $d560f0ea711888c1$var$_style.default)({
    prop: 'top'
});
const $d560f0ea711888c1$var$right = module.exports.right = (0, $d560f0ea711888c1$var$_style.default)({
    prop: 'right'
});
const $d560f0ea711888c1$var$bottom = module.exports.bottom = (0, $d560f0ea711888c1$var$_style.default)({
    prop: 'bottom'
});
const $d560f0ea711888c1$var$left = module.exports.left = (0, $d560f0ea711888c1$var$_style.default)({
    prop: 'left'
});
var $d560f0ea711888c1$var$_default = module.exports.default = (0, $d560f0ea711888c1$var$_compose.default)($d560f0ea711888c1$var$position, $d560f0ea711888c1$var$zIndex, $d560f0ea711888c1$var$top, $d560f0ea711888c1$var$right, $d560f0ea711888c1$var$bottom, $d560f0ea711888c1$var$left);

});


parcelRegister("euxvJ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a8cddc970265def5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $a8cddc970265def5$var$_shadows.default;
    }
});

var $a8cddc970265def5$var$_shadows = $a8cddc970265def5$require$_interopRequireDefault((parcelRequire("do9dk")));

});
parcelRegister("do9dk", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9bf4a9f1ed138aac$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9bf4a9f1ed138aac$var$_style = $9bf4a9f1ed138aac$require$_interopRequireDefault((parcelRequire("fuavR")));
const $9bf4a9f1ed138aac$var$boxShadow = (0, $9bf4a9f1ed138aac$var$_style.default)({
    prop: 'boxShadow',
    themeKey: 'shadows'
});
var $9bf4a9f1ed138aac$var$_default = module.exports.default = $9bf4a9f1ed138aac$var$boxShadow;

});


parcelRegister("6a6uc", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $47c8b53a4e972b5f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $47c8b53a4e972b5f$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $47c8b53a4e972b5f$var$_typography.default;
    }
});

var $47c8b53a4e972b5f$var$_typography = $47c8b53a4e972b5f$require$_interopRequireWildcard((parcelRequire("e7BDK")));
Object.keys($47c8b53a4e972b5f$var$_typography).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($47c8b53a4e972b5f$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $47c8b53a4e972b5f$var$_typography[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $47c8b53a4e972b5f$var$_typography[key];
        }
    });
});

});
parcelRegister("e7BDK", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a47eeaab0be0bf30$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.typographyVariant = module.exports.textTransform = module.exports.textAlign = module.exports.lineHeight = module.exports.letterSpacing = module.exports.fontWeight = module.exports.fontStyle = module.exports.fontSize = module.exports.fontFamily = module.exports.default = void 0;

var $a47eeaab0be0bf30$var$_style = $a47eeaab0be0bf30$require$_interopRequireDefault((parcelRequire("fuavR")));

var $a47eeaab0be0bf30$var$_compose = $a47eeaab0be0bf30$require$_interopRequireDefault((parcelRequire("79Mi4")));
const $a47eeaab0be0bf30$var$fontFamily = module.exports.fontFamily = (0, $a47eeaab0be0bf30$var$_style.default)({
    prop: 'fontFamily',
    themeKey: 'typography'
});
const $a47eeaab0be0bf30$var$fontSize = module.exports.fontSize = (0, $a47eeaab0be0bf30$var$_style.default)({
    prop: 'fontSize',
    themeKey: 'typography'
});
const $a47eeaab0be0bf30$var$fontStyle = module.exports.fontStyle = (0, $a47eeaab0be0bf30$var$_style.default)({
    prop: 'fontStyle',
    themeKey: 'typography'
});
const $a47eeaab0be0bf30$var$fontWeight = module.exports.fontWeight = (0, $a47eeaab0be0bf30$var$_style.default)({
    prop: 'fontWeight',
    themeKey: 'typography'
});
const $a47eeaab0be0bf30$var$letterSpacing = module.exports.letterSpacing = (0, $a47eeaab0be0bf30$var$_style.default)({
    prop: 'letterSpacing'
});
const $a47eeaab0be0bf30$var$textTransform = module.exports.textTransform = (0, $a47eeaab0be0bf30$var$_style.default)({
    prop: 'textTransform'
});
const $a47eeaab0be0bf30$var$lineHeight = module.exports.lineHeight = (0, $a47eeaab0be0bf30$var$_style.default)({
    prop: 'lineHeight'
});
const $a47eeaab0be0bf30$var$textAlign = module.exports.textAlign = (0, $a47eeaab0be0bf30$var$_style.default)({
    prop: 'textAlign'
});
const $a47eeaab0be0bf30$var$typographyVariant = module.exports.typographyVariant = (0, $a47eeaab0be0bf30$var$_style.default)({
    prop: 'typography',
    cssProperty: false,
    themeKey: 'typography'
});
const $a47eeaab0be0bf30$var$typography = (0, $a47eeaab0be0bf30$var$_compose.default)($a47eeaab0be0bf30$var$typographyVariant, $a47eeaab0be0bf30$var$fontFamily, $a47eeaab0be0bf30$var$fontSize, $a47eeaab0be0bf30$var$fontStyle, $a47eeaab0be0bf30$var$fontWeight, $a47eeaab0be0bf30$var$letterSpacing, $a47eeaab0be0bf30$var$lineHeight, $a47eeaab0be0bf30$var$textAlign, $a47eeaab0be0bf30$var$textTransform);
var $a47eeaab0be0bf30$var$_default = module.exports.default = $a47eeaab0be0bf30$var$typography;

});


parcelRegister("l6FST", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f5daa5e44059b221$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $f5daa5e44059b221$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $f5daa5e44059b221$var$_styleFunctionSx.default;
    }
});
Object.defineProperty(module.exports, "extendSxProp", {
    enumerable: true,
    get: function() {
        return $f5daa5e44059b221$var$_extendSxProp.default;
    }
});
Object.defineProperty(module.exports, "unstable_createStyleFunctionSx", {
    enumerable: true,
    get: function() {
        return $f5daa5e44059b221$var$_styleFunctionSx.unstable_createStyleFunctionSx;
    }
});
Object.defineProperty(module.exports, "unstable_defaultSxConfig", {
    enumerable: true,
    get: function() {
        return $f5daa5e44059b221$var$_defaultSxConfig.default;
    }
});

var $f5daa5e44059b221$var$_styleFunctionSx = $f5daa5e44059b221$require$_interopRequireWildcard((parcelRequire("jUGyl")));

var $f5daa5e44059b221$var$_extendSxProp = $f5daa5e44059b221$require$_interopRequireDefault((parcelRequire("i3YEE")));

var $f5daa5e44059b221$var$_defaultSxConfig = $f5daa5e44059b221$require$_interopRequireDefault((parcelRequire("epNpO")));

});
parcelRegister("i3YEE", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d2678e896d0416ce$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d2678e896d0416ce$var$extendSxProp;

var $bQ4jM = parcelRequire("bQ4jM");

var $d2678e896d0416ce$var$_defaultSxConfig = $d2678e896d0416ce$require$_interopRequireDefault((parcelRequire("epNpO")));
const $d2678e896d0416ce$var$splitProps = (props)=>{
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = props?.theme?.unstable_sxConfig ?? $d2678e896d0416ce$var$_defaultSxConfig.default;
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $d2678e896d0416ce$var$extendSxProp(props) {
    const { sx: inSx, ...other } = props;
    const { systemProps: systemProps, otherProps: otherProps } = $d2678e896d0416ce$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $bQ4jM.isPlainObject)(result)) return systemProps;
        return {
            ...systemProps,
            ...result
        };
    };
    else finalSx = {
        ...systemProps,
        ...inSx
    };
    return {
        ...otherProps,
        sx: finalSx
    };
}

});


parcelRegister("fykTt", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $b52a3d10487329b6$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $b52a3d10487329b6$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $b52a3d10487329b6$var$_getThemeValue.default;
    }
});

var $b52a3d10487329b6$var$_getThemeValue = $b52a3d10487329b6$require$_interopRequireWildcard((parcelRequire("bbSQf")));
Object.keys($b52a3d10487329b6$var$_getThemeValue).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($b52a3d10487329b6$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $b52a3d10487329b6$var$_getThemeValue[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b52a3d10487329b6$var$_getThemeValue[key];
        }
    });
});

});
parcelRegister("bbSQf", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $825b4332527bbf7e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.styleFunctionMapping = module.exports.propToStyleFunction = module.exports.default = void 0;

var $825b4332527bbf7e$var$_borders = $825b4332527bbf7e$require$_interopRequireDefault((parcelRequire("7G2Ky")));

var $825b4332527bbf7e$var$_display = $825b4332527bbf7e$require$_interopRequireDefault((parcelRequire("9p2mw")));

var $825b4332527bbf7e$var$_flexbox = $825b4332527bbf7e$require$_interopRequireDefault((parcelRequire("fbcSN")));

var $825b4332527bbf7e$var$_cssGrid = $825b4332527bbf7e$require$_interopRequireDefault((parcelRequire("bvdLQ")));

var $825b4332527bbf7e$var$_positions = $825b4332527bbf7e$require$_interopRequireDefault((parcelRequire("9cp7R")));

var $825b4332527bbf7e$var$_palette = $825b4332527bbf7e$require$_interopRequireDefault((parcelRequire("7Izgs")));

var $825b4332527bbf7e$var$_shadows = $825b4332527bbf7e$require$_interopRequireDefault((parcelRequire("euxvJ")));

var $825b4332527bbf7e$var$_sizing = $825b4332527bbf7e$require$_interopRequireDefault((parcelRequire("lk86k")));

var $825b4332527bbf7e$var$_spacing = $825b4332527bbf7e$require$_interopRequireDefault((parcelRequire("8ZgMs")));

var $825b4332527bbf7e$var$_typography = $825b4332527bbf7e$require$_interopRequireDefault((parcelRequire("6a6uc")));
const $825b4332527bbf7e$var$filterPropsMapping = {
    borders: $825b4332527bbf7e$var$_borders.default.filterProps,
    display: $825b4332527bbf7e$var$_display.default.filterProps,
    flexbox: $825b4332527bbf7e$var$_flexbox.default.filterProps,
    grid: $825b4332527bbf7e$var$_cssGrid.default.filterProps,
    positions: $825b4332527bbf7e$var$_positions.default.filterProps,
    palette: $825b4332527bbf7e$var$_palette.default.filterProps,
    shadows: $825b4332527bbf7e$var$_shadows.default.filterProps,
    sizing: $825b4332527bbf7e$var$_sizing.default.filterProps,
    spacing: $825b4332527bbf7e$var$_spacing.default.filterProps,
    typography: $825b4332527bbf7e$var$_typography.default.filterProps
};
const $825b4332527bbf7e$var$styleFunctionMapping = module.exports.styleFunctionMapping = {
    borders: $825b4332527bbf7e$var$_borders.default,
    display: $825b4332527bbf7e$var$_display.default,
    flexbox: $825b4332527bbf7e$var$_flexbox.default,
    grid: $825b4332527bbf7e$var$_cssGrid.default,
    positions: $825b4332527bbf7e$var$_positions.default,
    palette: $825b4332527bbf7e$var$_palette.default,
    shadows: $825b4332527bbf7e$var$_shadows.default,
    sizing: $825b4332527bbf7e$var$_sizing.default,
    spacing: $825b4332527bbf7e$var$_spacing.default,
    typography: $825b4332527bbf7e$var$_typography.default
};
const $825b4332527bbf7e$var$propToStyleFunction = module.exports.propToStyleFunction = Object.keys($825b4332527bbf7e$var$filterPropsMapping).reduce((acc, styleFnName)=>{
    $825b4332527bbf7e$var$filterPropsMapping[styleFnName].forEach((propName)=>{
        acc[propName] = $825b4332527bbf7e$var$styleFunctionMapping[styleFnName];
    });
    return acc;
}, {});
function $825b4332527bbf7e$var$getThemeValue(prop, value, theme) {
    const inputProps = {
        [prop]: value,
        theme: theme
    };
    const styleFunction = $825b4332527bbf7e$var$propToStyleFunction[prop];
    return styleFunction ? styleFunction(inputProps) : {
        [prop]: value
    };
}
var $825b4332527bbf7e$var$_default = module.exports.default = $825b4332527bbf7e$var$getThemeValue;

});


parcelRegister("8XfTG", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $68502a45a27be93d$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $68502a45a27be93d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $68502a45a27be93d$var$_exportNames = {
    boxClasses: true
};
Object.defineProperty(module.exports, "boxClasses", {
    enumerable: true,
    get: function() {
        return $68502a45a27be93d$var$_boxClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $68502a45a27be93d$var$_Box.default;
    }
});

var $68502a45a27be93d$var$_Box = $68502a45a27be93d$require$_interopRequireDefault((parcelRequire("767bZ")));

var $68502a45a27be93d$var$_boxClasses = $68502a45a27be93d$require$_interopRequireWildcard((parcelRequire("7b5dP")));
Object.keys($68502a45a27be93d$var$_boxClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($68502a45a27be93d$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $68502a45a27be93d$var$_boxClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $68502a45a27be93d$var$_boxClasses[key];
        }
    });
});

});
parcelRegister("767bZ", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $52aeac2e4081d4b0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $52aeac2e4081d4b0$var$_propTypes = $52aeac2e4081d4b0$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $52aeac2e4081d4b0$var$_ClassNameGenerator = $52aeac2e4081d4b0$require$_interopRequireDefault((parcelRequire("aYaRV")));

var $52aeac2e4081d4b0$var$_createBox = $52aeac2e4081d4b0$require$_interopRequireDefault((parcelRequire("7SBe1")));

var $52aeac2e4081d4b0$var$_boxClasses = $52aeac2e4081d4b0$require$_interopRequireDefault((parcelRequire("7b5dP")));
const $52aeac2e4081d4b0$var$Box = (0, $52aeac2e4081d4b0$var$_createBox.default)({
    defaultClassName: $52aeac2e4081d4b0$var$_boxClasses.default.root,
    generateClassName: $52aeac2e4081d4b0$var$_ClassNameGenerator.default.generate
});
$52aeac2e4081d4b0$var$Box.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * @ignore
   */ children: $52aeac2e4081d4b0$var$_propTypes.default.node,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $52aeac2e4081d4b0$var$_propTypes.default.elementType,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $52aeac2e4081d4b0$var$_propTypes.default.oneOfType([
        $52aeac2e4081d4b0$var$_propTypes.default.arrayOf($52aeac2e4081d4b0$var$_propTypes.default.oneOfType([
            $52aeac2e4081d4b0$var$_propTypes.default.func,
            $52aeac2e4081d4b0$var$_propTypes.default.object,
            $52aeac2e4081d4b0$var$_propTypes.default.bool
        ])),
        $52aeac2e4081d4b0$var$_propTypes.default.func,
        $52aeac2e4081d4b0$var$_propTypes.default.object
    ])
};
var $52aeac2e4081d4b0$var$_default = module.exports.default = $52aeac2e4081d4b0$var$Box;

});
parcelRegister("aYaRV", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $7fc7f047a82393ea$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $7fc7f047a82393ea$var$_ClassNameGenerator.default;
    }
});

var $7fc7f047a82393ea$var$_ClassNameGenerator = $7fc7f047a82393ea$require$_interopRequireDefault((parcelRequire("jyJSW")));

});
parcelRegister("jyJSW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $e3d4c91c63801eeb$var$defaultGenerator = (componentName)=>componentName;
const $e3d4c91c63801eeb$var$createClassNameGenerator = ()=>{
    let generate = $e3d4c91c63801eeb$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $e3d4c91c63801eeb$var$defaultGenerator;
        }
    };
};
const $e3d4c91c63801eeb$var$ClassNameGenerator = $e3d4c91c63801eeb$var$createClassNameGenerator();
var $e3d4c91c63801eeb$var$_default = module.exports.default = $e3d4c91c63801eeb$var$ClassNameGenerator;

});


parcelRegister("7SBe1", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5bca73b38b7b68b2$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $5bca73b38b7b68b2$var$_createBox.default;
    }
});

var $5bca73b38b7b68b2$var$_createBox = $5bca73b38b7b68b2$require$_interopRequireDefault((parcelRequire("310Oe")));

});
parcelRegister("310Oe", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $232217c4f59982d0$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $232217c4f59982d0$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $232217c4f59982d0$var$createBox;

var $232217c4f59982d0$var$React = $232217c4f59982d0$require$_interopRequireWildcard((parcelRequire("acw62")));

var $232217c4f59982d0$var$_clsx = $232217c4f59982d0$require$_interopRequireDefault((parcelRequire("9QePP")));

var $232217c4f59982d0$var$_styledEngine = $232217c4f59982d0$require$_interopRequireDefault((parcelRequire("bOOlK")));

var $232217c4f59982d0$var$_styleFunctionSx = $232217c4f59982d0$require$_interopRequireWildcard((parcelRequire("l6FST")));

var $232217c4f59982d0$var$_useTheme = $232217c4f59982d0$require$_interopRequireDefault((parcelRequire("lywMB")));

var $ayMG0 = parcelRequire("ayMG0");
function $232217c4f59982d0$var$createBox(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = 'MuiBox-root', generateClassName: generateClassName } = options;
    const BoxRoot = (0, $232217c4f59982d0$var$_styledEngine.default)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })($232217c4f59982d0$var$_styleFunctionSx.default);
    const Box = /*#__PURE__*/ $232217c4f59982d0$var$React.forwardRef(function Box(inProps, ref) {
        const theme = (0, $232217c4f59982d0$var$_useTheme.default)(defaultTheme);
        const { className: className, component: component = 'div', ...other } = (0, $232217c4f59982d0$var$_styleFunctionSx.extendSxProp)(inProps);
        return /*#__PURE__*/ (0, $ayMG0.jsx)(BoxRoot, {
            as: component,
            ref: ref,
            className: (0, $232217c4f59982d0$var$_clsx.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme,
            ...other
        });
    });
    return Box;
}

});


parcelRegister("7b5dP", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $539d9c7f6e95ee22$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $539d9c7f6e95ee22$var$_generateUtilityClasses = $539d9c7f6e95ee22$require$_interopRequireDefault((parcelRequire("5nY49")));
const $539d9c7f6e95ee22$var$boxClasses = (0, $539d9c7f6e95ee22$var$_generateUtilityClasses.default)('MuiBox', [
    'root'
]);
var $539d9c7f6e95ee22$var$_default = module.exports.default = $539d9c7f6e95ee22$var$boxClasses;

});
parcelRegister("5nY49", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3ebdb19980d19cf7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $3ebdb19980d19cf7$var$_generateUtilityClasses.default;
    }
});

var $3ebdb19980d19cf7$var$_generateUtilityClasses = $3ebdb19980d19cf7$require$_interopRequireDefault((parcelRequire("6q0pz")));

});
parcelRegister("6q0pz", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $4ac57d7e2ab16278$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4ac57d7e2ab16278$var$generateUtilityClasses;

var $4ac57d7e2ab16278$var$_generateUtilityClass = $4ac57d7e2ab16278$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $4ac57d7e2ab16278$var$generateUtilityClasses(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $4ac57d7e2ab16278$var$_generateUtilityClass.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("b14cZ", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $80530d69cb5af7b9$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $80530d69cb5af7b9$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $80530d69cb5af7b9$var$_generateUtilityClass.default;
    }
});

var $80530d69cb5af7b9$var$_generateUtilityClass = $80530d69cb5af7b9$require$_interopRequireWildcard((parcelRequire("8nnml")));
Object.keys($80530d69cb5af7b9$var$_generateUtilityClass).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($80530d69cb5af7b9$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $80530d69cb5af7b9$var$_generateUtilityClass[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $80530d69cb5af7b9$var$_generateUtilityClass[key];
        }
    });
});

});
parcelRegister("8nnml", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $61929767e33fc474$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $61929767e33fc474$var$generateUtilityClass;
module.exports.globalStateClasses = void 0;
module.exports.isGlobalState = $61929767e33fc474$var$isGlobalState;

var $61929767e33fc474$var$_ClassNameGenerator = $61929767e33fc474$require$_interopRequireDefault((parcelRequire("aYaRV")));
const $61929767e33fc474$var$globalStateClasses = module.exports.globalStateClasses = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $61929767e33fc474$var$generateUtilityClass(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $61929767e33fc474$var$globalStateClasses[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${$61929767e33fc474$var$_ClassNameGenerator.default.generate(componentName)}-${slot}`;
}
function $61929767e33fc474$var$isGlobalState(slot) {
    return $61929767e33fc474$var$globalStateClasses[slot] !== undefined;
}

});







parcelRegister("bbeCr", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $823c0fd313341cc1$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $823c0fd313341cc1$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $823c0fd313341cc1$var$_createStyled.default;
    }
});

var $823c0fd313341cc1$var$_createStyled = $823c0fd313341cc1$require$_interopRequireWildcard((parcelRequire("b8EC5")));
Object.keys($823c0fd313341cc1$var$_createStyled).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($823c0fd313341cc1$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $823c0fd313341cc1$var$_createStyled[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $823c0fd313341cc1$var$_createStyled[key];
        }
    });
});

});
parcelRegister("b8EC5", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $81bff209823fdfab$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $81bff209823fdfab$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $81bff209823fdfab$var$createStyled;
module.exports.shouldForwardProp = $81bff209823fdfab$var$shouldForwardProp;
module.exports.systemDefaultTheme = void 0;

var $81bff209823fdfab$var$_styledEngine = $81bff209823fdfab$require$_interopRequireWildcard((parcelRequire("bOOlK")));

var $bQ4jM = parcelRequire("bQ4jM");

var $81bff209823fdfab$var$_capitalize = $81bff209823fdfab$require$_interopRequireDefault((parcelRequire("4O6za")));

var $81bff209823fdfab$var$_getDisplayName = $81bff209823fdfab$require$_interopRequireDefault((parcelRequire("3cLs1")));

var $81bff209823fdfab$var$_createTheme = $81bff209823fdfab$require$_interopRequireDefault((parcelRequire("1dhnG")));

var $81bff209823fdfab$var$_styleFunctionSx = $81bff209823fdfab$require$_interopRequireDefault((parcelRequire("l6FST")));

var $81bff209823fdfab$var$_preprocessStyles = $81bff209823fdfab$require$_interopRequireDefault((parcelRequire("4bg7U")));
/* eslint-disable no-underscore-dangle */ /* eslint-disable no-labels */ /* eslint-disable no-lone-blocks */ const $81bff209823fdfab$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $81bff209823fdfab$var$_createTheme.default)();
// Update /system/styled/#api in case if this changes
function $81bff209823fdfab$var$shouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $81bff209823fdfab$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
function $81bff209823fdfab$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (_props, styles)=>styles[slot];
}
function $81bff209823fdfab$var$attachTheme(props, themeId, defaultTheme) {
    props.theme = $81bff209823fdfab$var$isObjectEmpty(props.theme) ? defaultTheme : props.theme[themeId] || props.theme;
}
function $81bff209823fdfab$var$processStyle(props, style, layerName) {
    /*
   * Style types:
   *  - null/undefined
   *  - string
   *  - CSS style object: { [cssKey]: [cssValue], variants }
   *  - Processed style object: { style, variants, isProcessed: true }
   *  - Array of any of the above
   */ const resolvedStyle = typeof style === 'function' ? style(props) : style;
    if (Array.isArray(resolvedStyle)) return resolvedStyle.flatMap((subStyle)=>$81bff209823fdfab$var$processStyle(props, subStyle, layerName));
    if (Array.isArray(resolvedStyle?.variants)) {
        let rootStyle;
        if (resolvedStyle.isProcessed) rootStyle = layerName ? $81bff209823fdfab$var$shallowLayer(resolvedStyle.style, layerName) : resolvedStyle.style;
        else {
            const { variants: variants, ...otherStyles } = resolvedStyle;
            rootStyle = layerName ? $81bff209823fdfab$var$shallowLayer((0, $81bff209823fdfab$var$_styledEngine.internal_serializeStyles)(otherStyles), layerName) : otherStyles;
        }
        return $81bff209823fdfab$var$processStyleVariants(props, resolvedStyle.variants, [
            rootStyle
        ], layerName);
    }
    if (resolvedStyle?.isProcessed) return layerName ? $81bff209823fdfab$var$shallowLayer((0, $81bff209823fdfab$var$_styledEngine.internal_serializeStyles)(resolvedStyle.style), layerName) : resolvedStyle.style;
    return layerName ? $81bff209823fdfab$var$shallowLayer((0, $81bff209823fdfab$var$_styledEngine.internal_serializeStyles)(resolvedStyle), layerName) : resolvedStyle;
}
function $81bff209823fdfab$var$processStyleVariants(props, variants, results = [], layerName) {
    let mergedState; // We might not need it, initialized lazily
    variantLoop: for(let i = 0; i < variants.length; i += 1){
        const variant = variants[i];
        if (typeof variant.props === 'function') {
            mergedState ?? (mergedState = {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            });
            if (!variant.props(mergedState)) continue;
        } else for(const key in variant.props){
            if (props[key] !== variant.props[key] && props.ownerState?.[key] !== variant.props[key]) continue variantLoop;
        }
        if (typeof variant.style === 'function') {
            mergedState ?? (mergedState = {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            });
            results.push(layerName ? $81bff209823fdfab$var$shallowLayer((0, $81bff209823fdfab$var$_styledEngine.internal_serializeStyles)(variant.style(mergedState)), layerName) : variant.style(mergedState));
        } else results.push(layerName ? $81bff209823fdfab$var$shallowLayer((0, $81bff209823fdfab$var$_styledEngine.internal_serializeStyles)(variant.style), layerName) : variant.style);
    }
    return results;
}
function $81bff209823fdfab$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $81bff209823fdfab$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $81bff209823fdfab$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $81bff209823fdfab$var$shouldForwardProp } = input;
    function styleAttachTheme(props) {
        $81bff209823fdfab$var$attachTheme(props, themeId, defaultTheme);
    }
    const styled = (tag, inputOptions = {})=>{
        // If `tag` is already a styled component, filter out the `sx` style function
        // to prevent unnecessary styles generated by the composite components.
        (0, $81bff209823fdfab$var$_styledEngine.internal_mutateStyles)(tag, (styles)=>styles.filter((style)=>style !== $81bff209823fdfab$var$_styleFunctionSx.default));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $81bff209823fdfab$var$defaultOverridesResolver($81bff209823fdfab$var$lowercaseFirstLetter(componentSlot)), ...options } = inputOptions;
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let shouldForwardPropOption = $81bff209823fdfab$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($81bff209823fdfab$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $81bff209823fdfab$var$_styledEngine.default)(tag, {
            shouldForwardProp: shouldForwardPropOption,
            label: $81bff209823fdfab$var$generateStyledLabel(componentName, componentSlot),
            ...options
        });
        const transformStyle = (style)=>{
            // - On the server Emotion doesn't use React.forwardRef for creating components, so the created
            //   component stays as a function. This condition makes sure that we do not interpolate functions
            //   which are basically components used as a selectors.
            // - `style` could be a styled component from a babel plugin for component selectors, This condition
            //   makes sure that we do not interpolate them.
            if (style.__emotion_real === style) return style;
            if (typeof style === 'function') return function styleFunctionProcessor(props) {
                return $81bff209823fdfab$var$processStyle(props, style, props.theme.modularCssLayers ? layerName : undefined);
            };
            if ((0, $bQ4jM.isPlainObject)(style)) {
                const serialized = (0, $81bff209823fdfab$var$_preprocessStyles.default)(style);
                return function styleObjectProcessor(props) {
                    if (!serialized.variants) return props.theme.modularCssLayers ? $81bff209823fdfab$var$shallowLayer(serialized.style, layerName) : serialized.style;
                    return $81bff209823fdfab$var$processStyle(props, serialized, props.theme.modularCssLayers ? layerName : undefined);
                };
            }
            return style;
        };
        const muiStyledResolver = (...expressionsInput)=>{
            const expressionsHead = [];
            const expressionsBody = expressionsInput.map(transformStyle);
            const expressionsTail = [];
            // Preprocess `props` to set the scoped theme value.
            // This must run before any other expression.
            expressionsHead.push(styleAttachTheme);
            if (componentName && overridesResolver) expressionsTail.push(function styleThemeOverrides(props) {
                const theme = props.theme;
                const styleOverrides = theme.components?.[componentName]?.styleOverrides;
                if (!styleOverrides) return null;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                // eslint-disable-next-line guard-for-in
                for(const slotKey in styleOverrides)resolvedStyleOverrides[slotKey] = $81bff209823fdfab$var$processStyle(props, styleOverrides[slotKey], props.theme.modularCssLayers ? 'theme' : undefined);
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsTail.push(function styleThemeVariants(props) {
                const theme = props.theme;
                const themeVariants = theme?.components?.[componentName]?.variants;
                if (!themeVariants) return null;
                return $81bff209823fdfab$var$processStyleVariants(props, themeVariants, [], props.theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsTail.push($81bff209823fdfab$var$_styleFunctionSx.default);
            // This function can be called as a tagged template, so the first argument would contain
            // CSS `string[]` values.
            if (Array.isArray(expressionsBody[0])) {
                const inputStrings = expressionsBody.shift();
                // We need to add placeholders in the tagged template for the custom functions we have
                // possibly added (attachTheme, overrides, variants, and sx).
                const placeholdersHead = new Array(expressionsHead.length).fill('');
                const placeholdersTail = new Array(expressionsTail.length).fill('');
                let outputStrings;
                outputStrings = [
                    ...placeholdersHead,
                    ...inputStrings,
                    ...placeholdersTail
                ];
                outputStrings.raw = [
                    ...placeholdersHead,
                    ...inputStrings.raw,
                    ...placeholdersTail
                ];
                // The only case where we put something before `attachTheme`
                expressionsHead.unshift(outputStrings);
            }
            const expressions = [
                ...expressionsHead,
                ...expressionsBody,
                ...expressionsTail
            ];
            const Component = defaultStyledResolver(...expressions);
            if (tag.muiName) Component.muiName = tag.muiName;
            Component.displayName = $81bff209823fdfab$var$generateDisplayName(componentName, componentSlot, tag);
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
    return styled;
}
function $81bff209823fdfab$var$generateDisplayName(componentName, componentSlot, tag) {
    if (componentName) return `${componentName}${(0, $81bff209823fdfab$var$_capitalize.default)(componentSlot || '')}`;
    return `Styled(${(0, $81bff209823fdfab$var$_getDisplayName.default)(tag)})`;
}
function $81bff209823fdfab$var$generateStyledLabel(componentName, componentSlot) {
    let label;
    if (componentName) // TODO v6: remove `lowercaseFirstLetter()` in the next major release
    // For more details: https://github.com/mui/material-ui/pull/37908
    label = `${componentName}-${$81bff209823fdfab$var$lowercaseFirstLetter(componentSlot || 'Root')}`;
    return label;
}
function $81bff209823fdfab$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $81bff209823fdfab$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $81bff209823fdfab$var$lowercaseFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
}

});
parcelRegister("3cLs1", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $25574cdde2068c11$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $25574cdde2068c11$var$_getDisplayName.default;
    }
});

var $25574cdde2068c11$var$_getDisplayName = $25574cdde2068c11$require$_interopRequireDefault((parcelRequire("98zty")));

});
parcelRegister("98zty", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6a706129b6f614d1$var$getDisplayName;

var $4jPKB = parcelRequire("4jPKB");
function $6a706129b6f614d1$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || fallback;
}
function $6a706129b6f614d1$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $6a706129b6f614d1$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
/**
 * cherry-pick from
 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
 * originally forked from recompose/getDisplayName
 */ function $6a706129b6f614d1$var$getDisplayName(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $6a706129b6f614d1$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case $4jPKB.ForwardRef:
            return $6a706129b6f614d1$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case $4jPKB.Memo:
            return $6a706129b6f614d1$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

});


parcelRegister("4bg7U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $30b4b2e6e89e9da3$var$preprocessStyles;

var $bOOlK = parcelRequire("bOOlK");
function $30b4b2e6e89e9da3$var$preprocessStyles(input) {
    const { variants: variants, ...style } = input;
    const result = {
        variants: variants,
        style: (0, $bOOlK.internal_serializeStyles)(style),
        isProcessed: true
    };
    // Not supported on styled-components
    if (result.style === style) return result;
    if (variants) variants.forEach((variant)=>{
        if (typeof variant.style !== 'function') variant.style = (0, $bOOlK.internal_serializeStyles)(variant.style);
    });
    return result;
}

});



parcelRegister("kpukb", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $edbdaa418a42b560$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $edbdaa418a42b560$var$_styled.default;
    }
});

var $edbdaa418a42b560$var$_styled = $edbdaa418a42b560$require$_interopRequireDefault((parcelRequire("haNZP")));

});
parcelRegister("haNZP", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c80a270d52203b73$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c80a270d52203b73$var$_createStyled = $c80a270d52203b73$require$_interopRequireDefault((parcelRequire("bbeCr")));
const $c80a270d52203b73$var$styled = (0, $c80a270d52203b73$var$_createStyled.default)();
var $c80a270d52203b73$var$_default = module.exports.default = $c80a270d52203b73$var$styled;

});


parcelRegister("2LgDM", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $202ce10b3dfaac20$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $202ce10b3dfaac20$var$_useThemeProps.default;
    }
});
Object.defineProperty(module.exports, "getThemeProps", {
    enumerable: true,
    get: function() {
        return $202ce10b3dfaac20$var$_getThemeProps.default;
    }
});

var $202ce10b3dfaac20$var$_useThemeProps = $202ce10b3dfaac20$require$_interopRequireDefault((parcelRequire("lfKzS")));

var $202ce10b3dfaac20$var$_getThemeProps = $202ce10b3dfaac20$require$_interopRequireDefault((parcelRequire("6wACh")));

});
parcelRegister("lfKzS", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $f78f2110a61a7e24$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f78f2110a61a7e24$var$useThemeProps;

var $f78f2110a61a7e24$var$_getThemeProps = $f78f2110a61a7e24$require$_interopRequireDefault((parcelRequire("6wACh")));

var $f78f2110a61a7e24$var$_useTheme = $f78f2110a61a7e24$require$_interopRequireDefault((parcelRequire("lywMB")));
function $f78f2110a61a7e24$var$useThemeProps({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $f78f2110a61a7e24$var$_useTheme.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    return (0, $f78f2110a61a7e24$var$_getThemeProps.default)({
        theme: theme,
        name: name,
        props: props
    });
}

});
parcelRegister("6wACh", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $4c022282094d7502$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4c022282094d7502$var$getThemeProps;

var $4c022282094d7502$var$_resolveProps = $4c022282094d7502$require$_interopRequireDefault((parcelRequire("7T9kw")));
function $4c022282094d7502$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $4c022282094d7502$var$_resolveProps.default)(theme.components[name].defaultProps, props);
}

});
parcelRegister("7T9kw", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5be4e83746700573$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $5be4e83746700573$var$_resolveProps.default;
    }
});

var $5be4e83746700573$var$_resolveProps = $5be4e83746700573$require$_interopRequireDefault((parcelRequire("jgIf5")));

});
parcelRegister("jgIf5", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e071d488489a190f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e071d488489a190f$var$resolveProps;

var $e071d488489a190f$var$_clsx = $e071d488489a190f$require$_interopRequireDefault((parcelRequire("9QePP")));
/**
 * Add keys, values of `defaultProps` that does not exist in `props`
 * @param defaultProps
 * @param props
 * @param mergeClassNameAndStyle If `true`, merges `className` and `style` props instead of overriding them.
 *   When `false` (default), props override defaultProps. When `true`, `className` values are concatenated
 *   and `style` objects are merged with props taking precedence.
 * @returns resolved props
 */ function $e071d488489a190f$var$resolveProps(defaultProps, props, mergeClassNameAndStyle = false) {
    const output = {
        ...props
    };
    for(const key in defaultProps)if (Object.prototype.hasOwnProperty.call(defaultProps, key)) {
        const propName = key;
        if (propName === 'components' || propName === 'slots') output[propName] = {
            ...defaultProps[propName],
            ...output[propName]
        };
        else if (propName === 'componentsProps' || propName === 'slotProps') {
            const defaultSlotProps = defaultProps[propName];
            const slotProps = props[propName];
            if (!slotProps) output[propName] = defaultSlotProps || {};
            else if (!defaultSlotProps) output[propName] = slotProps;
            else {
                output[propName] = {
                    ...slotProps
                };
                for(const slotKey in defaultSlotProps)if (Object.prototype.hasOwnProperty.call(defaultSlotProps, slotKey)) {
                    const slotPropName = slotKey;
                    output[propName][slotPropName] = $e071d488489a190f$var$resolveProps(defaultSlotProps[slotPropName], slotProps[slotPropName], mergeClassNameAndStyle);
                }
            }
        } else if (propName === 'className' && mergeClassNameAndStyle && props.className) output.className = (0, $e071d488489a190f$var$_clsx.default)(defaultProps?.className, props?.className);
        else if (propName === 'style' && mergeClassNameAndStyle && props.style) output.style = {
            ...defaultProps?.style,
            ...props?.style
        };
        else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    }
    return output;
}

});





parcelRegister("8h4LK", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $60639c4e52e8e25a$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $60639c4e52e8e25a$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $60639c4e52e8e25a$var$_useMediaQuery.default;
    }
});

var $60639c4e52e8e25a$var$_useMediaQuery = $60639c4e52e8e25a$require$_interopRequireWildcard((parcelRequire("78KYM")));
Object.keys($60639c4e52e8e25a$var$_useMediaQuery).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($60639c4e52e8e25a$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $60639c4e52e8e25a$var$_useMediaQuery[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $60639c4e52e8e25a$var$_useMediaQuery[key];
        }
    });
});

});
parcelRegister("78KYM", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $532db8df695edb5e$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $532db8df695edb5e$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.unstable_createUseMediaQuery = $532db8df695edb5e$var$unstable_createUseMediaQuery;

var $532db8df695edb5e$var$React = $532db8df695edb5e$require$_interopRequireWildcard((parcelRequire("acw62")));

var $532db8df695edb5e$var$_useEnhancedEffect = $532db8df695edb5e$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $2LgDM = parcelRequire("2LgDM");

var $532db8df695edb5e$var$_useThemeWithoutDefault = $532db8df695edb5e$require$_interopRequireDefault((parcelRequire("f18iq")));
// TODO React 17: Remove `useMediaQueryOld` once React 17 support is removed
function $532db8df695edb5e$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $532db8df695edb5e$var$React.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $532db8df695edb5e$var$_useEnhancedEffect.default)(()=>{
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            setMatch(queryList.matches);
        };
        updateMatch();
        queryList.addEventListener('change', updateMatch);
        return ()=>{
            queryList.removeEventListener('change', updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $532db8df695edb5e$var$safeReact = {
    ...$532db8df695edb5e$var$React
};
const $532db8df695edb5e$var$maybeReactUseSyncExternalStore = $532db8df695edb5e$var$safeReact.useSyncExternalStore;
function $532db8df695edb5e$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $532db8df695edb5e$var$React.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $532db8df695edb5e$var$React.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $532db8df695edb5e$var$React.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                mediaQueryList.addEventListener('change', notify);
                return ()=>{
                    mediaQueryList.removeEventListener('change', notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $532db8df695edb5e$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
// eslint-disable-next-line @typescript-eslint/naming-convention
function $532db8df695edb5e$var$unstable_createUseMediaQuery(params = {}) {
    const { themeId: themeId } = params;
    return function useMediaQuery(queryInput, options = {}) {
        let theme = (0, $532db8df695edb5e$var$_useThemeWithoutDefault.default)();
        if (theme && themeId) theme = theme[themeId] || theme;
        // Wait for jsdom to support the match media feature.
        // All the browsers MUI support have this built-in.
        // This defensive check is here for simplicity.
        // Most of the time, the match media logic isn't central to people tests.
        const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
        const { defaultMatches: defaultMatches = false, matchMedia: matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $2LgDM.getThemeProps)({
            name: 'MuiUseMediaQuery',
            props: options,
            theme: theme
        });
        if (typeof queryInput === 'function' && theme === null) console.error([
            'MUI: The `query` argument provided is invalid.',
            'You are providing a function without a theme in the context.',
            'One of the parent elements needs to use a ThemeProvider.'
        ].join('\n'));
        let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
        query = query.replace(/^@media( ?)/m, '');
        if (query.includes('print')) console.warn([
            `MUI: You have provided a \`print\` query to the \`useMediaQuery\` hook.`,
            'Using the print media query to modify print styles can lead to unexpected results.',
            'Consider using the `displayPrint` field in the `sx` prop instead.',
            'More information about `displayPrint` on our docs: https://mui.com/system/display/#display-in-print.'
        ].join('\n'));
        const useMediaQueryImplementation = $532db8df695edb5e$var$maybeReactUseSyncExternalStore !== undefined ? $532db8df695edb5e$var$useMediaQueryNew : $532db8df695edb5e$var$useMediaQueryOld;
        const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $532db8df695edb5e$var$React.useDebugValue({
            query: query,
            match: match
        });
        return match;
    };
}
const $532db8df695edb5e$var$useMediaQuery = $532db8df695edb5e$var$unstable_createUseMediaQuery();
var $532db8df695edb5e$var$_default = module.exports.default = $532db8df695edb5e$var$useMediaQuery;

});


parcelRegister("h61zw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $i0NBZ = parcelRequire("i0NBZ");
Object.keys($i0NBZ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $i0NBZ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $i0NBZ[key];
        }
    });
});

});
parcelRegister("i0NBZ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d1ceb5f718f3f33e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alpha = $d1ceb5f718f3f33e$var$alpha;
module.exports.blend = $d1ceb5f718f3f33e$var$blend;
module.exports.colorChannel = void 0;
module.exports.darken = $d1ceb5f718f3f33e$var$darken;
module.exports.decomposeColor = $d1ceb5f718f3f33e$var$decomposeColor;
module.exports.emphasize = $d1ceb5f718f3f33e$var$emphasize;
module.exports.getContrastRatio = $d1ceb5f718f3f33e$var$getContrastRatio;
module.exports.getLuminance = $d1ceb5f718f3f33e$var$getLuminance;
module.exports.hexToRgb = $d1ceb5f718f3f33e$var$hexToRgb;
module.exports.hslToRgb = $d1ceb5f718f3f33e$var$hslToRgb;
module.exports.lighten = $d1ceb5f718f3f33e$var$lighten;
module.exports.private_safeAlpha = $d1ceb5f718f3f33e$var$private_safeAlpha;
module.exports.private_safeColorChannel = void 0;
module.exports.private_safeDarken = $d1ceb5f718f3f33e$var$private_safeDarken;
module.exports.private_safeEmphasize = $d1ceb5f718f3f33e$var$private_safeEmphasize;
module.exports.private_safeLighten = $d1ceb5f718f3f33e$var$private_safeLighten;
module.exports.recomposeColor = $d1ceb5f718f3f33e$var$recomposeColor;
module.exports.rgbToHex = $d1ceb5f718f3f33e$var$rgbToHex;

var $d1ceb5f718f3f33e$var$_formatMuiErrorMessage = $d1ceb5f718f3f33e$require$_interopRequireDefault((parcelRequire("4Z6Nd")));

var $d1ceb5f718f3f33e$var$_clamp = $d1ceb5f718f3f33e$require$_interopRequireDefault((parcelRequire("3zA0b")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $d1ceb5f718f3f33e$var$clampWrapper(value, min = 0, max = 1) {
    if (value < min || value > max) console.error(`MUI: The value provided ${value} is out of range [${min}, ${max}].`);
    return (0, $d1ceb5f718f3f33e$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $d1ceb5f718f3f33e$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    if (color.length !== color.trim().length) console.error(`MUI: The color: "${color}" is invalid. Make sure the color input doesn't contain leading/trailing space.`);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $d1ceb5f718f3f33e$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $d1ceb5f718f3f33e$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $d1ceb5f718f3f33e$var$decomposeColor($d1ceb5f718f3f33e$var$hexToRgb(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if (![
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].includes(type)) throw new Error(`MUI: Unsupported \`${color}\` color.\n` + 'The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().');
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if (![
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].includes(colorSpace)) throw new Error(`MUI: unsupported \`${colorSpace}\` color space.\n` + 'The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.');
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $d1ceb5f718f3f33e$var$colorChannel = (color)=>{
    const decomposedColor = $d1ceb5f718f3f33e$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.includes('hsl') && idx !== 0 ? `${val}%` : val).join(' ');
};
module.exports.colorChannel = $d1ceb5f718f3f33e$var$colorChannel;
const $d1ceb5f718f3f33e$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $d1ceb5f718f3f33e$var$colorChannel(color);
    } catch (error) {
        if (warning && true) console.warn(warning);
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ module.exports.private_safeColorChannel = $d1ceb5f718f3f33e$var$private_safeColorChannel;
function $d1ceb5f718f3f33e$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.includes('rgb')) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.includes('hsl')) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.includes('color')) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $d1ceb5f718f3f33e$var$rgbToHex(color) {
    // Idempotent
    if (color.startsWith('#')) return color;
    const { values: values } = $d1ceb5f718f3f33e$var$decomposeColor(color);
    return `#${values.map((n, i)=>$d1ceb5f718f3f33e$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $d1ceb5f718f3f33e$var$hslToRgb(color) {
    color = $d1ceb5f718f3f33e$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $d1ceb5f718f3f33e$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $d1ceb5f718f3f33e$var$getLuminance(color) {
    color = $d1ceb5f718f3f33e$var$decomposeColor(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $d1ceb5f718f3f33e$var$decomposeColor($d1ceb5f718f3f33e$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $d1ceb5f718f3f33e$var$getContrastRatio(foreground, background) {
    const lumA = $d1ceb5f718f3f33e$var$getLuminance(foreground);
    const lumB = $d1ceb5f718f3f33e$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $d1ceb5f718f3f33e$var$alpha(color, value) {
    color = $d1ceb5f718f3f33e$var$decomposeColor(color);
    value = $d1ceb5f718f3f33e$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $d1ceb5f718f3f33e$var$recomposeColor(color);
}
function $d1ceb5f718f3f33e$var$private_safeAlpha(color, value, warning) {
    try {
        return $d1ceb5f718f3f33e$var$alpha(color, value);
    } catch (error) {
        if (warning && true) console.warn(warning);
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $d1ceb5f718f3f33e$var$darken(color, coefficient) {
    color = $d1ceb5f718f3f33e$var$decomposeColor(color);
    coefficient = $d1ceb5f718f3f33e$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] *= 1 - coefficient;
    else if (color.type.includes('rgb') || color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $d1ceb5f718f3f33e$var$recomposeColor(color);
}
function $d1ceb5f718f3f33e$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $d1ceb5f718f3f33e$var$darken(color, coefficient);
    } catch (error) {
        if (warning && true) console.warn(warning);
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $d1ceb5f718f3f33e$var$lighten(color, coefficient) {
    color = $d1ceb5f718f3f33e$var$decomposeColor(color);
    coefficient = $d1ceb5f718f3f33e$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.includes('rgb')) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $d1ceb5f718f3f33e$var$recomposeColor(color);
}
function $d1ceb5f718f3f33e$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $d1ceb5f718f3f33e$var$lighten(color, coefficient);
    } catch (error) {
        if (warning && true) console.warn(warning);
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $d1ceb5f718f3f33e$var$emphasize(color, coefficient = 0.15) {
    return $d1ceb5f718f3f33e$var$getLuminance(color) > 0.5 ? $d1ceb5f718f3f33e$var$darken(color, coefficient) : $d1ceb5f718f3f33e$var$lighten(color, coefficient);
}
function $d1ceb5f718f3f33e$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $d1ceb5f718f3f33e$var$emphasize(color, coefficient);
    } catch (error) {
        if (warning && true) console.warn(warning);
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $d1ceb5f718f3f33e$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $d1ceb5f718f3f33e$var$decomposeColor(background);
    const overlayColor = $d1ceb5f718f3f33e$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $d1ceb5f718f3f33e$var$recomposeColor({
        type: 'rgb',
        values: rgb
    });
}

});
parcelRegister("3zA0b", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $29a0913aac547ce8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $29a0913aac547ce8$var$_clamp.default;
    }
});

var $29a0913aac547ce8$var$_clamp = $29a0913aac547ce8$require$_interopRequireDefault((parcelRequire("4CRKF")));

});
parcelRegister("4CRKF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $35e4680625b68240$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $35e4680625b68240$var$_default = module.exports.default = $35e4680625b68240$var$clamp;

});




parcelRegister("ixP4k", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d802ec3fa7ccc11e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $d802ec3fa7ccc11e$var$_ThemeProvider.default;
    }
});

var $d802ec3fa7ccc11e$var$_ThemeProvider = $d802ec3fa7ccc11e$require$_interopRequireDefault((parcelRequire("411Qv")));

});
parcelRegister("411Qv", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $2ec8aff4a7c0cf18$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $2ec8aff4a7c0cf18$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ec8aff4a7c0cf18$var$React = $2ec8aff4a7c0cf18$require$_interopRequireWildcard((parcelRequire("acw62")));

var $2ec8aff4a7c0cf18$var$_propTypes = $2ec8aff4a7c0cf18$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $3YuG2 = parcelRequire("3YuG2");

var $2ec8aff4a7c0cf18$var$_exactProp = $2ec8aff4a7c0cf18$require$_interopRequireDefault((parcelRequire("5S3aN")));

var $bOOlK = parcelRequire("bOOlK");

var $2ec8aff4a7c0cf18$var$_useThemeWithoutDefault = $2ec8aff4a7c0cf18$require$_interopRequireDefault((parcelRequire("f18iq")));

var $2ec8aff4a7c0cf18$var$_RtlProvider = $2ec8aff4a7c0cf18$require$_interopRequireDefault((parcelRequire("9uEev")));

var $2ec8aff4a7c0cf18$var$_DefaultPropsProvider = $2ec8aff4a7c0cf18$require$_interopRequireDefault((parcelRequire("buuO7")));

var $2ec8aff4a7c0cf18$var$_useLayerOrder = $2ec8aff4a7c0cf18$require$_interopRequireDefault((parcelRequire("66f2w")));

var $ayMG0 = parcelRequire("ayMG0");
const $2ec8aff4a7c0cf18$var$EMPTY_THEME = {};
function $2ec8aff4a7c0cf18$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $2ec8aff4a7c0cf18$var$React.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? {
                ...upperTheme,
                [themeId]: mergedTheme
            } : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? {
            ...upperTheme,
            [themeId]: localTheme
        } : {
            ...upperTheme,
            ...localTheme
        };
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $2ec8aff4a7c0cf18$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $2ec8aff4a7c0cf18$var$_useThemeWithoutDefault.default)($2ec8aff4a7c0cf18$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $3YuG2.useTheme)() || $2ec8aff4a7c0cf18$var$EMPTY_THEME;
    if (upperTheme === null && typeof localTheme === 'function' || themeId && upperTheme && !upperTheme[themeId] && typeof localTheme === 'function') console.error([
        'MUI: You are providing a theme function prop to the ThemeProvider component:',
        '<ThemeProvider theme={outerTheme => outerTheme} />',
        '',
        'However, no outer theme is present.',
        "Make sure a theme is already injected higher in the React tree or provide a theme object."
    ].join('\n'));
    const engineTheme = $2ec8aff4a7c0cf18$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $2ec8aff4a7c0cf18$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = (themeId ? engineTheme[themeId] : engineTheme).direction === 'rtl';
    const layerOrder = (0, $2ec8aff4a7c0cf18$var$_useLayerOrder.default)(engineTheme);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3YuG2.ThemeProvider, {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($bOOlK.ThemeContext.Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($2ec8aff4a7c0cf18$var$_RtlProvider.default, {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)($2ec8aff4a7c0cf18$var$_DefaultPropsProvider.default, {
                    value: themeId ? engineTheme[themeId].components : engineTheme.components,
                    children: [
                        layerOrder,
                        children
                    ]
                })
            })
        })
    });
}
$2ec8aff4a7c0cf18$var$ThemeProvider.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Your component tree.
   */ children: $2ec8aff4a7c0cf18$var$_propTypes.default.node,
    /**
   * A theme object. You can provide a function to extend the outer theme.
   */ theme: $2ec8aff4a7c0cf18$var$_propTypes.default.oneOfType([
        $2ec8aff4a7c0cf18$var$_propTypes.default.func,
        $2ec8aff4a7c0cf18$var$_propTypes.default.object
    ]).isRequired,
    /**
   * The design system's unique id for getting the corresponded theme when there are multiple design systems.
   */ themeId: $2ec8aff4a7c0cf18$var$_propTypes.default.string
};
$2ec8aff4a7c0cf18$var$ThemeProvider.propTypes = (0, $2ec8aff4a7c0cf18$var$_exactProp.default)($2ec8aff4a7c0cf18$var$ThemeProvider.propTypes);
var $2ec8aff4a7c0cf18$var$_default = module.exports.default = $2ec8aff4a7c0cf18$var$ThemeProvider;

});
parcelRegister("3YuG2", function(module, exports) {
/**
 * @mui/private-theming v7.3.11
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $2e4ec584c6273f12$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $2e4ec584c6273f12$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $2e4ec584c6273f12$var$_exportNames = {
    ThemeProvider: true,
    useTheme: true
};
Object.defineProperty(module.exports, "ThemeProvider", {
    enumerable: true,
    get: function() {
        return $2e4ec584c6273f12$var$_ThemeProvider.default;
    }
});
Object.defineProperty(module.exports, "useTheme", {
    enumerable: true,
    get: function() {
        return $2e4ec584c6273f12$var$_useTheme.default;
    }
});

var $2e4ec584c6273f12$var$_ThemeProvider = $2e4ec584c6273f12$require$_interopRequireWildcard((parcelRequire("bAAZQ")));
Object.keys($2e4ec584c6273f12$var$_ThemeProvider).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2e4ec584c6273f12$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $2e4ec584c6273f12$var$_ThemeProvider[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2e4ec584c6273f12$var$_ThemeProvider[key];
        }
    });
});

var $2e4ec584c6273f12$var$_useTheme = $2e4ec584c6273f12$require$_interopRequireDefault((parcelRequire("l03D8")));

});
parcelRegister("bAAZQ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $86ffc1375996ef3d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $86ffc1375996ef3d$var$_ThemeProvider.default;
    }
});
Object.defineProperty(module.exports, "unstable_nested", {
    enumerable: true,
    get: function() {
        return $86ffc1375996ef3d$var$_nested.default;
    }
});

var $86ffc1375996ef3d$var$_ThemeProvider = $86ffc1375996ef3d$require$_interopRequireDefault((parcelRequire("lYrbz")));

var $86ffc1375996ef3d$var$_nested = $86ffc1375996ef3d$require$_interopRequireDefault((parcelRequire("2NPLA")));

});
parcelRegister("lYrbz", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $fff44a152eb20ab0$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $fff44a152eb20ab0$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fff44a152eb20ab0$var$React = $fff44a152eb20ab0$require$_interopRequireWildcard((parcelRequire("acw62")));

var $fff44a152eb20ab0$var$_propTypes = $fff44a152eb20ab0$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $fff44a152eb20ab0$var$_exactProp = $fff44a152eb20ab0$require$_interopRequireDefault((parcelRequire("5S3aN")));

var $fff44a152eb20ab0$var$_ThemeContext = $fff44a152eb20ab0$require$_interopRequireDefault((parcelRequire("fHPaR")));

var $fff44a152eb20ab0$var$_useTheme = $fff44a152eb20ab0$require$_interopRequireDefault((parcelRequire("l03D8")));

var $fff44a152eb20ab0$var$_nested = $fff44a152eb20ab0$require$_interopRequireDefault((parcelRequire("2NPLA")));

var $ayMG0 = parcelRequire("ayMG0");
// To support composition of theme.
function $fff44a152eb20ab0$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        if (!mergedTheme) console.error([
            'MUI: You should return an object from your theme function, i.e.',
            '<ThemeProvider theme={() => ({})} />'
        ].join('\n'));
        return mergedTheme;
    }
    return {
        ...outerTheme,
        ...localTheme
    };
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $fff44a152eb20ab0$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $fff44a152eb20ab0$var$_useTheme.default)();
    if (outerTheme === null && typeof localTheme === 'function') console.error([
        'MUI: You are providing a theme function prop to the ThemeProvider component:',
        '<ThemeProvider theme={outerTheme => outerTheme} />',
        '',
        'However, no outer theme is present.',
        "Make sure a theme is already injected higher in the React tree or provide a theme object."
    ].join('\n'));
    const theme = $fff44a152eb20ab0$var$React.useMemo(()=>{
        const output = outerTheme === null ? {
            ...localTheme
        } : $fff44a152eb20ab0$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[$fff44a152eb20ab0$var$_nested.default] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($fff44a152eb20ab0$var$_ThemeContext.default.Provider, {
        value: theme,
        children: children
    });
}
$fff44a152eb20ab0$var$ThemeProvider.propTypes = {
    /**
   * Your component tree.
   */ children: $fff44a152eb20ab0$var$_propTypes.default.node,
    /**
   * A theme object. You can provide a function to extend the outer theme.
   */ theme: $fff44a152eb20ab0$var$_propTypes.default.oneOfType([
        $fff44a152eb20ab0$var$_propTypes.default.object,
        $fff44a152eb20ab0$var$_propTypes.default.func
    ]).isRequired
};
$fff44a152eb20ab0$var$ThemeProvider.propTypes = (0, $fff44a152eb20ab0$var$_exactProp.default)($fff44a152eb20ab0$var$ThemeProvider.propTypes);
var $fff44a152eb20ab0$var$_default = module.exports.default = $fff44a152eb20ab0$var$ThemeProvider;

});
parcelRegister("5S3aN", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $446475069c751d22$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $446475069c751d22$var$_exactProp.default;
    }
});

var $446475069c751d22$var$_exactProp = $446475069c751d22$require$_interopRequireDefault((parcelRequire("9RGCL")));

});
parcelRegister("9RGCL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $72ea20960eca48cd$var$exactProp;
// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
const $72ea20960eca48cd$var$specialProperty = 'exact-prop: \u200b';
function $72ea20960eca48cd$var$exactProp(propTypes) {
    return {
        ...propTypes,
        [$72ea20960eca48cd$var$specialProperty]: (props)=>{
            const unsupportedProps = Object.keys(props).filter((prop)=>!propTypes.hasOwnProperty(prop));
            if (unsupportedProps.length > 0) return new Error(`The following props are not supported: ${unsupportedProps.map((prop)=>`\`${prop}\``).join(', ')}. Please remove them.`);
            return null;
        }
    };
}

});


parcelRegister("fHPaR", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $b6f2914bcc222460$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b6f2914bcc222460$var$React = $b6f2914bcc222460$require$_interopRequireWildcard((parcelRequire("acw62")));
const $b6f2914bcc222460$var$ThemeContext = /*#__PURE__*/ $b6f2914bcc222460$var$React.createContext(null);
$b6f2914bcc222460$var$ThemeContext.displayName = 'ThemeContext';
var $b6f2914bcc222460$var$_default = module.exports.default = $b6f2914bcc222460$var$ThemeContext;

});

parcelRegister("l03D8", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f49c69f16b6a34af$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $f49c69f16b6a34af$var$_useTheme.default;
    }
});

var $f49c69f16b6a34af$var$_useTheme = $f49c69f16b6a34af$require$_interopRequireDefault((parcelRequire("lT1cX")));

});
parcelRegister("lT1cX", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $feefabedf550ce3f$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $feefabedf550ce3f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $feefabedf550ce3f$var$useTheme;

var $feefabedf550ce3f$var$React = $feefabedf550ce3f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $feefabedf550ce3f$var$_ThemeContext = $feefabedf550ce3f$require$_interopRequireDefault((parcelRequire("fHPaR")));
function $feefabedf550ce3f$var$useTheme() {
    const theme = $feefabedf550ce3f$var$React.useContext($feefabedf550ce3f$var$_ThemeContext.default);
    // TODO: uncomment once we enable eslint-plugin-react-compiler eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks -- It's not required to run React.useDebugValue in production
    $feefabedf550ce3f$var$React.useDebugValue(theme);
    return theme;
}

});


parcelRegister("2NPLA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $20a8501e6e2f4912$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $20a8501e6e2f4912$var$_default = module.exports.default = $20a8501e6e2f4912$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

});




parcelRegister("9uEev", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $6e961fcfc1c15c66$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $6e961fcfc1c15c66$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useRtl = module.exports.default = void 0;

var $6e961fcfc1c15c66$var$React = $6e961fcfc1c15c66$require$_interopRequireWildcard((parcelRequire("acw62")));

var $6e961fcfc1c15c66$var$_propTypes = $6e961fcfc1c15c66$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $ayMG0 = parcelRequire("ayMG0");
const $6e961fcfc1c15c66$var$RtlContext = /*#__PURE__*/ $6e961fcfc1c15c66$var$React.createContext();
function $6e961fcfc1c15c66$var$RtlProvider({ value: value, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6e961fcfc1c15c66$var$RtlContext.Provider, {
        value: value ?? true,
        ...props
    });
}
$6e961fcfc1c15c66$var$RtlProvider.propTypes = {
    children: $6e961fcfc1c15c66$var$_propTypes.default.node,
    value: $6e961fcfc1c15c66$var$_propTypes.default.bool
};
const $6e961fcfc1c15c66$var$useRtl = ()=>{
    const value = $6e961fcfc1c15c66$var$React.useContext($6e961fcfc1c15c66$var$RtlContext);
    return value ?? false;
};
module.exports.useRtl = $6e961fcfc1c15c66$var$useRtl;
var $6e961fcfc1c15c66$var$_default = module.exports.default = $6e961fcfc1c15c66$var$RtlProvider;

});

parcelRegister("buuO7", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $85da64c4cc661dcb$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $85da64c4cc661dcb$var$_DefaultPropsProvider.default;
    }
});
Object.defineProperty(module.exports, "useDefaultProps", {
    enumerable: true,
    get: function() {
        return $85da64c4cc661dcb$var$_DefaultPropsProvider.useDefaultProps;
    }
});

var $85da64c4cc661dcb$var$_DefaultPropsProvider = $85da64c4cc661dcb$require$_interopRequireWildcard((parcelRequire("k3xKF")));

});
parcelRegister("k3xKF", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $e99e44d394b0848b$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $e99e44d394b0848b$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.useDefaultProps = $e99e44d394b0848b$var$useDefaultProps;

var $e99e44d394b0848b$var$React = $e99e44d394b0848b$require$_interopRequireWildcard((parcelRequire("acw62")));

var $e99e44d394b0848b$var$_propTypes = $e99e44d394b0848b$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $e99e44d394b0848b$var$_resolveProps = $e99e44d394b0848b$require$_interopRequireDefault((parcelRequire("7T9kw")));

var $ayMG0 = parcelRequire("ayMG0");
const $e99e44d394b0848b$var$PropsContext = /*#__PURE__*/ $e99e44d394b0848b$var$React.createContext(undefined);
function $e99e44d394b0848b$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($e99e44d394b0848b$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
$e99e44d394b0848b$var$DefaultPropsProvider.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * @ignore
   */ children: $e99e44d394b0848b$var$_propTypes.default.node,
    /**
   * @ignore
   */ value: $e99e44d394b0848b$var$_propTypes.default.object
};
function $e99e44d394b0848b$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $e99e44d394b0848b$var$_resolveProps.default)(config.defaultProps, props, theme.components.mergeClassNameAndStyle);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $e99e44d394b0848b$var$_resolveProps.default)(config, props, theme.components.mergeClassNameAndStyle);
    return props;
}
function $e99e44d394b0848b$var$useDefaultProps({ props: props, name: name }) {
    const ctx = $e99e44d394b0848b$var$React.useContext($e99e44d394b0848b$var$PropsContext);
    return $e99e44d394b0848b$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $e99e44d394b0848b$var$_default = module.exports.default = $e99e44d394b0848b$var$DefaultPropsProvider;

});


parcelRegister("66f2w", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $470ef830d3f406b4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $470ef830d3f406b4$var$useLayerOrder;

var $470ef830d3f406b4$var$_useEnhancedEffect = $470ef830d3f406b4$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $470ef830d3f406b4$var$_useId = $470ef830d3f406b4$require$_interopRequireDefault((parcelRequire("hwliF")));

var $470ef830d3f406b4$var$_GlobalStyles = $470ef830d3f406b4$require$_interopRequireDefault((parcelRequire("fJztl")));

var $470ef830d3f406b4$var$_useThemeWithoutDefault = $470ef830d3f406b4$require$_interopRequireDefault((parcelRequire("f18iq")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * This hook returns a `GlobalStyles` component that sets the CSS layer order (for server-side rendering).
 * Then on client-side, it injects the CSS layer order into the document head to ensure that the layer order is always present first before other Emotion styles.
 */ function $470ef830d3f406b4$var$useLayerOrder(theme) {
    const upperTheme = (0, $470ef830d3f406b4$var$_useThemeWithoutDefault.default)();
    const id = (0, $470ef830d3f406b4$var$_useId.default)() || '';
    const { modularCssLayers: modularCssLayers } = theme;
    let layerOrder = 'mui.global, mui.components, mui.theme, mui.custom, mui.sx';
    if (!modularCssLayers || upperTheme !== null) // skip this hook if upper theme exists.
    layerOrder = '';
    else if (typeof modularCssLayers === 'string') layerOrder = modularCssLayers.replace(/mui(?!\.)/g, layerOrder);
    else layerOrder = `@layer ${layerOrder};`;
    (0, $470ef830d3f406b4$var$_useEnhancedEffect.default)(()=>{
        const head = document.querySelector('head');
        if (!head) return;
        const firstChild = head.firstChild;
        if (layerOrder) {
            // Only insert if first child doesn't have data-mui-layer-order attribute
            if (firstChild && firstChild.hasAttribute?.('data-mui-layer-order') && firstChild.getAttribute('data-mui-layer-order') === id) return;
            const styleElement = document.createElement('style');
            styleElement.setAttribute('data-mui-layer-order', id);
            styleElement.textContent = layerOrder;
            head.prepend(styleElement);
        } else head.querySelector(`style[data-mui-layer-order="${id}"]`)?.remove();
    }, [
        layerOrder,
        id
    ]);
    if (!layerOrder) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($470ef830d3f406b4$var$_GlobalStyles.default, {
        styles: layerOrder
    });
}

});
parcelRegister("hwliF", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $cc15f294b94b87be$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $cc15f294b94b87be$var$_useId.default;
    }
});

var $cc15f294b94b87be$var$_useId = $cc15f294b94b87be$require$_interopRequireDefault((parcelRequire("4NWyA")));

});
parcelRegister("4NWyA", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $37f92932f8526401$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $37f92932f8526401$var$useId;

var $37f92932f8526401$var$React = $37f92932f8526401$require$_interopRequireWildcard((parcelRequire("acw62")));
let $37f92932f8526401$var$globalId = 0;
// TODO React 17: Remove `useGlobalId` once React 17 support is removed
function $37f92932f8526401$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $37f92932f8526401$var$React.useState(idOverride);
    const id = idOverride || defaultId;
    $37f92932f8526401$var$React.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $37f92932f8526401$var$globalId += 1;
            setDefaultId(`mui-${$37f92932f8526401$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $37f92932f8526401$var$safeReact = {
    ...$37f92932f8526401$var$React
};
const $37f92932f8526401$var$maybeReactUseId = $37f92932f8526401$var$safeReact.useId;
/**
 *
 * @example <div id={useId()} />
 * @param idOverride
 * @returns {string}
 */ function $37f92932f8526401$var$useId(idOverride) {
    // React.useId() is only available from React 17.0.0.
    if ($37f92932f8526401$var$maybeReactUseId !== undefined) {
        const reactId = $37f92932f8526401$var$maybeReactUseId();
        return idOverride ?? reactId;
    }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $37f92932f8526401$var$useGlobalId(idOverride);
}

});





parcelRegister("5Ts1H", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $44a7d4485060e536$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $44a7d4485060e536$var$unstable_memoTheme;

var $44a7d4485060e536$var$_preprocessStyles = $44a7d4485060e536$require$_interopRequireDefault((parcelRequire("4bg7U")));
/* eslint-disable @typescript-eslint/naming-convention */ // We need to pass an argument as `{ theme }` for PigmentCSS, but we don't want to
// allocate more objects.
const $44a7d4485060e536$var$arg = {
    theme: undefined
};
/**
 * Memoize style function on theme.
 * Intended to be used in styled() calls that only need access to the theme.
 */ function $44a7d4485060e536$var$unstable_memoTheme(styleFn) {
    let lastValue;
    let lastTheme;
    return function styleMemoized(props) {
        let value = lastValue;
        if (value === undefined || props.theme !== lastTheme) {
            $44a7d4485060e536$var$arg.theme = props.theme;
            value = (0, $44a7d4485060e536$var$_preprocessStyles.default)(styleFn($44a7d4485060e536$var$arg));
            lastValue = value;
            lastTheme = props.theme;
        }
        return value;
    };
}

});

parcelRegister("3Vfwq", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $2db2bc563e7e5e69$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $2db2bc563e7e5e69$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DISABLE_CSS_TRANSITION = void 0;
module.exports.default = $2db2bc563e7e5e69$var$createCssVarsProvider;

var $2db2bc563e7e5e69$var$React = $2db2bc563e7e5e69$require$_interopRequireWildcard((parcelRequire("acw62")));

var $2db2bc563e7e5e69$var$_propTypes = $2db2bc563e7e5e69$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $bOOlK = parcelRequire("bOOlK");

var $3YuG2 = parcelRequire("3YuG2");

var $2db2bc563e7e5e69$var$_useEnhancedEffect = $2db2bc563e7e5e69$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $2db2bc563e7e5e69$var$_ThemeProvider = $2db2bc563e7e5e69$require$_interopRequireDefault((parcelRequire("ixP4k")));

var $2db2bc563e7e5e69$var$_InitColorSchemeScript = $2db2bc563e7e5e69$require$_interopRequireWildcard((parcelRequire("79OI6")));

var $2db2bc563e7e5e69$var$_useCurrentColorScheme = $2db2bc563e7e5e69$require$_interopRequireDefault((parcelRequire("srPro")));

var $ayMG0 = parcelRequire("ayMG0");
const $2db2bc563e7e5e69$var$DISABLE_CSS_TRANSITION = module.exports.DISABLE_CSS_TRANSITION = '*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}';
function $2db2bc563e7e5e69$var$createCssVarsProvider(options) {
    const { themeId: themeId, /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */ theme: defaultTheme = {}, modeStorageKey: defaultModeStorageKey = $2db2bc563e7e5e69$var$_InitColorSchemeScript.DEFAULT_MODE_STORAGE_KEY, colorSchemeStorageKey: defaultColorSchemeStorageKey = $2db2bc563e7e5e69$var$_InitColorSchemeScript.DEFAULT_COLOR_SCHEME_STORAGE_KEY, disableTransitionOnChange: designSystemTransitionOnChange = false, defaultColorScheme: defaultColorScheme, resolveTheme: resolveTheme } = options;
    const defaultContext = {
        allColorSchemes: [],
        colorScheme: undefined,
        darkColorScheme: undefined,
        lightColorScheme: undefined,
        mode: undefined,
        setColorScheme: ()=>{},
        setMode: ()=>{},
        systemMode: undefined
    };
    const ColorSchemeContext = /*#__PURE__*/ $2db2bc563e7e5e69$var$React.createContext(undefined);
    ColorSchemeContext.displayName = 'ColorSchemeContext';
    const useColorScheme = ()=>$2db2bc563e7e5e69$var$React.useContext(ColorSchemeContext) || defaultContext;
    const defaultColorSchemes = {};
    const defaultComponents = {};
    function CssVarsProvider(props) {
        const { children: children, theme: themeProp, modeStorageKey: modeStorageKey = defaultModeStorageKey, colorSchemeStorageKey: colorSchemeStorageKey = defaultColorSchemeStorageKey, disableTransitionOnChange: disableTransitionOnChange = designSystemTransitionOnChange, storageManager: storageManager, storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, documentNode: documentNode = typeof document === 'undefined' ? undefined : document, colorSchemeNode: colorSchemeNode = typeof document === 'undefined' ? undefined : document.documentElement, disableNestedContext: disableNestedContext = false, disableStyleSheetGeneration: disableStyleSheetGeneration = false, defaultMode: initialMode = 'system', forceThemeRerender: forceThemeRerender = false, noSsr: noSsr } = props;
        const hasMounted = $2db2bc563e7e5e69$var$React.useRef(false);
        const upperTheme = (0, $3YuG2.useTheme)();
        const ctx = $2db2bc563e7e5e69$var$React.useContext(ColorSchemeContext);
        const nested = !!ctx && !disableNestedContext;
        const initialTheme = $2db2bc563e7e5e69$var$React.useMemo(()=>{
            if (themeProp) return themeProp;
            return typeof defaultTheme === 'function' ? defaultTheme() : defaultTheme;
        }, [
            themeProp
        ]);
        const scopedTheme = initialTheme[themeId];
        const restThemeProp = scopedTheme || initialTheme;
        const { colorSchemes: colorSchemes = defaultColorSchemes, components: components = defaultComponents, cssVarPrefix: cssVarPrefix } = restThemeProp;
        const joinedColorSchemes = Object.keys(colorSchemes).filter((k)=>!!colorSchemes[k]).join(',');
        const allColorSchemes = $2db2bc563e7e5e69$var$React.useMemo(()=>joinedColorSchemes.split(','), [
            joinedColorSchemes
        ]);
        const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
        const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
        const defaultMode = colorSchemes[defaultLightColorScheme] && colorSchemes[defaultDarkColorScheme] ? initialMode : colorSchemes[restThemeProp.defaultColorScheme]?.palette?.mode || restThemeProp.palette?.mode;
        // 1. Get the data about the `mode`, `colorScheme`, and setter functions.
        const { mode: stateMode, setMode: setMode, systemMode: systemMode, lightColorScheme: lightColorScheme, darkColorScheme: darkColorScheme, colorScheme: stateColorScheme, setColorScheme: setColorScheme } = (0, $2db2bc563e7e5e69$var$_useCurrentColorScheme.default)({
            supportedColorSchemes: allColorSchemes,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: modeStorageKey,
            colorSchemeStorageKey: colorSchemeStorageKey,
            defaultMode: defaultMode,
            storageManager: storageManager,
            storageWindow: storageWindow,
            noSsr: noSsr
        });
        let mode = stateMode;
        let colorScheme = stateColorScheme;
        if (nested) {
            mode = ctx.mode;
            colorScheme = ctx.colorScheme;
        }
        if (forceThemeRerender && !restThemeProp.vars) console.warn([
            'MUI: The `forceThemeRerender` prop should only be used with CSS theme variables.',
            'Note that it will slow down the app when changing between modes, so only do this when you cannot find a better solution.'
        ].join('\n'));
        // `colorScheme` is undefined on the server and hydration phase
        let calculatedColorScheme = colorScheme || restThemeProp.defaultColorScheme;
        if (restThemeProp.vars && !forceThemeRerender) calculatedColorScheme = restThemeProp.defaultColorScheme;
        const memoTheme = $2db2bc563e7e5e69$var$React.useMemo(()=>{
            // 2. get the `vars` object that refers to the CSS custom properties
            const themeVars = restThemeProp.generateThemeVars?.() || restThemeProp.vars;
            // 3. Start composing the theme object
            const theme = {
                ...restThemeProp,
                components: components,
                colorSchemes: colorSchemes,
                cssVarPrefix: cssVarPrefix,
                vars: themeVars
            };
            if (typeof theme.generateSpacing === 'function') theme.spacing = theme.generateSpacing();
            // 4. Resolve the color scheme and merge it to the theme
            if (calculatedColorScheme) {
                const scheme = colorSchemes[calculatedColorScheme];
                if (scheme && typeof scheme === 'object') // 4.1 Merge the selected color scheme to the theme
                Object.keys(scheme).forEach((schemeKey)=>{
                    if (scheme[schemeKey] && typeof scheme[schemeKey] === 'object') // shallow merge the 1st level structure of the theme.
                    theme[schemeKey] = {
                        ...theme[schemeKey],
                        ...scheme[schemeKey]
                    };
                    else theme[schemeKey] = scheme[schemeKey];
                });
            }
            return resolveTheme ? resolveTheme(theme) : theme;
        }, [
            restThemeProp,
            calculatedColorScheme,
            components,
            colorSchemes,
            cssVarPrefix
        ]);
        // 5. Declaring effects
        // 5.1 Updates the selector value to use the current color scheme which tells CSS to use the proper stylesheet.
        const colorSchemeSelector = restThemeProp.colorSchemeSelector;
        (0, $2db2bc563e7e5e69$var$_useEnhancedEffect.default)(()=>{
            if (colorScheme && colorSchemeNode && colorSchemeSelector && colorSchemeSelector !== 'media') {
                const selector = colorSchemeSelector;
                let rule = colorSchemeSelector;
                if (selector === 'class') rule = `.%s`;
                if (selector === 'data') rule = `[data-%s]`;
                if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
                rule = `[${selector}="%s"]`;
                if (rule.startsWith('.')) {
                    colorSchemeNode.classList.remove(...allColorSchemes.map((scheme)=>rule.substring(1).replace('%s', scheme)));
                    colorSchemeNode.classList.add(rule.substring(1).replace('%s', colorScheme));
                } else {
                    const matches = rule.replace('%s', colorScheme).match(/\[([^\]]+)\]/);
                    if (matches) {
                        const [attr, value] = matches[1].split('=');
                        if (!value) // for attributes like `data-theme-dark`, `data-theme-light`
                        // remove all the existing data attributes before setting the new one
                        allColorSchemes.forEach((scheme)=>{
                            colorSchemeNode.removeAttribute(attr.replace(colorScheme, scheme));
                        });
                        colorSchemeNode.setAttribute(attr, value ? value.replace(/"|'/g, '') : '');
                    } else colorSchemeNode.setAttribute(rule, colorScheme);
                }
            }
        }, [
            colorScheme,
            colorSchemeSelector,
            colorSchemeNode,
            allColorSchemes
        ]);
        // 5.2 Remove the CSS transition when color scheme changes to create instant experience.
        // credit: https://github.com/pacocoursey/next-themes/blob/b5c2bad50de2d61ad7b52a9c5cdc801a78507d7a/index.tsx#L313
        $2db2bc563e7e5e69$var$React.useEffect(()=>{
            let timer;
            if (disableTransitionOnChange && hasMounted.current && documentNode) {
                const css = documentNode.createElement('style');
                css.appendChild(documentNode.createTextNode($2db2bc563e7e5e69$var$DISABLE_CSS_TRANSITION));
                documentNode.head.appendChild(css);
                // Force browser repaint
                (()=>window.getComputedStyle(documentNode.body))();
                timer = setTimeout(()=>{
                    documentNode.head.removeChild(css);
                }, 1);
            }
            return ()=>{
                clearTimeout(timer);
            };
        }, [
            colorScheme,
            disableTransitionOnChange,
            documentNode
        ]);
        $2db2bc563e7e5e69$var$React.useEffect(()=>{
            hasMounted.current = true;
            return ()=>{
                hasMounted.current = false;
            };
        }, []);
        const contextValue = $2db2bc563e7e5e69$var$React.useMemo(()=>({
                allColorSchemes: allColorSchemes,
                colorScheme: colorScheme,
                darkColorScheme: darkColorScheme,
                lightColorScheme: lightColorScheme,
                mode: mode,
                setColorScheme: setColorScheme,
                setMode: (newMode)=>{
                    if (memoTheme.colorSchemeSelector === 'media') // #host-reference
                    console.error([
                        'MUI: The `setMode` function has no effect if `colorSchemeSelector` is `media` (`media` is the default value).',
                        'To toggle the mode manually, please configure `colorSchemeSelector` to use a class or data attribute.',
                        'To learn more, visit https://v7.mui.com/material-ui/customization/css-theme-variables/configuration/#toggling-dark-mode-manually'
                    ].join('\n'));
                    setMode(newMode);
                },
                systemMode: systemMode
            }), [
            allColorSchemes,
            colorScheme,
            darkColorScheme,
            lightColorScheme,
            mode,
            setColorScheme,
            setMode,
            systemMode,
            memoTheme.colorSchemeSelector
        ]);
        let shouldGenerateStyleSheet = true;
        if (disableStyleSheetGeneration || restThemeProp.cssVariables === false || nested && upperTheme?.cssVarPrefix === cssVarPrefix) shouldGenerateStyleSheet = false;
        const element = /*#__PURE__*/ (0, $ayMG0.jsxs)($2db2bc563e7e5e69$var$React.Fragment, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($2db2bc563e7e5e69$var$_ThemeProvider.default, {
                    themeId: scopedTheme ? themeId : undefined,
                    theme: memoTheme,
                    children: children
                }),
                shouldGenerateStyleSheet && /*#__PURE__*/ (0, $ayMG0.jsx)($bOOlK.GlobalStyles, {
                    styles: memoTheme.generateStyleSheets?.() || []
                })
            ]
        });
        if (nested) return element;
        return /*#__PURE__*/ (0, $ayMG0.jsx)(ColorSchemeContext.Provider, {
            value: contextValue,
            children: element
        });
    }
    CssVarsProvider.propTypes = {
        /**
     * The component tree.
     */ children: $2db2bc563e7e5e69$var$_propTypes.default.node,
        /**
     * The node used to attach the color-scheme attribute
     */ colorSchemeNode: $2db2bc563e7e5e69$var$_propTypes.default.any,
        /**
     * localStorage key used to store `colorScheme`
     */ colorSchemeStorageKey: $2db2bc563e7e5e69$var$_propTypes.default.string,
        /**
     * The default mode when the storage is empty,
     * require the theme to have `colorSchemes` with light and dark.
     */ defaultMode: $2db2bc563e7e5e69$var$_propTypes.default.string,
        /**
     * If `true`, the provider creates its own context and generate stylesheet as if it is a root `CssVarsProvider`.
     */ disableNestedContext: $2db2bc563e7e5e69$var$_propTypes.default.bool,
        /**
     * If `true`, the style sheet won't be generated.
     *
     * This is useful for controlling nested CssVarsProvider behavior.
     */ disableStyleSheetGeneration: $2db2bc563e7e5e69$var$_propTypes.default.bool,
        /**
     * Disable CSS transitions when switching between modes or color schemes.
     */ disableTransitionOnChange: $2db2bc563e7e5e69$var$_propTypes.default.bool,
        /**
     * The document to attach the attribute to.
     */ documentNode: $2db2bc563e7e5e69$var$_propTypes.default.any,
        /**
     * If `true`, theme values are recalculated when the mode changes.
     */ forceThemeRerender: $2db2bc563e7e5e69$var$_propTypes.default.bool,
        /**
     * The key in the local storage used to store current color scheme.
     */ modeStorageKey: $2db2bc563e7e5e69$var$_propTypes.default.string,
        /**
     * If `true`, the mode will be the same value as the storage without an extra rerendering after the hydration.
     * You should use this option in conjunction with `InitColorSchemeScript` component.
     */ noSsr: $2db2bc563e7e5e69$var$_propTypes.default.bool,
        /**
     * The storage manager to be used for storing the mode and color scheme
     * @default using `window.localStorage`
     */ storageManager: $2db2bc563e7e5e69$var$_propTypes.default.func,
        /**
     * The window that attaches the 'storage' event listener.
     * @default window
     */ storageWindow: $2db2bc563e7e5e69$var$_propTypes.default.any,
        /**
     * The calculated theme object that will be passed through context.
     */ theme: $2db2bc563e7e5e69$var$_propTypes.default.object
    };
    const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
    const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
    const getInitColorSchemeScript = (params)=>(0, $2db2bc563e7e5e69$var$_InitColorSchemeScript.default)({
            colorSchemeStorageKey: defaultColorSchemeStorageKey,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: defaultModeStorageKey,
            ...params
        });
    return {
        CssVarsProvider: CssVarsProvider,
        useColorScheme: useColorScheme,
        getInitColorSchemeScript: getInitColorSchemeScript
    };
}

});
parcelRegister("79OI6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_MODE_STORAGE_KEY = module.exports.DEFAULT_COLOR_SCHEME_STORAGE_KEY = module.exports.DEFAULT_ATTRIBUTE = void 0;
module.exports.default = $5360b5aae8294a93$var$InitColorSchemeScript;

var $ayMG0 = parcelRequire("ayMG0");
const $5360b5aae8294a93$var$DEFAULT_MODE_STORAGE_KEY = module.exports.DEFAULT_MODE_STORAGE_KEY = 'mode';
const $5360b5aae8294a93$var$DEFAULT_COLOR_SCHEME_STORAGE_KEY = module.exports.DEFAULT_COLOR_SCHEME_STORAGE_KEY = 'color-scheme';
const $5360b5aae8294a93$var$DEFAULT_ATTRIBUTE = module.exports.DEFAULT_ATTRIBUTE = 'data-color-scheme';
function $5360b5aae8294a93$var$InitColorSchemeScript(options) {
    const { defaultMode: defaultMode = 'system', defaultLightColorScheme: defaultLightColorScheme = 'light', defaultDarkColorScheme: defaultDarkColorScheme = 'dark', modeStorageKey: modeStorageKey = $5360b5aae8294a93$var$DEFAULT_MODE_STORAGE_KEY, colorSchemeStorageKey: colorSchemeStorageKey = $5360b5aae8294a93$var$DEFAULT_COLOR_SCHEME_STORAGE_KEY, attribute: initialAttribute = $5360b5aae8294a93$var$DEFAULT_ATTRIBUTE, colorSchemeNode: colorSchemeNode = 'document.documentElement', nonce: nonce } = options || {};
    let setter = '';
    let attribute = initialAttribute;
    if (initialAttribute === 'class') attribute = '.%s';
    if (initialAttribute === 'data') attribute = '[data-%s]';
    if (attribute.startsWith('.')) {
        const selector = attribute.substring(1);
        setter += `${colorSchemeNode}.classList.remove('${selector}'.replace('%s', light), '${selector}'.replace('%s', dark));
      ${colorSchemeNode}.classList.add('${selector}'.replace('%s', colorScheme));`;
    }
    const matches = attribute.match(/\[([^[\]]+)\]/); // case [data-color-scheme='%s'] or [data-color-scheme]
    if (matches) {
        const [attr, value] = matches[1].split('=');
        if (!value) setter += `${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', light));
      ${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', dark));`;
        setter += `
      ${colorSchemeNode}.setAttribute('${attr}'.replace('%s', colorScheme), ${value ? `${value}.replace('%s', colorScheme)` : '""'});`;
    } else if (attribute !== '.%s') setter += `${colorSchemeNode}.setAttribute('${attribute}', colorScheme);`;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("script", {
        suppressHydrationWarning: true,
        nonce: typeof window === 'undefined' ? nonce : '',
        dangerouslySetInnerHTML: {
            __html: `(function() {
try {
  let colorScheme = '';
  const mode = localStorage.getItem('${modeStorageKey}') || '${defaultMode}';
  const dark = localStorage.getItem('${colorSchemeStorageKey}-dark') || '${defaultDarkColorScheme}';
  const light = localStorage.getItem('${colorSchemeStorageKey}-light') || '${defaultLightColorScheme}';
  if (mode === 'system') {
    // handle system mode
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = dark
    } else {
      colorScheme = light
    }
  }
  if (mode === 'light') {
    colorScheme = light;
  }
  if (mode === 'dark') {
    colorScheme = dark;
  }
  if (colorScheme) {
    ${setter}
  }
} catch(e){}})();`
        }
    }, "mui-color-scheme-init");
}

});

parcelRegister("srPro", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $055833d66b0d6531$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $055833d66b0d6531$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $055833d66b0d6531$var$useCurrentColorScheme;
module.exports.getColorScheme = $055833d66b0d6531$var$getColorScheme;
module.exports.getSystemMode = $055833d66b0d6531$var$getSystemMode;

var $055833d66b0d6531$var$React = $055833d66b0d6531$require$_interopRequireWildcard((parcelRequire("acw62")));

var $79OI6 = parcelRequire("79OI6");

var $055833d66b0d6531$var$_localStorageManager = $055833d66b0d6531$require$_interopRequireDefault((parcelRequire("emFGB")));
function $055833d66b0d6531$var$noop() {}
function $055833d66b0d6531$var$getSystemMode(mode) {
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function' && mode === 'system') {
        const mql = window.matchMedia('(prefers-color-scheme: dark)');
        if (mql.matches) return 'dark';
        return 'light';
    }
    return undefined;
}
function $055833d66b0d6531$var$processState(state, callback) {
    if (state.mode === 'light' || state.mode === 'system' && state.systemMode === 'light') return callback('light');
    if (state.mode === 'dark' || state.mode === 'system' && state.systemMode === 'dark') return callback('dark');
    return undefined;
}
function $055833d66b0d6531$var$getColorScheme(state) {
    return $055833d66b0d6531$var$processState(state, (mode)=>{
        if (mode === 'light') return state.lightColorScheme;
        if (mode === 'dark') return state.darkColorScheme;
        return undefined;
    });
}
function $055833d66b0d6531$var$useCurrentColorScheme(options) {
    const { defaultMode: defaultMode = 'light', defaultLightColorScheme: defaultLightColorScheme, defaultDarkColorScheme: defaultDarkColorScheme, supportedColorSchemes: supportedColorSchemes = [], modeStorageKey: modeStorageKey = $79OI6.DEFAULT_MODE_STORAGE_KEY, colorSchemeStorageKey: colorSchemeStorageKey = $79OI6.DEFAULT_COLOR_SCHEME_STORAGE_KEY, storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, storageManager: storageManager = $055833d66b0d6531$var$_localStorageManager.default, noSsr: noSsr = false } = options;
    const joinedColorSchemes = supportedColorSchemes.join(',');
    const isMultiSchemes = supportedColorSchemes.length > 1;
    const modeStorage = $055833d66b0d6531$var$React.useMemo(()=>storageManager?.({
            key: modeStorageKey,
            storageWindow: storageWindow
        }), [
        storageManager,
        modeStorageKey,
        storageWindow
    ]);
    const lightStorage = $055833d66b0d6531$var$React.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-light`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const darkStorage = $055833d66b0d6531$var$React.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-dark`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const [state, setState] = $055833d66b0d6531$var$React.useState(()=>{
        const initialMode = modeStorage?.get(defaultMode) || defaultMode;
        const lightColorScheme = lightStorage?.get(defaultLightColorScheme) || defaultLightColorScheme;
        const darkColorScheme = darkStorage?.get(defaultDarkColorScheme) || defaultDarkColorScheme;
        return {
            mode: initialMode,
            systemMode: $055833d66b0d6531$var$getSystemMode(initialMode),
            lightColorScheme: lightColorScheme,
            darkColorScheme: darkColorScheme
        };
    });
    const [isClient, setIsClient] = $055833d66b0d6531$var$React.useState(noSsr || !isMultiSchemes);
    $055833d66b0d6531$var$React.useEffect(()=>{
        setIsClient(true); // to rerender the component after hydration
    }, []);
    const colorScheme = $055833d66b0d6531$var$getColorScheme(state);
    const setMode = $055833d66b0d6531$var$React.useCallback((mode)=>{
        setState((currentState)=>{
            if (mode === currentState.mode) // do nothing if mode does not change
            return currentState;
            const newMode = mode ?? defaultMode;
            modeStorage?.set(newMode);
            return {
                ...currentState,
                mode: newMode,
                systemMode: $055833d66b0d6531$var$getSystemMode(newMode)
            };
        });
    }, [
        modeStorage,
        defaultMode
    ]);
    const setColorScheme = $055833d66b0d6531$var$React.useCallback((value)=>{
        if (!value) setState((currentState)=>{
            lightStorage?.set(defaultLightColorScheme);
            darkStorage?.set(defaultDarkColorScheme);
            return {
                ...currentState,
                lightColorScheme: defaultLightColorScheme,
                darkColorScheme: defaultDarkColorScheme
            };
        });
        else if (typeof value === 'string') {
            if (value && !joinedColorSchemes.includes(value)) console.error(`\`${value}\` does not exist in \`theme.colorSchemes\`.`);
            else setState((currentState)=>{
                const newState = {
                    ...currentState
                };
                $055833d66b0d6531$var$processState(currentState, (mode)=>{
                    if (mode === 'light') {
                        lightStorage?.set(value);
                        newState.lightColorScheme = value;
                    }
                    if (mode === 'dark') {
                        darkStorage?.set(value);
                        newState.darkColorScheme = value;
                    }
                });
                return newState;
            });
        } else setState((currentState)=>{
            const newState = {
                ...currentState
            };
            const newLightColorScheme = value.light === null ? defaultLightColorScheme : value.light;
            const newDarkColorScheme = value.dark === null ? defaultDarkColorScheme : value.dark;
            if (newLightColorScheme) {
                if (!joinedColorSchemes.includes(newLightColorScheme)) console.error(`\`${newLightColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.lightColorScheme = newLightColorScheme;
                    lightStorage?.set(newLightColorScheme);
                }
            }
            if (newDarkColorScheme) {
                if (!joinedColorSchemes.includes(newDarkColorScheme)) console.error(`\`${newDarkColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.darkColorScheme = newDarkColorScheme;
                    darkStorage?.set(newDarkColorScheme);
                }
            }
            return newState;
        });
    }, [
        joinedColorSchemes,
        lightStorage,
        darkStorage,
        defaultLightColorScheme,
        defaultDarkColorScheme
    ]);
    const handleMediaQuery = $055833d66b0d6531$var$React.useCallback((event)=>{
        if (state.mode === 'system') setState((currentState)=>{
            const systemMode = event?.matches ? 'dark' : 'light';
            // Early exit, nothing changed.
            if (currentState.systemMode === systemMode) return currentState;
            return {
                ...currentState,
                systemMode: systemMode
            };
        });
    }, [
        state.mode
    ]);
    // Ref hack to avoid adding handleMediaQuery as a dep
    const mediaListener = $055833d66b0d6531$var$React.useRef(handleMediaQuery);
    mediaListener.current = handleMediaQuery;
    $055833d66b0d6531$var$React.useEffect(()=>{
        if (typeof window.matchMedia !== 'function' || !isMultiSchemes) return undefined;
        const handler = (...args)=>mediaListener.current(...args);
        // Always listen to System preference
        const media = window.matchMedia('(prefers-color-scheme: dark)');
        // Intentionally use deprecated listener methods to support iOS & old browsers
        media.addListener(handler);
        handler(media);
        return ()=>{
            media.removeListener(handler);
        };
    }, [
        isMultiSchemes
    ]);
    // Handle when localStorage has changed
    $055833d66b0d6531$var$React.useEffect(()=>{
        if (isMultiSchemes) {
            const unsubscribeMode = modeStorage?.subscribe((value)=>{
                if (!value || [
                    'light',
                    'dark',
                    'system'
                ].includes(value)) setMode(value || defaultMode);
            }) || $055833d66b0d6531$var$noop;
            const unsubscribeLight = lightStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    light: value
                });
            }) || $055833d66b0d6531$var$noop;
            const unsubscribeDark = darkStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    dark: value
                });
            }) || $055833d66b0d6531$var$noop;
            return ()=>{
                unsubscribeMode();
                unsubscribeLight();
                unsubscribeDark();
            };
        }
        return undefined;
    }, [
        setColorScheme,
        setMode,
        joinedColorSchemes,
        defaultMode,
        storageWindow,
        isMultiSchemes,
        modeStorage,
        lightStorage,
        darkStorage
    ]);
    return {
        ...state,
        mode: isClient ? state.mode : undefined,
        systemMode: isClient ? state.systemMode : undefined,
        colorScheme: isClient ? colorScheme : undefined,
        setMode: setMode,
        setColorScheme: setColorScheme
    };
}

});
parcelRegister("emFGB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $a75374c871ddabd4$var$noop() {}
const $a75374c871ddabd4$var$localStorageManager = ({ key: key, storageWindow: storageWindow })=>{
    if (!storageWindow && typeof window !== 'undefined') storageWindow = window;
    return {
        get (defaultValue) {
            if (typeof window === 'undefined') return undefined;
            if (!storageWindow) return defaultValue;
            let value;
            try {
                value = storageWindow.localStorage.getItem(key);
            } catch  {
            // Unsupported
            }
            return value || defaultValue;
        },
        set: (value)=>{
            if (storageWindow) try {
                storageWindow.localStorage.setItem(key, value);
            } catch  {
            // Unsupported
            }
        },
        subscribe: (handler)=>{
            if (!storageWindow) return $a75374c871ddabd4$var$noop;
            const listener = (event)=>{
                const value = event.newValue;
                if (event.key === key) handler(value);
            };
            storageWindow.addEventListener('storage', listener);
            return ()=>{
                storageWindow.removeEventListener('storage', listener);
            };
        }
    };
};
var $a75374c871ddabd4$var$_default = module.exports.default = $a75374c871ddabd4$var$localStorageManager;

});



parcelRegister("hKuOr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cebea242efdc3891$var$createGetCssVar;
/**
 * The benefit of this function is to help developers get CSS var from theme without specifying the whole variable
 * and they does not need to remember the prefix (defined once).
 */ function $cebea242efdc3891$var$createGetCssVar(prefix = '') {
    function appendVar(...vars) {
        if (!vars.length) return '';
        const value = vars[0];
        if (typeof value === 'string' && !value.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/)) return `, var(--${prefix ? `${prefix}-` : ''}${value}${appendVar(...vars.slice(1))})`;
        return `, ${value}`;
    }
    // AdditionalVars makes `getCssVar` less strict, so it can be use like this `getCssVar('non-mui-variable')` without type error.
    const getCssVar = (field, ...fallbacks)=>{
        return `var(--${prefix ? `${prefix}-` : ''}${field}${appendVar(...fallbacks)})`;
    };
    return getCssVar;
}

});

parcelRegister("ejFX8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assignNestedKeys = void 0;
module.exports.default = $a6c361fa93759ec5$var$cssVarsParser;
module.exports.walkObjectDeep = void 0;
/**
 * This function create an object from keys, value and then assign to target
 *
 * @param {Object} obj : the target object to be assigned
 * @param {string[]} keys
 * @param {string | number} value
 *
 * @example
 * const source = {}
 * assignNestedKeys(source, ['palette', 'primary'], 'var(--palette-primary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)' } }
 *
 * @example
 * const source = { palette: { primary: 'var(--palette-primary)' } }
 * assignNestedKeys(source, ['palette', 'secondary'], 'var(--palette-secondary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)', secondary: 'var(--palette-secondary)' } }
 */ const $a6c361fa93759ec5$var$assignNestedKeys = (obj, keys, value, arrayKeys = [])=>{
    let temp = obj;
    keys.forEach((k, index)=>{
        if (index === keys.length - 1) {
            if (Array.isArray(temp)) temp[Number(k)] = value;
            else if (temp && typeof temp === 'object') temp[k] = value;
        } else if (temp && typeof temp === 'object') {
            if (!temp[k]) temp[k] = arrayKeys.includes(k) ? [] : {};
            temp = temp[k];
        }
    });
};
/**
 *
 * @param {Object} obj : source object
 * @param {Function} callback : a function that will be called when
 *                   - the deepest key in source object is reached
 *                   - the value of the deepest key is NOT `undefined` | `null`
 *
 * @example
 * walkObjectDeep({ palette: { primary: { main: '#000000' } } }, console.log)
 * // ['palette', 'primary', 'main'] '#000000'
 */ module.exports.assignNestedKeys = $a6c361fa93759ec5$var$assignNestedKeys;
const $a6c361fa93759ec5$var$walkObjectDeep = (obj, callback, shouldSkipPaths)=>{
    function recurse(object, parentKeys = [], arrayKeys = []) {
        Object.entries(object).forEach(([key, value])=>{
            if (!shouldSkipPaths || shouldSkipPaths && !shouldSkipPaths([
                ...parentKeys,
                key
            ])) {
                if (value !== undefined && value !== null) {
                    if (typeof value === 'object' && Object.keys(value).length > 0) recurse(value, [
                        ...parentKeys,
                        key
                    ], Array.isArray(value) ? [
                        ...arrayKeys,
                        key
                    ] : arrayKeys);
                    else callback([
                        ...parentKeys,
                        key
                    ], value, arrayKeys);
                }
            }
        });
    }
    recurse(obj);
};
module.exports.walkObjectDeep = $a6c361fa93759ec5$var$walkObjectDeep;
const $a6c361fa93759ec5$var$getCssValue = (keys, value)=>{
    if (typeof value === 'number') {
        if ([
            'lineHeight',
            'fontWeight',
            'opacity',
            'zIndex'
        ].some((prop)=>keys.includes(prop))) // CSS property that are unitless
        return value;
        const lastKey = keys[keys.length - 1];
        if (lastKey.toLowerCase().includes('opacity')) // opacity values are unitless
        return value;
        return `${value}px`;
    }
    return value;
};
/**
 * a function that parse theme and return { css, vars }
 *
 * @param {Object} theme
 * @param {{
 *  prefix?: string,
 *  shouldSkipGeneratingVar?: (objectPathKeys: Array<string>, value: string | number) => boolean
 * }} options.
 *  `prefix`: The prefix of the generated CSS variables. This function does not change the value.
 *
 * @returns {{ css: Object, vars: Object }} `css` is the stylesheet, `vars` is an object to get css variable (same structure as theme).
 *
 * @example
 * const { css, vars } = parser({
 *   fontSize: 12,
 *   lineHeight: 1.2,
 *   palette: { primary: { 500: 'var(--color)' } }
 * }, { prefix: 'foo' })
 *
 * console.log(css) // { '--foo-fontSize': '12px', '--foo-lineHeight': 1.2, '--foo-palette-primary-500': 'var(--color)' }
 * console.log(vars) // { fontSize: 'var(--foo-fontSize)', lineHeight: 'var(--foo-lineHeight)', palette: { primary: { 500: 'var(--foo-palette-primary-500)' } } }
 */ function $a6c361fa93759ec5$var$cssVarsParser(theme, options) {
    const { prefix: prefix, shouldSkipGeneratingVar: shouldSkipGeneratingVar } = options || {};
    const css = {};
    const vars = {};
    const varsWithDefaults = {};
    $a6c361fa93759ec5$var$walkObjectDeep(theme, (keys, value, arrayKeys)=>{
        if (typeof value === 'string' || typeof value === 'number') {
            if (!shouldSkipGeneratingVar || !shouldSkipGeneratingVar(keys, value)) {
                // only create css & var if `shouldSkipGeneratingVar` return false
                const cssVar = `--${prefix ? `${prefix}-` : ''}${keys.join('-')}`;
                const resolvedValue = $a6c361fa93759ec5$var$getCssValue(keys, value);
                Object.assign(css, {
                    [cssVar]: resolvedValue
                });
                $a6c361fa93759ec5$var$assignNestedKeys(vars, keys, `var(${cssVar})`, arrayKeys);
                $a6c361fa93759ec5$var$assignNestedKeys(varsWithDefaults, keys, `var(${cssVar}, ${resolvedValue})`, arrayKeys);
            }
        }
    }, (keys)=>keys[0] === 'vars' // skip 'vars/*' paths
    );
    return {
        css: css,
        vars: vars,
        varsWithDefaults: varsWithDefaults
    };
}

});

parcelRegister("5magr", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3e66f819b409e224$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e66f819b409e224$var$_deepmerge = $3e66f819b409e224$require$_interopRequireDefault((parcelRequire("bQ4jM")));

var $3e66f819b409e224$var$_cssVarsParser = $3e66f819b409e224$require$_interopRequireDefault((parcelRequire("ejFX8")));
function $3e66f819b409e224$var$prepareCssVars(theme, parserConfig = {}) {
    const { getSelector: getSelector = defaultGetSelector, disableCssColorScheme: disableCssColorScheme, colorSchemeSelector: selector, enableContrastVars: enableContrastVars } = parserConfig;
    // @ts-ignore - ignore components do not exist
    const { colorSchemes: colorSchemes = {}, components: components, defaultColorScheme: defaultColorScheme = 'light', ...otherTheme } = theme;
    const { vars: rootVars, css: rootCss, varsWithDefaults: rootVarsWithDefaults } = (0, $3e66f819b409e224$var$_cssVarsParser.default)(otherTheme, parserConfig);
    let themeVars = rootVarsWithDefaults;
    const colorSchemesMap = {};
    const { [defaultColorScheme]: defaultScheme, ...otherColorSchemes } = colorSchemes;
    Object.entries(otherColorSchemes || {}).forEach(([key, scheme])=>{
        const { vars: vars, css: css, varsWithDefaults: varsWithDefaults } = (0, $3e66f819b409e224$var$_cssVarsParser.default)(scheme, parserConfig);
        themeVars = (0, $3e66f819b409e224$var$_deepmerge.default)(themeVars, varsWithDefaults);
        colorSchemesMap[key] = {
            css: css,
            vars: vars
        };
    });
    if (defaultScheme) {
        // default color scheme vars should be merged last to set as default
        const { css: css, vars: vars, varsWithDefaults: varsWithDefaults } = (0, $3e66f819b409e224$var$_cssVarsParser.default)(defaultScheme, parserConfig);
        themeVars = (0, $3e66f819b409e224$var$_deepmerge.default)(themeVars, varsWithDefaults);
        colorSchemesMap[defaultColorScheme] = {
            css: css,
            vars: vars
        };
    }
    function defaultGetSelector(colorScheme, cssObject) {
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-joy-color-scheme' -> '[data-joy-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (colorScheme) {
            if (rule === 'media') {
                if (theme.defaultColorScheme === colorScheme) return ':root';
                const mode = colorSchemes[colorScheme]?.palette?.mode || colorScheme;
                return {
                    [`@media (prefers-color-scheme: ${mode})`]: {
                        ':root': cssObject
                    }
                };
            }
            if (rule) {
                if (theme.defaultColorScheme === colorScheme) return `:root, ${rule.replace('%s', String(colorScheme))}`;
                return rule.replace('%s', String(colorScheme));
            }
        }
        return ':root';
    }
    const generateThemeVars = ()=>{
        let vars = {
            ...rootVars
        };
        Object.entries(colorSchemesMap).forEach(([, { vars: schemeVars }])=>{
            vars = (0, $3e66f819b409e224$var$_deepmerge.default)(vars, schemeVars);
        });
        return vars;
    };
    const generateStyleSheets = ()=>{
        const stylesheets = [];
        const colorScheme = theme.defaultColorScheme || 'light';
        function insertStyleSheet(key, css) {
            if (Object.keys(css).length) stylesheets.push(typeof key === 'string' ? {
                [key]: {
                    ...css
                }
            } : key);
        }
        insertStyleSheet(getSelector(undefined, {
            ...rootCss
        }), rootCss);
        const { [colorScheme]: defaultSchemeVal, ...other } = colorSchemesMap;
        if (defaultSchemeVal) {
            // default color scheme has to come before other color schemes
            const { css: css } = defaultSchemeVal;
            const cssColorSheme = colorSchemes[colorScheme]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(colorScheme, {
                ...finalCss
            }), finalCss);
        }
        Object.entries(other).forEach(([key, { css: css }])=>{
            const cssColorSheme = colorSchemes[key]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(key, {
                ...finalCss
            }), finalCss);
        });
        if (enableContrastVars) stylesheets.push({
            ':root': {
                // use double underscore to indicate that these are private variables
                '--__l-threshold': '0.7',
                '--__l': 'clamp(0, (l / var(--__l-threshold) - 1) * -infinity, 1)',
                '--__a': 'clamp(0.87, (l / var(--__l-threshold) - 1) * -infinity, 1)' // 0.87 is the default alpha value for black text.
            }
        });
        return stylesheets;
    };
    return {
        vars: themeVars,
        generateThemeVars: generateThemeVars,
        generateStyleSheets: generateStyleSheets
    };
}
var $3e66f819b409e224$var$_default = module.exports.default = $3e66f819b409e224$var$prepareCssVars;

});

parcelRegister("73CWR", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5237068774af7ee7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5237068774af7ee7$var$_prepareCssVars = $5237068774af7ee7$require$_interopRequireDefault((parcelRequire("5magr")));

var $9wccP = parcelRequire("9wccP");

var $79OI6 = parcelRequire("79OI6");
function $5237068774af7ee7$var$createCssVarsTheme({ colorSchemeSelector: colorSchemeSelector = `[${$79OI6.DEFAULT_ATTRIBUTE}="%s"]`, ...theme }) {
    const output = theme;
    const result = (0, $5237068774af7ee7$var$_prepareCssVars.default)(output, {
        ...theme,
        prefix: theme.cssVarPrefix,
        colorSchemeSelector: colorSchemeSelector
    });
    output.vars = result.vars;
    output.generateThemeVars = result.generateThemeVars;
    output.generateStyleSheets = result.generateStyleSheets;
    output.colorSchemeSelector = colorSchemeSelector;
    output.getColorSchemeSelector = (0, $9wccP.createGetColorSchemeSelector)(colorSchemeSelector);
    return output;
}
var $5237068774af7ee7$var$_default = module.exports.default = $5237068774af7ee7$var$createCssVarsTheme;

});
parcelRegister("9wccP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createGetColorSchemeSelector = $6ee0921037829b98$var$createGetColorSchemeSelector;
/* eslint-disable import/prefer-default-export */ function $6ee0921037829b98$var$createGetColorSchemeSelector(selector) {
    return function getColorSchemeSelector(colorScheme) {
        if (selector === 'media') {
            if (colorScheme !== 'light' && colorScheme !== 'dark') console.error(`MUI: @media (prefers-color-scheme) supports only 'light' or 'dark', but receive '${colorScheme}'.`);
            return `@media (prefers-color-scheme: ${colorScheme})`;
        }
        if (selector) {
            if (selector.startsWith('data-') && !selector.includes('%s')) return `[${selector}="${colorScheme}"] &`;
            if (selector === 'class') return `.${colorScheme} &`;
            if (selector === 'data') return `[data-${colorScheme}] &`;
            return `${selector.replace('%s', colorScheme)} &`;
        }
        return '&';
    };
}

});


parcelRegister("1RRq5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.version = module.exports.prerelease = module.exports.patch = module.exports.minor = module.exports.major = module.exports.default = void 0;
const $15c42dbad1fc53b5$var$version = module.exports.version = "7.3.11";
const $15c42dbad1fc53b5$var$major = module.exports.major = Number("7");
const $15c42dbad1fc53b5$var$minor = module.exports.minor = Number("3");
const $15c42dbad1fc53b5$var$patch = module.exports.patch = Number("11");
const $15c42dbad1fc53b5$var$prerelease = module.exports.prerelease = undefined;
var $15c42dbad1fc53b5$var$_default = module.exports.default = $15c42dbad1fc53b5$var$version;

});

parcelRegister("689Qv", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $476b209a249f8c65$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $476b209a249f8c65$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $476b209a249f8c65$var$createContainer;

var $476b209a249f8c65$var$React = $476b209a249f8c65$require$_interopRequireWildcard((parcelRequire("acw62")));

var $476b209a249f8c65$var$_propTypes = $476b209a249f8c65$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $476b209a249f8c65$var$_clsx = $476b209a249f8c65$require$_interopRequireDefault((parcelRequire("9QePP")));

var $476b209a249f8c65$var$_generateUtilityClass = $476b209a249f8c65$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $476b209a249f8c65$var$_composeClasses = $476b209a249f8c65$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $476b209a249f8c65$var$_capitalize = $476b209a249f8c65$require$_interopRequireDefault((parcelRequire("4O6za")));

var $476b209a249f8c65$var$_useThemeProps = $476b209a249f8c65$require$_interopRequireDefault((parcelRequire("2LgDM")));

var $476b209a249f8c65$var$_styled = $476b209a249f8c65$require$_interopRequireDefault((parcelRequire("kpukb")));

var $476b209a249f8c65$var$_createTheme = $476b209a249f8c65$require$_interopRequireDefault((parcelRequire("1dhnG")));

var $ayMG0 = parcelRequire("ayMG0");
const $476b209a249f8c65$var$defaultTheme = (0, $476b209a249f8c65$var$_createTheme.default)();
const $476b209a249f8c65$var$defaultCreateStyledComponent = (0, $476b209a249f8c65$var$_styled.default)('div', {
    name: 'MuiContainer',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`maxWidth${(0, $476b209a249f8c65$var$_capitalize.default)(String(ownerState.maxWidth))}`],
            ownerState.fixed && styles.fixed,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
});
const $476b209a249f8c65$var$useThemePropsDefault = (inProps)=>(0, $476b209a249f8c65$var$_useThemeProps.default)({
        props: inProps,
        name: 'MuiContainer',
        defaultTheme: $476b209a249f8c65$var$defaultTheme
    });
const $476b209a249f8c65$var$useUtilityClasses = (ownerState, componentName)=>{
    const getContainerUtilityClass = (slot)=>{
        return (0, $476b209a249f8c65$var$_generateUtilityClass.default)(componentName, slot);
    };
    const { classes: classes, fixed: fixed, disableGutters: disableGutters, maxWidth: maxWidth } = ownerState;
    const slots = {
        root: [
            'root',
            maxWidth && `maxWidth${(0, $476b209a249f8c65$var$_capitalize.default)(String(maxWidth))}`,
            fixed && 'fixed',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $476b209a249f8c65$var$_composeClasses.default)(slots, getContainerUtilityClass, classes);
};
function $476b209a249f8c65$var$createContainer(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $476b209a249f8c65$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $476b209a249f8c65$var$useThemePropsDefault, componentName: componentName = 'MuiContainer' } = options;
    const ContainerRoot = createStyledComponent(({ theme: theme, ownerState: ownerState })=>({
            width: '100%',
            marginLeft: 'auto',
            boxSizing: 'border-box',
            marginRight: 'auto',
            ...!ownerState.disableGutters && {
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(2),
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up('sm')]: {
                    paddingLeft: theme.spacing(3),
                    paddingRight: theme.spacing(3)
                }
            }
        }), ({ theme: theme, ownerState: ownerState })=>ownerState.fixed && Object.keys(theme.breakpoints.values).reduce((acc, breakpointValueKey)=>{
            const breakpoint = breakpointValueKey;
            const value = theme.breakpoints.values[breakpoint];
            if (value !== 0) // @ts-ignore
            acc[theme.breakpoints.up(breakpoint)] = {
                maxWidth: `${value}${theme.breakpoints.unit}`
            };
            return acc;
        }, {}), ({ theme: theme, ownerState: ownerState })=>({
            // @ts-ignore module augmentation fails if custom breakpoints are used
            ...ownerState.maxWidth === 'xs' && {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up('xs')]: {
                    // @ts-ignore module augmentation fails if custom breakpoints are used
                    maxWidth: Math.max(theme.breakpoints.values.xs, 444)
                }
            },
            ...ownerState.maxWidth && // @ts-ignore module augmentation fails if custom breakpoints are used
            ownerState.maxWidth !== 'xs' && {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up(ownerState.maxWidth)]: {
                    // @ts-ignore module augmentation fails if custom breakpoints are used
                    maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`
                }
            }
        }));
    const Container = /*#__PURE__*/ $476b209a249f8c65$var$React.forwardRef(function Container(inProps, ref) {
        const props = useThemeProps(inProps);
        const { className: className, component: component = 'div', disableGutters: disableGutters = false, fixed: fixed = false, maxWidth: maxWidth = 'lg', classes: classesProp, ...other } = props;
        const ownerState = {
            ...props,
            component: component,
            disableGutters: disableGutters,
            fixed: fixed,
            maxWidth: maxWidth
        };
        // @ts-ignore module augmentation fails if custom breakpoints are used
        const classes = $476b209a249f8c65$var$useUtilityClasses(ownerState, componentName);
        return(/*#__PURE__*/ // @ts-ignore theme is injected by the styled util
        (0, $ayMG0.jsx)(ContainerRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $476b209a249f8c65$var$_clsx.default)(classes.root, className),
            ref: ref,
            ...other
        }));
    });
    Container.propTypes = {
        children: $476b209a249f8c65$var$_propTypes.default.node,
        classes: $476b209a249f8c65$var$_propTypes.default.object,
        className: $476b209a249f8c65$var$_propTypes.default.string,
        component: $476b209a249f8c65$var$_propTypes.default.elementType,
        disableGutters: $476b209a249f8c65$var$_propTypes.default.bool,
        fixed: $476b209a249f8c65$var$_propTypes.default.bool,
        maxWidth: $476b209a249f8c65$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
            $476b209a249f8c65$var$_propTypes.default.oneOf([
                'xs',
                'sm',
                'md',
                'lg',
                'xl',
                false
            ]),
            $476b209a249f8c65$var$_propTypes.default.string
        ]),
        sx: $476b209a249f8c65$var$_propTypes.default.oneOfType([
            $476b209a249f8c65$var$_propTypes.default.arrayOf($476b209a249f8c65$var$_propTypes.default.oneOfType([
                $476b209a249f8c65$var$_propTypes.default.func,
                $476b209a249f8c65$var$_propTypes.default.object,
                $476b209a249f8c65$var$_propTypes.default.bool
            ])),
            $476b209a249f8c65$var$_propTypes.default.func,
            $476b209a249f8c65$var$_propTypes.default.object
        ])
    };
    return Container;
}

});
parcelRegister("3Hg1x", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $2b11d13e9f9cf7db$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $2b11d13e9f9cf7db$var$_composeClasses.default;
    }
});

var $2b11d13e9f9cf7db$var$_composeClasses = $2b11d13e9f9cf7db$require$_interopRequireDefault((parcelRequire("5m3Us")));

});
parcelRegister("5m3Us", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3e620a2ee867e5d5$var$composeClasses;
/* eslint no-restricted-syntax: 0, prefer-template: 0, guard-for-in: 0
   ---
   These rules are preventing the performance optimizations below.
 */ /**
 * Compose classes from multiple sources.
 *
 * @example
 * ```tsx
 * const slots = {
 *  root: ['root', 'primary'],
 *  label: ['label'],
 * };
 *
 * const getUtilityClass = (slot) => `MuiButton-${slot}`;
 *
 * const classes = {
 *   root: 'my-root-class',
 * };
 *
 * const output = composeClasses(slots, getUtilityClass, classes);
 * // {
 * //   root: 'MuiButton-root MuiButton-primary my-root-class',
 * //   label: 'MuiButton-label',
 * // }
 * ```
 *
 * @param slots a list of classes for each possible slot
 * @param getUtilityClass a function to resolve the class based on the slot name
 * @param classes the input classes from props
 * @returns the resolved classes for all slots
 */ function $3e620a2ee867e5d5$var$composeClasses(slots, getUtilityClass, classes) {
    const output = {};
    for(const slotName in slots){
        const slot = slots[slotName];
        let buffer = '';
        let start = true;
        for(let i = 0; i < slot.length; i += 1){
            const value = slot[i];
            if (value) {
                buffer += (start === true ? '' : ' ') + getUtilityClass(value);
                start = false;
                if (classes && classes[value]) buffer += ' ' + classes[value];
            }
        }
        output[slotName] = buffer;
    }
    return output;
}

});



parcelRegister("jYQTJ", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $e8bca752eef9579e$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $e8bca752eef9579e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $e8bca752eef9579e$var$_exportNames = {
    containerClasses: true
};
Object.defineProperty(module.exports, "containerClasses", {
    enumerable: true,
    get: function() {
        return $e8bca752eef9579e$var$_containerClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $e8bca752eef9579e$var$_Container.default;
    }
});

var $e8bca752eef9579e$var$_Container = $e8bca752eef9579e$require$_interopRequireDefault((parcelRequire("gRSQN")));

var $e8bca752eef9579e$var$_containerClasses = $e8bca752eef9579e$require$_interopRequireWildcard((parcelRequire("brfSx")));
Object.keys($e8bca752eef9579e$var$_containerClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($e8bca752eef9579e$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $e8bca752eef9579e$var$_containerClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $e8bca752eef9579e$var$_containerClasses[key];
        }
    });
});

});
parcelRegister("gRSQN", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $c47c24bbe2a0d6f8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c47c24bbe2a0d6f8$var$_propTypes = $c47c24bbe2a0d6f8$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $c47c24bbe2a0d6f8$var$_createContainer = $c47c24bbe2a0d6f8$require$_interopRequireDefault((parcelRequire("689Qv")));
/**
 *
 * Demos:
 *
 * - [Container (Material UI)](https://mui.com/material-ui/react-container/)
 * - [Container (MUI System)](https://mui.com/system/react-container/)
 *
 * API:
 *
 * - [Container API](https://mui.com/system/api/container/)
 */ const $c47c24bbe2a0d6f8$var$Container = (0, $c47c24bbe2a0d6f8$var$_createContainer.default)();
$c47c24bbe2a0d6f8$var$Container.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * @ignore
   */ children: $c47c24bbe2a0d6f8$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $c47c24bbe2a0d6f8$var$_propTypes.default.object,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $c47c24bbe2a0d6f8$var$_propTypes.default.elementType,
    /**
   * If `true`, the left and right padding is removed.
   * @default false
   */ disableGutters: $c47c24bbe2a0d6f8$var$_propTypes.default.bool,
    /**
   * Set the max-width to match the min-width of the current breakpoint.
   * This is useful if you'd prefer to design for a fixed set of sizes
   * instead of trying to accommodate a fully fluid viewport.
   * It's fluid by default.
   * @default false
   */ fixed: $c47c24bbe2a0d6f8$var$_propTypes.default.bool,
    /**
   * Determine the max-width of the container.
   * The container width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   * @default 'lg'
   */ maxWidth: $c47c24bbe2a0d6f8$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $c47c24bbe2a0d6f8$var$_propTypes.default.oneOf([
            'xs',
            'sm',
            'md',
            'lg',
            'xl',
            false
        ]),
        $c47c24bbe2a0d6f8$var$_propTypes.default.string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $c47c24bbe2a0d6f8$var$_propTypes.default.oneOfType([
        $c47c24bbe2a0d6f8$var$_propTypes.default.arrayOf($c47c24bbe2a0d6f8$var$_propTypes.default.oneOfType([
            $c47c24bbe2a0d6f8$var$_propTypes.default.func,
            $c47c24bbe2a0d6f8$var$_propTypes.default.object,
            $c47c24bbe2a0d6f8$var$_propTypes.default.bool
        ])),
        $c47c24bbe2a0d6f8$var$_propTypes.default.func,
        $c47c24bbe2a0d6f8$var$_propTypes.default.object
    ])
};
var $c47c24bbe2a0d6f8$var$_default = module.exports.default = $c47c24bbe2a0d6f8$var$Container;

});

parcelRegister("brfSx", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $853e8880b5f4e64d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getContainerUtilityClass = $853e8880b5f4e64d$var$getContainerUtilityClass;

var $853e8880b5f4e64d$var$_generateUtilityClasses = $853e8880b5f4e64d$require$_interopRequireDefault((parcelRequire("5nY49")));

var $853e8880b5f4e64d$var$_generateUtilityClass = $853e8880b5f4e64d$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $853e8880b5f4e64d$var$getContainerUtilityClass(slot) {
    return (0, $853e8880b5f4e64d$var$_generateUtilityClass.default)('MuiContainer', slot);
}
const $853e8880b5f4e64d$var$containerClasses = (0, $853e8880b5f4e64d$var$_generateUtilityClasses.default)('MuiContainer', [
    'root',
    'disableGutters',
    'fixed',
    'maxWidthXs',
    'maxWidthSm',
    'maxWidthMd',
    'maxWidthLg',
    'maxWidthXl'
]);
var $853e8880b5f4e64d$var$_default = module.exports.default = $853e8880b5f4e64d$var$containerClasses;

});


parcelRegister("dy2yf", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $9dd06e03e834ae16$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9dd06e03e834ae16$var$_propTypes = $9dd06e03e834ae16$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $9dd06e03e834ae16$var$_createGrid = $9dd06e03e834ae16$require$_interopRequireDefault((parcelRequire("h0TiG")));
/**
 *
 * Demos:
 *
 * - [Grid (Joy UI)](https://mui.com/joy-ui/react-grid/)
 * - [Grid (Material UI)](https://mui.com/material-ui/react-grid/)
 *
 * API:
 *
 * - [Grid API](https://mui.com/system/api/grid/)
 */ const $9dd06e03e834ae16$var$Grid = (0, $9dd06e03e834ae16$var$_createGrid.default)();
$9dd06e03e834ae16$var$Grid.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: $9dd06e03e834ae16$var$_propTypes.default.node,
    /**
   * The number of columns.
   * @default 12
   */ columns: $9dd06e03e834ae16$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $9dd06e03e834ae16$var$_propTypes.default.arrayOf($9dd06e03e834ae16$var$_propTypes.default.number),
        $9dd06e03e834ae16$var$_propTypes.default.number,
        $9dd06e03e834ae16$var$_propTypes.default.object
    ]),
    /**
   * Defines the horizontal space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */ columnSpacing: $9dd06e03e834ae16$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $9dd06e03e834ae16$var$_propTypes.default.arrayOf($9dd06e03e834ae16$var$_propTypes.default.oneOfType([
            $9dd06e03e834ae16$var$_propTypes.default.number,
            $9dd06e03e834ae16$var$_propTypes.default.string
        ])),
        $9dd06e03e834ae16$var$_propTypes.default.number,
        $9dd06e03e834ae16$var$_propTypes.default.object,
        $9dd06e03e834ae16$var$_propTypes.default.string
    ]),
    /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */ container: $9dd06e03e834ae16$var$_propTypes.default.bool,
    /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'row'
   */ direction: $9dd06e03e834ae16$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $9dd06e03e834ae16$var$_propTypes.default.oneOf([
            'column-reverse',
            'column',
            'row-reverse',
            'row'
        ]),
        $9dd06e03e834ae16$var$_propTypes.default.arrayOf($9dd06e03e834ae16$var$_propTypes.default.oneOf([
            'column-reverse',
            'column',
            'row-reverse',
            'row'
        ])),
        $9dd06e03e834ae16$var$_propTypes.default.object
    ]),
    /**
   * Defines the offset value for the type `item` components.
   */ offset: $9dd06e03e834ae16$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $9dd06e03e834ae16$var$_propTypes.default.string,
        $9dd06e03e834ae16$var$_propTypes.default.number,
        $9dd06e03e834ae16$var$_propTypes.default.arrayOf($9dd06e03e834ae16$var$_propTypes.default.oneOfType([
            $9dd06e03e834ae16$var$_propTypes.default.string,
            $9dd06e03e834ae16$var$_propTypes.default.number
        ])),
        $9dd06e03e834ae16$var$_propTypes.default.object
    ]),
    /**
   * Defines the vertical space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */ rowSpacing: $9dd06e03e834ae16$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $9dd06e03e834ae16$var$_propTypes.default.arrayOf($9dd06e03e834ae16$var$_propTypes.default.oneOfType([
            $9dd06e03e834ae16$var$_propTypes.default.number,
            $9dd06e03e834ae16$var$_propTypes.default.string
        ])),
        $9dd06e03e834ae16$var$_propTypes.default.number,
        $9dd06e03e834ae16$var$_propTypes.default.object,
        $9dd06e03e834ae16$var$_propTypes.default.string
    ]),
    /**
   * Defines the size of the the type `item` components.
   */ size: $9dd06e03e834ae16$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $9dd06e03e834ae16$var$_propTypes.default.string,
        $9dd06e03e834ae16$var$_propTypes.default.bool,
        $9dd06e03e834ae16$var$_propTypes.default.number,
        $9dd06e03e834ae16$var$_propTypes.default.arrayOf($9dd06e03e834ae16$var$_propTypes.default.oneOfType([
            $9dd06e03e834ae16$var$_propTypes.default.string,
            $9dd06e03e834ae16$var$_propTypes.default.bool,
            $9dd06e03e834ae16$var$_propTypes.default.number
        ])),
        $9dd06e03e834ae16$var$_propTypes.default.object
    ]),
    /**
   * Defines the space between the type `item` components.
   * It can only be used on a type `container` component.
   * @default 0
   */ spacing: $9dd06e03e834ae16$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $9dd06e03e834ae16$var$_propTypes.default.arrayOf($9dd06e03e834ae16$var$_propTypes.default.oneOfType([
            $9dd06e03e834ae16$var$_propTypes.default.number,
            $9dd06e03e834ae16$var$_propTypes.default.string
        ])),
        $9dd06e03e834ae16$var$_propTypes.default.number,
        $9dd06e03e834ae16$var$_propTypes.default.object,
        $9dd06e03e834ae16$var$_propTypes.default.string
    ]),
    /**
   * @ignore
   */ sx: $9dd06e03e834ae16$var$_propTypes.default.oneOfType([
        $9dd06e03e834ae16$var$_propTypes.default.arrayOf($9dd06e03e834ae16$var$_propTypes.default.oneOfType([
            $9dd06e03e834ae16$var$_propTypes.default.func,
            $9dd06e03e834ae16$var$_propTypes.default.object,
            $9dd06e03e834ae16$var$_propTypes.default.bool
        ])),
        $9dd06e03e834ae16$var$_propTypes.default.func,
        $9dd06e03e834ae16$var$_propTypes.default.object
    ]),
    /**
   * @internal
   * The level of the grid starts from `0` and increases when the grid nests
   * inside another grid. Nesting is defined as a container Grid being a direct
   * child of a container Grid.
   *
   * ```js
   * <Grid container> // level 0
   *   <Grid container> // level 1
   *     <Grid container> // level 2
   * ```
   *
   * Only consecutive grid is considered nesting. A grid container will start at
   * `0` if there are non-Grid container element above it.
   *
   * ```js
   * <Grid container> // level 0
   *   <div>
   *     <Grid container> // level 0
   * ```
   *
   * ```js
   * <Grid container> // level 0
   *   <Grid>
   *     <Grid container> // level 0
   * ```
   */ unstable_level: $9dd06e03e834ae16$var$_propTypes.default.number,
    /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   * @default 'wrap'
   */ wrap: $9dd06e03e834ae16$var$_propTypes.default.oneOf([
        'nowrap',
        'wrap-reverse',
        'wrap'
    ])
};
var $9dd06e03e834ae16$var$_default = module.exports.default = $9dd06e03e834ae16$var$Grid;

});
parcelRegister("h0TiG", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $c62d554115d846cf$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $c62d554115d846cf$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c62d554115d846cf$var$createGrid;

var $c62d554115d846cf$var$React = $c62d554115d846cf$require$_interopRequireWildcard((parcelRequire("acw62")));

var $c62d554115d846cf$var$_propTypes = $c62d554115d846cf$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $c62d554115d846cf$var$_clsx = $c62d554115d846cf$require$_interopRequireDefault((parcelRequire("9QePP")));

var $c62d554115d846cf$var$_isMuiElement = $c62d554115d846cf$require$_interopRequireDefault((parcelRequire("5yr9V")));

var $c62d554115d846cf$var$_generateUtilityClass = $c62d554115d846cf$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $c62d554115d846cf$var$_composeClasses = $c62d554115d846cf$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $c62d554115d846cf$var$_styled = $c62d554115d846cf$require$_interopRequireDefault((parcelRequire("kpukb")));

var $c62d554115d846cf$var$_useThemeProps = $c62d554115d846cf$require$_interopRequireDefault((parcelRequire("2LgDM")));

var $c62d554115d846cf$var$_useTheme = $c62d554115d846cf$require$_interopRequireDefault((parcelRequire("lywMB")));

var $l6FST = parcelRequire("l6FST");

var $c62d554115d846cf$var$_createTheme = $c62d554115d846cf$require$_interopRequireDefault((parcelRequire("1dhnG")));

var $ggHhD = parcelRequire("ggHhD");

var $c62d554115d846cf$var$_deleteLegacyGridProps = $c62d554115d846cf$require$_interopRequireDefault((parcelRequire("g9pbx")));

var $ayMG0 = parcelRequire("ayMG0");
const $c62d554115d846cf$var$defaultTheme = (0, $c62d554115d846cf$var$_createTheme.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $c62d554115d846cf$var$defaultCreateStyledComponent = (0, $c62d554115d846cf$var$_styled.default)('div', {
    name: 'MuiGrid',
    slot: 'Root'
});
function $c62d554115d846cf$var$useThemePropsDefault(props) {
    return (0, $c62d554115d846cf$var$_useThemeProps.default)({
        props: props,
        name: 'MuiGrid',
        defaultTheme: $c62d554115d846cf$var$defaultTheme
    });
}
function $c62d554115d846cf$var$createGrid(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $c62d554115d846cf$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $c62d554115d846cf$var$useThemePropsDefault, useTheme: useTheme = $c62d554115d846cf$var$_useTheme.default, componentName: componentName = 'MuiGrid' } = options;
    const useUtilityClasses = (ownerState, theme)=>{
        const { container: container, direction: direction, spacing: spacing, wrap: wrap, size: size } = ownerState;
        const slots = {
            root: [
                'root',
                container && 'container',
                wrap !== 'wrap' && `wrap-xs-${String(wrap)}`,
                ...(0, $ggHhD.generateDirectionClasses)(direction),
                ...(0, $ggHhD.generateSizeClassNames)(size),
                ...container ? (0, $ggHhD.generateSpacingClassNames)(spacing, theme.breakpoints.keys[0]) : []
            ]
        };
        return (0, $c62d554115d846cf$var$_composeClasses.default)(slots, (slot)=>(0, $c62d554115d846cf$var$_generateUtilityClass.default)(componentName, slot), {});
    };
    function parseResponsiveProp(propValue, breakpoints, shouldUseValue = ()=>true) {
        const parsedProp = {};
        if (propValue === null) return parsedProp;
        if (Array.isArray(propValue)) propValue.forEach((value, index)=>{
            if (value !== null && shouldUseValue(value) && breakpoints.keys[index]) parsedProp[breakpoints.keys[index]] = value;
        });
        else if (typeof propValue === 'object') Object.keys(propValue).forEach((key)=>{
            const value = propValue[key];
            if (value !== null && value !== undefined && shouldUseValue(value)) parsedProp[key] = value;
        });
        else parsedProp[breakpoints.keys[0]] = propValue;
        return parsedProp;
    }
    const GridRoot = createStyledComponent($ggHhD.generateGridColumnsStyles, $ggHhD.generateGridColumnSpacingStyles, $ggHhD.generateGridRowSpacingStyles, $ggHhD.generateGridSizeStyles, $ggHhD.generateGridDirectionStyles, $ggHhD.generateGridStyles, $ggHhD.generateGridOffsetStyles);
    const Grid = /*#__PURE__*/ $c62d554115d846cf$var$React.forwardRef(function Grid(inProps, ref) {
        const theme = useTheme();
        const themeProps = useThemeProps(inProps);
        const props = (0, $l6FST.extendSxProp)(themeProps); // `color` type conflicts with html color attribute.
        // TODO v8: Remove when removing the legacy Grid component
        (0, $c62d554115d846cf$var$_deleteLegacyGridProps.default)(props, theme.breakpoints);
        const { className: className, children: children, columns: columnsProp = 12, container: container = false, component: component = 'div', direction: direction = 'row', wrap: wrap = 'wrap', size: sizeProp = {}, offset: offsetProp = {}, spacing: spacingProp = 0, rowSpacing: rowSpacingProp = spacingProp, columnSpacing: columnSpacingProp = spacingProp, unstable_level: level = 0, ...other } = props;
        const size = parseResponsiveProp(sizeProp, theme.breakpoints, (val)=>val !== false);
        const offset = parseResponsiveProp(offsetProp, theme.breakpoints);
        const columns = inProps.columns ?? (level ? undefined : columnsProp);
        const spacing = inProps.spacing ?? (level ? undefined : spacingProp);
        const rowSpacing = inProps.rowSpacing ?? inProps.spacing ?? (level ? undefined : rowSpacingProp);
        const columnSpacing = inProps.columnSpacing ?? inProps.spacing ?? (level ? undefined : columnSpacingProp);
        const ownerState = {
            ...props,
            level: level,
            columns: columns,
            container: container,
            direction: direction,
            wrap: wrap,
            spacing: spacing,
            rowSpacing: rowSpacing,
            columnSpacing: columnSpacing,
            size: size,
            offset: offset
        };
        const classes = useUtilityClasses(ownerState, theme);
        return /*#__PURE__*/ (0, $ayMG0.jsx)(GridRoot, {
            ref: ref,
            as: component,
            ownerState: ownerState,
            className: (0, $c62d554115d846cf$var$_clsx.default)(classes.root, className),
            ...other,
            children: $c62d554115d846cf$var$React.Children.map(children, (child)=>{
                if (/*#__PURE__*/ $c62d554115d846cf$var$React.isValidElement(child) && (0, $c62d554115d846cf$var$_isMuiElement.default)(child, [
                    'Grid'
                ]) && container && child.props.container) return /*#__PURE__*/ $c62d554115d846cf$var$React.cloneElement(child, {
                    unstable_level: child.props?.unstable_level ?? level + 1
                });
                return child;
            })
        });
    });
    Grid.propTypes = {
        children: $c62d554115d846cf$var$_propTypes.default.node,
        className: $c62d554115d846cf$var$_propTypes.default.string,
        columns: $c62d554115d846cf$var$_propTypes.default.oneOfType([
            $c62d554115d846cf$var$_propTypes.default.arrayOf($c62d554115d846cf$var$_propTypes.default.number),
            $c62d554115d846cf$var$_propTypes.default.number,
            $c62d554115d846cf$var$_propTypes.default.object
        ]),
        columnSpacing: $c62d554115d846cf$var$_propTypes.default.oneOfType([
            $c62d554115d846cf$var$_propTypes.default.arrayOf($c62d554115d846cf$var$_propTypes.default.oneOfType([
                $c62d554115d846cf$var$_propTypes.default.number,
                $c62d554115d846cf$var$_propTypes.default.string
            ])),
            $c62d554115d846cf$var$_propTypes.default.number,
            $c62d554115d846cf$var$_propTypes.default.object,
            $c62d554115d846cf$var$_propTypes.default.string
        ]),
        component: $c62d554115d846cf$var$_propTypes.default.elementType,
        container: $c62d554115d846cf$var$_propTypes.default.bool,
        direction: $c62d554115d846cf$var$_propTypes.default.oneOfType([
            $c62d554115d846cf$var$_propTypes.default.oneOf([
                'column-reverse',
                'column',
                'row-reverse',
                'row'
            ]),
            $c62d554115d846cf$var$_propTypes.default.arrayOf($c62d554115d846cf$var$_propTypes.default.oneOf([
                'column-reverse',
                'column',
                'row-reverse',
                'row'
            ])),
            $c62d554115d846cf$var$_propTypes.default.object
        ]),
        offset: $c62d554115d846cf$var$_propTypes.default.oneOfType([
            $c62d554115d846cf$var$_propTypes.default.string,
            $c62d554115d846cf$var$_propTypes.default.number,
            $c62d554115d846cf$var$_propTypes.default.arrayOf($c62d554115d846cf$var$_propTypes.default.oneOfType([
                $c62d554115d846cf$var$_propTypes.default.string,
                $c62d554115d846cf$var$_propTypes.default.number
            ])),
            $c62d554115d846cf$var$_propTypes.default.object
        ]),
        rowSpacing: $c62d554115d846cf$var$_propTypes.default.oneOfType([
            $c62d554115d846cf$var$_propTypes.default.arrayOf($c62d554115d846cf$var$_propTypes.default.oneOfType([
                $c62d554115d846cf$var$_propTypes.default.number,
                $c62d554115d846cf$var$_propTypes.default.string
            ])),
            $c62d554115d846cf$var$_propTypes.default.number,
            $c62d554115d846cf$var$_propTypes.default.object,
            $c62d554115d846cf$var$_propTypes.default.string
        ]),
        size: $c62d554115d846cf$var$_propTypes.default.oneOfType([
            $c62d554115d846cf$var$_propTypes.default.string,
            $c62d554115d846cf$var$_propTypes.default.bool,
            $c62d554115d846cf$var$_propTypes.default.number,
            $c62d554115d846cf$var$_propTypes.default.arrayOf($c62d554115d846cf$var$_propTypes.default.oneOfType([
                $c62d554115d846cf$var$_propTypes.default.string,
                $c62d554115d846cf$var$_propTypes.default.bool,
                $c62d554115d846cf$var$_propTypes.default.number
            ])),
            $c62d554115d846cf$var$_propTypes.default.object
        ]),
        spacing: $c62d554115d846cf$var$_propTypes.default.oneOfType([
            $c62d554115d846cf$var$_propTypes.default.arrayOf($c62d554115d846cf$var$_propTypes.default.oneOfType([
                $c62d554115d846cf$var$_propTypes.default.number,
                $c62d554115d846cf$var$_propTypes.default.string
            ])),
            $c62d554115d846cf$var$_propTypes.default.number,
            $c62d554115d846cf$var$_propTypes.default.object,
            $c62d554115d846cf$var$_propTypes.default.string
        ]),
        sx: $c62d554115d846cf$var$_propTypes.default.oneOfType([
            $c62d554115d846cf$var$_propTypes.default.arrayOf($c62d554115d846cf$var$_propTypes.default.oneOfType([
                $c62d554115d846cf$var$_propTypes.default.func,
                $c62d554115d846cf$var$_propTypes.default.object,
                $c62d554115d846cf$var$_propTypes.default.bool
            ])),
            $c62d554115d846cf$var$_propTypes.default.func,
            $c62d554115d846cf$var$_propTypes.default.object
        ]),
        wrap: $c62d554115d846cf$var$_propTypes.default.oneOf([
            'nowrap',
            'wrap-reverse',
            'wrap'
        ])
    };
    // @ts-ignore internal logic for nested grid
    Grid.muiName = 'Grid';
    return Grid;
}

});
parcelRegister("5yr9V", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $40b531ef992288aa$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $40b531ef992288aa$var$_isMuiElement.default;
    }
});

var $40b531ef992288aa$var$_isMuiElement = $40b531ef992288aa$require$_interopRequireDefault((parcelRequire("cr6gy")));

});
parcelRegister("cr6gy", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $90dcddf03243cc11$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $90dcddf03243cc11$var$isMuiElement;

var $90dcddf03243cc11$var$React = $90dcddf03243cc11$require$_interopRequireWildcard((parcelRequire("acw62")));
function $90dcddf03243cc11$var$isMuiElement(element, muiNames) {
    return /*#__PURE__*/ $90dcddf03243cc11$var$React.isValidElement(element) && muiNames.indexOf(// For server components `muiName` is available in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    element.type.muiName ?? element.type?._payload?.value?.muiName) !== -1;
}

});


parcelRegister("ggHhD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.generateSpacingClassNames = module.exports.generateSizeClassNames = module.exports.generateGridStyles = module.exports.generateGridSizeStyles = module.exports.generateGridRowSpacingStyles = module.exports.generateGridOffsetStyles = module.exports.generateGridDirectionStyles = module.exports.generateGridColumnsStyles = module.exports.generateGridColumnSpacingStyles = module.exports.generateDirectionClasses = void 0;

var $99OVR = parcelRequire("99OVR");
function $bd7fb721dfb6dcf0$var$getSelfSpacingVar(axis) {
    return `--Grid-${axis}Spacing`;
}
function $bd7fb721dfb6dcf0$var$getParentSpacingVar(axis) {
    return `--Grid-parent-${axis}Spacing`;
}
const $bd7fb721dfb6dcf0$var$selfColumnsVar = '--Grid-columns';
const $bd7fb721dfb6dcf0$var$parentColumnsVar = '--Grid-parent-columns';
const $bd7fb721dfb6dcf0$var$generateGridSizeStyles = ({ theme: theme, ownerState: ownerState })=>{
    const styles = {};
    (0, $99OVR.traverseBreakpoints)(theme.breakpoints, ownerState.size, (appendStyle, value)=>{
        let style = {};
        if (value === 'grow') style = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: '100%'
        };
        if (value === 'auto') style = {
            flexBasis: 'auto',
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 'none',
            width: 'auto'
        };
        if (typeof value === 'number') style = {
            flexGrow: 0,
            flexBasis: 'auto',
            width: `calc(100% * ${value} / var(${$bd7fb721dfb6dcf0$var$parentColumnsVar}) - (var(${$bd7fb721dfb6dcf0$var$parentColumnsVar}) - ${value}) * (var(${$bd7fb721dfb6dcf0$var$getParentSpacingVar('column')}) / var(${$bd7fb721dfb6dcf0$var$parentColumnsVar})))`
        };
        appendStyle(styles, style);
    });
    return styles;
};
module.exports.generateGridSizeStyles = $bd7fb721dfb6dcf0$var$generateGridSizeStyles;
const $bd7fb721dfb6dcf0$var$generateGridOffsetStyles = ({ theme: theme, ownerState: ownerState })=>{
    const styles = {};
    (0, $99OVR.traverseBreakpoints)(theme.breakpoints, ownerState.offset, (appendStyle, value)=>{
        let style = {};
        if (value === 'auto') style = {
            marginLeft: 'auto'
        };
        if (typeof value === 'number') style = {
            marginLeft: value === 0 ? '0px' : `calc(100% * ${value} / var(${$bd7fb721dfb6dcf0$var$parentColumnsVar}) + var(${$bd7fb721dfb6dcf0$var$getParentSpacingVar('column')}) * ${value} / var(${$bd7fb721dfb6dcf0$var$parentColumnsVar}))`
        };
        appendStyle(styles, style);
    });
    return styles;
};
module.exports.generateGridOffsetStyles = $bd7fb721dfb6dcf0$var$generateGridOffsetStyles;
const $bd7fb721dfb6dcf0$var$generateGridColumnsStyles = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {
        [$bd7fb721dfb6dcf0$var$selfColumnsVar]: 12
    };
    (0, $99OVR.traverseBreakpoints)(theme.breakpoints, ownerState.columns, (appendStyle, value)=>{
        const columns = value ?? 12;
        appendStyle(styles, {
            [$bd7fb721dfb6dcf0$var$selfColumnsVar]: columns,
            '> *': {
                [$bd7fb721dfb6dcf0$var$parentColumnsVar]: columns
            }
        });
    });
    return styles;
};
module.exports.generateGridColumnsStyles = $bd7fb721dfb6dcf0$var$generateGridColumnsStyles;
const $bd7fb721dfb6dcf0$var$generateGridRowSpacingStyles = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $99OVR.traverseBreakpoints)(theme.breakpoints, ownerState.rowSpacing, (appendStyle, value)=>{
        const spacing = typeof value === 'string' ? value : theme.spacing?.(value);
        appendStyle(styles, {
            [$bd7fb721dfb6dcf0$var$getSelfSpacingVar('row')]: spacing,
            '> *': {
                [$bd7fb721dfb6dcf0$var$getParentSpacingVar('row')]: spacing
            }
        });
    });
    return styles;
};
module.exports.generateGridRowSpacingStyles = $bd7fb721dfb6dcf0$var$generateGridRowSpacingStyles;
const $bd7fb721dfb6dcf0$var$generateGridColumnSpacingStyles = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $99OVR.traverseBreakpoints)(theme.breakpoints, ownerState.columnSpacing, (appendStyle, value)=>{
        const spacing = typeof value === 'string' ? value : theme.spacing?.(value);
        appendStyle(styles, {
            [$bd7fb721dfb6dcf0$var$getSelfSpacingVar('column')]: spacing,
            '> *': {
                [$bd7fb721dfb6dcf0$var$getParentSpacingVar('column')]: spacing
            }
        });
    });
    return styles;
};
module.exports.generateGridColumnSpacingStyles = $bd7fb721dfb6dcf0$var$generateGridColumnSpacingStyles;
const $bd7fb721dfb6dcf0$var$generateGridDirectionStyles = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $99OVR.traverseBreakpoints)(theme.breakpoints, ownerState.direction, (appendStyle, value)=>{
        appendStyle(styles, {
            flexDirection: value
        });
    });
    return styles;
};
module.exports.generateGridDirectionStyles = $bd7fb721dfb6dcf0$var$generateGridDirectionStyles;
const $bd7fb721dfb6dcf0$var$generateGridStyles = ({ ownerState: ownerState })=>{
    return {
        minWidth: 0,
        boxSizing: 'border-box',
        ...ownerState.container && {
            display: 'flex',
            flexWrap: 'wrap',
            ...ownerState.wrap && ownerState.wrap !== 'wrap' && {
                flexWrap: ownerState.wrap
            },
            gap: `var(${$bd7fb721dfb6dcf0$var$getSelfSpacingVar('row')}) var(${$bd7fb721dfb6dcf0$var$getSelfSpacingVar('column')})`
        }
    };
};
module.exports.generateGridStyles = $bd7fb721dfb6dcf0$var$generateGridStyles;
const $bd7fb721dfb6dcf0$var$generateSizeClassNames = (size)=>{
    const classNames = [];
    Object.entries(size).forEach(([key, value])=>{
        if (value !== false && value !== undefined) classNames.push(`grid-${key}-${String(value)}`);
    });
    return classNames;
};
module.exports.generateSizeClassNames = $bd7fb721dfb6dcf0$var$generateSizeClassNames;
const $bd7fb721dfb6dcf0$var$generateSpacingClassNames = (spacing, smallestBreakpoint = 'xs')=>{
    function isValidSpacing(val) {
        if (val === undefined) return false;
        return typeof val === 'string' && !Number.isNaN(Number(val)) || typeof val === 'number' && val > 0;
    }
    if (isValidSpacing(spacing)) return [
        `spacing-${smallestBreakpoint}-${String(spacing)}`
    ];
    if (typeof spacing === 'object' && !Array.isArray(spacing)) {
        const classNames = [];
        Object.entries(spacing).forEach(([key, value])=>{
            if (isValidSpacing(value)) classNames.push(`spacing-${key}-${String(value)}`);
        });
        return classNames;
    }
    return [];
};
module.exports.generateSpacingClassNames = $bd7fb721dfb6dcf0$var$generateSpacingClassNames;
const $bd7fb721dfb6dcf0$var$generateDirectionClasses = (direction)=>{
    if (direction === undefined) return [];
    if (typeof direction === 'object') return Object.entries(direction).map(([key, value])=>`direction-${key}-${value}`);
    return [
        `direction-xs-${String(direction)}`
    ];
};
module.exports.generateDirectionClasses = $bd7fb721dfb6dcf0$var$generateDirectionClasses;

});
parcelRegister("99OVR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.traverseBreakpoints = module.exports.filterBreakpointKeys = void 0;
const $6aac76618a3aa479$var$filterBreakpointKeys = (breakpointsKeys, responsiveKeys)=>breakpointsKeys.filter((key)=>responsiveKeys.includes(key));
module.exports.filterBreakpointKeys = $6aac76618a3aa479$var$filterBreakpointKeys;
const $6aac76618a3aa479$var$traverseBreakpoints = (breakpoints, responsive, iterator)=>{
    const smallestBreakpoint = breakpoints.keys[0]; // the keys is sorted from smallest to largest by `createBreakpoints`.
    if (Array.isArray(responsive)) responsive.forEach((breakpointValue, index)=>{
        iterator((responsiveStyles, style)=>{
            if (index <= breakpoints.keys.length - 1) {
                if (index === 0) Object.assign(responsiveStyles, style);
                else responsiveStyles[breakpoints.up(breakpoints.keys[index])] = style;
            }
        }, breakpointValue);
    });
    else if (responsive && typeof responsive === 'object') {
        // prevent null
        // responsive could be a very big object, pick the smallest responsive values
        const keys = Object.keys(responsive).length > breakpoints.keys.length ? breakpoints.keys : $6aac76618a3aa479$var$filterBreakpointKeys(breakpoints.keys, Object.keys(responsive));
        keys.forEach((key)=>{
            if (breakpoints.keys.includes(key)) {
                // @ts-ignore already checked that responsive is an object
                const breakpointValue = responsive[key];
                if (breakpointValue !== undefined) iterator((responsiveStyles, style)=>{
                    if (smallestBreakpoint === key) Object.assign(responsiveStyles, style);
                    else responsiveStyles[breakpoints.up(key)] = style;
                }, breakpointValue);
            }
        });
    } else if (typeof responsive === 'number' || typeof responsive === 'string') iterator((responsiveStyles, style)=>{
        Object.assign(responsiveStyles, style);
    }, responsive);
};
module.exports.traverseBreakpoints = $6aac76618a3aa479$var$traverseBreakpoints;

});


parcelRegister("g9pbx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bc2105d70693a6c1$var$deleteLegacyGridProps;
const $bc2105d70693a6c1$var$getLegacyGridWarning = (propName)=>{
    if ([
        'item',
        'zeroMinWidth'
    ].includes(propName)) return `The \`${propName}\` prop has been removed and is no longer necessary. You can safely remove it.`;
    // #host-reference
    return `The \`${propName}\` prop has been removed. See https://v7.mui.com/material-ui/migration/upgrade-to-grid-v2/ for migration instructions.`;
};
const $bc2105d70693a6c1$var$warnedAboutProps = [];
/**
 * Deletes the legacy Grid component props from the `props` object and warns once about them if found.
 *
 * @param {object} props The props object to remove the legacy Grid props from.
 * @param {Breakpoints} breakpoints The breakpoints object.
 */ function $bc2105d70693a6c1$var$deleteLegacyGridProps(props, breakpoints) {
    const propsToWarn = [];
    if (props.item !== undefined) {
        delete props.item;
        propsToWarn.push('item');
    }
    if (props.zeroMinWidth !== undefined) {
        delete props.zeroMinWidth;
        propsToWarn.push('zeroMinWidth');
    }
    breakpoints.keys.forEach((breakpoint)=>{
        if (props[breakpoint] !== undefined) {
            propsToWarn.push(breakpoint);
            delete props[breakpoint];
        }
    });
    propsToWarn.forEach((prop)=>{
        if (!$bc2105d70693a6c1$var$warnedAboutProps.includes(prop)) {
            $bc2105d70693a6c1$var$warnedAboutProps.push(prop);
            console.warn(`MUI Grid: ${$bc2105d70693a6c1$var$getLegacyGridWarning(prop)}\n`);
        }
    });
}

});



parcelRegister("gxueG", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $c0a72ea334f236a5$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $c0a72ea334f236a5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $c0a72ea334f236a5$var$_exportNames = {
    createGrid: true,
    gridClasses: true,
    unstable_traverseBreakpoints: true,
    unstable_generateDirectionClasses: true,
    unstable_generateSizeClassNames: true,
    unstable_generateSpacingClassNames: true
};
Object.defineProperty(module.exports, "createGrid", {
    enumerable: true,
    get: function() {
        return $c0a72ea334f236a5$var$_createGrid.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $c0a72ea334f236a5$var$_Grid.default;
    }
});
Object.defineProperty(module.exports, "gridClasses", {
    enumerable: true,
    get: function() {
        return $c0a72ea334f236a5$var$_gridClasses.default;
    }
});
Object.defineProperty(module.exports, "unstable_generateDirectionClasses", {
    enumerable: true,
    get: function() {
        return $ggHhD.generateDirectionClasses;
    }
});
Object.defineProperty(module.exports, "unstable_generateSizeClassNames", {
    enumerable: true,
    get: function() {
        return $ggHhD.generateSizeClassNames;
    }
});
Object.defineProperty(module.exports, "unstable_generateSpacingClassNames", {
    enumerable: true,
    get: function() {
        return $ggHhD.generateSpacingClassNames;
    }
});
Object.defineProperty(module.exports, "unstable_traverseBreakpoints", {
    enumerable: true,
    get: function() {
        return $99OVR.traverseBreakpoints;
    }
});

var $c0a72ea334f236a5$var$_Grid = $c0a72ea334f236a5$require$_interopRequireDefault((parcelRequire("dy2yf")));

var $c0a72ea334f236a5$var$_createGrid = $c0a72ea334f236a5$require$_interopRequireDefault((parcelRequire("h0TiG")));

var $9GB8a = parcelRequire("9GB8a");
Object.keys($9GB8a).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($c0a72ea334f236a5$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $9GB8a[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9GB8a[key];
        }
    });
});

var $c0a72ea334f236a5$var$_gridClasses = $c0a72ea334f236a5$require$_interopRequireWildcard((parcelRequire("8HLwS")));
Object.keys($c0a72ea334f236a5$var$_gridClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($c0a72ea334f236a5$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $c0a72ea334f236a5$var$_gridClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $c0a72ea334f236a5$var$_gridClasses[key];
        }
    });
});

var $99OVR = parcelRequire("99OVR");

var $ggHhD = parcelRequire("ggHhD");

});
parcelRegister("9GB8a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("8HLwS", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $65673535bf7c146f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getGridUtilityClass = $65673535bf7c146f$var$getGridUtilityClass;

var $65673535bf7c146f$var$_generateUtilityClasses = $65673535bf7c146f$require$_interopRequireDefault((parcelRequire("5nY49")));

var $65673535bf7c146f$var$_generateUtilityClass = $65673535bf7c146f$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $65673535bf7c146f$var$getGridUtilityClass(slot) {
    return (0, $65673535bf7c146f$var$_generateUtilityClass.default)('MuiGrid', slot);
}
const $65673535bf7c146f$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $65673535bf7c146f$var$DIRECTIONS = [
    'column-reverse',
    'column',
    'row-reverse',
    'row'
];
const $65673535bf7c146f$var$WRAPS = [
    'nowrap',
    'wrap-reverse',
    'wrap'
];
const $65673535bf7c146f$var$GRID_SIZES = [
    'auto',
    'grow',
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $65673535bf7c146f$var$gridClasses = (0, $65673535bf7c146f$var$_generateUtilityClasses.default)('MuiGrid', [
    'root',
    'container',
    'item',
    // spacings
    ...$65673535bf7c146f$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...$65673535bf7c146f$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...$65673535bf7c146f$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...$65673535bf7c146f$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$65673535bf7c146f$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$65673535bf7c146f$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$65673535bf7c146f$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$65673535bf7c146f$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $65673535bf7c146f$var$_default = module.exports.default = $65673535bf7c146f$var$gridClasses;

});


parcelRegister("kgIUX", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $ec1824feff65c009$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ec1824feff65c009$var$_propTypes = $ec1824feff65c009$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $ec1824feff65c009$var$_createStack = $ec1824feff65c009$require$_interopRequireDefault((parcelRequire("4N1IS")));
/**
 *
 * Demos:
 *
 * - [Stack (Joy UI)](https://mui.com/joy-ui/react-stack/)
 * - [Stack (Material UI)](https://mui.com/material-ui/react-stack/)
 * - [Stack (MUI System)](https://mui.com/system/react-stack/)
 *
 * API:
 *
 * - [Stack API](https://mui.com/system/api/stack/)
 */ const $ec1824feff65c009$var$Stack = (0, $ec1824feff65c009$var$_createStack.default)();
$ec1824feff65c009$var$Stack.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: $ec1824feff65c009$var$_propTypes.default.node,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $ec1824feff65c009$var$_propTypes.default.elementType,
    /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'column'
   */ direction: $ec1824feff65c009$var$_propTypes.default.oneOfType([
        $ec1824feff65c009$var$_propTypes.default.oneOf([
            'column-reverse',
            'column',
            'row-reverse',
            'row'
        ]),
        $ec1824feff65c009$var$_propTypes.default.arrayOf($ec1824feff65c009$var$_propTypes.default.oneOf([
            'column-reverse',
            'column',
            'row-reverse',
            'row'
        ])),
        $ec1824feff65c009$var$_propTypes.default.object
    ]),
    /**
   * Add an element between each child.
   */ divider: $ec1824feff65c009$var$_propTypes.default.node,
    /**
   * Defines the space between immediate children.
   * @default 0
   */ spacing: $ec1824feff65c009$var$_propTypes.default.oneOfType([
        $ec1824feff65c009$var$_propTypes.default.arrayOf($ec1824feff65c009$var$_propTypes.default.oneOfType([
            $ec1824feff65c009$var$_propTypes.default.number,
            $ec1824feff65c009$var$_propTypes.default.string
        ])),
        $ec1824feff65c009$var$_propTypes.default.number,
        $ec1824feff65c009$var$_propTypes.default.object,
        $ec1824feff65c009$var$_propTypes.default.string
    ]),
    /**
   * The system prop, which allows defining system overrides as well as additional CSS styles.
   */ sx: $ec1824feff65c009$var$_propTypes.default.oneOfType([
        $ec1824feff65c009$var$_propTypes.default.arrayOf($ec1824feff65c009$var$_propTypes.default.oneOfType([
            $ec1824feff65c009$var$_propTypes.default.func,
            $ec1824feff65c009$var$_propTypes.default.object,
            $ec1824feff65c009$var$_propTypes.default.bool
        ])),
        $ec1824feff65c009$var$_propTypes.default.func,
        $ec1824feff65c009$var$_propTypes.default.object
    ]),
    /**
   * If `true`, the CSS flexbox `gap` is used instead of applying `margin` to children.
   *
   * While CSS `gap` removes the [known limitations](https://mui.com/joy-ui/react-stack/#limitations),
   * it is not fully supported in some browsers. We recommend checking https://caniuse.com/?search=flex%20gap before using this flag.
   *
   * To enable this flag globally, follow the theme's default props configuration.
   * @default false
   */ useFlexGap: $ec1824feff65c009$var$_propTypes.default.bool
};
var $ec1824feff65c009$var$_default = module.exports.default = $ec1824feff65c009$var$Stack;

});
parcelRegister("4N1IS", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $37cd131ec442ac03$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $37cd131ec442ac03$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $37cd131ec442ac03$var$createStack;
module.exports.style = void 0;

var $37cd131ec442ac03$var$React = $37cd131ec442ac03$require$_interopRequireWildcard((parcelRequire("acw62")));

var $37cd131ec442ac03$var$_propTypes = $37cd131ec442ac03$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $37cd131ec442ac03$var$_clsx = $37cd131ec442ac03$require$_interopRequireDefault((parcelRequire("9QePP")));

var $37cd131ec442ac03$var$_deepmerge = $37cd131ec442ac03$require$_interopRequireDefault((parcelRequire("bQ4jM")));

var $37cd131ec442ac03$var$_generateUtilityClass = $37cd131ec442ac03$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $37cd131ec442ac03$var$_composeClasses = $37cd131ec442ac03$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $37cd131ec442ac03$var$_styled = $37cd131ec442ac03$require$_interopRequireDefault((parcelRequire("kpukb")));

var $37cd131ec442ac03$var$_useThemeProps = $37cd131ec442ac03$require$_interopRequireDefault((parcelRequire("2LgDM")));

var $l6FST = parcelRequire("l6FST");

var $37cd131ec442ac03$var$_createTheme = $37cd131ec442ac03$require$_interopRequireDefault((parcelRequire("1dhnG")));

var $9mzYC = parcelRequire("9mzYC");

var $8ZgMs = parcelRequire("8ZgMs");

var $ayMG0 = parcelRequire("ayMG0");
const $37cd131ec442ac03$var$defaultTheme = (0, $37cd131ec442ac03$var$_createTheme.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $37cd131ec442ac03$var$defaultCreateStyledComponent = (0, $37cd131ec442ac03$var$_styled.default)('div', {
    name: 'MuiStack',
    slot: 'Root'
});
function $37cd131ec442ac03$var$useThemePropsDefault(props) {
    return (0, $37cd131ec442ac03$var$_useThemeProps.default)({
        props: props,
        name: 'MuiStack',
        defaultTheme: $37cd131ec442ac03$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $37cd131ec442ac03$var$joinChildren(children, separator) {
    const childrenArray = $37cd131ec442ac03$var$React.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $37cd131ec442ac03$var$React.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $37cd131ec442ac03$var$getSideFromDirection = (direction)=>{
    return ({
        row: 'Left',
        'row-reverse': 'Right',
        column: 'Top',
        'column-reverse': 'Bottom'
    })[direction];
};
const $37cd131ec442ac03$var$style = ({ ownerState: ownerState, theme: theme })=>{
    let styles = {
        display: 'flex',
        flexDirection: 'column',
        ...(0, $9mzYC.handleBreakpoints)({
            theme: theme
        }, (0, $9mzYC.resolveBreakpointValues)({
            values: ownerState.direction,
            breakpoints: theme.breakpoints.values
        }), (propValue)=>({
                flexDirection: propValue
            }))
    };
    if (ownerState.spacing) {
        const transformer = (0, $8ZgMs.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === 'object' && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === 'object' && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $9mzYC.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $9mzYC.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === 'object') Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : 'column';
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $8ZgMs.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                '& > :not(style):not(style)': {
                    margin: 0
                },
                '& > :not(style) ~ :not(style)': {
                    [`margin${$37cd131ec442ac03$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $8ZgMs.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $37cd131ec442ac03$var$_deepmerge.default)(styles, (0, $9mzYC.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $9mzYC.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
module.exports.style = $37cd131ec442ac03$var$style;
function $37cd131ec442ac03$var$createStack(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $37cd131ec442ac03$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $37cd131ec442ac03$var$useThemePropsDefault, componentName: componentName = 'MuiStack' } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                'root'
            ]
        };
        return (0, $37cd131ec442ac03$var$_composeClasses.default)(slots, (slot)=>(0, $37cd131ec442ac03$var$_generateUtilityClass.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($37cd131ec442ac03$var$style);
    const Stack = /*#__PURE__*/ $37cd131ec442ac03$var$React.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $l6FST.extendSxProp)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = 'div', direction: direction = 'column', spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false, ...other } = props;
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $ayMG0.jsx)(StackRoot, {
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $37cd131ec442ac03$var$_clsx.default)(classes.root, className),
            ...other,
            children: divider ? $37cd131ec442ac03$var$joinChildren(children, divider) : children
        });
    });
    Stack.propTypes = {
        children: $37cd131ec442ac03$var$_propTypes.default.node,
        direction: $37cd131ec442ac03$var$_propTypes.default.oneOfType([
            $37cd131ec442ac03$var$_propTypes.default.oneOf([
                'column-reverse',
                'column',
                'row-reverse',
                'row'
            ]),
            $37cd131ec442ac03$var$_propTypes.default.arrayOf($37cd131ec442ac03$var$_propTypes.default.oneOf([
                'column-reverse',
                'column',
                'row-reverse',
                'row'
            ])),
            $37cd131ec442ac03$var$_propTypes.default.object
        ]),
        divider: $37cd131ec442ac03$var$_propTypes.default.node,
        spacing: $37cd131ec442ac03$var$_propTypes.default.oneOfType([
            $37cd131ec442ac03$var$_propTypes.default.arrayOf($37cd131ec442ac03$var$_propTypes.default.oneOfType([
                $37cd131ec442ac03$var$_propTypes.default.number,
                $37cd131ec442ac03$var$_propTypes.default.string
            ])),
            $37cd131ec442ac03$var$_propTypes.default.number,
            $37cd131ec442ac03$var$_propTypes.default.object,
            $37cd131ec442ac03$var$_propTypes.default.string
        ]),
        sx: $37cd131ec442ac03$var$_propTypes.default.oneOfType([
            $37cd131ec442ac03$var$_propTypes.default.arrayOf($37cd131ec442ac03$var$_propTypes.default.oneOfType([
                $37cd131ec442ac03$var$_propTypes.default.func,
                $37cd131ec442ac03$var$_propTypes.default.object,
                $37cd131ec442ac03$var$_propTypes.default.bool
            ])),
            $37cd131ec442ac03$var$_propTypes.default.func,
            $37cd131ec442ac03$var$_propTypes.default.object
        ])
    };
    return Stack;
}

});


parcelRegister("106Hq", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $0baafce1ff534af1$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $0baafce1ff534af1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $0baafce1ff534af1$var$_exportNames = {
    createStack: true,
    stackClasses: true
};
Object.defineProperty(module.exports, "createStack", {
    enumerable: true,
    get: function() {
        return $0baafce1ff534af1$var$_createStack.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $0baafce1ff534af1$var$_Stack.default;
    }
});
Object.defineProperty(module.exports, "stackClasses", {
    enumerable: true,
    get: function() {
        return $0baafce1ff534af1$var$_stackClasses.default;
    }
});

var $0baafce1ff534af1$var$_Stack = $0baafce1ff534af1$require$_interopRequireDefault((parcelRequire("kgIUX")));

var $0baafce1ff534af1$var$_createStack = $0baafce1ff534af1$require$_interopRequireDefault((parcelRequire("4N1IS")));

var $19rVF = parcelRequire("19rVF");
Object.keys($19rVF).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($0baafce1ff534af1$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $19rVF[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $19rVF[key];
        }
    });
});

var $0baafce1ff534af1$var$_stackClasses = $0baafce1ff534af1$require$_interopRequireWildcard((parcelRequire("eh1Yu")));
Object.keys($0baafce1ff534af1$var$_stackClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($0baafce1ff534af1$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $0baafce1ff534af1$var$_stackClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $0baafce1ff534af1$var$_stackClasses[key];
        }
    });
});

});
parcelRegister("19rVF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("eh1Yu", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a6442f55ec27dd44$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getStackUtilityClass = $a6442f55ec27dd44$var$getStackUtilityClass;

var $a6442f55ec27dd44$var$_generateUtilityClasses = $a6442f55ec27dd44$require$_interopRequireDefault((parcelRequire("5nY49")));

var $a6442f55ec27dd44$var$_generateUtilityClass = $a6442f55ec27dd44$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $a6442f55ec27dd44$var$getStackUtilityClass(slot) {
    return (0, $a6442f55ec27dd44$var$_generateUtilityClass.default)('MuiStack', slot);
}
const $a6442f55ec27dd44$var$stackClasses = (0, $a6442f55ec27dd44$var$_generateUtilityClasses.default)('MuiStack', [
    'root'
]);
var $a6442f55ec27dd44$var$_default = module.exports.default = $a6442f55ec27dd44$var$stackClasses;

});




parcelRegister("68N2H", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $47898848065fef37$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "unstable_createBreakpoints", {
    enumerable: true,
    get: function() {
        return $47898848065fef37$var$_createBreakpoints.default;
    }
});

var $47898848065fef37$var$_createBreakpoints = $47898848065fef37$require$_interopRequireDefault((parcelRequire("hVW0x")));

});

parcelRegister("ijOKP", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d5615f18e5cd04fc$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d5615f18e5cd04fc$var$createTheme;

var $d5615f18e5cd04fc$var$_createPalette = $d5615f18e5cd04fc$require$_interopRequireDefault((parcelRequire("4Gk6P")));

var $d5615f18e5cd04fc$var$_createThemeWithVars = $d5615f18e5cd04fc$require$_interopRequireDefault((parcelRequire("eLI0w")));

var $d5615f18e5cd04fc$var$_createThemeNoVars = $d5615f18e5cd04fc$require$_interopRequireDefault((parcelRequire("8v3fy")));
// eslint-disable-next-line consistent-return
function $d5615f18e5cd04fc$var$attachColorScheme(theme, scheme, colorScheme) {
    if (!theme.colorSchemes) return undefined;
    if (colorScheme) theme.colorSchemes[scheme] = {
        ...colorScheme !== true && colorScheme,
        palette: (0, $d5615f18e5cd04fc$var$_createPalette.default)({
            ...colorScheme === true ? {} : colorScheme.palette,
            mode: scheme
        }) // cast type to skip module augmentation test
    };
}
/**
 * Generate a theme base on the options received.
 * @param options Takes an incomplete theme object and adds the missing parts.
 * @param args Deep merge the arguments with the about to be returned theme.
 * @returns A complete, ready-to-use theme object.
 */ function $d5615f18e5cd04fc$var$createTheme(options = {}, // cast type to skip module augmentation test
...args) {
    const { palette: palette, cssVariables: cssVariables = false, colorSchemes: initialColorSchemes = !palette ? {
        light: true
    } : undefined, defaultColorScheme: initialDefaultColorScheme = palette?.mode, ...other } = options;
    const defaultColorSchemeInput = initialDefaultColorScheme || 'light';
    const defaultScheme = initialColorSchemes?.[defaultColorSchemeInput];
    const colorSchemesInput = {
        ...initialColorSchemes,
        ...palette ? {
            [defaultColorSchemeInput]: {
                ...typeof defaultScheme !== 'boolean' && defaultScheme,
                palette: palette
            }
        } : undefined
    };
    if (cssVariables === false) {
        if (!('colorSchemes' in options)) // Behaves exactly as v5
        return (0, $d5615f18e5cd04fc$var$_createThemeNoVars.default)(options, ...args);
        let paletteOptions = palette;
        if (!('palette' in options)) {
            if (colorSchemesInput[defaultColorSchemeInput]) {
                if (colorSchemesInput[defaultColorSchemeInput] !== true) paletteOptions = colorSchemesInput[defaultColorSchemeInput].palette;
                else if (defaultColorSchemeInput === 'dark') // @ts-ignore to prevent the module augmentation test from failing
                paletteOptions = {
                    mode: 'dark'
                };
            }
        }
        const theme = (0, $d5615f18e5cd04fc$var$_createThemeNoVars.default)({
            ...options,
            palette: paletteOptions
        }, ...args);
        theme.defaultColorScheme = defaultColorSchemeInput;
        theme.colorSchemes = colorSchemesInput;
        if (theme.palette.mode === 'light') {
            theme.colorSchemes.light = {
                ...colorSchemesInput.light !== true && colorSchemesInput.light,
                palette: theme.palette
            };
            $d5615f18e5cd04fc$var$attachColorScheme(theme, 'dark', colorSchemesInput.dark);
        }
        if (theme.palette.mode === 'dark') {
            theme.colorSchemes.dark = {
                ...colorSchemesInput.dark !== true && colorSchemesInput.dark,
                palette: theme.palette
            };
            $d5615f18e5cd04fc$var$attachColorScheme(theme, 'light', colorSchemesInput.light);
        }
        return theme;
    }
    if (!palette && !('light' in colorSchemesInput) && defaultColorSchemeInput === 'light') colorSchemesInput.light = true;
    return (0, $d5615f18e5cd04fc$var$_createThemeWithVars.default)({
        ...other,
        colorSchemes: colorSchemesInput,
        defaultColorScheme: defaultColorSchemeInput,
        ...typeof cssVariables !== 'boolean' && cssVariables
    }, ...args);
}

});
parcelRegister("4Gk6P", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $368aaef25f6a2997$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.contrastColor = $368aaef25f6a2997$var$contrastColor;
module.exports.dark = void 0;
module.exports.default = $368aaef25f6a2997$var$createPalette;
module.exports.light = void 0;

var $368aaef25f6a2997$var$_formatMuiErrorMessage = $368aaef25f6a2997$require$_interopRequireDefault((parcelRequire("4Z6Nd")));

var $368aaef25f6a2997$var$_deepmerge = $368aaef25f6a2997$require$_interopRequireDefault((parcelRequire("bQ4jM")));

var $h61zw = parcelRequire("h61zw");

var $368aaef25f6a2997$var$_common = $368aaef25f6a2997$require$_interopRequireDefault((parcelRequire("dzxhF")));

var $368aaef25f6a2997$var$_grey = $368aaef25f6a2997$require$_interopRequireDefault((parcelRequire("eU5ou")));

var $368aaef25f6a2997$var$_purple = $368aaef25f6a2997$require$_interopRequireDefault((parcelRequire("kSXRh")));

var $368aaef25f6a2997$var$_red = $368aaef25f6a2997$require$_interopRequireDefault((parcelRequire("ln9F4")));

var $368aaef25f6a2997$var$_orange = $368aaef25f6a2997$require$_interopRequireDefault((parcelRequire("dMYym")));

var $368aaef25f6a2997$var$_blue = $368aaef25f6a2997$require$_interopRequireDefault((parcelRequire("bKnBV")));

var $368aaef25f6a2997$var$_lightBlue = $368aaef25f6a2997$require$_interopRequireDefault((parcelRequire("iDVue")));

var $368aaef25f6a2997$var$_green = $368aaef25f6a2997$require$_interopRequireDefault((parcelRequire("e4nxq")));
function $368aaef25f6a2997$var$getLight() {
    return {
        // The colors used to style the text.
        text: {
            // The most important text.
            primary: 'rgba(0, 0, 0, 0.87)',
            // Secondary text.
            secondary: 'rgba(0, 0, 0, 0.6)',
            // Disabled text have even lower visual prominence.
            disabled: 'rgba(0, 0, 0, 0.38)'
        },
        // The color used to divide different elements.
        divider: 'rgba(0, 0, 0, 0.12)',
        // The background colors used to style the surfaces.
        // Consistency between these values is important.
        background: {
            paper: $368aaef25f6a2997$var$_common.default.white,
            default: $368aaef25f6a2997$var$_common.default.white
        },
        // The colors used to style the action elements.
        action: {
            // The color of an active action like an icon button.
            active: 'rgba(0, 0, 0, 0.54)',
            // The color of an hovered action.
            hover: 'rgba(0, 0, 0, 0.04)',
            hoverOpacity: 0.04,
            // The color of a selected action.
            selected: 'rgba(0, 0, 0, 0.08)',
            selectedOpacity: 0.08,
            // The color of a disabled action.
            disabled: 'rgba(0, 0, 0, 0.26)',
            // The background color of a disabled action.
            disabledBackground: 'rgba(0, 0, 0, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(0, 0, 0, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.12
        }
    };
}
const $368aaef25f6a2997$var$light = module.exports.light = $368aaef25f6a2997$var$getLight();
function $368aaef25f6a2997$var$getDark() {
    return {
        text: {
            primary: $368aaef25f6a2997$var$_common.default.white,
            secondary: 'rgba(255, 255, 255, 0.7)',
            disabled: 'rgba(255, 255, 255, 0.5)',
            icon: 'rgba(255, 255, 255, 0.5)'
        },
        divider: 'rgba(255, 255, 255, 0.12)',
        background: {
            paper: '#121212',
            default: '#121212'
        },
        action: {
            active: $368aaef25f6a2997$var$_common.default.white,
            hover: 'rgba(255, 255, 255, 0.08)',
            hoverOpacity: 0.08,
            selected: 'rgba(255, 255, 255, 0.16)',
            selectedOpacity: 0.16,
            disabled: 'rgba(255, 255, 255, 0.3)',
            disabledBackground: 'rgba(255, 255, 255, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(255, 255, 255, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.24
        }
    };
}
const $368aaef25f6a2997$var$dark = module.exports.dark = $368aaef25f6a2997$var$getDark();
function $368aaef25f6a2997$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $h61zw.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $h61zw.darken)(intent.main, tonalOffsetDark);
    }
}
function $368aaef25f6a2997$var$mixLightOrDark(colorSpace, intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = `color-mix(in ${colorSpace}, ${intent.main}, #fff ${(tonalOffsetLight * 100).toFixed(0)}%)`;
        else if (direction === 'dark') intent.dark = `color-mix(in ${colorSpace}, ${intent.main}, #000 ${(tonalOffsetDark * 100).toFixed(0)}%)`;
    }
}
function $368aaef25f6a2997$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: $368aaef25f6a2997$var$_blue.default[200],
        light: $368aaef25f6a2997$var$_blue.default[50],
        dark: $368aaef25f6a2997$var$_blue.default[400]
    };
    return {
        main: $368aaef25f6a2997$var$_blue.default[700],
        light: $368aaef25f6a2997$var$_blue.default[400],
        dark: $368aaef25f6a2997$var$_blue.default[800]
    };
}
function $368aaef25f6a2997$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: $368aaef25f6a2997$var$_purple.default[200],
        light: $368aaef25f6a2997$var$_purple.default[50],
        dark: $368aaef25f6a2997$var$_purple.default[400]
    };
    return {
        main: $368aaef25f6a2997$var$_purple.default[500],
        light: $368aaef25f6a2997$var$_purple.default[300],
        dark: $368aaef25f6a2997$var$_purple.default[700]
    };
}
function $368aaef25f6a2997$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: $368aaef25f6a2997$var$_red.default[500],
        light: $368aaef25f6a2997$var$_red.default[300],
        dark: $368aaef25f6a2997$var$_red.default[700]
    };
    return {
        main: $368aaef25f6a2997$var$_red.default[700],
        light: $368aaef25f6a2997$var$_red.default[400],
        dark: $368aaef25f6a2997$var$_red.default[800]
    };
}
function $368aaef25f6a2997$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: $368aaef25f6a2997$var$_lightBlue.default[400],
        light: $368aaef25f6a2997$var$_lightBlue.default[300],
        dark: $368aaef25f6a2997$var$_lightBlue.default[700]
    };
    return {
        main: $368aaef25f6a2997$var$_lightBlue.default[700],
        light: $368aaef25f6a2997$var$_lightBlue.default[500],
        dark: $368aaef25f6a2997$var$_lightBlue.default[900]
    };
}
function $368aaef25f6a2997$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: $368aaef25f6a2997$var$_green.default[400],
        light: $368aaef25f6a2997$var$_green.default[300],
        dark: $368aaef25f6a2997$var$_green.default[700]
    };
    return {
        main: $368aaef25f6a2997$var$_green.default[800],
        light: $368aaef25f6a2997$var$_green.default[500],
        dark: $368aaef25f6a2997$var$_green.default[900]
    };
}
function $368aaef25f6a2997$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: $368aaef25f6a2997$var$_orange.default[400],
        light: $368aaef25f6a2997$var$_orange.default[300],
        dark: $368aaef25f6a2997$var$_orange.default[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: $368aaef25f6a2997$var$_orange.default[500],
        dark: $368aaef25f6a2997$var$_orange.default[900]
    };
}
// Use the same name as the experimental CSS `contrast-color` function.
function $368aaef25f6a2997$var$contrastColor(background) {
    return `oklch(from ${background} var(--__l) 0 h / var(--__a))`;
}
function $368aaef25f6a2997$var$createPalette(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2, colorSpace: colorSpace, ...other } = palette;
    const primary = palette.primary || $368aaef25f6a2997$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $368aaef25f6a2997$var$getDefaultSecondary(mode);
    const error = palette.error || $368aaef25f6a2997$var$getDefaultError(mode);
    const info = palette.info || $368aaef25f6a2997$var$getDefaultInfo(mode);
    const success = palette.success || $368aaef25f6a2997$var$getDefaultSuccess(mode);
    const warning = palette.warning || $368aaef25f6a2997$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        if (colorSpace) return $368aaef25f6a2997$var$contrastColor(background);
        const contrastText = (0, $h61zw.getContrastRatio)(background, $368aaef25f6a2997$var$dark.text.primary) >= contrastThreshold ? $368aaef25f6a2997$var$dark.text.primary : $368aaef25f6a2997$var$light.text.primary;
        {
            const contrast = (0, $h61zw.getContrastRatio)(background, contrastText);
            if (contrast < 3) console.error([
                `MUI: The contrast ratio of ${contrast}:1 for ${contrastText} on ${background}`,
                'falls below the WCAG recommended absolute minimum contrast ratio of 3:1.',
                'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'
            ].join('\n'));
        }
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = {
            ...color
        };
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error(`MUI: The color${name ? ` (${name})` : ''} provided to augmentColor(color) is invalid.\n` + `The color object needs to have a \`main\` property or a \`${mainShade}\` property.`);
        if (typeof color.main !== 'string') throw new Error(`MUI: The color${name ? ` (${name})` : ''} provided to augmentColor(color) is invalid.\n` + `\`color.main\` should be a string, but \`${JSON.stringify(color.main)}\` was provided instead.\n` + '\n' + 'Did you intend to use one of the following approaches?\n' + '\n' + 'import { green } from "@mui/material/colors";\n' + '\n' + 'const theme1 = createTheme({ palette: {\n' + '  primary: green,\n' + '} });\n' + '\n' + 'const theme2 = createTheme({ palette: {\n' + '  primary: { main: green[500] },\n' + '} });');
        if (colorSpace) {
            $368aaef25f6a2997$var$mixLightOrDark(colorSpace, color, 'light', lightShade, tonalOffset);
            $368aaef25f6a2997$var$mixLightOrDark(colorSpace, color, 'dark', darkShade, tonalOffset);
        } else {
            $368aaef25f6a2997$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
            $368aaef25f6a2997$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        }
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    let modeHydrated;
    if (mode === 'light') modeHydrated = $368aaef25f6a2997$var$getLight();
    else if (mode === 'dark') modeHydrated = $368aaef25f6a2997$var$getDark();
    if (!modeHydrated) console.error(`MUI: The palette mode \`${mode}\` is not supported.`);
    const paletteOutput = (0, $368aaef25f6a2997$var$_deepmerge.default)({
        // A collection of common colors.
        common: {
            ...$368aaef25f6a2997$var$_common.default
        },
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        // The grey colors.
        grey: $368aaef25f6a2997$var$_grey.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset,
        // The light and dark mode object.
        ...modeHydrated
    }, other);
    return paletteOutput;
}

});
parcelRegister("dzxhF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $9e185cbbdd17e0f7$var$common = {
    black: '#000',
    white: '#fff'
};
var $9e185cbbdd17e0f7$var$_default = module.exports.default = $9e185cbbdd17e0f7$var$common;

});

parcelRegister("eU5ou", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $ad9a7ac9db04746c$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $ad9a7ac9db04746c$var$_default = module.exports.default = $ad9a7ac9db04746c$var$grey;

});

parcelRegister("kSXRh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $f34748703626d0dc$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $f34748703626d0dc$var$_default = module.exports.default = $f34748703626d0dc$var$purple;

});

parcelRegister("ln9F4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $f8f33d825c71610f$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $f8f33d825c71610f$var$_default = module.exports.default = $f8f33d825c71610f$var$red;

});

parcelRegister("dMYym", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $a09ebaae00c386da$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $a09ebaae00c386da$var$_default = module.exports.default = $a09ebaae00c386da$var$orange;

});

parcelRegister("bKnBV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $88d64e288ac9a70b$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $88d64e288ac9a70b$var$_default = module.exports.default = $88d64e288ac9a70b$var$blue;

});

parcelRegister("iDVue", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $d9287623794ffe70$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $d9287623794ffe70$var$_default = module.exports.default = $d9287623794ffe70$var$lightBlue;

});

parcelRegister("e4nxq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $a3e3b29cd31a116f$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $a3e3b29cd31a116f$var$_default = module.exports.default = $a3e3b29cd31a116f$var$green;

});


parcelRegister("eLI0w", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $ac07976fc01fdfa9$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $ac07976fc01fdfa9$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createGetCssVar = void 0;
module.exports.default = $ac07976fc01fdfa9$var$createThemeWithVars;

var $ac07976fc01fdfa9$var$_formatMuiErrorMessage = $ac07976fc01fdfa9$require$_interopRequireDefault((parcelRequire("4Z6Nd")));

var $ac07976fc01fdfa9$var$_deepmerge = $ac07976fc01fdfa9$require$_interopRequireDefault((parcelRequire("bQ4jM")));

var $izOUK = parcelRequire("izOUK");

var $8ZgMs = parcelRequire("8ZgMs");

var $fckAO = parcelRequire("fckAO");

var $ac07976fc01fdfa9$var$_styleFunctionSx = $ac07976fc01fdfa9$require$_interopRequireWildcard((parcelRequire("l6FST")));

var $h61zw = parcelRequire("h61zw");

var $ac07976fc01fdfa9$var$_createThemeNoVars = $ac07976fc01fdfa9$require$_interopRequireDefault((parcelRequire("8v3fy")));

var $ac07976fc01fdfa9$var$_createColorScheme = $ac07976fc01fdfa9$require$_interopRequireWildcard((parcelRequire("2JzIB")));

var $ac07976fc01fdfa9$var$_shouldSkipGeneratingVar = $ac07976fc01fdfa9$require$_interopRequireDefault((parcelRequire("fPRn6")));

var $ac07976fc01fdfa9$var$_createGetSelector = $ac07976fc01fdfa9$require$_interopRequireDefault((parcelRequire("9yYvT")));

var $2ICMq = parcelRequire("2ICMq");

var $4Gk6P = parcelRequire("4Gk6P");
function $ac07976fc01fdfa9$var$assignNode(obj, keys) {
    keys.forEach((k)=>{
        if (!obj[k]) obj[k] = {};
    });
}
function $ac07976fc01fdfa9$var$setColor(obj, key, defaultValue) {
    if (!obj[key] && defaultValue) obj[key] = defaultValue;
}
function $ac07976fc01fdfa9$var$toRgb(color) {
    if (typeof color !== 'string' || !color.startsWith('hsl')) return color;
    return (0, $h61zw.hslToRgb)(color);
}
function $ac07976fc01fdfa9$var$setColorChannel(obj, key) {
    if (!(`${key}Channel` in obj)) // custom channel token is not provided, generate one.
    // if channel token can't be generated, show a warning.
    obj[`${key}Channel`] = (0, $h61zw.private_safeColorChannel)($ac07976fc01fdfa9$var$toRgb(obj[key]), `MUI: Can't create \`palette.${key}Channel\` because \`palette.${key}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` + '\n' + `To suppress this warning, you need to explicitly provide the \`palette.${key}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`);
}
function $ac07976fc01fdfa9$var$getSpacingVal(spacingInput) {
    if (typeof spacingInput === 'number') return `${spacingInput}px`;
    if (typeof spacingInput === 'string' || typeof spacingInput === 'function' || Array.isArray(spacingInput)) return spacingInput;
    return '8px';
}
const $ac07976fc01fdfa9$var$silent = (fn)=>{
    try {
        return fn();
    } catch (error) {
    // ignore error
    }
    return undefined;
};
const $ac07976fc01fdfa9$var$createGetCssVar = (cssVarPrefix = 'mui')=>(0, $izOUK.unstable_createGetCssVar)(cssVarPrefix);
module.exports.createGetCssVar = $ac07976fc01fdfa9$var$createGetCssVar;
function $ac07976fc01fdfa9$var$attachColorScheme(colorSpace, colorSchemes, scheme, restTheme, colorScheme) {
    if (!scheme) return undefined;
    scheme = scheme === true ? {} : scheme;
    const mode = colorScheme === 'dark' ? 'dark' : 'light';
    if (!restTheme) {
        colorSchemes[colorScheme] = (0, $ac07976fc01fdfa9$var$_createColorScheme.default)({
            ...scheme,
            palette: {
                mode: mode,
                ...scheme?.palette
            },
            colorSpace: colorSpace
        });
        return undefined;
    }
    const { palette: palette, ...muiTheme } = (0, $ac07976fc01fdfa9$var$_createThemeNoVars.default)({
        ...restTheme,
        palette: {
            mode: mode,
            ...scheme?.palette
        },
        colorSpace: colorSpace
    });
    colorSchemes[colorScheme] = {
        ...scheme,
        palette: palette,
        opacity: {
            ...(0, $ac07976fc01fdfa9$var$_createColorScheme.getOpacity)(mode),
            ...scheme?.opacity
        },
        overlays: scheme?.overlays || (0, $ac07976fc01fdfa9$var$_createColorScheme.getOverlays)(mode)
    };
    return muiTheme;
}
/**
 * A default `createThemeWithVars` comes with a single color scheme, either `light` or `dark` based on the `defaultColorScheme`.
 * This is better suited for apps that only need a single color scheme.
 *
 * To enable built-in `light` and `dark` color schemes, either:
 * 1. provide a `colorSchemeSelector` to define how the color schemes will change.
 * 2. provide `colorSchemes.dark` will set `colorSchemeSelector: 'media'` by default.
 */ function $ac07976fc01fdfa9$var$createThemeWithVars(options = {}, ...args) {
    const { colorSchemes: colorSchemesInput = {
        light: true
    }, defaultColorScheme: defaultColorSchemeInput, disableCssColorScheme: disableCssColorScheme = false, cssVarPrefix: cssVarPrefix = 'mui', nativeColor: nativeColor = false, shouldSkipGeneratingVar: shouldSkipGeneratingVar = $ac07976fc01fdfa9$var$_shouldSkipGeneratingVar.default, colorSchemeSelector: selector = colorSchemesInput.light && colorSchemesInput.dark ? 'media' : undefined, rootSelector: rootSelector = ':root', ...input } = options;
    const firstColorScheme = Object.keys(colorSchemesInput)[0];
    const defaultColorScheme = defaultColorSchemeInput || (colorSchemesInput.light && firstColorScheme !== 'light' ? 'light' : firstColorScheme);
    const getCssVar = $ac07976fc01fdfa9$var$createGetCssVar(cssVarPrefix);
    const { [defaultColorScheme]: defaultSchemeInput, light: builtInLight, dark: builtInDark, ...customColorSchemes } = colorSchemesInput;
    const colorSchemes = {
        ...customColorSchemes
    };
    let defaultScheme = defaultSchemeInput;
    // For built-in light and dark color schemes, ensure that the value is valid if they are the default color scheme.
    if (defaultColorScheme === 'dark' && !('dark' in colorSchemesInput) || defaultColorScheme === 'light' && !('light' in colorSchemesInput)) defaultScheme = true;
    if (!defaultScheme) throw new Error(`MUI: The \`colorSchemes.${defaultColorScheme}\` option is either missing or invalid.`);
    // The reason to use `oklch` is that it is the most perceptually uniform color space and widely supported.
    let colorSpace;
    if (nativeColor) colorSpace = 'oklch';
    // Create the palette for the default color scheme, either `light`, `dark`, or custom color scheme.
    const muiTheme = $ac07976fc01fdfa9$var$attachColorScheme(colorSpace, colorSchemes, defaultScheme, input, defaultColorScheme);
    if (builtInLight && !colorSchemes.light) $ac07976fc01fdfa9$var$attachColorScheme(colorSpace, colorSchemes, builtInLight, undefined, 'light');
    if (builtInDark && !colorSchemes.dark) $ac07976fc01fdfa9$var$attachColorScheme(colorSpace, colorSchemes, builtInDark, undefined, 'dark');
    let theme = {
        defaultColorScheme: defaultColorScheme,
        ...muiTheme,
        cssVarPrefix: cssVarPrefix,
        colorSchemeSelector: selector,
        rootSelector: rootSelector,
        getCssVar: getCssVar,
        colorSchemes: colorSchemes,
        font: {
            ...(0, $fckAO.prepareTypographyVars)(muiTheme.typography),
            ...muiTheme.font
        },
        spacing: $ac07976fc01fdfa9$var$getSpacingVal(input.spacing)
    };
    Object.keys(theme.colorSchemes).forEach((key)=>{
        const palette = theme.colorSchemes[key].palette;
        const setCssVarColor = (cssVar)=>{
            const tokens = cssVar.split('-');
            const color = tokens[1];
            const colorToken = tokens[2];
            return getCssVar(cssVar, palette[color][colorToken]);
        };
        // attach black & white channels to common node
        if (palette.mode === 'light') {
            $ac07976fc01fdfa9$var$setColor(palette.common, 'background', '#fff');
            $ac07976fc01fdfa9$var$setColor(palette.common, 'onBackground', '#000');
        }
        if (palette.mode === 'dark') {
            $ac07976fc01fdfa9$var$setColor(palette.common, 'background', '#000');
            $ac07976fc01fdfa9$var$setColor(palette.common, 'onBackground', '#fff');
        }
        function colorMix(method, color, coefficient) {
            if (colorSpace) {
                let mixer;
                if (method === $h61zw.private_safeAlpha) mixer = `transparent ${((1 - coefficient) * 100).toFixed(0)}%`;
                if (method === $h61zw.private_safeDarken) mixer = `#000 ${(coefficient * 100).toFixed(0)}%`;
                if (method === $h61zw.private_safeLighten) mixer = `#fff ${(coefficient * 100).toFixed(0)}%`;
                return `color-mix(in ${colorSpace}, ${color}, ${mixer})`;
            }
            return method(color, coefficient);
        }
        // assign component variables
        $ac07976fc01fdfa9$var$assignNode(palette, [
            'Alert',
            'AppBar',
            'Avatar',
            'Button',
            'Chip',
            'FilledInput',
            'LinearProgress',
            'Skeleton',
            'Slider',
            'SnackbarContent',
            'SpeedDialAction',
            'StepConnector',
            'StepContent',
            'Switch',
            'TableCell',
            'Tooltip'
        ]);
        if (palette.mode === 'light') {
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorColor', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-error-light') : palette.error.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoColor', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-info-light') : palette.info.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successColor', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-success-light') : palette.success.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningColor', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-warning-light') : palette.warning.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.error.main)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.info.main)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.success.main)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.warning.main)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorStandardBg', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-error-light') : palette.error.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoStandardBg', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-info-light') : palette.info.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successStandardBg', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-success-light') : palette.success.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningStandardBg', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-warning-light') : palette.warning.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $ac07976fc01fdfa9$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-100'));
            $ac07976fc01fdfa9$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-400'));
            $ac07976fc01fdfa9$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-300'));
            $ac07976fc01fdfa9$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-A100'));
            $ac07976fc01fdfa9$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-400'));
            $ac07976fc01fdfa9$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-700'));
            $ac07976fc01fdfa9$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-700'));
            $ac07976fc01fdfa9$var$setColor(palette.FilledInput, 'bg', 'rgba(0, 0, 0, 0.06)');
            $ac07976fc01fdfa9$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(0, 0, 0, 0.09)');
            $ac07976fc01fdfa9$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(0, 0, 0, 0.12)');
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'primaryBg', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'secondaryBg', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'errorBg', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'infoBg', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'successBg', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'warningBg', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-warning-light') : palette.warning.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Skeleton, 'bg', colorSpace ? colorMix($h61zw.private_safeAlpha, nativeColor ? getCssVar('palette-text-primary') : palette.text.primary, 0.11) : `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.11)`);
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'primaryTrack', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'secondaryTrack', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'errorTrack', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'infoTrack', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'successTrack', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'warningTrack', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-warning-main') : palette.warning.main, 0.62));
            const snackbarContentBackground = colorSpace ? colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-background-default') : palette.background.default, 0.6825) // use `0.6825` instead of `0.8` to match the contrast ratio of JS implementation
             : (0, $h61zw.private_safeEmphasize)(palette.background.default, 0.8);
            $ac07976fc01fdfa9$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $ac07976fc01fdfa9$var$setColor(palette.SnackbarContent, 'color', $ac07976fc01fdfa9$var$silent(()=>colorSpace ? $4Gk6P.dark.text.primary : palette.getContrastText(snackbarContentBackground)));
            $ac07976fc01fdfa9$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $h61zw.private_safeEmphasize)(palette.background.paper, 0.15));
            $ac07976fc01fdfa9$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-400'));
            $ac07976fc01fdfa9$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-400'));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-common-white'));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-100'));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'primaryDisabledColor', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'secondaryDisabledColor', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'errorDisabledColor', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'infoDisabledColor', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'successDisabledColor', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'warningDisabledColor', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-warning-main') : palette.warning.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.TableCell, 'border', colorMix($h61zw.private_safeLighten, (0, $h61zw.private_safeAlpha)(nativeColor ? getCssVar('palette-divider') : palette.divider, 1), 0.88));
            $ac07976fc01fdfa9$var$setColor(palette.Tooltip, 'bg', colorMix($h61zw.private_safeAlpha, nativeColor ? getCssVar('palette-grey-700') : palette.grey[700], 0.92));
        }
        if (palette.mode === 'dark') {
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorColor', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-error-light') : palette.error.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoColor', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-info-light') : palette.info.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successColor', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-success-light') : palette.success.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningColor', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-warning-light') : palette.warning.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-dark'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-dark'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-dark'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-dark'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.error.dark)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.info.dark)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.success.dark)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.warning.dark)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorStandardBg', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-error-light') : palette.error.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoStandardBg', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-info-light') : palette.info.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successStandardBg', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-success-light') : palette.success.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningStandardBg', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-warning-light') : palette.warning.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $ac07976fc01fdfa9$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-900'));
            $ac07976fc01fdfa9$var$setColor(palette.AppBar, 'darkBg', setCssVarColor('palette-background-paper')); // specific for dark mode
            $ac07976fc01fdfa9$var$setColor(palette.AppBar, 'darkColor', setCssVarColor('palette-text-primary')); // specific for dark mode
            $ac07976fc01fdfa9$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-600'));
            $ac07976fc01fdfa9$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-800'));
            $ac07976fc01fdfa9$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-700'));
            $ac07976fc01fdfa9$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-700'));
            $ac07976fc01fdfa9$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-300'));
            $ac07976fc01fdfa9$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-300'));
            $ac07976fc01fdfa9$var$setColor(palette.FilledInput, 'bg', 'rgba(255, 255, 255, 0.09)');
            $ac07976fc01fdfa9$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(255, 255, 255, 0.13)');
            $ac07976fc01fdfa9$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(255, 255, 255, 0.12)');
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'primaryBg', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'secondaryBg', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'errorBg', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'infoBg', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'successBg', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'warningBg', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-warning-main') : palette.warning.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.Skeleton, 'bg', colorSpace ? colorMix($h61zw.private_safeAlpha, nativeColor ? getCssVar('palette-text-primary') : palette.text.primary, 0.13) : `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.13)`);
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'primaryTrack', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'secondaryTrack', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'errorTrack', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'infoTrack', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'successTrack', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'warningTrack', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-warning-light') : palette.warning.main, 0.5));
            const snackbarContentBackground = colorSpace ? colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-background-default') : palette.background.default, 0.985) // use `0.985` instead of `0.98` to match the contrast ratio of JS implementation
             : (0, $h61zw.private_safeEmphasize)(palette.background.default, 0.98);
            $ac07976fc01fdfa9$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $ac07976fc01fdfa9$var$setColor(palette.SnackbarContent, 'color', $ac07976fc01fdfa9$var$silent(()=>colorSpace ? $4Gk6P.light.text.primary : palette.getContrastText(snackbarContentBackground)));
            $ac07976fc01fdfa9$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $h61zw.private_safeEmphasize)(palette.background.paper, 0.15));
            $ac07976fc01fdfa9$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-600'));
            $ac07976fc01fdfa9$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-600'));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-grey-300'));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-600'));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'primaryDisabledColor', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.55));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'secondaryDisabledColor', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.55));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'errorDisabledColor', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.55));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'infoDisabledColor', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.55));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'successDisabledColor', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.55));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'warningDisabledColor', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-warning-light') : palette.warning.main, 0.55));
            $ac07976fc01fdfa9$var$setColor(palette.TableCell, 'border', colorMix($h61zw.private_safeDarken, (0, $h61zw.private_safeAlpha)(nativeColor ? getCssVar('palette-divider') : palette.divider, 1), 0.68));
            $ac07976fc01fdfa9$var$setColor(palette.Tooltip, 'bg', colorMix($h61zw.private_safeAlpha, nativeColor ? getCssVar('palette-grey-700') : palette.grey[700], 0.92));
        }
        if (!nativeColor) {
            $ac07976fc01fdfa9$var$setColorChannel(palette.background, 'default');
            // added for consistency with the `background.default` token
            $ac07976fc01fdfa9$var$setColorChannel(palette.background, 'paper');
            $ac07976fc01fdfa9$var$setColorChannel(palette.common, 'background');
            $ac07976fc01fdfa9$var$setColorChannel(palette.common, 'onBackground');
            $ac07976fc01fdfa9$var$setColorChannel(palette, 'divider');
        }
        Object.keys(palette).forEach((color)=>{
            const colors = palette[color];
            // The default palettes (primary, secondary, error, info, success, and warning) errors are handled by the above `createTheme(...)`.
            if (color !== 'tonalOffset' && !nativeColor && colors && typeof colors === 'object') {
                // Silent the error for custom palettes.
                if (colors.main) $ac07976fc01fdfa9$var$setColor(palette[color], 'mainChannel', (0, $h61zw.private_safeColorChannel)($ac07976fc01fdfa9$var$toRgb(colors.main)));
                if (colors.light) $ac07976fc01fdfa9$var$setColor(palette[color], 'lightChannel', (0, $h61zw.private_safeColorChannel)($ac07976fc01fdfa9$var$toRgb(colors.light)));
                if (colors.dark) $ac07976fc01fdfa9$var$setColor(palette[color], 'darkChannel', (0, $h61zw.private_safeColorChannel)($ac07976fc01fdfa9$var$toRgb(colors.dark)));
                if (colors.contrastText) $ac07976fc01fdfa9$var$setColor(palette[color], 'contrastTextChannel', (0, $h61zw.private_safeColorChannel)($ac07976fc01fdfa9$var$toRgb(colors.contrastText)));
                if (color === 'text') {
                    // Text colors: text.primary, text.secondary
                    $ac07976fc01fdfa9$var$setColorChannel(palette[color], 'primary');
                    $ac07976fc01fdfa9$var$setColorChannel(palette[color], 'secondary');
                }
                if (color === 'action') {
                    // Action colors: action.active, action.selected
                    if (colors.active) $ac07976fc01fdfa9$var$setColorChannel(palette[color], 'active');
                    if (colors.selected) $ac07976fc01fdfa9$var$setColorChannel(palette[color], 'selected');
                }
            }
        });
    });
    theme = args.reduce((acc, argument)=>(0, $ac07976fc01fdfa9$var$_deepmerge.default)(acc, argument), theme);
    const parserConfig = {
        prefix: cssVarPrefix,
        disableCssColorScheme: disableCssColorScheme,
        shouldSkipGeneratingVar: shouldSkipGeneratingVar,
        getSelector: (0, $ac07976fc01fdfa9$var$_createGetSelector.default)(theme),
        enableContrastVars: nativeColor
    };
    const { vars: vars, generateThemeVars: generateThemeVars, generateStyleSheets: generateStyleSheets } = (0, $fckAO.prepareCssVars)(theme, parserConfig);
    theme.vars = vars;
    Object.entries(theme.colorSchemes[theme.defaultColorScheme]).forEach(([key, value])=>{
        theme[key] = value;
    });
    theme.generateThemeVars = generateThemeVars;
    theme.generateStyleSheets = generateStyleSheets;
    theme.generateSpacing = function generateSpacing() {
        return (0, $izOUK.createSpacing)(input.spacing, (0, $8ZgMs.createUnarySpacing)(this));
    };
    theme.getColorSchemeSelector = (0, $fckAO.createGetColorSchemeSelector)(selector);
    theme.spacing = theme.generateSpacing();
    theme.shouldSkipGeneratingVar = shouldSkipGeneratingVar;
    theme.unstable_sxConfig = {
        ...$ac07976fc01fdfa9$var$_styleFunctionSx.unstable_defaultSxConfig,
        ...input?.unstable_sxConfig
    };
    theme.unstable_sx = function sx(props) {
        return (0, $ac07976fc01fdfa9$var$_styleFunctionSx.default)({
            sx: props,
            theme: this
        });
    };
    theme.toRuntimeSource = $2ICMq.stringifyTheme; // for Pigment CSS integration
    return theme;
}

});
parcelRegister("fckAO", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $b107f34b17d36dd1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "createCssVarsTheme", {
    enumerable: true,
    get: function() {
        return $b107f34b17d36dd1$var$_createCssVarsTheme.default;
    }
});
Object.defineProperty(module.exports, "createGetColorSchemeSelector", {
    enumerable: true,
    get: function() {
        return $9wccP.createGetColorSchemeSelector;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $b107f34b17d36dd1$var$_createCssVarsProvider.default;
    }
});
Object.defineProperty(module.exports, "prepareCssVars", {
    enumerable: true,
    get: function() {
        return $b107f34b17d36dd1$var$_prepareCssVars.default;
    }
});
Object.defineProperty(module.exports, "prepareTypographyVars", {
    enumerable: true,
    get: function() {
        return $b107f34b17d36dd1$var$_prepareTypographyVars.default;
    }
});

var $b107f34b17d36dd1$var$_createCssVarsProvider = $b107f34b17d36dd1$require$_interopRequireDefault((parcelRequire("3Vfwq")));

var $b107f34b17d36dd1$var$_prepareCssVars = $b107f34b17d36dd1$require$_interopRequireDefault((parcelRequire("5magr")));

var $b107f34b17d36dd1$var$_prepareTypographyVars = $b107f34b17d36dd1$require$_interopRequireDefault((parcelRequire("ikjX2")));

var $b107f34b17d36dd1$var$_createCssVarsTheme = $b107f34b17d36dd1$require$_interopRequireDefault((parcelRequire("73CWR")));

var $9wccP = parcelRequire("9wccP");

});
parcelRegister("ikjX2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d579922b6de2dbd6$var$prepareTypographyVars;
function $d579922b6de2dbd6$var$prepareTypographyVars(typography) {
    const vars = {};
    const entries = Object.entries(typography);
    entries.forEach((entry)=>{
        const [key, value] = entry;
        if (typeof value === 'object') vars[key] = `${value.fontStyle ? `${value.fontStyle} ` : ''}${value.fontVariant ? `${value.fontVariant} ` : ''}${value.fontWeight ? `${value.fontWeight} ` : ''}${value.fontStretch ? `${value.fontStretch} ` : ''}${value.fontSize || ''}${value.lineHeight ? `/${value.lineHeight} ` : ''}${value.fontFamily || ''}`;
    });
    return vars;
}

});


parcelRegister("8v3fy", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $6303bd594dbbe1c5$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $6303bd594dbbe1c5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6303bd594dbbe1c5$var$_formatMuiErrorMessage = $6303bd594dbbe1c5$require$_interopRequireDefault((parcelRequire("4Z6Nd")));

var $6303bd594dbbe1c5$var$_deepmerge = $6303bd594dbbe1c5$require$_interopRequireDefault((parcelRequire("bQ4jM")));

var $6303bd594dbbe1c5$var$_styleFunctionSx = $6303bd594dbbe1c5$require$_interopRequireWildcard((parcelRequire("l6FST")));

var $6303bd594dbbe1c5$var$_createTheme = $6303bd594dbbe1c5$require$_interopRequireDefault((parcelRequire("1dhnG")));

var $h61zw = parcelRequire("h61zw");

var $6303bd594dbbe1c5$var$_generateUtilityClass = $6303bd594dbbe1c5$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $6303bd594dbbe1c5$var$_createMixins = $6303bd594dbbe1c5$require$_interopRequireDefault((parcelRequire("6plKN")));

var $6303bd594dbbe1c5$var$_createPalette = $6303bd594dbbe1c5$require$_interopRequireDefault((parcelRequire("4Gk6P")));

var $6303bd594dbbe1c5$var$_createTypography = $6303bd594dbbe1c5$require$_interopRequireDefault((parcelRequire("d6q8u")));

var $6303bd594dbbe1c5$var$_shadows = $6303bd594dbbe1c5$require$_interopRequireDefault((parcelRequire("jtCFx")));

var $6303bd594dbbe1c5$var$_createTransitions = $6303bd594dbbe1c5$require$_interopRequireDefault((parcelRequire("bmoVh")));

var $6303bd594dbbe1c5$var$_zIndex = $6303bd594dbbe1c5$require$_interopRequireDefault((parcelRequire("lhXgK")));

var $2ICMq = parcelRequire("2ICMq");
function $6303bd594dbbe1c5$var$coefficientToPercentage(coefficient) {
    if (typeof coefficient === 'number') return `${(coefficient * 100).toFixed(0)}%`;
    return `calc((${coefficient}) * 100%)`;
}
// This can be removed when moved to `color-mix()` entirely.
const $6303bd594dbbe1c5$var$parseAddition = (str)=>{
    if (!Number.isNaN(+str)) return +str;
    const numbers = str.match(/\d*\.?\d+/g);
    if (!numbers) return 0;
    let sum = 0;
    for(let i = 0; i < numbers.length; i += 1)sum += +numbers[i];
    return sum;
};
function $6303bd594dbbe1c5$var$attachColorManipulators(theme) {
    Object.assign(theme, {
        alpha (color, coefficient) {
            const obj = this || theme;
            if (obj.colorSpace) return `oklch(from ${color} l c h / ${typeof coefficient === 'string' ? `calc(${coefficient})` : coefficient})`;
            if (obj.vars) // To preserve the behavior of the CSS theme variables
            // In the future, this could be replaced by `color-mix` (when https://caniuse.com/?search=color-mix reaches 95%).
            return `rgba(${color.replace(/var\(--([^,\s)]+)(?:,[^)]+)?\)+/g, 'var(--$1Channel)')} / ${typeof coefficient === 'string' ? `calc(${coefficient})` : coefficient})`;
            return (0, $h61zw.alpha)(color, $6303bd594dbbe1c5$var$parseAddition(coefficient));
        },
        lighten (color, coefficient) {
            const obj = this || theme;
            if (obj.colorSpace) return `color-mix(in ${obj.colorSpace}, ${color}, #fff ${$6303bd594dbbe1c5$var$coefficientToPercentage(coefficient)})`;
            return (0, $h61zw.lighten)(color, coefficient);
        },
        darken (color, coefficient) {
            const obj = this || theme;
            if (obj.colorSpace) return `color-mix(in ${obj.colorSpace}, ${color}, #000 ${$6303bd594dbbe1c5$var$coefficientToPercentage(coefficient)})`;
            return (0, $h61zw.darken)(color, coefficient);
        }
    });
}
function $6303bd594dbbe1c5$var$createThemeNoVars(options = {}, ...args) {
    const { breakpoints: breakpointsInput, mixins: mixinsInput = {}, spacing: spacingInput, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {}, shape: shapeInput, colorSpace: colorSpace, ...other } = options;
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateThemeVars === undefined) throw new Error("MUI: `vars` is a private field used for CSS variables support.\nPlease use another name or follow the [docs](https://v7.mui.com/material-ui/customization/css-theme-variables/usage/) to enable the feature.");
    const palette = (0, $6303bd594dbbe1c5$var$_createPalette.default)({
        ...paletteInput,
        colorSpace: colorSpace
    });
    const systemTheme = (0, $6303bd594dbbe1c5$var$_createTheme.default)(options);
    let muiTheme = (0, $6303bd594dbbe1c5$var$_deepmerge.default)(systemTheme, {
        mixins: (0, $6303bd594dbbe1c5$var$_createMixins.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: $6303bd594dbbe1c5$var$_shadows.default.slice(),
        typography: (0, $6303bd594dbbe1c5$var$_createTypography.default)(palette, typographyInput),
        transitions: (0, $6303bd594dbbe1c5$var$_createTransitions.default)(transitionsInput),
        zIndex: {
            ...$6303bd594dbbe1c5$var$_zIndex.default
        }
    });
    muiTheme = (0, $6303bd594dbbe1c5$var$_deepmerge.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $6303bd594dbbe1c5$var$_deepmerge.default)(acc, argument), muiTheme);
    {
        // TODO v6: Refactor to use globalStateClassesMapping from @mui/utils once `readOnly` state class is used in Rating component.
        const stateClasses = [
            'active',
            'checked',
            'completed',
            'disabled',
            'error',
            'expanded',
            'focused',
            'focusVisible',
            'required',
            'selected'
        ];
        const traverse = (node, component)=>{
            let key;
            // eslint-disable-next-line guard-for-in
            for(key in node){
                const child = node[key];
                if (stateClasses.includes(key) && Object.keys(child).length > 0) {
                    {
                        const stateClass = (0, $6303bd594dbbe1c5$var$_generateUtilityClass.default)('', key);
                        console.error([
                            `MUI: The \`${component}\` component increases ` + `the CSS specificity of the \`${key}\` internal state.`,
                            'You can not override it like this: ',
                            JSON.stringify(node, null, 2),
                            '',
                            `Instead, you need to use the '&.${stateClass}' syntax:`,
                            JSON.stringify({
                                root: {
                                    [`&.${stateClass}`]: child
                                }
                            }, null, 2),
                            '',
                            'https://mui.com/r/state-classes-guide'
                        ].join('\n'));
                    }
                    // Remove the style to prevent global conflicts.
                    node[key] = {};
                }
            }
        };
        Object.keys(muiTheme.components).forEach((component)=>{
            const styleOverrides = muiTheme.components[component].styleOverrides;
            if (styleOverrides && component.startsWith('Mui')) traverse(styleOverrides, component);
        });
    }
    muiTheme.unstable_sxConfig = {
        ...$6303bd594dbbe1c5$var$_styleFunctionSx.unstable_defaultSxConfig,
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $6303bd594dbbe1c5$var$_styleFunctionSx.default)({
            sx: props,
            theme: this
        });
    };
    muiTheme.toRuntimeSource = $2ICMq.stringifyTheme; // for Pigment CSS integration
    $6303bd594dbbe1c5$var$attachColorManipulators(muiTheme);
    return muiTheme;
}
var $6303bd594dbbe1c5$var$_default = module.exports.default = $6303bd594dbbe1c5$var$createThemeNoVars;

});
parcelRegister("6plKN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4aa5f3b4975f3e4c$var$createMixins;
function $4aa5f3b4975f3e4c$var$createMixins(breakpoints, mixins) {
    return {
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        },
        ...mixins
    };
}

});

parcelRegister("d6q8u", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $98a01bf22de9dc59$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $98a01bf22de9dc59$var$createTypography;

var $98a01bf22de9dc59$var$_deepmerge = $98a01bf22de9dc59$require$_interopRequireDefault((parcelRequire("bQ4jM")));
function $98a01bf22de9dc59$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $98a01bf22de9dc59$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $98a01bf22de9dc59$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
/**
 * @see @link{https://m2.material.io/design/typography/the-type-system.html}
 * @see @link{https://m2.material.io/design/typography/understanding-typography.html}
 */ function $98a01bf22de9dc59$var$createTypography(palette, typography) {
    const { fontFamily: fontFamily = $98a01bf22de9dc59$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2, ...other } = typeof typography === 'function' ? typography(palette) : typography;
    if (typeof fontSize !== 'number') console.error('MUI: `fontSize` is required to be a number.');
    if (typeof htmlFontSize !== 'number') console.error('MUI: `htmlFontSize` is required to be a number.');
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight,
            // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
            // across font-families can cause issues with the kerning.
            ...fontFamily === $98a01bf22de9dc59$var$defaultFontFamily ? {
                letterSpacing: `${$98a01bf22de9dc59$var$round(letterSpacing / size)}em`
            } : {},
            ...casing,
            ...allVariants
        });
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $98a01bf22de9dc59$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $98a01bf22de9dc59$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $98a01bf22de9dc59$var$_deepmerge.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold,
        ...variants
    }, other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("jtCFx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $e2deb8a0bbe5ea21$var$shadowKeyUmbraOpacity = 0.2;
const $e2deb8a0bbe5ea21$var$shadowKeyPenumbraOpacity = 0.14;
const $e2deb8a0bbe5ea21$var$shadowAmbientShadowOpacity = 0.12;
function $e2deb8a0bbe5ea21$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$e2deb8a0bbe5ea21$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$e2deb8a0bbe5ea21$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$e2deb8a0bbe5ea21$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $e2deb8a0bbe5ea21$var$shadows = [
    'none',
    $e2deb8a0bbe5ea21$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $e2deb8a0bbe5ea21$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $e2deb8a0bbe5ea21$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $e2deb8a0bbe5ea21$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $e2deb8a0bbe5ea21$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $e2deb8a0bbe5ea21$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $e2deb8a0bbe5ea21$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $e2deb8a0bbe5ea21$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $e2deb8a0bbe5ea21$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $e2deb8a0bbe5ea21$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $e2deb8a0bbe5ea21$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $e2deb8a0bbe5ea21$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $e2deb8a0bbe5ea21$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $e2deb8a0bbe5ea21$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $e2deb8a0bbe5ea21$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $e2deb8a0bbe5ea21$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $e2deb8a0bbe5ea21$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $e2deb8a0bbe5ea21$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $e2deb8a0bbe5ea21$var$_default = module.exports.default = $e2deb8a0bbe5ea21$var$shadows;

});

parcelRegister("bmoVh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $845514f3678d3888$var$createTransitions;
module.exports.easing = module.exports.duration = void 0;
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
const $845514f3678d3888$var$easing = module.exports.easing = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
// Follow https://m2.material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing
const $845514f3678d3888$var$duration = module.exports.duration = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $845514f3678d3888$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $845514f3678d3888$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.desmos.com/calculator/vbrp3ggqet
    return Math.min(Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10), 3000);
}
function $845514f3678d3888$var$createTransitions(inputTransitions) {
    const mergedEasing = {
        ...$845514f3678d3888$var$easing,
        ...inputTransitions.easing
    };
    const mergedDuration = {
        ...$845514f3678d3888$var$duration,
        ...inputTransitions.duration
    };
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0, ...other } = options;
        {
            const isString = (value)=>typeof value === 'string';
            const isNumber = (value)=>!Number.isNaN(parseFloat(value));
            if (!isString(props) && !Array.isArray(props)) console.error('MUI: Argument "props" must be a string or Array.');
            if (!isNumber(durationOption) && !isString(durationOption)) console.error(`MUI: Argument "duration" must be a number or a string but found ${durationOption}.`);
            if (!isString(easingOption)) console.error('MUI: Argument "easing" must be a string.');
            if (!isNumber(delay) && !isString(delay)) console.error('MUI: Argument "delay" must be a number or a string.');
            if (typeof options !== 'object') console.error([
                'MUI: Secong argument of transition.create must be an object.',
                "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"
            ].join('\n'));
            if (Object.keys(other).length !== 0) console.error(`MUI: Unrecognized argument(s) [${Object.keys(other).join(',')}].`);
        }
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $845514f3678d3888$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $845514f3678d3888$var$formatMs(delay)}`).join(',');
    };
    return {
        getAutoHeightDuration: $845514f3678d3888$var$getAutoHeightDuration,
        create: create,
        ...inputTransitions,
        easing: mergedEasing,
        duration: mergedDuration
    };
}

});

parcelRegister("lhXgK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $f7f9291b6f07cefb$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $f7f9291b6f07cefb$var$_default = module.exports.default = $f7f9291b6f07cefb$var$zIndex;

});

parcelRegister("2ICMq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.stringifyTheme = $1fadc5be6a14f8c8$var$stringifyTheme;

var $bQ4jM = parcelRequire("bQ4jM");
/* eslint-disable import/prefer-default-export */ function $1fadc5be6a14f8c8$var$isSerializable(val) {
    return (0, $bQ4jM.isPlainObject)(val) || typeof val === 'undefined' || typeof val === 'string' || typeof val === 'boolean' || typeof val === 'number' || Array.isArray(val);
}
/**
 * `baseTheme` usually comes from `createTheme()` or `extendTheme()`.
 *
 * This function is intended to be used with zero-runtime CSS-in-JS like Pigment CSS
 * For example, in a Next.js project:
 *
 * ```js
 * // next.config.js
 * const { extendTheme } = require('@mui/material/styles');
 *
 * const theme = extendTheme();
 * // `.toRuntimeSource` is Pigment CSS specific to create a theme that is available at runtime.
 * theme.toRuntimeSource = stringifyTheme;
 *
 * module.exports = withPigment({
 *  theme,
 * });
 * ```
 */ function $1fadc5be6a14f8c8$var$stringifyTheme(baseTheme = {}) {
    const serializableTheme = {
        ...baseTheme
    };
    function serializeTheme(object) {
        const array = Object.entries(object);
        // eslint-disable-next-line no-plusplus
        for(let index = 0; index < array.length; index++){
            const [key, value] = array[index];
            if (!$1fadc5be6a14f8c8$var$isSerializable(value) || key.startsWith('unstable_')) delete object[key];
            else if ((0, $bQ4jM.isPlainObject)(value)) {
                object[key] = {
                    ...value
                };
                serializeTheme(object[key]);
            }
        }
    }
    serializeTheme(serializableTheme);
    return `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(serializableTheme, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}

});


parcelRegister("2JzIB", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $1fdb7dab8864519b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1fdb7dab8864519b$var$createColorScheme;
module.exports.getOpacity = $1fdb7dab8864519b$var$getOpacity;
module.exports.getOverlays = $1fdb7dab8864519b$var$getOverlays;

var $1fdb7dab8864519b$var$_createPalette = $1fdb7dab8864519b$require$_interopRequireDefault((parcelRequire("4Gk6P")));

var $1fdb7dab8864519b$var$_getOverlayAlpha = $1fdb7dab8864519b$require$_interopRequireDefault((parcelRequire("35vyj")));
const $1fdb7dab8864519b$var$defaultDarkOverlays = [
    ...Array(25)
].map((_, index)=>{
    if (index === 0) return 'none';
    const overlay = (0, $1fdb7dab8864519b$var$_getOverlayAlpha.default)(index);
    return `linear-gradient(rgba(255 255 255 / ${overlay}), rgba(255 255 255 / ${overlay}))`;
});
function $1fdb7dab8864519b$var$getOpacity(mode) {
    return {
        inputPlaceholder: mode === 'dark' ? 0.5 : 0.42,
        inputUnderline: mode === 'dark' ? 0.7 : 0.42,
        switchTrackDisabled: mode === 'dark' ? 0.2 : 0.12,
        switchTrack: mode === 'dark' ? 0.3 : 0.38
    };
}
function $1fdb7dab8864519b$var$getOverlays(mode) {
    return mode === 'dark' ? $1fdb7dab8864519b$var$defaultDarkOverlays : [];
}
function $1fdb7dab8864519b$var$createColorScheme(options) {
    const { palette: paletteInput = {
        mode: 'light'
    }, opacity: // need to cast to avoid module augmentation test
    opacity, overlays: overlays, colorSpace: colorSpace, ...other } = options;
    // need to cast because `colorSpace` is considered internal at the moment.
    const palette = (0, $1fdb7dab8864519b$var$_createPalette.default)({
        ...paletteInput,
        colorSpace: colorSpace
    });
    return {
        palette: palette,
        opacity: {
            ...$1fdb7dab8864519b$var$getOpacity(palette.mode),
            ...opacity
        },
        overlays: overlays || $1fdb7dab8864519b$var$getOverlays(palette.mode),
        ...other
    };
}

});
parcelRegister("35vyj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $23fa506264c010ed$var$getOverlayAlpha;
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
function $23fa506264c010ed$var$getOverlayAlpha(elevation) {
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return Math.round(alphaValue * 10) / 1000;
}

});


parcelRegister("fPRn6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b87504e8f71bd950$var$shouldSkipGeneratingVar;
function $b87504e8f71bd950$var$shouldSkipGeneratingVar(keys) {
    return !!keys[0].match(/(cssVarPrefix|colorSchemeSelector|modularCssLayers|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!keys[0].match(/sxConfig$/) || // ends with sxConfig
    keys[0] === 'palette' && !!keys[1]?.match(/(mode|contrastThreshold|tonalOffset)/);
}

});

parcelRegister("9yYvT", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $6f663abbabfb57a0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6f663abbabfb57a0$var$_excludeVariablesFromRoot = $6f663abbabfb57a0$require$_interopRequireDefault((parcelRequire("kKEhy")));
var $6f663abbabfb57a0$var$_default = (theme)=>(colorScheme, css)=>{
        const root = theme.rootSelector || ':root';
        const selector = theme.colorSchemeSelector;
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (theme.defaultColorScheme === colorScheme) {
            if (colorScheme === 'dark') {
                const excludedVariables = {};
                (0, $6f663abbabfb57a0$var$_excludeVariablesFromRoot.default)(theme.cssVarPrefix).forEach((cssVar)=>{
                    excludedVariables[cssVar] = css[cssVar];
                    delete css[cssVar];
                });
                if (rule === 'media') return {
                    [root]: css,
                    [`@media (prefers-color-scheme: dark)`]: {
                        [root]: excludedVariables
                    }
                };
                if (rule) return {
                    [rule.replace('%s', colorScheme)]: excludedVariables,
                    [`${root}, ${rule.replace('%s', colorScheme)}`]: css
                };
                return {
                    [root]: {
                        ...css,
                        ...excludedVariables
                    }
                };
            }
            if (rule && rule !== 'media') return `${root}, ${rule.replace('%s', String(colorScheme))}`;
        } else if (colorScheme) {
            if (rule === 'media') return {
                [`@media (prefers-color-scheme: ${String(colorScheme)})`]: {
                    [root]: css
                }
            };
            if (rule) return rule.replace('%s', String(colorScheme));
        }
        return root;
    };
module.exports.default = $6f663abbabfb57a0$var$_default;

});
parcelRegister("kKEhy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * @internal These variables should not appear in the :root stylesheet when the `defaultColorScheme="dark"`
 */ const $f1b759b2363a287f$var$excludeVariablesFromRoot = (cssVarPrefix)=>[
        ...[
            ...Array(25)
        ].map((_, index)=>`--${cssVarPrefix ? `${cssVarPrefix}-` : ''}overlays-${index}`),
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkBg`,
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkColor`
    ];
var $f1b759b2363a287f$var$_default = module.exports.default = $f1b759b2363a287f$var$excludeVariablesFromRoot;

});




parcelRegister("5fr1m", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3d23504439aa8524$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3d23504439aa8524$var$createMuiStrictModeTheme;

var $3d23504439aa8524$var$_deepmerge = $3d23504439aa8524$require$_interopRequireDefault((parcelRequire("bQ4jM")));

var $3d23504439aa8524$var$_createTheme = $3d23504439aa8524$require$_interopRequireDefault((parcelRequire("ijOKP")));
function $3d23504439aa8524$var$createMuiStrictModeTheme(options, ...args) {
    return (0, $3d23504439aa8524$var$_createTheme.default)((0, $3d23504439aa8524$var$_deepmerge.default)({
        unstable_strictMode: true
    }, options), ...args);
}

});

parcelRegister("22wy2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $17c504046cb9a64c$var$createStyles;
let $17c504046cb9a64c$var$warnedOnce = false;
// To remove in v6
function $17c504046cb9a64c$var$createStyles(styles) {
    if (!$17c504046cb9a64c$var$warnedOnce) {
        console.warn([
            'MUI: createStyles from @mui/material/styles is deprecated.',
            'Please use @mui/styles/createStyles'
        ].join('\n'));
        $17c504046cb9a64c$var$warnedOnce = true;
    }
    return styles;
}

});

parcelRegister("18jQK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alignProperty = $0d35ef8a52a98e99$var$alignProperty;
module.exports.convertLength = $0d35ef8a52a98e99$var$convertLength;
module.exports.fontGrid = $0d35ef8a52a98e99$var$fontGrid;
module.exports.getUnit = $0d35ef8a52a98e99$var$getUnit;
module.exports.isUnitless = $0d35ef8a52a98e99$var$isUnitless;
module.exports.responsiveProperty = $0d35ef8a52a98e99$var$responsiveProperty;
module.exports.toUnitless = $0d35ef8a52a98e99$var$toUnitless;
function $0d35ef8a52a98e99$var$isUnitless(value) {
    return String(parseFloat(value)).length === String(value).length;
}
// Ported from Compass
// https://github.com/Compass/compass/blob/master/core/stylesheets/compass/typography/_units.scss
// Emulate the sass function "unit"
function $0d35ef8a52a98e99$var$getUnit(input) {
    return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
}
// Emulate the sass function "unitless"
function $0d35ef8a52a98e99$var$toUnitless(length) {
    return parseFloat(length);
}
// Convert any CSS <length> or <percentage> value to any another.
// From https://github.com/KyleAMathews/convert-css-length
function $0d35ef8a52a98e99$var$convertLength(baseFontSize) {
    return (length, toUnit)=>{
        const fromUnit = $0d35ef8a52a98e99$var$getUnit(length);
        // Optimize for cases where `from` and `to` units are accidentally the same.
        if (fromUnit === toUnit) return length;
        // Convert input length to pixels.
        let pxLength = $0d35ef8a52a98e99$var$toUnitless(length);
        if (fromUnit !== 'px') {
            if (fromUnit === 'em') pxLength = $0d35ef8a52a98e99$var$toUnitless(length) * $0d35ef8a52a98e99$var$toUnitless(baseFontSize);
            else if (fromUnit === 'rem') pxLength = $0d35ef8a52a98e99$var$toUnitless(length) * $0d35ef8a52a98e99$var$toUnitless(baseFontSize);
        }
        // Convert length in pixels to the output unit
        let outputLength = pxLength;
        if (toUnit !== 'px') {
            if (toUnit === 'em') outputLength = pxLength / $0d35ef8a52a98e99$var$toUnitless(baseFontSize);
            else if (toUnit === 'rem') outputLength = pxLength / $0d35ef8a52a98e99$var$toUnitless(baseFontSize);
            else return length;
        }
        return parseFloat(outputLength.toFixed(5)) + toUnit;
    };
}
function $0d35ef8a52a98e99$var$alignProperty({ size: size, grid: grid }) {
    const sizeBelow = size - size % grid;
    const sizeAbove = sizeBelow + grid;
    return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
}
// fontGrid finds a minimal grid (in rem) for the fontSize values so that the
// lineHeight falls under a x pixels grid, 4px in the case of Material Design,
// without changing the relative line height
function $0d35ef8a52a98e99$var$fontGrid({ lineHeight: lineHeight, pixels: pixels, htmlFontSize: htmlFontSize }) {
    return pixels / (lineHeight * htmlFontSize);
}
/**
 * generate a responsive version of a given CSS property
 * @example
 * responsiveProperty({
 *   cssProperty: 'fontSize',
 *   min: 15,
 *   max: 20,
 *   unit: 'px',
 *   breakpoints: [300, 600],
 * })
 *
 * // this returns
 *
 * {
 *   fontSize: '15px',
 *   '@media (min-width:300px)': {
 *     fontSize: '17.5px',
 *   },
 *   '@media (min-width:600px)': {
 *     fontSize: '20px',
 *   },
 * }
 * @param {Object} params
 * @param {string} params.cssProperty - The CSS property to be made responsive
 * @param {number} params.min - The smallest value of the CSS property
 * @param {number} params.max - The largest value of the CSS property
 * @param {string} [params.unit] - The unit to be used for the CSS property
 * @param {Array.number} [params.breakpoints]  - An array of breakpoints
 * @param {number} [params.alignStep] - Round scaled value to fall under this grid
 * @returns {Object} responsive styles for {params.cssProperty}
 */ function $0d35ef8a52a98e99$var$responsiveProperty({ cssProperty: cssProperty, min: min, max: max, unit: unit = 'rem', breakpoints: breakpoints = [
    600,
    900,
    1200
], transform: transform = null }) {
    const output = {
        [cssProperty]: `${min}${unit}`
    };
    const factor = (max - min) / breakpoints[breakpoints.length - 1];
    breakpoints.forEach((breakpoint)=>{
        let value = min + factor * breakpoint;
        if (transform !== null) value = transform(value);
        output[`@media (min-width:${breakpoint}px)`] = {
            [cssProperty]: `${Math.round(value * 10000) / 10000}${unit}`
        };
    });
    return output;
}

});

parcelRegister("eoBMT", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a7b09e624fa460c3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a7b09e624fa460c3$var$responsiveFontSizes;

var $a7b09e624fa460c3$var$_formatMuiErrorMessage = $a7b09e624fa460c3$require$_interopRequireDefault((parcelRequire("4Z6Nd")));

var $18jQK = parcelRequire("18jQK");
function $a7b09e624fa460c3$var$responsiveFontSizes(themeInput, options = {}) {
    const { breakpoints: breakpoints = [
        'sm',
        'md',
        'lg'
    ], disableAlign: disableAlign = false, factor: factor = 2, variants: variants = [
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'subtitle1',
        'subtitle2',
        'body1',
        'body2',
        'caption',
        'button',
        'overline'
    ] } = options;
    const theme = {
        ...themeInput
    };
    theme.typography = {
        ...theme.typography
    };
    const typography = theme.typography;
    // Convert between CSS lengths e.g. em->px or px->rem
    // Set the baseFontSize for your project. Defaults to 16px (also the browser default).
    const convert = (0, $18jQK.convertLength)(typography.htmlFontSize);
    const breakpointValues = breakpoints.map((x)=>theme.breakpoints.values[x]);
    variants.forEach((variant)=>{
        const style = typography[variant];
        if (!style) return;
        const remFontSize = parseFloat(convert(style.fontSize, 'rem'));
        if (remFontSize <= 1) return;
        const maxFontSize = remFontSize;
        const minFontSize = 1 + (maxFontSize - 1) / factor;
        let { lineHeight: lineHeight } = style;
        if (!(0, $18jQK.isUnitless)(lineHeight) && !disableAlign) throw new Error("MUI: Unsupported non-unitless line height with grid alignment.\nUse unitless line heights instead.");
        if (!(0, $18jQK.isUnitless)(lineHeight)) // make it unitless
        lineHeight = parseFloat(convert(lineHeight, 'rem')) / parseFloat(remFontSize);
        let transform = null;
        if (!disableAlign) transform = (value)=>(0, $18jQK.alignProperty)({
                size: value,
                grid: (0, $18jQK.fontGrid)({
                    pixels: 4,
                    lineHeight: lineHeight,
                    htmlFontSize: typography.htmlFontSize
                })
            });
        typography[variant] = {
            ...style,
            ...(0, $18jQK.responsiveProperty)({
                cssProperty: 'fontSize',
                min: minFontSize,
                max: maxFontSize,
                unit: 'rem',
                breakpoints: breakpointValues,
                transform: transform
            })
        };
    });
    return theme;
}

});

parcelRegister("14H9o", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $0c87a2f38cd49c7a$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $0c87a2f38cd49c7a$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0c87a2f38cd49c7a$var$useTheme;

var $0c87a2f38cd49c7a$var$React = $0c87a2f38cd49c7a$require$_interopRequireWildcard((parcelRequire("acw62")));

var $izOUK = parcelRequire("izOUK");

var $0c87a2f38cd49c7a$var$_defaultTheme = $0c87a2f38cd49c7a$require$_interopRequireDefault((parcelRequire("jR9F1")));

var $0c87a2f38cd49c7a$var$_identifier = $0c87a2f38cd49c7a$require$_interopRequireDefault((parcelRequire("4jPsi")));
function $0c87a2f38cd49c7a$var$useTheme() {
    const theme = (0, $izOUK.useTheme)($0c87a2f38cd49c7a$var$_defaultTheme.default);
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $0c87a2f38cd49c7a$var$React.useDebugValue(theme);
    return theme[$0c87a2f38cd49c7a$var$_identifier.default] || theme;
}

});
parcelRegister("jR9F1", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $e74a75f0176cf8e3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e74a75f0176cf8e3$var$_createTheme = $e74a75f0176cf8e3$require$_interopRequireDefault((parcelRequire("ijOKP")));
const $e74a75f0176cf8e3$var$defaultTheme = (0, $e74a75f0176cf8e3$var$_createTheme.default)();
var $e74a75f0176cf8e3$var$_default = module.exports.default = $e74a75f0176cf8e3$var$defaultTheme;

});


parcelRegister("6g9fa", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $48eb684ebe9272b4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $48eb684ebe9272b4$var$useThemeProps;

var $48eb684ebe9272b4$var$_useThemeProps = $48eb684ebe9272b4$require$_interopRequireDefault((parcelRequire("2LgDM")));

var $48eb684ebe9272b4$var$_defaultTheme = $48eb684ebe9272b4$require$_interopRequireDefault((parcelRequire("jR9F1")));

var $48eb684ebe9272b4$var$_identifier = $48eb684ebe9272b4$require$_interopRequireDefault((parcelRequire("4jPsi")));
function $48eb684ebe9272b4$var$useThemeProps({ props: props, name: name }) {
    return (0, $48eb684ebe9272b4$var$_useThemeProps.default)({
        props: props,
        name: name,
        defaultTheme: $48eb684ebe9272b4$var$_defaultTheme.default,
        themeId: $48eb684ebe9272b4$var$_identifier.default
    });
}

});

parcelRegister("d8seH", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $0277c5e26ff0d56c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
Object.defineProperty(module.exports, "rootShouldForwardProp", {
    enumerable: true,
    get: function() {
        return $0277c5e26ff0d56c$var$_rootShouldForwardProp.default;
    }
});
Object.defineProperty(module.exports, "slotShouldForwardProp", {
    enumerable: true,
    get: function() {
        return $0277c5e26ff0d56c$var$_slotShouldForwardProp.default;
    }
});

var $0277c5e26ff0d56c$var$_createStyled = $0277c5e26ff0d56c$require$_interopRequireDefault((parcelRequire("bbeCr")));

var $0277c5e26ff0d56c$var$_defaultTheme = $0277c5e26ff0d56c$require$_interopRequireDefault((parcelRequire("jR9F1")));

var $0277c5e26ff0d56c$var$_identifier = $0277c5e26ff0d56c$require$_interopRequireDefault((parcelRequire("4jPsi")));

var $0277c5e26ff0d56c$var$_rootShouldForwardProp = $0277c5e26ff0d56c$require$_interopRequireDefault((parcelRequire("8Uq77")));

var $0277c5e26ff0d56c$var$_slotShouldForwardProp = $0277c5e26ff0d56c$require$_interopRequireDefault((parcelRequire("PJRTc")));
const $0277c5e26ff0d56c$var$styled = (0, $0277c5e26ff0d56c$var$_createStyled.default)({
    themeId: $0277c5e26ff0d56c$var$_identifier.default,
    defaultTheme: $0277c5e26ff0d56c$var$_defaultTheme.default,
    rootShouldForwardProp: $0277c5e26ff0d56c$var$_rootShouldForwardProp.default
});
var $0277c5e26ff0d56c$var$_default = module.exports.default = $0277c5e26ff0d56c$var$styled;

});
parcelRegister("8Uq77", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $67c7cf568a060c3d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $67c7cf568a060c3d$var$_slotShouldForwardProp = $67c7cf568a060c3d$require$_interopRequireDefault((parcelRequire("PJRTc")));
const $67c7cf568a060c3d$var$rootShouldForwardProp = (prop)=>(0, $67c7cf568a060c3d$var$_slotShouldForwardProp.default)(prop) && prop !== 'classes';
var $67c7cf568a060c3d$var$_default = module.exports.default = $67c7cf568a060c3d$var$rootShouldForwardProp;

});
parcelRegister("PJRTc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
// copied from @mui/system/createStyled
function $09b8580029d7f562$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $09b8580029d7f562$var$_default = module.exports.default = $09b8580029d7f562$var$slotShouldForwardProp;

});



parcelRegister("gRp5N", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $c4650f6dac4940cb$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $c4650f6dac4940cb$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c4650f6dac4940cb$var$ThemeProvider;

var $c4650f6dac4940cb$var$React = $c4650f6dac4940cb$require$_interopRequireWildcard((parcelRequire("acw62")));

var $c4650f6dac4940cb$var$_ThemeProviderNoVars = $c4650f6dac4940cb$require$_interopRequireDefault((parcelRequire("6osfi")));

var $b0NgK = parcelRequire("b0NgK");

var $c4650f6dac4940cb$var$_identifier = $c4650f6dac4940cb$require$_interopRequireDefault((parcelRequire("4jPsi")));

var $ayMG0 = parcelRequire("ayMG0");
function $c4650f6dac4940cb$var$ThemeProvider({ theme: theme, ...props }) {
    const noVarsTheme = $c4650f6dac4940cb$var$React.useMemo(()=>{
        if (typeof theme === 'function') return theme;
        const muiTheme = $c4650f6dac4940cb$var$_identifier.default in theme ? theme[$c4650f6dac4940cb$var$_identifier.default] : theme;
        if (!('colorSchemes' in muiTheme)) {
            if (!('vars' in muiTheme)) // For non-CSS variables themes, set `vars` to null to prevent theme inheritance from the upper theme.
            // The example use case is the docs demo that uses ThemeProvider to customize the theme while the upper theme is using CSS variables.
            return {
                ...theme,
                vars: null
            };
            return theme;
        }
        return null;
    }, [
        theme
    ]);
    if (noVarsTheme) return /*#__PURE__*/ (0, $ayMG0.jsx)($c4650f6dac4940cb$var$_ThemeProviderNoVars.default, {
        theme: noVarsTheme,
        ...props
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($b0NgK.CssVarsProvider, {
        theme: theme,
        ...props
    });
}

});
parcelRegister("6osfi", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $4a7ae4f41d656e46$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $4a7ae4f41d656e46$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4a7ae4f41d656e46$var$ThemeProviderNoVars;

var $4a7ae4f41d656e46$var$React = $4a7ae4f41d656e46$require$_interopRequireWildcard((parcelRequire("acw62")));

var $izOUK = parcelRequire("izOUK");

var $4a7ae4f41d656e46$var$_identifier = $4a7ae4f41d656e46$require$_interopRequireDefault((parcelRequire("4jPsi")));

var $ayMG0 = parcelRequire("ayMG0");
function $4a7ae4f41d656e46$var$ThemeProviderNoVars({ theme: themeInput, ...props }) {
    const scopedTheme = $4a7ae4f41d656e46$var$_identifier.default in themeInput ? themeInput[$4a7ae4f41d656e46$var$_identifier.default] : undefined;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($izOUK.ThemeProvider, {
        ...props,
        themeId: scopedTheme ? $4a7ae4f41d656e46$var$_identifier.default : undefined,
        theme: scopedTheme || themeInput
    });
}

});

parcelRegister("b0NgK", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $8045e99d413e4782$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CssVarsProvider = void 0;
module.exports.Experimental_CssVarsProvider = $8045e99d413e4782$var$Experimental_CssVarsProvider;
module.exports.useColorScheme = module.exports.getInitColorSchemeScript = void 0;

var $8045e99d413e4782$var$_styleFunctionSx = $8045e99d413e4782$require$_interopRequireDefault((parcelRequire("l6FST")));

var $izOUK = parcelRequire("izOUK");

var $8045e99d413e4782$var$_createTheme = $8045e99d413e4782$require$_interopRequireDefault((parcelRequire("ijOKP")));

var $8045e99d413e4782$var$_createTypography = $8045e99d413e4782$require$_interopRequireDefault((parcelRequire("d6q8u")));

var $8045e99d413e4782$var$_identifier = $8045e99d413e4782$require$_interopRequireDefault((parcelRequire("4jPsi")));

var $3K3i6 = parcelRequire("3K3i6");

var $ayMG0 = parcelRequire("ayMG0");
const { CssVarsProvider: $8045e99d413e4782$var$InternalCssVarsProvider, useColorScheme: $8045e99d413e4782$var$useColorScheme, getInitColorSchemeScript: $8045e99d413e4782$var$deprecatedGetInitColorSchemeScript } = (0, $izOUK.unstable_createCssVarsProvider)({
    themeId: $8045e99d413e4782$var$_identifier.default,
    // @ts-ignore ignore module augmentation tests
    theme: ()=>(0, $8045e99d413e4782$var$_createTheme.default)({
            cssVariables: true
        }),
    colorSchemeStorageKey: $3K3i6.defaultConfig.colorSchemeStorageKey,
    modeStorageKey: $3K3i6.defaultConfig.modeStorageKey,
    defaultColorScheme: {
        light: $3K3i6.defaultConfig.defaultLightColorScheme,
        dark: $3K3i6.defaultConfig.defaultDarkColorScheme
    },
    resolveTheme: (theme)=>{
        const newTheme = {
            ...theme,
            typography: (0, $8045e99d413e4782$var$_createTypography.default)(theme.palette, theme.typography)
        };
        newTheme.unstable_sx = function sx(props) {
            return (0, $8045e99d413e4782$var$_styleFunctionSx.default)({
                sx: props,
                theme: this
            });
        };
        return newTheme;
    }
});
module.exports.useColorScheme = $8045e99d413e4782$var$useColorScheme;
let $8045e99d413e4782$var$warnedOnce = false;
// TODO: remove in v7
// eslint-disable-next-line @typescript-eslint/naming-convention
function $8045e99d413e4782$var$Experimental_CssVarsProvider(props) {
    if (!$8045e99d413e4782$var$warnedOnce) {
        console.warn([
            'MUI: The Experimental_CssVarsProvider component has been ported into ThemeProvider.',
            '',
            "You should use `import { ThemeProvider } from '@mui/material/styles'` instead.",
            'For more details, check out https://mui.com/material-ui/customization/css-theme-variables/usage/'
        ].join('\n'));
        $8045e99d413e4782$var$warnedOnce = true;
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($8045e99d413e4782$var$InternalCssVarsProvider, {
        ...props
    });
}
let $8045e99d413e4782$var$warnedInitScriptOnce = false;
// TODO: remove in v7
const $8045e99d413e4782$var$getInitColorSchemeScript = (params)=>{
    if (!$8045e99d413e4782$var$warnedInitScriptOnce) {
        console.warn([
            'MUI: The getInitColorSchemeScript function has been deprecated.',
            '',
            "You should use `import InitColorSchemeScript from '@mui/material/InitColorSchemeScript'`",
            'and replace the function call with `<InitColorSchemeScript />` instead.'
        ].join('\n'));
        $8045e99d413e4782$var$warnedInitScriptOnce = true;
    }
    return $8045e99d413e4782$var$deprecatedGetInitColorSchemeScript(params);
};
/**
 * TODO: remove this export in v7
 * @deprecated
 * The `CssVarsProvider` component has been deprecated and ported into `ThemeProvider`.
 *
 * You should use `ThemeProvider` and `createTheme()` instead:
 *
 * ```diff
 * - import { CssVarsProvider, extendTheme } from '@mui/material/styles';
 * + import { ThemeProvider, createTheme } from '@mui/material/styles';
 *
 * - const theme = extendTheme();
 * + const theme = createTheme({
 * +   cssVariables: true,
 * +   colorSchemes: { light: true, dark: true },
 * + });
 *
 * - <CssVarsProvider theme={theme}>
 * + <ThemeProvider theme={theme}>
 * ```
 *
 * To see the full documentation, check out https://mui.com/material-ui/customization/css-theme-variables/usage/.
 */ module.exports.getInitColorSchemeScript = $8045e99d413e4782$var$getInitColorSchemeScript;
const $8045e99d413e4782$var$CssVarsProvider = module.exports.CssVarsProvider = $8045e99d413e4782$var$InternalCssVarsProvider;

});
parcelRegister("3K3i6", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $2b983880bbf899cb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultConfig = module.exports.default = void 0;

var $2b983880bbf899cb$var$_propTypes = $2b983880bbf899cb$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $2b983880bbf899cb$var$_InitColorSchemeScript = $2b983880bbf899cb$require$_interopRequireDefault((parcelRequire("5UPwK")));

var $ayMG0 = parcelRequire("ayMG0");
const $2b983880bbf899cb$var$defaultConfig = module.exports.defaultConfig = {
    attribute: 'data-mui-color-scheme',
    colorSchemeStorageKey: 'mui-color-scheme',
    defaultLightColorScheme: 'light',
    defaultDarkColorScheme: 'dark',
    modeStorageKey: 'mui-mode'
};
/**
 *
 * Demos:
 *
 * - [InitColorSchemeScript](https://v7.mui.com/material-ui/react-init-color-scheme-script/)
 *
 * API:
 *
 * - [InitColorSchemeScript API](https://v7.mui.com/material-ui/api/init-color-scheme-script/)
 */ function $2b983880bbf899cb$var$InitColorSchemeScript(props) {
    const { defaultMode: defaultMode = 'system', defaultLightColorScheme: defaultLightColorScheme = $2b983880bbf899cb$var$defaultConfig.defaultLightColorScheme, defaultDarkColorScheme: defaultDarkColorScheme = $2b983880bbf899cb$var$defaultConfig.defaultDarkColorScheme, modeStorageKey: modeStorageKey = $2b983880bbf899cb$var$defaultConfig.modeStorageKey, colorSchemeStorageKey: colorSchemeStorageKey = $2b983880bbf899cb$var$defaultConfig.colorSchemeStorageKey, attribute: initialAttribute = $2b983880bbf899cb$var$defaultConfig.attribute, colorSchemeNode: colorSchemeNode = 'document.documentElement', nonce: nonce } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($2b983880bbf899cb$var$_InitColorSchemeScript.default, {
        defaultMode: defaultMode,
        defaultLightColorScheme: defaultLightColorScheme,
        defaultDarkColorScheme: defaultDarkColorScheme,
        modeStorageKey: modeStorageKey,
        colorSchemeStorageKey: colorSchemeStorageKey,
        attribute: initialAttribute,
        colorSchemeNode: colorSchemeNode,
        nonce: nonce
    });
}
$2b983880bbf899cb$var$InitColorSchemeScript.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * DOM attribute for applying a color scheme.
   * @default 'data-mui-color-scheme'
   * @example '.mode-%s' // for class based color scheme
   * @example '[data-mode-%s]' // for data-attribute without '='
   */ attribute: $2b983880bbf899cb$var$_propTypes.default.string,
    /**
   * The node (provided as string) used to attach the color-scheme attribute.
   * @default 'document.documentElement'
   */ colorSchemeNode: $2b983880bbf899cb$var$_propTypes.default.string,
    /**
   * localStorage key used to store `colorScheme`.
   * @default 'mui-color-scheme'
   */ colorSchemeStorageKey: $2b983880bbf899cb$var$_propTypes.default.string,
    /**
   * The default color scheme to be used in dark mode.
   * @default 'dark'
   */ defaultDarkColorScheme: $2b983880bbf899cb$var$_propTypes.default.string,
    /**
   * The default color scheme to be used in light mode.
   * @default 'light'
   */ defaultLightColorScheme: $2b983880bbf899cb$var$_propTypes.default.string,
    /**
   * The default mode when the storage is empty (user's first visit).
   * @default 'system'
   */ defaultMode: $2b983880bbf899cb$var$_propTypes.default.oneOf([
        'dark',
        'light',
        'system'
    ]),
    /**
   * localStorage key used to store `mode`.
   * @default 'mui-mode'
   */ modeStorageKey: $2b983880bbf899cb$var$_propTypes.default.string,
    /**
   * Nonce string to pass to the inline script for CSP headers.
   */ nonce: $2b983880bbf899cb$var$_propTypes.default.string
};
var $2b983880bbf899cb$var$_default = module.exports.default = $2b983880bbf899cb$var$InitColorSchemeScript;

});
parcelRegister("5UPwK", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $44ea26ea463a672a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $44ea26ea463a672a$var$_InitColorSchemeScript.default;
    }
});

var $44ea26ea463a672a$var$_InitColorSchemeScript = $44ea26ea463a672a$require$_interopRequireDefault((parcelRequire("79OI6")));

});




parcelRegister("kLL7M", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f1ecc062bbad3379$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f1ecc062bbad3379$var$makeStyles;

var $f1ecc062bbad3379$var$_formatMuiErrorMessage = $f1ecc062bbad3379$require$_interopRequireDefault((parcelRequire("4Z6Nd")));
function $f1ecc062bbad3379$var$makeStyles() {
    throw new Error("MUI: makeStyles is no longer exported from @mui/material/styles.\nYou have to import it from @mui/styles.\nSee https://mui.com/r/migration-v4/#mui-material-styles for more details.");
}

});

parcelRegister("7i0uy", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $015e9f5cd865f1ca$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $015e9f5cd865f1ca$var$withStyles;

var $015e9f5cd865f1ca$var$_formatMuiErrorMessage = $015e9f5cd865f1ca$require$_interopRequireDefault((parcelRequire("4Z6Nd")));
function $015e9f5cd865f1ca$var$withStyles() {
    throw new Error("MUI: withStyles is no longer exported from @mui/material/styles.\nYou have to import it from @mui/styles.\nSee https://mui.com/r/migration-v4/#mui-material-styles for more details.");
}

});

parcelRegister("lXubi", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ffc685059eb0526f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ffc685059eb0526f$var$withTheme;

var $ffc685059eb0526f$var$_formatMuiErrorMessage = $ffc685059eb0526f$require$_interopRequireDefault((parcelRequire("4Z6Nd")));
function $ffc685059eb0526f$var$withTheme() {
    throw new Error("MUI: withTheme is no longer exported from @mui/material/styles.\nYou have to import it from @mui/styles.\nSee https://mui.com/r/migration-v4/#mui-material-styles for more details.");
}

});

parcelRegister("dj1n2", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9afe1ce524e8f62d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9afe1ce524e8f62d$var$deprecatedExtendTheme;

var $9afe1ce524e8f62d$var$_createThemeWithVars = $9afe1ce524e8f62d$require$_interopRequireDefault((parcelRequire("eLI0w")));
let $9afe1ce524e8f62d$var$warnedOnce = false;
function $9afe1ce524e8f62d$var$deprecatedExtendTheme(...args) {
    if (!$9afe1ce524e8f62d$var$warnedOnce) {
        console.warn([
            'MUI: The `experimental_extendTheme` has been stabilized.',
            '',
            "You should use `import { extendTheme } from '@mui/material/styles'`"
        ].join('\n'));
        $9afe1ce524e8f62d$var$warnedOnce = true;
    }
    return (0, $9afe1ce524e8f62d$var$_createThemeWithVars.default)(...args);
}

});


parcelRegister("aBB4t", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $7b8a1da92f713a60$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $7b8a1da92f713a60$var$_exportNames = {
    createFilterOptions: true,
    autocompleteClasses: true
};
Object.defineProperty(module.exports, "autocompleteClasses", {
    enumerable: true,
    get: function() {
        return $7b8a1da92f713a60$var$_autocompleteClasses.default;
    }
});
Object.defineProperty(module.exports, "createFilterOptions", {
    enumerable: true,
    get: function() {
        return $7b8a1da92f713a60$var$_Autocomplete.createFilterOptions;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $7b8a1da92f713a60$var$_Autocomplete.default;
    }
});

var $7b8a1da92f713a60$var$_Autocomplete = $7b8a1da92f713a60$require$_interopRequireWildcard((parcelRequire("cFBau")));

var $7b8a1da92f713a60$var$_autocompleteClasses = $7b8a1da92f713a60$require$_interopRequireWildcard((parcelRequire("9O25J")));
Object.keys($7b8a1da92f713a60$var$_autocompleteClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($7b8a1da92f713a60$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $7b8a1da92f713a60$var$_autocompleteClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7b8a1da92f713a60$var$_autocompleteClasses[key];
        }
    });
});

});
parcelRegister("cFBau", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $9396253983985262$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $9396253983985262$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "createFilterOptions", {
    enumerable: true,
    get: function() {
        return $9396253983985262$var$_useAutocomplete.createFilterOptions;
    }
});
module.exports.default = void 0;

var $9396253983985262$var$React = $9396253983985262$require$_interopRequireWildcard((parcelRequire("acw62")));

var $9396253983985262$var$_propTypes = $9396253983985262$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $9396253983985262$var$_integerPropType = $9396253983985262$require$_interopRequireDefault((parcelRequire("cxaSP")));

var $9396253983985262$var$_chainPropTypes = $9396253983985262$require$_interopRequireDefault((parcelRequire("abVWF")));

var $9396253983985262$var$_composeClasses = $9396253983985262$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $9396253983985262$var$_useForcedRerendering = $9396253983985262$require$_interopRequireDefault((parcelRequire("i7W0V")));

var $9396253983985262$var$_useEnhancedEffect = $9396253983985262$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $9396253983985262$var$_useAutocomplete = $9396253983985262$require$_interopRequireWildcard((parcelRequire("g924V")));

var $9396253983985262$var$_Popper = $9396253983985262$require$_interopRequireDefault((parcelRequire("eWJe7")));

var $9396253983985262$var$_ListSubheader = $9396253983985262$require$_interopRequireDefault((parcelRequire("1hfjF")));

var $9396253983985262$var$_Paper = $9396253983985262$require$_interopRequireDefault((parcelRequire("juRJQ")));

var $9396253983985262$var$_IconButton = $9396253983985262$require$_interopRequireDefault((parcelRequire("825Zh")));

var $9396253983985262$var$_Chip = $9396253983985262$require$_interopRequireDefault((parcelRequire("6p5K7")));

var $9396253983985262$var$_inputClasses = $9396253983985262$require$_interopRequireDefault((parcelRequire("b3ugU")));

var $9396253983985262$var$_inputBaseClasses = $9396253983985262$require$_interopRequireDefault((parcelRequire("dmljZ")));

var $9396253983985262$var$_outlinedInputClasses = $9396253983985262$require$_interopRequireDefault((parcelRequire("96QZi")));

var $9396253983985262$var$_filledInputClasses = $9396253983985262$require$_interopRequireDefault((parcelRequire("faAxf")));

var $9396253983985262$var$_Close = $9396253983985262$require$_interopRequireDefault((parcelRequire("ldBGF")));

var $9396253983985262$var$_ArrowDropDown = $9396253983985262$require$_interopRequireDefault((parcelRequire("7LRfY")));

var $aAbgT = parcelRequire("aAbgT");

var $9396253983985262$var$_memoTheme = $9396253983985262$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $9396253983985262$var$_autocompleteClasses = $9396253983985262$require$_interopRequireWildcard((parcelRequire("9O25J")));

var $9396253983985262$var$_capitalize = $9396253983985262$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $9396253983985262$var$_useSlot = $9396253983985262$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
var $9396253983985262$var$_ClearIcon, $9396253983985262$var$_ArrowDropDownIcon;
const $9396253983985262$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePortal: disablePortal, expanded: expanded, focused: focused, fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, popupOpen: popupOpen, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            expanded && 'expanded',
            focused && 'focused',
            fullWidth && 'fullWidth',
            hasClearIcon && 'hasClearIcon',
            hasPopupIcon && 'hasPopupIcon'
        ],
        inputRoot: [
            'inputRoot'
        ],
        input: [
            'input',
            inputFocused && 'inputFocused'
        ],
        tag: [
            'tag',
            `tagSize${(0, $9396253983985262$var$_capitalize.default)(size)}`
        ],
        endAdornment: [
            'endAdornment'
        ],
        clearIndicator: [
            'clearIndicator'
        ],
        popupIndicator: [
            'popupIndicator',
            popupOpen && 'popupIndicatorOpen'
        ],
        popper: [
            'popper',
            disablePortal && 'popperDisablePortal'
        ],
        paper: [
            'paper'
        ],
        listbox: [
            'listbox'
        ],
        loading: [
            'loading'
        ],
        noOptions: [
            'noOptions'
        ],
        option: [
            'option'
        ],
        groupLabel: [
            'groupLabel'
        ],
        groupUl: [
            'groupUl'
        ]
    };
    return (0, $9396253983985262$var$_composeClasses.default)(slots, $9396253983985262$var$_autocompleteClasses.getAutocompleteUtilityClass, classes);
};
const $9396253983985262$var$AutocompleteRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiAutocomplete',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, size: size } = ownerState;
        return [
            {
                [`& .${$9396253983985262$var$_autocompleteClasses.default.tag}`]: styles.tag
            },
            {
                [`& .${$9396253983985262$var$_autocompleteClasses.default.tag}`]: styles[`tagSize${(0, $9396253983985262$var$_capitalize.default)(size)}`]
            },
            {
                [`& .${$9396253983985262$var$_autocompleteClasses.default.inputRoot}`]: styles.inputRoot
            },
            {
                [`& .${$9396253983985262$var$_autocompleteClasses.default.input}`]: styles.input
            },
            {
                [`& .${$9396253983985262$var$_autocompleteClasses.default.input}`]: inputFocused && styles.inputFocused
            },
            styles.root,
            fullWidth && styles.fullWidth,
            hasPopupIcon && styles.hasPopupIcon,
            hasClearIcon && styles.hasClearIcon
        ];
    }
})({
    [`&.${$9396253983985262$var$_autocompleteClasses.default.focused} .${$9396253983985262$var$_autocompleteClasses.default.clearIndicator}`]: {
        visibility: 'visible'
    },
    /* Avoid double tap issue on iOS */ '@media (pointer: fine)': {
        [`&:hover .${$9396253983985262$var$_autocompleteClasses.default.clearIndicator}`]: {
            visibility: 'visible'
        }
    },
    [`& .${$9396253983985262$var$_autocompleteClasses.default.tag}`]: {
        margin: 3,
        maxWidth: 'calc(100% - 6px)'
    },
    [`& .${$9396253983985262$var$_autocompleteClasses.default.inputRoot}`]: {
        [`.${$9396253983985262$var$_autocompleteClasses.default.hasPopupIcon}&, .${$9396253983985262$var$_autocompleteClasses.default.hasClearIcon}&`]: {
            paddingRight: 30
        },
        [`.${$9396253983985262$var$_autocompleteClasses.default.hasPopupIcon}.${$9396253983985262$var$_autocompleteClasses.default.hasClearIcon}&`]: {
            paddingRight: 56
        },
        [`& .${$9396253983985262$var$_autocompleteClasses.default.input}`]: {
            width: 0,
            minWidth: 30
        }
    },
    [`& .${$9396253983985262$var$_inputClasses.default.root}`]: {
        paddingBottom: 1,
        '& .MuiInput-input': {
            padding: '4px 4px 4px 0px'
        }
    },
    [`& .${$9396253983985262$var$_inputClasses.default.root}.${$9396253983985262$var$_inputBaseClasses.default.sizeSmall}`]: {
        [`& .${$9396253983985262$var$_inputClasses.default.input}`]: {
            padding: '2px 4px 3px 0'
        }
    },
    [`& .${$9396253983985262$var$_outlinedInputClasses.default.root}`]: {
        padding: 9,
        [`.${$9396253983985262$var$_autocompleteClasses.default.hasPopupIcon}&, .${$9396253983985262$var$_autocompleteClasses.default.hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${$9396253983985262$var$_autocompleteClasses.default.hasPopupIcon}.${$9396253983985262$var$_autocompleteClasses.default.hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${$9396253983985262$var$_autocompleteClasses.default.input}`]: {
            padding: '7.5px 4px 7.5px 5px'
        },
        [`& .${$9396253983985262$var$_autocompleteClasses.default.endAdornment}`]: {
            right: 9
        }
    },
    [`& .${$9396253983985262$var$_outlinedInputClasses.default.root}.${$9396253983985262$var$_inputBaseClasses.default.sizeSmall}`]: {
        // Don't specify paddingRight, as it overrides the default value set when there is only
        // one of the popup or clear icon as the specificity is equal so the latter one wins
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 6,
        [`& .${$9396253983985262$var$_autocompleteClasses.default.input}`]: {
            padding: '2.5px 4px 2.5px 8px'
        }
    },
    [`& .${$9396253983985262$var$_filledInputClasses.default.root}`]: {
        paddingTop: 19,
        paddingLeft: 8,
        [`.${$9396253983985262$var$_autocompleteClasses.default.hasPopupIcon}&, .${$9396253983985262$var$_autocompleteClasses.default.hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${$9396253983985262$var$_autocompleteClasses.default.hasPopupIcon}.${$9396253983985262$var$_autocompleteClasses.default.hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${$9396253983985262$var$_filledInputClasses.default.input}`]: {
            padding: '7px 4px'
        },
        [`& .${$9396253983985262$var$_autocompleteClasses.default.endAdornment}`]: {
            right: 9
        }
    },
    [`& .${$9396253983985262$var$_filledInputClasses.default.root}.${$9396253983985262$var$_inputBaseClasses.default.sizeSmall}`]: {
        paddingBottom: 1,
        [`& .${$9396253983985262$var$_filledInputClasses.default.input}`]: {
            padding: '2.5px 4px'
        }
    },
    [`& .${$9396253983985262$var$_inputBaseClasses.default.hiddenLabel}`]: {
        paddingTop: 8
    },
    [`& .${$9396253983985262$var$_filledInputClasses.default.root}.${$9396253983985262$var$_inputBaseClasses.default.hiddenLabel}`]: {
        paddingTop: 0,
        paddingBottom: 0,
        [`& .${$9396253983985262$var$_autocompleteClasses.default.input}`]: {
            paddingTop: 16,
            paddingBottom: 17
        }
    },
    [`& .${$9396253983985262$var$_filledInputClasses.default.root}.${$9396253983985262$var$_inputBaseClasses.default.hiddenLabel}.${$9396253983985262$var$_inputBaseClasses.default.sizeSmall}`]: {
        [`& .${$9396253983985262$var$_autocompleteClasses.default.input}`]: {
            paddingTop: 8,
            paddingBottom: 9
        }
    },
    [`& .${$9396253983985262$var$_autocompleteClasses.default.input}`]: {
        flexGrow: 1,
        textOverflow: 'ellipsis',
        opacity: 0
    },
    variants: [
        {
            props: {
                fullWidth: true
            },
            style: {
                width: '100%'
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                [`& .${$9396253983985262$var$_autocompleteClasses.default.tag}`]: {
                    margin: 2,
                    maxWidth: 'calc(100% - 4px)'
                }
            }
        },
        {
            props: {
                inputFocused: true
            },
            style: {
                [`& .${$9396253983985262$var$_autocompleteClasses.default.input}`]: {
                    opacity: 1
                }
            }
        },
        {
            props: {
                multiple: true
            },
            style: {
                [`& .${$9396253983985262$var$_autocompleteClasses.default.inputRoot}`]: {
                    flexWrap: 'wrap'
                }
            }
        }
    ]
});
const $9396253983985262$var$AutocompleteEndAdornment = (0, $aAbgT.styled)('div', {
    name: 'MuiAutocomplete',
    slot: 'EndAdornment'
})({
    // We use a position absolute to support wrapping tags.
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translate(0, -50%)'
});
const $9396253983985262$var$AutocompleteClearIndicator = (0, $aAbgT.styled)($9396253983985262$var$_IconButton.default, {
    name: 'MuiAutocomplete',
    slot: 'ClearIndicator'
})({
    marginRight: -2,
    padding: 4,
    visibility: 'hidden'
});
const $9396253983985262$var$AutocompletePopupIndicator = (0, $aAbgT.styled)($9396253983985262$var$_IconButton.default, {
    name: 'MuiAutocomplete',
    slot: 'PopupIndicator',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popupIndicator,
            ownerState.popupOpen && styles.popupIndicatorOpen
        ];
    }
})({
    padding: 2,
    marginRight: -2,
    variants: [
        {
            props: {
                popupOpen: true
            },
            style: {
                transform: 'rotate(180deg)'
            }
        }
    ]
});
const $9396253983985262$var$AutocompletePopper = (0, $aAbgT.styled)($9396253983985262$var$_Popper.default, {
    name: 'MuiAutocomplete',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${$9396253983985262$var$_autocompleteClasses.default.option}`]: styles.option
            },
            styles.popper,
            ownerState.disablePortal && styles.popperDisablePortal
        ];
    }
})((0, $9396253983985262$var$_memoTheme.default)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.modal,
        variants: [
            {
                props: {
                    disablePortal: true
                },
                style: {
                    position: 'absolute'
                }
            }
        ]
    })));
const $9396253983985262$var$AutocompletePaper = (0, $aAbgT.styled)($9396253983985262$var$_Paper.default, {
    name: 'MuiAutocomplete',
    slot: 'Paper'
})((0, $9396253983985262$var$_memoTheme.default)(({ theme: theme })=>({
        ...theme.typography.body1,
        overflow: 'auto'
    })));
const $9396253983985262$var$AutocompleteLoading = (0, $aAbgT.styled)('div', {
    name: 'MuiAutocomplete',
    slot: 'Loading'
})((0, $9396253983985262$var$_memoTheme.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: '14px 16px'
    })));
const $9396253983985262$var$AutocompleteNoOptions = (0, $aAbgT.styled)('div', {
    name: 'MuiAutocomplete',
    slot: 'NoOptions'
})((0, $9396253983985262$var$_memoTheme.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: '14px 16px'
    })));
const $9396253983985262$var$AutocompleteListbox = (0, $aAbgT.styled)('ul', {
    name: 'MuiAutocomplete',
    slot: 'Listbox'
})((0, $9396253983985262$var$_memoTheme.default)(({ theme: theme })=>({
        listStyle: 'none',
        margin: 0,
        padding: '8px 0',
        maxHeight: '40vh',
        overflow: 'auto',
        position: 'relative',
        [`& .${$9396253983985262$var$_autocompleteClasses.default.option}`]: {
            minHeight: 48,
            display: 'flex',
            overflow: 'hidden',
            justifyContent: 'flex-start',
            alignItems: 'center',
            cursor: 'pointer',
            paddingTop: 6,
            boxSizing: 'border-box',
            outline: '0',
            WebkitTapHighlightColor: 'transparent',
            paddingBottom: 6,
            paddingLeft: 16,
            paddingRight: 16,
            [theme.breakpoints.up('sm')]: {
                minHeight: 'auto'
            },
            [`&.${$9396253983985262$var$_autocompleteClasses.default.focused}`]: {
                backgroundColor: (theme.vars || theme).palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            '&[aria-disabled="true"]': {
                opacity: (theme.vars || theme).palette.action.disabledOpacity,
                pointerEvents: 'none'
            },
            [`&.${$9396253983985262$var$_autocompleteClasses.default.focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette.action.focus
            },
            '&[aria-selected="true"]': {
                backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity),
                [`&.${$9396253983985262$var$_autocompleteClasses.default.focused}`]: {
                    backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: (theme.vars || theme).palette.action.selected
                    }
                },
                [`&.${$9396253983985262$var$_autocompleteClasses.default.focusVisible}`]: {
                    backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
                }
            }
        }
    })));
const $9396253983985262$var$AutocompleteGroupLabel = (0, $aAbgT.styled)($9396253983985262$var$_ListSubheader.default, {
    name: 'MuiAutocomplete',
    slot: 'GroupLabel'
})((0, $9396253983985262$var$_memoTheme.default)(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        top: -8
    })));
const $9396253983985262$var$AutocompleteGroupUl = (0, $aAbgT.styled)('ul', {
    name: 'MuiAutocomplete',
    slot: 'GroupUl'
})({
    padding: 0,
    [`& .${$9396253983985262$var$_autocompleteClasses.default.option}`]: {
        paddingLeft: 24
    }
});
const $9396253983985262$var$Autocomplete = /*#__PURE__*/ $9396253983985262$var$React.forwardRef(function Autocomplete(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiAutocomplete'
    });
    /* eslint-disable @typescript-eslint/no-unused-vars */ const { autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, ChipProps: ChipPropsProp, className: className, clearIcon: clearIcon = $9396253983985262$var$_ClearIcon || ($9396253983985262$var$_ClearIcon = /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$_Close.default, {
        fontSize: "small"
    })), clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, clearText: clearText = 'Clear', closeText: closeText = 'Close', componentsProps: componentsProps, defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabled = false, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, disablePortal: disablePortal = false, filterOptions: filterOptions, filterSelectedOptions: filterSelectedOptions = false, forcePopupIcon: forcePopupIcon = 'auto', freeSolo: freeSolo = false, fullWidth: fullWidth = false, getLimitTagsText: getLimitTagsText = (more)=>`+${more}`, getOptionDisabled: getOptionDisabled, getOptionKey: getOptionKey, getOptionLabel: getOptionLabelProp, isOptionEqualToValue: isOptionEqualToValue, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList: includeInputInList = false, inputValue: inputValueProp, limitTags: limitTags = -1, ListboxComponent: ListboxComponentProp, ListboxProps: ListboxPropsProp, loading: loading = false, loadingText: loadingText = "Loading\u2026", multiple: multiple = false, noOptionsText: noOptionsText = 'No options', onChange: onChange, onClose: onClose, onHighlightChange: onHighlightChange, onInputChange: onInputChange, onOpen: onOpen, open: open, openOnFocus: openOnFocus = false, openText: openText = 'Open', options: options, PaperComponent: PaperComponentProp, PopperComponent: PopperComponentProp, popupIcon: popupIcon = $9396253983985262$var$_ArrowDropDownIcon || ($9396253983985262$var$_ArrowDropDownIcon = /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$_ArrowDropDown.default, {})), readOnly: readOnly = false, renderGroup: renderGroupProp, renderInput: renderInput, renderOption: renderOptionProp, renderTags: renderTags, renderValue: renderValue, selectOnFocus: selectOnFocus = !props.freeSolo, size: size = 'medium', slots: slots = {}, slotProps: slotProps = {}, value: valueProp, ...other } = props;
    /* eslint-enable @typescript-eslint/no-unused-vars */ const { getRootProps: getRootProps, getInputProps: getInputProps, getInputLabelProps: getInputLabelProps, getPopupIndicatorProps: getPopupIndicatorProps, getClearProps: getClearProps, getItemProps: getItemProps, getListboxProps: getListboxProps, getOptionProps: getOptionProps, value: value, dirty: dirty, expanded: expanded, id: id, popupOpen: popupOpen, focused: focused, focusedItem: focusedItem, anchorEl: anchorEl, setAnchorEl: setAnchorEl, inputValue: inputValue, groupedOptions: groupedOptions } = (0, $9396253983985262$var$_useAutocomplete.default)({
        ...props,
        componentName: 'Autocomplete'
    });
    // Re-render when anchorEl resizes so the Popper width stays in sync.
    // Width is always read synchronously from anchorEl.clientWidth during render
    // (no stale cached value). The hook just triggers a re-render on resize.
    const forceRenderOnResize = (0, $9396253983985262$var$_useForcedRerendering.default)();
    $9396253983985262$var$React.useEffect(()=>{
        if (!popupOpen || !anchorEl || typeof ResizeObserver === 'undefined') return undefined;
        let lastWidth = anchorEl.clientWidth;
        const observer = new ResizeObserver(()=>{
            const newWidth = anchorEl.clientWidth;
            if (lastWidth !== newWidth) {
                lastWidth = newWidth;
                forceRenderOnResize();
            }
        });
        observer.observe(anchorEl);
        return ()=>{
            observer.disconnect();
        };
    }, [
        popupOpen,
        anchorEl,
        forceRenderOnResize
    ]);
    // When popupOpen becomes false, useAutocomplete returns [] for groupedOptions.
    // Transitioned Poppers can remain mounted for their exit animation, so keep rendering
    // the last open-state options instead of flashing "No options" or an empty Paper.
    // These options are stale because they no longer reflect the hook's current
    // groupedOptions, but they are non-interactive while closing and reset on next open.
    const previousGroupedOptionsRef = $9396253983985262$var$React.useRef([]);
    const prevPopupOpenRef = $9396253983985262$var$React.useRef(false);
    const renderedOptions = popupOpen ? groupedOptions : previousGroupedOptionsRef.current;
    (0, $9396253983985262$var$_useEnhancedEffect.default)(()=>{
        if (popupOpen && !prevPopupOpenRef.current) previousGroupedOptionsRef.current = [];
        prevPopupOpenRef.current = popupOpen;
        if (popupOpen && groupedOptions.length > 0) previousGroupedOptionsRef.current = groupedOptions;
    }, [
        popupOpen,
        groupedOptions
    ]);
    const hasClearIcon = !disableClearable && !disabled && dirty && !readOnly;
    const hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
    const { onMouseDown: handleInputMouseDown } = getInputProps();
    const { ref: listboxRef, ...otherListboxProps } = getListboxProps();
    const defaultGetOptionLabel = (option)=>option.label ?? option;
    const getOptionLabel = getOptionLabelProp || defaultGetOptionLabel;
    // If you modify this, make sure to keep the `AutocompleteOwnerState` type in sync.
    const ownerState = {
        ...props,
        disablePortal: disablePortal,
        expanded: expanded,
        focused: focused,
        fullWidth: fullWidth,
        getOptionLabel: getOptionLabel,
        hasClearIcon: hasClearIcon,
        hasPopupIcon: hasPopupIcon,
        inputFocused: focusedItem === -1,
        popupOpen: popupOpen,
        size: size
    };
    const classes = $9396253983985262$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: {
            paper: PaperComponentProp,
            popper: PopperComponentProp,
            ...slots
        },
        slotProps: {
            chip: ChipPropsProp,
            listbox: ListboxPropsProp,
            ...componentsProps,
            ...slotProps
        }
    };
    const [RootSlot, rootProps] = (0, $9396253983985262$var$_useSlot.default)('root', {
        ref: ref,
        className: [
            classes.root,
            className
        ],
        elementType: $9396253983985262$var$AutocompleteRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        getSlotProps: getRootProps,
        ownerState: ownerState
    });
    const [ListboxSlot, listboxProps] = (0, $9396253983985262$var$_useSlot.default)('listbox', {
        elementType: $9396253983985262$var$AutocompleteListbox,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.listbox,
        additionalProps: otherListboxProps,
        ref: listboxRef
    });
    const [PaperSlot, paperProps] = (0, $9396253983985262$var$_useSlot.default)('paper', {
        elementType: $9396253983985262$var$_Paper.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.paper
    });
    const [PopperSlot, popperProps] = (0, $9396253983985262$var$_useSlot.default)('popper', {
        elementType: $9396253983985262$var$_Popper.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.popper,
        additionalProps: {
            disablePortal: disablePortal,
            style: {
                width: anchorEl ? anchorEl.clientWidth : null,
                // Prevent interaction with stale cached options during exit transitions.
                // The hook's filteredOptions is [] when popupOpen=false, so clicks on stale
                // rendered options would pass undefined to selectNewValue.
                pointerEvents: popupOpen ? undefined : 'none'
            },
            role: 'presentation',
            anchorEl: anchorEl,
            open: popupOpen
        }
    });
    // Don't render the Popper when there's no content to show.
    // In freeSolo mode, "No options" text is suppressed, so if there are also no
    // matching options and loading is false, the Paper would be empty.
    // Uses renderedOptions (not groupedOptions) so Popper stays during exit transitions.
    // Respect keepMounted from resolved popperProps (handles both object and callback slotProps forms).
    const hasPopupContent = renderedOptions.length > 0 || loading || !freeSolo || popperProps.keepMounted === true;
    const [ClearIndicatorSlot, clearIndicatorProps] = (0, $9396253983985262$var$_useSlot.default)('clearIndicator', {
        elementType: $9396253983985262$var$AutocompleteClearIndicator,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.clearIndicator,
        shouldForwardComponentProp: true,
        additionalProps: {
            ...getClearProps(),
            'aria-label': clearText,
            title: clearText
        }
    });
    const [PopupIndicatorSlot, popupIndicatorProps] = (0, $9396253983985262$var$_useSlot.default)('popupIndicator', {
        elementType: $9396253983985262$var$AutocompletePopupIndicator,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.popupIndicator,
        shouldForwardComponentProp: true,
        additionalProps: {
            ...getPopupIndicatorProps(),
            disabled: disabled,
            'aria-label': popupOpen ? closeText : openText,
            title: popupOpen ? closeText : openText
        }
    });
    let startAdornment;
    const getCustomizedItemProps = (params)=>({
            className: classes.tag,
            disabled: disabled,
            ...getItemProps(params)
        });
    if (multiple) {
        if (value.length > 0) {
            if (renderTags) startAdornment = renderTags(value, getCustomizedItemProps, ownerState);
            else if (renderValue) startAdornment = renderValue(value, getCustomizedItemProps, ownerState);
            else startAdornment = value.map((option, index)=>{
                const { key: key, ...customItemProps } = getCustomizedItemProps({
                    index: index
                });
                return /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$_Chip.default, {
                    label: getOptionLabel(option),
                    size: size,
                    ...customItemProps,
                    ...externalForwardedProps.slotProps.chip
                }, key);
            });
        }
    } else if (renderValue && value != null) startAdornment = renderValue(value, getCustomizedItemProps, ownerState);
    if (limitTags > -1 && Array.isArray(startAdornment)) {
        const more = startAdornment.length - limitTags;
        if (!focused && more > 0) {
            startAdornment = startAdornment.splice(0, limitTags);
            startAdornment.push(/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: classes.tag,
                children: getLimitTagsText(more)
            }, startAdornment.length));
        }
    }
    const defaultRenderGroup = (params)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteGroupLabel, {
                    className: classes.groupLabel,
                    ownerState: ownerState,
                    component: "div",
                    children: params.group
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteGroupUl, {
                    className: classes.groupUl,
                    ownerState: ownerState,
                    children: params.children
                })
            ]
        }, params.key);
    const renderGroup = renderGroupProp || defaultRenderGroup;
    const defaultRenderOption = (props2, option)=>{
        // Need to clearly apply key because of https://github.com/vercel/next.js/issues/55642
        const { key: key, ...otherProps } = props2;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
            ...otherProps,
            children: getOptionLabel(option)
        }, key);
    };
    const renderOption = renderOptionProp || defaultRenderOption;
    const renderListOption = (option, index)=>{
        const optionProps = getOptionProps({
            option: option,
            index: index
        });
        return renderOption({
            ...optionProps,
            className: classes.option
        }, option, {
            selected: optionProps['aria-selected'],
            index: index,
            inputValue: inputValue
        }, ownerState);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($9396253983985262$var$React.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, {
                ...rootProps,
                children: renderInput({
                    id: id,
                    disabled: disabled,
                    fullWidth: props.fullWidth ?? true,
                    size: size === 'small' ? 'small' : undefined,
                    InputLabelProps: getInputLabelProps(),
                    InputProps: {
                        ref: setAnchorEl,
                        className: classes.inputRoot,
                        startAdornment: startAdornment,
                        onMouseDown: (event)=>{
                            if (event.target === event.currentTarget) handleInputMouseDown(event);
                        },
                        ...(hasClearIcon || hasPopupIcon) && {
                            endAdornment: /*#__PURE__*/ (0, $ayMG0.jsxs)($9396253983985262$var$AutocompleteEndAdornment, {
                                className: classes.endAdornment,
                                ownerState: ownerState,
                                children: [
                                    hasClearIcon ? /*#__PURE__*/ (0, $ayMG0.jsx)(ClearIndicatorSlot, {
                                        ...clearIndicatorProps,
                                        children: clearIcon
                                    }) : null,
                                    hasPopupIcon ? /*#__PURE__*/ (0, $ayMG0.jsx)(PopupIndicatorSlot, {
                                        ...popupIndicatorProps,
                                        children: popupIcon
                                    }) : null
                                ]
                            })
                        }
                    },
                    inputProps: {
                        className: classes.input,
                        disabled: disabled,
                        readOnly: readOnly,
                        ...getInputProps()
                    }
                })
            }),
            anchorEl && hasPopupContent ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompletePopper, {
                as: PopperSlot,
                ...popperProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)($9396253983985262$var$AutocompletePaper, {
                    as: PaperSlot,
                    ...paperProps,
                    children: [
                        loading && renderedOptions.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteLoading, {
                            className: classes.loading,
                            ownerState: ownerState,
                            children: loadingText
                        }) : null,
                        renderedOptions.length === 0 && !freeSolo && !loading ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteNoOptions, {
                            className: classes.noOptions,
                            ownerState: ownerState,
                            role: "presentation",
                            onMouseDown: (event)=>{
                                // Prevent input blur when interacting with the "no options" content
                                event.preventDefault();
                            },
                            children: noOptionsText
                        }) : null,
                        renderedOptions.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)(ListboxSlot, {
                            ...listboxProps,
                            children: renderedOptions.map((option, index)=>{
                                if (groupBy) return renderGroup({
                                    key: option.key,
                                    group: option.group,
                                    children: option.options.map((option2, index2)=>renderListOption(option2, option.index + index2))
                                });
                                return renderListOption(option, index);
                            })
                        }) : null
                    ]
                })
            }) : null
        ]
    });
});
$9396253983985262$var$Autocomplete.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * If `true`, the portion of the selected suggestion that the user hasn't typed,
   * known as the completion string, appears inline after the input cursor in the textbox.
   * The inline completion string is visually highlighted and has a selected state.
   * @default false
   */ autoComplete: $9396253983985262$var$_propTypes.default.bool,
    /**
   * If `true`, the first option is automatically highlighted.
   * @default false
   */ autoHighlight: $9396253983985262$var$_propTypes.default.bool,
    /**
   * If `true`, the value is updated when the input loses focus under one of these conditions:
   *
   * - An option highlighted via keyboard navigation or `autoHighlight` is selected.
   *   Hover and touch highlights are ignored.
   * - Otherwise, in `freeSolo` mode, the typed text becomes the value.
   * @default false
   */ autoSelect: $9396253983985262$var$_propTypes.default.bool,
    /**
   * Control if the input should be blurred when an option is selected:
   *
   * - `false` the input is not blurred.
   * - `true` the input is always blurred.
   * - `touch` the input is blurred after a touch event.
   * - `mouse` the input is blurred after a mouse event.
   * @default false
   */ blurOnSelect: $9396253983985262$var$_propTypes.default.oneOfType([
        $9396253983985262$var$_propTypes.default.oneOf([
            'mouse',
            'touch'
        ]),
        $9396253983985262$var$_propTypes.default.bool
    ]),
    /**
   * Props applied to the [`Chip`](https://mui.com/material-ui/api/chip/) element.
   * @deprecated Use `slotProps.chip` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ ChipProps: $9396253983985262$var$_propTypes.default.object,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $9396253983985262$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $9396253983985262$var$_propTypes.default.string,
    /**
   * The icon to display in place of the default clear icon.
   * @default <ClearIcon fontSize="small" />
   */ clearIcon: $9396253983985262$var$_propTypes.default.node,
    /**
   * If `true`, the input's text is cleared on blur if no value is selected.
   *
   * Set it to `true` if you want to help the user enter a new value.
   * Set it to `false` if you want to help the user resume their search.
   * @default !props.freeSolo
   */ clearOnBlur: $9396253983985262$var$_propTypes.default.bool,
    /**
   * If `true`, clear all values when the user presses escape and the popup is closed.
   * @default false
   */ clearOnEscape: $9396253983985262$var$_propTypes.default.bool,
    /**
   * Override the default text for the *clear* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Clear'
   */ clearText: $9396253983985262$var$_propTypes.default.string,
    /**
   * Override the default text for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Close'
   */ closeText: $9396253983985262$var$_propTypes.default.string,
    /**
   * The props used for each slot inside.
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ componentsProps: $9396253983985262$var$_propTypes.default.shape({
        clearIndicator: $9396253983985262$var$_propTypes.default.object,
        paper: $9396253983985262$var$_propTypes.default.object,
        popper: $9396253983985262$var$_propTypes.default.object,
        popupIndicator: $9396253983985262$var$_propTypes.default.object
    }),
    /**
   * The default value. Use when the component is not controlled.
   * @default props.multiple ? [] : null
   */ defaultValue: (0, $9396253983985262$var$_chainPropTypes.default)($9396253983985262$var$_propTypes.default.any, (props)=>{
        if (props.multiple && props.defaultValue !== undefined && !Array.isArray(props.defaultValue)) return new Error([
            'MUI: The Autocomplete expects the `defaultValue` prop to be an array when `multiple={true}` or undefined.',
            `However, ${props.defaultValue} was provided.`
        ].join('\n'));
        return null;
    }),
    /**
   * If `true`, the input can't be cleared.
   * @default false
   */ disableClearable: $9396253983985262$var$_propTypes.default.bool,
    /**
   * If `true`, the popup won't close when a value is selected.
   * @default false
   */ disableCloseOnSelect: $9396253983985262$var$_propTypes.default.bool,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: $9396253983985262$var$_propTypes.default.bool,
    /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */ disabledItemsFocusable: $9396253983985262$var$_propTypes.default.bool,
    /**
   * If `true`, the list box in the popup will not wrap focus.
   * @default false
   */ disableListWrap: $9396253983985262$var$_propTypes.default.bool,
    /**
   * If `true`, the `Popper` content will be under the DOM hierarchy of the parent component.
   * @default false
   */ disablePortal: $9396253983985262$var$_propTypes.default.bool,
    /**
   * A function that determines the filtered options to be rendered on search.
   *
   * @default createFilterOptions()
   * @param {Value[]} options The options to render.
   * @param {object} state The state of the component.
   * @returns {Value[]}
   */ filterOptions: $9396253983985262$var$_propTypes.default.func,
    /**
   * If `true`, hide the selected options from the list box.
   * @default false
   */ filterSelectedOptions: $9396253983985262$var$_propTypes.default.bool,
    /**
   * Force the visibility display of the popup icon.
   * @default 'auto'
   */ forcePopupIcon: $9396253983985262$var$_propTypes.default.oneOfType([
        $9396253983985262$var$_propTypes.default.oneOf([
            'auto'
        ]),
        $9396253983985262$var$_propTypes.default.bool
    ]),
    /**
   * If `true`, the Autocomplete is free solo, meaning that the user input is not bound to provided options.
   * @default false
   */ freeSolo: $9396253983985262$var$_propTypes.default.bool,
    /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */ fullWidth: $9396253983985262$var$_propTypes.default.bool,
    /**
   * The label to display when the tags are truncated (`limitTags`).
   *
   * @param {number} more The number of truncated tags.
   * @returns {ReactNode}
   * @default (more) => `+${more}`
   */ getLimitTagsText: $9396253983985262$var$_propTypes.default.func,
    /**
   * Used to determine the disabled state for a given option.
   *
   * @param {Value} option The option to test.
   * @template Value The option shape. Will be the same shape as an item of the options.
   * @returns {boolean}
   */ getOptionDisabled: $9396253983985262$var$_propTypes.default.func,
    /**
   * Used to determine the key for a given option.
   * This can be useful when the labels of options are not unique (since labels are used as keys by default).
   *
   * @param {Value} option The option to get the key for.
   * @returns {string | number}
   */ getOptionKey: $9396253983985262$var$_propTypes.default.func,
    /**
   * Used to determine the string value for a given option.
   * It's used to fill the input (and the list box options if `renderOption` is not provided).
   *
   * If used in free solo mode, it must accept both the type of the options and a string.
   *
   * @param {Value} option
   * @returns {string}
   * @default (option) => option.label ?? option
   */ getOptionLabel: $9396253983985262$var$_propTypes.default.func,
    /**
   * If provided, the options will be grouped under the returned string.
   * The groupBy value is also used as the text for group headings when `renderGroup` is not provided.
   *
   * @param {Value} option The Autocomplete option.
   * @returns {string}
   */ groupBy: $9396253983985262$var$_propTypes.default.func,
    /**
   * If `true`, the component handles the "Home" and "End" keys when the popup is open.
   * It should move focus to the first option and last option, respectively.
   * @default !props.freeSolo
   */ handleHomeEndKeys: $9396253983985262$var$_propTypes.default.bool,
    /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide an id it will fall back to a randomly generated one.
   */ id: $9396253983985262$var$_propTypes.default.string,
    /**
   * If `true`, the highlight can move to the input.
   * @default false
   */ includeInputInList: $9396253983985262$var$_propTypes.default.bool,
    /**
   * The input value.
   */ inputValue: $9396253983985262$var$_propTypes.default.string,
    /**
   * Used to determine if the option represents the given value.
   * Uses strict equality by default.
   * ⚠️ Both arguments need to be handled, an option can only match with one value.
   *
   * @param {Value} option The option to test.
   * @param {Value} value The value to test against.
   * @returns {boolean}
   */ isOptionEqualToValue: $9396253983985262$var$_propTypes.default.func,
    /**
   * The maximum number of tags that will be visible when not focused.
   * Set `-1` to disable the limit.
   * @default -1
   */ limitTags: $9396253983985262$var$_integerPropType.default,
    /**
   * The component used to render the listbox.
   * @default 'ul'
   * @deprecated Use `slotProps.listbox.component` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ ListboxComponent: $9396253983985262$var$_propTypes.default.elementType,
    /**
   * Props applied to the Listbox element.
   * @deprecated Use `slotProps.listbox` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ ListboxProps: $9396253983985262$var$_propTypes.default.object,
    /**
   * If `true`, the component is in a loading state.
   * This shows the `loadingText` in place of suggestions (only if there are no suggestions to show, for example `options` are empty).
   * @default false
   */ loading: $9396253983985262$var$_propTypes.default.bool,
    /**
   * Text to display when in a loading state.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Loading…'
   */ loadingText: $9396253983985262$var$_propTypes.default.node,
    /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */ multiple: $9396253983985262$var$_propTypes.default.bool,
    /**
   * Text to display when there are no options.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'No options'
   */ noOptionsText: $9396253983985262$var$_propTypes.default.node,
    /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value|Value[]} value The new value of the component.
   * @param {string} reason One of "createOption", "selectOption", "removeOption", "blur" or "clear".
   * @param {string} [details]
   */ onChange: $9396253983985262$var$_propTypes.default.func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} reason Can be: `"toggleInput"`, `"escape"`, `"selectOption"`, `"removeOption"`, `"blur"`.
   */ onClose: $9396253983985262$var$_propTypes.default.func,
    /**
   * Callback fired when the highlight option changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value} option The highlighted option.
   * @param {string} reason Can be: `"keyboard"`, `"mouse"`, `"touch"`.
   */ onHighlightChange: $9396253983985262$var$_propTypes.default.func,
    /**
   * Callback fired when the input value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} value The new value of the text input.
   * @param {string} reason Can be: `"input"` (user input), `"reset"` (programmatic change), `"clear"`, `"blur"`, `"selectOption"`, `"removeOption"`
   */ onInputChange: $9396253983985262$var$_propTypes.default.func,
    /**
   * @ignore
   */ onKeyDown: $9396253983985262$var$_propTypes.default.func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */ onOpen: $9396253983985262$var$_propTypes.default.func,
    /**
   * If `true`, the component is shown.
   */ open: $9396253983985262$var$_propTypes.default.bool,
    /**
   * If `true`, the popup will open on input focus.
   * @default false
   */ openOnFocus: $9396253983985262$var$_propTypes.default.bool,
    /**
   * Override the default text for the *open popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Open'
   */ openText: $9396253983985262$var$_propTypes.default.string,
    /**
   * A list of options that will be shown in the Autocomplete.
   */ options: $9396253983985262$var$_propTypes.default.array.isRequired,
    /**
   * The component used to render the body of the popup.
   * @default Paper
   * @deprecated Use `slots.paper` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ PaperComponent: $9396253983985262$var$_propTypes.default.elementType,
    /**
   * The component used to position the popup.
   * @default Popper
   * @deprecated Use `slots.popper` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ PopperComponent: $9396253983985262$var$_propTypes.default.elementType,
    /**
   * The icon to display in place of the default popup icon.
   * @default <ArrowDropDownIcon />
   */ popupIcon: $9396253983985262$var$_propTypes.default.node,
    /**
   * If `true`, the component becomes readonly. It is also supported for multiple tags where the tag cannot be deleted.
   * @default false
   */ readOnly: $9396253983985262$var$_propTypes.default.bool,
    /**
   * Render the group.
   *
   * @param {AutocompleteRenderGroupParams} params The group to render.
   * @returns {ReactNode}
   */ renderGroup: $9396253983985262$var$_propTypes.default.func,
    /**
   * Render the input.
   *
   * **Note:** The `renderInput` prop must return a `TextField` component or a compatible custom component
   * that correctly forwards `InputProps.ref` and spreads `inputProps`. This ensures proper integration
   * with the Autocomplete's internal logic (e.g., focus management and keyboard navigation).
   *
   * Avoid using components like `DatePicker` or `Select` directly, as they may not forward the required props,
   * leading to runtime errors or unexpected behavior.
   *
   * @param {object} params
   * @returns {ReactNode}
   */ renderInput: $9396253983985262$var$_propTypes.default.func.isRequired,
    /**
   * Render the option, use `getOptionLabel` by default.
   *
   * @param {object} props The props to apply on the li element.
   * @param {Value} option The option to render.
   * @param {object} state The state of each option.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */ renderOption: $9396253983985262$var$_propTypes.default.func,
    /**
   * Render the selected value when doing multiple selections.
   *
   * @deprecated Use `renderValue` prop instead
   *
   * @param {Value[]} value The `value` provided to the component.
   * @param {function} getTagProps A tag props getter.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */ renderTags: $9396253983985262$var$_propTypes.default.func,
    /**
   * Renders the selected value(s) as rich content in the input for both single and multiple selections.
   *
   * @param {AutocompleteRenderValue<Value, Multiple, FreeSolo>} value The `value` provided to the component.
   * @param {function} getItemProps The value item props.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */ renderValue: $9396253983985262$var$_propTypes.default.func,
    /**
   * If `true`, the input's text is selected on focus.
   * It helps the user clear the selected value.
   * @default !props.freeSolo
   */ selectOnFocus: $9396253983985262$var$_propTypes.default.bool,
    /**
   * The size of the component.
   * @default 'medium'
   */ size: $9396253983985262$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $9396253983985262$var$_propTypes.default.oneOf([
            'small',
            'medium'
        ]),
        $9396253983985262$var$_propTypes.default.string
    ]),
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $9396253983985262$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .shape({
        chip: $9396253983985262$var$_propTypes.default.oneOfType([
            $9396253983985262$var$_propTypes.default.func,
            $9396253983985262$var$_propTypes.default.object
        ]),
        clearIndicator: $9396253983985262$var$_propTypes.default.oneOfType([
            $9396253983985262$var$_propTypes.default.func,
            $9396253983985262$var$_propTypes.default.object
        ]),
        listbox: $9396253983985262$var$_propTypes.default.oneOfType([
            $9396253983985262$var$_propTypes.default.func,
            $9396253983985262$var$_propTypes.default.object
        ]),
        paper: $9396253983985262$var$_propTypes.default.oneOfType([
            $9396253983985262$var$_propTypes.default.func,
            $9396253983985262$var$_propTypes.default.object
        ]),
        popper: $9396253983985262$var$_propTypes.default.oneOfType([
            $9396253983985262$var$_propTypes.default.func,
            $9396253983985262$var$_propTypes.default.object
        ]),
        popupIndicator: $9396253983985262$var$_propTypes.default.oneOfType([
            $9396253983985262$var$_propTypes.default.func,
            $9396253983985262$var$_propTypes.default.object
        ]),
        root: $9396253983985262$var$_propTypes.default.oneOfType([
            $9396253983985262$var$_propTypes.default.func,
            $9396253983985262$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: $9396253983985262$var$_propTypes.default.shape({
        clearIndicator: $9396253983985262$var$_propTypes.default.elementType,
        listbox: $9396253983985262$var$_propTypes.default.elementType,
        paper: $9396253983985262$var$_propTypes.default.elementType,
        popper: $9396253983985262$var$_propTypes.default.elementType,
        popupIndicator: $9396253983985262$var$_propTypes.default.elementType,
        root: $9396253983985262$var$_propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $9396253983985262$var$_propTypes.default.oneOfType([
        $9396253983985262$var$_propTypes.default.arrayOf($9396253983985262$var$_propTypes.default.oneOfType([
            $9396253983985262$var$_propTypes.default.func,
            $9396253983985262$var$_propTypes.default.object,
            $9396253983985262$var$_propTypes.default.bool
        ])),
        $9396253983985262$var$_propTypes.default.func,
        $9396253983985262$var$_propTypes.default.object
    ]),
    /**
   * The value of the autocomplete.
   *
   * The value must have reference equality with the option in order to be selected.
   * You can customize the equality behavior with the `isOptionEqualToValue` prop.
   */ value: (0, $9396253983985262$var$_chainPropTypes.default)($9396253983985262$var$_propTypes.default.any, (props)=>{
        if (props.multiple && props.value !== undefined && !Array.isArray(props.value)) return new Error([
            'MUI: The Autocomplete expects the `value` prop to be an array when `multiple={true}` or undefined.',
            `However, ${props.value} was provided.`
        ].join('\n'));
        return null;
    })
};
var $9396253983985262$var$_default = module.exports.default = $9396253983985262$var$Autocomplete;

});
parcelRegister("cxaSP", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $92010252191041d3$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $92010252191041d3$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $92010252191041d3$var$_integerPropType.default;
    }
});

var $92010252191041d3$var$_integerPropType = $92010252191041d3$require$_interopRequireWildcard((parcelRequire("gsOpJ")));
Object.keys($92010252191041d3$var$_integerPropType).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($92010252191041d3$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $92010252191041d3$var$_integerPropType[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $92010252191041d3$var$_integerPropType[key];
        }
    });
});

});
parcelRegister("gsOpJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getTypeByValue = $bfc65e0b974ee482$var$getTypeByValue;
function $bfc65e0b974ee482$var$getTypeByValue(value) {
    const valueType = typeof value;
    switch(valueType){
        case 'number':
            if (Number.isNaN(value)) return 'NaN';
            if (!Number.isFinite(value)) return 'Infinity';
            if (value !== Math.floor(value)) return 'float';
            return 'number';
        case 'object':
            if (value === null) return 'null';
            return value.constructor.name;
        default:
            return valueType;
    }
}
function $bfc65e0b974ee482$var$requiredInteger(props, propName, componentName, location) {
    const propValue = props[propName];
    if (propValue == null || !Number.isInteger(propValue)) {
        const propType = $bfc65e0b974ee482$var$getTypeByValue(propValue);
        return new RangeError(`Invalid ${location} \`${propName}\` of type \`${propType}\` supplied to \`${componentName}\`, expected \`integer\`.`);
    }
    return null;
}
function $bfc65e0b974ee482$var$validator(props, propName, componentName, location) {
    const propValue = props[propName];
    if (propValue === undefined) return null;
    return $bfc65e0b974ee482$var$requiredInteger(props, propName, componentName, location);
}
function $bfc65e0b974ee482$var$validatorNoop() {
    return null;
}
$bfc65e0b974ee482$var$validator.isRequired = $bfc65e0b974ee482$var$requiredInteger;
$bfc65e0b974ee482$var$validatorNoop.isRequired = $bfc65e0b974ee482$var$validatorNoop;
const $bfc65e0b974ee482$var$integerPropType = $bfc65e0b974ee482$var$validator;
var $bfc65e0b974ee482$var$_default = module.exports.default = $bfc65e0b974ee482$var$integerPropType;

});


parcelRegister("abVWF", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $76b7e12fe7b0c8f4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $76b7e12fe7b0c8f4$var$_chainPropTypes.default;
    }
});

var $76b7e12fe7b0c8f4$var$_chainPropTypes = $76b7e12fe7b0c8f4$require$_interopRequireDefault((parcelRequire("8jTls")));

});
parcelRegister("8jTls", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $60eb0778cff380af$var$chainPropTypes;
function $60eb0778cff380af$var$chainPropTypes(propType1, propType2) {
    return function validate(...args) {
        return propType1(...args) || propType2(...args);
    };
}

});


parcelRegister("i7W0V", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d325e1cfabe5ef49$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $d325e1cfabe5ef49$var$_useForcedRerendering.default;
    }
});

var $d325e1cfabe5ef49$var$_useForcedRerendering = $d325e1cfabe5ef49$require$_interopRequireDefault((parcelRequire("7OX8m")));

});
parcelRegister("7OX8m", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $5b1b12ac4d005852$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5b1b12ac4d005852$var$useForcedRerendering;

var $5b1b12ac4d005852$var$React = $5b1b12ac4d005852$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * Copied from @base-ui/utils
 *
 * Returns a function that forces a rerender.
 */ function $5b1b12ac4d005852$var$useForcedRerendering() {
    const [, setState] = $5b1b12ac4d005852$var$React.useState({});
    return $5b1b12ac4d005852$var$React.useCallback(()=>{
        setState({});
    }, []);
}

});


parcelRegister("g924V", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $bc0f195a4e4d09e0$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "createFilterOptions", {
    enumerable: true,
    get: function() {
        return $bc0f195a4e4d09e0$var$_useAutocomplete.createFilterOptions;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $bc0f195a4e4d09e0$var$_useAutocomplete.default;
    }
});

var $bc0f195a4e4d09e0$var$_useAutocomplete = $bc0f195a4e4d09e0$require$_interopRequireWildcard((parcelRequire("33DpT")));

});
parcelRegister("33DpT", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $23a03a376a300fc5$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $23a03a376a300fc5$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createFilterOptions = $23a03a376a300fc5$var$createFilterOptions;
module.exports.default = void 0;

var $23a03a376a300fc5$var$React = $23a03a376a300fc5$require$_interopRequireWildcard((parcelRequire("acw62")));

var $23a03a376a300fc5$var$_contains = $23a03a376a300fc5$require$_interopRequireDefault((parcelRequire("9DeDn")));

var $23a03a376a300fc5$var$_setRef = $23a03a376a300fc5$require$_interopRequireDefault((parcelRequire("dGvj8")));

var $23a03a376a300fc5$var$_useEventCallback = $23a03a376a300fc5$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $23a03a376a300fc5$var$_useControlled = $23a03a376a300fc5$require$_interopRequireDefault((parcelRequire("iSpB2")));

var $23a03a376a300fc5$var$_useId = $23a03a376a300fc5$require$_interopRequireDefault((parcelRequire("hwliF")));

var $23a03a376a300fc5$var$_usePreviousProps = $23a03a376a300fc5$require$_interopRequireDefault((parcelRequire("54VdW")));
function $23a03a376a300fc5$var$areArraysSame({ array1: array1, array2: array2, parser: parser = (value)=>value }) {
    return array1 && array2 && array1.length === array2.length && array1.every((prevOption, index)=>parser(prevOption) === parser(array2[index]));
}
// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
function $23a03a376a300fc5$var$stripDiacritics(string) {
    return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}
function $23a03a376a300fc5$var$createFilterOptions(config = {}) {
    const { ignoreAccents: ignoreAccents = true, ignoreCase: ignoreCase = true, limit: limit, matchFrom: matchFrom = 'any', stringify: stringify, trim: trim = false } = config;
    return (options, { inputValue: inputValue, getOptionLabel: getOptionLabel })=>{
        let input = trim ? inputValue.trim() : inputValue;
        if (ignoreCase) input = input.toLowerCase();
        if (ignoreAccents) input = $23a03a376a300fc5$var$stripDiacritics(input);
        const filteredOptions = !input ? options : options.filter((option)=>{
            let candidate = (stringify || getOptionLabel)(option);
            if (ignoreCase) candidate = candidate.toLowerCase();
            if (ignoreAccents) candidate = $23a03a376a300fc5$var$stripDiacritics(candidate);
            return matchFrom === 'start' ? candidate.startsWith(input) : candidate.includes(input);
        });
        return typeof limit === 'number' ? filteredOptions.slice(0, limit) : filteredOptions;
    };
}
const $23a03a376a300fc5$var$defaultFilterOptions = $23a03a376a300fc5$var$createFilterOptions();
// Number of options to jump in list box when `Page Up` and `Page Down` keys are used.
const $23a03a376a300fc5$var$pageSize = 5;
const $23a03a376a300fc5$var$defaultIsActiveElementInListbox = (listboxRef)=>listboxRef.current !== null && (0, $23a03a376a300fc5$var$_contains.default)(listboxRef.current.parentElement, document.activeElement);
const $23a03a376a300fc5$var$defaultIsOptionEqualToValue = (option, value)=>option === value;
const $23a03a376a300fc5$var$MULTIPLE_DEFAULT_VALUE = [];
function $23a03a376a300fc5$var$getInputValue(value, multiple, getOptionLabel, renderValue) {
    if (multiple || value == null || renderValue) return '';
    const optionLabel = getOptionLabel(value);
    return typeof optionLabel === 'string' ? optionLabel : '';
}
function $23a03a376a300fc5$var$useAutocomplete(props) {
    const { unstable_isActiveElementInListbox: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox = $23a03a376a300fc5$var$defaultIsActiveElementInListbox, unstable_classNamePrefix: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix = 'Mui', autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, componentName: componentName = 'useAutocomplete', defaultValue: defaultValue = props.multiple ? $23a03a376a300fc5$var$MULTIPLE_DEFAULT_VALUE : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabledProp, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, filterOptions: filterOptions = $23a03a376a300fc5$var$defaultFilterOptions, filterSelectedOptions: filterSelectedOptions = false, freeSolo: freeSolo = false, getOptionDisabled: getOptionDisabled, getOptionKey: getOptionKey, getOptionLabel: getOptionLabelProp = (option)=>option.label ?? option, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList: includeInputInList = false, inputValue: inputValueProp, isOptionEqualToValue: isOptionEqualToValue = $23a03a376a300fc5$var$defaultIsOptionEqualToValue, multiple: multiple = false, onChange: onChange, onClose: onClose, onHighlightChange: onHighlightChange, onInputChange: onInputChange, onOpen: onOpen, open: openProp, openOnFocus: openOnFocus = false, options: options, readOnly: readOnly = false, renderValue: renderValue, selectOnFocus: selectOnFocus = !props.freeSolo, value: valueProp } = props;
    const id = (0, $23a03a376a300fc5$var$_useId.default)(idProp);
    let getOptionLabel = getOptionLabelProp;
    getOptionLabel = (option)=>{
        const optionLabel = getOptionLabelProp(option);
        if (typeof optionLabel !== 'string') {
            {
                const erroneousReturn = optionLabel === undefined ? 'undefined' : `${typeof optionLabel} (${optionLabel})`;
                console.error(`MUI: The \`getOptionLabel\` method of ${componentName} returned ${erroneousReturn} instead of a string for ${JSON.stringify(option)}.`);
            }
            return String(optionLabel);
        }
        return optionLabel;
    };
    const ignoreFocus = $23a03a376a300fc5$var$React.useRef(false);
    const firstFocus = $23a03a376a300fc5$var$React.useRef(true);
    const inputRef = $23a03a376a300fc5$var$React.useRef(null);
    const listboxRef = $23a03a376a300fc5$var$React.useRef(null);
    const windowLostFocus = $23a03a376a300fc5$var$React.useRef(false);
    const [anchorEl, setAnchorEl] = $23a03a376a300fc5$var$React.useState(null);
    const [focusedItem, setFocusedItem] = $23a03a376a300fc5$var$React.useState(-1);
    const defaultHighlighted = autoHighlight ? 0 : -1;
    const highlightedIndexRef = $23a03a376a300fc5$var$React.useRef(defaultHighlighted);
    // Tracks how the current highlight was set:
    // - 'keyboard' — arrow keys, Home/End, PageUp/PageDown
    // - 'mouse'    — handleOptionMouseMove
    // - 'touch'    — handleOptionTouchStart
    // - null       — programmatic (autoHighlight, value sync)
    //
    // This lets handleBlur and the Enter handler distinguish intentional
    // interactions from incidental ones — e.g. autoSelect should not commit
    // a highlight that came from a casual mouse hover.
    /** @type {React.RefObject<AutocompleteHighlightChangeReason | null>} */ const highlightReasonRef = $23a03a376a300fc5$var$React.useRef(null);
    const touchScrolledRef = $23a03a376a300fc5$var$React.useRef(false);
    const isTouchRef = $23a03a376a300fc5$var$React.useRef(false);
    // Calculate the initial inputValue on mount only.
    // useRef ensures it doesn't update dynamically with defaultValue or value props.
    const initialInputValue = $23a03a376a300fc5$var$React.useRef($23a03a376a300fc5$var$getInputValue(defaultValue ?? valueProp, multiple, getOptionLabel)).current;
    const [value, setValueState] = (0, $23a03a376a300fc5$var$_useControlled.default)({
        controlled: valueProp,
        default: defaultValue,
        name: componentName
    });
    const [inputValue, setInputValueState] = (0, $23a03a376a300fc5$var$_useControlled.default)({
        controlled: inputValueProp,
        default: initialInputValue,
        name: componentName,
        state: 'inputValue'
    });
    const [focused, setFocused] = $23a03a376a300fc5$var$React.useState(false);
    const resetInputValue = $23a03a376a300fc5$var$React.useCallback((event, newValue, reason)=>{
        // retain current `inputValue` if new option isn't selected and `clearOnBlur` is false
        // When `multiple` is enabled, `newValue` is an array of all selected items including the newly selected item
        const isOptionSelected = multiple ? value.length < newValue.length : newValue !== null;
        if (!isOptionSelected && !clearOnBlur) return;
        const newInputValue = $23a03a376a300fc5$var$getInputValue(newValue, multiple, getOptionLabel, renderValue);
        if (inputValue === newInputValue) return;
        setInputValueState(newInputValue);
        if (onInputChange) onInputChange(event, newInputValue, reason);
    }, [
        getOptionLabel,
        inputValue,
        multiple,
        onInputChange,
        setInputValueState,
        clearOnBlur,
        value,
        renderValue
    ]);
    const [open, setOpenState] = (0, $23a03a376a300fc5$var$_useControlled.default)({
        controlled: openProp,
        default: false,
        name: componentName,
        state: 'open'
    });
    const [inputPristine, setInputPristine] = $23a03a376a300fc5$var$React.useState(true);
    const inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
    const popupOpen = open && !readOnly;
    const selectedValues = $23a03a376a300fc5$var$React.useMemo(()=>{
        if (multiple) return value;
        if (value != null) return [
            value
        ];
        return [];
    }, [
        multiple,
        value
    ]);
    const selectedValuesSet = $23a03a376a300fc5$var$React.useMemo(()=>{
        // Fast path for the default strict equality comparator to avoid O(n^2) option checks.
        if (isOptionEqualToValue !== $23a03a376a300fc5$var$defaultIsOptionEqualToValue || selectedValues.length === 0) return null;
        return new Set(selectedValues);
    }, [
        isOptionEqualToValue,
        selectedValues
    ]);
    const isOptionSelected = $23a03a376a300fc5$var$React.useCallback((option)=>{
        if (selectedValuesSet) return selectedValuesSet.has(option);
        return selectedValues.some((value2)=>value2 != null && isOptionEqualToValue(option, value2));
    }, [
        isOptionEqualToValue,
        selectedValues,
        selectedValuesSet
    ]);
    const filteredOptions = popupOpen ? filterOptions(options.filter((option)=>{
        if (filterSelectedOptions && isOptionSelected(option)) return false;
        return true;
    }), // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
        inputValue: inputValueIsSelectedValue && inputPristine ? '' : inputValue,
        getOptionLabel: getOptionLabel
    }) : [];
    const previousProps = (0, $23a03a376a300fc5$var$_usePreviousProps.default)({
        filteredOptions: filteredOptions,
        value: value,
        inputValue: inputValue
    });
    $23a03a376a300fc5$var$React.useEffect(()=>{
        const valueChange = value !== previousProps.value;
        if (focused && !valueChange) return;
        // Only reset the input's value when freeSolo if the component's value changes.
        if (freeSolo && !valueChange) return;
        resetInputValue(null, value, 'reset');
    }, [
        value,
        resetInputValue,
        focused,
        previousProps.value,
        freeSolo
    ]);
    const listboxAvailable = open && filteredOptions.length > 0 && !readOnly;
    const focusItem = (0, $23a03a376a300fc5$var$_useEventCallback.default)((itemToFocus)=>{
        if (itemToFocus === -1) inputRef.current.focus();
        else {
            // Using `data-tag-index` for deprecated `renderTags`. Remove when `renderTags` is gone.
            const indexType = renderValue ? 'data-item-index' : 'data-tag-index';
            anchorEl.querySelector(`[${indexType}="${itemToFocus}"]`).focus();
        }
    });
    // Ensure the focusedItem is never inconsistent
    $23a03a376a300fc5$var$React.useEffect(()=>{
        if (multiple && focusedItem > value.length - 1) {
            setFocusedItem(-1);
            focusItem(-1);
        }
    }, [
        value,
        multiple,
        focusedItem,
        focusItem
    ]);
    function validOptionIndex(index, direction) {
        if (!listboxRef.current || index < 0 || index >= filteredOptions.length) return -1;
        let nextFocus = index;
        while(true){
            const option = listboxRef.current.querySelector(`[data-option-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            const nextFocusDisabled = disabledItemsFocusable ? false : !option || option.disabled || option.getAttribute('aria-disabled') === 'true';
            if (option && option.hasAttribute('tabindex') && !nextFocusDisabled) // The next option is available
            return nextFocus;
            // The next option is disabled, move to the next element.
            // with looped index
            if (direction === 'next') nextFocus = (nextFocus + 1) % filteredOptions.length;
            else nextFocus = (nextFocus - 1 + filteredOptions.length) % filteredOptions.length;
            // We end up with initial index, that means we don't have available options.
            // All of them are disabled
            if (nextFocus === index) return -1;
        }
    }
    const syncHighlightedIndexToDOM = (0, $23a03a376a300fc5$var$_useEventCallback.default)(({ index: index, reason: reason, preserveScroll: preserveScroll = false })=>{
        // does the index exist?
        if (index === -1) inputRef.current.removeAttribute('aria-activedescendant');
        else inputRef.current.setAttribute('aria-activedescendant', `${id}-option-${index}`);
        if (!listboxRef.current) return;
        const prev = listboxRef.current.querySelector(`[role="option"].${unstable_classNamePrefix}-focused`);
        if (prev) {
            prev.classList.remove(`${unstable_classNamePrefix}-focused`);
            prev.classList.remove(`${unstable_classNamePrefix}-focusVisible`);
        }
        let listboxNode = listboxRef.current;
        if (listboxRef.current.getAttribute('role') !== 'listbox') listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]');
        // "No results"
        if (!listboxNode) return;
        if (index === -1) {
            if (!preserveScroll) listboxNode.scrollTop = 0;
            return;
        }
        const option = listboxRef.current.querySelector(`[data-option-index="${index}"]`);
        if (!option) return;
        option.classList.add(`${unstable_classNamePrefix}-focused`);
        if (reason === 'keyboard') option.classList.add(`${unstable_classNamePrefix}-focusVisible`);
        // Scroll active descendant into view.
        // Logic copied from https://www.w3.org/WAI/content-assets/wai-aria-practices/patterns/combobox/examples/js/select-only.js
        // In case of mouse clicks and touch (in mobile devices) we avoid scrolling the element and keep both behaviors same.
        // Consider this API instead once it has a better browser support:
        // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
        if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== 'mouse' && reason !== 'touch') {
            const element = option;
            const scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
            const elementBottom = element.offsetTop + element.offsetHeight;
            if (elementBottom > scrollBottom) listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
            else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
        }
    });
    const setHighlightedIndex = (0, $23a03a376a300fc5$var$_useEventCallback.default)(({ event: event, index: index, reason: reason, preserveScroll: preserveScroll = false })=>{
        highlightedIndexRef.current = index;
        highlightReasonRef.current = reason ?? null;
        if (onHighlightChange && [
            'mouse',
            'keyboard',
            'touch'
        ].includes(reason)) onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
        syncHighlightedIndexToDOM({
            index: index,
            reason: reason,
            preserveScroll: preserveScroll
        });
    });
    const setHighlightedIndexFromSync = (0, $23a03a376a300fc5$var$_useEventCallback.default)(({ index: index })=>{
        highlightedIndexRef.current = index;
        syncHighlightedIndexToDOM({
            index: index,
            reason: highlightReasonRef.current
        });
    });
    const changeHighlightedIndex = (0, $23a03a376a300fc5$var$_useEventCallback.default)(({ event: event, diff: diff, direction: direction = 'next', reason: reason, preserveScroll: preserveScroll })=>{
        if (!popupOpen) return;
        if (reason === 'keyboard') {
            touchScrolledRef.current = false;
            isTouchRef.current = false;
        }
        const getNextIndex = ()=>{
            const maxIndex = filteredOptions.length - 1;
            if (diff === 'reset') return defaultHighlighted;
            if (diff === 'start') return 0;
            if (diff === 'end') return maxIndex;
            const newIndex = highlightedIndexRef.current + diff;
            if (newIndex < 0) {
                if (newIndex === -1 && includeInputInList) return -1;
                if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) return 0;
                return maxIndex;
            }
            if (newIndex > maxIndex) {
                if (newIndex === maxIndex + 1 && includeInputInList) return -1;
                if (disableListWrap || Math.abs(diff) > 1) return maxIndex;
                return 0;
            }
            return newIndex;
        };
        const nextIndex = validOptionIndex(getNextIndex(), direction);
        setHighlightedIndex({
            index: nextIndex,
            reason: reason,
            event: event,
            preserveScroll: preserveScroll
        });
        // Sync the content of the input with the highlighted option.
        if (autoComplete && diff !== 'reset') {
            if (nextIndex === -1) inputRef.current.value = inputValue;
            else {
                const option = getOptionLabel(filteredOptions[nextIndex]);
                inputRef.current.value = option;
                // The portion of the selected suggestion that has not been typed by the user,
                // a completion string, appears inline after the input cursor in the textbox.
                const index = option.toLowerCase().indexOf(inputValue.toLowerCase());
                if (index === 0 && inputValue.length > 0) inputRef.current.setSelectionRange(inputValue.length, option.length);
            }
        }
    });
    const filteredOptionsChanged = !$23a03a376a300fc5$var$areArraysSame({
        array1: previousProps.filteredOptions,
        array2: filteredOptions,
        parser: getOptionLabel
    });
    const getPreviousHighlightedOptionIndex = ()=>{
        const isSameValue = (value1, value2)=>{
            const label1 = value1 ? getOptionLabel(value1) : '';
            const label2 = value2 ? getOptionLabel(value2) : '';
            return label1 === label2;
        };
        if (highlightedIndexRef.current !== -1 && !$23a03a376a300fc5$var$areArraysSame({
            array1: previousProps.filteredOptions,
            array2: filteredOptions,
            parser: getOptionLabel
        }) && previousProps.inputValue === inputValue && (multiple ? value.length === previousProps.value.length && previousProps.value.every((val, i)=>getOptionLabel(value[i]) === getOptionLabel(val)) : isSameValue(previousProps.value, value))) {
            const previousHighlightedOption = previousProps.filteredOptions[highlightedIndexRef.current];
            if (previousHighlightedOption) return filteredOptions.findIndex((option)=>{
                return getOptionLabel(option) === getOptionLabel(previousHighlightedOption);
            });
        }
        return -1;
    };
    const syncHighlightedIndex = $23a03a376a300fc5$var$React.useCallback(()=>{
        if (!popupOpen) return;
        // Check if the previously highlighted option still exists in the updated filtered options list and if the value and inputValue haven't changed
        // If it exists and the value and the inputValue haven't changed, just update its index, otherwise continue execution
        const previousHighlightedOptionIndex = getPreviousHighlightedOptionIndex();
        if (previousHighlightedOptionIndex !== -1) {
            // Keep the original highlight reason while re-syncing the DOM state.
            // The highlighted option still exists after the filteredOptions array changed
            // (e.g. async fetch returns new options while the user is mid-navigation),
            // so the original interaction reason (keyboard, mouse, etc.) still applies.
            setHighlightedIndexFromSync({
                index: previousHighlightedOptionIndex
            });
            return;
        }
        const valueItem = multiple ? value[0] : value;
        // The popup is empty, reset
        if (filteredOptions.length === 0 || valueItem == null) {
            // Preserve scroll when new options are appended without changing the current filter.
            const isAppendOnly = filteredOptionsChanged && previousProps.inputValue === inputValue && previousProps.filteredOptions?.length > 0 && filteredOptions.length > previousProps.filteredOptions.length && previousProps.filteredOptions.every((option, index)=>getOptionLabel(option) === getOptionLabel(filteredOptions[index]));
            changeHighlightedIndex({
                diff: 'reset',
                preserveScroll: isAppendOnly
            });
            return;
        }
        if (!listboxRef.current) return;
        // Synchronize the value with the highlighted index
        if (valueItem != null) {
            const currentOption = filteredOptions[highlightedIndexRef.current];
            // Keep the current selected highlight while the popup stays open;
            // on reopen, resync from the selected value.
            if (multiple && currentOption && value.findIndex((val)=>isOptionEqualToValue(currentOption, val)) !== -1 && previousProps.filteredOptions?.length > 0) {
                setHighlightedIndexFromSync({
                    index: highlightedIndexRef.current
                });
                return;
            }
            const itemIndex = filteredOptions.findIndex((optionItem)=>isOptionEqualToValue(optionItem, valueItem));
            if (itemIndex === -1) changeHighlightedIndex({
                diff: 'reset'
            });
            else setHighlightedIndex({
                index: itemIndex
            });
            return;
        }
        // Prevent the highlighted index to leak outside the boundaries.
        if (highlightedIndexRef.current >= filteredOptions.length - 1) {
            setHighlightedIndex({
                index: filteredOptions.length - 1
            });
            return;
        }
        // Restore the focus to the previous index.
        setHighlightedIndex({
            index: highlightedIndexRef.current
        });
    // Ignore filteredOptions (and options, isOptionEqualToValue, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // Only sync the highlighted index when the option switch between empty and not
        filteredOptions.length,
        // Don't sync the highlighted index with the value when multiple
        // eslint-disable-next-line react-hooks/exhaustive-deps
        multiple ? false : value,
        changeHighlightedIndex,
        setHighlightedIndex,
        setHighlightedIndexFromSync,
        popupOpen,
        inputValue,
        multiple
    ]);
    const handleListboxRef = (0, $23a03a376a300fc5$var$_useEventCallback.default)((node)=>{
        (0, $23a03a376a300fc5$var$_setRef.default)(listboxRef, node);
        if (!node) return;
        syncHighlightedIndex();
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $23a03a376a300fc5$var$React.useEffect(()=>{
        if (!inputRef.current || inputRef.current.nodeName !== 'INPUT') {
            if (inputRef.current && inputRef.current.nodeName === 'TEXTAREA') console.warn([
                `A textarea element was provided to ${componentName} where input was expected.`,
                `This is not a supported scenario but it may work under certain conditions.`,
                `A textarea keyboard navigation may conflict with Autocomplete controls (for example enter and arrow keys).`,
                `Make sure to test keyboard navigation and add custom event handlers if necessary.`
            ].join('\n'));
            else console.error([
                `MUI: Unable to find the input element. It was resolved to ${inputRef.current} while an HTMLInputElement was expected.`,
                `Instead, ${componentName} expects an input element.`,
                '',
                componentName === 'useAutocomplete' ? 'Make sure you have bound getInputProps correctly and that the normal ref/effect resolutions order is guaranteed.' : 'Make sure you have customized the input component correctly.'
            ].join('\n'));
        }
    }, [
        componentName
    ]);
    $23a03a376a300fc5$var$React.useEffect(()=>{
        if (filteredOptionsChanged || popupOpen && !disableCloseOnSelect) syncHighlightedIndex();
    }, [
        syncHighlightedIndex,
        filteredOptionsChanged,
        popupOpen,
        disableCloseOnSelect
    ]);
    // Listen for browser window blur to detect when the user switches tabs or windows.
    // This helps prevent the popup from reopening automatically when the window regains focus.
    $23a03a376a300fc5$var$React.useEffect(()=>{
        if (typeof window === 'undefined') return undefined;
        const handleWindowBlur = ()=>{
            windowLostFocus.current = true;
        };
        window.addEventListener('blur', handleWindowBlur);
        return ()=>{
            window.removeEventListener('blur', handleWindowBlur);
        };
    }, []);
    const handleOpen = (event)=>{
        if (open) return;
        setOpenState(true);
        setInputPristine(true);
        isTouchRef.current = false;
        if (onOpen) onOpen(event);
    };
    const handleClose = (event, reason)=>{
        if (!open) return;
        setOpenState(false);
        touchScrolledRef.current = false;
        highlightReasonRef.current = null;
        if (onClose) onClose(event, reason);
    };
    const handleValue = (event, newValue, reason, details)=>{
        if (multiple) {
            if (value.length === newValue.length && value.every((val, i)=>val === newValue[i])) return;
        } else if (value === newValue) return;
        if (onChange) onChange(event, newValue, reason, details);
        setValueState(newValue);
    };
    const selectNewValue = (event, option, reasonProp = 'selectOption', origin = 'options')=>{
        let reason = reasonProp;
        let newValue = option;
        if (multiple) {
            newValue = Array.isArray(value) ? value.slice() : [];
            {
                const matches = newValue.filter((val)=>isOptionEqualToValue(option, val));
                if (matches.length > 1) console.error([
                    `MUI: The \`isOptionEqualToValue\` method of ${componentName} does not handle the arguments correctly.`,
                    `The component expects a single value to match a given option but found ${matches.length} matches.`
                ].join('\n'));
            }
            const itemIndex = newValue.findIndex((valueItem)=>isOptionEqualToValue(option, valueItem));
            if (itemIndex === -1) newValue.push(option);
            else if (origin !== 'freeSolo') {
                newValue.splice(itemIndex, 1);
                reason = 'removeOption';
            }
        }
        resetInputValue(event, newValue, reason);
        handleValue(event, newValue, reason, {
            option: option
        });
        if (!disableCloseOnSelect && (!event || !event.ctrlKey && !event.metaKey)) handleClose(event, reason);
        if (blurOnSelect === true || blurOnSelect === 'touch' && isTouchRef.current || blurOnSelect === 'mouse' && !isTouchRef.current) inputRef.current.blur();
    };
    function validItemIndex(index, direction) {
        if (index === -1) return -1;
        let nextFocus = index;
        while(true){
            // Out of range
            if (direction === 'next' && nextFocus === value.length || direction === 'previous' && nextFocus === -1) return -1;
            // Using `data-tag-index` for deprecated `renderTags`. Remove when `renderTags` is removed.
            const indexType = renderValue ? 'data-item-index' : 'data-tag-index';
            const option = anchorEl.querySelector(`[${indexType}="${nextFocus}"]`);
            // Same logic as MenuList.js
            if (!option || !option.hasAttribute('tabindex') || option.disabled || option.getAttribute('aria-disabled') === 'true') nextFocus += direction === 'next' ? 1 : -1;
            else return nextFocus;
        }
    }
    const handleFocusItem = (event, direction)=>{
        if (!multiple) return;
        if (inputValue === '') handleClose(event, 'toggleInput');
        let nextItem = focusedItem;
        // When moving focus from the input to tags with ArrowLeft,
        // always jump to the last tag (if any) from the input.
        if (focusedItem === -1 && direction === 'previous') {
            nextItem = value.length - 1;
            // In freeSolo, clear any draft text so it doesn't "come back" later.
            if (freeSolo && inputValue !== '') {
                setInputValueState('');
                if (onInputChange) onInputChange(event, '', 'reset');
            }
        } else {
            nextItem += direction === 'next' ? 1 : -1;
            if (nextItem < 0) nextItem = 0;
            if (nextItem === value.length) nextItem = -1;
        }
        nextItem = validItemIndex(nextItem, direction);
        setFocusedItem(nextItem);
        focusItem(nextItem);
    };
    const handleClear = (event)=>{
        ignoreFocus.current = true;
        setInputValueState('');
        if (onInputChange) onInputChange(event, '', 'clear');
        handleValue(event, multiple ? [] : null, 'clear');
    };
    const handleKeyDown = (other)=>(event)=>{
            if (other.onKeyDown) other.onKeyDown(event);
            if (event.defaultMuiPrevented) return;
            if (focusedItem !== -1 && ![
                'ArrowLeft',
                'ArrowRight'
            ].includes(event.key)) {
                setFocusedItem(-1);
                focusItem(-1);
            }
            // Wait until IME is settled.
            if (event.which !== 229) switch(event.key){
                case 'Home':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'start',
                            direction: 'next',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'End':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'end',
                            direction: 'previous',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'PageUp':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -$23a03a376a300fc5$var$pageSize,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'PageDown':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: $23a03a376a300fc5$var$pageSize,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowDown':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: 1,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowUp':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -1,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowLeft':
                    {
                        const input = inputRef.current;
                        // Only handle ArrowLeft when the caret is at the start of the input.
                        // Otherwise let the browser move the caret normally.
                        const caretAtStart = input && input.selectionStart === 0 && input.selectionEnd === 0;
                        if (!caretAtStart) // Let the browser handle normal cursor movement
                        return;
                        // Single-value rendering: move focus from input to the single tag.
                        if (!multiple && renderValue && value != null) {
                            // Moving from input to single tag; clear freeSolo draft text,
                            // so it doesn't reappear when we move back.
                            if (freeSolo && inputValue !== '') {
                                setInputValueState('');
                                if (onInputChange) onInputChange(event, '', 'reset');
                            }
                            setFocusedItem(0);
                            focusItem(0);
                        } else // Multi-value: delegate to tag navigation helper.
                        handleFocusItem(event, 'previous');
                        break;
                    }
                case 'ArrowRight':
                    if (!multiple && renderValue) {
                        setFocusedItem(-1);
                        focusItem(-1);
                    } else handleFocusItem(event, 'next');
                    break;
                case 'Enter':
                    {
                        // In freeSolo, only select the highlighted option if the user hasn't
                        // typed new text (inputPristine) or explicitly interacted with an option
                        // (keyboard, mouse, or touch — any non-null reason). This lets typed
                        // text win over a programmatic highlight (reason=null, e.g. from
                        // syncHighlightedIndex matching a previous value) while still honoring
                        // deliberate user interactions like hovering a suggestion then pressing Enter.
                        const shouldSelectHighlighted = !freeSolo || inputPristine || highlightReasonRef.current !== null;
                        if (highlightedIndexRef.current !== -1 && popupOpen && shouldSelectHighlighted && // After a touch-scroll the highlight is stale (the user scrolled
                        // past it), so skip selection until the next deliberate interaction.
                        !touchScrolledRef.current) {
                            const option = filteredOptions[highlightedIndexRef.current];
                            const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
                            // Avoid early form validation, let the end-users continue filling the form.
                            event.preventDefault();
                            if (disabled) return;
                            selectNewValue(event, option, 'selectOption');
                            // Move the selection to the end.
                            if (autoComplete) inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
                        } else if (freeSolo && inputValue !== '' && inputValueIsSelectedValue === false) {
                            if (multiple) // Allow people to add new values before they submit the form.
                            event.preventDefault();
                            selectNewValue(event, inputValue, 'createOption', 'freeSolo');
                        } else if (popupOpen && touchScrolledRef.current) {
                            // The highlight is stale from a touch-scroll - close without selecting.
                            event.preventDefault();
                            // This happens on Enter, but re-using "escape" as the closest `AutocompleteCloseReason`
                            // to avoid creating a new reason
                            handleClose(event, 'escape');
                        }
                        break;
                    }
                case 'Escape':
                    if (popupOpen) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClose(event, 'escape');
                    } else if (clearOnEscape && (inputValue !== '' || multiple && value.length > 0 || renderValue)) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClear(event);
                    }
                    break;
                case 'Backspace':
                    // Remove the value on the left of the "cursor"
                    if (multiple && !readOnly && inputValue === '' && value.length > 0) {
                        const index = focusedItem === -1 ? value.length - 1 : focusedItem;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'removeOption', {
                            option: value[index]
                        });
                    }
                    if (!multiple && renderValue && !readOnly && inputValue === '') handleValue(event, null, 'removeOption', {
                        option: value
                    });
                    break;
                case 'Delete':
                    // Remove the value on the right of the "cursor"
                    if (multiple && !readOnly && inputValue === '' && value.length > 0 && focusedItem !== -1) {
                        const index = focusedItem;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'removeOption', {
                            option: value[index]
                        });
                    }
                    if (!multiple && renderValue && !readOnly && inputValue === '') // Single-value rendering: Delete on empty input removes
                    // the single rendered option, same "removeOption" reason as multiple.
                    handleValue(event, null, 'removeOption', {
                        option: value
                    });
                    break;
                default:
            }
        };
    const handleFocus = (event)=>{
        setFocused(true);
        // When focusing the input, ensure any previously focused item (chip)
        // is cleared so the input receives the visible caret and the
        // input-focused styling is applied.
        if (focusedItem !== -1) {
            setFocusedItem(-1);
            // Ensure DOM focus lands on the input
            focusItem(-1);
        }
        // If the window previously lost focus while the popup was open,
        // ignore this focus event to prevent unintended reopening.
        // Reset the flag so normal focus behavior resumes.
        if (windowLostFocus.current) {
            windowLostFocus.current = false;
            return;
        }
        if (openOnFocus && !ignoreFocus.current) handleOpen(event);
    };
    const handleBlur = (event)=>{
        // Ignore the event when using the scrollbar with IE11
        if (unstable_isActiveElementInListbox(listboxRef)) {
            inputRef.current.focus();
            return;
        }
        setFocused(false);
        firstFocus.current = true;
        ignoreFocus.current = false;
        // Auto-select the highlighted option on blur, but only if the highlight
        // came from keyboard navigation or was set programmatically (autoHighlight).
        // Mouse hover and touch should not trigger selection — the user may have
        // moved the pointer over an option without intending to commit to it.
        if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen && highlightReasonRef.current !== 'mouse' && highlightReasonRef.current !== 'touch') selectNewValue(event, filteredOptions[highlightedIndexRef.current], 'blur');
        else if (autoSelect && freeSolo && inputValue !== '') selectNewValue(event, inputValue, 'blur', 'freeSolo');
        else if (clearOnBlur) resetInputValue(event, value, 'blur');
        handleClose(event, 'blur');
    };
    const handleInputChange = (event)=>{
        const newValue = event.target.value;
        const valueChanged = inputValue !== newValue;
        if (valueChanged) {
            setInputValueState(newValue);
            touchScrolledRef.current = false;
            if (onInputChange) onInputChange(event, newValue, 'input');
        }
        if (newValue === '') // For normal single-select, clearing the input clears the value.
        // For renderValue (chip-style single), only Backspace/Delete clear the value.
        {
            if (!disableClearable && !multiple && !renderValue) handleValue(event, null, 'clear');
        } else handleOpen(event);
        // Called after handleOpen so it overrides handleOpen's setInputPristine(true)
        // when the first keystroke also opens the popup.
        if (valueChanged) setInputPristine(false);
    };
    const handleOptionMouseMove = (event)=>{
        const index = Number(event.currentTarget.getAttribute('data-option-index'));
        if (highlightedIndexRef.current !== index) setHighlightedIndex({
            event: event,
            index: index,
            reason: 'mouse'
        });
        else // The option is already highlighted (e.g. programmatically via autoHighlight),
        // but the user moved the mouse over it — mark as mouse-initiated so
        // autoSelect on blur correctly treats this as incidental hover.
        highlightReasonRef.current = 'mouse';
        // Don't clear the touch-scroll guard while touch state is still latched.
        // After a touch gesture, browsers may fire compatibility mousemove
        // events; if those cleared the guard immediately, later compat events in
        // the same sequence could be misclassified as a real mouse interaction.
        // Touch state is cleared by the next deliberate interaction
        // (keyboard nav, handleOptionClick, or handleOpen).
        if (!isTouchRef.current) touchScrolledRef.current = false;
    };
    const handleOptionTouchStart = (event)=>{
        touchScrolledRef.current = false;
        setHighlightedIndex({
            event: event,
            index: Number(event.currentTarget.getAttribute('data-option-index')),
            reason: 'touch'
        });
        isTouchRef.current = true;
    };
    const handleOptionClick = (event)=>{
        const index = Number(event.currentTarget.getAttribute('data-option-index'));
        selectNewValue(event, filteredOptions[index], 'selectOption');
        isTouchRef.current = false;
    };
    const handleItemDelete = (index)=>(event)=>{
            const newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, 'removeOption', {
                option: value[index]
            });
        };
    const handleSingleItemDelete = (event)=>{
        handleValue(event, null, 'removeOption', {
            option: value
        });
    };
    const handlePopupIndicator = (event)=>{
        if (open) handleClose(event, 'toggleInput');
        else handleOpen(event);
    };
    // Prevent input blur when interacting with the combobox
    const handleMouseDown = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!(0, $23a03a376a300fc5$var$_contains.default)(event.currentTarget, event.target)) return;
        // Don't interfere with interactions outside the input area (e.g. helper text)
        if (anchorEl && !(0, $23a03a376a300fc5$var$_contains.default)(anchorEl, event.target)) return;
        if (event.target.getAttribute('id') !== id) event.preventDefault();
    };
    // Focus the input when interacting with the combobox
    const handleClick = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!(0, $23a03a376a300fc5$var$_contains.default)(event.currentTarget, event.target)) return;
        // Don't interfere with interactions outside the input area (e.g. helper text)
        if (anchorEl && !(0, $23a03a376a300fc5$var$_contains.default)(anchorEl, event.target)) return;
        inputRef.current.focus();
        if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) inputRef.current.select();
        firstFocus.current = false;
    };
    const handleInputMouseDown = (event)=>{
        if (!disabledProp && (inputValue === '' || !open)) handlePopupIndicator(event);
    };
    let dirty = freeSolo && inputValue.length > 0;
    dirty = dirty || (multiple ? value.length > 0 : value !== null);
    let groupedOptions = filteredOptions;
    if (groupBy) {
        // used to keep track of key and indexes in the result array
        const indexBy = new Map();
        let warn = false;
        groupedOptions = filteredOptions.reduce((acc, option, index)=>{
            const group = groupBy(option);
            if (acc.length > 0 && acc[acc.length - 1].group === group) acc[acc.length - 1].options.push(option);
            else {
                if (indexBy.get(group) && !warn) {
                    console.warn(`MUI: The options provided combined with the \`groupBy\` method of ${componentName} returns duplicated headers.`, 'You can solve the issue by sorting the options with the output of `groupBy`.');
                    warn = true;
                }
                indexBy.set(group, true);
                acc.push({
                    key: index,
                    index: index,
                    group: group,
                    options: [
                        option
                    ]
                });
            }
            return acc;
        }, []);
    }
    if (disabledProp && focused) handleBlur();
    return {
        getRootProps: (other = {})=>({
                ...other,
                onKeyDown: handleKeyDown(other),
                onMouseDown: handleMouseDown,
                onClick: handleClick
            }),
        getInputLabelProps: ()=>({
                id: `${id}-label`,
                htmlFor: id
            }),
        getInputProps: ()=>({
                id: id,
                value: inputValue,
                onBlur: handleBlur,
                onFocus: handleFocus,
                onChange: handleInputChange,
                onMouseDown: handleInputMouseDown,
                // if open then this is handled imperatively so don't let react override
                // only have an opinion about this when closed
                'aria-activedescendant': popupOpen ? '' : null,
                'aria-autocomplete': autoComplete ? 'both' : 'list',
                'aria-controls': listboxAvailable ? `${id}-listbox` : undefined,
                'aria-expanded': listboxAvailable,
                // Disable browser's suggestion that might overlap with the popup.
                // Handle autocomplete but not autofill.
                autoComplete: 'off',
                ref: inputRef,
                autoCapitalize: 'none',
                spellCheck: 'false',
                role: 'combobox',
                disabled: disabledProp
            }),
        getClearProps: ()=>({
                tabIndex: -1,
                type: 'button',
                onClick: handleClear
            }),
        getItemProps: ({ index: index = 0 } = {})=>({
                ...multiple && {
                    key: index
                },
                ...renderValue ? {
                    'data-item-index': index
                } : {
                    'data-tag-index': index
                },
                tabIndex: -1,
                ...!readOnly && {
                    onDelete: multiple ? handleItemDelete(index) : handleSingleItemDelete
                }
            }),
        getPopupIndicatorProps: ()=>({
                tabIndex: -1,
                type: 'button',
                onClick: handlePopupIndicator
            }),
        // deprecated
        getTagProps: ({ index: index })=>({
                key: index,
                'data-tag-index': index,
                tabIndex: -1,
                ...!readOnly && {
                    onDelete: handleItemDelete(index)
                }
            }),
        getListboxProps: ()=>({
                role: 'listbox',
                id: `${id}-listbox`,
                'aria-labelledby': `${id}-label`,
                'aria-multiselectable': multiple || undefined,
                ref: handleListboxRef,
                onMouseDown: (event)=>{
                    // Prevent blur
                    event.preventDefault();
                },
                onScroll: ()=>{
                    if (isTouchRef.current) touchScrolledRef.current = true;
                }
            }),
        getOptionProps: ({ index: index, option: option })=>{
            const selected = isOptionSelected(option);
            const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
            return {
                key: getOptionKey?.(option) ?? getOptionLabel(option),
                tabIndex: -1,
                role: 'option',
                id: `${id}-option-${index}`,
                onMouseMove: handleOptionMouseMove,
                onClick: handleOptionClick,
                onTouchStart: handleOptionTouchStart,
                'data-option-index': index,
                'aria-disabled': disabled,
                'aria-selected': selected
            };
        },
        id: id,
        inputValue: inputValue,
        value: value,
        dirty: dirty,
        expanded: popupOpen && anchorEl,
        popupOpen: popupOpen,
        focused: focused || focusedItem !== -1,
        anchorEl: anchorEl,
        setAnchorEl: setAnchorEl,
        focusedItem: focusedItem,
        // deprecated
        focusedTag: focusedItem,
        groupedOptions: groupedOptions
    };
}
var $23a03a376a300fc5$var$_default = module.exports.default = $23a03a376a300fc5$var$useAutocomplete;

});
parcelRegister("9DeDn", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $70331b9b9ce04a76$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $70331b9b9ce04a76$var$_contains.default;
    }
});

var $70331b9b9ce04a76$var$_contains = $70331b9b9ce04a76$require$_interopRequireDefault((parcelRequire("6DlW5")));

});
parcelRegister("6DlW5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4d47669a9d73ddb7$var$contains;
/**
 * Copied from @base-ui/utils
 *
 * Shadow DOM-aware containment check.
 *
 * Native `parent.contains(child)` returns `false` when the child is inside a
 * shadow root that is a descendant of the parent. This function handles that
 * case by traversing up through shadow root hosts.
 *
 * @param parent - The potential ancestor element.
 * @param child - The potential descendant element.
 * @returns Whether `parent` contains `child`, even across shadow root boundaries.
 */ function $4d47669a9d73ddb7$var$contains(parent, child) {
    if (!parent || !child) return false;
    // First, attempt with the faster native method.
    if (parent.contains(child)) return true;
    // Then fall back to traversing out of shadow roots when needed.
    const rootNode = child.getRootNode?.();
    if (rootNode && rootNode instanceof ShadowRoot) {
        let next = child;
        while(next){
            if (parent === next) return true;
            next = next.parentNode ?? next.host ?? null;
        }
    }
    return false;
}

});


parcelRegister("dGvj8", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9f677ba749dc745d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9f677ba749dc745d$var$_setRef.default;
    }
});

var $9f677ba749dc745d$var$_setRef = $9f677ba749dc745d$require$_interopRequireDefault((parcelRequire("01n9P")));

});
parcelRegister("01n9P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $00420eb250698fce$var$setRef;
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $00420eb250698fce$var$setRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}

});


parcelRegister("iSpB2", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $dbe1201302318660$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $dbe1201302318660$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $dbe1201302318660$var$_useControlled.default;
    }
});

var $dbe1201302318660$var$_useControlled = $dbe1201302318660$require$_interopRequireWildcard((parcelRequire("cEttN")));
Object.keys($dbe1201302318660$var$_useControlled).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($dbe1201302318660$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $dbe1201302318660$var$_useControlled[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dbe1201302318660$var$_useControlled[key];
        }
    });
});

});
parcelRegister("cEttN", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $936016844ea5135f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $936016844ea5135f$var$useControlled;

var $936016844ea5135f$var$React = $936016844ea5135f$require$_interopRequireWildcard((parcelRequire("acw62")));
function $936016844ea5135f$var$useControlled(props) {
    const { controlled: controlled, default: defaultProp, name: name, state: state = 'value' } = props;
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $936016844ea5135f$var$React.useRef(controlled !== undefined);
    const [valueState, setValue] = $936016844ea5135f$var$React.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    {
        $936016844ea5135f$var$React.useEffect(()=>{
            if (isControlled !== (controlled !== undefined)) console.error([
                `MUI: A component is changing the ${isControlled ? '' : 'un'}controlled ${state} state of ${name} to be ${isControlled ? 'un' : ''}controlled.`,
                'Elements should not switch from uncontrolled to controlled (or vice versa).',
                `Decide between using a controlled or uncontrolled ${name} ` + 'element for the lifetime of the component.',
                "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.",
                'More info: https://fb.me/react-controlled-components'
            ].join('\n'));
        }, [
            state,
            name,
            controlled
        ]);
        const { current: defaultValue } = $936016844ea5135f$var$React.useRef(defaultProp);
        $936016844ea5135f$var$React.useEffect(()=>{
            if (!isControlled && JSON.stringify(defaultProp) !== JSON.stringify(defaultValue)) console.error([
                `MUI: A component is changing the default ${state} state of an uncontrolled ${name} after being initialized. ` + `To suppress this warning opt to use a controlled ${name}.`
            ].join('\n'));
        }, [
            JSON.stringify(defaultProp)
        ]);
    }
    const setValueIfUncontrolled = $936016844ea5135f$var$React.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    // TODO: provide overloads for the useControlled function to account for the case where either
    // controlled or default is not undefined.
    // In that case the return type should be [T, React.Dispatch<React.SetStateAction<T>>]
    // otherwise it should be [T | undefined, React.Dispatch<React.SetStateAction<T | undefined>>]
    return [
        value,
        setValueIfUncontrolled
    ];
}

});


parcelRegister("54VdW", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3b29b6eb56c6bf1d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $3b29b6eb56c6bf1d$var$_usePreviousProps.default;
    }
});

var $3b29b6eb56c6bf1d$var$_usePreviousProps = $3b29b6eb56c6bf1d$require$_interopRequireDefault((parcelRequire("dofJB")));

});
parcelRegister("dofJB", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $9bf9b8cfe28ce71f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9bf9b8cfe28ce71f$var$React = $9bf9b8cfe28ce71f$require$_interopRequireWildcard((parcelRequire("acw62")));
function $9bf9b8cfe28ce71f$var$usePreviousProps(value) {
    const ref = $9bf9b8cfe28ce71f$var$React.useRef({});
    $9bf9b8cfe28ce71f$var$React.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
}
var $9bf9b8cfe28ce71f$var$_default = module.exports.default = $9bf9b8cfe28ce71f$var$usePreviousProps;

});




parcelRegister("eWJe7", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $ae19908c5516ff78$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $ae19908c5516ff78$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $ae19908c5516ff78$var$_exportNames = {
    popperClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ae19908c5516ff78$var$_Popper.default;
    }
});
Object.defineProperty(module.exports, "popperClasses", {
    enumerable: true,
    get: function() {
        return $ae19908c5516ff78$var$_popperClasses.default;
    }
});

var $ae19908c5516ff78$var$_Popper = $ae19908c5516ff78$require$_interopRequireDefault((parcelRequire("e76iu")));

var $ae19908c5516ff78$var$_popperClasses = $ae19908c5516ff78$require$_interopRequireWildcard((parcelRequire("g3XLf")));
Object.keys($ae19908c5516ff78$var$_popperClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($ae19908c5516ff78$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $ae19908c5516ff78$var$_popperClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ae19908c5516ff78$var$_popperClasses[key];
        }
    });
});

});
parcelRegister("e76iu", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $a4669aa090d445bd$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $a4669aa090d445bd$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9uEev = parcelRequire("9uEev");

var $a4669aa090d445bd$var$_refType = $a4669aa090d445bd$require$_interopRequireDefault((parcelRequire("b3gjr")));

var $a4669aa090d445bd$var$_HTMLElementType = $a4669aa090d445bd$require$_interopRequireDefault((parcelRequire("cIfK5")));

var $a4669aa090d445bd$var$_propTypes = $a4669aa090d445bd$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $a4669aa090d445bd$var$React = $a4669aa090d445bd$require$_interopRequireWildcard((parcelRequire("acw62")));

var $a4669aa090d445bd$var$_BasePopper = $a4669aa090d445bd$require$_interopRequireDefault((parcelRequire("7JHF2")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $ayMG0 = parcelRequire("ayMG0");
const $a4669aa090d445bd$var$PopperRoot = (0, $aAbgT.styled)($a4669aa090d445bd$var$_BasePopper.default, {
    name: 'MuiPopper',
    slot: 'Root'
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://v7.mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://v7.mui.com/material-ui/react-menu/)
 * - [Popper](https://v7.mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://v7.mui.com/material-ui/api/popper/)
 */ const $a4669aa090d445bd$var$Popper = /*#__PURE__*/ $a4669aa090d445bd$var$React.forwardRef(function Popper(inProps, ref) {
    const isRtl = (0, $9uEev.useRtl)();
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiPopper'
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps, ...other } = props;
    const RootComponent = slots?.root ?? components?.Root;
    const otherProps = {
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition,
        ...other
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a4669aa090d445bd$var$PopperRoot, {
        as: component,
        direction: isRtl ? 'rtl' : 'ltr',
        slots: {
            root: RootComponent
        },
        slotProps: slotProps ?? componentsProps,
        ...otherProps,
        ref: ref
    });
});
$a4669aa090d445bd$var$Popper.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */ anchorEl: $a4669aa090d445bd$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $a4669aa090d445bd$var$_HTMLElementType.default,
        $a4669aa090d445bd$var$_propTypes.default.object,
        $a4669aa090d445bd$var$_propTypes.default.func
    ]),
    /**
   * Popper render function or node.
   */ children: $a4669aa090d445bd$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $a4669aa090d445bd$var$_propTypes.default.node,
        $a4669aa090d445bd$var$_propTypes.default.func
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $a4669aa090d445bd$var$_propTypes.default.elementType,
    /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in a future major release. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   * @default {}
   */ components: $a4669aa090d445bd$var$_propTypes.default.shape({
        Root: $a4669aa090d445bd$var$_propTypes.default.elementType
    }),
    /**
   * The props used for each slot inside the Popper.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in a future major release. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   * @default {}
   */ componentsProps: $a4669aa090d445bd$var$_propTypes.default.shape({
        root: $a4669aa090d445bd$var$_propTypes.default.oneOfType([
            $a4669aa090d445bd$var$_propTypes.default.func,
            $a4669aa090d445bd$var$_propTypes.default.object
        ])
    }),
    /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */ container: $a4669aa090d445bd$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $a4669aa090d445bd$var$_HTMLElementType.default,
        $a4669aa090d445bd$var$_propTypes.default.func
    ]),
    /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */ disablePortal: $a4669aa090d445bd$var$_propTypes.default.bool,
    /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */ keepMounted: $a4669aa090d445bd$var$_propTypes.default.bool,
    /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */ modifiers: $a4669aa090d445bd$var$_propTypes.default.arrayOf($a4669aa090d445bd$var$_propTypes.default.shape({
        data: $a4669aa090d445bd$var$_propTypes.default.object,
        effect: $a4669aa090d445bd$var$_propTypes.default.func,
        enabled: $a4669aa090d445bd$var$_propTypes.default.bool,
        fn: $a4669aa090d445bd$var$_propTypes.default.func,
        name: $a4669aa090d445bd$var$_propTypes.default.any,
        options: $a4669aa090d445bd$var$_propTypes.default.object,
        phase: $a4669aa090d445bd$var$_propTypes.default.oneOf([
            'afterMain',
            'afterRead',
            'afterWrite',
            'beforeMain',
            'beforeRead',
            'beforeWrite',
            'main',
            'read',
            'write'
        ]),
        requires: $a4669aa090d445bd$var$_propTypes.default.arrayOf($a4669aa090d445bd$var$_propTypes.default.string),
        requiresIfExists: $a4669aa090d445bd$var$_propTypes.default.arrayOf($a4669aa090d445bd$var$_propTypes.default.string)
    })),
    /**
   * If `true`, the component is shown.
   */ open: $a4669aa090d445bd$var$_propTypes.default.bool.isRequired,
    /**
   * Popper placement.
   * @default 'bottom'
   */ placement: $a4669aa090d445bd$var$_propTypes.default.oneOf([
        'auto-end',
        'auto-start',
        'auto',
        'bottom-end',
        'bottom-start',
        'bottom',
        'left-end',
        'left-start',
        'left',
        'right-end',
        'right-start',
        'right',
        'top-end',
        'top-start',
        'top'
    ]),
    /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */ popperOptions: $a4669aa090d445bd$var$_propTypes.default.shape({
        modifiers: $a4669aa090d445bd$var$_propTypes.default.array,
        onFirstUpdate: $a4669aa090d445bd$var$_propTypes.default.func,
        placement: $a4669aa090d445bd$var$_propTypes.default.oneOf([
            'auto-end',
            'auto-start',
            'auto',
            'bottom-end',
            'bottom-start',
            'bottom',
            'left-end',
            'left-start',
            'left',
            'right-end',
            'right-start',
            'right',
            'top-end',
            'top-start',
            'top'
        ]),
        strategy: $a4669aa090d445bd$var$_propTypes.default.oneOf([
            'absolute',
            'fixed'
        ])
    }),
    /**
   * A ref that points to the used popper instance.
   */ popperRef: $a4669aa090d445bd$var$_refType.default,
    /**
   * The props used for each slot inside the Popper.
   * @default {}
   */ slotProps: $a4669aa090d445bd$var$_propTypes.default.shape({
        root: $a4669aa090d445bd$var$_propTypes.default.oneOfType([
            $a4669aa090d445bd$var$_propTypes.default.func,
            $a4669aa090d445bd$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */ slots: $a4669aa090d445bd$var$_propTypes.default.shape({
        root: $a4669aa090d445bd$var$_propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $a4669aa090d445bd$var$_propTypes.default.oneOfType([
        $a4669aa090d445bd$var$_propTypes.default.arrayOf($a4669aa090d445bd$var$_propTypes.default.oneOfType([
            $a4669aa090d445bd$var$_propTypes.default.func,
            $a4669aa090d445bd$var$_propTypes.default.object,
            $a4669aa090d445bd$var$_propTypes.default.bool
        ])),
        $a4669aa090d445bd$var$_propTypes.default.func,
        $a4669aa090d445bd$var$_propTypes.default.object
    ]),
    /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */ transition: $a4669aa090d445bd$var$_propTypes.default.bool
};
var $a4669aa090d445bd$var$_default = module.exports.default = $a4669aa090d445bd$var$Popper;

});
parcelRegister("b3gjr", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $80bca0e241370467$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $80bca0e241370467$var$_refType.default;
    }
});

var $80bca0e241370467$var$_refType = $80bca0e241370467$require$_interopRequireDefault((parcelRequire("5g2TU")));

});
parcelRegister("5g2TU", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3d40b2611b4cd7ef$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3d40b2611b4cd7ef$var$_propTypes = $3d40b2611b4cd7ef$require$_interopRequireDefault((parcelRequire("c9Z8w")));
const $3d40b2611b4cd7ef$var$refType = $3d40b2611b4cd7ef$var$_propTypes.default.oneOfType([
    $3d40b2611b4cd7ef$var$_propTypes.default.func,
    $3d40b2611b4cd7ef$var$_propTypes.default.object
]);
var $3d40b2611b4cd7ef$var$_default = module.exports.default = $3d40b2611b4cd7ef$var$refType;

});


parcelRegister("cIfK5", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9415ce3192d3b08c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9415ce3192d3b08c$var$_HTMLElementType.default;
    }
});

var $9415ce3192d3b08c$var$_HTMLElementType = $9415ce3192d3b08c$require$_interopRequireDefault((parcelRequire("8F42D")));

});
parcelRegister("8F42D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $64e549a55fe24dd8$var$HTMLElementType;
function $64e549a55fe24dd8$var$HTMLElementType(props, propName, componentName, location, propFullName) {
    const propValue = props[propName];
    const safePropName = propFullName || propName;
    if (propValue == null) return null;
    if (propValue && propValue.nodeType !== 1) return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. ` + `Expected an HTMLElement.`);
    return null;
}

});


parcelRegister("7JHF2", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $5a1e9a841ed0d0fc$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $5a1e9a841ed0d0fc$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5a1e9a841ed0d0fc$var$React = $5a1e9a841ed0d0fc$require$_interopRequireWildcard((parcelRequire("acw62")));

var $5a1e9a841ed0d0fc$var$_ownerDocument = $5a1e9a841ed0d0fc$require$_interopRequireDefault((parcelRequire("43fuO")));

var $5a1e9a841ed0d0fc$var$_useEnhancedEffect = $5a1e9a841ed0d0fc$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $5a1e9a841ed0d0fc$var$_useForkRef = $5a1e9a841ed0d0fc$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $5a1e9a841ed0d0fc$var$_chainPropTypes = $5a1e9a841ed0d0fc$require$_interopRequireDefault((parcelRequire("abVWF")));

var $5a1e9a841ed0d0fc$var$_HTMLElementType = $5a1e9a841ed0d0fc$require$_interopRequireDefault((parcelRequire("cIfK5")));

var $5a1e9a841ed0d0fc$var$_refType = $5a1e9a841ed0d0fc$require$_interopRequireDefault((parcelRequire("b3gjr")));

var $3tUi5 = parcelRequire("3tUi5");

var $5a1e9a841ed0d0fc$var$_propTypes = $5a1e9a841ed0d0fc$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $5a1e9a841ed0d0fc$var$_composeClasses = $5a1e9a841ed0d0fc$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $5a1e9a841ed0d0fc$var$_useSlotProps = $5a1e9a841ed0d0fc$require$_interopRequireDefault((parcelRequire("839K0")));

var $5a1e9a841ed0d0fc$var$_isLayoutSupported = $5a1e9a841ed0d0fc$require$_interopRequireDefault((parcelRequire("6toKj")));

var $5a1e9a841ed0d0fc$var$_Portal = $5a1e9a841ed0d0fc$require$_interopRequireDefault((parcelRequire("cJgE8")));

var $g3XLf = parcelRequire("g3XLf");

var $ayMG0 = parcelRequire("ayMG0");
function $5a1e9a841ed0d0fc$var$flipPlacement(placement, direction) {
    if (direction === 'ltr') return placement;
    switch(placement){
        case 'bottom-end':
            return 'bottom-start';
        case 'bottom-start':
            return 'bottom-end';
        case 'top-end':
            return 'top-start';
        case 'top-start':
            return 'top-end';
        default:
            return placement;
    }
}
function $5a1e9a841ed0d0fc$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
function $5a1e9a841ed0d0fc$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $5a1e9a841ed0d0fc$var$isVirtualElement(element) {
    return !$5a1e9a841ed0d0fc$var$isHTMLElement(element);
}
const $5a1e9a841ed0d0fc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $5a1e9a841ed0d0fc$var$_composeClasses.default)(slots, $g3XLf.getPopperUtilityClass, classes);
};
const $5a1e9a841ed0d0fc$var$defaultPopperOptions = {};
const $5a1e9a841ed0d0fc$var$PopperTooltip = /*#__PURE__*/ $5a1e9a841ed0d0fc$var$React.forwardRef(function PopperTooltip(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps, // @ts-ignore internal logic
    ownerState: ownerStateProp, // prevent from spreading to DOM, it can come from the parent component e.g. Select.
    ...other } = props;
    const tooltipRef = $5a1e9a841ed0d0fc$var$React.useRef(null);
    const ownRef = (0, $5a1e9a841ed0d0fc$var$_useForkRef.default)(tooltipRef, forwardedRef);
    const popperRef = $5a1e9a841ed0d0fc$var$React.useRef(null);
    const handlePopperRef = (0, $5a1e9a841ed0d0fc$var$_useForkRef.default)(popperRef, popperRefProp);
    const handlePopperRefRef = $5a1e9a841ed0d0fc$var$React.useRef(handlePopperRef);
    (0, $5a1e9a841ed0d0fc$var$_useEnhancedEffect.default)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $5a1e9a841ed0d0fc$var$React.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $5a1e9a841ed0d0fc$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $5a1e9a841ed0d0fc$var$React.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $5a1e9a841ed0d0fc$var$React.useState($5a1e9a841ed0d0fc$var$resolveAnchorEl(anchorEl));
    $5a1e9a841ed0d0fc$var$React.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $5a1e9a841ed0d0fc$var$React.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($5a1e9a841ed0d0fc$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $5a1e9a841ed0d0fc$var$_useEnhancedEffect.default)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        if (resolvedAnchorElement && $5a1e9a841ed0d0fc$var$isHTMLElement(resolvedAnchorElement) && resolvedAnchorElement.nodeType === 1) {
            const box = resolvedAnchorElement.getBoundingClientRect();
            if ((0, $5a1e9a841ed0d0fc$var$_isLayoutSupported.default)() && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) console.warn([
                'MUI: The `anchorEl` prop provided to the component is invalid.',
                'The anchor element should be part of the document layout.',
                "Make sure the element is present in the document or that it's not display none."
            ].join('\n'));
        }
        let popperModifiers = [
            {
                name: 'preventOverflow',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'flip',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'onUpdate',
                enabled: true,
                phase: 'afterWrite',
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $3tUi5.createPopper)(resolvedAnchorElement, tooltipRef.current, {
            placement: rtlPlacement,
            ...popperOptions,
            modifiers: popperModifiers
        });
        handlePopperRefRef.current(popper);
        const popperElement = tooltipRef.current;
        return ()=>{
            // popper.destroy() clears all inline positioning via the applyStyles
            // modifier cleanup, which causes the element to jump to its static
            // position. Snapshot and restore only the positioning properties so the
            // element stays in place during the destroy/recreate gap (prevents scroll
            // jumps when a child focuses between the two).
            // https://github.com/mui/mui-x/issues/21839
            if (popperElement) {
                const { style: style } = popperElement;
                const position = style.position;
                const top = style.top;
                const left = style.left;
                const transform = style.transform;
                popper.destroy();
                style.position = position;
                style.top = top;
                style.left = left;
                style.transform = transform;
            } else popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $5a1e9a841ed0d0fc$var$useUtilityClasses(props);
    const Root = slots.root ?? 'div';
    const rootProps = (0, $5a1e9a841ed0d0fc$var$_useSlotProps.default)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: 'tooltip',
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Root, {
        ...rootProps,
        children: typeof children === 'function' ? children(childProps) : children
    });
});
/**
 * @ignore - internal component.
 */ const $5a1e9a841ed0d0fc$var$Popper = /*#__PURE__*/ $5a1e9a841ed0d0fc$var$React.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = 'ltr', disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = 'bottom', popperOptions: popperOptions = $5a1e9a841ed0d0fc$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {}, ...other } = props;
    const [exited, setExited] = $5a1e9a841ed0d0fc$var$React.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $5a1e9a841ed0d0fc$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $5a1e9a841ed0d0fc$var$isHTMLElement(resolvedAnchorEl) ? (0, $5a1e9a841ed0d0fc$var$_ownerDocument.default)(resolvedAnchorEl).body : (0, $5a1e9a841ed0d0fc$var$_ownerDocument.default)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? 'none' : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5a1e9a841ed0d0fc$var$_Portal.default, {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($5a1e9a841ed0d0fc$var$PopperTooltip, {
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots,
            ...other,
            style: {
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: 'fixed',
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display,
                ...style
            },
            TransitionProps: transitionProps,
            children: children
        })
    });
});
$5a1e9a841ed0d0fc$var$Popper.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */ anchorEl: (0, $5a1e9a841ed0d0fc$var$_chainPropTypes.default)($5a1e9a841ed0d0fc$var$_propTypes.default.oneOfType([
        $5a1e9a841ed0d0fc$var$_HTMLElementType.default,
        $5a1e9a841ed0d0fc$var$_propTypes.default.object,
        $5a1e9a841ed0d0fc$var$_propTypes.default.func
    ]), (props)=>{
        if (props.open) {
            const resolvedAnchorEl = $5a1e9a841ed0d0fc$var$resolveAnchorEl(props.anchorEl);
            if (resolvedAnchorEl && $5a1e9a841ed0d0fc$var$isHTMLElement(resolvedAnchorEl) && resolvedAnchorEl.nodeType === 1) {
                const box = resolvedAnchorEl.getBoundingClientRect();
                if ((0, $5a1e9a841ed0d0fc$var$_isLayoutSupported.default)() && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) return new Error([
                    'MUI: The `anchorEl` prop provided to the component is invalid.',
                    'The anchor element should be part of the document layout.',
                    "Make sure the element is present in the document or that it's not display none."
                ].join('\n'));
            } else if (!resolvedAnchorEl || typeof resolvedAnchorEl.getBoundingClientRect !== 'function' || $5a1e9a841ed0d0fc$var$isVirtualElement(resolvedAnchorEl) && resolvedAnchorEl.contextElement != null && resolvedAnchorEl.contextElement.nodeType !== 1) return new Error([
                'MUI: The `anchorEl` prop provided to the component is invalid.',
                'It should be an HTML element instance or a virtualElement ',
                '(https://popper.js.org/docs/v2/virtual-elements/).'
            ].join('\n'));
        }
        return null;
    }),
    /**
   * Popper render function or node.
   */ children: $5a1e9a841ed0d0fc$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $5a1e9a841ed0d0fc$var$_propTypes.default.node,
        $5a1e9a841ed0d0fc$var$_propTypes.default.func
    ]),
    /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */ container: $5a1e9a841ed0d0fc$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $5a1e9a841ed0d0fc$var$_HTMLElementType.default,
        $5a1e9a841ed0d0fc$var$_propTypes.default.func
    ]),
    /**
   * Direction of the text.
   * @default 'ltr'
   */ direction: $5a1e9a841ed0d0fc$var$_propTypes.default.oneOf([
        'ltr',
        'rtl'
    ]),
    /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */ disablePortal: $5a1e9a841ed0d0fc$var$_propTypes.default.bool,
    /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */ keepMounted: $5a1e9a841ed0d0fc$var$_propTypes.default.bool,
    /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */ modifiers: $5a1e9a841ed0d0fc$var$_propTypes.default.arrayOf($5a1e9a841ed0d0fc$var$_propTypes.default.shape({
        data: $5a1e9a841ed0d0fc$var$_propTypes.default.object,
        effect: $5a1e9a841ed0d0fc$var$_propTypes.default.func,
        enabled: $5a1e9a841ed0d0fc$var$_propTypes.default.bool,
        fn: $5a1e9a841ed0d0fc$var$_propTypes.default.func,
        name: $5a1e9a841ed0d0fc$var$_propTypes.default.any,
        options: $5a1e9a841ed0d0fc$var$_propTypes.default.object,
        phase: $5a1e9a841ed0d0fc$var$_propTypes.default.oneOf([
            'afterMain',
            'afterRead',
            'afterWrite',
            'beforeMain',
            'beforeRead',
            'beforeWrite',
            'main',
            'read',
            'write'
        ]),
        requires: $5a1e9a841ed0d0fc$var$_propTypes.default.arrayOf($5a1e9a841ed0d0fc$var$_propTypes.default.string),
        requiresIfExists: $5a1e9a841ed0d0fc$var$_propTypes.default.arrayOf($5a1e9a841ed0d0fc$var$_propTypes.default.string)
    })),
    /**
   * If `true`, the component is shown.
   */ open: $5a1e9a841ed0d0fc$var$_propTypes.default.bool.isRequired,
    /**
   * Popper placement.
   * @default 'bottom'
   */ placement: $5a1e9a841ed0d0fc$var$_propTypes.default.oneOf([
        'auto-end',
        'auto-start',
        'auto',
        'bottom-end',
        'bottom-start',
        'bottom',
        'left-end',
        'left-start',
        'left',
        'right-end',
        'right-start',
        'right',
        'top-end',
        'top-start',
        'top'
    ]),
    /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */ popperOptions: $5a1e9a841ed0d0fc$var$_propTypes.default.shape({
        modifiers: $5a1e9a841ed0d0fc$var$_propTypes.default.array,
        onFirstUpdate: $5a1e9a841ed0d0fc$var$_propTypes.default.func,
        placement: $5a1e9a841ed0d0fc$var$_propTypes.default.oneOf([
            'auto-end',
            'auto-start',
            'auto',
            'bottom-end',
            'bottom-start',
            'bottom',
            'left-end',
            'left-start',
            'left',
            'right-end',
            'right-start',
            'right',
            'top-end',
            'top-start',
            'top'
        ]),
        strategy: $5a1e9a841ed0d0fc$var$_propTypes.default.oneOf([
            'absolute',
            'fixed'
        ])
    }),
    /**
   * A ref that points to the used popper instance.
   */ popperRef: $5a1e9a841ed0d0fc$var$_refType.default,
    /**
   * The props used for each slot inside the Popper.
   * @default {}
   */ slotProps: $5a1e9a841ed0d0fc$var$_propTypes.default.shape({
        root: $5a1e9a841ed0d0fc$var$_propTypes.default.oneOfType([
            $5a1e9a841ed0d0fc$var$_propTypes.default.func,
            $5a1e9a841ed0d0fc$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */ slots: $5a1e9a841ed0d0fc$var$_propTypes.default.shape({
        root: $5a1e9a841ed0d0fc$var$_propTypes.default.elementType
    }),
    /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */ transition: $5a1e9a841ed0d0fc$var$_propTypes.default.bool
};
var $5a1e9a841ed0d0fc$var$_default = module.exports.default = $5a1e9a841ed0d0fc$var$Popper;

});
parcelRegister("43fuO", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $2f33766ba7c82ed1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $2f33766ba7c82ed1$var$_ownerDocument.default;
    }
});

var $2f33766ba7c82ed1$var$_ownerDocument = $2f33766ba7c82ed1$require$_interopRequireDefault((parcelRequire("49EPw")));

});
parcelRegister("49EPw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3067acab6211afec$var$ownerDocument;
function $3067acab6211afec$var$ownerDocument(node) {
    return node && node.ownerDocument || document;
}

});


parcelRegister("3tUi5", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $288fbeb449f53487$export$8f7491d57c8f97a9);

var $8iXfp = parcelRequire("8iXfp");

var $jU5vk = parcelRequire("jU5vk");

var $cePA2 = parcelRequire("cePA2");

var $5ZHwq = parcelRequire("5ZHwq");

var $aOl9t = parcelRequire("aOl9t");

var $lWzyf = parcelRequire("lWzyf");

var $hMqHB = parcelRequire("hMqHB");

var $bxdrS = parcelRequire("bxdrS");

var $kU5lB = parcelRequire("kU5lB");

var $95q7y = parcelRequire("95q7y");


var $288fbeb449f53487$export$d34966752335dd47 = [
    (0, $jU5vk.default),
    (0, $cePA2.default),
    (0, $5ZHwq.default),
    (0, $aOl9t.default),
    (0, $lWzyf.default),
    (0, $hMqHB.default),
    (0, $bxdrS.default),
    (0, $kU5lB.default),
    (0, $95q7y.default)
];
var $288fbeb449f53487$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $8iXfp.popperGenerator)({
    defaultModifiers: $288fbeb449f53487$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("8iXfp", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $60bdf67e43f5dfcb$export$ed5e13716264f202);

var $gcqB4 = parcelRequire("gcqB4");

var $dElKO = parcelRequire("dElKO");

var $cqjGx = parcelRequire("cqjGx");

var $5KzeH = parcelRequire("5KzeH");

var $ahlk8 = parcelRequire("ahlk8");

var $dlelj = parcelRequire("dlelj");

var $l57aq = parcelRequire("l57aq");


var $93iQ7 = parcelRequire("93iQ7");
var $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $60bdf67e43f5dfcb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $60bdf67e43f5dfcb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $93iQ7.isElement)(reference) ? (0, $cqjGx.default)(reference) : reference.contextElement ? (0, $cqjGx.default)(reference.contextElement) : [],
                    popper: (0, $cqjGx.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $ahlk8.default)((0, $l57aq.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $gcqB4.default)(reference, (0, $5KzeH.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $dElKO.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $dlelj.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $60bdf67e43f5dfcb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $60bdf67e43f5dfcb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("gcqB4", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcb265ed9201975a$export$2e2bcd8739ae039);

var $41Z5W = parcelRequire("41Z5W");

var $eOasn = parcelRequire("eOasn");

var $oKPBf = parcelRequire("oKPBf");

var $93iQ7 = parcelRequire("93iQ7");

var $8fnXo = parcelRequire("8fnXo");

var $17OuU = parcelRequire("17OuU");

var $1ADUj = parcelRequire("1ADUj");

var $4J8n1 = parcelRequire("4J8n1");
function $bcb265ed9201975a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $4J8n1.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $4J8n1.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bcb265ed9201975a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $93iQ7.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $93iQ7.isHTMLElement)(offsetParent) && $bcb265ed9201975a$var$isElementScaled(offsetParent);
    var documentElement = (0, $17OuU.default)(offsetParent);
    var rect = (0, $41Z5W.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $oKPBf.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $1ADUj.default)(documentElement)) scroll = (0, $eOasn.default)(offsetParent);
        if ((0, $93iQ7.isHTMLElement)(offsetParent)) {
            offsets = (0, $41Z5W.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $8fnXo.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("41Z5W", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ef6a598263dba8e$export$2e2bcd8739ae039);

var $93iQ7 = parcelRequire("93iQ7");

var $4J8n1 = parcelRequire("4J8n1");

var $93G53 = parcelRequire("93G53");

var $gotNd = parcelRequire("gotNd");
function $2ef6a598263dba8e$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $93iQ7.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $4J8n1.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $4J8n1.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $93iQ7.isElement)(element) ? (0, $93G53.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $gotNd.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("93iQ7", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $69730206aa270d41$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $69730206aa270d41$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $69730206aa270d41$export$af51f0f06c0f328a);

var $93G53 = parcelRequire("93G53");
function $69730206aa270d41$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $93G53.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $69730206aa270d41$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $93G53.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $69730206aa270d41$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $93G53.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("93G53", function(module, exports) {

$parcel$export(module.exports, "default", () => $6985093033570817$export$2e2bcd8739ae039);
function $6985093033570817$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("4J8n1", function(module, exports) {

$parcel$export(module.exports, "max", () => $3711db8b00de96df$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $3711db8b00de96df$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $3711db8b00de96df$export$2077e0241d6afd3c);
var $3711db8b00de96df$export$8960430cfd85939f = Math.max;
var $3711db8b00de96df$export$96ec731ed4dcb222 = Math.min;
var $3711db8b00de96df$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("gotNd", function(module, exports) {

$parcel$export(module.exports, "default", () => $bef5ff765617d084$export$2e2bcd8739ae039);

var $9r1ut = parcelRequire("9r1ut");
function $bef5ff765617d084$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $9r1ut.default)());
}

});
parcelRegister("9r1ut", function(module, exports) {

$parcel$export(module.exports, "default", () => $6de7caa8ee90d63c$export$2e2bcd8739ae039);
function $6de7caa8ee90d63c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("eOasn", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac7dd8aeabb81fe8$export$2e2bcd8739ae039);

var $4WW7r = parcelRequire("4WW7r");

var $93G53 = parcelRequire("93G53");

var $93iQ7 = parcelRequire("93iQ7");

var $ieX38 = parcelRequire("ieX38");
function $ac7dd8aeabb81fe8$export$2e2bcd8739ae039(node) {
    if (node === (0, $93G53.default)(node) || !(0, $93iQ7.isHTMLElement)(node)) return (0, $4WW7r.default)(node);
    else return (0, $ieX38.default)(node);
}

});
parcelRegister("4WW7r", function(module, exports) {

$parcel$export(module.exports, "default", () => $39a9a96b6f99add9$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");
function $39a9a96b6f99add9$export$2e2bcd8739ae039(node) {
    var win = (0, $93G53.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("ieX38", function(module, exports) {

$parcel$export(module.exports, "default", () => $d47756cb7a847081$export$2e2bcd8739ae039);
function $d47756cb7a847081$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("oKPBf", function(module, exports) {

$parcel$export(module.exports, "default", () => $04a691b7a330df44$export$2e2bcd8739ae039);
function $04a691b7a330df44$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("8fnXo", function(module, exports) {

$parcel$export(module.exports, "default", () => $60124eceeef28a28$export$2e2bcd8739ae039);

var $41Z5W = parcelRequire("41Z5W");

var $17OuU = parcelRequire("17OuU");

var $4WW7r = parcelRequire("4WW7r");
function $60124eceeef28a28$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $41Z5W.default)((0, $17OuU.default)(element)).left + (0, $4WW7r.default)(element).scrollLeft;
}

});
parcelRegister("17OuU", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d1d9daad62fa952$export$2e2bcd8739ae039);

var $93iQ7 = parcelRequire("93iQ7");
function $0d1d9daad62fa952$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $93iQ7.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("1ADUj", function(module, exports) {

$parcel$export(module.exports, "default", () => $12881c0013479a14$export$2e2bcd8739ae039);

var $huVQQ = parcelRequire("huVQQ");
function $12881c0013479a14$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $huVQQ.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("huVQQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbd21d1454570861$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");
function $cbd21d1454570861$export$2e2bcd8739ae039(element) {
    return (0, $93G53.default)(element).getComputedStyle(element);
}

});



parcelRegister("dElKO", function(module, exports) {

$parcel$export(module.exports, "default", () => $9effe2b32f662e4a$export$2e2bcd8739ae039);

var $41Z5W = parcelRequire("41Z5W");
function $9effe2b32f662e4a$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $41Z5W.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("cqjGx", function(module, exports) {

$parcel$export(module.exports, "default", () => $90b72ed15edfd54a$export$2e2bcd8739ae039);

var $3QP5e = parcelRequire("3QP5e");

var $aerap = parcelRequire("aerap");

var $93G53 = parcelRequire("93G53");

var $1ADUj = parcelRequire("1ADUj");
function $90b72ed15edfd54a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $3QP5e.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $93G53.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $1ADUj.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($90b72ed15edfd54a$export$2e2bcd8739ae039((0, $aerap.default)(target)));
}

});
parcelRegister("3QP5e", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cddda83e3357241$export$2e2bcd8739ae039);

var $aerap = parcelRequire("aerap");

var $1ADUj = parcelRequire("1ADUj");

var $oKPBf = parcelRequire("oKPBf");

var $93iQ7 = parcelRequire("93iQ7");
function $2cddda83e3357241$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $oKPBf.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $93iQ7.isHTMLElement)(node) && (0, $1ADUj.default)(node)) return node;
    return $2cddda83e3357241$export$2e2bcd8739ae039((0, $aerap.default)(node));
}

});
parcelRegister("aerap", function(module, exports) {

$parcel$export(module.exports, "default", () => $773048fc1d2aa7ee$export$2e2bcd8739ae039);

var $oKPBf = parcelRequire("oKPBf");

var $17OuU = parcelRequire("17OuU");

var $93iQ7 = parcelRequire("93iQ7");
function $773048fc1d2aa7ee$export$2e2bcd8739ae039(element) {
    if ((0, $oKPBf.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $93iQ7.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $17OuU.default)(element) // fallback
    );
}

});



parcelRegister("5KzeH", function(module, exports) {

$parcel$export(module.exports, "default", () => $42fc94c94931c781$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");

var $oKPBf = parcelRequire("oKPBf");

var $huVQQ = parcelRequire("huVQQ");

var $93iQ7 = parcelRequire("93iQ7");

var $lKbxe = parcelRequire("lKbxe");

var $aerap = parcelRequire("aerap");

var $9r1ut = parcelRequire("9r1ut");
function $42fc94c94931c781$var$getTrueOffsetParent(element) {
    if (!(0, $93iQ7.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $huVQQ.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $42fc94c94931c781$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $9r1ut.default)());
    var isIE = /Trident/i.test((0, $9r1ut.default)());
    if (isIE && (0, $93iQ7.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $huVQQ.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $aerap.default)(element);
    if ((0, $93iQ7.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $93iQ7.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $oKPBf.default)(currentNode)) < 0){
        var css = (0, $huVQQ.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $42fc94c94931c781$export$2e2bcd8739ae039(element) {
    var window = (0, $93G53.default)(element);
    var offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $lKbxe.default)(offsetParent) && (0, $huVQQ.default)(offsetParent).position === 'static')offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $oKPBf.default)(offsetParent) === 'html' || (0, $oKPBf.default)(offsetParent) === 'body' && (0, $huVQQ.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $42fc94c94931c781$var$getContainingBlock(element) || window;
}

});
parcelRegister("lKbxe", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd46d779ec622be4$export$2e2bcd8739ae039);

var $oKPBf = parcelRequire("oKPBf");
function $fd46d779ec622be4$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $oKPBf.default)(element)) >= 0;
}

});


parcelRegister("ahlk8", function(module, exports) {

$parcel$export(module.exports, "default", () => $77bc085de34276f2$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");
function $77bc085de34276f2$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $77bc085de34276f2$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $77bc085de34276f2$var$order(modifiers); // order based on phase
    return (0, $1KQnQ.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("1KQnQ", function(module, exports) {

$parcel$export(module.exports, "top", () => $1472b89a65155de2$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $1472b89a65155de2$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $1472b89a65155de2$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $1472b89a65155de2$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $1472b89a65155de2$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $1472b89a65155de2$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $1472b89a65155de2$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $1472b89a65155de2$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $1472b89a65155de2$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $1472b89a65155de2$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $1472b89a65155de2$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $1472b89a65155de2$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $1472b89a65155de2$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $1472b89a65155de2$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $1472b89a65155de2$export$d087d3878fdf71d5);
var $1472b89a65155de2$export$1e95b668f3b82d = 'top';
var $1472b89a65155de2$export$40e543e69a8b3fbb = 'bottom';
var $1472b89a65155de2$export$79ffe56a765070d2 = 'right';
var $1472b89a65155de2$export$eabcd2c8791e7bf4 = 'left';
var $1472b89a65155de2$export$dfb5619354ba860 = 'auto';
var $1472b89a65155de2$export$aec2ce47c367b8c3 = [
    $1472b89a65155de2$export$1e95b668f3b82d,
    $1472b89a65155de2$export$40e543e69a8b3fbb,
    $1472b89a65155de2$export$79ffe56a765070d2,
    $1472b89a65155de2$export$eabcd2c8791e7bf4
];
var $1472b89a65155de2$export$b3571188c770cc5a = 'start';
var $1472b89a65155de2$export$bd5df0f255a350f8 = 'end';
var $1472b89a65155de2$export$390fd549c5303b4d = 'clippingParents';
var $1472b89a65155de2$export$d7b7311ec04a3e8f = 'viewport';
var $1472b89a65155de2$export$ae5ab1c730825774 = 'popper';
var $1472b89a65155de2$export$ca50aac9f3ba507f = 'reference';
var $1472b89a65155de2$export$368f9a87e87fa4e1 = /*#__PURE__*/ $1472b89a65155de2$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []);
var $1472b89a65155de2$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($1472b89a65155de2$export$aec2ce47c367b8c3, [
    $1472b89a65155de2$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $1472b89a65155de2$export$421679a7c3d56e = 'beforeRead';
var $1472b89a65155de2$export$aafa59e2e03f2942 = 'read';
var $1472b89a65155de2$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $1472b89a65155de2$export$c65e99957a05207c = 'beforeMain';
var $1472b89a65155de2$export$f22da7240b7add18 = 'main';
var $1472b89a65155de2$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $1472b89a65155de2$export$8d4d2d70e7d46032 = 'beforeWrite';
var $1472b89a65155de2$export$68d8715fc104d294 = 'write';
var $1472b89a65155de2$export$70a6e5159acce2e6 = 'afterWrite';
var $1472b89a65155de2$export$d087d3878fdf71d5 = [
    $1472b89a65155de2$export$421679a7c3d56e,
    $1472b89a65155de2$export$aafa59e2e03f2942,
    $1472b89a65155de2$export$6964f6c886723980,
    $1472b89a65155de2$export$c65e99957a05207c,
    $1472b89a65155de2$export$f22da7240b7add18,
    $1472b89a65155de2$export$bab79516f2d662fe,
    $1472b89a65155de2$export$8d4d2d70e7d46032,
    $1472b89a65155de2$export$68d8715fc104d294,
    $1472b89a65155de2$export$70a6e5159acce2e6
];

});


parcelRegister("dlelj", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b685cb08303911c$export$2e2bcd8739ae039);
function $9b685cb08303911c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("l57aq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f58f9fd4551b4b0f$export$2e2bcd8739ae039);
function $f58f9fd4551b4b0f$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("jU5vk", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7d7845625089588$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");
var $e7d7845625089588$var$passive = {
    passive: true
};
function $e7d7845625089588$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $93G53.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $e7d7845625089588$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $e7d7845625089588$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $e7d7845625089588$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $e7d7845625089588$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e7d7845625089588$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $e7d7845625089588$var$effect,
    data: {}
};

});

parcelRegister("cePA2", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e8ecd9a827a16d7$export$2e2bcd8739ae039);

var $dgDBP = parcelRequire("dgDBP");
function $8e8ecd9a827a16d7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $dgDBP.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8e8ecd9a827a16d7$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $8e8ecd9a827a16d7$var$popperOffsets,
    data: {}
};

});
parcelRegister("dgDBP", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a8b7e877fbba4f3$export$2e2bcd8739ae039);

var $h06jI = parcelRequire("h06jI");

var $7kchx = parcelRequire("7kchx");

var $g1hRA = parcelRequire("g1hRA");

var $1KQnQ = parcelRequire("1KQnQ");
function $9a8b7e877fbba4f3$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $h06jI.default)(placement) : null;
    var variation = placement ? (0, $7kchx.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1KQnQ.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1KQnQ.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1KQnQ.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1KQnQ.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $g1hRA.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $1KQnQ.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1KQnQ.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("h06jI", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6075629d0814627$export$2e2bcd8739ae039);

function $c6075629d0814627$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("7kchx", function(module, exports) {

$parcel$export(module.exports, "default", () => $5553ed9c2ee225e3$export$2e2bcd8739ae039);
function $5553ed9c2ee225e3$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("g1hRA", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba9a98a4204389e3$export$2e2bcd8739ae039);
function $ba9a98a4204389e3$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("5ZHwq", function(module, exports) {

$parcel$export(module.exports, "default", () => $45d468ca92a1d24b$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $5KzeH = parcelRequire("5KzeH");

var $93G53 = parcelRequire("93G53");

var $17OuU = parcelRequire("17OuU");

var $huVQQ = parcelRequire("huVQQ");

var $h06jI = parcelRequire("h06jI");

var $7kchx = parcelRequire("7kchx");

var $4J8n1 = parcelRequire("4J8n1");
var $45d468ca92a1d24b$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $45d468ca92a1d24b$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $4J8n1.round)(x * dpr) / dpr || 0,
        y: (0, $4J8n1.round)(y * dpr) / dpr || 0
    };
}
function $45d468ca92a1d24b$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $1KQnQ.left);
    var sideY = (0, $1KQnQ.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $5KzeH.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $93G53.default)(popper)) {
            offsetParent = (0, $17OuU.default)(popper);
            if ((0, $huVQQ.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1KQnQ.top) || (placement === (0, $1KQnQ.left) || placement === (0, $1KQnQ.right)) && variation === (0, $1KQnQ.end)) {
            sideY = (0, $1KQnQ.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1KQnQ.left) || (placement === (0, $1KQnQ.top) || placement === (0, $1KQnQ.bottom)) && variation === (0, $1KQnQ.end)) {
            sideX = (0, $1KQnQ.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $45d468ca92a1d24b$var$unsetSides);
    var _ref4 = roundOffsets === true ? $45d468ca92a1d24b$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $93G53.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $45d468ca92a1d24b$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $h06jI.default)(state.placement),
        variation: (0, $7kchx.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $45d468ca92a1d24b$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $45d468ca92a1d24b$var$computeStyles,
    data: {}
};

});

parcelRegister("aOl9t", function(module, exports) {

$parcel$export(module.exports, "default", () => $7deefb3680d4558f$export$2e2bcd8739ae039);

var $oKPBf = parcelRequire("oKPBf");

var $93iQ7 = parcelRequire("93iQ7");
// and applies them to the HTMLElements such as popper and arrow
function $7deefb3680d4558f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $93iQ7.isHTMLElement)(element) || !(0, $oKPBf.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $7deefb3680d4558f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $93iQ7.isHTMLElement)(element) || !(0, $oKPBf.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $7deefb3680d4558f$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $7deefb3680d4558f$var$applyStyles,
    effect: $7deefb3680d4558f$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("lWzyf", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff9a9783c10adebd$export$2e2bcd8739ae039);

var $h06jI = parcelRequire("h06jI");

var $1KQnQ = parcelRequire("1KQnQ");
function $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $h06jI.default)(placement);
    var invertDistance = [
        (0, $1KQnQ.left),
        (0, $1KQnQ.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1KQnQ.left),
        (0, $1KQnQ.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ff9a9783c10adebd$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1KQnQ.placements).reduce(function(acc, placement) {
        acc[placement] = $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ff9a9783c10adebd$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $ff9a9783c10adebd$var$offset
};

});

parcelRegister("hMqHB", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf1ba1dd94205465$export$2e2bcd8739ae039);

var $eFT7Y = parcelRequire("eFT7Y");

var $h06jI = parcelRequire("h06jI");

var $4NVvZ = parcelRequire("4NVvZ");

var $gGcga = parcelRequire("gGcga");

var $iN4T7 = parcelRequire("iN4T7");

var $1KQnQ = parcelRequire("1KQnQ");

var $7kchx = parcelRequire("7kchx");
function $cf1ba1dd94205465$var$getExpandedFallbackPlacements(placement) {
    if ((0, $h06jI.default)(placement) === (0, $1KQnQ.auto)) return [];
    var oppositePlacement = (0, $eFT7Y.default)(placement);
    return [
        (0, $4NVvZ.default)(placement),
        oppositePlacement,
        (0, $4NVvZ.default)(oppositePlacement)
    ];
}
function $cf1ba1dd94205465$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $h06jI.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $eFT7Y.default)(preferredPlacement)
    ] : $cf1ba1dd94205465$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $h06jI.default)(placement) === (0, $1KQnQ.auto) ? (0, $iN4T7.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $h06jI.default)(placement);
        var isStartVariation = (0, $7kchx.default)(placement) === (0, $1KQnQ.start);
        var isVertical = [
            (0, $1KQnQ.top),
            (0, $1KQnQ.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $gGcga.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1KQnQ.right) : (0, $1KQnQ.left) : isStartVariation ? (0, $1KQnQ.bottom) : (0, $1KQnQ.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $eFT7Y.default)(mainVariationSide);
        var altVariationSide = (0, $eFT7Y.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $cf1ba1dd94205465$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $cf1ba1dd94205465$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("eFT7Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaefa8315f14c8e2$export$2e2bcd8739ae039);
var $aaefa8315f14c8e2$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $aaefa8315f14c8e2$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $aaefa8315f14c8e2$var$hash[matched];
    });
}

});

parcelRegister("4NVvZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $37f85a49ff946cb6$export$2e2bcd8739ae039);
var $37f85a49ff946cb6$var$hash = {
    start: 'end',
    end: 'start'
};
function $37f85a49ff946cb6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $37f85a49ff946cb6$var$hash[matched];
    });
}

});

parcelRegister("gGcga", function(module, exports) {

$parcel$export(module.exports, "default", () => $c24a1421ba2f823c$export$2e2bcd8739ae039);

var $5T76m = parcelRequire("5T76m");

var $17OuU = parcelRequire("17OuU");

var $41Z5W = parcelRequire("41Z5W");

var $dgDBP = parcelRequire("dgDBP");

var $ik7Fq = parcelRequire("ik7Fq");

var $1KQnQ = parcelRequire("1KQnQ");

var $93iQ7 = parcelRequire("93iQ7");

var $3Os63 = parcelRequire("3Os63");

var $hdgde = parcelRequire("hdgde");
function $c24a1421ba2f823c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1KQnQ.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1KQnQ.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1KQnQ.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $3Os63.default)(typeof padding !== 'number' ? padding : (0, $hdgde.default)(padding, (0, $1KQnQ.basePlacements)));
    var altContext = elementContext === (0, $1KQnQ.popper) ? (0, $1KQnQ.reference) : (0, $1KQnQ.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $5T76m.default)((0, $93iQ7.isElement)(element) ? element : element.contextElement || (0, $17OuU.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $41Z5W.default)(state.elements.reference);
    var popperOffsets = (0, $dgDBP.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $ik7Fq.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1KQnQ.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1KQnQ.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1KQnQ.right),
                (0, $1KQnQ.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1KQnQ.top),
                (0, $1KQnQ.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("5T76m", function(module, exports) {

$parcel$export(module.exports, "default", () => $449799046a13d100$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $e1yxe = parcelRequire("e1yxe");

var $ef4Kl = parcelRequire("ef4Kl");

var $cqjGx = parcelRequire("cqjGx");

var $5KzeH = parcelRequire("5KzeH");

var $17OuU = parcelRequire("17OuU");

var $huVQQ = parcelRequire("huVQQ");

var $93iQ7 = parcelRequire("93iQ7");

var $41Z5W = parcelRequire("41Z5W");

var $aerap = parcelRequire("aerap");

var $ciq1x = parcelRequire("ciq1x");

var $oKPBf = parcelRequire("oKPBf");

var $ik7Fq = parcelRequire("ik7Fq");

var $4J8n1 = parcelRequire("4J8n1");
function $449799046a13d100$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $41Z5W.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1KQnQ.viewport) ? (0, $ik7Fq.default)((0, $e1yxe.default)(element, strategy)) : (0, $93iQ7.isElement)(clippingParent) ? $449799046a13d100$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $ik7Fq.default)((0, $ef4Kl.default)((0, $17OuU.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $449799046a13d100$var$getClippingParents(element) {
    var clippingParents = (0, $cqjGx.default)((0, $aerap.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $huVQQ.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $93iQ7.isHTMLElement)(element) ? (0, $5KzeH.default)(element) : element;
    if (!(0, $93iQ7.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $93iQ7.isElement)(clippingParent) && (0, $ciq1x.default)(clippingParent, clipperElement) && (0, $oKPBf.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $449799046a13d100$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $449799046a13d100$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $4J8n1.max)(rect.top, accRect.top);
        accRect.right = (0, $4J8n1.min)(rect.right, accRect.right);
        accRect.bottom = (0, $4J8n1.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $4J8n1.max)(rect.left, accRect.left);
        return accRect;
    }, $449799046a13d100$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("e1yxe", function(module, exports) {

$parcel$export(module.exports, "default", () => $a35bf29d5fc5ab40$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");

var $17OuU = parcelRequire("17OuU");

var $8fnXo = parcelRequire("8fnXo");

var $gotNd = parcelRequire("gotNd");
function $a35bf29d5fc5ab40$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $93G53.default)(element);
    var html = (0, $17OuU.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $gotNd.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $8fnXo.default)(element),
        y: y
    };
}

});

parcelRegister("ef4Kl", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5e625ef2dd801ec$export$2e2bcd8739ae039);

var $17OuU = parcelRequire("17OuU");

var $huVQQ = parcelRequire("huVQQ");

var $8fnXo = parcelRequire("8fnXo");

var $4WW7r = parcelRequire("4WW7r");

var $4J8n1 = parcelRequire("4J8n1");
function $a5e625ef2dd801ec$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $17OuU.default)(element);
    var winScroll = (0, $4WW7r.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $4J8n1.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $4J8n1.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $8fnXo.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $huVQQ.default)(body || html).direction === 'rtl') x += (0, $4J8n1.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("ciq1x", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f3b5a3db2e59cbc$export$2e2bcd8739ae039);

var $93iQ7 = parcelRequire("93iQ7");
function $8f3b5a3db2e59cbc$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $93iQ7.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("ik7Fq", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5700acdd3ba9a3c$export$2e2bcd8739ae039);
function $d5700acdd3ba9a3c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("3Os63", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c6bd604be4c867e$export$2e2bcd8739ae039);

var $gcu3h = parcelRequire("gcu3h");
function $2c6bd604be4c867e$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $gcu3h.default)(), paddingObject);
}

});
parcelRegister("gcu3h", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcb51404109b5184$export$2e2bcd8739ae039);
function $bcb51404109b5184$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("hdgde", function(module, exports) {

$parcel$export(module.exports, "default", () => $c88039fe47959ef5$export$2e2bcd8739ae039);
function $c88039fe47959ef5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("iN4T7", function(module, exports) {

$parcel$export(module.exports, "default", () => $dae0983d65fbfc0b$export$2e2bcd8739ae039);

var $7kchx = parcelRequire("7kchx");

var $1KQnQ = parcelRequire("1KQnQ");

var $gGcga = parcelRequire("gGcga");

var $h06jI = parcelRequire("h06jI");
function $dae0983d65fbfc0b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1KQnQ.placements) : _options$allowedAutoP;
    var variation = (0, $7kchx.default)(placement);
    var placements = variation ? flipVariations ? (0, $1KQnQ.variationPlacements) : (0, $1KQnQ.variationPlacements).filter(function(placement) {
        return (0, $7kchx.default)(placement) === variation;
    }) : (0, $1KQnQ.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $gGcga.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $h06jI.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("bxdrS", function(module, exports) {

$parcel$export(module.exports, "default", () => $865d356b2ca960a5$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $h06jI = parcelRequire("h06jI");

var $g1hRA = parcelRequire("g1hRA");

var $8ptl2 = parcelRequire("8ptl2");

var $cOvrb = parcelRequire("cOvrb");

var $dElKO = parcelRequire("dElKO");

var $5KzeH = parcelRequire("5KzeH");

var $gGcga = parcelRequire("gGcga");

var $7kchx = parcelRequire("7kchx");

var $gcu3h = parcelRequire("gcu3h");

var $4J8n1 = parcelRequire("4J8n1");
function $865d356b2ca960a5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $gGcga.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $h06jI.default)(state.placement);
    var variation = (0, $7kchx.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $g1hRA.default)(basePlacement);
    var altAxis = (0, $8ptl2.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $1KQnQ.top) : (0, $1KQnQ.left);
        var altSide = mainAxis === 'y' ? (0, $1KQnQ.bottom) : (0, $1KQnQ.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1KQnQ.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1KQnQ.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $dElKO.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $gcu3h.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $cOvrb.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $5KzeH.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $cOvrb.within)(tether ? (0, $4J8n1.min)(min, tetherMin) : min, offset, tether ? (0, $4J8n1.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $1KQnQ.top) : (0, $1KQnQ.left);
        var _altSide = mainAxis === 'x' ? (0, $1KQnQ.bottom) : (0, $1KQnQ.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1KQnQ.top),
            (0, $1KQnQ.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $cOvrb.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $cOvrb.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $865d356b2ca960a5$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $865d356b2ca960a5$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("8ptl2", function(module, exports) {

$parcel$export(module.exports, "default", () => $61f76a8076c296c7$export$2e2bcd8739ae039);
function $61f76a8076c296c7$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("cOvrb", function(module, exports) {

$parcel$export(module.exports, "within", () => $95428a5e75015184$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $95428a5e75015184$export$86c8af6d3ef0b4a);

var $4J8n1 = parcelRequire("4J8n1");
function $95428a5e75015184$export$f28d906d67a997f3(min, value, max) {
    return (0, $4J8n1.max)(min, (0, $4J8n1.min)(value, max));
}
function $95428a5e75015184$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $95428a5e75015184$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("kU5lB", function(module, exports) {

$parcel$export(module.exports, "default", () => $f37d2f7eaf2ad10e$export$2e2bcd8739ae039);

var $h06jI = parcelRequire("h06jI");

var $dElKO = parcelRequire("dElKO");

var $ciq1x = parcelRequire("ciq1x");

var $5KzeH = parcelRequire("5KzeH");

var $g1hRA = parcelRequire("g1hRA");

var $cOvrb = parcelRequire("cOvrb");

var $3Os63 = parcelRequire("3Os63");

var $hdgde = parcelRequire("hdgde");

var $1KQnQ = parcelRequire("1KQnQ");
var $f37d2f7eaf2ad10e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $3Os63.default)(typeof padding !== 'number' ? padding : (0, $hdgde.default)(padding, (0, $1KQnQ.basePlacements)));
};
function $f37d2f7eaf2ad10e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $h06jI.default)(state.placement);
    var axis = (0, $g1hRA.default)(basePlacement);
    var isVertical = [
        (0, $1KQnQ.left),
        (0, $1KQnQ.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $f37d2f7eaf2ad10e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $dElKO.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $1KQnQ.top) : (0, $1KQnQ.left);
    var maxProp = axis === 'y' ? (0, $1KQnQ.bottom) : (0, $1KQnQ.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $5KzeH.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $cOvrb.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $f37d2f7eaf2ad10e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $ciq1x.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $f37d2f7eaf2ad10e$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $f37d2f7eaf2ad10e$var$arrow,
    effect: $f37d2f7eaf2ad10e$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("95q7y", function(module, exports) {

$parcel$export(module.exports, "default", () => $69d8d7bda7717b01$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $gGcga = parcelRequire("gGcga");
function $69d8d7bda7717b01$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $69d8d7bda7717b01$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1KQnQ.top),
        (0, $1KQnQ.right),
        (0, $1KQnQ.bottom),
        (0, $1KQnQ.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $69d8d7bda7717b01$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $gGcga.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $gGcga.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $69d8d7bda7717b01$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $69d8d7bda7717b01$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $69d8d7bda7717b01$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $69d8d7bda7717b01$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $69d8d7bda7717b01$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $69d8d7bda7717b01$var$hide
};

});


parcelRegister("839K0", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5dc628ec8311fc9a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $5dc628ec8311fc9a$var$_useSlotProps.default;
    }
});

var $5dc628ec8311fc9a$var$_useSlotProps = $5dc628ec8311fc9a$require$_interopRequireDefault((parcelRequire("jjoya")));

});
parcelRegister("jjoya", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $e0f2d5c8a2ef3c7f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e0f2d5c8a2ef3c7f$var$_useForkRef = $e0f2d5c8a2ef3c7f$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $e0f2d5c8a2ef3c7f$var$_appendOwnerState = $e0f2d5c8a2ef3c7f$require$_interopRequireDefault((parcelRequire("fByHY")));

var $e0f2d5c8a2ef3c7f$var$_mergeSlotProps = $e0f2d5c8a2ef3c7f$require$_interopRequireDefault((parcelRequire("dfy9C")));

var $e0f2d5c8a2ef3c7f$var$_resolveComponentProps = $e0f2d5c8a2ef3c7f$require$_interopRequireDefault((parcelRequire("jzekU")));
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $e0f2d5c8a2ef3c7f$var$useSlotProps(parameters) {
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false, ...other } = parameters;
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $e0f2d5c8a2ef3c7f$var$_resolveComponentProps.default)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $e0f2d5c8a2ef3c7f$var$_mergeSlotProps.default)({
        ...other,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $e0f2d5c8a2ef3c7f$var$_useForkRef.default)(internalRef, resolvedComponentsProps?.ref, parameters.additionalProps?.ref);
    const props = (0, $e0f2d5c8a2ef3c7f$var$_appendOwnerState.default)(elementType, {
        ...mergedProps,
        ref: ref
    }, ownerState);
    return props;
}
var $e0f2d5c8a2ef3c7f$var$_default = module.exports.default = $e0f2d5c8a2ef3c7f$var$useSlotProps;

});
parcelRegister("fByHY", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $b5c53c0db043a190$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $b5c53c0db043a190$var$_appendOwnerState.default;
    }
});

var $b5c53c0db043a190$var$_appendOwnerState = $b5c53c0db043a190$require$_interopRequireDefault((parcelRequire("SxCI4")));

});
parcelRegister("SxCI4", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0a3f2028457854eb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0a3f2028457854eb$var$_isHostComponent = $0a3f2028457854eb$require$_interopRequireDefault((parcelRequire("7jqh1")));
/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $0a3f2028457854eb$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $0a3f2028457854eb$var$_isHostComponent.default)(elementType)) return otherProps;
    return {
        ...otherProps,
        ownerState: {
            ...otherProps.ownerState,
            ...ownerState
        }
    };
}
var $0a3f2028457854eb$var$_default = module.exports.default = $0a3f2028457854eb$var$appendOwnerState;

});
parcelRegister("7jqh1", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $552eb02447a4b108$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $552eb02447a4b108$var$_isHostComponent.default;
    }
});

var $552eb02447a4b108$var$_isHostComponent = $552eb02447a4b108$require$_interopRequireDefault((parcelRequire("1cVk7")));

});
parcelRegister("1cVk7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $0e1360ab77873eb8$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $0e1360ab77873eb8$var$_default = module.exports.default = $0e1360ab77873eb8$var$isHostComponent;

});




parcelRegister("dfy9C", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9a572b623f6aa29c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9a572b623f6aa29c$var$_mergeSlotProps.default;
    }
});

var $9a572b623f6aa29c$var$_mergeSlotProps = $9a572b623f6aa29c$require$_interopRequireDefault((parcelRequire("3vQQW")));

});
parcelRegister("3vQQW", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $28ed43d991ccc074$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $28ed43d991ccc074$var$_clsx = $28ed43d991ccc074$require$_interopRequireDefault((parcelRequire("9QePP")));

var $28ed43d991ccc074$var$_extractEventHandlers = $28ed43d991ccc074$require$_interopRequireDefault((parcelRequire("bhYgh")));

var $28ed43d991ccc074$var$_omitEventHandlers = $28ed43d991ccc074$require$_interopRequireDefault((parcelRequire("dgDmX")));
/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $28ed43d991ccc074$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $28ed43d991ccc074$var$_clsx.default)(additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
        const mergedStyle = {
            ...additionalProps?.style,
            ...externalForwardedProps?.style,
            ...externalSlotProps?.style
        };
        const props = {
            ...additionalProps,
            ...externalForwardedProps,
            ...externalSlotProps
        };
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $28ed43d991ccc074$var$_extractEventHandlers.default)({
        ...externalForwardedProps,
        ...externalSlotProps
    });
    const componentsPropsWithoutEventHandlers = (0, $28ed43d991ccc074$var$_omitEventHandlers.default)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $28ed43d991ccc074$var$_omitEventHandlers.default)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $28ed43d991ccc074$var$_clsx.default)(internalSlotProps?.className, additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
    const mergedStyle = {
        ...internalSlotProps?.style,
        ...additionalProps?.style,
        ...externalForwardedProps?.style,
        ...externalSlotProps?.style
    };
    const props = {
        ...internalSlotProps,
        ...additionalProps,
        ...otherPropsWithoutEventHandlers,
        ...componentsPropsWithoutEventHandlers
    };
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $28ed43d991ccc074$var$_default = module.exports.default = $28ed43d991ccc074$var$mergeSlotProps;

});
parcelRegister("bhYgh", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $838006f6038ae26f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $838006f6038ae26f$var$_extractEventHandlers.default;
    }
});

var $838006f6038ae26f$var$_extractEventHandlers = $838006f6038ae26f$require$_interopRequireDefault((parcelRequire("foye3")));

});
parcelRegister("foye3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $b353a56c2b32b8fb$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $b353a56c2b32b8fb$var$_default = module.exports.default = $b353a56c2b32b8fb$var$extractEventHandlers;

});


parcelRegister("dgDmX", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9a8b4ee879070d7d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9a8b4ee879070d7d$var$_omitEventHandlers.default;
    }
});

var $9a8b4ee879070d7d$var$_omitEventHandlers = $9a8b4ee879070d7d$require$_interopRequireDefault((parcelRequire("21PNK")));

});
parcelRegister("21PNK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $17a3db7502283a72$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $17a3db7502283a72$var$_default = module.exports.default = $17a3db7502283a72$var$omitEventHandlers;

});




parcelRegister("jzekU", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e3ec68142ab190e2$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $e3ec68142ab190e2$var$_resolveComponentProps.default;
    }
});

var $e3ec68142ab190e2$var$_resolveComponentProps = $e3ec68142ab190e2$require$_interopRequireDefault((parcelRequire("cgoZX")));

});
parcelRegister("cgoZX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $8eda5ecc2288dedf$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
var $8eda5ecc2288dedf$var$_default = module.exports.default = $8eda5ecc2288dedf$var$resolveComponentProps;

});




parcelRegister("6toKj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4b68a591cb35890b$var$isLayoutSupported;
function $4b68a591cb35890b$var$isLayoutSupported() {
    return !(/jsdom|HappyDOM/.test(window.navigator.userAgent) || // TODO(v9): Remove the test environment check
    // eslint-disable-next-line mui/consistent-production-guard
    false);
}

});

parcelRegister("cJgE8", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $944699a2e7967149$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $944699a2e7967149$var$_Portal.default;
    }
});

var $944699a2e7967149$var$_Portal = $944699a2e7967149$require$_interopRequireDefault((parcelRequire("2Q995")));

});
parcelRegister("2Q995", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $2117883cc21a32b2$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $2117883cc21a32b2$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2117883cc21a32b2$var$React = $2117883cc21a32b2$require$_interopRequireWildcard((parcelRequire("acw62")));

var $2117883cc21a32b2$var$ReactDOM = $2117883cc21a32b2$require$_interopRequireWildcard((parcelRequire("1u0KT")));

var $2117883cc21a32b2$var$_propTypes = $2117883cc21a32b2$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $2117883cc21a32b2$var$_useEnhancedEffect = $2117883cc21a32b2$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $2117883cc21a32b2$var$_useForkRef = $2117883cc21a32b2$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $2117883cc21a32b2$var$_setRef = $2117883cc21a32b2$require$_interopRequireDefault((parcelRequire("dGvj8")));

var $2117883cc21a32b2$var$_getReactElementRef = $2117883cc21a32b2$require$_interopRequireDefault((parcelRequire("2B4J6")));

var $2117883cc21a32b2$var$_exactProp = $2117883cc21a32b2$require$_interopRequireDefault((parcelRequire("5S3aN")));

var $2117883cc21a32b2$var$_HTMLElementType = $2117883cc21a32b2$require$_interopRequireDefault((parcelRequire("cIfK5")));
function $2117883cc21a32b2$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://v7.mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://v7.mui.com/material-ui/api/portal/)
 */ const $2117883cc21a32b2$var$Portal = /*#__PURE__*/ $2117883cc21a32b2$var$React.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $2117883cc21a32b2$var$React.useState(null);
    const handleRef = (0, $2117883cc21a32b2$var$_useForkRef.default)(/*#__PURE__*/ $2117883cc21a32b2$var$React.isValidElement(children) ? (0, $2117883cc21a32b2$var$_getReactElementRef.default)(children) : null, forwardedRef);
    (0, $2117883cc21a32b2$var$_useEnhancedEffect.default)(()=>{
        if (!disablePortal) setMountNode($2117883cc21a32b2$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $2117883cc21a32b2$var$_useEnhancedEffect.default)(()=>{
        if (mountNode && !disablePortal) {
            (0, $2117883cc21a32b2$var$_setRef.default)(forwardedRef, mountNode);
            return ()=>{
                (0, $2117883cc21a32b2$var$_setRef.default)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $2117883cc21a32b2$var$React.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $2117883cc21a32b2$var$React.cloneElement(children, newProps);
        }
        return children;
    }
    return mountNode ? /*#__PURE__*/ $2117883cc21a32b2$var$ReactDOM.createPortal(children, mountNode) : mountNode;
});
$2117883cc21a32b2$var$Portal.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The children to render into the `container`.
   */ children: $2117883cc21a32b2$var$_propTypes.default.node,
    /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */ container: $2117883cc21a32b2$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $2117883cc21a32b2$var$_HTMLElementType.default,
        $2117883cc21a32b2$var$_propTypes.default.func
    ]),
    /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */ disablePortal: $2117883cc21a32b2$var$_propTypes.default.bool
};
// eslint-disable-next-line
$2117883cc21a32b2$var$Portal["propTypes"] = (0, $2117883cc21a32b2$var$_exactProp.default)($2117883cc21a32b2$var$Portal.propTypes);
var $2117883cc21a32b2$var$_default = module.exports.default = $2117883cc21a32b2$var$Portal;

});
parcelRegister("2B4J6", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $1e42b4067cc53dea$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $1e42b4067cc53dea$var$_getReactElementRef.default;
    }
});

var $1e42b4067cc53dea$var$_getReactElementRef = $1e42b4067cc53dea$require$_interopRequireDefault((parcelRequire("4UzRg")));

});
parcelRegister("4UzRg", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $3938350e2a221962$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3938350e2a221962$var$getReactElementRef;

var $3938350e2a221962$var$React = $3938350e2a221962$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * Returns the ref of a React element handling differences between React 19 and older versions.
 * It will throw runtime error if the element is not a valid React element.
 *
 * @param element React.ReactElement
 * @returns React.Ref<any> | null
 */ function $3938350e2a221962$var$getReactElementRef(element) {
    // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to children in older versions
    if (parseInt($3938350e2a221962$var$React.version, 10) >= 19) return element?.props?.ref || null;
    // @ts-expect-error element.ref is not included in the ReactElement type
    // https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/70189
    return element?.ref || null;
}

});




parcelRegister("g3XLf", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $bb1b487b0ea8f7b1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getPopperUtilityClass = $bb1b487b0ea8f7b1$var$getPopperUtilityClass;

var $bb1b487b0ea8f7b1$var$_generateUtilityClasses = $bb1b487b0ea8f7b1$require$_interopRequireDefault((parcelRequire("5nY49")));

var $bb1b487b0ea8f7b1$var$_generateUtilityClass = $bb1b487b0ea8f7b1$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $bb1b487b0ea8f7b1$var$getPopperUtilityClass(slot) {
    return (0, $bb1b487b0ea8f7b1$var$_generateUtilityClass.default)('MuiPopper', slot);
}
const $bb1b487b0ea8f7b1$var$popperClasses = (0, $bb1b487b0ea8f7b1$var$_generateUtilityClasses.default)('MuiPopper', [
    'root'
]);
var $bb1b487b0ea8f7b1$var$_default = module.exports.default = $bb1b487b0ea8f7b1$var$popperClasses;

});


parcelRegister("aAbgT", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $7b460279bb5c09c1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "css", {
    enumerable: true,
    get: function() {
        return $izOUK.css;
    }
});
module.exports.globalCss = $7b460279bb5c09c1$var$globalCss;
module.exports.internal_createExtendSxProp = $7b460279bb5c09c1$var$internal_createExtendSxProp;
Object.defineProperty(module.exports, "keyframes", {
    enumerable: true,
    get: function() {
        return $izOUK.keyframes;
    }
});
Object.defineProperty(module.exports, "styled", {
    enumerable: true,
    get: function() {
        return $7b460279bb5c09c1$var$_styled.default;
    }
});
Object.defineProperty(module.exports, "useTheme", {
    enumerable: true,
    get: function() {
        return $7b460279bb5c09c1$var$_useTheme.default;
    }
});

var $l6FST = parcelRequire("l6FST");

var $7b460279bb5c09c1$var$_useTheme = $7b460279bb5c09c1$require$_interopRequireDefault((parcelRequire("14H9o")));

var $7b460279bb5c09c1$var$_GlobalStyles = $7b460279bb5c09c1$require$_interopRequireDefault((parcelRequire("kjVW8")));

var $ayMG0 = parcelRequire("ayMG0");

var $izOUK = parcelRequire("izOUK");

var $7b460279bb5c09c1$var$_styled = $7b460279bb5c09c1$require$_interopRequireDefault((parcelRequire("d8seH")));
function $7b460279bb5c09c1$var$globalCss(styles) {
    return function GlobalStylesWrapper(props) {
        return(/*#__PURE__*/ // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
        (0, $ayMG0.jsx)($7b460279bb5c09c1$var$_GlobalStyles.default, {
            styles: typeof styles === 'function' ? (theme)=>styles({
                    theme: theme,
                    ...props
                }) : styles
        }));
    };
}
// eslint-disable-next-line @typescript-eslint/naming-convention
function $7b460279bb5c09c1$var$internal_createExtendSxProp() {
    return $l6FST.extendSxProp;
}

});
parcelRegister("kjVW8", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ecb286025e88fbf5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ecb286025e88fbf5$var$_GlobalStyles.default;
    }
});

var $ecb286025e88fbf5$var$_GlobalStyles = $ecb286025e88fbf5$require$_interopRequireDefault((parcelRequire("ldx2z")));

});
parcelRegister("ldx2z", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $03fc756f7adfd498$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $03fc756f7adfd498$var$_propTypes = $03fc756f7adfd498$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $izOUK = parcelRequire("izOUK");

var $03fc756f7adfd498$var$_defaultTheme = $03fc756f7adfd498$require$_interopRequireDefault((parcelRequire("jR9F1")));

var $03fc756f7adfd498$var$_identifier = $03fc756f7adfd498$require$_interopRequireDefault((parcelRequire("4jPsi")));

var $ayMG0 = parcelRequire("ayMG0");
function $03fc756f7adfd498$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($izOUK.GlobalStyles, {
        ...props,
        defaultTheme: $03fc756f7adfd498$var$_defaultTheme.default,
        themeId: $03fc756f7adfd498$var$_identifier.default
    });
}
$03fc756f7adfd498$var$GlobalStyles.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The styles you want to apply globally.
   */ styles: $03fc756f7adfd498$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $03fc756f7adfd498$var$_propTypes.default.array,
        $03fc756f7adfd498$var$_propTypes.default.func,
        $03fc756f7adfd498$var$_propTypes.default.number,
        $03fc756f7adfd498$var$_propTypes.default.object,
        $03fc756f7adfd498$var$_propTypes.default.string,
        $03fc756f7adfd498$var$_propTypes.default.bool
    ])
};
var $03fc756f7adfd498$var$_default = module.exports.default = $03fc756f7adfd498$var$GlobalStyles;

});



parcelRegister("hL1nr", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $ced7e4e89ca5cfee$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ced7e4e89ca5cfee$var$_DefaultPropsProvider.default;
    }
});
Object.defineProperty(module.exports, "useDefaultProps", {
    enumerable: true,
    get: function() {
        return $ced7e4e89ca5cfee$var$_DefaultPropsProvider.useDefaultProps;
    }
});

var $ced7e4e89ca5cfee$var$_DefaultPropsProvider = $ced7e4e89ca5cfee$require$_interopRequireWildcard((parcelRequire("1iOpW")));

});
parcelRegister("1iOpW", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $0f2e94b8fca67639$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $0f2e94b8fca67639$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.useDefaultProps = $0f2e94b8fca67639$var$useDefaultProps;

var $0f2e94b8fca67639$var$React = $0f2e94b8fca67639$require$_interopRequireWildcard((parcelRequire("acw62")));

var $0f2e94b8fca67639$var$_propTypes = $0f2e94b8fca67639$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $0f2e94b8fca67639$var$_DefaultPropsProvider = $0f2e94b8fca67639$require$_interopRequireWildcard((parcelRequire("buuO7")));

var $ayMG0 = parcelRequire("ayMG0");
function $0f2e94b8fca67639$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($0f2e94b8fca67639$var$_DefaultPropsProvider.default, {
        ...props
    });
}
$0f2e94b8fca67639$var$DefaultPropsProvider.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * @ignore
   */ children: $0f2e94b8fca67639$var$_propTypes.default.node,
    /**
   * @ignore
   */ value: $0f2e94b8fca67639$var$_propTypes.default.object.isRequired
};
var $0f2e94b8fca67639$var$_default = module.exports.default = $0f2e94b8fca67639$var$DefaultPropsProvider;
function $0f2e94b8fca67639$var$useDefaultProps(params) {
    return (0, $0f2e94b8fca67639$var$_DefaultPropsProvider.useDefaultProps)(params);
}

});




parcelRegister("1hfjF", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $0ee342703d01369e$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $0ee342703d01369e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $0ee342703d01369e$var$_exportNames = {
    listSubheaderClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $0ee342703d01369e$var$_ListSubheader.default;
    }
});
Object.defineProperty(module.exports, "listSubheaderClasses", {
    enumerable: true,
    get: function() {
        return $0ee342703d01369e$var$_listSubheaderClasses.default;
    }
});

var $0ee342703d01369e$var$_ListSubheader = $0ee342703d01369e$require$_interopRequireDefault((parcelRequire("7djgP")));

var $0ee342703d01369e$var$_listSubheaderClasses = $0ee342703d01369e$require$_interopRequireWildcard((parcelRequire("ixwSf")));
Object.keys($0ee342703d01369e$var$_listSubheaderClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($0ee342703d01369e$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $0ee342703d01369e$var$_listSubheaderClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $0ee342703d01369e$var$_listSubheaderClasses[key];
        }
    });
});

});
parcelRegister("7djgP", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $5408b2039b9d572c$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $5408b2039b9d572c$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5408b2039b9d572c$var$React = $5408b2039b9d572c$require$_interopRequireWildcard((parcelRequire("acw62")));

var $5408b2039b9d572c$var$_propTypes = $5408b2039b9d572c$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $5408b2039b9d572c$var$_clsx = $5408b2039b9d572c$require$_interopRequireDefault((parcelRequire("9QePP")));

var $5408b2039b9d572c$var$_composeClasses = $5408b2039b9d572c$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $5408b2039b9d572c$var$_memoTheme = $5408b2039b9d572c$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $5408b2039b9d572c$var$_capitalize = $5408b2039b9d572c$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $ixwSf = parcelRequire("ixwSf");

var $ayMG0 = parcelRequire("ayMG0");
const $5408b2039b9d572c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disableGutters: disableGutters, inset: inset, disableSticky: disableSticky } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'default' && `color${(0, $5408b2039b9d572c$var$_capitalize.default)(color)}`,
            !disableGutters && 'gutters',
            inset && 'inset',
            !disableSticky && 'sticky'
        ]
    };
    return (0, $5408b2039b9d572c$var$_composeClasses.default)(slots, $ixwSf.getListSubheaderUtilityClass, classes);
};
const $5408b2039b9d572c$var$ListSubheaderRoot = (0, $aAbgT.styled)('li', {
    name: 'MuiListSubheader',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $5408b2039b9d572c$var$_capitalize.default)(ownerState.color)}`],
            !ownerState.disableGutters && styles.gutters,
            ownerState.inset && styles.inset,
            !ownerState.disableSticky && styles.sticky
        ];
    }
})((0, $5408b2039b9d572c$var$_memoTheme.default)(({ theme: theme })=>({
        boxSizing: 'border-box',
        lineHeight: '48px',
        listStyle: 'none',
        color: (theme.vars || theme).palette.text.secondary,
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(14),
        variants: [
            {
                props: {
                    color: 'primary'
                },
                style: {
                    color: (theme.vars || theme).palette.primary.main
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.inset,
                style: {
                    paddingLeft: 72
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableSticky,
                style: {
                    position: 'sticky',
                    top: 0,
                    zIndex: 1,
                    backgroundColor: (theme.vars || theme).palette.background.paper
                }
            }
        ]
    })));
const $5408b2039b9d572c$var$ListSubheader = /*#__PURE__*/ $5408b2039b9d572c$var$React.forwardRef(function ListSubheader(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiListSubheader'
    });
    const { className: className, color: color = 'default', component: component = 'li', disableGutters: disableGutters = false, disableSticky: disableSticky = false, inset: inset = false, ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disableGutters: disableGutters,
        disableSticky: disableSticky,
        inset: inset
    };
    const classes = $5408b2039b9d572c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5408b2039b9d572c$var$ListSubheaderRoot, {
        as: component,
        className: (0, $5408b2039b9d572c$var$_clsx.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
if ($5408b2039b9d572c$var$ListSubheader) $5408b2039b9d572c$var$ListSubheader.muiSkipListHighlight = true;
$5408b2039b9d572c$var$ListSubheader.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: $5408b2039b9d572c$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $5408b2039b9d572c$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $5408b2039b9d572c$var$_propTypes.default.string,
    /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * @default 'default'
   */ color: $5408b2039b9d572c$var$_propTypes.default.oneOf([
        'default',
        'inherit',
        'primary'
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $5408b2039b9d572c$var$_propTypes.default.elementType,
    /**
   * If `true`, the List Subheader will not have gutters.
   * @default false
   */ disableGutters: $5408b2039b9d572c$var$_propTypes.default.bool,
    /**
   * If `true`, the List Subheader will not stick to the top during scroll.
   * @default false
   */ disableSticky: $5408b2039b9d572c$var$_propTypes.default.bool,
    /**
   * If `true`, the List Subheader is indented.
   * @default false
   */ inset: $5408b2039b9d572c$var$_propTypes.default.bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $5408b2039b9d572c$var$_propTypes.default.oneOfType([
        $5408b2039b9d572c$var$_propTypes.default.arrayOf($5408b2039b9d572c$var$_propTypes.default.oneOfType([
            $5408b2039b9d572c$var$_propTypes.default.func,
            $5408b2039b9d572c$var$_propTypes.default.object,
            $5408b2039b9d572c$var$_propTypes.default.bool
        ])),
        $5408b2039b9d572c$var$_propTypes.default.func,
        $5408b2039b9d572c$var$_propTypes.default.object
    ])
};
var $5408b2039b9d572c$var$_default = module.exports.default = $5408b2039b9d572c$var$ListSubheader;

});
parcelRegister("aeD7H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $izOUK = parcelRequire("izOUK");
const $77398f38c6229912$var$memoTheme = $izOUK.unstable_memoTheme;
var $77398f38c6229912$var$_default = module.exports.default = $77398f38c6229912$var$memoTheme;

});

parcelRegister("jTnBY", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e7b578196486f177$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e7b578196486f177$var$_capitalize = $e7b578196486f177$require$_interopRequireDefault((parcelRequire("4O6za")));
var $e7b578196486f177$var$_default = module.exports.default = $e7b578196486f177$var$_capitalize.default;

});

parcelRegister("ixwSf", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d7f4cf29715b69dd$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getListSubheaderUtilityClass = $d7f4cf29715b69dd$var$getListSubheaderUtilityClass;

var $d7f4cf29715b69dd$var$_generateUtilityClasses = $d7f4cf29715b69dd$require$_interopRequireDefault((parcelRequire("5nY49")));

var $d7f4cf29715b69dd$var$_generateUtilityClass = $d7f4cf29715b69dd$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $d7f4cf29715b69dd$var$getListSubheaderUtilityClass(slot) {
    return (0, $d7f4cf29715b69dd$var$_generateUtilityClass.default)('MuiListSubheader', slot);
}
const $d7f4cf29715b69dd$var$listSubheaderClasses = (0, $d7f4cf29715b69dd$var$_generateUtilityClasses.default)('MuiListSubheader', [
    'root',
    'colorPrimary',
    'colorInherit',
    'gutters',
    'inset',
    'sticky'
]);
var $d7f4cf29715b69dd$var$_default = module.exports.default = $d7f4cf29715b69dd$var$listSubheaderClasses;

});



parcelRegister("juRJQ", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $e31a80f86c785b2c$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $e31a80f86c785b2c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $e31a80f86c785b2c$var$_exportNames = {
    paperClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $e31a80f86c785b2c$var$_Paper.default;
    }
});
Object.defineProperty(module.exports, "paperClasses", {
    enumerable: true,
    get: function() {
        return $e31a80f86c785b2c$var$_paperClasses.default;
    }
});

var $e31a80f86c785b2c$var$_Paper = $e31a80f86c785b2c$require$_interopRequireDefault((parcelRequire("7Frhn")));

var $e31a80f86c785b2c$var$_paperClasses = $e31a80f86c785b2c$require$_interopRequireWildcard((parcelRequire("6LfkK")));
Object.keys($e31a80f86c785b2c$var$_paperClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($e31a80f86c785b2c$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $e31a80f86c785b2c$var$_paperClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $e31a80f86c785b2c$var$_paperClasses[key];
        }
    });
});

});
parcelRegister("7Frhn", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $595185d0d7275c3b$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $595185d0d7275c3b$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $595185d0d7275c3b$var$React = $595185d0d7275c3b$require$_interopRequireWildcard((parcelRequire("acw62")));

var $595185d0d7275c3b$var$_propTypes = $595185d0d7275c3b$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $595185d0d7275c3b$var$_clsx = $595185d0d7275c3b$require$_interopRequireDefault((parcelRequire("9QePP")));

var $595185d0d7275c3b$var$_integerPropType = $595185d0d7275c3b$require$_interopRequireDefault((parcelRequire("cxaSP")));

var $595185d0d7275c3b$var$_chainPropTypes = $595185d0d7275c3b$require$_interopRequireDefault((parcelRequire("abVWF")));

var $595185d0d7275c3b$var$_composeClasses = $595185d0d7275c3b$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $h61zw = parcelRequire("h61zw");

var $aAbgT = parcelRequire("aAbgT");

var $595185d0d7275c3b$var$_memoTheme = $595185d0d7275c3b$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $595185d0d7275c3b$var$_getOverlayAlpha = $595185d0d7275c3b$require$_interopRequireDefault((parcelRequire("35vyj")));

var $6LfkK = parcelRequire("6LfkK");

var $ayMG0 = parcelRequire("ayMG0");
const $595185d0d7275c3b$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, $595185d0d7275c3b$var$_composeClasses.default)(slots, $6LfkK.getPaperUtilityClass, classes);
};
const $595185d0d7275c3b$var$PaperRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})((0, $595185d0d7275c3b$var$_memoTheme.default)(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow'),
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.square,
                style: {
                    borderRadius: theme.shape.borderRadius
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    border: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: {
                    variant: 'elevation'
                },
                style: {
                    boxShadow: 'var(--Paper-shadow)',
                    backgroundImage: 'var(--Paper-overlay)'
                }
            }
        ]
    })));
const $595185d0d7275c3b$var$Paper = /*#__PURE__*/ $595185d0d7275c3b$var$React.forwardRef(function Paper(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiPaper'
    });
    const theme = (0, $aAbgT.useTheme)();
    const { className: className, component: component = 'div', elevation: elevation = 1, square: square = false, variant: variant = 'elevation', ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    };
    const classes = $595185d0d7275c3b$var$useUtilityClasses(ownerState);
    if (theme.shadows[elevation] === undefined) console.error([
        `MUI: The elevation provided <Paper elevation={${elevation}}> is not available in the theme.`,
        `Please make sure that \`theme.shadows[${elevation}]\` is defined.`
    ].join('\n'));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($595185d0d7275c3b$var$PaperRoot, {
        as: component,
        ownerState: ownerState,
        className: (0, $595185d0d7275c3b$var$_clsx.default)(classes.root, className),
        ref: ref,
        ...other,
        style: {
            ...variant === 'elevation' && {
                '--Paper-shadow': (theme.vars || theme).shadows[elevation],
                ...theme.vars && {
                    '--Paper-overlay': theme.vars.overlays?.[elevation]
                },
                ...!theme.vars && theme.palette.mode === 'dark' && {
                    '--Paper-overlay': `linear-gradient(${(0, $h61zw.alpha)('#fff', (0, $595185d0d7275c3b$var$_getOverlayAlpha.default)(elevation))}, ${(0, $h61zw.alpha)('#fff', (0, $595185d0d7275c3b$var$_getOverlayAlpha.default)(elevation))})`
                }
            },
            ...other.style
        }
    });
});
$595185d0d7275c3b$var$Paper.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: $595185d0d7275c3b$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $595185d0d7275c3b$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $595185d0d7275c3b$var$_propTypes.default.string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $595185d0d7275c3b$var$_propTypes.default.elementType,
    /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */ elevation: (0, $595185d0d7275c3b$var$_chainPropTypes.default)($595185d0d7275c3b$var$_integerPropType.default, (props)=>{
        const { elevation: elevation, variant: variant } = props;
        if (elevation > 0 && variant === 'outlined') return new Error(`MUI: Combining \`elevation={${elevation}}\` with \`variant="${variant}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`);
        return null;
    }),
    /**
   * If `true`, rounded corners are disabled.
   * @default false
   */ square: $595185d0d7275c3b$var$_propTypes.default.bool,
    /**
   * @ignore
   */ style: $595185d0d7275c3b$var$_propTypes.default.object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $595185d0d7275c3b$var$_propTypes.default.oneOfType([
        $595185d0d7275c3b$var$_propTypes.default.arrayOf($595185d0d7275c3b$var$_propTypes.default.oneOfType([
            $595185d0d7275c3b$var$_propTypes.default.func,
            $595185d0d7275c3b$var$_propTypes.default.object,
            $595185d0d7275c3b$var$_propTypes.default.bool
        ])),
        $595185d0d7275c3b$var$_propTypes.default.func,
        $595185d0d7275c3b$var$_propTypes.default.object
    ]),
    /**
   * The variant to use.
   * @default 'elevation'
   */ variant: $595185d0d7275c3b$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $595185d0d7275c3b$var$_propTypes.default.oneOf([
            'elevation',
            'outlined'
        ]),
        $595185d0d7275c3b$var$_propTypes.default.string
    ])
};
var $595185d0d7275c3b$var$_default = module.exports.default = $595185d0d7275c3b$var$Paper;

});
parcelRegister("6LfkK", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $4ec306d48089c2c9$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getPaperUtilityClass = $4ec306d48089c2c9$var$getPaperUtilityClass;

var $4ec306d48089c2c9$var$_generateUtilityClasses = $4ec306d48089c2c9$require$_interopRequireDefault((parcelRequire("5nY49")));

var $4ec306d48089c2c9$var$_generateUtilityClass = $4ec306d48089c2c9$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $4ec306d48089c2c9$var$getPaperUtilityClass(slot) {
    return (0, $4ec306d48089c2c9$var$_generateUtilityClass.default)('MuiPaper', slot);
}
const $4ec306d48089c2c9$var$paperClasses = (0, $4ec306d48089c2c9$var$_generateUtilityClasses.default)('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
var $4ec306d48089c2c9$var$_default = module.exports.default = $4ec306d48089c2c9$var$paperClasses;

});



parcelRegister("825Zh", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $5d932794c82c2fcf$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $5d932794c82c2fcf$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $5d932794c82c2fcf$var$_exportNames = {
    iconButtonClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $5d932794c82c2fcf$var$_IconButton.default;
    }
});
Object.defineProperty(module.exports, "iconButtonClasses", {
    enumerable: true,
    get: function() {
        return $5d932794c82c2fcf$var$_iconButtonClasses.default;
    }
});

var $5d932794c82c2fcf$var$_IconButton = $5d932794c82c2fcf$require$_interopRequireDefault((parcelRequire("9Lykx")));

var $5d932794c82c2fcf$var$_iconButtonClasses = $5d932794c82c2fcf$require$_interopRequireWildcard((parcelRequire("jzUw6")));
Object.keys($5d932794c82c2fcf$var$_iconButtonClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($5d932794c82c2fcf$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $5d932794c82c2fcf$var$_iconButtonClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5d932794c82c2fcf$var$_iconButtonClasses[key];
        }
    });
});

});
parcelRegister("9Lykx", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $71c322247f7fbf93$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $71c322247f7fbf93$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $71c322247f7fbf93$var$React = $71c322247f7fbf93$require$_interopRequireWildcard((parcelRequire("acw62")));

var $71c322247f7fbf93$var$_propTypes = $71c322247f7fbf93$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $71c322247f7fbf93$var$_clsx = $71c322247f7fbf93$require$_interopRequireDefault((parcelRequire("9QePP")));

var $71c322247f7fbf93$var$_chainPropTypes = $71c322247f7fbf93$require$_interopRequireDefault((parcelRequire("abVWF")));

var $71c322247f7fbf93$var$_composeClasses = $71c322247f7fbf93$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $hGPki = parcelRequire("hGPki");

var $aAbgT = parcelRequire("aAbgT");

var $71c322247f7fbf93$var$_memoTheme = $71c322247f7fbf93$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $71c322247f7fbf93$var$_createSimplePaletteValueFilter = $71c322247f7fbf93$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $hL1nr = parcelRequire("hL1nr");

var $71c322247f7fbf93$var$_ButtonBase = $71c322247f7fbf93$require$_interopRequireDefault((parcelRequire("hhs3r")));

var $71c322247f7fbf93$var$_CircularProgress = $71c322247f7fbf93$require$_interopRequireDefault((parcelRequire("1sBf1")));

var $71c322247f7fbf93$var$_capitalize = $71c322247f7fbf93$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $71c322247f7fbf93$var$_iconButtonClasses = $71c322247f7fbf93$require$_interopRequireWildcard((parcelRequire("jzUw6")));

var $ayMG0 = parcelRequire("ayMG0");
const $71c322247f7fbf93$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size, loading: loading } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            disabled && 'disabled',
            color !== 'default' && `color${(0, $71c322247f7fbf93$var$_capitalize.default)(color)}`,
            edge && `edge${(0, $71c322247f7fbf93$var$_capitalize.default)(edge)}`,
            `size${(0, $71c322247f7fbf93$var$_capitalize.default)(size)}`
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    return (0, $71c322247f7fbf93$var$_composeClasses.default)(slots, $71c322247f7fbf93$var$_iconButtonClasses.getIconButtonUtilityClass, classes);
};
const $71c322247f7fbf93$var$IconButtonRoot = (0, $aAbgT.styled)($71c322247f7fbf93$var$_ButtonBase.default, {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.loading && styles.loading,
            ownerState.color !== 'default' && styles[`color${(0, $71c322247f7fbf93$var$_capitalize.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $71c322247f7fbf93$var$_capitalize.default)(ownerState.edge)}`],
            styles[`size${(0, $71c322247f7fbf93$var$_capitalize.default)(ownerState.size)}`]
        ];
    }
})((0, $71c322247f7fbf93$var$_memoTheme.default)(({ theme: theme })=>({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: (props)=>!props.disableRipple,
                style: {
                    '--IconButton-hoverBg': theme.alpha((theme.vars || theme).palette.action.active, (theme.vars || theme).palette.action.hoverOpacity),
                    '&:hover': {
                        backgroundColor: 'var(--IconButton-hoverBg)',
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            },
            {
                props: {
                    edge: 'start'
                },
                style: {
                    marginLeft: -12
                }
            },
            {
                props: {
                    edge: 'start',
                    size: 'small'
                },
                style: {
                    marginLeft: -3
                }
            },
            {
                props: {
                    edge: 'end'
                },
                style: {
                    marginRight: -12
                }
            },
            {
                props: {
                    edge: 'end',
                    size: 'small'
                },
                style: {
                    marginRight: -3
                }
            }
        ]
    })), (0, $71c322247f7fbf93$var$_memoTheme.default)(({ theme: theme })=>({
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            },
            ...Object.entries(theme.palette).filter((0, $71c322247f7fbf93$var$_createSimplePaletteValueFilter.default)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $71c322247f7fbf93$var$_createSimplePaletteValueFilter.default)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--IconButton-hoverBg': theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity)
                    }
                })),
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: 5,
                    fontSize: theme.typography.pxToRem(18)
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    padding: 12,
                    fontSize: theme.typography.pxToRem(28)
                }
            }
        ],
        [`&.${$71c322247f7fbf93$var$_iconButtonClasses.default.disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        },
        [`&.${$71c322247f7fbf93$var$_iconButtonClasses.default.loading}`]: {
            color: 'transparent'
        }
    })));
const $71c322247f7fbf93$var$IconButtonLoadingIndicator = (0, $aAbgT.styled)('span', {
    name: 'MuiIconButton',
    slot: 'LoadingIndicator'
})(({ theme: theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        color: (theme.vars || theme).palette.action.disabled,
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            }
        ]
    }));
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $71c322247f7fbf93$var$IconButton = /*#__PURE__*/ $71c322247f7fbf93$var$React.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge: edge = false, children: children, className: className, color: color = 'default', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = 'medium', id: idProp, loading: loading = null, loadingIndicator: loadingIndicatorProp, ...other } = props;
    const loadingId = (0, $hGPki.unstable_useId)(idProp);
    const loadingIndicator = loadingIndicatorProp ?? /*#__PURE__*/ (0, $ayMG0.jsx)($71c322247f7fbf93$var$_CircularProgress.default, {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = {
        ...props,
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        loading: loading,
        loadingIndicator: loadingIndicator,
        size: size
    };
    const classes = $71c322247f7fbf93$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($71c322247f7fbf93$var$IconButtonRoot, {
        id: loading ? loadingId : idProp,
        className: (0, $71c322247f7fbf93$var$_clsx.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled || loading,
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: [
            typeof loading === 'boolean' && /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
            (0, $ayMG0.jsx)("span", {
                className: classes.loadingWrapper,
                style: {
                    display: 'contents'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($71c322247f7fbf93$var$IconButtonLoadingIndicator, {
                    className: classes.loadingIndicator,
                    ownerState: ownerState,
                    children: loading && loadingIndicator
                })
            }),
            children
        ]
    });
});
$71c322247f7fbf93$var$IconButton.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The icon to display.
   */ children: (0, $71c322247f7fbf93$var$_chainPropTypes.default)($71c322247f7fbf93$var$_propTypes.default.node, (props)=>{
        const found = $71c322247f7fbf93$var$React.Children.toArray(props.children).some((child)=>/*#__PURE__*/ $71c322247f7fbf93$var$React.isValidElement(child) && child.props.onClick);
        if (found) return new Error([
            'MUI: You are providing an onClick event listener to a child of a button element.',
            'Prefer applying it to the IconButton directly.',
            'This guarantees that the whole <button> will be responsive to click events.'
        ].join('\n'));
        return null;
    }),
    /**
   * Override or extend the styles applied to the component.
   */ classes: $71c322247f7fbf93$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $71c322247f7fbf93$var$_propTypes.default.string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */ color: $71c322247f7fbf93$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $71c322247f7fbf93$var$_propTypes.default.oneOf([
            'inherit',
            'default',
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning'
        ]),
        $71c322247f7fbf93$var$_propTypes.default.string
    ]),
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: $71c322247f7fbf93$var$_propTypes.default.bool,
    /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */ disableFocusRipple: $71c322247f7fbf93$var$_propTypes.default.bool,
    /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */ disableRipple: $71c322247f7fbf93$var$_propTypes.default.bool,
    /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */ edge: $71c322247f7fbf93$var$_propTypes.default.oneOf([
        'end',
        'start',
        false
    ]),
    /**
   * @ignore
   */ id: $71c322247f7fbf93$var$_propTypes.default.string,
    /**
   * If `true`, the loading indicator is visible and the button is disabled.
   * If `true | false`, the loading wrapper is always rendered before the children to prevent [Google Translation Crash](https://github.com/mui/material-ui/issues/27853).
   * @default null
   */ loading: $71c322247f7fbf93$var$_propTypes.default.bool,
    /**
   * Element placed before the children if the button is in loading state.
   * The node should contain an element with `role="progressbar"` with an accessible name.
   * By default, it renders a `CircularProgress` that is labeled by the button itself.
   * @default <CircularProgress color="inherit" size={16} />
   */ loadingIndicator: $71c322247f7fbf93$var$_propTypes.default.node,
    /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */ size: $71c322247f7fbf93$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $71c322247f7fbf93$var$_propTypes.default.oneOf([
            'small',
            'medium',
            'large'
        ]),
        $71c322247f7fbf93$var$_propTypes.default.string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $71c322247f7fbf93$var$_propTypes.default.oneOfType([
        $71c322247f7fbf93$var$_propTypes.default.arrayOf($71c322247f7fbf93$var$_propTypes.default.oneOfType([
            $71c322247f7fbf93$var$_propTypes.default.func,
            $71c322247f7fbf93$var$_propTypes.default.object,
            $71c322247f7fbf93$var$_propTypes.default.bool
        ])),
        $71c322247f7fbf93$var$_propTypes.default.func,
        $71c322247f7fbf93$var$_propTypes.default.object
    ])
};
var $71c322247f7fbf93$var$_default = module.exports.default = $71c322247f7fbf93$var$IconButton;

});
parcelRegister("hGPki", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $ce0e2c401cd11493$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "capitalize", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_capitalize.default;
    }
});
Object.defineProperty(module.exports, "createChainedFunction", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_createChainedFunction.default;
    }
});
Object.defineProperty(module.exports, "createSvgIcon", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_createSvgIcon.default;
    }
});
Object.defineProperty(module.exports, "debounce", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_debounce.default;
    }
});
Object.defineProperty(module.exports, "deprecatedPropType", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_deprecatedPropType.default;
    }
});
Object.defineProperty(module.exports, "isMuiElement", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_isMuiElement.default;
    }
});
Object.defineProperty(module.exports, "mergeSlotProps", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_mergeSlotProps.default;
    }
});
Object.defineProperty(module.exports, "ownerDocument", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_ownerDocument.default;
    }
});
Object.defineProperty(module.exports, "ownerWindow", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_ownerWindow.default;
    }
});
Object.defineProperty(module.exports, "requirePropFactory", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_requirePropFactory.default;
    }
});
Object.defineProperty(module.exports, "setRef", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_setRef.default;
    }
});
module.exports.unstable_ClassNameGenerator = void 0;
Object.defineProperty(module.exports, "unstable_memoTheme", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_memoTheme.default;
    }
});
Object.defineProperty(module.exports, "unstable_useEnhancedEffect", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_useEnhancedEffect.default;
    }
});
Object.defineProperty(module.exports, "unstable_useId", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_useId.default;
    }
});
Object.defineProperty(module.exports, "unsupportedProp", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_unsupportedProp.default;
    }
});
Object.defineProperty(module.exports, "useControlled", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_useControlled.default;
    }
});
Object.defineProperty(module.exports, "useEventCallback", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_useEventCallback.default;
    }
});
Object.defineProperty(module.exports, "useForkRef", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_useForkRef.default;
    }
});

var $ce0e2c401cd11493$var$_ClassNameGenerator = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("aYaRV")));

var $ce0e2c401cd11493$var$_capitalize = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $ce0e2c401cd11493$var$_createChainedFunction = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("5gbhl")));

var $ce0e2c401cd11493$var$_createSvgIcon = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ce0e2c401cd11493$var$_debounce = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("1iGrQ")));

var $ce0e2c401cd11493$var$_deprecatedPropType = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("gIZJw")));

var $ce0e2c401cd11493$var$_isMuiElement = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("cpXNi")));

var $ce0e2c401cd11493$var$_memoTheme = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $ce0e2c401cd11493$var$_ownerDocument = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("gzyUk")));

var $ce0e2c401cd11493$var$_ownerWindow = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("9Evvr")));

var $ce0e2c401cd11493$var$_requirePropFactory = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("3VqP0")));

var $ce0e2c401cd11493$var$_setRef = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("e6E85")));

var $ce0e2c401cd11493$var$_useEnhancedEffect = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("khjmj")));

var $ce0e2c401cd11493$var$_useId = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("5A6d3")));

var $ce0e2c401cd11493$var$_unsupportedProp = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("gUzNi")));

var $ce0e2c401cd11493$var$_useControlled = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("3yddg")));

var $ce0e2c401cd11493$var$_useEventCallback = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("4o7uD")));

var $ce0e2c401cd11493$var$_useForkRef = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("9Rgf1")));

var $ce0e2c401cd11493$var$_mergeSlotProps = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("f8X1n")));
// TODO: remove this export once ClassNameGenerator is stable
// eslint-disable-next-line @typescript-eslint/naming-convention
const $ce0e2c401cd11493$var$unstable_ClassNameGenerator = module.exports.unstable_ClassNameGenerator = {
    configure: (generator)=>{
        console.warn([
            'MUI: `ClassNameGenerator` import from `@mui/material/utils` is outdated and might cause unexpected issues.',
            '',
            "You should use `import { unstable_ClassNameGenerator } from '@mui/material/className'` instead",
            '',
            'The detail of the issue: https://github.com/mui/material-ui/issues/30011#issuecomment-1024993401',
            '',
            'The updated documentation: https://mui.com/guides/classname-generator/'
        ].join('\n'));
        $ce0e2c401cd11493$var$_ClassNameGenerator.default.configure(generator);
    }
};

});
parcelRegister("5gbhl", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3d47321b9fcbcb38$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3d47321b9fcbcb38$var$_createChainedFunction = $3d47321b9fcbcb38$require$_interopRequireDefault((parcelRequire("7QInQ")));
var $3d47321b9fcbcb38$var$_default = module.exports.default = $3d47321b9fcbcb38$var$_createChainedFunction.default;

});
parcelRegister("7QInQ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5b6fd168e06dd390$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $5b6fd168e06dd390$var$_createChainedFunction.default;
    }
});

var $5b6fd168e06dd390$var$_createChainedFunction = $5b6fd168e06dd390$require$_interopRequireDefault((parcelRequire("ZfLEz")));

});
parcelRegister("ZfLEz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0b81edbcaacf3a52$var$createChainedFunction;
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $0b81edbcaacf3a52$var$createChainedFunction(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}

});



parcelRegister("bbT5Q", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $825b752ac2a74c27$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $825b752ac2a74c27$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $825b752ac2a74c27$var$createSvgIcon;

var $825b752ac2a74c27$var$React = $825b752ac2a74c27$require$_interopRequireWildcard((parcelRequire("acw62")));

var $825b752ac2a74c27$var$_SvgIcon = $825b752ac2a74c27$require$_interopRequireDefault((parcelRequire("loOwp")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * Private module reserved for @mui packages.
 */ function $825b752ac2a74c27$var$createSvgIcon(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $ayMG0.jsx)($825b752ac2a74c27$var$_SvgIcon.default, {
            "data-testid": `${displayName}Icon`,
            ref: ref,
            ...props,
            children: path
        });
    }
    // Need to set `displayName` on the inner component for React.memo.
    // React prior to 16.14 ignores `displayName` on the wrapper.
    Component.displayName = `${displayName}Icon`;
    Component.muiName = $825b752ac2a74c27$var$_SvgIcon.default.muiName;
    return /*#__PURE__*/ $825b752ac2a74c27$var$React.memo(/*#__PURE__*/ $825b752ac2a74c27$var$React.forwardRef(Component));
}

});
parcelRegister("loOwp", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $f943077249b43968$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $f943077249b43968$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $f943077249b43968$var$_exportNames = {
    svgIconClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $f943077249b43968$var$_SvgIcon.default;
    }
});
Object.defineProperty(module.exports, "svgIconClasses", {
    enumerable: true,
    get: function() {
        return $f943077249b43968$var$_svgIconClasses.default;
    }
});

var $f943077249b43968$var$_SvgIcon = $f943077249b43968$require$_interopRequireDefault((parcelRequire("3ErGR")));

var $f943077249b43968$var$_svgIconClasses = $f943077249b43968$require$_interopRequireWildcard((parcelRequire("aiIP4")));
Object.keys($f943077249b43968$var$_svgIconClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($f943077249b43968$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $f943077249b43968$var$_svgIconClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $f943077249b43968$var$_svgIconClasses[key];
        }
    });
});

});
parcelRegister("3ErGR", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $2a8a963e5702921b$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $2a8a963e5702921b$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2a8a963e5702921b$var$React = $2a8a963e5702921b$require$_interopRequireWildcard((parcelRequire("acw62")));

var $2a8a963e5702921b$var$_propTypes = $2a8a963e5702921b$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $2a8a963e5702921b$var$_clsx = $2a8a963e5702921b$require$_interopRequireDefault((parcelRequire("9QePP")));

var $2a8a963e5702921b$var$_composeClasses = $2a8a963e5702921b$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $2a8a963e5702921b$var$_capitalize = $2a8a963e5702921b$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $aAbgT = parcelRequire("aAbgT");

var $2a8a963e5702921b$var$_memoTheme = $2a8a963e5702921b$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $aiIP4 = parcelRequire("aiIP4");

var $ayMG0 = parcelRequire("ayMG0");
const $2a8a963e5702921b$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $2a8a963e5702921b$var$_capitalize.default)(color)}`,
            `fontSize${(0, $2a8a963e5702921b$var$_capitalize.default)(fontSize)}`
        ]
    };
    return (0, $2a8a963e5702921b$var$_composeClasses.default)(slots, $aiIP4.getSvgIconUtilityClass, classes);
};
const $2a8a963e5702921b$var$SvgIconRoot = (0, $aAbgT.styled)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $2a8a963e5702921b$var$_capitalize.default)(ownerState.color)}`],
            styles[`fontSize${(0, $2a8a963e5702921b$var$_capitalize.default)(ownerState.fontSize)}`]
        ];
    }
})((0, $2a8a963e5702921b$var$_memoTheme.default)(({ theme: theme })=>({
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        flexShrink: 0,
        transition: theme.transitions?.create?.('fill', {
            duration: (theme.vars ?? theme).transitions?.duration?.shorter
        }),
        variants: [
            {
                props: (props)=>!props.hasSvgAsChild,
                style: {
                    // the <svg> will define the property that has `currentColor`
                    // for example heroicons uses fill="none" and stroke="currentColor"
                    fill: 'currentColor'
                }
            },
            {
                props: {
                    fontSize: 'inherit'
                },
                style: {
                    fontSize: 'inherit'
                }
            },
            {
                props: {
                    fontSize: 'small'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(20) || '1.25rem'
                }
            },
            {
                props: {
                    fontSize: 'medium'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(24) || '1.5rem'
                }
            },
            {
                props: {
                    fontSize: 'large'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(35) || '2.1875rem'
                }
            },
            // TODO v5 deprecate color prop, v6 remove for sx
            ...Object.entries((theme.vars ?? theme).palette).filter(([, value])=>value && value.main).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars ?? theme).palette?.[color]?.main
                    }
                })),
            {
                props: {
                    color: 'action'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.active
                }
            },
            {
                props: {
                    color: 'disabled'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.disabled
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: undefined
                }
            }
        ]
    })));
const $2a8a963e5702921b$var$SvgIcon = /*#__PURE__*/ $2a8a963e5702921b$var$React.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24', ...other } = props;
    const hasSvgAsChild = /*#__PURE__*/ $2a8a963e5702921b$var$React.isValidElement(children) && children.type === 'svg';
    const ownerState = {
        ...props,
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    };
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $2a8a963e5702921b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($2a8a963e5702921b$var$SvgIconRoot, {
        as: component,
        className: (0, $2a8a963e5702921b$var$_clsx.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref,
        ...more,
        ...other,
        ...hasSvgAsChild && children.props,
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    });
});
$2a8a963e5702921b$var$SvgIcon.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Node passed into the SVG element.
   */ children: $2a8a963e5702921b$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $2a8a963e5702921b$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $2a8a963e5702921b$var$_propTypes.default.string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */ color: $2a8a963e5702921b$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $2a8a963e5702921b$var$_propTypes.default.oneOf([
            'inherit',
            'action',
            'disabled',
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning'
        ]),
        $2a8a963e5702921b$var$_propTypes.default.string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $2a8a963e5702921b$var$_propTypes.default.elementType,
    /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */ fontSize: $2a8a963e5702921b$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $2a8a963e5702921b$var$_propTypes.default.oneOf([
            'inherit',
            'large',
            'medium',
            'small'
        ]),
        $2a8a963e5702921b$var$_propTypes.default.string
    ]),
    /**
   * Applies a color attribute to the SVG element.
   */ htmlColor: $2a8a963e5702921b$var$_propTypes.default.string,
    /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */ inheritViewBox: $2a8a963e5702921b$var$_propTypes.default.bool,
    /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Reference/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */ shapeRendering: $2a8a963e5702921b$var$_propTypes.default.string,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $2a8a963e5702921b$var$_propTypes.default.oneOfType([
        $2a8a963e5702921b$var$_propTypes.default.arrayOf($2a8a963e5702921b$var$_propTypes.default.oneOfType([
            $2a8a963e5702921b$var$_propTypes.default.func,
            $2a8a963e5702921b$var$_propTypes.default.object,
            $2a8a963e5702921b$var$_propTypes.default.bool
        ])),
        $2a8a963e5702921b$var$_propTypes.default.func,
        $2a8a963e5702921b$var$_propTypes.default.object
    ]),
    /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */ titleAccess: $2a8a963e5702921b$var$_propTypes.default.string,
    /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */ viewBox: $2a8a963e5702921b$var$_propTypes.default.string
};
$2a8a963e5702921b$var$SvgIcon.muiName = 'SvgIcon';
var $2a8a963e5702921b$var$_default = module.exports.default = $2a8a963e5702921b$var$SvgIcon;

});
parcelRegister("aiIP4", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $77fe5ab326d42cdb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getSvgIconUtilityClass = $77fe5ab326d42cdb$var$getSvgIconUtilityClass;

var $77fe5ab326d42cdb$var$_generateUtilityClasses = $77fe5ab326d42cdb$require$_interopRequireDefault((parcelRequire("5nY49")));

var $77fe5ab326d42cdb$var$_generateUtilityClass = $77fe5ab326d42cdb$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $77fe5ab326d42cdb$var$getSvgIconUtilityClass(slot) {
    return (0, $77fe5ab326d42cdb$var$_generateUtilityClass.default)('MuiSvgIcon', slot);
}
const $77fe5ab326d42cdb$var$svgIconClasses = (0, $77fe5ab326d42cdb$var$_generateUtilityClasses.default)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $77fe5ab326d42cdb$var$_default = module.exports.default = $77fe5ab326d42cdb$var$svgIconClasses;

});




parcelRegister("1iGrQ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0f2866359d6621f3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0f2866359d6621f3$var$_debounce = $0f2866359d6621f3$require$_interopRequireDefault((parcelRequire("9NXOO")));
var $0f2866359d6621f3$var$_default = module.exports.default = $0f2866359d6621f3$var$_debounce.default;

});
parcelRegister("9NXOO", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $723717646d90af53$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $723717646d90af53$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $723717646d90af53$var$_debounce.default;
    }
});

var $723717646d90af53$var$_debounce = $723717646d90af53$require$_interopRequireWildcard((parcelRequire("7VOF5")));
Object.keys($723717646d90af53$var$_debounce).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($723717646d90af53$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $723717646d90af53$var$_debounce[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $723717646d90af53$var$_debounce[key];
        }
    });
});

});
parcelRegister("7VOF5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5c6527a444bb8d00$var$debounce;
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $5c6527a444bb8d00$var$debounce(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}

});



parcelRegister("gIZJw", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c2d0a44fb35b2388$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c2d0a44fb35b2388$var$_deprecatedPropType = $c2d0a44fb35b2388$require$_interopRequireDefault((parcelRequire("aDYnb")));
var $c2d0a44fb35b2388$var$_default = module.exports.default = $c2d0a44fb35b2388$var$_deprecatedPropType.default;

});
parcelRegister("aDYnb", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $7bfc60b9ae966df9$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $7bfc60b9ae966df9$var$_deprecatedPropType.default;
    }
});

var $7bfc60b9ae966df9$var$_deprecatedPropType = $7bfc60b9ae966df9$require$_interopRequireDefault((parcelRequire("6icuG")));

});
parcelRegister("6icuG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $494e1d8c1b97aa71$var$deprecatedPropType;
function $494e1d8c1b97aa71$var$deprecatedPropType(validator, reason) {
    return (props, propName, componentName, location, propFullName)=>{
        const componentNameSafe = componentName || '<<anonymous>>';
        const propFullNameSafe = propFullName || propName;
        if (typeof props[propName] !== 'undefined') return new Error(`The ${location} \`${propFullNameSafe}\` of ` + `\`${componentNameSafe}\` is deprecated. ${reason}`);
        return null;
    };
}

});



parcelRegister("cpXNi", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $90a633ad7a979daa$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $90a633ad7a979daa$var$_isMuiElement = $90a633ad7a979daa$require$_interopRequireDefault((parcelRequire("5yr9V")));
var $90a633ad7a979daa$var$_default = module.exports.default = $90a633ad7a979daa$var$_isMuiElement.default;

});

parcelRegister("gzyUk", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c10afe25107351d9$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c10afe25107351d9$var$_ownerDocument = $c10afe25107351d9$require$_interopRequireDefault((parcelRequire("43fuO")));
var $c10afe25107351d9$var$_default = module.exports.default = $c10afe25107351d9$var$_ownerDocument.default;

});

parcelRegister("9Evvr", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $707049eb9639aeac$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $707049eb9639aeac$var$_ownerWindow = $707049eb9639aeac$require$_interopRequireDefault((parcelRequire("4Rhws")));
var $707049eb9639aeac$var$_default = module.exports.default = $707049eb9639aeac$var$_ownerWindow.default;

});
parcelRegister("4Rhws", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3899b44489cdde78$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $3899b44489cdde78$var$_ownerWindow.default;
    }
});

var $3899b44489cdde78$var$_ownerWindow = $3899b44489cdde78$require$_interopRequireDefault((parcelRequire("l4FpR")));

});
parcelRegister("l4FpR", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f57a191378fb6173$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f57a191378fb6173$var$ownerWindow;

var $f57a191378fb6173$var$_ownerDocument = $f57a191378fb6173$require$_interopRequireDefault((parcelRequire("43fuO")));
function $f57a191378fb6173$var$ownerWindow(node) {
    const doc = (0, $f57a191378fb6173$var$_ownerDocument.default)(node);
    return doc.defaultView || window;
}

});



parcelRegister("3VqP0", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $2dbb80310490cb08$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2dbb80310490cb08$var$_requirePropFactory = $2dbb80310490cb08$require$_interopRequireDefault((parcelRequire("2IZ5o")));
var $2dbb80310490cb08$var$_default = module.exports.default = $2dbb80310490cb08$var$_requirePropFactory.default;

});
parcelRegister("2IZ5o", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $1fbf133d7c4f4f16$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $1fbf133d7c4f4f16$var$_requirePropFactory.default;
    }
});

var $1fbf133d7c4f4f16$var$_requirePropFactory = $1fbf133d7c4f4f16$require$_interopRequireDefault((parcelRequire("iJohf")));

});
parcelRegister("iJohf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $da2f42eafa577c28$var$requirePropFactory;
function $da2f42eafa577c28$var$requirePropFactory(componentNameInError, Component) {
    // eslint-disable-next-line react/forbid-foreign-prop-types
    const prevPropTypes = Component ? {
        ...Component.propTypes
    } : null;
    const requireProp = (requiredProp)=>(props, propName, componentName, location, propFullName, ...args)=>{
            const propFullNameSafe = propFullName || propName;
            const defaultTypeChecker = prevPropTypes?.[propFullNameSafe];
            if (defaultTypeChecker) {
                const typeCheckerResult = defaultTypeChecker(props, propName, componentName, location, propFullName, ...args);
                if (typeCheckerResult) return typeCheckerResult;
            }
            if (typeof props[propName] !== 'undefined' && !props[requiredProp]) return new Error(`The prop \`${propFullNameSafe}\` of ` + `\`${componentNameInError}\` can only be used together with the \`${requiredProp}\` prop.`);
            return null;
        };
    return requireProp;
}

});



parcelRegister("e6E85", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a450c11ad3ab84fa$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a450c11ad3ab84fa$var$_setRef = $a450c11ad3ab84fa$require$_interopRequireDefault((parcelRequire("dGvj8")));
var $a450c11ad3ab84fa$var$_default = module.exports.default = $a450c11ad3ab84fa$var$_setRef.default;

});

parcelRegister("khjmj", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $ec346974df496fc5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ec346974df496fc5$var$_useEnhancedEffect = $ec346974df496fc5$require$_interopRequireDefault((parcelRequire("jdWO4")));
var $ec346974df496fc5$var$_default = module.exports.default = $ec346974df496fc5$var$_useEnhancedEffect.default;

});

parcelRegister("5A6d3", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $4105219ee6538ed1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4105219ee6538ed1$var$_useId = $4105219ee6538ed1$require$_interopRequireDefault((parcelRequire("hwliF")));
var $4105219ee6538ed1$var$_default = module.exports.default = $4105219ee6538ed1$var$_useId.default;

});

parcelRegister("gUzNi", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c4fda44a4aac44a5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c4fda44a4aac44a5$var$_unsupportedProp = $c4fda44a4aac44a5$require$_interopRequireDefault((parcelRequire("kf98i")));
var $c4fda44a4aac44a5$var$_default = module.exports.default = $c4fda44a4aac44a5$var$_unsupportedProp.default;

});
parcelRegister("kf98i", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ebcc4af23e3dfede$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ebcc4af23e3dfede$var$_unsupportedProp.default;
    }
});

var $ebcc4af23e3dfede$var$_unsupportedProp = $ebcc4af23e3dfede$require$_interopRequireDefault((parcelRequire("hgZZv")));

});
parcelRegister("hgZZv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c9340465e04eedf1$var$unsupportedProp;
function $c9340465e04eedf1$var$unsupportedProp(props, propName, componentName, location, propFullName) {
    const propFullNameSafe = propFullName || propName;
    if (typeof props[propName] !== 'undefined') return new Error(`The prop \`${propFullNameSafe}\` is not supported. Please remove it.`);
    return null;
}

});



parcelRegister("3yddg", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $295ecbe78b5bad73$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $295ecbe78b5bad73$var$_useControlled = $295ecbe78b5bad73$require$_interopRequireDefault((parcelRequire("iSpB2")));
var $295ecbe78b5bad73$var$_default = module.exports.default = $295ecbe78b5bad73$var$_useControlled.default;

});

parcelRegister("4o7uD", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $331f3746e6346411$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $331f3746e6346411$var$_useEventCallback = $331f3746e6346411$require$_interopRequireDefault((parcelRequire("6Lbjo")));
var $331f3746e6346411$var$_default = module.exports.default = $331f3746e6346411$var$_useEventCallback.default;

});

parcelRegister("9Rgf1", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $72d5a979b2ad8bc9$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $72d5a979b2ad8bc9$var$_useForkRef = $72d5a979b2ad8bc9$require$_interopRequireDefault((parcelRequire("e4pKA")));
var $72d5a979b2ad8bc9$var$_default = module.exports.default = $72d5a979b2ad8bc9$var$_useForkRef.default;

});

parcelRegister("f8X1n", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $b06562c0a3ca8f02$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b06562c0a3ca8f02$var$mergeSlotProps;

var $b06562c0a3ca8f02$var$_clsx = $b06562c0a3ca8f02$require$_interopRequireDefault((parcelRequire("9QePP")));
// Brought from [Base UI](https://github.com/mui/base-ui/blob/master/packages/react/src/merge-props/mergeProps.ts#L119)
// Use it directly from Base UI once it's a package dependency.
function $b06562c0a3ca8f02$var$isEventHandler(key, value) {
    // This approach is more efficient than using a regex.
    const thirdCharCode = key.charCodeAt(2);
    return key[0] === 'o' && key[1] === 'n' && thirdCharCode >= 65 /* A */  && thirdCharCode <= 90 /* Z */  && typeof value === 'function';
}
function $b06562c0a3ca8f02$var$mergeSlotProps(externalSlotProps, defaultSlotProps) {
    if (!externalSlotProps) return defaultSlotProps;
    function extractHandlers(externalSlotPropsValue, defaultSlotPropsValue) {
        const handlers = {};
        Object.keys(defaultSlotPropsValue).forEach((key)=>{
            if ($b06562c0a3ca8f02$var$isEventHandler(key, defaultSlotPropsValue[key]) && typeof externalSlotPropsValue[key] === 'function') // only compose the handlers if both default and external slot props match the event handler
            handlers[key] = (...args)=>{
                externalSlotPropsValue[key](...args);
                defaultSlotPropsValue[key](...args);
            };
        });
        return handlers;
    }
    if (typeof externalSlotProps === 'function' || typeof defaultSlotProps === 'function') return (ownerState)=>{
        const defaultSlotPropsValue = typeof defaultSlotProps === 'function' ? defaultSlotProps(ownerState) : defaultSlotProps;
        const externalSlotPropsValue = typeof externalSlotProps === 'function' ? externalSlotProps({
            ...ownerState,
            ...defaultSlotPropsValue
        }) : externalSlotProps;
        const className = (0, $b06562c0a3ca8f02$var$_clsx.default)(ownerState?.className, defaultSlotPropsValue?.className, externalSlotPropsValue?.className);
        const handlers = extractHandlers(externalSlotPropsValue, defaultSlotPropsValue);
        return {
            ...defaultSlotPropsValue,
            ...externalSlotPropsValue,
            ...handlers,
            ...!!className && {
                className: className
            },
            ...defaultSlotPropsValue?.style && externalSlotPropsValue?.style && {
                style: {
                    ...defaultSlotPropsValue.style,
                    ...externalSlotPropsValue.style
                }
            },
            ...defaultSlotPropsValue?.sx && externalSlotPropsValue?.sx && {
                sx: [
                    ...Array.isArray(defaultSlotPropsValue.sx) ? defaultSlotPropsValue.sx : [
                        defaultSlotPropsValue.sx
                    ],
                    ...Array.isArray(externalSlotPropsValue.sx) ? externalSlotPropsValue.sx : [
                        externalSlotPropsValue.sx
                    ]
                ]
            }
        };
    };
    const typedDefaultSlotProps = defaultSlotProps;
    const handlers = extractHandlers(externalSlotProps, typedDefaultSlotProps);
    const className = (0, $b06562c0a3ca8f02$var$_clsx.default)(typedDefaultSlotProps?.className, externalSlotProps?.className);
    return {
        ...defaultSlotProps,
        ...externalSlotProps,
        ...handlers,
        ...!!className && {
            className: className
        },
        ...typedDefaultSlotProps?.style && externalSlotProps?.style && {
            style: {
                ...typedDefaultSlotProps.style,
                ...externalSlotProps.style
            }
        },
        ...typedDefaultSlotProps?.sx && externalSlotProps?.sx && {
            sx: [
                ...Array.isArray(typedDefaultSlotProps.sx) ? typedDefaultSlotProps.sx : [
                    typedDefaultSlotProps.sx
                ],
                ...Array.isArray(externalSlotProps.sx) ? externalSlotProps.sx : [
                    externalSlotProps.sx
                ]
            ]
        }
    };
}

});


parcelRegister("1Anyj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $127b6c47a683862d$var$createSimplePaletteValueFilter;
/**
 * Type guard to check if the object has a "main" property of type string.
 *
 * @param obj - the object to check
 * @returns boolean
 */ function $127b6c47a683862d$var$hasCorrectMainProperty(obj) {
    return typeof obj.main === 'string';
}
/**
 * Checks if the object conforms to the SimplePaletteColorOptions type.
 * The minimum requirement is that the object has a "main" property of type string, this is always checked.
 * Optionally, you can pass additional properties to check.
 *
 * @param obj - The object to check
 * @param additionalPropertiesToCheck - Array containing "light", "dark", and/or "contrastText"
 * @returns boolean
 */ function $127b6c47a683862d$var$checkSimplePaletteColorValues(obj, additionalPropertiesToCheck = []) {
    if (!$127b6c47a683862d$var$hasCorrectMainProperty(obj)) return false;
    for (const value of additionalPropertiesToCheck){
        if (!obj.hasOwnProperty(value) || typeof obj[value] !== 'string') return false;
    }
    return true;
}
/**
 * Creates a filter function used to filter simple palette color options.
 * The minimum requirement is that the object has a "main" property of type string, this is always checked.
 * Optionally, you can pass additional properties to check.
 *
 * @param additionalPropertiesToCheck - Array containing "light", "dark", and/or "contrastText"
 * @returns ([, value]: [any, PaletteColorOptions]) => boolean
 */ function $127b6c47a683862d$var$createSimplePaletteValueFilter(additionalPropertiesToCheck = []) {
    return ([, value])=>value && $127b6c47a683862d$var$checkSimplePaletteColorValues(value, additionalPropertiesToCheck);
}

});

parcelRegister("hhs3r", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $c949c943dfbcd61d$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $c949c943dfbcd61d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $c949c943dfbcd61d$var$_exportNames = {
    buttonBaseClasses: true,
    touchRippleClasses: true
};
Object.defineProperty(module.exports, "buttonBaseClasses", {
    enumerable: true,
    get: function() {
        return $c949c943dfbcd61d$var$_buttonBaseClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $c949c943dfbcd61d$var$_ButtonBase.default;
    }
});
Object.defineProperty(module.exports, "touchRippleClasses", {
    enumerable: true,
    get: function() {
        return $c949c943dfbcd61d$var$_touchRippleClasses.default;
    }
});

var $c949c943dfbcd61d$var$_ButtonBase = $c949c943dfbcd61d$require$_interopRequireDefault((parcelRequire("6n0Ko")));

var $c949c943dfbcd61d$var$_buttonBaseClasses = $c949c943dfbcd61d$require$_interopRequireWildcard((parcelRequire("5JO1P")));
Object.keys($c949c943dfbcd61d$var$_buttonBaseClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($c949c943dfbcd61d$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $c949c943dfbcd61d$var$_buttonBaseClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $c949c943dfbcd61d$var$_buttonBaseClasses[key];
        }
    });
});

var $c949c943dfbcd61d$var$_touchRippleClasses = $c949c943dfbcd61d$require$_interopRequireWildcard((parcelRequire("a4Mf7")));
Object.keys($c949c943dfbcd61d$var$_touchRippleClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($c949c943dfbcd61d$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $c949c943dfbcd61d$var$_touchRippleClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $c949c943dfbcd61d$var$_touchRippleClasses[key];
        }
    });
});

});
parcelRegister("6n0Ko", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $4a35786d89db9dda$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $4a35786d89db9dda$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.ButtonBaseRoot = void 0;

var $4a35786d89db9dda$var$React = $4a35786d89db9dda$require$_interopRequireWildcard((parcelRequire("acw62")));

var $4a35786d89db9dda$var$_propTypes = $4a35786d89db9dda$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $4a35786d89db9dda$var$_clsx = $4a35786d89db9dda$require$_interopRequireDefault((parcelRequire("9QePP")));

var $4a35786d89db9dda$var$_refType = $4a35786d89db9dda$require$_interopRequireDefault((parcelRequire("b3gjr")));

var $4a35786d89db9dda$var$_elementTypeAcceptingRef = $4a35786d89db9dda$require$_interopRequireDefault((parcelRequire("g6PKz")));

var $4a35786d89db9dda$var$_composeClasses = $4a35786d89db9dda$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $4a35786d89db9dda$var$_isFocusVisible = $4a35786d89db9dda$require$_interopRequireDefault((parcelRequire("cS73m")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $4a35786d89db9dda$var$_useForkRef = $4a35786d89db9dda$require$_interopRequireDefault((parcelRequire("9Rgf1")));

var $4a35786d89db9dda$var$_useEventCallback = $4a35786d89db9dda$require$_interopRequireDefault((parcelRequire("4o7uD")));

var $4a35786d89db9dda$var$_useLazyRipple = $4a35786d89db9dda$require$_interopRequireDefault((parcelRequire("dQknY")));

var $4a35786d89db9dda$var$_TouchRipple = $4a35786d89db9dda$require$_interopRequireDefault((parcelRequire("brF9L")));

var $4a35786d89db9dda$var$_buttonBaseClasses = $4a35786d89db9dda$require$_interopRequireWildcard((parcelRequire("5JO1P")));

var $ayMG0 = parcelRequire("ayMG0");
const $4a35786d89db9dda$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, $4a35786d89db9dda$var$_composeClasses.default)(slots, $4a35786d89db9dda$var$_buttonBaseClasses.getButtonBaseUtilityClass, classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $4a35786d89db9dda$var$ButtonBaseRoot = module.exports.ButtonBaseRoot = (0, $aAbgT.styled)('button', {
    name: 'MuiButtonBase',
    slot: 'Root'
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${$4a35786d89db9dda$var$_buttonBaseClasses.default.disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $4a35786d89db9dda$var$ButtonBase = /*#__PURE__*/ $4a35786d89db9dda$var$React.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, focusVisibleClassName: focusVisibleClassName, LinkComponent: LinkComponent = 'a', onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type, ...other } = props;
    const buttonRef = $4a35786d89db9dda$var$React.useRef(null);
    const ripple = (0, $4a35786d89db9dda$var$_useLazyRipple.default)();
    const handleRippleRef = (0, $4a35786d89db9dda$var$_useForkRef.default)(ripple.ref, touchRippleRef);
    const [focusVisible, setFocusVisible] = $4a35786d89db9dda$var$React.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $4a35786d89db9dda$var$React.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const enableTouchRipple = ripple.shouldMount && !disableRipple && !disabled;
    $4a35786d89db9dda$var$React.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple) ripple.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        ripple
    ]);
    const handleMouseDown = $4a35786d89db9dda$var$useRippleHandler(ripple, 'start', onMouseDown, disableTouchRipple);
    const handleContextMenu = $4a35786d89db9dda$var$useRippleHandler(ripple, 'stop', onContextMenu, disableTouchRipple);
    const handleDragLeave = $4a35786d89db9dda$var$useRippleHandler(ripple, 'stop', onDragLeave, disableTouchRipple);
    const handleMouseUp = $4a35786d89db9dda$var$useRippleHandler(ripple, 'stop', onMouseUp, disableTouchRipple);
    const handleMouseLeave = $4a35786d89db9dda$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    }, disableTouchRipple);
    const handleTouchStart = $4a35786d89db9dda$var$useRippleHandler(ripple, 'start', onTouchStart, disableTouchRipple);
    const handleTouchEnd = $4a35786d89db9dda$var$useRippleHandler(ripple, 'stop', onTouchEnd, disableTouchRipple);
    const handleTouchMove = $4a35786d89db9dda$var$useRippleHandler(ripple, 'stop', onTouchMove, disableTouchRipple);
    const handleBlur = $4a35786d89db9dda$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (!(0, $4a35786d89db9dda$var$_isFocusVisible.default)(event.target)) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $4a35786d89db9dda$var$_useEventCallback.default)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if ((0, $4a35786d89db9dda$var$_isFocusVisible.default)(event.target)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        if (!button) return component && component !== 'button';
        if (button.tagName === 'BUTTON') return false;
        return !(button.tagName === 'A' && button.href);
    };
    const handleKeyDown = (0, $4a35786d89db9dda$var$_useEventCallback.default)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !event.repeat && focusVisible && event.key === ' ') ripple.stop(event, ()=>{
            ripple.start(event);
        });
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $4a35786d89db9dda$var$_useEventCallback.default)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && focusVisible && !event.defaultPrevented) ripple.stop(event, ()=>{
            ripple.pulsate(event);
        });
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented && !disabled) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        const hasFormAttributes = !!other.formAction;
        // ButtonBase was defaulting to type="button" when no type prop was provided, which prevented form submission and broke formAction functionality.
        // The fix checks for form-related attributes and skips the default type to allow the browser's natural submit behavior (type="submit").
        buttonProps.type = type === undefined && !hasFormAttributes ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, $4a35786d89db9dda$var$_useForkRef.default)(ref, buttonRef);
    const ownerState = {
        ...props,
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    };
    const classes = $4a35786d89db9dda$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($4a35786d89db9dda$var$ButtonBaseRoot, {
        as: ComponentProp,
        className: (0, $4a35786d89db9dda$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type,
        ...buttonProps,
        ...other,
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ (0, $ayMG0.jsx)($4a35786d89db9dda$var$_TouchRipple.default, {
                ref: handleRippleRef,
                center: centerRipple,
                ...TouchRippleProps
            }) : null
        ]
    });
});
function $4a35786d89db9dda$var$useRippleHandler(ripple, rippleAction, eventCallback, skipRippleAction = false) {
    return (0, $4a35786d89db9dda$var$_useEventCallback.default)((event)=>{
        if (eventCallback) eventCallback(event);
        if (!skipRippleAction) ripple[rippleAction](event);
        return true;
    });
}
$4a35786d89db9dda$var$ButtonBase.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */ action: $4a35786d89db9dda$var$_refType.default,
    /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */ centerRipple: $4a35786d89db9dda$var$_propTypes.default.bool,
    /**
   * The content of the component.
   */ children: $4a35786d89db9dda$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $4a35786d89db9dda$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $4a35786d89db9dda$var$_propTypes.default.string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $4a35786d89db9dda$var$_elementTypeAcceptingRef.default,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: $4a35786d89db9dda$var$_propTypes.default.bool,
    /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */ disableRipple: $4a35786d89db9dda$var$_propTypes.default.bool,
    /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */ disableTouchRipple: $4a35786d89db9dda$var$_propTypes.default.bool,
    /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */ focusRipple: $4a35786d89db9dda$var$_propTypes.default.bool,
    /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */ focusVisibleClassName: $4a35786d89db9dda$var$_propTypes.default.string,
    /**
   * @ignore
   */ formAction: $4a35786d89db9dda$var$_propTypes.default.oneOfType([
        $4a35786d89db9dda$var$_propTypes.default.func,
        $4a35786d89db9dda$var$_propTypes.default.string
    ]),
    /**
   * @ignore
   */ href: $4a35786d89db9dda$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .any,
    /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */ LinkComponent: $4a35786d89db9dda$var$_propTypes.default.elementType,
    /**
   * @ignore
   */ onBlur: $4a35786d89db9dda$var$_propTypes.default.func,
    /**
   * @ignore
   */ onClick: $4a35786d89db9dda$var$_propTypes.default.func,
    /**
   * @ignore
   */ onContextMenu: $4a35786d89db9dda$var$_propTypes.default.func,
    /**
   * @ignore
   */ onDragLeave: $4a35786d89db9dda$var$_propTypes.default.func,
    /**
   * @ignore
   */ onFocus: $4a35786d89db9dda$var$_propTypes.default.func,
    /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */ onFocusVisible: $4a35786d89db9dda$var$_propTypes.default.func,
    /**
   * @ignore
   */ onKeyDown: $4a35786d89db9dda$var$_propTypes.default.func,
    /**
   * @ignore
   */ onKeyUp: $4a35786d89db9dda$var$_propTypes.default.func,
    /**
   * @ignore
   */ onMouseDown: $4a35786d89db9dda$var$_propTypes.default.func,
    /**
   * @ignore
   */ onMouseLeave: $4a35786d89db9dda$var$_propTypes.default.func,
    /**
   * @ignore
   */ onMouseUp: $4a35786d89db9dda$var$_propTypes.default.func,
    /**
   * @ignore
   */ onTouchEnd: $4a35786d89db9dda$var$_propTypes.default.func,
    /**
   * @ignore
   */ onTouchMove: $4a35786d89db9dda$var$_propTypes.default.func,
    /**
   * @ignore
   */ onTouchStart: $4a35786d89db9dda$var$_propTypes.default.func,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $4a35786d89db9dda$var$_propTypes.default.oneOfType([
        $4a35786d89db9dda$var$_propTypes.default.arrayOf($4a35786d89db9dda$var$_propTypes.default.oneOfType([
            $4a35786d89db9dda$var$_propTypes.default.func,
            $4a35786d89db9dda$var$_propTypes.default.object,
            $4a35786d89db9dda$var$_propTypes.default.bool
        ])),
        $4a35786d89db9dda$var$_propTypes.default.func,
        $4a35786d89db9dda$var$_propTypes.default.object
    ]),
    /**
   * @default 0
   */ tabIndex: $4a35786d89db9dda$var$_propTypes.default.number,
    /**
   * Props applied to the `TouchRipple` element.
   */ TouchRippleProps: $4a35786d89db9dda$var$_propTypes.default.object,
    /**
   * A ref that points to the `TouchRipple` element.
   */ touchRippleRef: $4a35786d89db9dda$var$_propTypes.default.oneOfType([
        $4a35786d89db9dda$var$_propTypes.default.func,
        $4a35786d89db9dda$var$_propTypes.default.shape({
            current: $4a35786d89db9dda$var$_propTypes.default.shape({
                pulsate: $4a35786d89db9dda$var$_propTypes.default.func.isRequired,
                start: $4a35786d89db9dda$var$_propTypes.default.func.isRequired,
                stop: $4a35786d89db9dda$var$_propTypes.default.func.isRequired
            })
        })
    ]),
    /**
   * @ignore
   */ type: $4a35786d89db9dda$var$_propTypes.default.oneOfType([
        $4a35786d89db9dda$var$_propTypes.default.oneOf([
            'button',
            'reset',
            'submit'
        ]),
        $4a35786d89db9dda$var$_propTypes.default.string
    ])
};
var $4a35786d89db9dda$var$_default = module.exports.default = $4a35786d89db9dda$var$ButtonBase;

});
parcelRegister("g6PKz", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $bba559669a6b05ba$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $bba559669a6b05ba$var$_elementTypeAcceptingRef.default;
    }
});

var $bba559669a6b05ba$var$_elementTypeAcceptingRef = $bba559669a6b05ba$require$_interopRequireDefault((parcelRequire("ipGOY")));

});
parcelRegister("ipGOY", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $d67bc73532990cfc$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $d67bc73532990cfc$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d67bc73532990cfc$var$_propTypes = $d67bc73532990cfc$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $d67bc73532990cfc$var$React = $d67bc73532990cfc$require$_interopRequireWildcard((parcelRequire("acw62")));

var $d67bc73532990cfc$var$_chainPropTypes = $d67bc73532990cfc$require$_interopRequireDefault((parcelRequire("abVWF")));
function $d67bc73532990cfc$var$isClassComponent(elementType) {
    // elementType.prototype?.isReactComponent
    const { prototype: prototype = {} } = elementType;
    return Boolean(prototype.isReactComponent);
}
function $d67bc73532990cfc$var$elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
    const propValue = props[propName];
    const safePropName = propFullName || propName;
    if (propValue == null || // When server-side rendering React doesn't warn either.
    // This is not an accurate check for SSR.
    // This is only in place for emotion compat.
    // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
    typeof window === 'undefined') return null;
    let warningHint;
    /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */ if (typeof propValue === 'function' && !$d67bc73532990cfc$var$isClassComponent(propValue)) warningHint = 'Did you accidentally provide a plain function component instead?';
    if (propValue === $d67bc73532990cfc$var$React.Fragment) warningHint = 'Did you accidentally provide a React.Fragment instead?';
    // #host-reference
    if (warningHint !== undefined) return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. ` + `Expected an element type that can hold a ref. ${warningHint} ` + 'For more information see https://v7.mui.com/r/caveat-with-refs-guide');
    return null;
}
var $d67bc73532990cfc$var$_default = module.exports.default = (0, $d67bc73532990cfc$var$_chainPropTypes.default)($d67bc73532990cfc$var$_propTypes.default.elementType, $d67bc73532990cfc$var$elementTypeAcceptingRef);

});


parcelRegister("cS73m", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $95efffca1849a5b5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $95efffca1849a5b5$var$_isFocusVisible.default;
    }
});

var $95efffca1849a5b5$var$_isFocusVisible = $95efffca1849a5b5$require$_interopRequireDefault((parcelRequire("clXxf")));

});
parcelRegister("clXxf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8fe5a0a4a52682b2$var$isFocusVisible;
/**
 * Returns a boolean indicating if the event's target has :focus-visible
 */ function $8fe5a0a4a52682b2$var$isFocusVisible(element) {
    try {
        return element.matches(':focus-visible');
    } catch (error) {
        // Do not warn on jsdom tests, otherwise all tests that rely on focus have to be skipped
        // Tests that rely on `:focus-visible` will still have to be skipped in jsdom
        if (!window.navigator.userAgent.includes('jsdom')) console.warn([
            'MUI: The `:focus-visible` pseudo class is not supported in this browser.',
            'Some components rely on this feature to work properly.'
        ].join('\n'));
    }
    return false;
}

});


parcelRegister("dQknY", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $a13ff1df58a097d2$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $a13ff1df58a097d2$var$_useLazyRipple.default;
    }
});

var $a13ff1df58a097d2$var$_useLazyRipple = $a13ff1df58a097d2$require$_interopRequireDefault((parcelRequire("ju2Oo")));

});
parcelRegister("ju2Oo", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $e2f30007e7be7ff3$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $e2f30007e7be7ff3$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LazyRipple = void 0;
module.exports.default = $e2f30007e7be7ff3$var$useLazyRipple;

var $e2f30007e7be7ff3$var$React = $e2f30007e7be7ff3$require$_interopRequireWildcard((parcelRequire("acw62")));

var $e2f30007e7be7ff3$var$_useLazyRef = $e2f30007e7be7ff3$require$_interopRequireDefault((parcelRequire("doV3C")));
/**
 * Lazy initialization container for the Ripple instance. This improves
 * performance by delaying mounting the ripple until it's needed.
 */ class $e2f30007e7be7ff3$var$LazyRipple {
    /** React ref to the ripple instance */ /** If the ripple component should be mounted */ /** Promise that resolves when the ripple component is mounted */ /** If the ripple component has been mounted */ /** React state hook setter */ static create() {
        return new $e2f30007e7be7ff3$var$LazyRipple();
    }
    static use() {
        /* eslint-disable */ const ripple = (0, $e2f30007e7be7ff3$var$_useLazyRef.default)($e2f30007e7be7ff3$var$LazyRipple.create).current;
        const [shouldMount, setShouldMount] = $e2f30007e7be7ff3$var$React.useState(false);
        ripple.shouldMount = shouldMount;
        ripple.setShouldMount = setShouldMount;
        $e2f30007e7be7ff3$var$React.useEffect(ripple.mountEffect, [
            shouldMount
        ]);
        /* eslint-enable */ return ripple;
    }
    constructor(){
        this.ref = {
            current: null
        };
        this.mounted = null;
        this.didMount = false;
        this.shouldMount = false;
        this.setShouldMount = null;
    }
    mount() {
        if (!this.mounted) {
            this.mounted = $e2f30007e7be7ff3$var$createControlledPromise();
            this.shouldMount = true;
            this.setShouldMount(this.shouldMount);
        }
        return this.mounted;
    }
    mountEffect = ()=>{
        if (this.shouldMount && !this.didMount) {
            if (this.ref.current !== null) {
                this.didMount = true;
                this.mounted.resolve();
            }
        }
    };
    /* Ripple API */ start(...args) {
        this.mount().then(()=>this.ref.current?.start(...args));
    }
    stop(...args) {
        this.mount().then(()=>this.ref.current?.stop(...args));
    }
    pulsate(...args) {
        this.mount().then(()=>this.ref.current?.pulsate(...args));
    }
}
module.exports.LazyRipple = $e2f30007e7be7ff3$var$LazyRipple;
function $e2f30007e7be7ff3$var$useLazyRipple() {
    return $e2f30007e7be7ff3$var$LazyRipple.use();
}
function $e2f30007e7be7ff3$var$createControlledPromise() {
    let resolve;
    let reject;
    const p = new Promise((resolveFn, rejectFn)=>{
        resolve = resolveFn;
        reject = rejectFn;
    });
    p.resolve = resolve;
    p.reject = reject;
    return p;
}

});
parcelRegister("doV3C", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9c19c6af0ae205c1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9c19c6af0ae205c1$var$_useLazyRef.default;
    }
});

var $9c19c6af0ae205c1$var$_useLazyRef = $9c19c6af0ae205c1$require$_interopRequireDefault((parcelRequire("5vBDv")));

});
parcelRegister("5vBDv", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $402d0abe25ac8831$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $402d0abe25ac8831$var$useLazyRef;

var $402d0abe25ac8831$var$React = $402d0abe25ac8831$require$_interopRequireWildcard((parcelRequire("acw62")));
const $402d0abe25ac8831$var$UNINITIALIZED = {};
/**
 * A React.useRef() that is initialized lazily with a function. Note that it accepts an optional
 * initialization argument, so the initialization function doesn't need to be an inline closure.
 *
 * @usage
 *   const ref = useLazyRef(sortColumns, columns)
 */ function $402d0abe25ac8831$var$useLazyRef(init, initArg) {
    const ref = $402d0abe25ac8831$var$React.useRef($402d0abe25ac8831$var$UNINITIALIZED);
    if (ref.current === $402d0abe25ac8831$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}

});




parcelRegister("brF9L", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $855224273a002a0f$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $855224273a002a0f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.TouchRippleRoot = module.exports.TouchRippleRipple = module.exports.DELAY_RIPPLE = void 0;

var $855224273a002a0f$var$React = $855224273a002a0f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $855224273a002a0f$var$_propTypes = $855224273a002a0f$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $jEvxL = parcelRequire("jEvxL");

var $855224273a002a0f$var$_clsx = $855224273a002a0f$require$_interopRequireDefault((parcelRequire("9QePP")));

var $855224273a002a0f$var$_useTimeout = $855224273a002a0f$require$_interopRequireDefault((parcelRequire("drY8V")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $855224273a002a0f$var$_Ripple = $855224273a002a0f$require$_interopRequireDefault((parcelRequire("hruNq")));

var $855224273a002a0f$var$_touchRippleClasses = $855224273a002a0f$require$_interopRequireDefault((parcelRequire("a4Mf7")));

var $ayMG0 = parcelRequire("ayMG0");
const $855224273a002a0f$var$DURATION = 550;
const $855224273a002a0f$var$DELAY_RIPPLE = module.exports.DELAY_RIPPLE = 80;
const $855224273a002a0f$var$enterKeyframe = (0, $aAbgT.keyframes)`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`;
const $855224273a002a0f$var$exitKeyframe = (0, $aAbgT.keyframes)`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`;
const $855224273a002a0f$var$pulsateKeyframe = (0, $aAbgT.keyframes)`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`;
const $855224273a002a0f$var$TouchRippleRoot = module.exports.TouchRippleRoot = (0, $aAbgT.styled)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
// This `styled()` function invokes keyframes. `styled-components` only supports keyframes
// in string templates. Do not convert these styles in JS object as it will break.
const $855224273a002a0f$var$TouchRippleRipple = module.exports.TouchRippleRipple = (0, $aAbgT.styled)($855224273a002a0f$var$_Ripple.default, {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})`
  opacity: 0;
  position: absolute;

  &.${$855224273a002a0f$var$_touchRippleClasses.default.rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${$855224273a002a0f$var$enterKeyframe};
    animation-duration: ${$855224273a002a0f$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  &.${$855224273a002a0f$var$_touchRippleClasses.default.ripplePulsate} {
    animation-duration: ${({ theme: theme })=>theme.transitions.duration.shorter}ms;
  }

  & .${$855224273a002a0f$var$_touchRippleClasses.default.child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${$855224273a002a0f$var$_touchRippleClasses.default.childLeaving} {
    opacity: 0;
    animation-name: ${$855224273a002a0f$var$exitKeyframe};
    animation-duration: ${$855224273a002a0f$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  & .${$855224273a002a0f$var$_touchRippleClasses.default.childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${$855224273a002a0f$var$pulsateKeyframe};
    animation-duration: 2500ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`;
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $855224273a002a0f$var$TouchRipple = /*#__PURE__*/ $855224273a002a0f$var$React.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes: classes = {}, className: className, ...other } = props;
    const [ripples, setRipples] = $855224273a002a0f$var$React.useState([]);
    const nextKey = $855224273a002a0f$var$React.useRef(0);
    const rippleCallback = $855224273a002a0f$var$React.useRef(null);
    $855224273a002a0f$var$React.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $855224273a002a0f$var$React.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $855224273a002a0f$var$_useTimeout.default)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $855224273a002a0f$var$React.useRef(null);
    const container = $855224273a002a0f$var$React.useRef(null);
    const startCommit = $855224273a002a0f$var$React.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $ayMG0.jsx)($855224273a002a0f$var$TouchRippleRipple, {
                    classes: {
                        ripple: (0, $855224273a002a0f$var$_clsx.default)(classes.ripple, $855224273a002a0f$var$_touchRippleClasses.default.ripple),
                        rippleVisible: (0, $855224273a002a0f$var$_clsx.default)(classes.rippleVisible, $855224273a002a0f$var$_touchRippleClasses.default.rippleVisible),
                        ripplePulsate: (0, $855224273a002a0f$var$_clsx.default)(classes.ripplePulsate, $855224273a002a0f$var$_touchRippleClasses.default.ripplePulsate),
                        child: (0, $855224273a002a0f$var$_clsx.default)(classes.child, $855224273a002a0f$var$_touchRippleClasses.default.child),
                        childLeaving: (0, $855224273a002a0f$var$_clsx.default)(classes.childLeaving, $855224273a002a0f$var$_touchRippleClasses.default.childLeaving),
                        childPulsate: (0, $855224273a002a0f$var$_clsx.default)(classes.childPulsate, $855224273a002a0f$var$_touchRippleClasses.default.childPulsate)
                    },
                    timeout: $855224273a002a0f$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $855224273a002a0f$var$React.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if (event?.type === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event?.type === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touch devices
        if (event?.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($855224273a002a0f$var$DELAY_RIPPLE, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $855224273a002a0f$var$React.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $855224273a002a0f$var$React.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if (event?.type === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $855224273a002a0f$var$React.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($855224273a002a0f$var$TouchRippleRoot, {
        className: (0, $855224273a002a0f$var$_clsx.default)($855224273a002a0f$var$_touchRippleClasses.default.root, classes.root, className),
        ref: container,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($jEvxL.default, {
            component: null,
            exit: true,
            children: ripples
        })
    });
});
$855224273a002a0f$var$TouchRipple.propTypes = {
    /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */ center: $855224273a002a0f$var$_propTypes.default.bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $855224273a002a0f$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $855224273a002a0f$var$_propTypes.default.string
};
var $855224273a002a0f$var$_default = module.exports.default = $855224273a002a0f$var$TouchRipple;

});
parcelRegister("jEvxL", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4ea38a8b431e8fc$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $hDpcU = parcelRequire("hDpcU");

var $g7ajw = parcelRequire("g7ajw");

var $c9Z8w = parcelRequire("c9Z8w");

var $acw62 = parcelRequire("acw62");

var $6xlZQ = parcelRequire("6xlZQ");

var $n2pn1 = parcelRequire("n2pn1");
var $e4ea38a8b431e8fc$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $e4ea38a8b431e8fc$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $e4ea38a8b431e8fc$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $hDpcU.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $n2pn1.getInitialChildMapping)(nextProps, handleExited) : (0, $n2pn1.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $n2pn1.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $8nd05.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $1En50.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $e4ea38a8b431e8fc$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xlZQ.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xlZQ.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$e4ea38a8b431e8fc$var$TransitionGroup.propTypes = {
    /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */ appear: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */ enter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */ exit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */ childFactory: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};
$e4ea38a8b431e8fc$var$TransitionGroup.defaultProps = $e4ea38a8b431e8fc$var$defaultProps;
var $e4ea38a8b431e8fc$export$2e2bcd8739ae039 = $e4ea38a8b431e8fc$var$TransitionGroup;

});
parcelRegister("1En50", function(module, exports) {

$parcel$export(module.exports, "default", () => $133b6e059b2f6d5e$export$2e2bcd8739ae039);
function $133b6e059b2f6d5e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("hDpcU", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd69a1d4c6210e44$export$2e2bcd8739ae039);
function $cd69a1d4c6210e44$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("g7ajw", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbb54ce93eb94a95$export$2e2bcd8739ae039);

var $VFVve = parcelRequire("VFVve");
function $bbb54ce93eb94a95$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $VFVve.default)(t, o);
}

});
parcelRegister("VFVve", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ad5d8b55fe970db$export$2e2bcd8739ae039);
function $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e) {
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("6xlZQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c26e32a51d8c622$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $4c26e32a51d8c622$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);

});

parcelRegister("n2pn1", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", () => $04540450bf60efa1$export$bbc8a025727ea824);
$parcel$export(module.exports, "getInitialChildMapping", () => $04540450bf60efa1$export$fa71e2345c31d7a2);
$parcel$export(module.exports, "getNextChildMapping", () => $04540450bf60efa1$export$36fd1af28d383ec0);

var $acw62 = parcelRequire("acw62");
function $04540450bf60efa1$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $acw62.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $acw62.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $04540450bf60efa1$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $04540450bf60efa1$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $04540450bf60efa1$export$fa71e2345c31d7a2(props, onExited) {
    return $04540450bf60efa1$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $04540450bf60efa1$var$getProp(child, 'appear', props),
            enter: $04540450bf60efa1$var$getProp(child, 'enter', props),
            exit: $04540450bf60efa1$var$getProp(child, 'exit', props)
        });
    });
}
function $04540450bf60efa1$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $04540450bf60efa1$export$bbc8a025727ea824(nextProps.children);
    var children = $04540450bf60efa1$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $acw62.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $acw62.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $04540450bf60efa1$var$getProp(child, 'exit', nextProps),
            enter: $04540450bf60efa1$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $acw62.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $04540450bf60efa1$var$getProp(child, 'exit', nextProps),
            enter: $04540450bf60efa1$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}

});


parcelRegister("drY8V", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $9cac7318e3bb01ed$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Timeout", {
    enumerable: true,
    get: function() {
        return $9cac7318e3bb01ed$var$_useTimeout.Timeout;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9cac7318e3bb01ed$var$_useTimeout.default;
    }
});

var $9cac7318e3bb01ed$var$_useTimeout = $9cac7318e3bb01ed$require$_interopRequireWildcard((parcelRequire("lAE8L")));

});
parcelRegister("lAE8L", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $fb7c18ce8a63cbff$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Timeout = void 0;
module.exports.default = $fb7c18ce8a63cbff$var$useTimeout;

var $fb7c18ce8a63cbff$var$_useLazyRef = $fb7c18ce8a63cbff$require$_interopRequireDefault((parcelRequire("5vBDv")));

var $fb7c18ce8a63cbff$var$_useOnMount = $fb7c18ce8a63cbff$require$_interopRequireDefault((parcelRequire("kWo5z")));
class $fb7c18ce8a63cbff$var$Timeout {
    static create() {
        return new $fb7c18ce8a63cbff$var$Timeout();
    }
    currentId = null;
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
    clear = ()=>{
        if (this.currentId !== null) {
            clearTimeout(this.currentId);
            this.currentId = null;
        }
    };
    disposeEffect = ()=>{
        return this.clear;
    };
}
module.exports.Timeout = $fb7c18ce8a63cbff$var$Timeout;
function $fb7c18ce8a63cbff$var$useTimeout() {
    const timeout = (0, $fb7c18ce8a63cbff$var$_useLazyRef.default)($fb7c18ce8a63cbff$var$Timeout.create).current;
    (0, $fb7c18ce8a63cbff$var$_useOnMount.default)(timeout.disposeEffect);
    return timeout;
}

});
parcelRegister("kWo5z", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $f3ebe8fe644f0aa5$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f3ebe8fe644f0aa5$var$useOnMount;

var $f3ebe8fe644f0aa5$var$React = $f3ebe8fe644f0aa5$require$_interopRequireWildcard((parcelRequire("acw62")));
const $f3ebe8fe644f0aa5$var$EMPTY = [];
/**
 * A React.useEffect equivalent that runs once, when the component is mounted.
 */ function $f3ebe8fe644f0aa5$var$useOnMount(fn) {
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- no need to put `fn` in the dependency array
    /* eslint-disable react-hooks/exhaustive-deps */ $f3ebe8fe644f0aa5$var$React.useEffect(fn, $f3ebe8fe644f0aa5$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }

});



parcelRegister("hruNq", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $cb2cd8c78d72bd92$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $cb2cd8c78d72bd92$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cb2cd8c78d72bd92$var$React = $cb2cd8c78d72bd92$require$_interopRequireWildcard((parcelRequire("acw62")));

var $cb2cd8c78d72bd92$var$_propTypes = $cb2cd8c78d72bd92$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $cb2cd8c78d72bd92$var$_clsx = $cb2cd8c78d72bd92$require$_interopRequireDefault((parcelRequire("9QePP")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ function $cb2cd8c78d72bd92$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $cb2cd8c78d72bd92$var$React.useState(false);
    const rippleClassName = (0, $cb2cd8c78d72bd92$var$_clsx.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $cb2cd8c78d72bd92$var$_clsx.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $cb2cd8c78d72bd92$var$React.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: childClassName
        })
    });
}
$cb2cd8c78d72bd92$var$Ripple.propTypes = {
    /**
   * Override or extend the styles applied to the component.
   */ classes: $cb2cd8c78d72bd92$var$_propTypes.default.object.isRequired,
    className: $cb2cd8c78d72bd92$var$_propTypes.default.string,
    /**
   * @ignore - injected from TransitionGroup
   */ in: $cb2cd8c78d72bd92$var$_propTypes.default.bool,
    /**
   * @ignore - injected from TransitionGroup
   */ onExited: $cb2cd8c78d72bd92$var$_propTypes.default.func,
    /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */ pulsate: $cb2cd8c78d72bd92$var$_propTypes.default.bool,
    /**
   * Diameter of the ripple.
   */ rippleSize: $cb2cd8c78d72bd92$var$_propTypes.default.number,
    /**
   * Horizontal position of the ripple center.
   */ rippleX: $cb2cd8c78d72bd92$var$_propTypes.default.number,
    /**
   * Vertical position of the ripple center.
   */ rippleY: $cb2cd8c78d72bd92$var$_propTypes.default.number,
    /**
   * exit delay
   */ timeout: $cb2cd8c78d72bd92$var$_propTypes.default.number.isRequired
};
var $cb2cd8c78d72bd92$var$_default = module.exports.default = $cb2cd8c78d72bd92$var$Ripple;

});

parcelRegister("a4Mf7", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $755fb323846f60d4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getTouchRippleUtilityClass = $755fb323846f60d4$var$getTouchRippleUtilityClass;

var $755fb323846f60d4$var$_generateUtilityClasses = $755fb323846f60d4$require$_interopRequireDefault((parcelRequire("5nY49")));

var $755fb323846f60d4$var$_generateUtilityClass = $755fb323846f60d4$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $755fb323846f60d4$var$getTouchRippleUtilityClass(slot) {
    return (0, $755fb323846f60d4$var$_generateUtilityClass.default)('MuiTouchRipple', slot);
}
const $755fb323846f60d4$var$touchRippleClasses = (0, $755fb323846f60d4$var$_generateUtilityClasses.default)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $755fb323846f60d4$var$_default = module.exports.default = $755fb323846f60d4$var$touchRippleClasses;

});


parcelRegister("5JO1P", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $42d7f65840078ec1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getButtonBaseUtilityClass = $42d7f65840078ec1$var$getButtonBaseUtilityClass;

var $42d7f65840078ec1$var$_generateUtilityClasses = $42d7f65840078ec1$require$_interopRequireDefault((parcelRequire("5nY49")));

var $42d7f65840078ec1$var$_generateUtilityClass = $42d7f65840078ec1$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $42d7f65840078ec1$var$getButtonBaseUtilityClass(slot) {
    return (0, $42d7f65840078ec1$var$_generateUtilityClass.default)('MuiButtonBase', slot);
}
const $42d7f65840078ec1$var$buttonBaseClasses = (0, $42d7f65840078ec1$var$_generateUtilityClasses.default)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $42d7f65840078ec1$var$_default = module.exports.default = $42d7f65840078ec1$var$buttonBaseClasses;

});



parcelRegister("1sBf1", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $11054b4f9cc1bbd6$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $11054b4f9cc1bbd6$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $11054b4f9cc1bbd6$var$_exportNames = {
    circularProgressClasses: true
};
Object.defineProperty(module.exports, "circularProgressClasses", {
    enumerable: true,
    get: function() {
        return $11054b4f9cc1bbd6$var$_circularProgressClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $11054b4f9cc1bbd6$var$_CircularProgress.default;
    }
});

var $11054b4f9cc1bbd6$var$_CircularProgress = $11054b4f9cc1bbd6$require$_interopRequireDefault((parcelRequire("2cPwN")));

var $11054b4f9cc1bbd6$var$_circularProgressClasses = $11054b4f9cc1bbd6$require$_interopRequireWildcard((parcelRequire("fPJfA")));
Object.keys($11054b4f9cc1bbd6$var$_circularProgressClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($11054b4f9cc1bbd6$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $11054b4f9cc1bbd6$var$_circularProgressClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $11054b4f9cc1bbd6$var$_circularProgressClasses[key];
        }
    });
});

});
parcelRegister("2cPwN", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $19b4ac261663afa8$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $19b4ac261663afa8$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $19b4ac261663afa8$var$React = $19b4ac261663afa8$require$_interopRequireWildcard((parcelRequire("acw62")));

var $19b4ac261663afa8$var$_propTypes = $19b4ac261663afa8$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $19b4ac261663afa8$var$_clsx = $19b4ac261663afa8$require$_interopRequireDefault((parcelRequire("9QePP")));

var $19b4ac261663afa8$var$_chainPropTypes = $19b4ac261663afa8$require$_interopRequireDefault((parcelRequire("abVWF")));

var $19b4ac261663afa8$var$_composeClasses = $19b4ac261663afa8$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $19b4ac261663afa8$var$_memoTheme = $19b4ac261663afa8$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $19b4ac261663afa8$var$_capitalize = $19b4ac261663afa8$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $19b4ac261663afa8$var$_createSimplePaletteValueFilter = $19b4ac261663afa8$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $fPJfA = parcelRequire("fPJfA");

var $ayMG0 = parcelRequire("ayMG0");
const $19b4ac261663afa8$var$SIZE = 44;
const $19b4ac261663afa8$var$circularRotateKeyframe = (0, $aAbgT.keyframes)`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;
const $19b4ac261663afa8$var$circularDashKeyframe = (0, $aAbgT.keyframes)`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: -126px;
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $19b4ac261663afa8$var$rotateAnimation = typeof $19b4ac261663afa8$var$circularRotateKeyframe !== 'string' ? (0, $aAbgT.css)`
        animation: ${$19b4ac261663afa8$var$circularRotateKeyframe} 1.4s linear infinite;
      ` : null;
const $19b4ac261663afa8$var$dashAnimation = typeof $19b4ac261663afa8$var$circularDashKeyframe !== 'string' ? (0, $aAbgT.css)`
        animation: ${$19b4ac261663afa8$var$circularDashKeyframe} 1.4s ease-in-out infinite;
      ` : null;
const $19b4ac261663afa8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, $19b4ac261663afa8$var$_capitalize.default)(color)}`
        ],
        svg: [
            'svg'
        ],
        track: [
            'track'
        ],
        circle: [
            'circle',
            `circle${(0, $19b4ac261663afa8$var$_capitalize.default)(variant)}`,
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, $19b4ac261663afa8$var$_composeClasses.default)(slots, $fPJfA.getCircularProgressUtilityClass, classes);
};
const $19b4ac261663afa8$var$CircularProgressRoot = (0, $aAbgT.styled)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $19b4ac261663afa8$var$_capitalize.default)(ownerState.color)}`]
        ];
    }
})((0, $19b4ac261663afa8$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'inline-block',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('transform')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: $19b4ac261663afa8$var$rotateAnimation || {
                    animation: `${$19b4ac261663afa8$var$circularRotateKeyframe} 1.4s linear infinite`
                }
            },
            ...Object.entries(theme.palette).filter((0, $19b4ac261663afa8$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                }))
        ]
    })));
const $19b4ac261663afa8$var$CircularProgressSVG = (0, $aAbgT.styled)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg'
})({
    display: 'block' // Keeps the progress centered
});
const $19b4ac261663afa8$var$CircularProgressCircle = (0, $aAbgT.styled)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $19b4ac261663afa8$var$_capitalize.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})((0, $19b4ac261663afa8$var$_memoTheme.default)(({ theme: theme })=>({
        stroke: 'currentColor',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('stroke-dashoffset')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: {
                    // Some default value that looks fine waiting for the animation to kicks in.
                    strokeDasharray: '80px, 200px',
                    strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink,
                style: $19b4ac261663afa8$var$dashAnimation || {
                    // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
                    animation: `${$19b4ac261663afa8$var$circularDashKeyframe} 1.4s ease-in-out infinite`
                }
            }
        ]
    })));
const $19b4ac261663afa8$var$CircularProgressTrack = (0, $aAbgT.styled)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Track'
})((0, $19b4ac261663afa8$var$_memoTheme.default)(({ theme: theme })=>({
        stroke: 'currentColor',
        opacity: (theme.vars || theme).palette.action.activatedOpacity
    })));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $19b4ac261663afa8$var$CircularProgress = /*#__PURE__*/ $19b4ac261663afa8$var$React.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className: className, color: color = 'primary', disableShrink: disableShrink = false, enableTrackSlot: enableTrackSlot = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = 'indeterminate', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant,
        enableTrackSlot: enableTrackSlot
    };
    const classes = $19b4ac261663afa8$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * (($19b4ac261663afa8$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($19b4ac261663afa8$var$CircularProgressRoot, {
        className: (0, $19b4ac261663afa8$var$_clsx.default)(classes.root, className),
        style: {
            width: size,
            height: size,
            ...rootStyle,
            ...style
        },
        ownerState: ownerState,
        ref: ref,
        role: "progressbar",
        ...rootProps,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($19b4ac261663afa8$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$19b4ac261663afa8$var$SIZE / 2} ${$19b4ac261663afa8$var$SIZE / 2} ${$19b4ac261663afa8$var$SIZE} ${$19b4ac261663afa8$var$SIZE}`,
            children: [
                enableTrackSlot ? /*#__PURE__*/ (0, $ayMG0.jsx)($19b4ac261663afa8$var$CircularProgressTrack, {
                    className: classes.track,
                    ownerState: ownerState,
                    cx: $19b4ac261663afa8$var$SIZE,
                    cy: $19b4ac261663afa8$var$SIZE,
                    r: ($19b4ac261663afa8$var$SIZE - thickness) / 2,
                    fill: "none",
                    strokeWidth: thickness,
                    "aria-hidden": "true"
                }) : null,
                /*#__PURE__*/ (0, $ayMG0.jsx)($19b4ac261663afa8$var$CircularProgressCircle, {
                    className: classes.circle,
                    style: circleStyle,
                    ownerState: ownerState,
                    cx: $19b4ac261663afa8$var$SIZE,
                    cy: $19b4ac261663afa8$var$SIZE,
                    r: ($19b4ac261663afa8$var$SIZE - thickness) / 2,
                    fill: "none",
                    strokeWidth: thickness
                })
            ]
        })
    });
});
$19b4ac261663afa8$var$CircularProgress.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Override or extend the styles applied to the component.
   */ classes: $19b4ac261663afa8$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $19b4ac261663afa8$var$_propTypes.default.string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */ color: $19b4ac261663afa8$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $19b4ac261663afa8$var$_propTypes.default.oneOf([
            'inherit',
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning'
        ]),
        $19b4ac261663afa8$var$_propTypes.default.string
    ]),
    /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   * @default false
   */ disableShrink: (0, $19b4ac261663afa8$var$_chainPropTypes.default)($19b4ac261663afa8$var$_propTypes.default.bool, (props)=>{
        if (props.disableShrink && props.variant && props.variant !== 'indeterminate') return new Error("MUI: You have provided the `disableShrink` prop with a variant other than `indeterminate`. This will have no effect.");
        return null;
    }),
    /**
   * If `true`, a track circle slot is mounted to show a subtle background for the progress.
   * The `size` and `thickness` apply to the track slot to be consistent with the progress circle.
   * @default false
   */ enableTrackSlot: $19b4ac261663afa8$var$_propTypes.default.bool,
    /**
   * The size of the component.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, for example '3rem'.
   * @default 40
   */ size: $19b4ac261663afa8$var$_propTypes.default.oneOfType([
        $19b4ac261663afa8$var$_propTypes.default.number,
        $19b4ac261663afa8$var$_propTypes.default.string
    ]),
    /**
   * @ignore
   */ style: $19b4ac261663afa8$var$_propTypes.default.object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $19b4ac261663afa8$var$_propTypes.default.oneOfType([
        $19b4ac261663afa8$var$_propTypes.default.arrayOf($19b4ac261663afa8$var$_propTypes.default.oneOfType([
            $19b4ac261663afa8$var$_propTypes.default.func,
            $19b4ac261663afa8$var$_propTypes.default.object,
            $19b4ac261663afa8$var$_propTypes.default.bool
        ])),
        $19b4ac261663afa8$var$_propTypes.default.func,
        $19b4ac261663afa8$var$_propTypes.default.object
    ]),
    /**
   * The thickness of the circle.
   * @default 3.6
   */ thickness: $19b4ac261663afa8$var$_propTypes.default.number,
    /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */ value: $19b4ac261663afa8$var$_propTypes.default.number,
    /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   * @default 'indeterminate'
   */ variant: $19b4ac261663afa8$var$_propTypes.default.oneOf([
        'determinate',
        'indeterminate'
    ])
};
var $19b4ac261663afa8$var$_default = module.exports.default = $19b4ac261663afa8$var$CircularProgress;

});
parcelRegister("fPJfA", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $b86eb8364bb4993c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getCircularProgressUtilityClass = $b86eb8364bb4993c$var$getCircularProgressUtilityClass;

var $b86eb8364bb4993c$var$_generateUtilityClasses = $b86eb8364bb4993c$require$_interopRequireDefault((parcelRequire("5nY49")));

var $b86eb8364bb4993c$var$_generateUtilityClass = $b86eb8364bb4993c$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $b86eb8364bb4993c$var$getCircularProgressUtilityClass(slot) {
    return (0, $b86eb8364bb4993c$var$_generateUtilityClass.default)('MuiCircularProgress', slot);
}
const $b86eb8364bb4993c$var$circularProgressClasses = (0, $b86eb8364bb4993c$var$_generateUtilityClasses.default)('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'track',
    'circle',
    'circleDeterminate',
    'circleIndeterminate',
    'circleDisableShrink'
]);
var $b86eb8364bb4993c$var$_default = module.exports.default = $b86eb8364bb4993c$var$circularProgressClasses;

});



parcelRegister("jzUw6", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e40d2047b7c1e09d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getIconButtonUtilityClass = $e40d2047b7c1e09d$var$getIconButtonUtilityClass;

var $e40d2047b7c1e09d$var$_generateUtilityClasses = $e40d2047b7c1e09d$require$_interopRequireDefault((parcelRequire("5nY49")));

var $e40d2047b7c1e09d$var$_generateUtilityClass = $e40d2047b7c1e09d$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $e40d2047b7c1e09d$var$getIconButtonUtilityClass(slot) {
    return (0, $e40d2047b7c1e09d$var$_generateUtilityClass.default)('MuiIconButton', slot);
}
const $e40d2047b7c1e09d$var$iconButtonClasses = (0, $e40d2047b7c1e09d$var$_generateUtilityClasses.default)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'loading',
    'loadingIndicator',
    'loadingWrapper'
]);
var $e40d2047b7c1e09d$var$_default = module.exports.default = $e40d2047b7c1e09d$var$iconButtonClasses;

});



parcelRegister("6p5K7", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $4a998843df0ddc3a$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $4a998843df0ddc3a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $4a998843df0ddc3a$var$_exportNames = {
    chipClasses: true
};
Object.defineProperty(module.exports, "chipClasses", {
    enumerable: true,
    get: function() {
        return $4a998843df0ddc3a$var$_chipClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $4a998843df0ddc3a$var$_Chip.default;
    }
});

var $4a998843df0ddc3a$var$_Chip = $4a998843df0ddc3a$require$_interopRequireDefault((parcelRequire("6ami2")));

var $4a998843df0ddc3a$var$_chipClasses = $4a998843df0ddc3a$require$_interopRequireWildcard((parcelRequire("iNSYf")));
Object.keys($4a998843df0ddc3a$var$_chipClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($4a998843df0ddc3a$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $4a998843df0ddc3a$var$_chipClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4a998843df0ddc3a$var$_chipClasses[key];
        }
    });
});

});
parcelRegister("6ami2", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $47d4f79319086dc5$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $47d4f79319086dc5$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $47d4f79319086dc5$var$React = $47d4f79319086dc5$require$_interopRequireWildcard((parcelRequire("acw62")));

var $47d4f79319086dc5$var$_propTypes = $47d4f79319086dc5$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $47d4f79319086dc5$var$_clsx = $47d4f79319086dc5$require$_interopRequireDefault((parcelRequire("9QePP")));

var $47d4f79319086dc5$var$_composeClasses = $47d4f79319086dc5$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $47d4f79319086dc5$var$_Cancel = $47d4f79319086dc5$require$_interopRequireDefault((parcelRequire("8u0rE")));

var $47d4f79319086dc5$var$_useForkRef = $47d4f79319086dc5$require$_interopRequireDefault((parcelRequire("9Rgf1")));

var $47d4f79319086dc5$var$_unsupportedProp = $47d4f79319086dc5$require$_interopRequireDefault((parcelRequire("gUzNi")));

var $47d4f79319086dc5$var$_capitalize = $47d4f79319086dc5$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $47d4f79319086dc5$var$_ButtonBase = $47d4f79319086dc5$require$_interopRequireDefault((parcelRequire("hhs3r")));

var $aAbgT = parcelRequire("aAbgT");

var $47d4f79319086dc5$var$_memoTheme = $47d4f79319086dc5$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $47d4f79319086dc5$var$_createSimplePaletteValueFilter = $47d4f79319086dc5$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $hL1nr = parcelRequire("hL1nr");

var $47d4f79319086dc5$var$_chipClasses = $47d4f79319086dc5$require$_interopRequireWildcard((parcelRequire("iNSYf")));

var $47d4f79319086dc5$var$_useSlot = $47d4f79319086dc5$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $47d4f79319086dc5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, size: size, color: color, iconColor: iconColor, onDelete: onDelete, clickable: clickable, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            disabled && 'disabled',
            `size${(0, $47d4f79319086dc5$var$_capitalize.default)(size)}`,
            `color${(0, $47d4f79319086dc5$var$_capitalize.default)(color)}`,
            clickable && 'clickable',
            clickable && `clickableColor${(0, $47d4f79319086dc5$var$_capitalize.default)(color)}`,
            onDelete && 'deletable',
            onDelete && `deletableColor${(0, $47d4f79319086dc5$var$_capitalize.default)(color)}`,
            `${variant}${(0, $47d4f79319086dc5$var$_capitalize.default)(color)}`
        ],
        label: [
            'label',
            `label${(0, $47d4f79319086dc5$var$_capitalize.default)(size)}`
        ],
        avatar: [
            'avatar',
            `avatar${(0, $47d4f79319086dc5$var$_capitalize.default)(size)}`,
            `avatarColor${(0, $47d4f79319086dc5$var$_capitalize.default)(color)}`
        ],
        icon: [
            'icon',
            `icon${(0, $47d4f79319086dc5$var$_capitalize.default)(size)}`,
            `iconColor${(0, $47d4f79319086dc5$var$_capitalize.default)(iconColor)}`
        ],
        deleteIcon: [
            'deleteIcon',
            `deleteIcon${(0, $47d4f79319086dc5$var$_capitalize.default)(size)}`,
            `deleteIconColor${(0, $47d4f79319086dc5$var$_capitalize.default)(color)}`,
            `deleteIcon${(0, $47d4f79319086dc5$var$_capitalize.default)(variant)}Color${(0, $47d4f79319086dc5$var$_capitalize.default)(color)}`
        ]
    };
    return (0, $47d4f79319086dc5$var$_composeClasses.default)(slots, $47d4f79319086dc5$var$_chipClasses.getChipUtilityClass, classes);
};
const $47d4f79319086dc5$var$ChipRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiChip',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { color: color, iconColor: iconColor, clickable: clickable, onDelete: onDelete, size: size, variant: variant } = ownerState;
        return [
            {
                [`& .${$47d4f79319086dc5$var$_chipClasses.default.avatar}`]: styles.avatar
            },
            {
                [`& .${$47d4f79319086dc5$var$_chipClasses.default.avatar}`]: styles[`avatar${(0, $47d4f79319086dc5$var$_capitalize.default)(size)}`]
            },
            {
                [`& .${$47d4f79319086dc5$var$_chipClasses.default.avatar}`]: styles[`avatarColor${(0, $47d4f79319086dc5$var$_capitalize.default)(color)}`]
            },
            {
                [`& .${$47d4f79319086dc5$var$_chipClasses.default.icon}`]: styles.icon
            },
            {
                [`& .${$47d4f79319086dc5$var$_chipClasses.default.icon}`]: styles[`icon${(0, $47d4f79319086dc5$var$_capitalize.default)(size)}`]
            },
            {
                [`& .${$47d4f79319086dc5$var$_chipClasses.default.icon}`]: styles[`iconColor${(0, $47d4f79319086dc5$var$_capitalize.default)(iconColor)}`]
            },
            {
                [`& .${$47d4f79319086dc5$var$_chipClasses.default.deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${$47d4f79319086dc5$var$_chipClasses.default.deleteIcon}`]: styles[`deleteIcon${(0, $47d4f79319086dc5$var$_capitalize.default)(size)}`]
            },
            {
                [`& .${$47d4f79319086dc5$var$_chipClasses.default.deleteIcon}`]: styles[`deleteIconColor${(0, $47d4f79319086dc5$var$_capitalize.default)(color)}`]
            },
            {
                [`& .${$47d4f79319086dc5$var$_chipClasses.default.deleteIcon}`]: styles[`deleteIcon${(0, $47d4f79319086dc5$var$_capitalize.default)(variant)}Color${(0, $47d4f79319086dc5$var$_capitalize.default)(color)}`]
            },
            styles.root,
            styles[`size${(0, $47d4f79319086dc5$var$_capitalize.default)(size)}`],
            styles[`color${(0, $47d4f79319086dc5$var$_capitalize.default)(color)}`],
            clickable && styles.clickable,
            clickable && color !== 'default' && styles[`clickableColor${(0, $47d4f79319086dc5$var$_capitalize.default)(color)}`],
            onDelete && styles.deletable,
            onDelete && color !== 'default' && styles[`deletableColor${(0, $47d4f79319086dc5$var$_capitalize.default)(color)}`],
            styles[variant],
            styles[`${variant}${(0, $47d4f79319086dc5$var$_capitalize.default)(color)}`]
        ];
    }
})((0, $47d4f79319086dc5$var$_memoTheme.default)(({ theme: theme })=>{
    const textColor = theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.grey[300];
    return {
        maxWidth: '100%',
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 32,
        lineHeight: 1.5,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: 'nowrap',
        transition: theme.transitions.create([
            'background-color',
            'box-shadow'
        ]),
        // reset cursor explicitly in case ButtonBase is used
        cursor: 'unset',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: 'none',
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: 'middle',
        boxSizing: 'border-box',
        [`&.${$47d4f79319086dc5$var$_chipClasses.default.disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: 'none'
        },
        [`& .${$47d4f79319086dc5$var$_chipClasses.default.avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${$47d4f79319086dc5$var$_chipClasses.default.avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${$47d4f79319086dc5$var$_chipClasses.default.avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${$47d4f79319086dc5$var$_chipClasses.default.avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${$47d4f79319086dc5$var$_chipClasses.default.icon}`]: {
            marginLeft: 5,
            marginRight: -6
        },
        [`& .${$47d4f79319086dc5$var$_chipClasses.default.deleteIcon}`]: {
            WebkitTapHighlightColor: 'transparent',
            color: theme.alpha((theme.vars || theme).palette.text.primary, 0.26),
            fontSize: 22,
            cursor: 'pointer',
            margin: '0 5px 0 -6px',
            '&:hover': {
                color: theme.alpha((theme.vars || theme).palette.text.primary, 0.4)
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    height: 24,
                    [`& .${$47d4f79319086dc5$var$_chipClasses.default.icon}`]: {
                        fontSize: 18,
                        marginLeft: 4,
                        marginRight: -4
                    },
                    [`& .${$47d4f79319086dc5$var$_chipClasses.default.deleteIcon}`]: {
                        fontSize: 16,
                        marginRight: 4,
                        marginLeft: -4
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $47d4f79319086dc5$var$_createSimplePaletteValueFilter.default)([
                'contrastText'
            ])).map(([color])=>{
                return {
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        color: (theme.vars || theme).palette[color].contrastText,
                        [`& .${$47d4f79319086dc5$var$_chipClasses.default.deleteIcon}`]: {
                            color: theme.alpha((theme.vars || theme).palette[color].contrastText, 0.7),
                            '&:hover, &:active': {
                                color: (theme.vars || theme).palette[color].contrastText
                            }
                        }
                    }
                };
            }),
            {
                props: (props)=>props.iconColor === props.color,
                style: {
                    [`& .${$47d4f79319086dc5$var$_chipClasses.default.icon}`]: {
                        color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
                    }
                }
            },
            {
                props: (props)=>props.iconColor === props.color && props.color !== 'default',
                style: {
                    [`& .${$47d4f79319086dc5$var$_chipClasses.default.icon}`]: {
                        color: 'inherit'
                    }
                }
            },
            {
                props: {
                    onDelete: true
                },
                style: {
                    [`&.${$47d4f79319086dc5$var$_chipClasses.default.focusVisible}`]: {
                        backgroundColor: theme.alpha((theme.vars || theme).palette.action.selected, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $47d4f79319086dc5$var$_createSimplePaletteValueFilter.default)([
                'dark'
            ])).map(([color])=>{
                return {
                    props: {
                        color: color,
                        onDelete: true
                    },
                    style: {
                        [`&.${$47d4f79319086dc5$var$_chipClasses.default.focusVisible}`]: {
                            background: (theme.vars || theme).palette[color].dark
                        }
                    }
                };
            }),
            {
                props: {
                    clickable: true
                },
                style: {
                    userSelect: 'none',
                    WebkitTapHighlightColor: 'transparent',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: theme.alpha((theme.vars || theme).palette.action.selected, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`)
                    },
                    [`&.${$47d4f79319086dc5$var$_chipClasses.default.focusVisible}`]: {
                        backgroundColor: theme.alpha((theme.vars || theme).palette.action.selected, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
                    },
                    '&:active': {
                        boxShadow: (theme.vars || theme).shadows[1]
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $47d4f79319086dc5$var$_createSimplePaletteValueFilter.default)([
                'dark'
            ])).map(([color])=>({
                    props: {
                        color: color,
                        clickable: true
                    },
                    style: {
                        [`&:hover, &.${$47d4f79319086dc5$var$_chipClasses.default.focusVisible}`]: {
                            backgroundColor: (theme.vars || theme).palette[color].dark
                        }
                    }
                })),
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    backgroundColor: 'transparent',
                    border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[700]}`,
                    [`&.${$47d4f79319086dc5$var$_chipClasses.default.clickable}:hover`]: {
                        backgroundColor: (theme.vars || theme).palette.action.hover
                    },
                    [`&.${$47d4f79319086dc5$var$_chipClasses.default.focusVisible}`]: {
                        backgroundColor: (theme.vars || theme).palette.action.focus
                    },
                    [`& .${$47d4f79319086dc5$var$_chipClasses.default.avatar}`]: {
                        marginLeft: 4
                    },
                    [`& .${$47d4f79319086dc5$var$_chipClasses.default.avatarSmall}`]: {
                        marginLeft: 2
                    },
                    [`& .${$47d4f79319086dc5$var$_chipClasses.default.icon}`]: {
                        marginLeft: 4
                    },
                    [`& .${$47d4f79319086dc5$var$_chipClasses.default.iconSmall}`]: {
                        marginLeft: 2
                    },
                    [`& .${$47d4f79319086dc5$var$_chipClasses.default.deleteIcon}`]: {
                        marginRight: 5
                    },
                    [`& .${$47d4f79319086dc5$var$_chipClasses.default.deleteIconSmall}`]: {
                        marginRight: 3
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $47d4f79319086dc5$var$_createSimplePaletteValueFilter.default)()) // no need to check for mainChannel as it's calculated from main
            .map(([color])=>({
                    props: {
                        variant: 'outlined',
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main,
                        border: `1px solid ${theme.alpha((theme.vars || theme).palette[color].main, 0.7)}`,
                        [`&.${$47d4f79319086dc5$var$_chipClasses.default.clickable}:hover`]: {
                            backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity)
                        },
                        [`&.${$47d4f79319086dc5$var$_chipClasses.default.focusVisible}`]: {
                            backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.focusOpacity)
                        },
                        [`& .${$47d4f79319086dc5$var$_chipClasses.default.deleteIcon}`]: {
                            color: theme.alpha((theme.vars || theme).palette[color].main, 0.7),
                            '&:hover, &:active': {
                                color: (theme.vars || theme).palette[color].main
                            }
                        }
                    }
                }))
        ]
    };
}));
const $47d4f79319086dc5$var$ChipLabel = (0, $aAbgT.styled)('span', {
    name: 'MuiChip',
    slot: 'Label',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { size: size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, $47d4f79319086dc5$var$_capitalize.default)(size)}`]
        ];
    }
})({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingLeft: 12,
    paddingRight: 12,
    whiteSpace: 'nowrap',
    variants: [
        {
            props: {
                variant: 'outlined'
            },
            style: {
                paddingLeft: 11,
                paddingRight: 11
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                paddingLeft: 8,
                paddingRight: 8
            }
        },
        {
            props: {
                size: 'small',
                variant: 'outlined'
            },
            style: {
                paddingLeft: 7,
                paddingRight: 7
            }
        }
    ]
});
function $47d4f79319086dc5$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const $47d4f79319086dc5$var$Chip = /*#__PURE__*/ $47d4f79319086dc5$var$React.forwardRef(function Chip(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiChip'
    });
    const { avatar: avatarProp, className: className, clickable: clickableProp, color: color = 'default', component: ComponentProp, deleteIcon: deleteIconProp, disabled: disabled = false, icon: iconProp, label: label, onClick: onClick, onDelete: onDelete, onKeyDown: onKeyDown, onKeyUp: onKeyUp, size: size = 'medium', variant: variant = 'filled', tabIndex: tabIndex, skipFocusWhenDisabled: skipFocusWhenDisabled = false, slots: // TODO v6: Rename to `focusableWhenDisabled`.
    slots = {}, slotProps: slotProps = {}, ...other } = props;
    const chipRef = $47d4f79319086dc5$var$React.useRef(null);
    const handleRef = (0, $47d4f79319086dc5$var$_useForkRef.default)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $47d4f79319086dc5$var$isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $47d4f79319086dc5$var$isDeleteKeyboardEvent(event)) onDelete(event);
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? $47d4f79319086dc5$var$_ButtonBase.default : ComponentProp || 'div';
    const ownerState = {
        ...props,
        component: component,
        disabled: disabled,
        size: size,
        color: color,
        iconColor: /*#__PURE__*/ $47d4f79319086dc5$var$React.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable: clickable,
        variant: variant
    };
    const classes = $47d4f79319086dc5$var$useUtilityClasses(ownerState);
    const moreProps = component === $47d4f79319086dc5$var$_ButtonBase.default ? {
        component: ComponentProp || 'div',
        focusVisibleClassName: classes.focusVisible,
        ...onDelete && {
            disableRipple: true
        }
    } : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ $47d4f79319086dc5$var$React.isValidElement(deleteIconProp) ? /*#__PURE__*/ $47d4f79319086dc5$var$React.cloneElement(deleteIconProp, {
        className: (0, $47d4f79319086dc5$var$_clsx.default)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)($47d4f79319086dc5$var$_Cancel.default, {
        className: classes.deleteIcon,
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ $47d4f79319086dc5$var$React.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $47d4f79319086dc5$var$React.cloneElement(avatarProp, {
        className: (0, $47d4f79319086dc5$var$_clsx.default)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ $47d4f79319086dc5$var$React.isValidElement(iconProp)) icon = /*#__PURE__*/ $47d4f79319086dc5$var$React.cloneElement(iconProp, {
        className: (0, $47d4f79319086dc5$var$_clsx.default)(classes.icon, iconProp.props.className)
    });
    if (avatar && icon) console.error("MUI: The Chip component can not handle the avatar and the icon prop at the same time. Pick one.");
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootProps] = (0, $47d4f79319086dc5$var$_useSlot.default)('root', {
        elementType: $47d4f79319086dc5$var$ChipRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        // The `component` prop is preserved because `Chip` relies on it for internal logic. If `shouldForwardComponentProp` were `false`, `useSlot` would remove the `component` prop, potentially breaking the component's behavior.
        shouldForwardComponentProp: true,
        ref: handleRef,
        className: (0, $47d4f79319086dc5$var$_clsx.default)(classes.root, className),
        additionalProps: {
            disabled: clickable && disabled ? true : undefined,
            tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
            ...moreProps
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onClick: (event)=>{
                    handlers.onClick?.(event);
                    onClick?.(event);
                },
                onKeyDown: (event)=>{
                    handlers.onKeyDown?.(event);
                    handleKeyDown(event);
                },
                onKeyUp: (event)=>{
                    handlers.onKeyUp?.(event);
                    handleKeyUp(event);
                }
            })
    });
    const [LabelSlot, labelProps] = (0, $47d4f79319086dc5$var$_useSlot.default)('label', {
        elementType: $47d4f79319086dc5$var$ChipLabel,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.label
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        as: component,
        ...rootProps,
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, $ayMG0.jsx)(LabelSlot, {
                ...labelProps,
                children: label
            }),
            deleteIcon
        ]
    });
});
$47d4f79319086dc5$var$Chip.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The Avatar element to display.
   */ avatar: $47d4f79319086dc5$var$_propTypes.default.element,
    /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */ children: $47d4f79319086dc5$var$_unsupportedProp.default,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $47d4f79319086dc5$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $47d4f79319086dc5$var$_propTypes.default.string,
    /**
   * If `true`, the chip will appear clickable, and will raise when pressed,
   * even if the onClick prop is not defined.
   * If `false`, the chip will not appear clickable, even if onClick prop is defined.
   * This can be used, for example,
   * along with the component prop to indicate an anchor Chip is clickable.
   * Note: this controls the UI and does not affect the onClick event.
   */ clickable: $47d4f79319086dc5$var$_propTypes.default.bool,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */ color: $47d4f79319086dc5$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $47d4f79319086dc5$var$_propTypes.default.oneOf([
            'default',
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning'
        ]),
        $47d4f79319086dc5$var$_propTypes.default.string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $47d4f79319086dc5$var$_propTypes.default.elementType,
    /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */ deleteIcon: $47d4f79319086dc5$var$_propTypes.default.element,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: $47d4f79319086dc5$var$_propTypes.default.bool,
    /**
   * Icon element.
   */ icon: $47d4f79319086dc5$var$_propTypes.default.element,
    /**
   * The content of the component.
   */ label: $47d4f79319086dc5$var$_propTypes.default.node,
    /**
   * @ignore
   */ onClick: $47d4f79319086dc5$var$_propTypes.default.func,
    /**
   * Callback fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */ onDelete: $47d4f79319086dc5$var$_propTypes.default.func,
    /**
   * @ignore
   */ onKeyDown: $47d4f79319086dc5$var$_propTypes.default.func,
    /**
   * @ignore
   */ onKeyUp: $47d4f79319086dc5$var$_propTypes.default.func,
    /**
   * The size of the component.
   * @default 'medium'
   */ size: $47d4f79319086dc5$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $47d4f79319086dc5$var$_propTypes.default.oneOf([
            'medium',
            'small'
        ]),
        $47d4f79319086dc5$var$_propTypes.default.string
    ]),
    /**
   * If `true`, allows the disabled chip to escape focus.
   * If `false`, allows the disabled chip to receive focus.
   * @default false
   */ skipFocusWhenDisabled: $47d4f79319086dc5$var$_propTypes.default.bool,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $47d4f79319086dc5$var$_propTypes.default.shape({
        label: $47d4f79319086dc5$var$_propTypes.default.oneOfType([
            $47d4f79319086dc5$var$_propTypes.default.func,
            $47d4f79319086dc5$var$_propTypes.default.object
        ]),
        root: $47d4f79319086dc5$var$_propTypes.default.oneOfType([
            $47d4f79319086dc5$var$_propTypes.default.func,
            $47d4f79319086dc5$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: $47d4f79319086dc5$var$_propTypes.default.shape({
        label: $47d4f79319086dc5$var$_propTypes.default.elementType,
        root: $47d4f79319086dc5$var$_propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $47d4f79319086dc5$var$_propTypes.default.oneOfType([
        $47d4f79319086dc5$var$_propTypes.default.arrayOf($47d4f79319086dc5$var$_propTypes.default.oneOfType([
            $47d4f79319086dc5$var$_propTypes.default.func,
            $47d4f79319086dc5$var$_propTypes.default.object,
            $47d4f79319086dc5$var$_propTypes.default.bool
        ])),
        $47d4f79319086dc5$var$_propTypes.default.func,
        $47d4f79319086dc5$var$_propTypes.default.object
    ]),
    /**
   * @ignore
   */ tabIndex: $47d4f79319086dc5$var$_propTypes.default.number,
    /**
   * The variant to use.
   * @default 'filled'
   */ variant: $47d4f79319086dc5$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $47d4f79319086dc5$var$_propTypes.default.oneOf([
            'filled',
            'outlined'
        ]),
        $47d4f79319086dc5$var$_propTypes.default.string
    ])
};
var $47d4f79319086dc5$var$_default = module.exports.default = $47d4f79319086dc5$var$Chip;

});
parcelRegister("8u0rE", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $62d1787512a69c15$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $62d1787512a69c15$var$_createSvgIcon = $62d1787512a69c15$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $62d1787512a69c15$var$_default = module.exports.default = (0, $62d1787512a69c15$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel');

});

parcelRegister("iNSYf", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $db0771a9e6a32b1d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getChipUtilityClass = $db0771a9e6a32b1d$var$getChipUtilityClass;

var $db0771a9e6a32b1d$var$_generateUtilityClasses = $db0771a9e6a32b1d$require$_interopRequireDefault((parcelRequire("5nY49")));

var $db0771a9e6a32b1d$var$_generateUtilityClass = $db0771a9e6a32b1d$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $db0771a9e6a32b1d$var$getChipUtilityClass(slot) {
    return (0, $db0771a9e6a32b1d$var$_generateUtilityClass.default)('MuiChip', slot);
}
const $db0771a9e6a32b1d$var$chipClasses = (0, $db0771a9e6a32b1d$var$_generateUtilityClasses.default)('MuiChip', [
    'root',
    'sizeSmall',
    'sizeMedium',
    'colorDefault',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'clickable',
    'clickableColorPrimary',
    'clickableColorSecondary',
    'deletable',
    'deletableColorPrimary',
    'deletableColorSecondary',
    'outlined',
    'filled',
    'outlinedPrimary',
    'outlinedSecondary',
    'filledPrimary',
    'filledSecondary',
    'avatar',
    'avatarSmall',
    'avatarMedium',
    'avatarColorPrimary',
    'avatarColorSecondary',
    'icon',
    'iconSmall',
    'iconMedium',
    'iconColorPrimary',
    'iconColorSecondary',
    'label',
    'labelSmall',
    'labelMedium',
    'deleteIcon',
    'deleteIconSmall',
    'deleteIconMedium',
    'deleteIconColorPrimary',
    'deleteIconColorSecondary',
    'deleteIconOutlinedColorPrimary',
    'deleteIconOutlinedColorSecondary',
    'deleteIconFilledColorPrimary',
    'deleteIconFilledColorSecondary',
    'focusVisible'
]);
var $db0771a9e6a32b1d$var$_default = module.exports.default = $db0771a9e6a32b1d$var$chipClasses;

});

parcelRegister("6lpak", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $49e8399bd2388464$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $49e8399bd2388464$var$useSlot;

var $49e8399bd2388464$var$_useForkRef = $49e8399bd2388464$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $49e8399bd2388464$var$_appendOwnerState = $49e8399bd2388464$require$_interopRequireDefault((parcelRequire("fByHY")));

var $49e8399bd2388464$var$_resolveComponentProps = $49e8399bd2388464$require$_interopRequireDefault((parcelRequire("jzekU")));

var $49e8399bd2388464$var$_mergeSlotProps = $49e8399bd2388464$require$_interopRequireDefault((parcelRequire("dfy9C")));
/**
 * An internal function to create a Material UI slot.
 *
 * This is an advanced version of Base UI `useSlotProps` because Material UI allows leaf component to be customized via `component` prop
 * while Base UI does not need to support leaf component customization.
 *
 * @param {string} name: name of the slot
 * @param {object} parameters
 * @returns {[Slot, slotProps]} The slot's React component and the slot's props
 *
 * Note: the returned slot's props
 * - will never contain `component` prop.
 * - might contain `as` prop.
 */ function $49e8399bd2388464$var$useSlot(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, internalForwardedProps: internalForwardedProps, shouldForwardComponentProp: shouldForwardComponentProp = false, ...useSlotPropsParams } = parameters;
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    }, ...other } = externalForwardedProps;
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $49e8399bd2388464$var$_resolveComponentProps.default)(slotProps[name], ownerState);
    const { props: { component: slotComponent, ...mergedProps }, internalRef: internalRef } = (0, $49e8399bd2388464$var$_mergeSlotProps.default)({
        className: className,
        ...useSlotPropsParams,
        externalForwardedProps: name === 'root' ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $49e8399bd2388464$var$_useForkRef.default)(internalRef, resolvedComponentsProps?.ref, parameters.ref);
    const LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
    const props = (0, $49e8399bd2388464$var$_appendOwnerState.default)(elementType, {
        ...name === 'root' && !rootComponent && !slots[name] && internalForwardedProps,
        ...name !== 'root' && !slots[name] && internalForwardedProps,
        ...mergedProps,
        ...LeafComponent && !shouldForwardComponentProp && {
            as: LeafComponent
        },
        ...LeafComponent && shouldForwardComponentProp && {
            component: LeafComponent
        },
        ref: ref
    }, ownerState);
    return [
        elementType,
        props
    ];
}

});



parcelRegister("b3ugU", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $80c774dd7f29b734$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getInputUtilityClass = $80c774dd7f29b734$var$getInputUtilityClass;

var $80c774dd7f29b734$var$_generateUtilityClasses = $80c774dd7f29b734$require$_interopRequireDefault((parcelRequire("5nY49")));

var $80c774dd7f29b734$var$_generateUtilityClass = $80c774dd7f29b734$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $9MvHs = parcelRequire("9MvHs");
function $80c774dd7f29b734$var$getInputUtilityClass(slot) {
    return (0, $80c774dd7f29b734$var$_generateUtilityClass.default)('MuiInput', slot);
}
const $80c774dd7f29b734$var$inputClasses = {
    ...$9MvHs.inputBaseClasses,
    ...(0, $80c774dd7f29b734$var$_generateUtilityClasses.default)('MuiInput', [
        'root',
        'underline',
        'input'
    ])
};
var $80c774dd7f29b734$var$_default = module.exports.default = $80c774dd7f29b734$var$inputClasses;

});
parcelRegister("9MvHs", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $71f12fb6991c55a7$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $71f12fb6991c55a7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $71f12fb6991c55a7$var$_exportNames = {
    inputBaseClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $71f12fb6991c55a7$var$_InputBase.default;
    }
});
Object.defineProperty(module.exports, "inputBaseClasses", {
    enumerable: true,
    get: function() {
        return $71f12fb6991c55a7$var$_inputBaseClasses.default;
    }
});

var $71f12fb6991c55a7$var$_InputBase = $71f12fb6991c55a7$require$_interopRequireDefault((parcelRequire("95gUw")));

var $71f12fb6991c55a7$var$_inputBaseClasses = $71f12fb6991c55a7$require$_interopRequireWildcard((parcelRequire("dmljZ")));
Object.keys($71f12fb6991c55a7$var$_inputBaseClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($71f12fb6991c55a7$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $71f12fb6991c55a7$var$_inputBaseClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $71f12fb6991c55a7$var$_inputBaseClasses[key];
        }
    });
});

});
parcelRegister("95gUw", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $69d1b2c99a8dc649$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $69d1b2c99a8dc649$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rootOverridesResolver = module.exports.inputOverridesResolver = module.exports.default = module.exports.InputBaseRoot = module.exports.InputBaseInput = void 0;

var $69d1b2c99a8dc649$var$_formatMuiErrorMessage = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("4Z6Nd")));

var $69d1b2c99a8dc649$var$React = $69d1b2c99a8dc649$require$_interopRequireWildcard((parcelRequire("acw62")));

var $69d1b2c99a8dc649$var$_propTypes = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $69d1b2c99a8dc649$var$_clsx = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("9QePP")));

var $69d1b2c99a8dc649$var$_elementTypeAcceptingRef = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("g6PKz")));

var $69d1b2c99a8dc649$var$_refType = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("b3gjr")));

var $69d1b2c99a8dc649$var$_composeClasses = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $69d1b2c99a8dc649$var$_isHostComponent = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("7jqh1")));

var $69d1b2c99a8dc649$var$_TextareaAutosize = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("3vH0x")));

var $69d1b2c99a8dc649$var$_formControlState = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("aaphR")));

var $69d1b2c99a8dc649$var$_FormControlContext = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("blr6C")));

var $69d1b2c99a8dc649$var$_useFormControl = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("cJQfW")));

var $aAbgT = parcelRequire("aAbgT");

var $69d1b2c99a8dc649$var$_memoTheme = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $69d1b2c99a8dc649$var$_capitalize = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $69d1b2c99a8dc649$var$_useForkRef = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("9Rgf1")));

var $69d1b2c99a8dc649$var$_useEnhancedEffect = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("khjmj")));

var $69d1b2c99a8dc649$var$_ownerDocument = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("gzyUk")));

var $69d1b2c99a8dc649$var$_getActiveElement = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("6uU67")));

var $2BbKU = parcelRequire("2BbKU");

var $69d1b2c99a8dc649$var$_inputBaseClasses = $69d1b2c99a8dc649$require$_interopRequireWildcard((parcelRequire("dmljZ")));

var $ayMG0 = parcelRequire("ayMG0");
var $69d1b2c99a8dc649$var$_InputGlobalStyles;
const $69d1b2c99a8dc649$var$MUI_AUTO_FILL = 'mui-auto-fill';
const $69d1b2c99a8dc649$var$MUI_AUTO_FILL_CANCEL = 'mui-auto-fill-cancel';
const $69d1b2c99a8dc649$var$rootOverridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === 'small' && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $69d1b2c99a8dc649$var$_capitalize.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
module.exports.rootOverridesResolver = $69d1b2c99a8dc649$var$rootOverridesResolver;
const $69d1b2c99a8dc649$var$inputOverridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === 'small' && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === 'search' && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
module.exports.inputOverridesResolver = $69d1b2c99a8dc649$var$inputOverridesResolver;
const $69d1b2c99a8dc649$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $69d1b2c99a8dc649$var$_capitalize.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            fullWidth && 'fullWidth',
            focused && 'focused',
            formControl && 'formControl',
            size && size !== 'medium' && `size${(0, $69d1b2c99a8dc649$var$_capitalize.default)(size)}`,
            multiline && 'multiline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            hiddenLabel && 'hiddenLabel',
            readOnly && 'readOnly'
        ],
        input: [
            'input',
            disabled && 'disabled',
            type === 'search' && 'inputTypeSearch',
            multiline && 'inputMultiline',
            size === 'small' && 'inputSizeSmall',
            hiddenLabel && 'inputHiddenLabel',
            startAdornment && 'inputAdornedStart',
            endAdornment && 'inputAdornedEnd',
            readOnly && 'readOnly'
        ]
    };
    return (0, $69d1b2c99a8dc649$var$_composeClasses.default)(slots, $69d1b2c99a8dc649$var$_inputBaseClasses.getInputBaseUtilityClass, classes);
};
const $69d1b2c99a8dc649$var$InputBaseRoot = module.exports.InputBaseRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiInputBase',
    slot: 'Root',
    overridesResolver: $69d1b2c99a8dc649$var$rootOverridesResolver
})((0, $69d1b2c99a8dc649$var$_memoTheme.default)(({ theme: theme })=>({
        ...theme.typography.body1,
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '1.4375em',
        // 23px
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        position: 'relative',
        cursor: 'text',
        display: 'inline-flex',
        alignItems: 'center',
        [`&.${$69d1b2c99a8dc649$var$_inputBaseClasses.default.disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: 'default'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '4px 0 5px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    width: '100%'
                }
            }
        ]
    })));
const $69d1b2c99a8dc649$var$InputBaseInput = module.exports.InputBaseInput = (0, $aAbgT.styled)('input', {
    name: 'MuiInputBase',
    slot: 'Input',
    overridesResolver: $69d1b2c99a8dc649$var$inputOverridesResolver
})((0, $69d1b2c99a8dc649$var$_memoTheme.default)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    const placeholder = {
        color: 'currentColor',
        ...theme.vars ? {
            opacity: theme.vars.opacity.inputPlaceholder
        } : {
            opacity: light ? 0.42 : 0.5
        },
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    };
    const placeholderHidden = {
        opacity: '0 !important'
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return {
        font: 'inherit',
        letterSpacing: 'inherit',
        color: 'currentColor',
        padding: '4px 0 5px',
        border: 0,
        boxSizing: 'content-box',
        background: 'none',
        height: '1.4375em',
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: 'transparent',
        display: 'block',
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: '100%',
        '&::-webkit-input-placeholder': placeholder,
        '&::-moz-placeholder': placeholder,
        // Firefox 19+
        '&::-ms-input-placeholder': placeholder,
        // Edge
        '&:focus': {
            outline: 0
        },
        // Reset Firefox invalid required input style
        '&:invalid': {
            boxShadow: 'none'
        },
        '&::-webkit-search-decoration': {
            // Remove the padding when type=search.
            WebkitAppearance: 'none'
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${$69d1b2c99a8dc649$var$_inputBaseClasses.default.formControl} &`]: {
            '&::-webkit-input-placeholder': placeholderHidden,
            '&::-moz-placeholder': placeholderHidden,
            // Firefox 19+
            '&::-ms-input-placeholder': placeholderHidden,
            // Edge
            '&:focus::-webkit-input-placeholder': placeholderVisible,
            '&:focus::-moz-placeholder': placeholderVisible,
            // Firefox 19+
            '&:focus::-ms-input-placeholder': placeholderVisible // Edge
        },
        [`&.${$69d1b2c99a8dc649$var$_inputBaseClasses.default.disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableInjectingGlobalStyles,
                style: {
                    animationName: $69d1b2c99a8dc649$var$MUI_AUTO_FILL_CANCEL,
                    animationDuration: '10ms',
                    '&:-webkit-autofill': {
                        animationDuration: '5000s',
                        animationName: $69d1b2c99a8dc649$var$MUI_AUTO_FILL
                    }
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    height: 'auto',
                    resize: 'none',
                    padding: 0,
                    paddingTop: 0
                }
            },
            {
                props: {
                    type: 'search'
                },
                style: {
                    MozAppearance: 'textfield' // Improve type search style.
                }
            }
        ]
    };
}));
const $69d1b2c99a8dc649$var$InputGlobalStyles = (0, $aAbgT.globalCss)({
    // Keep keyframes non-empty for Emotion production builds. Animation properties are ignored
    // inside keyframes, avoiding the visible display animation triggered by Chrome 117+.
    [`@keyframes ${$69d1b2c99a8dc649$var$MUI_AUTO_FILL}`]: {
        from: {
            animationName: $69d1b2c99a8dc649$var$MUI_AUTO_FILL
        }
    },
    [`@keyframes ${$69d1b2c99a8dc649$var$MUI_AUTO_FILL_CANCEL}`]: {
        from: {
            animationName: $69d1b2c99a8dc649$var$MUI_AUTO_FILL_CANCEL
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $69d1b2c99a8dc649$var$InputBase = /*#__PURE__*/ $69d1b2c99a8dc649$var$React.forwardRef(function InputBase(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiInputBase'
    });
    const { 'aria-describedby': ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, color: color, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, error: error, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = 'input', inputProps: inputPropsProp = {}, inputRef: inputRefProp, margin: margin, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, size: size, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = 'text', value: valueProp, ...other } = props;
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $69d1b2c99a8dc649$var$React.useRef(value != null);
    const inputRef = $69d1b2c99a8dc649$var$React.useRef();
    const handleInputRefWarning = $69d1b2c99a8dc649$var$React.useCallback((instance)=>{
        if (instance && instance.nodeName !== 'INPUT' && !instance.focus) console.error([
            'MUI: You have provided a `inputComponent` to the input component',
            'that does not correctly handle the `ref` prop.',
            'Make sure the `ref` prop is called with a HTMLInputElement.'
        ].join('\n'));
    }, []);
    const handleInputRef = (0, $69d1b2c99a8dc649$var$_useForkRef.default)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $69d1b2c99a8dc649$var$React.useState(false);
    const muiFormControl = (0, $69d1b2c99a8dc649$var$_useFormControl.default)();
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $69d1b2c99a8dc649$var$React.useEffect(()=>{
        if (muiFormControl) return muiFormControl.registerEffect();
        return undefined;
    }, [
        muiFormControl
    ]);
    const fcs = (0, $69d1b2c99a8dc649$var$_formControlState.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'size',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $69d1b2c99a8dc649$var$React.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $69d1b2c99a8dc649$var$React.useCallback((obj)=>{
        if ((0, $2BbKU.isFilled)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $69d1b2c99a8dc649$var$_useEnhancedEffect.default)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    // Sync focused state when autoFocus is used in SSR.
    // If the browser focused the element before hydration, the onFocus handler never
    // fires. If it did not, React hydration does not call focus() for autoFocus.
    (0, $69d1b2c99a8dc649$var$_useEnhancedEffect.default)(()=>{
        if (!autoFocus) return;
        const input = inputRef.current;
        if (!input) return;
        const doc = (0, $69d1b2c99a8dc649$var$_ownerDocument.default)(input);
        const activeElement = (0, $69d1b2c99a8dc649$var$_getActiveElement.default)(doc);
        const noElementFocused = activeElement == null || activeElement === doc.body || activeElement === doc.documentElement;
        if (input === activeElement) {
            if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus();
            else setFocused(true);
        } else if (noElementFocused) input.focus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        autoFocus
    ]);
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error("MUI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info.");
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $69d1b2c99a8dc649$var$React.useEffect(()=>{
        checkDirty(inputRef.current);
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === 'input') {
        if (rows) {
            if (minRows || maxRows) console.warn('MUI: You can not use the `minRows` or `maxRows` props when the input `rows` prop is set.');
            inputProps = {
                type: undefined,
                minRows: rows,
                maxRows: rows,
                ...inputProps
            };
        } else inputProps = {
            type: undefined,
            maxRows: maxRows,
            minRows: minRows,
            ...inputProps
        };
        InputComponent = $69d1b2c99a8dc649$var$_TextareaAutosize.default;
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === $69d1b2c99a8dc649$var$MUI_AUTO_FILL_CANCEL ? inputRef.current : {
            value: 'x'
        });
    };
    $69d1b2c99a8dc649$var$React.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    };
    const classes = $69d1b2c99a8dc649$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $69d1b2c99a8dc649$var$InputBaseRoot;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $69d1b2c99a8dc649$var$InputBaseInput;
    inputProps = {
        ...inputProps,
        ...slotProps.input ?? componentsProps.input
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($69d1b2c99a8dc649$var$React.Fragment, {
        children: [
            !disableInjectingGlobalStyles && typeof $69d1b2c99a8dc649$var$InputGlobalStyles === 'function' && // For Pigment CSS, this has no effect because the InputGlobalStyles will be null.
            ($69d1b2c99a8dc649$var$_InputGlobalStyles || ($69d1b2c99a8dc649$var$_InputGlobalStyles = /*#__PURE__*/ (0, $ayMG0.jsx)($69d1b2c99a8dc649$var$InputGlobalStyles, {}))),
            /*#__PURE__*/ (0, $ayMG0.jsxs)(Root, {
                ...rootProps,
                ref: ref,
                onClick: handleClick,
                ...other,
                ...!(0, $69d1b2c99a8dc649$var$_isHostComponent.default)(Root) && {
                    ownerState: {
                        ...ownerState,
                        ...rootProps.ownerState
                    }
                },
                className: (0, $69d1b2c99a8dc649$var$_clsx.default)(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $ayMG0.jsx)($69d1b2c99a8dc649$var$_FormControlContext.default.Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Input, {
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type,
                            ...inputProps,
                            ...!(0, $69d1b2c99a8dc649$var$_isHostComponent.default)(Input) && {
                                as: InputComponent,
                                ownerState: {
                                    ...ownerState,
                                    ...inputProps.ownerState
                                }
                            },
                            ref: handleInputRef,
                            className: (0, $69d1b2c99a8dc649$var$_clsx.default)(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        })
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix({
                        ...fcs,
                        startAdornment: startAdornment
                    }) : null
                ]
            })
        ]
    });
});
$69d1b2c99a8dc649$var$InputBase.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * @ignore
   */ 'aria-describedby': $69d1b2c99a8dc649$var$_propTypes.default.string,
    /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */ autoComplete: $69d1b2c99a8dc649$var$_propTypes.default.string,
    /**
   * If `true`, the `input` element is focused during the first mount.
   */ autoFocus: $69d1b2c99a8dc649$var$_propTypes.default.bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $69d1b2c99a8dc649$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $69d1b2c99a8dc649$var$_propTypes.default.string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */ color: $69d1b2c99a8dc649$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $69d1b2c99a8dc649$var$_propTypes.default.oneOf([
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning'
        ]),
        $69d1b2c99a8dc649$var$_propTypes.default.string
    ]),
    /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */ components: $69d1b2c99a8dc649$var$_propTypes.default.shape({
        Input: $69d1b2c99a8dc649$var$_propTypes.default.elementType,
        Root: $69d1b2c99a8dc649$var$_propTypes.default.elementType
    }),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */ componentsProps: $69d1b2c99a8dc649$var$_propTypes.default.shape({
        input: $69d1b2c99a8dc649$var$_propTypes.default.object,
        root: $69d1b2c99a8dc649$var$_propTypes.default.object
    }),
    /**
   * The default value. Use when the component is not controlled.
   */ defaultValue: $69d1b2c99a8dc649$var$_propTypes.default.any,
    /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ disabled: $69d1b2c99a8dc649$var$_propTypes.default.bool,
    /**
   * If `true`, GlobalStyles for the auto-fill keyframes will not be injected/removed on mount/unmount. Make sure to inject them at the top of your application.
   * This option is intended to help with boosting the initial rendering performance if you are loading a big amount of Input components at once.
   * @default false
   */ disableInjectingGlobalStyles: $69d1b2c99a8dc649$var$_propTypes.default.bool,
    /**
   * End `InputAdornment` for this component.
   */ endAdornment: $69d1b2c99a8dc649$var$_propTypes.default.node,
    /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ error: $69d1b2c99a8dc649$var$_propTypes.default.bool,
    /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */ fullWidth: $69d1b2c99a8dc649$var$_propTypes.default.bool,
    /**
   * The id of the `input` element.
   */ id: $69d1b2c99a8dc649$var$_propTypes.default.string,
    /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */ inputComponent: $69d1b2c99a8dc649$var$_elementTypeAcceptingRef.default,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   * @default {}
   */ inputProps: $69d1b2c99a8dc649$var$_propTypes.default.object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: $69d1b2c99a8dc649$var$_refType.default,
    /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */ margin: $69d1b2c99a8dc649$var$_propTypes.default.oneOf([
        'dense',
        'none'
    ]),
    /**
   * Maximum number of rows to display when multiline option is set to true.
   */ maxRows: $69d1b2c99a8dc649$var$_propTypes.default.oneOfType([
        $69d1b2c99a8dc649$var$_propTypes.default.number,
        $69d1b2c99a8dc649$var$_propTypes.default.string
    ]),
    /**
   * Minimum number of rows to display when multiline option is set to true.
   */ minRows: $69d1b2c99a8dc649$var$_propTypes.default.oneOfType([
        $69d1b2c99a8dc649$var$_propTypes.default.number,
        $69d1b2c99a8dc649$var$_propTypes.default.string
    ]),
    /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */ multiline: $69d1b2c99a8dc649$var$_propTypes.default.bool,
    /**
   * Name attribute of the `input` element.
   */ name: $69d1b2c99a8dc649$var$_propTypes.default.string,
    /**
   * Callback fired when the `input` is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */ onBlur: $69d1b2c99a8dc649$var$_propTypes.default.func,
    /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */ onChange: $69d1b2c99a8dc649$var$_propTypes.default.func,
    /**
   * @ignore
   */ onClick: $69d1b2c99a8dc649$var$_propTypes.default.func,
    /**
   * @ignore
   */ onFocus: $69d1b2c99a8dc649$var$_propTypes.default.func,
    /**
   * Callback fired when the `input` doesn't satisfy its constraints.
   */ onInvalid: $69d1b2c99a8dc649$var$_propTypes.default.func,
    /**
   * @ignore
   */ onKeyDown: $69d1b2c99a8dc649$var$_propTypes.default.func,
    /**
   * @ignore
   */ onKeyUp: $69d1b2c99a8dc649$var$_propTypes.default.func,
    /**
   * The short hint displayed in the `input` before the user enters a value.
   */ placeholder: $69d1b2c99a8dc649$var$_propTypes.default.string,
    /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */ readOnly: $69d1b2c99a8dc649$var$_propTypes.default.bool,
    /**
   * @ignore
   */ renderSuffix: $69d1b2c99a8dc649$var$_propTypes.default.func,
    /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ required: $69d1b2c99a8dc649$var$_propTypes.default.bool,
    /**
   * Number of rows to display when multiline option is set to true.
   */ rows: $69d1b2c99a8dc649$var$_propTypes.default.oneOfType([
        $69d1b2c99a8dc649$var$_propTypes.default.number,
        $69d1b2c99a8dc649$var$_propTypes.default.string
    ]),
    /**
   * The size of the component.
   */ size: $69d1b2c99a8dc649$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $69d1b2c99a8dc649$var$_propTypes.default.oneOf([
            'medium',
            'small'
        ]),
        $69d1b2c99a8dc649$var$_propTypes.default.string
    ]),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slotProps: $69d1b2c99a8dc649$var$_propTypes.default.shape({
        input: $69d1b2c99a8dc649$var$_propTypes.default.object,
        root: $69d1b2c99a8dc649$var$_propTypes.default.object
    }),
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slots: $69d1b2c99a8dc649$var$_propTypes.default.shape({
        input: $69d1b2c99a8dc649$var$_propTypes.default.elementType,
        root: $69d1b2c99a8dc649$var$_propTypes.default.elementType
    }),
    /**
   * Start `InputAdornment` for this component.
   */ startAdornment: $69d1b2c99a8dc649$var$_propTypes.default.node,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $69d1b2c99a8dc649$var$_propTypes.default.oneOfType([
        $69d1b2c99a8dc649$var$_propTypes.default.arrayOf($69d1b2c99a8dc649$var$_propTypes.default.oneOfType([
            $69d1b2c99a8dc649$var$_propTypes.default.func,
            $69d1b2c99a8dc649$var$_propTypes.default.object,
            $69d1b2c99a8dc649$var$_propTypes.default.bool
        ])),
        $69d1b2c99a8dc649$var$_propTypes.default.func,
        $69d1b2c99a8dc649$var$_propTypes.default.object
    ]),
    /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#input_types).
   * @default 'text'
   */ type: $69d1b2c99a8dc649$var$_propTypes.default.string,
    /**
   * The value of the `input` element, required for a controlled component.
   */ value: $69d1b2c99a8dc649$var$_propTypes.default.any
};
var $69d1b2c99a8dc649$var$_default = module.exports.default = $69d1b2c99a8dc649$var$InputBase;

});
parcelRegister("3vH0x", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $28e5a0c586f490cf$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $28e5a0c586f490cf$var$_TextareaAutosize.default;
    }
});

var $28e5a0c586f490cf$var$_TextareaAutosize = $28e5a0c586f490cf$require$_interopRequireDefault((parcelRequire("gSRTE")));

});
parcelRegister("gSRTE", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $032c0e7078a9cb7d$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $032c0e7078a9cb7d$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $032c0e7078a9cb7d$var$React = $032c0e7078a9cb7d$require$_interopRequireWildcard((parcelRequire("acw62")));

var $032c0e7078a9cb7d$var$_propTypes = $032c0e7078a9cb7d$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $032c0e7078a9cb7d$var$_debounce = $032c0e7078a9cb7d$require$_interopRequireDefault((parcelRequire("9NXOO")));

var $032c0e7078a9cb7d$var$_useForkRef = $032c0e7078a9cb7d$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $032c0e7078a9cb7d$var$_useEnhancedEffect = $032c0e7078a9cb7d$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $032c0e7078a9cb7d$var$_useEventCallback = $032c0e7078a9cb7d$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $032c0e7078a9cb7d$var$_ownerWindow = $032c0e7078a9cb7d$require$_interopRequireDefault((parcelRequire("4Rhws")));

var $ayMG0 = parcelRequire("ayMG0");
function $032c0e7078a9cb7d$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $032c0e7078a9cb7d$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
function $032c0e7078a9cb7d$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
function $032c0e7078a9cb7d$var$isEmpty(obj) {
    return $032c0e7078a9cb7d$var$isObjectEmpty(obj) || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://v7.mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://v7.mui.com/material-ui/api/textarea-autosize/)
 */ const $032c0e7078a9cb7d$var$TextareaAutosize = /*#__PURE__*/ $032c0e7078a9cb7d$var$React.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value, ...other } = props;
    const { current: isControlled } = $032c0e7078a9cb7d$var$React.useRef(value != null);
    const textareaRef = $032c0e7078a9cb7d$var$React.useRef(null);
    const handleRef = (0, $032c0e7078a9cb7d$var$_useForkRef.default)(forwardedRef, textareaRef);
    const heightRef = $032c0e7078a9cb7d$var$React.useRef(null);
    const hiddenTextareaRef = $032c0e7078a9cb7d$var$React.useRef(null);
    const calculateTextareaStyles = $032c0e7078a9cb7d$var$React.useCallback(()=>{
        const textarea = textareaRef.current;
        const hiddenTextarea = hiddenTextareaRef.current;
        if (!textarea || !hiddenTextarea) return undefined;
        const containerWindow = (0, $032c0e7078a9cb7d$var$_ownerWindow.default)(textarea);
        const computedStyle = containerWindow.getComputedStyle(textarea);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === '0px') return {
            outerHeightStyle: 0,
            overflowing: false
        };
        hiddenTextarea.style.width = computedStyle.width;
        hiddenTextarea.value = textarea.value || props.placeholder || 'x';
        if (hiddenTextarea.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        hiddenTextarea.value += ' ';
        const boxSizing = computedStyle.boxSizing;
        const padding = $032c0e7078a9cb7d$var$getStyleValue(computedStyle.paddingBottom) + $032c0e7078a9cb7d$var$getStyleValue(computedStyle.paddingTop);
        const border = $032c0e7078a9cb7d$var$getStyleValue(computedStyle.borderBottomWidth) + $032c0e7078a9cb7d$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = hiddenTextarea.scrollHeight;
        // Measure height of a textarea with a single row
        hiddenTextarea.value = 'x';
        const singleRowHeight = hiddenTextarea.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const didHeightChange = (0, $032c0e7078a9cb7d$var$_useEventCallback.default)(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $032c0e7078a9cb7d$var$isEmpty(textareaStyles)) return false;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        return heightRef.current != null && heightRef.current !== outerHeightStyle;
    });
    const syncHeight = $032c0e7078a9cb7d$var$React.useCallback(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $032c0e7078a9cb7d$var$isEmpty(textareaStyles)) return;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        if (heightRef.current !== outerHeightStyle) {
            heightRef.current = outerHeightStyle;
            textarea.style.height = `${outerHeightStyle}px`;
        }
        textarea.style.overflow = textareaStyles.overflowing ? 'hidden' : '';
    }, [
        calculateTextareaStyles
    ]);
    const frameRef = $032c0e7078a9cb7d$var$React.useRef(-1);
    (0, $032c0e7078a9cb7d$var$_useEnhancedEffect.default)(()=>{
        const debouncedHandleResize = (0, $032c0e7078a9cb7d$var$_debounce.default)(syncHeight);
        const textarea = textareaRef?.current;
        if (!textarea) return undefined;
        const containerWindow = (0, $032c0e7078a9cb7d$var$_ownerWindow.default)(textarea);
        containerWindow.addEventListener('resize', debouncedHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(()=>{
                if (didHeightChange()) {
                    // avoid "ResizeObserver loop completed with undelivered notifications" error
                    // by temporarily unobserving the textarea element while manipulating the height
                    // and reobserving one frame later
                    resizeObserver.unobserve(textarea);
                    cancelAnimationFrame(frameRef.current);
                    syncHeight();
                    frameRef.current = requestAnimationFrame(()=>{
                        resizeObserver.observe(textarea);
                    });
                }
            });
            resizeObserver.observe(textarea);
        }
        return ()=>{
            debouncedHandleResize.clear();
            cancelAnimationFrame(frameRef.current);
            containerWindow.removeEventListener('resize', debouncedHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight,
        didHeightChange
    ]);
    (0, $032c0e7078a9cb7d$var$_useEnhancedEffect.default)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        const textarea = event.target;
        const countOfCharacters = textarea.value.length;
        const isLastCharacterNewLine = textarea.value.endsWith('\n');
        const isEndOfTheLine = textarea.selectionStart === countOfCharacters;
        // Set the cursor position to the very end of the text.
        if (isLastCharacterNewLine && isEndOfTheLine) textarea.setSelectionRange(countOfCharacters, countOfCharacters);
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($032c0e7078a9cb7d$var$React.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style,
                ...other
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: hiddenTextareaRef,
                tabIndex: -1,
                style: {
                    ...$032c0e7078a9cb7d$var$styles.shadow,
                    ...style,
                    paddingTop: 0,
                    paddingBottom: 0
                }
            })
        ]
    });
});
$032c0e7078a9cb7d$var$TextareaAutosize.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * @ignore
   */ className: $032c0e7078a9cb7d$var$_propTypes.default.string,
    /**
   * Maximum number of rows to display.
   */ maxRows: $032c0e7078a9cb7d$var$_propTypes.default.oneOfType([
        $032c0e7078a9cb7d$var$_propTypes.default.number,
        $032c0e7078a9cb7d$var$_propTypes.default.string
    ]),
    /**
   * Minimum number of rows to display.
   * @default 1
   */ minRows: $032c0e7078a9cb7d$var$_propTypes.default.oneOfType([
        $032c0e7078a9cb7d$var$_propTypes.default.number,
        $032c0e7078a9cb7d$var$_propTypes.default.string
    ]),
    /**
   * @ignore
   */ onChange: $032c0e7078a9cb7d$var$_propTypes.default.func,
    /**
   * @ignore
   */ placeholder: $032c0e7078a9cb7d$var$_propTypes.default.string,
    /**
   * @ignore
   */ style: $032c0e7078a9cb7d$var$_propTypes.default.object,
    /**
   * @ignore
   */ value: $032c0e7078a9cb7d$var$_propTypes.default.oneOfType([
        $032c0e7078a9cb7d$var$_propTypes.default.arrayOf($032c0e7078a9cb7d$var$_propTypes.default.string),
        $032c0e7078a9cb7d$var$_propTypes.default.number,
        $032c0e7078a9cb7d$var$_propTypes.default.string
    ])
};
var $032c0e7078a9cb7d$var$_default = module.exports.default = $032c0e7078a9cb7d$var$TextareaAutosize;

});


parcelRegister("aaphR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $766e740713576b8d$var$formControlState;
function $766e740713576b8d$var$formControlState({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}

});

parcelRegister("blr6C", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $8426ae8303951a73$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8426ae8303951a73$var$React = $8426ae8303951a73$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * @ignore - internal component.
 */ const $8426ae8303951a73$var$FormControlContext = /*#__PURE__*/ $8426ae8303951a73$var$React.createContext(undefined);
$8426ae8303951a73$var$FormControlContext.displayName = 'FormControlContext';
var $8426ae8303951a73$var$_default = module.exports.default = $8426ae8303951a73$var$FormControlContext;

});

parcelRegister("cJQfW", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $946238fa82894619$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $946238fa82894619$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $946238fa82894619$var$useFormControl;

var $946238fa82894619$var$React = $946238fa82894619$require$_interopRequireWildcard((parcelRequire("acw62")));

var $946238fa82894619$var$_FormControlContext = $946238fa82894619$require$_interopRequireDefault((parcelRequire("blr6C")));
function $946238fa82894619$var$useFormControl() {
    return $946238fa82894619$var$React.useContext($946238fa82894619$var$_FormControlContext.default);
}

});

parcelRegister("6uU67", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $4bb10f3e537aa943$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4bb10f3e537aa943$var$_getActiveElement = $4bb10f3e537aa943$require$_interopRequireDefault((parcelRequire("auqlt")));
var $4bb10f3e537aa943$var$_default = module.exports.default = $4bb10f3e537aa943$var$_getActiveElement.default;

});
parcelRegister("auqlt", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $7a312461c420a305$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $7a312461c420a305$var$_getActiveElement.default;
    }
});

var $7a312461c420a305$var$_getActiveElement = $7a312461c420a305$require$_interopRequireDefault((parcelRequire("ffAmm")));

});
parcelRegister("ffAmm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b1a47605ee2f1b8f$var$activeElement;
/**
 * Gets the actual active element, traversing through shadow roots if necessary.
 *
 * When an element inside a shadow root has focus, `document.activeElement` returns
 * the shadow host element. This function recursively traverses shadow roots to find
 * the actual focused element.
 *
 * @param root - The document or shadow root to start the search from.
 * @returns The actual focused element, or null if no element has focus.
 *
 * @example
 * // In a shadow DOM context
 * const activeElement = getActiveElement(document);
 * // Returns the actual focused element inside the shadow root
 *
 * @example
 * // Starting from a specific document
 * const activeElement = getActiveElement(ownerDocument(element));
 */ function $b1a47605ee2f1b8f$var$activeElement(doc) {
    let element = doc.activeElement;
    while(element?.shadowRoot?.activeElement != null)element = element.shadowRoot.activeElement;
    return element;
}

});



parcelRegister("2BbKU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hasValue = $1e4827e2a850b1f0$var$hasValue;
module.exports.isAdornedStart = $1e4827e2a850b1f0$var$isAdornedStart;
module.exports.isFilled = $1e4827e2a850b1f0$var$isFilled;
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $1e4827e2a850b1f0$var$hasValue(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
// Determine if field is empty or filled.
// Response determines if label is presented above field or as placeholder.
//
// @param obj
// @param SSR
// @returns {boolean} False when not present or empty string.
//                    True when any number or string with length.
function $1e4827e2a850b1f0$var$isFilled(obj, SSR = false) {
    return obj && ($1e4827e2a850b1f0$var$hasValue(obj.value) && obj.value !== '' || SSR && $1e4827e2a850b1f0$var$hasValue(obj.defaultValue) && obj.defaultValue !== '');
}
// Determine if an Input is adorned on start.
// It's corresponding to the left with LTR.
//
// @param obj
// @returns {boolean} False when no adornments.
//                    True when adorned at the start.
function $1e4827e2a850b1f0$var$isAdornedStart(obj) {
    return obj.startAdornment;
}

});

parcelRegister("dmljZ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9b9dde6aa920e08c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getInputBaseUtilityClass = $9b9dde6aa920e08c$var$getInputBaseUtilityClass;

var $9b9dde6aa920e08c$var$_generateUtilityClasses = $9b9dde6aa920e08c$require$_interopRequireDefault((parcelRequire("5nY49")));

var $9b9dde6aa920e08c$var$_generateUtilityClass = $9b9dde6aa920e08c$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $9b9dde6aa920e08c$var$getInputBaseUtilityClass(slot) {
    return (0, $9b9dde6aa920e08c$var$_generateUtilityClass.default)('MuiInputBase', slot);
}
const $9b9dde6aa920e08c$var$inputBaseClasses = (0, $9b9dde6aa920e08c$var$_generateUtilityClasses.default)('MuiInputBase', [
    'root',
    'formControl',
    'focused',
    'disabled',
    'adornedStart',
    'adornedEnd',
    'error',
    'sizeSmall',
    'multiline',
    'colorSecondary',
    'fullWidth',
    'hiddenLabel',
    'readOnly',
    'input',
    'inputSizeSmall',
    'inputMultiline',
    'inputTypeSearch',
    'inputAdornedStart',
    'inputAdornedEnd',
    'inputHiddenLabel'
]);
var $9b9dde6aa920e08c$var$_default = module.exports.default = $9b9dde6aa920e08c$var$inputBaseClasses;

});




parcelRegister("96QZi", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $6a1dc6d1d7e1816a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getOutlinedInputUtilityClass = $6a1dc6d1d7e1816a$var$getOutlinedInputUtilityClass;

var $6a1dc6d1d7e1816a$var$_generateUtilityClasses = $6a1dc6d1d7e1816a$require$_interopRequireDefault((parcelRequire("5nY49")));

var $6a1dc6d1d7e1816a$var$_generateUtilityClass = $6a1dc6d1d7e1816a$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $9MvHs = parcelRequire("9MvHs");
function $6a1dc6d1d7e1816a$var$getOutlinedInputUtilityClass(slot) {
    return (0, $6a1dc6d1d7e1816a$var$_generateUtilityClass.default)('MuiOutlinedInput', slot);
}
const $6a1dc6d1d7e1816a$var$outlinedInputClasses = {
    ...$9MvHs.inputBaseClasses,
    ...(0, $6a1dc6d1d7e1816a$var$_generateUtilityClasses.default)('MuiOutlinedInput', [
        'root',
        'notchedOutline',
        'input'
    ])
};
var $6a1dc6d1d7e1816a$var$_default = module.exports.default = $6a1dc6d1d7e1816a$var$outlinedInputClasses;

});

parcelRegister("faAxf", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $b0b42157daacd8b1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getFilledInputUtilityClass = $b0b42157daacd8b1$var$getFilledInputUtilityClass;

var $b0b42157daacd8b1$var$_generateUtilityClasses = $b0b42157daacd8b1$require$_interopRequireDefault((parcelRequire("5nY49")));

var $b0b42157daacd8b1$var$_generateUtilityClass = $b0b42157daacd8b1$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $9MvHs = parcelRequire("9MvHs");
function $b0b42157daacd8b1$var$getFilledInputUtilityClass(slot) {
    return (0, $b0b42157daacd8b1$var$_generateUtilityClass.default)('MuiFilledInput', slot);
}
const $b0b42157daacd8b1$var$filledInputClasses = {
    ...$9MvHs.inputBaseClasses,
    ...(0, $b0b42157daacd8b1$var$_generateUtilityClasses.default)('MuiFilledInput', [
        'root',
        'underline',
        'input',
        'adornedStart',
        'adornedEnd',
        'sizeSmall',
        'multiline',
        'hiddenLabel'
    ])
};
var $b0b42157daacd8b1$var$_default = module.exports.default = $b0b42157daacd8b1$var$filledInputClasses;

});

parcelRegister("ldBGF", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $f7280bbf95507cba$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f7280bbf95507cba$var$_createSvgIcon = $f7280bbf95507cba$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 *
 * Alias to `Clear`.
 */ var $f7280bbf95507cba$var$_default = module.exports.default = (0, $f7280bbf95507cba$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

});

parcelRegister("7LRfY", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $5a863bd9b12ca76b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5a863bd9b12ca76b$var$_createSvgIcon = $5a863bd9b12ca76b$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $5a863bd9b12ca76b$var$_default = module.exports.default = (0, $5a863bd9b12ca76b$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');

});

parcelRegister("9O25J", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $723a67e53eb4dc4c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getAutocompleteUtilityClass = $723a67e53eb4dc4c$var$getAutocompleteUtilityClass;

var $723a67e53eb4dc4c$var$_generateUtilityClasses = $723a67e53eb4dc4c$require$_interopRequireDefault((parcelRequire("5nY49")));

var $723a67e53eb4dc4c$var$_generateUtilityClass = $723a67e53eb4dc4c$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $723a67e53eb4dc4c$var$getAutocompleteUtilityClass(slot) {
    return (0, $723a67e53eb4dc4c$var$_generateUtilityClass.default)('MuiAutocomplete', slot);
}
const $723a67e53eb4dc4c$var$autocompleteClasses = (0, $723a67e53eb4dc4c$var$_generateUtilityClasses.default)('MuiAutocomplete', [
    'root',
    'expanded',
    'fullWidth',
    'focused',
    'focusVisible',
    'tag',
    'tagSizeSmall',
    'tagSizeMedium',
    'hasPopupIcon',
    'hasClearIcon',
    'inputRoot',
    'input',
    'inputFocused',
    'endAdornment',
    'clearIndicator',
    'popupIndicator',
    'popupIndicatorOpen',
    'popper',
    'popperDisablePortal',
    'paper',
    'listbox',
    'loading',
    'noOptions',
    'option',
    'groupLabel',
    'groupUl'
]);
var $723a67e53eb4dc4c$var$_default = module.exports.default = $723a67e53eb4dc4c$var$autocompleteClasses;

});



parcelRegister("lgIyK", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $f7bda82e26c407eb$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $f7bda82e26c407eb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $f7bda82e26c407eb$var$_exportNames = {
    badgeClasses: true
};
Object.defineProperty(module.exports, "badgeClasses", {
    enumerable: true,
    get: function() {
        return $f7bda82e26c407eb$var$_badgeClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $f7bda82e26c407eb$var$_Badge.default;
    }
});

var $f7bda82e26c407eb$var$_Badge = $f7bda82e26c407eb$require$_interopRequireDefault((parcelRequire("fagfG")));

var $f7bda82e26c407eb$var$_badgeClasses = $f7bda82e26c407eb$require$_interopRequireWildcard((parcelRequire("8FqN6")));
Object.keys($f7bda82e26c407eb$var$_badgeClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($f7bda82e26c407eb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $f7bda82e26c407eb$var$_badgeClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $f7bda82e26c407eb$var$_badgeClasses[key];
        }
    });
});

});
parcelRegister("fagfG", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $b0a465815ebe726f$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $b0a465815ebe726f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b0a465815ebe726f$var$React = $b0a465815ebe726f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $b0a465815ebe726f$var$_propTypes = $b0a465815ebe726f$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $b0a465815ebe726f$var$_clsx = $b0a465815ebe726f$require$_interopRequireDefault((parcelRequire("9QePP")));

var $b0a465815ebe726f$var$_usePreviousProps = $b0a465815ebe726f$require$_interopRequireDefault((parcelRequire("54VdW")));

var $b0a465815ebe726f$var$_composeClasses = $b0a465815ebe726f$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $b0a465815ebe726f$var$_useBadge = $b0a465815ebe726f$require$_interopRequireDefault((parcelRequire("17KyE")));

var $aAbgT = parcelRequire("aAbgT");

var $b0a465815ebe726f$var$_memoTheme = $b0a465815ebe726f$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $b0a465815ebe726f$var$_createSimplePaletteValueFilter = $b0a465815ebe726f$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $hL1nr = parcelRequire("hL1nr");

var $b0a465815ebe726f$var$_capitalize = $b0a465815ebe726f$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $b0a465815ebe726f$var$_badgeClasses = $b0a465815ebe726f$require$_interopRequireWildcard((parcelRequire("8FqN6")));

var $b0a465815ebe726f$var$_useSlot = $b0a465815ebe726f$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $b0a465815ebe726f$var$RADIUS_STANDARD = 10;
const $b0a465815ebe726f$var$RADIUS_DOT = 4;
const $b0a465815ebe726f$var$useUtilityClasses = (ownerState)=>{
    const { color: color, anchorOrigin: anchorOrigin, invisible: invisible, overlap: overlap, variant: variant, classes: classes = {} } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        badge: [
            'badge',
            variant,
            invisible && 'invisible',
            `anchorOrigin${(0, $b0a465815ebe726f$var$_capitalize.default)(anchorOrigin.vertical)}${(0, $b0a465815ebe726f$var$_capitalize.default)(anchorOrigin.horizontal)}`,
            `anchorOrigin${(0, $b0a465815ebe726f$var$_capitalize.default)(anchorOrigin.vertical)}${(0, $b0a465815ebe726f$var$_capitalize.default)(anchorOrigin.horizontal)}${(0, $b0a465815ebe726f$var$_capitalize.default)(overlap)}`,
            `overlap${(0, $b0a465815ebe726f$var$_capitalize.default)(overlap)}`,
            color !== 'default' && `color${(0, $b0a465815ebe726f$var$_capitalize.default)(color)}`
        ]
    };
    return (0, $b0a465815ebe726f$var$_composeClasses.default)(slots, $b0a465815ebe726f$var$_badgeClasses.getBadgeUtilityClass, classes);
};
const $b0a465815ebe726f$var$BadgeRoot = (0, $aAbgT.styled)('span', {
    name: 'MuiBadge',
    slot: 'Root'
})({
    position: 'relative',
    display: 'inline-flex',
    // For correct alignment with the text.
    verticalAlign: 'middle',
    flexShrink: 0
});
const $b0a465815ebe726f$var$BadgeBadge = (0, $aAbgT.styled)('span', {
    name: 'MuiBadge',
    slot: 'Badge',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.badge,
            styles[ownerState.variant],
            styles[`anchorOrigin${(0, $b0a465815ebe726f$var$_capitalize.default)(ownerState.anchorOrigin.vertical)}${(0, $b0a465815ebe726f$var$_capitalize.default)(ownerState.anchorOrigin.horizontal)}${(0, $b0a465815ebe726f$var$_capitalize.default)(ownerState.overlap)}`],
            ownerState.color !== 'default' && styles[`color${(0, $b0a465815ebe726f$var$_capitalize.default)(ownerState.color)}`],
            ownerState.invisible && styles.invisible
        ];
    }
})((0, $b0a465815ebe726f$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        boxSizing: 'border-box',
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(12),
        minWidth: $b0a465815ebe726f$var$RADIUS_STANDARD * 2,
        lineHeight: 1,
        padding: '0 6px',
        height: $b0a465815ebe726f$var$RADIUS_STANDARD * 2,
        borderRadius: $b0a465815ebe726f$var$RADIUS_STANDARD,
        zIndex: 1,
        // Render the badge on top of potential ripples.
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        variants: [
            ...Object.entries(theme.palette).filter((0, $b0a465815ebe726f$var$_createSimplePaletteValueFilter.default)([
                'contrastText'
            ])).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        color: (theme.vars || theme).palette[color].contrastText
                    }
                })),
            {
                props: {
                    variant: 'dot'
                },
                style: {
                    borderRadius: $b0a465815ebe726f$var$RADIUS_DOT,
                    height: $b0a465815ebe726f$var$RADIUS_DOT * 2,
                    minWidth: $b0a465815ebe726f$var$RADIUS_DOT * 2,
                    padding: 0
                }
            },
            {
                props: {
                    invisible: true
                },
                style: {
                    transition: theme.transitions.create('transform', {
                        easing: theme.transitions.easing.easeInOut,
                        duration: theme.transitions.duration.leavingScreen
                    })
                }
            },
            {
                style: ({ ownerState: ownerState })=>{
                    const { vertical: vertical, horizontal: horizontal } = ownerState.anchorOrigin;
                    const offset = ownerState.overlap === 'circular' ? '14%' : 0;
                    return {
                        '--Badge-translateX': horizontal === 'right' ? '50%' : '-50%',
                        '--Badge-translateY': vertical === 'top' ? '-50%' : '50%',
                        top: vertical === 'top' ? offset : 'initial',
                        bottom: vertical === 'bottom' ? offset : 'initial',
                        right: horizontal === 'right' ? offset : 'initial',
                        left: horizontal === 'left' ? offset : 'initial',
                        transform: 'scale(1) translate(var(--Badge-translateX), var(--Badge-translateY))',
                        transformOrigin: `${horizontal === 'right' ? '100%' : '0%'} ${vertical === 'top' ? '0%' : '100%'}`,
                        [`&.${$b0a465815ebe726f$var$_badgeClasses.default.invisible}`]: {
                            transform: 'scale(0) translate(var(--Badge-translateX), var(--Badge-translateY))'
                        }
                    };
                }
            }
        ]
    })));
function $b0a465815ebe726f$var$getAnchorOrigin(anchorOrigin) {
    return {
        vertical: anchorOrigin?.vertical ?? 'top',
        horizontal: anchorOrigin?.horizontal ?? 'right'
    };
}
const $b0a465815ebe726f$var$Badge = /*#__PURE__*/ $b0a465815ebe726f$var$React.forwardRef(function Badge(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiBadge'
    });
    const { anchorOrigin: anchorOriginProp, className: className, classes: classesProp, component: component, components: components = {}, componentsProps: componentsProps = {}, children: children, overlap: overlapProp = 'rectangular', color: colorProp = 'default', invisible: invisibleProp = false, max: maxProp = 99, badgeContent: badgeContentProp, slots: slots, slotProps: slotProps, showZero: showZero = false, variant: variantProp = 'standard', ...other } = props;
    const { badgeContent: badgeContent, invisible: invisibleFromHook, max: max, displayValue: displayValueFromHook } = (0, $b0a465815ebe726f$var$_useBadge.default)({
        max: maxProp,
        invisible: invisibleProp,
        badgeContent: badgeContentProp,
        showZero: showZero
    });
    const prevProps = (0, $b0a465815ebe726f$var$_usePreviousProps.default)({
        anchorOrigin: $b0a465815ebe726f$var$getAnchorOrigin(anchorOriginProp),
        color: colorProp,
        overlap: overlapProp,
        variant: variantProp,
        badgeContent: badgeContentProp
    });
    const invisible = invisibleFromHook || badgeContent == null && variantProp !== 'dot';
    const { color: color = colorProp, overlap: overlap = overlapProp, anchorOrigin: anchorOriginPropProp, variant: variant = variantProp } = invisible ? prevProps : props;
    const anchorOrigin = $b0a465815ebe726f$var$getAnchorOrigin(anchorOriginPropProp);
    const displayValue = variant !== 'dot' ? displayValueFromHook : undefined;
    const ownerState = {
        ...props,
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue,
        showZero: showZero,
        anchorOrigin: anchorOrigin,
        color: color,
        overlap: overlap,
        variant: variant
    };
    const classes = $b0a465815ebe726f$var$useUtilityClasses(ownerState);
    // support both `slots` and `components` for backward compatibility
    const externalForwardedProps = {
        slots: {
            root: slots?.root ?? components.Root,
            badge: slots?.badge ?? components.Badge
        },
        slotProps: {
            root: slotProps?.root ?? componentsProps.root,
            badge: slotProps?.badge ?? componentsProps.badge
        }
    };
    const [RootSlot, rootProps] = (0, $b0a465815ebe726f$var$_useSlot.default)('root', {
        elementType: $b0a465815ebe726f$var$BadgeRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        className: (0, $b0a465815ebe726f$var$_clsx.default)(classes.root, className),
        ref: ref,
        additionalProps: {
            as: component
        }
    });
    const [BadgeSlot, badgeProps] = (0, $b0a465815ebe726f$var$_useSlot.default)('badge', {
        elementType: $b0a465815ebe726f$var$BadgeBadge,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.badge
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            children,
            /*#__PURE__*/ (0, $ayMG0.jsx)(BadgeSlot, {
                ...badgeProps,
                children: displayValue
            })
        ]
    });
});
$b0a465815ebe726f$var$Badge.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The anchor of the badge.
   * @default {
   *   vertical: 'top',
   *   horizontal: 'right',
   * }
   */ anchorOrigin: $b0a465815ebe726f$var$_propTypes.default.shape({
        horizontal: $b0a465815ebe726f$var$_propTypes.default.oneOf([
            'left',
            'right'
        ]),
        vertical: $b0a465815ebe726f$var$_propTypes.default.oneOf([
            'bottom',
            'top'
        ])
    }),
    /**
   * The content rendered within the badge.
   */ badgeContent: $b0a465815ebe726f$var$_propTypes.default.node,
    /**
   * The badge will be added relative to this node.
   */ children: $b0a465815ebe726f$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $b0a465815ebe726f$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $b0a465815ebe726f$var$_propTypes.default.string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */ color: $b0a465815ebe726f$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $b0a465815ebe726f$var$_propTypes.default.oneOf([
            'default',
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning'
        ]),
        $b0a465815ebe726f$var$_propTypes.default.string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $b0a465815ebe726f$var$_propTypes.default.elementType,
    /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */ components: $b0a465815ebe726f$var$_propTypes.default.shape({
        Badge: $b0a465815ebe726f$var$_propTypes.default.elementType,
        Root: $b0a465815ebe726f$var$_propTypes.default.elementType
    }),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */ componentsProps: $b0a465815ebe726f$var$_propTypes.default.shape({
        badge: $b0a465815ebe726f$var$_propTypes.default.oneOfType([
            $b0a465815ebe726f$var$_propTypes.default.func,
            $b0a465815ebe726f$var$_propTypes.default.object
        ]),
        root: $b0a465815ebe726f$var$_propTypes.default.oneOfType([
            $b0a465815ebe726f$var$_propTypes.default.func,
            $b0a465815ebe726f$var$_propTypes.default.object
        ])
    }),
    /**
   * If `true`, the badge is invisible.
   * @default false
   */ invisible: $b0a465815ebe726f$var$_propTypes.default.bool,
    /**
   * Max count to show.
   * @default 99
   */ max: $b0a465815ebe726f$var$_propTypes.default.number,
    /**
   * Wrapped shape the badge should overlap.
   * @default 'rectangular'
   */ overlap: $b0a465815ebe726f$var$_propTypes.default.oneOf([
        'circular',
        'rectangular'
    ]),
    /**
   * Controls whether the badge is hidden when `badgeContent` is zero.
   * @default false
   */ showZero: $b0a465815ebe726f$var$_propTypes.default.bool,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $b0a465815ebe726f$var$_propTypes.default.shape({
        badge: $b0a465815ebe726f$var$_propTypes.default.oneOfType([
            $b0a465815ebe726f$var$_propTypes.default.func,
            $b0a465815ebe726f$var$_propTypes.default.object
        ]),
        root: $b0a465815ebe726f$var$_propTypes.default.oneOfType([
            $b0a465815ebe726f$var$_propTypes.default.func,
            $b0a465815ebe726f$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: $b0a465815ebe726f$var$_propTypes.default.shape({
        badge: $b0a465815ebe726f$var$_propTypes.default.elementType,
        root: $b0a465815ebe726f$var$_propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $b0a465815ebe726f$var$_propTypes.default.oneOfType([
        $b0a465815ebe726f$var$_propTypes.default.arrayOf($b0a465815ebe726f$var$_propTypes.default.oneOfType([
            $b0a465815ebe726f$var$_propTypes.default.func,
            $b0a465815ebe726f$var$_propTypes.default.object,
            $b0a465815ebe726f$var$_propTypes.default.bool
        ])),
        $b0a465815ebe726f$var$_propTypes.default.func,
        $b0a465815ebe726f$var$_propTypes.default.object
    ]),
    /**
   * The variant to use.
   * @default 'standard'
   */ variant: $b0a465815ebe726f$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $b0a465815ebe726f$var$_propTypes.default.oneOf([
            'dot',
            'standard'
        ]),
        $b0a465815ebe726f$var$_propTypes.default.string
    ])
};
var $b0a465815ebe726f$var$_default = module.exports.default = $b0a465815ebe726f$var$Badge;

});
parcelRegister("17KyE", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $0d1a8f518d4ece30$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0d1a8f518d4ece30$var$_usePreviousProps = $0d1a8f518d4ece30$require$_interopRequireDefault((parcelRequire("54VdW")));
function $0d1a8f518d4ece30$var$useBadge(parameters) {
    const { badgeContent: badgeContentProp, invisible: invisibleProp = false, max: maxProp = 99, showZero: showZero = false } = parameters;
    const prevProps = (0, $0d1a8f518d4ece30$var$_usePreviousProps.default)({
        badgeContent: badgeContentProp,
        max: maxProp
    });
    let invisible = invisibleProp;
    if (invisibleProp === false && badgeContentProp === 0 && !showZero) invisible = true;
    const { badgeContent: badgeContent, max: max = maxProp } = invisible ? prevProps : parameters;
    const displayValue = badgeContent && Number(badgeContent) > max ? `${max}+` : badgeContent;
    return {
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue
    };
}
var $0d1a8f518d4ece30$var$_default = module.exports.default = $0d1a8f518d4ece30$var$useBadge;

});

parcelRegister("8FqN6", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $64f6ef338eb74fbc$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getBadgeUtilityClass = $64f6ef338eb74fbc$var$getBadgeUtilityClass;

var $64f6ef338eb74fbc$var$_generateUtilityClasses = $64f6ef338eb74fbc$require$_interopRequireDefault((parcelRequire("5nY49")));

var $64f6ef338eb74fbc$var$_generateUtilityClass = $64f6ef338eb74fbc$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $64f6ef338eb74fbc$var$getBadgeUtilityClass(slot) {
    return (0, $64f6ef338eb74fbc$var$_generateUtilityClass.default)('MuiBadge', slot);
}
const $64f6ef338eb74fbc$var$badgeClasses = (0, $64f6ef338eb74fbc$var$_generateUtilityClasses.default)('MuiBadge', [
    'root',
    'badge',
    'dot',
    'standard',
    'anchorOriginTopRight',
    'anchorOriginBottomRight',
    'anchorOriginTopLeft',
    'anchorOriginBottomLeft',
    'invisible',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'overlapRectangular',
    'overlapCircular',
    // TODO: v6 remove the overlap value from these class keys
    'anchorOriginTopLeftCircular',
    'anchorOriginTopLeftRectangular',
    'anchorOriginTopRightCircular',
    'anchorOriginTopRightRectangular',
    'anchorOriginBottomLeftCircular',
    'anchorOriginBottomLeftRectangular',
    'anchorOriginBottomRightCircular',
    'anchorOriginBottomRightRectangular'
]);
var $64f6ef338eb74fbc$var$_default = module.exports.default = $64f6ef338eb74fbc$var$badgeClasses;

});



parcelRegister("aGDqy", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $7c7c690d35982c52$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $7c7c690d35982c52$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $7c7c690d35982c52$var$_exportNames = {
    checkboxClasses: true
};
Object.defineProperty(module.exports, "checkboxClasses", {
    enumerable: true,
    get: function() {
        return $7c7c690d35982c52$var$_checkboxClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $7c7c690d35982c52$var$_Checkbox.default;
    }
});

var $7c7c690d35982c52$var$_Checkbox = $7c7c690d35982c52$require$_interopRequireDefault((parcelRequire("1Aijw")));

var $7c7c690d35982c52$var$_checkboxClasses = $7c7c690d35982c52$require$_interopRequireWildcard((parcelRequire("9s7Sp")));
Object.keys($7c7c690d35982c52$var$_checkboxClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($7c7c690d35982c52$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $7c7c690d35982c52$var$_checkboxClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7c7c690d35982c52$var$_checkboxClasses[key];
        }
    });
});

});
parcelRegister("1Aijw", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $12775c00f473d955$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $12775c00f473d955$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $12775c00f473d955$var$React = $12775c00f473d955$require$_interopRequireWildcard((parcelRequire("acw62")));

var $12775c00f473d955$var$_propTypes = $12775c00f473d955$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $12775c00f473d955$var$_clsx = $12775c00f473d955$require$_interopRequireDefault((parcelRequire("9QePP")));

var $12775c00f473d955$var$_composeClasses = $12775c00f473d955$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $12775c00f473d955$var$_SwitchBase = $12775c00f473d955$require$_interopRequireDefault((parcelRequire("kVqvD")));

var $12775c00f473d955$var$_CheckBoxOutlineBlank = $12775c00f473d955$require$_interopRequireDefault((parcelRequire("1yHUZ")));

var $12775c00f473d955$var$_CheckBox = $12775c00f473d955$require$_interopRequireDefault((parcelRequire("etWmn")));

var $12775c00f473d955$var$_IndeterminateCheckBox = $12775c00f473d955$require$_interopRequireDefault((parcelRequire("2rW38")));

var $12775c00f473d955$var$_capitalize = $12775c00f473d955$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $12775c00f473d955$var$_rootShouldForwardProp = $12775c00f473d955$require$_interopRequireDefault((parcelRequire("8Uq77")));

var $12775c00f473d955$var$_checkboxClasses = $12775c00f473d955$require$_interopRequireWildcard((parcelRequire("9s7Sp")));

var $aAbgT = parcelRequire("aAbgT");

var $12775c00f473d955$var$_memoTheme = $12775c00f473d955$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $12775c00f473d955$var$_createSimplePaletteValueFilter = $12775c00f473d955$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $hL1nr = parcelRequire("hL1nr");

var $hGPki = parcelRequire("hGPki");

var $12775c00f473d955$var$_useSlot = $12775c00f473d955$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $12775c00f473d955$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, indeterminate: indeterminate, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            indeterminate && 'indeterminate',
            `color${(0, $12775c00f473d955$var$_capitalize.default)(color)}`,
            `size${(0, $12775c00f473d955$var$_capitalize.default)(size)}`
        ]
    };
    const composedClasses = (0, $12775c00f473d955$var$_composeClasses.default)(slots, $12775c00f473d955$var$_checkboxClasses.getCheckboxUtilityClass, classes);
    return {
        ...classes,
        // forward the disabled and checked classes to the SwitchBase
        ...composedClasses
    };
};
const $12775c00f473d955$var$CheckboxRoot = (0, $aAbgT.styled)($12775c00f473d955$var$_SwitchBase.default, {
    shouldForwardProp: (prop)=>(0, $12775c00f473d955$var$_rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiCheckbox',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            styles[`size${(0, $12775c00f473d955$var$_capitalize.default)(ownerState.size)}`],
            ownerState.color !== 'default' && styles[`color${(0, $12775c00f473d955$var$_capitalize.default)(ownerState.color)}`]
        ];
    }
})((0, $12775c00f473d955$var$_memoTheme.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        variants: [
            {
                props: {
                    color: 'default',
                    disableRipple: false
                },
                style: {
                    '&:hover': {
                        backgroundColor: theme.alpha((theme.vars || theme).palette.action.active, (theme.vars || theme).palette.action.hoverOpacity)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $12775c00f473d955$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color,
                        disableRipple: false
                    },
                    style: {
                        '&:hover': {
                            backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity)
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $12775c00f473d955$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${$12775c00f473d955$var$_checkboxClasses.default.checked}, &.${$12775c00f473d955$var$_checkboxClasses.default.indeterminate}`]: {
                            color: (theme.vars || theme).palette[color].main
                        },
                        [`&.${$12775c00f473d955$var$_checkboxClasses.default.disabled}`]: {
                            color: (theme.vars || theme).palette.action.disabled
                        }
                    }
                })),
            {
                // Should be last to override other colors
                props: {
                    disableRipple: false
                },
                style: {
                    // Reset on touch devices, it doesn't add specificity
                    '&:hover': {
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            }
        ]
    })));
const $12775c00f473d955$var$defaultCheckedIcon = /*#__PURE__*/ (0, $ayMG0.jsx)($12775c00f473d955$var$_CheckBox.default, {});
const $12775c00f473d955$var$defaultIcon = /*#__PURE__*/ (0, $ayMG0.jsx)($12775c00f473d955$var$_CheckBoxOutlineBlank.default, {});
const $12775c00f473d955$var$defaultIndeterminateIcon = /*#__PURE__*/ (0, $ayMG0.jsx)($12775c00f473d955$var$_IndeterminateCheckBox.default, {});
const $12775c00f473d955$var$Checkbox = /*#__PURE__*/ $12775c00f473d955$var$React.forwardRef(function Checkbox(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiCheckbox'
    });
    const { checkedIcon: checkedIcon = $12775c00f473d955$var$defaultCheckedIcon, color: color = 'primary', icon: iconProp = $12775c00f473d955$var$defaultIcon, indeterminate: indeterminate = false, indeterminateIcon: indeterminateIconProp = $12775c00f473d955$var$defaultIndeterminateIcon, inputProps: inputProps, size: size = 'medium', disableRipple: disableRipple = false, className: className, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = {
        ...props,
        disableRipple: disableRipple,
        color: color,
        indeterminate: indeterminate,
        size: size
    };
    const classes = $12775c00f473d955$var$useUtilityClasses(ownerState);
    const externalInputProps = slotProps.input ?? inputProps;
    const [RootSlot, rootSlotProps] = (0, $12775c00f473d955$var$_useSlot.default)('root', {
        ref: ref,
        elementType: $12775c00f473d955$var$CheckboxRoot,
        className: (0, $12775c00f473d955$var$_clsx.default)(classes.root, className),
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps,
            ...other
        },
        ownerState: ownerState,
        additionalProps: {
            type: 'checkbox',
            icon: /*#__PURE__*/ $12775c00f473d955$var$React.cloneElement(icon, {
                fontSize: icon.props.fontSize ?? size
            }),
            checkedIcon: /*#__PURE__*/ $12775c00f473d955$var$React.cloneElement(indeterminateIcon, {
                fontSize: indeterminateIcon.props.fontSize ?? size
            }),
            disableRipple: disableRipple,
            slots: slots,
            slotProps: {
                input: (0, $hGPki.mergeSlotProps)(typeof externalInputProps === 'function' ? externalInputProps(ownerState) : externalInputProps, {
                    'data-indeterminate': indeterminate,
                    'aria-checked': indeterminate ? 'mixed' : undefined
                })
            }
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, {
        ...rootSlotProps,
        classes: classes
    });
});
$12775c00f473d955$var$Checkbox.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * If `true`, the component is checked.
   */ checked: $12775c00f473d955$var$_propTypes.default.bool,
    /**
   * The icon to display when the component is checked.
   * @default <CheckBoxIcon />
   */ checkedIcon: $12775c00f473d955$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $12775c00f473d955$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $12775c00f473d955$var$_propTypes.default.string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */ color: $12775c00f473d955$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $12775c00f473d955$var$_propTypes.default.oneOf([
            'default',
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning'
        ]),
        $12775c00f473d955$var$_propTypes.default.string
    ]),
    /**
   * The default checked state. Use when the component is not controlled.
   */ defaultChecked: $12775c00f473d955$var$_propTypes.default.bool,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: $12775c00f473d955$var$_propTypes.default.bool,
    /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */ disableRipple: $12775c00f473d955$var$_propTypes.default.bool,
    /**
   * The icon to display when the component is unchecked.
   * @default <CheckBoxOutlineBlankIcon />
   */ icon: $12775c00f473d955$var$_propTypes.default.node,
    /**
   * The id of the `input` element.
   */ id: $12775c00f473d955$var$_propTypes.default.string,
    /**
   * If `true`, the component appears indeterminate.
   * This does not set the native input element to indeterminate due
   * to inconsistent behavior across browsers.
   * However, we set a `data-indeterminate` attribute on the `input`.
   * @default false
   */ indeterminate: $12775c00f473d955$var$_propTypes.default.bool,
    /**
   * The icon to display when the component is indeterminate.
   * @default <IndeterminateCheckBoxIcon />
   */ indeterminateIcon: $12775c00f473d955$var$_propTypes.default.node,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   * @deprecated Use `slotProps.input` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ inputProps: $12775c00f473d955$var$_propTypes.default.object,
    /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */ onChange: $12775c00f473d955$var$_propTypes.default.func,
    /**
   * If `true`, the `input` element is required.
   * @default false
   */ required: $12775c00f473d955$var$_propTypes.default.bool,
    /**
   * The size of the component.
   * `small` is equivalent to the dense checkbox styling.
   * @default 'medium'
   */ size: $12775c00f473d955$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $12775c00f473d955$var$_propTypes.default.oneOf([
            'medium',
            'small'
        ]),
        $12775c00f473d955$var$_propTypes.default.string
    ]),
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $12775c00f473d955$var$_propTypes.default.shape({
        input: $12775c00f473d955$var$_propTypes.default.oneOfType([
            $12775c00f473d955$var$_propTypes.default.func,
            $12775c00f473d955$var$_propTypes.default.object
        ]),
        root: $12775c00f473d955$var$_propTypes.default.oneOfType([
            $12775c00f473d955$var$_propTypes.default.func,
            $12775c00f473d955$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: $12775c00f473d955$var$_propTypes.default.shape({
        input: $12775c00f473d955$var$_propTypes.default.elementType,
        root: $12775c00f473d955$var$_propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $12775c00f473d955$var$_propTypes.default.oneOfType([
        $12775c00f473d955$var$_propTypes.default.arrayOf($12775c00f473d955$var$_propTypes.default.oneOfType([
            $12775c00f473d955$var$_propTypes.default.func,
            $12775c00f473d955$var$_propTypes.default.object,
            $12775c00f473d955$var$_propTypes.default.bool
        ])),
        $12775c00f473d955$var$_propTypes.default.func,
        $12775c00f473d955$var$_propTypes.default.object
    ]),
    /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */ value: $12775c00f473d955$var$_propTypes.default.any
};
var $12775c00f473d955$var$_default = module.exports.default = $12775c00f473d955$var$Checkbox;

});
parcelRegister("kVqvD", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $f3bdb1b636c81735$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $f3bdb1b636c81735$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f3bdb1b636c81735$var$React = $f3bdb1b636c81735$require$_interopRequireWildcard((parcelRequire("acw62")));

var $f3bdb1b636c81735$var$_propTypes = $f3bdb1b636c81735$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $f3bdb1b636c81735$var$_refType = $f3bdb1b636c81735$require$_interopRequireDefault((parcelRequire("b3gjr")));

var $f3bdb1b636c81735$var$_composeClasses = $f3bdb1b636c81735$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $f3bdb1b636c81735$var$_capitalize = $f3bdb1b636c81735$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $f3bdb1b636c81735$var$_rootShouldForwardProp = $f3bdb1b636c81735$require$_interopRequireDefault((parcelRequire("8Uq77")));

var $aAbgT = parcelRequire("aAbgT");

var $f3bdb1b636c81735$var$_useControlled = $f3bdb1b636c81735$require$_interopRequireDefault((parcelRequire("3yddg")));

var $f3bdb1b636c81735$var$_useFormControl = $f3bdb1b636c81735$require$_interopRequireDefault((parcelRequire("cJQfW")));

var $f3bdb1b636c81735$var$_ButtonBase = $f3bdb1b636c81735$require$_interopRequireDefault((parcelRequire("hhs3r")));

var $bxhip = parcelRequire("bxhip");

var $f3bdb1b636c81735$var$_useSlot = $f3bdb1b636c81735$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $f3bdb1b636c81735$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            'root',
            checked && 'checked',
            disabled && 'disabled',
            edge && `edge${(0, $f3bdb1b636c81735$var$_capitalize.default)(edge)}`
        ],
        input: [
            'input'
        ]
    };
    return (0, $f3bdb1b636c81735$var$_composeClasses.default)(slots, $bxhip.getSwitchBaseUtilityClass, classes);
};
const $f3bdb1b636c81735$var$SwitchBaseRoot = (0, $aAbgT.styled)($f3bdb1b636c81735$var$_ButtonBase.default, {
    name: 'MuiSwitchBase'
})({
    padding: 9,
    borderRadius: '50%',
    variants: [
        {
            props: {
                edge: 'start',
                size: 'small'
            },
            style: {
                marginLeft: -3
            }
        },
        {
            props: ({ edge: edge, ownerState: ownerState })=>edge === 'start' && ownerState.size !== 'small',
            style: {
                marginLeft: -12
            }
        },
        {
            props: {
                edge: 'end',
                size: 'small'
            },
            style: {
                marginRight: -3
            }
        },
        {
            props: ({ edge: edge, ownerState: ownerState })=>edge === 'end' && ownerState.size !== 'small',
            style: {
                marginRight: -12
            }
        }
    ]
});
const $f3bdb1b636c81735$var$SwitchBaseInput = (0, $aAbgT.styled)('input', {
    name: 'MuiSwitchBase',
    shouldForwardProp: $f3bdb1b636c81735$var$_rootShouldForwardProp.default
})({
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $f3bdb1b636c81735$var$SwitchBase = /*#__PURE__*/ $f3bdb1b636c81735$var$React.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const [checked, setCheckedState] = (0, $f3bdb1b636c81735$var$_useControlled.default)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: 'SwitchBase',
        state: 'checked'
    });
    const muiFormControl = (0, $f3bdb1b636c81735$var$_useFormControl.default)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented || readOnly) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === 'checkbox' || type === 'radio';
    const ownerState = {
        ...props,
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    };
    const classes = $f3bdb1b636c81735$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            input: inputProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, $f3bdb1b636c81735$var$_useSlot.default)('root', {
        ref: ref,
        elementType: $f3bdb1b636c81735$var$SwitchBaseRoot,
        className: classes.root,
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            ...externalForwardedProps,
            component: 'span',
            ...other
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onFocus: (event)=>{
                    handlers.onFocus?.(event);
                    handleFocus(event);
                },
                onBlur: (event)=>{
                    handlers.onBlur?.(event);
                    handleBlur(event);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            centerRipple: true,
            focusRipple: !disableFocusRipple,
            role: undefined,
            tabIndex: null
        }
    });
    const [InputSlot, inputSlotProps] = (0, $f3bdb1b636c81735$var$_useSlot.default)('input', {
        ref: inputRef,
        elementType: $f3bdb1b636c81735$var$SwitchBaseInput,
        className: classes.input,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                ...handlers,
                onChange: (event)=>{
                    handlers.onChange?.(event);
                    handleInputChange(event);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            autoFocus: autoFocus,
            checked: checkedProp,
            defaultChecked: defaultChecked,
            disabled: disabled,
            id: hasLabelFor ? id : undefined,
            name: name,
            readOnly: readOnly,
            required: required,
            tabIndex: tabIndex,
            type: type,
            ...type === 'checkbox' && value === undefined ? {} : {
                value: value
            }
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(InputSlot, {
                ...inputSlotProps
            }),
            checked ? checkedIcon : icon
        ]
    });
});
// NB: If changed, please update Checkbox, Switch and Radio
// so that the API documentation is updated.
$f3bdb1b636c81735$var$SwitchBase.propTypes = {
    /**
   * If `true`, the `input` element is focused during the first mount.
   */ autoFocus: $f3bdb1b636c81735$var$_propTypes.default.bool,
    /**
   * If `true`, the component is checked.
   */ checked: $f3bdb1b636c81735$var$_propTypes.default.bool,
    /**
   * The icon to display when the component is checked.
   */ checkedIcon: $f3bdb1b636c81735$var$_propTypes.default.node.isRequired,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $f3bdb1b636c81735$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $f3bdb1b636c81735$var$_propTypes.default.string,
    /**
   * @ignore
   */ defaultChecked: $f3bdb1b636c81735$var$_propTypes.default.bool,
    /**
   * If `true`, the component is disabled.
   */ disabled: $f3bdb1b636c81735$var$_propTypes.default.bool,
    /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */ disableFocusRipple: $f3bdb1b636c81735$var$_propTypes.default.bool,
    /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */ edge: $f3bdb1b636c81735$var$_propTypes.default.oneOf([
        'end',
        'start',
        false
    ]),
    /**
   * The icon to display when the component is unchecked.
   */ icon: $f3bdb1b636c81735$var$_propTypes.default.node.isRequired,
    /**
   * The id of the `input` element.
   */ id: $f3bdb1b636c81735$var$_propTypes.default.string,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   */ inputProps: $f3bdb1b636c81735$var$_propTypes.default.object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: $f3bdb1b636c81735$var$_refType.default,
    /*
   * @ignore
   */ name: $f3bdb1b636c81735$var$_propTypes.default.string,
    /**
   * @ignore
   */ onBlur: $f3bdb1b636c81735$var$_propTypes.default.func,
    /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */ onChange: $f3bdb1b636c81735$var$_propTypes.default.func,
    /**
   * @ignore
   */ onFocus: $f3bdb1b636c81735$var$_propTypes.default.func,
    /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */ readOnly: $f3bdb1b636c81735$var$_propTypes.default.bool,
    /**
   * If `true`, the `input` element is required.
   */ required: $f3bdb1b636c81735$var$_propTypes.default.bool,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $f3bdb1b636c81735$var$_propTypes.default.shape({
        input: $f3bdb1b636c81735$var$_propTypes.default.oneOfType([
            $f3bdb1b636c81735$var$_propTypes.default.func,
            $f3bdb1b636c81735$var$_propTypes.default.object
        ]),
        root: $f3bdb1b636c81735$var$_propTypes.default.oneOfType([
            $f3bdb1b636c81735$var$_propTypes.default.func,
            $f3bdb1b636c81735$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: $f3bdb1b636c81735$var$_propTypes.default.shape({
        input: $f3bdb1b636c81735$var$_propTypes.default.elementType,
        root: $f3bdb1b636c81735$var$_propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $f3bdb1b636c81735$var$_propTypes.default.object,
    /**
   * @ignore
   */ tabIndex: $f3bdb1b636c81735$var$_propTypes.default.oneOfType([
        $f3bdb1b636c81735$var$_propTypes.default.number,
        $f3bdb1b636c81735$var$_propTypes.default.string
    ]),
    /**
   * The input component prop `type`.
   */ type: $f3bdb1b636c81735$var$_propTypes.default.string.isRequired,
    /**
   * The value of the component.
   */ value: $f3bdb1b636c81735$var$_propTypes.default.any
};
var $f3bdb1b636c81735$var$_default = module.exports.default = $f3bdb1b636c81735$var$SwitchBase;

});
parcelRegister("bxhip", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $86603163591f910a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getSwitchBaseUtilityClass = $86603163591f910a$var$getSwitchBaseUtilityClass;

var $86603163591f910a$var$_generateUtilityClasses = $86603163591f910a$require$_interopRequireDefault((parcelRequire("5nY49")));

var $86603163591f910a$var$_generateUtilityClass = $86603163591f910a$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $86603163591f910a$var$getSwitchBaseUtilityClass(slot) {
    return (0, $86603163591f910a$var$_generateUtilityClass.default)('PrivateSwitchBase', slot);
}
const $86603163591f910a$var$switchBaseClasses = (0, $86603163591f910a$var$_generateUtilityClasses.default)('PrivateSwitchBase', [
    'root',
    'checked',
    'disabled',
    'input',
    'edgeStart',
    'edgeEnd'
]);
var $86603163591f910a$var$_default = module.exports.default = $86603163591f910a$var$switchBaseClasses;

});


parcelRegister("1yHUZ", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $122b08a8ae2faae5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $122b08a8ae2faae5$var$_createSvgIcon = $122b08a8ae2faae5$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $122b08a8ae2faae5$var$_default = module.exports.default = (0, $122b08a8ae2faae5$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank');

});

parcelRegister("etWmn", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $a8b10b2b5aaa8e54$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a8b10b2b5aaa8e54$var$_createSvgIcon = $a8b10b2b5aaa8e54$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $a8b10b2b5aaa8e54$var$_default = module.exports.default = (0, $a8b10b2b5aaa8e54$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');

});

parcelRegister("2rW38", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $1c8b21cdbf539e4f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1c8b21cdbf539e4f$var$_createSvgIcon = $1c8b21cdbf539e4f$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $1c8b21cdbf539e4f$var$_default = module.exports.default = (0, $1c8b21cdbf539e4f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox');

});

parcelRegister("9s7Sp", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $6e1cd6b997bc70d3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getCheckboxUtilityClass = $6e1cd6b997bc70d3$var$getCheckboxUtilityClass;

var $6e1cd6b997bc70d3$var$_generateUtilityClasses = $6e1cd6b997bc70d3$require$_interopRequireDefault((parcelRequire("5nY49")));

var $6e1cd6b997bc70d3$var$_generateUtilityClass = $6e1cd6b997bc70d3$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $6e1cd6b997bc70d3$var$getCheckboxUtilityClass(slot) {
    return (0, $6e1cd6b997bc70d3$var$_generateUtilityClass.default)('MuiCheckbox', slot);
}
const $6e1cd6b997bc70d3$var$checkboxClasses = (0, $6e1cd6b997bc70d3$var$_generateUtilityClasses.default)('MuiCheckbox', [
    'root',
    'checked',
    'disabled',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium'
]);
var $6e1cd6b997bc70d3$var$_default = module.exports.default = $6e1cd6b997bc70d3$var$checkboxClasses;

});



parcelRegister("g6BeY", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $bb9a180c0f91ff1f$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $bb9a180c0f91ff1f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $bb9a180c0f91ff1f$var$_exportNames = {
    dividerClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $bb9a180c0f91ff1f$var$_Divider.default;
    }
});
Object.defineProperty(module.exports, "dividerClasses", {
    enumerable: true,
    get: function() {
        return $bb9a180c0f91ff1f$var$_dividerClasses.default;
    }
});

var $bb9a180c0f91ff1f$var$_Divider = $bb9a180c0f91ff1f$require$_interopRequireDefault((parcelRequire("lkxXU")));

var $bb9a180c0f91ff1f$var$_dividerClasses = $bb9a180c0f91ff1f$require$_interopRequireWildcard((parcelRequire("cbVYE")));
Object.keys($bb9a180c0f91ff1f$var$_dividerClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($bb9a180c0f91ff1f$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $bb9a180c0f91ff1f$var$_dividerClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bb9a180c0f91ff1f$var$_dividerClasses[key];
        }
    });
});

});
parcelRegister("lkxXU", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $f875d00b2138afe4$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $f875d00b2138afe4$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f875d00b2138afe4$var$React = $f875d00b2138afe4$require$_interopRequireWildcard((parcelRequire("acw62")));

var $f875d00b2138afe4$var$_propTypes = $f875d00b2138afe4$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $f875d00b2138afe4$var$_clsx = $f875d00b2138afe4$require$_interopRequireDefault((parcelRequire("9QePP")));

var $f875d00b2138afe4$var$_composeClasses = $f875d00b2138afe4$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $f875d00b2138afe4$var$_memoTheme = $f875d00b2138afe4$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $cbVYE = parcelRequire("cbVYE");

var $ayMG0 = parcelRequire("ayMG0");
const $f875d00b2138afe4$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            absolute && 'absolute',
            variant,
            light && 'light',
            orientation === 'vertical' && 'vertical',
            flexItem && 'flexItem',
            children && 'withChildren',
            children && orientation === 'vertical' && 'withChildrenVertical',
            textAlign === 'right' && orientation !== 'vertical' && 'textAlignRight',
            textAlign === 'left' && orientation !== 'vertical' && 'textAlignLeft'
        ],
        wrapper: [
            'wrapper',
            orientation === 'vertical' && 'wrapperVertical'
        ]
    };
    return (0, $f875d00b2138afe4$var$_composeClasses.default)(slots, $cbVYE.getDividerUtilityClass, classes);
};
const $f875d00b2138afe4$var$DividerRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiDivider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === 'vertical' && styles.withChildrenVertical,
            ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && styles.textAlignRight,
            ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && styles.textAlignLeft
        ];
    }
})((0, $f875d00b2138afe4$var$_memoTheme.default)(({ theme: theme })=>({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: 'solid',
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: 'thin',
        variants: [
            {
                props: {
                    absolute: true
                },
                style: {
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '100%'
                }
            },
            {
                props: {
                    light: true
                },
                style: {
                    borderColor: theme.alpha((theme.vars || theme).palette.divider, 0.08)
                }
            },
            {
                props: {
                    variant: 'inset'
                },
                style: {
                    marginLeft: 72
                }
            },
            {
                props: {
                    variant: 'middle',
                    orientation: 'horizontal'
                },
                style: {
                    marginLeft: theme.spacing(2),
                    marginRight: theme.spacing(2)
                }
            },
            {
                props: {
                    variant: 'middle',
                    orientation: 'vertical'
                },
                style: {
                    marginTop: theme.spacing(1),
                    marginBottom: theme.spacing(1)
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    height: '100%',
                    borderBottomWidth: 0,
                    borderRightWidth: 'thin'
                }
            },
            {
                props: {
                    flexItem: true
                },
                style: {
                    alignSelf: 'stretch',
                    height: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.children,
                style: {
                    display: 'flex',
                    textAlign: 'center',
                    border: 0,
                    borderTopStyle: 'solid',
                    borderLeftStyle: 'solid',
                    '&::before, &::after': {
                        content: '""',
                        alignSelf: 'center'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.children && ownerState.orientation !== 'vertical',
                style: {
                    '&::before, &::after': {
                        width: '100%',
                        borderTop: `thin solid ${(theme.vars || theme).palette.divider}`,
                        borderTopStyle: 'inherit'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.orientation === 'vertical' && ownerState.children,
                style: {
                    flexDirection: 'column',
                    '&::before, &::after': {
                        height: '100%',
                        borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`,
                        borderLeftStyle: 'inherit'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical',
                style: {
                    '&::before': {
                        width: '90%'
                    },
                    '&::after': {
                        width: '10%'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical',
                style: {
                    '&::before': {
                        width: '10%'
                    },
                    '&::after': {
                        width: '90%'
                    }
                }
            }
        ]
    })));
const $f875d00b2138afe4$var$DividerWrapper = (0, $aAbgT.styled)('span', {
    name: 'MuiDivider',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === 'vertical' && styles.wrapperVertical
        ];
    }
})((0, $f875d00b2138afe4$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'inline-block',
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`,
        whiteSpace: 'nowrap',
        variants: [
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
                    paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
                }
            }
        ]
    })));
const $f875d00b2138afe4$var$Divider = /*#__PURE__*/ $f875d00b2138afe4$var$React.forwardRef(function Divider(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiDivider'
    });
    const { absolute: absolute = false, children: children, className: className, orientation: orientation = 'horizontal', component: component = children || orientation === 'vertical' ? 'div' : 'hr', flexItem: flexItem = false, light: light = false, role: role = component !== 'hr' ? 'separator' : undefined, textAlign: textAlign = 'center', variant: variant = 'fullWidth', ...other } = props;
    const ownerState = {
        ...props,
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    };
    const classes = $f875d00b2138afe4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($f875d00b2138afe4$var$DividerRoot, {
        as: component,
        className: (0, $f875d00b2138afe4$var$_clsx.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState,
        "aria-orientation": role === 'separator' && (component !== 'hr' || orientation === 'vertical') ? orientation : undefined,
        ...other,
        children: children ? /*#__PURE__*/ (0, $ayMG0.jsx)($f875d00b2138afe4$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    });
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ if ($f875d00b2138afe4$var$Divider) $f875d00b2138afe4$var$Divider.muiSkipListHighlight = true;
$f875d00b2138afe4$var$Divider.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Absolutely position the element.
   * @default false
   */ absolute: $f875d00b2138afe4$var$_propTypes.default.bool,
    /**
   * The content of the component.
   */ children: $f875d00b2138afe4$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $f875d00b2138afe4$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $f875d00b2138afe4$var$_propTypes.default.string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $f875d00b2138afe4$var$_propTypes.default.elementType,
    /**
   * If `true`, a vertical divider will have the correct height when used in flex container.
   * (By default, a vertical divider will have a calculated height of `0px` if it is the child of a flex container.)
   * @default false
   */ flexItem: $f875d00b2138afe4$var$_propTypes.default.bool,
    /**
   * If `true`, the divider will have a lighter color.
   * @default false
   * @deprecated Use <Divider sx={{ opacity: 0.6 }} /> (or any opacity or color) instead. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ light: $f875d00b2138afe4$var$_propTypes.default.bool,
    /**
   * The component orientation.
   * @default 'horizontal'
   */ orientation: $f875d00b2138afe4$var$_propTypes.default.oneOf([
        'horizontal',
        'vertical'
    ]),
    /**
   * @ignore
   */ role: $f875d00b2138afe4$var$_propTypes.default.string,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $f875d00b2138afe4$var$_propTypes.default.oneOfType([
        $f875d00b2138afe4$var$_propTypes.default.arrayOf($f875d00b2138afe4$var$_propTypes.default.oneOfType([
            $f875d00b2138afe4$var$_propTypes.default.func,
            $f875d00b2138afe4$var$_propTypes.default.object,
            $f875d00b2138afe4$var$_propTypes.default.bool
        ])),
        $f875d00b2138afe4$var$_propTypes.default.func,
        $f875d00b2138afe4$var$_propTypes.default.object
    ]),
    /**
   * The text alignment.
   * @default 'center'
   */ textAlign: $f875d00b2138afe4$var$_propTypes.default.oneOf([
        'center',
        'left',
        'right'
    ]),
    /**
   * The variant to use.
   * @default 'fullWidth'
   */ variant: $f875d00b2138afe4$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $f875d00b2138afe4$var$_propTypes.default.oneOf([
            'fullWidth',
            'inset',
            'middle'
        ]),
        $f875d00b2138afe4$var$_propTypes.default.string
    ])
};
var $f875d00b2138afe4$var$_default = module.exports.default = $f875d00b2138afe4$var$Divider;

});
parcelRegister("cbVYE", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $024a60f892d3fa61$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getDividerUtilityClass = $024a60f892d3fa61$var$getDividerUtilityClass;

var $024a60f892d3fa61$var$_generateUtilityClasses = $024a60f892d3fa61$require$_interopRequireDefault((parcelRequire("5nY49")));

var $024a60f892d3fa61$var$_generateUtilityClass = $024a60f892d3fa61$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $024a60f892d3fa61$var$getDividerUtilityClass(slot) {
    return (0, $024a60f892d3fa61$var$_generateUtilityClass.default)('MuiDivider', slot);
}
const $024a60f892d3fa61$var$dividerClasses = (0, $024a60f892d3fa61$var$_generateUtilityClasses.default)('MuiDivider', [
    'root',
    'absolute',
    'fullWidth',
    'inset',
    'middle',
    'flexItem',
    'light',
    'vertical',
    'withChildren',
    'withChildrenVertical',
    'textAlignRight',
    'textAlignLeft',
    'wrapper',
    'wrapperVertical'
]);
var $024a60f892d3fa61$var$_default = module.exports.default = $024a60f892d3fa61$var$dividerClasses;

});



parcelRegister("c94Y8", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $8d7a2e093d9aaa46$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $8d7a2e093d9aaa46$var$_FocusTrap.default;
    }
});

var $8d7a2e093d9aaa46$var$_FocusTrap = $8d7a2e093d9aaa46$require$_interopRequireDefault((parcelRequire("kRwxQ")));

});
parcelRegister("kRwxQ", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $f30200a1e85b3f20$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $f30200a1e85b3f20$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f30200a1e85b3f20$var$React = $f30200a1e85b3f20$require$_interopRequireWildcard((parcelRequire("acw62")));

var $f30200a1e85b3f20$var$_propTypes = $f30200a1e85b3f20$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $f30200a1e85b3f20$var$_useForkRef = $f30200a1e85b3f20$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $f30200a1e85b3f20$var$_ownerDocument = $f30200a1e85b3f20$require$_interopRequireDefault((parcelRequire("43fuO")));

var $f30200a1e85b3f20$var$_getReactElementRef = $f30200a1e85b3f20$require$_interopRequireDefault((parcelRequire("2B4J6")));

var $f30200a1e85b3f20$var$_exactProp = $f30200a1e85b3f20$require$_interopRequireDefault((parcelRequire("5S3aN")));

var $f30200a1e85b3f20$var$_elementAcceptingRef = $f30200a1e85b3f20$require$_interopRequireDefault((parcelRequire("igTUE")));

var $f30200a1e85b3f20$var$_contains = $f30200a1e85b3f20$require$_interopRequireDefault((parcelRequire("191Fy")));

var $f30200a1e85b3f20$var$_getActiveElement = $f30200a1e85b3f20$require$_interopRequireDefault((parcelRequire("6uU67")));

var $ggK3e = parcelRequire("ggK3e");

var $ayMG0 = parcelRequire("ayMG0");
// Inspired by https://github.com/focus-trap/tabbable
const $f30200a1e85b3f20$var$candidatesSelector = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])'
].join(',');
function $f30200a1e85b3f20$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://issues.chromium.org/issues/41283952
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) return 0;
    return node.tabIndex;
}
function $f30200a1e85b3f20$var$isNonTabbableRadio(node) {
    if (node.tagName !== 'INPUT' || node.type !== 'radio') return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $f30200a1e85b3f20$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || $f30200a1e85b3f20$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $f30200a1e85b3f20$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($f30200a1e85b3f20$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $f30200a1e85b3f20$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$f30200a1e85b3f20$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $f30200a1e85b3f20$var$defaultIsEnabled() {
    return true;
}
/**
 * @ignore - internal component.
 */ function $f30200a1e85b3f20$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $f30200a1e85b3f20$var$defaultGetTabbable, isEnabled: isEnabled = $f30200a1e85b3f20$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $f30200a1e85b3f20$var$React.useRef(false);
    const sentinelStart = $f30200a1e85b3f20$var$React.useRef(null);
    const sentinelEnd = $f30200a1e85b3f20$var$React.useRef(null);
    const nodeToRestore = $f30200a1e85b3f20$var$React.useRef(null);
    const reactFocusEventTarget = $f30200a1e85b3f20$var$React.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $f30200a1e85b3f20$var$React.useRef(false);
    const rootRef = $f30200a1e85b3f20$var$React.useRef(null);
    const handleRef = (0, $f30200a1e85b3f20$var$_useForkRef.default)((0, $f30200a1e85b3f20$var$_getReactElementRef.default)(children), rootRef);
    const lastKeydown = $f30200a1e85b3f20$var$React.useRef(null);
    $f30200a1e85b3f20$var$React.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $f30200a1e85b3f20$var$React.useEffect(()=>{
        // Reset on every mount — React 18 Strict Mode double-mounts leave this
        // stuck at `true` after the cleanup of the previous mount set it.
        ignoreNextEnforceFocus.current = false;
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $f30200a1e85b3f20$var$_ownerDocument.default)(rootRef.current);
        const activeElement = (0, $f30200a1e85b3f20$var$_getActiveElement.default)(doc);
        // Prefer the explicitly marked focusable element. Fall back to the root
        // element for generic FocusTrap usage.
        const focusTarget = (0, $ggK3e.getFocusTarget)(rootRef.current) ?? rootRef.current;
        if (!(0, $f30200a1e85b3f20$var$_contains.default)(rootRef.current, activeElement)) {
            if (!focusTarget.hasAttribute('tabIndex')) {
                console.error([
                    'MUI: The modal content node does not accept focus.',
                    'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'
                ].join('\n'));
                focusTarget.setAttribute('tabIndex', '-1');
            }
            if (activated.current) focusTarget.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $f30200a1e85b3f20$var$React.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $f30200a1e85b3f20$var$_ownerDocument.default)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') return;
            const activeElement = (0, $f30200a1e85b3f20$var$_getActiveElement.default)(doc);
            // Make sure the next tab starts from the right place.
            // activeElement refers to the origin.
            if (activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            const activeEl = (0, $f30200a1e85b3f20$var$_getActiveElement.default)(doc);
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if ((0, $f30200a1e85b3f20$var$_contains.default)(rootElement, activeEl)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && activeEl !== sentinelStart.current && activeEl !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (activeEl !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (activeEl === sentinelStart.current || activeEl === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                const isShiftTab = Boolean(lastKeydown.current?.shiftKey && lastKeydown.current?.key === 'Tab');
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener('focusin', contain);
        doc.addEventListener('keydown', loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            const activeEl = (0, $f30200a1e85b3f20$var$_getActiveElement.default)(doc);
            if (activeEl && activeEl.tagName === 'BODY') contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener('focusin', contain);
            doc.removeEventListener('keydown', loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($f30200a1e85b3f20$var$React.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $f30200a1e85b3f20$var$React.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
$f30200a1e85b3f20$var$FocusTrap.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * A single child content element.
   */ children: $f30200a1e85b3f20$var$_elementAcceptingRef.default,
    /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */ disableAutoFocus: $f30200a1e85b3f20$var$_propTypes.default.bool,
    /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */ disableEnforceFocus: $f30200a1e85b3f20$var$_propTypes.default.bool,
    /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */ disableRestoreFocus: $f30200a1e85b3f20$var$_propTypes.default.bool,
    /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */ getTabbable: $f30200a1e85b3f20$var$_propTypes.default.func,
    /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */ isEnabled: $f30200a1e85b3f20$var$_propTypes.default.func,
    /**
   * If `true`, focus is locked.
   */ open: $f30200a1e85b3f20$var$_propTypes.default.bool.isRequired
};
// eslint-disable-next-line
$f30200a1e85b3f20$var$FocusTrap["propTypes"] = (0, $f30200a1e85b3f20$var$_exactProp.default)($f30200a1e85b3f20$var$FocusTrap.propTypes);
var $f30200a1e85b3f20$var$_default = module.exports.default = $f30200a1e85b3f20$var$FocusTrap;

});
parcelRegister("igTUE", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d4d517b73cdaa5e7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $d4d517b73cdaa5e7$var$_elementAcceptingRef.default;
    }
});

var $d4d517b73cdaa5e7$var$_elementAcceptingRef = $d4d517b73cdaa5e7$require$_interopRequireDefault((parcelRequire("9kjow")));

});
parcelRegister("9kjow", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $6ca506ac7edb93a5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6ca506ac7edb93a5$var$_propTypes = $6ca506ac7edb93a5$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $6ca506ac7edb93a5$var$_chainPropTypes = $6ca506ac7edb93a5$require$_interopRequireDefault((parcelRequire("abVWF")));
function $6ca506ac7edb93a5$var$isClassComponent(elementType) {
    // elementType.prototype?.isReactComponent
    const { prototype: prototype = {} } = elementType;
    return Boolean(prototype.isReactComponent);
}
function $6ca506ac7edb93a5$var$acceptingRef(props, propName, componentName, location, propFullName) {
    const element = props[propName];
    const safePropName = propFullName || propName;
    if (element == null || // When server-side rendering React doesn't warn either.
    // This is not an accurate check for SSR.
    // This is only in place for Emotion compat.
    // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
    typeof window === 'undefined') return null;
    let warningHint;
    const elementType = element.type;
    /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */ if (typeof elementType === 'function' && !$6ca506ac7edb93a5$var$isClassComponent(elementType)) warningHint = 'Did you accidentally use a plain function component for an element instead?';
    if (warningHint !== undefined) return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. ` + `Expected an element that can hold a ref. ${warningHint} ` + 'For more information see https://mui.com/r/caveat-with-refs-guide');
    return null;
}
const $6ca506ac7edb93a5$var$elementAcceptingRef = (0, $6ca506ac7edb93a5$var$_chainPropTypes.default)($6ca506ac7edb93a5$var$_propTypes.default.element, $6ca506ac7edb93a5$var$acceptingRef);
$6ca506ac7edb93a5$var$elementAcceptingRef.isRequired = (0, $6ca506ac7edb93a5$var$_chainPropTypes.default)($6ca506ac7edb93a5$var$_propTypes.default.element.isRequired, $6ca506ac7edb93a5$var$acceptingRef);
var $6ca506ac7edb93a5$var$_default = module.exports.default = $6ca506ac7edb93a5$var$elementAcceptingRef;

});


parcelRegister("191Fy", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0d57ed2eeb36116c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0d57ed2eeb36116c$var$_contains = $0d57ed2eeb36116c$require$_interopRequireDefault((parcelRequire("9DeDn")));
var $0d57ed2eeb36116c$var$_default = module.exports.default = $0d57ed2eeb36116c$var$_contains.default;

});

parcelRegister("ggK3e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FOCUSABLE_ATTRIBUTE = void 0;
module.exports.getFocusTarget = $bd81dcbe2bb08855$var$getFocusTarget;
const $bd81dcbe2bb08855$var$FOCUSABLE_ATTRIBUTE = module.exports.FOCUSABLE_ATTRIBUTE = 'data-mui-focusable';
/**
 * Returns the element marked as the initial focus target inside a focus trap.
 * The root element takes precedence over marked descendants so components can
 * opt into focusing their own root surface directly.
 */ function $bd81dcbe2bb08855$var$getFocusTarget(rootElement) {
    if (!rootElement) return null;
    return rootElement.hasAttribute($bd81dcbe2bb08855$var$FOCUSABLE_ATTRIBUTE) ? rootElement : rootElement.querySelector(`[${$bd81dcbe2bb08855$var$FOCUSABLE_ATTRIBUTE}]`);
}

});



parcelRegister("2vsem", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $1d34600829c15c5d$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $1d34600829c15c5d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $1d34600829c15c5d$var$_exportNames = {
    linearProgressClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $1d34600829c15c5d$var$_LinearProgress.default;
    }
});
Object.defineProperty(module.exports, "linearProgressClasses", {
    enumerable: true,
    get: function() {
        return $1d34600829c15c5d$var$_linearProgressClasses.default;
    }
});

var $1d34600829c15c5d$var$_LinearProgress = $1d34600829c15c5d$require$_interopRequireDefault((parcelRequire("1lfQl")));

var $1d34600829c15c5d$var$_linearProgressClasses = $1d34600829c15c5d$require$_interopRequireWildcard((parcelRequire("lJgAB")));
Object.keys($1d34600829c15c5d$var$_linearProgressClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1d34600829c15c5d$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $1d34600829c15c5d$var$_linearProgressClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1d34600829c15c5d$var$_linearProgressClasses[key];
        }
    });
});

});
parcelRegister("1lfQl", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $0fa40ac3f678fedb$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $0fa40ac3f678fedb$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0fa40ac3f678fedb$var$React = $0fa40ac3f678fedb$require$_interopRequireWildcard((parcelRequire("acw62")));

var $0fa40ac3f678fedb$var$_propTypes = $0fa40ac3f678fedb$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $0fa40ac3f678fedb$var$_clsx = $0fa40ac3f678fedb$require$_interopRequireDefault((parcelRequire("9QePP")));

var $0fa40ac3f678fedb$var$_composeClasses = $0fa40ac3f678fedb$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $9uEev = parcelRequire("9uEev");

var $aAbgT = parcelRequire("aAbgT");

var $0fa40ac3f678fedb$var$_memoTheme = $0fa40ac3f678fedb$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $0fa40ac3f678fedb$var$_createSimplePaletteValueFilter = $0fa40ac3f678fedb$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $hL1nr = parcelRequire("hL1nr");

var $0fa40ac3f678fedb$var$_capitalize = $0fa40ac3f678fedb$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $lJgAB = parcelRequire("lJgAB");

var $ayMG0 = parcelRequire("ayMG0");
const $0fa40ac3f678fedb$var$TRANSITION_DURATION = 4; // seconds
const $0fa40ac3f678fedb$var$indeterminate1Keyframe = (0, $aAbgT.keyframes)`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $0fa40ac3f678fedb$var$indeterminate1Animation = typeof $0fa40ac3f678fedb$var$indeterminate1Keyframe !== 'string' ? (0, $aAbgT.css)`
        animation: ${$0fa40ac3f678fedb$var$indeterminate1Keyframe} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
      ` : null;
const $0fa40ac3f678fedb$var$indeterminate2Keyframe = (0, $aAbgT.keyframes)`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`;
const $0fa40ac3f678fedb$var$indeterminate2Animation = typeof $0fa40ac3f678fedb$var$indeterminate2Keyframe !== 'string' ? (0, $aAbgT.css)`
        animation: ${$0fa40ac3f678fedb$var$indeterminate2Keyframe} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
      ` : null;
const $0fa40ac3f678fedb$var$bufferKeyframe = (0, $aAbgT.keyframes)`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`;
const $0fa40ac3f678fedb$var$bufferAnimation = typeof $0fa40ac3f678fedb$var$bufferKeyframe !== 'string' ? (0, $aAbgT.css)`
        animation: ${$0fa40ac3f678fedb$var$bufferKeyframe} 3s infinite linear;
      ` : null;
const $0fa40ac3f678fedb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $0fa40ac3f678fedb$var$_capitalize.default)(color)}`,
            variant
        ],
        dashed: [
            'dashed',
            `dashedColor${(0, $0fa40ac3f678fedb$var$_capitalize.default)(color)}`
        ],
        bar1: [
            'bar',
            'bar1',
            `barColor${(0, $0fa40ac3f678fedb$var$_capitalize.default)(color)}`,
            (variant === 'indeterminate' || variant === 'query') && 'bar1Indeterminate',
            variant === 'determinate' && 'bar1Determinate',
            variant === 'buffer' && 'bar1Buffer'
        ],
        bar2: [
            'bar',
            'bar2',
            variant !== 'buffer' && `barColor${(0, $0fa40ac3f678fedb$var$_capitalize.default)(color)}`,
            variant === 'buffer' && `color${(0, $0fa40ac3f678fedb$var$_capitalize.default)(color)}`,
            (variant === 'indeterminate' || variant === 'query') && 'bar2Indeterminate',
            variant === 'buffer' && 'bar2Buffer'
        ]
    };
    return (0, $0fa40ac3f678fedb$var$_composeClasses.default)(slots, $lJgAB.getLinearProgressUtilityClass, classes);
};
const $0fa40ac3f678fedb$var$getColorShade = (theme, color)=>{
    if (theme.vars) return theme.vars.palette.LinearProgress[`${color}Bg`];
    return theme.palette.mode === 'light' ? theme.lighten(theme.palette[color].main, 0.62) : theme.darken(theme.palette[color].main, 0.5);
};
const $0fa40ac3f678fedb$var$LinearProgressRoot = (0, $aAbgT.styled)('span', {
    name: 'MuiLinearProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $0fa40ac3f678fedb$var$_capitalize.default)(ownerState.color)}`],
            styles[ownerState.variant]
        ];
    }
})((0, $0fa40ac3f678fedb$var$_memoTheme.default)(({ theme: theme })=>({
        position: 'relative',
        overflow: 'hidden',
        display: 'block',
        height: 4,
        // Fix Safari's bug during composition of different paint.
        zIndex: 0,
        '@media print': {
            colorAdjust: 'exact'
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $0fa40ac3f678fedb$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: $0fa40ac3f678fedb$var$getColorShade(theme, color)
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.color === 'inherit' && ownerState.variant !== 'buffer',
                style: {
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        left: 0,
                        top: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'currentColor',
                        opacity: 0.3
                    }
                }
            },
            {
                props: {
                    variant: 'buffer'
                },
                style: {
                    backgroundColor: 'transparent'
                }
            },
            {
                props: {
                    variant: 'query'
                },
                style: {
                    transform: 'rotate(180deg)'
                }
            }
        ]
    })));
const $0fa40ac3f678fedb$var$LinearProgressDashed = (0, $aAbgT.styled)('span', {
    name: 'MuiLinearProgress',
    slot: 'Dashed',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.dashed,
            styles[`dashedColor${(0, $0fa40ac3f678fedb$var$_capitalize.default)(ownerState.color)}`]
        ];
    }
})((0, $0fa40ac3f678fedb$var$_memoTheme.default)(({ theme: theme })=>({
        position: 'absolute',
        marginTop: 0,
        height: '100%',
        width: '100%',
        backgroundSize: '10px 10px',
        backgroundPosition: '0 -23px',
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    opacity: 0.3,
                    backgroundImage: `radial-gradient(currentColor 0%, currentColor 16%, transparent 42%)`
                }
            },
            ...Object.entries(theme.palette).filter((0, $0fa40ac3f678fedb$var$_createSimplePaletteValueFilter.default)()).map(([color])=>{
                const backgroundColor = $0fa40ac3f678fedb$var$getColorShade(theme, color);
                return {
                    props: {
                        color: color
                    },
                    style: {
                        backgroundImage: `radial-gradient(${backgroundColor} 0%, ${backgroundColor} 16%, transparent 42%)`
                    }
                };
            })
        ]
    })), $0fa40ac3f678fedb$var$bufferAnimation || {
    // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
    animation: `${$0fa40ac3f678fedb$var$bufferKeyframe} 3s infinite linear`
});
const $0fa40ac3f678fedb$var$LinearProgressBar1 = (0, $aAbgT.styled)('span', {
    name: 'MuiLinearProgress',
    slot: 'Bar1',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles.bar1,
            styles[`barColor${(0, $0fa40ac3f678fedb$var$_capitalize.default)(ownerState.color)}`],
            (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar1Indeterminate,
            ownerState.variant === 'determinate' && styles.bar1Determinate,
            ownerState.variant === 'buffer' && styles.bar1Buffer
        ];
    }
})((0, $0fa40ac3f678fedb$var$_memoTheme.default)(({ theme: theme })=>({
        width: '100%',
        position: 'absolute',
        left: 0,
        bottom: 0,
        top: 0,
        transition: 'transform 0.2s linear',
        transformOrigin: 'left',
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    backgroundColor: 'currentColor'
                }
            },
            ...Object.entries(theme.palette).filter((0, $0fa40ac3f678fedb$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: `transform .${$0fa40ac3f678fedb$var$TRANSITION_DURATION}s linear`
                }
            },
            {
                props: {
                    variant: 'buffer'
                },
                style: {
                    zIndex: 1,
                    transition: `transform .${$0fa40ac3f678fedb$var$TRANSITION_DURATION}s linear`
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: {
                    width: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: $0fa40ac3f678fedb$var$indeterminate1Animation || {
                    animation: `${$0fa40ac3f678fedb$var$indeterminate1Keyframe} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite`
                }
            }
        ]
    })));
const $0fa40ac3f678fedb$var$LinearProgressBar2 = (0, $aAbgT.styled)('span', {
    name: 'MuiLinearProgress',
    slot: 'Bar2',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles.bar2,
            styles[`barColor${(0, $0fa40ac3f678fedb$var$_capitalize.default)(ownerState.color)}`],
            (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar2Indeterminate,
            ownerState.variant === 'buffer' && styles.bar2Buffer
        ];
    }
})((0, $0fa40ac3f678fedb$var$_memoTheme.default)(({ theme: theme })=>({
        width: '100%',
        position: 'absolute',
        left: 0,
        bottom: 0,
        top: 0,
        transition: 'transform 0.2s linear',
        transformOrigin: 'left',
        variants: [
            ...Object.entries(theme.palette).filter((0, $0fa40ac3f678fedb$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--LinearProgressBar2-barColor': (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== 'buffer' && ownerState.color !== 'inherit',
                style: {
                    backgroundColor: 'var(--LinearProgressBar2-barColor, currentColor)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== 'buffer' && ownerState.color === 'inherit',
                style: {
                    backgroundColor: 'currentColor'
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    opacity: 0.3
                }
            },
            ...Object.entries(theme.palette).filter((0, $0fa40ac3f678fedb$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color,
                        variant: 'buffer'
                    },
                    style: {
                        backgroundColor: $0fa40ac3f678fedb$var$getColorShade(theme, color),
                        transition: `transform .${$0fa40ac3f678fedb$var$TRANSITION_DURATION}s linear`
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: {
                    width: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: $0fa40ac3f678fedb$var$indeterminate2Animation || {
                    animation: `${$0fa40ac3f678fedb$var$indeterminate2Keyframe} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite`
                }
            }
        ]
    })));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $0fa40ac3f678fedb$var$LinearProgress = /*#__PURE__*/ $0fa40ac3f678fedb$var$React.forwardRef(function LinearProgress(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiLinearProgress'
    });
    const { className: className, color: color = 'primary', value: value, valueBuffer: valueBuffer, variant: variant = 'indeterminate', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        variant: variant
    };
    const classes = $0fa40ac3f678fedb$var$useUtilityClasses(ownerState);
    const isRtl = (0, $9uEev.useRtl)();
    const rootProps = {};
    const inlineStyles = {
        bar1: {},
        bar2: {}
    };
    if (variant === 'determinate' || variant === 'buffer') {
        if (value !== undefined) {
            rootProps['aria-valuenow'] = Math.round(value);
            rootProps['aria-valuemin'] = 0;
            rootProps['aria-valuemax'] = 100;
            let transform = value - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar1.transform = `translateX(${transform}%)`;
        } else console.error("MUI: You need to provide a value prop when using the determinate or buffer variant of LinearProgress .");
    }
    if (variant === 'buffer') {
        if (valueBuffer !== undefined) {
            let transform = (valueBuffer || 0) - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar2.transform = `translateX(${transform}%)`;
        } else console.error("MUI: You need to provide a valueBuffer prop when using the buffer variant of LinearProgress.");
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($0fa40ac3f678fedb$var$LinearProgressRoot, {
        className: (0, $0fa40ac3f678fedb$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        role: "progressbar",
        ...rootProps,
        ref: ref,
        ...other,
        children: [
            variant === 'buffer' ? /*#__PURE__*/ (0, $ayMG0.jsx)($0fa40ac3f678fedb$var$LinearProgressDashed, {
                className: classes.dashed,
                ownerState: ownerState
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)($0fa40ac3f678fedb$var$LinearProgressBar1, {
                className: classes.bar1,
                ownerState: ownerState,
                style: inlineStyles.bar1
            }),
            variant === 'determinate' ? null : /*#__PURE__*/ (0, $ayMG0.jsx)($0fa40ac3f678fedb$var$LinearProgressBar2, {
                className: classes.bar2,
                ownerState: ownerState,
                style: inlineStyles.bar2
            })
        ]
    });
});
$0fa40ac3f678fedb$var$LinearProgress.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Override or extend the styles applied to the component.
   */ classes: $0fa40ac3f678fedb$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $0fa40ac3f678fedb$var$_propTypes.default.string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */ color: $0fa40ac3f678fedb$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $0fa40ac3f678fedb$var$_propTypes.default.oneOf([
            'inherit',
            'primary',
            'secondary'
        ]),
        $0fa40ac3f678fedb$var$_propTypes.default.string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $0fa40ac3f678fedb$var$_propTypes.default.oneOfType([
        $0fa40ac3f678fedb$var$_propTypes.default.arrayOf($0fa40ac3f678fedb$var$_propTypes.default.oneOfType([
            $0fa40ac3f678fedb$var$_propTypes.default.func,
            $0fa40ac3f678fedb$var$_propTypes.default.object,
            $0fa40ac3f678fedb$var$_propTypes.default.bool
        ])),
        $0fa40ac3f678fedb$var$_propTypes.default.func,
        $0fa40ac3f678fedb$var$_propTypes.default.object
    ]),
    /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */ value: $0fa40ac3f678fedb$var$_propTypes.default.number,
    /**
   * The value for the buffer variant.
   * Value between 0 and 100.
   */ valueBuffer: $0fa40ac3f678fedb$var$_propTypes.default.number,
    /**
   * The variant to use.
   * Use indeterminate or query when there is no progress value.
   * @default 'indeterminate'
   */ variant: $0fa40ac3f678fedb$var$_propTypes.default.oneOf([
        'buffer',
        'determinate',
        'indeterminate',
        'query'
    ])
};
var $0fa40ac3f678fedb$var$_default = module.exports.default = $0fa40ac3f678fedb$var$LinearProgress;

});
parcelRegister("lJgAB", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $fd1aab3db3503e90$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getLinearProgressUtilityClass = $fd1aab3db3503e90$var$getLinearProgressUtilityClass;

var $fd1aab3db3503e90$var$_generateUtilityClasses = $fd1aab3db3503e90$require$_interopRequireDefault((parcelRequire("5nY49")));

var $fd1aab3db3503e90$var$_generateUtilityClass = $fd1aab3db3503e90$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $fd1aab3db3503e90$var$getLinearProgressUtilityClass(slot) {
    return (0, $fd1aab3db3503e90$var$_generateUtilityClass.default)('MuiLinearProgress', slot);
}
const $fd1aab3db3503e90$var$linearProgressClasses = (0, $fd1aab3db3503e90$var$_generateUtilityClasses.default)('MuiLinearProgress', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'determinate',
    'indeterminate',
    'buffer',
    'query',
    'dashed',
    'dashedColorPrimary',
    'dashedColorSecondary',
    'bar',
    'bar1',
    'bar2',
    'barColorPrimary',
    'barColorSecondary',
    'bar1Indeterminate',
    'bar1Determinate',
    'bar1Buffer',
    'bar2Indeterminate',
    'bar2Buffer'
]);
var $fd1aab3db3503e90$var$_default = module.exports.default = $fd1aab3db3503e90$var$linearProgressClasses;

});



parcelRegister("2fe4K", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $1a27e69578e2c56e$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $1a27e69578e2c56e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $1a27e69578e2c56e$var$_exportNames = {
    listItemIconClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $1a27e69578e2c56e$var$_ListItemIcon.default;
    }
});
Object.defineProperty(module.exports, "listItemIconClasses", {
    enumerable: true,
    get: function() {
        return $1a27e69578e2c56e$var$_listItemIconClasses.default;
    }
});

var $1a27e69578e2c56e$var$_ListItemIcon = $1a27e69578e2c56e$require$_interopRequireDefault((parcelRequire("bjZRT")));

var $1a27e69578e2c56e$var$_listItemIconClasses = $1a27e69578e2c56e$require$_interopRequireWildcard((parcelRequire("doXfV")));
Object.keys($1a27e69578e2c56e$var$_listItemIconClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1a27e69578e2c56e$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $1a27e69578e2c56e$var$_listItemIconClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1a27e69578e2c56e$var$_listItemIconClasses[key];
        }
    });
});

});
parcelRegister("bjZRT", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $83e175cb7e49d325$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $83e175cb7e49d325$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83e175cb7e49d325$var$React = $83e175cb7e49d325$require$_interopRequireWildcard((parcelRequire("acw62")));

var $83e175cb7e49d325$var$_propTypes = $83e175cb7e49d325$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $83e175cb7e49d325$var$_clsx = $83e175cb7e49d325$require$_interopRequireDefault((parcelRequire("9QePP")));

var $83e175cb7e49d325$var$_composeClasses = $83e175cb7e49d325$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $83e175cb7e49d325$var$_memoTheme = $83e175cb7e49d325$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $doXfV = parcelRequire("doXfV");

var $83e175cb7e49d325$var$_ListContext = $83e175cb7e49d325$require$_interopRequireDefault((parcelRequire("3W6ht")));

var $ayMG0 = parcelRequire("ayMG0");
const $83e175cb7e49d325$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            alignItems === 'flex-start' && 'alignItemsFlexStart'
        ]
    };
    return (0, $83e175cb7e49d325$var$_composeClasses.default)(slots, $doXfV.getListItemIconUtilityClass, classes);
};
const $83e175cb7e49d325$var$ListItemIconRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiListItemIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart
        ];
    }
})((0, $83e175cb7e49d325$var$_memoTheme.default)(({ theme: theme })=>({
        minWidth: 56,
        color: (theme.vars || theme).palette.action.active,
        flexShrink: 0,
        display: 'inline-flex',
        variants: [
            {
                props: {
                    alignItems: 'flex-start'
                },
                style: {
                    marginTop: 8
                }
            }
        ]
    })));
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ const $83e175cb7e49d325$var$ListItemIcon = /*#__PURE__*/ $83e175cb7e49d325$var$React.forwardRef(function ListItemIcon(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemIcon'
    });
    const { className: className, ...other } = props;
    const context = $83e175cb7e49d325$var$React.useContext($83e175cb7e49d325$var$_ListContext.default);
    const ownerState = {
        ...props,
        alignItems: context.alignItems
    };
    const classes = $83e175cb7e49d325$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($83e175cb7e49d325$var$ListItemIconRoot, {
        className: (0, $83e175cb7e49d325$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
$83e175cb7e49d325$var$ListItemIcon.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component, normally `Icon`, `SvgIcon`,
   * or a `@mui/icons-material` SVG icon element.
   */ children: $83e175cb7e49d325$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $83e175cb7e49d325$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $83e175cb7e49d325$var$_propTypes.default.string,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $83e175cb7e49d325$var$_propTypes.default.oneOfType([
        $83e175cb7e49d325$var$_propTypes.default.arrayOf($83e175cb7e49d325$var$_propTypes.default.oneOfType([
            $83e175cb7e49d325$var$_propTypes.default.func,
            $83e175cb7e49d325$var$_propTypes.default.object,
            $83e175cb7e49d325$var$_propTypes.default.bool
        ])),
        $83e175cb7e49d325$var$_propTypes.default.func,
        $83e175cb7e49d325$var$_propTypes.default.object
    ])
};
var $83e175cb7e49d325$var$_default = module.exports.default = $83e175cb7e49d325$var$ListItemIcon;

});
parcelRegister("doXfV", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9c1b7b40cd19f5fe$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getListItemIconUtilityClass = $9c1b7b40cd19f5fe$var$getListItemIconUtilityClass;

var $9c1b7b40cd19f5fe$var$_generateUtilityClasses = $9c1b7b40cd19f5fe$require$_interopRequireDefault((parcelRequire("5nY49")));

var $9c1b7b40cd19f5fe$var$_generateUtilityClass = $9c1b7b40cd19f5fe$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $9c1b7b40cd19f5fe$var$getListItemIconUtilityClass(slot) {
    return (0, $9c1b7b40cd19f5fe$var$_generateUtilityClass.default)('MuiListItemIcon', slot);
}
const $9c1b7b40cd19f5fe$var$listItemIconClasses = (0, $9c1b7b40cd19f5fe$var$_generateUtilityClasses.default)('MuiListItemIcon', [
    'root',
    'alignItemsFlexStart'
]);
var $9c1b7b40cd19f5fe$var$_default = module.exports.default = $9c1b7b40cd19f5fe$var$listItemIconClasses;

});

parcelRegister("3W6ht", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $2ddba918a398c481$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ddba918a398c481$var$React = $2ddba918a398c481$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * @ignore - internal component.
 */ const $2ddba918a398c481$var$ListContext = /*#__PURE__*/ $2ddba918a398c481$var$React.createContext({});
$2ddba918a398c481$var$ListContext.displayName = 'ListContext';
var $2ddba918a398c481$var$_default = module.exports.default = $2ddba918a398c481$var$ListContext;

});



parcelRegister("djLZl", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $9b22463c6c37319f$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $9b22463c6c37319f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $9b22463c6c37319f$var$_exportNames = {
    listItemTextClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9b22463c6c37319f$var$_ListItemText.default;
    }
});
Object.defineProperty(module.exports, "listItemTextClasses", {
    enumerable: true,
    get: function() {
        return $9b22463c6c37319f$var$_listItemTextClasses.default;
    }
});

var $9b22463c6c37319f$var$_ListItemText = $9b22463c6c37319f$require$_interopRequireDefault((parcelRequire("19ocJ")));

var $9b22463c6c37319f$var$_listItemTextClasses = $9b22463c6c37319f$require$_interopRequireWildcard((parcelRequire("guz4p")));
Object.keys($9b22463c6c37319f$var$_listItemTextClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($9b22463c6c37319f$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $9b22463c6c37319f$var$_listItemTextClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9b22463c6c37319f$var$_listItemTextClasses[key];
        }
    });
});

});
parcelRegister("19ocJ", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $0d696835f9b43a35$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $0d696835f9b43a35$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0d696835f9b43a35$var$React = $0d696835f9b43a35$require$_interopRequireWildcard((parcelRequire("acw62")));

var $0d696835f9b43a35$var$_propTypes = $0d696835f9b43a35$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $0d696835f9b43a35$var$_clsx = $0d696835f9b43a35$require$_interopRequireDefault((parcelRequire("9QePP")));

var $0d696835f9b43a35$var$_composeClasses = $0d696835f9b43a35$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $0d696835f9b43a35$var$_Typography = $0d696835f9b43a35$require$_interopRequireWildcard((parcelRequire("2dUd7")));

var $0d696835f9b43a35$var$_ListContext = $0d696835f9b43a35$require$_interopRequireDefault((parcelRequire("3W6ht")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $0d696835f9b43a35$var$_listItemTextClasses = $0d696835f9b43a35$require$_interopRequireWildcard((parcelRequire("guz4p")));

var $0d696835f9b43a35$var$_useSlot = $0d696835f9b43a35$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $0d696835f9b43a35$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, inset: inset, primary: primary, secondary: secondary, dense: dense } = ownerState;
    const slots = {
        root: [
            'root',
            inset && 'inset',
            dense && 'dense',
            primary && secondary && 'multiline'
        ],
        primary: [
            'primary'
        ],
        secondary: [
            'secondary'
        ]
    };
    return (0, $0d696835f9b43a35$var$_composeClasses.default)(slots, $0d696835f9b43a35$var$_listItemTextClasses.getListItemTextUtilityClass, classes);
};
const $0d696835f9b43a35$var$ListItemTextRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiListItemText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${$0d696835f9b43a35$var$_listItemTextClasses.default.primary}`]: styles.primary
            },
            {
                [`& .${$0d696835f9b43a35$var$_listItemTextClasses.default.secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})({
    flex: '1 1 auto',
    minWidth: 0,
    marginTop: 4,
    marginBottom: 4,
    // Combine this and the below selector once https://github.com/emotion-js/emotion/issues/3366 is solved
    [`.${$0d696835f9b43a35$var$_Typography.typographyClasses.root}:where(& .${$0d696835f9b43a35$var$_listItemTextClasses.default.primary})`]: {
        display: 'block'
    },
    [`.${$0d696835f9b43a35$var$_Typography.typographyClasses.root}:where(& .${$0d696835f9b43a35$var$_listItemTextClasses.default.secondary})`]: {
        display: 'block'
    },
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.primary && ownerState.secondary,
            style: {
                marginTop: 6,
                marginBottom: 6
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.inset,
            style: {
                paddingLeft: 56
            }
        }
    ]
});
const $0d696835f9b43a35$var$ListItemText = /*#__PURE__*/ $0d696835f9b43a35$var$React.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemText'
    });
    const { children: children, className: className, disableTypography: disableTypography = false, inset: inset = false, primary: primaryProp, primaryTypographyProps: primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps: secondaryTypographyProps, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const { dense: dense } = $0d696835f9b43a35$var$React.useContext($0d696835f9b43a35$var$_ListContext.default);
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = {
        ...props,
        disableTypography: disableTypography,
        inset: inset,
        primary: !!primary,
        secondary: !!secondary,
        dense: dense
    };
    const classes = $0d696835f9b43a35$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            primary: primaryTypographyProps,
            secondary: secondaryTypographyProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, $0d696835f9b43a35$var$_useSlot.default)('root', {
        className: (0, $0d696835f9b43a35$var$_clsx.default)(classes.root, className),
        elementType: $0d696835f9b43a35$var$ListItemTextRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        ref: ref
    });
    const [PrimarySlot, primarySlotProps] = (0, $0d696835f9b43a35$var$_useSlot.default)('primary', {
        className: classes.primary,
        elementType: $0d696835f9b43a35$var$_Typography.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SecondarySlot, secondarySlotProps] = (0, $0d696835f9b43a35$var$_useSlot.default)('secondary', {
        className: classes.secondary,
        elementType: $0d696835f9b43a35$var$_Typography.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    if (primary != null && primary.type !== $0d696835f9b43a35$var$_Typography.default && !disableTypography) primary = /*#__PURE__*/ (0, $ayMG0.jsx)(PrimarySlot, {
        variant: dense ? 'body2' : 'body1',
        component: primarySlotProps?.variant ? undefined : 'span',
        ...primarySlotProps,
        children: primary
    });
    if (secondary != null && secondary.type !== $0d696835f9b43a35$var$_Typography.default && !disableTypography) secondary = /*#__PURE__*/ (0, $ayMG0.jsx)(SecondarySlot, {
        variant: "body2",
        color: "textSecondary",
        ...secondarySlotProps,
        children: secondary
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            primary,
            secondary
        ]
    });
});
$0d696835f9b43a35$var$ListItemText.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Alias for the `primary` prop.
   */ children: $0d696835f9b43a35$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $0d696835f9b43a35$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $0d696835f9b43a35$var$_propTypes.default.string,
    /**
   * If `true`, the children won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `children` (or `primary`) text, and optional `secondary` text
   * with the Typography component.
   * @default false
   */ disableTypography: $0d696835f9b43a35$var$_propTypes.default.bool,
    /**
   * If `true`, the children are indented.
   * This should be used if there is no left avatar or left icon.
   * @default false
   */ inset: $0d696835f9b43a35$var$_propTypes.default.bool,
    /**
   * The main content element.
   */ primary: $0d696835f9b43a35$var$_propTypes.default.node,
    /**
   * These props will be forwarded to the primary typography component
   * (as long as disableTypography is not `true`).
   * @deprecated Use `slotProps.primary` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ primaryTypographyProps: $0d696835f9b43a35$var$_propTypes.default.object,
    /**
   * The secondary content element.
   */ secondary: $0d696835f9b43a35$var$_propTypes.default.node,
    /**
   * These props will be forwarded to the secondary typography component
   * (as long as disableTypography is not `true`).
   * @deprecated Use `slotProps.secondary` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ secondaryTypographyProps: $0d696835f9b43a35$var$_propTypes.default.object,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $0d696835f9b43a35$var$_propTypes.default.shape({
        primary: $0d696835f9b43a35$var$_propTypes.default.oneOfType([
            $0d696835f9b43a35$var$_propTypes.default.func,
            $0d696835f9b43a35$var$_propTypes.default.object
        ]),
        root: $0d696835f9b43a35$var$_propTypes.default.oneOfType([
            $0d696835f9b43a35$var$_propTypes.default.func,
            $0d696835f9b43a35$var$_propTypes.default.object
        ]),
        secondary: $0d696835f9b43a35$var$_propTypes.default.oneOfType([
            $0d696835f9b43a35$var$_propTypes.default.func,
            $0d696835f9b43a35$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: $0d696835f9b43a35$var$_propTypes.default.shape({
        primary: $0d696835f9b43a35$var$_propTypes.default.elementType,
        root: $0d696835f9b43a35$var$_propTypes.default.elementType,
        secondary: $0d696835f9b43a35$var$_propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $0d696835f9b43a35$var$_propTypes.default.oneOfType([
        $0d696835f9b43a35$var$_propTypes.default.arrayOf($0d696835f9b43a35$var$_propTypes.default.oneOfType([
            $0d696835f9b43a35$var$_propTypes.default.func,
            $0d696835f9b43a35$var$_propTypes.default.object,
            $0d696835f9b43a35$var$_propTypes.default.bool
        ])),
        $0d696835f9b43a35$var$_propTypes.default.func,
        $0d696835f9b43a35$var$_propTypes.default.object
    ])
};
var $0d696835f9b43a35$var$_default = module.exports.default = $0d696835f9b43a35$var$ListItemText;

});
parcelRegister("2dUd7", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $19e865ef3ed82f53$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $19e865ef3ed82f53$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $19e865ef3ed82f53$var$_exportNames = {
    typographyClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $19e865ef3ed82f53$var$_Typography.default;
    }
});
Object.defineProperty(module.exports, "typographyClasses", {
    enumerable: true,
    get: function() {
        return $19e865ef3ed82f53$var$_typographyClasses.default;
    }
});

var $19e865ef3ed82f53$var$_Typography = $19e865ef3ed82f53$require$_interopRequireDefault((parcelRequire("3bYfT")));

var $19e865ef3ed82f53$var$_typographyClasses = $19e865ef3ed82f53$require$_interopRequireWildcard((parcelRequire("bhKtZ")));
Object.keys($19e865ef3ed82f53$var$_typographyClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($19e865ef3ed82f53$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $19e865ef3ed82f53$var$_typographyClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $19e865ef3ed82f53$var$_typographyClasses[key];
        }
    });
});

});
parcelRegister("3bYfT", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $2531239e3a525689$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $2531239e3a525689$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.TypographyRoot = void 0;

var $2531239e3a525689$var$React = $2531239e3a525689$require$_interopRequireWildcard((parcelRequire("acw62")));

var $2531239e3a525689$var$_propTypes = $2531239e3a525689$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $2531239e3a525689$var$_clsx = $2531239e3a525689$require$_interopRequireDefault((parcelRequire("9QePP")));

var $2531239e3a525689$var$_composeClasses = $2531239e3a525689$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $2531239e3a525689$var$_memoTheme = $2531239e3a525689$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $2531239e3a525689$var$_capitalize = $2531239e3a525689$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $2531239e3a525689$var$_createSimplePaletteValueFilter = $2531239e3a525689$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $bhKtZ = parcelRequire("bhKtZ");

var $ayMG0 = parcelRequire("ayMG0");
const $2531239e3a525689$var$v6Colors = {
    primary: true,
    secondary: true,
    error: true,
    info: true,
    success: true,
    warning: true,
    textPrimary: true,
    textSecondary: true,
    textDisabled: true
};
const $2531239e3a525689$var$extendSxProp = (0, $aAbgT.internal_createExtendSxProp)();
const $2531239e3a525689$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, $2531239e3a525689$var$_capitalize.default)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap',
            paragraph && 'paragraph'
        ]
    };
    return (0, $2531239e3a525689$var$_composeClasses.default)(slots, $bhKtZ.getTypographyUtilityClass, classes);
};
const $2531239e3a525689$var$TypographyRoot = module.exports.TypographyRoot = (0, $aAbgT.styled)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, $2531239e3a525689$var$_capitalize.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})((0, $2531239e3a525689$var$_memoTheme.default)(({ theme: theme })=>({
        margin: 0,
        variants: [
            {
                props: {
                    variant: 'inherit'
                },
                style: {
                    // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
                    font: 'inherit',
                    lineHeight: 'inherit',
                    letterSpacing: 'inherit'
                }
            },
            ...Object.entries(theme.typography).filter(([variant, value])=>variant !== 'inherit' && value && typeof value === 'object').map(([variant, value])=>({
                    props: {
                        variant: variant
                    },
                    style: value
                })),
            ...Object.entries(theme.palette).filter((0, $2531239e3a525689$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette?.text || {}).filter(([, value])=>typeof value === 'string').map(([color])=>({
                    props: {
                        color: `text${(0, $2531239e3a525689$var$_capitalize.default)(color)}`
                    },
                    style: {
                        color: (theme.vars || theme).palette.text[color]
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.align !== 'inherit',
                style: {
                    textAlign: 'var(--Typography-textAlign)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.noWrap,
                style: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.gutterBottom,
                style: {
                    marginBottom: '0.35em'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.paragraph,
                style: {
                    marginBottom: 16
                }
            }
        ]
    })));
const $2531239e3a525689$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
const $2531239e3a525689$var$Typography = /*#__PURE__*/ $2531239e3a525689$var$React.forwardRef(function Typography(inProps, ref) {
    const { color: color, ...themeProps } = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiTypography'
    });
    const isSxColor = !$2531239e3a525689$var$v6Colors[color];
    // TODO: Remove `extendSxProp` in v7
    const props = $2531239e3a525689$var$extendSxProp({
        ...themeProps,
        ...isSxColor && {
            color: color
        }
    });
    const { align: align = 'inherit', className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = 'body1', variantMapping: variantMapping = $2531239e3a525689$var$defaultVariantMapping, ...other } = props;
    const ownerState = {
        ...props,
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    };
    const Component = component || (paragraph ? 'p' : variantMapping[variant] || $2531239e3a525689$var$defaultVariantMapping[variant]) || 'span';
    const classes = $2531239e3a525689$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($2531239e3a525689$var$TypographyRoot, {
        as: Component,
        ref: ref,
        className: (0, $2531239e3a525689$var$_clsx.default)(classes.root, className),
        ...other,
        ownerState: ownerState,
        style: {
            ...align !== 'inherit' && {
                '--Typography-textAlign': align
            },
            ...other.style
        }
    });
});
$2531239e3a525689$var$Typography.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Set the text-align on the component.
   * @default 'inherit'
   */ align: $2531239e3a525689$var$_propTypes.default.oneOf([
        'center',
        'inherit',
        'justify',
        'left',
        'right'
    ]),
    /**
   * The content of the component.
   */ children: $2531239e3a525689$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $2531239e3a525689$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $2531239e3a525689$var$_propTypes.default.string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */ color: $2531239e3a525689$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $2531239e3a525689$var$_propTypes.default.oneOf([
            'primary',
            'secondary',
            'success',
            'error',
            'info',
            'warning',
            'textPrimary',
            'textSecondary',
            'textDisabled'
        ]),
        $2531239e3a525689$var$_propTypes.default.string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $2531239e3a525689$var$_propTypes.default.elementType,
    /**
   * If `true`, the text will have a bottom margin.
   * @default false
   */ gutterBottom: $2531239e3a525689$var$_propTypes.default.bool,
    /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   * @default false
   */ noWrap: $2531239e3a525689$var$_propTypes.default.bool,
    /**
   * If `true`, the element will be a paragraph element.
   * @default false
   * @deprecated Use the `component` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ paragraph: $2531239e3a525689$var$_propTypes.default.bool,
    /**
   * @ignore
   */ style: $2531239e3a525689$var$_propTypes.default.object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $2531239e3a525689$var$_propTypes.default.oneOfType([
        $2531239e3a525689$var$_propTypes.default.arrayOf($2531239e3a525689$var$_propTypes.default.oneOfType([
            $2531239e3a525689$var$_propTypes.default.func,
            $2531239e3a525689$var$_propTypes.default.object,
            $2531239e3a525689$var$_propTypes.default.bool
        ])),
        $2531239e3a525689$var$_propTypes.default.func,
        $2531239e3a525689$var$_propTypes.default.object
    ]),
    /**
   * Applies the theme typography styles.
   * @default 'body1'
   */ variant: $2531239e3a525689$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $2531239e3a525689$var$_propTypes.default.oneOf([
            'body1',
            'body2',
            'button',
            'caption',
            'h1',
            'h2',
            'h3',
            'h4',
            'h5',
            'h6',
            'inherit',
            'overline',
            'subtitle1',
            'subtitle2'
        ]),
        $2531239e3a525689$var$_propTypes.default.string
    ]),
    /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'h6',
   *   body1: 'p',
   *   body2: 'p',
   *   inherit: 'p',
   * }
   */ variantMapping: $2531239e3a525689$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .object
};
var $2531239e3a525689$var$_default = module.exports.default = $2531239e3a525689$var$Typography;

});
parcelRegister("bhKtZ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $837556bdf75d281f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getTypographyUtilityClass = $837556bdf75d281f$var$getTypographyUtilityClass;

var $837556bdf75d281f$var$_generateUtilityClasses = $837556bdf75d281f$require$_interopRequireDefault((parcelRequire("5nY49")));

var $837556bdf75d281f$var$_generateUtilityClass = $837556bdf75d281f$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $837556bdf75d281f$var$getTypographyUtilityClass(slot) {
    return (0, $837556bdf75d281f$var$_generateUtilityClass.default)('MuiTypography', slot);
}
const $837556bdf75d281f$var$typographyClasses = (0, $837556bdf75d281f$var$_generateUtilityClasses.default)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom',
    'paragraph'
]);
var $837556bdf75d281f$var$_default = module.exports.default = $837556bdf75d281f$var$typographyClasses;

});



parcelRegister("guz4p", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c01aa6ddbe5e68bd$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getListItemTextUtilityClass = $c01aa6ddbe5e68bd$var$getListItemTextUtilityClass;

var $c01aa6ddbe5e68bd$var$_generateUtilityClasses = $c01aa6ddbe5e68bd$require$_interopRequireDefault((parcelRequire("5nY49")));

var $c01aa6ddbe5e68bd$var$_generateUtilityClass = $c01aa6ddbe5e68bd$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $c01aa6ddbe5e68bd$var$getListItemTextUtilityClass(slot) {
    return (0, $c01aa6ddbe5e68bd$var$_generateUtilityClass.default)('MuiListItemText', slot);
}
const $c01aa6ddbe5e68bd$var$listItemTextClasses = (0, $c01aa6ddbe5e68bd$var$_generateUtilityClasses.default)('MuiListItemText', [
    'root',
    'multiline',
    'dense',
    'inset',
    'primary',
    'secondary'
]);
var $c01aa6ddbe5e68bd$var$_default = module.exports.default = $c01aa6ddbe5e68bd$var$listItemTextClasses;

});



parcelRegister("8qqwQ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $6225548018c22e00$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $6225548018c22e00$var$_MenuList.default;
    }
});

var $6225548018c22e00$var$_MenuList = $6225548018c22e00$require$_interopRequireDefault((parcelRequire("lBOb7")));

});
parcelRegister("lBOb7", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $fbb3fa0cdc277971$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $fbb3fa0cdc277971$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fbb3fa0cdc277971$var$React = $fbb3fa0cdc277971$require$_interopRequireWildcard((parcelRequire("acw62")));

var $4jPKB = parcelRequire("4jPKB");

var $fbb3fa0cdc277971$var$_propTypes = $fbb3fa0cdc277971$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $fbb3fa0cdc277971$var$_ownerDocument = $fbb3fa0cdc277971$require$_interopRequireDefault((parcelRequire("gzyUk")));

var $fbb3fa0cdc277971$var$_List = $fbb3fa0cdc277971$require$_interopRequireDefault((parcelRequire("ib3g2")));

var $fbb3fa0cdc277971$var$_getActiveElement = $fbb3fa0cdc277971$require$_interopRequireDefault((parcelRequire("6uU67")));

var $fbb3fa0cdc277971$var$_getScrollbarSize = $fbb3fa0cdc277971$require$_interopRequireDefault((parcelRequire("19SuQ")));

var $fbb3fa0cdc277971$var$_useForkRef = $fbb3fa0cdc277971$require$_interopRequireDefault((parcelRequire("9Rgf1")));

var $fbb3fa0cdc277971$var$_useEnhancedEffect = $fbb3fa0cdc277971$require$_interopRequireDefault((parcelRequire("khjmj")));

var $hGPki = parcelRequire("hGPki");

var $ayMG0 = parcelRequire("ayMG0");
function $fbb3fa0cdc277971$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $fbb3fa0cdc277971$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $fbb3fa0cdc277971$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.startsWith(textCriteria.keys.join(''));
}
function $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || !$fbb3fa0cdc277971$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $fbb3fa0cdc277971$var$MenuList = /*#__PURE__*/ $fbb3fa0cdc277971$var$React.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = 'selectedMenu', ...other } = props;
    const listRef = $fbb3fa0cdc277971$var$React.useRef(null);
    const textCriteriaRef = $fbb3fa0cdc277971$var$React.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $fbb3fa0cdc277971$var$_useEnhancedEffect.default)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $fbb3fa0cdc277971$var$React.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction: direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $fbb3fa0cdc277971$var$_getScrollbarSize.default)((0, $hGPki.ownerWindow)(containerElement))}px`;
                    listRef.current.style[direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        const isModifierKeyPressed = event.ctrlKey || event.metaKey || event.altKey;
        if (isModifierKeyPressed) {
            if (onKeyDown) onKeyDown(event);
            return;
        }
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $fbb3fa0cdc277971$var$_getActiveElement.default)((0, $fbb3fa0cdc277971$var$_ownerDocument.default)(list));
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$nextItem);
        } else if (key === 'ArrowUp') {
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$previousItem);
        } else if (key === 'Home') {
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$nextItem);
        } else if (key === 'End') {
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $fbb3fa0cdc277971$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $fbb3fa0cdc277971$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $fbb3fa0cdc277971$var$_useForkRef.default)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $fbb3fa0cdc277971$var$React.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $fbb3fa0cdc277971$var$React.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if ((0, $4jPKB.isFragment)(child)) console.error([
            "MUI: The Menu component doesn't accept a Fragment as a child.",
            'Consider providing an array instead.'
        ].join('\n'));
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $fbb3fa0cdc277971$var$React.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $fbb3fa0cdc277971$var$React.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($fbb3fa0cdc277971$var$_List.default, {
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1,
        ...other,
        children: items
    });
});
$fbb3fa0cdc277971$var$MenuList.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */ autoFocus: $fbb3fa0cdc277971$var$_propTypes.default.bool,
    /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */ autoFocusItem: $fbb3fa0cdc277971$var$_propTypes.default.bool,
    /**
   * MenuList contents, normally `MenuItem`s.
   */ children: $fbb3fa0cdc277971$var$_propTypes.default.node,
    /**
   * @ignore
   */ className: $fbb3fa0cdc277971$var$_propTypes.default.string,
    /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */ disabledItemsFocusable: $fbb3fa0cdc277971$var$_propTypes.default.bool,
    /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */ disableListWrap: $fbb3fa0cdc277971$var$_propTypes.default.bool,
    /**
   * @ignore
   */ onKeyDown: $fbb3fa0cdc277971$var$_propTypes.default.func,
    /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */ variant: $fbb3fa0cdc277971$var$_propTypes.default.oneOf([
        'menu',
        'selectedMenu'
    ])
};
var $fbb3fa0cdc277971$var$_default = module.exports.default = $fbb3fa0cdc277971$var$MenuList;

});
parcelRegister("ib3g2", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $d3bbc7f720921ac7$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $d3bbc7f720921ac7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $d3bbc7f720921ac7$var$_exportNames = {
    listClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $d3bbc7f720921ac7$var$_List.default;
    }
});
Object.defineProperty(module.exports, "listClasses", {
    enumerable: true,
    get: function() {
        return $d3bbc7f720921ac7$var$_listClasses.default;
    }
});

var $d3bbc7f720921ac7$var$_List = $d3bbc7f720921ac7$require$_interopRequireDefault((parcelRequire("8AyZl")));

var $d3bbc7f720921ac7$var$_listClasses = $d3bbc7f720921ac7$require$_interopRequireWildcard((parcelRequire("eUMjp")));
Object.keys($d3bbc7f720921ac7$var$_listClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d3bbc7f720921ac7$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d3bbc7f720921ac7$var$_listClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d3bbc7f720921ac7$var$_listClasses[key];
        }
    });
});

});
parcelRegister("8AyZl", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $640cd381f5e8b3ea$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $640cd381f5e8b3ea$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $640cd381f5e8b3ea$var$React = $640cd381f5e8b3ea$require$_interopRequireWildcard((parcelRequire("acw62")));

var $640cd381f5e8b3ea$var$_propTypes = $640cd381f5e8b3ea$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $640cd381f5e8b3ea$var$_clsx = $640cd381f5e8b3ea$require$_interopRequireDefault((parcelRequire("9QePP")));

var $640cd381f5e8b3ea$var$_composeClasses = $640cd381f5e8b3ea$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $640cd381f5e8b3ea$var$_ListContext = $640cd381f5e8b3ea$require$_interopRequireDefault((parcelRequire("3W6ht")));

var $eUMjp = parcelRequire("eUMjp");

var $ayMG0 = parcelRequire("ayMG0");
const $640cd381f5e8b3ea$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            'root',
            !disablePadding && 'padding',
            dense && 'dense',
            subheader && 'subheader'
        ]
    };
    return (0, $640cd381f5e8b3ea$var$_composeClasses.default)(slots, $eUMjp.getListUtilityClass, classes);
};
const $640cd381f5e8b3ea$var$ListRoot = (0, $aAbgT.styled)('ul', {
    name: 'MuiList',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})({
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative',
    variants: [
        {
            props: ({ ownerState: ownerState })=>!ownerState.disablePadding,
            style: {
                paddingTop: 8,
                paddingBottom: 8
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.subheader,
            style: {
                paddingTop: 0
            }
        }
    ]
});
const $640cd381f5e8b3ea$var$List = /*#__PURE__*/ $640cd381f5e8b3ea$var$React.forwardRef(function List(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiList'
    });
    const { children: children, className: className, component: component = 'ul', dense: dense = false, disablePadding: disablePadding = false, subheader: subheader, ...other } = props;
    const context = $640cd381f5e8b3ea$var$React.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = {
        ...props,
        component: component,
        dense: dense,
        disablePadding: disablePadding
    };
    const classes = $640cd381f5e8b3ea$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($640cd381f5e8b3ea$var$_ListContext.default.Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($640cd381f5e8b3ea$var$ListRoot, {
            as: component,
            className: (0, $640cd381f5e8b3ea$var$_clsx.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState,
            ...other,
            children: [
                subheader,
                children
            ]
        })
    });
});
$640cd381f5e8b3ea$var$List.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: $640cd381f5e8b3ea$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $640cd381f5e8b3ea$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $640cd381f5e8b3ea$var$_propTypes.default.string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $640cd381f5e8b3ea$var$_propTypes.default.elementType,
    /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */ dense: $640cd381f5e8b3ea$var$_propTypes.default.bool,
    /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */ disablePadding: $640cd381f5e8b3ea$var$_propTypes.default.bool,
    /**
   * The content of the subheader, normally `ListSubheader`.
   */ subheader: $640cd381f5e8b3ea$var$_propTypes.default.node,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $640cd381f5e8b3ea$var$_propTypes.default.oneOfType([
        $640cd381f5e8b3ea$var$_propTypes.default.arrayOf($640cd381f5e8b3ea$var$_propTypes.default.oneOfType([
            $640cd381f5e8b3ea$var$_propTypes.default.func,
            $640cd381f5e8b3ea$var$_propTypes.default.object,
            $640cd381f5e8b3ea$var$_propTypes.default.bool
        ])),
        $640cd381f5e8b3ea$var$_propTypes.default.func,
        $640cd381f5e8b3ea$var$_propTypes.default.object
    ])
};
var $640cd381f5e8b3ea$var$_default = module.exports.default = $640cd381f5e8b3ea$var$List;

});
parcelRegister("eUMjp", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $adbbc5717e0d0350$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getListUtilityClass = $adbbc5717e0d0350$var$getListUtilityClass;

var $adbbc5717e0d0350$var$_generateUtilityClasses = $adbbc5717e0d0350$require$_interopRequireDefault((parcelRequire("5nY49")));

var $adbbc5717e0d0350$var$_generateUtilityClass = $adbbc5717e0d0350$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $adbbc5717e0d0350$var$getListUtilityClass(slot) {
    return (0, $adbbc5717e0d0350$var$_generateUtilityClass.default)('MuiList', slot);
}
const $adbbc5717e0d0350$var$listClasses = (0, $adbbc5717e0d0350$var$_generateUtilityClasses.default)('MuiList', [
    'root',
    'padding',
    'dense',
    'subheader'
]);
var $adbbc5717e0d0350$var$_default = module.exports.default = $adbbc5717e0d0350$var$listClasses;

});



parcelRegister("19SuQ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0d80e79907b6bdbc$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0d80e79907b6bdbc$var$_getScrollbarSize = $0d80e79907b6bdbc$require$_interopRequireDefault((parcelRequire("71aFq")));
var $0d80e79907b6bdbc$var$_default = module.exports.default = $0d80e79907b6bdbc$var$_getScrollbarSize.default;

});
parcelRegister("71aFq", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $51c0e6a6ca0c4663$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $51c0e6a6ca0c4663$var$_getScrollbarSize.default;
    }
});

var $51c0e6a6ca0c4663$var$_getScrollbarSize = $51c0e6a6ca0c4663$require$_interopRequireDefault((parcelRequire("2Fa2r")));

});
parcelRegister("2Fa2r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1f0732850f39cffc$var$getScrollbarSize;
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $1f0732850f39cffc$var$getScrollbarSize(win = window) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = win.document.documentElement.clientWidth;
    return win.innerWidth - documentWidth;
}

});





parcelRegister("iZ4W7", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $dd21c0ca7e345443$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $dd21c0ca7e345443$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $dd21c0ca7e345443$var$_exportNames = {
    menuItemClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $dd21c0ca7e345443$var$_MenuItem.default;
    }
});
Object.defineProperty(module.exports, "menuItemClasses", {
    enumerable: true,
    get: function() {
        return $dd21c0ca7e345443$var$_menuItemClasses.default;
    }
});

var $dd21c0ca7e345443$var$_MenuItem = $dd21c0ca7e345443$require$_interopRequireDefault((parcelRequire("2iAqv")));

var $dd21c0ca7e345443$var$_menuItemClasses = $dd21c0ca7e345443$require$_interopRequireWildcard((parcelRequire("eWb0W")));
Object.keys($dd21c0ca7e345443$var$_menuItemClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($dd21c0ca7e345443$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $dd21c0ca7e345443$var$_menuItemClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dd21c0ca7e345443$var$_menuItemClasses[key];
        }
    });
});

});
parcelRegister("2iAqv", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $1ac984bce84b2164$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $1ac984bce84b2164$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.overridesResolver = module.exports.default = void 0;

var $1ac984bce84b2164$var$React = $1ac984bce84b2164$require$_interopRequireWildcard((parcelRequire("acw62")));

var $1ac984bce84b2164$var$_propTypes = $1ac984bce84b2164$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $1ac984bce84b2164$var$_clsx = $1ac984bce84b2164$require$_interopRequireDefault((parcelRequire("9QePP")));

var $1ac984bce84b2164$var$_composeClasses = $1ac984bce84b2164$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $1ac984bce84b2164$var$_rootShouldForwardProp = $1ac984bce84b2164$require$_interopRequireDefault((parcelRequire("8Uq77")));

var $aAbgT = parcelRequire("aAbgT");

var $1ac984bce84b2164$var$_memoTheme = $1ac984bce84b2164$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $1ac984bce84b2164$var$_ListContext = $1ac984bce84b2164$require$_interopRequireDefault((parcelRequire("3W6ht")));

var $1ac984bce84b2164$var$_ButtonBase = $1ac984bce84b2164$require$_interopRequireDefault((parcelRequire("hhs3r")));

var $1ac984bce84b2164$var$_useEnhancedEffect = $1ac984bce84b2164$require$_interopRequireDefault((parcelRequire("khjmj")));

var $1ac984bce84b2164$var$_useForkRef = $1ac984bce84b2164$require$_interopRequireDefault((parcelRequire("9Rgf1")));

var $g6BeY = parcelRequire("g6BeY");

var $2fe4K = parcelRequire("2fe4K");

var $djLZl = parcelRequire("djLZl");

var $1ac984bce84b2164$var$_menuItemClasses = $1ac984bce84b2164$require$_interopRequireWildcard((parcelRequire("eWb0W")));

var $dALxx = parcelRequire("dALxx");

var $ayMG0 = parcelRequire("ayMG0");
/**
 * If autoFocus is an object, it will attempt to call `element.focus()` with the options argument.
 * If the browser doesn't support the options argument, it will fall back to a simple `element.focus()` call.
 */ function $1ac984bce84b2164$var$focusWithVisible(element, focusSource) {
    if (focusSource == null) {
        element.focus();
        return;
    }
    try {
        element.focus({
            focusVisible: focusSource === 'keyboard'
        });
    } catch (error) {
        // If the browser doesn't support the focus options argument, fall back to a simple focus call.
        element.focus();
    }
}
const $1ac984bce84b2164$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
module.exports.overridesResolver = $1ac984bce84b2164$var$overridesResolver;
const $1ac984bce84b2164$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            disabled && 'disabled',
            !disableGutters && 'gutters',
            divider && 'divider',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $1ac984bce84b2164$var$_composeClasses.default)(slots, $1ac984bce84b2164$var$_menuItemClasses.getMenuItemUtilityClass, classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const $1ac984bce84b2164$var$MenuItemRoot = (0, $aAbgT.styled)($1ac984bce84b2164$var$_ButtonBase.default, {
    shouldForwardProp: (prop)=>(0, $1ac984bce84b2164$var$_rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiMenuItem',
    slot: 'Root',
    overridesResolver: $1ac984bce84b2164$var$overridesResolver
})((0, $1ac984bce84b2164$var$_memoTheme.default)(({ theme: theme })=>({
        ...theme.typography.body1,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: 'border-box',
        whiteSpace: 'nowrap',
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${$1ac984bce84b2164$var$_menuItemClasses.default.selected}`]: {
            backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity),
            [`&.${$1ac984bce84b2164$var$_menuItemClasses.default.focusVisible}`]: {
                backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
            }
        },
        [`&.${$1ac984bce84b2164$var$_menuItemClasses.default.selected}:hover`]: {
            backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity)
            }
        },
        [`&.${$1ac984bce84b2164$var$_menuItemClasses.default.focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${$1ac984bce84b2164$var$_menuItemClasses.default.disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${$g6BeY.dividerClasses.root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${$g6BeY.dividerClasses.inset}`]: {
            marginLeft: 52
        },
        [`& .${$djLZl.listItemTextClasses.root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${$djLZl.listItemTextClasses.inset}`]: {
            paddingLeft: 36
        },
        [`& .${$2fe4K.listItemIconClasses.root}`]: {
            minWidth: 36
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.dense,
                style: {
                    [theme.breakpoints.up('sm')]: {
                        minHeight: 'auto'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.dense,
                style: {
                    minHeight: 32,
                    // https://m2.material.io/components/menus#specs > Dense
                    paddingTop: 4,
                    paddingBottom: 4,
                    ...theme.typography.body2,
                    [`& .${$2fe4K.listItemIconClasses.root} svg`]: {
                        fontSize: '1.25rem'
                    }
                }
            }
        ]
    })));
const $1ac984bce84b2164$var$MenuItem = /*#__PURE__*/ $1ac984bce84b2164$var$React.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiMenuItem'
    });
    const { autoFocus: autoFocus = false, component: component = 'li', dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = 'menuitem', tabIndex: tabIndexProp, className: className, ...other } = props;
    const focusSource = (0, $dALxx.useSelectFocusSource)();
    const context = $1ac984bce84b2164$var$React.useContext($1ac984bce84b2164$var$_ListContext.default);
    const childContext = $1ac984bce84b2164$var$React.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $1ac984bce84b2164$var$React.useRef(null);
    (0, $1ac984bce84b2164$var$_useEnhancedEffect.default)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) $1ac984bce84b2164$var$focusWithVisible(menuItemRef.current, focusSource);
            else console.error('MUI: Unable to set focus to a MenuItem whose component has not been rendered.');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        autoFocus
    ]);
    const ownerState = {
        ...props,
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    };
    const classes = $1ac984bce84b2164$var$useUtilityClasses(props);
    const handleRef = (0, $1ac984bce84b2164$var$_useForkRef.default)(menuItemRef, ref);
    // Don't forward the 'root' class to the ButtonBase, as it will get duplicated with the one passed to the className prop.
    const { root: root, ...forwardedClasses } = classes;
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1ac984bce84b2164$var$_ListContext.default.Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($1ac984bce84b2164$var$MenuItemRoot, {
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $1ac984bce84b2164$var$_clsx.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, $1ac984bce84b2164$var$_clsx.default)(classes.root, className),
            ...other,
            ownerState: ownerState,
            classes: forwardedClasses
        })
    });
});
$1ac984bce84b2164$var$MenuItem.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */ autoFocus: $1ac984bce84b2164$var$_propTypes.default.bool,
    /**
   * The content of the component.
   */ children: $1ac984bce84b2164$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $1ac984bce84b2164$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $1ac984bce84b2164$var$_propTypes.default.string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $1ac984bce84b2164$var$_propTypes.default.elementType,
    /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent Menu component.
   * @default false
   */ dense: $1ac984bce84b2164$var$_propTypes.default.bool,
    /**
   * @ignore
   */ disabled: $1ac984bce84b2164$var$_propTypes.default.bool,
    /**
   * If `true`, the left and right padding is removed.
   * @default false
   */ disableGutters: $1ac984bce84b2164$var$_propTypes.default.bool,
    /**
   * If `true`, a 1px light border is added to the bottom of the menu item.
   * @default false
   */ divider: $1ac984bce84b2164$var$_propTypes.default.bool,
    /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */ focusVisibleClassName: $1ac984bce84b2164$var$_propTypes.default.string,
    /**
   * @ignore
   */ role: $1ac984bce84b2164$var$_propTypes.default.string,
    /**
   * If `true`, the component is selected.
   * @default false
   */ selected: $1ac984bce84b2164$var$_propTypes.default.bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $1ac984bce84b2164$var$_propTypes.default.oneOfType([
        $1ac984bce84b2164$var$_propTypes.default.arrayOf($1ac984bce84b2164$var$_propTypes.default.oneOfType([
            $1ac984bce84b2164$var$_propTypes.default.func,
            $1ac984bce84b2164$var$_propTypes.default.object,
            $1ac984bce84b2164$var$_propTypes.default.bool
        ])),
        $1ac984bce84b2164$var$_propTypes.default.func,
        $1ac984bce84b2164$var$_propTypes.default.object
    ]),
    /**
   * @default 0
   */ tabIndex: $1ac984bce84b2164$var$_propTypes.default.number
};
var $1ac984bce84b2164$var$_default = module.exports.default = $1ac984bce84b2164$var$MenuItem;

});
parcelRegister("eWb0W", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $adff06ac3b11e066$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getMenuItemUtilityClass = $adff06ac3b11e066$var$getMenuItemUtilityClass;

var $adff06ac3b11e066$var$_generateUtilityClasses = $adff06ac3b11e066$require$_interopRequireDefault((parcelRequire("5nY49")));

var $adff06ac3b11e066$var$_generateUtilityClass = $adff06ac3b11e066$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $adff06ac3b11e066$var$getMenuItemUtilityClass(slot) {
    return (0, $adff06ac3b11e066$var$_generateUtilityClass.default)('MuiMenuItem', slot);
}
const $adff06ac3b11e066$var$menuItemClasses = (0, $adff06ac3b11e066$var$_generateUtilityClasses.default)('MuiMenuItem', [
    'root',
    'focusVisible',
    'dense',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $adff06ac3b11e066$var$_default = module.exports.default = $adff06ac3b11e066$var$menuItemClasses;

});

parcelRegister("dALxx", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $9e53839d220648fc$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $9e53839d220648fc$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $9e53839d220648fc$var$_exportNames = {
    selectClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9e53839d220648fc$var$_Select.default;
    }
});
Object.defineProperty(module.exports, "selectClasses", {
    enumerable: true,
    get: function() {
        return $9e53839d220648fc$var$_selectClasses.default;
    }
});

var $9e53839d220648fc$var$_Select = $9e53839d220648fc$require$_interopRequireDefault((parcelRequire("cX7V2")));

var $gLcHN = parcelRequire("gLcHN");
Object.keys($gLcHN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($9e53839d220648fc$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $gLcHN[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gLcHN[key];
        }
    });
});

var $9e53839d220648fc$var$_selectClasses = $9e53839d220648fc$require$_interopRequireWildcard((parcelRequire("bmfPX")));
Object.keys($9e53839d220648fc$var$_selectClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($9e53839d220648fc$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $9e53839d220648fc$var$_selectClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9e53839d220648fc$var$_selectClasses[key];
        }
    });
});

});
parcelRegister("cX7V2", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $96e1233e8d06bb2d$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $96e1233e8d06bb2d$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $96e1233e8d06bb2d$var$React = $96e1233e8d06bb2d$require$_interopRequireWildcard((parcelRequire("acw62")));

var $96e1233e8d06bb2d$var$_propTypes = $96e1233e8d06bb2d$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $96e1233e8d06bb2d$var$_clsx = $96e1233e8d06bb2d$require$_interopRequireDefault((parcelRequire("9QePP")));

var $96e1233e8d06bb2d$var$_deepmerge = $96e1233e8d06bb2d$require$_interopRequireDefault((parcelRequire("bQ4jM")));

var $96e1233e8d06bb2d$var$_composeClasses = $96e1233e8d06bb2d$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $96e1233e8d06bb2d$var$_getReactElementRef = $96e1233e8d06bb2d$require$_interopRequireDefault((parcelRequire("2B4J6")));

var $96e1233e8d06bb2d$var$_SelectInput = $96e1233e8d06bb2d$require$_interopRequireDefault((parcelRequire("c0lH6")));

var $96e1233e8d06bb2d$var$_formControlState = $96e1233e8d06bb2d$require$_interopRequireDefault((parcelRequire("aaphR")));

var $96e1233e8d06bb2d$var$_useFormControl = $96e1233e8d06bb2d$require$_interopRequireDefault((parcelRequire("cJQfW")));

var $96e1233e8d06bb2d$var$_ArrowDropDown = $96e1233e8d06bb2d$require$_interopRequireDefault((parcelRequire("7LRfY")));

var $96e1233e8d06bb2d$var$_Input = $96e1233e8d06bb2d$require$_interopRequireDefault((parcelRequire("eAJp9")));

var $96e1233e8d06bb2d$var$_NativeSelectInput = $96e1233e8d06bb2d$require$_interopRequireDefault((parcelRequire("iOErJ")));

var $96e1233e8d06bb2d$var$_FilledInput = $96e1233e8d06bb2d$require$_interopRequireDefault((parcelRequire("hE2RV")));

var $96e1233e8d06bb2d$var$_OutlinedInput = $96e1233e8d06bb2d$require$_interopRequireDefault((parcelRequire("in82R")));

var $hL1nr = parcelRequire("hL1nr");

var $96e1233e8d06bb2d$var$_useForkRef = $96e1233e8d06bb2d$require$_interopRequireDefault((parcelRequire("9Rgf1")));

var $aAbgT = parcelRequire("aAbgT");

var $96e1233e8d06bb2d$var$_rootShouldForwardProp = $96e1233e8d06bb2d$require$_interopRequireDefault((parcelRequire("8Uq77")));

var $bmfPX = parcelRequire("bmfPX");

var $ayMG0 = parcelRequire("ayMG0");
const $96e1233e8d06bb2d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    const composedClasses = (0, $96e1233e8d06bb2d$var$_composeClasses.default)(slots, $bmfPX.getSelectUtilityClasses, classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const $96e1233e8d06bb2d$var$styledRootConfig = {
    name: 'MuiSelect',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $96e1233e8d06bb2d$var$_rootShouldForwardProp.default)(prop) && prop !== 'variant'
};
const $96e1233e8d06bb2d$var$StyledInput = (0, $aAbgT.styled)($96e1233e8d06bb2d$var$_Input.default, $96e1233e8d06bb2d$var$styledRootConfig)('');
const $96e1233e8d06bb2d$var$StyledOutlinedInput = (0, $aAbgT.styled)($96e1233e8d06bb2d$var$_OutlinedInput.default, $96e1233e8d06bb2d$var$styledRootConfig)('');
const $96e1233e8d06bb2d$var$StyledFilledInput = (0, $aAbgT.styled)($96e1233e8d06bb2d$var$_FilledInput.default, $96e1233e8d06bb2d$var$styledRootConfig)('');
const $96e1233e8d06bb2d$var$Select = /*#__PURE__*/ $96e1233e8d06bb2d$var$React.forwardRef(function Select(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        name: 'MuiSelect',
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = $96e1233e8d06bb2d$var$_ArrowDropDown.default, id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = 'outlined', ...other } = props;
    const inputComponent = native ? $96e1233e8d06bb2d$var$_NativeSelectInput.default : $96e1233e8d06bb2d$var$_SelectInput.default;
    const muiFormControl = (0, $96e1233e8d06bb2d$var$_useFormControl.default)();
    const fcs = (0, $96e1233e8d06bb2d$var$_formControlState.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'error'
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = {
        ...props,
        variant: variant,
        classes: classesProp
    };
    const classes = $96e1233e8d06bb2d$var$useUtilityClasses(ownerState);
    const { root: root, ...restOfClasses } = classes;
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $ayMG0.jsx)($96e1233e8d06bb2d$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $ayMG0.jsx)($96e1233e8d06bb2d$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $ayMG0.jsx)($96e1233e8d06bb2d$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $96e1233e8d06bb2d$var$_useForkRef.default)(ref, (0, $96e1233e8d06bb2d$var$_getReactElementRef.default)(InputComponent));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($96e1233e8d06bb2d$var$React.Fragment, {
        children: /*#__PURE__*/ $96e1233e8d06bb2d$var$React.cloneElement(InputComponent, {
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: {
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple,
                ...native ? {
                    id: id
                } : {
                    autoWidth: autoWidth,
                    defaultOpen: defaultOpen,
                    displayEmpty: displayEmpty,
                    labelId: labelId,
                    MenuProps: MenuProps,
                    onClose: onClose,
                    onOpen: onOpen,
                    open: open,
                    renderValue: renderValue,
                    SelectDisplayProps: {
                        id: id,
                        ...SelectDisplayProps
                    }
                },
                ...inputProps,
                classes: inputProps ? (0, $96e1233e8d06bb2d$var$_deepmerge.default)(restOfClasses, inputProps.classes) : restOfClasses,
                ...input ? input.props.inputProps : {}
            },
            ...(multiple && native || displayEmpty) && variant === 'outlined' ? {
                notched: true
            } : {},
            ref: inputComponentRef,
            className: (0, $96e1233e8d06bb2d$var$_clsx.default)(InputComponent.props.className, className, classes.root),
            // If a custom input is provided via 'input' prop, do not allow 'variant' to be propagated to it's root element. See https://github.com/mui/material-ui/issues/33894.
            ...!input && {
                variant: variant
            },
            ...other
        })
    });
});
$96e1233e8d06bb2d$var$Select.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   * @default false
   */ autoWidth: $96e1233e8d06bb2d$var$_propTypes.default.bool,
    /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */ children: $96e1233e8d06bb2d$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   * @default {}
   */ classes: $96e1233e8d06bb2d$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $96e1233e8d06bb2d$var$_propTypes.default.string,
    /**
   * If `true`, the component is initially open. Use when the component open state is not controlled (i.e. the `open` prop is not defined).
   * You can only use it when the `native` prop is `false` (default).
   * @default false
   */ defaultOpen: $96e1233e8d06bb2d$var$_propTypes.default.bool,
    /**
   * The default value. Use when the component is not controlled.
   */ defaultValue: $96e1233e8d06bb2d$var$_propTypes.default.any,
    /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function can be passed to the `renderValue` prop which
   * returns the value to be displayed when no items are selected.
   *
   * ⚠️ When using this prop, make sure the label doesn't overlap with the empty displayed value.
   * The label should either be hidden or forced to a shrunk state.
   * @default false
   */ displayEmpty: $96e1233e8d06bb2d$var$_propTypes.default.bool,
    /**
   * The icon that displays the arrow.
   * @default ArrowDropDownIcon
   */ IconComponent: $96e1233e8d06bb2d$var$_propTypes.default.elementType,
    /**
   * The `id` of the wrapper element or the `select` element when `native`.
   */ id: $96e1233e8d06bb2d$var$_propTypes.default.string,
    /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */ input: $96e1233e8d06bb2d$var$_propTypes.default.element,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */ inputProps: $96e1233e8d06bb2d$var$_propTypes.default.object,
    /**
   * See [OutlinedInput#label](https://mui.com/material-ui/api/outlined-input/#props)
   */ label: $96e1233e8d06bb2d$var$_propTypes.default.node,
    /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */ labelId: $96e1233e8d06bb2d$var$_propTypes.default.string,
    /**
   * Props applied to the [`Menu`](https://mui.com/material-ui/api/menu/) element.
   */ MenuProps: $96e1233e8d06bb2d$var$_propTypes.default.object,
    /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */ multiple: $96e1233e8d06bb2d$var$_propTypes.default.bool,
    /**
   * If `true`, the component uses a native `select` element.
   * @default false
   */ native: $96e1233e8d06bb2d$var$_propTypes.default.bool,
    /**
   * Callback fired when a menu item is selected.
   *
   * @param {SelectChangeEvent<Value>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event, not a change event, unless the change event is caused by browser autofill.
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */ onChange: $96e1233e8d06bb2d$var$_propTypes.default.func,
    /**
   * Callback fired when the component requests to be closed.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select collapses).
   *
   * @param {object} event The event source of the callback.
   */ onClose: $96e1233e8d06bb2d$var$_propTypes.default.func,
    /**
   * Callback fired when the component requests to be opened.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select expands).
   *
   * @param {object} event The event source of the callback.
   */ onOpen: $96e1233e8d06bb2d$var$_propTypes.default.func,
    /**
   * If `true`, the component is shown.
   * You can only use it when the `native` prop is `false` (default).
   */ open: $96e1233e8d06bb2d$var$_propTypes.default.bool,
    /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */ renderValue: $96e1233e8d06bb2d$var$_propTypes.default.func,
    /**
   * Props applied to the clickable div element.
   */ SelectDisplayProps: $96e1233e8d06bb2d$var$_propTypes.default.object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $96e1233e8d06bb2d$var$_propTypes.default.oneOfType([
        $96e1233e8d06bb2d$var$_propTypes.default.arrayOf($96e1233e8d06bb2d$var$_propTypes.default.oneOfType([
            $96e1233e8d06bb2d$var$_propTypes.default.func,
            $96e1233e8d06bb2d$var$_propTypes.default.object,
            $96e1233e8d06bb2d$var$_propTypes.default.bool
        ])),
        $96e1233e8d06bb2d$var$_propTypes.default.func,
        $96e1233e8d06bb2d$var$_propTypes.default.object
    ]),
    /**
   * The `input` value. Providing an empty string will select no options.
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */ value: $96e1233e8d06bb2d$var$_propTypes.default.oneOfType([
        $96e1233e8d06bb2d$var$_propTypes.default.oneOf([
            ''
        ]),
        $96e1233e8d06bb2d$var$_propTypes.default.any
    ]),
    /**
   * The variant to use.
   * @default 'outlined'
   */ variant: $96e1233e8d06bb2d$var$_propTypes.default.oneOf([
        'filled',
        'outlined',
        'standard'
    ])
};
$96e1233e8d06bb2d$var$Select.muiName = 'Select';
var $96e1233e8d06bb2d$var$_default = module.exports.default = $96e1233e8d06bb2d$var$Select;

});
parcelRegister("c0lH6", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $8bd650259be885cb$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $8bd650259be885cb$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8bd650259be885cb$var$_formatMuiErrorMessage = $8bd650259be885cb$require$_interopRequireDefault((parcelRequire("4Z6Nd")));

var $8bd650259be885cb$var$React = $8bd650259be885cb$require$_interopRequireWildcard((parcelRequire("acw62")));

var $4jPKB = parcelRequire("4jPKB");

var $8bd650259be885cb$var$_propTypes = $8bd650259be885cb$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8bd650259be885cb$var$_clsx = $8bd650259be885cb$require$_interopRequireDefault((parcelRequire("9QePP")));

var $8bd650259be885cb$var$_composeClasses = $8bd650259be885cb$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $8bd650259be885cb$var$_useId = $8bd650259be885cb$require$_interopRequireDefault((parcelRequire("hwliF")));

var $8bd650259be885cb$var$_refType = $8bd650259be885cb$require$_interopRequireDefault((parcelRequire("b3gjr")));

var $8bd650259be885cb$var$_ownerDocument = $8bd650259be885cb$require$_interopRequireDefault((parcelRequire("gzyUk")));

var $8bd650259be885cb$var$_capitalize = $8bd650259be885cb$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $8bd650259be885cb$var$_Menu = $8bd650259be885cb$require$_interopRequireDefault((parcelRequire("4F5tJ")));

var $iOErJ = parcelRequire("iOErJ");

var $2BbKU = parcelRequire("2BbKU");

var $aAbgT = parcelRequire("aAbgT");

var $8bd650259be885cb$var$_slotShouldForwardProp = $8bd650259be885cb$require$_interopRequireDefault((parcelRequire("PJRTc")));

var $8bd650259be885cb$var$_useForkRef = $8bd650259be885cb$require$_interopRequireDefault((parcelRequire("9Rgf1")));

var $8bd650259be885cb$var$_useControlled = $8bd650259be885cb$require$_interopRequireDefault((parcelRequire("3yddg")));

var $8bd650259be885cb$var$_selectClasses = $8bd650259be885cb$require$_interopRequireWildcard((parcelRequire("bmfPX")));

var $gLcHN = parcelRequire("gLcHN");

var $63t5Y = parcelRequire("63t5Y");

var $ayMG0 = parcelRequire("ayMG0");
var $8bd650259be885cb$var$_span;
const $8bd650259be885cb$var$SelectSelect = (0, $aAbgT.styled)($iOErJ.StyledSelectSelect, {
    name: 'MuiSelect',
    slot: 'Select',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${$8bd650259be885cb$var$_selectClasses.default.select}`]: styles.select
            },
            {
                [`&.${$8bd650259be885cb$var$_selectClasses.default.select}`]: styles[ownerState.variant]
            },
            {
                [`&.${$8bd650259be885cb$var$_selectClasses.default.error}`]: styles.error
            },
            {
                [`&.${$8bd650259be885cb$var$_selectClasses.default.multiple}`]: styles.multiple
            }
        ];
    }
})({
    // Win specificity over the input base
    [`&.${$8bd650259be885cb$var$_selectClasses.default.select}`]: {
        height: 'auto',
        // Resets for multiple select with chips
        minHeight: '1.4375em',
        // Required for select\text-field height consistency
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }
});
const $8bd650259be885cb$var$SelectIcon = (0, $aAbgT.styled)($iOErJ.StyledSelectIcon, {
    name: 'MuiSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $8bd650259be885cb$var$_capitalize.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})({});
const $8bd650259be885cb$var$SelectNativeInput = (0, $aAbgT.styled)('input', {
    shouldForwardProp: (prop)=>(0, $8bd650259be885cb$var$_slotShouldForwardProp.default)(prop) && prop !== 'classes',
    name: 'MuiSelect',
    slot: 'NativeInput'
})({
    bottom: 0,
    left: 0,
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
    width: '100%',
    boxSizing: 'border-box'
});
const $8bd650259be885cb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $8bd650259be885cb$var$_capitalize.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ],
        nativeInput: [
            'nativeInput'
        ]
    };
    return (0, $8bd650259be885cb$var$_composeClasses.default)(slots, $8bd650259be885cb$var$_selectClasses.getSelectUtilityClasses, classes);
};
/**
 * @ignore - internal component.
 */ const $8bd650259be885cb$var$SelectInput = /*#__PURE__*/ $8bd650259be885cb$var$React.forwardRef(function SelectInput(props, ref) {
    const { 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onKeyDown: // eslint-disable-next-line react/prop-types
    onKeyDown, onMouseDown: // eslint-disable-next-line react/prop-types
    onMouseDown, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, required: required, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, type: // catching `type` from Input which makes no sense for SelectInput
    type, value: valueProp, variant: variant = 'standard', ...other } = props;
    const [value, setValueState] = (0, $8bd650259be885cb$var$_useControlled.default)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select'
    });
    const [openState, setOpenState] = (0, $8bd650259be885cb$var$_useControlled.default)({
        controlled: openProp,
        default: defaultOpen,
        name: 'Select'
    });
    const inputRef = $8bd650259be885cb$var$React.useRef(null);
    const displayRef = $8bd650259be885cb$var$React.useRef(null);
    const [displayNode, setDisplayNode] = $8bd650259be885cb$var$React.useState(null);
    const { current: isOpenControlled } = $8bd650259be885cb$var$React.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $8bd650259be885cb$var$React.useState();
    const [openInteractionType, setOpenInteractionType] = $8bd650259be885cb$var$React.useState(null);
    const handleRef = (0, $8bd650259be885cb$var$_useForkRef.default)(ref, inputRefProp);
    const handleDisplayRef = $8bd650259be885cb$var$React.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode?.parentNode;
    $8bd650259be885cb$var$React.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    const open = displayNode !== null && openState;
    $8bd650259be885cb$var$React.useEffect(()=>{
        if (!open || !anchorElement || autoWidth) return undefined;
        if (typeof ResizeObserver === 'undefined') return undefined;
        const observer = new ResizeObserver(()=>{
            setMenuMinWidthState(anchorElement.clientWidth);
        });
        observer.observe(anchorElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        open,
        anchorElement,
        autoWidth
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $8bd650259be885cb$var$React.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $8bd650259be885cb$var$React.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $8bd650259be885cb$var$React.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $8bd650259be885cb$var$_ownerDocument.default)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener('click', handler);
            return ()=>{
                label.removeEventListener('click', handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (openParam, event)=>{
        if (openParam) {
            setOpenInteractionType((0, $gLcHN.getOpenInteractionType)(event));
            if (onOpen) onOpen(event);
        } else {
            setOpenInteractionType(null);
            if (onClose) onClose(event);
        }
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(openParam);
        }
    };
    const handleMouseDown = (event)=>{
        onMouseDown?.(event);
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $8bd650259be885cb$var$React.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute('tabindex')) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, 'target', {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                'Enter'
            ];
            if (validKeys.includes(event.key)) {
                event.preventDefault();
                update(true, event);
            }
            onKeyDown?.(event);
        }
    };
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other['aria-invalid'];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $2BbKU.isFilled)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $8bd650259be885cb$var$React.isValidElement(child)) return null;
        if ((0, $4jPKB.isFragment)(child)) console.error([
            "MUI: The Select component doesn't accept a Fragment as a child.",
            'Consider providing an array instead.'
        ].join('\n'));
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error("MUI: The `value` prop must be an array when using the `Select` component with `multiple`.");
            selected = value.some((v)=>(0, $gLcHN.areEqualValues)(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = (0, $gLcHN.areEqualValues)(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $8bd650259be885cb$var$React.cloneElement(child, {
            'aria-selected': selected ? 'true' : 'false',
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === ' ') // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: 'option',
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            'data-value': child.props.value // Instead, we provide it as a data attribute.
        });
    });
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $8bd650259be885cb$var$React.useEffect(()=>{
        if (!foundMatch && !multiple && value !== '') {
            const values = childrenArray.map((child)=>child.props.value);
            console.warn([
                `MUI: You have provided an out-of-range value \`${value}\` for the select ${name ? `(name="${name}") ` : ''}component.`,
                "Consider providing a value that matches one of the available options or ''.",
                `The available values are ${values.filter((x)=>x != null).map((x)=>`\`${x}\``).join(', ') || '""'}.`
            ].join('\n'));
        }
    }, [
        foundMatch,
        childrenArray,
        multiple,
        name,
        value
    ]);
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(', ');
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== 'undefined') tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = {
        ...props,
        variant: variant,
        value: value,
        open: open,
        error: error
    };
    const classes = $8bd650259be885cb$var$useUtilityClasses(ownerState);
    const paperProps = {
        ...MenuProps.PaperProps,
        ...typeof MenuProps.slotProps?.paper === 'function' ? MenuProps.slotProps.paper(ownerState) : MenuProps.slotProps?.paper
    };
    const listProps = {
        ...MenuProps.MenuListProps,
        ...typeof MenuProps.slotProps?.list === 'function' ? MenuProps.slotProps.list(ownerState) : MenuProps.slotProps?.list
    };
    const listboxId = (0, $8bd650259be885cb$var$_useId.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($8bd650259be885cb$var$React.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($8bd650259be885cb$var$SelectSelect, {
                as: "div",
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": open ? listboxId : undefined,
                "aria-disabled": disabled ? 'true' : undefined,
                "aria-expanded": open ? 'true' : 'false',
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(' ') || undefined,
                "aria-describedby": ariaDescribedby,
                "aria-required": required ? 'true' : undefined,
                "aria-invalid": error ? 'true' : undefined,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus,
                ...SelectDisplayProps,
                ownerState: ownerState,
                className: (0, $8bd650259be885cb$var$_clsx.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: (0, $gLcHN.isEmpty)(display) ? $8bd650259be885cb$var$_span || ($8bd650259be885cb$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "notranslate",
                    "aria-hidden": true,
                    children: "\u200B"
                })) : display
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($8bd650259be885cb$var$SelectNativeInput, {
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(',') : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                required: required,
                ...other,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($8bd650259be885cb$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($63t5Y.SelectFocusSourceProvider, {
                value: openInteractionType,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($8bd650259be885cb$var$_Menu.default, {
                    id: `menu-${name || ''}`,
                    anchorEl: anchorElement,
                    open: open,
                    onClose: handleClose,
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'center'
                    },
                    transformOrigin: {
                        vertical: 'top',
                        horizontal: 'center'
                    },
                    ...MenuProps,
                    slotProps: {
                        ...MenuProps.slotProps,
                        list: {
                            'aria-labelledby': labelId,
                            role: 'listbox',
                            'aria-multiselectable': multiple ? 'true' : undefined,
                            disableListWrap: true,
                            id: listboxId,
                            ...listProps
                        },
                        paper: {
                            ...paperProps,
                            style: {
                                minWidth: menuMinWidth,
                                ...paperProps != null ? paperProps.style : null
                            }
                        }
                    },
                    children: items
                })
            })
        ]
    });
});
$8bd650259be885cb$var$SelectInput.propTypes = {
    /**
   * @ignore
   */ 'aria-describedby': $8bd650259be885cb$var$_propTypes.default.string,
    /**
   * @ignore
   */ 'aria-label': $8bd650259be885cb$var$_propTypes.default.string,
    /**
   * @ignore
   */ autoFocus: $8bd650259be885cb$var$_propTypes.default.bool,
    /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */ autoWidth: $8bd650259be885cb$var$_propTypes.default.bool,
    /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */ children: $8bd650259be885cb$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $8bd650259be885cb$var$_propTypes.default.object,
    /**
   * The CSS class name of the select element.
   */ className: $8bd650259be885cb$var$_propTypes.default.string,
    /**
   * If `true`, the component is toggled on mount. Use when the component open state is not controlled.
   * You can only use it when the `native` prop is `false` (default).
   */ defaultOpen: $8bd650259be885cb$var$_propTypes.default.bool,
    /**
   * The default value. Use when the component is not controlled.
   */ defaultValue: $8bd650259be885cb$var$_propTypes.default.any,
    /**
   * If `true`, the select is disabled.
   */ disabled: $8bd650259be885cb$var$_propTypes.default.bool,
    /**
   * If `true`, the selected item is displayed even if its value is empty.
   */ displayEmpty: $8bd650259be885cb$var$_propTypes.default.bool,
    /**
   * If `true`, the `select input` will indicate an error.
   */ error: $8bd650259be885cb$var$_propTypes.default.bool,
    /**
   * The icon that displays the arrow.
   */ IconComponent: $8bd650259be885cb$var$_propTypes.default.elementType.isRequired,
    /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */ inputRef: $8bd650259be885cb$var$_refType.default,
    /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */ labelId: $8bd650259be885cb$var$_propTypes.default.string,
    /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */ MenuProps: $8bd650259be885cb$var$_propTypes.default.object,
    /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */ multiple: $8bd650259be885cb$var$_propTypes.default.bool,
    /**
   * Name attribute of the `select` or hidden `input` element.
   */ name: $8bd650259be885cb$var$_propTypes.default.string,
    /**
   * @ignore
   */ onBlur: $8bd650259be885cb$var$_propTypes.default.func,
    /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */ onChange: $8bd650259be885cb$var$_propTypes.default.func,
    /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */ onClose: $8bd650259be885cb$var$_propTypes.default.func,
    /**
   * @ignore
   */ onFocus: $8bd650259be885cb$var$_propTypes.default.func,
    /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */ onOpen: $8bd650259be885cb$var$_propTypes.default.func,
    /**
   * If `true`, the component is shown.
   */ open: $8bd650259be885cb$var$_propTypes.default.bool,
    /**
   * @ignore
   */ readOnly: $8bd650259be885cb$var$_propTypes.default.bool,
    /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */ renderValue: $8bd650259be885cb$var$_propTypes.default.func,
    /**
   * If `true`, the component is required.
   */ required: $8bd650259be885cb$var$_propTypes.default.bool,
    /**
   * Props applied to the clickable div element.
   */ SelectDisplayProps: $8bd650259be885cb$var$_propTypes.default.object,
    /**
   * @ignore
   */ tabIndex: $8bd650259be885cb$var$_propTypes.default.oneOfType([
        $8bd650259be885cb$var$_propTypes.default.number,
        $8bd650259be885cb$var$_propTypes.default.string
    ]),
    /**
   * @ignore
   */ type: $8bd650259be885cb$var$_propTypes.default.any,
    /**
   * The input value.
   */ value: $8bd650259be885cb$var$_propTypes.default.any,
    /**
   * The variant to use.
   */ variant: $8bd650259be885cb$var$_propTypes.default.oneOf([
        'standard',
        'outlined',
        'filled'
    ])
};
var $8bd650259be885cb$var$_default = module.exports.default = $8bd650259be885cb$var$SelectInput;

});
parcelRegister("4F5tJ", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $364f3db28d8d2e79$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $364f3db28d8d2e79$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.MenuPaper = void 0;

var $364f3db28d8d2e79$var$React = $364f3db28d8d2e79$require$_interopRequireWildcard((parcelRequire("acw62")));

var $4jPKB = parcelRequire("4jPKB");

var $364f3db28d8d2e79$var$_propTypes = $364f3db28d8d2e79$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $364f3db28d8d2e79$var$_clsx = $364f3db28d8d2e79$require$_interopRequireDefault((parcelRequire("9QePP")));

var $364f3db28d8d2e79$var$_composeClasses = $364f3db28d8d2e79$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $364f3db28d8d2e79$var$_HTMLElementType = $364f3db28d8d2e79$require$_interopRequireDefault((parcelRequire("cIfK5")));

var $9uEev = parcelRequire("9uEev");

var $364f3db28d8d2e79$var$_useSlotProps = $364f3db28d8d2e79$require$_interopRequireDefault((parcelRequire("839K0")));

var $364f3db28d8d2e79$var$_MenuList = $364f3db28d8d2e79$require$_interopRequireDefault((parcelRequire("8qqwQ")));

var $364f3db28d8d2e79$var$_Popover = $364f3db28d8d2e79$require$_interopRequireWildcard((parcelRequire("32yuL")));

var $364f3db28d8d2e79$var$_rootShouldForwardProp = $364f3db28d8d2e79$require$_interopRequireDefault((parcelRequire("8Uq77")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $lyHsQ = parcelRequire("lyHsQ");

var $364f3db28d8d2e79$var$_useSlot = $364f3db28d8d2e79$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $364f3db28d8d2e79$var$RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
const $364f3db28d8d2e79$var$LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
const $364f3db28d8d2e79$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ],
        list: [
            'list'
        ]
    };
    return (0, $364f3db28d8d2e79$var$_composeClasses.default)(slots, $lyHsQ.getMenuUtilityClass, classes);
};
const $364f3db28d8d2e79$var$MenuRoot = (0, $aAbgT.styled)($364f3db28d8d2e79$var$_Popover.default, {
    shouldForwardProp: (prop)=>(0, $364f3db28d8d2e79$var$_rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiMenu',
    slot: 'Root'
})({});
const $364f3db28d8d2e79$var$MenuPaper = module.exports.MenuPaper = (0, $aAbgT.styled)($364f3db28d8d2e79$var$_Popover.PopoverPaper, {
    name: 'MuiMenu',
    slot: 'Paper'
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
});
const $364f3db28d8d2e79$var$MenuMenuList = (0, $aAbgT.styled)($364f3db28d8d2e79$var$_MenuList.default, {
    name: 'MuiMenu',
    slot: 'List'
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $364f3db28d8d2e79$var$Menu = /*#__PURE__*/ $364f3db28d8d2e79$var$React.forwardRef(function Menu(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiMenu'
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = 'auto', TransitionProps: { onEntering: onEntering, ...TransitionProps } = {}, variant: variant = 'selectedMenu', slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const isRtl = (0, $9uEev.useRtl)();
    const ownerState = {
        ...props,
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    };
    const classes = $364f3db28d8d2e79$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $364f3db28d8d2e79$var$React.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? 'rtl' : 'ltr'
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $364f3db28d8d2e79$var$React.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $364f3db28d8d2e79$var$React.isValidElement(child)) return;
        if ((0, $4jPKB.isFragment)(child)) console.error([
            "MUI: The Menu component doesn't accept a Fragment as a child.",
            'Consider providing an array instead.'
        ].join('\n'));
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            list: MenuListProps,
            transition: TransitionProps,
            paper: PaperProps,
            ...slotProps
        }
    };
    const rootSlotProps = (0, $364f3db28d8d2e79$var$_useSlotProps.default)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const [PaperSlot, paperSlotProps] = (0, $364f3db28d8d2e79$var$_useSlot.default)('paper', {
        className: classes.paper,
        elementType: $364f3db28d8d2e79$var$MenuPaper,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        ownerState: ownerState
    });
    const [ListSlot, listSlotProps] = (0, $364f3db28d8d2e79$var$_useSlot.default)('list', {
        className: (0, $364f3db28d8d2e79$var$_clsx.default)(classes.list, MenuListProps.className),
        elementType: $364f3db28d8d2e79$var$MenuMenuList,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                ...handlers,
                onKeyDown: (event)=>{
                    handleListKeyDown(event);
                    handlers.onKeyDown?.(event);
                }
            }),
        ownerState: ownerState
    });
    const resolvedTransitionProps = typeof externalForwardedProps.slotProps.transition === 'function' ? externalForwardedProps.slotProps.transition(ownerState) : externalForwardedProps.slotProps.transition;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($364f3db28d8d2e79$var$MenuRoot, {
        onClose: onClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: isRtl ? 'right' : 'left'
        },
        transformOrigin: isRtl ? $364f3db28d8d2e79$var$RTL_ORIGIN : $364f3db28d8d2e79$var$LTR_ORIGIN,
        slots: {
            root: slots.root,
            paper: PaperSlot,
            backdrop: slots.backdrop,
            ...slots.transition && {
                // TODO: pass `slots.transition` directly once `TransitionComponent` is removed from Popover
                transition: slots.transition
            }
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps,
            backdrop: typeof slotProps.backdrop === 'function' ? slotProps.backdrop(ownerState) : slotProps.backdrop,
            transition: {
                ...resolvedTransitionProps,
                onEntering: (...args)=>{
                    handleEntering(...args);
                    resolvedTransitionProps?.onEntering?.(...args);
                }
            }
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        ownerState: ownerState,
        ...other,
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(ListSlot, {
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant,
            ...listSlotProps,
            children: children
        })
    });
});
$364f3db28d8d2e79$var$Menu.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */ anchorEl: $364f3db28d8d2e79$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $364f3db28d8d2e79$var$_HTMLElementType.default,
        $364f3db28d8d2e79$var$_propTypes.default.func
    ]),
    /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */ autoFocus: $364f3db28d8d2e79$var$_propTypes.default.bool,
    /**
   * Menu contents, normally `MenuItem`s.
   */ children: $364f3db28d8d2e79$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $364f3db28d8d2e79$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $364f3db28d8d2e79$var$_propTypes.default.string,
    /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */ disableAutoFocusItem: $364f3db28d8d2e79$var$_propTypes.default.bool,
    /**
   * Props applied to the [`MenuList`](https://mui.com/material-ui/api/menu-list/) element.
   * @deprecated use the `slotProps.list` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */ MenuListProps: $364f3db28d8d2e79$var$_propTypes.default.object,
    /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */ onClose: $364f3db28d8d2e79$var$_propTypes.default.func,
    /**
   * If `true`, the component is shown.
   */ open: $364f3db28d8d2e79$var$_propTypes.default.bool.isRequired,
    /**
   * @ignore
   */ PaperProps: $364f3db28d8d2e79$var$_propTypes.default.object,
    /**
   * `classes` prop applied to the [`Popover`](https://mui.com/material-ui/api/popover/) element.
   */ PopoverClasses: $364f3db28d8d2e79$var$_propTypes.default.object,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $364f3db28d8d2e79$var$_propTypes.default.shape({
        backdrop: $364f3db28d8d2e79$var$_propTypes.default.oneOfType([
            $364f3db28d8d2e79$var$_propTypes.default.func,
            $364f3db28d8d2e79$var$_propTypes.default.object
        ]),
        list: $364f3db28d8d2e79$var$_propTypes.default.oneOfType([
            $364f3db28d8d2e79$var$_propTypes.default.func,
            $364f3db28d8d2e79$var$_propTypes.default.object
        ]),
        paper: $364f3db28d8d2e79$var$_propTypes.default.oneOfType([
            $364f3db28d8d2e79$var$_propTypes.default.func,
            $364f3db28d8d2e79$var$_propTypes.default.object
        ]),
        root: $364f3db28d8d2e79$var$_propTypes.default.oneOfType([
            $364f3db28d8d2e79$var$_propTypes.default.func,
            $364f3db28d8d2e79$var$_propTypes.default.object
        ]),
        transition: $364f3db28d8d2e79$var$_propTypes.default.oneOfType([
            $364f3db28d8d2e79$var$_propTypes.default.func,
            $364f3db28d8d2e79$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: $364f3db28d8d2e79$var$_propTypes.default.shape({
        backdrop: $364f3db28d8d2e79$var$_propTypes.default.elementType,
        list: $364f3db28d8d2e79$var$_propTypes.default.elementType,
        paper: $364f3db28d8d2e79$var$_propTypes.default.elementType,
        root: $364f3db28d8d2e79$var$_propTypes.default.elementType,
        transition: $364f3db28d8d2e79$var$_propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $364f3db28d8d2e79$var$_propTypes.default.oneOfType([
        $364f3db28d8d2e79$var$_propTypes.default.arrayOf($364f3db28d8d2e79$var$_propTypes.default.oneOfType([
            $364f3db28d8d2e79$var$_propTypes.default.func,
            $364f3db28d8d2e79$var$_propTypes.default.object,
            $364f3db28d8d2e79$var$_propTypes.default.bool
        ])),
        $364f3db28d8d2e79$var$_propTypes.default.func,
        $364f3db28d8d2e79$var$_propTypes.default.object
    ]),
    /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */ transitionDuration: $364f3db28d8d2e79$var$_propTypes.default.oneOfType([
        $364f3db28d8d2e79$var$_propTypes.default.oneOf([
            'auto'
        ]),
        $364f3db28d8d2e79$var$_propTypes.default.number,
        $364f3db28d8d2e79$var$_propTypes.default.shape({
            appear: $364f3db28d8d2e79$var$_propTypes.default.number,
            enter: $364f3db28d8d2e79$var$_propTypes.default.number,
            exit: $364f3db28d8d2e79$var$_propTypes.default.number
        })
    ]),
    /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */ TransitionProps: $364f3db28d8d2e79$var$_propTypes.default.object,
    /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */ variant: $364f3db28d8d2e79$var$_propTypes.default.oneOf([
        'menu',
        'selectedMenu'
    ])
};
var $364f3db28d8d2e79$var$_default = module.exports.default = $364f3db28d8d2e79$var$Menu;

});
parcelRegister("32yuL", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $236c5104463510ad$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $236c5104463510ad$var$_exportNames = {
    popoverClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $236c5104463510ad$var$_Popover.default;
    }
});
Object.defineProperty(module.exports, "popoverClasses", {
    enumerable: true,
    get: function() {
        return $236c5104463510ad$var$_popoverClasses.default;
    }
});

var $236c5104463510ad$var$_Popover = $236c5104463510ad$require$_interopRequireWildcard((parcelRequire("6el2W")));
Object.keys($236c5104463510ad$var$_Popover).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($236c5104463510ad$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $236c5104463510ad$var$_Popover[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $236c5104463510ad$var$_Popover[key];
        }
    });
});

var $236c5104463510ad$var$_popoverClasses = $236c5104463510ad$require$_interopRequireWildcard((parcelRequire("k6uEG")));
Object.keys($236c5104463510ad$var$_popoverClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($236c5104463510ad$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $236c5104463510ad$var$_popoverClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $236c5104463510ad$var$_popoverClasses[key];
        }
    });
});

});
parcelRegister("6el2W", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $012baef8dc9ae9d0$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $012baef8dc9ae9d0$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.PopoverRoot = module.exports.PopoverPaper = void 0;
module.exports.getOffsetLeft = $012baef8dc9ae9d0$var$getOffsetLeft;
module.exports.getOffsetTop = $012baef8dc9ae9d0$var$getOffsetTop;

var $012baef8dc9ae9d0$var$React = $012baef8dc9ae9d0$require$_interopRequireWildcard((parcelRequire("acw62")));

var $012baef8dc9ae9d0$var$_propTypes = $012baef8dc9ae9d0$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $012baef8dc9ae9d0$var$_clsx = $012baef8dc9ae9d0$require$_interopRequireDefault((parcelRequire("9QePP")));

var $012baef8dc9ae9d0$var$_composeClasses = $012baef8dc9ae9d0$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $012baef8dc9ae9d0$var$_HTMLElementType = $012baef8dc9ae9d0$require$_interopRequireDefault((parcelRequire("cIfK5")));

var $012baef8dc9ae9d0$var$_refType = $012baef8dc9ae9d0$require$_interopRequireDefault((parcelRequire("b3gjr")));

var $012baef8dc9ae9d0$var$_elementTypeAcceptingRef = $012baef8dc9ae9d0$require$_interopRequireDefault((parcelRequire("g6PKz")));

var $012baef8dc9ae9d0$var$_integerPropType = $012baef8dc9ae9d0$require$_interopRequireDefault((parcelRequire("cxaSP")));

var $012baef8dc9ae9d0$var$_chainPropTypes = $012baef8dc9ae9d0$require$_interopRequireDefault((parcelRequire("abVWF")));

var $012baef8dc9ae9d0$var$_isHostComponent = $012baef8dc9ae9d0$require$_interopRequireDefault((parcelRequire("7jqh1")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $012baef8dc9ae9d0$var$_isLayoutSupported = $012baef8dc9ae9d0$require$_interopRequireDefault((parcelRequire("6toKj")));

var $012baef8dc9ae9d0$var$_debounce = $012baef8dc9ae9d0$require$_interopRequireDefault((parcelRequire("1iGrQ")));

var $012baef8dc9ae9d0$var$_ownerDocument = $012baef8dc9ae9d0$require$_interopRequireDefault((parcelRequire("gzyUk")));

var $012baef8dc9ae9d0$var$_ownerWindow = $012baef8dc9ae9d0$require$_interopRequireDefault((parcelRequire("9Evvr")));

var $012baef8dc9ae9d0$var$_Grow = $012baef8dc9ae9d0$require$_interopRequireDefault((parcelRequire("6dJ4n")));

var $012baef8dc9ae9d0$var$_Modal = $012baef8dc9ae9d0$require$_interopRequireDefault((parcelRequire("8vVVd")));

var $012baef8dc9ae9d0$var$_Paper = $012baef8dc9ae9d0$require$_interopRequireDefault((parcelRequire("juRJQ")));

var $k6uEG = parcelRequire("k6uEG");

var $012baef8dc9ae9d0$var$_useSlot = $012baef8dc9ae9d0$require$_interopRequireDefault((parcelRequire("6lpak")));

var $hGPki = parcelRequire("hGPki");

var $ayMG0 = parcelRequire("ayMG0");
function $012baef8dc9ae9d0$var$getOffsetTop(rect, vertical) {
    let offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function $012baef8dc9ae9d0$var$getOffsetLeft(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function $012baef8dc9ae9d0$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === 'number' ? `${n}px` : n).join(' ');
}
function $012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
const $012baef8dc9ae9d0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $012baef8dc9ae9d0$var$_composeClasses.default)(slots, $k6uEG.getPopoverUtilityClass, classes);
};
const $012baef8dc9ae9d0$var$PopoverRoot = module.exports.PopoverRoot = (0, $aAbgT.styled)($012baef8dc9ae9d0$var$_Modal.default, {
    name: 'MuiPopover',
    slot: 'Root'
})({});
const $012baef8dc9ae9d0$var$PopoverPaper = module.exports.PopoverPaper = (0, $aAbgT.styled)($012baef8dc9ae9d0$var$_Paper.default, {
    name: 'MuiPopover',
    slot: 'Paper'
})({
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $012baef8dc9ae9d0$var$Popover = /*#__PURE__*/ $012baef8dc9ae9d0$var$React.forwardRef(function Popover(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiPopover'
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = 'anchorEl', children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: // TODO: remove in v7
    slots = {}, slotProps: slotProps = {}, transformOrigin: transformOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, TransitionComponent: TransitionComponent, // TODO: remove in v7
    transitionDuration: transitionDurationProp = 'auto', TransitionProps: TransitionProps = {}, disableScrollLock: // TODO: remove in v7
    disableScrollLock = false, ...other } = props;
    const paperRef = $012baef8dc9ae9d0$var$React.useRef();
    const ownerState = {
        ...props,
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    };
    const classes = $012baef8dc9ae9d0$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $012baef8dc9ae9d0$var$React.useCallback(()=>{
        if (anchorReference === 'anchorPosition') {
            if (!anchorPosition) console.error('MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.');
            return anchorPosition;
        }
        const resolvedAnchorEl = $012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $012baef8dc9ae9d0$var$_ownerDocument.default)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        {
            const box = anchorElement.getBoundingClientRect();
            if ((0, $012baef8dc9ae9d0$var$_isLayoutSupported.default)() && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) console.warn([
                'MUI: The `anchorEl` prop provided to the component is invalid.',
                'The anchor element should be part of the document layout.',
                "Make sure the element is present in the document or that it's not display none."
            ].join('\n'));
        }
        return {
            top: anchorRect.top + $012baef8dc9ae9d0$var$getOffsetTop(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $012baef8dc9ae9d0$var$getOffsetLeft(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $012baef8dc9ae9d0$var$React.useCallback((elemRect)=>{
        return {
            vertical: $012baef8dc9ae9d0$var$getOffsetTop(elemRect, transformOrigin.vertical),
            horizontal: $012baef8dc9ae9d0$var$getOffsetLeft(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $012baef8dc9ae9d0$var$React.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: $012baef8dc9ae9d0$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $012baef8dc9ae9d0$var$_ownerWindow.default)($012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        if (elemRect.height > heightThreshold && elemRect.height && heightThreshold) console.error([
            'MUI: The popover component is too tall.',
            `Some part of it can not be seen on the screen (${elemRect.height - heightThreshold}px).`,
            'Please consider adding a `max-height` to improve the user-experience.'
        ].join('\n'));
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $012baef8dc9ae9d0$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $012baef8dc9ae9d0$var$React.useState(open);
    const setPositioningStyles = $012baef8dc9ae9d0$var$React.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.setProperty('top', positioning.top);
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $012baef8dc9ae9d0$var$React.useEffect(()=>{
        if (disableScrollLock) window.addEventListener('scroll', setPositioningStyles);
        return ()=>window.removeEventListener('scroll', setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = ()=>{
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $012baef8dc9ae9d0$var$React.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $012baef8dc9ae9d0$var$React.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $012baef8dc9ae9d0$var$React.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $012baef8dc9ae9d0$var$_debounce.default)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $012baef8dc9ae9d0$var$_ownerWindow.default)($012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl));
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    const externalForwardedProps = {
        slots: {
            transition: TransitionComponent,
            ...slots
        },
        slotProps: {
            transition: TransitionProps,
            paper: PaperPropsProp,
            ...slotProps
        }
    };
    const [TransitionSlot, transitionSlotProps] = (0, $012baef8dc9ae9d0$var$_useSlot.default)('transition', {
        elementType: $012baef8dc9ae9d0$var$_Grow.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        getSlotProps: (handlers)=>({
                ...handlers,
                onEntering: (element, isAppearing)=>{
                    handlers.onEntering?.(element, isAppearing);
                    handleEntering();
                },
                onExited: (element)=>{
                    handlers.onExited?.(element);
                    handleExited();
                }
            }),
        additionalProps: {
            appear: true,
            in: open
        }
    });
    if (transitionDurationProp === 'auto' && !TransitionSlot.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $012baef8dc9ae9d0$var$_ownerDocument.default)($012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl)).body : undefined);
    const [RootSlot, { slots: rootSlotsProp, slotProps: rootSlotPropsProp, ...rootProps }] = (0, $012baef8dc9ae9d0$var$_useSlot.default)('root', {
        ref: ref,
        elementType: $012baef8dc9ae9d0$var$PopoverRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        shouldForwardComponentProp: true,
        additionalProps: {
            slots: {
                backdrop: slots.backdrop
            },
            slotProps: {
                backdrop: (0, $hGPki.mergeSlotProps)(typeof slotProps.backdrop === 'function' ? slotProps.backdrop(ownerState) : slotProps.backdrop, {
                    invisible: true
                })
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $012baef8dc9ae9d0$var$_clsx.default)(classes.root, className)
    });
    const [PaperSlot, paperProps] = (0, $012baef8dc9ae9d0$var$_useSlot.default)('paper', {
        ref: paperRef,
        className: classes.paper,
        elementType: $012baef8dc9ae9d0$var$PopoverPaper,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        additionalProps: {
            elevation: elevation,
            style: isPositioned ? undefined : {
                opacity: 0
            }
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, {
        ...rootProps,
        ...!(0, $012baef8dc9ae9d0$var$_isHostComponent.default)(RootSlot) && {
            slots: rootSlotsProp,
            slotProps: rootSlotPropsProp,
            disableScrollLock: disableScrollLock
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionSlot, {
            ...transitionSlotProps,
            timeout: transitionDuration,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)(PaperSlot, {
                ...paperProps,
                children: children
            })
        })
    });
});
$012baef8dc9ae9d0$var$Popover.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */ action: $012baef8dc9ae9d0$var$_refType.default,
    /**
   * An HTML element, [PopoverVirtualElement](https://mui.com/material-ui/react-popover/#virtual-element),
   * or a function that returns either.
   * It's used to set the position of the popover.
   */ anchorEl: (0, $012baef8dc9ae9d0$var$_chainPropTypes.default)($012baef8dc9ae9d0$var$_propTypes.default.oneOfType([
        $012baef8dc9ae9d0$var$_HTMLElementType.default,
        $012baef8dc9ae9d0$var$_propTypes.default.func
    ]), (props)=>{
        if (props.open && (!props.anchorReference || props.anchorReference === 'anchorEl')) {
            const resolvedAnchorEl = $012baef8dc9ae9d0$var$resolveAnchorEl(props.anchorEl);
            if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
                const box = resolvedAnchorEl.getBoundingClientRect();
                if ((0, $012baef8dc9ae9d0$var$_isLayoutSupported.default)() && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) return new Error([
                    'MUI: The `anchorEl` prop provided to the component is invalid.',
                    'The anchor element should be part of the document layout.',
                    "Make sure the element is present in the document or that it's not display none."
                ].join('\n'));
            } else return new Error([
                'MUI: The `anchorEl` prop provided to the component is invalid.',
                `It should be an Element or PopoverVirtualElement instance but it's \`${resolvedAnchorEl}\` instead.`
            ].join('\n'));
        }
        return null;
    }),
    /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */ anchorOrigin: $012baef8dc9ae9d0$var$_propTypes.default.shape({
        horizontal: $012baef8dc9ae9d0$var$_propTypes.default.oneOfType([
            $012baef8dc9ae9d0$var$_propTypes.default.oneOf([
                'center',
                'left',
                'right'
            ]),
            $012baef8dc9ae9d0$var$_propTypes.default.number
        ]).isRequired,
        vertical: $012baef8dc9ae9d0$var$_propTypes.default.oneOfType([
            $012baef8dc9ae9d0$var$_propTypes.default.oneOf([
                'bottom',
                'center',
                'top'
            ]),
            $012baef8dc9ae9d0$var$_propTypes.default.number
        ]).isRequired
    }),
    /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */ anchorPosition: $012baef8dc9ae9d0$var$_propTypes.default.shape({
        left: $012baef8dc9ae9d0$var$_propTypes.default.number.isRequired,
        top: $012baef8dc9ae9d0$var$_propTypes.default.number.isRequired
    }),
    /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */ anchorReference: $012baef8dc9ae9d0$var$_propTypes.default.oneOf([
        'anchorEl',
        'anchorPosition',
        'none'
    ]),
    /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */ BackdropComponent: $012baef8dc9ae9d0$var$_propTypes.default.elementType,
    /**
   * Props applied to the [`Backdrop`](/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ BackdropProps: $012baef8dc9ae9d0$var$_propTypes.default.object,
    /**
   * The content of the component.
   */ children: $012baef8dc9ae9d0$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $012baef8dc9ae9d0$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $012baef8dc9ae9d0$var$_propTypes.default.string,
    /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */ container: $012baef8dc9ae9d0$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $012baef8dc9ae9d0$var$_HTMLElementType.default,
        $012baef8dc9ae9d0$var$_propTypes.default.func
    ]),
    /**
   * Disable the scroll lock behavior.
   * @default false
   */ disableScrollLock: $012baef8dc9ae9d0$var$_propTypes.default.bool,
    /**
   * The elevation of the popover.
   * @default 8
   */ elevation: $012baef8dc9ae9d0$var$_integerPropType.default,
    /**
   * Specifies how close to the edge of the window the popover can appear.
   * If null, the popover will not be constrained by the window.
   * @default 16
   */ marginThreshold: $012baef8dc9ae9d0$var$_propTypes.default.number,
    /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */ onClose: $012baef8dc9ae9d0$var$_propTypes.default.func,
    /**
   * If `true`, the component is shown.
   */ open: $012baef8dc9ae9d0$var$_propTypes.default.bool.isRequired,
    /**
   * Props applied to the [`Paper`](https://mui.com/material-ui/api/paper/) element.
   *
   * This prop is an alias for `slotProps.paper` and will be overridden by it if both are used.
   * @deprecated Use `slotProps.paper` instead.
   *
   * @default {}
   */ PaperProps: $012baef8dc9ae9d0$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .shape({
        component: $012baef8dc9ae9d0$var$_elementTypeAcceptingRef.default
    }),
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $012baef8dc9ae9d0$var$_propTypes.default.shape({
        backdrop: $012baef8dc9ae9d0$var$_propTypes.default.oneOfType([
            $012baef8dc9ae9d0$var$_propTypes.default.func,
            $012baef8dc9ae9d0$var$_propTypes.default.object
        ]),
        paper: $012baef8dc9ae9d0$var$_propTypes.default.oneOfType([
            $012baef8dc9ae9d0$var$_propTypes.default.func,
            $012baef8dc9ae9d0$var$_propTypes.default.object
        ]),
        root: $012baef8dc9ae9d0$var$_propTypes.default.oneOfType([
            $012baef8dc9ae9d0$var$_propTypes.default.func,
            $012baef8dc9ae9d0$var$_propTypes.default.object
        ]),
        transition: $012baef8dc9ae9d0$var$_propTypes.default.oneOfType([
            $012baef8dc9ae9d0$var$_propTypes.default.func,
            $012baef8dc9ae9d0$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: $012baef8dc9ae9d0$var$_propTypes.default.shape({
        backdrop: $012baef8dc9ae9d0$var$_propTypes.default.elementType,
        paper: $012baef8dc9ae9d0$var$_propTypes.default.elementType,
        root: $012baef8dc9ae9d0$var$_propTypes.default.elementType,
        transition: $012baef8dc9ae9d0$var$_propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $012baef8dc9ae9d0$var$_propTypes.default.oneOfType([
        $012baef8dc9ae9d0$var$_propTypes.default.arrayOf($012baef8dc9ae9d0$var$_propTypes.default.oneOfType([
            $012baef8dc9ae9d0$var$_propTypes.default.func,
            $012baef8dc9ae9d0$var$_propTypes.default.object,
            $012baef8dc9ae9d0$var$_propTypes.default.bool
        ])),
        $012baef8dc9ae9d0$var$_propTypes.default.func,
        $012baef8dc9ae9d0$var$_propTypes.default.object
    ]),
    /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */ transformOrigin: $012baef8dc9ae9d0$var$_propTypes.default.shape({
        horizontal: $012baef8dc9ae9d0$var$_propTypes.default.oneOfType([
            $012baef8dc9ae9d0$var$_propTypes.default.oneOf([
                'center',
                'left',
                'right'
            ]),
            $012baef8dc9ae9d0$var$_propTypes.default.number
        ]).isRequired,
        vertical: $012baef8dc9ae9d0$var$_propTypes.default.oneOfType([
            $012baef8dc9ae9d0$var$_propTypes.default.oneOf([
                'bottom',
                'center',
                'top'
            ]),
            $012baef8dc9ae9d0$var$_propTypes.default.number
        ]).isRequired
    }),
    /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated use the `slots.transition` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default Grow
   */ TransitionComponent: $012baef8dc9ae9d0$var$_propTypes.default.elementType,
    /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */ transitionDuration: $012baef8dc9ae9d0$var$_propTypes.default.oneOfType([
        $012baef8dc9ae9d0$var$_propTypes.default.oneOf([
            'auto'
        ]),
        $012baef8dc9ae9d0$var$_propTypes.default.number,
        $012baef8dc9ae9d0$var$_propTypes.default.shape({
            appear: $012baef8dc9ae9d0$var$_propTypes.default.number,
            enter: $012baef8dc9ae9d0$var$_propTypes.default.number,
            exit: $012baef8dc9ae9d0$var$_propTypes.default.number
        })
    ]),
    /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */ TransitionProps: $012baef8dc9ae9d0$var$_propTypes.default.object
};
var $012baef8dc9ae9d0$var$_default = module.exports.default = $012baef8dc9ae9d0$var$Popover;

});
parcelRegister("6dJ4n", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $012b35560897a029$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $012b35560897a029$var$_Grow.default;
    }
});

var $012b35560897a029$var$_Grow = $012b35560897a029$require$_interopRequireDefault((parcelRequire("iscuz")));

});
parcelRegister("iscuz", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $d6f4882a3b1c59f2$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $d6f4882a3b1c59f2$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d6f4882a3b1c59f2$var$React = $d6f4882a3b1c59f2$require$_interopRequireWildcard((parcelRequire("acw62")));

var $d6f4882a3b1c59f2$var$_propTypes = $d6f4882a3b1c59f2$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $d6f4882a3b1c59f2$var$_useTimeout = $d6f4882a3b1c59f2$require$_interopRequireDefault((parcelRequire("drY8V")));

var $d6f4882a3b1c59f2$var$_elementAcceptingRef = $d6f4882a3b1c59f2$require$_interopRequireDefault((parcelRequire("igTUE")));

var $d6f4882a3b1c59f2$var$_getReactElementRef = $d6f4882a3b1c59f2$require$_interopRequireDefault((parcelRequire("2B4J6")));

var $1mPeS = parcelRequire("1mPeS");

var $aAbgT = parcelRequire("aAbgT");

var $hweuE = parcelRequire("hweuE");

var $d6f4882a3b1c59f2$var$_useForkRef = $d6f4882a3b1c59f2$require$_interopRequireDefault((parcelRequire("9Rgf1")));

var $ayMG0 = parcelRequire("ayMG0");
function $d6f4882a3b1c59f2$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $d6f4882a3b1c59f2$var$styles = {
    entering: {
        opacity: 1,
        transform: $d6f4882a3b1c59f2$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    },
    exiting: {
        opacity: 0,
        transform: $d6f4882a3b1c59f2$var$getScale(0.75)
    },
    exited: {
        opacity: 0,
        transform: $d6f4882a3b1c59f2$var$getScale(0.75)
    }
};
const $d6f4882a3b1c59f2$var$hiddenStyles = {
    opacity: 0,
    transform: $d6f4882a3b1c59f2$var$getScale(0.75),
    visibility: 'hidden'
};
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $d6f4882a3b1c59f2$var$Grow = /*#__PURE__*/ $d6f4882a3b1c59f2$var$React.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = 'auto', ...other } = props;
    const timer = (0, $d6f4882a3b1c59f2$var$_useTimeout.default)();
    const autoTimeout = $d6f4882a3b1c59f2$var$React.useRef();
    const theme = (0, $aAbgT.useTheme)();
    const nodeRef = $d6f4882a3b1c59f2$var$React.useRef(null);
    const handleRef = (0, $d6f4882a3b1c59f2$var$_useForkRef.default)(nodeRef, (0, $d6f4882a3b1c59f2$var$_getReactElementRef.default)(children), ref);
    const handleEntering = (0, $hweuE.normalizedTransitionCallback)(nodeRef, onEntering);
    const handleEnter = (0, $hweuE.normalizedTransitionCallback)(nodeRef, (node, isAppearing)=>{
        (0, $hweuE.reflow)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $hweuE.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = (0, $hweuE.normalizedTransitionCallback)(nodeRef, onEntered);
    const handleExiting = (0, $hweuE.normalizedTransitionCallback)(nodeRef, onExiting);
    const handleExit = (0, $hweuE.normalizedTransitionCallback)(nodeRef, (node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $hweuE.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: duration * 0.666,
                delay: delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(',');
        node.style.opacity = 0;
        node.style.transform = $d6f4882a3b1c59f2$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = (0, $hweuE.normalizedTransitionCallback)(nodeRef, (node)=>{
        node.style.transition = '';
        if (onExited) onExited(node);
    });
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1mPeS.default, {
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === 'auto' ? null : timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            const childStyle = (0, $hweuE.getTransitionChildStyle)(state, inProp, $d6f4882a3b1c59f2$var$styles, $d6f4882a3b1c59f2$var$hiddenStyles, style, children.props.style);
            return /*#__PURE__*/ $d6f4882a3b1c59f2$var$React.cloneElement(children, {
                style: childStyle,
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
$d6f4882a3b1c59f2$var$Grow.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */ addEndListener: $d6f4882a3b1c59f2$var$_propTypes.default.func,
    /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */ appear: $d6f4882a3b1c59f2$var$_propTypes.default.bool,
    /**
   * A single child content element.
   */ children: $d6f4882a3b1c59f2$var$_elementAcceptingRef.default.isRequired,
    /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */ easing: $d6f4882a3b1c59f2$var$_propTypes.default.oneOfType([
        $d6f4882a3b1c59f2$var$_propTypes.default.shape({
            enter: $d6f4882a3b1c59f2$var$_propTypes.default.string,
            exit: $d6f4882a3b1c59f2$var$_propTypes.default.string
        }),
        $d6f4882a3b1c59f2$var$_propTypes.default.string
    ]),
    /**
   * If `true`, the component will transition in.
   */ in: $d6f4882a3b1c59f2$var$_propTypes.default.bool,
    /**
   * @ignore
   */ onEnter: $d6f4882a3b1c59f2$var$_propTypes.default.func,
    /**
   * @ignore
   */ onEntered: $d6f4882a3b1c59f2$var$_propTypes.default.func,
    /**
   * @ignore
   */ onEntering: $d6f4882a3b1c59f2$var$_propTypes.default.func,
    /**
   * @ignore
   */ onExit: $d6f4882a3b1c59f2$var$_propTypes.default.func,
    /**
   * @ignore
   */ onExited: $d6f4882a3b1c59f2$var$_propTypes.default.func,
    /**
   * @ignore
   */ onExiting: $d6f4882a3b1c59f2$var$_propTypes.default.func,
    /**
   * @ignore
   */ style: $d6f4882a3b1c59f2$var$_propTypes.default.object,
    /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */ timeout: $d6f4882a3b1c59f2$var$_propTypes.default.oneOfType([
        $d6f4882a3b1c59f2$var$_propTypes.default.oneOf([
            'auto'
        ]),
        $d6f4882a3b1c59f2$var$_propTypes.default.number,
        $d6f4882a3b1c59f2$var$_propTypes.default.shape({
            appear: $d6f4882a3b1c59f2$var$_propTypes.default.number,
            enter: $d6f4882a3b1c59f2$var$_propTypes.default.number,
            exit: $d6f4882a3b1c59f2$var$_propTypes.default.number
        })
    ])
};
if ($d6f4882a3b1c59f2$var$Grow) $d6f4882a3b1c59f2$var$Grow.muiSupportAuto = true;
var $d6f4882a3b1c59f2$var$_default = module.exports.default = $d6f4882a3b1c59f2$var$Grow;

});
parcelRegister("1mPeS", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fef977f04119bf5$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $g7ajw = parcelRequire("g7ajw");

var $c9Z8w = parcelRequire("c9Z8w");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $dIte2 = parcelRequire("dIte2");

var $bRYJd = parcelRequire("bRYJd");

var $6xlZQ = parcelRequire("6xlZQ");

var $4NYRH = parcelRequire("4NYRH");
var $0fef977f04119bf5$export$bb38bb9a1161268 = 'unmounted';
var $0fef977f04119bf5$export$84cbff306f539230 = 'exited';
var $0fef977f04119bf5$export$df38205c966be359 = 'entering';
var $0fef977f04119bf5$export$78e9e6e3e014d60a = 'entered';
var $0fef977f04119bf5$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $0fef977f04119bf5$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
                _this.appearStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else initialStatus = $0fef977f04119bf5$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $0fef977f04119bf5$export$bb38bb9a1161268;
        else initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $0fef977f04119bf5$export$bb38bb9a1161268) return {
            status: $0fef977f04119bf5$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $0fef977f04119bf5$export$df38205c966be359 && status !== $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else if (status === $0fef977f04119bf5$export$df38205c966be359 || status === $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $0fef977f04119bf5$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $4NYRH.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $0fef977f04119bf5$export$84cbff306f539230) this.setState({
            status: $0fef977f04119bf5$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $dIte2.default).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $0fef977f04119bf5$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $0fef977f04119bf5$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $dIte2.default).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $0fef977f04119bf5$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $0fef977f04119bf5$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $0fef977f04119bf5$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $1En50.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xlZQ.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$0fef977f04119bf5$var$Transition.contextType = (0, $6xlZQ.default);
$0fef977f04119bf5$var$Transition.propTypes = {
    /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */ nodeRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        current: typeof Element === 'undefined' ? (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any : function(propValue, key, componentName, location, propFullName, secret) {
            var value = propValue[key];
            return (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
        }
    }),
    /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).element.isRequired
    ]).isRequired,
    /**
   * Show the component; triggers the enter or exit states
   */ in: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */ mountOnEnter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */ unmountOnExit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */ appear: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Enable or disable enter transitions.
   */ enter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Enable or disable exit transitions.
   */ exit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */ timeout: function timeout(props) {
        var pt = (0, $bRYJd.timeoutsShape);
        if (!props.addEndListener) pt = pt.isRequired;
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return pt.apply(void 0, [
            props
        ].concat(args));
    },
    /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */ addEndListener: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */ onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */ onEntering: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */ onEntered: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */ onExit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */ onExiting: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */ onExited: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
}; // Name the function so it is clearer in the documentation
function $0fef977f04119bf5$var$noop() {}
$0fef977f04119bf5$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $0fef977f04119bf5$var$noop,
    onEntering: $0fef977f04119bf5$var$noop,
    onEntered: $0fef977f04119bf5$var$noop,
    onExit: $0fef977f04119bf5$var$noop,
    onExiting: $0fef977f04119bf5$var$noop,
    onExited: $0fef977f04119bf5$var$noop
};
$0fef977f04119bf5$var$Transition.UNMOUNTED = $0fef977f04119bf5$export$bb38bb9a1161268;
$0fef977f04119bf5$var$Transition.EXITED = $0fef977f04119bf5$export$84cbff306f539230;
$0fef977f04119bf5$var$Transition.ENTERING = $0fef977f04119bf5$export$df38205c966be359;
$0fef977f04119bf5$var$Transition.ENTERED = $0fef977f04119bf5$export$78e9e6e3e014d60a;
$0fef977f04119bf5$var$Transition.EXITING = $0fef977f04119bf5$export$4aacc83d4d59139f;
var $0fef977f04119bf5$export$2e2bcd8739ae039 = $0fef977f04119bf5$var$Transition;

});
parcelRegister("dIte2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fc60dfb9203246b$export$2e2bcd8739ae039);
var $9fc60dfb9203246b$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("bRYJd", function(module, exports) {

$parcel$export(module.exports, "timeoutsShape", () => $8a43c04fdfd3c437$export$3458ee1082941f5e);

var $c9Z8w = parcelRequire("c9Z8w");
var $8a43c04fdfd3c437$export$3458ee1082941f5e = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        enter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        exit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        appear: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
    }).isRequired
]);
var $8a43c04fdfd3c437$export$d61341ca8ef7c732 = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        enter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        exit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        active: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        enter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        enterDone: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        enterActive: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        exit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        exitDone: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        exitActive: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    })
]);

});

parcelRegister("4NYRH", function(module, exports) {

$parcel$export(module.exports, "forceReflow", () => $37faf39349e00e45$export$7d26bbb1236dafd6);
var $37faf39349e00e45$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});


parcelRegister("hweuE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getTransitionChildStyle = $cc10aae84e3e4b9c$var$getTransitionChildStyle;
module.exports.getTransitionProps = $cc10aae84e3e4b9c$var$getTransitionProps;
module.exports.normalizedTransitionCallback = $cc10aae84e3e4b9c$var$normalizedTransitionCallback;
module.exports.reflow = void 0;
const $cc10aae84e3e4b9c$var$reflow = (node)=>node.scrollTop;
module.exports.reflow = $cc10aae84e3e4b9c$var$reflow;
function $cc10aae84e3e4b9c$var$normalizedTransitionCallback(nodeRef, callback) {
    return (maybeIsAppearing)=>{
        if (callback) {
            const node = nodeRef.current;
            // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
            if (maybeIsAppearing === undefined) callback(node);
            else callback(node, maybeIsAppearing);
        }
    };
}
/**
 * Computes the child style for a transition component, reusing existing
 * references when possible to preserve referential equality for React.memo.
 */ function $cc10aae84e3e4b9c$var$getTransitionChildStyle(state, inProp, baseStyles, hiddenStyles, styleProp, childStyle) {
    const base = state === 'exited' && !inProp ? hiddenStyles : baseStyles[state] || baseStyles.exited;
    return styleProp || childStyle ? {
        ...base,
        ...styleProp,
        ...childStyle
    } : base;
}
function $cc10aae84e3e4b9c$var$getTransitionProps(props, options) {
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: style.transitionDuration ?? (typeof timeout === 'number' ? timeout : timeout[options.mode] || 0),
        easing: style.transitionTimingFunction ?? (typeof easing === 'object' ? easing[options.mode] : easing),
        delay: style.transitionDelay
    };
}

});



parcelRegister("8vVVd", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $632e260cb6e75f90$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $632e260cb6e75f90$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $632e260cb6e75f90$var$_exportNames = {
    ModalManager: true,
    modalClasses: true
};
Object.defineProperty(module.exports, "ModalManager", {
    enumerable: true,
    get: function() {
        return $75CP6.ModalManager;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $632e260cb6e75f90$var$_Modal.default;
    }
});
Object.defineProperty(module.exports, "modalClasses", {
    enumerable: true,
    get: function() {
        return $632e260cb6e75f90$var$_modalClasses.default;
    }
});

var $75CP6 = parcelRequire("75CP6");

var $632e260cb6e75f90$var$_Modal = $632e260cb6e75f90$require$_interopRequireDefault((parcelRequire("118QM")));

var $632e260cb6e75f90$var$_modalClasses = $632e260cb6e75f90$require$_interopRequireWildcard((parcelRequire("16KGQ")));
Object.keys($632e260cb6e75f90$var$_modalClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($632e260cb6e75f90$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $632e260cb6e75f90$var$_modalClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $632e260cb6e75f90$var$_modalClasses[key];
        }
    });
});

});
parcelRegister("75CP6", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $52971d86e2bcd483$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ModalManager = void 0;
module.exports.ariaHidden = $52971d86e2bcd483$var$ariaHidden;

var $52971d86e2bcd483$var$_ownerWindow = $52971d86e2bcd483$require$_interopRequireDefault((parcelRequire("4Rhws")));

var $52971d86e2bcd483$var$_ownerDocument = $52971d86e2bcd483$require$_interopRequireDefault((parcelRequire("43fuO")));

var $52971d86e2bcd483$var$_getScrollbarSize = $52971d86e2bcd483$require$_interopRequireDefault((parcelRequire("71aFq")));
// Is a vertical scrollbar displayed?
function $52971d86e2bcd483$var$isOverflowing(container) {
    const doc = (0, $52971d86e2bcd483$var$_ownerDocument.default)(container);
    if (doc.body === container) return (0, $52971d86e2bcd483$var$_ownerWindow.default)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $52971d86e2bcd483$var$ariaHidden(element, hide) {
    if (hide) element.setAttribute('aria-hidden', 'true');
    else element.removeAttribute('aria-hidden');
}
function $52971d86e2bcd483$var$getPaddingRight(element) {
    return parseFloat((0, $52971d86e2bcd483$var$_ownerWindow.default)(element).getComputedStyle(element).paddingRight) || 0;
}
function $52971d86e2bcd483$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE',
        'LINK',
        'MAP',
        'META',
        'NOSCRIPT',
        'PICTURE',
        'COL',
        'COLGROUP',
        'PARAM',
        'SLOT',
        'SOURCE',
        'TRACK'
    ];
    const isForbiddenTagName = forbiddenTagNames.includes(element.tagName);
    const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
    return isForbiddenTagName || isInputHidden;
}
function $52971d86e2bcd483$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, hide) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = !blacklist.includes(element);
        const isNotForbiddenElement = !$52971d86e2bcd483$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $52971d86e2bcd483$var$ariaHidden(element, hide);
    });
}
function $52971d86e2bcd483$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $52971d86e2bcd483$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($52971d86e2bcd483$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $52971d86e2bcd483$var$_getScrollbarSize.default)((0, $52971d86e2bcd483$var$_ownerWindow.default)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: 'padding-right',
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$52971d86e2bcd483$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $52971d86e2bcd483$var$_ownerDocument.default)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: 'padding-right',
                    el: element
                });
                element.style.paddingRight = `${$52971d86e2bcd483$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $52971d86e2bcd483$var$_ownerDocument.default)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $52971d86e2bcd483$var$_ownerWindow.default)(container);
            scrollContainer = parent?.nodeName === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: 'overflow',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: 'overflow-x',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: 'overflow-y',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $52971d86e2bcd483$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
/**
 * @ignore - do not document.
 *
 * Proper state management for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */ class $52971d86e2bcd483$var$ModalManager {
    constructor(){
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $52971d86e2bcd483$var$ariaHidden(modal.modalRef, false);
        const hiddenSiblings = $52971d86e2bcd483$var$getHiddenSiblings(container);
        $52971d86e2bcd483$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $52971d86e2bcd483$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $52971d86e2bcd483$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $52971d86e2bcd483$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $52971d86e2bcd483$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $52971d86e2bcd483$var$ariaHidden(modal.modalRef, ariaHiddenState);
            $52971d86e2bcd483$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $52971d86e2bcd483$var$ariaHidden(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}
module.exports.ModalManager = $52971d86e2bcd483$var$ModalManager;

});

parcelRegister("118QM", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $0bdcbfecdf3275a2$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $0bdcbfecdf3275a2$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0bdcbfecdf3275a2$var$React = $0bdcbfecdf3275a2$require$_interopRequireWildcard((parcelRequire("acw62")));

var $0bdcbfecdf3275a2$var$_propTypes = $0bdcbfecdf3275a2$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $0bdcbfecdf3275a2$var$_clsx = $0bdcbfecdf3275a2$require$_interopRequireDefault((parcelRequire("9QePP")));

var $0bdcbfecdf3275a2$var$_HTMLElementType = $0bdcbfecdf3275a2$require$_interopRequireDefault((parcelRequire("cIfK5")));

var $0bdcbfecdf3275a2$var$_elementAcceptingRef = $0bdcbfecdf3275a2$require$_interopRequireDefault((parcelRequire("igTUE")));

var $0bdcbfecdf3275a2$var$_composeClasses = $0bdcbfecdf3275a2$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $0bdcbfecdf3275a2$var$_Unstable_TrapFocus = $0bdcbfecdf3275a2$require$_interopRequireDefault((parcelRequire("c94Y8")));

var $0bdcbfecdf3275a2$var$_Portal = $0bdcbfecdf3275a2$require$_interopRequireDefault((parcelRequire("cJgE8")));

var $aAbgT = parcelRequire("aAbgT");

var $0bdcbfecdf3275a2$var$_memoTheme = $0bdcbfecdf3275a2$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $0bdcbfecdf3275a2$var$_Backdrop = $0bdcbfecdf3275a2$require$_interopRequireDefault((parcelRequire("bXwVR")));

var $0bdcbfecdf3275a2$var$_useModal = $0bdcbfecdf3275a2$require$_interopRequireDefault((parcelRequire("lkowv")));

var $16KGQ = parcelRequire("16KGQ");

var $0bdcbfecdf3275a2$var$_useSlot = $0bdcbfecdf3275a2$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $0bdcbfecdf3275a2$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            !open && exited && 'hidden'
        ],
        backdrop: [
            'backdrop'
        ]
    };
    return (0, $0bdcbfecdf3275a2$var$_composeClasses.default)(slots, $16KGQ.getModalUtilityClass, classes);
};
const $0bdcbfecdf3275a2$var$ModalRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiModal',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})((0, $0bdcbfecdf3275a2$var$_memoTheme.default)(({ theme: theme })=>({
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.open && ownerState.exited,
                style: {
                    visibility: 'hidden'
                }
            }
        ]
    })));
const $0bdcbfecdf3275a2$var$ModalBackdrop = (0, $aAbgT.styled)($0bdcbfecdf3275a2$var$_Backdrop.default, {
    name: 'MuiModal',
    slot: 'Backdrop'
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $0bdcbfecdf3275a2$var$Modal = /*#__PURE__*/ $0bdcbfecdf3275a2$var$React.forwardRef(function Modal(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        name: 'MuiModal',
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $0bdcbfecdf3275a2$var$ModalBackdrop, BackdropProps: BackdropProps, classes: classesProp, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onClose: onClose, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, open: open, slotProps: slotProps = {}, slots: slots = {}, theme: // eslint-disable-next-line react/prop-types
    theme, ...other } = props;
    const propsWithDefaults = {
        ...props,
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    };
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $0bdcbfecdf3275a2$var$_useModal.default)({
        ...propsWithDefaults,
        rootRef: ref
    });
    const ownerState = {
        ...propsWithDefaults,
        exited: exited
    };
    const classes = $0bdcbfecdf3275a2$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = '-1';
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const externalForwardedProps = {
        slots: {
            root: components.Root,
            backdrop: components.Backdrop,
            ...slots
        },
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [RootSlot, rootProps] = (0, $0bdcbfecdf3275a2$var$_useSlot.default)('root', {
        ref: ref,
        elementType: $0bdcbfecdf3275a2$var$ModalRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            component: component
        },
        getSlotProps: getRootProps,
        ownerState: ownerState,
        className: (0, $0bdcbfecdf3275a2$var$_clsx.default)(className, classes?.root, !ownerState.open && ownerState.exited && classes?.hidden)
    });
    const [BackdropSlot, backdropProps] = (0, $0bdcbfecdf3275a2$var$_useSlot.default)('backdrop', {
        ref: BackdropProps?.ref,
        elementType: BackdropComponent,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps({
                ...otherHandlers,
                onClick: (event)=>{
                    if (otherHandlers?.onClick) otherHandlers.onClick(event);
                }
            });
        },
        className: (0, $0bdcbfecdf3275a2$var$_clsx.default)(BackdropProps?.className, classes?.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($0bdcbfecdf3275a2$var$_Portal.default, {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
            ...rootProps,
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $ayMG0.jsx)(BackdropSlot, {
                    ...backdropProps
                }) : null,
                /*#__PURE__*/ (0, $ayMG0.jsx)($0bdcbfecdf3275a2$var$_Unstable_TrapFocus.default, {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $0bdcbfecdf3275a2$var$React.cloneElement(children, childProps)
                })
            ]
        })
    });
});
$0bdcbfecdf3275a2$var$Modal.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   * })({
   *   zIndex: -1,
   * })
   */ BackdropComponent: $0bdcbfecdf3275a2$var$_propTypes.default.elementType,
    /**
   * Props applied to the [`Backdrop`](https://mui.com/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead.
   */ BackdropProps: $0bdcbfecdf3275a2$var$_propTypes.default.object,
    /**
   * A single child content element.
   */ children: $0bdcbfecdf3275a2$var$_elementAcceptingRef.default.isRequired,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $0bdcbfecdf3275a2$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $0bdcbfecdf3275a2$var$_propTypes.default.string,
    /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */ closeAfterTransition: $0bdcbfecdf3275a2$var$_propTypes.default.bool,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $0bdcbfecdf3275a2$var$_propTypes.default.elementType,
    /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */ components: $0bdcbfecdf3275a2$var$_propTypes.default.shape({
        Backdrop: $0bdcbfecdf3275a2$var$_propTypes.default.elementType,
        Root: $0bdcbfecdf3275a2$var$_propTypes.default.elementType
    }),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */ componentsProps: $0bdcbfecdf3275a2$var$_propTypes.default.shape({
        backdrop: $0bdcbfecdf3275a2$var$_propTypes.default.oneOfType([
            $0bdcbfecdf3275a2$var$_propTypes.default.func,
            $0bdcbfecdf3275a2$var$_propTypes.default.object
        ]),
        root: $0bdcbfecdf3275a2$var$_propTypes.default.oneOfType([
            $0bdcbfecdf3275a2$var$_propTypes.default.func,
            $0bdcbfecdf3275a2$var$_propTypes.default.object
        ])
    }),
    /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */ container: $0bdcbfecdf3275a2$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $0bdcbfecdf3275a2$var$_HTMLElementType.default,
        $0bdcbfecdf3275a2$var$_propTypes.default.func
    ]),
    /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */ disableAutoFocus: $0bdcbfecdf3275a2$var$_propTypes.default.bool,
    /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */ disableEnforceFocus: $0bdcbfecdf3275a2$var$_propTypes.default.bool,
    /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */ disableEscapeKeyDown: $0bdcbfecdf3275a2$var$_propTypes.default.bool,
    /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */ disablePortal: $0bdcbfecdf3275a2$var$_propTypes.default.bool,
    /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */ disableRestoreFocus: $0bdcbfecdf3275a2$var$_propTypes.default.bool,
    /**
   * Disable the scroll lock behavior.
   * @default false
   */ disableScrollLock: $0bdcbfecdf3275a2$var$_propTypes.default.bool,
    /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */ hideBackdrop: $0bdcbfecdf3275a2$var$_propTypes.default.bool,
    /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */ keepMounted: $0bdcbfecdf3275a2$var$_propTypes.default.bool,
    /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */ onClose: $0bdcbfecdf3275a2$var$_propTypes.default.func,
    /**
   * A function called when a transition enters.
   */ onTransitionEnter: $0bdcbfecdf3275a2$var$_propTypes.default.func,
    /**
   * A function called when a transition has exited.
   */ onTransitionExited: $0bdcbfecdf3275a2$var$_propTypes.default.func,
    /**
   * If `true`, the component is shown.
   */ open: $0bdcbfecdf3275a2$var$_propTypes.default.bool.isRequired,
    /**
   * The props used for each slot inside the Modal.
   * @default {}
   */ slotProps: $0bdcbfecdf3275a2$var$_propTypes.default.shape({
        backdrop: $0bdcbfecdf3275a2$var$_propTypes.default.oneOfType([
            $0bdcbfecdf3275a2$var$_propTypes.default.func,
            $0bdcbfecdf3275a2$var$_propTypes.default.object
        ]),
        root: $0bdcbfecdf3275a2$var$_propTypes.default.oneOfType([
            $0bdcbfecdf3275a2$var$_propTypes.default.func,
            $0bdcbfecdf3275a2$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */ slots: $0bdcbfecdf3275a2$var$_propTypes.default.shape({
        backdrop: $0bdcbfecdf3275a2$var$_propTypes.default.elementType,
        root: $0bdcbfecdf3275a2$var$_propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $0bdcbfecdf3275a2$var$_propTypes.default.oneOfType([
        $0bdcbfecdf3275a2$var$_propTypes.default.arrayOf($0bdcbfecdf3275a2$var$_propTypes.default.oneOfType([
            $0bdcbfecdf3275a2$var$_propTypes.default.func,
            $0bdcbfecdf3275a2$var$_propTypes.default.object,
            $0bdcbfecdf3275a2$var$_propTypes.default.bool
        ])),
        $0bdcbfecdf3275a2$var$_propTypes.default.func,
        $0bdcbfecdf3275a2$var$_propTypes.default.object
    ])
};
var $0bdcbfecdf3275a2$var$_default = module.exports.default = $0bdcbfecdf3275a2$var$Modal;

});
parcelRegister("bXwVR", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $8b4ec012404cb259$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $8b4ec012404cb259$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $8b4ec012404cb259$var$_exportNames = {
    backdropClasses: true
};
Object.defineProperty(module.exports, "backdropClasses", {
    enumerable: true,
    get: function() {
        return $8b4ec012404cb259$var$_backdropClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $8b4ec012404cb259$var$_Backdrop.default;
    }
});

var $8b4ec012404cb259$var$_Backdrop = $8b4ec012404cb259$require$_interopRequireDefault((parcelRequire("6cr7d")));

var $8b4ec012404cb259$var$_backdropClasses = $8b4ec012404cb259$require$_interopRequireWildcard((parcelRequire("7ViEK")));
Object.keys($8b4ec012404cb259$var$_backdropClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($8b4ec012404cb259$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $8b4ec012404cb259$var$_backdropClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8b4ec012404cb259$var$_backdropClasses[key];
        }
    });
});

});
parcelRegister("6cr7d", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $4838e5a14e330013$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $4838e5a14e330013$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4838e5a14e330013$var$React = $4838e5a14e330013$require$_interopRequireWildcard((parcelRequire("acw62")));

var $4838e5a14e330013$var$_propTypes = $4838e5a14e330013$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $4838e5a14e330013$var$_clsx = $4838e5a14e330013$require$_interopRequireDefault((parcelRequire("9QePP")));

var $4838e5a14e330013$var$_composeClasses = $4838e5a14e330013$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $4838e5a14e330013$var$_useSlot = $4838e5a14e330013$require$_interopRequireDefault((parcelRequire("6lpak")));

var $4838e5a14e330013$var$_Fade = $4838e5a14e330013$require$_interopRequireDefault((parcelRequire("5iZHj")));

var $7ViEK = parcelRequire("7ViEK");

var $ayMG0 = parcelRequire("ayMG0");
const $4838e5a14e330013$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            'root',
            invisible && 'invisible'
        ]
    };
    return (0, $4838e5a14e330013$var$_composeClasses.default)(slots, $7ViEK.getBackdropUtilityClass, classes);
};
const $4838e5a14e330013$var$BackdropRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiBackdrop',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})({
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    WebkitTapHighlightColor: 'transparent',
    variants: [
        {
            props: {
                invisible: true
            },
            style: {
                backgroundColor: 'transparent'
            }
        }
    ]
});
const $4838e5a14e330013$var$Backdrop = /*#__PURE__*/ $4838e5a14e330013$var$React.forwardRef(function Backdrop(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiBackdrop'
    });
    const { children: children, className: className, component: component = 'div', invisible: invisible = false, open: open, components: components = {}, componentsProps: componentsProps = {}, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponentProp, transitionDuration: transitionDuration, ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        invisible: invisible
    };
    const classes = $4838e5a14e330013$var$useUtilityClasses(ownerState);
    const backwardCompatibleSlots = {
        transition: TransitionComponentProp,
        root: components.Root,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        ...componentsProps,
        ...slotProps
    };
    const externalForwardedProps = {
        component: component,
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootProps] = (0, $4838e5a14e330013$var$_useSlot.default)('root', {
        elementType: $4838e5a14e330013$var$BackdropRoot,
        externalForwardedProps: externalForwardedProps,
        className: (0, $4838e5a14e330013$var$_clsx.default)(classes.root, className),
        ownerState: ownerState
    });
    const [TransitionSlot, transitionProps] = (0, $4838e5a14e330013$var$_useSlot.default)('transition', {
        elementType: $4838e5a14e330013$var$_Fade.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionSlot, {
        in: open,
        timeout: transitionDuration,
        ...other,
        ...transitionProps,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, {
            "aria-hidden": true,
            ...rootProps,
            ref: ref,
            children: children
        })
    });
});
$4838e5a14e330013$var$Backdrop.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: $4838e5a14e330013$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $4838e5a14e330013$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $4838e5a14e330013$var$_propTypes.default.string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $4838e5a14e330013$var$_propTypes.default.elementType,
    /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */ components: $4838e5a14e330013$var$_propTypes.default.shape({
        Root: $4838e5a14e330013$var$_propTypes.default.elementType
    }),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */ componentsProps: $4838e5a14e330013$var$_propTypes.default.shape({
        root: $4838e5a14e330013$var$_propTypes.default.object
    }),
    /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */ invisible: $4838e5a14e330013$var$_propTypes.default.bool,
    /**
   * If `true`, the component is shown.
   */ open: $4838e5a14e330013$var$_propTypes.default.bool.isRequired,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $4838e5a14e330013$var$_propTypes.default.shape({
        root: $4838e5a14e330013$var$_propTypes.default.oneOfType([
            $4838e5a14e330013$var$_propTypes.default.func,
            $4838e5a14e330013$var$_propTypes.default.object
        ]),
        transition: $4838e5a14e330013$var$_propTypes.default.oneOfType([
            $4838e5a14e330013$var$_propTypes.default.func,
            $4838e5a14e330013$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: $4838e5a14e330013$var$_propTypes.default.shape({
        root: $4838e5a14e330013$var$_propTypes.default.elementType,
        transition: $4838e5a14e330013$var$_propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $4838e5a14e330013$var$_propTypes.default.oneOfType([
        $4838e5a14e330013$var$_propTypes.default.arrayOf($4838e5a14e330013$var$_propTypes.default.oneOfType([
            $4838e5a14e330013$var$_propTypes.default.func,
            $4838e5a14e330013$var$_propTypes.default.object,
            $4838e5a14e330013$var$_propTypes.default.bool
        ])),
        $4838e5a14e330013$var$_propTypes.default.func,
        $4838e5a14e330013$var$_propTypes.default.object
    ]),
    /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   * @deprecated Use `slots.transition` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ TransitionComponent: $4838e5a14e330013$var$_propTypes.default.elementType,
    /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */ transitionDuration: $4838e5a14e330013$var$_propTypes.default.oneOfType([
        $4838e5a14e330013$var$_propTypes.default.number,
        $4838e5a14e330013$var$_propTypes.default.shape({
            appear: $4838e5a14e330013$var$_propTypes.default.number,
            enter: $4838e5a14e330013$var$_propTypes.default.number,
            exit: $4838e5a14e330013$var$_propTypes.default.number
        })
    ])
};
var $4838e5a14e330013$var$_default = module.exports.default = $4838e5a14e330013$var$Backdrop;

});
parcelRegister("5iZHj", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3dce7e103df60065$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $3dce7e103df60065$var$_Fade.default;
    }
});

var $3dce7e103df60065$var$_Fade = $3dce7e103df60065$require$_interopRequireDefault((parcelRequire("86f4a")));

});
parcelRegister("86f4a", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $5e5a92158e7d9bd4$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $5e5a92158e7d9bd4$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5e5a92158e7d9bd4$var$React = $5e5a92158e7d9bd4$require$_interopRequireWildcard((parcelRequire("acw62")));

var $5e5a92158e7d9bd4$var$_propTypes = $5e5a92158e7d9bd4$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $1mPeS = parcelRequire("1mPeS");

var $5e5a92158e7d9bd4$var$_elementAcceptingRef = $5e5a92158e7d9bd4$require$_interopRequireDefault((parcelRequire("igTUE")));

var $5e5a92158e7d9bd4$var$_getReactElementRef = $5e5a92158e7d9bd4$require$_interopRequireDefault((parcelRequire("2B4J6")));

var $aAbgT = parcelRequire("aAbgT");

var $hweuE = parcelRequire("hweuE");

var $5e5a92158e7d9bd4$var$_useForkRef = $5e5a92158e7d9bd4$require$_interopRequireDefault((parcelRequire("9Rgf1")));

var $ayMG0 = parcelRequire("ayMG0");
const $5e5a92158e7d9bd4$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    },
    exiting: {
        opacity: 0
    },
    exited: {
        opacity: 0
    }
};
const $5e5a92158e7d9bd4$var$hiddenStyles = {
    opacity: 0,
    visibility: 'hidden'
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $5e5a92158e7d9bd4$var$Fade = /*#__PURE__*/ $5e5a92158e7d9bd4$var$React.forwardRef(function Fade(props, ref) {
    const theme = (0, $aAbgT.useTheme)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, ...other } = props;
    const nodeRef = $5e5a92158e7d9bd4$var$React.useRef(null);
    const handleRef = (0, $5e5a92158e7d9bd4$var$_useForkRef.default)(nodeRef, (0, $5e5a92158e7d9bd4$var$_getReactElementRef.default)(children), ref);
    const handleEntering = (0, $hweuE.normalizedTransitionCallback)(nodeRef, onEntering);
    const handleEnter = (0, $hweuE.normalizedTransitionCallback)(nodeRef, (node, isAppearing)=>{
        (0, $hweuE.reflow)(node); // So the animation always start from the start.
        const transitionProps = (0, $hweuE.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = (0, $hweuE.normalizedTransitionCallback)(nodeRef, onEntered);
    const handleExiting = (0, $hweuE.normalizedTransitionCallback)(nodeRef, onExiting);
    const handleExit = (0, $hweuE.normalizedTransitionCallback)(nodeRef, (node)=>{
        const transitionProps = (0, $hweuE.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = (0, $hweuE.normalizedTransitionCallback)(nodeRef, (node)=>{
        // Clear the transition CSS to release the compositor layer when the
        // element is fully exited (prevents idle CPU usage on fixed elements
        // like Backdrop). handleEnter re-sets it on the next open.
        node.style.transition = '';
        if (onExited) onExited(node);
    });
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1mPeS.default, {
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            const childStyle = (0, $hweuE.getTransitionChildStyle)(state, inProp, $5e5a92158e7d9bd4$var$styles, $5e5a92158e7d9bd4$var$hiddenStyles, style, children.props.style);
            return /*#__PURE__*/ $5e5a92158e7d9bd4$var$React.cloneElement(children, {
                style: childStyle,
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
$5e5a92158e7d9bd4$var$Fade.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */ addEndListener: $5e5a92158e7d9bd4$var$_propTypes.default.func,
    /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */ appear: $5e5a92158e7d9bd4$var$_propTypes.default.bool,
    /**
   * A single child content element.
   */ children: $5e5a92158e7d9bd4$var$_elementAcceptingRef.default.isRequired,
    /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */ easing: $5e5a92158e7d9bd4$var$_propTypes.default.oneOfType([
        $5e5a92158e7d9bd4$var$_propTypes.default.shape({
            enter: $5e5a92158e7d9bd4$var$_propTypes.default.string,
            exit: $5e5a92158e7d9bd4$var$_propTypes.default.string
        }),
        $5e5a92158e7d9bd4$var$_propTypes.default.string
    ]),
    /**
   * If `true`, the component will transition in.
   */ in: $5e5a92158e7d9bd4$var$_propTypes.default.bool,
    /**
   * @ignore
   */ onEnter: $5e5a92158e7d9bd4$var$_propTypes.default.func,
    /**
   * @ignore
   */ onEntered: $5e5a92158e7d9bd4$var$_propTypes.default.func,
    /**
   * @ignore
   */ onEntering: $5e5a92158e7d9bd4$var$_propTypes.default.func,
    /**
   * @ignore
   */ onExit: $5e5a92158e7d9bd4$var$_propTypes.default.func,
    /**
   * @ignore
   */ onExited: $5e5a92158e7d9bd4$var$_propTypes.default.func,
    /**
   * @ignore
   */ onExiting: $5e5a92158e7d9bd4$var$_propTypes.default.func,
    /**
   * @ignore
   */ style: $5e5a92158e7d9bd4$var$_propTypes.default.object,
    /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */ timeout: $5e5a92158e7d9bd4$var$_propTypes.default.oneOfType([
        $5e5a92158e7d9bd4$var$_propTypes.default.number,
        $5e5a92158e7d9bd4$var$_propTypes.default.shape({
            appear: $5e5a92158e7d9bd4$var$_propTypes.default.number,
            enter: $5e5a92158e7d9bd4$var$_propTypes.default.number,
            exit: $5e5a92158e7d9bd4$var$_propTypes.default.number
        })
    ])
};
var $5e5a92158e7d9bd4$var$_default = module.exports.default = $5e5a92158e7d9bd4$var$Fade;

});


parcelRegister("7ViEK", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5c4c540114ae85ab$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getBackdropUtilityClass = $5c4c540114ae85ab$var$getBackdropUtilityClass;

var $5c4c540114ae85ab$var$_generateUtilityClasses = $5c4c540114ae85ab$require$_interopRequireDefault((parcelRequire("5nY49")));

var $5c4c540114ae85ab$var$_generateUtilityClass = $5c4c540114ae85ab$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $5c4c540114ae85ab$var$getBackdropUtilityClass(slot) {
    return (0, $5c4c540114ae85ab$var$_generateUtilityClass.default)('MuiBackdrop', slot);
}
const $5c4c540114ae85ab$var$backdropClasses = (0, $5c4c540114ae85ab$var$_generateUtilityClasses.default)('MuiBackdrop', [
    'root',
    'invisible'
]);
var $5c4c540114ae85ab$var$_default = module.exports.default = $5c4c540114ae85ab$var$backdropClasses;

});



parcelRegister("lkowv", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $f86e7d122c1fa324$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $f86e7d122c1fa324$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f86e7d122c1fa324$var$React = $f86e7d122c1fa324$require$_interopRequireWildcard((parcelRequire("acw62")));

var $f86e7d122c1fa324$var$_ownerDocument = $f86e7d122c1fa324$require$_interopRequireDefault((parcelRequire("43fuO")));

var $f86e7d122c1fa324$var$_useForkRef = $f86e7d122c1fa324$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $f86e7d122c1fa324$var$_useEventCallback = $f86e7d122c1fa324$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $f86e7d122c1fa324$var$_createChainedFunction = $f86e7d122c1fa324$require$_interopRequireDefault((parcelRequire("7QInQ")));

var $f86e7d122c1fa324$var$_extractEventHandlers = $f86e7d122c1fa324$require$_interopRequireDefault((parcelRequire("bhYgh")));

var $75CP6 = parcelRequire("75CP6");
function $f86e7d122c1fa324$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
function $f86e7d122c1fa324$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty('in') : false;
}
const $f86e7d122c1fa324$var$noop = ()=>{};
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $f86e7d122c1fa324$var$manager = new $75CP6.ModalManager();
function $f86e7d122c1fa324$var$useModal(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $f86e7d122c1fa324$var$React.useRef({});
    const mountNodeRef = $f86e7d122c1fa324$var$React.useRef(null);
    const modalRef = $f86e7d122c1fa324$var$React.useRef(null);
    const handleRef = (0, $f86e7d122c1fa324$var$_useForkRef.default)(modalRef, rootRef);
    const [exited, setExited] = $f86e7d122c1fa324$var$React.useState(!open);
    const hasTransition = $f86e7d122c1fa324$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $f86e7d122c1fa324$var$_ownerDocument.default)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        $f86e7d122c1fa324$var$manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $f86e7d122c1fa324$var$_useEventCallback.default)(()=>{
        const resolvedContainer = $f86e7d122c1fa324$var$getContainer(container) || getDoc().body;
        $f86e7d122c1fa324$var$manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = ()=>$f86e7d122c1fa324$var$manager.isTopModal(getModal());
    const handlePortalRef = (0, $f86e7d122c1fa324$var$_useEventCallback.default)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $75CP6.ariaHidden)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $f86e7d122c1fa324$var$React.useCallback(()=>{
        $f86e7d122c1fa324$var$manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp
    ]);
    $f86e7d122c1fa324$var$React.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $f86e7d122c1fa324$var$React.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            otherHandlers.onKeyDown?.(event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== 'Escape' || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, 'escapeKeyDown');
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            otherHandlers.onClick?.(event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, 'backdropClick');
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $f86e7d122c1fa324$var$_extractEventHandlers.default)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = {
            ...propsEventHandlers,
            ...otherHandlers
        };
        return {
            /*
       * Marking an element with the role presentation indicates to assistive technology
       * that this element should be ignored; it exists to support the web application and
       * is not meant for humans to interact with directly.
       * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
       */ role: 'presentation',
            ...externalEventHandlers,
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        };
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return {
            'aria-hidden': true,
            ...externalEventHandlers,
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        };
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $f86e7d122c1fa324$var$_createChainedFunction.default)(handleEnter, children?.props.onEnter ?? $f86e7d122c1fa324$var$noop),
            onExited: (0, $f86e7d122c1fa324$var$_createChainedFunction.default)(handleExited, children?.props.onExited ?? $f86e7d122c1fa324$var$noop)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}
var $f86e7d122c1fa324$var$_default = module.exports.default = $f86e7d122c1fa324$var$useModal;

});

parcelRegister("16KGQ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0cea91a79e26c98a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getModalUtilityClass = $0cea91a79e26c98a$var$getModalUtilityClass;

var $0cea91a79e26c98a$var$_generateUtilityClasses = $0cea91a79e26c98a$require$_interopRequireDefault((parcelRequire("5nY49")));

var $0cea91a79e26c98a$var$_generateUtilityClass = $0cea91a79e26c98a$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $0cea91a79e26c98a$var$getModalUtilityClass(slot) {
    return (0, $0cea91a79e26c98a$var$_generateUtilityClass.default)('MuiModal', slot);
}
const $0cea91a79e26c98a$var$modalClasses = (0, $0cea91a79e26c98a$var$_generateUtilityClasses.default)('MuiModal', [
    'root',
    'hidden',
    'backdrop'
]);
var $0cea91a79e26c98a$var$_default = module.exports.default = $0cea91a79e26c98a$var$modalClasses;

});



parcelRegister("k6uEG", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ea2c25a800e729b1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getPopoverUtilityClass = $ea2c25a800e729b1$var$getPopoverUtilityClass;

var $ea2c25a800e729b1$var$_generateUtilityClasses = $ea2c25a800e729b1$require$_interopRequireDefault((parcelRequire("5nY49")));

var $ea2c25a800e729b1$var$_generateUtilityClass = $ea2c25a800e729b1$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $ea2c25a800e729b1$var$getPopoverUtilityClass(slot) {
    return (0, $ea2c25a800e729b1$var$_generateUtilityClass.default)('MuiPopover', slot);
}
const $ea2c25a800e729b1$var$popoverClasses = (0, $ea2c25a800e729b1$var$_generateUtilityClasses.default)('MuiPopover', [
    'root',
    'paper'
]);
var $ea2c25a800e729b1$var$_default = module.exports.default = $ea2c25a800e729b1$var$popoverClasses;

});



parcelRegister("lyHsQ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $fb1e7d0ac8fac824$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getMenuUtilityClass = $fb1e7d0ac8fac824$var$getMenuUtilityClass;

var $fb1e7d0ac8fac824$var$_generateUtilityClasses = $fb1e7d0ac8fac824$require$_interopRequireDefault((parcelRequire("5nY49")));

var $fb1e7d0ac8fac824$var$_generateUtilityClass = $fb1e7d0ac8fac824$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $fb1e7d0ac8fac824$var$getMenuUtilityClass(slot) {
    return (0, $fb1e7d0ac8fac824$var$_generateUtilityClass.default)('MuiMenu', slot);
}
const $fb1e7d0ac8fac824$var$menuClasses = (0, $fb1e7d0ac8fac824$var$_generateUtilityClasses.default)('MuiMenu', [
    'root',
    'paper',
    'list'
]);
var $fb1e7d0ac8fac824$var$_default = module.exports.default = $fb1e7d0ac8fac824$var$menuClasses;

});


parcelRegister("iOErJ", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $db2c454fb2e8bc3c$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $db2c454fb2e8bc3c$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.StyledSelectSelect = module.exports.StyledSelectIcon = void 0;

var $db2c454fb2e8bc3c$var$React = $db2c454fb2e8bc3c$require$_interopRequireWildcard((parcelRequire("acw62")));

var $db2c454fb2e8bc3c$var$_propTypes = $db2c454fb2e8bc3c$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $db2c454fb2e8bc3c$var$_clsx = $db2c454fb2e8bc3c$require$_interopRequireDefault((parcelRequire("9QePP")));

var $db2c454fb2e8bc3c$var$_refType = $db2c454fb2e8bc3c$require$_interopRequireDefault((parcelRequire("b3gjr")));

var $db2c454fb2e8bc3c$var$_composeClasses = $db2c454fb2e8bc3c$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $db2c454fb2e8bc3c$var$_capitalize = $db2c454fb2e8bc3c$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $db2c454fb2e8bc3c$var$_nativeSelectClasses = $db2c454fb2e8bc3c$require$_interopRequireWildcard((parcelRequire("6jVRo")));

var $aAbgT = parcelRequire("aAbgT");

var $db2c454fb2e8bc3c$var$_rootShouldForwardProp = $db2c454fb2e8bc3c$require$_interopRequireDefault((parcelRequire("8Uq77")));

var $ayMG0 = parcelRequire("ayMG0");
const $db2c454fb2e8bc3c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $db2c454fb2e8bc3c$var$_capitalize.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ]
    };
    return (0, $db2c454fb2e8bc3c$var$_composeClasses.default)(slots, $db2c454fb2e8bc3c$var$_nativeSelectClasses.getNativeSelectUtilityClasses, classes);
};
const $db2c454fb2e8bc3c$var$StyledSelectSelect = module.exports.StyledSelectSelect = (0, $aAbgT.styled)('select', {
    name: 'MuiNativeSelect'
})(({ theme: theme })=>({
        // Reset
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: 'none',
        // Reset
        borderRadius: 0,
        cursor: 'pointer',
        '&:focus': {
            // Reset Chrome style
            borderRadius: 0
        },
        [`&.${$db2c454fb2e8bc3c$var$_nativeSelectClasses.default.disabled}`]: {
            cursor: 'default'
        },
        '&[multiple]': {
            height: 'auto'
        },
        '&:not([multiple]) option, &:not([multiple]) optgroup': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== 'filled' && ownerState.variant !== 'outlined',
                style: {
                    // Bump specificity to allow extending custom inputs
                    '&&&': {
                        paddingRight: 24,
                        minWidth: 16 // So it doesn't collapse.
                    }
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    '&&&': {
                        paddingRight: 32
                    }
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius,
                    '&:focus': {
                        borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
                    },
                    '&&&': {
                        paddingRight: 32
                    }
                }
            }
        ]
    }));
const $db2c454fb2e8bc3c$var$NativeSelectSelect = (0, $aAbgT.styled)($db2c454fb2e8bc3c$var$StyledSelectSelect, {
    name: 'MuiNativeSelect',
    slot: 'Select',
    shouldForwardProp: $db2c454fb2e8bc3c$var$_rootShouldForwardProp.default,
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${$db2c454fb2e8bc3c$var$_nativeSelectClasses.default.multiple}`]: styles.multiple
            }
        ];
    }
})({});
const $db2c454fb2e8bc3c$var$StyledSelectIcon = module.exports.StyledSelectIcon = (0, $aAbgT.styled)('svg', {
    name: 'MuiNativeSelect'
})(({ theme: theme })=>({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: 'absolute',
        right: 0,
        // Center vertically, height is 1em
        top: 'calc(50% - .5em)',
        // Don't block pointer events on the select under the icon.
        pointerEvents: 'none',
        color: (theme.vars || theme).palette.action.active,
        [`&.${$db2c454fb2e8bc3c$var$_nativeSelectClasses.default.disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.open,
                style: {
                    transform: 'rotate(180deg)'
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    right: 7
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    right: 7
                }
            }
        ]
    }));
const $db2c454fb2e8bc3c$var$NativeSelectIcon = (0, $aAbgT.styled)($db2c454fb2e8bc3c$var$StyledSelectIcon, {
    name: 'MuiNativeSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $db2c454fb2e8bc3c$var$_capitalize.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})({});
/**
 * @ignore - internal component.
 */ const $db2c454fb2e8bc3c$var$NativeSelectInput = /*#__PURE__*/ $db2c454fb2e8bc3c$var$React.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = 'standard', ...other } = props;
    const ownerState = {
        ...props,
        disabled: disabled,
        variant: variant,
        error: error
    };
    const classes = $db2c454fb2e8bc3c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($db2c454fb2e8bc3c$var$React.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($db2c454fb2e8bc3c$var$NativeSelectSelect, {
                ownerState: ownerState,
                className: (0, $db2c454fb2e8bc3c$var$_clsx.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref,
                ...other
            }),
            props.multiple ? null : /*#__PURE__*/ (0, $ayMG0.jsx)($db2c454fb2e8bc3c$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
$db2c454fb2e8bc3c$var$NativeSelectInput.propTypes = {
    /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */ children: $db2c454fb2e8bc3c$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $db2c454fb2e8bc3c$var$_propTypes.default.object,
    /**
   * The CSS class name of the select element.
   */ className: $db2c454fb2e8bc3c$var$_propTypes.default.string,
    /**
   * If `true`, the select is disabled.
   */ disabled: $db2c454fb2e8bc3c$var$_propTypes.default.bool,
    /**
   * If `true`, the `select input` will indicate an error.
   */ error: $db2c454fb2e8bc3c$var$_propTypes.default.bool,
    /**
   * The icon that displays the arrow.
   */ IconComponent: $db2c454fb2e8bc3c$var$_propTypes.default.elementType.isRequired,
    /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */ inputRef: $db2c454fb2e8bc3c$var$_refType.default,
    /**
   * @ignore
   */ multiple: $db2c454fb2e8bc3c$var$_propTypes.default.bool,
    /**
   * Name attribute of the `select` or hidden `input` element.
   */ name: $db2c454fb2e8bc3c$var$_propTypes.default.string,
    /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */ onChange: $db2c454fb2e8bc3c$var$_propTypes.default.func,
    /**
   * The input value.
   */ value: $db2c454fb2e8bc3c$var$_propTypes.default.any,
    /**
   * The variant to use.
   */ variant: $db2c454fb2e8bc3c$var$_propTypes.default.oneOf([
        'standard',
        'outlined',
        'filled'
    ])
};
var $db2c454fb2e8bc3c$var$_default = module.exports.default = $db2c454fb2e8bc3c$var$NativeSelectInput;

});
parcelRegister("6jVRo", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $49a1663d7631a8fa$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getNativeSelectUtilityClasses = $49a1663d7631a8fa$var$getNativeSelectUtilityClasses;

var $49a1663d7631a8fa$var$_generateUtilityClasses = $49a1663d7631a8fa$require$_interopRequireDefault((parcelRequire("5nY49")));

var $49a1663d7631a8fa$var$_generateUtilityClass = $49a1663d7631a8fa$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $49a1663d7631a8fa$var$getNativeSelectUtilityClasses(slot) {
    return (0, $49a1663d7631a8fa$var$_generateUtilityClass.default)('MuiNativeSelect', slot);
}
const $49a1663d7631a8fa$var$nativeSelectClasses = (0, $49a1663d7631a8fa$var$_generateUtilityClasses.default)('MuiNativeSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $49a1663d7631a8fa$var$_default = module.exports.default = $49a1663d7631a8fa$var$nativeSelectClasses;

});


parcelRegister("bmfPX", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $844e08aea9053c4b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getSelectUtilityClasses = $844e08aea9053c4b$var$getSelectUtilityClasses;

var $844e08aea9053c4b$var$_generateUtilityClasses = $844e08aea9053c4b$require$_interopRequireDefault((parcelRequire("5nY49")));

var $844e08aea9053c4b$var$_generateUtilityClass = $844e08aea9053c4b$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $844e08aea9053c4b$var$getSelectUtilityClasses(slot) {
    return (0, $844e08aea9053c4b$var$_generateUtilityClass.default)('MuiSelect', slot);
}
const $844e08aea9053c4b$var$selectClasses = (0, $844e08aea9053c4b$var$_generateUtilityClasses.default)('MuiSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'focused',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $844e08aea9053c4b$var$_default = module.exports.default = $844e08aea9053c4b$var$selectClasses;

});

parcelRegister("gLcHN", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c33ae42b85bcca10$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "SelectFocusSourceProvider", {
    enumerable: true,
    get: function() {
        return $63t5Y.SelectFocusSourceProvider;
    }
});
Object.defineProperty(module.exports, "areEqualValues", {
    enumerable: true,
    get: function() {
        return $c33ae42b85bcca10$var$_areEqualValues.default;
    }
});
Object.defineProperty(module.exports, "getOpenInteractionType", {
    enumerable: true,
    get: function() {
        return $c33ae42b85bcca10$var$_getOpenInteractionType.default;
    }
});
Object.defineProperty(module.exports, "isEmpty", {
    enumerable: true,
    get: function() {
        return $c33ae42b85bcca10$var$_isEmpty.default;
    }
});
Object.defineProperty(module.exports, "useSelectFocusSource", {
    enumerable: true,
    get: function() {
        return $63t5Y.useSelectFocusSource;
    }
});

var $c33ae42b85bcca10$var$_getOpenInteractionType = $c33ae42b85bcca10$require$_interopRequireDefault((parcelRequire("Lgl5u")));

var $c33ae42b85bcca10$var$_isEmpty = $c33ae42b85bcca10$require$_interopRequireDefault((parcelRequire("fa7VF")));

var $c33ae42b85bcca10$var$_areEqualValues = $c33ae42b85bcca10$require$_interopRequireDefault((parcelRequire("a2xS4")));

var $63t5Y = parcelRequire("63t5Y");

});
parcelRegister("Lgl5u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $08e1108288e37aa5$var$getOpenInteractionType;
function $08e1108288e37aa5$var$getOpenInteractionType(event) {
    if (!event) return null;
    if (event.type === 'mousedown' || event.type === 'pointerdown' || event.type === 'touchstart') return 'pointer';
    if (event.type === 'keydown' || event.type === 'click' && event.detail === 0) return 'keyboard';
    return null;
}

});

parcelRegister("fa7VF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b09df0bc6128f172$var$isEmpty;
function $b09df0bc6128f172$var$isEmpty(display) {
    return display == null || typeof display === 'string' && !display.trim();
}

});

parcelRegister("a2xS4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $74f45d62d647662c$var$areEqualValues;
function $74f45d62d647662c$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}

});

parcelRegister("63t5Y", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $4689979d45341855$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SelectFocusSourceProvider = void 0;
module.exports.useSelectFocusSource = $4689979d45341855$var$useSelectFocusSource;

var $4689979d45341855$var$React = $4689979d45341855$require$_interopRequireWildcard((parcelRequire("acw62")));
const $4689979d45341855$var$SelectFocusSourceContext = /*#__PURE__*/ $4689979d45341855$var$React.createContext(null);
$4689979d45341855$var$SelectFocusSourceContext.displayName = 'SelectFocusSourceContext';
function $4689979d45341855$var$useSelectFocusSource() {
    const context = $4689979d45341855$var$React.useContext($4689979d45341855$var$SelectFocusSourceContext);
    return context;
}
const $4689979d45341855$var$SelectFocusSourceProvider = module.exports.SelectFocusSourceProvider = $4689979d45341855$var$SelectFocusSourceContext.Provider;

});



parcelRegister("eAJp9", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $a9f7a5eb14f1ec4f$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $a9f7a5eb14f1ec4f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $a9f7a5eb14f1ec4f$var$_exportNames = {
    inputClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $a9f7a5eb14f1ec4f$var$_Input.default;
    }
});
Object.defineProperty(module.exports, "inputClasses", {
    enumerable: true,
    get: function() {
        return $a9f7a5eb14f1ec4f$var$_inputClasses.default;
    }
});

var $a9f7a5eb14f1ec4f$var$_Input = $a9f7a5eb14f1ec4f$require$_interopRequireDefault((parcelRequire("ab7Se")));

var $a9f7a5eb14f1ec4f$var$_inputClasses = $a9f7a5eb14f1ec4f$require$_interopRequireWildcard((parcelRequire("b3ugU")));
Object.keys($a9f7a5eb14f1ec4f$var$_inputClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($a9f7a5eb14f1ec4f$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $a9f7a5eb14f1ec4f$var$_inputClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $a9f7a5eb14f1ec4f$var$_inputClasses[key];
        }
    });
});

});
parcelRegister("ab7Se", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $76910a07fd4ac4fe$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $76910a07fd4ac4fe$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76910a07fd4ac4fe$var$React = $76910a07fd4ac4fe$require$_interopRequireWildcard((parcelRequire("acw62")));

var $76910a07fd4ac4fe$var$_propTypes = $76910a07fd4ac4fe$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $76910a07fd4ac4fe$var$_composeClasses = $76910a07fd4ac4fe$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $76910a07fd4ac4fe$var$_deepmerge = $76910a07fd4ac4fe$require$_interopRequireDefault((parcelRequire("bQ4jM")));

var $76910a07fd4ac4fe$var$_refType = $76910a07fd4ac4fe$require$_interopRequireDefault((parcelRequire("b3gjr")));

var $76910a07fd4ac4fe$var$_InputBase = $76910a07fd4ac4fe$require$_interopRequireDefault((parcelRequire("9MvHs")));

var $76910a07fd4ac4fe$var$_rootShouldForwardProp = $76910a07fd4ac4fe$require$_interopRequireDefault((parcelRequire("8Uq77")));

var $aAbgT = parcelRequire("aAbgT");

var $76910a07fd4ac4fe$var$_memoTheme = $76910a07fd4ac4fe$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $76910a07fd4ac4fe$var$_createSimplePaletteValueFilter = $76910a07fd4ac4fe$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $hL1nr = parcelRequire("hL1nr");

var $76910a07fd4ac4fe$var$_inputClasses = $76910a07fd4ac4fe$require$_interopRequireWildcard((parcelRequire("b3ugU")));

var $95gUw = parcelRequire("95gUw");

var $ayMG0 = parcelRequire("ayMG0");
const $76910a07fd4ac4fe$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $76910a07fd4ac4fe$var$_composeClasses.default)(slots, $76910a07fd4ac4fe$var$_inputClasses.getInputUtilityClass, classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $76910a07fd4ac4fe$var$InputRoot = (0, $aAbgT.styled)($95gUw.InputBaseRoot, {
    shouldForwardProp: (prop)=>(0, $76910a07fd4ac4fe$var$_rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $95gUw.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})((0, $76910a07fd4ac4fe$var$_memoTheme.default)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = theme.alpha(theme.vars.palette.common.onBackground, theme.vars.opacity.inputUnderline);
    return {
        position: 'relative',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.formControl,
                style: {
                    'label + &': {
                        marginTop: 16
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableUnderline,
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${$76910a07fd4ac4fe$var$_inputClasses.default.focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${$76910a07fd4ac4fe$var$_inputClasses.default.error}`]: {
                        '&::before, &::after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${$76910a07fd4ac4fe$var$_inputClasses.default.disabled}, .${$76910a07fd4ac4fe$var$_inputClasses.default.error}):before`]: {
                        borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            borderBottom: `1px solid ${bottomLineColor}`
                        }
                    },
                    [`&.${$76910a07fd4ac4fe$var$_inputClasses.default.disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $76910a07fd4ac4fe$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color,
                        disableUnderline: false
                    },
                    style: {
                        '&::after': {
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color].main}`
                        }
                    }
                }))
        ]
    };
}));
const $76910a07fd4ac4fe$var$InputInput = (0, $aAbgT.styled)($95gUw.InputBaseInput, {
    name: 'MuiInput',
    slot: 'Input',
    overridesResolver: $95gUw.inputOverridesResolver
})({});
const $76910a07fd4ac4fe$var$Input = /*#__PURE__*/ $76910a07fd4ac4fe$var$React.forwardRef(function Input(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiInput'
    });
    const { disableUnderline: disableUnderline = false, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text', ...other } = props;
    const classes = $76910a07fd4ac4fe$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = slotProps ?? componentsPropsProp ? (0, $76910a07fd4ac4fe$var$_deepmerge.default)(slotProps ?? componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = slots.root ?? components.Root ?? $76910a07fd4ac4fe$var$InputRoot;
    const InputSlot = slots.input ?? components.Input ?? $76910a07fd4ac4fe$var$InputInput;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($76910a07fd4ac4fe$var$_InputBase.default, {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: classes
    });
});
$76910a07fd4ac4fe$var$Input.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */ autoComplete: $76910a07fd4ac4fe$var$_propTypes.default.string,
    /**
   * If `true`, the `input` element is focused during the first mount.
   */ autoFocus: $76910a07fd4ac4fe$var$_propTypes.default.bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $76910a07fd4ac4fe$var$_propTypes.default.object,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */ color: $76910a07fd4ac4fe$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $76910a07fd4ac4fe$var$_propTypes.default.oneOf([
            'primary',
            'secondary'
        ]),
        $76910a07fd4ac4fe$var$_propTypes.default.string
    ]),
    /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */ components: $76910a07fd4ac4fe$var$_propTypes.default.shape({
        Input: $76910a07fd4ac4fe$var$_propTypes.default.elementType,
        Root: $76910a07fd4ac4fe$var$_propTypes.default.elementType
    }),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */ componentsProps: $76910a07fd4ac4fe$var$_propTypes.default.shape({
        input: $76910a07fd4ac4fe$var$_propTypes.default.object,
        root: $76910a07fd4ac4fe$var$_propTypes.default.object
    }),
    /**
   * The default value. Use when the component is not controlled.
   */ defaultValue: $76910a07fd4ac4fe$var$_propTypes.default.any,
    /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ disabled: $76910a07fd4ac4fe$var$_propTypes.default.bool,
    /**
   * If `true`, the `input` will not have an underline.
   * @default false
   */ disableUnderline: $76910a07fd4ac4fe$var$_propTypes.default.bool,
    /**
   * End `InputAdornment` for this component.
   */ endAdornment: $76910a07fd4ac4fe$var$_propTypes.default.node,
    /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ error: $76910a07fd4ac4fe$var$_propTypes.default.bool,
    /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */ fullWidth: $76910a07fd4ac4fe$var$_propTypes.default.bool,
    /**
   * The id of the `input` element.
   */ id: $76910a07fd4ac4fe$var$_propTypes.default.string,
    /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */ inputComponent: $76910a07fd4ac4fe$var$_propTypes.default.elementType,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   * @default {}
   */ inputProps: $76910a07fd4ac4fe$var$_propTypes.default.object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: $76910a07fd4ac4fe$var$_refType.default,
    /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */ margin: $76910a07fd4ac4fe$var$_propTypes.default.oneOf([
        'dense',
        'none'
    ]),
    /**
   * Maximum number of rows to display when multiline option is set to true.
   */ maxRows: $76910a07fd4ac4fe$var$_propTypes.default.oneOfType([
        $76910a07fd4ac4fe$var$_propTypes.default.number,
        $76910a07fd4ac4fe$var$_propTypes.default.string
    ]),
    /**
   * Minimum number of rows to display when multiline option is set to true.
   */ minRows: $76910a07fd4ac4fe$var$_propTypes.default.oneOfType([
        $76910a07fd4ac4fe$var$_propTypes.default.number,
        $76910a07fd4ac4fe$var$_propTypes.default.string
    ]),
    /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */ multiline: $76910a07fd4ac4fe$var$_propTypes.default.bool,
    /**
   * Name attribute of the `input` element.
   */ name: $76910a07fd4ac4fe$var$_propTypes.default.string,
    /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */ onChange: $76910a07fd4ac4fe$var$_propTypes.default.func,
    /**
   * The short hint displayed in the `input` before the user enters a value.
   */ placeholder: $76910a07fd4ac4fe$var$_propTypes.default.string,
    /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */ readOnly: $76910a07fd4ac4fe$var$_propTypes.default.bool,
    /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ required: $76910a07fd4ac4fe$var$_propTypes.default.bool,
    /**
   * Number of rows to display when multiline option is set to true.
   */ rows: $76910a07fd4ac4fe$var$_propTypes.default.oneOfType([
        $76910a07fd4ac4fe$var$_propTypes.default.number,
        $76910a07fd4ac4fe$var$_propTypes.default.string
    ]),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slotProps: $76910a07fd4ac4fe$var$_propTypes.default.shape({
        input: $76910a07fd4ac4fe$var$_propTypes.default.object,
        root: $76910a07fd4ac4fe$var$_propTypes.default.object
    }),
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slots: $76910a07fd4ac4fe$var$_propTypes.default.shape({
        input: $76910a07fd4ac4fe$var$_propTypes.default.elementType,
        root: $76910a07fd4ac4fe$var$_propTypes.default.elementType
    }),
    /**
   * Start `InputAdornment` for this component.
   */ startAdornment: $76910a07fd4ac4fe$var$_propTypes.default.node,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $76910a07fd4ac4fe$var$_propTypes.default.oneOfType([
        $76910a07fd4ac4fe$var$_propTypes.default.arrayOf($76910a07fd4ac4fe$var$_propTypes.default.oneOfType([
            $76910a07fd4ac4fe$var$_propTypes.default.func,
            $76910a07fd4ac4fe$var$_propTypes.default.object,
            $76910a07fd4ac4fe$var$_propTypes.default.bool
        ])),
        $76910a07fd4ac4fe$var$_propTypes.default.func,
        $76910a07fd4ac4fe$var$_propTypes.default.object
    ]),
    /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#input_types).
   * @default 'text'
   */ type: $76910a07fd4ac4fe$var$_propTypes.default.string,
    /**
   * The value of the `input` element, required for a controlled component.
   */ value: $76910a07fd4ac4fe$var$_propTypes.default.any
};
$76910a07fd4ac4fe$var$Input.muiName = 'Input';
var $76910a07fd4ac4fe$var$_default = module.exports.default = $76910a07fd4ac4fe$var$Input;

});


parcelRegister("hE2RV", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $cd8865c776d8094c$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $cd8865c776d8094c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $cd8865c776d8094c$var$_exportNames = {
    filledInputClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $cd8865c776d8094c$var$_FilledInput.default;
    }
});
Object.defineProperty(module.exports, "filledInputClasses", {
    enumerable: true,
    get: function() {
        return $cd8865c776d8094c$var$_filledInputClasses.default;
    }
});

var $cd8865c776d8094c$var$_FilledInput = $cd8865c776d8094c$require$_interopRequireDefault((parcelRequire("g4sO2")));

var $cd8865c776d8094c$var$_filledInputClasses = $cd8865c776d8094c$require$_interopRequireWildcard((parcelRequire("faAxf")));
Object.keys($cd8865c776d8094c$var$_filledInputClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($cd8865c776d8094c$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $cd8865c776d8094c$var$_filledInputClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cd8865c776d8094c$var$_filledInputClasses[key];
        }
    });
});

});
parcelRegister("g4sO2", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $bb335d5457c07f5b$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $bb335d5457c07f5b$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bb335d5457c07f5b$var$React = $bb335d5457c07f5b$require$_interopRequireWildcard((parcelRequire("acw62")));

var $bb335d5457c07f5b$var$_deepmerge = $bb335d5457c07f5b$require$_interopRequireDefault((parcelRequire("bQ4jM")));

var $bb335d5457c07f5b$var$_refType = $bb335d5457c07f5b$require$_interopRequireDefault((parcelRequire("b3gjr")));

var $bb335d5457c07f5b$var$_propTypes = $bb335d5457c07f5b$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $bb335d5457c07f5b$var$_composeClasses = $bb335d5457c07f5b$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $bb335d5457c07f5b$var$_InputBase = $bb335d5457c07f5b$require$_interopRequireDefault((parcelRequire("9MvHs")));

var $bb335d5457c07f5b$var$_rootShouldForwardProp = $bb335d5457c07f5b$require$_interopRequireDefault((parcelRequire("8Uq77")));

var $aAbgT = parcelRequire("aAbgT");

var $bb335d5457c07f5b$var$_memoTheme = $bb335d5457c07f5b$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $bb335d5457c07f5b$var$_createSimplePaletteValueFilter = $bb335d5457c07f5b$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $hL1nr = parcelRequire("hL1nr");

var $bb335d5457c07f5b$var$_filledInputClasses = $bb335d5457c07f5b$require$_interopRequireWildcard((parcelRequire("faAxf")));

var $95gUw = parcelRequire("95gUw");

var $hGPki = parcelRequire("hGPki");

var $ayMG0 = parcelRequire("ayMG0");
const $bb335d5457c07f5b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline, startAdornment: startAdornment, endAdornment: endAdornment, size: size, hiddenLabel: hiddenLabel, multiline: multiline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            size === 'small' && `size${(0, $hGPki.capitalize)(size)}`,
            hiddenLabel && 'hiddenLabel',
            multiline && 'multiline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $bb335d5457c07f5b$var$_composeClasses.default)(slots, $bb335d5457c07f5b$var$_filledInputClasses.getFilledInputUtilityClass, classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $bb335d5457c07f5b$var$FilledInputRoot = (0, $aAbgT.styled)($95gUw.InputBaseRoot, {
    shouldForwardProp: (prop)=>(0, $bb335d5457c07f5b$var$_rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiFilledInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $95gUw.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})((0, $bb335d5457c07f5b$var$_memoTheme.default)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return {
        position: 'relative',
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${$bb335d5457c07f5b$var$_filledInputClasses.default.focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${$bb335d5457c07f5b$var$_filledInputClasses.default.disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableUnderline,
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${$bb335d5457c07f5b$var$_filledInputClasses.default.focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${$bb335d5457c07f5b$var$_filledInputClasses.default.error}`]: {
                        '&::before, &::after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${theme.vars ? theme.alpha(theme.vars.palette.common.onBackground, theme.vars.opacity.inputUnderline) : bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${$bb335d5457c07f5b$var$_filledInputClasses.default.disabled}, .${$bb335d5457c07f5b$var$_filledInputClasses.default.error}):before`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
                    },
                    [`&.${$bb335d5457c07f5b$var$_filledInputClasses.default.disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $bb335d5457c07f5b$var$_createSimplePaletteValueFilter.default)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        disableUnderline: false,
                        color: color
                    },
                    style: {
                        '&::after': {
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color]?.main}`
                        }
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 12
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 12
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '25px 12px 8px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    paddingTop: 21,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline && ownerState.hiddenLabel,
                style: {
                    paddingTop: 16,
                    paddingBottom: 17
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline && ownerState.hiddenLabel && ownerState.size === 'small',
                style: {
                    paddingTop: 8,
                    paddingBottom: 9
                }
            }
        ]
    };
}));
const $bb335d5457c07f5b$var$FilledInputInput = (0, $aAbgT.styled)($95gUw.InputBaseInput, {
    name: 'MuiFilledInput',
    slot: 'Input',
    overridesResolver: $95gUw.inputOverridesResolver
})((0, $bb335d5457c07f5b$var$_memoTheme.default)(({ theme: theme })=>({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12,
        ...!theme.vars && {
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
                caretColor: theme.palette.mode === 'light' ? null : '#fff',
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit'
            }
        },
        ...theme.vars && {
            '&:-webkit-autofill': {
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit'
            },
            [theme.getColorSchemeSelector('dark')]: {
                '&:-webkit-autofill': {
                    WebkitBoxShadow: '0 0 0 100px #266798 inset',
                    WebkitTextFillColor: '#fff',
                    caretColor: '#fff'
                }
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    paddingTop: 21,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hiddenLabel,
                style: {
                    paddingTop: 16,
                    paddingBottom: 17
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hiddenLabel && ownerState.size === 'small',
                style: {
                    paddingTop: 8,
                    paddingBottom: 9
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: 0,
                    paddingRight: 0
                }
            }
        ]
    })));
const $bb335d5457c07f5b$var$FilledInput = /*#__PURE__*/ $bb335d5457c07f5b$var$React.forwardRef(function FilledInput(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiFilledInput'
    });
    const { disableUnderline: disableUnderline = false, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text', ...other } = props;
    const ownerState = {
        ...props,
        disableUnderline: disableUnderline,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    };
    const classes = $bb335d5457c07f5b$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = slotProps ?? componentsPropsProp ? (0, $bb335d5457c07f5b$var$_deepmerge.default)(filledInputComponentsProps, slotProps ?? componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = slots.root ?? components.Root ?? $bb335d5457c07f5b$var$FilledInputRoot;
    const InputSlot = slots.input ?? components.Input ?? $bb335d5457c07f5b$var$FilledInputInput;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($bb335d5457c07f5b$var$_InputBase.default, {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: classes
    });
});
$bb335d5457c07f5b$var$FilledInput.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */ autoComplete: $bb335d5457c07f5b$var$_propTypes.default.string,
    /**
   * If `true`, the `input` element is focused during the first mount.
   */ autoFocus: $bb335d5457c07f5b$var$_propTypes.default.bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $bb335d5457c07f5b$var$_propTypes.default.object,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */ color: $bb335d5457c07f5b$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $bb335d5457c07f5b$var$_propTypes.default.oneOf([
            'primary',
            'secondary'
        ]),
        $bb335d5457c07f5b$var$_propTypes.default.string
    ]),
    /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */ components: $bb335d5457c07f5b$var$_propTypes.default.shape({
        Input: $bb335d5457c07f5b$var$_propTypes.default.elementType,
        Root: $bb335d5457c07f5b$var$_propTypes.default.elementType
    }),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */ componentsProps: $bb335d5457c07f5b$var$_propTypes.default.shape({
        input: $bb335d5457c07f5b$var$_propTypes.default.object,
        root: $bb335d5457c07f5b$var$_propTypes.default.object
    }),
    /**
   * The default value. Use when the component is not controlled.
   */ defaultValue: $bb335d5457c07f5b$var$_propTypes.default.any,
    /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ disabled: $bb335d5457c07f5b$var$_propTypes.default.bool,
    /**
   * If `true`, the input will not have an underline.
   * @default false
   */ disableUnderline: $bb335d5457c07f5b$var$_propTypes.default.bool,
    /**
   * End `InputAdornment` for this component.
   */ endAdornment: $bb335d5457c07f5b$var$_propTypes.default.node,
    /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ error: $bb335d5457c07f5b$var$_propTypes.default.bool,
    /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */ fullWidth: $bb335d5457c07f5b$var$_propTypes.default.bool,
    /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */ hiddenLabel: $bb335d5457c07f5b$var$_propTypes.default.bool,
    /**
   * The id of the `input` element.
   */ id: $bb335d5457c07f5b$var$_propTypes.default.string,
    /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */ inputComponent: $bb335d5457c07f5b$var$_propTypes.default.elementType,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   * @default {}
   */ inputProps: $bb335d5457c07f5b$var$_propTypes.default.object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: $bb335d5457c07f5b$var$_refType.default,
    /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */ margin: $bb335d5457c07f5b$var$_propTypes.default.oneOf([
        'dense',
        'none'
    ]),
    /**
   * Maximum number of rows to display when multiline option is set to true.
   */ maxRows: $bb335d5457c07f5b$var$_propTypes.default.oneOfType([
        $bb335d5457c07f5b$var$_propTypes.default.number,
        $bb335d5457c07f5b$var$_propTypes.default.string
    ]),
    /**
   * Minimum number of rows to display when multiline option is set to true.
   */ minRows: $bb335d5457c07f5b$var$_propTypes.default.oneOfType([
        $bb335d5457c07f5b$var$_propTypes.default.number,
        $bb335d5457c07f5b$var$_propTypes.default.string
    ]),
    /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */ multiline: $bb335d5457c07f5b$var$_propTypes.default.bool,
    /**
   * Name attribute of the `input` element.
   */ name: $bb335d5457c07f5b$var$_propTypes.default.string,
    /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */ onChange: $bb335d5457c07f5b$var$_propTypes.default.func,
    /**
   * The short hint displayed in the `input` before the user enters a value.
   */ placeholder: $bb335d5457c07f5b$var$_propTypes.default.string,
    /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */ readOnly: $bb335d5457c07f5b$var$_propTypes.default.bool,
    /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ required: $bb335d5457c07f5b$var$_propTypes.default.bool,
    /**
   * Number of rows to display when multiline option is set to true.
   */ rows: $bb335d5457c07f5b$var$_propTypes.default.oneOfType([
        $bb335d5457c07f5b$var$_propTypes.default.number,
        $bb335d5457c07f5b$var$_propTypes.default.string
    ]),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slotProps: $bb335d5457c07f5b$var$_propTypes.default.shape({
        input: $bb335d5457c07f5b$var$_propTypes.default.object,
        root: $bb335d5457c07f5b$var$_propTypes.default.object
    }),
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slots: $bb335d5457c07f5b$var$_propTypes.default.shape({
        input: $bb335d5457c07f5b$var$_propTypes.default.elementType,
        root: $bb335d5457c07f5b$var$_propTypes.default.elementType
    }),
    /**
   * Start `InputAdornment` for this component.
   */ startAdornment: $bb335d5457c07f5b$var$_propTypes.default.node,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $bb335d5457c07f5b$var$_propTypes.default.oneOfType([
        $bb335d5457c07f5b$var$_propTypes.default.arrayOf($bb335d5457c07f5b$var$_propTypes.default.oneOfType([
            $bb335d5457c07f5b$var$_propTypes.default.func,
            $bb335d5457c07f5b$var$_propTypes.default.object,
            $bb335d5457c07f5b$var$_propTypes.default.bool
        ])),
        $bb335d5457c07f5b$var$_propTypes.default.func,
        $bb335d5457c07f5b$var$_propTypes.default.object
    ]),
    /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#input_types).
   * @default 'text'
   */ type: $bb335d5457c07f5b$var$_propTypes.default.string,
    /**
   * The value of the `input` element, required for a controlled component.
   */ value: $bb335d5457c07f5b$var$_propTypes.default.any
};
$bb335d5457c07f5b$var$FilledInput.muiName = 'Input';
var $bb335d5457c07f5b$var$_default = module.exports.default = $bb335d5457c07f5b$var$FilledInput;

});


parcelRegister("in82R", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $d6009d8f79a7cefd$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $d6009d8f79a7cefd$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $d6009d8f79a7cefd$var$_exportNames = {
    outlinedInputClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $d6009d8f79a7cefd$var$_OutlinedInput.default;
    }
});
Object.defineProperty(module.exports, "outlinedInputClasses", {
    enumerable: true,
    get: function() {
        return $d6009d8f79a7cefd$var$_outlinedInputClasses.default;
    }
});

var $d6009d8f79a7cefd$var$_OutlinedInput = $d6009d8f79a7cefd$require$_interopRequireDefault((parcelRequire("imehR")));

var $d6009d8f79a7cefd$var$_outlinedInputClasses = $d6009d8f79a7cefd$require$_interopRequireWildcard((parcelRequire("96QZi")));
Object.keys($d6009d8f79a7cefd$var$_outlinedInputClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d6009d8f79a7cefd$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d6009d8f79a7cefd$var$_outlinedInputClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d6009d8f79a7cefd$var$_outlinedInputClasses[key];
        }
    });
});

});
parcelRegister("imehR", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $d5d55d2dd82639e9$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $d5d55d2dd82639e9$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d5d55d2dd82639e9$var$React = $d5d55d2dd82639e9$require$_interopRequireWildcard((parcelRequire("acw62")));

var $d5d55d2dd82639e9$var$_propTypes = $d5d55d2dd82639e9$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $d5d55d2dd82639e9$var$_refType = $d5d55d2dd82639e9$require$_interopRequireDefault((parcelRequire("b3gjr")));

var $d5d55d2dd82639e9$var$_composeClasses = $d5d55d2dd82639e9$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $d5d55d2dd82639e9$var$_NotchedOutline = $d5d55d2dd82639e9$require$_interopRequireDefault((parcelRequire("9ZwEw")));

var $d5d55d2dd82639e9$var$_useFormControl = $d5d55d2dd82639e9$require$_interopRequireDefault((parcelRequire("cJQfW")));

var $d5d55d2dd82639e9$var$_formControlState = $d5d55d2dd82639e9$require$_interopRequireDefault((parcelRequire("aaphR")));

var $d5d55d2dd82639e9$var$_rootShouldForwardProp = $d5d55d2dd82639e9$require$_interopRequireDefault((parcelRequire("8Uq77")));

var $aAbgT = parcelRequire("aAbgT");

var $d5d55d2dd82639e9$var$_memoTheme = $d5d55d2dd82639e9$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $d5d55d2dd82639e9$var$_createSimplePaletteValueFilter = $d5d55d2dd82639e9$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $hL1nr = parcelRequire("hL1nr");

var $d5d55d2dd82639e9$var$_outlinedInputClasses = $d5d55d2dd82639e9$require$_interopRequireWildcard((parcelRequire("96QZi")));

var $d5d55d2dd82639e9$var$_InputBase = $d5d55d2dd82639e9$require$_interopRequireWildcard((parcelRequire("95gUw")));

var $d5d55d2dd82639e9$var$_useSlot = $d5d55d2dd82639e9$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $d5d55d2dd82639e9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $d5d55d2dd82639e9$var$_composeClasses.default)(slots, $d5d55d2dd82639e9$var$_outlinedInputClasses.getOutlinedInputUtilityClass, classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $d5d55d2dd82639e9$var$OutlinedInputRoot = (0, $aAbgT.styled)($d5d55d2dd82639e9$var$_InputBase.InputBaseRoot, {
    shouldForwardProp: (prop)=>(0, $d5d55d2dd82639e9$var$_rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiOutlinedInput',
    slot: 'Root',
    overridesResolver: $d5d55d2dd82639e9$var$_InputBase.rootOverridesResolver
})((0, $d5d55d2dd82639e9$var$_memoTheme.default)(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        position: 'relative',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${$d5d55d2dd82639e9$var$_outlinedInputClasses.default.notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${$d5d55d2dd82639e9$var$_outlinedInputClasses.default.notchedOutline}`]: {
                borderColor: theme.vars ? theme.alpha(theme.vars.palette.common.onBackground, 0.23) : borderColor
            }
        },
        [`&.${$d5d55d2dd82639e9$var$_outlinedInputClasses.default.focused} .${$d5d55d2dd82639e9$var$_outlinedInputClasses.default.notchedOutline}`]: {
            borderWidth: 2
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $d5d55d2dd82639e9$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${$d5d55d2dd82639e9$var$_outlinedInputClasses.default.focused} .${$d5d55d2dd82639e9$var$_outlinedInputClasses.default.notchedOutline}`]: {
                            borderColor: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                props: {},
                // to override the above style
                style: {
                    [`&.${$d5d55d2dd82639e9$var$_outlinedInputClasses.default.error} .${$d5d55d2dd82639e9$var$_outlinedInputClasses.default.notchedOutline}`]: {
                        borderColor: (theme.vars || theme).palette.error.main
                    },
                    [`&.${$d5d55d2dd82639e9$var$_outlinedInputClasses.default.disabled} .${$d5d55d2dd82639e9$var$_outlinedInputClasses.default.notchedOutline}`]: {
                        borderColor: (theme.vars || theme).palette.action.disabled
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 14
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 14
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '16.5px 14px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    padding: '8.5px 14px'
                }
            }
        ]
    };
}));
const $d5d55d2dd82639e9$var$NotchedOutlineRoot = (0, $aAbgT.styled)($d5d55d2dd82639e9$var$_NotchedOutline.default, {
    name: 'MuiOutlinedInput',
    slot: 'NotchedOutline'
})((0, $d5d55d2dd82639e9$var$_memoTheme.default)(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        borderColor: theme.vars ? theme.alpha(theme.vars.palette.common.onBackground, 0.23) : borderColor
    };
}));
const $d5d55d2dd82639e9$var$OutlinedInputInput = (0, $aAbgT.styled)($d5d55d2dd82639e9$var$_InputBase.InputBaseInput, {
    name: 'MuiOutlinedInput',
    slot: 'Input',
    overridesResolver: $d5d55d2dd82639e9$var$_InputBase.inputOverridesResolver
})((0, $d5d55d2dd82639e9$var$_memoTheme.default)(({ theme: theme })=>({
        padding: '16.5px 14px',
        ...!theme.vars && {
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
                caretColor: theme.palette.mode === 'light' ? null : '#fff',
                borderRadius: 'inherit'
            }
        },
        ...theme.vars && {
            '&:-webkit-autofill': {
                borderRadius: 'inherit'
            },
            [theme.getColorSchemeSelector('dark')]: {
                '&:-webkit-autofill': {
                    WebkitBoxShadow: '0 0 0 100px #266798 inset',
                    WebkitTextFillColor: '#fff',
                    caretColor: '#fff'
                }
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: '8.5px 14px'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 0
                }
            }
        ]
    })));
const $d5d55d2dd82639e9$var$OutlinedInput = /*#__PURE__*/ $d5d55d2dd82639e9$var$React.forwardRef(function OutlinedInput(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiOutlinedInput'
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', label: label, multiline: multiline = false, notched: notched, slots: slots = {}, slotProps: slotProps = {}, type: type = 'text', ...other } = props;
    const classes = $d5d55d2dd82639e9$var$useUtilityClasses(props);
    const muiFormControl = (0, $d5d55d2dd82639e9$var$_useFormControl.default)();
    const fcs = (0, $d5d55d2dd82639e9$var$_formControlState.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'focused',
            'hiddenLabel',
            'size',
            'required'
        ]
    });
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    };
    const RootSlot = slots.root ?? components.Root ?? $d5d55d2dd82639e9$var$OutlinedInputRoot;
    const InputSlot = slots.input ?? components.Input ?? $d5d55d2dd82639e9$var$OutlinedInputInput;
    const [NotchedSlot, notchedProps] = (0, $d5d55d2dd82639e9$var$_useSlot.default)('notchedOutline', {
        elementType: $d5d55d2dd82639e9$var$NotchedOutlineRoot,
        className: classes.notchedOutline,
        shouldForwardComponentProp: true,
        ownerState: ownerState,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps
        },
        additionalProps: {
            label: label != null && label !== '' && fcs.required ? /*#__PURE__*/ (0, $ayMG0.jsxs)($d5d55d2dd82639e9$var$React.Fragment, {
                children: [
                    label,
                    "\u2009",
                    '*'
                ]
            }) : label
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($d5d55d2dd82639e9$var$_InputBase.default, {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: slotProps,
        renderSuffix: (state)=>/*#__PURE__*/ (0, $ayMG0.jsx)(NotchedSlot, {
                ...notchedProps,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: {
            ...classes,
            notchedOutline: null
        }
    });
});
$d5d55d2dd82639e9$var$OutlinedInput.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */ autoComplete: $d5d55d2dd82639e9$var$_propTypes.default.string,
    /**
   * If `true`, the `input` element is focused during the first mount.
   */ autoFocus: $d5d55d2dd82639e9$var$_propTypes.default.bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $d5d55d2dd82639e9$var$_propTypes.default.object,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */ color: $d5d55d2dd82639e9$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $d5d55d2dd82639e9$var$_propTypes.default.oneOf([
            'primary',
            'secondary'
        ]),
        $d5d55d2dd82639e9$var$_propTypes.default.string
    ]),
    /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */ components: $d5d55d2dd82639e9$var$_propTypes.default.shape({
        Input: $d5d55d2dd82639e9$var$_propTypes.default.elementType,
        Root: $d5d55d2dd82639e9$var$_propTypes.default.elementType
    }),
    /**
   * The default value. Use when the component is not controlled.
   */ defaultValue: $d5d55d2dd82639e9$var$_propTypes.default.any,
    /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ disabled: $d5d55d2dd82639e9$var$_propTypes.default.bool,
    /**
   * End `InputAdornment` for this component.
   */ endAdornment: $d5d55d2dd82639e9$var$_propTypes.default.node,
    /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ error: $d5d55d2dd82639e9$var$_propTypes.default.bool,
    /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */ fullWidth: $d5d55d2dd82639e9$var$_propTypes.default.bool,
    /**
   * The id of the `input` element.
   */ id: $d5d55d2dd82639e9$var$_propTypes.default.string,
    /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */ inputComponent: $d5d55d2dd82639e9$var$_propTypes.default.elementType,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   * @default {}
   */ inputProps: $d5d55d2dd82639e9$var$_propTypes.default.object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: $d5d55d2dd82639e9$var$_refType.default,
    /**
   * The label of the `input`. It is only used for layout. The actual labelling
   * is handled by `InputLabel`.
   */ label: $d5d55d2dd82639e9$var$_propTypes.default.node,
    /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */ margin: $d5d55d2dd82639e9$var$_propTypes.default.oneOf([
        'dense',
        'none'
    ]),
    /**
   * Maximum number of rows to display when multiline option is set to true.
   */ maxRows: $d5d55d2dd82639e9$var$_propTypes.default.oneOfType([
        $d5d55d2dd82639e9$var$_propTypes.default.number,
        $d5d55d2dd82639e9$var$_propTypes.default.string
    ]),
    /**
   * Minimum number of rows to display when multiline option is set to true.
   */ minRows: $d5d55d2dd82639e9$var$_propTypes.default.oneOfType([
        $d5d55d2dd82639e9$var$_propTypes.default.number,
        $d5d55d2dd82639e9$var$_propTypes.default.string
    ]),
    /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */ multiline: $d5d55d2dd82639e9$var$_propTypes.default.bool,
    /**
   * Name attribute of the `input` element.
   */ name: $d5d55d2dd82639e9$var$_propTypes.default.string,
    /**
   * If `true`, the outline is notched to accommodate the label.
   */ notched: $d5d55d2dd82639e9$var$_propTypes.default.bool,
    /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */ onChange: $d5d55d2dd82639e9$var$_propTypes.default.func,
    /**
   * The short hint displayed in the `input` before the user enters a value.
   */ placeholder: $d5d55d2dd82639e9$var$_propTypes.default.string,
    /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */ readOnly: $d5d55d2dd82639e9$var$_propTypes.default.bool,
    /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ required: $d5d55d2dd82639e9$var$_propTypes.default.bool,
    /**
   * Number of rows to display when multiline option is set to true.
   */ rows: $d5d55d2dd82639e9$var$_propTypes.default.oneOfType([
        $d5d55d2dd82639e9$var$_propTypes.default.number,
        $d5d55d2dd82639e9$var$_propTypes.default.string
    ]),
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $d5d55d2dd82639e9$var$_propTypes.default.shape({
        input: $d5d55d2dd82639e9$var$_propTypes.default.object,
        notchedOutline: $d5d55d2dd82639e9$var$_propTypes.default.oneOfType([
            $d5d55d2dd82639e9$var$_propTypes.default.func,
            $d5d55d2dd82639e9$var$_propTypes.default.object
        ]),
        root: $d5d55d2dd82639e9$var$_propTypes.default.object
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: $d5d55d2dd82639e9$var$_propTypes.default.shape({
        input: $d5d55d2dd82639e9$var$_propTypes.default.elementType,
        notchedOutline: $d5d55d2dd82639e9$var$_propTypes.default.elementType,
        root: $d5d55d2dd82639e9$var$_propTypes.default.elementType
    }),
    /**
   * Start `InputAdornment` for this component.
   */ startAdornment: $d5d55d2dd82639e9$var$_propTypes.default.node,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $d5d55d2dd82639e9$var$_propTypes.default.oneOfType([
        $d5d55d2dd82639e9$var$_propTypes.default.arrayOf($d5d55d2dd82639e9$var$_propTypes.default.oneOfType([
            $d5d55d2dd82639e9$var$_propTypes.default.func,
            $d5d55d2dd82639e9$var$_propTypes.default.object,
            $d5d55d2dd82639e9$var$_propTypes.default.bool
        ])),
        $d5d55d2dd82639e9$var$_propTypes.default.func,
        $d5d55d2dd82639e9$var$_propTypes.default.object
    ]),
    /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#input_types).
   * @default 'text'
   */ type: $d5d55d2dd82639e9$var$_propTypes.default.string,
    /**
   * The value of the `input` element, required for a controlled component.
   */ value: $d5d55d2dd82639e9$var$_propTypes.default.any
};
$d5d55d2dd82639e9$var$OutlinedInput.muiName = 'Input';
var $d5d55d2dd82639e9$var$_default = module.exports.default = $d5d55d2dd82639e9$var$OutlinedInput;

});
parcelRegister("9ZwEw", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $746323a953600e78$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $746323a953600e78$var$NotchedOutline;

var $746323a953600e78$var$_propTypes = $746323a953600e78$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $746323a953600e78$var$_rootShouldForwardProp = $746323a953600e78$require$_interopRequireDefault((parcelRequire("8Uq77")));

var $aAbgT = parcelRequire("aAbgT");

var $746323a953600e78$var$_memoTheme = $746323a953600e78$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $ayMG0 = parcelRequire("ayMG0");
var $746323a953600e78$var$_span;
const $746323a953600e78$var$NotchedOutlineRoot = (0, $aAbgT.styled)('fieldset', {
    name: 'MuiNotchedOutlined',
    shouldForwardProp: $746323a953600e78$var$_rootShouldForwardProp.default
})({
    textAlign: 'left',
    position: 'absolute',
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: '0 8px',
    pointerEvents: 'none',
    borderRadius: 'inherit',
    borderStyle: 'solid',
    borderWidth: 1,
    overflow: 'hidden',
    minWidth: '0%'
});
const $746323a953600e78$var$NotchedOutlineLegend = (0, $aAbgT.styled)('legend', {
    name: 'MuiNotchedOutlined',
    shouldForwardProp: $746323a953600e78$var$_rootShouldForwardProp.default
})((0, $746323a953600e78$var$_memoTheme.default)(({ theme: theme })=>({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden',
        // Fix Horizontal scroll when label too long
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.withLabel,
                style: {
                    padding: 0,
                    lineHeight: '11px',
                    // sync with `height` in `legend` styles
                    transition: theme.transitions.create('width', {
                        duration: 150,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.withLabel,
                style: {
                    display: 'block',
                    // Fix conflict with normalize.css and sanitize.css
                    padding: 0,
                    height: 11,
                    // sync with `lineHeight` in `legend` styles
                    fontSize: '0.75em',
                    visibility: 'hidden',
                    maxWidth: 0.01,
                    transition: theme.transitions.create('max-width', {
                        duration: 50,
                        easing: theme.transitions.easing.easeOut
                    }),
                    whiteSpace: 'nowrap',
                    '& > span': {
                        paddingLeft: 5,
                        paddingRight: 5,
                        display: 'inline-block',
                        opacity: 0,
                        visibility: 'visible'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.withLabel && ownerState.notched,
                style: {
                    maxWidth: '100%',
                    transition: theme.transitions.create('max-width', {
                        duration: 100,
                        easing: theme.transitions.easing.easeOut,
                        delay: 50
                    })
                }
            }
        ]
    })));
/**
 * @ignore - internal component.
 */ function $746323a953600e78$var$NotchedOutline(props) {
    const { children: children, classes: classes, className: className, label: label, notched: notched, ...other } = props;
    const withLabel = label != null && label !== '';
    const ownerState = {
        ...props,
        notched: notched,
        withLabel: withLabel
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($746323a953600e78$var$NotchedOutlineRoot, {
        "aria-hidden": true,
        className: className,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($746323a953600e78$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                children: label
            }) : $746323a953600e78$var$_span || ($746323a953600e78$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "notranslate",
                "aria-hidden": true,
                children: "\u200B"
            }))
        })
    });
}
$746323a953600e78$var$NotchedOutline.propTypes = {
    /**
   * The content of the component.
   */ children: $746323a953600e78$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $746323a953600e78$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $746323a953600e78$var$_propTypes.default.string,
    /**
   * The label.
   */ label: $746323a953600e78$var$_propTypes.default.node,
    /**
   * If `true`, the outline is notched to accommodate the label.
   */ notched: $746323a953600e78$var$_propTypes.default.bool.isRequired,
    /**
   * @ignore
   */ style: $746323a953600e78$var$_propTypes.default.object
};

});







parcelRegister("hABDe", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $cce2fd59bc453dc9$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $cce2fd59bc453dc9$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $cce2fd59bc453dc9$var$_exportNames = {
    textFieldClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $cce2fd59bc453dc9$var$_TextField.default;
    }
});
Object.defineProperty(module.exports, "textFieldClasses", {
    enumerable: true,
    get: function() {
        return $cce2fd59bc453dc9$var$_textFieldClasses.default;
    }
});

var $cce2fd59bc453dc9$var$_TextField = $cce2fd59bc453dc9$require$_interopRequireDefault((parcelRequire("iAtns")));

var $cce2fd59bc453dc9$var$_textFieldClasses = $cce2fd59bc453dc9$require$_interopRequireWildcard((parcelRequire("3epOE")));
Object.keys($cce2fd59bc453dc9$var$_textFieldClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($cce2fd59bc453dc9$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $cce2fd59bc453dc9$var$_textFieldClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cce2fd59bc453dc9$var$_textFieldClasses[key];
        }
    });
});

});
parcelRegister("iAtns", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $d8826083c5af4ea7$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $d8826083c5af4ea7$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d8826083c5af4ea7$var$React = $d8826083c5af4ea7$require$_interopRequireWildcard((parcelRequire("acw62")));

var $d8826083c5af4ea7$var$_propTypes = $d8826083c5af4ea7$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $d8826083c5af4ea7$var$_clsx = $d8826083c5af4ea7$require$_interopRequireDefault((parcelRequire("9QePP")));

var $d8826083c5af4ea7$var$_composeClasses = $d8826083c5af4ea7$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $d8826083c5af4ea7$var$_useId = $d8826083c5af4ea7$require$_interopRequireDefault((parcelRequire("hwliF")));

var $d8826083c5af4ea7$var$_refType = $d8826083c5af4ea7$require$_interopRequireDefault((parcelRequire("b3gjr")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $d8826083c5af4ea7$var$_Input = $d8826083c5af4ea7$require$_interopRequireDefault((parcelRequire("eAJp9")));

var $d8826083c5af4ea7$var$_FilledInput = $d8826083c5af4ea7$require$_interopRequireDefault((parcelRequire("hE2RV")));

var $d8826083c5af4ea7$var$_OutlinedInput = $d8826083c5af4ea7$require$_interopRequireDefault((parcelRequire("in82R")));

var $d8826083c5af4ea7$var$_InputLabel = $d8826083c5af4ea7$require$_interopRequireDefault((parcelRequire("k9xmz")));

var $d8826083c5af4ea7$var$_FormControl = $d8826083c5af4ea7$require$_interopRequireDefault((parcelRequire("iA4iQ")));

var $d8826083c5af4ea7$var$_FormHelperText = $d8826083c5af4ea7$require$_interopRequireDefault((parcelRequire("4xkW2")));

var $d8826083c5af4ea7$var$_Select = $d8826083c5af4ea7$require$_interopRequireDefault((parcelRequire("dALxx")));

var $3epOE = parcelRequire("3epOE");

var $d8826083c5af4ea7$var$_useSlot = $d8826083c5af4ea7$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $d8826083c5af4ea7$var$variantComponent = {
    standard: $d8826083c5af4ea7$var$_Input.default,
    filled: $d8826083c5af4ea7$var$_FilledInput.default,
    outlined: $d8826083c5af4ea7$var$_OutlinedInput.default
};
const $d8826083c5af4ea7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $d8826083c5af4ea7$var$_composeClasses.default)(slots, $3epOE.getTextFieldUtilityClass, classes);
};
const $d8826083c5af4ea7$var$TextFieldRoot = (0, $aAbgT.styled)($d8826083c5af4ea7$var$_FormControl.default, {
    name: 'MuiTextField',
    slot: 'Root'
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $d8826083c5af4ea7$var$TextField = /*#__PURE__*/ $d8826083c5af4ea7$var$React.forwardRef(function TextField(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiTextField'
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = 'primary', defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextPropsProp, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelPropsProp, inputProps: inputPropsProp, InputProps: InputPropsProp, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectPropsProp, slots: slots = {}, slotProps: slotProps = {}, type: type, value: value, variant: variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    };
    const classes = $d8826083c5af4ea7$var$useUtilityClasses(ownerState);
    if (select && !children) console.error('MUI: `children` must be passed when using the `TextField` component with `select`.');
    const id = (0, $d8826083c5af4ea7$var$_useId.default)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $d8826083c5af4ea7$var$variantComponent[variant];
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            input: InputPropsProp,
            inputLabel: InputLabelPropsProp,
            htmlInput: inputPropsProp,
            formHelperText: FormHelperTextPropsProp,
            select: SelectPropsProp,
            ...slotProps
        }
    };
    const inputAdditionalProps = {};
    const inputLabelSlotProps = externalForwardedProps.slotProps.inputLabel;
    if (variant === 'outlined') {
        if (inputLabelSlotProps && typeof inputLabelSlotProps.shrink !== 'undefined') inputAdditionalProps.notched = inputLabelSlotProps.shrink;
        inputAdditionalProps.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectPropsProp || !SelectPropsProp.native) inputAdditionalProps.id = undefined;
        inputAdditionalProps['aria-describedby'] = undefined;
    }
    const [RootSlot, rootProps] = (0, $d8826083c5af4ea7$var$_useSlot.default)('root', {
        elementType: $d8826083c5af4ea7$var$TextFieldRoot,
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        className: (0, $d8826083c5af4ea7$var$_clsx.default)(classes.root, className),
        ref: ref,
        additionalProps: {
            disabled: disabled,
            error: error,
            fullWidth: fullWidth,
            required: required,
            color: color,
            variant: variant
        }
    });
    const [InputSlot, inputProps] = (0, $d8826083c5af4ea7$var$_useSlot.default)('input', {
        elementType: InputComponent,
        externalForwardedProps: externalForwardedProps,
        additionalProps: inputAdditionalProps,
        ownerState: ownerState
    });
    const [InputLabelSlot, inputLabelProps] = (0, $d8826083c5af4ea7$var$_useSlot.default)('inputLabel', {
        elementType: $d8826083c5af4ea7$var$_InputLabel.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [HtmlInputSlot, htmlInputProps] = (0, $d8826083c5af4ea7$var$_useSlot.default)('htmlInput', {
        elementType: 'input',
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [FormHelperTextSlot, formHelperTextProps] = (0, $d8826083c5af4ea7$var$_useSlot.default)('formHelperText', {
        elementType: $d8826083c5af4ea7$var$_FormHelperText.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SelectSlot, selectProps] = (0, $d8826083c5af4ea7$var$_useSlot.default)('select', {
        elementType: $d8826083c5af4ea7$var$_Select.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const InputElement = /*#__PURE__*/ (0, $ayMG0.jsx)(InputSlot, {
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: htmlInputProps,
        slots: {
            input: slots.htmlInput ? HtmlInputSlot : undefined
        },
        ...inputProps
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            label != null && label !== '' && /*#__PURE__*/ (0, $ayMG0.jsx)(InputLabelSlot, {
                htmlFor: id,
                id: inputLabelId,
                ...inputLabelProps,
                children: label
            }),
            select ? /*#__PURE__*/ (0, $ayMG0.jsx)(SelectSlot, {
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement,
                ...selectProps,
                children: children
            }) : InputElement,
            helperText && /*#__PURE__*/ (0, $ayMG0.jsx)(FormHelperTextSlot, {
                id: helperTextId,
                ...formHelperTextProps,
                children: helperText
            })
        ]
    });
});
$d8826083c5af4ea7$var$TextField.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */ autoComplete: $d8826083c5af4ea7$var$_propTypes.default.string,
    /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */ autoFocus: $d8826083c5af4ea7$var$_propTypes.default.bool,
    /**
   * @ignore
   */ children: $d8826083c5af4ea7$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $d8826083c5af4ea7$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $d8826083c5af4ea7$var$_propTypes.default.string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */ color: $d8826083c5af4ea7$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $d8826083c5af4ea7$var$_propTypes.default.oneOf([
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning'
        ]),
        $d8826083c5af4ea7$var$_propTypes.default.string
    ]),
    /**
   * The default value. Use when the component is not controlled.
   */ defaultValue: $d8826083c5af4ea7$var$_propTypes.default.any,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: $d8826083c5af4ea7$var$_propTypes.default.bool,
    /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */ error: $d8826083c5af4ea7$var$_propTypes.default.bool,
    /**
   * Props applied to the [`FormHelperText`](https://mui.com/material-ui/api/form-helper-text/) element.
   * @deprecated Use `slotProps.formHelperText` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ FormHelperTextProps: $d8826083c5af4ea7$var$_propTypes.default.object,
    /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */ fullWidth: $d8826083c5af4ea7$var$_propTypes.default.bool,
    /**
   * The helper text content.
   */ helperText: $d8826083c5af4ea7$var$_propTypes.default.node,
    /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */ id: $d8826083c5af4ea7$var$_propTypes.default.string,
    /**
   * Props applied to the [`InputLabel`](https://mui.com/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   * @deprecated Use `slotProps.inputLabel` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ InputLabelProps: $d8826083c5af4ea7$var$_propTypes.default.object,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   * @deprecated Use `slotProps.htmlInput` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ inputProps: $d8826083c5af4ea7$var$_propTypes.default.object,
    /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](https://mui.com/material-ui/api/filled-input/),
   * [`OutlinedInput`](https://mui.com/material-ui/api/outlined-input/) or [`Input`](https://mui.com/material-ui/api/input/)
   * component depending on the `variant` prop value.
   * @deprecated Use `slotProps.input` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ InputProps: $d8826083c5af4ea7$var$_propTypes.default.object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: $d8826083c5af4ea7$var$_refType.default,
    /**
   * The label content.
   */ label: $d8826083c5af4ea7$var$_propTypes.default.node,
    /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */ margin: $d8826083c5af4ea7$var$_propTypes.default.oneOf([
        'dense',
        'none',
        'normal'
    ]),
    /**
   * Maximum number of rows to display when multiline option is set to true.
   */ maxRows: $d8826083c5af4ea7$var$_propTypes.default.oneOfType([
        $d8826083c5af4ea7$var$_propTypes.default.number,
        $d8826083c5af4ea7$var$_propTypes.default.string
    ]),
    /**
   * Minimum number of rows to display when multiline option is set to true.
   */ minRows: $d8826083c5af4ea7$var$_propTypes.default.oneOfType([
        $d8826083c5af4ea7$var$_propTypes.default.number,
        $d8826083c5af4ea7$var$_propTypes.default.string
    ]),
    /**
   * If `true`, a `textarea` element is rendered instead of an input.
   * @default false
   */ multiline: $d8826083c5af4ea7$var$_propTypes.default.bool,
    /**
   * Name attribute of the `input` element.
   */ name: $d8826083c5af4ea7$var$_propTypes.default.string,
    /**
   * @ignore
   */ onBlur: $d8826083c5af4ea7$var$_propTypes.default.func,
    /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */ onChange: $d8826083c5af4ea7$var$_propTypes.default.func,
    /**
   * @ignore
   */ onFocus: $d8826083c5af4ea7$var$_propTypes.default.func,
    /**
   * The short hint displayed in the `input` before the user enters a value.
   */ placeholder: $d8826083c5af4ea7$var$_propTypes.default.string,
    /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */ required: $d8826083c5af4ea7$var$_propTypes.default.bool,
    /**
   * Number of rows to display when multiline option is set to true.
   */ rows: $d8826083c5af4ea7$var$_propTypes.default.oneOfType([
        $d8826083c5af4ea7$var$_propTypes.default.number,
        $d8826083c5af4ea7$var$_propTypes.default.string
    ]),
    /**
   * Render a [`Select`](https://mui.com/material-ui/api/select/) element while passing the Input element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   * @default false
   */ select: $d8826083c5af4ea7$var$_propTypes.default.bool,
    /**
   * Props applied to the [`Select`](https://mui.com/material-ui/api/select/) element.
   * @deprecated Use `slotProps.select` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ SelectProps: $d8826083c5af4ea7$var$_propTypes.default.object,
    /**
   * The size of the component.
   * @default 'medium'
   */ size: $d8826083c5af4ea7$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $d8826083c5af4ea7$var$_propTypes.default.oneOf([
            'medium',
            'small'
        ]),
        $d8826083c5af4ea7$var$_propTypes.default.string
    ]),
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $d8826083c5af4ea7$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .shape({
        formHelperText: $d8826083c5af4ea7$var$_propTypes.default.oneOfType([
            $d8826083c5af4ea7$var$_propTypes.default.func,
            $d8826083c5af4ea7$var$_propTypes.default.object
        ]),
        htmlInput: $d8826083c5af4ea7$var$_propTypes.default.oneOfType([
            $d8826083c5af4ea7$var$_propTypes.default.func,
            $d8826083c5af4ea7$var$_propTypes.default.object
        ]),
        input: $d8826083c5af4ea7$var$_propTypes.default.oneOfType([
            $d8826083c5af4ea7$var$_propTypes.default.func,
            $d8826083c5af4ea7$var$_propTypes.default.object
        ]),
        inputLabel: $d8826083c5af4ea7$var$_propTypes.default.oneOfType([
            $d8826083c5af4ea7$var$_propTypes.default.func,
            $d8826083c5af4ea7$var$_propTypes.default.object
        ]),
        select: $d8826083c5af4ea7$var$_propTypes.default.oneOfType([
            $d8826083c5af4ea7$var$_propTypes.default.func,
            $d8826083c5af4ea7$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: $d8826083c5af4ea7$var$_propTypes.default.shape({
        formHelperText: $d8826083c5af4ea7$var$_propTypes.default.elementType,
        htmlInput: $d8826083c5af4ea7$var$_propTypes.default.elementType,
        input: $d8826083c5af4ea7$var$_propTypes.default.elementType,
        inputLabel: $d8826083c5af4ea7$var$_propTypes.default.elementType,
        root: $d8826083c5af4ea7$var$_propTypes.default.elementType,
        select: $d8826083c5af4ea7$var$_propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $d8826083c5af4ea7$var$_propTypes.default.oneOfType([
        $d8826083c5af4ea7$var$_propTypes.default.arrayOf($d8826083c5af4ea7$var$_propTypes.default.oneOfType([
            $d8826083c5af4ea7$var$_propTypes.default.func,
            $d8826083c5af4ea7$var$_propTypes.default.object,
            $d8826083c5af4ea7$var$_propTypes.default.bool
        ])),
        $d8826083c5af4ea7$var$_propTypes.default.func,
        $d8826083c5af4ea7$var$_propTypes.default.object
    ]),
    /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#input_types).
   */ type: $d8826083c5af4ea7$var$_propTypes.default.string,
    /**
   * The value of the `input` element, required for a controlled component.
   */ value: $d8826083c5af4ea7$var$_propTypes.default.any,
    /**
   * The variant to use.
   * @default 'outlined'
   */ variant: $d8826083c5af4ea7$var$_propTypes.default.oneOf([
        'filled',
        'outlined',
        'standard'
    ])
};
var $d8826083c5af4ea7$var$_default = module.exports.default = $d8826083c5af4ea7$var$TextField;

});
parcelRegister("k9xmz", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $eabe871db5ab5d36$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $eabe871db5ab5d36$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $eabe871db5ab5d36$var$_exportNames = {
    inputLabelClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $eabe871db5ab5d36$var$_InputLabel.default;
    }
});
Object.defineProperty(module.exports, "inputLabelClasses", {
    enumerable: true,
    get: function() {
        return $eabe871db5ab5d36$var$_inputLabelClasses.default;
    }
});

var $eabe871db5ab5d36$var$_InputLabel = $eabe871db5ab5d36$require$_interopRequireDefault((parcelRequire("OEVqP")));

var $eabe871db5ab5d36$var$_inputLabelClasses = $eabe871db5ab5d36$require$_interopRequireWildcard((parcelRequire("cCThE")));
Object.keys($eabe871db5ab5d36$var$_inputLabelClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($eabe871db5ab5d36$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $eabe871db5ab5d36$var$_inputLabelClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eabe871db5ab5d36$var$_inputLabelClasses[key];
        }
    });
});

});
parcelRegister("OEVqP", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $09846a8ab0aba36e$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $09846a8ab0aba36e$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $09846a8ab0aba36e$var$React = $09846a8ab0aba36e$require$_interopRequireWildcard((parcelRequire("acw62")));

var $09846a8ab0aba36e$var$_propTypes = $09846a8ab0aba36e$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $09846a8ab0aba36e$var$_composeClasses = $09846a8ab0aba36e$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $09846a8ab0aba36e$var$_clsx = $09846a8ab0aba36e$require$_interopRequireDefault((parcelRequire("9QePP")));

var $09846a8ab0aba36e$var$_formControlState = $09846a8ab0aba36e$require$_interopRequireDefault((parcelRequire("aaphR")));

var $09846a8ab0aba36e$var$_useFormControl = $09846a8ab0aba36e$require$_interopRequireDefault((parcelRequire("cJQfW")));

var $09846a8ab0aba36e$var$_FormLabel = $09846a8ab0aba36e$require$_interopRequireWildcard((parcelRequire("d7nZ1")));

var $09846a8ab0aba36e$var$_capitalize = $09846a8ab0aba36e$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $09846a8ab0aba36e$var$_rootShouldForwardProp = $09846a8ab0aba36e$require$_interopRequireDefault((parcelRequire("8Uq77")));

var $aAbgT = parcelRequire("aAbgT");

var $09846a8ab0aba36e$var$_memoTheme = $09846a8ab0aba36e$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $cCThE = parcelRequire("cCThE");

var $ayMG0 = parcelRequire("ayMG0");
const $09846a8ab0aba36e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            formControl && 'formControl',
            !disableAnimation && 'animated',
            shrink && 'shrink',
            size && size !== 'medium' && `size${(0, $09846a8ab0aba36e$var$_capitalize.default)(size)}`,
            variant
        ],
        asterisk: [
            required && 'asterisk'
        ]
    };
    const composedClasses = (0, $09846a8ab0aba36e$var$_composeClasses.default)(slots, $cCThE.getInputLabelUtilityClasses, classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the FormLabel
        ...composedClasses
    };
};
const $09846a8ab0aba36e$var$InputLabelRoot = (0, $aAbgT.styled)($09846a8ab0aba36e$var$_FormLabel.default, {
    shouldForwardProp: (prop)=>(0, $09846a8ab0aba36e$var$_rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiInputLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${$09846a8ab0aba36e$var$_FormLabel.formLabelClasses.asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === 'small' && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})((0, $09846a8ab0aba36e$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'block',
        transformOrigin: 'top left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.formControl,
                style: {
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    // slight alteration to spec spacing to match visual spec result
                    transform: 'translate(0, 20px) scale(1)'
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    // Compensation for the `Input.inputSizeSmall` style.
                    transform: 'translate(0, 17px) scale(1)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.shrink,
                style: {
                    transform: 'translate(0, -1.5px) scale(0.75)',
                    transformOrigin: 'top left',
                    maxWidth: '133%'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableAnimation,
                style: {
                    transition: theme.transitions.create([
                        'color',
                        'transform',
                        'max-width'
                    ], {
                        duration: theme.transitions.duration.shorter,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    // Chrome's autofill feature gives the input field a yellow background.
                    // Since the input field is behind the label in the HTML tree,
                    // the input field is drawn last and hides the label with an opaque background color.
                    // zIndex: 1 will raise the label above opaque background-colors of input.
                    zIndex: 1,
                    pointerEvents: 'none',
                    transform: 'translate(12px, 16px) scale(1)',
                    maxWidth: 'calc(100% - 24px)'
                }
            },
            {
                props: {
                    variant: 'filled',
                    size: 'small'
                },
                style: {
                    transform: 'translate(12px, 13px) scale(1)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState })=>variant === 'filled' && ownerState.shrink,
                style: {
                    userSelect: 'none',
                    pointerEvents: 'auto',
                    transform: 'translate(12px, 7px) scale(0.75)',
                    maxWidth: 'calc(133% - 24px)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState, size: size })=>variant === 'filled' && ownerState.shrink && size === 'small',
                style: {
                    transform: 'translate(12px, 4px) scale(0.75)'
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    // see comment above on filled.zIndex
                    zIndex: 1,
                    pointerEvents: 'none',
                    transform: 'translate(14px, 16px) scale(1)',
                    maxWidth: 'calc(100% - 24px)'
                }
            },
            {
                props: {
                    variant: 'outlined',
                    size: 'small'
                },
                style: {
                    transform: 'translate(14px, 9px) scale(1)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState })=>variant === 'outlined' && ownerState.shrink,
                style: {
                    userSelect: 'none',
                    pointerEvents: 'auto',
                    // Theoretically, we should have (8+5)*2/0.75 = 34px
                    // but it feels a better when it bleeds a bit on the left, so 32px.
                    maxWidth: 'calc(133% - 32px)',
                    transform: 'translate(14px, -9px) scale(0.75)'
                }
            }
        ]
    })));
const $09846a8ab0aba36e$var$InputLabel = /*#__PURE__*/ $09846a8ab0aba36e$var$React.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        name: 'MuiInputLabel',
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, margin: margin, shrink: shrinkProp, variant: variant, className: className, ...other } = props;
    const muiFormControl = (0, $09846a8ab0aba36e$var$_useFormControl.default)();
    let shrink = shrinkProp;
    if (typeof shrink === 'undefined' && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $09846a8ab0aba36e$var$_formControlState.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'size',
            'variant',
            'required',
            'focused'
        ]
    });
    const ownerState = {
        ...props,
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    };
    const classes = $09846a8ab0aba36e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($09846a8ab0aba36e$var$InputLabelRoot, {
        "data-shrink": shrink,
        ref: ref,
        className: (0, $09846a8ab0aba36e$var$_clsx.default)(classes.root, className),
        ...other,
        ownerState: ownerState,
        classes: classes
    });
});
$09846a8ab0aba36e$var$InputLabel.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: $09846a8ab0aba36e$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $09846a8ab0aba36e$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $09846a8ab0aba36e$var$_propTypes.default.string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */ color: $09846a8ab0aba36e$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $09846a8ab0aba36e$var$_propTypes.default.oneOf([
            'error',
            'info',
            'primary',
            'secondary',
            'success',
            'warning'
        ]),
        $09846a8ab0aba36e$var$_propTypes.default.string
    ]),
    /**
   * If `true`, the transition animation is disabled.
   * @default false
   */ disableAnimation: $09846a8ab0aba36e$var$_propTypes.default.bool,
    /**
   * If `true`, the component is disabled.
   */ disabled: $09846a8ab0aba36e$var$_propTypes.default.bool,
    /**
   * If `true`, the label is displayed in an error state.
   */ error: $09846a8ab0aba36e$var$_propTypes.default.bool,
    /**
   * If `true`, the `input` of this label is focused.
   */ focused: $09846a8ab0aba36e$var$_propTypes.default.bool,
    /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */ margin: $09846a8ab0aba36e$var$_propTypes.default.oneOf([
        'dense'
    ]),
    /**
   * if `true`, the label will indicate that the `input` is required.
   */ required: $09846a8ab0aba36e$var$_propTypes.default.bool,
    /**
   * If `true`, the label is shrunk.
   */ shrink: $09846a8ab0aba36e$var$_propTypes.default.bool,
    /**
   * The size of the component.
   * @default 'medium'
   */ size: $09846a8ab0aba36e$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $09846a8ab0aba36e$var$_propTypes.default.oneOf([
            'medium',
            'small'
        ]),
        $09846a8ab0aba36e$var$_propTypes.default.string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $09846a8ab0aba36e$var$_propTypes.default.oneOfType([
        $09846a8ab0aba36e$var$_propTypes.default.arrayOf($09846a8ab0aba36e$var$_propTypes.default.oneOfType([
            $09846a8ab0aba36e$var$_propTypes.default.func,
            $09846a8ab0aba36e$var$_propTypes.default.object,
            $09846a8ab0aba36e$var$_propTypes.default.bool
        ])),
        $09846a8ab0aba36e$var$_propTypes.default.func,
        $09846a8ab0aba36e$var$_propTypes.default.object
    ]),
    /**
   * The variant to use.
   */ variant: $09846a8ab0aba36e$var$_propTypes.default.oneOf([
        'filled',
        'outlined',
        'standard'
    ])
};
var $09846a8ab0aba36e$var$_default = module.exports.default = $09846a8ab0aba36e$var$InputLabel;

});
parcelRegister("d7nZ1", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $98ce88637df666c4$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $98ce88637df666c4$var$_exportNames = {
    formLabelClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $98ce88637df666c4$var$_FormLabel.default;
    }
});
Object.defineProperty(module.exports, "formLabelClasses", {
    enumerable: true,
    get: function() {
        return $98ce88637df666c4$var$_formLabelClasses.default;
    }
});

var $98ce88637df666c4$var$_FormLabel = $98ce88637df666c4$require$_interopRequireWildcard((parcelRequire("djhCy")));
Object.keys($98ce88637df666c4$var$_FormLabel).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($98ce88637df666c4$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $98ce88637df666c4$var$_FormLabel[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $98ce88637df666c4$var$_FormLabel[key];
        }
    });
});

var $98ce88637df666c4$var$_formLabelClasses = $98ce88637df666c4$require$_interopRequireWildcard((parcelRequire("h2sOW")));
Object.keys($98ce88637df666c4$var$_formLabelClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($98ce88637df666c4$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $98ce88637df666c4$var$_formLabelClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $98ce88637df666c4$var$_formLabelClasses[key];
        }
    });
});

});
parcelRegister("djhCy", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $9b0ab7de0d37835d$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $9b0ab7de0d37835d$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.FormLabelRoot = void 0;

var $9b0ab7de0d37835d$var$React = $9b0ab7de0d37835d$require$_interopRequireWildcard((parcelRequire("acw62")));

var $9b0ab7de0d37835d$var$_propTypes = $9b0ab7de0d37835d$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $9b0ab7de0d37835d$var$_clsx = $9b0ab7de0d37835d$require$_interopRequireDefault((parcelRequire("9QePP")));

var $9b0ab7de0d37835d$var$_composeClasses = $9b0ab7de0d37835d$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $9b0ab7de0d37835d$var$_formControlState = $9b0ab7de0d37835d$require$_interopRequireDefault((parcelRequire("aaphR")));

var $9b0ab7de0d37835d$var$_useFormControl = $9b0ab7de0d37835d$require$_interopRequireDefault((parcelRequire("cJQfW")));

var $9b0ab7de0d37835d$var$_capitalize = $9b0ab7de0d37835d$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $aAbgT = parcelRequire("aAbgT");

var $9b0ab7de0d37835d$var$_memoTheme = $9b0ab7de0d37835d$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $9b0ab7de0d37835d$var$_createSimplePaletteValueFilter = $9b0ab7de0d37835d$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $hL1nr = parcelRequire("hL1nr");

var $9b0ab7de0d37835d$var$_formLabelClasses = $9b0ab7de0d37835d$require$_interopRequireWildcard((parcelRequire("h2sOW")));

var $ayMG0 = parcelRequire("ayMG0");
const $9b0ab7de0d37835d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $9b0ab7de0d37835d$var$_capitalize.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            filled && 'filled',
            focused && 'focused',
            required && 'required'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $9b0ab7de0d37835d$var$_composeClasses.default)(slots, $9b0ab7de0d37835d$var$_formLabelClasses.getFormLabelUtilityClasses, classes);
};
const $9b0ab7de0d37835d$var$FormLabelRoot = module.exports.FormLabelRoot = (0, $aAbgT.styled)('label', {
    name: 'MuiFormLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color === 'secondary' && styles.colorSecondary,
            ownerState.filled && styles.filled
        ];
    }
})((0, $9b0ab7de0d37835d$var$_memoTheme.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        ...theme.typography.body1,
        lineHeight: '1.4375em',
        padding: 0,
        position: 'relative',
        variants: [
            ...Object.entries(theme.palette).filter((0, $9b0ab7de0d37835d$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${$9b0ab7de0d37835d$var$_formLabelClasses.default.focused}`]: {
                            color: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                props: {},
                style: {
                    [`&.${$9b0ab7de0d37835d$var$_formLabelClasses.default.disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    },
                    [`&.${$9b0ab7de0d37835d$var$_formLabelClasses.default.error}`]: {
                        color: (theme.vars || theme).palette.error.main
                    }
                }
            }
        ]
    })));
const $9b0ab7de0d37835d$var$AsteriskComponent = (0, $aAbgT.styled)('span', {
    name: 'MuiFormLabel',
    slot: 'Asterisk'
})((0, $9b0ab7de0d37835d$var$_memoTheme.default)(({ theme: theme })=>({
        [`&.${$9b0ab7de0d37835d$var$_formLabelClasses.default.error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
const $9b0ab7de0d37835d$var$FormLabel = /*#__PURE__*/ $9b0ab7de0d37835d$var$React.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiFormLabel'
    });
    const { children: children, className: className, color: color, component: component = 'label', disabled: disabled, error: error, filled: filled, focused: focused, required: required, ...other } = props;
    const muiFormControl = (0, $9b0ab7de0d37835d$var$_useFormControl.default)();
    const fcs = (0, $9b0ab7de0d37835d$var$_formControlState.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'required',
            'focused',
            'disabled',
            'error',
            'filled'
        ]
    });
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    };
    const classes = $9b0ab7de0d37835d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($9b0ab7de0d37835d$var$FormLabelRoot, {
        as: component,
        ownerState: ownerState,
        className: (0, $9b0ab7de0d37835d$var$_clsx.default)(classes.root, className),
        ref: ref,
        ...other,
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $ayMG0.jsxs)($9b0ab7de0d37835d$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    '*'
                ]
            })
        ]
    });
});
$9b0ab7de0d37835d$var$FormLabel.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: $9b0ab7de0d37835d$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $9b0ab7de0d37835d$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $9b0ab7de0d37835d$var$_propTypes.default.string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */ color: $9b0ab7de0d37835d$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $9b0ab7de0d37835d$var$_propTypes.default.oneOf([
            'error',
            'info',
            'primary',
            'secondary',
            'success',
            'warning'
        ]),
        $9b0ab7de0d37835d$var$_propTypes.default.string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $9b0ab7de0d37835d$var$_propTypes.default.elementType,
    /**
   * If `true`, the label should be displayed in a disabled state.
   */ disabled: $9b0ab7de0d37835d$var$_propTypes.default.bool,
    /**
   * If `true`, the label is displayed in an error state.
   */ error: $9b0ab7de0d37835d$var$_propTypes.default.bool,
    /**
   * If `true`, the label should use filled classes key.
   */ filled: $9b0ab7de0d37835d$var$_propTypes.default.bool,
    /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */ focused: $9b0ab7de0d37835d$var$_propTypes.default.bool,
    /**
   * If `true`, the label will indicate that the `input` is required.
   */ required: $9b0ab7de0d37835d$var$_propTypes.default.bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $9b0ab7de0d37835d$var$_propTypes.default.oneOfType([
        $9b0ab7de0d37835d$var$_propTypes.default.arrayOf($9b0ab7de0d37835d$var$_propTypes.default.oneOfType([
            $9b0ab7de0d37835d$var$_propTypes.default.func,
            $9b0ab7de0d37835d$var$_propTypes.default.object,
            $9b0ab7de0d37835d$var$_propTypes.default.bool
        ])),
        $9b0ab7de0d37835d$var$_propTypes.default.func,
        $9b0ab7de0d37835d$var$_propTypes.default.object
    ])
};
var $9b0ab7de0d37835d$var$_default = module.exports.default = $9b0ab7de0d37835d$var$FormLabel;

});
parcelRegister("h2sOW", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c678fac155df4fc3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getFormLabelUtilityClasses = $c678fac155df4fc3$var$getFormLabelUtilityClasses;

var $c678fac155df4fc3$var$_generateUtilityClasses = $c678fac155df4fc3$require$_interopRequireDefault((parcelRequire("5nY49")));

var $c678fac155df4fc3$var$_generateUtilityClass = $c678fac155df4fc3$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $c678fac155df4fc3$var$getFormLabelUtilityClasses(slot) {
    return (0, $c678fac155df4fc3$var$_generateUtilityClass.default)('MuiFormLabel', slot);
}
const $c678fac155df4fc3$var$formLabelClasses = (0, $c678fac155df4fc3$var$_generateUtilityClasses.default)('MuiFormLabel', [
    'root',
    'colorSecondary',
    'focused',
    'disabled',
    'error',
    'filled',
    'required',
    'asterisk'
]);
var $c678fac155df4fc3$var$_default = module.exports.default = $c678fac155df4fc3$var$formLabelClasses;

});



parcelRegister("cCThE", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9313ead0c5e2e8ca$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getInputLabelUtilityClasses = $9313ead0c5e2e8ca$var$getInputLabelUtilityClasses;

var $9313ead0c5e2e8ca$var$_generateUtilityClasses = $9313ead0c5e2e8ca$require$_interopRequireDefault((parcelRequire("5nY49")));

var $9313ead0c5e2e8ca$var$_generateUtilityClass = $9313ead0c5e2e8ca$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $9313ead0c5e2e8ca$var$getInputLabelUtilityClasses(slot) {
    return (0, $9313ead0c5e2e8ca$var$_generateUtilityClass.default)('MuiInputLabel', slot);
}
const $9313ead0c5e2e8ca$var$inputLabelClasses = (0, $9313ead0c5e2e8ca$var$_generateUtilityClasses.default)('MuiInputLabel', [
    'root',
    'focused',
    'disabled',
    'error',
    'required',
    'asterisk',
    'formControl',
    'sizeSmall',
    'shrink',
    'animated',
    'standard',
    'filled',
    'outlined'
]);
var $9313ead0c5e2e8ca$var$_default = module.exports.default = $9313ead0c5e2e8ca$var$inputLabelClasses;

});



parcelRegister("iA4iQ", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $d86eed44238f23f0$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $d86eed44238f23f0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $d86eed44238f23f0$var$_exportNames = {
    useFormControl: true,
    formControlClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $d86eed44238f23f0$var$_FormControl.default;
    }
});
Object.defineProperty(module.exports, "formControlClasses", {
    enumerable: true,
    get: function() {
        return $d86eed44238f23f0$var$_formControlClasses.default;
    }
});
Object.defineProperty(module.exports, "useFormControl", {
    enumerable: true,
    get: function() {
        return $d86eed44238f23f0$var$_useFormControl.default;
    }
});

var $d86eed44238f23f0$var$_FormControl = $d86eed44238f23f0$require$_interopRequireDefault((parcelRequire("gd5y7")));

var $d86eed44238f23f0$var$_useFormControl = $d86eed44238f23f0$require$_interopRequireDefault((parcelRequire("cJQfW")));

var $d86eed44238f23f0$var$_formControlClasses = $d86eed44238f23f0$require$_interopRequireWildcard((parcelRequire("hGBKj")));
Object.keys($d86eed44238f23f0$var$_formControlClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d86eed44238f23f0$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d86eed44238f23f0$var$_formControlClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d86eed44238f23f0$var$_formControlClasses[key];
        }
    });
});

});
parcelRegister("gd5y7", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $bcd22a386c6068c0$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $bcd22a386c6068c0$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bcd22a386c6068c0$var$React = $bcd22a386c6068c0$require$_interopRequireWildcard((parcelRequire("acw62")));

var $bcd22a386c6068c0$var$_propTypes = $bcd22a386c6068c0$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $bcd22a386c6068c0$var$_clsx = $bcd22a386c6068c0$require$_interopRequireDefault((parcelRequire("9QePP")));

var $bcd22a386c6068c0$var$_composeClasses = $bcd22a386c6068c0$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $2BbKU = parcelRequire("2BbKU");

var $bcd22a386c6068c0$var$_capitalize = $bcd22a386c6068c0$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $bcd22a386c6068c0$var$_isMuiElement = $bcd22a386c6068c0$require$_interopRequireDefault((parcelRequire("cpXNi")));

var $bcd22a386c6068c0$var$_FormControlContext = $bcd22a386c6068c0$require$_interopRequireDefault((parcelRequire("blr6C")));

var $hGBKj = parcelRequire("hGBKj");

var $ayMG0 = parcelRequire("ayMG0");
const $bcd22a386c6068c0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            'root',
            margin !== 'none' && `margin${(0, $bcd22a386c6068c0$var$_capitalize.default)(margin)}`,
            fullWidth && 'fullWidth'
        ]
    };
    return (0, $bcd22a386c6068c0$var$_composeClasses.default)(slots, $hGBKj.getFormControlUtilityClasses, classes);
};
const $bcd22a386c6068c0$var$FormControlRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiFormControl',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`margin${(0, $bcd22a386c6068c0$var$_capitalize.default)(ownerState.margin)}`],
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})({
    display: 'inline-flex',
    flexDirection: 'column',
    position: 'relative',
    // Reset fieldset default style.
    minWidth: 0,
    padding: 0,
    margin: 0,
    border: 0,
    verticalAlign: 'top',
    // Fix alignment issue on Safari.
    variants: [
        {
            props: {
                margin: 'normal'
            },
            style: {
                marginTop: 16,
                marginBottom: 8
            }
        },
        {
            props: {
                margin: 'dense'
            },
            style: {
                marginTop: 8,
                marginBottom: 4
            }
        },
        {
            props: {
                fullWidth: true
            },
            style: {
                width: '100%'
            }
        }
    ]
});
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $bcd22a386c6068c0$var$FormControl = /*#__PURE__*/ $bcd22a386c6068c0$var$React.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControl'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = 'none', required: required = false, size: size = 'medium', variant: variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    };
    const classes = $bcd22a386c6068c0$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $bcd22a386c6068c0$var$React.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $bcd22a386c6068c0$var$React.Children.forEach(children, (child)=>{
            if (!(0, $bcd22a386c6068c0$var$_isMuiElement.default)(child, [
                'Input',
                'Select'
            ])) return;
            const input = (0, $bcd22a386c6068c0$var$_isMuiElement.default)(child, [
                'Select'
            ]) ? child.props.input : child;
            if (input && (0, $2BbKU.isAdornedStart)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $bcd22a386c6068c0$var$React.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $bcd22a386c6068c0$var$React.Children.forEach(children, (child)=>{
            if (!(0, $bcd22a386c6068c0$var$_isMuiElement.default)(child, [
                'Input',
                'Select'
            ])) return;
            if ((0, $2BbKU.isFilled)(child.props, true) || (0, $2BbKU.isFilled)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $bcd22a386c6068c0$var$React.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const registeredInput = $bcd22a386c6068c0$var$React.useRef(false);
    registerEffect = ()=>{
        if (registeredInput.current) console.error([
            'MUI: There are multiple `InputBase` components inside a FormControl.',
            'This creates visual inconsistencies, only use one `InputBase`.'
        ].join('\n'));
        registeredInput.current = true;
        return ()=>{
            registeredInput.current = false;
        };
    };
    const onFilled = $bcd22a386c6068c0$var$React.useCallback(()=>{
        setFilled(true);
    }, []);
    const onEmpty = $bcd22a386c6068c0$var$React.useCallback(()=>{
        setFilled(false);
    }, []);
    const childContext = $bcd22a386c6068c0$var$React.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            onEmpty: onEmpty,
            onFilled: onFilled,
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        onEmpty,
        onFilled,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($bcd22a386c6068c0$var$_FormControlContext.default.Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($bcd22a386c6068c0$var$FormControlRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $bcd22a386c6068c0$var$_clsx.default)(classes.root, className),
            ref: ref,
            ...other,
            children: children
        })
    });
});
$bcd22a386c6068c0$var$FormControl.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: $bcd22a386c6068c0$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $bcd22a386c6068c0$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $bcd22a386c6068c0$var$_propTypes.default.string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */ color: $bcd22a386c6068c0$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $bcd22a386c6068c0$var$_propTypes.default.oneOf([
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning'
        ]),
        $bcd22a386c6068c0$var$_propTypes.default.string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $bcd22a386c6068c0$var$_propTypes.default.elementType,
    /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   * @default false
   */ disabled: $bcd22a386c6068c0$var$_propTypes.default.bool,
    /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */ error: $bcd22a386c6068c0$var$_propTypes.default.bool,
    /**
   * If `true`, the component is displayed in focused state.
   */ focused: $bcd22a386c6068c0$var$_propTypes.default.bool,
    /**
   * If `true`, the component will take up the full width of its container.
   * @default false
   */ fullWidth: $bcd22a386c6068c0$var$_propTypes.default.bool,
    /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */ hiddenLabel: $bcd22a386c6068c0$var$_propTypes.default.bool,
    /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */ margin: $bcd22a386c6068c0$var$_propTypes.default.oneOf([
        'dense',
        'none',
        'normal'
    ]),
    /**
   * If `true`, the label will indicate that the `input` is required.
   * @default false
   */ required: $bcd22a386c6068c0$var$_propTypes.default.bool,
    /**
   * The size of the component.
   * @default 'medium'
   */ size: $bcd22a386c6068c0$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $bcd22a386c6068c0$var$_propTypes.default.oneOf([
            'medium',
            'small'
        ]),
        $bcd22a386c6068c0$var$_propTypes.default.string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $bcd22a386c6068c0$var$_propTypes.default.oneOfType([
        $bcd22a386c6068c0$var$_propTypes.default.arrayOf($bcd22a386c6068c0$var$_propTypes.default.oneOfType([
            $bcd22a386c6068c0$var$_propTypes.default.func,
            $bcd22a386c6068c0$var$_propTypes.default.object,
            $bcd22a386c6068c0$var$_propTypes.default.bool
        ])),
        $bcd22a386c6068c0$var$_propTypes.default.func,
        $bcd22a386c6068c0$var$_propTypes.default.object
    ]),
    /**
   * The variant to use.
   * @default 'outlined'
   */ variant: $bcd22a386c6068c0$var$_propTypes.default.oneOf([
        'filled',
        'outlined',
        'standard'
    ])
};
var $bcd22a386c6068c0$var$_default = module.exports.default = $bcd22a386c6068c0$var$FormControl;

});
parcelRegister("hGBKj", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ce03a37a8cfb980d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getFormControlUtilityClasses = $ce03a37a8cfb980d$var$getFormControlUtilityClasses;

var $ce03a37a8cfb980d$var$_generateUtilityClasses = $ce03a37a8cfb980d$require$_interopRequireDefault((parcelRequire("5nY49")));

var $ce03a37a8cfb980d$var$_generateUtilityClass = $ce03a37a8cfb980d$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $ce03a37a8cfb980d$var$getFormControlUtilityClasses(slot) {
    return (0, $ce03a37a8cfb980d$var$_generateUtilityClass.default)('MuiFormControl', slot);
}
const $ce03a37a8cfb980d$var$formControlClasses = (0, $ce03a37a8cfb980d$var$_generateUtilityClasses.default)('MuiFormControl', [
    'root',
    'marginNone',
    'marginNormal',
    'marginDense',
    'fullWidth',
    'disabled'
]);
var $ce03a37a8cfb980d$var$_default = module.exports.default = $ce03a37a8cfb980d$var$formControlClasses;

});



parcelRegister("4xkW2", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $34da7bc50263d1b5$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $34da7bc50263d1b5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $34da7bc50263d1b5$var$_exportNames = {
    formHelperTextClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $34da7bc50263d1b5$var$_FormHelperText.default;
    }
});
Object.defineProperty(module.exports, "formHelperTextClasses", {
    enumerable: true,
    get: function() {
        return $34da7bc50263d1b5$var$_formHelperTextClasses.default;
    }
});

var $34da7bc50263d1b5$var$_FormHelperText = $34da7bc50263d1b5$require$_interopRequireDefault((parcelRequire("i32L9")));

var $34da7bc50263d1b5$var$_formHelperTextClasses = $34da7bc50263d1b5$require$_interopRequireWildcard((parcelRequire("e7ceb")));
Object.keys($34da7bc50263d1b5$var$_formHelperTextClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($34da7bc50263d1b5$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $34da7bc50263d1b5$var$_formHelperTextClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $34da7bc50263d1b5$var$_formHelperTextClasses[key];
        }
    });
});

});
parcelRegister("i32L9", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $d23aa5c3ca6913fb$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $d23aa5c3ca6913fb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d23aa5c3ca6913fb$var$React = $d23aa5c3ca6913fb$require$_interopRequireWildcard((parcelRequire("acw62")));

var $d23aa5c3ca6913fb$var$_propTypes = $d23aa5c3ca6913fb$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $d23aa5c3ca6913fb$var$_clsx = $d23aa5c3ca6913fb$require$_interopRequireDefault((parcelRequire("9QePP")));

var $d23aa5c3ca6913fb$var$_composeClasses = $d23aa5c3ca6913fb$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $d23aa5c3ca6913fb$var$_formControlState = $d23aa5c3ca6913fb$require$_interopRequireDefault((parcelRequire("aaphR")));

var $d23aa5c3ca6913fb$var$_useFormControl = $d23aa5c3ca6913fb$require$_interopRequireDefault((parcelRequire("cJQfW")));

var $aAbgT = parcelRequire("aAbgT");

var $d23aa5c3ca6913fb$var$_memoTheme = $d23aa5c3ca6913fb$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $d23aa5c3ca6913fb$var$_capitalize = $d23aa5c3ca6913fb$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $d23aa5c3ca6913fb$var$_formHelperTextClasses = $d23aa5c3ca6913fb$require$_interopRequireWildcard((parcelRequire("e7ceb")));

var $ayMG0 = parcelRequire("ayMG0");
var $d23aa5c3ca6913fb$var$_span;
const $d23aa5c3ca6913fb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            error && 'error',
            size && `size${(0, $d23aa5c3ca6913fb$var$_capitalize.default)(size)}`,
            contained && 'contained',
            focused && 'focused',
            filled && 'filled',
            required && 'required'
        ]
    };
    return (0, $d23aa5c3ca6913fb$var$_composeClasses.default)(slots, $d23aa5c3ca6913fb$var$_formHelperTextClasses.getFormHelperTextUtilityClasses, classes);
};
const $d23aa5c3ca6913fb$var$FormHelperTextRoot = (0, $aAbgT.styled)('p', {
    name: 'MuiFormHelperText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $d23aa5c3ca6913fb$var$_capitalize.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})((0, $d23aa5c3ca6913fb$var$_memoTheme.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        ...theme.typography.caption,
        textAlign: 'left',
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${$d23aa5c3ca6913fb$var$_formHelperTextClasses.default.disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${$d23aa5c3ca6913fb$var$_formHelperTextClasses.default.error}`]: {
            color: (theme.vars || theme).palette.error.main
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginTop: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.contained,
                style: {
                    marginLeft: 14,
                    marginRight: 14
                }
            }
        ]
    })));
const $d23aa5c3ca6913fb$var$FormHelperText = /*#__PURE__*/ $d23aa5c3ca6913fb$var$React.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiFormHelperText'
    });
    const { children: children, className: className, component: component = 'p', disabled: disabled, error: error, filled: filled, focused: focused, margin: margin, required: required, variant: variant, ...other } = props;
    const muiFormControl = (0, $d23aa5c3ca6913fb$var$_useFormControl.default)();
    const fcs = (0, $d23aa5c3ca6913fb$var$_formControlState.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'size',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    const ownerState = {
        ...props,
        component: component,
        contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    };
    // This issue explains why this is required: https://github.com/mui/material-ui/issues/42184
    delete ownerState.ownerState;
    const classes = $d23aa5c3ca6913fb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($d23aa5c3ca6913fb$var$FormHelperTextRoot, {
        as: component,
        className: (0, $d23aa5c3ca6913fb$var$_clsx.default)(classes.root, className),
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: children === ' ' ? $d23aa5c3ca6913fb$var$_span || ($d23aa5c3ca6913fb$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "notranslate",
            "aria-hidden": true,
            children: "\u200B"
        })) : children
    });
});
$d23aa5c3ca6913fb$var$FormHelperText.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   *
   * If `' '` is provided, the component reserves one line height for displaying a future message.
   */ children: $d23aa5c3ca6913fb$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $d23aa5c3ca6913fb$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $d23aa5c3ca6913fb$var$_propTypes.default.string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $d23aa5c3ca6913fb$var$_propTypes.default.elementType,
    /**
   * If `true`, the helper text should be displayed in a disabled state.
   */ disabled: $d23aa5c3ca6913fb$var$_propTypes.default.bool,
    /**
   * If `true`, helper text should be displayed in an error state.
   */ error: $d23aa5c3ca6913fb$var$_propTypes.default.bool,
    /**
   * If `true`, the helper text should use filled classes key.
   */ filled: $d23aa5c3ca6913fb$var$_propTypes.default.bool,
    /**
   * If `true`, the helper text should use focused classes key.
   */ focused: $d23aa5c3ca6913fb$var$_propTypes.default.bool,
    /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */ margin: $d23aa5c3ca6913fb$var$_propTypes.default.oneOf([
        'dense'
    ]),
    /**
   * If `true`, the helper text should use required classes key.
   */ required: $d23aa5c3ca6913fb$var$_propTypes.default.bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $d23aa5c3ca6913fb$var$_propTypes.default.oneOfType([
        $d23aa5c3ca6913fb$var$_propTypes.default.arrayOf($d23aa5c3ca6913fb$var$_propTypes.default.oneOfType([
            $d23aa5c3ca6913fb$var$_propTypes.default.func,
            $d23aa5c3ca6913fb$var$_propTypes.default.object,
            $d23aa5c3ca6913fb$var$_propTypes.default.bool
        ])),
        $d23aa5c3ca6913fb$var$_propTypes.default.func,
        $d23aa5c3ca6913fb$var$_propTypes.default.object
    ]),
    /**
   * The variant to use.
   */ variant: $d23aa5c3ca6913fb$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $d23aa5c3ca6913fb$var$_propTypes.default.oneOf([
            'filled',
            'outlined',
            'standard'
        ]),
        $d23aa5c3ca6913fb$var$_propTypes.default.string
    ])
};
var $d23aa5c3ca6913fb$var$_default = module.exports.default = $d23aa5c3ca6913fb$var$FormHelperText;

});
parcelRegister("e7ceb", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a46b344d341d82c0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getFormHelperTextUtilityClasses = $a46b344d341d82c0$var$getFormHelperTextUtilityClasses;

var $a46b344d341d82c0$var$_generateUtilityClasses = $a46b344d341d82c0$require$_interopRequireDefault((parcelRequire("5nY49")));

var $a46b344d341d82c0$var$_generateUtilityClass = $a46b344d341d82c0$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $a46b344d341d82c0$var$getFormHelperTextUtilityClasses(slot) {
    return (0, $a46b344d341d82c0$var$_generateUtilityClass.default)('MuiFormHelperText', slot);
}
const $a46b344d341d82c0$var$formHelperTextClasses = (0, $a46b344d341d82c0$var$_generateUtilityClasses.default)('MuiFormHelperText', [
    'root',
    'error',
    'disabled',
    'sizeSmall',
    'sizeMedium',
    'contained',
    'focused',
    'filled',
    'required'
]);
var $a46b344d341d82c0$var$_default = module.exports.default = $a46b344d341d82c0$var$formHelperTextClasses;

});



parcelRegister("3epOE", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $25a6b464d3ca38da$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getTextFieldUtilityClass = $25a6b464d3ca38da$var$getTextFieldUtilityClass;

var $25a6b464d3ca38da$var$_generateUtilityClasses = $25a6b464d3ca38da$require$_interopRequireDefault((parcelRequire("5nY49")));

var $25a6b464d3ca38da$var$_generateUtilityClass = $25a6b464d3ca38da$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $25a6b464d3ca38da$var$getTextFieldUtilityClass(slot) {
    return (0, $25a6b464d3ca38da$var$_generateUtilityClass.default)('MuiTextField', slot);
}
const $25a6b464d3ca38da$var$textFieldClasses = (0, $25a6b464d3ca38da$var$_generateUtilityClasses.default)('MuiTextField', [
    'root'
]);
var $25a6b464d3ca38da$var$_default = module.exports.default = $25a6b464d3ca38da$var$textFieldClasses;

});



parcelRegister("i48ne", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $d26f188d49f0430b$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $d26f188d49f0430b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $d26f188d49f0430b$var$_exportNames = {
    formControlLabelClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $d26f188d49f0430b$var$_FormControlLabel.default;
    }
});
Object.defineProperty(module.exports, "formControlLabelClasses", {
    enumerable: true,
    get: function() {
        return $d26f188d49f0430b$var$_formControlLabelClasses.default;
    }
});

var $d26f188d49f0430b$var$_FormControlLabel = $d26f188d49f0430b$require$_interopRequireDefault((parcelRequire("2esSG")));

var $d26f188d49f0430b$var$_formControlLabelClasses = $d26f188d49f0430b$require$_interopRequireWildcard((parcelRequire("7Z1x5")));
Object.keys($d26f188d49f0430b$var$_formControlLabelClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d26f188d49f0430b$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d26f188d49f0430b$var$_formControlLabelClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d26f188d49f0430b$var$_formControlLabelClasses[key];
        }
    });
});

});
parcelRegister("2esSG", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $1a034abd43bd8eee$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $1a034abd43bd8eee$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.FormControlLabelRoot = void 0;

var $1a034abd43bd8eee$var$React = $1a034abd43bd8eee$require$_interopRequireWildcard((parcelRequire("acw62")));

var $1a034abd43bd8eee$var$_propTypes = $1a034abd43bd8eee$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $1a034abd43bd8eee$var$_clsx = $1a034abd43bd8eee$require$_interopRequireDefault((parcelRequire("9QePP")));

var $1a034abd43bd8eee$var$_refType = $1a034abd43bd8eee$require$_interopRequireDefault((parcelRequire("b3gjr")));

var $1a034abd43bd8eee$var$_composeClasses = $1a034abd43bd8eee$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $iA4iQ = parcelRequire("iA4iQ");

var $aAbgT = parcelRequire("aAbgT");

var $1a034abd43bd8eee$var$_memoTheme = $1a034abd43bd8eee$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $1a034abd43bd8eee$var$_Typography = $1a034abd43bd8eee$require$_interopRequireDefault((parcelRequire("2dUd7")));

var $1a034abd43bd8eee$var$_capitalize = $1a034abd43bd8eee$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $1a034abd43bd8eee$var$_formControlLabelClasses = $1a034abd43bd8eee$require$_interopRequireWildcard((parcelRequire("7Z1x5")));

var $1a034abd43bd8eee$var$_formControlState = $1a034abd43bd8eee$require$_interopRequireDefault((parcelRequire("aaphR")));

var $1a034abd43bd8eee$var$_useSlot = $1a034abd43bd8eee$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $1a034abd43bd8eee$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            `labelPlacement${(0, $1a034abd43bd8eee$var$_capitalize.default)(labelPlacement)}`,
            error && 'error',
            required && 'required'
        ],
        label: [
            'label',
            disabled && 'disabled'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $1a034abd43bd8eee$var$_composeClasses.default)(slots, $1a034abd43bd8eee$var$_formControlLabelClasses.getFormControlLabelUtilityClasses, classes);
};
const $1a034abd43bd8eee$var$FormControlLabelRoot = module.exports.FormControlLabelRoot = (0, $aAbgT.styled)('label', {
    name: 'MuiFormControlLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${$1a034abd43bd8eee$var$_formControlLabelClasses.default.label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $1a034abd43bd8eee$var$_capitalize.default)(ownerState.labelPlacement)}`]
        ];
    }
})((0, $1a034abd43bd8eee$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'pointer',
        // For correct alignment with the text.
        verticalAlign: 'middle',
        WebkitTapHighlightColor: 'transparent',
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${$1a034abd43bd8eee$var$_formControlLabelClasses.default.disabled}`]: {
            cursor: 'default'
        },
        [`& .${$1a034abd43bd8eee$var$_formControlLabelClasses.default.label}`]: {
            [`&.${$1a034abd43bd8eee$var$_formControlLabelClasses.default.disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        },
        variants: [
            {
                props: {
                    labelPlacement: 'start'
                },
                style: {
                    flexDirection: 'row-reverse',
                    marginRight: -11
                }
            },
            {
                props: {
                    labelPlacement: 'top'
                },
                style: {
                    flexDirection: 'column-reverse'
                }
            },
            {
                props: {
                    labelPlacement: 'bottom'
                },
                style: {
                    flexDirection: 'column'
                }
            },
            {
                props: ({ labelPlacement: labelPlacement })=>labelPlacement === 'start' || labelPlacement === 'top' || labelPlacement === 'bottom',
                style: {
                    marginLeft: 16 // used for row presentation of radio/checkbox
                }
            }
        ]
    })));
const $1a034abd43bd8eee$var$AsteriskComponent = (0, $aAbgT.styled)('span', {
    name: 'MuiFormControlLabel',
    slot: 'Asterisk'
})((0, $1a034abd43bd8eee$var$_memoTheme.default)(({ theme: theme })=>({
        [`&.${$1a034abd43bd8eee$var$_formControlLabelClasses.default.error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $1a034abd43bd8eee$var$FormControlLabel = /*#__PURE__*/ $1a034abd43bd8eee$var$React.forwardRef(function FormControlLabel(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControlLabel'
    });
    const { checked: checked, className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, inputRef: inputRef, label: labelProp, labelPlacement: labelPlacement = 'end', name: name, onChange: onChange, required: requiredProp, slots: slots = {}, slotProps: slotProps = {}, value: value, ...other } = props;
    const muiFormControl = (0, $iA4iQ.useFormControl)();
    const disabled = disabledProp ?? control.props.disabled ?? muiFormControl?.disabled;
    const required = requiredProp ?? control.props.required;
    const controlProps = {
        disabled: disabled,
        required: required
    };
    [
        'checked',
        'name',
        'onChange',
        'value',
        'inputRef'
    ].forEach((key)=>{
        if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') controlProps[key] = props[key];
    });
    const fcs = (0, $1a034abd43bd8eee$var$_formControlState.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = {
        ...props,
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    };
    const classes = $1a034abd43bd8eee$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [TypographySlot, typographySlotProps] = (0, $1a034abd43bd8eee$var$_useSlot.default)('typography', {
        elementType: $1a034abd43bd8eee$var$_Typography.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    let label = labelProp;
    if (label != null && label.type !== $1a034abd43bd8eee$var$_Typography.default && !disableTypography) label = /*#__PURE__*/ (0, $ayMG0.jsx)(TypographySlot, {
        component: "span",
        ...typographySlotProps,
        className: (0, $1a034abd43bd8eee$var$_clsx.default)(classes.label, typographySlotProps?.className),
        children: label
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($1a034abd43bd8eee$var$FormControlLabelRoot, {
        className: (0, $1a034abd43bd8eee$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other,
        children: [
            /*#__PURE__*/ $1a034abd43bd8eee$var$React.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    label,
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($1a034abd43bd8eee$var$AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            '*'
                        ]
                    })
                ]
            }) : label
        ]
    });
});
$1a034abd43bd8eee$var$FormControlLabel.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * If `true`, the component appears selected.
   */ checked: $1a034abd43bd8eee$var$_propTypes.default.bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $1a034abd43bd8eee$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $1a034abd43bd8eee$var$_propTypes.default.string,
    /**
   * The props used for each slot inside.
   * @default {}
   * @deprecated use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ componentsProps: $1a034abd43bd8eee$var$_propTypes.default.shape({
        typography: $1a034abd43bd8eee$var$_propTypes.default.object
    }),
    /**
   * A control element. For instance, it can be a `Radio`, a `Switch` or a `Checkbox`.
   */ control: $1a034abd43bd8eee$var$_propTypes.default.element.isRequired,
    /**
   * If `true`, the control is disabled.
   */ disabled: $1a034abd43bd8eee$var$_propTypes.default.bool,
    /**
   * If `true`, the label is rendered as it is passed without an additional typography node.
   */ disableTypography: $1a034abd43bd8eee$var$_propTypes.default.bool,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: $1a034abd43bd8eee$var$_refType.default,
    /**
   * A text or an element to be used in an enclosing label element.
   */ label: $1a034abd43bd8eee$var$_propTypes.default.node,
    /**
   * The position of the label.
   * @default 'end'
   */ labelPlacement: $1a034abd43bd8eee$var$_propTypes.default.oneOf([
        'bottom',
        'end',
        'start',
        'top'
    ]),
    /**
   * @ignore
   */ name: $1a034abd43bd8eee$var$_propTypes.default.string,
    /**
   * Callback fired when the state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */ onChange: $1a034abd43bd8eee$var$_propTypes.default.func,
    /**
   * If `true`, the label will indicate that the `input` is required.
   */ required: $1a034abd43bd8eee$var$_propTypes.default.bool,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $1a034abd43bd8eee$var$_propTypes.default.shape({
        typography: $1a034abd43bd8eee$var$_propTypes.default.oneOfType([
            $1a034abd43bd8eee$var$_propTypes.default.func,
            $1a034abd43bd8eee$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: $1a034abd43bd8eee$var$_propTypes.default.shape({
        typography: $1a034abd43bd8eee$var$_propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $1a034abd43bd8eee$var$_propTypes.default.oneOfType([
        $1a034abd43bd8eee$var$_propTypes.default.arrayOf($1a034abd43bd8eee$var$_propTypes.default.oneOfType([
            $1a034abd43bd8eee$var$_propTypes.default.func,
            $1a034abd43bd8eee$var$_propTypes.default.object,
            $1a034abd43bd8eee$var$_propTypes.default.bool
        ])),
        $1a034abd43bd8eee$var$_propTypes.default.func,
        $1a034abd43bd8eee$var$_propTypes.default.object
    ]),
    /**
   * The value of the component.
   */ value: $1a034abd43bd8eee$var$_propTypes.default.any
};
var $1a034abd43bd8eee$var$_default = module.exports.default = $1a034abd43bd8eee$var$FormControlLabel;

});
parcelRegister("7Z1x5", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5cff6b4166fff27c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getFormControlLabelUtilityClasses = $5cff6b4166fff27c$var$getFormControlLabelUtilityClasses;

var $5cff6b4166fff27c$var$_generateUtilityClasses = $5cff6b4166fff27c$require$_interopRequireDefault((parcelRequire("5nY49")));

var $5cff6b4166fff27c$var$_generateUtilityClass = $5cff6b4166fff27c$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $5cff6b4166fff27c$var$getFormControlLabelUtilityClasses(slot) {
    return (0, $5cff6b4166fff27c$var$_generateUtilityClass.default)('MuiFormControlLabel', slot);
}
const $5cff6b4166fff27c$var$formControlLabelClasses = (0, $5cff6b4166fff27c$var$_generateUtilityClasses.default)('MuiFormControlLabel', [
    'root',
    'labelPlacementStart',
    'labelPlacementTop',
    'labelPlacementBottom',
    'disabled',
    'label',
    'error',
    'required',
    'asterisk'
]);
var $5cff6b4166fff27c$var$_default = module.exports.default = $5cff6b4166fff27c$var$formControlLabelClasses;

});



parcelRegister("5QQ7K", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $442a3dd08ba79e73$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $442a3dd08ba79e73$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $442a3dd08ba79e73$var$_exportNames = {
    switchClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $442a3dd08ba79e73$var$_Switch.default;
    }
});
Object.defineProperty(module.exports, "switchClasses", {
    enumerable: true,
    get: function() {
        return $442a3dd08ba79e73$var$_switchClasses.default;
    }
});

var $442a3dd08ba79e73$var$_Switch = $442a3dd08ba79e73$require$_interopRequireDefault((parcelRequire("7s24a")));

var $442a3dd08ba79e73$var$_switchClasses = $442a3dd08ba79e73$require$_interopRequireWildcard((parcelRequire("89Onw")));
Object.keys($442a3dd08ba79e73$var$_switchClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($442a3dd08ba79e73$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $442a3dd08ba79e73$var$_switchClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $442a3dd08ba79e73$var$_switchClasses[key];
        }
    });
});

});
parcelRegister("7s24a", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $56ccc0421702a0be$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $56ccc0421702a0be$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $56ccc0421702a0be$var$React = $56ccc0421702a0be$require$_interopRequireWildcard((parcelRequire("acw62")));

var $56ccc0421702a0be$var$_propTypes = $56ccc0421702a0be$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $56ccc0421702a0be$var$_clsx = $56ccc0421702a0be$require$_interopRequireDefault((parcelRequire("9QePP")));

var $56ccc0421702a0be$var$_refType = $56ccc0421702a0be$require$_interopRequireDefault((parcelRequire("b3gjr")));

var $56ccc0421702a0be$var$_composeClasses = $56ccc0421702a0be$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $56ccc0421702a0be$var$_capitalize = $56ccc0421702a0be$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $56ccc0421702a0be$var$_createSimplePaletteValueFilter = $56ccc0421702a0be$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $56ccc0421702a0be$var$_SwitchBase = $56ccc0421702a0be$require$_interopRequireDefault((parcelRequire("kVqvD")));

var $aAbgT = parcelRequire("aAbgT");

var $56ccc0421702a0be$var$_memoTheme = $56ccc0421702a0be$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $56ccc0421702a0be$var$_switchClasses = $56ccc0421702a0be$require$_interopRequireWildcard((parcelRequire("89Onw")));

var $hGPki = parcelRequire("hGPki");

var $56ccc0421702a0be$var$_useSlot = $56ccc0421702a0be$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $56ccc0421702a0be$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, edge: edge, size: size, color: color, checked: checked, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            edge && `edge${(0, $56ccc0421702a0be$var$_capitalize.default)(edge)}`,
            `size${(0, $56ccc0421702a0be$var$_capitalize.default)(size)}`
        ],
        switchBase: [
            'switchBase',
            `color${(0, $56ccc0421702a0be$var$_capitalize.default)(color)}`,
            checked && 'checked',
            disabled && 'disabled'
        ],
        thumb: [
            'thumb'
        ],
        track: [
            'track'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $56ccc0421702a0be$var$_composeClasses.default)(slots, $56ccc0421702a0be$var$_switchClasses.getSwitchUtilityClass, classes);
    return {
        ...classes,
        // forward the disabled and checked classes to the SwitchBase
        ...composedClasses
    };
};
const $56ccc0421702a0be$var$SwitchRoot = (0, $aAbgT.styled)('span', {
    name: 'MuiSwitch',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.edge && styles[`edge${(0, $56ccc0421702a0be$var$_capitalize.default)(ownerState.edge)}`],
            styles[`size${(0, $56ccc0421702a0be$var$_capitalize.default)(ownerState.size)}`]
        ];
    }
})({
    display: 'inline-flex',
    width: 58,
    height: 38,
    overflow: 'hidden',
    padding: 12,
    boxSizing: 'border-box',
    position: 'relative',
    flexShrink: 0,
    zIndex: 0,
    // Reset the stacking context.
    verticalAlign: 'middle',
    // For correct alignment with the text.
    '@media print': {
        colorAdjust: 'exact'
    },
    variants: [
        {
            props: {
                edge: 'start'
            },
            style: {
                marginLeft: -8
            }
        },
        {
            props: {
                edge: 'end'
            },
            style: {
                marginRight: -8
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                width: 40,
                height: 24,
                padding: 7,
                [`& .${$56ccc0421702a0be$var$_switchClasses.default.thumb}`]: {
                    width: 16,
                    height: 16
                },
                [`& .${$56ccc0421702a0be$var$_switchClasses.default.switchBase}`]: {
                    padding: 4,
                    [`&.${$56ccc0421702a0be$var$_switchClasses.default.checked}`]: {
                        transform: 'translateX(16px)'
                    }
                }
            }
        }
    ]
});
const $56ccc0421702a0be$var$SwitchSwitchBase = (0, $aAbgT.styled)($56ccc0421702a0be$var$_SwitchBase.default, {
    name: 'MuiSwitch',
    slot: 'SwitchBase',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.switchBase,
            {
                [`& .${$56ccc0421702a0be$var$_switchClasses.default.input}`]: styles.input
            },
            ownerState.color !== 'default' && styles[`color${(0, $56ccc0421702a0be$var$_capitalize.default)(ownerState.color)}`]
        ];
    }
})((0, $56ccc0421702a0be$var$_memoTheme.default)(({ theme: theme })=>({
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 1,
        // Render above the focus ripple.
        color: theme.vars ? theme.vars.palette.Switch.defaultColor : `${theme.palette.mode === 'light' ? theme.palette.common.white : theme.palette.grey[300]}`,
        transition: theme.transitions.create([
            'left',
            'transform'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${$56ccc0421702a0be$var$_switchClasses.default.checked}`]: {
            transform: 'translateX(20px)'
        },
        [`&.${$56ccc0421702a0be$var$_switchClasses.default.disabled}`]: {
            color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : `${theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]}`
        },
        [`&.${$56ccc0421702a0be$var$_switchClasses.default.checked} + .${$56ccc0421702a0be$var$_switchClasses.default.track}`]: {
            opacity: 0.5
        },
        [`&.${$56ccc0421702a0be$var$_switchClasses.default.disabled} + .${$56ccc0421702a0be$var$_switchClasses.default.track}`]: {
            opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === 'light' ? 0.12 : 0.2}`
        },
        [`& .${$56ccc0421702a0be$var$_switchClasses.default.input}`]: {
            left: '-100%',
            width: '300%'
        }
    })), (0, $56ccc0421702a0be$var$_memoTheme.default)(({ theme: theme })=>({
        '&:hover': {
            backgroundColor: theme.alpha((theme.vars || theme).palette.action.active, (theme.vars || theme).palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $56ccc0421702a0be$var$_createSimplePaletteValueFilter.default)([
                'light'
            ])) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${$56ccc0421702a0be$var$_switchClasses.default.checked}`]: {
                            color: (theme.vars || theme).palette[color].main,
                            '&:hover': {
                                backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity),
                                '@media (hover: none)': {
                                    backgroundColor: 'transparent'
                                }
                            },
                            [`&.${$56ccc0421702a0be$var$_switchClasses.default.disabled}`]: {
                                color: theme.vars ? theme.vars.palette.Switch[`${color}DisabledColor`] : `${theme.palette.mode === 'light' ? theme.lighten(theme.palette[color].main, 0.62) : theme.darken(theme.palette[color].main, 0.55)}`
                            }
                        },
                        [`&.${$56ccc0421702a0be$var$_switchClasses.default.checked} + .${$56ccc0421702a0be$var$_switchClasses.default.track}`]: {
                            backgroundColor: (theme.vars || theme).palette[color].main
                        }
                    }
                }))
        ]
    })));
const $56ccc0421702a0be$var$SwitchTrack = (0, $aAbgT.styled)('span', {
    name: 'MuiSwitch',
    slot: 'Track'
})((0, $56ccc0421702a0be$var$_memoTheme.default)(({ theme: theme })=>({
        height: '100%',
        width: '100%',
        borderRadius: 7,
        boxSizing: 'border-box',
        border: '1px solid transparent',
        zIndex: -1,
        transition: theme.transitions.create([
            'opacity',
            'background-color'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === 'light' ? theme.palette.common.black : theme.palette.common.white}`,
        opacity: theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === 'light' ? 0.38 : 0.3}`
    })));
const $56ccc0421702a0be$var$SwitchThumb = (0, $aAbgT.styled)('span', {
    name: 'MuiSwitch',
    slot: 'Thumb'
})((0, $56ccc0421702a0be$var$_memoTheme.default)(({ theme: theme })=>({
        boxShadow: (theme.vars || theme).shadows[1],
        backgroundColor: 'currentColor',
        boxSizing: 'border-box',
        border: '1px solid transparent',
        width: 20,
        height: 20,
        borderRadius: '50%'
    })));
const $56ccc0421702a0be$var$Switch = /*#__PURE__*/ $56ccc0421702a0be$var$React.forwardRef(function Switch(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiSwitch'
    });
    const { className: className, color: color = 'primary', edge: edge = false, size: size = 'medium', sx: sx, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        edge: edge,
        size: size
    };
    const classes = $56ccc0421702a0be$var$useUtilityClasses(ownerState);
    const externalInputProps = slotProps.input;
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootSlotProps] = (0, $56ccc0421702a0be$var$_useSlot.default)('root', {
        className: (0, $56ccc0421702a0be$var$_clsx.default)(classes.root, className),
        elementType: $56ccc0421702a0be$var$SwitchRoot,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            sx: sx
        }
    });
    const [ThumbSlot, thumbSlotProps] = (0, $56ccc0421702a0be$var$_useSlot.default)('thumb', {
        className: classes.thumb,
        elementType: $56ccc0421702a0be$var$SwitchThumb,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const icon = /*#__PURE__*/ (0, $ayMG0.jsx)(ThumbSlot, {
        ...thumbSlotProps
    });
    const [TrackSlot, trackSlotProps] = (0, $56ccc0421702a0be$var$_useSlot.default)('track', {
        className: classes.track,
        elementType: $56ccc0421702a0be$var$SwitchTrack,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($56ccc0421702a0be$var$SwitchSwitchBase, {
                type: "checkbox",
                icon: icon,
                checkedIcon: icon,
                ref: ref,
                ownerState: ownerState,
                ...other,
                classes: {
                    ...classes,
                    root: classes.switchBase
                },
                slots: {
                    ...slots.switchBase && {
                        root: slots.switchBase
                    },
                    ...slots.input && {
                        input: slots.input
                    }
                },
                slotProps: {
                    ...slotProps.switchBase && {
                        root: typeof slotProps.switchBase === 'function' ? slotProps.switchBase(ownerState) : slotProps.switchBase
                    },
                    input: (0, $hGPki.mergeSlotProps)(typeof externalInputProps === 'function' ? externalInputProps(ownerState) : externalInputProps, {
                        role: 'switch'
                    })
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(TrackSlot, {
                ...trackSlotProps
            })
        ]
    });
});
$56ccc0421702a0be$var$Switch.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * If `true`, the component is checked.
   */ checked: $56ccc0421702a0be$var$_propTypes.default.bool,
    /**
   * The icon to display when the component is checked.
   */ checkedIcon: $56ccc0421702a0be$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $56ccc0421702a0be$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $56ccc0421702a0be$var$_propTypes.default.string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */ color: $56ccc0421702a0be$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $56ccc0421702a0be$var$_propTypes.default.oneOf([
            'default',
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning'
        ]),
        $56ccc0421702a0be$var$_propTypes.default.string
    ]),
    /**
   * The default checked state. Use when the component is not controlled.
   */ defaultChecked: $56ccc0421702a0be$var$_propTypes.default.bool,
    /**
   * If `true`, the component is disabled.
   */ disabled: $56ccc0421702a0be$var$_propTypes.default.bool,
    /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */ disableRipple: $56ccc0421702a0be$var$_propTypes.default.bool,
    /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */ edge: $56ccc0421702a0be$var$_propTypes.default.oneOf([
        'end',
        'start',
        false
    ]),
    /**
   * The icon to display when the component is unchecked.
   */ icon: $56ccc0421702a0be$var$_propTypes.default.node,
    /**
   * The id of the `input` element.
   */ id: $56ccc0421702a0be$var$_propTypes.default.string,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   * @deprecated Use `slotProps.input` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ inputProps: $56ccc0421702a0be$var$_propTypes.default.object,
    /**
   * Pass a ref to the `input` element.
   * @deprecated Use `slotProps.input.ref` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ inputRef: $56ccc0421702a0be$var$_refType.default,
    /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */ onChange: $56ccc0421702a0be$var$_propTypes.default.func,
    /**
   * If `true`, the `input` element is required.
   * @default false
   */ required: $56ccc0421702a0be$var$_propTypes.default.bool,
    /**
   * The size of the component.
   * `small` is equivalent to the dense switch styling.
   * @default 'medium'
   */ size: $56ccc0421702a0be$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $56ccc0421702a0be$var$_propTypes.default.oneOf([
            'medium',
            'small'
        ]),
        $56ccc0421702a0be$var$_propTypes.default.string
    ]),
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $56ccc0421702a0be$var$_propTypes.default.shape({
        input: $56ccc0421702a0be$var$_propTypes.default.oneOfType([
            $56ccc0421702a0be$var$_propTypes.default.func,
            $56ccc0421702a0be$var$_propTypes.default.object
        ]),
        root: $56ccc0421702a0be$var$_propTypes.default.oneOfType([
            $56ccc0421702a0be$var$_propTypes.default.func,
            $56ccc0421702a0be$var$_propTypes.default.object
        ]),
        switchBase: $56ccc0421702a0be$var$_propTypes.default.oneOfType([
            $56ccc0421702a0be$var$_propTypes.default.func,
            $56ccc0421702a0be$var$_propTypes.default.object
        ]),
        thumb: $56ccc0421702a0be$var$_propTypes.default.oneOfType([
            $56ccc0421702a0be$var$_propTypes.default.func,
            $56ccc0421702a0be$var$_propTypes.default.object
        ]),
        track: $56ccc0421702a0be$var$_propTypes.default.oneOfType([
            $56ccc0421702a0be$var$_propTypes.default.func,
            $56ccc0421702a0be$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: $56ccc0421702a0be$var$_propTypes.default.shape({
        input: $56ccc0421702a0be$var$_propTypes.default.elementType,
        root: $56ccc0421702a0be$var$_propTypes.default.elementType,
        switchBase: $56ccc0421702a0be$var$_propTypes.default.elementType,
        thumb: $56ccc0421702a0be$var$_propTypes.default.elementType,
        track: $56ccc0421702a0be$var$_propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $56ccc0421702a0be$var$_propTypes.default.oneOfType([
        $56ccc0421702a0be$var$_propTypes.default.arrayOf($56ccc0421702a0be$var$_propTypes.default.oneOfType([
            $56ccc0421702a0be$var$_propTypes.default.func,
            $56ccc0421702a0be$var$_propTypes.default.object,
            $56ccc0421702a0be$var$_propTypes.default.bool
        ])),
        $56ccc0421702a0be$var$_propTypes.default.func,
        $56ccc0421702a0be$var$_propTypes.default.object
    ]),
    /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */ value: $56ccc0421702a0be$var$_propTypes.default.any
};
var $56ccc0421702a0be$var$_default = module.exports.default = $56ccc0421702a0be$var$Switch;

});
parcelRegister("89Onw", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5f063e1b0f6d278b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getSwitchUtilityClass = $5f063e1b0f6d278b$var$getSwitchUtilityClass;

var $5f063e1b0f6d278b$var$_generateUtilityClasses = $5f063e1b0f6d278b$require$_interopRequireDefault((parcelRequire("5nY49")));

var $5f063e1b0f6d278b$var$_generateUtilityClass = $5f063e1b0f6d278b$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $5f063e1b0f6d278b$var$getSwitchUtilityClass(slot) {
    return (0, $5f063e1b0f6d278b$var$_generateUtilityClass.default)('MuiSwitch', slot);
}
const $5f063e1b0f6d278b$var$switchClasses = (0, $5f063e1b0f6d278b$var$_generateUtilityClasses.default)('MuiSwitch', [
    'root',
    'edgeStart',
    'edgeEnd',
    'switchBase',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium',
    'checked',
    'disabled',
    'input',
    'thumb',
    'track'
]);
var $5f063e1b0f6d278b$var$_default = module.exports.default = $5f063e1b0f6d278b$var$switchClasses;

});



parcelRegister("bBQKz", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $873c117b1fb2dd29$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $873c117b1fb2dd29$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $873c117b1fb2dd29$var$_exportNames = {
    buttonClasses: true
};
Object.defineProperty(module.exports, "buttonClasses", {
    enumerable: true,
    get: function() {
        return $873c117b1fb2dd29$var$_buttonClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $873c117b1fb2dd29$var$_Button.default;
    }
});

var $873c117b1fb2dd29$var$_Button = $873c117b1fb2dd29$require$_interopRequireDefault((parcelRequire("6lXkL")));

var $873c117b1fb2dd29$var$_buttonClasses = $873c117b1fb2dd29$require$_interopRequireWildcard((parcelRequire("1xAC3")));
Object.keys($873c117b1fb2dd29$var$_buttonClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($873c117b1fb2dd29$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $873c117b1fb2dd29$var$_buttonClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $873c117b1fb2dd29$var$_buttonClasses[key];
        }
    });
});

});
parcelRegister("6lXkL", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $4a02bab8c70a697b$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $4a02bab8c70a697b$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4a02bab8c70a697b$var$React = $4a02bab8c70a697b$require$_interopRequireWildcard((parcelRequire("acw62")));

var $4a02bab8c70a697b$var$_propTypes = $4a02bab8c70a697b$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $4a02bab8c70a697b$var$_clsx = $4a02bab8c70a697b$require$_interopRequireDefault((parcelRequire("9QePP")));

var $4a02bab8c70a697b$var$_resolveProps = $4a02bab8c70a697b$require$_interopRequireDefault((parcelRequire("7T9kw")));

var $4a02bab8c70a697b$var$_composeClasses = $4a02bab8c70a697b$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $hGPki = parcelRequire("hGPki");

var $4a02bab8c70a697b$var$_rootShouldForwardProp = $4a02bab8c70a697b$require$_interopRequireDefault((parcelRequire("8Uq77")));

var $aAbgT = parcelRequire("aAbgT");

var $4a02bab8c70a697b$var$_memoTheme = $4a02bab8c70a697b$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $4a02bab8c70a697b$var$_ButtonBase = $4a02bab8c70a697b$require$_interopRequireDefault((parcelRequire("hhs3r")));

var $4a02bab8c70a697b$var$_CircularProgress = $4a02bab8c70a697b$require$_interopRequireDefault((parcelRequire("1sBf1")));

var $4a02bab8c70a697b$var$_capitalize = $4a02bab8c70a697b$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $4a02bab8c70a697b$var$_createSimplePaletteValueFilter = $4a02bab8c70a697b$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $4a02bab8c70a697b$var$_buttonClasses = $4a02bab8c70a697b$require$_interopRequireWildcard((parcelRequire("1xAC3")));

var $4a02bab8c70a697b$var$_ButtonGroupContext = $4a02bab8c70a697b$require$_interopRequireDefault((parcelRequire("bwtSM")));

var $4a02bab8c70a697b$var$_ButtonGroupButtonContext = $4a02bab8c70a697b$require$_interopRequireDefault((parcelRequire("3eDio")));

var $ayMG0 = parcelRequire("ayMG0");
const $4a02bab8c70a697b$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, loading: loading, loadingPosition: loadingPosition, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            variant,
            `${variant}${(0, $4a02bab8c70a697b$var$_capitalize.default)(color)}`,
            `size${(0, $4a02bab8c70a697b$var$_capitalize.default)(size)}`,
            `${variant}Size${(0, $4a02bab8c70a697b$var$_capitalize.default)(size)}`,
            `color${(0, $4a02bab8c70a697b$var$_capitalize.default)(color)}`,
            disableElevation && 'disableElevation',
            fullWidth && 'fullWidth',
            loading && `loadingPosition${(0, $4a02bab8c70a697b$var$_capitalize.default)(loadingPosition)}`
        ],
        startIcon: [
            'icon',
            'startIcon',
            `iconSize${(0, $4a02bab8c70a697b$var$_capitalize.default)(size)}`
        ],
        endIcon: [
            'icon',
            'endIcon',
            `iconSize${(0, $4a02bab8c70a697b$var$_capitalize.default)(size)}`
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    const composedClasses = (0, $4a02bab8c70a697b$var$_composeClasses.default)(slots, $4a02bab8c70a697b$var$_buttonClasses.getButtonUtilityClass, classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the ButtonBase
        ...composedClasses
    };
};
const $4a02bab8c70a697b$var$commonIconStyles = [
    {
        props: {
            size: 'small'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 18
            }
        }
    },
    {
        props: {
            size: 'medium'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 20
            }
        }
    },
    {
        props: {
            size: 'large'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 22
            }
        }
    }
];
const $4a02bab8c70a697b$var$ButtonRoot = (0, $aAbgT.styled)($4a02bab8c70a697b$var$_ButtonBase.default, {
    shouldForwardProp: (prop)=>(0, $4a02bab8c70a697b$var$_rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $4a02bab8c70a697b$var$_capitalize.default)(ownerState.color)}`],
            styles[`size${(0, $4a02bab8c70a697b$var$_capitalize.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $4a02bab8c70a697b$var$_capitalize.default)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth,
            ownerState.loading && styles.loading
        ];
    }
})((0, $4a02bab8c70a697b$var$_memoTheme.default)(({ theme: theme })=>{
    const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
    return {
        ...theme.typography.button,
        minWidth: 64,
        padding: '6px 16px',
        border: 0,
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color',
            'color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': {
            textDecoration: 'none'
        },
        [`&.${$4a02bab8c70a697b$var$_buttonClasses.default.disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.startIcon || ownerState.loading && ownerState.loadingPosition === 'start',
                style: {
                    '&::before': {
                        content: '"\\200b"',
                        width: 0,
                        overflow: 'hidden'
                    }
                }
            },
            {
                props: {
                    variant: 'contained'
                },
                style: {
                    color: `var(--variant-containedColor)`,
                    backgroundColor: `var(--variant-containedBg)`,
                    boxShadow: (theme.vars || theme).shadows[2],
                    '&:hover': {
                        boxShadow: (theme.vars || theme).shadows[4],
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            boxShadow: (theme.vars || theme).shadows[2]
                        }
                    },
                    '&:active': {
                        boxShadow: (theme.vars || theme).shadows[8]
                    },
                    [`&.${$4a02bab8c70a697b$var$_buttonClasses.default.focusVisible}`]: {
                        boxShadow: (theme.vars || theme).shadows[6]
                    },
                    [`&.${$4a02bab8c70a697b$var$_buttonClasses.default.disabled}`]: {
                        color: (theme.vars || theme).palette.action.disabled,
                        boxShadow: (theme.vars || theme).shadows[0],
                        backgroundColor: (theme.vars || theme).palette.action.disabledBackground
                    }
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    padding: '5px 15px',
                    border: '1px solid currentColor',
                    borderColor: `var(--variant-outlinedBorder, currentColor)`,
                    backgroundColor: `var(--variant-outlinedBg)`,
                    color: `var(--variant-outlinedColor)`,
                    [`&.${$4a02bab8c70a697b$var$_buttonClasses.default.disabled}`]: {
                        border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
                    }
                }
            },
            {
                props: {
                    variant: 'text'
                },
                style: {
                    padding: '6px 8px',
                    color: `var(--variant-textColor)`,
                    backgroundColor: `var(--variant-textBg)`
                }
            },
            ...Object.entries(theme.palette).filter((0, $4a02bab8c70a697b$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--variant-textColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedBorder': theme.alpha((theme.vars || theme).palette[color].main, 0.5),
                        '--variant-containedColor': (theme.vars || theme).palette[color].contrastText,
                        '--variant-containedBg': (theme.vars || theme).palette[color].main,
                        '@media (hover: hover)': {
                            '&:hover': {
                                '--variant-containedBg': (theme.vars || theme).palette[color].dark,
                                '--variant-textBg': theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity),
                                '--variant-outlinedBorder': (theme.vars || theme).palette[color].main,
                                '--variant-outlinedBg': theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity)
                            }
                        }
                    }
                })),
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit',
                    borderColor: 'currentColor',
                    '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
                    '@media (hover: hover)': {
                        '&:hover': {
                            '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
                            '--variant-textBg': theme.alpha((theme.vars || theme).palette.text.primary, (theme.vars || theme).palette.action.hoverOpacity),
                            '--variant-outlinedBg': theme.alpha((theme.vars || theme).palette.text.primary, (theme.vars || theme).palette.action.hoverOpacity)
                        }
                    }
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'text'
                },
                style: {
                    padding: '4px 5px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'text'
                },
                style: {
                    padding: '8px 11px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'outlined'
                },
                style: {
                    padding: '3px 9px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'outlined'
                },
                style: {
                    padding: '7px 21px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'contained'
                },
                style: {
                    padding: '4px 10px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'contained'
                },
                style: {
                    padding: '8px 22px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    disableElevation: true
                },
                style: {
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: 'none'
                    },
                    [`&.${$4a02bab8c70a697b$var$_buttonClasses.default.focusVisible}`]: {
                        boxShadow: 'none'
                    },
                    '&:active': {
                        boxShadow: 'none'
                    },
                    [`&.${$4a02bab8c70a697b$var$_buttonClasses.default.disabled}`]: {
                        boxShadow: 'none'
                    }
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    loadingPosition: 'center'
                },
                style: {
                    transition: theme.transitions.create([
                        'background-color',
                        'box-shadow',
                        'border-color'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    [`&.${$4a02bab8c70a697b$var$_buttonClasses.default.loading}`]: {
                        color: 'transparent'
                    }
                }
            }
        ]
    };
}));
const $4a02bab8c70a697b$var$ButtonStartIcon = (0, $aAbgT.styled)('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            ownerState.loading && styles.startIconLoadingStart,
            styles[`iconSize${(0, $4a02bab8c70a697b$var$_capitalize.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme })=>({
        display: 'inherit',
        marginRight: 8,
        marginLeft: -4,
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginLeft: -2
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true
                },
                style: {
                    transition: theme.transitions.create([
                        'opacity'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    opacity: 0
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginRight: -8
                }
            },
            ...$4a02bab8c70a697b$var$commonIconStyles
        ]
    }));
const $4a02bab8c70a697b$var$ButtonEndIcon = (0, $aAbgT.styled)('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            ownerState.loading && styles.endIconLoadingEnd,
            styles[`iconSize${(0, $4a02bab8c70a697b$var$_capitalize.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme })=>({
        display: 'inherit',
        marginRight: -4,
        marginLeft: 8,
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginRight: -2
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true
                },
                style: {
                    transition: theme.transitions.create([
                        'opacity'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    opacity: 0
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginLeft: -8
                }
            },
            ...$4a02bab8c70a697b$var$commonIconStyles
        ]
    }));
const $4a02bab8c70a697b$var$ButtonLoadingIndicator = (0, $aAbgT.styled)('span', {
    name: 'MuiButton',
    slot: 'LoadingIndicator'
})(({ theme: theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            },
            {
                props: {
                    loadingPosition: 'start'
                },
                style: {
                    left: 14
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    size: 'small'
                },
                style: {
                    left: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'start'
                },
                style: {
                    left: 6
                }
            },
            {
                props: {
                    loadingPosition: 'center'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%)',
                    color: (theme.vars || theme).palette.action.disabled
                }
            },
            {
                props: {
                    loadingPosition: 'end'
                },
                style: {
                    right: 14
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    size: 'small'
                },
                style: {
                    right: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'end'
                },
                style: {
                    right: 6
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    left: -10
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    right: -10
                }
            }
        ]
    }));
const $4a02bab8c70a697b$var$ButtonLoadingIconPlaceholder = (0, $aAbgT.styled)('span', {
    name: 'MuiButton',
    slot: 'LoadingIconPlaceholder'
})({
    display: 'inline-block',
    width: '1em',
    height: '1em'
});
const $4a02bab8c70a697b$var$Button = /*#__PURE__*/ $4a02bab8c70a697b$var$React.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $4a02bab8c70a697b$var$React.useContext($4a02bab8c70a697b$var$_ButtonGroupContext.default);
    const buttonGroupButtonContextPositionClassName = $4a02bab8c70a697b$var$React.useContext($4a02bab8c70a697b$var$_ButtonGroupButtonContext.default);
    const resolvedProps = (0, $4a02bab8c70a697b$var$_resolveProps.default)(contextProps, inProps);
    const props = (0, $hL1nr.useDefaultProps)({
        props: resolvedProps,
        name: 'MuiButton'
    });
    const { children: children, color: color = 'primary', component: component = 'button', className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, id: idProp, loading: loading = null, loadingIndicator: loadingIndicatorProp, loadingPosition: loadingPosition = 'center', size: size = 'medium', startIcon: startIconProp, type: type, variant: variant = 'text', ...other } = props;
    const loadingId = (0, $hGPki.unstable_useId)(idProp);
    const loadingIndicator = loadingIndicatorProp ?? /*#__PURE__*/ (0, $ayMG0.jsx)($4a02bab8c70a697b$var$_CircularProgress.default, {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        loading: loading,
        loadingIndicator: loadingIndicator,
        loadingPosition: loadingPosition,
        size: size,
        type: type,
        variant: variant
    };
    const classes = $4a02bab8c70a697b$var$useUtilityClasses(ownerState);
    const startIcon = (startIconProp || loading && loadingPosition === 'start') && /*#__PURE__*/ (0, $ayMG0.jsx)($4a02bab8c70a697b$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp || /*#__PURE__*/ (0, $ayMG0.jsx)($4a02bab8c70a697b$var$ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const endIcon = (endIconProp || loading && loadingPosition === 'end') && /*#__PURE__*/ (0, $ayMG0.jsx)($4a02bab8c70a697b$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp || /*#__PURE__*/ (0, $ayMG0.jsx)($4a02bab8c70a697b$var$ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || '';
    const loader = typeof loading === 'boolean' ? /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
    (0, $ayMG0.jsx)("span", {
        className: classes.loadingWrapper,
        style: {
            display: 'contents'
        },
        children: loading && /*#__PURE__*/ (0, $ayMG0.jsx)($4a02bab8c70a697b$var$ButtonLoadingIndicator, {
            className: classes.loadingIndicator,
            ownerState: ownerState,
            children: loadingIndicator
        })
    }) : null;
    // Don't forward the 'root' classes to the ButtonBase, as they will get duplicated with the one passed to the className prop.
    const { root: root, ...forwardedClasses } = classes;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($4a02bab8c70a697b$var$ButtonRoot, {
        ownerState: ownerState,
        className: (0, $4a02bab8c70a697b$var$_clsx.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled || loading,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $4a02bab8c70a697b$var$_clsx.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type,
        id: loading ? loadingId : idProp,
        ...other,
        classes: forwardedClasses,
        children: [
            startIcon,
            loadingPosition !== 'end' && loader,
            children,
            loadingPosition === 'end' && loader,
            endIcon
        ]
    });
});
$4a02bab8c70a697b$var$Button.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: $4a02bab8c70a697b$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $4a02bab8c70a697b$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $4a02bab8c70a697b$var$_propTypes.default.string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */ color: $4a02bab8c70a697b$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $4a02bab8c70a697b$var$_propTypes.default.oneOf([
            'inherit',
            'primary',
            'secondary',
            'success',
            'error',
            'info',
            'warning'
        ]),
        $4a02bab8c70a697b$var$_propTypes.default.string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $4a02bab8c70a697b$var$_propTypes.default.elementType,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: $4a02bab8c70a697b$var$_propTypes.default.bool,
    /**
   * If `true`, no elevation is used.
   * @default false
   */ disableElevation: $4a02bab8c70a697b$var$_propTypes.default.bool,
    /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */ disableFocusRipple: $4a02bab8c70a697b$var$_propTypes.default.bool,
    /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */ disableRipple: $4a02bab8c70a697b$var$_propTypes.default.bool,
    /**
   * Element placed after the children.
   */ endIcon: $4a02bab8c70a697b$var$_propTypes.default.node,
    /**
   * @ignore
   */ focusVisibleClassName: $4a02bab8c70a697b$var$_propTypes.default.string,
    /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */ fullWidth: $4a02bab8c70a697b$var$_propTypes.default.bool,
    /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */ href: $4a02bab8c70a697b$var$_propTypes.default.string,
    /**
   * @ignore
   */ id: $4a02bab8c70a697b$var$_propTypes.default.string,
    /**
   * If `true`, the loading indicator is visible and the button is disabled.
   * If `true | false`, the loading wrapper is always rendered before the children to prevent [Google Translation Crash](https://github.com/mui/material-ui/issues/27853).
   * @default null
   */ loading: $4a02bab8c70a697b$var$_propTypes.default.bool,
    /**
   * Element placed before the children if the button is in loading state.
   * The node should contain an element with `role="progressbar"` with an accessible name.
   * By default, it renders a `CircularProgress` that is labeled by the button itself.
   * @default <CircularProgress color="inherit" size={16} />
   */ loadingIndicator: $4a02bab8c70a697b$var$_propTypes.default.node,
    /**
   * The loading indicator can be positioned on the start, end, or the center of the button.
   * @default 'center'
   */ loadingPosition: $4a02bab8c70a697b$var$_propTypes.default.oneOf([
        'center',
        'end',
        'start'
    ]),
    /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */ size: $4a02bab8c70a697b$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $4a02bab8c70a697b$var$_propTypes.default.oneOf([
            'small',
            'medium',
            'large'
        ]),
        $4a02bab8c70a697b$var$_propTypes.default.string
    ]),
    /**
   * Element placed before the children.
   */ startIcon: $4a02bab8c70a697b$var$_propTypes.default.node,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $4a02bab8c70a697b$var$_propTypes.default.oneOfType([
        $4a02bab8c70a697b$var$_propTypes.default.arrayOf($4a02bab8c70a697b$var$_propTypes.default.oneOfType([
            $4a02bab8c70a697b$var$_propTypes.default.func,
            $4a02bab8c70a697b$var$_propTypes.default.object,
            $4a02bab8c70a697b$var$_propTypes.default.bool
        ])),
        $4a02bab8c70a697b$var$_propTypes.default.func,
        $4a02bab8c70a697b$var$_propTypes.default.object
    ]),
    /**
   * @ignore
   */ type: $4a02bab8c70a697b$var$_propTypes.default.oneOfType([
        $4a02bab8c70a697b$var$_propTypes.default.oneOf([
            'button',
            'reset',
            'submit'
        ]),
        $4a02bab8c70a697b$var$_propTypes.default.string
    ]),
    /**
   * The variant to use.
   * @default 'text'
   */ variant: $4a02bab8c70a697b$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $4a02bab8c70a697b$var$_propTypes.default.oneOf([
            'contained',
            'outlined',
            'text'
        ]),
        $4a02bab8c70a697b$var$_propTypes.default.string
    ])
};
var $4a02bab8c70a697b$var$_default = module.exports.default = $4a02bab8c70a697b$var$Button;

});
parcelRegister("1xAC3", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $11f546081ba06ace$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getButtonUtilityClass = $11f546081ba06ace$var$getButtonUtilityClass;

var $11f546081ba06ace$var$_generateUtilityClasses = $11f546081ba06ace$require$_interopRequireDefault((parcelRequire("5nY49")));

var $11f546081ba06ace$var$_generateUtilityClass = $11f546081ba06ace$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $11f546081ba06ace$var$getButtonUtilityClass(slot) {
    return (0, $11f546081ba06ace$var$_generateUtilityClass.default)('MuiButton', slot);
}
const $11f546081ba06ace$var$buttonClasses = (0, $11f546081ba06ace$var$_generateUtilityClasses.default)('MuiButton', [
    'root',
    'text',
    'textInherit',
    'textPrimary',
    'textSecondary',
    'textSuccess',
    'textError',
    'textInfo',
    'textWarning',
    'outlined',
    'outlinedInherit',
    'outlinedPrimary',
    'outlinedSecondary',
    'outlinedSuccess',
    'outlinedError',
    'outlinedInfo',
    'outlinedWarning',
    'contained',
    'containedInherit',
    'containedPrimary',
    'containedSecondary',
    'containedSuccess',
    'containedError',
    'containedInfo',
    'containedWarning',
    'disableElevation',
    'focusVisible',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorError',
    'colorInfo',
    'colorWarning',
    'textSizeSmall',
    'textSizeMedium',
    'textSizeLarge',
    'outlinedSizeSmall',
    'outlinedSizeMedium',
    'outlinedSizeLarge',
    'containedSizeSmall',
    'containedSizeMedium',
    'containedSizeLarge',
    'sizeMedium',
    'sizeSmall',
    'sizeLarge',
    'fullWidth',
    'startIcon',
    'endIcon',
    'icon',
    'iconSizeSmall',
    'iconSizeMedium',
    'iconSizeLarge',
    'loading',
    'loadingWrapper',
    'loadingIconPlaceholder',
    'loadingIndicator',
    'loadingPositionCenter',
    'loadingPositionStart',
    'loadingPositionEnd'
]);
var $11f546081ba06ace$var$_default = module.exports.default = $11f546081ba06ace$var$buttonClasses;

});

parcelRegister("bwtSM", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $8639dcef822d5d4c$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8639dcef822d5d4c$var$React = $8639dcef822d5d4c$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * @ignore - internal component.
 */ const $8639dcef822d5d4c$var$ButtonGroupContext = /*#__PURE__*/ $8639dcef822d5d4c$var$React.createContext({});
$8639dcef822d5d4c$var$ButtonGroupContext.displayName = 'ButtonGroupContext';
var $8639dcef822d5d4c$var$_default = module.exports.default = $8639dcef822d5d4c$var$ButtonGroupContext;

});

parcelRegister("3eDio", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $25b1293270900846$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25b1293270900846$var$React = $25b1293270900846$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * @ignore - internal component.
 */ const $25b1293270900846$var$ButtonGroupButtonContext = /*#__PURE__*/ $25b1293270900846$var$React.createContext(undefined);
$25b1293270900846$var$ButtonGroupButtonContext.displayName = 'ButtonGroupButtonContext';
var $25b1293270900846$var$_default = module.exports.default = $25b1293270900846$var$ButtonGroupButtonContext;

});



parcelRegister("9bswS", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $6afb4578ee9180cf$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $6afb4578ee9180cf$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $6afb4578ee9180cf$var$_exportNames = {
    inputAdornmentClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $6afb4578ee9180cf$var$_InputAdornment.default;
    }
});
Object.defineProperty(module.exports, "inputAdornmentClasses", {
    enumerable: true,
    get: function() {
        return $6afb4578ee9180cf$var$_inputAdornmentClasses.default;
    }
});

var $6afb4578ee9180cf$var$_InputAdornment = $6afb4578ee9180cf$require$_interopRequireDefault((parcelRequire("hViLc")));

var $6afb4578ee9180cf$var$_inputAdornmentClasses = $6afb4578ee9180cf$require$_interopRequireWildcard((parcelRequire("kWfSh")));
Object.keys($6afb4578ee9180cf$var$_inputAdornmentClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($6afb4578ee9180cf$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $6afb4578ee9180cf$var$_inputAdornmentClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6afb4578ee9180cf$var$_inputAdornmentClasses[key];
        }
    });
});

});
parcelRegister("hViLc", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $d0c64ff513a9933f$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $d0c64ff513a9933f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d0c64ff513a9933f$var$React = $d0c64ff513a9933f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $d0c64ff513a9933f$var$_propTypes = $d0c64ff513a9933f$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $d0c64ff513a9933f$var$_clsx = $d0c64ff513a9933f$require$_interopRequireDefault((parcelRequire("9QePP")));

var $d0c64ff513a9933f$var$_composeClasses = $d0c64ff513a9933f$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $d0c64ff513a9933f$var$_capitalize = $d0c64ff513a9933f$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $d0c64ff513a9933f$var$_Typography = $d0c64ff513a9933f$require$_interopRequireDefault((parcelRequire("2dUd7")));

var $d0c64ff513a9933f$var$_FormControlContext = $d0c64ff513a9933f$require$_interopRequireDefault((parcelRequire("blr6C")));

var $d0c64ff513a9933f$var$_useFormControl = $d0c64ff513a9933f$require$_interopRequireDefault((parcelRequire("cJQfW")));

var $aAbgT = parcelRequire("aAbgT");

var $d0c64ff513a9933f$var$_memoTheme = $d0c64ff513a9933f$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $d0c64ff513a9933f$var$_inputAdornmentClasses = $d0c64ff513a9933f$require$_interopRequireWildcard((parcelRequire("kWfSh")));

var $ayMG0 = parcelRequire("ayMG0");
var $d0c64ff513a9933f$var$_span;
const $d0c64ff513a9933f$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $d0c64ff513a9933f$var$_capitalize.default)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $d0c64ff513a9933f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            disablePointerEvents && 'disablePointerEvents',
            position && `position${(0, $d0c64ff513a9933f$var$_capitalize.default)(position)}`,
            variant,
            hiddenLabel && 'hiddenLabel',
            size && `size${(0, $d0c64ff513a9933f$var$_capitalize.default)(size)}`
        ]
    };
    return (0, $d0c64ff513a9933f$var$_composeClasses.default)(slots, $d0c64ff513a9933f$var$_inputAdornmentClasses.getInputAdornmentUtilityClass, classes);
};
const $d0c64ff513a9933f$var$InputAdornmentRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiInputAdornment',
    slot: 'Root',
    overridesResolver: $d0c64ff513a9933f$var$overridesResolver
})((0, $d0c64ff513a9933f$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'flex',
        maxHeight: '2em',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        color: (theme.vars || theme).palette.action.active,
        variants: [
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    [`&.${$d0c64ff513a9933f$var$_inputAdornmentClasses.default.positionStart}&:not(.${$d0c64ff513a9933f$var$_inputAdornmentClasses.default.hiddenLabel})`]: {
                        marginTop: 16
                    }
                }
            },
            {
                props: {
                    position: 'start'
                },
                style: {
                    marginRight: 8
                }
            },
            {
                props: {
                    position: 'end'
                },
                style: {
                    marginLeft: 8
                }
            },
            {
                props: {
                    disablePointerEvents: true
                },
                style: {
                    pointerEvents: 'none'
                }
            }
        ]
    })));
const $d0c64ff513a9933f$var$InputAdornment = /*#__PURE__*/ $d0c64ff513a9933f$var$React.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiInputAdornment'
    });
    const { children: children, className: className, component: component = 'div', disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp, ...other } = props;
    const muiFormControl = (0, $d0c64ff513a9933f$var$_useFormControl.default)() || {};
    let variant = variantProp;
    if (variantProp && muiFormControl.variant) {
        if (variantProp === muiFormControl.variant) console.error("MUI: The `InputAdornment` variant infers the variant prop you do not have to provide one.");
    }
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = {
        ...props,
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    };
    const classes = $d0c64ff513a9933f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($d0c64ff513a9933f$var$_FormControlContext.default.Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($d0c64ff513a9933f$var$InputAdornmentRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $d0c64ff513a9933f$var$_clsx.default)(classes.root, className),
            ref: ref,
            ...other,
            children: typeof children === 'string' && !disableTypography ? /*#__PURE__*/ (0, $ayMG0.jsx)($d0c64ff513a9933f$var$_Typography.default, {
                color: "textSecondary",
                children: children
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($d0c64ff513a9933f$var$React.Fragment, {
                children: [
                    position === 'start' ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $d0c64ff513a9933f$var$_span || ($d0c64ff513a9933f$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "notranslate",
                        "aria-hidden": true,
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        })
    });
});
$d0c64ff513a9933f$var$InputAdornment.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component, normally an `IconButton` or string.
   */ children: $d0c64ff513a9933f$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $d0c64ff513a9933f$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $d0c64ff513a9933f$var$_propTypes.default.string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $d0c64ff513a9933f$var$_propTypes.default.elementType,
    /**
   * Disable pointer events on the root.
   * This allows for the content of the adornment to focus the `input` on click.
   * @default false
   */ disablePointerEvents: $d0c64ff513a9933f$var$_propTypes.default.bool,
    /**
   * If children is a string then disable wrapping in a Typography component.
   * @default false
   */ disableTypography: $d0c64ff513a9933f$var$_propTypes.default.bool,
    /**
   * The position this adornment should appear relative to the `Input`.
   */ position: $d0c64ff513a9933f$var$_propTypes.default.oneOf([
        'end',
        'start'
    ]).isRequired,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $d0c64ff513a9933f$var$_propTypes.default.oneOfType([
        $d0c64ff513a9933f$var$_propTypes.default.arrayOf($d0c64ff513a9933f$var$_propTypes.default.oneOfType([
            $d0c64ff513a9933f$var$_propTypes.default.func,
            $d0c64ff513a9933f$var$_propTypes.default.object,
            $d0c64ff513a9933f$var$_propTypes.default.bool
        ])),
        $d0c64ff513a9933f$var$_propTypes.default.func,
        $d0c64ff513a9933f$var$_propTypes.default.object
    ]),
    /**
   * The variant to use.
   * Note: If you are using the `TextField` component or the `FormControl` component
   * you do not have to set this manually.
   */ variant: $d0c64ff513a9933f$var$_propTypes.default.oneOf([
        'filled',
        'outlined',
        'standard'
    ])
};
var $d0c64ff513a9933f$var$_default = module.exports.default = $d0c64ff513a9933f$var$InputAdornment;

});
parcelRegister("kWfSh", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f3e589c60baacdec$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getInputAdornmentUtilityClass = $f3e589c60baacdec$var$getInputAdornmentUtilityClass;

var $f3e589c60baacdec$var$_generateUtilityClasses = $f3e589c60baacdec$require$_interopRequireDefault((parcelRequire("5nY49")));

var $f3e589c60baacdec$var$_generateUtilityClass = $f3e589c60baacdec$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $f3e589c60baacdec$var$getInputAdornmentUtilityClass(slot) {
    return (0, $f3e589c60baacdec$var$_generateUtilityClass.default)('MuiInputAdornment', slot);
}
const $f3e589c60baacdec$var$inputAdornmentClasses = (0, $f3e589c60baacdec$var$_generateUtilityClasses.default)('MuiInputAdornment', [
    'root',
    'filled',
    'standard',
    'outlined',
    'positionStart',
    'positionEnd',
    'disablePointerEvents',
    'hiddenLabel',
    'sizeSmall'
]);
var $f3e589c60baacdec$var$_default = module.exports.default = $f3e589c60baacdec$var$inputAdornmentClasses;

});



parcelRegister("tEWAm", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $05927828b8d9f8ec$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $05927828b8d9f8ec$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $05927828b8d9f8ec$var$_exportNames = {
    tooltipClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $05927828b8d9f8ec$var$_Tooltip.default;
    }
});
Object.defineProperty(module.exports, "tooltipClasses", {
    enumerable: true,
    get: function() {
        return $05927828b8d9f8ec$var$_tooltipClasses.default;
    }
});

var $05927828b8d9f8ec$var$_Tooltip = $05927828b8d9f8ec$require$_interopRequireDefault((parcelRequire("cVXaD")));

var $05927828b8d9f8ec$var$_tooltipClasses = $05927828b8d9f8ec$require$_interopRequireWildcard((parcelRequire("eVjpW")));
Object.keys($05927828b8d9f8ec$var$_tooltipClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($05927828b8d9f8ec$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $05927828b8d9f8ec$var$_tooltipClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $05927828b8d9f8ec$var$_tooltipClasses[key];
        }
    });
});

});
parcelRegister("cVXaD", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $96a8b4f445fd9172$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $96a8b4f445fd9172$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.testReset = $96a8b4f445fd9172$var$testReset;

var $96a8b4f445fd9172$var$React = $96a8b4f445fd9172$require$_interopRequireWildcard((parcelRequire("acw62")));

var $96a8b4f445fd9172$var$_propTypes = $96a8b4f445fd9172$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $96a8b4f445fd9172$var$_clsx = $96a8b4f445fd9172$require$_interopRequireDefault((parcelRequire("9QePP")));

var $96a8b4f445fd9172$var$_useTimeout = $96a8b4f445fd9172$require$_interopRequireWildcard((parcelRequire("drY8V")));

var $96a8b4f445fd9172$var$_elementAcceptingRef = $96a8b4f445fd9172$require$_interopRequireDefault((parcelRequire("igTUE")));

var $96a8b4f445fd9172$var$_composeClasses = $96a8b4f445fd9172$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $9uEev = parcelRequire("9uEev");

var $96a8b4f445fd9172$var$_isFocusVisible = $96a8b4f445fd9172$require$_interopRequireDefault((parcelRequire("cS73m")));

var $96a8b4f445fd9172$var$_getReactElementRef = $96a8b4f445fd9172$require$_interopRequireDefault((parcelRequire("2B4J6")));

var $aAbgT = parcelRequire("aAbgT");

var $96a8b4f445fd9172$var$_memoTheme = $96a8b4f445fd9172$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $96a8b4f445fd9172$var$_capitalize = $96a8b4f445fd9172$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $96a8b4f445fd9172$var$_Grow = $96a8b4f445fd9172$require$_interopRequireDefault((parcelRequire("6dJ4n")));

var $96a8b4f445fd9172$var$_Popper = $96a8b4f445fd9172$require$_interopRequireDefault((parcelRequire("eWJe7")));

var $96a8b4f445fd9172$var$_useEventCallback = $96a8b4f445fd9172$require$_interopRequireDefault((parcelRequire("4o7uD")));

var $96a8b4f445fd9172$var$_useForkRef = $96a8b4f445fd9172$require$_interopRequireDefault((parcelRequire("9Rgf1")));

var $96a8b4f445fd9172$var$_useId = $96a8b4f445fd9172$require$_interopRequireDefault((parcelRequire("5A6d3")));

var $96a8b4f445fd9172$var$_useControlled = $96a8b4f445fd9172$require$_interopRequireDefault((parcelRequire("3yddg")));

var $96a8b4f445fd9172$var$_useSlot = $96a8b4f445fd9172$require$_interopRequireDefault((parcelRequire("6lpak")));

var $96a8b4f445fd9172$var$_tooltipClasses = $96a8b4f445fd9172$require$_interopRequireWildcard((parcelRequire("eVjpW")));

var $ayMG0 = parcelRequire("ayMG0");
function $96a8b4f445fd9172$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $96a8b4f445fd9172$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            'popper',
            !disableInteractive && 'popperInteractive',
            arrow && 'popperArrow'
        ],
        tooltip: [
            'tooltip',
            arrow && 'tooltipArrow',
            touch && 'touch',
            `tooltipPlacement${(0, $96a8b4f445fd9172$var$_capitalize.default)(placement.split('-')[0])}`
        ],
        arrow: [
            'arrow'
        ]
    };
    return (0, $96a8b4f445fd9172$var$_composeClasses.default)(slots, $96a8b4f445fd9172$var$_tooltipClasses.getTooltipUtilityClass, classes);
};
const $96a8b4f445fd9172$var$TooltipPopper = (0, $aAbgT.styled)($96a8b4f445fd9172$var$_Popper.default, {
    name: 'MuiTooltip',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})((0, $96a8b4f445fd9172$var$_memoTheme.default)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: 'none',
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableInteractive,
                style: {
                    pointerEvents: 'auto'
                }
            },
            {
                props: ({ open: open })=>!open,
                style: {
                    pointerEvents: 'none'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow,
                style: {
                    [`&[data-popper-placement*="bottom"] .${$96a8b4f445fd9172$var$_tooltipClasses.default.arrow}`]: {
                        top: 0,
                        marginTop: '-0.71em',
                        '&::before': {
                            transformOrigin: '0 100%'
                        }
                    },
                    [`&[data-popper-placement*="top"] .${$96a8b4f445fd9172$var$_tooltipClasses.default.arrow}`]: {
                        bottom: 0,
                        marginBottom: '-0.71em',
                        '&::before': {
                            transformOrigin: '100% 0'
                        }
                    },
                    [`&[data-popper-placement*="right"] .${$96a8b4f445fd9172$var$_tooltipClasses.default.arrow}`]: {
                        height: '1em',
                        width: '0.71em',
                        '&::before': {
                            transformOrigin: '100% 100%'
                        }
                    },
                    [`&[data-popper-placement*="left"] .${$96a8b4f445fd9172$var$_tooltipClasses.default.arrow}`]: {
                        height: '1em',
                        width: '0.71em',
                        '&::before': {
                            transformOrigin: '0 0'
                        }
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="right"] .${$96a8b4f445fd9172$var$_tooltipClasses.default.arrow}`]: {
                        left: 0,
                        marginLeft: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !!ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="right"] .${$96a8b4f445fd9172$var$_tooltipClasses.default.arrow}`]: {
                        right: 0,
                        marginRight: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="left"] .${$96a8b4f445fd9172$var$_tooltipClasses.default.arrow}`]: {
                        right: 0,
                        marginRight: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !!ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="left"] .${$96a8b4f445fd9172$var$_tooltipClasses.default.arrow}`]: {
                        left: 0,
                        marginLeft: '-0.71em'
                    }
                }
            }
        ]
    })));
const $96a8b4f445fd9172$var$TooltipTooltip = (0, $aAbgT.styled)('div', {
    name: 'MuiTooltip',
    slot: 'Tooltip',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $96a8b4f445fd9172$var$_capitalize.default)(ownerState.placement.split('-')[0])}`]
        ];
    }
})((0, $96a8b4f445fd9172$var$_memoTheme.default)(({ theme: theme })=>({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : theme.alpha(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: '4px 8px',
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: 'break-word',
        fontWeight: theme.typography.fontWeightMedium,
        [`.${$96a8b4f445fd9172$var$_tooltipClasses.default.popper}[data-popper-placement*="left"] &`]: {
            transformOrigin: 'right center'
        },
        [`.${$96a8b4f445fd9172$var$_tooltipClasses.default.popper}[data-popper-placement*="right"] &`]: {
            transformOrigin: 'left center'
        },
        [`.${$96a8b4f445fd9172$var$_tooltipClasses.default.popper}[data-popper-placement*="top"] &`]: {
            transformOrigin: 'center bottom',
            marginBottom: '14px'
        },
        [`.${$96a8b4f445fd9172$var$_tooltipClasses.default.popper}[data-popper-placement*="bottom"] &`]: {
            transformOrigin: 'center top',
            marginTop: '14px'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow,
                style: {
                    position: 'relative',
                    margin: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    padding: '8px 16px',
                    fontSize: theme.typography.pxToRem(14),
                    lineHeight: `${$96a8b4f445fd9172$var$round(16 / 14)}em`,
                    fontWeight: theme.typography.fontWeightRegular
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.isRtl,
                style: {
                    [`.${$96a8b4f445fd9172$var$_tooltipClasses.default.popper}[data-popper-placement*="left"] &`]: {
                        marginRight: '14px'
                    },
                    [`.${$96a8b4f445fd9172$var$_tooltipClasses.default.popper}[data-popper-placement*="right"] &`]: {
                        marginLeft: '14px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.isRtl && ownerState.touch,
                style: {
                    [`.${$96a8b4f445fd9172$var$_tooltipClasses.default.popper}[data-popper-placement*="left"] &`]: {
                        marginRight: '24px'
                    },
                    [`.${$96a8b4f445fd9172$var$_tooltipClasses.default.popper}[data-popper-placement*="right"] &`]: {
                        marginLeft: '24px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.isRtl,
                style: {
                    [`.${$96a8b4f445fd9172$var$_tooltipClasses.default.popper}[data-popper-placement*="left"] &`]: {
                        marginLeft: '14px'
                    },
                    [`.${$96a8b4f445fd9172$var$_tooltipClasses.default.popper}[data-popper-placement*="right"] &`]: {
                        marginRight: '14px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.isRtl && ownerState.touch,
                style: {
                    [`.${$96a8b4f445fd9172$var$_tooltipClasses.default.popper}[data-popper-placement*="left"] &`]: {
                        marginLeft: '24px'
                    },
                    [`.${$96a8b4f445fd9172$var$_tooltipClasses.default.popper}[data-popper-placement*="right"] &`]: {
                        marginRight: '24px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    [`.${$96a8b4f445fd9172$var$_tooltipClasses.default.popper}[data-popper-placement*="top"] &`]: {
                        marginBottom: '24px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    [`.${$96a8b4f445fd9172$var$_tooltipClasses.default.popper}[data-popper-placement*="bottom"] &`]: {
                        marginTop: '24px'
                    }
                }
            }
        ]
    })));
const $96a8b4f445fd9172$var$TooltipArrow = (0, $aAbgT.styled)('span', {
    name: 'MuiTooltip',
    slot: 'Arrow'
})((0, $96a8b4f445fd9172$var$_memoTheme.default)(({ theme: theme })=>({
        overflow: 'hidden',
        position: 'absolute',
        width: '1em',
        height: '0.71em' /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: 'border-box',
        color: theme.vars ? theme.vars.palette.Tooltip.bg : theme.alpha(theme.palette.grey[700], 0.9),
        '&::before': {
            content: '""',
            margin: 'auto',
            display: 'block',
            width: '100%',
            height: '100%',
            backgroundColor: 'currentColor',
            transform: 'rotate(45deg)'
        }
    })));
let $96a8b4f445fd9172$var$hystersisOpen = false;
const $96a8b4f445fd9172$var$hystersisTimer = new $96a8b4f445fd9172$var$_useTimeout.Timeout();
let $96a8b4f445fd9172$var$cursorPosition = {
    x: 0,
    y: 0
};
function $96a8b4f445fd9172$var$testReset() {
    $96a8b4f445fd9172$var$hystersisOpen = false;
    $96a8b4f445fd9172$var$hystersisTimer.clear();
}
function $96a8b4f445fd9172$var$composeEventHandler(handler, eventHandler) {
    return (event, ...params)=>{
        if (eventHandler) eventHandler(event, ...params);
        handler(event, ...params);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $96a8b4f445fd9172$var$Tooltip = /*#__PURE__*/ $96a8b4f445fd9172$var$React.forwardRef(function Tooltip(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiTooltip'
    });
    const { arrow: arrow = false, children: childrenProp, classes: classesProp, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = 'bottom', PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp, TransitionProps: TransitionProps, ...other } = props;
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ $96a8b4f445fd9172$var$React.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, $aAbgT.useTheme)();
    const isRtl = (0, $9uEev.useRtl)();
    const [childNode, setChildNode] = $96a8b4f445fd9172$var$React.useState();
    const [arrowRef, setArrowRef] = $96a8b4f445fd9172$var$React.useState(null);
    const ignoreNonTouchEvents = $96a8b4f445fd9172$var$React.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = (0, $96a8b4f445fd9172$var$_useTimeout.default)();
    const enterTimer = (0, $96a8b4f445fd9172$var$_useTimeout.default)();
    const leaveTimer = (0, $96a8b4f445fd9172$var$_useTimeout.default)();
    const touchTimer = (0, $96a8b4f445fd9172$var$_useTimeout.default)();
    const [openState, setOpenState] = (0, $96a8b4f445fd9172$var$_useControlled.default)({
        controlled: openProp,
        default: false,
        name: 'Tooltip',
        state: 'open'
    });
    let open = openState;
    {
        // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks -- process.env never changes
        const { current: isControlled } = $96a8b4f445fd9172$var$React.useRef(openProp !== undefined);
        // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks -- process.env never changes
        $96a8b4f445fd9172$var$React.useEffect(()=>{
            if (childNode && childNode.disabled && !isControlled && title !== '' && childNode.tagName.toLowerCase() === 'button') console.warn([
                'MUI: You are providing a disabled `button` child to the Tooltip component.',
                'A disabled element does not fire events.',
                "Tooltip needs to listen to the child element's events to display the title.",
                '',
                'Add a simple wrapper element, such as a `span`.'
            ].join('\n'));
        }, [
            title,
            childNode,
            isControlled
        ]);
    }
    const id = (0, $96a8b4f445fd9172$var$_useId.default)(idProp);
    const prevUserSelect = $96a8b4f445fd9172$var$React.useRef();
    const stopTouchInteraction = (0, $96a8b4f445fd9172$var$_useEventCallback.default)(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        touchTimer.clear();
    });
    $96a8b4f445fd9172$var$React.useEffect(()=>stopTouchInteraction, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        $96a8b4f445fd9172$var$hystersisTimer.clear();
        $96a8b4f445fd9172$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $96a8b4f445fd9172$var$_useEventCallback.default)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        $96a8b4f445fd9172$var$hystersisTimer.start(800 + leaveDelay, ()=>{
            $96a8b4f445fd9172$var$hystersisOpen = false;
        });
        setOpenState(false);
        if (onClose && open) onClose(event);
        closeTimer.start(theme.transitions.duration.shortest, ()=>{
            ignoreNonTouchEvents.current = false;
        });
    });
    const handleMouseOver = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== 'touchstart') return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute('title');
        enterTimer.clear();
        leaveTimer.clear();
        if (enterDelay || $96a8b4f445fd9172$var$hystersisOpen && enterNextDelay) enterTimer.start($96a8b4f445fd9172$var$hystersisOpen ? enterNextDelay : enterDelay, ()=>{
            handleOpen(event);
        });
        else handleOpen(event);
    };
    const handleMouseLeave = (event)=>{
        enterTimer.clear();
        leaveTimer.start(leaveDelay, ()=>{
            handleClose(event);
        });
    };
    const [, setChildIsFocusVisible] = $96a8b4f445fd9172$var$React.useState(false);
    const handleBlur = (event)=>{
        // Needed for https://github.com/mui/material-ui/issues/45373
        const target = event?.target ?? childNode;
        if (!target || !(0, $96a8b4f445fd9172$var$_isFocusVisible.default)(target)) {
            setChildIsFocusVisible(false);
            // InputBase can call onBlur() without an event when the input becomes disabled.
            // Tooltip must not assume an event object exists.
            const closeEvent = event ?? new Event('blur');
            // `new Event('blur')` has `target/currentTarget === null`, but Tooltip's close logic
            // (and user callbacks like onClose) may expect them to reference the anchor element.
            if (!event && target) {
                Object.defineProperty(closeEvent, 'target', {
                    value: target
                });
                Object.defineProperty(closeEvent, 'currentTarget', {
                    value: target
                });
            }
            handleMouseLeave(closeEvent);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        if ((0, $96a8b4f445fd9172$var$_isFocusVisible.default)(event.target)) {
            setChildIsFocusVisible(true);
            handleMouseOver(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        leaveTimer.clear();
        closeTimer.clear();
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = 'none';
        touchTimer.start(enterTouchDelay, ()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleMouseOver(event);
        });
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        leaveTimer.start(leaveTouchDelay, ()=>{
            handleClose(event);
        });
    };
    $96a8b4f445fd9172$var$React.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (nativeEvent.key === 'Escape') handleClose(nativeEvent);
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $96a8b4f445fd9172$var$_useForkRef.default)((0, $96a8b4f445fd9172$var$_getReactElementRef.default)(children), setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    // So we exclude all falsy values, except 0, which is valid.
    if (!title && title !== 0) open = false;
    const popperRef = $96a8b4f445fd9172$var$React.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $96a8b4f445fd9172$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === 'string';
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps['aria-describedby'] = open ? id : null;
    } else {
        nameOrDescProps['aria-label'] = titleIsString ? title : null;
        nameOrDescProps['aria-labelledby'] = open && !titleIsString ? id : null;
    }
    const childrenProps = {
        ...nameOrDescProps,
        ...other,
        ...children.props,
        className: (0, $96a8b4f445fd9172$var$_clsx.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef,
        ...followCursor ? {
            onMouseMove: handleMouseMove
        } : {}
    };
    childrenProps['data-mui-internal-clone-element'] = true;
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks -- process.env never changes
    $96a8b4f445fd9172$var$React.useEffect(()=>{
        if (childNode && !childNode.getAttribute('data-mui-internal-clone-element')) console.error([
            'MUI: The `children` component of the Tooltip is not forwarding its props correctly.',
            'Please make sure that props are spread on the same element that the ref is applied to.'
        ].join('\n'));
    }, [
        childNode
    ]);
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $96a8b4f445fd9172$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $96a8b4f445fd9172$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $96a8b4f445fd9172$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $96a8b4f445fd9172$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    if (children.props.title) console.error([
        'MUI: You have provided a `title` prop to the child of <Tooltip />.',
        `Remove this title prop \`${children.props.title}\` or the Tooltip component.`
    ].join('\n'));
    const ownerState = {
        ...props,
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    };
    const resolvedPopperProps = typeof slotProps.popper === 'function' ? slotProps.popper(ownerState) : slotProps.popper;
    const popperOptions = $96a8b4f445fd9172$var$React.useMemo(()=>{
        let tooltipModifiers = [
            {
                name: 'arrow',
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if (PopperProps.popperOptions?.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        if (resolvedPopperProps?.popperOptions?.modifiers) tooltipModifiers = tooltipModifiers.concat(resolvedPopperProps.popperOptions.modifiers);
        return {
            ...PopperProps.popperOptions,
            ...resolvedPopperProps?.popperOptions,
            modifiers: tooltipModifiers
        };
    }, [
        arrowRef,
        PopperProps.popperOptions,
        resolvedPopperProps?.popperOptions
    ]);
    const classes = $96a8b4f445fd9172$var$useUtilityClasses(ownerState);
    const resolvedTransitionProps = typeof slotProps.transition === 'function' ? slotProps.transition(ownerState) : slotProps.transition;
    const externalForwardedProps = {
        slots: {
            popper: components.Popper,
            transition: components.Transition ?? TransitionComponentProp,
            tooltip: components.Tooltip,
            arrow: components.Arrow,
            ...slots
        },
        slotProps: {
            arrow: slotProps.arrow ?? componentsProps.arrow,
            popper: {
                ...PopperProps,
                ...resolvedPopperProps ?? componentsProps.popper
            },
            // resolvedPopperProps can be spread because it's already an object
            tooltip: slotProps.tooltip ?? componentsProps.tooltip,
            transition: {
                ...TransitionProps,
                ...resolvedTransitionProps ?? componentsProps.transition
            }
        }
    };
    const [PopperSlot, popperSlotProps] = (0, $96a8b4f445fd9172$var$_useSlot.default)('popper', {
        elementType: $96a8b4f445fd9172$var$TooltipPopper,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $96a8b4f445fd9172$var$_clsx.default)(classes.popper, PopperProps?.className)
    });
    const [TransitionSlot, transitionSlotProps] = (0, $96a8b4f445fd9172$var$_useSlot.default)('transition', {
        elementType: $96a8b4f445fd9172$var$_Grow.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [TooltipSlot, tooltipSlotProps] = (0, $96a8b4f445fd9172$var$_useSlot.default)('tooltip', {
        elementType: $96a8b4f445fd9172$var$TooltipTooltip,
        className: classes.tooltip,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ArrowSlot, arrowSlotProps] = (0, $96a8b4f445fd9172$var$_useSlot.default)('arrow', {
        elementType: $96a8b4f445fd9172$var$TooltipArrow,
        className: classes.arrow,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        ref: setArrowRef
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($96a8b4f445fd9172$var$React.Fragment, {
        children: [
            /*#__PURE__*/ $96a8b4f445fd9172$var$React.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $ayMG0.jsx)(PopperSlot, {
                as: PopperComponentProp ?? $96a8b4f445fd9172$var$_Popper.default,
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $96a8b4f445fd9172$var$cursorPosition.y,
                            left: $96a8b4f445fd9172$var$cursorPosition.x,
                            right: $96a8b4f445fd9172$var$cursorPosition.x,
                            bottom: $96a8b4f445fd9172$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true,
                ...interactiveWrapperListeners,
                ...popperSlotProps,
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $ayMG0.jsx)(TransitionSlot, {
                        timeout: theme.transitions.duration.shorter,
                        ...TransitionPropsInner,
                        ...transitionSlotProps,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(TooltipSlot, {
                            ...tooltipSlotProps,
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $ayMG0.jsx)(ArrowSlot, {
                                    ...arrowSlotProps
                                }) : null
                            ]
                        })
                    })
            })
        ]
    });
});
$96a8b4f445fd9172$var$Tooltip.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * If `true`, adds an arrow to the tooltip.
   * @default false
   */ arrow: $96a8b4f445fd9172$var$_propTypes.default.bool,
    /**
   * Tooltip reference element.
   */ children: $96a8b4f445fd9172$var$_elementAcceptingRef.default.isRequired,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $96a8b4f445fd9172$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $96a8b4f445fd9172$var$_propTypes.default.string,
    /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */ components: $96a8b4f445fd9172$var$_propTypes.default.shape({
        Arrow: $96a8b4f445fd9172$var$_propTypes.default.elementType,
        Popper: $96a8b4f445fd9172$var$_propTypes.default.elementType,
        Tooltip: $96a8b4f445fd9172$var$_propTypes.default.elementType,
        Transition: $96a8b4f445fd9172$var$_propTypes.default.elementType
    }),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */ componentsProps: $96a8b4f445fd9172$var$_propTypes.default.shape({
        arrow: $96a8b4f445fd9172$var$_propTypes.default.object,
        popper: $96a8b4f445fd9172$var$_propTypes.default.object,
        tooltip: $96a8b4f445fd9172$var$_propTypes.default.object,
        transition: $96a8b4f445fd9172$var$_propTypes.default.object
    }),
    /**
   * Set to `true` if the `title` acts as an accessible description.
   * By default the `title` acts as an accessible label for the child.
   * @default false
   */ describeChild: $96a8b4f445fd9172$var$_propTypes.default.bool,
    /**
   * Do not respond to focus-visible events.
   * @default false
   */ disableFocusListener: $96a8b4f445fd9172$var$_propTypes.default.bool,
    /**
   * Do not respond to hover events.
   * @default false
   */ disableHoverListener: $96a8b4f445fd9172$var$_propTypes.default.bool,
    /**
   * Makes a tooltip not interactive, i.e. it will close when the user
   * hovers over the tooltip before the `leaveDelay` is expired.
   * @default false
   */ disableInteractive: $96a8b4f445fd9172$var$_propTypes.default.bool,
    /**
   * Do not respond to long press touch events.
   * @default false
   */ disableTouchListener: $96a8b4f445fd9172$var$_propTypes.default.bool,
    /**
   * The number of milliseconds to wait before showing the tooltip.
   * This prop won't impact the enter touch delay (`enterTouchDelay`).
   * @default 100
   */ enterDelay: $96a8b4f445fd9172$var$_propTypes.default.number,
    /**
   * The number of milliseconds to wait before showing the tooltip when one was already recently opened.
   * @default 0
   */ enterNextDelay: $96a8b4f445fd9172$var$_propTypes.default.number,
    /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   * @default 700
   */ enterTouchDelay: $96a8b4f445fd9172$var$_propTypes.default.number,
    /**
   * If `true`, the tooltip follow the cursor over the wrapped element.
   * @default false
   */ followCursor: $96a8b4f445fd9172$var$_propTypes.default.bool,
    /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */ id: $96a8b4f445fd9172$var$_propTypes.default.string,
    /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
   * @default 0
   */ leaveDelay: $96a8b4f445fd9172$var$_propTypes.default.number,
    /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   * @default 1500
   */ leaveTouchDelay: $96a8b4f445fd9172$var$_propTypes.default.number,
    /**
   * Callback fired when the component requests to be closed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */ onClose: $96a8b4f445fd9172$var$_propTypes.default.func,
    /**
   * Callback fired when the component requests to be open.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */ onOpen: $96a8b4f445fd9172$var$_propTypes.default.func,
    /**
   * If `true`, the component is shown.
   */ open: $96a8b4f445fd9172$var$_propTypes.default.bool,
    /**
   * Tooltip placement.
   * @default 'bottom'
   */ placement: $96a8b4f445fd9172$var$_propTypes.default.oneOf([
        'auto-end',
        'auto-start',
        'auto',
        'bottom-end',
        'bottom-start',
        'bottom',
        'left-end',
        'left-start',
        'left',
        'right-end',
        'right-start',
        'right',
        'top-end',
        'top-start',
        'top'
    ]),
    /**
   * The component used for the popper.
   * @deprecated use the `slots.popper` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ PopperComponent: $96a8b4f445fd9172$var$_propTypes.default.elementType,
    /**
   * Props applied to the [`Popper`](https://mui.com/material-ui/api/popper/) element.
   * @deprecated use the `slotProps.popper` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */ PopperProps: $96a8b4f445fd9172$var$_propTypes.default.object,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $96a8b4f445fd9172$var$_propTypes.default.shape({
        arrow: $96a8b4f445fd9172$var$_propTypes.default.oneOfType([
            $96a8b4f445fd9172$var$_propTypes.default.func,
            $96a8b4f445fd9172$var$_propTypes.default.object
        ]),
        popper: $96a8b4f445fd9172$var$_propTypes.default.oneOfType([
            $96a8b4f445fd9172$var$_propTypes.default.func,
            $96a8b4f445fd9172$var$_propTypes.default.object
        ]),
        tooltip: $96a8b4f445fd9172$var$_propTypes.default.oneOfType([
            $96a8b4f445fd9172$var$_propTypes.default.func,
            $96a8b4f445fd9172$var$_propTypes.default.object
        ]),
        transition: $96a8b4f445fd9172$var$_propTypes.default.oneOfType([
            $96a8b4f445fd9172$var$_propTypes.default.func,
            $96a8b4f445fd9172$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: $96a8b4f445fd9172$var$_propTypes.default.shape({
        arrow: $96a8b4f445fd9172$var$_propTypes.default.elementType,
        popper: $96a8b4f445fd9172$var$_propTypes.default.elementType,
        tooltip: $96a8b4f445fd9172$var$_propTypes.default.elementType,
        transition: $96a8b4f445fd9172$var$_propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $96a8b4f445fd9172$var$_propTypes.default.oneOfType([
        $96a8b4f445fd9172$var$_propTypes.default.arrayOf($96a8b4f445fd9172$var$_propTypes.default.oneOfType([
            $96a8b4f445fd9172$var$_propTypes.default.func,
            $96a8b4f445fd9172$var$_propTypes.default.object,
            $96a8b4f445fd9172$var$_propTypes.default.bool
        ])),
        $96a8b4f445fd9172$var$_propTypes.default.func,
        $96a8b4f445fd9172$var$_propTypes.default.object
    ]),
    /**
   * Tooltip title. Zero-length titles string, undefined, null and false are never displayed.
   */ title: $96a8b4f445fd9172$var$_propTypes.default.node,
    /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated use the `slots.transition` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ TransitionComponent: $96a8b4f445fd9172$var$_propTypes.default.elementType,
    /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */ TransitionProps: $96a8b4f445fd9172$var$_propTypes.default.object
};
var $96a8b4f445fd9172$var$_default = module.exports.default = $96a8b4f445fd9172$var$Tooltip;

});
parcelRegister("eVjpW", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $add5737403c6a16a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getTooltipUtilityClass = $add5737403c6a16a$var$getTooltipUtilityClass;

var $add5737403c6a16a$var$_generateUtilityClasses = $add5737403c6a16a$require$_interopRequireDefault((parcelRequire("5nY49")));

var $add5737403c6a16a$var$_generateUtilityClass = $add5737403c6a16a$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $add5737403c6a16a$var$getTooltipUtilityClass(slot) {
    return (0, $add5737403c6a16a$var$_generateUtilityClass.default)('MuiTooltip', slot);
}
const $add5737403c6a16a$var$tooltipClasses = (0, $add5737403c6a16a$var$_generateUtilityClasses.default)('MuiTooltip', [
    'popper',
    'popperInteractive',
    'popperArrow',
    'popperClose',
    'tooltip',
    'tooltipArrow',
    'touch',
    'tooltipPlacementLeft',
    'tooltipPlacementRight',
    'tooltipPlacementTop',
    'tooltipPlacementBottom',
    'arrow'
]);
var $add5737403c6a16a$var$_default = module.exports.default = $add5737403c6a16a$var$tooltipClasses;

});



parcelRegister("b3HhA", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $80d18c8911cf744f$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $80d18c8911cf744f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $80d18c8911cf744f$var$_exportNames = {
    tablePaginationClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $80d18c8911cf744f$var$_TablePagination.default;
    }
});
Object.defineProperty(module.exports, "tablePaginationClasses", {
    enumerable: true,
    get: function() {
        return $80d18c8911cf744f$var$_tablePaginationClasses.default;
    }
});

var $80d18c8911cf744f$var$_TablePagination = $80d18c8911cf744f$require$_interopRequireDefault((parcelRequire("kBtCg")));

var $80d18c8911cf744f$var$_tablePaginationClasses = $80d18c8911cf744f$require$_interopRequireWildcard((parcelRequire("inBkn")));
Object.keys($80d18c8911cf744f$var$_tablePaginationClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($80d18c8911cf744f$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $80d18c8911cf744f$var$_tablePaginationClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $80d18c8911cf744f$var$_tablePaginationClasses[key];
        }
    });
});

});
parcelRegister("kBtCg", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $effe3c7e7b91170d$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $effe3c7e7b91170d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $effe3c7e7b91170d$var$_react = $effe3c7e7b91170d$require$_interopRequireWildcard((parcelRequire("acw62")));
var $effe3c7e7b91170d$var$React = $effe3c7e7b91170d$var$_react;

var $effe3c7e7b91170d$var$_propTypes = $effe3c7e7b91170d$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $effe3c7e7b91170d$var$_clsx = $effe3c7e7b91170d$require$_interopRequireDefault((parcelRequire("9QePP")));

var $effe3c7e7b91170d$var$_integerPropType = $effe3c7e7b91170d$require$_interopRequireDefault((parcelRequire("cxaSP")));

var $effe3c7e7b91170d$var$_chainPropTypes = $effe3c7e7b91170d$require$_interopRequireDefault((parcelRequire("abVWF")));

var $effe3c7e7b91170d$var$_composeClasses = $effe3c7e7b91170d$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $effe3c7e7b91170d$var$_memoTheme = $effe3c7e7b91170d$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $effe3c7e7b91170d$var$_InputBase2 = $effe3c7e7b91170d$require$_interopRequireDefault((parcelRequire("9MvHs")));

var $effe3c7e7b91170d$var$_MenuItem = $effe3c7e7b91170d$require$_interopRequireDefault((parcelRequire("iZ4W7")));

var $effe3c7e7b91170d$var$_Select = $effe3c7e7b91170d$require$_interopRequireDefault((parcelRequire("dALxx")));

var $effe3c7e7b91170d$var$_TableCell = $effe3c7e7b91170d$require$_interopRequireDefault((parcelRequire("hjoMW")));

var $effe3c7e7b91170d$var$_Toolbar = $effe3c7e7b91170d$require$_interopRequireDefault((parcelRequire("dfjP7")));

var $effe3c7e7b91170d$var$_TablePaginationActions = $effe3c7e7b91170d$require$_interopRequireDefault((parcelRequire("lqVz5")));

var $effe3c7e7b91170d$var$_useId = $effe3c7e7b91170d$require$_interopRequireDefault((parcelRequire("5A6d3")));

var $effe3c7e7b91170d$var$_tablePaginationClasses = $effe3c7e7b91170d$require$_interopRequireWildcard((parcelRequire("inBkn")));

var $effe3c7e7b91170d$var$_useSlot = $effe3c7e7b91170d$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
var $effe3c7e7b91170d$var$_InputBase;
const $effe3c7e7b91170d$var$TablePaginationRoot = (0, $aAbgT.styled)($effe3c7e7b91170d$var$_TableCell.default, {
    name: 'MuiTablePagination',
    slot: 'Root'
})((0, $effe3c7e7b91170d$var$_memoTheme.default)(({ theme: theme })=>({
        overflow: 'auto',
        color: (theme.vars || theme).palette.text.primary,
        fontSize: theme.typography.pxToRem(14),
        // Increase the specificity to override TableCell.
        '&:last-child': {
            padding: 0
        }
    })));
const $effe3c7e7b91170d$var$TablePaginationToolbar = (0, $aAbgT.styled)($effe3c7e7b91170d$var$_Toolbar.default, {
    name: 'MuiTablePagination',
    slot: 'Toolbar',
    overridesResolver: (props, styles)=>({
            [`& .${$effe3c7e7b91170d$var$_tablePaginationClasses.default.actions}`]: styles.actions,
            ...styles.toolbar
        })
})((0, $effe3c7e7b91170d$var$_memoTheme.default)(({ theme: theme })=>({
        minHeight: 52,
        paddingRight: 2,
        [`${theme.breakpoints.up('xs')} and (orientation: landscape)`]: {
            minHeight: 52
        },
        [theme.breakpoints.up('sm')]: {
            minHeight: 52,
            paddingRight: 2
        },
        [`& .${$effe3c7e7b91170d$var$_tablePaginationClasses.default.actions}`]: {
            flexShrink: 0,
            marginLeft: 20
        }
    })));
const $effe3c7e7b91170d$var$TablePaginationSpacer = (0, $aAbgT.styled)('div', {
    name: 'MuiTablePagination',
    slot: 'Spacer'
})({
    flex: '1 1 100%'
});
const $effe3c7e7b91170d$var$TablePaginationSelectLabel = (0, $aAbgT.styled)('p', {
    name: 'MuiTablePagination',
    slot: 'SelectLabel'
})((0, $effe3c7e7b91170d$var$_memoTheme.default)(({ theme: theme })=>({
        ...theme.typography.body2,
        flexShrink: 0
    })));
const $effe3c7e7b91170d$var$TablePaginationSelect = (0, $aAbgT.styled)($effe3c7e7b91170d$var$_Select.default, {
    name: 'MuiTablePagination',
    slot: 'Select',
    overridesResolver: (props, styles)=>({
            [`& .${$effe3c7e7b91170d$var$_tablePaginationClasses.default.selectIcon}`]: styles.selectIcon,
            [`& .${$effe3c7e7b91170d$var$_tablePaginationClasses.default.select}`]: styles.select,
            ...styles.input,
            ...styles.selectRoot
        })
})({
    color: 'inherit',
    fontSize: 'inherit',
    flexShrink: 0,
    marginRight: 32,
    marginLeft: 8,
    [`& .${$effe3c7e7b91170d$var$_tablePaginationClasses.default.select}`]: {
        paddingLeft: 8,
        paddingRight: 24,
        textAlign: 'right',
        textAlignLast: 'right' // Align <select> on Chrome.
    }
});
const $effe3c7e7b91170d$var$TablePaginationMenuItem = (0, $aAbgT.styled)($effe3c7e7b91170d$var$_MenuItem.default, {
    name: 'MuiTablePagination',
    slot: 'MenuItem'
})({});
const $effe3c7e7b91170d$var$TablePaginationDisplayedRows = (0, $aAbgT.styled)('p', {
    name: 'MuiTablePagination',
    slot: 'DisplayedRows'
})((0, $effe3c7e7b91170d$var$_memoTheme.default)(({ theme: theme })=>({
        ...theme.typography.body2,
        flexShrink: 0
    })));
function $effe3c7e7b91170d$var$defaultLabelDisplayedRows({ from: from, to: to, count: count }) {
    return `${from}\u{2013}${to} of ${count !== -1 ? count : `more than ${to}`}`;
}
function $effe3c7e7b91170d$var$defaultGetAriaLabel(type) {
    return `Go to ${type} page`;
}
const $effe3c7e7b91170d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        toolbar: [
            'toolbar'
        ],
        spacer: [
            'spacer'
        ],
        selectLabel: [
            'selectLabel'
        ],
        select: [
            'select'
        ],
        input: [
            'input'
        ],
        selectIcon: [
            'selectIcon'
        ],
        menuItem: [
            'menuItem'
        ],
        displayedRows: [
            'displayedRows'
        ],
        actions: [
            'actions'
        ]
    };
    return (0, $effe3c7e7b91170d$var$_composeClasses.default)(slots, $effe3c7e7b91170d$var$_tablePaginationClasses.getTablePaginationUtilityClass, classes);
};
/**
 * A `TableCell` based component for placing inside `TableFooter` for pagination.
 */ const $effe3c7e7b91170d$var$TablePagination = /*#__PURE__*/ $effe3c7e7b91170d$var$React.forwardRef(function TablePagination(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiTablePagination'
    });
    const { ActionsComponent: ActionsComponent = $effe3c7e7b91170d$var$_TablePaginationActions.default, backIconButtonProps: backIconButtonProps, colSpan: colSpanProp, component: component = $effe3c7e7b91170d$var$_TableCell.default, count: count, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel = $effe3c7e7b91170d$var$defaultGetAriaLabel, labelDisplayedRows: labelDisplayedRows = $effe3c7e7b91170d$var$defaultLabelDisplayedRows, labelRowsPerPage: labelRowsPerPage = 'Rows per page:', nextIconButtonProps: nextIconButtonProps, onPageChange: onPageChange, onRowsPerPageChange: onRowsPerPageChange, page: page, rowsPerPage: rowsPerPage, rowsPerPageOptions: rowsPerPageOptions = [
        10,
        25,
        50,
        100
    ], SelectProps: SelectProps = {}, showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, slotProps: slotProps = {}, slots: slots = {}, ...other } = props;
    const ownerState = props;
    const classes = $effe3c7e7b91170d$var$useUtilityClasses(ownerState);
    const selectProps = slotProps?.select ?? SelectProps;
    const MenuItemComponent = selectProps.native ? 'option' : $effe3c7e7b91170d$var$TablePaginationMenuItem;
    let colSpan;
    if (component === $effe3c7e7b91170d$var$_TableCell.default || component === 'td') colSpan = colSpanProp || 1000; // col-span over everything
    const selectId = (0, $effe3c7e7b91170d$var$_useId.default)(selectProps.id);
    const labelId = (0, $effe3c7e7b91170d$var$_useId.default)(selectProps.labelId);
    const getLabelDisplayedRowsTo = ()=>{
        if (count === -1) return (page + 1) * rowsPerPage;
        return rowsPerPage === -1 ? count : Math.min(count, (page + 1) * rowsPerPage);
    };
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootSlotProps] = (0, $effe3c7e7b91170d$var$_useSlot.default)('root', {
        ref: ref,
        className: classes.root,
        elementType: $effe3c7e7b91170d$var$TablePaginationRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            component: component,
            ...other
        },
        ownerState: ownerState,
        additionalProps: {
            colSpan: colSpan
        }
    });
    const [ToolbarSlot, toolbarSlotProps] = (0, $effe3c7e7b91170d$var$_useSlot.default)('toolbar', {
        className: classes.toolbar,
        elementType: $effe3c7e7b91170d$var$TablePaginationToolbar,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SpacerSlot, spacerSlotProps] = (0, $effe3c7e7b91170d$var$_useSlot.default)('spacer', {
        className: classes.spacer,
        elementType: $effe3c7e7b91170d$var$TablePaginationSpacer,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SelectLabelSlot, selectLabelSlotProps] = (0, $effe3c7e7b91170d$var$_useSlot.default)('selectLabel', {
        className: classes.selectLabel,
        elementType: $effe3c7e7b91170d$var$TablePaginationSelectLabel,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            id: labelId
        }
    });
    const [SelectSlot, selectSlotProps] = (0, $effe3c7e7b91170d$var$_useSlot.default)('select', {
        className: classes.select,
        elementType: $effe3c7e7b91170d$var$TablePaginationSelect,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [MenuItemSlot, menuItemSlotProps] = (0, $effe3c7e7b91170d$var$_useSlot.default)('menuItem', {
        className: classes.menuItem,
        elementType: MenuItemComponent,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [DisplayedRows, displayedRowsProps] = (0, $effe3c7e7b91170d$var$_useSlot.default)('displayedRows', {
        className: classes.displayedRows,
        elementType: $effe3c7e7b91170d$var$TablePaginationDisplayedRows,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, {
        ...rootSlotProps,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(ToolbarSlot, {
            ...toolbarSlotProps,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)(SpacerSlot, {
                    ...spacerSlotProps
                }),
                rowsPerPageOptions.length > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)(SelectLabelSlot, {
                    ...selectLabelSlotProps,
                    children: labelRowsPerPage
                }),
                rowsPerPageOptions.length > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)(SelectSlot, {
                    variant: "standard",
                    ...!selectProps.variant && {
                        input: $effe3c7e7b91170d$var$_InputBase || ($effe3c7e7b91170d$var$_InputBase = /*#__PURE__*/ (0, $ayMG0.jsx)($effe3c7e7b91170d$var$_InputBase2.default, {}))
                    },
                    value: rowsPerPage,
                    onChange: onRowsPerPageChange,
                    id: selectId,
                    labelId: labelId,
                    ...selectProps,
                    classes: {
                        ...selectProps.classes,
                        // TODO v5 remove `classes.input`
                        root: (0, $effe3c7e7b91170d$var$_clsx.default)(classes.input, classes.selectRoot, (selectProps.classes || {}).root),
                        select: (0, $effe3c7e7b91170d$var$_clsx.default)(classes.select, (selectProps.classes || {}).select),
                        // TODO v5 remove `selectIcon`
                        icon: (0, $effe3c7e7b91170d$var$_clsx.default)(classes.selectIcon, (selectProps.classes || {}).icon)
                    },
                    disabled: disabled,
                    ...selectSlotProps,
                    children: rowsPerPageOptions.map((rowsPerPageOption)=>/*#__PURE__*/ (0, $effe3c7e7b91170d$var$_react.createElement)(MenuItemSlot, {
                            ...menuItemSlotProps,
                            key: rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption,
                            value: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption
                        }, rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption))
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)(DisplayedRows, {
                    ...displayedRowsProps,
                    children: labelDisplayedRows({
                        from: count === 0 ? 0 : page * rowsPerPage + 1,
                        to: getLabelDisplayedRowsTo(),
                        count: count === -1 ? -1 : count,
                        page: page
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)(ActionsComponent, {
                    className: classes.actions,
                    backIconButtonProps: backIconButtonProps,
                    count: count,
                    nextIconButtonProps: nextIconButtonProps,
                    onPageChange: onPageChange,
                    page: page,
                    rowsPerPage: rowsPerPage,
                    showFirstButton: showFirstButton,
                    showLastButton: showLastButton,
                    slotProps: slotProps.actions,
                    slots: slots.actions,
                    getItemAriaLabel: getItemAriaLabel,
                    disabled: disabled
                })
            ]
        })
    });
});
$effe3c7e7b91170d$var$TablePagination.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The component used for displaying the actions.
   * Either a string to use a HTML element or a component.
   * @default TablePaginationActions
   */ ActionsComponent: $effe3c7e7b91170d$var$_propTypes.default.elementType,
    /**
   * Props applied to the back arrow [`IconButton`](https://mui.com/material-ui/api/icon-button/) component.
   *
   * This prop is an alias for `slotProps.actions.previousButton` and will be overridden by it if both are used.
   * @deprecated Use `slotProps.actions.previousButton` instead.
   */ backIconButtonProps: $effe3c7e7b91170d$var$_propTypes.default.object,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $effe3c7e7b91170d$var$_propTypes.default.object,
    /**
   * @ignore
   */ colSpan: $effe3c7e7b91170d$var$_propTypes.default.number,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $effe3c7e7b91170d$var$_propTypes.default.elementType,
    /**
   * The total number of rows.
   *
   * To enable server side pagination for an unknown number of items, provide -1.
   */ count: $effe3c7e7b91170d$var$_integerPropType.default.isRequired,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: $effe3c7e7b91170d$var$_propTypes.default.bool,
    /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   * This is important for screen reader users.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @param {string} type The link or button type to format ('first' | 'last' | 'next' | 'previous').
   * @returns {string}
   * @default function defaultGetAriaLabel(type) {
   *   return `Go to ${type} page`;
   * }
   */ getItemAriaLabel: $effe3c7e7b91170d$var$_propTypes.default.func,
    /**
   * Customize the displayed rows label. Invoked with a `{ from, to, count, page }`
   * object.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default function defaultLabelDisplayedRows({ from, to, count }) {
   *   return `${from}–${to} of ${count !== -1 ? count : `more than ${to}`}`;
   * }
   */ labelDisplayedRows: $effe3c7e7b91170d$var$_propTypes.default.func,
    /**
   * Customize the rows per page label.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Rows per page:'
   */ labelRowsPerPage: $effe3c7e7b91170d$var$_propTypes.default.node,
    /**
   * Props applied to the next arrow [`IconButton`](https://mui.com/material-ui/api/icon-button/) element.
   *
   * This prop is an alias for `slotProps.actions.nextButton` and will be overridden by it if both are used.
   * @deprecated Use `slotProps.actions.nextButton` instead.
   */ nextIconButtonProps: $effe3c7e7b91170d$var$_propTypes.default.object,
    /**
   * Callback fired when the page is changed.
   *
   * @param {React.MouseEvent<HTMLButtonElement> | null} event The event source of the callback.
   * @param {number} page The page selected.
   */ onPageChange: $effe3c7e7b91170d$var$_propTypes.default.func.isRequired,
    /**
   * Callback fired when the number of rows per page is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   */ onRowsPerPageChange: $effe3c7e7b91170d$var$_propTypes.default.func,
    /**
   * The zero-based index of the current page.
   */ page: (0, $effe3c7e7b91170d$var$_chainPropTypes.default)($effe3c7e7b91170d$var$_integerPropType.default.isRequired, (props)=>{
        const { count: count, page: page, rowsPerPage: rowsPerPage } = props;
        if (count === -1) return null;
        const newLastPage = Math.max(0, Math.ceil(count / rowsPerPage) - 1);
        if (page < 0 || page > newLastPage) return new Error('MUI: The page prop of a TablePagination is out of range ' + `(0 to ${newLastPage}, but page is ${page}).`);
        return null;
    }),
    /**
   * The number of rows per page.
   *
   * Set -1 to display all the rows.
   */ rowsPerPage: $effe3c7e7b91170d$var$_integerPropType.default.isRequired,
    /**
   * Customizes the options of the rows per page select field. If less than two options are
   * available, no select field will be displayed.
   * Use -1 for the value with a custom label to show all the rows.
   * @default [10, 25, 50, 100]
   */ rowsPerPageOptions: $effe3c7e7b91170d$var$_propTypes.default.arrayOf($effe3c7e7b91170d$var$_propTypes.default.oneOfType([
        $effe3c7e7b91170d$var$_propTypes.default.number,
        $effe3c7e7b91170d$var$_propTypes.default.shape({
            label: $effe3c7e7b91170d$var$_propTypes.default.string.isRequired,
            value: $effe3c7e7b91170d$var$_propTypes.default.number.isRequired
        })
    ]).isRequired),
    /**
   * Props applied to the rows per page [`Select`](https://mui.com/material-ui/api/select/) element.
   *
   * This prop is an alias for `slotProps.select` and will be overridden by it if both are used.
   * @deprecated Use `slotProps.select` instead.
   *
   * @default {}
   */ SelectProps: $effe3c7e7b91170d$var$_propTypes.default.object,
    /**
   * If `true`, show the first-page button.
   * @default false
   */ showFirstButton: $effe3c7e7b91170d$var$_propTypes.default.bool,
    /**
   * If `true`, show the last-page button.
   * @default false
   */ showLastButton: $effe3c7e7b91170d$var$_propTypes.default.bool,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $effe3c7e7b91170d$var$_propTypes.default.shape({
        actions: $effe3c7e7b91170d$var$_propTypes.default.shape({
            firstButton: $effe3c7e7b91170d$var$_propTypes.default.object,
            firstButtonIcon: $effe3c7e7b91170d$var$_propTypes.default.object,
            lastButton: $effe3c7e7b91170d$var$_propTypes.default.object,
            lastButtonIcon: $effe3c7e7b91170d$var$_propTypes.default.object,
            nextButton: $effe3c7e7b91170d$var$_propTypes.default.object,
            nextButtonIcon: $effe3c7e7b91170d$var$_propTypes.default.object,
            previousButton: $effe3c7e7b91170d$var$_propTypes.default.object,
            previousButtonIcon: $effe3c7e7b91170d$var$_propTypes.default.object
        }),
        displayedRows: $effe3c7e7b91170d$var$_propTypes.default.oneOfType([
            $effe3c7e7b91170d$var$_propTypes.default.func,
            $effe3c7e7b91170d$var$_propTypes.default.object
        ]),
        menuItem: $effe3c7e7b91170d$var$_propTypes.default.oneOfType([
            $effe3c7e7b91170d$var$_propTypes.default.func,
            $effe3c7e7b91170d$var$_propTypes.default.object
        ]),
        root: $effe3c7e7b91170d$var$_propTypes.default.oneOfType([
            $effe3c7e7b91170d$var$_propTypes.default.func,
            $effe3c7e7b91170d$var$_propTypes.default.object
        ]),
        select: $effe3c7e7b91170d$var$_propTypes.default.object,
        selectLabel: $effe3c7e7b91170d$var$_propTypes.default.oneOfType([
            $effe3c7e7b91170d$var$_propTypes.default.func,
            $effe3c7e7b91170d$var$_propTypes.default.object
        ]),
        spacer: $effe3c7e7b91170d$var$_propTypes.default.oneOfType([
            $effe3c7e7b91170d$var$_propTypes.default.func,
            $effe3c7e7b91170d$var$_propTypes.default.object
        ]),
        toolbar: $effe3c7e7b91170d$var$_propTypes.default.oneOfType([
            $effe3c7e7b91170d$var$_propTypes.default.func,
            $effe3c7e7b91170d$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: $effe3c7e7b91170d$var$_propTypes.default.shape({
        actions: $effe3c7e7b91170d$var$_propTypes.default.shape({
            firstButton: $effe3c7e7b91170d$var$_propTypes.default.elementType,
            firstButtonIcon: $effe3c7e7b91170d$var$_propTypes.default.elementType,
            lastButton: $effe3c7e7b91170d$var$_propTypes.default.elementType,
            lastButtonIcon: $effe3c7e7b91170d$var$_propTypes.default.elementType,
            nextButton: $effe3c7e7b91170d$var$_propTypes.default.elementType,
            nextButtonIcon: $effe3c7e7b91170d$var$_propTypes.default.elementType,
            previousButton: $effe3c7e7b91170d$var$_propTypes.default.elementType,
            previousButtonIcon: $effe3c7e7b91170d$var$_propTypes.default.elementType
        }),
        displayedRows: $effe3c7e7b91170d$var$_propTypes.default.elementType,
        menuItem: $effe3c7e7b91170d$var$_propTypes.default.elementType,
        root: $effe3c7e7b91170d$var$_propTypes.default.elementType,
        select: $effe3c7e7b91170d$var$_propTypes.default.elementType,
        selectLabel: $effe3c7e7b91170d$var$_propTypes.default.elementType,
        spacer: $effe3c7e7b91170d$var$_propTypes.default.elementType,
        toolbar: $effe3c7e7b91170d$var$_propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $effe3c7e7b91170d$var$_propTypes.default.oneOfType([
        $effe3c7e7b91170d$var$_propTypes.default.arrayOf($effe3c7e7b91170d$var$_propTypes.default.oneOfType([
            $effe3c7e7b91170d$var$_propTypes.default.func,
            $effe3c7e7b91170d$var$_propTypes.default.object,
            $effe3c7e7b91170d$var$_propTypes.default.bool
        ])),
        $effe3c7e7b91170d$var$_propTypes.default.func,
        $effe3c7e7b91170d$var$_propTypes.default.object
    ])
};
var $effe3c7e7b91170d$var$_default = module.exports.default = $effe3c7e7b91170d$var$TablePagination;

});
parcelRegister("hjoMW", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $c9a7707bc8e823db$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $c9a7707bc8e823db$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $c9a7707bc8e823db$var$_exportNames = {
    tableCellClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $c9a7707bc8e823db$var$_TableCell.default;
    }
});
Object.defineProperty(module.exports, "tableCellClasses", {
    enumerable: true,
    get: function() {
        return $c9a7707bc8e823db$var$_tableCellClasses.default;
    }
});

var $c9a7707bc8e823db$var$_TableCell = $c9a7707bc8e823db$require$_interopRequireDefault((parcelRequire("elyLx")));

var $c9a7707bc8e823db$var$_tableCellClasses = $c9a7707bc8e823db$require$_interopRequireWildcard((parcelRequire("ev9nI")));
Object.keys($c9a7707bc8e823db$var$_tableCellClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($c9a7707bc8e823db$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $c9a7707bc8e823db$var$_tableCellClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $c9a7707bc8e823db$var$_tableCellClasses[key];
        }
    });
});

});
parcelRegister("elyLx", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $a71dfe9e22152ea2$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $a71dfe9e22152ea2$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a71dfe9e22152ea2$var$React = $a71dfe9e22152ea2$require$_interopRequireWildcard((parcelRequire("acw62")));

var $a71dfe9e22152ea2$var$_propTypes = $a71dfe9e22152ea2$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $a71dfe9e22152ea2$var$_clsx = $a71dfe9e22152ea2$require$_interopRequireDefault((parcelRequire("9QePP")));

var $a71dfe9e22152ea2$var$_composeClasses = $a71dfe9e22152ea2$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $a71dfe9e22152ea2$var$_capitalize = $a71dfe9e22152ea2$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $a71dfe9e22152ea2$var$_TableContext = $a71dfe9e22152ea2$require$_interopRequireDefault((parcelRequire("jWrFr")));

var $a71dfe9e22152ea2$var$_Tablelvl2Context = $a71dfe9e22152ea2$require$_interopRequireDefault((parcelRequire("RbMj7")));

var $aAbgT = parcelRequire("aAbgT");

var $a71dfe9e22152ea2$var$_memoTheme = $a71dfe9e22152ea2$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $a71dfe9e22152ea2$var$_tableCellClasses = $a71dfe9e22152ea2$require$_interopRequireWildcard((parcelRequire("ev9nI")));

var $ayMG0 = parcelRequire("ayMG0");
const $a71dfe9e22152ea2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, align: align, padding: padding, size: size, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            stickyHeader && 'stickyHeader',
            align !== 'inherit' && `align${(0, $a71dfe9e22152ea2$var$_capitalize.default)(align)}`,
            padding !== 'normal' && `padding${(0, $a71dfe9e22152ea2$var$_capitalize.default)(padding)}`,
            `size${(0, $a71dfe9e22152ea2$var$_capitalize.default)(size)}`
        ]
    };
    return (0, $a71dfe9e22152ea2$var$_composeClasses.default)(slots, $a71dfe9e22152ea2$var$_tableCellClasses.getTableCellUtilityClass, classes);
};
const $a71dfe9e22152ea2$var$TableCellRoot = (0, $aAbgT.styled)('td', {
    name: 'MuiTableCell',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $a71dfe9e22152ea2$var$_capitalize.default)(ownerState.size)}`],
            ownerState.padding !== 'normal' && styles[`padding${(0, $a71dfe9e22152ea2$var$_capitalize.default)(ownerState.padding)}`],
            ownerState.align !== 'inherit' && styles[`align${(0, $a71dfe9e22152ea2$var$_capitalize.default)(ownerState.align)}`],
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})((0, $a71dfe9e22152ea2$var$_memoTheme.default)(({ theme: theme })=>({
        ...theme.typography.body2,
        display: 'table-cell',
        verticalAlign: 'inherit',
        // Workaround for a rendering bug with spanned columns in Chrome 62.0.
        // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
        borderBottom: theme.vars ? `1px solid ${theme.vars.palette.TableCell.border}` : `1px solid
    ${theme.palette.mode === 'light' ? theme.lighten(theme.alpha(theme.palette.divider, 1), 0.88) : theme.darken(theme.alpha(theme.palette.divider, 1), 0.68)}`,
        textAlign: 'left',
        padding: 16,
        variants: [
            {
                props: {
                    variant: 'head'
                },
                style: {
                    color: (theme.vars || theme).palette.text.primary,
                    lineHeight: theme.typography.pxToRem(24),
                    fontWeight: theme.typography.fontWeightMedium
                }
            },
            {
                props: {
                    variant: 'body'
                },
                style: {
                    color: (theme.vars || theme).palette.text.primary
                }
            },
            {
                props: {
                    variant: 'footer'
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary,
                    lineHeight: theme.typography.pxToRem(21),
                    fontSize: theme.typography.pxToRem(12)
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: '6px 16px',
                    [`&.${$a71dfe9e22152ea2$var$_tableCellClasses.default.paddingCheckbox}`]: {
                        width: 24,
                        // prevent the checkbox column from growing
                        padding: '0 12px 0 16px',
                        '& > *': {
                            padding: 0
                        }
                    }
                }
            },
            {
                props: {
                    padding: 'checkbox'
                },
                style: {
                    width: 48,
                    // prevent the checkbox column from growing
                    padding: '0 0 0 4px'
                }
            },
            {
                props: {
                    padding: 'none'
                },
                style: {
                    padding: 0
                }
            },
            {
                props: {
                    align: 'left'
                },
                style: {
                    textAlign: 'left'
                }
            },
            {
                props: {
                    align: 'center'
                },
                style: {
                    textAlign: 'center'
                }
            },
            {
                props: {
                    align: 'right'
                },
                style: {
                    textAlign: 'right',
                    flexDirection: 'row-reverse'
                }
            },
            {
                props: {
                    align: 'justify'
                },
                style: {
                    textAlign: 'justify'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.stickyHeader,
                style: {
                    position: 'sticky',
                    top: 0,
                    zIndex: 2,
                    backgroundColor: (theme.vars || theme).palette.background.default
                }
            }
        ]
    })));
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ const $a71dfe9e22152ea2$var$TableCell = /*#__PURE__*/ $a71dfe9e22152ea2$var$React.forwardRef(function TableCell(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiTableCell'
    });
    const { align: align = 'inherit', className: className, component: componentProp, padding: paddingProp, scope: scopeProp, size: sizeProp, sortDirection: sortDirection, variant: variantProp, ...other } = props;
    const table = $a71dfe9e22152ea2$var$React.useContext($a71dfe9e22152ea2$var$_TableContext.default);
    const tablelvl2 = $a71dfe9e22152ea2$var$React.useContext($a71dfe9e22152ea2$var$_Tablelvl2Context.default);
    const isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
    let component;
    if (componentProp) component = componentProp;
    else component = isHeadCell ? 'th' : 'td';
    let scope = scopeProp;
    // scope is not a valid attribute for <td/> elements.
    // source: https://html.spec.whatwg.org/multipage/tables.html#the-td-element
    if (component === 'td') scope = undefined;
    else if (!scope && isHeadCell) scope = 'col';
    const variant = variantProp || tablelvl2 && tablelvl2.variant;
    const ownerState = {
        ...props,
        align: align,
        component: component,
        padding: paddingProp || (table && table.padding ? table.padding : 'normal'),
        size: sizeProp || (table && table.size ? table.size : 'medium'),
        sortDirection: sortDirection,
        stickyHeader: variant === 'head' && table && table.stickyHeader,
        variant: variant
    };
    const classes = $a71dfe9e22152ea2$var$useUtilityClasses(ownerState);
    let ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a71dfe9e22152ea2$var$TableCellRoot, {
        as: component,
        ref: ref,
        className: (0, $a71dfe9e22152ea2$var$_clsx.default)(classes.root, className),
        "aria-sort": ariaSort,
        scope: scope,
        ownerState: ownerState,
        ...other
    });
});
$a71dfe9e22152ea2$var$TableCell.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Set the text-align on the table cell content.
   *
   * Monetary or generally number fields **should be right aligned** as that allows
   * you to add them up quickly in your head without having to worry about decimals.
   * @default 'inherit'
   */ align: $a71dfe9e22152ea2$var$_propTypes.default.oneOf([
        'center',
        'inherit',
        'justify',
        'left',
        'right'
    ]),
    /**
   * The content of the component.
   */ children: $a71dfe9e22152ea2$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $a71dfe9e22152ea2$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $a71dfe9e22152ea2$var$_propTypes.default.string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $a71dfe9e22152ea2$var$_propTypes.default.elementType,
    /**
   * Sets the padding applied to the cell.
   * The prop defaults to the value (`'default'`) inherited from the parent Table component.
   */ padding: $a71dfe9e22152ea2$var$_propTypes.default.oneOf([
        'checkbox',
        'none',
        'normal'
    ]),
    /**
   * Set scope attribute.
   */ scope: $a71dfe9e22152ea2$var$_propTypes.default.string,
    /**
   * Specify the size of the cell.
   * The prop defaults to the value (`'medium'`) inherited from the parent Table component.
   */ size: $a71dfe9e22152ea2$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $a71dfe9e22152ea2$var$_propTypes.default.oneOf([
            'medium',
            'small'
        ]),
        $a71dfe9e22152ea2$var$_propTypes.default.string
    ]),
    /**
   * Set aria-sort direction.
   */ sortDirection: $a71dfe9e22152ea2$var$_propTypes.default.oneOf([
        'asc',
        'desc',
        false
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $a71dfe9e22152ea2$var$_propTypes.default.oneOfType([
        $a71dfe9e22152ea2$var$_propTypes.default.arrayOf($a71dfe9e22152ea2$var$_propTypes.default.oneOfType([
            $a71dfe9e22152ea2$var$_propTypes.default.func,
            $a71dfe9e22152ea2$var$_propTypes.default.object,
            $a71dfe9e22152ea2$var$_propTypes.default.bool
        ])),
        $a71dfe9e22152ea2$var$_propTypes.default.func,
        $a71dfe9e22152ea2$var$_propTypes.default.object
    ]),
    /**
   * Specify the cell type.
   * The prop defaults to the value inherited from the parent TableHead, TableBody, or TableFooter components.
   */ variant: $a71dfe9e22152ea2$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $a71dfe9e22152ea2$var$_propTypes.default.oneOf([
            'body',
            'footer',
            'head'
        ]),
        $a71dfe9e22152ea2$var$_propTypes.default.string
    ])
};
var $a71dfe9e22152ea2$var$_default = module.exports.default = $a71dfe9e22152ea2$var$TableCell;

});
parcelRegister("jWrFr", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $e848e543ed3bf349$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e848e543ed3bf349$var$React = $e848e543ed3bf349$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * @ignore - internal component.
 */ const $e848e543ed3bf349$var$TableContext = /*#__PURE__*/ $e848e543ed3bf349$var$React.createContext();
$e848e543ed3bf349$var$TableContext.displayName = 'TableContext';
var $e848e543ed3bf349$var$_default = module.exports.default = $e848e543ed3bf349$var$TableContext;

});

parcelRegister("RbMj7", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $09fe163f52c859c8$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $09fe163f52c859c8$var$React = $09fe163f52c859c8$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * @ignore - internal component.
 */ const $09fe163f52c859c8$var$Tablelvl2Context = /*#__PURE__*/ $09fe163f52c859c8$var$React.createContext();
$09fe163f52c859c8$var$Tablelvl2Context.displayName = 'Tablelvl2Context';
var $09fe163f52c859c8$var$_default = module.exports.default = $09fe163f52c859c8$var$Tablelvl2Context;

});

parcelRegister("ev9nI", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a8eb3ce62ab46dc7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getTableCellUtilityClass = $a8eb3ce62ab46dc7$var$getTableCellUtilityClass;

var $a8eb3ce62ab46dc7$var$_generateUtilityClasses = $a8eb3ce62ab46dc7$require$_interopRequireDefault((parcelRequire("5nY49")));

var $a8eb3ce62ab46dc7$var$_generateUtilityClass = $a8eb3ce62ab46dc7$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $a8eb3ce62ab46dc7$var$getTableCellUtilityClass(slot) {
    return (0, $a8eb3ce62ab46dc7$var$_generateUtilityClass.default)('MuiTableCell', slot);
}
const $a8eb3ce62ab46dc7$var$tableCellClasses = (0, $a8eb3ce62ab46dc7$var$_generateUtilityClasses.default)('MuiTableCell', [
    'root',
    'head',
    'body',
    'footer',
    'sizeSmall',
    'sizeMedium',
    'paddingCheckbox',
    'paddingNone',
    'alignLeft',
    'alignCenter',
    'alignRight',
    'alignJustify',
    'stickyHeader'
]);
var $a8eb3ce62ab46dc7$var$_default = module.exports.default = $a8eb3ce62ab46dc7$var$tableCellClasses;

});



parcelRegister("dfjP7", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $9a4c0d9ab6473dab$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $9a4c0d9ab6473dab$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $9a4c0d9ab6473dab$var$_exportNames = {
    toolbarClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9a4c0d9ab6473dab$var$_Toolbar.default;
    }
});
Object.defineProperty(module.exports, "toolbarClasses", {
    enumerable: true,
    get: function() {
        return $9a4c0d9ab6473dab$var$_toolbarClasses.default;
    }
});

var $9a4c0d9ab6473dab$var$_Toolbar = $9a4c0d9ab6473dab$require$_interopRequireDefault((parcelRequire("kyRsi")));

var $9a4c0d9ab6473dab$var$_toolbarClasses = $9a4c0d9ab6473dab$require$_interopRequireWildcard((parcelRequire("iaUmy")));
Object.keys($9a4c0d9ab6473dab$var$_toolbarClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($9a4c0d9ab6473dab$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $9a4c0d9ab6473dab$var$_toolbarClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9a4c0d9ab6473dab$var$_toolbarClasses[key];
        }
    });
});

});
parcelRegister("kyRsi", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $ef8072c26f712b4c$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $ef8072c26f712b4c$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ef8072c26f712b4c$var$React = $ef8072c26f712b4c$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ef8072c26f712b4c$var$_propTypes = $ef8072c26f712b4c$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $ef8072c26f712b4c$var$_clsx = $ef8072c26f712b4c$require$_interopRequireDefault((parcelRequire("9QePP")));

var $ef8072c26f712b4c$var$_composeClasses = $ef8072c26f712b4c$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $ef8072c26f712b4c$var$_memoTheme = $ef8072c26f712b4c$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $iaUmy = parcelRequire("iaUmy");

var $ayMG0 = parcelRequire("ayMG0");
const $ef8072c26f712b4c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableGutters: disableGutters, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            !disableGutters && 'gutters',
            variant
        ]
    };
    return (0, $ef8072c26f712b4c$var$_composeClasses.default)(slots, $iaUmy.getToolbarUtilityClass, classes);
};
const $ef8072c26f712b4c$var$ToolbarRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiToolbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableGutters && styles.gutters,
            styles[ownerState.variant]
        ];
    }
})((0, $ef8072c26f712b4c$var$_memoTheme.default)(({ theme: theme })=>({
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: theme.spacing(2),
                    paddingRight: theme.spacing(2),
                    [theme.breakpoints.up('sm')]: {
                        paddingLeft: theme.spacing(3),
                        paddingRight: theme.spacing(3)
                    }
                }
            },
            {
                props: {
                    variant: 'dense'
                },
                style: {
                    minHeight: 48
                }
            },
            {
                props: {
                    variant: 'regular'
                },
                style: theme.mixins.toolbar
            }
        ]
    })));
const $ef8072c26f712b4c$var$Toolbar = /*#__PURE__*/ $ef8072c26f712b4c$var$React.forwardRef(function Toolbar(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiToolbar'
    });
    const { className: className, component: component = 'div', disableGutters: disableGutters = false, variant: variant = 'regular', ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        disableGutters: disableGutters,
        variant: variant
    };
    const classes = $ef8072c26f712b4c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ef8072c26f712b4c$var$ToolbarRoot, {
        as: component,
        className: (0, $ef8072c26f712b4c$var$_clsx.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
$ef8072c26f712b4c$var$Toolbar.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
   * The Toolbar is a flex container, allowing flex item properties to be used to lay out the children.
   */ children: $ef8072c26f712b4c$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $ef8072c26f712b4c$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $ef8072c26f712b4c$var$_propTypes.default.string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $ef8072c26f712b4c$var$_propTypes.default.elementType,
    /**
   * If `true`, disables gutter padding.
   * @default false
   */ disableGutters: $ef8072c26f712b4c$var$_propTypes.default.bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $ef8072c26f712b4c$var$_propTypes.default.oneOfType([
        $ef8072c26f712b4c$var$_propTypes.default.arrayOf($ef8072c26f712b4c$var$_propTypes.default.oneOfType([
            $ef8072c26f712b4c$var$_propTypes.default.func,
            $ef8072c26f712b4c$var$_propTypes.default.object,
            $ef8072c26f712b4c$var$_propTypes.default.bool
        ])),
        $ef8072c26f712b4c$var$_propTypes.default.func,
        $ef8072c26f712b4c$var$_propTypes.default.object
    ]),
    /**
   * The variant to use.
   * @default 'regular'
   */ variant: $ef8072c26f712b4c$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $ef8072c26f712b4c$var$_propTypes.default.oneOf([
            'dense',
            'regular'
        ]),
        $ef8072c26f712b4c$var$_propTypes.default.string
    ])
};
var $ef8072c26f712b4c$var$_default = module.exports.default = $ef8072c26f712b4c$var$Toolbar;

});
parcelRegister("iaUmy", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d3b4e1a115786e57$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getToolbarUtilityClass = $d3b4e1a115786e57$var$getToolbarUtilityClass;

var $d3b4e1a115786e57$var$_generateUtilityClasses = $d3b4e1a115786e57$require$_interopRequireDefault((parcelRequire("5nY49")));

var $d3b4e1a115786e57$var$_generateUtilityClass = $d3b4e1a115786e57$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $d3b4e1a115786e57$var$getToolbarUtilityClass(slot) {
    return (0, $d3b4e1a115786e57$var$_generateUtilityClass.default)('MuiToolbar', slot);
}
const $d3b4e1a115786e57$var$toolbarClasses = (0, $d3b4e1a115786e57$var$_generateUtilityClasses.default)('MuiToolbar', [
    'root',
    'gutters',
    'regular',
    'dense'
]);
var $d3b4e1a115786e57$var$_default = module.exports.default = $d3b4e1a115786e57$var$toolbarClasses;

});



parcelRegister("lqVz5", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f9a8adddd853f5c1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $f9a8adddd853f5c1$var$_TablePaginationActions.default;
    }
});
Object.defineProperty(module.exports, "tablePaginationActionsClasses", {
    enumerable: true,
    get: function() {
        return $f9a8adddd853f5c1$var$_tablePaginationActionsClasses.default;
    }
});

var $f9a8adddd853f5c1$var$_TablePaginationActions = $f9a8adddd853f5c1$require$_interopRequireDefault((parcelRequire("2uoZG")));

var $f9a8adddd853f5c1$var$_tablePaginationActionsClasses = $f9a8adddd853f5c1$require$_interopRequireDefault((parcelRequire("2u1Xb")));

});
parcelRegister("2uoZG", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $1d01c561014f714c$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $1d01c561014f714c$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1d01c561014f714c$var$React = $1d01c561014f714c$require$_interopRequireWildcard((parcelRequire("acw62")));

var $1d01c561014f714c$var$_propTypes = $1d01c561014f714c$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $9uEev = parcelRequire("9uEev");

var $1d01c561014f714c$var$_composeClasses = $1d01c561014f714c$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $1d01c561014f714c$var$_clsx = $1d01c561014f714c$require$_interopRequireDefault((parcelRequire("9QePP")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $1d01c561014f714c$var$_KeyboardArrowLeft = $1d01c561014f714c$require$_interopRequireDefault((parcelRequire("frMNQ")));

var $1d01c561014f714c$var$_KeyboardArrowRight = $1d01c561014f714c$require$_interopRequireDefault((parcelRequire("f46un")));

var $1d01c561014f714c$var$_IconButton = $1d01c561014f714c$require$_interopRequireDefault((parcelRequire("825Zh")));

var $1d01c561014f714c$var$_LastPage = $1d01c561014f714c$require$_interopRequireDefault((parcelRequire("5izos")));

var $1d01c561014f714c$var$_FirstPage = $1d01c561014f714c$require$_interopRequireDefault((parcelRequire("21SL6")));

var $2u1Xb = parcelRequire("2u1Xb");

var $ayMG0 = parcelRequire("ayMG0");
const $1d01c561014f714c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $1d01c561014f714c$var$_composeClasses.default)(slots, $2u1Xb.getTablePaginationActionsUtilityClass, classes);
};
const $1d01c561014f714c$var$TablePaginationActionsRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiTablePaginationActions',
    slot: 'Root'
})({});
const $1d01c561014f714c$var$TablePaginationActions = /*#__PURE__*/ $1d01c561014f714c$var$React.forwardRef(function TablePaginationActions(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiTablePaginationActions'
    });
    const { backIconButtonProps: backIconButtonProps, className: className, count: count, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel, nextIconButtonProps: nextIconButtonProps, onPageChange: onPageChange, page: page, rowsPerPage: rowsPerPage, showFirstButton: showFirstButton, showLastButton: showLastButton, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const isRtl = (0, $9uEev.useRtl)();
    const ownerState = props;
    const classes = $1d01c561014f714c$var$useUtilityClasses(ownerState);
    const handleFirstPageButtonClick = (event)=>{
        onPageChange(event, 0);
    };
    const handleBackButtonClick = (event)=>{
        onPageChange(event, page - 1);
    };
    const handleNextButtonClick = (event)=>{
        onPageChange(event, page + 1);
    };
    const handleLastPageButtonClick = (event)=>{
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
    const FirstButton = slots.firstButton ?? $1d01c561014f714c$var$_IconButton.default;
    const LastButton = slots.lastButton ?? $1d01c561014f714c$var$_IconButton.default;
    const NextButton = slots.nextButton ?? $1d01c561014f714c$var$_IconButton.default;
    const PreviousButton = slots.previousButton ?? $1d01c561014f714c$var$_IconButton.default;
    const FirstButtonIcon = slots.firstButtonIcon ?? $1d01c561014f714c$var$_FirstPage.default;
    const LastButtonIcon = slots.lastButtonIcon ?? $1d01c561014f714c$var$_LastPage.default;
    const NextButtonIcon = slots.nextButtonIcon ?? $1d01c561014f714c$var$_KeyboardArrowRight.default;
    const PreviousButtonIcon = slots.previousButtonIcon ?? $1d01c561014f714c$var$_KeyboardArrowLeft.default;
    const FirstButtonSlot = isRtl ? LastButton : FirstButton;
    const PreviousButtonSlot = isRtl ? NextButton : PreviousButton;
    const NextButtonSlot = isRtl ? PreviousButton : NextButton;
    const LastButtonSlot = isRtl ? FirstButton : LastButton;
    const firstButtonSlotProps = isRtl ? slotProps.lastButton : slotProps.firstButton;
    const previousButtonSlotProps = isRtl ? slotProps.nextButton : slotProps.previousButton;
    const nextButtonSlotProps = isRtl ? slotProps.previousButton : slotProps.nextButton;
    const lastButtonSlotProps = isRtl ? slotProps.firstButton : slotProps.lastButton;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($1d01c561014f714c$var$TablePaginationActionsRoot, {
        ref: ref,
        className: (0, $1d01c561014f714c$var$_clsx.default)(classes.root, className),
        ...other,
        children: [
            showFirstButton && /*#__PURE__*/ (0, $ayMG0.jsx)(FirstButtonSlot, {
                onClick: handleFirstPageButtonClick,
                disabled: disabled || page === 0,
                "aria-label": getItemAriaLabel('first', page),
                title: getItemAriaLabel('first', page),
                ...firstButtonSlotProps,
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(LastButtonIcon, {
                    ...slotProps.lastButtonIcon
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)(FirstButtonIcon, {
                    ...slotProps.firstButtonIcon
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(PreviousButtonSlot, {
                onClick: handleBackButtonClick,
                disabled: disabled || page === 0,
                color: "inherit",
                "aria-label": getItemAriaLabel('previous', page),
                title: getItemAriaLabel('previous', page),
                ...previousButtonSlotProps ?? backIconButtonProps,
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(NextButtonIcon, {
                    ...slotProps.nextButtonIcon
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)(PreviousButtonIcon, {
                    ...slotProps.previousButtonIcon
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(NextButtonSlot, {
                onClick: handleNextButtonClick,
                disabled: disabled || (count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false),
                color: "inherit",
                "aria-label": getItemAriaLabel('next', page),
                title: getItemAriaLabel('next', page),
                ...nextButtonSlotProps ?? nextIconButtonProps,
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(PreviousButtonIcon, {
                    ...slotProps.previousButtonIcon
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)(NextButtonIcon, {
                    ...slotProps.nextButtonIcon
                })
            }),
            showLastButton && /*#__PURE__*/ (0, $ayMG0.jsx)(LastButtonSlot, {
                onClick: handleLastPageButtonClick,
                disabled: disabled || page >= Math.ceil(count / rowsPerPage) - 1,
                "aria-label": getItemAriaLabel('last', page),
                title: getItemAriaLabel('last', page),
                ...lastButtonSlotProps,
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(FirstButtonIcon, {
                    ...slotProps.firstButtonIcon
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)(LastButtonIcon, {
                    ...slotProps.lastButtonIcon
                })
            })
        ]
    });
});
$1d01c561014f714c$var$TablePaginationActions.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * This prop is an alias for `slotProps.previousButton` and will be overridden by it if both are used.
   * @deprecated Use `slotProps.previousButton` instead.
   */ backIconButtonProps: $1d01c561014f714c$var$_propTypes.default.object,
    /**
   * @ignore
   */ children: $1d01c561014f714c$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $1d01c561014f714c$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $1d01c561014f714c$var$_propTypes.default.string,
    /**
   * @ignore
   */ count: $1d01c561014f714c$var$_propTypes.default.number.isRequired,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: $1d01c561014f714c$var$_propTypes.default.bool,
    /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   * This is important for screen reader users.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @param {string} type The link or button type to format ('first' | 'last' | 'next' | 'previous').
   * @returns {string}
   */ getItemAriaLabel: $1d01c561014f714c$var$_propTypes.default.func.isRequired,
    /**
   * This prop is an alias for `slotProps.nextButton` and will be overridden by it if both are used.
   * @deprecated Use `slotProps.nextButton` instead.
   */ nextIconButtonProps: $1d01c561014f714c$var$_propTypes.default.object,
    /**
   * @ignore
   */ onPageChange: $1d01c561014f714c$var$_propTypes.default.func.isRequired,
    /**
   * @ignore
   */ page: $1d01c561014f714c$var$_propTypes.default.number.isRequired,
    /**
   * @ignore
   */ rowsPerPage: $1d01c561014f714c$var$_propTypes.default.number.isRequired,
    /**
   * @ignore
   */ showFirstButton: $1d01c561014f714c$var$_propTypes.default.bool.isRequired,
    /**
   * @ignore
   */ showLastButton: $1d01c561014f714c$var$_propTypes.default.bool.isRequired,
    /**
   * @ignore
   */ slotProps: $1d01c561014f714c$var$_propTypes.default.shape({
        firstButton: $1d01c561014f714c$var$_propTypes.default.object,
        firstButtonIcon: $1d01c561014f714c$var$_propTypes.default.object,
        lastButton: $1d01c561014f714c$var$_propTypes.default.object,
        lastButtonIcon: $1d01c561014f714c$var$_propTypes.default.object,
        nextButton: $1d01c561014f714c$var$_propTypes.default.object,
        nextButtonIcon: $1d01c561014f714c$var$_propTypes.default.object,
        previousButton: $1d01c561014f714c$var$_propTypes.default.object,
        previousButtonIcon: $1d01c561014f714c$var$_propTypes.default.object
    }),
    /**
   * @ignore
   */ slots: $1d01c561014f714c$var$_propTypes.default.shape({
        firstButton: $1d01c561014f714c$var$_propTypes.default.elementType,
        firstButtonIcon: $1d01c561014f714c$var$_propTypes.default.elementType,
        lastButton: $1d01c561014f714c$var$_propTypes.default.elementType,
        lastButtonIcon: $1d01c561014f714c$var$_propTypes.default.elementType,
        nextButton: $1d01c561014f714c$var$_propTypes.default.elementType,
        nextButtonIcon: $1d01c561014f714c$var$_propTypes.default.elementType,
        previousButton: $1d01c561014f714c$var$_propTypes.default.elementType,
        previousButtonIcon: $1d01c561014f714c$var$_propTypes.default.elementType
    })
};
var $1d01c561014f714c$var$_default = module.exports.default = $1d01c561014f714c$var$TablePaginationActions;

});
parcelRegister("frMNQ", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $b3ef3be5c947a70a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b3ef3be5c947a70a$var$_createSvgIcon = $b3ef3be5c947a70a$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $b3ef3be5c947a70a$var$_default = module.exports.default = (0, $b3ef3be5c947a70a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), 'KeyboardArrowLeft');

});

parcelRegister("f46un", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $02d495bb1a743bb2$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02d495bb1a743bb2$var$_createSvgIcon = $02d495bb1a743bb2$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $02d495bb1a743bb2$var$_default = module.exports.default = (0, $02d495bb1a743bb2$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), 'KeyboardArrowRight');

});

parcelRegister("5izos", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $3dba169293b5f5f0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3dba169293b5f5f0$var$_createSvgIcon = $3dba169293b5f5f0$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $3dba169293b5f5f0$var$_default = module.exports.default = (0, $3dba169293b5f5f0$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), 'LastPage');

});

parcelRegister("21SL6", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $17a626ba35acf52f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $17a626ba35acf52f$var$_createSvgIcon = $17a626ba35acf52f$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $17a626ba35acf52f$var$_default = module.exports.default = (0, $17a626ba35acf52f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), 'FirstPage');

});

parcelRegister("2u1Xb", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $1cefe60f2b4973e8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getTablePaginationActionsUtilityClass = $1cefe60f2b4973e8$var$getTablePaginationActionsUtilityClass;

var $1cefe60f2b4973e8$var$_generateUtilityClasses = $1cefe60f2b4973e8$require$_interopRequireDefault((parcelRequire("5nY49")));

var $1cefe60f2b4973e8$var$_generateUtilityClass = $1cefe60f2b4973e8$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $1cefe60f2b4973e8$var$getTablePaginationActionsUtilityClass(slot) {
    return (0, $1cefe60f2b4973e8$var$_generateUtilityClass.default)('MuiTablePaginationActions', slot);
}
const $1cefe60f2b4973e8$var$tablePaginationActionsClasses = (0, $1cefe60f2b4973e8$var$_generateUtilityClasses.default)('MuiTablePaginationActions', [
    'root'
]);
var $1cefe60f2b4973e8$var$_default = module.exports.default = $1cefe60f2b4973e8$var$tablePaginationActionsClasses;

});



parcelRegister("inBkn", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d6175477fd255470$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getTablePaginationUtilityClass = $d6175477fd255470$var$getTablePaginationUtilityClass;

var $d6175477fd255470$var$_generateUtilityClasses = $d6175477fd255470$require$_interopRequireDefault((parcelRequire("5nY49")));

var $d6175477fd255470$var$_generateUtilityClass = $d6175477fd255470$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $d6175477fd255470$var$getTablePaginationUtilityClass(slot) {
    return (0, $d6175477fd255470$var$_generateUtilityClass.default)('MuiTablePagination', slot);
}
const $d6175477fd255470$var$tablePaginationClasses = (0, $d6175477fd255470$var$_generateUtilityClasses.default)('MuiTablePagination', [
    'root',
    'toolbar',
    'spacer',
    'selectLabel',
    'selectRoot',
    'select',
    'selectIcon',
    'input',
    'menuItem',
    'displayedRows',
    'actions'
]);
var $d6175477fd255470$var$_default = module.exports.default = $d6175477fd255470$var$tablePaginationClasses;

});



parcelRegister("7Ke9B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $kGwBF.ClickAwayListener;
    }
});

var $kGwBF = parcelRequire("kGwBF");

});
parcelRegister("kGwBF", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $f0f105dbd8c07c9e$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $f0f105dbd8c07c9e$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ClickAwayListener = $f0f105dbd8c07c9e$var$ClickAwayListener;

var $f0f105dbd8c07c9e$var$React = $f0f105dbd8c07c9e$require$_interopRequireWildcard((parcelRequire("acw62")));

var $f0f105dbd8c07c9e$var$_propTypes = $f0f105dbd8c07c9e$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $f0f105dbd8c07c9e$var$_contains = $f0f105dbd8c07c9e$require$_interopRequireDefault((parcelRequire("9DeDn")));

var $f0f105dbd8c07c9e$var$_ownerDocument = $f0f105dbd8c07c9e$require$_interopRequireDefault((parcelRequire("43fuO")));

var $f0f105dbd8c07c9e$var$_useForkRef = $f0f105dbd8c07c9e$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $f0f105dbd8c07c9e$var$_useEventCallback = $f0f105dbd8c07c9e$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $f0f105dbd8c07c9e$var$_elementAcceptingRef = $f0f105dbd8c07c9e$require$_interopRequireDefault((parcelRequire("igTUE")));

var $f0f105dbd8c07c9e$var$_exactProp = $f0f105dbd8c07c9e$require$_interopRequireDefault((parcelRequire("5S3aN")));

var $f0f105dbd8c07c9e$var$_getReactElementRef = $f0f105dbd8c07c9e$require$_interopRequireDefault((parcelRequire("2B4J6")));
// TODO: return `EventHandlerName extends `on${infer EventName}` ? Lowercase<EventName> : never` once generatePropTypes runs with TS 4.1
function $f0f105dbd8c07c9e$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $f0f105dbd8c07c9e$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click-Away Listener](https://v7.mui.com/material-ui/react-click-away-listener/)
 * - [Menu](https://v7.mui.com/material-ui/react-menu/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://v7.mui.com/material-ui/api/click-away-listener/)
 */ function $f0f105dbd8c07c9e$var$ClickAwayListener(props) {
    const { children: children, disableReactTree: disableReactTree = false, mouseEvent: mouseEvent = 'onClick', onClickAway: onClickAway, touchEvent: touchEvent = 'onTouchEnd' } = props;
    const movedRef = $f0f105dbd8c07c9e$var$React.useRef(false);
    const nodeRef = $f0f105dbd8c07c9e$var$React.useRef(null);
    const activatedRef = $f0f105dbd8c07c9e$var$React.useRef(false);
    const syntheticEventRef = $f0f105dbd8c07c9e$var$React.useRef(false);
    $f0f105dbd8c07c9e$var$React.useEffect(()=>{
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(()=>{
            activatedRef.current = true;
        }, 0);
        return ()=>{
            activatedRef.current = false;
        };
    }, []);
    const handleRef = (0, $f0f105dbd8c07c9e$var$_useForkRef.default)((0, $f0f105dbd8c07c9e$var$_getReactElementRef.default)(children), nodeRef);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $f0f105dbd8c07c9e$var$_useEventCallback.default)((event)=>{
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $f0f105dbd8c07c9e$var$_ownerDocument.default)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || 'clientX' in event && $f0f105dbd8c07c9e$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().includes(nodeRef.current);
        else insideDOM = !(0, $f0f105dbd8c07c9e$var$_contains.default)(doc.documentElement, event.target) || (0, $f0f105dbd8c07c9e$var$_contains.default)(nodeRef.current, event.target);
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const createHandleSynthetic = (handlerName)=>(event)=>{
            syntheticEventRef.current = true;
            const childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    const childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $f0f105dbd8c07c9e$var$React.useEffect(()=>{
        if (touchEvent !== false) {
            const mappedTouchEvent = $f0f105dbd8c07c9e$var$mapEventPropToEvent(touchEvent);
            const doc = (0, $f0f105dbd8c07c9e$var$_ownerDocument.default)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener('touchmove', handleTouchMove);
            return ()=>{
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener('touchmove', handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $f0f105dbd8c07c9e$var$React.useEffect(()=>{
        if (mouseEvent !== false) {
            const mappedMouseEvent = $f0f105dbd8c07c9e$var$mapEventPropToEvent(mouseEvent);
            const doc = (0, $f0f105dbd8c07c9e$var$_ownerDocument.default)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return ()=>{
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ $f0f105dbd8c07c9e$var$React.cloneElement(children, childrenProps);
}
$f0f105dbd8c07c9e$var$ClickAwayListener.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The wrapped element.
   */ children: $f0f105dbd8c07c9e$var$_elementAcceptingRef.default.isRequired,
    /**
   * If `true`, the React tree is ignored and only the DOM tree is considered.
   * This prop changes how portaled elements are handled.
   * @default false
   */ disableReactTree: $f0f105dbd8c07c9e$var$_propTypes.default.bool,
    /**
   * The mouse event to listen to. You can disable the listener by providing `false`.
   * @default 'onClick'
   */ mouseEvent: $f0f105dbd8c07c9e$var$_propTypes.default.oneOf([
        'onClick',
        'onMouseDown',
        'onMouseUp',
        'onPointerDown',
        'onPointerUp',
        false
    ]),
    /**
   * Callback fired when a "click away" event is detected.
   */ onClickAway: $f0f105dbd8c07c9e$var$_propTypes.default.func.isRequired,
    /**
   * The touch event to listen to. You can disable the listener by providing `false`.
   * @default 'onTouchEnd'
   */ touchEvent: $f0f105dbd8c07c9e$var$_propTypes.default.oneOf([
        'onTouchEnd',
        'onTouchStart',
        false
    ])
};
// eslint-disable-next-line
$f0f105dbd8c07c9e$var$ClickAwayListener["propTypes"] = (0, $f0f105dbd8c07c9e$var$_exactProp.default)($f0f105dbd8c07c9e$var$ClickAwayListener.propTypes);

});


parcelRegister("eTbCT", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $ad6f387c32d3bcf0$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $ad6f387c32d3bcf0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $ad6f387c32d3bcf0$var$_exportNames = {
    skeletonClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ad6f387c32d3bcf0$var$_Skeleton.default;
    }
});
Object.defineProperty(module.exports, "skeletonClasses", {
    enumerable: true,
    get: function() {
        return $ad6f387c32d3bcf0$var$_skeletonClasses.default;
    }
});

var $ad6f387c32d3bcf0$var$_Skeleton = $ad6f387c32d3bcf0$require$_interopRequireDefault((parcelRequire("5RIww")));

var $ad6f387c32d3bcf0$var$_skeletonClasses = $ad6f387c32d3bcf0$require$_interopRequireWildcard((parcelRequire("bWvDT")));
Object.keys($ad6f387c32d3bcf0$var$_skeletonClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($ad6f387c32d3bcf0$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $ad6f387c32d3bcf0$var$_skeletonClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ad6f387c32d3bcf0$var$_skeletonClasses[key];
        }
    });
});

});
parcelRegister("5RIww", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $445470756a9ff70a$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $445470756a9ff70a$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $445470756a9ff70a$var$React = $445470756a9ff70a$require$_interopRequireWildcard((parcelRequire("acw62")));

var $445470756a9ff70a$var$_clsx = $445470756a9ff70a$require$_interopRequireDefault((parcelRequire("9QePP")));

var $445470756a9ff70a$var$_propTypes = $445470756a9ff70a$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $445470756a9ff70a$var$_composeClasses = $445470756a9ff70a$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $8xDHs = parcelRequire("8xDHs");

var $aAbgT = parcelRequire("aAbgT");

var $445470756a9ff70a$var$_memoTheme = $445470756a9ff70a$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $bWvDT = parcelRequire("bWvDT");

var $ayMG0 = parcelRequire("ayMG0");
const $445470756a9ff70a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, animation: animation, hasChildren: hasChildren, width: width, height: height } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            animation,
            hasChildren && 'withChildren',
            hasChildren && !width && 'fitContent',
            hasChildren && !height && 'heightAuto'
        ]
    };
    return (0, $445470756a9ff70a$var$_composeClasses.default)(slots, $bWvDT.getSkeletonUtilityClass, classes);
};
const $445470756a9ff70a$var$pulseKeyframe = (0, $aAbgT.keyframes)`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`;
const $445470756a9ff70a$var$waveKeyframe = (0, $aAbgT.keyframes)`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $445470756a9ff70a$var$pulseAnimation = typeof $445470756a9ff70a$var$pulseKeyframe !== 'string' ? (0, $aAbgT.css)`
        animation: ${$445470756a9ff70a$var$pulseKeyframe} 2s ease-in-out 0.5s infinite;
      ` : null;
const $445470756a9ff70a$var$waveAnimation = typeof $445470756a9ff70a$var$waveKeyframe !== 'string' ? (0, $aAbgT.css)`
        &::after {
          animation: ${$445470756a9ff70a$var$waveKeyframe} 2s linear 0.5s infinite;
        }
      ` : null;
const $445470756a9ff70a$var$SkeletonRoot = (0, $aAbgT.styled)('span', {
    name: 'MuiSkeleton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.animation !== false && styles[ownerState.animation],
            ownerState.hasChildren && styles.withChildren,
            ownerState.hasChildren && !ownerState.width && styles.fitContent,
            ownerState.hasChildren && !ownerState.height && styles.heightAuto
        ];
    }
})((0, $445470756a9ff70a$var$_memoTheme.default)(({ theme: theme })=>{
    const radiusUnit = (0, $8xDHs.unstable_getUnit)(theme.shape.borderRadius) || 'px';
    const radiusValue = (0, $8xDHs.unstable_toUnitless)(theme.shape.borderRadius);
    return {
        display: 'block',
        // Create a "on paper" color with sufficient contrast retaining the color
        backgroundColor: theme.vars ? theme.vars.palette.Skeleton.bg : theme.alpha(theme.palette.text.primary, theme.palette.mode === 'light' ? 0.11 : 0.13),
        height: '1.2em',
        variants: [
            {
                props: {
                    variant: 'text'
                },
                style: {
                    marginTop: 0,
                    marginBottom: 0,
                    height: 'auto',
                    transformOrigin: '0 55%',
                    transform: 'scale(1, 0.60)',
                    borderRadius: `${radiusValue}${radiusUnit}/${Math.round(radiusValue / 0.6 * 10) / 10}${radiusUnit}`,
                    '&:empty:before': {
                        content: '"\\00a0"'
                    }
                }
            },
            {
                props: {
                    variant: 'circular'
                },
                style: {
                    borderRadius: '50%'
                }
            },
            {
                props: {
                    variant: 'rounded'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasChildren,
                style: {
                    '& > *': {
                        visibility: 'hidden'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasChildren && !ownerState.width,
                style: {
                    maxWidth: 'fit-content'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasChildren && !ownerState.height,
                style: {
                    height: 'auto'
                }
            },
            {
                props: {
                    animation: 'pulse'
                },
                style: $445470756a9ff70a$var$pulseAnimation || {
                    animation: `${$445470756a9ff70a$var$pulseKeyframe} 2s ease-in-out 0.5s infinite`
                }
            },
            {
                props: {
                    animation: 'wave'
                },
                style: {
                    position: 'relative',
                    overflow: 'hidden',
                    /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */ WebkitMaskImage: '-webkit-radial-gradient(white, black)',
                    '&::after': {
                        background: `linear-gradient(
                90deg,
                transparent,
                ${(theme.vars || theme).palette.action.hover},
                transparent
              )`,
                        content: '""',
                        position: 'absolute',
                        transform: 'translateX(-100%)' /* Avoid flash during server-side hydration */ ,
                        bottom: 0,
                        left: 0,
                        right: 0,
                        top: 0
                    }
                }
            },
            {
                props: {
                    animation: 'wave'
                },
                style: $445470756a9ff70a$var$waveAnimation || {
                    '&::after': {
                        animation: `${$445470756a9ff70a$var$waveKeyframe} 2s linear 0.5s infinite`
                    }
                }
            }
        ]
    };
}));
const $445470756a9ff70a$var$Skeleton = /*#__PURE__*/ $445470756a9ff70a$var$React.forwardRef(function Skeleton(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiSkeleton'
    });
    const { animation: animation = 'pulse', className: className, component: component = 'span', height: height, style: style, variant: variant = 'text', width: width, ...other } = props;
    const ownerState = {
        ...props,
        animation: animation,
        component: component,
        variant: variant,
        hasChildren: Boolean(other.children)
    };
    const classes = $445470756a9ff70a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($445470756a9ff70a$var$SkeletonRoot, {
        as: component,
        ref: ref,
        className: (0, $445470756a9ff70a$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        ...other,
        style: {
            width: width,
            height: height,
            ...style
        }
    });
});
$445470756a9ff70a$var$Skeleton.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The animation.
   * If `false` the animation effect is disabled.
   * @default 'pulse'
   */ animation: $445470756a9ff70a$var$_propTypes.default.oneOf([
        'pulse',
        'wave',
        false
    ]),
    /**
   * Optional children to infer width and height from.
   */ children: $445470756a9ff70a$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $445470756a9ff70a$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $445470756a9ff70a$var$_propTypes.default.string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $445470756a9ff70a$var$_propTypes.default.elementType,
    /**
   * Height of the skeleton.
   * Useful when you don't want to adapt the skeleton to a text element but for instance a card.
   */ height: $445470756a9ff70a$var$_propTypes.default.oneOfType([
        $445470756a9ff70a$var$_propTypes.default.number,
        $445470756a9ff70a$var$_propTypes.default.string
    ]),
    /**
   * @ignore
   */ style: $445470756a9ff70a$var$_propTypes.default.object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $445470756a9ff70a$var$_propTypes.default.oneOfType([
        $445470756a9ff70a$var$_propTypes.default.arrayOf($445470756a9ff70a$var$_propTypes.default.oneOfType([
            $445470756a9ff70a$var$_propTypes.default.func,
            $445470756a9ff70a$var$_propTypes.default.object,
            $445470756a9ff70a$var$_propTypes.default.bool
        ])),
        $445470756a9ff70a$var$_propTypes.default.func,
        $445470756a9ff70a$var$_propTypes.default.object
    ]),
    /**
   * The type of content that will be rendered.
   * @default 'text'
   */ variant: $445470756a9ff70a$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $445470756a9ff70a$var$_propTypes.default.oneOf([
            'circular',
            'rectangular',
            'rounded',
            'text'
        ]),
        $445470756a9ff70a$var$_propTypes.default.string
    ]),
    /**
   * Width of the skeleton.
   * Useful when the skeleton is inside an inline element with no width of its own.
   */ width: $445470756a9ff70a$var$_propTypes.default.oneOfType([
        $445470756a9ff70a$var$_propTypes.default.number,
        $445470756a9ff70a$var$_propTypes.default.string
    ])
};
var $445470756a9ff70a$var$_default = module.exports.default = $445470756a9ff70a$var$Skeleton;

});
parcelRegister("bWvDT", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $8b1da808c4852549$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getSkeletonUtilityClass = $8b1da808c4852549$var$getSkeletonUtilityClass;

var $8b1da808c4852549$var$_generateUtilityClasses = $8b1da808c4852549$require$_interopRequireDefault((parcelRequire("5nY49")));

var $8b1da808c4852549$var$_generateUtilityClass = $8b1da808c4852549$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $8b1da808c4852549$var$getSkeletonUtilityClass(slot) {
    return (0, $8b1da808c4852549$var$_generateUtilityClass.default)('MuiSkeleton', slot);
}
const $8b1da808c4852549$var$skeletonClasses = (0, $8b1da808c4852549$var$_generateUtilityClasses.default)('MuiSkeleton', [
    'root',
    'text',
    'rectangular',
    'rounded',
    'circular',
    'pulse',
    'wave',
    'withChildren',
    'fitContent',
    'heightAuto'
]);
var $8b1da808c4852549$var$_default = module.exports.default = $8b1da808c4852549$var$skeletonClasses;

});



parcelRegister("dKcJh", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $a019720230600cef$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $a019720230600cef$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $a019720230600cef$var$_exportNames = {
    tabsClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $a019720230600cef$var$_Tabs.default;
    }
});
Object.defineProperty(module.exports, "tabsClasses", {
    enumerable: true,
    get: function() {
        return $a019720230600cef$var$_tabsClasses.default;
    }
});

var $a019720230600cef$var$_Tabs = $a019720230600cef$require$_interopRequireDefault((parcelRequire("aDtBU")));

var $a019720230600cef$var$_tabsClasses = $a019720230600cef$require$_interopRequireWildcard((parcelRequire("bTm2Q")));
Object.keys($a019720230600cef$var$_tabsClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($a019720230600cef$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $a019720230600cef$var$_tabsClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $a019720230600cef$var$_tabsClasses[key];
        }
    });
});

});
parcelRegister("aDtBU", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $7be483edbed3b474$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $7be483edbed3b474$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7be483edbed3b474$var$React = $7be483edbed3b474$require$_interopRequireWildcard((parcelRequire("acw62")));

var $4jPKB = parcelRequire("4jPKB");

var $7be483edbed3b474$var$_propTypes = $7be483edbed3b474$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $7be483edbed3b474$var$_clsx = $7be483edbed3b474$require$_interopRequireDefault((parcelRequire("9QePP")));

var $7be483edbed3b474$var$_refType = $7be483edbed3b474$require$_interopRequireDefault((parcelRequire("b3gjr")));

var $7be483edbed3b474$var$_composeClasses = $7be483edbed3b474$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $9uEev = parcelRequire("9uEev");

var $7be483edbed3b474$var$_useSlotProps = $7be483edbed3b474$require$_interopRequireDefault((parcelRequire("839K0")));

var $aAbgT = parcelRequire("aAbgT");

var $7be483edbed3b474$var$_memoTheme = $7be483edbed3b474$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $7be483edbed3b474$var$_debounce = $7be483edbed3b474$require$_interopRequireDefault((parcelRequire("1iGrQ")));

var $7be483edbed3b474$var$_animate = $7be483edbed3b474$require$_interopRequireDefault((parcelRequire("kRsYK")));

var $7be483edbed3b474$var$_ScrollbarSize = $7be483edbed3b474$require$_interopRequireDefault((parcelRequire("l0ZbI")));

var $7be483edbed3b474$var$_TabScrollButton = $7be483edbed3b474$require$_interopRequireDefault((parcelRequire("b1hEL")));

var $7be483edbed3b474$var$_useEventCallback = $7be483edbed3b474$require$_interopRequireDefault((parcelRequire("4o7uD")));

var $7be483edbed3b474$var$_tabsClasses = $7be483edbed3b474$require$_interopRequireWildcard((parcelRequire("bTm2Q")));

var $7be483edbed3b474$var$_ownerDocument = $7be483edbed3b474$require$_interopRequireDefault((parcelRequire("gzyUk")));

var $7be483edbed3b474$var$_ownerWindow = $7be483edbed3b474$require$_interopRequireDefault((parcelRequire("9Evvr")));

var $7be483edbed3b474$var$_getActiveElement = $7be483edbed3b474$require$_interopRequireDefault((parcelRequire("6uU67")));

var $7be483edbed3b474$var$_isLayoutSupported = $7be483edbed3b474$require$_interopRequireDefault((parcelRequire("6toKj")));

var $7be483edbed3b474$var$_useSlot = $7be483edbed3b474$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $7be483edbed3b474$var$nextItem = (list, item)=>{
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return list.firstChild;
};
const $7be483edbed3b474$var$previousItem = (list, item)=>{
    if (list === item) return list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return list.lastChild;
};
const $7be483edbed3b474$var$moveFocus = (list, currentFocus, traversalFunction)=>{
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus);
        else {
            nextFocus.focus();
            return;
        }
    }
};
const $7be483edbed3b474$var$useUtilityClasses = (ownerState)=>{
    const { vertical: vertical, fixed: fixed, hideScrollbar: hideScrollbar, scrollableX: scrollableX, scrollableY: scrollableY, centered: centered, scrollButtonsHideMobile: scrollButtonsHideMobile, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            vertical && 'vertical'
        ],
        scroller: [
            'scroller',
            fixed && 'fixed',
            hideScrollbar && 'hideScrollbar',
            scrollableX && 'scrollableX',
            scrollableY && 'scrollableY'
        ],
        list: [
            'list',
            'flexContainer',
            vertical && 'flexContainerVertical',
            vertical && 'vertical',
            centered && 'centered'
        ],
        indicator: [
            'indicator'
        ],
        scrollButtons: [
            'scrollButtons',
            scrollButtonsHideMobile && 'scrollButtonsHideMobile'
        ],
        scrollableX: [
            scrollableX && 'scrollableX'
        ],
        hideScrollbar: [
            hideScrollbar && 'hideScrollbar'
        ]
    };
    return (0, $7be483edbed3b474$var$_composeClasses.default)(slots, $7be483edbed3b474$var$_tabsClasses.getTabsUtilityClass, classes);
};
const $7be483edbed3b474$var$TabsRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiTabs',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${$7be483edbed3b474$var$_tabsClasses.default.scrollButtons}`]: styles.scrollButtons
            },
            {
                [`& .${$7be483edbed3b474$var$_tabsClasses.default.scrollButtons}`]: ownerState.scrollButtonsHideMobile && styles.scrollButtonsHideMobile
            },
            styles.root,
            ownerState.vertical && styles.vertical
        ];
    }
})((0, $7be483edbed3b474$var$_memoTheme.default)(({ theme: theme })=>({
        overflow: 'hidden',
        minHeight: 48,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        display: 'flex',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.vertical,
                style: {
                    flexDirection: 'column'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.scrollButtonsHideMobile,
                style: {
                    [`& .${$7be483edbed3b474$var$_tabsClasses.default.scrollButtons}`]: {
                        [theme.breakpoints.down('sm')]: {
                            display: 'none'
                        }
                    }
                }
            }
        ]
    })));
const $7be483edbed3b474$var$TabsScroller = (0, $aAbgT.styled)('div', {
    name: 'MuiTabs',
    slot: 'Scroller',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.scroller,
            ownerState.fixed && styles.fixed,
            ownerState.hideScrollbar && styles.hideScrollbar,
            ownerState.scrollableX && styles.scrollableX,
            ownerState.scrollableY && styles.scrollableY
        ];
    }
})({
    position: 'relative',
    display: 'inline-block',
    flex: '1 1 auto',
    whiteSpace: 'nowrap',
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.fixed,
            style: {
                overflowX: 'hidden',
                width: '100%'
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.hideScrollbar,
            style: {
                // Hide dimensionless scrollbar on macOS
                scrollbarWidth: 'none',
                // Firefox
                '&::-webkit-scrollbar': {
                    display: 'none' // Safari + Chrome
                }
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.scrollableX,
            style: {
                overflowX: 'auto',
                overflowY: 'hidden'
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.scrollableY,
            style: {
                overflowY: 'auto',
                overflowX: 'hidden'
            }
        }
    ]
});
const $7be483edbed3b474$var$List = (0, $aAbgT.styled)('div', {
    name: 'MuiTabs',
    slot: 'List',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.list,
            styles.flexContainer,
            ownerState.vertical && styles.flexContainerVertical,
            ownerState.centered && styles.centered
        ];
    }
})({
    display: 'flex',
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.vertical,
            style: {
                flexDirection: 'column'
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.centered,
            style: {
                justifyContent: 'center'
            }
        }
    ]
});
const $7be483edbed3b474$var$TabsIndicator = (0, $aAbgT.styled)('span', {
    name: 'MuiTabs',
    slot: 'Indicator'
})((0, $7be483edbed3b474$var$_memoTheme.default)(({ theme: theme })=>({
        position: 'absolute',
        height: 2,
        bottom: 0,
        width: '100%',
        transition: theme.transitions.create(),
        variants: [
            {
                props: {
                    indicatorColor: 'primary'
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.primary.main
                }
            },
            {
                props: {
                    indicatorColor: 'secondary'
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.secondary.main
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.vertical,
                style: {
                    height: '100%',
                    width: 2,
                    right: 0
                }
            }
        ]
    })));
const $7be483edbed3b474$var$TabsScrollbarSize = (0, $aAbgT.styled)($7be483edbed3b474$var$_ScrollbarSize.default)({
    overflowX: 'auto',
    overflowY: 'hidden',
    // Hide dimensionless scrollbar on macOS
    scrollbarWidth: 'none',
    // Firefox
    '&::-webkit-scrollbar': {
        display: 'none' // Safari + Chrome
    }
});
const $7be483edbed3b474$var$defaultIndicatorStyle = {};
let $7be483edbed3b474$var$warnedOnceTabPresent = false;
const $7be483edbed3b474$var$Tabs = /*#__PURE__*/ $7be483edbed3b474$var$React.forwardRef(function Tabs(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiTabs'
    });
    const theme = (0, $aAbgT.useTheme)();
    const isRtl = (0, $9uEev.useRtl)();
    const { 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, action: action, centered: centered = false, children: childrenProp, className: className, component: component = 'div', allowScrollButtonsMobile: allowScrollButtonsMobile = false, indicatorColor: indicatorColor = 'primary', onChange: onChange, orientation: orientation = 'horizontal', ScrollButtonComponent: ScrollButtonComponent, scrollButtons: // TODO: remove in v7 (deprecated in v6)
    scrollButtons = 'auto', selectionFollowsFocus: selectionFollowsFocus, slots: slots = {}, slotProps: slotProps = {}, TabIndicatorProps: TabIndicatorProps = {}, TabScrollButtonProps: // TODO: remove in v7 (deprecated in v6)
    TabScrollButtonProps = {}, textColor: // TODO: remove in v7 (deprecated in v6)
    textColor = 'primary', value: value, variant: variant = 'standard', visibleScrollbar: visibleScrollbar = false, ...other } = props;
    const scrollable = variant === 'scrollable';
    const vertical = orientation === 'vertical';
    const scrollStart = vertical ? 'scrollTop' : 'scrollLeft';
    const start = vertical ? 'top' : 'left';
    const end = vertical ? 'bottom' : 'right';
    const clientSize = vertical ? 'clientHeight' : 'clientWidth';
    const size = vertical ? 'height' : 'width';
    const ownerState = {
        ...props,
        component: component,
        allowScrollButtonsMobile: allowScrollButtonsMobile,
        indicatorColor: indicatorColor,
        orientation: orientation,
        vertical: vertical,
        scrollButtons: scrollButtons,
        textColor: textColor,
        variant: variant,
        visibleScrollbar: visibleScrollbar,
        fixed: !scrollable,
        hideScrollbar: scrollable && !visibleScrollbar,
        scrollableX: scrollable && !vertical,
        scrollableY: scrollable && vertical,
        centered: centered && !scrollable,
        scrollButtonsHideMobile: !allowScrollButtonsMobile
    };
    const classes = $7be483edbed3b474$var$useUtilityClasses(ownerState);
    const startScrollButtonIconProps = (0, $7be483edbed3b474$var$_useSlotProps.default)({
        elementType: slots.StartScrollButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        ownerState: ownerState
    });
    const endScrollButtonIconProps = (0, $7be483edbed3b474$var$_useSlotProps.default)({
        elementType: slots.EndScrollButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        ownerState: ownerState
    });
    if (centered && scrollable) console.error('MUI: You can not use the `centered={true}` and `variant="scrollable"` properties at the same time on a `Tabs` component.');
    const [mounted, setMounted] = $7be483edbed3b474$var$React.useState(false);
    const [indicatorStyle, setIndicatorStyle] = $7be483edbed3b474$var$React.useState($7be483edbed3b474$var$defaultIndicatorStyle);
    const [displayStartScroll, setDisplayStartScroll] = $7be483edbed3b474$var$React.useState(false);
    const [displayEndScroll, setDisplayEndScroll] = $7be483edbed3b474$var$React.useState(false);
    const [updateScrollObserver, setUpdateScrollObserver] = $7be483edbed3b474$var$React.useState(false);
    const [scrollerStyle, setScrollerStyle] = $7be483edbed3b474$var$React.useState({
        overflow: 'hidden',
        scrollbarWidth: 0
    });
    const valueToIndex = new Map();
    const tabsRef = $7be483edbed3b474$var$React.useRef(null);
    const tabListRef = $7be483edbed3b474$var$React.useRef(null);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            indicator: TabIndicatorProps,
            scrollButtons: TabScrollButtonProps,
            ...slotProps
        }
    };
    const getTabsMeta = ()=>{
        const tabsNode = tabsRef.current;
        let tabsMeta;
        if (tabsNode) {
            const rect = tabsNode.getBoundingClientRect();
            // create a new object with ClientRect class props + scrollLeft
            tabsMeta = {
                clientWidth: tabsNode.clientWidth,
                scrollLeft: tabsNode.scrollLeft,
                scrollTop: tabsNode.scrollTop,
                scrollWidth: tabsNode.scrollWidth,
                top: rect.top,
                bottom: rect.bottom,
                left: rect.left,
                right: rect.right
            };
        }
        let tabMeta;
        if (tabsNode && value !== false) {
            const children = tabListRef.current.children;
            if (children.length > 0) {
                const tab = children[valueToIndex.get(value)];
                if (!tab) console.error([
                    `MUI: The \`value\` provided to the Tabs component is invalid.`,
                    `None of the Tabs' children match with "${value}".`,
                    valueToIndex.keys ? `You can provide one of the following values: ${Array.from(valueToIndex.keys()).join(', ')}.` : null
                ].join('\n'));
                tabMeta = tab ? tab.getBoundingClientRect() : null;
                if ((0, $7be483edbed3b474$var$_isLayoutSupported.default)() && !$7be483edbed3b474$var$warnedOnceTabPresent && tabMeta && tabMeta.width === 0 && tabMeta.height === 0 && // if the whole Tabs component is hidden, don't warn
                tabsMeta.clientWidth !== 0) {
                    tabsMeta = null;
                    console.error([
                        'MUI: The `value` provided to the Tabs component is invalid.',
                        `The Tab with this \`value\` ("${value}") is not part of the document layout.`,
                        "Make sure the tab item is present in the document or that it's not `display: none`."
                    ].join('\n'));
                    $7be483edbed3b474$var$warnedOnceTabPresent = true;
                }
            }
        }
        return {
            tabsMeta: tabsMeta,
            tabMeta: tabMeta
        };
    };
    const updateIndicatorState = (0, $7be483edbed3b474$var$_useEventCallback.default)(()=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        let startValue = 0;
        let startIndicator;
        if (vertical) {
            startIndicator = 'top';
            if (tabMeta && tabsMeta) startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
        } else {
            startIndicator = isRtl ? 'right' : 'left';
            if (tabMeta && tabsMeta) startValue = (isRtl ? -1 : 1) * (tabMeta[startIndicator] - tabsMeta[startIndicator] + tabsMeta.scrollLeft);
        }
        const newIndicatorStyle = {
            [startIndicator]: startValue,
            // May be wrong until the font is loaded.
            [size]: tabMeta ? tabMeta[size] : 0
        };
        if (typeof indicatorStyle[startIndicator] !== 'number' || typeof indicatorStyle[size] !== 'number') setIndicatorStyle(newIndicatorStyle);
        else {
            const dStart = Math.abs(indicatorStyle[startIndicator] - newIndicatorStyle[startIndicator]);
            const dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
            if (dStart >= 1 || dSize >= 1) setIndicatorStyle(newIndicatorStyle);
        }
    });
    const scroll = (scrollValue, { animation: animation = true } = {})=>{
        if (animation) (0, $7be483edbed3b474$var$_animate.default)(scrollStart, tabsRef.current, scrollValue, {
            duration: theme.transitions.duration.standard
        });
        else tabsRef.current[scrollStart] = scrollValue;
    };
    const moveTabsScroll = (delta)=>{
        let scrollValue = tabsRef.current[scrollStart];
        if (vertical) scrollValue += delta;
        else scrollValue += delta * (isRtl ? -1 : 1);
        scroll(scrollValue);
    };
    const getScrollSize = ()=>{
        const containerSize = tabsRef.current[clientSize];
        let totalSize = 0;
        const children = Array.from(tabListRef.current.children);
        for(let i = 0; i < children.length; i += 1){
            const tab = children[i];
            if (totalSize + tab[clientSize] > containerSize) {
                // If the first item is longer than the container size, then only scroll
                // by the container size.
                if (i === 0) totalSize = containerSize;
                break;
            }
            totalSize += tab[clientSize];
        }
        return totalSize;
    };
    const handleStartScrollClick = ()=>{
        moveTabsScroll(-1 * getScrollSize());
    };
    const handleEndScrollClick = ()=>{
        moveTabsScroll(getScrollSize());
    };
    const [ScrollbarSlot, { onChange: scrollbarOnChange, ...scrollbarSlotProps }] = (0, $7be483edbed3b474$var$_useSlot.default)('scrollbar', {
        className: (0, $7be483edbed3b474$var$_clsx.default)(classes.scrollableX, classes.hideScrollbar),
        elementType: $7be483edbed3b474$var$TabsScrollbarSize,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    // TODO Remove <ScrollbarSize /> as browser support for hiding the scrollbar
    // with CSS improves.
    const handleScrollbarSizeChange = $7be483edbed3b474$var$React.useCallback((scrollbarWidth)=>{
        scrollbarOnChange?.(scrollbarWidth);
        setScrollerStyle({
            overflow: null,
            scrollbarWidth: scrollbarWidth
        });
    }, [
        scrollbarOnChange
    ]);
    const [ScrollButtonsSlot, scrollButtonSlotProps] = (0, $7be483edbed3b474$var$_useSlot.default)('scrollButtons', {
        className: (0, $7be483edbed3b474$var$_clsx.default)(classes.scrollButtons, TabScrollButtonProps.className),
        elementType: $7be483edbed3b474$var$_TabScrollButton.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            orientation: orientation,
            slots: {
                StartScrollButtonIcon: slots.startScrollButtonIcon || slots.StartScrollButtonIcon,
                EndScrollButtonIcon: slots.endScrollButtonIcon || slots.EndScrollButtonIcon
            },
            slotProps: {
                startScrollButtonIcon: startScrollButtonIconProps,
                endScrollButtonIcon: endScrollButtonIconProps
            }
        }
    });
    const getConditionalElements = ()=>{
        const conditionalElements = {};
        conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/ (0, $ayMG0.jsx)(ScrollbarSlot, {
            ...scrollbarSlotProps,
            onChange: handleScrollbarSizeChange
        }) : null;
        const scrollButtonsActive = displayStartScroll || displayEndScroll;
        const showScrollButtons = scrollable && (scrollButtons === 'auto' && scrollButtonsActive || scrollButtons === true);
        conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/ (0, $ayMG0.jsx)(ScrollButtonsSlot, {
            direction: isRtl ? 'right' : 'left',
            onClick: handleStartScrollClick,
            disabled: !displayStartScroll,
            ...scrollButtonSlotProps
        }) : null;
        conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/ (0, $ayMG0.jsx)(ScrollButtonsSlot, {
            direction: isRtl ? 'left' : 'right',
            onClick: handleEndScrollClick,
            disabled: !displayEndScroll,
            ...scrollButtonSlotProps
        }) : null;
        return conditionalElements;
    };
    const scrollSelectedIntoView = (0, $7be483edbed3b474$var$_useEventCallback.default)((animation)=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        if (!tabMeta || !tabsMeta) return;
        if (tabMeta[start] < tabsMeta[start]) {
            // left side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
            scroll(nextScrollStart, {
                animation: animation
            });
        } else if (tabMeta[end] > tabsMeta[end]) {
            // right side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
            scroll(nextScrollStart, {
                animation: animation
            });
        }
    });
    const updateScrollButtonState = (0, $7be483edbed3b474$var$_useEventCallback.default)(()=>{
        if (scrollable && scrollButtons !== false) setUpdateScrollObserver(!updateScrollObserver);
    });
    $7be483edbed3b474$var$React.useEffect(()=>{
        const handleResize = (0, $7be483edbed3b474$var$_debounce.default)(()=>{
            // If the Tabs component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/33276
            // TODO: Add tests that will ensure the component is not failing when
            // replaced by Suspense with a fallback, once React is updated to version 18
            if (tabsRef.current) updateIndicatorState();
        });
        let resizeObserver;
        /**
     * @type {MutationCallback}
     */ const handleMutation = (records)=>{
            records.forEach((record)=>{
                record.removedNodes.forEach((item)=>{
                    resizeObserver?.unobserve(item);
                });
                record.addedNodes.forEach((item)=>{
                    resizeObserver?.observe(item);
                });
            });
            handleResize();
            updateScrollButtonState();
        };
        const win = (0, $7be483edbed3b474$var$_ownerWindow.default)(tabsRef.current);
        win.addEventListener('resize', handleResize);
        let mutationObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(handleResize);
            Array.from(tabListRef.current.children).forEach((child)=>{
                resizeObserver.observe(child);
            });
        }
        if (typeof MutationObserver !== 'undefined') {
            mutationObserver = new MutationObserver(handleMutation);
            mutationObserver.observe(tabListRef.current, {
                childList: true
            });
        }
        return ()=>{
            handleResize.clear();
            win.removeEventListener('resize', handleResize);
            mutationObserver?.disconnect();
            resizeObserver?.disconnect();
        };
    }, [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    /**
   * Toggle visibility of start and end scroll buttons
   * Using IntersectionObserver on first and last Tabs.
   */ $7be483edbed3b474$var$React.useEffect(()=>{
        const tabListChildren = Array.from(tabListRef.current.children);
        const length = tabListChildren.length;
        if (typeof IntersectionObserver !== 'undefined' && length > 0 && scrollable && scrollButtons !== false) {
            const firstTab = tabListChildren[0];
            const lastTab = tabListChildren[length - 1];
            const observerOptions = {
                root: tabsRef.current,
                threshold: 0.99
            };
            const handleScrollButtonStart = (entries)=>{
                setDisplayStartScroll(!entries[0].isIntersecting);
            };
            const firstObserver = new IntersectionObserver(handleScrollButtonStart, observerOptions);
            firstObserver.observe(firstTab);
            const handleScrollButtonEnd = (entries)=>{
                setDisplayEndScroll(!entries[0].isIntersecting);
            };
            const lastObserver = new IntersectionObserver(handleScrollButtonEnd, observerOptions);
            lastObserver.observe(lastTab);
            return ()=>{
                firstObserver.disconnect();
                lastObserver.disconnect();
            };
        }
        return undefined;
    }, [
        scrollable,
        scrollButtons,
        updateScrollObserver,
        childrenProp?.length
    ]);
    $7be483edbed3b474$var$React.useEffect(()=>{
        setMounted(true);
    }, []);
    $7be483edbed3b474$var$React.useEffect(()=>{
        updateIndicatorState();
    });
    $7be483edbed3b474$var$React.useEffect(()=>{
        // Don't animate on the first render.
        scrollSelectedIntoView($7be483edbed3b474$var$defaultIndicatorStyle !== indicatorStyle);
    }, [
        scrollSelectedIntoView,
        indicatorStyle
    ]);
    $7be483edbed3b474$var$React.useImperativeHandle(action, ()=>({
            updateIndicator: updateIndicatorState,
            updateScrollButtons: updateScrollButtonState
        }), [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    const [IndicatorSlot, indicatorSlotProps] = (0, $7be483edbed3b474$var$_useSlot.default)('indicator', {
        className: (0, $7be483edbed3b474$var$_clsx.default)(classes.indicator, TabIndicatorProps.className),
        elementType: $7be483edbed3b474$var$TabsIndicator,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            style: indicatorStyle
        }
    });
    const indicator = /*#__PURE__*/ (0, $ayMG0.jsx)(IndicatorSlot, {
        ...indicatorSlotProps
    });
    let childIndex = 0;
    const children = $7be483edbed3b474$var$React.Children.map(childrenProp, (child)=>{
        if (!/*#__PURE__*/ $7be483edbed3b474$var$React.isValidElement(child)) return null;
        if ((0, $4jPKB.isFragment)(child)) console.error([
            "MUI: The Tabs component doesn't accept a Fragment as a child.",
            'Consider providing an array instead.'
        ].join('\n'));
        const childValue = child.props.value === undefined ? childIndex : child.props.value;
        valueToIndex.set(childValue, childIndex);
        const selected = childValue === value;
        childIndex += 1;
        return /*#__PURE__*/ $7be483edbed3b474$var$React.cloneElement(child, {
            fullWidth: variant === 'fullWidth',
            indicator: selected && !mounted && indicator,
            selected: selected,
            selectionFollowsFocus: selectionFollowsFocus,
            onChange: onChange,
            textColor: textColor,
            value: childValue,
            ...childIndex === 1 && value === false && !child.props.tabIndex ? {
                tabIndex: 0
            } : {}
        });
    });
    const handleKeyDown = (event)=>{
        // Check if a modifier key (Alt, Shift, Ctrl, Meta) is pressed
        if (event.altKey || event.shiftKey || event.ctrlKey || event.metaKey) return;
        const list = tabListRef.current;
        const currentFocus = (0, $7be483edbed3b474$var$_getActiveElement.default)((0, $7be483edbed3b474$var$_ownerDocument.default)(list));
        // Keyboard navigation assumes that [role="tab"] are siblings
        // though we might warn in the future about nested, interactive elements
        // as a a11y violation
        const role = currentFocus?.getAttribute('role');
        if (role !== 'tab') return;
        let previousItemKey = orientation === 'horizontal' ? 'ArrowLeft' : 'ArrowUp';
        let nextItemKey = orientation === 'horizontal' ? 'ArrowRight' : 'ArrowDown';
        if (orientation === 'horizontal' && isRtl) {
            // swap previousItemKey with nextItemKey
            previousItemKey = 'ArrowRight';
            nextItemKey = 'ArrowLeft';
        }
        switch(event.key){
            case previousItemKey:
                event.preventDefault();
                $7be483edbed3b474$var$moveFocus(list, currentFocus, $7be483edbed3b474$var$previousItem);
                break;
            case nextItemKey:
                event.preventDefault();
                $7be483edbed3b474$var$moveFocus(list, currentFocus, $7be483edbed3b474$var$nextItem);
                break;
            case 'Home':
                event.preventDefault();
                $7be483edbed3b474$var$moveFocus(list, null, $7be483edbed3b474$var$nextItem);
                break;
            case 'End':
                event.preventDefault();
                $7be483edbed3b474$var$moveFocus(list, null, $7be483edbed3b474$var$previousItem);
                break;
            default:
                break;
        }
    };
    const conditionalElements = getConditionalElements();
    const [RootSlot, rootSlotProps] = (0, $7be483edbed3b474$var$_useSlot.default)('root', {
        ref: ref,
        className: (0, $7be483edbed3b474$var$_clsx.default)(classes.root, className),
        elementType: $7be483edbed3b474$var$TabsRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            component: component
        },
        ownerState: ownerState
    });
    const [ScrollerSlot, scrollerSlotProps] = (0, $7be483edbed3b474$var$_useSlot.default)('scroller', {
        ref: tabsRef,
        className: classes.scroller,
        elementType: $7be483edbed3b474$var$TabsScroller,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            style: {
                overflow: scrollerStyle.overflow,
                [vertical ? `margin${isRtl ? 'Left' : 'Right'}` : 'marginBottom']: visibleScrollbar ? undefined : -scrollerStyle.scrollbarWidth
            }
        }
    });
    const [ListSlot, listSlotProps] = (0, $7be483edbed3b474$var$_useSlot.default)('list', {
        ref: tabListRef,
        className: (0, $7be483edbed3b474$var$_clsx.default)(classes.list, classes.flexContainer),
        elementType: $7be483edbed3b474$var$List,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        getSlotProps: (handlers)=>({
                ...handlers,
                onKeyDown: (event)=>{
                    handleKeyDown(event);
                    handlers.onKeyDown?.(event);
                }
            })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            conditionalElements.scrollButtonStart,
            conditionalElements.scrollbarSizeListener,
            /*#__PURE__*/ (0, $ayMG0.jsxs)(ScrollerSlot, {
                ...scrollerSlotProps,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)(ListSlot, {
                        "aria-label": ariaLabel,
                        "aria-labelledby": ariaLabelledBy,
                        "aria-orientation": orientation === 'vertical' ? 'vertical' : null,
                        role: "tablist",
                        ...listSlotProps,
                        children: children
                    }),
                    mounted && indicator
                ]
            }),
            conditionalElements.scrollButtonEnd
        ]
    });
});
$7be483edbed3b474$var$Tabs.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Callback fired when the component mounts.
   * This is useful when you want to trigger an action programmatically.
   * It supports two actions: `updateIndicator()` and `updateScrollButtons()`
   *
   * @param {object} actions This object contains all possible actions
   * that can be triggered programmatically.
   */ action: $7be483edbed3b474$var$_refType.default,
    /**
   * If `true`, the scroll buttons aren't forced hidden on mobile.
   * By default the scroll buttons are hidden on mobile and takes precedence over `scrollButtons`.
   * @default false
   */ allowScrollButtonsMobile: $7be483edbed3b474$var$_propTypes.default.bool,
    /**
   * The label for the Tabs as a string.
   */ 'aria-label': $7be483edbed3b474$var$_propTypes.default.string,
    /**
   * An id or list of ids separated by a space that label the Tabs.
   */ 'aria-labelledby': $7be483edbed3b474$var$_propTypes.default.string,
    /**
   * If `true`, the tabs are centered.
   * This prop is intended for large views.
   * @default false
   */ centered: $7be483edbed3b474$var$_propTypes.default.bool,
    /**
   * The content of the component.
   */ children: $7be483edbed3b474$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $7be483edbed3b474$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $7be483edbed3b474$var$_propTypes.default.string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $7be483edbed3b474$var$_propTypes.default.elementType,
    /**
   * Determines the color of the indicator.
   * @default 'primary'
   */ indicatorColor: $7be483edbed3b474$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $7be483edbed3b474$var$_propTypes.default.oneOf([
            'primary',
            'secondary'
        ]),
        $7be483edbed3b474$var$_propTypes.default.string
    ]),
    /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {any} value We default to the index of the child (number)
   */ onChange: $7be483edbed3b474$var$_propTypes.default.func,
    /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */ orientation: $7be483edbed3b474$var$_propTypes.default.oneOf([
        'horizontal',
        'vertical'
    ]),
    /**
   * The component used to render the scroll buttons.
   * @deprecated use the `slots.scrollButtons` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default TabScrollButton
   */ ScrollButtonComponent: $7be483edbed3b474$var$_propTypes.default.elementType,
    /**
   * Determine behavior of scroll buttons when tabs are set to scroll:
   *
   * - `auto` will only present them when not all the items are visible.
   * - `true` will always present them.
   * - `false` will never present them.
   *
   * By default the scroll buttons are hidden on mobile.
   * This behavior can be disabled with `allowScrollButtonsMobile`.
   * @default 'auto'
   */ scrollButtons: $7be483edbed3b474$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOf([
        'auto',
        false,
        true
    ]),
    /**
   * If `true` the selected tab changes on focus. Otherwise it only
   * changes on activation.
   */ selectionFollowsFocus: $7be483edbed3b474$var$_propTypes.default.bool,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $7be483edbed3b474$var$_propTypes.default.shape({
        endScrollButtonIcon: $7be483edbed3b474$var$_propTypes.default.oneOfType([
            $7be483edbed3b474$var$_propTypes.default.func,
            $7be483edbed3b474$var$_propTypes.default.object
        ]),
        indicator: $7be483edbed3b474$var$_propTypes.default.oneOfType([
            $7be483edbed3b474$var$_propTypes.default.func,
            $7be483edbed3b474$var$_propTypes.default.object
        ]),
        list: $7be483edbed3b474$var$_propTypes.default.oneOfType([
            $7be483edbed3b474$var$_propTypes.default.func,
            $7be483edbed3b474$var$_propTypes.default.object
        ]),
        root: $7be483edbed3b474$var$_propTypes.default.oneOfType([
            $7be483edbed3b474$var$_propTypes.default.func,
            $7be483edbed3b474$var$_propTypes.default.object
        ]),
        scrollbar: $7be483edbed3b474$var$_propTypes.default.oneOfType([
            $7be483edbed3b474$var$_propTypes.default.func,
            $7be483edbed3b474$var$_propTypes.default.object
        ]),
        scrollButtons: $7be483edbed3b474$var$_propTypes.default.oneOfType([
            $7be483edbed3b474$var$_propTypes.default.func,
            $7be483edbed3b474$var$_propTypes.default.object
        ]),
        scroller: $7be483edbed3b474$var$_propTypes.default.oneOfType([
            $7be483edbed3b474$var$_propTypes.default.func,
            $7be483edbed3b474$var$_propTypes.default.object
        ]),
        startScrollButtonIcon: $7be483edbed3b474$var$_propTypes.default.oneOfType([
            $7be483edbed3b474$var$_propTypes.default.func,
            $7be483edbed3b474$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: $7be483edbed3b474$var$_propTypes.default.shape({
        endScrollButtonIcon: $7be483edbed3b474$var$_propTypes.default.elementType,
        EndScrollButtonIcon: $7be483edbed3b474$var$_propTypes.default.elementType,
        indicator: $7be483edbed3b474$var$_propTypes.default.elementType,
        list: $7be483edbed3b474$var$_propTypes.default.elementType,
        root: $7be483edbed3b474$var$_propTypes.default.elementType,
        scrollbar: $7be483edbed3b474$var$_propTypes.default.elementType,
        scrollButtons: $7be483edbed3b474$var$_propTypes.default.elementType,
        scroller: $7be483edbed3b474$var$_propTypes.default.elementType,
        startScrollButtonIcon: $7be483edbed3b474$var$_propTypes.default.elementType,
        StartScrollButtonIcon: $7be483edbed3b474$var$_propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $7be483edbed3b474$var$_propTypes.default.oneOfType([
        $7be483edbed3b474$var$_propTypes.default.arrayOf($7be483edbed3b474$var$_propTypes.default.oneOfType([
            $7be483edbed3b474$var$_propTypes.default.func,
            $7be483edbed3b474$var$_propTypes.default.object,
            $7be483edbed3b474$var$_propTypes.default.bool
        ])),
        $7be483edbed3b474$var$_propTypes.default.func,
        $7be483edbed3b474$var$_propTypes.default.object
    ]),
    /**
   * Props applied to the tab indicator element.
   * @deprecated use the `slotProps.indicator` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default  {}
   */ TabIndicatorProps: $7be483edbed3b474$var$_propTypes.default.object,
    /**
   * Props applied to the [`TabScrollButton`](https://mui.com/material-ui/api/tab-scroll-button/) element.
   * @deprecated use the `slotProps.scrollButtons` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */ TabScrollButtonProps: $7be483edbed3b474$var$_propTypes.default.object,
    /**
   * Determines the color of the `Tab`.
   * @default 'primary'
   */ textColor: $7be483edbed3b474$var$_propTypes.default.oneOf([
        'inherit',
        'primary',
        'secondary'
    ]),
    /**
   * The value of the currently selected `Tab`.
   * If you don't want any selected `Tab`, you can set this prop to `false`.
   */ value: $7be483edbed3b474$var$_propTypes.default.any,
    /**
   * Determines additional display behavior of the tabs:
   *
   *  - `scrollable` will invoke scrolling properties and allow for horizontally
   *  scrolling (or swiping) of the tab bar.
   *  - `fullWidth` will make the tabs grow to use all the available space,
   *  which should be used for small views, like on mobile.
   *  - `standard` will render the default state.
   * @default 'standard'
   */ variant: $7be483edbed3b474$var$_propTypes.default.oneOf([
        'fullWidth',
        'scrollable',
        'standard'
    ]),
    /**
   * If `true`, the scrollbar is visible. It can be useful when displaying
   * a long vertical list of tabs.
   * @default false
   */ visibleScrollbar: $7be483edbed3b474$var$_propTypes.default.bool
};
var $7be483edbed3b474$var$_default = module.exports.default = $7be483edbed3b474$var$Tabs;

});
parcelRegister("kRsYK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f2ff3c73ed46b37c$var$animate;
function $f2ff3c73ed46b37c$var$easeInOutSin(time) {
    return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}
function $f2ff3c73ed46b37c$var$animate(property, element, to, options = {}, cb = ()=>{}) {
    const { ease: ease = $f2ff3c73ed46b37c$var$easeInOutSin, duration: duration = 300 // standard
     } = options;
    let start = null;
    const from = element[property];
    let cancelled = false;
    const cancel = ()=>{
        cancelled = true;
    };
    const step = (timestamp)=>{
        if (cancelled) {
            cb(new Error('Animation cancelled'));
            return;
        }
        if (start === null) start = timestamp;
        const time = Math.min(1, (timestamp - start) / duration);
        element[property] = ease(time) * (to - from) + from;
        if (time >= 1) {
            requestAnimationFrame(()=>{
                cb(null);
            });
            return;
        }
        requestAnimationFrame(step);
    };
    if (from === to) {
        cb(new Error('Element already at target position'));
        return cancel;
    }
    requestAnimationFrame(step);
    return cancel;
}

});

parcelRegister("l0ZbI", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $f4c90fbbf54d23af$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $f4c90fbbf54d23af$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f4c90fbbf54d23af$var$ScrollbarSize;

var $f4c90fbbf54d23af$var$React = $f4c90fbbf54d23af$require$_interopRequireWildcard((parcelRequire("acw62")));

var $f4c90fbbf54d23af$var$_propTypes = $f4c90fbbf54d23af$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $f4c90fbbf54d23af$var$_debounce = $f4c90fbbf54d23af$require$_interopRequireDefault((parcelRequire("1iGrQ")));

var $hGPki = parcelRequire("hGPki");

var $ayMG0 = parcelRequire("ayMG0");
const $f4c90fbbf54d23af$var$styles = {
    width: 99,
    height: 99,
    position: 'absolute',
    top: -9999,
    overflow: 'scroll'
};
/**
 * @ignore - internal component.
 * The component originates from https://github.com/STORIS/react-scrollbar-size.
 * It has been moved into the core in order to minimize the bundle size.
 */ function $f4c90fbbf54d23af$var$ScrollbarSize(props) {
    const { onChange: onChange, ...other } = props;
    const scrollbarHeight = $f4c90fbbf54d23af$var$React.useRef();
    const nodeRef = $f4c90fbbf54d23af$var$React.useRef(null);
    const setMeasurements = ()=>{
        scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
    };
    (0, $hGPki.unstable_useEnhancedEffect)(()=>{
        const handleResize = (0, $f4c90fbbf54d23af$var$_debounce.default)(()=>{
            const prevHeight = scrollbarHeight.current;
            setMeasurements();
            if (prevHeight !== scrollbarHeight.current) onChange(scrollbarHeight.current);
        });
        const containerWindow = (0, $hGPki.ownerWindow)(nodeRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        onChange
    ]);
    $f4c90fbbf54d23af$var$React.useEffect(()=>{
        setMeasurements();
        onChange(scrollbarHeight.current);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: $f4c90fbbf54d23af$var$styles,
        ...other,
        ref: nodeRef
    });
}
$f4c90fbbf54d23af$var$ScrollbarSize.propTypes = {
    onChange: $f4c90fbbf54d23af$var$_propTypes.default.func.isRequired
};

});

parcelRegister("b1hEL", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $805d7bedd393d559$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $805d7bedd393d559$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $805d7bedd393d559$var$_exportNames = {
    tabScrollButtonClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $805d7bedd393d559$var$_TabScrollButton.default;
    }
});
Object.defineProperty(module.exports, "tabScrollButtonClasses", {
    enumerable: true,
    get: function() {
        return $805d7bedd393d559$var$_tabScrollButtonClasses.default;
    }
});

var $805d7bedd393d559$var$_TabScrollButton = $805d7bedd393d559$require$_interopRequireDefault((parcelRequire("dz5QO")));

var $805d7bedd393d559$var$_tabScrollButtonClasses = $805d7bedd393d559$require$_interopRequireWildcard((parcelRequire("4CguH")));
Object.keys($805d7bedd393d559$var$_tabScrollButtonClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($805d7bedd393d559$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $805d7bedd393d559$var$_tabScrollButtonClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $805d7bedd393d559$var$_tabScrollButtonClasses[key];
        }
    });
});

});
parcelRegister("dz5QO", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $9e031514df70ea8e$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $9e031514df70ea8e$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9e031514df70ea8e$var$React = $9e031514df70ea8e$require$_interopRequireWildcard((parcelRequire("acw62")));

var $9e031514df70ea8e$var$_propTypes = $9e031514df70ea8e$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $9e031514df70ea8e$var$_clsx = $9e031514df70ea8e$require$_interopRequireDefault((parcelRequire("9QePP")));

var $9e031514df70ea8e$var$_composeClasses = $9e031514df70ea8e$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $9uEev = parcelRequire("9uEev");

var $9e031514df70ea8e$var$_useSlotProps = $9e031514df70ea8e$require$_interopRequireDefault((parcelRequire("839K0")));

var $9e031514df70ea8e$var$_KeyboardArrowLeft = $9e031514df70ea8e$require$_interopRequireDefault((parcelRequire("frMNQ")));

var $9e031514df70ea8e$var$_KeyboardArrowRight = $9e031514df70ea8e$require$_interopRequireDefault((parcelRequire("f46un")));

var $9e031514df70ea8e$var$_ButtonBase = $9e031514df70ea8e$require$_interopRequireDefault((parcelRequire("hhs3r")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $9e031514df70ea8e$var$_tabScrollButtonClasses = $9e031514df70ea8e$require$_interopRequireWildcard((parcelRequire("4CguH")));

var $ayMG0 = parcelRequire("ayMG0");
const $9e031514df70ea8e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            disabled && 'disabled'
        ]
    };
    return (0, $9e031514df70ea8e$var$_composeClasses.default)(slots, $9e031514df70ea8e$var$_tabScrollButtonClasses.getTabScrollButtonUtilityClass, classes);
};
const $9e031514df70ea8e$var$TabScrollButtonRoot = (0, $aAbgT.styled)($9e031514df70ea8e$var$_ButtonBase.default, {
    name: 'MuiTabScrollButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.orientation && styles[ownerState.orientation]
        ];
    }
})({
    width: 40,
    flexShrink: 0,
    opacity: 0.8,
    [`&.${$9e031514df70ea8e$var$_tabScrollButtonClasses.default.disabled}`]: {
        opacity: 0
    },
    variants: [
        {
            props: {
                orientation: 'vertical'
            },
            style: {
                width: '100%',
                height: 40,
                '& svg': {
                    transform: 'var(--TabScrollButton-svgRotate)'
                }
            }
        }
    ]
});
const $9e031514df70ea8e$var$TabScrollButton = /*#__PURE__*/ $9e031514df70ea8e$var$React.forwardRef(function TabScrollButton(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiTabScrollButton'
    });
    const { className: className, slots: slots = {}, slotProps: slotProps = {}, direction: direction, orientation: orientation, disabled: disabled, ...other } = props;
    const isRtl = (0, $9uEev.useRtl)();
    const ownerState = {
        isRtl: isRtl,
        ...props
    };
    const classes = $9e031514df70ea8e$var$useUtilityClasses(ownerState);
    const StartButtonIcon = slots.StartScrollButtonIcon ?? $9e031514df70ea8e$var$_KeyboardArrowLeft.default;
    const EndButtonIcon = slots.EndScrollButtonIcon ?? $9e031514df70ea8e$var$_KeyboardArrowRight.default;
    const startButtonIconProps = (0, $9e031514df70ea8e$var$_useSlotProps.default)({
        elementType: StartButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    const endButtonIconProps = (0, $9e031514df70ea8e$var$_useSlotProps.default)({
        elementType: EndButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($9e031514df70ea8e$var$TabScrollButtonRoot, {
        component: "div",
        className: (0, $9e031514df70ea8e$var$_clsx.default)(classes.root, className),
        ref: ref,
        role: null,
        ownerState: ownerState,
        tabIndex: null,
        ...other,
        style: {
            ...other.style,
            ...orientation === 'vertical' && {
                '--TabScrollButton-svgRotate': `rotate(${isRtl ? -90 : 90}deg)`
            }
        },
        children: direction === 'left' ? /*#__PURE__*/ (0, $ayMG0.jsx)(StartButtonIcon, {
            ...startButtonIconProps
        }) : /*#__PURE__*/ (0, $ayMG0.jsx)(EndButtonIcon, {
            ...endButtonIconProps
        })
    });
});
$9e031514df70ea8e$var$TabScrollButton.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: $9e031514df70ea8e$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $9e031514df70ea8e$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $9e031514df70ea8e$var$_propTypes.default.string,
    /**
   * The direction the button should indicate.
   */ direction: $9e031514df70ea8e$var$_propTypes.default.oneOf([
        'left',
        'right'
    ]).isRequired,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: $9e031514df70ea8e$var$_propTypes.default.bool,
    /**
   * The component orientation (layout flow direction).
   */ orientation: $9e031514df70ea8e$var$_propTypes.default.oneOf([
        'horizontal',
        'vertical'
    ]).isRequired,
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   * @default {}
   */ slotProps: $9e031514df70ea8e$var$_propTypes.default.shape({
        endScrollButtonIcon: $9e031514df70ea8e$var$_propTypes.default.oneOfType([
            $9e031514df70ea8e$var$_propTypes.default.func,
            $9e031514df70ea8e$var$_propTypes.default.object
        ]),
        startScrollButtonIcon: $9e031514df70ea8e$var$_propTypes.default.oneOfType([
            $9e031514df70ea8e$var$_propTypes.default.func,
            $9e031514df70ea8e$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: $9e031514df70ea8e$var$_propTypes.default.shape({
        EndScrollButtonIcon: $9e031514df70ea8e$var$_propTypes.default.elementType,
        StartScrollButtonIcon: $9e031514df70ea8e$var$_propTypes.default.elementType
    }),
    /**
   * @ignore
   */ style: $9e031514df70ea8e$var$_propTypes.default.object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $9e031514df70ea8e$var$_propTypes.default.oneOfType([
        $9e031514df70ea8e$var$_propTypes.default.arrayOf($9e031514df70ea8e$var$_propTypes.default.oneOfType([
            $9e031514df70ea8e$var$_propTypes.default.func,
            $9e031514df70ea8e$var$_propTypes.default.object,
            $9e031514df70ea8e$var$_propTypes.default.bool
        ])),
        $9e031514df70ea8e$var$_propTypes.default.func,
        $9e031514df70ea8e$var$_propTypes.default.object
    ])
};
var $9e031514df70ea8e$var$_default = module.exports.default = $9e031514df70ea8e$var$TabScrollButton;

});
parcelRegister("4CguH", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $35c7816ebadb07c9$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getTabScrollButtonUtilityClass = $35c7816ebadb07c9$var$getTabScrollButtonUtilityClass;

var $35c7816ebadb07c9$var$_generateUtilityClasses = $35c7816ebadb07c9$require$_interopRequireDefault((parcelRequire("5nY49")));

var $35c7816ebadb07c9$var$_generateUtilityClass = $35c7816ebadb07c9$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $35c7816ebadb07c9$var$getTabScrollButtonUtilityClass(slot) {
    return (0, $35c7816ebadb07c9$var$_generateUtilityClass.default)('MuiTabScrollButton', slot);
}
const $35c7816ebadb07c9$var$tabScrollButtonClasses = (0, $35c7816ebadb07c9$var$_generateUtilityClasses.default)('MuiTabScrollButton', [
    'root',
    'vertical',
    'horizontal',
    'disabled'
]);
var $35c7816ebadb07c9$var$_default = module.exports.default = $35c7816ebadb07c9$var$tabScrollButtonClasses;

});



parcelRegister("bTm2Q", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $8a85ee70c626268d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getTabsUtilityClass = $8a85ee70c626268d$var$getTabsUtilityClass;

var $8a85ee70c626268d$var$_generateUtilityClasses = $8a85ee70c626268d$require$_interopRequireDefault((parcelRequire("5nY49")));

var $8a85ee70c626268d$var$_generateUtilityClass = $8a85ee70c626268d$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $8a85ee70c626268d$var$getTabsUtilityClass(slot) {
    return (0, $8a85ee70c626268d$var$_generateUtilityClass.default)('MuiTabs', slot);
}
const $8a85ee70c626268d$var$tabsClasses = (0, $8a85ee70c626268d$var$_generateUtilityClasses.default)('MuiTabs', [
    'root',
    'vertical',
    'list',
    'flexContainer',
    'flexContainerVertical',
    'centered',
    'scroller',
    'fixed',
    'scrollableX',
    'scrollableY',
    'hideScrollbar',
    'scrollButtons',
    'scrollButtonsHideMobile',
    'indicator'
]);
var $8a85ee70c626268d$var$_default = module.exports.default = $8a85ee70c626268d$var$tabsClasses;

});



parcelRegister("90blG", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $68dceac9a9a56312$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $68dceac9a9a56312$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $68dceac9a9a56312$var$_exportNames = {
    tabClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $68dceac9a9a56312$var$_Tab.default;
    }
});
Object.defineProperty(module.exports, "tabClasses", {
    enumerable: true,
    get: function() {
        return $68dceac9a9a56312$var$_tabClasses.default;
    }
});

var $68dceac9a9a56312$var$_Tab = $68dceac9a9a56312$require$_interopRequireDefault((parcelRequire("jNGAr")));

var $68dceac9a9a56312$var$_tabClasses = $68dceac9a9a56312$require$_interopRequireWildcard((parcelRequire("jHfLJ")));
Object.keys($68dceac9a9a56312$var$_tabClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($68dceac9a9a56312$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $68dceac9a9a56312$var$_tabClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $68dceac9a9a56312$var$_tabClasses[key];
        }
    });
});

});
parcelRegister("jNGAr", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $e6a3a0c577f6eee9$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $e6a3a0c577f6eee9$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e6a3a0c577f6eee9$var$React = $e6a3a0c577f6eee9$require$_interopRequireWildcard((parcelRequire("acw62")));

var $e6a3a0c577f6eee9$var$_propTypes = $e6a3a0c577f6eee9$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $e6a3a0c577f6eee9$var$_clsx = $e6a3a0c577f6eee9$require$_interopRequireDefault((parcelRequire("9QePP")));

var $e6a3a0c577f6eee9$var$_composeClasses = $e6a3a0c577f6eee9$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $e6a3a0c577f6eee9$var$_ButtonBase = $e6a3a0c577f6eee9$require$_interopRequireDefault((parcelRequire("hhs3r")));

var $e6a3a0c577f6eee9$var$_capitalize = $e6a3a0c577f6eee9$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $aAbgT = parcelRequire("aAbgT");

var $e6a3a0c577f6eee9$var$_memoTheme = $e6a3a0c577f6eee9$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $e6a3a0c577f6eee9$var$_unsupportedProp = $e6a3a0c577f6eee9$require$_interopRequireDefault((parcelRequire("gUzNi")));

var $e6a3a0c577f6eee9$var$_tabClasses = $e6a3a0c577f6eee9$require$_interopRequireWildcard((parcelRequire("jHfLJ")));

var $ayMG0 = parcelRequire("ayMG0");
const $e6a3a0c577f6eee9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, textColor: textColor, fullWidth: fullWidth, wrapped: wrapped, icon: icon, label: label, selected: selected, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            icon && label && 'labelIcon',
            `textColor${(0, $e6a3a0c577f6eee9$var$_capitalize.default)(textColor)}`,
            fullWidth && 'fullWidth',
            wrapped && 'wrapped',
            selected && 'selected',
            disabled && 'disabled'
        ],
        icon: [
            'iconWrapper',
            'icon'
        ]
    };
    return (0, $e6a3a0c577f6eee9$var$_composeClasses.default)(slots, $e6a3a0c577f6eee9$var$_tabClasses.getTabUtilityClass, classes);
};
const $e6a3a0c577f6eee9$var$TabRoot = (0, $aAbgT.styled)($e6a3a0c577f6eee9$var$_ButtonBase.default, {
    name: 'MuiTab',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.label && ownerState.icon && styles.labelIcon,
            styles[`textColor${(0, $e6a3a0c577f6eee9$var$_capitalize.default)(ownerState.textColor)}`],
            ownerState.fullWidth && styles.fullWidth,
            ownerState.wrapped && styles.wrapped,
            {
                [`& .${$e6a3a0c577f6eee9$var$_tabClasses.default.iconWrapper}`]: styles.iconWrapper
            },
            {
                [`& .${$e6a3a0c577f6eee9$var$_tabClasses.default.icon}`]: styles.icon
            }
        ];
    }
})((0, $e6a3a0c577f6eee9$var$_memoTheme.default)(({ theme: theme })=>({
        ...theme.typography.button,
        maxWidth: 360,
        minWidth: 90,
        position: 'relative',
        minHeight: 48,
        flexShrink: 0,
        padding: '12px 16px',
        overflow: 'hidden',
        whiteSpace: 'normal',
        textAlign: 'center',
        lineHeight: 1.25,
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.label && (ownerState.iconPosition === 'top' || ownerState.iconPosition === 'bottom'),
                style: {
                    flexDirection: 'column'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.label && ownerState.iconPosition !== 'top' && ownerState.iconPosition !== 'bottom',
                style: {
                    flexDirection: 'row'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.icon && ownerState.label,
                style: {
                    minHeight: 72,
                    paddingTop: 9,
                    paddingBottom: 9
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'top',
                style: {
                    [`& > .${$e6a3a0c577f6eee9$var$_tabClasses.default.icon}`]: {
                        marginBottom: 6
                    }
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'bottom',
                style: {
                    [`& > .${$e6a3a0c577f6eee9$var$_tabClasses.default.icon}`]: {
                        marginTop: 6
                    }
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'start',
                style: {
                    [`& > .${$e6a3a0c577f6eee9$var$_tabClasses.default.icon}`]: {
                        marginRight: theme.spacing(1)
                    }
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'end',
                style: {
                    [`& > .${$e6a3a0c577f6eee9$var$_tabClasses.default.icon}`]: {
                        marginLeft: theme.spacing(1)
                    }
                }
            },
            {
                props: {
                    textColor: 'inherit'
                },
                style: {
                    color: 'inherit',
                    opacity: 0.6,
                    // same opacity as theme.palette.text.secondary
                    [`&.${$e6a3a0c577f6eee9$var$_tabClasses.default.selected}`]: {
                        opacity: 1
                    },
                    [`&.${$e6a3a0c577f6eee9$var$_tabClasses.default.disabled}`]: {
                        opacity: (theme.vars || theme).palette.action.disabledOpacity
                    }
                }
            },
            {
                props: {
                    textColor: 'primary'
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary,
                    [`&.${$e6a3a0c577f6eee9$var$_tabClasses.default.selected}`]: {
                        color: (theme.vars || theme).palette.primary.main
                    },
                    [`&.${$e6a3a0c577f6eee9$var$_tabClasses.default.disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    }
                }
            },
            {
                props: {
                    textColor: 'secondary'
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary,
                    [`&.${$e6a3a0c577f6eee9$var$_tabClasses.default.selected}`]: {
                        color: (theme.vars || theme).palette.secondary.main
                    },
                    [`&.${$e6a3a0c577f6eee9$var$_tabClasses.default.disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    flexShrink: 1,
                    flexGrow: 1,
                    flexBasis: 0,
                    maxWidth: 'none'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.wrapped,
                style: {
                    fontSize: theme.typography.pxToRem(12)
                }
            }
        ]
    })));
const $e6a3a0c577f6eee9$var$Tab = /*#__PURE__*/ $e6a3a0c577f6eee9$var$React.forwardRef(function Tab(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiTab'
    });
    const { className: className, disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: // eslint-disable-next-line react/prop-types
    fullWidth, icon: iconProp, iconPosition: iconPosition = 'top', indicator: // eslint-disable-next-line react/prop-types
    indicator, label: label, onChange: onChange, onClick: onClick, onFocus: onFocus, selected: // eslint-disable-next-line react/prop-types
    selected, selectionFollowsFocus: // eslint-disable-next-line react/prop-types
    selectionFollowsFocus, textColor: // eslint-disable-next-line react/prop-types
    textColor = 'inherit', value: value, wrapped: wrapped = false, ...other } = props;
    const ownerState = {
        ...props,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        selected: selected,
        icon: !!iconProp,
        iconPosition: iconPosition,
        label: !!label,
        fullWidth: fullWidth,
        textColor: textColor,
        wrapped: wrapped
    };
    const classes = $e6a3a0c577f6eee9$var$useUtilityClasses(ownerState);
    const icon = iconProp && label && /*#__PURE__*/ $e6a3a0c577f6eee9$var$React.isValidElement(iconProp) ? /*#__PURE__*/ $e6a3a0c577f6eee9$var$React.cloneElement(iconProp, {
        className: (0, $e6a3a0c577f6eee9$var$_clsx.default)(classes.icon, iconProp.props.className)
    }) : iconProp;
    const handleClick = (event)=>{
        if (!selected && onChange) onChange(event, value);
        if (onClick) onClick(event);
    };
    const handleFocus = (event)=>{
        if (selectionFollowsFocus && !selected && onChange) onChange(event, value);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($e6a3a0c577f6eee9$var$TabRoot, {
        focusRipple: !disableFocusRipple,
        className: (0, $e6a3a0c577f6eee9$var$_clsx.default)(classes.root, className),
        ref: ref,
        role: "tab",
        "aria-selected": selected,
        disabled: disabled,
        onClick: handleClick,
        onFocus: handleFocus,
        ownerState: ownerState,
        tabIndex: selected ? 0 : -1,
        ...other,
        children: [
            iconPosition === 'top' || iconPosition === 'start' ? /*#__PURE__*/ (0, $ayMG0.jsxs)($e6a3a0c577f6eee9$var$React.Fragment, {
                children: [
                    icon,
                    label
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($e6a3a0c577f6eee9$var$React.Fragment, {
                children: [
                    label,
                    icon
                ]
            }),
            indicator
        ]
    });
});
$e6a3a0c577f6eee9$var$Tab.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */ children: $e6a3a0c577f6eee9$var$_unsupportedProp.default,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $e6a3a0c577f6eee9$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $e6a3a0c577f6eee9$var$_propTypes.default.string,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: $e6a3a0c577f6eee9$var$_propTypes.default.bool,
    /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */ disableFocusRipple: $e6a3a0c577f6eee9$var$_propTypes.default.bool,
    /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */ disableRipple: $e6a3a0c577f6eee9$var$_propTypes.default.bool,
    /**
   * The icon to display.
   */ icon: $e6a3a0c577f6eee9$var$_propTypes.default.oneOfType([
        $e6a3a0c577f6eee9$var$_propTypes.default.element,
        $e6a3a0c577f6eee9$var$_propTypes.default.string
    ]),
    /**
   * The position of the icon relative to the label.
   * @default 'top'
   */ iconPosition: $e6a3a0c577f6eee9$var$_propTypes.default.oneOf([
        'bottom',
        'end',
        'start',
        'top'
    ]),
    /**
   * The label element.
   */ label: $e6a3a0c577f6eee9$var$_propTypes.default.node,
    /**
   * @ignore
   */ onChange: $e6a3a0c577f6eee9$var$_propTypes.default.func,
    /**
   * @ignore
   */ onClick: $e6a3a0c577f6eee9$var$_propTypes.default.func,
    /**
   * @ignore
   */ onFocus: $e6a3a0c577f6eee9$var$_propTypes.default.func,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $e6a3a0c577f6eee9$var$_propTypes.default.oneOfType([
        $e6a3a0c577f6eee9$var$_propTypes.default.arrayOf($e6a3a0c577f6eee9$var$_propTypes.default.oneOfType([
            $e6a3a0c577f6eee9$var$_propTypes.default.func,
            $e6a3a0c577f6eee9$var$_propTypes.default.object,
            $e6a3a0c577f6eee9$var$_propTypes.default.bool
        ])),
        $e6a3a0c577f6eee9$var$_propTypes.default.func,
        $e6a3a0c577f6eee9$var$_propTypes.default.object
    ]),
    /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */ value: $e6a3a0c577f6eee9$var$_propTypes.default.any,
    /**
   * Tab labels appear in a single row.
   * They can use a second line if needed.
   * @default false
   */ wrapped: $e6a3a0c577f6eee9$var$_propTypes.default.bool
};
var $e6a3a0c577f6eee9$var$_default = module.exports.default = $e6a3a0c577f6eee9$var$Tab;

});
parcelRegister("jHfLJ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e56e43dd06ac0faa$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getTabUtilityClass = $e56e43dd06ac0faa$var$getTabUtilityClass;

var $e56e43dd06ac0faa$var$_generateUtilityClasses = $e56e43dd06ac0faa$require$_interopRequireDefault((parcelRequire("5nY49")));

var $e56e43dd06ac0faa$var$_generateUtilityClass = $e56e43dd06ac0faa$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $e56e43dd06ac0faa$var$getTabUtilityClass(slot) {
    return (0, $e56e43dd06ac0faa$var$_generateUtilityClass.default)('MuiTab', slot);
}
const $e56e43dd06ac0faa$var$tabClasses = (0, $e56e43dd06ac0faa$var$_generateUtilityClasses.default)('MuiTab', [
    'root',
    'labelIcon',
    'textColorInherit',
    'textColorPrimary',
    'textColorSecondary',
    'selected',
    'disabled',
    'fullWidth',
    'wrapped',
    'iconWrapper',
    'icon'
]);
var $e56e43dd06ac0faa$var$_default = module.exports.default = $e56e43dd06ac0faa$var$tabClasses;

});



parcelRegister("xwCPt", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $064c63e1ed87913a$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $064c63e1ed87913a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $064c63e1ed87913a$var$_exportNames = {
    toggleButtonClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $064c63e1ed87913a$var$_ToggleButton.default;
    }
});
Object.defineProperty(module.exports, "toggleButtonClasses", {
    enumerable: true,
    get: function() {
        return $064c63e1ed87913a$var$_toggleButtonClasses.default;
    }
});

var $064c63e1ed87913a$var$_ToggleButton = $064c63e1ed87913a$require$_interopRequireDefault((parcelRequire("eJ0JC")));

var $064c63e1ed87913a$var$_toggleButtonClasses = $064c63e1ed87913a$require$_interopRequireWildcard((parcelRequire("3cuAs")));
Object.keys($064c63e1ed87913a$var$_toggleButtonClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($064c63e1ed87913a$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $064c63e1ed87913a$var$_toggleButtonClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $064c63e1ed87913a$var$_toggleButtonClasses[key];
        }
    });
});

});
parcelRegister("eJ0JC", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $ab85d69438d76ec5$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $ab85d69438d76ec5$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ab85d69438d76ec5$var$React = $ab85d69438d76ec5$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ab85d69438d76ec5$var$_propTypes = $ab85d69438d76ec5$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $ab85d69438d76ec5$var$_clsx = $ab85d69438d76ec5$require$_interopRequireDefault((parcelRequire("9QePP")));

var $ab85d69438d76ec5$var$_resolveProps = $ab85d69438d76ec5$require$_interopRequireDefault((parcelRequire("7T9kw")));

var $ab85d69438d76ec5$var$_composeClasses = $ab85d69438d76ec5$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $ab85d69438d76ec5$var$_ButtonBase = $ab85d69438d76ec5$require$_interopRequireDefault((parcelRequire("hhs3r")));

var $ab85d69438d76ec5$var$_capitalize = $ab85d69438d76ec5$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $aAbgT = parcelRequire("aAbgT");

var $ab85d69438d76ec5$var$_memoTheme = $ab85d69438d76ec5$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $ab85d69438d76ec5$var$_createSimplePaletteValueFilter = $ab85d69438d76ec5$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $hL1nr = parcelRequire("hL1nr");

var $ab85d69438d76ec5$var$_toggleButtonClasses = $ab85d69438d76ec5$require$_interopRequireWildcard((parcelRequire("3cuAs")));

var $ab85d69438d76ec5$var$_ToggleButtonGroupContext = $ab85d69438d76ec5$require$_interopRequireDefault((parcelRequire("lOkLt")));

var $ab85d69438d76ec5$var$_ToggleButtonGroupButtonContext = $ab85d69438d76ec5$require$_interopRequireDefault((parcelRequire("jCUp4")));

var $ab85d69438d76ec5$var$_isValueSelected = $ab85d69438d76ec5$require$_interopRequireDefault((parcelRequire("d0d3x")));

var $ayMG0 = parcelRequire("ayMG0");
const $ab85d69438d76ec5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, fullWidth: fullWidth, selected: selected, disabled: disabled, size: size, color: color } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            disabled && 'disabled',
            fullWidth && 'fullWidth',
            `size${(0, $ab85d69438d76ec5$var$_capitalize.default)(size)}`,
            color
        ]
    };
    return (0, $ab85d69438d76ec5$var$_composeClasses.default)(slots, $ab85d69438d76ec5$var$_toggleButtonClasses.getToggleButtonUtilityClass, classes);
};
const $ab85d69438d76ec5$var$ToggleButtonRoot = (0, $aAbgT.styled)($ab85d69438d76ec5$var$_ButtonBase.default, {
    name: 'MuiToggleButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`size${(0, $ab85d69438d76ec5$var$_capitalize.default)(ownerState.size)}`]
        ];
    }
})((0, $ab85d69438d76ec5$var$_memoTheme.default)(({ theme: theme })=>({
        ...theme.typography.button,
        borderRadius: (theme.vars || theme).shape.borderRadius,
        padding: 11,
        border: `1px solid ${(theme.vars || theme).palette.divider}`,
        color: (theme.vars || theme).palette.action.active,
        [`&.${$ab85d69438d76ec5$var$_toggleButtonClasses.default.disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled,
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        },
        '&:hover': {
            textDecoration: 'none',
            // Reset on mouse devices
            backgroundColor: theme.alpha((theme.vars || theme).palette.text.primary, (theme.vars || theme).palette.action.hoverOpacity),
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        variants: [
            {
                props: {
                    color: 'standard'
                },
                style: {
                    [`&.${$ab85d69438d76ec5$var$_toggleButtonClasses.default.selected}`]: {
                        color: (theme.vars || theme).palette.text.primary,
                        backgroundColor: theme.alpha((theme.vars || theme).palette.text.primary, (theme.vars || theme).palette.action.selectedOpacity),
                        '&:hover': {
                            backgroundColor: theme.alpha((theme.vars || theme).palette.text.primary, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`),
                            // Reset on touch devices, it doesn't add specificity
                            '@media (hover: none)': {
                                backgroundColor: theme.alpha((theme.vars || theme).palette.text.primary, (theme.vars || theme).palette.action.selectedOpacity)
                            }
                        }
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $ab85d69438d76ec5$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${$ab85d69438d76ec5$var$_toggleButtonClasses.default.selected}`]: {
                            color: (theme.vars || theme).palette[color].main,
                            backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.selectedOpacity),
                            '&:hover': {
                                backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`),
                                // Reset on touch devices, it doesn't add specificity
                                '@media (hover: none)': {
                                    backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.selectedOpacity)
                                }
                            }
                        }
                    }
                })),
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: 7,
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    padding: 15,
                    fontSize: theme.typography.pxToRem(15)
                }
            }
        ]
    })));
const $ab85d69438d76ec5$var$ToggleButton = /*#__PURE__*/ $ab85d69438d76ec5$var$React.forwardRef(function ToggleButton(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const { value: contextValue, ...contextProps } = $ab85d69438d76ec5$var$React.useContext($ab85d69438d76ec5$var$_ToggleButtonGroupContext.default);
    const toggleButtonGroupButtonContextPositionClassName = $ab85d69438d76ec5$var$React.useContext($ab85d69438d76ec5$var$_ToggleButtonGroupButtonContext.default);
    const resolvedProps = (0, $ab85d69438d76ec5$var$_resolveProps.default)({
        ...contextProps,
        selected: (0, $ab85d69438d76ec5$var$_isValueSelected.default)(inProps.value, contextValue)
    }, inProps);
    const props = (0, $hL1nr.useDefaultProps)({
        props: resolvedProps,
        name: 'MuiToggleButton'
    });
    const { children: children, className: className, color: color = 'standard', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: fullWidth = false, onChange: onChange, onClick: onClick, selected: selected, size: size = 'medium', value: value, ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size
    };
    const classes = $ab85d69438d76ec5$var$useUtilityClasses(ownerState);
    const handleChange = (event)=>{
        if (onClick) {
            onClick(event, value);
            if (event.defaultPrevented) return;
        }
        if (onChange) onChange(event, value);
    };
    const positionClassName = toggleButtonGroupButtonContextPositionClassName || '';
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ab85d69438d76ec5$var$ToggleButtonRoot, {
        className: (0, $ab85d69438d76ec5$var$_clsx.default)(contextProps.className, classes.root, className, positionClassName),
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        ref: ref,
        onClick: handleChange,
        onChange: onChange,
        value: value,
        ownerState: ownerState,
        "aria-pressed": selected,
        ...other,
        children: children
    });
});
$ab85d69438d76ec5$var$ToggleButton.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: $ab85d69438d76ec5$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $ab85d69438d76ec5$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $ab85d69438d76ec5$var$_propTypes.default.string,
    /**
   * The color of the button when it is in an active state.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */ color: $ab85d69438d76ec5$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $ab85d69438d76ec5$var$_propTypes.default.oneOf([
            'standard',
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning'
        ]),
        $ab85d69438d76ec5$var$_propTypes.default.string
    ]),
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: $ab85d69438d76ec5$var$_propTypes.default.bool,
    /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */ disableFocusRipple: $ab85d69438d76ec5$var$_propTypes.default.bool,
    /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */ disableRipple: $ab85d69438d76ec5$var$_propTypes.default.bool,
    /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */ fullWidth: $ab85d69438d76ec5$var$_propTypes.default.bool,
    /**
   * Callback fired when the state changes.
   *
   * @param {React.MouseEvent<HTMLElement>} event The event source of the callback.
   * @param {any} value of the selected button.
   */ onChange: $ab85d69438d76ec5$var$_propTypes.default.func,
    /**
   * Callback fired when the button is clicked.
   *
   * @param {React.MouseEvent<HTMLElement>} event The event source of the callback.
   * @param {any} value of the selected button.
   */ onClick: $ab85d69438d76ec5$var$_propTypes.default.func,
    /**
   * If `true`, the button is rendered in an active state.
   */ selected: $ab85d69438d76ec5$var$_propTypes.default.bool,
    /**
   * The size of the component.
   * The prop defaults to the value inherited from the parent ToggleButtonGroup component.
   * @default 'medium'
   */ size: $ab85d69438d76ec5$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $ab85d69438d76ec5$var$_propTypes.default.oneOf([
            'small',
            'medium',
            'large'
        ]),
        $ab85d69438d76ec5$var$_propTypes.default.string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $ab85d69438d76ec5$var$_propTypes.default.oneOfType([
        $ab85d69438d76ec5$var$_propTypes.default.arrayOf($ab85d69438d76ec5$var$_propTypes.default.oneOfType([
            $ab85d69438d76ec5$var$_propTypes.default.func,
            $ab85d69438d76ec5$var$_propTypes.default.object,
            $ab85d69438d76ec5$var$_propTypes.default.bool
        ])),
        $ab85d69438d76ec5$var$_propTypes.default.func,
        $ab85d69438d76ec5$var$_propTypes.default.object
    ]),
    /**
   * The value to associate with the button when selected in a
   * ToggleButtonGroup.
   */ value: $ab85d69438d76ec5$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .any.isRequired
};
var $ab85d69438d76ec5$var$_default = module.exports.default = $ab85d69438d76ec5$var$ToggleButton;

});
parcelRegister("3cuAs", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $254a3802f36599bb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getToggleButtonUtilityClass = $254a3802f36599bb$var$getToggleButtonUtilityClass;

var $254a3802f36599bb$var$_generateUtilityClasses = $254a3802f36599bb$require$_interopRequireDefault((parcelRequire("5nY49")));

var $254a3802f36599bb$var$_generateUtilityClass = $254a3802f36599bb$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $254a3802f36599bb$var$getToggleButtonUtilityClass(slot) {
    return (0, $254a3802f36599bb$var$_generateUtilityClass.default)('MuiToggleButton', slot);
}
const $254a3802f36599bb$var$toggleButtonClasses = (0, $254a3802f36599bb$var$_generateUtilityClasses.default)('MuiToggleButton', [
    'root',
    'disabled',
    'selected',
    'standard',
    'primary',
    'secondary',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'fullWidth'
]);
var $254a3802f36599bb$var$_default = module.exports.default = $254a3802f36599bb$var$toggleButtonClasses;

});

parcelRegister("lOkLt", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $fe0e5fe90030f3ad$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fe0e5fe90030f3ad$var$React = $fe0e5fe90030f3ad$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * @ignore - internal component.
 */ const $fe0e5fe90030f3ad$var$ToggleButtonGroupContext = /*#__PURE__*/ $fe0e5fe90030f3ad$var$React.createContext({});
$fe0e5fe90030f3ad$var$ToggleButtonGroupContext.displayName = 'ToggleButtonGroupContext';
var $fe0e5fe90030f3ad$var$_default = module.exports.default = $fe0e5fe90030f3ad$var$ToggleButtonGroupContext;

});

parcelRegister("jCUp4", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $e49d517bbbfb7eee$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e49d517bbbfb7eee$var$React = $e49d517bbbfb7eee$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * @ignore - internal component.
 */ const $e49d517bbbfb7eee$var$ToggleButtonGroupButtonContext = /*#__PURE__*/ $e49d517bbbfb7eee$var$React.createContext(undefined);
$e49d517bbbfb7eee$var$ToggleButtonGroupButtonContext.displayName = 'ToggleButtonGroupButtonContext';
var $e49d517bbbfb7eee$var$_default = module.exports.default = $e49d517bbbfb7eee$var$ToggleButtonGroupButtonContext;

});

parcelRegister("d0d3x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9775671ab3ebd2db$var$isValueSelected;
// Determine if the toggle button value matches, or is contained in, the
// candidate group value.
function $9775671ab3ebd2db$var$isValueSelected(value, candidate) {
    if (candidate === undefined || value === undefined) return false;
    if (Array.isArray(candidate)) return candidate.includes(value);
    return value === candidate;
}

});



parcelRegister("fYxgT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $XSDP3 = parcelRequire("XSDP3");
Object.keys($XSDP3).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $XSDP3[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $XSDP3[key];
        }
    });
});

});
parcelRegister("XSDP3", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0b3fe56d0e4918e1$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $0b3fe56d0e4918e1$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.forwardRef = void 0;

var $0b3fe56d0e4918e1$var$React = $0b3fe56d0e4918e1$require$_interopRequireWildcard((parcelRequire("acw62")));

var $0b3fe56d0e4918e1$var$_reactMajor = $0b3fe56d0e4918e1$require$_interopRequireDefault((parcelRequire("eKs5z")));
// Compatibility shim that ensures stable props object for forwardRef components
// Fixes https://github.com/facebook/react/issues/31613
// We ensure that the ref is always present in the props object (even if that's not the case for older versions of React) to avoid the footgun of spreading props over the ref in the newer versions of React.
// Footgun: <Component ref={ref} {...props} /> will break past React 19, but the types will now warn us that we should use <Component {...props} ref={ref} /> instead.
const $0b3fe56d0e4918e1$var$forwardRef = (render)=>{
    if ($0b3fe56d0e4918e1$var$_reactMajor.default >= 19) {
        const Component = (props)=>render(props, props.ref ?? null);
        Component.displayName = render.displayName ?? render.name;
        return Component;
    }
    return /*#__PURE__*/ $0b3fe56d0e4918e1$var$React.forwardRef(render);
};
module.exports.forwardRef = $0b3fe56d0e4918e1$var$forwardRef;
$0b3fe56d0e4918e1$var$forwardRef.displayName = "forwardRef";

});
parcelRegister("eKs5z", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $abcb26696ab6da01$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $abcb26696ab6da01$var$React = $abcb26696ab6da01$require$_interopRequireWildcard((parcelRequire("acw62")));
var $abcb26696ab6da01$var$_default = module.exports.default = parseInt($abcb26696ab6da01$var$React.version, 10);

});



parcelRegister("fWql6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridVisibilityOffIcon = module.exports.GridViewStreamIcon = module.exports.GridViewHeadlineIcon = module.exports.GridViewColumnIcon = module.exports.GridTripleDotsVerticalIcon = module.exports.GridTableRowsIcon = module.exports.GridSeparatorIcon = module.exports.GridSearchIcon = module.exports.GridRemoveIcon = module.exports.GridMoreVertIcon = module.exports.GridMenuIcon = module.exports.GridLoadIcon = module.exports.GridKeyboardArrowRight = module.exports.GridFilterListIcon = module.exports.GridFilterAltIcon = module.exports.GridExpandMoreIcon = module.exports.GridDragIcon = module.exports.GridDownloadIcon = module.exports.GridDeleteIcon = module.exports.GridDeleteForeverIcon = module.exports.GridColumnIcon = module.exports.GridCloseIcon = module.exports.GridClearIcon = module.exports.GridCheckIcon = module.exports.GridCheckCircleIcon = module.exports.GridArrowUpwardIcon = module.exports.GridArrowDownwardIcon = module.exports.GridAddIcon = void 0;

var $c69f0 = parcelRequire("c69f0");

var $ayMG0 = parcelRequire("ayMG0");
const $b9b0b441ce479047$var$GridArrowUpwardIcon = module.exports.GridArrowUpwardIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
}), 'ArrowUpward');
const $b9b0b441ce479047$var$GridArrowDownwardIcon = module.exports.GridArrowDownwardIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), 'ArrowDownward');
const $b9b0b441ce479047$var$GridKeyboardArrowRight = module.exports.GridKeyboardArrowRight = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), 'KeyboardArrowRight');
const $b9b0b441ce479047$var$GridExpandMoreIcon = module.exports.GridExpandMoreIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');
const $b9b0b441ce479047$var$GridFilterListIcon = module.exports.GridFilterListIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
}), 'FilterList');
const $b9b0b441ce479047$var$GridFilterAltIcon = module.exports.GridFilterAltIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M4.25 5.61C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39c.51-.66.04-1.61-.79-1.61H5.04c-.83 0-1.3.95-.79 1.61z"
}), 'FilterAlt');
const $b9b0b441ce479047$var$GridSearchIcon = module.exports.GridSearchIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), 'Search');
const $b9b0b441ce479047$var$GridMenuIcon = module.exports.GridMenuIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
}), 'Menu');
const $b9b0b441ce479047$var$GridCheckCircleIcon = module.exports.GridCheckCircleIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckCircle');
const $b9b0b441ce479047$var$GridColumnIcon = module.exports.GridColumnIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M14.67 5v14H9.33V5zm1 14H21V5h-5.33zm-7.34 0V5H3v14z"
}), 'ColumnIcon');
const $b9b0b441ce479047$var$GridSeparatorIcon = module.exports.GridSeparatorIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
    width: "1",
    height: "24",
    x: "11.5",
    rx: "0.5"
}), 'Separator');
const $b9b0b441ce479047$var$GridViewHeadlineIcon = module.exports.GridViewHeadlineIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z"
}), 'ViewHeadline');
const $b9b0b441ce479047$var$GridTableRowsIcon = module.exports.GridTableRowsIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M21,8H3V4h18V8z M21,10H3v4h18V10z M21,16H3v4h18V16z"
}), 'TableRows');
const $b9b0b441ce479047$var$GridViewStreamIcon = module.exports.GridViewStreamIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M4 18h17v-6H4v6zM4 5v6h17V5H4z"
}), 'ViewStream');
const $b9b0b441ce479047$var$GridTripleDotsVerticalIcon = module.exports.GridTripleDotsVerticalIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'TripleDotsVertical');
const $b9b0b441ce479047$var$GridCloseIcon = module.exports.GridCloseIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');
const $b9b0b441ce479047$var$GridAddIcon = module.exports.GridAddIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), 'Add');
const $b9b0b441ce479047$var$GridRemoveIcon = module.exports.GridRemoveIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 13H5v-2h14v2z"
}), 'Remove');
const $b9b0b441ce479047$var$GridLoadIcon = module.exports.GridLoadIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
}), 'Load');
const $b9b0b441ce479047$var$GridDragIcon = module.exports.GridDragIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'Drag');
const $b9b0b441ce479047$var$GridCheckIcon = module.exports.GridCheckIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), 'Check');
const $b9b0b441ce479047$var$GridMoreVertIcon = module.exports.GridMoreVertIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreVert');
const $b9b0b441ce479047$var$GridVisibilityOffIcon = module.exports.GridVisibilityOffIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
}), 'VisibilityOff');
const $b9b0b441ce479047$var$GridViewColumnIcon = module.exports.GridViewColumnIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("g", {
    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M14.67,5v14H9.33V5H14.67z M15.67,19H21V5h-5.33V19z M8.33,19V5H3v14H8.33z"
    })
}), 'ViewColumn');
const $b9b0b441ce479047$var$GridClearIcon = module.exports.GridClearIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12z"
}), 'Clear');
const $b9b0b441ce479047$var$GridDeleteIcon = module.exports.GridDeleteIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
}), 'Delete');
const $b9b0b441ce479047$var$GridDeleteForeverIcon = module.exports.GridDeleteForeverIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z"
}), 'Delete');
const $b9b0b441ce479047$var$GridDownloadIcon = module.exports.GridDownloadIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M5 20h14v-2H5zM19 9h-4V3H9v6H5l7 7z"
}), 'Download');

});
parcelRegister("c69f0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createSvgIcon = void 0;

var $hGPki = parcelRequire("hGPki");
const $8ced36a16719fbed$var$createSvgIcon = module.exports.createSvgIcon = $hGPki.createSvgIcon;

});


parcelRegister("i9HdC", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d37a9791700d8c9e$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $d37a9791700d8c9e$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridColumnUnsortedIcon = void 0;

var $d37a9791700d8c9e$var$_extends2 = $d37a9791700d8c9e$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $d37a9791700d8c9e$var$_objectWithoutPropertiesLoose2 = $d37a9791700d8c9e$require$_interopRequireDefault((parcelRequire("c05no")));

var $d37a9791700d8c9e$var$React = $d37a9791700d8c9e$require$_interopRequireWildcard((parcelRequire("acw62")));

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $d37a9791700d8c9e$var$_excluded = [
    "sortingOrder"
];
const $d37a9791700d8c9e$var$GridColumnUnsortedIcon = module.exports.GridColumnUnsortedIcon = /*#__PURE__*/ $d37a9791700d8c9e$var$React.memo(function GridColumnHeaderSortIcon(props) {
    const { sortingOrder: sortingOrder } = props, other = (0, $d37a9791700d8c9e$var$_objectWithoutPropertiesLoose2.default)(props, $d37a9791700d8c9e$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const [nextSortDirection] = sortingOrder;
    const Icon = nextSortDirection === 'asc' ? rootProps.slots.columnSortedAscendingIcon : rootProps.slots.columnSortedDescendingIcon;
    return Icon ? /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, (0, $d37a9791700d8c9e$var$_extends2.default)({}, other)) : null;
});
$d37a9791700d8c9e$var$GridColumnUnsortedIcon.displayName = "GridColumnUnsortedIcon";

});
parcelRegister("jDpXp", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $e4b5cb616f3aaa8a$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridRootProps = void 0;

var $e4b5cb616f3aaa8a$var$React = $e4b5cb616f3aaa8a$require$_interopRequireWildcard((parcelRequire("acw62")));

var $96LtV = parcelRequire("96LtV");
const $e4b5cb616f3aaa8a$var$useGridRootProps = ()=>{
    const contextValue = $e4b5cb616f3aaa8a$var$React.useContext($96LtV.GridRootPropsContext);
    if (!contextValue) throw new Error('MUI X: useGridRootProps should only be used inside the DataGrid, DataGridPro or DataGridPremium component.');
    return contextValue;
};
module.exports.useGridRootProps = $e4b5cb616f3aaa8a$var$useGridRootProps;

});
parcelRegister("96LtV", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $6a19817c134c532b$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridRootPropsContext = void 0;

var $6a19817c134c532b$var$React = $6a19817c134c532b$require$_interopRequireWildcard((parcelRequire("acw62")));
const $6a19817c134c532b$var$GridRootPropsContext = module.exports.GridRootPropsContext = /*#__PURE__*/ $6a19817c134c532b$var$React.createContext(undefined);
$6a19817c134c532b$var$GridRootPropsContext.displayName = "GridRootPropsContext";

});



parcelRegister("bDyDY", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $878e35c228656139$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridApiContext = $878e35c228656139$var$useGridApiContext;

var $878e35c228656139$var$React = $878e35c228656139$require$_interopRequireWildcard((parcelRequire("acw62")));

var $YSznt = parcelRequire("YSznt");
function $878e35c228656139$var$useGridApiContext() {
    const apiRef = $878e35c228656139$var$React.useContext($YSznt.GridApiContext);
    if (apiRef === undefined) throw new Error([
        'MUI X: Could not find the Data Grid context.',
        'It looks like you rendered your component outside of a DataGrid, DataGridPro or DataGridPremium parent component.',
        'This can also happen if you are bundling multiple versions of the Data Grid.'
    ].join('\n'));
    return apiRef;
}

});
parcelRegister("YSznt", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $0b6fef1928293673$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridApiContext = void 0;

var $0b6fef1928293673$var$React = $0b6fef1928293673$require$_interopRequireWildcard((parcelRequire("acw62")));
const $0b6fef1928293673$var$GridApiContext = module.exports.GridApiContext = /*#__PURE__*/ $0b6fef1928293673$var$React.createContext(undefined);
$0b6fef1928293673$var$GridApiContext.displayName = "GridApiContext";

});


parcelRegister("5LM2M", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $43369c0a919be7e4$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useMaterialCSSVariables = $43369c0a919be7e4$var$useMaterialCSSVariables;

var $43369c0a919be7e4$var$React = $43369c0a919be7e4$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8xDHs = parcelRequire("8xDHs");

var $7OhqI = parcelRequire("7OhqI");

var $hbuUJ = parcelRequire("hbuUJ");

var $aOz2q = parcelRequire("aOz2q");
function $43369c0a919be7e4$var$useMaterialCSSVariables() {
    const theme = (0, $8xDHs.useTheme)();
    return $43369c0a919be7e4$var$React.useMemo(()=>{
        const id = (0, $7OhqI.hash)($43369c0a919be7e4$var$stringifyTheme(theme));
        const variables = $43369c0a919be7e4$var$transformTheme(theme);
        return {
            id: id,
            variables: variables
        };
    }, [
        theme
    ]);
}
function $43369c0a919be7e4$var$transformTheme(t) {
    const borderColor = $43369c0a919be7e4$var$getBorderColor(t);
    const dataGridPalette = (t.vars || t).palette.DataGrid;
    const paperColor = (t.vars || t).palette.background.paper;
    const backgroundBase = dataGridPalette?.bg ?? (t.palette.mode === 'dark' ? (0, $aOz2q.colorMixIfSupported)(`color-mix(in srgb, ${paperColor} 95%, #fff)`, paperColor) : paperColor);
    const backgroundHeader = dataGridPalette?.headerBg ?? backgroundBase;
    const backgroundPinned = dataGridPalette?.pinnedBg ?? backgroundBase;
    const backgroundBackdrop = t.vars ? `rgba(${t.vars.palette.background.defaultChannel} / ${t.vars.palette.action.disabledOpacity})` : (0, $8xDHs.alpha)(t.palette.background.default, t.palette.action.disabledOpacity);
    const backgroundOverlay = t.palette.mode === 'dark' ? (0, $aOz2q.colorMixIfSupported)(`color-mix(in srgb, ${paperColor} 90%, #fff)`, paperColor) : paperColor;
    const selectedColor = t.vars ? `rgb(${t.vars.palette.primary.mainChannel})` : t.palette.primary.main;
    const radius = $43369c0a919be7e4$var$getRadius(t);
    const fontBody = t.vars?.font?.body2 ?? $43369c0a919be7e4$var$formatFont(t.typography.body2);
    const fontSmall = t.vars?.font?.caption ?? $43369c0a919be7e4$var$formatFont(t.typography.caption);
    const fontLarge = t.vars?.font?.body1 ?? $43369c0a919be7e4$var$formatFont(t.typography.body1);
    const k = $hbuUJ.vars.keys;
    return {
        [k.spacingUnit]: t.vars ? t.vars.spacing ?? t.spacing(1) : t.spacing(1),
        [k.colors.border.base]: borderColor,
        [k.colors.background.base]: backgroundBase,
        [k.colors.background.overlay]: backgroundOverlay,
        [k.colors.background.backdrop]: backgroundBackdrop,
        [k.colors.foreground.base]: (t.vars || t).palette.text.primary,
        [k.colors.foreground.muted]: (t.vars || t).palette.text.secondary,
        [k.colors.foreground.accent]: (t.vars || t).palette.primary.dark,
        [k.colors.foreground.disabled]: (t.vars || t).palette.text.disabled,
        [k.colors.foreground.error]: (t.vars || t).palette.error.dark,
        [k.colors.interactive.hover]: $aOz2q.supportsColorMix ? (t.vars || t).palette.action.hover : (t.vars || t).palette.grey[t.palette.mode === 'dark' ? 800 : 100],
        [k.colors.interactive.hoverOpacity]: (t.vars || t).palette.action.hoverOpacity,
        [k.colors.interactive.focus]: $43369c0a919be7e4$var$removeOpacity((t.vars || t).palette.primary.main),
        [k.colors.interactive.focusOpacity]: (t.vars || t).palette.action.focusOpacity,
        [k.colors.interactive.disabled]: $43369c0a919be7e4$var$removeOpacity((t.vars || t).palette.action.disabled),
        [k.colors.interactive.disabledOpacity]: (t.vars || t).palette.action.disabledOpacity,
        [k.colors.interactive.selected]: $aOz2q.supportsColorMix ? selectedColor : (t.vars || t).palette.grey[t.palette.mode === 'dark' ? 700 : 200],
        [k.colors.interactive.selectedOpacity]: (t.vars || t).palette.action.selectedOpacity,
        [k.header.background.base]: backgroundHeader,
        [k.cell.background.pinned]: backgroundPinned,
        [k.radius.base]: radius,
        [k.typography.fontFamily.base]: t.typography.fontFamily,
        [k.typography.fontWeight.light]: t.typography.fontWeightLight,
        [k.typography.fontWeight.regular]: t.typography.fontWeightRegular,
        [k.typography.fontWeight.medium]: t.typography.fontWeightMedium,
        [k.typography.fontWeight.bold]: t.typography.fontWeightBold,
        [k.typography.font.body]: fontBody,
        [k.typography.font.small]: fontSmall,
        [k.typography.font.large]: fontLarge,
        [k.transitions.easing.easeIn]: t.transitions.easing.easeIn,
        [k.transitions.easing.easeOut]: t.transitions.easing.easeOut,
        [k.transitions.easing.easeInOut]: t.transitions.easing.easeInOut,
        [k.transitions.duration.short]: `${t.transitions.duration.shorter}ms`,
        [k.transitions.duration.base]: `${t.transitions.duration.short}ms`,
        [k.transitions.duration.long]: `${t.transitions.duration.standard}ms`,
        [k.shadows.base]: (t.vars || t).shadows[2],
        [k.shadows.overlay]: (t.vars || t).shadows[8],
        [k.zIndex.panel]: (t.vars || t).zIndex.modal,
        [k.zIndex.menu]: (t.vars || t).zIndex.modal
    };
}
function $43369c0a919be7e4$var$getRadius(theme) {
    if (theme.vars) return theme.vars.shape.borderRadius;
    return typeof theme.shape.borderRadius === 'number' ? `${theme.shape.borderRadius}px` : theme.shape.borderRadius;
}
function $43369c0a919be7e4$var$getBorderColor(theme) {
    if (theme.vars) return theme.vars.palette.TableCell.border;
    if (theme.palette.mode === 'light') return (0, $8xDHs.lighten)((0, $8xDHs.alpha)(theme.palette.divider, 1), 0.88);
    return (0, $8xDHs.darken)((0, $8xDHs.alpha)(theme.palette.divider, 1), 0.68);
}
function $43369c0a919be7e4$var$setOpacity(color, opacity) {
    return `rgba(from ${color} r g b / ${opacity})`;
}
function $43369c0a919be7e4$var$removeOpacity(color) {
    return $43369c0a919be7e4$var$setOpacity(color, 1);
}
function $43369c0a919be7e4$var$formatFont(font) {
    // Accounts for disabled typography variants
    // See: https://github.com/mui/mui-x/issues/17812
    if (!font) return undefined;
    const fontSize = typeof font.fontSize === 'number' ? `${font.fontSize}px` : font.fontSize;
    return `${font.fontWeight} ${fontSize} / ${font.lineHeight} ${font.fontFamily}`;
}
/**
 * A version of JSON.stringify for theme objects.
 * Fixes: https://github.com/mui/mui-x/issues/17521
 * Source: https://www.30secondsofcode.org/js/s/stringify-circular-json/
 */ function $43369c0a919be7e4$var$stringifyTheme(input) {
    const seen = new WeakSet();
    return JSON.stringify(input, (_, v)=>{
        // https://github.com/mui/mui-x/issues/17855
        if (typeof window !== 'undefined' && v === window || typeof document !== 'undefined' && v === document) return v.toString();
        if (v !== null && typeof v === 'object') {
            // Do not attempt to serialize React elements due to performance concerns.
            // Fixes https://github.com/mui/mui-x/issues/19414
            if (/*#__PURE__*/ $43369c0a919be7e4$var$React.isValidElement(v)) return null;
            if (seen.has(v)) return null;
            seen.add(v);
        }
        return v;
    });
}

});
parcelRegister("7OhqI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9jdiA = parcelRequire("9jdiA");
Object.keys($9jdiA).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9jdiA[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9jdiA[key];
        }
    });
});

});
parcelRegister("9jdiA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hash = void 0;
const $6c703441990b201b$var$encoder = new TextEncoder();
// bufferLength must be a multiple of 4 to satisfy Int32Array constraints
let $6c703441990b201b$var$bufferLength = 2048;
let $6c703441990b201b$var$buffer = new ArrayBuffer($6c703441990b201b$var$bufferLength);
let $6c703441990b201b$var$uint8View = new Uint8Array($6c703441990b201b$var$buffer);
let $6c703441990b201b$var$int32View = new Int32Array($6c703441990b201b$var$buffer);
const $6c703441990b201b$var$hash = module.exports.hash = $6c703441990b201b$var$xxh;
/**
 * Returns an xxh hash of `input` formatted as a decimal string.
 */ // prettier-ignore
function $6c703441990b201b$var$xxh(input) {
    /* eslint-disable no-bitwise */ // Worst-case scenario: full string of 2-byte characters
    const requiredLength = input.length * 2;
    if (requiredLength > $6c703441990b201b$var$bufferLength) {
        // buffer.resize() is only available in recent browsers, so we re-allocate
        // a new and views
        $6c703441990b201b$var$bufferLength = requiredLength + (4 - requiredLength % 4);
        $6c703441990b201b$var$buffer = new ArrayBuffer($6c703441990b201b$var$bufferLength);
        $6c703441990b201b$var$uint8View = new Uint8Array($6c703441990b201b$var$buffer);
        $6c703441990b201b$var$int32View = new Int32Array($6c703441990b201b$var$buffer);
    }
    const length8 = $6c703441990b201b$var$encoder.encodeInto(input, $6c703441990b201b$var$uint8View).written;
    const seed = 0;
    const len = length8 | 0;
    let i = 0;
    let h = (seed + len | 0) + 0x165667B1 | 0;
    if (len < 16) for(; (i + 3 | 0) < len; i = i + 4 | 0)h = Math.imul($6c703441990b201b$var$rotl32(h + Math.imul($6c703441990b201b$var$int32View[i] | 0, 0xC2B2AE3D) | 0, 17) | 0, 0x27D4EB2F);
    else {
        let v0 = seed + 0x24234428 | 0;
        let v1 = seed + 0x85EBCA77 | 0;
        let v2 = seed;
        let v3 = seed - 0x9E3779B1 | 0;
        for(; (i + 15 | 0) < len; i = i + 16 | 0){
            v0 = Math.imul($6c703441990b201b$var$rotl32(v0 + Math.imul($6c703441990b201b$var$int32View[i + 0 | 0] | 0, 0x85EBCA77) | 0, 13) | 0, 0x9E3779B1);
            v1 = Math.imul($6c703441990b201b$var$rotl32(v1 + Math.imul($6c703441990b201b$var$int32View[i + 4 | 0] | 0, 0x85EBCA77) | 0, 13) | 0, 0x9E3779B1);
            v2 = Math.imul($6c703441990b201b$var$rotl32(v2 + Math.imul($6c703441990b201b$var$int32View[i + 8 | 0] | 0, 0x85EBCA77) | 0, 13) | 0, 0x9E3779B1);
            v3 = Math.imul($6c703441990b201b$var$rotl32(v3 + Math.imul($6c703441990b201b$var$int32View[i + 12 | 0] | 0, 0x85EBCA77) | 0, 13) | 0, 0x9E3779B1);
        }
        h = ((($6c703441990b201b$var$rotl32(v0, 1) | 0 + $6c703441990b201b$var$rotl32(v1, 7) | 0) + $6c703441990b201b$var$rotl32(v2, 12) | 0) + $6c703441990b201b$var$rotl32(v3, 18) | 0) + len | 0;
        for(; (i + 3 | 0) < len; i = i + 4 | 0)h = Math.imul($6c703441990b201b$var$rotl32(h + Math.imul($6c703441990b201b$var$int32View[i] | 0, 0xC2B2AE3D) | 0, 17) | 0, 0x27D4EB2F);
    }
    for(; i < len; i = i + 1 | 0)h = Math.imul($6c703441990b201b$var$rotl32(h + Math.imul($6c703441990b201b$var$uint8View[i] | 0, 0x165667B1) | 0, 11) | 0, 0x9E3779B1);
    h = Math.imul(h ^ h >>> 15, 0x85EBCA77);
    h = Math.imul(h ^ h >>> 13, 0xC2B2AE3D);
    return ((h ^ h >>> 16) >>> 0).toString();
}
function $6c703441990b201b$var$rotl32(x, r) {
    return x << r | x >>> 32 - r;
}

});


parcelRegister("hbuUJ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c82b71a32bc2a7f4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.vars = void 0;

var $c82b71a32bc2a7f4$var$_extends2 = $c82b71a32bc2a7f4$require$_interopRequireDefault((parcelRequire("3p9rK")));
// NOTE: Breakpoints can't come from the theme because we need access to them at
// initialization time and media-queries can't use CSS variables. For users with
// custom breakpoints, we might want to provide a way to configure them globally
// instead of through the theme.
const $c82b71a32bc2a7f4$var$breakpoints = {
    values: {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    },
    up: (key)=>{
        const values = $c82b71a32bc2a7f4$var$breakpoints.values;
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}px)`;
    }
};
const $c82b71a32bc2a7f4$var$keys = {
    spacingUnit: '--DataGrid-t-spacing-unit',
    /* Variables */ colors: {
        border: {
            base: '--DataGrid-t-color-border-base'
        },
        foreground: {
            base: '--DataGrid-t-color-foreground-base',
            muted: '--DataGrid-t-color-foreground-muted',
            accent: '--DataGrid-t-color-foreground-accent',
            disabled: '--DataGrid-t-color-foreground-disabled',
            error: '--DataGrid-t-color-foreground-error'
        },
        background: {
            base: '--DataGrid-t-color-background-base',
            overlay: '--DataGrid-t-color-background-overlay',
            backdrop: '--DataGrid-t-color-background-backdrop'
        },
        interactive: {
            hover: '--DataGrid-t-color-interactive-hover',
            hoverOpacity: '--DataGrid-t-color-interactive-hover-opacity',
            focus: '--DataGrid-t-color-interactive-focus',
            focusOpacity: '--DataGrid-t-color-interactive-focus-opacity',
            disabled: '--DataGrid-t-color-interactive-disabled',
            disabledOpacity: '--DataGrid-t-color-interactive-disabled-opacity',
            selected: '--DataGrid-t-color-interactive-selected',
            selectedOpacity: '--DataGrid-t-color-interactive-selected-opacity'
        }
    },
    header: {
        background: {
            base: '--DataGrid-t-header-background-base'
        }
    },
    cell: {
        background: {
            pinned: '--DataGrid-t-cell-background-pinned'
        }
    },
    radius: {
        base: '--DataGrid-t-radius-base'
    },
    typography: {
        font: {
            body: '--DataGrid-t-typography-font-body',
            small: '--DataGrid-t-typography-font-small',
            large: '--DataGrid-t-typography-font-large'
        },
        fontFamily: {
            base: '--DataGrid-t-typography-font-family-base'
        },
        fontWeight: {
            light: '--DataGrid-t-typography-font-weight-light',
            regular: '--DataGrid-t-typography-font-weight-regular',
            medium: '--DataGrid-t-typography-font-weight-medium',
            bold: '--DataGrid-t-typography-font-weight-bold'
        }
    },
    transitions: {
        easing: {
            easeIn: '--DataGrid-t-transition-easing-ease-in',
            easeOut: '--DataGrid-t-transition-easing-ease-out',
            easeInOut: '--DataGrid-t-transition-easing-ease-in-out'
        },
        duration: {
            short: '--DataGrid-t-transition-duration-short',
            base: '--DataGrid-t-transition-duration-base',
            long: '--DataGrid-t-transition-duration-long'
        }
    },
    shadows: {
        base: '--DataGrid-t-shadow-base',
        overlay: '--DataGrid-t-shadow-overlay'
    },
    zIndex: {
        panel: '--DataGrid-t-z-index-panel',
        menu: '--DataGrid-t-z-index-menu'
    }
};
const $c82b71a32bc2a7f4$var$values = $c82b71a32bc2a7f4$var$wrap($c82b71a32bc2a7f4$var$keys);
const $c82b71a32bc2a7f4$var$vars = module.exports.vars = (0, $c82b71a32bc2a7f4$var$_extends2.default)({
    breakpoints: $c82b71a32bc2a7f4$var$breakpoints,
    spacing: $c82b71a32bc2a7f4$var$spacing,
    transition: $c82b71a32bc2a7f4$var$transition,
    keys: $c82b71a32bc2a7f4$var$keys
}, $c82b71a32bc2a7f4$var$values);
function $c82b71a32bc2a7f4$var$spacing(a, b, c, d) {
    /* eslint-disable prefer-template */ if (a === undefined) return $c82b71a32bc2a7f4$var$spacingString(1);
    if (b === undefined) return $c82b71a32bc2a7f4$var$spacingString(a);
    if (c === undefined) return $c82b71a32bc2a7f4$var$spacingString(a) + ' ' + $c82b71a32bc2a7f4$var$spacingString(b);
    if (d === undefined) return $c82b71a32bc2a7f4$var$spacingString(a) + ' ' + $c82b71a32bc2a7f4$var$spacingString(b) + ' ' + $c82b71a32bc2a7f4$var$spacingString(c);
    return $c82b71a32bc2a7f4$var$spacingString(a) + ' ' + $c82b71a32bc2a7f4$var$spacingString(b) + ' ' + $c82b71a32bc2a7f4$var$spacingString(c) + ' ' + $c82b71a32bc2a7f4$var$spacingString(d);
/* eslint-enable prefer-template */ }
function $c82b71a32bc2a7f4$var$spacingString(value) {
    if (value === 0) return '0';
    return `calc(var(--DataGrid-t-spacing-unit) * ${value})`;
}
function $c82b71a32bc2a7f4$var$transition(props, options) {
    const { duration: duration = $c82b71a32bc2a7f4$var$vars.transitions.duration.base, easing: easing = $c82b71a32bc2a7f4$var$vars.transitions.easing.easeInOut, delay: delay = 0 } = options ?? {};
    return props.map((prop)=>`${prop} ${duration} ${easing} ${delay}ms`).join(', ');
}
function $c82b71a32bc2a7f4$var$wrap(input) {
    if (typeof input === 'string') return `var(${input})`;
    const result = {};
    for(const key in input)if (Object.hasOwn(input, key)) result[key] = $c82b71a32bc2a7f4$var$wrap(input[key]);
    return result;
}

});

parcelRegister("aOz2q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.supportsColorMix = module.exports.colorMixIfSupported = module.exports.GridRootStyles = void 0;

var $8xDHs = parcelRequire("8xDHs");

var $5H1vo = parcelRequire("5H1vo");

var $hbuUJ = parcelRequire("hbuUJ");

var $5sOMZ = parcelRequire("5sOMZ");

var $er55f = parcelRequire("er55f");
const $7df9c0c298ff1f9f$var$columnSeparatorTargetSize = 10;
const $7df9c0c298ff1f9f$var$columnSeparatorOffset = -5;
const $7df9c0c298ff1f9f$var$focusOutlineWidth = 1;
const $7df9c0c298ff1f9f$var$separatorIconDragStyles = {
    width: 3,
    rx: 1.5,
    x: 10.5
};
// Emotion thinks it knows better than us which selector we should use.
// https://github.com/emotion-js/emotion/issues/1105#issuecomment-1722524968
const $7df9c0c298ff1f9f$var$ignoreSsrWarning = '/* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */';
const $7df9c0c298ff1f9f$var$shouldShowBorderTopRightRadiusSelector = (apiRef)=>!apiRef.current.state.dimensions.isReady ? apiRef.current.state.dimensions.scrollbarSize === 0 : apiRef.current.state.dimensions.hasScrollX && (!apiRef.current.state.dimensions.hasScrollY || apiRef.current.state.dimensions.scrollbarSize === 0);
const $7df9c0c298ff1f9f$var$GridRootStyles = module.exports.GridRootStyles = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'Root',
    overridesResolver: (props, styles)=>[
            // Root overrides
            styles.root,
            {
                [`&.${$5H1vo.gridClasses.autoHeight}`]: styles.autoHeight
            },
            {
                [`&.${$5H1vo.gridClasses.autosizing}`]: styles.autosizing
            },
            {
                [`&.${$5H1vo.gridClasses['root--densityStandard']}`]: styles['root--densityStandard']
            },
            {
                [`&.${$5H1vo.gridClasses['root--densityComfortable']}`]: styles['root--densityComfortable']
            },
            {
                [`&.${$5H1vo.gridClasses['root--densityCompact']}`]: styles['root--densityCompact']
            },
            {
                [`&.${$5H1vo.gridClasses['root--disableUserSelection']}`]: styles['root--disableUserSelection']
            },
            {
                [`&.${$5H1vo.gridClasses['root--noToolbar']}`]: styles['root--noToolbar']
            },
            {
                [`&.${$5H1vo.gridClasses.withVerticalBorder}`]: styles.withVerticalBorder
            },
            // Child element overrides
            // - Only declare overrides here for class names that are not applied to `styled` components.
            // - For `styled` components, declare overrides in the component itself.
            {
                [`& .${$5H1vo.gridClasses.actionsCell}`]: styles.actionsCell
            },
            {
                [`& .${$5H1vo.gridClasses.booleanCell}`]: styles.booleanCell
            },
            {
                [`& .${$5H1vo.gridClasses.cell}`]: styles.cell
            },
            {
                [`& .${$5H1vo.gridClasses['cell--editable']}`]: styles['cell--editable']
            },
            {
                [`& .${$5H1vo.gridClasses['cell--editing']}`]: styles['cell--editing']
            },
            {
                [`& .${$5H1vo.gridClasses['cell--flex']}`]: styles['cell--flex']
            },
            {
                [`& .${$5H1vo.gridClasses['cell--pinnedLeft']}`]: styles['cell--pinnedLeft']
            },
            {
                [`& .${$5H1vo.gridClasses['cell--pinnedRight']}`]: styles['cell--pinnedRight']
            },
            {
                [`& .${$5H1vo.gridClasses['cell--rangeBottom']}`]: styles['cell--rangeBottom']
            },
            {
                [`& .${$5H1vo.gridClasses['cell--rangeLeft']}`]: styles['cell--rangeLeft']
            },
            {
                [`& .${$5H1vo.gridClasses['cell--rangeRight']}`]: styles['cell--rangeRight']
            },
            {
                [`& .${$5H1vo.gridClasses['cell--rangeTop']}`]: styles['cell--rangeTop']
            },
            {
                [`& .${$5H1vo.gridClasses['cell--selectionMode']}`]: styles['cell--selectionMode']
            },
            {
                [`& .${$5H1vo.gridClasses['cell--textCenter']}`]: styles['cell--textCenter']
            },
            {
                [`& .${$5H1vo.gridClasses['cell--textLeft']}`]: styles['cell--textLeft']
            },
            {
                [`& .${$5H1vo.gridClasses['cell--textRight']}`]: styles['cell--textRight']
            },
            {
                [`& .${$5H1vo.gridClasses['cell--withLeftBorder']}`]: styles['cell--withLeftBorder']
            },
            {
                [`& .${$5H1vo.gridClasses['cell--withRightBorder']}`]: styles['cell--withRightBorder']
            },
            {
                [`& .${$5H1vo.gridClasses.cellCheckbox}`]: styles.cellCheckbox
            },
            {
                [`& .${$5H1vo.gridClasses.cellEmpty}`]: styles.cellEmpty
            },
            {
                [`& .${$5H1vo.gridClasses.cellOffsetLeft}`]: styles.cellOffsetLeft
            },
            {
                [`& .${$5H1vo.gridClasses.cellSkeleton}`]: styles.cellSkeleton
            },
            {
                [`& .${$5H1vo.gridClasses.checkboxInput}`]: styles.checkboxInput
            },
            {
                [`& .${$5H1vo.gridClasses.columnHeader}`]: styles.columnHeader
            },
            {
                [`& .${$5H1vo.gridClasses['columnHeader--alignCenter']}`]: styles['columnHeader--alignCenter']
            },
            {
                [`& .${$5H1vo.gridClasses['columnHeader--alignLeft']}`]: styles['columnHeader--alignLeft']
            },
            {
                [`& .${$5H1vo.gridClasses['columnHeader--alignRight']}`]: styles['columnHeader--alignRight']
            },
            {
                [`& .${$5H1vo.gridClasses['columnHeader--dragging']}`]: styles['columnHeader--dragging']
            },
            {
                [`& .${$5H1vo.gridClasses['columnHeader--emptyGroup']}`]: styles['columnHeader--emptyGroup']
            },
            {
                [`& .${$5H1vo.gridClasses['columnHeader--filledGroup']}`]: styles['columnHeader--filledGroup']
            },
            {
                [`& .${$5H1vo.gridClasses['columnHeader--filtered']}`]: styles['columnHeader--filtered']
            },
            {
                [`& .${$5H1vo.gridClasses['columnHeader--last']}`]: styles['columnHeader--last']
            },
            {
                [`& .${$5H1vo.gridClasses['columnHeader--moving']}`]: styles['columnHeader--moving']
            },
            {
                [`& .${$5H1vo.gridClasses['columnHeader--numeric']}`]: styles['columnHeader--numeric']
            },
            {
                [`& .${$5H1vo.gridClasses['columnHeader--pinnedLeft']}`]: styles['columnHeader--pinnedLeft']
            },
            {
                [`& .${$5H1vo.gridClasses['columnHeader--pinnedRight']}`]: styles['columnHeader--pinnedRight']
            },
            {
                [`& .${$5H1vo.gridClasses['columnHeader--siblingFocused']}`]: styles['columnHeader--siblingFocused']
            },
            {
                [`& .${$5H1vo.gridClasses['columnHeader--sortable']}`]: styles['columnHeader--sortable']
            },
            {
                [`& .${$5H1vo.gridClasses['columnHeader--sorted']}`]: styles['columnHeader--sorted']
            },
            {
                [`& .${$5H1vo.gridClasses['columnHeader--withLeftBorder']}`]: styles['columnHeader--withLeftBorder']
            },
            {
                [`& .${$5H1vo.gridClasses['columnHeader--withRightBorder']}`]: styles['columnHeader--withRightBorder']
            },
            {
                [`& .${$5H1vo.gridClasses.columnHeaderCheckbox}`]: styles.columnHeaderCheckbox
            },
            {
                [`& .${$5H1vo.gridClasses.columnHeaderDraggableContainer}`]: styles.columnHeaderDraggableContainer
            },
            {
                [`& .${$5H1vo.gridClasses.columnHeaderTitleContainer}`]: styles.columnHeaderTitleContainer
            },
            {
                [`& .${$5H1vo.gridClasses.columnHeaderTitleContainerContent}`]: styles.columnHeaderTitleContainerContent
            },
            {
                [`& .${$5H1vo.gridClasses.columnSeparator}`]: styles.columnSeparator
            },
            {
                [`& .${$5H1vo.gridClasses['columnSeparator--resizable']}`]: styles['columnSeparator--resizable']
            },
            {
                [`& .${$5H1vo.gridClasses['columnSeparator--resizing']}`]: styles['columnSeparator--resizing']
            },
            {
                [`& .${$5H1vo.gridClasses['columnSeparator--sideLeft']}`]: styles['columnSeparator--sideLeft']
            },
            {
                [`& .${$5H1vo.gridClasses['columnSeparator--sideRight']}`]: styles['columnSeparator--sideRight']
            },
            {
                [`& .${$5H1vo.gridClasses['container--bottom']}`]: styles['container--bottom']
            },
            {
                [`& .${$5H1vo.gridClasses['container--top']}`]: styles['container--top']
            },
            {
                [`& .${$5H1vo.gridClasses.detailPanelToggleCell}`]: styles.detailPanelToggleCell
            },
            {
                [`& .${$5H1vo.gridClasses['detailPanelToggleCell--expanded']}`]: styles['detailPanelToggleCell--expanded']
            },
            {
                [`& .${$5H1vo.gridClasses.editBooleanCell}`]: styles.editBooleanCell
            },
            {
                [`& .${$5H1vo.gridClasses.filterIcon}`]: styles.filterIcon
            },
            {
                [`& .${$5H1vo.gridClasses['filler--borderBottom']}`]: styles['filler--borderBottom']
            },
            {
                [`& .${$5H1vo.gridClasses['filler--pinnedLeft']}`]: styles['filler--pinnedLeft']
            },
            {
                [`& .${$5H1vo.gridClasses['filler--pinnedRight']}`]: styles['filler--pinnedRight']
            },
            {
                [`& .${$5H1vo.gridClasses.groupingCriteriaCell}`]: styles.groupingCriteriaCell
            },
            {
                [`& .${$5H1vo.gridClasses.groupingCriteriaCellLoadingContainer}`]: styles.groupingCriteriaCellLoadingContainer
            },
            {
                [`& .${$5H1vo.gridClasses.groupingCriteriaCellToggle}`]: styles.groupingCriteriaCellToggle
            },
            {
                [`& .${$5H1vo.gridClasses.headerFilterRow}`]: styles.headerFilterRow
            },
            {
                [`& .${$5H1vo.gridClasses.iconSeparator}`]: styles.iconSeparator
            },
            {
                [`& .${$5H1vo.gridClasses.menuIcon}`]: styles.menuIcon
            },
            {
                [`& .${$5H1vo.gridClasses.menuIconButton}`]: styles.menuIconButton
            },
            {
                [`& .${$5H1vo.gridClasses.menuList}`]: styles.menuList
            },
            {
                [`& .${$5H1vo.gridClasses.menuOpen}`]: styles.menuOpen
            },
            {
                [`& .${$5H1vo.gridClasses.overlayWrapperInner}`]: styles.overlayWrapperInner
            },
            {
                [`& .${$5H1vo.gridClasses.pinnedRows}`]: styles.pinnedRows
            },
            {
                [`& .${$5H1vo.gridClasses['pinnedRows--bottom']}`]: styles['pinnedRows--bottom']
            },
            {
                [`& .${$5H1vo.gridClasses['pinnedRows--top']}`]: styles['pinnedRows--top']
            },
            {
                [`& .${$5H1vo.gridClasses.row}`]: styles.row
            },
            {
                [`& .${$5H1vo.gridClasses['row--borderBottom']}`]: styles['row--borderBottom']
            },
            {
                [`& .${$5H1vo.gridClasses['row--detailPanelExpanded']}`]: styles['row--detailPanelExpanded']
            },
            {
                [`& .${$5H1vo.gridClasses['row--dragging']}`]: styles['row--dragging']
            },
            {
                [`& .${$5H1vo.gridClasses['row--dynamicHeight']}`]: styles['row--dynamicHeight']
            },
            {
                [`& .${$5H1vo.gridClasses['row--editable']}`]: styles['row--editable']
            },
            {
                [`& .${$5H1vo.gridClasses['row--editing']}`]: styles['row--editing']
            },
            {
                [`& .${$5H1vo.gridClasses['row--firstVisible']}`]: styles['row--firstVisible']
            },
            {
                [`& .${$5H1vo.gridClasses['row--lastVisible']}`]: styles['row--lastVisible']
            },
            {
                [`& .${$5H1vo.gridClasses.rowReorderCell}`]: styles.rowReorderCell
            },
            {
                [`& .${$5H1vo.gridClasses['rowReorderCell--draggable']}`]: styles['rowReorderCell--draggable']
            },
            {
                [`& .${$5H1vo.gridClasses.rowReorderCellContainer}`]: styles.rowReorderCellContainer
            },
            {
                [`& .${$5H1vo.gridClasses.rowReorderCellPlaceholder}`]: styles.rowReorderCellPlaceholder
            },
            {
                [`& .${$5H1vo.gridClasses.rowSkeleton}`]: styles.rowSkeleton
            },
            {
                [`& .${$5H1vo.gridClasses.scrollbar}`]: styles.scrollbar
            },
            {
                [`& .${$5H1vo.gridClasses['scrollbar--horizontal']}`]: styles['scrollbar--horizontal']
            },
            {
                [`& .${$5H1vo.gridClasses['scrollbar--vertical']}`]: styles['scrollbar--vertical']
            },
            {
                [`& .${$5H1vo.gridClasses.scrollbarFiller}`]: styles.scrollbarFiller
            },
            {
                [`& .${$5H1vo.gridClasses['scrollbarFiller--pinnedRight']}`]: styles['scrollbarFiller--pinnedRight']
            },
            {
                [`& .${$5H1vo.gridClasses.sortIcon}`]: styles.sortIcon
            },
            {
                [`& .${$5H1vo.gridClasses.treeDataGroupingCell}`]: styles.treeDataGroupingCell
            },
            {
                [`& .${$5H1vo.gridClasses.treeDataGroupingCellLoadingContainer}`]: styles.treeDataGroupingCellLoadingContainer
            },
            {
                [`& .${$5H1vo.gridClasses.treeDataGroupingCellToggle}`]: styles.treeDataGroupingCellToggle
            },
            {
                [`& .${$5H1vo.gridClasses.withBorderColor}`]: styles.withBorderColor
            },
            {
                [`& .${$5H1vo.gridClasses['row--beingDragged']}`]: styles['row--beingDragged']
            }
        ]
})(()=>{
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const shouldShowBorderTopRightRadius = (0, $5sOMZ.useGridSelector)(apiRef, $7df9c0c298ff1f9f$var$shouldShowBorderTopRightRadiusSelector);
    const baseBackground = $hbuUJ.vars.colors.background.base;
    const headerBackground = $hbuUJ.vars.header.background.base;
    const pinnedBackground = $hbuUJ.vars.cell.background.pinned;
    const hoverColor = $7df9c0c298ff1f9f$var$removeOpacity($hbuUJ.vars.colors.interactive.hover);
    const hoverOpacity = $hbuUJ.vars.colors.interactive.hoverOpacity;
    const selectedColor = $hbuUJ.vars.colors.interactive.selected;
    const selectedOpacity = $hbuUJ.vars.colors.interactive.selectedOpacity;
    const selectedHoverColor = selectedColor;
    const selectedHoverOpacity = `calc(${selectedOpacity} + ${hoverOpacity})`;
    const fallbackColors = {
        hover: $hbuUJ.vars.colors.interactive.hover,
        selected: selectedColor,
        selectedHover: selectedColor
    };
    const hoverBackground = $7df9c0c298ff1f9f$var$mix(baseBackground, hoverColor, hoverOpacity, fallbackColors.hover);
    const selectedBackground = $7df9c0c298ff1f9f$var$mix(baseBackground, selectedColor, selectedOpacity, fallbackColors.selected);
    const selectedHoverBackground = $7df9c0c298ff1f9f$var$mix(baseBackground, selectedHoverColor, selectedHoverOpacity, fallbackColors.selectedHover);
    const pinnedHoverBackground = $7df9c0c298ff1f9f$var$mix(pinnedBackground, hoverColor, hoverOpacity, fallbackColors.hover);
    const pinnedSelectedBackground = $7df9c0c298ff1f9f$var$mix(pinnedBackground, selectedColor, selectedOpacity, fallbackColors.selected);
    const pinnedSelectedHoverBackground = $7df9c0c298ff1f9f$var$mix(pinnedBackground, selectedHoverColor, selectedHoverOpacity, fallbackColors.selectedHover);
    const getPinnedBackgroundStyles = (backgroundColor)=>({
            [`& .${$5H1vo.gridClasses['cell--pinnedLeft']}, & .${$5H1vo.gridClasses['cell--pinnedRight']}`]: {
                backgroundColor: backgroundColor,
                '&.Mui-selected': {
                    backgroundColor: $7df9c0c298ff1f9f$var$mix(backgroundColor, selectedBackground, selectedOpacity, fallbackColors.selected),
                    '&:hover': {
                        backgroundColor: $7df9c0c298ff1f9f$var$mix(backgroundColor, selectedHoverBackground, selectedHoverOpacity, fallbackColors.selectedHover)
                    }
                }
            }
        });
    const pinnedHoverStyles = getPinnedBackgroundStyles(pinnedHoverBackground);
    const pinnedSelectedStyles = getPinnedBackgroundStyles(pinnedSelectedBackground);
    const pinnedSelectedHoverStyles = getPinnedBackgroundStyles(pinnedSelectedHoverBackground);
    const selectedStyles = {
        backgroundColor: selectedBackground,
        '&:hover': {
            backgroundColor: selectedHoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: selectedBackground
            }
        }
    };
    const gridStyle = {
        '--unstable_DataGrid-radius': $hbuUJ.vars.radius.base,
        '--unstable_DataGrid-headWeight': $hbuUJ.vars.typography.fontWeight.medium,
        '--DataGrid-rowBorderColor': $hbuUJ.vars.colors.border.base,
        '--DataGrid-cellOffsetMultiplier': 2,
        '--DataGrid-width': '0px',
        '--DataGrid-hasScrollX': '0',
        '--DataGrid-hasScrollY': '0',
        '--DataGrid-scrollbarSize': '10px',
        '--DataGrid-rowWidth': '0px',
        '--DataGrid-columnsTotalWidth': '0px',
        '--DataGrid-leftPinnedWidth': '0px',
        '--DataGrid-rightPinnedWidth': '0px',
        '--DataGrid-headerHeight': '0px',
        '--DataGrid-headersTotalHeight': '0px',
        '--DataGrid-topContainerHeight': '0px',
        '--DataGrid-bottomContainerHeight': '0px',
        flex: 1,
        boxSizing: 'border-box',
        position: 'relative',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: $hbuUJ.vars.colors.border.base,
        borderRadius: 'var(--unstable_DataGrid-radius)',
        backgroundColor: $hbuUJ.vars.colors.background.base,
        color: $hbuUJ.vars.colors.foreground.base,
        font: $hbuUJ.vars.typography.font.body,
        outline: 'none',
        height: '100%',
        display: 'flex',
        minWidth: 0,
        // See https://github.com/mui/mui-x/issues/8547
        minHeight: 0,
        flexDirection: 'column',
        overflow: 'hidden',
        overflowAnchor: 'none',
        // Keep the same scrolling position
        transform: 'translate(0, 0)',
        // Create a stacking context to keep scrollbars from showing on top
        [`.${$5H1vo.gridClasses.main} > *:first-child${$7df9c0c298ff1f9f$var$ignoreSsrWarning}`]: {
            borderTopLeftRadius: 'var(--unstable_DataGrid-radius)',
            borderTopRightRadius: 'var(--unstable_DataGrid-radius)'
        },
        [`&.${$5H1vo.gridClasses.autoHeight}`]: {
            height: 'auto'
        },
        [`&.${$5H1vo.gridClasses.autosizing}`]: {
            [`& .${$5H1vo.gridClasses.columnHeaderTitleContainerContent} > *`]: {
                overflow: 'visible !important'
            },
            '@media (hover: hover)': {
                [`& .${$5H1vo.gridClasses.menuIcon}`]: {
                    width: '0 !important',
                    visibility: 'hidden !important'
                }
            },
            [`& .${$5H1vo.gridClasses.cell}`]: {
                overflow: 'visible !important',
                whiteSpace: 'nowrap',
                minWidth: 'max-content !important',
                maxWidth: 'max-content !important'
            },
            [`& .${$5H1vo.gridClasses.groupingCriteriaCell}`]: {
                width: 'unset'
            },
            [`& .${$5H1vo.gridClasses.treeDataGroupingCell}`]: {
                width: 'unset'
            }
        },
        [`&.${$5H1vo.gridClasses.withSidePanel}`]: {
            flexDirection: 'row'
        },
        [`& .${$5H1vo.gridClasses.mainContent}`]: {
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            flex: 1
        },
        [`& .${$5H1vo.gridClasses.columnHeader}, & .${$5H1vo.gridClasses.cell}`]: {
            WebkitTapHighlightColor: 'transparent',
            padding: '0 10px',
            boxSizing: 'border-box'
        },
        [`& .${$5H1vo.gridClasses.columnHeader}:focus-within, & .${$5H1vo.gridClasses.cell}:focus-within`]: {
            outline: `solid ${$7df9c0c298ff1f9f$var$setOpacity($hbuUJ.vars.colors.interactive.focus, 0.5)} ${$7df9c0c298ff1f9f$var$focusOutlineWidth}px`,
            outlineOffset: $7df9c0c298ff1f9f$var$focusOutlineWidth * -1
        },
        [`& .${$5H1vo.gridClasses.columnHeader}:focus, & .${$5H1vo.gridClasses.cell}:focus`]: {
            outline: `solid ${$hbuUJ.vars.colors.interactive.focus} ${$7df9c0c298ff1f9f$var$focusOutlineWidth}px`,
            outlineOffset: $7df9c0c298ff1f9f$var$focusOutlineWidth * -1
        },
        // Hide the column separator when:
        // - the column is focused and has an outline
        // - the next column is focused and has an outline
        // - the column has a left or right border
        // - the next column is pinned right and has a left border
        [`& .${$5H1vo.gridClasses.columnHeader}:focus,
      & .${$5H1vo.gridClasses['columnHeader--withLeftBorder']},
      & .${$5H1vo.gridClasses['columnHeader--withRightBorder']},
      & .${$5H1vo.gridClasses['columnHeader--siblingFocused']}
      `]: {
            [`& .${$5H1vo.gridClasses.columnSeparator}`]: {
                opacity: 0
            },
            // Show resizable separators at all times on touch devices
            '@media (hover: none)': {
                [`& .${$5H1vo.gridClasses['columnSeparator--resizable']}`]: {
                    opacity: 1
                }
            },
            [`& .${$5H1vo.gridClasses['columnSeparator--resizable']}:hover`]: {
                opacity: 1
            }
        },
        [`&.${$5H1vo.gridClasses['root--noToolbar']} [aria-rowindex="1"] [aria-colindex="1"]`]: {
            borderTopLeftRadius: 'calc(var(--unstable_DataGrid-radius) - 1px)'
        },
        [`&.${$5H1vo.gridClasses['root--noToolbar']} [aria-rowindex="1"] .${$5H1vo.gridClasses['columnHeader--last']}`]: {
            borderTopRightRadius: shouldShowBorderTopRightRadius ? 'calc(var(--unstable_DataGrid-radius) - 1px)' : undefined
        },
        [`& .${$5H1vo.gridClasses.columnHeaderCheckbox}, & .${$5H1vo.gridClasses.cellCheckbox}`]: {
            padding: 0,
            justifyContent: 'center',
            alignItems: 'center'
        },
        [`& .${$5H1vo.gridClasses.columnHeader}`]: {
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            backgroundColor: headerBackground
        },
        [`& .${$5H1vo.gridClasses.columnHeader} .${$5H1vo.gridClasses.sortButton}`]: {
            backgroundColor: $hbuUJ.vars.header.background.base
        },
        [`& .${$5H1vo.gridClasses['columnHeader--filter']}`]: {
            paddingTop: 8,
            paddingBottom: 8,
            paddingRight: 5,
            minHeight: 'min-content',
            overflow: 'hidden'
        },
        [`& .${$5H1vo.gridClasses['virtualScroller--hasScrollX']} .${$5H1vo.gridClasses['columnHeader--last']}`]: {
            overflow: 'hidden'
        },
        [`& .${$5H1vo.gridClasses['pivotPanelField--sorted']} .${$5H1vo.gridClasses.iconButtonContainer},
      & .${$5H1vo.gridClasses['columnHeader--sorted']} .${$5H1vo.gridClasses.iconButtonContainer},
      & .${$5H1vo.gridClasses['columnHeader--filtered']} .${$5H1vo.gridClasses.iconButtonContainer}`]: {
            visibility: 'visible',
            width: 'auto'
        },
        [`& .${$5H1vo.gridClasses.pivotPanelField}:not(.${$5H1vo.gridClasses['pivotPanelField--sorted']}) .${$5H1vo.gridClasses.sortButton},
      & .${$5H1vo.gridClasses.columnHeader}:not(.${$5H1vo.gridClasses['columnHeader--sorted']}) .${$5H1vo.gridClasses.sortButton}`]: {
            opacity: 0,
            transition: $hbuUJ.vars.transition([
                'opacity'
            ], {
                duration: $hbuUJ.vars.transitions.duration.short
            })
        },
        [`& .${$5H1vo.gridClasses.columnHeaderTitleContainer}`]: {
            display: 'flex',
            alignItems: 'center',
            gap: $hbuUJ.vars.spacing(0.25),
            minWidth: 0,
            flex: 1,
            whiteSpace: 'nowrap',
            overflow: 'hidden'
        },
        [`& .${$5H1vo.gridClasses.columnHeaderTitleContainerContent}`]: {
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center'
        },
        [`& .${$5H1vo.gridClasses['columnHeader--filledGroup']} .${$5H1vo.gridClasses.columnHeaderTitleContainer}`]: {
            borderBottomWidth: '1px',
            borderBottomStyle: 'solid',
            boxSizing: 'border-box'
        },
        [`& .${$5H1vo.gridClasses.sortIcon}, & .${$5H1vo.gridClasses.filterIcon}`]: {
            fontSize: 'inherit'
        },
        [`& .${$5H1vo.gridClasses['columnHeader--sortable']}`]: {
            cursor: 'pointer'
        },
        [`& .${$5H1vo.gridClasses['columnHeader--alignCenter']} .${$5H1vo.gridClasses.columnHeaderTitleContainer}`]: {
            justifyContent: 'center'
        },
        [`& .${$5H1vo.gridClasses['columnHeader--alignRight']} .${$5H1vo.gridClasses.columnHeaderDraggableContainer}, & .${$5H1vo.gridClasses['columnHeader--alignRight']} .${$5H1vo.gridClasses.columnHeaderTitleContainer}`]: {
            flexDirection: 'row-reverse'
        },
        [`& .${$5H1vo.gridClasses['columnHeader--alignCenter']} .${$5H1vo.gridClasses.menuIcon}`]: {
            marginLeft: 'auto'
        },
        [`& .${$5H1vo.gridClasses['columnHeader--alignRight']} .${$5H1vo.gridClasses.menuIcon}`]: {
            marginRight: 'auto',
            marginLeft: -5
        },
        [`& .${$5H1vo.gridClasses['columnHeader--moving']}`]: {
            backgroundColor: hoverBackground
        },
        [`& .${$5H1vo.gridClasses['columnHeader--pinnedLeft']}, & .${$5H1vo.gridClasses['columnHeader--pinnedRight']}`]: {
            position: 'sticky',
            zIndex: 40,
            // Should be above the column separator
            background: $hbuUJ.vars.header.background.base
        },
        [`& .${$5H1vo.gridClasses.columnSeparator}`]: {
            position: 'absolute',
            overflow: 'hidden',
            zIndex: 30,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            maxWidth: $7df9c0c298ff1f9f$var$columnSeparatorTargetSize,
            color: $hbuUJ.vars.colors.border.base
        },
        [`& .${$5H1vo.gridClasses.columnHeaders}`]: {
            width: 'var(--DataGrid-rowWidth)',
            backgroundColor: headerBackground
        },
        '@media (hover: hover)': {
            [`& .${$5H1vo.gridClasses.columnHeader}:hover`]: {
                [`& .${$5H1vo.gridClasses.menuIcon}`]: {
                    width: 'auto',
                    visibility: 'visible'
                },
                [`& .${$5H1vo.gridClasses.iconButtonContainer}`]: {
                    visibility: 'visible',
                    width: 'auto'
                }
            },
            [`& .${$5H1vo.gridClasses.columnHeader}:not(.${$5H1vo.gridClasses['columnHeader--sorted']}):hover .${$5H1vo.gridClasses.sortButton},
        & .${$5H1vo.gridClasses.pivotPanelField}:not(.${$5H1vo.gridClasses['pivotPanelField--sorted']}):hover .${$5H1vo.gridClasses.sortButton},
        & .${$5H1vo.gridClasses.pivotPanelField}:not(.${$5H1vo.gridClasses['pivotPanelField--sorted']}) .${$5H1vo.gridClasses.sortButton}:focus-visible`]: {
                opacity: 1
            },
            // Add opacity only to the button content to avoid affecting the background color
            [`& .${$5H1vo.gridClasses.columnHeader}:not(.${$5H1vo.gridClasses['columnHeader--sorted']}):hover .${$5H1vo.gridClasses.sortButton} > *,
        & .${$5H1vo.gridClasses.pivotPanelField}:not(.${$5H1vo.gridClasses['pivotPanelField--sorted']}):hover .${$5H1vo.gridClasses.sortButton} > *,
        & .${$5H1vo.gridClasses.pivotPanelField}:not(.${$5H1vo.gridClasses['pivotPanelField--sorted']}) .${$5H1vo.gridClasses.sortButton}:focus-visible > *`]: {
                opacity: 0.78
            },
            [`& .${$5H1vo.gridClasses.pivotPanelFieldActionContainer} button:hover`]: {
                backgroundColor: $hbuUJ.vars.colors.background.base
            }
        },
        '@media (hover: none)': {
            [`& .${$5H1vo.gridClasses.columnHeader} .${$5H1vo.gridClasses.menuIcon}`]: {
                width: 'auto',
                visibility: 'visible'
            },
            [`& .${$5H1vo.gridClasses.columnHeader}:focus,
        & .${$5H1vo.gridClasses['columnHeader--siblingFocused']}`]: {
                [`.${$5H1vo.gridClasses['columnSeparator--resizable']}`]: {
                    color: $hbuUJ.vars.colors.foreground.accent
                }
            },
            [`& .${$5H1vo.gridClasses.pivotPanelField}:not(.${$5H1vo.gridClasses['pivotPanelField--sorted']}) .${$5H1vo.gridClasses.sortButton}`]: {
                opacity: 0.78
            }
        },
        // Hide the column separator when the column has border and it is not resizable
        // In this case, this column separator may block interaction with the separator from the adjacent column that is resizable
        [`& .${$5H1vo.gridClasses['columnHeader--withLeftBorder']} .${$5H1vo.gridClasses['columnSeparator--sideLeft']}:not(.${$5H1vo.gridClasses['columnSeparator--resizable']}), & .${$5H1vo.gridClasses['columnHeader--withRightBorder']} .${$5H1vo.gridClasses['columnSeparator--sideRight']}:not(.${$5H1vo.gridClasses['columnSeparator--resizable']})`]: {
            display: 'none'
        },
        [`& .${$5H1vo.gridClasses['columnSeparator--sideLeft']}`]: {
            left: $7df9c0c298ff1f9f$var$columnSeparatorOffset
        },
        [`& .${$5H1vo.gridClasses['columnSeparator--sideRight']}`]: {
            right: $7df9c0c298ff1f9f$var$columnSeparatorOffset
        },
        [`& .${$5H1vo.gridClasses['columnHeader--withRightBorder']} .${$5H1vo.gridClasses['columnSeparator--sideLeft']}`]: {
            left: $7df9c0c298ff1f9f$var$columnSeparatorOffset - 0.5
        },
        [`& .${$5H1vo.gridClasses['columnHeader--withRightBorder']} .${$5H1vo.gridClasses['columnSeparator--sideRight']}`]: {
            right: $7df9c0c298ff1f9f$var$columnSeparatorOffset - 0.5
        },
        [`& .${$5H1vo.gridClasses['columnSeparator--resizable']}`]: {
            cursor: 'col-resize',
            touchAction: 'none',
            [`&.${$5H1vo.gridClasses['columnSeparator--resizing']}`]: {
                color: $hbuUJ.vars.colors.foreground.accent
            },
            // Always appear as draggable on touch devices
            '@media (hover: none)': {
                [`& .${$5H1vo.gridClasses.iconSeparator} rect`]: $7df9c0c298ff1f9f$var$separatorIconDragStyles
            },
            '@media (hover: hover)': {
                '&:hover': {
                    color: $hbuUJ.vars.colors.foreground.accent,
                    [`& .${$5H1vo.gridClasses.iconSeparator} rect`]: $7df9c0c298ff1f9f$var$separatorIconDragStyles
                }
            },
            '& svg': {
                pointerEvents: 'none'
            }
        },
        [`& .${$5H1vo.gridClasses.iconSeparator}`]: {
            color: 'inherit',
            transition: $hbuUJ.vars.transition([
                'color',
                'width'
            ], {
                duration: $hbuUJ.vars.transitions.duration.short
            })
        },
        [`& .${$5H1vo.gridClasses.menuIcon}`]: {
            width: 0,
            visibility: 'hidden',
            fontSize: 20,
            marginRight: -5,
            display: 'flex',
            alignItems: 'center'
        },
        [`.${$5H1vo.gridClasses.menuOpen}`]: {
            visibility: 'visible',
            width: 'auto'
        },
        [`& .${$5H1vo.gridClasses.headerFilterRow}`]: {
            [`& .${$5H1vo.gridClasses.columnHeader}, & .${$5H1vo.gridClasses.scrollbarFiller}`]: {
                boxSizing: 'border-box',
                borderBottom: '1px solid var(--DataGrid-rowBorderColor)'
            }
        },
        /* Bottom border of the top-container */ [`& .${$5H1vo.gridClasses['row--borderBottom']} .${$5H1vo.gridClasses.columnHeader},
      & .${$5H1vo.gridClasses['row--borderBottom']} .${$5H1vo.gridClasses.filler},
      & .${$5H1vo.gridClasses['row--borderBottom']} .${$5H1vo.gridClasses.scrollbarFiller}`]: {
            borderBottom: `1px solid var(--DataGrid-rowBorderColor)`
        },
        [`& .${$5H1vo.gridClasses['row--borderBottom']} .${$5H1vo.gridClasses.cell}`]: {
            borderBottom: `1px solid var(--rowBorderColor)`
        },
        /* Row styles */ [`.${$5H1vo.gridClasses.row}`]: {
            display: 'flex',
            width: 'var(--DataGrid-rowWidth)',
            breakInside: 'avoid',
            // Avoid the row to be broken in two different print pages.
            '--rowBorderColor': 'var(--DataGrid-rowBorderColor)',
            [`&.${$5H1vo.gridClasses['row--firstVisible']}`]: {
                '--rowBorderColor': 'transparent'
            },
            '&:hover': {
                backgroundColor: hoverBackground,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            [`&.${$5H1vo.gridClasses.rowSkeleton}:hover`]: {
                backgroundColor: 'transparent'
            },
            '&.Mui-selected': selectedStyles,
            position: 'relative'
        },
        /* Cell styles */ [`& .${$5H1vo.gridClasses.cell}`]: {
            flex: '0 0 auto',
            height: 'var(--height)',
            width: 'var(--width)',
            lineHeight: 'calc(var(--height) - 1px)',
            // -1px for the border
            boxSizing: 'border-box',
            borderTop: `1px solid var(--rowBorderColor)`,
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            '&.Mui-selected': selectedStyles
        },
        [`& .${$5H1vo.gridClasses['virtualScrollerContent--overflowed']} .${$5H1vo.gridClasses['row--lastVisible']} .${$5H1vo.gridClasses.cell}`]: {
            borderTopColor: 'transparent'
        },
        [`& .${$5H1vo.gridClasses.pinnedRows} .${$5H1vo.gridClasses.row}, .${$5H1vo.gridClasses.aggregationRowOverlayWrapper} .${$5H1vo.gridClasses.row}`]: {
            backgroundColor: pinnedBackground,
            '&:hover': {
                backgroundColor: pinnedHoverBackground
            }
        },
        [`& .${$5H1vo.gridClasses['pinnedRows--top']} :first-of-type`]: {
            [`& .${$5H1vo.gridClasses.cell}, .${$5H1vo.gridClasses.scrollbarFiller}`]: {
                borderTop: 'none'
            }
        },
        [`&.${$5H1vo.gridClasses['root--disableUserSelection']}`]: {
            userSelect: 'none'
        },
        [`& .${$5H1vo.gridClasses['row--dynamicHeight']} > .${$5H1vo.gridClasses.cell}`]: {
            whiteSpace: 'initial',
            lineHeight: 'inherit'
        },
        [`& .${$5H1vo.gridClasses.cellEmpty}`]: {
            flex: 1,
            padding: 0,
            height: 'unset'
        },
        [`& .${$5H1vo.gridClasses.cell}.${$5H1vo.gridClasses['cell--selectionMode']}`]: {
            cursor: 'default'
        },
        [`& .${$5H1vo.gridClasses.cell}.${$5H1vo.gridClasses['cell--editing']}`]: {
            padding: 1,
            display: 'flex',
            boxShadow: $hbuUJ.vars.shadows.base,
            backgroundColor: $hbuUJ.vars.colors.background.overlay,
            '&:focus-within': {
                outline: `${$7df9c0c298ff1f9f$var$focusOutlineWidth}px solid ${$hbuUJ.vars.colors.interactive.focus}`,
                outlineOffset: $7df9c0c298ff1f9f$var$focusOutlineWidth * -1
            }
        },
        [`& .${$5H1vo.gridClasses['cell--editing']}`]: {
            '& .MuiInputBase-root': {
                height: '100%'
            }
        },
        [`& .${$5H1vo.gridClasses['row--editing']}`]: {
            boxShadow: $hbuUJ.vars.shadows.base
        },
        [`& .${$5H1vo.gridClasses['row--editing']} .${$5H1vo.gridClasses.cell}`]: {
            boxShadow: 'none',
            backgroundColor: $hbuUJ.vars.colors.background.overlay
        },
        [`& .${$5H1vo.gridClasses.editBooleanCell}`]: {
            display: 'flex',
            height: '100%',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'center'
        },
        [`& .${$5H1vo.gridClasses.booleanCell}[data-value="true"]`]: {
            color: $hbuUJ.vars.colors.foreground.muted
        },
        [`& .${$5H1vo.gridClasses.booleanCell}[data-value="false"]`]: {
            color: $hbuUJ.vars.colors.foreground.disabled
        },
        [`& .${$5H1vo.gridClasses.actionsCell}`]: {
            display: 'inline-flex',
            alignItems: 'center',
            gridGap: $hbuUJ.vars.spacing(1)
        },
        [`& .${$5H1vo.gridClasses.rowReorderCell}`]: {
            display: 'inline-flex',
            flex: 1,
            alignItems: 'center',
            justifyContent: 'center',
            opacity: $hbuUJ.vars.colors.interactive.disabledOpacity
        },
        [`& .${$5H1vo.gridClasses['rowReorderCell--draggable']}`]: {
            cursor: 'grab',
            opacity: 1
        },
        [`& .${$5H1vo.gridClasses.rowReorderCellContainer}`]: {
            padding: 0,
            display: 'flex',
            alignItems: 'stretch'
        },
        [`.${$5H1vo.gridClasses.withBorderColor}`]: {
            borderColor: $hbuUJ.vars.colors.border.base
        },
        [`& .${$5H1vo.gridClasses['cell--withLeftBorder']}, & .${$5H1vo.gridClasses['columnHeader--withLeftBorder']}`]: {
            borderLeftColor: 'var(--DataGrid-rowBorderColor)',
            borderLeftWidth: '1px',
            borderLeftStyle: 'solid'
        },
        [`& .${$5H1vo.gridClasses['cell--withRightBorder']}, & .${$5H1vo.gridClasses['columnHeader--withRightBorder']}`]: {
            borderRightColor: 'var(--DataGrid-rowBorderColor)',
            borderRightWidth: '1px',
            borderRightStyle: 'solid'
        },
        [`& .${$5H1vo.gridClasses['cell--flex']}`]: {
            display: 'flex',
            alignItems: 'center',
            lineHeight: 'inherit'
        },
        [`& .${$5H1vo.gridClasses['cell--textLeft']}`]: {
            textAlign: 'left',
            justifyContent: 'flex-start'
        },
        [`& .${$5H1vo.gridClasses['cell--textRight']}`]: {
            textAlign: 'right',
            justifyContent: 'flex-end'
        },
        [`& .${$5H1vo.gridClasses['cell--textCenter']}`]: {
            textAlign: 'center',
            justifyContent: 'center'
        },
        [`& .${$5H1vo.gridClasses['cell--pinnedLeft']}, & .${$5H1vo.gridClasses['cell--pinnedRight']}`]: {
            position: 'sticky',
            zIndex: 30,
            background: $hbuUJ.vars.cell.background.pinned,
            '&.Mui-selected': {
                backgroundColor: pinnedSelectedBackground
            }
        },
        [`& .${$5H1vo.gridClasses.row}`]: {
            '&:hover': pinnedHoverStyles,
            '&.Mui-selected': pinnedSelectedStyles,
            '&.Mui-selected:hover': pinnedSelectedHoverStyles
        },
        [`& .${$5H1vo.gridClasses.cellOffsetLeft}`]: {
            flex: '0 0 auto',
            display: 'inline-block'
        },
        [`& .${$5H1vo.gridClasses.cellSkeleton}`]: {
            flex: '0 0 auto',
            height: '100%',
            display: 'inline-flex',
            alignItems: 'center'
        },
        [`& .${$5H1vo.gridClasses.columnHeaderDraggableContainer}`]: {
            display: 'flex',
            width: '100%',
            height: '100%'
        },
        [`& .${$5H1vo.gridClasses.rowReorderCellPlaceholder}`]: {
            display: 'none'
        },
        [`& .${$5H1vo.gridClasses['columnHeader--dragging']}`]: {
            background: $hbuUJ.vars.colors.background.overlay,
            padding: '0 12px',
            borderRadius: 'var(--unstable_DataGrid-radius)',
            opacity: $hbuUJ.vars.colors.interactive.disabledOpacity
        },
        [`& .${$5H1vo.gridClasses['row--dragging']}`]: {
            background: $hbuUJ.vars.colors.background.overlay,
            padding: '0 12px',
            borderRadius: 'var(--unstable_DataGrid-radius)',
            border: '1px solid var(--DataGrid-rowBorderColor)',
            color: $hbuUJ.vars.colors.foreground.base,
            transform: 'translateZ(0)',
            [`& .${$5H1vo.gridClasses.rowReorderCellPlaceholder}`]: {
                padding: '0 6px',
                display: 'flex'
            }
        },
        [`& .${$5H1vo.gridClasses.treeDataGroupingCell}`]: {
            display: 'flex',
            alignItems: 'center',
            width: '100%'
        },
        [`& .${$5H1vo.gridClasses.treeDataGroupingCellToggle}`]: {
            flex: '0 0 28px',
            alignSelf: 'stretch',
            marginRight: $hbuUJ.vars.spacing(2)
        },
        [`& .${$5H1vo.gridClasses.treeDataGroupingCellLoadingContainer}, .${$5H1vo.gridClasses.groupingCriteriaCellLoadingContainer}`]: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%'
        },
        [`& .${$5H1vo.gridClasses.groupingCriteriaCell}`]: {
            display: 'flex',
            alignItems: 'center',
            width: '100%'
        },
        [`& .${$5H1vo.gridClasses.groupingCriteriaCellToggle}`]: {
            flex: '0 0 28px',
            alignSelf: 'stretch',
            marginRight: $hbuUJ.vars.spacing(2)
        },
        /* ScrollbarFiller styles */ [`& .${$5H1vo.gridClasses.columnHeaders} .${$5H1vo.gridClasses.scrollbarFiller}`]: {
            backgroundColor: headerBackground
        },
        [`.${$5H1vo.gridClasses.scrollbarFiller}`]: {
            minWidth: 'calc(var(--DataGrid-hasScrollY) * var(--DataGrid-scrollbarSize))',
            alignSelf: 'stretch',
            backgroundColor: headerBackground,
            [`&.${$5H1vo.gridClasses['scrollbarFiller--pinnedRight']}`]: {
                position: 'sticky',
                zIndex: 40,
                // Should be above the column separator
                right: 0
            }
        },
        [`& .${$5H1vo.gridClasses.filler}`]: {
            flex: '1 0 auto'
        },
        [`& .${$5H1vo.gridClasses['filler--borderBottom']}`]: {
            borderBottom: '1px solid var(--DataGrid-rowBorderColor)'
        },
        [`& .${$5H1vo.gridClasses.columnHeaders} .${$5H1vo.gridClasses.filler}`]: {
            backgroundColor: headerBackground
        },
        /* Used when skeleton/no columns overlay is visible */ [`& .${$5H1vo.gridClasses['main--hiddenContent']}`]: {
            [`& .${$5H1vo.gridClasses.virtualScrollerContent}`]: {
                // We use visibility hidden so that the virtual scroller content retains its height.
                // Position fixed is used to remove the virtual scroller content from the flow.
                // https://github.com/mui/mui-x/issues/14061
                position: 'fixed',
                visibility: 'hidden'
            },
            // Hide grid content
            [`& .${$5H1vo.gridClasses.pinnedRows}`]: {
                display: 'none'
            }
        },
        [`& .${$5H1vo.gridClasses['row--beingDragged']}`]: {
            color: $hbuUJ.vars.colors.foreground.disabled,
            '&:hover': {
                backgroundColor: 'transparent'
            }
        }
    };
    return gridStyle;
});
function $7df9c0c298ff1f9f$var$setOpacity(color, opacity) {
    return `rgba(from ${color} r g b / ${opacity})`;
}
function $7df9c0c298ff1f9f$var$removeOpacity(color) {
    return $7df9c0c298ff1f9f$var$setOpacity(color, 1);
}
const $7df9c0c298ff1f9f$var$supportsColorMix = module.exports.supportsColorMix = typeof CSS !== 'undefined' && typeof CSS.supports === 'function' && CSS.supports('color', 'color-mix(in srgb, red 50%, blue 50%)');
const $7df9c0c298ff1f9f$var$colorMixIfSupported = (colorMixValue, fallback)=>{
    if (!$7df9c0c298ff1f9f$var$supportsColorMix) return fallback;
    return colorMixValue;
};
module.exports.colorMixIfSupported = $7df9c0c298ff1f9f$var$colorMixIfSupported;
function $7df9c0c298ff1f9f$var$mix(background, overlay, opacity, fallback) {
    return $7df9c0c298ff1f9f$var$colorMixIfSupported(`color-mix(in srgb,${background}, ${overlay} calc(${opacity} * 100%))`, fallback);
}

});
parcelRegister("5H1vo", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $425222d9b2251c12$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDataGridUtilityClass = $425222d9b2251c12$var$getDataGridUtilityClass;
module.exports.gridClasses = void 0;

var $425222d9b2251c12$var$_generateUtilityClass = $425222d9b2251c12$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $425222d9b2251c12$var$_generateUtilityClasses = $425222d9b2251c12$require$_interopRequireDefault((parcelRequire("5nY49")));
function $425222d9b2251c12$var$getDataGridUtilityClass(slot) {
    return (0, $425222d9b2251c12$var$_generateUtilityClass.default)('MuiDataGrid', slot);
}
const $425222d9b2251c12$var$gridClasses = module.exports.gridClasses = (0, $425222d9b2251c12$var$_generateUtilityClasses.default)('MuiDataGrid', [
    'aiAssistantPanel',
    'aiAssistantPanelHeader',
    'aiAssistantPanelTitleContainer',
    'aiAssistantPanelTitle',
    'aiAssistantPanelBody',
    'aiAssistantPanelEmptyText',
    'aiAssistantPanelFooter',
    'aiAssistantPanelConversation',
    'aiAssistantPanelConversationList',
    'aiAssistantPanelConversationTitle',
    'aiAssistantPanelSuggestions',
    'aiAssistantPanelSuggestionsList',
    'aiAssistantPanelSuggestionsItem',
    'aiAssistantPanelSuggestionsLabel',
    'actionsCell',
    'aggregationColumnHeader',
    'aggregationColumnHeader--alignLeft',
    'aggregationColumnHeader--alignCenter',
    'aggregationColumnHeader--alignRight',
    'aggregationColumnHeaderLabel',
    'aggregationRowOverlayWrapper',
    'autoHeight',
    'autosizing',
    'mainContent',
    'withSidePanel',
    'booleanCell',
    'cell--editable',
    'cell--editing',
    'cell--flex',
    'cell--textCenter',
    'cell--textLeft',
    'cell--textRight',
    'cell--rangeTop',
    'cell--rangeBottom',
    'cell--rangeLeft',
    'cell--rangeRight',
    'cell--pinnedLeft',
    'cell--pinnedRight',
    'cell--selectionMode',
    'cell',
    'cellCheckbox',
    'cellEmpty',
    'cellSkeleton',
    'cellOffsetLeft',
    'checkboxInput',
    'collapsible',
    'collapsibleTrigger',
    'collapsibleIcon',
    'collapsiblePanel',
    'columnHeader',
    'columnHeader--alignCenter',
    'columnHeader--alignLeft',
    'columnHeader--alignRight',
    'columnHeader--dragging',
    'columnHeader--moving',
    'columnHeader--numeric',
    'columnHeader--sortable',
    'columnHeader--sorted',
    'columnHeader--filtered',
    'columnHeader--pinnedLeft',
    'columnHeader--pinnedRight',
    'columnHeader--last',
    'columnHeader--siblingFocused',
    'columnHeader--filter',
    'columnHeaderFilterInput',
    'columnHeaderFilterOperatorLabel',
    'columnHeaderCheckbox',
    'columnHeaderDraggableContainer',
    'columnHeaderTitle',
    'columnHeaderTitleContainer',
    'columnHeaderTitleContainerContent',
    'columnHeader--filledGroup',
    'columnHeader--emptyGroup',
    'columnHeaders',
    'columnSeparator--resizable',
    'columnSeparator--resizing',
    'columnSeparator--sideLeft',
    'columnSeparator--sideRight',
    'columnSeparator',
    'columnsManagement',
    'columnsManagementRow',
    'columnsManagementHeader',
    'columnsManagementSearchInput',
    'columnsManagementFooter',
    'columnsManagementScrollArea',
    'columnsManagementEmptyText',
    'container--top',
    'container--bottom',
    'detailPanel',
    'detailPanelToggleCell',
    'detailPanelToggleCell--expanded',
    'footerCell',
    'panel',
    'panelHeader',
    'panelWrapper',
    'panelContent',
    'panelFooter',
    'paper',
    'editBooleanCell',
    'editInputCell',
    'filler',
    'filler--borderBottom',
    'filler--pinnedLeft',
    'filler--pinnedRight',
    'filterForm',
    'filterFormDeleteIcon',
    'filterFormLogicOperatorInput',
    'filterFormColumnInput',
    'filterFormOperatorInput',
    'filterFormValueInput',
    'filterIcon',
    'footerContainer',
    'headerFilterRow',
    'iconButtonContainer',
    'iconSeparator',
    'main',
    'main--hasPinnedRight',
    'main--hiddenContent',
    'menu',
    'menuIcon',
    'menuIconButton',
    'menuOpen',
    'menuList',
    'overlay',
    'overlayWrapper',
    'overlayWrapperInner',
    'root',
    'root--densityStandard',
    'root--densityComfortable',
    'root--densityCompact',
    'root--disableUserSelection',
    'root--noToolbar',
    'row',
    'row--editable',
    'row--editing',
    'row--firstVisible',
    'row--lastVisible',
    // TODO v9: Rename to `cell--dragging`
    'row--dragging',
    'row--beingDragged',
    'row--dynamicHeight',
    'row--detailPanelExpanded',
    'row--borderBottom',
    'rowReorderCellPlaceholder',
    'rowCount',
    'rowReorderCellContainer',
    'rowReorderCell',
    'rowReorderCell--draggable',
    'rowReorderIcon',
    'rowSkeleton',
    'scrollArea--left',
    'scrollArea--right',
    'scrollArea--up',
    'scrollArea--down',
    'scrollArea',
    'scrollbar',
    'scrollbar--vertical',
    'scrollbar--horizontal',
    'scrollbarFiller',
    'scrollbarFiller--pinnedRight',
    'scrollShadow',
    'scrollShadow--vertical',
    'scrollShadow--horizontal',
    'selectedRowCount',
    'sortButton',
    'sortIcon',
    'shadowScrollArea',
    'sidebar',
    'sidebarHeader',
    'toolbarContainer',
    'toolbar',
    'toolbarLabel',
    'toolbarDivider',
    'toolbarFilterList',
    'toolbarQuickFilter',
    'toolbarQuickFilterTrigger',
    'toolbarQuickFilterControl',
    'virtualScroller',
    'virtualScroller--hasScrollX',
    'virtualScrollerContent',
    'virtualScrollerContent--overflowed',
    'virtualScrollerRenderZone',
    'withVerticalBorder',
    'withBorderColor',
    'cell--withRightBorder',
    'cell--withLeftBorder',
    'columnHeader--withRightBorder',
    'columnHeader--withLeftBorder',
    'treeDataGroupingCell',
    'treeDataGroupingCellToggle',
    'treeDataGroupingCellLoadingContainer',
    'groupingCriteriaCell',
    'groupingCriteriaCellToggle',
    'groupingCriteriaCellLoadingContainer',
    'pinnedRows',
    'pinnedRows--top',
    'pinnedRows--bottom',
    'pivotPanelAvailableFields',
    'pivotPanelField',
    'pivotPanelField--sorted',
    'pivotPanelFieldActionContainer',
    'pivotPanelFieldCheckbox',
    'pivotPanelFieldDragIcon',
    'pivotPanelFieldList',
    'pivotPanelFieldName',
    'pivotPanelHeader',
    'pivotPanelPlaceholder',
    'pivotPanelScrollArea',
    'pivotPanelSearchContainer',
    'pivotPanelSection',
    'pivotPanelSectionTitle',
    'pivotPanelSections',
    'pivotPanelSwitch',
    'pivotPanelSwitchLabel',
    'prompt',
    'promptContent',
    'promptText',
    'promptFeedback',
    'promptChangeList',
    'promptChangesToggle',
    'promptChangesToggleIcon',
    'promptIcon',
    'promptIconContainer',
    'promptError',
    'promptAction'
]);

});

parcelRegister("5sOMZ", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $3fa6f6f21ffa38ee$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.objectShallowCompare = module.exports.argsEqual = void 0;
module.exports.useGridSelector = $3fa6f6f21ffa38ee$var$useGridSelector;

var $3fa6f6f21ffa38ee$var$React = $3fa6f6f21ffa38ee$require$_interopRequireWildcard((parcelRequire("acw62")));

var $325pS = parcelRequire("325pS");

var $9Y8Cp = parcelRequire("9Y8Cp");

var $hfliI = parcelRequire("hfliI");

var $7O6ub = parcelRequire("7O6ub");
const $3fa6f6f21ffa38ee$var$defaultCompare = Object.is;
const $3fa6f6f21ffa38ee$var$objectShallowCompare = module.exports.objectShallowCompare = $325pS.fastObjectShallowCompare;
const $3fa6f6f21ffa38ee$var$arrayShallowCompare = (a, b)=>{
    if (a === b) return true;
    return a.length === b.length && a.every((v, i)=>v === b[i]);
};
const $3fa6f6f21ffa38ee$var$argsEqual = (prev, curr)=>{
    let fn = Object.is;
    if (curr instanceof Array) fn = $3fa6f6f21ffa38ee$var$arrayShallowCompare;
    else if (curr instanceof Object) fn = $3fa6f6f21ffa38ee$var$objectShallowCompare;
    return fn(prev, curr);
};
module.exports.argsEqual = $3fa6f6f21ffa38ee$var$argsEqual;
const $3fa6f6f21ffa38ee$var$createRefs = ()=>({
        state: null,
        equals: null,
        selector: null,
        args: undefined
    });
const $3fa6f6f21ffa38ee$var$EMPTY = [];
const $3fa6f6f21ffa38ee$var$emptyGetSnapshot = ()=>null;
function $3fa6f6f21ffa38ee$var$useGridSelector(apiRef, selector, args, equals = $3fa6f6f21ffa38ee$var$defaultCompare) {
    if (!apiRef.current.state) (0, $9Y8Cp.warnOnce)([
        'MUI X: `useGridSelector` has been called before the initialization of the state.',
        'This hook can only be used inside the context of the grid.'
    ]);
    const refs = (0, $7O6ub.useLazyRef)($3fa6f6f21ffa38ee$var$createRefs);
    const didInit = refs.current.selector !== null;
    const [state, setState] = $3fa6f6f21ffa38ee$var$React.useState(// We don't use an initialization function to avoid allocations
    didInit ? null : selector(apiRef, args));
    refs.current.state = state;
    refs.current.equals = equals;
    refs.current.selector = selector;
    const prevArgs = refs.current.args;
    refs.current.args = args;
    if (didInit && !$3fa6f6f21ffa38ee$var$argsEqual(prevArgs, args)) {
        const newState = refs.current.selector(apiRef, refs.current.args);
        if (!refs.current.equals(refs.current.state, newState)) {
            refs.current.state = newState;
            setState(newState);
        }
    }
    const subscribe = $3fa6f6f21ffa38ee$var$React.useCallback(()=>{
        if (refs.current.subscription) return null;
        refs.current.subscription = apiRef.current.store.subscribe(()=>{
            const newState = refs.current.selector(apiRef, refs.current.args);
            if (!refs.current.equals(refs.current.state, newState)) {
                refs.current.state = newState;
                setState(newState);
            }
        });
        return null;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    $3fa6f6f21ffa38ee$var$EMPTY);
    const unsubscribe = $3fa6f6f21ffa38ee$var$React.useCallback(()=>{
        // Fixes issue in React Strict Mode, where getSnapshot is not called
        if (!refs.current.subscription) subscribe();
        return ()=>{
            if (refs.current.subscription) {
                refs.current.subscription();
                refs.current.subscription = undefined;
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $3fa6f6f21ffa38ee$var$EMPTY);
    (0, $hfliI.useSyncExternalStore)(unsubscribe, subscribe, $3fa6f6f21ffa38ee$var$emptyGetSnapshot);
    return state;
}

});
parcelRegister("325pS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "fastObjectShallowCompare", {
    enumerable: true,
    get: function() {
        return $i3Zsf.fastObjectShallowCompare;
    }
});

var $i3Zsf = parcelRequire("i3Zsf");

});
parcelRegister("i3Zsf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fastObjectShallowCompare = $d2682d6f1fe72d29$var$fastObjectShallowCompare;
const $d2682d6f1fe72d29$var$is = Object.is;
/**
 * Fast shallow compare for objects.
 * @returns true if objects are equal.
 */ function $d2682d6f1fe72d29$var$fastObjectShallowCompare(a, b) {
    if (a === b) return true;
    if (!(a instanceof Object) || !(b instanceof Object)) return false;
    let aLength = 0;
    let bLength = 0;
    /* eslint-disable guard-for-in */ for(const key in a){
        aLength += 1;
        if (!$d2682d6f1fe72d29$var$is(a[key], b[key])) return false;
        if (!(key in b)) return false;
    }
    /* eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/no-unused-vars */ for(const _ in b)bLength += 1;
    return aLength === bLength;
}

});


parcelRegister("9Y8Cp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "clearWarningsCache", {
    enumerable: true,
    get: function() {
        return $3BDjL.clearWarningsCache;
    }
});
Object.defineProperty(module.exports, "warnOnce", {
    enumerable: true,
    get: function() {
        return $3BDjL.warnOnce;
    }
});

var $3BDjL = parcelRequire("3BDjL");

});
parcelRegister("3BDjL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clearWarningsCache = $2a03537a78f99f35$var$clearWarningsCache;
module.exports.warnOnce = $2a03537a78f99f35$var$warnOnce;
const $2a03537a78f99f35$var$warnedOnceCache = new Set();
/**
 * Logs a message to the console on development mode. The warning will only be logged once.
 *
 * The message is the log's cache key. Two identical messages will only be logged once.
 *
 * This function is a no-op in production.
 *
 * @param message the message to log
 * @param gravity the gravity of the warning. Defaults to `'warning'`.
 * @returns
 */ function $2a03537a78f99f35$var$warnOnce(message, gravity = 'warning') {
    const cleanMessage = Array.isArray(message) ? message.join('\n') : message;
    if (!$2a03537a78f99f35$var$warnedOnceCache.has(cleanMessage)) {
        $2a03537a78f99f35$var$warnedOnceCache.add(cleanMessage);
        if (gravity === 'error') console.error(cleanMessage);
        else console.warn(cleanMessage);
    }
}
function $2a03537a78f99f35$var$clearWarningsCache() {
    $2a03537a78f99f35$var$warnedOnceCache.clear();
}

});


parcelRegister("hfliI", function(module, exports) {
'use strict';

module.exports = (parcelRequire("6KR8i"));

});
parcelRegister("6KR8i", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $4eb0410bd318fafe$export$306c0aa65ff9ec16, (v) => $4eb0410bd318fafe$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4eb0410bd318fafe$export$306c0aa65ff9ec16;
"use strict";

(function() {
    function is(x, y) {
        return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
    }
    function useSyncExternalStore$2(subscribe, getSnapshot) {
        didWarnOld18Alpha || void 0 === React.startTransition || (didWarnOld18Alpha = !0, console.error("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
        var value = getSnapshot();
        if (!didWarnUncachedGetSnapshot) {
            var cachedValue = getSnapshot();
            objectIs(value, cachedValue) || (console.error("The result of getSnapshot should be cached to avoid an infinite loop"), didWarnUncachedGetSnapshot = !0);
        }
        cachedValue = useState({
            inst: {
                value: value,
                getSnapshot: getSnapshot
            }
        });
        var inst = cachedValue[0].inst, forceUpdate = cachedValue[1];
        useLayoutEffect(function() {
            inst.value = value;
            inst.getSnapshot = getSnapshot;
            checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        }, [
            subscribe,
            value,
            getSnapshot
        ]);
        useEffect(function() {
            checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
            return subscribe(function() {
                checkIfSnapshotChanged(inst) && forceUpdate({
                    inst: inst
                });
            });
        }, [
            subscribe
        ]);
        useDebugValue(value);
        return value;
    }
    function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        inst = inst.value;
        try {
            var nextValue = latestGetSnapshot();
            return !objectIs(inst, nextValue);
        } catch (error) {
            return !0;
        }
    }
    function useSyncExternalStore$1(subscribe, getSnapshot) {
        return getSnapshot();
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var React = (parcelRequire("acw62")), objectIs = "function" === typeof Object.is ? Object.is : is, useState = React.useState, useEffect = React.useEffect, useLayoutEffect = React.useLayoutEffect, useDebugValue = React.useDebugValue, didWarnOld18Alpha = !1, didWarnUncachedGetSnapshot = !1, shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? useSyncExternalStore$1 : useSyncExternalStore$2;
    $4eb0410bd318fafe$export$306c0aa65ff9ec16 = void 0 !== React.useSyncExternalStore ? React.useSyncExternalStore : shim;
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
})();

});


parcelRegister("7O6ub", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5af23bdc14a3ba8d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "useLazyRef", {
    enumerable: true,
    get: function() {
        return $5af23bdc14a3ba8d$var$_useLazyRef.default;
    }
});

var $5af23bdc14a3ba8d$var$_useLazyRef = $5af23bdc14a3ba8d$require$_interopRequireDefault((parcelRequire("doV3C")));

});


parcelRegister("er55f", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $a82787d0b1c2b050$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridPrivateApiContext = void 0;
module.exports.useGridPrivateApiContext = $a82787d0b1c2b050$var$useGridPrivateApiContext;

var $a82787d0b1c2b050$var$React = $a82787d0b1c2b050$require$_interopRequireWildcard((parcelRequire("acw62")));
const $a82787d0b1c2b050$var$GridPrivateApiContext = module.exports.GridPrivateApiContext = /*#__PURE__*/ $a82787d0b1c2b050$var$React.createContext(undefined);
$a82787d0b1c2b050$var$GridPrivateApiContext.displayName = "GridPrivateApiContext";
function $a82787d0b1c2b050$var$useGridPrivateApiContext() {
    const privateApiRef = $a82787d0b1c2b050$var$React.useContext($a82787d0b1c2b050$var$GridPrivateApiContext);
    if (privateApiRef === undefined) throw new Error([
        'MUI X: Could not find the Data Grid private context.',
        'It looks like you rendered your component outside of a DataGrid, DataGridPro or DataGridPremium parent component.',
        'This can also happen if you are bundling multiple versions of the Data Grid.'
    ].join('\n'));
    return privateApiRef;
}

});




parcelRegister("jZ8n5", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $e8ca352f25b37def$export$bf730a2d8bf68b42, (v) => $e8ca352f25b37def$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e8ca352f25b37def$export$bf730a2d8bf68b42;
"use strict";


(function() {
    function is(x, y) {
        return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var React = (parcelRequire("acw62")), shim = (parcelRequire("hfliI")), objectIs = "function" === typeof Object.is ? Object.is : is, useSyncExternalStore = shim.useSyncExternalStore, useRef = React.useRef, useEffect = React.useEffect, useMemo = React.useMemo, useDebugValue = React.useDebugValue;
    $e8ca352f25b37def$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
        var instRef = useRef(null);
        if (null === instRef.current) {
            var inst = {
                hasValue: !1,
                value: null
            };
            instRef.current = inst;
        } else inst = instRef.current;
        instRef = useMemo(function() {
            function memoizedSelector(nextSnapshot) {
                if (!hasMemo) {
                    hasMemo = !0;
                    memoizedSnapshot = nextSnapshot;
                    nextSnapshot = selector(nextSnapshot);
                    if (void 0 !== isEqual && inst.hasValue) {
                        var currentSelection = inst.value;
                        if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                    }
                    return memoizedSelection = nextSnapshot;
                }
                currentSelection = memoizedSelection;
                if (objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
                var nextSelection = selector(nextSnapshot);
                if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
                memoizedSnapshot = nextSnapshot;
                return memoizedSelection = nextSelection;
            }
            var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
            return [
                function() {
                    return memoizedSelector(getSnapshot());
                },
                null === maybeGetServerSnapshot ? void 0 : function() {
                    return memoizedSelector(maybeGetServerSnapshot());
                }
            ];
        }, [
            getSnapshot,
            getServerSnapshot,
            selector,
            isEqual
        ]);
        var value = useSyncExternalStore(subscribe, instRef[0], instRef[1]);
        useEffect(function() {
            inst.hasValue = !0;
            inst.value = value;
        }, [
            value
        ]);
        useDebugValue(value);
        return value;
    };
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
})();

});

parcelRegister("fGtMU", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $b6b1e281249837b9$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $b6b1e281249837b9$var$_useOnMount.default;
    }
});

var $b6b1e281249837b9$var$_useOnMount = $b6b1e281249837b9$require$_interopRequireDefault((parcelRequire("kWo5z")));

});

parcelRegister("44S7j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isJSDOM = module.exports.isFirefox = module.exports.default = void 0;
const $2f8183a962423c9d$var$userAgent = typeof navigator !== 'undefined' ? navigator.userAgent.toLowerCase() : 'empty';
const $2f8183a962423c9d$var$isFirefox = module.exports.isFirefox = $2f8183a962423c9d$var$userAgent.includes('firefox');
const $2f8183a962423c9d$var$isJSDOM = module.exports.isJSDOM = typeof window !== 'undefined' && /jsdom|HappyDOM/.test(window.navigator.userAgent);
var $2f8183a962423c9d$var$_default = module.exports.default = {
    isFirefox: $2f8183a962423c9d$var$isFirefox,
    isJSDOM: $2f8183a962423c9d$var$isJSDOM
};

});

parcelRegister("5DKOa", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $010f4e0e13c82e16$var$_typeof = $41YNz.default;

var $fKGZD = parcelRequire("fKGZD");
function $010f4e0e13c82e16$var$toPropertyKey(t) {
    var i = $fKGZD(t, "string");
    return "symbol" == $010f4e0e13c82e16$var$_typeof(i) ? i : i + "";
}
module.exports = $010f4e0e13c82e16$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("fKGZD", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $b77c8068776c2a21$var$_typeof = $41YNz.default;
function $b77c8068776c2a21$var$toPrimitive(t, r) {
    if ("object" != $b77c8068776c2a21$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b77c8068776c2a21$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $b77c8068776c2a21$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("2PSrq", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $210a9320270ce251$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "amber", {
    enumerable: true,
    get: function() {
        return $210a9320270ce251$var$_amber.default;
    }
});
Object.defineProperty(module.exports, "blue", {
    enumerable: true,
    get: function() {
        return $210a9320270ce251$var$_blue.default;
    }
});
Object.defineProperty(module.exports, "blueGrey", {
    enumerable: true,
    get: function() {
        return $210a9320270ce251$var$_blueGrey.default;
    }
});
Object.defineProperty(module.exports, "brown", {
    enumerable: true,
    get: function() {
        return $210a9320270ce251$var$_brown.default;
    }
});
Object.defineProperty(module.exports, "common", {
    enumerable: true,
    get: function() {
        return $210a9320270ce251$var$_common.default;
    }
});
Object.defineProperty(module.exports, "cyan", {
    enumerable: true,
    get: function() {
        return $210a9320270ce251$var$_cyan.default;
    }
});
Object.defineProperty(module.exports, "deepOrange", {
    enumerable: true,
    get: function() {
        return $210a9320270ce251$var$_deepOrange.default;
    }
});
Object.defineProperty(module.exports, "deepPurple", {
    enumerable: true,
    get: function() {
        return $210a9320270ce251$var$_deepPurple.default;
    }
});
Object.defineProperty(module.exports, "green", {
    enumerable: true,
    get: function() {
        return $210a9320270ce251$var$_green.default;
    }
});
Object.defineProperty(module.exports, "grey", {
    enumerable: true,
    get: function() {
        return $210a9320270ce251$var$_grey.default;
    }
});
Object.defineProperty(module.exports, "indigo", {
    enumerable: true,
    get: function() {
        return $210a9320270ce251$var$_indigo.default;
    }
});
Object.defineProperty(module.exports, "lightBlue", {
    enumerable: true,
    get: function() {
        return $210a9320270ce251$var$_lightBlue.default;
    }
});
Object.defineProperty(module.exports, "lightGreen", {
    enumerable: true,
    get: function() {
        return $210a9320270ce251$var$_lightGreen.default;
    }
});
Object.defineProperty(module.exports, "lime", {
    enumerable: true,
    get: function() {
        return $210a9320270ce251$var$_lime.default;
    }
});
Object.defineProperty(module.exports, "orange", {
    enumerable: true,
    get: function() {
        return $210a9320270ce251$var$_orange.default;
    }
});
Object.defineProperty(module.exports, "pink", {
    enumerable: true,
    get: function() {
        return $210a9320270ce251$var$_pink.default;
    }
});
Object.defineProperty(module.exports, "purple", {
    enumerable: true,
    get: function() {
        return $210a9320270ce251$var$_purple.default;
    }
});
Object.defineProperty(module.exports, "red", {
    enumerable: true,
    get: function() {
        return $210a9320270ce251$var$_red.default;
    }
});
Object.defineProperty(module.exports, "teal", {
    enumerable: true,
    get: function() {
        return $210a9320270ce251$var$_teal.default;
    }
});
Object.defineProperty(module.exports, "yellow", {
    enumerable: true,
    get: function() {
        return $210a9320270ce251$var$_yellow.default;
    }
});

var $210a9320270ce251$var$_common = $210a9320270ce251$require$_interopRequireDefault((parcelRequire("dzxhF")));

var $210a9320270ce251$var$_red = $210a9320270ce251$require$_interopRequireDefault((parcelRequire("ln9F4")));

var $210a9320270ce251$var$_pink = $210a9320270ce251$require$_interopRequireDefault((parcelRequire("OnZ7a")));

var $210a9320270ce251$var$_purple = $210a9320270ce251$require$_interopRequireDefault((parcelRequire("kSXRh")));

var $210a9320270ce251$var$_deepPurple = $210a9320270ce251$require$_interopRequireDefault((parcelRequire("9XfLT")));

var $210a9320270ce251$var$_indigo = $210a9320270ce251$require$_interopRequireDefault((parcelRequire("gnEXl")));

var $210a9320270ce251$var$_blue = $210a9320270ce251$require$_interopRequireDefault((parcelRequire("bKnBV")));

var $210a9320270ce251$var$_lightBlue = $210a9320270ce251$require$_interopRequireDefault((parcelRequire("iDVue")));

var $210a9320270ce251$var$_cyan = $210a9320270ce251$require$_interopRequireDefault((parcelRequire("fv0vs")));

var $210a9320270ce251$var$_teal = $210a9320270ce251$require$_interopRequireDefault((parcelRequire("cUmH8")));

var $210a9320270ce251$var$_green = $210a9320270ce251$require$_interopRequireDefault((parcelRequire("e4nxq")));

var $210a9320270ce251$var$_lightGreen = $210a9320270ce251$require$_interopRequireDefault((parcelRequire("jdv3V")));

var $210a9320270ce251$var$_lime = $210a9320270ce251$require$_interopRequireDefault((parcelRequire("drMtO")));

var $210a9320270ce251$var$_yellow = $210a9320270ce251$require$_interopRequireDefault((parcelRequire("2dr1n")));

var $210a9320270ce251$var$_amber = $210a9320270ce251$require$_interopRequireDefault((parcelRequire("ffAWJ")));

var $210a9320270ce251$var$_orange = $210a9320270ce251$require$_interopRequireDefault((parcelRequire("dMYym")));

var $210a9320270ce251$var$_deepOrange = $210a9320270ce251$require$_interopRequireDefault((parcelRequire("5n8ns")));

var $210a9320270ce251$var$_brown = $210a9320270ce251$require$_interopRequireDefault((parcelRequire("g9nNw")));

var $210a9320270ce251$var$_grey = $210a9320270ce251$require$_interopRequireDefault((parcelRequire("eU5ou")));

var $210a9320270ce251$var$_blueGrey = $210a9320270ce251$require$_interopRequireDefault((parcelRequire("aZOS8")));

});
parcelRegister("OnZ7a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $0977467e0d52ba8b$var$pink = {
    50: '#fce4ec',
    100: '#f8bbd0',
    200: '#f48fb1',
    300: '#f06292',
    400: '#ec407a',
    500: '#e91e63',
    600: '#d81b60',
    700: '#c2185b',
    800: '#ad1457',
    900: '#880e4f',
    A100: '#ff80ab',
    A200: '#ff4081',
    A400: '#f50057',
    A700: '#c51162'
};
var $0977467e0d52ba8b$var$_default = module.exports.default = $0977467e0d52ba8b$var$pink;

});

parcelRegister("9XfLT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $73f5dba4a86b7528$var$deepPurple = {
    50: '#ede7f6',
    100: '#d1c4e9',
    200: '#b39ddb',
    300: '#9575cd',
    400: '#7e57c2',
    500: '#673ab7',
    600: '#5e35b1',
    700: '#512da8',
    800: '#4527a0',
    900: '#311b92',
    A100: '#b388ff',
    A200: '#7c4dff',
    A400: '#651fff',
    A700: '#6200ea'
};
var $73f5dba4a86b7528$var$_default = module.exports.default = $73f5dba4a86b7528$var$deepPurple;

});

parcelRegister("gnEXl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $bece90587ed49c40$var$indigo = {
    50: '#e8eaf6',
    100: '#c5cae9',
    200: '#9fa8da',
    300: '#7986cb',
    400: '#5c6bc0',
    500: '#3f51b5',
    600: '#3949ab',
    700: '#303f9f',
    800: '#283593',
    900: '#1a237e',
    A100: '#8c9eff',
    A200: '#536dfe',
    A400: '#3d5afe',
    A700: '#304ffe'
};
var $bece90587ed49c40$var$_default = module.exports.default = $bece90587ed49c40$var$indigo;

});

parcelRegister("fv0vs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $b48a24d2f7b64288$var$cyan = {
    50: '#e0f7fa',
    100: '#b2ebf2',
    200: '#80deea',
    300: '#4dd0e1',
    400: '#26c6da',
    500: '#00bcd4',
    600: '#00acc1',
    700: '#0097a7',
    800: '#00838f',
    900: '#006064',
    A100: '#84ffff',
    A200: '#18ffff',
    A400: '#00e5ff',
    A700: '#00b8d4'
};
var $b48a24d2f7b64288$var$_default = module.exports.default = $b48a24d2f7b64288$var$cyan;

});

parcelRegister("cUmH8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $965c51b2111f81b0$var$teal = {
    50: '#e0f2f1',
    100: '#b2dfdb',
    200: '#80cbc4',
    300: '#4db6ac',
    400: '#26a69a',
    500: '#009688',
    600: '#00897b',
    700: '#00796b',
    800: '#00695c',
    900: '#004d40',
    A100: '#a7ffeb',
    A200: '#64ffda',
    A400: '#1de9b6',
    A700: '#00bfa5'
};
var $965c51b2111f81b0$var$_default = module.exports.default = $965c51b2111f81b0$var$teal;

});

parcelRegister("jdv3V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $dfd7538e53c5578e$var$lightGreen = {
    50: '#f1f8e9',
    100: '#dcedc8',
    200: '#c5e1a5',
    300: '#aed581',
    400: '#9ccc65',
    500: '#8bc34a',
    600: '#7cb342',
    700: '#689f38',
    800: '#558b2f',
    900: '#33691e',
    A100: '#ccff90',
    A200: '#b2ff59',
    A400: '#76ff03',
    A700: '#64dd17'
};
var $dfd7538e53c5578e$var$_default = module.exports.default = $dfd7538e53c5578e$var$lightGreen;

});

parcelRegister("drMtO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $9ca367113480e6b8$var$lime = {
    50: '#f9fbe7',
    100: '#f0f4c3',
    200: '#e6ee9c',
    300: '#dce775',
    400: '#d4e157',
    500: '#cddc39',
    600: '#c0ca33',
    700: '#afb42b',
    800: '#9e9d24',
    900: '#827717',
    A100: '#f4ff81',
    A200: '#eeff41',
    A400: '#c6ff00',
    A700: '#aeea00'
};
var $9ca367113480e6b8$var$_default = module.exports.default = $9ca367113480e6b8$var$lime;

});

parcelRegister("2dr1n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $19d1c187b7554b9f$var$yellow = {
    50: '#fffde7',
    100: '#fff9c4',
    200: '#fff59d',
    300: '#fff176',
    400: '#ffee58',
    500: '#ffeb3b',
    600: '#fdd835',
    700: '#fbc02d',
    800: '#f9a825',
    900: '#f57f17',
    A100: '#ffff8d',
    A200: '#ffff00',
    A400: '#ffea00',
    A700: '#ffd600'
};
var $19d1c187b7554b9f$var$_default = module.exports.default = $19d1c187b7554b9f$var$yellow;

});

parcelRegister("ffAWJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $b1a4ea7d0e15a230$var$amber = {
    50: '#fff8e1',
    100: '#ffecb3',
    200: '#ffe082',
    300: '#ffd54f',
    400: '#ffca28',
    500: '#ffc107',
    600: '#ffb300',
    700: '#ffa000',
    800: '#ff8f00',
    900: '#ff6f00',
    A100: '#ffe57f',
    A200: '#ffd740',
    A400: '#ffc400',
    A700: '#ffab00'
};
var $b1a4ea7d0e15a230$var$_default = module.exports.default = $b1a4ea7d0e15a230$var$amber;

});

parcelRegister("5n8ns", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $3e959950983c409e$var$deepOrange = {
    50: '#fbe9e7',
    100: '#ffccbc',
    200: '#ffab91',
    300: '#ff8a65',
    400: '#ff7043',
    500: '#ff5722',
    600: '#f4511e',
    700: '#e64a19',
    800: '#d84315',
    900: '#bf360c',
    A100: '#ff9e80',
    A200: '#ff6e40',
    A400: '#ff3d00',
    A700: '#dd2c00'
};
var $3e959950983c409e$var$_default = module.exports.default = $3e959950983c409e$var$deepOrange;

});

parcelRegister("g9nNw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $bc1ff25570917fdc$var$brown = {
    50: '#efebe9',
    100: '#d7ccc8',
    200: '#bcaaa4',
    300: '#a1887f',
    400: '#8d6e63',
    500: '#795548',
    600: '#6d4c41',
    700: '#5d4037',
    800: '#4e342e',
    900: '#3e2723',
    A100: '#d7ccc8',
    A200: '#bcaaa4',
    A400: '#8d6e63',
    A700: '#5d4037'
};
var $bc1ff25570917fdc$var$_default = module.exports.default = $bc1ff25570917fdc$var$brown;

});

parcelRegister("aZOS8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $801710099648f128$var$blueGrey = {
    50: '#eceff1',
    100: '#cfd8dc',
    200: '#b0bec5',
    300: '#90a4ae',
    400: '#78909c',
    500: '#607d8b',
    600: '#546e7a',
    700: '#455a64',
    800: '#37474f',
    900: '#263238',
    A100: '#cfd8dc',
    A200: '#b0bec5',
    A400: '#78909c',
    A700: '#455a64'
};
var $801710099648f128$var$_default = module.exports.default = $801710099648f128$var$blueGrey;

});


parcelRegister("lH1DK", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $fcaee2cf9d6d9c3f$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $fcaee2cf9d6d9c3f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $fcaee2cf9d6d9c3f$var$_exportNames = {
    accordionClasses: true
};
Object.defineProperty(module.exports, "accordionClasses", {
    enumerable: true,
    get: function() {
        return $fcaee2cf9d6d9c3f$var$_accordionClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $fcaee2cf9d6d9c3f$var$_Accordion.default;
    }
});

var $fcaee2cf9d6d9c3f$var$_Accordion = $fcaee2cf9d6d9c3f$require$_interopRequireDefault((parcelRequire("7UqNi")));

var $fcaee2cf9d6d9c3f$var$_accordionClasses = $fcaee2cf9d6d9c3f$require$_interopRequireWildcard((parcelRequire("jliMD")));
Object.keys($fcaee2cf9d6d9c3f$var$_accordionClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($fcaee2cf9d6d9c3f$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $fcaee2cf9d6d9c3f$var$_accordionClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fcaee2cf9d6d9c3f$var$_accordionClasses[key];
        }
    });
});

});
parcelRegister("7UqNi", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $5c228c234852d575$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $5c228c234852d575$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5c228c234852d575$var$React = $5c228c234852d575$require$_interopRequireWildcard((parcelRequire("acw62")));

var $4jPKB = parcelRequire("4jPKB");

var $5c228c234852d575$var$_propTypes = $5c228c234852d575$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $5c228c234852d575$var$_clsx = $5c228c234852d575$require$_interopRequireDefault((parcelRequire("9QePP")));

var $5c228c234852d575$var$_chainPropTypes = $5c228c234852d575$require$_interopRequireDefault((parcelRequire("abVWF")));

var $5c228c234852d575$var$_composeClasses = $5c228c234852d575$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $5c228c234852d575$var$_memoTheme = $5c228c234852d575$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $5c228c234852d575$var$_Collapse = $5c228c234852d575$require$_interopRequireDefault((parcelRequire("gsEuH")));

var $5c228c234852d575$var$_Paper = $5c228c234852d575$require$_interopRequireDefault((parcelRequire("juRJQ")));

var $5c228c234852d575$var$_AccordionContext = $5c228c234852d575$require$_interopRequireDefault((parcelRequire("7Snug")));

var $5c228c234852d575$var$_useControlled = $5c228c234852d575$require$_interopRequireDefault((parcelRequire("3yddg")));

var $5c228c234852d575$var$_useSlot = $5c228c234852d575$require$_interopRequireDefault((parcelRequire("6lpak")));

var $5c228c234852d575$var$_accordionClasses = $5c228c234852d575$require$_interopRequireWildcard((parcelRequire("jliMD")));

var $ayMG0 = parcelRequire("ayMG0");
const $5c228c234852d575$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, square: square, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            'root',
            !square && 'rounded',
            expanded && 'expanded',
            disabled && 'disabled',
            !disableGutters && 'gutters'
        ],
        heading: [
            'heading'
        ],
        region: [
            'region'
        ]
    };
    return (0, $5c228c234852d575$var$_composeClasses.default)(slots, $5c228c234852d575$var$_accordionClasses.getAccordionUtilityClass, classes);
};
const $5c228c234852d575$var$AccordionRoot = (0, $aAbgT.styled)($5c228c234852d575$var$_Paper.default, {
    name: 'MuiAccordion',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${$5c228c234852d575$var$_accordionClasses.default.region}`]: styles.region
            },
            styles.root,
            !ownerState.square && styles.rounded,
            !ownerState.disableGutters && styles.gutters
        ];
    }
})((0, $5c228c234852d575$var$_memoTheme.default)(({ theme: theme })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        position: 'relative',
        transition: theme.transitions.create([
            'margin'
        ], transition),
        overflowAnchor: 'none',
        // Keep the same scrolling position
        '&::before': {
            position: 'absolute',
            left: 0,
            top: -1,
            right: 0,
            height: 1,
            content: '""',
            opacity: 1,
            backgroundColor: (theme.vars || theme).palette.divider,
            transition: theme.transitions.create([
                'opacity',
                'background-color'
            ], transition)
        },
        '&:first-of-type': {
            '&::before': {
                display: 'none'
            }
        },
        [`&.${$5c228c234852d575$var$_accordionClasses.default.expanded}`]: {
            '&::before': {
                opacity: 0
            },
            '&:first-of-type': {
                marginTop: 0
            },
            '&:last-of-type': {
                marginBottom: 0
            },
            '& + &': {
                '&::before': {
                    display: 'none'
                }
            }
        },
        [`&.${$5c228c234852d575$var$_accordionClasses.default.disabled}`]: {
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        }
    };
}), (0, $5c228c234852d575$var$_memoTheme.default)(({ theme: theme })=>({
        variants: [
            {
                props: (props)=>!props.square,
                style: {
                    borderRadius: 0,
                    '&:first-of-type': {
                        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
                        borderTopRightRadius: (theme.vars || theme).shape.borderRadius
                    },
                    '&:last-of-type': {
                        borderBottomLeftRadius: (theme.vars || theme).shape.borderRadius,
                        borderBottomRightRadius: (theme.vars || theme).shape.borderRadius,
                        // Fix a rendering issue on Edge
                        '@supports (-ms-ime-align: auto)': {
                            borderBottomLeftRadius: 0,
                            borderBottomRightRadius: 0
                        }
                    }
                }
            },
            {
                props: (props)=>!props.disableGutters,
                style: {
                    [`&.${$5c228c234852d575$var$_accordionClasses.default.expanded}`]: {
                        margin: '16px 0'
                    }
                }
            }
        ]
    })));
const $5c228c234852d575$var$AccordionHeading = (0, $aAbgT.styled)('h3', {
    name: 'MuiAccordion',
    slot: 'Heading'
})({
    all: 'unset'
});
const $5c228c234852d575$var$AccordionRegion = (0, $aAbgT.styled)('div', {
    name: 'MuiAccordion',
    slot: 'Region'
})({});
const $5c228c234852d575$var$Accordion = /*#__PURE__*/ $5c228c234852d575$var$React.forwardRef(function Accordion(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordion'
    });
    const { children: childrenProp, className: className, defaultExpanded: defaultExpanded = false, disabled: disabled = false, disableGutters: disableGutters = false, expanded: expandedProp, onChange: onChange, slots: slots = {}, slotProps: slotProps = {}, TransitionComponent: TransitionComponentProp, TransitionProps: TransitionPropsProp, ...other } = props;
    const [expanded, setExpandedState] = (0, $5c228c234852d575$var$_useControlled.default)({
        controlled: expandedProp,
        default: defaultExpanded,
        name: 'Accordion',
        state: 'expanded'
    });
    const handleChange = $5c228c234852d575$var$React.useCallback((event)=>{
        setExpandedState(!expanded);
        if (onChange) onChange(event, !expanded);
    }, [
        expanded,
        onChange,
        setExpandedState
    ]);
    const [summary, ...children] = $5c228c234852d575$var$React.Children.toArray(childrenProp);
    const contextValue = $5c228c234852d575$var$React.useMemo(()=>({
            expanded: expanded,
            disabled: disabled,
            disableGutters: disableGutters,
            toggle: handleChange
        }), [
        expanded,
        disabled,
        disableGutters,
        handleChange
    ]);
    const ownerState = {
        ...props,
        disabled: disabled,
        disableGutters: disableGutters,
        expanded: expanded
    };
    const classes = $5c228c234852d575$var$useUtilityClasses(ownerState);
    const backwardCompatibleSlots = {
        transition: TransitionComponentProp,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        transition: TransitionPropsProp,
        ...slotProps
    };
    const externalForwardedProps = {
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootProps] = (0, $5c228c234852d575$var$_useSlot.default)('root', {
        elementType: $5c228c234852d575$var$AccordionRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        className: (0, $5c228c234852d575$var$_clsx.default)(classes.root, className),
        shouldForwardComponentProp: true,
        ownerState: ownerState,
        ref: ref
    });
    const [AccordionHeadingSlot, accordionProps] = (0, $5c228c234852d575$var$_useSlot.default)('heading', {
        elementType: $5c228c234852d575$var$AccordionHeading,
        externalForwardedProps: externalForwardedProps,
        className: classes.heading,
        ownerState: ownerState
    });
    const [TransitionSlot, transitionProps] = (0, $5c228c234852d575$var$_useSlot.default)('transition', {
        elementType: $5c228c234852d575$var$_Collapse.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [AccordionRegionSlot, accordionRegionProps] = (0, $5c228c234852d575$var$_useSlot.default)('region', {
        elementType: $5c228c234852d575$var$AccordionRegion,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.region,
        additionalProps: {
            'aria-labelledby': summary.props.id,
            id: summary.props['aria-controls'],
            role: 'region'
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(AccordionHeadingSlot, {
                ...accordionProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($5c228c234852d575$var$_AccordionContext.default.Provider, {
                    value: contextValue,
                    children: summary
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionSlot, {
                in: expanded,
                timeout: "auto",
                ...transitionProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(AccordionRegionSlot, {
                    ...accordionRegionProps,
                    children: children
                })
            })
        ]
    });
});
$5c228c234852d575$var$Accordion.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, $5c228c234852d575$var$_chainPropTypes.default)($5c228c234852d575$var$_propTypes.default.node.isRequired, (props)=>{
        const summary = $5c228c234852d575$var$React.Children.toArray(props.children)[0];
        if ((0, $4jPKB.isFragment)(summary)) return new Error("MUI: The Accordion doesn't accept a Fragment as a child. Consider providing an array instead.");
        if (!/*#__PURE__*/ $5c228c234852d575$var$React.isValidElement(summary)) return new Error('MUI: Expected the first child of Accordion to be a valid element.');
        return null;
    }),
    /**
   * Override or extend the styles applied to the component.
   */ classes: $5c228c234852d575$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $5c228c234852d575$var$_propTypes.default.string,
    /**
   * If `true`, expands the accordion by default.
   * @default false
   */ defaultExpanded: $5c228c234852d575$var$_propTypes.default.bool,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: $5c228c234852d575$var$_propTypes.default.bool,
    /**
   * If `true`, it removes the margin between two expanded accordion items and prevents the increased height when expanded.
   * @default false
   */ disableGutters: $5c228c234852d575$var$_propTypes.default.bool,
    /**
   * If `true`, expands the accordion, otherwise collapses it.
   * Setting this prop enables control over the accordion.
   */ expanded: $5c228c234852d575$var$_propTypes.default.bool,
    /**
   * Callback fired when the expand/collapse state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {boolean} expanded The `expanded` state of the accordion.
   */ onChange: $5c228c234852d575$var$_propTypes.default.func,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $5c228c234852d575$var$_propTypes.default.shape({
        heading: $5c228c234852d575$var$_propTypes.default.oneOfType([
            $5c228c234852d575$var$_propTypes.default.func,
            $5c228c234852d575$var$_propTypes.default.object
        ]),
        region: $5c228c234852d575$var$_propTypes.default.oneOfType([
            $5c228c234852d575$var$_propTypes.default.func,
            $5c228c234852d575$var$_propTypes.default.object
        ]),
        root: $5c228c234852d575$var$_propTypes.default.oneOfType([
            $5c228c234852d575$var$_propTypes.default.func,
            $5c228c234852d575$var$_propTypes.default.object
        ]),
        transition: $5c228c234852d575$var$_propTypes.default.oneOfType([
            $5c228c234852d575$var$_propTypes.default.func,
            $5c228c234852d575$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: $5c228c234852d575$var$_propTypes.default.shape({
        heading: $5c228c234852d575$var$_propTypes.default.elementType,
        region: $5c228c234852d575$var$_propTypes.default.elementType,
        root: $5c228c234852d575$var$_propTypes.default.elementType,
        transition: $5c228c234852d575$var$_propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $5c228c234852d575$var$_propTypes.default.oneOfType([
        $5c228c234852d575$var$_propTypes.default.arrayOf($5c228c234852d575$var$_propTypes.default.oneOfType([
            $5c228c234852d575$var$_propTypes.default.func,
            $5c228c234852d575$var$_propTypes.default.object,
            $5c228c234852d575$var$_propTypes.default.bool
        ])),
        $5c228c234852d575$var$_propTypes.default.func,
        $5c228c234852d575$var$_propTypes.default.object
    ]),
    /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated Use `slots.transition` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ TransitionComponent: $5c228c234852d575$var$_propTypes.default.elementType,
    /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated Use `slotProps.transition` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ TransitionProps: $5c228c234852d575$var$_propTypes.default.object
};
var $5c228c234852d575$var$_default = module.exports.default = $5c228c234852d575$var$Accordion;

});
parcelRegister("gsEuH", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $bfbeac2d30cd504d$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $bfbeac2d30cd504d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $bfbeac2d30cd504d$var$_exportNames = {
    collapseClasses: true
};
Object.defineProperty(module.exports, "collapseClasses", {
    enumerable: true,
    get: function() {
        return $bfbeac2d30cd504d$var$_collapseClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $bfbeac2d30cd504d$var$_Collapse.default;
    }
});

var $bfbeac2d30cd504d$var$_Collapse = $bfbeac2d30cd504d$require$_interopRequireDefault((parcelRequire("bnA1h")));

var $bfbeac2d30cd504d$var$_collapseClasses = $bfbeac2d30cd504d$require$_interopRequireWildcard((parcelRequire("38bi6")));
Object.keys($bfbeac2d30cd504d$var$_collapseClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($bfbeac2d30cd504d$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $bfbeac2d30cd504d$var$_collapseClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bfbeac2d30cd504d$var$_collapseClasses[key];
        }
    });
});

});
parcelRegister("bnA1h", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $848dc8709a4309c5$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $848dc8709a4309c5$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $848dc8709a4309c5$var$React = $848dc8709a4309c5$require$_interopRequireWildcard((parcelRequire("acw62")));

var $848dc8709a4309c5$var$_clsx = $848dc8709a4309c5$require$_interopRequireDefault((parcelRequire("9QePP")));

var $848dc8709a4309c5$var$_propTypes = $848dc8709a4309c5$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $1mPeS = parcelRequire("1mPeS");

var $848dc8709a4309c5$var$_useTimeout = $848dc8709a4309c5$require$_interopRequireDefault((parcelRequire("drY8V")));

var $848dc8709a4309c5$var$_elementTypeAcceptingRef = $848dc8709a4309c5$require$_interopRequireDefault((parcelRequire("g6PKz")));

var $848dc8709a4309c5$var$_composeClasses = $848dc8709a4309c5$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $848dc8709a4309c5$var$_memoTheme = $848dc8709a4309c5$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $bmoVh = parcelRequire("bmoVh");

var $hweuE = parcelRequire("hweuE");

var $hGPki = parcelRequire("hGPki");

var $848dc8709a4309c5$var$_useSlot = $848dc8709a4309c5$require$_interopRequireDefault((parcelRequire("6lpak")));

var $38bi6 = parcelRequire("38bi6");

var $ayMG0 = parcelRequire("ayMG0");
const $848dc8709a4309c5$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            orientation
        ],
        entered: [
            'entered'
        ],
        hidden: [
            'hidden'
        ],
        wrapper: [
            'wrapper',
            orientation
        ],
        wrapperInner: [
            'wrapperInner',
            orientation
        ]
    };
    return (0, $848dc8709a4309c5$var$_composeClasses.default)(slots, $38bi6.getCollapseUtilityClass, classes);
};
const $848dc8709a4309c5$var$CollapseRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiCollapse',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.state === 'entered' && styles.entered,
            ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && styles.hidden
        ];
    }
})((0, $848dc8709a4309c5$var$_memoTheme.default)(({ theme: theme })=>({
        height: 0,
        overflow: 'hidden',
        transition: theme.transitions.create('height'),
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 'auto',
                    width: 0,
                    transition: theme.transitions.create('width')
                }
            },
            {
                props: {
                    state: 'entered'
                },
                style: {
                    height: 'auto',
                    overflow: 'visible'
                }
            },
            {
                props: {
                    state: 'entered',
                    orientation: 'horizontal'
                },
                style: {
                    width: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px',
                style: {
                    visibility: 'hidden'
                }
            }
        ]
    })));
const $848dc8709a4309c5$var$CollapseWrapper = (0, $aAbgT.styled)('div', {
    name: 'MuiCollapse',
    slot: 'Wrapper'
})({
    // Hack to get children with a negative margin to not falsify the height computation.
    display: 'flex',
    width: '100%',
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                width: 'auto',
                height: '100%'
            }
        }
    ]
});
const $848dc8709a4309c5$var$CollapseWrapperInner = (0, $aAbgT.styled)('div', {
    name: 'MuiCollapse',
    slot: 'WrapperInner'
})({
    width: '100%',
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                width: 'auto',
                height: '100%'
            }
        }
    ]
});
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $848dc8709a4309c5$var$Collapse = /*#__PURE__*/ $848dc8709a4309c5$var$React.forwardRef(function Collapse(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiCollapse'
    });
    const { addEndListener: addEndListener, children: children, className: className, collapsedSize: collapsedSizeProp = '0px', component: component, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, orientation: orientation = 'vertical', slots: slots = {}, slotProps: slotProps = {}, style: style, timeout: timeout = $bmoVh.duration.standard, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = $1mPeS.default, ...other } = props;
    const ownerState = {
        ...props,
        orientation: orientation,
        collapsedSize: collapsedSizeProp
    };
    const classes = $848dc8709a4309c5$var$useUtilityClasses(ownerState);
    const theme = (0, $aAbgT.useTheme)();
    const timer = (0, $848dc8709a4309c5$var$_useTimeout.default)();
    const wrapperRef = $848dc8709a4309c5$var$React.useRef(null);
    const autoTransitionDuration = $848dc8709a4309c5$var$React.useRef();
    const collapsedSize = typeof collapsedSizeProp === 'number' ? `${collapsedSizeProp}px` : collapsedSizeProp;
    const isHorizontal = orientation === 'horizontal';
    const size = isHorizontal ? 'width' : 'height';
    const nodeRef = $848dc8709a4309c5$var$React.useRef(null);
    const handleRef = (0, $hGPki.useForkRef)(ref, nodeRef);
    const getWrapperSize = ()=>wrapperRef.current ? wrapperRef.current[isHorizontal ? 'clientWidth' : 'clientHeight'] : 0;
    const handleEnter = (0, $hweuE.normalizedTransitionCallback)(nodeRef, (node, isAppearing)=>{
        if (wrapperRef.current && isHorizontal) // Set absolute position to get the size of collapsed content
        wrapperRef.current.style.position = 'absolute';
        node.style[size] = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = (0, $hweuE.normalizedTransitionCallback)(nodeRef, (node, isAppearing)=>{
        const wrapperSize = getWrapperSize();
        if (wrapperRef.current && isHorizontal) // After the size is read reset the position back to default
        wrapperRef.current.style.position = '';
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $hweuE.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        if (timeout === 'auto') {
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = `${wrapperSize}px`;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = (0, $hweuE.normalizedTransitionCallback)(nodeRef, (node, isAppearing)=>{
        node.style[size] = 'auto';
        if (onEntered) onEntered(node, isAppearing);
    });
    const handleExit = (0, $hweuE.normalizedTransitionCallback)(nodeRef, (node)=>{
        node.style[size] = `${getWrapperSize()}px`;
        if (onExit) onExit(node);
    });
    const handleExited = (0, $hweuE.normalizedTransitionCallback)(nodeRef, onExited);
    const handleExiting = (0, $hweuE.normalizedTransitionCallback)(nodeRef, (node)=>{
        const wrapperSize = getWrapperSize();
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $hweuE.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        if (timeout === 'auto') {
            // TODO: rename getAutoHeightDuration to something more generic (width support)
            // Actually it just calculates animation duration based on size
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = collapsedSize;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onExiting) onExiting(node);
    });
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTransitionDuration.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps,
        component: component
    };
    const [RootSlot, rootSlotProps] = (0, $848dc8709a4309c5$var$_useSlot.default)('root', {
        ref: handleRef,
        className: (0, $848dc8709a4309c5$var$_clsx.default)(classes.root, className),
        elementType: $848dc8709a4309c5$var$CollapseRoot,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            style: {
                [isHorizontal ? 'minWidth' : 'minHeight']: collapsedSize,
                ...style
            }
        }
    });
    const [WrapperSlot, wrapperSlotProps] = (0, $848dc8709a4309c5$var$_useSlot.default)('wrapper', {
        ref: wrapperRef,
        className: classes.wrapper,
        elementType: $848dc8709a4309c5$var$CollapseWrapper,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [WrapperInnerSlot, wrapperInnerSlotProps] = (0, $848dc8709a4309c5$var$_useSlot.default)('wrapperInner', {
        className: classes.wrapperInner,
        elementType: $848dc8709a4309c5$var$CollapseWrapperInner,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, {
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        timeout: timeout === 'auto' ? null : timeout,
        ...other,
        children: (state, { ownerState: incomingOwnerState, ...restChildProps })=>{
            const stateOwnerState = {
                ...ownerState,
                state: state
            };
            return /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, {
                ...rootSlotProps,
                className: (0, $848dc8709a4309c5$var$_clsx.default)(rootSlotProps.className, {
                    'entered': classes.entered,
                    'exited': !inProp && collapsedSize === '0px' && classes.hidden
                }[state]),
                ownerState: stateOwnerState,
                ...restChildProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(WrapperSlot, {
                    ...wrapperSlotProps,
                    ownerState: stateOwnerState,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(WrapperInnerSlot, {
                        ...wrapperInnerSlotProps,
                        ownerState: stateOwnerState,
                        children: children
                    })
                })
            });
        }
    });
});
$848dc8709a4309c5$var$Collapse.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */ addEndListener: $848dc8709a4309c5$var$_propTypes.default.func,
    /**
   * The content node to be collapsed.
   */ children: $848dc8709a4309c5$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $848dc8709a4309c5$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $848dc8709a4309c5$var$_propTypes.default.string,
    /**
   * The width (horizontal) or height (vertical) of the container when collapsed.
   * @default '0px'
   */ collapsedSize: $848dc8709a4309c5$var$_propTypes.default.oneOfType([
        $848dc8709a4309c5$var$_propTypes.default.number,
        $848dc8709a4309c5$var$_propTypes.default.string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $848dc8709a4309c5$var$_elementTypeAcceptingRef.default,
    /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */ easing: $848dc8709a4309c5$var$_propTypes.default.oneOfType([
        $848dc8709a4309c5$var$_propTypes.default.shape({
            enter: $848dc8709a4309c5$var$_propTypes.default.string,
            exit: $848dc8709a4309c5$var$_propTypes.default.string
        }),
        $848dc8709a4309c5$var$_propTypes.default.string
    ]),
    /**
   * If `true`, the component will transition in.
   */ in: $848dc8709a4309c5$var$_propTypes.default.bool,
    /**
   * @ignore
   */ onEnter: $848dc8709a4309c5$var$_propTypes.default.func,
    /**
   * @ignore
   */ onEntered: $848dc8709a4309c5$var$_propTypes.default.func,
    /**
   * @ignore
   */ onEntering: $848dc8709a4309c5$var$_propTypes.default.func,
    /**
   * @ignore
   */ onExit: $848dc8709a4309c5$var$_propTypes.default.func,
    /**
   * @ignore
   */ onExited: $848dc8709a4309c5$var$_propTypes.default.func,
    /**
   * @ignore
   */ onExiting: $848dc8709a4309c5$var$_propTypes.default.func,
    /**
   * The transition orientation.
   * @default 'vertical'
   */ orientation: $848dc8709a4309c5$var$_propTypes.default.oneOf([
        'horizontal',
        'vertical'
    ]),
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $848dc8709a4309c5$var$_propTypes.default.shape({
        root: $848dc8709a4309c5$var$_propTypes.default.oneOfType([
            $848dc8709a4309c5$var$_propTypes.default.func,
            $848dc8709a4309c5$var$_propTypes.default.object
        ]),
        wrapper: $848dc8709a4309c5$var$_propTypes.default.oneOfType([
            $848dc8709a4309c5$var$_propTypes.default.func,
            $848dc8709a4309c5$var$_propTypes.default.object
        ]),
        wrapperInner: $848dc8709a4309c5$var$_propTypes.default.oneOfType([
            $848dc8709a4309c5$var$_propTypes.default.func,
            $848dc8709a4309c5$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: $848dc8709a4309c5$var$_propTypes.default.shape({
        root: $848dc8709a4309c5$var$_propTypes.default.elementType,
        wrapper: $848dc8709a4309c5$var$_propTypes.default.elementType,
        wrapperInner: $848dc8709a4309c5$var$_propTypes.default.elementType
    }),
    /**
   * @ignore
   */ style: $848dc8709a4309c5$var$_propTypes.default.object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $848dc8709a4309c5$var$_propTypes.default.oneOfType([
        $848dc8709a4309c5$var$_propTypes.default.arrayOf($848dc8709a4309c5$var$_propTypes.default.oneOfType([
            $848dc8709a4309c5$var$_propTypes.default.func,
            $848dc8709a4309c5$var$_propTypes.default.object,
            $848dc8709a4309c5$var$_propTypes.default.bool
        ])),
        $848dc8709a4309c5$var$_propTypes.default.func,
        $848dc8709a4309c5$var$_propTypes.default.object
    ]),
    /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default duration.standard
   */ timeout: $848dc8709a4309c5$var$_propTypes.default.oneOfType([
        $848dc8709a4309c5$var$_propTypes.default.oneOf([
            'auto'
        ]),
        $848dc8709a4309c5$var$_propTypes.default.number,
        $848dc8709a4309c5$var$_propTypes.default.shape({
            appear: $848dc8709a4309c5$var$_propTypes.default.number,
            enter: $848dc8709a4309c5$var$_propTypes.default.number,
            exit: $848dc8709a4309c5$var$_propTypes.default.number
        })
    ])
};
if ($848dc8709a4309c5$var$Collapse) $848dc8709a4309c5$var$Collapse.muiSupportAuto = true;
var $848dc8709a4309c5$var$_default = module.exports.default = $848dc8709a4309c5$var$Collapse;

});
parcelRegister("38bi6", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $247ae09dccc3464c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getCollapseUtilityClass = $247ae09dccc3464c$var$getCollapseUtilityClass;

var $247ae09dccc3464c$var$_generateUtilityClasses = $247ae09dccc3464c$require$_interopRequireDefault((parcelRequire("5nY49")));

var $247ae09dccc3464c$var$_generateUtilityClass = $247ae09dccc3464c$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $247ae09dccc3464c$var$getCollapseUtilityClass(slot) {
    return (0, $247ae09dccc3464c$var$_generateUtilityClass.default)('MuiCollapse', slot);
}
const $247ae09dccc3464c$var$collapseClasses = (0, $247ae09dccc3464c$var$_generateUtilityClasses.default)('MuiCollapse', [
    'root',
    'horizontal',
    'vertical',
    'entered',
    'hidden',
    'wrapper',
    'wrapperInner'
]);
var $247ae09dccc3464c$var$_default = module.exports.default = $247ae09dccc3464c$var$collapseClasses;

});



parcelRegister("7Snug", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $5bbfcb95732dc207$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5bbfcb95732dc207$var$React = $5bbfcb95732dc207$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */ const $5bbfcb95732dc207$var$AccordionContext = /*#__PURE__*/ $5bbfcb95732dc207$var$React.createContext({});
$5bbfcb95732dc207$var$AccordionContext.displayName = 'AccordionContext';
var $5bbfcb95732dc207$var$_default = module.exports.default = $5bbfcb95732dc207$var$AccordionContext;

});

parcelRegister("jliMD", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e14e8c767477d992$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getAccordionUtilityClass = $e14e8c767477d992$var$getAccordionUtilityClass;

var $e14e8c767477d992$var$_generateUtilityClasses = $e14e8c767477d992$require$_interopRequireDefault((parcelRequire("5nY49")));

var $e14e8c767477d992$var$_generateUtilityClass = $e14e8c767477d992$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $e14e8c767477d992$var$getAccordionUtilityClass(slot) {
    return (0, $e14e8c767477d992$var$_generateUtilityClass.default)('MuiAccordion', slot);
}
const $e14e8c767477d992$var$accordionClasses = (0, $e14e8c767477d992$var$_generateUtilityClasses.default)('MuiAccordion', [
    'root',
    'heading',
    'rounded',
    'expanded',
    'disabled',
    'gutters',
    'region'
]);
var $e14e8c767477d992$var$_default = module.exports.default = $e14e8c767477d992$var$accordionClasses;

});



parcelRegister("qjHPG", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $04f1b704f2eaef84$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $04f1b704f2eaef84$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $04f1b704f2eaef84$var$_exportNames = {
    accordionActionsClasses: true
};
Object.defineProperty(module.exports, "accordionActionsClasses", {
    enumerable: true,
    get: function() {
        return $04f1b704f2eaef84$var$_accordionActionsClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $04f1b704f2eaef84$var$_AccordionActions.default;
    }
});

var $04f1b704f2eaef84$var$_AccordionActions = $04f1b704f2eaef84$require$_interopRequireDefault((parcelRequire("5abSW")));

var $04f1b704f2eaef84$var$_accordionActionsClasses = $04f1b704f2eaef84$require$_interopRequireWildcard((parcelRequire("4nzbK")));
Object.keys($04f1b704f2eaef84$var$_accordionActionsClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($04f1b704f2eaef84$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $04f1b704f2eaef84$var$_accordionActionsClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $04f1b704f2eaef84$var$_accordionActionsClasses[key];
        }
    });
});

});
parcelRegister("5abSW", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $3c271b1069b6d28c$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $3c271b1069b6d28c$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3c271b1069b6d28c$var$React = $3c271b1069b6d28c$require$_interopRequireWildcard((parcelRequire("acw62")));

var $3c271b1069b6d28c$var$_propTypes = $3c271b1069b6d28c$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $3c271b1069b6d28c$var$_clsx = $3c271b1069b6d28c$require$_interopRequireDefault((parcelRequire("9QePP")));

var $3c271b1069b6d28c$var$_composeClasses = $3c271b1069b6d28c$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $4nzbK = parcelRequire("4nzbK");

var $ayMG0 = parcelRequire("ayMG0");
const $3c271b1069b6d28c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, $3c271b1069b6d28c$var$_composeClasses.default)(slots, $4nzbK.getAccordionActionsUtilityClass, classes);
};
const $3c271b1069b6d28c$var$AccordionActionsRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiAccordionActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})({
    display: 'flex',
    alignItems: 'center',
    padding: 8,
    justifyContent: 'flex-end',
    variants: [
        {
            props: (props)=>!props.disableSpacing,
            style: {
                '& > :not(style) ~ :not(style)': {
                    marginLeft: 8
                }
            }
        }
    ]
});
const $3c271b1069b6d28c$var$AccordionActions = /*#__PURE__*/ $3c271b1069b6d28c$var$React.forwardRef(function AccordionActions(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordionActions'
    });
    const { className: className, disableSpacing: disableSpacing = false, ...other } = props;
    const ownerState = {
        ...props,
        disableSpacing: disableSpacing
    };
    const classes = $3c271b1069b6d28c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3c271b1069b6d28c$var$AccordionActionsRoot, {
        className: (0, $3c271b1069b6d28c$var$_clsx.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
$3c271b1069b6d28c$var$AccordionActions.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: $3c271b1069b6d28c$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $3c271b1069b6d28c$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $3c271b1069b6d28c$var$_propTypes.default.string,
    /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */ disableSpacing: $3c271b1069b6d28c$var$_propTypes.default.bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $3c271b1069b6d28c$var$_propTypes.default.oneOfType([
        $3c271b1069b6d28c$var$_propTypes.default.arrayOf($3c271b1069b6d28c$var$_propTypes.default.oneOfType([
            $3c271b1069b6d28c$var$_propTypes.default.func,
            $3c271b1069b6d28c$var$_propTypes.default.object,
            $3c271b1069b6d28c$var$_propTypes.default.bool
        ])),
        $3c271b1069b6d28c$var$_propTypes.default.func,
        $3c271b1069b6d28c$var$_propTypes.default.object
    ])
};
var $3c271b1069b6d28c$var$_default = module.exports.default = $3c271b1069b6d28c$var$AccordionActions;

});
parcelRegister("4nzbK", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $33049b15cd6d3df2$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getAccordionActionsUtilityClass = $33049b15cd6d3df2$var$getAccordionActionsUtilityClass;

var $33049b15cd6d3df2$var$_generateUtilityClasses = $33049b15cd6d3df2$require$_interopRequireDefault((parcelRequire("5nY49")));

var $33049b15cd6d3df2$var$_generateUtilityClass = $33049b15cd6d3df2$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $33049b15cd6d3df2$var$getAccordionActionsUtilityClass(slot) {
    return (0, $33049b15cd6d3df2$var$_generateUtilityClass.default)('MuiAccordionActions', slot);
}
const $33049b15cd6d3df2$var$accordionActionsClasses = (0, $33049b15cd6d3df2$var$_generateUtilityClasses.default)('MuiAccordionActions', [
    'root',
    'spacing'
]);
var $33049b15cd6d3df2$var$_default = module.exports.default = $33049b15cd6d3df2$var$accordionActionsClasses;

});



parcelRegister("e5H02", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $a422e3223044b655$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $a422e3223044b655$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $a422e3223044b655$var$_exportNames = {
    accordionDetailsClasses: true
};
Object.defineProperty(module.exports, "accordionDetailsClasses", {
    enumerable: true,
    get: function() {
        return $a422e3223044b655$var$_accordionDetailsClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $a422e3223044b655$var$_AccordionDetails.default;
    }
});

var $a422e3223044b655$var$_AccordionDetails = $a422e3223044b655$require$_interopRequireDefault((parcelRequire("2mdyF")));

var $a422e3223044b655$var$_accordionDetailsClasses = $a422e3223044b655$require$_interopRequireWildcard((parcelRequire("9t5XO")));
Object.keys($a422e3223044b655$var$_accordionDetailsClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($a422e3223044b655$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $a422e3223044b655$var$_accordionDetailsClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $a422e3223044b655$var$_accordionDetailsClasses[key];
        }
    });
});

});
parcelRegister("2mdyF", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $1b78273c1c27a2e1$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $1b78273c1c27a2e1$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1b78273c1c27a2e1$var$React = $1b78273c1c27a2e1$require$_interopRequireWildcard((parcelRequire("acw62")));

var $1b78273c1c27a2e1$var$_propTypes = $1b78273c1c27a2e1$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $1b78273c1c27a2e1$var$_clsx = $1b78273c1c27a2e1$require$_interopRequireDefault((parcelRequire("9QePP")));

var $1b78273c1c27a2e1$var$_composeClasses = $1b78273c1c27a2e1$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $1b78273c1c27a2e1$var$_memoTheme = $1b78273c1c27a2e1$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $9t5XO = parcelRequire("9t5XO");

var $ayMG0 = parcelRequire("ayMG0");
const $1b78273c1c27a2e1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $1b78273c1c27a2e1$var$_composeClasses.default)(slots, $9t5XO.getAccordionDetailsUtilityClass, classes);
};
const $1b78273c1c27a2e1$var$AccordionDetailsRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiAccordionDetails',
    slot: 'Root'
})((0, $1b78273c1c27a2e1$var$_memoTheme.default)(({ theme: theme })=>({
        padding: theme.spacing(1, 2, 2)
    })));
const $1b78273c1c27a2e1$var$AccordionDetails = /*#__PURE__*/ $1b78273c1c27a2e1$var$React.forwardRef(function AccordionDetails(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordionDetails'
    });
    const { className: className, ...other } = props;
    const ownerState = props;
    const classes = $1b78273c1c27a2e1$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1b78273c1c27a2e1$var$AccordionDetailsRoot, {
        className: (0, $1b78273c1c27a2e1$var$_clsx.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
$1b78273c1c27a2e1$var$AccordionDetails.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: $1b78273c1c27a2e1$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $1b78273c1c27a2e1$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $1b78273c1c27a2e1$var$_propTypes.default.string,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $1b78273c1c27a2e1$var$_propTypes.default.oneOfType([
        $1b78273c1c27a2e1$var$_propTypes.default.arrayOf($1b78273c1c27a2e1$var$_propTypes.default.oneOfType([
            $1b78273c1c27a2e1$var$_propTypes.default.func,
            $1b78273c1c27a2e1$var$_propTypes.default.object,
            $1b78273c1c27a2e1$var$_propTypes.default.bool
        ])),
        $1b78273c1c27a2e1$var$_propTypes.default.func,
        $1b78273c1c27a2e1$var$_propTypes.default.object
    ])
};
var $1b78273c1c27a2e1$var$_default = module.exports.default = $1b78273c1c27a2e1$var$AccordionDetails;

});
parcelRegister("9t5XO", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $6e4b72c3145e33d8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getAccordionDetailsUtilityClass = $6e4b72c3145e33d8$var$getAccordionDetailsUtilityClass;

var $6e4b72c3145e33d8$var$_generateUtilityClasses = $6e4b72c3145e33d8$require$_interopRequireDefault((parcelRequire("5nY49")));

var $6e4b72c3145e33d8$var$_generateUtilityClass = $6e4b72c3145e33d8$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $6e4b72c3145e33d8$var$getAccordionDetailsUtilityClass(slot) {
    return (0, $6e4b72c3145e33d8$var$_generateUtilityClass.default)('MuiAccordionDetails', slot);
}
const $6e4b72c3145e33d8$var$accordionDetailsClasses = (0, $6e4b72c3145e33d8$var$_generateUtilityClasses.default)('MuiAccordionDetails', [
    'root'
]);
var $6e4b72c3145e33d8$var$_default = module.exports.default = $6e4b72c3145e33d8$var$accordionDetailsClasses;

});



parcelRegister("6QcED", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $4fb16a516036be86$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $4fb16a516036be86$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $4fb16a516036be86$var$_exportNames = {
    accordionSummaryClasses: true
};
Object.defineProperty(module.exports, "accordionSummaryClasses", {
    enumerable: true,
    get: function() {
        return $4fb16a516036be86$var$_accordionSummaryClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $4fb16a516036be86$var$_AccordionSummary.default;
    }
});

var $4fb16a516036be86$var$_AccordionSummary = $4fb16a516036be86$require$_interopRequireDefault((parcelRequire("2gURC")));

var $4fb16a516036be86$var$_accordionSummaryClasses = $4fb16a516036be86$require$_interopRequireWildcard((parcelRequire("ijHn9")));
Object.keys($4fb16a516036be86$var$_accordionSummaryClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($4fb16a516036be86$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $4fb16a516036be86$var$_accordionSummaryClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4fb16a516036be86$var$_accordionSummaryClasses[key];
        }
    });
});

});
parcelRegister("2gURC", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $1a792f5a0c37e2ab$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $1a792f5a0c37e2ab$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1a792f5a0c37e2ab$var$React = $1a792f5a0c37e2ab$require$_interopRequireWildcard((parcelRequire("acw62")));

var $1a792f5a0c37e2ab$var$_propTypes = $1a792f5a0c37e2ab$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $1a792f5a0c37e2ab$var$_clsx = $1a792f5a0c37e2ab$require$_interopRequireDefault((parcelRequire("9QePP")));

var $1a792f5a0c37e2ab$var$_composeClasses = $1a792f5a0c37e2ab$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $1a792f5a0c37e2ab$var$_memoTheme = $1a792f5a0c37e2ab$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $1a792f5a0c37e2ab$var$_ButtonBase = $1a792f5a0c37e2ab$require$_interopRequireDefault((parcelRequire("hhs3r")));

var $1a792f5a0c37e2ab$var$_AccordionContext = $1a792f5a0c37e2ab$require$_interopRequireDefault((parcelRequire("7Snug")));

var $1a792f5a0c37e2ab$var$_accordionSummaryClasses = $1a792f5a0c37e2ab$require$_interopRequireWildcard((parcelRequire("ijHn9")));

var $1a792f5a0c37e2ab$var$_useSlot = $1a792f5a0c37e2ab$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $1a792f5a0c37e2ab$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            'root',
            expanded && 'expanded',
            disabled && 'disabled',
            !disableGutters && 'gutters'
        ],
        focusVisible: [
            'focusVisible'
        ],
        content: [
            'content',
            expanded && 'expanded',
            !disableGutters && 'contentGutters'
        ],
        expandIconWrapper: [
            'expandIconWrapper',
            expanded && 'expanded'
        ]
    };
    return (0, $1a792f5a0c37e2ab$var$_composeClasses.default)(slots, $1a792f5a0c37e2ab$var$_accordionSummaryClasses.getAccordionSummaryUtilityClass, classes);
};
const $1a792f5a0c37e2ab$var$AccordionSummaryRoot = (0, $aAbgT.styled)($1a792f5a0c37e2ab$var$_ButtonBase.default, {
    name: 'MuiAccordionSummary',
    slot: 'Root'
})((0, $1a792f5a0c37e2ab$var$_memoTheme.default)(({ theme: theme })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        display: 'flex',
        width: '100%',
        minHeight: 48,
        padding: theme.spacing(0, 2),
        transition: theme.transitions.create([
            'min-height',
            'background-color'
        ], transition),
        [`&.${$1a792f5a0c37e2ab$var$_accordionSummaryClasses.default.focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${$1a792f5a0c37e2ab$var$_accordionSummaryClasses.default.disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`&:hover:not(.${$1a792f5a0c37e2ab$var$_accordionSummaryClasses.default.disabled})`]: {
            cursor: 'pointer'
        },
        variants: [
            {
                props: (props)=>!props.disableGutters,
                style: {
                    [`&.${$1a792f5a0c37e2ab$var$_accordionSummaryClasses.default.expanded}`]: {
                        minHeight: 64
                    }
                }
            }
        ]
    };
}));
const $1a792f5a0c37e2ab$var$AccordionSummaryContent = (0, $aAbgT.styled)('span', {
    name: 'MuiAccordionSummary',
    slot: 'Content'
})((0, $1a792f5a0c37e2ab$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'flex',
        textAlign: 'start',
        flexGrow: 1,
        margin: '12px 0',
        variants: [
            {
                props: (props)=>!props.disableGutters,
                style: {
                    transition: theme.transitions.create([
                        'margin'
                    ], {
                        duration: theme.transitions.duration.shortest
                    }),
                    [`&.${$1a792f5a0c37e2ab$var$_accordionSummaryClasses.default.expanded}`]: {
                        margin: '20px 0'
                    }
                }
            }
        ]
    })));
const $1a792f5a0c37e2ab$var$AccordionSummaryExpandIconWrapper = (0, $aAbgT.styled)('span', {
    name: 'MuiAccordionSummary',
    slot: 'ExpandIconWrapper'
})((0, $1a792f5a0c37e2ab$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'flex',
        color: (theme.vars || theme).palette.action.active,
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${$1a792f5a0c37e2ab$var$_accordionSummaryClasses.default.expanded}`]: {
            transform: 'rotate(180deg)'
        }
    })));
const $1a792f5a0c37e2ab$var$AccordionSummary = /*#__PURE__*/ $1a792f5a0c37e2ab$var$React.forwardRef(function AccordionSummary(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordionSummary'
    });
    const { children: children, className: className, expandIcon: expandIcon, focusVisibleClassName: focusVisibleClassName, onClick: onClick, slots: slots, slotProps: slotProps, ...other } = props;
    const { disabled: disabled = false, disableGutters: disableGutters, expanded: expanded, toggle: toggle } = $1a792f5a0c37e2ab$var$React.useContext($1a792f5a0c37e2ab$var$_AccordionContext.default);
    const handleChange = (event)=>{
        if (toggle) toggle(event);
        if (onClick) onClick(event);
    };
    const ownerState = {
        ...props,
        expanded: expanded,
        disabled: disabled,
        disableGutters: disableGutters
    };
    const classes = $1a792f5a0c37e2ab$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootSlotProps] = (0, $1a792f5a0c37e2ab$var$_useSlot.default)('root', {
        ref: ref,
        shouldForwardComponentProp: true,
        className: (0, $1a792f5a0c37e2ab$var$_clsx.default)(classes.root, className),
        elementType: $1a792f5a0c37e2ab$var$AccordionSummaryRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        additionalProps: {
            focusRipple: false,
            disableRipple: true,
            disabled: disabled,
            'aria-expanded': expanded,
            focusVisibleClassName: (0, $1a792f5a0c37e2ab$var$_clsx.default)(classes.focusVisible, focusVisibleClassName)
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onClick: (event)=>{
                    handlers.onClick?.(event);
                    handleChange(event);
                }
            })
    });
    const [ContentSlot, contentSlotProps] = (0, $1a792f5a0c37e2ab$var$_useSlot.default)('content', {
        className: classes.content,
        elementType: $1a792f5a0c37e2ab$var$AccordionSummaryContent,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ExpandIconWrapperSlot, expandIconWrapperSlotProps] = (0, $1a792f5a0c37e2ab$var$_useSlot.default)('expandIconWrapper', {
        className: classes.expandIconWrapper,
        elementType: $1a792f5a0c37e2ab$var$AccordionSummaryExpandIconWrapper,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(ContentSlot, {
                ...contentSlotProps,
                children: children
            }),
            expandIcon && /*#__PURE__*/ (0, $ayMG0.jsx)(ExpandIconWrapperSlot, {
                ...expandIconWrapperSlotProps,
                children: expandIcon
            })
        ]
    });
});
$1a792f5a0c37e2ab$var$AccordionSummary.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: $1a792f5a0c37e2ab$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $1a792f5a0c37e2ab$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $1a792f5a0c37e2ab$var$_propTypes.default.string,
    /**
   * The icon to display as the expand indicator.
   */ expandIcon: $1a792f5a0c37e2ab$var$_propTypes.default.node,
    /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */ focusVisibleClassName: $1a792f5a0c37e2ab$var$_propTypes.default.string,
    /**
   * @ignore
   */ onClick: $1a792f5a0c37e2ab$var$_propTypes.default.func,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $1a792f5a0c37e2ab$var$_propTypes.default.shape({
        content: $1a792f5a0c37e2ab$var$_propTypes.default.oneOfType([
            $1a792f5a0c37e2ab$var$_propTypes.default.func,
            $1a792f5a0c37e2ab$var$_propTypes.default.object
        ]),
        expandIconWrapper: $1a792f5a0c37e2ab$var$_propTypes.default.oneOfType([
            $1a792f5a0c37e2ab$var$_propTypes.default.func,
            $1a792f5a0c37e2ab$var$_propTypes.default.object
        ]),
        root: $1a792f5a0c37e2ab$var$_propTypes.default.oneOfType([
            $1a792f5a0c37e2ab$var$_propTypes.default.func,
            $1a792f5a0c37e2ab$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: $1a792f5a0c37e2ab$var$_propTypes.default.shape({
        content: $1a792f5a0c37e2ab$var$_propTypes.default.elementType,
        expandIconWrapper: $1a792f5a0c37e2ab$var$_propTypes.default.elementType,
        root: $1a792f5a0c37e2ab$var$_propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $1a792f5a0c37e2ab$var$_propTypes.default.oneOfType([
        $1a792f5a0c37e2ab$var$_propTypes.default.arrayOf($1a792f5a0c37e2ab$var$_propTypes.default.oneOfType([
            $1a792f5a0c37e2ab$var$_propTypes.default.func,
            $1a792f5a0c37e2ab$var$_propTypes.default.object,
            $1a792f5a0c37e2ab$var$_propTypes.default.bool
        ])),
        $1a792f5a0c37e2ab$var$_propTypes.default.func,
        $1a792f5a0c37e2ab$var$_propTypes.default.object
    ])
};
var $1a792f5a0c37e2ab$var$_default = module.exports.default = $1a792f5a0c37e2ab$var$AccordionSummary;

});
parcelRegister("ijHn9", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d55ba52db43b55df$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getAccordionSummaryUtilityClass = $d55ba52db43b55df$var$getAccordionSummaryUtilityClass;

var $d55ba52db43b55df$var$_generateUtilityClasses = $d55ba52db43b55df$require$_interopRequireDefault((parcelRequire("5nY49")));

var $d55ba52db43b55df$var$_generateUtilityClass = $d55ba52db43b55df$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $d55ba52db43b55df$var$getAccordionSummaryUtilityClass(slot) {
    return (0, $d55ba52db43b55df$var$_generateUtilityClass.default)('MuiAccordionSummary', slot);
}
const $d55ba52db43b55df$var$accordionSummaryClasses = (0, $d55ba52db43b55df$var$_generateUtilityClasses.default)('MuiAccordionSummary', [
    'root',
    'expanded',
    'focusVisible',
    'disabled',
    'gutters',
    'contentGutters',
    'content',
    'expandIconWrapper'
]);
var $d55ba52db43b55df$var$_default = module.exports.default = $d55ba52db43b55df$var$accordionSummaryClasses;

});



parcelRegister("16wD6", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $0cdfa98b6f9a20c7$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $0cdfa98b6f9a20c7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $0cdfa98b6f9a20c7$var$_exportNames = {
    alertClasses: true
};
Object.defineProperty(module.exports, "alertClasses", {
    enumerable: true,
    get: function() {
        return $0cdfa98b6f9a20c7$var$_alertClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $0cdfa98b6f9a20c7$var$_Alert.default;
    }
});

var $0cdfa98b6f9a20c7$var$_Alert = $0cdfa98b6f9a20c7$require$_interopRequireDefault((parcelRequire("iwiZ3")));

var $0cdfa98b6f9a20c7$var$_alertClasses = $0cdfa98b6f9a20c7$require$_interopRequireWildcard((parcelRequire("2xI7c")));
Object.keys($0cdfa98b6f9a20c7$var$_alertClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($0cdfa98b6f9a20c7$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $0cdfa98b6f9a20c7$var$_alertClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $0cdfa98b6f9a20c7$var$_alertClasses[key];
        }
    });
});

});
parcelRegister("iwiZ3", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $d7b9f0ef25189a24$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $d7b9f0ef25189a24$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d7b9f0ef25189a24$var$React = $d7b9f0ef25189a24$require$_interopRequireWildcard((parcelRequire("acw62")));

var $d7b9f0ef25189a24$var$_propTypes = $d7b9f0ef25189a24$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $d7b9f0ef25189a24$var$_clsx = $d7b9f0ef25189a24$require$_interopRequireDefault((parcelRequire("9QePP")));

var $d7b9f0ef25189a24$var$_composeClasses = $d7b9f0ef25189a24$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $d7b9f0ef25189a24$var$_memoTheme = $d7b9f0ef25189a24$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $d7b9f0ef25189a24$var$_useSlot = $d7b9f0ef25189a24$require$_interopRequireDefault((parcelRequire("6lpak")));

var $d7b9f0ef25189a24$var$_capitalize = $d7b9f0ef25189a24$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $d7b9f0ef25189a24$var$_createSimplePaletteValueFilter = $d7b9f0ef25189a24$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $d7b9f0ef25189a24$var$_Paper = $d7b9f0ef25189a24$require$_interopRequireDefault((parcelRequire("juRJQ")));

var $d7b9f0ef25189a24$var$_alertClasses = $d7b9f0ef25189a24$require$_interopRequireWildcard((parcelRequire("2xI7c")));

var $d7b9f0ef25189a24$var$_IconButton = $d7b9f0ef25189a24$require$_interopRequireDefault((parcelRequire("825Zh")));

var $d7b9f0ef25189a24$var$_SuccessOutlined = $d7b9f0ef25189a24$require$_interopRequireDefault((parcelRequire("1hqLn")));

var $d7b9f0ef25189a24$var$_ReportProblemOutlined = $d7b9f0ef25189a24$require$_interopRequireDefault((parcelRequire("8kXp7")));

var $d7b9f0ef25189a24$var$_ErrorOutline = $d7b9f0ef25189a24$require$_interopRequireDefault((parcelRequire("f42XJ")));

var $d7b9f0ef25189a24$var$_InfoOutlined = $d7b9f0ef25189a24$require$_interopRequireDefault((parcelRequire("a8MtG")));

var $d7b9f0ef25189a24$var$_Close = $d7b9f0ef25189a24$require$_interopRequireDefault((parcelRequire("ldBGF")));

var $ayMG0 = parcelRequire("ayMG0");
const $d7b9f0ef25189a24$var$useUtilityClasses = (ownerState)=>{
    const { variant: variant, color: color, severity: severity, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $d7b9f0ef25189a24$var$_capitalize.default)(color || severity)}`,
            `${variant}${(0, $d7b9f0ef25189a24$var$_capitalize.default)(color || severity)}`,
            `${variant}`
        ],
        icon: [
            'icon'
        ],
        message: [
            'message'
        ],
        action: [
            'action'
        ]
    };
    return (0, $d7b9f0ef25189a24$var$_composeClasses.default)(slots, $d7b9f0ef25189a24$var$_alertClasses.getAlertUtilityClass, classes);
};
const $d7b9f0ef25189a24$var$AlertRoot = (0, $aAbgT.styled)($d7b9f0ef25189a24$var$_Paper.default, {
    name: 'MuiAlert',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $d7b9f0ef25189a24$var$_capitalize.default)(ownerState.color || ownerState.severity)}`]
        ];
    }
})((0, $d7b9f0ef25189a24$var$_memoTheme.default)(({ theme: theme })=>{
    const getColor = theme.palette.mode === 'light' ? theme.darken : theme.lighten;
    const getBackgroundColor = theme.palette.mode === 'light' ? theme.lighten : theme.darken;
    return {
        ...theme.typography.body2,
        backgroundColor: 'transparent',
        display: 'flex',
        padding: '6px 16px',
        variants: [
            ...Object.entries(theme.palette).filter((0, $d7b9f0ef25189a24$var$_createSimplePaletteValueFilter.default)([
                'light'
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'standard'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
                        [`& .${$d7b9f0ef25189a24$var$_alertClasses.default.icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $d7b9f0ef25189a24$var$_createSimplePaletteValueFilter.default)([
                'light'
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'outlined'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        border: `1px solid ${(theme.vars || theme).palette[color].light}`,
                        [`& .${$d7b9f0ef25189a24$var$_alertClasses.default.icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $d7b9f0ef25189a24$var$_createSimplePaletteValueFilter.default)([
                'dark'
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'filled'
                    },
                    style: {
                        fontWeight: theme.typography.fontWeightMedium,
                        ...theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}FilledColor`],
                            backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
                        } : {
                            backgroundColor: theme.palette.mode === 'dark' ? theme.palette[color].dark : theme.palette[color].main,
                            color: theme.palette.getContrastText(theme.palette[color].main)
                        }
                    }
                }))
        ]
    };
}));
const $d7b9f0ef25189a24$var$AlertIcon = (0, $aAbgT.styled)('div', {
    name: 'MuiAlert',
    slot: 'Icon'
})({
    marginRight: 12,
    padding: '7px 0',
    display: 'flex',
    fontSize: 22,
    opacity: 0.9
});
const $d7b9f0ef25189a24$var$AlertMessage = (0, $aAbgT.styled)('div', {
    name: 'MuiAlert',
    slot: 'Message'
})({
    padding: '8px 0',
    minWidth: 0,
    overflow: 'auto'
});
const $d7b9f0ef25189a24$var$AlertAction = (0, $aAbgT.styled)('div', {
    name: 'MuiAlert',
    slot: 'Action'
})({
    display: 'flex',
    alignItems: 'flex-start',
    padding: '4px 0 0 16px',
    marginLeft: 'auto',
    marginRight: -8
});
const $d7b9f0ef25189a24$var$defaultIconMapping = {
    success: /*#__PURE__*/ (0, $ayMG0.jsx)($d7b9f0ef25189a24$var$_SuccessOutlined.default, {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ (0, $ayMG0.jsx)($d7b9f0ef25189a24$var$_ReportProblemOutlined.default, {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ (0, $ayMG0.jsx)($d7b9f0ef25189a24$var$_ErrorOutline.default, {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ (0, $ayMG0.jsx)($d7b9f0ef25189a24$var$_InfoOutlined.default, {
        fontSize: "inherit"
    })
};
const $d7b9f0ef25189a24$var$Alert = /*#__PURE__*/ $d7b9f0ef25189a24$var$React.forwardRef(function Alert(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiAlert'
    });
    const { action: action, children: children, className: className, closeText: closeText = 'Close', color: color, components: components = {}, componentsProps: componentsProps = {}, icon: icon, iconMapping: iconMapping = $d7b9f0ef25189a24$var$defaultIconMapping, onClose: onClose, role: role = 'alert', severity: severity = 'success', slotProps: slotProps = {}, slots: slots = {}, variant: variant = 'standard', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        severity: severity,
        variant: variant,
        colorSeverity: color || severity
    };
    const classes = $d7b9f0ef25189a24$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: {
            closeButton: components.CloseButton,
            closeIcon: components.CloseIcon,
            ...slots
        },
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, $d7b9f0ef25189a24$var$_useSlot.default)('root', {
        ref: ref,
        shouldForwardComponentProp: true,
        className: (0, $d7b9f0ef25189a24$var$_clsx.default)(classes.root, className),
        elementType: $d7b9f0ef25189a24$var$AlertRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        additionalProps: {
            role: role,
            elevation: 0
        }
    });
    const [IconSlot, iconSlotProps] = (0, $d7b9f0ef25189a24$var$_useSlot.default)('icon', {
        className: classes.icon,
        elementType: $d7b9f0ef25189a24$var$AlertIcon,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [MessageSlot, messageSlotProps] = (0, $d7b9f0ef25189a24$var$_useSlot.default)('message', {
        className: classes.message,
        elementType: $d7b9f0ef25189a24$var$AlertMessage,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ActionSlot, actionSlotProps] = (0, $d7b9f0ef25189a24$var$_useSlot.default)('action', {
        className: classes.action,
        elementType: $d7b9f0ef25189a24$var$AlertAction,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [CloseButtonSlot, closeButtonProps] = (0, $d7b9f0ef25189a24$var$_useSlot.default)('closeButton', {
        elementType: $d7b9f0ef25189a24$var$_IconButton.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [CloseIconSlot, closeIconProps] = (0, $d7b9f0ef25189a24$var$_useSlot.default)('closeIcon', {
        elementType: $d7b9f0ef25189a24$var$_Close.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            icon !== false ? /*#__PURE__*/ (0, $ayMG0.jsx)(IconSlot, {
                ...iconSlotProps,
                children: icon || iconMapping[severity] || $d7b9f0ef25189a24$var$defaultIconMapping[severity]
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)(MessageSlot, {
                ...messageSlotProps,
                children: children
            }),
            action != null ? /*#__PURE__*/ (0, $ayMG0.jsx)(ActionSlot, {
                ...actionSlotProps,
                children: action
            }) : null,
            action == null && onClose ? /*#__PURE__*/ (0, $ayMG0.jsx)(ActionSlot, {
                ...actionSlotProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(CloseButtonSlot, {
                    size: "small",
                    "aria-label": closeText,
                    title: closeText,
                    color: "inherit",
                    onClick: onClose,
                    ...closeButtonProps,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(CloseIconSlot, {
                        fontSize: "small",
                        ...closeIconProps
                    })
                })
            }) : null
        ]
    });
});
$d7b9f0ef25189a24$var$Alert.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The action to display. It renders after the message, at the end of the alert.
   */ action: $d7b9f0ef25189a24$var$_propTypes.default.node,
    /**
   * The content of the component.
   */ children: $d7b9f0ef25189a24$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $d7b9f0ef25189a24$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $d7b9f0ef25189a24$var$_propTypes.default.string,
    /**
   * Override the default label for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Close'
   */ closeText: $d7b9f0ef25189a24$var$_propTypes.default.string,
    /**
   * The color of the component. Unless provided, the value is taken from the `severity` prop.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */ color: $d7b9f0ef25189a24$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $d7b9f0ef25189a24$var$_propTypes.default.oneOf([
            'error',
            'info',
            'success',
            'warning'
        ]),
        $d7b9f0ef25189a24$var$_propTypes.default.string
    ]),
    /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */ components: $d7b9f0ef25189a24$var$_propTypes.default.shape({
        CloseButton: $d7b9f0ef25189a24$var$_propTypes.default.elementType,
        CloseIcon: $d7b9f0ef25189a24$var$_propTypes.default.elementType
    }),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */ componentsProps: $d7b9f0ef25189a24$var$_propTypes.default.shape({
        closeButton: $d7b9f0ef25189a24$var$_propTypes.default.object,
        closeIcon: $d7b9f0ef25189a24$var$_propTypes.default.object
    }),
    /**
   * Override the icon displayed before the children.
   * Unless provided, the icon is mapped to the value of the `severity` prop.
   * Set to `false` to remove the `icon`.
   */ icon: $d7b9f0ef25189a24$var$_propTypes.default.node,
    /**
   * The component maps the `severity` prop to a range of different icons,
   * for instance success to `<SuccessOutlined>`.
   * If you wish to change this mapping, you can provide your own.
   * Alternatively, you can use the `icon` prop to override the icon displayed.
   */ iconMapping: $d7b9f0ef25189a24$var$_propTypes.default.shape({
        error: $d7b9f0ef25189a24$var$_propTypes.default.node,
        info: $d7b9f0ef25189a24$var$_propTypes.default.node,
        success: $d7b9f0ef25189a24$var$_propTypes.default.node,
        warning: $d7b9f0ef25189a24$var$_propTypes.default.node
    }),
    /**
   * Callback fired when the component requests to be closed.
   * When provided and no `action` prop is set, a close icon button is displayed that triggers the callback when clicked.
   * @param {React.SyntheticEvent} event The event source of the callback.
   */ onClose: $d7b9f0ef25189a24$var$_propTypes.default.func,
    /**
   * The ARIA role attribute of the element.
   * @default 'alert'
   */ role: $d7b9f0ef25189a24$var$_propTypes.default.string,
    /**
   * The severity of the alert. This defines the color and icon used.
   * @default 'success'
   */ severity: $d7b9f0ef25189a24$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $d7b9f0ef25189a24$var$_propTypes.default.oneOf([
            'error',
            'info',
            'success',
            'warning'
        ]),
        $d7b9f0ef25189a24$var$_propTypes.default.string
    ]),
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $d7b9f0ef25189a24$var$_propTypes.default.shape({
        action: $d7b9f0ef25189a24$var$_propTypes.default.oneOfType([
            $d7b9f0ef25189a24$var$_propTypes.default.func,
            $d7b9f0ef25189a24$var$_propTypes.default.object
        ]),
        closeButton: $d7b9f0ef25189a24$var$_propTypes.default.oneOfType([
            $d7b9f0ef25189a24$var$_propTypes.default.func,
            $d7b9f0ef25189a24$var$_propTypes.default.object
        ]),
        closeIcon: $d7b9f0ef25189a24$var$_propTypes.default.oneOfType([
            $d7b9f0ef25189a24$var$_propTypes.default.func,
            $d7b9f0ef25189a24$var$_propTypes.default.object
        ]),
        icon: $d7b9f0ef25189a24$var$_propTypes.default.oneOfType([
            $d7b9f0ef25189a24$var$_propTypes.default.func,
            $d7b9f0ef25189a24$var$_propTypes.default.object
        ]),
        message: $d7b9f0ef25189a24$var$_propTypes.default.oneOfType([
            $d7b9f0ef25189a24$var$_propTypes.default.func,
            $d7b9f0ef25189a24$var$_propTypes.default.object
        ]),
        root: $d7b9f0ef25189a24$var$_propTypes.default.oneOfType([
            $d7b9f0ef25189a24$var$_propTypes.default.func,
            $d7b9f0ef25189a24$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: $d7b9f0ef25189a24$var$_propTypes.default.shape({
        action: $d7b9f0ef25189a24$var$_propTypes.default.elementType,
        closeButton: $d7b9f0ef25189a24$var$_propTypes.default.elementType,
        closeIcon: $d7b9f0ef25189a24$var$_propTypes.default.elementType,
        icon: $d7b9f0ef25189a24$var$_propTypes.default.elementType,
        message: $d7b9f0ef25189a24$var$_propTypes.default.elementType,
        root: $d7b9f0ef25189a24$var$_propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $d7b9f0ef25189a24$var$_propTypes.default.oneOfType([
        $d7b9f0ef25189a24$var$_propTypes.default.arrayOf($d7b9f0ef25189a24$var$_propTypes.default.oneOfType([
            $d7b9f0ef25189a24$var$_propTypes.default.func,
            $d7b9f0ef25189a24$var$_propTypes.default.object,
            $d7b9f0ef25189a24$var$_propTypes.default.bool
        ])),
        $d7b9f0ef25189a24$var$_propTypes.default.func,
        $d7b9f0ef25189a24$var$_propTypes.default.object
    ]),
    /**
   * The variant to use.
   * @default 'standard'
   */ variant: $d7b9f0ef25189a24$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $d7b9f0ef25189a24$var$_propTypes.default.oneOf([
            'filled',
            'outlined',
            'standard'
        ]),
        $d7b9f0ef25189a24$var$_propTypes.default.string
    ])
};
var $d7b9f0ef25189a24$var$_default = module.exports.default = $d7b9f0ef25189a24$var$Alert;

});
parcelRegister("2xI7c", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $1da0e229d53b4459$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getAlertUtilityClass = $1da0e229d53b4459$var$getAlertUtilityClass;

var $1da0e229d53b4459$var$_generateUtilityClasses = $1da0e229d53b4459$require$_interopRequireDefault((parcelRequire("5nY49")));

var $1da0e229d53b4459$var$_generateUtilityClass = $1da0e229d53b4459$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $1da0e229d53b4459$var$getAlertUtilityClass(slot) {
    return (0, $1da0e229d53b4459$var$_generateUtilityClass.default)('MuiAlert', slot);
}
const $1da0e229d53b4459$var$alertClasses = (0, $1da0e229d53b4459$var$_generateUtilityClasses.default)('MuiAlert', [
    'root',
    'action',
    'icon',
    'message',
    'filled',
    'colorSuccess',
    'colorInfo',
    'colorWarning',
    'colorError',
    'filledSuccess',
    'filledInfo',
    'filledWarning',
    'filledError',
    'outlined',
    'outlinedSuccess',
    'outlinedInfo',
    'outlinedWarning',
    'outlinedError',
    'standard',
    'standardSuccess',
    'standardInfo',
    'standardWarning',
    'standardError'
]);
var $1da0e229d53b4459$var$_default = module.exports.default = $1da0e229d53b4459$var$alertClasses;

});

parcelRegister("1hqLn", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $0eec239707c48bf2$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0eec239707c48bf2$var$_createSvgIcon = $0eec239707c48bf2$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $0eec239707c48bf2$var$_default = module.exports.default = (0, $0eec239707c48bf2$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), 'SuccessOutlined');

});

parcelRegister("8kXp7", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $611e456547a52fc7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $611e456547a52fc7$var$_createSvgIcon = $611e456547a52fc7$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $611e456547a52fc7$var$_default = module.exports.default = (0, $611e456547a52fc7$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), 'ReportProblemOutlined');

});

parcelRegister("f42XJ", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $af7987087272cca1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af7987087272cca1$var$_createSvgIcon = $af7987087272cca1$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $af7987087272cca1$var$_default = module.exports.default = (0, $af7987087272cca1$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline');

});

parcelRegister("a8MtG", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $76204164d2201318$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76204164d2201318$var$_createSvgIcon = $76204164d2201318$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $76204164d2201318$var$_default = module.exports.default = (0, $76204164d2201318$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), 'InfoOutlined');

});



parcelRegister("bkkWw", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $83f1cec610e0702c$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $83f1cec610e0702c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $83f1cec610e0702c$var$_exportNames = {
    alertTitleClasses: true
};
Object.defineProperty(module.exports, "alertTitleClasses", {
    enumerable: true,
    get: function() {
        return $83f1cec610e0702c$var$_alertTitleClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $83f1cec610e0702c$var$_AlertTitle.default;
    }
});

var $83f1cec610e0702c$var$_AlertTitle = $83f1cec610e0702c$require$_interopRequireDefault((parcelRequire("hvpJ1")));

var $83f1cec610e0702c$var$_alertTitleClasses = $83f1cec610e0702c$require$_interopRequireWildcard((parcelRequire("cFmTX")));
Object.keys($83f1cec610e0702c$var$_alertTitleClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($83f1cec610e0702c$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $83f1cec610e0702c$var$_alertTitleClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $83f1cec610e0702c$var$_alertTitleClasses[key];
        }
    });
});

});
parcelRegister("hvpJ1", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $cbe9496169f0560d$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $cbe9496169f0560d$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cbe9496169f0560d$var$React = $cbe9496169f0560d$require$_interopRequireWildcard((parcelRequire("acw62")));

var $cbe9496169f0560d$var$_propTypes = $cbe9496169f0560d$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $cbe9496169f0560d$var$_clsx = $cbe9496169f0560d$require$_interopRequireDefault((parcelRequire("9QePP")));

var $cbe9496169f0560d$var$_composeClasses = $cbe9496169f0560d$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $cbe9496169f0560d$var$_memoTheme = $cbe9496169f0560d$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $cbe9496169f0560d$var$_Typography = $cbe9496169f0560d$require$_interopRequireDefault((parcelRequire("2dUd7")));

var $cFmTX = parcelRequire("cFmTX");

var $ayMG0 = parcelRequire("ayMG0");
const $cbe9496169f0560d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $cbe9496169f0560d$var$_composeClasses.default)(slots, $cFmTX.getAlertTitleUtilityClass, classes);
};
const $cbe9496169f0560d$var$AlertTitleRoot = (0, $aAbgT.styled)($cbe9496169f0560d$var$_Typography.default, {
    name: 'MuiAlertTitle',
    slot: 'Root'
})((0, $cbe9496169f0560d$var$_memoTheme.default)(({ theme: theme })=>{
    return {
        fontWeight: theme.typography.fontWeightMedium,
        marginTop: -2
    };
}));
const $cbe9496169f0560d$var$AlertTitle = /*#__PURE__*/ $cbe9496169f0560d$var$React.forwardRef(function AlertTitle(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiAlertTitle'
    });
    const { className: className, ...other } = props;
    const ownerState = props;
    const classes = $cbe9496169f0560d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($cbe9496169f0560d$var$AlertTitleRoot, {
        gutterBottom: true,
        component: "div",
        ownerState: ownerState,
        ref: ref,
        className: (0, $cbe9496169f0560d$var$_clsx.default)(classes.root, className),
        ...other
    });
});
$cbe9496169f0560d$var$AlertTitle.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: $cbe9496169f0560d$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $cbe9496169f0560d$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $cbe9496169f0560d$var$_propTypes.default.string,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $cbe9496169f0560d$var$_propTypes.default.oneOfType([
        $cbe9496169f0560d$var$_propTypes.default.arrayOf($cbe9496169f0560d$var$_propTypes.default.oneOfType([
            $cbe9496169f0560d$var$_propTypes.default.func,
            $cbe9496169f0560d$var$_propTypes.default.object,
            $cbe9496169f0560d$var$_propTypes.default.bool
        ])),
        $cbe9496169f0560d$var$_propTypes.default.func,
        $cbe9496169f0560d$var$_propTypes.default.object
    ])
};
var $cbe9496169f0560d$var$_default = module.exports.default = $cbe9496169f0560d$var$AlertTitle;

});
parcelRegister("cFmTX", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $938b1427b9e9a19f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getAlertTitleUtilityClass = $938b1427b9e9a19f$var$getAlertTitleUtilityClass;

var $938b1427b9e9a19f$var$_generateUtilityClasses = $938b1427b9e9a19f$require$_interopRequireDefault((parcelRequire("5nY49")));

var $938b1427b9e9a19f$var$_generateUtilityClass = $938b1427b9e9a19f$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $938b1427b9e9a19f$var$getAlertTitleUtilityClass(slot) {
    return (0, $938b1427b9e9a19f$var$_generateUtilityClass.default)('MuiAlertTitle', slot);
}
const $938b1427b9e9a19f$var$alertTitleClasses = (0, $938b1427b9e9a19f$var$_generateUtilityClasses.default)('MuiAlertTitle', [
    'root'
]);
var $938b1427b9e9a19f$var$_default = module.exports.default = $938b1427b9e9a19f$var$alertTitleClasses;

});



parcelRegister("kvdH6", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $eed1534592dd796b$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $eed1534592dd796b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $eed1534592dd796b$var$_exportNames = {
    appBarClasses: true
};
Object.defineProperty(module.exports, "appBarClasses", {
    enumerable: true,
    get: function() {
        return $eed1534592dd796b$var$_appBarClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $eed1534592dd796b$var$_AppBar.default;
    }
});

var $eed1534592dd796b$var$_AppBar = $eed1534592dd796b$require$_interopRequireDefault((parcelRequire("4M9OB")));

var $eed1534592dd796b$var$_appBarClasses = $eed1534592dd796b$require$_interopRequireWildcard((parcelRequire("6c6m6")));
Object.keys($eed1534592dd796b$var$_appBarClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($eed1534592dd796b$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $eed1534592dd796b$var$_appBarClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eed1534592dd796b$var$_appBarClasses[key];
        }
    });
});

});
parcelRegister("4M9OB", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $37a342382669398e$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $37a342382669398e$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $37a342382669398e$var$React = $37a342382669398e$require$_interopRequireWildcard((parcelRequire("acw62")));

var $37a342382669398e$var$_propTypes = $37a342382669398e$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $37a342382669398e$var$_clsx = $37a342382669398e$require$_interopRequireDefault((parcelRequire("9QePP")));

var $37a342382669398e$var$_composeClasses = $37a342382669398e$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $37a342382669398e$var$_memoTheme = $37a342382669398e$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $37a342382669398e$var$_capitalize = $37a342382669398e$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $37a342382669398e$var$_createSimplePaletteValueFilter = $37a342382669398e$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $37a342382669398e$var$_Paper = $37a342382669398e$require$_interopRequireDefault((parcelRequire("juRJQ")));

var $6c6m6 = parcelRequire("6c6m6");

var $ayMG0 = parcelRequire("ayMG0");
const $37a342382669398e$var$useUtilityClasses = (ownerState)=>{
    const { color: color, position: position, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $37a342382669398e$var$_capitalize.default)(color)}`,
            `position${(0, $37a342382669398e$var$_capitalize.default)(position)}`
        ]
    };
    return (0, $37a342382669398e$var$_composeClasses.default)(slots, $6c6m6.getAppBarUtilityClass, classes);
};
// var2 is the fallback.
// Ex. var1: 'var(--a)', var2: 'var(--b)'; return: 'var(--a, var(--b))'
const $37a342382669398e$var$joinVars = (var1, var2)=>var1 ? `${var1.replace(')', '')}, ${var2})` : var2;
const $37a342382669398e$var$AppBarRoot = (0, $aAbgT.styled)($37a342382669398e$var$_Paper.default, {
    name: 'MuiAppBar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, $37a342382669398e$var$_capitalize.default)(ownerState.position)}`],
            styles[`color${(0, $37a342382669398e$var$_capitalize.default)(ownerState.color)}`]
        ];
    }
})((0, $37a342382669398e$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        boxSizing: 'border-box',
        // Prevent padding issue with the Modal and fixed positioned AppBar.
        flexShrink: 0,
        variants: [
            {
                props: {
                    position: 'fixed'
                },
                style: {
                    position: 'fixed',
                    zIndex: (theme.vars || theme).zIndex.appBar,
                    top: 0,
                    left: 'auto',
                    right: 0,
                    '@media print': {
                        // Prevent the app bar to be visible on each printed page.
                        position: 'absolute'
                    }
                }
            },
            {
                props: {
                    position: 'absolute'
                },
                style: {
                    position: 'absolute',
                    zIndex: (theme.vars || theme).zIndex.appBar,
                    top: 0,
                    left: 'auto',
                    right: 0
                }
            },
            {
                props: {
                    position: 'sticky'
                },
                style: {
                    position: 'sticky',
                    zIndex: (theme.vars || theme).zIndex.appBar,
                    top: 0,
                    left: 'auto',
                    right: 0
                }
            },
            {
                props: {
                    position: 'static'
                },
                style: {
                    position: 'static'
                }
            },
            {
                props: {
                    position: 'relative'
                },
                style: {
                    position: 'relative'
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    '--AppBar-color': 'inherit',
                    color: 'var(--AppBar-color)'
                }
            },
            {
                props: {
                    color: 'default'
                },
                style: {
                    '--AppBar-background': theme.vars ? theme.vars.palette.AppBar.defaultBg : theme.palette.grey[100],
                    '--AppBar-color': theme.vars ? theme.vars.palette.text.primary : theme.palette.getContrastText(theme.palette.grey[100]),
                    ...theme.applyStyles('dark', {
                        '--AppBar-background': theme.vars ? theme.vars.palette.AppBar.defaultBg : theme.palette.grey[900],
                        '--AppBar-color': theme.vars ? theme.vars.palette.text.primary : theme.palette.getContrastText(theme.palette.grey[900])
                    })
                }
            },
            ...Object.entries(theme.palette).filter((0, $37a342382669398e$var$_createSimplePaletteValueFilter.default)([
                'contrastText'
            ])).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--AppBar-background': (theme.vars ?? theme).palette[color].main,
                        '--AppBar-color': (theme.vars ?? theme).palette[color].contrastText
                    }
                })),
            {
                props: (props)=>props.enableColorOnDark === true && ![
                        'inherit',
                        'transparent'
                    ].includes(props.color),
                style: {
                    backgroundColor: 'var(--AppBar-background)',
                    color: 'var(--AppBar-color)'
                }
            },
            {
                props: (props)=>props.enableColorOnDark === false && ![
                        'inherit',
                        'transparent'
                    ].includes(props.color),
                style: {
                    backgroundColor: 'var(--AppBar-background)',
                    color: 'var(--AppBar-color)',
                    ...theme.applyStyles('dark', {
                        backgroundColor: theme.vars ? $37a342382669398e$var$joinVars(theme.vars.palette.AppBar.darkBg, 'var(--AppBar-background)') : null,
                        color: theme.vars ? $37a342382669398e$var$joinVars(theme.vars.palette.AppBar.darkColor, 'var(--AppBar-color)') : null
                    })
                }
            },
            {
                props: {
                    color: 'transparent'
                },
                style: {
                    '--AppBar-background': 'transparent',
                    '--AppBar-color': 'inherit',
                    backgroundColor: 'var(--AppBar-background)',
                    color: 'var(--AppBar-color)',
                    ...theme.applyStyles('dark', {
                        backgroundImage: 'none'
                    })
                }
            }
        ]
    })));
const $37a342382669398e$var$AppBar = /*#__PURE__*/ $37a342382669398e$var$React.forwardRef(function AppBar(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiAppBar'
    });
    const { className: className, color: color = 'primary', enableColorOnDark: enableColorOnDark = false, position: position = 'fixed', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        position: position,
        enableColorOnDark: enableColorOnDark
    };
    const classes = $37a342382669398e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($37a342382669398e$var$AppBarRoot, {
        square: true,
        component: "header",
        ownerState: ownerState,
        elevation: 4,
        className: (0, $37a342382669398e$var$_clsx.default)(classes.root, className, position === 'fixed' && 'mui-fixed'),
        ref: ref,
        ...other
    });
});
$37a342382669398e$var$AppBar.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: $37a342382669398e$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $37a342382669398e$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $37a342382669398e$var$_propTypes.default.string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */ color: $37a342382669398e$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $37a342382669398e$var$_propTypes.default.oneOf([
            'default',
            'inherit',
            'primary',
            'secondary',
            'transparent',
            'error',
            'info',
            'success',
            'warning'
        ]),
        $37a342382669398e$var$_propTypes.default.string
    ]),
    /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 4
   */ elevation: $37a342382669398e$var$_propTypes.default.number,
    /**
   * If true, the `color` prop is applied in dark mode.
   * @default false
   */ enableColorOnDark: $37a342382669398e$var$_propTypes.default.bool,
    /**
   * The positioning type. The behavior of the different options is described
   * [in the MDN web docs](https://developer.mozilla.org/en-US/docs/Web/CSS/Reference/Properties/position).
   * Note: `sticky` is not universally supported and will fall back to `static` when unavailable.
   * @default 'fixed'
   */ position: $37a342382669398e$var$_propTypes.default.oneOf([
        'absolute',
        'fixed',
        'relative',
        'static',
        'sticky'
    ]),
    /**
   * If `false`, rounded corners are enabled.
   * @default true
   */ square: $37a342382669398e$var$_propTypes.default.bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $37a342382669398e$var$_propTypes.default.oneOfType([
        $37a342382669398e$var$_propTypes.default.arrayOf($37a342382669398e$var$_propTypes.default.oneOfType([
            $37a342382669398e$var$_propTypes.default.func,
            $37a342382669398e$var$_propTypes.default.object,
            $37a342382669398e$var$_propTypes.default.bool
        ])),
        $37a342382669398e$var$_propTypes.default.func,
        $37a342382669398e$var$_propTypes.default.object
    ])
};
var $37a342382669398e$var$_default = module.exports.default = $37a342382669398e$var$AppBar;

});
parcelRegister("6c6m6", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $4828cb1f30b841b0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getAppBarUtilityClass = $4828cb1f30b841b0$var$getAppBarUtilityClass;

var $4828cb1f30b841b0$var$_generateUtilityClasses = $4828cb1f30b841b0$require$_interopRequireDefault((parcelRequire("5nY49")));

var $4828cb1f30b841b0$var$_generateUtilityClass = $4828cb1f30b841b0$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $4828cb1f30b841b0$var$getAppBarUtilityClass(slot) {
    return (0, $4828cb1f30b841b0$var$_generateUtilityClass.default)('MuiAppBar', slot);
}
const $4828cb1f30b841b0$var$appBarClasses = (0, $4828cb1f30b841b0$var$_generateUtilityClasses.default)('MuiAppBar', [
    'root',
    'positionFixed',
    'positionAbsolute',
    'positionSticky',
    'positionStatic',
    'positionRelative',
    'colorDefault',
    'colorPrimary',
    'colorSecondary',
    'colorInherit',
    'colorTransparent',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning'
]);
var $4828cb1f30b841b0$var$_default = module.exports.default = $4828cb1f30b841b0$var$appBarClasses;

});



parcelRegister("kpeRy", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $edb1abe77b6ce3b3$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $edb1abe77b6ce3b3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $edb1abe77b6ce3b3$var$_exportNames = {
    avatarClasses: true
};
Object.defineProperty(module.exports, "avatarClasses", {
    enumerable: true,
    get: function() {
        return $edb1abe77b6ce3b3$var$_avatarClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $edb1abe77b6ce3b3$var$_Avatar.default;
    }
});

var $edb1abe77b6ce3b3$var$_Avatar = $edb1abe77b6ce3b3$require$_interopRequireDefault((parcelRequire("26QC4")));

var $edb1abe77b6ce3b3$var$_avatarClasses = $edb1abe77b6ce3b3$require$_interopRequireWildcard((parcelRequire("68Vfr")));
Object.keys($edb1abe77b6ce3b3$var$_avatarClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($edb1abe77b6ce3b3$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $edb1abe77b6ce3b3$var$_avatarClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $edb1abe77b6ce3b3$var$_avatarClasses[key];
        }
    });
});

});
parcelRegister("26QC4", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $1894f4268467302e$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $1894f4268467302e$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1894f4268467302e$var$React = $1894f4268467302e$require$_interopRequireWildcard((parcelRequire("acw62")));

var $1894f4268467302e$var$_propTypes = $1894f4268467302e$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $1894f4268467302e$var$_clsx = $1894f4268467302e$require$_interopRequireDefault((parcelRequire("9QePP")));

var $1894f4268467302e$var$_composeClasses = $1894f4268467302e$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $1894f4268467302e$var$_memoTheme = $1894f4268467302e$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $1894f4268467302e$var$_Person = $1894f4268467302e$require$_interopRequireDefault((parcelRequire("df4uV")));

var $68Vfr = parcelRequire("68Vfr");

var $1894f4268467302e$var$_useSlot = $1894f4268467302e$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $1894f4268467302e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, colorDefault: colorDefault } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            colorDefault && 'colorDefault'
        ],
        img: [
            'img'
        ],
        fallback: [
            'fallback'
        ]
    };
    return (0, $1894f4268467302e$var$_composeClasses.default)(slots, $68Vfr.getAvatarUtilityClass, classes);
};
const $1894f4268467302e$var$AvatarRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiAvatar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.colorDefault && styles.colorDefault
        ];
    }
})((0, $1894f4268467302e$var$_memoTheme.default)(({ theme: theme })=>({
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        width: 40,
        height: 40,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(20),
        lineHeight: 1,
        borderRadius: '50%',
        overflow: 'hidden',
        userSelect: 'none',
        variants: [
            {
                props: {
                    variant: 'rounded'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius
                }
            },
            {
                props: {
                    variant: 'square'
                },
                style: {
                    borderRadius: 0
                }
            },
            {
                props: {
                    colorDefault: true
                },
                style: {
                    color: (theme.vars || theme).palette.background.default,
                    ...theme.vars ? {
                        backgroundColor: theme.vars.palette.Avatar.defaultBg
                    } : {
                        backgroundColor: theme.palette.grey[400],
                        ...theme.applyStyles('dark', {
                            backgroundColor: theme.palette.grey[600]
                        })
                    }
                }
            }
        ]
    })));
const $1894f4268467302e$var$AvatarImg = (0, $aAbgT.styled)('img', {
    name: 'MuiAvatar',
    slot: 'Img'
})({
    width: '100%',
    height: '100%',
    textAlign: 'center',
    // Handle non-square image.
    objectFit: 'cover',
    // Hide alt text.
    color: 'transparent',
    // Hide the image broken icon, only works on Chrome.
    textIndent: 10000
});
const $1894f4268467302e$var$AvatarFallback = (0, $aAbgT.styled)($1894f4268467302e$var$_Person.default, {
    name: 'MuiAvatar',
    slot: 'Fallback'
})({
    width: '75%',
    height: '75%'
});
function $1894f4268467302e$var$useLoaded({ crossOrigin: crossOrigin, referrerPolicy: referrerPolicy, src: src, srcSet: srcSet }) {
    const [loaded, setLoaded] = $1894f4268467302e$var$React.useState(false);
    $1894f4268467302e$var$React.useEffect(()=>{
        if (!src && !srcSet) return undefined;
        setLoaded(false);
        let active = true;
        const image = new Image();
        image.onload = ()=>{
            if (!active) return;
            setLoaded('loaded');
        };
        image.onerror = ()=>{
            if (!active) return;
            setLoaded('error');
        };
        image.crossOrigin = crossOrigin;
        image.referrerPolicy = referrerPolicy;
        image.src = src;
        if (srcSet) image.srcset = srcSet;
        return ()=>{
            active = false;
        };
    }, [
        crossOrigin,
        referrerPolicy,
        src,
        srcSet
    ]);
    return loaded;
}
const $1894f4268467302e$var$Avatar = /*#__PURE__*/ $1894f4268467302e$var$React.forwardRef(function Avatar(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiAvatar'
    });
    const { alt: alt, children: childrenProp, className: className, component: component = 'div', slots: slots = {}, slotProps: slotProps = {}, imgProps: imgProps, sizes: sizes, src: src, srcSet: srcSet, variant: variant = 'circular', ...other } = props;
    let children = null;
    const ownerState = {
        ...props,
        component: component,
        variant: variant
    };
    // Use a hook instead of onError on the img element to support server-side rendering.
    const loaded = $1894f4268467302e$var$useLoaded({
        ...imgProps,
        ...typeof slotProps.img === 'function' ? slotProps.img(ownerState) : slotProps.img,
        src: src,
        srcSet: srcSet
    });
    const hasImg = src || srcSet;
    const hasImgNotFailing = hasImg && loaded !== 'error';
    ownerState.colorDefault = !hasImgNotFailing;
    // This issue explains why this is required: https://github.com/mui/material-ui/issues/42184
    delete ownerState.ownerState;
    const classes = $1894f4268467302e$var$useUtilityClasses(ownerState);
    const [RootSlot, rootSlotProps] = (0, $1894f4268467302e$var$_useSlot.default)('root', {
        ref: ref,
        className: (0, $1894f4268467302e$var$_clsx.default)(classes.root, className),
        elementType: $1894f4268467302e$var$AvatarRoot,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps,
            component: component,
            ...other
        },
        ownerState: ownerState
    });
    const [ImgSlot, imgSlotProps] = (0, $1894f4268467302e$var$_useSlot.default)('img', {
        className: classes.img,
        elementType: $1894f4268467302e$var$AvatarImg,
        externalForwardedProps: {
            slots: slots,
            slotProps: {
                img: {
                    ...imgProps,
                    ...slotProps.img
                }
            }
        },
        additionalProps: {
            alt: alt,
            src: src,
            srcSet: srcSet,
            sizes: sizes
        },
        ownerState: ownerState
    });
    const [FallbackSlot, fallbackSlotProps] = (0, $1894f4268467302e$var$_useSlot.default)('fallback', {
        className: classes.fallback,
        elementType: $1894f4268467302e$var$AvatarFallback,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps
        },
        shouldForwardComponentProp: true,
        ownerState: ownerState
    });
    if (hasImgNotFailing) children = /*#__PURE__*/ (0, $ayMG0.jsx)(ImgSlot, {
        ...imgSlotProps
    });
    else if (!!childrenProp || childrenProp === 0) children = childrenProp;
    else if (hasImg && alt) children = alt[0];
    else children = /*#__PURE__*/ (0, $ayMG0.jsx)(FallbackSlot, {
        ...fallbackSlotProps
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, {
        ...rootSlotProps,
        children: children
    });
});
$1894f4268467302e$var$Avatar.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Used in combination with `src` or `srcSet` to
   * provide an alt attribute for the rendered `img` element.
   */ alt: $1894f4268467302e$var$_propTypes.default.string,
    /**
   * Used to render icon or text elements inside the Avatar if `src` is not set.
   * This can be an element, or just a string.
   */ children: $1894f4268467302e$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $1894f4268467302e$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $1894f4268467302e$var$_propTypes.default.string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $1894f4268467302e$var$_propTypes.default.elementType,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/img#attributes) applied to the `img` element if the component is used to display an image.
   * It can be used to listen for the loading error event.
   * @deprecated Use `slotProps.img` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ imgProps: $1894f4268467302e$var$_propTypes.default.object,
    /**
   * The `sizes` attribute for the `img` element.
   */ sizes: $1894f4268467302e$var$_propTypes.default.string,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $1894f4268467302e$var$_propTypes.default.shape({
        fallback: $1894f4268467302e$var$_propTypes.default.oneOfType([
            $1894f4268467302e$var$_propTypes.default.func,
            $1894f4268467302e$var$_propTypes.default.object
        ]),
        img: $1894f4268467302e$var$_propTypes.default.oneOfType([
            $1894f4268467302e$var$_propTypes.default.func,
            $1894f4268467302e$var$_propTypes.default.object
        ]),
        root: $1894f4268467302e$var$_propTypes.default.oneOfType([
            $1894f4268467302e$var$_propTypes.default.func,
            $1894f4268467302e$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: $1894f4268467302e$var$_propTypes.default.shape({
        fallback: $1894f4268467302e$var$_propTypes.default.elementType,
        img: $1894f4268467302e$var$_propTypes.default.elementType,
        root: $1894f4268467302e$var$_propTypes.default.elementType
    }),
    /**
   * The `src` attribute for the `img` element.
   */ src: $1894f4268467302e$var$_propTypes.default.string,
    /**
   * The `srcSet` attribute for the `img` element.
   * Use this attribute for responsive image display.
   */ srcSet: $1894f4268467302e$var$_propTypes.default.string,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $1894f4268467302e$var$_propTypes.default.oneOfType([
        $1894f4268467302e$var$_propTypes.default.arrayOf($1894f4268467302e$var$_propTypes.default.oneOfType([
            $1894f4268467302e$var$_propTypes.default.func,
            $1894f4268467302e$var$_propTypes.default.object,
            $1894f4268467302e$var$_propTypes.default.bool
        ])),
        $1894f4268467302e$var$_propTypes.default.func,
        $1894f4268467302e$var$_propTypes.default.object
    ]),
    /**
   * The shape of the avatar.
   * @default 'circular'
   */ variant: $1894f4268467302e$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $1894f4268467302e$var$_propTypes.default.oneOf([
            'circular',
            'rounded',
            'square'
        ]),
        $1894f4268467302e$var$_propTypes.default.string
    ])
};
var $1894f4268467302e$var$_default = module.exports.default = $1894f4268467302e$var$Avatar;

});
parcelRegister("df4uV", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $9a402a389bd8b499$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9a402a389bd8b499$var$_createSvgIcon = $9a402a389bd8b499$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $9a402a389bd8b499$var$_default = module.exports.default = (0, $9a402a389bd8b499$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), 'Person');

});

parcelRegister("68Vfr", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $478fe5b437ab8d6f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getAvatarUtilityClass = $478fe5b437ab8d6f$var$getAvatarUtilityClass;

var $478fe5b437ab8d6f$var$_generateUtilityClasses = $478fe5b437ab8d6f$require$_interopRequireDefault((parcelRequire("5nY49")));

var $478fe5b437ab8d6f$var$_generateUtilityClass = $478fe5b437ab8d6f$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $478fe5b437ab8d6f$var$getAvatarUtilityClass(slot) {
    return (0, $478fe5b437ab8d6f$var$_generateUtilityClass.default)('MuiAvatar', slot);
}
const $478fe5b437ab8d6f$var$avatarClasses = (0, $478fe5b437ab8d6f$var$_generateUtilityClasses.default)('MuiAvatar', [
    'root',
    'colorDefault',
    'circular',
    'rounded',
    'square',
    'img',
    'fallback'
]);
var $478fe5b437ab8d6f$var$_default = module.exports.default = $478fe5b437ab8d6f$var$avatarClasses;

});



parcelRegister("aHDU0", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $7cacdf50dce7d54d$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $7cacdf50dce7d54d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $7cacdf50dce7d54d$var$_exportNames = {
    avatarGroupClasses: true
};
Object.defineProperty(module.exports, "avatarGroupClasses", {
    enumerable: true,
    get: function() {
        return $7cacdf50dce7d54d$var$_avatarGroupClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $7cacdf50dce7d54d$var$_AvatarGroup.default;
    }
});

var $7cacdf50dce7d54d$var$_AvatarGroup = $7cacdf50dce7d54d$require$_interopRequireDefault((parcelRequire("9CTjG")));

var $7cacdf50dce7d54d$var$_avatarGroupClasses = $7cacdf50dce7d54d$require$_interopRequireWildcard((parcelRequire("iFLib")));
Object.keys($7cacdf50dce7d54d$var$_avatarGroupClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($7cacdf50dce7d54d$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $7cacdf50dce7d54d$var$_avatarGroupClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7cacdf50dce7d54d$var$_avatarGroupClasses[key];
        }
    });
});

});
parcelRegister("9CTjG", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $70229258f609d599$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $70229258f609d599$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $70229258f609d599$var$React = $70229258f609d599$require$_interopRequireWildcard((parcelRequire("acw62")));

var $70229258f609d599$var$_propTypes = $70229258f609d599$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $4jPKB = parcelRequire("4jPKB");

var $70229258f609d599$var$_clsx = $70229258f609d599$require$_interopRequireDefault((parcelRequire("9QePP")));

var $70229258f609d599$var$_chainPropTypes = $70229258f609d599$require$_interopRequireDefault((parcelRequire("abVWF")));

var $70229258f609d599$var$_composeClasses = $70229258f609d599$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $70229258f609d599$var$_memoTheme = $70229258f609d599$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $70229258f609d599$var$_Avatar = $70229258f609d599$require$_interopRequireWildcard((parcelRequire("kpeRy")));

var $70229258f609d599$var$_avatarGroupClasses = $70229258f609d599$require$_interopRequireWildcard((parcelRequire("iFLib")));

var $70229258f609d599$var$_useSlot = $70229258f609d599$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $70229258f609d599$var$SPACINGS = {
    small: -16,
    medium: -8
};
const $70229258f609d599$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        avatar: [
            'avatar'
        ]
    };
    return (0, $70229258f609d599$var$_composeClasses.default)(slots, $70229258f609d599$var$_avatarGroupClasses.getAvatarGroupUtilityClass, classes);
};
const $70229258f609d599$var$AvatarGroupRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiAvatarGroup',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        return [
            {
                [`& .${$70229258f609d599$var$_avatarGroupClasses.default.avatar}`]: styles.avatar
            },
            styles.root
        ];
    }
})((0, $70229258f609d599$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'flex',
        flexDirection: 'row-reverse',
        [`& .${$70229258f609d599$var$_Avatar.avatarClasses.root}`]: {
            border: `2px solid ${(theme.vars || theme).palette.background.default}`,
            boxSizing: 'content-box',
            marginLeft: 'var(--AvatarGroup-spacing, -8px)',
            '&:last-child': {
                marginLeft: 0
            }
        }
    })));
const $70229258f609d599$var$AvatarGroup = /*#__PURE__*/ $70229258f609d599$var$React.forwardRef(function AvatarGroup(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiAvatarGroup'
    });
    const { children: childrenProp, className: className, component: component = 'div', componentsProps: componentsProps, max: max = 5, renderSurplus: renderSurplus, slotProps: slotProps = {}, slots: slots = {}, spacing: spacing = 'medium', total: total, variant: variant = 'circular', ...other } = props;
    let clampedMax = max < 2 ? 2 : max;
    const ownerState = {
        ...props,
        max: max,
        spacing: spacing,
        component: component,
        variant: variant
    };
    const classes = $70229258f609d599$var$useUtilityClasses(ownerState);
    const children = $70229258f609d599$var$React.Children.toArray(childrenProp).filter((child)=>{
        if ((0, $4jPKB.isFragment)(child)) console.error([
            "MUI: The AvatarGroup component doesn't accept a Fragment as a child.",
            'Consider providing an array instead.'
        ].join('\n'));
        return /*#__PURE__*/ $70229258f609d599$var$React.isValidElement(child);
    });
    const totalAvatars = total || children.length;
    if (totalAvatars === clampedMax) clampedMax += 1;
    clampedMax = Math.min(totalAvatars + 1, clampedMax);
    const maxAvatars = Math.min(children.length, clampedMax - 1);
    const extraAvatars = Math.max(totalAvatars - clampedMax, totalAvatars - maxAvatars, 0);
    const extraAvatarsElement = renderSurplus ? renderSurplus(extraAvatars) : `+${extraAvatars}`;
    let marginValue;
    if (ownerState.spacing && $70229258f609d599$var$SPACINGS[ownerState.spacing] !== undefined) marginValue = $70229258f609d599$var$SPACINGS[ownerState.spacing];
    else if (ownerState.spacing === 0) marginValue = 0;
    else marginValue = -ownerState.spacing || $70229258f609d599$var$SPACINGS.medium;
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            surplus: slotProps.additionalAvatar ?? componentsProps?.additionalAvatar,
            ...componentsProps,
            ...slotProps
        }
    };
    const [SurplusSlot, surplusProps] = (0, $70229258f609d599$var$_useSlot.default)('surplus', {
        elementType: $70229258f609d599$var$_Avatar.default,
        externalForwardedProps: externalForwardedProps,
        className: classes.avatar,
        ownerState: ownerState,
        additionalProps: {
            variant: variant
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($70229258f609d599$var$AvatarGroupRoot, {
        as: component,
        ownerState: ownerState,
        className: (0, $70229258f609d599$var$_clsx.default)(classes.root, className),
        ref: ref,
        ...other,
        style: {
            '--AvatarGroup-spacing': `${marginValue}px`,
            // marginValue is always defined
            ...other.style
        },
        children: [
            extraAvatars ? /*#__PURE__*/ (0, $ayMG0.jsx)(SurplusSlot, {
                ...surplusProps,
                children: extraAvatarsElement
            }) : null,
            children.slice(0, maxAvatars).reverse().map((child)=>{
                return /*#__PURE__*/ $70229258f609d599$var$React.cloneElement(child, {
                    className: (0, $70229258f609d599$var$_clsx.default)(child.props.className, classes.avatar),
                    variant: child.props.variant || variant
                });
            })
        ]
    });
});
$70229258f609d599$var$AvatarGroup.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The avatars to stack.
   */ children: $70229258f609d599$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $70229258f609d599$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $70229258f609d599$var$_propTypes.default.string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $70229258f609d599$var$_propTypes.default.elementType,
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ componentsProps: $70229258f609d599$var$_propTypes.default.shape({
        additionalAvatar: $70229258f609d599$var$_propTypes.default.object
    }),
    /**
   * Max avatars to show before +x.
   * @default 5
   */ max: (0, $70229258f609d599$var$_chainPropTypes.default)($70229258f609d599$var$_propTypes.default.number, (props)=>{
        if (props.max < 2) return new Error([
            'MUI: The prop `max` should be equal to 2 or above.',
            'A value below is clamped to 2.'
        ].join('\n'));
        return null;
    }),
    /**
   * custom renderer of extraAvatars
   * @param {number} surplus number of extra avatars
   * @returns {React.ReactNode} custom element to display
   */ renderSurplus: $70229258f609d599$var$_propTypes.default.func,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $70229258f609d599$var$_propTypes.default.shape({
        additionalAvatar: $70229258f609d599$var$_propTypes.default.object,
        surplus: $70229258f609d599$var$_propTypes.default.oneOfType([
            $70229258f609d599$var$_propTypes.default.func,
            $70229258f609d599$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: $70229258f609d599$var$_propTypes.default.shape({
        surplus: $70229258f609d599$var$_propTypes.default.elementType
    }),
    /**
   * Spacing between avatars.
   * @default 'medium'
   */ spacing: $70229258f609d599$var$_propTypes.default.oneOfType([
        $70229258f609d599$var$_propTypes.default.oneOf([
            'medium',
            'small'
        ]),
        $70229258f609d599$var$_propTypes.default.number
    ]),
    /**
   * @ignore
   */ style: $70229258f609d599$var$_propTypes.default.object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $70229258f609d599$var$_propTypes.default.oneOfType([
        $70229258f609d599$var$_propTypes.default.arrayOf($70229258f609d599$var$_propTypes.default.oneOfType([
            $70229258f609d599$var$_propTypes.default.func,
            $70229258f609d599$var$_propTypes.default.object,
            $70229258f609d599$var$_propTypes.default.bool
        ])),
        $70229258f609d599$var$_propTypes.default.func,
        $70229258f609d599$var$_propTypes.default.object
    ]),
    /**
   * The total number of avatars. Used for calculating the number of extra avatars.
   * @default children.length
   */ total: $70229258f609d599$var$_propTypes.default.number,
    /**
   * The variant to use.
   * @default 'circular'
   */ variant: $70229258f609d599$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $70229258f609d599$var$_propTypes.default.oneOf([
            'circular',
            'rounded',
            'square'
        ]),
        $70229258f609d599$var$_propTypes.default.string
    ])
};
var $70229258f609d599$var$_default = module.exports.default = $70229258f609d599$var$AvatarGroup;

});
parcelRegister("iFLib", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d980bd9c21d06ae1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getAvatarGroupUtilityClass = $d980bd9c21d06ae1$var$getAvatarGroupUtilityClass;

var $d980bd9c21d06ae1$var$_generateUtilityClasses = $d980bd9c21d06ae1$require$_interopRequireDefault((parcelRequire("5nY49")));

var $d980bd9c21d06ae1$var$_generateUtilityClass = $d980bd9c21d06ae1$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $d980bd9c21d06ae1$var$getAvatarGroupUtilityClass(slot) {
    return (0, $d980bd9c21d06ae1$var$_generateUtilityClass.default)('MuiAvatarGroup', slot);
}
const $d980bd9c21d06ae1$var$avatarGroupClasses = (0, $d980bd9c21d06ae1$var$_generateUtilityClasses.default)('MuiAvatarGroup', [
    'root',
    'avatar'
]);
var $d980bd9c21d06ae1$var$_default = module.exports.default = $d980bd9c21d06ae1$var$avatarGroupClasses;

});



parcelRegister("jIzBR", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $e5adbfb42ac1b374$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $e5adbfb42ac1b374$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $e5adbfb42ac1b374$var$_exportNames = {
    bottomNavigationClasses: true
};
Object.defineProperty(module.exports, "bottomNavigationClasses", {
    enumerable: true,
    get: function() {
        return $e5adbfb42ac1b374$var$_bottomNavigationClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $e5adbfb42ac1b374$var$_BottomNavigation.default;
    }
});

var $e5adbfb42ac1b374$var$_BottomNavigation = $e5adbfb42ac1b374$require$_interopRequireDefault((parcelRequire("82v09")));

var $e5adbfb42ac1b374$var$_bottomNavigationClasses = $e5adbfb42ac1b374$require$_interopRequireWildcard((parcelRequire("2kzOn")));
Object.keys($e5adbfb42ac1b374$var$_bottomNavigationClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($e5adbfb42ac1b374$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $e5adbfb42ac1b374$var$_bottomNavigationClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $e5adbfb42ac1b374$var$_bottomNavigationClasses[key];
        }
    });
});

});
parcelRegister("82v09", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $5da68ee03f6480a6$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $5da68ee03f6480a6$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5da68ee03f6480a6$var$React = $5da68ee03f6480a6$require$_interopRequireWildcard((parcelRequire("acw62")));

var $4jPKB = parcelRequire("4jPKB");

var $5da68ee03f6480a6$var$_propTypes = $5da68ee03f6480a6$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $5da68ee03f6480a6$var$_clsx = $5da68ee03f6480a6$require$_interopRequireDefault((parcelRequire("9QePP")));

var $5da68ee03f6480a6$var$_composeClasses = $5da68ee03f6480a6$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $5da68ee03f6480a6$var$_memoTheme = $5da68ee03f6480a6$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $2kzOn = parcelRequire("2kzOn");

var $ayMG0 = parcelRequire("ayMG0");
const $5da68ee03f6480a6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $5da68ee03f6480a6$var$_composeClasses.default)(slots, $2kzOn.getBottomNavigationUtilityClass, classes);
};
const $5da68ee03f6480a6$var$BottomNavigationRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiBottomNavigation',
    slot: 'Root'
})((0, $5da68ee03f6480a6$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'flex',
        justifyContent: 'center',
        height: 56,
        backgroundColor: (theme.vars || theme).palette.background.paper
    })));
const $5da68ee03f6480a6$var$BottomNavigation = /*#__PURE__*/ $5da68ee03f6480a6$var$React.forwardRef(function BottomNavigation(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiBottomNavigation'
    });
    const { children: children, className: className, component: component = 'div', onChange: onChange, showLabels: showLabels = false, value: value, ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        showLabels: showLabels
    };
    const classes = $5da68ee03f6480a6$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5da68ee03f6480a6$var$BottomNavigationRoot, {
        as: component,
        className: (0, $5da68ee03f6480a6$var$_clsx.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other,
        children: $5da68ee03f6480a6$var$React.Children.map(children, (child, childIndex)=>{
            if (!/*#__PURE__*/ $5da68ee03f6480a6$var$React.isValidElement(child)) return null;
            if ((0, $4jPKB.isFragment)(child)) console.error([
                "MUI: The BottomNavigation component doesn't accept a Fragment as a child.",
                'Consider providing an array instead.'
            ].join('\n'));
            const childValue = child.props.value === undefined ? childIndex : child.props.value;
            return /*#__PURE__*/ $5da68ee03f6480a6$var$React.cloneElement(child, {
                selected: childValue === value,
                showLabel: child.props.showLabel !== undefined ? child.props.showLabel : showLabels,
                value: childValue,
                onChange: onChange
            });
        })
    });
});
$5da68ee03f6480a6$var$BottomNavigation.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: $5da68ee03f6480a6$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $5da68ee03f6480a6$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $5da68ee03f6480a6$var$_propTypes.default.string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $5da68ee03f6480a6$var$_propTypes.default.elementType,
    /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {any} value We default to the index of the child.
   */ onChange: $5da68ee03f6480a6$var$_propTypes.default.func,
    /**
   * If `true`, all `BottomNavigationAction`s will show their labels.
   * By default, only the selected `BottomNavigationAction` will show its label.
   * @default false
   */ showLabels: $5da68ee03f6480a6$var$_propTypes.default.bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $5da68ee03f6480a6$var$_propTypes.default.oneOfType([
        $5da68ee03f6480a6$var$_propTypes.default.arrayOf($5da68ee03f6480a6$var$_propTypes.default.oneOfType([
            $5da68ee03f6480a6$var$_propTypes.default.func,
            $5da68ee03f6480a6$var$_propTypes.default.object,
            $5da68ee03f6480a6$var$_propTypes.default.bool
        ])),
        $5da68ee03f6480a6$var$_propTypes.default.func,
        $5da68ee03f6480a6$var$_propTypes.default.object
    ]),
    /**
   * The value of the currently selected `BottomNavigationAction`.
   */ value: $5da68ee03f6480a6$var$_propTypes.default.any
};
var $5da68ee03f6480a6$var$_default = module.exports.default = $5da68ee03f6480a6$var$BottomNavigation;

});
parcelRegister("2kzOn", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $1b293a71daed0efc$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getBottomNavigationUtilityClass = $1b293a71daed0efc$var$getBottomNavigationUtilityClass;

var $1b293a71daed0efc$var$_generateUtilityClasses = $1b293a71daed0efc$require$_interopRequireDefault((parcelRequire("5nY49")));

var $1b293a71daed0efc$var$_generateUtilityClass = $1b293a71daed0efc$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $1b293a71daed0efc$var$getBottomNavigationUtilityClass(slot) {
    return (0, $1b293a71daed0efc$var$_generateUtilityClass.default)('MuiBottomNavigation', slot);
}
const $1b293a71daed0efc$var$bottomNavigationClasses = (0, $1b293a71daed0efc$var$_generateUtilityClasses.default)('MuiBottomNavigation', [
    'root'
]);
var $1b293a71daed0efc$var$_default = module.exports.default = $1b293a71daed0efc$var$bottomNavigationClasses;

});



parcelRegister("e9QPA", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $a4eae313114a1aef$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $a4eae313114a1aef$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $a4eae313114a1aef$var$_exportNames = {
    bottomNavigationActionClasses: true
};
Object.defineProperty(module.exports, "bottomNavigationActionClasses", {
    enumerable: true,
    get: function() {
        return $a4eae313114a1aef$var$_bottomNavigationActionClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $a4eae313114a1aef$var$_BottomNavigationAction.default;
    }
});

var $a4eae313114a1aef$var$_BottomNavigationAction = $a4eae313114a1aef$require$_interopRequireDefault((parcelRequire("lLgVd")));

var $a4eae313114a1aef$var$_bottomNavigationActionClasses = $a4eae313114a1aef$require$_interopRequireWildcard((parcelRequire("1AAR2")));
Object.keys($a4eae313114a1aef$var$_bottomNavigationActionClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($a4eae313114a1aef$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $a4eae313114a1aef$var$_bottomNavigationActionClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $a4eae313114a1aef$var$_bottomNavigationActionClasses[key];
        }
    });
});

});
parcelRegister("lLgVd", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $fd7b1d1a8629ce6b$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $fd7b1d1a8629ce6b$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fd7b1d1a8629ce6b$var$React = $fd7b1d1a8629ce6b$require$_interopRequireWildcard((parcelRequire("acw62")));

var $fd7b1d1a8629ce6b$var$_propTypes = $fd7b1d1a8629ce6b$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $fd7b1d1a8629ce6b$var$_clsx = $fd7b1d1a8629ce6b$require$_interopRequireDefault((parcelRequire("9QePP")));

var $fd7b1d1a8629ce6b$var$_composeClasses = $fd7b1d1a8629ce6b$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $fd7b1d1a8629ce6b$var$_memoTheme = $fd7b1d1a8629ce6b$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $fd7b1d1a8629ce6b$var$_ButtonBase = $fd7b1d1a8629ce6b$require$_interopRequireDefault((parcelRequire("hhs3r")));

var $fd7b1d1a8629ce6b$var$_unsupportedProp = $fd7b1d1a8629ce6b$require$_interopRequireDefault((parcelRequire("gUzNi")));

var $fd7b1d1a8629ce6b$var$_bottomNavigationActionClasses = $fd7b1d1a8629ce6b$require$_interopRequireWildcard((parcelRequire("1AAR2")));

var $fd7b1d1a8629ce6b$var$_useSlot = $fd7b1d1a8629ce6b$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $fd7b1d1a8629ce6b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, showLabel: showLabel, selected: selected } = ownerState;
    const slots = {
        root: [
            'root',
            !showLabel && !selected && 'iconOnly',
            selected && 'selected'
        ],
        label: [
            'label',
            !showLabel && !selected && 'iconOnly',
            selected && 'selected'
        ]
    };
    return (0, $fd7b1d1a8629ce6b$var$_composeClasses.default)(slots, $fd7b1d1a8629ce6b$var$_bottomNavigationActionClasses.getBottomNavigationActionUtilityClass, classes);
};
const $fd7b1d1a8629ce6b$var$BottomNavigationActionRoot = (0, $aAbgT.styled)($fd7b1d1a8629ce6b$var$_ButtonBase.default, {
    name: 'MuiBottomNavigationAction',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.showLabel && !ownerState.selected && styles.iconOnly
        ];
    }
})((0, $fd7b1d1a8629ce6b$var$_memoTheme.default)(({ theme: theme })=>({
        transition: theme.transitions.create([
            'color',
            'padding-top'
        ], {
            duration: theme.transitions.duration.short
        }),
        padding: '0px 12px',
        minWidth: 80,
        maxWidth: 168,
        color: (theme.vars || theme).palette.text.secondary,
        flexDirection: 'column',
        flex: '1',
        [`&.${$fd7b1d1a8629ce6b$var$_bottomNavigationActionClasses.default.selected}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        variants: [
            {
                props: ({ showLabel: showLabel, selected: selected })=>!showLabel && !selected,
                style: {
                    paddingTop: 14
                }
            },
            {
                props: ({ showLabel: showLabel, selected: selected, label: label })=>!showLabel && !selected && !label,
                style: {
                    paddingTop: 0
                }
            }
        ]
    })));
const $fd7b1d1a8629ce6b$var$BottomNavigationActionLabel = (0, $aAbgT.styled)('span', {
    name: 'MuiBottomNavigationAction',
    slot: 'Label'
})((0, $fd7b1d1a8629ce6b$var$_memoTheme.default)(({ theme: theme })=>({
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(12),
        opacity: 1,
        transition: 'font-size 0.2s, opacity 0.2s',
        transitionDelay: '0.1s',
        [`&.${$fd7b1d1a8629ce6b$var$_bottomNavigationActionClasses.default.selected}`]: {
            fontSize: theme.typography.pxToRem(14)
        },
        variants: [
            {
                props: ({ showLabel: showLabel, selected: selected })=>!showLabel && !selected,
                style: {
                    opacity: 0,
                    transitionDelay: '0s'
                }
            }
        ]
    })));
const $fd7b1d1a8629ce6b$var$BottomNavigationAction = /*#__PURE__*/ $fd7b1d1a8629ce6b$var$React.forwardRef(function BottomNavigationAction(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiBottomNavigationAction'
    });
    const { className: className, icon: icon, label: label, onChange: onChange, onClick: onClick, selected: // eslint-disable-next-line react/prop-types -- private, always overridden by BottomNavigation
    selected, showLabel: showLabel, value: value, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const ownerState = props;
    const classes = $fd7b1d1a8629ce6b$var$useUtilityClasses(ownerState);
    const handleChange = (event)=>{
        if (onChange) onChange(event, value);
        if (onClick) onClick(event);
    };
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootProps] = (0, $fd7b1d1a8629ce6b$var$_useSlot.default)('root', {
        elementType: $fd7b1d1a8629ce6b$var$BottomNavigationActionRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        shouldForwardComponentProp: true,
        ownerState: ownerState,
        ref: ref,
        className: (0, $fd7b1d1a8629ce6b$var$_clsx.default)(classes.root, className),
        additionalProps: {
            focusRipple: true
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onClick: (event)=>{
                    handlers.onClick?.(event);
                    handleChange(event);
                }
            })
    });
    const [LabelSlot, labelProps] = (0, $fd7b1d1a8629ce6b$var$_useSlot.default)('label', {
        elementType: $fd7b1d1a8629ce6b$var$BottomNavigationActionLabel,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.label
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            icon,
            /*#__PURE__*/ (0, $ayMG0.jsx)(LabelSlot, {
                ...labelProps,
                children: label
            })
        ]
    });
});
$fd7b1d1a8629ce6b$var$BottomNavigationAction.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */ children: $fd7b1d1a8629ce6b$var$_unsupportedProp.default,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $fd7b1d1a8629ce6b$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $fd7b1d1a8629ce6b$var$_propTypes.default.string,
    /**
   * The icon to display.
   */ icon: $fd7b1d1a8629ce6b$var$_propTypes.default.node,
    /**
   * The label element.
   */ label: $fd7b1d1a8629ce6b$var$_propTypes.default.node,
    /**
   * @ignore
   */ onChange: $fd7b1d1a8629ce6b$var$_propTypes.default.func,
    /**
   * @ignore
   */ onClick: $fd7b1d1a8629ce6b$var$_propTypes.default.func,
    /**
   * If `true`, the `BottomNavigationAction` will show its label.
   * By default, only the selected `BottomNavigationAction`
   * inside `BottomNavigation` will show its label.
   *
   * The prop defaults to the value (`false`) inherited from the parent BottomNavigation component.
   */ showLabel: $fd7b1d1a8629ce6b$var$_propTypes.default.bool,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $fd7b1d1a8629ce6b$var$_propTypes.default.shape({
        label: $fd7b1d1a8629ce6b$var$_propTypes.default.oneOfType([
            $fd7b1d1a8629ce6b$var$_propTypes.default.func,
            $fd7b1d1a8629ce6b$var$_propTypes.default.object
        ]),
        root: $fd7b1d1a8629ce6b$var$_propTypes.default.oneOfType([
            $fd7b1d1a8629ce6b$var$_propTypes.default.func,
            $fd7b1d1a8629ce6b$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: $fd7b1d1a8629ce6b$var$_propTypes.default.shape({
        label: $fd7b1d1a8629ce6b$var$_propTypes.default.elementType,
        root: $fd7b1d1a8629ce6b$var$_propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $fd7b1d1a8629ce6b$var$_propTypes.default.oneOfType([
        $fd7b1d1a8629ce6b$var$_propTypes.default.arrayOf($fd7b1d1a8629ce6b$var$_propTypes.default.oneOfType([
            $fd7b1d1a8629ce6b$var$_propTypes.default.func,
            $fd7b1d1a8629ce6b$var$_propTypes.default.object,
            $fd7b1d1a8629ce6b$var$_propTypes.default.bool
        ])),
        $fd7b1d1a8629ce6b$var$_propTypes.default.func,
        $fd7b1d1a8629ce6b$var$_propTypes.default.object
    ]),
    /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */ value: $fd7b1d1a8629ce6b$var$_propTypes.default.any
};
var $fd7b1d1a8629ce6b$var$_default = module.exports.default = $fd7b1d1a8629ce6b$var$BottomNavigationAction;

});
parcelRegister("1AAR2", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $1285bdc0c1011b3d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getBottomNavigationActionUtilityClass = $1285bdc0c1011b3d$var$getBottomNavigationActionUtilityClass;

var $1285bdc0c1011b3d$var$_generateUtilityClasses = $1285bdc0c1011b3d$require$_interopRequireDefault((parcelRequire("5nY49")));

var $1285bdc0c1011b3d$var$_generateUtilityClass = $1285bdc0c1011b3d$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $1285bdc0c1011b3d$var$getBottomNavigationActionUtilityClass(slot) {
    return (0, $1285bdc0c1011b3d$var$_generateUtilityClass.default)('MuiBottomNavigationAction', slot);
}
const $1285bdc0c1011b3d$var$bottomNavigationActionClasses = (0, $1285bdc0c1011b3d$var$_generateUtilityClasses.default)('MuiBottomNavigationAction', [
    'root',
    'iconOnly',
    'selected',
    'label'
]);
var $1285bdc0c1011b3d$var$_default = module.exports.default = $1285bdc0c1011b3d$var$bottomNavigationActionClasses;

});



parcelRegister("e5o5x", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $02a57cc52715b250$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $02a57cc52715b250$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $02a57cc52715b250$var$_exportNames = {
    boxClasses: true
};
Object.defineProperty(module.exports, "boxClasses", {
    enumerable: true,
    get: function() {
        return $02a57cc52715b250$var$_boxClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $02a57cc52715b250$var$_Box.default;
    }
});

var $02a57cc52715b250$var$_Box = $02a57cc52715b250$require$_interopRequireDefault((parcelRequire("03mUs")));

var $02a57cc52715b250$var$_boxClasses = $02a57cc52715b250$require$_interopRequireWildcard((parcelRequire("hOwN9")));
Object.keys($02a57cc52715b250$var$_boxClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($02a57cc52715b250$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $02a57cc52715b250$var$_boxClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $02a57cc52715b250$var$_boxClasses[key];
        }
    });
});

});
parcelRegister("03mUs", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $00a20d475386f68c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $izOUK = parcelRequire("izOUK");

var $00a20d475386f68c$var$_propTypes = $00a20d475386f68c$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $aXEQ8 = parcelRequire("aXEQ8");

var $8xDHs = parcelRequire("8xDHs");

var $00a20d475386f68c$var$_identifier = $00a20d475386f68c$require$_interopRequireDefault((parcelRequire("4jPsi")));

var $00a20d475386f68c$var$_boxClasses = $00a20d475386f68c$require$_interopRequireDefault((parcelRequire("hOwN9")));
const $00a20d475386f68c$var$defaultTheme = (0, $8xDHs.createTheme)();
const $00a20d475386f68c$var$Box = (0, $izOUK.createBox)({
    themeId: $00a20d475386f68c$var$_identifier.default,
    defaultTheme: $00a20d475386f68c$var$defaultTheme,
    defaultClassName: $00a20d475386f68c$var$_boxClasses.default.root,
    generateClassName: $aXEQ8.unstable_ClassNameGenerator.generate
});
$00a20d475386f68c$var$Box.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * @ignore
   */ children: $00a20d475386f68c$var$_propTypes.default.node,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $00a20d475386f68c$var$_propTypes.default.elementType,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $00a20d475386f68c$var$_propTypes.default.oneOfType([
        $00a20d475386f68c$var$_propTypes.default.arrayOf($00a20d475386f68c$var$_propTypes.default.oneOfType([
            $00a20d475386f68c$var$_propTypes.default.func,
            $00a20d475386f68c$var$_propTypes.default.object,
            $00a20d475386f68c$var$_propTypes.default.bool
        ])),
        $00a20d475386f68c$var$_propTypes.default.func,
        $00a20d475386f68c$var$_propTypes.default.object
    ])
};
var $00a20d475386f68c$var$_default = module.exports.default = $00a20d475386f68c$var$Box;

});
parcelRegister("aXEQ8", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $7faf1807a5669751$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "unstable_ClassNameGenerator", {
    enumerable: true,
    get: function() {
        return $7faf1807a5669751$var$_ClassNameGenerator.default;
    }
});

var $7faf1807a5669751$var$_ClassNameGenerator = $7faf1807a5669751$require$_interopRequireDefault((parcelRequire("aYaRV")));

});

parcelRegister("hOwN9", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $cf808af3a1d339c9$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cf808af3a1d339c9$var$_generateUtilityClasses = $cf808af3a1d339c9$require$_interopRequireDefault((parcelRequire("5nY49")));
const $cf808af3a1d339c9$var$boxClasses = (0, $cf808af3a1d339c9$var$_generateUtilityClasses.default)('MuiBox', [
    'root'
]);
var $cf808af3a1d339c9$var$_default = module.exports.default = $cf808af3a1d339c9$var$boxClasses;

});



parcelRegister("63l7x", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $468368052d2ef018$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $468368052d2ef018$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $468368052d2ef018$var$_exportNames = {
    breadcrumbsClasses: true
};
Object.defineProperty(module.exports, "breadcrumbsClasses", {
    enumerable: true,
    get: function() {
        return $468368052d2ef018$var$_breadcrumbsClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $468368052d2ef018$var$_Breadcrumbs.default;
    }
});

var $468368052d2ef018$var$_Breadcrumbs = $468368052d2ef018$require$_interopRequireDefault((parcelRequire("591qL")));

var $468368052d2ef018$var$_breadcrumbsClasses = $468368052d2ef018$require$_interopRequireWildcard((parcelRequire("4d25s")));
Object.keys($468368052d2ef018$var$_breadcrumbsClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($468368052d2ef018$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $468368052d2ef018$var$_breadcrumbsClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $468368052d2ef018$var$_breadcrumbsClasses[key];
        }
    });
});

});
parcelRegister("591qL", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $3beee71e1808c2fa$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $3beee71e1808c2fa$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3beee71e1808c2fa$var$React = $3beee71e1808c2fa$require$_interopRequireWildcard((parcelRequire("acw62")));

var $4jPKB = parcelRequire("4jPKB");

var $3beee71e1808c2fa$var$_propTypes = $3beee71e1808c2fa$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $3beee71e1808c2fa$var$_clsx = $3beee71e1808c2fa$require$_interopRequireDefault((parcelRequire("9QePP")));

var $3beee71e1808c2fa$var$_integerPropType = $3beee71e1808c2fa$require$_interopRequireDefault((parcelRequire("cxaSP")));

var $3beee71e1808c2fa$var$_composeClasses = $3beee71e1808c2fa$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $3beee71e1808c2fa$var$_useSlotProps = $3beee71e1808c2fa$require$_interopRequireDefault((parcelRequire("839K0")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $3beee71e1808c2fa$var$_Typography = $3beee71e1808c2fa$require$_interopRequireDefault((parcelRequire("2dUd7")));

var $3beee71e1808c2fa$var$_BreadcrumbCollapsed = $3beee71e1808c2fa$require$_interopRequireDefault((parcelRequire("eSNoo")));

var $3beee71e1808c2fa$var$_breadcrumbsClasses = $3beee71e1808c2fa$require$_interopRequireWildcard((parcelRequire("4d25s")));

var $ayMG0 = parcelRequire("ayMG0");
const $3beee71e1808c2fa$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        li: [
            'li'
        ],
        ol: [
            'ol'
        ],
        separator: [
            'separator'
        ]
    };
    return (0, $3beee71e1808c2fa$var$_composeClasses.default)(slots, $3beee71e1808c2fa$var$_breadcrumbsClasses.getBreadcrumbsUtilityClass, classes);
};
const $3beee71e1808c2fa$var$BreadcrumbsRoot = (0, $aAbgT.styled)($3beee71e1808c2fa$var$_Typography.default, {
    name: 'MuiBreadcrumbs',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        return [
            {
                [`& .${$3beee71e1808c2fa$var$_breadcrumbsClasses.default.li}`]: styles.li
            },
            styles.root
        ];
    }
})({});
const $3beee71e1808c2fa$var$BreadcrumbsOl = (0, $aAbgT.styled)('ol', {
    name: 'MuiBreadcrumbs',
    slot: 'Ol'
})({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: 0,
    margin: 0,
    listStyle: 'none'
});
const $3beee71e1808c2fa$var$BreadcrumbsSeparator = (0, $aAbgT.styled)('li', {
    name: 'MuiBreadcrumbs',
    slot: 'Separator'
})({
    display: 'flex',
    userSelect: 'none',
    marginLeft: 8,
    marginRight: 8
});
function $3beee71e1808c2fa$var$insertSeparators(items, className, separator, ownerState) {
    return items.reduce((acc, current, index)=>{
        if (index < items.length - 1) acc = acc.concat(current, /*#__PURE__*/ (0, $ayMG0.jsx)($3beee71e1808c2fa$var$BreadcrumbsSeparator, {
            "aria-hidden": true,
            className: className,
            ownerState: ownerState,
            children: separator
        }, `separator-${index}`));
        else acc.push(current);
        return acc;
    }, []);
}
const $3beee71e1808c2fa$var$Breadcrumbs = /*#__PURE__*/ $3beee71e1808c2fa$var$React.forwardRef(function Breadcrumbs(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiBreadcrumbs'
    });
    const { children: children, className: className, component: component = 'nav', slots: slots = {}, slotProps: slotProps = {}, expandText: expandText = 'Show path', itemsAfterCollapse: itemsAfterCollapse = 1, itemsBeforeCollapse: itemsBeforeCollapse = 1, maxItems: maxItems = 8, separator: separator = '/', ...other } = props;
    const [expanded, setExpanded] = $3beee71e1808c2fa$var$React.useState(false);
    const ownerState = {
        ...props,
        component: component,
        expanded: expanded,
        expandText: expandText,
        itemsAfterCollapse: itemsAfterCollapse,
        itemsBeforeCollapse: itemsBeforeCollapse,
        maxItems: maxItems,
        separator: separator
    };
    const classes = $3beee71e1808c2fa$var$useUtilityClasses(ownerState);
    const collapsedIconSlotProps = (0, $3beee71e1808c2fa$var$_useSlotProps.default)({
        elementType: slots.CollapsedIcon,
        externalSlotProps: slotProps.collapsedIcon,
        ownerState: ownerState
    });
    const listRef = $3beee71e1808c2fa$var$React.useRef(null);
    const renderItemsBeforeAndAfter = (allItems)=>{
        const handleClickExpand = ()=>{
            setExpanded(true);
            // The clicked element received the focus but gets removed from the DOM.
            // Let's keep the focus in the component after expanding.
            // Moving it to the <ol> or <nav> does not cause any announcement in NVDA.
            // By moving it to some link/button at least we have some announcement.
            const focusable = listRef.current.querySelector('a[href],button,[tabindex]');
            if (focusable) focusable.focus();
        };
        // This defends against someone passing weird input, to ensure that if all
        // items would be shown anyway, we just show all items without the EllipsisItem
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) {
            console.error([
                'MUI: You have provided an invalid combination of props to the Breadcrumbs.',
                `itemsAfterCollapse={${itemsAfterCollapse}} + itemsBeforeCollapse={${itemsBeforeCollapse}} >= maxItems={${maxItems}}`
            ].join('\n'));
            return allItems;
        }
        return [
            ...allItems.slice(0, itemsBeforeCollapse),
            /*#__PURE__*/ (0, $ayMG0.jsx)($3beee71e1808c2fa$var$_BreadcrumbCollapsed.default, {
                "aria-label": expandText,
                slots: {
                    CollapsedIcon: slots.CollapsedIcon
                },
                slotProps: {
                    collapsedIcon: collapsedIconSlotProps
                },
                onClick: handleClickExpand
            }, "ellipsis"),
            ...allItems.slice(allItems.length - itemsAfterCollapse, allItems.length)
        ];
    };
    const allItems = $3beee71e1808c2fa$var$React.Children.toArray(children).filter((child)=>{
        if ((0, $4jPKB.isFragment)(child)) console.error([
            "MUI: The Breadcrumbs component doesn't accept a Fragment as a child.",
            'Consider providing an array instead.'
        ].join('\n'));
        return /*#__PURE__*/ $3beee71e1808c2fa$var$React.isValidElement(child);
    }).map((child, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
            className: classes.li,
            children: child
        }, `child-${index}`));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3beee71e1808c2fa$var$BreadcrumbsRoot, {
        ref: ref,
        component: component,
        color: "textSecondary",
        className: (0, $3beee71e1808c2fa$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($3beee71e1808c2fa$var$BreadcrumbsOl, {
            className: classes.ol,
            ref: listRef,
            ownerState: ownerState,
            children: $3beee71e1808c2fa$var$insertSeparators(expanded || maxItems && allItems.length <= maxItems ? allItems : renderItemsBeforeAndAfter(allItems), classes.separator, separator, ownerState)
        })
    });
});
$3beee71e1808c2fa$var$Breadcrumbs.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: $3beee71e1808c2fa$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $3beee71e1808c2fa$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $3beee71e1808c2fa$var$_propTypes.default.string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $3beee71e1808c2fa$var$_propTypes.default.elementType,
    /**
   * Override the default label for the expand button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Show path'
   */ expandText: $3beee71e1808c2fa$var$_propTypes.default.string,
    /**
   * If max items is exceeded, the number of items to show after the ellipsis.
   * @default 1
   */ itemsAfterCollapse: $3beee71e1808c2fa$var$_integerPropType.default,
    /**
   * If max items is exceeded, the number of items to show before the ellipsis.
   * @default 1
   */ itemsBeforeCollapse: $3beee71e1808c2fa$var$_integerPropType.default,
    /**
   * Specifies the maximum number of breadcrumbs to display. When there are more
   * than the maximum number, only the first `itemsBeforeCollapse` and last `itemsAfterCollapse`
   * will be shown, with an ellipsis in between.
   * @default 8
   */ maxItems: $3beee71e1808c2fa$var$_integerPropType.default,
    /**
   * Custom separator node.
   * @default '/'
   */ separator: $3beee71e1808c2fa$var$_propTypes.default.node,
    /**
   * The props used for each slot inside the Breadcumb.
   * @default {}
   */ slotProps: $3beee71e1808c2fa$var$_propTypes.default.shape({
        collapsedIcon: $3beee71e1808c2fa$var$_propTypes.default.oneOfType([
            $3beee71e1808c2fa$var$_propTypes.default.func,
            $3beee71e1808c2fa$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside the Breadcumb.
   * Either a string to use a HTML element or a component.
   * @default {}
   */ slots: $3beee71e1808c2fa$var$_propTypes.default.shape({
        CollapsedIcon: $3beee71e1808c2fa$var$_propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $3beee71e1808c2fa$var$_propTypes.default.oneOfType([
        $3beee71e1808c2fa$var$_propTypes.default.arrayOf($3beee71e1808c2fa$var$_propTypes.default.oneOfType([
            $3beee71e1808c2fa$var$_propTypes.default.func,
            $3beee71e1808c2fa$var$_propTypes.default.object,
            $3beee71e1808c2fa$var$_propTypes.default.bool
        ])),
        $3beee71e1808c2fa$var$_propTypes.default.func,
        $3beee71e1808c2fa$var$_propTypes.default.object
    ])
};
var $3beee71e1808c2fa$var$_default = module.exports.default = $3beee71e1808c2fa$var$Breadcrumbs;

});
parcelRegister("eSNoo", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $ad5c6c214f96507f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ad5c6c214f96507f$var$_propTypes = $ad5c6c214f96507f$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $h61zw = parcelRequire("h61zw");

var $aAbgT = parcelRequire("aAbgT");

var $ad5c6c214f96507f$var$_memoTheme = $ad5c6c214f96507f$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $ad5c6c214f96507f$var$_MoreHoriz = $ad5c6c214f96507f$require$_interopRequireDefault((parcelRequire("jYtEk")));

var $ad5c6c214f96507f$var$_ButtonBase = $ad5c6c214f96507f$require$_interopRequireDefault((parcelRequire("hhs3r")));

var $ayMG0 = parcelRequire("ayMG0");
const $ad5c6c214f96507f$var$BreadcrumbCollapsedButton = (0, $aAbgT.styled)($ad5c6c214f96507f$var$_ButtonBase.default, {
    name: 'MuiBreadcrumbCollapsed'
})((0, $ad5c6c214f96507f$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'flex',
        marginLeft: `calc(${theme.spacing(1)} * 0.5)`,
        marginRight: `calc(${theme.spacing(1)} * 0.5)`,
        ...theme.palette.mode === 'light' ? {
            backgroundColor: theme.palette.grey[100],
            color: theme.palette.grey[700]
        } : {
            backgroundColor: theme.palette.grey[700],
            color: theme.palette.grey[100]
        },
        borderRadius: 2,
        '&:hover, &:focus': {
            ...theme.palette.mode === 'light' ? {
                backgroundColor: theme.palette.grey[200]
            } : {
                backgroundColor: theme.palette.grey[600]
            }
        },
        '&:active': {
            boxShadow: theme.shadows[0],
            ...theme.palette.mode === 'light' ? {
                backgroundColor: (0, $h61zw.emphasize)(theme.palette.grey[200], 0.12)
            } : {
                backgroundColor: (0, $h61zw.emphasize)(theme.palette.grey[600], 0.12)
            }
        }
    })));
const $ad5c6c214f96507f$var$BreadcrumbCollapsedIcon = (0, $aAbgT.styled)($ad5c6c214f96507f$var$_MoreHoriz.default)({
    width: 24,
    height: 16
});
/**
 * @ignore - internal component.
 */ function $ad5c6c214f96507f$var$BreadcrumbCollapsed(props) {
    const { slots: slots = {}, slotProps: slotProps = {}, ...otherProps } = props;
    const ownerState = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($ad5c6c214f96507f$var$BreadcrumbCollapsedButton, {
            focusRipple: true,
            ...otherProps,
            ownerState: ownerState,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($ad5c6c214f96507f$var$BreadcrumbCollapsedIcon, {
                as: slots.CollapsedIcon,
                ownerState: ownerState,
                ...slotProps.collapsedIcon
            })
        })
    });
}
$ad5c6c214f96507f$var$BreadcrumbCollapsed.propTypes = {
    /**
   * The props used for the CollapsedIcon slot.
   * @default {}
   */ slotProps: $ad5c6c214f96507f$var$_propTypes.default.shape({
        collapsedIcon: $ad5c6c214f96507f$var$_propTypes.default.oneOfType([
            $ad5c6c214f96507f$var$_propTypes.default.func,
            $ad5c6c214f96507f$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside the BreadcumbCollapsed.
   * Either a string to use a HTML element or a component.
   * @default {}
   */ slots: $ad5c6c214f96507f$var$_propTypes.default.shape({
        CollapsedIcon: $ad5c6c214f96507f$var$_propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $ad5c6c214f96507f$var$_propTypes.default.object
};
var $ad5c6c214f96507f$var$_default = module.exports.default = $ad5c6c214f96507f$var$BreadcrumbCollapsed;

});
parcelRegister("jYtEk", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $e8aa9eabd3007a18$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e8aa9eabd3007a18$var$_createSvgIcon = $e8aa9eabd3007a18$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $e8aa9eabd3007a18$var$_default = module.exports.default = (0, $e8aa9eabd3007a18$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreHoriz');

});


parcelRegister("4d25s", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3109febd55ba98e0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getBreadcrumbsUtilityClass = $3109febd55ba98e0$var$getBreadcrumbsUtilityClass;

var $3109febd55ba98e0$var$_generateUtilityClasses = $3109febd55ba98e0$require$_interopRequireDefault((parcelRequire("5nY49")));

var $3109febd55ba98e0$var$_generateUtilityClass = $3109febd55ba98e0$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $3109febd55ba98e0$var$getBreadcrumbsUtilityClass(slot) {
    return (0, $3109febd55ba98e0$var$_generateUtilityClass.default)('MuiBreadcrumbs', slot);
}
const $3109febd55ba98e0$var$breadcrumbsClasses = (0, $3109febd55ba98e0$var$_generateUtilityClasses.default)('MuiBreadcrumbs', [
    'root',
    'ol',
    'li',
    'separator'
]);
var $3109febd55ba98e0$var$_default = module.exports.default = $3109febd55ba98e0$var$breadcrumbsClasses;

});



parcelRegister("8Jh2o", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $65afbe095ccffd1e$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $65afbe095ccffd1e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $65afbe095ccffd1e$var$_exportNames = {
    buttonGroupClasses: true,
    ButtonGroupContext: true,
    ButtonGroupButtonContext: true
};
Object.defineProperty(module.exports, "ButtonGroupButtonContext", {
    enumerable: true,
    get: function() {
        return $65afbe095ccffd1e$var$_ButtonGroupButtonContext.default;
    }
});
Object.defineProperty(module.exports, "ButtonGroupContext", {
    enumerable: true,
    get: function() {
        return $65afbe095ccffd1e$var$_ButtonGroupContext.default;
    }
});
Object.defineProperty(module.exports, "buttonGroupClasses", {
    enumerable: true,
    get: function() {
        return $65afbe095ccffd1e$var$_buttonGroupClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $65afbe095ccffd1e$var$_ButtonGroup.default;
    }
});

var $65afbe095ccffd1e$var$_ButtonGroup = $65afbe095ccffd1e$require$_interopRequireDefault((parcelRequire("2p5OG")));

var $65afbe095ccffd1e$var$_buttonGroupClasses = $65afbe095ccffd1e$require$_interopRequireWildcard((parcelRequire("d8s3C")));
Object.keys($65afbe095ccffd1e$var$_buttonGroupClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($65afbe095ccffd1e$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $65afbe095ccffd1e$var$_buttonGroupClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $65afbe095ccffd1e$var$_buttonGroupClasses[key];
        }
    });
});

var $65afbe095ccffd1e$var$_ButtonGroupContext = $65afbe095ccffd1e$require$_interopRequireDefault((parcelRequire("bwtSM")));

var $65afbe095ccffd1e$var$_ButtonGroupButtonContext = $65afbe095ccffd1e$require$_interopRequireDefault((parcelRequire("3eDio")));

});
parcelRegister("2p5OG", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $1c026d95d0d4d482$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $1c026d95d0d4d482$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1c026d95d0d4d482$var$React = $1c026d95d0d4d482$require$_interopRequireWildcard((parcelRequire("acw62")));

var $1c026d95d0d4d482$var$_propTypes = $1c026d95d0d4d482$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $1c026d95d0d4d482$var$_clsx = $1c026d95d0d4d482$require$_interopRequireDefault((parcelRequire("9QePP")));

var $1c026d95d0d4d482$var$_composeClasses = $1c026d95d0d4d482$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $1c026d95d0d4d482$var$_getValidReactChildren = $1c026d95d0d4d482$require$_interopRequireDefault((parcelRequire("2jgfV")));

var $1c026d95d0d4d482$var$_capitalize = $1c026d95d0d4d482$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $aAbgT = parcelRequire("aAbgT");

var $1c026d95d0d4d482$var$_memoTheme = $1c026d95d0d4d482$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $1c026d95d0d4d482$var$_createSimplePaletteValueFilter = $1c026d95d0d4d482$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $hL1nr = parcelRequire("hL1nr");

var $1c026d95d0d4d482$var$_buttonGroupClasses = $1c026d95d0d4d482$require$_interopRequireWildcard((parcelRequire("d8s3C")));

var $1c026d95d0d4d482$var$_ButtonGroupContext = $1c026d95d0d4d482$require$_interopRequireDefault((parcelRequire("bwtSM")));

var $1c026d95d0d4d482$var$_ButtonGroupButtonContext = $1c026d95d0d4d482$require$_interopRequireDefault((parcelRequire("3eDio")));

var $ayMG0 = parcelRequire("ayMG0");
const $1c026d95d0d4d482$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        {
            [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.grouped}`]: styles.grouped
        },
        {
            [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.grouped}`]: styles[`grouped${(0, $1c026d95d0d4d482$var$_capitalize.default)(ownerState.orientation)}`]
        },
        {
            [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.grouped}`]: styles[`grouped${(0, $1c026d95d0d4d482$var$_capitalize.default)(ownerState.variant)}`]
        },
        {
            [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.grouped}`]: styles[`grouped${(0, $1c026d95d0d4d482$var$_capitalize.default)(ownerState.variant)}${(0, $1c026d95d0d4d482$var$_capitalize.default)(ownerState.orientation)}`]
        },
        {
            [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.grouped}`]: styles[`grouped${(0, $1c026d95d0d4d482$var$_capitalize.default)(ownerState.variant)}${(0, $1c026d95d0d4d482$var$_capitalize.default)(ownerState.color)}`]
        },
        {
            [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.firstButton}`]: styles.firstButton
        },
        {
            [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.lastButton}`]: styles.lastButton
        },
        {
            [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.middleButton}`]: styles.middleButton
        },
        styles.root,
        styles[ownerState.variant],
        ownerState.disableElevation === true && styles.disableElevation,
        ownerState.fullWidth && styles.fullWidth,
        ownerState.orientation === 'vertical' && styles.vertical
    ];
};
const $1c026d95d0d4d482$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, disableElevation: disableElevation, fullWidth: fullWidth, orientation: orientation, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            orientation,
            fullWidth && 'fullWidth',
            disableElevation && 'disableElevation',
            `color${(0, $1c026d95d0d4d482$var$_capitalize.default)(color)}`
        ],
        grouped: [
            'grouped',
            `grouped${(0, $1c026d95d0d4d482$var$_capitalize.default)(orientation)}`,
            `grouped${(0, $1c026d95d0d4d482$var$_capitalize.default)(variant)}`,
            `grouped${(0, $1c026d95d0d4d482$var$_capitalize.default)(variant)}${(0, $1c026d95d0d4d482$var$_capitalize.default)(orientation)}`,
            `grouped${(0, $1c026d95d0d4d482$var$_capitalize.default)(variant)}${(0, $1c026d95d0d4d482$var$_capitalize.default)(color)}`,
            disabled && 'disabled'
        ],
        firstButton: [
            'firstButton'
        ],
        lastButton: [
            'lastButton'
        ],
        middleButton: [
            'middleButton'
        ]
    };
    return (0, $1c026d95d0d4d482$var$_composeClasses.default)(slots, $1c026d95d0d4d482$var$_buttonGroupClasses.getButtonGroupUtilityClass, classes);
};
const $1c026d95d0d4d482$var$ButtonGroupRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiButtonGroup',
    slot: 'Root',
    overridesResolver: $1c026d95d0d4d482$var$overridesResolver
})((0, $1c026d95d0d4d482$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'inline-flex',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        variants: [
            {
                props: {
                    variant: 'contained'
                },
                style: {
                    boxShadow: (theme.vars || theme).shadows[2],
                    [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.grouped}`]: {
                        boxShadow: 'none',
                        '&:hover': {
                            boxShadow: 'none'
                        }
                    }
                }
            },
            {
                props: {
                    disableElevation: true
                },
                style: {
                    boxShadow: 'none'
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    flexDirection: 'column',
                    [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.lastButton},& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.middleButton}`]: {
                        borderTopRightRadius: 0,
                        borderTopLeftRadius: 0
                    },
                    [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.firstButton},& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.middleButton}`]: {
                        borderBottomRightRadius: 0,
                        borderBottomLeftRadius: 0
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.firstButton},& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.middleButton}`]: {
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 0
                    },
                    [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.lastButton},& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.middleButton}`]: {
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0
                    }
                }
            },
            {
                props: {
                    variant: 'text',
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.firstButton},& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.middleButton}`]: {
                        borderRight: theme.vars ? `1px solid ${theme.alpha(theme.vars.palette.common.onBackground, 0.23)}` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
                        [`&.${$1c026d95d0d4d482$var$_buttonGroupClasses.default.disabled}`]: {
                            borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            {
                props: {
                    variant: 'text',
                    orientation: 'vertical'
                },
                style: {
                    [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.firstButton},& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.middleButton}`]: {
                        borderBottom: theme.vars ? `1px solid ${theme.alpha(theme.vars.palette.common.onBackground, 0.23)}` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
                        [`&.${$1c026d95d0d4d482$var$_buttonGroupClasses.default.disabled}`]: {
                            borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $1c026d95d0d4d482$var$_createSimplePaletteValueFilter.default)()).flatMap(([color])=>[
                    {
                        props: {
                            variant: 'text',
                            color: color
                        },
                        style: {
                            [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.firstButton},& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.middleButton}`]: {
                                borderColor: theme.alpha((theme.vars || theme).palette[color].main, 0.5)
                            }
                        }
                    }
                ]),
            {
                props: {
                    variant: 'outlined',
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.firstButton},& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.middleButton}`]: {
                        borderRightColor: 'transparent',
                        '&:hover': {
                            borderRightColor: 'currentColor'
                        }
                    },
                    [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.lastButton},& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.middleButton}`]: {
                        marginLeft: -1
                    }
                }
            },
            {
                props: {
                    variant: 'outlined',
                    orientation: 'vertical'
                },
                style: {
                    [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.firstButton},& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.middleButton}`]: {
                        borderBottomColor: 'transparent',
                        '&:hover': {
                            borderBottomColor: 'currentColor'
                        }
                    },
                    [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.lastButton},& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.middleButton}`]: {
                        marginTop: -1
                    }
                }
            },
            {
                props: {
                    variant: 'contained',
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.firstButton},& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.middleButton}`]: {
                        borderRight: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
                        [`&.${$1c026d95d0d4d482$var$_buttonGroupClasses.default.disabled}`]: {
                            borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            {
                props: {
                    variant: 'contained',
                    orientation: 'vertical'
                },
                style: {
                    [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.firstButton},& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.middleButton}`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
                        [`&.${$1c026d95d0d4d482$var$_buttonGroupClasses.default.disabled}`]: {
                            borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $1c026d95d0d4d482$var$_createSimplePaletteValueFilter.default)([
                'dark'
            ])).map(([color])=>({
                    props: {
                        variant: 'contained',
                        color: color
                    },
                    style: {
                        [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.firstButton},& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.middleButton}`]: {
                            borderColor: (theme.vars || theme).palette[color].dark
                        }
                    }
                }))
        ],
        [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.grouped}`]: {
            minWidth: 40
        }
    })));
const $1c026d95d0d4d482$var$ButtonGroup = /*#__PURE__*/ $1c026d95d0d4d482$var$React.forwardRef(function ButtonGroup(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiButtonGroup'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, disableRipple: disableRipple = false, fullWidth: fullWidth = false, orientation: orientation = 'horizontal', size: size = 'medium', variant: variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        disableRipple: disableRipple,
        fullWidth: fullWidth,
        orientation: orientation,
        size: size,
        variant: variant
    };
    const classes = $1c026d95d0d4d482$var$useUtilityClasses(ownerState);
    const context = $1c026d95d0d4d482$var$React.useMemo(()=>({
            className: classes.grouped,
            color: color,
            disabled: disabled,
            disableElevation: disableElevation,
            disableFocusRipple: disableFocusRipple,
            disableRipple: disableRipple,
            fullWidth: fullWidth,
            size: size,
            variant: variant
        }), [
        color,
        disabled,
        disableElevation,
        disableFocusRipple,
        disableRipple,
        fullWidth,
        size,
        variant,
        classes.grouped
    ]);
    const validChildren = (0, $1c026d95d0d4d482$var$_getValidReactChildren.default)(children);
    const childrenCount = validChildren.length;
    const getButtonPositionClassName = (index)=>{
        const isFirstButton = index === 0;
        const isLastButton = index === childrenCount - 1;
        if (isFirstButton && isLastButton) return '';
        if (isFirstButton) return classes.firstButton;
        if (isLastButton) return classes.lastButton;
        return classes.middleButton;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1c026d95d0d4d482$var$ButtonGroupRoot, {
        as: component,
        role: "group",
        className: (0, $1c026d95d0d4d482$var$_clsx.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($1c026d95d0d4d482$var$_ButtonGroupContext.default.Provider, {
            value: context,
            children: validChildren.map((child, index)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)($1c026d95d0d4d482$var$_ButtonGroupButtonContext.default.Provider, {
                    value: getButtonPositionClassName(index),
                    children: child
                }, index);
            })
        })
    });
});
$1c026d95d0d4d482$var$ButtonGroup.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: $1c026d95d0d4d482$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $1c026d95d0d4d482$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $1c026d95d0d4d482$var$_propTypes.default.string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */ color: $1c026d95d0d4d482$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $1c026d95d0d4d482$var$_propTypes.default.oneOf([
            'inherit',
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning'
        ]),
        $1c026d95d0d4d482$var$_propTypes.default.string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $1c026d95d0d4d482$var$_propTypes.default.elementType,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: $1c026d95d0d4d482$var$_propTypes.default.bool,
    /**
   * If `true`, no elevation is used.
   * @default false
   */ disableElevation: $1c026d95d0d4d482$var$_propTypes.default.bool,
    /**
   * If `true`, the button keyboard focus ripple is disabled.
   * @default false
   */ disableFocusRipple: $1c026d95d0d4d482$var$_propTypes.default.bool,
    /**
   * If `true`, the button ripple effect is disabled.
   * @default false
   */ disableRipple: $1c026d95d0d4d482$var$_propTypes.default.bool,
    /**
   * If `true`, the buttons will take up the full width of its container.
   * @default false
   */ fullWidth: $1c026d95d0d4d482$var$_propTypes.default.bool,
    /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */ orientation: $1c026d95d0d4d482$var$_propTypes.default.oneOf([
        'horizontal',
        'vertical'
    ]),
    /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */ size: $1c026d95d0d4d482$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $1c026d95d0d4d482$var$_propTypes.default.oneOf([
            'small',
            'medium',
            'large'
        ]),
        $1c026d95d0d4d482$var$_propTypes.default.string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $1c026d95d0d4d482$var$_propTypes.default.oneOfType([
        $1c026d95d0d4d482$var$_propTypes.default.arrayOf($1c026d95d0d4d482$var$_propTypes.default.oneOfType([
            $1c026d95d0d4d482$var$_propTypes.default.func,
            $1c026d95d0d4d482$var$_propTypes.default.object,
            $1c026d95d0d4d482$var$_propTypes.default.bool
        ])),
        $1c026d95d0d4d482$var$_propTypes.default.func,
        $1c026d95d0d4d482$var$_propTypes.default.object
    ]),
    /**
   * The variant to use.
   * @default 'outlined'
   */ variant: $1c026d95d0d4d482$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $1c026d95d0d4d482$var$_propTypes.default.oneOf([
            'contained',
            'outlined',
            'text'
        ]),
        $1c026d95d0d4d482$var$_propTypes.default.string
    ])
};
var $1c026d95d0d4d482$var$_default = module.exports.default = $1c026d95d0d4d482$var$ButtonGroup;

});
parcelRegister("2jgfV", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $1ae9f731a004cefb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $1ae9f731a004cefb$var$_getValidReactChildren.default;
    }
});

var $1ae9f731a004cefb$var$_getValidReactChildren = $1ae9f731a004cefb$require$_interopRequireDefault((parcelRequire("6I7Xt")));

});
parcelRegister("6I7Xt", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $4e2d0676303c0919$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4e2d0676303c0919$var$getValidReactChildren;

var $4e2d0676303c0919$var$React = $4e2d0676303c0919$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * Gets only the valid children of a component,
 * and ignores any nullish or falsy child.
 *
 * @param children the children
 */ function $4e2d0676303c0919$var$getValidReactChildren(children) {
    return $4e2d0676303c0919$var$React.Children.toArray(children).filter((child)=>/*#__PURE__*/ $4e2d0676303c0919$var$React.isValidElement(child));
}

});


parcelRegister("d8s3C", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9901c9510940cf3a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getButtonGroupUtilityClass = $9901c9510940cf3a$var$getButtonGroupUtilityClass;

var $9901c9510940cf3a$var$_generateUtilityClasses = $9901c9510940cf3a$require$_interopRequireDefault((parcelRequire("5nY49")));

var $9901c9510940cf3a$var$_generateUtilityClass = $9901c9510940cf3a$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $9901c9510940cf3a$var$getButtonGroupUtilityClass(slot) {
    return (0, $9901c9510940cf3a$var$_generateUtilityClass.default)('MuiButtonGroup', slot);
}
const $9901c9510940cf3a$var$buttonGroupClasses = (0, $9901c9510940cf3a$var$_generateUtilityClasses.default)('MuiButtonGroup', [
    'root',
    'contained',
    'outlined',
    'text',
    'disableElevation',
    'disabled',
    'firstButton',
    'fullWidth',
    'horizontal',
    'vertical',
    'colorPrimary',
    'colorSecondary',
    'grouped',
    'groupedHorizontal',
    'groupedVertical',
    'groupedText',
    'groupedTextHorizontal',
    'groupedTextVertical',
    'groupedTextPrimary',
    'groupedTextSecondary',
    'groupedOutlined',
    'groupedOutlinedHorizontal',
    'groupedOutlinedVertical',
    'groupedOutlinedPrimary',
    'groupedOutlinedSecondary',
    'groupedContained',
    'groupedContainedHorizontal',
    'groupedContainedVertical',
    'groupedContainedPrimary',
    'groupedContainedSecondary',
    'lastButton',
    'middleButton'
]);
var $9901c9510940cf3a$var$_default = module.exports.default = $9901c9510940cf3a$var$buttonGroupClasses;

});



parcelRegister("3HHKi", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $2b27523fd597460f$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $2b27523fd597460f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $2b27523fd597460f$var$_exportNames = {
    cardClasses: true
};
Object.defineProperty(module.exports, "cardClasses", {
    enumerable: true,
    get: function() {
        return $2b27523fd597460f$var$_cardClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $2b27523fd597460f$var$_Card.default;
    }
});

var $2b27523fd597460f$var$_Card = $2b27523fd597460f$require$_interopRequireDefault((parcelRequire("5WjaY")));

var $2b27523fd597460f$var$_cardClasses = $2b27523fd597460f$require$_interopRequireWildcard((parcelRequire("bOBRq")));
Object.keys($2b27523fd597460f$var$_cardClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2b27523fd597460f$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $2b27523fd597460f$var$_cardClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2b27523fd597460f$var$_cardClasses[key];
        }
    });
});

});
parcelRegister("5WjaY", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $45313e7d506ce734$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $45313e7d506ce734$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $45313e7d506ce734$var$React = $45313e7d506ce734$require$_interopRequireWildcard((parcelRequire("acw62")));

var $45313e7d506ce734$var$_propTypes = $45313e7d506ce734$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $45313e7d506ce734$var$_clsx = $45313e7d506ce734$require$_interopRequireDefault((parcelRequire("9QePP")));

var $45313e7d506ce734$var$_chainPropTypes = $45313e7d506ce734$require$_interopRequireDefault((parcelRequire("abVWF")));

var $45313e7d506ce734$var$_composeClasses = $45313e7d506ce734$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $45313e7d506ce734$var$_Paper = $45313e7d506ce734$require$_interopRequireDefault((parcelRequire("juRJQ")));

var $bOBRq = parcelRequire("bOBRq");

var $ayMG0 = parcelRequire("ayMG0");
const $45313e7d506ce734$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $45313e7d506ce734$var$_composeClasses.default)(slots, $bOBRq.getCardUtilityClass, classes);
};
const $45313e7d506ce734$var$CardRoot = (0, $aAbgT.styled)($45313e7d506ce734$var$_Paper.default, {
    name: 'MuiCard',
    slot: 'Root'
})({
    overflow: 'hidden'
});
const $45313e7d506ce734$var$Card = /*#__PURE__*/ $45313e7d506ce734$var$React.forwardRef(function Card(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiCard'
    });
    const { className: className, raised: raised = false, ...other } = props;
    const ownerState = {
        ...props,
        raised: raised
    };
    const classes = $45313e7d506ce734$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($45313e7d506ce734$var$CardRoot, {
        className: (0, $45313e7d506ce734$var$_clsx.default)(classes.root, className),
        elevation: raised ? 8 : undefined,
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
$45313e7d506ce734$var$Card.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: $45313e7d506ce734$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $45313e7d506ce734$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $45313e7d506ce734$var$_propTypes.default.string,
    /**
   * If `true`, the card will use raised styling.
   * @default false
   */ raised: (0, $45313e7d506ce734$var$_chainPropTypes.default)($45313e7d506ce734$var$_propTypes.default.bool, (props)=>{
        if (props.raised && props.variant === 'outlined') return new Error('MUI: Combining `raised={true}` with `variant="outlined"` has no effect.');
        return null;
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $45313e7d506ce734$var$_propTypes.default.oneOfType([
        $45313e7d506ce734$var$_propTypes.default.arrayOf($45313e7d506ce734$var$_propTypes.default.oneOfType([
            $45313e7d506ce734$var$_propTypes.default.func,
            $45313e7d506ce734$var$_propTypes.default.object,
            $45313e7d506ce734$var$_propTypes.default.bool
        ])),
        $45313e7d506ce734$var$_propTypes.default.func,
        $45313e7d506ce734$var$_propTypes.default.object
    ])
};
var $45313e7d506ce734$var$_default = module.exports.default = $45313e7d506ce734$var$Card;

});
parcelRegister("bOBRq", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $89a1bb9709695920$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getCardUtilityClass = $89a1bb9709695920$var$getCardUtilityClass;

var $89a1bb9709695920$var$_generateUtilityClasses = $89a1bb9709695920$require$_interopRequireDefault((parcelRequire("5nY49")));

var $89a1bb9709695920$var$_generateUtilityClass = $89a1bb9709695920$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $89a1bb9709695920$var$getCardUtilityClass(slot) {
    return (0, $89a1bb9709695920$var$_generateUtilityClass.default)('MuiCard', slot);
}
const $89a1bb9709695920$var$cardClasses = (0, $89a1bb9709695920$var$_generateUtilityClasses.default)('MuiCard', [
    'root'
]);
var $89a1bb9709695920$var$_default = module.exports.default = $89a1bb9709695920$var$cardClasses;

});



parcelRegister("kIb8C", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $f1408e763033c57b$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $f1408e763033c57b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $f1408e763033c57b$var$_exportNames = {
    cardActionAreaClasses: true
};
Object.defineProperty(module.exports, "cardActionAreaClasses", {
    enumerable: true,
    get: function() {
        return $f1408e763033c57b$var$_cardActionAreaClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $f1408e763033c57b$var$_CardActionArea.default;
    }
});

var $f1408e763033c57b$var$_CardActionArea = $f1408e763033c57b$require$_interopRequireDefault((parcelRequire("c3ykc")));

var $f1408e763033c57b$var$_cardActionAreaClasses = $f1408e763033c57b$require$_interopRequireWildcard((parcelRequire("6apEP")));
Object.keys($f1408e763033c57b$var$_cardActionAreaClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($f1408e763033c57b$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $f1408e763033c57b$var$_cardActionAreaClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $f1408e763033c57b$var$_cardActionAreaClasses[key];
        }
    });
});

});
parcelRegister("c3ykc", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $8c7064036f0f2f9d$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $8c7064036f0f2f9d$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8c7064036f0f2f9d$var$React = $8c7064036f0f2f9d$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8c7064036f0f2f9d$var$_propTypes = $8c7064036f0f2f9d$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8c7064036f0f2f9d$var$_clsx = $8c7064036f0f2f9d$require$_interopRequireDefault((parcelRequire("9QePP")));

var $8c7064036f0f2f9d$var$_composeClasses = $8c7064036f0f2f9d$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $8c7064036f0f2f9d$var$_memoTheme = $8c7064036f0f2f9d$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $8c7064036f0f2f9d$var$_cardActionAreaClasses = $8c7064036f0f2f9d$require$_interopRequireWildcard((parcelRequire("6apEP")));

var $8c7064036f0f2f9d$var$_ButtonBase = $8c7064036f0f2f9d$require$_interopRequireDefault((parcelRequire("hhs3r")));

var $8c7064036f0f2f9d$var$_useSlot = $8c7064036f0f2f9d$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $8c7064036f0f2f9d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        focusHighlight: [
            'focusHighlight'
        ]
    };
    return (0, $8c7064036f0f2f9d$var$_composeClasses.default)(slots, $8c7064036f0f2f9d$var$_cardActionAreaClasses.getCardActionAreaUtilityClass, classes);
};
const $8c7064036f0f2f9d$var$CardActionAreaRoot = (0, $aAbgT.styled)($8c7064036f0f2f9d$var$_ButtonBase.default, {
    name: 'MuiCardActionArea',
    slot: 'Root'
})((0, $8c7064036f0f2f9d$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'block',
        textAlign: 'inherit',
        borderRadius: 'inherit',
        // for Safari to work https://github.com/mui/material-ui/issues/36285.
        width: '100%',
        [`&:hover .${$8c7064036f0f2f9d$var$_cardActionAreaClasses.default.focusHighlight}`]: {
            opacity: (theme.vars || theme).palette.action.hoverOpacity,
            '@media (hover: none)': {
                opacity: 0
            }
        },
        [`&.${$8c7064036f0f2f9d$var$_cardActionAreaClasses.default.focusVisible} .${$8c7064036f0f2f9d$var$_cardActionAreaClasses.default.focusHighlight}`]: {
            opacity: (theme.vars || theme).palette.action.focusOpacity
        }
    })));
const $8c7064036f0f2f9d$var$CardActionAreaFocusHighlight = (0, $aAbgT.styled)('span', {
    name: 'MuiCardActionArea',
    slot: 'FocusHighlight'
})((0, $8c7064036f0f2f9d$var$_memoTheme.default)(({ theme: theme })=>({
        overflow: 'hidden',
        pointerEvents: 'none',
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        borderRadius: 'inherit',
        opacity: 0,
        backgroundColor: 'currentcolor',
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.short
        })
    })));
const $8c7064036f0f2f9d$var$CardActionArea = /*#__PURE__*/ $8c7064036f0f2f9d$var$React.forwardRef(function CardActionArea(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiCardActionArea'
    });
    const { children: children, className: className, focusVisibleClassName: focusVisibleClassName, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const ownerState = props;
    const classes = $8c7064036f0f2f9d$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootProps] = (0, $8c7064036f0f2f9d$var$_useSlot.default)('root', {
        elementType: $8c7064036f0f2f9d$var$CardActionAreaRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        shouldForwardComponentProp: true,
        ownerState: ownerState,
        ref: ref,
        className: (0, $8c7064036f0f2f9d$var$_clsx.default)(classes.root, className),
        additionalProps: {
            focusVisibleClassName: (0, $8c7064036f0f2f9d$var$_clsx.default)(focusVisibleClassName, classes.focusVisible)
        }
    });
    const [FocusHighlightSlot, focusHighlightProps] = (0, $8c7064036f0f2f9d$var$_useSlot.default)('focusHighlight', {
        elementType: $8c7064036f0f2f9d$var$CardActionAreaFocusHighlight,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.focusHighlight
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            children,
            /*#__PURE__*/ (0, $ayMG0.jsx)(FocusHighlightSlot, {
                ...focusHighlightProps
            })
        ]
    });
});
$8c7064036f0f2f9d$var$CardActionArea.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: $8c7064036f0f2f9d$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $8c7064036f0f2f9d$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $8c7064036f0f2f9d$var$_propTypes.default.string,
    /**
   * @ignore
   */ focusVisibleClassName: $8c7064036f0f2f9d$var$_propTypes.default.string,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $8c7064036f0f2f9d$var$_propTypes.default.shape({
        focusHighlight: $8c7064036f0f2f9d$var$_propTypes.default.oneOfType([
            $8c7064036f0f2f9d$var$_propTypes.default.func,
            $8c7064036f0f2f9d$var$_propTypes.default.object
        ]),
        root: $8c7064036f0f2f9d$var$_propTypes.default.oneOfType([
            $8c7064036f0f2f9d$var$_propTypes.default.func,
            $8c7064036f0f2f9d$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: $8c7064036f0f2f9d$var$_propTypes.default.shape({
        focusHighlight: $8c7064036f0f2f9d$var$_propTypes.default.elementType,
        root: $8c7064036f0f2f9d$var$_propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $8c7064036f0f2f9d$var$_propTypes.default.oneOfType([
        $8c7064036f0f2f9d$var$_propTypes.default.arrayOf($8c7064036f0f2f9d$var$_propTypes.default.oneOfType([
            $8c7064036f0f2f9d$var$_propTypes.default.func,
            $8c7064036f0f2f9d$var$_propTypes.default.object,
            $8c7064036f0f2f9d$var$_propTypes.default.bool
        ])),
        $8c7064036f0f2f9d$var$_propTypes.default.func,
        $8c7064036f0f2f9d$var$_propTypes.default.object
    ])
};
var $8c7064036f0f2f9d$var$_default = module.exports.default = $8c7064036f0f2f9d$var$CardActionArea;

});
parcelRegister("6apEP", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $47d794472d40adee$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getCardActionAreaUtilityClass = $47d794472d40adee$var$getCardActionAreaUtilityClass;

var $47d794472d40adee$var$_generateUtilityClasses = $47d794472d40adee$require$_interopRequireDefault((parcelRequire("5nY49")));

var $47d794472d40adee$var$_generateUtilityClass = $47d794472d40adee$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $47d794472d40adee$var$getCardActionAreaUtilityClass(slot) {
    return (0, $47d794472d40adee$var$_generateUtilityClass.default)('MuiCardActionArea', slot);
}
const $47d794472d40adee$var$cardActionAreaClasses = (0, $47d794472d40adee$var$_generateUtilityClasses.default)('MuiCardActionArea', [
    'root',
    'focusVisible',
    'focusHighlight'
]);
var $47d794472d40adee$var$_default = module.exports.default = $47d794472d40adee$var$cardActionAreaClasses;

});



parcelRegister("Hi2UE", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $082203d287675024$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $082203d287675024$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $082203d287675024$var$_exportNames = {
    cardActionsClasses: true
};
Object.defineProperty(module.exports, "cardActionsClasses", {
    enumerable: true,
    get: function() {
        return $082203d287675024$var$_cardActionsClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $082203d287675024$var$_CardActions.default;
    }
});

var $082203d287675024$var$_CardActions = $082203d287675024$require$_interopRequireDefault((parcelRequire("fulwV")));

var $082203d287675024$var$_cardActionsClasses = $082203d287675024$require$_interopRequireWildcard((parcelRequire("6yuOx")));
Object.keys($082203d287675024$var$_cardActionsClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($082203d287675024$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $082203d287675024$var$_cardActionsClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $082203d287675024$var$_cardActionsClasses[key];
        }
    });
});

});
parcelRegister("fulwV", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $b46a5bcac23a5f99$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $b46a5bcac23a5f99$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b46a5bcac23a5f99$var$React = $b46a5bcac23a5f99$require$_interopRequireWildcard((parcelRequire("acw62")));

var $b46a5bcac23a5f99$var$_propTypes = $b46a5bcac23a5f99$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $b46a5bcac23a5f99$var$_clsx = $b46a5bcac23a5f99$require$_interopRequireDefault((parcelRequire("9QePP")));

var $b46a5bcac23a5f99$var$_composeClasses = $b46a5bcac23a5f99$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $6yuOx = parcelRequire("6yuOx");

var $ayMG0 = parcelRequire("ayMG0");
const $b46a5bcac23a5f99$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, $b46a5bcac23a5f99$var$_composeClasses.default)(slots, $6yuOx.getCardActionsUtilityClass, classes);
};
const $b46a5bcac23a5f99$var$CardActionsRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiCardActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})({
    display: 'flex',
    alignItems: 'center',
    padding: 8,
    variants: [
        {
            props: {
                disableSpacing: false
            },
            style: {
                '& > :not(style) ~ :not(style)': {
                    marginLeft: 8
                }
            }
        }
    ]
});
const $b46a5bcac23a5f99$var$CardActions = /*#__PURE__*/ $b46a5bcac23a5f99$var$React.forwardRef(function CardActions(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiCardActions'
    });
    const { disableSpacing: disableSpacing = false, className: className, ...other } = props;
    const ownerState = {
        ...props,
        disableSpacing: disableSpacing
    };
    const classes = $b46a5bcac23a5f99$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($b46a5bcac23a5f99$var$CardActionsRoot, {
        className: (0, $b46a5bcac23a5f99$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
$b46a5bcac23a5f99$var$CardActions.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: $b46a5bcac23a5f99$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $b46a5bcac23a5f99$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $b46a5bcac23a5f99$var$_propTypes.default.string,
    /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */ disableSpacing: $b46a5bcac23a5f99$var$_propTypes.default.bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $b46a5bcac23a5f99$var$_propTypes.default.oneOfType([
        $b46a5bcac23a5f99$var$_propTypes.default.arrayOf($b46a5bcac23a5f99$var$_propTypes.default.oneOfType([
            $b46a5bcac23a5f99$var$_propTypes.default.func,
            $b46a5bcac23a5f99$var$_propTypes.default.object,
            $b46a5bcac23a5f99$var$_propTypes.default.bool
        ])),
        $b46a5bcac23a5f99$var$_propTypes.default.func,
        $b46a5bcac23a5f99$var$_propTypes.default.object
    ])
};
var $b46a5bcac23a5f99$var$_default = module.exports.default = $b46a5bcac23a5f99$var$CardActions;

});
parcelRegister("6yuOx", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $4c5dd21dca115198$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getCardActionsUtilityClass = $4c5dd21dca115198$var$getCardActionsUtilityClass;

var $4c5dd21dca115198$var$_generateUtilityClasses = $4c5dd21dca115198$require$_interopRequireDefault((parcelRequire("5nY49")));

var $4c5dd21dca115198$var$_generateUtilityClass = $4c5dd21dca115198$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $4c5dd21dca115198$var$getCardActionsUtilityClass(slot) {
    return (0, $4c5dd21dca115198$var$_generateUtilityClass.default)('MuiCardActions', slot);
}
const $4c5dd21dca115198$var$cardActionsClasses = (0, $4c5dd21dca115198$var$_generateUtilityClasses.default)('MuiCardActions', [
    'root',
    'spacing'
]);
var $4c5dd21dca115198$var$_default = module.exports.default = $4c5dd21dca115198$var$cardActionsClasses;

});



parcelRegister("lQHMI", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $fe806b09c0847150$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $fe806b09c0847150$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $fe806b09c0847150$var$_exportNames = {
    cardContentClasses: true
};
Object.defineProperty(module.exports, "cardContentClasses", {
    enumerable: true,
    get: function() {
        return $fe806b09c0847150$var$_cardContentClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $fe806b09c0847150$var$_CardContent.default;
    }
});

var $fe806b09c0847150$var$_CardContent = $fe806b09c0847150$require$_interopRequireDefault((parcelRequire("3ulHf")));

var $fe806b09c0847150$var$_cardContentClasses = $fe806b09c0847150$require$_interopRequireWildcard((parcelRequire("3mVgJ")));
Object.keys($fe806b09c0847150$var$_cardContentClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($fe806b09c0847150$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $fe806b09c0847150$var$_cardContentClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fe806b09c0847150$var$_cardContentClasses[key];
        }
    });
});

});
parcelRegister("3ulHf", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $28a500ea92f2665f$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $28a500ea92f2665f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $28a500ea92f2665f$var$React = $28a500ea92f2665f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $28a500ea92f2665f$var$_propTypes = $28a500ea92f2665f$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $28a500ea92f2665f$var$_clsx = $28a500ea92f2665f$require$_interopRequireDefault((parcelRequire("9QePP")));

var $28a500ea92f2665f$var$_composeClasses = $28a500ea92f2665f$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $3mVgJ = parcelRequire("3mVgJ");

var $ayMG0 = parcelRequire("ayMG0");
const $28a500ea92f2665f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $28a500ea92f2665f$var$_composeClasses.default)(slots, $3mVgJ.getCardContentUtilityClass, classes);
};
const $28a500ea92f2665f$var$CardContentRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiCardContent',
    slot: 'Root'
})({
    padding: 16,
    '&:last-child': {
        paddingBottom: 24
    }
});
const $28a500ea92f2665f$var$CardContent = /*#__PURE__*/ $28a500ea92f2665f$var$React.forwardRef(function CardContent(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiCardContent'
    });
    const { className: className, component: component = 'div', ...other } = props;
    const ownerState = {
        ...props,
        component: component
    };
    const classes = $28a500ea92f2665f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($28a500ea92f2665f$var$CardContentRoot, {
        as: component,
        className: (0, $28a500ea92f2665f$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
$28a500ea92f2665f$var$CardContent.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: $28a500ea92f2665f$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $28a500ea92f2665f$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $28a500ea92f2665f$var$_propTypes.default.string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $28a500ea92f2665f$var$_propTypes.default.elementType,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $28a500ea92f2665f$var$_propTypes.default.oneOfType([
        $28a500ea92f2665f$var$_propTypes.default.arrayOf($28a500ea92f2665f$var$_propTypes.default.oneOfType([
            $28a500ea92f2665f$var$_propTypes.default.func,
            $28a500ea92f2665f$var$_propTypes.default.object,
            $28a500ea92f2665f$var$_propTypes.default.bool
        ])),
        $28a500ea92f2665f$var$_propTypes.default.func,
        $28a500ea92f2665f$var$_propTypes.default.object
    ])
};
var $28a500ea92f2665f$var$_default = module.exports.default = $28a500ea92f2665f$var$CardContent;

});
parcelRegister("3mVgJ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $273fd99738f3adbe$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getCardContentUtilityClass = $273fd99738f3adbe$var$getCardContentUtilityClass;

var $273fd99738f3adbe$var$_generateUtilityClasses = $273fd99738f3adbe$require$_interopRequireDefault((parcelRequire("5nY49")));

var $273fd99738f3adbe$var$_generateUtilityClass = $273fd99738f3adbe$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $273fd99738f3adbe$var$getCardContentUtilityClass(slot) {
    return (0, $273fd99738f3adbe$var$_generateUtilityClass.default)('MuiCardContent', slot);
}
const $273fd99738f3adbe$var$cardContentClasses = (0, $273fd99738f3adbe$var$_generateUtilityClasses.default)('MuiCardContent', [
    'root'
]);
var $273fd99738f3adbe$var$_default = module.exports.default = $273fd99738f3adbe$var$cardContentClasses;

});



parcelRegister("4DqKh", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $35ff8d0aba128694$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $35ff8d0aba128694$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $35ff8d0aba128694$var$_exportNames = {
    cardHeaderClasses: true
};
Object.defineProperty(module.exports, "cardHeaderClasses", {
    enumerable: true,
    get: function() {
        return $35ff8d0aba128694$var$_cardHeaderClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $35ff8d0aba128694$var$_CardHeader.default;
    }
});

var $35ff8d0aba128694$var$_CardHeader = $35ff8d0aba128694$require$_interopRequireDefault((parcelRequire("g9Cmg")));

var $35ff8d0aba128694$var$_cardHeaderClasses = $35ff8d0aba128694$require$_interopRequireWildcard((parcelRequire("TvS1j")));
Object.keys($35ff8d0aba128694$var$_cardHeaderClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($35ff8d0aba128694$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $35ff8d0aba128694$var$_cardHeaderClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $35ff8d0aba128694$var$_cardHeaderClasses[key];
        }
    });
});

});
parcelRegister("g9Cmg", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $bc2b3dbd11553d00$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $bc2b3dbd11553d00$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bc2b3dbd11553d00$var$React = $bc2b3dbd11553d00$require$_interopRequireWildcard((parcelRequire("acw62")));

var $bc2b3dbd11553d00$var$_propTypes = $bc2b3dbd11553d00$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $bc2b3dbd11553d00$var$_composeClasses = $bc2b3dbd11553d00$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $bc2b3dbd11553d00$var$_Typography = $bc2b3dbd11553d00$require$_interopRequireWildcard((parcelRequire("2dUd7")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $bc2b3dbd11553d00$var$_cardHeaderClasses = $bc2b3dbd11553d00$require$_interopRequireWildcard((parcelRequire("TvS1j")));

var $bc2b3dbd11553d00$var$_useSlot = $bc2b3dbd11553d00$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $bc2b3dbd11553d00$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        avatar: [
            'avatar'
        ],
        action: [
            'action'
        ],
        content: [
            'content'
        ],
        title: [
            'title'
        ],
        subheader: [
            'subheader'
        ]
    };
    return (0, $bc2b3dbd11553d00$var$_composeClasses.default)(slots, $bc2b3dbd11553d00$var$_cardHeaderClasses.getCardHeaderUtilityClass, classes);
};
const $bc2b3dbd11553d00$var$CardHeaderRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiCardHeader',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        return [
            {
                [`& .${$bc2b3dbd11553d00$var$_cardHeaderClasses.default.title}`]: styles.title
            },
            {
                [`& .${$bc2b3dbd11553d00$var$_cardHeaderClasses.default.subheader}`]: styles.subheader
            },
            styles.root
        ];
    }
})({
    display: 'flex',
    alignItems: 'center',
    padding: 16
});
const $bc2b3dbd11553d00$var$CardHeaderAvatar = (0, $aAbgT.styled)('div', {
    name: 'MuiCardHeader',
    slot: 'Avatar'
})({
    display: 'flex',
    flex: '0 0 auto',
    marginRight: 16
});
const $bc2b3dbd11553d00$var$CardHeaderAction = (0, $aAbgT.styled)('div', {
    name: 'MuiCardHeader',
    slot: 'Action'
})({
    flex: '0 0 auto',
    alignSelf: 'flex-start',
    marginTop: -4,
    marginRight: -8,
    marginBottom: -4
});
const $bc2b3dbd11553d00$var$CardHeaderContent = (0, $aAbgT.styled)('div', {
    name: 'MuiCardHeader',
    slot: 'Content'
})({
    flex: '1 1 auto',
    // Combine this and the below selector once https://github.com/emotion-js/emotion/issues/3366 is solved
    [`.${$bc2b3dbd11553d00$var$_Typography.typographyClasses.root}:where(& .${$bc2b3dbd11553d00$var$_cardHeaderClasses.default.title})`]: {
        display: 'block'
    },
    [`.${$bc2b3dbd11553d00$var$_Typography.typographyClasses.root}:where(& .${$bc2b3dbd11553d00$var$_cardHeaderClasses.default.subheader})`]: {
        display: 'block'
    }
});
const $bc2b3dbd11553d00$var$CardHeader = /*#__PURE__*/ $bc2b3dbd11553d00$var$React.forwardRef(function CardHeader(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiCardHeader'
    });
    const { action: action, avatar: avatar, component: component = 'div', disableTypography: disableTypography = false, subheader: subheaderProp, subheaderTypographyProps: subheaderTypographyProps, title: titleProp, titleTypographyProps: titleTypographyProps, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        disableTypography: disableTypography
    };
    const classes = $bc2b3dbd11553d00$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            title: titleTypographyProps,
            subheader: subheaderTypographyProps,
            ...slotProps
        }
    };
    let title = titleProp;
    const [TitleSlot, titleSlotProps] = (0, $bc2b3dbd11553d00$var$_useSlot.default)('title', {
        className: classes.title,
        elementType: $bc2b3dbd11553d00$var$_Typography.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            variant: avatar ? 'body2' : 'h5',
            component: 'span'
        }
    });
    if (title != null && title.type !== $bc2b3dbd11553d00$var$_Typography.default && !disableTypography) title = /*#__PURE__*/ (0, $ayMG0.jsx)(TitleSlot, {
        ...titleSlotProps,
        children: title
    });
    let subheader = subheaderProp;
    const [SubheaderSlot, subheaderSlotProps] = (0, $bc2b3dbd11553d00$var$_useSlot.default)('subheader', {
        className: classes.subheader,
        elementType: $bc2b3dbd11553d00$var$_Typography.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            variant: avatar ? 'body2' : 'body1',
            color: 'textSecondary',
            component: 'span'
        }
    });
    if (subheader != null && subheader.type !== $bc2b3dbd11553d00$var$_Typography.default && !disableTypography) subheader = /*#__PURE__*/ (0, $ayMG0.jsx)(SubheaderSlot, {
        ...subheaderSlotProps,
        children: subheader
    });
    const [RootSlot, rootSlotProps] = (0, $bc2b3dbd11553d00$var$_useSlot.default)('root', {
        ref: ref,
        className: classes.root,
        elementType: $bc2b3dbd11553d00$var$CardHeaderRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            component: component
        },
        ownerState: ownerState
    });
    const [AvatarSlot, avatarSlotProps] = (0, $bc2b3dbd11553d00$var$_useSlot.default)('avatar', {
        className: classes.avatar,
        elementType: $bc2b3dbd11553d00$var$CardHeaderAvatar,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ContentSlot, contentSlotProps] = (0, $bc2b3dbd11553d00$var$_useSlot.default)('content', {
        className: classes.content,
        elementType: $bc2b3dbd11553d00$var$CardHeaderContent,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ActionSlot, actionSlotProps] = (0, $bc2b3dbd11553d00$var$_useSlot.default)('action', {
        className: classes.action,
        elementType: $bc2b3dbd11553d00$var$CardHeaderAction,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            avatar && /*#__PURE__*/ (0, $ayMG0.jsx)(AvatarSlot, {
                ...avatarSlotProps,
                children: avatar
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)(ContentSlot, {
                ...contentSlotProps,
                children: [
                    title,
                    subheader
                ]
            }),
            action && /*#__PURE__*/ (0, $ayMG0.jsx)(ActionSlot, {
                ...actionSlotProps,
                children: action
            })
        ]
    });
});
$bc2b3dbd11553d00$var$CardHeader.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The action to display in the card header.
   */ action: $bc2b3dbd11553d00$var$_propTypes.default.node,
    /**
   * The Avatar element to display.
   */ avatar: $bc2b3dbd11553d00$var$_propTypes.default.node,
    /**
   * @ignore
   */ children: $bc2b3dbd11553d00$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $bc2b3dbd11553d00$var$_propTypes.default.object,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $bc2b3dbd11553d00$var$_propTypes.default.elementType,
    /**
   * If `true`, `subheader` and `title` won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `title` text, and optional `subheader` text
   * with the Typography component.
   * @default false
   */ disableTypography: $bc2b3dbd11553d00$var$_propTypes.default.bool,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $bc2b3dbd11553d00$var$_propTypes.default.shape({
        action: $bc2b3dbd11553d00$var$_propTypes.default.oneOfType([
            $bc2b3dbd11553d00$var$_propTypes.default.func,
            $bc2b3dbd11553d00$var$_propTypes.default.object
        ]),
        avatar: $bc2b3dbd11553d00$var$_propTypes.default.oneOfType([
            $bc2b3dbd11553d00$var$_propTypes.default.func,
            $bc2b3dbd11553d00$var$_propTypes.default.object
        ]),
        content: $bc2b3dbd11553d00$var$_propTypes.default.oneOfType([
            $bc2b3dbd11553d00$var$_propTypes.default.func,
            $bc2b3dbd11553d00$var$_propTypes.default.object
        ]),
        root: $bc2b3dbd11553d00$var$_propTypes.default.oneOfType([
            $bc2b3dbd11553d00$var$_propTypes.default.func,
            $bc2b3dbd11553d00$var$_propTypes.default.object
        ]),
        subheader: $bc2b3dbd11553d00$var$_propTypes.default.oneOfType([
            $bc2b3dbd11553d00$var$_propTypes.default.func,
            $bc2b3dbd11553d00$var$_propTypes.default.object
        ]),
        title: $bc2b3dbd11553d00$var$_propTypes.default.oneOfType([
            $bc2b3dbd11553d00$var$_propTypes.default.func,
            $bc2b3dbd11553d00$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: $bc2b3dbd11553d00$var$_propTypes.default.shape({
        action: $bc2b3dbd11553d00$var$_propTypes.default.elementType,
        avatar: $bc2b3dbd11553d00$var$_propTypes.default.elementType,
        content: $bc2b3dbd11553d00$var$_propTypes.default.elementType,
        root: $bc2b3dbd11553d00$var$_propTypes.default.elementType,
        subheader: $bc2b3dbd11553d00$var$_propTypes.default.elementType,
        title: $bc2b3dbd11553d00$var$_propTypes.default.elementType
    }),
    /**
   * The content of the component.
   */ subheader: $bc2b3dbd11553d00$var$_propTypes.default.node,
    /**
   * These props will be forwarded to the subheader
   * (as long as disableTypography is not `true`).
   * @deprecated Use `slotProps.subheader` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ subheaderTypographyProps: $bc2b3dbd11553d00$var$_propTypes.default.object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $bc2b3dbd11553d00$var$_propTypes.default.oneOfType([
        $bc2b3dbd11553d00$var$_propTypes.default.arrayOf($bc2b3dbd11553d00$var$_propTypes.default.oneOfType([
            $bc2b3dbd11553d00$var$_propTypes.default.func,
            $bc2b3dbd11553d00$var$_propTypes.default.object,
            $bc2b3dbd11553d00$var$_propTypes.default.bool
        ])),
        $bc2b3dbd11553d00$var$_propTypes.default.func,
        $bc2b3dbd11553d00$var$_propTypes.default.object
    ]),
    /**
   * The content of the component.
   */ title: $bc2b3dbd11553d00$var$_propTypes.default.node,
    /**
   * These props will be forwarded to the title
   * (as long as disableTypography is not `true`).
   * @deprecated Use `slotProps.title` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ titleTypographyProps: $bc2b3dbd11553d00$var$_propTypes.default.object
};
var $bc2b3dbd11553d00$var$_default = module.exports.default = $bc2b3dbd11553d00$var$CardHeader;

});
parcelRegister("TvS1j", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0a6ddbf21430a4ea$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getCardHeaderUtilityClass = $0a6ddbf21430a4ea$var$getCardHeaderUtilityClass;

var $0a6ddbf21430a4ea$var$_generateUtilityClasses = $0a6ddbf21430a4ea$require$_interopRequireDefault((parcelRequire("5nY49")));

var $0a6ddbf21430a4ea$var$_generateUtilityClass = $0a6ddbf21430a4ea$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $0a6ddbf21430a4ea$var$getCardHeaderUtilityClass(slot) {
    return (0, $0a6ddbf21430a4ea$var$_generateUtilityClass.default)('MuiCardHeader', slot);
}
const $0a6ddbf21430a4ea$var$cardHeaderClasses = (0, $0a6ddbf21430a4ea$var$_generateUtilityClasses.default)('MuiCardHeader', [
    'root',
    'avatar',
    'action',
    'content',
    'title',
    'subheader'
]);
var $0a6ddbf21430a4ea$var$_default = module.exports.default = $0a6ddbf21430a4ea$var$cardHeaderClasses;

});



parcelRegister("epQZV", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $a7ec82c27a16d3bc$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $a7ec82c27a16d3bc$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $a7ec82c27a16d3bc$var$_exportNames = {
    cardMediaClasses: true
};
Object.defineProperty(module.exports, "cardMediaClasses", {
    enumerable: true,
    get: function() {
        return $a7ec82c27a16d3bc$var$_cardMediaClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $a7ec82c27a16d3bc$var$_CardMedia.default;
    }
});

var $a7ec82c27a16d3bc$var$_CardMedia = $a7ec82c27a16d3bc$require$_interopRequireDefault((parcelRequire("bLOCA")));

var $a7ec82c27a16d3bc$var$_cardMediaClasses = $a7ec82c27a16d3bc$require$_interopRequireWildcard((parcelRequire("9ROVq")));
Object.keys($a7ec82c27a16d3bc$var$_cardMediaClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($a7ec82c27a16d3bc$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $a7ec82c27a16d3bc$var$_cardMediaClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $a7ec82c27a16d3bc$var$_cardMediaClasses[key];
        }
    });
});

});
parcelRegister("bLOCA", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $891b59d4b36435bb$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $891b59d4b36435bb$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $891b59d4b36435bb$var$React = $891b59d4b36435bb$require$_interopRequireWildcard((parcelRequire("acw62")));

var $891b59d4b36435bb$var$_propTypes = $891b59d4b36435bb$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $891b59d4b36435bb$var$_clsx = $891b59d4b36435bb$require$_interopRequireDefault((parcelRequire("9QePP")));

var $891b59d4b36435bb$var$_chainPropTypes = $891b59d4b36435bb$require$_interopRequireDefault((parcelRequire("abVWF")));

var $891b59d4b36435bb$var$_composeClasses = $891b59d4b36435bb$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $9ROVq = parcelRequire("9ROVq");

var $ayMG0 = parcelRequire("ayMG0");
const $891b59d4b36435bb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, isMediaComponent: isMediaComponent, isImageComponent: isImageComponent } = ownerState;
    const slots = {
        root: [
            'root',
            isMediaComponent && 'media',
            isImageComponent && 'img'
        ]
    };
    return (0, $891b59d4b36435bb$var$_composeClasses.default)(slots, $9ROVq.getCardMediaUtilityClass, classes);
};
const $891b59d4b36435bb$var$CardMediaRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiCardMedia',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { isMediaComponent: isMediaComponent, isImageComponent: isImageComponent } = ownerState;
        return [
            styles.root,
            isMediaComponent && styles.media,
            isImageComponent && styles.img
        ];
    }
})({
    display: 'block',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    variants: [
        {
            props: {
                isMediaComponent: true
            },
            style: {
                width: '100%'
            }
        },
        {
            props: {
                isImageComponent: true
            },
            style: {
                objectFit: 'cover'
            }
        }
    ]
});
const $891b59d4b36435bb$var$MEDIA_COMPONENTS = [
    'video',
    'audio',
    'picture',
    'iframe',
    'img'
];
const $891b59d4b36435bb$var$IMAGE_COMPONENTS = [
    'picture',
    'img'
];
const $891b59d4b36435bb$var$CardMedia = /*#__PURE__*/ $891b59d4b36435bb$var$React.forwardRef(function CardMedia(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiCardMedia'
    });
    const { children: children, className: className, component: component = 'div', image: image, src: src, style: style, ...other } = props;
    const isMediaComponent = $891b59d4b36435bb$var$MEDIA_COMPONENTS.includes(component);
    const composedStyle = !isMediaComponent && image ? {
        backgroundImage: `url("${image}")`,
        ...style
    } : style;
    const ownerState = {
        ...props,
        component: component,
        isMediaComponent: isMediaComponent,
        isImageComponent: $891b59d4b36435bb$var$IMAGE_COMPONENTS.includes(component)
    };
    const classes = $891b59d4b36435bb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($891b59d4b36435bb$var$CardMediaRoot, {
        className: (0, $891b59d4b36435bb$var$_clsx.default)(classes.root, className),
        as: component,
        role: !isMediaComponent && image ? 'img' : undefined,
        ref: ref,
        style: composedStyle,
        ownerState: ownerState,
        src: isMediaComponent ? image || src : undefined,
        ...other,
        children: children
    });
});
$891b59d4b36435bb$var$CardMedia.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, $891b59d4b36435bb$var$_chainPropTypes.default)($891b59d4b36435bb$var$_propTypes.default.node, (props)=>{
        if (!props.children && !props.image && !props.src && !props.component) return new Error('MUI: Either `children`, `image`, `src` or `component` prop must be specified.');
        return null;
    }),
    /**
   * Override or extend the styles applied to the component.
   */ classes: $891b59d4b36435bb$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $891b59d4b36435bb$var$_propTypes.default.string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $891b59d4b36435bb$var$_propTypes.default.elementType,
    /**
   * Image to be displayed as a background image.
   * Either `image` or `src` prop must be specified.
   * Note that caller must specify height otherwise the image will not be visible.
   */ image: $891b59d4b36435bb$var$_propTypes.default.string,
    /**
   * An alias for `image` property.
   * Available only with media components.
   * Media components: `video`, `audio`, `picture`, `iframe`, `img`.
   */ src: $891b59d4b36435bb$var$_propTypes.default.string,
    /**
   * @ignore
   */ style: $891b59d4b36435bb$var$_propTypes.default.object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $891b59d4b36435bb$var$_propTypes.default.oneOfType([
        $891b59d4b36435bb$var$_propTypes.default.arrayOf($891b59d4b36435bb$var$_propTypes.default.oneOfType([
            $891b59d4b36435bb$var$_propTypes.default.func,
            $891b59d4b36435bb$var$_propTypes.default.object,
            $891b59d4b36435bb$var$_propTypes.default.bool
        ])),
        $891b59d4b36435bb$var$_propTypes.default.func,
        $891b59d4b36435bb$var$_propTypes.default.object
    ])
};
var $891b59d4b36435bb$var$_default = module.exports.default = $891b59d4b36435bb$var$CardMedia;

});
parcelRegister("9ROVq", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $72f090ff2322b6ae$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getCardMediaUtilityClass = $72f090ff2322b6ae$var$getCardMediaUtilityClass;

var $72f090ff2322b6ae$var$_generateUtilityClasses = $72f090ff2322b6ae$require$_interopRequireDefault((parcelRequire("5nY49")));

var $72f090ff2322b6ae$var$_generateUtilityClass = $72f090ff2322b6ae$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $72f090ff2322b6ae$var$getCardMediaUtilityClass(slot) {
    return (0, $72f090ff2322b6ae$var$_generateUtilityClass.default)('MuiCardMedia', slot);
}
const $72f090ff2322b6ae$var$cardMediaClasses = (0, $72f090ff2322b6ae$var$_generateUtilityClasses.default)('MuiCardMedia', [
    'root',
    'media',
    'img'
]);
var $72f090ff2322b6ae$var$_default = module.exports.default = $72f090ff2322b6ae$var$cardMediaClasses;

});



parcelRegister("9GQ55", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $70e06f8560e22c27$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $70e06f8560e22c27$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $70e06f8560e22c27$var$_exportNames = {
    containerClasses: true
};
Object.defineProperty(module.exports, "containerClasses", {
    enumerable: true,
    get: function() {
        return $70e06f8560e22c27$var$_containerClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $70e06f8560e22c27$var$_Container.default;
    }
});

var $70e06f8560e22c27$var$_Container = $70e06f8560e22c27$require$_interopRequireDefault((parcelRequire("2Y0IO")));

var $70e06f8560e22c27$var$_containerClasses = $70e06f8560e22c27$require$_interopRequireWildcard((parcelRequire("grIpz")));
Object.keys($70e06f8560e22c27$var$_containerClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($70e06f8560e22c27$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $70e06f8560e22c27$var$_containerClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $70e06f8560e22c27$var$_containerClasses[key];
        }
    });
});

});
parcelRegister("2Y0IO", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $2291beb327d500f8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2291beb327d500f8$var$_propTypes = $2291beb327d500f8$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $izOUK = parcelRequire("izOUK");

var $2291beb327d500f8$var$_capitalize = $2291beb327d500f8$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $2291beb327d500f8$var$_styled = $2291beb327d500f8$require$_interopRequireDefault((parcelRequire("d8seH")));

var $hL1nr = parcelRequire("hL1nr");
const $2291beb327d500f8$var$Container = (0, $izOUK.createContainer)({
    createStyledComponent: (0, $2291beb327d500f8$var$_styled.default)('div', {
        name: 'MuiContainer',
        slot: 'Root',
        overridesResolver: (props, styles)=>{
            const { ownerState: ownerState } = props;
            return [
                styles.root,
                styles[`maxWidth${(0, $2291beb327d500f8$var$_capitalize.default)(String(ownerState.maxWidth))}`],
                ownerState.fixed && styles.fixed,
                ownerState.disableGutters && styles.disableGutters
            ];
        }
    }),
    useThemeProps: (inProps)=>(0, $hL1nr.useDefaultProps)({
            props: inProps,
            name: 'MuiContainer'
        })
});
$2291beb327d500f8$var$Container.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * @ignore
   */ children: $2291beb327d500f8$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $2291beb327d500f8$var$_propTypes.default.object,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $2291beb327d500f8$var$_propTypes.default.elementType,
    /**
   * If `true`, the left and right padding is removed.
   * @default false
   */ disableGutters: $2291beb327d500f8$var$_propTypes.default.bool,
    /**
   * Set the max-width to match the min-width of the current breakpoint.
   * This is useful if you'd prefer to design for a fixed set of sizes
   * instead of trying to accommodate a fully fluid viewport.
   * It's fluid by default.
   * @default false
   */ fixed: $2291beb327d500f8$var$_propTypes.default.bool,
    /**
   * Determine the max-width of the container.
   * The container width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   * @default 'lg'
   */ maxWidth: $2291beb327d500f8$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $2291beb327d500f8$var$_propTypes.default.oneOf([
            'xs',
            'sm',
            'md',
            'lg',
            'xl',
            false
        ]),
        $2291beb327d500f8$var$_propTypes.default.string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $2291beb327d500f8$var$_propTypes.default.oneOfType([
        $2291beb327d500f8$var$_propTypes.default.arrayOf($2291beb327d500f8$var$_propTypes.default.oneOfType([
            $2291beb327d500f8$var$_propTypes.default.func,
            $2291beb327d500f8$var$_propTypes.default.object,
            $2291beb327d500f8$var$_propTypes.default.bool
        ])),
        $2291beb327d500f8$var$_propTypes.default.func,
        $2291beb327d500f8$var$_propTypes.default.object
    ])
};
var $2291beb327d500f8$var$_default = module.exports.default = $2291beb327d500f8$var$Container;

});

parcelRegister("grIpz", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $bf919e292c78caff$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getContainerUtilityClass = $bf919e292c78caff$var$getContainerUtilityClass;

var $bf919e292c78caff$var$_generateUtilityClasses = $bf919e292c78caff$require$_interopRequireDefault((parcelRequire("5nY49")));

var $bf919e292c78caff$var$_generateUtilityClass = $bf919e292c78caff$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $bf919e292c78caff$var$getContainerUtilityClass(slot) {
    return (0, $bf919e292c78caff$var$_generateUtilityClass.default)('MuiContainer', slot);
}
const $bf919e292c78caff$var$containerClasses = (0, $bf919e292c78caff$var$_generateUtilityClasses.default)('MuiContainer', [
    'root',
    'disableGutters',
    'fixed',
    'maxWidthXs',
    'maxWidthSm',
    'maxWidthMd',
    'maxWidthLg',
    'maxWidthXl'
]);
var $bf919e292c78caff$var$_default = module.exports.default = $bf919e292c78caff$var$containerClasses;

});


parcelRegister("bl1Nj", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $84130c31a3f49bb6$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $84130c31a3f49bb6$var$_CssBaseline.default;
    }
});

var $84130c31a3f49bb6$var$_CssBaseline = $84130c31a3f49bb6$require$_interopRequireDefault((parcelRequire("gODrq")));

});
parcelRegister("gODrq", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $c3dfe91526ac04a1$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $c3dfe91526ac04a1$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.styles = module.exports.html = module.exports.default = module.exports.body = void 0;

var $c3dfe91526ac04a1$var$React = $c3dfe91526ac04a1$require$_interopRequireWildcard((parcelRequire("acw62")));

var $c3dfe91526ac04a1$var$_propTypes = $c3dfe91526ac04a1$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $ayMG0 = parcelRequire("ayMG0");
// to determine if the global styles are static or dynamic
const $c3dfe91526ac04a1$var$isDynamicSupport = typeof (0, $aAbgT.globalCss)({}) === 'function';
const $c3dfe91526ac04a1$var$html = (theme, enableColorScheme)=>({
        WebkitFontSmoothing: 'antialiased',
        // Antialiasing.
        MozOsxFontSmoothing: 'grayscale',
        // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: 'border-box',
        // Fix font resize problem in iOS
        WebkitTextSizeAdjust: '100%',
        // When used under CssVarsProvider, colorScheme should not be applied dynamically because it will generate the stylesheet twice for server-rendered applications.
        ...enableColorScheme && !theme.vars && {
            colorScheme: theme.palette.mode
        }
    });
module.exports.html = $c3dfe91526ac04a1$var$html;
const $c3dfe91526ac04a1$var$body = (theme)=>({
        color: (theme.vars || theme).palette.text.primary,
        ...theme.typography.body1,
        backgroundColor: (theme.vars || theme).palette.background.default,
        '@media print': {
            // Save printer ink.
            backgroundColor: (theme.vars || theme).palette.common.white
        }
    });
module.exports.body = $c3dfe91526ac04a1$var$body;
const $c3dfe91526ac04a1$var$styles = (theme, enableColorScheme = false)=>{
    const colorSchemeStyles = {};
    if (enableColorScheme && theme.colorSchemes && typeof theme.getColorSchemeSelector === 'function') Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        const selector = theme.getColorSchemeSelector(key);
        if (selector.startsWith('@')) // for @media (prefers-color-scheme), we need to target :root
        colorSchemeStyles[selector] = {
            ':root': {
                colorScheme: scheme.palette?.mode
            }
        };
        else // else, it's likely that the selector already target an element with a class or data attribute
        colorSchemeStyles[selector.replace(/\s*&/, '')] = {
            colorScheme: scheme.palette?.mode
        };
    });
    let defaultStyles = {
        html: $c3dfe91526ac04a1$var$html(theme, enableColorScheme),
        '*, *::before, *::after': {
            boxSizing: 'inherit'
        },
        'strong, b': {
            fontWeight: theme.typography.fontWeightBold
        },
        body: {
            margin: 0,
            // Remove the margin in all browsers.
            ...$c3dfe91526ac04a1$var$body(theme),
            // Add support for document.body.requestFullScreen().
            // Other elements, if background transparent, are not supported.
            '&::backdrop': {
                backgroundColor: (theme.vars || theme).palette.background.default
            }
        },
        ...colorSchemeStyles
    };
    const themeOverrides = theme.components?.MuiCssBaseline?.styleOverrides;
    if (themeOverrides) defaultStyles = [
        defaultStyles,
        themeOverrides
    ];
    return defaultStyles;
};
// `ecs` stands for enableColorScheme. This is internal logic to make it work with Pigment CSS, so shorter is better.
module.exports.styles = $c3dfe91526ac04a1$var$styles;
const $c3dfe91526ac04a1$var$SELECTOR = 'mui-ecs';
const $c3dfe91526ac04a1$var$staticStyles = (theme)=>{
    const result = $c3dfe91526ac04a1$var$styles(theme, false);
    const baseStyles = Array.isArray(result) ? result[0] : result;
    if (!theme.vars && baseStyles) baseStyles.html[`:root:has(${$c3dfe91526ac04a1$var$SELECTOR})`] = {
        colorScheme: theme.palette.mode
    };
    if (theme.colorSchemes) Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        const selector = theme.getColorSchemeSelector(key);
        if (selector.startsWith('@')) // for @media (prefers-color-scheme), we need to target :root
        baseStyles[selector] = {
            [`:root:not(:has(.${$c3dfe91526ac04a1$var$SELECTOR}))`]: {
                colorScheme: scheme.palette?.mode
            }
        };
        else // else, it's likely that the selector already target an element with a class or data attribute
        baseStyles[selector.replace(/\s*&/, '')] = {
            [`&:not(:has(.${$c3dfe91526ac04a1$var$SELECTOR}))`]: {
                colorScheme: scheme.palette?.mode
            }
        };
    });
    return result;
};
const $c3dfe91526ac04a1$var$GlobalStyles = (0, $aAbgT.globalCss)($c3dfe91526ac04a1$var$isDynamicSupport ? ({ theme: theme, enableColorScheme: enableColorScheme })=>$c3dfe91526ac04a1$var$styles(theme, enableColorScheme) : ({ theme: theme })=>$c3dfe91526ac04a1$var$staticStyles(theme));
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */ function $c3dfe91526ac04a1$var$CssBaseline(inProps) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiCssBaseline'
    });
    const { children: children, enableColorScheme: enableColorScheme = false } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($c3dfe91526ac04a1$var$React.Fragment, {
        children: [
            $c3dfe91526ac04a1$var$isDynamicSupport && /*#__PURE__*/ (0, $ayMG0.jsx)($c3dfe91526ac04a1$var$GlobalStyles, {
                enableColorScheme: enableColorScheme
            }),
            !$c3dfe91526ac04a1$var$isDynamicSupport && !enableColorScheme && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: $c3dfe91526ac04a1$var$SELECTOR,
                style: {
                    display: 'none'
                }
            }),
            children
        ]
    });
}
$c3dfe91526ac04a1$var$CssBaseline.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * You can wrap a node.
   */ children: $c3dfe91526ac04a1$var$_propTypes.default.node,
    /**
   * Enable `color-scheme` CSS property to use `theme.palette.mode`.
   * For more details, check out https://developer.mozilla.org/en-US/docs/Web/CSS/Reference/Properties/color-scheme
   * For browser support, check out https://caniuse.com/?search=color-scheme
   * @default false
   */ enableColorScheme: $c3dfe91526ac04a1$var$_propTypes.default.bool
};
var $c3dfe91526ac04a1$var$_default = module.exports.default = $c3dfe91526ac04a1$var$CssBaseline;

});


parcelRegister("4tB5n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3426a3520e69a38c$var$darkScrollbar;
// track, thumb and active are derived from macOS 10.15.7
const $3426a3520e69a38c$var$scrollBar = {
    track: '#2b2b2b',
    thumb: '#6b6b6b',
    active: '#959595'
};
function $3426a3520e69a38c$var$darkScrollbar(options = $3426a3520e69a38c$var$scrollBar) {
    return {
        scrollbarColor: `${options.thumb} ${options.track}`,
        '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
            backgroundColor: options.track
        },
        '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
            borderRadius: 8,
            backgroundColor: options.thumb,
            minHeight: 24,
            border: `3px solid ${options.track}`
        },
        '&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus': {
            backgroundColor: options.active
        },
        '&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active': {
            backgroundColor: options.active
        },
        '&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover': {
            backgroundColor: options.active
        },
        '&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner': {
            backgroundColor: options.track
        }
    };
}

});

parcelRegister("iZIMH", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $dd40a9c943ba05e0$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $dd40a9c943ba05e0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $dd40a9c943ba05e0$var$_exportNames = {
    dialogClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $dd40a9c943ba05e0$var$_Dialog.default;
    }
});
Object.defineProperty(module.exports, "dialogClasses", {
    enumerable: true,
    get: function() {
        return $dd40a9c943ba05e0$var$_dialogClasses.default;
    }
});

var $dd40a9c943ba05e0$var$_Dialog = $dd40a9c943ba05e0$require$_interopRequireDefault((parcelRequire("6MV2p")));

var $dd40a9c943ba05e0$var$_dialogClasses = $dd40a9c943ba05e0$require$_interopRequireWildcard((parcelRequire("gX5bM")));
Object.keys($dd40a9c943ba05e0$var$_dialogClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($dd40a9c943ba05e0$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $dd40a9c943ba05e0$var$_dialogClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dd40a9c943ba05e0$var$_dialogClasses[key];
        }
    });
});

});
parcelRegister("6MV2p", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $4f13784bd714c44e$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $4f13784bd714c44e$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f13784bd714c44e$var$React = $4f13784bd714c44e$require$_interopRequireWildcard((parcelRequire("acw62")));

var $4f13784bd714c44e$var$_propTypes = $4f13784bd714c44e$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $4f13784bd714c44e$var$_clsx = $4f13784bd714c44e$require$_interopRequireDefault((parcelRequire("9QePP")));

var $4f13784bd714c44e$var$_composeClasses = $4f13784bd714c44e$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $4f13784bd714c44e$var$_useId = $4f13784bd714c44e$require$_interopRequireDefault((parcelRequire("hwliF")));

var $4f13784bd714c44e$var$_capitalize = $4f13784bd714c44e$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $4f13784bd714c44e$var$_Modal = $4f13784bd714c44e$require$_interopRequireDefault((parcelRequire("8vVVd")));

var $4f13784bd714c44e$var$_Fade = $4f13784bd714c44e$require$_interopRequireDefault((parcelRequire("5iZHj")));

var $4f13784bd714c44e$var$_Paper = $4f13784bd714c44e$require$_interopRequireDefault((parcelRequire("juRJQ")));

var $4f13784bd714c44e$var$_dialogClasses = $4f13784bd714c44e$require$_interopRequireWildcard((parcelRequire("gX5bM")));

var $4f13784bd714c44e$var$_DialogContext = $4f13784bd714c44e$require$_interopRequireDefault((parcelRequire("8W68d")));

var $4f13784bd714c44e$var$_Backdrop = $4f13784bd714c44e$require$_interopRequireDefault((parcelRequire("bXwVR")));

var $aAbgT = parcelRequire("aAbgT");

var $4f13784bd714c44e$var$_memoTheme = $4f13784bd714c44e$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $4f13784bd714c44e$var$_useSlot = $4f13784bd714c44e$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ggK3e = parcelRequire("ggK3e");

var $ayMG0 = parcelRequire("ayMG0");
const $4f13784bd714c44e$var$DialogBackdrop = (0, $aAbgT.styled)($4f13784bd714c44e$var$_Backdrop.default, {
    name: 'MuiDialog',
    slot: 'Backdrop'
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $4f13784bd714c44e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        backdrop: [
            'backdrop'
        ],
        container: [
            'container',
            `scroll${(0, $4f13784bd714c44e$var$_capitalize.default)(scroll)}`
        ],
        paper: [
            'paper',
            `paperScroll${(0, $4f13784bd714c44e$var$_capitalize.default)(scroll)}`,
            `paperWidth${(0, $4f13784bd714c44e$var$_capitalize.default)(String(maxWidth))}`,
            fullWidth && 'paperFullWidth',
            fullScreen && 'paperFullScreen'
        ]
    };
    return (0, $4f13784bd714c44e$var$_composeClasses.default)(slots, $4f13784bd714c44e$var$_dialogClasses.getDialogUtilityClass, classes);
};
const $4f13784bd714c44e$var$DialogRoot = (0, $aAbgT.styled)($4f13784bd714c44e$var$_Modal.default, {
    name: 'MuiDialog',
    slot: 'Root'
})({
    '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
    }
});
const $4f13784bd714c44e$var$DialogContainer = (0, $aAbgT.styled)('div', {
    name: 'MuiDialog',
    slot: 'Container',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $4f13784bd714c44e$var$_capitalize.default)(ownerState.scroll)}`]
        ];
    }
})({
    height: '100%',
    '@media print': {
        height: 'auto'
    },
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    variants: [
        {
            props: {
                scroll: 'paper'
            },
            style: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }
        },
        {
            props: {
                scroll: 'body'
            },
            style: {
                overflowY: 'auto',
                overflowX: 'hidden',
                textAlign: 'center',
                '&::after': {
                    content: '""',
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    height: '100%',
                    width: '0'
                }
            }
        }
    ]
});
const $4f13784bd714c44e$var$DialogPaper = (0, $aAbgT.styled)($4f13784bd714c44e$var$_Paper.default, {
    name: 'MuiDialog',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $4f13784bd714c44e$var$_capitalize.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $4f13784bd714c44e$var$_capitalize.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})((0, $4f13784bd714c44e$var$_memoTheme.default)(({ theme: theme })=>({
        margin: 32,
        position: 'relative',
        overflowY: 'auto',
        '@media print': {
            overflowY: 'visible',
            boxShadow: 'none'
        },
        variants: [
            {
                props: {
                    scroll: 'paper'
                },
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    maxHeight: 'calc(100% - 64px)'
                }
            },
            {
                props: {
                    scroll: 'body'
                },
                style: {
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    textAlign: 'initial'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.maxWidth,
                style: {
                    maxWidth: 'calc(100% - 64px)'
                }
            },
            {
                props: {
                    maxWidth: 'xs'
                },
                style: {
                    maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
                    [`&.${$4f13784bd714c44e$var$_dialogClasses.default.paperScrollBody}`]: {
                        [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                            maxWidth: 'calc(100% - 64px)'
                        }
                    }
                }
            },
            ...Object.keys(theme.breakpoints.values).filter((maxWidth)=>maxWidth !== 'xs').map((maxWidth)=>({
                    props: {
                        maxWidth: maxWidth
                    },
                    style: {
                        maxWidth: `${theme.breakpoints.values[maxWidth]}${theme.breakpoints.unit}`,
                        [`&.${$4f13784bd714c44e$var$_dialogClasses.default.paperScrollBody}`]: {
                            [theme.breakpoints.down(theme.breakpoints.values[maxWidth] + 64)]: {
                                maxWidth: 'calc(100% - 64px)'
                            }
                        }
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    width: 'calc(100% - 64px)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullScreen,
                style: {
                    margin: 0,
                    width: '100%',
                    maxWidth: '100%',
                    height: '100%',
                    maxHeight: 'none',
                    borderRadius: 0,
                    [`&.${$4f13784bd714c44e$var$_dialogClasses.default.paperScrollBody}`]: {
                        margin: 0,
                        maxWidth: '100%'
                    }
                }
            }
        ]
    })));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $4f13784bd714c44e$var$Dialog = /*#__PURE__*/ $4f13784bd714c44e$var$React.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiDialog'
    });
    const theme = (0, $aAbgT.useTheme)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { 'aria-describedby': ariaDescribedby, 'aria-labelledby': ariaLabelledbyProp, 'aria-modal': ariaModal = true, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = 'sm', onClick: onClick, onClose: onClose, open: open, PaperComponent: PaperComponent = $4f13784bd714c44e$var$_Paper.default, PaperProps: PaperProps = {}, role: role = 'dialog', scroll: scroll = 'paper', slots: slots = {}, slotProps: slotProps = {}, TransitionComponent: TransitionComponent = $4f13784bd714c44e$var$_Fade.default, transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps, ...other } = props;
    const ownerState = {
        ...props,
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    };
    const classes = $4f13784bd714c44e$var$useUtilityClasses(ownerState);
    const backdropClick = $4f13784bd714c44e$var$React.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        if (onClick) onClick(event);
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onClose) onClose(event, 'backdropClick');
    };
    const ariaLabelledby = (0, $4f13784bd714c44e$var$_useId.default)(ariaLabelledbyProp);
    const dialogContextValue = $4f13784bd714c44e$var$React.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    const backwardCompatibleSlots = {
        transition: TransitionComponent,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        transition: TransitionProps,
        paper: PaperProps,
        backdrop: BackdropProps,
        ...slotProps
    };
    const externalForwardedProps = {
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootSlotProps] = (0, $4f13784bd714c44e$var$_useSlot.default)('root', {
        elementType: $4f13784bd714c44e$var$DialogRoot,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $4f13784bd714c44e$var$_clsx.default)(classes.root, className),
        ref: ref
    });
    const [BackdropSlot, backdropSlotProps] = (0, $4f13784bd714c44e$var$_useSlot.default)('backdrop', {
        elementType: $4f13784bd714c44e$var$DialogBackdrop,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.backdrop
    });
    const [PaperSlot, paperSlotProps] = (0, $4f13784bd714c44e$var$_useSlot.default)('paper', {
        elementType: $4f13784bd714c44e$var$DialogPaper,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.paper,
        additionalProps: {
            elevation: 24,
            role: role,
            'aria-describedby': ariaDescribedby,
            'aria-labelledby': ariaLabelledby,
            'aria-modal': ariaModal,
            tabIndex: -1,
            [$ggK3e.FOCUSABLE_ATTRIBUTE]: ''
        }
    });
    const [ContainerSlot, containerSlotProps] = (0, $4f13784bd714c44e$var$_useSlot.default)('container', {
        elementType: $4f13784bd714c44e$var$DialogContainer,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.container
    });
    const [TransitionSlot, transitionSlotProps] = (0, $4f13784bd714c44e$var$_useSlot.default)('transition', {
        elementType: $4f13784bd714c44e$var$_Fade.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: 'presentation'
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, {
        closeAfterTransition: true,
        slots: {
            backdrop: BackdropSlot
        },
        slotProps: {
            backdrop: {
                transitionDuration: transitionDuration,
                as: BackdropComponent,
                ...backdropSlotProps
            }
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        onClick: handleBackdropClick,
        ...rootSlotProps,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionSlot, {
            ...transitionSlotProps,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)(ContainerSlot, {
                onMouseDown: handleMouseDown,
                ...containerSlotProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(PaperSlot, {
                    as: PaperComponent,
                    ...paperSlotProps,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($4f13784bd714c44e$var$_DialogContext.default.Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                })
            })
        })
    });
});
$4f13784bd714c44e$var$Dialog.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The id(s) of the element(s) that describe the dialog.
   */ 'aria-describedby': $4f13784bd714c44e$var$_propTypes.default.string,
    /**
   * The id(s) of the element(s) that label the dialog.
   */ 'aria-labelledby': $4f13784bd714c44e$var$_propTypes.default.string,
    /**
   * Informs assistive technologies that the element is modal.
   * It's added on the element with role="dialog".
   * @default true
   */ 'aria-modal': $4f13784bd714c44e$var$_propTypes.default.oneOfType([
        $4f13784bd714c44e$var$_propTypes.default.oneOf([
            'false',
            'true'
        ]),
        $4f13784bd714c44e$var$_propTypes.default.bool
    ]),
    /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   * })({
   *   zIndex: -1,
   * })
   */ BackdropComponent: $4f13784bd714c44e$var$_propTypes.default.elementType,
    /**
   * @ignore
   */ BackdropProps: $4f13784bd714c44e$var$_propTypes.default.object,
    /**
   * Dialog children, usually the included sub-components.
   */ children: $4f13784bd714c44e$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $4f13784bd714c44e$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $4f13784bd714c44e$var$_propTypes.default.string,
    /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */ disableEscapeKeyDown: $4f13784bd714c44e$var$_propTypes.default.bool,
    /**
   * If `true`, the dialog is full-screen.
   * @default false
   */ fullScreen: $4f13784bd714c44e$var$_propTypes.default.bool,
    /**
   * If `true`, the dialog stretches to `maxWidth`.
   *
   * Notice that the dialog width grow is limited by the default margin.
   * @default false
   */ fullWidth: $4f13784bd714c44e$var$_propTypes.default.bool,
    /**
   * Determine the max-width of the dialog.
   * The dialog width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   * @default 'sm'
   */ maxWidth: $4f13784bd714c44e$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $4f13784bd714c44e$var$_propTypes.default.oneOf([
            'xs',
            'sm',
            'md',
            'lg',
            'xl',
            false
        ]),
        $4f13784bd714c44e$var$_propTypes.default.string
    ]),
    /**
   * @ignore
   */ onClick: $4f13784bd714c44e$var$_propTypes.default.func,
    /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */ onClose: $4f13784bd714c44e$var$_propTypes.default.func,
    /**
   * If `true`, the component is shown.
   */ open: $4f13784bd714c44e$var$_propTypes.default.bool.isRequired,
    /**
   * The component used to render the body of the dialog.
   * @default Paper
   */ PaperComponent: $4f13784bd714c44e$var$_propTypes.default.elementType,
    /**
   * Props applied to the [`Paper`](https://mui.com/material-ui/api/paper/) element.
   * @default {}
   * @deprecated Use `slotProps.paper` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ PaperProps: $4f13784bd714c44e$var$_propTypes.default.object,
    /**
   * The ARIA role for the dialog element.
   * The main dialog role is `dialog`, but `alertdialog` can be used if the content of the dialog requires immediate attention.
   * See https://www.w3.org/TR/wai-aria-1.2/#dialog and https://www.w3.org/TR/wai-aria-1.2/#alertdialog for more details.
   * @default 'dialog'
   */ role: $4f13784bd714c44e$var$_propTypes.default.oneOf([
        'alertdialog',
        'dialog'
    ]),
    /**
   * Determine the container for scrolling the dialog.
   * @default 'paper'
   */ scroll: $4f13784bd714c44e$var$_propTypes.default.oneOf([
        'body',
        'paper'
    ]),
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $4f13784bd714c44e$var$_propTypes.default.shape({
        backdrop: $4f13784bd714c44e$var$_propTypes.default.oneOfType([
            $4f13784bd714c44e$var$_propTypes.default.func,
            $4f13784bd714c44e$var$_propTypes.default.object
        ]),
        container: $4f13784bd714c44e$var$_propTypes.default.oneOfType([
            $4f13784bd714c44e$var$_propTypes.default.func,
            $4f13784bd714c44e$var$_propTypes.default.object
        ]),
        paper: $4f13784bd714c44e$var$_propTypes.default.oneOfType([
            $4f13784bd714c44e$var$_propTypes.default.func,
            $4f13784bd714c44e$var$_propTypes.default.object
        ]),
        root: $4f13784bd714c44e$var$_propTypes.default.oneOfType([
            $4f13784bd714c44e$var$_propTypes.default.func,
            $4f13784bd714c44e$var$_propTypes.default.object
        ]),
        transition: $4f13784bd714c44e$var$_propTypes.default.oneOfType([
            $4f13784bd714c44e$var$_propTypes.default.func,
            $4f13784bd714c44e$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: $4f13784bd714c44e$var$_propTypes.default.shape({
        backdrop: $4f13784bd714c44e$var$_propTypes.default.elementType,
        container: $4f13784bd714c44e$var$_propTypes.default.elementType,
        paper: $4f13784bd714c44e$var$_propTypes.default.elementType,
        root: $4f13784bd714c44e$var$_propTypes.default.elementType,
        transition: $4f13784bd714c44e$var$_propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $4f13784bd714c44e$var$_propTypes.default.oneOfType([
        $4f13784bd714c44e$var$_propTypes.default.arrayOf($4f13784bd714c44e$var$_propTypes.default.oneOfType([
            $4f13784bd714c44e$var$_propTypes.default.func,
            $4f13784bd714c44e$var$_propTypes.default.object,
            $4f13784bd714c44e$var$_propTypes.default.bool
        ])),
        $4f13784bd714c44e$var$_propTypes.default.func,
        $4f13784bd714c44e$var$_propTypes.default.object
    ]),
    /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   * @deprecated Use `slots.transition` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ TransitionComponent: $4f13784bd714c44e$var$_propTypes.default.elementType,
    /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */ transitionDuration: $4f13784bd714c44e$var$_propTypes.default.oneOfType([
        $4f13784bd714c44e$var$_propTypes.default.number,
        $4f13784bd714c44e$var$_propTypes.default.shape({
            appear: $4f13784bd714c44e$var$_propTypes.default.number,
            enter: $4f13784bd714c44e$var$_propTypes.default.number,
            exit: $4f13784bd714c44e$var$_propTypes.default.number
        })
    ]),
    /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated Use `slotProps.transition` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ TransitionProps: $4f13784bd714c44e$var$_propTypes.default.object
};
var $4f13784bd714c44e$var$_default = module.exports.default = $4f13784bd714c44e$var$Dialog;

});
parcelRegister("gX5bM", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c5762e789acf7dcc$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getDialogUtilityClass = $c5762e789acf7dcc$var$getDialogUtilityClass;

var $c5762e789acf7dcc$var$_generateUtilityClasses = $c5762e789acf7dcc$require$_interopRequireDefault((parcelRequire("5nY49")));

var $c5762e789acf7dcc$var$_generateUtilityClass = $c5762e789acf7dcc$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $c5762e789acf7dcc$var$getDialogUtilityClass(slot) {
    return (0, $c5762e789acf7dcc$var$_generateUtilityClass.default)('MuiDialog', slot);
}
const $c5762e789acf7dcc$var$dialogClasses = (0, $c5762e789acf7dcc$var$_generateUtilityClasses.default)('MuiDialog', [
    'root',
    'backdrop',
    'scrollPaper',
    'scrollBody',
    'container',
    'paper',
    'paperScrollPaper',
    'paperScrollBody',
    'paperWidthFalse',
    'paperWidthXs',
    'paperWidthSm',
    'paperWidthMd',
    'paperWidthLg',
    'paperWidthXl',
    'paperFullWidth',
    'paperFullScreen'
]);
var $c5762e789acf7dcc$var$_default = module.exports.default = $c5762e789acf7dcc$var$dialogClasses;

});

parcelRegister("8W68d", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $68187f174395cd28$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $68187f174395cd28$var$React = $68187f174395cd28$require$_interopRequireWildcard((parcelRequire("acw62")));
const $68187f174395cd28$var$DialogContext = /*#__PURE__*/ $68187f174395cd28$var$React.createContext({});
$68187f174395cd28$var$DialogContext.displayName = 'DialogContext';
var $68187f174395cd28$var$_default = module.exports.default = $68187f174395cd28$var$DialogContext;

});



parcelRegister("l5BZB", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $f5a78922775ef422$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $f5a78922775ef422$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $f5a78922775ef422$var$_exportNames = {
    dialogActionsClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $f5a78922775ef422$var$_DialogActions.default;
    }
});
Object.defineProperty(module.exports, "dialogActionsClasses", {
    enumerable: true,
    get: function() {
        return $f5a78922775ef422$var$_dialogActionsClasses.default;
    }
});

var $f5a78922775ef422$var$_DialogActions = $f5a78922775ef422$require$_interopRequireDefault((parcelRequire("2MUlQ")));

var $f5a78922775ef422$var$_dialogActionsClasses = $f5a78922775ef422$require$_interopRequireWildcard((parcelRequire("4ZLz5")));
Object.keys($f5a78922775ef422$var$_dialogActionsClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($f5a78922775ef422$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $f5a78922775ef422$var$_dialogActionsClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $f5a78922775ef422$var$_dialogActionsClasses[key];
        }
    });
});

});
parcelRegister("2MUlQ", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $207bc6ab7c60f4b2$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $207bc6ab7c60f4b2$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $207bc6ab7c60f4b2$var$React = $207bc6ab7c60f4b2$require$_interopRequireWildcard((parcelRequire("acw62")));

var $207bc6ab7c60f4b2$var$_propTypes = $207bc6ab7c60f4b2$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $207bc6ab7c60f4b2$var$_clsx = $207bc6ab7c60f4b2$require$_interopRequireDefault((parcelRequire("9QePP")));

var $207bc6ab7c60f4b2$var$_composeClasses = $207bc6ab7c60f4b2$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $4ZLz5 = parcelRequire("4ZLz5");

var $ayMG0 = parcelRequire("ayMG0");
const $207bc6ab7c60f4b2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, $207bc6ab7c60f4b2$var$_composeClasses.default)(slots, $4ZLz5.getDialogActionsUtilityClass, classes);
};
const $207bc6ab7c60f4b2$var$DialogActionsRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiDialogActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})({
    display: 'flex',
    alignItems: 'center',
    padding: 8,
    justifyContent: 'flex-end',
    flex: '0 0 auto',
    variants: [
        {
            props: ({ ownerState: ownerState })=>!ownerState.disableSpacing,
            style: {
                '& > :not(style) ~ :not(style)': {
                    marginLeft: 8
                }
            }
        }
    ]
});
const $207bc6ab7c60f4b2$var$DialogActions = /*#__PURE__*/ $207bc6ab7c60f4b2$var$React.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogActions'
    });
    const { className: className, disableSpacing: disableSpacing = false, ...other } = props;
    const ownerState = {
        ...props,
        disableSpacing: disableSpacing
    };
    const classes = $207bc6ab7c60f4b2$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($207bc6ab7c60f4b2$var$DialogActionsRoot, {
        className: (0, $207bc6ab7c60f4b2$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
$207bc6ab7c60f4b2$var$DialogActions.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: $207bc6ab7c60f4b2$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $207bc6ab7c60f4b2$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $207bc6ab7c60f4b2$var$_propTypes.default.string,
    /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */ disableSpacing: $207bc6ab7c60f4b2$var$_propTypes.default.bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $207bc6ab7c60f4b2$var$_propTypes.default.oneOfType([
        $207bc6ab7c60f4b2$var$_propTypes.default.arrayOf($207bc6ab7c60f4b2$var$_propTypes.default.oneOfType([
            $207bc6ab7c60f4b2$var$_propTypes.default.func,
            $207bc6ab7c60f4b2$var$_propTypes.default.object,
            $207bc6ab7c60f4b2$var$_propTypes.default.bool
        ])),
        $207bc6ab7c60f4b2$var$_propTypes.default.func,
        $207bc6ab7c60f4b2$var$_propTypes.default.object
    ])
};
var $207bc6ab7c60f4b2$var$_default = module.exports.default = $207bc6ab7c60f4b2$var$DialogActions;

});
parcelRegister("4ZLz5", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3a31c1516a2c01e5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getDialogActionsUtilityClass = $3a31c1516a2c01e5$var$getDialogActionsUtilityClass;

var $3a31c1516a2c01e5$var$_generateUtilityClasses = $3a31c1516a2c01e5$require$_interopRequireDefault((parcelRequire("5nY49")));

var $3a31c1516a2c01e5$var$_generateUtilityClass = $3a31c1516a2c01e5$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $3a31c1516a2c01e5$var$getDialogActionsUtilityClass(slot) {
    return (0, $3a31c1516a2c01e5$var$_generateUtilityClass.default)('MuiDialogActions', slot);
}
const $3a31c1516a2c01e5$var$dialogActionsClasses = (0, $3a31c1516a2c01e5$var$_generateUtilityClasses.default)('MuiDialogActions', [
    'root',
    'spacing'
]);
var $3a31c1516a2c01e5$var$_default = module.exports.default = $3a31c1516a2c01e5$var$dialogActionsClasses;

});



parcelRegister("hJoSv", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $ce89efe9ad487ed1$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $ce89efe9ad487ed1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $ce89efe9ad487ed1$var$_exportNames = {
    dialogContentClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ce89efe9ad487ed1$var$_DialogContent.default;
    }
});
Object.defineProperty(module.exports, "dialogContentClasses", {
    enumerable: true,
    get: function() {
        return $ce89efe9ad487ed1$var$_dialogContentClasses.default;
    }
});

var $ce89efe9ad487ed1$var$_DialogContent = $ce89efe9ad487ed1$require$_interopRequireDefault((parcelRequire("6Q1H5")));

var $ce89efe9ad487ed1$var$_dialogContentClasses = $ce89efe9ad487ed1$require$_interopRequireWildcard((parcelRequire("hd5xz")));
Object.keys($ce89efe9ad487ed1$var$_dialogContentClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($ce89efe9ad487ed1$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $ce89efe9ad487ed1$var$_dialogContentClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ce89efe9ad487ed1$var$_dialogContentClasses[key];
        }
    });
});

});
parcelRegister("6Q1H5", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $4fa8e9c420cdee0a$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $4fa8e9c420cdee0a$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4fa8e9c420cdee0a$var$React = $4fa8e9c420cdee0a$require$_interopRequireWildcard((parcelRequire("acw62")));

var $4fa8e9c420cdee0a$var$_propTypes = $4fa8e9c420cdee0a$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $4fa8e9c420cdee0a$var$_clsx = $4fa8e9c420cdee0a$require$_interopRequireDefault((parcelRequire("9QePP")));

var $4fa8e9c420cdee0a$var$_composeClasses = $4fa8e9c420cdee0a$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $4fa8e9c420cdee0a$var$_memoTheme = $4fa8e9c420cdee0a$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $hd5xz = parcelRequire("hd5xz");

var $4fa8e9c420cdee0a$var$_dialogTitleClasses = $4fa8e9c420cdee0a$require$_interopRequireDefault((parcelRequire("kQXVi")));

var $ayMG0 = parcelRequire("ayMG0");
const $4fa8e9c420cdee0a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            'root',
            dividers && 'dividers'
        ]
    };
    return (0, $4fa8e9c420cdee0a$var$_composeClasses.default)(slots, $hd5xz.getDialogContentUtilityClass, classes);
};
const $4fa8e9c420cdee0a$var$DialogContentRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiDialogContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})((0, $4fa8e9c420cdee0a$var$_memoTheme.default)(({ theme: theme })=>({
        flex: '1 1 auto',
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        overflowY: 'auto',
        padding: '20px 24px',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.dividers,
                style: {
                    padding: '16px 24px',
                    borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.dividers,
                style: {
                    [`.${$4fa8e9c420cdee0a$var$_dialogTitleClasses.default.root} + &`]: {
                        paddingTop: 0
                    }
                }
            }
        ]
    })));
const $4fa8e9c420cdee0a$var$DialogContent = /*#__PURE__*/ $4fa8e9c420cdee0a$var$React.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogContent'
    });
    const { className: className, dividers: dividers = false, ...other } = props;
    const ownerState = {
        ...props,
        dividers: dividers
    };
    const classes = $4fa8e9c420cdee0a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($4fa8e9c420cdee0a$var$DialogContentRoot, {
        className: (0, $4fa8e9c420cdee0a$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
$4fa8e9c420cdee0a$var$DialogContent.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: $4fa8e9c420cdee0a$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $4fa8e9c420cdee0a$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $4fa8e9c420cdee0a$var$_propTypes.default.string,
    /**
   * Display the top and bottom dividers.
   * @default false
   */ dividers: $4fa8e9c420cdee0a$var$_propTypes.default.bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $4fa8e9c420cdee0a$var$_propTypes.default.oneOfType([
        $4fa8e9c420cdee0a$var$_propTypes.default.arrayOf($4fa8e9c420cdee0a$var$_propTypes.default.oneOfType([
            $4fa8e9c420cdee0a$var$_propTypes.default.func,
            $4fa8e9c420cdee0a$var$_propTypes.default.object,
            $4fa8e9c420cdee0a$var$_propTypes.default.bool
        ])),
        $4fa8e9c420cdee0a$var$_propTypes.default.func,
        $4fa8e9c420cdee0a$var$_propTypes.default.object
    ])
};
var $4fa8e9c420cdee0a$var$_default = module.exports.default = $4fa8e9c420cdee0a$var$DialogContent;

});
parcelRegister("hd5xz", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c877f2cebcabf5cb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getDialogContentUtilityClass = $c877f2cebcabf5cb$var$getDialogContentUtilityClass;

var $c877f2cebcabf5cb$var$_generateUtilityClasses = $c877f2cebcabf5cb$require$_interopRequireDefault((parcelRequire("5nY49")));

var $c877f2cebcabf5cb$var$_generateUtilityClass = $c877f2cebcabf5cb$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $c877f2cebcabf5cb$var$getDialogContentUtilityClass(slot) {
    return (0, $c877f2cebcabf5cb$var$_generateUtilityClass.default)('MuiDialogContent', slot);
}
const $c877f2cebcabf5cb$var$dialogContentClasses = (0, $c877f2cebcabf5cb$var$_generateUtilityClasses.default)('MuiDialogContent', [
    'root',
    'dividers'
]);
var $c877f2cebcabf5cb$var$_default = module.exports.default = $c877f2cebcabf5cb$var$dialogContentClasses;

});

parcelRegister("kQXVi", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f2e7257b2514744a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getDialogTitleUtilityClass = $f2e7257b2514744a$var$getDialogTitleUtilityClass;

var $f2e7257b2514744a$var$_generateUtilityClasses = $f2e7257b2514744a$require$_interopRequireDefault((parcelRequire("5nY49")));

var $f2e7257b2514744a$var$_generateUtilityClass = $f2e7257b2514744a$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $f2e7257b2514744a$var$getDialogTitleUtilityClass(slot) {
    return (0, $f2e7257b2514744a$var$_generateUtilityClass.default)('MuiDialogTitle', slot);
}
const $f2e7257b2514744a$var$dialogTitleClasses = (0, $f2e7257b2514744a$var$_generateUtilityClasses.default)('MuiDialogTitle', [
    'root'
]);
var $f2e7257b2514744a$var$_default = module.exports.default = $f2e7257b2514744a$var$dialogTitleClasses;

});



parcelRegister("aX9Qs", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $7f970d1ffd61b921$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $7f970d1ffd61b921$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $7f970d1ffd61b921$var$_exportNames = {
    dialogContentTextClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $7f970d1ffd61b921$var$_DialogContentText.default;
    }
});
Object.defineProperty(module.exports, "dialogContentTextClasses", {
    enumerable: true,
    get: function() {
        return $7f970d1ffd61b921$var$_dialogContentTextClasses.default;
    }
});

var $7f970d1ffd61b921$var$_DialogContentText = $7f970d1ffd61b921$require$_interopRequireDefault((parcelRequire("eFqab")));

var $7f970d1ffd61b921$var$_dialogContentTextClasses = $7f970d1ffd61b921$require$_interopRequireWildcard((parcelRequire("8ANtp")));
Object.keys($7f970d1ffd61b921$var$_dialogContentTextClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($7f970d1ffd61b921$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $7f970d1ffd61b921$var$_dialogContentTextClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7f970d1ffd61b921$var$_dialogContentTextClasses[key];
        }
    });
});

});
parcelRegister("eFqab", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $aad93085434ac13f$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $aad93085434ac13f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aad93085434ac13f$var$React = $aad93085434ac13f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $aad93085434ac13f$var$_propTypes = $aad93085434ac13f$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $aad93085434ac13f$var$_clsx = $aad93085434ac13f$require$_interopRequireDefault((parcelRequire("9QePP")));

var $aad93085434ac13f$var$_composeClasses = $aad93085434ac13f$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aad93085434ac13f$var$_rootShouldForwardProp = $aad93085434ac13f$require$_interopRequireDefault((parcelRequire("8Uq77")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $aad93085434ac13f$var$_Typography = $aad93085434ac13f$require$_interopRequireDefault((parcelRequire("2dUd7")));

var $8ANtp = parcelRequire("8ANtp");

var $ayMG0 = parcelRequire("ayMG0");
const $aad93085434ac13f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    const composedClasses = (0, $aad93085434ac13f$var$_composeClasses.default)(slots, $8ANtp.getDialogContentTextUtilityClass, classes);
    return {
        ...classes,
        // forward classes to the Typography
        ...composedClasses
    };
};
const $aad93085434ac13f$var$DialogContentTextRoot = (0, $aAbgT.styled)($aad93085434ac13f$var$_Typography.default, {
    shouldForwardProp: (prop)=>(0, $aad93085434ac13f$var$_rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiDialogContentText',
    slot: 'Root'
})({});
const $aad93085434ac13f$var$DialogContentText = /*#__PURE__*/ $aad93085434ac13f$var$React.forwardRef(function DialogContentText(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogContentText'
    });
    const { children: children, className: className, ...ownerState } = props;
    const classes = $aad93085434ac13f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($aad93085434ac13f$var$DialogContentTextRoot, {
        component: "p",
        variant: "body1",
        color: "textSecondary",
        ref: ref,
        ownerState: ownerState,
        className: (0, $aad93085434ac13f$var$_clsx.default)(classes.root, className),
        ...props,
        classes: classes
    });
});
$aad93085434ac13f$var$DialogContentText.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: $aad93085434ac13f$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $aad93085434ac13f$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $aad93085434ac13f$var$_propTypes.default.string,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $aad93085434ac13f$var$_propTypes.default.oneOfType([
        $aad93085434ac13f$var$_propTypes.default.arrayOf($aad93085434ac13f$var$_propTypes.default.oneOfType([
            $aad93085434ac13f$var$_propTypes.default.func,
            $aad93085434ac13f$var$_propTypes.default.object,
            $aad93085434ac13f$var$_propTypes.default.bool
        ])),
        $aad93085434ac13f$var$_propTypes.default.func,
        $aad93085434ac13f$var$_propTypes.default.object
    ])
};
var $aad93085434ac13f$var$_default = module.exports.default = $aad93085434ac13f$var$DialogContentText;

});
parcelRegister("8ANtp", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $64180fe1152829a7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getDialogContentTextUtilityClass = $64180fe1152829a7$var$getDialogContentTextUtilityClass;

var $64180fe1152829a7$var$_generateUtilityClasses = $64180fe1152829a7$require$_interopRequireDefault((parcelRequire("5nY49")));

var $64180fe1152829a7$var$_generateUtilityClass = $64180fe1152829a7$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $64180fe1152829a7$var$getDialogContentTextUtilityClass(slot) {
    return (0, $64180fe1152829a7$var$_generateUtilityClass.default)('MuiDialogContentText', slot);
}
const $64180fe1152829a7$var$dialogContentTextClasses = (0, $64180fe1152829a7$var$_generateUtilityClasses.default)('MuiDialogContentText', [
    'root'
]);
var $64180fe1152829a7$var$_default = module.exports.default = $64180fe1152829a7$var$dialogContentTextClasses;

});



parcelRegister("lIycJ", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $fcf83d520808df6e$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $fcf83d520808df6e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $fcf83d520808df6e$var$_exportNames = {
    dialogTitleClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $fcf83d520808df6e$var$_DialogTitle.default;
    }
});
Object.defineProperty(module.exports, "dialogTitleClasses", {
    enumerable: true,
    get: function() {
        return $fcf83d520808df6e$var$_dialogTitleClasses.default;
    }
});

var $fcf83d520808df6e$var$_DialogTitle = $fcf83d520808df6e$require$_interopRequireDefault((parcelRequire("ejcfT")));

var $fcf83d520808df6e$var$_dialogTitleClasses = $fcf83d520808df6e$require$_interopRequireWildcard((parcelRequire("kQXVi")));
Object.keys($fcf83d520808df6e$var$_dialogTitleClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($fcf83d520808df6e$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $fcf83d520808df6e$var$_dialogTitleClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fcf83d520808df6e$var$_dialogTitleClasses[key];
        }
    });
});

});
parcelRegister("ejcfT", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $a6ac58aca374c76c$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $a6ac58aca374c76c$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a6ac58aca374c76c$var$React = $a6ac58aca374c76c$require$_interopRequireWildcard((parcelRequire("acw62")));

var $a6ac58aca374c76c$var$_propTypes = $a6ac58aca374c76c$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $a6ac58aca374c76c$var$_clsx = $a6ac58aca374c76c$require$_interopRequireDefault((parcelRequire("9QePP")));

var $a6ac58aca374c76c$var$_composeClasses = $a6ac58aca374c76c$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $a6ac58aca374c76c$var$_Typography = $a6ac58aca374c76c$require$_interopRequireDefault((parcelRequire("2dUd7")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $kQXVi = parcelRequire("kQXVi");

var $a6ac58aca374c76c$var$_DialogContext = $a6ac58aca374c76c$require$_interopRequireDefault((parcelRequire("8W68d")));

var $ayMG0 = parcelRequire("ayMG0");
const $a6ac58aca374c76c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $a6ac58aca374c76c$var$_composeClasses.default)(slots, $kQXVi.getDialogTitleUtilityClass, classes);
};
const $a6ac58aca374c76c$var$DialogTitleRoot = (0, $aAbgT.styled)($a6ac58aca374c76c$var$_Typography.default, {
    name: 'MuiDialogTitle',
    slot: 'Root'
})({
    padding: '16px 24px',
    flex: '0 0 auto'
});
const $a6ac58aca374c76c$var$DialogTitle = /*#__PURE__*/ $a6ac58aca374c76c$var$React.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogTitle'
    });
    const { className: className, id: idProp, ...other } = props;
    const ownerState = props;
    const classes = $a6ac58aca374c76c$var$useUtilityClasses(ownerState);
    const { titleId: titleId = idProp } = $a6ac58aca374c76c$var$React.useContext($a6ac58aca374c76c$var$_DialogContext.default);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a6ac58aca374c76c$var$DialogTitleRoot, {
        component: "h2",
        className: (0, $a6ac58aca374c76c$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp ?? titleId,
        ...other
    });
});
$a6ac58aca374c76c$var$DialogTitle.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: $a6ac58aca374c76c$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $a6ac58aca374c76c$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $a6ac58aca374c76c$var$_propTypes.default.string,
    /**
   * @ignore
   */ id: $a6ac58aca374c76c$var$_propTypes.default.string,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $a6ac58aca374c76c$var$_propTypes.default.oneOfType([
        $a6ac58aca374c76c$var$_propTypes.default.arrayOf($a6ac58aca374c76c$var$_propTypes.default.oneOfType([
            $a6ac58aca374c76c$var$_propTypes.default.func,
            $a6ac58aca374c76c$var$_propTypes.default.object,
            $a6ac58aca374c76c$var$_propTypes.default.bool
        ])),
        $a6ac58aca374c76c$var$_propTypes.default.func,
        $a6ac58aca374c76c$var$_propTypes.default.object
    ])
};
var $a6ac58aca374c76c$var$_default = module.exports.default = $a6ac58aca374c76c$var$DialogTitle;

});


parcelRegister("cPtMf", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $957158966c1dd989$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $957158966c1dd989$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $957158966c1dd989$var$_exportNames = {
    drawerClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $957158966c1dd989$var$_Drawer.default;
    }
});
Object.defineProperty(module.exports, "drawerClasses", {
    enumerable: true,
    get: function() {
        return $957158966c1dd989$var$_drawerClasses.default;
    }
});

var $957158966c1dd989$var$_Drawer = $957158966c1dd989$require$_interopRequireDefault((parcelRequire("2Ed4H")));

var $957158966c1dd989$var$_drawerClasses = $957158966c1dd989$require$_interopRequireWildcard((parcelRequire("4G59M")));
Object.keys($957158966c1dd989$var$_drawerClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($957158966c1dd989$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $957158966c1dd989$var$_drawerClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $957158966c1dd989$var$_drawerClasses[key];
        }
    });
});

});
parcelRegister("2Ed4H", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $1ed9758f3bc045cc$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $1ed9758f3bc045cc$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getAnchor = $1ed9758f3bc045cc$var$getAnchor;
module.exports.isHorizontal = $1ed9758f3bc045cc$var$isHorizontal;

var $1ed9758f3bc045cc$var$React = $1ed9758f3bc045cc$require$_interopRequireWildcard((parcelRequire("acw62")));

var $1ed9758f3bc045cc$var$_propTypes = $1ed9758f3bc045cc$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $1ed9758f3bc045cc$var$_clsx = $1ed9758f3bc045cc$require$_interopRequireDefault((parcelRequire("9QePP")));

var $1ed9758f3bc045cc$var$_integerPropType = $1ed9758f3bc045cc$require$_interopRequireDefault((parcelRequire("cxaSP")));

var $1ed9758f3bc045cc$var$_composeClasses = $1ed9758f3bc045cc$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $9uEev = parcelRequire("9uEev");

var $1ed9758f3bc045cc$var$_Modal = $1ed9758f3bc045cc$require$_interopRequireDefault((parcelRequire("8vVVd")));

var $1ed9758f3bc045cc$var$_Slide = $1ed9758f3bc045cc$require$_interopRequireDefault((parcelRequire("bQRpD")));

var $1ed9758f3bc045cc$var$_Paper = $1ed9758f3bc045cc$require$_interopRequireDefault((parcelRequire("juRJQ")));

var $1ed9758f3bc045cc$var$_capitalize = $1ed9758f3bc045cc$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $1ed9758f3bc045cc$var$_rootShouldForwardProp = $1ed9758f3bc045cc$require$_interopRequireDefault((parcelRequire("8Uq77")));

var $aAbgT = parcelRequire("aAbgT");

var $1ed9758f3bc045cc$var$_memoTheme = $1ed9758f3bc045cc$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $1ed9758f3bc045cc$var$_useForkRef = $1ed9758f3bc045cc$require$_interopRequireDefault((parcelRequire("9Rgf1")));

var $4G59M = parcelRequire("4G59M");

var $1ed9758f3bc045cc$var$_useSlot = $1ed9758f3bc045cc$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ggK3e = parcelRequire("ggK3e");

var $hGPki = parcelRequire("hGPki");

var $ayMG0 = parcelRequire("ayMG0");
const $1ed9758f3bc045cc$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        (ownerState.variant === 'permanent' || ownerState.variant === 'persistent') && styles.docked,
        ownerState.variant === 'temporary' && styles.modal
    ];
};
const $1ed9758f3bc045cc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchor: anchor, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            `anchor${(0, $1ed9758f3bc045cc$var$_capitalize.default)(anchor)}`
        ],
        docked: [
            (variant === 'permanent' || variant === 'persistent') && 'docked'
        ],
        modal: [
            'modal'
        ],
        paper: [
            'paper',
            `paperAnchor${(0, $1ed9758f3bc045cc$var$_capitalize.default)(anchor)}`,
            variant !== 'temporary' && `paperAnchorDocked${(0, $1ed9758f3bc045cc$var$_capitalize.default)(anchor)}`
        ]
    };
    return (0, $1ed9758f3bc045cc$var$_composeClasses.default)(slots, $4G59M.getDrawerUtilityClass, classes);
};
const $1ed9758f3bc045cc$var$DrawerRoot = (0, $aAbgT.styled)($1ed9758f3bc045cc$var$_Modal.default, {
    name: 'MuiDrawer',
    slot: 'Root',
    overridesResolver: $1ed9758f3bc045cc$var$overridesResolver
})((0, $1ed9758f3bc045cc$var$_memoTheme.default)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.drawer
    })));
const $1ed9758f3bc045cc$var$DrawerDockedRoot = (0, $aAbgT.styled)('div', {
    shouldForwardProp: $1ed9758f3bc045cc$var$_rootShouldForwardProp.default,
    name: 'MuiDrawer',
    slot: 'Docked',
    skipVariantsResolver: false,
    overridesResolver: $1ed9758f3bc045cc$var$overridesResolver
})({
    flex: '0 0 auto'
});
const $1ed9758f3bc045cc$var$DrawerPaper = (0, $aAbgT.styled)($1ed9758f3bc045cc$var$_Paper.default, {
    name: 'MuiDrawer',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`paperAnchor${(0, $1ed9758f3bc045cc$var$_capitalize.default)(ownerState.anchor)}`],
            ownerState.variant !== 'temporary' && styles[`paperAnchorDocked${(0, $1ed9758f3bc045cc$var$_capitalize.default)(ownerState.anchor)}`]
        ];
    }
})((0, $1ed9758f3bc045cc$var$_memoTheme.default)(({ theme: theme })=>({
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        flex: '1 0 auto',
        zIndex: (theme.vars || theme).zIndex.drawer,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        // temporary style
        position: 'fixed',
        top: 0,
        // We disable the focus ring for mouse, touch and keyboard users.
        // At some point, it would be better to keep it for keyboard users.
        // :focus-ring CSS pseudo-class will help.
        outline: 0,
        variants: [
            {
                props: {
                    anchor: 'left'
                },
                style: {
                    left: 0
                }
            },
            {
                props: {
                    anchor: 'top'
                },
                style: {
                    top: 0,
                    left: 0,
                    right: 0,
                    height: 'auto',
                    maxHeight: '100%'
                }
            },
            {
                props: {
                    anchor: 'right'
                },
                style: {
                    right: 0
                }
            },
            {
                props: {
                    anchor: 'bottom'
                },
                style: {
                    top: 'auto',
                    left: 0,
                    bottom: 0,
                    right: 0,
                    height: 'auto',
                    maxHeight: '100%'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchor === 'left' && ownerState.variant !== 'temporary',
                style: {
                    borderRight: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchor === 'top' && ownerState.variant !== 'temporary',
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchor === 'right' && ownerState.variant !== 'temporary',
                style: {
                    borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchor === 'bottom' && ownerState.variant !== 'temporary',
                style: {
                    borderTop: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            }
        ]
    })));
const $1ed9758f3bc045cc$var$oppositeDirection = {
    left: 'right',
    right: 'left',
    top: 'down',
    bottom: 'up'
};
function $1ed9758f3bc045cc$var$isHorizontal(anchor) {
    return [
        'left',
        'right'
    ].includes(anchor);
}
function $1ed9758f3bc045cc$var$getAnchor({ direction: direction }, anchor) {
    return direction === 'rtl' && $1ed9758f3bc045cc$var$isHorizontal(anchor) ? $1ed9758f3bc045cc$var$oppositeDirection[anchor] : anchor;
}
/**
 * The props of the [Modal](/material-ui/api/modal/) component are available
 * when `variant="temporary"` is set.
 */ const $1ed9758f3bc045cc$var$Drawer = /*#__PURE__*/ $1ed9758f3bc045cc$var$React.forwardRef(function Drawer(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiDrawer'
    });
    const theme = (0, $aAbgT.useTheme)();
    const isRtl = (0, $9uEev.useRtl)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { anchor: anchorProp = 'left', BackdropProps: BackdropProps, children: children, className: className, elevation: elevation = 16, hideBackdrop: hideBackdrop = false, ModalProps: { BackdropProps: BackdropPropsProp, ...ModalProps } = {}, onClose: onClose, open: open = false, PaperProps: PaperProps = {}, SlideProps: SlideProps, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent, transitionDuration: transitionDuration = defaultTransitionDuration, variant: variant = 'temporary', slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    // Let's assume that the Drawer will always be rendered on user space.
    // We use this state is order to skip the appear transition during the
    // initial mount of the component.
    const mounted = $1ed9758f3bc045cc$var$React.useRef(false);
    const rootRef = $1ed9758f3bc045cc$var$React.useRef(null);
    const handleRef = (0, $1ed9758f3bc045cc$var$_useForkRef.default)(ref, rootRef);
    $1ed9758f3bc045cc$var$React.useEffect(()=>{
        mounted.current = true;
    }, []);
    // Resolve the container lazily so Slide reads the mounted modal root
    // after refs are assigned, rather than the initial null ref during render.
    const resolveSlideContainer = $1ed9758f3bc045cc$var$React.useCallback(()=>rootRef.current, []);
    const anchorInvariant = $1ed9758f3bc045cc$var$getAnchor({
        direction: isRtl ? 'rtl' : 'ltr'
    }, anchorProp);
    const anchor = anchorProp;
    const ownerState = {
        ...props,
        anchor: anchor,
        elevation: elevation,
        open: open,
        variant: variant,
        ...other
    };
    const classes = $1ed9758f3bc045cc$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: {
            transition: TransitionComponent,
            ...slots
        },
        slotProps: {
            paper: PaperProps,
            transition: SlideProps,
            ...slotProps,
            backdrop: (0, $hGPki.mergeSlotProps)(slotProps.backdrop || {
                ...BackdropProps,
                ...BackdropPropsProp
            }, {
                transitionDuration: transitionDuration
            })
        }
    };
    const [RootSlot, rootSlotProps] = (0, $1ed9758f3bc045cc$var$_useSlot.default)('root', {
        ref: handleRef,
        elementType: $1ed9758f3bc045cc$var$DrawerRoot,
        className: (0, $1ed9758f3bc045cc$var$_clsx.default)(classes.root, classes.modal, className),
        shouldForwardComponentProp: true,
        ownerState: ownerState,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            ...ModalProps
        },
        additionalProps: {
            closeAfterTransition: true,
            open: open,
            onClose: onClose,
            hideBackdrop: hideBackdrop,
            slots: {
                backdrop: externalForwardedProps.slots.backdrop
            },
            slotProps: {
                backdrop: externalForwardedProps.slotProps.backdrop
            }
        }
    });
    const [PaperSlot, paperSlotProps] = (0, $1ed9758f3bc045cc$var$_useSlot.default)('paper', {
        elementType: $1ed9758f3bc045cc$var$DrawerPaper,
        shouldForwardComponentProp: true,
        className: (0, $1ed9758f3bc045cc$var$_clsx.default)(classes.paper, PaperProps.className),
        ownerState: ownerState,
        externalForwardedProps: externalForwardedProps,
        additionalProps: {
            elevation: variant === 'temporary' ? elevation : 0,
            square: true,
            ...variant === 'temporary' && {
                role: 'dialog',
                'aria-modal': 'true',
                [$ggK3e.FOCUSABLE_ATTRIBUTE]: '',
                tabIndex: -1
            }
        }
    });
    const [DockedSlot, dockedSlotProps] = (0, $1ed9758f3bc045cc$var$_useSlot.default)('docked', {
        elementType: $1ed9758f3bc045cc$var$DrawerDockedRoot,
        ref: handleRef,
        className: (0, $1ed9758f3bc045cc$var$_clsx.default)(classes.root, classes.docked, className),
        ownerState: ownerState,
        externalForwardedProps: externalForwardedProps,
        additionalProps: other // pass `other` here because `DockedSlot` is also a root slot for some variants
    });
    const [TransitionSlot, transitionSlotProps] = (0, $1ed9758f3bc045cc$var$_useSlot.default)('transition', {
        elementType: $1ed9758f3bc045cc$var$_Slide.default,
        ownerState: ownerState,
        externalForwardedProps: externalForwardedProps,
        additionalProps: {
            in: open,
            direction: $1ed9758f3bc045cc$var$oppositeDirection[anchorInvariant],
            timeout: transitionDuration,
            appear: mounted.current,
            ...variant === 'temporary' && (slots.transition == null || slots.transition === $1ed9758f3bc045cc$var$_Slide.default) && {
                container: resolveSlideContainer
            }
        }
    });
    const drawer = /*#__PURE__*/ (0, $ayMG0.jsx)(PaperSlot, {
        ...paperSlotProps,
        children: children
    });
    if (variant === 'permanent') return /*#__PURE__*/ (0, $ayMG0.jsx)(DockedSlot, {
        ...dockedSlotProps,
        children: drawer
    });
    const slidingDrawer = /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionSlot, {
        ...transitionSlotProps,
        children: drawer
    });
    if (variant === 'persistent') return /*#__PURE__*/ (0, $ayMG0.jsx)(DockedSlot, {
        ...dockedSlotProps,
        children: slidingDrawer
    });
    // variant === temporary
    return /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, {
        ...rootSlotProps,
        children: slidingDrawer
    });
});
$1ed9758f3bc045cc$var$Drawer.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Side from which the drawer will appear.
   * @default 'left'
   */ anchor: $1ed9758f3bc045cc$var$_propTypes.default.oneOf([
        'bottom',
        'left',
        'right',
        'top'
    ]),
    /**
   * @ignore
   */ BackdropProps: $1ed9758f3bc045cc$var$_propTypes.default.object,
    /**
   * The content of the component.
   */ children: $1ed9758f3bc045cc$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $1ed9758f3bc045cc$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $1ed9758f3bc045cc$var$_propTypes.default.string,
    /**
   * The elevation of the drawer.
   * @default 16
   */ elevation: $1ed9758f3bc045cc$var$_integerPropType.default,
    /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */ hideBackdrop: $1ed9758f3bc045cc$var$_propTypes.default.bool,
    /**
   * Props applied to the [`Modal`](https://mui.com/material-ui/api/modal/) element.
   * @default {}
   */ ModalProps: $1ed9758f3bc045cc$var$_propTypes.default.object,
    /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */ onClose: $1ed9758f3bc045cc$var$_propTypes.default.func,
    /**
   * If `true`, the component is shown.
   * @default false
   */ open: $1ed9758f3bc045cc$var$_propTypes.default.bool,
    /**
   * Props applied to the [`Paper`](https://mui.com/material-ui/api/paper/) element.
   * @deprecated use the `slotProps.paper` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */ PaperProps: $1ed9758f3bc045cc$var$_propTypes.default.object,
    /**
   * Props applied to the [`Slide`](https://mui.com/material-ui/api/slide/) element.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ SlideProps: $1ed9758f3bc045cc$var$_propTypes.default.object,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $1ed9758f3bc045cc$var$_propTypes.default.shape({
        backdrop: $1ed9758f3bc045cc$var$_propTypes.default.oneOfType([
            $1ed9758f3bc045cc$var$_propTypes.default.func,
            $1ed9758f3bc045cc$var$_propTypes.default.object
        ]),
        docked: $1ed9758f3bc045cc$var$_propTypes.default.oneOfType([
            $1ed9758f3bc045cc$var$_propTypes.default.func,
            $1ed9758f3bc045cc$var$_propTypes.default.object
        ]),
        paper: $1ed9758f3bc045cc$var$_propTypes.default.oneOfType([
            $1ed9758f3bc045cc$var$_propTypes.default.func,
            $1ed9758f3bc045cc$var$_propTypes.default.object
        ]),
        root: $1ed9758f3bc045cc$var$_propTypes.default.oneOfType([
            $1ed9758f3bc045cc$var$_propTypes.default.func,
            $1ed9758f3bc045cc$var$_propTypes.default.object
        ]),
        transition: $1ed9758f3bc045cc$var$_propTypes.default.oneOfType([
            $1ed9758f3bc045cc$var$_propTypes.default.func,
            $1ed9758f3bc045cc$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: $1ed9758f3bc045cc$var$_propTypes.default.shape({
        backdrop: $1ed9758f3bc045cc$var$_propTypes.default.elementType,
        docked: $1ed9758f3bc045cc$var$_propTypes.default.elementType,
        paper: $1ed9758f3bc045cc$var$_propTypes.default.elementType,
        root: $1ed9758f3bc045cc$var$_propTypes.default.elementType,
        transition: $1ed9758f3bc045cc$var$_propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $1ed9758f3bc045cc$var$_propTypes.default.oneOfType([
        $1ed9758f3bc045cc$var$_propTypes.default.arrayOf($1ed9758f3bc045cc$var$_propTypes.default.oneOfType([
            $1ed9758f3bc045cc$var$_propTypes.default.func,
            $1ed9758f3bc045cc$var$_propTypes.default.object,
            $1ed9758f3bc045cc$var$_propTypes.default.bool
        ])),
        $1ed9758f3bc045cc$var$_propTypes.default.func,
        $1ed9758f3bc045cc$var$_propTypes.default.object
    ]),
    /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */ transitionDuration: $1ed9758f3bc045cc$var$_propTypes.default.oneOfType([
        $1ed9758f3bc045cc$var$_propTypes.default.number,
        $1ed9758f3bc045cc$var$_propTypes.default.shape({
            appear: $1ed9758f3bc045cc$var$_propTypes.default.number,
            enter: $1ed9758f3bc045cc$var$_propTypes.default.number,
            exit: $1ed9758f3bc045cc$var$_propTypes.default.number
        })
    ]),
    /**
   * The variant to use.
   * @default 'temporary'
   */ variant: $1ed9758f3bc045cc$var$_propTypes.default.oneOf([
        'permanent',
        'persistent',
        'temporary'
    ])
};
var $1ed9758f3bc045cc$var$_default = module.exports.default = $1ed9758f3bc045cc$var$Drawer;

});
parcelRegister("bQRpD", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $8a0dfba99a405f81$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $8a0dfba99a405f81$var$_Slide.default;
    }
});

var $8a0dfba99a405f81$var$_Slide = $8a0dfba99a405f81$require$_interopRequireDefault((parcelRequire("6FKde")));

});
parcelRegister("6FKde", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $4dba6b402693f5d6$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $4dba6b402693f5d6$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.setTranslateValue = $4dba6b402693f5d6$var$setTranslateValue;

var $4dba6b402693f5d6$var$React = $4dba6b402693f5d6$require$_interopRequireWildcard((parcelRequire("acw62")));

var $4dba6b402693f5d6$var$_propTypes = $4dba6b402693f5d6$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $1mPeS = parcelRequire("1mPeS");

var $4dba6b402693f5d6$var$_chainPropTypes = $4dba6b402693f5d6$require$_interopRequireDefault((parcelRequire("abVWF")));

var $4dba6b402693f5d6$var$_HTMLElementType = $4dba6b402693f5d6$require$_interopRequireDefault((parcelRequire("cIfK5")));

var $4dba6b402693f5d6$var$_elementAcceptingRef = $4dba6b402693f5d6$require$_interopRequireDefault((parcelRequire("igTUE")));

var $4dba6b402693f5d6$var$_getReactElementRef = $4dba6b402693f5d6$require$_interopRequireDefault((parcelRequire("2B4J6")));

var $4dba6b402693f5d6$var$_isLayoutSupported = $4dba6b402693f5d6$require$_interopRequireDefault((parcelRequire("6toKj")));

var $4dba6b402693f5d6$var$_debounce = $4dba6b402693f5d6$require$_interopRequireDefault((parcelRequire("1iGrQ")));

var $4dba6b402693f5d6$var$_useForkRef = $4dba6b402693f5d6$require$_interopRequireDefault((parcelRequire("9Rgf1")));

var $aAbgT = parcelRequire("aAbgT");

var $hweuE = parcelRequire("hweuE");

var $hGPki = parcelRequire("hGPki");

var $ayMG0 = parcelRequire("ayMG0");
const $4dba6b402693f5d6$var$hiddenStyles = {
    visibility: 'hidden'
};
// Translate the node so it can't be seen on the screen.
// Later, we're going to translate the node back to its original location with `none`.
function $4dba6b402693f5d6$var$getTranslateValue(direction, node, resolvedContainer) {
    const containerRect = resolvedContainer && resolvedContainer.getBoundingClientRect();
    const containerWindow = (0, $hGPki.ownerWindow)(node);
    // Clear the inline transform and transition before reading layout and computed
    // style so we compute from the element's natural position, not its previous
    // off-screen translation. The transition must also be cleared, otherwise the
    // browser may report an animated intermediate value from a still-running
    // enter transition when reading getComputedStyle during exit.
    const previousTransform = node.style.transform;
    const previousTransition = node.style.transition;
    node.style.transition = '';
    node.style.transform = '';
    const rect = node.getBoundingClientRect();
    const computedStyle = containerWindow.getComputedStyle(node);
    const transform = computedStyle.getPropertyValue('transform');
    node.style.transform = previousTransform;
    node.style.transition = previousTransition;
    let offsetX = 0;
    let offsetY = 0;
    if (transform && transform !== 'none' && typeof transform === 'string') {
        const transformValues = transform.split('(')[1].split(')')[0].split(',');
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    if (direction === 'left') {
        if (containerRect) return `translateX(${containerRect.right + offsetX - rect.left}px)`;
        return `translateX(${containerWindow.innerWidth + offsetX - rect.left}px)`;
    }
    if (direction === 'right') {
        if (containerRect) return `translateX(-${rect.right - containerRect.left - offsetX}px)`;
        return `translateX(-${rect.left + rect.width - offsetX}px)`;
    }
    if (direction === 'up') {
        if (containerRect) return `translateY(${containerRect.bottom + offsetY - rect.top}px)`;
        return `translateY(${containerWindow.innerHeight + offsetY - rect.top}px)`;
    }
    // direction === 'down'
    if (containerRect) return `translateY(-${rect.top - containerRect.top + rect.height - offsetY}px)`;
    return `translateY(-${rect.top + rect.height - offsetY}px)`;
}
function $4dba6b402693f5d6$var$resolveContainer(containerPropProp) {
    return typeof containerPropProp === 'function' ? containerPropProp() : containerPropProp;
}
function $4dba6b402693f5d6$var$setTranslateValue(direction, node, containerProp) {
    const resolvedContainer = $4dba6b402693f5d6$var$resolveContainer(containerProp);
    const transform = $4dba6b402693f5d6$var$getTranslateValue(direction, node, resolvedContainer);
    if (transform) node.style.transform = transform;
}
/**
 * The Slide transition is used by the [Drawer](/material-ui/react-drawer/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $4dba6b402693f5d6$var$Slide = /*#__PURE__*/ $4dba6b402693f5d6$var$React.forwardRef(function Slide(props, ref) {
    const theme = (0, $aAbgT.useTheme)();
    const defaultEasing = {
        enter: theme.transitions.easing.easeOut,
        exit: theme.transitions.easing.sharp
    };
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, container: containerProp, direction: direction = 'down', easing: easingProp = defaultEasing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, ...other } = props;
    const childrenRef = $4dba6b402693f5d6$var$React.useRef(null);
    const handleRef = (0, $4dba6b402693f5d6$var$_useForkRef.default)((0, $4dba6b402693f5d6$var$_getReactElementRef.default)(children), childrenRef, ref);
    const handleEnter = (0, $hweuE.normalizedTransitionCallback)(childrenRef, (node, isAppearing)=>{
        $4dba6b402693f5d6$var$setTranslateValue(direction, node, containerProp);
        (0, $hweuE.reflow)(node);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = (0, $hweuE.normalizedTransitionCallback)(childrenRef, (node, isAppearing)=>{
        const transitionProps = (0, $hweuE.getTransitionProps)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: 'enter'
        });
        node.style.transition = theme.transitions.create('transform', transitionProps);
        node.style.transform = 'none';
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = (0, $hweuE.normalizedTransitionCallback)(childrenRef, onEntered);
    const handleExiting = (0, $hweuE.normalizedTransitionCallback)(childrenRef, onExiting);
    const handleExit = (0, $hweuE.normalizedTransitionCallback)(childrenRef, (node)=>{
        const transitionProps = (0, $hweuE.getTransitionProps)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: 'exit'
        });
        node.style.transition = theme.transitions.create('transform', transitionProps);
        $4dba6b402693f5d6$var$setTranslateValue(direction, node, containerProp);
        if (onExit) onExit(node);
    });
    const handleExited = (0, $hweuE.normalizedTransitionCallback)(childrenRef, (node)=>{
        // No need for transitions when the component is hidden
        node.style.transition = '';
        if (onExited) onExited(node);
    });
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(childrenRef.current, next);
    };
    const updatePosition = $4dba6b402693f5d6$var$React.useCallback(()=>{
        if (childrenRef.current) $4dba6b402693f5d6$var$setTranslateValue(direction, childrenRef.current, containerProp);
    }, [
        direction,
        containerProp
    ]);
    $4dba6b402693f5d6$var$React.useEffect(()=>{
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === 'down' || direction === 'right') return undefined;
        const handleResize = (0, $4dba6b402693f5d6$var$_debounce.default)(()=>{
            if (childrenRef.current) $4dba6b402693f5d6$var$setTranslateValue(direction, childrenRef.current, containerProp);
        });
        const containerWindow = (0, $hGPki.ownerWindow)(childrenRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        direction,
        inProp,
        containerProp
    ]);
    $4dba6b402693f5d6$var$React.useEffect(()=>{
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1mPeS.default, {
        nodeRef: childrenRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        appear: appear,
        in: inProp,
        timeout: timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            let childStyle;
            if (state === 'exited' && !inProp) childStyle = style || children.props.style ? {
                visibility: 'hidden',
                ...style,
                ...children.props.style
            } : $4dba6b402693f5d6$var$hiddenStyles;
            else if (style && children.props.style) childStyle = {
                ...style,
                ...children.props.style
            };
            else childStyle = style || children.props.style;
            return /*#__PURE__*/ $4dba6b402693f5d6$var$React.cloneElement(children, {
                ref: handleRef,
                style: childStyle,
                ...restChildProps
            });
        }
    });
});
$4dba6b402693f5d6$var$Slide.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */ addEndListener: $4dba6b402693f5d6$var$_propTypes.default.func,
    /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */ appear: $4dba6b402693f5d6$var$_propTypes.default.bool,
    /**
   * A single child content element.
   */ children: $4dba6b402693f5d6$var$_elementAcceptingRef.default.isRequired,
    /**
   * An HTML element, or a function that returns one.
   * It's used to set the container the Slide is transitioning from.
   */ container: (0, $4dba6b402693f5d6$var$_chainPropTypes.default)($4dba6b402693f5d6$var$_propTypes.default.oneOfType([
        $4dba6b402693f5d6$var$_HTMLElementType.default,
        $4dba6b402693f5d6$var$_propTypes.default.func
    ]), (props)=>{
        if (props.open) {
            const resolvedContainer = $4dba6b402693f5d6$var$resolveContainer(props.container);
            if (resolvedContainer && resolvedContainer.nodeType === 1) {
                const box = resolvedContainer.getBoundingClientRect();
                if ((0, $4dba6b402693f5d6$var$_isLayoutSupported.default)() && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) return new Error([
                    'MUI: The `container` prop provided to the component is invalid.',
                    'The anchor element should be part of the document layout.',
                    "Make sure the element is present in the document or that it's not display none."
                ].join('\n'));
            } else if (!resolvedContainer || typeof resolvedContainer.getBoundingClientRect !== 'function' || resolvedContainer.contextElement != null && resolvedContainer.contextElement.nodeType !== 1) return new Error([
                'MUI: The `container` prop provided to the component is invalid.',
                'It should be an HTML element instance.'
            ].join('\n'));
        }
        return null;
    }),
    /**
   * Direction the child node will enter from.
   * @default 'down'
   */ direction: $4dba6b402693f5d6$var$_propTypes.default.oneOf([
        'down',
        'left',
        'right',
        'up'
    ]),
    /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   * @default {
   *   enter: theme.transitions.easing.easeOut,
   *   exit: theme.transitions.easing.sharp,
   * }
   */ easing: $4dba6b402693f5d6$var$_propTypes.default.oneOfType([
        $4dba6b402693f5d6$var$_propTypes.default.shape({
            enter: $4dba6b402693f5d6$var$_propTypes.default.string,
            exit: $4dba6b402693f5d6$var$_propTypes.default.string
        }),
        $4dba6b402693f5d6$var$_propTypes.default.string
    ]),
    /**
   * If `true`, the component will transition in.
   */ in: $4dba6b402693f5d6$var$_propTypes.default.bool,
    /**
   * @ignore
   */ onEnter: $4dba6b402693f5d6$var$_propTypes.default.func,
    /**
   * @ignore
   */ onEntered: $4dba6b402693f5d6$var$_propTypes.default.func,
    /**
   * @ignore
   */ onEntering: $4dba6b402693f5d6$var$_propTypes.default.func,
    /**
   * @ignore
   */ onExit: $4dba6b402693f5d6$var$_propTypes.default.func,
    /**
   * @ignore
   */ onExited: $4dba6b402693f5d6$var$_propTypes.default.func,
    /**
   * @ignore
   */ onExiting: $4dba6b402693f5d6$var$_propTypes.default.func,
    /**
   * @ignore
   */ style: $4dba6b402693f5d6$var$_propTypes.default.object,
    /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */ timeout: $4dba6b402693f5d6$var$_propTypes.default.oneOfType([
        $4dba6b402693f5d6$var$_propTypes.default.number,
        $4dba6b402693f5d6$var$_propTypes.default.shape({
            appear: $4dba6b402693f5d6$var$_propTypes.default.number,
            enter: $4dba6b402693f5d6$var$_propTypes.default.number,
            exit: $4dba6b402693f5d6$var$_propTypes.default.number
        })
    ])
};
var $4dba6b402693f5d6$var$_default = module.exports.default = $4dba6b402693f5d6$var$Slide;

});


parcelRegister("4G59M", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $367f15b5d414b8d7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getDrawerUtilityClass = $367f15b5d414b8d7$var$getDrawerUtilityClass;

var $367f15b5d414b8d7$var$_generateUtilityClasses = $367f15b5d414b8d7$require$_interopRequireDefault((parcelRequire("5nY49")));

var $367f15b5d414b8d7$var$_generateUtilityClass = $367f15b5d414b8d7$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $367f15b5d414b8d7$var$getDrawerUtilityClass(slot) {
    return (0, $367f15b5d414b8d7$var$_generateUtilityClass.default)('MuiDrawer', slot);
}
const $367f15b5d414b8d7$var$drawerClasses = (0, $367f15b5d414b8d7$var$_generateUtilityClasses.default)('MuiDrawer', [
    'root',
    'docked',
    'paper',
    'anchorLeft',
    'anchorRight',
    'anchorTop',
    'anchorBottom',
    'paperAnchorLeft',
    'paperAnchorRight',
    'paperAnchorTop',
    'paperAnchorBottom',
    'paperAnchorDockedLeft',
    'paperAnchorDockedRight',
    'paperAnchorDockedTop',
    'paperAnchorDockedBottom',
    'modal'
]);
var $367f15b5d414b8d7$var$_default = module.exports.default = $367f15b5d414b8d7$var$drawerClasses;

});



parcelRegister("2r6m0", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $1c63081f73fd2072$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $1c63081f73fd2072$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $1c63081f73fd2072$var$_exportNames = {
    fabClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $1c63081f73fd2072$var$_Fab.default;
    }
});
Object.defineProperty(module.exports, "fabClasses", {
    enumerable: true,
    get: function() {
        return $1c63081f73fd2072$var$_fabClasses.default;
    }
});

var $1c63081f73fd2072$var$_Fab = $1c63081f73fd2072$require$_interopRequireDefault((parcelRequire("36qXg")));

var $1c63081f73fd2072$var$_fabClasses = $1c63081f73fd2072$require$_interopRequireWildcard((parcelRequire("dUss3")));
Object.keys($1c63081f73fd2072$var$_fabClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1c63081f73fd2072$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $1c63081f73fd2072$var$_fabClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1c63081f73fd2072$var$_fabClasses[key];
        }
    });
});

});
parcelRegister("36qXg", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $2426d7556721cbb6$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $2426d7556721cbb6$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2426d7556721cbb6$var$React = $2426d7556721cbb6$require$_interopRequireWildcard((parcelRequire("acw62")));

var $2426d7556721cbb6$var$_propTypes = $2426d7556721cbb6$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $2426d7556721cbb6$var$_clsx = $2426d7556721cbb6$require$_interopRequireDefault((parcelRequire("9QePP")));

var $2426d7556721cbb6$var$_composeClasses = $2426d7556721cbb6$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $2426d7556721cbb6$var$_ButtonBase = $2426d7556721cbb6$require$_interopRequireDefault((parcelRequire("hhs3r")));

var $2426d7556721cbb6$var$_capitalize = $2426d7556721cbb6$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $2426d7556721cbb6$var$_fabClasses = $2426d7556721cbb6$require$_interopRequireWildcard((parcelRequire("dUss3")));

var $2426d7556721cbb6$var$_rootShouldForwardProp = $2426d7556721cbb6$require$_interopRequireDefault((parcelRequire("8Uq77")));

var $aAbgT = parcelRequire("aAbgT");

var $2426d7556721cbb6$var$_memoTheme = $2426d7556721cbb6$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $2426d7556721cbb6$var$_createSimplePaletteValueFilter = $2426d7556721cbb6$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $hL1nr = parcelRequire("hL1nr");

var $ayMG0 = parcelRequire("ayMG0");
const $2426d7556721cbb6$var$useUtilityClasses = (ownerState)=>{
    const { color: color, variant: variant, classes: classes, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `size${(0, $2426d7556721cbb6$var$_capitalize.default)(size)}`,
            color === 'inherit' ? 'colorInherit' : color
        ]
    };
    const composedClasses = (0, $2426d7556721cbb6$var$_composeClasses.default)(slots, $2426d7556721cbb6$var$_fabClasses.getFabUtilityClass, classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the ButtonBase
        ...composedClasses
    };
};
const $2426d7556721cbb6$var$FabRoot = (0, $aAbgT.styled)($2426d7556721cbb6$var$_ButtonBase.default, {
    name: 'MuiFab',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $2426d7556721cbb6$var$_rootShouldForwardProp.default)(prop) || prop === 'classes',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $2426d7556721cbb6$var$_capitalize.default)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            styles[(0, $2426d7556721cbb6$var$_capitalize.default)(ownerState.size)],
            styles[ownerState.color]
        ];
    }
})((0, $2426d7556721cbb6$var$_memoTheme.default)(({ theme: theme })=>({
        ...theme.typography.button,
        minHeight: 36,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color'
        ], {
            duration: theme.transitions.duration.short
        }),
        borderRadius: '50%',
        padding: 0,
        minWidth: 0,
        width: 56,
        height: 56,
        zIndex: (theme.vars || theme).zIndex.fab,
        boxShadow: (theme.vars || theme).shadows[6],
        '&:active': {
            boxShadow: (theme.vars || theme).shadows[12]
        },
        color: theme.vars ? theme.vars.palette.grey[900] : theme.palette.getContrastText?.(theme.palette.grey[300]),
        backgroundColor: (theme.vars || theme).palette.grey[300],
        '&:hover': {
            backgroundColor: (theme.vars || theme).palette.grey.A100,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: (theme.vars || theme).palette.grey[300]
            },
            textDecoration: 'none'
        },
        [`&.${$2426d7556721cbb6$var$_fabClasses.default.focusVisible}`]: {
            boxShadow: (theme.vars || theme).shadows[6]
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    width: 40,
                    height: 40
                }
            },
            {
                props: {
                    size: 'medium'
                },
                style: {
                    width: 48,
                    height: 48
                }
            },
            {
                props: {
                    variant: 'extended'
                },
                style: {
                    borderRadius: 24,
                    padding: '0 16px',
                    width: 'auto',
                    minHeight: 'auto',
                    minWidth: 48,
                    height: 48
                }
            },
            {
                props: {
                    variant: 'extended',
                    size: 'small'
                },
                style: {
                    width: 'auto',
                    padding: '0 8px',
                    borderRadius: 17,
                    minWidth: 34,
                    height: 34
                }
            },
            {
                props: {
                    variant: 'extended',
                    size: 'medium'
                },
                style: {
                    width: 'auto',
                    padding: '0 16px',
                    borderRadius: 20,
                    minWidth: 40,
                    height: 40
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            }
        ]
    })), (0, $2426d7556721cbb6$var$_memoTheme.default)(({ theme: theme })=>({
        variants: [
            ...Object.entries(theme.palette).filter((0, $2426d7556721cbb6$var$_createSimplePaletteValueFilter.default)([
                'dark',
                'contrastText'
            ])) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].contrastText,
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        '&:hover': {
                            backgroundColor: (theme.vars || theme).palette[color].dark,
                            // Reset on touch devices, it doesn't add specificity
                            '@media (hover: none)': {
                                backgroundColor: (theme.vars || theme).palette[color].main
                            }
                        }
                    }
                }))
        ]
    })), (0, $2426d7556721cbb6$var$_memoTheme.default)(({ theme: theme })=>({
        [`&.${$2426d7556721cbb6$var$_fabClasses.default.disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        }
    })));
const $2426d7556721cbb6$var$Fab = /*#__PURE__*/ $2426d7556721cbb6$var$React.forwardRef(function Fab(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiFab'
    });
    const { children: children, className: className, color: color = 'default', component: component = 'button', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, focusVisibleClassName: focusVisibleClassName, size: size = 'large', variant: variant = 'circular', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size,
        variant: variant
    };
    const classes = $2426d7556721cbb6$var$useUtilityClasses(ownerState);
    // Don't forward the 'root' class to the ButtonBase, as it will get duplicated with the one passed to the className prop.
    const { root: root, ...forwardedClasses } = classes;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($2426d7556721cbb6$var$FabRoot, {
        className: (0, $2426d7556721cbb6$var$_clsx.default)(classes.root, className),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $2426d7556721cbb6$var$_clsx.default)(classes.focusVisible, focusVisibleClassName),
        ownerState: ownerState,
        ref: ref,
        ...other,
        classes: forwardedClasses,
        children: children
    });
});
$2426d7556721cbb6$var$Fab.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: $2426d7556721cbb6$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $2426d7556721cbb6$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $2426d7556721cbb6$var$_propTypes.default.string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */ color: $2426d7556721cbb6$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $2426d7556721cbb6$var$_propTypes.default.oneOf([
            'default',
            'error',
            'info',
            'inherit',
            'primary',
            'secondary',
            'success',
            'warning'
        ]),
        $2426d7556721cbb6$var$_propTypes.default.string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $2426d7556721cbb6$var$_propTypes.default.elementType,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: $2426d7556721cbb6$var$_propTypes.default.bool,
    /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */ disableFocusRipple: $2426d7556721cbb6$var$_propTypes.default.bool,
    /**
   * If `true`, the ripple effect is disabled.
   */ disableRipple: $2426d7556721cbb6$var$_propTypes.default.bool,
    /**
   * @ignore
   */ focusVisibleClassName: $2426d7556721cbb6$var$_propTypes.default.string,
    /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */ href: $2426d7556721cbb6$var$_propTypes.default.string,
    /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'large'
   */ size: $2426d7556721cbb6$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $2426d7556721cbb6$var$_propTypes.default.oneOf([
            'small',
            'medium',
            'large'
        ]),
        $2426d7556721cbb6$var$_propTypes.default.string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $2426d7556721cbb6$var$_propTypes.default.oneOfType([
        $2426d7556721cbb6$var$_propTypes.default.arrayOf($2426d7556721cbb6$var$_propTypes.default.oneOfType([
            $2426d7556721cbb6$var$_propTypes.default.func,
            $2426d7556721cbb6$var$_propTypes.default.object,
            $2426d7556721cbb6$var$_propTypes.default.bool
        ])),
        $2426d7556721cbb6$var$_propTypes.default.func,
        $2426d7556721cbb6$var$_propTypes.default.object
    ]),
    /**
   * The variant to use.
   * @default 'circular'
   */ variant: $2426d7556721cbb6$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $2426d7556721cbb6$var$_propTypes.default.oneOf([
            'circular',
            'extended'
        ]),
        $2426d7556721cbb6$var$_propTypes.default.string
    ])
};
var $2426d7556721cbb6$var$_default = module.exports.default = $2426d7556721cbb6$var$Fab;

});
parcelRegister("dUss3", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a206933548dacbdf$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getFabUtilityClass = $a206933548dacbdf$var$getFabUtilityClass;

var $a206933548dacbdf$var$_generateUtilityClasses = $a206933548dacbdf$require$_interopRequireDefault((parcelRequire("5nY49")));

var $a206933548dacbdf$var$_generateUtilityClass = $a206933548dacbdf$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $a206933548dacbdf$var$getFabUtilityClass(slot) {
    return (0, $a206933548dacbdf$var$_generateUtilityClass.default)('MuiFab', slot);
}
const $a206933548dacbdf$var$fabClasses = (0, $a206933548dacbdf$var$_generateUtilityClasses.default)('MuiFab', [
    'root',
    'primary',
    'secondary',
    'extended',
    'circular',
    'focusVisible',
    'disabled',
    'colorInherit',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'info',
    'error',
    'warning',
    'success'
]);
var $a206933548dacbdf$var$_default = module.exports.default = $a206933548dacbdf$var$fabClasses;

});



parcelRegister("buuiu", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $85d9ff6e52a65e06$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $85d9ff6e52a65e06$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $85d9ff6e52a65e06$var$_exportNames = {
    formGroupClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $85d9ff6e52a65e06$var$_FormGroup.default;
    }
});
Object.defineProperty(module.exports, "formGroupClasses", {
    enumerable: true,
    get: function() {
        return $85d9ff6e52a65e06$var$_formGroupClasses.default;
    }
});

var $85d9ff6e52a65e06$var$_FormGroup = $85d9ff6e52a65e06$require$_interopRequireDefault((parcelRequire("6Tegk")));

var $85d9ff6e52a65e06$var$_formGroupClasses = $85d9ff6e52a65e06$require$_interopRequireWildcard((parcelRequire("j5wWn")));
Object.keys($85d9ff6e52a65e06$var$_formGroupClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($85d9ff6e52a65e06$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $85d9ff6e52a65e06$var$_formGroupClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $85d9ff6e52a65e06$var$_formGroupClasses[key];
        }
    });
});

});
parcelRegister("6Tegk", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $5042f159189dda87$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $5042f159189dda87$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5042f159189dda87$var$React = $5042f159189dda87$require$_interopRequireWildcard((parcelRequire("acw62")));

var $5042f159189dda87$var$_propTypes = $5042f159189dda87$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $5042f159189dda87$var$_clsx = $5042f159189dda87$require$_interopRequireDefault((parcelRequire("9QePP")));

var $5042f159189dda87$var$_composeClasses = $5042f159189dda87$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $j5wWn = parcelRequire("j5wWn");

var $5042f159189dda87$var$_useFormControl = $5042f159189dda87$require$_interopRequireDefault((parcelRequire("cJQfW")));

var $5042f159189dda87$var$_formControlState = $5042f159189dda87$require$_interopRequireDefault((parcelRequire("aaphR")));

var $ayMG0 = parcelRequire("ayMG0");
const $5042f159189dda87$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, row: row, error: error } = ownerState;
    const slots = {
        root: [
            'root',
            row && 'row',
            error && 'error'
        ]
    };
    return (0, $5042f159189dda87$var$_composeClasses.default)(slots, $j5wWn.getFormGroupUtilityClass, classes);
};
const $5042f159189dda87$var$FormGroupRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiFormGroup',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.row && styles.row
        ];
    }
})({
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    variants: [
        {
            props: {
                row: true
            },
            style: {
                flexDirection: 'row'
            }
        }
    ]
});
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */ const $5042f159189dda87$var$FormGroup = /*#__PURE__*/ $5042f159189dda87$var$React.forwardRef(function FormGroup(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiFormGroup'
    });
    const { className: className, row: row = false, ...other } = props;
    const muiFormControl = (0, $5042f159189dda87$var$_useFormControl.default)();
    const fcs = (0, $5042f159189dda87$var$_formControlState.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = {
        ...props,
        row: row,
        error: fcs.error
    };
    const classes = $5042f159189dda87$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5042f159189dda87$var$FormGroupRoot, {
        className: (0, $5042f159189dda87$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
$5042f159189dda87$var$FormGroup.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: $5042f159189dda87$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $5042f159189dda87$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $5042f159189dda87$var$_propTypes.default.string,
    /**
   * Display group of elements in a compact row.
   * @default false
   */ row: $5042f159189dda87$var$_propTypes.default.bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $5042f159189dda87$var$_propTypes.default.oneOfType([
        $5042f159189dda87$var$_propTypes.default.arrayOf($5042f159189dda87$var$_propTypes.default.oneOfType([
            $5042f159189dda87$var$_propTypes.default.func,
            $5042f159189dda87$var$_propTypes.default.object,
            $5042f159189dda87$var$_propTypes.default.bool
        ])),
        $5042f159189dda87$var$_propTypes.default.func,
        $5042f159189dda87$var$_propTypes.default.object
    ])
};
var $5042f159189dda87$var$_default = module.exports.default = $5042f159189dda87$var$FormGroup;

});
parcelRegister("j5wWn", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $de580948e3d734b1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getFormGroupUtilityClass = $de580948e3d734b1$var$getFormGroupUtilityClass;

var $de580948e3d734b1$var$_generateUtilityClasses = $de580948e3d734b1$require$_interopRequireDefault((parcelRequire("5nY49")));

var $de580948e3d734b1$var$_generateUtilityClass = $de580948e3d734b1$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $de580948e3d734b1$var$getFormGroupUtilityClass(slot) {
    return (0, $de580948e3d734b1$var$_generateUtilityClass.default)('MuiFormGroup', slot);
}
const $de580948e3d734b1$var$formGroupClasses = (0, $de580948e3d734b1$var$_generateUtilityClasses.default)('MuiFormGroup', [
    'root',
    'row',
    'error'
]);
var $de580948e3d734b1$var$_default = module.exports.default = $de580948e3d734b1$var$formGroupClasses;

});



parcelRegister("jNkhK", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $e692542356e1b3b3$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $e692542356e1b3b3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $e692542356e1b3b3$var$_exportNames = {
    gridLegacyClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $e692542356e1b3b3$var$_GridLegacy.default;
    }
});
Object.defineProperty(module.exports, "gridLegacyClasses", {
    enumerable: true,
    get: function() {
        return $e692542356e1b3b3$var$_gridLegacyClasses.default;
    }
});

var $e692542356e1b3b3$var$_GridLegacy = $e692542356e1b3b3$require$_interopRequireDefault((parcelRequire("7PZ8a")));

var $e692542356e1b3b3$var$_gridLegacyClasses = $e692542356e1b3b3$require$_interopRequireWildcard((parcelRequire("6qE3E")));
Object.keys($e692542356e1b3b3$var$_gridLegacyClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($e692542356e1b3b3$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $e692542356e1b3b3$var$_gridLegacyClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $e692542356e1b3b3$var$_gridLegacyClasses[key];
        }
    });
});

});
parcelRegister("7PZ8a", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $5b4cb71c8460708a$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $5b4cb71c8460708a$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.generateColumnGap = $5b4cb71c8460708a$var$generateColumnGap;
module.exports.generateDirection = $5b4cb71c8460708a$var$generateDirection;
module.exports.generateGridLegacy = $5b4cb71c8460708a$var$generateGridLegacy;
module.exports.generateRowGap = $5b4cb71c8460708a$var$generateRowGap;
module.exports.resolveSpacingClasses = $5b4cb71c8460708a$var$resolveSpacingClasses;
module.exports.resolveSpacingStyles = $5b4cb71c8460708a$var$resolveSpacingStyles;

var $5b4cb71c8460708a$var$React = $5b4cb71c8460708a$require$_interopRequireWildcard((parcelRequire("acw62")));

var $5b4cb71c8460708a$var$_propTypes = $5b4cb71c8460708a$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $5b4cb71c8460708a$var$_clsx = $5b4cb71c8460708a$require$_interopRequireDefault((parcelRequire("9QePP")));

var $izOUK = parcelRequire("izOUK");

var $l6FST = parcelRequire("l6FST");

var $5b4cb71c8460708a$var$_composeClasses = $5b4cb71c8460708a$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $5b4cb71c8460708a$var$_requirePropFactory = $5b4cb71c8460708a$require$_interopRequireDefault((parcelRequire("3VqP0")));

var $5b4cb71c8460708a$var$_styled = $5b4cb71c8460708a$require$_interopRequireDefault((parcelRequire("d8seH")));

var $hL1nr = parcelRequire("hL1nr");

var $5b4cb71c8460708a$var$_useTheme = $5b4cb71c8460708a$require$_interopRequireDefault((parcelRequire("14H9o")));

var $5b4cb71c8460708a$var$_GridLegacyContext = $5b4cb71c8460708a$require$_interopRequireDefault((parcelRequire("8961s")));

var $5b4cb71c8460708a$var$_gridLegacyClasses = $5b4cb71c8460708a$require$_interopRequireWildcard((parcelRequire("6qE3E")));

var $ayMG0 = parcelRequire("ayMG0");
let $5b4cb71c8460708a$var$warnedOnce = false;
function $5b4cb71c8460708a$var$warnAboutDeprecatedGridLegacy() {
    if (!$5b4cb71c8460708a$var$warnedOnce && true) {
        $5b4cb71c8460708a$var$warnedOnce = true;
        console.warn('MUI: The GridLegacy component is deprecated. See https://mui.com/material-ui/migration/upgrade-to-grid-v2/ for migration instructions.\n');
    }
}
function $5b4cb71c8460708a$var$generateGridLegacy({ theme: theme, ownerState: ownerState }) {
    let size;
    return theme.breakpoints.keys.reduce((globalStyles, breakpoint)=>{
        // Use side effect over immutability for better performance.
        let styles = {};
        if (ownerState[breakpoint]) size = ownerState[breakpoint];
        if (!size) return globalStyles;
        if (size === true) // For the auto layouting
        styles = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: '100%'
        };
        else if (size === 'auto') styles = {
            flexBasis: 'auto',
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 'none',
            width: 'auto'
        };
        else {
            const columnsBreakpointValues = (0, $izOUK.unstable_resolveBreakpointValues)({
                values: ownerState.columns,
                breakpoints: theme.breakpoints.values
            });
            const columnValue = typeof columnsBreakpointValues === 'object' ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues;
            if (columnValue === undefined || columnValue === null) return globalStyles;
            // Keep 7 significant numbers.
            const width = `${Math.round(size / columnValue * 10e7) / 10e5}%`;
            let more = {};
            if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
                const themeSpacing = theme.spacing(ownerState.columnSpacing);
                if (themeSpacing !== '0px') {
                    const fullWidth = `calc(${width} + ${themeSpacing})`;
                    more = {
                        flexBasis: fullWidth,
                        maxWidth: fullWidth
                    };
                }
            }
            // Close to the bootstrap implementation:
            // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
            styles = {
                flexBasis: width,
                flexGrow: 0,
                maxWidth: width,
                ...more
            };
        }
        // No need for a media query for the first size.
        if (theme.breakpoints.values[breakpoint] === 0) Object.assign(globalStyles, styles);
        else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
        return globalStyles;
    }, {});
}
function $5b4cb71c8460708a$var$generateDirection({ theme: theme, ownerState: ownerState }) {
    const directionValues = (0, $izOUK.unstable_resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    });
    return (0, $izOUK.handleBreakpoints)({
        theme: theme
    }, directionValues, (propValue)=>{
        const output = {
            flexDirection: propValue
        };
        if (propValue.startsWith('column')) output[`& > .${$5b4cb71c8460708a$var$_gridLegacyClasses.default.item}`] = {
            maxWidth: 'none'
        };
        return output;
    });
}
/**
 * Extracts zero value breakpoint keys before a non-zero value breakpoint key.
 * @example { xs: 0, sm: 0, md: 2, lg: 0, xl: 0 } or [0, 0, 2, 0, 0]
 * @returns [xs, sm]
 */ function $5b4cb71c8460708a$var$extractZeroValueBreakpointKeys({ breakpoints: breakpoints, values: values }) {
    let nonZeroKey = '';
    Object.keys(values).forEach((key)=>{
        if (nonZeroKey !== '') return;
        if (values[key] !== 0) nonZeroKey = key;
    });
    const sortedBreakpointKeysByValue = Object.keys(breakpoints).sort((a, b)=>{
        return breakpoints[a] - breakpoints[b];
    });
    return sortedBreakpointKeysByValue.slice(0, sortedBreakpointKeysByValue.indexOf(nonZeroKey));
}
function $5b4cb71c8460708a$var$generateRowGap({ theme: theme, ownerState: ownerState }) {
    const { container: container, rowSpacing: rowSpacing } = ownerState;
    let styles = {};
    if (container && rowSpacing !== 0) {
        const rowSpacingValues = (0, $izOUK.unstable_resolveBreakpointValues)({
            values: rowSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof rowSpacingValues === 'object') zeroValueBreakpointKeys = $5b4cb71c8460708a$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: rowSpacingValues
        });
        styles = (0, $izOUK.handleBreakpoints)({
            theme: theme
        }, rowSpacingValues, (propValue, breakpoint)=>{
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== '0px') return {
                marginTop: `calc(-1 * ${themeSpacing})`,
                [`& > .${$5b4cb71c8460708a$var$_gridLegacyClasses.default.item}`]: {
                    paddingTop: themeSpacing
                }
            };
            if (zeroValueBreakpointKeys?.includes(breakpoint)) return {};
            return {
                marginTop: 0,
                [`& > .${$5b4cb71c8460708a$var$_gridLegacyClasses.default.item}`]: {
                    paddingTop: 0
                }
            };
        });
    }
    return styles;
}
function $5b4cb71c8460708a$var$generateColumnGap({ theme: theme, ownerState: ownerState }) {
    const { container: container, columnSpacing: columnSpacing } = ownerState;
    let styles = {};
    if (container && columnSpacing !== 0) {
        const columnSpacingValues = (0, $izOUK.unstable_resolveBreakpointValues)({
            values: columnSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof columnSpacingValues === 'object') zeroValueBreakpointKeys = $5b4cb71c8460708a$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: columnSpacingValues
        });
        styles = (0, $izOUK.handleBreakpoints)({
            theme: theme
        }, columnSpacingValues, (propValue, breakpoint)=>{
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== '0px') {
                const negativeValue = `calc(-1 * ${themeSpacing})`;
                return {
                    width: `calc(100% + ${themeSpacing})`,
                    marginLeft: negativeValue,
                    [`& > .${$5b4cb71c8460708a$var$_gridLegacyClasses.default.item}`]: {
                        paddingLeft: themeSpacing
                    }
                };
            }
            if (zeroValueBreakpointKeys?.includes(breakpoint)) return {};
            return {
                width: '100%',
                marginLeft: 0,
                [`& > .${$5b4cb71c8460708a$var$_gridLegacyClasses.default.item}`]: {
                    paddingLeft: 0
                }
            };
        });
    }
    return styles;
}
function $5b4cb71c8460708a$var$resolveSpacingStyles(spacing, breakpoints, styles = {}) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') return [
        styles[`spacing-xs-${String(spacing)}`]
    ];
    // in case of object `spacing`
    const spacingStyles = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) spacingStyles.push(styles[`spacing-${breakpoint}-${String(value)}`]);
    });
    return spacingStyles;
}
// Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
const $5b4cb71c8460708a$var$GridLegacyRoot = (0, $5b4cb71c8460708a$var$_styled.default)('div', {
    name: 'MuiGridLegacy',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
        let spacingStyles = [];
        // in case of grid item
        if (container) spacingStyles = $5b4cb71c8460708a$var$resolveSpacingStyles(spacing, breakpoints, styles);
        const breakpointsStyles = [];
        breakpoints.forEach((breakpoint)=>{
            const value = ownerState[breakpoint];
            if (value) breakpointsStyles.push(styles[`grid-${breakpoint}-${String(value)}`]);
        });
        return [
            styles.root,
            container && styles.container,
            item && styles.item,
            zeroMinWidth && styles.zeroMinWidth,
            ...spacingStyles,
            direction !== 'row' && styles[`direction-xs-${String(direction)}`],
            wrap !== 'wrap' && styles[`wrap-xs-${String(wrap)}`],
            ...breakpointsStyles
        ];
    }
})(// FIXME(romgrk): Can't use memoTheme here
({ ownerState: ownerState })=>({
        boxSizing: 'border-box',
        ...ownerState.container && {
            display: 'flex',
            flexWrap: 'wrap',
            width: '100%'
        },
        ...ownerState.item && {
            margin: 0 // For instance, it's useful when used with a `figure` element.
        },
        ...ownerState.zeroMinWidth && {
            minWidth: 0
        },
        ...ownerState.wrap !== 'wrap' && {
            flexWrap: ownerState.wrap
        }
    }), $5b4cb71c8460708a$var$generateDirection, $5b4cb71c8460708a$var$generateRowGap, $5b4cb71c8460708a$var$generateColumnGap, $5b4cb71c8460708a$var$generateGridLegacy);
function $5b4cb71c8460708a$var$resolveSpacingClasses(spacing, breakpoints) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') return [
        `spacing-xs-${String(spacing)}`
    ];
    // in case of object `spacing`
    const classes = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) {
            const className = `spacing-${breakpoint}-${String(value)}`;
            classes.push(className);
        }
    });
    return classes;
}
const $5b4cb71c8460708a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
    let spacingClasses = [];
    // in case of grid item
    if (container) spacingClasses = $5b4cb71c8460708a$var$resolveSpacingClasses(spacing, breakpoints);
    const breakpointsClasses = [];
    breakpoints.forEach((breakpoint)=>{
        const value = ownerState[breakpoint];
        if (value) breakpointsClasses.push(`grid-${breakpoint}-${String(value)}`);
    });
    const slots = {
        root: [
            'root',
            container && 'container',
            item && 'item',
            zeroMinWidth && 'zeroMinWidth',
            ...spacingClasses,
            direction !== 'row' && `direction-xs-${String(direction)}`,
            wrap !== 'wrap' && `wrap-xs-${String(wrap)}`,
            ...breakpointsClasses
        ]
    };
    return (0, $5b4cb71c8460708a$var$_composeClasses.default)(slots, $5b4cb71c8460708a$var$_gridLegacyClasses.getGridLegacyUtilityClass, classes);
};
/**
 * @deprecated Use the [`Grid`](https://mui.com/material-ui/react-grid/) component instead.
 */ const $5b4cb71c8460708a$var$GridLegacy = /*#__PURE__*/ $5b4cb71c8460708a$var$React.forwardRef(function GridLegacy(inProps, ref) {
    const themeProps = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiGridLegacy'
    });
    const { breakpoints: breakpoints } = (0, $5b4cb71c8460708a$var$_useTheme.default)();
    const props = (0, $l6FST.extendSxProp)(themeProps);
    const { className: className, columns: columnsProp, columnSpacing: columnSpacingProp, component: component = 'div', container: container = false, direction: direction = 'row', item: item = false, rowSpacing: rowSpacingProp, spacing: spacing = 0, wrap: wrap = 'wrap', zeroMinWidth: zeroMinWidth = false, ...other } = props;
    $5b4cb71c8460708a$var$React.useEffect(()=>{
        $5b4cb71c8460708a$var$warnAboutDeprecatedGridLegacy();
    }, []);
    const rowSpacing = rowSpacingProp || spacing;
    const columnSpacing = columnSpacingProp || spacing;
    const columnsContext = $5b4cb71c8460708a$var$React.useContext($5b4cb71c8460708a$var$_GridLegacyContext.default);
    // columns set with default breakpoint unit of 12
    const columns = container ? columnsProp || 12 : columnsContext;
    const breakpointsValues = {};
    const otherFiltered = {
        ...other
    };
    breakpoints.keys.forEach((breakpoint)=>{
        if (other[breakpoint] != null) {
            breakpointsValues[breakpoint] = other[breakpoint];
            delete otherFiltered[breakpoint];
        }
    });
    const ownerState = {
        ...props,
        columns: columns,
        container: container,
        direction: direction,
        item: item,
        rowSpacing: rowSpacing,
        columnSpacing: columnSpacing,
        wrap: wrap,
        zeroMinWidth: zeroMinWidth,
        spacing: spacing,
        ...breakpointsValues,
        breakpoints: breakpoints.keys
    };
    const classes = $5b4cb71c8460708a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5b4cb71c8460708a$var$_GridLegacyContext.default.Provider, {
        value: columns,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($5b4cb71c8460708a$var$GridLegacyRoot, {
            ownerState: ownerState,
            className: (0, $5b4cb71c8460708a$var$_clsx.default)(classes.root, className),
            as: component,
            ref: ref,
            ...otherFiltered
        })
    });
});
$5b4cb71c8460708a$var$GridLegacy.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: $5b4cb71c8460708a$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $5b4cb71c8460708a$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $5b4cb71c8460708a$var$_propTypes.default.string,
    /**
   * The number of columns.
   * @default 12
   */ columns: $5b4cb71c8460708a$var$_propTypes.default.oneOfType([
        $5b4cb71c8460708a$var$_propTypes.default.arrayOf($5b4cb71c8460708a$var$_propTypes.default.number),
        $5b4cb71c8460708a$var$_propTypes.default.number,
        $5b4cb71c8460708a$var$_propTypes.default.object
    ]),
    /**
   * Defines the horizontal space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */ columnSpacing: $5b4cb71c8460708a$var$_propTypes.default.oneOfType([
        $5b4cb71c8460708a$var$_propTypes.default.arrayOf($5b4cb71c8460708a$var$_propTypes.default.oneOfType([
            $5b4cb71c8460708a$var$_propTypes.default.number,
            $5b4cb71c8460708a$var$_propTypes.default.string
        ])),
        $5b4cb71c8460708a$var$_propTypes.default.number,
        $5b4cb71c8460708a$var$_propTypes.default.object,
        $5b4cb71c8460708a$var$_propTypes.default.string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $5b4cb71c8460708a$var$_propTypes.default.elementType,
    /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */ container: $5b4cb71c8460708a$var$_propTypes.default.bool,
    /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'row'
   */ direction: $5b4cb71c8460708a$var$_propTypes.default.oneOfType([
        $5b4cb71c8460708a$var$_propTypes.default.oneOf([
            'column-reverse',
            'column',
            'row-reverse',
            'row'
        ]),
        $5b4cb71c8460708a$var$_propTypes.default.arrayOf($5b4cb71c8460708a$var$_propTypes.default.oneOf([
            'column-reverse',
            'column',
            'row-reverse',
            'row'
        ])),
        $5b4cb71c8460708a$var$_propTypes.default.object
    ]),
    /**
   * If `true`, the component will have the flex *item* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */ item: $5b4cb71c8460708a$var$_propTypes.default.bool,
    /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `lg` breakpoint and wider screens if not overridden.
   * @default false
   */ lg: $5b4cb71c8460708a$var$_propTypes.default.oneOfType([
        $5b4cb71c8460708a$var$_propTypes.default.oneOf([
            'auto'
        ]),
        $5b4cb71c8460708a$var$_propTypes.default.number,
        $5b4cb71c8460708a$var$_propTypes.default.bool
    ]),
    /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `md` breakpoint and wider screens if not overridden.
   * @default false
   */ md: $5b4cb71c8460708a$var$_propTypes.default.oneOfType([
        $5b4cb71c8460708a$var$_propTypes.default.oneOf([
            'auto'
        ]),
        $5b4cb71c8460708a$var$_propTypes.default.number,
        $5b4cb71c8460708a$var$_propTypes.default.bool
    ]),
    /**
   * Defines the vertical space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */ rowSpacing: $5b4cb71c8460708a$var$_propTypes.default.oneOfType([
        $5b4cb71c8460708a$var$_propTypes.default.arrayOf($5b4cb71c8460708a$var$_propTypes.default.oneOfType([
            $5b4cb71c8460708a$var$_propTypes.default.number,
            $5b4cb71c8460708a$var$_propTypes.default.string
        ])),
        $5b4cb71c8460708a$var$_propTypes.default.number,
        $5b4cb71c8460708a$var$_propTypes.default.object,
        $5b4cb71c8460708a$var$_propTypes.default.string
    ]),
    /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `sm` breakpoint and wider screens if not overridden.
   * @default false
   */ sm: $5b4cb71c8460708a$var$_propTypes.default.oneOfType([
        $5b4cb71c8460708a$var$_propTypes.default.oneOf([
            'auto'
        ]),
        $5b4cb71c8460708a$var$_propTypes.default.number,
        $5b4cb71c8460708a$var$_propTypes.default.bool
    ]),
    /**
   * Defines the space between the type `item` components.
   * It can only be used on a type `container` component.
   * @default 0
   */ spacing: $5b4cb71c8460708a$var$_propTypes.default.oneOfType([
        $5b4cb71c8460708a$var$_propTypes.default.arrayOf($5b4cb71c8460708a$var$_propTypes.default.oneOfType([
            $5b4cb71c8460708a$var$_propTypes.default.number,
            $5b4cb71c8460708a$var$_propTypes.default.string
        ])),
        $5b4cb71c8460708a$var$_propTypes.default.number,
        $5b4cb71c8460708a$var$_propTypes.default.object,
        $5b4cb71c8460708a$var$_propTypes.default.string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $5b4cb71c8460708a$var$_propTypes.default.oneOfType([
        $5b4cb71c8460708a$var$_propTypes.default.arrayOf($5b4cb71c8460708a$var$_propTypes.default.oneOfType([
            $5b4cb71c8460708a$var$_propTypes.default.func,
            $5b4cb71c8460708a$var$_propTypes.default.object,
            $5b4cb71c8460708a$var$_propTypes.default.bool
        ])),
        $5b4cb71c8460708a$var$_propTypes.default.func,
        $5b4cb71c8460708a$var$_propTypes.default.object
    ]),
    /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   * @default 'wrap'
   */ wrap: $5b4cb71c8460708a$var$_propTypes.default.oneOf([
        'nowrap',
        'wrap-reverse',
        'wrap'
    ]),
    /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `xl` breakpoint and wider screens if not overridden.
   * @default false
   */ xl: $5b4cb71c8460708a$var$_propTypes.default.oneOfType([
        $5b4cb71c8460708a$var$_propTypes.default.oneOf([
            'auto'
        ]),
        $5b4cb71c8460708a$var$_propTypes.default.number,
        $5b4cb71c8460708a$var$_propTypes.default.bool
    ]),
    /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for all the screen sizes with the lowest priority.
   * @default false
   */ xs: $5b4cb71c8460708a$var$_propTypes.default.oneOfType([
        $5b4cb71c8460708a$var$_propTypes.default.oneOf([
            'auto'
        ]),
        $5b4cb71c8460708a$var$_propTypes.default.number,
        $5b4cb71c8460708a$var$_propTypes.default.bool
    ]),
    /**
   * If `true`, it sets `min-width: 0` on the item.
   * Refer to the limitations section of the documentation to better understand the use case.
   * @default false
   */ zeroMinWidth: $5b4cb71c8460708a$var$_propTypes.default.bool
};
{
    const requireProp = (0, $5b4cb71c8460708a$var$_requirePropFactory.default)('GridLegacy', $5b4cb71c8460708a$var$GridLegacy);
    // eslint-disable-next-line no-useless-concat
    $5b4cb71c8460708a$var$GridLegacy["propTypes"] = {
        // eslint-disable-next-line react/forbid-foreign-prop-types
        ...$5b4cb71c8460708a$var$GridLegacy.propTypes,
        direction: requireProp('container'),
        lg: requireProp('item'),
        md: requireProp('item'),
        sm: requireProp('item'),
        spacing: requireProp('container'),
        wrap: requireProp('container'),
        xs: requireProp('item'),
        zeroMinWidth: requireProp('item')
    };
}var $5b4cb71c8460708a$var$_default = module.exports.default = $5b4cb71c8460708a$var$GridLegacy;

});
parcelRegister("8961s", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $5ee3d5f3a806867c$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5ee3d5f3a806867c$var$React = $5ee3d5f3a806867c$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * @ignore - internal component.
 */ const $5ee3d5f3a806867c$var$GridLegacyContext = /*#__PURE__*/ $5ee3d5f3a806867c$var$React.createContext();
$5ee3d5f3a806867c$var$GridLegacyContext.displayName = 'GridLegacyContext';
var $5ee3d5f3a806867c$var$_default = module.exports.default = $5ee3d5f3a806867c$var$GridLegacyContext;

});

parcelRegister("6qE3E", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $4ae43e742e38e040$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getGridLegacyUtilityClass = $4ae43e742e38e040$var$getGridLegacyUtilityClass;

var $4ae43e742e38e040$var$_generateUtilityClasses = $4ae43e742e38e040$require$_interopRequireDefault((parcelRequire("5nY49")));

var $4ae43e742e38e040$var$_generateUtilityClass = $4ae43e742e38e040$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $4ae43e742e38e040$var$getGridLegacyUtilityClass(slot) {
    return (0, $4ae43e742e38e040$var$_generateUtilityClass.default)('MuiGridLegacy', slot);
}
const $4ae43e742e38e040$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $4ae43e742e38e040$var$DIRECTIONS = [
    'column-reverse',
    'column',
    'row-reverse',
    'row'
];
const $4ae43e742e38e040$var$WRAPS = [
    'nowrap',
    'wrap-reverse',
    'wrap'
];
const $4ae43e742e38e040$var$GRID_SIZES = [
    'auto',
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $4ae43e742e38e040$var$gridClasses = (0, $4ae43e742e38e040$var$_generateUtilityClasses.default)('MuiGridLegacy', [
    'root',
    'container',
    'item',
    'zeroMinWidth',
    // spacings
    ...$4ae43e742e38e040$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...$4ae43e742e38e040$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...$4ae43e742e38e040$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...$4ae43e742e38e040$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$4ae43e742e38e040$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$4ae43e742e38e040$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$4ae43e742e38e040$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$4ae43e742e38e040$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $4ae43e742e38e040$var$_default = module.exports.default = $4ae43e742e38e040$var$gridClasses;

});



parcelRegister("7Zchb", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $5d07c0b3a49e1daf$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $5d07c0b3a49e1daf$var$_exportNames = {
    gridClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $5d07c0b3a49e1daf$var$_Grid.default;
    }
});
Object.defineProperty(module.exports, "gridClasses", {
    enumerable: true,
    get: function() {
        return $5d07c0b3a49e1daf$var$_gridClasses.default;
    }
});

var $5d07c0b3a49e1daf$var$_Grid = $5d07c0b3a49e1daf$require$_interopRequireWildcard((parcelRequire("cJu23")));
Object.keys($5d07c0b3a49e1daf$var$_Grid).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($5d07c0b3a49e1daf$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $5d07c0b3a49e1daf$var$_Grid[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5d07c0b3a49e1daf$var$_Grid[key];
        }
    });
});

var $5d07c0b3a49e1daf$var$_gridClasses = $5d07c0b3a49e1daf$require$_interopRequireWildcard((parcelRequire("kTnYy")));
Object.keys($5d07c0b3a49e1daf$var$_gridClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($5d07c0b3a49e1daf$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $5d07c0b3a49e1daf$var$_gridClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5d07c0b3a49e1daf$var$_gridClasses[key];
        }
    });
});

});
parcelRegister("cJu23", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $9450fbc34cc5b2ea$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9450fbc34cc5b2ea$var$_propTypes = $9450fbc34cc5b2ea$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $gxueG = parcelRequire("gxueG");

var $9450fbc34cc5b2ea$var$_requirePropFactory = $9450fbc34cc5b2ea$require$_interopRequireDefault((parcelRequire("3VqP0")));

var $8xDHs = parcelRequire("8xDHs");

var $hL1nr = parcelRequire("hL1nr");

var $9450fbc34cc5b2ea$var$_useTheme = $9450fbc34cc5b2ea$require$_interopRequireDefault((parcelRequire("14H9o")));
/**
 *
 * Demos:
 *
 * - [Grid](https://v7.mui.com/material-ui/react-grid/)
 *
 * API:
 *
 * - [Grid API](https://v7.mui.com/material-ui/api/grid/)
 */ const $9450fbc34cc5b2ea$var$Grid = (0, $gxueG.createGrid)({
    createStyledComponent: (0, $8xDHs.styled)('div', {
        name: 'MuiGrid',
        slot: 'Root',
        overridesResolver: (props, styles)=>{
            const { ownerState: ownerState } = props;
            return [
                styles.root,
                ownerState.container && styles.container
            ];
        }
    }),
    componentName: 'MuiGrid',
    useThemeProps: (inProps)=>(0, $hL1nr.useDefaultProps)({
            props: inProps,
            name: 'MuiGrid'
        }),
    useTheme: $9450fbc34cc5b2ea$var$_useTheme.default
});
$9450fbc34cc5b2ea$var$Grid.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: $9450fbc34cc5b2ea$var$_propTypes.default.node,
    /**
   * The number of columns.
   * @default 12
   */ columns: $9450fbc34cc5b2ea$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $9450fbc34cc5b2ea$var$_propTypes.default.arrayOf($9450fbc34cc5b2ea$var$_propTypes.default.number),
        $9450fbc34cc5b2ea$var$_propTypes.default.number,
        $9450fbc34cc5b2ea$var$_propTypes.default.object
    ]),
    /**
   * Defines the horizontal space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */ columnSpacing: $9450fbc34cc5b2ea$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $9450fbc34cc5b2ea$var$_propTypes.default.arrayOf($9450fbc34cc5b2ea$var$_propTypes.default.oneOfType([
            $9450fbc34cc5b2ea$var$_propTypes.default.number,
            $9450fbc34cc5b2ea$var$_propTypes.default.string
        ])),
        $9450fbc34cc5b2ea$var$_propTypes.default.number,
        $9450fbc34cc5b2ea$var$_propTypes.default.object,
        $9450fbc34cc5b2ea$var$_propTypes.default.string
    ]),
    /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */ container: $9450fbc34cc5b2ea$var$_propTypes.default.bool,
    /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'row'
   */ direction: $9450fbc34cc5b2ea$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $9450fbc34cc5b2ea$var$_propTypes.default.oneOf([
            'column-reverse',
            'column',
            'row-reverse',
            'row'
        ]),
        $9450fbc34cc5b2ea$var$_propTypes.default.arrayOf($9450fbc34cc5b2ea$var$_propTypes.default.oneOf([
            'column-reverse',
            'column',
            'row-reverse',
            'row'
        ])),
        $9450fbc34cc5b2ea$var$_propTypes.default.object
    ]),
    /**
   * Defines the offset value for the type `item` components.
   */ offset: $9450fbc34cc5b2ea$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $9450fbc34cc5b2ea$var$_propTypes.default.string,
        $9450fbc34cc5b2ea$var$_propTypes.default.number,
        $9450fbc34cc5b2ea$var$_propTypes.default.arrayOf($9450fbc34cc5b2ea$var$_propTypes.default.oneOfType([
            $9450fbc34cc5b2ea$var$_propTypes.default.string,
            $9450fbc34cc5b2ea$var$_propTypes.default.number
        ])),
        $9450fbc34cc5b2ea$var$_propTypes.default.object
    ]),
    /**
   * Defines the vertical space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */ rowSpacing: $9450fbc34cc5b2ea$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $9450fbc34cc5b2ea$var$_propTypes.default.arrayOf($9450fbc34cc5b2ea$var$_propTypes.default.oneOfType([
            $9450fbc34cc5b2ea$var$_propTypes.default.number,
            $9450fbc34cc5b2ea$var$_propTypes.default.string
        ])),
        $9450fbc34cc5b2ea$var$_propTypes.default.number,
        $9450fbc34cc5b2ea$var$_propTypes.default.object,
        $9450fbc34cc5b2ea$var$_propTypes.default.string
    ]),
    /**
   * Defines the size of the the type `item` components.
   */ size: $9450fbc34cc5b2ea$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $9450fbc34cc5b2ea$var$_propTypes.default.string,
        $9450fbc34cc5b2ea$var$_propTypes.default.bool,
        $9450fbc34cc5b2ea$var$_propTypes.default.number,
        $9450fbc34cc5b2ea$var$_propTypes.default.arrayOf($9450fbc34cc5b2ea$var$_propTypes.default.oneOfType([
            $9450fbc34cc5b2ea$var$_propTypes.default.string,
            $9450fbc34cc5b2ea$var$_propTypes.default.bool,
            $9450fbc34cc5b2ea$var$_propTypes.default.number
        ])),
        $9450fbc34cc5b2ea$var$_propTypes.default.object
    ]),
    /**
   * Defines the space between the type `item` components.
   * It can only be used on a type `container` component.
   * @default 0
   */ spacing: $9450fbc34cc5b2ea$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $9450fbc34cc5b2ea$var$_propTypes.default.arrayOf($9450fbc34cc5b2ea$var$_propTypes.default.oneOfType([
            $9450fbc34cc5b2ea$var$_propTypes.default.number,
            $9450fbc34cc5b2ea$var$_propTypes.default.string
        ])),
        $9450fbc34cc5b2ea$var$_propTypes.default.number,
        $9450fbc34cc5b2ea$var$_propTypes.default.object,
        $9450fbc34cc5b2ea$var$_propTypes.default.string
    ]),
    /**
   * @ignore
   */ sx: $9450fbc34cc5b2ea$var$_propTypes.default.oneOfType([
        $9450fbc34cc5b2ea$var$_propTypes.default.arrayOf($9450fbc34cc5b2ea$var$_propTypes.default.oneOfType([
            $9450fbc34cc5b2ea$var$_propTypes.default.func,
            $9450fbc34cc5b2ea$var$_propTypes.default.object,
            $9450fbc34cc5b2ea$var$_propTypes.default.bool
        ])),
        $9450fbc34cc5b2ea$var$_propTypes.default.func,
        $9450fbc34cc5b2ea$var$_propTypes.default.object
    ]),
    /**
   * @internal
   * The level of the grid starts from `0` and increases when the grid nests
   * inside another grid. Nesting is defined as a container Grid being a direct
   * child of a container Grid.
   *
   * ```js
   * <Grid container> // level 0
   *   <Grid container> // level 1
   *     <Grid container> // level 2
   * ```
   *
   * Only consecutive grid is considered nesting. A grid container will start at
   * `0` if there are non-Grid container element above it.
   *
   * ```js
   * <Grid container> // level 0
   *   <div>
   *     <Grid container> // level 0
   * ```
   *
   * ```js
   * <Grid container> // level 0
   *   <Grid>
   *     <Grid container> // level 0
   * ```
   */ unstable_level: $9450fbc34cc5b2ea$var$_propTypes.default.number,
    /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   * @default 'wrap'
   */ wrap: $9450fbc34cc5b2ea$var$_propTypes.default.oneOf([
        'nowrap',
        'wrap-reverse',
        'wrap'
    ])
};
{
    const Component = $9450fbc34cc5b2ea$var$Grid;
    const requireProp = (0, $9450fbc34cc5b2ea$var$_requirePropFactory.default)('Grid', Component);
    // eslint-disable-next-line no-useless-concat
    Component["propTypes"] = {
        // eslint-disable-next-line react/forbid-foreign-prop-types
        ...Component.propTypes,
        direction: requireProp('container'),
        spacing: requireProp('container'),
        wrap: requireProp('container')
    };
}var $9450fbc34cc5b2ea$var$_default = module.exports.default = $9450fbc34cc5b2ea$var$Grid;

});

parcelRegister("kTnYy", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f35b8acab3fc2f62$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getGridUtilityClass = $f35b8acab3fc2f62$var$getGridUtilityClass;

var $f35b8acab3fc2f62$var$_generateUtilityClasses = $f35b8acab3fc2f62$require$_interopRequireDefault((parcelRequire("5nY49")));

var $f35b8acab3fc2f62$var$_generateUtilityClass = $f35b8acab3fc2f62$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $f35b8acab3fc2f62$var$getGridUtilityClass(slot) {
    return (0, $f35b8acab3fc2f62$var$_generateUtilityClass.default)('MuiGrid', slot);
}
const $f35b8acab3fc2f62$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $f35b8acab3fc2f62$var$DIRECTIONS = [
    'column-reverse',
    'column',
    'row-reverse',
    'row'
];
const $f35b8acab3fc2f62$var$WRAPS = [
    'nowrap',
    'wrap-reverse',
    'wrap'
];
const $f35b8acab3fc2f62$var$GRID_SIZES = [
    'auto',
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $f35b8acab3fc2f62$var$gridClasses = (0, $f35b8acab3fc2f62$var$_generateUtilityClasses.default)('MuiGrid', [
    'root',
    'container',
    // spacings
    ...$f35b8acab3fc2f62$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...$f35b8acab3fc2f62$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...$f35b8acab3fc2f62$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $f35b8acab3fc2f62$var$_default = module.exports.default = $f35b8acab3fc2f62$var$gridClasses;

});


parcelRegister("3IKLG", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $2b59c24f9f8bf5b3$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $2b59c24f9f8bf5b3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $2b59c24f9f8bf5b3$var$_exportNames = {
    iconClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $2b59c24f9f8bf5b3$var$_Icon.default;
    }
});
Object.defineProperty(module.exports, "iconClasses", {
    enumerable: true,
    get: function() {
        return $2b59c24f9f8bf5b3$var$_iconClasses.default;
    }
});

var $2b59c24f9f8bf5b3$var$_Icon = $2b59c24f9f8bf5b3$require$_interopRequireDefault((parcelRequire("cGE4z")));

var $2b59c24f9f8bf5b3$var$_iconClasses = $2b59c24f9f8bf5b3$require$_interopRequireWildcard((parcelRequire("8vYwX")));
Object.keys($2b59c24f9f8bf5b3$var$_iconClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2b59c24f9f8bf5b3$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $2b59c24f9f8bf5b3$var$_iconClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2b59c24f9f8bf5b3$var$_iconClasses[key];
        }
    });
});

});
parcelRegister("cGE4z", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $93c87ddcceadf9a1$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $93c87ddcceadf9a1$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $93c87ddcceadf9a1$var$React = $93c87ddcceadf9a1$require$_interopRequireWildcard((parcelRequire("acw62")));

var $93c87ddcceadf9a1$var$_propTypes = $93c87ddcceadf9a1$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $93c87ddcceadf9a1$var$_clsx = $93c87ddcceadf9a1$require$_interopRequireDefault((parcelRequire("9QePP")));

var $93c87ddcceadf9a1$var$_composeClasses = $93c87ddcceadf9a1$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $93c87ddcceadf9a1$var$_capitalize = $93c87ddcceadf9a1$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $aAbgT = parcelRequire("aAbgT");

var $93c87ddcceadf9a1$var$_memoTheme = $93c87ddcceadf9a1$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $93c87ddcceadf9a1$var$_createSimplePaletteValueFilter = $93c87ddcceadf9a1$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $hL1nr = parcelRequire("hL1nr");

var $8vYwX = parcelRequire("8vYwX");

var $ayMG0 = parcelRequire("ayMG0");
const $93c87ddcceadf9a1$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $93c87ddcceadf9a1$var$_capitalize.default)(color)}`,
            `fontSize${(0, $93c87ddcceadf9a1$var$_capitalize.default)(fontSize)}`
        ]
    };
    return (0, $93c87ddcceadf9a1$var$_composeClasses.default)(slots, $8vYwX.getIconUtilityClass, classes);
};
const $93c87ddcceadf9a1$var$IconRoot = (0, $aAbgT.styled)('span', {
    name: 'MuiIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $93c87ddcceadf9a1$var$_capitalize.default)(ownerState.color)}`],
            styles[`fontSize${(0, $93c87ddcceadf9a1$var$_capitalize.default)(ownerState.fontSize)}`]
        ];
    }
})((0, $93c87ddcceadf9a1$var$_memoTheme.default)(({ theme: theme })=>({
        userSelect: 'none',
        width: '1em',
        height: '1em',
        // Chrome fix for https://issues.chromium.org/issues/41375697
        // To remove at some point.
        overflow: 'hidden',
        display: 'inline-block',
        // allow overflow hidden to take action
        textAlign: 'center',
        // support non-square icon
        flexShrink: 0,
        variants: [
            {
                props: {
                    fontSize: 'inherit'
                },
                style: {
                    fontSize: 'inherit'
                }
            },
            {
                props: {
                    fontSize: 'small'
                },
                style: {
                    fontSize: theme.typography.pxToRem(20)
                }
            },
            {
                props: {
                    fontSize: 'medium'
                },
                style: {
                    fontSize: theme.typography.pxToRem(24)
                }
            },
            {
                props: {
                    fontSize: 'large'
                },
                style: {
                    fontSize: theme.typography.pxToRem(36)
                }
            },
            {
                props: {
                    color: 'action'
                },
                style: {
                    color: (theme.vars || theme).palette.action.active
                }
            },
            {
                props: {
                    color: 'disabled'
                },
                style: {
                    color: (theme.vars || theme).palette.action.disabled
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: undefined
                }
            },
            ...Object.entries(theme.palette).filter((0, $93c87ddcceadf9a1$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                }))
        ]
    })));
const $93c87ddcceadf9a1$var$Icon = /*#__PURE__*/ $93c87ddcceadf9a1$var$React.forwardRef(function Icon(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiIcon'
    });
    const { baseClassName: baseClassName = 'material-icons', className: className, color: color = 'inherit', component: Component = 'span', fontSize: fontSize = 'medium', ...other } = props;
    const ownerState = {
        ...props,
        baseClassName: baseClassName,
        color: color,
        component: Component,
        fontSize: fontSize
    };
    const classes = $93c87ddcceadf9a1$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($93c87ddcceadf9a1$var$IconRoot, {
        as: Component,
        className: (0, $93c87ddcceadf9a1$var$_clsx.default)(baseClassName, // Prevent the translation of the text content.
        // The font relies on the exact text content to render the icon.
        'notranslate', classes.root, className),
        ownerState: ownerState,
        "aria-hidden": true,
        ref: ref,
        ...other
    });
});
$93c87ddcceadf9a1$var$Icon.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The base class applied to the icon. Defaults to 'material-icons', but can be changed to any
   * other base class that suits the icon font you're using (for example material-icons-rounded, fas, etc).
   * @default 'material-icons'
   */ baseClassName: $93c87ddcceadf9a1$var$_propTypes.default.string,
    /**
   * The name of the icon font ligature.
   */ children: $93c87ddcceadf9a1$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $93c87ddcceadf9a1$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $93c87ddcceadf9a1$var$_propTypes.default.string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'inherit'
   */ color: $93c87ddcceadf9a1$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $93c87ddcceadf9a1$var$_propTypes.default.oneOf([
            'inherit',
            'action',
            'disabled',
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning'
        ]),
        $93c87ddcceadf9a1$var$_propTypes.default.string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $93c87ddcceadf9a1$var$_propTypes.default.elementType,
    /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */ fontSize: $93c87ddcceadf9a1$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $93c87ddcceadf9a1$var$_propTypes.default.oneOf([
            'inherit',
            'large',
            'medium',
            'small'
        ]),
        $93c87ddcceadf9a1$var$_propTypes.default.string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $93c87ddcceadf9a1$var$_propTypes.default.oneOfType([
        $93c87ddcceadf9a1$var$_propTypes.default.arrayOf($93c87ddcceadf9a1$var$_propTypes.default.oneOfType([
            $93c87ddcceadf9a1$var$_propTypes.default.func,
            $93c87ddcceadf9a1$var$_propTypes.default.object,
            $93c87ddcceadf9a1$var$_propTypes.default.bool
        ])),
        $93c87ddcceadf9a1$var$_propTypes.default.func,
        $93c87ddcceadf9a1$var$_propTypes.default.object
    ])
};
$93c87ddcceadf9a1$var$Icon.muiName = 'Icon';
var $93c87ddcceadf9a1$var$_default = module.exports.default = $93c87ddcceadf9a1$var$Icon;

});
parcelRegister("8vYwX", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $63302c123a5539bd$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getIconUtilityClass = $63302c123a5539bd$var$getIconUtilityClass;

var $63302c123a5539bd$var$_generateUtilityClasses = $63302c123a5539bd$require$_interopRequireDefault((parcelRequire("5nY49")));

var $63302c123a5539bd$var$_generateUtilityClass = $63302c123a5539bd$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $63302c123a5539bd$var$getIconUtilityClass(slot) {
    return (0, $63302c123a5539bd$var$_generateUtilityClass.default)('MuiIcon', slot);
}
const $63302c123a5539bd$var$iconClasses = (0, $63302c123a5539bd$var$_generateUtilityClasses.default)('MuiIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $63302c123a5539bd$var$_default = module.exports.default = $63302c123a5539bd$var$iconClasses;

});



parcelRegister("dGTe0", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $9f7a092074edd6d0$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $9f7a092074edd6d0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $9f7a092074edd6d0$var$_exportNames = {
    imageListClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9f7a092074edd6d0$var$_ImageList.default;
    }
});
Object.defineProperty(module.exports, "imageListClasses", {
    enumerable: true,
    get: function() {
        return $9f7a092074edd6d0$var$_imageListClasses.default;
    }
});

var $9f7a092074edd6d0$var$_ImageList = $9f7a092074edd6d0$require$_interopRequireDefault((parcelRequire("cZDSl")));

var $9f7a092074edd6d0$var$_imageListClasses = $9f7a092074edd6d0$require$_interopRequireWildcard((parcelRequire("cqVjf")));
Object.keys($9f7a092074edd6d0$var$_imageListClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($9f7a092074edd6d0$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $9f7a092074edd6d0$var$_imageListClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9f7a092074edd6d0$var$_imageListClasses[key];
        }
    });
});

});
parcelRegister("cZDSl", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $975a1cffa46f382b$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $975a1cffa46f382b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $975a1cffa46f382b$var$_composeClasses = $975a1cffa46f382b$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $975a1cffa46f382b$var$_integerPropType = $975a1cffa46f382b$require$_interopRequireDefault((parcelRequire("cxaSP")));

var $975a1cffa46f382b$var$_clsx = $975a1cffa46f382b$require$_interopRequireDefault((parcelRequire("9QePP")));

var $975a1cffa46f382b$var$_propTypes = $975a1cffa46f382b$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $975a1cffa46f382b$var$React = $975a1cffa46f382b$require$_interopRequireWildcard((parcelRequire("acw62")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $cqVjf = parcelRequire("cqVjf");

var $975a1cffa46f382b$var$_ImageListContext = $975a1cffa46f382b$require$_interopRequireDefault((parcelRequire("d1nkD")));

var $ayMG0 = parcelRequire("ayMG0");
const $975a1cffa46f382b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant
        ]
    };
    return (0, $975a1cffa46f382b$var$_composeClasses.default)(slots, $cqVjf.getImageListUtilityClass, classes);
};
const $975a1cffa46f382b$var$ImageListRoot = (0, $aAbgT.styled)('ul', {
    name: 'MuiImageList',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant]
        ];
    }
})({
    display: 'grid',
    overflowY: 'auto',
    listStyle: 'none',
    padding: 0,
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch',
    variants: [
        {
            props: {
                variant: 'masonry'
            },
            style: {
                display: 'block'
            }
        }
    ]
});
const $975a1cffa46f382b$var$ImageList = /*#__PURE__*/ $975a1cffa46f382b$var$React.forwardRef(function ImageList(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiImageList'
    });
    const { children: children, className: className, cols: cols = 2, component: component = 'ul', rowHeight: rowHeight = 'auto', gap: gap = 4, style: styleProp, variant: variant = 'standard', ...other } = props;
    const contextValue = $975a1cffa46f382b$var$React.useMemo(()=>({
            rowHeight: rowHeight,
            gap: gap,
            variant: variant
        }), [
        rowHeight,
        gap,
        variant
    ]);
    const style = variant === 'masonry' ? {
        columnCount: cols,
        columnGap: gap,
        ...styleProp
    } : {
        gridTemplateColumns: `repeat(${cols}, 1fr)`,
        gap: gap,
        ...styleProp
    };
    const ownerState = {
        ...props,
        component: component,
        gap: gap,
        rowHeight: rowHeight,
        variant: variant
    };
    const classes = $975a1cffa46f382b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($975a1cffa46f382b$var$ImageListRoot, {
        as: component,
        className: (0, $975a1cffa46f382b$var$_clsx.default)(classes.root, classes[variant], className),
        ref: ref,
        style: style,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($975a1cffa46f382b$var$_ImageListContext.default.Provider, {
            value: contextValue,
            children: children
        })
    });
});
$975a1cffa46f382b$var$ImageList.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component, normally `ImageListItem`s.
   */ children: $975a1cffa46f382b$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .node.isRequired,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $975a1cffa46f382b$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $975a1cffa46f382b$var$_propTypes.default.string,
    /**
   * Number of columns.
   * @default 2
   */ cols: $975a1cffa46f382b$var$_integerPropType.default,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $975a1cffa46f382b$var$_propTypes.default.elementType,
    /**
   * The gap between items in px.
   * @default 4
   */ gap: $975a1cffa46f382b$var$_propTypes.default.number,
    /**
   * The height of one row in px.
   * @default 'auto'
   */ rowHeight: $975a1cffa46f382b$var$_propTypes.default.oneOfType([
        $975a1cffa46f382b$var$_propTypes.default.oneOf([
            'auto'
        ]),
        $975a1cffa46f382b$var$_propTypes.default.number
    ]),
    /**
   * @ignore
   */ style: $975a1cffa46f382b$var$_propTypes.default.object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $975a1cffa46f382b$var$_propTypes.default.oneOfType([
        $975a1cffa46f382b$var$_propTypes.default.arrayOf($975a1cffa46f382b$var$_propTypes.default.oneOfType([
            $975a1cffa46f382b$var$_propTypes.default.func,
            $975a1cffa46f382b$var$_propTypes.default.object,
            $975a1cffa46f382b$var$_propTypes.default.bool
        ])),
        $975a1cffa46f382b$var$_propTypes.default.func,
        $975a1cffa46f382b$var$_propTypes.default.object
    ]),
    /**
   * The variant to use.
   * @default 'standard'
   */ variant: $975a1cffa46f382b$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $975a1cffa46f382b$var$_propTypes.default.oneOf([
            'masonry',
            'quilted',
            'standard',
            'woven'
        ]),
        $975a1cffa46f382b$var$_propTypes.default.string
    ])
};
var $975a1cffa46f382b$var$_default = module.exports.default = $975a1cffa46f382b$var$ImageList;

});
parcelRegister("cqVjf", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $90d45e39fe6c23d3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getImageListUtilityClass = $90d45e39fe6c23d3$var$getImageListUtilityClass;

var $90d45e39fe6c23d3$var$_generateUtilityClasses = $90d45e39fe6c23d3$require$_interopRequireDefault((parcelRequire("5nY49")));

var $90d45e39fe6c23d3$var$_generateUtilityClass = $90d45e39fe6c23d3$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $90d45e39fe6c23d3$var$getImageListUtilityClass(slot) {
    return (0, $90d45e39fe6c23d3$var$_generateUtilityClass.default)('MuiImageList', slot);
}
const $90d45e39fe6c23d3$var$imageListClasses = (0, $90d45e39fe6c23d3$var$_generateUtilityClasses.default)('MuiImageList', [
    'root',
    'masonry',
    'quilted',
    'standard',
    'woven'
]);
var $90d45e39fe6c23d3$var$_default = module.exports.default = $90d45e39fe6c23d3$var$imageListClasses;

});

parcelRegister("d1nkD", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $97ad778fce8cd0d8$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $97ad778fce8cd0d8$var$React = $97ad778fce8cd0d8$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */ const $97ad778fce8cd0d8$var$ImageListContext = /*#__PURE__*/ $97ad778fce8cd0d8$var$React.createContext({});
$97ad778fce8cd0d8$var$ImageListContext.displayName = 'ImageListContext';
var $97ad778fce8cd0d8$var$_default = module.exports.default = $97ad778fce8cd0d8$var$ImageListContext;

});



parcelRegister("cJR6h", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $9462e0a2246915d8$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $9462e0a2246915d8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $9462e0a2246915d8$var$_exportNames = {
    imageListItemClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9462e0a2246915d8$var$_ImageListItem.default;
    }
});
Object.defineProperty(module.exports, "imageListItemClasses", {
    enumerable: true,
    get: function() {
        return $9462e0a2246915d8$var$_imageListItemClasses.default;
    }
});

var $9462e0a2246915d8$var$_ImageListItem = $9462e0a2246915d8$require$_interopRequireDefault((parcelRequire("f0119")));

var $9462e0a2246915d8$var$_imageListItemClasses = $9462e0a2246915d8$require$_interopRequireWildcard((parcelRequire("4vKND")));
Object.keys($9462e0a2246915d8$var$_imageListItemClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($9462e0a2246915d8$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $9462e0a2246915d8$var$_imageListItemClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9462e0a2246915d8$var$_imageListItemClasses[key];
        }
    });
});

});
parcelRegister("f0119", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $aeb7a529fa95e8e4$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $aeb7a529fa95e8e4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aeb7a529fa95e8e4$var$_composeClasses = $aeb7a529fa95e8e4$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aeb7a529fa95e8e4$var$_integerPropType = $aeb7a529fa95e8e4$require$_interopRequireDefault((parcelRequire("cxaSP")));

var $aeb7a529fa95e8e4$var$_clsx = $aeb7a529fa95e8e4$require$_interopRequireDefault((parcelRequire("9QePP")));

var $aeb7a529fa95e8e4$var$_propTypes = $aeb7a529fa95e8e4$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $aeb7a529fa95e8e4$var$React = $aeb7a529fa95e8e4$require$_interopRequireWildcard((parcelRequire("acw62")));

var $4jPKB = parcelRequire("4jPKB");

var $aeb7a529fa95e8e4$var$_ImageListContext = $aeb7a529fa95e8e4$require$_interopRequireDefault((parcelRequire("d1nkD")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $aeb7a529fa95e8e4$var$_isMuiElement = $aeb7a529fa95e8e4$require$_interopRequireDefault((parcelRequire("cpXNi")));

var $aeb7a529fa95e8e4$var$_imageListItemClasses = $aeb7a529fa95e8e4$require$_interopRequireWildcard((parcelRequire("4vKND")));

var $ayMG0 = parcelRequire("ayMG0");
const $aeb7a529fa95e8e4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant
        ],
        img: [
            'img'
        ]
    };
    return (0, $aeb7a529fa95e8e4$var$_composeClasses.default)(slots, $aeb7a529fa95e8e4$var$_imageListItemClasses.getImageListItemUtilityClass, classes);
};
const $aeb7a529fa95e8e4$var$ImageListItemRoot = (0, $aAbgT.styled)('li', {
    name: 'MuiImageListItem',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${$aeb7a529fa95e8e4$var$_imageListItemClasses.default.img}`]: styles.img
            },
            styles.root,
            styles[ownerState.variant]
        ];
    }
})({
    display: 'block',
    position: 'relative',
    [`& .${$aeb7a529fa95e8e4$var$_imageListItemClasses.default.img}`]: {
        objectFit: 'cover',
        width: '100%',
        height: '100%',
        display: 'block'
    },
    variants: [
        {
            props: {
                variant: 'standard'
            },
            style: {
                // For titlebar under list item
                display: 'flex',
                flexDirection: 'column'
            }
        },
        {
            props: {
                variant: 'woven'
            },
            style: {
                height: '100%',
                alignSelf: 'center',
                '&:nth-of-type(even)': {
                    height: '70%'
                }
            }
        },
        {
            props: {
                variant: 'standard'
            },
            style: {
                [`& .${$aeb7a529fa95e8e4$var$_imageListItemClasses.default.img}`]: {
                    height: 'auto',
                    flexGrow: 1
                }
            }
        }
    ]
});
const $aeb7a529fa95e8e4$var$ImageListItem = /*#__PURE__*/ $aeb7a529fa95e8e4$var$React.forwardRef(function ImageListItem(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiImageListItem'
    });
    // TODO: - Use jsdoc @default?: "cols rows default values are for docs only"
    const { children: children, className: className, cols: cols = 1, component: component = 'li', rows: rows = 1, style: style, ...other } = props;
    const { rowHeight: rowHeight = 'auto', gap: gap, variant: variant } = $aeb7a529fa95e8e4$var$React.useContext($aeb7a529fa95e8e4$var$_ImageListContext.default);
    let height = 'auto';
    if (variant === 'woven') height = undefined;
    else if (rowHeight !== 'auto') height = rowHeight * rows + gap * (rows - 1);
    const ownerState = {
        ...props,
        cols: cols,
        component: component,
        gap: gap,
        rowHeight: rowHeight,
        rows: rows,
        variant: variant
    };
    const classes = $aeb7a529fa95e8e4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($aeb7a529fa95e8e4$var$ImageListItemRoot, {
        as: component,
        className: (0, $aeb7a529fa95e8e4$var$_clsx.default)(classes.root, classes[variant], className),
        ref: ref,
        style: {
            height: height,
            gridColumnEnd: variant !== 'masonry' ? `span ${cols}` : undefined,
            gridRowEnd: variant !== 'masonry' ? `span ${rows}` : undefined,
            marginBottom: variant === 'masonry' ? gap : undefined,
            breakInside: variant === 'masonry' ? 'avoid' : undefined,
            ...style
        },
        ownerState: ownerState,
        ...other,
        children: $aeb7a529fa95e8e4$var$React.Children.map(children, (child)=>{
            if (!/*#__PURE__*/ $aeb7a529fa95e8e4$var$React.isValidElement(child)) return null;
            if ((0, $4jPKB.isFragment)(child)) console.error([
                "MUI: The ImageListItem component doesn't accept a Fragment as a child.",
                'Consider providing an array instead.'
            ].join('\n'));
            if (child.type === 'img' || (0, $aeb7a529fa95e8e4$var$_isMuiElement.default)(child, [
                'Image'
            ])) return /*#__PURE__*/ $aeb7a529fa95e8e4$var$React.cloneElement(child, {
                className: (0, $aeb7a529fa95e8e4$var$_clsx.default)(classes.img, child.props.className)
            });
            return child;
        })
    });
});
$aeb7a529fa95e8e4$var$ImageListItem.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component, normally an `<img>`.
   */ children: $aeb7a529fa95e8e4$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $aeb7a529fa95e8e4$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $aeb7a529fa95e8e4$var$_propTypes.default.string,
    /**
   * Width of the item in number of grid columns.
   * @default 1
   */ cols: $aeb7a529fa95e8e4$var$_integerPropType.default,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $aeb7a529fa95e8e4$var$_propTypes.default.elementType,
    /**
   * Height of the item in number of grid rows.
   * @default 1
   */ rows: $aeb7a529fa95e8e4$var$_integerPropType.default,
    /**
   * @ignore
   */ style: $aeb7a529fa95e8e4$var$_propTypes.default.object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $aeb7a529fa95e8e4$var$_propTypes.default.oneOfType([
        $aeb7a529fa95e8e4$var$_propTypes.default.arrayOf($aeb7a529fa95e8e4$var$_propTypes.default.oneOfType([
            $aeb7a529fa95e8e4$var$_propTypes.default.func,
            $aeb7a529fa95e8e4$var$_propTypes.default.object,
            $aeb7a529fa95e8e4$var$_propTypes.default.bool
        ])),
        $aeb7a529fa95e8e4$var$_propTypes.default.func,
        $aeb7a529fa95e8e4$var$_propTypes.default.object
    ])
};
var $aeb7a529fa95e8e4$var$_default = module.exports.default = $aeb7a529fa95e8e4$var$ImageListItem;

});
parcelRegister("4vKND", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $348e5c185e9c1cc5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getImageListItemUtilityClass = $348e5c185e9c1cc5$var$getImageListItemUtilityClass;

var $348e5c185e9c1cc5$var$_generateUtilityClasses = $348e5c185e9c1cc5$require$_interopRequireDefault((parcelRequire("5nY49")));

var $348e5c185e9c1cc5$var$_generateUtilityClass = $348e5c185e9c1cc5$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $348e5c185e9c1cc5$var$getImageListItemUtilityClass(slot) {
    return (0, $348e5c185e9c1cc5$var$_generateUtilityClass.default)('MuiImageListItem', slot);
}
const $348e5c185e9c1cc5$var$imageListItemClasses = (0, $348e5c185e9c1cc5$var$_generateUtilityClasses.default)('MuiImageListItem', [
    'root',
    'img',
    'standard',
    'woven',
    'masonry',
    'quilted'
]);
var $348e5c185e9c1cc5$var$_default = module.exports.default = $348e5c185e9c1cc5$var$imageListItemClasses;

});



parcelRegister("2yXyU", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $1ddcf58ca2045c53$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $1ddcf58ca2045c53$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $1ddcf58ca2045c53$var$_exportNames = {
    imageListItemBarClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $1ddcf58ca2045c53$var$_ImageListItemBar.default;
    }
});
Object.defineProperty(module.exports, "imageListItemBarClasses", {
    enumerable: true,
    get: function() {
        return $1ddcf58ca2045c53$var$_imageListItemBarClasses.default;
    }
});

var $1ddcf58ca2045c53$var$_ImageListItemBar = $1ddcf58ca2045c53$require$_interopRequireDefault((parcelRequire("lzxDz")));

var $1ddcf58ca2045c53$var$_imageListItemBarClasses = $1ddcf58ca2045c53$require$_interopRequireWildcard((parcelRequire("eMzfg")));
Object.keys($1ddcf58ca2045c53$var$_imageListItemBarClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1ddcf58ca2045c53$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $1ddcf58ca2045c53$var$_imageListItemBarClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1ddcf58ca2045c53$var$_imageListItemBarClasses[key];
        }
    });
});

});
parcelRegister("lzxDz", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $fb46f5873d57d468$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $fb46f5873d57d468$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fb46f5873d57d468$var$_composeClasses = $fb46f5873d57d468$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $fb46f5873d57d468$var$_clsx = $fb46f5873d57d468$require$_interopRequireDefault((parcelRequire("9QePP")));

var $fb46f5873d57d468$var$_propTypes = $fb46f5873d57d468$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $fb46f5873d57d468$var$React = $fb46f5873d57d468$require$_interopRequireWildcard((parcelRequire("acw62")));

var $aAbgT = parcelRequire("aAbgT");

var $fb46f5873d57d468$var$_memoTheme = $fb46f5873d57d468$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $fb46f5873d57d468$var$_capitalize = $fb46f5873d57d468$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $eMzfg = parcelRequire("eMzfg");

var $ayMG0 = parcelRequire("ayMG0");
const $fb46f5873d57d468$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, position: position, actionIcon: actionIcon, actionPosition: actionPosition } = ownerState;
    const slots = {
        root: [
            'root',
            `position${(0, $fb46f5873d57d468$var$_capitalize.default)(position)}`,
            `actionPosition${(0, $fb46f5873d57d468$var$_capitalize.default)(actionPosition)}`
        ],
        titleWrap: [
            'titleWrap',
            `titleWrap${(0, $fb46f5873d57d468$var$_capitalize.default)(position)}`,
            actionIcon && `titleWrapActionPos${(0, $fb46f5873d57d468$var$_capitalize.default)(actionPosition)}`
        ],
        title: [
            'title'
        ],
        subtitle: [
            'subtitle'
        ],
        actionIcon: [
            'actionIcon',
            `actionIconActionPos${(0, $fb46f5873d57d468$var$_capitalize.default)(actionPosition)}`
        ]
    };
    return (0, $fb46f5873d57d468$var$_composeClasses.default)(slots, $eMzfg.getImageListItemBarUtilityClass, classes);
};
const $fb46f5873d57d468$var$ImageListItemBarRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiImageListItemBar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, $fb46f5873d57d468$var$_capitalize.default)(ownerState.position)}`]
        ];
    }
})((0, $fb46f5873d57d468$var$_memoTheme.default)(({ theme: theme })=>{
    return {
        position: 'absolute',
        left: 0,
        right: 0,
        background: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        fontFamily: theme.typography.fontFamily,
        variants: [
            {
                props: {
                    position: 'bottom'
                },
                style: {
                    bottom: 0
                }
            },
            {
                props: {
                    position: 'top'
                },
                style: {
                    top: 0
                }
            },
            {
                props: {
                    position: 'below'
                },
                style: {
                    position: 'relative',
                    background: 'transparent',
                    alignItems: 'normal'
                }
            }
        ]
    };
}));
const $fb46f5873d57d468$var$ImageListItemBarTitleWrap = (0, $aAbgT.styled)('div', {
    name: 'MuiImageListItemBar',
    slot: 'TitleWrap',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.titleWrap,
            styles[`titleWrap${(0, $fb46f5873d57d468$var$_capitalize.default)(ownerState.position)}`],
            ownerState.actionIcon && styles[`titleWrapActionPos${(0, $fb46f5873d57d468$var$_capitalize.default)(ownerState.actionPosition)}`]
        ];
    }
})((0, $fb46f5873d57d468$var$_memoTheme.default)(({ theme: theme })=>{
    return {
        flexGrow: 1,
        padding: '12px 16px',
        color: (theme.vars || theme).palette.common.white,
        overflow: 'hidden',
        variants: [
            {
                props: {
                    position: 'below'
                },
                style: {
                    padding: '6px 0 12px',
                    color: 'inherit'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.actionIcon && ownerState.actionPosition === 'left',
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.actionIcon && ownerState.actionPosition === 'right',
                style: {
                    paddingRight: 0
                }
            }
        ]
    };
}));
const $fb46f5873d57d468$var$ImageListItemBarTitle = (0, $aAbgT.styled)('div', {
    name: 'MuiImageListItemBar',
    slot: 'Title'
})((0, $fb46f5873d57d468$var$_memoTheme.default)(({ theme: theme })=>{
    return {
        fontSize: theme.typography.pxToRem(16),
        lineHeight: '24px',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
    };
}));
const $fb46f5873d57d468$var$ImageListItemBarSubtitle = (0, $aAbgT.styled)('div', {
    name: 'MuiImageListItemBar',
    slot: 'Subtitle'
})((0, $fb46f5873d57d468$var$_memoTheme.default)(({ theme: theme })=>{
    return {
        fontSize: theme.typography.pxToRem(12),
        lineHeight: 1,
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
    };
}));
const $fb46f5873d57d468$var$ImageListItemBarActionIcon = (0, $aAbgT.styled)('div', {
    name: 'MuiImageListItemBar',
    slot: 'ActionIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.actionIcon,
            styles[`actionIconActionPos${(0, $fb46f5873d57d468$var$_capitalize.default)(ownerState.actionPosition)}`]
        ];
    }
})({
    variants: [
        {
            props: {
                actionPosition: 'left'
            },
            style: {
                order: -1
            }
        }
    ]
});
const $fb46f5873d57d468$var$ImageListItemBar = /*#__PURE__*/ $fb46f5873d57d468$var$React.forwardRef(function ImageListItemBar(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiImageListItemBar'
    });
    const { actionIcon: actionIcon, actionPosition: actionPosition = 'right', className: className, subtitle: subtitle, title: title, position: position = 'bottom', ...other } = props;
    const ownerState = {
        ...props,
        position: position,
        actionPosition: actionPosition
    };
    const classes = $fb46f5873d57d468$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($fb46f5873d57d468$var$ImageListItemBarRoot, {
        ownerState: ownerState,
        className: (0, $fb46f5873d57d468$var$_clsx.default)(classes.root, className),
        ref: ref,
        ...other,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($fb46f5873d57d468$var$ImageListItemBarTitleWrap, {
                ownerState: ownerState,
                className: classes.titleWrap,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($fb46f5873d57d468$var$ImageListItemBarTitle, {
                        className: classes.title,
                        children: title
                    }),
                    subtitle ? /*#__PURE__*/ (0, $ayMG0.jsx)($fb46f5873d57d468$var$ImageListItemBarSubtitle, {
                        className: classes.subtitle,
                        children: subtitle
                    }) : null
                ]
            }),
            actionIcon ? /*#__PURE__*/ (0, $ayMG0.jsx)($fb46f5873d57d468$var$ImageListItemBarActionIcon, {
                ownerState: ownerState,
                className: classes.actionIcon,
                children: actionIcon
            }) : null
        ]
    });
});
$fb46f5873d57d468$var$ImageListItemBar.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * An IconButton element to be used as secondary action target
   * (primary action target is the item itself).
   */ actionIcon: $fb46f5873d57d468$var$_propTypes.default.node,
    /**
   * Position of secondary action IconButton.
   * @default 'right'
   */ actionPosition: $fb46f5873d57d468$var$_propTypes.default.oneOf([
        'left',
        'right'
    ]),
    /**
   * @ignore
   */ children: $fb46f5873d57d468$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $fb46f5873d57d468$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $fb46f5873d57d468$var$_propTypes.default.string,
    /**
   * Position of the title bar.
   * @default 'bottom'
   */ position: $fb46f5873d57d468$var$_propTypes.default.oneOf([
        'below',
        'bottom',
        'top'
    ]),
    /**
   * String or element serving as subtitle (support text).
   */ subtitle: $fb46f5873d57d468$var$_propTypes.default.node,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $fb46f5873d57d468$var$_propTypes.default.oneOfType([
        $fb46f5873d57d468$var$_propTypes.default.arrayOf($fb46f5873d57d468$var$_propTypes.default.oneOfType([
            $fb46f5873d57d468$var$_propTypes.default.func,
            $fb46f5873d57d468$var$_propTypes.default.object,
            $fb46f5873d57d468$var$_propTypes.default.bool
        ])),
        $fb46f5873d57d468$var$_propTypes.default.func,
        $fb46f5873d57d468$var$_propTypes.default.object
    ]),
    /**
   * Title to be displayed.
   */ title: $fb46f5873d57d468$var$_propTypes.default.node
};
var $fb46f5873d57d468$var$_default = module.exports.default = $fb46f5873d57d468$var$ImageListItemBar;

});
parcelRegister("eMzfg", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ac30e3552d9f386c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getImageListItemBarUtilityClass = $ac30e3552d9f386c$var$getImageListItemBarUtilityClass;

var $ac30e3552d9f386c$var$_generateUtilityClasses = $ac30e3552d9f386c$require$_interopRequireDefault((parcelRequire("5nY49")));

var $ac30e3552d9f386c$var$_generateUtilityClass = $ac30e3552d9f386c$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $ac30e3552d9f386c$var$getImageListItemBarUtilityClass(slot) {
    return (0, $ac30e3552d9f386c$var$_generateUtilityClass.default)('MuiImageListItemBar', slot);
}
const $ac30e3552d9f386c$var$imageListItemBarClasses = (0, $ac30e3552d9f386c$var$_generateUtilityClasses.default)('MuiImageListItemBar', [
    'root',
    'positionBottom',
    'positionTop',
    'positionBelow',
    'actionPositionLeft',
    'actionPositionRight',
    'titleWrap',
    'titleWrapBottom',
    'titleWrapTop',
    'titleWrapBelow',
    'titleWrapActionPosLeft',
    'titleWrapActionPosRight',
    'title',
    'subtitle',
    'actionIcon',
    'actionIconActionPosLeft',
    'actionIconActionPosRight'
]);
var $ac30e3552d9f386c$var$_default = module.exports.default = $ac30e3552d9f386c$var$imageListItemBarClasses;

});



parcelRegister("fyPI4", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $b542247f17114115$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $b542247f17114115$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $b542247f17114115$var$_exportNames = {
    linkClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $b542247f17114115$var$_Link.default;
    }
});
Object.defineProperty(module.exports, "linkClasses", {
    enumerable: true,
    get: function() {
        return $b542247f17114115$var$_linkClasses.default;
    }
});

var $b542247f17114115$var$_Link = $b542247f17114115$require$_interopRequireDefault((parcelRequire("9SK5h")));

var $b542247f17114115$var$_linkClasses = $b542247f17114115$require$_interopRequireWildcard((parcelRequire("lLIcc")));
Object.keys($b542247f17114115$var$_linkClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($b542247f17114115$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $b542247f17114115$var$_linkClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b542247f17114115$var$_linkClasses[key];
        }
    });
});

});
parcelRegister("9SK5h", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $731ce78e0c47d0a7$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $731ce78e0c47d0a7$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $731ce78e0c47d0a7$var$React = $731ce78e0c47d0a7$require$_interopRequireWildcard((parcelRequire("acw62")));

var $731ce78e0c47d0a7$var$_propTypes = $731ce78e0c47d0a7$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $731ce78e0c47d0a7$var$_clsx = $731ce78e0c47d0a7$require$_interopRequireDefault((parcelRequire("9QePP")));

var $731ce78e0c47d0a7$var$_elementTypeAcceptingRef = $731ce78e0c47d0a7$require$_interopRequireDefault((parcelRequire("g6PKz")));

var $731ce78e0c47d0a7$var$_composeClasses = $731ce78e0c47d0a7$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $731ce78e0c47d0a7$var$_isFocusVisible = $731ce78e0c47d0a7$require$_interopRequireDefault((parcelRequire("cS73m")));

var $731ce78e0c47d0a7$var$_capitalize = $731ce78e0c47d0a7$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $aAbgT = parcelRequire("aAbgT");

var $731ce78e0c47d0a7$var$_memoTheme = $731ce78e0c47d0a7$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $731ce78e0c47d0a7$var$_createSimplePaletteValueFilter = $731ce78e0c47d0a7$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $hL1nr = parcelRequire("hL1nr");

var $731ce78e0c47d0a7$var$_Typography = $731ce78e0c47d0a7$require$_interopRequireDefault((parcelRequire("2dUd7")));

var $731ce78e0c47d0a7$var$_linkClasses = $731ce78e0c47d0a7$require$_interopRequireWildcard((parcelRequire("lLIcc")));

var $731ce78e0c47d0a7$var$_getTextDecoration = $731ce78e0c47d0a7$require$_interopRequireDefault((parcelRequire("2LVI8")));

var $ayMG0 = parcelRequire("ayMG0");
const $731ce78e0c47d0a7$var$v6Colors = {
    primary: true,
    secondary: true,
    error: true,
    info: true,
    success: true,
    warning: true,
    textPrimary: true,
    textSecondary: true,
    textDisabled: true
};
const $731ce78e0c47d0a7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, component: component, focusVisible: focusVisible, underline: underline } = ownerState;
    const slots = {
        root: [
            'root',
            `underline${(0, $731ce78e0c47d0a7$var$_capitalize.default)(underline)}`,
            component === 'button' && 'button',
            focusVisible && 'focusVisible'
        ]
    };
    return (0, $731ce78e0c47d0a7$var$_composeClasses.default)(slots, $731ce78e0c47d0a7$var$_linkClasses.getLinkUtilityClass, classes);
};
const $731ce78e0c47d0a7$var$LinkRoot = (0, $aAbgT.styled)($731ce78e0c47d0a7$var$_Typography.default, {
    name: 'MuiLink',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`underline${(0, $731ce78e0c47d0a7$var$_capitalize.default)(ownerState.underline)}`],
            ownerState.component === 'button' && styles.button
        ];
    }
})((0, $731ce78e0c47d0a7$var$_memoTheme.default)(({ theme: theme })=>{
    return {
        variants: [
            {
                props: {
                    underline: 'none'
                },
                style: {
                    textDecoration: 'none'
                }
            },
            {
                props: {
                    underline: 'hover'
                },
                style: {
                    textDecoration: 'none',
                    '&:hover': {
                        textDecoration: 'underline'
                    }
                }
            },
            {
                props: {
                    underline: 'always'
                },
                style: {
                    textDecoration: 'underline',
                    '&:hover': {
                        textDecorationColor: 'inherit'
                    }
                }
            },
            {
                props: ({ underline: underline, ownerState: ownerState })=>underline === 'always' && ownerState.color !== 'inherit',
                style: {
                    textDecorationColor: 'var(--Link-underlineColor)'
                }
            },
            {
                props: ({ underline: underline, ownerState: ownerState })=>underline === 'always' && ownerState.color === 'inherit',
                style: theme.colorSpace ? {
                    textDecorationColor: theme.alpha('currentColor', 0.4)
                } : null
            },
            ...Object.entries(theme.palette).filter((0, $731ce78e0c47d0a7$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        underline: 'always',
                        color: color
                    },
                    style: {
                        '--Link-underlineColor': theme.alpha((theme.vars || theme).palette[color].main, 0.4)
                    }
                })),
            {
                props: {
                    underline: 'always',
                    color: 'textPrimary'
                },
                style: {
                    '--Link-underlineColor': theme.alpha((theme.vars || theme).palette.text.primary, 0.4)
                }
            },
            {
                props: {
                    underline: 'always',
                    color: 'textSecondary'
                },
                style: {
                    '--Link-underlineColor': theme.alpha((theme.vars || theme).palette.text.secondary, 0.4)
                }
            },
            {
                props: {
                    underline: 'always',
                    color: 'textDisabled'
                },
                style: {
                    '--Link-underlineColor': (theme.vars || theme).palette.text.disabled
                }
            },
            {
                props: {
                    component: 'button'
                },
                style: {
                    position: 'relative',
                    WebkitTapHighlightColor: 'transparent',
                    backgroundColor: 'transparent',
                    // Reset default value
                    // We disable the focus ring for mouse, touch and keyboard users.
                    outline: 0,
                    border: 0,
                    margin: 0,
                    // Remove the margin in Safari
                    borderRadius: 0,
                    padding: 0,
                    // Remove the padding in Firefox
                    cursor: 'pointer',
                    userSelect: 'none',
                    verticalAlign: 'middle',
                    MozAppearance: 'none',
                    // Reset
                    WebkitAppearance: 'none',
                    // Reset
                    '&::-moz-focus-inner': {
                        borderStyle: 'none' // Remove Firefox dotted outline.
                    },
                    [`&.${$731ce78e0c47d0a7$var$_linkClasses.default.focusVisible}`]: {
                        outline: 'auto'
                    }
                }
            }
        ]
    };
}));
const $731ce78e0c47d0a7$var$Link = /*#__PURE__*/ $731ce78e0c47d0a7$var$React.forwardRef(function Link(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiLink'
    });
    const theme = (0, $aAbgT.useTheme)();
    const { className: className, color: color = 'primary', component: component = 'a', onBlur: onBlur, onFocus: onFocus, TypographyClasses: TypographyClasses, underline: underline = 'always', variant: variant = 'inherit', sx: sx, ...other } = props;
    const [focusVisible, setFocusVisible] = $731ce78e0c47d0a7$var$React.useState(false);
    const handleBlur = (event)=>{
        if (!(0, $731ce78e0c47d0a7$var$_isFocusVisible.default)(event.target)) setFocusVisible(false);
        if (onBlur) onBlur(event);
    };
    const handleFocus = (event)=>{
        if ((0, $731ce78e0c47d0a7$var$_isFocusVisible.default)(event.target)) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    const ownerState = {
        ...props,
        color: color,
        component: component,
        focusVisible: focusVisible,
        underline: underline,
        variant: variant
    };
    const classes = $731ce78e0c47d0a7$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($731ce78e0c47d0a7$var$LinkRoot, {
        color: color,
        className: (0, $731ce78e0c47d0a7$var$_clsx.default)(classes.root, className),
        classes: TypographyClasses,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: ref,
        ownerState: ownerState,
        variant: variant,
        ...other,
        sx: [
            ...$731ce78e0c47d0a7$var$v6Colors[color] === undefined ? [
                {
                    color: color
                }
            ] : [],
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ],
        style: {
            ...other.style,
            ...underline === 'always' && color !== 'inherit' && !$731ce78e0c47d0a7$var$v6Colors[color] && {
                '--Link-underlineColor': (0, $731ce78e0c47d0a7$var$_getTextDecoration.default)({
                    theme: theme,
                    ownerState: ownerState
                })
            }
        }
    });
});
$731ce78e0c47d0a7$var$Link.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: $731ce78e0c47d0a7$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $731ce78e0c47d0a7$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $731ce78e0c47d0a7$var$_propTypes.default.string,
    /**
   * The color of the link.
   * @default 'primary'
   */ color: $731ce78e0c47d0a7$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $731ce78e0c47d0a7$var$_propTypes.default.oneOf([
            'primary',
            'secondary',
            'success',
            'error',
            'info',
            'warning',
            'textPrimary',
            'textSecondary',
            'textDisabled'
        ]),
        $731ce78e0c47d0a7$var$_propTypes.default.string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $731ce78e0c47d0a7$var$_elementTypeAcceptingRef.default,
    /**
   * @ignore
   */ onBlur: $731ce78e0c47d0a7$var$_propTypes.default.func,
    /**
   * @ignore
   */ onFocus: $731ce78e0c47d0a7$var$_propTypes.default.func,
    /**
   * @ignore
   */ style: $731ce78e0c47d0a7$var$_propTypes.default.object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $731ce78e0c47d0a7$var$_propTypes.default.oneOfType([
        $731ce78e0c47d0a7$var$_propTypes.default.arrayOf($731ce78e0c47d0a7$var$_propTypes.default.oneOfType([
            $731ce78e0c47d0a7$var$_propTypes.default.func,
            $731ce78e0c47d0a7$var$_propTypes.default.object,
            $731ce78e0c47d0a7$var$_propTypes.default.bool
        ])),
        $731ce78e0c47d0a7$var$_propTypes.default.func,
        $731ce78e0c47d0a7$var$_propTypes.default.object
    ]),
    /**
   * `classes` prop applied to the [`Typography`](https://mui.com/material-ui/api/typography/) element.
   */ TypographyClasses: $731ce78e0c47d0a7$var$_propTypes.default.object,
    /**
   * Controls when the link should have an underline.
   * @default 'always'
   */ underline: $731ce78e0c47d0a7$var$_propTypes.default.oneOf([
        'always',
        'hover',
        'none'
    ]),
    /**
   * Applies the theme typography styles.
   * @default 'inherit'
   */ variant: $731ce78e0c47d0a7$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $731ce78e0c47d0a7$var$_propTypes.default.oneOf([
            'body1',
            'body2',
            'button',
            'caption',
            'h1',
            'h2',
            'h3',
            'h4',
            'h5',
            'h6',
            'inherit',
            'overline',
            'subtitle1',
            'subtitle2'
        ]),
        $731ce78e0c47d0a7$var$_propTypes.default.string
    ])
};
var $731ce78e0c47d0a7$var$_default = module.exports.default = $731ce78e0c47d0a7$var$Link;

});
parcelRegister("lLIcc", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $fd904517f2a78af6$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getLinkUtilityClass = $fd904517f2a78af6$var$getLinkUtilityClass;

var $fd904517f2a78af6$var$_generateUtilityClasses = $fd904517f2a78af6$require$_interopRequireDefault((parcelRequire("5nY49")));

var $fd904517f2a78af6$var$_generateUtilityClass = $fd904517f2a78af6$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $fd904517f2a78af6$var$getLinkUtilityClass(slot) {
    return (0, $fd904517f2a78af6$var$_generateUtilityClass.default)('MuiLink', slot);
}
const $fd904517f2a78af6$var$linkClasses = (0, $fd904517f2a78af6$var$_generateUtilityClasses.default)('MuiLink', [
    'root',
    'underlineNone',
    'underlineHover',
    'underlineAlways',
    'button',
    'focusVisible'
]);
var $fd904517f2a78af6$var$_default = module.exports.default = $fd904517f2a78af6$var$linkClasses;

});

parcelRegister("2LVI8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fuavR = parcelRequire("fuavR");

var $h61zw = parcelRequire("h61zw");
const $204cbcbead979fad$var$getTextDecoration = ({ theme: theme, ownerState: ownerState })=>{
    const transformedColor = ownerState.color;
    if ('colorSpace' in theme && theme.colorSpace) {
        const color = (0, $fuavR.getPath)(theme, `palette.${transformedColor}.main`) || (0, $fuavR.getPath)(theme, `palette.${transformedColor}`) || ownerState.color;
        return theme.alpha(color, 0.4);
    }
    // check the `main` color first for a custom palette, then fallback to the color itself
    const color = (0, $fuavR.getPath)(theme, `palette.${transformedColor}.main`, false) || (0, $fuavR.getPath)(theme, `palette.${transformedColor}`, false) || ownerState.color;
    const channelColor = (0, $fuavR.getPath)(theme, `palette.${transformedColor}.mainChannel`) || (0, $fuavR.getPath)(theme, `palette.${transformedColor}Channel`);
    if ('vars' in theme && channelColor) return `rgba(${channelColor} / 0.4)`;
    return (0, $h61zw.alpha)(color, 0.4);
};
var $204cbcbead979fad$var$_default = module.exports.default = $204cbcbead979fad$var$getTextDecoration;

});



parcelRegister("hOLYA", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $cf8c523bf26d7f9a$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $cf8c523bf26d7f9a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $cf8c523bf26d7f9a$var$_exportNames = {
    listItemClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $cf8c523bf26d7f9a$var$_ListItem.default;
    }
});
Object.defineProperty(module.exports, "listItemClasses", {
    enumerable: true,
    get: function() {
        return $cf8c523bf26d7f9a$var$_listItemClasses.default;
    }
});

var $cf8c523bf26d7f9a$var$_ListItem = $cf8c523bf26d7f9a$require$_interopRequireDefault((parcelRequire("lofVM")));

var $cf8c523bf26d7f9a$var$_listItemClasses = $cf8c523bf26d7f9a$require$_interopRequireWildcard((parcelRequire("fiKZz")));
Object.keys($cf8c523bf26d7f9a$var$_listItemClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($cf8c523bf26d7f9a$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $cf8c523bf26d7f9a$var$_listItemClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cf8c523bf26d7f9a$var$_listItemClasses[key];
        }
    });
});

});
parcelRegister("lofVM", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $f92832698674c928$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $f92832698674c928$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.overridesResolver = module.exports.default = module.exports.ListItemRoot = void 0;

var $f92832698674c928$var$React = $f92832698674c928$require$_interopRequireWildcard((parcelRequire("acw62")));

var $f92832698674c928$var$_propTypes = $f92832698674c928$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $f92832698674c928$var$_clsx = $f92832698674c928$require$_interopRequireDefault((parcelRequire("9QePP")));

var $f92832698674c928$var$_composeClasses = $f92832698674c928$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $f92832698674c928$var$_elementTypeAcceptingRef = $f92832698674c928$require$_interopRequireDefault((parcelRequire("g6PKz")));

var $f92832698674c928$var$_chainPropTypes = $f92832698674c928$require$_interopRequireDefault((parcelRequire("abVWF")));

var $f92832698674c928$var$_isHostComponent = $f92832698674c928$require$_interopRequireDefault((parcelRequire("7jqh1")));

var $aAbgT = parcelRequire("aAbgT");

var $f92832698674c928$var$_memoTheme = $f92832698674c928$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $f92832698674c928$var$_isMuiElement = $f92832698674c928$require$_interopRequireDefault((parcelRequire("cpXNi")));

var $f92832698674c928$var$_useForkRef = $f92832698674c928$require$_interopRequireDefault((parcelRequire("9Rgf1")));

var $f92832698674c928$var$_useSlot = $f92832698674c928$require$_interopRequireDefault((parcelRequire("6lpak")));

var $f92832698674c928$var$_ListContext = $f92832698674c928$require$_interopRequireDefault((parcelRequire("3W6ht")));

var $fiKZz = parcelRequire("fiKZz");

var $iVzhN = parcelRequire("iVzhN");

var $f92832698674c928$var$_ListItemSecondaryAction = $f92832698674c928$require$_interopRequireDefault((parcelRequire("4LntB")));

var $ayMG0 = parcelRequire("ayMG0");
const $f92832698674c928$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
module.exports.overridesResolver = $f92832698674c928$var$overridesResolver;
const $f92832698674c928$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes, dense: dense, disableGutters: disableGutters, disablePadding: disablePadding, divider: divider, hasSecondaryAction: hasSecondaryAction } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            !disablePadding && 'padding',
            divider && 'divider',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            hasSecondaryAction && 'secondaryAction'
        ],
        container: [
            'container'
        ],
        secondaryAction: [
            'secondaryAction'
        ]
    };
    return (0, $f92832698674c928$var$_composeClasses.default)(slots, $fiKZz.getListItemUtilityClass, classes);
};
const $f92832698674c928$var$ListItemRoot = module.exports.ListItemRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiListItem',
    slot: 'Root',
    overridesResolver: $f92832698674c928$var$overridesResolver
})((0, $f92832698674c928$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        width: '100%',
        boxSizing: 'border-box',
        textAlign: 'left',
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding,
                style: {
                    paddingTop: 8,
                    paddingBottom: 8
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && ownerState.dense,
                style: {
                    paddingTop: 4,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && !ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && !!ownerState.secondaryAction,
                style: {
                    // Add some space to avoid collision as `ListItemSecondaryAction`
                    // is absolutely positioned.
                    paddingRight: 48
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.secondaryAction,
                style: {
                    [`& > .${$iVzhN.listItemButtonClasses.root}`]: {
                        paddingRight: 48
                    }
                }
            },
            {
                props: {
                    alignItems: 'flex-start'
                },
                style: {
                    alignItems: 'flex-start'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.button,
                style: {
                    transition: theme.transitions.create('background-color', {
                        duration: theme.transitions.duration.shortest
                    }),
                    '&:hover': {
                        textDecoration: 'none',
                        backgroundColor: (theme.vars || theme).palette.action.hover,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasSecondaryAction,
                style: {
                    // Add some space to avoid collision as `ListItemSecondaryAction`
                    // is absolutely positioned.
                    paddingRight: 48
                }
            }
        ]
    })));
const $f92832698674c928$var$ListItemContainer = (0, $aAbgT.styled)('li', {
    name: 'MuiListItem',
    slot: 'Container'
})({
    position: 'relative'
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const $f92832698674c928$var$ListItem = /*#__PURE__*/ $f92832698674c928$var$React.forwardRef(function ListItem(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiListItem'
    });
    const { alignItems: alignItems = 'center', children: childrenProp, className: className, component: componentProp, components: components = {}, componentsProps: componentsProps = {}, ContainerComponent: ContainerComponent = 'li', ContainerProps: { className: ContainerClassName, ...ContainerProps } = {}, dense: dense = false, disableGutters: disableGutters = false, disablePadding: disablePadding = false, divider: divider = false, secondaryAction: secondaryAction, slotProps: slotProps = {}, slots: slots = {}, ...other } = props;
    const context = $f92832698674c928$var$React.useContext($f92832698674c928$var$_ListContext.default);
    const childContext = $f92832698674c928$var$React.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $f92832698674c928$var$React.useRef(null);
    const children = $f92832698674c928$var$React.Children.toArray(childrenProp);
    // v4 implementation, deprecated in v6, will be removed in a future major release
    const hasSecondaryAction = children.length && (0, $f92832698674c928$var$_isMuiElement.default)(children[children.length - 1], [
        'ListItemSecondaryAction'
    ]);
    const ownerState = {
        ...props,
        alignItems: alignItems,
        dense: childContext.dense,
        disableGutters: disableGutters,
        disablePadding: disablePadding,
        divider: divider,
        hasSecondaryAction: hasSecondaryAction
    };
    const classes = $f92832698674c928$var$useUtilityClasses(ownerState);
    const handleRef = (0, $f92832698674c928$var$_useForkRef.default)(listItemRef, ref);
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [SecondaryActionSlot, secondaryActionSlotProps] = (0, $f92832698674c928$var$_useSlot.default)('secondaryAction', {
        elementType: $f92832698674c928$var$_ListItemSecondaryAction.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.secondaryAction
    });
    const Root = slots.root || components.Root || $f92832698674c928$var$ListItemRoot;
    const rootProps = slotProps.root || componentsProps.root || {};
    const componentProps = {
        className: (0, $f92832698674c928$var$_clsx.default)(classes.root, rootProps.className, className),
        ...other
    };
    let Component = componentProp || 'li';
    // v4 implementation, deprecated in v6, will be removed in a future major release
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? 'div' : Component;
        // Avoid nesting of li > li.
        if (ContainerComponent === 'li') {
            if (Component === 'li') Component = 'div';
            else if (componentProps.component === 'li') componentProps.component = 'div';
        }
        return /*#__PURE__*/ (0, $ayMG0.jsx)($f92832698674c928$var$_ListContext.default.Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)($f92832698674c928$var$ListItemContainer, {
                as: ContainerComponent,
                className: (0, $f92832698674c928$var$_clsx.default)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState,
                ...ContainerProps,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)(Root, {
                        ...rootProps,
                        ...!(0, $f92832698674c928$var$_isHostComponent.default)(Root) && {
                            as: Component,
                            ownerState: {
                                ...ownerState,
                                ...rootProps.ownerState
                            }
                        },
                        ...componentProps,
                        children: children
                    }),
                    children.pop()
                ]
            })
        });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($f92832698674c928$var$_ListContext.default.Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(Root, {
            ...rootProps,
            as: Component,
            ref: handleRef,
            ...!(0, $f92832698674c928$var$_isHostComponent.default)(Root) && {
                ownerState: {
                    ...ownerState,
                    ...rootProps.ownerState
                }
            },
            ...componentProps,
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, $ayMG0.jsx)(SecondaryActionSlot, {
                    ...secondaryActionSlotProps,
                    children: secondaryAction
                })
            ]
        })
    });
});
$f92832698674c928$var$ListItem.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Defines the `align-items` style property.
   * @default 'center'
   */ alignItems: $f92832698674c928$var$_propTypes.default.oneOf([
        'center',
        'flex-start'
    ]),
    /**
   * The content of the component if a `ListItemSecondaryAction` is used it must
   * be the last child.
   */ children: (0, $f92832698674c928$var$_chainPropTypes.default)($f92832698674c928$var$_propTypes.default.node, (props)=>{
        const children = $f92832698674c928$var$React.Children.toArray(props.children);
        // React.Children.toArray(props.children).findLastIndex(isListItemSecondaryAction)
        let secondaryActionIndex = -1;
        for(let i = children.length - 1; i >= 0; i -= 1){
            const child = children[i];
            if ((0, $f92832698674c928$var$_isMuiElement.default)(child, [
                'ListItemSecondaryAction'
            ])) {
                secondaryActionIndex = i;
                break;
            }
        }
        //  is ListItemSecondaryAction the last child of ListItem
        if (secondaryActionIndex !== -1 && secondaryActionIndex !== children.length - 1) return new Error("MUI: You used an element after ListItemSecondaryAction. For ListItem to detect that it has a secondary action you must pass it as the last child to ListItem.");
        return null;
    }),
    /**
   * Override or extend the styles applied to the component.
   */ classes: $f92832698674c928$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $f92832698674c928$var$_propTypes.default.string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $f92832698674c928$var$_propTypes.default.elementType,
    /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */ components: $f92832698674c928$var$_propTypes.default.shape({
        Root: $f92832698674c928$var$_propTypes.default.elementType
    }),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */ componentsProps: $f92832698674c928$var$_propTypes.default.shape({
        root: $f92832698674c928$var$_propTypes.default.object
    }),
    /**
   * The container component used when a `ListItemSecondaryAction` is the last child.
   * @default 'li'
   * @deprecated Use the `component` or `slots.root` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ ContainerComponent: $f92832698674c928$var$_elementTypeAcceptingRef.default,
    /**
   * Props applied to the container component if used.
   * @default {}
   * @deprecated Use the `slotProps.root` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ ContainerProps: $f92832698674c928$var$_propTypes.default.object,
    /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent List component.
   * @default false
   */ dense: $f92832698674c928$var$_propTypes.default.bool,
    /**
   * If `true`, the left and right padding is removed.
   * @default false
   */ disableGutters: $f92832698674c928$var$_propTypes.default.bool,
    /**
   * If `true`, all padding is removed.
   * @default false
   */ disablePadding: $f92832698674c928$var$_propTypes.default.bool,
    /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   * @default false
   */ divider: $f92832698674c928$var$_propTypes.default.bool,
    /**
   * The element to display at the end of ListItem.
   */ secondaryAction: $f92832698674c928$var$_propTypes.default.node,
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */ slotProps: $f92832698674c928$var$_propTypes.default.shape({
        root: $f92832698674c928$var$_propTypes.default.object,
        secondaryAction: $f92832698674c928$var$_propTypes.default.oneOfType([
            $f92832698674c928$var$_propTypes.default.func,
            $f92832698674c928$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   *
   * @default {}
   */ slots: $f92832698674c928$var$_propTypes.default.shape({
        root: $f92832698674c928$var$_propTypes.default.elementType,
        secondaryAction: $f92832698674c928$var$_propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $f92832698674c928$var$_propTypes.default.oneOfType([
        $f92832698674c928$var$_propTypes.default.arrayOf($f92832698674c928$var$_propTypes.default.oneOfType([
            $f92832698674c928$var$_propTypes.default.func,
            $f92832698674c928$var$_propTypes.default.object,
            $f92832698674c928$var$_propTypes.default.bool
        ])),
        $f92832698674c928$var$_propTypes.default.func,
        $f92832698674c928$var$_propTypes.default.object
    ])
};
var $f92832698674c928$var$_default = module.exports.default = $f92832698674c928$var$ListItem;

});
parcelRegister("fiKZz", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $b23cfd2067550897$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getListItemUtilityClass = $b23cfd2067550897$var$getListItemUtilityClass;

var $b23cfd2067550897$var$_generateUtilityClasses = $b23cfd2067550897$require$_interopRequireDefault((parcelRequire("5nY49")));

var $b23cfd2067550897$var$_generateUtilityClass = $b23cfd2067550897$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $b23cfd2067550897$var$getListItemUtilityClass(slot) {
    return (0, $b23cfd2067550897$var$_generateUtilityClass.default)('MuiListItem', slot);
}
const $b23cfd2067550897$var$listItemClasses = (0, $b23cfd2067550897$var$_generateUtilityClasses.default)('MuiListItem', [
    'root',
    'container',
    'dense',
    'alignItemsFlexStart',
    'divider',
    'gutters',
    'padding',
    'secondaryAction'
]);
var $b23cfd2067550897$var$_default = module.exports.default = $b23cfd2067550897$var$listItemClasses;

});

parcelRegister("iVzhN", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $dc78ebeb7704024e$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $dc78ebeb7704024e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $dc78ebeb7704024e$var$_exportNames = {
    listItemButtonClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $dc78ebeb7704024e$var$_ListItemButton.default;
    }
});
Object.defineProperty(module.exports, "listItemButtonClasses", {
    enumerable: true,
    get: function() {
        return $dc78ebeb7704024e$var$_listItemButtonClasses.default;
    }
});

var $dc78ebeb7704024e$var$_ListItemButton = $dc78ebeb7704024e$require$_interopRequireDefault((parcelRequire("cSDx2")));

var $dc78ebeb7704024e$var$_listItemButtonClasses = $dc78ebeb7704024e$require$_interopRequireWildcard((parcelRequire("dUgGz")));
Object.keys($dc78ebeb7704024e$var$_listItemButtonClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($dc78ebeb7704024e$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $dc78ebeb7704024e$var$_listItemButtonClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dc78ebeb7704024e$var$_listItemButtonClasses[key];
        }
    });
});

});
parcelRegister("cSDx2", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $960931686a59e228$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $960931686a59e228$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.overridesResolver = module.exports.default = void 0;

var $960931686a59e228$var$React = $960931686a59e228$require$_interopRequireWildcard((parcelRequire("acw62")));

var $960931686a59e228$var$_propTypes = $960931686a59e228$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $960931686a59e228$var$_clsx = $960931686a59e228$require$_interopRequireDefault((parcelRequire("9QePP")));

var $960931686a59e228$var$_composeClasses = $960931686a59e228$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $960931686a59e228$var$_memoTheme = $960931686a59e228$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $960931686a59e228$var$_rootShouldForwardProp = $960931686a59e228$require$_interopRequireDefault((parcelRequire("8Uq77")));

var $960931686a59e228$var$_ButtonBase = $960931686a59e228$require$_interopRequireDefault((parcelRequire("hhs3r")));

var $960931686a59e228$var$_useEnhancedEffect = $960931686a59e228$require$_interopRequireDefault((parcelRequire("khjmj")));

var $960931686a59e228$var$_useForkRef = $960931686a59e228$require$_interopRequireDefault((parcelRequire("9Rgf1")));

var $960931686a59e228$var$_ListContext = $960931686a59e228$require$_interopRequireDefault((parcelRequire("3W6ht")));

var $960931686a59e228$var$_listItemButtonClasses = $960931686a59e228$require$_interopRequireWildcard((parcelRequire("dUgGz")));

var $ayMG0 = parcelRequire("ayMG0");
const $960931686a59e228$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
module.exports.overridesResolver = $960931686a59e228$var$overridesResolver;
const $960931686a59e228$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes, dense: dense, disabled: disabled, disableGutters: disableGutters, divider: divider, selected: selected } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            divider && 'divider',
            disabled && 'disabled',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $960931686a59e228$var$_composeClasses.default)(slots, $960931686a59e228$var$_listItemButtonClasses.getListItemButtonUtilityClass, classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const $960931686a59e228$var$ListItemButtonRoot = (0, $aAbgT.styled)($960931686a59e228$var$_ButtonBase.default, {
    shouldForwardProp: (prop)=>(0, $960931686a59e228$var$_rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiListItemButton',
    slot: 'Root',
    overridesResolver: $960931686a59e228$var$overridesResolver
})((0, $960931686a59e228$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'flex',
        flexGrow: 1,
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minWidth: 0,
        boxSizing: 'border-box',
        textAlign: 'left',
        paddingTop: 8,
        paddingBottom: 8,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${$960931686a59e228$var$_listItemButtonClasses.default.selected}`]: {
            backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity),
            [`&.${$960931686a59e228$var$_listItemButtonClasses.default.focusVisible}`]: {
                backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
            }
        },
        [`&.${$960931686a59e228$var$_listItemButtonClasses.default.selected}:hover`]: {
            backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity)
            }
        },
        [`&.${$960931686a59e228$var$_listItemButtonClasses.default.focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${$960931686a59e228$var$_listItemButtonClasses.default.disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: {
                    alignItems: 'flex-start'
                },
                style: {
                    alignItems: 'flex-start'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.dense,
                style: {
                    paddingTop: 4,
                    paddingBottom: 4
                }
            }
        ]
    })));
const $960931686a59e228$var$ListItemButton = /*#__PURE__*/ $960931686a59e228$var$React.forwardRef(function ListItemButton(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemButton'
    });
    const { alignItems: alignItems = 'center', autoFocus: autoFocus = false, component: component = 'div', children: children, dense: dense = false, disableGutters: disableGutters = false, divider: divider = false, focusVisibleClassName: focusVisibleClassName, selected: selected = false, className: className, ...other } = props;
    const context = $960931686a59e228$var$React.useContext($960931686a59e228$var$_ListContext.default);
    const childContext = $960931686a59e228$var$React.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $960931686a59e228$var$React.useRef(null);
    (0, $960931686a59e228$var$_useEnhancedEffect.default)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
            else console.error('MUI: Unable to set focus to a ListItemButton whose component has not been rendered.');
        }
    }, [
        autoFocus
    ]);
    const ownerState = {
        ...props,
        alignItems: alignItems,
        dense: childContext.dense,
        disableGutters: disableGutters,
        divider: divider,
        selected: selected
    };
    const classes = $960931686a59e228$var$useUtilityClasses(ownerState);
    // Don't forward the 'root' class to the ButtonBase, as it will get duplicated with the one passed to the className prop.
    const { root: root, ...forwardedClasses } = classes;
    const handleRef = (0, $960931686a59e228$var$_useForkRef.default)(listItemRef, ref);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($960931686a59e228$var$_ListContext.default.Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($960931686a59e228$var$ListItemButtonRoot, {
            ref: handleRef,
            href: other.href || other.to,
            component: (other.href || other.to) && component === 'div' ? 'button' : component,
            focusVisibleClassName: (0, $960931686a59e228$var$_clsx.default)(classes.focusVisible, focusVisibleClassName),
            ownerState: ownerState,
            className: (0, $960931686a59e228$var$_clsx.default)(classes.root, className),
            ...other,
            classes: forwardedClasses,
            children: children
        })
    });
});
$960931686a59e228$var$ListItemButton.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Defines the `align-items` style property.
   * @default 'center'
   */ alignItems: $960931686a59e228$var$_propTypes.default.oneOf([
        'center',
        'flex-start'
    ]),
    /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */ autoFocus: $960931686a59e228$var$_propTypes.default.bool,
    /**
   * The content of the component if a `ListItemSecondaryAction` is used it must
   * be the last child.
   */ children: $960931686a59e228$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $960931686a59e228$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $960931686a59e228$var$_propTypes.default.string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $960931686a59e228$var$_propTypes.default.elementType,
    /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent List component.
   * @default false
   */ dense: $960931686a59e228$var$_propTypes.default.bool,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: $960931686a59e228$var$_propTypes.default.bool,
    /**
   * If `true`, the left and right padding is removed.
   * @default false
   */ disableGutters: $960931686a59e228$var$_propTypes.default.bool,
    /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   * @default false
   */ divider: $960931686a59e228$var$_propTypes.default.bool,
    /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */ focusVisibleClassName: $960931686a59e228$var$_propTypes.default.string,
    /**
   * @ignore
   */ href: $960931686a59e228$var$_propTypes.default.string,
    /**
   * Use to apply selected styling.
   * @default false
   */ selected: $960931686a59e228$var$_propTypes.default.bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $960931686a59e228$var$_propTypes.default.oneOfType([
        $960931686a59e228$var$_propTypes.default.arrayOf($960931686a59e228$var$_propTypes.default.oneOfType([
            $960931686a59e228$var$_propTypes.default.func,
            $960931686a59e228$var$_propTypes.default.object,
            $960931686a59e228$var$_propTypes.default.bool
        ])),
        $960931686a59e228$var$_propTypes.default.func,
        $960931686a59e228$var$_propTypes.default.object
    ])
};
var $960931686a59e228$var$_default = module.exports.default = $960931686a59e228$var$ListItemButton;

});
parcelRegister("dUgGz", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a1fd72c2634274a8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getListItemButtonUtilityClass = $a1fd72c2634274a8$var$getListItemButtonUtilityClass;

var $a1fd72c2634274a8$var$_generateUtilityClasses = $a1fd72c2634274a8$require$_interopRequireDefault((parcelRequire("5nY49")));

var $a1fd72c2634274a8$var$_generateUtilityClass = $a1fd72c2634274a8$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $a1fd72c2634274a8$var$getListItemButtonUtilityClass(slot) {
    return (0, $a1fd72c2634274a8$var$_generateUtilityClass.default)('MuiListItemButton', slot);
}
const $a1fd72c2634274a8$var$listItemButtonClasses = (0, $a1fd72c2634274a8$var$_generateUtilityClasses.default)('MuiListItemButton', [
    'root',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $a1fd72c2634274a8$var$_default = module.exports.default = $a1fd72c2634274a8$var$listItemButtonClasses;

});



parcelRegister("4LntB", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $377dc32070e7887f$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $377dc32070e7887f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $377dc32070e7887f$var$_exportNames = {
    listItemSecondaryActionClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $377dc32070e7887f$var$_ListItemSecondaryAction.default;
    }
});
Object.defineProperty(module.exports, "listItemSecondaryActionClasses", {
    enumerable: true,
    get: function() {
        return $377dc32070e7887f$var$_listItemSecondaryActionClasses.default;
    }
});

var $377dc32070e7887f$var$_ListItemSecondaryAction = $377dc32070e7887f$require$_interopRequireDefault((parcelRequire("d9alg")));

var $377dc32070e7887f$var$_listItemSecondaryActionClasses = $377dc32070e7887f$require$_interopRequireWildcard((parcelRequire("7lon8")));
Object.keys($377dc32070e7887f$var$_listItemSecondaryActionClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($377dc32070e7887f$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $377dc32070e7887f$var$_listItemSecondaryActionClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $377dc32070e7887f$var$_listItemSecondaryActionClasses[key];
        }
    });
});

});
parcelRegister("d9alg", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $9924235485c5a222$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $9924235485c5a222$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9924235485c5a222$var$React = $9924235485c5a222$require$_interopRequireWildcard((parcelRequire("acw62")));

var $9924235485c5a222$var$_propTypes = $9924235485c5a222$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $9924235485c5a222$var$_clsx = $9924235485c5a222$require$_interopRequireDefault((parcelRequire("9QePP")));

var $9924235485c5a222$var$_composeClasses = $9924235485c5a222$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $9924235485c5a222$var$_ListContext = $9924235485c5a222$require$_interopRequireDefault((parcelRequire("3W6ht")));

var $7lon8 = parcelRequire("7lon8");

var $ayMG0 = parcelRequire("ayMG0");
const $9924235485c5a222$var$useUtilityClasses = (ownerState)=>{
    const { disableGutters: disableGutters, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $9924235485c5a222$var$_composeClasses.default)(slots, $7lon8.getListItemSecondaryActionClassesUtilityClass, classes);
};
const $9924235485c5a222$var$ListItemSecondaryActionRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiListItemSecondaryAction',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})({
    position: 'absolute',
    right: 16,
    top: '50%',
    transform: 'translateY(-50%)',
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.disableGutters,
            style: {
                right: 0
            }
        }
    ]
});
/**
 * Must be used as the last child of ListItem to function properly.
 *
 * @deprecated Use the `secondaryAction` prop in the `ListItem` component instead. This component will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
 */ const $9924235485c5a222$var$ListItemSecondaryAction = /*#__PURE__*/ $9924235485c5a222$var$React.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemSecondaryAction'
    });
    const { className: className, ...other } = props;
    const context = $9924235485c5a222$var$React.useContext($9924235485c5a222$var$_ListContext.default);
    const ownerState = {
        ...props,
        disableGutters: context.disableGutters
    };
    const classes = $9924235485c5a222$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($9924235485c5a222$var$ListItemSecondaryActionRoot, {
        className: (0, $9924235485c5a222$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
$9924235485c5a222$var$ListItemSecondaryAction.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component, normally an `IconButton` or selection control.
   */ children: $9924235485c5a222$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $9924235485c5a222$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $9924235485c5a222$var$_propTypes.default.string,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $9924235485c5a222$var$_propTypes.default.oneOfType([
        $9924235485c5a222$var$_propTypes.default.arrayOf($9924235485c5a222$var$_propTypes.default.oneOfType([
            $9924235485c5a222$var$_propTypes.default.func,
            $9924235485c5a222$var$_propTypes.default.object,
            $9924235485c5a222$var$_propTypes.default.bool
        ])),
        $9924235485c5a222$var$_propTypes.default.func,
        $9924235485c5a222$var$_propTypes.default.object
    ])
};
$9924235485c5a222$var$ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
var $9924235485c5a222$var$_default = module.exports.default = $9924235485c5a222$var$ListItemSecondaryAction;

});
parcelRegister("7lon8", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $558d665a4b71ad4c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getListItemSecondaryActionClassesUtilityClass = $558d665a4b71ad4c$var$getListItemSecondaryActionClassesUtilityClass;

var $558d665a4b71ad4c$var$_generateUtilityClasses = $558d665a4b71ad4c$require$_interopRequireDefault((parcelRequire("5nY49")));

var $558d665a4b71ad4c$var$_generateUtilityClass = $558d665a4b71ad4c$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $558d665a4b71ad4c$var$getListItemSecondaryActionClassesUtilityClass(slot) {
    return (0, $558d665a4b71ad4c$var$_generateUtilityClass.default)('MuiListItemSecondaryAction', slot);
}
const $558d665a4b71ad4c$var$listItemSecondaryActionClasses = (0, $558d665a4b71ad4c$var$_generateUtilityClasses.default)('MuiListItemSecondaryAction', [
    'root',
    'disableGutters'
]);
var $558d665a4b71ad4c$var$_default = module.exports.default = $558d665a4b71ad4c$var$listItemSecondaryActionClasses;

});





parcelRegister("6HgAC", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $4e03a092ccfc165d$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $4e03a092ccfc165d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $4e03a092ccfc165d$var$_exportNames = {
    listItemAvatarClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $4e03a092ccfc165d$var$_ListItemAvatar.default;
    }
});
Object.defineProperty(module.exports, "listItemAvatarClasses", {
    enumerable: true,
    get: function() {
        return $4e03a092ccfc165d$var$_listItemAvatarClasses.default;
    }
});

var $4e03a092ccfc165d$var$_ListItemAvatar = $4e03a092ccfc165d$require$_interopRequireDefault((parcelRequire("84UsW")));

var $4e03a092ccfc165d$var$_listItemAvatarClasses = $4e03a092ccfc165d$require$_interopRequireWildcard((parcelRequire("cohVi")));
Object.keys($4e03a092ccfc165d$var$_listItemAvatarClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($4e03a092ccfc165d$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $4e03a092ccfc165d$var$_listItemAvatarClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4e03a092ccfc165d$var$_listItemAvatarClasses[key];
        }
    });
});

});
parcelRegister("84UsW", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $5e1a7f5eff0ff3e8$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $5e1a7f5eff0ff3e8$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5e1a7f5eff0ff3e8$var$React = $5e1a7f5eff0ff3e8$require$_interopRequireWildcard((parcelRequire("acw62")));

var $5e1a7f5eff0ff3e8$var$_propTypes = $5e1a7f5eff0ff3e8$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $5e1a7f5eff0ff3e8$var$_clsx = $5e1a7f5eff0ff3e8$require$_interopRequireDefault((parcelRequire("9QePP")));

var $5e1a7f5eff0ff3e8$var$_composeClasses = $5e1a7f5eff0ff3e8$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $5e1a7f5eff0ff3e8$var$_ListContext = $5e1a7f5eff0ff3e8$require$_interopRequireDefault((parcelRequire("3W6ht")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $cohVi = parcelRequire("cohVi");

var $ayMG0 = parcelRequire("ayMG0");
const $5e1a7f5eff0ff3e8$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            alignItems === 'flex-start' && 'alignItemsFlexStart'
        ]
    };
    return (0, $5e1a7f5eff0ff3e8$var$_composeClasses.default)(slots, $cohVi.getListItemAvatarUtilityClass, classes);
};
const $5e1a7f5eff0ff3e8$var$ListItemAvatarRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiListItemAvatar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart
        ];
    }
})({
    minWidth: 56,
    flexShrink: 0,
    variants: [
        {
            props: {
                alignItems: 'flex-start'
            },
            style: {
                marginTop: 8
            }
        }
    ]
});
/**
 * A simple wrapper to apply `List` styles to an `Avatar`.
 */ const $5e1a7f5eff0ff3e8$var$ListItemAvatar = /*#__PURE__*/ $5e1a7f5eff0ff3e8$var$React.forwardRef(function ListItemAvatar(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemAvatar'
    });
    const { className: className, ...other } = props;
    const context = $5e1a7f5eff0ff3e8$var$React.useContext($5e1a7f5eff0ff3e8$var$_ListContext.default);
    const ownerState = {
        ...props,
        alignItems: context.alignItems
    };
    const classes = $5e1a7f5eff0ff3e8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5e1a7f5eff0ff3e8$var$ListItemAvatarRoot, {
        className: (0, $5e1a7f5eff0ff3e8$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
$5e1a7f5eff0ff3e8$var$ListItemAvatar.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component, normally an `Avatar`.
   */ children: $5e1a7f5eff0ff3e8$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $5e1a7f5eff0ff3e8$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $5e1a7f5eff0ff3e8$var$_propTypes.default.string,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $5e1a7f5eff0ff3e8$var$_propTypes.default.oneOfType([
        $5e1a7f5eff0ff3e8$var$_propTypes.default.arrayOf($5e1a7f5eff0ff3e8$var$_propTypes.default.oneOfType([
            $5e1a7f5eff0ff3e8$var$_propTypes.default.func,
            $5e1a7f5eff0ff3e8$var$_propTypes.default.object,
            $5e1a7f5eff0ff3e8$var$_propTypes.default.bool
        ])),
        $5e1a7f5eff0ff3e8$var$_propTypes.default.func,
        $5e1a7f5eff0ff3e8$var$_propTypes.default.object
    ])
};
var $5e1a7f5eff0ff3e8$var$_default = module.exports.default = $5e1a7f5eff0ff3e8$var$ListItemAvatar;

});
parcelRegister("cohVi", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9055a111c146fc9b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getListItemAvatarUtilityClass = $9055a111c146fc9b$var$getListItemAvatarUtilityClass;

var $9055a111c146fc9b$var$_generateUtilityClasses = $9055a111c146fc9b$require$_interopRequireDefault((parcelRequire("5nY49")));

var $9055a111c146fc9b$var$_generateUtilityClass = $9055a111c146fc9b$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $9055a111c146fc9b$var$getListItemAvatarUtilityClass(slot) {
    return (0, $9055a111c146fc9b$var$_generateUtilityClass.default)('MuiListItemAvatar', slot);
}
const $9055a111c146fc9b$var$listItemAvatarClasses = (0, $9055a111c146fc9b$var$_generateUtilityClasses.default)('MuiListItemAvatar', [
    'root',
    'alignItemsFlexStart'
]);
var $9055a111c146fc9b$var$_default = module.exports.default = $9055a111c146fc9b$var$listItemAvatarClasses;

});



parcelRegister("kCnQI", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $03dfa491627f975c$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $03dfa491627f975c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $03dfa491627f975c$var$_exportNames = {
    menuClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $03dfa491627f975c$var$_Menu.default;
    }
});
Object.defineProperty(module.exports, "menuClasses", {
    enumerable: true,
    get: function() {
        return $03dfa491627f975c$var$_menuClasses.default;
    }
});

var $03dfa491627f975c$var$_Menu = $03dfa491627f975c$require$_interopRequireDefault((parcelRequire("4F5tJ")));

var $03dfa491627f975c$var$_menuClasses = $03dfa491627f975c$require$_interopRequireWildcard((parcelRequire("lyHsQ")));
Object.keys($03dfa491627f975c$var$_menuClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($03dfa491627f975c$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $03dfa491627f975c$var$_menuClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $03dfa491627f975c$var$_menuClasses[key];
        }
    });
});

});

parcelRegister("1e1yc", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $0e484d2d1153e25c$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $0e484d2d1153e25c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $0e484d2d1153e25c$var$_exportNames = {
    mobileStepperClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $0e484d2d1153e25c$var$_MobileStepper.default;
    }
});
Object.defineProperty(module.exports, "mobileStepperClasses", {
    enumerable: true,
    get: function() {
        return $0e484d2d1153e25c$var$_mobileStepperClasses.default;
    }
});

var $0e484d2d1153e25c$var$_MobileStepper = $0e484d2d1153e25c$require$_interopRequireDefault((parcelRequire("5moyV")));

var $0e484d2d1153e25c$var$_mobileStepperClasses = $0e484d2d1153e25c$require$_interopRequireWildcard((parcelRequire("50EKC")));
Object.keys($0e484d2d1153e25c$var$_mobileStepperClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($0e484d2d1153e25c$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $0e484d2d1153e25c$var$_mobileStepperClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $0e484d2d1153e25c$var$_mobileStepperClasses[key];
        }
    });
});

});
parcelRegister("5moyV", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $3e720f5cf13cfb0a$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $3e720f5cf13cfb0a$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e720f5cf13cfb0a$var$React = $3e720f5cf13cfb0a$require$_interopRequireWildcard((parcelRequire("acw62")));

var $3e720f5cf13cfb0a$var$_propTypes = $3e720f5cf13cfb0a$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $3e720f5cf13cfb0a$var$_clsx = $3e720f5cf13cfb0a$require$_interopRequireDefault((parcelRequire("9QePP")));

var $3e720f5cf13cfb0a$var$_integerPropType = $3e720f5cf13cfb0a$require$_interopRequireDefault((parcelRequire("cxaSP")));

var $3e720f5cf13cfb0a$var$_composeClasses = $3e720f5cf13cfb0a$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $3e720f5cf13cfb0a$var$_Paper = $3e720f5cf13cfb0a$require$_interopRequireDefault((parcelRequire("juRJQ")));

var $3e720f5cf13cfb0a$var$_capitalize = $3e720f5cf13cfb0a$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $3e720f5cf13cfb0a$var$_LinearProgress = $3e720f5cf13cfb0a$require$_interopRequireDefault((parcelRequire("2vsem")));

var $aAbgT = parcelRequire("aAbgT");

var $3e720f5cf13cfb0a$var$_memoTheme = $3e720f5cf13cfb0a$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $3e720f5cf13cfb0a$var$_slotShouldForwardProp = $3e720f5cf13cfb0a$require$_interopRequireDefault((parcelRequire("PJRTc")));

var $50EKC = parcelRequire("50EKC");

var $3e720f5cf13cfb0a$var$_useSlot = $3e720f5cf13cfb0a$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $3e720f5cf13cfb0a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, position: position } = ownerState;
    const slots = {
        root: [
            'root',
            `position${(0, $3e720f5cf13cfb0a$var$_capitalize.default)(position)}`
        ],
        dots: [
            'dots'
        ],
        dot: [
            'dot'
        ],
        dotActive: [
            'dotActive'
        ],
        progress: [
            'progress'
        ]
    };
    return (0, $3e720f5cf13cfb0a$var$_composeClasses.default)(slots, $50EKC.getMobileStepperUtilityClass, classes);
};
const $3e720f5cf13cfb0a$var$MobileStepperRoot = (0, $aAbgT.styled)($3e720f5cf13cfb0a$var$_Paper.default, {
    name: 'MuiMobileStepper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, $3e720f5cf13cfb0a$var$_capitalize.default)(ownerState.position)}`]
        ];
    }
})((0, $3e720f5cf13cfb0a$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        background: (theme.vars || theme).palette.background.default,
        padding: 8,
        variants: [
            {
                props: ({ position: position })=>position === 'top' || position === 'bottom',
                style: {
                    position: 'fixed',
                    left: 0,
                    right: 0,
                    zIndex: (theme.vars || theme).zIndex.mobileStepper
                }
            },
            {
                props: {
                    position: 'top'
                },
                style: {
                    top: 0
                }
            },
            {
                props: {
                    position: 'bottom'
                },
                style: {
                    bottom: 0
                }
            }
        ]
    })));
const $3e720f5cf13cfb0a$var$MobileStepperDots = (0, $aAbgT.styled)('div', {
    name: 'MuiMobileStepper',
    slot: 'Dots'
})({
    variants: [
        {
            props: {
                variant: 'dots'
            },
            style: {
                display: 'flex',
                flexDirection: 'row'
            }
        }
    ]
});
const $3e720f5cf13cfb0a$var$MobileStepperDot = (0, $aAbgT.styled)('div', {
    name: 'MuiMobileStepper',
    slot: 'Dot',
    shouldForwardProp: (prop)=>(0, $3e720f5cf13cfb0a$var$_slotShouldForwardProp.default)(prop) && prop !== 'dotActive',
    overridesResolver: (props, styles)=>{
        const { dotActive: dotActive } = props;
        return [
            styles.dot,
            dotActive && styles.dotActive
        ];
    }
})((0, $3e720f5cf13cfb0a$var$_memoTheme.default)(({ theme: theme })=>({
        variants: [
            {
                props: {
                    variant: 'dots'
                },
                style: {
                    transition: theme.transitions.create('background-color', {
                        duration: theme.transitions.duration.shortest
                    }),
                    backgroundColor: (theme.vars || theme).palette.action.disabled,
                    borderRadius: '50%',
                    width: 8,
                    height: 8,
                    margin: '0 2px'
                }
            },
            {
                props: {
                    variant: 'dots',
                    dotActive: true
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.primary.main
                }
            }
        ]
    })));
const $3e720f5cf13cfb0a$var$MobileStepperProgress = (0, $aAbgT.styled)($3e720f5cf13cfb0a$var$_LinearProgress.default, {
    name: 'MuiMobileStepper',
    slot: 'Progress'
})({
    variants: [
        {
            props: {
                variant: 'progress'
            },
            style: {
                width: '50%'
            }
        }
    ]
});
const $3e720f5cf13cfb0a$var$MobileStepper = /*#__PURE__*/ $3e720f5cf13cfb0a$var$React.forwardRef(function MobileStepper(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiMobileStepper'
    });
    const { activeStep: activeStep = 0, backButton: backButton, className: className, LinearProgressProps: LinearProgressProps, nextButton: nextButton, position: position = 'bottom', steps: steps, variant: variant = 'dots', slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const ownerState = {
        ...props,
        activeStep: activeStep,
        position: position,
        variant: variant
    };
    let value;
    if (variant === 'progress') {
        if (steps === 1) value = 100;
        else value = Math.ceil(activeStep / (steps - 1) * 100);
    }
    const classes = $3e720f5cf13cfb0a$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            progress: LinearProgressProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, $3e720f5cf13cfb0a$var$_useSlot.default)('root', {
        ref: ref,
        elementType: $3e720f5cf13cfb0a$var$MobileStepperRoot,
        shouldForwardComponentProp: true,
        className: (0, $3e720f5cf13cfb0a$var$_clsx.default)(classes.root, className),
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        additionalProps: {
            square: true,
            elevation: 0
        }
    });
    const [DotsSlot, dotsSlotProps] = (0, $3e720f5cf13cfb0a$var$_useSlot.default)('dots', {
        className: classes.dots,
        elementType: $3e720f5cf13cfb0a$var$MobileStepperDots,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [DotSlot, dotSlotProps] = (0, $3e720f5cf13cfb0a$var$_useSlot.default)('dot', {
        elementType: $3e720f5cf13cfb0a$var$MobileStepperDot,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ProgressSlot, progressSlotProps] = (0, $3e720f5cf13cfb0a$var$_useSlot.default)('progress', {
        className: classes.progress,
        elementType: $3e720f5cf13cfb0a$var$MobileStepperProgress,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            value: value,
            variant: 'determinate'
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            backButton,
            variant === 'text' && /*#__PURE__*/ (0, $ayMG0.jsxs)($3e720f5cf13cfb0a$var$React.Fragment, {
                children: [
                    activeStep + 1,
                    " / ",
                    steps
                ]
            }),
            variant === 'dots' && /*#__PURE__*/ (0, $ayMG0.jsx)(DotsSlot, {
                ...dotsSlotProps,
                children: [
                    ...new Array(steps)
                ].map((_, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)(DotSlot, {
                        ...dotSlotProps,
                        className: (0, $3e720f5cf13cfb0a$var$_clsx.default)(classes.dot, dotSlotProps.className, index === activeStep && classes.dotActive),
                        dotActive: index === activeStep
                    }, index))
            }),
            variant === 'progress' && /*#__PURE__*/ (0, $ayMG0.jsx)(ProgressSlot, {
                ...progressSlotProps
            }),
            nextButton
        ]
    });
});
$3e720f5cf13cfb0a$var$MobileStepper.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Set the active step (zero based index).
   * Defines which dot is highlighted when the variant is 'dots'.
   * @default 0
   */ activeStep: $3e720f5cf13cfb0a$var$_integerPropType.default,
    /**
   * A back button element. For instance, it can be a `Button` or an `IconButton`.
   */ backButton: $3e720f5cf13cfb0a$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $3e720f5cf13cfb0a$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $3e720f5cf13cfb0a$var$_propTypes.default.string,
    /**
   * Props applied to the `LinearProgress` element.
   * @deprecated Use `slotProps.progress` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ LinearProgressProps: $3e720f5cf13cfb0a$var$_propTypes.default.object,
    /**
   * A next button element. For instance, it can be a `Button` or an `IconButton`.
   */ nextButton: $3e720f5cf13cfb0a$var$_propTypes.default.node,
    /**
   * Set the positioning type.
   * @default 'bottom'
   */ position: $3e720f5cf13cfb0a$var$_propTypes.default.oneOf([
        'bottom',
        'static',
        'top'
    ]),
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $3e720f5cf13cfb0a$var$_propTypes.default.shape({
        dot: $3e720f5cf13cfb0a$var$_propTypes.default.oneOfType([
            $3e720f5cf13cfb0a$var$_propTypes.default.func,
            $3e720f5cf13cfb0a$var$_propTypes.default.object
        ]),
        dots: $3e720f5cf13cfb0a$var$_propTypes.default.oneOfType([
            $3e720f5cf13cfb0a$var$_propTypes.default.func,
            $3e720f5cf13cfb0a$var$_propTypes.default.object
        ]),
        progress: $3e720f5cf13cfb0a$var$_propTypes.default.oneOfType([
            $3e720f5cf13cfb0a$var$_propTypes.default.func,
            $3e720f5cf13cfb0a$var$_propTypes.default.object
        ]),
        root: $3e720f5cf13cfb0a$var$_propTypes.default.oneOfType([
            $3e720f5cf13cfb0a$var$_propTypes.default.func,
            $3e720f5cf13cfb0a$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: $3e720f5cf13cfb0a$var$_propTypes.default.shape({
        dot: $3e720f5cf13cfb0a$var$_propTypes.default.elementType,
        dots: $3e720f5cf13cfb0a$var$_propTypes.default.elementType,
        progress: $3e720f5cf13cfb0a$var$_propTypes.default.elementType,
        root: $3e720f5cf13cfb0a$var$_propTypes.default.elementType
    }),
    /**
   * The total steps.
   */ steps: $3e720f5cf13cfb0a$var$_integerPropType.default.isRequired,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $3e720f5cf13cfb0a$var$_propTypes.default.oneOfType([
        $3e720f5cf13cfb0a$var$_propTypes.default.arrayOf($3e720f5cf13cfb0a$var$_propTypes.default.oneOfType([
            $3e720f5cf13cfb0a$var$_propTypes.default.func,
            $3e720f5cf13cfb0a$var$_propTypes.default.object,
            $3e720f5cf13cfb0a$var$_propTypes.default.bool
        ])),
        $3e720f5cf13cfb0a$var$_propTypes.default.func,
        $3e720f5cf13cfb0a$var$_propTypes.default.object
    ]),
    /**
   * The variant to use.
   * @default 'dots'
   */ variant: $3e720f5cf13cfb0a$var$_propTypes.default.oneOf([
        'dots',
        'progress',
        'text'
    ])
};
var $3e720f5cf13cfb0a$var$_default = module.exports.default = $3e720f5cf13cfb0a$var$MobileStepper;

});
parcelRegister("50EKC", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3a5c9021f712a37c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getMobileStepperUtilityClass = $3a5c9021f712a37c$var$getMobileStepperUtilityClass;

var $3a5c9021f712a37c$var$_generateUtilityClasses = $3a5c9021f712a37c$require$_interopRequireDefault((parcelRequire("5nY49")));

var $3a5c9021f712a37c$var$_generateUtilityClass = $3a5c9021f712a37c$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $3a5c9021f712a37c$var$getMobileStepperUtilityClass(slot) {
    return (0, $3a5c9021f712a37c$var$_generateUtilityClass.default)('MuiMobileStepper', slot);
}
const $3a5c9021f712a37c$var$mobileStepperClasses = (0, $3a5c9021f712a37c$var$_generateUtilityClasses.default)('MuiMobileStepper', [
    'root',
    'positionBottom',
    'positionTop',
    'positionStatic',
    'dots',
    'dot',
    'dotActive',
    'progress'
]);
var $3a5c9021f712a37c$var$_default = module.exports.default = $3a5c9021f712a37c$var$mobileStepperClasses;

});



parcelRegister("24k8B", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $181b936a865fd5c4$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $181b936a865fd5c4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $181b936a865fd5c4$var$_exportNames = {
    nativeSelectClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $181b936a865fd5c4$var$_NativeSelect.default;
    }
});
Object.defineProperty(module.exports, "nativeSelectClasses", {
    enumerable: true,
    get: function() {
        return $181b936a865fd5c4$var$_nativeSelectClasses.default;
    }
});

var $181b936a865fd5c4$var$_NativeSelect = $181b936a865fd5c4$require$_interopRequireDefault((parcelRequire("5cKqR")));

var $181b936a865fd5c4$var$_nativeSelectClasses = $181b936a865fd5c4$require$_interopRequireWildcard((parcelRequire("6jVRo")));
Object.keys($181b936a865fd5c4$var$_nativeSelectClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($181b936a865fd5c4$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $181b936a865fd5c4$var$_nativeSelectClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $181b936a865fd5c4$var$_nativeSelectClasses[key];
        }
    });
});

});
parcelRegister("5cKqR", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $3ca2173d4de87b59$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $3ca2173d4de87b59$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3ca2173d4de87b59$var$React = $3ca2173d4de87b59$require$_interopRequireWildcard((parcelRequire("acw62")));

var $3ca2173d4de87b59$var$_clsx = $3ca2173d4de87b59$require$_interopRequireDefault((parcelRequire("9QePP")));

var $3ca2173d4de87b59$var$_propTypes = $3ca2173d4de87b59$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $3ca2173d4de87b59$var$_composeClasses = $3ca2173d4de87b59$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $3ca2173d4de87b59$var$_NativeSelectInput = $3ca2173d4de87b59$require$_interopRequireDefault((parcelRequire("iOErJ")));

var $3ca2173d4de87b59$var$_formControlState = $3ca2173d4de87b59$require$_interopRequireDefault((parcelRequire("aaphR")));

var $3ca2173d4de87b59$var$_useFormControl = $3ca2173d4de87b59$require$_interopRequireDefault((parcelRequire("cJQfW")));

var $3ca2173d4de87b59$var$_ArrowDropDown = $3ca2173d4de87b59$require$_interopRequireDefault((parcelRequire("7LRfY")));

var $3ca2173d4de87b59$var$_Input = $3ca2173d4de87b59$require$_interopRequireDefault((parcelRequire("eAJp9")));

var $hL1nr = parcelRequire("hL1nr");

var $6jVRo = parcelRequire("6jVRo");

var $ayMG0 = parcelRequire("ayMG0");
const $3ca2173d4de87b59$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $3ca2173d4de87b59$var$_composeClasses.default)(slots, $6jVRo.getNativeSelectUtilityClasses, classes);
};
const $3ca2173d4de87b59$var$defaultInput = /*#__PURE__*/ (0, $ayMG0.jsx)($3ca2173d4de87b59$var$_Input.default, {});
/**
 * An alternative to `<Select native />` with a much smaller bundle size footprint.
 */ const $3ca2173d4de87b59$var$NativeSelect = /*#__PURE__*/ $3ca2173d4de87b59$var$React.forwardRef(function NativeSelect(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        name: 'MuiNativeSelect',
        props: inProps
    });
    const { className: className, children: children, classes: classesProp = {}, IconComponent: IconComponent = $3ca2173d4de87b59$var$_ArrowDropDown.default, input: input = $3ca2173d4de87b59$var$defaultInput, inputProps: inputProps, variant: variant, ...other } = props;
    const muiFormControl = (0, $3ca2173d4de87b59$var$_useFormControl.default)();
    const fcs = (0, $3ca2173d4de87b59$var$_formControlState.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant'
        ]
    });
    const ownerState = {
        ...props,
        classes: classesProp
    };
    const classes = $3ca2173d4de87b59$var$useUtilityClasses(ownerState);
    const { root: root, ...otherClasses } = classesProp;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3ca2173d4de87b59$var$React.Fragment, {
        children: /*#__PURE__*/ $3ca2173d4de87b59$var$React.cloneElement(input, {
            // Most of the logic is implemented in `NativeSelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent: $3ca2173d4de87b59$var$_NativeSelectInput.default,
            inputProps: {
                children: children,
                classes: otherClasses,
                IconComponent: IconComponent,
                variant: fcs.variant,
                type: undefined,
                // We render a select. We can ignore the type provided by the `Input`.
                ...inputProps,
                ...input ? input.props.inputProps : {}
            },
            ref: ref,
            ...other,
            className: (0, $3ca2173d4de87b59$var$_clsx.default)(classes.root, input.props.className, className)
        })
    });
});
$3ca2173d4de87b59$var$NativeSelect.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */ children: $3ca2173d4de87b59$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   * @default {}
   */ classes: $3ca2173d4de87b59$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $3ca2173d4de87b59$var$_propTypes.default.string,
    /**
   * The icon that displays the arrow.
   * @default ArrowDropDownIcon
   */ IconComponent: $3ca2173d4de87b59$var$_propTypes.default.elementType,
    /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   * @default <Input />
   */ input: $3ca2173d4de87b59$var$_propTypes.default.element,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/select#attributes) applied to the `select` element.
   */ inputProps: $3ca2173d4de87b59$var$_propTypes.default.object,
    /**
   * Callback fired when a menu item is selected.
   *
   * @param {React.ChangeEvent<HTMLSelectElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */ onChange: $3ca2173d4de87b59$var$_propTypes.default.func,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $3ca2173d4de87b59$var$_propTypes.default.oneOfType([
        $3ca2173d4de87b59$var$_propTypes.default.arrayOf($3ca2173d4de87b59$var$_propTypes.default.oneOfType([
            $3ca2173d4de87b59$var$_propTypes.default.func,
            $3ca2173d4de87b59$var$_propTypes.default.object,
            $3ca2173d4de87b59$var$_propTypes.default.bool
        ])),
        $3ca2173d4de87b59$var$_propTypes.default.func,
        $3ca2173d4de87b59$var$_propTypes.default.object
    ]),
    /**
   * The `input` value. The DOM API casts this to a string.
   */ value: $3ca2173d4de87b59$var$_propTypes.default.any,
    /**
   * The variant to use.
   */ variant: $3ca2173d4de87b59$var$_propTypes.default.oneOf([
        'filled',
        'outlined',
        'standard'
    ])
};
$3ca2173d4de87b59$var$NativeSelect.muiName = 'Select';
var $3ca2173d4de87b59$var$_default = module.exports.default = $3ca2173d4de87b59$var$NativeSelect;

});


parcelRegister("cQC3m", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $95a7dbf177b90875$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $95a7dbf177b90875$var$_NoSsr.default;
    }
});

var $95a7dbf177b90875$var$_NoSsr = $95a7dbf177b90875$require$_interopRequireDefault((parcelRequire("4W06i")));

});
parcelRegister("4W06i", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $397ca82a6faac65f$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $397ca82a6faac65f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $397ca82a6faac65f$var$React = $397ca82a6faac65f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $397ca82a6faac65f$var$_propTypes = $397ca82a6faac65f$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $397ca82a6faac65f$var$_useEnhancedEffect = $397ca82a6faac65f$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $397ca82a6faac65f$var$_exactProp = $397ca82a6faac65f$require$_interopRequireDefault((parcelRequire("5S3aN")));
/**
 * NoSsr purposely removes components from the subject of Server Side Rendering (SSR).
 *
 * This component can be useful in a variety of situations:
 *
 * * Escape hatch for broken dependencies not supporting SSR.
 * * Improve the time-to-first paint on the client by only rendering above the fold.
 * * Reduce the rendering time on the server.
 * * Under too heavy server load, you can turn on service degradation.
 *
 * Demos:
 *
 * - [No SSR](https://v7.mui.com/material-ui/react-no-ssr/)
 *
 * API:
 *
 * - [NoSsr API](https://v7.mui.com/material-ui/api/no-ssr/)
 */ function $397ca82a6faac65f$var$NoSsr(props) {
    const { children: children, defer: defer = false, fallback: fallback = null } = props;
    const [mountedState, setMountedState] = $397ca82a6faac65f$var$React.useState(false);
    (0, $397ca82a6faac65f$var$_useEnhancedEffect.default)(()=>{
        if (!defer) setMountedState(true);
    }, [
        defer
    ]);
    $397ca82a6faac65f$var$React.useEffect(()=>{
        if (defer) setMountedState(true);
    }, [
        defer
    ]);
    // TODO casting won't be needed at one point https://github.com/DefinitelyTyped/DefinitelyTyped/pull/65135
    return mountedState ? children : fallback;
}
$397ca82a6faac65f$var$NoSsr.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * You can wrap a node.
   */ children: $397ca82a6faac65f$var$_propTypes.default.node,
    /**
   * If `true`, the component will not only prevent server-side rendering.
   * It will also defer the rendering of the children into a different screen frame.
   * @default false
   */ defer: $397ca82a6faac65f$var$_propTypes.default.bool,
    /**
   * The fallback content to display.
   * @default null
   */ fallback: $397ca82a6faac65f$var$_propTypes.default.node
};
// eslint-disable-next-line
$397ca82a6faac65f$var$NoSsr["propTypes"] = (0, $397ca82a6faac65f$var$_exactProp.default)($397ca82a6faac65f$var$NoSsr.propTypes);
var $397ca82a6faac65f$var$_default = module.exports.default = $397ca82a6faac65f$var$NoSsr;

});


parcelRegister("lAj4Z", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $fb6bc293e767dac6$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $fb6bc293e767dac6$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $fb6bc293e767dac6$var$_exportNames = {
    paginationClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $fb6bc293e767dac6$var$_Pagination.default;
    }
});
Object.defineProperty(module.exports, "paginationClasses", {
    enumerable: true,
    get: function() {
        return $fb6bc293e767dac6$var$_paginationClasses.default;
    }
});

var $fb6bc293e767dac6$var$_Pagination = $fb6bc293e767dac6$require$_interopRequireDefault((parcelRequire("GXAmj")));

var $fb6bc293e767dac6$var$_paginationClasses = $fb6bc293e767dac6$require$_interopRequireWildcard((parcelRequire("jozOO")));
Object.keys($fb6bc293e767dac6$var$_paginationClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($fb6bc293e767dac6$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $fb6bc293e767dac6$var$_paginationClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fb6bc293e767dac6$var$_paginationClasses[key];
        }
    });
});

});
parcelRegister("GXAmj", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $081224c8d3cb055f$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $081224c8d3cb055f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $081224c8d3cb055f$var$React = $081224c8d3cb055f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $081224c8d3cb055f$var$_propTypes = $081224c8d3cb055f$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $081224c8d3cb055f$var$_clsx = $081224c8d3cb055f$require$_interopRequireDefault((parcelRequire("9QePP")));

var $081224c8d3cb055f$var$_composeClasses = $081224c8d3cb055f$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $081224c8d3cb055f$var$_integerPropType = $081224c8d3cb055f$require$_interopRequireDefault((parcelRequire("cxaSP")));

var $jozOO = parcelRequire("jozOO");

var $081224c8d3cb055f$var$_usePagination = $081224c8d3cb055f$require$_interopRequireDefault((parcelRequire("8WIPv")));

var $081224c8d3cb055f$var$_PaginationItem = $081224c8d3cb055f$require$_interopRequireDefault((parcelRequire("5SUZl")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $ayMG0 = parcelRequire("ayMG0");
const $081224c8d3cb055f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant
        ],
        ul: [
            'ul'
        ]
    };
    return (0, $081224c8d3cb055f$var$_composeClasses.default)(slots, $jozOO.getPaginationUtilityClass, classes);
};
const $081224c8d3cb055f$var$PaginationRoot = (0, $aAbgT.styled)('nav', {
    name: 'MuiPagination',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant]
        ];
    }
})({});
const $081224c8d3cb055f$var$PaginationUl = (0, $aAbgT.styled)('ul', {
    name: 'MuiPagination',
    slot: 'Ul'
})({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: 0,
    margin: 0,
    listStyle: 'none'
});
function $081224c8d3cb055f$var$defaultGetAriaLabel(type, page, selected) {
    if (type === 'page') return `${selected ? '' : 'Go to '}page ${page}`;
    return `Go to ${type} page`;
}
const $081224c8d3cb055f$var$Pagination = /*#__PURE__*/ $081224c8d3cb055f$var$React.forwardRef(function Pagination(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiPagination'
    });
    const { boundaryCount: boundaryCount = 1, className: className, color: color = 'standard', count: count = 1, defaultPage: defaultPage = 1, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel = $081224c8d3cb055f$var$defaultGetAriaLabel, hideNextButton: hideNextButton = false, hidePrevButton: hidePrevButton = false, onChange: onChange, page: page, renderItem: renderItem = (item)=>/*#__PURE__*/ (0, $ayMG0.jsx)($081224c8d3cb055f$var$_PaginationItem.default, {
            ...item
        }), shape: shape = 'circular', showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, siblingCount: siblingCount = 1, size: size = 'medium', variant: variant = 'text', ...other } = props;
    const { items: items } = (0, $081224c8d3cb055f$var$_usePagination.default)({
        ...props,
        componentName: 'Pagination'
    });
    const ownerState = {
        ...props,
        boundaryCount: boundaryCount,
        color: color,
        count: count,
        defaultPage: defaultPage,
        disabled: disabled,
        getItemAriaLabel: getItemAriaLabel,
        hideNextButton: hideNextButton,
        hidePrevButton: hidePrevButton,
        renderItem: renderItem,
        shape: shape,
        showFirstButton: showFirstButton,
        showLastButton: showLastButton,
        siblingCount: siblingCount,
        size: size,
        variant: variant
    };
    const classes = $081224c8d3cb055f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($081224c8d3cb055f$var$PaginationRoot, {
        "aria-label": "pagination navigation",
        className: (0, $081224c8d3cb055f$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($081224c8d3cb055f$var$PaginationUl, {
            className: classes.ul,
            ownerState: ownerState,
            children: items.map((item, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                    children: renderItem({
                        ...item,
                        color: color,
                        'aria-label': getItemAriaLabel(item.type, item.page, item.selected),
                        shape: shape,
                        size: size,
                        variant: variant
                    })
                }, index))
        })
    });
});
// @default tags synced with default values from usePagination
$081224c8d3cb055f$var$Pagination.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Number of always visible pages at the beginning and end.
   * @default 1
   */ boundaryCount: $081224c8d3cb055f$var$_integerPropType.default,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $081224c8d3cb055f$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $081224c8d3cb055f$var$_propTypes.default.string,
    /**
   * The active color.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */ color: $081224c8d3cb055f$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $081224c8d3cb055f$var$_propTypes.default.oneOf([
            'primary',
            'secondary',
            'standard'
        ]),
        $081224c8d3cb055f$var$_propTypes.default.string
    ]),
    /**
   * The total number of pages.
   * @default 1
   */ count: $081224c8d3cb055f$var$_integerPropType.default,
    /**
   * The page selected by default when the component is uncontrolled.
   * @default 1
   */ defaultPage: $081224c8d3cb055f$var$_integerPropType.default,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: $081224c8d3cb055f$var$_propTypes.default.bool,
    /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   * This is important for screen reader users.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @param {string} type The link or button type to format ('page' | 'first' | 'last' | 'next' | 'previous' | 'start-ellipsis' | 'end-ellipsis'). Defaults to 'page'.
   * @param {number | null} page The page number to format.
   * @param {boolean} selected If true, the current page is selected.
   * @returns {string}
   */ getItemAriaLabel: $081224c8d3cb055f$var$_propTypes.default.func,
    /**
   * If `true`, hide the next-page button.
   * @default false
   */ hideNextButton: $081224c8d3cb055f$var$_propTypes.default.bool,
    /**
   * If `true`, hide the previous-page button.
   * @default false
   */ hidePrevButton: $081224c8d3cb055f$var$_propTypes.default.bool,
    /**
   * Callback fired when the page is changed.
   *
   * @param {React.ChangeEvent<unknown>} event The event source of the callback.
   * @param {number} page The page selected.
   */ onChange: $081224c8d3cb055f$var$_propTypes.default.func,
    /**
   * The current page. Unlike `TablePagination`, which starts numbering from `0`, this pagination starts from `1`.
   */ page: $081224c8d3cb055f$var$_integerPropType.default,
    /**
   * Render the item.
   * @param {PaginationRenderItemParams} params The props to spread on a PaginationItem.
   * @returns {ReactNode}
   * @default (item) => <PaginationItem {...item} />
   */ renderItem: $081224c8d3cb055f$var$_propTypes.default.func,
    /**
   * The shape of the pagination items.
   * @default 'circular'
   */ shape: $081224c8d3cb055f$var$_propTypes.default.oneOf([
        'circular',
        'rounded'
    ]),
    /**
   * If `true`, show the first-page button.
   * @default false
   */ showFirstButton: $081224c8d3cb055f$var$_propTypes.default.bool,
    /**
   * If `true`, show the last-page button.
   * @default false
   */ showLastButton: $081224c8d3cb055f$var$_propTypes.default.bool,
    /**
   * Number of always visible pages before and after the current page.
   * @default 1
   */ siblingCount: $081224c8d3cb055f$var$_integerPropType.default,
    /**
   * The size of the component.
   * @default 'medium'
   */ size: $081224c8d3cb055f$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $081224c8d3cb055f$var$_propTypes.default.oneOf([
            'small',
            'medium',
            'large'
        ]),
        $081224c8d3cb055f$var$_propTypes.default.string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $081224c8d3cb055f$var$_propTypes.default.oneOfType([
        $081224c8d3cb055f$var$_propTypes.default.arrayOf($081224c8d3cb055f$var$_propTypes.default.oneOfType([
            $081224c8d3cb055f$var$_propTypes.default.func,
            $081224c8d3cb055f$var$_propTypes.default.object,
            $081224c8d3cb055f$var$_propTypes.default.bool
        ])),
        $081224c8d3cb055f$var$_propTypes.default.func,
        $081224c8d3cb055f$var$_propTypes.default.object
    ]),
    /**
   * The variant to use.
   * @default 'text'
   */ variant: $081224c8d3cb055f$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $081224c8d3cb055f$var$_propTypes.default.oneOf([
            'outlined',
            'text'
        ]),
        $081224c8d3cb055f$var$_propTypes.default.string
    ])
};
var $081224c8d3cb055f$var$_default = module.exports.default = $081224c8d3cb055f$var$Pagination;

});
parcelRegister("jozOO", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e1ec0b0c4e143dec$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getPaginationUtilityClass = $e1ec0b0c4e143dec$var$getPaginationUtilityClass;

var $e1ec0b0c4e143dec$var$_generateUtilityClasses = $e1ec0b0c4e143dec$require$_interopRequireDefault((parcelRequire("5nY49")));

var $e1ec0b0c4e143dec$var$_generateUtilityClass = $e1ec0b0c4e143dec$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $e1ec0b0c4e143dec$var$getPaginationUtilityClass(slot) {
    return (0, $e1ec0b0c4e143dec$var$_generateUtilityClass.default)('MuiPagination', slot);
}
const $e1ec0b0c4e143dec$var$paginationClasses = (0, $e1ec0b0c4e143dec$var$_generateUtilityClasses.default)('MuiPagination', [
    'root',
    'ul',
    'outlined',
    'text'
]);
var $e1ec0b0c4e143dec$var$_default = module.exports.default = $e1ec0b0c4e143dec$var$paginationClasses;

});

parcelRegister("8WIPv", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $683683be0e6e5e52$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $683683be0e6e5e52$var$_usePagination.default;
    }
});

var $683683be0e6e5e52$var$_usePagination = $683683be0e6e5e52$require$_interopRequireDefault((parcelRequire("lIrIv")));

});
parcelRegister("lIrIv", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $fcf3350ab6dcf91e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fcf3350ab6dcf91e$var$usePagination;

var $fcf3350ab6dcf91e$var$_useControlled = $fcf3350ab6dcf91e$require$_interopRequireDefault((parcelRequire("iSpB2")));
function $fcf3350ab6dcf91e$var$usePagination(props = {}) {
    // keep default values in sync with @default tags in Pagination.propTypes
    const { boundaryCount: boundaryCount = 1, componentName: componentName = 'usePagination', count: count = 1, defaultPage: defaultPage = 1, disabled: disabled = false, hideNextButton: hideNextButton = false, hidePrevButton: hidePrevButton = false, onChange: handleChange, page: pageProp, showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, siblingCount: siblingCount = 1, ...other } = props;
    const [page, setPageState] = (0, $fcf3350ab6dcf91e$var$_useControlled.default)({
        controlled: pageProp,
        default: defaultPage,
        name: componentName,
        state: 'page'
    });
    const handleClick = (event, value)=>{
        if (!pageProp) setPageState(value);
        if (handleChange) handleChange(event, value);
    };
    // https://dev.to/namirsab/comment/2050
    const range = (start, end)=>{
        const length = end - start + 1;
        return Array.from({
            length: length
        }, (_, i)=>start + i);
    };
    const startPages = range(1, Math.min(boundaryCount, count));
    const endPages = range(Math.max(count - boundaryCount + 1, boundaryCount + 1), count);
    const siblingsStart = Math.max(Math.min(// Natural start
    page - siblingCount, // Lower boundary when page is high
    count - boundaryCount - siblingCount * 2 - 1), // Greater than startPages
    boundaryCount + 2);
    const siblingsEnd = Math.min(Math.max(// Natural end
    page + siblingCount, // Upper boundary when page is low
    boundaryCount + siblingCount * 2 + 2), // Less than endPages
    count - boundaryCount - 1);
    // Basic list of items to render
    // for example itemList = ['first', 'previous', 1, 'ellipsis', 4, 5, 6, 'ellipsis', 10, 'next', 'last']
    const itemList = [
        ...showFirstButton ? [
            'first'
        ] : [],
        ...hidePrevButton ? [] : [
            'previous'
        ],
        ...startPages,
        // Start ellipsis
        // eslint-disable-next-line no-nested-ternary
        ...siblingsStart > boundaryCount + 2 ? [
            'start-ellipsis'
        ] : boundaryCount + 1 < count - boundaryCount ? [
            boundaryCount + 1
        ] : [],
        // Sibling pages
        ...range(siblingsStart, siblingsEnd),
        // End ellipsis
        // eslint-disable-next-line no-nested-ternary
        ...siblingsEnd < count - boundaryCount - 1 ? [
            'end-ellipsis'
        ] : count - boundaryCount > boundaryCount ? [
            count - boundaryCount
        ] : [],
        ...endPages,
        ...hideNextButton ? [] : [
            'next'
        ],
        ...showLastButton ? [
            'last'
        ] : []
    ];
    // Map the button type to its page number
    const buttonPage = (type)=>{
        switch(type){
            case 'first':
                return 1;
            case 'previous':
                return page - 1;
            case 'next':
                return page + 1;
            case 'last':
                return count;
            default:
                return null;
        }
    };
    // Convert the basic item list to PaginationItem props objects
    const items = itemList.map((item)=>{
        return typeof item === 'number' ? {
            onClick: (event)=>{
                handleClick(event, item);
            },
            type: 'page',
            page: item,
            selected: item === page,
            disabled: disabled,
            'aria-current': item === page ? 'page' : undefined
        } : {
            onClick: (event)=>{
                handleClick(event, buttonPage(item));
            },
            type: item,
            page: buttonPage(item),
            selected: false,
            disabled: disabled || !item.includes('ellipsis') && (item === 'next' || item === 'last' ? page >= count : page <= 1)
        };
    });
    return {
        items: items,
        ...other
    };
}

});


parcelRegister("5SUZl", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $448e339b1c87d651$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $448e339b1c87d651$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $448e339b1c87d651$var$_exportNames = {
    paginationItemClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $448e339b1c87d651$var$_PaginationItem.default;
    }
});
Object.defineProperty(module.exports, "paginationItemClasses", {
    enumerable: true,
    get: function() {
        return $448e339b1c87d651$var$_paginationItemClasses.default;
    }
});

var $448e339b1c87d651$var$_PaginationItem = $448e339b1c87d651$require$_interopRequireDefault((parcelRequire("973a9")));

var $448e339b1c87d651$var$_paginationItemClasses = $448e339b1c87d651$require$_interopRequireWildcard((parcelRequire("97hzb")));
Object.keys($448e339b1c87d651$var$_paginationItemClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($448e339b1c87d651$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $448e339b1c87d651$var$_paginationItemClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $448e339b1c87d651$var$_paginationItemClasses[key];
        }
    });
});

});
parcelRegister("973a9", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $6a273894865f8b08$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $6a273894865f8b08$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6a273894865f8b08$var$React = $6a273894865f8b08$require$_interopRequireWildcard((parcelRequire("acw62")));

var $6a273894865f8b08$var$_propTypes = $6a273894865f8b08$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $6a273894865f8b08$var$_clsx = $6a273894865f8b08$require$_interopRequireDefault((parcelRequire("9QePP")));

var $6a273894865f8b08$var$_composeClasses = $6a273894865f8b08$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $9uEev = parcelRequire("9uEev");

var $6a273894865f8b08$var$_paginationItemClasses = $6a273894865f8b08$require$_interopRequireWildcard((parcelRequire("97hzb")));

var $6a273894865f8b08$var$_ButtonBase = $6a273894865f8b08$require$_interopRequireDefault((parcelRequire("hhs3r")));

var $6a273894865f8b08$var$_capitalize = $6a273894865f8b08$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $6a273894865f8b08$var$_createSimplePaletteValueFilter = $6a273894865f8b08$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $6a273894865f8b08$var$_FirstPage = $6a273894865f8b08$require$_interopRequireDefault((parcelRequire("21SL6")));

var $6a273894865f8b08$var$_LastPage = $6a273894865f8b08$require$_interopRequireDefault((parcelRequire("5izos")));

var $6a273894865f8b08$var$_NavigateBefore = $6a273894865f8b08$require$_interopRequireDefault((parcelRequire("3kz9M")));

var $6a273894865f8b08$var$_NavigateNext = $6a273894865f8b08$require$_interopRequireDefault((parcelRequire("89ow0")));

var $6a273894865f8b08$var$_useSlot = $6a273894865f8b08$require$_interopRequireDefault((parcelRequire("6lpak")));

var $aAbgT = parcelRequire("aAbgT");

var $6a273894865f8b08$var$_memoTheme = $6a273894865f8b08$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $ayMG0 = parcelRequire("ayMG0");
const $6a273894865f8b08$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[ownerState.variant],
        styles[`size${(0, $6a273894865f8b08$var$_capitalize.default)(ownerState.size)}`],
        ownerState.variant === 'text' && styles[`text${(0, $6a273894865f8b08$var$_capitalize.default)(ownerState.color)}`],
        ownerState.variant === 'outlined' && styles[`outlined${(0, $6a273894865f8b08$var$_capitalize.default)(ownerState.color)}`],
        ownerState.shape === 'rounded' && styles.rounded,
        ownerState.type === 'page' && styles.page,
        (ownerState.type === 'start-ellipsis' || ownerState.type === 'end-ellipsis') && styles.ellipsis,
        (ownerState.type === 'previous' || ownerState.type === 'next') && styles.previousNext,
        (ownerState.type === 'first' || ownerState.type === 'last') && styles.firstLast
    ];
};
const $6a273894865f8b08$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, selected: selected, size: size, shape: shape, type: type, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            `size${(0, $6a273894865f8b08$var$_capitalize.default)(size)}`,
            variant,
            shape,
            color !== 'standard' && `color${(0, $6a273894865f8b08$var$_capitalize.default)(color)}`,
            color !== 'standard' && `${variant}${(0, $6a273894865f8b08$var$_capitalize.default)(color)}`,
            disabled && 'disabled',
            selected && 'selected',
            {
                page: 'page',
                first: 'firstLast',
                last: 'firstLast',
                'start-ellipsis': 'ellipsis',
                'end-ellipsis': 'ellipsis',
                previous: 'previousNext',
                next: 'previousNext'
            }[type]
        ],
        icon: [
            'icon'
        ]
    };
    return (0, $6a273894865f8b08$var$_composeClasses.default)(slots, $6a273894865f8b08$var$_paginationItemClasses.getPaginationItemUtilityClass, classes);
};
const $6a273894865f8b08$var$PaginationItemEllipsis = (0, $aAbgT.styled)('div', {
    name: 'MuiPaginationItem',
    slot: 'Root',
    overridesResolver: $6a273894865f8b08$var$overridesResolver
})((0, $6a273894865f8b08$var$_memoTheme.default)(({ theme: theme })=>({
        ...theme.typography.body2,
        borderRadius: 16,
        textAlign: 'center',
        boxSizing: 'border-box',
        minWidth: 32,
        padding: '0 6px',
        margin: '0 3px',
        color: (theme.vars || theme).palette.text.primary,
        height: 'auto',
        [`&.${$6a273894865f8b08$var$_paginationItemClasses.default.disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    minWidth: 26,
                    borderRadius: 13,
                    margin: '0 1px',
                    padding: '0 4px'
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    minWidth: 40,
                    borderRadius: 20,
                    padding: '0 10px',
                    fontSize: theme.typography.pxToRem(15)
                }
            }
        ]
    })));
const $6a273894865f8b08$var$PaginationItemPage = (0, $aAbgT.styled)($6a273894865f8b08$var$_ButtonBase.default, {
    name: 'MuiPaginationItem',
    slot: 'Root',
    overridesResolver: $6a273894865f8b08$var$overridesResolver
})((0, $6a273894865f8b08$var$_memoTheme.default)(({ theme: theme })=>({
        ...theme.typography.body2,
        borderRadius: 16,
        textAlign: 'center',
        boxSizing: 'border-box',
        minWidth: 32,
        height: 32,
        padding: '0 6px',
        margin: '0 3px',
        color: (theme.vars || theme).palette.text.primary,
        [`&.${$6a273894865f8b08$var$_paginationItemClasses.default.focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${$6a273894865f8b08$var$_paginationItemClasses.default.disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        transition: theme.transitions.create([
            'color',
            'background-color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': {
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${$6a273894865f8b08$var$_paginationItemClasses.default.selected}`]: {
            backgroundColor: (theme.vars || theme).palette.action.selected,
            '&:hover': {
                backgroundColor: theme.alpha((theme.vars || theme).palette.action.selected, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: (theme.vars || theme).palette.action.selected
                }
            },
            [`&.${$6a273894865f8b08$var$_paginationItemClasses.default.focusVisible}`]: {
                backgroundColor: theme.alpha((theme.vars || theme).palette.action.selected, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
            },
            [`&.${$6a273894865f8b08$var$_paginationItemClasses.default.disabled}`]: {
                opacity: 1,
                color: (theme.vars || theme).palette.action.disabled,
                backgroundColor: (theme.vars || theme).palette.action.selected
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    minWidth: 26,
                    height: 26,
                    borderRadius: 13,
                    margin: '0 1px',
                    padding: '0 4px'
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    minWidth: 40,
                    height: 40,
                    borderRadius: 20,
                    padding: '0 10px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    shape: 'rounded'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    border: theme.vars ? `1px solid ${theme.alpha(theme.vars.palette.common.onBackground, 0.23)}` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
                    [`&.${$6a273894865f8b08$var$_paginationItemClasses.default.selected}`]: {
                        [`&.${$6a273894865f8b08$var$_paginationItemClasses.default.disabled}`]: {
                            borderColor: (theme.vars || theme).palette.action.disabledBackground,
                            color: (theme.vars || theme).palette.action.disabled
                        }
                    }
                }
            },
            {
                props: {
                    variant: 'text'
                },
                style: {
                    [`&.${$6a273894865f8b08$var$_paginationItemClasses.default.selected}`]: {
                        [`&.${$6a273894865f8b08$var$_paginationItemClasses.default.disabled}`]: {
                            color: (theme.vars || theme).palette.action.disabled
                        }
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $6a273894865f8b08$var$_createSimplePaletteValueFilter.default)([
                'dark',
                'contrastText'
            ])).map(([color])=>({
                    props: {
                        variant: 'text',
                        color: color
                    },
                    style: {
                        [`&.${$6a273894865f8b08$var$_paginationItemClasses.default.selected}`]: {
                            color: (theme.vars || theme).palette[color].contrastText,
                            backgroundColor: (theme.vars || theme).palette[color].main,
                            '&:hover': {
                                backgroundColor: (theme.vars || theme).palette[color].dark,
                                // Reset on touch devices, it doesn't add specificity
                                '@media (hover: none)': {
                                    backgroundColor: (theme.vars || theme).palette[color].main
                                }
                            },
                            [`&.${$6a273894865f8b08$var$_paginationItemClasses.default.focusVisible}`]: {
                                backgroundColor: (theme.vars || theme).palette[color].dark
                            },
                            [`&.${$6a273894865f8b08$var$_paginationItemClasses.default.disabled}`]: {
                                color: (theme.vars || theme).palette.action.disabled
                            }
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $6a273894865f8b08$var$_createSimplePaletteValueFilter.default)([
                'light'
            ])).map(([color])=>({
                    props: {
                        variant: 'outlined',
                        color: color
                    },
                    style: {
                        [`&.${$6a273894865f8b08$var$_paginationItemClasses.default.selected}`]: {
                            color: (theme.vars || theme).palette[color].main,
                            border: `1px solid ${theme.alpha((theme.vars || theme).palette[color].main, 0.5)}`,
                            backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.activatedOpacity),
                            '&:hover': {
                                backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, `${(theme.vars || theme).palette.action.activatedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`),
                                // Reset on touch devices, it doesn't add specificity
                                '@media (hover: none)': {
                                    backgroundColor: 'transparent'
                                }
                            },
                            [`&.${$6a273894865f8b08$var$_paginationItemClasses.default.focusVisible}`]: {
                                backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, `${(theme.vars || theme).palette.action.activatedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
                            }
                        }
                    }
                }))
        ]
    })));
const $6a273894865f8b08$var$PaginationItemPageIcon = (0, $aAbgT.styled)('div', {
    name: 'MuiPaginationItem',
    slot: 'Icon'
})((0, $6a273894865f8b08$var$_memoTheme.default)(({ theme: theme })=>({
        fontSize: theme.typography.pxToRem(20),
        margin: '0 -8px',
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    fontSize: theme.typography.pxToRem(18)
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    fontSize: theme.typography.pxToRem(22)
                }
            }
        ]
    })));
const $6a273894865f8b08$var$PaginationItem = /*#__PURE__*/ $6a273894865f8b08$var$React.forwardRef(function PaginationItem(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiPaginationItem'
    });
    const { className: className, color: color = 'standard', component: component, components: components = {}, disabled: disabled = false, page: page, selected: selected = false, shape: shape = 'circular', size: size = 'medium', slots: slots = {}, slotProps: slotProps = {}, type: type = 'page', variant: variant = 'text', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        disabled: disabled,
        selected: selected,
        shape: shape,
        size: size,
        type: type,
        variant: variant
    };
    const isRtl = (0, $9uEev.useRtl)();
    const classes = $6a273894865f8b08$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: {
            previous: slots.previous ?? components.previous,
            next: slots.next ?? components.next,
            first: slots.first ?? components.first,
            last: slots.last ?? components.last
        },
        slotProps: slotProps
    };
    const [PreviousSlot, previousSlotProps] = (0, $6a273894865f8b08$var$_useSlot.default)('previous', {
        elementType: $6a273894865f8b08$var$_NavigateBefore.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [NextSlot, nextSlotProps] = (0, $6a273894865f8b08$var$_useSlot.default)('next', {
        elementType: $6a273894865f8b08$var$_NavigateNext.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [FirstSlot, firstSlotProps] = (0, $6a273894865f8b08$var$_useSlot.default)('first', {
        elementType: $6a273894865f8b08$var$_FirstPage.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [LastSlot, lastSlotProps] = (0, $6a273894865f8b08$var$_useSlot.default)('last', {
        elementType: $6a273894865f8b08$var$_LastPage.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const rtlAwareType = isRtl ? ({
        previous: 'next',
        next: 'previous',
        first: 'last',
        last: 'first'
    })[type] : type;
    const IconSlot = {
        previous: PreviousSlot,
        next: NextSlot,
        first: FirstSlot,
        last: LastSlot
    }[rtlAwareType];
    const iconSlotProps = {
        previous: previousSlotProps,
        next: nextSlotProps,
        first: firstSlotProps,
        last: lastSlotProps
    }[rtlAwareType];
    return type === 'start-ellipsis' || type === 'end-ellipsis' ? /*#__PURE__*/ (0, $ayMG0.jsx)($6a273894865f8b08$var$PaginationItemEllipsis, {
        ref: ref,
        ownerState: ownerState,
        className: (0, $6a273894865f8b08$var$_clsx.default)(classes.root, className),
        children: "\u2026"
    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($6a273894865f8b08$var$PaginationItemPage, {
        ref: ref,
        ownerState: ownerState,
        component: component,
        disabled: disabled,
        className: (0, $6a273894865f8b08$var$_clsx.default)(classes.root, className),
        ...other,
        children: [
            type === 'page' && page,
            IconSlot ? /*#__PURE__*/ (0, $ayMG0.jsx)($6a273894865f8b08$var$PaginationItemPageIcon, {
                ...iconSlotProps,
                className: classes.icon,
                as: IconSlot
            }) : null
        ]
    });
});
$6a273894865f8b08$var$PaginationItem.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * @ignore
   */ children: $6a273894865f8b08$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $6a273894865f8b08$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $6a273894865f8b08$var$_propTypes.default.string,
    /**
   * The active color.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */ color: $6a273894865f8b08$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $6a273894865f8b08$var$_propTypes.default.oneOf([
            'primary',
            'secondary',
            'standard'
        ]),
        $6a273894865f8b08$var$_propTypes.default.string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $6a273894865f8b08$var$_propTypes.default.elementType,
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   * @deprecated use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ components: $6a273894865f8b08$var$_propTypes.default.shape({
        first: $6a273894865f8b08$var$_propTypes.default.elementType,
        last: $6a273894865f8b08$var$_propTypes.default.elementType,
        next: $6a273894865f8b08$var$_propTypes.default.elementType,
        previous: $6a273894865f8b08$var$_propTypes.default.elementType
    }),
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: $6a273894865f8b08$var$_propTypes.default.bool,
    /**
   * The current page number.
   */ page: $6a273894865f8b08$var$_propTypes.default.node,
    /**
   * If `true` the pagination item is selected.
   * @default false
   */ selected: $6a273894865f8b08$var$_propTypes.default.bool,
    /**
   * The shape of the pagination item.
   * @default 'circular'
   */ shape: $6a273894865f8b08$var$_propTypes.default.oneOf([
        'circular',
        'rounded'
    ]),
    /**
   * The size of the component.
   * @default 'medium'
   */ size: $6a273894865f8b08$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $6a273894865f8b08$var$_propTypes.default.oneOf([
            'small',
            'medium',
            'large'
        ]),
        $6a273894865f8b08$var$_propTypes.default.string
    ]),
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $6a273894865f8b08$var$_propTypes.default.shape({
        first: $6a273894865f8b08$var$_propTypes.default.oneOfType([
            $6a273894865f8b08$var$_propTypes.default.func,
            $6a273894865f8b08$var$_propTypes.default.object
        ]),
        last: $6a273894865f8b08$var$_propTypes.default.oneOfType([
            $6a273894865f8b08$var$_propTypes.default.func,
            $6a273894865f8b08$var$_propTypes.default.object
        ]),
        next: $6a273894865f8b08$var$_propTypes.default.oneOfType([
            $6a273894865f8b08$var$_propTypes.default.func,
            $6a273894865f8b08$var$_propTypes.default.object
        ]),
        previous: $6a273894865f8b08$var$_propTypes.default.oneOfType([
            $6a273894865f8b08$var$_propTypes.default.func,
            $6a273894865f8b08$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: $6a273894865f8b08$var$_propTypes.default.shape({
        first: $6a273894865f8b08$var$_propTypes.default.elementType,
        last: $6a273894865f8b08$var$_propTypes.default.elementType,
        next: $6a273894865f8b08$var$_propTypes.default.elementType,
        previous: $6a273894865f8b08$var$_propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $6a273894865f8b08$var$_propTypes.default.oneOfType([
        $6a273894865f8b08$var$_propTypes.default.arrayOf($6a273894865f8b08$var$_propTypes.default.oneOfType([
            $6a273894865f8b08$var$_propTypes.default.func,
            $6a273894865f8b08$var$_propTypes.default.object,
            $6a273894865f8b08$var$_propTypes.default.bool
        ])),
        $6a273894865f8b08$var$_propTypes.default.func,
        $6a273894865f8b08$var$_propTypes.default.object
    ]),
    /**
   * The type of pagination item.
   * @default 'page'
   */ type: $6a273894865f8b08$var$_propTypes.default.oneOf([
        'end-ellipsis',
        'first',
        'last',
        'next',
        'page',
        'previous',
        'start-ellipsis'
    ]),
    /**
   * The variant to use.
   * @default 'text'
   */ variant: $6a273894865f8b08$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $6a273894865f8b08$var$_propTypes.default.oneOf([
            'outlined',
            'text'
        ]),
        $6a273894865f8b08$var$_propTypes.default.string
    ])
};
var $6a273894865f8b08$var$_default = module.exports.default = $6a273894865f8b08$var$PaginationItem;

});
parcelRegister("97hzb", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $6a3264dc4d579370$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getPaginationItemUtilityClass = $6a3264dc4d579370$var$getPaginationItemUtilityClass;

var $6a3264dc4d579370$var$_generateUtilityClasses = $6a3264dc4d579370$require$_interopRequireDefault((parcelRequire("5nY49")));

var $6a3264dc4d579370$var$_generateUtilityClass = $6a3264dc4d579370$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $6a3264dc4d579370$var$getPaginationItemUtilityClass(slot) {
    return (0, $6a3264dc4d579370$var$_generateUtilityClass.default)('MuiPaginationItem', slot);
}
const $6a3264dc4d579370$var$paginationItemClasses = (0, $6a3264dc4d579370$var$_generateUtilityClasses.default)('MuiPaginationItem', [
    'root',
    'page',
    'sizeSmall',
    'sizeLarge',
    'text',
    'textPrimary',
    'textSecondary',
    'outlined',
    'outlinedPrimary',
    'outlinedSecondary',
    'rounded',
    'ellipsis',
    'firstLast',
    'previousNext',
    'focusVisible',
    'disabled',
    'selected',
    'icon',
    'colorPrimary',
    'colorSecondary'
]);
var $6a3264dc4d579370$var$_default = module.exports.default = $6a3264dc4d579370$var$paginationItemClasses;

});

parcelRegister("3kz9M", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $26ce82c6cc8a75d9$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $26ce82c6cc8a75d9$var$_createSvgIcon = $26ce82c6cc8a75d9$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $26ce82c6cc8a75d9$var$_default = module.exports.default = (0, $26ce82c6cc8a75d9$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), 'NavigateBefore');

});

parcelRegister("89ow0", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $5ef22e36056d1791$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5ef22e36056d1791$var$_createSvgIcon = $5ef22e36056d1791$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $5ef22e36056d1791$var$_default = module.exports.default = (0, $5ef22e36056d1791$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'NavigateNext');

});





parcelRegister("5Gk0e", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $4230641a48862144$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $4230641a48862144$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $4230641a48862144$var$_exportNames = {
    radioClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $4230641a48862144$var$_Radio.default;
    }
});
Object.defineProperty(module.exports, "radioClasses", {
    enumerable: true,
    get: function() {
        return $4230641a48862144$var$_radioClasses.default;
    }
});

var $4230641a48862144$var$_Radio = $4230641a48862144$require$_interopRequireDefault((parcelRequire("hrMZe")));

var $4230641a48862144$var$_radioClasses = $4230641a48862144$require$_interopRequireWildcard((parcelRequire("iHxWE")));
Object.keys($4230641a48862144$var$_radioClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($4230641a48862144$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $4230641a48862144$var$_radioClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4230641a48862144$var$_radioClasses[key];
        }
    });
});

});
parcelRegister("hrMZe", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $cb3af4fea2cad44e$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $cb3af4fea2cad44e$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cb3af4fea2cad44e$var$React = $cb3af4fea2cad44e$require$_interopRequireWildcard((parcelRequire("acw62")));

var $cb3af4fea2cad44e$var$_propTypes = $cb3af4fea2cad44e$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $cb3af4fea2cad44e$var$_clsx = $cb3af4fea2cad44e$require$_interopRequireDefault((parcelRequire("9QePP")));

var $cb3af4fea2cad44e$var$_refType = $cb3af4fea2cad44e$require$_interopRequireDefault((parcelRequire("b3gjr")));

var $cb3af4fea2cad44e$var$_composeClasses = $cb3af4fea2cad44e$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $cb3af4fea2cad44e$var$_SwitchBase = $cb3af4fea2cad44e$require$_interopRequireDefault((parcelRequire("kVqvD")));

var $cb3af4fea2cad44e$var$_RadioButtonIcon = $cb3af4fea2cad44e$require$_interopRequireDefault((parcelRequire("9plBP")));

var $cb3af4fea2cad44e$var$_capitalize = $cb3af4fea2cad44e$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $cb3af4fea2cad44e$var$_createChainedFunction = $cb3af4fea2cad44e$require$_interopRequireDefault((parcelRequire("5gbhl")));

var $cb3af4fea2cad44e$var$_useFormControl = $cb3af4fea2cad44e$require$_interopRequireDefault((parcelRequire("cJQfW")));

var $cb3af4fea2cad44e$var$_useRadioGroup = $cb3af4fea2cad44e$require$_interopRequireDefault((parcelRequire("k0Fx1")));

var $cb3af4fea2cad44e$var$_radioClasses = $cb3af4fea2cad44e$require$_interopRequireWildcard((parcelRequire("iHxWE")));

var $cb3af4fea2cad44e$var$_rootShouldForwardProp = $cb3af4fea2cad44e$require$_interopRequireDefault((parcelRequire("8Uq77")));

var $aAbgT = parcelRequire("aAbgT");

var $cb3af4fea2cad44e$var$_memoTheme = $cb3af4fea2cad44e$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $cb3af4fea2cad44e$var$_createSimplePaletteValueFilter = $cb3af4fea2cad44e$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $cb3af4fea2cad44e$var$_useSlot = $cb3af4fea2cad44e$require$_interopRequireDefault((parcelRequire("6lpak")));

var $hL1nr = parcelRequire("hL1nr");

var $ayMG0 = parcelRequire("ayMG0");
const $cb3af4fea2cad44e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $cb3af4fea2cad44e$var$_capitalize.default)(color)}`,
            size !== 'medium' && `size${(0, $cb3af4fea2cad44e$var$_capitalize.default)(size)}`
        ]
    };
    return {
        ...classes,
        ...(0, $cb3af4fea2cad44e$var$_composeClasses.default)(slots, $cb3af4fea2cad44e$var$_radioClasses.getRadioUtilityClass, classes)
    };
};
const $cb3af4fea2cad44e$var$RadioRoot = (0, $aAbgT.styled)($cb3af4fea2cad44e$var$_SwitchBase.default, {
    shouldForwardProp: (prop)=>(0, $cb3af4fea2cad44e$var$_rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiRadio',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size !== 'medium' && styles[`size${(0, $cb3af4fea2cad44e$var$_capitalize.default)(ownerState.size)}`],
            styles[`color${(0, $cb3af4fea2cad44e$var$_capitalize.default)(ownerState.color)}`]
        ];
    }
})((0, $cb3af4fea2cad44e$var$_memoTheme.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${$cb3af4fea2cad44e$var$_radioClasses.default.disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: {
                    color: 'default',
                    disabled: false,
                    disableRipple: false
                },
                style: {
                    '&:hover': {
                        backgroundColor: theme.alpha((theme.vars || theme).palette.action.active, (theme.vars || theme).palette.action.hoverOpacity)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $cb3af4fea2cad44e$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color,
                        disabled: false,
                        disableRipple: false
                    },
                    style: {
                        '&:hover': {
                            backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity)
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $cb3af4fea2cad44e$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color,
                        disabled: false
                    },
                    style: {
                        [`&.${$cb3af4fea2cad44e$var$_radioClasses.default.checked}`]: {
                            color: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                // Should be last to override other colors
                props: {
                    disableRipple: false
                },
                style: {
                    // Reset on touch devices, it doesn't add specificity
                    '&:hover': {
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            }
        ]
    })));
function $cb3af4fea2cad44e$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
const $cb3af4fea2cad44e$var$defaultCheckedIcon = /*#__PURE__*/ (0, $ayMG0.jsx)($cb3af4fea2cad44e$var$_RadioButtonIcon.default, {
    checked: true
});
const $cb3af4fea2cad44e$var$defaultIcon = /*#__PURE__*/ (0, $ayMG0.jsx)($cb3af4fea2cad44e$var$_RadioButtonIcon.default, {});
const $cb3af4fea2cad44e$var$Radio = /*#__PURE__*/ $cb3af4fea2cad44e$var$React.forwardRef(function Radio(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiRadio'
    });
    const { checked: checkedProp, checkedIcon: checkedIcon = $cb3af4fea2cad44e$var$defaultCheckedIcon, color: color = 'primary', icon: icon = $cb3af4fea2cad44e$var$defaultIcon, name: nameProp, onChange: onChangeProp, size: size = 'medium', className: className, disabled: disabledProp, disableRipple: disableRipple = false, slots: slots = {}, slotProps: slotProps = {}, inputProps: inputProps, ...other } = props;
    const muiFormControl = (0, $cb3af4fea2cad44e$var$_useFormControl.default)();
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    disabled ?? (disabled = false);
    const ownerState = {
        ...props,
        disabled: disabled,
        disableRipple: disableRipple,
        color: color,
        size: size
    };
    const classes = $cb3af4fea2cad44e$var$useUtilityClasses(ownerState);
    const radioGroup = (0, $cb3af4fea2cad44e$var$_useRadioGroup.default)();
    let checked = checkedProp;
    const onChange = (0, $cb3af4fea2cad44e$var$_createChainedFunction.default)(onChangeProp, radioGroup && radioGroup.onChange);
    let name = nameProp;
    if (radioGroup) {
        if (typeof checked === 'undefined') checked = $cb3af4fea2cad44e$var$areEqualValues(radioGroup.value, props.value);
        if (typeof name === 'undefined') name = radioGroup.name;
    }
    const externalInputProps = slotProps.input ?? inputProps;
    const [RootSlot, rootSlotProps] = (0, $cb3af4fea2cad44e$var$_useSlot.default)('root', {
        ref: ref,
        elementType: $cb3af4fea2cad44e$var$RadioRoot,
        className: (0, $cb3af4fea2cad44e$var$_clsx.default)(classes.root, className),
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps,
            ...other
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onChange: (event, ...args)=>{
                    handlers.onChange?.(event, ...args);
                    onChange(event, ...args);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            type: 'radio',
            icon: /*#__PURE__*/ $cb3af4fea2cad44e$var$React.cloneElement(icon, {
                fontSize: icon.props.fontSize ?? size
            }),
            checkedIcon: /*#__PURE__*/ $cb3af4fea2cad44e$var$React.cloneElement(checkedIcon, {
                fontSize: checkedIcon.props.fontSize ?? size
            }),
            disabled: disabled,
            name: name,
            checked: checked,
            slots: slots,
            slotProps: {
                // Do not forward `slotProps.root` again because it's already handled by the `RootSlot` in this file.
                input: typeof externalInputProps === 'function' ? externalInputProps(ownerState) : externalInputProps
            }
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, {
        ...rootSlotProps,
        classes: classes
    });
});
$cb3af4fea2cad44e$var$Radio.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * If `true`, the component is checked.
   */ checked: $cb3af4fea2cad44e$var$_propTypes.default.bool,
    /**
   * The icon to display when the component is checked.
   * @default <RadioButtonIcon checked />
   */ checkedIcon: $cb3af4fea2cad44e$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $cb3af4fea2cad44e$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $cb3af4fea2cad44e$var$_propTypes.default.string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */ color: $cb3af4fea2cad44e$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $cb3af4fea2cad44e$var$_propTypes.default.oneOf([
            'default',
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning'
        ]),
        $cb3af4fea2cad44e$var$_propTypes.default.string
    ]),
    /**
   * If `true`, the component is disabled.
   */ disabled: $cb3af4fea2cad44e$var$_propTypes.default.bool,
    /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */ disableRipple: $cb3af4fea2cad44e$var$_propTypes.default.bool,
    /**
   * The icon to display when the component is unchecked.
   * @default <RadioButtonIcon />
   */ icon: $cb3af4fea2cad44e$var$_propTypes.default.node,
    /**
   * The id of the `input` element.
   */ id: $cb3af4fea2cad44e$var$_propTypes.default.string,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   * @deprecated Use `slotProps.input` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ inputProps: $cb3af4fea2cad44e$var$_propTypes.default.object,
    /**
   * Pass a ref to the `input` element.
   * @deprecated Use `slotProps.input.ref` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ inputRef: $cb3af4fea2cad44e$var$_refType.default,
    /**
   * Name attribute of the `input` element.
   */ name: $cb3af4fea2cad44e$var$_propTypes.default.string,
    /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */ onChange: $cb3af4fea2cad44e$var$_propTypes.default.func,
    /**
   * If `true`, the `input` element is required.
   * @default false
   */ required: $cb3af4fea2cad44e$var$_propTypes.default.bool,
    /**
   * The size of the component.
   * `small` is equivalent to the dense radio styling.
   * @default 'medium'
   */ size: $cb3af4fea2cad44e$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $cb3af4fea2cad44e$var$_propTypes.default.oneOf([
            'medium',
            'small'
        ]),
        $cb3af4fea2cad44e$var$_propTypes.default.string
    ]),
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $cb3af4fea2cad44e$var$_propTypes.default.shape({
        input: $cb3af4fea2cad44e$var$_propTypes.default.oneOfType([
            $cb3af4fea2cad44e$var$_propTypes.default.func,
            $cb3af4fea2cad44e$var$_propTypes.default.object
        ]),
        root: $cb3af4fea2cad44e$var$_propTypes.default.oneOfType([
            $cb3af4fea2cad44e$var$_propTypes.default.func,
            $cb3af4fea2cad44e$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: $cb3af4fea2cad44e$var$_propTypes.default.shape({
        input: $cb3af4fea2cad44e$var$_propTypes.default.elementType,
        root: $cb3af4fea2cad44e$var$_propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $cb3af4fea2cad44e$var$_propTypes.default.oneOfType([
        $cb3af4fea2cad44e$var$_propTypes.default.arrayOf($cb3af4fea2cad44e$var$_propTypes.default.oneOfType([
            $cb3af4fea2cad44e$var$_propTypes.default.func,
            $cb3af4fea2cad44e$var$_propTypes.default.object,
            $cb3af4fea2cad44e$var$_propTypes.default.bool
        ])),
        $cb3af4fea2cad44e$var$_propTypes.default.func,
        $cb3af4fea2cad44e$var$_propTypes.default.object
    ]),
    /**
   * The value of the component. The DOM API casts this to a string.
   */ value: $cb3af4fea2cad44e$var$_propTypes.default.any
};
var $cb3af4fea2cad44e$var$_default = module.exports.default = $cb3af4fea2cad44e$var$Radio;

});
parcelRegister("9plBP", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $6d9735fee3c00fe1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6d9735fee3c00fe1$var$_propTypes = $6d9735fee3c00fe1$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $6d9735fee3c00fe1$var$_RadioButtonUnchecked = $6d9735fee3c00fe1$require$_interopRequireDefault((parcelRequire("k0iyu")));

var $6d9735fee3c00fe1$var$_RadioButtonChecked = $6d9735fee3c00fe1$require$_interopRequireDefault((parcelRequire("jA2KS")));

var $6d9735fee3c00fe1$var$_rootShouldForwardProp = $6d9735fee3c00fe1$require$_interopRequireDefault((parcelRequire("8Uq77")));

var $aAbgT = parcelRequire("aAbgT");

var $6d9735fee3c00fe1$var$_memoTheme = $6d9735fee3c00fe1$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $ayMG0 = parcelRequire("ayMG0");
const $6d9735fee3c00fe1$var$RadioButtonIconRoot = (0, $aAbgT.styled)('span', {
    name: 'MuiRadioButtonIcon',
    shouldForwardProp: $6d9735fee3c00fe1$var$_rootShouldForwardProp.default
})({
    position: 'relative',
    display: 'flex'
});
const $6d9735fee3c00fe1$var$RadioButtonIconBackground = (0, $aAbgT.styled)($6d9735fee3c00fe1$var$_RadioButtonUnchecked.default, {
    name: 'MuiRadioButtonIcon'
})({
    // Scale applied to prevent dot misalignment in Safari
    transform: 'scale(1)'
});
const $6d9735fee3c00fe1$var$RadioButtonIconDot = (0, $aAbgT.styled)($6d9735fee3c00fe1$var$_RadioButtonChecked.default, {
    name: 'MuiRadioButtonIcon'
})((0, $6d9735fee3c00fe1$var$_memoTheme.default)(({ theme: theme })=>({
        left: 0,
        position: 'absolute',
        transform: 'scale(0)',
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeIn,
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: {
                    checked: true
                },
                style: {
                    transform: 'scale(1)',
                    transition: theme.transitions.create('transform', {
                        easing: theme.transitions.easing.easeOut,
                        duration: theme.transitions.duration.shortest
                    })
                }
            }
        ]
    })));
/**
 * @ignore - internal component.
 */ function $6d9735fee3c00fe1$var$RadioButtonIcon(props) {
    const { checked: checked = false, classes: classes = {}, fontSize: fontSize } = props;
    const ownerState = {
        ...props,
        checked: checked
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($6d9735fee3c00fe1$var$RadioButtonIconRoot, {
        className: classes.root,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($6d9735fee3c00fe1$var$RadioButtonIconBackground, {
                fontSize: fontSize,
                className: classes.background,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($6d9735fee3c00fe1$var$RadioButtonIconDot, {
                fontSize: fontSize,
                className: classes.dot,
                ownerState: ownerState
            })
        ]
    });
}
$6d9735fee3c00fe1$var$RadioButtonIcon.propTypes = {
    /**
   * If `true`, the component is checked.
   */ checked: $6d9735fee3c00fe1$var$_propTypes.default.bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $6d9735fee3c00fe1$var$_propTypes.default.object,
    /**
   * The size of the component.
   * `small` is equivalent to the dense radio styling.
   */ fontSize: $6d9735fee3c00fe1$var$_propTypes.default.oneOf([
        'small',
        'medium'
    ])
};
var $6d9735fee3c00fe1$var$_default = module.exports.default = $6d9735fee3c00fe1$var$RadioButtonIcon;

});
parcelRegister("k0iyu", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $03c2199a765ab5af$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $03c2199a765ab5af$var$_createSvgIcon = $03c2199a765ab5af$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $03c2199a765ab5af$var$_default = module.exports.default = (0, $03c2199a765ab5af$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'RadioButtonUnchecked');

});

parcelRegister("jA2KS", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $e413843d0810bb75$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e413843d0810bb75$var$_createSvgIcon = $e413843d0810bb75$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $e413843d0810bb75$var$_default = module.exports.default = (0, $e413843d0810bb75$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), 'RadioButtonChecked');

});


parcelRegister("k0Fx1", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $e9140607eee18105$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $e9140607eee18105$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e9140607eee18105$var$useRadioGroup;

var $e9140607eee18105$var$React = $e9140607eee18105$require$_interopRequireWildcard((parcelRequire("acw62")));

var $e9140607eee18105$var$_RadioGroupContext = $e9140607eee18105$require$_interopRequireDefault((parcelRequire("lsybK")));
function $e9140607eee18105$var$useRadioGroup() {
    return $e9140607eee18105$var$React.useContext($e9140607eee18105$var$_RadioGroupContext.default);
}

});
parcelRegister("lsybK", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $f9f6bb9b992d33b5$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f9f6bb9b992d33b5$var$React = $f9f6bb9b992d33b5$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * @ignore - internal component.
 */ const $f9f6bb9b992d33b5$var$RadioGroupContext = /*#__PURE__*/ $f9f6bb9b992d33b5$var$React.createContext(undefined);
$f9f6bb9b992d33b5$var$RadioGroupContext.displayName = 'RadioGroupContext';
var $f9f6bb9b992d33b5$var$_default = module.exports.default = $f9f6bb9b992d33b5$var$RadioGroupContext;

});


parcelRegister("iHxWE", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d9d692e9561f6352$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getRadioUtilityClass = $d9d692e9561f6352$var$getRadioUtilityClass;

var $d9d692e9561f6352$var$_generateUtilityClasses = $d9d692e9561f6352$require$_interopRequireDefault((parcelRequire("5nY49")));

var $d9d692e9561f6352$var$_generateUtilityClass = $d9d692e9561f6352$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $d9d692e9561f6352$var$getRadioUtilityClass(slot) {
    return (0, $d9d692e9561f6352$var$_generateUtilityClass.default)('MuiRadio', slot);
}
const $d9d692e9561f6352$var$radioClasses = (0, $d9d692e9561f6352$var$_generateUtilityClasses.default)('MuiRadio', [
    'root',
    'checked',
    'disabled',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall'
]);
var $d9d692e9561f6352$var$_default = module.exports.default = $d9d692e9561f6352$var$radioClasses;

});



parcelRegister("31l3D", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $2331ccb4eb2af4bc$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $2331ccb4eb2af4bc$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $2331ccb4eb2af4bc$var$_exportNames = {
    useRadioGroup: true,
    radioGroupClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $2331ccb4eb2af4bc$var$_RadioGroup.default;
    }
});
Object.defineProperty(module.exports, "radioGroupClasses", {
    enumerable: true,
    get: function() {
        return $2331ccb4eb2af4bc$var$_radioGroupClasses.default;
    }
});
Object.defineProperty(module.exports, "useRadioGroup", {
    enumerable: true,
    get: function() {
        return $2331ccb4eb2af4bc$var$_useRadioGroup.default;
    }
});

var $2331ccb4eb2af4bc$var$_RadioGroup = $2331ccb4eb2af4bc$require$_interopRequireDefault((parcelRequire("8IWga")));

var $2331ccb4eb2af4bc$var$_useRadioGroup = $2331ccb4eb2af4bc$require$_interopRequireDefault((parcelRequire("k0Fx1")));

var $2331ccb4eb2af4bc$var$_radioGroupClasses = $2331ccb4eb2af4bc$require$_interopRequireWildcard((parcelRequire("gWj0r")));
Object.keys($2331ccb4eb2af4bc$var$_radioGroupClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2331ccb4eb2af4bc$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $2331ccb4eb2af4bc$var$_radioGroupClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2331ccb4eb2af4bc$var$_radioGroupClasses[key];
        }
    });
});

});
parcelRegister("8IWga", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $659f9ff12b4e3755$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $659f9ff12b4e3755$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $659f9ff12b4e3755$var$React = $659f9ff12b4e3755$require$_interopRequireWildcard((parcelRequire("acw62")));

var $659f9ff12b4e3755$var$_propTypes = $659f9ff12b4e3755$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $659f9ff12b4e3755$var$_clsx = $659f9ff12b4e3755$require$_interopRequireDefault((parcelRequire("9QePP")));

var $659f9ff12b4e3755$var$_composeClasses = $659f9ff12b4e3755$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $659f9ff12b4e3755$var$_FormGroup = $659f9ff12b4e3755$require$_interopRequireDefault((parcelRequire("buuiu")));

var $gWj0r = parcelRequire("gWj0r");

var $659f9ff12b4e3755$var$_useForkRef = $659f9ff12b4e3755$require$_interopRequireDefault((parcelRequire("9Rgf1")));

var $659f9ff12b4e3755$var$_useControlled = $659f9ff12b4e3755$require$_interopRequireDefault((parcelRequire("3yddg")));

var $659f9ff12b4e3755$var$_RadioGroupContext = $659f9ff12b4e3755$require$_interopRequireDefault((parcelRequire("lsybK")));

var $659f9ff12b4e3755$var$_useId = $659f9ff12b4e3755$require$_interopRequireDefault((parcelRequire("5A6d3")));

var $ayMG0 = parcelRequire("ayMG0");
const $659f9ff12b4e3755$var$useUtilityClasses = (props)=>{
    const { classes: classes, row: row, error: error } = props;
    const slots = {
        root: [
            'root',
            row && 'row',
            error && 'error'
        ]
    };
    return (0, $659f9ff12b4e3755$var$_composeClasses.default)(slots, $gWj0r.getRadioGroupUtilityClass, classes);
};
const $659f9ff12b4e3755$var$RadioGroup = /*#__PURE__*/ $659f9ff12b4e3755$var$React.forwardRef(function RadioGroup(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, children: children, className: className, defaultValue: defaultValue, name: nameProp, onChange: onChange, value: valueProp, ...other } = props;
    const rootRef = $659f9ff12b4e3755$var$React.useRef(null);
    const classes = $659f9ff12b4e3755$var$useUtilityClasses(props);
    const [value, setValueState] = (0, $659f9ff12b4e3755$var$_useControlled.default)({
        controlled: valueProp,
        default: defaultValue,
        name: 'RadioGroup'
    });
    $659f9ff12b4e3755$var$React.useImperativeHandle(actions, ()=>({
            focus: ()=>{
                let input = rootRef.current.querySelector('input:not(:disabled):checked');
                if (!input) input = rootRef.current.querySelector('input:not(:disabled)');
                if (input) input.focus();
            }
        }), []);
    const handleRef = (0, $659f9ff12b4e3755$var$_useForkRef.default)(ref, rootRef);
    const name = (0, $659f9ff12b4e3755$var$_useId.default)(nameProp);
    const contextValue = $659f9ff12b4e3755$var$React.useMemo(()=>({
            name: name,
            onChange (event) {
                setValueState(event.target.value);
                if (onChange) onChange(event, event.target.value);
            },
            value: value
        }), [
        name,
        onChange,
        setValueState,
        value
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($659f9ff12b4e3755$var$_RadioGroupContext.default.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($659f9ff12b4e3755$var$_FormGroup.default, {
            role: "radiogroup",
            ref: handleRef,
            className: (0, $659f9ff12b4e3755$var$_clsx.default)(classes.root, className),
            ...other,
            children: children
        })
    });
});
$659f9ff12b4e3755$var$RadioGroup.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: $659f9ff12b4e3755$var$_propTypes.default.node,
    /**
   * @ignore
   */ className: $659f9ff12b4e3755$var$_propTypes.default.string,
    /**
   * The default value. Use when the component is not controlled.
   */ defaultValue: $659f9ff12b4e3755$var$_propTypes.default.any,
    /**
   * The name used to reference the value of the control.
   * If you don't provide this prop, it falls back to a randomly generated name.
   */ name: $659f9ff12b4e3755$var$_propTypes.default.string,
    /**
   * Callback fired when a radio button is selected.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * @param {string} value The value of the selected radio button.
   * You can pull out the new value by accessing `event.target.value` (string).
   */ onChange: $659f9ff12b4e3755$var$_propTypes.default.func,
    /**
   * Value of the selected radio button. The DOM API casts this to a string.
   */ value: $659f9ff12b4e3755$var$_propTypes.default.any
};
var $659f9ff12b4e3755$var$_default = module.exports.default = $659f9ff12b4e3755$var$RadioGroup;

});
parcelRegister("gWj0r", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c550ce5d3f5617f8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getRadioGroupUtilityClass = $c550ce5d3f5617f8$var$getRadioGroupUtilityClass;

var $c550ce5d3f5617f8$var$_generateUtilityClasses = $c550ce5d3f5617f8$require$_interopRequireDefault((parcelRequire("5nY49")));

var $c550ce5d3f5617f8$var$_generateUtilityClass = $c550ce5d3f5617f8$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $c550ce5d3f5617f8$var$getRadioGroupUtilityClass(slot) {
    return (0, $c550ce5d3f5617f8$var$_generateUtilityClass.default)('MuiRadioGroup', slot);
}
const $c550ce5d3f5617f8$var$radioGroupClasses = (0, $c550ce5d3f5617f8$var$_generateUtilityClasses.default)('MuiRadioGroup', [
    'root',
    'row',
    'error'
]);
var $c550ce5d3f5617f8$var$_default = module.exports.default = $c550ce5d3f5617f8$var$radioGroupClasses;

});



parcelRegister("lNr9b", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $fde33b68b1c0968e$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $fde33b68b1c0968e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $fde33b68b1c0968e$var$_exportNames = {
    ratingClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $fde33b68b1c0968e$var$_Rating.default;
    }
});
Object.defineProperty(module.exports, "ratingClasses", {
    enumerable: true,
    get: function() {
        return $fde33b68b1c0968e$var$_ratingClasses.default;
    }
});

var $fde33b68b1c0968e$var$_Rating = $fde33b68b1c0968e$require$_interopRequireDefault((parcelRequire("dVqTC")));

var $fde33b68b1c0968e$var$_ratingClasses = $fde33b68b1c0968e$require$_interopRequireWildcard((parcelRequire("7ynaW")));
Object.keys($fde33b68b1c0968e$var$_ratingClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($fde33b68b1c0968e$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $fde33b68b1c0968e$var$_ratingClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fde33b68b1c0968e$var$_ratingClasses[key];
        }
    });
});

});
parcelRegister("dVqTC", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $a235763b3a7014ab$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $a235763b3a7014ab$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a235763b3a7014ab$var$_react = $a235763b3a7014ab$require$_interopRequireWildcard((parcelRequire("acw62")));
var $a235763b3a7014ab$var$React = $a235763b3a7014ab$var$_react;

var $a235763b3a7014ab$var$_propTypes = $a235763b3a7014ab$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $a235763b3a7014ab$var$_clsx = $a235763b3a7014ab$require$_interopRequireDefault((parcelRequire("9QePP")));

var $a235763b3a7014ab$var$_clamp = $a235763b3a7014ab$require$_interopRequireDefault((parcelRequire("3zA0b")));

var $a235763b3a7014ab$var$_visuallyHidden = $a235763b3a7014ab$require$_interopRequireDefault((parcelRequire("1YYSs")));

var $a235763b3a7014ab$var$_chainPropTypes = $a235763b3a7014ab$require$_interopRequireDefault((parcelRequire("abVWF")));

var $a235763b3a7014ab$var$_composeClasses = $a235763b3a7014ab$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $9uEev = parcelRequire("9uEev");

var $a235763b3a7014ab$var$_isFocusVisible = $a235763b3a7014ab$require$_interopRequireDefault((parcelRequire("cS73m")));

var $hGPki = parcelRequire("hGPki");

var $a235763b3a7014ab$var$_Star = $a235763b3a7014ab$require$_interopRequireDefault((parcelRequire("k2Gvj")));

var $a235763b3a7014ab$var$_StarBorder = $a235763b3a7014ab$require$_interopRequireDefault((parcelRequire("6TAtw")));

var $aAbgT = parcelRequire("aAbgT");

var $a235763b3a7014ab$var$_memoTheme = $a235763b3a7014ab$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $a235763b3a7014ab$var$_slotShouldForwardProp = $a235763b3a7014ab$require$_interopRequireDefault((parcelRequire("PJRTc")));

var $a235763b3a7014ab$var$_ratingClasses = $a235763b3a7014ab$require$_interopRequireWildcard((parcelRequire("7ynaW")));

var $a235763b3a7014ab$var$_useSlot = $a235763b3a7014ab$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
function $a235763b3a7014ab$var$getDecimalPrecision(num) {
    const decimalPart = num.toString().split('.')[1];
    return decimalPart ? decimalPart.length : 0;
}
function $a235763b3a7014ab$var$roundValueToPrecision(value, precision) {
    if (value == null) return value;
    const nearest = Math.round(value / precision) * precision;
    return Number(nearest.toFixed($a235763b3a7014ab$var$getDecimalPrecision(precision)));
}
const $a235763b3a7014ab$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, size: size, readOnly: readOnly, disabled: disabled, emptyValueFocused: emptyValueFocused, focusVisible: focusVisible } = ownerState;
    const slots = {
        root: [
            'root',
            `size${(0, $hGPki.capitalize)(size)}`,
            disabled && 'disabled',
            focusVisible && 'focusVisible',
            readOnly && 'readOnly'
        ],
        label: [
            'label',
            'pristine'
        ],
        labelEmptyValue: [
            emptyValueFocused && 'labelEmptyValueActive'
        ],
        icon: [
            'icon'
        ],
        iconEmpty: [
            'iconEmpty'
        ],
        iconFilled: [
            'iconFilled'
        ],
        iconHover: [
            'iconHover'
        ],
        iconFocus: [
            'iconFocus'
        ],
        iconActive: [
            'iconActive'
        ],
        decimal: [
            'decimal'
        ],
        visuallyHidden: [
            'visuallyHidden'
        ]
    };
    return (0, $a235763b3a7014ab$var$_composeClasses.default)(slots, $a235763b3a7014ab$var$_ratingClasses.getRatingUtilityClass, classes);
};
const $a235763b3a7014ab$var$RatingRoot = (0, $aAbgT.styled)('span', {
    name: 'MuiRating',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${$a235763b3a7014ab$var$_ratingClasses.default.visuallyHidden}`]: styles.visuallyHidden
            },
            styles.root,
            styles[`size${(0, $hGPki.capitalize)(ownerState.size)}`],
            ownerState.readOnly && styles.readOnly
        ];
    }
})((0, $a235763b3a7014ab$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'inline-flex',
        // Required to position the pristine input absolutely
        position: 'relative',
        fontSize: theme.typography.pxToRem(24),
        color: '#faaf00',
        cursor: 'pointer',
        textAlign: 'left',
        width: 'min-content',
        WebkitTapHighlightColor: 'transparent',
        [`&.${$a235763b3a7014ab$var$_ratingClasses.default.disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: 'none'
        },
        [`&.${$a235763b3a7014ab$var$_ratingClasses.default.focusVisible} .${$a235763b3a7014ab$var$_ratingClasses.default.iconActive}`]: {
            outline: '1px solid #999'
        },
        [`& .${$a235763b3a7014ab$var$_ratingClasses.default.visuallyHidden}`]: $a235763b3a7014ab$var$_visuallyHidden.default,
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    fontSize: theme.typography.pxToRem(18)
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    fontSize: theme.typography.pxToRem(30)
                }
            },
            {
                // TODO v6: use the .Mui-readOnly global state class
                props: ({ ownerState: ownerState })=>ownerState.readOnly,
                style: {
                    pointerEvents: 'none'
                }
            }
        ]
    })));
const $a235763b3a7014ab$var$RatingLabel = (0, $aAbgT.styled)('label', {
    name: 'MuiRating',
    slot: 'Label',
    overridesResolver: ({ ownerState: ownerState }, styles)=>[
            styles.label,
            ownerState.emptyValueFocused && styles.labelEmptyValueActive
        ]
})({
    cursor: 'inherit',
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.emptyValueFocused,
            style: {
                top: 0,
                bottom: 0,
                position: 'absolute',
                outline: '1px solid #999',
                width: '100%'
            }
        }
    ]
});
const $a235763b3a7014ab$var$RatingIcon = (0, $aAbgT.styled)('span', {
    name: 'MuiRating',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.iconEmpty && styles.iconEmpty,
            ownerState.iconFilled && styles.iconFilled,
            ownerState.iconHover && styles.iconHover,
            ownerState.iconFocus && styles.iconFocus,
            ownerState.iconActive && styles.iconActive
        ];
    }
})((0, $a235763b3a7014ab$var$_memoTheme.default)(({ theme: theme })=>({
        // Fit wrapper to actual icon size.
        display: 'flex',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest
        }),
        // Fix mouseLeave issue.
        // https://github.com/facebook/react/issues/4492
        pointerEvents: 'none',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.iconActive,
                style: {
                    transform: 'scale(1.2)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.iconEmpty,
                style: {
                    color: (theme.vars || theme).palette.action.disabled
                }
            }
        ]
    })));
const $a235763b3a7014ab$var$RatingDecimal = (0, $aAbgT.styled)('span', {
    name: 'MuiRating',
    slot: 'Decimal',
    shouldForwardProp: (prop)=>(0, $a235763b3a7014ab$var$_slotShouldForwardProp.default)(prop) && prop !== 'iconActive',
    overridesResolver: (props, styles)=>{
        const { iconActive: iconActive } = props;
        return [
            styles.decimal,
            iconActive && styles.iconActive
        ];
    }
})({
    position: 'relative',
    variants: [
        {
            props: ({ iconActive: iconActive })=>iconActive,
            style: {
                transform: 'scale(1.2)'
            }
        }
    ]
});
function $a235763b3a7014ab$var$IconContainer(props) {
    const { value: value, ...other } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        ...other
    });
}
$a235763b3a7014ab$var$IconContainer.propTypes = {
    value: $a235763b3a7014ab$var$_propTypes.default.number.isRequired
};
function $a235763b3a7014ab$var$RatingItem(props) {
    const { classes: classes, disabled: disabled, emptyIcon: emptyIcon, focus: focus, getLabelText: getLabelText, highlightSelectedOnly: highlightSelectedOnly, hover: hover, icon: icon, IconContainerComponent: IconContainerComponent, isActive: isActive, itemValue: itemValue, labelProps: labelProps, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, readOnly: readOnly, ownerState: ownerState, ratingValue: ratingValue, ratingValueRounded: ratingValueRounded, slots: slots = {}, slotProps: slotProps = {} } = props;
    const isFilled = highlightSelectedOnly ? itemValue === ratingValue : itemValue <= ratingValue;
    const isHovered = itemValue <= hover;
    const isFocused = itemValue <= focus;
    const isChecked = itemValue === ratingValueRounded;
    // "name" ensures unique IDs across different Rating components in React 17,
    // preventing one component from affecting another. React 18's useId already handles this.
    // Update to const id = useId(); when React 17 support is dropped.
    // More details: https://github.com/mui/material-ui/issues/40997
    const id = `${name}-${(0, $hGPki.unstable_useId)()}`;
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [IconSlot, iconSlotProps] = (0, $a235763b3a7014ab$var$_useSlot.default)('icon', {
        elementType: $a235763b3a7014ab$var$RatingIcon,
        className: (0, $a235763b3a7014ab$var$_clsx.default)(classes.icon, isFilled ? classes.iconFilled : classes.iconEmpty, isHovered && classes.iconHover, isFocused && classes.iconFocus, isActive && classes.iconActive),
        externalForwardedProps: externalForwardedProps,
        ownerState: {
            ...ownerState,
            iconEmpty: !isFilled,
            iconFilled: isFilled,
            iconHover: isHovered,
            iconFocus: isFocused,
            iconActive: isActive
        },
        additionalProps: {
            value: itemValue
        },
        internalForwardedProps: {
            // TODO: remove this in v7 because `IconContainerComponent` is deprecated
            // only forward if `slots.icon` is NOT provided
            as: IconContainerComponent
        }
    });
    const [LabelSlot, labelSlotProps] = (0, $a235763b3a7014ab$var$_useSlot.default)('label', {
        elementType: $a235763b3a7014ab$var$RatingLabel,
        externalForwardedProps: externalForwardedProps,
        ownerState: {
            ...ownerState,
            emptyValueFocused: undefined
        },
        additionalProps: {
            style: labelProps?.style,
            htmlFor: id
        }
    });
    const container = /*#__PURE__*/ (0, $ayMG0.jsx)(IconSlot, {
        ...iconSlotProps,
        children: emptyIcon && !isFilled ? emptyIcon : icon
    });
    if (readOnly) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        ...labelProps,
        children: container
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($a235763b3a7014ab$var$React.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)(LabelSlot, {
                ...labelSlotProps,
                children: [
                    container,
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: classes.visuallyHidden,
                        children: getLabelText(itemValue)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                className: classes.visuallyHidden,
                onFocus: onFocus,
                onBlur: onBlur,
                onChange: onChange,
                onClick: onClick,
                disabled: disabled,
                value: itemValue,
                id: id,
                type: "radio",
                name: name,
                checked: isChecked
            })
        ]
    });
}
$a235763b3a7014ab$var$RatingItem.propTypes = {
    classes: $a235763b3a7014ab$var$_propTypes.default.object.isRequired,
    disabled: $a235763b3a7014ab$var$_propTypes.default.bool.isRequired,
    emptyIcon: $a235763b3a7014ab$var$_propTypes.default.node,
    focus: $a235763b3a7014ab$var$_propTypes.default.number.isRequired,
    getLabelText: $a235763b3a7014ab$var$_propTypes.default.func.isRequired,
    highlightSelectedOnly: $a235763b3a7014ab$var$_propTypes.default.bool.isRequired,
    hover: $a235763b3a7014ab$var$_propTypes.default.number.isRequired,
    icon: $a235763b3a7014ab$var$_propTypes.default.node,
    IconContainerComponent: $a235763b3a7014ab$var$_propTypes.default.elementType.isRequired,
    isActive: $a235763b3a7014ab$var$_propTypes.default.bool.isRequired,
    itemValue: $a235763b3a7014ab$var$_propTypes.default.number.isRequired,
    labelProps: $a235763b3a7014ab$var$_propTypes.default.object,
    name: $a235763b3a7014ab$var$_propTypes.default.string,
    onBlur: $a235763b3a7014ab$var$_propTypes.default.func.isRequired,
    onChange: $a235763b3a7014ab$var$_propTypes.default.func.isRequired,
    onClick: $a235763b3a7014ab$var$_propTypes.default.func.isRequired,
    onFocus: $a235763b3a7014ab$var$_propTypes.default.func.isRequired,
    ownerState: $a235763b3a7014ab$var$_propTypes.default.object.isRequired,
    ratingValue: $a235763b3a7014ab$var$_propTypes.default.number,
    ratingValueRounded: $a235763b3a7014ab$var$_propTypes.default.number,
    readOnly: $a235763b3a7014ab$var$_propTypes.default.bool.isRequired,
    slotProps: $a235763b3a7014ab$var$_propTypes.default.object,
    slots: $a235763b3a7014ab$var$_propTypes.default.object
};
const $a235763b3a7014ab$var$defaultIcon = /*#__PURE__*/ (0, $ayMG0.jsx)($a235763b3a7014ab$var$_Star.default, {
    fontSize: "inherit"
});
const $a235763b3a7014ab$var$defaultEmptyIcon = /*#__PURE__*/ (0, $ayMG0.jsx)($a235763b3a7014ab$var$_StarBorder.default, {
    fontSize: "inherit"
});
function $a235763b3a7014ab$var$defaultLabelText(value) {
    return `${value || '0'} Star${value !== 1 ? 's' : ''}`;
}
const $a235763b3a7014ab$var$Rating = /*#__PURE__*/ $a235763b3a7014ab$var$React.forwardRef(function Rating(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        name: 'MuiRating',
        props: inProps
    });
    const { component: component = 'span', className: className, defaultValue: defaultValue = null, disabled: disabled = false, emptyIcon: emptyIcon = $a235763b3a7014ab$var$defaultEmptyIcon, emptyLabelText: emptyLabelText = 'Empty', getLabelText: getLabelText = $a235763b3a7014ab$var$defaultLabelText, highlightSelectedOnly: highlightSelectedOnly = false, icon: icon = $a235763b3a7014ab$var$defaultIcon, IconContainerComponent: IconContainerComponent = $a235763b3a7014ab$var$IconContainer, max: max = 5, name: nameProp, onChange: onChange, onChangeActive: onChangeActive, onMouseLeave: onMouseLeave, onMouseMove: onMouseMove, precision: precision = 1, readOnly: readOnly = false, size: size = 'medium', value: valueProp, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const name = (0, $hGPki.unstable_useId)(nameProp);
    const [valueDerived, setValueState] = (0, $hGPki.useControlled)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Rating'
    });
    const valueRounded = $a235763b3a7014ab$var$roundValueToPrecision(valueDerived, precision);
    const isRtl = (0, $9uEev.useRtl)();
    const [{ hover: hover, focus: focus }, setState] = $a235763b3a7014ab$var$React.useState({
        hover: -1,
        focus: -1
    });
    let value = valueRounded;
    if (hover !== -1) value = hover;
    if (focus !== -1) value = focus;
    const [focusVisible, setFocusVisible] = $a235763b3a7014ab$var$React.useState(false);
    const rootRef = $a235763b3a7014ab$var$React.useRef();
    const handleRef = (0, $hGPki.useForkRef)(rootRef, ref);
    const handleMouseMove = (event)=>{
        if (onMouseMove) onMouseMove(event);
        const rootNode = rootRef.current;
        const { right: right, left: left, width: containerWidth } = rootNode.getBoundingClientRect();
        let percent;
        if (isRtl) percent = (right - event.clientX) / containerWidth;
        else percent = (event.clientX - left) / containerWidth;
        let newHover = $a235763b3a7014ab$var$roundValueToPrecision(max * percent + precision / 2, precision);
        newHover = (0, $a235763b3a7014ab$var$_clamp.default)(newHover, precision, max);
        setState((prev)=>prev.hover === newHover && prev.focus === newHover ? prev : {
                hover: newHover,
                focus: newHover
            });
        setFocusVisible(false);
        if (onChangeActive && hover !== newHover) onChangeActive(event, newHover);
    };
    const handleMouseLeave = (event)=>{
        if (onMouseLeave) onMouseLeave(event);
        const newHover = -1;
        setState({
            hover: newHover,
            focus: newHover
        });
        if (onChangeActive && hover !== newHover) onChangeActive(event, newHover);
    };
    const handleChange = (event)=>{
        let newValue = event.target.value === '' ? null : parseFloat(event.target.value);
        // Give mouse priority over keyboard
        // Fix https://github.com/mui/material-ui/issues/22827
        if (hover !== -1) newValue = hover;
        setValueState(newValue);
        if (onChange) onChange(event, newValue);
    };
    const handleClear = (event)=>{
        // Ignore keyboard events
        // https://github.com/facebook/react/issues/7407
        if (event.clientX === 0 && event.clientY === 0) return;
        setState({
            hover: -1,
            focus: -1
        });
        setValueState(null);
        if (onChange && parseFloat(event.target.value) === valueRounded) onChange(event, null);
    };
    const handleFocus = (event)=>{
        if ((0, $a235763b3a7014ab$var$_isFocusVisible.default)(event.target)) setFocusVisible(true);
        const newFocus = parseFloat(event.target.value);
        setState((prev)=>({
                hover: prev.hover,
                focus: newFocus
            }));
    };
    const handleBlur = (event)=>{
        if (hover !== -1) return;
        if (!(0, $a235763b3a7014ab$var$_isFocusVisible.default)(event.target)) setFocusVisible(false);
        const newFocus = -1;
        setState((prev)=>({
                hover: prev.hover,
                focus: newFocus
            }));
    };
    const [emptyValueFocused, setEmptyValueFocused] = $a235763b3a7014ab$var$React.useState(false);
    const ownerState = {
        ...props,
        component: component,
        defaultValue: defaultValue,
        disabled: disabled,
        emptyIcon: emptyIcon,
        emptyLabelText: emptyLabelText,
        emptyValueFocused: emptyValueFocused,
        focusVisible: focusVisible,
        getLabelText: getLabelText,
        icon: icon,
        IconContainerComponent: IconContainerComponent,
        max: max,
        precision: precision,
        readOnly: readOnly,
        size: size
    };
    const classes = $a235763b3a7014ab$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootSlotProps] = (0, $a235763b3a7014ab$var$_useSlot.default)('root', {
        ref: handleRef,
        className: (0, $a235763b3a7014ab$var$_clsx.default)(classes.root, className),
        elementType: $a235763b3a7014ab$var$RatingRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            component: component
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onMouseMove: (event)=>{
                    handleMouseMove(event);
                    handlers.onMouseMove?.(event);
                },
                onMouseLeave: (event)=>{
                    handleMouseLeave(event);
                    handlers.onMouseLeave?.(event);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            role: readOnly ? 'img' : null,
            'aria-label': readOnly ? getLabelText(value) : null
        }
    });
    const [LabelSlot, labelSlotProps] = (0, $a235763b3a7014ab$var$_useSlot.default)('label', {
        className: (0, $a235763b3a7014ab$var$_clsx.default)(classes.label, classes.labelEmptyValue),
        elementType: $a235763b3a7014ab$var$RatingLabel,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [DecimalSlot, decimalSlotProps] = (0, $a235763b3a7014ab$var$_useSlot.default)('decimal', {
        className: classes.decimal,
        elementType: $a235763b3a7014ab$var$RatingDecimal,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            Array.from(new Array(max)).map((_, index)=>{
                const itemValue = index + 1;
                const ratingItemProps = {
                    classes: classes,
                    disabled: disabled,
                    emptyIcon: emptyIcon,
                    focus: focus,
                    getLabelText: getLabelText,
                    highlightSelectedOnly: highlightSelectedOnly,
                    hover: hover,
                    icon: icon,
                    IconContainerComponent: IconContainerComponent,
                    name: name,
                    onBlur: handleBlur,
                    onChange: handleChange,
                    onClick: handleClear,
                    onFocus: handleFocus,
                    ratingValue: value,
                    ratingValueRounded: valueRounded,
                    readOnly: readOnly,
                    ownerState: ownerState,
                    slots: slots,
                    slotProps: slotProps
                };
                const isActive = itemValue === Math.ceil(value) && (hover !== -1 || focus !== -1);
                if (precision < 1) {
                    const items = Array.from(new Array(1 / precision));
                    return /*#__PURE__*/ (0, $a235763b3a7014ab$var$_react.createElement)(DecimalSlot, {
                        ...decimalSlotProps,
                        key: itemValue,
                        className: (0, $a235763b3a7014ab$var$_clsx.default)(decimalSlotProps.className, isActive && classes.iconActive),
                        iconActive: isActive
                    }, items.map(($, indexDecimal)=>{
                        const itemDecimalValue = $a235763b3a7014ab$var$roundValueToPrecision(itemValue - 1 + (indexDecimal + 1) * precision, precision);
                        return /*#__PURE__*/ (0, $ayMG0.jsx)($a235763b3a7014ab$var$RatingItem, {
                            ...ratingItemProps,
                            // The icon is already displayed as active
                            isActive: false,
                            itemValue: itemDecimalValue,
                            labelProps: {
                                style: items.length - 1 === indexDecimal ? {} : {
                                    width: itemDecimalValue === value ? `${(indexDecimal + 1) * precision * 100}%` : '0%',
                                    overflow: 'hidden',
                                    position: 'absolute'
                                }
                            }
                        }, itemDecimalValue);
                    }));
                }
                return /*#__PURE__*/ (0, $ayMG0.jsx)($a235763b3a7014ab$var$RatingItem, {
                    ...ratingItemProps,
                    isActive: isActive,
                    itemValue: itemValue
                }, itemValue);
            }),
            !readOnly && !disabled && /*#__PURE__*/ (0, $ayMG0.jsxs)(LabelSlot, {
                ...labelSlotProps,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        className: classes.visuallyHidden,
                        value: "",
                        id: `${name}-empty`,
                        type: "radio",
                        name: name,
                        checked: valueRounded == null,
                        onFocus: ()=>setEmptyValueFocused(true),
                        onBlur: ()=>setEmptyValueFocused(false),
                        onChange: handleChange
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: classes.visuallyHidden,
                        children: emptyLabelText
                    })
                ]
            })
        ]
    });
});
$a235763b3a7014ab$var$Rating.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * @ignore
   */ children: $a235763b3a7014ab$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $a235763b3a7014ab$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $a235763b3a7014ab$var$_propTypes.default.string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $a235763b3a7014ab$var$_propTypes.default.elementType,
    /**
   * The default value. Use when the component is not controlled.
   * @default null
   */ defaultValue: $a235763b3a7014ab$var$_propTypes.default.number,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: $a235763b3a7014ab$var$_propTypes.default.bool,
    /**
   * The icon to display when empty.
   * @default <StarBorder fontSize="inherit" />
   */ emptyIcon: $a235763b3a7014ab$var$_propTypes.default.node,
    /**
   * The label read when the rating input is empty.
   * @default 'Empty'
   */ emptyLabelText: $a235763b3a7014ab$var$_propTypes.default.node,
    /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current value of the rating.
   * This is important for screen reader users.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @param {number} value The rating label's value to format.
   * @returns {string}
   * @default function defaultLabelText(value) {
   *   return `${value || '0'} Star${value !== 1 ? 's' : ''}`;
   * }
   */ getLabelText: $a235763b3a7014ab$var$_propTypes.default.func,
    /**
   * If `true`, only the selected icon will be highlighted.
   * @default false
   */ highlightSelectedOnly: $a235763b3a7014ab$var$_propTypes.default.bool,
    /**
   * The icon to display.
   * @default <Star fontSize="inherit" />
   */ icon: $a235763b3a7014ab$var$_propTypes.default.node,
    /**
   * The component containing the icon.
   * @deprecated Use `slotProps.icon.component` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default function IconContainer(props) {
   *   const { value, ...other } = props;
   *   return <span {...other} />;
   * }
   */ IconContainerComponent: $a235763b3a7014ab$var$_propTypes.default.elementType,
    /**
   * Maximum rating.
   * @default 5
   */ max: $a235763b3a7014ab$var$_propTypes.default.number,
    /**
   * The name attribute of the radio `input` elements.
   * This input `name` should be unique within the page.
   * Being unique within a form is insufficient since the `name` is used to generate IDs.
   */ name: $a235763b3a7014ab$var$_propTypes.default.string,
    /**
   * Callback fired when the value changes.
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {number|null} value The new value.
   */ onChange: $a235763b3a7014ab$var$_propTypes.default.func,
    /**
   * Callback function that is fired when the hover state changes.
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {number} value The new value.
   */ onChangeActive: $a235763b3a7014ab$var$_propTypes.default.func,
    /**
   * @ignore
   */ onMouseLeave: $a235763b3a7014ab$var$_propTypes.default.func,
    /**
   * @ignore
   */ onMouseMove: $a235763b3a7014ab$var$_propTypes.default.func,
    /**
   * The minimum increment value change allowed.
   * @default 1
   */ precision: (0, $a235763b3a7014ab$var$_chainPropTypes.default)($a235763b3a7014ab$var$_propTypes.default.number, (props)=>{
        if (props.precision < 0.1) return new Error([
            'MUI: The prop `precision` should be above 0.1.',
            'A value below this limit has an imperceptible impact.'
        ].join('\n'));
        return null;
    }),
    /**
   * Removes all hover effects and pointer events.
   * @default false
   */ readOnly: $a235763b3a7014ab$var$_propTypes.default.bool,
    /**
   * The size of the component.
   * @default 'medium'
   */ size: $a235763b3a7014ab$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $a235763b3a7014ab$var$_propTypes.default.oneOf([
            'small',
            'medium',
            'large'
        ]),
        $a235763b3a7014ab$var$_propTypes.default.string
    ]),
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $a235763b3a7014ab$var$_propTypes.default.shape({
        decimal: $a235763b3a7014ab$var$_propTypes.default.oneOfType([
            $a235763b3a7014ab$var$_propTypes.default.func,
            $a235763b3a7014ab$var$_propTypes.default.object
        ]),
        icon: $a235763b3a7014ab$var$_propTypes.default.oneOfType([
            $a235763b3a7014ab$var$_propTypes.default.func,
            $a235763b3a7014ab$var$_propTypes.default.object
        ]),
        label: $a235763b3a7014ab$var$_propTypes.default.oneOfType([
            $a235763b3a7014ab$var$_propTypes.default.func,
            $a235763b3a7014ab$var$_propTypes.default.object
        ]),
        root: $a235763b3a7014ab$var$_propTypes.default.oneOfType([
            $a235763b3a7014ab$var$_propTypes.default.func,
            $a235763b3a7014ab$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: $a235763b3a7014ab$var$_propTypes.default.shape({
        decimal: $a235763b3a7014ab$var$_propTypes.default.elementType,
        icon: $a235763b3a7014ab$var$_propTypes.default.elementType,
        label: $a235763b3a7014ab$var$_propTypes.default.elementType,
        root: $a235763b3a7014ab$var$_propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $a235763b3a7014ab$var$_propTypes.default.oneOfType([
        $a235763b3a7014ab$var$_propTypes.default.arrayOf($a235763b3a7014ab$var$_propTypes.default.oneOfType([
            $a235763b3a7014ab$var$_propTypes.default.func,
            $a235763b3a7014ab$var$_propTypes.default.object,
            $a235763b3a7014ab$var$_propTypes.default.bool
        ])),
        $a235763b3a7014ab$var$_propTypes.default.func,
        $a235763b3a7014ab$var$_propTypes.default.object
    ]),
    /**
   * The rating value.
   */ value: $a235763b3a7014ab$var$_propTypes.default.number
};
var $a235763b3a7014ab$var$_default = module.exports.default = $a235763b3a7014ab$var$Rating;

});
parcelRegister("1YYSs", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $171a9e042ff90d6b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $171a9e042ff90d6b$var$_visuallyHidden.default;
    }
});

var $171a9e042ff90d6b$var$_visuallyHidden = $171a9e042ff90d6b$require$_interopRequireDefault((parcelRequire("8llzV")));

});
parcelRegister("8llzV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $613105e9b38354c3$var$visuallyHidden = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
};
var $613105e9b38354c3$var$_default = module.exports.default = $613105e9b38354c3$var$visuallyHidden;

});


parcelRegister("k2Gvj", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $e974f6f757d51cd9$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e974f6f757d51cd9$var$_createSvgIcon = $e974f6f757d51cd9$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $e974f6f757d51cd9$var$_default = module.exports.default = (0, $e974f6f757d51cd9$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
}), 'Star');

});

parcelRegister("6TAtw", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $50542c5736b6354f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $50542c5736b6354f$var$_createSvgIcon = $50542c5736b6354f$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $50542c5736b6354f$var$_default = module.exports.default = (0, $50542c5736b6354f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
}), 'StarBorder');

});

parcelRegister("7ynaW", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $57fdaf8fdc94de34$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getRatingUtilityClass = $57fdaf8fdc94de34$var$getRatingUtilityClass;

var $57fdaf8fdc94de34$var$_generateUtilityClasses = $57fdaf8fdc94de34$require$_interopRequireDefault((parcelRequire("5nY49")));

var $57fdaf8fdc94de34$var$_generateUtilityClass = $57fdaf8fdc94de34$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $57fdaf8fdc94de34$var$getRatingUtilityClass(slot) {
    return (0, $57fdaf8fdc94de34$var$_generateUtilityClass.default)('MuiRating', slot);
}
const $57fdaf8fdc94de34$var$ratingClasses = (0, $57fdaf8fdc94de34$var$_generateUtilityClasses.default)('MuiRating', [
    'root',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'readOnly',
    'disabled',
    'focusVisible',
    'visuallyHidden',
    'pristine',
    'label',
    'labelEmptyValueActive',
    'icon',
    'iconEmpty',
    'iconFilled',
    'iconHover',
    'iconFocus',
    'iconActive',
    'decimal'
]);
var $57fdaf8fdc94de34$var$_default = module.exports.default = $57fdaf8fdc94de34$var$ratingClasses;

});



parcelRegister("ePchM", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $acaf5bc8fc7510ef$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $acaf5bc8fc7510ef$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $acaf5bc8fc7510ef$var$_exportNames = {
    scopedCssBaselineClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $acaf5bc8fc7510ef$var$_ScopedCssBaseline.default;
    }
});
Object.defineProperty(module.exports, "scopedCssBaselineClasses", {
    enumerable: true,
    get: function() {
        return $acaf5bc8fc7510ef$var$_scopedCssBaselineClasses.default;
    }
});

var $acaf5bc8fc7510ef$var$_ScopedCssBaseline = $acaf5bc8fc7510ef$require$_interopRequireDefault((parcelRequire("ll3GB")));

var $acaf5bc8fc7510ef$var$_scopedCssBaselineClasses = $acaf5bc8fc7510ef$require$_interopRequireWildcard((parcelRequire("hH8RP")));
Object.keys($acaf5bc8fc7510ef$var$_scopedCssBaselineClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($acaf5bc8fc7510ef$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $acaf5bc8fc7510ef$var$_scopedCssBaselineClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $acaf5bc8fc7510ef$var$_scopedCssBaselineClasses[key];
        }
    });
});

});
parcelRegister("ll3GB", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $f88e6b262a71acad$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $f88e6b262a71acad$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f88e6b262a71acad$var$React = $f88e6b262a71acad$require$_interopRequireWildcard((parcelRequire("acw62")));

var $f88e6b262a71acad$var$_propTypes = $f88e6b262a71acad$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $f88e6b262a71acad$var$_clsx = $f88e6b262a71acad$require$_interopRequireDefault((parcelRequire("9QePP")));

var $f88e6b262a71acad$var$_composeClasses = $f88e6b262a71acad$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $f88e6b262a71acad$var$_memoTheme = $f88e6b262a71acad$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $gODrq = parcelRequire("gODrq");

var $hH8RP = parcelRequire("hH8RP");

var $ayMG0 = parcelRequire("ayMG0");
const $f88e6b262a71acad$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $f88e6b262a71acad$var$_composeClasses.default)(slots, $hH8RP.getScopedCssBaselineUtilityClass, classes);
};
const $f88e6b262a71acad$var$ScopedCssBaselineRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiScopedCssBaseline',
    slot: 'Root'
})((0, $f88e6b262a71acad$var$_memoTheme.default)(({ theme: theme })=>{
    const colorSchemeStyles = {};
    if (theme.colorSchemes) Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        const selector = theme.getColorSchemeSelector(key);
        if (selector.startsWith('@')) colorSchemeStyles[selector] = {
            colorScheme: scheme.palette?.mode
        };
        else colorSchemeStyles[`&${selector.replace(/\s*&/, '')}`] = {
            colorScheme: scheme.palette?.mode
        };
    });
    return {
        ...(0, $gODrq.html)(theme, false),
        ...(0, $gODrq.body)(theme),
        '& *, & *::before, & *::after': {
            boxSizing: 'inherit'
        },
        '& strong, & b': {
            fontWeight: theme.typography.fontWeightBold
        },
        variants: [
            {
                props: {
                    enableColorScheme: true
                },
                style: theme.vars ? colorSchemeStyles : {
                    colorScheme: theme.palette.mode
                }
            }
        ]
    };
}));
const $f88e6b262a71acad$var$ScopedCssBaseline = /*#__PURE__*/ $f88e6b262a71acad$var$React.forwardRef(function ScopedCssBaseline(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiScopedCssBaseline'
    });
    const { className: className, component: component = 'div', enableColorScheme: enableColorScheme, ...other } = props;
    const ownerState = {
        ...props,
        component: component
    };
    const classes = $f88e6b262a71acad$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($f88e6b262a71acad$var$ScopedCssBaselineRoot, {
        as: component,
        className: (0, $f88e6b262a71acad$var$_clsx.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
$f88e6b262a71acad$var$ScopedCssBaseline.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: $f88e6b262a71acad$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $f88e6b262a71acad$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $f88e6b262a71acad$var$_propTypes.default.string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $f88e6b262a71acad$var$_propTypes.default.elementType,
    /**
   * Enable `color-scheme` CSS property to use `theme.palette.mode`.
   * For more details, check out https://developer.mozilla.org/en-US/docs/Web/CSS/Reference/Properties/color-scheme
   * For browser support, check out https://caniuse.com/?search=color-scheme
   */ enableColorScheme: $f88e6b262a71acad$var$_propTypes.default.bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $f88e6b262a71acad$var$_propTypes.default.oneOfType([
        $f88e6b262a71acad$var$_propTypes.default.arrayOf($f88e6b262a71acad$var$_propTypes.default.oneOfType([
            $f88e6b262a71acad$var$_propTypes.default.func,
            $f88e6b262a71acad$var$_propTypes.default.object,
            $f88e6b262a71acad$var$_propTypes.default.bool
        ])),
        $f88e6b262a71acad$var$_propTypes.default.func,
        $f88e6b262a71acad$var$_propTypes.default.object
    ])
};
var $f88e6b262a71acad$var$_default = module.exports.default = $f88e6b262a71acad$var$ScopedCssBaseline;

});
parcelRegister("hH8RP", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ce1d54a938e4ef44$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getScopedCssBaselineUtilityClass = $ce1d54a938e4ef44$var$getScopedCssBaselineUtilityClass;

var $ce1d54a938e4ef44$var$_generateUtilityClasses = $ce1d54a938e4ef44$require$_interopRequireDefault((parcelRequire("5nY49")));

var $ce1d54a938e4ef44$var$_generateUtilityClass = $ce1d54a938e4ef44$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $ce1d54a938e4ef44$var$getScopedCssBaselineUtilityClass(slot) {
    return (0, $ce1d54a938e4ef44$var$_generateUtilityClass.default)('MuiScopedCssBaseline', slot);
}
const $ce1d54a938e4ef44$var$scopedCssBaselineClasses = (0, $ce1d54a938e4ef44$var$_generateUtilityClasses.default)('MuiScopedCssBaseline', [
    'root'
]);
var $ce1d54a938e4ef44$var$_default = module.exports.default = $ce1d54a938e4ef44$var$scopedCssBaselineClasses;

});



parcelRegister("1WNCH", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $16b1b35b06ce5bdf$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $16b1b35b06ce5bdf$var$_exportNames = {
    sliderClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $16b1b35b06ce5bdf$var$_Slider.default;
    }
});
Object.defineProperty(module.exports, "sliderClasses", {
    enumerable: true,
    get: function() {
        return $16b1b35b06ce5bdf$var$_sliderClasses.default;
    }
});

var $16b1b35b06ce5bdf$var$_Slider = $16b1b35b06ce5bdf$require$_interopRequireWildcard((parcelRequire("jU0bc")));
Object.keys($16b1b35b06ce5bdf$var$_Slider).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($16b1b35b06ce5bdf$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $16b1b35b06ce5bdf$var$_Slider[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $16b1b35b06ce5bdf$var$_Slider[key];
        }
    });
});

var $16b1b35b06ce5bdf$var$_sliderClasses = $16b1b35b06ce5bdf$require$_interopRequireWildcard((parcelRequire("20dvU")));
Object.keys($16b1b35b06ce5bdf$var$_sliderClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($16b1b35b06ce5bdf$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $16b1b35b06ce5bdf$var$_sliderClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $16b1b35b06ce5bdf$var$_sliderClasses[key];
        }
    });
});

});
parcelRegister("jU0bc", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $e7d362f04a4204f3$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $e7d362f04a4204f3$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.SliderValueLabel = module.exports.SliderTrack = module.exports.SliderThumb = module.exports.SliderRoot = module.exports.SliderRail = module.exports.SliderMarkLabel = module.exports.SliderMark = void 0;

var $e7d362f04a4204f3$var$React = $e7d362f04a4204f3$require$_interopRequireWildcard((parcelRequire("acw62")));

var $e7d362f04a4204f3$var$_propTypes = $e7d362f04a4204f3$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $e7d362f04a4204f3$var$_clsx = $e7d362f04a4204f3$require$_interopRequireDefault((parcelRequire("9QePP")));

var $e7d362f04a4204f3$var$_chainPropTypes = $e7d362f04a4204f3$require$_interopRequireDefault((parcelRequire("abVWF")));

var $e7d362f04a4204f3$var$_composeClasses = $e7d362f04a4204f3$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $9uEev = parcelRequire("9uEev");

var $e7d362f04a4204f3$var$_useSlotProps = $e7d362f04a4204f3$require$_interopRequireDefault((parcelRequire("839K0")));

var $e7d362f04a4204f3$var$_isHostComponent = $e7d362f04a4204f3$require$_interopRequireDefault((parcelRequire("7jqh1")));

var $dBUOG = parcelRequire("dBUOG");

var $aAbgT = parcelRequire("aAbgT");

var $e7d362f04a4204f3$var$_memoTheme = $e7d362f04a4204f3$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $e7d362f04a4204f3$var$_slotShouldForwardProp = $e7d362f04a4204f3$require$_interopRequireDefault((parcelRequire("PJRTc")));

var $e7d362f04a4204f3$var$_shouldSpreadAdditionalProps = $e7d362f04a4204f3$require$_interopRequireDefault((parcelRequire("lTbyd")));

var $e7d362f04a4204f3$var$_capitalize = $e7d362f04a4204f3$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $e7d362f04a4204f3$var$_createSimplePaletteValueFilter = $e7d362f04a4204f3$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $e7d362f04a4204f3$var$_SliderValueLabel = $e7d362f04a4204f3$require$_interopRequireDefault((parcelRequire("2xkal")));

var $e7d362f04a4204f3$var$_sliderClasses = $e7d362f04a4204f3$require$_interopRequireWildcard((parcelRequire("20dvU")));

var $ayMG0 = parcelRequire("ayMG0");
function $e7d362f04a4204f3$var$Identity(x) {
    return x;
}
const $e7d362f04a4204f3$var$SliderRoot = module.exports.SliderRoot = (0, $aAbgT.styled)('span', {
    name: 'MuiSlider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $e7d362f04a4204f3$var$_capitalize.default)(ownerState.color)}`],
            ownerState.size !== 'medium' && styles[`size${(0, $e7d362f04a4204f3$var$_capitalize.default)(ownerState.size)}`],
            ownerState.marked && styles.marked,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.track === 'inverted' && styles.trackInverted,
            ownerState.track === false && styles.trackFalse
        ];
    }
})((0, $e7d362f04a4204f3$var$_memoTheme.default)(({ theme: theme })=>({
        borderRadius: 12,
        boxSizing: 'content-box',
        display: 'inline-block',
        position: 'relative',
        cursor: 'pointer',
        touchAction: 'none',
        WebkitTapHighlightColor: 'transparent',
        '@media print': {
            colorAdjust: 'exact'
        },
        [`&.${$e7d362f04a4204f3$var$_sliderClasses.default.disabled}`]: {
            pointerEvents: 'none',
            cursor: 'default',
            color: (theme.vars || theme).palette.grey[400]
        },
        [`&.${$e7d362f04a4204f3$var$_sliderClasses.default.dragging}`]: {
            [`& .${$e7d362f04a4204f3$var$_sliderClasses.default.thumb}, & .${$e7d362f04a4204f3$var$_sliderClasses.default.track}`]: {
                transition: 'none'
            }
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $e7d362f04a4204f3$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 4,
                    width: '100%',
                    padding: '13px 0',
                    // The primary input mechanism of the device includes a pointing device of limited accuracy.
                    '@media (pointer: coarse)': {
                        // Reach 42px touch target, about ~8mm on screen.
                        padding: '20px 0'
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal',
                    size: 'small'
                },
                style: {
                    height: 2
                }
            },
            {
                props: {
                    orientation: 'horizontal',
                    marked: true
                },
                style: {
                    marginBottom: 20
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    height: '100%',
                    width: 4,
                    padding: '0 13px',
                    // The primary input mechanism of the device includes a pointing device of limited accuracy.
                    '@media (pointer: coarse)': {
                        // Reach 42px touch target, about ~8mm on screen.
                        padding: '0 20px'
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    size: 'small'
                },
                style: {
                    width: 2
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    marked: true
                },
                style: {
                    marginRight: 44
                }
            }
        ]
    })));
const $e7d362f04a4204f3$var$SliderRail = module.exports.SliderRail = (0, $aAbgT.styled)('span', {
    name: 'MuiSlider',
    slot: 'Rail'
})({
    display: 'block',
    position: 'absolute',
    borderRadius: 'inherit',
    backgroundColor: 'currentColor',
    opacity: 0.38,
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                width: '100%',
                height: 'inherit',
                top: '50%',
                transform: 'translateY(-50%)'
            }
        },
        {
            props: {
                orientation: 'vertical'
            },
            style: {
                height: '100%',
                width: 'inherit',
                left: '50%',
                transform: 'translateX(-50%)'
            }
        },
        {
            props: {
                track: 'inverted'
            },
            style: {
                opacity: 1
            }
        }
    ]
});
const $e7d362f04a4204f3$var$SliderTrack = module.exports.SliderTrack = (0, $aAbgT.styled)('span', {
    name: 'MuiSlider',
    slot: 'Track'
})((0, $e7d362f04a4204f3$var$_memoTheme.default)(({ theme: theme })=>{
    return {
        display: 'block',
        position: 'absolute',
        borderRadius: 'inherit',
        border: '1px solid currentColor',
        backgroundColor: 'currentColor',
        transition: theme.transitions.create([
            'left',
            'width',
            'bottom',
            'height'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    border: 'none'
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 'inherit',
                    top: '50%',
                    transform: 'translateY(-50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    width: 'inherit',
                    left: '50%',
                    transform: 'translateX(-50%)'
                }
            },
            {
                props: {
                    track: false
                },
                style: {
                    display: 'none'
                }
            },
            ...Object.entries(theme.palette).filter((0, $e7d362f04a4204f3$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color,
                        track: 'inverted'
                    },
                    style: {
                        ...theme.vars ? {
                            backgroundColor: theme.vars.palette.Slider[`${color}Track`],
                            borderColor: theme.vars.palette.Slider[`${color}Track`]
                        } : {
                            backgroundColor: theme.lighten(theme.palette[color].main, 0.62),
                            borderColor: theme.lighten(theme.palette[color].main, 0.62),
                            ...theme.applyStyles('dark', {
                                backgroundColor: theme.darken(theme.palette[color].main, 0.5)
                            }),
                            ...theme.applyStyles('dark', {
                                borderColor: theme.darken(theme.palette[color].main, 0.5)
                            })
                        }
                    }
                }))
        ]
    };
}));
const $e7d362f04a4204f3$var$SliderThumb = module.exports.SliderThumb = (0, $aAbgT.styled)('span', {
    name: 'MuiSlider',
    slot: 'Thumb',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.thumb,
            styles[`thumbColor${(0, $e7d362f04a4204f3$var$_capitalize.default)(ownerState.color)}`],
            ownerState.size !== 'medium' && styles[`thumbSize${(0, $e7d362f04a4204f3$var$_capitalize.default)(ownerState.size)}`]
        ];
    }
})((0, $e7d362f04a4204f3$var$_memoTheme.default)(({ theme: theme })=>({
        position: 'absolute',
        width: 20,
        height: 20,
        boxSizing: 'border-box',
        borderRadius: '50%',
        outline: 0,
        backgroundColor: 'currentColor',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: theme.transitions.create([
            'box-shadow',
            'left',
            'bottom'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        '&::before': {
            position: 'absolute',
            content: '""',
            borderRadius: 'inherit',
            width: '100%',
            height: '100%',
            boxShadow: (theme.vars || theme).shadows[2]
        },
        '&::after': {
            position: 'absolute',
            content: '""',
            borderRadius: '50%',
            // 42px is the hit target
            width: 42,
            height: 42,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
        },
        [`&.${$e7d362f04a4204f3$var$_sliderClasses.default.disabled}`]: {
            '&:hover': {
                boxShadow: 'none'
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    width: 12,
                    height: 12,
                    '&::before': {
                        boxShadow: 'none'
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: '50%',
                    transform: 'translate(-50%, -50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%, 50%)'
                }
            },
            ...Object.entries(theme.palette).filter((0, $e7d362f04a4204f3$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&:hover, &.${$e7d362f04a4204f3$var$_sliderClasses.default.focusVisible}`]: {
                            boxShadow: `0px 0px 0px 8px ${theme.alpha((theme.vars || theme).palette[color].main, 0.16)}`,
                            '@media (hover: none)': {
                                boxShadow: 'none'
                            }
                        },
                        [`&.${$e7d362f04a4204f3$var$_sliderClasses.default.active}`]: {
                            boxShadow: `0px 0px 0px 14px ${theme.alpha((theme.vars || theme).palette[color].main, 0.16)}`
                        }
                    }
                }))
        ]
    })));
const $e7d362f04a4204f3$var$SliderValueLabel = module.exports.SliderValueLabel = (0, $aAbgT.styled)($e7d362f04a4204f3$var$_SliderValueLabel.default, {
    name: 'MuiSlider',
    slot: 'ValueLabel'
})((0, $e7d362f04a4204f3$var$_memoTheme.default)(({ theme: theme })=>({
        zIndex: 1,
        whiteSpace: 'nowrap',
        ...theme.typography.body2,
        fontWeight: 500,
        transition: theme.transitions.create([
            'transform'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        position: 'absolute',
        backgroundColor: (theme.vars || theme).palette.grey[600],
        borderRadius: 2,
        color: (theme.vars || theme).palette.common.white,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0.25rem 0.75rem',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    transform: 'translateY(-100%) scale(0)',
                    top: '-10px',
                    transformOrigin: 'bottom center',
                    '&::before': {
                        position: 'absolute',
                        content: '""',
                        width: 8,
                        height: 8,
                        transform: 'translate(-50%, 50%) rotate(45deg)',
                        backgroundColor: 'inherit',
                        bottom: 0,
                        left: '50%'
                    },
                    [`&.${$e7d362f04a4204f3$var$_sliderClasses.default.valueLabelOpen}`]: {
                        transform: 'translateY(-100%) scale(1)'
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    transform: 'translateY(-50%) scale(0)',
                    right: '30px',
                    top: '50%',
                    transformOrigin: 'right center',
                    '&::before': {
                        position: 'absolute',
                        content: '""',
                        width: 8,
                        height: 8,
                        transform: 'translate(-50%, -50%) rotate(45deg)',
                        backgroundColor: 'inherit',
                        right: -8,
                        top: '50%'
                    },
                    [`&.${$e7d362f04a4204f3$var$_sliderClasses.default.valueLabelOpen}`]: {
                        transform: 'translateY(-50%) scale(1)'
                    }
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    fontSize: theme.typography.pxToRem(12),
                    padding: '0.25rem 0.5rem'
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    size: 'small'
                },
                style: {
                    right: '20px'
                }
            }
        ]
    })));
$e7d362f04a4204f3$var$SliderValueLabel.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * @ignore
   */ children: $e7d362f04a4204f3$var$_propTypes.default.element.isRequired,
    /**
   * @ignore
   */ index: $e7d362f04a4204f3$var$_propTypes.default.number.isRequired,
    /**
   * @ignore
   */ open: $e7d362f04a4204f3$var$_propTypes.default.bool.isRequired,
    /**
   * @ignore
   */ value: $e7d362f04a4204f3$var$_propTypes.default.node
};
const $e7d362f04a4204f3$var$SliderMark = module.exports.SliderMark = (0, $aAbgT.styled)('span', {
    name: 'MuiSlider',
    slot: 'Mark',
    shouldForwardProp: (prop)=>(0, $e7d362f04a4204f3$var$_slotShouldForwardProp.default)(prop) && prop !== 'markActive',
    overridesResolver: (props, styles)=>{
        const { markActive: markActive } = props;
        return [
            styles.mark,
            markActive && styles.markActive
        ];
    }
})((0, $e7d362f04a4204f3$var$_memoTheme.default)(({ theme: theme })=>({
        position: 'absolute',
        width: 2,
        height: 2,
        borderRadius: 1,
        backgroundColor: 'currentColor',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: '50%',
                    transform: 'translate(-1px, -50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%, 1px)'
                }
            },
            {
                props: {
                    markActive: true
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.background.paper,
                    opacity: 0.8
                }
            }
        ]
    })));
const $e7d362f04a4204f3$var$SliderMarkLabel = module.exports.SliderMarkLabel = (0, $aAbgT.styled)('span', {
    name: 'MuiSlider',
    slot: 'MarkLabel',
    shouldForwardProp: (prop)=>(0, $e7d362f04a4204f3$var$_slotShouldForwardProp.default)(prop) && prop !== 'markLabelActive'
})((0, $e7d362f04a4204f3$var$_memoTheme.default)(({ theme: theme })=>({
        ...theme.typography.body2,
        color: (theme.vars || theme).palette.text.secondary,
        position: 'absolute',
        whiteSpace: 'nowrap',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: 30,
                    transform: 'translateX(-50%)',
                    '@media (pointer: coarse)': {
                        top: 40
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: 36,
                    transform: 'translateY(50%)',
                    '@media (pointer: coarse)': {
                        left: 44
                    }
                }
            },
            {
                props: {
                    markLabelActive: true
                },
                style: {
                    color: (theme.vars || theme).palette.text.primary
                }
            }
        ]
    })));
const $e7d362f04a4204f3$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dragging: dragging, marked: marked, orientation: orientation, track: track, classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            dragging && 'dragging',
            marked && 'marked',
            orientation === 'vertical' && 'vertical',
            track === 'inverted' && 'trackInverted',
            track === false && 'trackFalse',
            color && `color${(0, $e7d362f04a4204f3$var$_capitalize.default)(color)}`,
            size && `size${(0, $e7d362f04a4204f3$var$_capitalize.default)(size)}`
        ],
        rail: [
            'rail'
        ],
        track: [
            'track'
        ],
        mark: [
            'mark'
        ],
        markActive: [
            'markActive'
        ],
        markLabel: [
            'markLabel'
        ],
        markLabelActive: [
            'markLabelActive'
        ],
        valueLabel: [
            'valueLabel'
        ],
        thumb: [
            'thumb',
            disabled && 'disabled',
            size && `thumbSize${(0, $e7d362f04a4204f3$var$_capitalize.default)(size)}`,
            color && `thumbColor${(0, $e7d362f04a4204f3$var$_capitalize.default)(color)}`
        ],
        active: [
            'active'
        ],
        disabled: [
            'disabled'
        ],
        focusVisible: [
            'focusVisible'
        ]
    };
    return (0, $e7d362f04a4204f3$var$_composeClasses.default)(slots, $e7d362f04a4204f3$var$_sliderClasses.getSliderUtilityClass, classes);
};
const $e7d362f04a4204f3$var$Forward = ({ children: children })=>children;
const $e7d362f04a4204f3$var$Slider = /*#__PURE__*/ $e7d362f04a4204f3$var$React.forwardRef(function Slider(inputProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inputProps,
        name: 'MuiSlider'
    });
    const isRtl = (0, $9uEev.useRtl)();
    const { 'aria-label': ariaLabel, 'aria-valuetext': ariaValuetext, 'aria-labelledby': ariaLabelledby, component: // eslint-disable-next-line react/prop-types
    component = 'span', components: components = {}, componentsProps: componentsProps = {}, color: color = 'primary', classes: classesProp, className: className, disableSwap: disableSwap = false, disabled: disabled = false, getAriaLabel: getAriaLabel, getAriaValueText: getAriaValueText, marks: marksProp = false, max: max = 100, min: min = 0, name: name, onChange: onChange, onChangeCommitted: onChangeCommitted, orientation: orientation = 'horizontal', shiftStep: shiftStep = 10, size: size = 'medium', step: step = 1, scale: scale = $e7d362f04a4204f3$var$Identity, slotProps: slotProps, slots: slots, tabIndex: tabIndex, track: track = 'normal', value: valueProp, valueLabelDisplay: valueLabelDisplay = 'off', valueLabelFormat: valueLabelFormat = $e7d362f04a4204f3$var$Identity, ...other } = props;
    const ownerState = {
        ...props,
        isRtl: isRtl,
        max: max,
        min: min,
        classes: classesProp,
        disabled: disabled,
        disableSwap: disableSwap,
        orientation: orientation,
        marks: marksProp,
        color: color,
        size: size,
        step: step,
        shiftStep: shiftStep,
        scale: scale,
        track: track,
        valueLabelDisplay: valueLabelDisplay,
        valueLabelFormat: valueLabelFormat
    };
    const { axisProps: axisProps, getRootProps: getRootProps, getHiddenInputProps: getHiddenInputProps, getThumbProps: getThumbProps, open: open, active: active, axis: axis, focusedThumbIndex: focusedThumbIndex, range: range, dragging: dragging, marks: marks, values: values, trackOffset: trackOffset, trackLeap: trackLeap, getThumbStyle: getThumbStyle } = (0, $dBUOG.useSlider)({
        ...ownerState,
        rootRef: ref
    });
    ownerState.marked = marks.length > 0 && marks.some((mark)=>mark.label);
    ownerState.dragging = dragging;
    ownerState.focusedThumbIndex = focusedThumbIndex;
    const classes = $e7d362f04a4204f3$var$useUtilityClasses(ownerState);
    // support both `slots` and `components` for backward compatibility
    const RootSlot = slots?.root ?? components.Root ?? $e7d362f04a4204f3$var$SliderRoot;
    const RailSlot = slots?.rail ?? components.Rail ?? $e7d362f04a4204f3$var$SliderRail;
    const TrackSlot = slots?.track ?? components.Track ?? $e7d362f04a4204f3$var$SliderTrack;
    const ThumbSlot = slots?.thumb ?? components.Thumb ?? $e7d362f04a4204f3$var$SliderThumb;
    const ValueLabelSlot = slots?.valueLabel ?? components.ValueLabel ?? $e7d362f04a4204f3$var$SliderValueLabel;
    const MarkSlot = slots?.mark ?? components.Mark ?? $e7d362f04a4204f3$var$SliderMark;
    const MarkLabelSlot = slots?.markLabel ?? components.MarkLabel ?? $e7d362f04a4204f3$var$SliderMarkLabel;
    const InputSlot = slots?.input ?? components.Input ?? 'input';
    const rootSlotProps = slotProps?.root ?? componentsProps.root;
    const railSlotProps = slotProps?.rail ?? componentsProps.rail;
    const trackSlotProps = slotProps?.track ?? componentsProps.track;
    const thumbSlotProps = slotProps?.thumb ?? componentsProps.thumb;
    const valueLabelSlotProps = slotProps?.valueLabel ?? componentsProps.valueLabel;
    const markSlotProps = slotProps?.mark ?? componentsProps.mark;
    const markLabelSlotProps = slotProps?.markLabel ?? componentsProps.markLabel;
    const inputSlotProps = slotProps?.input ?? componentsProps.input;
    const rootProps = (0, $e7d362f04a4204f3$var$_useSlotProps.default)({
        elementType: RootSlot,
        getSlotProps: getRootProps,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        additionalProps: {
            ...(0, $e7d362f04a4204f3$var$_shouldSpreadAdditionalProps.default)(RootSlot) && {
                as: component
            }
        },
        ownerState: {
            ...ownerState,
            ...rootSlotProps?.ownerState
        },
        className: [
            classes.root,
            className
        ]
    });
    const railProps = (0, $e7d362f04a4204f3$var$_useSlotProps.default)({
        elementType: RailSlot,
        externalSlotProps: railSlotProps,
        ownerState: ownerState,
        className: classes.rail
    });
    const trackProps = (0, $e7d362f04a4204f3$var$_useSlotProps.default)({
        elementType: TrackSlot,
        externalSlotProps: trackSlotProps,
        additionalProps: {
            style: {
                ...axisProps[axis].offset(trackOffset),
                ...axisProps[axis].leap(trackLeap)
            }
        },
        ownerState: {
            ...ownerState,
            ...trackSlotProps?.ownerState
        },
        className: classes.track
    });
    const thumbProps = (0, $e7d362f04a4204f3$var$_useSlotProps.default)({
        elementType: ThumbSlot,
        getSlotProps: getThumbProps,
        externalSlotProps: thumbSlotProps,
        ownerState: {
            ...ownerState,
            ...thumbSlotProps?.ownerState
        },
        className: classes.thumb
    });
    const valueLabelProps = (0, $e7d362f04a4204f3$var$_useSlotProps.default)({
        elementType: ValueLabelSlot,
        externalSlotProps: valueLabelSlotProps,
        ownerState: {
            ...ownerState,
            ...valueLabelSlotProps?.ownerState
        },
        className: classes.valueLabel
    });
    const markProps = (0, $e7d362f04a4204f3$var$_useSlotProps.default)({
        elementType: MarkSlot,
        externalSlotProps: markSlotProps,
        ownerState: ownerState,
        className: classes.mark
    });
    const markLabelProps = (0, $e7d362f04a4204f3$var$_useSlotProps.default)({
        elementType: MarkLabelSlot,
        externalSlotProps: markLabelSlotProps,
        ownerState: ownerState,
        className: classes.markLabel
    });
    const inputSliderProps = (0, $e7d362f04a4204f3$var$_useSlotProps.default)({
        elementType: InputSlot,
        getSlotProps: getHiddenInputProps,
        externalSlotProps: inputSlotProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(RailSlot, {
                ...railProps
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(TrackSlot, {
                ...trackProps
            }),
            marks.filter((mark)=>mark.value >= min && mark.value <= max).map((mark, index)=>{
                const percent = (0, $dBUOG.valueToPercent)(mark.value, min, max);
                const style = axisProps[axis].offset(percent);
                let markActive;
                if (track === false) markActive = values.includes(mark.value);
                else markActive = track === 'normal' && (range ? mark.value >= values[0] && mark.value <= values[values.length - 1] : mark.value <= values[0]) || track === 'inverted' && (range ? mark.value <= values[0] || mark.value >= values[values.length - 1] : mark.value >= values[0]);
                return /*#__PURE__*/ (0, $ayMG0.jsxs)($e7d362f04a4204f3$var$React.Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)(MarkSlot, {
                            "data-index": index,
                            ...markProps,
                            ...!(0, $e7d362f04a4204f3$var$_isHostComponent.default)(MarkSlot) && {
                                markActive: markActive
                            },
                            style: {
                                ...style,
                                ...markProps.style
                            },
                            className: (0, $e7d362f04a4204f3$var$_clsx.default)(markProps.className, markActive && classes.markActive)
                        }),
                        mark.label != null ? /*#__PURE__*/ (0, $ayMG0.jsx)(MarkLabelSlot, {
                            "aria-hidden": true,
                            "data-index": index,
                            ...markLabelProps,
                            ...!(0, $e7d362f04a4204f3$var$_isHostComponent.default)(MarkLabelSlot) && {
                                markLabelActive: markActive
                            },
                            style: {
                                ...style,
                                ...markLabelProps.style
                            },
                            className: (0, $e7d362f04a4204f3$var$_clsx.default)(classes.markLabel, markLabelProps.className, markActive && classes.markLabelActive),
                            children: mark.label
                        }) : null
                    ]
                }, index);
            }),
            values.map((value, index)=>{
                const percent = (0, $dBUOG.valueToPercent)(value, min, max);
                const style = axisProps[axis].offset(percent);
                const ValueLabelComponent = valueLabelDisplay === 'off' ? $e7d362f04a4204f3$var$Forward : ValueLabelSlot;
                return /*#__PURE__*/ /* TODO v6: Change component structure. It will help in avoiding the complicated React.cloneElement API added in SliderValueLabel component. Should be: Thumb -> Input, ValueLabel. Follow Joy UI's Slider structure. */ (0, $ayMG0.jsx)(ValueLabelComponent, {
                    ...!(0, $e7d362f04a4204f3$var$_isHostComponent.default)(ValueLabelComponent) && {
                        valueLabelFormat: valueLabelFormat,
                        valueLabelDisplay: valueLabelDisplay,
                        value: typeof valueLabelFormat === 'function' ? valueLabelFormat(scale(value), index) : valueLabelFormat,
                        index: index,
                        open: open === index || active === index || valueLabelDisplay === 'on',
                        disabled: disabled
                    },
                    ...valueLabelProps,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(ThumbSlot, {
                        "data-index": index,
                        ...thumbProps,
                        className: (0, $e7d362f04a4204f3$var$_clsx.default)(classes.thumb, thumbProps.className, active === index && classes.active, focusedThumbIndex === index && classes.focusVisible),
                        style: {
                            ...style,
                            ...getThumbStyle(index),
                            ...thumbProps.style
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(InputSlot, {
                            "data-index": index,
                            "aria-label": getAriaLabel ? getAriaLabel(index) : ariaLabel,
                            "aria-valuenow": scale(value),
                            "aria-labelledby": ariaLabelledby,
                            "aria-valuetext": getAriaValueText ? getAriaValueText(scale(value), index) : ariaValuetext,
                            value: values[index],
                            ...inputSliderProps
                        })
                    })
                }, index);
            })
        ]
    });
});
$e7d362f04a4204f3$var$Slider.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The label of the slider.
   */ 'aria-label': (0, $e7d362f04a4204f3$var$_chainPropTypes.default)($e7d362f04a4204f3$var$_propTypes.default.string, (props)=>{
        const range = Array.isArray(props.value || props.defaultValue);
        if (range && props['aria-label'] != null) return new Error('MUI: You need to use the `getAriaLabel` prop instead of `aria-label` when using a range slider.');
        return null;
    }),
    /**
   * The id of the element containing a label for the slider.
   */ 'aria-labelledby': $e7d362f04a4204f3$var$_propTypes.default.string,
    /**
   * A string value that provides a user-friendly name for the current value of the slider.
   */ 'aria-valuetext': (0, $e7d362f04a4204f3$var$_chainPropTypes.default)($e7d362f04a4204f3$var$_propTypes.default.string, (props)=>{
        const range = Array.isArray(props.value || props.defaultValue);
        if (range && props['aria-valuetext'] != null) return new Error('MUI: You need to use the `getAriaValueText` prop instead of `aria-valuetext` when using a range slider.');
        return null;
    }),
    /**
   * @ignore
   */ children: $e7d362f04a4204f3$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $e7d362f04a4204f3$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $e7d362f04a4204f3$var$_propTypes.default.string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */ color: $e7d362f04a4204f3$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $e7d362f04a4204f3$var$_propTypes.default.oneOf([
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning'
        ]),
        $e7d362f04a4204f3$var$_propTypes.default.string
    ]),
    /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */ components: $e7d362f04a4204f3$var$_propTypes.default.shape({
        Input: $e7d362f04a4204f3$var$_propTypes.default.elementType,
        Mark: $e7d362f04a4204f3$var$_propTypes.default.elementType,
        MarkLabel: $e7d362f04a4204f3$var$_propTypes.default.elementType,
        Rail: $e7d362f04a4204f3$var$_propTypes.default.elementType,
        Root: $e7d362f04a4204f3$var$_propTypes.default.elementType,
        Thumb: $e7d362f04a4204f3$var$_propTypes.default.elementType,
        Track: $e7d362f04a4204f3$var$_propTypes.default.elementType,
        ValueLabel: $e7d362f04a4204f3$var$_propTypes.default.elementType
    }),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */ componentsProps: $e7d362f04a4204f3$var$_propTypes.default.shape({
        input: $e7d362f04a4204f3$var$_propTypes.default.oneOfType([
            $e7d362f04a4204f3$var$_propTypes.default.func,
            $e7d362f04a4204f3$var$_propTypes.default.object
        ]),
        mark: $e7d362f04a4204f3$var$_propTypes.default.oneOfType([
            $e7d362f04a4204f3$var$_propTypes.default.func,
            $e7d362f04a4204f3$var$_propTypes.default.object
        ]),
        markLabel: $e7d362f04a4204f3$var$_propTypes.default.oneOfType([
            $e7d362f04a4204f3$var$_propTypes.default.func,
            $e7d362f04a4204f3$var$_propTypes.default.object
        ]),
        rail: $e7d362f04a4204f3$var$_propTypes.default.oneOfType([
            $e7d362f04a4204f3$var$_propTypes.default.func,
            $e7d362f04a4204f3$var$_propTypes.default.object
        ]),
        root: $e7d362f04a4204f3$var$_propTypes.default.oneOfType([
            $e7d362f04a4204f3$var$_propTypes.default.func,
            $e7d362f04a4204f3$var$_propTypes.default.object
        ]),
        thumb: $e7d362f04a4204f3$var$_propTypes.default.oneOfType([
            $e7d362f04a4204f3$var$_propTypes.default.func,
            $e7d362f04a4204f3$var$_propTypes.default.object
        ]),
        track: $e7d362f04a4204f3$var$_propTypes.default.oneOfType([
            $e7d362f04a4204f3$var$_propTypes.default.func,
            $e7d362f04a4204f3$var$_propTypes.default.object
        ]),
        valueLabel: $e7d362f04a4204f3$var$_propTypes.default.oneOfType([
            $e7d362f04a4204f3$var$_propTypes.default.func,
            $e7d362f04a4204f3$var$_propTypes.default.shape({
                children: $e7d362f04a4204f3$var$_propTypes.default.element,
                className: $e7d362f04a4204f3$var$_propTypes.default.string,
                open: $e7d362f04a4204f3$var$_propTypes.default.bool,
                style: $e7d362f04a4204f3$var$_propTypes.default.object,
                value: $e7d362f04a4204f3$var$_propTypes.default.node,
                valueLabelDisplay: $e7d362f04a4204f3$var$_propTypes.default.oneOf([
                    'auto',
                    'off',
                    'on'
                ])
            })
        ])
    }),
    /**
   * The default value. Use when the component is not controlled.
   */ defaultValue: $e7d362f04a4204f3$var$_propTypes.default.oneOfType([
        $e7d362f04a4204f3$var$_propTypes.default.arrayOf($e7d362f04a4204f3$var$_propTypes.default.number),
        $e7d362f04a4204f3$var$_propTypes.default.number
    ]),
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: $e7d362f04a4204f3$var$_propTypes.default.bool,
    /**
   * If `true`, the active thumb doesn't swap when moving pointer over a thumb while dragging another thumb.
   * @default false
   */ disableSwap: $e7d362f04a4204f3$var$_propTypes.default.bool,
    /**
   * Accepts a function which returns a string value that provides a user-friendly name for the thumb labels of the slider.
   * This is important for screen reader users.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */ getAriaLabel: $e7d362f04a4204f3$var$_propTypes.default.func,
    /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current value of the slider.
   * This is important for screen reader users.
   * @param {number} value The thumb label's value to format.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */ getAriaValueText: $e7d362f04a4204f3$var$_propTypes.default.func,
    /**
   * Marks indicate predetermined values to which the user can move the slider.
   * If `true` the marks are spaced according the value of the `step` prop.
   * If an array, it should contain objects with `value` and an optional `label` keys.
   * @default false
   */ marks: $e7d362f04a4204f3$var$_propTypes.default.oneOfType([
        $e7d362f04a4204f3$var$_propTypes.default.arrayOf($e7d362f04a4204f3$var$_propTypes.default.shape({
            label: $e7d362f04a4204f3$var$_propTypes.default.node,
            value: $e7d362f04a4204f3$var$_propTypes.default.number.isRequired
        })),
        $e7d362f04a4204f3$var$_propTypes.default.bool
    ]),
    /**
   * The maximum allowed value of the slider.
   * Should not be equal to min.
   * @default 100
   */ max: $e7d362f04a4204f3$var$_propTypes.default.number,
    /**
   * The minimum allowed value of the slider.
   * Should not be equal to max.
   * @default 0
   */ min: $e7d362f04a4204f3$var$_propTypes.default.number,
    /**
   * Name attribute of the hidden `input` element.
   */ name: $e7d362f04a4204f3$var$_propTypes.default.string,
    /**
   * Callback function that is fired when the slider's value changed.
   *
   * @param {Event} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event not a change event.
   * @param {Value} value The new value.
   * @param {number} activeThumb Index of the currently moved thumb.
   */ onChange: $e7d362f04a4204f3$var$_propTypes.default.func,
    /**
   * Callback function that is fired when the `mouseup` is triggered.
   *
   * @param {React.SyntheticEvent | Event} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {Value} value The new value.
   */ onChangeCommitted: $e7d362f04a4204f3$var$_propTypes.default.func,
    /**
   * The component orientation.
   * @default 'horizontal'
   */ orientation: $e7d362f04a4204f3$var$_propTypes.default.oneOf([
        'horizontal',
        'vertical'
    ]),
    /**
   * A transformation function, to change the scale of the slider.
   * @param {any} x
   * @returns {any}
   * @default function Identity(x) {
   *   return x;
   * }
   */ scale: $e7d362f04a4204f3$var$_propTypes.default.func,
    /**
   * The granularity with which the slider can step through values when using Page Up/Page Down or Shift + Arrow Up/Arrow Down.
   * @default 10
   */ shiftStep: $e7d362f04a4204f3$var$_propTypes.default.number,
    /**
   * The size of the slider.
   * @default 'medium'
   */ size: $e7d362f04a4204f3$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $e7d362f04a4204f3$var$_propTypes.default.oneOf([
            'small',
            'medium'
        ]),
        $e7d362f04a4204f3$var$_propTypes.default.string
    ]),
    /**
   * The props used for each slot inside the Slider.
   * @default {}
   */ slotProps: $e7d362f04a4204f3$var$_propTypes.default.shape({
        input: $e7d362f04a4204f3$var$_propTypes.default.oneOfType([
            $e7d362f04a4204f3$var$_propTypes.default.func,
            $e7d362f04a4204f3$var$_propTypes.default.object
        ]),
        mark: $e7d362f04a4204f3$var$_propTypes.default.oneOfType([
            $e7d362f04a4204f3$var$_propTypes.default.func,
            $e7d362f04a4204f3$var$_propTypes.default.object
        ]),
        markLabel: $e7d362f04a4204f3$var$_propTypes.default.oneOfType([
            $e7d362f04a4204f3$var$_propTypes.default.func,
            $e7d362f04a4204f3$var$_propTypes.default.object
        ]),
        rail: $e7d362f04a4204f3$var$_propTypes.default.oneOfType([
            $e7d362f04a4204f3$var$_propTypes.default.func,
            $e7d362f04a4204f3$var$_propTypes.default.object
        ]),
        root: $e7d362f04a4204f3$var$_propTypes.default.oneOfType([
            $e7d362f04a4204f3$var$_propTypes.default.func,
            $e7d362f04a4204f3$var$_propTypes.default.object
        ]),
        thumb: $e7d362f04a4204f3$var$_propTypes.default.oneOfType([
            $e7d362f04a4204f3$var$_propTypes.default.func,
            $e7d362f04a4204f3$var$_propTypes.default.object
        ]),
        track: $e7d362f04a4204f3$var$_propTypes.default.oneOfType([
            $e7d362f04a4204f3$var$_propTypes.default.func,
            $e7d362f04a4204f3$var$_propTypes.default.object
        ]),
        valueLabel: $e7d362f04a4204f3$var$_propTypes.default.oneOfType([
            $e7d362f04a4204f3$var$_propTypes.default.func,
            $e7d362f04a4204f3$var$_propTypes.default.shape({
                children: $e7d362f04a4204f3$var$_propTypes.default.element,
                className: $e7d362f04a4204f3$var$_propTypes.default.string,
                open: $e7d362f04a4204f3$var$_propTypes.default.bool,
                style: $e7d362f04a4204f3$var$_propTypes.default.object,
                value: $e7d362f04a4204f3$var$_propTypes.default.node,
                valueLabelDisplay: $e7d362f04a4204f3$var$_propTypes.default.oneOf([
                    'auto',
                    'off',
                    'on'
                ])
            })
        ])
    }),
    /**
   * The components used for each slot inside the Slider.
   * Either a string to use a HTML element or a component.
   * @default {}
   */ slots: $e7d362f04a4204f3$var$_propTypes.default.shape({
        input: $e7d362f04a4204f3$var$_propTypes.default.elementType,
        mark: $e7d362f04a4204f3$var$_propTypes.default.elementType,
        markLabel: $e7d362f04a4204f3$var$_propTypes.default.elementType,
        rail: $e7d362f04a4204f3$var$_propTypes.default.elementType,
        root: $e7d362f04a4204f3$var$_propTypes.default.elementType,
        thumb: $e7d362f04a4204f3$var$_propTypes.default.elementType,
        track: $e7d362f04a4204f3$var$_propTypes.default.elementType,
        valueLabel: $e7d362f04a4204f3$var$_propTypes.default.elementType
    }),
    /**
   * The granularity with which the slider can step through values. (A "discrete" slider.)
   * The `min` prop serves as the origin for the valid values.
   * We recommend (max - min) to be evenly divisible by the step.
   *
   * When step is `null`, the thumb can only be slid onto marks provided with the `marks` prop.
   * @default 1
   */ step: $e7d362f04a4204f3$var$_propTypes.default.number,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $e7d362f04a4204f3$var$_propTypes.default.oneOfType([
        $e7d362f04a4204f3$var$_propTypes.default.arrayOf($e7d362f04a4204f3$var$_propTypes.default.oneOfType([
            $e7d362f04a4204f3$var$_propTypes.default.func,
            $e7d362f04a4204f3$var$_propTypes.default.object,
            $e7d362f04a4204f3$var$_propTypes.default.bool
        ])),
        $e7d362f04a4204f3$var$_propTypes.default.func,
        $e7d362f04a4204f3$var$_propTypes.default.object
    ]),
    /**
   * Tab index attribute of the hidden `input` element.
   */ tabIndex: $e7d362f04a4204f3$var$_propTypes.default.number,
    /**
   * The track presentation:
   *
   * - `normal` the track will render a bar representing the slider value.
   * - `inverted` the track will render a bar representing the remaining slider value.
   * - `false` the track will render without a bar.
   * @default 'normal'
   */ track: $e7d362f04a4204f3$var$_propTypes.default.oneOf([
        'inverted',
        'normal',
        false
    ]),
    /**
   * The value of the slider.
   * For ranged sliders, provide an array with two values.
   */ value: $e7d362f04a4204f3$var$_propTypes.default.oneOfType([
        $e7d362f04a4204f3$var$_propTypes.default.arrayOf($e7d362f04a4204f3$var$_propTypes.default.number),
        $e7d362f04a4204f3$var$_propTypes.default.number
    ]),
    /**
   * Controls when the value label is displayed:
   *
   * - `auto` the value label will display when the thumb is hovered or focused.
   * - `on` will display persistently.
   * - `off` will never display.
   * @default 'off'
   */ valueLabelDisplay: $e7d362f04a4204f3$var$_propTypes.default.oneOf([
        'auto',
        'off',
        'on'
    ]),
    /**
   * The format function the value label's value.
   *
   * When a function is provided, it should have the following signature:
   *
   * - {number} value The value label's value to format
   * - {number} index The value label's index to format
   * @param {any} x
   * @returns {any}
   * @default function Identity(x) {
   *   return x;
   * }
   */ valueLabelFormat: $e7d362f04a4204f3$var$_propTypes.default.oneOfType([
        $e7d362f04a4204f3$var$_propTypes.default.func,
        $e7d362f04a4204f3$var$_propTypes.default.string
    ])
};
var $e7d362f04a4204f3$var$_default = module.exports.default = $e7d362f04a4204f3$var$Slider;

});
parcelRegister("dBUOG", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $9e8acd9e5bad7cc4$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $9e8acd9e5bad7cc4$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Identity = void 0;
module.exports.useSlider = $9e8acd9e5bad7cc4$var$useSlider;
module.exports.valueToPercent = $9e8acd9e5bad7cc4$var$valueToPercent;

var $9e8acd9e5bad7cc4$var$React = $9e8acd9e5bad7cc4$require$_interopRequireWildcard((parcelRequire("acw62")));

var $9e8acd9e5bad7cc4$var$_ownerDocument = $9e8acd9e5bad7cc4$require$_interopRequireDefault((parcelRequire("43fuO")));

var $9e8acd9e5bad7cc4$var$_useControlled = $9e8acd9e5bad7cc4$require$_interopRequireDefault((parcelRequire("iSpB2")));

var $9e8acd9e5bad7cc4$var$_useEnhancedEffect = $9e8acd9e5bad7cc4$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $9e8acd9e5bad7cc4$var$_useEventCallback = $9e8acd9e5bad7cc4$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $9e8acd9e5bad7cc4$var$_useForkRef = $9e8acd9e5bad7cc4$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $9e8acd9e5bad7cc4$var$_isFocusVisible = $9e8acd9e5bad7cc4$require$_interopRequireDefault((parcelRequire("cS73m")));

var $9e8acd9e5bad7cc4$var$_visuallyHidden = $9e8acd9e5bad7cc4$require$_interopRequireDefault((parcelRequire("1YYSs")));

var $9e8acd9e5bad7cc4$var$_clamp = $9e8acd9e5bad7cc4$require$_interopRequireDefault((parcelRequire("3zA0b")));

var $9e8acd9e5bad7cc4$var$_extractEventHandlers = $9e8acd9e5bad7cc4$require$_interopRequireDefault((parcelRequire("bhYgh")));

var $9e8acd9e5bad7cc4$var$_areArraysEqual = $9e8acd9e5bad7cc4$require$_interopRequireDefault((parcelRequire("9r78y")));

var $9e8acd9e5bad7cc4$var$_contains = $9e8acd9e5bad7cc4$require$_interopRequireDefault((parcelRequire("191Fy")));

var $9e8acd9e5bad7cc4$var$_getActiveElement = $9e8acd9e5bad7cc4$require$_interopRequireDefault((parcelRequire("6uU67")));
const $9e8acd9e5bad7cc4$var$INTENTIONAL_DRAG_COUNT_THRESHOLD = 2;
function $9e8acd9e5bad7cc4$var$getNewValue(currentValue, step, direction, min, max) {
    return direction === 1 ? Math.min(currentValue + step, max) : Math.max(currentValue - step, min);
}
function $9e8acd9e5bad7cc4$var$asc(a, b) {
    return a - b;
}
function $9e8acd9e5bad7cc4$var$findClosest(values, currentValue) {
    const { index: closestIndex } = values.reduce((acc, value, index)=>{
        const distance = Math.abs(currentValue - value);
        if (acc === null || distance < acc.distance || distance === acc.distance) return {
            distance: distance,
            index: index
        };
        return acc;
    }, null) ?? {};
    return closestIndex;
}
function $9e8acd9e5bad7cc4$var$trackFinger(event, touchId) {
    // The event is TouchEvent
    if (touchId.current !== undefined && event.changedTouches) {
        const touchEvent = event;
        for(let i = 0; i < touchEvent.changedTouches.length; i += 1){
            const touch = touchEvent.changedTouches[i];
            if (touch.identifier === touchId.current) return {
                x: touch.clientX,
                y: touch.clientY
            };
        }
        return false;
    }
    // The event is MouseEvent
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $9e8acd9e5bad7cc4$var$valueToPercent(value, min, max) {
    return (value - min) * 100 / (max - min);
}
function $9e8acd9e5bad7cc4$var$percentToValue(percent, min, max) {
    return (max - min) * percent + min;
}
function $9e8acd9e5bad7cc4$var$getDecimalPrecision(num) {
    // This handles the case when num is very small (0.00000001), js will turn this into 1e-8.
    // When num is bigger than 1 or less than -1 it won't get converted to this notation so it's fine.
    if (Math.abs(num) < 1) {
        const parts = num.toExponential().split('e-');
        const matissaDecimalPart = parts[0].split('.')[1];
        return (matissaDecimalPart ? matissaDecimalPart.length : 0) + parseInt(parts[1], 10);
    }
    const decimalPart = num.toString().split('.')[1];
    return decimalPart ? decimalPart.length : 0;
}
function $9e8acd9e5bad7cc4$var$roundValueToStep(value, step, min) {
    const nearest = Math.round((value - min) / step) * step + min;
    return Number(nearest.toFixed($9e8acd9e5bad7cc4$var$getDecimalPrecision(step)));
}
function $9e8acd9e5bad7cc4$var$setValueIndex({ values: values, newValue: newValue, index: index }) {
    const output = values.slice();
    output[index] = newValue;
    return output.sort($9e8acd9e5bad7cc4$var$asc);
}
function $9e8acd9e5bad7cc4$var$focusThumb({ sliderRef: sliderRef, activeIndex: activeIndex, setActive: setActive }) {
    const activeElement = (0, $9e8acd9e5bad7cc4$var$_getActiveElement.default)((0, $9e8acd9e5bad7cc4$var$_ownerDocument.default)(sliderRef.current));
    if (!(0, $9e8acd9e5bad7cc4$var$_contains.default)(sliderRef.current, activeElement) || Number(activeElement?.getAttribute('data-index')) !== activeIndex) sliderRef.current?.querySelector(`[type="range"][data-index="${activeIndex}"]`).focus();
    if (setActive) setActive(activeIndex);
}
function $9e8acd9e5bad7cc4$var$areValuesEqual(newValue, oldValue) {
    if (typeof newValue === 'number' && typeof oldValue === 'number') return newValue === oldValue;
    if (typeof newValue === 'object' && typeof oldValue === 'object') return (0, $9e8acd9e5bad7cc4$var$_areArraysEqual.default)(newValue, oldValue);
    return false;
}
const $9e8acd9e5bad7cc4$var$axisProps = {
    horizontal: {
        offset: (percent)=>({
                left: `${percent}%`
            }),
        leap: (percent)=>({
                width: `${percent}%`
            })
    },
    'horizontal-reverse': {
        offset: (percent)=>({
                right: `${percent}%`
            }),
        leap: (percent)=>({
                width: `${percent}%`
            })
    },
    vertical: {
        offset: (percent)=>({
                bottom: `${percent}%`
            }),
        leap: (percent)=>({
                height: `${percent}%`
            })
    }
};
const $9e8acd9e5bad7cc4$var$Identity = (x)=>x;
// TODO: remove support for Safari < 13.
// https://caniuse.com/#search=touch-action
//
// Safari, on iOS, supports touch action since v13.
// Over 80% of the iOS phones are compatible
// in August 2020.
// Utilizing the CSS.supports method to check if touch-action is supported.
// Since CSS.supports is supported on all but Edge@12 and IE and touch-action
// is supported on both Edge@12 and IE if CSS.supports is not available that means that
// touch-action will be supported
module.exports.Identity = $9e8acd9e5bad7cc4$var$Identity;
let $9e8acd9e5bad7cc4$var$cachedSupportsTouchActionNone;
function $9e8acd9e5bad7cc4$var$doesSupportTouchActionNone() {
    if ($9e8acd9e5bad7cc4$var$cachedSupportsTouchActionNone === undefined) {
        if (typeof CSS !== 'undefined' && typeof CSS.supports === 'function') $9e8acd9e5bad7cc4$var$cachedSupportsTouchActionNone = CSS.supports('touch-action', 'none');
        else $9e8acd9e5bad7cc4$var$cachedSupportsTouchActionNone = true;
    }
    return $9e8acd9e5bad7cc4$var$cachedSupportsTouchActionNone;
}
function $9e8acd9e5bad7cc4$var$useSlider(parameters) {
    const { 'aria-labelledby': ariaLabelledby, defaultValue: defaultValue, disabled: disabled = false, disableSwap: disableSwap = false, isRtl: isRtl = false, marks: marksProp = false, max: max = 100, min: min = 0, name: name, onChange: onChange, onChangeCommitted: onChangeCommitted, orientation: orientation = 'horizontal', rootRef: ref, scale: scale = $9e8acd9e5bad7cc4$var$Identity, step: step = 1, shiftStep: shiftStep = 10, tabIndex: tabIndex, value: valueProp } = parameters;
    const touchId = $9e8acd9e5bad7cc4$var$React.useRef(undefined);
    // We can't use the :active browser pseudo-classes.
    // - The active state isn't triggered when clicking on the rail.
    // - The active state isn't transferred when inversing a range slider.
    const [active, setActive] = $9e8acd9e5bad7cc4$var$React.useState(-1);
    const [open, setOpen] = $9e8acd9e5bad7cc4$var$React.useState(-1);
    const [dragging, setDragging] = $9e8acd9e5bad7cc4$var$React.useState(false);
    const moveCount = $9e8acd9e5bad7cc4$var$React.useRef(0);
    // lastChangedValue is updated whenever onChange is triggered.
    const lastChangedValue = $9e8acd9e5bad7cc4$var$React.useRef(null);
    const [valueDerived, setValueState] = (0, $9e8acd9e5bad7cc4$var$_useControlled.default)({
        controlled: valueProp,
        default: defaultValue ?? min,
        name: 'Slider'
    });
    const handleChange = onChange && ((event, value, thumbIndex)=>{
        // Redefine target to allow name and value to be read.
        // This allows seamless integration with the most popular form libraries.
        // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
        // Clone the event to not override `target` of the original event.
        const nativeEvent = event.nativeEvent || event;
        // @ts-ignore The nativeEvent is function, not object
        const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
        Object.defineProperty(clonedEvent, 'target', {
            writable: true,
            value: {
                value: value,
                name: name
            }
        });
        lastChangedValue.current = value;
        onChange(clonedEvent, value, thumbIndex);
    });
    const range = Array.isArray(valueDerived);
    let values = range ? valueDerived.slice().sort($9e8acd9e5bad7cc4$var$asc) : [
        valueDerived
    ];
    values = values.map((value)=>value == null ? min : (0, $9e8acd9e5bad7cc4$var$_clamp.default)(value, min, max));
    const marks = marksProp === true && step !== null ? [
        ...Array(Math.floor((max - min) / step) + 1)
    ].map((_, index)=>({
            value: min + step * index
        })) : marksProp || [];
    const marksValues = marks.map((mark)=>mark.value);
    const [focusedThumbIndex, setFocusedThumbIndex] = $9e8acd9e5bad7cc4$var$React.useState(-1);
    const sliderRef = $9e8acd9e5bad7cc4$var$React.useRef(null);
    const handleRef = (0, $9e8acd9e5bad7cc4$var$_useForkRef.default)(ref, sliderRef);
    const createHandleHiddenInputFocus = (otherHandlers)=>(event)=>{
            const index = Number(event.currentTarget.getAttribute('data-index'));
            if ((0, $9e8acd9e5bad7cc4$var$_isFocusVisible.default)(event.target)) setFocusedThumbIndex(index);
            setOpen(index);
            otherHandlers?.onFocus?.(event);
        };
    const createHandleHiddenInputBlur = (otherHandlers)=>(event)=>{
            if (!(0, $9e8acd9e5bad7cc4$var$_isFocusVisible.default)(event.target)) setFocusedThumbIndex(-1);
            setOpen(-1);
            otherHandlers?.onBlur?.(event);
        };
    const changeValue = (event, valueInput)=>{
        const index = Number(event.currentTarget.getAttribute('data-index'));
        const value = values[index];
        const marksIndex = marksValues.indexOf(value);
        let newValue = valueInput;
        if (marks && step == null) {
            const maxMarksValue = marksValues[marksValues.length - 1];
            if (newValue >= maxMarksValue) newValue = maxMarksValue;
            else if (newValue <= marksValues[0]) newValue = marksValues[0];
            else newValue = newValue < value ? marksValues[marksIndex - 1] : marksValues[marksIndex + 1];
        }
        newValue = (0, $9e8acd9e5bad7cc4$var$_clamp.default)(newValue, min, max);
        if (range) {
            // Bound the new value to the thumb's neighbours.
            if (disableSwap) newValue = (0, $9e8acd9e5bad7cc4$var$_clamp.default)(newValue, values[index - 1] || -Infinity, values[index + 1] || Infinity);
            const previousValue = newValue;
            newValue = $9e8acd9e5bad7cc4$var$setValueIndex({
                values: values,
                newValue: newValue,
                index: index
            });
            let activeIndex = index;
            // Potentially swap the index if needed.
            if (!disableSwap) activeIndex = newValue.indexOf(previousValue);
            $9e8acd9e5bad7cc4$var$focusThumb({
                sliderRef: sliderRef,
                activeIndex: activeIndex
            });
        }
        setValueState(newValue);
        setFocusedThumbIndex(index);
        if (handleChange && !$9e8acd9e5bad7cc4$var$areValuesEqual(newValue, valueDerived)) handleChange(event, newValue, index);
        if (onChangeCommitted) onChangeCommitted(event, lastChangedValue.current ?? newValue);
    };
    const createHandleHiddenInputKeyDown = (otherHandlers)=>(event)=>{
            if ([
                'ArrowUp',
                'ArrowDown',
                'ArrowLeft',
                'ArrowRight',
                'PageUp',
                'PageDown',
                'Home',
                'End'
            ].includes(event.key)) {
                event.preventDefault();
                const index = Number(event.currentTarget.getAttribute('data-index'));
                const value = values[index];
                let newValue = null;
                // Keys actions that change the value by more than the most granular `step`
                // value are only applied if the step not `null`.
                // When step is `null`, the `marks` prop is used instead to define valid values.
                if (step != null) {
                    const stepSize = event.shiftKey ? shiftStep : step;
                    switch(event.key){
                        case 'ArrowUp':
                            newValue = $9e8acd9e5bad7cc4$var$getNewValue(value, stepSize, 1, min, max);
                            break;
                        case 'ArrowRight':
                            newValue = $9e8acd9e5bad7cc4$var$getNewValue(value, stepSize, isRtl ? -1 : 1, min, max);
                            break;
                        case 'ArrowDown':
                            newValue = $9e8acd9e5bad7cc4$var$getNewValue(value, stepSize, -1, min, max);
                            break;
                        case 'ArrowLeft':
                            newValue = $9e8acd9e5bad7cc4$var$getNewValue(value, stepSize, isRtl ? 1 : -1, min, max);
                            break;
                        case 'PageUp':
                            newValue = $9e8acd9e5bad7cc4$var$getNewValue(value, shiftStep, 1, min, max);
                            break;
                        case 'PageDown':
                            newValue = $9e8acd9e5bad7cc4$var$getNewValue(value, shiftStep, -1, min, max);
                            break;
                        case 'Home':
                            newValue = min;
                            break;
                        case 'End':
                            newValue = max;
                            break;
                        default:
                            break;
                    }
                } else if (marks) {
                    const maxMarksValue = marksValues[marksValues.length - 1];
                    const currentMarkIndex = marksValues.indexOf(value);
                    const decrementKeys = [
                        isRtl ? 'ArrowRight' : 'ArrowLeft',
                        'ArrowDown',
                        'PageDown',
                        'Home'
                    ];
                    const incrementKeys = [
                        isRtl ? 'ArrowLeft' : 'ArrowRight',
                        'ArrowUp',
                        'PageUp',
                        'End'
                    ];
                    if (decrementKeys.includes(event.key)) {
                        if (currentMarkIndex === 0) newValue = marksValues[0];
                        else newValue = marksValues[currentMarkIndex - 1];
                    } else if (incrementKeys.includes(event.key)) {
                        if (currentMarkIndex === marksValues.length - 1) newValue = maxMarksValue;
                        else newValue = marksValues[currentMarkIndex + 1];
                    }
                }
                if (newValue != null) changeValue(event, newValue);
            }
            otherHandlers?.onKeyDown?.(event);
        };
    (0, $9e8acd9e5bad7cc4$var$_useEnhancedEffect.default)(()=>{
        const activeElement = (0, $9e8acd9e5bad7cc4$var$_getActiveElement.default)((0, $9e8acd9e5bad7cc4$var$_ownerDocument.default)(sliderRef.current));
        if (disabled && (0, $9e8acd9e5bad7cc4$var$_contains.default)(sliderRef.current, activeElement)) // This is necessary because Firefox and Safari will keep focus
        // on a disabled element:
        // https://codesandbox.io/p/sandbox/mui-pr-22247-forked-h151h?file=/src/App.js
        // @ts-ignore
        document.activeElement?.blur();
    }, [
        disabled
    ]);
    if (disabled && active !== -1) setActive(-1);
    if (disabled && focusedThumbIndex !== -1) setFocusedThumbIndex(-1);
    const createHandleHiddenInputChange = (otherHandlers)=>(event)=>{
            otherHandlers.onChange?.(event);
            // this handles value change by Pointer or Touch events
            // @ts-ignore
            changeValue(event, event.target.valueAsNumber);
        };
    const previousIndex = $9e8acd9e5bad7cc4$var$React.useRef(undefined);
    let axis = orientation;
    if (isRtl && orientation === 'horizontal') axis += '-reverse';
    const getFingerNewValue = ({ finger: finger, move: move = false })=>{
        const { current: slider } = sliderRef;
        const { width: width, height: height, bottom: bottom, left: left } = slider.getBoundingClientRect();
        let percent;
        if (axis.startsWith('vertical')) percent = (bottom - finger.y) / height;
        else percent = (finger.x - left) / width;
        if (axis.includes('-reverse')) percent = 1 - percent;
        let newValue;
        newValue = $9e8acd9e5bad7cc4$var$percentToValue(percent, min, max);
        if (step) newValue = $9e8acd9e5bad7cc4$var$roundValueToStep(newValue, step, min);
        else {
            const closestIndex = $9e8acd9e5bad7cc4$var$findClosest(marksValues, newValue);
            newValue = marksValues[closestIndex];
        }
        newValue = (0, $9e8acd9e5bad7cc4$var$_clamp.default)(newValue, min, max);
        let activeIndex = 0;
        if (range) {
            if (!move) activeIndex = $9e8acd9e5bad7cc4$var$findClosest(values, newValue);
            else activeIndex = previousIndex.current;
            // Bound the new value to the thumb's neighbours.
            if (disableSwap) newValue = (0, $9e8acd9e5bad7cc4$var$_clamp.default)(newValue, values[activeIndex - 1] || -Infinity, values[activeIndex + 1] || Infinity);
            const previousValue = newValue;
            newValue = $9e8acd9e5bad7cc4$var$setValueIndex({
                values: values,
                newValue: newValue,
                index: activeIndex
            });
            // Potentially swap the index if needed.
            if (!(disableSwap && move)) {
                activeIndex = newValue.indexOf(previousValue);
                previousIndex.current = activeIndex;
            }
        }
        return {
            newValue: newValue,
            activeIndex: activeIndex
        };
    };
    const handleTouchMove = (0, $9e8acd9e5bad7cc4$var$_useEventCallback.default)((nativeEvent)=>{
        const finger = $9e8acd9e5bad7cc4$var$trackFinger(nativeEvent, touchId);
        if (!finger) return;
        moveCount.current += 1;
        // Cancel move in case some other element consumed a mouseup event and it was not fired.
        // @ts-ignore buttons doesn't not exists on touch event
        if (nativeEvent.type === 'mousemove' && nativeEvent.buttons === 0) {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            handleTouchEnd(nativeEvent);
            return;
        }
        const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
            finger: finger,
            move: true
        });
        $9e8acd9e5bad7cc4$var$focusThumb({
            sliderRef: sliderRef,
            activeIndex: activeIndex,
            setActive: setActive
        });
        setValueState(newValue);
        if (!dragging && moveCount.current > $9e8acd9e5bad7cc4$var$INTENTIONAL_DRAG_COUNT_THRESHOLD) setDragging(true);
        if (handleChange && !$9e8acd9e5bad7cc4$var$areValuesEqual(newValue, valueDerived)) handleChange(nativeEvent, newValue, activeIndex);
    });
    const handleTouchEnd = (0, $9e8acd9e5bad7cc4$var$_useEventCallback.default)((nativeEvent)=>{
        const finger = $9e8acd9e5bad7cc4$var$trackFinger(nativeEvent, touchId);
        setDragging(false);
        if (!finger) return;
        const { newValue: newValue } = getFingerNewValue({
            finger: finger,
            move: true
        });
        setActive(-1);
        if (nativeEvent.type === 'touchend') setOpen(-1);
        if (onChangeCommitted) onChangeCommitted(nativeEvent, lastChangedValue.current ?? newValue);
        touchId.current = undefined;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        stopListening();
    });
    const handleTouchStart = (0, $9e8acd9e5bad7cc4$var$_useEventCallback.default)((nativeEvent)=>{
        if (disabled) return;
        // If touch-action: none; is not supported we need to prevent the scroll manually.
        if (!$9e8acd9e5bad7cc4$var$doesSupportTouchActionNone()) nativeEvent.preventDefault();
        const touch = nativeEvent.changedTouches[0];
        if (touch != null) // A number that uniquely identifies the current finger in the touch session.
        touchId.current = touch.identifier;
        const finger = $9e8acd9e5bad7cc4$var$trackFinger(nativeEvent, touchId);
        if (finger !== false) {
            const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
                finger: finger
            });
            $9e8acd9e5bad7cc4$var$focusThumb({
                sliderRef: sliderRef,
                activeIndex: activeIndex,
                setActive: setActive
            });
            setValueState(newValue);
            if (handleChange && !$9e8acd9e5bad7cc4$var$areValuesEqual(newValue, valueDerived)) handleChange(nativeEvent, newValue, activeIndex);
        }
        moveCount.current = 0;
        const doc = (0, $9e8acd9e5bad7cc4$var$_ownerDocument.default)(sliderRef.current);
        doc.addEventListener('touchmove', handleTouchMove, {
            passive: true
        });
        doc.addEventListener('touchend', handleTouchEnd, {
            passive: true
        });
    });
    const stopListening = $9e8acd9e5bad7cc4$var$React.useCallback(()=>{
        const doc = (0, $9e8acd9e5bad7cc4$var$_ownerDocument.default)(sliderRef.current);
        doc.removeEventListener('mousemove', handleTouchMove);
        doc.removeEventListener('mouseup', handleTouchEnd);
        doc.removeEventListener('touchmove', handleTouchMove);
        doc.removeEventListener('touchend', handleTouchEnd);
    }, [
        handleTouchEnd,
        handleTouchMove
    ]);
    $9e8acd9e5bad7cc4$var$React.useEffect(()=>{
        const { current: slider } = sliderRef;
        slider.addEventListener('touchstart', handleTouchStart, {
            passive: $9e8acd9e5bad7cc4$var$doesSupportTouchActionNone()
        });
        return ()=>{
            slider.removeEventListener('touchstart', handleTouchStart);
            stopListening();
        };
    }, [
        stopListening,
        handleTouchStart
    ]);
    $9e8acd9e5bad7cc4$var$React.useEffect(()=>{
        if (disabled) stopListening();
    }, [
        disabled,
        stopListening
    ]);
    const createHandleMouseDown = (otherHandlers)=>(event)=>{
            otherHandlers.onMouseDown?.(event);
            if (disabled) return;
            if (event.defaultPrevented) return;
            // Only handle left clicks
            if (event.button !== 0) return;
            // Avoid text selection
            event.preventDefault();
            const finger = $9e8acd9e5bad7cc4$var$trackFinger(event, touchId);
            if (finger !== false) {
                const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
                    finger: finger
                });
                $9e8acd9e5bad7cc4$var$focusThumb({
                    sliderRef: sliderRef,
                    activeIndex: activeIndex,
                    setActive: setActive
                });
                setValueState(newValue);
                if (handleChange && !$9e8acd9e5bad7cc4$var$areValuesEqual(newValue, valueDerived)) handleChange(event, newValue, activeIndex);
            }
            moveCount.current = 0;
            const doc = (0, $9e8acd9e5bad7cc4$var$_ownerDocument.default)(sliderRef.current);
            doc.addEventListener('mousemove', handleTouchMove, {
                passive: true
            });
            doc.addEventListener('mouseup', handleTouchEnd);
        };
    const trackOffset = $9e8acd9e5bad7cc4$var$valueToPercent(range ? values[0] : min, min, max);
    const trackLeap = $9e8acd9e5bad7cc4$var$valueToPercent(values[values.length - 1], min, max) - trackOffset;
    const getRootProps = (externalProps = {})=>{
        const externalHandlers = (0, $9e8acd9e5bad7cc4$var$_extractEventHandlers.default)(externalProps);
        const ownEventHandlers = {
            onMouseDown: createHandleMouseDown(externalHandlers || {})
        };
        const mergedEventHandlers = {
            ...externalHandlers,
            ...ownEventHandlers
        };
        return {
            ...externalProps,
            ref: handleRef,
            ...mergedEventHandlers
        };
    };
    const createHandleMouseOver = (otherHandlers)=>(event)=>{
            otherHandlers.onMouseOver?.(event);
            const index = Number(event.currentTarget.getAttribute('data-index'));
            setOpen(index);
        };
    const createHandleMouseLeave = (otherHandlers)=>(event)=>{
            otherHandlers.onMouseLeave?.(event);
            setOpen(-1);
        };
    const getThumbProps = (externalProps = {})=>{
        const externalHandlers = (0, $9e8acd9e5bad7cc4$var$_extractEventHandlers.default)(externalProps);
        const ownEventHandlers = {
            onMouseOver: createHandleMouseOver(externalHandlers || {}),
            onMouseLeave: createHandleMouseLeave(externalHandlers || {})
        };
        return {
            ...externalProps,
            ...externalHandlers,
            ...ownEventHandlers
        };
    };
    const getThumbStyle = (index)=>{
        return {
            // So the non active thumb doesn't show its label on hover.
            pointerEvents: active !== -1 && active !== index ? 'none' : undefined
        };
    };
    let cssWritingMode;
    if (orientation === 'vertical') cssWritingMode = isRtl ? 'vertical-rl' : 'vertical-lr';
    const getHiddenInputProps = (externalProps = {})=>{
        const externalHandlers = (0, $9e8acd9e5bad7cc4$var$_extractEventHandlers.default)(externalProps);
        const ownEventHandlers = {
            onChange: createHandleHiddenInputChange(externalHandlers || {}),
            onFocus: createHandleHiddenInputFocus(externalHandlers || {}),
            onBlur: createHandleHiddenInputBlur(externalHandlers || {}),
            onKeyDown: createHandleHiddenInputKeyDown(externalHandlers || {})
        };
        const mergedEventHandlers = {
            ...externalHandlers,
            ...ownEventHandlers
        };
        return {
            tabIndex: tabIndex,
            'aria-labelledby': ariaLabelledby,
            'aria-orientation': orientation,
            'aria-valuemax': scale(max),
            'aria-valuemin': scale(min),
            name: name,
            type: 'range',
            min: parameters.min,
            max: parameters.max,
            step: parameters.step === null && parameters.marks ? 'any' : parameters.step ?? undefined,
            disabled: disabled,
            ...externalProps,
            ...mergedEventHandlers,
            style: {
                ...$9e8acd9e5bad7cc4$var$_visuallyHidden.default,
                direction: isRtl ? 'rtl' : 'ltr',
                // So that VoiceOver's focus indicator matches the thumb's dimensions
                width: '100%',
                height: '100%',
                writingMode: cssWritingMode
            }
        };
    };
    return {
        active: active,
        axis: axis,
        axisProps: $9e8acd9e5bad7cc4$var$axisProps,
        dragging: dragging,
        focusedThumbIndex: focusedThumbIndex,
        getHiddenInputProps: getHiddenInputProps,
        getRootProps: getRootProps,
        getThumbProps: getThumbProps,
        marks: marks,
        open: open,
        range: range,
        rootRef: handleRef,
        trackLeap: trackLeap,
        trackOffset: trackOffset,
        values: values,
        getThumbStyle: getThumbStyle
    };
}

});
parcelRegister("9r78y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $6dec2bf07d6d333a$var$areArraysEqual(array1, array2, itemComparer = (a, b)=>a === b) {
    return array1.length === array2.length && array1.every((value, index)=>itemComparer(value, array2[index]));
}
var $6dec2bf07d6d333a$var$_default = module.exports.default = $6dec2bf07d6d333a$var$areArraysEqual;

});


parcelRegister("lTbyd", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $fef7b1c426e97238$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fef7b1c426e97238$var$_isHostComponent = $fef7b1c426e97238$require$_interopRequireDefault((parcelRequire("7jqh1")));
const $fef7b1c426e97238$var$shouldSpreadAdditionalProps = (Slot)=>{
    return !Slot || !(0, $fef7b1c426e97238$var$_isHostComponent.default)(Slot);
};
var $fef7b1c426e97238$var$_default = module.exports.default = $fef7b1c426e97238$var$shouldSpreadAdditionalProps;

});

parcelRegister("2xkal", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $1d8e4e584d12bd05$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $1d8e4e584d12bd05$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1d8e4e584d12bd05$var$SliderValueLabel;

var $1d8e4e584d12bd05$var$React = $1d8e4e584d12bd05$require$_interopRequireWildcard((parcelRequire("acw62")));

var $1d8e4e584d12bd05$var$_propTypes = $1d8e4e584d12bd05$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $1d8e4e584d12bd05$var$_clsx = $1d8e4e584d12bd05$require$_interopRequireDefault((parcelRequire("9QePP")));

var $1d8e4e584d12bd05$var$_sliderClasses = $1d8e4e584d12bd05$require$_interopRequireDefault((parcelRequire("20dvU")));

var $ayMG0 = parcelRequire("ayMG0");
const $1d8e4e584d12bd05$var$useValueLabelClasses = (props)=>{
    const { open: open } = props;
    const utilityClasses = {
        offset: (0, $1d8e4e584d12bd05$var$_clsx.default)(open && $1d8e4e584d12bd05$var$_sliderClasses.default.valueLabelOpen),
        circle: $1d8e4e584d12bd05$var$_sliderClasses.default.valueLabelCircle,
        label: $1d8e4e584d12bd05$var$_sliderClasses.default.valueLabelLabel
    };
    return utilityClasses;
};
/**
 * @ignore - internal component.
 */ function $1d8e4e584d12bd05$var$SliderValueLabel(props) {
    const { children: children, className: className, value: value } = props;
    const classes = $1d8e4e584d12bd05$var$useValueLabelClasses(props);
    if (!children) return null;
    return /*#__PURE__*/ $1d8e4e584d12bd05$var$React.cloneElement(children, {
        className: children.props.className
    }, /*#__PURE__*/ (0, $ayMG0.jsxs)($1d8e4e584d12bd05$var$React.Fragment, {
        children: [
            children.props.children,
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: (0, $1d8e4e584d12bd05$var$_clsx.default)(classes.offset, className),
                "aria-hidden": true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: classes.circle,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: classes.label,
                        children: value
                    })
                })
            })
        ]
    }));
}
$1d8e4e584d12bd05$var$SliderValueLabel.propTypes = {
    children: $1d8e4e584d12bd05$var$_propTypes.default.element.isRequired,
    className: $1d8e4e584d12bd05$var$_propTypes.default.string,
    value: $1d8e4e584d12bd05$var$_propTypes.default.node
};

});
parcelRegister("20dvU", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $175610683d4083b7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getSliderUtilityClass = $175610683d4083b7$var$getSliderUtilityClass;

var $175610683d4083b7$var$_generateUtilityClasses = $175610683d4083b7$require$_interopRequireDefault((parcelRequire("5nY49")));

var $175610683d4083b7$var$_generateUtilityClass = $175610683d4083b7$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $175610683d4083b7$var$getSliderUtilityClass(slot) {
    return (0, $175610683d4083b7$var$_generateUtilityClass.default)('MuiSlider', slot);
}
const $175610683d4083b7$var$sliderClasses = (0, $175610683d4083b7$var$_generateUtilityClasses.default)('MuiSlider', [
    'root',
    'active',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'dragging',
    'focusVisible',
    'mark',
    'markActive',
    'marked',
    'markLabel',
    'markLabelActive',
    'rail',
    'sizeSmall',
    'thumb',
    'thumbColorPrimary',
    'thumbColorSecondary',
    'thumbColorError',
    'thumbColorSuccess',
    'thumbColorInfo',
    'thumbColorWarning',
    'track',
    'trackInverted',
    'trackFalse',
    'thumbSizeSmall',
    'valueLabel',
    'valueLabelOpen',
    'valueLabelCircle',
    'valueLabelLabel',
    'vertical'
]);
var $175610683d4083b7$var$_default = module.exports.default = $175610683d4083b7$var$sliderClasses;

});




parcelRegister("b3tNC", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $80c71705f119f7ad$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $80c71705f119f7ad$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $80c71705f119f7ad$var$_exportNames = {
    snackbarClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $80c71705f119f7ad$var$_Snackbar.default;
    }
});
Object.defineProperty(module.exports, "snackbarClasses", {
    enumerable: true,
    get: function() {
        return $80c71705f119f7ad$var$_snackbarClasses.default;
    }
});

var $80c71705f119f7ad$var$_Snackbar = $80c71705f119f7ad$require$_interopRequireDefault((parcelRequire("kybK6")));

var $80c71705f119f7ad$var$_snackbarClasses = $80c71705f119f7ad$require$_interopRequireWildcard((parcelRequire("kVqBB")));
Object.keys($80c71705f119f7ad$var$_snackbarClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($80c71705f119f7ad$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $80c71705f119f7ad$var$_snackbarClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $80c71705f119f7ad$var$_snackbarClasses[key];
        }
    });
});

});
parcelRegister("kybK6", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $ef601776ba11bb1e$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $ef601776ba11bb1e$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ef601776ba11bb1e$var$React = $ef601776ba11bb1e$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ef601776ba11bb1e$var$_propTypes = $ef601776ba11bb1e$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $ef601776ba11bb1e$var$_composeClasses = $ef601776ba11bb1e$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $ef601776ba11bb1e$var$_useSnackbar = $ef601776ba11bb1e$require$_interopRequireDefault((parcelRequire("3S0qO")));

var $ef601776ba11bb1e$var$_ClickAwayListener = $ef601776ba11bb1e$require$_interopRequireDefault((parcelRequire("7Ke9B")));

var $aAbgT = parcelRequire("aAbgT");

var $ef601776ba11bb1e$var$_memoTheme = $ef601776ba11bb1e$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $ef601776ba11bb1e$var$_capitalize = $ef601776ba11bb1e$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $ef601776ba11bb1e$var$_Grow = $ef601776ba11bb1e$require$_interopRequireDefault((parcelRequire("6dJ4n")));

var $ef601776ba11bb1e$var$_SnackbarContent = $ef601776ba11bb1e$require$_interopRequireDefault((parcelRequire("8BKxX")));

var $kVqBB = parcelRequire("kVqBB");

var $ef601776ba11bb1e$var$_useSlot = $ef601776ba11bb1e$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $ef601776ba11bb1e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchorOrigin: anchorOrigin } = ownerState;
    const slots = {
        root: [
            'root',
            `anchorOrigin${(0, $ef601776ba11bb1e$var$_capitalize.default)(anchorOrigin.vertical)}${(0, $ef601776ba11bb1e$var$_capitalize.default)(anchorOrigin.horizontal)}`
        ]
    };
    return (0, $ef601776ba11bb1e$var$_composeClasses.default)(slots, $kVqBB.getSnackbarUtilityClass, classes);
};
const $ef601776ba11bb1e$var$SnackbarRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiSnackbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`anchorOrigin${(0, $ef601776ba11bb1e$var$_capitalize.default)(ownerState.anchorOrigin.vertical)}${(0, $ef601776ba11bb1e$var$_capitalize.default)(ownerState.anchorOrigin.horizontal)}`]
        ];
    }
})((0, $ef601776ba11bb1e$var$_memoTheme.default)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.snackbar,
        position: 'fixed',
        display: 'flex',
        left: 8,
        right: 8,
        justifyContent: 'center',
        alignItems: 'center',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top',
                style: {
                    top: 8,
                    [theme.breakpoints.up('sm')]: {
                        top: 24
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical !== 'top',
                style: {
                    bottom: 8,
                    [theme.breakpoints.up('sm')]: {
                        bottom: 24
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.horizontal === 'left',
                style: {
                    justifyContent: 'flex-start',
                    [theme.breakpoints.up('sm')]: {
                        left: 24,
                        right: 'auto'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.horizontal === 'right',
                style: {
                    justifyContent: 'flex-end',
                    [theme.breakpoints.up('sm')]: {
                        right: 24,
                        left: 'auto'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.horizontal === 'center',
                style: {
                    [theme.breakpoints.up('sm')]: {
                        left: '50%',
                        right: 'auto',
                        transform: 'translateX(-50%)'
                    }
                }
            }
        ]
    })));
const $ef601776ba11bb1e$var$Snackbar = /*#__PURE__*/ $ef601776ba11bb1e$var$React.forwardRef(function Snackbar(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiSnackbar'
    });
    const theme = (0, $aAbgT.useTheme)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { action: action, anchorOrigin: { vertical: vertical, horizontal: horizontal } = {
        vertical: 'bottom',
        horizontal: 'left'
    }, autoHideDuration: autoHideDuration = null, children: children, className: className, ClickAwayListenerProps: ClickAwayListenerPropsProp, ContentProps: ContentPropsProp, disableWindowBlurListener: disableWindowBlurListener = false, message: message, onBlur: onBlur, onClose: onClose, onFocus: onFocus, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, open: open, resumeHideDuration: resumeHideDuration, slots: slots = {}, slotProps: slotProps = {}, TransitionComponent: TransitionComponentProp, transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: { onEnter: onEnter, onExited: onExited, ...TransitionPropsProp } = {}, ...other } = props;
    const ownerState = {
        ...props,
        anchorOrigin: {
            vertical: vertical,
            horizontal: horizontal
        },
        autoHideDuration: autoHideDuration,
        disableWindowBlurListener: disableWindowBlurListener,
        TransitionComponent: TransitionComponentProp,
        transitionDuration: transitionDuration
    };
    const classes = $ef601776ba11bb1e$var$useUtilityClasses(ownerState);
    const { getRootProps: getRootProps, onClickAway: onClickAway } = (0, $ef601776ba11bb1e$var$_useSnackbar.default)(ownerState);
    const [exited, setExited] = $ef601776ba11bb1e$var$React.useState(true);
    const handleExited = (node)=>{
        setExited(true);
        if (onExited) onExited(node);
    };
    const handleEnter = (node, isAppearing)=>{
        setExited(false);
        if (onEnter) onEnter(node, isAppearing);
    };
    const externalForwardedProps = {
        slots: {
            transition: TransitionComponentProp,
            ...slots
        },
        slotProps: {
            content: ContentPropsProp,
            clickAwayListener: ClickAwayListenerPropsProp,
            transition: TransitionPropsProp,
            ...slotProps
        }
    };
    const [Root, rootProps] = (0, $ef601776ba11bb1e$var$_useSlot.default)('root', {
        ref: ref,
        className: [
            classes.root,
            className
        ],
        elementType: $ef601776ba11bb1e$var$SnackbarRoot,
        getSlotProps: getRootProps,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState
    });
    const [ClickAwaySlot, { ownerState: clickAwayOwnerStateProp, ...clickAwayListenerProps }] = (0, $ef601776ba11bb1e$var$_useSlot.default)('clickAwayListener', {
        elementType: $ef601776ba11bb1e$var$_ClickAwayListener.default,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                onClickAway: (...params)=>{
                    const event = params[0];
                    handlers.onClickAway?.(...params);
                    if (event?.defaultMuiPrevented) return;
                    onClickAway(...params);
                }
            }),
        ownerState: ownerState
    });
    const [ContentSlot, contentSlotProps] = (0, $ef601776ba11bb1e$var$_useSlot.default)('content', {
        elementType: $ef601776ba11bb1e$var$_SnackbarContent.default,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        additionalProps: {
            message: message,
            action: action
        },
        ownerState: ownerState
    });
    const [TransitionSlot, transitionProps] = (0, $ef601776ba11bb1e$var$_useSlot.default)('transition', {
        elementType: $ef601776ba11bb1e$var$_Grow.default,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                onEnter: (...params)=>{
                    handlers.onEnter?.(...params);
                    handleEnter(...params);
                },
                onExited: (...params)=>{
                    handlers.onExited?.(...params);
                    handleExited(...params);
                }
            }),
        additionalProps: {
            appear: true,
            in: open,
            timeout: transitionDuration,
            direction: vertical === 'top' ? 'down' : 'up'
        },
        ownerState: ownerState
    });
    // So we only render active snackbars.
    if (!open && exited) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(ClickAwaySlot, {
        ...clickAwayListenerProps,
        ...slots.clickAwayListener && {
            ownerState: clickAwayOwnerStateProp
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Root, {
            ...rootProps,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionSlot, {
                ...transitionProps,
                children: children || /*#__PURE__*/ (0, $ayMG0.jsx)(ContentSlot, {
                    ...contentSlotProps
                })
            })
        })
    });
});
$ef601776ba11bb1e$var$Snackbar.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The action to display. It renders after the message, at the end of the snackbar.
   */ action: $ef601776ba11bb1e$var$_propTypes.default.node,
    /**
   * The anchor of the `Snackbar`.
   * On smaller screens, the component grows to occupy all the available width,
   * the horizontal alignment is ignored.
   * @default { vertical: 'bottom', horizontal: 'left' }
   */ anchorOrigin: $ef601776ba11bb1e$var$_propTypes.default.shape({
        horizontal: $ef601776ba11bb1e$var$_propTypes.default.oneOf([
            'center',
            'left',
            'right'
        ]).isRequired,
        vertical: $ef601776ba11bb1e$var$_propTypes.default.oneOf([
            'bottom',
            'top'
        ]).isRequired
    }),
    /**
   * The number of milliseconds to wait before automatically calling the
   * `onClose` function. `onClose` should then set the state of the `open`
   * prop to hide the Snackbar. This behavior is disabled by default with
   * the `null` value.
   * @default null
   */ autoHideDuration: $ef601776ba11bb1e$var$_propTypes.default.number,
    /**
   * Replace the `SnackbarContent` component.
   */ children: $ef601776ba11bb1e$var$_propTypes.default.element,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $ef601776ba11bb1e$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $ef601776ba11bb1e$var$_propTypes.default.string,
    /**
   * Props applied to the `ClickAwayListener` element.
   * @deprecated Use `slotProps.clickAwayListener` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ ClickAwayListenerProps: $ef601776ba11bb1e$var$_propTypes.default.object,
    /**
   * Props applied to the [`SnackbarContent`](https://mui.com/material-ui/api/snackbar-content/) element.
   * @deprecated Use `slotProps.content` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ ContentProps: $ef601776ba11bb1e$var$_propTypes.default.object,
    /**
   * If `true`, the `autoHideDuration` timer will expire even if the window is not focused.
   * @default false
   */ disableWindowBlurListener: $ef601776ba11bb1e$var$_propTypes.default.bool,
    /**
   * When displaying multiple consecutive snackbars using a single parent-rendered
   * `<Snackbar/>`, add the `key` prop to ensure independent treatment of each message.
   * For instance, use `<Snackbar key={message} />`. Otherwise, messages might update
   * in place, and features like `autoHideDuration` could be affected.
   */ key: ()=>null,
    /**
   * The message to display.
   */ message: $ef601776ba11bb1e$var$_propTypes.default.node,
    /**
   * @ignore
   */ onBlur: $ef601776ba11bb1e$var$_propTypes.default.func,
    /**
   * Callback fired when the component requests to be closed.
   * Typically `onClose` is used to set state in the parent component,
   * which is used to control the `Snackbar` `open` prop.
   * The `reason` parameter can optionally be used to control the response to `onClose`,
   * for example ignoring `clickaway`.
   *
   * @param {React.SyntheticEvent<any> | Event} event The event source of the callback.
   * @param {string} reason Can be: `"timeout"` (`autoHideDuration` expired), `"clickaway"`, or `"escapeKeyDown"`.
   */ onClose: $ef601776ba11bb1e$var$_propTypes.default.func,
    /**
   * @ignore
   */ onFocus: $ef601776ba11bb1e$var$_propTypes.default.func,
    /**
   * @ignore
   */ onMouseEnter: $ef601776ba11bb1e$var$_propTypes.default.func,
    /**
   * @ignore
   */ onMouseLeave: $ef601776ba11bb1e$var$_propTypes.default.func,
    /**
   * If `true`, the component is shown.
   */ open: $ef601776ba11bb1e$var$_propTypes.default.bool,
    /**
   * The number of milliseconds to wait before dismissing after user interaction.
   * If `autoHideDuration` prop isn't specified, it does nothing.
   * If `autoHideDuration` prop is specified but `resumeHideDuration` isn't,
   * we default to `autoHideDuration / 2` ms.
   */ resumeHideDuration: $ef601776ba11bb1e$var$_propTypes.default.number,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $ef601776ba11bb1e$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .shape({
        clickAwayListener: $ef601776ba11bb1e$var$_propTypes.default.oneOfType([
            $ef601776ba11bb1e$var$_propTypes.default.func,
            $ef601776ba11bb1e$var$_propTypes.default.object
        ]),
        content: $ef601776ba11bb1e$var$_propTypes.default.oneOfType([
            $ef601776ba11bb1e$var$_propTypes.default.func,
            $ef601776ba11bb1e$var$_propTypes.default.object
        ]),
        root: $ef601776ba11bb1e$var$_propTypes.default.oneOfType([
            $ef601776ba11bb1e$var$_propTypes.default.func,
            $ef601776ba11bb1e$var$_propTypes.default.object
        ]),
        transition: $ef601776ba11bb1e$var$_propTypes.default.oneOfType([
            $ef601776ba11bb1e$var$_propTypes.default.func,
            $ef601776ba11bb1e$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: $ef601776ba11bb1e$var$_propTypes.default.shape({
        clickAwayListener: $ef601776ba11bb1e$var$_propTypes.default.elementType,
        content: $ef601776ba11bb1e$var$_propTypes.default.elementType,
        root: $ef601776ba11bb1e$var$_propTypes.default.elementType,
        transition: $ef601776ba11bb1e$var$_propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $ef601776ba11bb1e$var$_propTypes.default.oneOfType([
        $ef601776ba11bb1e$var$_propTypes.default.arrayOf($ef601776ba11bb1e$var$_propTypes.default.oneOfType([
            $ef601776ba11bb1e$var$_propTypes.default.func,
            $ef601776ba11bb1e$var$_propTypes.default.object,
            $ef601776ba11bb1e$var$_propTypes.default.bool
        ])),
        $ef601776ba11bb1e$var$_propTypes.default.func,
        $ef601776ba11bb1e$var$_propTypes.default.object
    ]),
    /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated Use `slots.transition` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default Grow
   */ TransitionComponent: $ef601776ba11bb1e$var$_propTypes.default.elementType,
    /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */ transitionDuration: $ef601776ba11bb1e$var$_propTypes.default.oneOfType([
        $ef601776ba11bb1e$var$_propTypes.default.number,
        $ef601776ba11bb1e$var$_propTypes.default.shape({
            appear: $ef601776ba11bb1e$var$_propTypes.default.number,
            enter: $ef601776ba11bb1e$var$_propTypes.default.number,
            exit: $ef601776ba11bb1e$var$_propTypes.default.number
        })
    ]),
    /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated Use `slotProps.transition` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */ TransitionProps: $ef601776ba11bb1e$var$_propTypes.default.object
};
var $ef601776ba11bb1e$var$_default = module.exports.default = $ef601776ba11bb1e$var$Snackbar;

});
parcelRegister("3S0qO", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $2d16bff1157c299f$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $2d16bff1157c299f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2d16bff1157c299f$var$React = $2d16bff1157c299f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $2d16bff1157c299f$var$_useEventCallback = $2d16bff1157c299f$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $2d16bff1157c299f$var$_useTimeout = $2d16bff1157c299f$require$_interopRequireDefault((parcelRequire("drY8V")));

var $2d16bff1157c299f$var$_extractEventHandlers = $2d16bff1157c299f$require$_interopRequireDefault((parcelRequire("bhYgh")));
function $2d16bff1157c299f$var$useSnackbar(parameters = {}) {
    const { autoHideDuration: autoHideDuration = null, disableWindowBlurListener: disableWindowBlurListener = false, onClose: onClose, open: open, resumeHideDuration: resumeHideDuration } = parameters;
    const timerAutoHide = (0, $2d16bff1157c299f$var$_useTimeout.default)();
    $2d16bff1157c299f$var$React.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (!nativeEvent.defaultPrevented) {
                if (nativeEvent.key === 'Escape') // not calling `preventDefault` since we don't know if people may ignore this event e.g. a permanently open snackbar
                onClose?.(nativeEvent, 'escapeKeyDown');
            }
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        open,
        onClose
    ]);
    const handleClose = (0, $2d16bff1157c299f$var$_useEventCallback.default)((event, reason)=>{
        onClose?.(event, reason);
    });
    const setAutoHideTimer = (0, $2d16bff1157c299f$var$_useEventCallback.default)((autoHideDurationParam)=>{
        if (!onClose || autoHideDurationParam == null) return;
        timerAutoHide.start(autoHideDurationParam, ()=>{
            handleClose(null, 'timeout');
        });
    });
    $2d16bff1157c299f$var$React.useEffect(()=>{
        if (open) setAutoHideTimer(autoHideDuration);
        return timerAutoHide.clear;
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer,
        timerAutoHide
    ]);
    const handleClickAway = (event)=>{
        onClose?.(event, 'clickaway');
    };
    // Pause the timer when the user is interacting with the Snackbar
    // or when the user hide the window.
    const handlePause = timerAutoHide.clear;
    // Restart the timer when the user is no longer interacting with the Snackbar
    // or when the window is shown back.
    const handleResume = $2d16bff1157c299f$var$React.useCallback(()=>{
        if (autoHideDuration != null) setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        resumeHideDuration,
        setAutoHideTimer
    ]);
    const createHandleBlur = (otherHandlers)=>(event)=>{
            const onBlurCallback = otherHandlers.onBlur;
            onBlurCallback?.(event);
            handleResume();
        };
    const createHandleFocus = (otherHandlers)=>(event)=>{
            const onFocusCallback = otherHandlers.onFocus;
            onFocusCallback?.(event);
            handlePause();
        };
    const createMouseEnter = (otherHandlers)=>(event)=>{
            const onMouseEnterCallback = otherHandlers.onMouseEnter;
            onMouseEnterCallback?.(event);
            handlePause();
        };
    const createMouseLeave = (otherHandlers)=>(event)=>{
            const onMouseLeaveCallback = otherHandlers.onMouseLeave;
            onMouseLeaveCallback?.(event);
            handleResume();
        };
    $2d16bff1157c299f$var$React.useEffect(()=>{
        // TODO: window global should be refactored here
        if (!disableWindowBlurListener && open) {
            window.addEventListener('focus', handleResume);
            window.addEventListener('blur', handlePause);
            return ()=>{
                window.removeEventListener('focus', handleResume);
                window.removeEventListener('blur', handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        open,
        handleResume,
        handlePause
    ]);
    const getRootProps = (externalProps = {})=>{
        const externalEventHandlers = {
            ...(0, $2d16bff1157c299f$var$_extractEventHandlers.default)(parameters),
            ...(0, $2d16bff1157c299f$var$_extractEventHandlers.default)(externalProps)
        };
        return {
            // ClickAwayListener adds an `onClick` prop which results in the alert not being announced.
            // See https://github.com/mui/material-ui/issues/29080
            role: 'presentation',
            ...externalProps,
            ...externalEventHandlers,
            onBlur: createHandleBlur(externalEventHandlers),
            onFocus: createHandleFocus(externalEventHandlers),
            onMouseEnter: createMouseEnter(externalEventHandlers),
            onMouseLeave: createMouseLeave(externalEventHandlers)
        };
    };
    return {
        getRootProps: getRootProps,
        onClickAway: handleClickAway
    };
}
var $2d16bff1157c299f$var$_default = module.exports.default = $2d16bff1157c299f$var$useSnackbar;

});

parcelRegister("8BKxX", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $6445e2a5635b1c13$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $6445e2a5635b1c13$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $6445e2a5635b1c13$var$_exportNames = {
    snackbarContentClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $6445e2a5635b1c13$var$_SnackbarContent.default;
    }
});
Object.defineProperty(module.exports, "snackbarContentClasses", {
    enumerable: true,
    get: function() {
        return $6445e2a5635b1c13$var$_snackbarContentClasses.default;
    }
});

var $6445e2a5635b1c13$var$_SnackbarContent = $6445e2a5635b1c13$require$_interopRequireDefault((parcelRequire("iSsbN")));

var $6445e2a5635b1c13$var$_snackbarContentClasses = $6445e2a5635b1c13$require$_interopRequireWildcard((parcelRequire("6CRBu")));
Object.keys($6445e2a5635b1c13$var$_snackbarContentClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($6445e2a5635b1c13$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $6445e2a5635b1c13$var$_snackbarContentClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6445e2a5635b1c13$var$_snackbarContentClasses[key];
        }
    });
});

});
parcelRegister("iSsbN", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $dbe322effc7340b4$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $dbe322effc7340b4$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dbe322effc7340b4$var$React = $dbe322effc7340b4$require$_interopRequireWildcard((parcelRequire("acw62")));

var $dbe322effc7340b4$var$_propTypes = $dbe322effc7340b4$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $dbe322effc7340b4$var$_clsx = $dbe322effc7340b4$require$_interopRequireDefault((parcelRequire("9QePP")));

var $dbe322effc7340b4$var$_composeClasses = $dbe322effc7340b4$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $h61zw = parcelRequire("h61zw");

var $aAbgT = parcelRequire("aAbgT");

var $dbe322effc7340b4$var$_memoTheme = $dbe322effc7340b4$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $dbe322effc7340b4$var$_Paper = $dbe322effc7340b4$require$_interopRequireDefault((parcelRequire("juRJQ")));

var $6CRBu = parcelRequire("6CRBu");

var $ayMG0 = parcelRequire("ayMG0");
const $dbe322effc7340b4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        action: [
            'action'
        ],
        message: [
            'message'
        ]
    };
    return (0, $dbe322effc7340b4$var$_composeClasses.default)(slots, $6CRBu.getSnackbarContentUtilityClass, classes);
};
const $dbe322effc7340b4$var$SnackbarContentRoot = (0, $aAbgT.styled)($dbe322effc7340b4$var$_Paper.default, {
    name: 'MuiSnackbarContent',
    slot: 'Root'
})((0, $dbe322effc7340b4$var$_memoTheme.default)(({ theme: theme })=>{
    const emphasis = theme.palette.mode === 'light' ? 0.8 : 0.98;
    return {
        ...theme.typography.body2,
        color: theme.vars ? theme.vars.palette.SnackbarContent.color : theme.palette.getContrastText((0, $h61zw.emphasize)(theme.palette.background.default, emphasis)),
        backgroundColor: theme.vars ? theme.vars.palette.SnackbarContent.bg : (0, $h61zw.emphasize)(theme.palette.background.default, emphasis),
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        padding: '6px 16px',
        flexGrow: 1,
        [theme.breakpoints.up('sm')]: {
            flexGrow: 'initial',
            minWidth: 288
        }
    };
}));
const $dbe322effc7340b4$var$SnackbarContentMessage = (0, $aAbgT.styled)('div', {
    name: 'MuiSnackbarContent',
    slot: 'Message'
})({
    padding: '8px 0'
});
const $dbe322effc7340b4$var$SnackbarContentAction = (0, $aAbgT.styled)('div', {
    name: 'MuiSnackbarContent',
    slot: 'Action'
})({
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
    paddingLeft: 16,
    marginRight: -8
});
const $dbe322effc7340b4$var$SnackbarContent = /*#__PURE__*/ $dbe322effc7340b4$var$React.forwardRef(function SnackbarContent(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiSnackbarContent'
    });
    const { action: action, className: className, message: message, role: role = 'alert', ...other } = props;
    const ownerState = props;
    const classes = $dbe322effc7340b4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($dbe322effc7340b4$var$SnackbarContentRoot, {
        role: role,
        elevation: 6,
        className: (0, $dbe322effc7340b4$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($dbe322effc7340b4$var$SnackbarContentMessage, {
                className: classes.message,
                ownerState: ownerState,
                children: message
            }),
            action ? /*#__PURE__*/ (0, $ayMG0.jsx)($dbe322effc7340b4$var$SnackbarContentAction, {
                className: classes.action,
                ownerState: ownerState,
                children: action
            }) : null
        ]
    });
});
$dbe322effc7340b4$var$SnackbarContent.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The action to display. It renders after the message, at the end of the snackbar.
   */ action: $dbe322effc7340b4$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $dbe322effc7340b4$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $dbe322effc7340b4$var$_propTypes.default.string,
    /**
   * The message to display.
   */ message: $dbe322effc7340b4$var$_propTypes.default.node,
    /**
   * The ARIA role attribute of the element.
   * @default 'alert'
   */ role: $dbe322effc7340b4$var$_propTypes.default.string,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $dbe322effc7340b4$var$_propTypes.default.oneOfType([
        $dbe322effc7340b4$var$_propTypes.default.arrayOf($dbe322effc7340b4$var$_propTypes.default.oneOfType([
            $dbe322effc7340b4$var$_propTypes.default.func,
            $dbe322effc7340b4$var$_propTypes.default.object,
            $dbe322effc7340b4$var$_propTypes.default.bool
        ])),
        $dbe322effc7340b4$var$_propTypes.default.func,
        $dbe322effc7340b4$var$_propTypes.default.object
    ])
};
var $dbe322effc7340b4$var$_default = module.exports.default = $dbe322effc7340b4$var$SnackbarContent;

});
parcelRegister("6CRBu", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $4d2fdf4430378182$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getSnackbarContentUtilityClass = $4d2fdf4430378182$var$getSnackbarContentUtilityClass;

var $4d2fdf4430378182$var$_generateUtilityClasses = $4d2fdf4430378182$require$_interopRequireDefault((parcelRequire("5nY49")));

var $4d2fdf4430378182$var$_generateUtilityClass = $4d2fdf4430378182$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $4d2fdf4430378182$var$getSnackbarContentUtilityClass(slot) {
    return (0, $4d2fdf4430378182$var$_generateUtilityClass.default)('MuiSnackbarContent', slot);
}
const $4d2fdf4430378182$var$snackbarContentClasses = (0, $4d2fdf4430378182$var$_generateUtilityClasses.default)('MuiSnackbarContent', [
    'root',
    'message',
    'action'
]);
var $4d2fdf4430378182$var$_default = module.exports.default = $4d2fdf4430378182$var$snackbarContentClasses;

});



parcelRegister("kVqBB", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f3bdc4d25b715a88$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getSnackbarUtilityClass = $f3bdc4d25b715a88$var$getSnackbarUtilityClass;

var $f3bdc4d25b715a88$var$_generateUtilityClasses = $f3bdc4d25b715a88$require$_interopRequireDefault((parcelRequire("5nY49")));

var $f3bdc4d25b715a88$var$_generateUtilityClass = $f3bdc4d25b715a88$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $f3bdc4d25b715a88$var$getSnackbarUtilityClass(slot) {
    return (0, $f3bdc4d25b715a88$var$_generateUtilityClass.default)('MuiSnackbar', slot);
}
const $f3bdc4d25b715a88$var$snackbarClasses = (0, $f3bdc4d25b715a88$var$_generateUtilityClasses.default)('MuiSnackbar', [
    'root',
    'anchorOriginTopCenter',
    'anchorOriginBottomCenter',
    'anchorOriginTopRight',
    'anchorOriginBottomRight',
    'anchorOriginTopLeft',
    'anchorOriginBottomLeft'
]);
var $f3bdc4d25b715a88$var$_default = module.exports.default = $f3bdc4d25b715a88$var$snackbarClasses;

});



parcelRegister("kqAaP", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $edf24babb8f47c92$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $edf24babb8f47c92$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $edf24babb8f47c92$var$_exportNames = {
    speedDialClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $edf24babb8f47c92$var$_SpeedDial.default;
    }
});
Object.defineProperty(module.exports, "speedDialClasses", {
    enumerable: true,
    get: function() {
        return $edf24babb8f47c92$var$_speedDialClasses.default;
    }
});

var $edf24babb8f47c92$var$_SpeedDial = $edf24babb8f47c92$require$_interopRequireDefault((parcelRequire("kzdtv")));

var $edf24babb8f47c92$var$_speedDialClasses = $edf24babb8f47c92$require$_interopRequireWildcard((parcelRequire("iwNBi")));
Object.keys($edf24babb8f47c92$var$_speedDialClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($edf24babb8f47c92$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $edf24babb8f47c92$var$_speedDialClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $edf24babb8f47c92$var$_speedDialClasses[key];
        }
    });
});

});
parcelRegister("kzdtv", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $ef91875cc443f344$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $ef91875cc443f344$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ef91875cc443f344$var$React = $ef91875cc443f344$require$_interopRequireWildcard((parcelRequire("acw62")));

var $4jPKB = parcelRequire("4jPKB");

var $ef91875cc443f344$var$_propTypes = $ef91875cc443f344$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $ef91875cc443f344$var$_clsx = $ef91875cc443f344$require$_interopRequireDefault((parcelRequire("9QePP")));

var $ef91875cc443f344$var$_composeClasses = $ef91875cc443f344$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $ef91875cc443f344$var$_useTimeout = $ef91875cc443f344$require$_interopRequireDefault((parcelRequire("drY8V")));

var $ef91875cc443f344$var$_clamp = $ef91875cc443f344$require$_interopRequireDefault((parcelRequire("3zA0b")));

var $aAbgT = parcelRequire("aAbgT");

var $ef91875cc443f344$var$_memoTheme = $ef91875cc443f344$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $ef91875cc443f344$var$_Zoom = $ef91875cc443f344$require$_interopRequireDefault((parcelRequire("3uqi7")));

var $ef91875cc443f344$var$_Fab = $ef91875cc443f344$require$_interopRequireDefault((parcelRequire("2r6m0")));

var $ef91875cc443f344$var$_capitalize = $ef91875cc443f344$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $ef91875cc443f344$var$_isMuiElement = $ef91875cc443f344$require$_interopRequireDefault((parcelRequire("cpXNi")));

var $ef91875cc443f344$var$_useForkRef = $ef91875cc443f344$require$_interopRequireDefault((parcelRequire("9Rgf1")));

var $ef91875cc443f344$var$_useControlled = $ef91875cc443f344$require$_interopRequireDefault((parcelRequire("3yddg")));

var $ef91875cc443f344$var$_speedDialClasses = $ef91875cc443f344$require$_interopRequireWildcard((parcelRequire("iwNBi")));

var $ef91875cc443f344$var$_useSlot = $ef91875cc443f344$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $ef91875cc443f344$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, open: open, direction: direction } = ownerState;
    const slots = {
        root: [
            'root',
            `direction${(0, $ef91875cc443f344$var$_capitalize.default)(direction)}`
        ],
        fab: [
            'fab'
        ],
        actions: [
            'actions',
            !open && 'actionsClosed'
        ]
    };
    return (0, $ef91875cc443f344$var$_composeClasses.default)(slots, $ef91875cc443f344$var$_speedDialClasses.getSpeedDialUtilityClass, classes);
};
function $ef91875cc443f344$var$getOrientation(direction) {
    if (direction === 'up' || direction === 'down') return 'vertical';
    if (direction === 'right' || direction === 'left') return 'horizontal';
    return undefined;
}
const $ef91875cc443f344$var$dialRadius = 32;
const $ef91875cc443f344$var$spacingActions = 16;
const $ef91875cc443f344$var$SpeedDialRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiSpeedDial',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`direction${(0, $ef91875cc443f344$var$_capitalize.default)(ownerState.direction)}`]
        ];
    }
})((0, $ef91875cc443f344$var$_memoTheme.default)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.speedDial,
        display: 'flex',
        alignItems: 'center',
        pointerEvents: 'none',
        variants: [
            {
                props: {
                    direction: 'up'
                },
                style: {
                    flexDirection: 'column-reverse',
                    [`& .${$ef91875cc443f344$var$_speedDialClasses.default.actions}`]: {
                        flexDirection: 'column-reverse',
                        marginBottom: -$ef91875cc443f344$var$dialRadius,
                        paddingBottom: $ef91875cc443f344$var$spacingActions + $ef91875cc443f344$var$dialRadius
                    }
                }
            },
            {
                props: {
                    direction: 'down'
                },
                style: {
                    flexDirection: 'column',
                    [`& .${$ef91875cc443f344$var$_speedDialClasses.default.actions}`]: {
                        flexDirection: 'column',
                        marginTop: -$ef91875cc443f344$var$dialRadius,
                        paddingTop: $ef91875cc443f344$var$spacingActions + $ef91875cc443f344$var$dialRadius
                    }
                }
            },
            {
                props: {
                    direction: 'left'
                },
                style: {
                    flexDirection: 'row-reverse',
                    [`& .${$ef91875cc443f344$var$_speedDialClasses.default.actions}`]: {
                        flexDirection: 'row-reverse',
                        marginRight: -$ef91875cc443f344$var$dialRadius,
                        paddingRight: $ef91875cc443f344$var$spacingActions + $ef91875cc443f344$var$dialRadius
                    }
                }
            },
            {
                props: {
                    direction: 'right'
                },
                style: {
                    flexDirection: 'row',
                    [`& .${$ef91875cc443f344$var$_speedDialClasses.default.actions}`]: {
                        flexDirection: 'row',
                        marginLeft: -$ef91875cc443f344$var$dialRadius,
                        paddingLeft: $ef91875cc443f344$var$spacingActions + $ef91875cc443f344$var$dialRadius
                    }
                }
            }
        ]
    })));
const $ef91875cc443f344$var$SpeedDialFab = (0, $aAbgT.styled)($ef91875cc443f344$var$_Fab.default, {
    name: 'MuiSpeedDial',
    slot: 'Fab'
})({
    pointerEvents: 'auto'
});
const $ef91875cc443f344$var$SpeedDialActions = (0, $aAbgT.styled)('div', {
    name: 'MuiSpeedDial',
    slot: 'Actions',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.actions,
            !ownerState.open && styles.actionsClosed
        ];
    }
})({
    display: 'flex',
    pointerEvents: 'auto',
    variants: [
        {
            props: ({ ownerState: ownerState })=>!ownerState.open,
            style: {
                transition: 'top 0s linear 0.2s',
                pointerEvents: 'none'
            }
        }
    ]
});
const $ef91875cc443f344$var$SpeedDial = /*#__PURE__*/ $ef91875cc443f344$var$React.forwardRef(function SpeedDial(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiSpeedDial'
    });
    const theme = (0, $aAbgT.useTheme)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { ariaLabel: ariaLabel, FabProps: { ref: origDialButtonRef, ...FabProps } = {}, children: childrenProp, className: className, direction: direction = 'up', hidden: hidden = false, icon: icon, onBlur: onBlur, onClose: onClose, onFocus: onFocus, onKeyDown: onKeyDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onOpen: onOpen, open: openProp, openIcon: openIcon, slots: slots = {}, slotProps: slotProps = {}, TransitionComponent: TransitionComponentProp, TransitionProps: TransitionPropsProp, transitionDuration: transitionDuration = defaultTransitionDuration, ...other } = props;
    const [open, setOpenState] = (0, $ef91875cc443f344$var$_useControlled.default)({
        controlled: openProp,
        default: false,
        name: 'SpeedDial',
        state: 'open'
    });
    const ownerState = {
        ...props,
        open: open,
        direction: direction
    };
    const classes = $ef91875cc443f344$var$useUtilityClasses(ownerState);
    const eventTimer = (0, $ef91875cc443f344$var$_useTimeout.default)();
    /**
   * an index in actions.current
   */ const focusedAction = $ef91875cc443f344$var$React.useRef(0);
    /**
   * pressing this key while the focus is on a child SpeedDialAction focuses
   * the next SpeedDialAction.
   * It is equal to the first arrow key pressed while focus is on the SpeedDial
   * that is not orthogonal to the direction.
   * @type {utils.ArrowKey?}
   */ const nextItemArrowKey = $ef91875cc443f344$var$React.useRef();
    /**
   * refs to the Button that have an action associated to them in this SpeedDial
   * [Fab, ...(SpeedDialActions > Button)]
   * @type {HTMLButtonElement[]}
   */ const actions = $ef91875cc443f344$var$React.useRef([]);
    actions.current = [
        actions.current[0]
    ];
    const handleOwnFabRef = $ef91875cc443f344$var$React.useCallback((fabFef)=>{
        actions.current[0] = fabFef;
    }, []);
    const handleFabRef = (0, $ef91875cc443f344$var$_useForkRef.default)(origDialButtonRef, handleOwnFabRef);
    /**
   * creates a ref callback for the Button in a SpeedDialAction
   * Is called before the original ref callback for Button that was set in buttonProps
   *
   * @param dialActionIndex {number}
   * @param origButtonRef {React.RefObject?}
   * @param fabSlotOrigButtonRef {React.RefObject?}
   */ const createHandleSpeedDialActionButtonRef = (dialActionIndex, origButtonRef, fabSlotOrigButtonRef)=>{
        return (buttonRef)=>{
            actions.current[dialActionIndex + 1] = buttonRef;
            if (origButtonRef) origButtonRef(buttonRef);
            if (fabSlotOrigButtonRef) fabSlotOrigButtonRef(buttonRef);
        };
    };
    const handleKeyDown = (event)=>{
        if (onKeyDown) onKeyDown(event);
        const key = event.key.replace('Arrow', '').toLowerCase();
        const { current: nextItemArrowKeyCurrent = key } = nextItemArrowKey;
        if (event.key === 'Escape') {
            setOpenState(false);
            actions.current[0].focus();
            if (onClose) onClose(event, 'escapeKeyDown');
            return;
        }
        if ($ef91875cc443f344$var$getOrientation(key) === $ef91875cc443f344$var$getOrientation(nextItemArrowKeyCurrent) && $ef91875cc443f344$var$getOrientation(key) !== undefined) {
            event.preventDefault();
            const actionStep = key === nextItemArrowKeyCurrent ? 1 : -1;
            // stay within array indices
            const nextAction = (0, $ef91875cc443f344$var$_clamp.default)(focusedAction.current + actionStep, 0, actions.current.length - 1);
            actions.current[nextAction].focus();
            focusedAction.current = nextAction;
            nextItemArrowKey.current = nextItemArrowKeyCurrent;
        }
    };
    $ef91875cc443f344$var$React.useEffect(()=>{
        // actions were closed while navigation state was not reset
        if (!open) {
            focusedAction.current = 0;
            nextItemArrowKey.current = undefined;
        }
    }, [
        open
    ]);
    const handleClose = (event)=>{
        if (event.type === 'mouseleave' && onMouseLeave) onMouseLeave(event);
        if (event.type === 'blur' && onBlur) onBlur(event);
        eventTimer.clear();
        if (event.type === 'blur') eventTimer.start(0, ()=>{
            setOpenState(false);
            if (onClose) onClose(event, 'blur');
        });
        else {
            setOpenState(false);
            if (onClose) onClose(event, 'mouseLeave');
        }
    };
    const handleClick = (event)=>{
        if (FabProps.onClick) FabProps.onClick(event);
        eventTimer.clear();
        if (open) {
            setOpenState(false);
            if (onClose) onClose(event, 'toggle');
        } else {
            setOpenState(true);
            if (onOpen) onOpen(event, 'toggle');
        }
    };
    const handleOpen = (event)=>{
        if (event.type === 'mouseenter' && onMouseEnter) onMouseEnter(event);
        if (event.type === 'focus' && onFocus) onFocus(event);
        // When moving the focus between two items,
        // a chain if blur and focus event is triggered.
        // We only handle the last event.
        eventTimer.clear();
        if (!open) // Wait for a future focus or click event
        eventTimer.start(0, ()=>{
            setOpenState(true);
            if (onOpen) {
                const eventMap = {
                    focus: 'focus',
                    mouseenter: 'mouseEnter'
                };
                onOpen(event, eventMap[event.type]);
            }
        });
    };
    // Filter the label for valid id characters.
    const id = ariaLabel.replace(/^[^a-z]+|[^\w:.-]+/gi, '');
    const allItems = $ef91875cc443f344$var$React.Children.toArray(childrenProp).filter((child)=>{
        if ((0, $4jPKB.isFragment)(child)) console.error([
            "MUI: The SpeedDial component doesn't accept a Fragment as a child.",
            'Consider providing an array instead.'
        ].join('\n'));
        return /*#__PURE__*/ $ef91875cc443f344$var$React.isValidElement(child);
    });
    const children = allItems.map((child, index)=>{
        const { FabProps: { ref: origButtonRef } = {}, slotProps: childSlotProps = {}, tooltipPlacement: tooltipPlacementProp } = child.props;
        const { fab: { ref: fabSlotOrigButtonRef, ...fabSlotProps } = {}, ...restOfSlotProps } = childSlotProps;
        const tooltipPlacement = tooltipPlacementProp || ($ef91875cc443f344$var$getOrientation(direction) === 'vertical' ? 'left' : 'top');
        return /*#__PURE__*/ $ef91875cc443f344$var$React.cloneElement(child, {
            slotProps: {
                fab: {
                    ...fabSlotProps,
                    ref: createHandleSpeedDialActionButtonRef(index, origButtonRef, fabSlotOrigButtonRef)
                },
                ...restOfSlotProps
            },
            delay: 30 * (open ? index : allItems.length - index),
            open: open,
            tooltipPlacement: tooltipPlacement,
            id: `${id}-action-${index}`
        });
    });
    const backwardCompatibleSlots = {
        transition: TransitionComponentProp,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        transition: TransitionPropsProp,
        ...slotProps
    };
    const externalForwardedProps = {
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootSlotProps] = (0, $ef91875cc443f344$var$_useSlot.default)('root', {
        elementType: $ef91875cc443f344$var$SpeedDialRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        ref: ref,
        className: (0, $ef91875cc443f344$var$_clsx.default)(classes.root, className),
        additionalProps: {
            role: 'presentation'
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onKeyDown: (event)=>{
                    handlers.onKeyDown?.(event);
                    handleKeyDown(event);
                },
                onBlur: (event)=>{
                    handlers.onBlur?.(event);
                    handleClose(event);
                },
                onFocus: (event)=>{
                    handlers.onFocus?.(event);
                    handleOpen(event);
                },
                onMouseEnter: (event)=>{
                    handlers.onMouseEnter?.(event);
                    handleOpen(event);
                },
                onMouseLeave: (event)=>{
                    handlers.onMouseLeave?.(event);
                    handleClose(event);
                }
            })
    });
    const [TransitionSlot, transitionProps] = (0, $ef91875cc443f344$var$_useSlot.default)('transition', {
        elementType: $ef91875cc443f344$var$_Zoom.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionSlot, {
                in: !hidden,
                timeout: transitionDuration,
                unmountOnExit: true,
                ...transitionProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($ef91875cc443f344$var$SpeedDialFab, {
                    color: "primary",
                    "aria-label": ariaLabel,
                    "aria-haspopup": "true",
                    "aria-expanded": open,
                    "aria-controls": `${id}-actions`,
                    ...FabProps,
                    onClick: handleClick,
                    className: (0, $ef91875cc443f344$var$_clsx.default)(classes.fab, FabProps.className),
                    ref: handleFabRef,
                    ownerState: ownerState,
                    children: /*#__PURE__*/ $ef91875cc443f344$var$React.isValidElement(icon) && (0, $ef91875cc443f344$var$_isMuiElement.default)(icon, [
                        'SpeedDialIcon'
                    ]) ? /*#__PURE__*/ $ef91875cc443f344$var$React.cloneElement(icon, {
                        open: open
                    }) : icon
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($ef91875cc443f344$var$SpeedDialActions, {
                id: `${id}-actions`,
                role: "menu",
                "aria-orientation": $ef91875cc443f344$var$getOrientation(direction),
                className: (0, $ef91875cc443f344$var$_clsx.default)(classes.actions, !open && classes.actionsClosed),
                ownerState: ownerState,
                children: children
            })
        ]
    });
});
$ef91875cc443f344$var$SpeedDial.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The aria-label of the button element.
   * Also used to provide the `id` for the `SpeedDial` element and its children.
   */ ariaLabel: $ef91875cc443f344$var$_propTypes.default.string.isRequired,
    /**
   * SpeedDialActions to display when the SpeedDial is `open`.
   */ children: $ef91875cc443f344$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $ef91875cc443f344$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $ef91875cc443f344$var$_propTypes.default.string,
    /**
   * The direction the actions open relative to the floating action button.
   * @default 'up'
   */ direction: $ef91875cc443f344$var$_propTypes.default.oneOf([
        'down',
        'left',
        'right',
        'up'
    ]),
    /**
   * Props applied to the [`Fab`](https://mui.com/material-ui/api/fab/) element.
   * @default {}
   */ FabProps: $ef91875cc443f344$var$_propTypes.default.object,
    /**
   * If `true`, the SpeedDial is hidden.
   * @default false
   */ hidden: $ef91875cc443f344$var$_propTypes.default.bool,
    /**
   * The icon to display in the SpeedDial Fab. The `SpeedDialIcon` component
   * provides a default Icon with animation.
   */ icon: $ef91875cc443f344$var$_propTypes.default.node,
    /**
   * @ignore
   */ onBlur: $ef91875cc443f344$var$_propTypes.default.func,
    /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"toggle"`, `"blur"`, `"mouseLeave"`, `"escapeKeyDown"`.
   */ onClose: $ef91875cc443f344$var$_propTypes.default.func,
    /**
   * @ignore
   */ onFocus: $ef91875cc443f344$var$_propTypes.default.func,
    /**
   * @ignore
   */ onKeyDown: $ef91875cc443f344$var$_propTypes.default.func,
    /**
   * @ignore
   */ onMouseEnter: $ef91875cc443f344$var$_propTypes.default.func,
    /**
   * @ignore
   */ onMouseLeave: $ef91875cc443f344$var$_propTypes.default.func,
    /**
   * Callback fired when the component requests to be open.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"toggle"`, `"focus"`, `"mouseEnter"`.
   */ onOpen: $ef91875cc443f344$var$_propTypes.default.func,
    /**
   * If `true`, the component is shown.
   */ open: $ef91875cc443f344$var$_propTypes.default.bool,
    /**
   * The icon to display in the SpeedDial Fab when the SpeedDial is open.
   */ openIcon: $ef91875cc443f344$var$_propTypes.default.node,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $ef91875cc443f344$var$_propTypes.default.shape({
        root: $ef91875cc443f344$var$_propTypes.default.oneOfType([
            $ef91875cc443f344$var$_propTypes.default.func,
            $ef91875cc443f344$var$_propTypes.default.object
        ]),
        transition: $ef91875cc443f344$var$_propTypes.default.oneOfType([
            $ef91875cc443f344$var$_propTypes.default.func,
            $ef91875cc443f344$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: $ef91875cc443f344$var$_propTypes.default.shape({
        root: $ef91875cc443f344$var$_propTypes.default.elementType,
        transition: $ef91875cc443f344$var$_propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $ef91875cc443f344$var$_propTypes.default.oneOfType([
        $ef91875cc443f344$var$_propTypes.default.arrayOf($ef91875cc443f344$var$_propTypes.default.oneOfType([
            $ef91875cc443f344$var$_propTypes.default.func,
            $ef91875cc443f344$var$_propTypes.default.object,
            $ef91875cc443f344$var$_propTypes.default.bool
        ])),
        $ef91875cc443f344$var$_propTypes.default.func,
        $ef91875cc443f344$var$_propTypes.default.object
    ]),
    /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Zoom
   * * @deprecated Use `slots.transition` instead. This prop will be removed in a future major release. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/)
   */ TransitionComponent: $ef91875cc443f344$var$_propTypes.default.elementType,
    /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */ transitionDuration: $ef91875cc443f344$var$_propTypes.default.oneOfType([
        $ef91875cc443f344$var$_propTypes.default.number,
        $ef91875cc443f344$var$_propTypes.default.shape({
            appear: $ef91875cc443f344$var$_propTypes.default.number,
            enter: $ef91875cc443f344$var$_propTypes.default.number,
            exit: $ef91875cc443f344$var$_propTypes.default.number
        })
    ]),
    /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated Use `slotProps.transition` instead. This prop will be removed in a future major release. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/)
   */ TransitionProps: $ef91875cc443f344$var$_propTypes.default.object
};
var $ef91875cc443f344$var$_default = module.exports.default = $ef91875cc443f344$var$SpeedDial;

});
parcelRegister("3uqi7", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $28a89151afea75ff$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $28a89151afea75ff$var$_Zoom.default;
    }
});

var $28a89151afea75ff$var$_Zoom = $28a89151afea75ff$require$_interopRequireDefault((parcelRequire("62Z1m")));

});
parcelRegister("62Z1m", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $4672437388b729f6$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $4672437388b729f6$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4672437388b729f6$var$React = $4672437388b729f6$require$_interopRequireWildcard((parcelRequire("acw62")));

var $4672437388b729f6$var$_propTypes = $4672437388b729f6$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $1mPeS = parcelRequire("1mPeS");

var $4672437388b729f6$var$_elementAcceptingRef = $4672437388b729f6$require$_interopRequireDefault((parcelRequire("igTUE")));

var $4672437388b729f6$var$_getReactElementRef = $4672437388b729f6$require$_interopRequireDefault((parcelRequire("2B4J6")));

var $aAbgT = parcelRequire("aAbgT");

var $hweuE = parcelRequire("hweuE");

var $4672437388b729f6$var$_useForkRef = $4672437388b729f6$require$_interopRequireDefault((parcelRequire("9Rgf1")));

var $ayMG0 = parcelRequire("ayMG0");
const $4672437388b729f6$var$styles = {
    entering: {
        transform: 'none'
    },
    entered: {
        transform: 'none'
    },
    exiting: {
        transform: 'scale(0)'
    },
    exited: {
        transform: 'scale(0)'
    }
};
const $4672437388b729f6$var$hiddenStyles = {
    transform: 'scale(0)',
    visibility: 'hidden'
};
/**
 * The Zoom transition can be used for the floating variant of the
 * [Button](/material-ui/react-floating-action-button/#animation) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $4672437388b729f6$var$Zoom = /*#__PURE__*/ $4672437388b729f6$var$React.forwardRef(function Zoom(props, ref) {
    const theme = (0, $aAbgT.useTheme)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, ...other } = props;
    const nodeRef = $4672437388b729f6$var$React.useRef(null);
    const handleRef = (0, $4672437388b729f6$var$_useForkRef.default)(nodeRef, (0, $4672437388b729f6$var$_getReactElementRef.default)(children), ref);
    const handleEntering = (0, $hweuE.normalizedTransitionCallback)(nodeRef, onEntering);
    const handleEnter = (0, $hweuE.normalizedTransitionCallback)(nodeRef, (node, isAppearing)=>{
        (0, $hweuE.reflow)(node); // So the animation always start from the start.
        const transitionProps = (0, $hweuE.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        node.style.transition = theme.transitions.create('transform', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = (0, $hweuE.normalizedTransitionCallback)(nodeRef, onEntered);
    const handleExiting = (0, $hweuE.normalizedTransitionCallback)(nodeRef, onExiting);
    const handleExit = (0, $hweuE.normalizedTransitionCallback)(nodeRef, (node)=>{
        const transitionProps = (0, $hweuE.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        node.style.transition = theme.transitions.create('transform', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = (0, $hweuE.normalizedTransitionCallback)(nodeRef, (node)=>{
        node.style.transition = '';
        if (onExited) onExited(node);
    });
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1mPeS.default, {
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            const childStyle = (0, $hweuE.getTransitionChildStyle)(state, inProp, $4672437388b729f6$var$styles, $4672437388b729f6$var$hiddenStyles, style, children.props.style);
            return /*#__PURE__*/ $4672437388b729f6$var$React.cloneElement(children, {
                style: childStyle,
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
$4672437388b729f6$var$Zoom.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */ addEndListener: $4672437388b729f6$var$_propTypes.default.func,
    /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */ appear: $4672437388b729f6$var$_propTypes.default.bool,
    /**
   * A single child content element.
   */ children: $4672437388b729f6$var$_elementAcceptingRef.default.isRequired,
    /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */ easing: $4672437388b729f6$var$_propTypes.default.oneOfType([
        $4672437388b729f6$var$_propTypes.default.shape({
            enter: $4672437388b729f6$var$_propTypes.default.string,
            exit: $4672437388b729f6$var$_propTypes.default.string
        }),
        $4672437388b729f6$var$_propTypes.default.string
    ]),
    /**
   * If `true`, the component will transition in.
   */ in: $4672437388b729f6$var$_propTypes.default.bool,
    /**
   * @ignore
   */ onEnter: $4672437388b729f6$var$_propTypes.default.func,
    /**
   * @ignore
   */ onEntered: $4672437388b729f6$var$_propTypes.default.func,
    /**
   * @ignore
   */ onEntering: $4672437388b729f6$var$_propTypes.default.func,
    /**
   * @ignore
   */ onExit: $4672437388b729f6$var$_propTypes.default.func,
    /**
   * @ignore
   */ onExited: $4672437388b729f6$var$_propTypes.default.func,
    /**
   * @ignore
   */ onExiting: $4672437388b729f6$var$_propTypes.default.func,
    /**
   * @ignore
   */ style: $4672437388b729f6$var$_propTypes.default.object,
    /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */ timeout: $4672437388b729f6$var$_propTypes.default.oneOfType([
        $4672437388b729f6$var$_propTypes.default.number,
        $4672437388b729f6$var$_propTypes.default.shape({
            appear: $4672437388b729f6$var$_propTypes.default.number,
            enter: $4672437388b729f6$var$_propTypes.default.number,
            exit: $4672437388b729f6$var$_propTypes.default.number
        })
    ])
};
var $4672437388b729f6$var$_default = module.exports.default = $4672437388b729f6$var$Zoom;

});


parcelRegister("iwNBi", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d7d1b0c877edfc53$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getSpeedDialUtilityClass = $d7d1b0c877edfc53$var$getSpeedDialUtilityClass;

var $d7d1b0c877edfc53$var$_generateUtilityClasses = $d7d1b0c877edfc53$require$_interopRequireDefault((parcelRequire("5nY49")));

var $d7d1b0c877edfc53$var$_generateUtilityClass = $d7d1b0c877edfc53$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $d7d1b0c877edfc53$var$getSpeedDialUtilityClass(slot) {
    return (0, $d7d1b0c877edfc53$var$_generateUtilityClass.default)('MuiSpeedDial', slot);
}
const $d7d1b0c877edfc53$var$speedDialClasses = (0, $d7d1b0c877edfc53$var$_generateUtilityClasses.default)('MuiSpeedDial', [
    'root',
    'fab',
    'directionUp',
    'directionDown',
    'directionLeft',
    'directionRight',
    'actions',
    'actionsClosed'
]);
var $d7d1b0c877edfc53$var$_default = module.exports.default = $d7d1b0c877edfc53$var$speedDialClasses;

});



parcelRegister("2Pq3d", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $20f48d600d3ec25e$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $20f48d600d3ec25e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $20f48d600d3ec25e$var$_exportNames = {
    speedDialActionClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $20f48d600d3ec25e$var$_SpeedDialAction.default;
    }
});
Object.defineProperty(module.exports, "speedDialActionClasses", {
    enumerable: true,
    get: function() {
        return $20f48d600d3ec25e$var$_speedDialActionClasses.default;
    }
});

var $20f48d600d3ec25e$var$_SpeedDialAction = $20f48d600d3ec25e$require$_interopRequireDefault((parcelRequire("hK7mH")));

var $20f48d600d3ec25e$var$_speedDialActionClasses = $20f48d600d3ec25e$require$_interopRequireWildcard((parcelRequire("iTcEP")));
Object.keys($20f48d600d3ec25e$var$_speedDialActionClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($20f48d600d3ec25e$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $20f48d600d3ec25e$var$_speedDialActionClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $20f48d600d3ec25e$var$_speedDialActionClasses[key];
        }
    });
});

});
parcelRegister("hK7mH", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $ceac721f7000e3b1$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $ceac721f7000e3b1$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ceac721f7000e3b1$var$React = $ceac721f7000e3b1$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ceac721f7000e3b1$var$_propTypes = $ceac721f7000e3b1$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $ceac721f7000e3b1$var$_clsx = $ceac721f7000e3b1$require$_interopRequireDefault((parcelRequire("9QePP")));

var $ceac721f7000e3b1$var$_composeClasses = $ceac721f7000e3b1$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $h61zw = parcelRequire("h61zw");

var $aAbgT = parcelRequire("aAbgT");

var $ceac721f7000e3b1$var$_memoTheme = $ceac721f7000e3b1$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $ceac721f7000e3b1$var$_Fab = $ceac721f7000e3b1$require$_interopRequireDefault((parcelRequire("2r6m0")));

var $ceac721f7000e3b1$var$_Tooltip = $ceac721f7000e3b1$require$_interopRequireDefault((parcelRequire("tEWAm")));

var $ceac721f7000e3b1$var$_capitalize = $ceac721f7000e3b1$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $ceac721f7000e3b1$var$_speedDialActionClasses = $ceac721f7000e3b1$require$_interopRequireWildcard((parcelRequire("iTcEP")));

var $ceac721f7000e3b1$var$_useSlot = $ceac721f7000e3b1$require$_interopRequireDefault((parcelRequire("6lpak")));

var $hGPki = parcelRequire("hGPki");

var $ayMG0 = parcelRequire("ayMG0");
const $ceac721f7000e3b1$var$useUtilityClasses = (ownerState)=>{
    const { open: open, tooltipPlacement: tooltipPlacement, classes: classes } = ownerState;
    const slots = {
        fab: [
            'fab',
            !open && 'fabClosed'
        ],
        staticTooltip: [
            'staticTooltip',
            `tooltipPlacement${(0, $ceac721f7000e3b1$var$_capitalize.default)(tooltipPlacement)}`,
            !open && 'staticTooltipClosed'
        ],
        staticTooltipLabel: [
            'staticTooltipLabel'
        ]
    };
    return (0, $ceac721f7000e3b1$var$_composeClasses.default)(slots, $ceac721f7000e3b1$var$_speedDialActionClasses.getSpeedDialActionUtilityClass, classes);
};
const $ceac721f7000e3b1$var$SpeedDialActionFab = (0, $aAbgT.styled)($ceac721f7000e3b1$var$_Fab.default, {
    name: 'MuiSpeedDialAction',
    slot: 'Fab',
    skipVariantsResolver: false,
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.fab,
            !ownerState.open && styles.fabClosed
        ];
    }
})((0, $ceac721f7000e3b1$var$_memoTheme.default)(({ theme: theme })=>({
        margin: 8,
        color: (theme.vars || theme).palette.text.secondary,
        backgroundColor: (theme.vars || theme).palette.background.paper,
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.SpeedDialAction.fabHoverBg : (0, $h61zw.emphasize)(theme.palette.background.paper, 0.15)
        },
        transition: `${theme.transitions.create('transform', {
            duration: theme.transitions.duration.shorter
        })}, opacity 0.8s`,
        opacity: 1,
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.open,
                style: {
                    opacity: 0,
                    transform: 'scale(0)'
                }
            }
        ]
    })));
const $ceac721f7000e3b1$var$SpeedDialActionStaticTooltip = (0, $aAbgT.styled)('span', {
    name: 'MuiSpeedDialAction',
    slot: 'StaticTooltip',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.staticTooltip,
            !ownerState.open && styles.staticTooltipClosed,
            styles[`tooltipPlacement${(0, $ceac721f7000e3b1$var$_capitalize.default)(ownerState.tooltipPlacement)}`]
        ];
    }
})((0, $ceac721f7000e3b1$var$_memoTheme.default)(({ theme: theme })=>({
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        [`& .${$ceac721f7000e3b1$var$_speedDialActionClasses.default.staticTooltipLabel}`]: {
            transition: theme.transitions.create([
                'transform',
                'opacity'
            ], {
                duration: theme.transitions.duration.shorter
            }),
            opacity: 1
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.open,
                style: {
                    [`& .${$ceac721f7000e3b1$var$_speedDialActionClasses.default.staticTooltipLabel}`]: {
                        opacity: 0,
                        transform: 'scale(0.5)'
                    }
                }
            },
            {
                props: {
                    tooltipPlacement: 'left'
                },
                style: {
                    [`& .${$ceac721f7000e3b1$var$_speedDialActionClasses.default.staticTooltipLabel}`]: {
                        transformOrigin: '100% 50%',
                        right: '100%',
                        marginRight: 8
                    }
                }
            },
            {
                props: {
                    tooltipPlacement: 'right'
                },
                style: {
                    [`& .${$ceac721f7000e3b1$var$_speedDialActionClasses.default.staticTooltipLabel}`]: {
                        transformOrigin: '0% 50%',
                        left: '100%',
                        marginLeft: 8
                    }
                }
            }
        ]
    })));
const $ceac721f7000e3b1$var$SpeedDialActionStaticTooltipLabel = (0, $aAbgT.styled)('span', {
    name: 'MuiSpeedDialAction',
    slot: 'StaticTooltipLabel'
})((0, $ceac721f7000e3b1$var$_memoTheme.default)(({ theme: theme })=>({
        position: 'absolute',
        ...theme.typography.body1,
        backgroundColor: (theme.vars || theme).palette.background.paper,
        borderRadius: (theme.vars || theme).shape.borderRadius,
        boxShadow: (theme.vars || theme).shadows[1],
        color: (theme.vars || theme).palette.text.secondary,
        padding: '4px 16px',
        wordBreak: 'keep-all'
    })));
const $ceac721f7000e3b1$var$SpeedDialAction = /*#__PURE__*/ $ceac721f7000e3b1$var$React.forwardRef(function SpeedDialAction(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiSpeedDialAction'
    });
    const { className: className, delay: delay = 0, FabProps: FabProps = {}, icon: icon, id: id, open: open, TooltipClasses: TooltipClasses, tooltipOpen: tooltipOpenProp = false, tooltipPlacement: tooltipPlacement = 'left', tooltipTitle: tooltipTitle, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const ownerState = {
        ...props,
        tooltipPlacement: tooltipPlacement
    };
    const classes = $ceac721f7000e3b1$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            fab: FabProps,
            ...slotProps,
            tooltip: (0, $hGPki.mergeSlotProps)(typeof slotProps.tooltip === 'function' ? slotProps.tooltip(ownerState) : slotProps.tooltip, {
                title: tooltipTitle,
                open: tooltipOpenProp,
                placement: tooltipPlacement,
                classes: TooltipClasses
            })
        }
    };
    const [tooltipOpen, setTooltipOpen] = $ceac721f7000e3b1$var$React.useState(externalForwardedProps.slotProps.tooltip?.open);
    const handleTooltipClose = ()=>{
        setTooltipOpen(false);
    };
    const handleTooltipOpen = ()=>{
        setTooltipOpen(true);
    };
    const transitionStyle = {
        transitionDelay: `${delay}ms`
    };
    const [FabSlot, fabSlotProps] = (0, $ceac721f7000e3b1$var$_useSlot.default)('fab', {
        elementType: $ceac721f7000e3b1$var$SpeedDialActionFab,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        shouldForwardComponentProp: true,
        className: (0, $ceac721f7000e3b1$var$_clsx.default)(classes.fab, className),
        additionalProps: {
            style: transitionStyle,
            tabIndex: -1,
            role: 'menuitem',
            size: 'small'
        }
    });
    const [TooltipSlot, tooltipSlotProps] = (0, $ceac721f7000e3b1$var$_useSlot.default)('tooltip', {
        elementType: $ceac721f7000e3b1$var$_Tooltip.default,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        ref: ref,
        additionalProps: {
            id: id
        },
        ownerState: ownerState,
        getSlotProps: (handlers)=>({
                ...handlers,
                onClose: (event)=>{
                    handlers.onClose?.(event);
                    handleTooltipClose();
                },
                onOpen: (event)=>{
                    handlers.onOpen?.(event);
                    handleTooltipOpen();
                }
            })
    });
    const [StaticTooltipSlot, staticTooltipSlotProps] = (0, $ceac721f7000e3b1$var$_useSlot.default)('staticTooltip', {
        elementType: $ceac721f7000e3b1$var$SpeedDialActionStaticTooltip,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        ref: ref,
        className: classes.staticTooltip,
        additionalProps: {
            id: id
        }
    });
    const [StaticTooltipLabelSlot, staticTooltipLabelSlotProps] = (0, $ceac721f7000e3b1$var$_useSlot.default)('staticTooltipLabel', {
        elementType: $ceac721f7000e3b1$var$SpeedDialActionStaticTooltipLabel,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.staticTooltipLabel,
        additionalProps: {
            style: transitionStyle,
            id: `${id}-label`
        }
    });
    const fab = /*#__PURE__*/ (0, $ayMG0.jsx)(FabSlot, {
        ...fabSlotProps,
        children: icon
    });
    if (tooltipSlotProps.open) return /*#__PURE__*/ (0, $ayMG0.jsxs)(StaticTooltipSlot, {
        ...staticTooltipSlotProps,
        ...other,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(StaticTooltipLabelSlot, {
                ...staticTooltipLabelSlotProps,
                children: tooltipSlotProps.title
            }),
            /*#__PURE__*/ $ceac721f7000e3b1$var$React.cloneElement(fab, {
                'aria-labelledby': `${id}-label`
            })
        ]
    });
    if (!open && tooltipOpen) setTooltipOpen(false);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TooltipSlot, {
        ...tooltipSlotProps,
        title: tooltipSlotProps.title,
        open: open && tooltipOpen,
        placement: tooltipSlotProps.placement,
        classes: tooltipSlotProps.classes,
        ...other,
        children: fab
    });
});
$ceac721f7000e3b1$var$SpeedDialAction.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Override or extend the styles applied to the component.
   */ classes: $ceac721f7000e3b1$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $ceac721f7000e3b1$var$_propTypes.default.string,
    /**
   * Adds a transition delay, to allow a series of SpeedDialActions to be animated.
   * @default 0
   */ delay: $ceac721f7000e3b1$var$_propTypes.default.number,
    /**
   * Props applied to the [`Fab`](https://mui.com/material-ui/api/fab/) component.
   * @default {}
   * @deprecated Use `slotProps.fab` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ FabProps: $ceac721f7000e3b1$var$_propTypes.default.object,
    /**
   * The icon to display in the SpeedDial Fab.
   */ icon: $ceac721f7000e3b1$var$_propTypes.default.node,
    /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */ id: $ceac721f7000e3b1$var$_propTypes.default.string,
    /**
   * If `true`, the component is shown.
   */ open: $ceac721f7000e3b1$var$_propTypes.default.bool,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $ceac721f7000e3b1$var$_propTypes.default.shape({
        fab: $ceac721f7000e3b1$var$_propTypes.default.oneOfType([
            $ceac721f7000e3b1$var$_propTypes.default.func,
            $ceac721f7000e3b1$var$_propTypes.default.object
        ]),
        staticTooltip: $ceac721f7000e3b1$var$_propTypes.default.oneOfType([
            $ceac721f7000e3b1$var$_propTypes.default.func,
            $ceac721f7000e3b1$var$_propTypes.default.object
        ]),
        staticTooltipLabel: $ceac721f7000e3b1$var$_propTypes.default.oneOfType([
            $ceac721f7000e3b1$var$_propTypes.default.func,
            $ceac721f7000e3b1$var$_propTypes.default.object
        ]),
        tooltip: $ceac721f7000e3b1$var$_propTypes.default.oneOfType([
            $ceac721f7000e3b1$var$_propTypes.default.func,
            $ceac721f7000e3b1$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: $ceac721f7000e3b1$var$_propTypes.default.shape({
        fab: $ceac721f7000e3b1$var$_propTypes.default.elementType,
        staticTooltip: $ceac721f7000e3b1$var$_propTypes.default.elementType,
        staticTooltipLabel: $ceac721f7000e3b1$var$_propTypes.default.elementType,
        tooltip: $ceac721f7000e3b1$var$_propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $ceac721f7000e3b1$var$_propTypes.default.oneOfType([
        $ceac721f7000e3b1$var$_propTypes.default.arrayOf($ceac721f7000e3b1$var$_propTypes.default.oneOfType([
            $ceac721f7000e3b1$var$_propTypes.default.func,
            $ceac721f7000e3b1$var$_propTypes.default.object,
            $ceac721f7000e3b1$var$_propTypes.default.bool
        ])),
        $ceac721f7000e3b1$var$_propTypes.default.func,
        $ceac721f7000e3b1$var$_propTypes.default.object
    ]),
    /**
   * `classes` prop applied to the [`Tooltip`](https://mui.com/material-ui/api/tooltip/) element.
   * @deprecated Use `slotProps.tooltip.classes` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ TooltipClasses: $ceac721f7000e3b1$var$_propTypes.default.object,
    /**
   * Make the tooltip always visible when the SpeedDial is open.
   * @default false
   * @deprecated Use `slotProps.tooltip.open` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ tooltipOpen: $ceac721f7000e3b1$var$_propTypes.default.bool,
    /**
   * Placement of the tooltip.
   * @default 'left'
   * @deprecated Use `slotProps.tooltip.placement` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ tooltipPlacement: $ceac721f7000e3b1$var$_propTypes.default.oneOf([
        'auto-end',
        'auto-start',
        'auto',
        'bottom-end',
        'bottom-start',
        'bottom',
        'left-end',
        'left-start',
        'left',
        'right-end',
        'right-start',
        'right',
        'top-end',
        'top-start',
        'top'
    ]),
    /**
   * Label to display in the tooltip.
   * @deprecated Use `slotProps.tooltip.title` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ tooltipTitle: $ceac721f7000e3b1$var$_propTypes.default.node
};
var $ceac721f7000e3b1$var$_default = module.exports.default = $ceac721f7000e3b1$var$SpeedDialAction;

});
parcelRegister("iTcEP", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $dc072e92edbac389$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getSpeedDialActionUtilityClass = $dc072e92edbac389$var$getSpeedDialActionUtilityClass;

var $dc072e92edbac389$var$_generateUtilityClasses = $dc072e92edbac389$require$_interopRequireDefault((parcelRequire("5nY49")));

var $dc072e92edbac389$var$_generateUtilityClass = $dc072e92edbac389$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $dc072e92edbac389$var$getSpeedDialActionUtilityClass(slot) {
    return (0, $dc072e92edbac389$var$_generateUtilityClass.default)('MuiSpeedDialAction', slot);
}
const $dc072e92edbac389$var$speedDialActionClasses = (0, $dc072e92edbac389$var$_generateUtilityClasses.default)('MuiSpeedDialAction', [
    'fab',
    'fabClosed',
    'staticTooltip',
    'staticTooltipClosed',
    'staticTooltipLabel',
    'tooltipPlacementLeft',
    'tooltipPlacementRight'
]);
var $dc072e92edbac389$var$_default = module.exports.default = $dc072e92edbac389$var$speedDialActionClasses;

});



parcelRegister("6LxK9", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $4ed14e9d13fe3bbe$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $4ed14e9d13fe3bbe$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $4ed14e9d13fe3bbe$var$_exportNames = {
    speedDialIconClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $4ed14e9d13fe3bbe$var$_SpeedDialIcon.default;
    }
});
Object.defineProperty(module.exports, "speedDialIconClasses", {
    enumerable: true,
    get: function() {
        return $4ed14e9d13fe3bbe$var$_speedDialIconClasses.default;
    }
});

var $4ed14e9d13fe3bbe$var$_SpeedDialIcon = $4ed14e9d13fe3bbe$require$_interopRequireDefault((parcelRequire("l7RMX")));

var $4ed14e9d13fe3bbe$var$_speedDialIconClasses = $4ed14e9d13fe3bbe$require$_interopRequireWildcard((parcelRequire("ePWG5")));
Object.keys($4ed14e9d13fe3bbe$var$_speedDialIconClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($4ed14e9d13fe3bbe$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $4ed14e9d13fe3bbe$var$_speedDialIconClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4ed14e9d13fe3bbe$var$_speedDialIconClasses[key];
        }
    });
});

});
parcelRegister("l7RMX", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $f613f9bdcf68845e$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $f613f9bdcf68845e$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f613f9bdcf68845e$var$React = $f613f9bdcf68845e$require$_interopRequireWildcard((parcelRequire("acw62")));

var $f613f9bdcf68845e$var$_propTypes = $f613f9bdcf68845e$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $f613f9bdcf68845e$var$_clsx = $f613f9bdcf68845e$require$_interopRequireDefault((parcelRequire("9QePP")));

var $f613f9bdcf68845e$var$_composeClasses = $f613f9bdcf68845e$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $f613f9bdcf68845e$var$_memoTheme = $f613f9bdcf68845e$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $f613f9bdcf68845e$var$_Add = $f613f9bdcf68845e$require$_interopRequireDefault((parcelRequire("3nzbA")));

var $f613f9bdcf68845e$var$_speedDialIconClasses = $f613f9bdcf68845e$require$_interopRequireWildcard((parcelRequire("ePWG5")));

var $ayMG0 = parcelRequire("ayMG0");
const $f613f9bdcf68845e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, open: open, openIcon: openIcon } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        icon: [
            'icon',
            open && 'iconOpen',
            openIcon && open && 'iconWithOpenIconOpen'
        ],
        openIcon: [
            'openIcon',
            open && 'openIconOpen'
        ]
    };
    return (0, $f613f9bdcf68845e$var$_composeClasses.default)(slots, $f613f9bdcf68845e$var$_speedDialIconClasses.getSpeedDialIconUtilityClass, classes);
};
const $f613f9bdcf68845e$var$SpeedDialIconRoot = (0, $aAbgT.styled)('span', {
    name: 'MuiSpeedDialIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${$f613f9bdcf68845e$var$_speedDialIconClasses.default.icon}`]: styles.icon
            },
            {
                [`& .${$f613f9bdcf68845e$var$_speedDialIconClasses.default.icon}`]: ownerState.open && styles.iconOpen
            },
            {
                [`& .${$f613f9bdcf68845e$var$_speedDialIconClasses.default.icon}`]: ownerState.open && ownerState.openIcon && styles.iconWithOpenIconOpen
            },
            {
                [`& .${$f613f9bdcf68845e$var$_speedDialIconClasses.default.openIcon}`]: styles.openIcon
            },
            {
                [`& .${$f613f9bdcf68845e$var$_speedDialIconClasses.default.openIcon}`]: ownerState.open && styles.openIconOpen
            },
            styles.root
        ];
    }
})((0, $f613f9bdcf68845e$var$_memoTheme.default)(({ theme: theme })=>({
        height: 24,
        [`& .${$f613f9bdcf68845e$var$_speedDialIconClasses.default.icon}`]: {
            transition: theme.transitions.create([
                'transform',
                'opacity'
            ], {
                duration: theme.transitions.duration.short
            })
        },
        [`& .${$f613f9bdcf68845e$var$_speedDialIconClasses.default.openIcon}`]: {
            position: 'absolute',
            transition: theme.transitions.create([
                'transform',
                'opacity'
            ], {
                duration: theme.transitions.duration.short
            }),
            opacity: 0,
            transform: 'rotate(-45deg)'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.open,
                style: {
                    [`& .${$f613f9bdcf68845e$var$_speedDialIconClasses.default.icon}`]: {
                        transform: 'rotate(45deg)'
                    },
                    [`& .${$f613f9bdcf68845e$var$_speedDialIconClasses.default.openIcon}`]: {
                        transform: 'rotate(0deg)',
                        opacity: 1
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.open && ownerState.openIcon,
                style: {
                    [`& .${$f613f9bdcf68845e$var$_speedDialIconClasses.default.icon}`]: {
                        opacity: 0
                    }
                }
            }
        ]
    })));
const $f613f9bdcf68845e$var$SpeedDialIcon = /*#__PURE__*/ $f613f9bdcf68845e$var$React.forwardRef(function SpeedDialIcon(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiSpeedDialIcon'
    });
    const { className: className, icon: iconProp, open: open, openIcon: openIconProp, ...other } = props;
    const ownerState = props;
    const classes = $f613f9bdcf68845e$var$useUtilityClasses(ownerState);
    function formatIcon(icon, newClassName) {
        if (/*#__PURE__*/ $f613f9bdcf68845e$var$React.isValidElement(icon)) return /*#__PURE__*/ $f613f9bdcf68845e$var$React.cloneElement(icon, {
            className: newClassName
        });
        return icon;
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($f613f9bdcf68845e$var$SpeedDialIconRoot, {
        className: (0, $f613f9bdcf68845e$var$_clsx.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other,
        children: [
            openIconProp ? formatIcon(openIconProp, classes.openIcon) : null,
            iconProp ? formatIcon(iconProp, classes.icon) : /*#__PURE__*/ (0, $ayMG0.jsx)($f613f9bdcf68845e$var$_Add.default, {
                className: classes.icon
            })
        ]
    });
});
$f613f9bdcf68845e$var$SpeedDialIcon.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Override or extend the styles applied to the component.
   */ classes: $f613f9bdcf68845e$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $f613f9bdcf68845e$var$_propTypes.default.string,
    /**
   * The icon to display.
   */ icon: $f613f9bdcf68845e$var$_propTypes.default.node,
    /**
   * @ignore
   * If `true`, the component is shown.
   */ open: $f613f9bdcf68845e$var$_propTypes.default.bool,
    /**
   * The icon to display in the SpeedDial Floating Action Button when the SpeedDial is open.
   */ openIcon: $f613f9bdcf68845e$var$_propTypes.default.node,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $f613f9bdcf68845e$var$_propTypes.default.oneOfType([
        $f613f9bdcf68845e$var$_propTypes.default.arrayOf($f613f9bdcf68845e$var$_propTypes.default.oneOfType([
            $f613f9bdcf68845e$var$_propTypes.default.func,
            $f613f9bdcf68845e$var$_propTypes.default.object,
            $f613f9bdcf68845e$var$_propTypes.default.bool
        ])),
        $f613f9bdcf68845e$var$_propTypes.default.func,
        $f613f9bdcf68845e$var$_propTypes.default.object
    ])
};
$f613f9bdcf68845e$var$SpeedDialIcon.muiName = 'SpeedDialIcon';
var $f613f9bdcf68845e$var$_default = module.exports.default = $f613f9bdcf68845e$var$SpeedDialIcon;

});
parcelRegister("3nzbA", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hGPki = parcelRequire("hGPki");

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $275ed03e426ba761$var$_default = module.exports.default = (0, $hGPki.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), 'Add');

});

parcelRegister("ePWG5", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $acd358505730020e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getSpeedDialIconUtilityClass = $acd358505730020e$var$getSpeedDialIconUtilityClass;

var $acd358505730020e$var$_generateUtilityClasses = $acd358505730020e$require$_interopRequireDefault((parcelRequire("5nY49")));

var $acd358505730020e$var$_generateUtilityClass = $acd358505730020e$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $acd358505730020e$var$getSpeedDialIconUtilityClass(slot) {
    return (0, $acd358505730020e$var$_generateUtilityClass.default)('MuiSpeedDialIcon', slot);
}
const $acd358505730020e$var$speedDialIconClasses = (0, $acd358505730020e$var$_generateUtilityClasses.default)('MuiSpeedDialIcon', [
    'root',
    'icon',
    'iconOpen',
    'iconWithOpenIconOpen',
    'openIcon',
    'openIconOpen'
]);
var $acd358505730020e$var$_default = module.exports.default = $acd358505730020e$var$speedDialIconClasses;

});



parcelRegister("jkhql", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e11d669415a30ea5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $e11d669415a30ea5$var$_Stack.default;
    }
});
Object.defineProperty(module.exports, "stackClasses", {
    enumerable: true,
    get: function() {
        return $e11d669415a30ea5$var$_stackClasses.default;
    }
});

var $e11d669415a30ea5$var$_Stack = $e11d669415a30ea5$require$_interopRequireDefault((parcelRequire("30UGG")));

var $e11d669415a30ea5$var$_stackClasses = $e11d669415a30ea5$require$_interopRequireDefault((parcelRequire("axvsV")));

});
parcelRegister("30UGG", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $231d58234d437bc0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $231d58234d437bc0$var$_propTypes = $231d58234d437bc0$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $izOUK = parcelRequire("izOUK");

var $231d58234d437bc0$var$_styled = $231d58234d437bc0$require$_interopRequireDefault((parcelRequire("d8seH")));

var $hL1nr = parcelRequire("hL1nr");
const $231d58234d437bc0$var$Stack = (0, $izOUK.createStack)({
    createStyledComponent: (0, $231d58234d437bc0$var$_styled.default)('div', {
        name: 'MuiStack',
        slot: 'Root'
    }),
    useThemeProps: (inProps)=>(0, $hL1nr.useDefaultProps)({
            props: inProps,
            name: 'MuiStack'
        })
});
$231d58234d437bc0$var$Stack.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: $231d58234d437bc0$var$_propTypes.default.node,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $231d58234d437bc0$var$_propTypes.default.elementType,
    /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'column'
   */ direction: $231d58234d437bc0$var$_propTypes.default.oneOfType([
        $231d58234d437bc0$var$_propTypes.default.oneOf([
            'column-reverse',
            'column',
            'row-reverse',
            'row'
        ]),
        $231d58234d437bc0$var$_propTypes.default.arrayOf($231d58234d437bc0$var$_propTypes.default.oneOf([
            'column-reverse',
            'column',
            'row-reverse',
            'row'
        ])),
        $231d58234d437bc0$var$_propTypes.default.object
    ]),
    /**
   * Add an element between each child.
   */ divider: $231d58234d437bc0$var$_propTypes.default.node,
    /**
   * Defines the space between immediate children.
   * @default 0
   */ spacing: $231d58234d437bc0$var$_propTypes.default.oneOfType([
        $231d58234d437bc0$var$_propTypes.default.arrayOf($231d58234d437bc0$var$_propTypes.default.oneOfType([
            $231d58234d437bc0$var$_propTypes.default.number,
            $231d58234d437bc0$var$_propTypes.default.string
        ])),
        $231d58234d437bc0$var$_propTypes.default.number,
        $231d58234d437bc0$var$_propTypes.default.object,
        $231d58234d437bc0$var$_propTypes.default.string
    ]),
    /**
   * The system prop, which allows defining system overrides as well as additional CSS styles.
   */ sx: $231d58234d437bc0$var$_propTypes.default.oneOfType([
        $231d58234d437bc0$var$_propTypes.default.arrayOf($231d58234d437bc0$var$_propTypes.default.oneOfType([
            $231d58234d437bc0$var$_propTypes.default.func,
            $231d58234d437bc0$var$_propTypes.default.object,
            $231d58234d437bc0$var$_propTypes.default.bool
        ])),
        $231d58234d437bc0$var$_propTypes.default.func,
        $231d58234d437bc0$var$_propTypes.default.object
    ]),
    /**
   * If `true`, the CSS flexbox `gap` is used instead of applying `margin` to children.
   *
   * While CSS `gap` removes the [known limitations](https://mui.com/joy-ui/react-stack/#limitations),
   * it is not fully supported in some browsers. We recommend checking https://caniuse.com/?search=flex%20gap before using this flag.
   *
   * To enable this flag globally, follow the [theme's default props](https://mui.com/material-ui/customization/theme-components/#default-props) configuration.
   * @default false
   */ useFlexGap: $231d58234d437bc0$var$_propTypes.default.bool
};
var $231d58234d437bc0$var$_default = module.exports.default = $231d58234d437bc0$var$Stack;

});

parcelRegister("axvsV", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $7ac564dc7b213020$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getStackUtilityClass = $7ac564dc7b213020$var$getStackUtilityClass;

var $7ac564dc7b213020$var$_generateUtilityClasses = $7ac564dc7b213020$require$_interopRequireDefault((parcelRequire("5nY49")));

var $7ac564dc7b213020$var$_generateUtilityClass = $7ac564dc7b213020$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $7ac564dc7b213020$var$getStackUtilityClass(slot) {
    return (0, $7ac564dc7b213020$var$_generateUtilityClass.default)('MuiStack', slot);
}
const $7ac564dc7b213020$var$stackClasses = (0, $7ac564dc7b213020$var$_generateUtilityClasses.default)('MuiStack', [
    'root'
]);
var $7ac564dc7b213020$var$_default = module.exports.default = $7ac564dc7b213020$var$stackClasses;

});


parcelRegister("fxSW4", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $b5148d23ad5d90bb$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $b5148d23ad5d90bb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $b5148d23ad5d90bb$var$_exportNames = {
    stepClasses: true,
    StepContext: true
};
Object.defineProperty(module.exports, "StepContext", {
    enumerable: true,
    get: function() {
        return $b5148d23ad5d90bb$var$_StepContext.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $b5148d23ad5d90bb$var$_Step.default;
    }
});
Object.defineProperty(module.exports, "stepClasses", {
    enumerable: true,
    get: function() {
        return $b5148d23ad5d90bb$var$_stepClasses.default;
    }
});

var $b5148d23ad5d90bb$var$_Step = $b5148d23ad5d90bb$require$_interopRequireDefault((parcelRequire("lttiO")));

var $b5148d23ad5d90bb$var$_stepClasses = $b5148d23ad5d90bb$require$_interopRequireWildcard((parcelRequire("bspH3")));
Object.keys($b5148d23ad5d90bb$var$_stepClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($b5148d23ad5d90bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $b5148d23ad5d90bb$var$_stepClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b5148d23ad5d90bb$var$_stepClasses[key];
        }
    });
});

var $b5148d23ad5d90bb$var$_StepContext = $b5148d23ad5d90bb$require$_interopRequireWildcard((parcelRequire("jrw2p")));
Object.keys($b5148d23ad5d90bb$var$_StepContext).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($b5148d23ad5d90bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $b5148d23ad5d90bb$var$_StepContext[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b5148d23ad5d90bb$var$_StepContext[key];
        }
    });
});

});
parcelRegister("lttiO", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $fa230948139f2492$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $fa230948139f2492$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fa230948139f2492$var$React = $fa230948139f2492$require$_interopRequireWildcard((parcelRequire("acw62")));

var $fa230948139f2492$var$_propTypes = $fa230948139f2492$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $fa230948139f2492$var$_clsx = $fa230948139f2492$require$_interopRequireDefault((parcelRequire("9QePP")));

var $fa230948139f2492$var$_integerPropType = $fa230948139f2492$require$_interopRequireDefault((parcelRequire("cxaSP")));

var $fa230948139f2492$var$_composeClasses = $fa230948139f2492$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $fa230948139f2492$var$_StepperContext = $fa230948139f2492$require$_interopRequireDefault((parcelRequire("8c8ll")));

var $fa230948139f2492$var$_StepContext = $fa230948139f2492$require$_interopRequireDefault((parcelRequire("jrw2p")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $bspH3 = parcelRequire("bspH3");

var $ayMG0 = parcelRequire("ayMG0");
const $fa230948139f2492$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, alternativeLabel: alternativeLabel, completed: completed } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            alternativeLabel && 'alternativeLabel',
            completed && 'completed'
        ]
    };
    return (0, $fa230948139f2492$var$_composeClasses.default)(slots, $bspH3.getStepUtilityClass, classes);
};
const $fa230948139f2492$var$StepRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiStep',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.alternativeLabel && styles.alternativeLabel,
            ownerState.completed && styles.completed
        ];
    }
})({
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                paddingLeft: 8,
                paddingRight: 8
            }
        },
        {
            props: {
                alternativeLabel: true
            },
            style: {
                flex: 1,
                position: 'relative'
            }
        }
    ]
});
const $fa230948139f2492$var$Step = /*#__PURE__*/ $fa230948139f2492$var$React.forwardRef(function Step(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiStep'
    });
    const { active: activeProp, children: children, className: className, component: component = 'div', completed: completedProp, disabled: disabledProp, expanded: expanded = false, index: index, last: last, ...other } = props;
    const { activeStep: activeStep, connector: connector, alternativeLabel: alternativeLabel, orientation: orientation, nonLinear: nonLinear } = $fa230948139f2492$var$React.useContext($fa230948139f2492$var$_StepperContext.default);
    let [active = false, completed = false, disabled = false] = [
        activeProp,
        completedProp,
        disabledProp
    ];
    if (activeStep === index) active = activeProp !== undefined ? activeProp : true;
    else if (!nonLinear && activeStep > index) completed = completedProp !== undefined ? completedProp : true;
    else if (!nonLinear && activeStep < index) disabled = disabledProp !== undefined ? disabledProp : true;
    const contextValue = $fa230948139f2492$var$React.useMemo(()=>({
            index: index,
            last: last,
            expanded: expanded,
            icon: index + 1,
            active: active,
            completed: completed,
            disabled: disabled
        }), [
        index,
        last,
        expanded,
        active,
        completed,
        disabled
    ]);
    const ownerState = {
        ...props,
        active: active,
        orientation: orientation,
        alternativeLabel: alternativeLabel,
        completed: completed,
        disabled: disabled,
        expanded: expanded,
        component: component
    };
    const classes = $fa230948139f2492$var$useUtilityClasses(ownerState);
    const newChildren = /*#__PURE__*/ (0, $ayMG0.jsxs)($fa230948139f2492$var$StepRoot, {
        as: component,
        className: (0, $fa230948139f2492$var$_clsx.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other,
        children: [
            connector && alternativeLabel && index !== 0 ? connector : null,
            children
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($fa230948139f2492$var$_StepContext.default.Provider, {
        value: contextValue,
        children: connector && !alternativeLabel && index !== 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)($fa230948139f2492$var$React.Fragment, {
            children: [
                connector,
                newChildren
            ]
        }) : newChildren
    });
});
$fa230948139f2492$var$Step.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Sets the step as active. Is passed to child components.
   */ active: $fa230948139f2492$var$_propTypes.default.bool,
    /**
   * Should be `Step` sub-components such as `StepLabel`, `StepContent`.
   */ children: $fa230948139f2492$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $fa230948139f2492$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $fa230948139f2492$var$_propTypes.default.string,
    /**
   * Mark the step as completed. Is passed to child components.
   */ completed: $fa230948139f2492$var$_propTypes.default.bool,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $fa230948139f2492$var$_propTypes.default.elementType,
    /**
   * If `true`, the step is disabled, will also disable the button if
   * `StepButton` is a child of `Step`. Is passed to child components.
   */ disabled: $fa230948139f2492$var$_propTypes.default.bool,
    /**
   * Expand the step.
   * @default false
   */ expanded: $fa230948139f2492$var$_propTypes.default.bool,
    /**
   * The position of the step.
   * The prop defaults to the value inherited from the parent Stepper component.
   */ index: $fa230948139f2492$var$_integerPropType.default,
    /**
   * If `true`, the Step is displayed as rendered last.
   * The prop defaults to the value inherited from the parent Stepper component.
   */ last: $fa230948139f2492$var$_propTypes.default.bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $fa230948139f2492$var$_propTypes.default.oneOfType([
        $fa230948139f2492$var$_propTypes.default.arrayOf($fa230948139f2492$var$_propTypes.default.oneOfType([
            $fa230948139f2492$var$_propTypes.default.func,
            $fa230948139f2492$var$_propTypes.default.object,
            $fa230948139f2492$var$_propTypes.default.bool
        ])),
        $fa230948139f2492$var$_propTypes.default.func,
        $fa230948139f2492$var$_propTypes.default.object
    ])
};
var $fa230948139f2492$var$_default = module.exports.default = $fa230948139f2492$var$Step;

});
parcelRegister("8c8ll", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $5f75ea7f43c8474b$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.useStepperContext = $5f75ea7f43c8474b$var$useStepperContext;

var $5f75ea7f43c8474b$var$React = $5f75ea7f43c8474b$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * Provides information about the current step in Stepper.
 */ const $5f75ea7f43c8474b$var$StepperContext = /*#__PURE__*/ $5f75ea7f43c8474b$var$React.createContext({});
$5f75ea7f43c8474b$var$StepperContext.displayName = 'StepperContext';
/**
 * Returns the current StepperContext or an empty object if no StepperContext
 * has been defined in the component tree.
 */ function $5f75ea7f43c8474b$var$useStepperContext() {
    return $5f75ea7f43c8474b$var$React.useContext($5f75ea7f43c8474b$var$StepperContext);
}
var $5f75ea7f43c8474b$var$_default = module.exports.default = $5f75ea7f43c8474b$var$StepperContext;

});

parcelRegister("jrw2p", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $e279640208208f42$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.useStepContext = $e279640208208f42$var$useStepContext;

var $e279640208208f42$var$React = $e279640208208f42$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * Provides information about the current step in Stepper.
 */ const $e279640208208f42$var$StepContext = /*#__PURE__*/ $e279640208208f42$var$React.createContext({});
$e279640208208f42$var$StepContext.displayName = 'StepContext';
/**
 * Returns the current StepContext or an empty object if no StepContext
 * has been defined in the component tree.
 */ function $e279640208208f42$var$useStepContext() {
    return $e279640208208f42$var$React.useContext($e279640208208f42$var$StepContext);
}
var $e279640208208f42$var$_default = module.exports.default = $e279640208208f42$var$StepContext;

});

parcelRegister("bspH3", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $85763d6f4c7e74c7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getStepUtilityClass = $85763d6f4c7e74c7$var$getStepUtilityClass;

var $85763d6f4c7e74c7$var$_generateUtilityClasses = $85763d6f4c7e74c7$require$_interopRequireDefault((parcelRequire("5nY49")));

var $85763d6f4c7e74c7$var$_generateUtilityClass = $85763d6f4c7e74c7$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $85763d6f4c7e74c7$var$getStepUtilityClass(slot) {
    return (0, $85763d6f4c7e74c7$var$_generateUtilityClass.default)('MuiStep', slot);
}
const $85763d6f4c7e74c7$var$stepClasses = (0, $85763d6f4c7e74c7$var$_generateUtilityClasses.default)('MuiStep', [
    'root',
    'horizontal',
    'vertical',
    'alternativeLabel',
    'completed'
]);
var $85763d6f4c7e74c7$var$_default = module.exports.default = $85763d6f4c7e74c7$var$stepClasses;

});



parcelRegister("k1pY1", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $e9380b273cd6ee6d$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $e9380b273cd6ee6d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $e9380b273cd6ee6d$var$_exportNames = {
    stepButtonClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $e9380b273cd6ee6d$var$_StepButton.default;
    }
});
Object.defineProperty(module.exports, "stepButtonClasses", {
    enumerable: true,
    get: function() {
        return $e9380b273cd6ee6d$var$_stepButtonClasses.default;
    }
});

var $e9380b273cd6ee6d$var$_StepButton = $e9380b273cd6ee6d$require$_interopRequireDefault((parcelRequire("3s4fu")));

var $e9380b273cd6ee6d$var$_stepButtonClasses = $e9380b273cd6ee6d$require$_interopRequireWildcard((parcelRequire("3OtA2")));
Object.keys($e9380b273cd6ee6d$var$_stepButtonClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($e9380b273cd6ee6d$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $e9380b273cd6ee6d$var$_stepButtonClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $e9380b273cd6ee6d$var$_stepButtonClasses[key];
        }
    });
});

});
parcelRegister("3s4fu", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $2837485fb2fa495c$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $2837485fb2fa495c$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2837485fb2fa495c$var$React = $2837485fb2fa495c$require$_interopRequireWildcard((parcelRequire("acw62")));

var $2837485fb2fa495c$var$_propTypes = $2837485fb2fa495c$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $2837485fb2fa495c$var$_clsx = $2837485fb2fa495c$require$_interopRequireDefault((parcelRequire("9QePP")));

var $2837485fb2fa495c$var$_composeClasses = $2837485fb2fa495c$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $2837485fb2fa495c$var$_ButtonBase = $2837485fb2fa495c$require$_interopRequireDefault((parcelRequire("hhs3r")));

var $2837485fb2fa495c$var$_StepLabel = $2837485fb2fa495c$require$_interopRequireDefault((parcelRequire("cD4Pq")));

var $2837485fb2fa495c$var$_isMuiElement = $2837485fb2fa495c$require$_interopRequireDefault((parcelRequire("cpXNi")));

var $2837485fb2fa495c$var$_StepperContext = $2837485fb2fa495c$require$_interopRequireDefault((parcelRequire("8c8ll")));

var $2837485fb2fa495c$var$_StepContext = $2837485fb2fa495c$require$_interopRequireDefault((parcelRequire("jrw2p")));

var $2837485fb2fa495c$var$_stepButtonClasses = $2837485fb2fa495c$require$_interopRequireWildcard((parcelRequire("3OtA2")));

var $ayMG0 = parcelRequire("ayMG0");
const $2837485fb2fa495c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation } = ownerState;
    const slots = {
        root: [
            'root',
            orientation
        ],
        touchRipple: [
            'touchRipple'
        ]
    };
    return (0, $2837485fb2fa495c$var$_composeClasses.default)(slots, $2837485fb2fa495c$var$_stepButtonClasses.getStepButtonUtilityClass, classes);
};
const $2837485fb2fa495c$var$StepButtonRoot = (0, $aAbgT.styled)($2837485fb2fa495c$var$_ButtonBase.default, {
    name: 'MuiStepButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${$2837485fb2fa495c$var$_stepButtonClasses.default.touchRipple}`]: styles.touchRipple
            },
            styles.root,
            styles[ownerState.orientation]
        ];
    }
})({
    width: '100%',
    padding: '24px 16px',
    margin: '-24px -16px',
    boxSizing: 'content-box',
    [`& .${$2837485fb2fa495c$var$_stepButtonClasses.default.touchRipple}`]: {
        color: 'rgba(0, 0, 0, 0.3)'
    },
    variants: [
        {
            props: {
                orientation: 'vertical'
            },
            style: {
                justifyContent: 'flex-start',
                padding: '8px',
                margin: '-8px'
            }
        }
    ]
});
const $2837485fb2fa495c$var$StepButton = /*#__PURE__*/ $2837485fb2fa495c$var$React.forwardRef(function StepButton(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiStepButton'
    });
    const { children: children, className: className, icon: icon, optional: optional, ...other } = props;
    const { disabled: disabled, active: active } = $2837485fb2fa495c$var$React.useContext($2837485fb2fa495c$var$_StepContext.default);
    const { orientation: orientation } = $2837485fb2fa495c$var$React.useContext($2837485fb2fa495c$var$_StepperContext.default);
    const ownerState = {
        ...props,
        orientation: orientation
    };
    const classes = $2837485fb2fa495c$var$useUtilityClasses(ownerState);
    const childProps = {
        icon: icon,
        optional: optional
    };
    const child = (0, $2837485fb2fa495c$var$_isMuiElement.default)(children, [
        'StepLabel'
    ]) ? /*#__PURE__*/ $2837485fb2fa495c$var$React.cloneElement(children, childProps) : /*#__PURE__*/ (0, $ayMG0.jsx)($2837485fb2fa495c$var$_StepLabel.default, {
        ...childProps,
        children: children
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($2837485fb2fa495c$var$StepButtonRoot, {
        focusRipple: true,
        disabled: disabled,
        TouchRippleProps: {
            className: classes.touchRipple
        },
        className: (0, $2837485fb2fa495c$var$_clsx.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        "aria-current": active ? 'step' : undefined,
        ...other,
        children: child
    });
});
$2837485fb2fa495c$var$StepButton.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Can be a `StepLabel` or a node to place inside `StepLabel` as children.
   */ children: $2837485fb2fa495c$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $2837485fb2fa495c$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $2837485fb2fa495c$var$_propTypes.default.string,
    /**
   * The icon displayed by the step label.
   */ icon: $2837485fb2fa495c$var$_propTypes.default.node,
    /**
   * The optional node to display.
   */ optional: $2837485fb2fa495c$var$_propTypes.default.node,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $2837485fb2fa495c$var$_propTypes.default.oneOfType([
        $2837485fb2fa495c$var$_propTypes.default.arrayOf($2837485fb2fa495c$var$_propTypes.default.oneOfType([
            $2837485fb2fa495c$var$_propTypes.default.func,
            $2837485fb2fa495c$var$_propTypes.default.object,
            $2837485fb2fa495c$var$_propTypes.default.bool
        ])),
        $2837485fb2fa495c$var$_propTypes.default.func,
        $2837485fb2fa495c$var$_propTypes.default.object
    ])
};
var $2837485fb2fa495c$var$_default = module.exports.default = $2837485fb2fa495c$var$StepButton;

});
parcelRegister("cD4Pq", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $931cdf5c02131bb6$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $931cdf5c02131bb6$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $931cdf5c02131bb6$var$_exportNames = {
    stepLabelClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $931cdf5c02131bb6$var$_StepLabel.default;
    }
});
Object.defineProperty(module.exports, "stepLabelClasses", {
    enumerable: true,
    get: function() {
        return $931cdf5c02131bb6$var$_stepLabelClasses.default;
    }
});

var $931cdf5c02131bb6$var$_StepLabel = $931cdf5c02131bb6$require$_interopRequireDefault((parcelRequire("e2Az3")));

var $931cdf5c02131bb6$var$_stepLabelClasses = $931cdf5c02131bb6$require$_interopRequireWildcard((parcelRequire("avvt2")));
Object.keys($931cdf5c02131bb6$var$_stepLabelClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($931cdf5c02131bb6$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $931cdf5c02131bb6$var$_stepLabelClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $931cdf5c02131bb6$var$_stepLabelClasses[key];
        }
    });
});

});
parcelRegister("e2Az3", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $a38d9d8360b02e78$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $a38d9d8360b02e78$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a38d9d8360b02e78$var$_composeClasses = $a38d9d8360b02e78$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $a38d9d8360b02e78$var$_clsx = $a38d9d8360b02e78$require$_interopRequireDefault((parcelRequire("9QePP")));

var $a38d9d8360b02e78$var$_propTypes = $a38d9d8360b02e78$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $a38d9d8360b02e78$var$React = $a38d9d8360b02e78$require$_interopRequireWildcard((parcelRequire("acw62")));

var $a38d9d8360b02e78$var$_StepContext = $a38d9d8360b02e78$require$_interopRequireDefault((parcelRequire("jrw2p")));

var $a38d9d8360b02e78$var$_StepIcon = $a38d9d8360b02e78$require$_interopRequireDefault((parcelRequire("2K1qt")));

var $a38d9d8360b02e78$var$_StepperContext = $a38d9d8360b02e78$require$_interopRequireDefault((parcelRequire("8c8ll")));

var $aAbgT = parcelRequire("aAbgT");

var $a38d9d8360b02e78$var$_memoTheme = $a38d9d8360b02e78$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $a38d9d8360b02e78$var$_stepLabelClasses = $a38d9d8360b02e78$require$_interopRequireWildcard((parcelRequire("avvt2")));

var $a38d9d8360b02e78$var$_useSlot = $a38d9d8360b02e78$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $a38d9d8360b02e78$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, active: active, completed: completed, error: error, disabled: disabled, alternativeLabel: alternativeLabel } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            error && 'error',
            disabled && 'disabled',
            alternativeLabel && 'alternativeLabel'
        ],
        label: [
            'label',
            active && 'active',
            completed && 'completed',
            error && 'error',
            disabled && 'disabled',
            alternativeLabel && 'alternativeLabel'
        ],
        iconContainer: [
            'iconContainer',
            active && 'active',
            completed && 'completed',
            error && 'error',
            disabled && 'disabled',
            alternativeLabel && 'alternativeLabel'
        ],
        labelContainer: [
            'labelContainer',
            alternativeLabel && 'alternativeLabel'
        ]
    };
    return (0, $a38d9d8360b02e78$var$_composeClasses.default)(slots, $a38d9d8360b02e78$var$_stepLabelClasses.getStepLabelUtilityClass, classes);
};
const $a38d9d8360b02e78$var$StepLabelRoot = (0, $aAbgT.styled)('span', {
    name: 'MuiStepLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation]
        ];
    }
})({
    display: 'flex',
    alignItems: 'center',
    [`&.${$a38d9d8360b02e78$var$_stepLabelClasses.default.alternativeLabel}`]: {
        flexDirection: 'column'
    },
    [`&.${$a38d9d8360b02e78$var$_stepLabelClasses.default.disabled}`]: {
        cursor: 'default'
    },
    variants: [
        {
            props: {
                orientation: 'vertical'
            },
            style: {
                textAlign: 'left',
                padding: '8px 0'
            }
        }
    ]
});
const $a38d9d8360b02e78$var$StepLabelLabel = (0, $aAbgT.styled)('span', {
    name: 'MuiStepLabel',
    slot: 'Label'
})((0, $a38d9d8360b02e78$var$_memoTheme.default)(({ theme: theme })=>({
        ...theme.typography.body2,
        display: 'block',
        transition: theme.transitions.create('color', {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${$a38d9d8360b02e78$var$_stepLabelClasses.default.active}, &.${$a38d9d8360b02e78$var$_stepLabelClasses.default.completed}`]: {
            color: (theme.vars || theme).palette.text.primary,
            fontWeight: 500
        },
        [`&.${$a38d9d8360b02e78$var$_stepLabelClasses.default.alternativeLabel}`]: {
            marginTop: 16
        },
        [`&.${$a38d9d8360b02e78$var$_stepLabelClasses.default.error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
const $a38d9d8360b02e78$var$StepLabelIconContainer = (0, $aAbgT.styled)('span', {
    name: 'MuiStepLabel',
    slot: 'IconContainer'
})({
    flexShrink: 0,
    display: 'flex',
    paddingRight: 8,
    [`&.${$a38d9d8360b02e78$var$_stepLabelClasses.default.alternativeLabel}`]: {
        paddingRight: 0
    }
});
const $a38d9d8360b02e78$var$StepLabelLabelContainer = (0, $aAbgT.styled)('span', {
    name: 'MuiStepLabel',
    slot: 'LabelContainer'
})((0, $a38d9d8360b02e78$var$_memoTheme.default)(({ theme: theme })=>({
        width: '100%',
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${$a38d9d8360b02e78$var$_stepLabelClasses.default.alternativeLabel}`]: {
            textAlign: 'center'
        }
    })));
const $a38d9d8360b02e78$var$StepLabel = /*#__PURE__*/ $a38d9d8360b02e78$var$React.forwardRef(function StepLabel(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiStepLabel'
    });
    const { children: children, className: className, componentsProps: componentsProps = {}, error: error = false, icon: iconProp, optional: optional, slots: slots = {}, slotProps: slotProps = {}, StepIconComponent: StepIconComponentProp, StepIconProps: StepIconProps, ...other } = props;
    const { alternativeLabel: alternativeLabel, orientation: orientation } = $a38d9d8360b02e78$var$React.useContext($a38d9d8360b02e78$var$_StepperContext.default);
    const { active: active, disabled: disabled, completed: completed, icon: iconContext } = $a38d9d8360b02e78$var$React.useContext($a38d9d8360b02e78$var$_StepContext.default);
    const icon = iconProp || iconContext;
    let StepIconComponent = StepIconComponentProp;
    if (icon && !StepIconComponent) StepIconComponent = $a38d9d8360b02e78$var$_StepIcon.default;
    const ownerState = {
        ...props,
        active: active,
        alternativeLabel: alternativeLabel,
        completed: completed,
        disabled: disabled,
        error: error,
        orientation: orientation
    };
    const classes = $a38d9d8360b02e78$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            stepIcon: StepIconProps,
            ...componentsProps,
            ...slotProps
        }
    };
    const [RootSlot, rootProps] = (0, $a38d9d8360b02e78$var$_useSlot.default)('root', {
        elementType: $a38d9d8360b02e78$var$StepLabelRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        ref: ref,
        className: (0, $a38d9d8360b02e78$var$_clsx.default)(classes.root, className)
    });
    const [LabelSlot, labelProps] = (0, $a38d9d8360b02e78$var$_useSlot.default)('label', {
        elementType: $a38d9d8360b02e78$var$StepLabelLabel,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [StepIconSlot, stepIconProps] = (0, $a38d9d8360b02e78$var$_useSlot.default)('stepIcon', {
        elementType: StepIconComponent,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            icon || StepIconSlot ? /*#__PURE__*/ (0, $ayMG0.jsx)($a38d9d8360b02e78$var$StepLabelIconContainer, {
                className: classes.iconContainer,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(StepIconSlot, {
                    completed: completed,
                    active: active,
                    error: error,
                    icon: icon,
                    ...stepIconProps
                })
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)($a38d9d8360b02e78$var$StepLabelLabelContainer, {
                className: classes.labelContainer,
                ownerState: ownerState,
                children: [
                    children ? /*#__PURE__*/ (0, $ayMG0.jsx)(LabelSlot, {
                        ...labelProps,
                        className: (0, $a38d9d8360b02e78$var$_clsx.default)(classes.label, labelProps?.className),
                        children: children
                    }) : null,
                    optional
                ]
            })
        ]
    });
});
$a38d9d8360b02e78$var$StepLabel.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * In most cases will simply be a string containing a title for the label.
   */ children: $a38d9d8360b02e78$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $a38d9d8360b02e78$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $a38d9d8360b02e78$var$_propTypes.default.string,
    /**
   * The props used for each slot inside.
   * @default {}
   * @deprecated use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ componentsProps: $a38d9d8360b02e78$var$_propTypes.default.shape({
        label: $a38d9d8360b02e78$var$_propTypes.default.object
    }),
    /**
   * If `true`, the step is marked as failed.
   * @default false
   */ error: $a38d9d8360b02e78$var$_propTypes.default.bool,
    /**
   * Override the default label of the step icon.
   */ icon: $a38d9d8360b02e78$var$_propTypes.default.node,
    /**
   * The optional node to display.
   */ optional: $a38d9d8360b02e78$var$_propTypes.default.node,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $a38d9d8360b02e78$var$_propTypes.default.shape({
        label: $a38d9d8360b02e78$var$_propTypes.default.oneOfType([
            $a38d9d8360b02e78$var$_propTypes.default.func,
            $a38d9d8360b02e78$var$_propTypes.default.object
        ]),
        root: $a38d9d8360b02e78$var$_propTypes.default.oneOfType([
            $a38d9d8360b02e78$var$_propTypes.default.func,
            $a38d9d8360b02e78$var$_propTypes.default.object
        ]),
        stepIcon: $a38d9d8360b02e78$var$_propTypes.default.oneOfType([
            $a38d9d8360b02e78$var$_propTypes.default.func,
            $a38d9d8360b02e78$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: $a38d9d8360b02e78$var$_propTypes.default.shape({
        label: $a38d9d8360b02e78$var$_propTypes.default.elementType,
        root: $a38d9d8360b02e78$var$_propTypes.default.elementType,
        stepIcon: $a38d9d8360b02e78$var$_propTypes.default.elementType
    }),
    /**
   * The component to render in place of the [`StepIcon`](https://mui.com/material-ui/api/step-icon/).
   * @deprecated Use `slots.stepIcon` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ StepIconComponent: $a38d9d8360b02e78$var$_propTypes.default.elementType,
    /**
   * Props applied to the [`StepIcon`](https://mui.com/material-ui/api/step-icon/) element.
   * @deprecated Use `slotProps.stepIcon` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ StepIconProps: $a38d9d8360b02e78$var$_propTypes.default.object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $a38d9d8360b02e78$var$_propTypes.default.oneOfType([
        $a38d9d8360b02e78$var$_propTypes.default.arrayOf($a38d9d8360b02e78$var$_propTypes.default.oneOfType([
            $a38d9d8360b02e78$var$_propTypes.default.func,
            $a38d9d8360b02e78$var$_propTypes.default.object,
            $a38d9d8360b02e78$var$_propTypes.default.bool
        ])),
        $a38d9d8360b02e78$var$_propTypes.default.func,
        $a38d9d8360b02e78$var$_propTypes.default.object
    ])
};
$a38d9d8360b02e78$var$StepLabel.muiName = 'StepLabel';
var $a38d9d8360b02e78$var$_default = module.exports.default = $a38d9d8360b02e78$var$StepLabel;

});
parcelRegister("2K1qt", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $1ff0fbd06d13ad2a$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $1ff0fbd06d13ad2a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $1ff0fbd06d13ad2a$var$_exportNames = {
    stepIconClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $1ff0fbd06d13ad2a$var$_StepIcon.default;
    }
});
Object.defineProperty(module.exports, "stepIconClasses", {
    enumerable: true,
    get: function() {
        return $1ff0fbd06d13ad2a$var$_stepIconClasses.default;
    }
});

var $1ff0fbd06d13ad2a$var$_StepIcon = $1ff0fbd06d13ad2a$require$_interopRequireDefault((parcelRequire("NklxQ")));

var $1ff0fbd06d13ad2a$var$_stepIconClasses = $1ff0fbd06d13ad2a$require$_interopRequireWildcard((parcelRequire("7f59P")));
Object.keys($1ff0fbd06d13ad2a$var$_stepIconClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1ff0fbd06d13ad2a$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $1ff0fbd06d13ad2a$var$_stepIconClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1ff0fbd06d13ad2a$var$_stepIconClasses[key];
        }
    });
});

});
parcelRegister("NklxQ", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $09445c1bc5a83d17$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $09445c1bc5a83d17$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $09445c1bc5a83d17$var$React = $09445c1bc5a83d17$require$_interopRequireWildcard((parcelRequire("acw62")));

var $09445c1bc5a83d17$var$_propTypes = $09445c1bc5a83d17$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $09445c1bc5a83d17$var$_clsx = $09445c1bc5a83d17$require$_interopRequireDefault((parcelRequire("9QePP")));

var $09445c1bc5a83d17$var$_composeClasses = $09445c1bc5a83d17$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $09445c1bc5a83d17$var$_memoTheme = $09445c1bc5a83d17$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $09445c1bc5a83d17$var$_CheckCircle = $09445c1bc5a83d17$require$_interopRequireDefault((parcelRequire("9uq0C")));

var $09445c1bc5a83d17$var$_Warning = $09445c1bc5a83d17$require$_interopRequireDefault((parcelRequire("7PGQc")));

var $09445c1bc5a83d17$var$_SvgIcon = $09445c1bc5a83d17$require$_interopRequireDefault((parcelRequire("loOwp")));

var $09445c1bc5a83d17$var$_stepIconClasses = $09445c1bc5a83d17$require$_interopRequireWildcard((parcelRequire("7f59P")));

var $ayMG0 = parcelRequire("ayMG0");
var $09445c1bc5a83d17$var$_circle;
const $09445c1bc5a83d17$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, active: active, completed: completed, error: error } = ownerState;
    const slots = {
        root: [
            'root',
            active && 'active',
            completed && 'completed',
            error && 'error'
        ],
        text: [
            'text'
        ]
    };
    return (0, $09445c1bc5a83d17$var$_composeClasses.default)(slots, $09445c1bc5a83d17$var$_stepIconClasses.getStepIconUtilityClass, classes);
};
const $09445c1bc5a83d17$var$StepIconRoot = (0, $aAbgT.styled)($09445c1bc5a83d17$var$_SvgIcon.default, {
    name: 'MuiStepIcon',
    slot: 'Root'
})((0, $09445c1bc5a83d17$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'block',
        transition: theme.transitions.create('color', {
            duration: theme.transitions.duration.shortest
        }),
        color: (theme.vars || theme).palette.text.disabled,
        [`&.${$09445c1bc5a83d17$var$_stepIconClasses.default.completed}, &.${$09445c1bc5a83d17$var$_stepIconClasses.default.active}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${$09445c1bc5a83d17$var$_stepIconClasses.default.error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
const $09445c1bc5a83d17$var$StepIconText = (0, $aAbgT.styled)('text', {
    name: 'MuiStepIcon',
    slot: 'Text'
})((0, $09445c1bc5a83d17$var$_memoTheme.default)(({ theme: theme })=>({
        fill: (theme.vars || theme).palette.primary.contrastText,
        fontSize: theme.typography.caption.fontSize,
        fontFamily: theme.typography.fontFamily
    })));
const $09445c1bc5a83d17$var$StepIcon = /*#__PURE__*/ $09445c1bc5a83d17$var$React.forwardRef(function StepIcon(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiStepIcon'
    });
    const { active: active = false, className: classNameProp, completed: completed = false, error: error = false, icon: icon, ...other } = props;
    const ownerState = {
        ...props,
        active: active,
        completed: completed,
        error: error
    };
    const classes = $09445c1bc5a83d17$var$useUtilityClasses(ownerState);
    if (typeof icon === 'number' || typeof icon === 'string') {
        const className = (0, $09445c1bc5a83d17$var$_clsx.default)(classNameProp, classes.root);
        if (error) return /*#__PURE__*/ (0, $ayMG0.jsx)($09445c1bc5a83d17$var$StepIconRoot, {
            as: $09445c1bc5a83d17$var$_Warning.default,
            className: className,
            ref: ref,
            ownerState: ownerState,
            ...other
        });
        if (completed) return /*#__PURE__*/ (0, $ayMG0.jsx)($09445c1bc5a83d17$var$StepIconRoot, {
            as: $09445c1bc5a83d17$var$_CheckCircle.default,
            className: className,
            ref: ref,
            ownerState: ownerState,
            ...other
        });
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($09445c1bc5a83d17$var$StepIconRoot, {
            className: className,
            ref: ref,
            ownerState: ownerState,
            ...other,
            children: [
                $09445c1bc5a83d17$var$_circle || ($09445c1bc5a83d17$var$_circle = /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "12"
                })),
                /*#__PURE__*/ (0, $ayMG0.jsx)($09445c1bc5a83d17$var$StepIconText, {
                    className: classes.text,
                    x: "12",
                    y: "12",
                    textAnchor: "middle",
                    dominantBaseline: "central",
                    ownerState: ownerState,
                    children: icon
                })
            ]
        });
    }
    return icon;
});
$09445c1bc5a83d17$var$StepIcon.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Whether this step is active.
   * @default false
   */ active: $09445c1bc5a83d17$var$_propTypes.default.bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $09445c1bc5a83d17$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $09445c1bc5a83d17$var$_propTypes.default.string,
    /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */ completed: $09445c1bc5a83d17$var$_propTypes.default.bool,
    /**
   * If `true`, the step is marked as failed.
   * @default false
   */ error: $09445c1bc5a83d17$var$_propTypes.default.bool,
    /**
   * The label displayed in the step icon.
   */ icon: $09445c1bc5a83d17$var$_propTypes.default.node,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $09445c1bc5a83d17$var$_propTypes.default.oneOfType([
        $09445c1bc5a83d17$var$_propTypes.default.arrayOf($09445c1bc5a83d17$var$_propTypes.default.oneOfType([
            $09445c1bc5a83d17$var$_propTypes.default.func,
            $09445c1bc5a83d17$var$_propTypes.default.object,
            $09445c1bc5a83d17$var$_propTypes.default.bool
        ])),
        $09445c1bc5a83d17$var$_propTypes.default.func,
        $09445c1bc5a83d17$var$_propTypes.default.object
    ])
};
var $09445c1bc5a83d17$var$_default = module.exports.default = $09445c1bc5a83d17$var$StepIcon;

});
parcelRegister("9uq0C", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $6e8b174384ed5c4f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6e8b174384ed5c4f$var$_createSvgIcon = $6e8b174384ed5c4f$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $6e8b174384ed5c4f$var$_default = module.exports.default = (0, $6e8b174384ed5c4f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
}), 'CheckCircle');

});

parcelRegister("7PGQc", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $5b3e87234e6d594a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5b3e87234e6d594a$var$_createSvgIcon = $5b3e87234e6d594a$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $5b3e87234e6d594a$var$_default = module.exports.default = (0, $5b3e87234e6d594a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
}), 'Warning');

});

parcelRegister("7f59P", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $545def50b7760bec$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getStepIconUtilityClass = $545def50b7760bec$var$getStepIconUtilityClass;

var $545def50b7760bec$var$_generateUtilityClasses = $545def50b7760bec$require$_interopRequireDefault((parcelRequire("5nY49")));

var $545def50b7760bec$var$_generateUtilityClass = $545def50b7760bec$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $545def50b7760bec$var$getStepIconUtilityClass(slot) {
    return (0, $545def50b7760bec$var$_generateUtilityClass.default)('MuiStepIcon', slot);
}
const $545def50b7760bec$var$stepIconClasses = (0, $545def50b7760bec$var$_generateUtilityClasses.default)('MuiStepIcon', [
    'root',
    'active',
    'completed',
    'error',
    'text'
]);
var $545def50b7760bec$var$_default = module.exports.default = $545def50b7760bec$var$stepIconClasses;

});



parcelRegister("avvt2", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $7a65356a062b77fd$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getStepLabelUtilityClass = $7a65356a062b77fd$var$getStepLabelUtilityClass;

var $7a65356a062b77fd$var$_generateUtilityClasses = $7a65356a062b77fd$require$_interopRequireDefault((parcelRequire("5nY49")));

var $7a65356a062b77fd$var$_generateUtilityClass = $7a65356a062b77fd$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $7a65356a062b77fd$var$getStepLabelUtilityClass(slot) {
    return (0, $7a65356a062b77fd$var$_generateUtilityClass.default)('MuiStepLabel', slot);
}
const $7a65356a062b77fd$var$stepLabelClasses = (0, $7a65356a062b77fd$var$_generateUtilityClasses.default)('MuiStepLabel', [
    'root',
    'horizontal',
    'vertical',
    'label',
    'active',
    'completed',
    'error',
    'disabled',
    'iconContainer',
    'alternativeLabel',
    'labelContainer'
]);
var $7a65356a062b77fd$var$_default = module.exports.default = $7a65356a062b77fd$var$stepLabelClasses;

});



parcelRegister("3OtA2", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $2c6cfca685d9c4a3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getStepButtonUtilityClass = $2c6cfca685d9c4a3$var$getStepButtonUtilityClass;

var $2c6cfca685d9c4a3$var$_generateUtilityClasses = $2c6cfca685d9c4a3$require$_interopRequireDefault((parcelRequire("5nY49")));

var $2c6cfca685d9c4a3$var$_generateUtilityClass = $2c6cfca685d9c4a3$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $2c6cfca685d9c4a3$var$getStepButtonUtilityClass(slot) {
    return (0, $2c6cfca685d9c4a3$var$_generateUtilityClass.default)('MuiStepButton', slot);
}
const $2c6cfca685d9c4a3$var$stepButtonClasses = (0, $2c6cfca685d9c4a3$var$_generateUtilityClasses.default)('MuiStepButton', [
    'root',
    'horizontal',
    'vertical',
    'touchRipple'
]);
var $2c6cfca685d9c4a3$var$_default = module.exports.default = $2c6cfca685d9c4a3$var$stepButtonClasses;

});



parcelRegister("jjQoZ", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $e108709a7cb36655$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $e108709a7cb36655$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $e108709a7cb36655$var$_exportNames = {
    stepConnectorClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $e108709a7cb36655$var$_StepConnector.default;
    }
});
Object.defineProperty(module.exports, "stepConnectorClasses", {
    enumerable: true,
    get: function() {
        return $e108709a7cb36655$var$_stepConnectorClasses.default;
    }
});

var $e108709a7cb36655$var$_StepConnector = $e108709a7cb36655$require$_interopRequireDefault((parcelRequire("4r3Nm")));

var $e108709a7cb36655$var$_stepConnectorClasses = $e108709a7cb36655$require$_interopRequireWildcard((parcelRequire("6CCNL")));
Object.keys($e108709a7cb36655$var$_stepConnectorClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($e108709a7cb36655$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $e108709a7cb36655$var$_stepConnectorClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $e108709a7cb36655$var$_stepConnectorClasses[key];
        }
    });
});

});
parcelRegister("4r3Nm", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $33aca0a7deb8d615$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $33aca0a7deb8d615$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $33aca0a7deb8d615$var$React = $33aca0a7deb8d615$require$_interopRequireWildcard((parcelRequire("acw62")));

var $33aca0a7deb8d615$var$_propTypes = $33aca0a7deb8d615$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $33aca0a7deb8d615$var$_clsx = $33aca0a7deb8d615$require$_interopRequireDefault((parcelRequire("9QePP")));

var $33aca0a7deb8d615$var$_composeClasses = $33aca0a7deb8d615$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $33aca0a7deb8d615$var$_capitalize = $33aca0a7deb8d615$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $aAbgT = parcelRequire("aAbgT");

var $33aca0a7deb8d615$var$_memoTheme = $33aca0a7deb8d615$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $33aca0a7deb8d615$var$_StepperContext = $33aca0a7deb8d615$require$_interopRequireDefault((parcelRequire("8c8ll")));

var $33aca0a7deb8d615$var$_StepContext = $33aca0a7deb8d615$require$_interopRequireDefault((parcelRequire("jrw2p")));

var $6CCNL = parcelRequire("6CCNL");

var $ayMG0 = parcelRequire("ayMG0");
const $33aca0a7deb8d615$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, alternativeLabel: alternativeLabel, active: active, completed: completed, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            alternativeLabel && 'alternativeLabel',
            active && 'active',
            completed && 'completed',
            disabled && 'disabled'
        ],
        line: [
            'line',
            `line${(0, $33aca0a7deb8d615$var$_capitalize.default)(orientation)}`
        ]
    };
    return (0, $33aca0a7deb8d615$var$_composeClasses.default)(slots, $6CCNL.getStepConnectorUtilityClass, classes);
};
const $33aca0a7deb8d615$var$StepConnectorRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiStepConnector',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.alternativeLabel && styles.alternativeLabel,
            ownerState.completed && styles.completed
        ];
    }
})({
    flex: '1 1 auto',
    variants: [
        {
            props: {
                orientation: 'vertical'
            },
            style: {
                marginLeft: 12 // half icon
            }
        },
        {
            props: {
                alternativeLabel: true
            },
            style: {
                position: 'absolute',
                top: 12,
                left: 'calc(-50% + 20px)',
                right: 'calc(50% + 20px)'
            }
        }
    ]
});
const $33aca0a7deb8d615$var$StepConnectorLine = (0, $aAbgT.styled)('span', {
    name: 'MuiStepConnector',
    slot: 'Line',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.line,
            styles[`line${(0, $33aca0a7deb8d615$var$_capitalize.default)(ownerState.orientation)}`]
        ];
    }
})((0, $33aca0a7deb8d615$var$_memoTheme.default)(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[600];
    return {
        display: 'block',
        borderColor: theme.vars ? theme.vars.palette.StepConnector.border : borderColor,
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    borderTopStyle: 'solid',
                    borderTopWidth: 1
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    borderLeftStyle: 'solid',
                    borderLeftWidth: 1,
                    minHeight: 24
                }
            }
        ]
    };
}));
const $33aca0a7deb8d615$var$StepConnector = /*#__PURE__*/ $33aca0a7deb8d615$var$React.forwardRef(function StepConnector(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiStepConnector'
    });
    const { className: className, ...other } = props;
    const { alternativeLabel: alternativeLabel, orientation: orientation = 'horizontal' } = $33aca0a7deb8d615$var$React.useContext($33aca0a7deb8d615$var$_StepperContext.default);
    const { active: active, disabled: disabled, completed: completed } = $33aca0a7deb8d615$var$React.useContext($33aca0a7deb8d615$var$_StepContext.default);
    const ownerState = {
        ...props,
        alternativeLabel: alternativeLabel,
        orientation: orientation,
        active: active,
        completed: completed,
        disabled: disabled
    };
    const classes = $33aca0a7deb8d615$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($33aca0a7deb8d615$var$StepConnectorRoot, {
        className: (0, $33aca0a7deb8d615$var$_clsx.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($33aca0a7deb8d615$var$StepConnectorLine, {
            className: classes.line,
            ownerState: ownerState
        })
    });
});
$33aca0a7deb8d615$var$StepConnector.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Override or extend the styles applied to the component.
   */ classes: $33aca0a7deb8d615$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $33aca0a7deb8d615$var$_propTypes.default.string,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $33aca0a7deb8d615$var$_propTypes.default.oneOfType([
        $33aca0a7deb8d615$var$_propTypes.default.arrayOf($33aca0a7deb8d615$var$_propTypes.default.oneOfType([
            $33aca0a7deb8d615$var$_propTypes.default.func,
            $33aca0a7deb8d615$var$_propTypes.default.object,
            $33aca0a7deb8d615$var$_propTypes.default.bool
        ])),
        $33aca0a7deb8d615$var$_propTypes.default.func,
        $33aca0a7deb8d615$var$_propTypes.default.object
    ])
};
var $33aca0a7deb8d615$var$_default = module.exports.default = $33aca0a7deb8d615$var$StepConnector;

});
parcelRegister("6CCNL", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $4d2463e67e3000c3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getStepConnectorUtilityClass = $4d2463e67e3000c3$var$getStepConnectorUtilityClass;

var $4d2463e67e3000c3$var$_generateUtilityClasses = $4d2463e67e3000c3$require$_interopRequireDefault((parcelRequire("5nY49")));

var $4d2463e67e3000c3$var$_generateUtilityClass = $4d2463e67e3000c3$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $4d2463e67e3000c3$var$getStepConnectorUtilityClass(slot) {
    return (0, $4d2463e67e3000c3$var$_generateUtilityClass.default)('MuiStepConnector', slot);
}
const $4d2463e67e3000c3$var$stepConnectorClasses = (0, $4d2463e67e3000c3$var$_generateUtilityClasses.default)('MuiStepConnector', [
    'root',
    'horizontal',
    'vertical',
    'alternativeLabel',
    'active',
    'completed',
    'disabled',
    'line',
    'lineHorizontal',
    'lineVertical'
]);
var $4d2463e67e3000c3$var$_default = module.exports.default = $4d2463e67e3000c3$var$stepConnectorClasses;

});



parcelRegister("b3U7M", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $80db82a861533602$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $80db82a861533602$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $80db82a861533602$var$_exportNames = {
    stepContentClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $80db82a861533602$var$_StepContent.default;
    }
});
Object.defineProperty(module.exports, "stepContentClasses", {
    enumerable: true,
    get: function() {
        return $80db82a861533602$var$_stepContentClasses.default;
    }
});

var $80db82a861533602$var$_StepContent = $80db82a861533602$require$_interopRequireDefault((parcelRequire("dNCDH")));

var $80db82a861533602$var$_stepContentClasses = $80db82a861533602$require$_interopRequireWildcard((parcelRequire("5A2Y1")));
Object.keys($80db82a861533602$var$_stepContentClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($80db82a861533602$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $80db82a861533602$var$_stepContentClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $80db82a861533602$var$_stepContentClasses[key];
        }
    });
});

});
parcelRegister("dNCDH", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $a0bdd2eb216e9220$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $a0bdd2eb216e9220$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a0bdd2eb216e9220$var$React = $a0bdd2eb216e9220$require$_interopRequireWildcard((parcelRequire("acw62")));

var $a0bdd2eb216e9220$var$_propTypes = $a0bdd2eb216e9220$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $a0bdd2eb216e9220$var$_clsx = $a0bdd2eb216e9220$require$_interopRequireDefault((parcelRequire("9QePP")));

var $a0bdd2eb216e9220$var$_composeClasses = $a0bdd2eb216e9220$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $a0bdd2eb216e9220$var$_memoTheme = $a0bdd2eb216e9220$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $a0bdd2eb216e9220$var$_Collapse = $a0bdd2eb216e9220$require$_interopRequireDefault((parcelRequire("gsEuH")));

var $a0bdd2eb216e9220$var$_StepperContext = $a0bdd2eb216e9220$require$_interopRequireDefault((parcelRequire("8c8ll")));

var $a0bdd2eb216e9220$var$_StepContext = $a0bdd2eb216e9220$require$_interopRequireDefault((parcelRequire("jrw2p")));

var $5A2Y1 = parcelRequire("5A2Y1");

var $a0bdd2eb216e9220$var$_useSlot = $a0bdd2eb216e9220$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $a0bdd2eb216e9220$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, last: last } = ownerState;
    const slots = {
        root: [
            'root',
            last && 'last'
        ],
        transition: [
            'transition'
        ]
    };
    return (0, $a0bdd2eb216e9220$var$_composeClasses.default)(slots, $5A2Y1.getStepContentUtilityClass, classes);
};
const $a0bdd2eb216e9220$var$StepContentRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiStepContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.last && styles.last
        ];
    }
})((0, $a0bdd2eb216e9220$var$_memoTheme.default)(({ theme: theme })=>({
        marginLeft: 12,
        // half icon
        paddingLeft: 20,
        // margin + half icon
        paddingRight: 8,
        borderLeft: theme.vars ? `1px solid ${theme.vars.palette.StepContent.border}` : `1px solid ${theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]}`,
        variants: [
            {
                props: {
                    last: true
                },
                style: {
                    borderLeft: 'none'
                }
            }
        ]
    })));
const $a0bdd2eb216e9220$var$StepContentTransition = (0, $aAbgT.styled)($a0bdd2eb216e9220$var$_Collapse.default, {
    name: 'MuiStepContent',
    slot: 'Transition'
})({});
const $a0bdd2eb216e9220$var$StepContent = /*#__PURE__*/ $a0bdd2eb216e9220$var$React.forwardRef(function StepContent(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiStepContent'
    });
    const { children: children, className: className, TransitionComponent: TransitionComponent = $a0bdd2eb216e9220$var$_Collapse.default, transitionDuration: transitionDurationProp = 'auto', TransitionProps: TransitionProps, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const { orientation: orientation } = $a0bdd2eb216e9220$var$React.useContext($a0bdd2eb216e9220$var$_StepperContext.default);
    const { active: active, last: last, expanded: expanded } = $a0bdd2eb216e9220$var$React.useContext($a0bdd2eb216e9220$var$_StepContext.default);
    const ownerState = {
        ...props,
        last: last
    };
    const classes = $a0bdd2eb216e9220$var$useUtilityClasses(ownerState);
    if (orientation !== 'vertical') console.error('MUI: <StepContent /> is only designed for use with the vertical stepper.');
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            transition: TransitionProps,
            ...slotProps
        }
    };
    const [TransitionSlot, transitionProps] = (0, $a0bdd2eb216e9220$var$_useSlot.default)('transition', {
        elementType: $a0bdd2eb216e9220$var$StepContentTransition,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.transition,
        additionalProps: {
            in: active || expanded,
            timeout: transitionDuration,
            unmountOnExit: true
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a0bdd2eb216e9220$var$StepContentRoot, {
        className: (0, $a0bdd2eb216e9220$var$_clsx.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionSlot, {
            as: TransitionComponent,
            ...transitionProps,
            children: children
        })
    });
});
$a0bdd2eb216e9220$var$StepContent.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: $a0bdd2eb216e9220$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $a0bdd2eb216e9220$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $a0bdd2eb216e9220$var$_propTypes.default.string,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $a0bdd2eb216e9220$var$_propTypes.default.shape({
        transition: $a0bdd2eb216e9220$var$_propTypes.default.oneOfType([
            $a0bdd2eb216e9220$var$_propTypes.default.func,
            $a0bdd2eb216e9220$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: $a0bdd2eb216e9220$var$_propTypes.default.shape({
        transition: $a0bdd2eb216e9220$var$_propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $a0bdd2eb216e9220$var$_propTypes.default.oneOfType([
        $a0bdd2eb216e9220$var$_propTypes.default.arrayOf($a0bdd2eb216e9220$var$_propTypes.default.oneOfType([
            $a0bdd2eb216e9220$var$_propTypes.default.func,
            $a0bdd2eb216e9220$var$_propTypes.default.object,
            $a0bdd2eb216e9220$var$_propTypes.default.bool
        ])),
        $a0bdd2eb216e9220$var$_propTypes.default.func,
        $a0bdd2eb216e9220$var$_propTypes.default.object
    ]),
    /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Collapse
   * @deprecated Use `slots.transition` instead. This prop will be removed in a future major release. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   */ TransitionComponent: $a0bdd2eb216e9220$var$_propTypes.default.elementType,
    /**
   * Adjust the duration of the content expand transition.
   * Passed as a prop to the transition component.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */ transitionDuration: $a0bdd2eb216e9220$var$_propTypes.default.oneOfType([
        $a0bdd2eb216e9220$var$_propTypes.default.oneOf([
            'auto'
        ]),
        $a0bdd2eb216e9220$var$_propTypes.default.number,
        $a0bdd2eb216e9220$var$_propTypes.default.shape({
            appear: $a0bdd2eb216e9220$var$_propTypes.default.number,
            enter: $a0bdd2eb216e9220$var$_propTypes.default.number,
            exit: $a0bdd2eb216e9220$var$_propTypes.default.number
        })
    ]),
    /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated Use `slotProps.transition` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ TransitionProps: $a0bdd2eb216e9220$var$_propTypes.default.object
};
var $a0bdd2eb216e9220$var$_default = module.exports.default = $a0bdd2eb216e9220$var$StepContent;

});
parcelRegister("5A2Y1", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $41029dbb16e3c896$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getStepContentUtilityClass = $41029dbb16e3c896$var$getStepContentUtilityClass;

var $41029dbb16e3c896$var$_generateUtilityClasses = $41029dbb16e3c896$require$_interopRequireDefault((parcelRequire("5nY49")));

var $41029dbb16e3c896$var$_generateUtilityClass = $41029dbb16e3c896$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $41029dbb16e3c896$var$getStepContentUtilityClass(slot) {
    return (0, $41029dbb16e3c896$var$_generateUtilityClass.default)('MuiStepContent', slot);
}
const $41029dbb16e3c896$var$stepContentClasses = (0, $41029dbb16e3c896$var$_generateUtilityClasses.default)('MuiStepContent', [
    'root',
    'last',
    'transition'
]);
var $41029dbb16e3c896$var$_default = module.exports.default = $41029dbb16e3c896$var$stepContentClasses;

});



parcelRegister("5kBLW", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $3e1c1ec9d9e33247$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $3e1c1ec9d9e33247$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $3e1c1ec9d9e33247$var$_exportNames = {
    stepperClasses: true,
    StepperContext: true
};
Object.defineProperty(module.exports, "StepperContext", {
    enumerable: true,
    get: function() {
        return $3e1c1ec9d9e33247$var$_StepperContext.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $3e1c1ec9d9e33247$var$_Stepper.default;
    }
});
Object.defineProperty(module.exports, "stepperClasses", {
    enumerable: true,
    get: function() {
        return $3e1c1ec9d9e33247$var$_stepperClasses.default;
    }
});

var $3e1c1ec9d9e33247$var$_Stepper = $3e1c1ec9d9e33247$require$_interopRequireDefault((parcelRequire("RyhSp")));

var $3e1c1ec9d9e33247$var$_stepperClasses = $3e1c1ec9d9e33247$require$_interopRequireWildcard((parcelRequire("7qR9n")));
Object.keys($3e1c1ec9d9e33247$var$_stepperClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($3e1c1ec9d9e33247$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $3e1c1ec9d9e33247$var$_stepperClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3e1c1ec9d9e33247$var$_stepperClasses[key];
        }
    });
});

var $3e1c1ec9d9e33247$var$_StepperContext = $3e1c1ec9d9e33247$require$_interopRequireWildcard((parcelRequire("8c8ll")));
Object.keys($3e1c1ec9d9e33247$var$_StepperContext).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($3e1c1ec9d9e33247$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $3e1c1ec9d9e33247$var$_StepperContext[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3e1c1ec9d9e33247$var$_StepperContext[key];
        }
    });
});

});
parcelRegister("RyhSp", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $0a0f8c19f5f3ee7a$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $0a0f8c19f5f3ee7a$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0a0f8c19f5f3ee7a$var$React = $0a0f8c19f5f3ee7a$require$_interopRequireWildcard((parcelRequire("acw62")));

var $0a0f8c19f5f3ee7a$var$_propTypes = $0a0f8c19f5f3ee7a$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $0a0f8c19f5f3ee7a$var$_clsx = $0a0f8c19f5f3ee7a$require$_interopRequireDefault((parcelRequire("9QePP")));

var $0a0f8c19f5f3ee7a$var$_integerPropType = $0a0f8c19f5f3ee7a$require$_interopRequireDefault((parcelRequire("cxaSP")));

var $0a0f8c19f5f3ee7a$var$_composeClasses = $0a0f8c19f5f3ee7a$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $7qR9n = parcelRequire("7qR9n");

var $0a0f8c19f5f3ee7a$var$_StepConnector = $0a0f8c19f5f3ee7a$require$_interopRequireDefault((parcelRequire("jjQoZ")));

var $0a0f8c19f5f3ee7a$var$_StepperContext = $0a0f8c19f5f3ee7a$require$_interopRequireDefault((parcelRequire("8c8ll")));

var $ayMG0 = parcelRequire("ayMG0");
const $0a0f8c19f5f3ee7a$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, nonLinear: nonLinear, alternativeLabel: alternativeLabel, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            nonLinear && 'nonLinear',
            alternativeLabel && 'alternativeLabel'
        ]
    };
    return (0, $0a0f8c19f5f3ee7a$var$_composeClasses.default)(slots, $7qR9n.getStepperUtilityClass, classes);
};
const $0a0f8c19f5f3ee7a$var$StepperRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiStepper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.alternativeLabel && styles.alternativeLabel,
            ownerState.nonLinear && styles.nonLinear
        ];
    }
})({
    display: 'flex',
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                flexDirection: 'row',
                alignItems: 'center'
            }
        },
        {
            props: {
                orientation: 'vertical'
            },
            style: {
                flexDirection: 'column'
            }
        },
        {
            props: {
                alternativeLabel: true
            },
            style: {
                alignItems: 'flex-start'
            }
        }
    ]
});
const $0a0f8c19f5f3ee7a$var$defaultConnector = /*#__PURE__*/ (0, $ayMG0.jsx)($0a0f8c19f5f3ee7a$var$_StepConnector.default, {});
const $0a0f8c19f5f3ee7a$var$Stepper = /*#__PURE__*/ $0a0f8c19f5f3ee7a$var$React.forwardRef(function Stepper(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiStepper'
    });
    const { activeStep: activeStep = 0, alternativeLabel: alternativeLabel = false, children: children, className: className, component: component = 'div', connector: connector = $0a0f8c19f5f3ee7a$var$defaultConnector, nonLinear: nonLinear = false, orientation: orientation = 'horizontal', ...other } = props;
    const ownerState = {
        ...props,
        nonLinear: nonLinear,
        alternativeLabel: alternativeLabel,
        orientation: orientation,
        component: component
    };
    const classes = $0a0f8c19f5f3ee7a$var$useUtilityClasses(ownerState);
    const childrenArray = $0a0f8c19f5f3ee7a$var$React.Children.toArray(children).filter(Boolean);
    const steps = childrenArray.map((step, index)=>{
        return /*#__PURE__*/ $0a0f8c19f5f3ee7a$var$React.cloneElement(step, {
            index: index,
            last: index + 1 === childrenArray.length,
            ...step.props
        });
    });
    const contextValue = $0a0f8c19f5f3ee7a$var$React.useMemo(()=>({
            activeStep: activeStep,
            alternativeLabel: alternativeLabel,
            connector: connector,
            nonLinear: nonLinear,
            orientation: orientation
        }), [
        activeStep,
        alternativeLabel,
        connector,
        nonLinear,
        orientation
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($0a0f8c19f5f3ee7a$var$_StepperContext.default.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($0a0f8c19f5f3ee7a$var$StepperRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $0a0f8c19f5f3ee7a$var$_clsx.default)(classes.root, className),
            ref: ref,
            ...other,
            children: steps
        })
    });
});
$0a0f8c19f5f3ee7a$var$Stepper.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Set the active step (zero based index).
   * Set to -1 to disable all the steps.
   * @default 0
   */ activeStep: $0a0f8c19f5f3ee7a$var$_integerPropType.default,
    /**
   * If set to 'true' and orientation is horizontal,
   * then the step label will be positioned under the icon.
   * @default false
   */ alternativeLabel: $0a0f8c19f5f3ee7a$var$_propTypes.default.bool,
    /**
   * Two or more `<Step />` components.
   */ children: $0a0f8c19f5f3ee7a$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $0a0f8c19f5f3ee7a$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $0a0f8c19f5f3ee7a$var$_propTypes.default.string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $0a0f8c19f5f3ee7a$var$_propTypes.default.elementType,
    /**
   * An element to be placed between each step.
   * @default <StepConnector />
   */ connector: $0a0f8c19f5f3ee7a$var$_propTypes.default.element,
    /**
   * If set the `Stepper` will not assist in controlling steps for linear flow.
   * @default false
   */ nonLinear: $0a0f8c19f5f3ee7a$var$_propTypes.default.bool,
    /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */ orientation: $0a0f8c19f5f3ee7a$var$_propTypes.default.oneOf([
        'horizontal',
        'vertical'
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $0a0f8c19f5f3ee7a$var$_propTypes.default.oneOfType([
        $0a0f8c19f5f3ee7a$var$_propTypes.default.arrayOf($0a0f8c19f5f3ee7a$var$_propTypes.default.oneOfType([
            $0a0f8c19f5f3ee7a$var$_propTypes.default.func,
            $0a0f8c19f5f3ee7a$var$_propTypes.default.object,
            $0a0f8c19f5f3ee7a$var$_propTypes.default.bool
        ])),
        $0a0f8c19f5f3ee7a$var$_propTypes.default.func,
        $0a0f8c19f5f3ee7a$var$_propTypes.default.object
    ])
};
var $0a0f8c19f5f3ee7a$var$_default = module.exports.default = $0a0f8c19f5f3ee7a$var$Stepper;

});
parcelRegister("7qR9n", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $569430a767235b4e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getStepperUtilityClass = $569430a767235b4e$var$getStepperUtilityClass;

var $569430a767235b4e$var$_generateUtilityClasses = $569430a767235b4e$require$_interopRequireDefault((parcelRequire("5nY49")));

var $569430a767235b4e$var$_generateUtilityClass = $569430a767235b4e$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $569430a767235b4e$var$getStepperUtilityClass(slot) {
    return (0, $569430a767235b4e$var$_generateUtilityClass.default)('MuiStepper', slot);
}
const $569430a767235b4e$var$stepperClasses = (0, $569430a767235b4e$var$_generateUtilityClasses.default)('MuiStepper', [
    'root',
    'horizontal',
    'vertical',
    'nonLinear',
    'alternativeLabel'
]);
var $569430a767235b4e$var$_default = module.exports.default = $569430a767235b4e$var$stepperClasses;

});



parcelRegister("fuux0", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $b471573c23b3da9a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $b471573c23b3da9a$var$_SwipeableDrawer.default;
    }
});

var $b471573c23b3da9a$var$_SwipeableDrawer = $b471573c23b3da9a$require$_interopRequireDefault((parcelRequire("ftPRU")));

});
parcelRegister("ftPRU", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $b451cc713fab7e92$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $b451cc713fab7e92$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.reset = $b451cc713fab7e92$var$reset;

var $b451cc713fab7e92$var$React = $b451cc713fab7e92$require$_interopRequireWildcard((parcelRequire("acw62")));

var $b451cc713fab7e92$var$ReactDOM = $b451cc713fab7e92$require$_interopRequireWildcard((parcelRequire("1u0KT")));

var $b451cc713fab7e92$var$_propTypes = $b451cc713fab7e92$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $b451cc713fab7e92$var$_elementTypeAcceptingRef = $b451cc713fab7e92$require$_interopRequireDefault((parcelRequire("g6PKz")));

var $b451cc713fab7e92$var$_NoSsr = $b451cc713fab7e92$require$_interopRequireDefault((parcelRequire("cQC3m")));

var $b451cc713fab7e92$var$_Drawer = $b451cc713fab7e92$require$_interopRequireWildcard((parcelRequire("2Ed4H")));

var $b451cc713fab7e92$var$_contains = $b451cc713fab7e92$require$_interopRequireDefault((parcelRequire("191Fy")));

var $b451cc713fab7e92$var$_ownerDocument = $b451cc713fab7e92$require$_interopRequireDefault((parcelRequire("gzyUk")));

var $b451cc713fab7e92$var$_ownerWindow = $b451cc713fab7e92$require$_interopRequireDefault((parcelRequire("9Evvr")));

var $b451cc713fab7e92$var$_useEventCallback = $b451cc713fab7e92$require$_interopRequireDefault((parcelRequire("4o7uD")));

var $b451cc713fab7e92$var$_useForkRef = $b451cc713fab7e92$require$_interopRequireDefault((parcelRequire("9Rgf1")));

var $b451cc713fab7e92$var$_useEnhancedEffect = $b451cc713fab7e92$require$_interopRequireDefault((parcelRequire("khjmj")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $hweuE = parcelRequire("hweuE");

var $hGPki = parcelRequire("hGPki");

var $b451cc713fab7e92$var$_useSlot = $b451cc713fab7e92$require$_interopRequireDefault((parcelRequire("6lpak")));

var $b451cc713fab7e92$var$_SwipeArea = $b451cc713fab7e92$require$_interopRequireDefault((parcelRequire("gQeSR")));

var $ayMG0 = parcelRequire("ayMG0");
// This value is closed to what browsers are using internally to
// trigger a native scroll.
const $b451cc713fab7e92$var$UNCERTAINTY_THRESHOLD = 3; // px
// This is the part of the drawer displayed on touch start.
const $b451cc713fab7e92$var$DRAG_STARTED_SIGNAL = 20; // px
// We can only have one instance at the time claiming ownership for handling the swipe.
// Otherwise, the UX would be confusing.
// That's why we use a singleton here.
let $b451cc713fab7e92$var$claimedSwipeInstance = null;
// Exported for test purposes.
function $b451cc713fab7e92$var$reset() {
    $b451cc713fab7e92$var$claimedSwipeInstance = null;
}
function $b451cc713fab7e92$var$calculateCurrentX(anchor, touches, doc) {
    return anchor === 'right' ? doc.body.offsetWidth - touches[0].pageX : touches[0].pageX;
}
function $b451cc713fab7e92$var$calculateCurrentY(anchor, touches, containerWindow) {
    return anchor === 'bottom' ? containerWindow.innerHeight - touches[0].clientY : touches[0].clientY;
}
function $b451cc713fab7e92$var$getMaxTranslate(horizontalSwipe, paperInstance) {
    return horizontalSwipe ? paperInstance.clientWidth : paperInstance.clientHeight;
}
function $b451cc713fab7e92$var$getTranslate(currentTranslate, startLocation, open, maxTranslate) {
    return Math.min(Math.max(open ? startLocation - currentTranslate : maxTranslate + startLocation - currentTranslate, 0), maxTranslate);
}
/**
 * @param {Element | null} element
 * @param {Element} rootNode
 */ function $b451cc713fab7e92$var$getDomTreeShapes(element, rootNode) {
    // Adapted from https://github.com/oliviertassinari/react-swipeable-views/blob/7666de1dba253b896911adf2790ce51467670856/packages/react-swipeable-views/src/SwipeableViews.js#L129
    const domTreeShapes = [];
    while(element && element !== rootNode.parentElement){
        const style = (0, $b451cc713fab7e92$var$_ownerWindow.default)(rootNode).getComputedStyle(element);
        if (// Ignore the scroll children if the element is absolute positioned.
        style.getPropertyValue('position') === 'absolute' || // Ignore the scroll children if the element has an overflowX hidden
        style.getPropertyValue('overflow-x') === 'hidden') ;
        else if (element.clientWidth > 0 && element.scrollWidth > element.clientWidth || element.clientHeight > 0 && element.scrollHeight > element.clientHeight) // Ignore the nodes that have no width.
        // Keep elements with a scroll
        domTreeShapes.push(element);
        element = element.parentElement;
    }
    return domTreeShapes;
}
/**
 * @param {object} param0
 * @param {ReturnType<getDomTreeShapes>} param0.domTreeShapes
 */ function $b451cc713fab7e92$var$computeHasNativeHandler({ domTreeShapes: domTreeShapes, start: start, current: current, anchor: anchor }) {
    // Adapted from https://github.com/oliviertassinari/react-swipeable-views/blob/7666de1dba253b896911adf2790ce51467670856/packages/react-swipeable-views/src/SwipeableViews.js#L175
    const axisProperties = {
        scrollPosition: {
            x: 'scrollLeft',
            y: 'scrollTop'
        },
        scrollLength: {
            x: 'scrollWidth',
            y: 'scrollHeight'
        },
        clientLength: {
            x: 'clientWidth',
            y: 'clientHeight'
        }
    };
    return domTreeShapes.some((shape)=>{
        // Determine if we are going backward or forward.
        let goingForward = current >= start;
        if (anchor === 'top' || anchor === 'left') goingForward = !goingForward;
        const axis = anchor === 'left' || anchor === 'right' ? 'x' : 'y';
        const scrollPosition = Math.round(shape[axisProperties.scrollPosition[axis]]);
        const areNotAtStart = scrollPosition > 0;
        const areNotAtEnd = scrollPosition + shape[axisProperties.clientLength[axis]] < shape[axisProperties.scrollLength[axis]];
        if (goingForward && areNotAtEnd || !goingForward && areNotAtStart) return true;
        return false;
    });
}
const $b451cc713fab7e92$var$iOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent);
const $b451cc713fab7e92$var$SwipeableDrawer = /*#__PURE__*/ $b451cc713fab7e92$var$React.forwardRef(function SwipeableDrawer(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        name: 'MuiSwipeableDrawer',
        props: inProps
    });
    const theme = (0, $aAbgT.useTheme)();
    const transitionDurationDefault = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { anchor: anchor = 'left', disableBackdropTransition: disableBackdropTransition = false, disableDiscovery: disableDiscovery = false, disableSwipeToOpen: disableSwipeToOpen = $b451cc713fab7e92$var$iOS, hideBackdrop: hideBackdrop, hysteresis: hysteresis = 0.52, allowSwipeInChildren: allowSwipeInChildren = false, minFlingVelocity: minFlingVelocity = 450, ModalProps: { BackdropProps: BackdropProps, ...ModalPropsProp } = {}, onClose: onClose, onOpen: onOpen, open: open = false, PaperProps: PaperProps = {}, SwipeAreaProps: SwipeAreaProps, swipeAreaWidth: swipeAreaWidth = 20, transitionDuration: transitionDuration = transitionDurationDefault, variant: variant = 'temporary', slots: // Mobile first.
    slots = {}, slotProps: slotProps = {}, ...other } = props;
    const [maybeSwiping, setMaybeSwiping] = $b451cc713fab7e92$var$React.useState(false);
    const swipeInstance = $b451cc713fab7e92$var$React.useRef({
        isSwiping: null
    });
    const swipeAreaRef = $b451cc713fab7e92$var$React.useRef();
    const backdropRef = $b451cc713fab7e92$var$React.useRef();
    const paperRef = $b451cc713fab7e92$var$React.useRef();
    const handleRef = (0, $b451cc713fab7e92$var$_useForkRef.default)(PaperProps.ref, paperRef);
    const touchDetected = $b451cc713fab7e92$var$React.useRef(false);
    // Ref for transition duration based on / to match swipe speed
    const calculatedDurationRef = $b451cc713fab7e92$var$React.useRef();
    // Use a ref so the open value used is always up to date inside useCallback.
    (0, $b451cc713fab7e92$var$_useEnhancedEffect.default)(()=>{
        calculatedDurationRef.current = null;
    }, [
        open
    ]);
    const setPosition = $b451cc713fab7e92$var$React.useCallback((translate, options = {})=>{
        const { mode: mode = null, changeTransition: changeTransition = true } = options;
        const anchorRtl = (0, $b451cc713fab7e92$var$_Drawer.getAnchor)(theme, anchor);
        const rtlTranslateMultiplier = [
            'right',
            'bottom'
        ].includes(anchorRtl) ? 1 : -1;
        const horizontalSwipe = (0, $b451cc713fab7e92$var$_Drawer.isHorizontal)(anchor);
        const transform = horizontalSwipe ? `translate(${rtlTranslateMultiplier * translate}px, 0)` : `translate(0, ${rtlTranslateMultiplier * translate}px)`;
        const drawerStyle = paperRef.current.style;
        drawerStyle.transform = transform;
        let transition = '';
        if (mode) transition = theme.transitions.create('all', (0, $hweuE.getTransitionProps)({
            easing: undefined,
            style: undefined,
            timeout: transitionDuration
        }, {
            mode: mode
        }));
        if (changeTransition) drawerStyle.transition = transition;
        if (!disableBackdropTransition && !hideBackdrop) {
            const backdropStyle = backdropRef.current.style;
            backdropStyle.opacity = 1 - translate / $b451cc713fab7e92$var$getMaxTranslate(horizontalSwipe, paperRef.current);
            if (changeTransition) backdropStyle.transition = transition;
        }
    }, [
        anchor,
        disableBackdropTransition,
        hideBackdrop,
        theme,
        transitionDuration
    ]);
    const handleBodyTouchEnd = (0, $b451cc713fab7e92$var$_useEventCallback.default)((nativeEvent)=>{
        if (!touchDetected.current) return;
        // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- claimedSwipeInstance is a singleton
        $b451cc713fab7e92$var$claimedSwipeInstance = null;
        touchDetected.current = false;
        $b451cc713fab7e92$var$ReactDOM.flushSync(()=>{
            setMaybeSwiping(false);
        });
        // The swipe wasn't started.
        if (!swipeInstance.current.isSwiping) {
            swipeInstance.current.isSwiping = null;
            return;
        }
        swipeInstance.current.isSwiping = null;
        const anchorRtl = (0, $b451cc713fab7e92$var$_Drawer.getAnchor)(theme, anchor);
        const horizontal = (0, $b451cc713fab7e92$var$_Drawer.isHorizontal)(anchor);
        let current;
        if (horizontal) current = $b451cc713fab7e92$var$calculateCurrentX(anchorRtl, nativeEvent.changedTouches, (0, $b451cc713fab7e92$var$_ownerDocument.default)(nativeEvent.currentTarget));
        else current = $b451cc713fab7e92$var$calculateCurrentY(anchorRtl, nativeEvent.changedTouches, (0, $b451cc713fab7e92$var$_ownerWindow.default)(nativeEvent.currentTarget));
        const startLocation = horizontal ? swipeInstance.current.startX : swipeInstance.current.startY;
        const maxTranslate = $b451cc713fab7e92$var$getMaxTranslate(horizontal, paperRef.current);
        const currentTranslate = $b451cc713fab7e92$var$getTranslate(current, startLocation, open, maxTranslate);
        const translateRatio = currentTranslate / maxTranslate;
        if (Math.abs(swipeInstance.current.velocity) > minFlingVelocity) // Calculate transition duration to match swipe speed
        calculatedDurationRef.current = Math.abs((maxTranslate - currentTranslate) / swipeInstance.current.velocity) * 1000;
        if (open) {
            if (swipeInstance.current.velocity > minFlingVelocity || translateRatio > hysteresis) onClose();
            else // Reset the position, the swipe was aborted.
            setPosition(0, {
                mode: 'exit'
            });
            return;
        }
        if (swipeInstance.current.velocity < -minFlingVelocity || 1 - translateRatio > hysteresis) onOpen();
        else // Reset the position, the swipe was aborted.
        setPosition($b451cc713fab7e92$var$getMaxTranslate(horizontal, paperRef.current), {
            mode: 'enter'
        });
    });
    const startMaybeSwiping = (force = false)=>{
        if (!maybeSwiping) {
            // on Safari Mobile, if you want to be able to have the 'click' event fired on child elements, nothing in the DOM can be changed.
            // this is because Safari Mobile will not fire any mouse events (still fires touch though) if the DOM changes during mousemove.
            // so do this change on first touchmove instead of touchstart
            if (force || !(disableDiscovery && allowSwipeInChildren)) $b451cc713fab7e92$var$ReactDOM.flushSync(()=>{
                setMaybeSwiping(true);
            });
            const horizontalSwipe = (0, $b451cc713fab7e92$var$_Drawer.isHorizontal)(anchor);
            if (!open && paperRef.current) // The ref may be null when a parent component updates while swiping.
            setPosition($b451cc713fab7e92$var$getMaxTranslate(horizontalSwipe, paperRef.current) + (disableDiscovery ? 15 : -$b451cc713fab7e92$var$DRAG_STARTED_SIGNAL), {
                changeTransition: false
            });
            swipeInstance.current.velocity = 0;
            swipeInstance.current.lastTime = null;
            swipeInstance.current.lastTranslate = null;
            swipeInstance.current.paperHit = false;
            touchDetected.current = true;
        }
    };
    const handleBodyTouchMove = (0, $b451cc713fab7e92$var$_useEventCallback.default)((nativeEvent)=>{
        // the ref may be null when a parent component updates while swiping
        if (!paperRef.current || !touchDetected.current) return;
        // We are not supposed to handle this touch move because the swipe was started in a scrollable container in the drawer
        if ($b451cc713fab7e92$var$claimedSwipeInstance !== null && $b451cc713fab7e92$var$claimedSwipeInstance !== swipeInstance.current) return;
        startMaybeSwiping(true);
        const anchorRtl = (0, $b451cc713fab7e92$var$_Drawer.getAnchor)(theme, anchor);
        const horizontalSwipe = (0, $b451cc713fab7e92$var$_Drawer.isHorizontal)(anchor);
        const currentX = $b451cc713fab7e92$var$calculateCurrentX(anchorRtl, nativeEvent.touches, (0, $b451cc713fab7e92$var$_ownerDocument.default)(nativeEvent.currentTarget));
        const currentY = $b451cc713fab7e92$var$calculateCurrentY(anchorRtl, nativeEvent.touches, (0, $b451cc713fab7e92$var$_ownerWindow.default)(nativeEvent.currentTarget));
        if (open && (0, $b451cc713fab7e92$var$_contains.default)(paperRef.current, nativeEvent.target) && $b451cc713fab7e92$var$claimedSwipeInstance === null) {
            const domTreeShapes = $b451cc713fab7e92$var$getDomTreeShapes(nativeEvent.target, paperRef.current);
            const hasNativeHandler = $b451cc713fab7e92$var$computeHasNativeHandler({
                domTreeShapes: domTreeShapes,
                start: horizontalSwipe ? swipeInstance.current.startX : swipeInstance.current.startY,
                current: horizontalSwipe ? currentX : currentY,
                anchor: anchor
            });
            if (hasNativeHandler) {
                $b451cc713fab7e92$var$claimedSwipeInstance = true;
                return;
            }
            $b451cc713fab7e92$var$claimedSwipeInstance = swipeInstance.current;
        }
        // We don't know yet.
        if (swipeInstance.current.isSwiping == null) {
            const dx = Math.abs(currentX - swipeInstance.current.startX);
            const dy = Math.abs(currentY - swipeInstance.current.startY);
            const definitelySwiping = horizontalSwipe ? dx > dy && dx > $b451cc713fab7e92$var$UNCERTAINTY_THRESHOLD : dy > dx && dy > $b451cc713fab7e92$var$UNCERTAINTY_THRESHOLD;
            if (definitelySwiping && nativeEvent.cancelable) nativeEvent.preventDefault();
            if (definitelySwiping === true || (horizontalSwipe ? dy > $b451cc713fab7e92$var$UNCERTAINTY_THRESHOLD : dx > $b451cc713fab7e92$var$UNCERTAINTY_THRESHOLD)) {
                swipeInstance.current.isSwiping = definitelySwiping;
                if (!definitelySwiping) {
                    handleBodyTouchEnd(nativeEvent);
                    return;
                }
                // Shift the starting point.
                swipeInstance.current.startX = currentX;
                swipeInstance.current.startY = currentY;
                // Compensate for the part of the drawer displayed on touch start.
                if (!disableDiscovery && !open) {
                    if (horizontalSwipe) swipeInstance.current.startX -= $b451cc713fab7e92$var$DRAG_STARTED_SIGNAL;
                    else swipeInstance.current.startY -= $b451cc713fab7e92$var$DRAG_STARTED_SIGNAL;
                }
            }
        }
        if (!swipeInstance.current.isSwiping) return;
        const maxTranslate = $b451cc713fab7e92$var$getMaxTranslate(horizontalSwipe, paperRef.current);
        let startLocation = horizontalSwipe ? swipeInstance.current.startX : swipeInstance.current.startY;
        if (open && !swipeInstance.current.paperHit) startLocation = Math.min(startLocation, maxTranslate);
        const translate = $b451cc713fab7e92$var$getTranslate(horizontalSwipe ? currentX : currentY, startLocation, open, maxTranslate);
        if (open) {
            if (!swipeInstance.current.paperHit) {
                const paperHit = horizontalSwipe ? currentX < maxTranslate : currentY < maxTranslate;
                if (paperHit) {
                    swipeInstance.current.paperHit = true;
                    swipeInstance.current.startX = currentX;
                    swipeInstance.current.startY = currentY;
                } else return;
            } else if (translate === 0) {
                swipeInstance.current.startX = currentX;
                swipeInstance.current.startY = currentY;
            }
        }
        if (swipeInstance.current.lastTranslate === null) {
            swipeInstance.current.lastTranslate = translate;
            swipeInstance.current.lastTime = performance.now() + 1;
        }
        const velocity = (translate - swipeInstance.current.lastTranslate) / (performance.now() - swipeInstance.current.lastTime) * 1e3;
        // Low Pass filter.
        swipeInstance.current.velocity = swipeInstance.current.velocity * 0.4 + velocity * 0.6;
        swipeInstance.current.lastTranslate = translate;
        swipeInstance.current.lastTime = performance.now();
        // We are swiping, let's prevent the scroll event on iOS.
        if (nativeEvent.cancelable) nativeEvent.preventDefault();
        setPosition(translate);
    });
    const handleBodyTouchStart = (0, $b451cc713fab7e92$var$_useEventCallback.default)((nativeEvent)=>{
        // We are not supposed to handle this touch move.
        // Example of use case: ignore the event if there is a Slider.
        if (nativeEvent.defaultPrevented) return;
        // We can only have one node at the time claiming ownership for handling the swipe.
        if (nativeEvent.defaultMuiPrevented) return;
        // At least one element clogs the drawer interaction zone.
        if (open && (hideBackdrop || !(0, $b451cc713fab7e92$var$_contains.default)(backdropRef.current, nativeEvent.target)) && !(0, $b451cc713fab7e92$var$_contains.default)(paperRef.current, nativeEvent.target)) return;
        const anchorRtl = (0, $b451cc713fab7e92$var$_Drawer.getAnchor)(theme, anchor);
        const horizontalSwipe = (0, $b451cc713fab7e92$var$_Drawer.isHorizontal)(anchor);
        const currentX = $b451cc713fab7e92$var$calculateCurrentX(anchorRtl, nativeEvent.touches, (0, $b451cc713fab7e92$var$_ownerDocument.default)(nativeEvent.currentTarget));
        const currentY = $b451cc713fab7e92$var$calculateCurrentY(anchorRtl, nativeEvent.touches, (0, $b451cc713fab7e92$var$_ownerWindow.default)(nativeEvent.currentTarget));
        if (!open) {
            // logic for if swipe should be ignored:
            // if disableSwipeToOpen
            // if target != swipeArea, and target is not a child of paper ref
            // if is a child of paper ref, and `allowSwipeInChildren` does not allow it
            if (disableSwipeToOpen || !(nativeEvent.target === swipeAreaRef.current || (0, $b451cc713fab7e92$var$_contains.default)(paperRef.current, nativeEvent.target) && (typeof allowSwipeInChildren === 'function' ? allowSwipeInChildren(nativeEvent, swipeAreaRef.current, paperRef.current) : allowSwipeInChildren))) return;
            if (horizontalSwipe) {
                if (currentX > swipeAreaWidth) return;
            } else if (currentY > swipeAreaWidth) return;
        }
        nativeEvent.defaultMuiPrevented = true;
        $b451cc713fab7e92$var$claimedSwipeInstance = null;
        swipeInstance.current.startX = currentX;
        swipeInstance.current.startY = currentY;
        startMaybeSwiping();
    });
    $b451cc713fab7e92$var$React.useEffect(()=>{
        if (variant === 'temporary') {
            const doc = (0, $b451cc713fab7e92$var$_ownerDocument.default)(paperRef.current);
            doc.addEventListener('touchstart', handleBodyTouchStart);
            // A blocking listener prevents Firefox's navbar to auto-hide on scroll.
            // It only needs to prevent scrolling on the drawer's content when open.
            // When closed, the overlay prevents scrolling.
            doc.addEventListener('touchmove', handleBodyTouchMove, {
                passive: !open
            });
            doc.addEventListener('touchend', handleBodyTouchEnd);
            return ()=>{
                doc.removeEventListener('touchstart', handleBodyTouchStart);
                doc.removeEventListener('touchmove', handleBodyTouchMove, {
                    passive: !open
                });
                doc.removeEventListener('touchend', handleBodyTouchEnd);
            };
        }
        return undefined;
    }, [
        variant,
        open,
        handleBodyTouchStart,
        handleBodyTouchMove,
        handleBodyTouchEnd
    ]);
    $b451cc713fab7e92$var$React.useEffect(()=>()=>{
            // We need to release the lock.
            if ($b451cc713fab7e92$var$claimedSwipeInstance === swipeInstance.current) $b451cc713fab7e92$var$claimedSwipeInstance = null;
        }, []);
    $b451cc713fab7e92$var$React.useEffect(()=>{
        if (!open) setMaybeSwiping(false);
    }, [
        open
    ]);
    const [SwipeAreaSlot, swipeAreaSlotProps] = (0, $b451cc713fab7e92$var$_useSlot.default)('swipeArea', {
        ref: swipeAreaRef,
        elementType: $b451cc713fab7e92$var$_SwipeArea.default,
        ownerState: props,
        externalForwardedProps: {
            slots: slots,
            slotProps: {
                swipeArea: SwipeAreaProps,
                ...slotProps
            }
        },
        additionalProps: {
            width: swipeAreaWidth,
            anchor: anchor
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($b451cc713fab7e92$var$React.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($b451cc713fab7e92$var$_Drawer.default, {
                open: variant === 'temporary' && maybeSwiping ? true : open,
                variant: variant,
                ModalProps: {
                    BackdropProps: {
                        ...BackdropProps,
                        ref: backdropRef
                    },
                    // Ensures that paperRef.current will be defined inside the touch start event handler
                    // See https://github.com/mui/material-ui/issues/30414 for more information
                    ...variant === 'temporary' && {
                        keepMounted: true
                    },
                    ...ModalPropsProp
                },
                hideBackdrop: hideBackdrop,
                anchor: anchor,
                transitionDuration: calculatedDurationRef.current || transitionDuration,
                onClose: onClose,
                ref: ref,
                slots: slots,
                slotProps: {
                    ...slotProps,
                    backdrop: (0, $hGPki.mergeSlotProps)(slotProps.backdrop ?? BackdropProps, {
                        ref: backdropRef
                    }),
                    paper: (0, $hGPki.mergeSlotProps)(slotProps.paper ?? PaperProps, {
                        style: {
                            pointerEvents: variant === 'temporary' && !open && !allowSwipeInChildren ? 'none' : ''
                        },
                        ref: handleRef
                    })
                },
                ...other
            }),
            !disableSwipeToOpen && variant === 'temporary' && /*#__PURE__*/ (0, $ayMG0.jsx)($b451cc713fab7e92$var$_NoSsr.default, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(SwipeAreaSlot, {
                    ...swipeAreaSlotProps
                })
            })
        ]
    });
});
$b451cc713fab7e92$var$SwipeableDrawer.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * If set to true, the swipe event will open the drawer even if the user begins the swipe on one of the drawer's children.
   * This can be useful in scenarios where the drawer is partially visible.
   * You can customize it further with a callback that determines which children the user can drag over to open the drawer
   * (for example, to ignore other elements that handle touch move events, like sliders).
   *
   * @param {TouchEvent} event The 'touchstart' event
   * @param {HTMLDivElement} swipeArea The swipe area element
   * @param {HTMLDivElement} paper The drawer's paper element
   *
   * @default false
   */ allowSwipeInChildren: $b451cc713fab7e92$var$_propTypes.default.oneOfType([
        $b451cc713fab7e92$var$_propTypes.default.func,
        $b451cc713fab7e92$var$_propTypes.default.bool
    ]),
    /**
   * @ignore
   */ anchor: $b451cc713fab7e92$var$_propTypes.default.oneOf([
        'bottom',
        'left',
        'right',
        'top'
    ]),
    /**
   * The content of the component.
   */ children: $b451cc713fab7e92$var$_propTypes.default.node,
    /**
   * Disable the backdrop transition.
   * This can improve the FPS on low-end devices.
   * @default false
   */ disableBackdropTransition: $b451cc713fab7e92$var$_propTypes.default.bool,
    /**
   * If `true`, touching the screen near the edge of the drawer will not slide in the drawer a bit
   * to promote accidental discovery of the swipe gesture.
   * @default false
   */ disableDiscovery: $b451cc713fab7e92$var$_propTypes.default.bool,
    /**
   * If `true`, swipe to open is disabled. This is useful in browsers where swiping triggers
   * navigation actions. Swipe to open is disabled on iOS browsers by default.
   * @default typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent)
   */ disableSwipeToOpen: $b451cc713fab7e92$var$_propTypes.default.bool,
    /**
   * @ignore
   */ hideBackdrop: $b451cc713fab7e92$var$_propTypes.default.bool,
    /**
   * Affects how far the drawer must be opened/closed to change its state.
   * Specified as percent (0-1) of the width of the drawer
   * @default 0.52
   */ hysteresis: $b451cc713fab7e92$var$_propTypes.default.number,
    /**
   * Defines, from which (average) velocity on, the swipe is
   * defined as complete although hysteresis isn't reached.
   * Good threshold is between 250 - 1000 px/s
   * @default 450
   */ minFlingVelocity: $b451cc713fab7e92$var$_propTypes.default.number,
    /**
   * @ignore
   */ ModalProps: $b451cc713fab7e92$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .shape({
        BackdropProps: $b451cc713fab7e92$var$_propTypes.default.shape({
            component: $b451cc713fab7e92$var$_elementTypeAcceptingRef.default
        })
    }),
    /**
   * Callback fired when the component requests to be closed.
   *
   * @param {React.SyntheticEvent<{}>} event The event source of the callback.
   */ onClose: $b451cc713fab7e92$var$_propTypes.default.func.isRequired,
    /**
   * Callback fired when the component requests to be opened.
   *
   * @param {React.SyntheticEvent<{}>} event The event source of the callback.
   */ onOpen: $b451cc713fab7e92$var$_propTypes.default.func.isRequired,
    /**
   * If `true`, the component is shown.
   * @default false
   */ open: $b451cc713fab7e92$var$_propTypes.default.bool,
    /**
   * @ignore
   */ PaperProps: $b451cc713fab7e92$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .shape({
        component: $b451cc713fab7e92$var$_elementTypeAcceptingRef.default,
        style: $b451cc713fab7e92$var$_propTypes.default.object
    }),
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $b451cc713fab7e92$var$_propTypes.default.shape({
        backdrop: $b451cc713fab7e92$var$_propTypes.default.oneOfType([
            $b451cc713fab7e92$var$_propTypes.default.func,
            $b451cc713fab7e92$var$_propTypes.default.object
        ]),
        docked: $b451cc713fab7e92$var$_propTypes.default.oneOfType([
            $b451cc713fab7e92$var$_propTypes.default.func,
            $b451cc713fab7e92$var$_propTypes.default.object
        ]),
        paper: $b451cc713fab7e92$var$_propTypes.default.oneOfType([
            $b451cc713fab7e92$var$_propTypes.default.func,
            $b451cc713fab7e92$var$_propTypes.default.object
        ]),
        root: $b451cc713fab7e92$var$_propTypes.default.oneOfType([
            $b451cc713fab7e92$var$_propTypes.default.func,
            $b451cc713fab7e92$var$_propTypes.default.object
        ]),
        swipeArea: $b451cc713fab7e92$var$_propTypes.default.oneOfType([
            $b451cc713fab7e92$var$_propTypes.default.func,
            $b451cc713fab7e92$var$_propTypes.default.object
        ]),
        transition: $b451cc713fab7e92$var$_propTypes.default.oneOfType([
            $b451cc713fab7e92$var$_propTypes.default.func,
            $b451cc713fab7e92$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: $b451cc713fab7e92$var$_propTypes.default.shape({
        backdrop: $b451cc713fab7e92$var$_propTypes.default.elementType,
        docked: $b451cc713fab7e92$var$_propTypes.default.elementType,
        paper: $b451cc713fab7e92$var$_propTypes.default.elementType,
        root: $b451cc713fab7e92$var$_propTypes.default.elementType,
        swipeArea: $b451cc713fab7e92$var$_propTypes.default.elementType,
        transition: $b451cc713fab7e92$var$_propTypes.default.elementType
    }),
    /**
   * The element is used to intercept the touch events on the edge.
   * @deprecated use the `slotProps.swipeArea` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ SwipeAreaProps: $b451cc713fab7e92$var$_propTypes.default.object,
    /**
   * The width of the left most (or right most) area in `px` that
   * the drawer can be swiped open from.
   * @default 20
   */ swipeAreaWidth: $b451cc713fab7e92$var$_propTypes.default.number,
    /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */ transitionDuration: $b451cc713fab7e92$var$_propTypes.default.oneOfType([
        $b451cc713fab7e92$var$_propTypes.default.number,
        $b451cc713fab7e92$var$_propTypes.default.shape({
            appear: $b451cc713fab7e92$var$_propTypes.default.number,
            enter: $b451cc713fab7e92$var$_propTypes.default.number,
            exit: $b451cc713fab7e92$var$_propTypes.default.number
        })
    ]),
    /**
   * @ignore
   */ variant: $b451cc713fab7e92$var$_propTypes.default.oneOf([
        'permanent',
        'persistent',
        'temporary'
    ])
};
var $b451cc713fab7e92$var$_default = module.exports.default = $b451cc713fab7e92$var$SwipeableDrawer;

});
parcelRegister("gQeSR", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $c42d0c4e6d0277b4$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $c42d0c4e6d0277b4$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c42d0c4e6d0277b4$var$React = $c42d0c4e6d0277b4$require$_interopRequireWildcard((parcelRequire("acw62")));

var $c42d0c4e6d0277b4$var$_propTypes = $c42d0c4e6d0277b4$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $c42d0c4e6d0277b4$var$_clsx = $c42d0c4e6d0277b4$require$_interopRequireDefault((parcelRequire("9QePP")));

var $aAbgT = parcelRequire("aAbgT");

var $c42d0c4e6d0277b4$var$_memoTheme = $c42d0c4e6d0277b4$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $c42d0c4e6d0277b4$var$_rootShouldForwardProp = $c42d0c4e6d0277b4$require$_interopRequireDefault((parcelRequire("8Uq77")));

var $c42d0c4e6d0277b4$var$_capitalize = $c42d0c4e6d0277b4$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $2Ed4H = parcelRequire("2Ed4H");

var $ayMG0 = parcelRequire("ayMG0");
const $c42d0c4e6d0277b4$var$SwipeAreaRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiSwipeArea',
    shouldForwardProp: $c42d0c4e6d0277b4$var$_rootShouldForwardProp.default
})((0, $c42d0c4e6d0277b4$var$_memoTheme.default)(({ theme: theme })=>({
        position: 'fixed',
        top: 0,
        left: 0,
        bottom: 0,
        zIndex: theme.zIndex.drawer - 1,
        variants: [
            {
                props: {
                    anchor: 'left'
                },
                style: {
                    right: 'auto'
                }
            },
            {
                props: {
                    anchor: 'right'
                },
                style: {
                    left: 'auto',
                    right: 0
                }
            },
            {
                props: {
                    anchor: 'top'
                },
                style: {
                    bottom: 'auto',
                    right: 0
                }
            },
            {
                props: {
                    anchor: 'bottom'
                },
                style: {
                    top: 'auto',
                    bottom: 0,
                    right: 0
                }
            }
        ]
    })));
/**
 * @ignore - internal component.
 */ const $c42d0c4e6d0277b4$var$SwipeArea = /*#__PURE__*/ $c42d0c4e6d0277b4$var$React.forwardRef(function SwipeArea(props, ref) {
    const { anchor: anchor, classes: classes = {}, className: className, width: width, style: style, ...other } = props;
    const ownerState = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($c42d0c4e6d0277b4$var$SwipeAreaRoot, {
        className: (0, $c42d0c4e6d0277b4$var$_clsx.default)('PrivateSwipeArea-root', classes.root, classes[`anchor${(0, $c42d0c4e6d0277b4$var$_capitalize.default)(anchor)}`], className),
        ref: ref,
        style: {
            [(0, $2Ed4H.isHorizontal)(anchor) ? 'width' : 'height']: width,
            ...style
        },
        ownerState: ownerState,
        ...other
    });
});
$c42d0c4e6d0277b4$var$SwipeArea.propTypes = {
    /**
   * Side on which to attach the discovery area.
   */ anchor: $c42d0c4e6d0277b4$var$_propTypes.default.oneOf([
        'left',
        'top',
        'right',
        'bottom'
    ]).isRequired,
    /**
   * @ignore
   */ classes: $c42d0c4e6d0277b4$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $c42d0c4e6d0277b4$var$_propTypes.default.string,
    /**
   * @ignore
   */ style: $c42d0c4e6d0277b4$var$_propTypes.default.object,
    /**
   * The width of the left most (or right most) area in `px` where the
   * drawer can be swiped open from.
   */ width: $c42d0c4e6d0277b4$var$_propTypes.default.number.isRequired
};
var $c42d0c4e6d0277b4$var$_default = module.exports.default = $c42d0c4e6d0277b4$var$SwipeArea;

});



parcelRegister("bGe9g", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $880e97827fd7145b$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $880e97827fd7145b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $880e97827fd7145b$var$_exportNames = {
    tableClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $880e97827fd7145b$var$_Table.default;
    }
});
Object.defineProperty(module.exports, "tableClasses", {
    enumerable: true,
    get: function() {
        return $880e97827fd7145b$var$_tableClasses.default;
    }
});

var $880e97827fd7145b$var$_Table = $880e97827fd7145b$require$_interopRequireDefault((parcelRequire("30hyv")));

var $880e97827fd7145b$var$_tableClasses = $880e97827fd7145b$require$_interopRequireWildcard((parcelRequire("5kXxI")));
Object.keys($880e97827fd7145b$var$_tableClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($880e97827fd7145b$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $880e97827fd7145b$var$_tableClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $880e97827fd7145b$var$_tableClasses[key];
        }
    });
});

});
parcelRegister("30hyv", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $22fefd5f207422b3$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $22fefd5f207422b3$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $22fefd5f207422b3$var$React = $22fefd5f207422b3$require$_interopRequireWildcard((parcelRequire("acw62")));

var $22fefd5f207422b3$var$_propTypes = $22fefd5f207422b3$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $22fefd5f207422b3$var$_clsx = $22fefd5f207422b3$require$_interopRequireDefault((parcelRequire("9QePP")));

var $22fefd5f207422b3$var$_composeClasses = $22fefd5f207422b3$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $22fefd5f207422b3$var$_TableContext = $22fefd5f207422b3$require$_interopRequireDefault((parcelRequire("jWrFr")));

var $aAbgT = parcelRequire("aAbgT");

var $22fefd5f207422b3$var$_memoTheme = $22fefd5f207422b3$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $5kXxI = parcelRequire("5kXxI");

var $ayMG0 = parcelRequire("ayMG0");
const $22fefd5f207422b3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            stickyHeader && 'stickyHeader'
        ]
    };
    return (0, $22fefd5f207422b3$var$_composeClasses.default)(slots, $5kXxI.getTableUtilityClass, classes);
};
const $22fefd5f207422b3$var$TableRoot = (0, $aAbgT.styled)('table', {
    name: 'MuiTable',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})((0, $22fefd5f207422b3$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'table',
        width: '100%',
        borderCollapse: 'collapse',
        borderSpacing: 0,
        '& caption': {
            ...theme.typography.body2,
            padding: theme.spacing(2),
            color: (theme.vars || theme).palette.text.secondary,
            textAlign: 'left',
            captionSide: 'bottom'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.stickyHeader,
                style: {
                    borderCollapse: 'separate'
                }
            }
        ]
    })));
const $22fefd5f207422b3$var$defaultComponent = 'table';
const $22fefd5f207422b3$var$Table = /*#__PURE__*/ $22fefd5f207422b3$var$React.forwardRef(function Table(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiTable'
    });
    const { className: className, component: component = $22fefd5f207422b3$var$defaultComponent, padding: padding = 'normal', size: size = 'medium', stickyHeader: stickyHeader = false, ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        padding: padding,
        size: size,
        stickyHeader: stickyHeader
    };
    const classes = $22fefd5f207422b3$var$useUtilityClasses(ownerState);
    const table = $22fefd5f207422b3$var$React.useMemo(()=>({
            padding: padding,
            size: size,
            stickyHeader: stickyHeader
        }), [
        padding,
        size,
        stickyHeader
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($22fefd5f207422b3$var$_TableContext.default.Provider, {
        value: table,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($22fefd5f207422b3$var$TableRoot, {
            as: component,
            role: component === $22fefd5f207422b3$var$defaultComponent ? null : 'table',
            ref: ref,
            className: (0, $22fefd5f207422b3$var$_clsx.default)(classes.root, className),
            ownerState: ownerState,
            ...other
        })
    });
});
$22fefd5f207422b3$var$Table.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the table, normally `TableHead` and `TableBody`.
   */ children: $22fefd5f207422b3$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $22fefd5f207422b3$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $22fefd5f207422b3$var$_propTypes.default.string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $22fefd5f207422b3$var$_propTypes.default.elementType,
    /**
   * Allows TableCells to inherit padding of the Table.
   * @default 'normal'
   */ padding: $22fefd5f207422b3$var$_propTypes.default.oneOf([
        'checkbox',
        'none',
        'normal'
    ]),
    /**
   * Allows TableCells to inherit size of the Table.
   * @default 'medium'
   */ size: $22fefd5f207422b3$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $22fefd5f207422b3$var$_propTypes.default.oneOf([
            'medium',
            'small'
        ]),
        $22fefd5f207422b3$var$_propTypes.default.string
    ]),
    /**
   * Set the header sticky.
   * @default false
   */ stickyHeader: $22fefd5f207422b3$var$_propTypes.default.bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $22fefd5f207422b3$var$_propTypes.default.oneOfType([
        $22fefd5f207422b3$var$_propTypes.default.arrayOf($22fefd5f207422b3$var$_propTypes.default.oneOfType([
            $22fefd5f207422b3$var$_propTypes.default.func,
            $22fefd5f207422b3$var$_propTypes.default.object,
            $22fefd5f207422b3$var$_propTypes.default.bool
        ])),
        $22fefd5f207422b3$var$_propTypes.default.func,
        $22fefd5f207422b3$var$_propTypes.default.object
    ])
};
var $22fefd5f207422b3$var$_default = module.exports.default = $22fefd5f207422b3$var$Table;

});
parcelRegister("5kXxI", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3e2d01fd3f88b8c8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getTableUtilityClass = $3e2d01fd3f88b8c8$var$getTableUtilityClass;

var $3e2d01fd3f88b8c8$var$_generateUtilityClasses = $3e2d01fd3f88b8c8$require$_interopRequireDefault((parcelRequire("5nY49")));

var $3e2d01fd3f88b8c8$var$_generateUtilityClass = $3e2d01fd3f88b8c8$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $3e2d01fd3f88b8c8$var$getTableUtilityClass(slot) {
    return (0, $3e2d01fd3f88b8c8$var$_generateUtilityClass.default)('MuiTable', slot);
}
const $3e2d01fd3f88b8c8$var$tableClasses = (0, $3e2d01fd3f88b8c8$var$_generateUtilityClasses.default)('MuiTable', [
    'root',
    'stickyHeader'
]);
var $3e2d01fd3f88b8c8$var$_default = module.exports.default = $3e2d01fd3f88b8c8$var$tableClasses;

});



parcelRegister("5hLrb", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $3d935658447069c3$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $3d935658447069c3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $3d935658447069c3$var$_exportNames = {
    tableBodyClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $3d935658447069c3$var$_TableBody.default;
    }
});
Object.defineProperty(module.exports, "tableBodyClasses", {
    enumerable: true,
    get: function() {
        return $3d935658447069c3$var$_tableBodyClasses.default;
    }
});

var $3d935658447069c3$var$_TableBody = $3d935658447069c3$require$_interopRequireDefault((parcelRequire("QpuKB")));

var $3d935658447069c3$var$_tableBodyClasses = $3d935658447069c3$require$_interopRequireWildcard((parcelRequire("dfSTK")));
Object.keys($3d935658447069c3$var$_tableBodyClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($3d935658447069c3$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $3d935658447069c3$var$_tableBodyClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3d935658447069c3$var$_tableBodyClasses[key];
        }
    });
});

});
parcelRegister("QpuKB", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $09d8a23708c3ccc9$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $09d8a23708c3ccc9$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $09d8a23708c3ccc9$var$React = $09d8a23708c3ccc9$require$_interopRequireWildcard((parcelRequire("acw62")));

var $09d8a23708c3ccc9$var$_propTypes = $09d8a23708c3ccc9$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $09d8a23708c3ccc9$var$_clsx = $09d8a23708c3ccc9$require$_interopRequireDefault((parcelRequire("9QePP")));

var $09d8a23708c3ccc9$var$_composeClasses = $09d8a23708c3ccc9$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $09d8a23708c3ccc9$var$_Tablelvl2Context = $09d8a23708c3ccc9$require$_interopRequireDefault((parcelRequire("RbMj7")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $dfSTK = parcelRequire("dfSTK");

var $ayMG0 = parcelRequire("ayMG0");
const $09d8a23708c3ccc9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $09d8a23708c3ccc9$var$_composeClasses.default)(slots, $dfSTK.getTableBodyUtilityClass, classes);
};
const $09d8a23708c3ccc9$var$TableBodyRoot = (0, $aAbgT.styled)('tbody', {
    name: 'MuiTableBody',
    slot: 'Root'
})({
    display: 'table-row-group'
});
const $09d8a23708c3ccc9$var$tablelvl2 = {
    variant: 'body'
};
const $09d8a23708c3ccc9$var$defaultComponent = 'tbody';
const $09d8a23708c3ccc9$var$TableBody = /*#__PURE__*/ $09d8a23708c3ccc9$var$React.forwardRef(function TableBody(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiTableBody'
    });
    const { className: className, component: component = $09d8a23708c3ccc9$var$defaultComponent, ...other } = props;
    const ownerState = {
        ...props,
        component: component
    };
    const classes = $09d8a23708c3ccc9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($09d8a23708c3ccc9$var$_Tablelvl2Context.default.Provider, {
        value: $09d8a23708c3ccc9$var$tablelvl2,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($09d8a23708c3ccc9$var$TableBodyRoot, {
            className: (0, $09d8a23708c3ccc9$var$_clsx.default)(classes.root, className),
            as: component,
            ref: ref,
            role: component === $09d8a23708c3ccc9$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState,
            ...other
        })
    });
});
$09d8a23708c3ccc9$var$TableBody.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component, normally `TableRow`.
   */ children: $09d8a23708c3ccc9$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $09d8a23708c3ccc9$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $09d8a23708c3ccc9$var$_propTypes.default.string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $09d8a23708c3ccc9$var$_propTypes.default.elementType,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $09d8a23708c3ccc9$var$_propTypes.default.oneOfType([
        $09d8a23708c3ccc9$var$_propTypes.default.arrayOf($09d8a23708c3ccc9$var$_propTypes.default.oneOfType([
            $09d8a23708c3ccc9$var$_propTypes.default.func,
            $09d8a23708c3ccc9$var$_propTypes.default.object,
            $09d8a23708c3ccc9$var$_propTypes.default.bool
        ])),
        $09d8a23708c3ccc9$var$_propTypes.default.func,
        $09d8a23708c3ccc9$var$_propTypes.default.object
    ])
};
var $09d8a23708c3ccc9$var$_default = module.exports.default = $09d8a23708c3ccc9$var$TableBody;

});
parcelRegister("dfSTK", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9a6742b7048414d1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getTableBodyUtilityClass = $9a6742b7048414d1$var$getTableBodyUtilityClass;

var $9a6742b7048414d1$var$_generateUtilityClasses = $9a6742b7048414d1$require$_interopRequireDefault((parcelRequire("5nY49")));

var $9a6742b7048414d1$var$_generateUtilityClass = $9a6742b7048414d1$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $9a6742b7048414d1$var$getTableBodyUtilityClass(slot) {
    return (0, $9a6742b7048414d1$var$_generateUtilityClass.default)('MuiTableBody', slot);
}
const $9a6742b7048414d1$var$tableBodyClasses = (0, $9a6742b7048414d1$var$_generateUtilityClasses.default)('MuiTableBody', [
    'root'
]);
var $9a6742b7048414d1$var$_default = module.exports.default = $9a6742b7048414d1$var$tableBodyClasses;

});



parcelRegister("12YAp", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $0c34f9894e705401$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $0c34f9894e705401$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $0c34f9894e705401$var$_exportNames = {
    tableContainerClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $0c34f9894e705401$var$_TableContainer.default;
    }
});
Object.defineProperty(module.exports, "tableContainerClasses", {
    enumerable: true,
    get: function() {
        return $0c34f9894e705401$var$_tableContainerClasses.default;
    }
});

var $0c34f9894e705401$var$_TableContainer = $0c34f9894e705401$require$_interopRequireDefault((parcelRequire("81yMd")));

var $0c34f9894e705401$var$_tableContainerClasses = $0c34f9894e705401$require$_interopRequireWildcard((parcelRequire("lNHXc")));
Object.keys($0c34f9894e705401$var$_tableContainerClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($0c34f9894e705401$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $0c34f9894e705401$var$_tableContainerClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $0c34f9894e705401$var$_tableContainerClasses[key];
        }
    });
});

});
parcelRegister("81yMd", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $5d7964a6269b66c8$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $5d7964a6269b66c8$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5d7964a6269b66c8$var$React = $5d7964a6269b66c8$require$_interopRequireWildcard((parcelRequire("acw62")));

var $5d7964a6269b66c8$var$_propTypes = $5d7964a6269b66c8$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $5d7964a6269b66c8$var$_clsx = $5d7964a6269b66c8$require$_interopRequireDefault((parcelRequire("9QePP")));

var $5d7964a6269b66c8$var$_composeClasses = $5d7964a6269b66c8$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $lNHXc = parcelRequire("lNHXc");

var $ayMG0 = parcelRequire("ayMG0");
const $5d7964a6269b66c8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $5d7964a6269b66c8$var$_composeClasses.default)(slots, $lNHXc.getTableContainerUtilityClass, classes);
};
const $5d7964a6269b66c8$var$TableContainerRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiTableContainer',
    slot: 'Root'
})({
    width: '100%',
    overflowX: 'auto'
});
const $5d7964a6269b66c8$var$TableContainer = /*#__PURE__*/ $5d7964a6269b66c8$var$React.forwardRef(function TableContainer(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiTableContainer'
    });
    const { className: className, component: component = 'div', ...other } = props;
    const ownerState = {
        ...props,
        component: component
    };
    const classes = $5d7964a6269b66c8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5d7964a6269b66c8$var$TableContainerRoot, {
        ref: ref,
        as: component,
        className: (0, $5d7964a6269b66c8$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        ...other
    });
});
$5d7964a6269b66c8$var$TableContainer.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component, normally `Table`.
   */ children: $5d7964a6269b66c8$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $5d7964a6269b66c8$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $5d7964a6269b66c8$var$_propTypes.default.string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $5d7964a6269b66c8$var$_propTypes.default.elementType,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $5d7964a6269b66c8$var$_propTypes.default.oneOfType([
        $5d7964a6269b66c8$var$_propTypes.default.arrayOf($5d7964a6269b66c8$var$_propTypes.default.oneOfType([
            $5d7964a6269b66c8$var$_propTypes.default.func,
            $5d7964a6269b66c8$var$_propTypes.default.object,
            $5d7964a6269b66c8$var$_propTypes.default.bool
        ])),
        $5d7964a6269b66c8$var$_propTypes.default.func,
        $5d7964a6269b66c8$var$_propTypes.default.object
    ])
};
var $5d7964a6269b66c8$var$_default = module.exports.default = $5d7964a6269b66c8$var$TableContainer;

});
parcelRegister("lNHXc", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $fdf044e88b1c9ad4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getTableContainerUtilityClass = $fdf044e88b1c9ad4$var$getTableContainerUtilityClass;

var $fdf044e88b1c9ad4$var$_generateUtilityClasses = $fdf044e88b1c9ad4$require$_interopRequireDefault((parcelRequire("5nY49")));

var $fdf044e88b1c9ad4$var$_generateUtilityClass = $fdf044e88b1c9ad4$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $fdf044e88b1c9ad4$var$getTableContainerUtilityClass(slot) {
    return (0, $fdf044e88b1c9ad4$var$_generateUtilityClass.default)('MuiTableContainer', slot);
}
const $fdf044e88b1c9ad4$var$tableContainerClasses = (0, $fdf044e88b1c9ad4$var$_generateUtilityClasses.default)('MuiTableContainer', [
    'root'
]);
var $fdf044e88b1c9ad4$var$_default = module.exports.default = $fdf044e88b1c9ad4$var$tableContainerClasses;

});



parcelRegister("7fYtl", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $5488d7a1a9461c14$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $5488d7a1a9461c14$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $5488d7a1a9461c14$var$_exportNames = {
    tableFooterClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $5488d7a1a9461c14$var$_TableFooter.default;
    }
});
Object.defineProperty(module.exports, "tableFooterClasses", {
    enumerable: true,
    get: function() {
        return $5488d7a1a9461c14$var$_tableFooterClasses.default;
    }
});

var $5488d7a1a9461c14$var$_TableFooter = $5488d7a1a9461c14$require$_interopRequireDefault((parcelRequire("lUd3q")));

var $5488d7a1a9461c14$var$_tableFooterClasses = $5488d7a1a9461c14$require$_interopRequireWildcard((parcelRequire("j1Zxr")));
Object.keys($5488d7a1a9461c14$var$_tableFooterClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($5488d7a1a9461c14$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $5488d7a1a9461c14$var$_tableFooterClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5488d7a1a9461c14$var$_tableFooterClasses[key];
        }
    });
});

});
parcelRegister("lUd3q", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $ff28f43fd0d3e223$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $ff28f43fd0d3e223$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ff28f43fd0d3e223$var$React = $ff28f43fd0d3e223$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ff28f43fd0d3e223$var$_propTypes = $ff28f43fd0d3e223$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $ff28f43fd0d3e223$var$_clsx = $ff28f43fd0d3e223$require$_interopRequireDefault((parcelRequire("9QePP")));

var $ff28f43fd0d3e223$var$_composeClasses = $ff28f43fd0d3e223$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $ff28f43fd0d3e223$var$_Tablelvl2Context = $ff28f43fd0d3e223$require$_interopRequireDefault((parcelRequire("RbMj7")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $j1Zxr = parcelRequire("j1Zxr");

var $ayMG0 = parcelRequire("ayMG0");
const $ff28f43fd0d3e223$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $ff28f43fd0d3e223$var$_composeClasses.default)(slots, $j1Zxr.getTableFooterUtilityClass, classes);
};
const $ff28f43fd0d3e223$var$TableFooterRoot = (0, $aAbgT.styled)('tfoot', {
    name: 'MuiTableFooter',
    slot: 'Root'
})({
    display: 'table-footer-group'
});
const $ff28f43fd0d3e223$var$tablelvl2 = {
    variant: 'footer'
};
const $ff28f43fd0d3e223$var$defaultComponent = 'tfoot';
const $ff28f43fd0d3e223$var$TableFooter = /*#__PURE__*/ $ff28f43fd0d3e223$var$React.forwardRef(function TableFooter(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiTableFooter'
    });
    const { className: className, component: component = $ff28f43fd0d3e223$var$defaultComponent, ...other } = props;
    const ownerState = {
        ...props,
        component: component
    };
    const classes = $ff28f43fd0d3e223$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ff28f43fd0d3e223$var$_Tablelvl2Context.default.Provider, {
        value: $ff28f43fd0d3e223$var$tablelvl2,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($ff28f43fd0d3e223$var$TableFooterRoot, {
            as: component,
            className: (0, $ff28f43fd0d3e223$var$_clsx.default)(classes.root, className),
            ref: ref,
            role: component === $ff28f43fd0d3e223$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState,
            ...other
        })
    });
});
$ff28f43fd0d3e223$var$TableFooter.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component, normally `TableRow`.
   */ children: $ff28f43fd0d3e223$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $ff28f43fd0d3e223$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $ff28f43fd0d3e223$var$_propTypes.default.string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $ff28f43fd0d3e223$var$_propTypes.default.elementType,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $ff28f43fd0d3e223$var$_propTypes.default.oneOfType([
        $ff28f43fd0d3e223$var$_propTypes.default.arrayOf($ff28f43fd0d3e223$var$_propTypes.default.oneOfType([
            $ff28f43fd0d3e223$var$_propTypes.default.func,
            $ff28f43fd0d3e223$var$_propTypes.default.object,
            $ff28f43fd0d3e223$var$_propTypes.default.bool
        ])),
        $ff28f43fd0d3e223$var$_propTypes.default.func,
        $ff28f43fd0d3e223$var$_propTypes.default.object
    ])
};
var $ff28f43fd0d3e223$var$_default = module.exports.default = $ff28f43fd0d3e223$var$TableFooter;

});
parcelRegister("j1Zxr", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ddadd89367698db0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getTableFooterUtilityClass = $ddadd89367698db0$var$getTableFooterUtilityClass;

var $ddadd89367698db0$var$_generateUtilityClasses = $ddadd89367698db0$require$_interopRequireDefault((parcelRequire("5nY49")));

var $ddadd89367698db0$var$_generateUtilityClass = $ddadd89367698db0$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $ddadd89367698db0$var$getTableFooterUtilityClass(slot) {
    return (0, $ddadd89367698db0$var$_generateUtilityClass.default)('MuiTableFooter', slot);
}
const $ddadd89367698db0$var$tableFooterClasses = (0, $ddadd89367698db0$var$_generateUtilityClasses.default)('MuiTableFooter', [
    'root'
]);
var $ddadd89367698db0$var$_default = module.exports.default = $ddadd89367698db0$var$tableFooterClasses;

});



parcelRegister("g2Lhl", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $bae181d386a885e4$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $bae181d386a885e4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $bae181d386a885e4$var$_exportNames = {
    tableHeadClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $bae181d386a885e4$var$_TableHead.default;
    }
});
Object.defineProperty(module.exports, "tableHeadClasses", {
    enumerable: true,
    get: function() {
        return $bae181d386a885e4$var$_tableHeadClasses.default;
    }
});

var $bae181d386a885e4$var$_TableHead = $bae181d386a885e4$require$_interopRequireDefault((parcelRequire("hjXJ8")));

var $bae181d386a885e4$var$_tableHeadClasses = $bae181d386a885e4$require$_interopRequireWildcard((parcelRequire("hMbPk")));
Object.keys($bae181d386a885e4$var$_tableHeadClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($bae181d386a885e4$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $bae181d386a885e4$var$_tableHeadClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bae181d386a885e4$var$_tableHeadClasses[key];
        }
    });
});

});
parcelRegister("hjXJ8", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $c9c28a8e795911dc$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $c9c28a8e795911dc$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c9c28a8e795911dc$var$React = $c9c28a8e795911dc$require$_interopRequireWildcard((parcelRequire("acw62")));

var $c9c28a8e795911dc$var$_propTypes = $c9c28a8e795911dc$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $c9c28a8e795911dc$var$_clsx = $c9c28a8e795911dc$require$_interopRequireDefault((parcelRequire("9QePP")));

var $c9c28a8e795911dc$var$_composeClasses = $c9c28a8e795911dc$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $c9c28a8e795911dc$var$_Tablelvl2Context = $c9c28a8e795911dc$require$_interopRequireDefault((parcelRequire("RbMj7")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $hMbPk = parcelRequire("hMbPk");

var $ayMG0 = parcelRequire("ayMG0");
const $c9c28a8e795911dc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $c9c28a8e795911dc$var$_composeClasses.default)(slots, $hMbPk.getTableHeadUtilityClass, classes);
};
const $c9c28a8e795911dc$var$TableHeadRoot = (0, $aAbgT.styled)('thead', {
    name: 'MuiTableHead',
    slot: 'Root'
})({
    display: 'table-header-group'
});
const $c9c28a8e795911dc$var$tablelvl2 = {
    variant: 'head'
};
const $c9c28a8e795911dc$var$defaultComponent = 'thead';
const $c9c28a8e795911dc$var$TableHead = /*#__PURE__*/ $c9c28a8e795911dc$var$React.forwardRef(function TableHead(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiTableHead'
    });
    const { className: className, component: component = $c9c28a8e795911dc$var$defaultComponent, ...other } = props;
    const ownerState = {
        ...props,
        component: component
    };
    const classes = $c9c28a8e795911dc$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($c9c28a8e795911dc$var$_Tablelvl2Context.default.Provider, {
        value: $c9c28a8e795911dc$var$tablelvl2,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($c9c28a8e795911dc$var$TableHeadRoot, {
            as: component,
            className: (0, $c9c28a8e795911dc$var$_clsx.default)(classes.root, className),
            ref: ref,
            role: component === $c9c28a8e795911dc$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState,
            ...other
        })
    });
});
$c9c28a8e795911dc$var$TableHead.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component, normally `TableRow`.
   */ children: $c9c28a8e795911dc$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $c9c28a8e795911dc$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $c9c28a8e795911dc$var$_propTypes.default.string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $c9c28a8e795911dc$var$_propTypes.default.elementType,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $c9c28a8e795911dc$var$_propTypes.default.oneOfType([
        $c9c28a8e795911dc$var$_propTypes.default.arrayOf($c9c28a8e795911dc$var$_propTypes.default.oneOfType([
            $c9c28a8e795911dc$var$_propTypes.default.func,
            $c9c28a8e795911dc$var$_propTypes.default.object,
            $c9c28a8e795911dc$var$_propTypes.default.bool
        ])),
        $c9c28a8e795911dc$var$_propTypes.default.func,
        $c9c28a8e795911dc$var$_propTypes.default.object
    ])
};
var $c9c28a8e795911dc$var$_default = module.exports.default = $c9c28a8e795911dc$var$TableHead;

});
parcelRegister("hMbPk", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $cf1017f12785ebe4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getTableHeadUtilityClass = $cf1017f12785ebe4$var$getTableHeadUtilityClass;

var $cf1017f12785ebe4$var$_generateUtilityClasses = $cf1017f12785ebe4$require$_interopRequireDefault((parcelRequire("5nY49")));

var $cf1017f12785ebe4$var$_generateUtilityClass = $cf1017f12785ebe4$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $cf1017f12785ebe4$var$getTableHeadUtilityClass(slot) {
    return (0, $cf1017f12785ebe4$var$_generateUtilityClass.default)('MuiTableHead', slot);
}
const $cf1017f12785ebe4$var$tableHeadClasses = (0, $cf1017f12785ebe4$var$_generateUtilityClasses.default)('MuiTableHead', [
    'root'
]);
var $cf1017f12785ebe4$var$_default = module.exports.default = $cf1017f12785ebe4$var$tableHeadClasses;

});



parcelRegister("7IILB", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $59ef5e314ba45566$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $59ef5e314ba45566$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $59ef5e314ba45566$var$_exportNames = {
    tableRowClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $59ef5e314ba45566$var$_TableRow.default;
    }
});
Object.defineProperty(module.exports, "tableRowClasses", {
    enumerable: true,
    get: function() {
        return $59ef5e314ba45566$var$_tableRowClasses.default;
    }
});

var $59ef5e314ba45566$var$_TableRow = $59ef5e314ba45566$require$_interopRequireDefault((parcelRequire("2XjE0")));

var $59ef5e314ba45566$var$_tableRowClasses = $59ef5e314ba45566$require$_interopRequireWildcard((parcelRequire("4iLi6")));
Object.keys($59ef5e314ba45566$var$_tableRowClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($59ef5e314ba45566$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $59ef5e314ba45566$var$_tableRowClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $59ef5e314ba45566$var$_tableRowClasses[key];
        }
    });
});

});
parcelRegister("2XjE0", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $22705465ad6920f8$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $22705465ad6920f8$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $22705465ad6920f8$var$React = $22705465ad6920f8$require$_interopRequireWildcard((parcelRequire("acw62")));

var $22705465ad6920f8$var$_propTypes = $22705465ad6920f8$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $22705465ad6920f8$var$_clsx = $22705465ad6920f8$require$_interopRequireDefault((parcelRequire("9QePP")));

var $22705465ad6920f8$var$_composeClasses = $22705465ad6920f8$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $22705465ad6920f8$var$_Tablelvl2Context = $22705465ad6920f8$require$_interopRequireDefault((parcelRequire("RbMj7")));

var $aAbgT = parcelRequire("aAbgT");

var $22705465ad6920f8$var$_memoTheme = $22705465ad6920f8$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $22705465ad6920f8$var$_tableRowClasses = $22705465ad6920f8$require$_interopRequireWildcard((parcelRequire("4iLi6")));

var $ayMG0 = parcelRequire("ayMG0");
const $22705465ad6920f8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected, hover: hover, head: head, footer: footer } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            hover && 'hover',
            head && 'head',
            footer && 'footer'
        ]
    };
    return (0, $22705465ad6920f8$var$_composeClasses.default)(slots, $22705465ad6920f8$var$_tableRowClasses.getTableRowUtilityClass, classes);
};
const $22705465ad6920f8$var$TableRowRoot = (0, $aAbgT.styled)('tr', {
    name: 'MuiTableRow',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.head && styles.head,
            ownerState.footer && styles.footer
        ];
    }
})((0, $22705465ad6920f8$var$_memoTheme.default)(({ theme: theme })=>({
        color: 'inherit',
        display: 'table-row',
        verticalAlign: 'middle',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        [`&.${$22705465ad6920f8$var$_tableRowClasses.default.hover}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${$22705465ad6920f8$var$_tableRowClasses.default.selected}`]: {
            backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity),
            '&:hover': {
                backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`)
            }
        }
    })));
const $22705465ad6920f8$var$defaultComponent = 'tr';
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */ const $22705465ad6920f8$var$TableRow = /*#__PURE__*/ $22705465ad6920f8$var$React.forwardRef(function TableRow(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiTableRow'
    });
    const { className: className, component: component = $22705465ad6920f8$var$defaultComponent, hover: hover = false, selected: selected = false, ...other } = props;
    const tablelvl2 = $22705465ad6920f8$var$React.useContext($22705465ad6920f8$var$_Tablelvl2Context.default);
    const ownerState = {
        ...props,
        component: component,
        hover: hover,
        selected: selected,
        head: tablelvl2 && tablelvl2.variant === 'head',
        footer: tablelvl2 && tablelvl2.variant === 'footer'
    };
    const classes = $22705465ad6920f8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($22705465ad6920f8$var$TableRowRoot, {
        as: component,
        ref: ref,
        className: (0, $22705465ad6920f8$var$_clsx.default)(classes.root, className),
        role: component === $22705465ad6920f8$var$defaultComponent ? null : 'row',
        ownerState: ownerState,
        ...other
    });
});
$22705465ad6920f8$var$TableRow.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Should be valid `<tr>` children such as `TableCell`.
   */ children: $22705465ad6920f8$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $22705465ad6920f8$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $22705465ad6920f8$var$_propTypes.default.string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: $22705465ad6920f8$var$_propTypes.default.elementType,
    /**
   * If `true`, the table row will shade on hover.
   * @default false
   */ hover: $22705465ad6920f8$var$_propTypes.default.bool,
    /**
   * If `true`, the table row will have the selected shading.
   * @default false
   */ selected: $22705465ad6920f8$var$_propTypes.default.bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $22705465ad6920f8$var$_propTypes.default.oneOfType([
        $22705465ad6920f8$var$_propTypes.default.arrayOf($22705465ad6920f8$var$_propTypes.default.oneOfType([
            $22705465ad6920f8$var$_propTypes.default.func,
            $22705465ad6920f8$var$_propTypes.default.object,
            $22705465ad6920f8$var$_propTypes.default.bool
        ])),
        $22705465ad6920f8$var$_propTypes.default.func,
        $22705465ad6920f8$var$_propTypes.default.object
    ])
};
var $22705465ad6920f8$var$_default = module.exports.default = $22705465ad6920f8$var$TableRow;

});
parcelRegister("4iLi6", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $321d86e199abda5b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getTableRowUtilityClass = $321d86e199abda5b$var$getTableRowUtilityClass;

var $321d86e199abda5b$var$_generateUtilityClasses = $321d86e199abda5b$require$_interopRequireDefault((parcelRequire("5nY49")));

var $321d86e199abda5b$var$_generateUtilityClass = $321d86e199abda5b$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $321d86e199abda5b$var$getTableRowUtilityClass(slot) {
    return (0, $321d86e199abda5b$var$_generateUtilityClass.default)('MuiTableRow', slot);
}
const $321d86e199abda5b$var$tableRowClasses = (0, $321d86e199abda5b$var$_generateUtilityClasses.default)('MuiTableRow', [
    'root',
    'selected',
    'hover',
    'head',
    'footer'
]);
var $321d86e199abda5b$var$_default = module.exports.default = $321d86e199abda5b$var$tableRowClasses;

});



parcelRegister("Zain6", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $0b7daf0e3c2d5146$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $0b7daf0e3c2d5146$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $0b7daf0e3c2d5146$var$_exportNames = {
    tableSortLabelClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $0b7daf0e3c2d5146$var$_TableSortLabel.default;
    }
});
Object.defineProperty(module.exports, "tableSortLabelClasses", {
    enumerable: true,
    get: function() {
        return $0b7daf0e3c2d5146$var$_tableSortLabelClasses.default;
    }
});

var $0b7daf0e3c2d5146$var$_TableSortLabel = $0b7daf0e3c2d5146$require$_interopRequireDefault((parcelRequire("gjoVE")));

var $0b7daf0e3c2d5146$var$_tableSortLabelClasses = $0b7daf0e3c2d5146$require$_interopRequireWildcard((parcelRequire("9NhvM")));
Object.keys($0b7daf0e3c2d5146$var$_tableSortLabelClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($0b7daf0e3c2d5146$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $0b7daf0e3c2d5146$var$_tableSortLabelClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $0b7daf0e3c2d5146$var$_tableSortLabelClasses[key];
        }
    });
});

});
parcelRegister("gjoVE", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $be01c206ebbcc5af$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $be01c206ebbcc5af$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $be01c206ebbcc5af$var$_composeClasses = $be01c206ebbcc5af$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $be01c206ebbcc5af$var$_clsx = $be01c206ebbcc5af$require$_interopRequireDefault((parcelRequire("9QePP")));

var $be01c206ebbcc5af$var$_propTypes = $be01c206ebbcc5af$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $be01c206ebbcc5af$var$React = $be01c206ebbcc5af$require$_interopRequireWildcard((parcelRequire("acw62")));

var $be01c206ebbcc5af$var$_ButtonBase = $be01c206ebbcc5af$require$_interopRequireDefault((parcelRequire("hhs3r")));

var $be01c206ebbcc5af$var$_ArrowDownward = $be01c206ebbcc5af$require$_interopRequireDefault((parcelRequire("5egRk")));

var $aAbgT = parcelRequire("aAbgT");

var $be01c206ebbcc5af$var$_memoTheme = $be01c206ebbcc5af$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $be01c206ebbcc5af$var$_capitalize = $be01c206ebbcc5af$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $be01c206ebbcc5af$var$_tableSortLabelClasses = $be01c206ebbcc5af$require$_interopRequireWildcard((parcelRequire("9NhvM")));

var $be01c206ebbcc5af$var$_useSlot = $be01c206ebbcc5af$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $be01c206ebbcc5af$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, direction: direction, active: active } = ownerState;
    const slots = {
        root: [
            'root',
            active && 'active',
            `direction${(0, $be01c206ebbcc5af$var$_capitalize.default)(direction)}`
        ],
        icon: [
            'icon',
            `iconDirection${(0, $be01c206ebbcc5af$var$_capitalize.default)(direction)}`
        ]
    };
    return (0, $be01c206ebbcc5af$var$_composeClasses.default)(slots, $be01c206ebbcc5af$var$_tableSortLabelClasses.getTableSortLabelUtilityClass, classes);
};
const $be01c206ebbcc5af$var$TableSortLabelRoot = (0, $aAbgT.styled)($be01c206ebbcc5af$var$_ButtonBase.default, {
    name: 'MuiTableSortLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.active && styles.active
        ];
    }
})((0, $be01c206ebbcc5af$var$_memoTheme.default)(({ theme: theme })=>({
        cursor: 'pointer',
        display: 'inline-flex',
        justifyContent: 'flex-start',
        flexDirection: 'inherit',
        alignItems: 'center',
        '&:focus': {
            color: (theme.vars || theme).palette.text.secondary
        },
        '&:hover': {
            color: (theme.vars || theme).palette.text.secondary,
            [`& .${$be01c206ebbcc5af$var$_tableSortLabelClasses.default.icon}`]: {
                opacity: 0.5
            }
        },
        [`&.${$be01c206ebbcc5af$var$_tableSortLabelClasses.default.active}`]: {
            color: (theme.vars || theme).palette.text.primary,
            [`& .${$be01c206ebbcc5af$var$_tableSortLabelClasses.default.icon}`]: {
                opacity: 1,
                color: (theme.vars || theme).palette.text.secondary
            }
        }
    })));
const $be01c206ebbcc5af$var$TableSortLabelIcon = (0, $aAbgT.styled)('span', {
    name: 'MuiTableSortLabel',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            styles[`iconDirection${(0, $be01c206ebbcc5af$var$_capitalize.default)(ownerState.direction)}`]
        ];
    }
})((0, $be01c206ebbcc5af$var$_memoTheme.default)(({ theme: theme })=>({
        fontSize: 18,
        marginRight: 4,
        marginLeft: 4,
        opacity: 0,
        transition: theme.transitions.create([
            'opacity',
            'transform'
        ], {
            duration: theme.transitions.duration.shorter
        }),
        userSelect: 'none',
        variants: [
            {
                props: {
                    direction: 'desc'
                },
                style: {
                    transform: 'rotate(0deg)'
                }
            },
            {
                props: {
                    direction: 'asc'
                },
                style: {
                    transform: 'rotate(180deg)'
                }
            }
        ]
    })));
/**
 * A button based label for placing inside `TableCell` for column sorting.
 */ const $be01c206ebbcc5af$var$TableSortLabel = /*#__PURE__*/ $be01c206ebbcc5af$var$React.forwardRef(function TableSortLabel(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiTableSortLabel'
    });
    const { active: active = false, children: children, className: className, direction: direction = 'asc', hideSortIcon: hideSortIcon = false, IconComponent: IconComponent = $be01c206ebbcc5af$var$_ArrowDownward.default, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const ownerState = {
        ...props,
        active: active,
        direction: direction,
        hideSortIcon: hideSortIcon,
        IconComponent: IconComponent
    };
    const classes = $be01c206ebbcc5af$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootProps] = (0, $be01c206ebbcc5af$var$_useSlot.default)('root', {
        elementType: $be01c206ebbcc5af$var$TableSortLabelRoot,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $be01c206ebbcc5af$var$_clsx.default)(classes.root, className),
        ref: ref
    });
    const [IconSlot, iconProps] = (0, $be01c206ebbcc5af$var$_useSlot.default)('icon', {
        elementType: $be01c206ebbcc5af$var$TableSortLabelIcon,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.icon
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        disableRipple: true,
        component: "span",
        ...rootProps,
        ...other,
        children: [
            children,
            hideSortIcon && !active ? null : /*#__PURE__*/ (0, $ayMG0.jsx)(IconSlot, {
                as: IconComponent,
                ...iconProps
            })
        ]
    });
});
$be01c206ebbcc5af$var$TableSortLabel.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * If `true`, the label will have the active styling (should be true for the sorted column).
   * @default false
   */ active: $be01c206ebbcc5af$var$_propTypes.default.bool,
    /**
   * Label contents, the arrow will be appended automatically.
   */ children: $be01c206ebbcc5af$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $be01c206ebbcc5af$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $be01c206ebbcc5af$var$_propTypes.default.string,
    /**
   * The current sort direction.
   * @default 'asc'
   */ direction: $be01c206ebbcc5af$var$_propTypes.default.oneOf([
        'asc',
        'desc'
    ]),
    /**
   * Hide sort icon when active is false.
   * @default false
   */ hideSortIcon: $be01c206ebbcc5af$var$_propTypes.default.bool,
    /**
   * Sort icon to use.
   * @default ArrowDownwardIcon
   */ IconComponent: $be01c206ebbcc5af$var$_propTypes.default.elementType,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $be01c206ebbcc5af$var$_propTypes.default.shape({
        icon: $be01c206ebbcc5af$var$_propTypes.default.oneOfType([
            $be01c206ebbcc5af$var$_propTypes.default.func,
            $be01c206ebbcc5af$var$_propTypes.default.object
        ]),
        root: $be01c206ebbcc5af$var$_propTypes.default.oneOfType([
            $be01c206ebbcc5af$var$_propTypes.default.func,
            $be01c206ebbcc5af$var$_propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: $be01c206ebbcc5af$var$_propTypes.default.shape({
        icon: $be01c206ebbcc5af$var$_propTypes.default.elementType,
        root: $be01c206ebbcc5af$var$_propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $be01c206ebbcc5af$var$_propTypes.default.oneOfType([
        $be01c206ebbcc5af$var$_propTypes.default.arrayOf($be01c206ebbcc5af$var$_propTypes.default.oneOfType([
            $be01c206ebbcc5af$var$_propTypes.default.func,
            $be01c206ebbcc5af$var$_propTypes.default.object,
            $be01c206ebbcc5af$var$_propTypes.default.bool
        ])),
        $be01c206ebbcc5af$var$_propTypes.default.func,
        $be01c206ebbcc5af$var$_propTypes.default.object
    ])
};
var $be01c206ebbcc5af$var$_default = module.exports.default = $be01c206ebbcc5af$var$TableSortLabel;

});
parcelRegister("5egRk", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $3ceb567076b478bc$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3ceb567076b478bc$var$_createSvgIcon = $3ceb567076b478bc$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $3ceb567076b478bc$var$_default = module.exports.default = (0, $3ceb567076b478bc$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), 'ArrowDownward');

});

parcelRegister("9NhvM", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $72164616b8f12725$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getTableSortLabelUtilityClass = $72164616b8f12725$var$getTableSortLabelUtilityClass;

var $72164616b8f12725$var$_generateUtilityClasses = $72164616b8f12725$require$_interopRequireDefault((parcelRequire("5nY49")));

var $72164616b8f12725$var$_generateUtilityClass = $72164616b8f12725$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $72164616b8f12725$var$getTableSortLabelUtilityClass(slot) {
    return (0, $72164616b8f12725$var$_generateUtilityClass.default)('MuiTableSortLabel', slot);
}
const $72164616b8f12725$var$tableSortLabelClasses = (0, $72164616b8f12725$var$_generateUtilityClasses.default)('MuiTableSortLabel', [
    'root',
    'active',
    'icon',
    'iconDirectionDesc',
    'iconDirectionAsc',
    'directionDesc',
    'directionAsc'
]);
var $72164616b8f12725$var$_default = module.exports.default = $72164616b8f12725$var$tableSortLabelClasses;

});



parcelRegister("6GVj6", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $4df31e56c78281ac$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $4df31e56c78281ac$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $4df31e56c78281ac$var$_exportNames = {
    toggleButtonGroupClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $4df31e56c78281ac$var$_ToggleButtonGroup.default;
    }
});
Object.defineProperty(module.exports, "toggleButtonGroupClasses", {
    enumerable: true,
    get: function() {
        return $4df31e56c78281ac$var$_toggleButtonGroupClasses.default;
    }
});

var $4df31e56c78281ac$var$_ToggleButtonGroup = $4df31e56c78281ac$require$_interopRequireDefault((parcelRequire("9ZYXn")));

var $4df31e56c78281ac$var$_toggleButtonGroupClasses = $4df31e56c78281ac$require$_interopRequireWildcard((parcelRequire("i9RU8")));
Object.keys($4df31e56c78281ac$var$_toggleButtonGroupClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($4df31e56c78281ac$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $4df31e56c78281ac$var$_toggleButtonGroupClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4df31e56c78281ac$var$_toggleButtonGroupClasses[key];
        }
    });
});

});
parcelRegister("9ZYXn", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $7479184c3cda7f5d$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $7479184c3cda7f5d$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7479184c3cda7f5d$var$React = $7479184c3cda7f5d$require$_interopRequireWildcard((parcelRequire("acw62")));

var $4jPKB = parcelRequire("4jPKB");

var $7479184c3cda7f5d$var$_propTypes = $7479184c3cda7f5d$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $7479184c3cda7f5d$var$_clsx = $7479184c3cda7f5d$require$_interopRequireDefault((parcelRequire("9QePP")));

var $7479184c3cda7f5d$var$_composeClasses = $7479184c3cda7f5d$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $7479184c3cda7f5d$var$_getValidReactChildren = $7479184c3cda7f5d$require$_interopRequireDefault((parcelRequire("2jgfV")));

var $aAbgT = parcelRequire("aAbgT");

var $7479184c3cda7f5d$var$_memoTheme = $7479184c3cda7f5d$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $7479184c3cda7f5d$var$_capitalize = $7479184c3cda7f5d$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $7479184c3cda7f5d$var$_toggleButtonGroupClasses = $7479184c3cda7f5d$require$_interopRequireWildcard((parcelRequire("i9RU8")));

var $7479184c3cda7f5d$var$_ToggleButtonGroupContext = $7479184c3cda7f5d$require$_interopRequireDefault((parcelRequire("lOkLt")));

var $7479184c3cda7f5d$var$_ToggleButtonGroupButtonContext = $7479184c3cda7f5d$require$_interopRequireDefault((parcelRequire("jCUp4")));

var $7479184c3cda7f5d$var$_toggleButtonClasses = $7479184c3cda7f5d$require$_interopRequireDefault((parcelRequire("3cuAs")));

var $ayMG0 = parcelRequire("ayMG0");
const $7479184c3cda7f5d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, fullWidth: fullWidth, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            fullWidth && 'fullWidth'
        ],
        grouped: [
            'grouped',
            `grouped${(0, $7479184c3cda7f5d$var$_capitalize.default)(orientation)}`,
            disabled && 'disabled'
        ],
        firstButton: [
            'firstButton'
        ],
        lastButton: [
            'lastButton'
        ],
        middleButton: [
            'middleButton'
        ]
    };
    return (0, $7479184c3cda7f5d$var$_composeClasses.default)(slots, $7479184c3cda7f5d$var$_toggleButtonGroupClasses.getToggleButtonGroupUtilityClass, classes);
};
const $7479184c3cda7f5d$var$ToggleButtonGroupRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiToggleButtonGroup',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.grouped}`]: styles.grouped
            },
            {
                [`& .${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.grouped}`]: styles[`grouped${(0, $7479184c3cda7f5d$var$_capitalize.default)(ownerState.orientation)}`]
            },
            {
                [`& .${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.firstButton}`]: styles.firstButton
            },
            {
                [`& .${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.lastButton}`]: styles.lastButton
            },
            {
                [`& .${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.middleButton}`]: styles.middleButton
            },
            styles.root,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})((0, $7479184c3cda7f5d$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'inline-flex',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        variants: [
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    flexDirection: 'column',
                    [`& .${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.grouped}`]: {
                        [`&.${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.selected} + .${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.grouped}.${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.selected}`]: {
                            borderTop: 0,
                            marginTop: 0
                        }
                    },
                    [`& .${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.firstButton},& .${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.middleButton}`]: {
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0
                    },
                    [`& .${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.lastButton},& .${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.middleButton}`]: {
                        marginTop: -1,
                        borderTop: '1px solid transparent',
                        borderTopLeftRadius: 0,
                        borderTopRightRadius: 0
                    },
                    [`& .${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.lastButton}.${$7479184c3cda7f5d$var$_toggleButtonClasses.default.disabled},& .${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.middleButton}.${$7479184c3cda7f5d$var$_toggleButtonClasses.default.disabled}`]: {
                        borderTop: '1px solid transparent'
                    }
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.grouped}`]: {
                        [`&.${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.selected} + .${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.grouped}.${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.selected}`]: {
                            borderLeft: 0,
                            marginLeft: 0
                        }
                    },
                    [`& .${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.firstButton},& .${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.middleButton}`]: {
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 0
                    },
                    [`& .${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.lastButton},& .${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.middleButton}`]: {
                        marginLeft: -1,
                        borderLeft: '1px solid transparent',
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0
                    },
                    [`& .${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.lastButton}.${$7479184c3cda7f5d$var$_toggleButtonClasses.default.disabled},& .${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.middleButton}.${$7479184c3cda7f5d$var$_toggleButtonClasses.default.disabled}`]: {
                        borderLeft: '1px solid transparent'
                    }
                }
            }
        ]
    })));
const $7479184c3cda7f5d$var$ToggleButtonGroup = /*#__PURE__*/ $7479184c3cda7f5d$var$React.forwardRef(function ToggleButtonGroup(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiToggleButtonGroup'
    });
    const { children: children, className: className, color: color = 'standard', disabled: disabled = false, exclusive: exclusive = false, fullWidth: fullWidth = false, onChange: onChange, orientation: orientation = 'horizontal', size: size = 'medium', value: value, ...other } = props;
    const ownerState = {
        ...props,
        disabled: disabled,
        fullWidth: fullWidth,
        orientation: orientation,
        size: size
    };
    const classes = $7479184c3cda7f5d$var$useUtilityClasses(ownerState);
    const handleChange = $7479184c3cda7f5d$var$React.useCallback((event, buttonValue)=>{
        if (!onChange) return;
        const index = value && value.indexOf(buttonValue);
        let newValue;
        if (value && index >= 0) {
            newValue = value.slice();
            newValue.splice(index, 1);
        } else newValue = value ? value.concat(buttonValue) : [
            buttonValue
        ];
        onChange(event, newValue);
    }, [
        onChange,
        value
    ]);
    const handleExclusiveChange = $7479184c3cda7f5d$var$React.useCallback((event, buttonValue)=>{
        if (!onChange) return;
        onChange(event, value === buttonValue ? null : buttonValue);
    }, [
        onChange,
        value
    ]);
    const context = $7479184c3cda7f5d$var$React.useMemo(()=>({
            className: classes.grouped,
            onChange: exclusive ? handleExclusiveChange : handleChange,
            value: value,
            size: size,
            fullWidth: fullWidth,
            color: color,
            disabled: disabled
        }), [
        classes.grouped,
        exclusive,
        handleExclusiveChange,
        handleChange,
        value,
        size,
        fullWidth,
        color,
        disabled
    ]);
    const validChildren = (0, $7479184c3cda7f5d$var$_getValidReactChildren.default)(children);
    const childrenCount = validChildren.length;
    const getButtonPositionClassName = (index)=>{
        const isFirstButton = index === 0;
        const isLastButton = index === childrenCount - 1;
        if (isFirstButton && isLastButton) return '';
        if (isFirstButton) return classes.firstButton;
        if (isLastButton) return classes.lastButton;
        return classes.middleButton;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($7479184c3cda7f5d$var$ToggleButtonGroupRoot, {
        role: "group",
        className: (0, $7479184c3cda7f5d$var$_clsx.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($7479184c3cda7f5d$var$_ToggleButtonGroupContext.default.Provider, {
            value: context,
            children: validChildren.map((child, index)=>{
                if ((0, $4jPKB.isFragment)(child)) console.error([
                    "MUI: The ToggleButtonGroup component doesn't accept a Fragment as a child.",
                    'Consider providing an array instead.'
                ].join('\n'));
                return /*#__PURE__*/ (0, $ayMG0.jsx)($7479184c3cda7f5d$var$_ToggleButtonGroupButtonContext.default.Provider, {
                    value: getButtonPositionClassName(index),
                    children: child
                }, index);
            })
        })
    });
});
$7479184c3cda7f5d$var$ToggleButtonGroup.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: $7479184c3cda7f5d$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $7479184c3cda7f5d$var$_propTypes.default.object,
    /**
   * @ignore
   */ className: $7479184c3cda7f5d$var$_propTypes.default.string,
    /**
   * The color of the button when it is selected.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */ color: $7479184c3cda7f5d$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $7479184c3cda7f5d$var$_propTypes.default.oneOf([
            'standard',
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning'
        ]),
        $7479184c3cda7f5d$var$_propTypes.default.string
    ]),
    /**
   * If `true`, the component is disabled. This implies that all ToggleButton children will be disabled.
   * @default false
   */ disabled: $7479184c3cda7f5d$var$_propTypes.default.bool,
    /**
   * If `true`, only allow one of the child ToggleButton values to be selected.
   * @default false
   */ exclusive: $7479184c3cda7f5d$var$_propTypes.default.bool,
    /**
   * If `true`, the button group will take up the full width of its container.
   * @default false
   */ fullWidth: $7479184c3cda7f5d$var$_propTypes.default.bool,
    /**
   * Callback fired when the value changes.
   *
   * @param {React.MouseEvent<HTMLElement>} event The event source of the callback.
   * @param {any} value of the selected buttons. When `exclusive` is true
   * this is a single value; when false an array of selected values. If no value
   * is selected and `exclusive` is true the value is null; when false an empty array.
   */ onChange: $7479184c3cda7f5d$var$_propTypes.default.func,
    /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */ orientation: $7479184c3cda7f5d$var$_propTypes.default.oneOf([
        'horizontal',
        'vertical'
    ]),
    /**
   * The size of the component.
   * @default 'medium'
   */ size: $7479184c3cda7f5d$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $7479184c3cda7f5d$var$_propTypes.default.oneOf([
            'small',
            'medium',
            'large'
        ]),
        $7479184c3cda7f5d$var$_propTypes.default.string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $7479184c3cda7f5d$var$_propTypes.default.oneOfType([
        $7479184c3cda7f5d$var$_propTypes.default.arrayOf($7479184c3cda7f5d$var$_propTypes.default.oneOfType([
            $7479184c3cda7f5d$var$_propTypes.default.func,
            $7479184c3cda7f5d$var$_propTypes.default.object,
            $7479184c3cda7f5d$var$_propTypes.default.bool
        ])),
        $7479184c3cda7f5d$var$_propTypes.default.func,
        $7479184c3cda7f5d$var$_propTypes.default.object
    ]),
    /**
   * The currently selected value within the group or an array of selected
   * values when `exclusive` is false.
   *
   * The value must have reference equality with the option in order to be selected.
   */ value: $7479184c3cda7f5d$var$_propTypes.default.any
};
var $7479184c3cda7f5d$var$_default = module.exports.default = $7479184c3cda7f5d$var$ToggleButtonGroup;

});
parcelRegister("i9RU8", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d382e18949ecbd32$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getToggleButtonGroupUtilityClass = $d382e18949ecbd32$var$getToggleButtonGroupUtilityClass;

var $d382e18949ecbd32$var$_generateUtilityClasses = $d382e18949ecbd32$require$_interopRequireDefault((parcelRequire("5nY49")));

var $d382e18949ecbd32$var$_generateUtilityClass = $d382e18949ecbd32$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $d382e18949ecbd32$var$getToggleButtonGroupUtilityClass(slot) {
    return (0, $d382e18949ecbd32$var$_generateUtilityClass.default)('MuiToggleButtonGroup', slot);
}
const $d382e18949ecbd32$var$toggleButtonGroupClasses = (0, $d382e18949ecbd32$var$_generateUtilityClasses.default)('MuiToggleButtonGroup', [
    'root',
    'selected',
    'horizontal',
    'vertical',
    'disabled',
    'grouped',
    'groupedHorizontal',
    'groupedVertical',
    'fullWidth',
    'firstButton',
    'lastButton',
    'middleButton'
]);
var $d382e18949ecbd32$var$_default = module.exports.default = $d382e18949ecbd32$var$toggleButtonGroupClasses;

});



parcelRegister("18tt9", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0d3d65c0582fd03d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8h4LK = parcelRequire("8h4LK");

var $0d3d65c0582fd03d$var$_identifier = $0d3d65c0582fd03d$require$_interopRequireDefault((parcelRequire("4jPsi")));
const $0d3d65c0582fd03d$var$useMediaQuery = (0, $8h4LK.unstable_createUseMediaQuery)({
    themeId: $0d3d65c0582fd03d$var$_identifier.default
});
var $0d3d65c0582fd03d$var$_default = module.exports.default = $0d3d65c0582fd03d$var$useMediaQuery;

});

parcelRegister("dL2y2", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a041a41a6f25c19c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $a041a41a6f25c19c$var$_useScrollTrigger.default;
    }
});

var $a041a41a6f25c19c$var$_useScrollTrigger = $a041a41a6f25c19c$require$_interopRequireDefault((parcelRequire("e0QfK")));

});
parcelRegister("e0QfK", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $a3399924514ccab2$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a3399924514ccab2$var$useScrollTrigger;

var $a3399924514ccab2$var$React = $a3399924514ccab2$require$_interopRequireWildcard((parcelRequire("acw62")));
function $a3399924514ccab2$var$defaultTrigger(store, options) {
    const { disableHysteresis: disableHysteresis = false, threshold: threshold = 100, target: target } = options;
    const previous = store.current;
    if (target) // Get vertical scroll
    store.current = target.pageYOffset !== undefined ? target.pageYOffset : target.scrollTop;
    if (!disableHysteresis && previous !== undefined) {
        if (store.current < previous) return false;
    }
    return store.current > threshold;
}
const $a3399924514ccab2$var$defaultTarget = typeof window !== 'undefined' ? window : null;
function $a3399924514ccab2$var$useScrollTrigger(options = {}) {
    const { getTrigger: getTrigger = $a3399924514ccab2$var$defaultTrigger, target: target = $a3399924514ccab2$var$defaultTarget, ...other } = options;
    const store = $a3399924514ccab2$var$React.useRef();
    const [trigger, setTrigger] = $a3399924514ccab2$var$React.useState(()=>getTrigger(store, other));
    $a3399924514ccab2$var$React.useEffect(()=>{
        if (target === null) return setTrigger(false);
        const handleScroll = ()=>{
            setTrigger(getTrigger(store, {
                target: target,
                ...other
            }));
        };
        handleScroll(); // Re-evaluate trigger when dependencies change
        target.addEventListener('scroll', handleScroll, {
            passive: true
        });
        return ()=>{
            target.removeEventListener('scroll', handleScroll, {
                passive: true
            });
        };
    // See Option 3. https://github.com/facebook/react/issues/14476#issuecomment-471199055
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        target,
        getTrigger,
        JSON.stringify(other)
    ]);
    return trigger;
}

});


parcelRegister("e9Nv0", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a4e84d7603b01204$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $a4e84d7603b01204$var$_generateUtilityClass.default;
    }
});

var $a4e84d7603b01204$var$_generateUtilityClass = $a4e84d7603b01204$require$_interopRequireDefault((parcelRequire("b14cZ")));

});

parcelRegister("c2K5x", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $8c496c244c450de4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $8c496c244c450de4$var$_generateUtilityClasses.default;
    }
});

var $8c496c244c450de4$var$_generateUtilityClasses = $8c496c244c450de4$require$_interopRequireDefault((parcelRequire("5nY49")));

});

parcelRegister("2bNdG", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $1982c9dba5dbf858$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $1982c9dba5dbf858$var$_InitColorSchemeScript.default;
    }
});

var $1982c9dba5dbf858$var$_InitColorSchemeScript = $1982c9dba5dbf858$require$_interopRequireDefault((parcelRequire("3K3i6")));

});

parcelRegister("7Ekty", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $hGPki.createSvgIcon;
    }
});

var $hGPki = parcelRequire("hGPki");

});


var $ayMG0 = parcelRequire("ayMG0");
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* eslint-disable @typescript-eslint/no-explicit-any */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * based on lodash in order to support esm builds without esModuleInterop.
 * lodash is using MIT License.
 **/ const $e6c7889dba68b6a8$var$objectTag = '[object Object]';
const $e6c7889dba68b6a8$var$nullTag = '[object Null]';
const $e6c7889dba68b6a8$var$undefinedTag = '[object Undefined]';
const $e6c7889dba68b6a8$var$funcProto = Function.prototype;
const $e6c7889dba68b6a8$var$funcToString = $e6c7889dba68b6a8$var$funcProto.toString;
const $e6c7889dba68b6a8$var$objectCtorString = $e6c7889dba68b6a8$var$funcToString.call(Object);
const $e6c7889dba68b6a8$var$getPrototypeOf = Object.getPrototypeOf;
const $e6c7889dba68b6a8$var$objectProto = Object.prototype;
const $e6c7889dba68b6a8$var$hasOwnProperty = $e6c7889dba68b6a8$var$objectProto.hasOwnProperty;
const $e6c7889dba68b6a8$var$symToStringTag = Symbol ? Symbol.toStringTag : undefined;
const $e6c7889dba68b6a8$var$nativeObjectToString = $e6c7889dba68b6a8$var$objectProto.toString;
function $e6c7889dba68b6a8$export$53b83ca8eaab0383(value) {
    if (!$e6c7889dba68b6a8$var$isObjectLike(value) || $e6c7889dba68b6a8$var$baseGetTag(value) !== $e6c7889dba68b6a8$var$objectTag) return false;
    const proto = $e6c7889dba68b6a8$var$getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = $e6c7889dba68b6a8$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $e6c7889dba68b6a8$var$funcToString.call(Ctor) === $e6c7889dba68b6a8$var$objectCtorString;
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $e6c7889dba68b6a8$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $e6c7889dba68b6a8$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $e6c7889dba68b6a8$var$undefinedTag : $e6c7889dba68b6a8$var$nullTag;
    return $e6c7889dba68b6a8$var$symToStringTag && $e6c7889dba68b6a8$var$symToStringTag in Object(value) ? $e6c7889dba68b6a8$var$getRawTag(value) : $e6c7889dba68b6a8$var$objectToString(value);
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $e6c7889dba68b6a8$var$getRawTag(value) {
    const isOwn = $e6c7889dba68b6a8$var$hasOwnProperty.call(value, $e6c7889dba68b6a8$var$symToStringTag), tag = value[$e6c7889dba68b6a8$var$symToStringTag];
    let unmasked = false;
    try {
        value[$e6c7889dba68b6a8$var$symToStringTag] = undefined;
        unmasked = true;
    } catch  {
    // silence
    }
    const result = $e6c7889dba68b6a8$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$e6c7889dba68b6a8$var$symToStringTag] = tag;
        else delete value[$e6c7889dba68b6a8$var$symToStringTag];
    }
    return result;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $e6c7889dba68b6a8$var$objectToString(value) {
    return $e6c7889dba68b6a8$var$nativeObjectToString.call(value);
}


const $a99eaf6108fc00d6$var$MAX_LEVEL = 20;
function $a99eaf6108fc00d6$export$4950aa0f605343fb(...args) {
    let result = args.shift();
    const objects = new WeakMap();
    while(args.length > 0)result = $a99eaf6108fc00d6$var$mergeTwoObjects(result, args.shift(), 0, objects);
    return result;
}
function $a99eaf6108fc00d6$var$takeValue(value) {
    if ($a99eaf6108fc00d6$var$isArray(value)) return value.slice();
    return value;
}
/**
 * Merges two objects
 * @param one - first object
 * @param two - second object
 * @param level - current deep level
 * @param objects - objects holder that has been already referenced - to prevent
 * cyclic dependency
 */ function $a99eaf6108fc00d6$var$mergeTwoObjects(one, two, level = 0, objects) {
    let result;
    if (level > $a99eaf6108fc00d6$var$MAX_LEVEL) return undefined;
    level++;
    if ($a99eaf6108fc00d6$var$isPrimitive(one) || $a99eaf6108fc00d6$var$isPrimitive(two) || $a99eaf6108fc00d6$var$isFunction(two)) result = $a99eaf6108fc00d6$var$takeValue(two);
    else if ($a99eaf6108fc00d6$var$isArray(one)) {
        result = one.slice();
        if ($a99eaf6108fc00d6$var$isArray(two)) for(let i = 0, j = two.length; i < j; i++)result.push($a99eaf6108fc00d6$var$takeValue(two[i]));
        else if ($a99eaf6108fc00d6$var$isObject(two)) {
            const keys = Object.keys(two);
            for(let i = 0, j = keys.length; i < j; i++){
                const key = keys[i];
                result[key] = $a99eaf6108fc00d6$var$takeValue(two[key]);
            }
        }
    } else if ($a99eaf6108fc00d6$var$isObject(one)) {
        if ($a99eaf6108fc00d6$var$isObject(two)) {
            if (!$a99eaf6108fc00d6$var$shouldMerge(one, two)) return two;
            result = Object.assign({}, one);
            const keys = Object.keys(two);
            for(let i = 0, j = keys.length; i < j; i++){
                const key = keys[i];
                const twoValue = two[key];
                if ($a99eaf6108fc00d6$var$isPrimitive(twoValue)) {
                    if (typeof twoValue === 'undefined') delete result[key];
                    else // result[key] = takeValue(twoValue);
                    result[key] = twoValue;
                } else {
                    const obj1 = result[key];
                    const obj2 = twoValue;
                    if ($a99eaf6108fc00d6$var$wasObjectReferenced(one, key, objects) || $a99eaf6108fc00d6$var$wasObjectReferenced(two, key, objects)) delete result[key];
                    else {
                        if ($a99eaf6108fc00d6$var$isObject(obj1) && $a99eaf6108fc00d6$var$isObject(obj2)) {
                            const arr1 = objects.get(obj1) || [];
                            const arr2 = objects.get(obj2) || [];
                            arr1.push({
                                obj: one,
                                key: key
                            });
                            arr2.push({
                                obj: two,
                                key: key
                            });
                            objects.set(obj1, arr1);
                            objects.set(obj2, arr2);
                        }
                        result[key] = $a99eaf6108fc00d6$var$mergeTwoObjects(result[key], twoValue, level, objects);
                    }
                }
            }
        } else result = two;
    }
    return result;
}
/**
 * Function to check if object has been already reference
 * @param obj
 * @param key
 * @param objects
 */ function $a99eaf6108fc00d6$var$wasObjectReferenced(obj, key, objects) {
    const arr = objects.get(obj[key]) || [];
    for(let i = 0, j = arr.length; i < j; i++){
        const info = arr[i];
        if (info.key === key && info.obj === obj) return true;
    }
    return false;
}
function $a99eaf6108fc00d6$var$isArray(value) {
    return Array.isArray(value);
}
function $a99eaf6108fc00d6$var$isFunction(value) {
    return typeof value === 'function';
}
function $a99eaf6108fc00d6$var$isObject(value) {
    return !$a99eaf6108fc00d6$var$isPrimitive(value) && !$a99eaf6108fc00d6$var$isArray(value) && !$a99eaf6108fc00d6$var$isFunction(value) && typeof value === 'object';
}
function $a99eaf6108fc00d6$var$isPrimitive(value) {
    return typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean' || typeof value === 'undefined' || value instanceof Date || value instanceof RegExp || value === null;
}
function $a99eaf6108fc00d6$var$shouldMerge(one, two) {
    if (!(0, $e6c7889dba68b6a8$export$53b83ca8eaab0383)(one) || !(0, $e6c7889dba68b6a8$export$53b83ca8eaab0383)(two)) return false;
    return true;
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Updates to this file should also be replicated to @opentelemetry/core too.
/**
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS implementation)
 * - <object> (When all else fails)
 */ /** only globals that common to node and browsers are allowed */ // eslint-disable-next-line node/no-unsupported-features/es-builtins, no-undef
var $26b92d9057f09375$export$5c524ddf7208c00c = typeof globalThis === 'object' ? globalThis : typeof self === 'object' ? self : typeof window === 'object' ? window : typeof $parcel$global === 'object' ? $parcel$global : {};


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // this is autogenerated file, see scripts/version-update.js
var $edd92bd5ed3d12cd$export$a4ad2735b021c132 = '1.9.0';


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $aeeabfecb8c43ff4$var$re = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
function $aeeabfecb8c43ff4$export$a5733a4d26a1ec61(ownVersion) {
    var acceptedVersions = new Set([
        ownVersion
    ]);
    var rejectedVersions = new Set();
    var myVersionMatch = ownVersion.match($aeeabfecb8c43ff4$var$re);
    if (!myVersionMatch) // we cannot guarantee compatibility so we always return noop
    return function() {
        return false;
    };
    var ownVersionParsed = {
        major: +myVersionMatch[1],
        minor: +myVersionMatch[2],
        patch: +myVersionMatch[3],
        prerelease: myVersionMatch[4]
    };
    // if ownVersion has a prerelease tag, versions must match exactly
    if (ownVersionParsed.prerelease != null) return function isExactmatch(globalVersion) {
        return globalVersion === ownVersion;
    };
    function _reject(v) {
        rejectedVersions.add(v);
        return false;
    }
    function _accept(v) {
        acceptedVersions.add(v);
        return true;
    }
    return function isCompatible(globalVersion) {
        if (acceptedVersions.has(globalVersion)) return true;
        if (rejectedVersions.has(globalVersion)) return false;
        var globalVersionMatch = globalVersion.match($aeeabfecb8c43ff4$var$re);
        if (!globalVersionMatch) // cannot parse other version
        // we cannot guarantee compatibility so we always noop
        return _reject(globalVersion);
        var globalVersionParsed = {
            major: +globalVersionMatch[1],
            minor: +globalVersionMatch[2],
            patch: +globalVersionMatch[3],
            prerelease: globalVersionMatch[4]
        };
        // if globalVersion has a prerelease tag, versions must match exactly
        if (globalVersionParsed.prerelease != null) return _reject(globalVersion);
        // major versions must match
        if (ownVersionParsed.major !== globalVersionParsed.major) return _reject(globalVersion);
        if (ownVersionParsed.major === 0) {
            if (ownVersionParsed.minor === globalVersionParsed.minor && ownVersionParsed.patch <= globalVersionParsed.patch) return _accept(globalVersion);
            return _reject(globalVersion);
        }
        if (ownVersionParsed.minor <= globalVersionParsed.minor) return _accept(globalVersion);
        return _reject(globalVersion);
    };
}
var $aeeabfecb8c43ff4$export$7fc0d8c3ab188c4c = $aeeabfecb8c43ff4$export$a5733a4d26a1ec61((0, $edd92bd5ed3d12cd$export$a4ad2735b021c132));


var $b2d9d13e726c481d$var$major = (0, $edd92bd5ed3d12cd$export$a4ad2735b021c132).split('.')[0];
var $b2d9d13e726c481d$var$GLOBAL_OPENTELEMETRY_API_KEY = Symbol.for("opentelemetry.js.api." + $b2d9d13e726c481d$var$major);
var $b2d9d13e726c481d$var$_global = (0, $26b92d9057f09375$export$5c524ddf7208c00c);
function $b2d9d13e726c481d$export$d586ae880b433238(type, instance, diag, allowOverride) {
    var _a;
    if (allowOverride === void 0) allowOverride = false;
    var api = $b2d9d13e726c481d$var$_global[$b2d9d13e726c481d$var$GLOBAL_OPENTELEMETRY_API_KEY] = (_a = $b2d9d13e726c481d$var$_global[$b2d9d13e726c481d$var$GLOBAL_OPENTELEMETRY_API_KEY]) !== null && _a !== void 0 ? _a : {
        version: (0, $edd92bd5ed3d12cd$export$a4ad2735b021c132)
    };
    if (!allowOverride && api[type]) {
        // already registered an API of this type
        var err = new Error("@opentelemetry/api: Attempted duplicate registration of API: " + type);
        diag.error(err.stack || err.message);
        return false;
    }
    if (api.version !== (0, $edd92bd5ed3d12cd$export$a4ad2735b021c132)) {
        // All registered APIs must be of the same version exactly
        var err = new Error("@opentelemetry/api: Registration of version v" + api.version + " for " + type + " does not match previously registered API v" + (0, $edd92bd5ed3d12cd$export$a4ad2735b021c132));
        diag.error(err.stack || err.message);
        return false;
    }
    api[type] = instance;
    diag.debug("@opentelemetry/api: Registered a global for " + type + " v" + (0, $edd92bd5ed3d12cd$export$a4ad2735b021c132) + ".");
    return true;
}
function $b2d9d13e726c481d$export$a4e55266d2135a7f(type) {
    var _a, _b;
    var globalVersion = (_a = $b2d9d13e726c481d$var$_global[$b2d9d13e726c481d$var$GLOBAL_OPENTELEMETRY_API_KEY]) === null || _a === void 0 ? void 0 : _a.version;
    if (!globalVersion || !(0, $aeeabfecb8c43ff4$export$7fc0d8c3ab188c4c)(globalVersion)) return;
    return (_b = $b2d9d13e726c481d$var$_global[$b2d9d13e726c481d$var$GLOBAL_OPENTELEMETRY_API_KEY]) === null || _b === void 0 ? void 0 : _b[type];
}
function $b2d9d13e726c481d$export$d42ac835f38d1fb2(type, diag) {
    diag.debug("@opentelemetry/api: Unregistering a global for " + type + " v" + (0, $edd92bd5ed3d12cd$export$a4ad2735b021c132) + ".");
    var api = $b2d9d13e726c481d$var$_global[$b2d9d13e726c481d$var$GLOBAL_OPENTELEMETRY_API_KEY];
    if (api) delete api[type];
}


var $0d7e1bd3a658b161$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $0d7e1bd3a658b161$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * Component Logger which is meant to be used as part of any component which
 * will add automatically additional namespace in front of the log message.
 * It will then forward all message to global diag logger
 * @example
 * const cLogger = diag.createComponentLogger({ namespace: '@opentelemetry/instrumentation-http' });
 * cLogger.debug('test');
 * // @opentelemetry/instrumentation-http test
 */ var $0d7e1bd3a658b161$export$b4bccc12f5b13129 = /** @class */ function() {
    function DiagComponentLogger(props) {
        this._namespace = props.namespace || 'DiagComponentLogger';
    }
    DiagComponentLogger.prototype.debug = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $0d7e1bd3a658b161$var$logProxy('debug', this._namespace, args);
    };
    DiagComponentLogger.prototype.error = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $0d7e1bd3a658b161$var$logProxy('error', this._namespace, args);
    };
    DiagComponentLogger.prototype.info = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $0d7e1bd3a658b161$var$logProxy('info', this._namespace, args);
    };
    DiagComponentLogger.prototype.warn = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $0d7e1bd3a658b161$var$logProxy('warn', this._namespace, args);
    };
    DiagComponentLogger.prototype.verbose = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $0d7e1bd3a658b161$var$logProxy('verbose', this._namespace, args);
    };
    return DiagComponentLogger;
}();
function $0d7e1bd3a658b161$var$logProxy(funcName, namespace, args) {
    var logger = (0, $b2d9d13e726c481d$export$a4e55266d2135a7f)('diag');
    // shortcut if logger not set
    if (!logger) return;
    args.unshift(namespace);
    return logger[funcName].apply(logger, $0d7e1bd3a658b161$var$__spreadArray([], $0d7e1bd3a658b161$var$__read(args), false));
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Defines the available internal logging levels for the diagnostic logger, the numeric values
 * of the levels are defined to match the original values from the initial LogLevel to avoid
 * compatibility/migration issues for any implementation that assume the numeric ordering.
 */ var $042c1418c9626221$export$b7d7b4c0f3c95263;
(function(DiagLogLevel) {
    /** Diagnostic Logging level setting to disable all logging (except and forced logs) */ DiagLogLevel[DiagLogLevel["NONE"] = 0] = "NONE";
    /** Identifies an error scenario */ DiagLogLevel[DiagLogLevel["ERROR"] = 30] = "ERROR";
    /** Identifies a warning scenario */ DiagLogLevel[DiagLogLevel["WARN"] = 50] = "WARN";
    /** General informational log message */ DiagLogLevel[DiagLogLevel["INFO"] = 60] = "INFO";
    /** General debug log message */ DiagLogLevel[DiagLogLevel["DEBUG"] = 70] = "DEBUG";
    /**
     * Detailed trace level logging should only be used for development, should only be set
     * in a development environment.
     */ DiagLogLevel[DiagLogLevel["VERBOSE"] = 80] = "VERBOSE";
    /** Used to set the logging level to include all logging */ DiagLogLevel[DiagLogLevel["ALL"] = 9999] = "ALL";
})($042c1418c9626221$export$b7d7b4c0f3c95263 || ($042c1418c9626221$export$b7d7b4c0f3c95263 = {}));


function $c8159f058a092f2c$export$9a9cc475abb19689(maxLevel, logger) {
    if (maxLevel < (0, $042c1418c9626221$export$b7d7b4c0f3c95263).NONE) maxLevel = (0, $042c1418c9626221$export$b7d7b4c0f3c95263).NONE;
    else if (maxLevel > (0, $042c1418c9626221$export$b7d7b4c0f3c95263).ALL) maxLevel = (0, $042c1418c9626221$export$b7d7b4c0f3c95263).ALL;
    // In case the logger is null or undefined
    logger = logger || {};
    function _filterFunc(funcName, theLevel) {
        var theFunc = logger[funcName];
        if (typeof theFunc === 'function' && maxLevel >= theLevel) return theFunc.bind(logger);
        return function() {};
    }
    return {
        error: _filterFunc('error', (0, $042c1418c9626221$export$b7d7b4c0f3c95263).ERROR),
        warn: _filterFunc('warn', (0, $042c1418c9626221$export$b7d7b4c0f3c95263).WARN),
        info: _filterFunc('info', (0, $042c1418c9626221$export$b7d7b4c0f3c95263).INFO),
        debug: _filterFunc('debug', (0, $042c1418c9626221$export$b7d7b4c0f3c95263).DEBUG),
        verbose: _filterFunc('verbose', (0, $042c1418c9626221$export$b7d7b4c0f3c95263).VERBOSE)
    };
}




var $515ee5c32a70b2b2$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $515ee5c32a70b2b2$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $515ee5c32a70b2b2$var$API_NAME = 'diag';
/**
 * Singleton object which represents the entry point to the OpenTelemetry internal
 * diagnostic API
 */ var $515ee5c32a70b2b2$export$5c8937ffc688cfd3 = /** @class */ function() {
    /**
     * Private internal constructor
     * @private
     */ function DiagAPI() {
        function _logProxy(funcName) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var logger = (0, $b2d9d13e726c481d$export$a4e55266d2135a7f)('diag');
                // shortcut if logger not set
                if (!logger) return;
                return logger[funcName].apply(logger, $515ee5c32a70b2b2$var$__spreadArray([], $515ee5c32a70b2b2$var$__read(args), false));
            };
        }
        // Using self local variable for minification purposes as 'this' cannot be minified
        var self = this;
        // DiagAPI specific functions
        var setLogger = function(logger, optionsOrLogLevel) {
            var _a, _b, _c;
            if (optionsOrLogLevel === void 0) optionsOrLogLevel = {
                logLevel: (0, $042c1418c9626221$export$b7d7b4c0f3c95263).INFO
            };
            if (logger === self) {
                // There isn't much we can do here.
                // Logging to the console might break the user application.
                // Try to log to self. If a logger was previously registered it will receive the log.
                var err = new Error('Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation');
                self.error((_a = err.stack) !== null && _a !== void 0 ? _a : err.message);
                return false;
            }
            if (typeof optionsOrLogLevel === 'number') optionsOrLogLevel = {
                logLevel: optionsOrLogLevel
            };
            var oldLogger = (0, $b2d9d13e726c481d$export$a4e55266d2135a7f)('diag');
            var newLogger = (0, $c8159f058a092f2c$export$9a9cc475abb19689)((_b = optionsOrLogLevel.logLevel) !== null && _b !== void 0 ? _b : (0, $042c1418c9626221$export$b7d7b4c0f3c95263).INFO, logger);
            // There already is an logger registered. We'll let it know before overwriting it.
            if (oldLogger && !optionsOrLogLevel.suppressOverrideMessage) {
                var stack = (_c = new Error().stack) !== null && _c !== void 0 ? _c : '<failed to generate stacktrace>';
                oldLogger.warn("Current logger will be overwritten from " + stack);
                newLogger.warn("Current logger will overwrite one already registered from " + stack);
            }
            return (0, $b2d9d13e726c481d$export$d586ae880b433238)('diag', newLogger, self, true);
        };
        self.setLogger = setLogger;
        self.disable = function() {
            (0, $b2d9d13e726c481d$export$d42ac835f38d1fb2)($515ee5c32a70b2b2$var$API_NAME, self);
        };
        self.createComponentLogger = function(options) {
            return new (0, $0d7e1bd3a658b161$export$b4bccc12f5b13129)(options);
        };
        self.verbose = _logProxy('verbose');
        self.debug = _logProxy('debug');
        self.info = _logProxy('info');
        self.warn = _logProxy('warn');
        self.error = _logProxy('error');
    }
    /** Get the singleton instance of the DiagAPI API */ DiagAPI.instance = function() {
        if (!this._instance) this._instance = new DiagAPI();
        return this._instance;
    };
    return DiagAPI;
}();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $8458c3575773417c$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $8458c3575773417c$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $8458c3575773417c$export$b8c511fa1a5f4987 = /** @class */ function() {
    function BaggageImpl(entries) {
        this._entries = entries ? new Map(entries) : new Map();
    }
    BaggageImpl.prototype.getEntry = function(key) {
        var entry = this._entries.get(key);
        if (!entry) return undefined;
        return Object.assign({}, entry);
    };
    BaggageImpl.prototype.getAllEntries = function() {
        return Array.from(this._entries.entries()).map(function(_a) {
            var _b = $8458c3575773417c$var$__read(_a, 2), k = _b[0], v = _b[1];
            return [
                k,
                v
            ];
        });
    };
    BaggageImpl.prototype.setEntry = function(key, entry) {
        var newBaggage = new BaggageImpl(this._entries);
        newBaggage._entries.set(key, entry);
        return newBaggage;
    };
    BaggageImpl.prototype.removeEntry = function(key) {
        var newBaggage = new BaggageImpl(this._entries);
        newBaggage._entries.delete(key);
        return newBaggage;
    };
    BaggageImpl.prototype.removeEntries = function() {
        var e_1, _a;
        var keys = [];
        for(var _i = 0; _i < arguments.length; _i++)keys[_i] = arguments[_i];
        var newBaggage = new BaggageImpl(this._entries);
        try {
            for(var keys_1 = $8458c3575773417c$var$__values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()){
                var key = keys_1_1.value;
                newBaggage._entries.delete(key);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return newBaggage;
    };
    BaggageImpl.prototype.clear = function() {
        return new BaggageImpl();
    };
    return BaggageImpl;
}();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Symbol used to make BaggageEntryMetadata an opaque type
 */ var $47a64c29f401437a$export$92dd2fe8ddb5cb7 = Symbol('BaggageEntryMetadata');


var $36ecce552d4bbf35$var$diag = (0, $515ee5c32a70b2b2$export$5c8937ffc688cfd3).instance();
function $36ecce552d4bbf35$export$1034a425c7384452(entries) {
    if (entries === void 0) entries = {};
    return new (0, $8458c3575773417c$export$b8c511fa1a5f4987)(new Map(Object.entries(entries)));
}
function $36ecce552d4bbf35$export$c491cedc1b2b6e9e(str) {
    if (typeof str !== 'string') {
        $36ecce552d4bbf35$var$diag.error("Cannot create baggage metadata from unknown type: " + typeof str);
        str = '';
    }
    return {
        __TYPE__: (0, $47a64c29f401437a$export$92dd2fe8ddb5cb7),
        toString: function() {
            return str;
        }
    };
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Get a key to uniquely identify a context value */ function $411320e1da10ff3d$export$b8c322c5a7cfce78(description) {
    // The specification states that for the same input, multiple calls should
    // return different keys. Due to the nature of the JS dependency management
    // system, this creates problems where multiple versions of some package
    // could hold different keys for the same property.
    //
    // Therefore, we use Symbol.for which returns the same key for the same input.
    return Symbol.for(description);
}
var $411320e1da10ff3d$var$BaseContext = /** @class */ function() {
    /**
     * Construct a new context which inherits values from an optional parent context.
     *
     * @param parentContext a context from which to inherit values
     */ function BaseContext(parentContext) {
        // for minification
        var self = this;
        self._currentContext = parentContext ? new Map(parentContext) : new Map();
        self.getValue = function(key) {
            return self._currentContext.get(key);
        };
        self.setValue = function(key, value) {
            var context = new BaseContext(self._currentContext);
            context._currentContext.set(key, value);
            return context;
        };
        self.deleteValue = function(key) {
            var context = new BaseContext(self._currentContext);
            context._currentContext.delete(key);
            return context;
        };
    }
    return BaseContext;
}();
var $411320e1da10ff3d$export$78df28f9b2f9a7dc = new $411320e1da10ff3d$var$BaseContext();









/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @deprecated use the one declared in @opentelemetry/sdk-trace-base instead.
 * A sampling decision that determines how a {@link Span} will be recorded
 * and collected.
 */ var $0cc84bf49b6d9783$export$94df7a7a96a92f7b;
(function(SamplingDecision) {
    /**
     * `Span.isRecording() === false`, span will not be recorded and all events
     * and attributes will be dropped.
     */ SamplingDecision[SamplingDecision["NOT_RECORD"] = 0] = "NOT_RECORD";
    /**
     * `Span.isRecording() === true`, but `Sampled` flag in {@link TraceFlags}
     * MUST NOT be set.
     */ SamplingDecision[SamplingDecision["RECORD"] = 1] = "RECORD";
    /**
     * `Span.isRecording() === true` AND `Sampled` flag in {@link TraceFlags}
     * MUST be set.
     */ SamplingDecision[SamplingDecision["RECORD_AND_SAMPLED"] = 2] = "RECORD_AND_SAMPLED";
})($0cc84bf49b6d9783$export$94df7a7a96a92f7b || ($0cc84bf49b6d9783$export$94df7a7a96a92f7b = {}));


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $566044c3d0fbdc36$export$4da4ea8145910e8b;
(function(SpanKind) {
    /** Default value. Indicates that the span is used internally. */ SpanKind[SpanKind["INTERNAL"] = 0] = "INTERNAL";
    /**
     * Indicates that the span covers server-side handling of an RPC or other
     * remote request.
     */ SpanKind[SpanKind["SERVER"] = 1] = "SERVER";
    /**
     * Indicates that the span covers the client-side wrapper around an RPC or
     * other remote request.
     */ SpanKind[SpanKind["CLIENT"] = 2] = "CLIENT";
    /**
     * Indicates that the span describes producer sending a message to a
     * broker. Unlike client and server, there is no direct critical path latency
     * relationship between producer and consumer spans.
     */ SpanKind[SpanKind["PRODUCER"] = 3] = "PRODUCER";
    /**
     * Indicates that the span describes consumer receiving a message from a
     * broker. Unlike client and server, there is no direct critical path latency
     * relationship between producer and consumer spans.
     */ SpanKind[SpanKind["CONSUMER"] = 4] = "CONSUMER";
})($566044c3d0fbdc36$export$4da4ea8145910e8b || ($566044c3d0fbdc36$export$4da4ea8145910e8b = {}));


/**
 * An enumeration of status codes.
 */ var $ed982b21ea27c702$export$1e28dd9b5d01db83;
(function(SpanStatusCode) {
    /**
     * The default status.
     */ SpanStatusCode[SpanStatusCode["UNSET"] = 0] = "UNSET";
    /**
     * The operation has been validated by an Application developer or
     * Operator to have completed successfully.
     */ SpanStatusCode[SpanStatusCode["OK"] = 1] = "OK";
    /**
     * The operation contains an error.
     */ SpanStatusCode[SpanStatusCode["ERROR"] = 2] = "ERROR";
})($ed982b21ea27c702$export$1e28dd9b5d01db83 || ($ed982b21ea27c702$export$1e28dd9b5d01db83 = {}));


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $5dcc187a863bca89$export$bf9049ad2b0883ff;
(function(TraceFlags) {
    /** Represents no flag set. */ TraceFlags[TraceFlags["NONE"] = 0] = "NONE";
    /** Bit to represent whether trace is sampled in trace flags. */ TraceFlags[TraceFlags["SAMPLED"] = 1] = "SAMPLED";
})($5dcc187a863bca89$export$bf9049ad2b0883ff || ($5dcc187a863bca89$export$bf9049ad2b0883ff = {}));



/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $c0773e3017d46dd4$export$55cc39fb0d4bb4c0 = '0000000000000000';
var $c0773e3017d46dd4$export$22be96e88d95e128 = '00000000000000000000000000000000';
var $c0773e3017d46dd4$export$8591e4c852b66703 = {
    traceId: $c0773e3017d46dd4$export$22be96e88d95e128,
    spanId: $c0773e3017d46dd4$export$55cc39fb0d4bb4c0,
    traceFlags: (0, $5dcc187a863bca89$export$bf9049ad2b0883ff).NONE
};


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/**
 * The NonRecordingSpan is the default {@link Span} that is used when no Span
 * implementation is available. All operations are no-op including context
 * propagation.
 */ var $751bfb7d16d79d70$export$972d28f7c6a8c6c7 = /** @class */ function() {
    function NonRecordingSpan(_spanContext) {
        if (_spanContext === void 0) _spanContext = (0, $c0773e3017d46dd4$export$8591e4c852b66703);
        this._spanContext = _spanContext;
    }
    // Returns a SpanContext.
    NonRecordingSpan.prototype.spanContext = function() {
        return this._spanContext;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setAttribute = function(_key, _value) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setAttributes = function(_attributes) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.addEvent = function(_name, _attributes) {
        return this;
    };
    NonRecordingSpan.prototype.addLink = function(_link) {
        return this;
    };
    NonRecordingSpan.prototype.addLinks = function(_links) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setStatus = function(_status) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.updateName = function(_name) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.end = function(_endTime) {};
    // isRecording always returns false for NonRecordingSpan.
    NonRecordingSpan.prototype.isRecording = function() {
        return false;
    };
    // By default does nothing
    NonRecordingSpan.prototype.recordException = function(_exception, _time) {};
    return NonRecordingSpan;
}();


var $99a3da0b8477e363$var$VALID_TRACEID_REGEX = /^([0-9a-f]{32})$/i;
var $99a3da0b8477e363$var$VALID_SPANID_REGEX = /^[0-9a-f]{16}$/i;
function $99a3da0b8477e363$export$29dd34cf1269f6da(traceId) {
    return $99a3da0b8477e363$var$VALID_TRACEID_REGEX.test(traceId) && traceId !== (0, $c0773e3017d46dd4$export$22be96e88d95e128);
}
function $99a3da0b8477e363$export$8e51c6d8f0586aff(spanId) {
    return $99a3da0b8477e363$var$VALID_SPANID_REGEX.test(spanId) && spanId !== (0, $c0773e3017d46dd4$export$55cc39fb0d4bb4c0);
}
function $99a3da0b8477e363$export$e4373b9a2c09216c(spanContext) {
    return $99a3da0b8477e363$export$29dd34cf1269f6da(spanContext.traceId) && $99a3da0b8477e363$export$8e51c6d8f0586aff(spanContext.spanId);
}
function $99a3da0b8477e363$export$c19cc0f1911bdb85(spanContext) {
    return new (0, $751bfb7d16d79d70$export$972d28f7c6a8c6c7)(spanContext);
}



/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $67daccb289228955$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $67daccb289228955$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $67daccb289228955$export$a27e5df35d1539a6 = /** @class */ function() {
    function NoopContextManager() {}
    NoopContextManager.prototype.active = function() {
        return 0, $411320e1da10ff3d$export$78df28f9b2f9a7dc;
    };
    NoopContextManager.prototype.with = function(_context, fn, thisArg) {
        var args = [];
        for(var _i = 3; _i < arguments.length; _i++)args[_i - 3] = arguments[_i];
        return fn.call.apply(fn, $67daccb289228955$var$__spreadArray([
            thisArg
        ], $67daccb289228955$var$__read(args), false));
    };
    NoopContextManager.prototype.bind = function(_context, target) {
        return target;
    };
    NoopContextManager.prototype.enable = function() {
        return this;
    };
    NoopContextManager.prototype.disable = function() {
        return this;
    };
    return NoopContextManager;
}();




var $8d5128149d5cfd94$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $8d5128149d5cfd94$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $8d5128149d5cfd94$var$API_NAME = 'context';
var $8d5128149d5cfd94$var$NOOP_CONTEXT_MANAGER = new (0, $67daccb289228955$export$a27e5df35d1539a6)();
/**
 * Singleton object which represents the entry point to the OpenTelemetry Context API
 */ var $8d5128149d5cfd94$export$4148866f0a453927 = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function ContextAPI() {}
    /** Get the singleton instance of the Context API */ ContextAPI.getInstance = function() {
        if (!this._instance) this._instance = new ContextAPI();
        return this._instance;
    };
    /**
     * Set the current context manager.
     *
     * @returns true if the context manager was successfully registered, else false
     */ ContextAPI.prototype.setGlobalContextManager = function(contextManager) {
        return (0, $b2d9d13e726c481d$export$d586ae880b433238)($8d5128149d5cfd94$var$API_NAME, contextManager, (0, $515ee5c32a70b2b2$export$5c8937ffc688cfd3).instance());
    };
    /**
     * Get the currently active context
     */ ContextAPI.prototype.active = function() {
        return this._getContextManager().active();
    };
    /**
     * Execute a function with an active context
     *
     * @param context context to be active during function execution
     * @param fn function to execute in a context
     * @param thisArg optional receiver to be used for calling fn
     * @param args optional arguments forwarded to fn
     */ ContextAPI.prototype.with = function(context, fn, thisArg) {
        var _a;
        var args = [];
        for(var _i = 3; _i < arguments.length; _i++)args[_i - 3] = arguments[_i];
        return (_a = this._getContextManager()).with.apply(_a, $8d5128149d5cfd94$var$__spreadArray([
            context,
            fn,
            thisArg
        ], $8d5128149d5cfd94$var$__read(args), false));
    };
    /**
     * Bind a context to a target function or event emitter
     *
     * @param context context to bind to the event emitter or function. Defaults to the currently active context
     * @param target function or event emitter to bind
     */ ContextAPI.prototype.bind = function(context, target) {
        return this._getContextManager().bind(context, target);
    };
    ContextAPI.prototype._getContextManager = function() {
        return (0, $b2d9d13e726c481d$export$a4e55266d2135a7f)($8d5128149d5cfd94$var$API_NAME) || $8d5128149d5cfd94$var$NOOP_CONTEXT_MANAGER;
    };
    /** Disable and remove the global context manager */ ContextAPI.prototype.disable = function() {
        this._getContextManager().disable();
        (0, $b2d9d13e726c481d$export$d42ac835f38d1fb2)($8d5128149d5cfd94$var$API_NAME, (0, $515ee5c32a70b2b2$export$5c8937ffc688cfd3).instance());
    };
    return ContextAPI;
}();


var $0c57d9262090934c$export$a078c61943f9dbbe = (0, $8d5128149d5cfd94$export$4148866f0a453927).getInstance();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $0006a4b399ea8ee4$export$c042e7c2f59bc046 = (0, $515ee5c32a70b2b2$export$5c8937ffc688cfd3).instance();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $58d90c77e6429fbf$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * NoopMeter is a noop implementation of the {@link Meter} interface. It reuses
 * constant NoopMetrics for all of its methods.
 */ var $58d90c77e6429fbf$export$c23c6f85dd4fc1e9 = /** @class */ function() {
    function NoopMeter() {}
    /**
     * @see {@link Meter.createGauge}
     */ NoopMeter.prototype.createGauge = function(_name, _options) {
        return $58d90c77e6429fbf$export$dd01300aacbcec1c;
    };
    /**
     * @see {@link Meter.createHistogram}
     */ NoopMeter.prototype.createHistogram = function(_name, _options) {
        return $58d90c77e6429fbf$export$689c32a6a552e1a6;
    };
    /**
     * @see {@link Meter.createCounter}
     */ NoopMeter.prototype.createCounter = function(_name, _options) {
        return $58d90c77e6429fbf$export$e6d19fe5233efc54;
    };
    /**
     * @see {@link Meter.createUpDownCounter}
     */ NoopMeter.prototype.createUpDownCounter = function(_name, _options) {
        return $58d90c77e6429fbf$export$2f189cd99d2b7429;
    };
    /**
     * @see {@link Meter.createObservableGauge}
     */ NoopMeter.prototype.createObservableGauge = function(_name, _options) {
        return $58d90c77e6429fbf$export$ea67e3c6ff624776;
    };
    /**
     * @see {@link Meter.createObservableCounter}
     */ NoopMeter.prototype.createObservableCounter = function(_name, _options) {
        return $58d90c77e6429fbf$export$163422b94c3edbcb;
    };
    /**
     * @see {@link Meter.createObservableUpDownCounter}
     */ NoopMeter.prototype.createObservableUpDownCounter = function(_name, _options) {
        return $58d90c77e6429fbf$export$5b8be9ab17b673b3;
    };
    /**
     * @see {@link Meter.addBatchObservableCallback}
     */ NoopMeter.prototype.addBatchObservableCallback = function(_callback, _observables) {};
    /**
     * @see {@link Meter.removeBatchObservableCallback}
     */ NoopMeter.prototype.removeBatchObservableCallback = function(_callback) {};
    return NoopMeter;
}();
var $58d90c77e6429fbf$export$834a616d1cf278b = /** @class */ function() {
    function NoopMetric() {}
    return NoopMetric;
}();
var $58d90c77e6429fbf$export$b556ba0f560c45b = /** @class */ function(_super) {
    $58d90c77e6429fbf$var$__extends(NoopCounterMetric, _super);
    function NoopCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopCounterMetric.prototype.add = function(_value, _attributes) {};
    return NoopCounterMetric;
}($58d90c77e6429fbf$export$834a616d1cf278b);
var $58d90c77e6429fbf$export$df09a35db160df98 = /** @class */ function(_super) {
    $58d90c77e6429fbf$var$__extends(NoopUpDownCounterMetric, _super);
    function NoopUpDownCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopUpDownCounterMetric.prototype.add = function(_value, _attributes) {};
    return NoopUpDownCounterMetric;
}($58d90c77e6429fbf$export$834a616d1cf278b);
var $58d90c77e6429fbf$export$b7f4a3c7ea16c24 = /** @class */ function(_super) {
    $58d90c77e6429fbf$var$__extends(NoopGaugeMetric, _super);
    function NoopGaugeMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopGaugeMetric.prototype.record = function(_value, _attributes) {};
    return NoopGaugeMetric;
}($58d90c77e6429fbf$export$834a616d1cf278b);
var $58d90c77e6429fbf$export$ef064c3e0426c607 = /** @class */ function(_super) {
    $58d90c77e6429fbf$var$__extends(NoopHistogramMetric, _super);
    function NoopHistogramMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopHistogramMetric.prototype.record = function(_value, _attributes) {};
    return NoopHistogramMetric;
}($58d90c77e6429fbf$export$834a616d1cf278b);
var $58d90c77e6429fbf$export$a5a3e7829c289482 = /** @class */ function() {
    function NoopObservableMetric() {}
    NoopObservableMetric.prototype.addCallback = function(_callback) {};
    NoopObservableMetric.prototype.removeCallback = function(_callback) {};
    return NoopObservableMetric;
}();
var $58d90c77e6429fbf$export$7a7e4b169d5c93a8 = /** @class */ function(_super) {
    $58d90c77e6429fbf$var$__extends(NoopObservableCounterMetric, _super);
    function NoopObservableCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableCounterMetric;
}($58d90c77e6429fbf$export$a5a3e7829c289482);
var $58d90c77e6429fbf$export$6990a2f90809ffc1 = /** @class */ function(_super) {
    $58d90c77e6429fbf$var$__extends(NoopObservableGaugeMetric, _super);
    function NoopObservableGaugeMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableGaugeMetric;
}($58d90c77e6429fbf$export$a5a3e7829c289482);
var $58d90c77e6429fbf$export$3ec3555bc6f693a4 = /** @class */ function(_super) {
    $58d90c77e6429fbf$var$__extends(NoopObservableUpDownCounterMetric, _super);
    function NoopObservableUpDownCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableUpDownCounterMetric;
}($58d90c77e6429fbf$export$a5a3e7829c289482);
var $58d90c77e6429fbf$export$65e277d35235a01f = new $58d90c77e6429fbf$export$c23c6f85dd4fc1e9();
var $58d90c77e6429fbf$export$e6d19fe5233efc54 = new $58d90c77e6429fbf$export$b556ba0f560c45b();
var $58d90c77e6429fbf$export$dd01300aacbcec1c = new $58d90c77e6429fbf$export$b7f4a3c7ea16c24();
var $58d90c77e6429fbf$export$689c32a6a552e1a6 = new $58d90c77e6429fbf$export$ef064c3e0426c607();
var $58d90c77e6429fbf$export$2f189cd99d2b7429 = new $58d90c77e6429fbf$export$df09a35db160df98();
var $58d90c77e6429fbf$export$163422b94c3edbcb = new $58d90c77e6429fbf$export$7a7e4b169d5c93a8();
var $58d90c77e6429fbf$export$ea67e3c6ff624776 = new $58d90c77e6429fbf$export$6990a2f90809ffc1();
var $58d90c77e6429fbf$export$5b8be9ab17b673b3 = new $58d90c77e6429fbf$export$3ec3555bc6f693a4();
function $58d90c77e6429fbf$export$bc3a498ccbb5c2b5() {
    return $58d90c77e6429fbf$export$65e277d35235a01f;
}


/**
 * An implementation of the {@link MeterProvider} which returns an impotent Meter
 * for all calls to `getMeter`
 */ var $eb5099a020c5ab24$export$51c513ea08316108 = /** @class */ function() {
    function NoopMeterProvider() {}
    NoopMeterProvider.prototype.getMeter = function(_name, _version, _options) {
        return 0, $58d90c77e6429fbf$export$65e277d35235a01f;
    };
    return NoopMeterProvider;
}();
var $eb5099a020c5ab24$export$d21fe83355c56e18 = new $eb5099a020c5ab24$export$51c513ea08316108();




var $e9dac7b9b480fa25$var$API_NAME = 'metrics';
/**
 * Singleton object which represents the entry point to the OpenTelemetry Metrics API
 */ var $e9dac7b9b480fa25$export$1339f6eb6111c638 = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function MetricsAPI() {}
    /** Get the singleton instance of the Metrics API */ MetricsAPI.getInstance = function() {
        if (!this._instance) this._instance = new MetricsAPI();
        return this._instance;
    };
    /**
     * Set the current global meter provider.
     * Returns true if the meter provider was successfully registered, else false.
     */ MetricsAPI.prototype.setGlobalMeterProvider = function(provider) {
        return (0, $b2d9d13e726c481d$export$d586ae880b433238)($e9dac7b9b480fa25$var$API_NAME, provider, (0, $515ee5c32a70b2b2$export$5c8937ffc688cfd3).instance());
    };
    /**
     * Returns the global meter provider.
     */ MetricsAPI.prototype.getMeterProvider = function() {
        return (0, $b2d9d13e726c481d$export$a4e55266d2135a7f)($e9dac7b9b480fa25$var$API_NAME) || (0, $eb5099a020c5ab24$export$d21fe83355c56e18);
    };
    /**
     * Returns a meter from the global meter provider.
     */ MetricsAPI.prototype.getMeter = function(name, version, options) {
        return this.getMeterProvider().getMeter(name, version, options);
    };
    /** Remove the global meter provider */ MetricsAPI.prototype.disable = function() {
        (0, $b2d9d13e726c481d$export$d42ac835f38d1fb2)($e9dac7b9b480fa25$var$API_NAME, (0, $515ee5c32a70b2b2$export$5c8937ffc688cfd3).instance());
    };
    return MetricsAPI;
}();


var $b8db6f384fae8886$export$b0c5c2fac8144e54 = (0, $e9dac7b9b480fa25$export$1339f6eb6111c638).getInstance();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * No-op implementations of {@link TextMapPropagator}.
 */ var $f1e8bb5930fe5111$export$8356c7eb3af7963b = /** @class */ function() {
    function NoopTextMapPropagator() {}
    /** Noop inject function does nothing */ NoopTextMapPropagator.prototype.inject = function(_context, _carrier) {};
    /** Noop extract function does nothing and returns the input context */ NoopTextMapPropagator.prototype.extract = function(context, _carrier) {
        return context;
    };
    NoopTextMapPropagator.prototype.fields = function() {
        return [];
    };
    return NoopTextMapPropagator;
}();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $53c5756a2197b4fb$export$a0f575f55f38720a = {
    get: function(carrier, key) {
        if (carrier == null) return undefined;
        return carrier[key];
    },
    keys: function(carrier) {
        if (carrier == null) return [];
        return Object.keys(carrier);
    }
};
var $53c5756a2197b4fb$export$f70f1d111fccf1c1 = {
    set: function(carrier, key, value) {
        if (carrier == null) return;
        carrier[key] = value;
    }
};


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

/**
 * Baggage key
 */ var $20f935f8b2b2bb5d$var$BAGGAGE_KEY = (0, $411320e1da10ff3d$export$b8c322c5a7cfce78)('OpenTelemetry Baggage Key');
function $20f935f8b2b2bb5d$export$f3bffa0b5dd10d1e(context) {
    return context.getValue($20f935f8b2b2bb5d$var$BAGGAGE_KEY) || undefined;
}
function $20f935f8b2b2bb5d$export$120a1756099436ee() {
    return $20f935f8b2b2bb5d$export$f3bffa0b5dd10d1e((0, $8d5128149d5cfd94$export$4148866f0a453927).getInstance().active());
}
function $20f935f8b2b2bb5d$export$adc9ca19eab3f500(context, baggage) {
    return context.setValue($20f935f8b2b2bb5d$var$BAGGAGE_KEY, baggage);
}
function $20f935f8b2b2bb5d$export$4ca3a8a743c9f633(context) {
    return context.deleteValue($20f935f8b2b2bb5d$var$BAGGAGE_KEY);
}




var $ae331592dad650ec$var$API_NAME = 'propagation';
var $ae331592dad650ec$var$NOOP_TEXT_MAP_PROPAGATOR = new (0, $f1e8bb5930fe5111$export$8356c7eb3af7963b)();
/**
 * Singleton object which represents the entry point to the OpenTelemetry Propagation API
 */ var $ae331592dad650ec$export$471eda0a6213cac9 = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function PropagationAPI() {
        this.createBaggage = (0, $36ecce552d4bbf35$export$1034a425c7384452);
        this.getBaggage = (0, $20f935f8b2b2bb5d$export$f3bffa0b5dd10d1e);
        this.getActiveBaggage = (0, $20f935f8b2b2bb5d$export$120a1756099436ee);
        this.setBaggage = (0, $20f935f8b2b2bb5d$export$adc9ca19eab3f500);
        this.deleteBaggage = (0, $20f935f8b2b2bb5d$export$4ca3a8a743c9f633);
    }
    /** Get the singleton instance of the Propagator API */ PropagationAPI.getInstance = function() {
        if (!this._instance) this._instance = new PropagationAPI();
        return this._instance;
    };
    /**
     * Set the current propagator.
     *
     * @returns true if the propagator was successfully registered, else false
     */ PropagationAPI.prototype.setGlobalPropagator = function(propagator) {
        return (0, $b2d9d13e726c481d$export$d586ae880b433238)($ae331592dad650ec$var$API_NAME, propagator, (0, $515ee5c32a70b2b2$export$5c8937ffc688cfd3).instance());
    };
    /**
     * Inject context into a carrier to be propagated inter-process
     *
     * @param context Context carrying tracing data to inject
     * @param carrier carrier to inject context into
     * @param setter Function used to set values on the carrier
     */ PropagationAPI.prototype.inject = function(context, carrier, setter) {
        if (setter === void 0) setter = (0, $53c5756a2197b4fb$export$f70f1d111fccf1c1);
        return this._getGlobalPropagator().inject(context, carrier, setter);
    };
    /**
     * Extract context from a carrier
     *
     * @param context Context which the newly created context will inherit from
     * @param carrier Carrier to extract context from
     * @param getter Function used to extract keys from a carrier
     */ PropagationAPI.prototype.extract = function(context, carrier, getter) {
        if (getter === void 0) getter = (0, $53c5756a2197b4fb$export$a0f575f55f38720a);
        return this._getGlobalPropagator().extract(context, carrier, getter);
    };
    /**
     * Return a list of all fields which may be used by the propagator.
     */ PropagationAPI.prototype.fields = function() {
        return this._getGlobalPropagator().fields();
    };
    /** Remove the global propagator */ PropagationAPI.prototype.disable = function() {
        (0, $b2d9d13e726c481d$export$d42ac835f38d1fb2)($ae331592dad650ec$var$API_NAME, (0, $515ee5c32a70b2b2$export$5c8937ffc688cfd3).instance());
    };
    PropagationAPI.prototype._getGlobalPropagator = function() {
        return (0, $b2d9d13e726c481d$export$a4e55266d2135a7f)($ae331592dad650ec$var$API_NAME) || $ae331592dad650ec$var$NOOP_TEXT_MAP_PROPAGATOR;
    };
    return PropagationAPI;
}();


var $77955577000c938d$export$3e49040daa9dba20 = (0, $ae331592dad650ec$export$471eda0a6213cac9).getInstance();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 


/**
 * span key
 */ var $ead6237849042dac$var$SPAN_KEY = (0, $411320e1da10ff3d$export$b8c322c5a7cfce78)('OpenTelemetry Context Key SPAN');
function $ead6237849042dac$export$246e04ba06066af1(context) {
    return context.getValue($ead6237849042dac$var$SPAN_KEY) || undefined;
}
function $ead6237849042dac$export$1be426a8e585c83e() {
    return $ead6237849042dac$export$246e04ba06066af1((0, $8d5128149d5cfd94$export$4148866f0a453927).getInstance().active());
}
function $ead6237849042dac$export$8ab2f2e6ee8ed0a8(context, span) {
    return context.setValue($ead6237849042dac$var$SPAN_KEY, span);
}
function $ead6237849042dac$export$a6bbfe9a17f7941c(context) {
    return context.deleteValue($ead6237849042dac$var$SPAN_KEY);
}
function $ead6237849042dac$export$c90bf5428c14cdb1(context, spanContext) {
    return $ead6237849042dac$export$8ab2f2e6ee8ed0a8(context, new (0, $751bfb7d16d79d70$export$972d28f7c6a8c6c7)(spanContext));
}
function $ead6237849042dac$export$1a635f8f0b912781(context) {
    var _a;
    return (_a = $ead6237849042dac$export$246e04ba06066af1(context)) === null || _a === void 0 ? void 0 : _a.spanContext();
}




var $0391c1963efeb814$var$contextApi = (0, $8d5128149d5cfd94$export$4148866f0a453927).getInstance();
/**
 * No-op implementations of {@link Tracer}.
 */ var $0391c1963efeb814$export$714c1036cabcd223 = /** @class */ function() {
    function NoopTracer() {}
    // startSpan starts a noop span.
    NoopTracer.prototype.startSpan = function(name, options, context) {
        if (context === void 0) context = $0391c1963efeb814$var$contextApi.active();
        var root = Boolean(options === null || options === void 0 ? void 0 : options.root);
        if (root) return new (0, $751bfb7d16d79d70$export$972d28f7c6a8c6c7)();
        var parentFromContext = context && (0, $ead6237849042dac$export$1a635f8f0b912781)(context);
        if ($0391c1963efeb814$var$isSpanContext(parentFromContext) && (0, $99a3da0b8477e363$export$e4373b9a2c09216c)(parentFromContext)) return new (0, $751bfb7d16d79d70$export$972d28f7c6a8c6c7)(parentFromContext);
        else return new (0, $751bfb7d16d79d70$export$972d28f7c6a8c6c7)();
    };
    NoopTracer.prototype.startActiveSpan = function(name, arg2, arg3, arg4) {
        var opts;
        var ctx;
        var fn;
        if (arguments.length < 2) return;
        else if (arguments.length === 2) fn = arg2;
        else if (arguments.length === 3) {
            opts = arg2;
            fn = arg3;
        } else {
            opts = arg2;
            ctx = arg3;
            fn = arg4;
        }
        var parentContext = ctx !== null && ctx !== void 0 ? ctx : $0391c1963efeb814$var$contextApi.active();
        var span = this.startSpan(name, opts, parentContext);
        var contextWithSpanSet = (0, $ead6237849042dac$export$8ab2f2e6ee8ed0a8)(parentContext, span);
        return $0391c1963efeb814$var$contextApi.with(contextWithSpanSet, fn, undefined, span);
    };
    return NoopTracer;
}();
function $0391c1963efeb814$var$isSpanContext(spanContext) {
    return typeof spanContext === 'object' && typeof spanContext['spanId'] === 'string' && typeof spanContext['traceId'] === 'string' && typeof spanContext['traceFlags'] === 'number';
}


var $652ff47926e88b55$var$NOOP_TRACER = new (0, $0391c1963efeb814$export$714c1036cabcd223)();
/**
 * Proxy tracer provided by the proxy tracer provider
 */ var $652ff47926e88b55$export$df2c38268c6bb6b3 = /** @class */ function() {
    function ProxyTracer(_provider, name, version, options) {
        this._provider = _provider;
        this.name = name;
        this.version = version;
        this.options = options;
    }
    ProxyTracer.prototype.startSpan = function(name, options, context) {
        return this._getTracer().startSpan(name, options, context);
    };
    ProxyTracer.prototype.startActiveSpan = function(_name, _options, _context, _fn) {
        var tracer = this._getTracer();
        return Reflect.apply(tracer.startActiveSpan, tracer, arguments);
    };
    /**
     * Try to get a tracer from the proxy tracer provider.
     * If the proxy tracer provider has no delegate, return a noop tracer.
     */ ProxyTracer.prototype._getTracer = function() {
        if (this._delegate) return this._delegate;
        var tracer = this._provider.getDelegateTracer(this.name, this.version, this.options);
        if (!tracer) return $652ff47926e88b55$var$NOOP_TRACER;
        this._delegate = tracer;
        return this._delegate;
    };
    return ProxyTracer;
}();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/**
 * An implementation of the {@link TracerProvider} which returns an impotent
 * Tracer for all calls to `getTracer`.
 *
 * All operations are no-op.
 */ var $df5db4b932dc665b$export$87d8e93756f9e86e = /** @class */ function() {
    function NoopTracerProvider() {}
    NoopTracerProvider.prototype.getTracer = function(_name, _version, _options) {
        return new (0, $0391c1963efeb814$export$714c1036cabcd223)();
    };
    return NoopTracerProvider;
}();


var $78f56c784e7c1cff$var$NOOP_TRACER_PROVIDER = new (0, $df5db4b932dc665b$export$87d8e93756f9e86e)();
/**
 * Tracer provider which provides {@link ProxyTracer}s.
 *
 * Before a delegate is set, tracers provided are NoOp.
 *   When a delegate is set, traces are provided from the delegate.
 *   When a delegate is set after tracers have already been provided,
 *   all tracers already provided will use the provided delegate implementation.
 */ var $78f56c784e7c1cff$export$4137aabcb4254962 = /** @class */ function() {
    function ProxyTracerProvider() {}
    /**
     * Get a {@link ProxyTracer}
     */ ProxyTracerProvider.prototype.getTracer = function(name, version, options) {
        var _a;
        return (_a = this.getDelegateTracer(name, version, options)) !== null && _a !== void 0 ? _a : new (0, $652ff47926e88b55$export$df2c38268c6bb6b3)(this, name, version, options);
    };
    ProxyTracerProvider.prototype.getDelegate = function() {
        var _a;
        return (_a = this._delegate) !== null && _a !== void 0 ? _a : $78f56c784e7c1cff$var$NOOP_TRACER_PROVIDER;
    };
    /**
     * Set the delegate tracer provider
     */ ProxyTracerProvider.prototype.setDelegate = function(delegate) {
        this._delegate = delegate;
    };
    ProxyTracerProvider.prototype.getDelegateTracer = function(name, version, options) {
        var _a;
        return (_a = this._delegate) === null || _a === void 0 ? void 0 : _a.getTracer(name, version, options);
    };
    return ProxyTracerProvider;
}();





var $ae20af81b47909fe$var$API_NAME = 'trace';
/**
 * Singleton object which represents the entry point to the OpenTelemetry Tracing API
 */ var $ae20af81b47909fe$export$2cccde6fcc7b568a = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function TraceAPI() {
        this._proxyTracerProvider = new (0, $78f56c784e7c1cff$export$4137aabcb4254962)();
        this.wrapSpanContext = (0, $99a3da0b8477e363$export$c19cc0f1911bdb85);
        this.isSpanContextValid = (0, $99a3da0b8477e363$export$e4373b9a2c09216c);
        this.deleteSpan = (0, $ead6237849042dac$export$a6bbfe9a17f7941c);
        this.getSpan = (0, $ead6237849042dac$export$246e04ba06066af1);
        this.getActiveSpan = (0, $ead6237849042dac$export$1be426a8e585c83e);
        this.getSpanContext = (0, $ead6237849042dac$export$1a635f8f0b912781);
        this.setSpan = (0, $ead6237849042dac$export$8ab2f2e6ee8ed0a8);
        this.setSpanContext = (0, $ead6237849042dac$export$c90bf5428c14cdb1);
    }
    /** Get the singleton instance of the Trace API */ TraceAPI.getInstance = function() {
        if (!this._instance) this._instance = new TraceAPI();
        return this._instance;
    };
    /**
     * Set the current global tracer.
     *
     * @returns true if the tracer provider was successfully registered, else false
     */ TraceAPI.prototype.setGlobalTracerProvider = function(provider) {
        var success = (0, $b2d9d13e726c481d$export$d586ae880b433238)($ae20af81b47909fe$var$API_NAME, this._proxyTracerProvider, (0, $515ee5c32a70b2b2$export$5c8937ffc688cfd3).instance());
        if (success) this._proxyTracerProvider.setDelegate(provider);
        return success;
    };
    /**
     * Returns the global tracer provider.
     */ TraceAPI.prototype.getTracerProvider = function() {
        return (0, $b2d9d13e726c481d$export$a4e55266d2135a7f)($ae20af81b47909fe$var$API_NAME) || this._proxyTracerProvider;
    };
    /**
     * Returns a tracer from the global tracer provider.
     */ TraceAPI.prototype.getTracer = function(name, version) {
        return this.getTracerProvider().getTracer(name, version);
    };
    /** Remove the global tracer provider */ TraceAPI.prototype.disable = function() {
        (0, $b2d9d13e726c481d$export$d42ac835f38d1fb2)($ae20af81b47909fe$var$API_NAME, (0, $515ee5c32a70b2b2$export$5c8937ffc688cfd3).instance());
        this._proxyTracerProvider = new (0, $78f56c784e7c1cff$export$4137aabcb4254962)();
    };
    return TraceAPI;
}();


var $496851d2cf78caa4$export$357889f174732d38 = (0, $ae20af81b47909fe$export$2cccde6fcc7b568a).getInstance();


var // Default export.
$6b26b0d919da0068$export$2e2bcd8739ae039 = {
    context: (0, $0c57d9262090934c$export$a078c61943f9dbbe),
    diag: (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046),
    metrics: (0, $b8db6f384fae8886$export$b0c5c2fac8144e54),
    propagation: (0, $77955577000c938d$export$3e49040daa9dba20),
    trace: (0, $496851d2cf78caa4$export$357889f174732d38)
};


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // this is autogenerated file, see scripts/version-update.js
const $0ce0ff0f84d92ad6$export$a4ad2735b021c132 = '2.2.0';


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ //----------------------------------------------------------------------------------------------------------
// DO NOT EDIT, this is an Auto-generated file from scripts/semconv/templates/registry/stable/attributes.ts.j2
//----------------------------------------------------------------------------------------------------------
/**
 * ASP.NET Core exception middleware handling result.
 *
 * @example handled
 * @example unhandled
 */ const $3fcd7ea0f1087866$export$f82340eb6f7ee4fc = 'aspnetcore.diagnostics.exception.result';
const $3fcd7ea0f1087866$export$cda1f266e1fc5b3f = "aborted";
const $3fcd7ea0f1087866$export$f59ec205fdfe6400 = "handled";
const $3fcd7ea0f1087866$export$b427e935fd6651ab = "skipped";
const $3fcd7ea0f1087866$export$7a0c380cad26f867 = "unhandled";
const $3fcd7ea0f1087866$export$e15ee6ced4b4d793 = 'aspnetcore.diagnostics.handler.type';
const $3fcd7ea0f1087866$export$d6be6e9a073ccba5 = 'aspnetcore.rate_limiting.policy';
const $3fcd7ea0f1087866$export$df376702a339c094 = 'aspnetcore.rate_limiting.result';
const $3fcd7ea0f1087866$export$e160ee3fb23dd21e = "acquired";
const $3fcd7ea0f1087866$export$336cf096763833a3 = "endpoint_limiter";
const $3fcd7ea0f1087866$export$ee99d6c8d66ba053 = "global_limiter";
const $3fcd7ea0f1087866$export$d4525b0bcb1802a6 = "request_canceled";
const $3fcd7ea0f1087866$export$746fc3f900d45c45 = 'aspnetcore.request.is_unhandled';
const $3fcd7ea0f1087866$export$bcd5f0f8484c3bc0 = 'aspnetcore.routing.is_fallback';
const $3fcd7ea0f1087866$export$d181153b8bdfa0b6 = 'aspnetcore.routing.match_status';
const $3fcd7ea0f1087866$export$ca7f093befa342d4 = "failure";
const $3fcd7ea0f1087866$export$ae1a39d3a4050746 = "success";
const $3fcd7ea0f1087866$export$f25890d1e3848156 = 'aspnetcore.user.is_authenticated';
const $3fcd7ea0f1087866$export$d68d146ff79c04a8 = 'client.address';
const $3fcd7ea0f1087866$export$98967a53baad5eec = 'client.port';
const $3fcd7ea0f1087866$export$5285ee03db771e5b = 'code.column.number';
const $3fcd7ea0f1087866$export$ac9d6c9a41211595 = 'code.file.path';
const $3fcd7ea0f1087866$export$fd34f7e1f0c418fc = 'code.function.name';
const $3fcd7ea0f1087866$export$ccc16b040f2d3c68 = 'code.line.number';
const $3fcd7ea0f1087866$export$84cf154ace206984 = 'code.stacktrace';
const $3fcd7ea0f1087866$export$f3ebe872053c9886 = 'db.collection.name';
const $3fcd7ea0f1087866$export$354f27025f67a12d = 'db.namespace';
const $3fcd7ea0f1087866$export$899baaeb75956560 = 'db.operation.batch.size';
const $3fcd7ea0f1087866$export$32ff3b5ea8eeed5d = 'db.operation.name';
const $3fcd7ea0f1087866$export$ebef2908cb0508b2 = 'db.query.summary';
const $3fcd7ea0f1087866$export$dc45382793fd9c73 = 'db.query.text';
const $3fcd7ea0f1087866$export$5f1e82edb68082a5 = 'db.response.status_code';
const $3fcd7ea0f1087866$export$59730bfffb801deb = 'db.stored_procedure.name';
const $3fcd7ea0f1087866$export$e092ac179da1bacb = 'db.system.name';
const $3fcd7ea0f1087866$export$33a9d0e8e2693338 = "mariadb";
const $3fcd7ea0f1087866$export$e0e77e85ab698795 = "microsoft.sql_server";
const $3fcd7ea0f1087866$export$6b580327d217ab17 = "mysql";
const $3fcd7ea0f1087866$export$de5fcd2a0648ea59 = "postgresql";
const $3fcd7ea0f1087866$export$50d2ae8f0fe53654 = 'dotnet.gc.heap.generation';
const $3fcd7ea0f1087866$export$53c7cec226bbc008 = "gen0";
const $3fcd7ea0f1087866$export$16eba2d1cd3c6aae = "gen1";
const $3fcd7ea0f1087866$export$53cbcd4ebe9fed52 = "gen2";
const $3fcd7ea0f1087866$export$73025750a790bd80 = "loh";
const $3fcd7ea0f1087866$export$92f06dbb8b8e4efb = "poh";
const $3fcd7ea0f1087866$export$27bc5d0fa190eb39 = 'error.type';
const $3fcd7ea0f1087866$export$c00e2e224ae81dcc = "_OTHER";
const $3fcd7ea0f1087866$export$5afa65f3c67a6da5 = 'exception.escaped';
const $3fcd7ea0f1087866$export$ab4513c1b55519b5 = 'exception.message';
const $3fcd7ea0f1087866$export$9b74e4928364b671 = 'exception.stacktrace';
const $3fcd7ea0f1087866$export$85da07cb5d867763 = 'exception.type';
const $3fcd7ea0f1087866$export$6dc05c1a4ea7d452 = (key)=>`http.request.header.${key}`;
const $3fcd7ea0f1087866$export$c950c48d651d36f6 = 'http.request.method';
const $3fcd7ea0f1087866$export$475d0b6904c72522 = "_OTHER";
const $3fcd7ea0f1087866$export$1d0475e0429ecc7a = "CONNECT";
const $3fcd7ea0f1087866$export$f5009fc3b2e116f6 = "DELETE";
const $3fcd7ea0f1087866$export$b37eb57f1c0ae17e = "GET";
const $3fcd7ea0f1087866$export$cfad2d23aef0a595 = "HEAD";
const $3fcd7ea0f1087866$export$ffb5e83a22c8414 = "OPTIONS";
const $3fcd7ea0f1087866$export$c4e10ea4e2b3375 = "PATCH";
const $3fcd7ea0f1087866$export$ca259afc8ad50e83 = "POST";
const $3fcd7ea0f1087866$export$a8e9778ce76ecdaa = "PUT";
const $3fcd7ea0f1087866$export$81cc82dc1804c06e = "TRACE";
const $3fcd7ea0f1087866$export$b4706f4398125cd2 = 'http.request.method_original';
const $3fcd7ea0f1087866$export$44a2b6455db2b082 = 'http.request.resend_count';
const $3fcd7ea0f1087866$export$a3227fcde36256b7 = (key)=>`http.response.header.${key}`;
const $3fcd7ea0f1087866$export$4f9cc9c1e7b4e832 = 'http.response.status_code';
const $3fcd7ea0f1087866$export$ee724a749950397e = 'http.route';
const $3fcd7ea0f1087866$export$9633601338584456 = 'jvm.gc.action';
const $3fcd7ea0f1087866$export$81a9f72367df0211 = 'jvm.gc.name';
const $3fcd7ea0f1087866$export$27fb7cfe62c0cad7 = 'jvm.memory.pool.name';
const $3fcd7ea0f1087866$export$c9dfa04abbde6209 = 'jvm.memory.type';
const $3fcd7ea0f1087866$export$5eceb6c6d9c4a2b1 = "heap";
const $3fcd7ea0f1087866$export$fb42d239cc164326 = "non_heap";
const $3fcd7ea0f1087866$export$b9f4735680b4c618 = 'jvm.thread.daemon';
const $3fcd7ea0f1087866$export$49cfe86a143a90f4 = 'jvm.thread.state';
const $3fcd7ea0f1087866$export$4d1c8eb785b37946 = "blocked";
const $3fcd7ea0f1087866$export$438d3b92d604d3c1 = "new";
const $3fcd7ea0f1087866$export$efbf4822176b787e = "runnable";
const $3fcd7ea0f1087866$export$10d62496862243a3 = "terminated";
const $3fcd7ea0f1087866$export$54c3957659069067 = "timed_waiting";
const $3fcd7ea0f1087866$export$97de93f28bd98f0c = "waiting";
const $3fcd7ea0f1087866$export$122a3f3d92b58f2d = 'network.local.address';
const $3fcd7ea0f1087866$export$dd3d00f8681df0ce = 'network.local.port';
const $3fcd7ea0f1087866$export$28b7676252843fab = 'network.peer.address';
const $3fcd7ea0f1087866$export$9fb532b0fee2b1f1 = 'network.peer.port';
const $3fcd7ea0f1087866$export$dee59b686a2846ec = 'network.protocol.name';
const $3fcd7ea0f1087866$export$d98f8d975600c0d0 = 'network.protocol.version';
const $3fcd7ea0f1087866$export$7616c996937a34bc = 'network.transport';
const $3fcd7ea0f1087866$export$f4431576993bcf7a = "pipe";
const $3fcd7ea0f1087866$export$169e124b418d088f = "quic";
const $3fcd7ea0f1087866$export$26ef76391bdfab1b = "tcp";
const $3fcd7ea0f1087866$export$a1d89d523a38f571 = "udp";
const $3fcd7ea0f1087866$export$19b3a90274118dec = "unix";
const $3fcd7ea0f1087866$export$9ce893eda94da085 = 'network.type';
const $3fcd7ea0f1087866$export$1c0032dd042c0036 = "ipv4";
const $3fcd7ea0f1087866$export$2e20616f92e0c61 = "ipv6";
const $3fcd7ea0f1087866$export$c0272561abab91e2 = 'otel.scope.name';
const $3fcd7ea0f1087866$export$f34b883f266e7940 = 'otel.scope.version';
const $3fcd7ea0f1087866$export$1ce3678560a98f66 = 'otel.status_code';
const $3fcd7ea0f1087866$export$91e9746558fdb3eb = "ERROR";
const $3fcd7ea0f1087866$export$88d70046bd134963 = "OK";
const $3fcd7ea0f1087866$export$bb722bc34dbbae55 = 'otel.status_description';
const $3fcd7ea0f1087866$export$a5acaa0dbc823e02 = 'server.address';
const $3fcd7ea0f1087866$export$b7822882ad829476 = 'server.port';
const $3fcd7ea0f1087866$export$84187ab40ae4fa9c = 'service.name';
const $3fcd7ea0f1087866$export$262ef07bab967f36 = 'service.version';
const $3fcd7ea0f1087866$export$d52213f71e0d6fe9 = 'signalr.connection.status';
const $3fcd7ea0f1087866$export$1941a43dd05c1796 = "app_shutdown";
const $3fcd7ea0f1087866$export$339985f783caddd3 = "normal_closure";
const $3fcd7ea0f1087866$export$5dbce0c170853f5d = "timeout";
const $3fcd7ea0f1087866$export$344eec4d4360b8c9 = 'signalr.transport';
const $3fcd7ea0f1087866$export$c9ad321a279e5110 = "long_polling";
const $3fcd7ea0f1087866$export$ade38f22da951337 = "server_sent_events";
const $3fcd7ea0f1087866$export$cb9a023ecee30642 = "web_sockets";
const $3fcd7ea0f1087866$export$f0cc9f40fa472996 = 'telemetry.sdk.language';
const $3fcd7ea0f1087866$export$76253579e9fea8e3 = "cpp";
const $3fcd7ea0f1087866$export$4163d8f19c62acfe = "dotnet";
const $3fcd7ea0f1087866$export$d735f65160d35019 = "erlang";
const $3fcd7ea0f1087866$export$1dde175b7d1c8a44 = "go";
const $3fcd7ea0f1087866$export$73150af2f1f383fa = "java";
const $3fcd7ea0f1087866$export$1b3cb919ea0daa1c = "nodejs";
const $3fcd7ea0f1087866$export$1a3ac4d13e9292be = "php";
const $3fcd7ea0f1087866$export$5734868f06d7b5c8 = "python";
const $3fcd7ea0f1087866$export$b7bb3f8171ef2aa3 = "ruby";
const $3fcd7ea0f1087866$export$713f4fffa2875054 = "rust";
const $3fcd7ea0f1087866$export$8d08f2cb0d9fd722 = "swift";
const $3fcd7ea0f1087866$export$2f063992689fdf64 = "webjs";
const $3fcd7ea0f1087866$export$8f719441032e7a01 = 'telemetry.sdk.name';
const $3fcd7ea0f1087866$export$5fe5e8dd061ec635 = 'telemetry.sdk.version';
const $3fcd7ea0f1087866$export$f00e0b7bc579cfe4 = 'url.fragment';
const $3fcd7ea0f1087866$export$ef7da4fb774e8a84 = 'url.full';
const $3fcd7ea0f1087866$export$36f670b9709ab2f8 = 'url.path';
const $3fcd7ea0f1087866$export$55ce97b387061dd1 = 'url.query';
const $3fcd7ea0f1087866$export$d1d5ca1ca02801e6 = 'url.scheme';
const $3fcd7ea0f1087866$export$11d4f8ef7be26b3d = 'user_agent.original';


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * This file contains a copy of unstable semantic convention definitions
 * used by this package.
 * @see https://github.com/open-telemetry/opentelemetry-js/tree/main/semantic-conventions#unstable-semconv
 */ /**
 * The name of the runtime of this process.
 *
 * @example OpenJDK Runtime Environment
 *
 * @experimental This attribute is experimental and is subject to breaking changes in minor releases of `@opentelemetry/semantic-conventions`.
 */ const $0d91014795ea706f$export$ad06ab84cf3d9d79 = 'process.runtime.name';


const $1c5e0c7f8c3f5fd5$export$3c44663382dce232 = {
    [(0, $3fcd7ea0f1087866$export$8f719441032e7a01)]: 'opentelemetry',
    [(0, $0d91014795ea706f$export$ad06ab84cf3d9d79)]: 'browser',
    [(0, $3fcd7ea0f1087866$export$f0cc9f40fa472996)]: (0, $3fcd7ea0f1087866$export$2f063992689fdf64),
    [(0, $3fcd7ea0f1087866$export$5fe5e8dd061ec635)]: (0, $0ce0ff0f84d92ad6$export$a4ad2735b021c132)
};



/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $83363c78016a8c41$export$b8c2abd2a6cf7c10() {
    return 'unknown_service';
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $7c4fbd050fa7f541$export$ae936b9d47e5870e = (val)=>{
    return val !== null && typeof val === 'object' && typeof val.then === 'function';
};
function $7c4fbd050fa7f541$export$f0954fd7d5368655(_) {
    return _;
}


class $34b7feab81bdb448$var$ResourceImpl {
    _rawAttributes;
    _asyncAttributesPending = false;
    _schemaUrl;
    _memoizedAttributes;
    static FromAttributeList(attributes, options) {
        const res = new $34b7feab81bdb448$var$ResourceImpl({}, options);
        res._rawAttributes = $34b7feab81bdb448$var$guardedRawAttributes(attributes);
        res._asyncAttributesPending = attributes.filter(([_, val])=>(0, $7c4fbd050fa7f541$export$ae936b9d47e5870e)(val)).length > 0;
        return res;
    }
    constructor(/**
     * A dictionary of attributes with string keys and values that provide
     * information about the entity as numbers, strings or booleans
     * TODO: Consider to add check/validation on attributes.
     */ resource, options){
        const attributes = resource.attributes ?? {};
        this._rawAttributes = Object.entries(attributes).map(([k, v])=>{
            if ((0, $7c4fbd050fa7f541$export$ae936b9d47e5870e)(v)) // side-effect
            this._asyncAttributesPending = true;
            return [
                k,
                v
            ];
        });
        this._rawAttributes = $34b7feab81bdb448$var$guardedRawAttributes(this._rawAttributes);
        this._schemaUrl = $34b7feab81bdb448$var$validateSchemaUrl(options?.schemaUrl);
    }
    get asyncAttributesPending() {
        return this._asyncAttributesPending;
    }
    async waitForAsyncAttributes() {
        if (!this.asyncAttributesPending) return;
        for(let i = 0; i < this._rawAttributes.length; i++){
            const [k, v] = this._rawAttributes[i];
            this._rawAttributes[i] = [
                k,
                (0, $7c4fbd050fa7f541$export$ae936b9d47e5870e)(v) ? await v : v
            ];
        }
        this._asyncAttributesPending = false;
    }
    get attributes() {
        if (this.asyncAttributesPending) (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).error('Accessing resource attributes before async attributes settled');
        if (this._memoizedAttributes) return this._memoizedAttributes;
        const attrs = {};
        for (const [k, v] of this._rawAttributes){
            if ((0, $7c4fbd050fa7f541$export$ae936b9d47e5870e)(v)) {
                (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).debug(`Unsettled resource attribute ${k} skipped`);
                continue;
            }
            if (v != null) attrs[k] ??= v;
        }
        // only memoize output if all attributes are settled
        if (!this._asyncAttributesPending) this._memoizedAttributes = attrs;
        return attrs;
    }
    getRawAttributes() {
        return this._rawAttributes;
    }
    get schemaUrl() {
        return this._schemaUrl;
    }
    merge(resource) {
        if (resource == null) return this;
        // Order is important
        // Spec states incoming attributes override existing attributes
        const mergedSchemaUrl = $34b7feab81bdb448$var$mergeSchemaUrl(this, resource);
        const mergedOptions = mergedSchemaUrl ? {
            schemaUrl: mergedSchemaUrl
        } : undefined;
        return $34b7feab81bdb448$var$ResourceImpl.FromAttributeList([
            ...resource.getRawAttributes(),
            ...this.getRawAttributes()
        ], mergedOptions);
    }
}
function $34b7feab81bdb448$export$bb0fe4e7060febbf(attributes, options) {
    return $34b7feab81bdb448$var$ResourceImpl.FromAttributeList(Object.entries(attributes), options);
}
function $34b7feab81bdb448$export$4d462f2e58ee368a(detectedResource, options) {
    return new $34b7feab81bdb448$var$ResourceImpl(detectedResource, options);
}
function $34b7feab81bdb448$export$6ed870441802d126() {
    return $34b7feab81bdb448$export$bb0fe4e7060febbf({});
}
function $34b7feab81bdb448$export$522a862cad1b0abc() {
    return $34b7feab81bdb448$export$bb0fe4e7060febbf({
        [(0, $3fcd7ea0f1087866$export$84187ab40ae4fa9c)]: (0, $83363c78016a8c41$export$b8c2abd2a6cf7c10)(),
        [(0, $3fcd7ea0f1087866$export$f0cc9f40fa472996)]: (0, $1c5e0c7f8c3f5fd5$export$3c44663382dce232)[0, $3fcd7ea0f1087866$export$f0cc9f40fa472996],
        [(0, $3fcd7ea0f1087866$export$8f719441032e7a01)]: (0, $1c5e0c7f8c3f5fd5$export$3c44663382dce232)[0, $3fcd7ea0f1087866$export$8f719441032e7a01],
        [(0, $3fcd7ea0f1087866$export$5fe5e8dd061ec635)]: (0, $1c5e0c7f8c3f5fd5$export$3c44663382dce232)[0, $3fcd7ea0f1087866$export$5fe5e8dd061ec635]
    });
}
function $34b7feab81bdb448$var$guardedRawAttributes(attributes) {
    return attributes.map(([k, v])=>{
        if ((0, $7c4fbd050fa7f541$export$ae936b9d47e5870e)(v)) return [
            k,
            v.catch((err)=>{
                (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).debug('promise rejection for resource attribute: %s - %s', k, err);
                return undefined;
            })
        ];
        return [
            k,
            v
        ];
    });
}
function $34b7feab81bdb448$var$validateSchemaUrl(schemaUrl) {
    if (typeof schemaUrl === 'string' || schemaUrl === undefined) return schemaUrl;
    (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).warn('Schema URL must be string or undefined, got %s. Schema URL will be ignored.', schemaUrl);
    return undefined;
}
function $34b7feab81bdb448$var$mergeSchemaUrl(old, updating) {
    const oldSchemaUrl = old?.schemaUrl;
    const updatingSchemaUrl = updating?.schemaUrl;
    const isOldEmpty = oldSchemaUrl === undefined || oldSchemaUrl === '';
    const isUpdatingEmpty = updatingSchemaUrl === undefined || updatingSchemaUrl === '';
    if (isOldEmpty) return updatingSchemaUrl;
    if (isUpdatingEmpty) return oldSchemaUrl;
    if (oldSchemaUrl === updatingSchemaUrl) return oldSchemaUrl;
    (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).warn('Schema URL merge conflict: old resource has "%s", updating resource has "%s". Resulting resource will have undefined Schema URL.', oldSchemaUrl, updatingSchemaUrl);
    return undefined;
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
const $a2728a0463bf3b1f$var$SUPPRESS_TRACING_KEY = (0, $411320e1da10ff3d$export$b8c322c5a7cfce78)('OpenTelemetry SDK Context Key SUPPRESS_TRACING');
function $a2728a0463bf3b1f$export$869298f9835abc68(context) {
    return context.setValue($a2728a0463bf3b1f$var$SUPPRESS_TRACING_KEY, true);
}
function $a2728a0463bf3b1f$export$a8cb26cef1019d30(context) {
    return context.deleteValue($a2728a0463bf3b1f$var$SUPPRESS_TRACING_KEY);
}
function $a2728a0463bf3b1f$export$7d5f2376f7cf513(context) {
    return context.getValue($a2728a0463bf3b1f$var$SUPPRESS_TRACING_KEY) === true;
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
function $ce0d74c13ee0c534$export$b0663eba150d60c9(attributes) {
    const out = {};
    if (typeof attributes !== 'object' || attributes == null) return out;
    for(const key in attributes){
        if (!Object.prototype.hasOwnProperty.call(attributes, key)) continue;
        if (!$ce0d74c13ee0c534$export$d3dd8ead6a0318c3(key)) {
            (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).warn(`Invalid attribute key: ${key}`);
            continue;
        }
        const val = attributes[key];
        if (!$ce0d74c13ee0c534$export$1daad3d2aacf48c5(val)) {
            (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).warn(`Invalid attribute value set for key: ${key}`);
            continue;
        }
        if (Array.isArray(val)) out[key] = val.slice();
        else out[key] = val;
    }
    return out;
}
function $ce0d74c13ee0c534$export$d3dd8ead6a0318c3(key) {
    return typeof key === 'string' && key !== '';
}
function $ce0d74c13ee0c534$export$1daad3d2aacf48c5(val) {
    if (val == null) return true;
    if (Array.isArray(val)) return $ce0d74c13ee0c534$var$isHomogeneousAttributeValueArray(val);
    return $ce0d74c13ee0c534$var$isValidPrimitiveAttributeValueType(typeof val);
}
function $ce0d74c13ee0c534$var$isHomogeneousAttributeValueArray(arr) {
    let type;
    for (const element of arr){
        // null/undefined elements are allowed
        if (element == null) continue;
        const elementType = typeof element;
        if (elementType === type) continue;
        if (!type) {
            if ($ce0d74c13ee0c534$var$isValidPrimitiveAttributeValueType(elementType)) {
                type = elementType;
                continue;
            }
            // encountered an invalid primitive
            return false;
        }
        return false;
    }
    return true;
}
function $ce0d74c13ee0c534$var$isValidPrimitiveAttributeValueType(valType) {
    switch(valType){
        case 'number':
        case 'boolean':
        case 'string':
            return true;
    }
    return false;
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b5bb7b0fa6e48696$export$b22daef4119238cd = performance;


const $02ed3a94ae5b2eb2$var$NANOSECOND_DIGITS = 9;
const $02ed3a94ae5b2eb2$var$NANOSECOND_DIGITS_IN_MILLIS = 6;
const $02ed3a94ae5b2eb2$var$MILLISECONDS_TO_NANOSECONDS = Math.pow(10, $02ed3a94ae5b2eb2$var$NANOSECOND_DIGITS_IN_MILLIS);
const $02ed3a94ae5b2eb2$var$SECOND_TO_NANOSECONDS = Math.pow(10, $02ed3a94ae5b2eb2$var$NANOSECOND_DIGITS);
function $02ed3a94ae5b2eb2$export$e7ec5c82995537b1(epochMillis) {
    const epochSeconds = epochMillis / 1000;
    // Decimals only.
    const seconds = Math.trunc(epochSeconds);
    // Round sub-nanosecond accuracy to nanosecond.
    const nanos = Math.round(epochMillis % 1000 * $02ed3a94ae5b2eb2$var$MILLISECONDS_TO_NANOSECONDS);
    return [
        seconds,
        nanos
    ];
}
function $02ed3a94ae5b2eb2$export$e752b05e58096a2f() {
    let timeOrigin = (0, $b5bb7b0fa6e48696$export$b22daef4119238cd).timeOrigin;
    if (typeof timeOrigin !== 'number') {
        const perf = (0, $b5bb7b0fa6e48696$export$b22daef4119238cd);
        timeOrigin = perf.timing && perf.timing.fetchStart;
    }
    return timeOrigin;
}
function $02ed3a94ae5b2eb2$export$24b3f7dcd2848fa8(performanceNow) {
    const timeOrigin = $02ed3a94ae5b2eb2$export$e7ec5c82995537b1($02ed3a94ae5b2eb2$export$e752b05e58096a2f());
    const now = $02ed3a94ae5b2eb2$export$e7ec5c82995537b1(typeof performanceNow === 'number' ? performanceNow : (0, $b5bb7b0fa6e48696$export$b22daef4119238cd).now());
    return $02ed3a94ae5b2eb2$export$f07bb1dbc72184c3(timeOrigin, now);
}
function $02ed3a94ae5b2eb2$export$5f4c8a8ba0e36226(time) {
    // process.hrtime
    if ($02ed3a94ae5b2eb2$export$390c59432f173a9f(time)) return time;
    else if (typeof time === 'number') {
        // Must be a performance.now() if it's smaller than process start time.
        if (time < $02ed3a94ae5b2eb2$export$e752b05e58096a2f()) return $02ed3a94ae5b2eb2$export$24b3f7dcd2848fa8(time);
        else // epoch milliseconds or performance.timeOrigin
        return $02ed3a94ae5b2eb2$export$e7ec5c82995537b1(time);
    } else if (time instanceof Date) return $02ed3a94ae5b2eb2$export$e7ec5c82995537b1(time.getTime());
    else throw TypeError('Invalid input type');
}
function $02ed3a94ae5b2eb2$export$b783ad6617389e3e(startTime, endTime) {
    let seconds = endTime[0] - startTime[0];
    let nanos = endTime[1] - startTime[1];
    // overflow
    if (nanos < 0) {
        seconds -= 1;
        // negate
        nanos += $02ed3a94ae5b2eb2$var$SECOND_TO_NANOSECONDS;
    }
    return [
        seconds,
        nanos
    ];
}
function $02ed3a94ae5b2eb2$export$973c1c4fad6103e(time) {
    const precision = $02ed3a94ae5b2eb2$var$NANOSECOND_DIGITS;
    const tmp = `${'0'.repeat(precision)}${time[1]}Z`;
    const nanoString = tmp.substring(tmp.length - precision - 1);
    const date = new Date(time[0] * 1000).toISOString();
    return date.replace('000Z', nanoString);
}
function $02ed3a94ae5b2eb2$export$2d91441ae30ebcfc(time) {
    return time[0] * $02ed3a94ae5b2eb2$var$SECOND_TO_NANOSECONDS + time[1];
}
function $02ed3a94ae5b2eb2$export$30b3706e4e35edf0(time) {
    return time[0] * 1e3 + time[1] / 1e6;
}
function $02ed3a94ae5b2eb2$export$95601fd64fa689b7(time) {
    return time[0] * 1e6 + time[1] / 1e3;
}
function $02ed3a94ae5b2eb2$export$390c59432f173a9f(value) {
    return Array.isArray(value) && value.length === 2 && typeof value[0] === 'number' && typeof value[1] === 'number';
}
function $02ed3a94ae5b2eb2$export$a5e58227c317ebb9(value) {
    return $02ed3a94ae5b2eb2$export$390c59432f173a9f(value) || typeof value === 'number' || value instanceof Date;
}
function $02ed3a94ae5b2eb2$export$f07bb1dbc72184c3(time1, time2) {
    const out = [
        time1[0] + time2[0],
        time1[1] + time2[1]
    ];
    // Nanoseconds
    if (out[1] >= $02ed3a94ae5b2eb2$var$SECOND_TO_NANOSECONDS) {
        out[1] -= $02ed3a94ae5b2eb2$var$SECOND_TO_NANOSECONDS;
        out[0] += 1;
    }
    return out;
}



/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Event name definitions
const $c2e0162c8d3ecc5b$export$a0fff09a5370d06f = 'exception';


class $dd2bc1ab4de8b1df$export$7b15d0c2dba75760 {
    // Below properties are included to implement ReadableSpan for export
    // purposes but are not intended to be written-to directly.
    _spanContext;
    kind;
    parentSpanContext;
    attributes = {};
    links = [];
    events = [];
    startTime;
    resource;
    instrumentationScope;
    _droppedAttributesCount = 0;
    _droppedEventsCount = 0;
    _droppedLinksCount = 0;
    name;
    status = {
        code: (0, $ed982b21ea27c702$export$1e28dd9b5d01db83).UNSET
    };
    endTime = [
        0,
        0
    ];
    _ended = false;
    _duration = [
        -1,
        -1
    ];
    _spanProcessor;
    _spanLimits;
    _attributeValueLengthLimit;
    _performanceStartTime;
    _performanceOffset;
    _startTimeProvided;
    /**
     * Constructs a new SpanImpl instance.
     */ constructor(opts){
        const now = Date.now();
        this._spanContext = opts.spanContext;
        this._performanceStartTime = (0, $b5bb7b0fa6e48696$export$b22daef4119238cd).now();
        this._performanceOffset = now - (this._performanceStartTime + (0, $02ed3a94ae5b2eb2$export$e752b05e58096a2f)());
        this._startTimeProvided = opts.startTime != null;
        this._spanLimits = opts.spanLimits;
        this._attributeValueLengthLimit = this._spanLimits.attributeValueLengthLimit || 0;
        this._spanProcessor = opts.spanProcessor;
        this.name = opts.name;
        this.parentSpanContext = opts.parentSpanContext;
        this.kind = opts.kind;
        this.links = opts.links || [];
        this.startTime = this._getTime(opts.startTime ?? now);
        this.resource = opts.resource;
        this.instrumentationScope = opts.scope;
        if (opts.attributes != null) this.setAttributes(opts.attributes);
        this._spanProcessor.onStart(this, opts.context);
    }
    spanContext() {
        return this._spanContext;
    }
    setAttribute(key, value) {
        if (value == null || this._isSpanEnded()) return this;
        if (key.length === 0) {
            (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).warn(`Invalid attribute key: ${key}`);
            return this;
        }
        if (!(0, $ce0d74c13ee0c534$export$1daad3d2aacf48c5)(value)) {
            (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).warn(`Invalid attribute value set for key: ${key}`);
            return this;
        }
        const { attributeCountLimit: attributeCountLimit } = this._spanLimits;
        if (attributeCountLimit !== undefined && Object.keys(this.attributes).length >= attributeCountLimit && !Object.prototype.hasOwnProperty.call(this.attributes, key)) {
            this._droppedAttributesCount++;
            return this;
        }
        this.attributes[key] = this._truncateToSize(value);
        return this;
    }
    setAttributes(attributes) {
        for (const [k, v] of Object.entries(attributes))this.setAttribute(k, v);
        return this;
    }
    /**
     *
     * @param name Span Name
     * @param [attributesOrStartTime] Span attributes or start time
     *     if type is {@type TimeInput} and 3rd param is undefined
     * @param [timeStamp] Specified time stamp for the event
     */ addEvent(name, attributesOrStartTime, timeStamp) {
        if (this._isSpanEnded()) return this;
        const { eventCountLimit: eventCountLimit } = this._spanLimits;
        if (eventCountLimit === 0) {
            (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).warn('No events allowed.');
            this._droppedEventsCount++;
            return this;
        }
        if (eventCountLimit !== undefined && this.events.length >= eventCountLimit) {
            if (this._droppedEventsCount === 0) (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).debug('Dropping extra events.');
            this.events.shift();
            this._droppedEventsCount++;
        }
        if ((0, $02ed3a94ae5b2eb2$export$a5e58227c317ebb9)(attributesOrStartTime)) {
            if (!(0, $02ed3a94ae5b2eb2$export$a5e58227c317ebb9)(timeStamp)) timeStamp = attributesOrStartTime;
            attributesOrStartTime = undefined;
        }
        const attributes = (0, $ce0d74c13ee0c534$export$b0663eba150d60c9)(attributesOrStartTime);
        this.events.push({
            name: name,
            attributes: attributes,
            time: this._getTime(timeStamp),
            droppedAttributesCount: 0
        });
        return this;
    }
    addLink(link) {
        this.links.push(link);
        return this;
    }
    addLinks(links) {
        this.links.push(...links);
        return this;
    }
    setStatus(status) {
        if (this._isSpanEnded()) return this;
        this.status = {
            ...status
        };
        // When using try-catch, the caught "error" is of type `any`. When then assigning `any` to `status.message`,
        // TypeScript will not error. While this can happen during use of any API, it is more common on Span#setStatus()
        // as it's likely used in a catch-block. Therefore, we validate if `status.message` is actually a string, null, or
        // undefined to avoid an incorrect type causing issues downstream.
        if (this.status.message != null && typeof status.message !== 'string') {
            (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).warn(`Dropping invalid status.message of type '${typeof status.message}', expected 'string'`);
            delete this.status.message;
        }
        return this;
    }
    updateName(name) {
        if (this._isSpanEnded()) return this;
        this.name = name;
        return this;
    }
    end(endTime) {
        if (this._isSpanEnded()) {
            (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).error(`${this.name} ${this._spanContext.traceId}-${this._spanContext.spanId} - You can only call end() on a span once.`);
            return;
        }
        this._ended = true;
        this.endTime = this._getTime(endTime);
        this._duration = (0, $02ed3a94ae5b2eb2$export$b783ad6617389e3e)(this.startTime, this.endTime);
        if (this._duration[0] < 0) {
            (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).warn('Inconsistent start and end time, startTime > endTime. Setting span duration to 0ms.', this.startTime, this.endTime);
            this.endTime = this.startTime.slice();
            this._duration = [
                0,
                0
            ];
        }
        if (this._droppedEventsCount > 0) (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).warn(`Dropped ${this._droppedEventsCount} events because eventCountLimit reached`);
        this._spanProcessor.onEnd(this);
    }
    _getTime(inp) {
        if (typeof inp === 'number' && inp <= (0, $b5bb7b0fa6e48696$export$b22daef4119238cd).now()) // must be a performance timestamp
        // apply correction and convert to hrtime
        return (0, $02ed3a94ae5b2eb2$export$24b3f7dcd2848fa8)(inp + this._performanceOffset);
        if (typeof inp === 'number') return (0, $02ed3a94ae5b2eb2$export$e7ec5c82995537b1)(inp);
        if (inp instanceof Date) return (0, $02ed3a94ae5b2eb2$export$e7ec5c82995537b1)(inp.getTime());
        if ((0, $02ed3a94ae5b2eb2$export$390c59432f173a9f)(inp)) return inp;
        if (this._startTimeProvided) // if user provided a time for the start manually
        // we can't use duration to calculate event/end times
        return (0, $02ed3a94ae5b2eb2$export$e7ec5c82995537b1)(Date.now());
        const msDuration = (0, $b5bb7b0fa6e48696$export$b22daef4119238cd).now() - this._performanceStartTime;
        return (0, $02ed3a94ae5b2eb2$export$f07bb1dbc72184c3)(this.startTime, (0, $02ed3a94ae5b2eb2$export$e7ec5c82995537b1)(msDuration));
    }
    isRecording() {
        return this._ended === false;
    }
    recordException(exception, time) {
        const attributes = {};
        if (typeof exception === 'string') attributes[0, $3fcd7ea0f1087866$export$ab4513c1b55519b5] = exception;
        else if (exception) {
            if (exception.code) attributes[0, $3fcd7ea0f1087866$export$85da07cb5d867763] = exception.code.toString();
            else if (exception.name) attributes[0, $3fcd7ea0f1087866$export$85da07cb5d867763] = exception.name;
            if (exception.message) attributes[0, $3fcd7ea0f1087866$export$ab4513c1b55519b5] = exception.message;
            if (exception.stack) attributes[0, $3fcd7ea0f1087866$export$9b74e4928364b671] = exception.stack;
        }
        // these are minimum requirements from spec
        if (attributes[0, $3fcd7ea0f1087866$export$85da07cb5d867763] || attributes[0, $3fcd7ea0f1087866$export$ab4513c1b55519b5]) this.addEvent((0, $c2e0162c8d3ecc5b$export$a0fff09a5370d06f), attributes, time);
        else (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).warn(`Failed to record an exception ${exception}`);
    }
    get duration() {
        return this._duration;
    }
    get ended() {
        return this._ended;
    }
    get droppedAttributesCount() {
        return this._droppedAttributesCount;
    }
    get droppedEventsCount() {
        return this._droppedEventsCount;
    }
    get droppedLinksCount() {
        return this._droppedLinksCount;
    }
    _isSpanEnded() {
        if (this._ended) {
            const error = new Error(`Operation attempted on ended Span {traceId: ${this._spanContext.traceId}, spanId: ${this._spanContext.spanId}}`);
            (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).warn(`Cannot execute the operation on ended Span {traceId: ${this._spanContext.traceId}, spanId: ${this._spanContext.spanId}}`, error);
        }
        return this._ended;
    }
    // Utility function to truncate given value within size
    // for value type of string, will truncate to given limit
    // for type of non-string, will return same value
    _truncateToLimitUtil(value, limit) {
        if (value.length <= limit) return value;
        return value.substring(0, limit);
    }
    /**
     * If the given attribute value is of type string and has more characters than given {@code attributeValueLengthLimit} then
     * return string with truncated to {@code attributeValueLengthLimit} characters
     *
     * If the given attribute value is array of strings then
     * return new array of strings with each element truncated to {@code attributeValueLengthLimit} characters
     *
     * Otherwise return same Attribute {@code value}
     *
     * @param value Attribute value
     * @returns truncated attribute value if required, otherwise same value
     */ _truncateToSize(value) {
        const limit = this._attributeValueLengthLimit;
        // Check limit
        if (limit <= 0) {
            // Negative values are invalid, so do not truncate
            (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).warn(`Attribute value limit must be positive, got ${limit}`);
            return value;
        }
        // String
        if (typeof value === 'string') return this._truncateToLimitUtil(value, limit);
        // Array of strings
        if (Array.isArray(value)) return value.map((val)=>typeof val === 'string' ? this._truncateToLimitUtil(val, limit) : val);
        // Other types, no need to apply value length limit
        return value;
    }
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $2904c97a66abe41f$export$c1cd528968868329(_) {
    return undefined;
}
function $2904c97a66abe41f$export$9d8f36a7ac8db58c(_) {
    return undefined;
}
function $2904c97a66abe41f$export$9d6c13e44580559c(_) {
    return undefined;
}
function $2904c97a66abe41f$export$a18720db12f89f06(_) {
    return undefined;
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A sampling decision that determines how a {@link Span} will be recorded
 * and collected.
 */ var $25c79665d2cd8aeb$export$94df7a7a96a92f7b;
(function(SamplingDecision) {
    /**
     * `Span.isRecording() === false`, span will not be recorded and all events
     * and attributes will be dropped.
     */ SamplingDecision[SamplingDecision["NOT_RECORD"] = 0] = "NOT_RECORD";
    /**
     * `Span.isRecording() === true`, but `Sampled` flag in {@link TraceFlags}
     * MUST NOT be set.
     */ SamplingDecision[SamplingDecision["RECORD"] = 1] = "RECORD";
    /**
     * `Span.isRecording() === true` AND `Sampled` flag in {@link TraceFlags}
     * MUST be set.
     */ SamplingDecision[SamplingDecision["RECORD_AND_SAMPLED"] = 2] = "RECORD_AND_SAMPLED";
})($25c79665d2cd8aeb$export$94df7a7a96a92f7b || ($25c79665d2cd8aeb$export$94df7a7a96a92f7b = {}));


class $60169ab10f3cead0$export$abc5f11618c4d6a3 {
    shouldSample() {
        return {
            decision: (0, $25c79665d2cd8aeb$export$94df7a7a96a92f7b).NOT_RECORD
        };
    }
    toString() {
        return 'AlwaysOffSampler';
    }
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
class $68a767112c26cd40$export$653f832afb4ffa27 {
    shouldSample() {
        return {
            decision: (0, $25c79665d2cd8aeb$export$94df7a7a96a92f7b).RECORD_AND_SAMPLED
        };
    }
    toString() {
        return 'AlwaysOnSampler';
    }
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
function $cb0221cc65996bf5$export$cd67a16f6d11e5bd() {
    return (ex)=>{
        (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).error($cb0221cc65996bf5$var$stringifyException(ex));
    };
}
/**
 * Converts an exception into a string representation
 * @param {Exception} ex
 */ function $cb0221cc65996bf5$var$stringifyException(ex) {
    if (typeof ex === 'string') return ex;
    else return JSON.stringify($cb0221cc65996bf5$var$flattenException(ex));
}
/**
 * Flattens an exception into key-value pairs by traversing the prototype chain
 * and coercing values to strings. Duplicate properties will not be overwritten;
 * the first insert wins.
 */ function $cb0221cc65996bf5$var$flattenException(ex) {
    const result = {};
    let current = ex;
    while(current !== null){
        Object.getOwnPropertyNames(current).forEach((propertyName)=>{
            if (result[propertyName]) return;
            const value = current[propertyName];
            if (value) result[propertyName] = String(value);
        });
        current = Object.getPrototypeOf(current);
    }
    return result;
}


/** The global error handler delegate */ let $c70d952740b6ceea$var$delegateHandler = (0, $cb0221cc65996bf5$export$cd67a16f6d11e5bd)();
function $c70d952740b6ceea$export$bdff946829732435(handler) {
    $c70d952740b6ceea$var$delegateHandler = handler;
}
function $c70d952740b6ceea$export$54c6946fc34b7cc2(ex) {
    try {
        $c70d952740b6ceea$var$delegateHandler(ex);
    } catch  {} // eslint-disable-line no-empty
}




class $b054fb6a94c417b0$export$2bc0b1b09c2e3b47 {
    _root;
    _remoteParentSampled;
    _remoteParentNotSampled;
    _localParentSampled;
    _localParentNotSampled;
    constructor(config){
        this._root = config.root;
        if (!this._root) {
            (0, $c70d952740b6ceea$export$54c6946fc34b7cc2)(new Error('ParentBasedSampler must have a root sampler configured'));
            this._root = new (0, $68a767112c26cd40$export$653f832afb4ffa27)();
        }
        this._remoteParentSampled = config.remoteParentSampled ?? new (0, $68a767112c26cd40$export$653f832afb4ffa27)();
        this._remoteParentNotSampled = config.remoteParentNotSampled ?? new (0, $60169ab10f3cead0$export$abc5f11618c4d6a3)();
        this._localParentSampled = config.localParentSampled ?? new (0, $68a767112c26cd40$export$653f832afb4ffa27)();
        this._localParentNotSampled = config.localParentNotSampled ?? new (0, $60169ab10f3cead0$export$abc5f11618c4d6a3)();
    }
    shouldSample(context, traceId, spanName, spanKind, attributes, links) {
        const parentContext = (0, $496851d2cf78caa4$export$357889f174732d38).getSpanContext(context);
        if (!parentContext || !(0, $99a3da0b8477e363$export$e4373b9a2c09216c)(parentContext)) return this._root.shouldSample(context, traceId, spanName, spanKind, attributes, links);
        if (parentContext.isRemote) {
            if (parentContext.traceFlags & (0, $5dcc187a863bca89$export$bf9049ad2b0883ff).SAMPLED) return this._remoteParentSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
            return this._remoteParentNotSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
        }
        if (parentContext.traceFlags & (0, $5dcc187a863bca89$export$bf9049ad2b0883ff).SAMPLED) return this._localParentSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
        return this._localParentNotSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
    }
    toString() {
        return `ParentBased{root=${this._root.toString()}, remoteParentSampled=${this._remoteParentSampled.toString()}, remoteParentNotSampled=${this._remoteParentNotSampled.toString()}, localParentSampled=${this._localParentSampled.toString()}, localParentNotSampled=${this._localParentNotSampled.toString()}}`;
    }
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

class $faaa926fe3c38efa$export$f1624f887f708bbf {
    _ratio;
    _upperBound;
    constructor(_ratio = 0){
        this._ratio = _ratio;
        this._ratio = this._normalize(_ratio);
        this._upperBound = Math.floor(this._ratio * 0xffffffff);
    }
    shouldSample(context, traceId) {
        return {
            decision: (0, $99a3da0b8477e363$export$29dd34cf1269f6da)(traceId) && this._accumulate(traceId) < this._upperBound ? (0, $25c79665d2cd8aeb$export$94df7a7a96a92f7b).RECORD_AND_SAMPLED : (0, $25c79665d2cd8aeb$export$94df7a7a96a92f7b).NOT_RECORD
        };
    }
    toString() {
        return `TraceIdRatioBased{${this._ratio}}`;
    }
    _normalize(ratio) {
        if (typeof ratio !== 'number' || isNaN(ratio)) return 0;
        return ratio >= 1 ? 1 : ratio <= 0 ? 0 : ratio;
    }
    _accumulate(traceId) {
        let accumulation = 0;
        for(let i = 0; i < traceId.length / 8; i++){
            const pos = i * 8;
            const part = parseInt(traceId.slice(pos, pos + 8), 16);
            accumulation = (accumulation ^ part) >>> 0;
        }
        return accumulation;
    }
}


var $591d7c39ce34927b$var$TracesSamplerValues;
(function(TracesSamplerValues) {
    TracesSamplerValues["AlwaysOff"] = "always_off";
    TracesSamplerValues["AlwaysOn"] = "always_on";
    TracesSamplerValues["ParentBasedAlwaysOff"] = "parentbased_always_off";
    TracesSamplerValues["ParentBasedAlwaysOn"] = "parentbased_always_on";
    TracesSamplerValues["ParentBasedTraceIdRatio"] = "parentbased_traceidratio";
    TracesSamplerValues["TraceIdRatio"] = "traceidratio";
})($591d7c39ce34927b$var$TracesSamplerValues || ($591d7c39ce34927b$var$TracesSamplerValues = {}));
const $591d7c39ce34927b$var$DEFAULT_RATIO = 1;
function $591d7c39ce34927b$export$d25a2c2f78a5e968() {
    return {
        sampler: $591d7c39ce34927b$export$534308d7e73f0e71(),
        forceFlushTimeoutMillis: 30000,
        generalLimits: {
            attributeValueLengthLimit: (0, $2904c97a66abe41f$export$9d6c13e44580559c)('OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT') ?? Infinity,
            attributeCountLimit: (0, $2904c97a66abe41f$export$9d6c13e44580559c)('OTEL_ATTRIBUTE_COUNT_LIMIT') ?? 128
        },
        spanLimits: {
            attributeValueLengthLimit: (0, $2904c97a66abe41f$export$9d6c13e44580559c)('OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT') ?? Infinity,
            attributeCountLimit: (0, $2904c97a66abe41f$export$9d6c13e44580559c)('OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT') ?? 128,
            linkCountLimit: (0, $2904c97a66abe41f$export$9d6c13e44580559c)('OTEL_SPAN_LINK_COUNT_LIMIT') ?? 128,
            eventCountLimit: (0, $2904c97a66abe41f$export$9d6c13e44580559c)('OTEL_SPAN_EVENT_COUNT_LIMIT') ?? 128,
            attributePerEventCountLimit: (0, $2904c97a66abe41f$export$9d6c13e44580559c)('OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT') ?? 128,
            attributePerLinkCountLimit: (0, $2904c97a66abe41f$export$9d6c13e44580559c)('OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT') ?? 128
        }
    };
}
function $591d7c39ce34927b$export$534308d7e73f0e71() {
    const sampler = (0, $2904c97a66abe41f$export$c1cd528968868329)('OTEL_TRACES_SAMPLER') ?? $591d7c39ce34927b$var$TracesSamplerValues.ParentBasedAlwaysOn;
    switch(sampler){
        case $591d7c39ce34927b$var$TracesSamplerValues.AlwaysOn:
            return new (0, $68a767112c26cd40$export$653f832afb4ffa27)();
        case $591d7c39ce34927b$var$TracesSamplerValues.AlwaysOff:
            return new (0, $60169ab10f3cead0$export$abc5f11618c4d6a3)();
        case $591d7c39ce34927b$var$TracesSamplerValues.ParentBasedAlwaysOn:
            return new (0, $b054fb6a94c417b0$export$2bc0b1b09c2e3b47)({
                root: new (0, $68a767112c26cd40$export$653f832afb4ffa27)()
            });
        case $591d7c39ce34927b$var$TracesSamplerValues.ParentBasedAlwaysOff:
            return new (0, $b054fb6a94c417b0$export$2bc0b1b09c2e3b47)({
                root: new (0, $60169ab10f3cead0$export$abc5f11618c4d6a3)()
            });
        case $591d7c39ce34927b$var$TracesSamplerValues.TraceIdRatio:
            return new (0, $faaa926fe3c38efa$export$f1624f887f708bbf)($591d7c39ce34927b$var$getSamplerProbabilityFromEnv());
        case $591d7c39ce34927b$var$TracesSamplerValues.ParentBasedTraceIdRatio:
            return new (0, $b054fb6a94c417b0$export$2bc0b1b09c2e3b47)({
                root: new (0, $faaa926fe3c38efa$export$f1624f887f708bbf)($591d7c39ce34927b$var$getSamplerProbabilityFromEnv())
            });
        default:
            (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).error(`OTEL_TRACES_SAMPLER value "${sampler}" invalid, defaulting to "${$591d7c39ce34927b$var$TracesSamplerValues.ParentBasedAlwaysOn}".`);
            return new (0, $b054fb6a94c417b0$export$2bc0b1b09c2e3b47)({
                root: new (0, $68a767112c26cd40$export$653f832afb4ffa27)()
            });
    }
}
function $591d7c39ce34927b$var$getSamplerProbabilityFromEnv() {
    const probability = (0, $2904c97a66abe41f$export$9d6c13e44580559c)('OTEL_TRACES_SAMPLER_ARG');
    if (probability == null) {
        (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).error(`OTEL_TRACES_SAMPLER_ARG is blank, defaulting to ${$591d7c39ce34927b$var$DEFAULT_RATIO}.`);
        return $591d7c39ce34927b$var$DEFAULT_RATIO;
    }
    if (probability < 0 || probability > 1) {
        (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).error(`OTEL_TRACES_SAMPLER_ARG=${probability} was given, but it is out of range ([0..1]), defaulting to ${$591d7c39ce34927b$var$DEFAULT_RATIO}.`);
        return $591d7c39ce34927b$var$DEFAULT_RATIO;
    }
    return probability;
}



const $42239b7258725033$export$6ad612be99f9ed48 = 128;
const $42239b7258725033$export$d9446f3c1c12def1 = Infinity;
function $42239b7258725033$export$7ec1ebcfa9d8bd6a(userConfig) {
    const perInstanceDefaults = {
        sampler: (0, $591d7c39ce34927b$export$534308d7e73f0e71)()
    };
    const DEFAULT_CONFIG = (0, $591d7c39ce34927b$export$d25a2c2f78a5e968)();
    const target = Object.assign({}, DEFAULT_CONFIG, perInstanceDefaults, userConfig);
    target.generalLimits = Object.assign({}, DEFAULT_CONFIG.generalLimits, userConfig.generalLimits || {});
    target.spanLimits = Object.assign({}, DEFAULT_CONFIG.spanLimits, userConfig.spanLimits || {});
    return target;
}
function $42239b7258725033$export$9f9fb435f8494555(userConfig) {
    const spanLimits = Object.assign({}, userConfig.spanLimits);
    /**
     * Reassign span attribute count limit to use first non null value defined by user or use default value
     */ spanLimits.attributeCountLimit = userConfig.spanLimits?.attributeCountLimit ?? userConfig.generalLimits?.attributeCountLimit ?? (0, $2904c97a66abe41f$export$9d6c13e44580559c)('OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT') ?? (0, $2904c97a66abe41f$export$9d6c13e44580559c)('OTEL_ATTRIBUTE_COUNT_LIMIT') ?? $42239b7258725033$export$6ad612be99f9ed48;
    /**
     * Reassign span attribute value length limit to use first non null value defined by user or use default value
     */ spanLimits.attributeValueLengthLimit = userConfig.spanLimits?.attributeValueLengthLimit ?? userConfig.generalLimits?.attributeValueLengthLimit ?? (0, $2904c97a66abe41f$export$9d6c13e44580559c)('OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT') ?? (0, $2904c97a66abe41f$export$9d6c13e44580559c)('OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT') ?? $42239b7258725033$export$d9446f3c1c12def1;
    return Object.assign({}, userConfig, {
        spanLimits: spanLimits
    });
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c9cac266b6afb7c8$var$SPAN_ID_BYTES = 8;
const $c9cac266b6afb7c8$var$TRACE_ID_BYTES = 16;
class $c9cac266b6afb7c8$export$97307207ef48da75 {
    /**
     * Returns a random 16-byte trace ID formatted/encoded as a 32 lowercase hex
     * characters corresponding to 128 bits.
     */ generateTraceId = $c9cac266b6afb7c8$var$getIdGenerator($c9cac266b6afb7c8$var$TRACE_ID_BYTES);
    /**
     * Returns a random 8-byte span ID formatted/encoded as a 16 lowercase hex
     * characters corresponding to 64 bits.
     */ generateSpanId = $c9cac266b6afb7c8$var$getIdGenerator($c9cac266b6afb7c8$var$SPAN_ID_BYTES);
}
const $c9cac266b6afb7c8$var$SHARED_CHAR_CODES_ARRAY = Array(32);
function $c9cac266b6afb7c8$var$getIdGenerator(bytes) {
    return function generateId() {
        for(let i = 0; i < bytes * 2; i++){
            $c9cac266b6afb7c8$var$SHARED_CHAR_CODES_ARRAY[i] = Math.floor(Math.random() * 16) + 48;
            // valid hex characters in the range 48-57 and 97-102
            if ($c9cac266b6afb7c8$var$SHARED_CHAR_CODES_ARRAY[i] >= 58) $c9cac266b6afb7c8$var$SHARED_CHAR_CODES_ARRAY[i] += 39;
        }
        return String.fromCharCode.apply(null, $c9cac266b6afb7c8$var$SHARED_CHAR_CODES_ARRAY.slice(0, bytes * 2));
    };
}


class $69210e1664695281$export$c4b9363e2fc65361 {
    _sampler;
    _generalLimits;
    _spanLimits;
    _idGenerator;
    instrumentationScope;
    _resource;
    _spanProcessor;
    /**
     * Constructs a new Tracer instance.
     */ constructor(instrumentationScope, config, resource, spanProcessor){
        const localConfig = (0, $42239b7258725033$export$7ec1ebcfa9d8bd6a)(config);
        this._sampler = localConfig.sampler;
        this._generalLimits = localConfig.generalLimits;
        this._spanLimits = localConfig.spanLimits;
        this._idGenerator = config.idGenerator || new (0, $c9cac266b6afb7c8$export$97307207ef48da75)();
        this._resource = resource;
        this._spanProcessor = spanProcessor;
        this.instrumentationScope = instrumentationScope;
    }
    /**
     * Starts a new Span or returns the default NoopSpan based on the sampling
     * decision.
     */ startSpan(name, options = {}, context = $0c57d9262090934c$export$a078c61943f9dbbe.active()) {
        // remove span from context in case a root span is requested via options
        if (options.root) context = $496851d2cf78caa4$export$357889f174732d38.deleteSpan(context);
        const parentSpan = $496851d2cf78caa4$export$357889f174732d38.getSpan(context);
        if ((0, $a2728a0463bf3b1f$export$7d5f2376f7cf513)(context)) {
            $0006a4b399ea8ee4$export$c042e7c2f59bc046.debug('Instrumentation suppressed, returning Noop Span');
            const nonRecordingSpan = $496851d2cf78caa4$export$357889f174732d38.wrapSpanContext($c0773e3017d46dd4$export$8591e4c852b66703);
            return nonRecordingSpan;
        }
        const parentSpanContext = parentSpan?.spanContext();
        const spanId = this._idGenerator.generateSpanId();
        let validParentSpanContext;
        let traceId;
        let traceState;
        if (!parentSpanContext || !$496851d2cf78caa4$export$357889f174732d38.isSpanContextValid(parentSpanContext)) // New root span.
        traceId = this._idGenerator.generateTraceId();
        else {
            // New child span.
            traceId = parentSpanContext.traceId;
            traceState = parentSpanContext.traceState;
            validParentSpanContext = parentSpanContext;
        }
        const spanKind = options.kind ?? $566044c3d0fbdc36$export$4da4ea8145910e8b.INTERNAL;
        const links = (options.links ?? []).map((link)=>{
            return {
                context: link.context,
                attributes: (0, $ce0d74c13ee0c534$export$b0663eba150d60c9)(link.attributes)
            };
        });
        const attributes = (0, $ce0d74c13ee0c534$export$b0663eba150d60c9)(options.attributes);
        // make sampling decision
        const samplingResult = this._sampler.shouldSample(context, traceId, name, spanKind, attributes, links);
        traceState = samplingResult.traceState ?? traceState;
        const traceFlags = samplingResult.decision === $0cc84bf49b6d9783$export$94df7a7a96a92f7b.RECORD_AND_SAMPLED ? $5dcc187a863bca89$export$bf9049ad2b0883ff.SAMPLED : $5dcc187a863bca89$export$bf9049ad2b0883ff.NONE;
        const spanContext = {
            traceId: traceId,
            spanId: spanId,
            traceFlags: traceFlags,
            traceState: traceState
        };
        if (samplingResult.decision === $0cc84bf49b6d9783$export$94df7a7a96a92f7b.NOT_RECORD) {
            $0006a4b399ea8ee4$export$c042e7c2f59bc046.debug('Recording is off, propagating context in a non-recording span');
            const nonRecordingSpan = $496851d2cf78caa4$export$357889f174732d38.wrapSpanContext(spanContext);
            return nonRecordingSpan;
        }
        // Set initial span attributes. The attributes object may have been mutated
        // by the sampler, so we sanitize the merged attributes before setting them.
        const initAttributes = (0, $ce0d74c13ee0c534$export$b0663eba150d60c9)(Object.assign(attributes, samplingResult.attributes));
        const span = new (0, $dd2bc1ab4de8b1df$export$7b15d0c2dba75760)({
            resource: this._resource,
            scope: this.instrumentationScope,
            context: context,
            spanContext: spanContext,
            name: name,
            kind: spanKind,
            links: links,
            parentSpanContext: validParentSpanContext,
            attributes: initAttributes,
            startTime: options.startTime,
            spanProcessor: this._spanProcessor,
            spanLimits: this._spanLimits
        });
        return span;
    }
    startActiveSpan(name, arg2, arg3, arg4) {
        let opts;
        let ctx;
        let fn;
        if (arguments.length < 2) return;
        else if (arguments.length === 2) fn = arg2;
        else if (arguments.length === 3) {
            opts = arg2;
            fn = arg3;
        } else {
            opts = arg2;
            ctx = arg3;
            fn = arg4;
        }
        const parentContext = ctx ?? $0c57d9262090934c$export$a078c61943f9dbbe.active();
        const span = this.startSpan(name, opts, parentContext);
        const contextWithSpanSet = $496851d2cf78caa4$export$357889f174732d38.setSpan(parentContext, span);
        return $0c57d9262090934c$export$a078c61943f9dbbe.with(contextWithSpanSet, fn, undefined, span);
    }
    /** Returns the active {@link GeneralLimits}. */ getGeneralLimits() {
        return this._generalLimits;
    }
    /** Returns the active {@link SpanLimits}. */ getSpanLimits() {
        return this._spanLimits;
    }
}



/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
class $532398cbdb6e6938$export$3012fe5a49154394 {
    _spanProcessors;
    constructor(_spanProcessors){
        this._spanProcessors = _spanProcessors;
    }
    forceFlush() {
        const promises = [];
        for (const spanProcessor of this._spanProcessors)promises.push(spanProcessor.forceFlush());
        return new Promise((resolve)=>{
            Promise.all(promises).then(()=>{
                resolve();
            }).catch((error)=>{
                (0, $c70d952740b6ceea$export$54c6946fc34b7cc2)(error || new Error('MultiSpanProcessor: forceFlush failed'));
                resolve();
            });
        });
    }
    onStart(span, context) {
        for (const spanProcessor of this._spanProcessors)spanProcessor.onStart(span, context);
    }
    onEnd(span) {
        for (const spanProcessor of this._spanProcessors)spanProcessor.onEnd(span);
    }
    shutdown() {
        const promises = [];
        for (const spanProcessor of this._spanProcessors)promises.push(spanProcessor.shutdown());
        return new Promise((resolve, reject)=>{
            Promise.all(promises).then(()=>{
                resolve();
            }, reject);
        });
    }
}



var $09b0f540efe38fab$export$11a85395fcf5a7f0;
(function(ForceFlushState) {
    ForceFlushState[ForceFlushState["resolved"] = 0] = "resolved";
    ForceFlushState[ForceFlushState["timeout"] = 1] = "timeout";
    ForceFlushState[ForceFlushState["error"] = 2] = "error";
    ForceFlushState[ForceFlushState["unresolved"] = 3] = "unresolved";
})($09b0f540efe38fab$export$11a85395fcf5a7f0 || ($09b0f540efe38fab$export$11a85395fcf5a7f0 = {}));
class $09b0f540efe38fab$export$1f2f0f67f5ecff3b {
    _config;
    _tracers = new Map();
    _resource;
    _activeSpanProcessor;
    constructor(config = {}){
        const mergedConfig = (0, $a99eaf6108fc00d6$export$4950aa0f605343fb)({}, (0, $591d7c39ce34927b$export$d25a2c2f78a5e968)(), (0, $42239b7258725033$export$9f9fb435f8494555)(config));
        this._resource = mergedConfig.resource ?? (0, $34b7feab81bdb448$export$522a862cad1b0abc)();
        this._config = Object.assign({}, mergedConfig, {
            resource: this._resource
        });
        const spanProcessors = [];
        if (config.spanProcessors?.length) spanProcessors.push(...config.spanProcessors);
        this._activeSpanProcessor = new (0, $532398cbdb6e6938$export$3012fe5a49154394)(spanProcessors);
    }
    getTracer(name, version, options) {
        const key = `${name}@${version || ''}:${options?.schemaUrl || ''}`;
        if (!this._tracers.has(key)) this._tracers.set(key, new (0, $69210e1664695281$export$c4b9363e2fc65361)({
            name: name,
            version: version,
            schemaUrl: options?.schemaUrl
        }, this._config, this._resource, this._activeSpanProcessor));
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return this._tracers.get(key);
    }
    forceFlush() {
        const timeout = this._config.forceFlushTimeoutMillis;
        const promises = this._activeSpanProcessor['_spanProcessors'].map((spanProcessor)=>{
            return new Promise((resolve)=>{
                let state;
                const timeoutInterval = setTimeout(()=>{
                    resolve(new Error(`Span processor did not completed within timeout period of ${timeout} ms`));
                    state = $09b0f540efe38fab$export$11a85395fcf5a7f0.timeout;
                }, timeout);
                spanProcessor.forceFlush().then(()=>{
                    clearTimeout(timeoutInterval);
                    if (state !== $09b0f540efe38fab$export$11a85395fcf5a7f0.timeout) {
                        state = $09b0f540efe38fab$export$11a85395fcf5a7f0.resolved;
                        resolve(state);
                    }
                }).catch((error)=>{
                    clearTimeout(timeoutInterval);
                    state = $09b0f540efe38fab$export$11a85395fcf5a7f0.error;
                    resolve(error);
                });
            });
        });
        return new Promise((resolve, reject)=>{
            Promise.all(promises).then((results)=>{
                const errors = results.filter((result)=>result !== $09b0f540efe38fab$export$11a85395fcf5a7f0.resolved);
                if (errors.length > 0) reject(errors);
                else resolve();
            }).catch((error)=>reject([
                    error
                ]));
        });
    }
    shutdown() {
        return this._activeSpanProcessor.shutdown();
    }
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
class $a8d66854eb53d217$export$3dfe62dd209faf13 {
    /**
     * whether the context manager is enabled or not
     */ _enabled = false;
    /**
     * Keeps the reference to current context
     */ _currentContext = (0, $411320e1da10ff3d$export$78df28f9b2f9a7dc);
    /**
     *
     * @param context
     * @param target Function to be executed within the context
     */ // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
    _bindFunction(context = (0, $411320e1da10ff3d$export$78df28f9b2f9a7dc), target) {
        const manager = this;
        const contextWrapper = function(...args) {
            return manager.with(context, ()=>target.apply(this, args));
        };
        Object.defineProperty(contextWrapper, 'length', {
            enumerable: false,
            configurable: true,
            writable: false,
            value: target.length
        });
        return contextWrapper;
    }
    /**
     * Returns the active context
     */ active() {
        return this._currentContext;
    }
    /**
     * Binds a the certain context or the active one to the target function and then returns the target
     * @param context A context (span) to be bind to target
     * @param target a function or event emitter. When target or one of its callbacks is called,
     *  the provided context will be used as the active context for the duration of the call.
     */ bind(context, target) {
        // if no specific context to propagate is given, we use the current one
        if (context === undefined) context = this.active();
        if (typeof target === 'function') return this._bindFunction(context, target);
        return target;
    }
    /**
     * Disable the context manager (clears the current context)
     */ disable() {
        this._currentContext = (0, $411320e1da10ff3d$export$78df28f9b2f9a7dc);
        this._enabled = false;
        return this;
    }
    /**
     * Enables the context manager and creates a default(root) context
     */ enable() {
        if (this._enabled) return this;
        this._enabled = true;
        this._currentContext = (0, $411320e1da10ff3d$export$78df28f9b2f9a7dc);
        return this;
    }
    /**
     * Calls the callback function [fn] with the provided [context]. If [context] is undefined then it will use the window.
     * The context will be set as active
     * @param context
     * @param fn Callback function
     * @param thisArg optional receiver to be used for calling fn
     * @param args optional arguments forwarded to fn
     */ with(context, fn, thisArg, ...args) {
        const previousContext = this._currentContext;
        this._currentContext = context || (0, $411320e1da10ff3d$export$78df28f9b2f9a7dc);
        try {
            return fn.call(thisArg, ...args);
        } finally{
            this._currentContext = previousContext;
        }
    }
}



/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
class $ff40152fd01f45b5$export$4beb26f46770357f {
    _propagators;
    _fields;
    /**
     * Construct a composite propagator from a list of propagators.
     *
     * @param [config] Configuration object for composite propagator
     */ constructor(config = {}){
        this._propagators = config.propagators ?? [];
        this._fields = Array.from(new Set(this._propagators// older propagators may not have fields function, null check to be sure
        .map((p)=>typeof p.fields === 'function' ? p.fields() : []).reduce((x, y)=>x.concat(y), [])));
    }
    /**
     * Run each of the configured propagators with the given context and carrier.
     * Propagators are run in the order they are configured, so if multiple
     * propagators write the same carrier key, the propagator later in the list
     * will "win".
     *
     * @param context Context to inject
     * @param carrier Carrier into which context will be injected
     */ inject(context, carrier, setter) {
        for (const propagator of this._propagators)try {
            propagator.inject(context, carrier, setter);
        } catch (err) {
            (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).warn(`Failed to inject with ${propagator.constructor.name}. Err: ${err.message}`);
        }
    }
    /**
     * Run each of the configured propagators with the given context and carrier.
     * Propagators are run in the order they are configured, so if multiple
     * propagators write the same context key, the propagator later in the list
     * will "win".
     *
     * @param context Context to add values to
     * @param carrier Carrier from which to extract context
     */ extract(context, carrier, getter) {
        return this._propagators.reduce((ctx, propagator)=>{
            try {
                return propagator.extract(ctx, carrier, getter);
            } catch (err) {
                (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).warn(`Failed to extract with ${propagator.constructor.name}. Err: ${err.message}`);
            }
            return ctx;
        }, context);
    }
    fields() {
        // return a new array so our fields cannot be modified
        return this._fields.slice();
    }
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $f115375854688b9c$export$3043215ef908d54f = '=';
const $f115375854688b9c$export$393a3f9e6e76438 = ';';
const $f115375854688b9c$export$1ab471785c2cf557 = ',';
const $f115375854688b9c$export$a6199dd4fe419e69 = 'baggage';
const $f115375854688b9c$export$9a50757016085e99 = 180;
const $f115375854688b9c$export$c7d9e39bb295c1f = 4096;
const $f115375854688b9c$export$dd0527bee1f518e7 = 8192;


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

function $34e1b15c9a64a7b4$export$790fc82b2ff5bf87(keyPairs) {
    return keyPairs.reduce((hValue, current)=>{
        const value = `${hValue}${hValue !== '' ? (0, $f115375854688b9c$export$1ab471785c2cf557) : ''}${current}`;
        return value.length > (0, $f115375854688b9c$export$dd0527bee1f518e7) ? hValue : value;
    }, '');
}
function $34e1b15c9a64a7b4$export$ed4c06f0919b1951(baggage) {
    return baggage.getAllEntries().map(([key, value])=>{
        let entry = `${encodeURIComponent(key)}=${encodeURIComponent(value.value)}`;
        // include opaque metadata if provided
        // NOTE: we intentionally don't URI-encode the metadata - that responsibility falls on the metadata implementation
        if (value.metadata !== undefined) entry += (0, $f115375854688b9c$export$393a3f9e6e76438) + value.metadata.toString();
        return entry;
    });
}
function $34e1b15c9a64a7b4$export$62659c450b08e504(entry) {
    const valueProps = entry.split((0, $f115375854688b9c$export$393a3f9e6e76438));
    if (valueProps.length <= 0) return;
    const keyPairPart = valueProps.shift();
    if (!keyPairPart) return;
    const separatorIndex = keyPairPart.indexOf((0, $f115375854688b9c$export$3043215ef908d54f));
    if (separatorIndex <= 0) return;
    const key = decodeURIComponent(keyPairPart.substring(0, separatorIndex).trim());
    const value = decodeURIComponent(keyPairPart.substring(separatorIndex + 1).trim());
    let metadata;
    if (valueProps.length > 0) metadata = (0, $36ecce552d4bbf35$export$c491cedc1b2b6e9e)(valueProps.join((0, $f115375854688b9c$export$393a3f9e6e76438)));
    return {
        key: key,
        value: value,
        metadata: metadata
    };
}
function $34e1b15c9a64a7b4$export$1259660ed6830e21(value) {
    const result = {};
    if (typeof value === 'string' && value.length > 0) value.split((0, $f115375854688b9c$export$1ab471785c2cf557)).forEach((entry)=>{
        const keyPair = $34e1b15c9a64a7b4$export$62659c450b08e504(entry);
        if (keyPair !== undefined && keyPair.value.length > 0) result[keyPair.key] = keyPair.value;
    });
    return result;
}


class $12d7120b6dd6df4f$export$604bcc7f2bff6bb {
    inject(context, carrier, setter) {
        const baggage = (0, $77955577000c938d$export$3e49040daa9dba20).getBaggage(context);
        if (!baggage || (0, $a2728a0463bf3b1f$export$7d5f2376f7cf513)(context)) return;
        const keyPairs = (0, $34e1b15c9a64a7b4$export$ed4c06f0919b1951)(baggage).filter((pair)=>{
            return pair.length <= (0, $f115375854688b9c$export$c7d9e39bb295c1f);
        }).slice(0, (0, $f115375854688b9c$export$9a50757016085e99));
        const headerValue = (0, $34e1b15c9a64a7b4$export$790fc82b2ff5bf87)(keyPairs);
        if (headerValue.length > 0) setter.set(carrier, (0, $f115375854688b9c$export$a6199dd4fe419e69), headerValue);
    }
    extract(context, carrier, getter) {
        const headerValue = getter.get(carrier, (0, $f115375854688b9c$export$a6199dd4fe419e69));
        const baggageString = Array.isArray(headerValue) ? headerValue.join((0, $f115375854688b9c$export$1ab471785c2cf557)) : headerValue;
        if (!baggageString) return context;
        const baggage = {};
        if (baggageString.length === 0) return context;
        const pairs = baggageString.split((0, $f115375854688b9c$export$1ab471785c2cf557));
        pairs.forEach((entry)=>{
            const keyPair = (0, $34e1b15c9a64a7b4$export$62659c450b08e504)(entry);
            if (keyPair) {
                const baggageEntry = {
                    value: keyPair.value
                };
                if (keyPair.metadata) baggageEntry.metadata = keyPair.metadata;
                baggage[keyPair.key] = baggageEntry;
            }
        });
        if (Object.entries(baggage).length === 0) return context;
        return (0, $77955577000c938d$export$3e49040daa9dba20).setBaggage(context, (0, $77955577000c938d$export$3e49040daa9dba20).createBaggage(baggage));
    }
    fields() {
        return [
            (0, $f115375854688b9c$export$a6199dd4fe419e69)
        ];
    }
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $d42c44c5a713d81c$var$VALID_KEY_CHAR_RANGE = '[_0-9a-z-*/]';
const $d42c44c5a713d81c$var$VALID_KEY = `[a-z]${$d42c44c5a713d81c$var$VALID_KEY_CHAR_RANGE}{0,255}`;
const $d42c44c5a713d81c$var$VALID_VENDOR_KEY = `[a-z0-9]${$d42c44c5a713d81c$var$VALID_KEY_CHAR_RANGE}{0,240}@[a-z]${$d42c44c5a713d81c$var$VALID_KEY_CHAR_RANGE}{0,13}`;
const $d42c44c5a713d81c$var$VALID_KEY_REGEX = new RegExp(`^(?:${$d42c44c5a713d81c$var$VALID_KEY}|${$d42c44c5a713d81c$var$VALID_VENDOR_KEY})$`);
const $d42c44c5a713d81c$var$VALID_VALUE_BASE_REGEX = /^[ -~]{0,255}[!-~]$/;
const $d42c44c5a713d81c$var$INVALID_VALUE_COMMA_EQUAL_REGEX = /,|=/;
function $d42c44c5a713d81c$export$469cc9c479301ba6(key) {
    return $d42c44c5a713d81c$var$VALID_KEY_REGEX.test(key);
}
function $d42c44c5a713d81c$export$b76e9316566cc26e(value) {
    return $d42c44c5a713d81c$var$VALID_VALUE_BASE_REGEX.test(value) && !$d42c44c5a713d81c$var$INVALID_VALUE_COMMA_EQUAL_REGEX.test(value);
}


const $da45a91e3c0e04ee$var$MAX_TRACE_STATE_ITEMS = 32;
const $da45a91e3c0e04ee$var$MAX_TRACE_STATE_LEN = 512;
const $da45a91e3c0e04ee$var$LIST_MEMBERS_SEPARATOR = ',';
const $da45a91e3c0e04ee$var$LIST_MEMBER_KEY_VALUE_SPLITTER = '=';
class $da45a91e3c0e04ee$export$b0addedc390b67c2 {
    _internalState = new Map();
    constructor(rawTraceState){
        if (rawTraceState) this._parse(rawTraceState);
    }
    set(key, value) {
        // TODO: Benchmark the different approaches(map vs list) and
        // use the faster one.
        const traceState = this._clone();
        if (traceState._internalState.has(key)) traceState._internalState.delete(key);
        traceState._internalState.set(key, value);
        return traceState;
    }
    unset(key) {
        const traceState = this._clone();
        traceState._internalState.delete(key);
        return traceState;
    }
    get(key) {
        return this._internalState.get(key);
    }
    serialize() {
        return this._keys().reduce((agg, key)=>{
            agg.push(key + $da45a91e3c0e04ee$var$LIST_MEMBER_KEY_VALUE_SPLITTER + this.get(key));
            return agg;
        }, []).join($da45a91e3c0e04ee$var$LIST_MEMBERS_SEPARATOR);
    }
    _parse(rawTraceState) {
        if (rawTraceState.length > $da45a91e3c0e04ee$var$MAX_TRACE_STATE_LEN) return;
        this._internalState = rawTraceState.split($da45a91e3c0e04ee$var$LIST_MEMBERS_SEPARATOR).reverse() // Store in reverse so new keys (.set(...)) will be placed at the beginning
        .reduce((agg, part)=>{
            const listMember = part.trim(); // Optional Whitespace (OWS) handling
            const i = listMember.indexOf($da45a91e3c0e04ee$var$LIST_MEMBER_KEY_VALUE_SPLITTER);
            if (i !== -1) {
                const key = listMember.slice(0, i);
                const value = listMember.slice(i + 1, part.length);
                if ((0, $d42c44c5a713d81c$export$469cc9c479301ba6)(key) && (0, $d42c44c5a713d81c$export$b76e9316566cc26e)(value)) agg.set(key, value);
            }
            return agg;
        }, new Map());
        // Because of the reverse() requirement, trunc must be done after map is created
        if (this._internalState.size > $da45a91e3c0e04ee$var$MAX_TRACE_STATE_ITEMS) this._internalState = new Map(Array.from(this._internalState.entries()).reverse() // Use reverse same as original tracestate parse chain
        .slice(0, $da45a91e3c0e04ee$var$MAX_TRACE_STATE_ITEMS));
    }
    _keys() {
        return Array.from(this._internalState.keys()).reverse();
    }
    _clone() {
        const traceState = new $da45a91e3c0e04ee$export$b0addedc390b67c2();
        traceState._internalState = new Map(this._internalState);
        return traceState;
    }
}


const $972b3cdb4eaa2e74$export$830e05fa2746348 = 'traceparent';
const $972b3cdb4eaa2e74$export$2b12ed38dcfae2ae = 'tracestate';
const $972b3cdb4eaa2e74$var$VERSION = '00';
const $972b3cdb4eaa2e74$var$VERSION_PART = '(?!ff)[\\da-f]{2}';
const $972b3cdb4eaa2e74$var$TRACE_ID_PART = '(?![0]{32})[\\da-f]{32}';
const $972b3cdb4eaa2e74$var$PARENT_ID_PART = '(?![0]{16})[\\da-f]{16}';
const $972b3cdb4eaa2e74$var$FLAGS_PART = '[\\da-f]{2}';
const $972b3cdb4eaa2e74$var$TRACE_PARENT_REGEX = new RegExp(`^\\s?(${$972b3cdb4eaa2e74$var$VERSION_PART})-(${$972b3cdb4eaa2e74$var$TRACE_ID_PART})-(${$972b3cdb4eaa2e74$var$PARENT_ID_PART})-(${$972b3cdb4eaa2e74$var$FLAGS_PART})(-.*)?\\s?$`);
function $972b3cdb4eaa2e74$export$f4d87f8901a93f5d(traceParent) {
    const match = $972b3cdb4eaa2e74$var$TRACE_PARENT_REGEX.exec(traceParent);
    if (!match) return null;
    // According to the specification the implementation should be compatible
    // with future versions. If there are more parts, we only reject it if it's using version 00
    // See https://www.w3.org/TR/trace-context/#versioning-of-traceparent
    if (match[1] === '00' && match[5]) return null;
    return {
        traceId: match[2],
        spanId: match[3],
        traceFlags: parseInt(match[4], 16)
    };
}
class $972b3cdb4eaa2e74$export$737c747d043a1f7b {
    inject(context, carrier, setter) {
        const spanContext = (0, $496851d2cf78caa4$export$357889f174732d38).getSpanContext(context);
        if (!spanContext || (0, $a2728a0463bf3b1f$export$7d5f2376f7cf513)(context) || !(0, $99a3da0b8477e363$export$e4373b9a2c09216c)(spanContext)) return;
        const traceParent = `${$972b3cdb4eaa2e74$var$VERSION}-${spanContext.traceId}-${spanContext.spanId}-0${Number(spanContext.traceFlags || (0, $5dcc187a863bca89$export$bf9049ad2b0883ff).NONE).toString(16)}`;
        setter.set(carrier, $972b3cdb4eaa2e74$export$830e05fa2746348, traceParent);
        if (spanContext.traceState) setter.set(carrier, $972b3cdb4eaa2e74$export$2b12ed38dcfae2ae, spanContext.traceState.serialize());
    }
    extract(context, carrier, getter) {
        const traceParentHeader = getter.get(carrier, $972b3cdb4eaa2e74$export$830e05fa2746348);
        if (!traceParentHeader) return context;
        const traceParent = Array.isArray(traceParentHeader) ? traceParentHeader[0] : traceParentHeader;
        if (typeof traceParent !== 'string') return context;
        const spanContext = $972b3cdb4eaa2e74$export$f4d87f8901a93f5d(traceParent);
        if (!spanContext) return context;
        spanContext.isRemote = true;
        const traceStateHeader = getter.get(carrier, $972b3cdb4eaa2e74$export$2b12ed38dcfae2ae);
        if (traceStateHeader) {
            // If more than one `tracestate` header is found, we merge them into a
            // single header.
            const state = Array.isArray(traceStateHeader) ? traceStateHeader.join(',') : traceStateHeader;
            spanContext.traceState = new (0, $da45a91e3c0e04ee$export$b0addedc390b67c2)(typeof state === 'string' ? state : undefined);
        }
        return (0, $496851d2cf78caa4$export$357889f174732d38).setSpanContext(context, spanContext);
    }
    fields() {
        return [
            $972b3cdb4eaa2e74$export$830e05fa2746348,
            $972b3cdb4eaa2e74$export$2b12ed38dcfae2ae
        ];
    }
}


function $63a533b9ee75e32f$var$setupContextManager(contextManager) {
    // null means 'do not register'
    if (contextManager === null) return;
    // undefined means 'register default'
    if (contextManager === undefined) {
        const defaultContextManager = new (0, $a8d66854eb53d217$export$3dfe62dd209faf13)();
        defaultContextManager.enable();
        (0, $0c57d9262090934c$export$a078c61943f9dbbe).setGlobalContextManager(defaultContextManager);
        return;
    }
    contextManager.enable();
    (0, $0c57d9262090934c$export$a078c61943f9dbbe).setGlobalContextManager(contextManager);
}
function $63a533b9ee75e32f$var$setupPropagator(propagator) {
    // null means 'do not register'
    if (propagator === null) return;
    // undefined means 'register default'
    if (propagator === undefined) {
        (0, $77955577000c938d$export$3e49040daa9dba20).setGlobalPropagator(new (0, $ff40152fd01f45b5$export$4beb26f46770357f)({
            propagators: [
                new (0, $972b3cdb4eaa2e74$export$737c747d043a1f7b)(),
                new (0, $12d7120b6dd6df4f$export$604bcc7f2bff6bb)()
            ]
        }));
        return;
    }
    (0, $77955577000c938d$export$3e49040daa9dba20).setGlobalPropagator(propagator);
}
class $63a533b9ee75e32f$export$a785009afeee3453 extends (0, $09b0f540efe38fab$export$1f2f0f67f5ecff3b) {
    /**
     * Constructs a new Tracer instance.
     * @param config Web Tracer config
     */ constructor(config = {}){
        super(config);
    }
    /**
     * Register this TracerProvider for use with the OpenTelemetry API.
     * Undefined values may be replaced with defaults, and
     * null values will be skipped.
     *
     * @param config Configuration object for SDK registration
     */ register(config = {}) {
        (0, $496851d2cf78caa4$export$357889f174732d38).setGlobalTracerProvider(this);
        $63a533b9ee75e32f$var$setupPropagator(config.propagator);
        $63a533b9ee75e32f$var$setupContextManager(config.contextManager);
    }
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $3e8831089012b6e0$export$74be52df2d6fd28c;
(function(PerformanceTimingNames) {
    PerformanceTimingNames["CONNECT_END"] = "connectEnd";
    PerformanceTimingNames["CONNECT_START"] = "connectStart";
    PerformanceTimingNames["DECODED_BODY_SIZE"] = "decodedBodySize";
    PerformanceTimingNames["DOM_COMPLETE"] = "domComplete";
    PerformanceTimingNames["DOM_CONTENT_LOADED_EVENT_END"] = "domContentLoadedEventEnd";
    PerformanceTimingNames["DOM_CONTENT_LOADED_EVENT_START"] = "domContentLoadedEventStart";
    PerformanceTimingNames["DOM_INTERACTIVE"] = "domInteractive";
    PerformanceTimingNames["DOMAIN_LOOKUP_END"] = "domainLookupEnd";
    PerformanceTimingNames["DOMAIN_LOOKUP_START"] = "domainLookupStart";
    PerformanceTimingNames["ENCODED_BODY_SIZE"] = "encodedBodySize";
    PerformanceTimingNames["FETCH_START"] = "fetchStart";
    PerformanceTimingNames["LOAD_EVENT_END"] = "loadEventEnd";
    PerformanceTimingNames["LOAD_EVENT_START"] = "loadEventStart";
    PerformanceTimingNames["NAVIGATION_START"] = "navigationStart";
    PerformanceTimingNames["REDIRECT_END"] = "redirectEnd";
    PerformanceTimingNames["REDIRECT_START"] = "redirectStart";
    PerformanceTimingNames["REQUEST_START"] = "requestStart";
    PerformanceTimingNames["RESPONSE_END"] = "responseEnd";
    PerformanceTimingNames["RESPONSE_START"] = "responseStart";
    PerformanceTimingNames["SECURE_CONNECTION_START"] = "secureConnectionStart";
    PerformanceTimingNames["START_TIME"] = "startTime";
    PerformanceTimingNames["UNLOAD_EVENT_END"] = "unloadEventEnd";
    PerformanceTimingNames["UNLOAD_EVENT_START"] = "unloadEventStart";
})($3e8831089012b6e0$export$74be52df2d6fd28c || ($3e8831089012b6e0$export$74be52df2d6fd28c = {}));


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $3b8b64466dc61937$export$c2a944331f80ae92(url, urlToMatch) {
    if (typeof urlToMatch === 'string') return url === urlToMatch;
    else return !!url.match(urlToMatch);
}
function $3b8b64466dc61937$export$172b5a1c42a6f83d(url, ignoredUrls) {
    if (!ignoredUrls) return false;
    for (const ignoreUrl of ignoredUrls){
        if ($3b8b64466dc61937$export$c2a944331f80ae92(url, ignoreUrl)) return true;
    }
    return false;
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * This file contains a copy of unstable semantic convention definitions
 * used by this package.
 * @see https://github.com/open-telemetry/opentelemetry-js/tree/main/semantic-conventions#unstable-semconv
 */ /**
 * Deprecated, use `http.response.header.<key>` instead.
 *
 * @example 3495
 *
 * @experimental This attribute is experimental and is subject to breaking changes in minor releases of `@opentelemetry/semantic-conventions`.
 *
 * @deprecated Replaced by `http.response.header.<key>`.
 */ const $8434e5fc70ff7666$export$237bc893b534cd8c = 'http.response_content_length';
const $8434e5fc70ff7666$export$651dae55eea4b228 = 'http.response_content_length_uncompressed';


// Used to normalize relative URLs
let $0f094f3dcc7447ce$var$urlNormalizingAnchor;
function $0f094f3dcc7447ce$var$getUrlNormalizingAnchor() {
    if (!$0f094f3dcc7447ce$var$urlNormalizingAnchor) $0f094f3dcc7447ce$var$urlNormalizingAnchor = document.createElement('a');
    return $0f094f3dcc7447ce$var$urlNormalizingAnchor;
}
function $0f094f3dcc7447ce$export$94df19ecb868bc1a(obj, key) {
    return key in obj;
}
function $0f094f3dcc7447ce$export$7e5e8f17966d37d1(span, performanceName, entries, ignoreZeros = true) {
    if ($0f094f3dcc7447ce$export$94df19ecb868bc1a(entries, performanceName) && typeof entries[performanceName] === 'number' && !(ignoreZeros && entries[performanceName] === 0)) return span.addEvent(performanceName, entries[performanceName]);
    return undefined;
}
function $0f094f3dcc7447ce$export$e2385716cf129455(span, resource, ignoreNetworkEvents = false, ignoreZeros, skipOldSemconvContentLengthAttrs) {
    if (ignoreZeros === undefined) ignoreZeros = resource[(0, $3e8831089012b6e0$export$74be52df2d6fd28c).START_TIME] !== 0;
    if (!ignoreNetworkEvents) {
        $0f094f3dcc7447ce$export$7e5e8f17966d37d1(span, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).FETCH_START, resource, ignoreZeros);
        $0f094f3dcc7447ce$export$7e5e8f17966d37d1(span, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).DOMAIN_LOOKUP_START, resource, ignoreZeros);
        $0f094f3dcc7447ce$export$7e5e8f17966d37d1(span, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).DOMAIN_LOOKUP_END, resource, ignoreZeros);
        $0f094f3dcc7447ce$export$7e5e8f17966d37d1(span, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).CONNECT_START, resource, ignoreZeros);
        $0f094f3dcc7447ce$export$7e5e8f17966d37d1(span, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).SECURE_CONNECTION_START, resource, ignoreZeros);
        $0f094f3dcc7447ce$export$7e5e8f17966d37d1(span, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).CONNECT_END, resource, ignoreZeros);
        $0f094f3dcc7447ce$export$7e5e8f17966d37d1(span, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).REQUEST_START, resource, ignoreZeros);
        $0f094f3dcc7447ce$export$7e5e8f17966d37d1(span, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).RESPONSE_START, resource, ignoreZeros);
        $0f094f3dcc7447ce$export$7e5e8f17966d37d1(span, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).RESPONSE_END, resource, ignoreZeros);
    }
    if (!skipOldSemconvContentLengthAttrs) {
        // This block adds content-length-related span attributes using the
        // *old* HTTP semconv (v1.7.0).
        const encodedLength = resource[(0, $3e8831089012b6e0$export$74be52df2d6fd28c).ENCODED_BODY_SIZE];
        if (encodedLength !== undefined) span.setAttribute((0, $8434e5fc70ff7666$export$237bc893b534cd8c), encodedLength);
        const decodedLength = resource[(0, $3e8831089012b6e0$export$74be52df2d6fd28c).DECODED_BODY_SIZE];
        // Spec: Not set if transport encoding not used (in which case encoded and decoded sizes match)
        if (decodedLength !== undefined && encodedLength !== decodedLength) span.setAttribute((0, $8434e5fc70ff7666$export$651dae55eea4b228), decodedLength);
    }
}
function $0f094f3dcc7447ce$export$5d17283e524de23c(filteredResources) {
    return filteredResources.slice().sort((a, b)=>{
        const valueA = a[(0, $3e8831089012b6e0$export$74be52df2d6fd28c).FETCH_START];
        const valueB = b[(0, $3e8831089012b6e0$export$74be52df2d6fd28c).FETCH_START];
        if (valueA > valueB) return 1;
        else if (valueA < valueB) return -1;
        return 0;
    });
}
/** Returns the origin if present (if in browser context). */ function $0f094f3dcc7447ce$var$getOrigin() {
    return typeof location !== 'undefined' ? location.origin : undefined;
}
function $0f094f3dcc7447ce$export$cdcba7438a7553e8(spanUrl, startTimeHR, endTimeHR, resources, ignoredResources = new WeakSet(), initiatorType) {
    // de-relativize the URL before usage (does no harm to absolute URLs)
    const parsedSpanUrl = $0f094f3dcc7447ce$export$7a5253c0f62e0150(spanUrl);
    spanUrl = parsedSpanUrl.toString();
    const filteredResources = $0f094f3dcc7447ce$var$filterResourcesForSpan(spanUrl, startTimeHR, endTimeHR, resources, ignoredResources, initiatorType);
    if (filteredResources.length === 0) return {
        mainRequest: undefined
    };
    if (filteredResources.length === 1) return {
        mainRequest: filteredResources[0]
    };
    const sorted = $0f094f3dcc7447ce$export$5d17283e524de23c(filteredResources);
    if (parsedSpanUrl.origin !== $0f094f3dcc7447ce$var$getOrigin() && sorted.length > 1) {
        let corsPreFlightRequest = sorted[0];
        let mainRequest = $0f094f3dcc7447ce$var$findMainRequest(sorted, corsPreFlightRequest[(0, $3e8831089012b6e0$export$74be52df2d6fd28c).RESPONSE_END], endTimeHR);
        const responseEnd = corsPreFlightRequest[(0, $3e8831089012b6e0$export$74be52df2d6fd28c).RESPONSE_END];
        const fetchStart = mainRequest[(0, $3e8831089012b6e0$export$74be52df2d6fd28c).FETCH_START];
        // no corsPreFlightRequest
        if (fetchStart < responseEnd) {
            mainRequest = corsPreFlightRequest;
            corsPreFlightRequest = undefined;
        }
        return {
            corsPreFlightRequest: corsPreFlightRequest,
            mainRequest: mainRequest
        };
    } else return {
        mainRequest: filteredResources[0]
    };
}
/**
 * Will find the main request skipping the cors pre flight requests
 * @param resources
 * @param corsPreFlightRequestEndTime
 * @param spanEndTimeHR
 */ function $0f094f3dcc7447ce$var$findMainRequest(resources, corsPreFlightRequestEndTime, spanEndTimeHR) {
    const spanEndTime = (0, $02ed3a94ae5b2eb2$export$2d91441ae30ebcfc)(spanEndTimeHR);
    const minTime = (0, $02ed3a94ae5b2eb2$export$2d91441ae30ebcfc)((0, $02ed3a94ae5b2eb2$export$5f4c8a8ba0e36226)(corsPreFlightRequestEndTime));
    let mainRequest = resources[1];
    let bestGap;
    const length = resources.length;
    for(let i = 1; i < length; i++){
        const resource = resources[i];
        const resourceStartTime = (0, $02ed3a94ae5b2eb2$export$2d91441ae30ebcfc)((0, $02ed3a94ae5b2eb2$export$5f4c8a8ba0e36226)(resource[(0, $3e8831089012b6e0$export$74be52df2d6fd28c).FETCH_START]));
        const resourceEndTime = (0, $02ed3a94ae5b2eb2$export$2d91441ae30ebcfc)((0, $02ed3a94ae5b2eb2$export$5f4c8a8ba0e36226)(resource[(0, $3e8831089012b6e0$export$74be52df2d6fd28c).RESPONSE_END]));
        const currentGap = spanEndTime - resourceEndTime;
        if (resourceStartTime >= minTime && (!bestGap || currentGap < bestGap)) {
            bestGap = currentGap;
            mainRequest = resource;
        }
    }
    return mainRequest;
}
/**
 * Filter all resources that has started and finished according to span start time and end time.
 *     It will return the closest resource to a start time
 * @param spanUrl
 * @param startTimeHR
 * @param endTimeHR
 * @param resources
 * @param ignoredResources
 */ function $0f094f3dcc7447ce$var$filterResourcesForSpan(spanUrl, startTimeHR, endTimeHR, resources, ignoredResources, initiatorType) {
    const startTime = (0, $02ed3a94ae5b2eb2$export$2d91441ae30ebcfc)(startTimeHR);
    const endTime = (0, $02ed3a94ae5b2eb2$export$2d91441ae30ebcfc)(endTimeHR);
    let filteredResources = resources.filter((resource)=>{
        const resourceStartTime = (0, $02ed3a94ae5b2eb2$export$2d91441ae30ebcfc)((0, $02ed3a94ae5b2eb2$export$5f4c8a8ba0e36226)(resource[(0, $3e8831089012b6e0$export$74be52df2d6fd28c).FETCH_START]));
        const resourceEndTime = (0, $02ed3a94ae5b2eb2$export$2d91441ae30ebcfc)((0, $02ed3a94ae5b2eb2$export$5f4c8a8ba0e36226)(resource[(0, $3e8831089012b6e0$export$74be52df2d6fd28c).RESPONSE_END]));
        return resource.initiatorType.toLowerCase() === (initiatorType || 'xmlhttprequest') && resource.name === spanUrl && resourceStartTime >= startTime && resourceEndTime <= endTime;
    });
    if (filteredResources.length > 0) filteredResources = filteredResources.filter((resource)=>{
        return !ignoredResources.has(resource);
    });
    return filteredResources;
}
function $0f094f3dcc7447ce$export$7a5253c0f62e0150(url) {
    if (typeof URL === 'function') return new URL(url, typeof document !== 'undefined' ? document.baseURI : typeof location !== 'undefined' // Some JS runtimes (e.g. Deno) don't define this
     ? location.href : undefined);
    const element = $0f094f3dcc7447ce$var$getUrlNormalizingAnchor();
    element.href = url;
    return element;
}
function $0f094f3dcc7447ce$export$6535eb414fa2c8b6(url) {
    const urlLike = $0f094f3dcc7447ce$export$7a5253c0f62e0150(url);
    return urlLike.href;
}
function $0f094f3dcc7447ce$export$fabdebd274ccbd1c(target, optimised) {
    if (target.nodeType === Node.DOCUMENT_NODE) return '/';
    const targetValue = $0f094f3dcc7447ce$var$getNodeValue(target, optimised);
    if (optimised && targetValue.indexOf('@id') > 0) return targetValue;
    let xpath = '';
    if (target.parentNode) xpath += $0f094f3dcc7447ce$export$fabdebd274ccbd1c(target.parentNode, false);
    xpath += targetValue;
    return xpath;
}
/**
 * get node index within the siblings
 * @param target
 */ function $0f094f3dcc7447ce$var$getNodeIndex(target) {
    if (!target.parentNode) return 0;
    const allowedTypes = [
        target.nodeType
    ];
    if (target.nodeType === Node.CDATA_SECTION_NODE) allowedTypes.push(Node.TEXT_NODE);
    let elements = Array.from(target.parentNode.childNodes);
    elements = elements.filter((element)=>{
        const localName = element.localName;
        return allowedTypes.indexOf(element.nodeType) >= 0 && localName === target.localName;
    });
    if (elements.length >= 1) return elements.indexOf(target) + 1; // xpath starts from 1
    // if there are no other similar child xpath doesn't need index
    return 0;
}
/**
 * get node value for xpath
 * @param target
 * @param optimised
 */ function $0f094f3dcc7447ce$var$getNodeValue(target, optimised) {
    const nodeType = target.nodeType;
    const index = $0f094f3dcc7447ce$var$getNodeIndex(target);
    let nodeValue = '';
    if (nodeType === Node.ELEMENT_NODE) {
        const id = target.getAttribute('id');
        if (optimised && id) return `//*[@id="${id}"]`;
        nodeValue = target.localName;
    } else if (nodeType === Node.TEXT_NODE || nodeType === Node.CDATA_SECTION_NODE) nodeValue = 'text()';
    else if (nodeType === Node.COMMENT_NODE) nodeValue = 'comment()';
    else return '';
    // if index is 1 it can be omitted in xpath
    if (nodeValue && index > 1) return `/${nodeValue}[${index}]`;
    return `/${nodeValue}`;
}
function $0f094f3dcc7447ce$export$c6501d7e56a5b40a(spanUrl, propagateTraceHeaderCorsUrls) {
    let propagateTraceHeaderUrls = propagateTraceHeaderCorsUrls || [];
    if (typeof propagateTraceHeaderUrls === 'string' || propagateTraceHeaderUrls instanceof RegExp) propagateTraceHeaderUrls = [
        propagateTraceHeaderUrls
    ];
    const parsedSpanUrl = $0f094f3dcc7447ce$export$7a5253c0f62e0150(spanUrl);
    if (parsedSpanUrl.origin === $0f094f3dcc7447ce$var$getOrigin()) return true;
    else return propagateTraceHeaderUrls.some((propagateTraceHeaderUrl)=>(0, $3b8b64466dc61937$export$c2a944331f80ae92)(spanUrl, propagateTraceHeaderUrl));
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Updates to this file should also be replicated to @opentelemetry/api and
// @opentelemetry/core too.
/**
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS implementation)
 * - <object> (When all else fails)
 */ /** only globals that common to node and browsers are allowed */ // eslint-disable-next-line n/no-unsupported-features/es-builtins, no-undef
const $a7d7063c72d030a8$export$5c524ddf7208c00c = typeof globalThis === 'object' ? globalThis : typeof self === 'object' ? self : typeof window === 'object' ? window : typeof $parcel$global === 'object' ? $parcel$global : {};


const $1a01db1422e59375$export$be5e405504011951 = Symbol.for('io.opentelemetry.js.api.logs');
const $1a01db1422e59375$export$fb1208122242c205 = (0, $a7d7063c72d030a8$export$5c524ddf7208c00c);
function $1a01db1422e59375$export$bf9e00ce1090794f(requiredVersion, instance, fallback) {
    return (version)=>version === requiredVersion ? instance : fallback;
}
const $1a01db1422e59375$export$41e8763f7160bb4 = 1;


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $703d4468e177722d$export$d16ba98760c74dd5 {
    emit(_logRecord) {}
}
const $703d4468e177722d$export$f5681b99b7ff4eb3 = new $703d4468e177722d$export$d16ba98760c74dd5();


class $7d7f8c3c8e555ce0$export$8d7f6fb42e615208 {
    getLogger(_name, _version, _options) {
        return new (0, $703d4468e177722d$export$d16ba98760c74dd5)();
    }
}
const $7d7f8c3c8e555ce0$export$ade97358fd6ba8df = new $7d7f8c3c8e555ce0$export$8d7f6fb42e615208();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
class $ca38947d9bfc14c7$export$ed6b4cba4dd55d4b {
    constructor(_provider, name, version, options){
        this._provider = _provider;
        this.name = name;
        this.version = version;
        this.options = options;
    }
    /**
     * Emit a log record. This method should only be used by log appenders.
     *
     * @param logRecord
     */ emit(logRecord) {
        this._getLogger().emit(logRecord);
    }
    /**
     * Try to get a logger from the proxy logger provider.
     * If the proxy logger provider has no delegate, return a noop logger.
     */ _getLogger() {
        if (this._delegate) return this._delegate;
        const logger = this._provider._getDelegateLogger(this.name, this.version, this.options);
        if (!logger) return 0, $703d4468e177722d$export$f5681b99b7ff4eb3;
        this._delegate = logger;
        return this._delegate;
    }
}


class $b490e513dbe6b4e6$export$f72276fc3bc2aaa4 {
    getLogger(name, version, options) {
        var _a;
        return (_a = this._getDelegateLogger(name, version, options)) !== null && _a !== void 0 ? _a : new (0, $ca38947d9bfc14c7$export$ed6b4cba4dd55d4b)(this, name, version, options);
    }
    /**
     * Get the delegate logger provider.
     * Used by tests only.
     * @internal
     */ _getDelegate() {
        var _a;
        return (_a = this._delegate) !== null && _a !== void 0 ? _a : (0, $7d7f8c3c8e555ce0$export$ade97358fd6ba8df);
    }
    /**
     * Set the delegate logger provider
     * @internal
     */ _setDelegate(delegate) {
        this._delegate = delegate;
    }
    /**
     * @internal
     */ _getDelegateLogger(name, version, options) {
        var _a;
        return (_a = this._delegate) === null || _a === void 0 ? void 0 : _a.getLogger(name, version, options);
    }
}


class $dab714d323f16e75$export$f8e63508eb6a0fc1 {
    constructor(){
        this._proxyLoggerProvider = new (0, $b490e513dbe6b4e6$export$f72276fc3bc2aaa4)();
    }
    static getInstance() {
        if (!this._instance) this._instance = new $dab714d323f16e75$export$f8e63508eb6a0fc1();
        return this._instance;
    }
    setGlobalLoggerProvider(provider) {
        if ((0, $1a01db1422e59375$export$fb1208122242c205)[0, $1a01db1422e59375$export$be5e405504011951]) return this.getLoggerProvider();
        (0, $1a01db1422e59375$export$fb1208122242c205)[0, $1a01db1422e59375$export$be5e405504011951] = (0, $1a01db1422e59375$export$bf9e00ce1090794f)((0, $1a01db1422e59375$export$41e8763f7160bb4), provider, (0, $7d7f8c3c8e555ce0$export$ade97358fd6ba8df));
        this._proxyLoggerProvider._setDelegate(provider);
        return provider;
    }
    /**
     * Returns the global logger provider.
     *
     * @returns LoggerProvider
     */ getLoggerProvider() {
        var _a, _b;
        return (_b = (_a = (0, $1a01db1422e59375$export$fb1208122242c205)[0, $1a01db1422e59375$export$be5e405504011951]) === null || _a === void 0 ? void 0 : _a.call((0, $1a01db1422e59375$export$fb1208122242c205), (0, $1a01db1422e59375$export$41e8763f7160bb4))) !== null && _b !== void 0 ? _b : this._proxyLoggerProvider;
    }
    /**
     * Returns a logger from the global logger provider.
     *
     * @returns Logger
     */ getLogger(name, version, options) {
        return this.getLoggerProvider().getLogger(name, version, options);
    }
    /** Remove the global logger provider */ disable() {
        delete (0, $1a01db1422e59375$export$fb1208122242c205)[0, $1a01db1422e59375$export$be5e405504011951];
        this._proxyLoggerProvider = new (0, $b490e513dbe6b4e6$export$f72276fc3bc2aaa4)();
    }
}


const $6d3371a0a865dabe$export$fa0831f497706bad = (0, $dab714d323f16e75$export$f8e63508eb6a0fc1).getInstance();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Default to complaining loudly when things don't go according to plan.
// eslint-disable-next-line no-console
let $3d9904bc9d2c84f8$var$logger = console.error.bind(console);
// Sets a property on an object, preserving its enumerability.
// This function assumes that the property is already writable.
function $3d9904bc9d2c84f8$var$defineProperty(obj, name, value) {
    const enumerable = !!obj[name] && Object.prototype.propertyIsEnumerable.call(obj, name);
    Object.defineProperty(obj, name, {
        configurable: true,
        enumerable: enumerable,
        writable: true,
        value: value
    });
}
const $3d9904bc9d2c84f8$export$4997ffc0176396a6 = (nodule, name, wrapper)=>{
    if (!nodule || !nodule[name]) {
        $3d9904bc9d2c84f8$var$logger('no original function ' + String(name) + ' to wrap');
        return;
    }
    if (!wrapper) {
        $3d9904bc9d2c84f8$var$logger('no wrapper function');
        $3d9904bc9d2c84f8$var$logger(new Error().stack);
        return;
    }
    const original = nodule[name];
    if (typeof original !== 'function' || typeof wrapper !== 'function') {
        $3d9904bc9d2c84f8$var$logger('original object and wrapper must be functions');
        return;
    }
    const wrapped = wrapper(original, name);
    $3d9904bc9d2c84f8$var$defineProperty(wrapped, '__original', original);
    $3d9904bc9d2c84f8$var$defineProperty(wrapped, '__unwrap', ()=>{
        if (nodule[name] === wrapped) $3d9904bc9d2c84f8$var$defineProperty(nodule, name, original);
    });
    $3d9904bc9d2c84f8$var$defineProperty(wrapped, '__wrapped', true);
    $3d9904bc9d2c84f8$var$defineProperty(nodule, name, wrapped);
    return wrapped;
};
const $3d9904bc9d2c84f8$export$358d869541567f31 = (nodules, names, wrapper)=>{
    if (!nodules) {
        $3d9904bc9d2c84f8$var$logger('must provide one or more modules to patch');
        $3d9904bc9d2c84f8$var$logger(new Error().stack);
        return;
    } else if (!Array.isArray(nodules)) nodules = [
        nodules
    ];
    if (!(names && Array.isArray(names))) {
        $3d9904bc9d2c84f8$var$logger('must provide one or more functions to wrap on modules');
        return;
    }
    nodules.forEach((nodule)=>{
        names.forEach((name)=>{
            $3d9904bc9d2c84f8$export$4997ffc0176396a6(nodule, name, wrapper);
        });
    });
};
const $3d9904bc9d2c84f8$export$debb760848ca95a = (nodule, name)=>{
    if (!nodule || !nodule[name]) {
        $3d9904bc9d2c84f8$var$logger('no function to unwrap.');
        $3d9904bc9d2c84f8$var$logger(new Error().stack);
        return;
    }
    const wrapped = nodule[name];
    if (!wrapped.__unwrap) $3d9904bc9d2c84f8$var$logger('no original to unwrap to -- has ' + String(name) + ' already been unwrapped?');
    else {
        wrapped.__unwrap();
        return;
    }
};
const $3d9904bc9d2c84f8$export$43e13a935e49ecde = (nodules, names)=>{
    if (!nodules) {
        $3d9904bc9d2c84f8$var$logger('must provide one or more modules to patch');
        $3d9904bc9d2c84f8$var$logger(new Error().stack);
        return;
    } else if (!Array.isArray(nodules)) nodules = [
        nodules
    ];
    if (!(names && Array.isArray(names))) {
        $3d9904bc9d2c84f8$var$logger('must provide one or more functions to unwrap on modules');
        return;
    }
    nodules.forEach((nodule)=>{
        names.forEach((name)=>{
            $3d9904bc9d2c84f8$export$debb760848ca95a(nodule, name);
        });
    });
};
function $3d9904bc9d2c84f8$export$2e2bcd8739ae039(options) {
    if (options && options.logger) {
        if (typeof options.logger !== 'function') $3d9904bc9d2c84f8$var$logger("new logger isn't a function, not replacing");
        else $3d9904bc9d2c84f8$var$logger = options.logger;
    }
}
$3d9904bc9d2c84f8$export$2e2bcd8739ae039.wrap = $3d9904bc9d2c84f8$export$4997ffc0176396a6;
$3d9904bc9d2c84f8$export$2e2bcd8739ae039.massWrap = $3d9904bc9d2c84f8$export$358d869541567f31;
$3d9904bc9d2c84f8$export$2e2bcd8739ae039.unwrap = $3d9904bc9d2c84f8$export$debb760848ca95a;
$3d9904bc9d2c84f8$export$2e2bcd8739ae039.massUnwrap = $3d9904bc9d2c84f8$export$43e13a935e49ecde;


class $2f7376613c351001$export$74c31cfd4e541b89 {
    instrumentationName;
    instrumentationVersion;
    _config = {};
    _tracer;
    _meter;
    _logger;
    _diag;
    constructor(instrumentationName, instrumentationVersion, config){
        this.instrumentationName = instrumentationName;
        this.instrumentationVersion = instrumentationVersion;
        this.setConfig(config);
        this._diag = (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).createComponentLogger({
            namespace: instrumentationName
        });
        this._tracer = (0, $496851d2cf78caa4$export$357889f174732d38).getTracer(instrumentationName, instrumentationVersion);
        this._meter = (0, $b8db6f384fae8886$export$b0c5c2fac8144e54).getMeter(instrumentationName, instrumentationVersion);
        this._logger = (0, $6d3371a0a865dabe$export$fa0831f497706bad).getLogger(instrumentationName, instrumentationVersion);
        this._updateMetricInstruments();
    }
    /* Api to wrap instrumented method */ _wrap = $3d9904bc9d2c84f8$export$4997ffc0176396a6;
    /* Api to unwrap instrumented methods */ _unwrap = $3d9904bc9d2c84f8$export$debb760848ca95a;
    /* Api to mass wrap instrumented method */ _massWrap = $3d9904bc9d2c84f8$export$358d869541567f31;
    /* Api to mass unwrap instrumented methods */ _massUnwrap = $3d9904bc9d2c84f8$export$43e13a935e49ecde;
    /* Returns meter */ get meter() {
        return this._meter;
    }
    /**
     * Sets MeterProvider to this plugin
     * @param meterProvider
     */ setMeterProvider(meterProvider) {
        this._meter = meterProvider.getMeter(this.instrumentationName, this.instrumentationVersion);
        this._updateMetricInstruments();
    }
    /* Returns logger */ get logger() {
        return this._logger;
    }
    /**
     * Sets LoggerProvider to this plugin
     * @param loggerProvider
     */ setLoggerProvider(loggerProvider) {
        this._logger = loggerProvider.getLogger(this.instrumentationName, this.instrumentationVersion);
    }
    /**
     * @experimental
     *
     * Get module definitions defined by {@link init}.
     * This can be used for experimental compile-time instrumentation.
     *
     * @returns an array of {@link InstrumentationModuleDefinition}
     */ getModuleDefinitions() {
        const initResult = this.init() ?? [];
        if (!Array.isArray(initResult)) return [
            initResult
        ];
        return initResult;
    }
    /**
     * Sets the new metric instruments with the current Meter.
     */ _updateMetricInstruments() {
        return;
    }
    /* Returns InstrumentationConfig */ getConfig() {
        return this._config;
    }
    /**
     * Sets InstrumentationConfig to this plugin
     * @param config
     */ setConfig(config) {
        // copy config first level properties to ensure they are immutable.
        // nested properties are not copied, thus are mutable from the outside.
        this._config = {
            enabled: true,
            ...config
        };
    }
    /**
     * Sets TraceProvider to this plugin
     * @param tracerProvider
     */ setTracerProvider(tracerProvider) {
        this._tracer = tracerProvider.getTracer(this.instrumentationName, this.instrumentationVersion);
    }
    /* Returns tracer */ get tracer() {
        return this._tracer;
    }
    /**
     * Execute span customization hook, if configured, and log any errors.
     * Any semantics of the trigger and info are defined by the specific instrumentation.
     * @param hookHandler The optional hook handler which the user has configured via instrumentation config
     * @param triggerName The name of the trigger for executing the hook for logging purposes
     * @param span The span to which the hook should be applied
     * @param info The info object to be passed to the hook, with useful data the hook may use
     */ _runSpanCustomizationHook(hookHandler, triggerName, span, info) {
        if (!hookHandler) return;
        try {
            hookHandler(span, info);
        } catch (e) {
            this._diag.error(`Error running span customization hook due to exception in handler`, {
                triggerName: triggerName
            }, e);
        }
    }
}


class $671e8529d3469f36$export$436b1c2bf7e9756b extends (0, $2f7376613c351001$export$74c31cfd4e541b89) {
    constructor(instrumentationName, instrumentationVersion, config){
        super(instrumentationName, instrumentationVersion, config);
        if (this._config.enabled) this.enable();
    }
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * function to execute patched function and being able to catch errors
 * @param execute - function to be executed
 * @param onFinish - callback to run when execute finishes
 */ function $b17aef886b8eab2d$export$fdff7e10f8ca069e(execute, onFinish, preventThrowingError) {
    let error;
    let result;
    try {
        result = execute();
    } catch (e) {
        error = e;
    } finally{
        onFinish(error, result);
        if (error && !preventThrowingError) // eslint-disable-next-line no-unsafe-finally
        throw error;
        // eslint-disable-next-line no-unsafe-finally
        return result;
    }
}
async function $b17aef886b8eab2d$export$75852fe3c08f1502(execute, onFinish, preventThrowingError) {
    let error;
    let result;
    try {
        result = await execute();
    } catch (e) {
        error = e;
    } finally{
        await onFinish(error, result);
        if (error && !preventThrowingError) // eslint-disable-next-line no-unsafe-finally
        throw error;
        // eslint-disable-next-line no-unsafe-finally
        return result;
    }
}
function $b17aef886b8eab2d$export$ec0fd572751979bc(func) {
    return typeof func === 'function' && typeof func.__original === 'function' && typeof func.__unwrap === 'function' && func.__wrapped === true;
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $358486a6f01822c1$export$38c181bcafcf2fa0;
(function(SemconvStability) {
    /** Emit only stable semantic conventions. */ SemconvStability[SemconvStability["STABLE"] = 1] = "STABLE";
    /** Emit only old semantic conventions. */ SemconvStability[SemconvStability["OLD"] = 2] = "OLD";
    /** Emit both stable and old semantic conventions. */ SemconvStability[SemconvStability["DUPLICATE"] = 3] = "DUPLICATE";
})($358486a6f01822c1$export$38c181bcafcf2fa0 || ($358486a6f01822c1$export$38c181bcafcf2fa0 = {}));
function $358486a6f01822c1$export$f9fa4e140bcc07bb(namespace, str) {
    let semconvStability = $358486a6f01822c1$export$38c181bcafcf2fa0.OLD;
    // The same parsing of `str` as `getStringListFromEnv` from the core pkg.
    const entries = str?.split(',').map((v)=>v.trim()).filter((s)=>s !== '');
    for (const entry of entries ?? []){
        if (entry.toLowerCase() === namespace + '/dup') {
            // DUPLICATE takes highest precedence.
            semconvStability = $358486a6f01822c1$export$38c181bcafcf2fa0.DUPLICATE;
            break;
        } else if (entry.toLowerCase() === namespace) semconvStability = $358486a6f01822c1$export$38c181bcafcf2fa0.STABLE;
    }
    return semconvStability;
}



/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6655623dd4db2a26$export$668754fb61dd076c;
(function(AttributeNames) {
    AttributeNames["DOCUMENT_LOAD"] = "documentLoad";
    AttributeNames["DOCUMENT_FETCH"] = "documentFetch";
    AttributeNames["RESOURCE_FETCH"] = "resourceFetch";
})($6655623dd4db2a26$export$668754fb61dd076c || ($6655623dd4db2a26$export$668754fb61dd076c = {}));


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // this is autogenerated file, see scripts/version-update.js
const $376aaa84b847c71a$export$4a03ffab3315ee34 = '0.54.0';
const $376aaa84b847c71a$export$b8b9d90f9e5bd72b = '@opentelemetry/instrumentation-document-load';


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * This file contains a copy of unstable semantic convention definitions
 * used by this package.
 * @see https://github.com/open-telemetry/opentelemetry-js/tree/main/semantic-conventions#unstable-semconv
 */ /**
 * Deprecated, use `http.response.header.content-length` instead.
 *
 * @example 3495
 *
 * @experimental This attribute is experimental and is subject to breaking changes in minor releases of `@opentelemetry/semantic-conventions`.
 *
 * @deprecated Replaced by `http.response.header.content-length`.
 */ const $72bb9ce1d0ec1a56$export$237bc893b534cd8c = 'http.response_content_length';
const $72bb9ce1d0ec1a56$export$13e2e9fdaf5f7c2d = 'http.url';
const $72bb9ce1d0ec1a56$export$a4ba95edc60c8ef3 = 'http.user_agent';


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9c030dacc11594a0$export$3fd36d65bf762270;
(function(EventNames) {
    EventNames["FIRST_PAINT"] = "firstPaint";
    EventNames["FIRST_CONTENTFUL_PAINT"] = "firstContentfulPaint";
})($9c030dacc11594a0$export$3fd36d65bf762270 || ($9c030dacc11594a0$export$3fd36d65bf762270 = {}));


const $d182fe99c2490bb3$export$1edb6265ef1ecc26 = ()=>{
    const entries = {};
    const performanceNavigationTiming = (0, $b5bb7b0fa6e48696$export$b22daef4119238cd).getEntriesByType?.('navigation')[0];
    if (performanceNavigationTiming) {
        const keys = Object.values((0, $3e8831089012b6e0$export$74be52df2d6fd28c));
        keys.forEach((key)=>{
            if ((0, $0f094f3dcc7447ce$export$94df19ecb868bc1a)(performanceNavigationTiming, key)) {
                const value = performanceNavigationTiming[key];
                if (typeof value === 'number') entries[key] = value;
            }
        });
    } else {
        // // fallback to previous version
        const perf = (0, $b5bb7b0fa6e48696$export$b22daef4119238cd);
        const performanceTiming = perf.timing;
        if (performanceTiming) {
            const keys = Object.values((0, $3e8831089012b6e0$export$74be52df2d6fd28c));
            keys.forEach((key)=>{
                if ((0, $0f094f3dcc7447ce$export$94df19ecb868bc1a)(performanceTiming, key)) {
                    const value = performanceTiming[key];
                    if (typeof value === 'number') entries[key] = value;
                }
            });
        }
    }
    return entries;
};
const $d182fe99c2490bb3$var$performancePaintNames = {
    'first-paint': (0, $9c030dacc11594a0$export$3fd36d65bf762270).FIRST_PAINT,
    'first-contentful-paint': (0, $9c030dacc11594a0$export$3fd36d65bf762270).FIRST_CONTENTFUL_PAINT
};
const $d182fe99c2490bb3$export$dbffc7a51b89acf6 = (span)=>{
    const performancePaintTiming = (0, $b5bb7b0fa6e48696$export$b22daef4119238cd).getEntriesByType?.('paint');
    if (performancePaintTiming) performancePaintTiming.forEach(({ name: name, startTime: startTime })=>{
        if ((0, $0f094f3dcc7447ce$export$94df19ecb868bc1a)($d182fe99c2490bb3$var$performancePaintNames, name)) span.addEvent($d182fe99c2490bb3$var$performancePaintNames[name], startTime);
    });
};


class $f8d3747903d55f9c$export$381e8ef2e310d2c3 extends (0, $671e8529d3469f36$export$436b1c2bf7e9756b) {
    component = 'document-load';
    version = '1';
    moduleName = this.component;
    _semconvStability;
    constructor(config = {}){
        super((0, $376aaa84b847c71a$export$b8b9d90f9e5bd72b), (0, $376aaa84b847c71a$export$4a03ffab3315ee34), config);
        this._semconvStability = (0, $358486a6f01822c1$export$f9fa4e140bcc07bb)('http', config?.semconvStabilityOptIn);
    }
    init() {}
    /**
     * callback to be executed when page is loaded
     */ _onDocumentLoaded() {
        // Timeout is needed as load event doesn't have yet the performance metrics for loadEnd.
        // Support for event "loadend" is very limited and cannot be used
        window.setTimeout(()=>{
            this._collectPerformance();
        });
    }
    /**
     * Adds spans for all resources
     * @param rootSpan
     */ _addResourcesSpans(rootSpan) {
        const resources = (0, $b5bb7b0fa6e48696$export$b22daef4119238cd).getEntriesByType?.('resource');
        if (resources) resources.forEach((resource)=>{
            this._initResourceSpan(resource, rootSpan);
        });
    }
    /**
     * Collects information about performance and creates appropriate spans
     */ _collectPerformance() {
        const metaElement = Array.from(document.getElementsByTagName('meta')).find((e)=>e.getAttribute('name') === (0, $972b3cdb4eaa2e74$export$830e05fa2746348));
        const entries = (0, $d182fe99c2490bb3$export$1edb6265ef1ecc26)();
        const traceparent = metaElement && metaElement.content || '';
        (0, $0c57d9262090934c$export$a078c61943f9dbbe).with((0, $77955577000c938d$export$3e49040daa9dba20).extract((0, $411320e1da10ff3d$export$78df28f9b2f9a7dc), {
            traceparent: traceparent
        }), ()=>{
            const rootSpan = this._startSpan((0, $6655623dd4db2a26$export$668754fb61dd076c).DOCUMENT_LOAD, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).FETCH_START, entries);
            if (!rootSpan) return;
            (0, $0c57d9262090934c$export$a078c61943f9dbbe).with((0, $496851d2cf78caa4$export$357889f174732d38).setSpan((0, $0c57d9262090934c$export$a078c61943f9dbbe).active(), rootSpan), ()=>{
                const fetchSpan = this._startSpan((0, $6655623dd4db2a26$export$668754fb61dd076c).DOCUMENT_FETCH, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).FETCH_START, entries);
                if (fetchSpan) {
                    if (this._semconvStability & (0, $358486a6f01822c1$export$38c181bcafcf2fa0).OLD) fetchSpan.setAttribute((0, $72bb9ce1d0ec1a56$export$13e2e9fdaf5f7c2d), location.href);
                    if (this._semconvStability & (0, $358486a6f01822c1$export$38c181bcafcf2fa0).STABLE) fetchSpan.setAttribute((0, $3fcd7ea0f1087866$export$ef7da4fb774e8a84), location.href);
                    (0, $0c57d9262090934c$export$a078c61943f9dbbe).with((0, $496851d2cf78caa4$export$357889f174732d38).setSpan((0, $0c57d9262090934c$export$a078c61943f9dbbe).active(), fetchSpan), ()=>{
                        const skipOldSemconvContentLengthAttrs = !(this._semconvStability & (0, $358486a6f01822c1$export$38c181bcafcf2fa0).OLD);
                        (0, $0f094f3dcc7447ce$export$e2385716cf129455)(fetchSpan, entries, this.getConfig().ignoreNetworkEvents, undefined, skipOldSemconvContentLengthAttrs);
                        this._addCustomAttributesOnSpan(fetchSpan, this.getConfig().applyCustomAttributesOnSpan?.documentFetch);
                        this._endSpan(fetchSpan, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).RESPONSE_END, entries);
                    });
                }
            });
            if (this._semconvStability & (0, $358486a6f01822c1$export$38c181bcafcf2fa0).OLD) {
                rootSpan.setAttribute((0, $72bb9ce1d0ec1a56$export$13e2e9fdaf5f7c2d), location.href);
                rootSpan.setAttribute((0, $72bb9ce1d0ec1a56$export$a4ba95edc60c8ef3), navigator.userAgent);
            }
            if (this._semconvStability & (0, $358486a6f01822c1$export$38c181bcafcf2fa0).STABLE) {
                rootSpan.setAttribute((0, $3fcd7ea0f1087866$export$ef7da4fb774e8a84), location.href);
                rootSpan.setAttribute((0, $3fcd7ea0f1087866$export$11d4f8ef7be26b3d), navigator.userAgent);
            }
            this._addResourcesSpans(rootSpan);
            if (!this.getConfig().ignoreNetworkEvents) {
                (0, $0f094f3dcc7447ce$export$7e5e8f17966d37d1)(rootSpan, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).FETCH_START, entries);
                (0, $0f094f3dcc7447ce$export$7e5e8f17966d37d1)(rootSpan, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).UNLOAD_EVENT_START, entries);
                (0, $0f094f3dcc7447ce$export$7e5e8f17966d37d1)(rootSpan, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).UNLOAD_EVENT_END, entries);
                (0, $0f094f3dcc7447ce$export$7e5e8f17966d37d1)(rootSpan, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).DOM_INTERACTIVE, entries);
                (0, $0f094f3dcc7447ce$export$7e5e8f17966d37d1)(rootSpan, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).DOM_CONTENT_LOADED_EVENT_START, entries);
                (0, $0f094f3dcc7447ce$export$7e5e8f17966d37d1)(rootSpan, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).DOM_CONTENT_LOADED_EVENT_END, entries);
                (0, $0f094f3dcc7447ce$export$7e5e8f17966d37d1)(rootSpan, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).DOM_COMPLETE, entries);
                (0, $0f094f3dcc7447ce$export$7e5e8f17966d37d1)(rootSpan, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).LOAD_EVENT_START, entries);
                (0, $0f094f3dcc7447ce$export$7e5e8f17966d37d1)(rootSpan, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).LOAD_EVENT_END, entries);
            }
            if (!this.getConfig().ignorePerformancePaintEvents) (0, $d182fe99c2490bb3$export$dbffc7a51b89acf6)(rootSpan);
            this._addCustomAttributesOnSpan(rootSpan, this.getConfig().applyCustomAttributesOnSpan?.documentLoad);
            this._endSpan(rootSpan, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).LOAD_EVENT_END, entries);
        });
    }
    /**
     * Helper function for ending span
     * @param span
     * @param performanceName name of performance entry for time end
     * @param entries
     */ _endSpan(span, performanceName, entries) {
        // span can be undefined when entries are missing the certain performance - the span will not be created
        if (span) {
            if ((0, $0f094f3dcc7447ce$export$94df19ecb868bc1a)(entries, performanceName)) span.end(entries[performanceName]);
            else // just end span
            span.end();
        }
    }
    /**
     * Creates and ends a span with network information about resource added as timed events
     * @param resource
     * @param parentSpan
     */ _initResourceSpan(resource, parentSpan) {
        const span = this._startSpan((0, $6655623dd4db2a26$export$668754fb61dd076c).RESOURCE_FETCH, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).FETCH_START, resource, parentSpan);
        if (span) {
            if (this._semconvStability & (0, $358486a6f01822c1$export$38c181bcafcf2fa0).OLD) span.setAttribute((0, $72bb9ce1d0ec1a56$export$13e2e9fdaf5f7c2d), resource.name);
            if (this._semconvStability & (0, $358486a6f01822c1$export$38c181bcafcf2fa0).STABLE) span.setAttribute((0, $3fcd7ea0f1087866$export$ef7da4fb774e8a84), resource.name);
            const skipOldSemconvContentLengthAttrs = !(this._semconvStability & (0, $358486a6f01822c1$export$38c181bcafcf2fa0).OLD);
            (0, $0f094f3dcc7447ce$export$e2385716cf129455)(span, resource, this.getConfig().ignoreNetworkEvents, undefined, skipOldSemconvContentLengthAttrs);
            this._addCustomAttributesOnResourceSpan(span, resource, this.getConfig().applyCustomAttributesOnSpan?.resourceFetch);
            this._endSpan(span, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).RESPONSE_END, resource);
        }
    }
    /**
     * Helper function for starting a span
     * @param spanName name of span
     * @param performanceName name of performance entry for time start
     * @param entries
     * @param parentSpan
     */ _startSpan(spanName, performanceName, entries, parentSpan) {
        if ((0, $0f094f3dcc7447ce$export$94df19ecb868bc1a)(entries, performanceName) && typeof entries[performanceName] === 'number') {
            const span = this.tracer.startSpan(spanName, {
                startTime: entries[performanceName]
            }, parentSpan ? (0, $496851d2cf78caa4$export$357889f174732d38).setSpan((0, $0c57d9262090934c$export$a078c61943f9dbbe).active(), parentSpan) : undefined);
            return span;
        }
        return undefined;
    }
    /**
     * executes callback {_onDocumentLoaded} when the page is loaded
     */ _waitForPageLoad() {
        if (window.document.readyState === 'complete') this._onDocumentLoaded();
        else {
            this._onDocumentLoaded = this._onDocumentLoaded.bind(this);
            window.addEventListener('load', this._onDocumentLoaded);
        }
    }
    /**
     * adds custom attributes to root span if configured
     */ _addCustomAttributesOnSpan(span, applyCustomAttributesOnSpan) {
        if (applyCustomAttributesOnSpan) (0, $b17aef886b8eab2d$export$fdff7e10f8ca069e)(()=>applyCustomAttributesOnSpan(span), (error)=>{
            if (!error) return;
            this._diag.error('addCustomAttributesOnSpan', error);
        }, true);
    }
    /**
     * adds custom attributes to span if configured
     */ _addCustomAttributesOnResourceSpan(span, resource, applyCustomAttributesOnSpan) {
        if (applyCustomAttributesOnSpan) (0, $b17aef886b8eab2d$export$fdff7e10f8ca069e)(()=>applyCustomAttributesOnSpan(span, resource), (error)=>{
            if (!error) return;
            this._diag.error('addCustomAttributesOnResourceSpan', error);
        }, true);
    }
    /**
     * implements enable function
     */ enable() {
        // remove previously attached load to avoid adding the same event twice
        // in case of multiple enable calling.
        window.removeEventListener('load', this._onDocumentLoaded);
        this._waitForPageLoad();
    }
    /**
     * implements disable function
     */ disable() {
        window.removeEventListener('load', this._onDocumentLoaded);
    }
}





/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Updates to this file should also be replicated to @opentelemetry/api too.
/**
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS implementation)
 * - <object> (When all else fails)
 */ /** only globals that common to node and browsers are allowed */ // eslint-disable-next-line n/no-unsupported-features/es-builtins, no-undef
const $5629ca04bdc27edd$export$5c524ddf7208c00c = typeof globalThis === 'object' ? globalThis : typeof self === 'object' ? self : typeof window === 'object' ? window : typeof $parcel$global === 'object' ? $parcel$global : {};



/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * https://github.com/open-telemetry/opentelemetry-specification/blob/master/specification/trace/semantic_conventions/http.md
 */ var $9502e9df635d3a51$export$668754fb61dd076c;
(function(AttributeNames) {
    AttributeNames["COMPONENT"] = "component";
    AttributeNames["HTTP_STATUS_TEXT"] = "http.status_text";
})($9502e9df635d3a51$export$668754fb61dd076c || ($9502e9df635d3a51$export$668754fb61dd076c = {}));


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * This file contains a copy of unstable semantic convention definitions
 * used by this package.
 * @see https://github.com/open-telemetry/opentelemetry-js/tree/main/semantic-conventions#unstable-semconv
 */ /**
 * Deprecated, use one of `server.address`, `client.address` or `http.request.header.host` instead, depending on the usage.
 *
 * @example www.example.org
 *
 * @experimental This attribute is experimental and is subject to breaking changes in minor releases of `@opentelemetry/semantic-conventions`.
 *
 * @deprecated Replaced by one of `server.address`, `client.address` or `http.request.header.host`, depending on the usage.
 */ const $89211b3553a1dfe2$export$15464108e35f33c4 = 'http.host';
const $89211b3553a1dfe2$export$cf26e21ee4664adb = 'http.method';
const $89211b3553a1dfe2$export$d65e4dc87162df0a = 'http.request.body.size';
const $89211b3553a1dfe2$export$3cbfc10a128d2cf7 = 'http.request_content_length_uncompressed';
const $89211b3553a1dfe2$export$237bc893b534cd8c = 'http.response_content_length';
const $89211b3553a1dfe2$export$2d7ebf68a433b0fd = 'http.scheme';
const $89211b3553a1dfe2$export$116a6efc1c017b7b = 'http.status_code';
const $89211b3553a1dfe2$export$13e2e9fdaf5f7c2d = 'http.url';
const $89211b3553a1dfe2$export$a4ba95edc60c8ef3 = 'http.user_agent';



/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Much of the logic here overlaps with the same utils file in opentelemetry-instrumentation-xml-http-request
// These may be unified in the future.


const $5f1c6c93862cb6b6$var$DIAG_LOGGER = $0006a4b399ea8ee4$export$c042e7c2f59bc046.createComponentLogger({
    namespace: '@opentelemetry/opentelemetry-instrumentation-fetch/utils'
});
function $5f1c6c93862cb6b6$export$71d292fa56cdb7b9(...args) {
    if (args[0] instanceof URL || typeof args[0] === 'string') {
        const requestInit = args[1];
        if (!requestInit?.body) return Promise.resolve();
        if (requestInit.body instanceof ReadableStream) {
            const { body: body, length: length } = $5f1c6c93862cb6b6$var$_getBodyNonDestructively(requestInit.body);
            requestInit.body = body;
            return length;
        } else return Promise.resolve($5f1c6c93862cb6b6$export$e6a57dee760266dc(requestInit.body));
    } else {
        const info = args[0];
        if (!info?.body) return Promise.resolve();
        return info.clone().text().then((t)=>$5f1c6c93862cb6b6$var$getByteLength(t));
    }
}
function $5f1c6c93862cb6b6$var$_getBodyNonDestructively(body) {
    // can't read a ReadableStream without destroying it
    // but we CAN pipe it through and return a new ReadableStream
    // some (older) platforms don't expose the pipeThrough method and in that scenario, we're out of luck;
    //   there's no way to read the stream without consuming it.
    if (!body.pipeThrough) {
        $5f1c6c93862cb6b6$var$DIAG_LOGGER.warn('Platform has ReadableStream but not pipeThrough!');
        return {
            body: body,
            length: Promise.resolve(undefined)
        };
    }
    let length = 0;
    let resolveLength;
    const lengthPromise = new Promise((resolve)=>{
        resolveLength = resolve;
    });
    const transform = new TransformStream({
        start () {},
        async transform (chunk, controller) {
            const bytearray = await chunk;
            length += bytearray.byteLength;
            controller.enqueue(chunk);
        },
        flush () {
            resolveLength(length);
        }
    });
    return {
        body: body.pipeThrough(transform),
        length: lengthPromise
    };
}
function $5f1c6c93862cb6b6$var$isDocument(value) {
    return typeof Document !== 'undefined' && value instanceof Document;
}
function $5f1c6c93862cb6b6$export$e6a57dee760266dc(body) {
    if ($5f1c6c93862cb6b6$var$isDocument(body)) return new XMLSerializer().serializeToString(document).length;
    // XMLHttpRequestBodyInit expands to the following:
    if (typeof body === 'string') return $5f1c6c93862cb6b6$var$getByteLength(body);
    if (body instanceof Blob) return body.size;
    if (body instanceof FormData) return $5f1c6c93862cb6b6$var$getFormDataSize(body);
    if (body instanceof URLSearchParams) return $5f1c6c93862cb6b6$var$getByteLength(body.toString());
    // ArrayBuffer | ArrayBufferView
    if (body.byteLength !== undefined) return body.byteLength;
    $5f1c6c93862cb6b6$var$DIAG_LOGGER.warn('unknown body type');
    return undefined;
}
const $5f1c6c93862cb6b6$var$TEXT_ENCODER = new TextEncoder();
function $5f1c6c93862cb6b6$var$getByteLength(s) {
    return $5f1c6c93862cb6b6$var$TEXT_ENCODER.encode(s).byteLength;
}
function $5f1c6c93862cb6b6$var$getFormDataSize(formData) {
    let size = 0;
    for (const [key, value] of formData.entries()){
        size += key.length;
        if (value instanceof Blob) size += value.size;
        else size += value.length;
    }
    return size;
}
function $5f1c6c93862cb6b6$export$873c02bc543800b4(method) {
    const knownMethods = $5f1c6c93862cb6b6$var$getKnownMethods();
    const methUpper = method.toUpperCase();
    if (methUpper in knownMethods) return methUpper;
    else return '_OTHER';
}
const $5f1c6c93862cb6b6$var$DEFAULT_KNOWN_METHODS = {
    CONNECT: true,
    DELETE: true,
    GET: true,
    HEAD: true,
    OPTIONS: true,
    PATCH: true,
    POST: true,
    PUT: true,
    TRACE: true
};
let $5f1c6c93862cb6b6$var$knownMethods;
function $5f1c6c93862cb6b6$var$getKnownMethods() {
    if ($5f1c6c93862cb6b6$var$knownMethods === undefined) {
        const cfgMethods = (0, $2904c97a66abe41f$export$a18720db12f89f06)('OTEL_INSTRUMENTATION_HTTP_KNOWN_METHODS');
        if (cfgMethods && cfgMethods.length > 0) {
            $5f1c6c93862cb6b6$var$knownMethods = {};
            cfgMethods.forEach((m)=>{
                $5f1c6c93862cb6b6$var$knownMethods[m] = true;
            });
        } else $5f1c6c93862cb6b6$var$knownMethods = $5f1c6c93862cb6b6$var$DEFAULT_KNOWN_METHODS;
    }
    return $5f1c6c93862cb6b6$var$knownMethods;
}
const $5f1c6c93862cb6b6$var$HTTP_PORT_FROM_PROTOCOL = {
    'https:': '443',
    'http:': '80'
};
function $5f1c6c93862cb6b6$export$ba627727eda86738(url) {
    const serverPort = Number(url.port || $5f1c6c93862cb6b6$var$HTTP_PORT_FROM_PROTOCOL[url.protocol]);
    // Guard with `if (serverPort)` because `Number('') === 0`.
    if (serverPort && !isNaN(serverPort)) return serverPort;
    else return undefined;
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // this is autogenerated file, see scripts/version-update.js
const $46f3e23479dacc5c$export$a4ad2735b021c132 = '0.208.0';


// how long to wait for observer to collect information about resources
// this is needed as event "load" is called before observer
// hard to say how long it should really wait, seems like 300ms is
// safe enough
const $de740098744fc8e9$var$OBSERVER_WAIT_TIME_MS = 300;
const $de740098744fc8e9$var$isNode = false;
class $de740098744fc8e9$export$f922a490458c98a8 extends (0, $671e8529d3469f36$export$436b1c2bf7e9756b) {
    component = 'fetch';
    version = (0, $46f3e23479dacc5c$export$a4ad2735b021c132);
    moduleName = this.component;
    _usedResources = new WeakSet();
    _tasksCount = 0;
    _semconvStability;
    constructor(config = {}){
        super('@opentelemetry/instrumentation-fetch', (0, $46f3e23479dacc5c$export$a4ad2735b021c132), config);
        this._semconvStability = (0, $358486a6f01822c1$export$f9fa4e140bcc07bb)('http', config?.semconvStabilityOptIn);
    }
    init() {}
    /**
     * Add cors pre flight child span
     * @param span
     * @param corsPreFlightRequest
     */ _addChildSpan(span, corsPreFlightRequest) {
        const childSpan = this.tracer.startSpan('CORS Preflight', {
            startTime: corsPreFlightRequest[$3e8831089012b6e0$export$74be52df2d6fd28c.FETCH_START]
        }, $496851d2cf78caa4$export$357889f174732d38.setSpan($0c57d9262090934c$export$a078c61943f9dbbe.active(), span));
        const skipOldSemconvContentLengthAttrs = !(this._semconvStability & (0, $358486a6f01822c1$export$38c181bcafcf2fa0).OLD);
        $0f094f3dcc7447ce$export$e2385716cf129455(childSpan, corsPreFlightRequest, this.getConfig().ignoreNetworkEvents, undefined, skipOldSemconvContentLengthAttrs);
        childSpan.end(corsPreFlightRequest[$3e8831089012b6e0$export$74be52df2d6fd28c.RESPONSE_END]);
    }
    /**
     * Adds more attributes to span just before ending it
     * @param span
     * @param response
     */ _addFinalSpanAttributes(span, response) {
        const parsedUrl = $0f094f3dcc7447ce$export$7a5253c0f62e0150(response.url);
        if (this._semconvStability & (0, $358486a6f01822c1$export$38c181bcafcf2fa0).OLD) {
            span.setAttribute((0, $89211b3553a1dfe2$export$116a6efc1c017b7b), response.status);
            if (response.statusText != null) span.setAttribute((0, $9502e9df635d3a51$export$668754fb61dd076c).HTTP_STATUS_TEXT, response.statusText);
            span.setAttribute((0, $89211b3553a1dfe2$export$15464108e35f33c4), parsedUrl.host);
            span.setAttribute((0, $89211b3553a1dfe2$export$2d7ebf68a433b0fd), parsedUrl.protocol.replace(':', ''));
            if (typeof navigator !== 'undefined') span.setAttribute((0, $89211b3553a1dfe2$export$a4ba95edc60c8ef3), navigator.userAgent);
        }
        if (this._semconvStability & (0, $358486a6f01822c1$export$38c181bcafcf2fa0).STABLE) {
            span.setAttribute((0, $3fcd7ea0f1087866$export$4f9cc9c1e7b4e832), response.status);
            // TODO: Set server.{address,port} at span creation for sampling decisions
            // (a "SHOULD" requirement in semconv).
            span.setAttribute((0, $3fcd7ea0f1087866$export$a5acaa0dbc823e02), parsedUrl.hostname);
            const serverPort = (0, $5f1c6c93862cb6b6$export$ba627727eda86738)(parsedUrl);
            if (serverPort) span.setAttribute((0, $3fcd7ea0f1087866$export$b7822882ad829476), serverPort);
        }
    }
    /**
     * Add headers
     * @param options
     * @param spanUrl
     */ _addHeaders(options, spanUrl) {
        if (!$0f094f3dcc7447ce$export$c6501d7e56a5b40a(spanUrl, this.getConfig().propagateTraceHeaderCorsUrls)) {
            const headers = {};
            $77955577000c938d$export$3e49040daa9dba20.inject($0c57d9262090934c$export$a078c61943f9dbbe.active(), headers);
            if (Object.keys(headers).length > 0) this._diag.debug('headers inject skipped due to CORS policy');
            return;
        }
        if (options instanceof Request) $77955577000c938d$export$3e49040daa9dba20.inject($0c57d9262090934c$export$a078c61943f9dbbe.active(), options.headers, {
            set: (h, k, v)=>h.set(k, typeof v === 'string' ? v : String(v))
        });
        else if (options.headers instanceof Headers) $77955577000c938d$export$3e49040daa9dba20.inject($0c57d9262090934c$export$a078c61943f9dbbe.active(), options.headers, {
            set: (h, k, v)=>h.set(k, typeof v === 'string' ? v : String(v))
        });
        else if (options.headers instanceof Map) $77955577000c938d$export$3e49040daa9dba20.inject($0c57d9262090934c$export$a078c61943f9dbbe.active(), options.headers, {
            set: (h, k, v)=>h.set(k, typeof v === 'string' ? v : String(v))
        });
        else {
            const headers = {};
            $77955577000c938d$export$3e49040daa9dba20.inject($0c57d9262090934c$export$a078c61943f9dbbe.active(), headers);
            options.headers = Object.assign({}, headers, options.headers || {});
        }
    }
    /**
     * Clears the resource timings and all resources assigned with spans
     *     when {@link FetchPluginConfig.clearTimingResources} is
     *     set to true (default false)
     * @private
     */ _clearResources() {
        if (this._tasksCount === 0 && this.getConfig().clearTimingResources) {
            performance.clearResourceTimings();
            this._usedResources = new WeakSet();
        }
    }
    /**
     * Creates a new span
     * @param url
     * @param options
     */ _createSpan(url, options = {}) {
        if ($3b8b64466dc61937$export$172b5a1c42a6f83d(url, this.getConfig().ignoreUrls)) {
            this._diag.debug('ignoring span as url matches ignored url');
            return;
        }
        let name = '';
        const attributes = {};
        if (this._semconvStability & (0, $358486a6f01822c1$export$38c181bcafcf2fa0).OLD) {
            const method = (options.method || 'GET').toUpperCase();
            name = `HTTP ${method}`;
            attributes[(0, $9502e9df635d3a51$export$668754fb61dd076c).COMPONENT] = this.moduleName;
            attributes[0, $89211b3553a1dfe2$export$cf26e21ee4664adb] = method;
            attributes[0, $89211b3553a1dfe2$export$13e2e9fdaf5f7c2d] = url;
        }
        if (this._semconvStability & (0, $358486a6f01822c1$export$38c181bcafcf2fa0).STABLE) {
            const origMethod = options.method;
            const normMethod = (0, $5f1c6c93862cb6b6$export$873c02bc543800b4)(options.method || 'GET');
            if (!name) // The "old" span name wins if emitting both old and stable semconv
            // ('http/dup').
            name = normMethod;
            attributes[0, $3fcd7ea0f1087866$export$c950c48d651d36f6] = normMethod;
            if (normMethod !== origMethod) attributes[0, $3fcd7ea0f1087866$export$b4706f4398125cd2] = origMethod;
            attributes[0, $3fcd7ea0f1087866$export$ef7da4fb774e8a84] = url;
        }
        return this.tracer.startSpan(name, {
            kind: $566044c3d0fbdc36$export$4da4ea8145910e8b.CLIENT,
            attributes: attributes
        });
    }
    /**
     * Finds appropriate resource and add network events to the span
     * @param span
     * @param resourcesObserver
     * @param endTime
     */ _findResourceAndAddNetworkEvents(span, resourcesObserver, endTime) {
        let resources = resourcesObserver.entries;
        if (!resources.length) {
            if (!performance.getEntriesByType) return;
            // fallback - either Observer is not available or it took longer
            // then OBSERVER_WAIT_TIME_MS and observer didn't collect enough
            // information
            resources = performance.getEntriesByType('resource');
        }
        const resource = $0f094f3dcc7447ce$export$cdcba7438a7553e8(resourcesObserver.spanUrl, resourcesObserver.startTime, endTime, resources, this._usedResources, 'fetch');
        if (resource.mainRequest) {
            const mainRequest = resource.mainRequest;
            this._markResourceAsUsed(mainRequest);
            const corsPreFlightRequest = resource.corsPreFlightRequest;
            if (corsPreFlightRequest) {
                this._addChildSpan(span, corsPreFlightRequest);
                this._markResourceAsUsed(corsPreFlightRequest);
            }
            const skipOldSemconvContentLengthAttrs = !(this._semconvStability & (0, $358486a6f01822c1$export$38c181bcafcf2fa0).OLD);
            $0f094f3dcc7447ce$export$e2385716cf129455(span, mainRequest, this.getConfig().ignoreNetworkEvents, undefined, skipOldSemconvContentLengthAttrs);
        }
    }
    /**
     * Marks certain [resource]{@link PerformanceResourceTiming} when information
     * from this is used to add events to span.
     * This is done to avoid reusing the same resource again for next span
     * @param resource
     */ _markResourceAsUsed(resource) {
        this._usedResources.add(resource);
    }
    /**
     * Finish span, add attributes, network events etc.
     * @param span
     * @param spanData
     * @param response
     */ _endSpan(span, spanData, response) {
        const endTime = $02ed3a94ae5b2eb2$export$e7ec5c82995537b1(Date.now());
        const performanceEndTime = $02ed3a94ae5b2eb2$export$24b3f7dcd2848fa8();
        this._addFinalSpanAttributes(span, response);
        if (this._semconvStability & (0, $358486a6f01822c1$export$38c181bcafcf2fa0).STABLE) // https://github.com/open-telemetry/semantic-conventions/blob/main/docs/http/http-spans.md#status
        {
            if (response.status >= 400) {
                span.setStatus({
                    code: $ed982b21ea27c702$export$1e28dd9b5d01db83.ERROR
                });
                span.setAttribute((0, $3fcd7ea0f1087866$export$27bc5d0fa190eb39), String(response.status));
            }
        }
        setTimeout(()=>{
            spanData.observer?.disconnect();
            this._findResourceAndAddNetworkEvents(span, spanData, performanceEndTime);
            this._tasksCount--;
            this._clearResources();
            span.end(endTime);
        }, $de740098744fc8e9$var$OBSERVER_WAIT_TIME_MS);
    }
    /**
     * Patches the constructor of fetch
     */ _patchConstructor() {
        return (original)=>{
            const plugin = this;
            return function patchConstructor(...args) {
                const self = this;
                const url = $0f094f3dcc7447ce$export$7a5253c0f62e0150(args[0] instanceof Request ? args[0].url : String(args[0])).href;
                const options = args[0] instanceof Request ? args[0] : args[1] || {};
                const createdSpan = plugin._createSpan(url, options);
                if (!createdSpan) return original.apply(this, args);
                const spanData = plugin._prepareSpanData(url);
                if (plugin.getConfig().measureRequestSize) (0, $5f1c6c93862cb6b6$export$71d292fa56cdb7b9)(...args).then((bodyLength)=>{
                    if (!bodyLength) return;
                    if (plugin._semconvStability & (0, $358486a6f01822c1$export$38c181bcafcf2fa0).OLD) createdSpan.setAttribute((0, $89211b3553a1dfe2$export$3cbfc10a128d2cf7), bodyLength);
                    if (plugin._semconvStability & (0, $358486a6f01822c1$export$38c181bcafcf2fa0).STABLE) createdSpan.setAttribute((0, $89211b3553a1dfe2$export$d65e4dc87162df0a), bodyLength);
                }).catch((error)=>{
                    plugin._diag.warn('getFetchBodyLength', error);
                });
                function endSpanOnError(span, error) {
                    plugin._applyAttributesAfterFetch(span, options, error);
                    plugin._endSpan(span, spanData, {
                        status: error.status || 0,
                        statusText: error.message,
                        url: url
                    });
                }
                function endSpanOnSuccess(span, response) {
                    plugin._applyAttributesAfterFetch(span, options, response);
                    if (response.status >= 200 && response.status < 400) plugin._endSpan(span, spanData, response);
                    else plugin._endSpan(span, spanData, {
                        status: response.status,
                        statusText: response.statusText,
                        url: url
                    });
                }
                function withCancelPropagation(body, readerClone) {
                    if (!body) return null;
                    const reader = body.getReader();
                    return new ReadableStream({
                        async pull (controller) {
                            try {
                                const { value: value, done: done } = await reader.read();
                                if (done) {
                                    reader.releaseLock();
                                    controller.close();
                                } else controller.enqueue(value);
                            } catch (err) {
                                controller.error(err);
                                reader.cancel(err).catch((_)=>{});
                                try {
                                    reader.releaseLock();
                                } catch  {
                                // Spec reference:
                                // https://streams.spec.whatwg.org/#default-reader-release-lock
                                //
                                // releaseLock() only throws if called on an invalid reader
                                // (i.e. reader.[[stream]] is undefined, meaning the lock is already released
                                // or the reader was never associated). In normal use this cannot happen.
                                // This catch is defensive only.
                                }
                            }
                        },
                        cancel (reason) {
                            readerClone.cancel(reason).catch((_)=>{});
                            return reader.cancel(reason);
                        }
                    });
                }
                function onSuccess(span, resolve, response) {
                    let proxiedResponse = null;
                    try {
                        // TODO: Switch to a consumer-driven model and drop `resClone`.
                        // Keeping eager consumption here to preserve current behavior and avoid breaking existing tests.
                        // Context: discussion in PR #5894 → https://github.com/open-telemetry/opentelemetry-js/pull/5894
                        const resClone = response.clone();
                        const body = resClone.body;
                        if (body) {
                            const reader = body.getReader();
                            const isNullBodyStatus = // 101 responses and protocol upgrading is handled internally by the browser
                            response.status === 204 || response.status === 205 || response.status === 304;
                            const wrappedBody = isNullBodyStatus ? null : withCancelPropagation(response.body, reader);
                            proxiedResponse = new Response(wrappedBody, {
                                status: response.status,
                                statusText: response.statusText,
                                headers: response.headers
                            });
                            const read = ()=>{
                                reader.read().then(({ done: done })=>{
                                    if (done) endSpanOnSuccess(span, response);
                                    else read();
                                }, (error)=>{
                                    endSpanOnError(span, error);
                                });
                            };
                            read();
                        } else // some older browsers don't have .body implemented
                        endSpanOnSuccess(span, response);
                    } finally{
                        resolve(proxiedResponse ?? response);
                    }
                }
                function onError(span, reject, error) {
                    try {
                        endSpanOnError(span, error);
                    } finally{
                        reject(error);
                    }
                }
                return new Promise((resolve, reject)=>{
                    return $0c57d9262090934c$export$a078c61943f9dbbe.with($496851d2cf78caa4$export$357889f174732d38.setSpan($0c57d9262090934c$export$a078c61943f9dbbe.active(), createdSpan), ()=>{
                        plugin._addHeaders(options, url);
                        plugin._callRequestHook(createdSpan, options);
                        plugin._tasksCount++;
                        return original.apply(self, options instanceof Request ? [
                            options
                        ] : [
                            url,
                            options
                        ]).then(onSuccess.bind(self, createdSpan, resolve), onError.bind(self, createdSpan, reject));
                    });
                });
            };
        };
    }
    _applyAttributesAfterFetch(span, request, result) {
        const applyCustomAttributesOnSpan = this.getConfig().applyCustomAttributesOnSpan;
        if (applyCustomAttributesOnSpan) (0, $b17aef886b8eab2d$export$fdff7e10f8ca069e)(()=>applyCustomAttributesOnSpan(span, request, result), (error)=>{
            if (!error) return;
            this._diag.error('applyCustomAttributesOnSpan', error);
        }, true);
    }
    _callRequestHook(span, request) {
        const requestHook = this.getConfig().requestHook;
        if (requestHook) (0, $b17aef886b8eab2d$export$fdff7e10f8ca069e)(()=>requestHook(span, request), (error)=>{
            if (!error) return;
            this._diag.error('requestHook', error);
        }, true);
    }
    /**
     * Prepares a span data - needed later for matching appropriate network
     *     resources
     * @param spanUrl
     */ _prepareSpanData(spanUrl) {
        const startTime = $02ed3a94ae5b2eb2$export$24b3f7dcd2848fa8();
        const entries = [];
        if (typeof PerformanceObserver !== 'function') return {
            entries: entries,
            startTime: startTime,
            spanUrl: spanUrl
        };
        const observer = new PerformanceObserver((list)=>{
            const perfObsEntries = list.getEntries();
            perfObsEntries.forEach((entry)=>{
                if (entry.initiatorType === 'fetch' && entry.name === spanUrl) entries.push(entry);
            });
        });
        observer.observe({
            entryTypes: [
                'resource'
            ]
        });
        return {
            entries: entries,
            observer: observer,
            startTime: startTime,
            spanUrl: spanUrl
        };
    }
    /**
     * implements enable function
     */ enable() {
        if ($de740098744fc8e9$var$isNode) {
            // Node.js v18+ *does* have a global `fetch()`, but this package does not
            // support instrumenting it.
            this._diag.warn("this instrumentation is intended for web usage only, it does not instrument Node.js's fetch()");
            return;
        }
        if ((0, $b17aef886b8eab2d$export$ec0fd572751979bc)(fetch)) {
            this._unwrap((0, $5629ca04bdc27edd$export$5c524ddf7208c00c), 'fetch');
            this._diag.debug('removing previous patch for constructor');
        }
        this._wrap((0, $5629ca04bdc27edd$export$5c524ddf7208c00c), 'fetch', this._patchConstructor());
    }
    /**
     * implements unpatch function
     */ disable() {
        if ($de740098744fc8e9$var$isNode) return;
        this._unwrap((0, $5629ca04bdc27edd$export$5c524ddf7208c00c), 'fetch');
        this._usedResources = new WeakSet();
    }
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /// <reference types="zone.js" />




/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $3cf9c1f13085a085$export$668754fb61dd076c;
(function(AttributeNames) {
    AttributeNames["EVENT_TYPE"] = "event_type";
    AttributeNames["TARGET_ELEMENT"] = "target_element";
    AttributeNames["TARGET_XPATH"] = "target_xpath";
    AttributeNames["HTTP_URL"] = "http.url";
})($3cf9c1f13085a085$export$668754fb61dd076c || ($3cf9c1f13085a085$export$668754fb61dd076c = {}));


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // this is autogenerated file, see scripts/version-update.js
const $6fe7fa98eadab011$export$4a03ffab3315ee34 = '0.53.0';
const $6fe7fa98eadab011$export$b8b9d90f9e5bd72b = '@opentelemetry/instrumentation-user-interaction';


const $2f2eba6eeb127827$var$ZONE_CONTEXT_KEY = 'OT_ZONE_CONTEXT';
const $2f2eba6eeb127827$var$EVENT_NAVIGATION_NAME = 'Navigation:';
const $2f2eba6eeb127827$var$DEFAULT_EVENT_NAMES = [
    'click'
];
function $2f2eba6eeb127827$var$defaultShouldPreventSpanCreation() {
    return false;
}
class $2f2eba6eeb127827$export$e96a40d3914620d1 extends (0, $671e8529d3469f36$export$436b1c2bf7e9756b) {
    version = (0, $6fe7fa98eadab011$export$4a03ffab3315ee34);
    moduleName = 'user-interaction';
    _spansData = new WeakMap();
    // for addEventListener/removeEventListener state
    _wrappedListeners = new WeakMap();
    // for event bubbling
    _eventsSpanMap = new WeakMap();
    _eventNames;
    _shouldPreventSpanCreation;
    constructor(config = {}){
        super((0, $6fe7fa98eadab011$export$b8b9d90f9e5bd72b), (0, $6fe7fa98eadab011$export$4a03ffab3315ee34), config);
        this._eventNames = new Set(config?.eventNames ?? $2f2eba6eeb127827$var$DEFAULT_EVENT_NAMES);
        this._shouldPreventSpanCreation = typeof config?.shouldPreventSpanCreation === 'function' ? config.shouldPreventSpanCreation : $2f2eba6eeb127827$var$defaultShouldPreventSpanCreation;
    }
    init() {}
    /**
     * This will check if last task was timeout and will save the time to
     * fix the user interaction when nothing happens
     * This timeout comes from xhr plugin which is needed to collect information
     * about last xhr main request from observer
     * @param task
     * @param span
     */ _checkForTimeout(task, span) {
        const spanData = this._spansData.get(span);
        if (spanData) {
            if (task.source === 'setTimeout') spanData.hrTimeLastTimeout = (0, $02ed3a94ae5b2eb2$export$24b3f7dcd2848fa8)();
            else if (task.source !== 'Promise.then' && task.source !== 'setTimeout') spanData.hrTimeLastTimeout = undefined;
        }
    }
    /**
     * Controls whether or not to create a span, based on the event type.
     */ _allowEventName(eventName) {
        return this._eventNames.has(eventName);
    }
    /**
     * Creates a new span
     * @param element
     * @param eventName
     * @param parentSpan
     */ _createSpan(element, eventName, parentSpan) {
        if (!(element instanceof HTMLElement)) return undefined;
        if (!element.getAttribute) return undefined;
        if (element.hasAttribute('disabled')) return undefined;
        if (!this._allowEventName(eventName)) return undefined;
        const xpath = (0, $0f094f3dcc7447ce$export$fabdebd274ccbd1c)(element, true);
        try {
            const span = this.tracer.startSpan(eventName, {
                attributes: {
                    [(0, $3cf9c1f13085a085$export$668754fb61dd076c).EVENT_TYPE]: eventName,
                    [(0, $3cf9c1f13085a085$export$668754fb61dd076c).TARGET_ELEMENT]: element.tagName,
                    [(0, $3cf9c1f13085a085$export$668754fb61dd076c).TARGET_XPATH]: xpath,
                    [(0, $3cf9c1f13085a085$export$668754fb61dd076c).HTTP_URL]: window.location.href
                }
            }, parentSpan ? $496851d2cf78caa4$export$357889f174732d38.setSpan($0c57d9262090934c$export$a078c61943f9dbbe.active(), parentSpan) : undefined);
            if (this._shouldPreventSpanCreation(eventName, element, span) === true) return undefined;
            this._spansData.set(span, {
                taskCount: 0
            });
            return span;
        } catch (e) {
            this._diag.error('failed to start create new user interaction span', e);
        }
        return undefined;
    }
    /**
     * Decrement number of tasks that left in zone,
     * This is needed to be able to end span when no more tasks left
     * @param span
     */ _decrementTask(span) {
        const spanData = this._spansData.get(span);
        if (spanData) {
            spanData.taskCount--;
            if (spanData.taskCount === 0) this._tryToEndSpan(span, spanData.hrTimeLastTimeout);
        }
    }
    /**
     * Return the current span
     * @param zone
     * @private
     */ _getCurrentSpan(zone) {
        const context = zone.get($2f2eba6eeb127827$var$ZONE_CONTEXT_KEY);
        if (context) return $496851d2cf78caa4$export$357889f174732d38.getSpan(context);
        return context;
    }
    /**
     * Increment number of tasks that are run within the same zone.
     *     This is needed to be able to end span when no more tasks left
     * @param span
     */ _incrementTask(span) {
        const spanData = this._spansData.get(span);
        if (spanData) spanData.taskCount++;
    }
    /**
     * Returns true iff we should use the patched callback; false if it's already been patched
     */ addPatchedListener(on, type, listener, wrappedListener) {
        let listener2Type = this._wrappedListeners.get(listener);
        if (!listener2Type) {
            listener2Type = new Map();
            this._wrappedListeners.set(listener, listener2Type);
        }
        let element2patched = listener2Type.get(type);
        if (!element2patched) {
            element2patched = new Map();
            listener2Type.set(type, element2patched);
        }
        if (element2patched.has(on)) return false;
        element2patched.set(on, wrappedListener);
        return true;
    }
    /**
     * Returns the patched version of the callback (or undefined)
     */ removePatchedListener(on, type, listener) {
        const listener2Type = this._wrappedListeners.get(listener);
        if (!listener2Type) return undefined;
        const element2patched = listener2Type.get(type);
        if (!element2patched) return undefined;
        const patched = element2patched.get(on);
        if (patched) {
            element2patched.delete(on);
            if (element2patched.size === 0) {
                listener2Type.delete(type);
                if (listener2Type.size === 0) this._wrappedListeners.delete(listener);
            }
        }
        return patched;
    }
    // utility method to deal with the Function|EventListener nature of addEventListener
    _invokeListener(listener, target, args) {
        if (typeof listener === 'function') return listener.apply(target, args);
        else return listener.handleEvent(args[0]);
    }
    /**
     * This patches the addEventListener of HTMLElement to be able to
     * auto instrument the click events
     * This is done when zone is not available
     */ _patchAddEventListener() {
        const plugin = this;
        return (original)=>{
            return function addEventListenerPatched(type, listener, useCapture) {
                // Forward calls with listener = null
                if (!listener) return original.call(this, type, listener, useCapture);
                // filter out null (typeof null === 'object')
                const once = useCapture && typeof useCapture === 'object' && useCapture.once;
                const patchedListener = function(...args) {
                    let parentSpan;
                    const event = args[0];
                    const target = event?.target;
                    if (event) parentSpan = plugin._eventsSpanMap.get(event);
                    if (once) plugin.removePatchedListener(this, type, listener);
                    const span = plugin._createSpan(target, type, parentSpan);
                    if (span) {
                        if (event) plugin._eventsSpanMap.set(event, span);
                        return $0c57d9262090934c$export$a078c61943f9dbbe.with($496851d2cf78caa4$export$357889f174732d38.setSpan($0c57d9262090934c$export$a078c61943f9dbbe.active(), span), ()=>{
                            const result = plugin._invokeListener(listener, this, args);
                            // no zone so end span immediately
                            span.end();
                            return result;
                        });
                    } else return plugin._invokeListener(listener, this, args);
                };
                if (plugin.addPatchedListener(this, type, listener, patchedListener)) return original.call(this, type, patchedListener, useCapture);
            };
        };
    }
    /**
     * This patches the removeEventListener of HTMLElement to handle the fact that
     * we patched the original callbacks
     * This is done when zone is not available
     */ _patchRemoveEventListener() {
        const plugin = this;
        return (original)=>{
            return function removeEventListenerPatched(type, listener, useCapture) {
                const wrappedListener = plugin.removePatchedListener(this, type, listener);
                if (wrappedListener) return original.call(this, type, wrappedListener, useCapture);
                else return original.call(this, type, listener, useCapture);
            };
        };
    }
    /**
     * Most browser provide event listener api via EventTarget in prototype chain.
     * Exception to this is IE 11 which has it on the prototypes closest to EventTarget:
     *
     * * - has addEventListener in IE
     * ** - has addEventListener in all other browsers
     * ! - missing in IE
     *
     * HTMLElement -> Element -> Node * -> EventTarget **! -> Object
     * Document -> Node * -> EventTarget **! -> Object
     * Window * -> WindowProperties ! -> EventTarget **! -> Object
     */ _getPatchableEventTargets() {
        return window.EventTarget ? [
            EventTarget.prototype
        ] : [
            Node.prototype,
            Window.prototype
        ];
    }
    /**
     * Patches the history api
     */ _patchHistoryApi() {
        this._unpatchHistoryApi();
        this._wrap(history, 'replaceState', this._patchHistoryMethod());
        this._wrap(history, 'pushState', this._patchHistoryMethod());
        this._wrap(history, 'back', this._patchHistoryMethod());
        this._wrap(history, 'forward', this._patchHistoryMethod());
        this._wrap(history, 'go', this._patchHistoryMethod());
    }
    /**
     * Patches the certain history api method
     */ _patchHistoryMethod() {
        const plugin = this;
        return (original)=>{
            return function patchHistoryMethod(...args) {
                const url = `${location.pathname}${location.hash}${location.search}`;
                const result = original.apply(this, args);
                const urlAfter = `${location.pathname}${location.hash}${location.search}`;
                if (url !== urlAfter) plugin._updateInteractionName(urlAfter);
                return result;
            };
        };
    }
    /**
     * unpatch the history api methods
     */ _unpatchHistoryApi() {
        if ((0, $b17aef886b8eab2d$export$ec0fd572751979bc)(history.replaceState)) this._unwrap(history, 'replaceState');
        if ((0, $b17aef886b8eab2d$export$ec0fd572751979bc)(history.pushState)) this._unwrap(history, 'pushState');
        if ((0, $b17aef886b8eab2d$export$ec0fd572751979bc)(history.back)) this._unwrap(history, 'back');
        if ((0, $b17aef886b8eab2d$export$ec0fd572751979bc)(history.forward)) this._unwrap(history, 'forward');
        if ((0, $b17aef886b8eab2d$export$ec0fd572751979bc)(history.go)) this._unwrap(history, 'go');
    }
    /**
     * Updates interaction span name
     * @param url
     */ _updateInteractionName(url) {
        const span = $496851d2cf78caa4$export$357889f174732d38.getSpan($0c57d9262090934c$export$a078c61943f9dbbe.active());
        if (span && typeof span.updateName === 'function') span.updateName(`${$2f2eba6eeb127827$var$EVENT_NAVIGATION_NAME} ${url}`);
    }
    /**
     * Patches zone cancel task - this is done to be able to correctly
     * decrement the number of remaining tasks
     */ _patchZoneCancelTask() {
        const plugin = this;
        return (original)=>{
            return function patchCancelTask(task) {
                const currentZone = Zone.current;
                const currentSpan = plugin._getCurrentSpan(currentZone);
                if (currentSpan && plugin._shouldCountTask(task, currentZone)) plugin._decrementTask(currentSpan);
                return original.call(this, task);
            };
        };
    }
    /**
     * Patches zone schedule task - this is done to be able to correctly
     * increment the number of tasks running within current zone but also to
     * save time in case of timeout running from xhr plugin when waiting for
     * main request from PerformanceResourceTiming
     */ _patchZoneScheduleTask() {
        const plugin = this;
        return (original)=>{
            return function patchScheduleTask(task) {
                const currentZone = Zone.current;
                const currentSpan = plugin._getCurrentSpan(currentZone);
                if (currentSpan && plugin._shouldCountTask(task, currentZone)) {
                    plugin._incrementTask(currentSpan);
                    plugin._checkForTimeout(task, currentSpan);
                }
                return original.call(this, task);
            };
        };
    }
    /**
     * Patches zone run task - this is done to be able to create a span when
     * user interaction starts
     * @private
     */ _patchZoneRunTask() {
        const plugin = this;
        return (original)=>{
            return function patchRunTask(task, applyThis, applyArgs) {
                const event = Array.isArray(applyArgs) && applyArgs[0] instanceof Event ? applyArgs[0] : undefined;
                const target = event?.target;
                let span;
                const activeZone = this;
                if (target) {
                    span = plugin._createSpan(target, task.eventName);
                    if (span) {
                        plugin._incrementTask(span);
                        return activeZone.run(()=>{
                            try {
                                return $0c57d9262090934c$export$a078c61943f9dbbe.with($496851d2cf78caa4$export$357889f174732d38.setSpan($0c57d9262090934c$export$a078c61943f9dbbe.active(), span), ()=>{
                                    const currentZone = Zone.current;
                                    task._zone = currentZone;
                                    return original.call(currentZone, task, applyThis, applyArgs);
                                });
                            } finally{
                                plugin._decrementTask(span);
                            }
                        });
                    }
                } else span = plugin._getCurrentSpan(activeZone);
                try {
                    return original.call(activeZone, task, applyThis, applyArgs);
                } finally{
                    if (span && plugin._shouldCountTask(task, activeZone)) plugin._decrementTask(span);
                }
            };
        };
    }
    /**
     * Decides if task should be counted.
     * @param task
     * @param currentZone
     * @private
     */ _shouldCountTask(task, currentZone) {
        if (task._zone) currentZone = task._zone;
        if (!currentZone || !task.data || task.data.isPeriodic) return false;
        const currentSpan = this._getCurrentSpan(currentZone);
        if (!currentSpan) return false;
        if (!this._spansData.get(currentSpan)) return false;
        return task.type === 'macroTask' || task.type === 'microTask';
    }
    /**
     * Will try to end span when such span still exists.
     * @param span
     * @param endTime
     * @private
     */ _tryToEndSpan(span, endTime) {
        if (span) {
            const spanData = this._spansData.get(span);
            if (spanData) {
                span.end(endTime);
                this._spansData.delete(span);
            }
        }
    }
    /**
     * implements enable function
     */ enable() {
        const ZoneWithPrototype = this._getZoneWithPrototype();
        this._diag.debug('applying patch to', this.moduleName, this.version, 'zone:', !!ZoneWithPrototype);
        if (ZoneWithPrototype) {
            if ((0, $b17aef886b8eab2d$export$ec0fd572751979bc)(ZoneWithPrototype.prototype.runTask)) {
                this._unwrap(ZoneWithPrototype.prototype, 'runTask');
                this._diag.debug('removing previous patch from method runTask');
            }
            if ((0, $b17aef886b8eab2d$export$ec0fd572751979bc)(ZoneWithPrototype.prototype.scheduleTask)) {
                this._unwrap(ZoneWithPrototype.prototype, 'scheduleTask');
                this._diag.debug('removing previous patch from method scheduleTask');
            }
            if ((0, $b17aef886b8eab2d$export$ec0fd572751979bc)(ZoneWithPrototype.prototype.cancelTask)) {
                this._unwrap(ZoneWithPrototype.prototype, 'cancelTask');
                this._diag.debug('removing previous patch from method cancelTask');
            }
            this._zonePatched = true;
            this._wrap(ZoneWithPrototype.prototype, 'runTask', this._patchZoneRunTask());
            this._wrap(ZoneWithPrototype.prototype, 'scheduleTask', this._patchZoneScheduleTask());
            this._wrap(ZoneWithPrototype.prototype, 'cancelTask', this._patchZoneCancelTask());
        } else {
            this._zonePatched = false;
            const targets = this._getPatchableEventTargets();
            targets.forEach((target)=>{
                if ((0, $b17aef886b8eab2d$export$ec0fd572751979bc)(target.addEventListener)) {
                    this._unwrap(target, 'addEventListener');
                    this._diag.debug('removing previous patch from method addEventListener');
                }
                if ((0, $b17aef886b8eab2d$export$ec0fd572751979bc)(target.removeEventListener)) {
                    this._unwrap(target, 'removeEventListener');
                    this._diag.debug('removing previous patch from method removeEventListener');
                }
                this._wrap(target, 'addEventListener', this._patchAddEventListener());
                this._wrap(target, 'removeEventListener', this._patchRemoveEventListener());
            });
        }
        this._patchHistoryApi();
    }
    /**
     * implements unpatch function
     */ disable() {
        const ZoneWithPrototype = this._getZoneWithPrototype();
        this._diag.debug('removing patch from', this.moduleName, this.version, 'zone:', !!ZoneWithPrototype);
        if (ZoneWithPrototype && this._zonePatched) {
            if ((0, $b17aef886b8eab2d$export$ec0fd572751979bc)(ZoneWithPrototype.prototype.runTask)) this._unwrap(ZoneWithPrototype.prototype, 'runTask');
            if ((0, $b17aef886b8eab2d$export$ec0fd572751979bc)(ZoneWithPrototype.prototype.scheduleTask)) this._unwrap(ZoneWithPrototype.prototype, 'scheduleTask');
            if ((0, $b17aef886b8eab2d$export$ec0fd572751979bc)(ZoneWithPrototype.prototype.cancelTask)) this._unwrap(ZoneWithPrototype.prototype, 'cancelTask');
        } else {
            const targets = this._getPatchableEventTargets();
            targets.forEach((target)=>{
                if ((0, $b17aef886b8eab2d$export$ec0fd572751979bc)(target.addEventListener)) this._unwrap(target, 'addEventListener');
                if ((0, $b17aef886b8eab2d$export$ec0fd572751979bc)(target.removeEventListener)) this._unwrap(target, 'removeEventListener');
            });
        }
        this._unpatchHistoryApi();
    }
    /**
     * returns Zone
     */ _getZoneWithPrototype() {
        const _window = window;
        return _window.Zone;
    }
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 




/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * This file contains a copy of unstable semantic convention definitions
 * used by this package.
 * @see https://github.com/open-telemetry/opentelemetry-js/tree/main/semantic-conventions#unstable-semconv
 */ /**
 * Deprecated, use one of `server.address`, `client.address` or `http.request.header.host` instead, depending on the usage.
 *
 * @example www.example.org
 *
 * @experimental This attribute is experimental and is subject to breaking changes in minor releases of `@opentelemetry/semantic-conventions`.
 *
 * @deprecated Replaced by one of `server.address`, `client.address` or `http.request.header.host`, depending on the usage.
 */ const $6f54230ccb5a0ba6$export$15464108e35f33c4 = 'http.host';
const $6f54230ccb5a0ba6$export$cf26e21ee4664adb = 'http.method';
const $6f54230ccb5a0ba6$export$d65e4dc87162df0a = 'http.request.body.size';
const $6f54230ccb5a0ba6$export$3cbfc10a128d2cf7 = 'http.request_content_length_uncompressed';
const $6f54230ccb5a0ba6$export$237bc893b534cd8c = 'http.response_content_length';
const $6f54230ccb5a0ba6$export$2d7ebf68a433b0fd = 'http.scheme';
const $6f54230ccb5a0ba6$export$116a6efc1c017b7b = 'http.status_code';
const $6f54230ccb5a0ba6$export$13e2e9fdaf5f7c2d = 'http.url';
const $6f54230ccb5a0ba6$export$a4ba95edc60c8ef3 = 'http.user_agent';


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $7d2220872b9b3d69$export$3fd36d65bf762270;
(function(EventNames) {
    EventNames["METHOD_OPEN"] = "open";
    EventNames["METHOD_SEND"] = "send";
    EventNames["EVENT_ABORT"] = "abort";
    EventNames["EVENT_ERROR"] = "error";
    EventNames["EVENT_LOAD"] = "loaded";
    EventNames["EVENT_TIMEOUT"] = "timeout";
})($7d2220872b9b3d69$export$3fd36d65bf762270 || ($7d2220872b9b3d69$export$3fd36d65bf762270 = {}));


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Much of the logic here overlaps with the same utils file in opentelemetry-instrumentation-fetch
// These may be unified in the future.


const $0650a511e6e67e3b$var$DIAG_LOGGER = $0006a4b399ea8ee4$export$c042e7c2f59bc046.createComponentLogger({
    namespace: '@opentelemetry/opentelemetry-instrumentation-xml-http-request/utils'
});
function $0650a511e6e67e3b$var$isDocument(value) {
    return typeof Document !== 'undefined' && value instanceof Document;
}
function $0650a511e6e67e3b$export$e6a57dee760266dc(body) {
    if ($0650a511e6e67e3b$var$isDocument(body)) return new XMLSerializer().serializeToString(document).length;
    // XMLHttpRequestBodyInit expands to the following:
    if (typeof body === 'string') return $0650a511e6e67e3b$var$getByteLength(body);
    if (body instanceof Blob) return body.size;
    if (body instanceof FormData) return $0650a511e6e67e3b$var$getFormDataSize(body);
    if (body instanceof URLSearchParams) return $0650a511e6e67e3b$var$getByteLength(body.toString());
    // ArrayBuffer | ArrayBufferView
    if (body.byteLength !== undefined) return body.byteLength;
    $0650a511e6e67e3b$var$DIAG_LOGGER.warn('unknown body type');
    return undefined;
}
const $0650a511e6e67e3b$var$TEXT_ENCODER = new TextEncoder();
function $0650a511e6e67e3b$var$getByteLength(s) {
    return $0650a511e6e67e3b$var$TEXT_ENCODER.encode(s).byteLength;
}
function $0650a511e6e67e3b$var$getFormDataSize(formData) {
    let size = 0;
    for (const [key, value] of formData.entries()){
        size += key.length;
        if (value instanceof Blob) size += value.size;
        else size += value.length;
    }
    return size;
}
function $0650a511e6e67e3b$export$873c02bc543800b4(method) {
    const knownMethods = $0650a511e6e67e3b$var$getKnownMethods();
    const methUpper = method.toUpperCase();
    if (methUpper in knownMethods) return methUpper;
    else return '_OTHER';
}
const $0650a511e6e67e3b$var$DEFAULT_KNOWN_METHODS = {
    CONNECT: true,
    DELETE: true,
    GET: true,
    HEAD: true,
    OPTIONS: true,
    PATCH: true,
    POST: true,
    PUT: true,
    TRACE: true
};
let $0650a511e6e67e3b$var$knownMethods;
function $0650a511e6e67e3b$var$getKnownMethods() {
    if ($0650a511e6e67e3b$var$knownMethods === undefined) {
        const cfgMethods = (0, $2904c97a66abe41f$export$a18720db12f89f06)('OTEL_INSTRUMENTATION_HTTP_KNOWN_METHODS');
        if (cfgMethods && cfgMethods.length > 0) {
            $0650a511e6e67e3b$var$knownMethods = {};
            cfgMethods.forEach((m)=>{
                $0650a511e6e67e3b$var$knownMethods[m] = true;
            });
        } else $0650a511e6e67e3b$var$knownMethods = $0650a511e6e67e3b$var$DEFAULT_KNOWN_METHODS;
    }
    return $0650a511e6e67e3b$var$knownMethods;
}
const $0650a511e6e67e3b$var$HTTP_PORT_FROM_PROTOCOL = {
    'https:': '443',
    'http:': '80'
};
function $0650a511e6e67e3b$export$ba627727eda86738(url) {
    const serverPort = Number(url.port || $0650a511e6e67e3b$var$HTTP_PORT_FROM_PROTOCOL[url.protocol]);
    // Guard with `if (serverPort)` because `Number('') === 0`.
    if (serverPort && !isNaN(serverPort)) return serverPort;
    else return undefined;
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // this is autogenerated file, see scripts/version-update.js
const $70159accea98df27$export$a4ad2735b021c132 = '0.208.0';


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * https://github.com/open-telemetry/opentelemetry-specification/blob/master/specification/trace/semantic_conventions/http.md
 */ var $668a1dc64f3caab6$export$668754fb61dd076c;
(function(AttributeNames) {
    AttributeNames["HTTP_STATUS_TEXT"] = "http.status_text";
})($668a1dc64f3caab6$export$668754fb61dd076c || ($668a1dc64f3caab6$export$668754fb61dd076c = {}));


// how long to wait for observer to collect information about resources
// this is needed as event "load" is called before observer
// hard to say how long it should really wait, seems like 300ms is
// safe enough
const $0986bd57d5a18290$var$OBSERVER_WAIT_TIME_MS = 300;
class $0986bd57d5a18290$export$35de81ee328d915e extends (0, $671e8529d3469f36$export$436b1c2bf7e9756b) {
    component = 'xml-http-request';
    version = (0, $70159accea98df27$export$a4ad2735b021c132);
    moduleName = this.component;
    _tasksCount = 0;
    _xhrMem = new WeakMap();
    _usedResources = new WeakSet();
    _semconvStability;
    constructor(config = {}){
        super('@opentelemetry/instrumentation-xml-http-request', (0, $70159accea98df27$export$a4ad2735b021c132), config);
        this._semconvStability = (0, $358486a6f01822c1$export$f9fa4e140bcc07bb)('http', config?.semconvStabilityOptIn);
    }
    init() {}
    /**
     * Adds custom headers to XMLHttpRequest
     * @param xhr
     * @param spanUrl
     * @private
     */ _addHeaders(xhr, spanUrl) {
        const url = (0, $0f094f3dcc7447ce$export$7a5253c0f62e0150)(spanUrl).href;
        if (!(0, $0f094f3dcc7447ce$export$c6501d7e56a5b40a)(url, this.getConfig().propagateTraceHeaderCorsUrls)) {
            const headers = {};
            $77955577000c938d$export$3e49040daa9dba20.inject($0c57d9262090934c$export$a078c61943f9dbbe.active(), headers);
            if (Object.keys(headers).length > 0) this._diag.debug('headers inject skipped due to CORS policy');
            return;
        }
        const headers = {};
        $77955577000c938d$export$3e49040daa9dba20.inject($0c57d9262090934c$export$a078c61943f9dbbe.active(), headers);
        Object.keys(headers).forEach((key)=>{
            xhr.setRequestHeader(key, String(headers[key]));
        });
    }
    /**
     * Add cors pre flight child span
     * @param span
     * @param corsPreFlightRequest
     * @private
     */ _addChildSpan(span, corsPreFlightRequest) {
        $0c57d9262090934c$export$a078c61943f9dbbe.with($496851d2cf78caa4$export$357889f174732d38.setSpan($0c57d9262090934c$export$a078c61943f9dbbe.active(), span), ()=>{
            const childSpan = this.tracer.startSpan('CORS Preflight', {
                startTime: corsPreFlightRequest[(0, $3e8831089012b6e0$export$74be52df2d6fd28c).FETCH_START]
            });
            const skipOldSemconvContentLengthAttrs = !(this._semconvStability & (0, $358486a6f01822c1$export$38c181bcafcf2fa0).OLD);
            (0, $0f094f3dcc7447ce$export$e2385716cf129455)(childSpan, corsPreFlightRequest, this.getConfig().ignoreNetworkEvents, undefined, skipOldSemconvContentLengthAttrs);
            childSpan.end(corsPreFlightRequest[(0, $3e8831089012b6e0$export$74be52df2d6fd28c).RESPONSE_END]);
        });
    }
    /**
     * Add attributes when span is going to end
     * @param span
     * @param xhr
     * @param spanUrl
     * @private
     */ _addFinalSpanAttributes(span, xhrMem, spanUrl) {
        if (this._semconvStability & (0, $358486a6f01822c1$export$38c181bcafcf2fa0).OLD) {
            if (xhrMem.status !== undefined) span.setAttribute((0, $6f54230ccb5a0ba6$export$116a6efc1c017b7b), xhrMem.status);
            if (xhrMem.statusText !== undefined) span.setAttribute((0, $668a1dc64f3caab6$export$668754fb61dd076c).HTTP_STATUS_TEXT, xhrMem.statusText);
            if (typeof spanUrl === 'string') {
                const parsedUrl = (0, $0f094f3dcc7447ce$export$7a5253c0f62e0150)(spanUrl);
                span.setAttribute((0, $6f54230ccb5a0ba6$export$15464108e35f33c4), parsedUrl.host);
                span.setAttribute((0, $6f54230ccb5a0ba6$export$2d7ebf68a433b0fd), parsedUrl.protocol.replace(':', ''));
            }
            // @TODO do we want to collect this or it will be collected earlier once only or
            //    maybe when parent span is not available ?
            span.setAttribute((0, $6f54230ccb5a0ba6$export$a4ba95edc60c8ef3), navigator.userAgent);
        }
        if (this._semconvStability & (0, $358486a6f01822c1$export$38c181bcafcf2fa0).STABLE) {
            if (xhrMem.status) // Intentionally exclude status=0, because XHR uses 0 for before a
            // response is received and semconv says to only add the attribute if
            // received a response.
            span.setAttribute((0, $3fcd7ea0f1087866$export$4f9cc9c1e7b4e832), xhrMem.status);
        }
    }
    _applyAttributesAfterXHR(span, xhr) {
        const applyCustomAttributesOnSpan = this.getConfig().applyCustomAttributesOnSpan;
        if (typeof applyCustomAttributesOnSpan === 'function') (0, $b17aef886b8eab2d$export$fdff7e10f8ca069e)(()=>applyCustomAttributesOnSpan(span, xhr), (error)=>{
            if (!error) return;
            this._diag.error('applyCustomAttributesOnSpan', error);
        }, true);
    }
    /**
     * will collect information about all resources created
     * between "send" and "end" with additional waiting for main resource
     * @param xhr
     * @param spanUrl
     * @private
     */ _addResourceObserver(xhr, spanUrl) {
        const xhrMem = this._xhrMem.get(xhr);
        if (!xhrMem || typeof PerformanceObserver !== 'function' || typeof PerformanceResourceTiming !== 'function') return;
        xhrMem.createdResources = {
            observer: new PerformanceObserver((list)=>{
                const entries = list.getEntries();
                const parsedUrl = (0, $0f094f3dcc7447ce$export$7a5253c0f62e0150)(spanUrl);
                entries.forEach((entry)=>{
                    if (entry.initiatorType === 'xmlhttprequest' && entry.name === parsedUrl.href) {
                        if (xhrMem.createdResources) xhrMem.createdResources.entries.push(entry);
                    }
                });
            }),
            entries: []
        };
        xhrMem.createdResources.observer.observe({
            entryTypes: [
                'resource'
            ]
        });
    }
    /**
     * Clears the resource timings and all resources assigned with spans
     *     when {@link XMLHttpRequestInstrumentationConfig.clearTimingResources} is
     *     set to true (default false)
     * @private
     */ _clearResources() {
        if (this._tasksCount === 0 && this.getConfig().clearTimingResources) {
            (0, $b5bb7b0fa6e48696$export$b22daef4119238cd).clearResourceTimings();
            this._xhrMem = new WeakMap();
            this._usedResources = new WeakSet();
        }
    }
    /**
     * Finds appropriate resource and add network events to the span
     * @param span
     */ _findResourceAndAddNetworkEvents(xhrMem, span, spanUrl, startTime, endTime) {
        if (!spanUrl || !startTime || !endTime || !xhrMem.createdResources) return;
        let resources = xhrMem.createdResources.entries;
        if (!resources || !resources.length) // fallback - either Observer is not available or it took longer
        // then OBSERVER_WAIT_TIME_MS and observer didn't collect enough
        // information
        // ts thinks this is the perf_hooks module, but it is the browser performance api
        resources = (0, $b5bb7b0fa6e48696$export$b22daef4119238cd).getEntriesByType('resource');
        const resource = (0, $0f094f3dcc7447ce$export$cdcba7438a7553e8)((0, $0f094f3dcc7447ce$export$7a5253c0f62e0150)(spanUrl).href, startTime, endTime, resources, this._usedResources);
        if (resource.mainRequest) {
            const mainRequest = resource.mainRequest;
            this._markResourceAsUsed(mainRequest);
            const corsPreFlightRequest = resource.corsPreFlightRequest;
            if (corsPreFlightRequest) {
                this._addChildSpan(span, corsPreFlightRequest);
                this._markResourceAsUsed(corsPreFlightRequest);
            }
            const skipOldSemconvContentLengthAttrs = !(this._semconvStability & (0, $358486a6f01822c1$export$38c181bcafcf2fa0).OLD);
            (0, $0f094f3dcc7447ce$export$e2385716cf129455)(span, mainRequest, this.getConfig().ignoreNetworkEvents, undefined, skipOldSemconvContentLengthAttrs);
        }
    }
    /**
     * Removes the previous information about span.
     * This might happened when the same xhr is used again.
     * @param xhr
     * @private
     */ _cleanPreviousSpanInformation(xhr) {
        const xhrMem = this._xhrMem.get(xhr);
        if (xhrMem) {
            const callbackToRemoveEvents = xhrMem.callbackToRemoveEvents;
            if (callbackToRemoveEvents) callbackToRemoveEvents();
            this._xhrMem.delete(xhr);
        }
    }
    /**
     * Creates a new span when method "open" is called
     * @param xhr
     * @param url
     * @param method
     * @private
     */ _createSpan(xhr, url, method) {
        if ((0, $3b8b64466dc61937$export$172b5a1c42a6f83d)(url, this.getConfig().ignoreUrls)) {
            this._diag.debug('ignoring span as url matches ignored url');
            return;
        }
        let name = '';
        const parsedUrl = (0, $0f094f3dcc7447ce$export$7a5253c0f62e0150)(url);
        const attributes = {};
        if (this._semconvStability & (0, $358486a6f01822c1$export$38c181bcafcf2fa0).OLD) {
            name = method.toUpperCase();
            attributes[0, $6f54230ccb5a0ba6$export$cf26e21ee4664adb] = method;
            attributes[0, $6f54230ccb5a0ba6$export$13e2e9fdaf5f7c2d] = parsedUrl.toString();
        }
        if (this._semconvStability & (0, $358486a6f01822c1$export$38c181bcafcf2fa0).STABLE) {
            const origMethod = method;
            const normMethod = (0, $0650a511e6e67e3b$export$873c02bc543800b4)(method);
            if (!name) // The "old" span name wins if emitting both old and stable semconv
            // ('http/dup').
            name = normMethod;
            attributes[0, $3fcd7ea0f1087866$export$c950c48d651d36f6] = normMethod;
            if (normMethod !== origMethod) attributes[0, $3fcd7ea0f1087866$export$b4706f4398125cd2] = origMethod;
            attributes[0, $3fcd7ea0f1087866$export$ef7da4fb774e8a84] = parsedUrl.toString();
            attributes[0, $3fcd7ea0f1087866$export$a5acaa0dbc823e02] = parsedUrl.hostname;
            const serverPort = (0, $0650a511e6e67e3b$export$ba627727eda86738)(parsedUrl);
            if (serverPort) attributes[0, $3fcd7ea0f1087866$export$b7822882ad829476] = serverPort;
        }
        const currentSpan = this.tracer.startSpan(name, {
            kind: $566044c3d0fbdc36$export$4da4ea8145910e8b.CLIENT,
            attributes: attributes
        });
        currentSpan.addEvent((0, $7d2220872b9b3d69$export$3fd36d65bf762270).METHOD_OPEN);
        this._cleanPreviousSpanInformation(xhr);
        this._xhrMem.set(xhr, {
            span: currentSpan,
            spanUrl: url
        });
        return currentSpan;
    }
    /**
     * Marks certain [resource]{@link PerformanceResourceTiming} when information
     * from this is used to add events to span.
     * This is done to avoid reusing the same resource again for next span
     * @param resource
     * @private
     */ _markResourceAsUsed(resource) {
        this._usedResources.add(resource);
    }
    /**
     * Patches the method open
     * @private
     */ _patchOpen() {
        return (original)=>{
            const plugin = this;
            return function patchOpen(...args) {
                const method = args[0];
                const url = args[1];
                plugin._createSpan(this, url, method);
                return original.apply(this, args);
            };
        };
    }
    /**
     * Patches the method send
     * @private
     */ _patchSend() {
        const plugin = this;
        function endSpanTimeout(eventName, xhrMem, performanceEndTime, endTime) {
            const callbackToRemoveEvents = xhrMem.callbackToRemoveEvents;
            if (typeof callbackToRemoveEvents === 'function') callbackToRemoveEvents();
            const { span: span, spanUrl: spanUrl, sendStartTime: sendStartTime } = xhrMem;
            if (span) {
                plugin._findResourceAndAddNetworkEvents(xhrMem, span, spanUrl, sendStartTime, performanceEndTime);
                span.addEvent(eventName, endTime);
                plugin._addFinalSpanAttributes(span, xhrMem, spanUrl);
                span.end(endTime);
                plugin._tasksCount--;
            }
            plugin._clearResources();
        }
        function endSpan(eventName, xhr, isError, errorType) {
            const xhrMem = plugin._xhrMem.get(xhr);
            if (!xhrMem) return;
            xhrMem.status = xhr.status;
            xhrMem.statusText = xhr.statusText;
            plugin._xhrMem.delete(xhr);
            if (xhrMem.span) {
                const span = xhrMem.span;
                plugin._applyAttributesAfterXHR(span, xhr);
                if (plugin._semconvStability & (0, $358486a6f01822c1$export$38c181bcafcf2fa0).STABLE) {
                    if (isError) {
                        if (errorType) {
                            span.setStatus({
                                code: $ed982b21ea27c702$export$1e28dd9b5d01db83.ERROR,
                                message: errorType
                            });
                            span.setAttribute((0, $3fcd7ea0f1087866$export$27bc5d0fa190eb39), errorType);
                        }
                    } else if (xhrMem.status && xhrMem.status >= 400) {
                        span.setStatus({
                            code: $ed982b21ea27c702$export$1e28dd9b5d01db83.ERROR
                        });
                        span.setAttribute((0, $3fcd7ea0f1087866$export$27bc5d0fa190eb39), String(xhrMem.status));
                    }
                }
            }
            const performanceEndTime = (0, $02ed3a94ae5b2eb2$export$24b3f7dcd2848fa8)();
            const endTime = Date.now();
            // the timeout is needed as observer doesn't have yet information
            // when event "load" is called. Also the time may differ depends on
            // browser and speed of computer
            setTimeout(()=>{
                endSpanTimeout(eventName, xhrMem, performanceEndTime, endTime);
            }, $0986bd57d5a18290$var$OBSERVER_WAIT_TIME_MS);
        }
        function onError() {
            endSpan((0, $7d2220872b9b3d69$export$3fd36d65bf762270).EVENT_ERROR, this, true, 'error');
        }
        function onAbort() {
            endSpan((0, $7d2220872b9b3d69$export$3fd36d65bf762270).EVENT_ABORT, this, false);
        }
        function onTimeout() {
            endSpan((0, $7d2220872b9b3d69$export$3fd36d65bf762270).EVENT_TIMEOUT, this, true, 'timeout');
        }
        function onLoad() {
            if (this.status < 299) endSpan((0, $7d2220872b9b3d69$export$3fd36d65bf762270).EVENT_LOAD, this, false);
            else endSpan((0, $7d2220872b9b3d69$export$3fd36d65bf762270).EVENT_ERROR, this, false);
        }
        function unregister(xhr) {
            xhr.removeEventListener('abort', onAbort);
            xhr.removeEventListener('error', onError);
            xhr.removeEventListener('load', onLoad);
            xhr.removeEventListener('timeout', onTimeout);
            const xhrMem = plugin._xhrMem.get(xhr);
            if (xhrMem) xhrMem.callbackToRemoveEvents = undefined;
        }
        return (original)=>{
            return function patchSend(...args) {
                const xhrMem = plugin._xhrMem.get(this);
                if (!xhrMem) return original.apply(this, args);
                const currentSpan = xhrMem.span;
                const spanUrl = xhrMem.spanUrl;
                if (currentSpan && spanUrl) {
                    if (plugin.getConfig().measureRequestSize && args?.[0]) {
                        const body = args[0];
                        const bodyLength = (0, $0650a511e6e67e3b$export$e6a57dee760266dc)(body);
                        if (bodyLength !== undefined) {
                            if (plugin._semconvStability & (0, $358486a6f01822c1$export$38c181bcafcf2fa0).OLD) currentSpan.setAttribute((0, $6f54230ccb5a0ba6$export$3cbfc10a128d2cf7), bodyLength);
                            if (plugin._semconvStability & (0, $358486a6f01822c1$export$38c181bcafcf2fa0).STABLE) currentSpan.setAttribute((0, $6f54230ccb5a0ba6$export$d65e4dc87162df0a), bodyLength);
                        }
                    }
                    $0c57d9262090934c$export$a078c61943f9dbbe.with($496851d2cf78caa4$export$357889f174732d38.setSpan($0c57d9262090934c$export$a078c61943f9dbbe.active(), currentSpan), ()=>{
                        plugin._tasksCount++;
                        xhrMem.sendStartTime = (0, $02ed3a94ae5b2eb2$export$24b3f7dcd2848fa8)();
                        currentSpan.addEvent((0, $7d2220872b9b3d69$export$3fd36d65bf762270).METHOD_SEND);
                        this.addEventListener('abort', onAbort);
                        this.addEventListener('error', onError);
                        this.addEventListener('load', onLoad);
                        this.addEventListener('timeout', onTimeout);
                        xhrMem.callbackToRemoveEvents = ()=>{
                            unregister(this);
                            if (xhrMem.createdResources) xhrMem.createdResources.observer.disconnect();
                        };
                        plugin._addHeaders(this, spanUrl);
                        plugin._addResourceObserver(this, spanUrl);
                    });
                }
                return original.apply(this, args);
            };
        };
    }
    /**
     * implements enable function
     */ enable() {
        this._diag.debug('applying patch to', this.moduleName, this.version);
        if ((0, $b17aef886b8eab2d$export$ec0fd572751979bc)(XMLHttpRequest.prototype.open)) {
            this._unwrap(XMLHttpRequest.prototype, 'open');
            this._diag.debug('removing previous patch from method open');
        }
        if ((0, $b17aef886b8eab2d$export$ec0fd572751979bc)(XMLHttpRequest.prototype.send)) {
            this._unwrap(XMLHttpRequest.prototype, 'send');
            this._diag.debug('removing previous patch from method send');
        }
        this._wrap(XMLHttpRequest.prototype, 'open', this._patchOpen());
        this._wrap(XMLHttpRequest.prototype, 'send', this._patchSend());
    }
    /**
     * implements disable function
     */ disable() {
        this._diag.debug('removing patch from', this.moduleName, this.version);
        this._unwrap(XMLHttpRequest.prototype, 'open');
        this._unwrap(XMLHttpRequest.prototype, 'send');
        this._tasksCount = 0;
        this._xhrMem = new WeakMap();
        this._usedResources = new WeakSet();
    }
}


const $a112618ca8699b5a$var$InstrumentationMap = {
    '@opentelemetry/instrumentation-document-load': (0, $f8d3747903d55f9c$export$381e8ef2e310d2c3),
    '@opentelemetry/instrumentation-fetch': (0, $de740098744fc8e9$export$f922a490458c98a8),
    '@opentelemetry/instrumentation-user-interaction': (0, $2f2eba6eeb127827$export$e96a40d3914620d1),
    '@opentelemetry/instrumentation-xml-http-request': (0, $0986bd57d5a18290$export$35de81ee328d915e)
};
function $a112618ca8699b5a$export$2b6a8cc738089ff9(inputConfigs = {}) {
    for (const name of Object.keys(inputConfigs))if (!Object.prototype.hasOwnProperty.call($a112618ca8699b5a$var$InstrumentationMap, name)) {
        (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).error(`Provided instrumentation name "${name}" not found`);
        continue;
    }
    const instrumentations = [];
    for (const name of Object.keys($a112618ca8699b5a$var$InstrumentationMap)){
        const Instance = $a112618ca8699b5a$var$InstrumentationMap[name];
        // Defaults are defined by the instrumentation itself
        const userConfig = inputConfigs[name] ?? {};
        if (userConfig.enabled === false) {
            (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).debug(`Disabling instrumentation for ${name}`);
            continue;
        }
        try {
            (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).debug(`Loading instrumentation for ${name}`);
            instrumentations.push(new Instance(userConfig));
        } catch (e) {
            (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).error(e);
        }
    }
    return instrumentations;
}




/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $ef6af0e9bef7148a$export$a756c21bf453f1b5 {
    _delegate;
    constructor(_delegate){
        this._delegate = _delegate;
    }
    /**
     * Export items.
     * @param items
     * @param resultCallback
     */ export(items, resultCallback) {
        this._delegate.export(items, resultCallback);
    }
    forceFlush() {
        return this._delegate.forceFlush();
    }
    shutdown() {
        return this._delegate.shutdown();
    }
}


function $9090c1a17d23b5ac$export$edd172c6c83c39cc(resource) {
    const result = {
        attributes: $9090c1a17d23b5ac$export$b6255b619acd6709(resource.attributes),
        droppedAttributesCount: 0
    };
    const schemaUrl = resource.schemaUrl;
    if (schemaUrl && schemaUrl !== '') result.schemaUrl = schemaUrl;
    return result;
}
function $9090c1a17d23b5ac$export$5a2377b8e90dd1bf(scope) {
    return {
        name: scope.name,
        version: scope.version
    };
}
function $9090c1a17d23b5ac$export$b6255b619acd6709(attributes) {
    return Object.keys(attributes).map((key)=>$9090c1a17d23b5ac$export$155f69accf533147(key, attributes[key]));
}
function $9090c1a17d23b5ac$export$155f69accf533147(key, value) {
    return {
        key: key,
        value: $9090c1a17d23b5ac$export$9544ab3c60b2d8ce(value)
    };
}
function $9090c1a17d23b5ac$export$9544ab3c60b2d8ce(value) {
    const t = typeof value;
    if (t === 'string') return {
        stringValue: value
    };
    if (t === 'number') {
        if (!Number.isInteger(value)) return {
            doubleValue: value
        };
        return {
            intValue: value
        };
    }
    if (t === 'boolean') return {
        boolValue: value
    };
    if (value instanceof Uint8Array) return {
        bytesValue: value
    };
    if (Array.isArray(value)) return {
        arrayValue: {
            values: value.map($9090c1a17d23b5ac$export$9544ab3c60b2d8ce)
        }
    };
    if (t === 'object' && value != null) return {
        kvlistValue: {
            values: Object.entries(value).map(([k, v])=>$9090c1a17d23b5ac$export$155f69accf533147(k, v))
        }
    };
    return {};
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $026bcd5069522885$var$intValue(charCode) {
    // 0-9
    if (charCode >= 48 && charCode <= 57) return charCode - 48;
    // a-f
    if (charCode >= 97 && charCode <= 102) return charCode - 87;
    // A-F
    return charCode - 55;
}
function $026bcd5069522885$export$f7e0d8803cecbdc0(hexStr) {
    const buf = new Uint8Array(hexStr.length / 2);
    let offset = 0;
    for(let i = 0; i < hexStr.length; i += 2){
        const hi = $026bcd5069522885$var$intValue(hexStr.charCodeAt(i));
        const lo = $026bcd5069522885$var$intValue(hexStr.charCodeAt(i + 1));
        buf[offset++] = hi << 4 | lo;
    }
    return buf;
}


function $3dd40681f773d237$export$93fd2c60d7ab39e5(hrTime) {
    const NANOSECONDS = BigInt(1000000000);
    return BigInt(Math.trunc(hrTime[0])) * NANOSECONDS + BigInt(Math.trunc(hrTime[1]));
}
function $3dd40681f773d237$export$25fa08d6f84e69de(value) {
    const low = Number(BigInt.asUintN(32, value));
    const high = Number(BigInt.asUintN(32, value >> BigInt(32)));
    return {
        low: low,
        high: high
    };
}
function $3dd40681f773d237$export$9aa1c44d160043e3(hrTime) {
    const nanos = $3dd40681f773d237$export$93fd2c60d7ab39e5(hrTime);
    return $3dd40681f773d237$export$25fa08d6f84e69de(nanos);
}
function $3dd40681f773d237$export$91e61e5f118af2ed(hrTime) {
    const nanos = $3dd40681f773d237$export$93fd2c60d7ab39e5(hrTime);
    return nanos.toString();
}
const $3dd40681f773d237$var$encodeTimestamp = typeof BigInt !== 'undefined' ? $3dd40681f773d237$export$91e61e5f118af2ed : (0, $02ed3a94ae5b2eb2$export$2d91441ae30ebcfc);
function $3dd40681f773d237$var$identity(value) {
    return value;
}
function $3dd40681f773d237$var$optionalHexToBinary(str) {
    if (str === undefined) return undefined;
    return (0, $026bcd5069522885$export$f7e0d8803cecbdc0)(str);
}
const $3dd40681f773d237$var$DEFAULT_ENCODER = {
    encodeHrTime: $3dd40681f773d237$export$9aa1c44d160043e3,
    encodeSpanContext: (0, $026bcd5069522885$export$f7e0d8803cecbdc0),
    encodeOptionalSpanContext: $3dd40681f773d237$var$optionalHexToBinary
};
function $3dd40681f773d237$export$2d50162b78680823(options) {
    if (options === undefined) return $3dd40681f773d237$var$DEFAULT_ENCODER;
    const useLongBits = options.useLongBits ?? true;
    const useHex = options.useHex ?? false;
    return {
        encodeHrTime: useLongBits ? $3dd40681f773d237$export$9aa1c44d160043e3 : $3dd40681f773d237$var$encodeTimestamp,
        encodeSpanContext: useHex ? $3dd40681f773d237$var$identity : (0, $026bcd5069522885$export$f7e0d8803cecbdc0),
        encodeOptionalSpanContext: useHex ? $3dd40681f773d237$var$identity : $3dd40681f773d237$var$optionalHexToBinary
    };
}


// Span flags constants matching the OTLP specification
const $bafc9bb3ebf00c5f$var$SPAN_FLAGS_CONTEXT_HAS_IS_REMOTE_MASK = 0x100;
const $bafc9bb3ebf00c5f$var$SPAN_FLAGS_CONTEXT_IS_REMOTE_MASK = 0x200;
/**
 * Builds the 32-bit span flags value combining the low 8-bit W3C TraceFlags
 * with the HAS_IS_REMOTE and IS_REMOTE bits according to the OTLP spec.
 */ function $bafc9bb3ebf00c5f$var$buildSpanFlagsFrom(traceFlags, isRemote) {
    // low 8 bits are W3C TraceFlags (e.g., sampled)
    let flags = traceFlags & 0xff | $bafc9bb3ebf00c5f$var$SPAN_FLAGS_CONTEXT_HAS_IS_REMOTE_MASK;
    if (isRemote) flags |= $bafc9bb3ebf00c5f$var$SPAN_FLAGS_CONTEXT_IS_REMOTE_MASK;
    return flags;
}
function $bafc9bb3ebf00c5f$export$8c81c8011901e012(span, encoder) {
    const ctx = span.spanContext();
    const status = span.status;
    const parentSpanId = span.parentSpanContext?.spanId ? encoder.encodeSpanContext(span.parentSpanContext?.spanId) : undefined;
    return {
        traceId: encoder.encodeSpanContext(ctx.traceId),
        spanId: encoder.encodeSpanContext(ctx.spanId),
        parentSpanId: parentSpanId,
        traceState: ctx.traceState?.serialize(),
        name: span.name,
        // Span kind is offset by 1 because the API does not define a value for unset
        kind: span.kind == null ? 0 : span.kind + 1,
        startTimeUnixNano: encoder.encodeHrTime(span.startTime),
        endTimeUnixNano: encoder.encodeHrTime(span.endTime),
        attributes: (0, $9090c1a17d23b5ac$export$b6255b619acd6709)(span.attributes),
        droppedAttributesCount: span.droppedAttributesCount,
        events: span.events.map((event)=>$bafc9bb3ebf00c5f$export$c0221297e49388cc(event, encoder)),
        droppedEventsCount: span.droppedEventsCount,
        status: {
            // API and proto enums share the same values
            code: status.code,
            message: status.message
        },
        links: span.links.map((link)=>$bafc9bb3ebf00c5f$export$d40a678c50e6f4f2(link, encoder)),
        droppedLinksCount: span.droppedLinksCount,
        flags: $bafc9bb3ebf00c5f$var$buildSpanFlagsFrom(ctx.traceFlags, span.parentSpanContext?.isRemote)
    };
}
function $bafc9bb3ebf00c5f$export$d40a678c50e6f4f2(link, encoder) {
    return {
        attributes: link.attributes ? (0, $9090c1a17d23b5ac$export$b6255b619acd6709)(link.attributes) : [],
        spanId: encoder.encodeSpanContext(link.context.spanId),
        traceId: encoder.encodeSpanContext(link.context.traceId),
        traceState: link.context.traceState?.serialize(),
        droppedAttributesCount: link.droppedAttributesCount || 0,
        flags: $bafc9bb3ebf00c5f$var$buildSpanFlagsFrom(link.context.traceFlags, link.context.isRemote)
    };
}
function $bafc9bb3ebf00c5f$export$c0221297e49388cc(timedEvent, encoder) {
    return {
        attributes: timedEvent.attributes ? (0, $9090c1a17d23b5ac$export$b6255b619acd6709)(timedEvent.attributes) : [],
        name: timedEvent.name,
        timeUnixNano: encoder.encodeHrTime(timedEvent.time),
        droppedAttributesCount: timedEvent.droppedAttributesCount || 0
    };
}
function $bafc9bb3ebf00c5f$export$4bd5e67fadfa9fe0(spans, options) {
    const encoder = (0, $3dd40681f773d237$export$2d50162b78680823)(options);
    return {
        resourceSpans: $bafc9bb3ebf00c5f$var$spanRecordsToResourceSpans(spans, encoder)
    };
}
function $bafc9bb3ebf00c5f$var$createResourceMap(readableSpans) {
    const resourceMap = new Map();
    for (const record of readableSpans){
        let ilsMap = resourceMap.get(record.resource);
        if (!ilsMap) {
            ilsMap = new Map();
            resourceMap.set(record.resource, ilsMap);
        }
        // TODO this is duplicated in basic tracer. Consolidate on a common helper in core
        const instrumentationScopeKey = `${record.instrumentationScope.name}@${record.instrumentationScope.version || ''}:${record.instrumentationScope.schemaUrl || ''}`;
        let records = ilsMap.get(instrumentationScopeKey);
        if (!records) {
            records = [];
            ilsMap.set(instrumentationScopeKey, records);
        }
        records.push(record);
    }
    return resourceMap;
}
function $bafc9bb3ebf00c5f$var$spanRecordsToResourceSpans(readableSpans, encoder) {
    const resourceMap = $bafc9bb3ebf00c5f$var$createResourceMap(readableSpans);
    const out = [];
    const entryIterator = resourceMap.entries();
    let entry = entryIterator.next();
    while(!entry.done){
        const [resource, ilmMap] = entry.value;
        const scopeResourceSpans = [];
        const ilmIterator = ilmMap.values();
        let ilmEntry = ilmIterator.next();
        while(!ilmEntry.done){
            const scopeSpans = ilmEntry.value;
            if (scopeSpans.length > 0) {
                const spans = scopeSpans.map((readableSpan)=>$bafc9bb3ebf00c5f$export$8c81c8011901e012(readableSpan, encoder));
                scopeResourceSpans.push({
                    scope: (0, $9090c1a17d23b5ac$export$5a2377b8e90dd1bf)(scopeSpans[0].instrumentationScope),
                    spans: spans,
                    schemaUrl: scopeSpans[0].instrumentationScope.schemaUrl
                });
            }
            ilmEntry = ilmIterator.next();
        }
        const processedResource = (0, $9090c1a17d23b5ac$export$edd172c6c83c39cc)(resource);
        const transformedSpans = {
            resource: processedResource,
            scopeSpans: scopeResourceSpans,
            schemaUrl: processedResource.schemaUrl
        };
        out.push(transformedSpans);
        entry = entryIterator.next();
    }
    return out;
}


const $604be5f4b909e111$export$dfba2b8376f2d3f5 = {
    serializeRequest: (arg)=>{
        const request = (0, $bafc9bb3ebf00c5f$export$4bd5e67fadfa9fe0)(arg, {
            useHex: true,
            useLongBits: false
        });
        const encoder = new TextEncoder();
        return encoder.encode(JSON.stringify(request));
    },
    deserializeResponse: (arg)=>{
        if (arg.length === 0) return {};
        const decoder = new TextDecoder();
        return JSON.parse(decoder.decode(arg));
    }
};


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $13990a785eb19d49$var$MAX_ATTEMPTS = 5;
const $13990a785eb19d49$var$INITIAL_BACKOFF = 1000;
const $13990a785eb19d49$var$MAX_BACKOFF = 5000;
const $13990a785eb19d49$var$BACKOFF_MULTIPLIER = 1.5;
const $13990a785eb19d49$var$JITTER = 0.2;
/**
 * Get a pseudo-random jitter that falls in the range of [-JITTER, +JITTER]
 */ function $13990a785eb19d49$var$getJitter() {
    return Math.random() * (2 * $13990a785eb19d49$var$JITTER) - $13990a785eb19d49$var$JITTER;
}
class $13990a785eb19d49$var$RetryingTransport {
    _transport;
    constructor(_transport){
        this._transport = _transport;
    }
    retry(data, timeoutMillis, inMillis) {
        return new Promise((resolve, reject)=>{
            setTimeout(()=>{
                this._transport.send(data, timeoutMillis).then(resolve, reject);
            }, inMillis);
        });
    }
    async send(data, timeoutMillis) {
        const deadline = Date.now() + timeoutMillis;
        let result = await this._transport.send(data, timeoutMillis);
        let attempts = $13990a785eb19d49$var$MAX_ATTEMPTS;
        let nextBackoff = $13990a785eb19d49$var$INITIAL_BACKOFF;
        while(result.status === 'retryable' && attempts > 0){
            attempts--;
            // use maximum of computed backoff and 0 to avoid negative timeouts
            const backoff = Math.max(Math.min(nextBackoff, $13990a785eb19d49$var$MAX_BACKOFF) + $13990a785eb19d49$var$getJitter(), 0);
            nextBackoff = nextBackoff * $13990a785eb19d49$var$BACKOFF_MULTIPLIER;
            const retryInMillis = result.retryInMillis ?? backoff;
            // return when expected retry time is after the export deadline.
            const remainingTimeoutMillis = deadline - Date.now();
            if (retryInMillis > remainingTimeoutMillis) return result;
            result = await this.retry(data, remainingTimeoutMillis, retryInMillis);
        }
        return result;
    }
    shutdown() {
        return this._transport.shutdown();
    }
}
function $13990a785eb19d49$export$2a8528aedd03b24e(options) {
    return new $13990a785eb19d49$var$RetryingTransport(options.transport);
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $958bc8fb5bc50350$export$bc409a649b31360b(statusCode) {
    const retryCodes = [
        429,
        502,
        503,
        504
    ];
    return retryCodes.includes(statusCode);
}
function $958bc8fb5bc50350$export$4e009558974ad065(retryAfter) {
    if (retryAfter == null) return undefined;
    const seconds = Number.parseInt(retryAfter, 10);
    if (Number.isInteger(seconds)) return seconds > 0 ? seconds * 1000 : -1;
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Retry-After#directives
    const delay = new Date(retryAfter).getTime() - Date.now();
    if (delay >= 0) return delay;
    return 0;
}


class $fcc0e488dae9c036$var$XhrTransport {
    _parameters;
    constructor(_parameters){
        this._parameters = _parameters;
    }
    async send(data, timeoutMillis) {
        const headers = await this._parameters.headers();
        const response = await new Promise((resolve)=>{
            const xhr = new XMLHttpRequest();
            xhr.timeout = timeoutMillis;
            xhr.open('POST', this._parameters.url);
            Object.entries(headers).forEach(([k, v])=>{
                xhr.setRequestHeader(k, v);
            });
            xhr.ontimeout = (_)=>{
                resolve({
                    status: 'failure',
                    error: new Error('XHR request timed out')
                });
            };
            xhr.onreadystatechange = ()=>{
                if (xhr.status >= 200 && xhr.status <= 299) {
                    (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).debug('XHR success');
                    resolve({
                        status: 'success'
                    });
                } else if (xhr.status && (0, $958bc8fb5bc50350$export$bc409a649b31360b)(xhr.status)) resolve({
                    status: 'retryable',
                    retryInMillis: (0, $958bc8fb5bc50350$export$4e009558974ad065)(xhr.getResponseHeader('Retry-After'))
                });
                else if (xhr.status !== 0) resolve({
                    status: 'failure',
                    error: new Error('XHR request failed with non-retryable status')
                });
            };
            xhr.onabort = ()=>{
                resolve({
                    status: 'failure',
                    error: new Error('XHR request aborted')
                });
            };
            xhr.onerror = ()=>{
                resolve({
                    status: 'failure',
                    error: new Error('XHR request errored')
                });
            };
            xhr.send(data);
        });
        return response;
    }
    shutdown() {
    // Intentionally left empty, nothing to do.
    }
}
function $fcc0e488dae9c036$export$8ab960d599ca0ecc(parameters) {
    return new $fcc0e488dae9c036$var$XhrTransport(parameters);
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
class $5cf098f56601da02$var$SendBeaconTransport {
    _params;
    constructor(_params){
        this._params = _params;
    }
    async send(data) {
        const blobType = (await this._params.headers())['Content-Type'];
        return new Promise((resolve)=>{
            if (navigator.sendBeacon(this._params.url, new Blob([
                data
            ], {
                type: blobType
            }))) {
                // no way to signal retry, treat everything as success
                (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).debug('SendBeacon success');
                resolve({
                    status: 'success'
                });
            } else resolve({
                status: 'failure',
                error: new Error('SendBeacon failed')
            });
        });
    }
    shutdown() {
    // Intentionally left empty, nothing to do.
    }
}
function $5cf098f56601da02$export$ef075750bfec2f31(parameters) {
    return new $5cf098f56601da02$var$SendBeaconTransport(parameters);
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $685a2db24d35f739$var$BoundedQueueExportPromiseHandler {
    _concurrencyLimit;
    _sendingPromises = [];
    /**
     * @param concurrencyLimit maximum promises allowed in a queue at the same time.
     */ constructor(concurrencyLimit){
        this._concurrencyLimit = concurrencyLimit;
    }
    pushPromise(promise) {
        if (this.hasReachedLimit()) throw new Error('Concurrency Limit reached');
        this._sendingPromises.push(promise);
        const popPromise = ()=>{
            const index = this._sendingPromises.indexOf(promise);
            this._sendingPromises.splice(index, 1);
        };
        promise.then(popPromise, popPromise);
    }
    hasReachedLimit() {
        return this._sendingPromises.length >= this._concurrencyLimit;
    }
    async awaitAll() {
        await Promise.all(this._sendingPromises);
    }
}
function $685a2db24d35f739$export$1de3d1a6b8cb6545(options) {
    return new $685a2db24d35f739$var$BoundedQueueExportPromiseHandler(options.concurrencyLimit);
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $f3cb0785acfa889d$export$ee0fe4df4ef0f3a1;
(function(ExportResultCode) {
    ExportResultCode[ExportResultCode["SUCCESS"] = 0] = "SUCCESS";
    ExportResultCode[ExportResultCode["FAILED"] = 1] = "FAILED";
})($f3cb0785acfa889d$export$ee0fe4df4ef0f3a1 || ($f3cb0785acfa889d$export$ee0fe4df4ef0f3a1 = {}));


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface for handling error
 */ class $7aabbb86f45ea095$export$26c718c16cda30c6 extends Error {
    code;
    name = 'OTLPExporterError';
    data;
    constructor(message, code, data){
        super(message);
        this.data = data;
        this.code = code;
    }
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
function $09b0270c3bf87ff5$var$isPartialSuccessResponse(response) {
    return Object.prototype.hasOwnProperty.call(response, 'partialSuccess');
}
function $09b0270c3bf87ff5$export$b6a88465884baecf() {
    return {
        handleResponse (response) {
            // Partial success MUST never be an empty object according the specification
            // see https://opentelemetry.io/docs/specs/otlp/#partial-success
            if (response == null || !$09b0270c3bf87ff5$var$isPartialSuccessResponse(response) || response.partialSuccess == null || Object.keys(response.partialSuccess).length === 0) return;
            (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).warn('Received Partial Success response:', JSON.stringify(response.partialSuccess));
        }
    };
}



class $bc097abe1f02f34c$var$OTLPExportDelegate {
    _transport;
    _serializer;
    _responseHandler;
    _promiseQueue;
    _timeout;
    _diagLogger;
    constructor(_transport, _serializer, _responseHandler, _promiseQueue, _timeout){
        this._transport = _transport;
        this._serializer = _serializer;
        this._responseHandler = _responseHandler;
        this._promiseQueue = _promiseQueue;
        this._timeout = _timeout;
        this._diagLogger = (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).createComponentLogger({
            namespace: 'OTLPExportDelegate'
        });
    }
    export(internalRepresentation, resultCallback) {
        this._diagLogger.debug('items to be sent', internalRepresentation);
        // don't do any work if too many exports are in progress.
        if (this._promiseQueue.hasReachedLimit()) {
            resultCallback({
                code: (0, $f3cb0785acfa889d$export$ee0fe4df4ef0f3a1).FAILED,
                error: new Error('Concurrent export limit reached')
            });
            return;
        }
        const serializedRequest = this._serializer.serializeRequest(internalRepresentation);
        if (serializedRequest == null) {
            resultCallback({
                code: (0, $f3cb0785acfa889d$export$ee0fe4df4ef0f3a1).FAILED,
                error: new Error('Nothing to send')
            });
            return;
        }
        this._promiseQueue.pushPromise(this._transport.send(serializedRequest, this._timeout).then((response)=>{
            if (response.status === 'success') {
                if (response.data != null) try {
                    this._responseHandler.handleResponse(this._serializer.deserializeResponse(response.data));
                } catch (e) {
                    this._diagLogger.warn('Export succeeded but could not deserialize response - is the response specification compliant?', e, response.data);
                }
                // No matter the response, we can consider the export still successful.
                resultCallback({
                    code: (0, $f3cb0785acfa889d$export$ee0fe4df4ef0f3a1).SUCCESS
                });
                return;
            } else if (response.status === 'failure' && response.error) {
                resultCallback({
                    code: (0, $f3cb0785acfa889d$export$ee0fe4df4ef0f3a1).FAILED,
                    error: response.error
                });
                return;
            } else if (response.status === 'retryable') resultCallback({
                code: (0, $f3cb0785acfa889d$export$ee0fe4df4ef0f3a1).FAILED,
                error: new (0, $7aabbb86f45ea095$export$26c718c16cda30c6)('Export failed with retryable status')
            });
            else resultCallback({
                code: (0, $f3cb0785acfa889d$export$ee0fe4df4ef0f3a1).FAILED,
                error: new (0, $7aabbb86f45ea095$export$26c718c16cda30c6)('Export failed with unknown error')
            });
        }, (reason)=>resultCallback({
                code: (0, $f3cb0785acfa889d$export$ee0fe4df4ef0f3a1).FAILED,
                error: reason
            })));
    }
    forceFlush() {
        return this._promiseQueue.awaitAll();
    }
    async shutdown() {
        this._diagLogger.debug('shutdown started');
        await this.forceFlush();
        this._transport.shutdown();
    }
}
function $bc097abe1f02f34c$export$40ae898156a6d951(components, settings) {
    return new $bc097abe1f02f34c$var$OTLPExportDelegate(components.transport, components.serializer, (0, $09b0270c3bf87ff5$export$b6a88465884baecf)(), components.promiseHandler, settings.timeout);
}


function $be797e04b4adb295$export$8874016870239da4(options, serializer, transport) {
    return (0, $bc097abe1f02f34c$export$40ae898156a6d951)({
        transport: transport,
        serializer: serializer,
        promiseHandler: (0, $685a2db24d35f739$export$1de3d1a6b8cb6545)(options)
    }, {
        timeout: options.timeoutMillis
    });
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

class $5407df0f70753998$var$FetchTransport {
    _parameters;
    constructor(_parameters){
        this._parameters = _parameters;
    }
    async send(data, timeoutMillis) {
        const abortController = new AbortController();
        const timeout = setTimeout(()=>abortController.abort(), timeoutMillis);
        try {
            const isBrowserEnvironment = !!globalThis.location;
            const url = new URL(this._parameters.url);
            const response = await fetch(url.href, {
                method: 'POST',
                headers: await this._parameters.headers(),
                body: data,
                signal: abortController.signal,
                keepalive: isBrowserEnvironment,
                mode: isBrowserEnvironment ? globalThis.location?.origin === url.origin ? 'same-origin' : 'cors' : 'no-cors'
            });
            if (response.status >= 200 && response.status <= 299) {
                (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).debug('response success');
                return {
                    status: 'success'
                };
            } else if ((0, $958bc8fb5bc50350$export$bc409a649b31360b)(response.status)) {
                const retryAfter = response.headers.get('Retry-After');
                const retryInMillis = (0, $958bc8fb5bc50350$export$4e009558974ad065)(retryAfter);
                return {
                    status: 'retryable',
                    retryInMillis: retryInMillis
                };
            }
            return {
                status: 'failure',
                error: new Error('Fetch request failed with non-retryable status')
            };
        } catch (error) {
            if (error?.name === 'AbortError') return {
                status: 'failure',
                error: new Error('Fetch request timed out', {
                    cause: error
                })
            };
            return {
                status: 'failure',
                error: new Error('Fetch request errored', {
                    cause: error
                })
            };
        } finally{
            clearTimeout(timeout);
        }
    }
    shutdown() {
    // Intentionally left empty, nothing to do.
    }
}
function $5407df0f70753998$export$9e4ae37cd458911c(parameters) {
    return new $5407df0f70753998$var$FetchTransport(parameters);
}


function $d4018dbe2131893d$export$f1ed08af29ca92a7(options, serializer) {
    return (0, $be797e04b4adb295$export$8874016870239da4)(options, serializer, (0, $13990a785eb19d49$export$2a8528aedd03b24e)({
        transport: (0, $fcc0e488dae9c036$export$8ab960d599ca0ecc)(options)
    }));
}
function $d4018dbe2131893d$export$6ca8051e58a2f94e(options, serializer) {
    return (0, $be797e04b4adb295$export$8874016870239da4)(options, serializer, (0, $13990a785eb19d49$export$2a8528aedd03b24e)({
        transport: (0, $5407df0f70753998$export$9e4ae37cd458911c)(options)
    }));
}
function $d4018dbe2131893d$export$5b68ba408d750db3(options, serializer) {
    return (0, $be797e04b4adb295$export$8874016870239da4)(options, serializer, (0, $13990a785eb19d49$export$2a8528aedd03b24e)({
        transport: (0, $5cf098f56601da02$export$ef075750bfec2f31)({
            url: options.url,
            headers: options.headers
        })
    }));
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $265b4634ac42e699$export$c7dc25f7ba3fe11a(timeoutMillis) {
    if (Number.isFinite(timeoutMillis) && timeoutMillis > 0) return timeoutMillis;
    throw new Error(`Configuration: timeoutMillis is invalid, expected number greater than 0 (actual: '${timeoutMillis}')`);
}
function $265b4634ac42e699$export$c37a46ab59261386(headers) {
    if (headers == null) return undefined;
    return async ()=>headers;
}
function $265b4634ac42e699$export$f0204f09cd0066b(userProvidedConfiguration, fallbackConfiguration, defaultConfiguration) {
    return {
        timeoutMillis: $265b4634ac42e699$export$c7dc25f7ba3fe11a(userProvidedConfiguration.timeoutMillis ?? fallbackConfiguration.timeoutMillis ?? defaultConfiguration.timeoutMillis),
        concurrencyLimit: userProvidedConfiguration.concurrencyLimit ?? fallbackConfiguration.concurrencyLimit ?? defaultConfiguration.concurrencyLimit,
        compression: userProvidedConfiguration.compression ?? fallbackConfiguration.compression ?? defaultConfiguration.compression
    };
}
function $265b4634ac42e699$export$cd8c80b353c895f4() {
    return {
        timeoutMillis: 10000,
        concurrencyLimit: 30,
        compression: 'none'
    };
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
function $fa634b3865a51535$export$4144cc9174bc6a0(partialHeaders) {
    const headers = {};
    Object.entries(partialHeaders ?? {}).forEach(([key, value])=>{
        if (typeof value !== 'undefined') headers[key] = String(value);
        else (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).warn(`Header "${key}" has invalid value (${value}) and will be ignored`);
    });
    return headers;
}


function $2e3f5d053382e22e$var$mergeHeaders(userProvidedHeaders, fallbackHeaders, defaultHeaders) {
    return async ()=>{
        const requiredHeaders = {
            ...await defaultHeaders()
        };
        const headers = {};
        // add fallback ones first
        if (fallbackHeaders != null) Object.assign(headers, await fallbackHeaders());
        // override with user-provided ones
        if (userProvidedHeaders != null) Object.assign(headers, (0, $fa634b3865a51535$export$4144cc9174bc6a0)(await userProvidedHeaders()));
        // override required ones.
        return Object.assign(headers, requiredHeaders);
    };
}
function $2e3f5d053382e22e$var$validateUserProvidedUrl(url) {
    if (url == null) return undefined;
    try {
        // NOTE: In non-browser environments, `globalThis.location` will be `undefined`.
        const base = globalThis.location?.href;
        return new URL(url, base).href;
    } catch  {
        throw new Error(`Configuration: Could not parse user-provided export URL: '${url}'`);
    }
}
function $2e3f5d053382e22e$export$dae543ef16d16f76(userProvidedConfiguration, fallbackConfiguration, defaultConfiguration) {
    return {
        ...(0, $265b4634ac42e699$export$f0204f09cd0066b)(userProvidedConfiguration, fallbackConfiguration, defaultConfiguration),
        headers: $2e3f5d053382e22e$var$mergeHeaders(userProvidedConfiguration.headers, fallbackConfiguration.headers, defaultConfiguration.headers),
        url: $2e3f5d053382e22e$var$validateUserProvidedUrl(userProvidedConfiguration.url) ?? fallbackConfiguration.url ?? defaultConfiguration.url
    };
}
function $2e3f5d053382e22e$export$ed5dc921e0200ace(requiredHeaders, signalResourcePath) {
    return {
        ...(0, $265b4634ac42e699$export$cd8c80b353c895f4)(),
        headers: async ()=>requiredHeaders,
        url: 'http://localhost:4318/' + signalResourcePath
    };
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
function $a9803136ef406769$export$204793d8eaaae015(config) {
    if (typeof config.headers === 'function') return config.headers;
    return (0, $265b4634ac42e699$export$c37a46ab59261386)(config.headers);
}


function $0bd74c2c64e72fa1$export$816c85190fdd0ca8(config, signalResourcePath, requiredHeaders) {
    return (0, $2e3f5d053382e22e$export$dae543ef16d16f76)({
        url: config.url,
        timeoutMillis: config.timeoutMillis,
        headers: (0, $a9803136ef406769$export$204793d8eaaae015)(config),
        concurrencyLimit: config.concurrencyLimit
    }, {}, (0, $2e3f5d053382e22e$export$ed5dc921e0200ace)(requiredHeaders, signalResourcePath));
}


function $797afe353fd8f389$export$f0b482136e1f7b30(config, serializer, signalResourcePath, requiredHeaders) {
    const createOtlpExportDelegate = $797afe353fd8f389$export$20dd511f645ec088(config.headers);
    const options = (0, $0bd74c2c64e72fa1$export$816c85190fdd0ca8)(config, signalResourcePath, requiredHeaders);
    return createOtlpExportDelegate(options, serializer);
}
function $797afe353fd8f389$export$20dd511f645ec088(configHeaders) {
    if (!configHeaders && typeof navigator.sendBeacon === 'function') return 0, $d4018dbe2131893d$export$5b68ba408d750db3;
    else if (typeof globalThis.fetch !== 'undefined') return 0, $d4018dbe2131893d$export$6ca8051e58a2f94e;
    else return 0, $d4018dbe2131893d$export$f1ed08af29ca92a7;
}


class $50e24aa04678c249$export$f73dc942b4b27de3 extends (0, $ef6af0e9bef7148a$export$a756c21bf453f1b5) {
    constructor(config = {}){
        super((0, $797afe353fd8f389$export$f0b482136e1f7b30)(config, (0, $604be5f4b909e111$export$dfba2b8376f2d3f5), 'v1/traces', {
            'Content-Type': 'application/json'
        }));
    }
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $56fc24ae98cc6f86$export$85f6557964517f1a {
    _promise;
    _resolve;
    _reject;
    constructor(){
        this._promise = new Promise((resolve, reject)=>{
            this._resolve = resolve;
            this._reject = reject;
        });
    }
    get promise() {
        return this._promise;
    }
    resolve(val) {
        this._resolve(val);
    }
    reject(err) {
        this._reject(err);
    }
}


class $db7650949c267d86$export$c1f52ab4952184cd {
    _callback;
    _that;
    _isCalled = false;
    _deferred = new (0, $56fc24ae98cc6f86$export$85f6557964517f1a)();
    constructor(_callback, _that){
        this._callback = _callback;
        this._that = _that;
    }
    get isCalled() {
        return this._isCalled;
    }
    get promise() {
        return this._deferred.promise;
    }
    call(...args) {
        if (!this._isCalled) {
            this._isCalled = true;
            try {
                Promise.resolve(this._callback.call(this._that, ...args)).then((val)=>this._deferred.resolve(val), (err)=>this._deferred.reject(err));
            } catch (err) {
                this._deferred.reject(err);
            }
        }
        return this._deferred.promise;
    }
}


class $31540fc2074db7cc$export$54ea939f5d39e8a2 {
    _exporter;
    _maxExportBatchSize;
    _maxQueueSize;
    _scheduledDelayMillis;
    _exportTimeoutMillis;
    _isExporting = false;
    _finishedSpans = [];
    _timer;
    _shutdownOnce;
    _droppedSpansCount = 0;
    constructor(_exporter, config){
        this._exporter = _exporter;
        this._maxExportBatchSize = typeof config?.maxExportBatchSize === 'number' ? config.maxExportBatchSize : (0, $2904c97a66abe41f$export$9d6c13e44580559c)('OTEL_BSP_MAX_EXPORT_BATCH_SIZE') ?? 512;
        this._maxQueueSize = typeof config?.maxQueueSize === 'number' ? config.maxQueueSize : (0, $2904c97a66abe41f$export$9d6c13e44580559c)('OTEL_BSP_MAX_QUEUE_SIZE') ?? 2048;
        this._scheduledDelayMillis = typeof config?.scheduledDelayMillis === 'number' ? config.scheduledDelayMillis : (0, $2904c97a66abe41f$export$9d6c13e44580559c)('OTEL_BSP_SCHEDULE_DELAY') ?? 5000;
        this._exportTimeoutMillis = typeof config?.exportTimeoutMillis === 'number' ? config.exportTimeoutMillis : (0, $2904c97a66abe41f$export$9d6c13e44580559c)('OTEL_BSP_EXPORT_TIMEOUT') ?? 30000;
        this._shutdownOnce = new (0, $db7650949c267d86$export$c1f52ab4952184cd)(this._shutdown, this);
        if (this._maxExportBatchSize > this._maxQueueSize) {
            (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).warn('BatchSpanProcessor: maxExportBatchSize must be smaller or equal to maxQueueSize, setting maxExportBatchSize to match maxQueueSize');
            this._maxExportBatchSize = this._maxQueueSize;
        }
    }
    forceFlush() {
        if (this._shutdownOnce.isCalled) return this._shutdownOnce.promise;
        return this._flushAll();
    }
    // does nothing.
    onStart(_span, _parentContext) {}
    onEnd(span) {
        if (this._shutdownOnce.isCalled) return;
        if ((span.spanContext().traceFlags & (0, $5dcc187a863bca89$export$bf9049ad2b0883ff).SAMPLED) === 0) return;
        this._addToBuffer(span);
    }
    shutdown() {
        return this._shutdownOnce.call();
    }
    _shutdown() {
        return Promise.resolve().then(()=>{
            return this.onShutdown();
        }).then(()=>{
            return this._flushAll();
        }).then(()=>{
            return this._exporter.shutdown();
        });
    }
    /** Add a span in the buffer. */ _addToBuffer(span) {
        if (this._finishedSpans.length >= this._maxQueueSize) {
            // limit reached, drop span
            if (this._droppedSpansCount === 0) (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).debug('maxQueueSize reached, dropping spans');
            this._droppedSpansCount++;
            return;
        }
        if (this._droppedSpansCount > 0) {
            // some spans were dropped, log once with count of spans dropped
            (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).warn(`Dropped ${this._droppedSpansCount} spans because maxQueueSize reached`);
            this._droppedSpansCount = 0;
        }
        this._finishedSpans.push(span);
        this._maybeStartTimer();
    }
    /**
     * Send all spans to the exporter respecting the batch size limit
     * This function is used only on forceFlush or shutdown,
     * for all other cases _flush should be used
     * */ _flushAll() {
        return new Promise((resolve, reject)=>{
            const promises = [];
            // calculate number of batches
            const count = Math.ceil(this._finishedSpans.length / this._maxExportBatchSize);
            for(let i = 0, j = count; i < j; i++)promises.push(this._flushOneBatch());
            Promise.all(promises).then(()=>{
                resolve();
            }).catch(reject);
        });
    }
    _flushOneBatch() {
        this._clearTimer();
        if (this._finishedSpans.length === 0) return Promise.resolve();
        return new Promise((resolve, reject)=>{
            const timer = setTimeout(()=>{
                // don't wait anymore for export, this way the next batch can start
                reject(new Error('Timeout'));
            }, this._exportTimeoutMillis);
            // prevent downstream exporter calls from generating spans
            (0, $0c57d9262090934c$export$a078c61943f9dbbe).with((0, $a2728a0463bf3b1f$export$869298f9835abc68)((0, $0c57d9262090934c$export$a078c61943f9dbbe).active()), ()=>{
                // Reset the finished spans buffer here because the next invocations of the _flush method
                // could pass the same finished spans to the exporter if the buffer is cleared
                // outside the execution of this callback.
                let spans;
                if (this._finishedSpans.length <= this._maxExportBatchSize) {
                    spans = this._finishedSpans;
                    this._finishedSpans = [];
                } else spans = this._finishedSpans.splice(0, this._maxExportBatchSize);
                const doExport = ()=>this._exporter.export(spans, (result)=>{
                        clearTimeout(timer);
                        if (result.code === (0, $f3cb0785acfa889d$export$ee0fe4df4ef0f3a1).SUCCESS) resolve();
                        else reject(result.error ?? new Error('BatchSpanProcessor: span export failed'));
                    });
                let pendingResources = null;
                for(let i = 0, len = spans.length; i < len; i++){
                    const span = spans[i];
                    if (span.resource.asyncAttributesPending && span.resource.waitForAsyncAttributes) {
                        pendingResources ??= [];
                        pendingResources.push(span.resource.waitForAsyncAttributes());
                    }
                }
                // Avoid scheduling a promise to make the behavior more predictable and easier to test
                if (pendingResources === null) doExport();
                else Promise.all(pendingResources).then(doExport, (err)=>{
                    (0, $c70d952740b6ceea$export$54c6946fc34b7cc2)(err);
                    reject(err);
                });
            });
        });
    }
    _maybeStartTimer() {
        if (this._isExporting) return;
        const flush = ()=>{
            this._isExporting = true;
            this._flushOneBatch().finally(()=>{
                this._isExporting = false;
                if (this._finishedSpans.length > 0) {
                    this._clearTimer();
                    this._maybeStartTimer();
                }
            }).catch((e)=>{
                this._isExporting = false;
                (0, $c70d952740b6ceea$export$54c6946fc34b7cc2)(e);
            });
        };
        // we only wait if the queue doesn't have enough elements yet
        if (this._finishedSpans.length >= this._maxExportBatchSize) return flush();
        if (this._timer !== undefined) return;
        this._timer = setTimeout(()=>flush(), this._scheduledDelayMillis);
        // depending on runtime, this may be a 'number' or NodeJS.Timeout
        if (typeof this._timer !== 'number') this._timer.unref();
    }
    _clearTimer() {
        if (this._timer !== undefined) {
            clearTimeout(this._timer);
            this._timer = undefined;
        }
    }
}



class $6387aa3fe0aa015a$export$237547059fd543f9 extends (0, $31540fc2074db7cc$export$54ea939f5d39e8a2) {
    _visibilityChangeListener;
    _pageHideListener;
    constructor(_exporter, config){
        super(_exporter, config);
        this.onInit(config);
    }
    onInit(config) {
        if (config?.disableAutoFlushOnDocumentHide !== true && typeof document !== 'undefined') {
            this._visibilityChangeListener = ()=>{
                if (document.visibilityState === 'hidden') this.forceFlush().catch((error)=>{
                    (0, $c70d952740b6ceea$export$54c6946fc34b7cc2)(error);
                });
            };
            this._pageHideListener = ()=>{
                this.forceFlush().catch((error)=>{
                    (0, $c70d952740b6ceea$export$54c6946fc34b7cc2)(error);
                });
            };
            document.addEventListener('visibilitychange', this._visibilityChangeListener);
            // use 'pagehide' event as a fallback for Safari; see https://bugs.webkit.org/show_bug.cgi?id=116769
            document.addEventListener('pagehide', this._pageHideListener);
        }
    }
    onShutdown() {
        if (typeof document !== 'undefined') {
            if (this._visibilityChangeListener) document.removeEventListener('visibilitychange', this._visibilityChangeListener);
            if (this._pageHideListener) document.removeEventListener('pagehide', this._pageHideListener);
        }
    }
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Enable instrumentations
 * @param instrumentations
 * @param tracerProvider
 * @param meterProvider
 */ function $c186d9cbf55f295f$export$56a6415128a54b1(instrumentations, tracerProvider, meterProvider, loggerProvider) {
    for(let i = 0, j = instrumentations.length; i < j; i++){
        const instrumentation = instrumentations[i];
        if (tracerProvider) instrumentation.setTracerProvider(tracerProvider);
        if (meterProvider) instrumentation.setMeterProvider(meterProvider);
        if (loggerProvider && instrumentation.setLoggerProvider) instrumentation.setLoggerProvider(loggerProvider);
        // instrumentations have been already enabled during creation
        // so enable only if user prevented that by setting enabled to false
        // this is to prevent double enabling but when calling register all
        // instrumentations should be now enabled
        if (!instrumentation.getConfig().enabled) instrumentation.enable();
    }
}
function $c186d9cbf55f295f$export$c7d87b302116dc69(instrumentations) {
    instrumentations.forEach((instrumentation)=>instrumentation.disable());
}


function $412e403263150e72$export$fc0a1ca5231d826a(options) {
    const tracerProvider = options.tracerProvider || (0, $496851d2cf78caa4$export$357889f174732d38).getTracerProvider();
    const meterProvider = options.meterProvider || (0, $b8db6f384fae8886$export$b0c5c2fac8144e54).getMeterProvider();
    const loggerProvider = options.loggerProvider || (0, $6d3371a0a865dabe$export$fa0831f497706bad).getLoggerProvider();
    const instrumentations = options.instrumentations?.flat() ?? [];
    (0, $c186d9cbf55f295f$export$56a6415128a54b1)(instrumentations, tracerProvider, meterProvider, loggerProvider);
    return ()=>{
        (0, $c186d9cbf55f295f$export$c7d87b302116dc69)(instrumentations);
    };
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /// <reference types="zone.js" />

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * check if an object has `addEventListener` and `removeEventListener` functions.
 * Generally only called with a `TargetWithEvents` but may be called with an `unknown` value.
 * @param obj - The object to check.
 */ function $b924243e44cd2d5c$export$8b321bf7829ce743(obj) {
    return typeof obj === 'object' && obj !== null && 'addEventListener' in obj && typeof obj.addEventListener === 'function' && 'removeEventListener' in obj && typeof obj.removeEventListener === 'function';
}


/* Key name to be used to save a context reference in Zone */ const $89c185efeb78c80b$var$ZONE_CONTEXT_KEY = 'OT_ZONE_CONTEXT';
class $89c185efeb78c80b$export$148434e42b84e81c {
    /**
     * whether the context manager is enabled or not
     */ _enabled = false;
    /**
     * Helps to create a unique name for the zones - part of zone name
     */ _zoneCounter = 0;
    /**
     * Returns the active context from certain zone name
     * @param activeZone
     */ _activeContextFromZone(activeZone) {
        return activeZone && activeZone.get($89c185efeb78c80b$var$ZONE_CONTEXT_KEY) || (0, $411320e1da10ff3d$export$78df28f9b2f9a7dc);
    }
    /**
     * @param context A context (span) to be executed within target function
     * @param target Function to be executed within the context
     */ // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
    _bindFunction(context, target) {
        const manager = this;
        const contextWrapper = function(...args) {
            return manager.with(context, ()=>target.apply(this, args));
        };
        Object.defineProperty(contextWrapper, 'length', {
            enumerable: false,
            configurable: true,
            writable: false,
            value: target.length
        });
        return contextWrapper;
    }
    /**
     * @param context A context (span) to be bind to target
     * @param obj target object on which the listeners will be patched
     */ _bindListener(context, obj) {
        const target = obj;
        if (target.__ot_listeners !== undefined) return obj;
        target.__ot_listeners = {};
        if (typeof target.addEventListener === 'function') target.addEventListener = this._patchAddEventListener(target, target.addEventListener, context);
        if (typeof target.removeEventListener === 'function') target.removeEventListener = this._patchRemoveEventListener(target, target.removeEventListener);
        return obj;
    }
    /**
     * Creates a new unique zone name
     */ _createZoneName() {
        this._zoneCounter++;
        const random = Math.random();
        return `${this._zoneCounter}-${random}`;
    }
    /**
     * Creates a new zone
     * @param zoneName zone name
     * @param context A context (span) to be bind with Zone
     */ _createZone(zoneName, context) {
        return Zone.current.fork({
            name: zoneName,
            properties: {
                [$89c185efeb78c80b$var$ZONE_CONTEXT_KEY]: context
            }
        });
    }
    /**
     * Returns the active zone
     */ _getActiveZone() {
        return Zone.current;
    }
    /**
     * Patches addEventListener method
     * @param target any target that has "addEventListener" method
     * @param original reference to the patched method
     * @param [context] context to be bind to the listener
     */ _patchAddEventListener(target, original, context) {
        const contextManager = this;
        return function(event, listener, opts) {
            if (target.__ot_listeners === undefined) target.__ot_listeners = {};
            let listeners = target.__ot_listeners[event];
            if (listeners === undefined) {
                listeners = new WeakMap();
                target.__ot_listeners[event] = listeners;
            }
            const patchedListener = contextManager.bind(context, listener);
            // store a weak reference of the user listener to ours
            listeners.set(listener, patchedListener);
            return original.call(this, event, patchedListener, opts);
        };
    }
    /**
     * Patches removeEventListener method
     * @param target any target that has "removeEventListener" method
     * @param original reference to the patched method
     */ _patchRemoveEventListener(target, original) {
        return function(event, listener) {
            if (target.__ot_listeners === undefined || target.__ot_listeners[event] === undefined) return original.call(this, event, listener);
            const events = target.__ot_listeners[event];
            const patchedListener = events.get(listener);
            events.delete(listener);
            return original.call(this, event, patchedListener || listener);
        };
    }
    /**
     * Returns the active context
     */ active() {
        if (!this._enabled) return 0, $411320e1da10ff3d$export$78df28f9b2f9a7dc;
        const activeZone = this._getActiveZone();
        const active = this._activeContextFromZone(activeZone);
        if (active) return active;
        return 0, $411320e1da10ff3d$export$78df28f9b2f9a7dc;
    }
    /**
     * Binds a the certain context or the active one to the target function and then returns the target
     * @param context A context (span) to be bind to target
     * @param target a function or event emitter. When target or one of its callbacks is called,
     *  the provided context will be used as the active context for the duration of the call.
     */ bind(context, target) {
        // if no specific context to propagate is given, we use the current one
        if (context === undefined) context = this.active();
        if (typeof target === 'function') return this._bindFunction(context, target);
        else if ((0, $b924243e44cd2d5c$export$8b321bf7829ce743)(target)) this._bindListener(context, target);
        return target;
    }
    /**
     * Disable the context manager (clears all the contexts)
     */ disable() {
        this._enabled = false;
        return this;
    }
    /**
     * Enables the context manager and creates a default(root) context
     */ enable() {
        this._enabled = true;
        return this;
    }
    /**
     * Calls the callback function [fn] with the provided [context].
     *     If [context] is undefined then it will use the active context.
     *     The context will be set as active
     * @param context A context (span) to be called with provided callback
     * @param fn Callback function
     * @param thisArg optional receiver to be used for calling fn
     * @param args optional arguments forwarded to fn
     */ with(context, fn, thisArg, ...args) {
        const zoneName = this._createZoneName();
        const newZone = this._createZone(zoneName, context);
        return newZone.run(fn, thisArg, args);
    }
}


'use strict';
/**
 * @license Angular v<unknown>
 * (c) 2010-2025 Google LLC. https://angular.io/
 * License: MIT
 */ const $d9497ea901ae627a$var$global = globalThis;
// __Zone_symbol_prefix global can be used to override the default zone
// symbol prefix with a custom one if needed.
function $d9497ea901ae627a$var$__symbol__(name) {
    const symbolPrefix = $d9497ea901ae627a$var$global['__Zone_symbol_prefix'] || '__zone_symbol__';
    return symbolPrefix + name;
}
function $d9497ea901ae627a$var$initZone() {
    const performance = $d9497ea901ae627a$var$global['performance'];
    function mark(name) {
        performance && performance['mark'] && performance['mark'](name);
    }
    function performanceMeasure(name, label) {
        performance && performance['measure'] && performance['measure'](name, label);
    }
    mark('Zone');
    class ZoneImpl {
        static __symbol__ = $d9497ea901ae627a$var$__symbol__;
        static assertZonePatched() {
            if ($d9497ea901ae627a$var$global['Promise'] !== patches['ZoneAwarePromise']) throw new Error("Zone.js has detected that ZoneAwarePromise `(window|global).Promise` has been overwritten.\nMost likely cause is that a Promise polyfill has been loaded after Zone.js (Polyfilling Promise api is not necessary when zone.js is loaded. If you must load one, do so before loading zone.js.)");
        }
        static get root() {
            let zone = ZoneImpl.current;
            while(zone.parent)zone = zone.parent;
            return zone;
        }
        static get current() {
            return _currentZoneFrame.zone;
        }
        static get currentTask() {
            return _currentTask;
        }
        static __load_patch(name, fn, ignoreDuplicate = false) {
            if (patches.hasOwnProperty(name)) {
                // `checkDuplicate` option is defined from global variable
                // so it works for all modules.
                // `ignoreDuplicate` can work for the specified module
                const checkDuplicate = $d9497ea901ae627a$var$global[$d9497ea901ae627a$var$__symbol__('forceDuplicateZoneCheck')] === true;
                if (!ignoreDuplicate && checkDuplicate) throw Error('Already loaded patch: ' + name);
            } else if (!$d9497ea901ae627a$var$global['__Zone_disable_' + name]) {
                const perfName = 'Zone:' + name;
                mark(perfName);
                patches[name] = fn($d9497ea901ae627a$var$global, ZoneImpl, _api);
                performanceMeasure(perfName, perfName);
            }
        }
        get parent() {
            return this._parent;
        }
        get name() {
            return this._name;
        }
        _parent;
        _name;
        _properties;
        _zoneDelegate;
        constructor(parent, zoneSpec){
            this._parent = parent;
            this._name = zoneSpec ? zoneSpec.name || 'unnamed' : '<root>';
            this._properties = zoneSpec && zoneSpec.properties || {};
            this._zoneDelegate = new _ZoneDelegate(this, this._parent && this._parent._zoneDelegate, zoneSpec);
        }
        get(key) {
            const zone = this.getZoneWith(key);
            if (zone) return zone._properties[key];
        }
        getZoneWith(key) {
            let current = this;
            while(current){
                if (current._properties.hasOwnProperty(key)) return current;
                current = current._parent;
            }
            return null;
        }
        fork(zoneSpec) {
            if (!zoneSpec) throw new Error('ZoneSpec required!');
            return this._zoneDelegate.fork(this, zoneSpec);
        }
        wrap(callback, source) {
            if (typeof callback !== 'function') throw new Error('Expecting function got: ' + callback);
            const _callback = this._zoneDelegate.intercept(this, callback, source);
            const zone = this;
            return function() {
                return zone.runGuarded(_callback, this, arguments, source);
            };
        }
        run(callback, applyThis, applyArgs, source) {
            _currentZoneFrame = {
                parent: _currentZoneFrame,
                zone: this
            };
            try {
                return this._zoneDelegate.invoke(this, callback, applyThis, applyArgs, source);
            } finally{
                _currentZoneFrame = _currentZoneFrame.parent;
            }
        }
        runGuarded(callback, applyThis = null, applyArgs, source) {
            _currentZoneFrame = {
                parent: _currentZoneFrame,
                zone: this
            };
            try {
                try {
                    return this._zoneDelegate.invoke(this, callback, applyThis, applyArgs, source);
                } catch (error) {
                    if (this._zoneDelegate.handleError(this, error)) throw error;
                }
            } finally{
                _currentZoneFrame = _currentZoneFrame.parent;
            }
        }
        runTask(task, applyThis, applyArgs) {
            if (task.zone != this) throw new Error('A task can only be run in the zone of creation! (Creation: ' + (task.zone || NO_ZONE).name + '; Execution: ' + this.name + ')');
            const zoneTask = task;
            // https://github.com/angular/zone.js/issues/778, sometimes eventTask
            // will run in notScheduled(canceled) state, we should not try to
            // run such kind of task but just return
            const { type: type, data: { isPeriodic: isPeriodic = false, isRefreshable: isRefreshable = false } = {} } = task;
            if (task.state === notScheduled && (type === eventTask || type === macroTask)) return;
            const reEntryGuard = task.state != running;
            reEntryGuard && zoneTask._transitionTo(running, scheduled);
            const previousTask = _currentTask;
            _currentTask = zoneTask;
            _currentZoneFrame = {
                parent: _currentZoneFrame,
                zone: this
            };
            try {
                if (type == macroTask && task.data && !isPeriodic && !isRefreshable) task.cancelFn = undefined;
                try {
                    return this._zoneDelegate.invokeTask(this, zoneTask, applyThis, applyArgs);
                } catch (error) {
                    if (this._zoneDelegate.handleError(this, error)) throw error;
                }
            } finally{
                // if the task's state is notScheduled or unknown, then it has already been cancelled
                // we should not reset the state to scheduled
                const state = task.state;
                if (state !== notScheduled && state !== unknown) {
                    if (type == eventTask || isPeriodic || isRefreshable && state === scheduling) reEntryGuard && zoneTask._transitionTo(scheduled, running, scheduling);
                    else {
                        const zoneDelegates = zoneTask._zoneDelegates;
                        this._updateTaskCount(zoneTask, -1);
                        reEntryGuard && zoneTask._transitionTo(notScheduled, running, notScheduled);
                        if (isRefreshable) zoneTask._zoneDelegates = zoneDelegates;
                    }
                }
                _currentZoneFrame = _currentZoneFrame.parent;
                _currentTask = previousTask;
            }
        }
        scheduleTask(task) {
            if (task.zone && task.zone !== this) {
                // check if the task was rescheduled, the newZone
                // should not be the children of the original zone
                let newZone = this;
                while(newZone){
                    if (newZone === task.zone) throw Error(`can not reschedule task to ${this.name} which is descendants of the original zone ${task.zone.name}`);
                    newZone = newZone.parent;
                }
            }
            task._transitionTo(scheduling, notScheduled);
            const zoneDelegates = [];
            task._zoneDelegates = zoneDelegates;
            task._zone = this;
            try {
                task = this._zoneDelegate.scheduleTask(this, task);
            } catch (err) {
                // should set task's state to unknown when scheduleTask throw error
                // because the err may from reschedule, so the fromState maybe notScheduled
                task._transitionTo(unknown, scheduling, notScheduled);
                // TODO: @JiaLiPassion, should we check the result from handleError?
                this._zoneDelegate.handleError(this, err);
                throw err;
            }
            if (task._zoneDelegates === zoneDelegates) // we have to check because internally the delegate can reschedule the task.
            this._updateTaskCount(task, 1);
            if (task.state == scheduling) task._transitionTo(scheduled, scheduling);
            return task;
        }
        scheduleMicroTask(source, callback, data, customSchedule) {
            return this.scheduleTask(new ZoneTask(microTask, source, callback, data, customSchedule, undefined));
        }
        scheduleMacroTask(source, callback, data, customSchedule, customCancel) {
            return this.scheduleTask(new ZoneTask(macroTask, source, callback, data, customSchedule, customCancel));
        }
        scheduleEventTask(source, callback, data, customSchedule, customCancel) {
            return this.scheduleTask(new ZoneTask(eventTask, source, callback, data, customSchedule, customCancel));
        }
        cancelTask(task) {
            if (task.zone != this) throw new Error('A task can only be cancelled in the zone of creation! (Creation: ' + (task.zone || NO_ZONE).name + '; Execution: ' + this.name + ')');
            if (task.state !== scheduled && task.state !== running) return;
            task._transitionTo(canceling, scheduled, running);
            try {
                this._zoneDelegate.cancelTask(this, task);
            } catch (err) {
                // if error occurs when cancelTask, transit the state to unknown
                task._transitionTo(unknown, canceling);
                this._zoneDelegate.handleError(this, err);
                throw err;
            }
            this._updateTaskCount(task, -1);
            task._transitionTo(notScheduled, canceling);
            task.runCount = -1;
            return task;
        }
        _updateTaskCount(task, count) {
            const zoneDelegates = task._zoneDelegates;
            if (count == -1) task._zoneDelegates = null;
            for(let i = 0; i < zoneDelegates.length; i++)zoneDelegates[i]._updateTaskCount(task.type, count);
        }
    }
    const DELEGATE_ZS = {
        name: '',
        onHasTask: (delegate, _, target, hasTaskState)=>delegate.hasTask(target, hasTaskState),
        onScheduleTask: (delegate, _, target, task)=>delegate.scheduleTask(target, task),
        onInvokeTask: (delegate, _, target, task, applyThis, applyArgs)=>delegate.invokeTask(target, task, applyThis, applyArgs),
        onCancelTask: (delegate, _, target, task)=>delegate.cancelTask(target, task)
    };
    class _ZoneDelegate {
        get zone() {
            return this._zone;
        }
        _zone;
        _taskCounts = {
            'microTask': 0,
            'macroTask': 0,
            'eventTask': 0
        };
        _parentDelegate;
        _forkDlgt;
        _forkZS;
        _forkCurrZone;
        _interceptDlgt;
        _interceptZS;
        _interceptCurrZone;
        _invokeDlgt;
        _invokeZS;
        _invokeCurrZone;
        _handleErrorDlgt;
        _handleErrorZS;
        _handleErrorCurrZone;
        _scheduleTaskDlgt;
        _scheduleTaskZS;
        _scheduleTaskCurrZone;
        _invokeTaskDlgt;
        _invokeTaskZS;
        _invokeTaskCurrZone;
        _cancelTaskDlgt;
        _cancelTaskZS;
        _cancelTaskCurrZone;
        _hasTaskDlgt;
        _hasTaskDlgtOwner;
        _hasTaskZS;
        _hasTaskCurrZone;
        constructor(zone, parentDelegate, zoneSpec){
            this._zone = zone;
            this._parentDelegate = parentDelegate;
            this._forkZS = zoneSpec && (zoneSpec && zoneSpec.onFork ? zoneSpec : parentDelegate._forkZS);
            this._forkDlgt = zoneSpec && (zoneSpec.onFork ? parentDelegate : parentDelegate._forkDlgt);
            this._forkCurrZone = zoneSpec && (zoneSpec.onFork ? this._zone : parentDelegate._forkCurrZone);
            this._interceptZS = zoneSpec && (zoneSpec.onIntercept ? zoneSpec : parentDelegate._interceptZS);
            this._interceptDlgt = zoneSpec && (zoneSpec.onIntercept ? parentDelegate : parentDelegate._interceptDlgt);
            this._interceptCurrZone = zoneSpec && (zoneSpec.onIntercept ? this._zone : parentDelegate._interceptCurrZone);
            this._invokeZS = zoneSpec && (zoneSpec.onInvoke ? zoneSpec : parentDelegate._invokeZS);
            this._invokeDlgt = zoneSpec && (zoneSpec.onInvoke ? parentDelegate : parentDelegate._invokeDlgt);
            this._invokeCurrZone = zoneSpec && (zoneSpec.onInvoke ? this._zone : parentDelegate._invokeCurrZone);
            this._handleErrorZS = zoneSpec && (zoneSpec.onHandleError ? zoneSpec : parentDelegate._handleErrorZS);
            this._handleErrorDlgt = zoneSpec && (zoneSpec.onHandleError ? parentDelegate : parentDelegate._handleErrorDlgt);
            this._handleErrorCurrZone = zoneSpec && (zoneSpec.onHandleError ? this._zone : parentDelegate._handleErrorCurrZone);
            this._scheduleTaskZS = zoneSpec && (zoneSpec.onScheduleTask ? zoneSpec : parentDelegate._scheduleTaskZS);
            this._scheduleTaskDlgt = zoneSpec && (zoneSpec.onScheduleTask ? parentDelegate : parentDelegate._scheduleTaskDlgt);
            this._scheduleTaskCurrZone = zoneSpec && (zoneSpec.onScheduleTask ? this._zone : parentDelegate._scheduleTaskCurrZone);
            this._invokeTaskZS = zoneSpec && (zoneSpec.onInvokeTask ? zoneSpec : parentDelegate._invokeTaskZS);
            this._invokeTaskDlgt = zoneSpec && (zoneSpec.onInvokeTask ? parentDelegate : parentDelegate._invokeTaskDlgt);
            this._invokeTaskCurrZone = zoneSpec && (zoneSpec.onInvokeTask ? this._zone : parentDelegate._invokeTaskCurrZone);
            this._cancelTaskZS = zoneSpec && (zoneSpec.onCancelTask ? zoneSpec : parentDelegate._cancelTaskZS);
            this._cancelTaskDlgt = zoneSpec && (zoneSpec.onCancelTask ? parentDelegate : parentDelegate._cancelTaskDlgt);
            this._cancelTaskCurrZone = zoneSpec && (zoneSpec.onCancelTask ? this._zone : parentDelegate._cancelTaskCurrZone);
            this._hasTaskZS = null;
            this._hasTaskDlgt = null;
            this._hasTaskDlgtOwner = null;
            this._hasTaskCurrZone = null;
            const zoneSpecHasTask = zoneSpec && zoneSpec.onHasTask;
            const parentHasTask = parentDelegate && parentDelegate._hasTaskZS;
            if (zoneSpecHasTask || parentHasTask) {
                // If we need to report hasTask, than this ZS needs to do ref counting on tasks. In such
                // a case all task related interceptors must go through this ZD. We can't short circuit it.
                this._hasTaskZS = zoneSpecHasTask ? zoneSpec : DELEGATE_ZS;
                this._hasTaskDlgt = parentDelegate;
                this._hasTaskDlgtOwner = this;
                this._hasTaskCurrZone = this._zone;
                if (!zoneSpec.onScheduleTask) {
                    this._scheduleTaskZS = DELEGATE_ZS;
                    this._scheduleTaskDlgt = parentDelegate;
                    this._scheduleTaskCurrZone = this._zone;
                }
                if (!zoneSpec.onInvokeTask) {
                    this._invokeTaskZS = DELEGATE_ZS;
                    this._invokeTaskDlgt = parentDelegate;
                    this._invokeTaskCurrZone = this._zone;
                }
                if (!zoneSpec.onCancelTask) {
                    this._cancelTaskZS = DELEGATE_ZS;
                    this._cancelTaskDlgt = parentDelegate;
                    this._cancelTaskCurrZone = this._zone;
                }
            }
        }
        fork(targetZone, zoneSpec) {
            return this._forkZS ? this._forkZS.onFork(this._forkDlgt, this.zone, targetZone, zoneSpec) : new ZoneImpl(targetZone, zoneSpec);
        }
        intercept(targetZone, callback, source) {
            return this._interceptZS ? this._interceptZS.onIntercept(this._interceptDlgt, this._interceptCurrZone, targetZone, callback, source) : callback;
        }
        invoke(targetZone, callback, applyThis, applyArgs, source) {
            return this._invokeZS ? this._invokeZS.onInvoke(this._invokeDlgt, this._invokeCurrZone, targetZone, callback, applyThis, applyArgs, source) : callback.apply(applyThis, applyArgs);
        }
        handleError(targetZone, error) {
            return this._handleErrorZS ? this._handleErrorZS.onHandleError(this._handleErrorDlgt, this._handleErrorCurrZone, targetZone, error) : true;
        }
        scheduleTask(targetZone, task) {
            let returnTask = task;
            if (this._scheduleTaskZS) {
                if (this._hasTaskZS) returnTask._zoneDelegates.push(this._hasTaskDlgtOwner);
                returnTask = this._scheduleTaskZS.onScheduleTask(this._scheduleTaskDlgt, this._scheduleTaskCurrZone, targetZone, task);
                if (!returnTask) returnTask = task;
            } else {
                if (task.scheduleFn) task.scheduleFn(task);
                else if (task.type == microTask) scheduleMicroTask(task);
                else throw new Error('Task is missing scheduleFn.');
            }
            return returnTask;
        }
        invokeTask(targetZone, task, applyThis, applyArgs) {
            return this._invokeTaskZS ? this._invokeTaskZS.onInvokeTask(this._invokeTaskDlgt, this._invokeTaskCurrZone, targetZone, task, applyThis, applyArgs) : task.callback.apply(applyThis, applyArgs);
        }
        cancelTask(targetZone, task) {
            let value;
            if (this._cancelTaskZS) value = this._cancelTaskZS.onCancelTask(this._cancelTaskDlgt, this._cancelTaskCurrZone, targetZone, task);
            else {
                if (!task.cancelFn) throw Error('Task is not cancelable');
                value = task.cancelFn(task);
            }
            return value;
        }
        hasTask(targetZone, isEmpty) {
            // hasTask should not throw error so other ZoneDelegate
            // can still trigger hasTask callback
            try {
                this._hasTaskZS && this._hasTaskZS.onHasTask(this._hasTaskDlgt, this._hasTaskCurrZone, targetZone, isEmpty);
            } catch (err) {
                this.handleError(targetZone, err);
            }
        }
        _updateTaskCount(type, count) {
            const counts = this._taskCounts;
            const prev = counts[type];
            const next = counts[type] = prev + count;
            if (next < 0) throw new Error('More tasks executed then were scheduled.');
            if (prev == 0 || next == 0) {
                const isEmpty = {
                    microTask: counts['microTask'] > 0,
                    macroTask: counts['macroTask'] > 0,
                    eventTask: counts['eventTask'] > 0,
                    change: type
                };
                this.hasTask(this._zone, isEmpty);
            }
        }
    }
    class ZoneTask {
        type;
        source;
        invoke;
        callback;
        data;
        scheduleFn;
        cancelFn;
        _zone = null;
        runCount = 0;
        _zoneDelegates = null;
        _state = 'notScheduled';
        constructor(type, source, callback, options, scheduleFn, cancelFn){
            this.type = type;
            this.source = source;
            this.data = options;
            this.scheduleFn = scheduleFn;
            this.cancelFn = cancelFn;
            if (!callback) throw new Error('callback is not defined');
            this.callback = callback;
            const self1 = this;
            // TODO: @JiaLiPassion options should have interface
            if (type === eventTask && options && options.useG) this.invoke = ZoneTask.invokeTask;
            else this.invoke = function() {
                return ZoneTask.invokeTask.call($d9497ea901ae627a$var$global, self1, this, arguments);
            };
        }
        static invokeTask(task, target, args) {
            if (!task) task = this;
            _numberOfNestedTaskFrames++;
            try {
                task.runCount++;
                return task.zone.runTask(task, target, args);
            } finally{
                if (_numberOfNestedTaskFrames == 1) drainMicroTaskQueue();
                _numberOfNestedTaskFrames--;
            }
        }
        get zone() {
            return this._zone;
        }
        get state() {
            return this._state;
        }
        cancelScheduleRequest() {
            this._transitionTo(notScheduled, scheduling);
        }
        _transitionTo(toState, fromState1, fromState2) {
            if (this._state === fromState1 || this._state === fromState2) {
                this._state = toState;
                if (toState == notScheduled) this._zoneDelegates = null;
            } else throw new Error(`${this.type} '${this.source}': can not transition to '${toState}', expecting state '${fromState1}'${fromState2 ? " or '" + fromState2 + "'" : ''}, was '${this._state}'.`);
        }
        toString() {
            if (this.data && typeof this.data.handleId !== 'undefined') return this.data.handleId.toString();
            else return Object.prototype.toString.call(this);
        }
        // add toJSON method to prevent cyclic error when
        // call JSON.stringify(zoneTask)
        toJSON() {
            return {
                type: this.type,
                state: this.state,
                source: this.source,
                zone: this.zone.name,
                runCount: this.runCount
            };
        }
    }
    //////////////////////////////////////////////////////
    //////////////////////////////////////////////////////
    ///  MICROTASK QUEUE
    //////////////////////////////////////////////////////
    //////////////////////////////////////////////////////
    const symbolSetTimeout = $d9497ea901ae627a$var$__symbol__('setTimeout');
    const symbolPromise = $d9497ea901ae627a$var$__symbol__('Promise');
    const symbolThen = $d9497ea901ae627a$var$__symbol__('then');
    let _microTaskQueue = [];
    let _isDrainingMicrotaskQueue = false;
    let nativeMicroTaskQueuePromise;
    function nativeScheduleMicroTask(func) {
        if (!nativeMicroTaskQueuePromise) {
            if ($d9497ea901ae627a$var$global[symbolPromise]) nativeMicroTaskQueuePromise = $d9497ea901ae627a$var$global[symbolPromise].resolve(0);
        }
        if (nativeMicroTaskQueuePromise) {
            let nativeThen = nativeMicroTaskQueuePromise[symbolThen];
            if (!nativeThen) // native Promise is not patchable, we need to use `then` directly
            // issue 1078
            nativeThen = nativeMicroTaskQueuePromise['then'];
            nativeThen.call(nativeMicroTaskQueuePromise, func);
        } else $d9497ea901ae627a$var$global[symbolSetTimeout](func, 0);
    }
    function scheduleMicroTask(task) {
        // if we are not running in any task, and there has not been anything scheduled
        // we must bootstrap the initial task creation by manually scheduling the drain
        if (_numberOfNestedTaskFrames === 0 && _microTaskQueue.length === 0) // We are not running in Task, so we need to kickstart the microtask queue.
        nativeScheduleMicroTask(drainMicroTaskQueue);
        task && _microTaskQueue.push(task);
    }
    function drainMicroTaskQueue() {
        if (!_isDrainingMicrotaskQueue) {
            _isDrainingMicrotaskQueue = true;
            while(_microTaskQueue.length){
                const queue = _microTaskQueue;
                _microTaskQueue = [];
                for(let i = 0; i < queue.length; i++){
                    const task = queue[i];
                    try {
                        task.zone.runTask(task, null, null);
                    } catch (error) {
                        _api.onUnhandledError(error);
                    }
                }
            }
            _api.microtaskDrainDone();
            _isDrainingMicrotaskQueue = false;
        }
    }
    //////////////////////////////////////////////////////
    //////////////////////////////////////////////////////
    ///  BOOTSTRAP
    //////////////////////////////////////////////////////
    //////////////////////////////////////////////////////
    const NO_ZONE = {
        name: 'NO ZONE'
    };
    const notScheduled = 'notScheduled', scheduling = 'scheduling', scheduled = 'scheduled', running = 'running', canceling = 'canceling', unknown = 'unknown';
    const microTask = 'microTask', macroTask = 'macroTask', eventTask = 'eventTask';
    const patches = {};
    const _api = {
        symbol: $d9497ea901ae627a$var$__symbol__,
        currentZoneFrame: ()=>_currentZoneFrame,
        onUnhandledError: noop,
        microtaskDrainDone: noop,
        scheduleMicroTask: scheduleMicroTask,
        showUncaughtError: ()=>!ZoneImpl[$d9497ea901ae627a$var$__symbol__('ignoreConsoleErrorUncaughtError')],
        patchEventTarget: ()=>[],
        patchOnProperties: noop,
        patchMethod: ()=>noop,
        bindArguments: ()=>[],
        patchThen: ()=>noop,
        patchMacroTask: ()=>noop,
        patchEventPrototype: ()=>noop,
        isIEOrEdge: ()=>false,
        getGlobalObjects: ()=>undefined,
        ObjectDefineProperty: ()=>noop,
        ObjectGetOwnPropertyDescriptor: ()=>undefined,
        ObjectCreate: ()=>undefined,
        ArraySlice: ()=>[],
        patchClass: ()=>noop,
        wrapWithCurrentZone: ()=>noop,
        filterProperties: ()=>[],
        attachOriginToPatched: ()=>noop,
        _redefineProperty: ()=>noop,
        patchCallbacks: ()=>noop,
        nativeScheduleMicroTask: nativeScheduleMicroTask
    };
    let _currentZoneFrame = {
        parent: null,
        zone: new ZoneImpl(null, null)
    };
    let _currentTask = null;
    let _numberOfNestedTaskFrames = 0;
    function noop() {}
    performanceMeasure('Zone', 'Zone');
    return ZoneImpl;
}
function $d9497ea901ae627a$var$loadZone() {
    // if global['Zone'] already exists (maybe zone.js was already loaded or
    // some other lib also registered a global object named Zone), we may need
    // to throw an error, but sometimes user may not want this error.
    // For example,
    // we have two web pages, page1 includes zone.js, page2 doesn't.
    // and the 1st time user load page1 and page2, everything work fine,
    // but when user load page2 again, error occurs because global['Zone'] already exists.
    // so we add a flag to let user choose whether to throw this error or not.
    // By default, if existing Zone is from zone.js, we will not throw the error.
    const global = globalThis;
    const checkDuplicate = global[$d9497ea901ae627a$var$__symbol__('forceDuplicateZoneCheck')] === true;
    if (global['Zone'] && (checkDuplicate || typeof global['Zone'].__symbol__ !== 'function')) throw new Error('Zone already loaded.');
    // Initialize global `Zone` constant.
    global['Zone'] ??= $d9497ea901ae627a$var$initZone();
    return global['Zone'];
}
/**
 * Suppress closure compiler errors about unknown 'Zone' variable
 * @fileoverview
 * @suppress {undefinedVars,globalThis,missingRequire}
 */ /// <reference types="node"/>
// issue #989, to reduce bundle size, use short name
/** Object.getOwnPropertyDescriptor */ const $d9497ea901ae627a$var$ObjectGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
/** Object.defineProperty */ const $d9497ea901ae627a$var$ObjectDefineProperty = Object.defineProperty;
/** Object.getPrototypeOf */ const $d9497ea901ae627a$var$ObjectGetPrototypeOf = Object.getPrototypeOf;
/** Object.create */ const $d9497ea901ae627a$var$ObjectCreate = Object.create;
/** Array.prototype.slice */ const $d9497ea901ae627a$var$ArraySlice = Array.prototype.slice;
/** addEventListener string const */ const $d9497ea901ae627a$var$ADD_EVENT_LISTENER_STR = 'addEventListener';
/** removeEventListener string const */ const $d9497ea901ae627a$var$REMOVE_EVENT_LISTENER_STR = 'removeEventListener';
/** zoneSymbol addEventListener */ const $d9497ea901ae627a$var$ZONE_SYMBOL_ADD_EVENT_LISTENER = $d9497ea901ae627a$var$__symbol__($d9497ea901ae627a$var$ADD_EVENT_LISTENER_STR);
/** zoneSymbol removeEventListener */ const $d9497ea901ae627a$var$ZONE_SYMBOL_REMOVE_EVENT_LISTENER = $d9497ea901ae627a$var$__symbol__($d9497ea901ae627a$var$REMOVE_EVENT_LISTENER_STR);
/** true string const */ const $d9497ea901ae627a$var$TRUE_STR = 'true';
/** false string const */ const $d9497ea901ae627a$var$FALSE_STR = 'false';
/** Zone symbol prefix string const. */ const $d9497ea901ae627a$var$ZONE_SYMBOL_PREFIX = $d9497ea901ae627a$var$__symbol__('');
function $d9497ea901ae627a$var$wrapWithCurrentZone(callback, source) {
    return Zone.current.wrap(callback, source);
}
function $d9497ea901ae627a$var$scheduleMacroTaskWithCurrentZone(source, callback, data, customSchedule, customCancel) {
    return Zone.current.scheduleMacroTask(source, callback, data, customSchedule, customCancel);
}
const $d9497ea901ae627a$var$zoneSymbol = $d9497ea901ae627a$var$__symbol__;
const $d9497ea901ae627a$var$isWindowExists = typeof window !== 'undefined';
const $d9497ea901ae627a$var$internalWindow = $d9497ea901ae627a$var$isWindowExists ? window : undefined;
const $d9497ea901ae627a$var$_global = $d9497ea901ae627a$var$isWindowExists && $d9497ea901ae627a$var$internalWindow || globalThis;
const $d9497ea901ae627a$var$REMOVE_ATTRIBUTE = 'removeAttribute';
function $d9497ea901ae627a$var$bindArguments(args, source) {
    for(let i = args.length - 1; i >= 0; i--)if (typeof args[i] === 'function') args[i] = $d9497ea901ae627a$var$wrapWithCurrentZone(args[i], source + '_' + i);
    return args;
}
function $d9497ea901ae627a$var$patchPrototype(prototype, fnNames) {
    const source = prototype.constructor['name'];
    for(let i = 0; i < fnNames.length; i++){
        const name = fnNames[i];
        const delegate = prototype[name];
        if (delegate) {
            const prototypeDesc = $d9497ea901ae627a$var$ObjectGetOwnPropertyDescriptor(prototype, name);
            if (!$d9497ea901ae627a$var$isPropertyWritable(prototypeDesc)) continue;
            prototype[name] = ((delegate)=>{
                const patched = function() {
                    return delegate.apply(this, $d9497ea901ae627a$var$bindArguments(arguments, source + '.' + name));
                };
                $d9497ea901ae627a$var$attachOriginToPatched(patched, delegate);
                return patched;
            })(delegate);
        }
    }
}
function $d9497ea901ae627a$var$isPropertyWritable(propertyDesc) {
    if (!propertyDesc) return true;
    if (propertyDesc.writable === false) return false;
    return !(typeof propertyDesc.get === 'function' && typeof propertyDesc.set === 'undefined');
}
const $d9497ea901ae627a$var$isWebWorker = typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope;
// Make sure to access `process` through `_global` so that WebPack does not accidentally browserify
// this code.
const $d9497ea901ae627a$var$isNode = !('nw' in $d9497ea901ae627a$var$_global) && typeof $d9497ea901ae627a$var$_global.process !== 'undefined' && $d9497ea901ae627a$var$_global.process.toString() === '[object process]';
const $d9497ea901ae627a$var$isBrowser = !$d9497ea901ae627a$var$isNode && !$d9497ea901ae627a$var$isWebWorker && !!($d9497ea901ae627a$var$isWindowExists && $d9497ea901ae627a$var$internalWindow['HTMLElement']);
// we are in electron of nw, so we are both browser and nodejs
// Make sure to access `process` through `_global` so that WebPack does not accidentally browserify
// this code.
const $d9497ea901ae627a$var$isMix = typeof $d9497ea901ae627a$var$_global.process !== 'undefined' && $d9497ea901ae627a$var$_global.process.toString() === '[object process]' && !$d9497ea901ae627a$var$isWebWorker && !!($d9497ea901ae627a$var$isWindowExists && $d9497ea901ae627a$var$internalWindow['HTMLElement']);
const $d9497ea901ae627a$var$zoneSymbolEventNames$1 = {};
const $d9497ea901ae627a$var$enableBeforeunloadSymbol = $d9497ea901ae627a$var$zoneSymbol('enable_beforeunload');
const $d9497ea901ae627a$var$wrapFn = function(event) {
    // https://github.com/angular/zone.js/issues/911, in IE, sometimes
    // event will be undefined, so we need to use window.event
    event = event || $d9497ea901ae627a$var$_global.event;
    if (!event) return;
    let eventNameSymbol = $d9497ea901ae627a$var$zoneSymbolEventNames$1[event.type];
    if (!eventNameSymbol) eventNameSymbol = $d9497ea901ae627a$var$zoneSymbolEventNames$1[event.type] = $d9497ea901ae627a$var$zoneSymbol('ON_PROPERTY' + event.type);
    const target = this || event.target || $d9497ea901ae627a$var$_global;
    const listener = target[eventNameSymbol];
    let result;
    if ($d9497ea901ae627a$var$isBrowser && target === $d9497ea901ae627a$var$internalWindow && event.type === 'error') {
        // window.onerror have different signature
        // https://developer.mozilla.org/en-US/docs/Web/API/GlobalEventHandlers/onerror#window.onerror
        // and onerror callback will prevent default when callback return true
        const errorEvent = event;
        result = listener && listener.call(this, errorEvent.message, errorEvent.filename, errorEvent.lineno, errorEvent.colno, errorEvent.error);
        if (result === true) event.preventDefault();
    } else {
        result = listener && listener.apply(this, arguments);
        if (// https://github.com/angular/angular/issues/47579
        // https://www.w3.org/TR/2011/WD-html5-20110525/history.html#beforeunloadevent
        // This is the only specific case we should check for. The spec defines that the
        // `returnValue` attribute represents the message to show the user. When the event
        // is created, this attribute must be set to the empty string.
        event.type === 'beforeunload' && // To prevent any breaking changes resulting from this change, given that
        // it was already causing a significant number of failures in G3, we have hidden
        // that behavior behind a global configuration flag. Consumers can enable this
        // flag explicitly if they want the `beforeunload` event to be handled as defined
        // in the specification.
        $d9497ea901ae627a$var$_global[$d9497ea901ae627a$var$enableBeforeunloadSymbol] && // The IDL event definition is `attribute DOMString returnValue`, so we check whether
        // `typeof result` is a string.
        typeof result === 'string') event.returnValue = result;
        else if (result != undefined && !result) event.preventDefault();
    }
    return result;
};
function $d9497ea901ae627a$var$patchProperty(obj, prop, prototype) {
    let desc = $d9497ea901ae627a$var$ObjectGetOwnPropertyDescriptor(obj, prop);
    if (!desc && prototype) {
        // when patch window object, use prototype to check prop exist or not
        const prototypeDesc = $d9497ea901ae627a$var$ObjectGetOwnPropertyDescriptor(prototype, prop);
        if (prototypeDesc) desc = {
            enumerable: true,
            configurable: true
        };
    }
    // if the descriptor not exists or is not configurable
    // just return
    if (!desc || !desc.configurable) return;
    const onPropPatchedSymbol = $d9497ea901ae627a$var$zoneSymbol('on' + prop + 'patched');
    if (obj.hasOwnProperty(onPropPatchedSymbol) && obj[onPropPatchedSymbol]) return;
    // A property descriptor cannot have getter/setter and be writable
    // deleting the writable and value properties avoids this error:
    //
    // TypeError: property descriptors must not specify a value or be writable when a
    // getter or setter has been specified
    delete desc.writable;
    delete desc.value;
    const originalDescGet = desc.get;
    const originalDescSet = desc.set;
    // slice(2) cuz 'onclick' -> 'click', etc
    const eventName = prop.slice(2);
    let eventNameSymbol = $d9497ea901ae627a$var$zoneSymbolEventNames$1[eventName];
    if (!eventNameSymbol) eventNameSymbol = $d9497ea901ae627a$var$zoneSymbolEventNames$1[eventName] = $d9497ea901ae627a$var$zoneSymbol('ON_PROPERTY' + eventName);
    desc.set = function(newValue) {
        // In some versions of Windows, the `this` context may be undefined
        // in on-property callbacks.
        // To handle this edge case, we check if `this` is falsy and
        // fallback to `_global` if needed.
        let target = this;
        if (!target && obj === $d9497ea901ae627a$var$_global) target = $d9497ea901ae627a$var$_global;
        if (!target) return;
        const previousValue = target[eventNameSymbol];
        if (typeof previousValue === 'function') target.removeEventListener(eventName, $d9497ea901ae627a$var$wrapFn);
        // https://github.com/angular/zone.js/issues/978
        // If an inline handler (like `onload`) was defined before zone.js was loaded,
        // call the original descriptor's setter to clean it up.
        originalDescSet?.call(target, null);
        target[eventNameSymbol] = newValue;
        if (typeof newValue === 'function') target.addEventListener(eventName, $d9497ea901ae627a$var$wrapFn, false);
    };
    // The getter would return undefined for unassigned properties but the default value of an
    // unassigned property is null
    desc.get = function() {
        // in some of windows's onproperty callback, this is undefined
        // so we need to check it
        let target = this;
        if (!target && obj === $d9497ea901ae627a$var$_global) target = $d9497ea901ae627a$var$_global;
        if (!target) return null;
        const listener = target[eventNameSymbol];
        if (listener) return listener;
        else if (originalDescGet) {
            // result will be null when use inline event attribute,
            // such as <button onclick="func();">OK</button>
            // because the onclick function is internal raw uncompiled handler
            // the onclick will be evaluated when first time event was triggered or
            // the property is accessed, https://github.com/angular/zone.js/issues/525
            // so we should use original native get to retrieve the handler
            let value = originalDescGet.call(this);
            if (value) {
                desc.set.call(this, value);
                if (typeof target[$d9497ea901ae627a$var$REMOVE_ATTRIBUTE] === 'function') target.removeAttribute(prop);
                return value;
            }
        }
        return null;
    };
    $d9497ea901ae627a$var$ObjectDefineProperty(obj, prop, desc);
    obj[onPropPatchedSymbol] = true;
}
function $d9497ea901ae627a$var$patchOnProperties(obj, properties, prototype) {
    if (properties) for(let i = 0; i < properties.length; i++)$d9497ea901ae627a$var$patchProperty(obj, 'on' + properties[i], prototype);
    else {
        const onProperties = [];
        for(const prop in obj)if (prop.slice(0, 2) == 'on') onProperties.push(prop);
        for(let j = 0; j < onProperties.length; j++)$d9497ea901ae627a$var$patchProperty(obj, onProperties[j], prototype);
    }
}
const $d9497ea901ae627a$var$originalInstanceKey = $d9497ea901ae627a$var$zoneSymbol('originalInstance');
// wrap some native API on `window`
function $d9497ea901ae627a$var$patchClass(className) {
    const OriginalClass = $d9497ea901ae627a$var$_global[className];
    if (!OriginalClass) return;
    // keep original class in global
    $d9497ea901ae627a$var$_global[$d9497ea901ae627a$var$zoneSymbol(className)] = OriginalClass;
    $d9497ea901ae627a$var$_global[className] = function() {
        const a = $d9497ea901ae627a$var$bindArguments(arguments, className);
        switch(a.length){
            case 0:
                this[$d9497ea901ae627a$var$originalInstanceKey] = new OriginalClass();
                break;
            case 1:
                this[$d9497ea901ae627a$var$originalInstanceKey] = new OriginalClass(a[0]);
                break;
            case 2:
                this[$d9497ea901ae627a$var$originalInstanceKey] = new OriginalClass(a[0], a[1]);
                break;
            case 3:
                this[$d9497ea901ae627a$var$originalInstanceKey] = new OriginalClass(a[0], a[1], a[2]);
                break;
            case 4:
                this[$d9497ea901ae627a$var$originalInstanceKey] = new OriginalClass(a[0], a[1], a[2], a[3]);
                break;
            default:
                throw new Error('Arg list too long.');
        }
    };
    // attach original delegate to patched function
    $d9497ea901ae627a$var$attachOriginToPatched($d9497ea901ae627a$var$_global[className], OriginalClass);
    const instance = new OriginalClass(function() {});
    let prop;
    for(prop in instance){
        // https://bugs.webkit.org/show_bug.cgi?id=44721
        if (className === 'XMLHttpRequest' && prop === 'responseBlob') continue;
        (function(prop) {
            if (typeof instance[prop] === 'function') $d9497ea901ae627a$var$_global[className].prototype[prop] = function() {
                return this[$d9497ea901ae627a$var$originalInstanceKey][prop].apply(this[$d9497ea901ae627a$var$originalInstanceKey], arguments);
            };
            else $d9497ea901ae627a$var$ObjectDefineProperty($d9497ea901ae627a$var$_global[className].prototype, prop, {
                set: function(fn) {
                    if (typeof fn === 'function') {
                        this[$d9497ea901ae627a$var$originalInstanceKey][prop] = $d9497ea901ae627a$var$wrapWithCurrentZone(fn, className + '.' + prop);
                        // keep callback in wrapped function so we can
                        // use it in Function.prototype.toString to return
                        // the native one.
                        $d9497ea901ae627a$var$attachOriginToPatched(this[$d9497ea901ae627a$var$originalInstanceKey][prop], fn);
                    } else this[$d9497ea901ae627a$var$originalInstanceKey][prop] = fn;
                },
                get: function() {
                    return this[$d9497ea901ae627a$var$originalInstanceKey][prop];
                }
            });
        })(prop);
    }
    for(prop in OriginalClass)if (prop !== 'prototype' && OriginalClass.hasOwnProperty(prop)) $d9497ea901ae627a$var$_global[className][prop] = OriginalClass[prop];
}
function $d9497ea901ae627a$var$patchMethod(target, name, patchFn) {
    let proto = target;
    while(proto && !proto.hasOwnProperty(name))proto = $d9497ea901ae627a$var$ObjectGetPrototypeOf(proto);
    if (!proto && target[name]) // somehow we did not find it, but we can see it. This happens on IE for Window properties.
    proto = target;
    const delegateName = $d9497ea901ae627a$var$zoneSymbol(name);
    let delegate = null;
    if (proto && (!(delegate = proto[delegateName]) || !proto.hasOwnProperty(delegateName))) {
        delegate = proto[delegateName] = proto[name];
        // check whether proto[name] is writable
        // some property is readonly in safari, such as HtmlCanvasElement.prototype.toBlob
        const desc = proto && $d9497ea901ae627a$var$ObjectGetOwnPropertyDescriptor(proto, name);
        if ($d9497ea901ae627a$var$isPropertyWritable(desc)) {
            const patchDelegate = patchFn(delegate, delegateName, name);
            proto[name] = function() {
                return patchDelegate(this, arguments);
            };
            $d9497ea901ae627a$var$attachOriginToPatched(proto[name], delegate);
        }
    }
    return delegate;
}
// TODO: @JiaLiPassion, support cancel task later if necessary
function $d9497ea901ae627a$var$patchMacroTask(obj, funcName, metaCreator) {
    let setNative = null;
    function scheduleTask(task) {
        const data = task.data;
        data.args[data.cbIdx] = function() {
            task.invoke.apply(this, arguments);
        };
        setNative.apply(data.target, data.args);
        return task;
    }
    setNative = $d9497ea901ae627a$var$patchMethod(obj, funcName, (delegate)=>function(self1, args) {
            const meta = metaCreator(self1, args);
            if (meta.cbIdx >= 0 && typeof args[meta.cbIdx] === 'function') return $d9497ea901ae627a$var$scheduleMacroTaskWithCurrentZone(meta.name, args[meta.cbIdx], meta, scheduleTask);
            else // cause an error by calling it directly.
            return delegate.apply(self1, args);
        });
}
function $d9497ea901ae627a$var$attachOriginToPatched(patched, original) {
    patched[$d9497ea901ae627a$var$zoneSymbol('OriginalDelegate')] = original;
}
let $d9497ea901ae627a$var$isDetectedIEOrEdge = false;
let $d9497ea901ae627a$var$ieOrEdge = false;
function $d9497ea901ae627a$var$isIEOrEdge() {
    if ($d9497ea901ae627a$var$isDetectedIEOrEdge) return $d9497ea901ae627a$var$ieOrEdge;
    $d9497ea901ae627a$var$isDetectedIEOrEdge = true;
    try {
        const ua = $d9497ea901ae627a$var$internalWindow.navigator.userAgent;
        if (ua.indexOf('MSIE ') !== -1 || ua.indexOf('Trident/') !== -1 || ua.indexOf('Edge/') !== -1) $d9497ea901ae627a$var$ieOrEdge = true;
    } catch (error) {}
    return $d9497ea901ae627a$var$ieOrEdge;
}
function $d9497ea901ae627a$var$isFunction(value) {
    return typeof value === 'function';
}
function $d9497ea901ae627a$var$isNumber(value) {
    return typeof value === 'number';
}
/**
 * @fileoverview
 * @suppress {missingRequire}
 */ // an identifier to tell ZoneTask do not create a new invoke closure
const $d9497ea901ae627a$var$OPTIMIZED_ZONE_EVENT_TASK_DATA = {
    useG: true
};
const $d9497ea901ae627a$var$zoneSymbolEventNames = {};
const $d9497ea901ae627a$var$globalSources = {};
const $d9497ea901ae627a$var$EVENT_NAME_SYMBOL_REGX = new RegExp('^' + $d9497ea901ae627a$var$ZONE_SYMBOL_PREFIX + '(\\w+)(true|false)$');
const $d9497ea901ae627a$var$IMMEDIATE_PROPAGATION_SYMBOL = $d9497ea901ae627a$var$zoneSymbol('propagationStopped');
function $d9497ea901ae627a$var$prepareEventNames(eventName, eventNameToString) {
    const falseEventName = (eventNameToString ? eventNameToString(eventName) : eventName) + $d9497ea901ae627a$var$FALSE_STR;
    const trueEventName = (eventNameToString ? eventNameToString(eventName) : eventName) + $d9497ea901ae627a$var$TRUE_STR;
    const symbol = $d9497ea901ae627a$var$ZONE_SYMBOL_PREFIX + falseEventName;
    const symbolCapture = $d9497ea901ae627a$var$ZONE_SYMBOL_PREFIX + trueEventName;
    $d9497ea901ae627a$var$zoneSymbolEventNames[eventName] = {};
    $d9497ea901ae627a$var$zoneSymbolEventNames[eventName][$d9497ea901ae627a$var$FALSE_STR] = symbol;
    $d9497ea901ae627a$var$zoneSymbolEventNames[eventName][$d9497ea901ae627a$var$TRUE_STR] = symbolCapture;
}
function $d9497ea901ae627a$var$patchEventTarget(_global, api, apis, patchOptions) {
    const ADD_EVENT_LISTENER = patchOptions && patchOptions.add || $d9497ea901ae627a$var$ADD_EVENT_LISTENER_STR;
    const REMOVE_EVENT_LISTENER = patchOptions && patchOptions.rm || $d9497ea901ae627a$var$REMOVE_EVENT_LISTENER_STR;
    const LISTENERS_EVENT_LISTENER = patchOptions && patchOptions.listeners || 'eventListeners';
    const REMOVE_ALL_LISTENERS_EVENT_LISTENER = patchOptions && patchOptions.rmAll || 'removeAllListeners';
    const zoneSymbolAddEventListener = $d9497ea901ae627a$var$zoneSymbol(ADD_EVENT_LISTENER);
    const ADD_EVENT_LISTENER_SOURCE = '.' + ADD_EVENT_LISTENER + ':';
    const PREPEND_EVENT_LISTENER = 'prependListener';
    const PREPEND_EVENT_LISTENER_SOURCE = '.' + PREPEND_EVENT_LISTENER + ':';
    const invokeTask = function(task, target, event) {
        // for better performance, check isRemoved which is set
        // by removeEventListener
        if (task.isRemoved) return;
        const delegate = task.callback;
        if (typeof delegate === 'object' && delegate.handleEvent) {
            // create the bind version of handleEvent when invoke
            task.callback = (event)=>delegate.handleEvent(event);
            task.originalDelegate = delegate;
        }
        // invoke static task.invoke
        // need to try/catch error here, otherwise, the error in one event listener
        // will break the executions of the other event listeners. Also error will
        // not remove the event listener when `once` options is true.
        let error;
        try {
            task.invoke(task, target, [
                event
            ]);
        } catch (err) {
            error = err;
        }
        const options = task.options;
        if (options && typeof options === 'object' && options.once) {
            // if options.once is true, after invoke once remove listener here
            // only browser need to do this, nodejs eventEmitter will cal removeListener
            // inside EventEmitter.once
            const delegate = task.originalDelegate ? task.originalDelegate : task.callback;
            target[REMOVE_EVENT_LISTENER].call(target, event.type, delegate, options);
        }
        return error;
    };
    function globalCallback(context, event, isCapture) {
        // https://github.com/angular/zone.js/issues/911, in IE, sometimes
        // event will be undefined, so we need to use window.event
        event = event || _global.event;
        if (!event) return;
        // event.target is needed for Samsung TV and SourceBuffer
        // || global is needed https://github.com/angular/zone.js/issues/190
        const target = context || event.target || _global;
        const tasks = target[$d9497ea901ae627a$var$zoneSymbolEventNames[event.type][isCapture ? $d9497ea901ae627a$var$TRUE_STR : $d9497ea901ae627a$var$FALSE_STR]];
        if (tasks) {
            const errors = [];
            // invoke all tasks which attached to current target with given event.type and capture = false
            // for performance concern, if task.length === 1, just invoke
            if (tasks.length === 1) {
                const err = invokeTask(tasks[0], target, event);
                err && errors.push(err);
            } else {
                // https://github.com/angular/zone.js/issues/836
                // copy the tasks array before invoke, to avoid
                // the callback will remove itself or other listener
                const copyTasks = tasks.slice();
                for(let i = 0; i < copyTasks.length; i++){
                    if (event && event[$d9497ea901ae627a$var$IMMEDIATE_PROPAGATION_SYMBOL] === true) break;
                    const err = invokeTask(copyTasks[i], target, event);
                    err && errors.push(err);
                }
            }
            // Since there is only one error, we don't need to schedule microTask
            // to throw the error.
            if (errors.length === 1) throw errors[0];
            else for(let i = 0; i < errors.length; i++){
                const err = errors[i];
                api.nativeScheduleMicroTask(()=>{
                    throw err;
                });
            }
        }
    }
    // global shared zoneAwareCallback to handle all event callback with capture = false
    const globalZoneAwareCallback = function(event) {
        return globalCallback(this, event, false);
    };
    // global shared zoneAwareCallback to handle all event callback with capture = true
    const globalZoneAwareCaptureCallback = function(event) {
        return globalCallback(this, event, true);
    };
    function patchEventTargetMethods(obj, patchOptions) {
        if (!obj) return false;
        let useGlobalCallback = true;
        if (patchOptions && patchOptions.useG !== undefined) useGlobalCallback = patchOptions.useG;
        const validateHandler = patchOptions && patchOptions.vh;
        let checkDuplicate = true;
        if (patchOptions && patchOptions.chkDup !== undefined) checkDuplicate = patchOptions.chkDup;
        let returnTarget = false;
        if (patchOptions && patchOptions.rt !== undefined) returnTarget = patchOptions.rt;
        let proto = obj;
        while(proto && !proto.hasOwnProperty(ADD_EVENT_LISTENER))proto = $d9497ea901ae627a$var$ObjectGetPrototypeOf(proto);
        if (!proto && obj[ADD_EVENT_LISTENER]) // somehow we did not find it, but we can see it. This happens on IE for Window properties.
        proto = obj;
        if (!proto) return false;
        if (proto[zoneSymbolAddEventListener]) return false;
        const eventNameToString = patchOptions && patchOptions.eventNameToString;
        // We use a shared global `taskData` to pass data for `scheduleEventTask`,
        // eliminating the need to create a new object solely for passing data.
        // WARNING: This object has a static lifetime, meaning it is not created
        // each time `addEventListener` is called. It is instantiated only once
        // and captured by reference inside the `addEventListener` and
        // `removeEventListener` functions. Do not add any new properties to this
        // object, as doing so would necessitate maintaining the information
        // between `addEventListener` calls.
        const taskData = {};
        const nativeAddEventListener = proto[zoneSymbolAddEventListener] = proto[ADD_EVENT_LISTENER];
        const nativeRemoveEventListener = proto[$d9497ea901ae627a$var$zoneSymbol(REMOVE_EVENT_LISTENER)] = proto[REMOVE_EVENT_LISTENER];
        const nativeListeners = proto[$d9497ea901ae627a$var$zoneSymbol(LISTENERS_EVENT_LISTENER)] = proto[LISTENERS_EVENT_LISTENER];
        const nativeRemoveAllListeners = proto[$d9497ea901ae627a$var$zoneSymbol(REMOVE_ALL_LISTENERS_EVENT_LISTENER)] = proto[REMOVE_ALL_LISTENERS_EVENT_LISTENER];
        let nativePrependEventListener;
        if (patchOptions && patchOptions.prepend) nativePrependEventListener = proto[$d9497ea901ae627a$var$zoneSymbol(patchOptions.prepend)] = proto[patchOptions.prepend];
        /**
         * This util function will build an option object with passive option
         * to handle all possible input from the user.
         */ function buildEventListenerOptions(options, passive) {
            if (!passive) return options;
            if (typeof options === 'boolean') return {
                capture: options,
                passive: true
            };
            if (!options) return {
                passive: true
            };
            if (typeof options === 'object' && options.passive !== false) return {
                ...options,
                passive: true
            };
            return options;
        }
        const customScheduleGlobal = function(task) {
            // if there is already a task for the eventName + capture,
            // just return, because we use the shared globalZoneAwareCallback here.
            if (taskData.isExisting) return;
            return nativeAddEventListener.call(taskData.target, taskData.eventName, taskData.capture ? globalZoneAwareCaptureCallback : globalZoneAwareCallback, taskData.options);
        };
        /**
         * In the context of events and listeners, this function will be
         * called at the end by `cancelTask`, which, in turn, calls `task.cancelFn`.
         * Cancelling a task is primarily used to remove event listeners from
         * the task target.
         */ const customCancelGlobal = function(task) {
            // if task is not marked as isRemoved, this call is directly
            // from Zone.prototype.cancelTask, we should remove the task
            // from tasksList of target first
            if (!task.isRemoved) {
                const symbolEventNames = $d9497ea901ae627a$var$zoneSymbolEventNames[task.eventName];
                let symbolEventName;
                if (symbolEventNames) symbolEventName = symbolEventNames[task.capture ? $d9497ea901ae627a$var$TRUE_STR : $d9497ea901ae627a$var$FALSE_STR];
                const existingTasks = symbolEventName && task.target[symbolEventName];
                if (existingTasks) for(let i = 0; i < existingTasks.length; i++){
                    const existingTask = existingTasks[i];
                    if (existingTask === task) {
                        existingTasks.splice(i, 1);
                        // set isRemoved to data for faster invokeTask check
                        task.isRemoved = true;
                        if (task.removeAbortListener) {
                            task.removeAbortListener();
                            task.removeAbortListener = null;
                        }
                        if (existingTasks.length === 0) {
                            // all tasks for the eventName + capture have gone,
                            // remove globalZoneAwareCallback and remove the task cache from target
                            task.allRemoved = true;
                            task.target[symbolEventName] = null;
                        }
                        break;
                    }
                }
            }
            // if all tasks for the eventName + capture have gone,
            // we will really remove the global event callback,
            // if not, return
            if (!task.allRemoved) return;
            return nativeRemoveEventListener.call(task.target, task.eventName, task.capture ? globalZoneAwareCaptureCallback : globalZoneAwareCallback, task.options);
        };
        const customScheduleNonGlobal = function(task) {
            return nativeAddEventListener.call(taskData.target, taskData.eventName, task.invoke, taskData.options);
        };
        const customSchedulePrepend = function(task) {
            return nativePrependEventListener.call(taskData.target, taskData.eventName, task.invoke, taskData.options);
        };
        const customCancelNonGlobal = function(task) {
            return nativeRemoveEventListener.call(task.target, task.eventName, task.invoke, task.options);
        };
        const customSchedule = useGlobalCallback ? customScheduleGlobal : customScheduleNonGlobal;
        const customCancel = useGlobalCallback ? customCancelGlobal : customCancelNonGlobal;
        const compareTaskCallbackVsDelegate = function(task, delegate) {
            const typeOfDelegate = typeof delegate;
            return typeOfDelegate === 'function' && task.callback === delegate || typeOfDelegate === 'object' && task.originalDelegate === delegate;
        };
        const compare = patchOptions?.diff || compareTaskCallbackVsDelegate;
        const unpatchedEvents = Zone[$d9497ea901ae627a$var$zoneSymbol('UNPATCHED_EVENTS')];
        const passiveEvents = _global[$d9497ea901ae627a$var$zoneSymbol('PASSIVE_EVENTS')];
        function copyEventListenerOptions(options) {
            if (typeof options === 'object' && options !== null) {
                // We need to destructure the target `options` object since it may
                // be frozen or sealed (possibly provided implicitly by a third-party
                // library), or its properties may be readonly.
                const newOptions = {
                    ...options
                };
                // The `signal` option was recently introduced, which caused regressions in
                // third-party scenarios where `AbortController` was directly provided to
                // `addEventListener` as options. For instance, in cases like
                // `document.addEventListener('keydown', callback, abortControllerInstance)`,
                // which is valid because `AbortController` includes a `signal` getter, spreading
                // `{...options}` wouldn't copy the `signal`. Additionally, using `Object.create`
                // isn't feasible since `AbortController` is a built-in object type, and attempting
                // to create a new object directly with it as the prototype might result in
                // unexpected behavior.
                if (options.signal) newOptions.signal = options.signal;
                return newOptions;
            }
            return options;
        }
        const makeAddListener = function(nativeListener, addSource, customScheduleFn, customCancelFn, returnTarget = false, prepend = false) {
            return function() {
                const target = this || _global;
                let eventName = arguments[0];
                if (patchOptions && patchOptions.transferEventName) eventName = patchOptions.transferEventName(eventName);
                let delegate = arguments[1];
                if (!delegate) return nativeListener.apply(this, arguments);
                if ($d9497ea901ae627a$var$isNode && eventName === 'uncaughtException') // don't patch uncaughtException of nodejs to prevent endless loop
                return nativeListener.apply(this, arguments);
                // To improve `addEventListener` performance, we will create the callback
                // for the task later when the task is invoked.
                let isEventListenerObject = false;
                if (typeof delegate !== 'function') {
                    // This checks whether the provided listener argument is an object with
                    // a `handleEvent` method (since we can call `addEventListener` with a
                    // function `event => ...` or with an object `{ handleEvent: event => ... }`).
                    if (!delegate.handleEvent) return nativeListener.apply(this, arguments);
                    isEventListenerObject = true;
                }
                if (validateHandler && !validateHandler(nativeListener, delegate, target, arguments)) return;
                const passive = !!passiveEvents && passiveEvents.indexOf(eventName) !== -1;
                const options = copyEventListenerOptions(buildEventListenerOptions(arguments[2], passive));
                const signal = options?.signal;
                if (signal?.aborted) // the signal is an aborted one, just return without attaching the event listener.
                return;
                if (unpatchedEvents) {
                    // check unpatched list
                    for(let i = 0; i < unpatchedEvents.length; i++)if (eventName === unpatchedEvents[i]) {
                        if (passive) return nativeListener.call(target, eventName, delegate, options);
                        else return nativeListener.apply(this, arguments);
                    }
                }
                const capture = !options ? false : typeof options === 'boolean' ? true : options.capture;
                const once = options && typeof options === 'object' ? options.once : false;
                const zone = Zone.current;
                let symbolEventNames = $d9497ea901ae627a$var$zoneSymbolEventNames[eventName];
                if (!symbolEventNames) {
                    $d9497ea901ae627a$var$prepareEventNames(eventName, eventNameToString);
                    symbolEventNames = $d9497ea901ae627a$var$zoneSymbolEventNames[eventName];
                }
                const symbolEventName = symbolEventNames[capture ? $d9497ea901ae627a$var$TRUE_STR : $d9497ea901ae627a$var$FALSE_STR];
                let existingTasks = target[symbolEventName];
                let isExisting = false;
                if (existingTasks) {
                    // already have task registered
                    isExisting = true;
                    if (checkDuplicate) for(let i = 0; i < existingTasks.length; i++){
                        if (compare(existingTasks[i], delegate)) // same callback, same capture, same event name, just return
                        return;
                    }
                } else existingTasks = target[symbolEventName] = [];
                let source;
                const constructorName = target.constructor['name'];
                const targetSource = $d9497ea901ae627a$var$globalSources[constructorName];
                if (targetSource) source = targetSource[eventName];
                if (!source) source = constructorName + addSource + (eventNameToString ? eventNameToString(eventName) : eventName);
                // In the code below, `options` should no longer be reassigned; instead, it
                // should only be mutated. This is because we pass that object to the native
                // `addEventListener`.
                // It's generally recommended to use the same object reference for options.
                // This ensures consistency and avoids potential issues.
                taskData.options = options;
                if (once) // When using `addEventListener` with the `once` option, we don't pass
                // the `once` option directly to the native `addEventListener` method.
                // Instead, we keep the `once` setting and handle it ourselves.
                taskData.options.once = false;
                taskData.target = target;
                taskData.capture = capture;
                taskData.eventName = eventName;
                taskData.isExisting = isExisting;
                const data = useGlobalCallback ? $d9497ea901ae627a$var$OPTIMIZED_ZONE_EVENT_TASK_DATA : undefined;
                // keep taskData into data to allow onScheduleEventTask to access the task information
                if (data) data.taskData = taskData;
                if (signal) // When using `addEventListener` with the `signal` option, we don't pass
                // the `signal` option directly to the native `addEventListener` method.
                // Instead, we keep the `signal` setting and handle it ourselves.
                taskData.options.signal = undefined;
                // The `scheduleEventTask` function will ultimately call `customScheduleGlobal`,
                // which in turn calls the native `addEventListener`. This is why `taskData.options`
                // is updated before scheduling the task, as `customScheduleGlobal` uses
                // `taskData.options` to pass it to the native `addEventListener`.
                const task = zone.scheduleEventTask(source, delegate, data, customScheduleFn, customCancelFn);
                if (signal) {
                    // after task is scheduled, we need to store the signal back to task.options
                    taskData.options.signal = signal;
                    // Wrapping `task` in a weak reference would not prevent memory leaks. Weak references are
                    // primarily used for preventing strong references cycles. `onAbort` is always reachable
                    // as it's an event listener, so its closure retains a strong reference to the `task`.
                    const onAbort = ()=>task.zone.cancelTask(task);
                    nativeListener.call(signal, 'abort', onAbort, {
                        once: true
                    });
                    // We need to remove the `abort` listener when the event listener is going to be removed,
                    // as it creates a closure that captures `task`. This closure retains a reference to the
                    // `task` object even after it goes out of scope, preventing `task` from being garbage
                    // collected.
                    task.removeAbortListener = ()=>signal.removeEventListener('abort', onAbort);
                }
                // should clear taskData.target to avoid memory leak
                // issue, https://github.com/angular/angular/issues/20442
                taskData.target = null;
                // need to clear up taskData because it is a global object
                if (data) data.taskData = null;
                // have to save those information to task in case
                // application may call task.zone.cancelTask() directly
                if (once) taskData.options.once = true;
                if (typeof task.options !== 'boolean') // We should save the options on the task (if it's an object) because
                // we'll be using `task.options` later when removing the event listener
                // and passing it back to `removeEventListener`.
                task.options = options;
                task.target = target;
                task.capture = capture;
                task.eventName = eventName;
                if (isEventListenerObject) // save original delegate for compare to check duplicate
                task.originalDelegate = delegate;
                if (!prepend) existingTasks.push(task);
                else existingTasks.unshift(task);
                if (returnTarget) return target;
            };
        };
        proto[ADD_EVENT_LISTENER] = makeAddListener(nativeAddEventListener, ADD_EVENT_LISTENER_SOURCE, customSchedule, customCancel, returnTarget);
        if (nativePrependEventListener) proto[PREPEND_EVENT_LISTENER] = makeAddListener(nativePrependEventListener, PREPEND_EVENT_LISTENER_SOURCE, customSchedulePrepend, customCancel, returnTarget, true);
        proto[REMOVE_EVENT_LISTENER] = function() {
            const target = this || _global;
            let eventName = arguments[0];
            if (patchOptions && patchOptions.transferEventName) eventName = patchOptions.transferEventName(eventName);
            const options = arguments[2];
            const capture = !options ? false : typeof options === 'boolean' ? true : options.capture;
            const delegate = arguments[1];
            if (!delegate) return nativeRemoveEventListener.apply(this, arguments);
            if (validateHandler && !validateHandler(nativeRemoveEventListener, delegate, target, arguments)) return;
            const symbolEventNames = $d9497ea901ae627a$var$zoneSymbolEventNames[eventName];
            let symbolEventName;
            if (symbolEventNames) symbolEventName = symbolEventNames[capture ? $d9497ea901ae627a$var$TRUE_STR : $d9497ea901ae627a$var$FALSE_STR];
            const existingTasks = symbolEventName && target[symbolEventName];
            // `existingTasks` may not exist if the `addEventListener` was called before
            // it was patched by zone.js. Please refer to the attached issue for
            // clarification, particularly after the `if` condition, before calling
            // the native `removeEventListener`.
            if (existingTasks) for(let i = 0; i < existingTasks.length; i++){
                const existingTask = existingTasks[i];
                if (compare(existingTask, delegate)) {
                    existingTasks.splice(i, 1);
                    // set isRemoved to data for faster invokeTask check
                    existingTask.isRemoved = true;
                    if (existingTasks.length === 0) {
                        // all tasks for the eventName + capture have gone,
                        // remove globalZoneAwareCallback and remove the task cache from target
                        existingTask.allRemoved = true;
                        target[symbolEventName] = null;
                        // in the target, we have an event listener which is added by on_property
                        // such as target.onclick = function() {}, so we need to clear this internal
                        // property too if all delegates with capture=false were removed
                        // https:// github.com/angular/angular/issues/31643
                        // https://github.com/angular/angular/issues/54581
                        if (!capture && typeof eventName === 'string') {
                            const onPropertySymbol = $d9497ea901ae627a$var$ZONE_SYMBOL_PREFIX + 'ON_PROPERTY' + eventName;
                            target[onPropertySymbol] = null;
                        }
                    }
                    // In all other conditions, when `addEventListener` is called after being
                    // patched by zone.js, we would always find an event task on the `EventTarget`.
                    // This will trigger `cancelFn` on the `existingTask`, leading to `customCancelGlobal`,
                    // which ultimately removes an event listener and cleans up the abort listener
                    // (if an `AbortSignal` was provided when scheduling a task).
                    existingTask.zone.cancelTask(existingTask);
                    if (returnTarget) return target;
                    return;
                }
            }
            // https://github.com/angular/zone.js/issues/930
            // We may encounter a situation where the `addEventListener` was
            // called on the event target before zone.js is loaded, resulting
            // in no task being stored on the event target due to its invocation
            // of the native implementation. In this scenario, we simply need to
            // invoke the native `removeEventListener`.
            return nativeRemoveEventListener.apply(this, arguments);
        };
        proto[LISTENERS_EVENT_LISTENER] = function() {
            const target = this || _global;
            let eventName = arguments[0];
            if (patchOptions && patchOptions.transferEventName) eventName = patchOptions.transferEventName(eventName);
            const listeners = [];
            const tasks = $d9497ea901ae627a$var$findEventTasks(target, eventNameToString ? eventNameToString(eventName) : eventName);
            for(let i = 0; i < tasks.length; i++){
                const task = tasks[i];
                let delegate = task.originalDelegate ? task.originalDelegate : task.callback;
                listeners.push(delegate);
            }
            return listeners;
        };
        proto[REMOVE_ALL_LISTENERS_EVENT_LISTENER] = function() {
            const target = this || _global;
            let eventName = arguments[0];
            if (!eventName) {
                const keys = Object.keys(target);
                for(let i = 0; i < keys.length; i++){
                    const prop = keys[i];
                    const match = $d9497ea901ae627a$var$EVENT_NAME_SYMBOL_REGX.exec(prop);
                    let evtName = match && match[1];
                    // in nodejs EventEmitter, removeListener event is
                    // used for monitoring the removeListener call,
                    // so just keep removeListener eventListener until
                    // all other eventListeners are removed
                    if (evtName && evtName !== 'removeListener') this[REMOVE_ALL_LISTENERS_EVENT_LISTENER].call(this, evtName);
                }
                // remove removeListener listener finally
                this[REMOVE_ALL_LISTENERS_EVENT_LISTENER].call(this, 'removeListener');
            } else {
                if (patchOptions && patchOptions.transferEventName) eventName = patchOptions.transferEventName(eventName);
                const symbolEventNames = $d9497ea901ae627a$var$zoneSymbolEventNames[eventName];
                if (symbolEventNames) {
                    const symbolEventName = symbolEventNames[$d9497ea901ae627a$var$FALSE_STR];
                    const symbolCaptureEventName = symbolEventNames[$d9497ea901ae627a$var$TRUE_STR];
                    const tasks = target[symbolEventName];
                    const captureTasks = target[symbolCaptureEventName];
                    if (tasks) {
                        const removeTasks = tasks.slice();
                        for(let i = 0; i < removeTasks.length; i++){
                            const task = removeTasks[i];
                            let delegate = task.originalDelegate ? task.originalDelegate : task.callback;
                            this[REMOVE_EVENT_LISTENER].call(this, eventName, delegate, task.options);
                        }
                    }
                    if (captureTasks) {
                        const removeTasks = captureTasks.slice();
                        for(let i = 0; i < removeTasks.length; i++){
                            const task = removeTasks[i];
                            let delegate = task.originalDelegate ? task.originalDelegate : task.callback;
                            this[REMOVE_EVENT_LISTENER].call(this, eventName, delegate, task.options);
                        }
                    }
                }
            }
            if (returnTarget) return this;
        };
        // for native toString patch
        $d9497ea901ae627a$var$attachOriginToPatched(proto[ADD_EVENT_LISTENER], nativeAddEventListener);
        $d9497ea901ae627a$var$attachOriginToPatched(proto[REMOVE_EVENT_LISTENER], nativeRemoveEventListener);
        if (nativeRemoveAllListeners) $d9497ea901ae627a$var$attachOriginToPatched(proto[REMOVE_ALL_LISTENERS_EVENT_LISTENER], nativeRemoveAllListeners);
        if (nativeListeners) $d9497ea901ae627a$var$attachOriginToPatched(proto[LISTENERS_EVENT_LISTENER], nativeListeners);
        return true;
    }
    let results = [];
    for(let i = 0; i < apis.length; i++)results[i] = patchEventTargetMethods(apis[i], patchOptions);
    return results;
}
function $d9497ea901ae627a$var$findEventTasks(target, eventName) {
    if (!eventName) {
        const foundTasks = [];
        for(let prop in target){
            const match = $d9497ea901ae627a$var$EVENT_NAME_SYMBOL_REGX.exec(prop);
            let evtName = match && match[1];
            if (evtName && (!eventName || evtName === eventName)) {
                const tasks = target[prop];
                if (tasks) for(let i = 0; i < tasks.length; i++)foundTasks.push(tasks[i]);
            }
        }
        return foundTasks;
    }
    let symbolEventName = $d9497ea901ae627a$var$zoneSymbolEventNames[eventName];
    if (!symbolEventName) {
        $d9497ea901ae627a$var$prepareEventNames(eventName);
        symbolEventName = $d9497ea901ae627a$var$zoneSymbolEventNames[eventName];
    }
    const captureFalseTasks = target[symbolEventName[$d9497ea901ae627a$var$FALSE_STR]];
    const captureTrueTasks = target[symbolEventName[$d9497ea901ae627a$var$TRUE_STR]];
    if (!captureFalseTasks) return captureTrueTasks ? captureTrueTasks.slice() : [];
    else return captureTrueTasks ? captureFalseTasks.concat(captureTrueTasks) : captureFalseTasks.slice();
}
function $d9497ea901ae627a$var$patchEventPrototype(global, api) {
    const Event = global['Event'];
    if (Event && Event.prototype) api.patchMethod(Event.prototype, 'stopImmediatePropagation', (delegate)=>function(self1, args) {
            self1[$d9497ea901ae627a$var$IMMEDIATE_PROPAGATION_SYMBOL] = true;
            // we need to call the native stopImmediatePropagation
            // in case in some hybrid application, some part of
            // application will be controlled by zone, some are not
            delegate && delegate.apply(self1, args);
        });
}
/**
 * @fileoverview
 * @suppress {missingRequire}
 */ function $d9497ea901ae627a$var$patchQueueMicrotask(global, api) {
    api.patchMethod(global, 'queueMicrotask', (delegate)=>{
        return function(self1, args) {
            Zone.current.scheduleMicroTask('queueMicrotask', args[0]);
        };
    });
}
/**
 * @fileoverview
 * @suppress {missingRequire}
 */ const $d9497ea901ae627a$var$taskSymbol = $d9497ea901ae627a$var$zoneSymbol('zoneTask');
function $d9497ea901ae627a$var$patchTimer(window1, setName, cancelName, nameSuffix) {
    let setNative = null;
    let clearNative = null;
    setName += nameSuffix;
    cancelName += nameSuffix;
    const tasksByHandleId = {};
    function scheduleTask(task) {
        const data = task.data;
        data.args[0] = function() {
            return task.invoke.apply(this, arguments);
        };
        const handleOrId = setNative.apply(window1, data.args);
        // Whlist on Node.js when get can the ID by using `[Symbol.toPrimitive]()` we do
        // to this so that we do not cause potentally leaks when using `setTimeout`
        // since this can be periodic when using `.refresh`.
        if ($d9497ea901ae627a$var$isNumber(handleOrId)) data.handleId = handleOrId;
        else {
            data.handle = handleOrId;
            // On Node.js a timeout and interval can be restarted over and over again by using the `.refresh` method.
            data.isRefreshable = $d9497ea901ae627a$var$isFunction(handleOrId.refresh);
        }
        return task;
    }
    function clearTask(task) {
        const { handle: handle, handleId: handleId } = task.data;
        return clearNative.call(window1, handle ?? handleId);
    }
    setNative = $d9497ea901ae627a$var$patchMethod(window1, setName, (delegate)=>function(self1, args) {
            if ($d9497ea901ae627a$var$isFunction(args[0])) {
                const options = {
                    isRefreshable: false,
                    isPeriodic: nameSuffix === 'Interval',
                    delay: nameSuffix === 'Timeout' || nameSuffix === 'Interval' ? args[1] || 0 : undefined,
                    args: args
                };
                const callback = args[0];
                args[0] = function timer() {
                    try {
                        return callback.apply(this, arguments);
                    } finally{
                        // issue-934, task will be cancelled
                        // even it is a periodic task such as
                        // setInterval
                        // https://github.com/angular/angular/issues/40387
                        // Cleanup tasksByHandleId should be handled before scheduleTask
                        // Since some zoneSpec may intercept and doesn't trigger
                        // scheduleFn(scheduleTask) provided here.
                        const { handle: handle, handleId: handleId, isPeriodic: isPeriodic, isRefreshable: isRefreshable } = options;
                        if (!isPeriodic && !isRefreshable) {
                            if (handleId) // in non-nodejs env, we remove timerId
                            // from local cache
                            delete tasksByHandleId[handleId];
                            else if (handle) // Node returns complex objects as handleIds
                            // we remove task reference from timer object
                            handle[$d9497ea901ae627a$var$taskSymbol] = null;
                        }
                    }
                };
                const task = $d9497ea901ae627a$var$scheduleMacroTaskWithCurrentZone(setName, args[0], options, scheduleTask, clearTask);
                if (!task) return task;
                // Node.js must additionally support the ref and unref functions.
                const { handleId: handleId, handle: handle, isRefreshable: isRefreshable, isPeriodic: isPeriodic } = task.data;
                if (handleId) // for non nodejs env, we save handleId: task
                // mapping in local cache for clearTimeout
                tasksByHandleId[handleId] = task;
                else if (handle) {
                    // for nodejs env, we save task
                    // reference in timerId Object for clearTimeout
                    handle[$d9497ea901ae627a$var$taskSymbol] = task;
                    if (isRefreshable && !isPeriodic) {
                        const originalRefresh = handle.refresh;
                        handle.refresh = function() {
                            const { zone: zone, state: state } = task;
                            if (state === 'notScheduled') {
                                task._state = 'scheduled';
                                zone._updateTaskCount(task, 1);
                            } else if (state === 'running') task._state = 'scheduling';
                            return originalRefresh.call(this);
                        };
                    }
                }
                return handle ?? handleId ?? task;
            } else // cause an error by calling it directly.
            return delegate.apply(window1, args);
        });
    clearNative = $d9497ea901ae627a$var$patchMethod(window1, cancelName, (delegate)=>function(self1, args) {
            const id = args[0];
            let task;
            if ($d9497ea901ae627a$var$isNumber(id)) {
                // non nodejs env.
                task = tasksByHandleId[id];
                delete tasksByHandleId[id];
            } else {
                // nodejs env ?? other environments.
                task = id?.[$d9497ea901ae627a$var$taskSymbol];
                if (task) id[$d9497ea901ae627a$var$taskSymbol] = null;
                else task = id;
            }
            if (task?.type) {
                if (task.cancelFn) // Do not cancel already canceled functions
                task.zone.cancelTask(task);
            } else // cause an error by calling it directly.
            delegate.apply(window1, args);
        });
}
function $d9497ea901ae627a$var$patchCustomElements(_global, api) {
    const { isBrowser: isBrowser, isMix: isMix } = api.getGlobalObjects();
    if (!isBrowser && !isMix || !_global['customElements'] || !('customElements' in _global)) return;
    // https://html.spec.whatwg.org/multipage/custom-elements.html#concept-custom-element-definition-lifecycle-callbacks
    const callbacks = [
        'connectedCallback',
        'disconnectedCallback',
        'adoptedCallback',
        'attributeChangedCallback',
        'formAssociatedCallback',
        'formDisabledCallback',
        'formResetCallback',
        'formStateRestoreCallback'
    ];
    api.patchCallbacks(api, _global.customElements, 'customElements', 'define', callbacks);
}
function $d9497ea901ae627a$var$eventTargetPatch(_global, api) {
    if (Zone[api.symbol('patchEventTarget')]) // EventTarget is already patched.
    return;
    const { eventNames: eventNames, zoneSymbolEventNames: zoneSymbolEventNames, TRUE_STR: TRUE_STR, FALSE_STR: FALSE_STR, ZONE_SYMBOL_PREFIX: ZONE_SYMBOL_PREFIX } = api.getGlobalObjects();
    //  predefine all __zone_symbol__ + eventName + true/false string
    for(let i = 0; i < eventNames.length; i++){
        const eventName = eventNames[i];
        const falseEventName = eventName + FALSE_STR;
        const trueEventName = eventName + TRUE_STR;
        const symbol = ZONE_SYMBOL_PREFIX + falseEventName;
        const symbolCapture = ZONE_SYMBOL_PREFIX + trueEventName;
        zoneSymbolEventNames[eventName] = {};
        zoneSymbolEventNames[eventName][FALSE_STR] = symbol;
        zoneSymbolEventNames[eventName][TRUE_STR] = symbolCapture;
    }
    const EVENT_TARGET = _global['EventTarget'];
    if (!EVENT_TARGET || !EVENT_TARGET.prototype) return;
    api.patchEventTarget(_global, api, [
        EVENT_TARGET && EVENT_TARGET.prototype
    ]);
    return true;
}
function $d9497ea901ae627a$var$patchEvent(global, api) {
    api.patchEventPrototype(global, api);
}
/**
 * @fileoverview
 * @suppress {globalThis}
 */ function $d9497ea901ae627a$var$filterProperties(target, onProperties, ignoreProperties) {
    if (!ignoreProperties || ignoreProperties.length === 0) return onProperties;
    const tip = ignoreProperties.filter((ip)=>ip.target === target);
    if (tip.length === 0) return onProperties;
    const targetIgnoreProperties = tip[0].ignoreProperties;
    return onProperties.filter((op)=>targetIgnoreProperties.indexOf(op) === -1);
}
function $d9497ea901ae627a$var$patchFilteredProperties(target, onProperties, ignoreProperties, prototype) {
    // check whether target is available, sometimes target will be undefined
    // because different browser or some 3rd party plugin.
    if (!target) return;
    const filteredProperties = $d9497ea901ae627a$var$filterProperties(target, onProperties, ignoreProperties);
    $d9497ea901ae627a$var$patchOnProperties(target, filteredProperties, prototype);
}
/**
 * Get all event name properties which the event name startsWith `on`
 * from the target object itself, inherited properties are not considered.
 */ function $d9497ea901ae627a$var$getOnEventNames(target) {
    return Object.getOwnPropertyNames(target).filter((name)=>name.startsWith('on') && name.length > 2).map((name)=>name.substring(2));
}
function $d9497ea901ae627a$var$propertyDescriptorPatch(api, _global) {
    if ($d9497ea901ae627a$var$isNode && !$d9497ea901ae627a$var$isMix) return;
    if (Zone[api.symbol('patchEvents')]) // events are already been patched by legacy patch.
    return;
    const ignoreProperties = _global['__Zone_ignore_on_properties'];
    // for browsers that we can patch the descriptor:  Chrome & Firefox
    let patchTargets = [];
    if ($d9497ea901ae627a$var$isBrowser) {
        const internalWindow = window;
        patchTargets = patchTargets.concat([
            'Document',
            'SVGElement',
            'Element',
            'HTMLElement',
            'HTMLBodyElement',
            'HTMLMediaElement',
            'HTMLFrameSetElement',
            'HTMLFrameElement',
            'HTMLIFrameElement',
            'HTMLMarqueeElement',
            'Worker'
        ]);
        const ignoreErrorProperties = [];
        // In older browsers like IE or Edge, event handler properties (e.g., `onclick`)
        // may not be defined directly on the `window` object but on its prototype (`WindowPrototype`).
        // To ensure complete coverage, we use the prototype when checking
        // for and patching these properties.
        $d9497ea901ae627a$var$patchFilteredProperties(internalWindow, $d9497ea901ae627a$var$getOnEventNames(internalWindow), ignoreProperties ? ignoreProperties.concat(ignoreErrorProperties) : ignoreProperties, $d9497ea901ae627a$var$ObjectGetPrototypeOf(internalWindow));
    }
    patchTargets = patchTargets.concat([
        'XMLHttpRequest',
        'XMLHttpRequestEventTarget',
        'IDBIndex',
        'IDBRequest',
        'IDBOpenDBRequest',
        'IDBDatabase',
        'IDBTransaction',
        'IDBCursor',
        'WebSocket'
    ]);
    for(let i = 0; i < patchTargets.length; i++){
        const target = _global[patchTargets[i]];
        target?.prototype && $d9497ea901ae627a$var$patchFilteredProperties(target.prototype, $d9497ea901ae627a$var$getOnEventNames(target.prototype), ignoreProperties);
    }
}
/**
 * @fileoverview
 * @suppress {missingRequire}
 */ function $d9497ea901ae627a$var$patchBrowser(Zone1) {
    Zone1.__load_patch('legacy', (global)=>{
        const legacyPatch = global[Zone1.__symbol__('legacyPatch')];
        if (legacyPatch) legacyPatch();
    });
    Zone1.__load_patch('timers', (global)=>{
        const set = 'set';
        const clear = 'clear';
        $d9497ea901ae627a$var$patchTimer(global, set, clear, 'Timeout');
        $d9497ea901ae627a$var$patchTimer(global, set, clear, 'Interval');
        $d9497ea901ae627a$var$patchTimer(global, set, clear, 'Immediate');
    });
    Zone1.__load_patch('requestAnimationFrame', (global)=>{
        $d9497ea901ae627a$var$patchTimer(global, 'request', 'cancel', 'AnimationFrame');
        $d9497ea901ae627a$var$patchTimer(global, 'mozRequest', 'mozCancel', 'AnimationFrame');
        $d9497ea901ae627a$var$patchTimer(global, 'webkitRequest', 'webkitCancel', 'AnimationFrame');
    });
    Zone1.__load_patch('blocking', (global, Zone1)=>{
        const blockingMethods = [
            'alert',
            'prompt',
            'confirm'
        ];
        for(let i = 0; i < blockingMethods.length; i++){
            const name = blockingMethods[i];
            $d9497ea901ae627a$var$patchMethod(global, name, (delegate, symbol, name)=>{
                return function(s, args) {
                    return Zone1.current.run(delegate, global, args, name);
                };
            });
        }
    });
    Zone1.__load_patch('EventTarget', (global, Zone1, api)=>{
        $d9497ea901ae627a$var$patchEvent(global, api);
        $d9497ea901ae627a$var$eventTargetPatch(global, api);
        // patch XMLHttpRequestEventTarget's addEventListener/removeEventListener
        const XMLHttpRequestEventTarget = global['XMLHttpRequestEventTarget'];
        if (XMLHttpRequestEventTarget && XMLHttpRequestEventTarget.prototype) api.patchEventTarget(global, api, [
            XMLHttpRequestEventTarget.prototype
        ]);
    });
    Zone1.__load_patch('MutationObserver', (global, Zone1, api)=>{
        $d9497ea901ae627a$var$patchClass('MutationObserver');
        $d9497ea901ae627a$var$patchClass('WebKitMutationObserver');
    });
    Zone1.__load_patch('IntersectionObserver', (global, Zone1, api)=>{
        $d9497ea901ae627a$var$patchClass('IntersectionObserver');
    });
    Zone1.__load_patch('FileReader', (global, Zone1, api)=>{
        $d9497ea901ae627a$var$patchClass('FileReader');
    });
    Zone1.__load_patch('on_property', (global, Zone1, api)=>{
        $d9497ea901ae627a$var$propertyDescriptorPatch(api, global);
    });
    Zone1.__load_patch('customElements', (global, Zone1, api)=>{
        $d9497ea901ae627a$var$patchCustomElements(global, api);
    });
    Zone1.__load_patch('XHR', (global, Zone1)=>{
        // Treat XMLHttpRequest as a macrotask.
        patchXHR(global);
        const XHR_TASK = $d9497ea901ae627a$var$zoneSymbol('xhrTask');
        const XHR_SYNC = $d9497ea901ae627a$var$zoneSymbol('xhrSync');
        const XHR_LISTENER = $d9497ea901ae627a$var$zoneSymbol('xhrListener');
        const XHR_SCHEDULED = $d9497ea901ae627a$var$zoneSymbol('xhrScheduled');
        const XHR_URL = $d9497ea901ae627a$var$zoneSymbol('xhrURL');
        const XHR_ERROR_BEFORE_SCHEDULED = $d9497ea901ae627a$var$zoneSymbol('xhrErrorBeforeScheduled');
        function patchXHR(window1) {
            const XMLHttpRequest = window1['XMLHttpRequest'];
            if (!XMLHttpRequest) // XMLHttpRequest is not available in service worker
            return;
            const XMLHttpRequestPrototype = XMLHttpRequest.prototype;
            function findPendingTask(target) {
                return target[XHR_TASK];
            }
            let oriAddListener = XMLHttpRequestPrototype[$d9497ea901ae627a$var$ZONE_SYMBOL_ADD_EVENT_LISTENER];
            let oriRemoveListener = XMLHttpRequestPrototype[$d9497ea901ae627a$var$ZONE_SYMBOL_REMOVE_EVENT_LISTENER];
            if (!oriAddListener) {
                const XMLHttpRequestEventTarget = window1['XMLHttpRequestEventTarget'];
                if (XMLHttpRequestEventTarget) {
                    const XMLHttpRequestEventTargetPrototype = XMLHttpRequestEventTarget.prototype;
                    oriAddListener = XMLHttpRequestEventTargetPrototype[$d9497ea901ae627a$var$ZONE_SYMBOL_ADD_EVENT_LISTENER];
                    oriRemoveListener = XMLHttpRequestEventTargetPrototype[$d9497ea901ae627a$var$ZONE_SYMBOL_REMOVE_EVENT_LISTENER];
                }
            }
            const READY_STATE_CHANGE = 'readystatechange';
            const SCHEDULED = 'scheduled';
            function scheduleTask(task) {
                const data = task.data;
                const target = data.target;
                target[XHR_SCHEDULED] = false;
                target[XHR_ERROR_BEFORE_SCHEDULED] = false;
                // remove existing event listener
                const listener = target[XHR_LISTENER];
                if (!oriAddListener) {
                    oriAddListener = target[$d9497ea901ae627a$var$ZONE_SYMBOL_ADD_EVENT_LISTENER];
                    oriRemoveListener = target[$d9497ea901ae627a$var$ZONE_SYMBOL_REMOVE_EVENT_LISTENER];
                }
                if (listener) oriRemoveListener.call(target, READY_STATE_CHANGE, listener);
                const newListener = target[XHR_LISTENER] = ()=>{
                    if (target.readyState === target.DONE) {
                        // sometimes on some browsers XMLHttpRequest will fire onreadystatechange with
                        // readyState=4 multiple times, so we need to check task state here
                        if (!data.aborted && target[XHR_SCHEDULED] && task.state === SCHEDULED) {
                            // check whether the xhr has registered onload listener
                            // if that is the case, the task should invoke after all
                            // onload listeners finish.
                            // Also if the request failed without response (status = 0), the load event handler
                            // will not be triggered, in that case, we should also invoke the placeholder callback
                            // to close the XMLHttpRequest::send macroTask.
                            // https://github.com/angular/angular/issues/38795
                            const loadTasks = target[Zone1.__symbol__('loadfalse')];
                            if (target.status !== 0 && loadTasks && loadTasks.length > 0) {
                                const oriInvoke = task.invoke;
                                task.invoke = function() {
                                    // need to load the tasks again, because in other
                                    // load listener, they may remove themselves
                                    const loadTasks = target[Zone1.__symbol__('loadfalse')];
                                    for(let i = 0; i < loadTasks.length; i++)if (loadTasks[i] === task) loadTasks.splice(i, 1);
                                    if (!data.aborted && task.state === SCHEDULED) oriInvoke.call(task);
                                };
                                loadTasks.push(task);
                            } else task.invoke();
                        } else if (!data.aborted && target[XHR_SCHEDULED] === false) // error occurs when xhr.send()
                        target[XHR_ERROR_BEFORE_SCHEDULED] = true;
                    }
                };
                oriAddListener.call(target, READY_STATE_CHANGE, newListener);
                const storedTask = target[XHR_TASK];
                if (!storedTask) target[XHR_TASK] = task;
                sendNative.apply(target, data.args);
                target[XHR_SCHEDULED] = true;
                return task;
            }
            function placeholderCallback() {}
            function clearTask(task) {
                const data = task.data;
                // Note - ideally, we would call data.target.removeEventListener here, but it's too late
                // to prevent it from firing. So instead, we store info for the event listener.
                data.aborted = true;
                return abortNative.apply(data.target, data.args);
            }
            const openNative = $d9497ea901ae627a$var$patchMethod(XMLHttpRequestPrototype, 'open', ()=>function(self1, args) {
                    self1[XHR_SYNC] = args[2] == false;
                    self1[XHR_URL] = args[1];
                    return openNative.apply(self1, args);
                });
            const XMLHTTPREQUEST_SOURCE = 'XMLHttpRequest.send';
            const fetchTaskAborting = $d9497ea901ae627a$var$zoneSymbol('fetchTaskAborting');
            const fetchTaskScheduling = $d9497ea901ae627a$var$zoneSymbol('fetchTaskScheduling');
            const sendNative = $d9497ea901ae627a$var$patchMethod(XMLHttpRequestPrototype, 'send', ()=>function(self1, args) {
                    if (Zone1.current[fetchTaskScheduling] === true) // a fetch is scheduling, so we are using xhr to polyfill fetch
                    // and because we already schedule macroTask for fetch, we should
                    // not schedule a macroTask for xhr again
                    return sendNative.apply(self1, args);
                    if (self1[XHR_SYNC]) // if the XHR is sync there is no task to schedule, just execute the code.
                    return sendNative.apply(self1, args);
                    else {
                        const options = {
                            target: self1,
                            url: self1[XHR_URL],
                            isPeriodic: false,
                            args: args,
                            aborted: false
                        };
                        const task = $d9497ea901ae627a$var$scheduleMacroTaskWithCurrentZone(XMLHTTPREQUEST_SOURCE, placeholderCallback, options, scheduleTask, clearTask);
                        if (self1 && self1[XHR_ERROR_BEFORE_SCHEDULED] === true && !options.aborted && task.state === SCHEDULED) // xhr request throw error when send
                        // we should invoke task instead of leaving a scheduled
                        // pending macroTask
                        task.invoke();
                    }
                });
            const abortNative = $d9497ea901ae627a$var$patchMethod(XMLHttpRequestPrototype, 'abort', ()=>function(self1, args) {
                    const task = findPendingTask(self1);
                    if (task && typeof task.type == 'string') {
                        // If the XHR has already completed, do nothing.
                        // If the XHR has already been aborted, do nothing.
                        // Fix #569, call abort multiple times before done will cause
                        // macroTask task count be negative number
                        if (task.cancelFn == null || task.data && task.data.aborted) return;
                        task.zone.cancelTask(task);
                    } else if (Zone1.current[fetchTaskAborting] === true) // the abort is called from fetch polyfill, we need to call native abort of XHR.
                    return abortNative.apply(self1, args);
                // Otherwise, we are trying to abort an XHR which has not yet been sent, so there is no
                // task
                // to cancel. Do nothing.
                });
        }
    });
    Zone1.__load_patch('geolocation', (global)=>{
        /// GEO_LOCATION
        if (global['navigator'] && global['navigator'].geolocation) $d9497ea901ae627a$var$patchPrototype(global['navigator'].geolocation, [
            'getCurrentPosition',
            'watchPosition'
        ]);
    });
    Zone1.__load_patch('PromiseRejectionEvent', (global, Zone1)=>{
        // handle unhandled promise rejection
        function findPromiseRejectionHandler(evtName) {
            return function(e) {
                const eventTasks = $d9497ea901ae627a$var$findEventTasks(global, evtName);
                eventTasks.forEach((eventTask)=>{
                    // windows has added unhandledrejection event listener
                    // trigger the event listener
                    const PromiseRejectionEvent = global['PromiseRejectionEvent'];
                    if (PromiseRejectionEvent) {
                        const evt = new PromiseRejectionEvent(evtName, {
                            promise: e.promise,
                            reason: e.rejection
                        });
                        eventTask.invoke(evt);
                    }
                });
            };
        }
        if (global['PromiseRejectionEvent']) {
            Zone1[$d9497ea901ae627a$var$zoneSymbol('unhandledPromiseRejectionHandler')] = findPromiseRejectionHandler('unhandledrejection');
            Zone1[$d9497ea901ae627a$var$zoneSymbol('rejectionHandledHandler')] = findPromiseRejectionHandler('rejectionhandled');
        }
    });
    Zone1.__load_patch('queueMicrotask', (global, Zone1, api)=>{
        $d9497ea901ae627a$var$patchQueueMicrotask(global, api);
    });
}
function $d9497ea901ae627a$var$patchPromise(Zone1) {
    Zone1.__load_patch('ZoneAwarePromise', (global, Zone1, api)=>{
        const ObjectGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
        const ObjectDefineProperty = Object.defineProperty;
        function readableObjectToString(obj) {
            if (obj && obj.toString === Object.prototype.toString) {
                const className = obj.constructor && obj.constructor.name;
                return (className ? className : '') + ': ' + JSON.stringify(obj);
            }
            return obj ? obj.toString() : Object.prototype.toString.call(obj);
        }
        const __symbol__ = api.symbol;
        const _uncaughtPromiseErrors = [];
        const isDisableWrappingUncaughtPromiseRejection = global[__symbol__('DISABLE_WRAPPING_UNCAUGHT_PROMISE_REJECTION')] !== false;
        const symbolPromise = __symbol__('Promise');
        const symbolThen = __symbol__('then');
        const creationTrace = '__creationTrace__';
        api.onUnhandledError = (e)=>{
            if (api.showUncaughtError()) {
                const rejection = e && e.rejection;
                if (rejection) console.error('Unhandled Promise rejection:', rejection instanceof Error ? rejection.message : rejection, '; Zone:', e.zone.name, '; Task:', e.task && e.task.source, '; Value:', rejection, rejection instanceof Error ? rejection.stack : undefined);
                else console.error(e);
            }
        };
        api.microtaskDrainDone = ()=>{
            while(_uncaughtPromiseErrors.length){
                const uncaughtPromiseError = _uncaughtPromiseErrors.shift();
                try {
                    uncaughtPromiseError.zone.runGuarded(()=>{
                        if (uncaughtPromiseError.throwOriginal) throw uncaughtPromiseError.rejection;
                        throw uncaughtPromiseError;
                    });
                } catch (error) {
                    handleUnhandledRejection(error);
                }
            }
        };
        const UNHANDLED_PROMISE_REJECTION_HANDLER_SYMBOL = __symbol__('unhandledPromiseRejectionHandler');
        function handleUnhandledRejection(e) {
            api.onUnhandledError(e);
            try {
                const handler = Zone1[UNHANDLED_PROMISE_REJECTION_HANDLER_SYMBOL];
                if (typeof handler === 'function') handler.call(this, e);
            } catch (err) {}
        }
        function isThenable(value) {
            return value && typeof value.then === 'function';
        }
        function forwardResolution(value) {
            return value;
        }
        function forwardRejection(rejection) {
            return ZoneAwarePromise.reject(rejection);
        }
        const symbolState = __symbol__('state');
        const symbolValue = __symbol__('value');
        const symbolFinally = __symbol__('finally');
        const symbolParentPromiseValue = __symbol__('parentPromiseValue');
        const symbolParentPromiseState = __symbol__('parentPromiseState');
        const source = 'Promise.then';
        const UNRESOLVED = null;
        const RESOLVED = true;
        const REJECTED = false;
        const REJECTED_NO_CATCH = 0;
        function makeResolver(promise, state) {
            return (v)=>{
                try {
                    resolvePromise(promise, state, v);
                } catch (err) {
                    resolvePromise(promise, false, err);
                }
            // Do not return value or you will break the Promise spec.
            };
        }
        const once = function() {
            let wasCalled = false;
            return function wrapper(wrappedFunction) {
                return function() {
                    if (wasCalled) return;
                    wasCalled = true;
                    wrappedFunction.apply(null, arguments);
                };
            };
        };
        const TYPE_ERROR = 'Promise resolved with itself';
        const CURRENT_TASK_TRACE_SYMBOL = __symbol__('currentTaskTrace');
        // Promise Resolution
        function resolvePromise(promise, state, value) {
            const onceWrapper = once();
            if (promise === value) throw new TypeError(TYPE_ERROR);
            if (promise[symbolState] === UNRESOLVED) {
                // should only get value.then once based on promise spec.
                let then = null;
                try {
                    if (typeof value === 'object' || typeof value === 'function') then = value && value.then;
                } catch (err) {
                    onceWrapper(()=>{
                        resolvePromise(promise, false, err);
                    })();
                    return promise;
                }
                // if (value instanceof ZoneAwarePromise) {
                if (state !== REJECTED && value instanceof ZoneAwarePromise && value.hasOwnProperty(symbolState) && value.hasOwnProperty(symbolValue) && value[symbolState] !== UNRESOLVED) {
                    clearRejectedNoCatch(value);
                    resolvePromise(promise, value[symbolState], value[symbolValue]);
                } else if (state !== REJECTED && typeof then === 'function') try {
                    then.call(value, onceWrapper(makeResolver(promise, state)), onceWrapper(makeResolver(promise, false)));
                } catch (err) {
                    onceWrapper(()=>{
                        resolvePromise(promise, false, err);
                    })();
                }
                else {
                    promise[symbolState] = state;
                    const queue = promise[symbolValue];
                    promise[symbolValue] = value;
                    if (promise[symbolFinally] === symbolFinally) // the promise is generated by Promise.prototype.finally
                    {
                        if (state === RESOLVED) {
                            // the state is resolved, should ignore the value
                            // and use parent promise value
                            promise[symbolState] = promise[symbolParentPromiseState];
                            promise[symbolValue] = promise[symbolParentPromiseValue];
                        }
                    }
                    // record task information in value when error occurs, so we can
                    // do some additional work such as render longStackTrace
                    if (state === REJECTED && value instanceof Error) {
                        // check if longStackTraceZone is here
                        const trace = Zone1.currentTask && Zone1.currentTask.data && Zone1.currentTask.data[creationTrace];
                        if (trace) // only keep the long stack trace into error when in longStackTraceZone
                        ObjectDefineProperty(value, CURRENT_TASK_TRACE_SYMBOL, {
                            configurable: true,
                            enumerable: false,
                            writable: true,
                            value: trace
                        });
                    }
                    for(let i = 0; i < queue.length;)scheduleResolveOrReject(promise, queue[i++], queue[i++], queue[i++], queue[i++]);
                    if (queue.length == 0 && state == REJECTED) {
                        promise[symbolState] = REJECTED_NO_CATCH;
                        let uncaughtPromiseError = value;
                        try {
                            // Here we throws a new Error to print more readable error log
                            // and if the value is not an error, zone.js builds an `Error`
                            // Object here to attach the stack information.
                            throw new Error('Uncaught (in promise): ' + readableObjectToString(value) + (value && value.stack ? '\n' + value.stack : ''));
                        } catch (err) {
                            uncaughtPromiseError = err;
                        }
                        if (isDisableWrappingUncaughtPromiseRejection) // If disable wrapping uncaught promise reject
                        // use the value instead of wrapping it.
                        uncaughtPromiseError.throwOriginal = true;
                        uncaughtPromiseError.rejection = value;
                        uncaughtPromiseError.promise = promise;
                        uncaughtPromiseError.zone = Zone1.current;
                        uncaughtPromiseError.task = Zone1.currentTask;
                        _uncaughtPromiseErrors.push(uncaughtPromiseError);
                        api.scheduleMicroTask(); // to make sure that it is running
                    }
                }
            }
            // Resolving an already resolved promise is a noop.
            return promise;
        }
        const REJECTION_HANDLED_HANDLER = __symbol__('rejectionHandledHandler');
        function clearRejectedNoCatch(promise) {
            if (promise[symbolState] === REJECTED_NO_CATCH) {
                // if the promise is rejected no catch status
                // and queue.length > 0, means there is a error handler
                // here to handle the rejected promise, we should trigger
                // windows.rejectionhandled eventHandler or nodejs rejectionHandled
                // eventHandler
                try {
                    const handler = Zone1[REJECTION_HANDLED_HANDLER];
                    if (handler && typeof handler === 'function') handler.call(this, {
                        rejection: promise[symbolValue],
                        promise: promise
                    });
                } catch (err) {}
                promise[symbolState] = REJECTED;
                for(let i = 0; i < _uncaughtPromiseErrors.length; i++)if (promise === _uncaughtPromiseErrors[i].promise) _uncaughtPromiseErrors.splice(i, 1);
            }
        }
        function scheduleResolveOrReject(promise, zone, chainPromise, onFulfilled, onRejected) {
            clearRejectedNoCatch(promise);
            const promiseState = promise[symbolState];
            const delegate = promiseState ? typeof onFulfilled === 'function' ? onFulfilled : forwardResolution : typeof onRejected === 'function' ? onRejected : forwardRejection;
            zone.scheduleMicroTask(source, ()=>{
                try {
                    const parentPromiseValue = promise[symbolValue];
                    const isFinallyPromise = !!chainPromise && symbolFinally === chainPromise[symbolFinally];
                    if (isFinallyPromise) {
                        // if the promise is generated from finally call, keep parent promise's state and value
                        chainPromise[symbolParentPromiseValue] = parentPromiseValue;
                        chainPromise[symbolParentPromiseState] = promiseState;
                    }
                    // should not pass value to finally callback
                    const value = zone.run(delegate, undefined, isFinallyPromise && delegate !== forwardRejection && delegate !== forwardResolution ? [] : [
                        parentPromiseValue
                    ]);
                    resolvePromise(chainPromise, true, value);
                } catch (error) {
                    // if error occurs, should always return this error
                    resolvePromise(chainPromise, false, error);
                }
            }, chainPromise);
        }
        const ZONE_AWARE_PROMISE_TO_STRING = 'function ZoneAwarePromise() { [native code] }';
        const noop = function() {};
        const AggregateError = global.AggregateError;
        class ZoneAwarePromise {
            static toString() {
                return ZONE_AWARE_PROMISE_TO_STRING;
            }
            static resolve(value) {
                if (value instanceof ZoneAwarePromise) return value;
                return resolvePromise(new this(null), RESOLVED, value);
            }
            static reject(error) {
                return resolvePromise(new this(null), REJECTED, error);
            }
            static withResolvers() {
                const result = {};
                result.promise = new ZoneAwarePromise((res, rej)=>{
                    result.resolve = res;
                    result.reject = rej;
                });
                return result;
            }
            static any(values) {
                if (!values || typeof values[Symbol.iterator] !== 'function') return Promise.reject(new AggregateError([], 'All promises were rejected'));
                const promises = [];
                let count = 0;
                try {
                    for (let v of values){
                        count++;
                        promises.push(ZoneAwarePromise.resolve(v));
                    }
                } catch (err) {
                    return Promise.reject(new AggregateError([], 'All promises were rejected'));
                }
                if (count === 0) return Promise.reject(new AggregateError([], 'All promises were rejected'));
                let finished = false;
                const errors = [];
                return new ZoneAwarePromise((resolve, reject)=>{
                    for(let i = 0; i < promises.length; i++)promises[i].then((v)=>{
                        if (finished) return;
                        finished = true;
                        resolve(v);
                    }, (err)=>{
                        errors.push(err);
                        count--;
                        if (count === 0) {
                            finished = true;
                            reject(new AggregateError(errors, 'All promises were rejected'));
                        }
                    });
                });
            }
            static race(values) {
                let resolve;
                let reject;
                let promise = new this((res, rej)=>{
                    resolve = res;
                    reject = rej;
                });
                function onResolve(value) {
                    resolve(value);
                }
                function onReject(error) {
                    reject(error);
                }
                for (let value of values){
                    if (!isThenable(value)) value = this.resolve(value);
                    value.then(onResolve, onReject);
                }
                return promise;
            }
            static all(values) {
                return ZoneAwarePromise.allWithCallback(values);
            }
            static allSettled(values) {
                const P = this && this.prototype instanceof ZoneAwarePromise ? this : ZoneAwarePromise;
                return P.allWithCallback(values, {
                    thenCallback: (value)=>({
                            status: 'fulfilled',
                            value: value
                        }),
                    errorCallback: (err)=>({
                            status: 'rejected',
                            reason: err
                        })
                });
            }
            static allWithCallback(values, callback) {
                let resolve;
                let reject;
                let promise = new this((res, rej)=>{
                    resolve = res;
                    reject = rej;
                });
                // Start at 2 to prevent prematurely resolving if .then is called immediately.
                let unresolvedCount = 2;
                let valueIndex = 0;
                const resolvedValues = [];
                for (let value of values){
                    if (!isThenable(value)) value = this.resolve(value);
                    const curValueIndex = valueIndex;
                    try {
                        value.then((value)=>{
                            resolvedValues[curValueIndex] = callback ? callback.thenCallback(value) : value;
                            unresolvedCount--;
                            if (unresolvedCount === 0) resolve(resolvedValues);
                        }, (err)=>{
                            if (!callback) reject(err);
                            else {
                                resolvedValues[curValueIndex] = callback.errorCallback(err);
                                unresolvedCount--;
                                if (unresolvedCount === 0) resolve(resolvedValues);
                            }
                        });
                    } catch (thenErr) {
                        reject(thenErr);
                    }
                    unresolvedCount++;
                    valueIndex++;
                }
                // Make the unresolvedCount zero-based again.
                unresolvedCount -= 2;
                if (unresolvedCount === 0) resolve(resolvedValues);
                return promise;
            }
            constructor(executor){
                const promise = this;
                if (!(promise instanceof ZoneAwarePromise)) throw new Error('Must be an instanceof Promise.');
                promise[symbolState] = UNRESOLVED;
                promise[symbolValue] = []; // queue;
                try {
                    const onceWrapper = once();
                    executor && executor(onceWrapper(makeResolver(promise, RESOLVED)), onceWrapper(makeResolver(promise, REJECTED)));
                } catch (error) {
                    resolvePromise(promise, false, error);
                }
            }
            get [Symbol.toStringTag]() {
                return 'Promise';
            }
            get [Symbol.species]() {
                return ZoneAwarePromise;
            }
            then(onFulfilled, onRejected) {
                // We must read `Symbol.species` safely because `this` may be anything. For instance, `this`
                // may be an object without a prototype (created through `Object.create(null)`); thus
                // `this.constructor` will be undefined. One of the use cases is SystemJS creating
                // prototype-less objects (modules) via `Object.create(null)`. The SystemJS creates an empty
                // object and copies promise properties into that object (within the `getOrCreateLoad`
                // function). The zone.js then checks if the resolved value has the `then` method and
                // invokes it with the `value` context. Otherwise, this will throw an error: `TypeError:
                // Cannot read properties of undefined (reading 'Symbol(Symbol.species)')`.
                let C = this.constructor?.[Symbol.species];
                if (!C || typeof C !== 'function') C = this.constructor || ZoneAwarePromise;
                const chainPromise = new C(noop);
                const zone = Zone1.current;
                if (this[symbolState] == UNRESOLVED) this[symbolValue].push(zone, chainPromise, onFulfilled, onRejected);
                else scheduleResolveOrReject(this, zone, chainPromise, onFulfilled, onRejected);
                return chainPromise;
            }
            catch(onRejected) {
                return this.then(null, onRejected);
            }
            finally(onFinally) {
                // See comment on the call to `then` about why thee `Symbol.species` is safely accessed.
                let C = this.constructor?.[Symbol.species];
                if (!C || typeof C !== 'function') C = ZoneAwarePromise;
                const chainPromise = new C(noop);
                chainPromise[symbolFinally] = symbolFinally;
                const zone = Zone1.current;
                if (this[symbolState] == UNRESOLVED) this[symbolValue].push(zone, chainPromise, onFinally, onFinally);
                else scheduleResolveOrReject(this, zone, chainPromise, onFinally, onFinally);
                return chainPromise;
            }
        }
        // Protect against aggressive optimizers dropping seemingly unused properties.
        // E.g. Closure Compiler in advanced mode.
        ZoneAwarePromise['resolve'] = ZoneAwarePromise.resolve;
        ZoneAwarePromise['reject'] = ZoneAwarePromise.reject;
        ZoneAwarePromise['race'] = ZoneAwarePromise.race;
        ZoneAwarePromise['all'] = ZoneAwarePromise.all;
        const NativePromise = global[symbolPromise] = global['Promise'];
        global['Promise'] = ZoneAwarePromise;
        const symbolThenPatched = __symbol__('thenPatched');
        function patchThen(Ctor) {
            const proto = Ctor.prototype;
            const prop = ObjectGetOwnPropertyDescriptor(proto, 'then');
            if (prop && (prop.writable === false || !prop.configurable)) // check Ctor.prototype.then propertyDescriptor is writable or not
            // in meteor env, writable is false, we should ignore such case
            return;
            const originalThen = proto.then;
            // Keep a reference to the original method.
            proto[symbolThen] = originalThen;
            Ctor.prototype.then = function(onResolve, onReject) {
                const wrapped = new ZoneAwarePromise((resolve, reject)=>{
                    originalThen.call(this, resolve, reject);
                });
                return wrapped.then(onResolve, onReject);
            };
            Ctor[symbolThenPatched] = true;
        }
        api.patchThen = patchThen;
        function zoneify(fn) {
            return function(self1, args) {
                let resultPromise = fn.apply(self1, args);
                if (resultPromise instanceof ZoneAwarePromise) return resultPromise;
                let ctor = resultPromise.constructor;
                if (!ctor[symbolThenPatched]) patchThen(ctor);
                return resultPromise;
            };
        }
        if (NativePromise) {
            patchThen(NativePromise);
            $d9497ea901ae627a$var$patchMethod(global, 'fetch', (delegate)=>zoneify(delegate));
        }
        // This is not part of public API, but it is useful for tests, so we expose it.
        Promise[Zone1.__symbol__('uncaughtPromiseErrors')] = _uncaughtPromiseErrors;
        return ZoneAwarePromise;
    });
}
function $d9497ea901ae627a$var$patchToString(Zone1) {
    // override Function.prototype.toString to make zone.js patched function
    // look like native function
    Zone1.__load_patch('toString', (global)=>{
        // patch Func.prototype.toString to let them look like native
        const originalFunctionToString = Function.prototype.toString;
        const ORIGINAL_DELEGATE_SYMBOL = $d9497ea901ae627a$var$zoneSymbol('OriginalDelegate');
        const PROMISE_SYMBOL = $d9497ea901ae627a$var$zoneSymbol('Promise');
        const ERROR_SYMBOL = $d9497ea901ae627a$var$zoneSymbol('Error');
        const newFunctionToString = function toString() {
            if (typeof this === 'function') {
                const originalDelegate = this[ORIGINAL_DELEGATE_SYMBOL];
                if (originalDelegate) {
                    if (typeof originalDelegate === 'function') return originalFunctionToString.call(originalDelegate);
                    else return Object.prototype.toString.call(originalDelegate);
                }
                if (this === Promise) {
                    const nativePromise = global[PROMISE_SYMBOL];
                    if (nativePromise) return originalFunctionToString.call(nativePromise);
                }
                if (this === Error) {
                    const nativeError = global[ERROR_SYMBOL];
                    if (nativeError) return originalFunctionToString.call(nativeError);
                }
            }
            return originalFunctionToString.call(this);
        };
        newFunctionToString[ORIGINAL_DELEGATE_SYMBOL] = originalFunctionToString;
        Function.prototype.toString = newFunctionToString;
        // patch Object.prototype.toString to let them look like native
        const originalObjectToString = Object.prototype.toString;
        const PROMISE_OBJECT_TO_STRING = '[object Promise]';
        Object.prototype.toString = function() {
            if (typeof Promise === 'function' && this instanceof Promise) return PROMISE_OBJECT_TO_STRING;
            return originalObjectToString.call(this);
        };
    });
}
function $d9497ea901ae627a$var$patchCallbacks(api, target, targetName, method, callbacks) {
    const symbol = Zone.__symbol__(method);
    if (target[symbol]) return;
    const nativeDelegate = target[symbol] = target[method];
    target[method] = function(name, opts, options) {
        if (opts && opts.prototype) callbacks.forEach(function(callback) {
            const source = `${targetName}.${method}::` + callback;
            const prototype = opts.prototype;
            // Note: the `patchCallbacks` is used for patching the `document.registerElement` and
            // `customElements.define`. We explicitly wrap the patching code into try-catch since
            // callbacks may be already patched by other web components frameworks (e.g. LWC), and they
            // make those properties non-writable. This means that patching callback will throw an error
            // `cannot assign to read-only property`. See this code as an example:
            // https://github.com/salesforce/lwc/blob/master/packages/@lwc/engine-core/src/framework/base-bridge-element.ts#L180-L186
            // We don't want to stop the application rendering if we couldn't patch some
            // callback, e.g. `attributeChangedCallback`.
            try {
                if (prototype.hasOwnProperty(callback)) {
                    const descriptor = api.ObjectGetOwnPropertyDescriptor(prototype, callback);
                    if (descriptor && descriptor.value) {
                        descriptor.value = api.wrapWithCurrentZone(descriptor.value, source);
                        api._redefineProperty(opts.prototype, callback, descriptor);
                    } else if (prototype[callback]) prototype[callback] = api.wrapWithCurrentZone(prototype[callback], source);
                } else if (prototype[callback]) prototype[callback] = api.wrapWithCurrentZone(prototype[callback], source);
            } catch  {
            // Note: we leave the catch block empty since there's no way to handle the error related
            // to non-writable property.
            }
        });
        return nativeDelegate.call(target, name, opts, options);
    };
    api.attachOriginToPatched(target[method], nativeDelegate);
}
function $d9497ea901ae627a$var$patchUtil(Zone1) {
    Zone1.__load_patch('util', (global, Zone1, api)=>{
        // Collect native event names by looking at properties
        // on the global namespace, e.g. 'onclick'.
        const eventNames = $d9497ea901ae627a$var$getOnEventNames(global);
        api.patchOnProperties = $d9497ea901ae627a$var$patchOnProperties;
        api.patchMethod = $d9497ea901ae627a$var$patchMethod;
        api.bindArguments = $d9497ea901ae627a$var$bindArguments;
        api.patchMacroTask = $d9497ea901ae627a$var$patchMacroTask;
        // In earlier version of zone.js (<0.9.0), we use env name `__zone_symbol__BLACK_LISTED_EVENTS`
        // to define which events will not be patched by `Zone.js`. In newer version (>=0.9.0), we
        // change the env name to `__zone_symbol__UNPATCHED_EVENTS` to keep the name consistent with
        // angular repo. The  `__zone_symbol__BLACK_LISTED_EVENTS` is deprecated, but it is still be
        // supported for backwards compatibility.
        const SYMBOL_BLACK_LISTED_EVENTS = Zone1.__symbol__('BLACK_LISTED_EVENTS');
        const SYMBOL_UNPATCHED_EVENTS = Zone1.__symbol__('UNPATCHED_EVENTS');
        if (global[SYMBOL_UNPATCHED_EVENTS]) global[SYMBOL_BLACK_LISTED_EVENTS] = global[SYMBOL_UNPATCHED_EVENTS];
        if (global[SYMBOL_BLACK_LISTED_EVENTS]) Zone1[SYMBOL_BLACK_LISTED_EVENTS] = Zone1[SYMBOL_UNPATCHED_EVENTS] = global[SYMBOL_BLACK_LISTED_EVENTS];
        api.patchEventPrototype = $d9497ea901ae627a$var$patchEventPrototype;
        api.patchEventTarget = $d9497ea901ae627a$var$patchEventTarget;
        api.isIEOrEdge = $d9497ea901ae627a$var$isIEOrEdge;
        api.ObjectDefineProperty = $d9497ea901ae627a$var$ObjectDefineProperty;
        api.ObjectGetOwnPropertyDescriptor = $d9497ea901ae627a$var$ObjectGetOwnPropertyDescriptor;
        api.ObjectCreate = $d9497ea901ae627a$var$ObjectCreate;
        api.ArraySlice = $d9497ea901ae627a$var$ArraySlice;
        api.patchClass = $d9497ea901ae627a$var$patchClass;
        api.wrapWithCurrentZone = $d9497ea901ae627a$var$wrapWithCurrentZone;
        api.filterProperties = $d9497ea901ae627a$var$filterProperties;
        api.attachOriginToPatched = $d9497ea901ae627a$var$attachOriginToPatched;
        api._redefineProperty = Object.defineProperty;
        api.patchCallbacks = $d9497ea901ae627a$var$patchCallbacks;
        api.getGlobalObjects = ()=>({
                globalSources: $d9497ea901ae627a$var$globalSources,
                zoneSymbolEventNames: $d9497ea901ae627a$var$zoneSymbolEventNames,
                eventNames: eventNames,
                isBrowser: $d9497ea901ae627a$var$isBrowser,
                isMix: $d9497ea901ae627a$var$isMix,
                isNode: $d9497ea901ae627a$var$isNode,
                TRUE_STR: $d9497ea901ae627a$var$TRUE_STR,
                FALSE_STR: $d9497ea901ae627a$var$FALSE_STR,
                ZONE_SYMBOL_PREFIX: $d9497ea901ae627a$var$ZONE_SYMBOL_PREFIX,
                ADD_EVENT_LISTENER_STR: $d9497ea901ae627a$var$ADD_EVENT_LISTENER_STR,
                REMOVE_EVENT_LISTENER_STR: $d9497ea901ae627a$var$REMOVE_EVENT_LISTENER_STR
            });
    });
}
function $d9497ea901ae627a$var$patchCommon(Zone1) {
    $d9497ea901ae627a$var$patchPromise(Zone1);
    $d9497ea901ae627a$var$patchToString(Zone1);
    $d9497ea901ae627a$var$patchUtil(Zone1);
}
const $d9497ea901ae627a$var$Zone$1 = $d9497ea901ae627a$var$loadZone();
$d9497ea901ae627a$var$patchCommon($d9497ea901ae627a$var$Zone$1);
$d9497ea901ae627a$var$patchBrowser($d9497ea901ae627a$var$Zone$1);





/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Creates a const map from the given values
 * @param values - An array of values to be used as keys and values in the map.
 * @returns A populated version of the map with the values and keys derived from the values.
 */ /*#__NO_SIDE_EFFECTS__*/ function $4fd9e333ade5ddac$export$8796db7ca257d576(values) {
    // eslint-disable-next-line prefer-const, @typescript-eslint/no-explicit-any
    let res = {};
    const len = values.length;
    for(let lp = 0; lp < len; lp++){
        const val = values[lp];
        if (val) res[String(val).toUpperCase().replace(/[-.]/g, '_')] = val;
    }
    return res;
}


//----------------------------------------------------------------------------------------------------------
// DO NOT EDIT, this is an Auto-generated file from scripts/semconv/templates//templates/SemanticAttributes.ts.j2
//----------------------------------------------------------------------------------------------------------
//----------------------------------------------------------------------------------------------------------
// Constant values for SemanticResourceAttributes
//----------------------------------------------------------------------------------------------------------
// Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
const $11a2fe521a5dc687$var$TMP_CLOUD_PROVIDER = 'cloud.provider';
const $11a2fe521a5dc687$var$TMP_CLOUD_ACCOUNT_ID = 'cloud.account.id';
const $11a2fe521a5dc687$var$TMP_CLOUD_REGION = 'cloud.region';
const $11a2fe521a5dc687$var$TMP_CLOUD_AVAILABILITY_ZONE = 'cloud.availability_zone';
const $11a2fe521a5dc687$var$TMP_CLOUD_PLATFORM = 'cloud.platform';
const $11a2fe521a5dc687$var$TMP_AWS_ECS_CONTAINER_ARN = 'aws.ecs.container.arn';
const $11a2fe521a5dc687$var$TMP_AWS_ECS_CLUSTER_ARN = 'aws.ecs.cluster.arn';
const $11a2fe521a5dc687$var$TMP_AWS_ECS_LAUNCHTYPE = 'aws.ecs.launchtype';
const $11a2fe521a5dc687$var$TMP_AWS_ECS_TASK_ARN = 'aws.ecs.task.arn';
const $11a2fe521a5dc687$var$TMP_AWS_ECS_TASK_FAMILY = 'aws.ecs.task.family';
const $11a2fe521a5dc687$var$TMP_AWS_ECS_TASK_REVISION = 'aws.ecs.task.revision';
const $11a2fe521a5dc687$var$TMP_AWS_EKS_CLUSTER_ARN = 'aws.eks.cluster.arn';
const $11a2fe521a5dc687$var$TMP_AWS_LOG_GROUP_NAMES = 'aws.log.group.names';
const $11a2fe521a5dc687$var$TMP_AWS_LOG_GROUP_ARNS = 'aws.log.group.arns';
const $11a2fe521a5dc687$var$TMP_AWS_LOG_STREAM_NAMES = 'aws.log.stream.names';
const $11a2fe521a5dc687$var$TMP_AWS_LOG_STREAM_ARNS = 'aws.log.stream.arns';
const $11a2fe521a5dc687$var$TMP_CONTAINER_NAME = 'container.name';
const $11a2fe521a5dc687$var$TMP_CONTAINER_ID = 'container.id';
const $11a2fe521a5dc687$var$TMP_CONTAINER_RUNTIME = 'container.runtime';
const $11a2fe521a5dc687$var$TMP_CONTAINER_IMAGE_NAME = 'container.image.name';
const $11a2fe521a5dc687$var$TMP_CONTAINER_IMAGE_TAG = 'container.image.tag';
const $11a2fe521a5dc687$var$TMP_DEPLOYMENT_ENVIRONMENT = 'deployment.environment';
const $11a2fe521a5dc687$var$TMP_DEVICE_ID = 'device.id';
const $11a2fe521a5dc687$var$TMP_DEVICE_MODEL_IDENTIFIER = 'device.model.identifier';
const $11a2fe521a5dc687$var$TMP_DEVICE_MODEL_NAME = 'device.model.name';
const $11a2fe521a5dc687$var$TMP_FAAS_NAME = 'faas.name';
const $11a2fe521a5dc687$var$TMP_FAAS_ID = 'faas.id';
const $11a2fe521a5dc687$var$TMP_FAAS_VERSION = 'faas.version';
const $11a2fe521a5dc687$var$TMP_FAAS_INSTANCE = 'faas.instance';
const $11a2fe521a5dc687$var$TMP_FAAS_MAX_MEMORY = 'faas.max_memory';
const $11a2fe521a5dc687$var$TMP_HOST_ID = 'host.id';
const $11a2fe521a5dc687$var$TMP_HOST_NAME = 'host.name';
const $11a2fe521a5dc687$var$TMP_HOST_TYPE = 'host.type';
const $11a2fe521a5dc687$var$TMP_HOST_ARCH = 'host.arch';
const $11a2fe521a5dc687$var$TMP_HOST_IMAGE_NAME = 'host.image.name';
const $11a2fe521a5dc687$var$TMP_HOST_IMAGE_ID = 'host.image.id';
const $11a2fe521a5dc687$var$TMP_HOST_IMAGE_VERSION = 'host.image.version';
const $11a2fe521a5dc687$var$TMP_K8S_CLUSTER_NAME = 'k8s.cluster.name';
const $11a2fe521a5dc687$var$TMP_K8S_NODE_NAME = 'k8s.node.name';
const $11a2fe521a5dc687$var$TMP_K8S_NODE_UID = 'k8s.node.uid';
const $11a2fe521a5dc687$var$TMP_K8S_NAMESPACE_NAME = 'k8s.namespace.name';
const $11a2fe521a5dc687$var$TMP_K8S_POD_UID = 'k8s.pod.uid';
const $11a2fe521a5dc687$var$TMP_K8S_POD_NAME = 'k8s.pod.name';
const $11a2fe521a5dc687$var$TMP_K8S_CONTAINER_NAME = 'k8s.container.name';
const $11a2fe521a5dc687$var$TMP_K8S_REPLICASET_UID = 'k8s.replicaset.uid';
const $11a2fe521a5dc687$var$TMP_K8S_REPLICASET_NAME = 'k8s.replicaset.name';
const $11a2fe521a5dc687$var$TMP_K8S_DEPLOYMENT_UID = 'k8s.deployment.uid';
const $11a2fe521a5dc687$var$TMP_K8S_DEPLOYMENT_NAME = 'k8s.deployment.name';
const $11a2fe521a5dc687$var$TMP_K8S_STATEFULSET_UID = 'k8s.statefulset.uid';
const $11a2fe521a5dc687$var$TMP_K8S_STATEFULSET_NAME = 'k8s.statefulset.name';
const $11a2fe521a5dc687$var$TMP_K8S_DAEMONSET_UID = 'k8s.daemonset.uid';
const $11a2fe521a5dc687$var$TMP_K8S_DAEMONSET_NAME = 'k8s.daemonset.name';
const $11a2fe521a5dc687$var$TMP_K8S_JOB_UID = 'k8s.job.uid';
const $11a2fe521a5dc687$var$TMP_K8S_JOB_NAME = 'k8s.job.name';
const $11a2fe521a5dc687$var$TMP_K8S_CRONJOB_UID = 'k8s.cronjob.uid';
const $11a2fe521a5dc687$var$TMP_K8S_CRONJOB_NAME = 'k8s.cronjob.name';
const $11a2fe521a5dc687$var$TMP_OS_TYPE = 'os.type';
const $11a2fe521a5dc687$var$TMP_OS_DESCRIPTION = 'os.description';
const $11a2fe521a5dc687$var$TMP_OS_NAME = 'os.name';
const $11a2fe521a5dc687$var$TMP_OS_VERSION = 'os.version';
const $11a2fe521a5dc687$var$TMP_PROCESS_PID = 'process.pid';
const $11a2fe521a5dc687$var$TMP_PROCESS_EXECUTABLE_NAME = 'process.executable.name';
const $11a2fe521a5dc687$var$TMP_PROCESS_EXECUTABLE_PATH = 'process.executable.path';
const $11a2fe521a5dc687$var$TMP_PROCESS_COMMAND = 'process.command';
const $11a2fe521a5dc687$var$TMP_PROCESS_COMMAND_LINE = 'process.command_line';
const $11a2fe521a5dc687$var$TMP_PROCESS_COMMAND_ARGS = 'process.command_args';
const $11a2fe521a5dc687$var$TMP_PROCESS_OWNER = 'process.owner';
const $11a2fe521a5dc687$var$TMP_PROCESS_RUNTIME_NAME = 'process.runtime.name';
const $11a2fe521a5dc687$var$TMP_PROCESS_RUNTIME_VERSION = 'process.runtime.version';
const $11a2fe521a5dc687$var$TMP_PROCESS_RUNTIME_DESCRIPTION = 'process.runtime.description';
const $11a2fe521a5dc687$var$TMP_SERVICE_NAME = 'service.name';
const $11a2fe521a5dc687$var$TMP_SERVICE_NAMESPACE = 'service.namespace';
const $11a2fe521a5dc687$var$TMP_SERVICE_INSTANCE_ID = 'service.instance.id';
const $11a2fe521a5dc687$var$TMP_SERVICE_VERSION = 'service.version';
const $11a2fe521a5dc687$var$TMP_TELEMETRY_SDK_NAME = 'telemetry.sdk.name';
const $11a2fe521a5dc687$var$TMP_TELEMETRY_SDK_LANGUAGE = 'telemetry.sdk.language';
const $11a2fe521a5dc687$var$TMP_TELEMETRY_SDK_VERSION = 'telemetry.sdk.version';
const $11a2fe521a5dc687$var$TMP_TELEMETRY_AUTO_VERSION = 'telemetry.auto.version';
const $11a2fe521a5dc687$var$TMP_WEBENGINE_NAME = 'webengine.name';
const $11a2fe521a5dc687$var$TMP_WEBENGINE_VERSION = 'webengine.version';
const $11a2fe521a5dc687$var$TMP_WEBENGINE_DESCRIPTION = 'webengine.description';
const $11a2fe521a5dc687$export$9fa486cd651f5f18 = $11a2fe521a5dc687$var$TMP_CLOUD_PROVIDER;
const $11a2fe521a5dc687$export$3b9e160fb5fd0b48 = $11a2fe521a5dc687$var$TMP_CLOUD_ACCOUNT_ID;
const $11a2fe521a5dc687$export$7dda4a2b7e6f2925 = $11a2fe521a5dc687$var$TMP_CLOUD_REGION;
const $11a2fe521a5dc687$export$ba02b007970def42 = $11a2fe521a5dc687$var$TMP_CLOUD_AVAILABILITY_ZONE;
const $11a2fe521a5dc687$export$112df106e7dd2eda = $11a2fe521a5dc687$var$TMP_CLOUD_PLATFORM;
const $11a2fe521a5dc687$export$a43adfce130205e = $11a2fe521a5dc687$var$TMP_AWS_ECS_CONTAINER_ARN;
const $11a2fe521a5dc687$export$2ba3c01be08dc7b1 = $11a2fe521a5dc687$var$TMP_AWS_ECS_CLUSTER_ARN;
const $11a2fe521a5dc687$export$323329f2ad65b2aa = $11a2fe521a5dc687$var$TMP_AWS_ECS_LAUNCHTYPE;
const $11a2fe521a5dc687$export$5275732a76e56248 = $11a2fe521a5dc687$var$TMP_AWS_ECS_TASK_ARN;
const $11a2fe521a5dc687$export$fb3f0b7a7be1babd = $11a2fe521a5dc687$var$TMP_AWS_ECS_TASK_FAMILY;
const $11a2fe521a5dc687$export$3ed6f78d5dfa8242 = $11a2fe521a5dc687$var$TMP_AWS_ECS_TASK_REVISION;
const $11a2fe521a5dc687$export$a7708dae05d391dc = $11a2fe521a5dc687$var$TMP_AWS_EKS_CLUSTER_ARN;
const $11a2fe521a5dc687$export$bf434df1f3c89b1 = $11a2fe521a5dc687$var$TMP_AWS_LOG_GROUP_NAMES;
const $11a2fe521a5dc687$export$c522b98ccd83a439 = $11a2fe521a5dc687$var$TMP_AWS_LOG_GROUP_ARNS;
const $11a2fe521a5dc687$export$40794b06cac6b1bc = $11a2fe521a5dc687$var$TMP_AWS_LOG_STREAM_NAMES;
const $11a2fe521a5dc687$export$c9f081f4b744b01b = $11a2fe521a5dc687$var$TMP_AWS_LOG_STREAM_ARNS;
const $11a2fe521a5dc687$export$3e6fef409a60fc1e = $11a2fe521a5dc687$var$TMP_CONTAINER_NAME;
const $11a2fe521a5dc687$export$4d0381aa96fe1c3b = $11a2fe521a5dc687$var$TMP_CONTAINER_ID;
const $11a2fe521a5dc687$export$8806c0adf7bb0584 = $11a2fe521a5dc687$var$TMP_CONTAINER_RUNTIME;
const $11a2fe521a5dc687$export$44771c6519c06259 = $11a2fe521a5dc687$var$TMP_CONTAINER_IMAGE_NAME;
const $11a2fe521a5dc687$export$9f5798300d33c86b = $11a2fe521a5dc687$var$TMP_CONTAINER_IMAGE_TAG;
const $11a2fe521a5dc687$export$4783aaf4e8f7afa0 = $11a2fe521a5dc687$var$TMP_DEPLOYMENT_ENVIRONMENT;
const $11a2fe521a5dc687$export$6e497113334fabdb = $11a2fe521a5dc687$var$TMP_DEVICE_ID;
const $11a2fe521a5dc687$export$73c71cc1c141692b = $11a2fe521a5dc687$var$TMP_DEVICE_MODEL_IDENTIFIER;
const $11a2fe521a5dc687$export$44e87b3b8704bc8a = $11a2fe521a5dc687$var$TMP_DEVICE_MODEL_NAME;
const $11a2fe521a5dc687$export$fe110625e5aee93d = $11a2fe521a5dc687$var$TMP_FAAS_NAME;
const $11a2fe521a5dc687$export$6bbd0c1523702b22 = $11a2fe521a5dc687$var$TMP_FAAS_ID;
const $11a2fe521a5dc687$export$b1cb8996c7f671f1 = $11a2fe521a5dc687$var$TMP_FAAS_VERSION;
const $11a2fe521a5dc687$export$aa4a460944af09fe = $11a2fe521a5dc687$var$TMP_FAAS_INSTANCE;
const $11a2fe521a5dc687$export$a099969737f46339 = $11a2fe521a5dc687$var$TMP_FAAS_MAX_MEMORY;
const $11a2fe521a5dc687$export$e0a684ea09b55cf4 = $11a2fe521a5dc687$var$TMP_HOST_ID;
const $11a2fe521a5dc687$export$3b62edd76224926e = $11a2fe521a5dc687$var$TMP_HOST_NAME;
const $11a2fe521a5dc687$export$ba26ec134241ab05 = $11a2fe521a5dc687$var$TMP_HOST_TYPE;
const $11a2fe521a5dc687$export$4ef6e9b690c5d3ad = $11a2fe521a5dc687$var$TMP_HOST_ARCH;
const $11a2fe521a5dc687$export$80c1be409ca0daf7 = $11a2fe521a5dc687$var$TMP_HOST_IMAGE_NAME;
const $11a2fe521a5dc687$export$ae211b0849dd0d75 = $11a2fe521a5dc687$var$TMP_HOST_IMAGE_ID;
const $11a2fe521a5dc687$export$729ea06c32794759 = $11a2fe521a5dc687$var$TMP_HOST_IMAGE_VERSION;
const $11a2fe521a5dc687$export$9e0ac736c1d187bc = $11a2fe521a5dc687$var$TMP_K8S_CLUSTER_NAME;
const $11a2fe521a5dc687$export$e2479edf033ed1cd = $11a2fe521a5dc687$var$TMP_K8S_NODE_NAME;
const $11a2fe521a5dc687$export$a348ce0508cee2d8 = $11a2fe521a5dc687$var$TMP_K8S_NODE_UID;
const $11a2fe521a5dc687$export$f74f5d90b490f9a6 = $11a2fe521a5dc687$var$TMP_K8S_NAMESPACE_NAME;
const $11a2fe521a5dc687$export$341429c1b099564 = $11a2fe521a5dc687$var$TMP_K8S_POD_UID;
const $11a2fe521a5dc687$export$9e6f11bbfd666f4d = $11a2fe521a5dc687$var$TMP_K8S_POD_NAME;
const $11a2fe521a5dc687$export$ee1ae14ab5631334 = $11a2fe521a5dc687$var$TMP_K8S_CONTAINER_NAME;
const $11a2fe521a5dc687$export$845974e52d5d977b = $11a2fe521a5dc687$var$TMP_K8S_REPLICASET_UID;
const $11a2fe521a5dc687$export$1735237e4ef99ddc = $11a2fe521a5dc687$var$TMP_K8S_REPLICASET_NAME;
const $11a2fe521a5dc687$export$ff557043393b8413 = $11a2fe521a5dc687$var$TMP_K8S_DEPLOYMENT_UID;
const $11a2fe521a5dc687$export$1b29810364e6fd87 = $11a2fe521a5dc687$var$TMP_K8S_DEPLOYMENT_NAME;
const $11a2fe521a5dc687$export$fd37db901d73f6dc = $11a2fe521a5dc687$var$TMP_K8S_STATEFULSET_UID;
const $11a2fe521a5dc687$export$8030a8ee6a430fb9 = $11a2fe521a5dc687$var$TMP_K8S_STATEFULSET_NAME;
const $11a2fe521a5dc687$export$6369d5a7f9c03019 = $11a2fe521a5dc687$var$TMP_K8S_DAEMONSET_UID;
const $11a2fe521a5dc687$export$f55c2f841978e686 = $11a2fe521a5dc687$var$TMP_K8S_DAEMONSET_NAME;
const $11a2fe521a5dc687$export$1618e60c71672510 = $11a2fe521a5dc687$var$TMP_K8S_JOB_UID;
const $11a2fe521a5dc687$export$fae3f547adbfd628 = $11a2fe521a5dc687$var$TMP_K8S_JOB_NAME;
const $11a2fe521a5dc687$export$c6a5d371a9279cc4 = $11a2fe521a5dc687$var$TMP_K8S_CRONJOB_UID;
const $11a2fe521a5dc687$export$2411967a413e48d4 = $11a2fe521a5dc687$var$TMP_K8S_CRONJOB_NAME;
const $11a2fe521a5dc687$export$832bf06644fbf55d = $11a2fe521a5dc687$var$TMP_OS_TYPE;
const $11a2fe521a5dc687$export$5ea67b5ceab8e5b2 = $11a2fe521a5dc687$var$TMP_OS_DESCRIPTION;
const $11a2fe521a5dc687$export$ba2bcf7e30621987 = $11a2fe521a5dc687$var$TMP_OS_NAME;
const $11a2fe521a5dc687$export$e0381cc218bde593 = $11a2fe521a5dc687$var$TMP_OS_VERSION;
const $11a2fe521a5dc687$export$f184e78598ab0d4c = $11a2fe521a5dc687$var$TMP_PROCESS_PID;
const $11a2fe521a5dc687$export$e2e53a1071096d12 = $11a2fe521a5dc687$var$TMP_PROCESS_EXECUTABLE_NAME;
const $11a2fe521a5dc687$export$cc1c2bacfc72d251 = $11a2fe521a5dc687$var$TMP_PROCESS_EXECUTABLE_PATH;
const $11a2fe521a5dc687$export$1921c91b182b21e6 = $11a2fe521a5dc687$var$TMP_PROCESS_COMMAND;
const $11a2fe521a5dc687$export$33d6a2745a92e4bf = $11a2fe521a5dc687$var$TMP_PROCESS_COMMAND_LINE;
const $11a2fe521a5dc687$export$1a3243771890bbd7 = $11a2fe521a5dc687$var$TMP_PROCESS_COMMAND_ARGS;
const $11a2fe521a5dc687$export$5bc9efe4d24f374b = $11a2fe521a5dc687$var$TMP_PROCESS_OWNER;
const $11a2fe521a5dc687$export$6c52ea893832d871 = $11a2fe521a5dc687$var$TMP_PROCESS_RUNTIME_NAME;
const $11a2fe521a5dc687$export$7c038ff97737b111 = $11a2fe521a5dc687$var$TMP_PROCESS_RUNTIME_VERSION;
const $11a2fe521a5dc687$export$cae71c4fbbf205fb = $11a2fe521a5dc687$var$TMP_PROCESS_RUNTIME_DESCRIPTION;
const $11a2fe521a5dc687$export$48c68257f49298c9 = $11a2fe521a5dc687$var$TMP_SERVICE_NAME;
const $11a2fe521a5dc687$export$77c0752ab7c26c9 = $11a2fe521a5dc687$var$TMP_SERVICE_NAMESPACE;
const $11a2fe521a5dc687$export$bb5ecf41777e0d0c = $11a2fe521a5dc687$var$TMP_SERVICE_INSTANCE_ID;
const $11a2fe521a5dc687$export$202d10b361b87ab2 = $11a2fe521a5dc687$var$TMP_SERVICE_VERSION;
const $11a2fe521a5dc687$export$2d668a3bde1cddea = $11a2fe521a5dc687$var$TMP_TELEMETRY_SDK_NAME;
const $11a2fe521a5dc687$export$b5c1717bbc4c6044 = $11a2fe521a5dc687$var$TMP_TELEMETRY_SDK_LANGUAGE;
const $11a2fe521a5dc687$export$e0b67501ecc1df37 = $11a2fe521a5dc687$var$TMP_TELEMETRY_SDK_VERSION;
const $11a2fe521a5dc687$export$3d43fbbcabb62eca = $11a2fe521a5dc687$var$TMP_TELEMETRY_AUTO_VERSION;
const $11a2fe521a5dc687$export$a6b7ffad45e0c20b = $11a2fe521a5dc687$var$TMP_WEBENGINE_NAME;
const $11a2fe521a5dc687$export$589250d7a0c7cee4 = $11a2fe521a5dc687$var$TMP_WEBENGINE_VERSION;
const $11a2fe521a5dc687$export$3318c199ccb51731 = $11a2fe521a5dc687$var$TMP_WEBENGINE_DESCRIPTION;
const $11a2fe521a5dc687$export$85d6ffe28a084c78 = /*#__PURE__*/ (0, $4fd9e333ade5ddac$export$8796db7ca257d576)([
    $11a2fe521a5dc687$var$TMP_CLOUD_PROVIDER,
    $11a2fe521a5dc687$var$TMP_CLOUD_ACCOUNT_ID,
    $11a2fe521a5dc687$var$TMP_CLOUD_REGION,
    $11a2fe521a5dc687$var$TMP_CLOUD_AVAILABILITY_ZONE,
    $11a2fe521a5dc687$var$TMP_CLOUD_PLATFORM,
    $11a2fe521a5dc687$var$TMP_AWS_ECS_CONTAINER_ARN,
    $11a2fe521a5dc687$var$TMP_AWS_ECS_CLUSTER_ARN,
    $11a2fe521a5dc687$var$TMP_AWS_ECS_LAUNCHTYPE,
    $11a2fe521a5dc687$var$TMP_AWS_ECS_TASK_ARN,
    $11a2fe521a5dc687$var$TMP_AWS_ECS_TASK_FAMILY,
    $11a2fe521a5dc687$var$TMP_AWS_ECS_TASK_REVISION,
    $11a2fe521a5dc687$var$TMP_AWS_EKS_CLUSTER_ARN,
    $11a2fe521a5dc687$var$TMP_AWS_LOG_GROUP_NAMES,
    $11a2fe521a5dc687$var$TMP_AWS_LOG_GROUP_ARNS,
    $11a2fe521a5dc687$var$TMP_AWS_LOG_STREAM_NAMES,
    $11a2fe521a5dc687$var$TMP_AWS_LOG_STREAM_ARNS,
    $11a2fe521a5dc687$var$TMP_CONTAINER_NAME,
    $11a2fe521a5dc687$var$TMP_CONTAINER_ID,
    $11a2fe521a5dc687$var$TMP_CONTAINER_RUNTIME,
    $11a2fe521a5dc687$var$TMP_CONTAINER_IMAGE_NAME,
    $11a2fe521a5dc687$var$TMP_CONTAINER_IMAGE_TAG,
    $11a2fe521a5dc687$var$TMP_DEPLOYMENT_ENVIRONMENT,
    $11a2fe521a5dc687$var$TMP_DEVICE_ID,
    $11a2fe521a5dc687$var$TMP_DEVICE_MODEL_IDENTIFIER,
    $11a2fe521a5dc687$var$TMP_DEVICE_MODEL_NAME,
    $11a2fe521a5dc687$var$TMP_FAAS_NAME,
    $11a2fe521a5dc687$var$TMP_FAAS_ID,
    $11a2fe521a5dc687$var$TMP_FAAS_VERSION,
    $11a2fe521a5dc687$var$TMP_FAAS_INSTANCE,
    $11a2fe521a5dc687$var$TMP_FAAS_MAX_MEMORY,
    $11a2fe521a5dc687$var$TMP_HOST_ID,
    $11a2fe521a5dc687$var$TMP_HOST_NAME,
    $11a2fe521a5dc687$var$TMP_HOST_TYPE,
    $11a2fe521a5dc687$var$TMP_HOST_ARCH,
    $11a2fe521a5dc687$var$TMP_HOST_IMAGE_NAME,
    $11a2fe521a5dc687$var$TMP_HOST_IMAGE_ID,
    $11a2fe521a5dc687$var$TMP_HOST_IMAGE_VERSION,
    $11a2fe521a5dc687$var$TMP_K8S_CLUSTER_NAME,
    $11a2fe521a5dc687$var$TMP_K8S_NODE_NAME,
    $11a2fe521a5dc687$var$TMP_K8S_NODE_UID,
    $11a2fe521a5dc687$var$TMP_K8S_NAMESPACE_NAME,
    $11a2fe521a5dc687$var$TMP_K8S_POD_UID,
    $11a2fe521a5dc687$var$TMP_K8S_POD_NAME,
    $11a2fe521a5dc687$var$TMP_K8S_CONTAINER_NAME,
    $11a2fe521a5dc687$var$TMP_K8S_REPLICASET_UID,
    $11a2fe521a5dc687$var$TMP_K8S_REPLICASET_NAME,
    $11a2fe521a5dc687$var$TMP_K8S_DEPLOYMENT_UID,
    $11a2fe521a5dc687$var$TMP_K8S_DEPLOYMENT_NAME,
    $11a2fe521a5dc687$var$TMP_K8S_STATEFULSET_UID,
    $11a2fe521a5dc687$var$TMP_K8S_STATEFULSET_NAME,
    $11a2fe521a5dc687$var$TMP_K8S_DAEMONSET_UID,
    $11a2fe521a5dc687$var$TMP_K8S_DAEMONSET_NAME,
    $11a2fe521a5dc687$var$TMP_K8S_JOB_UID,
    $11a2fe521a5dc687$var$TMP_K8S_JOB_NAME,
    $11a2fe521a5dc687$var$TMP_K8S_CRONJOB_UID,
    $11a2fe521a5dc687$var$TMP_K8S_CRONJOB_NAME,
    $11a2fe521a5dc687$var$TMP_OS_TYPE,
    $11a2fe521a5dc687$var$TMP_OS_DESCRIPTION,
    $11a2fe521a5dc687$var$TMP_OS_NAME,
    $11a2fe521a5dc687$var$TMP_OS_VERSION,
    $11a2fe521a5dc687$var$TMP_PROCESS_PID,
    $11a2fe521a5dc687$var$TMP_PROCESS_EXECUTABLE_NAME,
    $11a2fe521a5dc687$var$TMP_PROCESS_EXECUTABLE_PATH,
    $11a2fe521a5dc687$var$TMP_PROCESS_COMMAND,
    $11a2fe521a5dc687$var$TMP_PROCESS_COMMAND_LINE,
    $11a2fe521a5dc687$var$TMP_PROCESS_COMMAND_ARGS,
    $11a2fe521a5dc687$var$TMP_PROCESS_OWNER,
    $11a2fe521a5dc687$var$TMP_PROCESS_RUNTIME_NAME,
    $11a2fe521a5dc687$var$TMP_PROCESS_RUNTIME_VERSION,
    $11a2fe521a5dc687$var$TMP_PROCESS_RUNTIME_DESCRIPTION,
    $11a2fe521a5dc687$var$TMP_SERVICE_NAME,
    $11a2fe521a5dc687$var$TMP_SERVICE_NAMESPACE,
    $11a2fe521a5dc687$var$TMP_SERVICE_INSTANCE_ID,
    $11a2fe521a5dc687$var$TMP_SERVICE_VERSION,
    $11a2fe521a5dc687$var$TMP_TELEMETRY_SDK_NAME,
    $11a2fe521a5dc687$var$TMP_TELEMETRY_SDK_LANGUAGE,
    $11a2fe521a5dc687$var$TMP_TELEMETRY_SDK_VERSION,
    $11a2fe521a5dc687$var$TMP_TELEMETRY_AUTO_VERSION,
    $11a2fe521a5dc687$var$TMP_WEBENGINE_NAME,
    $11a2fe521a5dc687$var$TMP_WEBENGINE_VERSION,
    $11a2fe521a5dc687$var$TMP_WEBENGINE_DESCRIPTION
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for CloudProviderValues enum definition
 *
 * Name of the cloud provider.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
const $11a2fe521a5dc687$var$TMP_CLOUDPROVIDERVALUES_ALIBABA_CLOUD = 'alibaba_cloud';
const $11a2fe521a5dc687$var$TMP_CLOUDPROVIDERVALUES_AWS = 'aws';
const $11a2fe521a5dc687$var$TMP_CLOUDPROVIDERVALUES_AZURE = 'azure';
const $11a2fe521a5dc687$var$TMP_CLOUDPROVIDERVALUES_GCP = 'gcp';
const $11a2fe521a5dc687$export$1f18298beaae37d3 = $11a2fe521a5dc687$var$TMP_CLOUDPROVIDERVALUES_ALIBABA_CLOUD;
const $11a2fe521a5dc687$export$f56ad4bf836470f2 = $11a2fe521a5dc687$var$TMP_CLOUDPROVIDERVALUES_AWS;
const $11a2fe521a5dc687$export$a607df3e2371e436 = $11a2fe521a5dc687$var$TMP_CLOUDPROVIDERVALUES_AZURE;
const $11a2fe521a5dc687$export$b5cb559e526f402a = $11a2fe521a5dc687$var$TMP_CLOUDPROVIDERVALUES_GCP;
const $11a2fe521a5dc687$export$c2664345bd8aad14 = /*#__PURE__*/ (0, $4fd9e333ade5ddac$export$8796db7ca257d576)([
    $11a2fe521a5dc687$var$TMP_CLOUDPROVIDERVALUES_ALIBABA_CLOUD,
    $11a2fe521a5dc687$var$TMP_CLOUDPROVIDERVALUES_AWS,
    $11a2fe521a5dc687$var$TMP_CLOUDPROVIDERVALUES_AZURE,
    $11a2fe521a5dc687$var$TMP_CLOUDPROVIDERVALUES_GCP
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for CloudPlatformValues enum definition
 *
 * The cloud platform in use.
 *
 * Note: The prefix of the service SHOULD match the one specified in `cloud.provider`.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
const $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_ECS = 'alibaba_cloud_ecs';
const $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_FC = 'alibaba_cloud_fc';
const $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_AWS_EC2 = 'aws_ec2';
const $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_AWS_ECS = 'aws_ecs';
const $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_AWS_EKS = 'aws_eks';
const $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_AWS_LAMBDA = 'aws_lambda';
const $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_AWS_ELASTIC_BEANSTALK = 'aws_elastic_beanstalk';
const $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_AZURE_VM = 'azure_vm';
const $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_AZURE_CONTAINER_INSTANCES = 'azure_container_instances';
const $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_AZURE_AKS = 'azure_aks';
const $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_AZURE_FUNCTIONS = 'azure_functions';
const $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_AZURE_APP_SERVICE = 'azure_app_service';
const $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_GCP_COMPUTE_ENGINE = 'gcp_compute_engine';
const $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_RUN = 'gcp_cloud_run';
const $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_GCP_KUBERNETES_ENGINE = 'gcp_kubernetes_engine';
const $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_FUNCTIONS = 'gcp_cloud_functions';
const $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_GCP_APP_ENGINE = 'gcp_app_engine';
const $11a2fe521a5dc687$export$b7ccb6b2de7534ed = $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_ECS;
const $11a2fe521a5dc687$export$5e031b328860dffd = $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_FC;
const $11a2fe521a5dc687$export$f0e8dec51b6cf37d = $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_AWS_EC2;
const $11a2fe521a5dc687$export$a325ac849a598ed7 = $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_AWS_ECS;
const $11a2fe521a5dc687$export$9c3f60b2b4d542e1 = $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_AWS_EKS;
const $11a2fe521a5dc687$export$1edcff8a13326911 = $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_AWS_LAMBDA;
const $11a2fe521a5dc687$export$2f7128c57ade0d50 = $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_AWS_ELASTIC_BEANSTALK;
const $11a2fe521a5dc687$export$10256094f96cd373 = $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_AZURE_VM;
const $11a2fe521a5dc687$export$ed505d4ca2b4d712 = $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_AZURE_CONTAINER_INSTANCES;
const $11a2fe521a5dc687$export$83131f1a1f001ee = $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_AZURE_AKS;
const $11a2fe521a5dc687$export$36f98571cef96af7 = $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_AZURE_FUNCTIONS;
const $11a2fe521a5dc687$export$66faee8e64625c5d = $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_AZURE_APP_SERVICE;
const $11a2fe521a5dc687$export$dd043c2707119e75 = $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_GCP_COMPUTE_ENGINE;
const $11a2fe521a5dc687$export$d0a1ecf47fa77b8b = $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_RUN;
const $11a2fe521a5dc687$export$649c271f5295d71e = $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_GCP_KUBERNETES_ENGINE;
const $11a2fe521a5dc687$export$e9becd93e8daa01a = $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_FUNCTIONS;
const $11a2fe521a5dc687$export$5862836e4b24761c = $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_GCP_APP_ENGINE;
const $11a2fe521a5dc687$export$fe811090f8b1259c = /*#__PURE__*/ (0, $4fd9e333ade5ddac$export$8796db7ca257d576)([
    $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_ECS,
    $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_FC,
    $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_AWS_EC2,
    $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_AWS_ECS,
    $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_AWS_EKS,
    $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_AWS_LAMBDA,
    $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_AWS_ELASTIC_BEANSTALK,
    $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_AZURE_VM,
    $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_AZURE_CONTAINER_INSTANCES,
    $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_AZURE_AKS,
    $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_AZURE_FUNCTIONS,
    $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_AZURE_APP_SERVICE,
    $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_GCP_COMPUTE_ENGINE,
    $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_RUN,
    $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_GCP_KUBERNETES_ENGINE,
    $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_FUNCTIONS,
    $11a2fe521a5dc687$var$TMP_CLOUDPLATFORMVALUES_GCP_APP_ENGINE
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for AwsEcsLaunchtypeValues enum definition
 *
 * The [launch type](https://docs.aws.amazon.com/AmazonECS/latest/developerguide/launch_types.html) for an ECS task.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
const $11a2fe521a5dc687$var$TMP_AWSECSLAUNCHTYPEVALUES_EC2 = 'ec2';
const $11a2fe521a5dc687$var$TMP_AWSECSLAUNCHTYPEVALUES_FARGATE = 'fargate';
const $11a2fe521a5dc687$export$54d16708f9a4cde = $11a2fe521a5dc687$var$TMP_AWSECSLAUNCHTYPEVALUES_EC2;
const $11a2fe521a5dc687$export$7bf660b6e44fe06e = $11a2fe521a5dc687$var$TMP_AWSECSLAUNCHTYPEVALUES_FARGATE;
const $11a2fe521a5dc687$export$6945fb1e4f2852ef = /*#__PURE__*/ (0, $4fd9e333ade5ddac$export$8796db7ca257d576)([
    $11a2fe521a5dc687$var$TMP_AWSECSLAUNCHTYPEVALUES_EC2,
    $11a2fe521a5dc687$var$TMP_AWSECSLAUNCHTYPEVALUES_FARGATE
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for HostArchValues enum definition
 *
 * The CPU architecture the host system is running on.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
const $11a2fe521a5dc687$var$TMP_HOSTARCHVALUES_AMD64 = 'amd64';
const $11a2fe521a5dc687$var$TMP_HOSTARCHVALUES_ARM32 = 'arm32';
const $11a2fe521a5dc687$var$TMP_HOSTARCHVALUES_ARM64 = 'arm64';
const $11a2fe521a5dc687$var$TMP_HOSTARCHVALUES_IA64 = 'ia64';
const $11a2fe521a5dc687$var$TMP_HOSTARCHVALUES_PPC32 = 'ppc32';
const $11a2fe521a5dc687$var$TMP_HOSTARCHVALUES_PPC64 = 'ppc64';
const $11a2fe521a5dc687$var$TMP_HOSTARCHVALUES_X86 = 'x86';
const $11a2fe521a5dc687$export$6050a837e7da966a = $11a2fe521a5dc687$var$TMP_HOSTARCHVALUES_AMD64;
const $11a2fe521a5dc687$export$3c7341cec70023f0 = $11a2fe521a5dc687$var$TMP_HOSTARCHVALUES_ARM32;
const $11a2fe521a5dc687$export$2fac5f715b596c6d = $11a2fe521a5dc687$var$TMP_HOSTARCHVALUES_ARM64;
const $11a2fe521a5dc687$export$231235882f6e6443 = $11a2fe521a5dc687$var$TMP_HOSTARCHVALUES_IA64;
const $11a2fe521a5dc687$export$c4a24e52d6385d55 = $11a2fe521a5dc687$var$TMP_HOSTARCHVALUES_PPC32;
const $11a2fe521a5dc687$export$18594ce63eac5c97 = $11a2fe521a5dc687$var$TMP_HOSTARCHVALUES_PPC64;
const $11a2fe521a5dc687$export$1af722303cbf3f49 = $11a2fe521a5dc687$var$TMP_HOSTARCHVALUES_X86;
const $11a2fe521a5dc687$export$f31e10d6db5b428b = /*#__PURE__*/ (0, $4fd9e333ade5ddac$export$8796db7ca257d576)([
    $11a2fe521a5dc687$var$TMP_HOSTARCHVALUES_AMD64,
    $11a2fe521a5dc687$var$TMP_HOSTARCHVALUES_ARM32,
    $11a2fe521a5dc687$var$TMP_HOSTARCHVALUES_ARM64,
    $11a2fe521a5dc687$var$TMP_HOSTARCHVALUES_IA64,
    $11a2fe521a5dc687$var$TMP_HOSTARCHVALUES_PPC32,
    $11a2fe521a5dc687$var$TMP_HOSTARCHVALUES_PPC64,
    $11a2fe521a5dc687$var$TMP_HOSTARCHVALUES_X86
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for OsTypeValues enum definition
 *
 * The operating system type.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
const $11a2fe521a5dc687$var$TMP_OSTYPEVALUES_WINDOWS = 'windows';
const $11a2fe521a5dc687$var$TMP_OSTYPEVALUES_LINUX = 'linux';
const $11a2fe521a5dc687$var$TMP_OSTYPEVALUES_DARWIN = 'darwin';
const $11a2fe521a5dc687$var$TMP_OSTYPEVALUES_FREEBSD = 'freebsd';
const $11a2fe521a5dc687$var$TMP_OSTYPEVALUES_NETBSD = 'netbsd';
const $11a2fe521a5dc687$var$TMP_OSTYPEVALUES_OPENBSD = 'openbsd';
const $11a2fe521a5dc687$var$TMP_OSTYPEVALUES_DRAGONFLYBSD = 'dragonflybsd';
const $11a2fe521a5dc687$var$TMP_OSTYPEVALUES_HPUX = 'hpux';
const $11a2fe521a5dc687$var$TMP_OSTYPEVALUES_AIX = 'aix';
const $11a2fe521a5dc687$var$TMP_OSTYPEVALUES_SOLARIS = 'solaris';
const $11a2fe521a5dc687$var$TMP_OSTYPEVALUES_Z_OS = 'z_os';
const $11a2fe521a5dc687$export$9e247b47b87a5e98 = $11a2fe521a5dc687$var$TMP_OSTYPEVALUES_WINDOWS;
const $11a2fe521a5dc687$export$79d9a21d50f1d11b = $11a2fe521a5dc687$var$TMP_OSTYPEVALUES_LINUX;
const $11a2fe521a5dc687$export$29d1fb472dabfab5 = $11a2fe521a5dc687$var$TMP_OSTYPEVALUES_DARWIN;
const $11a2fe521a5dc687$export$41f1a684ef8f38a0 = $11a2fe521a5dc687$var$TMP_OSTYPEVALUES_FREEBSD;
const $11a2fe521a5dc687$export$d11e84640954119d = $11a2fe521a5dc687$var$TMP_OSTYPEVALUES_NETBSD;
const $11a2fe521a5dc687$export$cf6bab1412b5a24 = $11a2fe521a5dc687$var$TMP_OSTYPEVALUES_OPENBSD;
const $11a2fe521a5dc687$export$e902e17ab5ff9bad = $11a2fe521a5dc687$var$TMP_OSTYPEVALUES_DRAGONFLYBSD;
const $11a2fe521a5dc687$export$9a4c793b18e0bd5e = $11a2fe521a5dc687$var$TMP_OSTYPEVALUES_HPUX;
const $11a2fe521a5dc687$export$bdec18d31f5e2d9d = $11a2fe521a5dc687$var$TMP_OSTYPEVALUES_AIX;
const $11a2fe521a5dc687$export$6226a44babc07d2d = $11a2fe521a5dc687$var$TMP_OSTYPEVALUES_SOLARIS;
const $11a2fe521a5dc687$export$a81b7e7863a06968 = $11a2fe521a5dc687$var$TMP_OSTYPEVALUES_Z_OS;
const $11a2fe521a5dc687$export$efc6a8b7a61f5577 = /*#__PURE__*/ (0, $4fd9e333ade5ddac$export$8796db7ca257d576)([
    $11a2fe521a5dc687$var$TMP_OSTYPEVALUES_WINDOWS,
    $11a2fe521a5dc687$var$TMP_OSTYPEVALUES_LINUX,
    $11a2fe521a5dc687$var$TMP_OSTYPEVALUES_DARWIN,
    $11a2fe521a5dc687$var$TMP_OSTYPEVALUES_FREEBSD,
    $11a2fe521a5dc687$var$TMP_OSTYPEVALUES_NETBSD,
    $11a2fe521a5dc687$var$TMP_OSTYPEVALUES_OPENBSD,
    $11a2fe521a5dc687$var$TMP_OSTYPEVALUES_DRAGONFLYBSD,
    $11a2fe521a5dc687$var$TMP_OSTYPEVALUES_HPUX,
    $11a2fe521a5dc687$var$TMP_OSTYPEVALUES_AIX,
    $11a2fe521a5dc687$var$TMP_OSTYPEVALUES_SOLARIS,
    $11a2fe521a5dc687$var$TMP_OSTYPEVALUES_Z_OS
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for TelemetrySdkLanguageValues enum definition
 *
 * The language of the telemetry SDK.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
const $11a2fe521a5dc687$var$TMP_TELEMETRYSDKLANGUAGEVALUES_CPP = 'cpp';
const $11a2fe521a5dc687$var$TMP_TELEMETRYSDKLANGUAGEVALUES_DOTNET = 'dotnet';
const $11a2fe521a5dc687$var$TMP_TELEMETRYSDKLANGUAGEVALUES_ERLANG = 'erlang';
const $11a2fe521a5dc687$var$TMP_TELEMETRYSDKLANGUAGEVALUES_GO = 'go';
const $11a2fe521a5dc687$var$TMP_TELEMETRYSDKLANGUAGEVALUES_JAVA = 'java';
const $11a2fe521a5dc687$var$TMP_TELEMETRYSDKLANGUAGEVALUES_NODEJS = 'nodejs';
const $11a2fe521a5dc687$var$TMP_TELEMETRYSDKLANGUAGEVALUES_PHP = 'php';
const $11a2fe521a5dc687$var$TMP_TELEMETRYSDKLANGUAGEVALUES_PYTHON = 'python';
const $11a2fe521a5dc687$var$TMP_TELEMETRYSDKLANGUAGEVALUES_RUBY = 'ruby';
const $11a2fe521a5dc687$var$TMP_TELEMETRYSDKLANGUAGEVALUES_WEBJS = 'webjs';
const $11a2fe521a5dc687$export$bb305b29d3ff12b2 = $11a2fe521a5dc687$var$TMP_TELEMETRYSDKLANGUAGEVALUES_CPP;
const $11a2fe521a5dc687$export$36f70c7fec241585 = $11a2fe521a5dc687$var$TMP_TELEMETRYSDKLANGUAGEVALUES_DOTNET;
const $11a2fe521a5dc687$export$9254854c1a90f699 = $11a2fe521a5dc687$var$TMP_TELEMETRYSDKLANGUAGEVALUES_ERLANG;
const $11a2fe521a5dc687$export$870f3d5bf5403ac2 = $11a2fe521a5dc687$var$TMP_TELEMETRYSDKLANGUAGEVALUES_GO;
const $11a2fe521a5dc687$export$a115dae9eb65ef38 = $11a2fe521a5dc687$var$TMP_TELEMETRYSDKLANGUAGEVALUES_JAVA;
const $11a2fe521a5dc687$export$f599ed80e3c8d29a = $11a2fe521a5dc687$var$TMP_TELEMETRYSDKLANGUAGEVALUES_NODEJS;
const $11a2fe521a5dc687$export$42ae93f6bda608ef = $11a2fe521a5dc687$var$TMP_TELEMETRYSDKLANGUAGEVALUES_PHP;
const $11a2fe521a5dc687$export$7f6f8205f1621418 = $11a2fe521a5dc687$var$TMP_TELEMETRYSDKLANGUAGEVALUES_PYTHON;
const $11a2fe521a5dc687$export$3dd620b466e18cf = $11a2fe521a5dc687$var$TMP_TELEMETRYSDKLANGUAGEVALUES_RUBY;
const $11a2fe521a5dc687$export$1414beb1e03cac7c = $11a2fe521a5dc687$var$TMP_TELEMETRYSDKLANGUAGEVALUES_WEBJS;
const $11a2fe521a5dc687$export$b43162e16168dba6 = /*#__PURE__*/ (0, $4fd9e333ade5ddac$export$8796db7ca257d576)([
    $11a2fe521a5dc687$var$TMP_TELEMETRYSDKLANGUAGEVALUES_CPP,
    $11a2fe521a5dc687$var$TMP_TELEMETRYSDKLANGUAGEVALUES_DOTNET,
    $11a2fe521a5dc687$var$TMP_TELEMETRYSDKLANGUAGEVALUES_ERLANG,
    $11a2fe521a5dc687$var$TMP_TELEMETRYSDKLANGUAGEVALUES_GO,
    $11a2fe521a5dc687$var$TMP_TELEMETRYSDKLANGUAGEVALUES_JAVA,
    $11a2fe521a5dc687$var$TMP_TELEMETRYSDKLANGUAGEVALUES_NODEJS,
    $11a2fe521a5dc687$var$TMP_TELEMETRYSDKLANGUAGEVALUES_PHP,
    $11a2fe521a5dc687$var$TMP_TELEMETRYSDKLANGUAGEVALUES_PYTHON,
    $11a2fe521a5dc687$var$TMP_TELEMETRYSDKLANGUAGEVALUES_RUBY,
    $11a2fe521a5dc687$var$TMP_TELEMETRYSDKLANGUAGEVALUES_WEBJS
]);


const $d42f6bfbf27b66f6$var$isLocalhost = typeof window !== "undefined" && [
    "localhost",
    "127.0.0.1"
].includes(window.location.hostname);
// Deployed environments export to the same-origin ingress (/v1/traces), which
// proxies to that environment's OTel collector. This avoids CORS and prevents
// a tst/lab/prd build from pointing at the wrong collector. Local dev keeps
// the explicit endpoint from .env.
const $d42f6bfbf27b66f6$var$otlpEndpoint = $d42f6bfbf27b66f6$var$isLocalhost ? "/v1/traces" : "/v1/traces";
const $d42f6bfbf27b66f6$var$exporter = new (0, $50e24aa04678c249$export$f73dc942b4b27de3)({
    url: $d42f6bfbf27b66f6$var$otlpEndpoint
});
const $d42f6bfbf27b66f6$var$provider = new (0, $63a533b9ee75e32f$export$a785009afeee3453)({
    // @ts-ignore
    resource: (0, $34b7feab81bdb448$export$bb0fe4e7060febbf)({
        [(0, $11a2fe521a5dc687$export$48c68257f49298c9)]: "tst.niposom.intranet-frontend"
    }),
    spanProcessors: [
        new (0, $6387aa3fe0aa015a$export$237547059fd543f9)($d42f6bfbf27b66f6$var$exporter)
    ]
});
$d42f6bfbf27b66f6$var$provider.register({
    contextManager: new (0, $89c185efeb78c80b$export$148434e42b84e81c)()
});
(0, $412e403263150e72$export$fc0a1ca5231d826a)({
    tracerProvider: $d42f6bfbf27b66f6$var$provider,
    instrumentations: [
        (0, $a112618ca8699b5a$export$2b6a8cc738089ff9)({
            // load custom configuration for web instrumentations here
            "@opentelemetry/instrumentation-fetch": {
                propagateTraceHeaderCorsUrls: /.*/,
                clearTimingResources: true,
                applyCustomAttributesOnSpan: (span)=>{
                    span.setAttribute("app.synthetic", false);
                }
            }
        })
    ]
});


parcelRequire("acw62");
var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    var err;
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
}

$7e96a608cb33bf79$exports = (parcelRequire("lkeHb"));



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
/**
 * react-router v7.10.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");
var $585f8bce88e531c1$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/development/chunk-WWGJGFF6.mjs"
});
var $585f8bce88e531c1$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $585f8bce88e531c1$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $585f8bce88e531c1$var$__typeError("Cannot " + msg);
var $585f8bce88e531c1$var$__privateGet = (obj, member, getter)=>($585f8bce88e531c1$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $585f8bce88e531c1$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $585f8bce88e531c1$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
// lib/router/history.ts
var $585f8bce88e531c1$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($585f8bce88e531c1$export$e19cd5f9376f8cee || {});
var $585f8bce88e531c1$var$PopStateEventType = "popstate";
function $585f8bce88e531c1$var$createMemoryHistory(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key) {
        let location = $585f8bce88e531c1$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $585f8bce88e531c1$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $585f8bce88e531c1$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $585f8bce88e531c1$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $585f8bce88e531c1$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window2.location;
        return $585f8bce88e531c1$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $585f8bce88e531c1$export$fe53371bee54353d(to);
    }
    return $585f8bce88e531c1$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $585f8bce88e531c1$var$createHashHistory(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $585f8bce88e531c1$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $585f8bce88e531c1$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $585f8bce88e531c1$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $585f8bce88e531c1$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $585f8bce88e531c1$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $585f8bce88e531c1$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $585f8bce88e531c1$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $585f8bce88e531c1$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $585f8bce88e531c1$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
function $585f8bce88e531c1$var$createLocation(current, to, state = null, key) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $585f8bce88e531c1$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $585f8bce88e531c1$var$createKey()
    };
    return location;
}
function $585f8bce88e531c1$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $585f8bce88e531c1$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $585f8bce88e531c1$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $585f8bce88e531c1$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $585f8bce88e531c1$var$getHistoryState(location, index);
        let url = history.createHref(location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $585f8bce88e531c1$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $585f8bce88e531c1$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $585f8bce88e531c1$var$createBrowserURLImpl(to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($585f8bce88e531c1$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($585f8bce88e531c1$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $585f8bce88e531c1$var$createBrowserURLImpl(to, isAbsolute = false) {
    let base = "http://localhost";
    if (typeof window !== "undefined") base = window.location.origin !== "null" ? window.location.origin : window.location.href;
    $585f8bce88e531c1$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $585f8bce88e531c1$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && href.startsWith("//")) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function $585f8bce88e531c1$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $585f8bce88e531c1$var$_map;
var $585f8bce88e531c1$export$b8d3e69d4b3eff04 = class {
    /**
   * Create a new `RouterContextProvider` instance
   * @param init An optional initial context map to populate the provider with
   */ constructor(init){
        $585f8bce88e531c1$var$__privateAdd(this, $585f8bce88e531c1$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ get(context) {
        if ($585f8bce88e531c1$var$__privateGet(this, $585f8bce88e531c1$var$_map).has(context)) return $585f8bce88e531c1$var$__privateGet(this, $585f8bce88e531c1$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ set(context, value) {
        $585f8bce88e531c1$var$__privateGet(this, $585f8bce88e531c1$var$_map).set(context, value);
    }
};
$585f8bce88e531c1$var$_map = new WeakMap();
var $585f8bce88e531c1$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $585f8bce88e531c1$var$isUnsupportedLazyRouteObjectKey(key) {
    return $585f8bce88e531c1$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $585f8bce88e531c1$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $585f8bce88e531c1$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $585f8bce88e531c1$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $585f8bce88e531c1$var$isIndexRoute(route) {
    return route.index === true;
}
function $585f8bce88e531c1$export$87cb1a9238dc3fba(routes, mapRouteProperties2, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $585f8bce88e531c1$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $585f8bce88e531c1$export$f5708dca728d7177(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($585f8bce88e531c1$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $585f8bce88e531c1$var$mergeRouteUpdates(indexRoute, mapRouteProperties2(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $585f8bce88e531c1$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties2(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $585f8bce88e531c1$export$87cb1a9238dc3fba(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $585f8bce88e531c1$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
function $585f8bce88e531c1$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $585f8bce88e531c1$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $585f8bce88e531c1$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $585f8bce88e531c1$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $585f8bce88e531c1$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $585f8bce88e531c1$var$flattenRoutes(routes);
    $585f8bce88e531c1$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        let decoded = $585f8bce88e531c1$var$decodePath(pathname);
        matches = $585f8bce88e531c1$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $585f8bce88e531c1$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $585f8bce88e531c1$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            $585f8bce88e531c1$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $585f8bce88e531c1$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $585f8bce88e531c1$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $585f8bce88e531c1$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $585f8bce88e531c1$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $585f8bce88e531c1$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $585f8bce88e531c1$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $585f8bce88e531c1$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $585f8bce88e531c1$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $585f8bce88e531c1$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $585f8bce88e531c1$var$paramRe = /^:[\w-]+$/;
var $585f8bce88e531c1$var$dynamicSegmentValue = 3;
var $585f8bce88e531c1$var$indexRouteValue = 2;
var $585f8bce88e531c1$var$emptySegmentValue = 1;
var $585f8bce88e531c1$var$staticSegmentValue = 10;
var $585f8bce88e531c1$var$splatPenalty = -2;
var $585f8bce88e531c1$var$isSplat = (s)=>s === "*";
function $585f8bce88e531c1$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($585f8bce88e531c1$var$isSplat)) initialScore += $585f8bce88e531c1$var$splatPenalty;
    if (index) initialScore += $585f8bce88e531c1$var$indexRouteValue;
    return segments.filter((s)=>!$585f8bce88e531c1$var$isSplat(s)).reduce((score, segment)=>score + ($585f8bce88e531c1$var$paramRe.test(segment) ? $585f8bce88e531c1$var$dynamicSegmentValue : segment === "" ? $585f8bce88e531c1$var$emptySegmentValue : $585f8bce88e531c1$var$staticSegmentValue), initialScore);
}
function $585f8bce88e531c1$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $585f8bce88e531c1$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $585f8bce88e531c1$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $585f8bce88e531c1$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $585f8bce88e531c1$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $585f8bce88e531c1$var$normalizePathname($585f8bce88e531c1$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $585f8bce88e531c1$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $585f8bce88e531c1$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $585f8bce88e531c1$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") {
            const star = "*";
            return stringify2(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $585f8bce88e531c1$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return encodeURIComponent(stringify2(param));
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $585f8bce88e531c1$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $585f8bce88e531c1$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $585f8bce88e531c1$var$compilePath(path, caseSensitive = false, end = true) {
    $585f8bce88e531c1$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $585f8bce88e531c1$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $585f8bce88e531c1$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $585f8bce88e531c1$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $585f8bce88e531c1$var$prependBasename({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $585f8bce88e531c1$var$joinPaths([
        basename,
        pathname
    ]);
}
var $585f8bce88e531c1$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $585f8bce88e531c1$var$isAbsoluteUrl = (url)=>$585f8bce88e531c1$var$ABSOLUTE_URL_REGEX.test(url);
function $585f8bce88e531c1$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $585f8bce88e531c1$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($585f8bce88e531c1$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = toPathname.replace(/\/\/+/g, "/");
                $585f8bce88e531c1$var$warning(false, `Pathnames cannot have embedded double slashes - normalizing ${oldPathname} -> ${toPathname}`);
            }
            if (toPathname.startsWith("/")) pathname = $585f8bce88e531c1$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $585f8bce88e531c1$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $585f8bce88e531c1$var$normalizeSearch(search),
        hash: $585f8bce88e531c1$var$normalizeHash(hash)
    };
}
function $585f8bce88e531c1$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $585f8bce88e531c1$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $585f8bce88e531c1$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $585f8bce88e531c1$var$getResolveToMatches(matches) {
    let pathMatches = $585f8bce88e531c1$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $585f8bce88e531c1$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $585f8bce88e531c1$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $585f8bce88e531c1$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $585f8bce88e531c1$var$getInvalidPathError("?", "pathname", "search", to));
        $585f8bce88e531c1$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $585f8bce88e531c1$var$getInvalidPathError("#", "pathname", "hash", to));
        $585f8bce88e531c1$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $585f8bce88e531c1$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $585f8bce88e531c1$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $585f8bce88e531c1$var$joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
var $585f8bce88e531c1$var$normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
var $585f8bce88e531c1$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $585f8bce88e531c1$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $585f8bce88e531c1$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $585f8bce88e531c1$export$4051a07651545597(data2, init) {
    return new $585f8bce88e531c1$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $585f8bce88e531c1$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $585f8bce88e531c1$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $585f8bce88e531c1$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $585f8bce88e531c1$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $585f8bce88e531c1$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $585f8bce88e531c1$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $585f8bce88e531c1$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $585f8bce88e531c1$var$getRoutePattern(matches) {
    return matches.map((m)=>m.route.path).filter(Boolean).join("/").replace(/\/\/*/g, "/") || "/";
}
// lib/router/instrumentation.ts
var $585f8bce88e531c1$var$UninstrumentedSymbol = Symbol("Uninstrumented");
function $585f8bce88e531c1$var$getRouteInstrumentationUpdates(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                let keys = Object.keys(aggregated);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let instrumented = $585f8bce88e531c1$var$wrapImpl(aggregated.lazy, route.lazy, ()=>void 0);
        if (instrumented) updates.lazy = instrumented;
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach((key)=>{
            let lazyFn = lazyObject[key];
            let instrumentations = aggregated[`lazy.${key}`];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                let instrumented = $585f8bce88e531c1$var$wrapImpl(instrumentations, lazyFn, ()=>void 0);
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, {
                    [key]: instrumented
                });
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach((key)=>{
        let handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            let original = handler[$585f8bce88e531c1$var$UninstrumentedSymbol] ?? handler;
            let instrumented = $585f8bce88e531c1$var$wrapImpl(aggregated[key], original, (...args)=>$585f8bce88e531c1$var$getHandlerInfo(args[0]));
            if (instrumented) {
                instrumented[$585f8bce88e531c1$var$UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = middleware[$585f8bce88e531c1$var$UninstrumentedSymbol] ?? middleware;
        let instrumented = $585f8bce88e531c1$var$wrapImpl(aggregated.middleware, original, (...args)=>$585f8bce88e531c1$var$getHandlerInfo(args[0]));
        if (instrumented) {
            instrumented[$585f8bce88e531c1$var$UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function $585f8bce88e531c1$var$instrumentClientSideRouter(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = router.navigate[$585f8bce88e531c1$var$UninstrumentedSymbol] ?? router.navigate;
        let instrumentedNavigate = $585f8bce88e531c1$var$wrapImpl(aggregated.navigate, navigate, (...args)=>{
            let [to, opts] = args;
            return {
                to: typeof to === "number" || typeof to === "string" ? to : to ? $585f8bce88e531c1$export$fe53371bee54353d(to) : ".",
                ...$585f8bce88e531c1$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[$585f8bce88e531c1$var$UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        let fetch2 = router.fetch[$585f8bce88e531c1$var$UninstrumentedSymbol] ?? router.fetch;
        let instrumentedFetch = $585f8bce88e531c1$var$wrapImpl(aggregated.fetch, fetch2, (...args)=>{
            let [key, , href, opts] = args;
            return {
                href: href ?? ".",
                fetcherKey: key,
                ...$585f8bce88e531c1$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedFetch) {
            instrumentedFetch[$585f8bce88e531c1$var$UninstrumentedSymbol] = fetch2;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function $585f8bce88e531c1$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = $585f8bce88e531c1$var$wrapImpl(aggregated.request, handler, (...args)=>{
        let [request, context] = args;
        return {
            request: $585f8bce88e531c1$var$getReadonlyRequest(request),
            context: context != null ? $585f8bce88e531c1$var$getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function $585f8bce88e531c1$var$wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return async (...args)=>{
        let result = await $585f8bce88e531c1$var$recurseRight(impls, getInfo(...args), ()=>handler(...args), impls.length - 1);
        if (result.type === "error") throw result.value;
        return result.value;
    };
}
async function $585f8bce88e531c1$var$recurseRight(impls, info, handler, index) {
    let impl = impls[index];
    let result;
    if (!impl) try {
        let value = await handler();
        result = {
            type: "success",
            value: value
        };
    } catch (e) {
        result = {
            type: "error",
            value: e
        };
    }
    else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $585f8bce88e531c1$var$recurseRight(impls, info, handler, index - 1);
            result = await handlerPromise;
            $585f8bce88e531c1$export$f5708dca728d7177(result, "Expected a result");
            if (result.type === "error" && result.value instanceof Error) return {
                status: "error",
                error: result.value
            };
            return {
                status: "success",
                error: void 0
            };
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (result) return result;
    return {
        type: "error",
        value: new Error("No result assigned in instrumentation chain.")
    };
}
function $585f8bce88e531c1$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params, unstable_pattern: unstable_pattern } = args;
    return {
        request: $585f8bce88e531c1$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        unstable_pattern: unstable_pattern,
        context: $585f8bce88e531c1$var$getReadonlyContext(context)
    };
}
function $585f8bce88e531c1$var$getRouterInfo(router, opts) {
    return {
        currentUrl: $585f8bce88e531c1$export$fe53371bee54353d(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $585f8bce88e531c1$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $585f8bce88e531c1$var$getReadonlyContext(context) {
    if ($585f8bce88e531c1$var$isPlainObject(context)) {
        let frozen = {
            ...context
        };
        Object.freeze(frozen);
        return frozen;
    } else return {
        get: (ctx)=>context.get(ctx)
    };
}
var $585f8bce88e531c1$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $585f8bce88e531c1$var$isPlainObject(thing) {
    if (thing === null || typeof thing !== "object") return false;
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $585f8bce88e531c1$var$objectProtoNames;
}
// lib/router/router.ts
var $585f8bce88e531c1$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $585f8bce88e531c1$var$validMutationMethods = new Set($585f8bce88e531c1$var$validMutationMethodsArr);
var $585f8bce88e531c1$var$validRequestMethodsArr = [
    "GET",
    ...$585f8bce88e531c1$var$validMutationMethodsArr
];
var $585f8bce88e531c1$var$validRequestMethods = new Set($585f8bce88e531c1$var$validRequestMethodsArr);
var $585f8bce88e531c1$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $585f8bce88e531c1$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $585f8bce88e531c1$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $585f8bce88e531c1$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $585f8bce88e531c1$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $585f8bce88e531c1$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $585f8bce88e531c1$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $585f8bce88e531c1$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
function $585f8bce88e531c1$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser2 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $585f8bce88e531c1$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties || $585f8bce88e531c1$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (init.unstable_instrumentations) {
        let instrumentations = init.unstable_instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$585f8bce88e531c1$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let manifest = {};
    let dataRoutes = $585f8bce88e531c1$export$87cb1a9238dc3fba(init.routes, mapRouteProperties2, void 0, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $585f8bce88e531c1$var$defaultDataStrategyWithMiddleware;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $585f8bce88e531c1$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $585f8bce88e531c1$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $585f8bce88e531c1$var$getShortCircuitMatches(dataRoutes);
        initialized = true;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) initialized = false;
        else if (!initialMatches.some((m)=>$585f8bce88e531c1$var$routeHasLoaderOrMiddleware(m.route))) initialized = true;
        else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                initialized = initialMatches.slice(0, idx + 1).every((m)=>!$585f8bce88e531c1$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
            } else initialized = initialMatches.every((m)=>!$585f8bce88e531c1$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $585f8bce88e531c1$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $585f8bce88e531c1$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $585f8bce88e531c1$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd?.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser2) {
            $585f8bce88e531c1$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$585f8bce88e531c1$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: newState.errors ?? null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $585f8bce88e531c1$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $585f8bce88e531c1$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $585f8bce88e531c1$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $585f8bce88e531c1$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = void 0;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $585f8bce88e531c1$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $585f8bce88e531c1$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let normalizedPath = $585f8bce88e531c1$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $585f8bce88e531c1$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $585f8bce88e531c1$var$createLocation(state.location, path, opts && opts.state);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $585f8bce88e531c1$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $585f8bce88e531c1$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $585f8bce88e531c1$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $585f8bce88e531c1$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $585f8bce88e531c1$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $585f8bce88e531c1$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        pendingNavigationController = new AbortController();
        let request = $585f8bce88e531c1$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new $585f8bce88e531c1$export$b8d3e69d4b3eff04();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $585f8bce88e531c1$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $585f8bce88e531c1$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($585f8bce88e531c1$var$isErrorResult(result) && $585f8bce88e531c1$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $585f8bce88e531c1$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $585f8bce88e531c1$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$585f8bce88e531c1$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors
        });
    }
    async function handleAction(request, location, submission, matches, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $585f8bce88e531c1$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $585f8bce88e531c1$var$getShortCircuitMatches(dataRoutes);
                    return {
                        matches: matches2,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error" /* error */ ,
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $585f8bce88e531c1$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $585f8bce88e531c1$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $585f8bce88e531c1$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $585f8bce88e531c1$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($585f8bce88e531c1$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $585f8bce88e531c1$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($585f8bce88e531c1$var$isErrorResult(result)) {
            let boundaryMatch = $585f8bce88e531c1$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult) {
        let loadingNavigation = overrideNavigation || $585f8bce88e531c1$var$getLoadingNavigation(location, submission);
        let activeSubmission = submission || fetcherSubmission || $585f8bce88e531c1$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $585f8bce88e531c1$var$getShortCircuitMatches(dataRoutes);
                    return {
                        matches: matches2,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $585f8bce88e531c1$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $585f8bce88e531c1$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, pendingActionResult);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let updatedFetchers2 = markFetchRedirectsDone();
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $585f8bce88e531c1$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$585f8bce88e531c1$var$getActionDataForCommit(pendingActionResult),
                ...updatedFetchers2 ? {
                    fetchers: new Map(state.fetchers)
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $585f8bce88e531c1$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $585f8bce88e531c1$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let { loaderData: loaderData, errors: errors } = $585f8bce88e531c1$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$585f8bce88e531c1$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $585f8bce88e531c1$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $585f8bce88e531c1$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $585f8bce88e531c1$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $585f8bce88e531c1$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $585f8bce88e531c1$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new $585f8bce88e531c1$export$b8d3e69d4b3eff04();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $585f8bce88e531c1$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $585f8bce88e531c1$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $585f8bce88e531c1$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $585f8bce88e531c1$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $585f8bce88e531c1$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            let error = $585f8bce88e531c1$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $585f8bce88e531c1$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match2 of fetchMatches)if (actionResults[match2.route.id]) {
                actionResult = actionResults[match2.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($585f8bce88e531c1$var$isRedirectResult(actionResult) || $585f8bce88e531c1$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $585f8bce88e531c1$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($585f8bce88e531c1$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $585f8bce88e531c1$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $585f8bce88e531c1$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($585f8bce88e531c1$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $585f8bce88e531c1$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $585f8bce88e531c1$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $585f8bce88e531c1$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $585f8bce88e531c1$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $585f8bce88e531c1$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, [
            match.route.id,
            actionResult
        ]);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = state.fetchers.get(staleKey);
            let revalidatingFetcher = $585f8bce88e531c1$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        if (state.fetchers.has(key)) {
            let doneFetcher = $585f8bce88e531c1$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let redirect2 = $585f8bce88e531c1$var$findRedirect(loaderResults);
        if (redirect2) return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect2 = $585f8bce88e531c1$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let { loaderData: loaderData, errors: errors } = $585f8bce88e531c1$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults);
        abortStaleFetchLoads(loadId);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $585f8bce88e531c1$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $585f8bce88e531c1$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $585f8bce88e531c1$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $585f8bce88e531c1$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $585f8bce88e531c1$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $585f8bce88e531c1$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $585f8bce88e531c1$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $585f8bce88e531c1$var$getDoneFetcher(void 0));
            return;
        }
        if ($585f8bce88e531c1$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $585f8bce88e531c1$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($585f8bce88e531c1$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $585f8bce88e531c1$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd?.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $585f8bce88e531c1$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        location = $585f8bce88e531c1$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $585f8bce88e531c1$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser2) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($585f8bce88e531c1$var$isAbsoluteUrl(location)) {
                const url = $585f8bce88e531c1$var$createBrowserURLImpl(location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $585f8bce88e531c1$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $585f8bce88e531c1$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($585f8bce88e531c1$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $585f8bce88e531c1$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $585f8bce88e531c1$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $585f8bce88e531c1$var$callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        for (let [routeId, result] of Object.entries(results))if ($585f8bce88e531c1$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $585f8bce88e531c1$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $585f8bce88e531c1$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $585f8bce88e531c1$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $585f8bce88e531c1$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $585f8bce88e531c1$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        updateFetcherState(key, $585f8bce88e531c1$var$getDoneFetcher(null));
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $585f8bce88e531c1$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $585f8bce88e531c1$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $585f8bce88e531c1$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $585f8bce88e531c1$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $585f8bce88e531c1$export$386d57f03f0b2883;
        $585f8bce88e531c1$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $585f8bce88e531c1$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $585f8bce88e531c1$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $585f8bce88e531c1$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $585f8bce88e531c1$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$585f8bce88e531c1$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            if (!matches) {
                let fogMatches = $585f8bce88e531c1$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $585f8bce88e531c1$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $585f8bce88e531c1$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties2, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $585f8bce88e531c1$export$2708184779ceb39d(routesToUse, pathname, basename);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = $585f8bce88e531c1$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                    let matchedDeeper = newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length));
                    if (!matchedDeeper) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = $585f8bce88e531c1$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $585f8bce88e531c1$export$87cb1a9238dc3fba(newRoutes, mapRouteProperties2, void 0, manifest);
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $585f8bce88e531c1$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.unstable_instrumentations) router = $585f8bce88e531c1$var$instrumentClientSideRouter(router, init.unstable_instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
function $585f8bce88e531c1$export$3336b097a6fbc59a(routes, opts) {
    $585f8bce88e531c1$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties || $585f8bce88e531c1$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (opts?.unstable_instrumentations) {
        let instrumentations = opts.unstable_instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$585f8bce88e531c1$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = $585f8bce88e531c1$export$87cb1a9238dc3fba(routes, mapRouteProperties2, void 0, manifest);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $585f8bce88e531c1$var$createLocation("", $585f8bce88e531c1$export$fe53371bee54353d(url), null, "default");
        let matches = $585f8bce88e531c1$export$2708184779ceb39d(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new $585f8bce88e531c1$export$b8d3e69d4b3eff04();
        if (!$585f8bce88e531c1$var$isValidMethod(method) && method !== "HEAD") {
            let error = $585f8bce88e531c1$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $585f8bce88e531c1$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $585f8bce88e531c1$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $585f8bce88e531c1$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            $585f8bce88e531c1$export$f5708dca728d7177(requestContext instanceof $585f8bce88e531c1$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $585f8bce88e531c1$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $585f8bce88e531c1$var$runServerMiddlewarePipeline({
                    request: request,
                    unstable_pattern: $585f8bce88e531c1$var$getRoutePattern(matches),
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, async ()=>{
                    let res = await generateMiddlewareResponse(async (revalidationRequest, opts2 = {})=>{
                        let result2 = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? opts2.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($585f8bce88e531c1$export$3f1eb41d9a6a6a27(result2)) return result2;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result2
                        };
                        return renderedStaticContext;
                    });
                    return res;
                }, async (error, routeId)=>{
                    if ($585f8bce88e531c1$export$6e80290866a84dd4(error)) return error;
                    if ($585f8bce88e531c1$export$3f1eb41d9a6a6a27(error)) try {
                        error = new $585f8bce88e531c1$export$f2680fa305b734ca(error.status, error.statusText, await $585f8bce88e531c1$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($585f8bce88e531c1$export$e0163cfdf7bc9cfa(error)) error = $585f8bce88e531c1$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $585f8bce88e531c1$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $585f8bce88e531c1$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $585f8bce88e531c1$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $585f8bce88e531c1$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                $585f8bce88e531c1$export$f5708dca728d7177($585f8bce88e531c1$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($585f8bce88e531c1$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($585f8bce88e531c1$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $585f8bce88e531c1$var$createLocation("", $585f8bce88e531c1$export$fe53371bee54353d(url), null, "default");
        let matches = $585f8bce88e531c1$export$2708184779ceb39d(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new $585f8bce88e531c1$export$b8d3e69d4b3eff04();
        if (!$585f8bce88e531c1$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $585f8bce88e531c1$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $585f8bce88e531c1$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $585f8bce88e531c1$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $585f8bce88e531c1$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $585f8bce88e531c1$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            $585f8bce88e531c1$export$f5708dca728d7177(requestContext instanceof $585f8bce88e531c1$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $585f8bce88e531c1$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $585f8bce88e531c1$var$runServerMiddlewarePipeline({
                request: request,
                unstable_pattern: $585f8bce88e531c1$var$getRoutePattern(matches),
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, async ()=>{
                let res = await generateMiddlewareResponse(async (innerRequest)=>{
                    let result2 = await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                    let processed = handleQueryResult(result2);
                    return $585f8bce88e531c1$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
                return res;
            }, (error)=>{
                if ($585f8bce88e531c1$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($585f8bce88e531c1$var$dataWithResponseInitToResponse(error));
                if ($585f8bce88e531c1$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        return handleQueryResult(result);
        function handleQueryResult(result2) {
            if ($585f8bce88e531c1$export$3f1eb41d9a6a6a27(result2)) return result2;
            let error = result2.errors ? Object.values(result2.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result2.actionData) return Object.values(result2.actionData)[0];
            if (result2.loaderData) return Object.values(result2.loaderData)[0];
            return void 0;
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $585f8bce88e531c1$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($585f8bce88e531c1$export$cbae47800eb95bc3(request.method)) {
                let result2 = await submit(request, matches, routeMatch || $585f8bce88e531c1$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $585f8bce88e531c1$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($585f8bce88e531c1$var$isDataStrategyResult(e) && $585f8bce88e531c1$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($585f8bce88e531c1$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $585f8bce88e531c1$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $585f8bce88e531c1$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $585f8bce88e531c1$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($585f8bce88e531c1$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($585f8bce88e531c1$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($585f8bce88e531c1$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $585f8bce88e531c1$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $585f8bce88e531c1$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($585f8bce88e531c1$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $585f8bce88e531c1$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: $585f8bce88e531c1$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $585f8bce88e531c1$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $585f8bce88e531c1$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $585f8bce88e531c1$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = $585f8bce88e531c1$var$getRoutePattern(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $585f8bce88e531c1$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, [], requestContext, false);
                return $585f8bce88e531c1$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $585f8bce88e531c1$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $585f8bce88e531c1$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $585f8bce88e531c1$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches: matches
        };
    }
    async function callDataStrategy(request, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $585f8bce88e531c1$var$callDataStrategyImpl(dataStrategy || $585f8bce88e531c1$var$defaultDataStrategy, request, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($585f8bce88e531c1$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $585f8bce88e531c1$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($585f8bce88e531c1$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($585f8bce88e531c1$export$e0163cfdf7bc9cfa(result.result)) throw $585f8bce88e531c1$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $585f8bce88e531c1$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
function $585f8bce88e531c1$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: $585f8bce88e531c1$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $585f8bce88e531c1$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $585f8bce88e531c1$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $585f8bce88e531c1$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $585f8bce88e531c1$var$resolveTo(to ? to : ".", $585f8bce88e531c1$var$getResolveToMatches(contextualMatches), $585f8bce88e531c1$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $585f8bce88e531c1$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = $585f8bce88e531c1$var$prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return $585f8bce88e531c1$export$fe53371bee54353d(path);
}
function $585f8bce88e531c1$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$585f8bce88e531c1$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$585f8bce88e531c1$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $585f8bce88e531c1$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $585f8bce88e531c1$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $585f8bce88e531c1$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$585f8bce88e531c1$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$585f8bce88e531c1$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $585f8bce88e531c1$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $585f8bce88e531c1$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $585f8bce88e531c1$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $585f8bce88e531c1$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $585f8bce88e531c1$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($585f8bce88e531c1$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $585f8bce88e531c1$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $585f8bce88e531c1$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $585f8bce88e531c1$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $585f8bce88e531c1$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, pendingActionResult) {
    let actionResult = pendingActionResult ? $585f8bce88e531c1$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $585f8bce88e531c1$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = $585f8bce88e531c1$var$getRoutePattern(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$585f8bce88e531c1$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) forceShouldLoad = $585f8bce88e531c1$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        else if ($585f8bce88e531c1$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $585f8bce88e531c1$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
        isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
        currentUrl.search !== nextUrl.search || $585f8bce88e531c1$var$isNewRouteInstance(state.matches[index], match);
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        let shouldLoad = $585f8bce88e531c1$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $585f8bce88e531c1$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = $585f8bce88e531c1$export$2708184779ceb39d(routesToUse, f.path, basename);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $585f8bce88e531c1$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $585f8bce88e531c1$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $585f8bce88e531c1$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $585f8bce88e531c1$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
            };
            if ($585f8bce88e531c1$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $585f8bce88e531c1$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $585f8bce88e531c1$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $585f8bce88e531c1$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    if (route.lazy) return true;
    if (!$585f8bce88e531c1$var$routeHasLoaderOrMiddleware(route)) return false;
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return false;
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    return !hasData && !hasError;
}
function $585f8bce88e531c1$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $585f8bce88e531c1$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $585f8bce88e531c1$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $585f8bce88e531c1$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $585f8bce88e531c1$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute2)=>$585f8bce88e531c1$var$isSameRoute(newRoute, existingRoute2));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = $585f8bce88e531c1$export$87cb1a9238dc3fba(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = $585f8bce88e531c1$export$87cb1a9238dc3fba([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
}
function $585f8bce88e531c1$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children.every((aChild, i)=>existingRoute.children?.some((bChild)=>$585f8bce88e531c1$var$isSameRoute(aChild, bChild)));
}
var $585f8bce88e531c1$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $585f8bce88e531c1$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $585f8bce88e531c1$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $585f8bce88e531c1$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $585f8bce88e531c1$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $585f8bce88e531c1$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $585f8bce88e531c1$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $585f8bce88e531c1$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $585f8bce88e531c1$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $585f8bce88e531c1$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $585f8bce88e531c1$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $585f8bce88e531c1$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $585f8bce88e531c1$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $585f8bce88e531c1$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $585f8bce88e531c1$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $585f8bce88e531c1$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        $585f8bce88e531c1$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $585f8bce88e531c1$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $585f8bce88e531c1$var$isNonNullable(value) {
    return value !== void 0;
}
function $585f8bce88e531c1$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return void 0;
        return $585f8bce88e531c1$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($585f8bce88e531c1$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $585f8bce88e531c1$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $585f8bce88e531c1$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $585f8bce88e531c1$var$defaultDataStrategy(args);
    return $585f8bce88e531c1$var$runClientMiddlewarePipeline(args, ()=>$585f8bce88e531c1$var$defaultDataStrategy(args));
}
function $585f8bce88e531c1$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $585f8bce88e531c1$var$runMiddlewarePipeline(args, handler, processResult, $585f8bce88e531c1$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $585f8bce88e531c1$export$e0163cfdf7bc9cfa(result) ? $585f8bce88e531c1$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $585f8bce88e531c1$var$runClientMiddlewarePipeline(args, handler) {
    return $585f8bce88e531c1$var$runMiddlewarePipeline(args, handler, (r)=>r, // No post-processing needed on the client
    $585f8bce88e531c1$var$isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        }));
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let boundaryRouteId = $585f8bce88e531c1$var$findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve({
                [boundaryRouteId]: {
                    type: "error",
                    result: error
                }
            });
        }
    }
}
async function $585f8bce88e531c1$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, request: request, params: params, context: context, unstable_pattern: unstable_pattern } = args;
    let tuples = matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []);
    let result = await $585f8bce88e531c1$var$callRouteMiddleware({
        request: request,
        params: params,
        context: context,
        unstable_pattern: unstable_pattern
    }, tuples, handler, processResult, isResult, errorHandler);
    return result;
}
async function $585f8bce88e531c1$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) {
        let result = await handler();
        return result;
    }
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            let result = await $585f8bce88e531c1$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1);
            nextResult = {
                value: result
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        let response = await errorHandler(error, routeId, nextResult);
        return response;
    }
}
function $585f8bce88e531c1$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $585f8bce88e531c1$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $585f8bce88e531c1$var$loadLazyRoute(match.route, $585f8bce88e531c1$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $585f8bce88e531c1$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, unstable_pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null) {
    let isUsingNewApi = false;
    let _lazyPromises = $585f8bce88e531c1$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof defaultShouldRevalidate === "boolean") return $585f8bce88e531c1$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $585f8bce88e531c1$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$585f8bce88e531c1$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($585f8bce88e531c1$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $585f8bce88e531c1$var$callLoaderOrAction({
                request: request,
                unstable_pattern: unstable_pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function $585f8bce88e531c1$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $585f8bce88e531c1$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $585f8bce88e531c1$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, $585f8bce88e531c1$var$getRoutePattern(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $585f8bce88e531c1$var$callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        unstable_pattern: $585f8bce88e531c1$var$getRoutePattern(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $585f8bce88e531c1$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function $585f8bce88e531c1$var$callLoaderOrAction({ request: request, unstable_pattern: unstable_pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $585f8bce88e531c1$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                unstable_pattern: unstable_pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $585f8bce88e531c1$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $585f8bce88e531c1$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $585f8bce88e531c1$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $585f8bce88e531c1$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($585f8bce88e531c1$export$3f1eb41d9a6a6a27(result)) {
        let data2;
        try {
            data2 = await $585f8bce88e531c1$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $585f8bce88e531c1$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($585f8bce88e531c1$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: $585f8bce88e531c1$var$dataWithResponseInitToErrorResponse(result),
                statusCode: $585f8bce88e531c1$export$972111febbeef05b(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $585f8bce88e531c1$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($585f8bce88e531c1$export$e0163cfdf7bc9cfa(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $585f8bce88e531c1$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $585f8bce88e531c1$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$585f8bce88e531c1$var$isAbsoluteUrl(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $585f8bce88e531c1$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
function $585f8bce88e531c1$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($585f8bce88e531c1$var$isAbsoluteUrl(location)) {
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $585f8bce88e531c1$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
function $585f8bce88e531c1$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($585f8bce88e531c1$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $585f8bce88e531c1$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $585f8bce88e531c1$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $585f8bce88e531c1$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $585f8bce88e531c1$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $585f8bce88e531c1$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $585f8bce88e531c1$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $585f8bce88e531c1$export$f5708dca728d7177(!$585f8bce88e531c1$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($585f8bce88e531c1$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $585f8bce88e531c1$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $585f8bce88e531c1$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $585f8bce88e531c1$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $585f8bce88e531c1$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults) {
    let { loaderData: loaderData, errors: errors } = $585f8bce88e531c1$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        $585f8bce88e531c1$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if ($585f8bce88e531c1$var$isErrorResult(result)) {
            let boundaryMatch = $585f8bce88e531c1$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            state.fetchers.delete(key);
        } else if ($585f8bce88e531c1$var$isRedirectResult(result)) $585f8bce88e531c1$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $585f8bce88e531c1$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $585f8bce88e531c1$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $585f8bce88e531c1$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $585f8bce88e531c1$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $585f8bce88e531c1$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $585f8bce88e531c1$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $585f8bce88e531c1$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $585f8bce88e531c1$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $585f8bce88e531c1$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $585f8bce88e531c1$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($585f8bce88e531c1$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $585f8bce88e531c1$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $585f8bce88e531c1$export$8ccf933b0513f8d0(path) : path;
    return $585f8bce88e531c1$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $585f8bce88e531c1$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $585f8bce88e531c1$var$dataWithResponseInitToResponse(data2) {
    return Response.json(data2.data, data2.init ?? void 0);
}
function $585f8bce88e531c1$var$dataWithResponseInitToErrorResponse(data2) {
    return new $585f8bce88e531c1$export$f2680fa305b734ca(data2.init?.status ?? 500, data2.init?.statusText ?? "Internal Server Error", data2.data);
}
function $585f8bce88e531c1$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $585f8bce88e531c1$var$isDataStrategyResult(value));
}
function $585f8bce88e531c1$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $585f8bce88e531c1$var$isRedirectDataStrategyResult(result) {
    return $585f8bce88e531c1$export$3f1eb41d9a6a6a27(result.result) && $585f8bce88e531c1$var$redirectStatusCodes.has(result.result.status);
}
function $585f8bce88e531c1$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $585f8bce88e531c1$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $585f8bce88e531c1$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $585f8bce88e531c1$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $585f8bce88e531c1$export$794b2760043cf8cd(statusCode) {
    return $585f8bce88e531c1$var$redirectStatusCodes.has(statusCode);
}
function $585f8bce88e531c1$export$6e80290866a84dd4(result) {
    return $585f8bce88e531c1$export$3f1eb41d9a6a6a27(result) && $585f8bce88e531c1$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $585f8bce88e531c1$var$isValidMethod(method) {
    return $585f8bce88e531c1$var$validRequestMethods.has(method.toUpperCase());
}
function $585f8bce88e531c1$export$cbae47800eb95bc3(method) {
    return $585f8bce88e531c1$var$validMutationMethods.has(method.toUpperCase());
}
function $585f8bce88e531c1$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $585f8bce88e531c1$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $585f8bce88e531c1$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $585f8bce88e531c1$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $585f8bce88e531c1$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $585f8bce88e531c1$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $585f8bce88e531c1$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $585f8bce88e531c1$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $585f8bce88e531c1$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $585f8bce88e531c1$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $585f8bce88e531c1$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $585f8bce88e531c1$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($585f8bce88e531c1$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $585f8bce88e531c1$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($585f8bce88e531c1$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $585f8bce88e531c1$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $585f8bce88e531c1$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $585f8bce88e531c1$export$2eeee58951ff3c1c = $acw62.createContext(null);
$585f8bce88e531c1$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $585f8bce88e531c1$export$315e3ffb01f217 = $acw62.createContext(null);
$585f8bce88e531c1$export$315e3ffb01f217.displayName = "DataRouterState";
var $585f8bce88e531c1$export$717f757c655223f1 = $acw62.createContext(false);
function $585f8bce88e531c1$var$useIsRSCRouterContext() {
    return $acw62.useContext($585f8bce88e531c1$export$717f757c655223f1);
}
var $585f8bce88e531c1$export$3681f408decb40d1 = $acw62.createContext({
    isTransitioning: false
});
$585f8bce88e531c1$export$3681f408decb40d1.displayName = "ViewTransition";
var $585f8bce88e531c1$export$cb3f1df1bef00a39 = $acw62.createContext(/* @__PURE__ */ new Map());
$585f8bce88e531c1$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $585f8bce88e531c1$var$AwaitContext = $acw62.createContext(null);
$585f8bce88e531c1$var$AwaitContext.displayName = "Await";
var $585f8bce88e531c1$export$2666c20e15407622 = (props)=>$acw62.createElement($585f8bce88e531c1$var$AwaitContext.Provider, props);
var $585f8bce88e531c1$export$3044ab7fdabeaee6 = $acw62.createContext(null);
$585f8bce88e531c1$export$3044ab7fdabeaee6.displayName = "Navigation";
var $585f8bce88e531c1$export$e6a44b110a0c44d3 = $acw62.createContext(null);
$585f8bce88e531c1$export$e6a44b110a0c44d3.displayName = "Location";
var $585f8bce88e531c1$export$aac280ed165a4397 = $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$585f8bce88e531c1$export$aac280ed165a4397.displayName = "Route";
var $585f8bce88e531c1$var$RouteErrorContext = $acw62.createContext(null);
$585f8bce88e531c1$var$RouteErrorContext.displayName = "RouteError";
var $585f8bce88e531c1$export$945fecf35a8ef089 = true;
function $585f8bce88e531c1$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $585f8bce88e531c1$export$f5708dca728d7177($585f8bce88e531c1$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $acw62.useContext($585f8bce88e531c1$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $585f8bce88e531c1$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $585f8bce88e531c1$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $585f8bce88e531c1$export$9c954a9d03d32f4a() {
    return $acw62.useContext($585f8bce88e531c1$export$e6a44b110a0c44d3) != null;
}
function $585f8bce88e531c1$export$45d76561a5302f2b() {
    $585f8bce88e531c1$export$f5708dca728d7177($585f8bce88e531c1$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $acw62.useContext($585f8bce88e531c1$export$e6a44b110a0c44d3).location;
}
function $585f8bce88e531c1$export$1b3f31771c5d07c() {
    return $acw62.useContext($585f8bce88e531c1$export$e6a44b110a0c44d3).navigationType;
}
function $585f8bce88e531c1$export$6c330e8992e8a295(pattern) {
    $585f8bce88e531c1$export$f5708dca728d7177($585f8bce88e531c1$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $585f8bce88e531c1$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>$585f8bce88e531c1$export$81336c211d5ff295(pattern, $585f8bce88e531c1$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $585f8bce88e531c1$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $585f8bce88e531c1$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($585f8bce88e531c1$export$3044ab7fdabeaee6).static;
    if (!isStatic) $acw62.useLayoutEffect(cb);
}
function $585f8bce88e531c1$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($585f8bce88e531c1$export$aac280ed165a4397);
    return isDataRoute ? $585f8bce88e531c1$var$useNavigateStable() : $585f8bce88e531c1$var$useNavigateUnstable();
}
function $585f8bce88e531c1$var$useNavigateUnstable() {
    $585f8bce88e531c1$export$f5708dca728d7177($585f8bce88e531c1$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $acw62.useContext($585f8bce88e531c1$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $acw62.useContext($585f8bce88e531c1$export$3044ab7fdabeaee6);
    let { matches: matches } = $acw62.useContext($585f8bce88e531c1$export$aac280ed165a4397);
    let { pathname: locationPathname } = $585f8bce88e531c1$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($585f8bce88e531c1$var$getResolveToMatches(matches));
    let activeRef = $acw62.useRef(false);
    $585f8bce88e531c1$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback((to, options = {})=>{
        $585f8bce88e531c1$var$warning(activeRef.current, $585f8bce88e531c1$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $585f8bce88e531c1$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $585f8bce88e531c1$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $585f8bce88e531c1$var$OutletContext = $acw62.createContext(null);
function $585f8bce88e531c1$export$4138103a3ae699cc() {
    return $acw62.useContext($585f8bce88e531c1$var$OutletContext);
}
function $585f8bce88e531c1$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($585f8bce88e531c1$export$aac280ed165a4397).outlet;
    return $acw62.useMemo(()=>outlet && /* @__PURE__ */ $acw62.createElement($585f8bce88e531c1$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
function $585f8bce88e531c1$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($585f8bce88e531c1$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
function $585f8bce88e531c1$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $acw62.useContext($585f8bce88e531c1$export$aac280ed165a4397);
    let { pathname: locationPathname } = $585f8bce88e531c1$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($585f8bce88e531c1$var$getResolveToMatches(matches));
    return $acw62.useMemo(()=>$585f8bce88e531c1$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $585f8bce88e531c1$export$5d3fca4a98652595(routes, locationArg) {
    return $585f8bce88e531c1$var$useRoutesImpl(routes, locationArg);
}
function $585f8bce88e531c1$var$useRoutesImpl(routes, locationArg, dataRouterState, unstable_onError, future) {
    $585f8bce88e531c1$export$f5708dca728d7177($585f8bce88e531c1$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $acw62.useContext($585f8bce88e531c1$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $acw62.useContext($585f8bce88e531c1$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($585f8bce88e531c1$export$945fecf35a8ef089) {
        let parentPath = parentRoute && parentRoute.path || "";
        $585f8bce88e531c1$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $585f8bce88e531c1$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $585f8bce88e531c1$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $585f8bce88e531c1$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = $585f8bce88e531c1$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($585f8bce88e531c1$export$945fecf35a8ef089) {
        $585f8bce88e531c1$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $585f8bce88e531c1$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $585f8bce88e531c1$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $585f8bce88e531c1$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $585f8bce88e531c1$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, unstable_onError, future);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $acw62.createElement($585f8bce88e531c1$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $585f8bce88e531c1$var$DefaultErrorComponent() {
    let error = $585f8bce88e531c1$export$ed527bf60f6e05f2();
    let message = $585f8bce88e531c1$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($585f8bce88e531c1$export$945fecf35a8ef089) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $acw62.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $acw62.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $acw62.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $585f8bce88e531c1$var$defaultErrorElement = /* @__PURE__ */ $acw62.createElement($585f8bce88e531c1$var$DefaultErrorComponent, null);
var $585f8bce88e531c1$var$RenderErrorBoundary = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        return this.state.error !== void 0 ? /* @__PURE__ */ $acw62.createElement($585f8bce88e531c1$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $acw62.createElement($585f8bce88e531c1$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
};
function $585f8bce88e531c1$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $acw62.useContext($585f8bce88e531c1$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $acw62.createElement($585f8bce88e531c1$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $585f8bce88e531c1$var$_renderMatches(matches, parentMatches = [], dataRouterState = null, unstable_onError = null, future = null) {
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $585f8bce88e531c1$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors2 } = dataRouterState;
            let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
            if (match.route.lazy || needsToRunLoader) {
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    let onError = dataRouterState && unstable_onError ? (error, errorInfo)=>{
        unstable_onError(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            unstable_pattern: $585f8bce88e531c1$var$getRoutePattern(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $585f8bce88e531c1$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $585f8bce88e531c1$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $acw62.createElement($585f8bce88e531c1$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $acw62.createElement($585f8bce88e531c1$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $585f8bce88e531c1$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $585f8bce88e531c1$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($585f8bce88e531c1$export$2eeee58951ff3c1c);
    $585f8bce88e531c1$export$f5708dca728d7177(ctx, $585f8bce88e531c1$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $585f8bce88e531c1$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($585f8bce88e531c1$export$315e3ffb01f217);
    $585f8bce88e531c1$export$f5708dca728d7177(state, $585f8bce88e531c1$var$getDataRouterConsoleError(hookName));
    return state;
}
function $585f8bce88e531c1$var$useRouteContext(hookName) {
    let route = $acw62.useContext($585f8bce88e531c1$export$aac280ed165a4397);
    $585f8bce88e531c1$export$f5708dca728d7177(route, $585f8bce88e531c1$var$getDataRouterConsoleError(hookName));
    return route;
}
function $585f8bce88e531c1$var$useCurrentRouteId(hookName) {
    let route = $585f8bce88e531c1$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $585f8bce88e531c1$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $585f8bce88e531c1$var$useRouteId() {
    return $585f8bce88e531c1$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $585f8bce88e531c1$export$d0fd4b7106de2769() {
    let state = $585f8bce88e531c1$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return state.navigation;
}
function $585f8bce88e531c1$export$600dc272ed516c15() {
    let dataRouterContext = $585f8bce88e531c1$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $585f8bce88e531c1$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $acw62.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $acw62.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $585f8bce88e531c1$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $585f8bce88e531c1$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $acw62.useMemo(()=>matches.map((m)=>$585f8bce88e531c1$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $585f8bce88e531c1$export$1448a5050d252c4d() {
    let state = $585f8bce88e531c1$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $585f8bce88e531c1$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $585f8bce88e531c1$export$fd5d37484eab868d(routeId) {
    let state = $585f8bce88e531c1$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $585f8bce88e531c1$export$fdc00f3f26066d5e() {
    let state = $585f8bce88e531c1$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $585f8bce88e531c1$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $585f8bce88e531c1$export$ed527bf60f6e05f2() {
    let error = $acw62.useContext($585f8bce88e531c1$var$RouteErrorContext);
    let state = $585f8bce88e531c1$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $585f8bce88e531c1$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $585f8bce88e531c1$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($585f8bce88e531c1$var$AwaitContext);
    return value?._data;
}
function $585f8bce88e531c1$export$17f53340677d5831() {
    let value = $acw62.useContext($585f8bce88e531c1$var$AwaitContext);
    return value?._error;
}
var $585f8bce88e531c1$var$blockerId = 0;
function $585f8bce88e531c1$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $585f8bce88e531c1$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $585f8bce88e531c1$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $585f8bce88e531c1$export$b69e3301ce081aa3(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $585f8bce88e531c1$export$b69e3301ce081aa3(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $acw62.useEffect(()=>{
        let key = String(++$585f8bce88e531c1$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $585f8bce88e531c1$export$386d57f03f0b2883;
}
function $585f8bce88e531c1$var$useNavigateStable() {
    let { router: router } = $585f8bce88e531c1$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $585f8bce88e531c1$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $acw62.useRef(false);
    $585f8bce88e531c1$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(async (to, options = {})=>{
        $585f8bce88e531c1$var$warning(activeRef.current, $585f8bce88e531c1$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $585f8bce88e531c1$var$alreadyWarned = {};
function $585f8bce88e531c1$var$warningOnce(key, cond, message) {
    if (!cond && !$585f8bce88e531c1$var$alreadyWarned[key]) {
        $585f8bce88e531c1$var$alreadyWarned[key] = true;
        $585f8bce88e531c1$var$warning(false, message);
    }
}
function $585f8bce88e531c1$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $585f8bce88e531c1$var$useCurrentRouteId("useRoute" /* UseRoute */ );
    const id = args[0] ?? currentRouteId;
    const state = $585f8bce88e531c1$var$useDataRouterState("useRoute" /* UseRoute */ );
    const route = state.matches.find(({ route: route2 })=>route2.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: state.actionData?.[id]
    };
}
// lib/server-runtime/warnings.ts
var $585f8bce88e531c1$var$alreadyWarned2 = {};
function $585f8bce88e531c1$export$5b28268982f175ba(condition, message) {
    if (!condition && !$585f8bce88e531c1$var$alreadyWarned2[message]) {
        $585f8bce88e531c1$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $585f8bce88e531c1$var$USE_OPTIMISTIC = "useOptimistic";
var $585f8bce88e531c1$var$useOptimisticImpl = $acw62[$585f8bce88e531c1$var$USE_OPTIMISTIC];
var $585f8bce88e531c1$var$stableUseOptimisticSetter = ()=>void 0;
function $585f8bce88e531c1$var$useOptimisticSafe(val) {
    if ($585f8bce88e531c1$var$useOptimisticImpl) return $585f8bce88e531c1$var$useOptimisticImpl(val);
    else return [
        val,
        $585f8bce88e531c1$var$stableUseOptimisticSetter
    ];
}
function $585f8bce88e531c1$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($585f8bce88e531c1$export$945fecf35a8ef089) {
            if (route.element) $585f8bce88e531c1$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $acw62.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($585f8bce88e531c1$export$945fecf35a8ef089) {
            if (route.hydrateFallbackElement) $585f8bce88e531c1$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $acw62.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($585f8bce88e531c1$export$945fecf35a8ef089) {
            if (route.errorElement) $585f8bce88e531c1$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $acw62.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $585f8bce88e531c1$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $585f8bce88e531c1$export$f30f7e456d254e83(routes, opts) {
    return $585f8bce88e531c1$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $585f8bce88e531c1$var$createMemoryHistory({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        hydrationRouteProperties: $585f8bce88e531c1$export$e2fd2c03906469db,
        mapRouteProperties: $585f8bce88e531c1$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
var $585f8bce88e531c1$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $585f8bce88e531c1$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, unstable_onError: unstable_onError, unstable_useTransitions: unstable_useTransitions }) {
    let [_state, setStateImpl] = $acw62.useState(router.state);
    let [state, setOptimisticState] = $585f8bce88e531c1$var$useOptimisticSafe(_state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(/* @__PURE__ */ new Map());
    let setState = $acw62.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && unstable_onError) Object.values(newErrors).forEach((error)=>unstable_onError(error, {
                location: newState.location,
                params: newState.matches[0]?.params ?? {},
                unstable_pattern: $585f8bce88e531c1$var$getRoutePattern(newState.matches)
            }));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $585f8bce88e531c1$export$5b28268982f175ba(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $585f8bce88e531c1$export$5b28268982f175ba(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (unstable_useTransitions === false) setStateImpl(newState);
            else $acw62.startTransition(()=>{
                if (unstable_useTransitions === true) setOptimisticState((s)=>$585f8bce88e531c1$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd?.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd?.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        unstable_useTransitions,
        setOptimisticState,
        unstable_onError
    ]);
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $585f8bce88e531c1$var$Deferred());
    }, [
        vtContext
    ]);
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                if (unstable_useTransitions === false) setStateImpl(newState);
                else $acw62.startTransition(()=>{
                    if (unstable_useTransitions === true) setOptimisticState((s)=>$585f8bce88e531c1$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        unstable_useTransitions,
        setOptimisticState
    ]);
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            unstable_onError: unstable_onError
        }), [
        router,
        navigator,
        basename,
        unstable_onError
    ]);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement($585f8bce88e531c1$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $acw62.createElement($585f8bce88e531c1$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $acw62.createElement($585f8bce88e531c1$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $acw62.createElement($585f8bce88e531c1$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $acw62.createElement($585f8bce88e531c1$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        unstable_useTransitions: unstable_useTransitions === true
    }, /* @__PURE__ */ $acw62.createElement($585f8bce88e531c1$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state,
        unstable_onError: unstable_onError
    })))))), null);
}
function $585f8bce88e531c1$var$getOptimisticRouterState(currentState, newState) {
    return {
        // Don't surface "current location specific" stuff mid-navigation
        // (historyAction, location, matches, loaderData, errors, initialized,
        // restoreScroll, preventScrollReset, blockers, etc.)
        ...currentState,
        // Only surface "pending/in-flight stuff"
        // (navigation, revalidation, actionData, fetchers, )
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
var $585f8bce88e531c1$var$MemoizedDataRoutes = $acw62.memo($585f8bce88e531c1$var$DataRoutes);
function $585f8bce88e531c1$var$DataRoutes({ routes: routes, future: future, state: state, unstable_onError: unstable_onError }) {
    return $585f8bce88e531c1$var$useRoutesImpl(routes, void 0, state, unstable_onError, future);
}
function $585f8bce88e531c1$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, unstable_useTransitions: unstable_useTransitions }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $585f8bce88e531c1$var$createMemoryHistory({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($585f8bce88e531c1$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions === true
    });
}
function $585f8bce88e531c1$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $585f8bce88e531c1$export$f5708dca728d7177($585f8bce88e531c1$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = $acw62.useContext($585f8bce88e531c1$export$3044ab7fdabeaee6);
    $585f8bce88e531c1$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $acw62.useContext($585f8bce88e531c1$export$aac280ed165a4397);
    let { pathname: locationPathname } = $585f8bce88e531c1$export$45d76561a5302f2b();
    let navigate = $585f8bce88e531c1$export$9770f232ac06a008();
    let path = $585f8bce88e531c1$var$resolveTo(to, $585f8bce88e531c1$var$getResolveToMatches(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $585f8bce88e531c1$export$910ae8079b2c2852(props) {
    return $585f8bce88e531c1$export$a3be3530d8e40d0b(props.context);
}
function $585f8bce88e531c1$export$e7b0ac011bb776c6(props) {
    $585f8bce88e531c1$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $585f8bce88e531c1$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false, unstable_useTransitions: unstable_useTransitions }) {
    $585f8bce88e531c1$export$f5708dca728d7177(!$585f8bce88e531c1$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            unstable_useTransitions: unstable_useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        unstable_useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = $585f8bce88e531c1$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = $585f8bce88e531c1$export$b69e3301ce081aa3(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    $585f8bce88e531c1$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $acw62.createElement($585f8bce88e531c1$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $acw62.createElement($585f8bce88e531c1$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $585f8bce88e531c1$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $585f8bce88e531c1$export$5d3fca4a98652595($585f8bce88e531c1$export$16da398f5434bdec(children), location);
}
function $585f8bce88e531c1$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $acw62.useContext($585f8bce88e531c1$export$2eeee58951ff3c1c);
    let dataRouterStateContext = $acw62.useContext($585f8bce88e531c1$export$315e3ffb01f217);
    let onError = $acw62.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.unstable_onError && dataRouterStateContext) dataRouterContext.unstable_onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches[0]?.params || {},
            unstable_pattern: $585f8bce88e531c1$var$getRoutePattern(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $acw62.createElement($585f8bce88e531c1$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $acw62.createElement($585f8bce88e531c1$var$ResolveAwait, null, children));
}
var $585f8bce88e531c1$var$AwaitErrorBoundary = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $acw62.createElement($585f8bce88e531c1$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $acw62.createElement($585f8bce88e531c1$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $585f8bce88e531c1$var$ResolveAwait({ children: children }) {
    let data2 = $585f8bce88e531c1$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, toRender);
}
function $585f8bce88e531c1$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!$acw62.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            routes.push.apply(routes, $585f8bce88e531c1$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $585f8bce88e531c1$export$f5708dca728d7177(element.type === $585f8bce88e531c1$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $585f8bce88e531c1$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $585f8bce88e531c1$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $585f8bce88e531c1$export$9b5b6d122dea0c88 = $585f8bce88e531c1$export$16da398f5434bdec;
function $585f8bce88e531c1$export$daf73786167a7f72(matches) {
    return $585f8bce88e531c1$var$_renderMatches(matches);
}
function $585f8bce88e531c1$var$useRouteComponentProps() {
    return {
        params: $585f8bce88e531c1$export$99eaa27ddbbb95ef(),
        loaderData: $585f8bce88e531c1$export$1448a5050d252c4d(),
        actionData: $585f8bce88e531c1$export$fdc00f3f26066d5e(),
        matches: $585f8bce88e531c1$export$2378eb7f5ff86053()
    };
}
function $585f8bce88e531c1$export$6c4f3826290c37af({ children: children }) {
    const props = $585f8bce88e531c1$var$useRouteComponentProps();
    return $acw62.cloneElement(children, props);
}
function $585f8bce88e531c1$export$1a5de91a5c3255e0(Component4) {
    return function WithComponentProps2() {
        const props = $585f8bce88e531c1$var$useRouteComponentProps();
        return $acw62.createElement(Component4, props);
    };
}
function $585f8bce88e531c1$var$useHydrateFallbackProps() {
    return {
        params: $585f8bce88e531c1$export$99eaa27ddbbb95ef(),
        loaderData: $585f8bce88e531c1$export$1448a5050d252c4d(),
        actionData: $585f8bce88e531c1$export$fdc00f3f26066d5e()
    };
}
function $585f8bce88e531c1$export$f8cff34f39c1932a({ children: children }) {
    const props = $585f8bce88e531c1$var$useHydrateFallbackProps();
    return $acw62.cloneElement(children, props);
}
function $585f8bce88e531c1$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        const props = $585f8bce88e531c1$var$useHydrateFallbackProps();
        return $acw62.createElement(HydrateFallback, props);
    };
}
function $585f8bce88e531c1$var$useErrorBoundaryProps() {
    return {
        params: $585f8bce88e531c1$export$99eaa27ddbbb95ef(),
        loaderData: $585f8bce88e531c1$export$1448a5050d252c4d(),
        actionData: $585f8bce88e531c1$export$fdc00f3f26066d5e(),
        error: $585f8bce88e531c1$export$ed527bf60f6e05f2()
    };
}
function $585f8bce88e531c1$export$e5afde5c4b6d747b({ children: children }) {
    const props = $585f8bce88e531c1$var$useErrorBoundaryProps();
    return $acw62.cloneElement(children, props);
}
function $585f8bce88e531c1$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        const props = $585f8bce88e531c1$var$useErrorBoundaryProps();
        return $acw62.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var $585f8bce88e531c1$var$defaultMethod = "get";
var $585f8bce88e531c1$var$defaultEncType = "application/x-www-form-urlencoded";
function $585f8bce88e531c1$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $585f8bce88e531c1$var$isButtonElement(object) {
    return $585f8bce88e531c1$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $585f8bce88e531c1$var$isFormElement(object) {
    return $585f8bce88e531c1$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $585f8bce88e531c1$var$isInputElement(object) {
    return $585f8bce88e531c1$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $585f8bce88e531c1$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $585f8bce88e531c1$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$585f8bce88e531c1$var$isModifiedEvent(event);
}
function $585f8bce88e531c1$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $585f8bce88e531c1$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $585f8bce88e531c1$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $585f8bce88e531c1$var$_formDataSupportsSubmitter = null;
function $585f8bce88e531c1$var$isFormDataSubmitterSupported() {
    if ($585f8bce88e531c1$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $585f8bce88e531c1$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $585f8bce88e531c1$var$_formDataSupportsSubmitter = true;
    }
    return $585f8bce88e531c1$var$_formDataSupportsSubmitter;
}
var $585f8bce88e531c1$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $585f8bce88e531c1$var$getFormEncType(encType) {
    if (encType != null && !$585f8bce88e531c1$var$supportedFormEncTypes.has(encType)) {
        $585f8bce88e531c1$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$585f8bce88e531c1$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $585f8bce88e531c1$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($585f8bce88e531c1$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $585f8bce88e531c1$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("method") || $585f8bce88e531c1$var$defaultMethod;
        encType = $585f8bce88e531c1$var$getFormEncType(target.getAttribute("enctype")) || $585f8bce88e531c1$var$defaultEncType;
        formData = new FormData(target);
    } else if ($585f8bce88e531c1$var$isButtonElement(target) || $585f8bce88e531c1$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $585f8bce88e531c1$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $585f8bce88e531c1$var$defaultMethod;
        encType = $585f8bce88e531c1$var$getFormEncType(target.getAttribute("formenctype")) || $585f8bce88e531c1$var$getFormEncType(form.getAttribute("enctype")) || $585f8bce88e531c1$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$585f8bce88e531c1$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($585f8bce88e531c1$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $585f8bce88e531c1$var$defaultMethod;
        action = null;
        encType = $585f8bce88e531c1$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var $585f8bce88e531c1$var$HOLE = -1;
var $585f8bce88e531c1$var$NAN = -2;
var $585f8bce88e531c1$var$NEGATIVE_INFINITY = -3;
var $585f8bce88e531c1$var$NEGATIVE_ZERO = -4;
var $585f8bce88e531c1$var$NULL = -5;
var $585f8bce88e531c1$var$POSITIVE_INFINITY = -6;
var $585f8bce88e531c1$var$UNDEFINED = -7;
var $585f8bce88e531c1$var$TYPE_BIGINT = "B";
var $585f8bce88e531c1$var$TYPE_DATE = "D";
var $585f8bce88e531c1$var$TYPE_ERROR = "E";
var $585f8bce88e531c1$var$TYPE_MAP = "M";
var $585f8bce88e531c1$var$TYPE_NULL_OBJECT = "N";
var $585f8bce88e531c1$var$TYPE_PROMISE = "P";
var $585f8bce88e531c1$var$TYPE_REGEXP = "R";
var $585f8bce88e531c1$var$TYPE_SET = "S";
var $585f8bce88e531c1$var$TYPE_SYMBOL = "Y";
var $585f8bce88e531c1$var$TYPE_URL = "U";
var $585f8bce88e531c1$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $585f8bce88e531c1$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $585f8bce88e531c1$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
function $585f8bce88e531c1$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $585f8bce88e531c1$var$UNDEFINED;
    if (input === null) return $585f8bce88e531c1$var$NULL;
    if (Number.isNaN(input)) return $585f8bce88e531c1$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $585f8bce88e531c1$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $585f8bce88e531c1$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $585f8bce88e531c1$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    $585f8bce88e531c1$var$stringify.call(this, input, index);
    return index;
}
function $585f8bce88e531c1$var$stringify(input, index) {
    const { deferred: deferred, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    const stack = [
        [
            input,
            index
        ]
    ];
    while(stack.length > 0){
        const [input2, index2] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${$585f8bce88e531c1$var$flatten.call(this, k)}":${$585f8bce88e531c1$var$flatten.call(this, obj[k])}`).join(",");
        let error = null;
        switch(typeof input2){
            case "boolean":
            case "number":
            case "string":
                str[index2] = JSON.stringify(input2);
                break;
            case "bigint":
                str[index2] = `["${$585f8bce88e531c1$var$TYPE_BIGINT}","${input2}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input2);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index2] = `["${$585f8bce88e531c1$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input2) {
                        str[index2] = `${$585f8bce88e531c1$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>$585f8bce88e531c1$var$flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i = 0; i < input2.length; i++)result += (i ? "," : "") + (i in input2 ? $585f8bce88e531c1$var$flatten.call(this, input2[i]) : $585f8bce88e531c1$var$HOLE);
                            str[index2] = `${result}]`;
                        } else if (input2 instanceof Date) {
                            const dateTime = input2.getTime();
                            str[index2] = `["${$585f8bce88e531c1$var$TYPE_DATE}",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input2 instanceof URL) str[index2] = `["${$585f8bce88e531c1$var$TYPE_URL}",${JSON.stringify(input2.href)}]`;
                        else if (input2 instanceof RegExp) str[index2] = `["${$585f8bce88e531c1$var$TYPE_REGEXP}",${JSON.stringify(input2.source)},${JSON.stringify(input2.flags)}]`;
                        else if (input2 instanceof Set) {
                            if (input2.size > 0) str[index2] = `["${$585f8bce88e531c1$var$TYPE_SET}",${[
                                ...input2
                            ].map((val)=>$585f8bce88e531c1$var$flatten.call(this, val)).join(",")}]`;
                            else str[index2] = `["${$585f8bce88e531c1$var$TYPE_SET}"]`;
                        } else if (input2 instanceof Map) {
                            if (input2.size > 0) str[index2] = `["${$585f8bce88e531c1$var$TYPE_MAP}",${[
                                ...input2
                            ].flatMap(([k, v])=>[
                                    $585f8bce88e531c1$var$flatten.call(this, k),
                                    $585f8bce88e531c1$var$flatten.call(this, v)
                                ]).join(",")}]`;
                            else str[index2] = `["${$585f8bce88e531c1$var$TYPE_MAP}"]`;
                        } else if (input2 instanceof Promise) {
                            str[index2] = `["${$585f8bce88e531c1$var$TYPE_PROMISE}",${index2}]`;
                            deferred[index2] = input2;
                        } else if (input2 instanceof Error) {
                            str[index2] = `["${$585f8bce88e531c1$var$TYPE_ERROR}",${JSON.stringify(input2.message)}`;
                            if (input2.name !== "Error") str[index2] += `,${JSON.stringify(input2.name)}`;
                            str[index2] += "]";
                        } else if (Object.getPrototypeOf(input2) === null) str[index2] = `["${$585f8bce88e531c1$var$TYPE_NULL_OBJECT}",{${partsForObj(input2)}}]`;
                        else if ($585f8bce88e531c1$var$isPlainObject2(input2)) str[index2] = `{${partsForObj(input2)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>$585f8bce88e531c1$var$flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input2);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index2] += `,${rest.map((v)=>$585f8bce88e531c1$var$flatten.call(this, v)).join(",")}`;
                    str[index2] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $585f8bce88e531c1$var$objectProtoNames2 = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $585f8bce88e531c1$var$isPlainObject2(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $585f8bce88e531c1$var$objectProtoNames2;
}
// vendor/turbo-stream-v2/unflatten.ts
var $585f8bce88e531c1$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $585f8bce88e531c1$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $585f8bce88e531c1$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $585f8bce88e531c1$var$hydrate.call(this, startIndex);
}
function $585f8bce88e531c1$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $585f8bce88e531c1$var$UNDEFINED:
                set(void 0);
                continue;
            case $585f8bce88e531c1$var$NULL:
                set(null);
                continue;
            case $585f8bce88e531c1$var$NAN:
                set(NaN);
                continue;
            case $585f8bce88e531c1$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $585f8bce88e531c1$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $585f8bce88e531c1$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $585f8bce88e531c1$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $585f8bce88e531c1$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $585f8bce88e531c1$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $585f8bce88e531c1$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $585f8bce88e531c1$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $585f8bce88e531c1$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $585f8bce88e531c1$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $585f8bce88e531c1$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $585f8bce88e531c1$var$TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $585f8bce88e531c1$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $585f8bce88e531c1$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $585f8bce88e531c1$var$globalObj && $585f8bce88e531c1$var$globalObj[errorType] ? new $585f8bce88e531c1$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $585f8bce88e531c1$var$TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $585f8bce88e531c1$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $585f8bce88e531c1$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $585f8bce88e531c1$var$Deferred2();
    const reader = readable.pipeThrough($585f8bce88e531c1$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $585f8bce88e531c1$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $585f8bce88e531c1$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $585f8bce88e531c1$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $585f8bce88e531c1$var$unflatten.call(this, line)
    };
}
async function $585f8bce88e531c1$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $585f8bce88e531c1$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $585f8bce88e531c1$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $585f8bce88e531c1$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $585f8bce88e531c1$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $585f8bce88e531c1$export$c564cdbbe6da493(input, options) {
    const { plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = $585f8bce88e531c1$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            const id2 = $585f8bce88e531c1$var$flatten.call(encoder, resolved);
                            if (Array.isArray(id2)) {
                                controller.enqueue(textEncoder.encode(`${$585f8bce88e531c1$var$TYPE_PROMISE}${deferredId}:[["${$585f8bce88e531c1$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                encoder.index++;
                                lastSentIndex++;
                            } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$585f8bce88e531c1$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                            else {
                                const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                controller.enqueue(textEncoder.encode(`${$585f8bce88e531c1$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                lastSentIndex = encoder.stringified.length - 1;
                            }
                        }, (reason)=>{
                            if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                            const id2 = $585f8bce88e531c1$var$flatten.call(encoder, reason);
                            if (Array.isArray(id2)) {
                                controller.enqueue(textEncoder.encode(`${$585f8bce88e531c1$var$TYPE_ERROR}${deferredId}:[["${$585f8bce88e531c1$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                encoder.index++;
                                lastSentIndex++;
                            } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$585f8bce88e531c1$var$TYPE_ERROR}${deferredId}:${id2}
`));
                            else {
                                const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                controller.enqueue(textEncoder.encode(`${$585f8bce88e531c1$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                lastSentIndex = encoder.stringified.length - 1;
                            }
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            controller.close();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $585f8bce88e531c1$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/markup.ts
var $585f8bce88e531c1$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $585f8bce88e531c1$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $585f8bce88e531c1$export$4cf11838cdc2a8a8(html) {
    return html.replace($585f8bce88e531c1$var$ESCAPE_REGEX, (match)=>$585f8bce88e531c1$var$ESCAPE_LOOKUP[match]);
}
// lib/dom/ssr/invariant.ts
function $585f8bce88e531c1$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var $585f8bce88e531c1$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $585f8bce88e531c1$var$SingleFetchNoResultError = class extends Error {
};
var $585f8bce88e531c1$export$ae9272e641ead836 = 202;
var $585f8bce88e531c1$export$e35ccdcde387134d = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $585f8bce88e531c1$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$585f8bce88e531c1$export$4cf11838cdc2a8a8(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, scriptTag, /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, scriptTag, /* @__PURE__ */ $acw62.createElement($acw62.Suspense, null, /* @__PURE__ */ $acw62.createElement($585f8bce88e531c1$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $585f8bce88e531c1$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename) {
    let dataStrategy = $585f8bce88e531c1$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $585f8bce88e531c1$var$invariant2(manifestRoute, "Route not found in manifest");
        let routeModule = routeModules[match.route.id];
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader,
            hasShouldRevalidate: Boolean(routeModule?.shouldRevalidate)
        };
    }, $585f8bce88e531c1$var$fetchAndDecodeViaTurboStream, ssr, basename);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $585f8bce88e531c1$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $585f8bce88e531c1$var$singleFetchActionStrategy(args, fetchAndDecode, basename);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $585f8bce88e531c1$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename);
        if (fetcherKey) return $585f8bce88e531c1$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename);
        return $585f8bce88e531c1$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, shouldAllowOptOut);
    };
}
async function $585f8bce88e531c1$var$singleFetchActionStrategy(args, fetchAndDecode, basename) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    $585f8bce88e531c1$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $585f8bce88e531c1$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($585f8bce88e531c1$export$3f1eb41d9a6a6a27(result.result) || $585f8bce88e531c1$export$972111febbeef05b(result.result) || $585f8bce88e531c1$export$e0163cfdf7bc9cfa(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $585f8bce88e531c1$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $585f8bce88e531c1$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, [
                        routeId
                    ]);
                    return $585f8bce88e531c1$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $585f8bce88e531c1$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$585f8bce88e531c1$var$createDeferred2());
    let singleFetchDfd = $585f8bce88e531c1$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader, hasShouldRevalidate: hasShouldRevalidate } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader && // for a route with a server loader,
                hasShouldRevalidate === true);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, [
                            routeId
                        ]);
                        return $585f8bce88e531c1$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $585f8bce88e531c1$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $585f8bce88e531c1$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $585f8bce88e531c1$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $585f8bce88e531c1$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $585f8bce88e531c1$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    $585f8bce88e531c1$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, [
                routeId
            ]);
            return $585f8bce88e531c1$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $585f8bce88e531c1$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $585f8bce88e531c1$export$7b977381851b2c(reqUrl, basename, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (url.pathname === "/") url.pathname = `_root.${extension}`;
    else if (basename && $585f8bce88e531c1$export$b69e3301ce081aa3(url.pathname, basename) === "/") url.pathname = `${basename.replace(/\/$/, "")}/_root.${extension}`;
    else url.pathname = `${url.pathname.replace(/\/$/, "")}.${extension}`;
    return url;
}
async function $585f8bce88e531c1$var$fetchAndDecodeViaTurboStream(args, basename, targetRoutes) {
    let { request: request } = args;
    let url = $585f8bce88e531c1$export$7b977381851b2c(request.url, basename, "data");
    if (request.method === "GET") {
        url = $585f8bce88e531c1$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $585f8bce88e531c1$export$a30aa2a0fce6c468(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new $585f8bce88e531c1$export$f2680fa305b734ca(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $585f8bce88e531c1$export$ae9272e641ead836,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($585f8bce88e531c1$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $585f8bce88e531c1$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $585f8bce88e531c1$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($585f8bce88e531c1$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$585f8bce88e531c1$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            $585f8bce88e531c1$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $585f8bce88e531c1$export$4023ad4ecd4126a2(body, global) {
    return $585f8bce88e531c1$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && name in global && typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $585f8bce88e531c1$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$585f8bce88e531c1$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $585f8bce88e531c1$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $585f8bce88e531c1$export$89e12c5b50f7529d(location, {
            status: status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $585f8bce88e531c1$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $585f8bce88e531c1$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
// lib/dom/ssr/routeModules.ts
async function $585f8bce88e531c1$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $585f8bce88e531c1$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $585f8bce88e531c1$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $585f8bce88e531c1$var$getModuleLinkHrefs(matches, manifest);
    return $585f8bce88e531c1$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $585f8bce88e531c1$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $585f8bce88e531c1$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $585f8bce88e531c1$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($585f8bce88e531c1$var$prefetchStyleLink));
}
async function $585f8bce88e531c1$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$585f8bce88e531c1$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$585f8bce88e531c1$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$585f8bce88e531c1$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($585f8bce88e531c1$var$prefetchStyleLink));
}
async function $585f8bce88e531c1$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $585f8bce88e531c1$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $585f8bce88e531c1$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $585f8bce88e531c1$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $585f8bce88e531c1$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $585f8bce88e531c1$var$dedupeLinkDescriptors(links.flat(1).filter($585f8bce88e531c1$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $585f8bce88e531c1$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $585f8bce88e531c1$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $585f8bce88e531c1$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $585f8bce88e531c1$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $585f8bce88e531c1$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $585f8bce88e531c1$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$585f8bce88e531c1$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($585f8bce88e531c1$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $585f8bce88e531c1$var$_isPreloadSupported;
function $585f8bce88e531c1$var$isPreloadSupported() {
    if ($585f8bce88e531c1$var$_isPreloadSupported !== void 0) return $585f8bce88e531c1$var$_isPreloadSupported;
    let el = document.createElement("link");
    $585f8bce88e531c1$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $585f8bce88e531c1$var$_isPreloadSupported;
}
function $585f8bce88e531c1$var$RemixRootDefaultHydrateFallback() {
    return /* @__PURE__ */ $acw62.createElement($585f8bce88e531c1$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $585f8bce88e531c1$export$945fecf35a8ef089 ? /* @__PURE__ */ $acw62.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $585f8bce88e531c1$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $585f8bce88e531c1$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $585f8bce88e531c1$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $585f8bce88e531c1$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $acw62.createElement($585f8bce88e531c1$var$RemixRootDefaultErrorBoundary, {
            error: $585f8bce88e531c1$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $585f8bce88e531c1$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $585f8bce88e531c1$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $585f8bce88e531c1$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$585f8bce88e531c1$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $585f8bce88e531c1$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $585f8bce88e531c1$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $585f8bce88e531c1$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $585f8bce88e531c1$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $585f8bce88e531c1$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $585f8bce88e531c1$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $585f8bce88e531c1$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $585f8bce88e531c1$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $585f8bce88e531c1$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $585f8bce88e531c1$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $585f8bce88e531c1$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $585f8bce88e531c1$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $585f8bce88e531c1$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$585f8bce88e531c1$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $585f8bce88e531c1$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, unstable_pattern: unstable_pattern }, singleFetch)=>{
                try {
                    let result = await prefetchStylesAndCallHandler(async ()=>{
                        $585f8bce88e531c1$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                        if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                        return routeModule.clientLoader({
                            request: request,
                            params: params,
                            context: context,
                            unstable_pattern: unstable_pattern,
                            async serverLoader () {
                                $585f8bce88e531c1$var$preventInvalidServerHandlerCall("loader", route);
                                if (isHydrationRequest) {
                                    if (hasInitialData) return initialData;
                                    if (hasInitialError) throw initialError;
                                }
                                return fetchServerLoader(singleFetch);
                            }
                        });
                    });
                    return result;
                } finally{
                    isHydrationRequest = false;
                }
            };
            dataRoute.loader.hydrate = $585f8bce88e531c1$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, unstable_pattern: unstable_pattern }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $585f8bce88e531c1$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $585f8bce88e531c1$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        unstable_pattern: unstable_pattern,
                        async serverAction () {
                            $585f8bce88e531c1$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $585f8bce88e531c1$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $585f8bce88e531c1$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $585f8bce88e531c1$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $585f8bce88e531c1$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $585f8bce88e531c1$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $585f8bce88e531c1$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $585f8bce88e531c1$var$invariant2(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $585f8bce88e531c1$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $585f8bce88e531c1$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $585f8bce88e531c1$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $585f8bce88e531c1$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $585f8bce88e531c1$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $585f8bce88e531c1$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $585f8bce88e531c1$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $585f8bce88e531c1$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $585f8bce88e531c1$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $585f8bce88e531c1$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $585f8bce88e531c1$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $585f8bce88e531c1$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $585f8bce88e531c1$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $585f8bce88e531c1$var$nextPaths = /* @__PURE__ */ new Set();
var $585f8bce88e531c1$var$discoveredPathsMaxSize = 1e3;
var $585f8bce88e531c1$var$discoveredPaths = /* @__PURE__ */ new Set();
var $585f8bce88e531c1$var$URL_LIMIT = 7680;
function $585f8bce88e531c1$var$isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $585f8bce88e531c1$var$getPartialManifest({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $585f8bce88e531c1$export$2708184779ceb39d(router.routes, path, router.basename);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $585f8bce88e531c1$export$72ab377a1030deb9(manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$585f8bce88e531c1$var$isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($585f8bce88e531c1$var$discoveredPaths.has(path)) return;
        await $585f8bce88e531c1$var$fetchAndApplyManifestPatches([
            path
        ], fetcherKey ? window.location.href : path, manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $585f8bce88e531c1$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $acw62.useEffect(()=>{
        if (!$585f8bce88e531c1$var$isFogOfWarEnabled(routeDiscovery, ssr) || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$585f8bce88e531c1$var$discoveredPaths.has(pathname)) $585f8bce88e531c1$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($585f8bce88e531c1$var$nextPaths.keys()).filter((path)=>{
                if ($585f8bce88e531c1$var$discoveredPaths.has(path)) {
                    $585f8bce88e531c1$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $585f8bce88e531c1$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $585f8bce88e531c1$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $585f8bce88e531c1$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    if (basename == null) return manifestPath;
    return `${basename}${manifestPath}`.replace(/\/+/g, "/");
}
var $585f8bce88e531c1$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $585f8bce88e531c1$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($585f8bce88e531c1$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > $585f8bce88e531c1$var$URL_LIMIT) {
        $585f8bce88e531c1$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            try {
                if (sessionStorage.getItem($585f8bce88e531c1$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                    console.error("Unable to discover routes due to manifest version mismatch.");
                    return;
                }
                sessionStorage.setItem($585f8bce88e531c1$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            } catch  {}
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        try {
            sessionStorage.removeItem($585f8bce88e531c1$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$585f8bce88e531c1$var$addToFifoQueue(p, $585f8bce88e531c1$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $585f8bce88e531c1$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $585f8bce88e531c1$var$addToFifoQueue(path, queue) {
    if (queue.size >= $585f8bce88e531c1$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $585f8bce88e531c1$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $585f8bce88e531c1$var$useDataRouterContext2() {
    let context = $acw62.useContext($585f8bce88e531c1$export$2eeee58951ff3c1c);
    $585f8bce88e531c1$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $585f8bce88e531c1$var$useDataRouterStateContext() {
    let context = $acw62.useContext($585f8bce88e531c1$export$315e3ffb01f217);
    $585f8bce88e531c1$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $585f8bce88e531c1$export$208d6a3bc3aa62bd = $acw62.createContext(void 0);
$585f8bce88e531c1$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $585f8bce88e531c1$var$useFrameworkContext() {
    let context = $acw62.useContext($585f8bce88e531c1$export$208d6a3bc3aa62bd);
    $585f8bce88e531c1$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $585f8bce88e531c1$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $acw62.useContext($585f8bce88e531c1$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $acw62.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $acw62.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $acw62.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $585f8bce88e531c1$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $585f8bce88e531c1$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $585f8bce88e531c1$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $585f8bce88e531c1$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $585f8bce88e531c1$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $585f8bce88e531c1$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $585f8bce88e531c1$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$585f8bce88e531c1$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $585f8bce88e531c1$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
function $585f8bce88e531c1$export$b2e089eb3692b073({ nonce: nonce }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss } = $585f8bce88e531c1$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $585f8bce88e531c1$var$useDataRouterStateContext();
    let matches = $585f8bce88e531c1$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $acw62.useMemo(()=>$585f8bce88e531c1$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $acw62.createElement("style", {
        [$585f8bce88e531c1$export$7e4ed4715c00dab0]: "",
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $acw62.createElement("link", {
        [$585f8bce88e531c1$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce
    }) : null, keyedLinks.map(({ key: key, link: link })=>$585f8bce88e531c1$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $acw62.createElement($585f8bce88e531c1$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link
        }) : /* @__PURE__ */ $acw62.createElement("link", {
            key: key,
            nonce: nonce,
            ...link
        })));
}
function $585f8bce88e531c1$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let { router: router } = $585f8bce88e531c1$var$useDataRouterContext2();
    let matches = $acw62.useMemo(()=>$585f8bce88e531c1$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    return /* @__PURE__ */ $acw62.createElement($585f8bce88e531c1$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $585f8bce88e531c1$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $585f8bce88e531c1$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $acw62.useState([]);
    $acw62.useEffect(()=>{
        let interrupted = false;
        $585f8bce88e531c1$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $585f8bce88e531c1$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $585f8bce88e531c1$export$45d76561a5302f2b();
    let { manifest: manifest, routeModules: routeModules } = $585f8bce88e531c1$var$useFrameworkContext();
    let { basename: basename } = $585f8bce88e531c1$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $585f8bce88e531c1$var$useDataRouterStateContext();
    let newMatchesForData = $acw62.useMemo(()=>$585f8bce88e531c1$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $acw62.useMemo(()=>$585f8bce88e531c1$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $acw62.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $585f8bce88e531c1$export$7b977381851b2c(page, basename, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $acw62.useMemo(()=>$585f8bce88e531c1$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $585f8bce88e531c1$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $acw62.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link
        })));
}
function $585f8bce88e531c1$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $585f8bce88e531c1$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $585f8bce88e531c1$var$useDataRouterStateContext();
    let location = $585f8bce88e531c1$export$45d76561a5302f2b();
    let _matches = $585f8bce88e531c1$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://remix.run/route/meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$585f8bce88e531c1$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $acw62.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $acw62.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $acw62.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $acw62.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: $585f8bce88e531c1$export$4cf11838cdc2a8a8(json)
                }
            });
        } catch (err) {
            return null;
        }
        return /* @__PURE__ */ $acw62.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $585f8bce88e531c1$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $585f8bce88e531c1$var$isHydrated = false;
function $585f8bce88e531c1$export$3be068dde909e563() {
    $585f8bce88e531c1$var$isHydrated = true;
}
function $585f8bce88e531c1$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr } = $585f8bce88e531c1$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $585f8bce88e531c1$var$useDataRouterContext2();
    let { matches: routerMatches } = $585f8bce88e531c1$var$useDataRouterStateContext();
    let isRSCRouterContext = $585f8bce88e531c1$var$useIsRSCRouterContext();
    let enableFogOfWar = $585f8bce88e531c1$var$isFogOfWarEnabled(routeDiscovery, ssr);
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $585f8bce88e531c1$var$getActiveMatches(routerMatches, null, isSpaMode);
    $acw62.useEffect(()=>{
        $585f8bce88e531c1$export$3be068dde909e563();
    }, []);
    let initialScripts = $acw62.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $585f8bce88e531c1$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($585f8bce88e531c1$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $acw62.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $585f8bce88e531c1$var$isHydrated || isRSCRouterContext ? [] : $585f8bce88e531c1$var$dedupe(manifest.entry.imports.concat($585f8bce88e531c1$var$getModuleLinkHrefs(matches, manifest, {
        includeHydrateFallback: true
    })));
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    $585f8bce88e531c1$export$5b28268982f175ba(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $585f8bce88e531c1$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $acw62.createElement("script", {
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $acw62.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $acw62.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            suppressHydrationWarning: true
        })), initialScripts);
}
function $585f8bce88e531c1$var$dedupe(array) {
    return [
        ...new Set(array)
    ];
}
function $585f8bce88e531c1$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var $585f8bce88e531c1$export$32e57f52df4b6e34 = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $acw62.createElement($585f8bce88e531c1$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $585f8bce88e531c1$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $acw62.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($585f8bce88e531c1$export$972111febbeef05b(error)) return /* @__PURE__ */ $acw62.createElement($585f8bce88e531c1$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $acw62.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $585f8bce88e531c1$export$945fecf35a8ef089 ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $acw62.createElement($585f8bce88e531c1$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $acw62.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $acw62.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $585f8bce88e531c1$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $585f8bce88e531c1$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $acw62.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $acw62.createElement("head", null, /* @__PURE__ */ $acw62.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $acw62.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $acw62.createElement("title", null, title)), /* @__PURE__ */ $acw62.createElement("body", null, /* @__PURE__ */ $acw62.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $acw62.createElement($585f8bce88e531c1$export$ff0bf87698939488, null) : null)));
}
var $585f8bce88e531c1$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($585f8bce88e531c1$var$isBrowser) window.__reactRouterVersion = "7.10.1";
} catch (e) {}
function $585f8bce88e531c1$export$1f3f55432a00e06d(routes, opts) {
    return $585f8bce88e531c1$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $585f8bce88e531c1$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $585f8bce88e531c1$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $585f8bce88e531c1$export$9269a41d8c4635e,
        hydrationRouteProperties: $585f8bce88e531c1$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
function $585f8bce88e531c1$export$1ba7ed8a3a7b3765(routes, opts) {
    return $585f8bce88e531c1$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $585f8bce88e531c1$var$createHashHistory({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $585f8bce88e531c1$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $585f8bce88e531c1$export$9269a41d8c4635e,
        hydrationRouteProperties: $585f8bce88e531c1$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
function $585f8bce88e531c1$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $585f8bce88e531c1$var$deserializeErrors(state.errors)
    };
    return state;
}
function $585f8bce88e531c1$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $585f8bce88e531c1$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $585f8bce88e531c1$export$9ba4e89fdfa1fc54({ basename: basename, children: children, unstable_useTransitions: unstable_useTransitions, window: window2 }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $585f8bce88e531c1$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($585f8bce88e531c1$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions === true
    });
}
function $585f8bce88e531c1$export$7221d69dcfc8e36b({ basename: basename, children: children, unstable_useTransitions: unstable_useTransitions, window: window2 }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $585f8bce88e531c1$var$createHashHistory({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($585f8bce88e531c1$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions === true
    });
}
function $585f8bce88e531c1$export$de73885c9336221c({ basename: basename, children: children, history: history, unstable_useTransitions: unstable_useTransitions }) {
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($585f8bce88e531c1$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions === true
    });
}
$585f8bce88e531c1$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $585f8bce88e531c1$var$ABSOLUTE_URL_REGEX2 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $585f8bce88e531c1$export$a6c7ac8248d6e38a = $acw62.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, ...rest }, forwardedRef) {
    let { basename: basename, unstable_useTransitions: unstable_useTransitions } = $acw62.useContext($585f8bce88e531c1$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $585f8bce88e531c1$var$ABSOLUTE_URL_REGEX2.test(to);
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && isAbsolute) {
        absoluteHref = to;
        if ($585f8bce88e531c1$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = $585f8bce88e531c1$export$b69e3301ce081aa3(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {
            $585f8bce88e531c1$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
        }
    }
    let href = $585f8bce88e531c1$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $585f8bce88e531c1$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $585f8bce88e531c1$export$67621102c14d847(to, {
        replace: replace2,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        unstable_useTransitions: unstable_useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $acw62.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: $585f8bce88e531c1$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, link, /* @__PURE__ */ $acw62.createElement($585f8bce88e531c1$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$585f8bce88e531c1$export$a6c7ac8248d6e38a.displayName = "Link";
var $585f8bce88e531c1$export$b0d92dbee9b5b60d = $acw62.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $585f8bce88e531c1$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $585f8bce88e531c1$export$45d76561a5302f2b();
    let routerState = $acw62.useContext($585f8bce88e531c1$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $acw62.useContext($585f8bce88e531c1$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $585f8bce88e531c1$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $585f8bce88e531c1$export$b69e3301ce081aa3(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $acw62.createElement($585f8bce88e531c1$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$585f8bce88e531c1$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $585f8bce88e531c1$export$a7fed597f4b8afd8 = $acw62.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $585f8bce88e531c1$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, ...props }, forwardedRef)=>{
    let { unstable_useTransitions: unstable_useTransitions } = $acw62.useContext($585f8bce88e531c1$export$3044ab7fdabeaee6);
    let submit = $585f8bce88e531c1$export$47c85c6e3a081d3();
    let formAction = $585f8bce88e531c1$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $585f8bce88e531c1$var$ABSOLUTE_URL_REGEX2.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace2,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition
            });
        if (unstable_useTransitions && navigate !== false) $acw62.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $acw62.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$585f8bce88e531c1$export$a7fed597f4b8afd8.displayName = "Form";
function $585f8bce88e531c1$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $acw62.useContext($585f8bce88e531c1$export$208d6a3bc3aa62bd);
    let { basename: basename } = $acw62.useContext($585f8bce88e531c1$export$3044ab7fdabeaee6);
    let location = $585f8bce88e531c1$export$45d76561a5302f2b();
    let matches = $585f8bce88e531c1$export$2378eb7f5ff86053();
    $585f8bce88e531c1$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $acw62.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $585f8bce88e531c1$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    return /* @__PURE__ */ $acw62.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${JSON.stringify(storageKey || $585f8bce88e531c1$var$SCROLL_RESTORATION_STORAGE_KEY)}, ${JSON.stringify(ssrKey)})`
        }
    });
}
$585f8bce88e531c1$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $585f8bce88e531c1$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $585f8bce88e531c1$var$useDataRouterContext3(hookName) {
    let ctx = $acw62.useContext($585f8bce88e531c1$export$2eeee58951ff3c1c);
    $585f8bce88e531c1$export$f5708dca728d7177(ctx, $585f8bce88e531c1$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $585f8bce88e531c1$var$useDataRouterState2(hookName) {
    let state = $acw62.useContext($585f8bce88e531c1$export$315e3ffb01f217);
    $585f8bce88e531c1$export$f5708dca728d7177(state, $585f8bce88e531c1$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $585f8bce88e531c1$export$67621102c14d847(to, { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, unstable_useTransitions: unstable_useTransitions } = {}) {
    let navigate = $585f8bce88e531c1$export$9770f232ac06a008();
    let location = $585f8bce88e531c1$export$45d76561a5302f2b();
    let path = $585f8bce88e531c1$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($585f8bce88e531c1$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $585f8bce88e531c1$export$fe53371bee54353d(location) === $585f8bce88e531c1$export$fe53371bee54353d(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace2,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition
                });
            if (unstable_useTransitions) $acw62.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        unstable_useTransitions
    ]);
}
function $585f8bce88e531c1$export$f1a78c17382fe22a(defaultInit) {
    $585f8bce88e531c1$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $acw62.useRef($585f8bce88e531c1$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = $585f8bce88e531c1$export$45d76561a5302f2b();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $585f8bce88e531c1$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $585f8bce88e531c1$export$9770f232ac06a008();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $585f8bce88e531c1$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $585f8bce88e531c1$var$fetcherId = 0;
var $585f8bce88e531c1$var$getUniqueFetcherId = ()=>`__${String(++$585f8bce88e531c1$var$fetcherId)}__`;
function $585f8bce88e531c1$export$47c85c6e3a081d3() {
    let { router: router } = $585f8bce88e531c1$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $acw62.useContext($585f8bce88e531c1$export$3044ab7fdabeaee6);
    let currentRouteId = $585f8bce88e531c1$var$useRouteId();
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $acw62.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $585f8bce88e531c1$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $585f8bce88e531c1$var$getUniqueFetcherId();
            await routerFetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await routerNavigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
function $585f8bce88e531c1$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $acw62.useContext($585f8bce88e531c1$export$3044ab7fdabeaee6);
    let routeContext = $acw62.useContext($585f8bce88e531c1$export$aac280ed165a4397);
    $585f8bce88e531c1$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$585f8bce88e531c1$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $585f8bce88e531c1$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $585f8bce88e531c1$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $585f8bce88e531c1$export$fe53371bee54353d(path);
}
function $585f8bce88e531c1$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $585f8bce88e531c1$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $585f8bce88e531c1$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $acw62.useContext($585f8bce88e531c1$export$cb3f1df1bef00a39);
    let route = $acw62.useContext($585f8bce88e531c1$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $585f8bce88e531c1$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $585f8bce88e531c1$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $585f8bce88e531c1$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $acw62.useId();
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $acw62.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $acw62.useCallback(async (href, opts)=>{
        $585f8bce88e531c1$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $585f8bce88e531c1$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $acw62.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm2 = $acw62.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $acw62.createElement($585f8bce88e531c1$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $585f8bce88e531c1$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $585f8bce88e531c1$export$fa996778a3a31087() {
    let state = $585f8bce88e531c1$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
            ...fetcher,
            key: key
        }));
}
var $585f8bce88e531c1$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $585f8bce88e531c1$var$savedScrollPositions = {};
function $585f8bce88e531c1$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $585f8bce88e531c1$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $585f8bce88e531c1$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $585f8bce88e531c1$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $585f8bce88e531c1$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $acw62.useContext($585f8bce88e531c1$export$3044ab7fdabeaee6);
    let location = $585f8bce88e531c1$export$45d76561a5302f2b();
    let matches = $585f8bce88e531c1$export$2378eb7f5ff86053();
    let navigation = $585f8bce88e531c1$export$d0fd4b7106de2769();
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $585f8bce88e531c1$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $585f8bce88e531c1$var$getScrollRestorationKey(location, matches, basename, getKey);
            $585f8bce88e531c1$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $585f8bce88e531c1$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($585f8bce88e531c1$var$savedScrollPositions));
        } catch (error) {
            $585f8bce88e531c1$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $585f8bce88e531c1$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $585f8bce88e531c1$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $acw62.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($585f8bce88e531c1$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$585f8bce88e531c1$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $acw62.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                $585f8bce88e531c1$var$warning(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $585f8bce88e531c1$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $585f8bce88e531c1$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $585f8bce88e531c1$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $585f8bce88e531c1$export$b273b3273281a049(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $585f8bce88e531c1$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $acw62.useContext($585f8bce88e531c1$export$3681f408decb40d1);
    $585f8bce88e531c1$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $585f8bce88e531c1$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $585f8bce88e531c1$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $585f8bce88e531c1$export$b69e3301ce081aa3(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $585f8bce88e531c1$export$b69e3301ce081aa3(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $585f8bce88e531c1$export$81336c211d5ff295(path.pathname, nextPath) != null || $585f8bce88e531c1$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $585f8bce88e531c1$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $585f8bce88e531c1$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default"
    };
    let staticNavigator = $585f8bce88e531c1$var$getStatelessNavigator();
    return /* @__PURE__ */ $acw62.createElement($585f8bce88e531c1$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true,
        unstable_useTransitions: false
    });
}
function $585f8bce88e531c1$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $585f8bce88e531c1$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $585f8bce88e531c1$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $585f8bce88e531c1$var$serializeErrors(context.errors)
        };
        let json = $585f8bce88e531c1$var$htmlEscape(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement($585f8bce88e531c1$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $acw62.createElement($585f8bce88e531c1$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $acw62.createElement($585f8bce88e531c1$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $acw62.createElement($585f8bce88e531c1$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $acw62.createElement($585f8bce88e531c1$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static,
        unstable_useTransitions: false
    }, /* @__PURE__ */ $acw62.createElement($585f8bce88e531c1$var$DataRoutes2, {
        routes: router.routes,
        future: router.future,
        state: state
    })))))), hydrateScript ? /* @__PURE__ */ $acw62.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $585f8bce88e531c1$var$DataRoutes2({ routes: routes, future: future, state: state }) {
    return $585f8bce88e531c1$var$useRoutesImpl(routes, void 0, state, void 0, future);
}
function $585f8bce88e531c1$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($585f8bce88e531c1$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $585f8bce88e531c1$var$getStatelessNavigator() {
    return {
        createHref: $585f8bce88e531c1$var$createHref,
        encodeLocation: $585f8bce88e531c1$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $585f8bce88e531c1$export$69163f0b72ec60d9(routes, opts) {
    return $585f8bce88e531c1$export$3336b097a6fbc59a(routes, {
        ...opts,
        mapRouteProperties: $585f8bce88e531c1$export$9269a41d8c4635e
    });
}
function $585f8bce88e531c1$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $585f8bce88e531c1$export$87cb1a9238dc3fba(routes, $585f8bce88e531c1$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                v8_middleware: false,
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                navigation: $585f8bce88e531c1$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $585f8bce88e531c1$var$createHref,
        encodeLocation: $585f8bce88e531c1$var$encodeLocation,
        getFetcher () {
            return $585f8bce88e531c1$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        resetFetcher () {
            throw msg("resetFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $585f8bce88e531c1$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp () {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function $585f8bce88e531c1$var$createHref(to) {
    return typeof to === "string" ? to : $585f8bce88e531c1$export$fe53371bee54353d(to);
}
function $585f8bce88e531c1$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $585f8bce88e531c1$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $585f8bce88e531c1$var$ABSOLUTE_URL_REGEX3.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}
var $585f8bce88e531c1$var$ABSOLUTE_URL_REGEX3 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $585f8bce88e531c1$var$ESCAPE_LOOKUP2 = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $585f8bce88e531c1$var$ESCAPE_REGEX2 = /[&><\u2028\u2029]/g;
function $585f8bce88e531c1$var$htmlEscape(str) {
    return str.replace($585f8bce88e531c1$var$ESCAPE_REGEX2, (match)=>$585f8bce88e531c1$var$ESCAPE_LOOKUP2[match]);
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $a55f2a94cd420149$var$LayoutContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
const $a55f2a94cd420149$export$94811c40c55f3d65 = ({ children: children })=>{
    const searchParams = new URLSearchParams(window.location.search);
    const currentPage = parseInt(searchParams.get("page") || "1", 10) || 1;
    const [layoutListItem, setLayoutListItemState] = (0, $acw62.useState)(localStorage.getItem("layoutList") || "grid");
    const [tasks, setTasks] = (0, $acw62.useState)([]);
    const [error, setError] = (0, $acw62.useState)(null);
    const [success, setSuccess] = (0, $acw62.useState)(null);
    const [userSettings, setUserSettings] = (0, $acw62.useState)(null);
    const [systemError, setSystemError] = (0, $acw62.useState)(null);
    const [loading, setInternalLoading] = (0, $acw62.useState)(null);
    const [modalScreen, setModalScreen] = (0, $acw62.useState)(null);
    const [page, setPage] = (0, $acw62.useState)(currentPage);
    const isDevMode = localStorage.getItem("isDevMode") === "true";
    const modalRef = (0, $acw62.useRef)(null);
    const setLayoutListItem = (layout)=>{
        setLayoutListItemState(layout);
        localStorage.setItem("layoutList", layout);
    };
    const setLoading = (loading)=>{
        if (typeof loading === "boolean") setInternalLoading(loading ? {
            showSpinner: true,
            style: "fixed"
        } : null);
        else setInternalLoading(loading);
    };
    const addTask = (workingTask)=>{
        setTasks((prevTasks)=>[
                ...prevTasks,
                workingTask
            ]);
        if (workingTask.onAdd) workingTask.onAdd();
    };
    const removeTask = (taskId)=>{
        const task = tasks.find((t)=>t.id === taskId);
        setTasks((prevTasks)=>prevTasks.filter((task)=>task.id !== taskId));
        if (task && task.onRemove) task.onRemove();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a55f2a94cd420149$var$LayoutContext.Provider, {
        value: {
            layoutListItem: layoutListItem,
            setLayoutListItem: setLayoutListItem,
            tasks: tasks,
            addTask: addTask,
            removeTask: removeTask,
            error: error,
            setError: setError,
            success: success,
            setSuccess: setSuccess,
            userSettings: userSettings,
            setUserSettings: setUserSettings,
            systemError: systemError,
            setSystemError: setSystemError,
            loading: loading,
            setLoading: setLoading,
            modalScreen: modalScreen,
            setModalScreen: setModalScreen,
            page: page,
            setPage: setPage,
            isDevMode: isDevMode,
            modalRef: modalRef
        },
        children: children
    });
};
const $a55f2a94cd420149$export$c50e37a2f0a2b064 = ()=>{
    const context = (0, $acw62.useContext)($a55f2a94cd420149$var$LayoutContext);
    if (!context) throw new Error("useLayoutContext must be used within a LayoutProvider");
    return context;
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
'use strict';
function $e5cb5cefd6507f7e$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $c319b2c832c2914a$var$toString } = Object.prototype;
const { getPrototypeOf: $c319b2c832c2914a$var$getPrototypeOf } = Object;
const { iterator: $c319b2c832c2914a$var$iterator, toStringTag: $c319b2c832c2914a$var$toStringTag } = Symbol;
const $c319b2c832c2914a$var$kindOf = ((cache)=>(thing)=>{
        const str = $c319b2c832c2914a$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $c319b2c832c2914a$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$c319b2c832c2914a$var$kindOf(thing) === type;
};
const $c319b2c832c2914a$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $c319b2c832c2914a$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $c319b2c832c2914a$var$isUndefined = $c319b2c832c2914a$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && $c319b2c832c2914a$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $c319b2c832c2914a$var$isArrayBuffer = $c319b2c832c2914a$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $c319b2c832c2914a$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $c319b2c832c2914a$var$isString = $c319b2c832c2914a$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $c319b2c832c2914a$var$isFunction = $c319b2c832c2914a$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $c319b2c832c2914a$var$isNumber = $c319b2c832c2914a$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $c319b2c832c2914a$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $c319b2c832c2914a$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $c319b2c832c2914a$var$isPlainObject = (val)=>{
    if ($c319b2c832c2914a$var$kindOf(val) !== 'object') return false;
    const prototype = $c319b2c832c2914a$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($c319b2c832c2914a$var$toStringTag in val) && !($c319b2c832c2914a$var$iterator in val);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $c319b2c832c2914a$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$c319b2c832c2914a$var$isObject(val) || $c319b2c832c2914a$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $c319b2c832c2914a$var$isDate = $c319b2c832c2914a$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFile = $c319b2c832c2914a$var$kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $c319b2c832c2914a$var$isBlob = $c319b2c832c2914a$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFileList = $c319b2c832c2914a$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $c319b2c832c2914a$var$isStream = (val)=>$c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $c319b2c832c2914a$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === 'function' && thing instanceof FormData || $c319b2c832c2914a$var$isFunction(thing.append) && ((kind = $c319b2c832c2914a$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $c319b2c832c2914a$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $c319b2c832c2914a$var$isURLSearchParams = $c319b2c832c2914a$var$kindOfTest('URLSearchParams');
const [$c319b2c832c2914a$var$isReadableStream, $c319b2c832c2914a$var$isRequest, $c319b2c832c2914a$var$isResponse, $c319b2c832c2914a$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($c319b2c832c2914a$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $c319b2c832c2914a$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $c319b2c832c2914a$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($c319b2c832c2914a$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $c319b2c832c2914a$var$findKey(obj, key) {
    if ($c319b2c832c2914a$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $c319b2c832c2914a$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $c319b2c832c2914a$var$isContextDefined = (context)=>!$c319b2c832c2914a$var$isUndefined(context) && context !== $c319b2c832c2914a$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge() {
    const { caseless: caseless, skipUndefined: skipUndefined } = $c319b2c832c2914a$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $c319b2c832c2914a$var$findKey(result, key) || key;
        if ($c319b2c832c2914a$var$isPlainObject(result[targetKey]) && $c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge(result[targetKey], val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$c319b2c832c2914a$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $c319b2c832c2914a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $c319b2c832c2914a$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $c319b2c832c2914a$var$forEach(b, (val, key)=>{
        if (thisArg && $c319b2c832c2914a$var$isFunction(val)) a[key] = (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $c319b2c832c2914a$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $c319b2c832c2914a$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $c319b2c832c2914a$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $c319b2c832c2914a$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $c319b2c832c2914a$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($c319b2c832c2914a$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$c319b2c832c2914a$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $c319b2c832c2914a$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $c319b2c832c2914a$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$c319b2c832c2914a$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $c319b2c832c2914a$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $c319b2c832c2914a$var$isHTMLForm = $c319b2c832c2914a$var$kindOfTest('HTMLFormElement');
const $c319b2c832c2914a$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $c319b2c832c2914a$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $c319b2c832c2914a$var$isRegExp = $c319b2c832c2914a$var$kindOfTest('RegExp');
const $c319b2c832c2914a$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $c319b2c832c2914a$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $c319b2c832c2914a$var$freezeMethods = (obj)=>{
    $c319b2c832c2914a$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($c319b2c832c2914a$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$c319b2c832c2914a$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error('Can not rewrite read-only method \'' + name + '\'');
        };
    });
};
const $c319b2c832c2914a$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $c319b2c832c2914a$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $c319b2c832c2914a$var$noop = ()=>{};
const $c319b2c832c2914a$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $c319b2c832c2914a$var$isSpecCompliantForm(thing) {
    return !!(thing && $c319b2c832c2914a$var$isFunction(thing.append) && thing[$c319b2c832c2914a$var$toStringTag] === 'FormData' && thing[$c319b2c832c2914a$var$iterator]);
}
const $c319b2c832c2914a$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($c319b2c832c2914a$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            //Buffer check
            if ($c319b2c832c2914a$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $c319b2c832c2914a$var$isArray(source) ? [] : {};
                $c319b2c832c2914a$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$c319b2c832c2914a$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $c319b2c832c2914a$var$isAsyncFn = $c319b2c832c2914a$var$kindOfTest('AsyncFunction');
const $c319b2c832c2914a$var$isThenable = (thing)=>thing && ($c319b2c832c2914a$var$isObject(thing) || $c319b2c832c2914a$var$isFunction(thing)) && $c319b2c832c2914a$var$isFunction(thing.then) && $c319b2c832c2914a$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $c319b2c832c2914a$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $c319b2c832c2914a$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $c319b2c832c2914a$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $c319b2c832c2914a$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $c319b2c832c2914a$var$isFunction($c319b2c832c2914a$var$_global.postMessage));
const $c319b2c832c2914a$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($c319b2c832c2914a$var$_global) : $c319b2c832c2914a$var$_setImmediate;
// *********************
const $c319b2c832c2914a$var$isIterable = (thing)=>thing != null && $c319b2c832c2914a$var$isFunction(thing[$c319b2c832c2914a$var$iterator]);
var $c319b2c832c2914a$export$2e2bcd8739ae039 = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isBoolean: $c319b2c832c2914a$var$isBoolean,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isEmptyObject: $c319b2c832c2914a$var$isEmptyObject,
    isReadableStream: $c319b2c832c2914a$var$isReadableStream,
    isRequest: $c319b2c832c2914a$var$isRequest,
    isResponse: $c319b2c832c2914a$var$isResponse,
    isHeaders: $c319b2c832c2914a$var$isHeaders,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isRegExp: $c319b2c832c2914a$var$isRegExp,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isTypedArray: $c319b2c832c2914a$var$isTypedArray,
    isFileList: $c319b2c832c2914a$var$isFileList,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM,
    inherits: $c319b2c832c2914a$var$inherits,
    toFlatObject: $c319b2c832c2914a$var$toFlatObject,
    kindOf: $c319b2c832c2914a$var$kindOf,
    kindOfTest: $c319b2c832c2914a$var$kindOfTest,
    endsWith: $c319b2c832c2914a$var$endsWith,
    toArray: $c319b2c832c2914a$var$toArray,
    forEachEntry: $c319b2c832c2914a$var$forEachEntry,
    matchAll: $c319b2c832c2914a$var$matchAll,
    isHTMLForm: $c319b2c832c2914a$var$isHTMLForm,
    hasOwnProperty: $c319b2c832c2914a$var$hasOwnProperty,
    hasOwnProp: $c319b2c832c2914a$var$hasOwnProperty,
    reduceDescriptors: $c319b2c832c2914a$var$reduceDescriptors,
    freezeMethods: $c319b2c832c2914a$var$freezeMethods,
    toObjectSet: $c319b2c832c2914a$var$toObjectSet,
    toCamelCase: $c319b2c832c2914a$var$toCamelCase,
    noop: $c319b2c832c2914a$var$noop,
    toFiniteNumber: $c319b2c832c2914a$var$toFiniteNumber,
    findKey: $c319b2c832c2914a$var$findKey,
    global: $c319b2c832c2914a$var$_global,
    isContextDefined: $c319b2c832c2914a$var$isContextDefined,
    isSpecCompliantForm: $c319b2c832c2914a$var$isSpecCompliantForm,
    toJSONObject: $c319b2c832c2914a$var$toJSONObject,
    isAsyncFn: $c319b2c832c2914a$var$isAsyncFn,
    isThenable: $c319b2c832c2914a$var$isThenable,
    setImmediate: $c319b2c832c2914a$var$_setImmediate,
    asap: $c319b2c832c2914a$var$asap,
    isIterable: $c319b2c832c2914a$var$isIterable
};







'use strict';
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $4e2395edb77acf3a$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).inherits($4e2395edb77acf3a$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $4e2395edb77acf3a$var$prototype = $4e2395edb77acf3a$var$AxiosError.prototype;
const $4e2395edb77acf3a$var$descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
].forEach((code)=>{
    $4e2395edb77acf3a$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($4e2395edb77acf3a$var$AxiosError, $4e2395edb77acf3a$var$descriptors);
Object.defineProperty($4e2395edb77acf3a$var$prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
$4e2395edb77acf3a$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($4e2395edb77acf3a$var$prototype);
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== 'isAxiosError';
    });
    const msg = error && error.message ? error.message : 'Error';
    // Prefer explicit code; otherwise copy the low-level error's code (e.g. ECONNREFUSED)
    const errCode = code == null && error ? error.code : code;
    $4e2395edb77acf3a$var$AxiosError.call(axiosError, msg, errCode, config, request, response);
    // Chain the original error on the standard field; non-enumerable to avoid JSON noise
    if (error && axiosError.cause == null) Object.defineProperty(axiosError, 'cause', {
        value: error,
        configurable: true
    });
    axiosError.name = error && error.name || 'Error';
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $4e2395edb77acf3a$export$2e2bcd8739ae039 = $4e2395edb77acf3a$var$AxiosError;


// eslint-disable-next-line strict
var $4023ac50ad132196$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $e6cbd383b18c9625$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isVisitable(thing) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $e6cbd383b18c9625$var$removeBrackets(key) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $e6cbd383b18c9625$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $e6cbd383b18c9625$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isFlatArray(arr) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(arr) && !arr.some($e6cbd383b18c9625$var$isVisitable);
}
const $e6cbd383b18c9625$var$predicates = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject((0, $c319b2c832c2914a$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $e6cbd383b18c9625$var$toFormData(obj, formData, options) {
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $4023ac50ad132196$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $e6cbd383b18c9625$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === 'object') {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) && $e6cbd383b18c9625$var$isFlatArray(value) || ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $e6cbd383b18c9625$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $e6cbd383b18c9625$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($e6cbd383b18c9625$var$isVisitable(value)) return true;
        formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($e6cbd383b18c9625$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $e6cbd383b18c9625$var$isVisitable
    });
    function build(value, path) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $e6cbd383b18c9625$export$2e2bcd8739ae039 = $e6cbd383b18c9625$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $f66f8c7b4f247caf$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $f66f8c7b4f247caf$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(params, this, options);
}
const $f66f8c7b4f247caf$var$prototype = $f66f8c7b4f247caf$var$AxiosURLSearchParams.prototype;
$f66f8c7b4f247caf$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$f66f8c7b4f247caf$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $f66f8c7b4f247caf$var$encode);
    } : $f66f8c7b4f247caf$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $f66f8c7b4f247caf$export$2e2bcd8739ae039 = $f66f8c7b4f247caf$var$AxiosURLSearchParams;


'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $8df8fedf1c1e4428$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $8df8fedf1c1e4428$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $8df8fedf1c1e4428$var$encode;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $5de878cd737ef277$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $5de878cd737ef277$export$2e2bcd8739ae039 = $5de878cd737ef277$var$InterceptorManager;





'use strict';
var $51466d41a76e5b4b$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






'use strict';
var $6eeff4490c995137$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039);


'use strict';
var $86d275a264afb13f$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $59c79e94740631e4$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $2f71637df772b183$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $6eeff4490c995137$export$2e2bcd8739ae039,
        FormData: $86d275a264afb13f$export$2e2bcd8739ae039,
        Blob: $59c79e94740631e4$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $565e85ead8bde60a$exports = {};

$parcel$export($565e85ead8bde60a$exports, "hasBrowserEnv", () => $565e85ead8bde60a$export$c4996c4b7b93b0bf);
$parcel$export($565e85ead8bde60a$exports, "navigator", () => $565e85ead8bde60a$export$ec7c8efa7f5790ae);
$parcel$export($565e85ead8bde60a$exports, "hasStandardBrowserEnv", () => $565e85ead8bde60a$export$c0bcc9250309d66);
$parcel$export($565e85ead8bde60a$exports, "hasStandardBrowserWebWorkerEnv", () => $565e85ead8bde60a$export$c81692cf5af97dac);
$parcel$export($565e85ead8bde60a$exports, "origin", () => $565e85ead8bde60a$export$f710a83a91838a36);
const $565e85ead8bde60a$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $565e85ead8bde60a$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $565e85ead8bde60a$export$c0bcc9250309d66 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && (!$565e85ead8bde60a$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($565e85ead8bde60a$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $565e85ead8bde60a$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $565e85ead8bde60a$export$f710a83a91838a36 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $bb8180acb278e187$export$2e2bcd8739ae039 = {
    ...$565e85ead8bde60a$exports,
    ...(0, $2f71637df772b183$export$2e2bcd8739ae039)
};


'use strict';
function $f6f250f62cadb740$export$2e2bcd8739ae039(data, options) {
    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(data, new (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).isNode && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}




'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $5f8142930b3b943f$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $5f8142930b3b943f$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $5f8142930b3b943f$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $5f8142930b3b943f$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(formData) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($5f8142930b3b943f$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $5f8142930b3b943f$export$2e2bcd8739ae039 = $5f8142930b3b943f$var$formDataToJSON;


'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $843bf0209bc94df8$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $843bf0209bc94df8$var$defaults = {
    transitional: (0, $51466d41a76e5b4b$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $5f8142930b3b943f$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isStream(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFile(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $f6f250f62cadb740$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $843bf0209bc94df8$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $843bf0209bc94df8$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isResponse(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, this.parseReviver);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(e, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $843bf0209bc94df8$var$defaults.headers[method] = {};
});
var $843bf0209bc94df8$export$2e2bcd8739ae039 = $843bf0209bc94df8$var$defaults;




'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $fc026bbf9ee156f1$var$ignoreDuplicateOf = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $fc026bbf9ee156f1$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};


'use strict';
const $866cce54f6bdfb0c$var$$internals = Symbol('internals');
function $866cce54f6bdfb0c$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $866cce54f6bdfb0c$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.map($866cce54f6bdfb0c$var$normalizeValue) : String(value);
}
function $866cce54f6bdfb0c$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $866cce54f6bdfb0c$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $866cce54f6bdfb0c$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $866cce54f6bdfb0c$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $866cce54f6bdfb0c$var$buildAccessors(obj, header) {
    const accessorName = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $866cce54f6bdfb0c$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $866cce54f6bdfb0c$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$866cce54f6bdfb0c$var$isValidHeaderName(header)) setHeaders((0, $fc026bbf9ee156f1$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(header) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(entry)) throw TypeError('Object iterator must return a key-value pair');
                obj[key = entry[0]] = (dest = obj[key]) ? (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $866cce54f6bdfb0c$var$parseTokens(value);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $866cce54f6bdfb0c$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $866cce54f6bdfb0c$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $866cce54f6bdfb0c$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get("set-cookie") || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$866cce54f6bdfb0c$var$$internals] = this[$866cce54f6bdfb0c$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $866cce54f6bdfb0c$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$866cce54f6bdfb0c$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).reduceDescriptors($866cce54f6bdfb0c$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).freezeMethods($866cce54f6bdfb0c$var$AxiosHeaders);
var $866cce54f6bdfb0c$export$2e2bcd8739ae039 = $866cce54f6bdfb0c$var$AxiosHeaders;


'use strict';
function $5cf10c777cce5f4f$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $843bf0209bc94df8$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $5a60afef8b0dd173$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





'use strict';
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $9fd0919e266b4fda$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).call(this, message == null ? 'canceled' : message, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).inherits($9fd0919e266b4fda$var$CanceledError, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $9fd0919e266b4fda$export$2e2bcd8739ae039 = $9fd0919e266b4fda$var$CanceledError;







'use strict';
function $ecb62d5372993dcf$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, [
        (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





'use strict';
function $23607f53e4fda918$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $4a9d49cd0e6b8acc$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $4a9d49cd0e6b8acc$export$2e2bcd8739ae039 = $4a9d49cd0e6b8acc$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $9b3ced92bc7bdc99$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $9b3ced92bc7bdc99$export$2e2bcd8739ae039 = $9b3ced92bc7bdc99$var$throttle;



const $1a6c80b567b74091$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $4a9d49cd0e6b8acc$export$2e2bcd8739ae039)(50, 250);
    return (0, $9b3ced92bc7bdc99$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $1a6c80b567b74091$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $1a6c80b567b74091$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $5eb63b558e1fb85a$export$2e2bcd8739ae039 = (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $bb8180acb278e187$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin), (0, $bb8180acb278e187$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $bb8180acb278e187$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $65cc14c0704b5541$export$2e2bcd8739ae039 = (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(path)) cookie.push(`path=${path}`);
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


'use strict';
function $8fa91c1a59edb5d9$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $b63e12c1e0b9e0be$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
function $598acbfafd2c63c5$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $8fa91c1a59edb5d9$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, $b63e12c1e0b9e0be$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




'use strict';
const $f85fda54cd977b19$var$headersToObject = (thing)=>thing instanceof (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $f85fda54cd977b19$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(target) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($f85fda54cd977b19$var$headersToObject(a), $f85fda54cd977b19$var$headersToObject(b), prop, true)
    };
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(Object.keys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $ab4625fac3104691$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)((0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // browser handles it
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(data.getHeaders)) {
            // Node.js FormData (like form-data package)
            const formHeaders = data.getHeaders();
            // Only set safe headers to avoid overwriting security headers
            const allowedHeaders = [
                'content-type',
                'content-length'
            ];
            Object.entries(formHeaders).forEach(([key, val])=>{
                if (allowedHeaders.includes(key.toLowerCase())) headers.set(key, val);
            });
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $5eb63b558e1fb85a$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $65cc14c0704b5541$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $79f0a48d5eb7919b$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $79f0a48d5eb7919b$export$2e2bcd8739ae039 = $79f0a48d5eb7919b$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $ab4625fac3104691$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Request aborted', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(msg, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $51466d41a76e5b4b$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT : (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $1a6c80b567b74091$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $1a6c80b567b74091$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $23607f53e4fda918$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $bb8180acb278e187$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $a052b9a6636aacdc$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $4e2395edb77acf3a$export$2e2bcd8739ae039) ? err : new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`timeout ${timeout} of ms exceeded`, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $a052b9a6636aacdc$export$2e2bcd8739ae039 = $a052b9a6636aacdc$var$composeSignals;


const $c9465135abb26626$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $c9465135abb26626$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $c9465135abb26626$var$readStream(iterable))yield* $c9465135abb26626$export$71b051935044bd5d(chunk, chunkSize);
};
const $c9465135abb26626$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $c9465135abb26626$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $c9465135abb26626$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $e52be20a9fc15e96$var$isFunction } = (0, $c319b2c832c2914a$export$2e2bcd8739ae039);
const $e52be20a9fc15e96$var$globalFetchAPI = (({ Request: Request, Response: Response })=>({
        Request: Request,
        Response: Response
    }))((0, $c319b2c832c2914a$export$2e2bcd8739ae039).global);
const { ReadableStream: $e52be20a9fc15e96$var$ReadableStream, TextEncoder: $e52be20a9fc15e96$var$TextEncoder } = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).global;
const $e52be20a9fc15e96$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $e52be20a9fc15e96$var$factory = (env)=>{
    env = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, $e52be20a9fc15e96$var$globalFetchAPI, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $e52be20a9fc15e96$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $e52be20a9fc15e96$var$isFunction(Request);
    const isResponseSupported = $e52be20a9fc15e96$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $e52be20a9fc15e96$var$isFunction($e52be20a9fc15e96$var$ReadableStream);
    const encodeText = isFetchSupported && (typeof $e52be20a9fc15e96$var$TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new $e52be20a9fc15e96$var$TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>{
        let duplexAccessed = false;
        const hasContentType = new Request((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin, {
            body: new $e52be20a9fc15e96$var$ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        }).headers.has('Content-Type');
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(body)) return body.size;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
            const _request = new Request((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $ab4625fac3104691$export$2e2bcd8739ae039)(config);
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $a052b9a6636aacdc$export$2e2bcd8739ae039)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        try {
            if (onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
                let _request = new Request(url, {
                    method: 'POST',
                    body: data,
                    duplex: "half"
                });
                let contentTypeHeader;
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                if (_request.body) {
                    const [onProgress, flush] = (0, $1a6c80b567b74091$export$d9fadd12586c18d6)(requestContentLength, (0, $1a6c80b567b74091$export$c1b28109d46c3592)((0, $1a6c80b567b74091$export$5d35863c355a22a9)(onUploadProgress)));
                    data = (0, $c9465135abb26626$export$b0119225647bd83)(_request.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
                }
            }
            if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && "credentials" in Request.prototype;
            const resolvedOptions = {
                ...fetchOptions,
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: headers.normalize().toJSON(),
                body: data,
                duplex: "half",
                credentials: isCredentialsSupported ? withCredentials : undefined
            };
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
                const [onProgress, flush] = onDownloadProgress && (0, $1a6c80b567b74091$export$d9fadd12586c18d6)(responseContentLength, (0, $1a6c80b567b74091$export$c1b28109d46c3592)((0, $1a6c80b567b74091$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
                response = new Response((0, $c9465135abb26626$export$b0119225647bd83)(response.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(resolvers, responseType) || 'text'](response, config);
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(resolve, reject, {
                    data: responseData,
                    headers: (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Network Error', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
                cause: err.cause || err
            });
            throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
        }
    };
};
const $e52be20a9fc15e96$var$seedCache = new Map();
const $e52be20a9fc15e96$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $e52be20a9fc15e96$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $e52be20a9fc15e96$var$factory(env));
        map = target;
    }
    return target;
};
const $e52be20a9fc15e96$var$adapter = $e52be20a9fc15e96$export$3105c6651375d4fa();
var $e52be20a9fc15e96$export$2e2bcd8739ae039 = $e52be20a9fc15e96$var$adapter;



/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 * 
 * @type {Object<string, Function|Object>}
 */ const $e8c8c7960873e9ee$var$knownAdapters = {
    http: (0, $4023ac50ad132196$export$2e2bcd8739ae039),
    xhr: (0, $79f0a48d5eb7919b$export$2e2bcd8739ae039),
    fetch: {
        get: $e52be20a9fc15e96$export$3105c6651375d4fa
    }
};
// Assign adapter names for easier debugging and identification
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach($e8c8c7960873e9ee$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 * 
 * @param {string} reason
 * @returns {string}
 */ const $e8c8c7960873e9ee$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 * 
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $e8c8c7960873e9ee$var$isResolvedHandle = (adapter)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 * 
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $e8c8c7960873e9ee$var$getAdapter(adapters, config) {
    adapters = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$e8c8c7960873e9ee$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $e8c8c7960873e9ee$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($e8c8c7960873e9ee$var$renderReason).join('\n') : ' ' + $e8c8c7960873e9ee$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $e8c8c7960873e9ee$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $e8c8c7960873e9ee$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $e8c8c7960873e9ee$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config);
}
function $9b8d10189805ccc0$export$2e2bcd8739ae039(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $843bf0209bc94df8$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $5a60afef8b0dd173$export$2e2bcd8739ae039)(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $23ff3f1a5c7912d5$export$a4ad2735b021c132 = "1.13.2";



'use strict';
const $85f59389941e7907$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $85f59389941e7907$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $85f59389941e7907$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $85f59389941e7907$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$85f59389941e7907$var$deprecatedWarnings[opt]) {
            $85f59389941e7907$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$85f59389941e7907$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $85f59389941e7907$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('options must be an object', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $85f59389941e7907$export$2e2bcd8739ae039 = {
    assertOptions: $85f59389941e7907$var$assertOptions,
    validators: $85f59389941e7907$var$validators
};



'use strict';
const $a93486d2307f31c3$var$validators = (0, $85f59389941e7907$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $a93486d2307f31c3$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)(),
            response: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            forcedJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            clarifyTimeoutError: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $a93486d2307f31c3$var$validators.function,
                serialize: $a93486d2307f31c3$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $a93486d2307f31c3$var$validators.spelling('baseURL'),
            withXsrfToken: $a93486d2307f31c3$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $a93486d2307f31c3$var$Axios.prototype[method] = generateHTTPMethod();
    $a93486d2307f31c3$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $a93486d2307f31c3$export$2e2bcd8739ae039 = $a93486d2307f31c3$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $fb81495929d8a282$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $fb81495929d8a282$export$2e2bcd8739ae039 = $fb81495929d8a282$var$CancelToken;






'use strict';
function $089369673aa7c1c3$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $9db8da59db12cd94$export$2e2bcd8739ae039(payload) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $f919374d785e9fb8$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($f919374d785e9fb8$var$HttpStatusCode).forEach(([key, value])=>{
    $f919374d785e9fb8$var$HttpStatusCode[value] = key;
});
var $f919374d785e9fb8$export$2e2bcd8739ae039 = $f919374d785e9fb8$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    const context = new (0, $a93486d2307f31c3$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)((0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, (0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $57966c7e0affc4cb$var$createInstance((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance((0, $843bf0209bc94df8$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = (0, $a93486d2307f31c3$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.CanceledError = (0, $9fd0919e266b4fda$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.CancelToken = (0, $fb81495929d8a282$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.isCancel = (0, $5a60afef8b0dd173$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.VERSION = (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132);
$57966c7e0affc4cb$var$axios.toFormData = (0, $e6cbd383b18c9625$export$2e2bcd8739ae039);
// Expose AxiosError class
$57966c7e0affc4cb$var$axios.AxiosError = (0, $4e2395edb77acf3a$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$57966c7e0affc4cb$var$axios.Cancel = $57966c7e0affc4cb$var$axios.CanceledError;
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$57966c7e0affc4cb$var$axios.spread = (0, $089369673aa7c1c3$export$2e2bcd8739ae039);
// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (0, $9db8da59db12cd94$export$2e2bcd8739ae039);
// Expose mergeConfig
$57966c7e0affc4cb$var$axios.mergeConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.AxiosHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.formToJSON = (thing)=>(0, $5f8142930b3b943f$export$2e2bcd8739ae039)((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$57966c7e0affc4cb$var$axios.getAdapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter;
$57966c7e0affc4cb$var$axios.HttpStatusCode = (0, $f919374d785e9fb8$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.default = $57966c7e0affc4cb$var$axios;
var // this module should only have a default export
$57966c7e0affc4cb$export$2e2bcd8739ae039 = $57966c7e0affc4cb$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $b302555736d21bd7$export$1c00760e9e5a4e95, AxiosError: $b302555736d21bd7$export$c1fbed17c2f6a328, CanceledError: $b302555736d21bd7$export$1ab0c6b20d94fa14, isCancel: $b302555736d21bd7$export$3b22524397b493c6, CancelToken: $b302555736d21bd7$export$fd08e3cb425f0d61, VERSION: $b302555736d21bd7$export$a4ad2735b021c132, all: $b302555736d21bd7$export$84bf76cd7afc7469, Cancel: $b302555736d21bd7$export$848c9b7ead0df967, isAxiosError: $b302555736d21bd7$export$fbafdbe06a5b5a9a, spread: $b302555736d21bd7$export$3ae0fd4797ed47c8, toFormData: $b302555736d21bd7$export$10ae0d317ea97f8b, AxiosHeaders: $b302555736d21bd7$export$4e7d6ff0f3e6520, HttpStatusCode: $b302555736d21bd7$export$a972f69c851492b3, formToJSON: $b302555736d21bd7$export$86d7c59254d6a2c9, getAdapter: $b302555736d21bd7$export$17ddc20a97d669e2, mergeConfig: $b302555736d21bd7$export$7ec1ebcfa9d8bd6a } = (0, $57966c7e0affc4cb$export$2e2bcd8739ae039);


const $bac44633733ff026$var$api = (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).create({
    baseURL: "/api"
});
/** Paths whose handlers in OMS Go (`internal/handler/dto/proposal_dto.go`)
 *  honour `Accept-Version` negotiation. Match must run on the URL the
 *  caller passed to axios (relative path, post-baseURL). Backend strips
 *  `/oms` prefix at api-gw; frontend keeps it. We match either form. */ const $bac44633733ff026$var$ACCEPT_VERSION_PATTERN = /^\/?(oms\/)?admin\/orders\b/;
const $bac44633733ff026$var$shouldInjectAcceptVersion = (url)=>{
    if (!url) return false;
    return $bac44633733ff026$var$ACCEPT_VERSION_PATTERN.test(url);
};
$bac44633733ff026$var$api.interceptors.request.use((config)=>{
    // Tenta obter o token do localStorage ou sessionStorage
    const token = localStorage.getItem("authToken") || sessionStorage.getItem("authToken");
    if (token) config.headers.authorization = `Bearer ${token}`;
    // ADR-021: forward the operator's tenant selection for the multi-tenant
    // backoffice. The api-gw validates it against the caller's server-derived
    // grant and returns 403 if not allowed — the client never authorises itself.
    const selectedTenant = localStorage.getItem("selectedTenantId");
    if (selectedTenant) config.headers["X-Selected-Tenant-ID"] = selectedTenant;
    // PR 6b — inject Accept-Version on OMS admin order routes so the
    // backend's dto.NegotiateVersion returns "v1" deterministically and
    // unknown versions surface as 406 (mapped to "version_mismatch" by
    // helpers/apiErrors.ts). See ADR-6b §B1.
    if ($bac44633733ff026$var$shouldInjectAcceptVersion(config.url)) // Don't overwrite if a call already set its own Accept-Version
    // (defensive — no current call site does, but keep idempotent).
    {
        if (!config.headers["Accept-Version"]) config.headers["Accept-Version"] = "v1";
    }
    return config;
}, (error)=>{
    return Promise.reject(error);
});
// Paths that validate the session itself — a 401/403 here means the session
// is truly dead and the user must re-authenticate.
const $bac44633733ff026$var$AUTH_PATHS = [
    "/settings",
    "/auth/",
    "/auth/profile"
];
const $bac44633733ff026$var$isAuthPath = (url)=>{
    if (!url) return false;
    return $bac44633733ff026$var$AUTH_PATHS.some((p)=>url.includes(p));
};
// Admin catalog endpoint. Exact match only: `/catalog/metadata/categories` is a
// feature endpoint whose 401/403 must not wipe the session. Only a 401 (dead
// token) triggers re-auth here; 403 is a permission problem, not expiry.
const $bac44633733ff026$var$isAdminCategoriesPath = (url)=>{
    if (!url) return false;
    return url === "/categories" || url.startsWith("/categories/") || url.startsWith("/categories?");
};
$bac44633733ff026$var$api.interceptors.response.use((config)=>{
    // Verifica se o token foi atualizado e salva no localStorage ou sessionStorage
    const authHeader = config.headers.authorization || config.headers.Authorization || (typeof config.headers.get === "function" ? config.headers.get("authorization") : undefined);
    const token = typeof authHeader === "string" ? authHeader.split(" ")[1] : undefined;
    if (token) {
        localStorage.setItem("authToken", token);
        sessionStorage.setItem("authToken", token);
    }
    return config;
}, (error)=>{
    const status = error.response?.status || 0;
    const url = error.config?.url;
    if (status === 401 && $bac44633733ff026$var$isAdminCategoriesPath(url)) // Admin catalog: 401 means the session is dead, 403 means "not allowed".
    // @ts-ignore
    $bac44633733ff026$var$api.clearToken();
    else if ([
        401,
        403,
        423
    ].includes(status) && $bac44633733ff026$var$isAuthPath(url)) // Only force-logout when the auth/session endpoints reject the token.
    // Feature endpoints (OMS, payments, reviews…) may legitimately return
    // 401/403 without meaning the session is invalid — let callers handle.
    // @ts-ignore
    $bac44633733ff026$var$api.clearToken();
    return Promise.reject(error);
});
// @ts-ignore
$bac44633733ff026$var$api.clearToken = async ()=>{
    // Limpa o token do localStorage e sessionStorage
    localStorage.removeItem("authToken");
    sessionStorage.removeItem("authToken");
    // Redireciona para a página de login
    if (window.location.pathname !== "/login") window.location.href = "/login";
};
var $bac44633733ff026$export$2e2bcd8739ae039 = $bac44633733ff026$var$api;



// The user has `ChatSettings` in `src/model/ChatSettings.tsx` (interface).
// And `ProfileAndSettings` likely has `chat_settings: ChatSettings | null`.
let $2a65a3d8084c2117$var$initTimer = null;
const $2a65a3d8084c2117$export$1a8b766124301833 = (chatSettings)=>{
    // Profile refreshes call this repeatedly; never re-init a connected widget
    // and never log the token.
    if (window.ChatWidget?.isConnected?.()) return;
    if ($2a65a3d8084c2117$var$initTimer) {
        clearInterval($2a65a3d8084c2117$var$initTimer);
        $2a65a3d8084c2117$var$initTimer = null;
    }
    // If widget not loaded, load it
    const existingScript = document.querySelector('script[src*="chat-widget.js"]');
    if (!existingScript) {
        const script = document.createElement("script");
        script.src = `${chatSettings.url}/chat-widget.js`;
        script.async = true;
        document.body.appendChild(script);
    }
    const existingStyle = document.querySelector('link[href*="chat-widget.css"]');
    if (!existingStyle) {
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = `${chatSettings.url}/chat-widget.css`;
        document.head.appendChild(link);
    }
    let maxTries = 10;
    const timeout = setInterval(()=>{
        if (window.ChatWidget) {
            try {
                clearInterval(timeout);
            } catch (error) {
                console.log("Error clearing interval:", error);
            }
            $2a65a3d8084c2117$var$initTimer = null;
            if (window.ChatWidget.isConnected && window.ChatWidget.isConnected()) {
                console.log("Chat widget already connected");
                return;
            }
            console.log("Subscribe campaign_name:", chatSettings.campaign_name);
            window.ChatWidget.init({
                tenantSubdomain: chatSettings.tenant_subdomain,
                apiUrl: chatSettings.url,
                wsUrl: chatSettings.ws_url,
                token: chatSettings.token,
                campaignName: chatSettings.campaign_name
            });
        } else {
            console.log("ChatWidget not found");
            maxTries--;
            if (maxTries <= 0) {
                console.log("Max tries reached to initialize chat widget");
                clearInterval(timeout);
                $2a65a3d8084c2117$var$initTimer = null;
            }
        }
    }, 1000);
    $2a65a3d8084c2117$var$initTimer = timeout;
};



const $031177517a2d1428$var$tracer = (0, $496851d2cf78caa4$export$357889f174732d38).getTracer("intranet-frontend");
const $031177517a2d1428$export$b33b857ad1d9900e = (operation, error, attributes = {})=>{
    const message = error instanceof Error ? error.message : String(error);
    const span = $031177517a2d1428$var$tracer.startSpan(operation, {
        attributes: {
            operation: operation,
            ...attributes,
            "error.message": message
        }
    });
    const traceId = span.spanContext().traceId;
    span.recordException(error instanceof Error ? error : new Error(message));
    span.setStatus({
        code: (0, $ed982b21ea27c702$export$1e28dd9b5d01db83).ERROR,
        message: message
    });
    span.end();
    // eslint-disable-next-line no-console
    console.error(`[${operation}] ${message}`, {
        operation: operation,
        traceId: traceId,
        ...attributes
    });
    return traceId;
};


/**
 * Sync helper: derive admin status directly from a ProfileAndSettings payload.
 * Mirrors `enhanceProfileAndSettings(...).isAdmin()` but as a pure function so
 * it can be used both inside the provider and in tests without instantiating
 * the cache.
 */ const $b622ef53e38024e7$export$4fbaf01c14a521ac = (data)=>{
    if (!data) return false;
    return data.profile.type === "admin" || data.profile.roles.includes("ADMIN");
};
const $b622ef53e38024e7$var$PROFILE_LIFECYCLE_ERROR = "ProfileLifecycleError";
const $b622ef53e38024e7$var$profileLifecycleError = (message)=>{
    const error = new Error(message);
    error.name = $b622ef53e38024e7$var$PROFILE_LIFECYCLE_ERROR;
    return error;
};
const $b622ef53e38024e7$export$48df6aec8f98c4a0 = (error)=>error instanceof Error && error.name === $b622ef53e38024e7$var$PROFILE_LIFECYCLE_ERROR;
const $b622ef53e38024e7$var$enhanceProfileAndSettings = (data)=>{
    console.log("Enhancing profile");
    if (data.chat_settings) (0, $2a65a3d8084c2117$export$1a8b766124301833)(data.chat_settings);
    else console.log("No chat token found, skipping chat widget initialization");
    return {
        ...data,
        isAdmin: function() {
            return data.profile.type === "admin" || data.profile.roles.includes("ADMIN");
        },
        isReseller: function() {
            return data.profile.type === "reseller" || data.profile.roles.includes("RESELLER");
        },
        isCommercial: function() {
            return data.profile.type === "commercial" || data.profile.roles.includes("COMMERCIAL");
        },
        isNormalUser: function() {
            return data.profile.type === "user" || data.profile.roles.length === 1 && data.profile.roles[0] === "USER";
        },
        isOperatorUser: function() {
            return this.isAdmin() || this.isReseller() || this.isCommercial();
        },
        isMainAccount: function() {
            return data.profile.isMainAccount || data.profile.roles.includes("MAIN_ACCOUNT");
        },
        isSubAccount: function() {
            return data.profile.isSubAccount;
        }
    };
};
// Create the AuthContext
const $b622ef53e38024e7$var$AuthContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
const $b622ef53e38024e7$export$1d39dc5b47e56ff0 = ()=>{
    const context = (0, $acw62.useContext)($b622ef53e38024e7$var$AuthContext);
    if (!context) throw new Error("useAuth must be used within a AuthProvider");
    return context;
};
const $b622ef53e38024e7$export$87091915187a1a85 = ({ children: children })=>{
    const [profileCache, setProfileCache] = (0, $acw62.useState)(null);
    // Mirrors of the cache so `profile` can read the latest value without
    // depending on it. Keeping the callback identity stable stops every consumer
    // effect with `profile` in its dependency array from re-firing.
    const profileCacheRef = (0, $acw62.useRef)(null);
    const profileRequestRef = (0, $acw62.useRef)(null);
    const cacheTimeoutRef = (0, $acw62.useRef)(null);
    // Bumped whenever a newer profile is written outside the GET path
    // (saveProfile/setProfile). An older in-flight GET must not overwrite it.
    const profileEpochRef = (0, $acw62.useRef)(0);
    const armCacheExpiry = (0, $acw62.useCallback)(()=>{
        if (cacheTimeoutRef.current) clearTimeout(cacheTimeoutRef.current);
        cacheTimeoutRef.current = setTimeout(()=>{
            profileCacheRef.current = null;
            setProfileCache(null);
            cacheTimeoutRef.current = null;
        }, 300000);
    }, []);
    (0, $acw62.useEffect)(()=>()=>{
            if (cacheTimeoutRef.current) clearTimeout(cacheTimeoutRef.current);
        }, []);
    const profile = (0, $acw62.useCallback)(async ()=>{
        const cached = profileCacheRef.current;
        if (cached) return Promise.resolve(cached);
        const pending = profileRequestRef.current;
        if (pending) return pending;
        const epoch = profileEpochRef.current;
        const request = (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).SETTINGS, {
            timeout: 15000
        }).then((response)=>{
            // A logout may have happened while /settings was in flight. Never
            // repopulate the cache for a session that no longer exists.
            const token = localStorage.getItem("authToken") || sessionStorage.getItem("authToken");
            if (!token) throw $b622ef53e38024e7$var$profileLifecycleError("Sess\xe3o terminada");
            // A newer profile was saved (or set) after this request started; its
            // data wins over this stale response.
            if (epoch !== profileEpochRef.current) {
                const latest = profileCacheRef.current;
                if (latest) return latest;
                throw $b622ef53e38024e7$var$profileLifecycleError("Perfil substitu\xeddo");
            }
            const profileData = $b622ef53e38024e7$var$enhanceProfileAndSettings(response.data);
            profileCacheRef.current = profileData;
            setProfileCache(profileData);
            armCacheExpiry();
            return profileData;
        }).catch((error)=>{
            // Expected lifecycle outcomes are not failures to report.
            if (!$b622ef53e38024e7$export$48df6aec8f98c4a0(error)) (0, $031177517a2d1428$export$b33b857ad1d9900e)("profile.fetch", error);
            throw error; // Re-throw to allow caller to catch
        });
        const wrappedRequest = request.finally(()=>{
            if (profileRequestRef.current === wrappedRequest) profileRequestRef.current = null;
        });
        profileRequestRef.current = wrappedRequest;
        return wrappedRequest;
    }, [
        armCacheExpiry
    ]);
    const saveProfile = (0, $acw62.useCallback)(async (dataToUpdate, file)=>{
        const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).put((0, $cd93687958c8007e$export$bfe19bc25132bb7c).SETTINGS, dataToUpdate, {
            timeout: 20000
        }).then(async (res)=>{
            if (file) {
                // If a file is provided, upload it as well
                const formData = new FormData();
                formData.append("file", file);
                formData.append("data", JSON.stringify(dataToUpdate));
                return await (0, $bac44633733ff026$export$2e2bcd8739ae039).put((0, $cd93687958c8007e$export$bfe19bc25132bb7c).SETTINGS + "/company-logo", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    },
                    timeout: 20000
                });
            }
            return res;
        });
        const profileData = $b622ef53e38024e7$var$enhanceProfileAndSettings(response.data);
        profileEpochRef.current += 1;
        profileRequestRef.current = null;
        profileCacheRef.current = profileData;
        setProfileCache(profileData);
        armCacheExpiry();
        return profileData;
    }, [
        armCacheExpiry
    ]);
    const isAuthenticated = (0, $acw62.useCallback)(()=>{
        const token = localStorage.getItem("authToken") || sessionStorage.getItem("authToken");
        return !!token;
    }, []);
    const setProfile = (0, $acw62.useCallback)((profileData)=>{
        profileEpochRef.current += 1;
        profileRequestRef.current = null;
        if (!profileData) {
            if (cacheTimeoutRef.current) {
                clearTimeout(cacheTimeoutRef.current);
                cacheTimeoutRef.current = null;
            }
            profileCacheRef.current = null;
            setProfileCache(null);
            return;
        }
        const enhanced = $b622ef53e38024e7$var$enhanceProfileAndSettings(profileData);
        profileCacheRef.current = enhanced;
        setProfileCache(enhanced);
        armCacheExpiry();
    }, [
        armCacheExpiry
    ]);
    // Synchronous, render-safe admin flag. Recomputed cheaply on every render;
    // memoised so the context `value` object is stable when `profileCache` does
    // not change, avoiding spurious re-renders in consumers.
    const isAdmin = (0, $acw62.useMemo)(()=>$b622ef53e38024e7$export$4fbaf01c14a521ac(profileCache), [
        profileCache
    ]);
    // Hydrate the cache on mount when the user is already authenticated, so
    // consumers can read `isAdmin` synchronously after the first tick instead
    // of waiting for some downstream component to call `profile()`.
    //
    // We intentionally swallow errors here: `profile()` already logs failures
    // and individual screens still trigger their own fetches, so this hook is a
    // best-effort warm-up. The `hydrated` guard avoids re-fetching when callers
    // populate the cache through `setProfile` (e.g. right after login) before
    // this effect runs.
    const hydrate = (0, $acw62.useCallback)(()=>{
        if (profileCache) return;
        if (!isAuthenticated()) return;
        profile().catch(()=>{
        /* logged inside profile() */ });
    }, [
        profileCache
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    (0, $acw62.useEffect)(()=>{
        hydrate();
    }, [
        hydrate
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($b622ef53e38024e7$var$AuthContext.Provider, {
        value: {
            setProfile: setProfile,
            isAuthenticated: isAuthenticated,
            isAdmin: isAdmin,
            profile: profile,
            profileData: profileCache,
            saveProfile: saveProfile
        },
        children: children
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $db42588f972bc829$export$73bda83cddbc7187 = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const $db42588f972bc829$export$86f54f62aa7a7514 = (string)=>string.replace(/^([A-Z])|[\s-_]+(\w)/g, (match, p1, p2)=>p2 ? p2.toUpperCase() : p1.toLowerCase());
const $db42588f972bc829$export$6fb43ff9addf7357 = (string)=>{
    const camelCase = $db42588f972bc829$export$86f54f62aa7a7514(string);
    return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};
const $db42588f972bc829$export$3d46f4579dba46e5 = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
    }).join(" ").trim();
const $db42588f972bc829$export$ab365959aa6deed0 = (props)=>{
    for(const prop in props){
        if (prop.startsWith("aria-") || prop === "role" || prop === "title") return true;
    }
};


/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var $65855df5fc59b2ec$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};



const $d2b1338ec3fa0df8$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)(({ color: color = "currentColor", size: size = 24, strokeWidth: strokeWidth = 2, absoluteStrokeWidth: absoluteStrokeWidth, className: className = "", children: children, iconNode: iconNode, ...rest }, ref)=>(0, $acw62.createElement)("svg", {
        ref: ref,
        ...(0, $65855df5fc59b2ec$export$2e2bcd8739ae039),
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        className: (0, $db42588f972bc829$export$3d46f4579dba46e5)("lucide", className),
        ...!children && !(0, $db42588f972bc829$export$ab365959aa6deed0)(rest) && {
            "aria-hidden": "true"
        },
        ...rest
    }, [
        ...iconNode.map(([tag, attrs])=>(0, $acw62.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]));


const $810dc495bedb1cb1$export$2e2bcd8739ae039 = (iconName, iconNode)=>{
    const Component = (0, $acw62.forwardRef)(({ className: className, ...props }, ref)=>(0, $acw62.createElement)((0, $d2b1338ec3fa0df8$export$2e2bcd8739ae039), {
            ref: ref,
            iconNode: iconNode,
            className: (0, $db42588f972bc829$export$3d46f4579dba46e5)(`lucide-${(0, $db42588f972bc829$export$73bda83cddbc7187)((0, $db42588f972bc829$export$6fb43ff9addf7357)(iconName))}`, `lucide-${iconName}`, className),
            ...props
        }));
    Component.displayName = (0, $db42588f972bc829$export$6fb43ff9addf7357)(iconName);
    return Component;
};


const $0811c1891b547863$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z",
            key: "7g6ntu"
        }
    ],
    [
        "path",
        {
            d: "m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z",
            key: "ijws7r"
        }
    ],
    [
        "path",
        {
            d: "M7 21h10",
            key: "1b0cd5"
        }
    ],
    [
        "path",
        {
            d: "M12 3v18",
            key: "108xh3"
        }
    ],
    [
        "path",
        {
            d: "M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2",
            key: "3gwbw2"
        }
    ]
];
const $0811c1891b547863$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("scale", $0811c1891b547863$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $1eaa8953d6f809f8$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3 6h18",
            key: "d0wm0j"
        }
    ],
    [
        "path",
        {
            d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6",
            key: "4alrt4"
        }
    ],
    [
        "path",
        {
            d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2",
            key: "v07s0e"
        }
    ]
];
const $1eaa8953d6f809f8$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("trash", $1eaa8953d6f809f8$export$3efd853dbb351e94);



var $acw62 = parcelRequire("acw62");
const $2e5fda4b6d357a01$var$radToDeg = (rad)=>rad * 180 / Math.PI;
const $2e5fda4b6d357a01$var$rotate = (v)=>{
    const angle = $2e5fda4b6d357a01$var$radToDeg(Math.atan2(v[1], v[0]));
    return $2e5fda4b6d357a01$var$rebaseAngle(angle);
};
const $2e5fda4b6d357a01$var$matrix2dParsers = {
    x: 4,
    y: 5,
    translateX: 4,
    translateY: 5,
    scaleX: 0,
    scaleY: 3,
    scale: (v)=>(Math.abs(v[0]) + Math.abs(v[3])) / 2,
    rotate: $2e5fda4b6d357a01$var$rotate,
    rotateZ: $2e5fda4b6d357a01$var$rotate,
    skewX: (v)=>$2e5fda4b6d357a01$var$radToDeg(Math.atan(v[1])),
    skewY: (v)=>$2e5fda4b6d357a01$var$radToDeg(Math.atan(v[2])),
    skew: (v)=>(Math.abs(v[1]) + Math.abs(v[2])) / 2
};
const $2e5fda4b6d357a01$var$rebaseAngle = (angle)=>{
    angle = angle % 360;
    if (angle < 0) angle += 360;
    return angle;
};
const $2e5fda4b6d357a01$var$rotateZ = $2e5fda4b6d357a01$var$rotate;
const $2e5fda4b6d357a01$var$scaleX = (v)=>Math.sqrt(v[0] * v[0] + v[1] * v[1]);
const $2e5fda4b6d357a01$var$scaleY = (v)=>Math.sqrt(v[4] * v[4] + v[5] * v[5]);
const $2e5fda4b6d357a01$var$matrix3dParsers = {
    x: 12,
    y: 13,
    z: 14,
    translateX: 12,
    translateY: 13,
    translateZ: 14,
    scaleX: $2e5fda4b6d357a01$var$scaleX,
    scaleY: $2e5fda4b6d357a01$var$scaleY,
    scale: (v)=>($2e5fda4b6d357a01$var$scaleX(v) + $2e5fda4b6d357a01$var$scaleY(v)) / 2,
    rotateX: (v)=>$2e5fda4b6d357a01$var$rebaseAngle($2e5fda4b6d357a01$var$radToDeg(Math.atan2(v[6], v[5]))),
    rotateY: (v)=>$2e5fda4b6d357a01$var$rebaseAngle($2e5fda4b6d357a01$var$radToDeg(Math.atan2(-v[2], v[0]))),
    rotateZ: $2e5fda4b6d357a01$var$rotateZ,
    rotate: $2e5fda4b6d357a01$var$rotateZ,
    skewX: (v)=>$2e5fda4b6d357a01$var$radToDeg(Math.atan(v[4])),
    skewY: (v)=>$2e5fda4b6d357a01$var$radToDeg(Math.atan(v[1])),
    skew: (v)=>(Math.abs(v[1]) + Math.abs(v[4])) / 2
};
function $2e5fda4b6d357a01$export$1f10c01143b9f089(name) {
    return name.includes("scale") ? 1 : 0;
}
function $2e5fda4b6d357a01$export$f9111f9e16b73a26(transform, name) {
    if (!transform || transform === "none") return $2e5fda4b6d357a01$export$1f10c01143b9f089(name);
    const matrix3dMatch = transform.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
    let parsers;
    let match;
    if (matrix3dMatch) {
        parsers = $2e5fda4b6d357a01$var$matrix3dParsers;
        match = matrix3dMatch;
    } else {
        const matrix2dMatch = transform.match(/^matrix\(([-\d.e\s,]+)\)$/u);
        parsers = $2e5fda4b6d357a01$var$matrix2dParsers;
        match = matrix2dMatch;
    }
    if (!match) return $2e5fda4b6d357a01$export$1f10c01143b9f089(name);
    const valueParser = parsers[name];
    const values = match[1].split(",").map($2e5fda4b6d357a01$var$convertTransformToNumber);
    return typeof valueParser === "function" ? valueParser(values) : values[valueParser];
}
const $2e5fda4b6d357a01$export$bcd97e0e03ba17f6 = (instance, name)=>{
    const { transform: transform = "none" } = getComputedStyle(instance);
    return $2e5fda4b6d357a01$export$f9111f9e16b73a26(transform, name);
};
function $2e5fda4b6d357a01$var$convertTransformToNumber(value) {
    return parseFloat(value.trim());
}

const $678aad7e5ff4ee18$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $678aad7e5ff4ee18$export$9de1236619d9e756 = /*@__PURE__*/ $678aad7e5ff4ee18$var$checkStringStartsWith("--");
const $678aad7e5ff4ee18$var$startsAsVariableToken = /*@__PURE__*/ $678aad7e5ff4ee18$var$checkStringStartsWith("var(--");
const $678aad7e5ff4ee18$export$31f9caa2600b5723 = (value)=>{
    const startsWithToken = $678aad7e5ff4ee18$var$startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return $678aad7e5ff4ee18$var$singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const $678aad7e5ff4ee18$var$singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;

/**
 * Generate a list of every possible transform key.
 */ const $807cad0c0e3f2e9a$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $807cad0c0e3f2e9a$export$7b42a0094fb00b6e = /*@__PURE__*/ (()=>new Set($807cad0c0e3f2e9a$export$280dc01950909d86))();


/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $0e0401fe38bd0bd1$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $0e0401fe38bd0bd1$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $0e0401fe38bd0bd1$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}


/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $be9fc9b72a711b93$export$3bb0b4ff1037b8dd = (from, to, progress)=>{
    return from + (to - from) * progress;
};


function $fe0ee806cd19fc1f$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $fe0ee806cd19fc1f$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$fe0ee806cd19fc1f$var$isIdentityScale(scale) || !$fe0ee806cd19fc1f$var$isIdentityScale(scaleX) || !$fe0ee806cd19fc1f$var$isIdentityScale(scaleY);
}
function $fe0ee806cd19fc1f$export$a545127cf1fbb600(values) {
    return $fe0ee806cd19fc1f$export$bdf30dca883ea463(values) || $fe0ee806cd19fc1f$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function $fe0ee806cd19fc1f$export$bf80f5f8f4dc327f(values) {
    return $fe0ee806cd19fc1f$var$is2DTranslate(values.x) || $fe0ee806cd19fc1f$var$is2DTranslate(values.y);
}
function $fe0ee806cd19fc1f$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $d8332eb74969584e$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $d8332eb74969584e$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $d8332eb74969584e$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $d8332eb74969584e$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $d8332eb74969584e$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $d8332eb74969584e$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $d8332eb74969584e$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $d8332eb74969584e$export$d80074982803af5c(box, { x: x, y: y }) {
    $d8332eb74969584e$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $d8332eb74969584e$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
const $d8332eb74969584e$var$TREE_SCALE_SNAP_MIN = 0.999999999999;
const $d8332eb74969584e$var$TREE_SCALE_SNAP_MAX = 1.0000000000001;
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $d8332eb74969584e$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const { visualElement: visualElement } = node.options;
        if (visualElement && visualElement.props.style && visualElement.props.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $d8332eb74969584e$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $d8332eb74969584e$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(node.latestValues)) $d8332eb74969584e$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ if (treeScale.x < $d8332eb74969584e$var$TREE_SCALE_SNAP_MAX && treeScale.x > $d8332eb74969584e$var$TREE_SCALE_SNAP_MIN) treeScale.x = 1.0;
    if (treeScale.y < $d8332eb74969584e$var$TREE_SCALE_SNAP_MAX && treeScale.y > $d8332eb74969584e$var$TREE_SCALE_SNAP_MIN) treeScale.y = 1.0;
}
function $d8332eb74969584e$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $d8332eb74969584e$export$625f1dd140a2f5e7(axis, axisTranslate, axisScale, boxScale, axisOrigin = 0.5) {
    const originPoint = (0, $be9fc9b72a711b93$export$3bb0b4ff1037b8dd)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $d8332eb74969584e$export$e8e3a712e9ebf422(axis, axisTranslate, axisScale, originPoint, boxScale);
}
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $d8332eb74969584e$export$58b16271041fbfb(box, transform) {
    $d8332eb74969584e$export$625f1dd140a2f5e7(box.x, transform.x, transform.scaleX, transform.scale, transform.originX);
    $d8332eb74969584e$export$625f1dd140a2f5e7(box.y, transform.y, transform.scaleY, transform.scale, transform.originY);
}


function $4ca2f8055771ddf4$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $0e0401fe38bd0bd1$export$d3955c6a8f65a36b)((0, $0e0401fe38bd0bd1$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $4ca2f8055771ddf4$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $4ca2f8055771ddf4$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}



const $994004d9eac5e5b8$export$c66c0d5db2a205d = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    ...(0, $807cad0c0e3f2e9a$export$280dc01950909d86)
]);


/**
 * ValueType for "auto"
 */ const $2ee423ae5df5dfb8$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};


const $10aeec2c389b2314$export$7d15b64cf5a3a4c4 = (min, max, v)=>{
    if (v > max) return max;
    if (v < min) return min;
    return v;
};


const $37373b26cbe35eee$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $37373b26cbe35eee$export$58f0f39f63f3cf42 = {
    ...$37373b26cbe35eee$export$98e628dec113755e,
    transform: (v)=>(0, $10aeec2c389b2314$export$7d15b64cf5a3a4c4)(0, 1, v)
};
const $37373b26cbe35eee$export$dcdf75081b88279d = {
    ...$37373b26cbe35eee$export$98e628dec113755e,
    default: 1
};


/*#__NO_SIDE_EFFECTS__*/ const $8b3d385d4c2e0df7$var$createUnitType = (unit)=>({
        test: (v)=>typeof v === "string" && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $8b3d385d4c2e0df7$export$41fc368e1a942b97 = /*@__PURE__*/ $8b3d385d4c2e0df7$var$createUnitType("deg");
const $8b3d385d4c2e0df7$export$626336c2cd4b14de = /*@__PURE__*/ $8b3d385d4c2e0df7$var$createUnitType("%");
const $8b3d385d4c2e0df7$export$91c0eda1d06bf008 = /*@__PURE__*/ $8b3d385d4c2e0df7$var$createUnitType("px");
const $8b3d385d4c2e0df7$export$f91e8c45a95a32f2 = /*@__PURE__*/ $8b3d385d4c2e0df7$var$createUnitType("vh");
const $8b3d385d4c2e0df7$export$aed3d7b7d206c196 = /*@__PURE__*/ $8b3d385d4c2e0df7$var$createUnitType("vw");
const $8b3d385d4c2e0df7$export$44e2e1705876d7ed = /*@__PURE__*/ (()=>({
        ...$8b3d385d4c2e0df7$export$626336c2cd4b14de,
        parse: (v)=>$8b3d385d4c2e0df7$export$626336c2cd4b14de.parse(v) / 100,
        transform: (v)=>$8b3d385d4c2e0df7$export$626336c2cd4b14de.transform(v * 100)
    }))();


/**
 * Tests a provided value against a ValueType
 */ const $0fc168331a7653d5$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * A list of value types commonly used for dimensions
 */ const $38b8cc3c59925225$export$d176691c1998a1f5 = [
    (0, $37373b26cbe35eee$export$98e628dec113755e),
    (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008),
    (0, $8b3d385d4c2e0df7$export$626336c2cd4b14de),
    (0, $8b3d385d4c2e0df7$export$41fc368e1a942b97),
    (0, $8b3d385d4c2e0df7$export$aed3d7b7d206c196),
    (0, $8b3d385d4c2e0df7$export$f91e8c45a95a32f2),
    (0, $2ee423ae5df5dfb8$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $38b8cc3c59925225$export$eefdd52e3ccae428 = (v)=>$38b8cc3c59925225$export$d176691c1998a1f5.find((0, $0fc168331a7653d5$export$6eae4d0a6a7ca7cd)(v));


function $1021d431e8520e64$export$5201d50a34753d71(message, errorCode) {
    return errorCode ? `${message}. For more information and steps for solving, visit https://motion.dev/troubleshooting/${errorCode}` : message;
}


let $fbe9f318b7b09044$export$491112666e282270 = ()=>{};
let $fbe9f318b7b09044$export$f5708dca728d7177 = ()=>{};
$fbe9f318b7b09044$export$491112666e282270 = (check, message, errorCode)=>{
    if (!check && typeof console !== "undefined") console.warn((0, $1021d431e8520e64$export$5201d50a34753d71)(message, errorCode));
};
$fbe9f318b7b09044$export$f5708dca728d7177 = (check, message, errorCode)=>{
    if (!check) throw new Error((0, $1021d431e8520e64$export$5201d50a34753d71)(message, errorCode));
};

/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $dd4e99dc1119eedf$export$65583ed5a868f2d9 = (v)=>/^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);



/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $e2fa456e7a85d1af$var$splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
/^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function $e2fa456e7a85d1af$export$b9f0c1f373aee2b0(current) {
    const match = $e2fa456e7a85d1af$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token1, token2, fallback] = match;
    return [
        `--${token1 ?? token2}`,
        fallback
    ];
}
const $e2fa456e7a85d1af$var$maxDepth = 4;
function $e2fa456e7a85d1af$export$289398774300c991(current, element, depth = 1) {
    (0, $fbe9f318b7b09044$export$f5708dca728d7177)(depth <= $e2fa456e7a85d1af$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`, "max-css-var-depth");
    const [token, fallback] = $e2fa456e7a85d1af$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $dd4e99dc1119eedf$export$65583ed5a868f2d9)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, $678aad7e5ff4ee18$export$31f9caa2600b5723)(fallback) ? $e2fa456e7a85d1af$export$289398774300c991(fallback, element, depth + 1) : fallback;
}



function $a03d40a1c5528569$export$5a98a90409277f5a(keyframes) {
    for(let i = 1; i < keyframes.length; i++)keyframes[i] ?? (keyframes[i] = keyframes[i - 1]);
}






const $9a979bb9539357a9$export$8e5250d1aa9bf370 = (v)=>v === (0, $37373b26cbe35eee$export$98e628dec113755e) || v === (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008);
const $9a979bb9539357a9$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $9a979bb9539357a9$var$nonTranslationalTransformKeys = (0, $807cad0c0e3f2e9a$export$280dc01950909d86).filter((key)=>!$9a979bb9539357a9$var$transformKeys.has(key));
function $9a979bb9539357a9$export$39d4bc9655f3f632(visualElement) {
    const removedTransforms = [];
    $9a979bb9539357a9$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
const $9a979bb9539357a9$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: (_bbox, { transform: transform })=>(0, $2e5fda4b6d357a01$export$f9111f9e16b73a26)(transform, "x"),
    y: (_bbox, { transform: transform })=>(0, $2e5fda4b6d357a01$export$f9111f9e16b73a26)(transform, "y")
};
// Alias translate longform names
$9a979bb9539357a9$export$781d46a8aa670d52.translateX = $9a979bb9539357a9$export$781d46a8aa670d52.x;
$9a979bb9539357a9$export$781d46a8aa670d52.translateY = $9a979bb9539357a9$export$781d46a8aa670d52.y;


/*#__NO_SIDE_EFFECTS__*/ const $d6ca2382cab65984$export$8793edee2d425525 = (any)=>any;


const $502ec5afb929f350$export$dd826089e3c5e502 = {};


const $66df8db352cf3b40$export$71ecace0a033b35a = [
    "setup",
    "read",
    "resolveKeyframes",
    "preUpdate",
    "update",
    "preRender",
    "render",
    "postRender"
];


const $047730deae5140b7$export$84ce9a476f53d110 = {
    value: null,
    addProjectionMetrics: null
};


function $4e564ba785217323$export$b995e5e85f5c8289(runNextFrame, stepName) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new Set();
    let nextFrame = new Set();
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    let latestFrameData = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    let numCalls = 0;
    function triggerCallback(callback) {
        if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
        }
        numCalls++;
        callback(latestFrameData);
    }
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (!queue.has(callback)) queue.add(callback);
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.delete(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            latestFrameData = frameData;
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Execute this frame
            thisFrame.forEach(triggerCallback);
            /**
             * If we're recording stats then
             */ if (stepName && (0, $047730deae5140b7$export$84ce9a476f53d110).value) (0, $047730deae5140b7$export$84ce9a476f53d110).value.frameloop[stepName].push(numCalls);
            numCalls = 0;
            // Clear the frame so no callbacks remain. This is to avoid
            // memory leaks should this render step not run for a while.
            thisFrame.clear();
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $91fcd7686044c7e0$var$maxElapsed = 40;
function $91fcd7686044c7e0$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    const flagRunNextFrame = ()=>runNextFrame = true;
    const steps = (0, $66df8db352cf3b40$export$71ecace0a033b35a).reduce((acc, key)=>{
        acc[key] = (0, $4e564ba785217323$export$b995e5e85f5c8289)(flagRunNextFrame, allowKeepAlive ? key : undefined);
        return acc;
    }, {});
    const { setup: setup, read: read, resolveKeyframes: resolveKeyframes, preUpdate: preUpdate, update: update, preRender: preRender, render: render, postRender: postRender } = steps;
    const processBatch = ()=>{
        const timestamp = (0, $502ec5afb929f350$export$dd826089e3c5e502).useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        if (!(0, $502ec5afb929f350$export$dd826089e3c5e502).useManualTiming) state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $91fcd7686044c7e0$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        // Unrolled render loop for better per-frame performance
        setup.process(state);
        read.process(state);
        resolveKeyframes.process(state);
        preUpdate.process(state);
        update.process(state);
        preRender.process(state);
        render.process(state);
        postRender.process(state);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = (0, $66df8db352cf3b40$export$71ecace0a033b35a).reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>{
        for(let i = 0; i < (0, $66df8db352cf3b40$export$71ecace0a033b35a).length; i++)steps[(0, $66df8db352cf3b40$export$71ecace0a033b35a)[i]].cancel(process);
    };
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}


const { schedule: $1fc179758a6fb1d9$export$2cef06c20297c17d, cancel: $1fc179758a6fb1d9$export$ec99c0ef4978dccb, state: $1fc179758a6fb1d9$export$fff89137e9e818ce, steps: $1fc179758a6fb1d9$export$1811c3a7e3af92f0 } = /* @__PURE__ */ (0, $91fcd7686044c7e0$export$510b0596a933801a)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $d6ca2382cab65984$export$8793edee2d425525), true);


const $c982fbe82ecf7d0b$var$toResolve = new Set();
let $c982fbe82ecf7d0b$var$isScheduled = false;
let $c982fbe82ecf7d0b$var$anyNeedsMeasurement = false;
let $c982fbe82ecf7d0b$var$isForced = false;
function $c982fbe82ecf7d0b$var$measureAllKeyframes() {
    if ($c982fbe82ecf7d0b$var$anyNeedsMeasurement) {
        const resolversToMeasure = Array.from($c982fbe82ecf7d0b$var$toResolve).filter((resolver)=>resolver.needsMeasurement);
        const elementsToMeasure = new Set(resolversToMeasure.map((resolver)=>resolver.element));
        const transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach((element)=>{
            const removedTransforms = (0, $9a979bb9539357a9$export$39d4bc9655f3f632)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureInitialState());
        // Write
        elementsToMeasure.forEach((element)=>{
            element.render();
            const restore = transformsToRestore.get(element);
            if (restore) restore.forEach(([key, value])=>{
                element.getValue(key)?.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureEndState());
        // Write
        resolversToMeasure.forEach((resolver)=>{
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    $c982fbe82ecf7d0b$var$anyNeedsMeasurement = false;
    $c982fbe82ecf7d0b$var$isScheduled = false;
    $c982fbe82ecf7d0b$var$toResolve.forEach((resolver)=>resolver.complete($c982fbe82ecf7d0b$var$isForced));
    $c982fbe82ecf7d0b$var$toResolve.clear();
}
function $c982fbe82ecf7d0b$var$readAllKeyframes() {
    $c982fbe82ecf7d0b$var$toResolve.forEach((resolver)=>{
        resolver.readKeyframes();
        if (resolver.needsMeasurement) $c982fbe82ecf7d0b$var$anyNeedsMeasurement = true;
    });
}
function $c982fbe82ecf7d0b$export$78b96d2a12593b05() {
    $c982fbe82ecf7d0b$var$isForced = true;
    $c982fbe82ecf7d0b$var$readAllKeyframes();
    $c982fbe82ecf7d0b$var$measureAllKeyframes();
    $c982fbe82ecf7d0b$var$isForced = false;
}
class $c982fbe82ecf7d0b$export$74d34ca3182f1750 {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element, isAsync = false){
        this.state = "pending";
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        this.unresolvedKeyframes = [
            ...unresolvedKeyframes
        ];
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
    scheduleResolve() {
        this.state = "scheduled";
        if (this.isAsync) {
            $c982fbe82ecf7d0b$var$toResolve.add(this);
            if (!$c982fbe82ecf7d0b$var$isScheduled) {
                $c982fbe82ecf7d0b$var$isScheduled = true;
                (0, $1fc179758a6fb1d9$export$2cef06c20297c17d).read($c982fbe82ecf7d0b$var$readAllKeyframes);
                (0, $1fc179758a6fb1d9$export$2cef06c20297c17d).resolveKeyframes($c982fbe82ecf7d0b$var$measureAllKeyframes);
            }
        } else {
            this.readKeyframes();
            this.complete();
        }
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name, element: element, motionValue: motionValue } = this;
        // If initial keyframe is null we need to read it from the DOM
        if (unresolvedKeyframes[0] === null) {
            const currentValue = motionValue?.get();
            // TODO: This doesn't work if the final keyframe is a wildcard
            const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
            if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
            else if (element && name) {
                const valueAsRead = element.readValue(name, finalKeyframe);
                if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
            }
            if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
            if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
        }
        (0, $a03d40a1c5528569$export$5a98a90409277f5a)(unresolvedKeyframes);
    }
    setFinalKeyframe() {}
    measureInitialState() {}
    renderEndStyles() {}
    measureEndState() {}
    complete(isForcedComplete = false) {
        this.state = "complete";
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, isForcedComplete);
        $c982fbe82ecf7d0b$var$toResolve.delete(this);
    }
    cancel() {
        if (this.state === "scheduled") {
            $c982fbe82ecf7d0b$var$toResolve.delete(this);
            this.state = "pending";
        }
    }
    resume() {
        if (this.state === "pending") this.scheduleResolve();
    }
}


/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $5596943de35d27aa$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/u.test(v);


function $b9a4b56ecadb00d1$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $5596943de35d27aa$export$ade84c85e44a6cb1)(value);
    else return true;
}




// If this number is a decimal, make it just five decimal places
// to avoid exponents
const $98f6b3dbac10614b$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;


const $f3bb76c29dbc041e$export$2444ca58c08448e4 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;


function $3ac44f15ee71e14d$export$b931b78cbb3caf86(v) {
    return v == null;
}


const $55ebaaf5b0d89adb$export$ed808ff6ecd39e8d = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;


/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $6a88d7d64279210a$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean(typeof v === "string" && (0, $55ebaaf5b0d89adb$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && !(0, $3ac44f15ee71e14d$export$b931b78cbb3caf86)(v) && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $6a88d7d64279210a$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (typeof v !== "string") return v;
        const [a, b, c, alpha] = v.match((0, $f3bb76c29dbc041e$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $5a3ee899e2525965$var$clampRgbUnit = (v)=>(0, $10aeec2c389b2314$export$7d15b64cf5a3a4c4)(0, 255, v);
const $5a3ee899e2525965$export$7a99c86b5b1f4c9e = {
    ...(0, $37373b26cbe35eee$export$98e628dec113755e),
    transform: (v)=>Math.round($5a3ee899e2525965$var$clampRgbUnit(v))
};
const $5a3ee899e2525965$export$4e46ac54fc82cf3b = {
    test: /*@__PURE__*/ (0, $6a88d7d64279210a$export$2c8400d58aca05e)("rgb", "red"),
    parse: /*@__PURE__*/ (0, $6a88d7d64279210a$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $5a3ee899e2525965$export$7a99c86b5b1f4c9e.transform(red) + ", " + $5a3ee899e2525965$export$7a99c86b5b1f4c9e.transform(green) + ", " + $5a3ee899e2525965$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $98f6b3dbac10614b$export$83d2e9e3e4ee39ed)((0, $37373b26cbe35eee$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $77fb23ad025cd7f6$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $77fb23ad025cd7f6$export$834dfc94dde4b3d8 = {
    test: /*@__PURE__*/ (0, $6a88d7d64279210a$export$2c8400d58aca05e)("#"),
    parse: $77fb23ad025cd7f6$var$parseHex,
    transform: (0, $5a3ee899e2525965$export$4e46ac54fc82cf3b).transform
};






const $86db837a393ca21c$export$810b04175080204c = {
    test: /*@__PURE__*/ (0, $6a88d7d64279210a$export$2c8400d58aca05e)("hsl", "hue"),
    parse: /*@__PURE__*/ (0, $6a88d7d64279210a$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $8b3d385d4c2e0df7$export$626336c2cd4b14de).transform((0, $98f6b3dbac10614b$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $8b3d385d4c2e0df7$export$626336c2cd4b14de).transform((0, $98f6b3dbac10614b$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $98f6b3dbac10614b$export$83d2e9e3e4ee39ed)((0, $37373b26cbe35eee$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $c735af09100d3b88$export$35e9368ef982300f = {
    test: (v)=>(0, $5a3ee899e2525965$export$4e46ac54fc82cf3b).test(v) || (0, $77fb23ad025cd7f6$export$834dfc94dde4b3d8).test(v) || (0, $86db837a393ca21c$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $5a3ee899e2525965$export$4e46ac54fc82cf3b).test(v)) return (0, $5a3ee899e2525965$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $86db837a393ca21c$export$810b04175080204c).test(v)) return (0, $86db837a393ca21c$export$810b04175080204c).parse(v);
        else return (0, $77fb23ad025cd7f6$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return typeof v === "string" ? v : v.hasOwnProperty("red") ? (0, $5a3ee899e2525965$export$4e46ac54fc82cf3b).transform(v) : (0, $86db837a393ca21c$export$810b04175080204c).transform(v);
    },
    getAnimatableNone: (v)=>{
        const parsed = $c735af09100d3b88$export$35e9368ef982300f.parse(v);
        parsed.alpha = 0;
        return $c735af09100d3b88$export$35e9368ef982300f.transform(parsed);
    }
};


const $2502384e0ada1f54$export$740b69c5fad25dba = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;




function $1c1147c837df3766$var$test(v) {
    return isNaN(v) && typeof v === "string" && (v.match((0, $f3bb76c29dbc041e$export$2444ca58c08448e4))?.length || 0) + (v.match((0, $2502384e0ada1f54$export$740b69c5fad25dba))?.length || 0) > 0;
}
const $1c1147c837df3766$var$NUMBER_TOKEN = "number";
const $1c1147c837df3766$var$COLOR_TOKEN = "color";
const $1c1147c837df3766$var$VAR_TOKEN = "var";
const $1c1147c837df3766$var$VAR_FUNCTION_TOKEN = "var(";
const $1c1147c837df3766$var$SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const $1c1147c837df3766$var$complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function $1c1147c837df3766$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const values = [];
    const indexes = {
        color: [],
        number: [],
        var: []
    };
    const types = [];
    let i = 0;
    const tokenised = originalValue.replace($1c1147c837df3766$var$complexRegex, (parsedValue)=>{
        if ((0, $c735af09100d3b88$export$35e9368ef982300f).test(parsedValue)) {
            indexes.color.push(i);
            types.push($1c1147c837df3766$var$COLOR_TOKEN);
            values.push((0, $c735af09100d3b88$export$35e9368ef982300f).parse(parsedValue));
        } else if (parsedValue.startsWith($1c1147c837df3766$var$VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push($1c1147c837df3766$var$VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push($1c1147c837df3766$var$NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return $1c1147c837df3766$var$SPLIT_TOKEN;
    });
    const split = tokenised.split($1c1147c837df3766$var$SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function $1c1147c837df3766$var$parseComplexValue(v) {
    return $1c1147c837df3766$export$b61fc7c44bf646d5(v).values;
}
function $1c1147c837df3766$var$createTransformer(source) {
    const { split: split, types: types } = $1c1147c837df3766$export$b61fc7c44bf646d5(source);
    const numSections = split.length;
    return (v)=>{
        let output = "";
        for(let i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                const type = types[i];
                if (type === $1c1147c837df3766$var$NUMBER_TOKEN) output += (0, $98f6b3dbac10614b$export$83d2e9e3e4ee39ed)(v[i]);
                else if (type === $1c1147c837df3766$var$COLOR_TOKEN) output += (0, $c735af09100d3b88$export$35e9368ef982300f).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
const $1c1147c837df3766$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : (0, $c735af09100d3b88$export$35e9368ef982300f).test(v) ? (0, $c735af09100d3b88$export$35e9368ef982300f).getAnimatableNone(v) : v;
function $1c1147c837df3766$var$getAnimatableNone(v) {
    const parsed = $1c1147c837df3766$var$parseComplexValue(v);
    const transformer = $1c1147c837df3766$var$createTransformer(v);
    return transformer(parsed.map($1c1147c837df3766$var$convertNumbersToZero));
}
const $1c1147c837df3766$export$83a0e34f1302825b = {
    test: $1c1147c837df3766$var$test,
    parse: $1c1147c837df3766$var$parseComplexValue,
    createTransformer: $1c1147c837df3766$var$createTransformer,
    getAnimatableNone: $1c1147c837df3766$var$getAnimatableNone
};





/**
 * Properties that should default to 1 or 100%
 */ const $64fbfad81d3aa279$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $64fbfad81d3aa279$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $f3bb76c29dbc041e$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $64fbfad81d3aa279$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $64fbfad81d3aa279$var$functionRegex = /\b([a-z-]*)\(.*?\)/gu;
const $64fbfad81d3aa279$export$3dea766d36a8935f = {
    ...(0, $1c1147c837df3766$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const functions = v.match($64fbfad81d3aa279$var$functionRegex);
        return functions ? functions.map($64fbfad81d3aa279$var$applyDefaultFilter).join(" ") : v;
    }
};





const $32337cd3ec64b6c7$export$7d260a2a5f8bc19e = {
    ...(0, $37373b26cbe35eee$export$98e628dec113755e),
    transform: Math.round
};






const $231f44288eb820da$export$f2e4285fee37e26 = {
    rotate: (0, $8b3d385d4c2e0df7$export$41fc368e1a942b97),
    rotateX: (0, $8b3d385d4c2e0df7$export$41fc368e1a942b97),
    rotateY: (0, $8b3d385d4c2e0df7$export$41fc368e1a942b97),
    rotateZ: (0, $8b3d385d4c2e0df7$export$41fc368e1a942b97),
    scale: $37373b26cbe35eee$export$dcdf75081b88279d,
    scaleX: (0, $37373b26cbe35eee$export$dcdf75081b88279d),
    scaleY: (0, $37373b26cbe35eee$export$dcdf75081b88279d),
    scaleZ: (0, $37373b26cbe35eee$export$dcdf75081b88279d),
    skew: (0, $8b3d385d4c2e0df7$export$41fc368e1a942b97),
    skewX: (0, $8b3d385d4c2e0df7$export$41fc368e1a942b97),
    skewY: (0, $8b3d385d4c2e0df7$export$41fc368e1a942b97),
    distance: (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008),
    translateX: (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008),
    translateY: (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008),
    translateZ: (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008),
    x: (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008),
    y: (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008),
    z: (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008),
    perspective: (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008),
    transformPerspective: (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008),
    opacity: (0, $37373b26cbe35eee$export$58f0f39f63f3cf42),
    originX: (0, $8b3d385d4c2e0df7$export$44e2e1705876d7ed),
    originY: (0, $8b3d385d4c2e0df7$export$44e2e1705876d7ed),
    originZ: (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008)
};


const $600744ecb436af48$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008),
    borderTopWidth: (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008),
    borderRightWidth: (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008),
    borderRadius: (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008),
    radius: (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008),
    maxWidth: (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008),
    height: (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008),
    maxHeight: (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008),
    top: (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008),
    right: (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008),
    bottom: (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008),
    left: (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008),
    paddingTop: (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008),
    paddingRight: (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008),
    paddingBottom: (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008),
    paddingLeft: (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008),
    margin: (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008),
    marginTop: (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008),
    marginRight: (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008),
    marginBottom: (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008),
    marginLeft: (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008),
    // Misc
    backgroundPositionX: (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008),
    backgroundPositionY: (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008),
    ...(0, $231f44288eb820da$export$f2e4285fee37e26),
    zIndex: (0, $32337cd3ec64b6c7$export$7d260a2a5f8bc19e),
    // SVG
    fillOpacity: (0, $37373b26cbe35eee$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $37373b26cbe35eee$export$58f0f39f63f3cf42),
    numOctaves: (0, $32337cd3ec64b6c7$export$7d260a2a5f8bc19e)
};


/**
 * A map of default value types for common values
 */ const $f3598fc4cf1ed189$export$98cd7c72c5a731fb = {
    ...(0, $600744ecb436af48$export$eec14432cd1cb67b),
    color: // Color props
    $c735af09100d3b88$export$35e9368ef982300f,
    backgroundColor: (0, $c735af09100d3b88$export$35e9368ef982300f),
    outlineColor: (0, $c735af09100d3b88$export$35e9368ef982300f),
    fill: (0, $c735af09100d3b88$export$35e9368ef982300f),
    stroke: (0, $c735af09100d3b88$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $c735af09100d3b88$export$35e9368ef982300f),
    borderTopColor: (0, $c735af09100d3b88$export$35e9368ef982300f),
    borderRightColor: (0, $c735af09100d3b88$export$35e9368ef982300f),
    borderBottomColor: (0, $c735af09100d3b88$export$35e9368ef982300f),
    borderLeftColor: (0, $c735af09100d3b88$export$35e9368ef982300f),
    filter: $64fbfad81d3aa279$export$3dea766d36a8935f,
    WebkitFilter: (0, $64fbfad81d3aa279$export$3dea766d36a8935f)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $f3598fc4cf1ed189$export$67d1babe0338d23b = (key)=>$f3598fc4cf1ed189$export$98cd7c72c5a731fb[key];


function $e809d8b3dcab66da$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $f3598fc4cf1ed189$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $64fbfad81d3aa279$export$3dea766d36a8935f)) defaultValueType = (0, $1c1147c837df3766$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}


/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ const $7ed6256f87abca74$var$invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function $7ed6256f87abca74$export$8cc4958f8e540f37(unresolvedKeyframes, noneKeyframeIndexes, name) {
    let i = 0;
    let animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        const keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !$7ed6256f87abca74$var$invalidTemplates.has(keyframe) && (0, $1c1147c837df3766$export$b61fc7c44bf646d5)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    if (animatableTemplate && name) for (const noneIndex of noneKeyframeIndexes)unresolvedKeyframes[noneIndex] = (0, $e809d8b3dcab66da$export$cea0cedcb94873b5)(name, animatableTemplate);
}



class $8a248eab473b7981$export$4983792d11b61017 extends (0, $c982fbe82ecf7d0b$export$74d34ca3182f1750) {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element){
        super(unresolvedKeyframes, onComplete, name, motionValue, element, true);
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, element: element, name: name } = this;
        if (!element || !element.current) return;
        super.readKeyframes();
        /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(let i = 0; i < unresolvedKeyframes.length; i++){
            let keyframe = unresolvedKeyframes[i];
            if (typeof keyframe === "string") {
                keyframe = keyframe.trim();
                if ((0, $678aad7e5ff4ee18$export$31f9caa2600b5723)(keyframe)) {
                    const resolved = (0, $e2fa456e7a85d1af$export$289398774300c991)(keyframe, element.current);
                    if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                    if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                }
            }
        }
        /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
        /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, $994004d9eac5e5b8$export$c66c0d5db2a205d).has(name) || unresolvedKeyframes.length !== 2) return;
        const [origin, target] = unresolvedKeyframes;
        const originType = (0, $38b8cc3c59925225$export$eefdd52e3ccae428)(origin);
        const targetType = (0, $38b8cc3c59925225$export$eefdd52e3ccae428)(target);
        /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
        /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, $9a979bb9539357a9$export$8e5250d1aa9bf370)(originType) && (0, $9a979bb9539357a9$export$8e5250d1aa9bf370)(targetType)) for(let i = 0; i < unresolvedKeyframes.length; i++){
            const value = unresolvedKeyframes[i];
            if (typeof value === "string") unresolvedKeyframes[i] = parseFloat(value);
        }
        else if ((0, $9a979bb9539357a9$export$781d46a8aa670d52)[name]) /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
    }
    resolveNoneKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        const noneKeyframeIndexes = [];
        for(let i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null || (0, $b9a4b56ecadb00d1$export$e56af863d5645d5f)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
        if (noneKeyframeIndexes.length) (0, $7ed6256f87abca74$export$8cc4958f8e540f37)(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
    measureInitialState() {
        const { element: element, unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        if (!element || !element.current) return;
        if (name === "height") this.suspendedScrollY = window.pageYOffset;
        this.measuredOrigin = (0, $9a979bb9539357a9$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        unresolvedKeyframes[0] = this.measuredOrigin;
        // Set final key frame to measure after next render
        const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
        if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
    measureEndState() {
        const { element: element, name: name, unresolvedKeyframes: unresolvedKeyframes } = this;
        if (!element || !element.current) return;
        const value = element.getValue(name);
        value && value.jump(this.measuredOrigin, false);
        const finalKeyframeIndex = unresolvedKeyframes.length - 1;
        const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
        unresolvedKeyframes[finalKeyframeIndex] = (0, $9a979bb9539357a9$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
        // If we removed transform values, reapply them before the next render
        if (this.removedTransforms?.length) this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue])=>{
            element.getValue(unsetTransformName).set(unsetTransformValue);
        });
        this.resolveNoneKeyframes();
    }
}

const $eadb4e7ad13d3244$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);






/**
 * A list of all ValueTypes
 */ const $79a3d08b7950b39a$var$valueTypes = [
    ...(0, $38b8cc3c59925225$export$d176691c1998a1f5),
    (0, $c735af09100d3b88$export$35e9368ef982300f),
    (0, $1c1147c837df3766$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $79a3d08b7950b39a$export$950e7e59ea1ffed7 = (v)=>$79a3d08b7950b39a$var$valueTypes.find((0, $0fc168331a7653d5$export$6eae4d0a6a7ca7cd)(v));


const { schedule: $2ea51e08c4a70f38$export$bb76eed83315504c, cancel: $2ea51e08c4a70f38$export$3252729004b8456e } = /* @__PURE__ */ (0, $91fcd7686044c7e0$export$510b0596a933801a)(queueMicrotask, false);

function $7b6ce60ba01b86f0$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $7b6ce60ba01b86f0$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $7b6ce60ba01b86f0$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


class $ee5d55ee4695ef73$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $7b6ce60ba01b86f0$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $7b6ce60ba01b86f0$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}

/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $50d2e38bc0676790$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}


const $6e5dff638919bf7c$var$warned = new Set();
function $6e5dff638919bf7c$export$1adc410501177663(message) {
    return $6e5dff638919bf7c$var$warned.has(message);
}
function $6e5dff638919bf7c$export$5b28268982f175ba(condition, message, errorCode) {
    if (condition || $6e5dff638919bf7c$var$warned.has(message)) return;
    console.warn((0, $1021d431e8520e64$export$5201d50a34753d71)(message, errorCode));
    $6e5dff638919bf7c$var$warned.add(message);
}




let $fa7790817f905603$var$now;
function $fa7790817f905603$var$clearTime() {
    $fa7790817f905603$var$now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ const $fa7790817f905603$export$2da9be4cfdb689b1 = {
    now: ()=>{
        if ($fa7790817f905603$var$now === undefined) $fa7790817f905603$export$2da9be4cfdb689b1.set((0, $1fc179758a6fb1d9$export$fff89137e9e818ce).isProcessing || (0, $502ec5afb929f350$export$dd826089e3c5e502).useManualTiming ? (0, $1fc179758a6fb1d9$export$fff89137e9e818ce).timestamp : performance.now());
        return $fa7790817f905603$var$now;
    },
    set: (newTime)=>{
        $fa7790817f905603$var$now = newTime;
        queueMicrotask($fa7790817f905603$var$clearTime);
    }
};



/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ const $61b3ffa62977d1fd$var$MAX_VELOCITY_DELTA = 30;
const $61b3ffa62977d1fd$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $61b3ffa62977d1fd$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $61b3ffa62977d1fd$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     */ constructor(init, options = {}){
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v)=>{
            const currentTime = (0, $fa7790817f905603$export$2da9be4cfdb689b1).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (this.updatedAt !== currentTime) this.setPrevFrameValue();
            this.prev = this.current;
            this.setCurrent(v);
            // Update update subscribers
            if (this.current !== this.prev) {
                this.events.change?.notify(this.current);
                if (this.dependents) for (const dependent of this.dependents)dependent.dirty();
            }
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
    setCurrent(current) {
        this.current = current;
        this.updatedAt = (0, $fa7790817f905603$export$2da9be4cfdb689b1).now();
        if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = $61b3ffa62977d1fd$var$isFloat(this.current);
    }
    setPrevFrameValue(prevFrameValue = this.current) {
        this.prevFrameValue = prevFrameValue;
        this.prevUpdatedAt = this.updatedAt;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        (0, $6e5dff638919bf7c$export$5b28268982f175ba)(false, `value.onChange(callback) is deprecated. Switch to value.on("change", callback).`);
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $ee5d55ee4695ef73$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $1fc179758a6fb1d9$export$2cef06c20297c17d).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v) {
        if (!this.passiveEffect) this.updateAndNotify(v);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = undefined;
        this.prevFrameValue = prev;
        this.prevUpdatedAt = this.updatedAt - delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v, endAnimation = true) {
        this.updateAndNotify(v);
        this.prev = v;
        this.prevUpdatedAt = this.prevFrameValue = undefined;
        endAnimation && this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    dirty() {
        this.events.change?.notify(this.current);
    }
    addDependent(dependent) {
        if (!this.dependents) this.dependents = new Set();
        this.dependents.add(dependent);
    }
    removeDependent(dependent) {
        if (this.dependents) this.dependents.delete(dependent);
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($61b3ffa62977d1fd$export$67fcd818a264039d.current) $61b3ffa62977d1fd$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        const currentTime = (0, $fa7790817f905603$export$2da9be4cfdb689b1).now();
        if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > $61b3ffa62977d1fd$var$MAX_VELOCITY_DELTA) return 0;
        const delta = Math.min(this.updatedAt - this.prevUpdatedAt, $61b3ffa62977d1fd$var$MAX_VELOCITY_DELTA);
        // Casts because of parseFloat's poor typing
        return (0, $50d2e38bc0676790$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.dependents?.clear();
        this.events.destroy?.notify();
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $61b3ffa62977d1fd$export$ce8bdc721e76545f(init, options) {
    return new $61b3ffa62977d1fd$export$8cea36d14ee64562(init, options);
}



const $a8d82256030e9525$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $a8d82256030e9525$export$65570e08d843624d = {};
for(const key in $a8d82256030e9525$var$featureProps)$a8d82256030e9525$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$a8d82256030e9525$var$featureProps[key].some((name)=>!!props[name])
};


const $a3727e4e12b23353$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $a3727e4e12b23353$export$3d227df54007d73a = ()=>({
        x: $a3727e4e12b23353$export$ff25708b37f72782(),
        y: $a3727e4e12b23353$export$ff25708b37f72782()
    });
const $a3727e4e12b23353$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $a3727e4e12b23353$export$6459fc9e86be362e = ()=>({
        x: $a3727e4e12b23353$export$6db76765312617ac(),
        y: $a3727e4e12b23353$export$6db76765312617ac()
    });


const $784730508f12f72c$export$4e09c449d6c407f7 = typeof window !== "undefined";


// Does this device prefer reduced motion? Returns `null` server-side.
const $5d1c3a7750a03ec7$export$ff7706047246b98b = {
    current: null
};
const $5d1c3a7750a03ec7$export$6476d16e2fd2d0db = {
    current: false
};


function $402b11b96c54cb2c$export$ca9f41fb23dded3d() {
    (0, $5d1c3a7750a03ec7$export$6476d16e2fd2d0db).current = true;
    if (!(0, $784730508f12f72c$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $5d1c3a7750a03ec7$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addEventListener("change", setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $5d1c3a7750a03ec7$export$ff7706047246b98b).current = false;
}



const $a4ccbde0d696dfdf$export$bc2a978a17abfdde = new WeakMap();


function $1e5344c7f0db9c8f$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}


/**
 * Decides if the supplied variable is variant label
 */ function $a35be4d5814e7c66$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


const $0172fb3d3512f551$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $0172fb3d3512f551$export$1405a65085f40b9 = [
    "initial",
    ...$0172fb3d3512f551$export$16e45afcc206d3a8
];


function $06b1046bf0f33e63$export$4b3c3bd8d910d78d(props) {
    return (0, $1e5344c7f0db9c8f$export$aa71198ceeaf53ce)(props.animate) || (0, $0172fb3d3512f551$export$1405a65085f40b9).some((name)=>(0, $a35be4d5814e7c66$export$720b90e312cea233)(props[name]));
}
function $06b1046bf0f33e63$export$ce46fa4165cdec40(props) {
    return Boolean($06b1046bf0f33e63$export$4b3c3bd8d910d78d(props) || props.variants);
}



function $69635cdb8982f9d2$export$9a552858d5197f6e(element, next, prev) {
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $eadb4e7ad13d3244$export$605d60a2578142d3)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $eadb4e7ad13d3244$export$605d60a2578142d3)(prevValue)) /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $61b3ffa62977d1fd$export$ce8bdc721e76545f)(nextValue, {
            owner: element
        }));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $61b3ffa62977d1fd$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}


function $abbf779fde460163$var$getValueState(visualElement) {
    const state = [
        {},
        {}
    ];
    visualElement?.values.forEach((value, key)=>{
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function $abbf779fde460163$export$d68f140c4d9b48bc(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        const [current, velocity] = $abbf779fde460163$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        const [current, velocity] = $abbf779fde460163$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    return definition;
}


const $e66750f3fb0f96bb$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $e66750f3fb0f96bb$export$fa8b653c0f3714e5 {
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
        return {};
    }
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, blockInitialAnimation: blockInitialAnimation, visualState: visualState }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, $c982fbe82ecf7d0b$export$74d34ca3182f1750);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.renderScheduledAt = 0.0;
        this.scheduleRender = ()=>{
            const now = (0, $fa7790817f905603$export$2da9be4cfdb689b1).now();
            if (this.renderScheduledAt < now) {
                this.renderScheduledAt = now;
                (0, $1fc179758a6fb1d9$export$2cef06c20297c17d).render(this.render, false, true);
            }
        };
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, $06b1046bf0f33e63$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $06b1046bf0f33e63$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't necessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {}, this);
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $eadb4e7ad13d3244$export$605d60a2578142d3)(value)) value.set(latestValues[key]);
        }
    }
    mount(instance) {
        this.current = instance;
        (0, $a4ccbde0d696dfdf$export$bc2a978a17abfdde).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $5d1c3a7750a03ec7$export$6476d16e2fd2d0db).current) (0, $402b11b96c54cb2c$export$ca9f41fb23dded3d)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $5d1c3a7750a03ec7$export$ff7706047246b98b).current;
        (0, $6e5dff638919bf7c$export$5b28268982f175ba)(this.shouldReduceMotion !== true, "You have Reduced Motion enabled on your device. Animations may not appear as expected.", "reduced-motion-disabled");
        this.parent?.addChild(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        this.projection && this.projection.unmount();
        (0, $1fc179758a6fb1d9$export$ec99c0ef4978dccb)(this.notifyUpdate);
        (0, $1fc179758a6fb1d9$export$ec99c0ef4978dccb)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.valueSubscriptions.clear();
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent?.removeChild(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features){
            const feature = this.features[key];
            if (feature) {
                feature.unmount();
                feature.isMounted = false;
            }
        }
        this.current = null;
    }
    addChild(child) {
        this.children.add(child);
        this.enteringChildren ?? (this.enteringChildren = new Set());
        this.enteringChildren.add(child);
    }
    removeChild(child) {
        this.children.delete(child);
        this.enteringChildren && this.enteringChildren.delete(child);
    }
    bindToMotionValue(key, value) {
        if (this.valueSubscriptions.has(key)) this.valueSubscriptions.get(key)();
        const valueIsTransform = (0, $807cad0c0e3f2e9a$export$7b42a0094fb00b6e).has(key);
        if (valueIsTransform && this.onBindTransform) this.onBindTransform();
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $1fc179758a6fb1d9$export$2cef06c20297c17d).preRender(this.notifyUpdate);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
            this.scheduleRender();
        });
        let removeSyncCheck;
        if (window.MotionCheckAppearSync) removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            if (removeSyncCheck) removeSyncCheck();
            if (value.owner) value.stop();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    updateFeatures() {
        let key = "animation";
        for(key in 0, $a8d82256030e9525$export$65570e08d843624d){
            const featureDefinition = (0, $a8d82256030e9525$export$65570e08d843624d)[key];
            if (!featureDefinition) continue;
            const { isEnabled: isEnabled, Feature: FeatureConstructor } = featureDefinition;
            /**
             * If this feature is enabled but not active, make a new instance.
             */ if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) this.features[key] = new FeatureConstructor(this);
            /**
             * If we have a feature, mount or update it.
             */ if (this.features[key]) {
                const feature = this.features[key];
                if (feature.isMounted) feature.update();
                else {
                    feature.mount();
                    feature.isMounted = true;
                }
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $e66750f3fb0f96bb$var$propEventHandlers.length; i++){
            const key = $e66750f3fb0f96bb$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listenerName = "on" + key;
            const listener = props[listenerName];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $69635cdb8982f9d2$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps, this), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        const existingValue = this.values.get(key);
        if (value !== existingValue) {
            if (existingValue) this.removeValue(key);
            this.bindToMotionValue(key, value);
            this.values.set(key, value);
            this.latestValues[key] = value.get();
        }
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $61b3ffa62977d1fd$export$ce8bdc721e76545f)(defaultValue === null ? undefined : defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key, target) {
        let value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : this.getBaseTargetFromProps(this.props, key) ?? this.readValueFromInstance(this.current, key, this.options);
        if (value !== undefined && value !== null) {
            if (typeof value === "string" && ((0, $dd4e99dc1119eedf$export$65583ed5a868f2d9)(value) || (0, $5596943de35d27aa$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
            else if (!(0, $79a3d08b7950b39a$export$950e7e59ea1ffed7)(value) && (0, $1c1147c837df3766$export$83a0e34f1302825b).test(target)) value = (0, $e809d8b3dcab66da$export$cea0cedcb94873b5)(key, target);
            this.setBaseTarget(key, (0, $eadb4e7ad13d3244$export$605d60a2578142d3)(value) ? value.get() : value);
        }
        return (0, $eadb4e7ad13d3244$export$605d60a2578142d3)(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        const { initial: initial } = this.props;
        let valueFromInitial;
        if (typeof initial === "string" || typeof initial === "object") {
            const variant = (0, $abbf779fde460163$export$d68f140c4d9b48bc)(this.props, initial, this.presenceContext?.custom);
            if (variant) valueFromInitial = variant[key];
        }
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $eadb4e7ad13d3244$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $ee5d55ee4695ef73$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
    scheduleRenderMicrotask() {
        (0, $2ea51e08c4a70f38$export$bb76eed83315504c).render(this.render);
    }
}


class $28a1ebc4c0bc036f$export$e49735c2a366bdc7 extends (0, $e66750f3fb0f96bb$export$fa8b653c0f3714e5) {
    constructor(){
        super(...arguments);
        this.KeyframeResolver = (0, $8a248eab473b7981$export$4983792d11b61017);
    }
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $eadb4e7ad13d3244$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
}


/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $fc323ea9459e7f0b$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};



const $1724c99b9b724858$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $1724c99b9b724858$var$numTransforms = (0, $807cad0c0e3f2e9a$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $1724c99b9b724858$export$bdc96e0d5c8f914(latestValues, transform, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    let transformIsDefault = true;
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $1724c99b9b724858$var$numTransforms; i++){
        const key = (0, $807cad0c0e3f2e9a$export$280dc01950909d86)[i];
        const value = latestValues[key];
        if (value === undefined) continue;
        let valueIsDefault = true;
        if (typeof value === "number") valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
        else valueIsDefault = parseFloat(value) === 0;
        if (!valueIsDefault || transformTemplate) {
            const valueAsType = (0, $fc323ea9459e7f0b$export$453ef540a9a1bd6b)(value, (0, $600744ecb436af48$export$eec14432cd1cb67b)[key]);
            if (!valueIsDefault) {
                transformIsDefault = false;
                const transformName = $1724c99b9b724858$var$translateAlias[key] || key;
                transformString += `${transformName}(${valueAsType}) `;
            }
            if (transformTemplate) transform[key] = valueAsType;
        }
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (transformIsDefault) transformString = "none";
    return transformString;
}


function $a883e7c624291d03$export$bb517f8b40f8e99d(state, latestValues, transformTemplate) {
    const { style: style, vars: vars, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept separately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        if ((0, $807cad0c0e3f2e9a$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            continue;
        } else if ((0, $678aad7e5ff4ee18$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        } else {
            // Convert the value to its default value type, ie 0 -> "0px"
            const valueAsType = (0, $fc323ea9459e7f0b$export$453ef540a9a1bd6b)(value, (0, $600744ecb436af48$export$eec14432cd1cb67b)[key]);
            if (key.startsWith("origin")) {
                // If this is a transform origin, flag and enable further transform-origin processing
                hasTransformOrigin = true;
                transformOrigin[key] = valueAsType;
            } else style[key] = valueAsType;
        }
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $1724c99b9b724858$export$bdc96e0d5c8f914)(latestValues, state.transform, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}


function $a52b6fc2f3af305f$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    const elementStyle = element.style;
    let key;
    for(key in style)// CSSStyleDeclaration has [index: number]: string; in the types, so we use that as key type.
    elementStyle[key] = style[key];
    // Write projection styles directly to element style
    projection?.applyProjectionStyles(elementStyle, styleProp);
    for(key in vars)// Loop over any CSS variables and assign those.
    // They can only be assigned using `setProperty`.
    elementStyle.setProperty(key, vars[key]);
}






function $967b202c839557ef$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $967b202c839557ef$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $967b202c839557ef$export$fafff692be55225d(latest, node.target.x);
        const y = $967b202c839557ef$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};



const $a42cd9e0ef50cb70$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        const shadow = (0, $1c1147c837df3766$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $1c1147c837df3766$export$83a0e34f1302825b).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $be9fc9b72a711b93$export$3bb0b4ff1037b8dd)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};


const $eced91e16bda42df$export$91ddd985b97788d1 = {
    borderRadius: {
        ...(0, $967b202c839557ef$export$5eafb6257a5844c),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $967b202c839557ef$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $967b202c839557ef$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $967b202c839557ef$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $967b202c839557ef$export$5eafb6257a5844c),
    boxShadow: (0, $a42cd9e0ef50cb70$export$eb0bc629e74dcf8)
};
function $eced91e16bda42df$export$de9e7791c71225fd(correctors) {
    for(const key in correctors){
        $eced91e16bda42df$export$91ddd985b97788d1[key] = correctors[key];
        if ((0, $678aad7e5ff4ee18$export$9de1236619d9e756)(key)) $eced91e16bda42df$export$91ddd985b97788d1[key].isCSSVariable = true;
    }
}


function $443c859766df5778$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $807cad0c0e3f2e9a$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $eced91e16bda42df$export$91ddd985b97788d1)[key] || key === "opacity");
}


function $a8ee53e44f8c4ac8$export$16da615486abaa45(props, prevProps, visualElement) {
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $eadb4e7ad13d3244$export$605d60a2578142d3)(style[key]) || prevProps.style && (0, $eadb4e7ad13d3244$export$605d60a2578142d3)(prevProps.style[key]) || (0, $443c859766df5778$export$6d27ce8e3de1c3cf)(key, props) || visualElement?.getValue(key)?.liveStyle !== undefined) newValues[key] = style[key];
    return newValues;
}


function $bce82b8bf0dbf6b7$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $bce82b8bf0dbf6b7$export$23fea75b03ac16b3 extends (0, $28a1ebc4c0bc036f$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "html";
        this.renderInstance = (0, $a52b6fc2f3af305f$export$1a32bf6229c258c0);
    }
    readValueFromInstance(instance, key) {
        if ((0, $807cad0c0e3f2e9a$export$7b42a0094fb00b6e).has(key)) return this.projection?.isProjecting ? (0, $2e5fda4b6d357a01$export$1f10c01143b9f089)(key) : (0, $2e5fda4b6d357a01$export$bcd97e0e03ba17f6)(instance, key);
        else {
            const computedStyle = $bce82b8bf0dbf6b7$export$3735103072e4a80(instance);
            const value = ((0, $678aad7e5ff4ee18$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $4ca2f8055771ddf4$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, props) {
        (0, $a883e7c624291d03$export$bb517f8b40f8e99d)(renderState, latestValues, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $a8ee53e44f8c4ac8$export$16da615486abaa45)(props, prevProps, visualElement);
    }
}





/**
 * Convert camelCase to dash-case properties.
 */ const $9dc069bda924fd3f$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase();




const $f5fdba1fd96a9ba7$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $f5fdba1fd96a9ba7$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $f5fdba1fd96a9ba7$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $f5fdba1fd96a9ba7$var$dashKeys : $f5fdba1fd96a9ba7$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    const pathLength = (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008).transform(length);
    const pathSpacing = (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}


/**
 * Build SVG visual attributes, like cx and style.transform
 */ function $59f141cfaf6fcabb$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, isSVGTag, transformTemplate, styleProp) {
    (0, $a883e7c624291d03$export$bb517f8b40f8e99d)(state, latest, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style } = state;
    /**
     * However, we apply transforms as CSS transforms.
     * So if we detect a transform, transformOrigin we take it from attrs and copy it into style.
     */ if (attrs.transform) {
        style.transform = attrs.transform;
        delete attrs.transform;
    }
    if (style.transform || attrs.transformOrigin) {
        style.transformOrigin = attrs.transformOrigin ?? "50% 50%";
        delete attrs.transformOrigin;
    }
    if (style.transform) {
        /**
         * SVG's element transform-origin uses its own median as a reference.
         * Therefore, transformBox becomes a fill-box
         */ style.transformBox = styleProp?.transformBox ?? "fill-box";
        delete attrs.transformBox;
    }
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $f5fdba1fd96a9ba7$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ const $ea3ecc5fb2887a0f$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);


const $c139bf35362d2174$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";





function $9422342e44092cf6$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $a52b6fc2f3af305f$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $ea3ecc5fb2887a0f$export$28931db5d57958e5).has(key) ? (0, $9dc069bda924fd3f$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}




function $eac085b45c9e0925$export$16da615486abaa45(props, prevProps, visualElement) {
    const newValues = (0, $a8ee53e44f8c4ac8$export$16da615486abaa45)(props, prevProps, visualElement);
    for(const key in props)if ((0, $eadb4e7ad13d3244$export$605d60a2578142d3)(props[key]) || (0, $eadb4e7ad13d3244$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = (0, $807cad0c0e3f2e9a$export$280dc01950909d86).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}


class $a0798b9f9973cb35$export$86bcdffbaf733d84 extends (0, $28a1ebc4c0bc036f$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
        this.measureInstanceViewportBox = (0, $a3727e4e12b23353$export$6459fc9e86be362e);
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $807cad0c0e3f2e9a$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $f3598fc4cf1ed189$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $ea3ecc5fb2887a0f$export$28931db5d57958e5).has(key) ? (0, $9dc069bda924fd3f$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $eac085b45c9e0925$export$16da615486abaa45)(props, prevProps, visualElement);
    }
    build(renderState, latestValues, props) {
        (0, $59f141cfaf6fcabb$export$5475d24f125d7053)(renderState, latestValues, this.isSVGTag, props.transformTemplate, props.style);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $9422342e44092cf6$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $c139bf35362d2174$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
}


/**
 * We keep these listed separately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $1d85745fbdd79bfa$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];


function $ca4ea6365adee72d$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $1d85745fbdd79bfa$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/u.test(Component)) return true;
    return false;
}


const $2f8881102ac6dde9$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $ca4ea6365adee72d$export$88f3fc2fd3766989)(Component) ? new (0, $a0798b9f9973cb35$export$86bcdffbaf733d84)(options) : new (0, $bce82b8bf0dbf6b7$export$23fea75b03ac16b3)(options, {
        allowProjection: Component !== (0, $acw62.Fragment)
    });
};




var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
"use client";
const $4ae202aab5791dbc$export$a3579ca508007a95 = (0, $acw62.createContext)({});



var $acw62 = parcelRequire("acw62");
"use client";
const $410b846e117db9e1$export$40f10139ecf1f171 = (0, $acw62.createContext)({
    strict: false
});



var $acw62 = parcelRequire("acw62");
"use client";
/**
 * @public
 */ const $3bbbde5b328b4154$export$22a697fb29aac98d = (0, $acw62.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});



var $acw62 = parcelRequire("acw62");
"use client";
const $3ce32ada97cfc8f7$export$2285bbca2c666415 = /* @__PURE__ */ (0, $acw62.createContext)({});



var $acw62 = parcelRequire("acw62");



function $9e57028cf0cad086$export$12fc32fc096a04a3(props, context) {
    if ((0, $06b1046bf0f33e63$export$4b3c3bd8d910d78d)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $a35be4d5814e7c66$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $a35be4d5814e7c66$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


"use client";
function $4cb87fa0b981df8c$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $9e57028cf0cad086$export$12fc32fc096a04a3)(props, (0, $acw62.useContext)((0, $3ce32ada97cfc8f7$export$2285bbca2c666415)));
    return (0, $acw62.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $4cb87fa0b981df8c$var$variantLabelsAsDependency(initial),
        $4cb87fa0b981df8c$var$variantLabelsAsDependency(animate)
    ]);
}
function $4cb87fa0b981df8c$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


const $57bb451bc3d87577$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });


"use client";
function $81d8dfeeb8038b0d$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $eadb4e7ad13d3244$export$605d60a2578142d3)(source[key]) && !(0, $443c859766df5778$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $81d8dfeeb8038b0d$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState) {
    return (0, $acw62.useMemo)(()=>{
        const state = (0, $57bb451bc3d87577$export$8940b483cf52eeda)();
        (0, $a883e7c624291d03$export$bb517f8b40f8e99d)(state, visualState, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $81d8dfeeb8038b0d$var$useStyle(props, visualState) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $81d8dfeeb8038b0d$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $81d8dfeeb8038b0d$var$useInitialMotionValues(props, visualState));
    return style;
}
function $81d8dfeeb8038b0d$export$57be0a314572d87d(props, visualState) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $81d8dfeeb8038b0d$var$useStyle(props, visualState);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}



var $acw62 = parcelRequire("acw62");



const $b7a2547211637b3c$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $57bb451bc3d87577$export$8940b483cf52eeda)(),
        attrs: {}
    });



"use client";
function $268dc116ac4d3a3d$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $acw62.useMemo)(()=>{
        const state = (0, $b7a2547211637b3c$export$41be8b43e1c4d4f9)();
        (0, $59f141cfaf6fcabb$export$5475d24f125d7053)(state, visualState, (0, $c139bf35362d2174$export$6328ce7565ea1049)(Component), props.transformTemplate, props.style);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $81d8dfeeb8038b0d$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}


/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $c4bee6acbf082b7d$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $c4bee6acbf082b7d$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || $c4bee6acbf082b7d$var$validMotionProps.has(key);
}


let $05db6db4ebcdf5f1$var$shouldForward = (key)=>!(0, $c4bee6acbf082b7d$export$2f9c46555243bf04)(key);
function $05db6db4ebcdf5f1$export$59d6962c470509a5(isValidProp) {
    if (typeof isValidProp !== "function") return;
    // Explicitly filter our events
    $05db6db4ebcdf5f1$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $c4bee6acbf082b7d$export$2f9c46555243bf04)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $05db6db4ebcdf5f1$export$59d6962c470509a5((parcelRequire("gd942")).default);
} catch  {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $05db6db4ebcdf5f1$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($05db6db4ebcdf5f1$var$shouldForward(key) || forwardMotionProps === true && (0, $c4bee6acbf082b7d$export$2f9c46555243bf04)(key) || !isDom && !(0, $c4bee6acbf082b7d$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}



"use client";
function $dc80cb5954e76638$export$e25bb1e5b53cbdff(Component, props, ref, { latestValues: latestValues }, isStatic, forwardMotionProps = false) {
    const useVisualProps = (0, $ca4ea6365adee72d$export$88f3fc2fd3766989)(Component) ? (0, $268dc116ac4d3a3d$export$84309c4f53cb1bd5) : (0, $81d8dfeeb8038b0d$export$57be0a314572d87d);
    const visualProps = useVisualProps(props, latestValues, isStatic, Component);
    const filteredProps = (0, $05db6db4ebcdf5f1$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
    const elementProps = Component !== (0, $acw62.Fragment) ? {
        ...filteredProps,
        ...visualProps,
        ref: ref
    } : {};
    /**
     * If component has been handed a motion value as its child,
     * memoise its initial value and render that. Subsequent updates
     * will be handled by the onChange handler
     */ const { children: children } = props;
    const renderedChildren = (0, $acw62.useMemo)(()=>(0, $eadb4e7ad13d3244$export$605d60a2578142d3)(children) ? children.get() : children, [
        children
    ]);
    return (0, $acw62.createElement)(Component, {
        ...elementProps,
        children: renderedChildren
    });
}




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
"use client";
/**
 * @public
 */ const $dba5d94a982c4145$export$f224e4635b6f8ce2 = /* @__PURE__ */ (0, $acw62.createContext)(null);





var $acw62 = parcelRequire("acw62");
"use client";
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $40f5fd83135889a9$export$fe4300aa8eebea86(init) {
    const ref = (0, $acw62.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}



/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $18cbbcef55016eac$export$fcc2206ecb6d74b(value) {
    return (0, $eadb4e7ad13d3244$export$605d60a2578142d3)(value) ? value.get() : value;
}


"use client";
function $5c26ebcca6422185$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState }, props, context, presenceContext) {
    const state = {
        latestValues: $5c26ebcca6422185$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    return state;
}
function $5c26ebcca6422185$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $18cbbcef55016eac$export$fcc2206ecb6d74b)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $06b1046bf0f33e63$export$4b3c3bd8d910d78d)(props);
    const isVariantNode$1 = (0, $06b1046bf0f33e63$export$ce46fa4165cdec40)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $1e5344c7f0db9c8f$export$aa71198ceeaf53ce)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        for(let i = 0; i < list.length; i++){
            const resolved = (0, $abbf779fde460163$export$d68f140c4d9b48bc)(props, list[i]);
            if (resolved) {
                const { transitionEnd: transitionEnd, transition: transition, ...target } = resolved;
                for(const key in target){
                    let valueTarget = target[key];
                    if (Array.isArray(valueTarget)) {
                        /**
                         * Take final keyframe if the initial animation is blocked because
                         * we want to initialise at the end of that blocked animation.
                         */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                        valueTarget = valueTarget[index];
                    }
                    if (valueTarget !== null) values[key] = valueTarget;
                }
                for(const key in transitionEnd)values[key] = transitionEnd[key];
            }
        }
    }
    return values;
}
const $5c26ebcca6422185$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $acw62.useContext)((0, $3ce32ada97cfc8f7$export$2285bbca2c666415));
        const presenceContext = (0, $acw62.useContext)((0, $dba5d94a982c4145$export$f224e4635b6f8ce2));
        const make = ()=>$5c26ebcca6422185$var$makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, $40f5fd83135889a9$export$fe4300aa8eebea86)(make);
    };




"use client";
const $7208aa5e20bc052f$export$851cf1f78cb3feac = /*@__PURE__*/ (0, $5c26ebcca6422185$export$e91e107bc6d03a8e)({
    scrapeMotionValuesFromProps: $a8ee53e44f8c4ac8$export$16da615486abaa45,
    createRenderState: (0, $57bb451bc3d87577$export$8940b483cf52eeda)
});





"use client";
const $e4b5d02c3383862e$export$9922240e40b88c48 = /*@__PURE__*/ (0, $5c26ebcca6422185$export$e91e107bc6d03a8e)({
    scrapeMotionValuesFromProps: (0, $eac085b45c9e0925$export$16da615486abaa45),
    createRenderState: (0, $b7a2547211637b3c$export$41be8b43e1c4d4f9)
});





function $b9879783068c1762$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $a8d82256030e9525$export$65570e08d843624d)[key] = {
        ...(0, $a8d82256030e9525$export$65570e08d843624d)[key],
        ...features[key]
    };
}


const $9b94ea54d3350cc1$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");



var $acw62 = parcelRequire("acw62");
function $d157673547c2a934$export$dedd81df7bc1307(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}


"use client";
/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $88efa764bb00537b$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $acw62.useCallback)((instance)=>{
        if (instance) visualState.onMount && visualState.onMount(instance);
        if (visualElement) {
            if (instance) visualElement.mount(instance);
            else visualElement.unmount();
        }
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $d157673547c2a934$export$dedd81df7bc1307)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Include externalRef in dependencies to ensure the callback updates
     * when the ref changes, allowing proper ref forwarding.
     */ [
        visualElement
    ]);
}



var $acw62 = parcelRequire("acw62");

const $5fd2b57c27674a98$export$ed7b8fa9dbf0105d = "framerAppearId";
const $5fd2b57c27674a98$export$8592e1c077c890a6 = "data-" + (0, $9dc069bda924fd3f$export$9fd24a634729c672)($5fd2b57c27674a98$export$ed7b8fa9dbf0105d);







var $acw62 = parcelRequire("acw62");
"use client";
/**
 * Internal, exported only for usage in Framer
 */ const $c612a166b65a9c69$export$da5f7b802957459a = (0, $acw62.createContext)({});




var $acw62 = parcelRequire("acw62");

"use client";
const $9c674755a93db746$export$700979bc83e7db82 = (0, $784730508f12f72c$export$4e09c449d6c407f7) ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);


"use client";
function $7fb0f4644b9cc8ad$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement, ProjectionNodeConstructor) {
    const { visualElement: parent } = (0, $acw62.useContext)((0, $3ce32ada97cfc8f7$export$2285bbca2c666415));
    const lazyContext = (0, $acw62.useContext)((0, $410b846e117db9e1$export$40f10139ecf1f171));
    const presenceContext = (0, $acw62.useContext)((0, $dba5d94a982c4145$export$f224e4635b6f8ce2));
    const reducedMotionConfig = (0, $acw62.useContext)((0, $3bbbde5b328b4154$export$22a697fb29aac98d)).reducedMotion;
    const visualElementRef = (0, $acw62.useRef)(null);
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    /**
     * Load Motion gesture and animation features. These are rendered as renderless
     * components so each feature can optionally make use of React lifecycle methods.
     */ const initialLayoutGroupConfig = (0, $acw62.useContext)((0, $c612a166b65a9c69$export$da5f7b802957459a));
    if (visualElement && !visualElement.projection && ProjectionNodeConstructor && (visualElement.type === "html" || visualElement.type === "svg")) $7fb0f4644b9cc8ad$var$createProjectionNode(visualElementRef.current, props, ProjectionNodeConstructor, initialLayoutGroupConfig);
    const isMounted = (0, $acw62.useRef)(false);
    (0, $acw62.useInsertionEffect)(()=>{
        /**
         * Check the component has already mounted before calling
         * `update` unnecessarily. This ensures we skip the initial update.
         */ if (visualElement && isMounted.current) visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const optimisedAppearId = props[0, $5fd2b57c27674a98$export$8592e1c077c890a6];
    const wantsHandoff = (0, $acw62.useRef)(Boolean(optimisedAppearId) && !window.MotionHandoffIsComplete?.(optimisedAppearId) && window.MotionHasOptimisedAnimation?.(optimisedAppearId));
    (0, $9c674755a93db746$export$700979bc83e7db82)(()=>{
        if (!visualElement) return;
        isMounted.current = true;
        window.MotionIsMounted = true;
        visualElement.updateFeatures();
        visualElement.scheduleRenderMicrotask();
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $acw62.useEffect)(()=>{
        if (!visualElement) return;
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        if (wantsHandoff.current) {
            // This ensures all future calls to animateChanges() in this component will run in useEffect
            queueMicrotask(()=>{
                window.MotionHandoffMarkAsComplete?.(optimisedAppearId);
            });
            wantsHandoff.current = false;
        }
        /**
         * Now we've finished triggering animations for this element we
         * can wipe the enteringChildren set for the next render.
         */ visualElement.enteringChildren = undefined;
    });
    return visualElement;
}
function $7fb0f4644b9cc8ad$var$createProjectionNode(visualElement, props, ProjectionNodeConstructor, initialPromotionConfig) {
    const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot, layoutCrossfade: layoutCrossfade } = props;
    visualElement.projection = new ProjectionNodeConstructor(visualElement.latestValues, props["data-framer-portal-id"] ? undefined : $7fb0f4644b9cc8ad$var$getClosestProjectingNode(visualElement.parent));
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $d157673547c2a934$export$dedd81df7bc1307)(dragConstraints),
        visualElement: visualElement,
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        crossfade: layoutCrossfade,
        layoutScroll: layoutScroll,
        layoutRoot: layoutRoot
    });
}
function $7fb0f4644b9cc8ad$var$getClosestProjectingNode(visualElement) {
    if (!visualElement) return undefined;
    return visualElement.options.allowProjection !== false ? visualElement.projection : $7fb0f4644b9cc8ad$var$getClosestProjectingNode(visualElement.parent);
}


"use client";
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $b40dad60036091a1$export$46b7e4b9dc6110c3(Component, { forwardMotionProps: forwardMotionProps = false } = {}, preloadedFeatures, createVisualElement) {
    preloadedFeatures && (0, $b9879783068c1762$export$449561ec5703cdc8)(preloadedFeatures);
    const useVisualState = (0, $ca4ea6365adee72d$export$88f3fc2fd3766989)(Component) ? (0, $e4b5d02c3383862e$export$9922240e40b88c48) : (0, $7208aa5e20bc052f$export$851cf1f78cb3feac);
    function MotionDOMComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $acw62.useContext)((0, $3bbbde5b328b4154$export$22a697fb29aac98d)),
            ...props,
            layoutId: $b40dad60036091a1$var$useLayoutId(props)
        };
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $4cb87fa0b981df8c$export$c5638d843b37a176)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $784730508f12f72c$export$4e09c449d6c407f7)) {
            $b40dad60036091a1$var$useStrictMode(configAndProps, preloadedFeatures);
            const layoutProjection = $b40dad60036091a1$var$getProjectionFunctionality(configAndProps);
            MeasureLayout = layoutProjection.MeasureLayout;
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $7fb0f4644b9cc8ad$export$dc0335d73ab0b115)(Component, visualState, configAndProps, createVisualElement, layoutProjection.ProjectionNode);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return (0, $ayMG0.jsxs)((0, $3ce32ada97cfc8f7$export$2285bbca2c666415).Provider, {
            value: context,
            children: [
                MeasureLayout && context.visualElement ? (0, $ayMG0.jsx)(MeasureLayout, {
                    visualElement: context.visualElement,
                    ...configAndProps
                }) : null,
                (0, $dc80cb5954e76638$export$e25bb1e5b53cbdff)(Component, props, (0, $88efa764bb00537b$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, isStatic, forwardMotionProps)
            ]
        });
    }
    MotionDOMComponent.displayName = `motion.${typeof Component === "string" ? Component : `create(${Component.displayName ?? Component.name ?? ""})`}`;
    const ForwardRefMotionComponent = (0, $acw62.forwardRef)(MotionDOMComponent);
    ForwardRefMotionComponent[0, $9b94ea54d3350cc1$export$28e2e4cce424ae23] = Component;
    return ForwardRefMotionComponent;
}
function $b40dad60036091a1$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $acw62.useContext)((0, $4ae202aab5791dbc$export$a3579ca508007a95)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
function $b40dad60036091a1$var$useStrictMode(configAndProps, preloadedFeatures) {
    const isStrict = (0, $acw62.useContext)((0, $410b846e117db9e1$export$40f10139ecf1f171)).strict;
    /**
     * If we're in development mode, check to make sure we're not rendering a motion component
     * as a child of LazyMotion, as this will break the file-size benefits of using it.
     */ if (preloadedFeatures && isStrict) {
        const strictMessage = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
        configAndProps.ignoreStrict ? (0, $fbe9f318b7b09044$export$491112666e282270)(false, strictMessage, "lazy-strict-mode") : (0, $fbe9f318b7b09044$export$f5708dca728d7177)(false, strictMessage, "lazy-strict-mode");
    }
}
function $b40dad60036091a1$var$getProjectionFunctionality(props) {
    const { drag: drag, layout: layout } = (0, $a8d82256030e9525$export$65570e08d843624d);
    if (!drag && !layout) return {};
    const combined = {
        ...drag,
        ...layout
    };
    return {
        MeasureLayout: drag?.isEnabled(props) || layout?.isEnabled(props) ? combined.MeasureLayout : undefined,
        ProjectionNode: combined.ProjectionNode
    };
}


function $f1922c0288de6004$export$a28d6df673050e18(preloadedFeatures, createVisualElement) {
    if (typeof Proxy === "undefined") return 0, $b40dad60036091a1$export$46b7e4b9dc6110c3;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    const factory = (Component, options)=>{
        return (0, $b40dad60036091a1$export$46b7e4b9dc6110c3)(Component, options, preloadedFeatures, createVisualElement);
    };
    /**
     * Support for deprecated`motion(Component)` pattern
     */ const deprecatedFactoryFunction = (Component, options)=>{
        (0, $6e5dff638919bf7c$export$5b28268982f175ba)(false, "motion() is deprecated. Use motion.create() instead.");
        return factory(Component, options);
    };
    return new Proxy(deprecatedFactoryFunction, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            if (key === "create") return factory;
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, (0, $b40dad60036091a1$export$46b7e4b9dc6110c3)(key, undefined, preloadedFeatures, createVisualElement));
            return componentCache.get(key);
        }
    });
}




function $58c1fda9d3891d8d$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $abbf779fde460163$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}


function $339fe6708b513dab$export$7c1391340308742e(transition, key) {
    return transition?.[key] ?? transition?.["default"] ?? transition;
}



const $ef59b2359a289b82$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};



/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $ea04fe669600292a$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $61b3ffa62977d1fd$export$ce8bdc721e76545f)(value));
}
function $ea04fe669600292a$var$resolveFinalValueInKeyframes(v) {
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $ef59b2359a289b82$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
}
function $ea04fe669600292a$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $58c1fda9d3891d8d$export$7b1b1c981f4f0558)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved || {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = $ea04fe669600292a$var$resolveFinalValueInKeyframes(target[key]);
        $ea04fe669600292a$var$setMotionValue(visualElement, key, value);
    }
}




function $d94f283b675f700d$export$98397f3adbf6259f(value) {
    return Boolean((0, $eadb4e7ad13d3244$export$605d60a2578142d3)(value) && value.add);
}


function $74e7c7f6c49b7323$export$3ac5aed310be0bee(visualElement, key) {
    const willChange = visualElement.getValue("willChange");
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */ if ((0, $d94f283b675f700d$export$98397f3adbf6259f)(willChange)) return willChange.add(key);
    else if (!willChange && (0, $502ec5afb929f350$export$dd826089e3c5e502).WillChange) {
        const newWillChange = new (0, $502ec5afb929f350$export$dd826089e3c5e502).WillChange("auto");
        visualElement.addValue("willChange", newWillChange);
        newWillChange.add(key);
    }
}



function $59a52f0eed0e0e03$export$5f8d21e84d1d84fc(visualElement) {
    return visualElement.props[0, $5fd2b57c27674a98$export$8592e1c077c890a6];
}




/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ /*#__NO_SIDE_EFFECTS__*/ const $891d0606d6764488$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
/*#__NO_SIDE_EFFECTS__*/ const $891d0606d6764488$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;

/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $c5c22880df3796c2$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $c5c22880df3796c2$export$a4627e546088548d = (...transformers)=>transformers.reduce($c5c22880df3796c2$var$combineFunctions);



const $c27f978081fc4187$export$d921fb2475e2900c = {
    layout: 0,
    mainThread: 0,
    waapi: 0
};









// Adapted from https://gist.github.com/mjackson/5311256
function $b0149b2968d0b60f$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $b0149b2968d0b60f$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $b0149b2968d0b60f$var$hueToRgb(p, q, hue + 1 / 3);
        green = $b0149b2968d0b60f$var$hueToRgb(p, q, hue);
        blue = $b0149b2968d0b60f$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}



function $e8dffd34c64d5158$export$a6f92d4bae65c0f1(a, b) {
    return (p)=>p > 0 ? b : a;
}



// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $301750c658004541$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
const $301750c658004541$var$colorTypes = [
    (0, $77fb23ad025cd7f6$export$834dfc94dde4b3d8),
    (0, $5a3ee899e2525965$export$4e46ac54fc82cf3b),
    (0, $86db837a393ca21c$export$810b04175080204c)
];
const $301750c658004541$var$getColorType = (v)=>$301750c658004541$var$colorTypes.find((type)=>type.test(v));
function $301750c658004541$var$asRGBA(color) {
    const type = $301750c658004541$var$getColorType(color);
    (0, $fbe9f318b7b09044$export$491112666e282270)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`, "color-not-animatable");
    if (!Boolean(type)) return false;
    let model = type.parse(color);
    if (type === (0, $86db837a393ca21c$export$810b04175080204c)) // TODO Remove this cast - needed since Motion's stricter typing
    model = (0, $b0149b2968d0b60f$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $301750c658004541$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $301750c658004541$var$asRGBA(from);
    const toRGBA = $301750c658004541$var$asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, $e8dffd34c64d5158$export$a6f92d4bae65c0f1)(from, to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $301750c658004541$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $301750c658004541$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $301750c658004541$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $be9fc9b72a711b93$export$3bb0b4ff1037b8dd)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $5a3ee899e2525965$export$4e46ac54fc82cf3b).transform(blended);
    };
};




const $326c1dabb495b1d6$export$e5a55ae567dd4ac7 = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function $326c1dabb495b1d6$export$fed62ccc3fb1a568(origin, target) {
    if ($326c1dabb495b1d6$export$e5a55ae567dd4ac7.has(origin)) return (p)=>p <= 0 ? origin : target;
    else return (p)=>p >= 1 ? target : origin;
}


function $7f4bfb007437a8ac$var$mixNumber(a, b) {
    return (p)=>(0, $be9fc9b72a711b93$export$3bb0b4ff1037b8dd)(a, b, p);
}
function $7f4bfb007437a8ac$export$36ec24672cd098e0(a) {
    if (typeof a === "number") return $7f4bfb007437a8ac$var$mixNumber;
    else if (typeof a === "string") return (0, $678aad7e5ff4ee18$export$31f9caa2600b5723)(a) ? (0, $e8dffd34c64d5158$export$a6f92d4bae65c0f1) : (0, $c735af09100d3b88$export$35e9368ef982300f).test(a) ? (0, $301750c658004541$export$51e568cf5c039bac) : $7f4bfb007437a8ac$export$65516310a87d8205;
    else if (Array.isArray(a)) return $7f4bfb007437a8ac$export$3bbefa2f402845c4;
    else if (typeof a === "object") return (0, $c735af09100d3b88$export$35e9368ef982300f).test(a) ? (0, $301750c658004541$export$51e568cf5c039bac) : $7f4bfb007437a8ac$export$ebc23b6840c51ba1;
    return 0, $e8dffd34c64d5158$export$a6f92d4bae65c0f1;
}
function $7f4bfb007437a8ac$export$3bbefa2f402845c4(a, b) {
    const output = [
        ...a
    ];
    const numValues = output.length;
    const blendValue = a.map((v, i)=>$7f4bfb007437a8ac$export$36ec24672cd098e0(v)(v, b[i]));
    return (p)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function $7f4bfb007437a8ac$export$ebc23b6840c51ba1(a, b) {
    const output = {
        ...a,
        ...b
    };
    const blendValue = {};
    for(const key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = $7f4bfb007437a8ac$export$36ec24672cd098e0(a[key])(a[key], b[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function $7f4bfb007437a8ac$var$matchOrder(origin, target) {
    const orderedOrigin = [];
    const pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(let i = 0; i < target.values.length; i++){
        const type = target.types[i];
        const originIndex = origin.indexes[type][pointers[type]];
        const originValue = origin.values[originIndex] ?? 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
const $7f4bfb007437a8ac$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $1c1147c837df3766$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $1c1147c837df3766$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $1c1147c837df3766$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, $326c1dabb495b1d6$export$e5a55ae567dd4ac7).has(origin) && !targetStats.values.length || (0, $326c1dabb495b1d6$export$e5a55ae567dd4ac7).has(target) && !originStats.values.length) return (0, $326c1dabb495b1d6$export$fed62ccc3fb1a568)(origin, target);
        return (0, $c5c22880df3796c2$export$a4627e546088548d)($7f4bfb007437a8ac$export$3bbefa2f402845c4($7f4bfb007437a8ac$var$matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, $fbe9f318b7b09044$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`, "complex-values-different");
        return (0, $e8dffd34c64d5158$export$a6f92d4bae65c0f1)(origin, target);
    }
};



function $d18b3a06ee6c9c04$export$2c9e8a9632a706b2(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, $be9fc9b72a711b93$export$3bb0b4ff1037b8dd)(from, to, p);
    const mixer = (0, $7f4bfb007437a8ac$export$36ec24672cd098e0)(from);
    return mixer(from, to);
}




const $4d9396ad3ac58af1$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: (keepAlive = true)=>(0, $1fc179758a6fb1d9$export$2cef06c20297c17d).update(passTimestamp, keepAlive),
        stop: ()=>(0, $1fc179758a6fb1d9$export$ec99c0ef4978dccb)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $1fc179758a6fb1d9$export$fff89137e9e818ce).isProcessing ? (0, $1fc179758a6fb1d9$export$fff89137e9e818ce).timestamp : (0, $fa7790817f905603$export$2da9be4cfdb689b1).now()
    };
};



const $69cb28fe1a379f6b$export$66d3851e2b1ec912 = (easing, duration, resolution = 10 // as milliseconds
)=>{
    let points = "";
    const numPoints = Math.max(Math.round(duration / resolution), 2);
    for(let i = 0; i < numPoints; i++)points += Math.round(easing(i / (numPoints - 1)) * 10000) / 10000 + ", ";
    return `linear(${points.substring(0, points.length - 2)})`;
};


/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $5c909f44513f233e$export$f4ff70a5b4808fd8 = 20000;
function $5c909f44513f233e$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $5c909f44513f233e$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $5c909f44513f233e$export$f4ff70a5b4808fd8 ? Infinity : duration;
}




/**
 * Create a progress => progress easing function from a generator.
 */ function $729017bd1753a405$export$7f1511d09ee75a99(options, scale = 100, createGenerator) {
    const generator = createGenerator({
        ...options,
        keyframes: [
            0,
            scale
        ]
    });
    const duration = Math.min((0, $5c909f44513f233e$export$cbdd6b3d40ea54e2)(generator), (0, $5c909f44513f233e$export$f4ff70a5b4808fd8));
    return {
        type: "keyframes",
        ease: (progress)=>{
            return generator.next(duration * progress).value / scale;
        },
        duration: (0, $891d0606d6764488$export$f64c3bfbc58eec0f)(duration)
    };
}



const $adcc7b12b885af4d$var$velocitySampleDuration = 5; // ms
function $adcc7b12b885af4d$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $adcc7b12b885af4d$var$velocitySampleDuration, 0);
    return (0, $50d2e38bc0676790$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}


const $f0c6d931723f0d9a$export$86436497e7b05d16 = {
    // Default spring physics
    stiffness: 100,
    damping: 10,
    mass: 1.0,
    velocity: 0.0,
    // Default duration/bounce-based options
    duration: 800,
    bounce: 0.3,
    visualDuration: 0.3,
    // Rest thresholds
    restSpeed: {
        granular: 0.01,
        default: 2
    },
    restDelta: {
        granular: 0.005,
        default: 0.5
    },
    // Limits
    minDuration: 0.01,
    maxDuration: 10.0,
    minDamping: 0.05,
    maxDamping: 1
};




const $f750997f56957331$var$safeMin = 0.001;
function $f750997f56957331$export$b15f158dc6d6f458({ duration: duration = (0, $f0c6d931723f0d9a$export$86436497e7b05d16).duration, bounce: bounce = (0, $f0c6d931723f0d9a$export$86436497e7b05d16).bounce, velocity: velocity = (0, $f0c6d931723f0d9a$export$86436497e7b05d16).velocity, mass: mass = (0, $f0c6d931723f0d9a$export$86436497e7b05d16).mass }) {
    let envelope;
    let derivative;
    (0, $fbe9f318b7b09044$export$491112666e282270)(duration <= (0, $891d0606d6764488$export$fc3e7e8557f8c8c7)((0, $f0c6d931723f0d9a$export$86436497e7b05d16).maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $10aeec2c389b2314$export$7d15b64cf5a3a4c4)((0, $f0c6d931723f0d9a$export$86436497e7b05d16).minDamping, (0, $f0c6d931723f0d9a$export$86436497e7b05d16).maxDamping, dampingRatio);
    duration = (0, $10aeec2c389b2314$export$7d15b64cf5a3a4c4)((0, $f0c6d931723f0d9a$export$86436497e7b05d16).minDuration, (0, $f0c6d931723f0d9a$export$86436497e7b05d16).maxDuration, (0, $891d0606d6764488$export$f64c3bfbc58eec0f)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $f750997f56957331$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $f750997f56957331$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $f750997f56957331$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $f750997f56957331$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$f750997f56957331$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $f750997f56957331$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $891d0606d6764488$export$fc3e7e8557f8c8c7)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: (0, $f0c6d931723f0d9a$export$86436497e7b05d16).stiffness,
        damping: (0, $f0c6d931723f0d9a$export$86436497e7b05d16).damping,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $f750997f56957331$var$rootIterations = 12;
function $f750997f56957331$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $f750997f56957331$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $f750997f56957331$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}


const $da8d26ec9d894a38$var$durationKeys = [
    "duration",
    "bounce"
];
const $da8d26ec9d894a38$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $da8d26ec9d894a38$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $da8d26ec9d894a38$var$getSpringOptions(options) {
    let springOptions = {
        velocity: (0, $f0c6d931723f0d9a$export$86436497e7b05d16).velocity,
        stiffness: (0, $f0c6d931723f0d9a$export$86436497e7b05d16).stiffness,
        damping: (0, $f0c6d931723f0d9a$export$86436497e7b05d16).damping,
        mass: (0, $f0c6d931723f0d9a$export$86436497e7b05d16).mass,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$da8d26ec9d894a38$var$isSpringType(options, $da8d26ec9d894a38$var$physicsKeys) && $da8d26ec9d894a38$var$isSpringType(options, $da8d26ec9d894a38$var$durationKeys)) {
        if (options.visualDuration) {
            const visualDuration = options.visualDuration;
            const root = 2 * Math.PI / (visualDuration * 1.2);
            const stiffness = root * root;
            const damping = 2 * (0, $10aeec2c389b2314$export$7d15b64cf5a3a4c4)(0.05, 1, 1 - (options.bounce || 0)) * Math.sqrt(stiffness);
            springOptions = {
                ...springOptions,
                mass: (0, $f0c6d931723f0d9a$export$86436497e7b05d16).mass,
                stiffness: stiffness,
                damping: damping
            };
        } else {
            const derived = (0, $f750997f56957331$export$b15f158dc6d6f458)(options);
            springOptions = {
                ...springOptions,
                ...derived,
                mass: (0, $f0c6d931723f0d9a$export$86436497e7b05d16).mass
            };
            springOptions.isResolvedFromDuration = true;
        }
    }
    return springOptions;
}
function $da8d26ec9d894a38$export$b36281d89752ae66(optionsOrVisualDuration = (0, $f0c6d931723f0d9a$export$86436497e7b05d16).visualDuration, bounce = (0, $f0c6d931723f0d9a$export$86436497e7b05d16).bounce) {
    const options = typeof optionsOrVisualDuration !== "object" ? {
        visualDuration: optionsOrVisualDuration,
        keyframes: [
            0,
            1
        ],
        bounce: bounce
    } : optionsOrVisualDuration;
    let { restSpeed: restSpeed, restDelta: restDelta } = options;
    const origin = options.keyframes[0];
    const target = options.keyframes[options.keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, duration: duration, velocity: velocity, isResolvedFromDuration: isResolvedFromDuration } = $da8d26ec9d894a38$var$getSpringOptions({
        ...options,
        velocity: -(0, $891d0606d6764488$export$f64c3bfbc58eec0f)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $891d0606d6764488$export$f64c3bfbc58eec0f)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? (0, $f0c6d931723f0d9a$export$86436497e7b05d16).restSpeed.granular : (0, $f0c6d931723f0d9a$export$86436497e7b05d16).restSpeed.default);
    restDelta || (restDelta = isGranularScale ? (0, $f0c6d931723f0d9a$export$86436497e7b05d16).restDelta.granular : (0, $f0c6d931723f0d9a$export$86436497e7b05d16).restDelta.default);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $f750997f56957331$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    const generator = {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = t === 0 ? initialVelocity : 0.0;
                /**
                 * We only need to calculate velocity for under-damped springs
                 * as over- and critically-damped springs can't overshoot, so
                 * checking only for displacement is enough.
                 */ if (dampingRatio < 1) currentVelocity = t === 0 ? (0, $891d0606d6764488$export$fc3e7e8557f8c8c7)(initialVelocity) : (0, $adcc7b12b885af4d$export$854187271d233eb5)(resolveSpring, t, current);
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        },
        toString: ()=>{
            const calculatedDuration = Math.min((0, $5c909f44513f233e$export$cbdd6b3d40ea54e2)(generator), (0, $5c909f44513f233e$export$f4ff70a5b4808fd8));
            const easing = (0, $69cb28fe1a379f6b$export$66d3851e2b1ec912)((progress)=>generator.next(calculatedDuration * progress).value, calculatedDuration, 30);
            return calculatedDuration + "ms " + easing;
        },
        toTransition: ()=>{}
    };
    return generator;
}
$da8d26ec9d894a38$export$b36281d89752ae66.applyToOptions = (options)=>{
    const generatorOptions = (0, $729017bd1753a405$export$7f1511d09ee75a99)(options, 100, $da8d26ec9d894a38$export$b36281d89752ae66);
    options.ease = generatorOptions.ease;
    options.duration = (0, $891d0606d6764488$export$fc3e7e8557f8c8c7)(generatorOptions.duration);
    options.type = "keyframes";
    return options;
};



function $63cc59478059cc35$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $da8d26ec9d894a38$export$b36281d89752ae66)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $adcc7b12b885af4d$export$854187271d233eb5)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}



/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticeably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $aca15d3800bf9e02$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $aca15d3800bf9e02$var$subdivisionPrecision = 0.0000001;
const $aca15d3800bf9e02$var$subdivisionMaxIterations = 12;
function $aca15d3800bf9e02$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $aca15d3800bf9e02$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $aca15d3800bf9e02$var$subdivisionPrecision && ++i < $aca15d3800bf9e02$var$subdivisionMaxIterations);
    return currentT;
}
function $aca15d3800bf9e02$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $d6ca2382cab65984$export$8793edee2d425525;
    const getTForX = (aX)=>$aca15d3800bf9e02$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $aca15d3800bf9e02$var$calcBezier(getTForX(t), mY1, mY2);
}


const $bb0b957dc097fcc7$export$929e5a82286172a6 = /*@__PURE__*/ (0, $aca15d3800bf9e02$export$2c575fa1d20488bd)(0.42, 0, 1, 1);
const $bb0b957dc097fcc7$export$57636bb43b1ccbb0 = /*@__PURE__*/ (0, $aca15d3800bf9e02$export$2c575fa1d20488bd)(0, 0, 0.58, 1);
const $bb0b957dc097fcc7$export$c07234257a03d5e9 = /*@__PURE__*/ (0, $aca15d3800bf9e02$export$2c575fa1d20488bd)(0.42, 0, 0.58, 1);




// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $d9690b0cfc0e265a$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $066975e8f1278991$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $537c5f6932b570cf$export$77edfce482316a60 = /*@__PURE__*/ (0, $aca15d3800bf9e02$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $537c5f6932b570cf$export$b01116c84cdfe1a2 = /*@__PURE__*/ (0, $066975e8f1278991$export$2c07eeff45156d4d)($537c5f6932b570cf$export$77edfce482316a60);
const $537c5f6932b570cf$export$ddc5fd596f6c71b2 = /*@__PURE__*/ (0, $d9690b0cfc0e265a$export$f946554fb8aeaf0d)($537c5f6932b570cf$export$b01116c84cdfe1a2);


const $9c53f5638f3cf35f$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $537c5f6932b570cf$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));





const $2bb074bad255cd38$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $2bb074bad255cd38$export$c8d67a19199d1a50 = (0, $066975e8f1278991$export$2c07eeff45156d4d)($2bb074bad255cd38$export$e444123e42d03385);
const $2bb074bad255cd38$export$30d3455eee55bed5 = (0, $d9690b0cfc0e265a$export$f946554fb8aeaf0d)($2bb074bad255cd38$export$e444123e42d03385);




const $0bf4c4e168893afc$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";


const $7fd27e3dd8cf2d2c$var$easingLookup = {
    linear: (0, $d6ca2382cab65984$export$8793edee2d425525),
    easeIn: $bb0b957dc097fcc7$export$929e5a82286172a6,
    easeInOut: $bb0b957dc097fcc7$export$c07234257a03d5e9,
    easeOut: $bb0b957dc097fcc7$export$57636bb43b1ccbb0,
    circIn: $2bb074bad255cd38$export$e444123e42d03385,
    circInOut: $2bb074bad255cd38$export$30d3455eee55bed5,
    circOut: $2bb074bad255cd38$export$c8d67a19199d1a50,
    backIn: $537c5f6932b570cf$export$b01116c84cdfe1a2,
    backInOut: $537c5f6932b570cf$export$ddc5fd596f6c71b2,
    backOut: $537c5f6932b570cf$export$77edfce482316a60,
    anticipate: $9c53f5638f3cf35f$export$6b0af63b873d419e
};
const $7fd27e3dd8cf2d2c$var$isValidEasing = (easing)=>{
    return typeof easing === "string";
};
const $7fd27e3dd8cf2d2c$export$ef97fe084f156ca4 = (definition)=>{
    if ((0, $0bf4c4e168893afc$export$ff43f99925d7366b)(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $fbe9f318b7b09044$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`, "cubic-bezier-length");
        const [x1, y1, x2, y2] = definition;
        return (0, $aca15d3800bf9e02$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if ($7fd27e3dd8cf2d2c$var$isValidEasing(definition)) {
        // Else lookup from table
        (0, $fbe9f318b7b09044$export$f5708dca728d7177)($7fd27e3dd8cf2d2c$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`, "invalid-easing-type");
        return $7fd27e3dd8cf2d2c$var$easingLookup[definition];
    }
    return definition;
};

const $f8448fec4791fb7a$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};


/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ /*#__NO_SIDE_EFFECTS__*/ const $89ae9d711a24132c$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};



function $e9da5fb9b12636fe$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || (0, $502ec5afb929f350$export$dd826089e3c5e502).mix || (0, $d18b3a06ee6c9c04$export$2c9e8a9632a706b2);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $d6ca2382cab65984$export$8793edee2d425525) : ease;
            mixer = (0, $c5c22880df3796c2$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revisit this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $e9da5fb9b12636fe$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $fbe9f318b7b09044$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length", "range-length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    if (inputLength === 2 && output[0] === output[1]) return ()=>output[1];
    const isZeroDeltaRange = input[0] === input[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $e9da5fb9b12636fe$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        if (isZeroDeltaRange && v < input[0]) return output[0];
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $89ae9d711a24132c$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $10aeec2c389b2314$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}




function $9bca39c9fe13f746$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $89ae9d711a24132c$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $be9fc9b72a711b93$export$3bb0b4ff1037b8dd)(min, 1, offsetProgress));
    }
}


function $aaf1bf4874962317$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $9bca39c9fe13f746$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}


function $ab53af72f0332d79$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}


function $8a7386595e1be9ca$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $bb0b957dc097fcc7$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $8a7386595e1be9ca$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $f8448fec4791fb7a$export$216948827bbdc797)(ease) ? ease.map((0, $7fd27e3dd8cf2d2c$export$ef97fe084f156ca4)) : (0, $7fd27e3dd8cf2d2c$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $ab53af72f0332d79$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $aaf1bf4874962317$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $e9da5fb9b12636fe$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $8a7386595e1be9ca$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}



const $935e5253f73fe3a1$var$isNotNull = (value)=>value !== null;
function $935e5253f73fe3a1$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }, finalKeyframe, speed = 1) {
    const resolvedKeyframes = keyframes.filter($935e5253f73fe3a1$var$isNotNull);
    const useFirstKeyframe = speed < 0 || repeat && repeatType !== "loop" && repeat % 2 === 1;
    const index = useFirstKeyframe ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}





const $3d3cdcee5ed0dde4$var$transitionTypeMap = {
    decay: (0, $63cc59478059cc35$export$ee3ff3a17106998),
    inertia: $63cc59478059cc35$export$ee3ff3a17106998,
    tween: (0, $8a7386595e1be9ca$export$d25ddfdf17c3ad3e),
    keyframes: (0, $8a7386595e1be9ca$export$d25ddfdf17c3ad3e),
    spring: $da8d26ec9d894a38$export$b36281d89752ae66
};
function $3d3cdcee5ed0dde4$export$98db6ef1242dfa2(transition) {
    if (typeof transition.type === "string") transition.type = $3d3cdcee5ed0dde4$var$transitionTypeMap[transition.type];
}


class $4045fc94dc18c996$export$655db786091c33e0 {
    constructor(){
        this.updateFinished();
    }
    get finished() {
        return this._finished;
    }
    updateFinished() {
        this._finished = new Promise((resolve)=>{
            this.resolve = resolve;
        });
    }
    notifyFinished() {
        this.resolve();
    }
    /**
     * Allows the animation to be awaited.
     *
     * @deprecated Use `finished` instead.
     */ then(onResolve, onReject) {
        return this.finished.then(onResolve, onReject);
    }
}


const $2ddbb829946dfd7d$var$percentToProgress = (percent)=>percent / 100;
class $2ddbb829946dfd7d$export$3394f837405475c7 extends (0, $4045fc94dc18c996$export$655db786091c33e0) {
    constructor(options){
        super();
        this.state = "idle";
        this.startTime = null;
        this.isStopped = false;
        /**
         * The current time of the animation.
         */ this.currentTime = 0;
        /**
         * The time at which the animation was paused.
         */ this.holdTime = null;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ this.playbackSpeed = 1;
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ this.stop = ()=>{
            const { motionValue: motionValue } = this.options;
            if (motionValue && motionValue.updatedAt !== (0, $fa7790817f905603$export$2da9be4cfdb689b1).now()) this.tick((0, $fa7790817f905603$export$2da9be4cfdb689b1).now());
            this.isStopped = true;
            if (this.state === "idle") return;
            this.teardown();
            this.options.onStop?.();
        };
        (0, $c27f978081fc4187$export$d921fb2475e2900c).mainThread++;
        this.options = options;
        this.initAnimation();
        this.play();
        if (options.autoplay === false) this.pause();
    }
    initAnimation() {
        const { options: options } = this;
        (0, $3d3cdcee5ed0dde4$export$98db6ef1242dfa2)(options);
        const { type: type = (0, $8a7386595e1be9ca$export$d25ddfdf17c3ad3e), repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType, velocity: velocity = 0 } = options;
        let { keyframes: keyframes$1 } = options;
        const generatorFactory = type || (0, $8a7386595e1be9ca$export$d25ddfdf17c3ad3e);
        if (generatorFactory !== (0, $8a7386595e1be9ca$export$d25ddfdf17c3ad3e)) (0, $fbe9f318b7b09044$export$f5708dca728d7177)(keyframes$1.length <= 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${keyframes$1}`, "spring-two-frames");
        if (generatorFactory !== (0, $8a7386595e1be9ca$export$d25ddfdf17c3ad3e) && typeof keyframes$1[0] !== "number") {
            this.mixKeyframes = (0, $c5c22880df3796c2$export$a4627e546088548d)($2ddbb829946dfd7d$var$percentToProgress, (0, $d18b3a06ee6c9c04$export$2c9e8a9632a706b2)(keyframes$1[0], keyframes$1[1]));
            keyframes$1 = [
                0,
                100
            ];
        }
        const generator = generatorFactory({
            ...options,
            keyframes: keyframes$1
        });
        /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") this.mirroredGenerator = generatorFactory({
            ...options,
            keyframes: [
                ...keyframes$1
            ].reverse(),
            velocity: -velocity
        });
        /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, $5c909f44513f233e$export$cbdd6b3d40ea54e2)(generator);
        const { calculatedDuration: calculatedDuration } = generator;
        this.calculatedDuration = calculatedDuration;
        this.resolvedDuration = calculatedDuration + repeatDelay;
        this.totalDuration = this.resolvedDuration * (repeat + 1) - repeatDelay;
        this.generator = generator;
    }
    updateTime(timestamp) {
        const animationTime = Math.round(timestamp - this.startTime) * this.playbackSpeed;
        // Update currentTime
        if (this.holdTime !== null) this.currentTime = this.holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        this.currentTime = animationTime;
    }
    tick(timestamp, sample = false) {
        const { generator: generator, totalDuration: totalDuration, mixKeyframes: mixKeyframes, mirroredGenerator: mirroredGenerator, resolvedDuration: resolvedDuration, calculatedDuration: calculatedDuration } = this;
        if (this.startTime === null) return generator.next(0);
        const { delay: delay = 0, keyframes: keyframes, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, type: type, onUpdate: onUpdate, finalKeyframe: finalKeyframe } = this.options;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
        else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
        if (sample) this.currentTime = timestamp;
        else this.updateTime(timestamp);
        // Rebase on delay
        const timeWithoutDelay = this.currentTime - delay * (this.playbackSpeed >= 0 ? 1 : -1);
        const isInDelayPhase = this.playbackSpeed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        this.currentTime = Math.max(timeWithoutDelay, 0);
        // If this animation has finished, set the current time  to the total duration.
        if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
        let elapsed = this.currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $10aeec2c389b2314$export$7d15b64cf5a3a4c4)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes[0]
        } : frameGenerator.next(elapsed);
        if (mixKeyframes) state.value = mixKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = this.playbackSpeed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
        const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
        // TODO: The exception for inertia could be cleaner here
        if (isAnimationFinished && type !== (0, $63cc59478059cc35$export$ee3ff3a17106998)) state.value = (0, $935e5253f73fe3a1$export$14de59408fad90b)(keyframes, this.options, finalKeyframe, this.speed);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) this.finish();
        return state;
    }
    /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ then(resolve, reject) {
        return this.finished.then(resolve, reject);
    }
    get duration() {
        return (0, $891d0606d6764488$export$f64c3bfbc58eec0f)(this.calculatedDuration);
    }
    get iterationDuration() {
        const { delay: delay = 0 } = this.options || {};
        return this.duration + (0, $891d0606d6764488$export$f64c3bfbc58eec0f)(delay);
    }
    get time() {
        return (0, $891d0606d6764488$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    set time(newTime) {
        newTime = (0, $891d0606d6764488$export$fc3e7e8557f8c8c7)(newTime);
        this.currentTime = newTime;
        if (this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0) this.holdTime = newTime;
        else if (this.driver) this.startTime = this.driver.now() - newTime / this.playbackSpeed;
        this.driver?.start(false);
    }
    get speed() {
        return this.playbackSpeed;
    }
    set speed(newSpeed) {
        this.updateTime((0, $fa7790817f905603$export$2da9be4cfdb689b1).now());
        const hasChanged = this.playbackSpeed !== newSpeed;
        this.playbackSpeed = newSpeed;
        if (hasChanged) this.time = (0, $891d0606d6764488$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    play() {
        if (this.isStopped) return;
        const { driver: driver = (0, $4d9396ad3ac58af1$export$c1033964b5ad7fef), startTime: startTime } = this.options;
        if (!this.driver) this.driver = driver((timestamp)=>this.tick(timestamp));
        this.options.onPlay?.();
        const now = this.driver.now();
        if (this.state === "finished") {
            this.updateFinished();
            this.startTime = now;
        } else if (this.holdTime !== null) this.startTime = now - this.holdTime;
        else if (!this.startTime) this.startTime = startTime ?? now;
        if (this.state === "finished" && this.speed < 0) this.startTime += this.calculatedDuration;
        this.holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
        this.driver.start();
    }
    pause() {
        this.state = "paused";
        this.updateTime((0, $fa7790817f905603$export$2da9be4cfdb689b1).now());
        this.holdTime = this.currentTime;
    }
    complete() {
        if (this.state !== "running") this.play();
        this.state = "finished";
        this.holdTime = null;
    }
    finish() {
        this.notifyFinished();
        this.teardown();
        this.state = "finished";
        this.options.onComplete?.();
    }
    cancel() {
        this.holdTime = null;
        this.startTime = 0;
        this.tick(0);
        this.teardown();
        this.options.onCancel?.();
    }
    teardown() {
        this.state = "idle";
        this.stopDriver();
        this.startTime = this.holdTime = null;
        (0, $c27f978081fc4187$export$d921fb2475e2900c).mainThread--;
    }
    stopDriver() {
        if (!this.driver) return;
        this.driver.stop();
        this.driver = undefined;
    }
    sample(sampleTime) {
        this.startTime = 0;
        return this.tick(sampleTime, true);
    }
    attachTimeline(timeline) {
        if (this.options.allowFlatten) {
            this.options.type = "keyframes";
            this.options.ease = "linear";
            this.initAnimation();
        }
        this.driver?.stop();
        return timeline.observe(this);
    }
}
// Legacy function support
function $2ddbb829946dfd7d$export$ee9b76de7353d815(options) {
    return new $2ddbb829946dfd7d$export$3394f837405475c7(options);
}







const $30b48255dbf601b2$export$c9f584638d388483 = (name)=>name.startsWith("--");


function $75b6fb2fca9b123c$export$37a5fde709c1db82(element, name, value) {
    (0, $30b48255dbf601b2$export$c9f584638d388483)(name) ? element.style.setProperty(name, value) : element.style[name] = value;
}


/*#__NO_SIDE_EFFECTS__*/ function $03b1e113dfb94491$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}


const $8ac1d844d9312523$export$20d68f04f30763a5 = /* @__PURE__ */ (0, $03b1e113dfb94491$export$7c73462e0d25e514)(()=>window.ScrollTimeline !== undefined);








/**
 * Add the ability for test suites to manually set support flags
 * to better test more environments.
 */ const $bed8dc94a895aa99$export$e3ad02c335474dee = {};


function $2a91f6688812e326$export$1964673d5ec13c3a(callback, supportsFlag) {
    const memoized = (0, $03b1e113dfb94491$export$7c73462e0d25e514)(callback);
    return ()=>(0, $bed8dc94a895aa99$export$e3ad02c335474dee)[supportsFlag] ?? memoized();
}


const $1434703073c509f8$export$866c1d07a1ac2ab = /*@__PURE__*/ (0, $2a91f6688812e326$export$1964673d5ec13c3a)(()=>{
    try {
        document.createElement("div").animate({
            opacity: 0
        }, {
            easing: "linear(0, 1)"
        });
    } catch (e) {
        return false;
    }
    return true;
}, "linearEasing");



const $262cb0f90b197612$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;



const $9c754dab1ec7a3f5$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: /*@__PURE__*/ (0, $262cb0f90b197612$export$2523b8f0bd8f44cb)([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: /*@__PURE__*/ (0, $262cb0f90b197612$export$2523b8f0bd8f44cb)([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: /*@__PURE__*/ (0, $262cb0f90b197612$export$2523b8f0bd8f44cb)([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: /*@__PURE__*/ (0, $262cb0f90b197612$export$2523b8f0bd8f44cb)([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};


function $b36e7d2c15e9de9f$export$916ea73bcd3a6030(easing, duration) {
    if (!easing) return undefined;
    else if (typeof easing === "function") return (0, $1434703073c509f8$export$866c1d07a1ac2ab)() ? (0, $69cb28fe1a379f6b$export$66d3851e2b1ec912)(easing, duration) : "ease-out";
    else if ((0, $0bf4c4e168893afc$export$ff43f99925d7366b)(easing)) return (0, $262cb0f90b197612$export$2523b8f0bd8f44cb)(easing);
    else if (Array.isArray(easing)) return easing.map((segmentEasing)=>$b36e7d2c15e9de9f$export$916ea73bcd3a6030(segmentEasing, duration) || (0, $9c754dab1ec7a3f5$export$2cf569f5e2221176).easeOut);
    else return (0, $9c754dab1ec7a3f5$export$2cf569f5e2221176)[easing];
}


function $3d20f6c46466222a$export$d896de52f97cb615(element, valueName, keyframes, { delay: delay = 0, duration: duration = 300, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease = "easeOut", times: times } = {}, pseudoElement) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $b36e7d2c15e9de9f$export$916ea73bcd3a6030)(ease, duration);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    if ((0, $047730deae5140b7$export$84ce9a476f53d110).value) (0, $c27f978081fc4187$export$d921fb2475e2900c).waapi++;
    const options = {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    };
    if (pseudoElement) options.pseudoElement = pseudoElement;
    const animation = element.animate(keyframeOptions, options);
    if ((0, $047730deae5140b7$export$84ce9a476f53d110).value) animation.finished.finally(()=>{
        (0, $c27f978081fc4187$export$d921fb2475e2900c).waapi--;
    });
    return animation;
}



function $22c361e3b5591215$export$6ab7812f1bac68be(type) {
    return typeof type === "function" && "applyToOptions" in type;
}


function $3e0d413ede1817ee$export$a31269144d66b4a({ type: type, ...options }) {
    if ((0, $22c361e3b5591215$export$6ab7812f1bac68be)(type) && (0, $1434703073c509f8$export$866c1d07a1ac2ab)()) return type.applyToOptions(options);
    else {
        options.duration ?? (options.duration = 300);
        options.ease ?? (options.ease = "easeOut");
    }
    return options;
}


/**
 * NativeAnimation implements AnimationPlaybackControls for the browser's Web Animations API.
 */ class $70bd9d932d4a7829$export$6c0f9803d8aa7219 extends (0, $4045fc94dc18c996$export$655db786091c33e0) {
    constructor(options){
        super();
        this.finishedTime = null;
        this.isStopped = false;
        if (!options) return;
        const { element: element, name: name, keyframes: keyframes, pseudoElement: pseudoElement, allowFlatten: allowFlatten = false, finalKeyframe: finalKeyframe, onComplete: onComplete } = options;
        this.isPseudoElement = Boolean(pseudoElement);
        this.allowFlatten = allowFlatten;
        this.options = options;
        (0, $fbe9f318b7b09044$export$f5708dca728d7177)(typeof options.type !== "string", `Mini animate() doesn't support "type" as a string.`, "mini-spring");
        const transition = (0, $3e0d413ede1817ee$export$a31269144d66b4a)(options);
        this.animation = (0, $3d20f6c46466222a$export$d896de52f97cb615)(element, name, keyframes, transition, pseudoElement);
        if (transition.autoplay === false) this.animation.pause();
        this.animation.onfinish = ()=>{
            this.finishedTime = this.time;
            if (!pseudoElement) {
                const keyframe = (0, $935e5253f73fe3a1$export$14de59408fad90b)(keyframes, this.options, finalKeyframe, this.speed);
                if (this.updateMotionValue) this.updateMotionValue(keyframe);
                else /**
                     * If we can, we want to commit the final style as set by the user,
                     * rather than the computed keyframe value supplied by the animation.
                     */ (0, $75b6fb2fca9b123c$export$37a5fde709c1db82)(element, name, keyframe);
                this.animation.cancel();
            }
            onComplete?.();
            this.notifyFinished();
        };
    }
    play() {
        if (this.isStopped) return;
        this.animation.play();
        if (this.state === "finished") this.updateFinished();
    }
    pause() {
        this.animation.pause();
    }
    complete() {
        this.animation.finish?.();
    }
    cancel() {
        try {
            this.animation.cancel();
        } catch (e) {}
    }
    stop() {
        if (this.isStopped) return;
        this.isStopped = true;
        const { state: state } = this;
        if (state === "idle" || state === "finished") return;
        if (this.updateMotionValue) this.updateMotionValue();
        else this.commitStyles();
        if (!this.isPseudoElement) this.cancel();
    }
    /**
     * WAAPI doesn't natively have any interruption capabilities.
     *
     * In this method, we commit styles back to the DOM before cancelling
     * the animation.
     *
     * This is designed to be overridden by NativeAnimationExtended, which
     * will create a renderless JS animation and sample it twice to calculate
     * its current value, "previous" value, and therefore allow
     * Motion to also correctly calculate velocity for any subsequent animation
     * while deferring the commit until the next animation frame.
     */ commitStyles() {
        if (!this.isPseudoElement) this.animation.commitStyles?.();
    }
    get duration() {
        const duration = this.animation.effect?.getComputedTiming?.().duration || 0;
        return (0, $891d0606d6764488$export$f64c3bfbc58eec0f)(Number(duration));
    }
    get iterationDuration() {
        const { delay: delay = 0 } = this.options || {};
        return this.duration + (0, $891d0606d6764488$export$f64c3bfbc58eec0f)(delay);
    }
    get time() {
        return (0, $891d0606d6764488$export$f64c3bfbc58eec0f)(Number(this.animation.currentTime) || 0);
    }
    set time(newTime) {
        this.finishedTime = null;
        this.animation.currentTime = (0, $891d0606d6764488$export$fc3e7e8557f8c8c7)(newTime);
    }
    /**
     * The playback speed of the animation.
     * 1 = normal speed, 2 = double speed, 0.5 = half speed.
     */ get speed() {
        return this.animation.playbackRate;
    }
    set speed(newSpeed) {
        // Allow backwards playback after finishing
        if (newSpeed < 0) this.finishedTime = null;
        this.animation.playbackRate = newSpeed;
    }
    get state() {
        return this.finishedTime !== null ? "finished" : this.animation.playState;
    }
    get startTime() {
        return Number(this.animation.startTime);
    }
    set startTime(newStartTime) {
        this.animation.startTime = newStartTime;
    }
    /**
     * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
     */ attachTimeline({ timeline: timeline, observe: observe }) {
        if (this.allowFlatten) this.animation.effect?.updateTiming({
            easing: "linear"
        });
        this.animation.onfinish = null;
        if (timeline && (0, $8ac1d844d9312523$export$20d68f04f30763a5)()) {
            this.animation.timeline = timeline;
            return 0, $d6ca2382cab65984$export$8793edee2d425525;
        } else return observe(this);
    }
}




const $e316529608551002$var$unsupportedEasingFunctions = {
    anticipate: $9c53f5638f3cf35f$export$6b0af63b873d419e,
    backInOut: $537c5f6932b570cf$export$ddc5fd596f6c71b2,
    circInOut: $2bb074bad255cd38$export$30d3455eee55bed5
};
function $e316529608551002$var$isUnsupportedEase(key) {
    return key in $e316529608551002$var$unsupportedEasingFunctions;
}
function $e316529608551002$export$5195f232c29d1f82(transition) {
    if (typeof transition.ease === "string" && $e316529608551002$var$isUnsupportedEase(transition.ease)) transition.ease = $e316529608551002$var$unsupportedEasingFunctions[transition.ease];
}


/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $c84355779d5a9151$var$sampleDelta = 10; //ms
class $c84355779d5a9151$export$bd2cd6a048093d96 extends (0, $70bd9d932d4a7829$export$6c0f9803d8aa7219) {
    constructor(options){
        /**
         * The base NativeAnimation function only supports a subset
         * of Motion easings, and WAAPI also only supports some
         * easing functions via string/cubic-bezier definitions.
         *
         * This function replaces those unsupported easing functions
         * with a JS easing function. This will later get compiled
         * to a linear() easing function.
         */ (0, $e316529608551002$export$5195f232c29d1f82)(options);
        /**
         * Ensure we replace the transition type with a generator function
         * before passing to WAAPI.
         *
         * TODO: Does this have a better home? It could be shared with
         * JSAnimation.
         */ (0, $3d3cdcee5ed0dde4$export$98db6ef1242dfa2)(options);
        super(options);
        if (options.startTime) this.startTime = options.startTime;
        this.options = options;
    }
    /**
     * WAAPI doesn't natively have any interruption capabilities.
     *
     * Rather than read commited styles back out of the DOM, we can
     * create a renderless JS animation and sample it twice to calculate
     * its current value, "previous" value, and therefore allow
     * Motion to calculate velocity for any subsequent animation.
     */ updateMotionValue(value) {
        const { motionValue: motionValue, onUpdate: onUpdate, onComplete: onComplete, element: element, ...options } = this.options;
        if (!motionValue) return;
        if (value !== undefined) {
            motionValue.set(value);
            return;
        }
        const sampleAnimation = new (0, $2ddbb829946dfd7d$export$3394f837405475c7)({
            ...options,
            autoplay: false
        });
        const sampleTime = (0, $891d0606d6764488$export$fc3e7e8557f8c8c7)(this.finishedTime ?? this.time);
        motionValue.setWithVelocity(sampleAnimation.sample(sampleTime - $c84355779d5a9151$var$sampleDelta).value, sampleAnimation.sample(sampleTime).value, $c84355779d5a9151$var$sampleDelta);
        sampleAnimation.stop();
    }
}





/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $feb59fe8e0062d84$export$65676b58b122bc38 = (value, name)=>{
    // If the list of keys that might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $1c1147c837df3766$export$83a0e34f1302825b).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};


function $fe22d9552a912afd$var$hasKeyframesChanged(keyframes) {
    const current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(let i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function $fe22d9552a912afd$export$1b109e6c9968df4f(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ const originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    const targetKeyframe = keyframes[keyframes.length - 1];
    const isOriginAnimatable = (0, $feb59fe8e0062d84$export$65676b58b122bc38)(originKeyframe, name);
    const isTargetAnimatable = (0, $feb59fe8e0062d84$export$65676b58b122bc38)(targetKeyframe, name);
    (0, $fbe9f318b7b09044$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". "${isOriginAnimatable ? targetKeyframe : originKeyframe}" is not an animatable value.`, "value-not-animatable");
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return $fe22d9552a912afd$var$hasKeyframesChanged(keyframes) || (type === "spring" || (0, $22c361e3b5591215$export$6ab7812f1bac68be)(type)) && velocity;
}


function $bc8c3b50b4d4e4cd$export$b2585dd3c345da47(options) {
    options.duration = 0;
    options.type = "keyframes";
}




/**
 * A list of values that can be hardware-accelerated.
 */ const $9f02c03710e30a39$var$acceleratedValues = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);
const $9f02c03710e30a39$var$supportsWaapi = /*@__PURE__*/ (0, $03b1e113dfb94491$export$7c73462e0d25e514)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));
function $9f02c03710e30a39$export$ea92bde116fda821(options) {
    const { motionValue: motionValue, name: name, repeatDelay: repeatDelay, repeatType: repeatType, damping: damping, type: type } = options;
    const subject = motionValue?.owner?.current;
    /**
     * We use this check instead of isHTMLElement() because we explicitly
     * **don't** want elements in different timing contexts (i.e. popups)
     * to be accelerated, as it's not possible to sync these animations
     * properly with those driven from the main window frameloop.
     */ if (!(subject instanceof HTMLElement)) return false;
    const { onUpdate: onUpdate, transformTemplate: transformTemplate } = motionValue.owner.getProps();
    return $9f02c03710e30a39$var$supportsWaapi() && name && $9f02c03710e30a39$var$acceleratedValues.has(name) && (name !== "transform" || !transformTemplate) && /**
         * If we're outputting values to onUpdate then we can't use WAAPI as there's
         * no way to read the value from WAAPI every frame.
         */ !onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
}


/**
 * Maximum time allowed between an animation being created and it being
 * resolved for us to use the latter as the start time.
 *
 * This is to ensure that while we prefer to "start" an animation as soon
 * as it's triggered, we also want to avoid a visual jump if there's a big delay
 * between these two moments.
 */ const $e9cdff58ee5dda59$var$MAX_RESOLVE_DELAY = 40;
class $e9cdff58ee5dda59$export$b9855e2a7dee3dd2 extends (0, $4045fc94dc18c996$export$655db786091c33e0) {
    constructor({ autoplay: autoplay = true, delay: delay = 0, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", keyframes: keyframes, name: name, motionValue: motionValue, element: element, ...options }){
        super();
        /**
         * Bound to support return animation.stop pattern
         */ this.stop = ()=>{
            if (this._animation) {
                this._animation.stop();
                this.stopTimeline?.();
            }
            this.keyframeResolver?.cancel();
        };
        this.createdAt = (0, $fa7790817f905603$export$2da9be4cfdb689b1).now();
        const optionsWithDefaults = {
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType,
            name: name,
            motionValue: motionValue,
            element: element,
            ...options
        };
        const KeyframeResolver$1 = element?.KeyframeResolver || (0, $c982fbe82ecf7d0b$export$74d34ca3182f1750);
        this.keyframeResolver = new KeyframeResolver$1(keyframes, (resolvedKeyframes, finalKeyframe, forced)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe, optionsWithDefaults, !forced), name, motionValue, element);
        this.keyframeResolver?.scheduleResolve();
    }
    onKeyframesResolved(keyframes, finalKeyframe, options, sync) {
        this.keyframeResolver = undefined;
        const { name: name, type: type, velocity: velocity, delay: delay, isHandoff: isHandoff, onUpdate: onUpdate } = options;
        this.resolvedAt = (0, $fa7790817f905603$export$2da9be4cfdb689b1).now();
        /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ if (!(0, $fe22d9552a912afd$export$1b109e6c9968df4f)(keyframes, name, type, velocity)) {
            if ((0, $502ec5afb929f350$export$dd826089e3c5e502).instantAnimations || !delay) onUpdate?.((0, $935e5253f73fe3a1$export$14de59408fad90b)(keyframes, options, finalKeyframe));
            keyframes[0] = keyframes[keyframes.length - 1];
            (0, $bc8c3b50b4d4e4cd$export$b2585dd3c345da47)(options);
            options.repeat = 0;
        }
        /**
         * Resolve startTime for the animation.
         *
         * This method uses the createdAt and resolvedAt to calculate the
         * animation startTime. *Ideally*, we would use the createdAt time as t=0
         * as the following frame would then be the first frame of the animation in
         * progress, which would feel snappier.
         *
         * However, if there's a delay (main thread work) between the creation of
         * the animation and the first commited frame, we prefer to use resolvedAt
         * to avoid a sudden jump into the animation.
         */ const startTime = sync ? !this.resolvedAt ? this.createdAt : this.resolvedAt - this.createdAt > $e9cdff58ee5dda59$var$MAX_RESOLVE_DELAY ? this.resolvedAt : this.createdAt : undefined;
        const resolvedOptions = {
            startTime: startTime,
            finalKeyframe: finalKeyframe,
            ...options,
            keyframes: keyframes
        };
        /**
         * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
         * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
         * optimised animation.
         */ const animation = !isHandoff && (0, $9f02c03710e30a39$export$ea92bde116fda821)(resolvedOptions) ? new (0, $c84355779d5a9151$export$bd2cd6a048093d96)({
            ...resolvedOptions,
            element: resolvedOptions.motionValue.owner.current
        }) : new (0, $2ddbb829946dfd7d$export$3394f837405475c7)(resolvedOptions);
        animation.finished.then(()=>this.notifyFinished()).catch((0, $d6ca2382cab65984$export$8793edee2d425525));
        if (this.pendingTimeline) {
            this.stopTimeline = animation.attachTimeline(this.pendingTimeline);
            this.pendingTimeline = undefined;
        }
        this._animation = animation;
    }
    get finished() {
        if (!this._animation) return this._finished;
        else return this.animation.finished;
    }
    then(onResolve, _onReject) {
        return this.finished.finally(onResolve).then(()=>{});
    }
    get animation() {
        if (!this._animation) {
            this.keyframeResolver?.resume();
            (0, $c982fbe82ecf7d0b$export$78b96d2a12593b05)();
        }
        return this._animation;
    }
    get duration() {
        return this.animation.duration;
    }
    get iterationDuration() {
        return this.animation.iterationDuration;
    }
    get time() {
        return this.animation.time;
    }
    set time(newTime) {
        this.animation.time = newTime;
    }
    get speed() {
        return this.animation.speed;
    }
    get state() {
        return this.animation.state;
    }
    set speed(newSpeed) {
        this.animation.speed = newSpeed;
    }
    get startTime() {
        return this.animation.startTime;
    }
    attachTimeline(timeline) {
        if (this._animation) this.stopTimeline = this.animation.attachTimeline(timeline);
        else this.pendingTimeline = timeline;
        return ()=>this.stop();
    }
    play() {
        this.animation.play();
    }
    pause() {
        this.animation.pause();
    }
    complete() {
        this.animation.complete();
    }
    cancel() {
        if (this._animation) this.animation.cancel();
        this.keyframeResolver?.cancel();
    }
}



const $b7455746a6cabbfe$var$isNotNull = (value)=>value !== null;
function $b7455746a6cabbfe$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }, finalKeyframe) {
    const resolvedKeyframes = keyframes.filter($b7455746a6cabbfe$var$isNotNull);
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}



const $5f1d5ca1d398e82d$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $5f1d5ca1d398e82d$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $5f1d5ca1d398e82d$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $5f1d5ca1d398e82d$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $5f1d5ca1d398e82d$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $5f1d5ca1d398e82d$var$keyframesTransition;
    else if ((0, $807cad0c0e3f2e9a$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $5f1d5ca1d398e82d$var$criticallyDampedSpring(keyframes[1]) : $5f1d5ca1d398e82d$var$underDampedSpring;
    return $5f1d5ca1d398e82d$var$ease;
};


/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $83951ac351b4cbcd$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}


const $9e7a9f8af70c9aa6$export$90b3dfc33ff3548 = (name, value, target, transition = {}, element, isHandoff)=>(onComplete)=>{
        const valueTransition = (0, $339fe6708b513dab$export$7c1391340308742e)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ const delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $891d0606d6764488$export$fc3e7e8557f8c8c7)(delay);
        const options = {
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity(),
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            },
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        };
        /**
     * If there's no transition defined for this value, we can generate
     * unique transition settings for this value.
     */ if (!(0, $83951ac351b4cbcd$export$ca8e47dc8ed5a9d7)(valueTransition)) Object.assign(options, (0, $5f1d5ca1d398e82d$export$262124b154b9f1c0)(name, options));
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ options.duration && (options.duration = (0, $891d0606d6764488$export$fc3e7e8557f8c8c7)(options.duration));
        options.repeatDelay && (options.repeatDelay = (0, $891d0606d6764488$export$fc3e7e8557f8c8c7)(options.repeatDelay));
        /**
     * Support deprecated way to set initial value. Prefer keyframe syntax.
     */ if (options.from !== undefined) options.keyframes[0] = options.from;
        let shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            (0, $bc8c3b50b4d4e4cd$export$b2585dd3c345da47)(options);
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, $502ec5afb929f350$export$dd826089e3c5e502).instantAnimations || (0, $502ec5afb929f350$export$dd826089e3c5e502).skipAnimations) {
            shouldSkip = true;
            (0, $bc8c3b50b4d4e4cd$export$b2585dd3c345da47)(options);
            options.delay = 0;
        }
        /**
     * If the transition type or easing has been explicitly set by the user
     * then we don't want to allow flattening the animation.
     */ options.allowFlatten = !valueTransition.type && !valueTransition.ease;
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            const finalKeyframe = (0, $b7455746a6cabbfe$export$14de59408fad90b)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, $1fc179758a6fb1d9$export$2cef06c20297c17d).update(()=>{
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                return;
            }
        }
        return valueTransition.isSync ? new (0, $2ddbb829946dfd7d$export$3394f837405475c7)(options) : new (0, $e9cdff58ee5dda59$export$b9855e2a7dee3dd2)(options);
    };


/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $14d5e29c1a7af8ca$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $14d5e29c1a7af8ca$export$68cacfeee78d98d2(visualElement, targetAndTransition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = targetAndTransition;
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key, visualElement.latestValues[key] ?? null);
        const valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && $14d5e29c1a7af8ca$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            ...(0, $339fe6708b513dab$export$7c1391340308742e)(transition || {}, key)
        };
        /**
         * If the value is already at the defined target, skip the animation.
         */ const currentValue = value.get();
        if (currentValue !== undefined && !value.isAnimating && !Array.isArray(valueTarget) && valueTarget === currentValue && !valueTransition.velocity) continue;
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ let isHandoff = false;
        if (window.MotionHandoffAnimation) {
            const appearId = (0, $59a52f0eed0e0e03$export$5f8d21e84d1d84fc)(visualElement);
            if (appearId) {
                const startTime = window.MotionHandoffAnimation(appearId, key, (0, $1fc179758a6fb1d9$export$2cef06c20297c17d));
                if (startTime !== null) {
                    valueTransition.startTime = startTime;
                    isHandoff = true;
                }
            }
        }
        (0, $74e7c7f6c49b7323$export$3ac5aed310be0bee)(visualElement, key);
        value.start((0, $9e7a9f8af70c9aa6$export$90b3dfc33ff3548)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $994004d9eac5e5b8$export$c66c0d5db2a205d).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff));
        const animation = value.animation;
        if (animation) animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        (0, $1fc179758a6fb1d9$export$2cef06c20297c17d).update(()=>{
            transitionEnd && (0, $ea04fe669600292a$export$1f61c53461aff4a5)(visualElement, transitionEnd);
        });
    });
    return animations;
}



function $ee9e3da43a1ac506$export$6e01cb2cb232d79b(children, child, delayChildren, staggerChildren = 0, staggerDirection = 1) {
    const index = Array.from(children).sort((a, b)=>a.sortNodePosition(b)).indexOf(child);
    const numChildren = children.size;
    const maxStaggerDuration = (numChildren - 1) * staggerChildren;
    const delayIsFunction = typeof delayChildren === "function";
    return delayIsFunction ? delayChildren(index, numChildren) : staggerDirection === 1 ? index * staggerChildren : maxStaggerDuration - index * staggerChildren;
}



function $697c3fc694c39c2d$export$4709dc300705b2af(visualElement, variant, options = {}) {
    const resolved = (0, $58c1fda9d3891d8d$export$7b1b1c981f4f0558)(visualElement, variant, options.type === "exit" ? visualElement.presenceContext?.custom : undefined);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $14d5e29c1a7af8ca$export$68cacfeee78d98d2)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $697c3fc694c39c2d$var$animateChildren(visualElement, variant, forwardDelay, delayChildren, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $697c3fc694c39c2d$var$animateChildren(visualElement, variant, delay = 0, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    for (const child of visualElement.variantChildren){
        child.notify("AnimationStart", variant);
        animations.push($697c3fc694c39c2d$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delay + (typeof delayChildren === "function" ? 0 : delayChildren) + (0, $ee9e3da43a1ac506$export$6e01cb2cb232d79b)(visualElement.variantChildren, child, delayChildren, staggerChildren, staggerDirection)
        }).then(()=>child.notify("AnimationComplete", variant)));
    }
    return Promise.all(animations);
}


function $7d7d5f8a14d3a662$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $697c3fc694c39c2d$export$4709dc300705b2af)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $697c3fc694c39c2d$export$4709dc300705b2af)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $58c1fda9d3891d8d$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $14d5e29c1a7af8ca$export$68cacfeee78d98d2)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>{
        visualElement.notify("AnimationComplete", definition);
    });
}





function $21ec58272207c53a$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}




const $b67819dcbd44ec40$var$numVariantProps = (0, $0172fb3d3512f551$export$1405a65085f40b9).length;
function $b67819dcbd44ec40$export$6669f52f7ffa343b(visualElement) {
    if (!visualElement) return undefined;
    if (!visualElement.isControllingVariants) {
        const context = visualElement.parent ? $b67819dcbd44ec40$export$6669f52f7ffa343b(visualElement.parent) || {} : {};
        if (visualElement.props.initial !== undefined) context.initial = visualElement.props.initial;
        return context;
    }
    const context = {};
    for(let i = 0; i < $b67819dcbd44ec40$var$numVariantProps; i++){
        const name = (0, $0172fb3d3512f551$export$1405a65085f40b9)[i];
        const prop = visualElement.props[name];
        if ((0, $a35be4d5814e7c66$export$720b90e312cea233)(prop) || prop === false) context[name] = prop;
    }
    return context;
}





const $351ff45a987b08cc$var$reversePriorityOrder = [
    ...(0, $0172fb3d3512f551$export$16e45afcc206d3a8)
].reverse();
const $351ff45a987b08cc$var$numAnimationTypes = (0, $0172fb3d3512f551$export$16e45afcc206d3a8).length;
function $351ff45a987b08cc$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $7d7d5f8a14d3a662$export$ff62cf473653f109)(visualElement, animation, options)));
}
function $351ff45a987b08cc$export$bb53502b7a672aa8(visualElement) {
    let animate = $351ff45a987b08cc$var$animateList(visualElement);
    let state = $351ff45a987b08cc$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (type)=>(acc, definition)=>{
            const resolved = (0, $58c1fda9d3891d8d$export$7b1b1c981f4f0558)(visualElement, definition, type === "exit" ? visualElement.presenceContext?.custom : undefined);
            if (resolved) {
                const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
                acc = {
                    ...acc,
                    ...target,
                    ...transitionEnd
                };
            }
            return acc;
        };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(changedActiveType) {
        const { props: props } = visualElement;
        const context = (0, $b67819dcbd44ec40$export$6669f52f7ffa343b)(visualElement.parent) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $351ff45a987b08cc$var$numAnimationTypes; i++){
            const type = $351ff45a987b08cc$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $a35be4d5814e7c66$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $1e5344c7f0db9c8f$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $351ff45a987b08cc$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = false;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ let valueHasChanged = false;
                if ((0, $ef59b2359a289b82$export$9153ad4c4999f4a0)(next) && (0, $ef59b2359a289b82$export$9153ad4c4999f4a0)(prev)) valueHasChanged = !(0, $21ec58272207c53a$export$90e866afbd6b9f1a)(next, prev);
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined && next !== null) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to skip this animation
             * unless the inherited variants haven't changed on this render.
             */ const willAnimateViaParent = isInherited && variantDidChange;
            const needsAnimating = !willAnimateViaParent || handledRemovedValues;
            if (shouldAnimateType && needsAnimating) animations.push(...definitionList.map((animation)=>{
                const options = {
                    type: type
                };
                /**
                     * If we're performing the initial animation, but we're not
                     * rendering at the same time as the variant-controlling parent,
                     * we want to use the parent's transition to calculate the stagger.
                     */ if (typeof animation === "string" && isInitialRender && !willAnimateViaParent && visualElement.manuallyAnimateOnMount && visualElement.parent) {
                    const { parent: parent } = visualElement;
                    const parentVariant = (0, $58c1fda9d3891d8d$export$7b1b1c981f4f0558)(parent, animation);
                    if (parent.enteringChildren && parentVariant) {
                        const { delayChildren: delayChildren } = parentVariant.transition || {};
                        options.delay = (0, $ee9e3da43a1ac506$export$6e01cb2cb232d79b)(parent.enteringChildren, visualElement, delayChildren);
                    }
                }
                return {
                    animation: animation,
                    options: options
                };
            }));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            /**
             * If the initial prop contains a transition we can use that, otherwise
             * allow the animation function to use the visual element's default.
             */ if (typeof props.initial !== "boolean") {
                const initialTransition = (0, $58c1fda9d3891d8d$export$7b1b1c981f4f0558)(visualElement, Array.isArray(props.initial) ? props.initial[0] : props.initial);
                if (initialTransition && initialTransition.transition) fallbackAnimation.transition = initialTransition.transition;
            }
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = true;
                // @ts-expect-error - @mattgperry to figure if we should do something here
                fallbackAnimation[key] = fallbackTarget ?? null;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive) {
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        visualElement.variantChildren?.forEach((child)=>child.animationState?.setActive(type, isActive));
        state[type].isActive = isActive;
        const animations = animateChanges(type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state,
        reset: ()=>{
            state = $351ff45a987b08cc$var$createState();
        /**
             * Temporarily disabling resetting this flag as it prevents components
             * with initial={false} from animating after being remounted, for instance
             * as the child of an Activity component.
             */ // isInitialRender = true
        }
    };
}
function $351ff45a987b08cc$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $21ec58272207c53a$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $351ff45a987b08cc$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $351ff45a987b08cc$var$createState() {
    return {
        animate: $351ff45a987b08cc$var$createTypeState(true),
        whileInView: $351ff45a987b08cc$var$createTypeState(),
        whileHover: $351ff45a987b08cc$var$createTypeState(),
        whileTap: $351ff45a987b08cc$var$createTypeState(),
        whileDrag: $351ff45a987b08cc$var$createTypeState(),
        whileFocus: $351ff45a987b08cc$var$createTypeState(),
        exit: $351ff45a987b08cc$var$createTypeState()
    };
}


class $5b9241b1e863e695$export$6e91cf7616333d5 {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}


class $bfc36aed86970b83$export$b45b3fe5caabdca extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $351ff45a987b08cc$export$bb53502b7a672aa8)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        if ((0, $1e5344c7f0db9c8f$export$aa71198ceeaf53ce)(animate)) this.unmountControls = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {
        this.node.animationState.reset();
        this.unmountControls?.();
    }
}



let $7ad505f20eee7073$var$id = 0;
class $7ad505f20eee7073$export$4989d1eb6104cc6c extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.id = $7ad505f20eee7073$var$id++;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent);
        if (onExitComplete && !isPresent) exitAnimation.then(()=>{
            onExitComplete(this.id);
        });
    }
    mount() {
        const { register: register, onExitComplete: onExitComplete } = this.node.presenceContext || {};
        if (onExitComplete) onExitComplete(this.id);
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}


const $03e8b675a1009b68$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $bfc36aed86970b83$export$b45b3fe5caabdca)
    },
    exit: {
        Feature: (0, $7ad505f20eee7073$export$4989d1eb6104cc6c)
    }
};




const $b6ebf11b6100dc3c$export$9e9bc3c487fccc00 = {
    x: false,
    y: false
};
function $b6ebf11b6100dc3c$export$1b3dd616664938e4() {
    return $b6ebf11b6100dc3c$export$9e9bc3c487fccc00.x || $b6ebf11b6100dc3c$export$9e9bc3c487fccc00.y;
}


function $dba16263340dfedf$export$64d8a3fd7eb621d5(axis) {
    if (axis === "x" || axis === "y") {
        if ((0, $b6ebf11b6100dc3c$export$9e9bc3c487fccc00)[axis]) return null;
        else {
            (0, $b6ebf11b6100dc3c$export$9e9bc3c487fccc00)[axis] = true;
            return ()=>{
                (0, $b6ebf11b6100dc3c$export$9e9bc3c487fccc00)[axis] = false;
            };
        }
    } else {
        if ((0, $b6ebf11b6100dc3c$export$9e9bc3c487fccc00).x || (0, $b6ebf11b6100dc3c$export$9e9bc3c487fccc00).y) return null;
        else {
            (0, $b6ebf11b6100dc3c$export$9e9bc3c487fccc00).x = (0, $b6ebf11b6100dc3c$export$9e9bc3c487fccc00).y = true;
            return ()=>{
                (0, $b6ebf11b6100dc3c$export$9e9bc3c487fccc00).x = (0, $b6ebf11b6100dc3c$export$9e9bc3c487fccc00).y = false;
            };
        }
    }
}




function $43ace1b5a11c3a40$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}



const $09534cabd85214e2$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};


function $23ab615c547792c0$export$12f84bb882d06e1a(event) {
    return {
        point: {
            x: event.pageX,
            y: event.pageY
        }
    };
}
const $23ab615c547792c0$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $09534cabd85214e2$export$a4cf9c8a4b063a6e)(event) && handler(event, $23ab615c547792c0$export$12f84bb882d06e1a(event));
};


function $7fd40e38993f1c69$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(target, eventName, (0, $23ab615c547792c0$export$c404e80f92c98d29)(handler), options);
}





const $b352f7cdd42c49d7$var$SCALE_PRECISION = 0.0001;
const $b352f7cdd42c49d7$var$SCALE_MIN = 1 - $b352f7cdd42c49d7$var$SCALE_PRECISION;
const $b352f7cdd42c49d7$var$SCALE_MAX = 1 + $b352f7cdd42c49d7$var$SCALE_PRECISION;
const $b352f7cdd42c49d7$var$TRANSLATE_PRECISION = 0.01;
const $b352f7cdd42c49d7$var$TRANSLATE_MIN = 0 - $b352f7cdd42c49d7$var$TRANSLATE_PRECISION;
const $b352f7cdd42c49d7$var$TRANSLATE_MAX = 0 + $b352f7cdd42c49d7$var$TRANSLATE_PRECISION;
function $b352f7cdd42c49d7$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $b352f7cdd42c49d7$export$28d0384c4b79bde2(value, target, maxDistance) {
    return Math.abs(value - target) <= maxDistance;
}
function $b352f7cdd42c49d7$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $be9fc9b72a711b93$export$3bb0b4ff1037b8dd)(source.min, source.max, delta.origin);
    delta.scale = $b352f7cdd42c49d7$export$c1c127004b72a37(target) / $b352f7cdd42c49d7$export$c1c127004b72a37(source);
    delta.translate = (0, $be9fc9b72a711b93$export$3bb0b4ff1037b8dd)(target.min, target.max, delta.origin) - delta.originPoint;
    if (delta.scale >= $b352f7cdd42c49d7$var$SCALE_MIN && delta.scale <= $b352f7cdd42c49d7$var$SCALE_MAX || isNaN(delta.scale)) delta.scale = 1.0;
    if (delta.translate >= $b352f7cdd42c49d7$var$TRANSLATE_MIN && delta.translate <= $b352f7cdd42c49d7$var$TRANSLATE_MAX || isNaN(delta.translate)) delta.translate = 0.0;
}
function $b352f7cdd42c49d7$export$c0d25e96fc67d310(delta, source, target, origin) {
    $b352f7cdd42c49d7$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $b352f7cdd42c49d7$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $b352f7cdd42c49d7$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $b352f7cdd42c49d7$export$c1c127004b72a37(relative);
}
function $b352f7cdd42c49d7$export$426154f9d100f99(target, relative, parent) {
    $b352f7cdd42c49d7$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $b352f7cdd42c49d7$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $b352f7cdd42c49d7$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $b352f7cdd42c49d7$export$c1c127004b72a37(layout);
}
function $b352f7cdd42c49d7$export$2785bfcc929c5650(target, layout, parent) {
    $b352f7cdd42c49d7$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $b352f7cdd42c49d7$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}



function $247f90d2510fbc55$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}



// Fixes https://github.com/motiondivision/motion/issues/2270
const $763b481d779908b7$export$d533d84f9871c879 = ({ current: current })=>{
    return current ? current.ownerDocument.defaultView : null;
};








const $8eeaeb5692ba8175$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $8eeaeb5692ba8175$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $8eeaeb5692ba8175$export$9f17032d917177de(a.x, b.x);
    const yDelta = $8eeaeb5692ba8175$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}


/**
 * @internal
 */ class $2bb1a5b2e1002b2e$export$d9c66232c9c4689c {
    constructor(event, handlers, { transformPagePoint: transformPagePoint, contextWindow: contextWindow = window, dragSnapToOrigin: dragSnapToOrigin = false, distanceThreshold: distanceThreshold = 3 } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $2bb1a5b2e1002b2e$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursor.
            const isDistancePastThreshold = (0, $8eeaeb5692ba8175$export$503a1d513f12e38b)(info.offset, {
                x: 0,
                y: 0
            }) >= this.distanceThreshold;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $1fc179758a6fb1d9$export$fff89137e9e818ce);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $2bb1a5b2e1002b2e$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $1fc179758a6fb1d9$export$2cef06c20297c17d).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            const { onEnd: onEnd, onSessionEnd: onSessionEnd, resumeAnimation: resumeAnimation } = this.handlers;
            if (this.dragSnapToOrigin) resumeAnimation && resumeAnimation();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const panInfo = $2bb1a5b2e1002b2e$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $2bb1a5b2e1002b2e$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $09534cabd85214e2$export$a4cf9c8a4b063a6e)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.distanceThreshold = distanceThreshold;
        this.contextWindow = contextWindow || window;
        const info = (0, $23ab615c547792c0$export$12f84bb882d06e1a)(event);
        const initialInfo = $2bb1a5b2e1002b2e$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $1fc179758a6fb1d9$export$fff89137e9e818ce);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $2bb1a5b2e1002b2e$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $c5c22880df3796c2$export$a4627e546088548d)((0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(this.contextWindow, "pointermove", this.handlePointerMove), (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(this.contextWindow, "pointerup", this.handlePointerUp), (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(this.contextWindow, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $1fc179758a6fb1d9$export$ec99c0ef4978dccb)(this.updatePoint);
    }
}
function $2bb1a5b2e1002b2e$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $2bb1a5b2e1002b2e$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $2bb1a5b2e1002b2e$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $2bb1a5b2e1002b2e$var$subtractPoint(point, $2bb1a5b2e1002b2e$var$lastDevicePoint(history)),
        offset: $2bb1a5b2e1002b2e$var$subtractPoint(point, $2bb1a5b2e1002b2e$var$startDevicePoint(history)),
        velocity: $2bb1a5b2e1002b2e$var$getVelocity(history, 0.1)
    };
}
function $2bb1a5b2e1002b2e$var$startDevicePoint(history) {
    return history[0];
}
function $2bb1a5b2e1002b2e$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $2bb1a5b2e1002b2e$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $2bb1a5b2e1002b2e$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $891d0606d6764488$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (0, $891d0606d6764488$export$f64c3bfbc58eec0f)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}





/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $2df0cf7aa8fef8fc$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $be9fc9b72a711b93$export$3bb0b4ff1037b8dd)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $be9fc9b72a711b93$export$3bb0b4ff1037b8dd)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $2df0cf7aa8fef8fc$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $2df0cf7aa8fef8fc$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $2df0cf7aa8fef8fc$export$690c180aa5775042(layoutBox.x, left, right),
        y: $2df0cf7aa8fef8fc$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $2df0cf7aa8fef8fc$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $2df0cf7aa8fef8fc$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $2df0cf7aa8fef8fc$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $2df0cf7aa8fef8fc$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $2df0cf7aa8fef8fc$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(source);
    const targetLength = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $89ae9d711a24132c$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $89ae9d711a24132c$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $10aeec2c389b2314$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $2df0cf7aa8fef8fc$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $2df0cf7aa8fef8fc$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $2df0cf7aa8fef8fc$export$7c5eaef8f4723d22(dragElastic = $2df0cf7aa8fef8fc$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $2df0cf7aa8fef8fc$export$a3366d3bac43a742;
    return {
        x: $2df0cf7aa8fef8fc$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $2df0cf7aa8fef8fc$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $2df0cf7aa8fef8fc$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $2df0cf7aa8fef8fc$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $2df0cf7aa8fef8fc$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $2df0cf7aa8fef8fc$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}


const $59924ee873defaad$export$f0a15892c27dc07c = new WeakMap();
class $59924ee873defaad$export$86bff71f18910307 {
    constructor(visualElement){
        this.openDragLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
        /**
         * The latest pointer event. Used as fallback when the `cancel` and `stop` functions are called without arguments.
         */ this.latestPointerEvent = null;
        /**
         * The latest pan info. Used as fallback when the `cancel` and `stop` functions are called without arguments.
         */ this.latestPanInfo = null;
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor: snapToCursor = false, distanceThreshold: distanceThreshold } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
            // Stop or pause any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            dragSnapToOrigin ? this.pauseAnimation() : this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $23ab615c547792c0$export$12f84bb882d06e1a)(event).point);
        };
        const onStart = (event, info)=>{
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openDragLock) this.openDragLock();
                this.openDragLock = (0, $dba16263340dfedf$export$64d8a3fd7eb621d5)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openDragLock) return;
            }
            this.latestPointerEvent = event;
            this.latestPanInfo = info;
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $8b3d385d4c2e0df7$export$626336c2cd4b14de).test(current)) {
                    const { projection: projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, $1fc179758a6fb1d9$export$2cef06c20297c17d).postRender(()=>onDragStart(event, info));
            (0, $74e7c7f6c49b7323$export$3ac5aed310be0bee)(this.visualElement, "transform");
            const { animationState: animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            this.latestPointerEvent = event;
            this.latestPanInfo = info;
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openDragLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $59924ee873defaad$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>{
            this.latestPointerEvent = event;
            this.latestPanInfo = info;
            this.stop(event, info);
            this.latestPointerEvent = null;
            this.latestPanInfo = null;
        };
        const resumeAnimation = ()=>(0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>this.getAnimationState(axis) === "paused" && this.getAxisMotionValue(axis).animation?.play());
        const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
        this.panSession = new (0, $2bb1a5b2e1002b2e$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd,
            resumeAnimation: resumeAnimation
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            dragSnapToOrigin: dragSnapToOrigin,
            distanceThreshold: distanceThreshold,
            contextWindow: (0, $763b481d779908b7$export$d533d84f9871c879)(this.visualElement)
        });
    }
    /**
     * @internal
     */ stop(event, panInfo) {
        const finalEvent = event || this.latestPointerEvent;
        const finalPanInfo = panInfo || this.latestPanInfo;
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging || !finalPanInfo || !finalEvent) return;
        const { velocity: velocity } = finalPanInfo;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        if (onDragEnd) (0, $1fc179758a6fb1d9$export$2cef06c20297c17d).postRender(()=>onDragEnd(finalEvent, finalPanInfo));
    }
    /**
     * @internal
     */ cancel() {
        this.isDragging = false;
        const { projection: projection, animationState: animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openDragLock) {
            this.openDragLock();
            this.openDragLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$59924ee873defaad$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $2df0cf7aa8fef8fc$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : this.visualElement.projection?.layout;
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $d157673547c2a934$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $2df0cf7aa8fef8fc$export$4e9195bf7793bc78)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $2df0cf7aa8fef8fc$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            if (this.constraints !== false && this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $2df0cf7aa8fef8fc$export$e9672cc4c36a8b87)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $d157673547c2a934$export$dedd81df7bc1307)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $fbe9f318b7b09044$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.", "drag-constraints-ref");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $4ca2f8055771ddf4$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $2df0cf7aa8fef8fc$export$4228500f19d4cdf7)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $0e0401fe38bd0bd1$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $0e0401fe38bd0bd1$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            if (!$59924ee873defaad$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        (0, $74e7c7f6c49b7323$export$3ac5aed310be0bee)(this.visualElement, axis);
        return axisValue.start((0, $9e7a9f8af70c9aa6$export$90b3dfc33ff3548)(axis, axisValue, 0, transition, this.visualElement, false));
    }
    stopAnimation() {
        (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    pauseAnimation() {
        (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).animation?.pause());
    }
    getAnimationState(axis) {
        return this.getAxisMotionValue(axis).animation?.state;
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = `_drag${axis.toUpperCase()}`;
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$59924ee873defaad$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $be9fc9b72a711b93$export$3bb0b4ff1037b8dd)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $d157673547c2a934$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue && this.constraints !== false) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $2df0cf7aa8fef8fc$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            if (!$59924ee873defaad$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $be9fc9b72a711b93$export$3bb0b4ff1037b8dd)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $59924ee873defaad$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $d157673547c2a934$export$dedd81df7bc1307)(dragConstraints) && dragConstraints.current) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        (0, $1fc179758a6fb1d9$export$2cef06c20297c17d).read(measureDragConstraints);
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $2df0cf7aa8fef8fc$export$a3366d3bac43a742), dragMomentum: dragMomentum = true } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
}
function $59924ee873defaad$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $59924ee873defaad$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}


class $abae7830ca84eed8$export$5d97dc2872682820 extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $d6ca2382cab65984$export$8793edee2d425525);
        this.removeListeners = (0, $d6ca2382cab65984$export$8793edee2d425525);
        this.controls = new (0, $59924ee873defaad$export$86bff71f18910307)(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $d6ca2382cab65984$export$8793edee2d425525);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
}








const $d43ff984f7bd7f1a$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, $1fc179758a6fb1d9$export$2cef06c20297c17d).postRender(()=>handler(event, info));
    };
class $d43ff984f7bd7f1a$export$b4f8f1ee75ce5859 extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $d6ca2382cab65984$export$8793edee2d425525);
    }
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $2bb1a5b2e1002b2e$export$d9c66232c9c4689c)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: (0, $763b481d779908b7$export$d533d84f9871c879)(this.node)
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart, onPanStart: onPanStart, onPan: onPan, onPanEnd: onPanEnd } = this.node.getProps();
        return {
            onSessionStart: $d43ff984f7bd7f1a$var$asyncHandler(onPanSessionStart),
            onStart: $d43ff984f7bd7f1a$var$asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, $1fc179758a6fb1d9$export$2cef06c20297c17d).postRender(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

"use client";
/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $bc77fac60b5d77cc$export$2a8c16d82a0a0e26(subscribe = true) {
    const context = (0, $acw62.useContext)((0, $dba5d94a982c4145$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $acw62.useId)();
    (0, $acw62.useEffect)(()=>{
        if (subscribe) return register(id);
    }, [
        subscribe
    ]);
    const safeToRemove = (0, $acw62.useCallback)(()=>subscribe && onExitComplete && onExitComplete(id), [
        id,
        onExitComplete,
        subscribe
    ]);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $bc77fac60b5d77cc$export$8249053f690ea39a() {
    return $bc77fac60b5d77cc$export$ee27c052bca048fb((0, $acw62.useContext)((0, $dba5d94a982c4145$export$f224e4635b6f8ce2)));
}
function $bc77fac60b5d77cc$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}




/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $b29dc04080b74d0c$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};


"use client";
/**
 * Track whether we've taken any snapshots yet. If not,
 * we can safely skip notification of didUpdate.
 *
 * Difficult to capture in a test but to prevent flickering
 * we must set this to true either on update or unmount.
 * Running `next-env/layout-id` in Safari will show this behaviour if broken.
 */ let $cdf2a2ac04e7ce67$var$hasTakenAnySnapshot = false;
class $cdf2a2ac04e7ce67$var$MeasureLayoutWithContext extends (0, $acw62.Component) {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            if ($cdf2a2ac04e7ce67$var$hasTakenAnySnapshot) projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $b29dc04080b74d0c$export$97db156a3ed1593b).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const { projection: projection } = visualElement;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        $cdf2a2ac04e7ce67$var$hasTakenAnySnapshot = true;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined || prevProps.isPresent !== isPresent) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $1fc179758a6fb1d9$export$2cef06c20297c17d).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            (0, $2ea51e08c4a70f38$export$bb76eed83315504c).postRender(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        $cdf2a2ac04e7ce67$var$hasTakenAnySnapshot = true;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $cdf2a2ac04e7ce67$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $bc77fac60b5d77cc$export$2a8c16d82a0a0e26)();
    const layoutGroup = (0, $acw62.useContext)((0, $4ae202aab5791dbc$export$a3579ca508007a95));
    return (0, $ayMG0.jsx)($cdf2a2ac04e7ce67$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $acw62.useContext)((0, $c612a166b65a9c69$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}


function $8000ea2de73d8af0$export$a6cdc56e425d0d0a(value) {
    return typeof value === "object" && value !== null;
}


/**
 * Checks if an element is an SVG element in a way
 * that works across iframes
 */ function $ee04726c54a1baf9$export$17eda790a720ec57(element) {
    return (0, $8000ea2de73d8af0$export$a6cdc56e425d0d0a)(element) && "ownerSVGElement" in element;
}


/**
 * Checks if an element is specifically an SVGSVGElement (the root SVG element)
 * in a way that works across iframes
 */ function $1966590b3a16936e$export$66957ea77182581d(element) {
    return (0, $ee04726c54a1baf9$export$17eda790a720ec57)(element) && element.tagName === "svg";
}





function $91bfdf42c5aa00ed$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $eadb4e7ad13d3244$export$605d60a2578142d3)(value) ? value : (0, $61b3ffa62977d1fd$export$ce8bdc721e76545f)(value);
    motionValue$1.start((0, $9e7a9f8af70c9aa6$export$90b3dfc33ff3548)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}




const $8e214807702da081$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;


class $e21f5e6c9473a18c$export$1465d17e3de78a96 {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, $7b6ce60ba01b86f0$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $7b6ce60ba01b86f0$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $8e214807702da081$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}




/**
 * Timeout defined in ms
 */ function $fab50a206e6cc096$export$1391212d75b2ee65(callback, timeout) {
    const start = (0, $fa7790817f905603$export$2da9be4cfdb689b1).now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $1fc179758a6fb1d9$export$ec99c0ef4978dccb)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $1fc179758a6fb1d9$export$2cef06c20297c17d).setup(checkElapsed, true);
    return ()=>(0, $1fc179758a6fb1d9$export$ec99c0ef4978dccb)(checkElapsed);
}
function $fab50a206e6cc096$export$fcd451ca460f8a2a(callback, timeout) {
    return $fab50a206e6cc096$export$1391212d75b2ee65(callback, (0, $891d0606d6764488$export$fc3e7e8557f8c8c7)(timeout));
}





const $82b1c16a20b13fa0$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $82b1c16a20b13fa0$var$numBorders = $82b1c16a20b13fa0$var$borders.length;
const $82b1c16a20b13fa0$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $82b1c16a20b13fa0$var$isPx = (value)=>typeof value === "number" || (0, $8b3d385d4c2e0df7$export$91c0eda1d06bf008).test(value);
function $82b1c16a20b13fa0$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $be9fc9b72a711b93$export$3bb0b4ff1037b8dd)(0, lead.opacity ?? 1, $82b1c16a20b13fa0$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $be9fc9b72a711b93$export$3bb0b4ff1037b8dd)(follow.opacity ?? 1, 0, $82b1c16a20b13fa0$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $be9fc9b72a711b93$export$3bb0b4ff1037b8dd)(follow.opacity ?? 1, lead.opacity ?? 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $82b1c16a20b13fa0$var$numBorders; i++){
        const borderLabel = `border${$82b1c16a20b13fa0$var$borders[i]}Radius`;
        let followRadius = $82b1c16a20b13fa0$var$getRadius(follow, borderLabel);
        let leadRadius = $82b1c16a20b13fa0$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $82b1c16a20b13fa0$var$isPx(followRadius) === $82b1c16a20b13fa0$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $be9fc9b72a711b93$export$3bb0b4ff1037b8dd)($82b1c16a20b13fa0$var$asNumber(followRadius), $82b1c16a20b13fa0$var$asNumber(leadRadius), progress), 0);
            if ((0, $8b3d385d4c2e0df7$export$626336c2cd4b14de).test(leadRadius) || (0, $8b3d385d4c2e0df7$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $be9fc9b72a711b93$export$3bb0b4ff1037b8dd)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $82b1c16a20b13fa0$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $82b1c16a20b13fa0$var$easeCrossfadeIn = /*@__PURE__*/ $82b1c16a20b13fa0$var$compress(0, 0.5, (0, $2bb074bad255cd38$export$c8d67a19199d1a50));
const $82b1c16a20b13fa0$var$easeCrossfadeOut = /*@__PURE__*/ $82b1c16a20b13fa0$var$compress(0.5, 0.95, (0, $d6ca2382cab65984$export$8793edee2d425525));
function $82b1c16a20b13fa0$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $89ae9d711a24132c$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $5960d81994414d5a$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $5960d81994414d5a$export$c53fd88f45d77e4b(box, originBox) {
    $5960d81994414d5a$export$a0230ae482601ae8(box.x, originBox.x);
    $5960d81994414d5a$export$a0230ae482601ae8(box.y, originBox.y);
}
/**
 * Reset a delta to the provided origin box.
 *
 * This is a mutative operation.
 */ function $5960d81994414d5a$export$8ead6a7d6b225ef(delta, originDelta) {
    delta.translate = originDelta.translate;
    delta.scale = originDelta.scale;
    delta.originPoint = originDelta.originPoint;
    delta.origin = originDelta.origin;
}






/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $db628fcc785b8b87$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $d8332eb74969584e$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $d8332eb74969584e$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $db628fcc785b8b87$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $8b3d385d4c2e0df7$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $be9fc9b72a711b93$export$3bb0b4ff1037b8dd)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $be9fc9b72a711b93$export$3bb0b4ff1037b8dd)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $db628fcc785b8b87$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $db628fcc785b8b87$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $db628fcc785b8b87$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $db628fcc785b8b87$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $db628fcc785b8b87$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $db628fcc785b8b87$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $db628fcc785b8b87$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $db628fcc785b8b87$export$42b76f1d0d16d5b(box.x, transforms, $db628fcc785b8b87$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $db628fcc785b8b87$export$42b76f1d0d16d5b(box.y, transforms, $db628fcc785b8b87$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}




function $b070f9c5f268d45c$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $b070f9c5f268d45c$export$a7ec7642fe550fb6(delta) {
    return $b070f9c5f268d45c$var$isAxisDeltaZero(delta.x) && $b070f9c5f268d45c$var$isAxisDeltaZero(delta.y);
}
function $b070f9c5f268d45c$export$7a9a6f114ddd0fdb(a, b) {
    return a.min === b.min && a.max === b.max;
}
function $b070f9c5f268d45c$export$8d5cf76bb7daff09(a, b) {
    return $b070f9c5f268d45c$export$7a9a6f114ddd0fdb(a.x, b.x) && $b070f9c5f268d45c$export$7a9a6f114ddd0fdb(a.y, b.y);
}
function $b070f9c5f268d45c$export$22adf28bfca1c186(a, b) {
    return Math.round(a.min) === Math.round(b.min) && Math.round(a.max) === Math.round(b.max);
}
function $b070f9c5f268d45c$export$ef641b782d85522(a, b) {
    return $b070f9c5f268d45c$export$22adf28bfca1c186(a.x, b.x) && $b070f9c5f268d45c$export$22adf28bfca1c186(a.y, b.y);
}
function $b070f9c5f268d45c$export$c5706146bc63213(box) {
    return (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(box.x) / (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(box.y);
}
function $b070f9c5f268d45c$export$444620505e28fe92(a, b) {
    return a.translate === b.translate && a.scale === b.scale && a.originPoint === b.originPoint;
}



class $a040ab986103db06$export$39be5b2d82fc9dc7 {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, $7b6ce60ba01b86f0$export$20e507e47fae79fd)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $7b6ce60ba01b86f0$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options: options, resumingFrom: resumingFrom } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
}



function $0214cdf9d4bb801d$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    const zTranslate = latestTransform?.z || 0;
    if (xTranslate || yTranslate || zTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, ${zTranslate}px) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { transformPerspective: transformPerspective, rotate: rotate, rotateX: rotateX, rotateY: rotateY, skewX: skewX, skewY: skewY } = latestTransform;
        if (transformPerspective) transform = `perspective(${transformPerspective}px) ${transform}`;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
        if (skewX) transform += `skewX(${skewX}deg) `;
        if (skewY) transform += `skewY(${skewY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}





const $d2ca41ba1b84bcfe$var$metrics = {
    nodes: 0,
    calculatedTargetDeltas: 0,
    calculatedProjections: 0
};
const $d2ca41ba1b84bcfe$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $d2ca41ba1b84bcfe$var$animationTarget = 1000;
let $d2ca41ba1b84bcfe$var$id = 0;
function $d2ca41ba1b84bcfe$var$resetDistortingTransform(key, visualElement, values, sharedAnimationValues) {
    const { latestValues: latestValues } = visualElement;
    // Record the distorting transform and then temporarily set it to 0
    if (latestValues[key]) {
        values[key] = latestValues[key];
        visualElement.setStaticValue(key, 0);
        if (sharedAnimationValues) sharedAnimationValues[key] = 0;
    }
}
function $d2ca41ba1b84bcfe$var$cancelTreeOptimisedTransformAnimations(projectionNode) {
    projectionNode.hasCheckedOptimisedAppear = true;
    if (projectionNode.root === projectionNode) return;
    const { visualElement: visualElement } = projectionNode.options;
    if (!visualElement) return;
    const appearId = (0, $59a52f0eed0e0e03$export$5f8d21e84d1d84fc)(visualElement);
    if (window.MotionHasOptimisedAnimation(appearId, "transform")) {
        const { layout: layout, layoutId: layoutId } = projectionNode.options;
        window.MotionCancelOptimisedAnimation(appearId, "transform", (0, $1fc179758a6fb1d9$export$2cef06c20297c17d), !(layout || layoutId));
    }
    const { parent: parent } = projectionNode;
    if (parent && !parent.hasCheckedOptimisedAppear) $d2ca41ba1b84bcfe$var$cancelTreeOptimisedTransformAnimations(parent);
}
function $d2ca41ba1b84bcfe$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        constructor(latestValues = {}, parent = defaultParent?.()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $d2ca41ba1b84bcfe$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            this.animationCommitId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * Store whether this node has been checked for optimised appear animations. As
             * effects fire bottom-up, and we want to look up the tree for appear animations,
             * this makes sure we only check each path once, stopping at nodes that
             * have already been checked.
             */ this.hasCheckedOptimisedAppear = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            this.layoutVersion = 0;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.scheduleUpdate = ()=>this.update();
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ if ((0, $047730deae5140b7$export$84ce9a476f53d110).value) $d2ca41ba1b84bcfe$var$metrics.nodes = $d2ca41ba1b84bcfe$var$metrics.calculatedTargetDeltas = $d2ca41ba1b84bcfe$var$metrics.calculatedProjections = 0;
                this.nodes.forEach($d2ca41ba1b84bcfe$export$131f2f0cc5fe9609);
                this.nodes.forEach($d2ca41ba1b84bcfe$var$resolveTargetDelta);
                this.nodes.forEach($d2ca41ba1b84bcfe$var$calcProjection);
                this.nodes.forEach($d2ca41ba1b84bcfe$export$c2664f37bc951031);
                if ((0, $047730deae5140b7$export$84ce9a476f53d110).addProjectionMetrics) (0, $047730deae5140b7$export$84ce9a476f53d110).addProjectionMetrics($d2ca41ba1b84bcfe$var$metrics);
            };
            /**
             * Frame calculations
             */ this.resolvedRelativeTargetAt = 0.0;
            this.linkedParentVersion = 0;
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $e21f5e6c9473a18c$export$1465d17e3de78a96)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $ee5d55ee4695ef73$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance) {
            if (this.instance) return;
            this.isSVG = (0, $ee04726c54a1baf9$export$17eda790a720ec57)(instance) && !(0, $1966590b3a16936e$export$66957ea77182581d)(instance);
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (this.root.hasTreeAnimated && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                let innerWidth = 0;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                // Set initial innerWidth in a frame.read callback to batch the read
                (0, $1fc179758a6fb1d9$export$2cef06c20297c17d).read(()=>{
                    innerWidth = window.innerWidth;
                });
                attachResizeListener(instance, ()=>{
                    const newInnerWidth = window.innerWidth;
                    if (newInnerWidth === innerWidth) return;
                    innerWidth = newInnerWidth;
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $fab50a206e6cc096$export$1391212d75b2ee65)(resizeUnblockUpdate, 250);
                    if ((0, $b29dc04080b74d0c$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $b29dc04080b74d0c$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        this.nodes.forEach($d2ca41ba1b84bcfe$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeLayoutChanged: hasRelativeLayoutChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $d2ca41ba1b84bcfe$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const hasTargetChanged = !this.targetLayout || !(0, $b070f9c5f268d45c$export$ef641b782d85522)(this.targetLayout, newLayout);
                /*
                     * Note: Disabled to fix relative animations always triggering new
                     * layout animations. If this causes further issues, we can try
                     * a different approach to detecting relative target changes.
                     */ // || hasRelativeLayoutChanged
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeLayoutChanged;
                if (this.options.layoutRoot || this.resumeFrom || hasOnlyRelativeTargetChanged || hasLayoutChanged && (hasTargetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    const animationOptions = {
                        ...(0, $339fe6708b513dab$export$7c1391340308742e)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                    /**
                         * Set animation origin after starting animation to avoid layout jump
                         * caused by stopping previous layout animation
                         */ this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $d2ca41ba1b84bcfe$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            this.eventHandlers.clear();
            (0, $1fc179758a6fb1d9$export$ec99c0ef4978dccb)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($d2ca41ba1b84bcfe$var$resetSkewAndRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            /**
             * If we're running optimised appear animations then these must be
             * cancelled before measuring the DOM. This is so we can measure
             * the true layout of the element rather than the WAAPI animation
             * which will be unaffected by the resetSkewAndRotate step.
             *
             * Note: This is a DOM write. Worst case scenario is this is sandwiched
             * between other snapshot reads which will cause unnecessary style recalculations.
             * This has to happen here though, as we don't yet know which nodes will need
             * snapshots in startUpdate(), but we only want to cancel optimised animations
             * if a layout animation measurement is actually going to be affected by them.
             */ if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear) $d2ca41ba1b84bcfe$var$cancelTreeOptimisedTransformAnimations(this);
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($d2ca41ba1b84bcfe$var$clearMeasurements);
                return;
            }
            /**
             * If this is a repeat of didUpdate then ignore the animation.
             */ if (this.animationId <= this.animationCommitId) {
                this.nodes.forEach($d2ca41ba1b84bcfe$var$clearIsLayoutDirty);
                return;
            }
            this.animationCommitId = this.animationId;
            if (!this.isUpdating) this.nodes.forEach($d2ca41ba1b84bcfe$var$clearIsLayoutDirty);
            else {
                this.isUpdating = false;
                /**
                 * Write
                 */ this.nodes.forEach($d2ca41ba1b84bcfe$var$resetTransformStyle);
                /**
                 * Read ==================
                 */ // Update layout measurements of updated children
                this.nodes.forEach($d2ca41ba1b84bcfe$var$updateLayout);
                /**
                 * Write
                 */ // Notify listeners that the layout is updated
                this.nodes.forEach($d2ca41ba1b84bcfe$var$notifyLayoutUpdate);
            }
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = (0, $fa7790817f905603$export$2da9be4cfdb689b1).now();
            (0, $1fc179758a6fb1d9$export$fff89137e9e818ce).delta = (0, $10aeec2c389b2314$export$7d15b64cf5a3a4c4)(0, 1000 / 60, now - (0, $1fc179758a6fb1d9$export$fff89137e9e818ce).timestamp);
            (0, $1fc179758a6fb1d9$export$fff89137e9e818ce).timestamp = now;
            (0, $1fc179758a6fb1d9$export$fff89137e9e818ce).isProcessing = true;
            (0, $1fc179758a6fb1d9$export$1811c3a7e3af92f0).update.process((0, $1fc179758a6fb1d9$export$fff89137e9e818ce));
            (0, $1fc179758a6fb1d9$export$1811c3a7e3af92f0).preRender.process((0, $1fc179758a6fb1d9$export$fff89137e9e818ce));
            (0, $1fc179758a6fb1d9$export$1811c3a7e3af92f0).render.process((0, $1fc179758a6fb1d9$export$fff89137e9e818ce));
            (0, $1fc179758a6fb1d9$export$fff89137e9e818ce).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                (0, $2ea51e08c4a70f38$export$bb76eed83315504c).read(this.scheduleUpdate);
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($d2ca41ba1b84bcfe$var$clearSnapshot);
            this.sharedNodes.forEach($d2ca41ba1b84bcfe$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            if (!this.projectionUpdateScheduled) {
                this.projectionUpdateScheduled = true;
                (0, $1fc179758a6fb1d9$export$2cef06c20297c17d).preRender(this.updateProjection, false, true);
            }
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $1fc179758a6fb1d9$export$2cef06c20297c17d).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
            if (this.snapshot && !(0, $b352f7cdd42c49d7$export$c1c127004b72a37)(this.snapshot.measuredBox.x) && !(0, $b352f7cdd42c49d7$export$c1c127004b72a37)(this.snapshot.measuredBox.y)) this.snapshot = undefined;
        }
        updateLayout() {
            if (!this.instance) return;
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutVersion++;
            this.layoutCorrected = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement && this.instance) {
                const isRoot = checkIsScrollRoot(this.instance);
                this.scroll = {
                    animationId: this.root.animationId,
                    phase: phase,
                    isRoot: isRoot,
                    offset: measureScroll(this.instance),
                    wasRoot: this.scroll ? this.scroll.isRoot : isRoot
                };
            }
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout;
            const hasProjection = this.projectionDelta && !(0, $b070f9c5f268d45c$export$a7ec7642fe550fb6)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && this.instance && (hasProjection || (0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $d2ca41ba1b84bcfe$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            const box = visualElement.measureViewportBox();
            const wasInScrollRoot = this.scroll?.wasRoot || this.path.some($d2ca41ba1b84bcfe$var$checkNodeWasScrollRoot);
            if (!wasInScrollRoot) {
                // Remove viewport scroll to give page-relative coordinates
                const { scroll: scroll } = this.root;
                if (scroll) {
                    (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(box.x, scroll.offset.x);
                    (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(box.y, scroll.offset.y);
                }
            }
            return box;
        }
        removeElementScroll(box) {
            const boxWithoutScroll = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            if (this.scroll?.wasRoot) return boxWithoutScroll;
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.wasRoot) (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                    (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $d8332eb74969584e$export$58b16271041fbfb)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $d8332eb74969584e$export$58b16271041fbfb)(withTransforms, node.latestValues);
            }
            if ((0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(this.latestValues)) (0, $d8332eb74969584e$export$58b16271041fbfb)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $fe0ee806cd19fc1f$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                const nodeBox = node.measurePageBox();
                (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(sourceBox, nodeBox);
                (0, $db628fcc785b8b87$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(this.latestValues)) (0, $db628fcc785b8b87$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $1fc179758a6fb1d9$export$fff89137e9e818ce).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || this.parent?.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize);
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $1fc179758a6fb1d9$export$fff89137e9e818ce).timestamp;
            const relativeParent = this.getClosestProjectingParent();
            if (relativeParent && this.linkedParentVersion !== relativeParent.layoutVersion && !relativeParent.options.layoutRoot) this.removeRelativeTarget();
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ if (!this.targetDelta && !this.relativeTarget) {
                if (relativeParent && relativeParent.layout) this.createRelativeTarget(relativeParent, this.layout.layoutBox, relativeParent.layout.layoutBox);
                else this.removeRelativeTarget();
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $b352f7cdd42c49d7$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
                (0, $d8332eb74969584e$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) this.createRelativeTarget(relativeParent, this.target, relativeParent.target);
                else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ if ((0, $047730deae5140b7$export$84ce9a476f53d110).value) $d2ca41ba1b84bcfe$var$metrics.calculatedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $fe0ee806cd19fc1f$export$bdf30dca883ea463)(this.parent.latestValues) || (0, $fe0ee806cd19fc1f$export$bf80f5f8f4dc327f)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        createRelativeTarget(relativeParent, layout, parentLayout) {
            this.relativeParent = relativeParent;
            this.linkedParentVersion = relativeParent.layoutVersion;
            this.forceRelativeParentToResolveTarget();
            this.relativeTarget = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            this.relativeTargetOrigin = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(this.relativeTargetOrigin, layout, parentLayout);
            (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
        }
        removeRelativeTarget() {
            this.relativeParent = this.relativeTarget = undefined;
        }
        calcProjection() {
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || this.parent?.isProjectionDirty) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $1fc179758a6fb1d9$export$fff89137e9e818ce).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $d8332eb74969584e$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
                lead.target = lead.layout.layoutBox;
                lead.targetWithTransforms = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            }
            const { target: target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.prevProjectionDelta) {
                    this.createProjectionDeltas();
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta || !this.prevProjectionDelta) this.createProjectionDeltas();
            else {
                (0, $5960d81994414d5a$export$8ead6a7d6b225ef)(this.prevProjectionDelta.x, this.projectionDelta.x);
                (0, $5960d81994414d5a$export$8ead6a7d6b225ef)(this.prevProjectionDelta.y, this.projectionDelta.y);
            }
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            if (this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY || !(0, $b070f9c5f268d45c$export$444620505e28fe92)(this.projectionDelta.x, this.prevProjectionDelta.x) || !(0, $b070f9c5f268d45c$export$444620505e28fe92)(this.projectionDelta.y, this.prevProjectionDelta.y)) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ if ((0, $047730deae5140b7$export$84ce9a476f53d110).value) $d2ca41ba1b84bcfe$var$metrics.calculatedProjections++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            this.options.visualElement?.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        createProjectionDeltas() {
            this.prevProjectionDelta = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
            this.projectionDelta = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
            this.projectionDeltaWithTransform = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($d2ca41ba1b84bcfe$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                $d2ca41ba1b84bcfe$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $d2ca41ba1b84bcfe$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $d2ca41ba1b84bcfe$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $b070f9c5f268d45c$export$8d5cf76bb7daff09)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $82b1c16a20b13fa0$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation?.stop();
            this.resumingFrom?.currentAnimation?.stop();
            if (this.pendingAnimation) {
                (0, $1fc179758a6fb1d9$export$ec99c0ef4978dccb)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $1fc179758a6fb1d9$export$2cef06c20297c17d).update(()=>{
                (0, $b29dc04080b74d0c$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                (0, $c27f978081fc4187$export$d921fb2475e2900c).layout++;
                this.motionValue || (this.motionValue = (0, $61b3ffa62977d1fd$export$ce8bdc721e76545f)(0));
                this.currentAnimation = (0, $91bfdf42c5aa00ed$export$335a17c977067b99)(this.motionValue, [
                    0,
                    1000
                ], {
                    ...options,
                    velocity: 0,
                    isSync: true,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onStop: ()=>{
                        (0, $c27f978081fc4187$export$d921fb2475e2900c).layout--;
                    },
                    onComplete: ()=>{
                        (0, $c27f978081fc4187$export$d921fb2475e2900c).layout--;
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($d2ca41ba1b84bcfe$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $d2ca41ba1b84bcfe$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                const xLength = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $d8332eb74969584e$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $a040ab986103db06$export$39be5b2d82fc9dc7)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            const { layoutId: layoutId } = this.options;
            return layoutId ? this.getStack()?.lead || this : this;
        }
        getPrevLead() {
            const { layoutId: layoutId } = this.options;
            return layoutId ? this.getStack()?.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetSkewAndRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected skew or rotation values, we can early return without a forced render.
            let hasDistortingTransform = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.z || latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ || latestValues.skewX || latestValues.skewY) hasDistortingTransform = true;
            // If there's no distorting values, we don't need to do any more.
            if (!hasDistortingTransform) return;
            const resetValues = {};
            if (latestValues.z) $d2ca41ba1b84bcfe$var$resetDistortingTransform("z", visualElement, resetValues, this.animationValues);
            // Check the skew and rotate value of all axes and reset to 0
            for(let i = 0; i < $d2ca41ba1b84bcfe$var$transformAxes.length; i++){
                $d2ca41ba1b84bcfe$var$resetDistortingTransform(`rotate${$d2ca41ba1b84bcfe$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
                $d2ca41ba1b84bcfe$var$resetDistortingTransform(`skew${$d2ca41ba1b84bcfe$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
            }
            // Force a render of this element to apply the transform with all skews and rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues){
                visualElement.setStaticValue(key, resetValues[key]);
                if (this.animationValues) this.animationValues[key] = resetValues[key];
            }
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        applyProjectionStyles(targetStyle, styleProp) {
            if (!this.instance || this.isSVG) return;
            if (!this.isVisible) {
                targetStyle.visibility = "hidden";
                return;
            }
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                targetStyle.visibility = "";
                targetStyle.opacity = "";
                targetStyle.pointerEvents = (0, $18cbbcef55016eac$export$fcc2206ecb6d74b)(styleProp?.pointerEvents) || "";
                targetStyle.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                if (this.options.layoutId) {
                    targetStyle.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    targetStyle.pointerEvents = (0, $18cbbcef55016eac$export$fcc2206ecb6d74b)(styleProp?.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(this.latestValues)) {
                    targetStyle.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return;
            }
            targetStyle.visibility = "";
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            let transform = (0, $0214cdf9d4bb801d$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) transform = transformTemplate(valuesToRender, transform);
            targetStyle.transform = transform;
            const { x: x, y: y } = this.projectionDelta;
            targetStyle.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ targetStyle.opacity = lead === this ? valuesToRender.opacity ?? this.latestValues.opacity ?? 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ targetStyle.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $eced91e16bda42df$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo, isCSSVariable: isCSSVariable } = (0, $eced91e16bda42df$export$91ddd985b97788d1)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)targetStyle[applyTo[i]] = corrected;
                } else // If this is a CSS variable, set it directly on the instance.
                // Replacing this function from creating styles to setting them
                // would be a good place to remove per frame object creation
                if (isCSSVariable) this.options.visualElement.renderState.vars[key] = corrected;
                else targetStyle[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) targetStyle.pointerEvents = lead === this ? (0, $18cbbcef55016eac$export$fcc2206ecb6d74b)(styleProp?.pointerEvents) || "" : "none";
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>node.currentAnimation?.stop());
            this.root.nodes.forEach($d2ca41ba1b84bcfe$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function $d2ca41ba1b84bcfe$var$updateLayout(node) {
    node.updateLayout();
}
function $d2ca41ba1b84bcfe$var$notifyLayoutUpdate(node) {
    const snapshot = node.resumeFrom?.snapshot || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($d2ca41ba1b84bcfe$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
        (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
        if (isShared) (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $b070f9c5f268d45c$export$a7ec7642fe550fb6)(layoutDelta);
        let hasRelativeLayoutChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $b070f9c5f268d45c$export$ef641b782d85522)(relativeSnapshot, relativeLayout)) hasRelativeLayoutChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeLayoutChanged: hasRelativeLayoutChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $d2ca41ba1b84bcfe$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ if ((0, $047730deae5140b7$export$84ce9a476f53d110).value) $d2ca41ba1b84bcfe$var$metrics.nodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $d2ca41ba1b84bcfe$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $d2ca41ba1b84bcfe$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $d2ca41ba1b84bcfe$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $d2ca41ba1b84bcfe$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function $d2ca41ba1b84bcfe$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $d2ca41ba1b84bcfe$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $d2ca41ba1b84bcfe$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $d2ca41ba1b84bcfe$var$calcProjection(node) {
    node.calcProjection();
}
function $d2ca41ba1b84bcfe$var$resetSkewAndRotation(node) {
    node.resetSkewAndRotation();
}
function $d2ca41ba1b84bcfe$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $d2ca41ba1b84bcfe$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $be9fc9b72a711b93$export$3bb0b4ff1037b8dd)(delta.translate, 0, p);
    output.scale = (0, $be9fc9b72a711b93$export$3bb0b4ff1037b8dd)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $d2ca41ba1b84bcfe$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $be9fc9b72a711b93$export$3bb0b4ff1037b8dd)(from.min, to.min, p);
    output.max = (0, $be9fc9b72a711b93$export$3bb0b4ff1037b8dd)(from.max, to.max, p);
}
function $d2ca41ba1b84bcfe$export$6ffd3e6ae339a132(output, from, to, p) {
    $d2ca41ba1b84bcfe$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $d2ca41ba1b84bcfe$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $d2ca41ba1b84bcfe$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $d2ca41ba1b84bcfe$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $d2ca41ba1b84bcfe$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $d2ca41ba1b84bcfe$var$roundPoint = $d2ca41ba1b84bcfe$var$userAgentContains("applewebkit/") && !$d2ca41ba1b84bcfe$var$userAgentContains("chrome/") ? Math.round : (0, $d6ca2382cab65984$export$8793edee2d425525);
function $d2ca41ba1b84bcfe$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $d2ca41ba1b84bcfe$var$roundPoint(axis.min);
    axis.max = $d2ca41ba1b84bcfe$var$roundPoint(axis.max);
}
function $d2ca41ba1b84bcfe$var$roundBox(box) {
    $d2ca41ba1b84bcfe$var$roundAxis(box.x);
    $d2ca41ba1b84bcfe$var$roundAxis(box.y);
}
function $d2ca41ba1b84bcfe$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $b352f7cdd42c49d7$export$28d0384c4b79bde2)((0, $b070f9c5f268d45c$export$c5706146bc63213)(snapshot), (0, $b070f9c5f268d45c$export$c5706146bc63213)(layout), 0.2);
}
function $d2ca41ba1b84bcfe$var$checkNodeWasScrollRoot(node) {
    return node !== node.root && node.scroll?.wasRoot;
}




const $6e97f3a9a89d5fc1$export$2d029a49a09b6177 = (0, $d2ca41ba1b84bcfe$export$a84b61f69daa9da0)({
    attachResizeListener: (ref, notify)=>(0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});


const $a3289660bde9b219$export$b91509fcf893b648 = {
    current: undefined
};
const $a3289660bde9b219$export$b61a9eb3dbde8858 = (0, $d2ca41ba1b84bcfe$export$a84b61f69daa9da0)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$a3289660bde9b219$export$b91509fcf893b648.current) {
            const documentNode = new (0, $6e97f3a9a89d5fc1$export$2d029a49a09b6177)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $a3289660bde9b219$export$b91509fcf893b648.current = documentNode;
        }
        return $a3289660bde9b219$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});


const $fc1974bcfc4fde1a$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $d43ff984f7bd7f1a$export$b4f8f1ee75ce5859)
    },
    drag: {
        Feature: (0, $abae7830ca84eed8$export$5d97dc2872682820),
        ProjectionNode: (0, $a3289660bde9b219$export$b61a9eb3dbde8858),
        MeasureLayout: $cdf2a2ac04e7ce67$export$779f5fb01ad751cd
    }
};



function $6a04df806db4c5b6$export$90ceba2564a894f8(elementOrSelector, scope, selectorCache) {
    if (elementOrSelector instanceof EventTarget) return [
        elementOrSelector
    ];
    else if (typeof elementOrSelector === "string") {
        let root = document;
        if (scope) root = scope.current;
        const elements = selectorCache?.[elementOrSelector] ?? root.querySelectorAll(elementOrSelector);
        return elements ? Array.from(elements) : [];
    }
    return Array.from(elementOrSelector);
}


function $50bd1bf239096030$export$edc0ace9d5e7e842(elementOrSelector, options) {
    const elements = (0, $6a04df806db4c5b6$export$90ceba2564a894f8)(elementOrSelector);
    const gestureAbortController = new AbortController();
    const eventOptions = {
        passive: true,
        ...options,
        signal: gestureAbortController.signal
    };
    const cancel = ()=>gestureAbortController.abort();
    return [
        elements,
        eventOptions,
        cancel
    ];
}


function $9a889f77ec8ec9fa$var$isValidHover(event) {
    return !(event.pointerType === "touch" || (0, $b6ebf11b6100dc3c$export$1b3dd616664938e4)());
}
/**
 * Create a hover gesture. hover() is different to .addEventListener("pointerenter")
 * in that it has an easier syntax, filters out polyfilled touch events, interoperates
 * with drag gestures, and automatically removes the "pointerennd" event listener when the hover ends.
 *
 * @public
 */ function $9a889f77ec8ec9fa$export$3f60957f5dbf3876(elementOrSelector, onHoverStart, options = {}) {
    const [elements, eventOptions, cancel] = (0, $50bd1bf239096030$export$edc0ace9d5e7e842)(elementOrSelector, options);
    const onPointerEnter = (enterEvent)=>{
        if (!$9a889f77ec8ec9fa$var$isValidHover(enterEvent)) return;
        const { target: target } = enterEvent;
        const onHoverEnd = onHoverStart(target, enterEvent);
        if (typeof onHoverEnd !== "function" || !target) return;
        const onPointerLeave = (leaveEvent)=>{
            if (!$9a889f77ec8ec9fa$var$isValidHover(leaveEvent)) return;
            onHoverEnd(leaveEvent);
            target.removeEventListener("pointerleave", onPointerLeave);
        };
        target.addEventListener("pointerleave", onPointerLeave, eventOptions);
    };
    elements.forEach((element)=>{
        element.addEventListener("pointerenter", onPointerEnter, eventOptions);
    });
    return cancel;
}




function $dfb80d799aa36175$var$handleHoverEvent(node, event, lifecycle) {
    const { props: props } = node;
    if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", lifecycle === "Start");
    const eventName = "onHover" + lifecycle;
    const callback = props[eventName];
    if (callback) (0, $1fc179758a6fb1d9$export$2cef06c20297c17d).postRender(()=>callback(event, (0, $23ab615c547792c0$export$12f84bb882d06e1a)(event)));
}
class $dfb80d799aa36175$export$93a81ea037eac456 extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    mount() {
        const { current: current } = this.node;
        if (!current) return;
        this.unmount = (0, $9a889f77ec8ec9fa$export$3f60957f5dbf3876)(current, (_element, startEvent)=>{
            $dfb80d799aa36175$var$handleHoverEvent(this.node, startEvent, "Start");
            return (endEvent)=>$dfb80d799aa36175$var$handleHoverEvent(this.node, endEvent, "End");
        });
    }
    unmount() {}
}





class $46d14c2f8ccf5da4$export$d4826db40d47595b extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $c5c22880df3796c2$export$a4627e546088548d)((0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(this.node.current, "focus", ()=>this.onFocus()), (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}



/**
 * Checks if an element is an HTML element in a way
 * that works across iframes
 */ function $cbd7a6317a819185$export$1b3bfaa9684536aa(element) {
    return (0, $8000ea2de73d8af0$export$a6cdc56e425d0d0a)(element) && "offsetHeight" in element;
}



/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $e89922a58014da6d$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $e89922a58014da6d$export$e841ada32ff745b(parent, child.parentElement);
};




const $ad1d34389582b0f4$var$focusableElements = new Set([
    "BUTTON",
    "INPUT",
    "SELECT",
    "TEXTAREA",
    "A"
]);
function $ad1d34389582b0f4$export$5f6976e2f961e8b7(element) {
    return $ad1d34389582b0f4$var$focusableElements.has(element.tagName) || element.tabIndex !== -1;
}


const $e8d22a14e745d2e6$export$7987404a4e35b84b = new WeakSet();


/**
 * Filter out events that are not "Enter" keys.
 */ function $d23214382ef45c41$var$filterEvents(callback) {
    return (event)=>{
        if (event.key !== "Enter") return;
        callback(event);
    };
}
function $d23214382ef45c41$var$firePointerEvent(target, type) {
    target.dispatchEvent(new PointerEvent("pointer" + type, {
        isPrimary: true,
        bubbles: true
    }));
}
const $d23214382ef45c41$export$4b5790288fe12a79 = (focusEvent, eventOptions)=>{
    const element = focusEvent.currentTarget;
    if (!element) return;
    const handleKeydown = $d23214382ef45c41$var$filterEvents(()=>{
        if ((0, $e8d22a14e745d2e6$export$7987404a4e35b84b).has(element)) return;
        $d23214382ef45c41$var$firePointerEvent(element, "down");
        const handleKeyup = $d23214382ef45c41$var$filterEvents(()=>{
            $d23214382ef45c41$var$firePointerEvent(element, "up");
        });
        const handleBlur = ()=>$d23214382ef45c41$var$firePointerEvent(element, "cancel");
        element.addEventListener("keyup", handleKeyup, eventOptions);
        element.addEventListener("blur", handleBlur, eventOptions);
    });
    element.addEventListener("keydown", handleKeydown, eventOptions);
    /**
     * Add an event listener that fires on blur to remove the keydown events.
     */ element.addEventListener("blur", ()=>element.removeEventListener("keydown", handleKeydown), eventOptions);
};



/**
 * Filter out events that are not primary pointer events, or are triggering
 * while a Motion gesture is active.
 */ function $0dce0970d0f5ed4e$var$isValidPressEvent(event) {
    return (0, $09534cabd85214e2$export$a4cf9c8a4b063a6e)(event) && !(0, $b6ebf11b6100dc3c$export$1b3dd616664938e4)();
}
/**
 * Create a press gesture.
 *
 * Press is different to `"pointerdown"`, `"pointerup"` in that it
 * automatically filters out secondary pointer events like right
 * click and multitouch.
 *
 * It also adds accessibility support for keyboards, where
 * an element with a press gesture will receive focus and
 *  trigger on Enter `"keydown"` and `"keyup"` events.
 *
 * This is different to a browser's `"click"` event, which does
 * respond to keyboards but only for the `"click"` itself, rather
 * than the press start and end/cancel. The element also needs
 * to be focusable for this to work, whereas a press gesture will
 * make an element focusable by default.
 *
 * @public
 */ function $0dce0970d0f5ed4e$export$dbe9198142dace0c(targetOrSelector, onPressStart, options = {}) {
    const [targets, eventOptions, cancelEvents] = (0, $50bd1bf239096030$export$edc0ace9d5e7e842)(targetOrSelector, options);
    const startPress = (startEvent)=>{
        const target = startEvent.currentTarget;
        if (!$0dce0970d0f5ed4e$var$isValidPressEvent(startEvent)) return;
        (0, $e8d22a14e745d2e6$export$7987404a4e35b84b).add(target);
        const onPressEnd = onPressStart(target, startEvent);
        const onPointerEnd = (endEvent, success)=>{
            window.removeEventListener("pointerup", onPointerUp);
            window.removeEventListener("pointercancel", onPointerCancel);
            if ((0, $e8d22a14e745d2e6$export$7987404a4e35b84b).has(target)) (0, $e8d22a14e745d2e6$export$7987404a4e35b84b).delete(target);
            if (!$0dce0970d0f5ed4e$var$isValidPressEvent(endEvent)) return;
            if (typeof onPressEnd === "function") onPressEnd(endEvent, {
                success: success
            });
        };
        const onPointerUp = (upEvent)=>{
            onPointerEnd(upEvent, target === window || target === document || options.useGlobalTarget || (0, $e89922a58014da6d$export$e841ada32ff745b)(target, upEvent.target));
        };
        const onPointerCancel = (cancelEvent)=>{
            onPointerEnd(cancelEvent, false);
        };
        window.addEventListener("pointerup", onPointerUp, eventOptions);
        window.addEventListener("pointercancel", onPointerCancel, eventOptions);
    };
    targets.forEach((target)=>{
        const pointerDownTarget = options.useGlobalTarget ? window : target;
        pointerDownTarget.addEventListener("pointerdown", startPress, eventOptions);
        if ((0, $cbd7a6317a819185$export$1b3bfaa9684536aa)(target)) {
            target.addEventListener("focus", (event)=>(0, $d23214382ef45c41$export$4b5790288fe12a79)(event, eventOptions));
            if (!(0, $ad1d34389582b0f4$export$5f6976e2f961e8b7)(target) && !target.hasAttribute("tabindex")) target.tabIndex = 0;
        }
    });
    return cancelEvents;
}




function $b3902e3e20ea107a$var$handlePressEvent(node, event, lifecycle) {
    const { props: props } = node;
    if (node.current instanceof HTMLButtonElement && node.current.disabled) return;
    if (node.animationState && props.whileTap) node.animationState.setActive("whileTap", lifecycle === "Start");
    const eventName = "onTap" + (lifecycle === "End" ? "" : lifecycle);
    const callback = props[eventName];
    if (callback) (0, $1fc179758a6fb1d9$export$2cef06c20297c17d).postRender(()=>callback(event, (0, $23ab615c547792c0$export$12f84bb882d06e1a)(event)));
}
class $b3902e3e20ea107a$export$f026abdbba7f0c9e extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    mount() {
        const { current: current } = this.node;
        if (!current) return;
        this.unmount = (0, $0dce0970d0f5ed4e$export$dbe9198142dace0c)(current, (_element, startEvent)=>{
            $b3902e3e20ea107a$var$handlePressEvent(this.node, startEvent, "Start");
            return (endEvent, { success: success })=>$b3902e3e20ea107a$var$handlePressEvent(this.node, endEvent, success ? "End" : "Cancel");
        }, {
            useGlobalTarget: this.node.props.globalTapTarget
        });
    }
    unmount() {}
}



/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $577133ec08d9e334$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $577133ec08d9e334$var$observers = new WeakMap();
const $577133ec08d9e334$var$fireObserverCallback = (entry)=>{
    const callback = $577133ec08d9e334$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $577133ec08d9e334$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($577133ec08d9e334$var$fireObserverCallback);
};
function $577133ec08d9e334$var$initIntersectionObserver({ root: root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$577133ec08d9e334$var$observers.has(lookupRoot)) $577133ec08d9e334$var$observers.set(lookupRoot, {});
    const rootObservers = $577133ec08d9e334$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($577133ec08d9e334$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $577133ec08d9e334$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $577133ec08d9e334$var$initIntersectionObserver(options);
    $577133ec08d9e334$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $577133ec08d9e334$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


const $3926a5d0685d183c$var$thresholdNames = {
    some: 0,
    all: 1
};
class $3926a5d0685d183c$export$150851c8cc2f0c72 extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $3926a5d0685d183c$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $577133ec08d9e334$export$b2bcd62fb7925aa5)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($3926a5d0685d183c$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
}
function $3926a5d0685d183c$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}


const $5e115984cd871deb$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $3926a5d0685d183c$export$150851c8cc2f0c72)
    },
    tap: {
        Feature: (0, $b3902e3e20ea107a$export$f026abdbba7f0c9e)
    },
    focus: {
        Feature: (0, $46d14c2f8ccf5da4$export$d4826db40d47595b)
    },
    hover: {
        Feature: (0, $dfb80d799aa36175$export$93a81ea037eac456)
    }
};




const $2c407ffdaf3c120a$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $a3289660bde9b219$export$b61a9eb3dbde8858),
        MeasureLayout: $cdf2a2ac04e7ce67$export$779f5fb01ad751cd
    }
};


const $8274a5011ff9e150$export$d596cd8841d25433 = {
    ...(0, $03e8b675a1009b68$export$7f9953c70dacfd7f),
    ...(0, $5e115984cd871deb$export$e5b72898e5a201f1),
    ...(0, $fc1974bcfc4fde1a$export$d7d5d435647ed5a0),
    ...(0, $2c407ffdaf3c120a$export$b3219800bda33a1f)
};


const $ffb02ccc9d959c1b$export$e25e478948902b8b = /*@__PURE__*/ (0, $f1922c0288de6004$export$a28d6df673050e18)((0, $8274a5011ff9e150$export$d596cd8841d25433), (0, $2f8881102ac6dde9$export$56ba0183203348f5));





var $acw62 = parcelRequire("acw62");
function $a1d52c9ea4d56e1e$var$parseRecipe(value) {
    if (!value) return {};
    if (typeof value === "object") return value;
    try {
        const parsed = JSON.parse(value);
        return parsed && typeof parsed === "object" ? parsed : {};
    } catch  {
        return {};
    }
}
function $a1d52c9ea4d56e1e$var$toList(value) {
    if (Array.isArray(value)) return value.filter((item)=>typeof item === "string" && item.trim() !== "");
    return typeof value === "string" && value.trim() !== "" ? [
        value
    ] : [];
}
function $a1d52c9ea4d56e1e$export$73da9e608103c23e(categories, params) {
    const selected = params.categories ?? [];
    const matched = selected.map((slug)=>categories.find((category)=>category.slug === slug)).filter((category)=>Boolean(category));
    const virtuals = matched.filter((category)=>category.filters || category.filters_invalid);
    if (virtuals.length === 0) return {
        params: params,
        lockedFacets: [],
        isVirtual: false,
        isInvalid: false
    };
    // A virtual recipe is a filter over its parent. With several selected
    // categories the backend applies search filters globally, so only apply the
    // recipe when the virtual category is the sole selected category; otherwise
    // keep every selected category (virtual children resolve to their parent).
    const applyRecipe = selected.length === 1 && virtuals.length === 1;
    const recipe = applyRecipe ? $a1d52c9ea4d56e1e$var$parseRecipe(virtuals[0].filters) : {};
    const search = recipe.search ?? {};
    const locked = new Set(applyRecipe && Array.isArray(recipe.lockedFacets) ? recipe.lockedFacets.filter((facet)=>typeof facet === "string") : []);
    const resolvedCategories = [
        ...matched.map((category)=>category.filters || category.filters_invalid ? category.parent_slug || category.slug : category.slug)
    ];
    const next = {
        ...params,
        categories: [
            ...new Set(resolvedCategories)
        ]
    };
    if (locked.has("screen_size")) {
        if (typeof search.screen_size_min === "number") next.screen_size_min = search.screen_size_min;
        if (typeof search.screen_size_max === "number") next.screen_size_max = search.screen_size_max;
    }
    if (locked.has("brand") && typeof search.brand === "string") next.brand = search.brand;
    if (locked.has("memory") && typeof search.memory === "string") next.memory = search.memory;
    if (locked.has("storage") && typeof search.storage === "string") next.storage = search.storage;
    if (locked.has("cpu")) {
        next.cpu = $a1d52c9ea4d56e1e$var$toList(search.cpu);
        if (!("cpu_brand" in search)) next.cpu_brand = null;
    }
    if (locked.has("gpu")) {
        next.gpu = $a1d52c9ea4d56e1e$var$toList(search.gpu);
        if (!("gpu_brand" in search)) next.gpu_brand = null;
    }
    if (locked.has("cpu") && typeof search.cpu_brand === "string") next.cpu_brand = search.cpu_brand;
    if (locked.has("gpu") && typeof search.gpu_brand === "string") next.gpu_brand = search.gpu_brand;
    if (locked.has("stock") && typeof search.stock_status === "string") next.stock_status = search.stock_status;
    if (locked.has("tags")) next.tags = $a1d52c9ea4d56e1e$var$toList(search.tags);
    if (locked.has("price") && Array.isArray(search.price_range)) next.price_range = search.price_range.filter((item)=>typeof item === "object" && item !== null).map((item)=>({
            min_price: typeof item.min_price === "number" ? item.min_price : 0,
            max_price: typeof item.max_price === "number" ? item.max_price : Number.MAX_SAFE_INTEGER
        }));
    const userSearch = typeof next.search_text === "string" ? next.search_text.trim() : "";
    const recipeSearch = typeof search.search_text === "string" ? search.search_text.trim() : "";
    next.search_text = userSearch || recipeSearch || null;
    return {
        params: next,
        lockedFacets: [
            ...locked
        ],
        isVirtual: true,
        isInvalid: virtuals.some((category)=>category.filters_invalid === true)
    };
}




const $14d5aa0296717100$export$80ee20aa64f130f = (searchParams, setLoading, setError)=>{
    const lastResolvedKey = (0, $acw62.useRef)("");
    const [pcs, setPCs] = (0, $acw62.useState)([]);
    const [categories, setCategories] = (0, $acw62.useState)([]);
    const [totalPages, setTotalPages] = (0, $acw62.useState)(0);
    const [filters, setFilters] = (0, $acw62.useState)(null);
    const fetchPCs = (0, $acw62.useCallback)(async (params)=>{
        setError(null);
        (0, $bac44633733ff026$export$2e2bcd8739ae039).post((0, $cd93687958c8007e$export$bfe19bc25132bb7c).CATALOG + "/_search", params).then((res)=>{
            const responseData = res.data;
            setPCs(responseData.results);
            setTotalPages(responseData.total_pages);
            setFilters(responseData.filters_summary_result);
        }).catch((err)=>{
            setError("Ocorreu um erro ao buscar os PCs: " + err.message);
            setPCs([]);
            setTotalPages(0);
            setFilters(null);
        }).finally(()=>setLoading(null));
    }, [
        setLoading,
        setError
    ]);
    const fetchCategories = (0, $acw62.useCallback)(async ()=>{
        setError(null);
        try {
            const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).CATALOG + "/metadata/categories");
            const categories = res.data;
            setCategories(categories);
            return categories;
        } catch (err) {
            setError("Ocorreu um erro ao buscar as categorias: " + err.message);
            return [];
        } finally{
            setLoading(null);
        }
    }, [
        setLoading,
        setError
    ]);
    const updateBrowserUrl = (params)=>{
        const queryParams = new URLSearchParams();
        Object.entries(params).forEach(([key, value])=>{
            if (key === "skip_filter") // Skip this filter from URL
            return;
            if (key === "price_range" && Array.isArray(value)) {
                value.forEach((v, index)=>{
                    if (v !== null && v !== undefined) {
                        queryParams.append(`${key}.min_price[${index}]`, String(v.min_price));
                        queryParams.append(`${key}.max_price[${index}]`, String(v.max_price));
                    }
                });
                return;
            }
            if (value !== null && value !== undefined && value !== "") {
                if (Array.isArray(value)) value.forEach((v)=>queryParams.append(key, String(v)));
                else if (typeof value === "object") // Handle object values if needed
                queryParams.set(key, JSON.stringify(value));
                else queryParams.set(key, String(value));
            }
        });
        window.history.pushState({
            ...history.state,
            searchParams: params
        }, "", `${window.location.pathname}?${queryParams.toString()}`);
    };
    (0, $acw62.useEffect)(()=>{
        if (categories.length === 0) fetchCategories();
    }, [
        fetchCategories,
        categories.length
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!searchParams || categories.length === 0) return;
        const resolved = (0, $a1d52c9ea4d56e1e$export$73da9e608103c23e)(categories, searchParams);
        if (resolved.isInvalid) {
            setPCs([]);
            setTotalPages(0);
            setFilters(null);
            setLoading(null);
            updateBrowserUrl(searchParams);
            return;
        }
        const key = JSON.stringify(resolved.params);
        if (key === lastResolvedKey.current) return;
        lastResolvedKey.current = key;
        fetchPCs(resolved.params);
        updateBrowserUrl(searchParams);
    }, [
        searchParams,
        categories,
        fetchPCs,
        setLoading
    ]);
    return {
        categories: categories.filter((category)=>category.is_filterable),
        compounds: pcs,
        totalPages: totalPages,
        filters: filters
    };
};


var $c48783e82a8986d7$exports = {};
"use strict";
function $c48783e82a8986d7$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $c48783e82a8986d7$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $c48783e82a8986d7$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $c48783e82a8986d7$var$_typeof(obj);
}
Object.defineProperty($c48783e82a8986d7$exports, "__esModule", {
    value: true
});
Object.defineProperty($c48783e82a8986d7$exports, "Box", {
    enumerable: true,
    get: function get() {
        return $c48783e82a8986d7$var$_box["default"];
    }
});
Object.defineProperty($c48783e82a8986d7$exports, "Block", {
    enumerable: true,
    get: function get() {
        return $c48783e82a8986d7$var$_block["default"];
    }
});
Object.defineProperty($c48783e82a8986d7$exports, "Button", {
    enumerable: true,
    get: function get() {
        return $c48783e82a8986d7$var$_button["default"];
    }
});
Object.defineProperty($c48783e82a8986d7$exports, "Breadcrumb", {
    enumerable: true,
    get: function get() {
        return $c48783e82a8986d7$var$_breadcrumb["default"];
    }
});
Object.defineProperty($c48783e82a8986d7$exports, "Card", {
    enumerable: true,
    get: function get() {
        return $c48783e82a8986d7$var$_card["default"];
    }
});
Object.defineProperty($c48783e82a8986d7$exports, "Columns", {
    enumerable: true,
    get: function get() {
        return $c48783e82a8986d7$var$_columns["default"];
    }
});
Object.defineProperty($c48783e82a8986d7$exports, "Container", {
    enumerable: true,
    get: function get() {
        return $c48783e82a8986d7$var$_container["default"];
    }
});
Object.defineProperty($c48783e82a8986d7$exports, "Content", {
    enumerable: true,
    get: function get() {
        return $c48783e82a8986d7$var$_content["default"];
    }
});
Object.defineProperty($c48783e82a8986d7$exports, "Footer", {
    enumerable: true,
    get: function get() {
        return $c48783e82a8986d7$var$_footer["default"];
    }
});
Object.defineProperty($c48783e82a8986d7$exports, "Heading", {
    enumerable: true,
    get: function get() {
        return $c48783e82a8986d7$var$_heading["default"];
    }
});
Object.defineProperty($c48783e82a8986d7$exports, "Hero", {
    enumerable: true,
    get: function get() {
        return $c48783e82a8986d7$var$_hero["default"];
    }
});
Object.defineProperty($c48783e82a8986d7$exports, "Image", {
    enumerable: true,
    get: function get() {
        return $c48783e82a8986d7$var$_image["default"];
    }
});
Object.defineProperty($c48783e82a8986d7$exports, "Level", {
    enumerable: true,
    get: function get() {
        return $c48783e82a8986d7$var$_level["default"];
    }
});
Object.defineProperty($c48783e82a8986d7$exports, "Media", {
    enumerable: true,
    get: function get() {
        return $c48783e82a8986d7$var$_media["default"];
    }
});
Object.defineProperty($c48783e82a8986d7$exports, "Notification", {
    enumerable: true,
    get: function get() {
        return $c48783e82a8986d7$var$_notification["default"];
    }
});
Object.defineProperty($c48783e82a8986d7$exports, "Progress", {
    enumerable: true,
    get: function get() {
        return $c48783e82a8986d7$var$_progress["default"];
    }
});
Object.defineProperty($c48783e82a8986d7$exports, "Section", {
    enumerable: true,
    get: function get() {
        return $c48783e82a8986d7$var$_section["default"];
    }
});
Object.defineProperty($c48783e82a8986d7$exports, "Tabs", {
    enumerable: true,
    get: function get() {
        return $c48783e82a8986d7$var$_tabs["default"];
    }
});
Object.defineProperty($c48783e82a8986d7$exports, "Table", {
    enumerable: true,
    get: function get() {
        return $c48783e82a8986d7$var$_table["default"];
    }
});
Object.defineProperty($c48783e82a8986d7$exports, "Tag", {
    enumerable: true,
    get: function get() {
        return $c48783e82a8986d7$var$_tag["default"];
    }
});
Object.defineProperty($c48783e82a8986d7$exports, "Tile", {
    enumerable: true,
    get: function get() {
        return $c48783e82a8986d7$var$_tile["default"];
    }
});
Object.defineProperty($c48783e82a8986d7$exports, "Modal", {
    enumerable: true,
    get: function get() {
        return $c48783e82a8986d7$var$_modal["default"];
    }
});
Object.defineProperty($c48783e82a8986d7$exports, "Dropdown", {
    enumerable: true,
    get: function get() {
        return $c48783e82a8986d7$var$_dropdown["default"];
    }
});
Object.defineProperty($c48783e82a8986d7$exports, "Icon", {
    enumerable: true,
    get: function get() {
        return $c48783e82a8986d7$var$_icon["default"];
    }
});
Object.defineProperty($c48783e82a8986d7$exports, "Loader", {
    enumerable: true,
    get: function get() {
        return $c48783e82a8986d7$var$_loader["default"];
    }
});
Object.defineProperty($c48783e82a8986d7$exports, "Navbar", {
    enumerable: true,
    get: function get() {
        return $c48783e82a8986d7$var$_navbar["default"];
    }
});
Object.defineProperty($c48783e82a8986d7$exports, "Pagination", {
    enumerable: true,
    get: function get() {
        return $c48783e82a8986d7$var$_pagination["default"];
    }
});
Object.defineProperty($c48783e82a8986d7$exports, "Menu", {
    enumerable: true,
    get: function get() {
        return $c48783e82a8986d7$var$_menu["default"];
    }
});
Object.defineProperty($c48783e82a8986d7$exports, "Message", {
    enumerable: true,
    get: function get() {
        return $c48783e82a8986d7$var$_message["default"];
    }
});
Object.defineProperty($c48783e82a8986d7$exports, "Panel", {
    enumerable: true,
    get: function get() {
        return $c48783e82a8986d7$var$_panel["default"];
    }
});
Object.defineProperty($c48783e82a8986d7$exports, "Element", {
    enumerable: true,
    get: function get() {
        return $c48783e82a8986d7$var$_element["default"];
    }
});
$c48783e82a8986d7$exports.Form = void 0;

var $c48783e82a8986d7$var$Form = $c48783e82a8986d7$var$_interopRequireWildcard((parcelRequire("bknYF")));
$c48783e82a8986d7$exports.Form = $c48783e82a8986d7$var$Form;

var $c48783e82a8986d7$var$_box = $c48783e82a8986d7$var$_interopRequireDefault((parcelRequire("5ovFQ")));

var $c48783e82a8986d7$var$_block = $c48783e82a8986d7$var$_interopRequireDefault((parcelRequire("h0tYP")));

var $c48783e82a8986d7$var$_button = $c48783e82a8986d7$var$_interopRequireDefault((parcelRequire("dcCpL")));

var $c48783e82a8986d7$var$_breadcrumb = $c48783e82a8986d7$var$_interopRequireDefault((parcelRequire("4H1Ps")));

var $c48783e82a8986d7$var$_card = $c48783e82a8986d7$var$_interopRequireDefault((parcelRequire("a9Mjo")));

var $c48783e82a8986d7$var$_columns = $c48783e82a8986d7$var$_interopRequireDefault((parcelRequire("3l82Q")));

var $c48783e82a8986d7$var$_container = $c48783e82a8986d7$var$_interopRequireDefault((parcelRequire("2iRmO")));

var $c48783e82a8986d7$var$_content = $c48783e82a8986d7$var$_interopRequireDefault((parcelRequire("fjmVQ")));

var $c48783e82a8986d7$var$_footer = $c48783e82a8986d7$var$_interopRequireDefault((parcelRequire("adbhe")));

var $c48783e82a8986d7$var$_heading = $c48783e82a8986d7$var$_interopRequireDefault((parcelRequire("d6xqU")));

var $c48783e82a8986d7$var$_hero = $c48783e82a8986d7$var$_interopRequireDefault((parcelRequire("eTw4Q")));

var $c48783e82a8986d7$var$_image = $c48783e82a8986d7$var$_interopRequireDefault((parcelRequire("hJmz0")));

var $c48783e82a8986d7$var$_level = $c48783e82a8986d7$var$_interopRequireDefault((parcelRequire("hWHZF")));

var $c48783e82a8986d7$var$_media = $c48783e82a8986d7$var$_interopRequireDefault((parcelRequire("4193C")));

var $c48783e82a8986d7$var$_notification = $c48783e82a8986d7$var$_interopRequireDefault((parcelRequire("cpj6E")));

var $c48783e82a8986d7$var$_progress = $c48783e82a8986d7$var$_interopRequireDefault((parcelRequire("fd74O")));

var $c48783e82a8986d7$var$_section = $c48783e82a8986d7$var$_interopRequireDefault((parcelRequire("5fxKp")));

var $c48783e82a8986d7$var$_tabs = $c48783e82a8986d7$var$_interopRequireDefault((parcelRequire("7GBox")));

var $c48783e82a8986d7$var$_table = $c48783e82a8986d7$var$_interopRequireDefault((parcelRequire("a6WHJ")));

var $c48783e82a8986d7$var$_tag = $c48783e82a8986d7$var$_interopRequireDefault((parcelRequire("9mk3w")));

var $c48783e82a8986d7$var$_tile = $c48783e82a8986d7$var$_interopRequireDefault((parcelRequire("78A1j")));

var $c48783e82a8986d7$var$_modal = $c48783e82a8986d7$var$_interopRequireDefault((parcelRequire("gxwfC")));

var $c48783e82a8986d7$var$_dropdown = $c48783e82a8986d7$var$_interopRequireDefault((parcelRequire("iK1sd")));

var $c48783e82a8986d7$var$_icon = $c48783e82a8986d7$var$_interopRequireDefault((parcelRequire("jlNIA")));

var $c48783e82a8986d7$var$_loader = $c48783e82a8986d7$var$_interopRequireDefault((parcelRequire("gckJY")));

var $c48783e82a8986d7$var$_navbar = $c48783e82a8986d7$var$_interopRequireDefault((parcelRequire("27h0F")));

var $c48783e82a8986d7$var$_pagination = $c48783e82a8986d7$var$_interopRequireDefault((parcelRequire("l0TYH")));

var $c48783e82a8986d7$var$_menu = $c48783e82a8986d7$var$_interopRequireDefault((parcelRequire("lkdWn")));

var $c48783e82a8986d7$var$_message = $c48783e82a8986d7$var$_interopRequireDefault((parcelRequire("jcCo9")));

var $c48783e82a8986d7$var$_panel = $c48783e82a8986d7$var$_interopRequireDefault((parcelRequire("9Zgtx")));

var $c48783e82a8986d7$var$_element = $c48783e82a8986d7$var$_interopRequireDefault((parcelRequire("9rI5f")));
function $c48783e82a8986d7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $c48783e82a8986d7$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $c48783e82a8986d7$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $c48783e82a8986d7$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || $c48783e82a8986d7$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $c48783e82a8986d7$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
// Hook personalizado para media queries
const $6473a599667a30d6$var$useMediaQuery = (query)=>{
    const [matches, setMatches] = (0, $acw62.useState)(()=>typeof window !== "undefined" ? window.matchMedia(query).matches : false);
    (0, $acw62.useEffect)(()=>{
        if (typeof window !== "undefined") {
            const mediaQuery = window.matchMedia(query);
            const handler = (event)=>setMatches(event.matches);
            mediaQuery.addEventListener("change", handler);
            return ()=>mediaQuery.removeEventListener("change", handler);
        }
    }, [
        query
    ]);
    return matches;
};
var $6473a599667a30d6$export$2e2bcd8739ae039 = $6473a599667a30d6$var$useMediaQuery;


const $93c2c2f5add88edc$var$useFilters = ()=>{
    const isDesktop = (0, $6473a599667a30d6$export$2e2bcd8739ae039)("(min-width: 1586px)");
    const [showFilters, setShowFilters] = (0, $acw62.useState)(isDesktop);
    const [selectedFirstFilter, setSelectedFirstFilter] = (0, $acw62.useState)(null);
    const [selectedLastFilter, setSelectedLastFilter] = (0, $acw62.useState)(null);
    const handleSelectedFirstFilter = (0, $acw62.useCallback)((filterType)=>{
        setSelectedFirstFilter((prevFirstFilter)=>{
            return filterType;
        });
    }, []);
    const handleSelectedLastFilter = (0, $acw62.useCallback)((filterType)=>{
        setSelectedLastFilter((prevLastFilter)=>{
            return filterType;
        });
    }, []);
    const handleShowFilters = (0, $acw62.useCallback)((show)=>{
        setShowFilters((prevShowFilters)=>{
            return show;
        });
    }, []);
    return {
        showFilters: showFilters,
        selectedFirstFilter: selectedFirstFilter,
        selectedLastFilter: selectedLastFilter,
        handleShowFilters: handleShowFilters,
        handleSelectedFirstFilter: handleSelectedFirstFilter,
        handleSelectedLastFilter: handleSelectedLastFilter
    };
};
var $93c2c2f5add88edc$export$2e2bcd8739ae039 = $93c2c2f5add88edc$var$useFilters;



var $acw62 = parcelRequire("acw62");
const $7e9192b0fa88c4ef$var$PAGINATION_LIMIT = 20;
const $7e9192b0fa88c4ef$var$useSearchAndPagination = ()=>{
    const [searchParams, setSearchParams] = (0, $acw62.useState)(()=>{
        if (history.state && history.state.searchParams) return history.state.searchParams;
        else {
            const result = {
                categories: [],
                memory: null,
                storage: null,
                cpu_brand: null,
                cpu: [],
                gpu_brand: null,
                gpu: [],
                price_range: [],
                skip_filter: null,
                page: 1,
                sort: "configured_price_pvp_with_vat asc",
                limit: $7e9192b0fa88c4ef$var$PAGINATION_LIMIT
            };
            const params = new URLSearchParams(window.location.search);
            params.forEach((value, key)=>{
                if (key.startsWith("price_range.")) {
                    const rangeIndex = parseInt(key.split(".")[2], 10);
                    if (!result.price_range) result.price_range = [];
                    if (!result.price_range[rangeIndex]) result.price_range[rangeIndex] = {
                        min_price: -1,
                        max_price: -1
                    };
                    // @ts-ignore
                    result.price_range[rangeIndex][key.split(".")[1]] = parseInt(value, 10);
                } else if (key === "sort") result[key] = value;
                else if (key === "skip_filter") result[key] = value;
                else if (key === "cpu_brand" || key === "gpu_brand") result[key] = value.trim() !== "" ? value : null;
                else if (key === "memory" || key === "storage") result[key] = value.trim() !== "" ? value : null;
                else if (key === "brand" || key === "stock_status") result[key] = value.trim() !== "" ? value : null;
                else if (key === "screen_size_min" || key === "screen_size_max") {
                    const parsed = Number(value);
                    result[key] = Number.isFinite(parsed) ? parsed : null;
                } else if (key === "categories") result.categories = value.split(",").map((v)=>v.trim()).filter((v)=>v !== "");
                else if (key === "limit") result[key] = parseInt(value, 10);
                else if (key === "page") result[key] = parseInt(value, 10);
                else if (key === "cpu" || key === "gpu") result[key] = value.split(",").map((v)=>v.trim()).filter((v)=>v !== "");
                else // @ts-ignore
                result[key] = value;
            });
            const categories = params.getAll("categories");
            if (categories.length > 0) result.categories = categories.flatMap((value)=>value.split(",")).map((value)=>value.trim()).filter((value)=>value !== "");
            return result;
        }
    });
    const handleFilterChange = (0, $acw62.useCallback)((filter, value, brand)=>{
        setSearchParams((prevParams)=>{
            const updatedParams = {
                ...prevParams,
                [filter]: value,
                page: 1
            };
            if (brand?.trim()) {
                if (filter === "cpu") updatedParams.cpu_brand = brand;
                else if (filter === "gpu") updatedParams.gpu_brand = brand;
            } else if (filter === "cpu" && value == "" && updatedParams.cpu_brand) updatedParams.cpu_brand = null;
            else if (filter === "gpu" && value == "" && updatedParams.gpu_brand) updatedParams.gpu_brand = null;
            if (Object.keys(prevParams).some((key)=>// @ts-ignore
                key !== "skip_filter" && prevParams[key] !== updatedParams[key])) updatedParams.skip_filter = filter;
            return updatedParams;
        });
    }, [
        setSearchParams
    ]);
    const resetFilter = (0, $acw62.useCallback)(()=>{
        setSearchParams((prevParams)=>({
                ...prevParams,
                cpu: [],
                gpu: [],
                gpu_brand: null,
                cpu_brand: null,
                memory: "",
                storage: "",
                price_range: [],
                search: "",
                page: 1
            }));
    }, [
        setSearchParams
    ]);
    const setPriceRange = (0, $acw62.useCallback)((priceRanges)=>{
        setSearchParams((prevParams)=>({
                ...prevParams,
                price_range: priceRanges,
                page: 1
            }));
    }, [
        setSearchParams
    ]);
    const handleSearch = (0, $acw62.useCallback)((searchTerm)=>{
        setSearchParams((prevParams)=>({
                ...prevParams,
                search_text: searchTerm,
                page: 1
            }));
    }, [
        setSearchParams
    ]);
    const handlePageChange = (0, $acw62.useCallback)((newPage)=>{
        setSearchParams((prevParams)=>({
                ...prevParams,
                page: newPage
            }));
    }, [
        setSearchParams
    ]);
    return {
        searchParams: searchParams,
        resetFilter: resetFilter,
        setSearchParams: setSearchParams,
        handleFilterChange: handleFilterChange,
        setPriceRange: setPriceRange,
        handleSearch: handleSearch,
        handlePageChange: handlePageChange
    };
};
var $7e9192b0fa88c4ef$export$2e2bcd8739ae039 = $7e9192b0fa88c4ef$var$useSearchAndPagination;



var $acw62 = parcelRequire("acw62");
const $20c1d43c3adcec74$var$usePCComparison = ()=>{
    const [selectedPCIdsToCompare, setSelectedPCIdsToCompare] = (0, $acw62.useState)(()=>{
        const storedIds = localStorage.getItem("comparePCs");
        return storedIds ? JSON.parse(storedIds) : [];
    });
    const handleAddToCompare = (0, $acw62.useCallback)((id)=>{
        if (!id) {
            setSelectedPCIdsToCompare([]);
            return;
        }
        if (Array.isArray(id)) {
            setSelectedPCIdsToCompare(id);
            return;
        }
        setSelectedPCIdsToCompare((prevIds)=>{
            if (prevIds.includes(id)) return prevIds.filter((pcId)=>pcId !== id);
            return [
                ...prevIds,
                id
            ];
        });
    }, []);
    const handleCloseCompare = (0, $acw62.useCallback)(()=>{
        setSelectedPCIdsToCompare([]);
    }, []);
    const doOpenCompare = (0, $acw62.useCallback)((selectedPCIds)=>{
        return selectedPCIds.length >= 2;
    }, []);
    const getPCsToCompare = (0, $acw62.useCallback)((allPCs)=>{
        return selectedPCIdsToCompare.map((id)=>{
            return allPCs.find((pc)=>pc.id === id) || null;
        });
    }, [
        selectedPCIdsToCompare
    ]);
    (0, $acw62.useEffect)(()=>{
        localStorage.setItem("comparePCs", JSON.stringify(selectedPCIdsToCompare));
    }, [
        selectedPCIdsToCompare
    ]);
    return {
        selectedPCIdsToCompare: selectedPCIdsToCompare,
        handleAddToCompare: handleAddToCompare,
        handleCloseCompare: handleCloseCompare,
        doOpenCompare: doOpenCompare,
        getPCsToCompare: getPCsToCompare
    };
};
var $20c1d43c3adcec74$export$2e2bcd8739ae039 = $20c1d43c3adcec74$var$usePCComparison;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $ae68eaa6700eaade$var$PriceRangeFilter = ({ setSelectedPriceRanges: setSelectedPriceRanges, selectedPriceRanges: selectedPriceRanges })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: [
            {
                min_price: -1,
                max_price: 500,
                name: "at\xe9 500 \u20AC"
            },
            {
                min_price: 500,
                max_price: 1000,
                name: "500\u20AC - 1000\u20AC"
            },
            {
                min_price: 1000,
                max_price: 2000,
                name: "1000\u20AC - 2000\u20AC"
            },
            {
                min_price: 2000,
                max_price: 3000,
                name: "2000\u20AC - 3000\u20AC"
            },
            {
                min_price: 3000,
                max_price: -1,
                name: "mais de 3000\u20AC"
            }
        ].map((item, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                className: `${selectedPriceRanges.some((range)=>range.min_price === item.min_price && range.max_price === item.max_price) ? "is-active has-background-info-dark has-text-white" : "has-background-info-light has-text-dark"} button text-white`,
                onClick: ()=>{
                    const isSelected = selectedPriceRanges.some((range)=>range.min_price === item.min_price && range.max_price === item.max_price);
                    if (isSelected) setSelectedPriceRanges(selectedPriceRanges.filter((range)=>!(range.min_price === item.min_price && range.max_price === item.max_price)));
                    else setSelectedPriceRanges([
                        ...selectedPriceRanges,
                        {
                            min_price: item.min_price,
                            max_price: item.max_price
                        }
                    ]);
                },
                children: item.name
            }, index))
    });
var $ae68eaa6700eaade$export$2e2bcd8739ae039 = $ae68eaa6700eaade$var$PriceRangeFilter;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $897d87e56f0ba47f$var$SortOptions = ({ searchParams: searchParams, setSearchParams: setSearchParams })=>{
    const handleSortChange = (event)=>{
        setSearchParams((prevParams)=>({
                ...prevParams,
                sort: event.target.value,
                page: 1
            }));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
            defaultValue: searchParams?.sort,
            className: "is-clickable button",
            onChange: handleSortChange,
            children: [
                {
                    value: "name asc",
                    label: "Nome A-Z"
                },
                {
                    value: "name desc",
                    label: "Nome Z-A"
                },
                {
                    value: "configured_price_pvp_with_vat asc",
                    label: "Pre\xe7o Crescente"
                },
                {
                    value: "configured_price_pvp_with_vat desc",
                    label: "Pre\xe7o Decrescente"
                }
            ].map((option, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                    value: option.value,
                    children: option.label
                }, index))
        })
    });
};
var $897d87e56f0ba47f$export$2e2bcd8739ae039 = $897d87e56f0ba47f$var$SortOptions;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c31db635520dc385$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m15 18-6-6 6-6",
            key: "1wnfg3"
        }
    ]
];
const $c31db635520dc385$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("chevron-left", $c31db635520dc385$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $7979593adeba180b$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m9 18 6-6-6-6",
            key: "mthhwq"
        }
    ]
];
const $7979593adeba180b$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("chevron-right", $7979593adeba180b$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4551b311634241de$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m11 17-5-5 5-5",
            key: "13zhaf"
        }
    ],
    [
        "path",
        {
            d: "m18 17-5-5 5-5",
            key: "h8a8et"
        }
    ]
];
const $4551b311634241de$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("chevrons-left", $4551b311634241de$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f09bbb993f3fef38$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m6 17 5-5-5-5",
            key: "xnjwq"
        }
    ],
    [
        "path",
        {
            d: "m13 17 5-5-5-5",
            key: "17xmmf"
        }
    ]
];
const $f09bbb993f3fef38$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("chevrons-right", $f09bbb993f3fef38$export$3efd853dbb351e94);


const $b38f3f5e0e7c2086$var$Pagination = ({ currentPage: currentPage, perPage: perPage, setPerPage: setPerPage, totalPages: totalPages, onPageChange: onPageChange })=>{
    if (totalPages <= 1 && !perPage) return null; // Don't show pagination if there's only one page
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex items-center justify-center mt-6 gap-2",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48783e82a8986d7$exports.Button), {
                variant: "outline",
                onClick: ()=>onPageChange(1),
                disabled: currentPage === 1,
                className: "bg-gray-800 text-white hover:bg-gray-700 disabled:opacity-50",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4551b311634241de$export$2e2bcd8739ae039), {
                    className: "w-4 h-4"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48783e82a8986d7$exports.Button), {
                variant: "outline",
                onClick: ()=>onPageChange(currentPage - 1),
                disabled: currentPage === 1,
                className: "bg-gray-800 text-white hover:bg-gray-700 disabled:opacity-50",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c31db635520dc385$export$2e2bcd8739ae039), {
                    className: "w-4 h-4"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                className: "text-gray-400",
                children: [
                    "P\xe1gina ",
                    currentPage,
                    " de ",
                    totalPages
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48783e82a8986d7$exports.Button), {
                variant: "outline",
                onClick: ()=>onPageChange(currentPage + 1),
                disabled: currentPage === totalPages,
                className: "bg-gray-800 text-white hover:bg-gray-700 disabled:opacity-50",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                    className: "w-4 h-4"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48783e82a8986d7$exports.Button), {
                variant: "outline",
                onClick: ()=>onPageChange(totalPages),
                disabled: currentPage === totalPages,
                className: "bg-gray-800 text-white hover:bg-gray-700 disabled:opacity-50",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f09bbb993f3fef38$export$2e2bcd8739ae039), {
                    className: "w-4 h-4"
                })
            }),
            perPage && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "text-gray-400 ml-4",
                children: setPerPage ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            children: "Itens por p\xe1gina "
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                            value: perPage,
                            onChange: (e)=>setPerPage(Number(e.target.value)),
                            className: "bg-gray-800 text-white border border-gray-600 rounded px-2 py-1",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                    value: 10,
                                    children: "10"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                    value: 20,
                                    children: "20"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                    value: 50,
                                    children: "50"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                    value: 100,
                                    children: "100"
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    children: [
                        "Mostrando ",
                        perPage,
                        " itens por p\xe1gina"
                    ]
                })
            })
        ]
    });
};
var $b38f3f5e0e7c2086$export$2e2bcd8739ae039 = $b38f3f5e0e7c2086$var$Pagination;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $0b3839c233a854b7$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "18",
            cy: "18",
            r: "3",
            key: "1xkwt0"
        }
    ],
    [
        "circle",
        {
            cx: "6",
            cy: "6",
            r: "3",
            key: "1lh9wr"
        }
    ],
    [
        "path",
        {
            d: "M13 6h3a2 2 0 0 1 2 2v7",
            key: "1yeb86"
        }
    ],
    [
        "path",
        {
            d: "M11 18H8a2 2 0 0 1-2-2V9",
            key: "19pyzm"
        }
    ]
];
const $0b3839c233a854b7$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("git-compare", $0b3839c233a854b7$export$3efd853dbb351e94);




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $59c13cdd8f338caa$var$NIPOSOM_DOMAINS = [
    "www.niposom.com",
    "www.niposom.pt"
];
// Keep in sync with the transcoder defaults (TRANSCODER_MAX_WIDTH / _MAX_HEIGHT).
const $59c13cdd8f338caa$var$CDN_MAX_WIDTH = 1920;
const $59c13cdd8f338caa$var$CDN_MAX_HEIGHT = 1080;
// Mirrors the transcoder route: /webp/<w>[x<h>]/<path>
const $59c13cdd8f338caa$var$SIZES_PATTERN = /^(\d{2,4})(?:x(\d{2,4}))?$/;
function $59c13cdd8f338caa$export$d5678b2d235dd40(src, sizes, version) {
    if (!src || !sizes) return src;
    const sizesMatch = $59c13cdd8f338caa$var$SIZES_PATTERN.exec(sizes);
    const width = Number(sizesMatch?.[1] ?? 0);
    const height = Number(sizesMatch?.[2] ?? 0);
    if (!sizesMatch || width <= 0 || width > $59c13cdd8f338caa$var$CDN_MAX_WIDTH || height > $59c13cdd8f338caa$var$CDN_MAX_HEIGHT) return src;
    const domain = $59c13cdd8f338caa$var$NIPOSOM_DOMAINS.find((host)=>src.includes(host));
    let imagePath = null;
    if (domain) imagePath = src.substring(src.indexOf(domain) + domain.length + 1);
    else if (src.includes("/static/") && !src.includes("localhost")) imagePath = src.substring(src.indexOf("/static/") + 8);
    if (imagePath === null) return src;
    // The transcoder ignores query strings; drop any source cache-buster so the
    // version we append is the only query parameter.
    const cleanPath = imagePath.split("?")[0];
    const url = `/webp/${sizes}/${cleanPath}`;
    return version ? `${url}?v=${version}` : url;
}


const $1e87b4633e3445bd$var$Image = ({ src: src, dataSrc: dataSrc, sizes: sizes, version: version, alt: alt, loading: loading, ...rest })=>{
    const contentRef = (0, $acw62.useRef)(null);
    const [imageSrc, setImageSrc] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(src);
    const translateUrl = (dataSrc)=>(0, $59c13cdd8f338caa$export$d5678b2d235dd40)(dataSrc ?? src, sizes, version);
    (0, $acw62.useEffect)(()=>{
        if (contentRef.current) {
            contentRef.current.style.filter = "blur(10px)";
            contentRef.current.classList.add("image-loading");
        }
        setImageSrc(translateUrl(src));
    }, [
        dataSrc,
        sizes,
        src,
        version
    ]);
    (0, $acw62.useEffect)(()=>{
        const translatedSrc = translateUrl(src);
        setImageSrc(translatedSrc);
        if (loading === "progressive") {
            if (contentRef.current) contentRef.current.classList.add("image-loading");
            const tmpImg = document.createElement("img");
            tmpImg.src = translateUrl(dataSrc ?? null);
            tmpImg.onload = ()=>{
                if (contentRef.current) {
                    contentRef.current.style.filter = "none";
                    contentRef.current.classList.add("image-loaded");
                    contentRef.current.classList.remove("image-loading");
                    contentRef.current.src = tmpImg.src;
                }
            };
        } else if (contentRef.current) {
            contentRef.current.style.filter = "none";
            contentRef.current.classList.add("image-loaded");
            contentRef.current.classList.remove("image-loading");
        }
    }, [
        dataSrc,
        sizes,
        src,
        loading,
        version
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
        ref: contentRef,
        src: imageSrc,
        alt: alt,
        style: {
            filter: "blur(10px)",
            transition: "filter 0.3s ease-out"
        },
        className: "rounded-lg shadow-md max-w-full h-auto object-cover",
        ...rest
    });
};
var $1e87b4633e3445bd$export$2e2bcd8739ae039 = $1e87b4633e3445bd$var$Image;


const $26e0a94c4d362f24$var$PCListItem = ({ pc: pc, layoutGrid: layoutGrid, handleViewDetails: handleViewDetails, handleAddToCompare: handleAddToCompare, selectedPCIdsToCompare: selectedPCIdsToCompare, showCosts: showCosts = true })=>{
    const stockWarningThreshold = 5;
    const stockLabel = pc.available_units === 0 ? "Consultar" : pc.available_units <= stockWarningThreshold ? "\xdaltimas Unidades" : "Disponivel";
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c48783e82a8986d7$exports.Card), {
        onClick: ()=>handleViewDetails(pc.id),
        className: `pc-configuration hover:shadow-lg is-clickable transition-shadow is-rounded ${layoutGrid ? "" : "flex grow-2"}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48783e82a8986d7$exports.Card).Header, {
                className: layoutGrid ? "" : "flex-row sm:flex-col",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "image-container w-full",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e87b4633e3445bd$export$2e2bcd8739ae039), {
                        height: layoutGrid ? 200 : 100,
                        src: "https://placehold.co/400",
                        dataSrc: pc.image && pc.image.trim() !== "" ? `${pc.image.trim()}` : "https://placehold.co/400",
                        alt: pc.name,
                        sizes: "400x400",
                        version: pc.version,
                        loading: "progressive",
                        className: `object-cover w-full  ${layoutGrid ? "h-48" : "sm:h-full sm:max-h-[200px]"}`
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c48783e82a8986d7$exports.Card).Content, {
                className: layoutGrid ? "" : "flex flex-col items-start justify-between",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "block justify-between items-start",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                className: `text-stone-900 is-size-5 ${layoutGrid ? "line-clamp-2" : ""}`,
                                children: pc.id
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: `text-gray-600 text-xs`,
                                children: pc.description
                            })
                        ]
                    }),
                    stockLabel && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: layoutGrid ? "" : "absolute top-2 right-2",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: `tag is-light text-xs font-bold ${pc.available_units === 0 ? "is-danger" : pc.available_units <= stockWarningThreshold ? "is-warning" : "is-success"}`,
                            children: stockLabel
                        })
                    }),
                    !pc.image && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: `${layoutGrid ? "flex justify-between items-start gap-2" : ""}`,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: `text-gray-400 mb-6 ${layoutGrid ? "line-clamp-3" : ""}`,
                            children: pc.description
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: layoutGrid ? "space-y-2" : "flex flex-col sm:flex-row sm:items-center sm:gap-4",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: `w-full ${layoutGrid ? "gap-2" : "flex gap-4"}`,
                            children: [
                                showCosts && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "text-xs font-bold text-gray-400 reseller-cost",
                                    children: [
                                        "preco de revenda:",
                                        " ",
                                        (pc.price.promotional_reseller_price ?? pc.price.resell ?? 0).toLocaleString("pt-PT", {
                                            style: "currency",
                                            currency: pc.price.currency
                                        }),
                                        " ",
                                        pc.price.promotional_reseller_price != null && pc.price.resell != null && pc.price.promotional_reseller_price < pc.price.resell && /*#__PURE__*/ (0, $ayMG0.jsx)("del", {
                                            className: "ml-1",
                                            title: "Pre\xe7o anterior",
                                            children: pc.price.resell.toLocaleString("pt-PT", {
                                                style: "currency",
                                                currency: pc.price.currency
                                            })
                                        })
                                    ]
                                }),
                                pc.price.promotional_pvp_with_vat != null && pc.price.promotional_pvp_with_vat > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "text-lg font-bold price-value",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "text-green-700",
                                            children: pc.price.promotional_pvp_with_vat.toLocaleString("pt-PT", {
                                                style: "currency",
                                                currency: pc.price.currency
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "text-xs text-gray-400 ml-1 line-through",
                                            children: pc.price.value.toLocaleString("pt-PT", {
                                                style: "currency",
                                                currency: pc.price.currency
                                            })
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "text-lg font-bold price-value",
                                    children: pc.price.value.toLocaleString("pt-PT", {
                                        style: "currency",
                                        currency: pc.price.currency
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "absolute items-center justify-between bottom-0 right-0 p-1 is-clearfix",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).button, {
                            whileHover: {
                                scale: 1.1
                            },
                            whileTap: {
                                scale: 0.9
                            },
                            onClick: (e)=>{
                                handleAddToCompare(pc.id);
                                e.stopPropagation();
                            },
                            disabled: !selectedPCIdsToCompare.includes(pc.id) && selectedPCIdsToCompare.length >= 5,
                            className: `is-clickable p-2  text-white  disabled:bg-gray-400 ${selectedPCIdsToCompare.includes(pc.id) ? "bg-blue-500 hover:bg-red-600" : "bg-gray-800 hover:bg-blue-700"}`,
                            "aria-label": "Adicionar ao comparador",
                            title: "Adicionar ao comparador",
                            children: selectedPCIdsToCompare.includes(pc.id) ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0b3839c233a854b7$export$2e2bcd8739ae039), {
                                className: "w-5 h-5"
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0811c1891b547863$export$2e2bcd8739ae039), {
                                className: "w-5 h-5"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $26e0a94c4d362f24$export$2e2bcd8739ae039 = $26e0a94c4d362f24$var$PCListItem;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $0fc1c6431925772d$var$FilterComponent = ({ allFilters: allFilters, component_name: component_name, componentTypeKey: componentTypeKey, selectedFilter: selectedFilter, setSelectedFilter: setSelectedFilter, lastSelectedFilter: lastSelectedFilter })=>{
    const groupFiltersByCategory = (allFilters)=>{
        return allFilters.reduce((acc, filter)=>{
            if (!acc[filter.brand]) acc[filter.brand] = [];
            acc[filter.brand].push(filter);
            return acc;
        }, {});
    };
    const groupedFilters = groupFiltersByCategory(allFilters);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "field mt-4",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                className: "label",
                children: component_name
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "control",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "select is-fullwidth",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                        value: selectedFilter || "",
                        onChange: (e)=>{
                            const selectedId = e.target.value;
                            setSelectedFilter(selectedId);
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                value: "",
                                children: "Todos"
                            }),
                            Object.entries(groupedFilters).map(([type, filters])=>filters.map((filter, index)=>{
                                    if (lastSelectedFilter != null && (lastSelectedFilter != componentTypeKey && filter.count_filter_compounds === 0 || lastSelectedFilter == componentTypeKey && filter.count_skipped_compounds === 0) && selectedFilter != filter.name) return null;
                                    return filter.name !== "" && /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: filter.name,
                                        children: filter.name
                                    }, index);
                                }))
                        ]
                    })
                })
            })
        ]
    });
};
var $0fc1c6431925772d$export$2e2bcd8739ae039 = $0fc1c6431925772d$var$FilterComponent;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $41875c673ca43149$var$FilterComponentMulti = ({ allFilters: allFilters, componentName: componentName, componentTypeKey: componentTypeKey, selectedFilter: selectedFilter, setSelectedFilter: setSelectedFilter, lastSelectedFilter: lastSelectedFilter, selectedGroupType: selectedGroupType })=>{
    const [selectedOptions, setSelectedOptions] = (0, $acw62.useState)([]);
    const setBrandFilter = (brand)=>{
        const options = [];
        setSelectedOptions(options);
        setSelectedFilter(componentTypeKey, options, brand);
    };
    const groupFiltersByCategory = (allFilters)=>{
        return allFilters.reduce((acc, filter)=>{
            if (!acc[filter.brand]) acc[filter.brand] = [];
            acc[filter.brand].push(filter);
            return acc;
        }, {});
    };
    const groupedFilters = groupFiltersByCategory(allFilters);
    const handleSelectChange = (e)=>{
        const selectedId = e.target.value;
        setBrandFilter(selectedId);
    };
    const handleOptionChange = (option)=>{
        let updateOptions = selectedOptions.includes(option) ? selectedOptions.filter((o)=>o !== option) : [
            ...selectedOptions,
            option
        ];
        setSelectedOptions(updateOptions);
        setSelectedFilter(componentTypeKey, updateOptions, null);
    };
    (0, $acw62.useEffect)(()=>{
        setSelectedOptions(selectedFilter || []);
    }, [
        selectedFilter
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: `field mt-4`,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "control multi-filter",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "is-fullwidth flex flex-wrap",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "is-align-content-space-evenly",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                className: "label",
                                children: componentName
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "select ml-10",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                value: selectedGroupType || "",
                                onChange: handleSelectChange,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "",
                                        children: "Todos"
                                    }),
                                    Object.entries(groupedFilters).map(([type, filters])=>filters.filter((filter)=>filter.brand === type && !filter.name).map((filter, index)=>filter.brand.trim() !== "" && /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                value: filter.brand,
                                                children: filter.brand
                                            }, index)))
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "field m-3",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "checkboxes grid",
                        children: Object.entries(groupedFilters).flatMap(([type, filters])=>filters.map((option, index)=>{
                                if (lastSelectedFilter != null && (lastSelectedFilter != componentTypeKey && option.count_filter_compounds === 0 && option.brand !== selectedGroupType || lastSelectedFilter == componentTypeKey && option.count_skipped_compounds === 0) && !selectedOptions.includes(option.name)) return null;
                                return option.name && /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                    className: `checkbox is-block ${lastSelectedFilter != null && lastSelectedFilter != componentTypeKey && option.count_filter_compounds === 0 || (selectedGroupType ?? "") != "" && selectedGroupType !== option.brand ? "opacity-50" : ""}`,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "checkbox",
                                            value: option.name,
                                            name: option.name,
                                            disabled: (selectedGroupType ?? "") != "" && selectedGroupType !== option.brand,
                                            checked: selectedOptions.includes(option.name),
                                            onChange: ()=>handleOptionChange(option.name)
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "p-2 y-2",
                                            children: option.name
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "float-right text-xs",
                                            children: lastSelectedFilter != null && lastSelectedFilter != componentTypeKey ? option.count_filter_compounds : option.count_compounds
                                        })
                                    ]
                                }, option.component_type_key + option.brand + option.name + index);
                            }))
                    })
                })
            ]
        })
    });
};
var $41875c673ca43149$export$2e2bcd8739ae039 = $41875c673ca43149$var$FilterComponentMulti;



var $acw62 = parcelRequire("acw62");

const $2bad8a286d23d5dc$var$useOpenPage = ()=>{
    const navigate = (0, $585f8bce88e531c1$export$9770f232ac06a008)();
    const handleOpenPage = (0, $acw62.useCallback)((id)=>{
        navigate(`/pc/${id}`);
    }, [
        navigate
    ]);
    return {
        handleOpenPage: handleOpenPage
    };
};
var $2bad8a286d23d5dc$export$2e2bcd8739ae039 = $2bad8a286d23d5dc$var$useOpenPage;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $25675e0b3018d144$var$FilterCategories = ({ categories: categories, selectedFilter: selectedFilter, setSelectedFilter: setSelectedFilter })=>{
    const handleCategoryChange = (event)=>{
        const { value: value, checked: checked } = event.target;
        let updatedFilters = [
            ...selectedFilter
        ];
        if (checked) updatedFilters.push(value);
        else updatedFilters = updatedFilters.filter((filter)=>filter !== value);
        setSelectedFilter("categories", updatedFilters, null);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "filter-categories field mt-4",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "control",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "is-fullwidth flex flex-wrap",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "is-align-content-space-evenly",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                            className: "label",
                            children: "Categoria"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: `filters-container m-4 w-full sm:max-w-[350px]`,
                        children: (()=>{
                            const visible = categories.filter((category)=>category.is_filterable);
                            const byParent = new Map();
                            for (const category of visible){
                                const parent = category.parent_slug || "";
                                const children = byParent.get(parent) ?? [];
                                children.push(category);
                                byParent.set(parent, children);
                            }
                            const roots = visible.filter((category)=>!category.parent_slug || !visible.some((candidate)=>candidate.slug === category.parent_slug));
                            const renderCategory = (category, depth)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "filter-category",
                                    style: {
                                        marginLeft: depth * 14
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "checkbox",
                                            id: category.slug,
                                            name: category.slug,
                                            value: category.slug,
                                            className: "mr-2",
                                            checked: selectedFilter.includes(category.slug),
                                            onChange: handleCategoryChange
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            htmlFor: category.slug,
                                            children: category.name
                                        }),
                                        (byParent.get(category.slug) ?? []).map((child)=>renderCategory(child, depth + 1))
                                    ]
                                }, category.slug);
                            return roots.map((category)=>renderCategory(category, 0));
                        })()
                    })
                ]
            })
        })
    });
};
var $25675e0b3018d144$export$2e2bcd8739ae039 = $25675e0b3018d144$var$FilterCategories;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $30050f52d874b8f2$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M8 2v4",
            key: "1cmpym"
        }
    ],
    [
        "path",
        {
            d: "M16 2v4",
            key: "4m81vk"
        }
    ],
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "4",
            rx: "2",
            key: "1hopcy"
        }
    ],
    [
        "path",
        {
            d: "M3 10h18",
            key: "8toen8"
        }
    ]
];
const $30050f52d874b8f2$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("calendar", $30050f52d874b8f2$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4f88028b3cc726f6$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m6 9 6 6 6-6",
            key: "qrunsl"
        }
    ]
];
const $4f88028b3cc726f6$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("chevron-down", $4f88028b3cc726f6$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $b397e876e35a9277$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m18 15-6-6-6 6",
            key: "153udz"
        }
    ]
];
const $b397e876e35a9277$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("chevron-up", $b397e876e35a9277$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $3c35b0991cad9668$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M15 3h6v6",
            key: "1q9fwt"
        }
    ],
    [
        "path",
        {
            d: "M10 14 21 3",
            key: "gplh6r"
        }
    ],
    [
        "path",
        {
            d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6",
            key: "a6xqqp"
        }
    ]
];
const $3c35b0991cad9668$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("external-link", $3c35b0991cad9668$export$3efd853dbb351e94);




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $72a6b92b551e5c3a$var$ImageCarousel = ({ images: images, alt: alt, autoRotateInterval: autoRotateInterval = 4000 })=>{
    const [currentIndex, setCurrentIndex] = (0, $acw62.useState)(0);
    const [isPaused, setIsPaused] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (images.length <= 1 || isPaused) return;
        const interval = setInterval(()=>{
            setCurrentIndex((prev)=>(prev + 1) % images.length);
        }, autoRotateInterval);
        return ()=>clearInterval(interval);
    }, [
        images.length,
        autoRotateInterval,
        isPaused
    ]);
    if (!images || images.length === 0) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "w-full h-48 bg-gray-200 flex items-center justify-center text-gray-400",
        children: "No images"
    });
    if (images.length === 1) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "w-full h-48 overflow-hidden bg-gray-200",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
            src: images[0],
            alt: alt,
            className: "w-full h-full object-cover"
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "relative w-full h-48 overflow-hidden bg-gray-200",
        onMouseEnter: ()=>setIsPaused(true),
        onMouseLeave: ()=>setIsPaused(false),
        children: [
            images.map((image, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: `absolute inset-0 transition-opacity duration-500 ${index === currentIndex ? "opacity-100" : "opacity-0"}`,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: image,
                        alt: `${alt} - ${index + 1}`,
                        className: "w-full h-full object-cover"
                    })
                }, index)),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "absolute bottom-2 left-0 right-0 flex justify-center gap-2",
                children: images.map((_, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: ()=>setCurrentIndex(index),
                        className: `w-2 h-2 rounded-full transition-all ${index === currentIndex ? "bg-white w-4" : "bg-white/50 hover:bg-white/75"}`,
                        "aria-label": `Go to image ${index + 1}`
                    }, index))
            })
        ]
    });
};
var $72a6b92b551e5c3a$export$2e2bcd8739ae039 = $72a6b92b551e5c3a$var$ImageCarousel;


const $1e0b1d4517ccefed$var$HighlightsSection = ()=>{
    const [highlights, setHighlights] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [expanded, setExpanded] = (0, $acw62.useState)(true);
    const navigate = (0, $585f8bce88e531c1$export$9770f232ac06a008)();
    (0, $acw62.useEffect)(()=>{
        const fetchHighlights = async ()=>{
            try {
                const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).HIGHLIGHTS}/active`);
                setHighlights(response.data || []);
            } catch (error) {
                console.log("Error fetching active highlights:", error);
            } finally{
                setLoading(false);
            }
        };
        fetchHighlights();
    }, []);
    const handleHighlightClick = (highlight)=>{
        if (highlight.compound_id) navigate(`/pc/${highlight.compound_id}`);
        else if (highlight.link_url) window.open(highlight.link_url, "_blank", "noopener,noreferrer");
    };
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "mb-8 p-6 bg-gray-50 rounded-lg",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "animate-pulse flex space-x-4",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex-1 space-y-4 py-1",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "h-4 bg-gray-300 rounded w-3/4"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "h-4 bg-gray-300 rounded"
                    })
                ]
            })
        })
    });
    if (highlights.length === 0) return null; // Don't show anything if no active highlights
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "overflow-hidden",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex justify-between items-center p-4 cursor-pointer bg-gray-50 hover:bg-gray-100 transition-colors",
                onClick: ()=>setExpanded(!expanded),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "text-xl font-bold text-gray-900 tracking-tight",
                        children: "Destaques"
                    }),
                    expanded ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b397e876e35a9277$export$2e2bcd8739ae039), {
                        className: "w-5 h-5 text-gray-600"
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                        className: "w-5 h-5 text-gray-600"
                    })
                ]
            }),
            expanded && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "py-4 border-t border-gray-200",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "overflow-x-auto",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex gap-6 pb-1",
                        style: {
                            minWidth: "min-content"
                        },
                        children: highlights.map((highlight)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                onClick: ()=>handleHighlightClick(highlight),
                                className: `bg-white rounded-lg shadow-md overflow-hidden transition-all flex-shrink-0 w-80 border border-gray-100 ${highlight.compound_id || highlight.link_url ? "cursor-pointer hover:shadow-lg hover:-translate-y-1" : ""}`,
                                children: [
                                    highlight.images && highlight.images.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $72a6b92b551e5c3a$export$2e2bcd8739ae039), {
                                        images: highlight.images,
                                        alt: highlight.title
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "p-4",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                                className: "text-lg font-semibold text-gray-900 mb-2",
                                                children: [
                                                    highlight.title,
                                                    highlight.link_url && !highlight.compound_id && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3c35b0991cad9668$export$2e2bcd8739ae039), {
                                                        className: "inline w-4 h-4 ml-1 text-blue-600"
                                                    })
                                                ]
                                            }),
                                            highlight.description && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "text-gray-600 text-sm mb-3 line-clamp-3",
                                                children: highlight.description
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex items-center text-xs text-gray-500",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30050f52d874b8f2$export$2e2bcd8739ae039), {
                                                        className: "w-3 h-3 mr-1"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        children: [
                                                            "V\xe1lido at\xe9",
                                                            " ",
                                                            new Date(highlight.end_date).toLocaleDateString("pt-PT")
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, highlight.id))
                    })
                })
            })
        ]
    });
};
var $1e0b1d4517ccefed$export$2e2bcd8739ae039 = $1e0b1d4517ccefed$var$HighlightsSection;


const $26f70be055e85cab$var$ListPage = ()=>{
    const { searchParams: searchParams, resetFilter: resetFilter, setSearchParams: setSearchParams, handleFilterChange: handleFilterChange, handleSearch: setSearchTerm, handlePageChange: handlePageChange } = (0, $7e9192b0fa88c4ef$export$2e2bcd8739ae039)();
    const navigate = (0, $585f8bce88e531c1$export$9770f232ac06a008)();
    const { isAuthenticated: isAuthenticated } = (0, $b622ef53e38024e7$export$1d39dc5b47e56ff0)();
    const { userSettings: userSettings, page: page, setPage: setPage, error: error, setError: setError, loading: loading, setLoading: setLoading } = (0, $a55f2a94cd420149$export$c50e37a2f0a2b064)();
    const { showFilters: showFilters, handleShowFilters: handleShowFilters } = (0, $93c2c2f5add88edc$export$2e2bcd8739ae039)();
    const { categories: categories, compounds: compounds, totalPages: totalPages, filters: filters } = (0, $14d5aa0296717100$export$80ee20aa64f130f)(searchParams, setLoading, setError);
    const { selectedPCIdsToCompare: selectedPCIdsToCompare, handleAddToCompare: handleAddToCompare } = (0, $20c1d43c3adcec74$export$2e2bcd8739ae039)();
    const { handleOpenPage: handleOpenPage } = (0, $2bad8a286d23d5dc$export$2e2bcd8739ae039)();
    const [showCompare, setShowCompare] = (0, $acw62.useState)(false);
    const toggleCompareModal = ()=>{
        if (selectedPCIdsToCompare.length >= 2) {
            const ids = selectedPCIdsToCompare.join(";");
            navigate(`/comparar/${ids}`);
        } else setShowCompare(!showCompare);
    };
    const handleSearchSubmit = (0, $acw62.useCallback)((searchTerm)=>{
        setSearchTerm(searchTerm);
    }, [
        setSearchTerm
    ]);
    if (!isAuthenticated()) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: "You must be logged in to edit items."
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "container mx-auto relative flex flex-col sm:flex-row",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: `filters-container m-4 w-full sm:max-w-[350px] ${showFilters ? "block" : "hidden"}`,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "box top-0",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                type: "text",
                                className: "input mt-4",
                                placeholder: "Pesquisar...",
                                value: searchParams.search_text || "",
                                onChange: (e)=>setSearchTerm(e.target.value),
                                onKeyDown: (e)=>{
                                    if (e.key === "Enter") handleSearchSubmit(e.currentTarget.value);
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $25675e0b3018d144$export$2e2bcd8739ae039), {
                                categories: categories,
                                selectedFilter: searchParams?.categories || [],
                                setSelectedFilter: handleFilterChange
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48783e82a8986d7$exports.Button), {
                                onClick: ()=>{
                                    resetFilter();
                                },
                                className: "mt-4",
                                children: "Limpar Filtros"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $41875c673ca43149$export$2e2bcd8739ae039), {
                                allFilters: filters?.gpu || [],
                                componentName: "Placa Gr\xe1fica",
                                componentTypeKey: "gpu",
                                lastSelectedFilter: filters?.skip_filter ?? null,
                                selectedFilter: searchParams?.gpu || [],
                                selectedGroupType: searchParams?.gpu_brand || "",
                                setSelectedFilter: handleFilterChange
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $41875c673ca43149$export$2e2bcd8739ae039), {
                                allFilters: filters?.cpu || [],
                                componentName: "Processador",
                                componentTypeKey: "cpu",
                                lastSelectedFilter: filters?.skip_filter ?? null,
                                selectedFilter: searchParams?.cpu || [],
                                selectedGroupType: searchParams?.cpu_brand || "",
                                setSelectedFilter: handleFilterChange
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0fc1c6431925772d$export$2e2bcd8739ae039), {
                                allFilters: filters?.memory || [],
                                component_name: "Memoria",
                                componentTypeKey: "memory",
                                selectedFilter: searchParams?.memory ?? "",
                                lastSelectedFilter: filters?.skip_filter ?? null,
                                setSelectedFilter: (value)=>handleFilterChange("memory", value, null)
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0fc1c6431925772d$export$2e2bcd8739ae039), {
                                allFilters: filters?.storage || [],
                                component_name: "Storage",
                                componentTypeKey: "storage",
                                selectedFilter: searchParams?.storage ?? "",
                                lastSelectedFilter: filters?.skip_filter ?? null,
                                setSelectedFilter: (value)=>handleFilterChange("storage", value, null)
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    id: "list",
                    className: `items-center px-4 py-2 pb-6 ${showFilters ? "pl-10" : "flex-1 w-full"}`,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "container mx-auto py-2",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e0b1d4517ccefed$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("nav", {
                            className: "box is-centered is-medium mt-2",
                            "aria-label": "breadcrumbs",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                className: "flex flex-wrap gap-6 justify-center",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        className: "block",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            className: "button text-gray-500 hover:text-gray-700",
                                            onClick: ()=>handleShowFilters(!showFilters),
                                            children: showFilters ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: "Fechar Filtros"
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: "Mostrar Filtros"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ae68eaa6700eaade$export$2e2bcd8739ae039), {
                                        selectedPriceRanges: searchParams?.price_range || [],
                                        setSelectedPriceRanges: (selectedPriceRanges)=>{
                                            setSearchParams((prevParams)=>({
                                                    ...prevParams,
                                                    price_range: selectedPriceRanges,
                                                    page: 1
                                                }));
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $897d87e56f0ba47f$export$2e2bcd8739ae039), {
                                        searchParams: searchParams,
                                        setSearchParams: (value)=>setSearchParams(value)
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: `grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 ${showFilters ? "md:grid-cols-1" : "md:grid-cols-2"}`,
                            children: loading ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "flex justify-center items-center w-full h-full",
                                children: "A carregar ..."
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: compounds.map((compound, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $26e0a94c4d362f24$export$2e2bcd8739ae039), {
                                        pc: compound,
                                        layoutGrid: true,
                                        handleViewDetails: handleOpenPage,
                                        handleAddToCompare: handleAddToCompare,
                                        selectedPCIdsToCompare: selectedPCIdsToCompare,
                                        showCosts: userSettings?.isOperatorUser() && (userSettings?.generalSettings?.show_cost_price ?? false)
                                    }, `${compound.id}-${idx}`))
                            })
                        }),
                        totalPages > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b38f3f5e0e7c2086$export$2e2bcd8739ae039), {
                            currentPage: searchParams?.page || 1,
                            totalPages: totalPages,
                            onPageChange: handlePageChange
                        })
                    ]
                }),
                selectedPCIdsToCompare.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).div, {
                    className: "relative inline-block",
                    onMouseEnter: ()=>setShowCompare(true),
                    onMouseLeave: ()=>setShowCompare(false),
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).button, {
                            whileHover: {
                                scale: 1.1
                            },
                            whileTap: {
                                scale: 0.9
                            },
                            className: `fixed bottom-4 right-4 text-white font-bold py-3 px-5 rounded-full shadow z-50 flex items-center gap-2 ${selectedPCIdsToCompare.length > 1 ? " bg-blue-500 hover:bg-blue-700" : "bg-gray-500 cursor-not-allowed"}`,
                            onClick: toggleCompareModal,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0811c1891b547863$export$2e2bcd8739ae039), {
                                    className: "w-5 h-5"
                                }),
                                "Comparar PCs (",
                                selectedPCIdsToCompare.length,
                                ")"
                            ]
                        }),
                        showCompare && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).button, {
                            initial: {
                                x: 100,
                                opacity: 0
                            },
                            animate: {
                                x: 0,
                                opacity: 1
                            },
                            exit: {
                                x: 100,
                                opacity: 0
                            },
                            transition: {
                                type: "spring",
                                stiffness: 300,
                                damping: 30
                            },
                            className: "fixed bottom-4 right-41 bg-red-500 hover:bg-red-700 text-white py-3 pl-3 pr-20 rounded-full shadow z-25 flex items-center gap-2",
                            onClick: ()=>{
                                handleAddToCompare(null);
                                setShowCompare(false);
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1eaa8953d6f809f8$export$2e2bcd8739ae039), {
                                className: "w-5 h-5"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $26f70be055e85cab$export$2e2bcd8739ae039 = $26f70be055e85cab$var$ListPage;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $53d93132fb4ab0c7$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
            key: "1rqfz7"
        }
    ],
    [
        "path",
        {
            d: "M14 2v4a2 2 0 0 0 2 2h4",
            key: "tnqrlb"
        }
    ]
];
const $53d93132fb4ab0c7$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("file", $53d93132fb4ab0c7$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $ce43cf1e11212652$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 13v8",
            key: "1l5pq0"
        }
    ],
    [
        "path",
        {
            d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242",
            key: "1pljnt"
        }
    ],
    [
        "path",
        {
            d: "m8 17 4-4 4 4",
            key: "1quai1"
        }
    ]
];
const $ce43cf1e11212652$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("cloud-upload", $ce43cf1e11212652$export$3efd853dbb351e94);




var $ayMG0 = parcelRequire("ayMG0");
// Helper Functions
// @ts-ignore
const $1cec967d8d56bb4d$export$283944746fe73a85 = (pcData)=>{
    if (pcData.price.resell) return pcData.price.resell;
    return pcData.price.without_vat;
};
/**
 * Base reseller purchase price for the active campaign, when Niposom funds
 * (part of) the discount. Falls back to the configured reseller price.
 * Optional components are NOT discounted — only this base is.
 */ const $1cec967d8d56bb4d$export$114200318393bfc2 = (pcData)=>{
    const promo = pcData.price.promotional_reseller_price;
    return promo != null && promo > 0 ? promo : $1cec967d8d56bb4d$export$283944746fe73a85(pcData);
};
const $1cec967d8d56bb4d$var$sumSelectedComponentDeltas = (pcData)=>Object.values(pcData.selected_components || {}).reduce((acc, component)=>acc + (component?.cost || 0), 0);
const $1cec967d8d56bb4d$export$5aa74e344e478425 = (pcData)=>{
    const promo = pcData.price.promotional_pvp_with_vat;
    return promo != null && promo > 0 ? promo : pcData.price.value;
};
const $1cec967d8d56bb4d$export$2274474197183b21 = (pcData)=>$1cec967d8d56bb4d$var$sumSelectedComponentDeltas(pcData) + $1cec967d8d56bb4d$export$114200318393bfc2(pcData);
/** Pre-campaign reseller price of the current configuration (for strikethrough). */ const $1cec967d8d56bb4d$export$118cceac05e63f57 = (pcData)=>$1cec967d8d56bb4d$var$sumSelectedComponentDeltas(pcData) + $1cec967d8d56bb4d$export$283944746fe73a85(pcData);
const $1cec967d8d56bb4d$var$hasCustomizationComponents = (pcData)=>{
    return Object.values(pcData.selected_components || {}).some((component)=>component && component.cost > 0);
};
const $1cec967d8d56bb4d$export$26dee7c5dd7408fb = (number, significance)=>{
    if (significance <= 0) throw new Error("Significance must be greater than zero");
    return Math.floor(number / significance) * significance;
};
const $1cec967d8d56bb4d$var$getResellerLevelMargin = (pcData)=>pcData.price.margin || 0;
const $1cec967d8d56bb4d$export$fa8f633eee111545 = (pcData)=>{
    // Campaign-aware: the reseller's margin is derived from the promotional PVP
    // and the promotional (Niposom-funded) reseller price.
    const resellerPrice = $1cec967d8d56bb4d$export$114200318393bfc2(pcData);
    const pvpPrice = $1cec967d8d56bb4d$export$5aa74e344e478425(pcData);
    return pvpPrice / (1 + pcData.price.vat_rate) - resellerPrice;
};
const $1cec967d8d56bb4d$export$d0fa95c6a6348eca = (pcData)=>{
    const grossMargin = $1cec967d8d56bb4d$export$fa8f633eee111545(pcData);
    const resellerPrice = $1cec967d8d56bb4d$export$114200318393bfc2(pcData);
    if (!(resellerPrice > 0)) return 0;
    return grossMargin / resellerPrice;
};
const $1cec967d8d56bb4d$var$calculatePVPPriceUsingMargin = (resellerPrice, marginPercentage, vat_rate)=>{
    return $1cec967d8d56bb4d$export$63ad841d70774900(resellerPrice * (1 + marginPercentage / 100) * (1 + vat_rate));
};
const $1cec967d8d56bb4d$export$8c4251099de346b0 = (pcData, marginPercentage)=>{
    const promoPvp = pcData.price.promotional_pvp_with_vat;
    const promoResell = pcData.price.promotional_reseller_price;
    // Campaign prices are not on the catalog's 5€ grid, so re-flooring snaps the
    // PVP to the wrong price. Scale the promo PVP proportionally to the margin
    // change instead: at the campaign margin this reproduces the promo PVP exactly.
    if (promoPvp != null && promoPvp > 0) {
        const initialMargin = $1cec967d8d56bb4d$export$d0fa95c6a6348eca(pcData) * 100;
        if (1 + initialMargin / 100 > 0) return $1cec967d8d56bb4d$export$63ad841d70774900(promoPvp * (1 + marginPercentage / 100) / (1 + initialMargin / 100));
        if (promoResell != null && promoResell > 0) return $1cec967d8d56bb4d$export$63ad841d70774900(promoResell * (1 + marginPercentage / 100) * (1 + pcData.price.vat_rate));
    }
    const value = $1cec967d8d56bb4d$export$26dee7c5dd7408fb($1cec967d8d56bb4d$var$calculatePVPPriceUsingMargin($1cec967d8d56bb4d$export$114200318393bfc2(pcData), marginPercentage, pcData.price.vat_rate) + 1, 5) - 1;
    return value;
};
const $1cec967d8d56bb4d$export$fbe39f73a557d98d = (pcData, marginPercentage)=>{
    if (marginPercentage === null) // If marginPercentage is null, return the current configuration reseller price because it's the default pvp price
    return $1cec967d8d56bb4d$export$f728be4ab20cbf1f($1cec967d8d56bb4d$export$2274474197183b21(pcData));
    else return $1cec967d8d56bb4d$export$f728be4ab20cbf1f($1cec967d8d56bb4d$var$calculatePVPPriceUsingMargin($1cec967d8d56bb4d$export$2274474197183b21(pcData), marginPercentage, pcData.price.vat_rate));
};
const $1cec967d8d56bb4d$export$860e5d4374a91701 = (pcData, marginPercentage)=>{
    const pvpPrice = $1cec967d8d56bb4d$export$fbe39f73a557d98d(pcData, marginPercentage);
    const resellerPrice = $1cec967d8d56bb4d$export$2274474197183b21(pcData);
    return $1cec967d8d56bb4d$export$63ad841d70774900(pvpPrice / (1 + pcData.price.vat_rate) - resellerPrice);
};
const $1cec967d8d56bb4d$var$calculateNewMarginPercentage = (resellerPrice, newPVP, vat_rate)=>{
    const margin = newPVP / (1 + vat_rate) - resellerPrice;
    return $1cec967d8d56bb4d$export$c37640da124effef(margin / resellerPrice);
};
const $1cec967d8d56bb4d$export$54f7b4b156bb5661 = (pcData, newPVP)=>$1cec967d8d56bb4d$var$calculateNewMarginPercentage($1cec967d8d56bb4d$export$114200318393bfc2(pcData), newPVP, pcData.price.vat_rate);
const $1cec967d8d56bb4d$export$55530814c1a6ecfc = (pcData, newPVP)=>$1cec967d8d56bb4d$var$calculateNewMarginPercentage($1cec967d8d56bb4d$export$2274474197183b21(pcData), newPVP, pcData.price.vat_rate);
/** Converts a decimal ratio (0..1) to a percentage display value (0..100).
 *  If the value is already a percentage, display it directly without calling this. */ const $1cec967d8d56bb4d$export$c37640da124effef = (value)=>Math.round(value * 10000) / 100;
const $1cec967d8d56bb4d$export$63ad841d70774900 = (value)=>Math.round(value * 100) / 100;
const $1cec967d8d56bb4d$export$f728be4ab20cbf1f = (value)=>Math.round(value);
/**
 * Returns the reseller-side price (no VAT) of a PCComponent, falling back
 * across the available Price fields in the same priority order used by
 * getBaseResellerPrice. Returns 0 when the input is undefined.
 *
 * This is the unit that getCurrentConfigurationResellerPrice expects when
 * summing component deltas — keeping units consistent is essential.
 */ /**
 * Computes the reseller-no-VAT delta of `selected` against the group base.
 *
 * The backend's `adjustComponentPricesUsingBaseComponentAsReference` already
 * delta-encodes `price.value` (configuredCompoundResellerPrice) against the
 * group's base component — the base is 0, an upgrade carries a positive delta,
 * a cheaper option a negative one, and quantity is already factored in. So the
 * reseller cost delta is simply `selected.price.value`.
 *
 * `price.resell` (rev3) is the undiscounted per-unit reseller list price and
 * must NOT be used here: the base cost `getBaseResellerPrice` is itself the
 * compound (discounted) reseller price, so summing `value` deltas keeps the
 * units consistent (regression: a GT730 whose rev3 is 54.90 but compound price
 * is 48.37 was shown as +54.90 instead of +48.37).
 *
 * Used by CompoundDetailPage.handleChangeComponent to populate
 * selected_components[type].cost in the same unit that
 * getCurrentConfigurationResellerPrice consumes.
 */ const $1cec967d8d56bb4d$export$a2cc5fc5ea7ea67b = (_componentsForType, selected)=>{
    if (!selected) return 0;
    return selected.price?.value ?? 0;
};
/**
 * Resolves the price-reference (base) option of a component group for PVP
 * delta calculations. Priority — identical to the storefront's
 * getConfigurableComponentGroups:
 *   1. the real `baseComponent` flag (base groups: processador, motherboard…)
 *   2. the synthetic `empty_option` sentinel at €0 (peripheral groups:
 *      monitor, teclado, rato… meaning "nothing chosen yet")
 *   3. the first option as a last resort.
 *
 * Note: the intranet mutates `selected` onto the user's chosen option in
 * CompoundDetailPage.handleChangeComponent, so `find(c => c.selected)` must
 * NOT be used here (it would resolve to the selection, not the base).
 */ const $1cec967d8d56bb4d$var$getComponentGroupBase = (options)=>{
    if (!options || options.length === 0) return undefined;
    return options.find((c)=>c.baseComponent) ?? options.find((c)=>c.id === "empty_option") ?? options[0];
};
/**
 * Customer-facing PVP upgrade delta for the current configuration, computed
 * from the catalog `pvp_with_vat` field exactly like the eurosys storefront
 * (lib/storefront/compound.ts → calculateConfiguredPrice):
 *
 *   delta = Σ_groups ( selected.pvp_with_vat − base.pvp_with_vat )
 *
 * Component `pvp_with_vat` is delta-encoded against the group base (base = 0),
 * so an upgrade adds its positive delta and a cheaper option subtracts. The
 * delta is intentionally NOT scaled by the reseller margin slider nor by
 * quantity — only the base compound price reacts to margin, mirroring the
 * storefront where upgrades are added at their full PVP delta on top of the
 * (possibly promotional) base price.
 *
 * Iterates `selected_components` (the intranet's source of truth for what the
 * user picked); types absent from it resolve to base → 0 contribution.
 * Returns a raw (unrounded) number so the displayed/stored value matches the
 * storefront to full precision; formatting rounds at the presentation layer.
 */ const $1cec967d8d56bb4d$export$89ef2f2a3b3c42de = (pcData)=>{
    return Object.entries(pcData.selected_components || {}).reduce((delta, [type, entry])=>{
        if (!entry?.id) return delta;
        const options = pcData.components?.[type];
        const selected = options?.find((c)=>c.id === entry.id);
        if (!selected) return delta;
        const base = $1cec967d8d56bb4d$var$getComponentGroupBase(options);
        const selectedPVP = selected.price?.pvp_with_vat ?? 0;
        const basePVP = base?.price?.pvp_with_vat ?? 0;
        return delta + (selectedPVP - basePVP);
    }, 0);
};



/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e3f86240925e7a9e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21.801 10A10 10 0 1 1 17 3.335",
            key: "yps3ct"
        }
    ],
    [
        "path",
        {
            d: "m9 11 3 3L22 4",
            key: "1pflzl"
        }
    ]
];
const $e3f86240925e7a9e$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("circle-check-big", $e3f86240925e7a9e$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $737c279b45d43939$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7",
            key: "1m0v6g"
        }
    ],
    [
        "path",
        {
            d: "M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z",
            key: "ohrbg2"
        }
    ]
];
const $737c279b45d43939$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("square-pen", $737c279b45d43939$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $9a9bbf84fd0f8247$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M15 12h-5",
            key: "r7krc0"
        }
    ],
    [
        "path",
        {
            d: "M15 8h-5",
            key: "1khuty"
        }
    ],
    [
        "path",
        {
            d: "M19 17V5a2 2 0 0 0-2-2H4",
            key: "zz82l3"
        }
    ],
    [
        "path",
        {
            d: "M8 21h12a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v1a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v2a1 1 0 0 0 1 1h3",
            key: "1ph1d7"
        }
    ]
];
const $9a9bbf84fd0f8247$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("scroll-text", $9a9bbf84fd0f8247$export$3efd853dbb351e94);



var $acw62 = parcelRequire("acw62");
var $808944a671b11c1c$exports = {};
/**
 * @mui/x-data-grid v8.22.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
Object.defineProperty($808944a671b11c1c$exports, "__esModule", {
    value: true
});
var $808944a671b11c1c$var$_exportNames = {
    useGridApiContext: true,
    useGridApiRef: true,
    useGridRootProps: true,
    GridColumnHeaders: true,
    GridColumnMenu: true,
    GRID_COLUMN_MENU_SLOTS: true,
    GRID_COLUMN_MENU_SLOT_PROPS: true
};
Object.defineProperty($808944a671b11c1c$exports, "GRID_COLUMN_MENU_SLOTS", {
    enumerable: true,
    get: function() {
        return $3703708d962d2564$exports.GRID_COLUMN_MENU_SLOTS;
    }
});
Object.defineProperty($808944a671b11c1c$exports, "GRID_COLUMN_MENU_SLOT_PROPS", {
    enumerable: true,
    get: function() {
        return $3703708d962d2564$exports.GRID_COLUMN_MENU_SLOT_PROPS;
    }
});
Object.defineProperty($808944a671b11c1c$exports, "GridColumnHeaders", {
    enumerable: true,
    get: function() {
        return $056733ac91e6ea07$exports.GridColumnHeaders;
    }
});
Object.defineProperty($808944a671b11c1c$exports, "GridColumnMenu", {
    enumerable: true,
    get: function() {
        return $3703708d962d2564$exports.GridColumnMenu;
    }
});
Object.defineProperty($808944a671b11c1c$exports, "useGridApiContext", {
    enumerable: true,
    get: function() {
        return $bDyDY.useGridApiContext;
    }
});
Object.defineProperty($808944a671b11c1c$exports, "useGridApiRef", {
    enumerable: true,
    get: function() {
        return $0d0b75328ed00f71$exports.useGridApiRef;
    }
});
Object.defineProperty($808944a671b11c1c$exports, "useGridRootProps", {
    enumerable: true,
    get: function() {
        return $jDpXp.useGridRootProps;
    }
});


var $bDyDY = parcelRequire("bDyDY");
var $0d0b75328ed00f71$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $0d0b75328ed00f71$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($0d0b75328ed00f71$exports, "__esModule", {
    value: true
});
$0d0b75328ed00f71$exports.useGridApiRef = void 0;

var $0d0b75328ed00f71$var$React = $0d0b75328ed00f71$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * Hook that instantiate a [[GridApiRef]].
 */ const $0d0b75328ed00f71$var$useGridApiRef = ()=>$0d0b75328ed00f71$var$React.useRef(null);
$0d0b75328ed00f71$exports.useGridApiRef = $0d0b75328ed00f71$var$useGridApiRef;



var $jDpXp = parcelRequire("jDpXp");
var $3d7c0613ecc5fc3b$exports = {};
"use strict";
Object.defineProperty($3d7c0613ecc5fc3b$exports, "__esModule", {
    value: true
});

var $141bce2f2738cba8$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $141bce2f2738cba8$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $141bce2f2738cba8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($141bce2f2738cba8$exports, "__esModule", {
    value: true
});
$141bce2f2738cba8$exports.DataGrid = void 0;

var $141bce2f2738cba8$var$_extends2 = $141bce2f2738cba8$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $141bce2f2738cba8$var$React = $141bce2f2738cba8$require$_interopRequireWildcard((parcelRequire("acw62")));

var $141bce2f2738cba8$var$_propTypes = $141bce2f2738cba8$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $fYxgT = parcelRequire("fYxgT");
var $08eee520e810d520$exports = {};
"use strict";
Object.defineProperty($08eee520e810d520$exports, "__esModule", {
    value: true
});
var $08eee520e810d520$var$_exportNames = {
    GridPagination: true
};
Object.defineProperty($08eee520e810d520$exports, "GridPagination", {
    enumerable: true,
    get: function() {
        return $b46e33860b6061fb$exports.GridPagination;
    }
});
var $ecac20e02127a1f6$exports = {};
"use strict";
Object.defineProperty($ecac20e02127a1f6$exports, "__esModule", {
    value: true
});
var $f1c85321eab9b516$exports = {};
"use strict";
Object.defineProperty($f1c85321eab9b516$exports, "__esModule", {
    value: true
});
Object.defineProperty($f1c85321eab9b516$exports, "GridBody", {
    enumerable: true,
    get: function() {
        return $0e5dd7e9e576a614$exports.GridVirtualScroller;
    }
});
var $0e5dd7e9e576a614$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $0e5dd7e9e576a614$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $0e5dd7e9e576a614$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($0e5dd7e9e576a614$exports, "__esModule", {
    value: true
});
$0e5dd7e9e576a614$exports.GridVirtualScroller = $0e5dd7e9e576a614$var$GridVirtualScroller;

var $0e5dd7e9e576a614$var$_extends2 = $0e5dd7e9e576a614$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $0e5dd7e9e576a614$var$React = $0e5dd7e9e576a614$require$_interopRequireWildcard((parcelRequire("acw62")));

var $izOUK = parcelRequire("izOUK");

var $0e5dd7e9e576a614$var$_composeClasses = $0e5dd7e9e576a614$require$_interopRequireDefault((parcelRequire("3Hg1x")));
var $46349fe7fabb2b4d$exports = {};
"use strict";
Object.defineProperty($46349fe7fabb2b4d$exports, "__esModule", {
    value: true
});
$46349fe7fabb2b4d$exports.gridVerticalScrollbarWidthSelector = $46349fe7fabb2b4d$exports.gridRowHeightSelector = $46349fe7fabb2b4d$exports.gridHorizontalScrollbarHeightSelector = $46349fe7fabb2b4d$exports.gridHeaderHeightSelector = $46349fe7fabb2b4d$exports.gridHeaderFilterHeightSelector = $46349fe7fabb2b4d$exports.gridHasScrollYSelector = $46349fe7fabb2b4d$exports.gridHasScrollXSelector = $46349fe7fabb2b4d$exports.gridHasFillerSelector = $46349fe7fabb2b4d$exports.gridHasBottomFillerSelector = $46349fe7fabb2b4d$exports.gridGroupHeaderHeightSelector = $46349fe7fabb2b4d$exports.gridDimensionsSelector = $46349fe7fabb2b4d$exports.gridContentHeightSelector = $46349fe7fabb2b4d$exports.gridColumnsTotalWidthSelector = void 0;
var $8eef5f2af445e503$exports = {};
"use strict";
Object.defineProperty($8eef5f2af445e503$exports, "__esModule", {
    value: true
});
$8eef5f2af445e503$exports.createSelectorMemoized = $8eef5f2af445e503$exports.createSelector = $8eef5f2af445e503$exports.createRootSelector = void 0;
var $66c3b1bd8ca83ba8$exports = {};
"use strict";
Object.defineProperty($66c3b1bd8ca83ba8$exports, "__esModule", {
    value: true
});
var $b3919923ab8efcb8$exports = {};
"use strict";
Object.defineProperty($b3919923ab8efcb8$exports, "__esModule", {
    value: true
});
$b3919923ab8efcb8$exports.createSelectorMemoizedWithOptions = $b3919923ab8efcb8$exports.createSelectorMemoized = $b3919923ab8efcb8$exports.createSelector = void 0;
var $375276bea32f9eda$var$__defProp = Object.defineProperty;
var $375276bea32f9eda$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $375276bea32f9eda$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $375276bea32f9eda$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $375276bea32f9eda$var$__defNormalProp = (obj, key, value)=>key in obj ? $375276bea32f9eda$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $375276bea32f9eda$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($375276bea32f9eda$var$__hasOwnProp.call(b, prop)) $375276bea32f9eda$var$__defNormalProp(a, prop, b[prop]);
    if ($375276bea32f9eda$var$__getOwnPropSymbols) {
        for (var prop of $375276bea32f9eda$var$__getOwnPropSymbols(b))if ($375276bea32f9eda$var$__propIsEnum.call(b, prop)) $375276bea32f9eda$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $375276bea32f9eda$var$__publicField = (obj, key, value)=>{
    $375276bea32f9eda$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $375276bea32f9eda$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $375276bea32f9eda$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $375276bea32f9eda$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $375276bea32f9eda$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($375276bea32f9eda$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $375276bea32f9eda$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $375276bea32f9eda$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $375276bea32f9eda$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $375276bea32f9eda$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $375276bea32f9eda$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $375276bea32f9eda$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $375276bea32f9eda$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $375276bea32f9eda$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $375276bea32f9eda$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = $375276bea32f9eda$var$__spreadValues($375276bea32f9eda$var$__spreadValues({}, $375276bea32f9eda$var$globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $375276bea32f9eda$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $375276bea32f9eda$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $375276bea32f9eda$var$$REVISION = 0;
var $375276bea32f9eda$var$CURRENT_TRACKER = null;
var $375276bea32f9eda$var$Cell = class {
    constructor(initialValue, isEqual = $375276bea32f9eda$var$tripleEq){
        $375276bea32f9eda$var$__publicField(this, "revision", $375276bea32f9eda$var$$REVISION);
        $375276bea32f9eda$var$__publicField(this, "_value");
        $375276bea32f9eda$var$__publicField(this, "_lastValue");
        $375276bea32f9eda$var$__publicField(this, "_isEqual", $375276bea32f9eda$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $375276bea32f9eda$var$CURRENT_TRACKER == null || $375276bea32f9eda$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$375276bea32f9eda$var$$REVISION;
    }
};
function $375276bea32f9eda$var$tripleEq(a, b) {
    return a === b;
}
var $375276bea32f9eda$var$TrackingCache = class {
    constructor(fn){
        $375276bea32f9eda$var$__publicField(this, "_cachedValue");
        $375276bea32f9eda$var$__publicField(this, "_cachedRevision", -1);
        $375276bea32f9eda$var$__publicField(this, "_deps", []);
        $375276bea32f9eda$var$__publicField(this, "hits", 0);
        $375276bea32f9eda$var$__publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $375276bea32f9eda$var$CURRENT_TRACKER;
            $375276bea32f9eda$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $375276bea32f9eda$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $375276bea32f9eda$var$CURRENT_TRACKER == null || $375276bea32f9eda$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $375276bea32f9eda$var$getValue(cell) {
    if (!(cell instanceof $375276bea32f9eda$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $375276bea32f9eda$var$setValue(storage, value) {
    if (!(storage instanceof $375276bea32f9eda$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $375276bea32f9eda$var$createCell(initialValue, isEqual = $375276bea32f9eda$var$tripleEq) {
    return new $375276bea32f9eda$var$Cell(initialValue, isEqual);
}
function $375276bea32f9eda$var$createCache(fn) {
    $375276bea32f9eda$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $375276bea32f9eda$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $375276bea32f9eda$var$neverEq = (a, b)=>false;
function $375276bea32f9eda$var$createTag() {
    return $375276bea32f9eda$var$createCell(null, $375276bea32f9eda$var$neverEq);
}
function $375276bea32f9eda$var$dirtyTag(tag, value) {
    $375276bea32f9eda$var$setValue(tag, value);
}
var $375276bea32f9eda$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $375276bea32f9eda$var$createTag();
    $375276bea32f9eda$var$getValue(tag);
};
var $375276bea32f9eda$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $375276bea32f9eda$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $375276bea32f9eda$var$REDUX_PROXY_LABEL = Symbol();
var $375276bea32f9eda$var$nextId = 0;
var $375276bea32f9eda$var$proto = Object.getPrototypeOf({});
var $375276bea32f9eda$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        $375276bea32f9eda$var$__publicField(this, "proxy", new Proxy(this, $375276bea32f9eda$var$objectProxyHandler));
        $375276bea32f9eda$var$__publicField(this, "tag", $375276bea32f9eda$var$createTag());
        $375276bea32f9eda$var$__publicField(this, "tags", {});
        $375276bea32f9eda$var$__publicField(this, "children", {});
        $375276bea32f9eda$var$__publicField(this, "collectionTag", null);
        $375276bea32f9eda$var$__publicField(this, "id", $375276bea32f9eda$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $375276bea32f9eda$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $375276bea32f9eda$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $375276bea32f9eda$var$createNode(childValue);
                if (childNode.tag) $375276bea32f9eda$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $375276bea32f9eda$var$createTag();
                    tag.value = childValue;
                }
                $375276bea32f9eda$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $375276bea32f9eda$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $375276bea32f9eda$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        $375276bea32f9eda$var$__publicField(this, "proxy", new Proxy([
            this
        ], $375276bea32f9eda$var$arrayProxyHandler));
        $375276bea32f9eda$var$__publicField(this, "tag", $375276bea32f9eda$var$createTag());
        $375276bea32f9eda$var$__publicField(this, "tags", {});
        $375276bea32f9eda$var$__publicField(this, "children", {});
        $375276bea32f9eda$var$__publicField(this, "collectionTag", null);
        $375276bea32f9eda$var$__publicField(this, "id", $375276bea32f9eda$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $375276bea32f9eda$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $375276bea32f9eda$var$consumeCollection(node);
        return $375276bea32f9eda$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $375276bea32f9eda$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $375276bea32f9eda$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $375276bea32f9eda$var$objectProxyHandler.has(node, prop);
    }
};
function $375276bea32f9eda$var$createNode(value) {
    if (Array.isArray(value)) return new $375276bea32f9eda$var$ArrayTreeNode(value);
    return new $375276bea32f9eda$var$ObjectTreeNode(value);
}
function $375276bea32f9eda$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $375276bea32f9eda$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $375276bea32f9eda$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $375276bea32f9eda$var$dirtyCollection(node);
            $375276bea32f9eda$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $375276bea32f9eda$var$updateNode(childNode, newChildValue);
        else {
            $375276bea32f9eda$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $375276bea32f9eda$var$deleteNode(node) {
    if (node.tag) $375276bea32f9eda$var$dirtyTag(node.tag, null);
    $375276bea32f9eda$var$dirtyCollection(node);
    for(const key in node.tags)$375276bea32f9eda$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$375276bea32f9eda$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $375276bea32f9eda$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $375276bea32f9eda$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $375276bea32f9eda$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $375276bea32f9eda$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $375276bea32f9eda$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $375276bea32f9eda$export$3f025202a230c6dd = (a, b)=>a === b;
function $375276bea32f9eda$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $375276bea32f9eda$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $375276bea32f9eda$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $375276bea32f9eda$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $375276bea32f9eda$var$createSingletonCache(comparator) : $375276bea32f9eda$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $375276bea32f9eda$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $375276bea32f9eda$export$c8f9cf88d9fdee55(func) {
    const node = $375276bea32f9eda$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $375276bea32f9eda$var$createCacheKeyComparator($375276bea32f9eda$export$3f025202a230c6dd);
    const cache = $375276bea32f9eda$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $375276bea32f9eda$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $375276bea32f9eda$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $375276bea32f9eda$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $375276bea32f9eda$var$StrongRef;
var $375276bea32f9eda$var$UNTERMINATED = 0;
var $375276bea32f9eda$var$TERMINATED = 1;
function $375276bea32f9eda$var$createCacheNode() {
    return {
        s: $375276bea32f9eda$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $375276bea32f9eda$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $375276bea32f9eda$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a, _b;
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $375276bea32f9eda$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $375276bea32f9eda$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $375276bea32f9eda$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new $375276bea32f9eda$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $375276bea32f9eda$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $375276bea32f9eda$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $375276bea32f9eda$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $375276bea32f9eda$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $375276bea32f9eda$var$__spreadValues($375276bea32f9eda$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $375276bea32f9eda$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $375276bea32f9eda$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $375276bea32f9eda$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $375276bea32f9eda$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $375276bea32f9eda$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            {
                const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = $375276bea32f9eda$var$getDevModeChecksExecutionInfo(firstRun, devModeChecks);
                if (identityFunctionCheck.shouldRun) identityFunctionCheck.run(resultFunc, inputSelectorResults, lastResult);
                if (inputStabilityCheck.shouldRun) {
                    const inputSelectorResultsCopy = $375276bea32f9eda$var$collectInputSelectorResults(dependencies, arguments);
                    inputStabilityCheck.run({
                        inputSelectorResults: inputSelectorResults,
                        inputSelectorResultsCopy: inputSelectorResultsCopy
                    }, {
                        memoize: memoize,
                        memoizeOptions: finalMemoizeOptions
                    }, arguments);
                }
                if (firstRun) firstRun = false;
            }
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $375276bea32f9eda$export$595d22ed68ca2841 = /* @__PURE__ */ $375276bea32f9eda$export$5943f4447f6ef248($375276bea32f9eda$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $375276bea32f9eda$export$75979cfcd91bf38f = Object.assign((inputSelectorsObject, selectorCreator = $375276bea32f9eda$export$595d22ed68ca2841)=>{
    $375276bea32f9eda$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$375276bea32f9eda$export$75979cfcd91bf38f
});


/* eslint-disable no-underscore-dangle */ // __cacheKey__
const $b3919923ab8efcb8$var$reselectCreateSelector = (0, $375276bea32f9eda$export$5943f4447f6ef248)({
    memoize: $375276bea32f9eda$export$d8ead1d92249919b,
    memoizeOptions: {
        maxSize: 1,
        equalityCheck: Object.is
    }
});
/* eslint-disable id-denylist */ const $b3919923ab8efcb8$var$createSelector = (a, b, c, d, e, f, g, h, ...other)=>{
    if (other.length > 0) throw new Error('Unsupported number of selectors');
    let selector;
    if (a && b && c && d && e && f && g && h) selector = (state, a1, a2, a3)=>{
        const va = a(state, a1, a2, a3);
        const vb = b(state, a1, a2, a3);
        const vc = c(state, a1, a2, a3);
        const vd = d(state, a1, a2, a3);
        const ve = e(state, a1, a2, a3);
        const vf = f(state, a1, a2, a3);
        const vg = g(state, a1, a2, a3);
        return h(va, vb, vc, vd, ve, vf, vg, a1, a2, a3);
    };
    else if (a && b && c && d && e && f && g) selector = (state, a1, a2, a3)=>{
        const va = a(state, a1, a2, a3);
        const vb = b(state, a1, a2, a3);
        const vc = c(state, a1, a2, a3);
        const vd = d(state, a1, a2, a3);
        const ve = e(state, a1, a2, a3);
        const vf = f(state, a1, a2, a3);
        return g(va, vb, vc, vd, ve, vf, a1, a2, a3);
    };
    else if (a && b && c && d && e && f) selector = (state, a1, a2, a3)=>{
        const va = a(state, a1, a2, a3);
        const vb = b(state, a1, a2, a3);
        const vc = c(state, a1, a2, a3);
        const vd = d(state, a1, a2, a3);
        const ve = e(state, a1, a2, a3);
        return f(va, vb, vc, vd, ve, a1, a2, a3);
    };
    else if (a && b && c && d && e) selector = (state, a1, a2, a3)=>{
        const va = a(state, a1, a2, a3);
        const vb = b(state, a1, a2, a3);
        const vc = c(state, a1, a2, a3);
        const vd = d(state, a1, a2, a3);
        return e(va, vb, vc, vd, a1, a2, a3);
    };
    else if (a && b && c && d) selector = (state, a1, a2, a3)=>{
        const va = a(state, a1, a2, a3);
        const vb = b(state, a1, a2, a3);
        const vc = c(state, a1, a2, a3);
        return d(va, vb, vc, a1, a2, a3);
    };
    else if (a && b && c) selector = (state, a1, a2, a3)=>{
        const va = a(state, a1, a2, a3);
        const vb = b(state, a1, a2, a3);
        return c(va, vb, a1, a2, a3);
    };
    else if (a && b) selector = (state, a1, a2, a3)=>{
        const va = a(state, a1, a2, a3);
        return b(va, a1, a2, a3);
    };
    else if (a) selector = a;
    else throw new Error('Missing arguments');
    return selector;
};
/* eslint-enable id-denylist */ $b3919923ab8efcb8$exports.createSelector = $b3919923ab8efcb8$var$createSelector;
const $b3919923ab8efcb8$var$createSelectorMemoizedWithOptions = (options)=>(...inputs)=>{
        const cache = new WeakMap();
        let nextCacheId = 1;
        const combiner = inputs[inputs.length - 1];
        const nSelectors = inputs.length - 1 || 1;
        // (s1, s2, ..., sN, a1, a2, a3) => { ... }
        const argsLength = Math.max(combiner.length - nSelectors, 0);
        if (argsLength > 3) throw new Error('Unsupported number of arguments');
        // prettier-ignore
        const selector = (state, a1, a2, a3)=>{
            let cacheKey = state.__cacheKey__;
            if (!cacheKey) {
                cacheKey = {
                    id: nextCacheId
                };
                state.__cacheKey__ = cacheKey;
                nextCacheId += 1;
            }
            let fn = cache.get(cacheKey);
            if (!fn) {
                const selectors = inputs.length === 1 ? [
                    (x)=>x,
                    combiner
                ] : inputs;
                let reselectArgs = inputs;
                const selectorArgs = [
                    undefined,
                    undefined,
                    undefined
                ];
                switch(argsLength){
                    case 0:
                        break;
                    case 1:
                        reselectArgs = [
                            ...selectors.slice(0, -1),
                            ()=>selectorArgs[0],
                            combiner
                        ];
                        break;
                    case 2:
                        reselectArgs = [
                            ...selectors.slice(0, -1),
                            ()=>selectorArgs[0],
                            ()=>selectorArgs[1],
                            combiner
                        ];
                        break;
                    case 3:
                        reselectArgs = [
                            ...selectors.slice(0, -1),
                            ()=>selectorArgs[0],
                            ()=>selectorArgs[1],
                            ()=>selectorArgs[2],
                            combiner
                        ];
                        break;
                    default:
                        throw new Error('Unsupported number of arguments');
                }
                if (options) reselectArgs = [
                    ...reselectArgs,
                    options
                ];
                fn = $b3919923ab8efcb8$var$reselectCreateSelector(...reselectArgs);
                fn.selectorArgs = selectorArgs;
                cache.set(cacheKey, fn);
            }
            /* eslint-disable no-fallthrough */ switch(argsLength){
                case 3:
                    fn.selectorArgs[2] = a3;
                case 2:
                    fn.selectorArgs[1] = a2;
                case 1:
                    fn.selectorArgs[0] = a1;
                case 0:
                default:
            }
            switch(argsLength){
                case 0:
                    return fn(state);
                case 1:
                    return fn(state, a1);
                case 2:
                    return fn(state, a1, a2);
                case 3:
                    return fn(state, a1, a2, a3);
                default:
                    throw new Error('unreachable');
            }
        };
        return selector;
    };
$b3919923ab8efcb8$exports.createSelectorMemoizedWithOptions = $b3919923ab8efcb8$var$createSelectorMemoizedWithOptions;
const $b3919923ab8efcb8$var$createSelectorMemoized = $b3919923ab8efcb8$exports.createSelectorMemoized = $b3919923ab8efcb8$var$createSelectorMemoizedWithOptions();


Object.keys($b3919923ab8efcb8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $66c3b1bd8ca83ba8$exports && $66c3b1bd8ca83ba8$exports[key] === $b3919923ab8efcb8$exports[key]) return;
    Object.defineProperty($66c3b1bd8ca83ba8$exports, key, {
        enumerable: true,
        get: function() {
            return $b3919923ab8efcb8$exports[key];
        }
    });
});
var $b962400ee8aa786f$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $b962400ee8aa786f$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $b962400ee8aa786f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($b962400ee8aa786f$exports, "__esModule", {
    value: true
});
$b962400ee8aa786f$exports.useStore = $b962400ee8aa786f$var$useStore;

var $b962400ee8aa786f$var$React = $b962400ee8aa786f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $hfliI = parcelRequire("hfliI");
var $6ae5e5baff12bbf7$exports = {};
'use strict';

$6ae5e5baff12bbf7$exports = (parcelRequire("jZ8n5"));



var $b962400ee8aa786f$var$_reactMajor = $b962400ee8aa786f$require$_interopRequireDefault((parcelRequire("eKs5z")));
/* We need to import the shim because React 17 does not support the `useSyncExternalStore` API.
 * More info: https://github.com/mui/mui-x/issues/18303#issuecomment-2958392341 */ /* Some tests fail in R18 with the raw useSyncExternalStore. It may be possible to make it work
 * but for now we only enable it for R19+. */ const $b962400ee8aa786f$var$canUseRawUseSyncExternalStore = $b962400ee8aa786f$var$_reactMajor.default >= 19;
const $b962400ee8aa786f$var$useStoreImplementation = $b962400ee8aa786f$var$canUseRawUseSyncExternalStore ? $b962400ee8aa786f$var$useStoreR19 : $b962400ee8aa786f$var$useStoreLegacy;
function $b962400ee8aa786f$var$useStore(store, selector, a1, a2, a3) {
    return $b962400ee8aa786f$var$useStoreImplementation(store, selector, a1, a2, a3);
}
function $b962400ee8aa786f$var$useStoreR19(store, selector, a1, a2, a3) {
    const getSelection = $b962400ee8aa786f$var$React.useCallback(()=>selector(store.getSnapshot(), a1, a2, a3), [
        store,
        selector,
        a1,
        a2,
        a3
    ]);
    return (0, $hfliI.useSyncExternalStore)(store.subscribe, getSelection, getSelection);
}
function $b962400ee8aa786f$var$useStoreLegacy(store, selector, a1, a2, a3) {
    return (0, $6ae5e5baff12bbf7$exports.useSyncExternalStoreWithSelector)(store.subscribe, store.getSnapshot, store.getSnapshot, (state)=>selector(state, a1, a2, a3));
}


Object.keys($b962400ee8aa786f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $66c3b1bd8ca83ba8$exports && $66c3b1bd8ca83ba8$exports[key] === $b962400ee8aa786f$exports[key]) return;
    Object.defineProperty($66c3b1bd8ca83ba8$exports, key, {
        enumerable: true,
        get: function() {
            return $b962400ee8aa786f$exports[key];
        }
    });
});
var $154044f791287af0$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $154044f791287af0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($154044f791287af0$exports, "__esModule", {
    value: true
});
$154044f791287af0$exports.useStoreEffect = $154044f791287af0$var$useStoreEffect;

var $154044f791287af0$var$_useLazyRef = $154044f791287af0$require$_interopRequireDefault((parcelRequire("doV3C")));

var $154044f791287af0$var$_useOnMount = $154044f791287af0$require$_interopRequireDefault((parcelRequire("fGtMU")));
const $154044f791287af0$var$noop = ()=>{};
/**
 * An Effect implementation for the Store. This should be used for side-effects only. To
 * compute and store derived state, use `createSelectorMemoized` instead.
 */ function $154044f791287af0$var$useStoreEffect(store, selector, effect) {
    const instance = (0, $154044f791287af0$var$_useLazyRef.default)($154044f791287af0$var$initialize, {
        store: store,
        selector: selector
    }).current;
    instance.effect = effect;
    (0, $154044f791287af0$var$_useOnMount.default)(instance.onMount);
}
// `useLazyRef` typings are incorrect, `params` should not be optional
function $154044f791287af0$var$initialize(params) {
    const { store: store, selector: selector } = params;
    let previousState = selector(store.state);
    const instance = {
        effect: $154044f791287af0$var$noop,
        dispose: null,
        // We want a single subscription done right away and cleared on unmount only,
        // but React triggers `useOnMount` multiple times in dev, so we need to manage
        // the subscription anyway.
        subscribe: ()=>{
            instance.dispose ?? (instance.dispose = store.subscribe((state)=>{
                const nextState = selector(state);
                if (!Object.is(previousState, nextState)) {
                    const prev = previousState;
                    previousState = nextState;
                    instance.effect(prev, nextState);
                }
            }));
        },
        onMount: ()=>{
            instance.subscribe();
            return ()=>{
                instance.dispose?.();
                instance.dispose = null;
            };
        }
    };
    instance.subscribe();
    return instance;
}


Object.keys($154044f791287af0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $66c3b1bd8ca83ba8$exports && $66c3b1bd8ca83ba8$exports[key] === $154044f791287af0$exports[key]) return;
    Object.defineProperty($66c3b1bd8ca83ba8$exports, key, {
        enumerable: true,
        get: function() {
            return $154044f791287af0$exports[key];
        }
    });
});
var $a53bff302fde4700$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a53bff302fde4700$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($a53bff302fde4700$exports, "__esModule", {
    value: true
});
$a53bff302fde4700$exports.Store = void 0;

var $a53bff302fde4700$var$_extends2 = $a53bff302fde4700$require$_interopRequireDefault((parcelRequire("3p9rK")));

/* eslint-disable no-cond-assign */ class $a53bff302fde4700$var$Store {
    // HACK: `any` fixes adding listeners that accept partial state.
    // Internal state to handle recursive `setState()` calls
    static create(state) {
        return new $a53bff302fde4700$var$Store(state);
    }
    constructor(state){
        this.state = state;
        this.listeners = new Set();
        this.updateTick = 0;
    }
    subscribe = (fn)=>{
        this.listeners.add(fn);
        return ()=>{
            this.listeners.delete(fn);
        };
    };
    /**
   * Returns the current state snapshot. Meant for usage with `useSyncExternalStore`.
   * If you want to access the state, use the `state` property instead.
   */ getSnapshot = ()=>{
        return this.state;
    };
    setState(newState) {
        this.state = newState;
        this.updateTick += 1;
        const currentTick = this.updateTick;
        const it = this.listeners.values();
        let result;
        while(result = it.next(), !result.done){
            if (currentTick !== this.updateTick) // If the tick has changed, a recursive `setState` call has been made,
            // and it has already notified all listeners.
            return;
            const listener = result.value;
            listener(newState);
        }
    }
    update(changes) {
        for(const key in changes)if (!Object.is(this.state[key], changes[key])) {
            this.setState((0, $a53bff302fde4700$var$_extends2.default)({}, this.state, changes));
            return;
        }
    }
    set(key, value) {
        if (!Object.is(this.state[key], value)) this.setState((0, $a53bff302fde4700$var$_extends2.default)({}, this.state, {
            [key]: value
        }));
    }
    use = (selector, a1, a2, a3)=>{
        return (0, $b962400ee8aa786f$exports.useStore)(this, selector, a1, a2, a3);
    };
}
$a53bff302fde4700$exports.Store = $a53bff302fde4700$var$Store;


Object.keys($a53bff302fde4700$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $66c3b1bd8ca83ba8$exports && $66c3b1bd8ca83ba8$exports[key] === $a53bff302fde4700$exports[key]) return;
    Object.defineProperty($66c3b1bd8ca83ba8$exports, key, {
        enumerable: true,
        get: function() {
            return $a53bff302fde4700$exports[key];
        }
    });
});


const $8eef5f2af445e503$var$createSelector = (...args)=>{
    const baseSelector = (0, $66c3b1bd8ca83ba8$exports.createSelector)(...args);
    const selector = (apiRef, a1, a2, a3)=>baseSelector($8eef5f2af445e503$var$unwrapIfNeeded(apiRef), a1, a2, a3);
    return selector;
};
$8eef5f2af445e503$exports.createSelector = $8eef5f2af445e503$var$createSelector;
const $8eef5f2af445e503$var$createSelectorMemoized = (...args)=>{
    const baseSelector = (0, $66c3b1bd8ca83ba8$exports.createSelectorMemoized)(...args);
    const selector = (apiRef, a1, a2, a3)=>baseSelector($8eef5f2af445e503$var$unwrapIfNeeded(apiRef), a1, a2, a3);
    return selector;
};
/**
 * Used to create the root selector for a feature. It assumes that the state is already initialized
 * and strips from the types the possibility of `apiRef` being `null`.
 * Users are warned about this in our documentation https://mui.com/x/react-data-grid/state/#direct-selector-access
 */ $8eef5f2af445e503$exports.createSelectorMemoized = $8eef5f2af445e503$var$createSelectorMemoized;
const $8eef5f2af445e503$var$createRootSelector = (fn)=>(apiRef, args)=>fn($8eef5f2af445e503$var$unwrapIfNeeded(apiRef), args);
$8eef5f2af445e503$exports.createRootSelector = $8eef5f2af445e503$var$createRootSelector;
function $8eef5f2af445e503$var$unwrapIfNeeded(refOrState) {
    if ('current' in refOrState) return refOrState.current.state;
    return refOrState;
}


const $46349fe7fabb2b4d$var$gridDimensionsSelector = $46349fe7fabb2b4d$exports.gridDimensionsSelector = (0, $8eef5f2af445e503$exports.createRootSelector)((state)=>state.dimensions);
/**
 * Get the summed width of all the visible columns.
 * @category Visible Columns
 */ const $46349fe7fabb2b4d$var$gridColumnsTotalWidthSelector = $46349fe7fabb2b4d$exports.gridColumnsTotalWidthSelector = (0, $8eef5f2af445e503$exports.createSelector)($46349fe7fabb2b4d$var$gridDimensionsSelector, (dimensions)=>dimensions.columnsTotalWidth);
const $46349fe7fabb2b4d$var$gridRowHeightSelector = $46349fe7fabb2b4d$exports.gridRowHeightSelector = (0, $8eef5f2af445e503$exports.createSelector)($46349fe7fabb2b4d$var$gridDimensionsSelector, (dimensions)=>dimensions.rowHeight);
const $46349fe7fabb2b4d$var$gridContentHeightSelector = $46349fe7fabb2b4d$exports.gridContentHeightSelector = (0, $8eef5f2af445e503$exports.createSelector)($46349fe7fabb2b4d$var$gridDimensionsSelector, (dimensions)=>dimensions.contentSize.height);
const $46349fe7fabb2b4d$var$gridHasScrollXSelector = $46349fe7fabb2b4d$exports.gridHasScrollXSelector = (0, $8eef5f2af445e503$exports.createSelector)($46349fe7fabb2b4d$var$gridDimensionsSelector, (dimensions)=>dimensions.hasScrollX);
const $46349fe7fabb2b4d$var$gridHasScrollYSelector = $46349fe7fabb2b4d$exports.gridHasScrollYSelector = (0, $8eef5f2af445e503$exports.createSelector)($46349fe7fabb2b4d$var$gridDimensionsSelector, (dimensions)=>dimensions.hasScrollY);
const $46349fe7fabb2b4d$var$gridHasFillerSelector = $46349fe7fabb2b4d$exports.gridHasFillerSelector = (0, $8eef5f2af445e503$exports.createSelector)($46349fe7fabb2b4d$var$gridDimensionsSelector, (dimensions)=>dimensions.columnsTotalWidth < dimensions.viewportOuterSize.width);
const $46349fe7fabb2b4d$var$gridHeaderHeightSelector = $46349fe7fabb2b4d$exports.gridHeaderHeightSelector = (0, $8eef5f2af445e503$exports.createSelector)($46349fe7fabb2b4d$var$gridDimensionsSelector, (dimensions)=>dimensions.headerHeight);
const $46349fe7fabb2b4d$var$gridGroupHeaderHeightSelector = $46349fe7fabb2b4d$exports.gridGroupHeaderHeightSelector = (0, $8eef5f2af445e503$exports.createSelector)($46349fe7fabb2b4d$var$gridDimensionsSelector, (dimensions)=>dimensions.groupHeaderHeight);
const $46349fe7fabb2b4d$var$gridHeaderFilterHeightSelector = $46349fe7fabb2b4d$exports.gridHeaderFilterHeightSelector = (0, $8eef5f2af445e503$exports.createSelector)($46349fe7fabb2b4d$var$gridDimensionsSelector, (dimensions)=>dimensions.headerFilterHeight);
const $46349fe7fabb2b4d$var$gridHorizontalScrollbarHeightSelector = $46349fe7fabb2b4d$exports.gridHorizontalScrollbarHeightSelector = (0, $8eef5f2af445e503$exports.createSelector)($46349fe7fabb2b4d$var$gridDimensionsSelector, (dimensions)=>dimensions.hasScrollX ? dimensions.scrollbarSize : 0);
const $46349fe7fabb2b4d$var$gridVerticalScrollbarWidthSelector = $46349fe7fabb2b4d$exports.gridVerticalScrollbarWidthSelector = (0, $8eef5f2af445e503$exports.createSelector)($46349fe7fabb2b4d$var$gridDimensionsSelector, (dimensions)=>dimensions.hasScrollY ? dimensions.scrollbarSize : 0);
const $46349fe7fabb2b4d$var$gridHasBottomFillerSelector = $46349fe7fabb2b4d$exports.gridHasBottomFillerSelector = (0, $8eef5f2af445e503$exports.createSelector)($46349fe7fabb2b4d$var$gridDimensionsSelector, $46349fe7fabb2b4d$var$gridHorizontalScrollbarHeightSelector, (dimensions, height)=>{
    const needsLastRowBorder = dimensions.viewportOuterSize.height - dimensions.minimumSize.height > 0;
    if (height === 0 && !needsLastRowBorder) return false;
    return true;
});


var $aad5df8f504205b0$exports = {};
"use strict";
Object.defineProperty($aad5df8f504205b0$exports, "__esModule", {
    value: true
});
var $aad5df8f504205b0$var$_exportNames = {
    gridRowCountSelector: true,
    gridRowsLoadingSelector: true,
    gridTopLevelRowCountSelector: true,
    gridRowsLookupSelector: true,
    gridRowTreeSelector: true,
    gridRowGroupingNameSelector: true,
    gridRowTreeDepthsSelector: true,
    gridRowMaximumTreeDepthSelector: true,
    gridDataRowIdsSelector: true,
    gridRowNodeSelector: true,
    gridRowSelector: true,
    GRID_ROOT_GROUP_ID: true,
    checkGridRowIdIsValid: true,
    isAutogeneratedRow: true
};
Object.defineProperty($aad5df8f504205b0$exports, "GRID_ROOT_GROUP_ID", {
    enumerable: true,
    get: function() {
        return $0166dd44615cae0d$exports.GRID_ROOT_GROUP_ID;
    }
});
Object.defineProperty($aad5df8f504205b0$exports, "checkGridRowIdIsValid", {
    enumerable: true,
    get: function() {
        return $0166dd44615cae0d$exports.checkGridRowIdIsValid;
    }
});
Object.defineProperty($aad5df8f504205b0$exports, "gridDataRowIdsSelector", {
    enumerable: true,
    get: function() {
        return $befccaa56b49492d$exports.gridDataRowIdsSelector;
    }
});
Object.defineProperty($aad5df8f504205b0$exports, "gridRowCountSelector", {
    enumerable: true,
    get: function() {
        return $befccaa56b49492d$exports.gridRowCountSelector;
    }
});
Object.defineProperty($aad5df8f504205b0$exports, "gridRowGroupingNameSelector", {
    enumerable: true,
    get: function() {
        return $befccaa56b49492d$exports.gridRowGroupingNameSelector;
    }
});
Object.defineProperty($aad5df8f504205b0$exports, "gridRowMaximumTreeDepthSelector", {
    enumerable: true,
    get: function() {
        return $befccaa56b49492d$exports.gridRowMaximumTreeDepthSelector;
    }
});
Object.defineProperty($aad5df8f504205b0$exports, "gridRowNodeSelector", {
    enumerable: true,
    get: function() {
        return $befccaa56b49492d$exports.gridRowNodeSelector;
    }
});
Object.defineProperty($aad5df8f504205b0$exports, "gridRowSelector", {
    enumerable: true,
    get: function() {
        return $befccaa56b49492d$exports.gridRowSelector;
    }
});
Object.defineProperty($aad5df8f504205b0$exports, "gridRowTreeDepthsSelector", {
    enumerable: true,
    get: function() {
        return $befccaa56b49492d$exports.gridRowTreeDepthsSelector;
    }
});
Object.defineProperty($aad5df8f504205b0$exports, "gridRowTreeSelector", {
    enumerable: true,
    get: function() {
        return $befccaa56b49492d$exports.gridRowTreeSelector;
    }
});
Object.defineProperty($aad5df8f504205b0$exports, "gridRowsLoadingSelector", {
    enumerable: true,
    get: function() {
        return $befccaa56b49492d$exports.gridRowsLoadingSelector;
    }
});
Object.defineProperty($aad5df8f504205b0$exports, "gridRowsLookupSelector", {
    enumerable: true,
    get: function() {
        return $befccaa56b49492d$exports.gridRowsLookupSelector;
    }
});
Object.defineProperty($aad5df8f504205b0$exports, "gridTopLevelRowCountSelector", {
    enumerable: true,
    get: function() {
        return $befccaa56b49492d$exports.gridTopLevelRowCountSelector;
    }
});
Object.defineProperty($aad5df8f504205b0$exports, "isAutogeneratedRow", {
    enumerable: true,
    get: function() {
        return $0166dd44615cae0d$exports.isAutogeneratedRow;
    }
});
var $82a5a13765976ef2$exports = {};
"use strict";
Object.defineProperty($82a5a13765976ef2$exports, "__esModule", {
    value: true
});
$82a5a13765976ef2$exports.gridRowsMetaSelector = void 0;

const $82a5a13765976ef2$var$gridRowsMetaSelector = $82a5a13765976ef2$exports.gridRowsMetaSelector = (0, $8eef5f2af445e503$exports.createRootSelector)((state)=>state.rowsMeta);


Object.keys($82a5a13765976ef2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($aad5df8f504205b0$var$_exportNames, key)) return;
    if (key in $aad5df8f504205b0$exports && $aad5df8f504205b0$exports[key] === $82a5a13765976ef2$exports[key]) return;
    Object.defineProperty($aad5df8f504205b0$exports, key, {
        enumerable: true,
        get: function() {
            return $82a5a13765976ef2$exports[key];
        }
    });
});
var $67602ca1e8a6b5c9$exports = {};
"use strict";
Object.defineProperty($67602ca1e8a6b5c9$exports, "__esModule", {
    value: true
});


Object.keys($67602ca1e8a6b5c9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($aad5df8f504205b0$var$_exportNames, key)) return;
    if (key in $aad5df8f504205b0$exports && $aad5df8f504205b0$exports[key] === $67602ca1e8a6b5c9$exports[key]) return;
    Object.defineProperty($aad5df8f504205b0$exports, key, {
        enumerable: true,
        get: function() {
            return $67602ca1e8a6b5c9$exports[key];
        }
    });
});
var $befccaa56b49492d$exports = {};
"use strict";
Object.defineProperty($befccaa56b49492d$exports, "__esModule", {
    value: true
});
$befccaa56b49492d$exports.gridTopLevelRowCountSelector = $befccaa56b49492d$exports.gridRowsStateSelector = $befccaa56b49492d$exports.gridRowsLookupSelector = $befccaa56b49492d$exports.gridRowsLoadingSelector = $befccaa56b49492d$exports.gridRowTreeSelector = $befccaa56b49492d$exports.gridRowTreeDepthsSelector = $befccaa56b49492d$exports.gridRowSelector = $befccaa56b49492d$exports.gridRowNodeSelector = $befccaa56b49492d$exports.gridRowMaximumTreeDepthSelector = $befccaa56b49492d$exports.gridRowGroupsToFetchSelector = $befccaa56b49492d$exports.gridRowGroupingNameSelector = $befccaa56b49492d$exports.gridRowCountSelector = $befccaa56b49492d$exports.gridPinnedRowsSelector = $befccaa56b49492d$exports.gridPinnedRowsCountSelector = $befccaa56b49492d$exports.gridDataRowsSelector = $befccaa56b49492d$exports.gridDataRowIdsSelector = $befccaa56b49492d$exports.gridAdditionalRowGroupsSelector = void 0;

const $befccaa56b49492d$var$gridRowsStateSelector = $befccaa56b49492d$exports.gridRowsStateSelector = (0, $8eef5f2af445e503$exports.createRootSelector)((state)=>state.rows);
const $befccaa56b49492d$var$gridRowCountSelector = $befccaa56b49492d$exports.gridRowCountSelector = (0, $8eef5f2af445e503$exports.createSelector)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>rows.totalRowCount);
const $befccaa56b49492d$var$gridRowsLoadingSelector = $befccaa56b49492d$exports.gridRowsLoadingSelector = (0, $8eef5f2af445e503$exports.createSelector)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>rows.loading);
const $befccaa56b49492d$var$gridTopLevelRowCountSelector = $befccaa56b49492d$exports.gridTopLevelRowCountSelector = (0, $8eef5f2af445e503$exports.createSelector)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>rows.totalTopLevelRowCount);
// TODO rows v6: Rename
const $befccaa56b49492d$var$gridRowsLookupSelector = $befccaa56b49492d$exports.gridRowsLookupSelector = (0, $8eef5f2af445e503$exports.createSelector)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>rows.dataRowIdToModelLookup);
/**
 * @category Rows
 */ const $befccaa56b49492d$var$gridRowSelector = $befccaa56b49492d$exports.gridRowSelector = (0, $8eef5f2af445e503$exports.createSelector)($befccaa56b49492d$var$gridRowsLookupSelector, (rows, id)=>rows[id]);
const $befccaa56b49492d$var$gridRowTreeSelector = $befccaa56b49492d$exports.gridRowTreeSelector = (0, $8eef5f2af445e503$exports.createSelector)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>rows.tree);
/**
 * @category Rows
 */ const $befccaa56b49492d$var$gridRowNodeSelector = $befccaa56b49492d$exports.gridRowNodeSelector = (0, $8eef5f2af445e503$exports.createSelector)($befccaa56b49492d$var$gridRowTreeSelector, (rowTree, rowId)=>rowTree[rowId]);
const $befccaa56b49492d$var$gridRowGroupsToFetchSelector = $befccaa56b49492d$exports.gridRowGroupsToFetchSelector = (0, $8eef5f2af445e503$exports.createSelector)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>rows.groupsToFetch);
const $befccaa56b49492d$var$gridRowGroupingNameSelector = $befccaa56b49492d$exports.gridRowGroupingNameSelector = (0, $8eef5f2af445e503$exports.createSelector)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>rows.groupingName);
const $befccaa56b49492d$var$gridRowTreeDepthsSelector = $befccaa56b49492d$exports.gridRowTreeDepthsSelector = (0, $8eef5f2af445e503$exports.createSelector)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>rows.treeDepths);
const $befccaa56b49492d$var$gridRowMaximumTreeDepthSelector = $befccaa56b49492d$exports.gridRowMaximumTreeDepthSelector = (0, $8eef5f2af445e503$exports.createSelectorMemoized)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>{
    const entries = Object.entries(rows.treeDepths);
    if (entries.length === 0) return 1;
    return (entries.filter(([, nodeCount])=>nodeCount > 0).map(([depth])=>Number(depth)).sort((a, b)=>b - a)[0] ?? 0) + 1;
});
/**
 * @category Rows
 */ const $befccaa56b49492d$var$gridDataRowIdsSelector = $befccaa56b49492d$exports.gridDataRowIdsSelector = (0, $8eef5f2af445e503$exports.createSelector)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>rows.dataRowIds);
const $befccaa56b49492d$var$gridDataRowsSelector = $befccaa56b49492d$exports.gridDataRowsSelector = (0, $8eef5f2af445e503$exports.createSelectorMemoized)($befccaa56b49492d$var$gridDataRowIdsSelector, $befccaa56b49492d$var$gridRowsLookupSelector, (dataRowIds, rowsLookup)=>dataRowIds.reduce((acc, id)=>{
        if (!rowsLookup[id]) return acc;
        acc.push(rowsLookup[id]);
        return acc;
    }, []));
/**
 * @ignore - do not document.
 */ const $befccaa56b49492d$var$gridAdditionalRowGroupsSelector = $befccaa56b49492d$exports.gridAdditionalRowGroupsSelector = (0, $8eef5f2af445e503$exports.createSelector)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>rows?.additionalRowGroups);
/**
 * @ignore - do not document.
 */ const $befccaa56b49492d$var$gridPinnedRowsSelector = $befccaa56b49492d$exports.gridPinnedRowsSelector = (0, $8eef5f2af445e503$exports.createSelectorMemoized)($befccaa56b49492d$var$gridAdditionalRowGroupsSelector, (additionalRowGroups)=>{
    const rawPinnedRows = additionalRowGroups?.pinnedRows;
    return {
        bottom: rawPinnedRows?.bottom?.map((rowEntry)=>({
                id: rowEntry.id,
                model: rowEntry.model ?? {}
            })) ?? [],
        top: rawPinnedRows?.top?.map((rowEntry)=>({
                id: rowEntry.id,
                model: rowEntry.model ?? {}
            })) ?? []
    };
});
/**
 * @ignore - do not document.
 */ const $befccaa56b49492d$var$gridPinnedRowsCountSelector = $befccaa56b49492d$exports.gridPinnedRowsCountSelector = (0, $8eef5f2af445e503$exports.createSelector)($befccaa56b49492d$var$gridPinnedRowsSelector, (pinnedRows)=>{
    return (pinnedRows?.top?.length || 0) + (pinnedRows?.bottom?.length || 0);
});


var $0166dd44615cae0d$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0166dd44615cae0d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($0166dd44615cae0d$exports, "__esModule", {
    value: true
});
$0166dd44615cae0d$exports.buildRootGroup = $0166dd44615cae0d$exports.GRID_ROOT_GROUP_ID = $0166dd44615cae0d$exports.GRID_ID_AUTOGENERATED = void 0;
$0166dd44615cae0d$exports.checkGridRowIdIsValid = $0166dd44615cae0d$var$checkGridRowIdIsValid;
$0166dd44615cae0d$exports.computeRowsUpdates = $0166dd44615cae0d$var$computeRowsUpdates;
$0166dd44615cae0d$exports.updateCacheWithNewRows = $0166dd44615cae0d$exports.rowHeightWarning = $0166dd44615cae0d$exports.minimalContentHeight = $0166dd44615cae0d$exports.isAutogeneratedRowNode = $0166dd44615cae0d$exports.isAutogeneratedRow = $0166dd44615cae0d$exports.getValidRowHeight = $0166dd44615cae0d$exports.getTreeNodeDescendants = $0166dd44615cae0d$exports.getTopLevelRowCount = $0166dd44615cae0d$exports.getRowsStateFromCache = $0166dd44615cae0d$exports.getRowValue = $0166dd44615cae0d$exports.getRowIdFromRowModel = $0166dd44615cae0d$exports.getRowHeightWarning = $0166dd44615cae0d$exports.createRowsInternalCache = void 0;

var $0166dd44615cae0d$var$_extends2 = $0166dd44615cae0d$require$_interopRequireDefault((parcelRequire("3p9rK")));

const $0166dd44615cae0d$var$GRID_ROOT_GROUP_ID = $0166dd44615cae0d$exports.GRID_ROOT_GROUP_ID = `auto-generated-group-node-root`;
const $0166dd44615cae0d$var$GRID_ID_AUTOGENERATED = $0166dd44615cae0d$exports.GRID_ID_AUTOGENERATED = Symbol('mui.id_autogenerated');
const $0166dd44615cae0d$var$buildRootGroup = ()=>({
        type: 'group',
        id: $0166dd44615cae0d$var$GRID_ROOT_GROUP_ID,
        depth: -1,
        groupingField: null,
        groupingKey: null,
        isAutoGenerated: true,
        children: [],
        childrenFromPath: {},
        childrenExpanded: true,
        parent: null
    });
/**
 * A helper function to check if the id provided is valid.
 * @param {GridRowId} id Id as [[GridRowId]].
 * @param {GridRowModel | Partial<GridRowModel>} row Row as [[GridRowModel]].
 * @param {string} detailErrorMessage A custom error message to display for invalid IDs
 */ $0166dd44615cae0d$exports.buildRootGroup = $0166dd44615cae0d$var$buildRootGroup;
function $0166dd44615cae0d$var$checkGridRowIdIsValid(id, row, detailErrorMessage = 'A row was provided without id in the rows prop:') {
    if (id == null) throw new Error([
        'MUI X: The Data Grid component requires all rows to have a unique `id` property.',
        'Alternatively, you can use the `getRowId` prop to specify a custom id for each row.',
        detailErrorMessage,
        JSON.stringify(row)
    ].join('\n'));
}
const $0166dd44615cae0d$var$getRowIdFromRowModel = (rowModel, getRowId, detailErrorMessage)=>{
    const id = getRowId ? getRowId(rowModel) : rowModel.id;
    $0166dd44615cae0d$var$checkGridRowIdIsValid(id, rowModel, detailErrorMessage);
    return id;
};
$0166dd44615cae0d$exports.getRowIdFromRowModel = $0166dd44615cae0d$var$getRowIdFromRowModel;
const $0166dd44615cae0d$var$getRowValue = (row, colDef, apiRef)=>{
    const field = colDef.field;
    if (!colDef || !colDef.valueGetter) return row[field];
    const value = row[colDef.field];
    return colDef.valueGetter(value, row, colDef, apiRef);
};
$0166dd44615cae0d$exports.getRowValue = $0166dd44615cae0d$var$getRowValue;
const $0166dd44615cae0d$var$createRowsInternalCache = ({ rows: rows, getRowId: getRowId, loading: loading, rowCount: rowCount })=>{
    const updates = {
        type: 'full',
        rows: []
    };
    const dataRowIdToModelLookup = {};
    for(let i = 0; i < rows.length; i += 1){
        const model = rows[i];
        const id = $0166dd44615cae0d$var$getRowIdFromRowModel(model, getRowId);
        dataRowIdToModelLookup[id] = model;
        updates.rows.push(id);
    }
    return {
        rowsBeforePartialUpdates: rows,
        loadingPropBeforePartialUpdates: loading,
        rowCountPropBeforePartialUpdates: rowCount,
        updates: updates,
        dataRowIdToModelLookup: dataRowIdToModelLookup
    };
};
$0166dd44615cae0d$exports.createRowsInternalCache = $0166dd44615cae0d$var$createRowsInternalCache;
const $0166dd44615cae0d$var$getTopLevelRowCount = ({ tree: tree, rowCountProp: rowCountProp = 0 })=>{
    const rootGroupNode = tree[$0166dd44615cae0d$var$GRID_ROOT_GROUP_ID];
    return Math.max(rowCountProp, rootGroupNode.children.length + (rootGroupNode.footerId == null ? 0 : 1));
};
$0166dd44615cae0d$exports.getTopLevelRowCount = $0166dd44615cae0d$var$getTopLevelRowCount;
const $0166dd44615cae0d$var$getRowsStateFromCache = ({ apiRef: apiRef, rowCountProp: rowCountProp = 0, loadingProp: loadingProp, previousTree: previousTree, previousTreeDepths: previousTreeDepths, previousGroupsToFetch: previousGroupsToFetch })=>{
    const cache = apiRef.current.caches.rows;
    // 1. Apply the "rowTreeCreation" family processing.
    const { tree: unProcessedTree, treeDepths: unProcessedTreeDepths, dataRowIds: unProcessedDataRowIds, groupingName: groupingName, groupsToFetch: groupsToFetch = [] } = apiRef.current.applyStrategyProcessor('rowTreeCreation', {
        previousTree: previousTree,
        previousTreeDepths: previousTreeDepths,
        updates: cache.updates,
        dataRowIdToModelLookup: cache.dataRowIdToModelLookup,
        previousGroupsToFetch: previousGroupsToFetch
    });
    // 2. Apply the "hydrateRows" pipe-processing.
    const groupingParamsWithHydrateRows = apiRef.current.unstable_applyPipeProcessors('hydrateRows', {
        tree: unProcessedTree,
        treeDepths: unProcessedTreeDepths,
        dataRowIds: unProcessedDataRowIds,
        dataRowIdToModelLookup: cache.dataRowIdToModelLookup
    });
    // 3. Reset the cache updates
    apiRef.current.caches.rows.updates = {
        type: 'partial',
        actions: {
            insert: [],
            modify: [],
            remove: []
        },
        idToActionLookup: {}
    };
    return (0, $0166dd44615cae0d$var$_extends2.default)({}, groupingParamsWithHydrateRows, {
        totalRowCount: Math.max(rowCountProp, groupingParamsWithHydrateRows.dataRowIds.length),
        totalTopLevelRowCount: $0166dd44615cae0d$var$getTopLevelRowCount({
            tree: groupingParamsWithHydrateRows.tree,
            rowCountProp: rowCountProp
        }),
        groupingName: groupingName,
        loading: loadingProp,
        groupsToFetch: groupsToFetch
    });
};
$0166dd44615cae0d$exports.getRowsStateFromCache = $0166dd44615cae0d$var$getRowsStateFromCache;
const $0166dd44615cae0d$var$isAutogeneratedRow = (row)=>$0166dd44615cae0d$var$GRID_ID_AUTOGENERATED in row;
$0166dd44615cae0d$exports.isAutogeneratedRow = $0166dd44615cae0d$var$isAutogeneratedRow;
const $0166dd44615cae0d$var$isAutogeneratedRowNode = (rowNode)=>rowNode.type === 'skeletonRow' || rowNode.type === 'footer' || rowNode.type === 'group' && rowNode.isAutoGenerated || rowNode.type === 'pinnedRow' && rowNode.isAutoGenerated;
$0166dd44615cae0d$exports.isAutogeneratedRowNode = $0166dd44615cae0d$var$isAutogeneratedRowNode;
const $0166dd44615cae0d$var$getTreeNodeDescendants = (tree, parentId, skipAutoGeneratedRows, directChildrenOnly)=>{
    const node = tree[parentId];
    if (node.type !== 'group') return [];
    const validDescendants = [];
    for(let i = 0; i < node.children.length; i += 1){
        const child = node.children[i];
        if (!skipAutoGeneratedRows || !$0166dd44615cae0d$var$isAutogeneratedRowNode(tree[child])) validDescendants.push(child);
        if (directChildrenOnly) continue;
        const childDescendants = $0166dd44615cae0d$var$getTreeNodeDescendants(tree, child, skipAutoGeneratedRows, directChildrenOnly);
        for(let j = 0; j < childDescendants.length; j += 1)validDescendants.push(childDescendants[j]);
    }
    if (!skipAutoGeneratedRows && node.footerId != null) validDescendants.push(node.footerId);
    return validDescendants;
};
$0166dd44615cae0d$exports.getTreeNodeDescendants = $0166dd44615cae0d$var$getTreeNodeDescendants;
const $0166dd44615cae0d$var$updateCacheWithNewRows = ({ previousCache: previousCache, getRowId: getRowId, updates: updates, groupKeys: groupKeys })=>{
    if (previousCache.updates.type === 'full') throw new Error('MUI X: Unable to prepare a partial update if a full update is not applied yet.');
    // Remove duplicate updates.
    // A server can batch updates, and send several updates for the same row in one fn call.
    const uniqueUpdates = new Map();
    updates.forEach((update)=>{
        const id = $0166dd44615cae0d$var$getRowIdFromRowModel(update, getRowId, 'A row was provided without id when calling updateRows():');
        if (uniqueUpdates.has(id)) uniqueUpdates.set(id, (0, $0166dd44615cae0d$var$_extends2.default)({}, uniqueUpdates.get(id), update));
        else uniqueUpdates.set(id, update);
    });
    const partialUpdates = {
        type: 'partial',
        actions: {
            insert: [
                ...previousCache.updates.actions.insert ?? []
            ],
            modify: [
                ...previousCache.updates.actions.modify ?? []
            ],
            remove: [
                ...previousCache.updates.actions.remove ?? []
            ]
        },
        idToActionLookup: (0, $0166dd44615cae0d$var$_extends2.default)({}, previousCache.updates.idToActionLookup),
        groupKeys: groupKeys
    };
    const dataRowIdToModelLookup = (0, $0166dd44615cae0d$var$_extends2.default)({}, previousCache.dataRowIdToModelLookup);
    const alreadyAppliedActionsToRemove = {
        insert: {},
        modify: {},
        remove: {}
    };
    // Depending on the action already applied to the data row,
    // We might want drop the already-applied-update.
    // For instance:
    // - if you delete then insert, then you don't want to apply the deletion in the tree.
    // - if you insert, then modify, then you just want to apply the insertion in the tree.
    uniqueUpdates.forEach((partialRow, id)=>{
        const actionAlreadyAppliedToRow = partialUpdates.idToActionLookup[id];
        // Action === "delete"
        // eslint-disable-next-line no-underscore-dangle
        if (partialRow._action === 'delete') {
            // If the data row has been removed since the last state update,
            // Then do nothing.
            if (actionAlreadyAppliedToRow === 'remove' || !dataRowIdToModelLookup[id]) return;
            // If the data row has been inserted / modified since the last state update,
            // Then drop this "insert" / "modify" update.
            if (actionAlreadyAppliedToRow != null) alreadyAppliedActionsToRemove[actionAlreadyAppliedToRow][id] = true;
            // Remove the data row from the lookups and add it to the "delete" update.
            partialUpdates.actions.remove.push(id);
            delete dataRowIdToModelLookup[id];
            return;
        }
        const oldRow = dataRowIdToModelLookup[id];
        // Action === "modify"
        if (oldRow) {
            // If the data row has been removed since the last state update,
            // Then drop this "remove" update and add it to the "modify" update instead.
            if (actionAlreadyAppliedToRow === 'remove') {
                alreadyAppliedActionsToRemove.remove[id] = true;
                partialUpdates.actions.modify.push(id);
            } else if (actionAlreadyAppliedToRow == null) partialUpdates.actions.modify.push(id);
            // Update the data row lookups.
            dataRowIdToModelLookup[id] = (0, $0166dd44615cae0d$var$_extends2.default)({}, oldRow, partialRow);
            return;
        }
        // Action === "insert"
        // If the data row has been removed since the last state update,
        // Then drop the "remove" update and add it to the "insert" update instead.
        if (actionAlreadyAppliedToRow === 'remove') {
            alreadyAppliedActionsToRemove.remove[id] = true;
            partialUpdates.actions.insert.push(id);
        } else if (actionAlreadyAppliedToRow == null) partialUpdates.actions.insert.push(id);
        // Update the data row lookups.
        dataRowIdToModelLookup[id] = partialRow;
    });
    const actionTypeWithActionsToRemove = Object.keys(alreadyAppliedActionsToRemove);
    for(let i = 0; i < actionTypeWithActionsToRemove.length; i += 1){
        const actionType = actionTypeWithActionsToRemove[i];
        const idsToRemove = alreadyAppliedActionsToRemove[actionType];
        if (Object.keys(idsToRemove).length > 0) partialUpdates.actions[actionType] = partialUpdates.actions[actionType].filter((id)=>!idsToRemove[id]);
    }
    return {
        dataRowIdToModelLookup: dataRowIdToModelLookup,
        updates: partialUpdates,
        rowsBeforePartialUpdates: previousCache.rowsBeforePartialUpdates,
        loadingPropBeforePartialUpdates: previousCache.loadingPropBeforePartialUpdates,
        rowCountPropBeforePartialUpdates: previousCache.rowCountPropBeforePartialUpdates
    };
};
$0166dd44615cae0d$exports.updateCacheWithNewRows = $0166dd44615cae0d$var$updateCacheWithNewRows;
const $0166dd44615cae0d$var$minimalContentHeight = $0166dd44615cae0d$exports.minimalContentHeight = 'var(--DataGrid-overlayHeight, calc(var(--height) * 2))';
function $0166dd44615cae0d$var$computeRowsUpdates(apiRef, updates, getRowId) {
    const nonPinnedRowsUpdates = [];
    updates.forEach((update)=>{
        const id = $0166dd44615cae0d$var$getRowIdFromRowModel(update, getRowId, 'A row was provided without id when calling updateRows():');
        const rowNode = (0, $befccaa56b49492d$exports.gridRowNodeSelector)(apiRef, id);
        if (rowNode?.type === 'pinnedRow') {
            // @ts-ignore because otherwise `release:build` doesn't work
            const pinnedRowsCache = apiRef.current.caches.pinnedRows;
            const prevModel = pinnedRowsCache.idLookup[id];
            if (prevModel) pinnedRowsCache.idLookup[id] = (0, $0166dd44615cae0d$var$_extends2.default)({}, prevModel, update);
        } else nonPinnedRowsUpdates.push(update);
    });
    return nonPinnedRowsUpdates;
}
let $0166dd44615cae0d$var$warnedOnceInvalidRowHeight = false;
const $0166dd44615cae0d$var$getValidRowHeight = (rowHeightProp, defaultRowHeight, warningMessage)=>{
    if (typeof rowHeightProp === 'number' && rowHeightProp > 0) return rowHeightProp;
    if (!$0166dd44615cae0d$var$warnedOnceInvalidRowHeight && typeof rowHeightProp !== 'undefined' && rowHeightProp !== null) {
        console.warn(warningMessage);
        $0166dd44615cae0d$var$warnedOnceInvalidRowHeight = true;
    }
    return defaultRowHeight;
};
$0166dd44615cae0d$exports.getValidRowHeight = $0166dd44615cae0d$var$getValidRowHeight;
const $0166dd44615cae0d$var$rowHeightWarning = $0166dd44615cae0d$exports.rowHeightWarning = [
    `MUI X: The \`rowHeight\` prop should be a number greater than 0.`,
    `The default value will be used instead.`
].join('\n');
const $0166dd44615cae0d$var$getRowHeightWarning = $0166dd44615cae0d$exports.getRowHeightWarning = [
    `MUI X: The \`getRowHeight\` prop should return a number greater than 0 or 'auto'.`,
    `The default value will be used instead.`
].join('\n');




var $3b92023a13ae6811$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $3b92023a13ae6811$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $3b92023a13ae6811$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($3b92023a13ae6811$exports, "__esModule", {
    value: true
});
$3b92023a13ae6811$exports.GridScrollArea = void 0;

var $3b92023a13ae6811$var$_extends2 = $3b92023a13ae6811$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $3b92023a13ae6811$var$React = $3b92023a13ae6811$require$_interopRequireWildcard((parcelRequire("acw62")));

var $3b92023a13ae6811$var$_useEventCallback = $3b92023a13ae6811$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $3b92023a13ae6811$var$_composeClasses = $3b92023a13ae6811$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $izOUK = parcelRequire("izOUK");
var $1bc1b286f3c678cc$exports = {};
"use strict";
Object.defineProperty($1bc1b286f3c678cc$exports, "__esModule", {
    value: true
});
Object.defineProperty($1bc1b286f3c678cc$exports, "fastMemo", {
    enumerable: true,
    get: function() {
        return $f9605ab7c59a9c8a$exports.fastMemo;
    }
});
var $f9605ab7c59a9c8a$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $f9605ab7c59a9c8a$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($f9605ab7c59a9c8a$exports, "__esModule", {
    value: true
});
$f9605ab7c59a9c8a$exports.fastMemo = $f9605ab7c59a9c8a$var$fastMemo;

var $f9605ab7c59a9c8a$var$React = $f9605ab7c59a9c8a$require$_interopRequireWildcard((parcelRequire("acw62")));

var $325pS = parcelRequire("325pS");
function $f9605ab7c59a9c8a$var$fastMemo(component) {
    return /*#__PURE__*/ $f9605ab7c59a9c8a$var$React.memo(component, $325pS.fastObjectShallowCompare);
}





var $fYxgT = parcelRequire("fYxgT");

var $jDpXp = parcelRequire("jDpXp");
var $553c2bbb14fa5500$exports = {};
"use strict";
Object.defineProperty($553c2bbb14fa5500$exports, "__esModule", {
    value: true
});
var $f5717c864dbc0f49$exports = {};
"use strict";
Object.defineProperty($f5717c864dbc0f49$exports, "__esModule", {
    value: true
});
$f5717c864dbc0f49$exports.GRID_EXPERIMENTAL_ENABLED = void 0;
// A guide to feature toggling (deprecated)
//
// The feature toggle is:
// - independent from the NODE_ENV
// - isn't pruning code in production, as the objective is to eventually ship the code.
// - doesn't allow to cherry-pick which feature to enable
//
// By default, the experimental features are only enabled in:
// - the local environment
// - the pull request previews
//
// Reviewers can force the value with the local storage and the GRID_EXPERIMENTAL_ENABLED key:
// - 'true' => force it to be enabled
// - 'false' => force it to be disabled
//
// Developers (users) are discouraged to enable the experimental feature by setting the GRID_EXPERIMENTAL_ENABLED env.
// Instead, prefer exposing experimental APIs, for instance, a prop or a new `unstable_` module.
const $f5717c864dbc0f49$var$GRID_EXPERIMENTAL_ENABLED = $f5717c864dbc0f49$exports.GRID_EXPERIMENTAL_ENABLED = false;


Object.keys($f5717c864dbc0f49$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $553c2bbb14fa5500$exports && $553c2bbb14fa5500$exports[key] === $f5717c864dbc0f49$exports[key]) return;
    Object.defineProperty($553c2bbb14fa5500$exports, key, {
        enumerable: true,
        get: function() {
            return $f5717c864dbc0f49$exports[key];
        }
    });
});
var $ce4677c59813cb05$exports = {};
"use strict";
Object.defineProperty($ce4677c59813cb05$exports, "__esModule", {
    value: true
});
$ce4677c59813cb05$exports.GRID_DEFAULT_LOCALE_TEXT = void 0;
const $ce4677c59813cb05$var$GRID_DEFAULT_LOCALE_TEXT = $ce4677c59813cb05$exports.GRID_DEFAULT_LOCALE_TEXT = {
    // Root
    noRowsLabel: 'No rows',
    noResultsOverlayLabel: 'No results found.',
    noColumnsOverlayLabel: 'No columns',
    noColumnsOverlayManageColumns: 'Manage columns',
    emptyPivotOverlayLabel: 'Add fields to rows, columns, and values to create a pivot table',
    // Density selector toolbar button text
    toolbarDensity: 'Density',
    toolbarDensityLabel: 'Density',
    toolbarDensityCompact: 'Compact',
    toolbarDensityStandard: 'Standard',
    toolbarDensityComfortable: 'Comfortable',
    // Columns selector toolbar button text
    toolbarColumns: 'Columns',
    toolbarColumnsLabel: 'Select columns',
    // Filters toolbar button text
    toolbarFilters: 'Filters',
    toolbarFiltersLabel: 'Show filters',
    toolbarFiltersTooltipHide: 'Hide filters',
    toolbarFiltersTooltipShow: 'Show filters',
    toolbarFiltersTooltipActive: (count)=>count !== 1 ? `${count} active filters` : `${count} active filter`,
    // Quick filter toolbar field
    toolbarQuickFilterPlaceholder: "Search\u2026",
    toolbarQuickFilterLabel: 'Search',
    toolbarQuickFilterDeleteIconLabel: 'Clear',
    // Export selector toolbar button text
    toolbarExport: 'Export',
    toolbarExportLabel: 'Export',
    toolbarExportCSV: 'Download as CSV',
    toolbarExportPrint: 'Print',
    toolbarExportExcel: 'Download as Excel',
    // Toolbar pivot button
    toolbarPivot: 'Pivot',
    // Toolbar charts button
    toolbarCharts: 'Charts',
    // Toolbar AI Assistant button
    toolbarAssistant: 'AI Assistant',
    // Columns management text
    columnsManagementSearchTitle: 'Search',
    columnsManagementNoColumns: 'No columns',
    columnsManagementShowHideAllText: 'Show/Hide All',
    columnsManagementReset: 'Reset',
    columnsManagementDeleteIconLabel: 'Clear',
    // Filter panel text
    filterPanelAddFilter: 'Add filter',
    filterPanelRemoveAll: 'Remove all',
    filterPanelDeleteIconLabel: 'Delete',
    filterPanelLogicOperator: 'Logic operator',
    filterPanelOperator: 'Operator',
    filterPanelOperatorAnd: 'And',
    filterPanelOperatorOr: 'Or',
    filterPanelColumns: 'Columns',
    filterPanelInputLabel: 'Value',
    filterPanelInputPlaceholder: 'Filter value',
    // Filter operators text
    filterOperatorContains: 'contains',
    filterOperatorDoesNotContain: 'does not contain',
    filterOperatorEquals: 'equals',
    filterOperatorDoesNotEqual: 'does not equal',
    filterOperatorStartsWith: 'starts with',
    filterOperatorEndsWith: 'ends with',
    filterOperatorIs: 'is',
    filterOperatorNot: 'is not',
    filterOperatorAfter: 'is after',
    filterOperatorOnOrAfter: 'is on or after',
    filterOperatorBefore: 'is before',
    filterOperatorOnOrBefore: 'is on or before',
    filterOperatorIsEmpty: 'is empty',
    filterOperatorIsNotEmpty: 'is not empty',
    filterOperatorIsAnyOf: 'is any of',
    'filterOperator=': '=',
    'filterOperator!=': '!=',
    'filterOperator>': '>',
    'filterOperator>=': '>=',
    'filterOperator<': '<',
    'filterOperator<=': '<=',
    // Header filter operators text
    headerFilterOperatorContains: 'Contains',
    headerFilterOperatorDoesNotContain: 'Does not contain',
    headerFilterOperatorEquals: 'Equals',
    headerFilterOperatorDoesNotEqual: 'Does not equal',
    headerFilterOperatorStartsWith: 'Starts with',
    headerFilterOperatorEndsWith: 'Ends with',
    headerFilterOperatorIs: 'Is',
    headerFilterOperatorNot: 'Is not',
    headerFilterOperatorAfter: 'Is after',
    headerFilterOperatorOnOrAfter: 'Is on or after',
    headerFilterOperatorBefore: 'Is before',
    headerFilterOperatorOnOrBefore: 'Is on or before',
    headerFilterOperatorIsEmpty: 'Is empty',
    headerFilterOperatorIsNotEmpty: 'Is not empty',
    headerFilterOperatorIsAnyOf: 'Is any of',
    'headerFilterOperator=': 'Equals',
    'headerFilterOperator!=': 'Not equals',
    'headerFilterOperator>': 'Greater than',
    'headerFilterOperator>=': 'Greater than or equal to',
    'headerFilterOperator<': 'Less than',
    'headerFilterOperator<=': 'Less than or equal to',
    headerFilterClear: 'Clear filter',
    // Filter values text
    filterValueAny: 'any',
    filterValueTrue: 'true',
    filterValueFalse: 'false',
    // Column menu text
    columnMenuLabel: 'Menu',
    columnMenuAriaLabel: (columnName)=>`${columnName} column menu`,
    columnMenuShowColumns: 'Show columns',
    columnMenuManageColumns: 'Manage columns',
    columnMenuFilter: 'Filter',
    columnMenuHideColumn: 'Hide column',
    columnMenuUnsort: 'Unsort',
    columnMenuSortAsc: 'Sort by ASC',
    columnMenuSortDesc: 'Sort by DESC',
    columnMenuManagePivot: 'Manage pivot',
    columnMenuManageCharts: 'Manage charts',
    // Column header text
    columnHeaderFiltersTooltipActive: (count)=>count !== 1 ? `${count} active filters` : `${count} active filter`,
    columnHeaderFiltersLabel: 'Show filters',
    columnHeaderSortIconLabel: 'Sort',
    // Rows selected footer text
    footerRowSelected: (count)=>count !== 1 ? `${count.toLocaleString()} rows selected` : `${count.toLocaleString()} row selected`,
    // Total row amount footer text
    footerTotalRows: 'Total Rows:',
    // Total visible row amount footer text
    footerTotalVisibleRows: (visibleCount, totalCount)=>`${visibleCount.toLocaleString()} of ${totalCount.toLocaleString()}`,
    // Checkbox selection text
    checkboxSelectionHeaderName: 'Checkbox selection',
    checkboxSelectionSelectAllRows: 'Select all rows',
    checkboxSelectionUnselectAllRows: 'Unselect all rows',
    checkboxSelectionSelectRow: 'Select row',
    checkboxSelectionUnselectRow: 'Unselect row',
    // Boolean cell text
    booleanCellTrueLabel: 'yes',
    booleanCellFalseLabel: 'no',
    // Actions cell more text
    actionsCellMore: 'more',
    // Column pinning text
    pinToLeft: 'Pin to left',
    pinToRight: 'Pin to right',
    unpin: 'Unpin',
    // Tree Data
    treeDataGroupingHeaderName: 'Group',
    treeDataExpand: 'see children',
    treeDataCollapse: 'hide children',
    // Grouping columns
    groupingColumnHeaderName: 'Group',
    groupColumn: (name)=>`Group by ${name}`,
    unGroupColumn: (name)=>`Stop grouping by ${name}`,
    // Master/detail
    detailPanelToggle: 'Detail panel toggle',
    expandDetailPanel: 'Expand',
    collapseDetailPanel: 'Collapse',
    // Pagination
    paginationRowsPerPage: 'Rows per page:',
    paginationDisplayedRows: ({ from: from, to: to, count: count, estimated: estimated })=>{
        if (!estimated) return `${from}\u{2013}${to} of ${count !== -1 ? count : `more than ${to}`}`;
        const estimatedLabel = estimated && estimated > to ? `around ${estimated}` : `more than ${to}`;
        return `${from}\u{2013}${to} of ${count !== -1 ? count : estimatedLabel}`;
    },
    paginationItemAriaLabel: (type)=>{
        if (type === 'first') return 'Go to first page';
        if (type === 'last') return 'Go to last page';
        if (type === 'next') return 'Go to next page';
        // if (type === 'previous') {
        return 'Go to previous page';
    },
    // Row reordering text
    rowReorderingHeaderName: 'Row reordering',
    // Aggregation
    aggregationMenuItemHeader: 'Aggregation',
    aggregationFunctionLabelNone: 'none',
    aggregationFunctionLabelSum: 'sum',
    aggregationFunctionLabelAvg: 'avg',
    aggregationFunctionLabelMin: 'min',
    aggregationFunctionLabelMax: 'max',
    aggregationFunctionLabelSize: 'size',
    // Pivot panel
    pivotToggleLabel: 'Pivot',
    pivotRows: 'Rows',
    pivotColumns: 'Columns',
    pivotValues: 'Values',
    pivotCloseButton: 'Close pivot settings',
    pivotSearchButton: 'Search fields',
    pivotSearchControlPlaceholder: 'Search fields',
    pivotSearchControlLabel: 'Search fields',
    pivotSearchControlClear: 'Clear search',
    pivotNoFields: 'No fields',
    pivotMenuMoveUp: 'Move up',
    pivotMenuMoveDown: 'Move down',
    pivotMenuMoveToTop: 'Move to top',
    pivotMenuMoveToBottom: 'Move to bottom',
    pivotMenuRows: 'Rows',
    pivotMenuColumns: 'Columns',
    pivotMenuValues: 'Values',
    pivotMenuOptions: 'Field options',
    pivotMenuAddToRows: 'Add to Rows',
    pivotMenuAddToColumns: 'Add to Columns',
    pivotMenuAddToValues: 'Add to Values',
    pivotMenuRemove: 'Remove',
    pivotDragToRows: 'Drag here to create rows',
    pivotDragToColumns: 'Drag here to create columns',
    pivotDragToValues: 'Drag here to create values',
    pivotYearColumnHeaderName: '(Year)',
    pivotQuarterColumnHeaderName: '(Quarter)',
    // Charts configuration panel
    chartsNoCharts: 'There are no charts available',
    chartsChartNotSelected: 'Select a chart type to configure its options',
    chartsTabChart: 'Chart',
    chartsTabFields: 'Fields',
    chartsTabCustomize: 'Customize',
    chartsCloseButton: 'Close charts configuration',
    chartsSyncButtonLabel: 'Sync chart',
    chartsSearchPlaceholder: 'Search fields',
    chartsSearchLabel: 'Search fields',
    chartsSearchClear: 'Clear search',
    chartsNoFields: 'No fields',
    chartsFieldBlocked: 'This field cannot be added to any section',
    chartsCategories: 'Categories',
    chartsSeries: 'Series',
    chartsMenuAddToDimensions: (dimensionLabel)=>`Add to ${dimensionLabel}`,
    chartsMenuAddToValues: (valuesLabel)=>`Add to ${valuesLabel}`,
    chartsMenuMoveUp: 'Move up',
    chartsMenuMoveDown: 'Move down',
    chartsMenuMoveToTop: 'Move to top',
    chartsMenuMoveToBottom: 'Move to bottom',
    chartsMenuOptions: 'Field options',
    chartsMenuRemove: 'Remove',
    chartsDragToDimensions: (dimensionLabel)=>`Drag here to use column as ${dimensionLabel}`,
    chartsDragToValues: (valuesLabel)=>`Drag here to use column as ${valuesLabel}`,
    // AI Assistant panel
    aiAssistantPanelTitle: 'AI Assistant',
    aiAssistantPanelClose: 'Close AI Assistant',
    aiAssistantPanelNewConversation: 'New conversation',
    aiAssistantPanelConversationHistory: 'Conversation history',
    aiAssistantPanelEmptyConversation: 'No prompt history',
    aiAssistantSuggestions: 'Suggestions',
    // Prompt field
    promptFieldLabel: 'Prompt',
    promptFieldPlaceholder: "Type a prompt\u2026",
    promptFieldPlaceholderWithRecording: "Type or record a prompt\u2026",
    promptFieldPlaceholderListening: "Listening for prompt\u2026",
    promptFieldSpeechRecognitionNotSupported: 'Speech recognition is not supported in this browser',
    promptFieldSend: 'Send',
    promptFieldRecord: 'Record',
    promptFieldStopRecording: 'Stop recording',
    // Prompt
    promptRerun: 'Run again',
    promptProcessing: "Processing\u2026",
    promptAppliedChanges: 'Applied changes',
    // Prompt changes
    promptChangeGroupDescription: (column)=>`Group by ${column}`,
    promptChangeAggregationLabel: (column, aggregation)=>`${column} (${aggregation})`,
    promptChangeAggregationDescription: (column, aggregation)=>`Aggregate ${column} (${aggregation})`,
    promptChangeFilterLabel: (column, operator, value)=>{
        if (operator === 'is any of') return `${column} is any of: ${value}`;
        return `${column} ${operator} ${value}`;
    },
    promptChangeFilterDescription: (column, operator, value)=>{
        if (operator === 'is any of') return `Filter where ${column} is any of: ${value}`;
        return `Filter where ${column} ${operator} ${value}`;
    },
    promptChangeSortDescription: (column, direction)=>`Sort by ${column} (${direction})`,
    promptChangePivotEnableLabel: 'Pivot',
    promptChangePivotEnableDescription: 'Enable pivot',
    promptChangePivotColumnsLabel: (count)=>`Columns (${count})`,
    promptChangePivotColumnsDescription: (column, direction)=>`${column}${direction ? ` (${direction})` : ''}`,
    promptChangePivotRowsLabel: (count)=>`Rows (${count})`,
    promptChangePivotValuesLabel: (count)=>`Values (${count})`,
    promptChangePivotValuesDescription: (column, aggregation)=>`${column} (${aggregation})`,
    promptChangeChartsLabel: (dimensionsCount, valuesCount)=>`Dimensions (${dimensionsCount}), Values (${valuesCount})`
};


Object.keys($ce4677c59813cb05$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $553c2bbb14fa5500$exports && $553c2bbb14fa5500$exports[key] === $ce4677c59813cb05$exports[key]) return;
    Object.defineProperty($553c2bbb14fa5500$exports, key, {
        enumerable: true,
        get: function() {
            return $ce4677c59813cb05$exports[key];
        }
    });
});

var $5H1vo = parcelRequire("5H1vo");
Object.keys($5H1vo).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $553c2bbb14fa5500$exports && $553c2bbb14fa5500$exports[key] === $5H1vo[key]) return;
    Object.defineProperty($553c2bbb14fa5500$exports, key, {
        enumerable: true,
        get: function() {
            return $5H1vo[key];
        }
    });
});
var $dc886d040ec4e87c$exports = {};
"use strict";
Object.defineProperty($dc886d040ec4e87c$exports, "__esModule", {
    value: true
});
$dc886d040ec4e87c$exports.GridSignature = void 0;
/**
 * Signal to the underlying logic what version of the public component API
 * of the Data Grid is exposed.
 */ let $dc886d040ec4e87c$var$GridSignature = $dc886d040ec4e87c$exports.GridSignature = /*#__PURE__*/ function(GridSignature) {
    GridSignature["DataGrid"] = "DataGrid";
    GridSignature["DataGridPro"] = "DataGridPro";
    GridSignature["DataGridPremium"] = "DataGridPremium";
    return GridSignature;
}({});


Object.keys($dc886d040ec4e87c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $553c2bbb14fa5500$exports && $553c2bbb14fa5500$exports[key] === $dc886d040ec4e87c$exports[key]) return;
    Object.defineProperty($553c2bbb14fa5500$exports, key, {
        enumerable: true,
        get: function() {
            return $dc886d040ec4e87c$exports[key];
        }
    });
});



var $bDyDY = parcelRequire("bDyDY");
var $bc055d85bc2d0e70$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $bc055d85bc2d0e70$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($bc055d85bc2d0e70$exports, "__esModule", {
    value: true
});
$bc055d85bc2d0e70$exports.internal_registryContainer = void 0;
$bc055d85bc2d0e70$exports.unstable_resetCleanupTracking = $bc055d85bc2d0e70$var$unstable_resetCleanupTracking;
$bc055d85bc2d0e70$exports.useGridEvent = $bc055d85bc2d0e70$var$useGridEvent;
$bc055d85bc2d0e70$exports.useGridEventPriority = $bc055d85bc2d0e70$var$useGridEventPriority;

var $bc055d85bc2d0e70$var$React = $bc055d85bc2d0e70$require$_interopRequireWildcard((parcelRequire("acw62")));
var $551e6f5a35c0c62f$exports = {};
"use strict";
Object.defineProperty($551e6f5a35c0c62f$exports, "__esModule", {
    value: true
});
$551e6f5a35c0c62f$exports.TimerBasedCleanupTracking = void 0;
// If no effect ran after this amount of time, we assume that the render was not committed by React
const $551e6f5a35c0c62f$var$CLEANUP_TIMER_LOOP_MILLIS = 1000;
class $551e6f5a35c0c62f$var$TimerBasedCleanupTracking {
    timeouts = new Map();
    cleanupTimeout = $551e6f5a35c0c62f$var$CLEANUP_TIMER_LOOP_MILLIS;
    constructor(timeout = $551e6f5a35c0c62f$var$CLEANUP_TIMER_LOOP_MILLIS){
        this.cleanupTimeout = timeout;
    }
    register(object, unsubscribe, unregisterToken) {
        if (!this.timeouts) this.timeouts = new Map();
        const timeout = setTimeout(()=>{
            if (typeof unsubscribe === 'function') unsubscribe();
            this.timeouts.delete(unregisterToken.cleanupToken);
        }, this.cleanupTimeout);
        this.timeouts.set(unregisterToken.cleanupToken, timeout);
    }
    unregister(unregisterToken) {
        const timeout = this.timeouts.get(unregisterToken.cleanupToken);
        if (timeout) {
            this.timeouts.delete(unregisterToken.cleanupToken);
            clearTimeout(timeout);
        }
    }
    reset() {
        if (this.timeouts) {
            this.timeouts.forEach((value, key)=>{
                this.unregister({
                    cleanupToken: key
                });
            });
            this.timeouts = undefined;
        }
    }
}
$551e6f5a35c0c62f$exports.TimerBasedCleanupTracking = $551e6f5a35c0c62f$var$TimerBasedCleanupTracking;


var $c1aaf59f4b0a47d9$exports = {};
"use strict";
Object.defineProperty($c1aaf59f4b0a47d9$exports, "__esModule", {
    value: true
});
$c1aaf59f4b0a47d9$exports.FinalizationRegistryBasedCleanupTracking = void 0;
class $c1aaf59f4b0a47d9$var$FinalizationRegistryBasedCleanupTracking {
    registry = new FinalizationRegistry((unsubscribe)=>{
        if (typeof unsubscribe === 'function') unsubscribe();
    });
    register(object, unsubscribe, unregisterToken) {
        this.registry.register(object, unsubscribe, unregisterToken);
    }
    unregister(unregisterToken) {
        this.registry.unregister(unregisterToken);
    }
    reset() {}
}
$c1aaf59f4b0a47d9$exports.FinalizationRegistryBasedCleanupTracking = $c1aaf59f4b0a47d9$var$FinalizationRegistryBasedCleanupTracking;


// Based on https://github.com/Bnaya/use-dispose-uncommitted/blob/main/src/finalization-registry-based-impl.ts
// Check https://github.com/facebook/react/issues/15317 to get more information
// We use class to make it easier to detect in heap snapshots by name
class $bc055d85bc2d0e70$var$ObjectToBeRetainedByReact {
    static create() {
        return new $bc055d85bc2d0e70$var$ObjectToBeRetainedByReact();
    }
}
const $bc055d85bc2d0e70$var$registryContainer = {
    current: $bc055d85bc2d0e70$var$createRegistry()
};
let $bc055d85bc2d0e70$var$cleanupTokensCounter = 0;
function $bc055d85bc2d0e70$var$useGridEvent(apiRef, eventName, handler, options) {
    const objectRetainedByReact = $bc055d85bc2d0e70$var$React.useState($bc055d85bc2d0e70$var$ObjectToBeRetainedByReact.create)[0];
    const subscription = $bc055d85bc2d0e70$var$React.useRef(null);
    const handlerRef = $bc055d85bc2d0e70$var$React.useRef(null);
    handlerRef.current = handler;
    const cleanupTokenRef = $bc055d85bc2d0e70$var$React.useRef(null);
    if (!subscription.current && handlerRef.current) {
        const enhancedHandler = (params, event, details)=>{
            // Check for the existence of the event once more to avoid Safari 26 issue
            // https://github.com/mui/mui-x/issues/20159
            if (event && !event.defaultMuiPrevented) handlerRef.current?.(params, event, details);
        };
        subscription.current = apiRef.current.subscribeEvent(eventName, enhancedHandler, options);
        $bc055d85bc2d0e70$var$cleanupTokensCounter += 1;
        cleanupTokenRef.current = {
            cleanupToken: $bc055d85bc2d0e70$var$cleanupTokensCounter
        };
        $bc055d85bc2d0e70$var$registryContainer.current.register(objectRetainedByReact, // The callback below will be called once this reference stops being retained
        ()=>{
            subscription.current?.();
            subscription.current = null;
            cleanupTokenRef.current = null;
        }, cleanupTokenRef.current);
    } else if (!handlerRef.current && subscription.current) {
        subscription.current();
        subscription.current = null;
        if (cleanupTokenRef.current) {
            $bc055d85bc2d0e70$var$registryContainer.current.unregister(cleanupTokenRef.current);
            cleanupTokenRef.current = null;
        }
    }
    $bc055d85bc2d0e70$var$React.useEffect(()=>{
        if (!subscription.current && handlerRef.current) {
            const enhancedHandler = (params, event, details)=>{
                // Check for the existence of the event once more to avoid Safari 26 issue
                // https://github.com/mui/mui-x/issues/20159
                if (event && !event.defaultMuiPrevented) handlerRef.current?.(params, event, details);
            };
            subscription.current = apiRef.current.subscribeEvent(eventName, enhancedHandler, options);
        }
        if (cleanupTokenRef.current && $bc055d85bc2d0e70$var$registryContainer.current) {
            // If the effect was called, it means that this render was committed
            // so we can trust the cleanup function to remove the listener.
            $bc055d85bc2d0e70$var$registryContainer.current.unregister(cleanupTokenRef.current);
            cleanupTokenRef.current = null;
        }
        return ()=>{
            subscription.current?.();
            subscription.current = null;
        };
    }, [
        apiRef,
        eventName,
        options
    ]);
}
const $bc055d85bc2d0e70$var$OPTIONS_IS_FIRST = {
    isFirst: true
};
function $bc055d85bc2d0e70$var$useGridEventPriority(apiRef, eventName, handler) {
    $bc055d85bc2d0e70$var$useGridEvent(apiRef, eventName, handler, $bc055d85bc2d0e70$var$OPTIONS_IS_FIRST);
}
// TODO: move to @mui/x-data-grid/internals
// eslint-disable-next-line @typescript-eslint/naming-convention
function $bc055d85bc2d0e70$var$unstable_resetCleanupTracking() {
    $bc055d85bc2d0e70$var$registryContainer.current?.reset();
    $bc055d85bc2d0e70$var$registryContainer.current = $bc055d85bc2d0e70$var$createRegistry();
}
// eslint-disable-next-line @typescript-eslint/naming-convention
const $bc055d85bc2d0e70$var$internal_registryContainer = $bc055d85bc2d0e70$exports.internal_registryContainer = $bc055d85bc2d0e70$var$registryContainer;
function $bc055d85bc2d0e70$var$createRegistry() {
    return typeof FinalizationRegistry !== 'undefined' ? new $c1aaf59f4b0a47d9$exports.FinalizationRegistryBasedCleanupTracking() : new $551e6f5a35c0c62f$exports.TimerBasedCleanupTracking();
}



var $5sOMZ = parcelRequire("5sOMZ");

var $b611aad21a5b677d$exports = {};
"use strict";
Object.defineProperty($b611aad21a5b677d$exports, "__esModule", {
    value: true
});
$b611aad21a5b677d$exports.gridDensitySelector = $b611aad21a5b677d$exports.gridDensityFactorSelector = $b611aad21a5b677d$exports.COMPACT_DENSITY_FACTOR = $b611aad21a5b677d$exports.COMFORTABLE_DENSITY_FACTOR = void 0;

const $b611aad21a5b677d$var$COMPACT_DENSITY_FACTOR = $b611aad21a5b677d$exports.COMPACT_DENSITY_FACTOR = 0.7;
const $b611aad21a5b677d$var$COMFORTABLE_DENSITY_FACTOR = $b611aad21a5b677d$exports.COMFORTABLE_DENSITY_FACTOR = 1.3;
const $b611aad21a5b677d$var$DENSITY_FACTORS = {
    compact: $b611aad21a5b677d$var$COMPACT_DENSITY_FACTOR,
    comfortable: $b611aad21a5b677d$var$COMFORTABLE_DENSITY_FACTOR,
    standard: 1
};
const $b611aad21a5b677d$var$gridDensitySelector = $b611aad21a5b677d$exports.gridDensitySelector = (0, $8eef5f2af445e503$exports.createRootSelector)((state)=>state.density);
const $b611aad21a5b677d$var$gridDensityFactorSelector = $b611aad21a5b677d$exports.gridDensityFactorSelector = (0, $8eef5f2af445e503$exports.createSelector)($b611aad21a5b677d$var$gridDensitySelector, (density)=>$b611aad21a5b677d$var$DENSITY_FACTORS[density]);


var $3ede1456da2c476e$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3ede1456da2c476e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($3ede1456da2c476e$exports, "__esModule", {
    value: true
});
Object.defineProperty($3ede1456da2c476e$exports, "useTimeout", {
    enumerable: true,
    get: function() {
        return $3ede1456da2c476e$var$_useTimeout.default;
    }
});

var $3ede1456da2c476e$var$_useTimeout = $3ede1456da2c476e$require$_interopRequireDefault((parcelRequire("drY8V")));


var $d1cd1e3fd8558ad5$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d1cd1e3fd8558ad5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($d1cd1e3fd8558ad5$exports, "__esModule", {
    value: true
});
$d1cd1e3fd8558ad5$exports.applyInitialState = $d1cd1e3fd8558ad5$exports.COLUMNS_DIMENSION_PROPERTIES = void 0;
$d1cd1e3fd8558ad5$exports.computeFlexColumnsWidth = $d1cd1e3fd8558ad5$var$computeFlexColumnsWidth;
$d1cd1e3fd8558ad5$exports.createColumnsState = void 0;
$d1cd1e3fd8558ad5$exports.getDefaultColTypeDef = $d1cd1e3fd8558ad5$var$getDefaultColTypeDef;
$d1cd1e3fd8558ad5$exports.getFirstNonSpannedColumnToRender = $d1cd1e3fd8558ad5$var$getFirstNonSpannedColumnToRender;
$d1cd1e3fd8558ad5$exports.getTotalHeaderHeight = $d1cd1e3fd8558ad5$var$getTotalHeaderHeight;
$d1cd1e3fd8558ad5$exports.hydrateColumnsWidth = void 0;

var $d1cd1e3fd8558ad5$var$_extends2 = $d1cd1e3fd8558ad5$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $d1cd1e3fd8558ad5$var$_resolveProps = $d1cd1e3fd8558ad5$require$_interopRequireDefault((parcelRequire("7T9kw")));
var $a6506085715c5aff$exports = {};
"use strict";
Object.defineProperty($a6506085715c5aff$exports, "__esModule", {
    value: true
});
var $63c3e445c9bf0af1$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $63c3e445c9bf0af1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($63c3e445c9bf0af1$exports, "__esModule", {
    value: true
});
$63c3e445c9bf0af1$exports.GRID_ACTIONS_COL_DEF = $63c3e445c9bf0af1$exports.GRID_ACTIONS_COLUMN_TYPE = void 0;

var $63c3e445c9bf0af1$var$_extends2 = $63c3e445c9bf0af1$require$_interopRequireDefault((parcelRequire("3p9rK")));
var $8a69393405f257b1$exports = {};
"use strict";
Object.defineProperty($8a69393405f257b1$exports, "__esModule", {
    value: true
});
$8a69393405f257b1$exports.GRID_STRING_COL_DEF = void 0;
var $387abc8f0fc4c9a9$exports = {};
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $387abc8f0fc4c9a9$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $387abc8f0fc4c9a9$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($387abc8f0fc4c9a9$exports, "__esModule", {
    value: true
});
$387abc8f0fc4c9a9$exports.renderEditInputCell = $387abc8f0fc4c9a9$exports.GridEditInputCell = void 0;

var $387abc8f0fc4c9a9$var$_extends2 = $387abc8f0fc4c9a9$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $387abc8f0fc4c9a9$var$_objectWithoutPropertiesLoose2 = $387abc8f0fc4c9a9$require$_interopRequireDefault((parcelRequire("c05no")));

var $387abc8f0fc4c9a9$var$React = $387abc8f0fc4c9a9$require$_interopRequireWildcard((parcelRequire("acw62")));

var $387abc8f0fc4c9a9$var$_composeClasses = $387abc8f0fc4c9a9$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $387abc8f0fc4c9a9$var$_useEnhancedEffect = $387abc8f0fc4c9a9$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $8xDHs = parcelRequire("8xDHs");

var $fYxgT = parcelRequire("fYxgT");
var $dd66ac2a2c256d30$exports = {};
"use strict";
Object.defineProperty($dd66ac2a2c256d30$exports, "__esModule", {
    value: true
});
$dd66ac2a2c256d30$exports.NotRendered = $dd66ac2a2c256d30$var$NotRendered;
function $dd66ac2a2c256d30$var$NotRendered(_props) {
    throw new Error('Failed assertion: should not be rendered');
}



var $hbuUJ = parcelRequire("hbuUJ");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $bDyDY = parcelRequire("bDyDY");

var $ayMG0 = parcelRequire("ayMG0");
const $387abc8f0fc4c9a9$var$_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "tabIndex",
    "hasFocus",
    "isValidating",
    "debounceMs",
    "isProcessingProps",
    "onValueChange",
    "slotProps"
];
const $387abc8f0fc4c9a9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'editInputCell'
        ]
    };
    return (0, $387abc8f0fc4c9a9$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $387abc8f0fc4c9a9$var$GridEditInputCellRoot = (0, $8xDHs.styled)($dd66ac2a2c256d30$exports.NotRendered, {
    name: 'MuiDataGrid',
    slot: 'EditInputCell'
})({
    font: $hbuUJ.vars.typography.font.body,
    padding: '1px 0',
    '& input': {
        padding: '0 16px',
        height: '100%'
    }
});
const $387abc8f0fc4c9a9$var$GridEditInputCell = $387abc8f0fc4c9a9$exports.GridEditInputCell = (0, $fYxgT.forwardRef)((props, ref)=>{
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const { id: id, value: value, field: field, colDef: colDef, hasFocus: hasFocus, debounceMs: debounceMs = 200, isProcessingProps: isProcessingProps, onValueChange: onValueChange, slotProps: slotProps } = props, other = (0, $387abc8f0fc4c9a9$var$_objectWithoutPropertiesLoose2.default)(props, $387abc8f0fc4c9a9$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const inputRef = $387abc8f0fc4c9a9$var$React.useRef(null);
    const [valueState, setValueState] = $387abc8f0fc4c9a9$var$React.useState(value);
    const classes = $387abc8f0fc4c9a9$var$useUtilityClasses(rootProps);
    const handleChange = $387abc8f0fc4c9a9$var$React.useCallback(async (event)=>{
        const newValue = event.target.value;
        const column = apiRef.current.getColumn(field);
        let parsedValue = newValue;
        if (column.valueParser) parsedValue = column.valueParser(newValue, apiRef.current.getRow(id), column, apiRef);
        setValueState(parsedValue);
        apiRef.current.setEditCellValue({
            id: id,
            field: field,
            value: parsedValue,
            debounceMs: debounceMs,
            unstable_skipValueParser: true
        }, event);
        if (onValueChange) await onValueChange(event, newValue);
    }, [
        apiRef,
        debounceMs,
        field,
        id,
        onValueChange
    ]);
    const meta = apiRef.current.unstable_getEditCellMeta(id, field);
    $387abc8f0fc4c9a9$var$React.useEffect(()=>{
        if (meta?.changeReason !== 'debouncedSetEditCellValue') setValueState(value);
    }, [
        meta,
        value
    ]);
    (0, $387abc8f0fc4c9a9$var$_useEnhancedEffect.default)(()=>{
        if (hasFocus) inputRef.current.focus();
    }, [
        hasFocus
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($387abc8f0fc4c9a9$var$GridEditInputCellRoot, (0, $387abc8f0fc4c9a9$var$_extends2.default)({
        as: rootProps.slots.baseInput,
        inputRef: inputRef,
        className: classes.root,
        ownerState: rootProps,
        fullWidth: true,
        type: colDef.type === 'number' ? colDef.type : 'text',
        value: valueState ?? '',
        onChange: handleChange,
        endAdornment: isProcessingProps ? /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.loadIcon, {
            fontSize: "small",
            color: "action"
        }) : undefined
    }, other, slotProps?.root, {
        ref: ref
    }));
});
$387abc8f0fc4c9a9$var$GridEditInputCell.displayName = "GridEditInputCell";
const $387abc8f0fc4c9a9$var$renderEditInputCell = (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)($387abc8f0fc4c9a9$var$GridEditInputCell, (0, $387abc8f0fc4c9a9$var$_extends2.default)({}, params));
$387abc8f0fc4c9a9$exports.renderEditInputCell = $387abc8f0fc4c9a9$var$renderEditInputCell;
$387abc8f0fc4c9a9$var$renderEditInputCell.displayName = "renderEditInputCell";


var $c78f90aae54b126e$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c78f90aae54b126e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($c78f90aae54b126e$exports, "__esModule", {
    value: true
});
$c78f90aae54b126e$exports.sanitizeSortModel = $c78f90aae54b126e$exports.mergeStateWithSortModel = $c78f90aae54b126e$exports.gridStringOrNumberComparator = $c78f90aae54b126e$exports.gridNumberComparator = $c78f90aae54b126e$exports.gridDateComparator = $c78f90aae54b126e$exports.getNextGridSortDirection = $c78f90aae54b126e$exports.buildAggregatedSortingApplier = void 0;

var $c78f90aae54b126e$var$_extends2 = $c78f90aae54b126e$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $9Y8Cp = parcelRequire("9Y8Cp");

const $c78f90aae54b126e$var$sanitizeSortModel = (model, disableMultipleColumnsSorting)=>{
    if (disableMultipleColumnsSorting && model.length > 1) {
        (0, $9Y8Cp.warnOnce)([
            'MUI X: The `sortModel` can only contain a single item when the `disableMultipleColumnsSorting` prop is set to `true`.',
            'If you are using the community version of the Data Grid, this prop is always `true`.'
        ], 'error');
        return [
            model[0]
        ];
    }
    return model;
};
$c78f90aae54b126e$exports.sanitizeSortModel = $c78f90aae54b126e$var$sanitizeSortModel;
const $c78f90aae54b126e$var$mergeStateWithSortModel = (sortModel, disableMultipleColumnsSorting)=>(state)=>(0, $c78f90aae54b126e$var$_extends2.default)({}, state, {
            sorting: (0, $c78f90aae54b126e$var$_extends2.default)({}, state.sorting, {
                sortModel: $c78f90aae54b126e$var$sanitizeSortModel(sortModel, disableMultipleColumnsSorting)
            })
        });
$c78f90aae54b126e$exports.mergeStateWithSortModel = $c78f90aae54b126e$var$mergeStateWithSortModel;
const $c78f90aae54b126e$var$isDesc = (direction)=>direction === 'desc';
/**
 * @name sortValueGetter
 * @param {GridRowId} id The id of the row.
 * @param {string} field The field to sort by.
 *
 * Transform an item of the sorting model into a method comparing two rows.
 * @param {GridSortItem} sortItem The sort item we want to apply.
 * @param {RefObject<GridApiCommunity>} apiRef The API of the grid.
 * @returns {GridParsedSortItem | null} The parsed sort item. Returns `null` is the sort item is not valid.
 */ const $c78f90aae54b126e$var$parseSortItem = (sortItem, apiRef)=>{
    const column = apiRef.current.getColumn(sortItem.field);
    if (!column || sortItem.sort === null) return null;
    let comparator;
    if (column.getSortComparator) comparator = column.getSortComparator(sortItem.sort);
    else comparator = $c78f90aae54b126e$var$isDesc(sortItem.sort) ? (...args)=>-1 * column.sortComparator(...args) : column.sortComparator;
    if (!comparator) return null;
    const getSortCellParams = (id)=>({
            id: id,
            field: column.field,
            rowNode: (0, $befccaa56b49492d$exports.gridRowNodeSelector)(apiRef, id),
            value: apiRef.current.getCellValue(id, column.field),
            api: apiRef.current
        });
    return {
        getSortCellParams: getSortCellParams,
        comparator: comparator
    };
};
/**
 * Compare two rows according to a list of valid sort items.
 * The `row1Params` and `row2Params` must have the same length as `parsedSortItems`,
 * and each of their index must contain the `GridSortCellParams` of the sort item with the same index.
 * @param {GridParsedSortItem[]} parsedSortItems All the sort items with which we want to compare the rows.
 * @param {GridRowAggregatedSortingParams} row1 The node and params of the 1st row for each sort item.
 * @param {GridRowAggregatedSortingParams} row2 The node and params of the 2nd row for each sort item.
 */ const $c78f90aae54b126e$var$compareRows = (parsedSortItems, row1, row2)=>{
    return parsedSortItems.reduce((res, item, index)=>{
        if (res !== 0) // return the results of the first comparator which distinguish the two rows
        return res;
        const sortCellParams1 = row1.params[index];
        const sortCellParams2 = row2.params[index];
        res = item.comparator(sortCellParams1.value, sortCellParams2.value, sortCellParams1, sortCellParams2);
        return res;
    }, 0);
};
/**
 * Generates a method to easily sort a list of rows according to the current sort model.
 * @param {GridSortModel} sortModel The model with which we want to sort the rows.
 * @param {RefObject<GridApiCommunity>} apiRef The API of the grid.
 * @returns {GridSortingModelApplier | null} A method that generates a list of sorted row ids from a list of rows according to the current sort model. If `null`, we consider that the rows should remain in the order there were provided.
 */ const $c78f90aae54b126e$var$buildAggregatedSortingApplier = (sortModel, apiRef)=>{
    const comparatorList = sortModel.map((item)=>$c78f90aae54b126e$var$parseSortItem(item, apiRef)).filter((comparator)=>!!comparator);
    if (comparatorList.length === 0) return null;
    return (rowList)=>rowList.map((node)=>({
                node: node,
                params: comparatorList.map((el)=>el.getSortCellParams(node.id))
            })).sort((a, b)=>$c78f90aae54b126e$var$compareRows(comparatorList, a, b)).map((row)=>row.node.id);
};
$c78f90aae54b126e$exports.buildAggregatedSortingApplier = $c78f90aae54b126e$var$buildAggregatedSortingApplier;
const $c78f90aae54b126e$var$getNextGridSortDirection = (sortingOrder, current)=>{
    const currentIdx = sortingOrder.indexOf(current);
    if (!current || currentIdx === -1 || currentIdx + 1 === sortingOrder.length) return sortingOrder[0];
    return sortingOrder[currentIdx + 1];
};
$c78f90aae54b126e$exports.getNextGridSortDirection = $c78f90aae54b126e$var$getNextGridSortDirection;
const $c78f90aae54b126e$var$gridNillComparator = (v1, v2)=>{
    if (v1 == null && v2 != null) return -1;
    if (v2 == null && v1 != null) return 1;
    if (v1 == null && v2 == null) return 0;
    return null;
};
const $c78f90aae54b126e$var$collator = new Intl.Collator();
const $c78f90aae54b126e$var$gridStringOrNumberComparator = (value1, value2)=>{
    const nillResult = $c78f90aae54b126e$var$gridNillComparator(value1, value2);
    if (nillResult !== null) return nillResult;
    if (typeof value1 === 'string') return $c78f90aae54b126e$var$collator.compare(value1.toString(), value2.toString());
    return value1 - value2;
};
$c78f90aae54b126e$exports.gridStringOrNumberComparator = $c78f90aae54b126e$var$gridStringOrNumberComparator;
const $c78f90aae54b126e$var$gridNumberComparator = (value1, value2)=>{
    const nillResult = $c78f90aae54b126e$var$gridNillComparator(value1, value2);
    if (nillResult !== null) return nillResult;
    return Number(value1) - Number(value2);
};
$c78f90aae54b126e$exports.gridNumberComparator = $c78f90aae54b126e$var$gridNumberComparator;
const $c78f90aae54b126e$var$gridDateComparator = (value1, value2)=>{
    const nillResult = $c78f90aae54b126e$var$gridNillComparator(value1, value2);
    if (nillResult !== null) return nillResult;
    if (value1 > value2) return 1;
    if (value1 < value2) return -1;
    return 0;
};
$c78f90aae54b126e$exports.gridDateComparator = $c78f90aae54b126e$var$gridDateComparator;


var $ced5632839836707$exports = {};
"use strict";
Object.defineProperty($ced5632839836707$exports, "__esModule", {
    value: true
});
$ced5632839836707$exports.getGridStringQuickFilterFn = $ced5632839836707$exports.getGridStringOperators = void 0;
var $bbbaea9771a9f69f$exports = {};
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $bbbaea9771a9f69f$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $bbbaea9771a9f69f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($bbbaea9771a9f69f$exports, "__esModule", {
    value: true
});
$bbbaea9771a9f69f$exports.GridFilterInputValue = $bbbaea9771a9f69f$var$GridFilterInputValue;

var $bbbaea9771a9f69f$var$_extends2 = $bbbaea9771a9f69f$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $bbbaea9771a9f69f$var$_objectWithoutPropertiesLoose2 = $bbbaea9771a9f69f$require$_interopRequireDefault((parcelRequire("c05no")));

var $bbbaea9771a9f69f$var$React = $bbbaea9771a9f69f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $bbbaea9771a9f69f$var$_propTypes = $bbbaea9771a9f69f$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $bbbaea9771a9f69f$var$_useId = $bbbaea9771a9f69f$require$_interopRequireDefault((parcelRequire("hwliF")));


var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $bbbaea9771a9f69f$var$_excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "tabIndex",
    "disabled",
    "isFilterActive",
    "slotProps",
    "clearButton",
    "headerFilterMenu"
];
function $bbbaea9771a9f69f$var$GridFilterInputValue(props) {
    const { item: item, applyValue: applyValue, type: type, apiRef: apiRef, focusElementRef: focusElementRef, tabIndex: tabIndex, disabled: disabled, slotProps: slotProps, clearButton: clearButton, headerFilterMenu: headerFilterMenu } = props, other = (0, $bbbaea9771a9f69f$var$_objectWithoutPropertiesLoose2.default)(props, $bbbaea9771a9f69f$var$_excluded);
    const textFieldProps = slotProps?.root;
    const filterTimeout = (0, $3ede1456da2c476e$exports.useTimeout)();
    const [filterValueState, setFilterValueState] = $bbbaea9771a9f69f$var$React.useState($bbbaea9771a9f69f$var$sanitizeFilterItemValue(item.value));
    const [applying, setIsApplying] = $bbbaea9771a9f69f$var$React.useState(false);
    const id = (0, $bbbaea9771a9f69f$var$_useId.default)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const onFilterChange = $bbbaea9771a9f69f$var$React.useCallback((event)=>{
        const value = $bbbaea9771a9f69f$var$sanitizeFilterItemValue(event.target.value);
        setFilterValueState(value);
        setIsApplying(true);
        filterTimeout.start(rootProps.filterDebounceMs, ()=>{
            const newItem = (0, $bbbaea9771a9f69f$var$_extends2.default)({}, item, {
                value: type === 'number' && !Number.isNaN(Number(value)) ? Number(value) : value,
                fromInput: id
            });
            applyValue(newItem);
            setIsApplying(false);
        });
    }, [
        filterTimeout,
        rootProps.filterDebounceMs,
        item,
        type,
        id,
        applyValue
    ]);
    $bbbaea9771a9f69f$var$React.useEffect(()=>{
        const itemPlusTag = item;
        if (itemPlusTag.fromInput !== id || item.value == null) setFilterValueState($bbbaea9771a9f69f$var$sanitizeFilterItemValue(item.value));
    }, [
        id,
        item
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($bbbaea9771a9f69f$var$React.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTextField, (0, $bbbaea9771a9f69f$var$_extends2.default)({
                id: id,
                label: apiRef.current.getLocaleText('filterPanelInputLabel'),
                placeholder: apiRef.current.getLocaleText('filterPanelInputPlaceholder'),
                value: filterValueState ?? '',
                onChange: onFilterChange,
                type: type || 'text',
                disabled: disabled,
                slotProps: (0, $bbbaea9771a9f69f$var$_extends2.default)({}, textFieldProps?.slotProps, {
                    input: (0, $bbbaea9771a9f69f$var$_extends2.default)({
                        endAdornment: applying ? /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.loadIcon, {
                            fontSize: "small",
                            color: "action"
                        }) : null
                    }, textFieldProps?.slotProps?.input),
                    htmlInput: (0, $bbbaea9771a9f69f$var$_extends2.default)({
                        tabIndex: tabIndex
                    }, textFieldProps?.slotProps?.htmlInput)
                }),
                inputRef: focusElementRef
            }, rootProps.slotProps?.baseTextField, other, textFieldProps)),
            headerFilterMenu,
            clearButton
        ]
    });
}
function $bbbaea9771a9f69f$var$sanitizeFilterItemValue(value) {
    if (value == null || value === '') return undefined;
    return String(value);
}
$bbbaea9771a9f69f$var$GridFilterInputValue.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    apiRef: $bbbaea9771a9f69f$var$_propTypes.default.shape({
        current: $bbbaea9771a9f69f$var$_propTypes.default.object.isRequired
    }).isRequired,
    applyValue: $bbbaea9771a9f69f$var$_propTypes.default.func.isRequired,
    className: $bbbaea9771a9f69f$var$_propTypes.default.string,
    clearButton: $bbbaea9771a9f69f$var$_propTypes.default.node,
    disabled: $bbbaea9771a9f69f$var$_propTypes.default.bool,
    focusElementRef: $bbbaea9771a9f69f$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $bbbaea9771a9f69f$var$_propTypes.default.func,
        $bbbaea9771a9f69f$var$_propTypes.default.object
    ]),
    headerFilterMenu: $bbbaea9771a9f69f$var$_propTypes.default.node,
    inputRef: $bbbaea9771a9f69f$var$_propTypes.default.oneOfType([
        $bbbaea9771a9f69f$var$_propTypes.default.func,
        $bbbaea9771a9f69f$var$_propTypes.default.shape({
            current: (props, propName)=>{
                if (props[propName] == null) return null;
                if (typeof props[propName] !== 'object' || props[propName].nodeType !== 1) return new Error(`Expected prop '${propName}' to be of type Element`);
                return null;
            }
        })
    ]),
    /**
   * It is `true` if the filter either has a value or an operator with no value
   * required is selected (for example `isEmpty`)
   */ isFilterActive: $bbbaea9771a9f69f$var$_propTypes.default.bool,
    item: $bbbaea9771a9f69f$var$_propTypes.default.shape({
        field: $bbbaea9771a9f69f$var$_propTypes.default.string.isRequired,
        id: $bbbaea9771a9f69f$var$_propTypes.default.oneOfType([
            $bbbaea9771a9f69f$var$_propTypes.default.number,
            $bbbaea9771a9f69f$var$_propTypes.default.string
        ]),
        operator: $bbbaea9771a9f69f$var$_propTypes.default.string.isRequired,
        value: $bbbaea9771a9f69f$var$_propTypes.default.any
    }).isRequired,
    onBlur: $bbbaea9771a9f69f$var$_propTypes.default.func,
    onFocus: $bbbaea9771a9f69f$var$_propTypes.default.func,
    slotProps: $bbbaea9771a9f69f$var$_propTypes.default.object,
    tabIndex: $bbbaea9771a9f69f$var$_propTypes.default.number,
    type: $bbbaea9771a9f69f$var$_propTypes.default.oneOf([
        'date',
        'datetime-local',
        'number',
        'text'
    ])
};


var $fe919794eb3b24e8$exports = {};
"use strict";
Object.defineProperty($fe919794eb3b24e8$exports, "__esModule", {
    value: true
});
$fe919794eb3b24e8$exports.clamp = void 0;
$fe919794eb3b24e8$exports.createRandomNumberGenerator = $fe919794eb3b24e8$var$createRandomNumberGenerator;
$fe919794eb3b24e8$exports.deepClone = $fe919794eb3b24e8$var$deepClone;
$fe919794eb3b24e8$exports.escapeRegExp = $fe919794eb3b24e8$var$escapeRegExp;
$fe919794eb3b24e8$exports.eslintUseValue = $fe919794eb3b24e8$var$eslintUseValue;
$fe919794eb3b24e8$exports.isFunction = $fe919794eb3b24e8$var$isFunction;
$fe919794eb3b24e8$exports.isNumber = $fe919794eb3b24e8$var$isNumber;
$fe919794eb3b24e8$exports.isObject = $fe919794eb3b24e8$var$isObject;
$fe919794eb3b24e8$exports.localStorageAvailable = $fe919794eb3b24e8$var$localStorageAvailable;
$fe919794eb3b24e8$exports.range = $fe919794eb3b24e8$var$range;
$fe919794eb3b24e8$exports.runIf = void 0;
function $fe919794eb3b24e8$var$isNumber(value) {
    return typeof value === 'number' && !Number.isNaN(value);
}
function $fe919794eb3b24e8$var$isFunction(value) {
    return typeof value === 'function';
}
function $fe919794eb3b24e8$var$isObject(value) {
    return typeof value === 'object' && value !== null;
}
function $fe919794eb3b24e8$var$localStorageAvailable() {
    try {
        // Incognito mode might reject access to the localStorage for security reasons.
        // window isn't defined on Node.js
        // https://stackoverflow.com/questions/16427636/check-if-localstorage-is-available
        const key = '__some_random_key_you_are_not_going_to_use__';
        window.localStorage.setItem(key, key);
        window.localStorage.removeItem(key);
        return true;
    } catch (err) {
        return false;
    }
}
function $fe919794eb3b24e8$var$escapeRegExp(value) {
    return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}
/**
 * Follows the CSS specification behavior for min and max
 * If min > max, then the min have priority
 */ const $fe919794eb3b24e8$var$clamp = (value, min, max)=>Math.max(min, Math.min(max, value));
/**
 * Create an array containing the range [from, to[
 */ $fe919794eb3b24e8$exports.clamp = $fe919794eb3b24e8$var$clamp;
function $fe919794eb3b24e8$var$range(from, to) {
    return Array.from({
        length: to - from
    }).map((_, i)=>from + i);
}
// Pseudo random number. See https://stackoverflow.com/a/47593316
function $fe919794eb3b24e8$var$mulberry32(a) {
    return ()=>{
        /* eslint-disable */ let t = a += 0x6d2b79f5;
        t = Math.imul(t ^ t >>> 15, t | 1);
        t ^= t + Math.imul(t ^ t >>> 7, t | 61);
        return ((t ^ t >>> 14) >>> 0) / 4294967296;
    /* eslint-enable */ };
}
/**
 * Create a random number generator from a seed. The seed
 * ensures that the random number generator produces the
 * same sequence of 'random' numbers on every render. It
 * returns a function that generates a random number between
 * a specified min and max.
 */ function $fe919794eb3b24e8$var$createRandomNumberGenerator(seed) {
    const random = $fe919794eb3b24e8$var$mulberry32(seed);
    return (min, max)=>min + (max - min) * random();
}
function $fe919794eb3b24e8$var$deepClone(obj) {
    if (typeof structuredClone === 'function') return structuredClone(obj);
    return JSON.parse(JSON.stringify(obj));
}
/**
 * Mark a value as used so eslint doesn't complain. Use this instead
 * of a `eslint-disable-next-line react-hooks/exhaustive-deps` because
 * that hint disables checks on all values instead of just one.
 */ function $fe919794eb3b24e8$var$eslintUseValue(_) {}
const $fe919794eb3b24e8$var$runIf = (condition, fn)=>(params)=>{
        if (condition) fn(params);
    };
$fe919794eb3b24e8$exports.runIf = $fe919794eb3b24e8$var$runIf;


var $4b64102825ff1e40$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $4b64102825ff1e40$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $4b64102825ff1e40$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($4b64102825ff1e40$exports, "__esModule", {
    value: true
});
$4b64102825ff1e40$exports.GridFilterInputMultipleValue = $4b64102825ff1e40$var$GridFilterInputMultipleValue;

var $4b64102825ff1e40$var$_extends2 = $4b64102825ff1e40$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $4b64102825ff1e40$var$React = $4b64102825ff1e40$require$_interopRequireWildcard((parcelRequire("acw62")));

var $4b64102825ff1e40$var$_propTypes = $4b64102825ff1e40$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $4b64102825ff1e40$var$_useId = $4b64102825ff1e40$require$_interopRequireDefault((parcelRequire("hwliF")));

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
function $4b64102825ff1e40$var$GridFilterInputMultipleValue(props) {
    const { item: item, applyValue: applyValue, type: type, apiRef: apiRef, focusElementRef: focusElementRef, slotProps: slotProps } = props;
    const id = (0, $4b64102825ff1e40$var$_useId.default)();
    const [options, setOptions] = $4b64102825ff1e40$var$React.useState([]);
    const [filterValueState, setFilterValueState] = $4b64102825ff1e40$var$React.useState(item.value || []);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    $4b64102825ff1e40$var$React.useEffect(()=>{
        const itemValue = item.value ?? [];
        setFilterValueState(itemValue.map(String));
    }, [
        item.value
    ]);
    const handleChange = $4b64102825ff1e40$var$React.useCallback((event, value)=>{
        setFilterValueState(value.map(String));
        applyValue((0, $4b64102825ff1e40$var$_extends2.default)({}, item, {
            value: [
                ...value.map((filterItemValue)=>type === 'number' ? Number(filterItemValue) : filterItemValue)
            ]
        }));
    }, [
        applyValue,
        item,
        type
    ]);
    const handleInputChange = $4b64102825ff1e40$var$React.useCallback((event, value)=>{
        if (value === '') setOptions([]);
        else setOptions([
            value
        ]);
    }, [
        setOptions
    ]);
    const BaseAutocomplete = rootProps.slots.baseAutocomplete;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(BaseAutocomplete, (0, $4b64102825ff1e40$var$_extends2.default)({
        multiple: true,
        freeSolo: true,
        options: options,
        id: id,
        value: filterValueState,
        onChange: handleChange,
        onInputChange: handleInputChange,
        label: apiRef.current.getLocaleText('filterPanelInputLabel'),
        placeholder: apiRef.current.getLocaleText('filterPanelInputPlaceholder'),
        slotProps: {
            textField: {
                type: type || 'text',
                inputRef: focusElementRef
            }
        }
    }, slotProps?.root));
}
$4b64102825ff1e40$var$GridFilterInputMultipleValue.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    apiRef: $4b64102825ff1e40$var$_propTypes.default.shape({
        current: $4b64102825ff1e40$var$_propTypes.default.object.isRequired
    }).isRequired,
    applyValue: $4b64102825ff1e40$var$_propTypes.default.func.isRequired,
    className: $4b64102825ff1e40$var$_propTypes.default.string,
    clearButton: $4b64102825ff1e40$var$_propTypes.default.node,
    disabled: $4b64102825ff1e40$var$_propTypes.default.bool,
    focusElementRef: $4b64102825ff1e40$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $4b64102825ff1e40$var$_propTypes.default.func,
        $4b64102825ff1e40$var$_propTypes.default.object
    ]),
    headerFilterMenu: $4b64102825ff1e40$var$_propTypes.default.node,
    inputRef: $4b64102825ff1e40$var$_propTypes.default.oneOfType([
        $4b64102825ff1e40$var$_propTypes.default.func,
        $4b64102825ff1e40$var$_propTypes.default.shape({
            current: (props, propName)=>{
                if (props[propName] == null) return null;
                if (typeof props[propName] !== 'object' || props[propName].nodeType !== 1) return new Error(`Expected prop '${propName}' to be of type Element`);
                return null;
            }
        })
    ]),
    /**
   * It is `true` if the filter either has a value or an operator with no value
   * required is selected (for example `isEmpty`)
   */ isFilterActive: $4b64102825ff1e40$var$_propTypes.default.bool,
    item: $4b64102825ff1e40$var$_propTypes.default.shape({
        field: $4b64102825ff1e40$var$_propTypes.default.string.isRequired,
        id: $4b64102825ff1e40$var$_propTypes.default.oneOfType([
            $4b64102825ff1e40$var$_propTypes.default.number,
            $4b64102825ff1e40$var$_propTypes.default.string
        ]),
        operator: $4b64102825ff1e40$var$_propTypes.default.string.isRequired,
        value: $4b64102825ff1e40$var$_propTypes.default.any
    }).isRequired,
    onBlur: $4b64102825ff1e40$var$_propTypes.default.func,
    onFocus: $4b64102825ff1e40$var$_propTypes.default.func,
    slotProps: $4b64102825ff1e40$var$_propTypes.default.object,
    tabIndex: $4b64102825ff1e40$var$_propTypes.default.number,
    type: $4b64102825ff1e40$var$_propTypes.default.oneOf([
        'date',
        'datetime-local',
        'number',
        'text'
    ])
};


var $0c70cf7c1343c218$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0c70cf7c1343c218$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($0c70cf7c1343c218$exports, "__esModule", {
    value: true
});
$0c70cf7c1343c218$exports.shouldQuickFilterExcludeHiddenColumns = $0c70cf7c1343c218$exports.sanitizeFilterModel = $0c70cf7c1343c218$exports.removeDiacritics = $0c70cf7c1343c218$exports.passFilterLogic = $0c70cf7c1343c218$exports.mergeStateWithFilterModel = $0c70cf7c1343c218$exports.cleanFilterItem = $0c70cf7c1343c218$exports.buildAggregatedFilterApplier = void 0;

var $0c70cf7c1343c218$var$_extends2 = $0c70cf7c1343c218$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $9Y8Cp = parcelRequire("9Y8Cp");
var $2f20061a3ca46e99$exports = {};
"use strict";
Object.defineProperty($2f20061a3ca46e99$exports, "__esModule", {
    value: true
});
var $2f20061a3ca46e99$var$_exportNames = {
    createRowSelectionManager: true
};
Object.defineProperty($2f20061a3ca46e99$exports, "createRowSelectionManager", {
    enumerable: true,
    get: function() {
        return $8ee7986d138c7e40$exports.createRowSelectionManager;
    }
});
var $43116f7faa183b71$exports = {};
"use strict";
Object.defineProperty($43116f7faa183b71$exports, "__esModule", {
    value: true
});
var $9d4f7b5ae12246fc$exports = {};
"use strict";
Object.defineProperty($9d4f7b5ae12246fc$exports, "__esModule", {
    value: true
});


Object.keys($9d4f7b5ae12246fc$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $43116f7faa183b71$exports && $43116f7faa183b71$exports[key] === $9d4f7b5ae12246fc$exports[key]) return;
    Object.defineProperty($43116f7faa183b71$exports, key, {
        enumerable: true,
        get: function() {
            return $9d4f7b5ae12246fc$exports[key];
        }
    });
});
var $f4fd13e0ad11ce19$exports = {};
"use strict";
Object.defineProperty($f4fd13e0ad11ce19$exports, "__esModule", {
    value: true
});


Object.keys($f4fd13e0ad11ce19$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $43116f7faa183b71$exports && $43116f7faa183b71$exports[key] === $f4fd13e0ad11ce19$exports[key]) return;
    Object.defineProperty($43116f7faa183b71$exports, key, {
        enumerable: true,
        get: function() {
            return $f4fd13e0ad11ce19$exports[key];
        }
    });
});


Object.keys($43116f7faa183b71$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in $2f20061a3ca46e99$exports && $2f20061a3ca46e99$exports[key] === $43116f7faa183b71$exports[key]) return;
    Object.defineProperty($2f20061a3ca46e99$exports, key, {
        enumerable: true,
        get: function() {
            return $43116f7faa183b71$exports[key];
        }
    });
});
var $d916f0309fd6dde2$exports = {};
"use strict";
Object.defineProperty($d916f0309fd6dde2$exports, "__esModule", {
    value: true
});


Object.keys($d916f0309fd6dde2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in $2f20061a3ca46e99$exports && $2f20061a3ca46e99$exports[key] === $d916f0309fd6dde2$exports[key]) return;
    Object.defineProperty($2f20061a3ca46e99$exports, key, {
        enumerable: true,
        get: function() {
            return $d916f0309fd6dde2$exports[key];
        }
    });
});
var $656ff6ccf1bf5f37$exports = {};
"use strict";
Object.defineProperty($656ff6ccf1bf5f37$exports, "__esModule", {
    value: true
});


Object.keys($656ff6ccf1bf5f37$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in $2f20061a3ca46e99$exports && $2f20061a3ca46e99$exports[key] === $656ff6ccf1bf5f37$exports[key]) return;
    Object.defineProperty($2f20061a3ca46e99$exports, key, {
        enumerable: true,
        get: function() {
            return $656ff6ccf1bf5f37$exports[key];
        }
    });
});
var $e139707caeafbfd6$exports = {};
"use strict";
Object.defineProperty($e139707caeafbfd6$exports, "__esModule", {
    value: true
});
$e139707caeafbfd6$exports.GridRowModes = $e139707caeafbfd6$exports.GridEditModes = $e139707caeafbfd6$exports.GridCellModes = void 0;
var $e139707caeafbfd6$var$GridEditModes = $e139707caeafbfd6$exports.GridEditModes = /*#__PURE__*/ function(GridEditModes) {
    GridEditModes["Cell"] = "cell";
    GridEditModes["Row"] = "row";
    return GridEditModes;
}($e139707caeafbfd6$var$GridEditModes || {});
var $e139707caeafbfd6$var$GridCellModes = $e139707caeafbfd6$exports.GridCellModes = /*#__PURE__*/ function(GridCellModes) {
    GridCellModes["Edit"] = "edit";
    GridCellModes["View"] = "view";
    return GridCellModes;
}($e139707caeafbfd6$var$GridCellModes || {});
var $e139707caeafbfd6$var$GridRowModes = $e139707caeafbfd6$exports.GridRowModes = /*#__PURE__*/ function(GridRowModes) {
    GridRowModes["Edit"] = "edit";
    GridRowModes["View"] = "view";
    return GridRowModes;
}($e139707caeafbfd6$var$GridRowModes || {});


Object.keys($e139707caeafbfd6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in $2f20061a3ca46e99$exports && $2f20061a3ca46e99$exports[key] === $e139707caeafbfd6$exports[key]) return;
    Object.defineProperty($2f20061a3ca46e99$exports, key, {
        enumerable: true,
        get: function() {
            return $e139707caeafbfd6$exports[key];
        }
    });
});
var $c95f68e3b0b98101$exports = {};
"use strict";
Object.defineProperty($c95f68e3b0b98101$exports, "__esModule", {
    value: true
});


Object.keys($c95f68e3b0b98101$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in $2f20061a3ca46e99$exports && $2f20061a3ca46e99$exports[key] === $c95f68e3b0b98101$exports[key]) return;
    Object.defineProperty($2f20061a3ca46e99$exports, key, {
        enumerable: true,
        get: function() {
            return $c95f68e3b0b98101$exports[key];
        }
    });
});
var $6c940a0517b1c6d5$exports = {};
"use strict";
Object.defineProperty($6c940a0517b1c6d5$exports, "__esModule", {
    value: true
});
$6c940a0517b1c6d5$exports.GridLogicOperator = void 0;
/**
 * Filter item definition interface.
 * @demos
 *   - [Custom filter operator](/x/react-data-grid/filtering/customization/#create-a-custom-operator)
 */ var $6c940a0517b1c6d5$var$GridLogicOperator = $6c940a0517b1c6d5$exports.GridLogicOperator = /*#__PURE__*/ function(GridLogicOperator) {
    GridLogicOperator["And"] = "and";
    GridLogicOperator["Or"] = "or";
    return GridLogicOperator;
}($6c940a0517b1c6d5$var$GridLogicOperator || {});


Object.keys($6c940a0517b1c6d5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in $2f20061a3ca46e99$exports && $2f20061a3ca46e99$exports[key] === $6c940a0517b1c6d5$exports[key]) return;
    Object.defineProperty($2f20061a3ca46e99$exports, key, {
        enumerable: true,
        get: function() {
            return $6c940a0517b1c6d5$exports[key];
        }
    });
});
var $6caaf0f4a32ef5a3$exports = {};
"use strict";
Object.defineProperty($6caaf0f4a32ef5a3$exports, "__esModule", {
    value: true
});


Object.keys($6caaf0f4a32ef5a3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in $2f20061a3ca46e99$exports && $2f20061a3ca46e99$exports[key] === $6caaf0f4a32ef5a3$exports[key]) return;
    Object.defineProperty($2f20061a3ca46e99$exports, key, {
        enumerable: true,
        get: function() {
            return $6caaf0f4a32ef5a3$exports[key];
        }
    });
});
var $cbe167396cb8592e$exports = {};
"use strict";
Object.defineProperty($cbe167396cb8592e$exports, "__esModule", {
    value: true
});


Object.keys($cbe167396cb8592e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in $2f20061a3ca46e99$exports && $2f20061a3ca46e99$exports[key] === $cbe167396cb8592e$exports[key]) return;
    Object.defineProperty($2f20061a3ca46e99$exports, key, {
        enumerable: true,
        get: function() {
            return $cbe167396cb8592e$exports[key];
        }
    });
});
var $a2f6bda437b097fd$exports = {};
"use strict";
Object.defineProperty($a2f6bda437b097fd$exports, "__esModule", {
    value: true
});


Object.keys($a2f6bda437b097fd$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in $2f20061a3ca46e99$exports && $2f20061a3ca46e99$exports[key] === $a2f6bda437b097fd$exports[key]) return;
    Object.defineProperty($2f20061a3ca46e99$exports, key, {
        enumerable: true,
        get: function() {
            return $a2f6bda437b097fd$exports[key];
        }
    });
});
var $f56c1f46171e94b8$exports = {};
"use strict";
Object.defineProperty($f56c1f46171e94b8$exports, "__esModule", {
    value: true
});


Object.keys($f56c1f46171e94b8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in $2f20061a3ca46e99$exports && $2f20061a3ca46e99$exports[key] === $f56c1f46171e94b8$exports[key]) return;
    Object.defineProperty($2f20061a3ca46e99$exports, key, {
        enumerable: true,
        get: function() {
            return $f56c1f46171e94b8$exports[key];
        }
    });
});
var $ad1649b1f0b4df34$exports = {};
"use strict";
Object.defineProperty($ad1649b1f0b4df34$exports, "__esModule", {
    value: true
});


Object.keys($ad1649b1f0b4df34$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in $2f20061a3ca46e99$exports && $2f20061a3ca46e99$exports[key] === $ad1649b1f0b4df34$exports[key]) return;
    Object.defineProperty($2f20061a3ca46e99$exports, key, {
        enumerable: true,
        get: function() {
            return $ad1649b1f0b4df34$exports[key];
        }
    });
});
var $8ee7986d138c7e40$exports = {};
"use strict";
Object.defineProperty($8ee7986d138c7e40$exports, "__esModule", {
    value: true
});
$8ee7986d138c7e40$exports.createRowSelectionManager = void 0;
class $8ee7986d138c7e40$var$IncludeManager {
    constructor(model){
        this.data = model.ids;
    }
    has(id) {
        return this.data.has(id);
    }
    select(id) {
        this.data.add(id);
    }
    unselect(id) {
        this.data.delete(id);
    }
}
class $8ee7986d138c7e40$var$ExcludeManager {
    constructor(model){
        this.data = model.ids;
    }
    has(id) {
        return !this.data.has(id);
    }
    select(id) {
        this.data.delete(id);
    }
    unselect(id) {
        this.data.add(id);
    }
}
const $8ee7986d138c7e40$var$createRowSelectionManager = (model)=>{
    if (model.type === 'include') return new $8ee7986d138c7e40$var$IncludeManager(model);
    return new $8ee7986d138c7e40$var$ExcludeManager(model);
};
$8ee7986d138c7e40$exports.createRowSelectionManager = $8ee7986d138c7e40$var$createRowSelectionManager;


var $8343034794934d70$exports = {};
"use strict";
Object.defineProperty($8343034794934d70$exports, "__esModule", {
    value: true
});
var $1cc5edd0a201a0c1$exports = {};
"use strict";
Object.defineProperty($1cc5edd0a201a0c1$exports, "__esModule", {
    value: true
});


Object.keys($1cc5edd0a201a0c1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $8343034794934d70$exports && $8343034794934d70$exports[key] === $1cc5edd0a201a0c1$exports[key]) return;
    Object.defineProperty($8343034794934d70$exports, key, {
        enumerable: true,
        get: function() {
            return $1cc5edd0a201a0c1$exports[key];
        }
    });
});
var $c59e89de2fcf0a2b$exports = {};
"use strict";
Object.defineProperty($c59e89de2fcf0a2b$exports, "__esModule", {
    value: true
});


Object.keys($c59e89de2fcf0a2b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $8343034794934d70$exports && $8343034794934d70$exports[key] === $c59e89de2fcf0a2b$exports[key]) return;
    Object.defineProperty($8343034794934d70$exports, key, {
        enumerable: true,
        get: function() {
            return $c59e89de2fcf0a2b$exports[key];
        }
    });
});
var $1c1a1791fd6ed47e$exports = {};
"use strict";
Object.defineProperty($1c1a1791fd6ed47e$exports, "__esModule", {
    value: true
});


Object.keys($1c1a1791fd6ed47e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $8343034794934d70$exports && $8343034794934d70$exports[key] === $1c1a1791fd6ed47e$exports[key]) return;
    Object.defineProperty($8343034794934d70$exports, key, {
        enumerable: true,
        get: function() {
            return $1c1a1791fd6ed47e$exports[key];
        }
    });
});
var $af2d976e14d5e750$exports = {};
"use strict";
Object.defineProperty($af2d976e14d5e750$exports, "__esModule", {
    value: true
});


Object.keys($af2d976e14d5e750$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $8343034794934d70$exports && $8343034794934d70$exports[key] === $af2d976e14d5e750$exports[key]) return;
    Object.defineProperty($8343034794934d70$exports, key, {
        enumerable: true,
        get: function() {
            return $af2d976e14d5e750$exports[key];
        }
    });
});
var $dae8aa7db1c69e5a$exports = {};
"use strict";
Object.defineProperty($dae8aa7db1c69e5a$exports, "__esModule", {
    value: true
});
$dae8aa7db1c69e5a$exports.GridCellEditStopReasons = $dae8aa7db1c69e5a$exports.GridCellEditStartReasons = void 0;
/**
 * Params passed to `apiRef.current.setEditCellValue`.
 */ var $dae8aa7db1c69e5a$var$GridCellEditStartReasons = $dae8aa7db1c69e5a$exports.GridCellEditStartReasons = /*#__PURE__*/ function(GridCellEditStartReasons) {
    GridCellEditStartReasons["enterKeyDown"] = "enterKeyDown";
    GridCellEditStartReasons["cellDoubleClick"] = "cellDoubleClick";
    GridCellEditStartReasons["printableKeyDown"] = "printableKeyDown";
    GridCellEditStartReasons["deleteKeyDown"] = "deleteKeyDown";
    GridCellEditStartReasons["pasteKeyDown"] = "pasteKeyDown";
    return GridCellEditStartReasons;
}($dae8aa7db1c69e5a$var$GridCellEditStartReasons || {});
/**
 * Params passed to the `cellEditStart` event.
 */ var $dae8aa7db1c69e5a$var$GridCellEditStopReasons = $dae8aa7db1c69e5a$exports.GridCellEditStopReasons = /*#__PURE__*/ function(GridCellEditStopReasons) {
    GridCellEditStopReasons["cellFocusOut"] = "cellFocusOut";
    GridCellEditStopReasons["escapeKeyDown"] = "escapeKeyDown";
    GridCellEditStopReasons["enterKeyDown"] = "enterKeyDown";
    GridCellEditStopReasons["tabKeyDown"] = "tabKeyDown";
    GridCellEditStopReasons["shiftTabKeyDown"] = "shiftTabKeyDown";
    return GridCellEditStopReasons;
}($dae8aa7db1c69e5a$var$GridCellEditStopReasons || {}); /**
 * Params passed to the `cellEditStop event.
 */  // https://github.com/mui/mui-x/pull/3738#discussion_r798504277


Object.keys($dae8aa7db1c69e5a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $8343034794934d70$exports && $8343034794934d70$exports[key] === $dae8aa7db1c69e5a$exports[key]) return;
    Object.defineProperty($8343034794934d70$exports, key, {
        enumerable: true,
        get: function() {
            return $dae8aa7db1c69e5a$exports[key];
        }
    });
});
var $e03e8aca644cf2db$exports = {};
"use strict";
Object.defineProperty($e03e8aca644cf2db$exports, "__esModule", {
    value: true
});
$e03e8aca644cf2db$exports.GridRowEditStopReasons = $e03e8aca644cf2db$exports.GridRowEditStartReasons = void 0;
/**
 * Object passed as parameter in the row callbacks.
 * @demos
 *   - [Master-detail row panels](/x/react-data-grid/master-detail/)
 */ /**
 * Object passed as parameter in the row `getRowClassName` callback prop.
 * @demos
 *   - [Styling rows](/x/react-data-grid/style/#styling-rows)
 */ /**
 * Object passed as parameter in the row `getRowHeight` callback prop.
 */ /**
 * The getRowHeight return value.
 */ var $e03e8aca644cf2db$var$GridRowEditStartReasons = $e03e8aca644cf2db$exports.GridRowEditStartReasons = /*#__PURE__*/ function(GridRowEditStartReasons) {
    GridRowEditStartReasons["enterKeyDown"] = "enterKeyDown";
    GridRowEditStartReasons["cellDoubleClick"] = "cellDoubleClick";
    GridRowEditStartReasons["printableKeyDown"] = "printableKeyDown";
    GridRowEditStartReasons["deleteKeyDown"] = "deleteKeyDown";
    return GridRowEditStartReasons;
}($e03e8aca644cf2db$var$GridRowEditStartReasons || {});
/**
 * Params passed to the `rowEditStart` event.
 */ var $e03e8aca644cf2db$var$GridRowEditStopReasons = $e03e8aca644cf2db$exports.GridRowEditStopReasons = /*#__PURE__*/ function(GridRowEditStopReasons) {
    GridRowEditStopReasons["rowFocusOut"] = "rowFocusOut";
    GridRowEditStopReasons["escapeKeyDown"] = "escapeKeyDown";
    GridRowEditStopReasons["enterKeyDown"] = "enterKeyDown";
    GridRowEditStopReasons["tabKeyDown"] = "tabKeyDown";
    GridRowEditStopReasons["shiftTabKeyDown"] = "shiftTabKeyDown";
    return GridRowEditStopReasons;
}($e03e8aca644cf2db$var$GridRowEditStopReasons || {}); /**
 * Object passed as parameter in the row `getRowSpacing` callback prop.
 * @demos
 *   - [Row spacing](/x/react-data-grid/row-height/#row-spacing)
 */  /**
 * The getRowSpacing return value.
 */  // https://github.com/mui/mui-x/pull/3738#discussion_r798504277


Object.keys($e03e8aca644cf2db$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $8343034794934d70$exports && $8343034794934d70$exports[key] === $e03e8aca644cf2db$exports[key]) return;
    Object.defineProperty($8343034794934d70$exports, key, {
        enumerable: true,
        get: function() {
            return $e03e8aca644cf2db$exports[key];
        }
    });
});
var $2c2b5d97244cefd4$exports = {};
"use strict";
Object.defineProperty($2c2b5d97244cefd4$exports, "__esModule", {
    value: true
});


Object.keys($2c2b5d97244cefd4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $8343034794934d70$exports && $8343034794934d70$exports[key] === $2c2b5d97244cefd4$exports[key]) return;
    Object.defineProperty($8343034794934d70$exports, key, {
        enumerable: true,
        get: function() {
            return $2c2b5d97244cefd4$exports[key];
        }
    });
});
var $49ac7eacffc8fc84$exports = {};
"use strict";
Object.defineProperty($49ac7eacffc8fc84$exports, "__esModule", {
    value: true
});


Object.keys($49ac7eacffc8fc84$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $8343034794934d70$exports && $8343034794934d70$exports[key] === $49ac7eacffc8fc84$exports[key]) return;
    Object.defineProperty($8343034794934d70$exports, key, {
        enumerable: true,
        get: function() {
            return $49ac7eacffc8fc84$exports[key];
        }
    });
});
var $37f79bc17dd0f455$exports = {};
"use strict";
Object.defineProperty($37f79bc17dd0f455$exports, "__esModule", {
    value: true
});


Object.keys($37f79bc17dd0f455$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $8343034794934d70$exports && $8343034794934d70$exports[key] === $37f79bc17dd0f455$exports[key]) return;
    Object.defineProperty($8343034794934d70$exports, key, {
        enumerable: true,
        get: function() {
            return $37f79bc17dd0f455$exports[key];
        }
    });
});
var $6140a5999905f15d$exports = {};
"use strict";
Object.defineProperty($6140a5999905f15d$exports, "__esModule", {
    value: true
});


Object.keys($6140a5999905f15d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $8343034794934d70$exports && $8343034794934d70$exports[key] === $6140a5999905f15d$exports[key]) return;
    Object.defineProperty($8343034794934d70$exports, key, {
        enumerable: true,
        get: function() {
            return $6140a5999905f15d$exports[key];
        }
    });
});
var $db033511c562e4a8$exports = {};
"use strict";
Object.defineProperty($db033511c562e4a8$exports, "__esModule", {
    value: true
});


Object.keys($db033511c562e4a8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $8343034794934d70$exports && $8343034794934d70$exports[key] === $db033511c562e4a8$exports[key]) return;
    Object.defineProperty($8343034794934d70$exports, key, {
        enumerable: true,
        get: function() {
            return $db033511c562e4a8$exports[key];
        }
    });
});
var $8f652dac596df494$exports = {};
"use strict";
Object.defineProperty($8f652dac596df494$exports, "__esModule", {
    value: true
});


Object.keys($8f652dac596df494$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $8343034794934d70$exports && $8343034794934d70$exports[key] === $8f652dac596df494$exports[key]) return;
    Object.defineProperty($8343034794934d70$exports, key, {
        enumerable: true,
        get: function() {
            return $8f652dac596df494$exports[key];
        }
    });
});
var $a958176cb4e945ff$exports = {};
"use strict";
Object.defineProperty($a958176cb4e945ff$exports, "__esModule", {
    value: true
});


Object.keys($a958176cb4e945ff$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $8343034794934d70$exports && $8343034794934d70$exports[key] === $a958176cb4e945ff$exports[key]) return;
    Object.defineProperty($8343034794934d70$exports, key, {
        enumerable: true,
        get: function() {
            return $a958176cb4e945ff$exports[key];
        }
    });
});


Object.keys($8343034794934d70$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in $2f20061a3ca46e99$exports && $2f20061a3ca46e99$exports[key] === $8343034794934d70$exports[key]) return;
    Object.defineProperty($2f20061a3ca46e99$exports, key, {
        enumerable: true,
        get: function() {
            return $8343034794934d70$exports[key];
        }
    });
});
var $0d18f00efb1cd513$exports = {};
"use strict";
Object.defineProperty($0d18f00efb1cd513$exports, "__esModule", {
    value: true
});


Object.keys($0d18f00efb1cd513$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in $2f20061a3ca46e99$exports && $2f20061a3ca46e99$exports[key] === $0d18f00efb1cd513$exports[key]) return;
    Object.defineProperty($2f20061a3ca46e99$exports, key, {
        enumerable: true,
        get: function() {
            return $0d18f00efb1cd513$exports[key];
        }
    });
});
var $3fc7827a1eb0354f$exports = {};
"use strict";
Object.defineProperty($3fc7827a1eb0354f$exports, "__esModule", {
    value: true
});


Object.keys($3fc7827a1eb0354f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in $2f20061a3ca46e99$exports && $2f20061a3ca46e99$exports[key] === $3fc7827a1eb0354f$exports[key]) return;
    Object.defineProperty($2f20061a3ca46e99$exports, key, {
        enumerable: true,
        get: function() {
            return $3fc7827a1eb0354f$exports[key];
        }
    });
});
var $28171b55cfa6cb7e$exports = {};
"use strict";
Object.defineProperty($28171b55cfa6cb7e$exports, "__esModule", {
    value: true
});


Object.keys($28171b55cfa6cb7e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in $2f20061a3ca46e99$exports && $2f20061a3ca46e99$exports[key] === $28171b55cfa6cb7e$exports[key]) return;
    Object.defineProperty($2f20061a3ca46e99$exports, key, {
        enumerable: true,
        get: function() {
            return $28171b55cfa6cb7e$exports[key];
        }
    });
});
var $03210161ac4d5f7a$exports = {};
"use strict";
Object.defineProperty($03210161ac4d5f7a$exports, "__esModule", {
    value: true
});
var $c1a03b864f3c70d4$exports = {};
"use strict";
Object.defineProperty($c1a03b864f3c70d4$exports, "__esModule", {
    value: true
});


Object.keys($c1a03b864f3c70d4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $03210161ac4d5f7a$exports && $03210161ac4d5f7a$exports[key] === $c1a03b864f3c70d4$exports[key]) return;
    Object.defineProperty($03210161ac4d5f7a$exports, key, {
        enumerable: true,
        get: function() {
            return $c1a03b864f3c70d4$exports[key];
        }
    });
});
var $ffd1a56b328c6bfc$exports = {};
"use strict";
Object.defineProperty($ffd1a56b328c6bfc$exports, "__esModule", {
    value: true
});


Object.keys($ffd1a56b328c6bfc$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $03210161ac4d5f7a$exports && $03210161ac4d5f7a$exports[key] === $ffd1a56b328c6bfc$exports[key]) return;
    Object.defineProperty($03210161ac4d5f7a$exports, key, {
        enumerable: true,
        get: function() {
            return $ffd1a56b328c6bfc$exports[key];
        }
    });
});
var $a34fe705db7cc1aa$exports = {};
"use strict";
Object.defineProperty($a34fe705db7cc1aa$exports, "__esModule", {
    value: true
});


Object.keys($a34fe705db7cc1aa$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $03210161ac4d5f7a$exports && $03210161ac4d5f7a$exports[key] === $a34fe705db7cc1aa$exports[key]) return;
    Object.defineProperty($03210161ac4d5f7a$exports, key, {
        enumerable: true,
        get: function() {
            return $a34fe705db7cc1aa$exports[key];
        }
    });
});
var $22fe3a7cb9dd1b49$exports = {};
"use strict";
Object.defineProperty($22fe3a7cb9dd1b49$exports, "__esModule", {
    value: true
});


Object.keys($22fe3a7cb9dd1b49$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $03210161ac4d5f7a$exports && $03210161ac4d5f7a$exports[key] === $22fe3a7cb9dd1b49$exports[key]) return;
    Object.defineProperty($03210161ac4d5f7a$exports, key, {
        enumerable: true,
        get: function() {
            return $22fe3a7cb9dd1b49$exports[key];
        }
    });
});
var $8e21739708aff6ff$exports = {};
"use strict";
Object.defineProperty($8e21739708aff6ff$exports, "__esModule", {
    value: true
});


Object.keys($8e21739708aff6ff$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $03210161ac4d5f7a$exports && $03210161ac4d5f7a$exports[key] === $8e21739708aff6ff$exports[key]) return;
    Object.defineProperty($03210161ac4d5f7a$exports, key, {
        enumerable: true,
        get: function() {
            return $8e21739708aff6ff$exports[key];
        }
    });
});
var $07022a2335098dec$exports = {};
"use strict";
Object.defineProperty($07022a2335098dec$exports, "__esModule", {
    value: true
});


Object.keys($07022a2335098dec$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $03210161ac4d5f7a$exports && $03210161ac4d5f7a$exports[key] === $07022a2335098dec$exports[key]) return;
    Object.defineProperty($03210161ac4d5f7a$exports, key, {
        enumerable: true,
        get: function() {
            return $07022a2335098dec$exports[key];
        }
    });
});
var $ada63655d59ef6de$exports = {};
"use strict";
Object.defineProperty($ada63655d59ef6de$exports, "__esModule", {
    value: true
});


Object.keys($ada63655d59ef6de$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $03210161ac4d5f7a$exports && $03210161ac4d5f7a$exports[key] === $ada63655d59ef6de$exports[key]) return;
    Object.defineProperty($03210161ac4d5f7a$exports, key, {
        enumerable: true,
        get: function() {
            return $ada63655d59ef6de$exports[key];
        }
    });
});
var $e9d5c509545bb7c5$exports = {};
"use strict";
Object.defineProperty($e9d5c509545bb7c5$exports, "__esModule", {
    value: true
});


Object.keys($e9d5c509545bb7c5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $03210161ac4d5f7a$exports && $03210161ac4d5f7a$exports[key] === $e9d5c509545bb7c5$exports[key]) return;
    Object.defineProperty($03210161ac4d5f7a$exports, key, {
        enumerable: true,
        get: function() {
            return $e9d5c509545bb7c5$exports[key];
        }
    });
});
var $78d850814e96bcc2$exports = {};
"use strict";
Object.defineProperty($78d850814e96bcc2$exports, "__esModule", {
    value: true
});


Object.keys($78d850814e96bcc2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $03210161ac4d5f7a$exports && $03210161ac4d5f7a$exports[key] === $78d850814e96bcc2$exports[key]) return;
    Object.defineProperty($03210161ac4d5f7a$exports, key, {
        enumerable: true,
        get: function() {
            return $78d850814e96bcc2$exports[key];
        }
    });
});
var $8b0c348d369a1774$exports = {};
"use strict";
Object.defineProperty($8b0c348d369a1774$exports, "__esModule", {
    value: true
});


Object.keys($8b0c348d369a1774$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $03210161ac4d5f7a$exports && $03210161ac4d5f7a$exports[key] === $8b0c348d369a1774$exports[key]) return;
    Object.defineProperty($03210161ac4d5f7a$exports, key, {
        enumerable: true,
        get: function() {
            return $8b0c348d369a1774$exports[key];
        }
    });
});
var $143bd7ee9281df7a$exports = {};
"use strict";
Object.defineProperty($143bd7ee9281df7a$exports, "__esModule", {
    value: true
});


Object.keys($143bd7ee9281df7a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $03210161ac4d5f7a$exports && $03210161ac4d5f7a$exports[key] === $143bd7ee9281df7a$exports[key]) return;
    Object.defineProperty($03210161ac4d5f7a$exports, key, {
        enumerable: true,
        get: function() {
            return $143bd7ee9281df7a$exports[key];
        }
    });
});


Object.keys($03210161ac4d5f7a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in $2f20061a3ca46e99$exports && $2f20061a3ca46e99$exports[key] === $03210161ac4d5f7a$exports[key]) return;
    Object.defineProperty($2f20061a3ca46e99$exports, key, {
        enumerable: true,
        get: function() {
            return $03210161ac4d5f7a$exports[key];
        }
    });
});
var $8bd0a040b59e38c9$exports = {};
"use strict";
Object.defineProperty($8bd0a040b59e38c9$exports, "__esModule", {
    value: true
});


Object.keys($8bd0a040b59e38c9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in $2f20061a3ca46e99$exports && $2f20061a3ca46e99$exports[key] === $8bd0a040b59e38c9$exports[key]) return;
    Object.defineProperty($2f20061a3ca46e99$exports, key, {
        enumerable: true,
        get: function() {
            return $8bd0a040b59e38c9$exports[key];
        }
    });
});
var $1139698831919a0e$exports = {};
"use strict";
Object.defineProperty($1139698831919a0e$exports, "__esModule", {
    value: true
});


Object.keys($1139698831919a0e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in $2f20061a3ca46e99$exports && $2f20061a3ca46e99$exports[key] === $1139698831919a0e$exports[key]) return;
    Object.defineProperty($2f20061a3ca46e99$exports, key, {
        enumerable: true,
        get: function() {
            return $1139698831919a0e$exports[key];
        }
    });
});
var $0007b8e4883ec070$exports = {};
"use strict";
Object.defineProperty($0007b8e4883ec070$exports, "__esModule", {
    value: true
});


Object.keys($0007b8e4883ec070$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in $2f20061a3ca46e99$exports && $2f20061a3ca46e99$exports[key] === $0007b8e4883ec070$exports[key]) return;
    Object.defineProperty($2f20061a3ca46e99$exports, key, {
        enumerable: true,
        get: function() {
            return $0007b8e4883ec070$exports[key];
        }
    });
});
var $6c7c3f11e38380be$exports = {};
"use strict";
Object.defineProperty($6c7c3f11e38380be$exports, "__esModule", {
    value: true
});


Object.keys($6c7c3f11e38380be$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in $2f20061a3ca46e99$exports && $2f20061a3ca46e99$exports[key] === $6c7c3f11e38380be$exports[key]) return;
    Object.defineProperty($2f20061a3ca46e99$exports, key, {
        enumerable: true,
        get: function() {
            return $6c7c3f11e38380be$exports[key];
        }
    });
});
var $be43cb5e4f55fb8f$exports = {};
"use strict";
Object.defineProperty($be43cb5e4f55fb8f$exports, "__esModule", {
    value: true
});
var $b3f0bd2133b09c32$exports = {};
"use strict";
Object.defineProperty($b3f0bd2133b09c32$exports, "__esModule", {
    value: true
});


Object.keys($b3f0bd2133b09c32$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $be43cb5e4f55fb8f$exports && $be43cb5e4f55fb8f$exports[key] === $b3f0bd2133b09c32$exports[key]) return;
    Object.defineProperty($be43cb5e4f55fb8f$exports, key, {
        enumerable: true,
        get: function() {
            return $b3f0bd2133b09c32$exports[key];
        }
    });
});
var $23cafa884ddde2fa$exports = {};
"use strict";
Object.defineProperty($23cafa884ddde2fa$exports, "__esModule", {
    value: true
});


Object.keys($23cafa884ddde2fa$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $be43cb5e4f55fb8f$exports && $be43cb5e4f55fb8f$exports[key] === $23cafa884ddde2fa$exports[key]) return;
    Object.defineProperty($be43cb5e4f55fb8f$exports, key, {
        enumerable: true,
        get: function() {
            return $23cafa884ddde2fa$exports[key];
        }
    });
});
var $b7150e830d011066$exports = {};
"use strict";
Object.defineProperty($b7150e830d011066$exports, "__esModule", {
    value: true
});


Object.keys($b7150e830d011066$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $be43cb5e4f55fb8f$exports && $be43cb5e4f55fb8f$exports[key] === $b7150e830d011066$exports[key]) return;
    Object.defineProperty($be43cb5e4f55fb8f$exports, key, {
        enumerable: true,
        get: function() {
            return $b7150e830d011066$exports[key];
        }
    });
});


Object.keys($be43cb5e4f55fb8f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in $2f20061a3ca46e99$exports && $2f20061a3ca46e99$exports[key] === $be43cb5e4f55fb8f$exports[key]) return;
    Object.defineProperty($2f20061a3ca46e99$exports, key, {
        enumerable: true,
        get: function() {
            return $be43cb5e4f55fb8f$exports[key];
        }
    });
});
var $de4444ff1794c3fb$exports = {};
"use strict";
Object.defineProperty($de4444ff1794c3fb$exports, "__esModule", {
    value: true
});
$de4444ff1794c3fb$exports.isLeaf = $de4444ff1794c3fb$var$isLeaf;
function $de4444ff1794c3fb$var$isLeaf(node) {
    return node.field !== undefined;
} /**
 * A function used to process headerClassName params.
 * @param {GridColumnGroupHeaderParams} params The parameters of the column group header.
 * @returns {string} The class name to be added to the column group header cell.
 */  /**
 * The union type representing the [[GridColDef]] column header class type.
 */ 


Object.keys($de4444ff1794c3fb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in $2f20061a3ca46e99$exports && $2f20061a3ca46e99$exports[key] === $de4444ff1794c3fb$exports[key]) return;
    Object.defineProperty($2f20061a3ca46e99$exports, key, {
        enumerable: true,
        get: function() {
            return $de4444ff1794c3fb$exports[key];
        }
    });
});
var $b56ebbf82fe90813$exports = {};
"use strict";
Object.defineProperty($b56ebbf82fe90813$exports, "__esModule", {
    value: true
});


Object.keys($b56ebbf82fe90813$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in $2f20061a3ca46e99$exports && $2f20061a3ca46e99$exports[key] === $b56ebbf82fe90813$exports[key]) return;
    Object.defineProperty($2f20061a3ca46e99$exports, key, {
        enumerable: true,
        get: function() {
            return $b56ebbf82fe90813$exports[key];
        }
    });
});


var $f582e8f6fdde33c9$exports = {};
"use strict";
Object.defineProperty($f582e8f6fdde33c9$exports, "__esModule", {
    value: true
});
$f582e8f6fdde33c9$exports.getDefaultGridFilterModel = $f582e8f6fdde33c9$exports.defaultGridFilterLookup = void 0;

const $f582e8f6fdde33c9$var$defaultGridFilterLookup = $f582e8f6fdde33c9$exports.defaultGridFilterLookup = {
    filteredRowsLookup: {},
    filteredChildrenCountLookup: {},
    filteredDescendantCountLookup: {}
};
const $f582e8f6fdde33c9$var$getDefaultGridFilterModel = ()=>({
        items: [],
        logicOperator: $6c940a0517b1c6d5$exports.GridLogicOperator.And,
        quickFilterValues: [],
        quickFilterLogicOperator: $6c940a0517b1c6d5$exports.GridLogicOperator.And
    });
/**
 * @param {GridValidRowModel} row The model of the row we want to filter.
 * @param {(filterItem: GridFilterItem) => boolean} shouldApplyItem An optional callback to allow the filtering engine to only apply some items.
 * @param {GridAggregatedFilterItemApplierResult} result The previous result of the filtering engine.
 */ /**
 * Visibility status for each row.
 * A row is visible if it is passing the filters AND if its parents are expanded.
 * If a row is not registered in this lookup, it is visible.
 */ $f582e8f6fdde33c9$exports.getDefaultGridFilterModel = $f582e8f6fdde33c9$var$getDefaultGridFilterModel;


var $9ba5bb68a0cac1c6$exports = {};
"use strict";
Object.defineProperty($9ba5bb68a0cac1c6$exports, "__esModule", {
    value: true
});
$9ba5bb68a0cac1c6$exports.getPublicApiRef = $9ba5bb68a0cac1c6$var$getPublicApiRef;
function $9ba5bb68a0cac1c6$var$getPublicApiRef(apiRef) {
    return {
        current: apiRef.current.getPublicApi()
    };
}


var $e3b5f2e67362f55f$exports = {};
"use strict";
Object.defineProperty($e3b5f2e67362f55f$exports, "__esModule", {
    value: true
});
var $e3b5f2e67362f55f$var$_exportNames = {
    gridColumnsStateSelector: true,
    gridColumnFieldsSelector: true,
    gridColumnLookupSelector: true,
    gridColumnVisibilityModelSelector: true,
    gridColumnDefinitionsSelector: true,
    gridVisibleColumnDefinitionsSelector: true,
    gridVisibleColumnFieldsSelector: true,
    gridPinnedColumnsSelector: true,
    gridVisiblePinnedColumnDefinitionsSelector: true,
    gridColumnPositionsSelector: true,
    gridFilterableColumnDefinitionsSelector: true,
    gridFilterableColumnLookupSelector: true,
    gridHasColSpanSelector: true
};
Object.defineProperty($e3b5f2e67362f55f$exports, "gridColumnDefinitionsSelector", {
    enumerable: true,
    get: function() {
        return $e732684465924d20$exports.gridColumnDefinitionsSelector;
    }
});
Object.defineProperty($e3b5f2e67362f55f$exports, "gridColumnFieldsSelector", {
    enumerable: true,
    get: function() {
        return $e732684465924d20$exports.gridColumnFieldsSelector;
    }
});
Object.defineProperty($e3b5f2e67362f55f$exports, "gridColumnLookupSelector", {
    enumerable: true,
    get: function() {
        return $e732684465924d20$exports.gridColumnLookupSelector;
    }
});
Object.defineProperty($e3b5f2e67362f55f$exports, "gridColumnPositionsSelector", {
    enumerable: true,
    get: function() {
        return $e732684465924d20$exports.gridColumnPositionsSelector;
    }
});
Object.defineProperty($e3b5f2e67362f55f$exports, "gridColumnVisibilityModelSelector", {
    enumerable: true,
    get: function() {
        return $e732684465924d20$exports.gridColumnVisibilityModelSelector;
    }
});
Object.defineProperty($e3b5f2e67362f55f$exports, "gridColumnsStateSelector", {
    enumerable: true,
    get: function() {
        return $e732684465924d20$exports.gridColumnsStateSelector;
    }
});
Object.defineProperty($e3b5f2e67362f55f$exports, "gridFilterableColumnDefinitionsSelector", {
    enumerable: true,
    get: function() {
        return $e732684465924d20$exports.gridFilterableColumnDefinitionsSelector;
    }
});
Object.defineProperty($e3b5f2e67362f55f$exports, "gridFilterableColumnLookupSelector", {
    enumerable: true,
    get: function() {
        return $e732684465924d20$exports.gridFilterableColumnLookupSelector;
    }
});
Object.defineProperty($e3b5f2e67362f55f$exports, "gridHasColSpanSelector", {
    enumerable: true,
    get: function() {
        return $e732684465924d20$exports.gridHasColSpanSelector;
    }
});
Object.defineProperty($e3b5f2e67362f55f$exports, "gridPinnedColumnsSelector", {
    enumerable: true,
    get: function() {
        return $e732684465924d20$exports.gridPinnedColumnsSelector;
    }
});
Object.defineProperty($e3b5f2e67362f55f$exports, "gridVisibleColumnDefinitionsSelector", {
    enumerable: true,
    get: function() {
        return $e732684465924d20$exports.gridVisibleColumnDefinitionsSelector;
    }
});
Object.defineProperty($e3b5f2e67362f55f$exports, "gridVisibleColumnFieldsSelector", {
    enumerable: true,
    get: function() {
        return $e732684465924d20$exports.gridVisibleColumnFieldsSelector;
    }
});
Object.defineProperty($e3b5f2e67362f55f$exports, "gridVisiblePinnedColumnDefinitionsSelector", {
    enumerable: true,
    get: function() {
        return $e732684465924d20$exports.gridVisiblePinnedColumnDefinitionsSelector;
    }
});
var $e732684465924d20$exports = {};
"use strict";
Object.defineProperty($e732684465924d20$exports, "__esModule", {
    value: true
});
$e732684465924d20$exports.gridVisiblePinnedColumnDefinitionsSelector = $e732684465924d20$exports.gridVisibleColumnFieldsSelector = $e732684465924d20$exports.gridVisibleColumnDefinitionsSelector = $e732684465924d20$exports.gridPinnedColumnsSelector = $e732684465924d20$exports.gridInitialColumnVisibilityModelSelector = $e732684465924d20$exports.gridHasColSpanSelector = $e732684465924d20$exports.gridFilterableColumnLookupSelector = $e732684465924d20$exports.gridFilterableColumnDefinitionsSelector = $e732684465924d20$exports.gridExistingPinnedColumnSelector = $e732684465924d20$exports.gridColumnsStateSelector = $e732684465924d20$exports.gridColumnVisibilityModelSelector = $e732684465924d20$exports.gridColumnPositionsSelector = $e732684465924d20$exports.gridColumnLookupSelector = $e732684465924d20$exports.gridColumnFieldsSelector = $e732684465924d20$exports.gridColumnDefinitionsSelector = void 0;

var $3a32d3fdbf8b29fd$exports = {};
"use strict";
Object.defineProperty($3a32d3fdbf8b29fd$exports, "__esModule", {
    value: true
});
$3a32d3fdbf8b29fd$exports.GridPinnedColumnPosition = $3a32d3fdbf8b29fd$exports.EMPTY_PINNED_COLUMN_FIELDS = void 0;
let $3a32d3fdbf8b29fd$var$GridPinnedColumnPosition = $3a32d3fdbf8b29fd$exports.GridPinnedColumnPosition = /*#__PURE__*/ function(GridPinnedColumnPosition) {
    GridPinnedColumnPosition["LEFT"] = "left";
    GridPinnedColumnPosition["RIGHT"] = "right";
    return GridPinnedColumnPosition;
}({});
const $3a32d3fdbf8b29fd$var$EMPTY_PINNED_COLUMN_FIELDS = $3a32d3fdbf8b29fd$exports.EMPTY_PINNED_COLUMN_FIELDS = {
    left: [],
    right: []
};


var $74274e8a7594bea9$exports = {};
"use strict";
Object.defineProperty($74274e8a7594bea9$exports, "__esModule", {
    value: true
});
$74274e8a7594bea9$exports.gridIsRtlSelector = void 0;

/**
 * Get the theme state
 * @category Core
 */ const $74274e8a7594bea9$var$gridIsRtlSelector = $74274e8a7594bea9$exports.gridIsRtlSelector = (0, $8eef5f2af445e503$exports.createRootSelector)((state)=>state.isRtl);


var $0a2279c071105276$exports = {};
"use strict";
Object.defineProperty($0a2279c071105276$exports, "__esModule", {
    value: true
});
var $6432707a9c80427e$exports = {};
"use strict";
Object.defineProperty($6432707a9c80427e$exports, "__esModule", {
    value: true
});
$6432707a9c80427e$exports.gridListViewSelector = $6432707a9c80427e$exports.gridListColumnSelector = void 0;

/**
 * Get the list view state
 * @category List View
 * @ignore - Do not document
 */ const $6432707a9c80427e$var$gridListViewSelector = $6432707a9c80427e$exports.gridListViewSelector = (0, $8eef5f2af445e503$exports.createRootSelector)((state)=>state.props.listView ?? false);
/**
 * Get the list column definition
 * @category List View
 * @ignore - Do not document
 */ const $6432707a9c80427e$var$gridListColumnSelector = $6432707a9c80427e$exports.gridListColumnSelector = (0, $8eef5f2af445e503$exports.createRootSelector)((state)=>state.listViewColumn);


Object.keys($6432707a9c80427e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $0a2279c071105276$exports && $0a2279c071105276$exports[key] === $6432707a9c80427e$exports[key]) return;
    Object.defineProperty($0a2279c071105276$exports, key, {
        enumerable: true,
        get: function() {
            return $6432707a9c80427e$exports[key];
        }
    });
});


/**
 * Get the columns state
 * @category Columns
 */ const $e732684465924d20$var$gridColumnsStateSelector = $e732684465924d20$exports.gridColumnsStateSelector = (0, $8eef5f2af445e503$exports.createRootSelector)((state)=>state.columns);
/**
 * Get an array of column fields in the order rendered on screen.
 * @category Columns
 */ const $e732684465924d20$var$gridColumnFieldsSelector = $e732684465924d20$exports.gridColumnFieldsSelector = (0, $8eef5f2af445e503$exports.createSelector)($e732684465924d20$var$gridColumnsStateSelector, (columnsState)=>columnsState.orderedFields);
/**
 * Get the columns as a lookup (an object containing the field for keys and the definition for values).
 * @category Columns
 */ const $e732684465924d20$var$gridColumnLookupSelector = $e732684465924d20$exports.gridColumnLookupSelector = (0, $8eef5f2af445e503$exports.createSelector)($e732684465924d20$var$gridColumnsStateSelector, (columnsState)=>columnsState.lookup);
/**
 * Get an array of column definitions in the order rendered on screen..
 * @category Columns
 */ const $e732684465924d20$var$gridColumnDefinitionsSelector = $e732684465924d20$exports.gridColumnDefinitionsSelector = (0, $8eef5f2af445e503$exports.createSelectorMemoized)($e732684465924d20$var$gridColumnFieldsSelector, $e732684465924d20$var$gridColumnLookupSelector, (allFields, lookup)=>allFields.map((field)=>lookup[field]));
/**
 * Get the column visibility model, containing the visibility status of each column.
 * If a column is not registered in the model, it is visible.
 * @category Visible Columns
 */ const $e732684465924d20$var$gridColumnVisibilityModelSelector = $e732684465924d20$exports.gridColumnVisibilityModelSelector = (0, $8eef5f2af445e503$exports.createSelector)($e732684465924d20$var$gridColumnsStateSelector, (columnsState)=>columnsState.columnVisibilityModel);
/**
 * Get the "initial" column visibility model, containing the visibility status of each column.
 * It is updated when the `columns` prop is updated or when `updateColumns` API method is called.
 * If a column is not registered in the model, it is visible.
 * @category Visible Columns
 */ const $e732684465924d20$var$gridInitialColumnVisibilityModelSelector = $e732684465924d20$exports.gridInitialColumnVisibilityModelSelector = (0, $8eef5f2af445e503$exports.createSelector)($e732684465924d20$var$gridColumnsStateSelector, (columnsState)=>columnsState.initialColumnVisibilityModel);
/**
 * Get the visible columns as a lookup (an object containing the field for keys and the definition for values).
 * @category Visible Columns
 */ const $e732684465924d20$var$gridVisibleColumnDefinitionsSelector = $e732684465924d20$exports.gridVisibleColumnDefinitionsSelector = (0, $8eef5f2af445e503$exports.createSelectorMemoized)($e732684465924d20$var$gridColumnDefinitionsSelector, $e732684465924d20$var$gridColumnVisibilityModelSelector, $0a2279c071105276$exports.gridListViewSelector, $0a2279c071105276$exports.gridListColumnSelector, (columns, columnVisibilityModel, listView, listColumn)=>listView && listColumn ? [
        listColumn
    ] : columns.filter((column)=>columnVisibilityModel[column.field] !== false));
/**
 * Get the field of each visible column.
 * @category Visible Columns
 */ const $e732684465924d20$var$gridVisibleColumnFieldsSelector = $e732684465924d20$exports.gridVisibleColumnFieldsSelector = (0, $8eef5f2af445e503$exports.createSelectorMemoized)($e732684465924d20$var$gridVisibleColumnDefinitionsSelector, (visibleColumns)=>visibleColumns.map((column)=>column.field));
/**
 * Get the visible pinned columns model.
 * @category Visible Columns
 */ const $e732684465924d20$var$gridPinnedColumnsSelector = $e732684465924d20$exports.gridPinnedColumnsSelector = (0, $8eef5f2af445e503$exports.createRootSelector)((state)=>state.pinnedColumns);
/**
 * Get all existing pinned columns. Place the columns on the side that depends on the rtl state.
 * @category Pinned Columns
 * @ignore - Do not document
 */ const $e732684465924d20$var$gridExistingPinnedColumnSelector = $e732684465924d20$exports.gridExistingPinnedColumnSelector = (0, $8eef5f2af445e503$exports.createSelectorMemoized)($e732684465924d20$var$gridPinnedColumnsSelector, $e732684465924d20$var$gridColumnFieldsSelector, $74274e8a7594bea9$exports.gridIsRtlSelector, (model, orderedFields, isRtl)=>$e732684465924d20$var$filterMissingColumns(model, orderedFields, isRtl));
/**
 * Get the visible pinned columns.
 * @category Visible Columns
 */ const $e732684465924d20$var$gridVisiblePinnedColumnDefinitionsSelector = $e732684465924d20$exports.gridVisiblePinnedColumnDefinitionsSelector = (0, $8eef5f2af445e503$exports.createSelectorMemoized)($e732684465924d20$var$gridColumnsStateSelector, $e732684465924d20$var$gridPinnedColumnsSelector, $e732684465924d20$var$gridVisibleColumnFieldsSelector, $74274e8a7594bea9$exports.gridIsRtlSelector, $0a2279c071105276$exports.gridListViewSelector, (columnsState, model, visibleColumnFields, isRtl, listView)=>{
    if (listView) return $3a32d3fdbf8b29fd$exports.EMPTY_PINNED_COLUMN_FIELDS;
    const visiblePinnedFields = $e732684465924d20$var$filterMissingColumns(model, visibleColumnFields, isRtl);
    const visiblePinnedColumns = {
        left: visiblePinnedFields.left.map((field)=>columnsState.lookup[field]),
        right: visiblePinnedFields.right.map((field)=>columnsState.lookup[field])
    };
    return visiblePinnedColumns;
});
function $e732684465924d20$var$filterMissingColumns(pinnedColumns, columns, invert) {
    if (!Array.isArray(pinnedColumns.left) && !Array.isArray(pinnedColumns.right)) return $3a32d3fdbf8b29fd$exports.EMPTY_PINNED_COLUMN_FIELDS;
    if (pinnedColumns.left?.length === 0 && pinnedColumns.right?.length === 0) return $3a32d3fdbf8b29fd$exports.EMPTY_PINNED_COLUMN_FIELDS;
    const filter = (newPinnedColumns, remainingColumns)=>{
        if (!Array.isArray(newPinnedColumns)) return [];
        return newPinnedColumns.filter((field)=>remainingColumns.includes(field));
    };
    const leftPinnedColumns = filter(pinnedColumns.left, columns);
    const columnsWithoutLeftPinnedColumns = columns.filter(// Filter out from the remaining columns those columns already pinned to the left
    (field)=>!leftPinnedColumns.includes(field));
    const rightPinnedColumns = filter(pinnedColumns.right, columnsWithoutLeftPinnedColumns);
    if (invert) return {
        left: rightPinnedColumns,
        right: leftPinnedColumns
    };
    return {
        left: leftPinnedColumns,
        right: rightPinnedColumns
    };
}
/**
 * Get the left position in pixel of each visible columns relative to the left of the first column.
 * @category Visible Columns
 */ const $e732684465924d20$var$gridColumnPositionsSelector = $e732684465924d20$exports.gridColumnPositionsSelector = (0, $8eef5f2af445e503$exports.createSelectorMemoized)($e732684465924d20$var$gridVisibleColumnDefinitionsSelector, (visibleColumns)=>{
    const positions = [];
    let currentPosition = 0;
    for(let i = 0; i < visibleColumns.length; i += 1){
        positions.push(currentPosition);
        currentPosition += visibleColumns[i].computedWidth;
    }
    return positions;
});
/**
 * Get the filterable columns as an array.
 * @category Columns
 */ const $e732684465924d20$var$gridFilterableColumnDefinitionsSelector = $e732684465924d20$exports.gridFilterableColumnDefinitionsSelector = (0, $8eef5f2af445e503$exports.createSelectorMemoized)($e732684465924d20$var$gridColumnDefinitionsSelector, (columns)=>columns.filter((col)=>col.filterable));
/**
 * Get the filterable columns as a lookup (an object containing the field for keys and the definition for values).
 * @category Columns
 */ const $e732684465924d20$var$gridFilterableColumnLookupSelector = $e732684465924d20$exports.gridFilterableColumnLookupSelector = (0, $8eef5f2af445e503$exports.createSelectorMemoized)($e732684465924d20$var$gridColumnDefinitionsSelector, (columns)=>columns.reduce((acc, col)=>{
        if (col.filterable) acc[col.field] = col;
        return acc;
    }, {}));
/**
 * Checks if some column has a colSpan field.
 * @category Columns
 * @ignore - Do not document
 */ const $e732684465924d20$var$gridHasColSpanSelector = $e732684465924d20$exports.gridHasColSpanSelector = (0, $8eef5f2af445e503$exports.createSelectorMemoized)($e732684465924d20$var$gridColumnDefinitionsSelector, (columns)=>columns.some((column)=>column.colSpan !== undefined));



Object.keys($3a32d3fdbf8b29fd$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($e3b5f2e67362f55f$var$_exportNames, key)) return;
    if (key in $e3b5f2e67362f55f$exports && $e3b5f2e67362f55f$exports[key] === $3a32d3fdbf8b29fd$exports[key]) return;
    Object.defineProperty($e3b5f2e67362f55f$exports, key, {
        enumerable: true,
        get: function() {
            return $3a32d3fdbf8b29fd$exports[key];
        }
    });
});


let $0c70cf7c1343c218$var$hasEval;
function $0c70cf7c1343c218$var$getHasEval() {
    if ($0c70cf7c1343c218$var$hasEval !== undefined) return $0c70cf7c1343c218$var$hasEval;
    try {
        // eslint-disable-next-line no-new-func
        $0c70cf7c1343c218$var$hasEval = new Function('return true')();
    } catch (_) {
        $0c70cf7c1343c218$var$hasEval = false;
    }
    return $0c70cf7c1343c218$var$hasEval;
}
/**
 * Adds default values to the optional fields of a filter items.
 * @param {GridFilterItem} item The raw filter item.
 * @param {RefObject<GridPrivateApiCommunity>} apiRef The API of the grid.
 * @return {GridFilterItem} The clean filter item with an uniq ID and an always-defined operator.
 * TODO: Make the typing reflect the different between GridFilterInputItem and GridFilterItem.
 */ const $0c70cf7c1343c218$var$cleanFilterItem = (item, apiRef)=>{
    const cleanItem = (0, $0c70cf7c1343c218$var$_extends2.default)({}, item);
    if (cleanItem.id == null) cleanItem.id = Math.round(Math.random() * 1e5);
    if (cleanItem.operator == null) {
        // Selects a default operator
        // We don't use `apiRef.current.getColumn` because it is not ready during state initialization
        const column = (0, $e3b5f2e67362f55f$exports.gridColumnLookupSelector)(apiRef)[cleanItem.field];
        cleanItem.operator = column && column.filterOperators[0].value;
    }
    return cleanItem;
};
$0c70cf7c1343c218$exports.cleanFilterItem = $0c70cf7c1343c218$var$cleanFilterItem;
const $0c70cf7c1343c218$var$sanitizeFilterModel = (model, disableMultipleColumnsFiltering, apiRef)=>{
    const hasSeveralItems = model.items.length > 1;
    let items;
    if (hasSeveralItems && disableMultipleColumnsFiltering) {
        (0, $9Y8Cp.warnOnce)([
            'MUI X: The `filterModel` can only contain a single item when the `disableMultipleColumnsFiltering` prop is set to `true`.',
            'If you are using the community version of the Data Grid, this prop is always `true`.'
        ], 'error');
        items = [
            model.items[0]
        ];
    } else items = model.items;
    const hasItemsWithoutIds = hasSeveralItems && items.some((item)=>item.id == null);
    const hasItemWithoutOperator = items.some((item)=>item.operator == null);
    if (hasItemsWithoutIds) (0, $9Y8Cp.warnOnce)('MUI X: The `id` field is required on `filterModel.items` when you use multiple filters.', 'error');
    if (hasItemWithoutOperator) (0, $9Y8Cp.warnOnce)('MUI X: The `operator` field is required on `filterModel.items`, one or more of your filtering item has no `operator` provided.', 'error');
    if (hasItemWithoutOperator || hasItemsWithoutIds) return (0, $0c70cf7c1343c218$var$_extends2.default)({}, model, {
        items: items.map((item)=>$0c70cf7c1343c218$var$cleanFilterItem(item, apiRef))
    });
    if (model.items !== items) return (0, $0c70cf7c1343c218$var$_extends2.default)({}, model, {
        items: items
    });
    return model;
};
$0c70cf7c1343c218$exports.sanitizeFilterModel = $0c70cf7c1343c218$var$sanitizeFilterModel;
const $0c70cf7c1343c218$var$mergeStateWithFilterModel = (filterModel, disableMultipleColumnsFiltering, apiRef)=>(filteringState)=>(0, $0c70cf7c1343c218$var$_extends2.default)({}, filteringState, {
            filterModel: $0c70cf7c1343c218$var$sanitizeFilterModel(filterModel, disableMultipleColumnsFiltering, apiRef)
        });
$0c70cf7c1343c218$exports.mergeStateWithFilterModel = $0c70cf7c1343c218$var$mergeStateWithFilterModel;
const $0c70cf7c1343c218$var$removeDiacritics = (value)=>{
    if (typeof value === 'string') return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return value;
};
$0c70cf7c1343c218$exports.removeDiacritics = $0c70cf7c1343c218$var$removeDiacritics;
const $0c70cf7c1343c218$var$getFilterCallbackFromItem = (filterItem, filterValueGetter, apiRef)=>{
    if (!filterItem.field || !filterItem.operator) return null;
    const column = apiRef.current.getColumn(filterItem.field);
    if (!column) return null;
    let parsedValue;
    if (column.valueParser) {
        const parser = column.valueParser;
        parsedValue = Array.isArray(filterItem.value) ? filterItem.value?.map((x)=>parser(x, undefined, column, apiRef)) : parser(filterItem.value, undefined, column, apiRef);
    } else parsedValue = filterItem.value;
    const { ignoreDiacritics: ignoreDiacritics } = apiRef.current.rootProps;
    if (ignoreDiacritics) parsedValue = $0c70cf7c1343c218$var$removeDiacritics(parsedValue);
    const newFilterItem = (0, $0c70cf7c1343c218$var$_extends2.default)({}, filterItem, {
        value: parsedValue
    });
    const filterOperators = column.filterOperators;
    if (!filterOperators?.length) throw new Error(`MUI X: No filter operators found for column '${column.field}'.`);
    const filterOperator = filterOperators.find((operator)=>operator.value === newFilterItem.operator);
    if (!filterOperator) throw new Error(`MUI X: No filter operator found for column '${column.field}' and operator value '${newFilterItem.operator}'.`);
    const publicApiRef = (0, $9ba5bb68a0cac1c6$exports.getPublicApiRef)(apiRef);
    const applyFilterOnRow = filterOperator.getApplyFilterFn(newFilterItem, column);
    if (typeof applyFilterOnRow !== 'function') return null;
    return {
        item: newFilterItem,
        fn: (row)=>{
            let value = filterValueGetter(row, column);
            if (ignoreDiacritics) value = $0c70cf7c1343c218$var$removeDiacritics(value);
            return applyFilterOnRow(value, row, column, publicApiRef);
        }
    };
};
let $0c70cf7c1343c218$var$filterItemsApplierId = 1;
/**
 * @name filterValueGetter
 * @param {GridRowModel} row The row to get the value from.
 * @param {GridColDef} column The column that the filter is applied on.
 *
 * Generates a method to easily check if a row is matching the current filter model.
 * @param {GridFilterModel} filterModel The model with which we want to filter the rows.
 * @param {FilterValueGetterFn} filterValueGetter The function to get the value to filter by.
 * @param {RefObject<GridPrivateApiCommunity>} apiRef The API of the grid.
 * @returns {GridAggregatedFilterItemApplier | null} A method that checks if a row is matching the current filter model. If `null`, we consider that all the rows are matching the filters.
 */ const $0c70cf7c1343c218$var$buildAggregatedFilterItemsApplier = (filterModel, filterValueGetter, apiRef, disableEval)=>{
    const { items: items } = filterModel;
    const appliers = items.map((item)=>$0c70cf7c1343c218$var$getFilterCallbackFromItem(item, filterValueGetter, apiRef)).filter((callback)=>!!callback);
    if (appliers.length === 0) return null;
    if (disableEval || !$0c70cf7c1343c218$var$getHasEval()) // This is the original logic, which is used if `eval()` is not supported (aka prevented by CSP).
    return (row, shouldApplyFilter)=>{
        const resultPerItemId = {};
        for(let i = 0; i < appliers.length; i += 1){
            const applier = appliers[i];
            if (!shouldApplyFilter || shouldApplyFilter(applier.item.field)) resultPerItemId[applier.item.id] = applier.fn(row);
        }
        return resultPerItemId;
    };
    // We generate a new function with `new Function()` to avoid expensive patterns for JS engines
    // such as a dynamic object assignment, for example `{ [dynamicKey]: value }`.
    // eslint-disable-next-line no-new-func
    const filterItemCore = new Function('appliers', 'row', 'shouldApplyFilter', `"use strict";
${appliers.map((applier, i)=>`const shouldApply${i} = !shouldApplyFilter || shouldApplyFilter(${JSON.stringify(applier.item.field)});`).join('\n')}

const result$$ = {
${appliers.map((applier, i)=>`  ${JSON.stringify(String(applier.item.id))}: !shouldApply${i} ? false : appliers[${i}].fn(row),`).join('\n')}
};

return result$$;`.replaceAll('$$', String($0c70cf7c1343c218$var$filterItemsApplierId)));
    $0c70cf7c1343c218$var$filterItemsApplierId += 1;
    // Assign to the arrow function a name to help debugging
    const filterItem = (row, shouldApplyItem)=>filterItemCore(appliers, row, shouldApplyItem);
    return filterItem;
};
const $0c70cf7c1343c218$var$shouldQuickFilterExcludeHiddenColumns = (filterModel)=>{
    return filterModel.quickFilterExcludeHiddenColumns ?? true;
};
/**
 * @name filterValueGetter
 * @param {GridRowModel} row The row to get the value from.
 * @param {GridColDef} column The column that the filter is applied on.
 *
 * Generates a method to easily check if a row is matching the current quick filter.
 * @param {any[]} filterModel The model with which we want to filter the rows.
 * @param {FilterValueGetterFn} filterValueGetter The function to get the value to filter by.
 * @param {RefObject<GridPrivateApiCommunity>} apiRef The API of the grid.
 * @returns {GridAggregatedFilterItemApplier | null} A method that checks if a row is matching the current filter model. If `null`, we consider that all the rows are matching the filters.
 */ $0c70cf7c1343c218$exports.shouldQuickFilterExcludeHiddenColumns = $0c70cf7c1343c218$var$shouldQuickFilterExcludeHiddenColumns;
const $0c70cf7c1343c218$var$buildAggregatedQuickFilterApplier = (filterModel, filterValueGetter, apiRef)=>{
    const quickFilterValues = filterModel.quickFilterValues?.filter(Boolean) ?? [];
    if (quickFilterValues.length === 0) return null;
    const allColumnFields = (0, $e3b5f2e67362f55f$exports.gridColumnFieldsSelector)(apiRef);
    const columnVisibilityModel = (0, $e3b5f2e67362f55f$exports.gridColumnVisibilityModelSelector)(apiRef);
    let columnFields;
    if ($0c70cf7c1343c218$var$shouldQuickFilterExcludeHiddenColumns(filterModel)) // Do not use gridVisibleColumnFieldsSelector here, because quick filter won't work in the list view mode
    // See https://github.com/mui/mui-x/issues/19145
    columnFields = allColumnFields.filter((field)=>columnVisibilityModel[field] !== false);
    else columnFields = allColumnFields;
    const appliersPerField = [];
    const { ignoreDiacritics: ignoreDiacritics } = apiRef.current.rootProps;
    const publicApiRef = (0, $9ba5bb68a0cac1c6$exports.getPublicApiRef)(apiRef);
    columnFields.forEach((field)=>{
        const column = apiRef.current.getColumn(field);
        const getApplyQuickFilterFn = column?.getApplyQuickFilterFn;
        if (getApplyQuickFilterFn) appliersPerField.push({
            column: column,
            appliers: quickFilterValues.map((quickFilterValue)=>{
                const value = ignoreDiacritics ? $0c70cf7c1343c218$var$removeDiacritics(quickFilterValue) : quickFilterValue;
                return {
                    fn: getApplyQuickFilterFn(value, column, publicApiRef)
                };
            })
        });
    });
    return function isRowMatchingQuickFilter(row, shouldApplyFilter) {
        const result = {};
        /* eslint-disable no-labels */ outer: for(let v = 0; v < quickFilterValues.length; v += 1){
            const filterValue = quickFilterValues[v];
            for(let i = 0; i < appliersPerField.length; i += 1){
                const { column: column, appliers: appliers } = appliersPerField[i];
                const { field: field } = column;
                if (shouldApplyFilter && !shouldApplyFilter(field)) continue;
                const applier = appliers[v];
                let value = filterValueGetter(row, column);
                if (applier.fn === null) continue;
                if (ignoreDiacritics) value = $0c70cf7c1343c218$var$removeDiacritics(value);
                const isMatching = applier.fn(value, row, column, publicApiRef);
                if (isMatching) {
                    result[filterValue] = true;
                    continue outer;
                }
            }
            result[filterValue] = false;
        }
        return result;
    };
};
const $0c70cf7c1343c218$var$buildAggregatedFilterApplier = (filterModel, filterValueGetter, apiRef, disableEval)=>{
    const isRowMatchingFilterItems = $0c70cf7c1343c218$var$buildAggregatedFilterItemsApplier(filterModel, filterValueGetter, apiRef, disableEval);
    const isRowMatchingQuickFilter = $0c70cf7c1343c218$var$buildAggregatedQuickFilterApplier(filterModel, filterValueGetter, apiRef);
    return function isRowMatchingFilters(row, shouldApplyFilter, result) {
        result.passingFilterItems = isRowMatchingFilterItems?.(row, shouldApplyFilter) ?? null;
        result.passingQuickFilterValues = isRowMatchingQuickFilter?.(row, shouldApplyFilter) ?? null;
    };
};
$0c70cf7c1343c218$exports.buildAggregatedFilterApplier = $0c70cf7c1343c218$var$buildAggregatedFilterApplier;
const $0c70cf7c1343c218$var$isNotNull = (result)=>result != null;
const $0c70cf7c1343c218$var$filterModelItems = (cache, filterValueGetter, apiRef, items)=>{
    if (!cache.cleanedFilterItems) cache.cleanedFilterItems = items.filter((item)=>$0c70cf7c1343c218$var$getFilterCallbackFromItem(item, filterValueGetter, apiRef) !== null);
    return cache.cleanedFilterItems;
};
const $0c70cf7c1343c218$var$passFilterLogic = (allFilterItemResults, allQuickFilterResults, filterModel, filterValueGetter, apiRef, cache)=>{
    const cleanedFilterItems = $0c70cf7c1343c218$var$filterModelItems(cache, filterValueGetter, apiRef, filterModel.items);
    const cleanedFilterItemResults = allFilterItemResults.filter($0c70cf7c1343c218$var$isNotNull);
    const cleanedQuickFilterResults = allQuickFilterResults.filter($0c70cf7c1343c218$var$isNotNull);
    // get result for filter items model
    if (cleanedFilterItemResults.length > 0) {
        // Return true if the item pass with one of the rows
        const filterItemPredicate = (item)=>{
            return cleanedFilterItemResults.some((filterItemResult)=>filterItemResult[item.id]);
        };
        const logicOperator = filterModel.logicOperator ?? (0, $f582e8f6fdde33c9$exports.getDefaultGridFilterModel)().logicOperator;
        if (logicOperator === $2f20061a3ca46e99$exports.GridLogicOperator.And) {
            const passesAllFilters = cleanedFilterItems.every(filterItemPredicate);
            if (!passesAllFilters) return false;
        } else {
            const passesSomeFilters = cleanedFilterItems.some(filterItemPredicate);
            if (!passesSomeFilters) return false;
        }
    }
    // get result for quick filter model
    if (cleanedQuickFilterResults.length > 0 && filterModel.quickFilterValues != null) {
        // Return true if the item pass with one of the rows
        const quickFilterValuePredicate = (value)=>{
            return cleanedQuickFilterResults.some((quickFilterValueResult)=>quickFilterValueResult[value]);
        };
        const quickFilterLogicOperator = filterModel.quickFilterLogicOperator ?? (0, $f582e8f6fdde33c9$exports.getDefaultGridFilterModel)().quickFilterLogicOperator;
        if (quickFilterLogicOperator === $2f20061a3ca46e99$exports.GridLogicOperator.And) {
            const passesAllQuickFilterValues = filterModel.quickFilterValues.every(quickFilterValuePredicate);
            if (!passesAllQuickFilterValues) return false;
        } else {
            const passesSomeQuickFilterValues = filterModel.quickFilterValues.some(quickFilterValuePredicate);
            if (!passesSomeQuickFilterValues) return false;
        }
    }
    return true;
};
$0c70cf7c1343c218$exports.passFilterLogic = $0c70cf7c1343c218$var$passFilterLogic;


const $ced5632839836707$var$getGridStringQuickFilterFn = (value)=>{
    if (!value) return null;
    const filterRegex = new RegExp((0, $fe919794eb3b24e8$exports.escapeRegExp)(value), 'i');
    return (_, row, column, apiRef)=>{
        let columnValue = apiRef.current.getRowFormattedValue(row, column);
        if (apiRef.current.ignoreDiacritics) columnValue = (0, $0c70cf7c1343c218$exports.removeDiacritics)(columnValue);
        return columnValue != null ? filterRegex.test(columnValue.toString()) : false;
    };
};
$ced5632839836707$exports.getGridStringQuickFilterFn = $ced5632839836707$var$getGridStringQuickFilterFn;
const $ced5632839836707$var$createContainsFilterFn = (disableTrim, negate)=>(filterItem)=>{
        if (!filterItem.value) return null;
        const trimmedValue = disableTrim ? filterItem.value : filterItem.value.trim();
        const filterRegex = new RegExp((0, $fe919794eb3b24e8$exports.escapeRegExp)(trimmedValue), 'i');
        return (value)=>{
            if (value == null) return negate;
            const matches = filterRegex.test(String(value));
            return negate ? !matches : matches;
        };
    };
const $ced5632839836707$var$createEqualityFilterFn = (disableTrim, negate)=>(filterItem)=>{
        if (!filterItem.value) return null;
        const trimmedValue = disableTrim ? filterItem.value : filterItem.value.trim();
        const collator = new Intl.Collator(undefined, {
            sensitivity: 'base',
            usage: 'search'
        });
        return (value)=>{
            if (value == null) return negate;
            const isEqual = collator.compare(trimmedValue, value.toString()) === 0;
            return negate ? !isEqual : isEqual;
        };
    };
const $ced5632839836707$var$createEmptyFilterFn = (negate)=>()=>{
        return (value)=>{
            const isEmpty = value === '' || value == null;
            return negate ? !isEmpty : isEmpty;
        };
    };
const $ced5632839836707$var$getGridStringOperators = (disableTrim = false)=>[
        {
            value: 'contains',
            getApplyFilterFn: $ced5632839836707$var$createContainsFilterFn(disableTrim, false),
            InputComponent: $bbbaea9771a9f69f$exports.GridFilterInputValue
        },
        {
            value: 'doesNotContain',
            getApplyFilterFn: $ced5632839836707$var$createContainsFilterFn(disableTrim, true),
            InputComponent: $bbbaea9771a9f69f$exports.GridFilterInputValue
        },
        {
            value: 'equals',
            getApplyFilterFn: $ced5632839836707$var$createEqualityFilterFn(disableTrim, false),
            InputComponent: $bbbaea9771a9f69f$exports.GridFilterInputValue
        },
        {
            value: 'doesNotEqual',
            getApplyFilterFn: $ced5632839836707$var$createEqualityFilterFn(disableTrim, true),
            InputComponent: $bbbaea9771a9f69f$exports.GridFilterInputValue
        },
        {
            value: 'startsWith',
            getApplyFilterFn: (filterItem)=>{
                if (!filterItem.value) return null;
                const filterItemValue = disableTrim ? filterItem.value : filterItem.value.trim();
                const filterRegex = new RegExp(`^${(0, $fe919794eb3b24e8$exports.escapeRegExp)(filterItemValue)}.*$`, 'i');
                return (value)=>{
                    return value != null ? filterRegex.test(value.toString()) : false;
                };
            },
            InputComponent: $bbbaea9771a9f69f$exports.GridFilterInputValue
        },
        {
            value: 'endsWith',
            getApplyFilterFn: (filterItem)=>{
                if (!filterItem.value) return null;
                const filterItemValue = disableTrim ? filterItem.value : filterItem.value.trim();
                const filterRegex = new RegExp(`.*${(0, $fe919794eb3b24e8$exports.escapeRegExp)(filterItemValue)}$`, 'i');
                return (value)=>{
                    return value != null ? filterRegex.test(value.toString()) : false;
                };
            },
            InputComponent: $bbbaea9771a9f69f$exports.GridFilterInputValue
        },
        {
            value: 'isEmpty',
            getApplyFilterFn: $ced5632839836707$var$createEmptyFilterFn(false),
            requiresFilterValue: false
        },
        {
            value: 'isNotEmpty',
            getApplyFilterFn: $ced5632839836707$var$createEmptyFilterFn(true),
            requiresFilterValue: false
        },
        {
            value: 'isAnyOf',
            getApplyFilterFn: (filterItem)=>{
                if (!Array.isArray(filterItem.value) || filterItem.value.length === 0) return null;
                const filterItemValue = disableTrim ? filterItem.value : filterItem.value.map((val)=>val.trim());
                const collator = new Intl.Collator(undefined, {
                    sensitivity: 'base',
                    usage: 'search'
                });
                return (value)=>value != null ? filterItemValue.some((filterValue)=>{
                        return collator.compare(filterValue, value.toString() || '') === 0;
                    }) : false;
            },
            InputComponent: $4b64102825ff1e40$exports.GridFilterInputMultipleValue
        }
    ];
$ced5632839836707$exports.getGridStringOperators = $ced5632839836707$var$getGridStringOperators;


/**
 * TODO: Move pro and premium properties outside of this Community file
 */ const $8a69393405f257b1$var$GRID_STRING_COL_DEF = $8a69393405f257b1$exports.GRID_STRING_COL_DEF = {
    width: 100,
    minWidth: 50,
    maxWidth: Infinity,
    hideable: true,
    sortable: true,
    resizable: true,
    filterable: true,
    groupable: true,
    pinnable: true,
    // @ts-ignore
    aggregable: true,
    chartable: true,
    editable: false,
    sortComparator: $c78f90aae54b126e$exports.gridStringOrNumberComparator,
    type: 'string',
    align: 'left',
    filterOperators: (0, $ced5632839836707$exports.getGridStringOperators)(),
    renderEditCell: $387abc8f0fc4c9a9$exports.renderEditInputCell,
    getApplyQuickFilterFn: $ced5632839836707$exports.getGridStringQuickFilterFn
};


var $8e08f1e439e1e2b5$exports = {};
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $8e08f1e439e1e2b5$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $8e08f1e439e1e2b5$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($8e08f1e439e1e2b5$exports, "__esModule", {
    value: true
});
$8e08f1e439e1e2b5$exports.GridActionsCell = $8e08f1e439e1e2b5$var$GridActionsCell;
$8e08f1e439e1e2b5$exports.renderActionsCell = void 0;

var $8e08f1e439e1e2b5$var$_extends2 = $8e08f1e439e1e2b5$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $8e08f1e439e1e2b5$var$_objectWithoutPropertiesLoose2 = $8e08f1e439e1e2b5$require$_interopRequireDefault((parcelRequire("c05no")));

var $8e08f1e439e1e2b5$var$React = $8e08f1e439e1e2b5$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8e08f1e439e1e2b5$var$_propTypes = $8e08f1e439e1e2b5$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $9uEev = parcelRequire("9uEev");

var $8e08f1e439e1e2b5$var$_useId = $8e08f1e439e1e2b5$require$_interopRequireDefault((parcelRequire("hwliF")));

var $9Y8Cp = parcelRequire("9Y8Cp");

var $5H1vo = parcelRequire("5H1vo");
var $8efc7911d5661cb8$exports = {};
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $8efc7911d5661cb8$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $8efc7911d5661cb8$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($8efc7911d5661cb8$exports, "__esModule", {
    value: true
});
$8efc7911d5661cb8$exports.GridMenu = $8efc7911d5661cb8$var$GridMenu;

var $8efc7911d5661cb8$var$_extends2 = $8efc7911d5661cb8$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $8efc7911d5661cb8$var$_objectWithoutPropertiesLoose2 = $8efc7911d5661cb8$require$_interopRequireDefault((parcelRequire("c05no")));

var $8efc7911d5661cb8$var$React = $8efc7911d5661cb8$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8efc7911d5661cb8$var$_propTypes = $8efc7911d5661cb8$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8efc7911d5661cb8$var$_clsx = $8efc7911d5661cb8$require$_interopRequireDefault((parcelRequire("9QePP")));

var $8efc7911d5661cb8$var$_composeClasses = $8efc7911d5661cb8$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $8efc7911d5661cb8$var$_useEnhancedEffect = $8efc7911d5661cb8$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $8efc7911d5661cb8$var$_HTMLElementType = $8efc7911d5661cb8$require$_interopRequireDefault((parcelRequire("cIfK5")));

var $8xDHs = parcelRequire("8xDHs");
var $a08faead7d1bb429$exports = {};
"use strict";
Object.defineProperty($a08faead7d1bb429$exports, "__esModule", {
    value: true
});
$a08faead7d1bb429$exports.isCopyShortcut = $a08faead7d1bb429$var$isCopyShortcut;
$a08faead7d1bb429$exports.isNavigationKey = $a08faead7d1bb429$exports.isKeyboardEvent = $a08faead7d1bb429$exports.isHideMenuKey = void 0;
$a08faead7d1bb429$exports.isPasteShortcut = $a08faead7d1bb429$var$isPasteShortcut;
$a08faead7d1bb429$exports.isPrintableKey = $a08faead7d1bb429$var$isPrintableKey;
// Non printable keys have a name, for example "ArrowRight", see the whole list:
// https://developer.mozilla.org/en-US/docs/Web/API/UI_Events/Keyboard_event_key_values
// So event.key.length === 1 is often enough.
//
// However, we also need to ignore shortcuts, for example: select all:
// - Windows: Ctrl+A, event.ctrlKey is true
// - macOS: ⌘ Command+A, event.metaKey is true
function $a08faead7d1bb429$var$isPrintableKey(event) {
    return event.key.length === 1 && !event.ctrlKey && !event.metaKey;
}
const $a08faead7d1bb429$var$isNavigationKey = (key)=>key.indexOf('Arrow') === 0 || key.indexOf('Page') === 0 || key === ' ' || key === 'Home' || key === 'End';
$a08faead7d1bb429$exports.isNavigationKey = $a08faead7d1bb429$var$isNavigationKey;
const $a08faead7d1bb429$var$isKeyboardEvent = (event)=>!!event.key;
$a08faead7d1bb429$exports.isKeyboardEvent = $a08faead7d1bb429$var$isKeyboardEvent;
const $a08faead7d1bb429$var$isHideMenuKey = (key)=>key === 'Tab' || key === 'Escape';
// In theory, on macOS, ctrl + v doesn't trigger a paste, so the function should return false.
// However, maybe it's overkill to fix, so let's be lazy.
$a08faead7d1bb429$exports.isHideMenuKey = $a08faead7d1bb429$var$isHideMenuKey;
function $a08faead7d1bb429$var$isPasteShortcut(event) {
    return (event.ctrlKey || event.metaKey) && // We can't use event.code === 'KeyV' as event.code assumes a QWERTY keyboard layout,
    // for example, it would be another letter on a Dvorak physical keyboard.
    // We can't use event.key === 'v' as event.key is not stable with key modifiers and keyboard layouts,
    // for example, it would be ה on a Hebrew keyboard layout.
    // https://github.com/w3c/uievents/issues/377 could be a long-term solution
    String.fromCharCode(event.keyCode) === 'V' && !event.shiftKey && !event.altKey;
}
// Checks if the keyboard event corresponds to the copy shortcut (CTRL+C or CMD+C) across different localization keyboards.
function $a08faead7d1bb429$var$isCopyShortcut(event) {
    return (event.ctrlKey || event.metaKey) && String.fromCharCode(event.keyCode) === 'C' && !event.shiftKey && !event.altKey;
}



var $hbuUJ = parcelRequire("hbuUJ");
var $2a727ae4835cc807$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $2a727ae4835cc807$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($2a727ae4835cc807$exports, "__esModule", {
    value: true
});
$2a727ae4835cc807$exports.GridCSSVariablesContext = $2a727ae4835cc807$var$GridCSSVariablesContext;
$2a727ae4835cc807$exports.GridPortalWrapper = $2a727ae4835cc807$var$GridPortalWrapper;
$2a727ae4835cc807$exports.useCSSVariablesClass = $2a727ae4835cc807$var$useCSSVariablesClass;
$2a727ae4835cc807$exports.useCSSVariablesContext = $2a727ae4835cc807$var$useCSSVariablesContext;

var $2a727ae4835cc807$var$React = $2a727ae4835cc807$require$_interopRequireWildcard((parcelRequire("acw62")));

var $jDpXp = parcelRequire("jDpXp");
var $2b6c64068d1db0b4$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $2b6c64068d1db0b4$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($2b6c64068d1db0b4$exports, "__esModule", {
    value: true
});
$2b6c64068d1db0b4$exports.useGridConfiguration = void 0;

var $2b6c64068d1db0b4$var$React = $2b6c64068d1db0b4$require$_interopRequireWildcard((parcelRequire("acw62")));
var $dfe2502031b16236$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $dfe2502031b16236$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($dfe2502031b16236$exports, "__esModule", {
    value: true
});
$dfe2502031b16236$exports.GridConfigurationContext = void 0;

var $dfe2502031b16236$var$React = $dfe2502031b16236$require$_interopRequireWildcard((parcelRequire("acw62")));
const $dfe2502031b16236$var$GridConfigurationContext = $dfe2502031b16236$exports.GridConfigurationContext = /*#__PURE__*/ $dfe2502031b16236$var$React.createContext(undefined);
$dfe2502031b16236$var$GridConfigurationContext.displayName = "GridConfigurationContext";


const $2b6c64068d1db0b4$var$useGridConfiguration = ()=>{
    const configuration = $2b6c64068d1db0b4$var$React.useContext($dfe2502031b16236$exports.GridConfigurationContext);
    if (configuration === undefined) throw new Error([
        'MUI X: Could not find the Data Grid configuration context.',
        'It looks like you rendered your component outside of a DataGrid, DataGridPro or DataGridPremium parent component.',
        'This can also happen if you are bundling multiple versions of the Data Grid.'
    ].join('\n'));
    return configuration;
};
$2b6c64068d1db0b4$exports.useGridConfiguration = $2b6c64068d1db0b4$var$useGridConfiguration;



var $ayMG0 = parcelRequire("ayMG0");
const $2a727ae4835cc807$var$CLASSNAME_PREFIX = 'MuiDataGridVariables';
const $2a727ae4835cc807$var$CSSVariablesContext = /*#__PURE__*/ $2a727ae4835cc807$var$React.createContext({
    className: 'unset',
    tag: /*#__PURE__*/ (0, $ayMG0.jsx)("style", {
        href: "/unset"
    })
});
$2a727ae4835cc807$var$CSSVariablesContext.displayName = "CSSVariablesContext";
function $2a727ae4835cc807$var$useCSSVariablesClass() {
    return $2a727ae4835cc807$var$React.useContext($2a727ae4835cc807$var$CSSVariablesContext).className;
}
function $2a727ae4835cc807$var$useCSSVariablesContext() {
    return $2a727ae4835cc807$var$React.useContext($2a727ae4835cc807$var$CSSVariablesContext);
}
function $2a727ae4835cc807$var$GridPortalWrapper({ children: children }) {
    const className = $2a727ae4835cc807$var$useCSSVariablesClass();
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: children
    });
}
function $2a727ae4835cc807$var$GridCSSVariablesContext(props) {
    const config = (0, $2b6c64068d1db0b4$exports.useGridConfiguration)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const description = config.hooks.useCSSVariables();
    const context = $2a727ae4835cc807$var$React.useMemo(()=>{
        const className = `${$2a727ae4835cc807$var$CLASSNAME_PREFIX}-${description.id}`;
        const cssString = `.${className}{${$2a727ae4835cc807$var$variablesToString(description.variables)}}`;
        const tag = /*#__PURE__*/ (0, $ayMG0.jsx)("style", {
            href: `/${className}`,
            nonce: rootProps.nonce,
            children: cssString
        });
        return {
            className: className,
            tag: tag
        };
    }, [
        rootProps.nonce,
        description
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($2a727ae4835cc807$var$CSSVariablesContext.Provider, {
        value: context,
        children: props.children
    });
}
function $2a727ae4835cc807$var$variablesToString(variables) {
    let output = '';
    for(const key in variables)if (Object.hasOwn(variables, key) && variables[key] !== undefined) output += `${key}:${variables[key]};`;
    return output;
}



var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $bDyDY = parcelRequire("bDyDY");


var $ayMG0 = parcelRequire("ayMG0");
const $8efc7911d5661cb8$var$_excluded = [
    "open",
    "target",
    "onClose",
    "children",
    "position",
    "className",
    "onExited"
];
const $8efc7911d5661cb8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'menu'
        ]
    };
    return (0, $8efc7911d5661cb8$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $8efc7911d5661cb8$var$GridMenuRoot = (0, $8xDHs.styled)($dd66ac2a2c256d30$exports.NotRendered, {
    name: 'MuiDataGrid',
    slot: 'Menu'
})({
    zIndex: $hbuUJ.vars.zIndex.menu,
    [`& .${$5H1vo.gridClasses.menuList}`]: {
        outline: 0
    }
});
function $8efc7911d5661cb8$var$GridMenu(props) {
    const { open: open, target: target, onClose: onClose, children: children, position: position, className: className, onExited: onExited } = props, other = (0, $8efc7911d5661cb8$var$_objectWithoutPropertiesLoose2.default)(props, $8efc7911d5661cb8$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $8efc7911d5661cb8$var$useUtilityClasses(rootProps);
    const variablesClass = (0, $2a727ae4835cc807$exports.useCSSVariablesClass)();
    const savedFocusRef = $8efc7911d5661cb8$var$React.useRef(null);
    (0, $8efc7911d5661cb8$var$_useEnhancedEffect.default)(()=>{
        if (open) savedFocusRef.current = document.activeElement instanceof HTMLElement ? document.activeElement : null;
        else {
            savedFocusRef.current?.focus?.();
            savedFocusRef.current = null;
        }
    }, [
        open
    ]);
    $8efc7911d5661cb8$var$React.useEffect(()=>{
        // Emit menuOpen or menuClose events
        const eventName = open ? 'menuOpen' : 'menuClose';
        apiRef.current.publishEvent(eventName, {
            target: target
        });
    }, [
        apiRef,
        open,
        target
    ]);
    const handleClickAway = (event)=>{
        if (event.target && (target === event.target || target?.contains(event.target))) return;
        onClose(event);
    };
    const handleKeyDown = (event)=>{
        if ((0, $a08faead7d1bb429$exports.isHideMenuKey)(event.key)) onClose(event);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($8efc7911d5661cb8$var$GridMenuRoot, (0, $8efc7911d5661cb8$var$_extends2.default)({
        as: rootProps.slots.basePopper,
        className: (0, $8efc7911d5661cb8$var$_clsx.default)(classes.root, className, variablesClass),
        ownerState: rootProps,
        open: open,
        target: target,
        transition: true,
        placement: position,
        onClickAway: handleClickAway,
        onExited: onExited,
        clickAwayMouseEvent: "onMouseDown",
        onKeyDown: handleKeyDown
    }, other, rootProps.slotProps?.basePopper, {
        children: children
    }));
}
$8efc7911d5661cb8$var$GridMenu.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    children: $8efc7911d5661cb8$var$_propTypes.default.node,
    className: $8efc7911d5661cb8$var$_propTypes.default.string,
    onClose: $8efc7911d5661cb8$var$_propTypes.default.func.isRequired,
    onExited: $8efc7911d5661cb8$var$_propTypes.default.func,
    open: $8efc7911d5661cb8$var$_propTypes.default.bool.isRequired,
    position: $8efc7911d5661cb8$var$_propTypes.default.oneOf([
        'bottom-end',
        'bottom-start',
        'bottom',
        'left-end',
        'left-start',
        'left',
        'right-end',
        'right-start',
        'right',
        'top-end',
        'top-start',
        'top'
    ]),
    target: $8efc7911d5661cb8$var$_HTMLElementType.default
};



var $jDpXp = parcelRequire("jDpXp");

var $bDyDY = parcelRequire("bDyDY");
var $5785bd871901a1ec$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5785bd871901a1ec$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $5785bd871901a1ec$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($5785bd871901a1ec$exports, "__esModule", {
    value: true
});
$5785bd871901a1ec$exports.GridActionsCellItem = void 0;

var $5785bd871901a1ec$var$_extends2 = $5785bd871901a1ec$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $5785bd871901a1ec$var$_objectWithoutPropertiesLoose2 = $5785bd871901a1ec$require$_interopRequireDefault((parcelRequire("c05no")));

var $5785bd871901a1ec$var$React = $5785bd871901a1ec$require$_interopRequireWildcard((parcelRequire("acw62")));

var $fYxgT = parcelRequire("fYxgT");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $5785bd871901a1ec$var$_excluded = [
    "label",
    "icon",
    "showInMenu",
    "onClick"
], $5785bd871901a1ec$var$_excluded2 = [
    "label",
    "icon",
    "showInMenu",
    "onClick",
    "closeMenuOnClick",
    "closeMenu"
];
const $5785bd871901a1ec$var$GridActionsCellItem = $5785bd871901a1ec$exports.GridActionsCellItem = (0, $fYxgT.forwardRef)((props, ref)=>{
    const rootProps = (0, $jDpXp.useGridRootProps)();
    if (!props.showInMenu) {
        const { label: label, icon: icon, onClick: onClick } = props, other = (0, $5785bd871901a1ec$var$_objectWithoutPropertiesLoose2.default)(props, $5785bd871901a1ec$var$_excluded);
        const handleClick = (event)=>{
            onClick?.(event);
        };
        return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseIconButton, (0, $5785bd871901a1ec$var$_extends2.default)({
            size: "small",
            role: "menuitem",
            "aria-label": label
        }, other, {
            onClick: handleClick
        }, rootProps.slotProps?.baseIconButton, {
            ref: ref,
            children: /*#__PURE__*/ $5785bd871901a1ec$var$React.cloneElement(icon, {
                fontSize: 'small'
            })
        }));
    }
    const { label: label, icon: icon, onClick: onClick, closeMenuOnClick: closeMenuOnClick = true, closeMenu: closeMenu } = props, other = (0, $5785bd871901a1ec$var$_objectWithoutPropertiesLoose2.default)(props, $5785bd871901a1ec$var$_excluded2);
    const handleClick = (event)=>{
        onClick?.(event);
        if (closeMenuOnClick) closeMenu?.();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseMenuItem, (0, $5785bd871901a1ec$var$_extends2.default)({
        ref: ref
    }, other, {
        onClick: handleClick,
        iconStart: icon,
        children: label
    }));
});
$5785bd871901a1ec$var$GridActionsCellItem.displayName = "GridActionsCellItem";



var $ayMG0 = parcelRequire("ayMG0");
const $8e08f1e439e1e2b5$var$_excluded = [
    "api",
    "colDef",
    "id",
    "hasFocus",
    "isEditable",
    "field",
    "value",
    "formattedValue",
    "row",
    "rowNode",
    "cellMode",
    "tabIndex",
    "position",
    "children",
    "suppressChildrenValidation"
];
const $8e08f1e439e1e2b5$var$hasActions = (colDef)=>typeof colDef.getActions === 'function';
function $8e08f1e439e1e2b5$var$GridActionsCell(props) {
    const { hasFocus: hasFocus, tabIndex: tabIndex, position: position = 'bottom-end', children: children, suppressChildrenValidation: suppressChildrenValidation } = props, other = (0, $8e08f1e439e1e2b5$var$_objectWithoutPropertiesLoose2.default)(props, $8e08f1e439e1e2b5$var$_excluded);
    const [focusedButtonIndex, setFocusedButtonIndex] = $8e08f1e439e1e2b5$var$React.useState(-1);
    const [open, setOpen] = $8e08f1e439e1e2b5$var$React.useState(false);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootRef = $8e08f1e439e1e2b5$var$React.useRef(null);
    const buttonRef = $8e08f1e439e1e2b5$var$React.useRef(null);
    const ignoreCallToFocus = $8e08f1e439e1e2b5$var$React.useRef(false);
    const touchRippleRefs = $8e08f1e439e1e2b5$var$React.useRef({});
    const isRtl = (0, $9uEev.useRtl)();
    const menuId = (0, $8e08f1e439e1e2b5$var$_useId.default)();
    const buttonId = (0, $8e08f1e439e1e2b5$var$_useId.default)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const actions = [];
    $8e08f1e439e1e2b5$var$React.Children.forEach(children, (child)=>{
        // Unwrap React.Fragment
        if (/*#__PURE__*/ $8e08f1e439e1e2b5$var$React.isValidElement(child)) {
            if (child.type === $8e08f1e439e1e2b5$var$React.Fragment) $8e08f1e439e1e2b5$var$React.Children.forEach(child.props.children, (fragChild)=>{
                if (/*#__PURE__*/ $8e08f1e439e1e2b5$var$React.isValidElement(fragChild)) actions.push(fragChild);
            });
            else if (child.type === $5785bd871901a1ec$exports.GridActionsCellItem || suppressChildrenValidation) actions.push(child);
            else {
                const childType = typeof child.type === 'function' ? child.type.name : child.type;
                (0, $9Y8Cp.warnOnce)(`MUI X: Invalid child type in \`GridActionsCell\`. Expected \`GridActionsCellItem\` or \`React.Fragment\`, got \`${childType}\`.
If this is intentional, you can suppress this warning by passing the \`suppressChildrenValidation\` prop to \`GridActionsCell\`.`, 'error');
            }
        }
    });
    const iconButtons = actions.filter((option)=>!option.props.showInMenu);
    const menuButtons = actions.filter((option)=>option.props.showInMenu);
    const numberOfButtons = iconButtons.length + (menuButtons.length ? 1 : 0);
    $8e08f1e439e1e2b5$var$React.useLayoutEffect(()=>{
        if (!hasFocus) Object.entries(touchRippleRefs.current).forEach(([index, ref])=>{
            ref?.stop({}, ()=>{
                delete touchRippleRefs.current[index];
            });
        });
    }, [
        hasFocus
    ]);
    $8e08f1e439e1e2b5$var$React.useEffect(()=>{
        if (focusedButtonIndex < 0 || !rootRef.current) return;
        if (focusedButtonIndex >= rootRef.current.children.length) return;
        const child = rootRef.current.children[focusedButtonIndex];
        child.focus({
            preventScroll: true
        });
    }, [
        focusedButtonIndex
    ]);
    const firstFocusableButtonIndex = actions.findIndex((o)=>!o.props.disabled);
    $8e08f1e439e1e2b5$var$React.useEffect(()=>{
        if (hasFocus && focusedButtonIndex === -1) setFocusedButtonIndex(firstFocusableButtonIndex);
        if (!hasFocus) {
            setFocusedButtonIndex(-1);
            ignoreCallToFocus.current = false;
        }
    }, [
        hasFocus,
        focusedButtonIndex,
        firstFocusableButtonIndex
    ]);
    $8e08f1e439e1e2b5$var$React.useEffect(()=>{
        if (focusedButtonIndex >= numberOfButtons) setFocusedButtonIndex(numberOfButtons - 1);
    }, [
        focusedButtonIndex,
        numberOfButtons
    ]);
    const showMenu = ()=>{
        setOpen(true);
        setFocusedButtonIndex(numberOfButtons - 1);
        ignoreCallToFocus.current = true;
    };
    const hideMenu = ()=>{
        setOpen(false);
    };
    const toggleMenu = (event)=>{
        event.stopPropagation();
        event.preventDefault();
        if (open) hideMenu();
        else showMenu();
    };
    const handleTouchRippleRef = (index)=>(instance)=>{
            touchRippleRefs.current[index] = instance;
        };
    const handleButtonClick = (index, onClick)=>(event)=>{
            setFocusedButtonIndex(index);
            ignoreCallToFocus.current = true;
            if (onClick) onClick(event);
        };
    const handleRootKeyDown = (event)=>{
        if (numberOfButtons <= 1) return;
        const getNewIndex = (index, direction)=>{
            if (index < 0 || index > actions.length) return index;
            // for rtl mode we need to reverse the direction
            const rtlMod = isRtl ? -1 : 1;
            const indexMod = (direction === 'left' ? -1 : 1) * rtlMod;
            // if the button that should receive focus is disabled go one more step
            return actions[index + indexMod]?.props.disabled ? getNewIndex(index + indexMod, direction) : index + indexMod;
        };
        let newIndex = focusedButtonIndex;
        if (event.key === 'ArrowRight') newIndex = getNewIndex(focusedButtonIndex, 'right');
        else if (event.key === 'ArrowLeft') newIndex = getNewIndex(focusedButtonIndex, 'left');
        if (newIndex < 0 || newIndex >= numberOfButtons) return; // We're already in the first or last item = do nothing and let the grid listen the event
        if (newIndex !== focusedButtonIndex) {
            event.preventDefault(); // Prevent scrolling
            event.stopPropagation(); // Don't stop propagation for other keys, for example ArrowUp
            setFocusedButtonIndex(newIndex);
        }
    };
    // role="menu" requires at least one child element
    const attributes = numberOfButtons > 0 ? {
        role: 'menu',
        onKeyDown: handleRootKeyDown
    } : undefined;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", (0, $8e08f1e439e1e2b5$var$_extends2.default)({
        ref: rootRef,
        tabIndex: -1,
        className: $5H1vo.gridClasses.actionsCell
    }, attributes, other, {
        children: [
            iconButtons.map((button, index)=>/*#__PURE__*/ $8e08f1e439e1e2b5$var$React.cloneElement(button, {
                    key: index,
                    touchRippleRef: handleTouchRippleRef(index),
                    onClick: handleButtonClick(index, button.props.onClick),
                    tabIndex: focusedButtonIndex === index ? tabIndex : -1
                })),
            menuButtons.length > 0 && buttonId && /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseIconButton, (0, $8e08f1e439e1e2b5$var$_extends2.default)({
                ref: buttonRef,
                id: buttonId,
                "aria-label": apiRef.current.getLocaleText('actionsCellMore'),
                "aria-haspopup": "menu",
                "aria-expanded": open,
                "aria-controls": open ? menuId : undefined,
                role: "menuitem",
                size: "small",
                onClick: toggleMenu,
                touchRippleRef: handleTouchRippleRef(buttonId),
                tabIndex: focusedButtonIndex === iconButtons.length ? tabIndex : -1
            }, rootProps.slotProps?.baseIconButton, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.moreActionsIcon, {
                    fontSize: "small"
                })
            })),
            menuButtons.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)($8efc7911d5661cb8$exports.GridMenu, {
                open: open,
                target: buttonRef.current,
                position: position,
                onClose: hideMenu,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseMenuList, {
                    id: menuId,
                    className: $5H1vo.gridClasses.menuList,
                    "aria-labelledby": buttonId,
                    autoFocusItem: true,
                    children: menuButtons.map((button, index)=>/*#__PURE__*/ $8e08f1e439e1e2b5$var$React.cloneElement(button, {
                            key: index,
                            closeMenu: hideMenu
                        }))
                })
            })
        ]
    }));
}
$8e08f1e439e1e2b5$var$GridActionsCell.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    api: $8e08f1e439e1e2b5$var$_propTypes.default.object,
    /**
   * The mode of the cell.
   */ cellMode: $8e08f1e439e1e2b5$var$_propTypes.default.oneOf([
        'edit',
        'view'
    ]).isRequired,
    children: $8e08f1e439e1e2b5$var$_propTypes.default.node.isRequired,
    /**
   * The column of the row that the current cell belongs to.
   */ colDef: $8e08f1e439e1e2b5$var$_propTypes.default.object.isRequired,
    /**
   * The column field of the cell that triggered the event.
   */ field: $8e08f1e439e1e2b5$var$_propTypes.default.string.isRequired,
    /**
   * The cell value formatted with the column valueFormatter.
   */ formattedValue: $8e08f1e439e1e2b5$var$_propTypes.default.any,
    /**
   * If true, the cell is the active element.
   */ hasFocus: $8e08f1e439e1e2b5$var$_propTypes.default.bool.isRequired,
    /**
   * The grid row id.
   */ id: $8e08f1e439e1e2b5$var$_propTypes.default.oneOfType([
        $8e08f1e439e1e2b5$var$_propTypes.default.number,
        $8e08f1e439e1e2b5$var$_propTypes.default.string
    ]).isRequired,
    /**
   * If true, the cell is editable.
   */ isEditable: $8e08f1e439e1e2b5$var$_propTypes.default.bool,
    position: $8e08f1e439e1e2b5$var$_propTypes.default.oneOf([
        'bottom-end',
        'bottom-start',
        'bottom',
        'left-end',
        'left-start',
        'left',
        'right-end',
        'right-start',
        'right',
        'top-end',
        'top-start',
        'top'
    ]),
    /**
   * The row model of the row that the current cell belongs to.
   */ row: $8e08f1e439e1e2b5$var$_propTypes.default.any.isRequired,
    /**
   * The node of the row that the current cell belongs to.
   */ rowNode: $8e08f1e439e1e2b5$var$_propTypes.default.object.isRequired,
    /**
   * the tabIndex value.
   */ tabIndex: $8e08f1e439e1e2b5$var$_propTypes.default.oneOf([
        -1,
        0
    ]).isRequired,
    /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */ value: $8e08f1e439e1e2b5$var$_propTypes.default.any
};
// Temporary wrapper for backward compatibility.
// Only used to support `getActions` method in `GridColDef`.
// TODO(v9): Remove this wrapper and the default `renderCell` in gridActionsColDef
function $8e08f1e439e1e2b5$var$GridActionsCellWrapper(props) {
    const { colDef: colDef, id: id } = props;
    const apiRef = (0, $bDyDY.useGridApiContext)();
    if (!$8e08f1e439e1e2b5$var$hasActions(colDef)) throw new Error('MUI X: Missing the `getActions` property in the `GridColDef`.');
    const actions = colDef.getActions(apiRef.current.getRowParams(id));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($8e08f1e439e1e2b5$var$GridActionsCell, (0, $8e08f1e439e1e2b5$var$_extends2.default)({
        suppressChildrenValidation: true
    }, props, {
        children: actions
    }));
}
const $8e08f1e439e1e2b5$var$renderActionsCell = (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)($8e08f1e439e1e2b5$var$GridActionsCellWrapper, (0, $8e08f1e439e1e2b5$var$_extends2.default)({}, params));
$8e08f1e439e1e2b5$exports.renderActionsCell = $8e08f1e439e1e2b5$var$renderActionsCell;
$8e08f1e439e1e2b5$var$renderActionsCell.displayName = "renderActionsCell";


const $63c3e445c9bf0af1$var$GRID_ACTIONS_COLUMN_TYPE = $63c3e445c9bf0af1$exports.GRID_ACTIONS_COLUMN_TYPE = 'actions';
const $63c3e445c9bf0af1$var$GRID_ACTIONS_COL_DEF = $63c3e445c9bf0af1$exports.GRID_ACTIONS_COL_DEF = (0, $63c3e445c9bf0af1$var$_extends2.default)({}, $8a69393405f257b1$exports.GRID_STRING_COL_DEF, {
    sortable: false,
    filterable: false,
    // @ts-ignore
    aggregable: false,
    chartable: false,
    width: 100,
    display: 'flex',
    align: 'center',
    headerAlign: 'center',
    headerName: '',
    disableColumnMenu: true,
    disableExport: true,
    renderCell: $8e08f1e439e1e2b5$exports.renderActionsCell,
    getApplyQuickFilterFn: ()=>null
});


Object.keys($63c3e445c9bf0af1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $a6506085715c5aff$exports && $a6506085715c5aff$exports[key] === $63c3e445c9bf0af1$exports[key]) return;
    Object.defineProperty($a6506085715c5aff$exports, key, {
        enumerable: true,
        get: function() {
            return $63c3e445c9bf0af1$exports[key];
        }
    });
});
var $daf44030e7d36790$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $daf44030e7d36790$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($daf44030e7d36790$exports, "__esModule", {
    value: true
});
$daf44030e7d36790$exports.GRID_BOOLEAN_COL_DEF = void 0;

var $daf44030e7d36790$var$_extends2 = $daf44030e7d36790$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $6324800d89fce0fa$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $6324800d89fce0fa$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $6324800d89fce0fa$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($6324800d89fce0fa$exports, "__esModule", {
    value: true
});
$6324800d89fce0fa$exports.renderBooleanCell = $6324800d89fce0fa$exports.GridBooleanCell = void 0;

var $6324800d89fce0fa$var$_extends2 = $6324800d89fce0fa$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $6324800d89fce0fa$var$_objectWithoutPropertiesLoose2 = $6324800d89fce0fa$require$_interopRequireDefault((parcelRequire("c05no")));

var $6324800d89fce0fa$var$React = $6324800d89fce0fa$require$_interopRequireWildcard((parcelRequire("acw62")));

var $6324800d89fce0fa$var$_propTypes = $6324800d89fce0fa$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $6324800d89fce0fa$var$_composeClasses = $6324800d89fce0fa$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $5sOMZ = parcelRequire("5sOMZ");


var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $bDyDY = parcelRequire("bDyDY");

var $e8d35a7c12bdaa1d$exports = {};
"use strict";
Object.defineProperty($e8d35a7c12bdaa1d$exports, "__esModule", {
    value: true
});
$e8d35a7c12bdaa1d$exports.PinnedColumnPosition = $e8d35a7c12bdaa1d$exports.GRID_TREE_DATA_GROUPING_FIELD = $e8d35a7c12bdaa1d$exports.GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD = $e8d35a7c12bdaa1d$exports.GRID_DETAIL_PANEL_TOGGLE_FIELD = void 0;
const $e8d35a7c12bdaa1d$var$GRID_TREE_DATA_GROUPING_FIELD = $e8d35a7c12bdaa1d$exports.GRID_TREE_DATA_GROUPING_FIELD = '__tree_data_group__';
const $e8d35a7c12bdaa1d$var$GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD = $e8d35a7c12bdaa1d$exports.GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD = '__row_group_by_columns_group__';
const $e8d35a7c12bdaa1d$var$GRID_DETAIL_PANEL_TOGGLE_FIELD = $e8d35a7c12bdaa1d$exports.GRID_DETAIL_PANEL_TOGGLE_FIELD = '__detail_panel_toggle__';
let $e8d35a7c12bdaa1d$var$PinnedColumnPosition = $e8d35a7c12bdaa1d$exports.PinnedColumnPosition = /*#__PURE__*/ function(PinnedColumnPosition) {
    PinnedColumnPosition[PinnedColumnPosition["NONE"] = 0] = "NONE";
    PinnedColumnPosition[PinnedColumnPosition["LEFT"] = 1] = "LEFT";
    PinnedColumnPosition[PinnedColumnPosition["RIGHT"] = 2] = "RIGHT";
    PinnedColumnPosition[PinnedColumnPosition["VIRTUAL"] = 3] = "VIRTUAL";
    return PinnedColumnPosition;
}({});



var $ayMG0 = parcelRequire("ayMG0");
const $6324800d89fce0fa$var$_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "hasFocus",
    "tabIndex",
    "hideDescendantCount"
];
const $6324800d89fce0fa$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'booleanCell'
        ]
    };
    return (0, $6324800d89fce0fa$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
function $6324800d89fce0fa$var$GridBooleanCellRaw(props) {
    const { value: value, rowNode: rowNode } = props, other = (0, $6324800d89fce0fa$var$_objectWithoutPropertiesLoose2.default)(props, $6324800d89fce0fa$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = $6324800d89fce0fa$var$useUtilityClasses(ownerState);
    const maxDepth = (0, $5sOMZ.useGridSelector)(apiRef, $befccaa56b49492d$exports.gridRowMaximumTreeDepthSelector);
    const isServerSideRowGroupingRow = // @ts-expect-error - Access tree data prop
    maxDepth > 0 && rowNode.type === 'group' && rootProps.treeData === false;
    const Icon = $6324800d89fce0fa$var$React.useMemo(()=>value ? rootProps.slots.booleanCellTrueIcon : rootProps.slots.booleanCellFalseIcon, [
        rootProps.slots.booleanCellFalseIcon,
        rootProps.slots.booleanCellTrueIcon,
        value
    ]);
    if (isServerSideRowGroupingRow && value === undefined) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, (0, $6324800d89fce0fa$var$_extends2.default)({
        fontSize: "small",
        className: classes.root,
        titleAccess: apiRef.current.getLocaleText(value ? 'booleanCellTrueLabel' : 'booleanCellFalseLabel'),
        "data-value": Boolean(value)
    }, other));
}
$6324800d89fce0fa$var$GridBooleanCellRaw.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * GridApi that let you manipulate the grid.
   */ api: $6324800d89fce0fa$var$_propTypes.default.object.isRequired,
    /**
   * The mode of the cell.
   */ cellMode: $6324800d89fce0fa$var$_propTypes.default.oneOf([
        'edit',
        'view'
    ]).isRequired,
    /**
   * The column of the row that the current cell belongs to.
   */ colDef: $6324800d89fce0fa$var$_propTypes.default.object.isRequired,
    /**
   * The column field of the cell that triggered the event.
   */ field: $6324800d89fce0fa$var$_propTypes.default.string.isRequired,
    /**
   * The cell value formatted with the column valueFormatter.
   */ formattedValue: $6324800d89fce0fa$var$_propTypes.default.any,
    /**
   * If true, the cell is the active element.
   */ hasFocus: $6324800d89fce0fa$var$_propTypes.default.bool.isRequired,
    hideDescendantCount: $6324800d89fce0fa$var$_propTypes.default.bool,
    /**
   * The grid row id.
   */ id: $6324800d89fce0fa$var$_propTypes.default.oneOfType([
        $6324800d89fce0fa$var$_propTypes.default.number,
        $6324800d89fce0fa$var$_propTypes.default.string
    ]).isRequired,
    /**
   * If true, the cell is editable.
   */ isEditable: $6324800d89fce0fa$var$_propTypes.default.bool,
    /**
   * The row model of the row that the current cell belongs to.
   */ row: $6324800d89fce0fa$var$_propTypes.default.any.isRequired,
    /**
   * The node of the row that the current cell belongs to.
   */ rowNode: $6324800d89fce0fa$var$_propTypes.default.object.isRequired,
    /**
   * the tabIndex value.
   */ tabIndex: $6324800d89fce0fa$var$_propTypes.default.oneOf([
        -1,
        0
    ]).isRequired,
    /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */ value: $6324800d89fce0fa$var$_propTypes.default.any
};
const $6324800d89fce0fa$var$GridBooleanCell = $6324800d89fce0fa$exports.GridBooleanCell = /*#__PURE__*/ $6324800d89fce0fa$var$React.memo($6324800d89fce0fa$var$GridBooleanCellRaw);
$6324800d89fce0fa$var$GridBooleanCell.displayName = "GridBooleanCell";
const $6324800d89fce0fa$var$renderBooleanCell = (params)=>{
    if (params.field !== $e8d35a7c12bdaa1d$exports.GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD && (0, $0166dd44615cae0d$exports.isAutogeneratedRowNode)(params.rowNode)) return '';
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6324800d89fce0fa$var$GridBooleanCell, (0, $6324800d89fce0fa$var$_extends2.default)({}, params));
};
$6324800d89fce0fa$exports.renderBooleanCell = $6324800d89fce0fa$var$renderBooleanCell;
$6324800d89fce0fa$var$renderBooleanCell.displayName = "renderBooleanCell";


var $cb74606ec716e4c3$exports = {};
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $cb74606ec716e4c3$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $cb74606ec716e4c3$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($cb74606ec716e4c3$exports, "__esModule", {
    value: true
});
$cb74606ec716e4c3$exports.GridEditBooleanCell = $cb74606ec716e4c3$var$GridEditBooleanCell;
$cb74606ec716e4c3$exports.renderEditBooleanCell = void 0;

var $cb74606ec716e4c3$var$_extends2 = $cb74606ec716e4c3$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $cb74606ec716e4c3$var$_objectWithoutPropertiesLoose2 = $cb74606ec716e4c3$require$_interopRequireDefault((parcelRequire("c05no")));

var $cb74606ec716e4c3$var$React = $cb74606ec716e4c3$require$_interopRequireWildcard((parcelRequire("acw62")));

var $cb74606ec716e4c3$var$_propTypes = $cb74606ec716e4c3$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $cb74606ec716e4c3$var$_clsx = $cb74606ec716e4c3$require$_interopRequireDefault((parcelRequire("9QePP")));

var $cb74606ec716e4c3$var$_composeClasses = $cb74606ec716e4c3$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $cb74606ec716e4c3$var$_useId = $cb74606ec716e4c3$require$_interopRequireDefault((parcelRequire("hwliF")));

var $cb74606ec716e4c3$var$_useEnhancedEffect = $cb74606ec716e4c3$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $bDyDY = parcelRequire("bDyDY");

var $ayMG0 = parcelRequire("ayMG0");
const $cb74606ec716e4c3$var$_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "tabIndex",
    "className",
    "hasFocus",
    "isValidating",
    "isProcessingProps",
    "error",
    "onValueChange"
];
const $cb74606ec716e4c3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'editBooleanCell'
        ]
    };
    return (0, $cb74606ec716e4c3$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
function $cb74606ec716e4c3$var$GridEditBooleanCell(props) {
    const { id: idProp, value: value, field: field, className: className, hasFocus: hasFocus, onValueChange: onValueChange } = props, other = (0, $cb74606ec716e4c3$var$_objectWithoutPropertiesLoose2.default)(props, $cb74606ec716e4c3$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const inputRef = $cb74606ec716e4c3$var$React.useRef(null);
    const id = (0, $cb74606ec716e4c3$var$_useId.default)();
    const [valueState, setValueState] = $cb74606ec716e4c3$var$React.useState(value);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = $cb74606ec716e4c3$var$useUtilityClasses(ownerState);
    const handleChange = $cb74606ec716e4c3$var$React.useCallback(async (event)=>{
        const newValue = event.target.checked;
        if (onValueChange) await onValueChange(event, newValue);
        setValueState(newValue);
        await apiRef.current.setEditCellValue({
            id: idProp,
            field: field,
            value: newValue
        }, event);
    }, [
        apiRef,
        field,
        idProp,
        onValueChange
    ]);
    $cb74606ec716e4c3$var$React.useEffect(()=>{
        setValueState(value);
    }, [
        value
    ]);
    (0, $cb74606ec716e4c3$var$_useEnhancedEffect.default)(()=>{
        if (hasFocus) inputRef.current.focus();
    }, [
        hasFocus
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("label", (0, $cb74606ec716e4c3$var$_extends2.default)({
        htmlFor: id,
        className: (0, $cb74606ec716e4c3$var$_clsx.default)(classes.root, className)
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseCheckbox, (0, $cb74606ec716e4c3$var$_extends2.default)({
            id: id,
            inputRef: inputRef,
            checked: Boolean(valueState),
            onChange: handleChange,
            size: "small"
        }, rootProps.slotProps?.baseCheckbox))
    }));
}
$cb74606ec716e4c3$var$GridEditBooleanCell.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * GridApi that let you manipulate the grid.
   */ api: $cb74606ec716e4c3$var$_propTypes.default.object.isRequired,
    /**
   * The mode of the cell.
   */ cellMode: $cb74606ec716e4c3$var$_propTypes.default.oneOf([
        'edit',
        'view'
    ]).isRequired,
    changeReason: $cb74606ec716e4c3$var$_propTypes.default.oneOf([
        'debouncedSetEditCellValue',
        'setEditCellValue'
    ]),
    /**
   * The column of the row that the current cell belongs to.
   */ colDef: $cb74606ec716e4c3$var$_propTypes.default.object.isRequired,
    /**
   * The column field of the cell that triggered the event.
   */ field: $cb74606ec716e4c3$var$_propTypes.default.string.isRequired,
    /**
   * The cell value formatted with the column valueFormatter.
   */ formattedValue: $cb74606ec716e4c3$var$_propTypes.default.any,
    /**
   * If true, the cell is the active element.
   */ hasFocus: $cb74606ec716e4c3$var$_propTypes.default.bool.isRequired,
    /**
   * The grid row id.
   */ id: $cb74606ec716e4c3$var$_propTypes.default.oneOfType([
        $cb74606ec716e4c3$var$_propTypes.default.number,
        $cb74606ec716e4c3$var$_propTypes.default.string
    ]).isRequired,
    /**
   * If true, the cell is editable.
   */ isEditable: $cb74606ec716e4c3$var$_propTypes.default.bool,
    isProcessingProps: $cb74606ec716e4c3$var$_propTypes.default.bool,
    isValidating: $cb74606ec716e4c3$var$_propTypes.default.bool,
    /**
   * Callback called when the value is changed by the user.
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * @param {boolean} newValue The value that is going to be passed to `apiRef.current.setEditCellValue`.
   * @returns {Promise<void> | void} A promise to be awaited before calling `apiRef.current.setEditCellValue`
   */ onValueChange: $cb74606ec716e4c3$var$_propTypes.default.func,
    /**
   * The row model of the row that the current cell belongs to.
   */ row: $cb74606ec716e4c3$var$_propTypes.default.any.isRequired,
    /**
   * The node of the row that the current cell belongs to.
   */ rowNode: $cb74606ec716e4c3$var$_propTypes.default.object.isRequired,
    /**
   * the tabIndex value.
   */ tabIndex: $cb74606ec716e4c3$var$_propTypes.default.oneOf([
        -1,
        0
    ]).isRequired,
    /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */ value: $cb74606ec716e4c3$var$_propTypes.default.any
};
const $cb74606ec716e4c3$var$renderEditBooleanCell = (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)($cb74606ec716e4c3$var$GridEditBooleanCell, (0, $cb74606ec716e4c3$var$_extends2.default)({}, params));
$cb74606ec716e4c3$exports.renderEditBooleanCell = $cb74606ec716e4c3$var$renderEditBooleanCell;
$cb74606ec716e4c3$var$renderEditBooleanCell.displayName = "renderEditBooleanCell";



var $e84ace6ba51eccb1$exports = {};
"use strict";
Object.defineProperty($e84ace6ba51eccb1$exports, "__esModule", {
    value: true
});
$e84ace6ba51eccb1$exports.getGridBooleanOperators = void 0;
var $ccd0a0b443bb9406$exports = {};
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $ccd0a0b443bb9406$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $ccd0a0b443bb9406$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($ccd0a0b443bb9406$exports, "__esModule", {
    value: true
});
$ccd0a0b443bb9406$exports.GridFilterInputBoolean = $ccd0a0b443bb9406$var$GridFilterInputBoolean;
$ccd0a0b443bb9406$exports.sanitizeFilterItemValue = $ccd0a0b443bb9406$var$sanitizeFilterItemValue;

var $ccd0a0b443bb9406$var$_extends2 = $ccd0a0b443bb9406$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $ccd0a0b443bb9406$var$_objectWithoutPropertiesLoose2 = $ccd0a0b443bb9406$require$_interopRequireDefault((parcelRequire("c05no")));

var $ccd0a0b443bb9406$var$React = $ccd0a0b443bb9406$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ccd0a0b443bb9406$var$_propTypes = $ccd0a0b443bb9406$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $ccd0a0b443bb9406$var$_refType = $ccd0a0b443bb9406$require$_interopRequireDefault((parcelRequire("b3gjr")));

var $ccd0a0b443bb9406$var$_useId = $ccd0a0b443bb9406$require$_interopRequireDefault((parcelRequire("hwliF")));

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $ccd0a0b443bb9406$var$_excluded = [
    "item",
    "applyValue",
    "apiRef",
    "focusElementRef",
    "isFilterActive",
    "headerFilterMenu",
    "clearButton",
    "tabIndex",
    "slotProps"
];
function $ccd0a0b443bb9406$var$GridFilterInputBoolean(props) {
    const { item: item, applyValue: applyValue, apiRef: apiRef, focusElementRef: focusElementRef, headerFilterMenu: headerFilterMenu, clearButton: clearButton, tabIndex: tabIndex, slotProps: slotProps } = props, other = (0, $ccd0a0b443bb9406$var$_objectWithoutPropertiesLoose2.default)(props, $ccd0a0b443bb9406$var$_excluded);
    const [filterValueState, setFilterValueState] = $ccd0a0b443bb9406$var$React.useState($ccd0a0b443bb9406$var$sanitizeFilterItemValue(item.value));
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const labelId = (0, $ccd0a0b443bb9406$var$_useId.default)();
    const selectId = (0, $ccd0a0b443bb9406$var$_useId.default)();
    const baseSelectProps = rootProps.slotProps?.baseSelect || {};
    const isSelectNative = baseSelectProps.native ?? false;
    const baseSelectOptionProps = rootProps.slotProps?.baseSelectOption || {};
    const onFilterChange = $ccd0a0b443bb9406$var$React.useCallback((event)=>{
        const value = $ccd0a0b443bb9406$var$sanitizeFilterItemValue(event.target.value);
        setFilterValueState(value);
        applyValue((0, $ccd0a0b443bb9406$var$_extends2.default)({}, item, {
            value: value
        }));
    }, [
        applyValue,
        item
    ]);
    $ccd0a0b443bb9406$var$React.useEffect(()=>{
        setFilterValueState($ccd0a0b443bb9406$var$sanitizeFilterItemValue(item.value));
    }, [
        item.value
    ]);
    const label = slotProps?.root.label ?? apiRef.current.getLocaleText('filterPanelInputLabel');
    const rootSlotProps = slotProps?.root.slotProps;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($ccd0a0b443bb9406$var$React.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)(rootProps.slots.baseSelect, (0, $ccd0a0b443bb9406$var$_extends2.default)({
                fullWidth: true,
                labelId: labelId,
                id: selectId,
                label: label,
                value: filterValueState === undefined ? '' : String(filterValueState),
                onChange: onFilterChange,
                native: isSelectNative,
                slotProps: {
                    htmlInput: (0, $ccd0a0b443bb9406$var$_extends2.default)({
                        ref: focusElementRef,
                        tabIndex: tabIndex
                    }, rootSlotProps?.htmlInput)
                }
            }, baseSelectProps, other, slotProps?.root, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseSelectOption, (0, $ccd0a0b443bb9406$var$_extends2.default)({}, baseSelectOptionProps, {
                        native: isSelectNative,
                        value: "",
                        children: apiRef.current.getLocaleText('filterValueAny')
                    })),
                    /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseSelectOption, (0, $ccd0a0b443bb9406$var$_extends2.default)({}, baseSelectOptionProps, {
                        native: isSelectNative,
                        value: "true",
                        children: apiRef.current.getLocaleText('filterValueTrue')
                    })),
                    /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseSelectOption, (0, $ccd0a0b443bb9406$var$_extends2.default)({}, baseSelectOptionProps, {
                        native: isSelectNative,
                        value: "false",
                        children: apiRef.current.getLocaleText('filterValueFalse')
                    }))
                ]
            })),
            headerFilterMenu,
            clearButton
        ]
    });
}
function $ccd0a0b443bb9406$var$sanitizeFilterItemValue(value) {
    if (String(value).toLowerCase() === 'true') return true;
    if (String(value).toLowerCase() === 'false') return false;
    return undefined;
}
$ccd0a0b443bb9406$var$GridFilterInputBoolean.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    apiRef: $ccd0a0b443bb9406$var$_propTypes.default.shape({
        current: $ccd0a0b443bb9406$var$_propTypes.default.object.isRequired
    }).isRequired,
    applyValue: $ccd0a0b443bb9406$var$_propTypes.default.func.isRequired,
    className: $ccd0a0b443bb9406$var$_propTypes.default.string,
    clearButton: $ccd0a0b443bb9406$var$_propTypes.default.node,
    disabled: $ccd0a0b443bb9406$var$_propTypes.default.bool,
    focusElementRef: $ccd0a0b443bb9406$var$_refType.default,
    headerFilterMenu: $ccd0a0b443bb9406$var$_propTypes.default.node,
    inputRef: $ccd0a0b443bb9406$var$_propTypes.default.oneOfType([
        $ccd0a0b443bb9406$var$_propTypes.default.func,
        $ccd0a0b443bb9406$var$_propTypes.default.shape({
            current: (props, propName)=>{
                if (props[propName] == null) return null;
                if (typeof props[propName] !== 'object' || props[propName].nodeType !== 1) return new Error(`Expected prop '${propName}' to be of type Element`);
                return null;
            }
        })
    ]),
    /**
   * It is `true` if the filter either has a value or an operator with no value
   * required is selected (for example `isEmpty`)
   */ isFilterActive: $ccd0a0b443bb9406$var$_propTypes.default.bool,
    item: $ccd0a0b443bb9406$var$_propTypes.default.shape({
        field: $ccd0a0b443bb9406$var$_propTypes.default.string.isRequired,
        id: $ccd0a0b443bb9406$var$_propTypes.default.oneOfType([
            $ccd0a0b443bb9406$var$_propTypes.default.number,
            $ccd0a0b443bb9406$var$_propTypes.default.string
        ]),
        operator: $ccd0a0b443bb9406$var$_propTypes.default.string.isRequired,
        value: $ccd0a0b443bb9406$var$_propTypes.default.any
    }).isRequired,
    onBlur: $ccd0a0b443bb9406$var$_propTypes.default.func,
    onFocus: $ccd0a0b443bb9406$var$_propTypes.default.func,
    slotProps: $ccd0a0b443bb9406$var$_propTypes.default.object,
    tabIndex: $ccd0a0b443bb9406$var$_propTypes.default.number
};


const $e84ace6ba51eccb1$var$getGridBooleanOperators = ()=>[
        {
            value: 'is',
            getApplyFilterFn: (filterItem)=>{
                const sanitizedValue = (0, $ccd0a0b443bb9406$exports.sanitizeFilterItemValue)(filterItem.value);
                if (sanitizedValue === undefined) return null;
                return (value)=>Boolean(value) === sanitizedValue;
            },
            InputComponent: $ccd0a0b443bb9406$exports.GridFilterInputBoolean
        }
    ];
$e84ace6ba51eccb1$exports.getGridBooleanOperators = $e84ace6ba51eccb1$var$getGridBooleanOperators;


const $daf44030e7d36790$var$gridBooleanFormatter = (value, row, column, apiRef)=>{
    return value ? apiRef.current.getLocaleText('booleanCellTrueLabel') : apiRef.current.getLocaleText('booleanCellFalseLabel');
};
const $daf44030e7d36790$var$stringToBoolean = (value)=>{
    switch(value.toLowerCase().trim()){
        case 'true':
        case 'yes':
        case '1':
            return true;
        case 'false':
        case 'no':
        case '0':
        case 'null':
        case 'undefined':
            return false;
        default:
            return undefined;
    }
};
const $daf44030e7d36790$var$GRID_BOOLEAN_COL_DEF = $daf44030e7d36790$exports.GRID_BOOLEAN_COL_DEF = (0, $daf44030e7d36790$var$_extends2.default)({}, $8a69393405f257b1$exports.GRID_STRING_COL_DEF, {
    type: 'boolean',
    display: 'flex',
    align: 'center',
    headerAlign: 'center',
    renderCell: $6324800d89fce0fa$exports.renderBooleanCell,
    renderEditCell: $cb74606ec716e4c3$exports.renderEditBooleanCell,
    sortComparator: $c78f90aae54b126e$exports.gridNumberComparator,
    valueFormatter: $daf44030e7d36790$var$gridBooleanFormatter,
    filterOperators: (0, $e84ace6ba51eccb1$exports.getGridBooleanOperators)(),
    getApplyQuickFilterFn: ()=>null,
    // @ts-ignore
    aggregable: false,
    chartable: false,
    // @ts-ignore
    pastedValueParser: (value)=>$daf44030e7d36790$var$stringToBoolean(value)
});


Object.keys($daf44030e7d36790$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $a6506085715c5aff$exports && $a6506085715c5aff$exports[key] === $daf44030e7d36790$exports[key]) return;
    Object.defineProperty($a6506085715c5aff$exports, key, {
        enumerable: true,
        get: function() {
            return $daf44030e7d36790$exports[key];
        }
    });
});
var $3c6ea315aeb792f9$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3c6ea315aeb792f9$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($3c6ea315aeb792f9$exports, "__esModule", {
    value: true
});
$3c6ea315aeb792f9$exports.GRID_CHECKBOX_SELECTION_FIELD = $3c6ea315aeb792f9$exports.GRID_CHECKBOX_SELECTION_COL_DEF = void 0;

var $3c6ea315aeb792f9$var$_extends2 = $3c6ea315aeb792f9$require$_interopRequireDefault((parcelRequire("3p9rK")));
var $b1dfb45352a7562a$exports = {};
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $b1dfb45352a7562a$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $b1dfb45352a7562a$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($b1dfb45352a7562a$exports, "__esModule", {
    value: true
});
$b1dfb45352a7562a$exports.GridCellCheckboxRenderer = $b1dfb45352a7562a$exports.GridCellCheckboxForwardRef = void 0;

var $b1dfb45352a7562a$var$_extends2 = $b1dfb45352a7562a$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $b1dfb45352a7562a$var$_objectWithoutPropertiesLoose2 = $b1dfb45352a7562a$require$_interopRequireDefault((parcelRequire("c05no")));

var $b1dfb45352a7562a$var$React = $b1dfb45352a7562a$require$_interopRequireWildcard((parcelRequire("acw62")));

var $b1dfb45352a7562a$var$_propTypes = $b1dfb45352a7562a$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $b1dfb45352a7562a$var$_clsx = $b1dfb45352a7562a$require$_interopRequireDefault((parcelRequire("9QePP")));

var $b1dfb45352a7562a$var$_composeClasses = $b1dfb45352a7562a$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $b1dfb45352a7562a$var$_useEventCallback = $b1dfb45352a7562a$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $fYxgT = parcelRequire("fYxgT");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");

var $5sOMZ = parcelRequire("5sOMZ");
var $dae18049c8685698$exports = {};
"use strict";
Object.defineProperty($dae18049c8685698$exports, "__esModule", {
    value: true
});
$dae18049c8685698$exports.findRowsToSelect = $dae18049c8685698$exports.findRowsToDeselect = $dae18049c8685698$exports.checkboxPropsSelector = $dae18049c8685698$exports.ROW_SELECTION_PROPAGATION_DEFAULT = void 0;
$dae18049c8685698$exports.isMultipleRowSelectionEnabled = $dae18049c8685698$var$isMultipleRowSelectionEnabled;


var $e95988b653de2e96$exports = {};
"use strict";
Object.defineProperty($e95988b653de2e96$exports, "__esModule", {
    value: true
});
$e95988b653de2e96$exports.gridVisibleRowsLookupSelector = $e95988b653de2e96$exports.gridQuickFilterValuesSelector = $e95988b653de2e96$exports.gridFilteredTopLevelRowCountSelector = $e95988b653de2e96$exports.gridFilteredSortedTopLevelRowEntriesSelector = $e95988b653de2e96$exports.gridFilteredSortedRowIdsSelector = $e95988b653de2e96$exports.gridFilteredSortedRowEntriesSelector = $e95988b653de2e96$exports.gridFilteredSortedDepthRowEntriesSelector = $e95988b653de2e96$exports.gridFilteredRowsLookupSelector = $e95988b653de2e96$exports.gridFilteredRowCountSelector = $e95988b653de2e96$exports.gridFilteredDescendantRowCountSelector = $e95988b653de2e96$exports.gridFilteredDescendantCountLookupSelector = $e95988b653de2e96$exports.gridFilteredChildrenCountLookupSelector = $e95988b653de2e96$exports.gridFilterModelSelector = $e95988b653de2e96$exports.gridFilterActiveItemsSelector = $e95988b653de2e96$exports.gridFilterActiveItemsLookupSelector = $e95988b653de2e96$exports.gridExpandedSortedRowTreeLevelPositionLookupSelector = $e95988b653de2e96$exports.gridExpandedSortedRowIndexLookupSelector = $e95988b653de2e96$exports.gridExpandedSortedRowIdsSelector = $e95988b653de2e96$exports.gridExpandedSortedRowEntriesSelector = $e95988b653de2e96$exports.gridExpandedRowCountSelector = void 0;
var $57908709a849d718$exports = {};
"use strict";
Object.defineProperty($57908709a849d718$exports, "__esModule", {
    value: true
});
Object.defineProperty($57908709a849d718$exports, "isObjectEmpty", {
    enumerable: true,
    get: function() {
        return $5561a094c2d5818a$exports.isObjectEmpty;
    }
});
var $5561a094c2d5818a$exports = {};
"use strict";
Object.defineProperty($5561a094c2d5818a$exports, "__esModule", {
    value: true
});
$5561a094c2d5818a$exports.isObjectEmpty = $5561a094c2d5818a$var$isObjectEmpty;
function $5561a094c2d5818a$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}





var $dc3028b3b629fae7$exports = {};
"use strict";
Object.defineProperty($dc3028b3b629fae7$exports, "__esModule", {
    value: true
});
$dc3028b3b629fae7$exports.gridSortedRowIndexLookupSelector = $dc3028b3b629fae7$exports.gridSortedRowIdsSelector = $dc3028b3b629fae7$exports.gridSortedRowEntriesSelector = $dc3028b3b629fae7$exports.gridSortModelSelector = $dc3028b3b629fae7$exports.gridSortColumnLookupSelector = void 0;



/**
 * @category Sorting
 * @ignore - do not document.
 */ const $dc3028b3b629fae7$var$gridSortingStateSelector = (0, $8eef5f2af445e503$exports.createRootSelector)((state)=>state.sorting);
/**
 * Get the id of the rows after the sorting process.
 * @category Sorting
 */ const $dc3028b3b629fae7$var$gridSortedRowIdsSelector = $dc3028b3b629fae7$exports.gridSortedRowIdsSelector = (0, $8eef5f2af445e503$exports.createSelector)($dc3028b3b629fae7$var$gridSortingStateSelector, (sortingState)=>sortingState.sortedRows);
/**
 * Get the id and the model of the rows after the sorting process.
 * @category Sorting
 */ const $dc3028b3b629fae7$var$gridSortedRowEntriesSelector = $dc3028b3b629fae7$exports.gridSortedRowEntriesSelector = (0, $8eef5f2af445e503$exports.createSelectorMemoized)($dc3028b3b629fae7$var$gridSortedRowIdsSelector, $befccaa56b49492d$exports.gridRowsLookupSelector, $befccaa56b49492d$exports.gridRowTreeSelector, (sortedIds, idRowsLookup, rowTree)=>sortedIds.reduce((acc, id)=>{
        const model = idRowsLookup[id];
        if (model) acc.push({
            id: id,
            model: model
        });
        else {
            const rowNode = rowTree[id];
            if (rowNode && (0, $0166dd44615cae0d$exports.isAutogeneratedRowNode)(rowNode)) acc.push({
                id: id,
                model: {
                    [$0166dd44615cae0d$exports.GRID_ID_AUTOGENERATED]: id
                }
            });
        }
        return acc;
    }, []));
/**
 * Get the current sorting model.
 * @category Sorting
 */ const $dc3028b3b629fae7$var$gridSortModelSelector = $dc3028b3b629fae7$exports.gridSortModelSelector = (0, $8eef5f2af445e503$exports.createSelector)($dc3028b3b629fae7$var$gridSortingStateSelector, (sorting)=>sorting.sortModel);
/**
 * @category Sorting
 * @ignore - do not document.
 */ const $dc3028b3b629fae7$var$gridSortColumnLookupSelector = $dc3028b3b629fae7$exports.gridSortColumnLookupSelector = (0, $8eef5f2af445e503$exports.createSelectorMemoized)($dc3028b3b629fae7$var$gridSortModelSelector, (sortModel)=>{
    const result = sortModel.reduce((res, sortItem, index)=>{
        res[sortItem.field] = {
            sortDirection: sortItem.sort,
            sortIndex: sortModel.length > 1 ? index + 1 : undefined
        };
        return res;
    }, {});
    return result;
});
/**
 * @category Sorting
 * @ignore - do not document.
 */ const $dc3028b3b629fae7$var$gridSortedRowIndexLookupSelector = $dc3028b3b629fae7$exports.gridSortedRowIndexLookupSelector = (0, $8eef5f2af445e503$exports.createSelectorMemoized)($dc3028b3b629fae7$var$gridSortedRowIdsSelector, (sortedIds)=>{
    return sortedIds.reduce((acc, id, index)=>{
        acc[id] = index;
        return acc;
    }, Object.create(null));
});




/**
 * @category Filtering
 */ const $e95988b653de2e96$var$gridFilterStateSelector = (0, $8eef5f2af445e503$exports.createRootSelector)((state)=>state.filter);
/**
 * Get the current filter model.
 * @category Filtering
 */ const $e95988b653de2e96$var$gridFilterModelSelector = $e95988b653de2e96$exports.gridFilterModelSelector = (0, $8eef5f2af445e503$exports.createSelector)($e95988b653de2e96$var$gridFilterStateSelector, (filterState)=>filterState.filterModel);
/**
 * Get the current quick filter values.
 * @category Filtering
 */ const $e95988b653de2e96$var$gridQuickFilterValuesSelector = $e95988b653de2e96$exports.gridQuickFilterValuesSelector = (0, $8eef5f2af445e503$exports.createSelector)($e95988b653de2e96$var$gridFilterModelSelector, (filterModel)=>filterModel.quickFilterValues);
/**
 * @category Visible rows
 * @ignore - do not document.
 */ const $e95988b653de2e96$var$gridVisibleRowsLookupSelector = $e95988b653de2e96$exports.gridVisibleRowsLookupSelector = (0, $8eef5f2af445e503$exports.createRootSelector)((state)=>state.visibleRowsLookup);
/**
 * @category Filtering
 * @ignore - do not document.
 */ const $e95988b653de2e96$var$gridFilteredRowsLookupSelector = $e95988b653de2e96$exports.gridFilteredRowsLookupSelector = (0, $8eef5f2af445e503$exports.createSelector)($e95988b653de2e96$var$gridFilterStateSelector, (filterState)=>filterState.filteredRowsLookup);
/**
 * @category Filtering
 * @ignore - do not document.
 */ const $e95988b653de2e96$var$gridFilteredChildrenCountLookupSelector = $e95988b653de2e96$exports.gridFilteredChildrenCountLookupSelector = (0, $8eef5f2af445e503$exports.createSelector)($e95988b653de2e96$var$gridFilterStateSelector, (filterState)=>filterState.filteredChildrenCountLookup);
/**
 * @category Filtering
 * @ignore - do not document.
 */ const $e95988b653de2e96$var$gridFilteredDescendantCountLookupSelector = $e95988b653de2e96$exports.gridFilteredDescendantCountLookupSelector = (0, $8eef5f2af445e503$exports.createSelector)($e95988b653de2e96$var$gridFilterStateSelector, (filterState)=>filterState.filteredDescendantCountLookup);
/**
 * Get the id and the model of the rows accessible after the filtering process.
 * Does not contain the collapsed children.
 * @category Filtering
 */ const $e95988b653de2e96$var$gridExpandedSortedRowEntriesSelector = $e95988b653de2e96$exports.gridExpandedSortedRowEntriesSelector = (0, $8eef5f2af445e503$exports.createSelectorMemoized)($e95988b653de2e96$var$gridVisibleRowsLookupSelector, $dc3028b3b629fae7$exports.gridSortedRowEntriesSelector, (visibleRowsLookup, sortedRows)=>{
    if ((0, $57908709a849d718$exports.isObjectEmpty)(visibleRowsLookup)) return sortedRows;
    return sortedRows.filter((row)=>visibleRowsLookup[row.id] !== false);
});
/**
 * Get the id of the rows accessible after the filtering process.
 * Does not contain the collapsed children.
 * @category Filtering
 */ const $e95988b653de2e96$var$gridExpandedSortedRowIdsSelector = $e95988b653de2e96$exports.gridExpandedSortedRowIdsSelector = (0, $8eef5f2af445e503$exports.createSelectorMemoized)($e95988b653de2e96$var$gridExpandedSortedRowEntriesSelector, (visibleSortedRowEntries)=>visibleSortedRowEntries.map((row)=>row.id));
/**
 * Get the id and the model of the rows accessible after the filtering process.
 * Contains the collapsed children.
 * @category Filtering
 */ const $e95988b653de2e96$var$gridFilteredSortedRowEntriesSelector = $e95988b653de2e96$exports.gridFilteredSortedRowEntriesSelector = (0, $8eef5f2af445e503$exports.createSelectorMemoized)($e95988b653de2e96$var$gridFilteredRowsLookupSelector, $dc3028b3b629fae7$exports.gridSortedRowEntriesSelector, (filteredRowsLookup, sortedRows)=>(0, $57908709a849d718$exports.isObjectEmpty)(filteredRowsLookup) ? sortedRows : sortedRows.filter((row)=>filteredRowsLookup[row.id] !== false));
/**
 * Get the id of the rows accessible after the filtering process.
 * Contains the collapsed children.
 * @category Filtering
 */ const $e95988b653de2e96$var$gridFilteredSortedRowIdsSelector = $e95988b653de2e96$exports.gridFilteredSortedRowIdsSelector = (0, $8eef5f2af445e503$exports.createSelectorMemoized)($e95988b653de2e96$var$gridFilteredSortedRowEntriesSelector, (filteredSortedRowEntries)=>filteredSortedRowEntries.map((row)=>row.id));
/**
 * Get the ids to position in the current tree level lookup of the rows accessible after the filtering process.
 * Does not contain the collapsed children.
 * @category Filtering
 * @ignore - do not document.
 */ const $e95988b653de2e96$var$gridExpandedSortedRowTreeLevelPositionLookupSelector = $e95988b653de2e96$exports.gridExpandedSortedRowTreeLevelPositionLookupSelector = (0, $8eef5f2af445e503$exports.createSelectorMemoized)($e95988b653de2e96$var$gridExpandedSortedRowIdsSelector, $befccaa56b49492d$exports.gridRowTreeSelector, (visibleSortedRowIds, rowTree)=>{
    const depthPositionCounter = {};
    let lastDepth = 0;
    return visibleSortedRowIds.reduce((acc, rowId)=>{
        const rowNode = rowTree[rowId];
        if (!depthPositionCounter[rowNode.depth]) depthPositionCounter[rowNode.depth] = 0;
        // going deeper in the tree should reset the counter
        // since it might have been used in some other branch at the same level, up in the tree
        // going back up should keep the counter and continue where it left off
        if (rowNode.depth > lastDepth) depthPositionCounter[rowNode.depth] = 0;
        lastDepth = rowNode.depth;
        depthPositionCounter[rowNode.depth] += 1;
        acc[rowId] = depthPositionCounter[rowNode.depth];
        return acc;
    }, {});
});
/**
 * Get the id and the model of the rows per depth level, accessible after the filtering process.
 * Returns an array of arrays, where each array index contains the rows for the depth level equal to the index.
 * @category Filtering
 */ const $e95988b653de2e96$var$gridFilteredSortedDepthRowEntriesSelector = $e95988b653de2e96$exports.gridFilteredSortedDepthRowEntriesSelector = (0, $8eef5f2af445e503$exports.createSelectorMemoized)($e95988b653de2e96$var$gridFilteredSortedRowEntriesSelector, $befccaa56b49492d$exports.gridRowTreeSelector, $befccaa56b49492d$exports.gridRowMaximumTreeDepthSelector, (sortedRows, rowTree, rowTreeDepth)=>{
    if (rowTreeDepth < 2) return [
        sortedRows
    ];
    return sortedRows.reduce((acc, row)=>{
        const depth = rowTree[row.id]?.depth;
        if (depth === undefined) return acc;
        if (!acc[depth]) acc[depth] = [];
        acc[depth].push(row);
        return acc;
    }, [
        []
    ]);
});
/**
 * Get the id and the model of the top level rows accessible after the filtering process.
 * @category Filtering
 */ const $e95988b653de2e96$var$gridFilteredSortedTopLevelRowEntriesSelector = $e95988b653de2e96$exports.gridFilteredSortedTopLevelRowEntriesSelector = (0, $8eef5f2af445e503$exports.createSelector)($e95988b653de2e96$var$gridFilteredSortedDepthRowEntriesSelector, (filteredSortedDepthRows)=>filteredSortedDepthRows[0] ?? []);
/**
 * Get the amount of rows accessible after the filtering process.
 * @category Filtering
 */ const $e95988b653de2e96$var$gridExpandedRowCountSelector = $e95988b653de2e96$exports.gridExpandedRowCountSelector = (0, $8eef5f2af445e503$exports.createSelector)($e95988b653de2e96$var$gridExpandedSortedRowEntriesSelector, (visibleSortedRows)=>visibleSortedRows.length);
/**
 * Get the amount of top level rows accessible after the filtering process.
 * @category Filtering
 */ const $e95988b653de2e96$var$gridFilteredTopLevelRowCountSelector = $e95988b653de2e96$exports.gridFilteredTopLevelRowCountSelector = (0, $8eef5f2af445e503$exports.createSelector)($e95988b653de2e96$var$gridFilteredSortedTopLevelRowEntriesSelector, (visibleSortedTopLevelRows)=>visibleSortedTopLevelRows.length);
/**
 * Get the amount of rows accessible after the filtering process.
 * Includes top level and descendant rows.
 * @category Filtering
 */ const $e95988b653de2e96$var$gridFilteredRowCountSelector = $e95988b653de2e96$exports.gridFilteredRowCountSelector = (0, $8eef5f2af445e503$exports.createSelector)($e95988b653de2e96$var$gridFilteredSortedRowEntriesSelector, (filteredSortedRowEntries)=>filteredSortedRowEntries.length);
/**
 * Get the amount of descendant rows accessible after the filtering process.
 * @category Filtering
 */ const $e95988b653de2e96$var$gridFilteredDescendantRowCountSelector = $e95988b653de2e96$exports.gridFilteredDescendantRowCountSelector = (0, $8eef5f2af445e503$exports.createSelector)($e95988b653de2e96$var$gridFilteredRowCountSelector, $e95988b653de2e96$var$gridFilteredTopLevelRowCountSelector, (totalRowCount, topLevelRowCount)=>totalRowCount - topLevelRowCount);
/**
 * @category Filtering
 * @ignore - do not document.
 */ const $e95988b653de2e96$var$gridFilterActiveItemsSelector = $e95988b653de2e96$exports.gridFilterActiveItemsSelector = (0, $8eef5f2af445e503$exports.createSelectorMemoized)($e95988b653de2e96$var$gridFilterModelSelector, $e732684465924d20$exports.gridColumnLookupSelector, (filterModel, columnLookup)=>filterModel.items?.filter((item)=>{
        if (!item.field) return false;
        const column = columnLookup[item.field];
        if (!column?.filterOperators || column?.filterOperators?.length === 0) return false;
        const filterOperator = column.filterOperators.find((operator)=>operator.value === item.operator);
        if (!filterOperator) return false;
        return !filterOperator.InputComponent || item.value != null && item.value?.toString() !== '';
    }));
/**
 * @category Filtering
 * @ignore - do not document.
 */ const $e95988b653de2e96$var$gridFilterActiveItemsLookupSelector = $e95988b653de2e96$exports.gridFilterActiveItemsLookupSelector = (0, $8eef5f2af445e503$exports.createSelectorMemoized)($e95988b653de2e96$var$gridFilterActiveItemsSelector, (activeFilters)=>{
    const result = activeFilters.reduce((res, filterItem)=>{
        if (!res[filterItem.field]) res[filterItem.field] = [
            filterItem
        ];
        else res[filterItem.field].push(filterItem);
        return res;
    }, {});
    return result;
});
/**
 * Get the index lookup for expanded (visible) rows only.
 * Does not include collapsed children.
 * @ignore - do not document.
 */ const $e95988b653de2e96$var$gridExpandedSortedRowIndexLookupSelector = $e95988b653de2e96$exports.gridExpandedSortedRowIndexLookupSelector = (0, $8eef5f2af445e503$exports.createSelectorMemoized)($e95988b653de2e96$var$gridExpandedSortedRowIdsSelector, (expandedSortedIds)=>{
    return expandedSortedIds.reduce((acc, id, index)=>{
        acc[id] = index;
        return acc;
    }, Object.create(null));
});



var $7a5249c135fd39c1$exports = {};
"use strict";
Object.defineProperty($7a5249c135fd39c1$exports, "__esModule", {
    value: true
});
$7a5249c135fd39c1$exports.gridRowSelectionStateSelector = $7a5249c135fd39c1$exports.gridRowSelectionManagerSelector = $7a5249c135fd39c1$exports.gridRowSelectionIdsSelector = $7a5249c135fd39c1$exports.gridRowSelectionCountSelector = void 0;




const $7a5249c135fd39c1$var$gridRowSelectionStateSelector = $7a5249c135fd39c1$exports.gridRowSelectionStateSelector = (0, $8eef5f2af445e503$exports.createRootSelector)((state)=>state.rowSelection);
const $7a5249c135fd39c1$var$gridRowSelectionManagerSelector = $7a5249c135fd39c1$exports.gridRowSelectionManagerSelector = (0, $8eef5f2af445e503$exports.createSelectorMemoized)($7a5249c135fd39c1$var$gridRowSelectionStateSelector, $8ee7986d138c7e40$exports.createRowSelectionManager);
const $7a5249c135fd39c1$var$gridRowSelectionCountSelector = $7a5249c135fd39c1$exports.gridRowSelectionCountSelector = (0, $8eef5f2af445e503$exports.createSelector)($7a5249c135fd39c1$var$gridRowSelectionStateSelector, $e95988b653de2e96$exports.gridFilteredRowCountSelector, (selection, filteredRowCount)=>{
    if (selection.type === 'include') return selection.ids.size;
    // In exclude selection, all rows are selectable.
    return filteredRowCount - selection.ids.size;
});
const $7a5249c135fd39c1$var$gridRowSelectionIdsSelector = $7a5249c135fd39c1$exports.gridRowSelectionIdsSelector = (0, $8eef5f2af445e503$exports.createSelectorMemoized)($7a5249c135fd39c1$var$gridRowSelectionStateSelector, $befccaa56b49492d$exports.gridRowsLookupSelector, $befccaa56b49492d$exports.gridDataRowIdsSelector, (selectionModel, rowsLookup, rowIds)=>{
    const map = new Map();
    if (selectionModel.type === 'include') for (const id of selectionModel.ids)map.set(id, rowsLookup[id]);
    else for(let i = 0; i < rowIds.length; i += 1){
        const id = rowIds[i];
        if (!selectionModel.ids.has(id)) map.set(id, rowsLookup[id]);
    }
    return map;
});





var $0d26ce0880758663$exports = {};
"use strict";
Object.defineProperty($0d26ce0880758663$exports, "__esModule", {
    value: true
});
$0d26ce0880758663$exports.gridRowSelectableSelector = $0d26ce0880758663$exports.gridRowIdSelector = void 0;


/**
 * Get the row id for a given row
 * @param apiRef - The grid api reference
 * @param {GridRowModel} row - The row to get the id for
 * @returns {GridRowId} The row id
 */ const $0d26ce0880758663$var$gridRowIdSelector = $0d26ce0880758663$exports.gridRowIdSelector = (0, $8eef5f2af445e503$exports.createRootSelector)((state, row)=>{
    if ($0166dd44615cae0d$exports.GRID_ID_AUTOGENERATED in row) return row[$0166dd44615cae0d$exports.GRID_ID_AUTOGENERATED];
    return state.props.getRowId ? state.props.getRowId(row) : row.id;
});
const $0d26ce0880758663$var$gridRowSelectableSelector = $0d26ce0880758663$exports.gridRowSelectableSelector = (0, $8eef5f2af445e503$exports.createRootSelector)((state)=>{
    return state.props.isRowSelectable;
});


const $dae18049c8685698$var$ROW_SELECTION_PROPAGATION_DEFAULT = $dae18049c8685698$exports.ROW_SELECTION_PROPAGATION_DEFAULT = {
    parents: true,
    descendants: true
};
function $dae18049c8685698$var$getGridRowGroupSelectableDescendants(apiRef, groupId) {
    const rowTree = (0, $befccaa56b49492d$exports.gridRowTreeSelector)(apiRef);
    const sortedRowIds = (0, $dc3028b3b629fae7$exports.gridSortedRowIdsSelector)(apiRef);
    const filteredRowsLookup = (0, $e95988b653de2e96$exports.gridFilteredRowsLookupSelector)(apiRef);
    const groupNode = rowTree[groupId];
    if (!groupNode || groupNode.type !== 'group') return [];
    const descendants = [];
    const startIndex = sortedRowIds.findIndex((id)=>id === groupId) + 1;
    for(let index = startIndex; index < sortedRowIds.length && rowTree[sortedRowIds[index]]?.depth > groupNode.depth; index += 1){
        const id = sortedRowIds[index];
        if (filteredRowsLookup[id] !== false && apiRef.current.isRowSelectable(id)) descendants.push(id);
    }
    return descendants;
}
const $dae18049c8685698$var$checkboxPropsSelector = $dae18049c8685698$exports.checkboxPropsSelector = (0, $8eef5f2af445e503$exports.createSelector)($e3b5f2e67362f55f$exports.gridColumnDefinitionsSelector, $befccaa56b49492d$exports.gridRowTreeSelector, $e95988b653de2e96$exports.gridFilteredRowsLookupSelector, $7a5249c135fd39c1$exports.gridRowSelectionManagerSelector, $befccaa56b49492d$exports.gridRowsLookupSelector, $0d26ce0880758663$exports.gridRowSelectableSelector, (columns, rowTree, filteredRowsLookup, rowSelectionManager, rowsLookup, isRowSelectable, { groupId: groupId, autoSelectParents: autoSelectParents })=>{
    const groupNode = rowTree[groupId];
    const rowParams = {
        id: groupId,
        row: rowsLookup[groupId],
        columns: columns
    };
    let isSelectable = true;
    if (typeof isRowSelectable === 'function') isSelectable = isRowSelectable(rowParams);
    if (!groupNode || groupNode.type !== 'group' || rowSelectionManager.has(groupId)) return {
        isIndeterminate: false,
        isChecked: rowSelectionManager.has(groupId),
        isSelectable: isSelectable
    };
    let hasSelectedDescendant = false;
    let hasUnSelectedDescendant = false;
    const traverseDescendants = (itemToTraverseId)=>{
        if (filteredRowsLookup[itemToTraverseId] === false || // Perf: Skip checking the rest of the descendants if we already
        // know that there is a selected and an unselected descendant
        hasSelectedDescendant && hasUnSelectedDescendant) return;
        const node = rowTree[itemToTraverseId];
        if (node?.type === 'group') node.children.forEach(traverseDescendants);
        if (rowSelectionManager.has(itemToTraverseId)) hasSelectedDescendant = true;
        else hasUnSelectedDescendant = true;
    };
    traverseDescendants(groupId);
    return {
        isIndeterminate: hasSelectedDescendant && hasUnSelectedDescendant,
        isChecked: autoSelectParents ? hasSelectedDescendant && !hasUnSelectedDescendant : false,
        isSelectable: isSelectable
    };
});
function $dae18049c8685698$var$isMultipleRowSelectionEnabled(props) {
    if (props.signature === $dc886d040ec4e87c$exports.GridSignature.DataGrid) // DataGrid Community has multiple row selection enabled only if checkbox selection is enabled.
    return props.checkboxSelection && props.disableMultipleRowSelection !== true;
    return !props.disableMultipleRowSelection;
}
const $dae18049c8685698$var$getRowNodeParents = (tree, id)=>{
    const parents = [];
    let parent = id;
    while(parent != null && parent !== $0166dd44615cae0d$exports.GRID_ROOT_GROUP_ID){
        const node = tree[parent];
        if (!node) return parents;
        parents.push(parent);
        parent = node.parent;
    }
    return parents;
};
const $dae18049c8685698$var$getFilteredRowNodeSiblings = (tree, filteredRows, id)=>{
    const node = tree[id];
    if (!node) return [];
    const parent = node.parent;
    if (parent == null) return [];
    const parentNode = tree[parent];
    return parentNode.children.filter((childId)=>childId !== id && filteredRows[childId] !== false);
};
const $dae18049c8685698$var$findRowsToSelect = (apiRef, tree, selectedRow, autoSelectDescendants, autoSelectParents, addRow, rowSelectionManager = (0, $7a5249c135fd39c1$exports.gridRowSelectionManagerSelector)(apiRef))=>{
    const filteredRows = (0, $e95988b653de2e96$exports.gridFilteredRowsLookupSelector)(apiRef);
    const selectedDescendants = new Set([]);
    if (!autoSelectDescendants && !autoSelectParents || filteredRows[selectedRow] === false) return;
    if (autoSelectDescendants) {
        const rowNode = tree[selectedRow];
        if (rowNode?.type === 'group') {
            const descendants = $dae18049c8685698$var$getGridRowGroupSelectableDescendants(apiRef, selectedRow);
            descendants.forEach((rowId)=>{
                addRow(rowId);
                selectedDescendants.add(rowId);
            });
        }
    }
    if (autoSelectParents) {
        const checkAllDescendantsSelected = (rowId)=>{
            if (!rowSelectionManager.has(rowId) && !selectedDescendants.has(rowId)) return false;
            const node = tree[rowId];
            if (!node) return false;
            if (node.type !== 'group') return true;
            return node.children.every(checkAllDescendantsSelected);
        };
        const traverseParents = (rowId)=>{
            const siblings = $dae18049c8685698$var$getFilteredRowNodeSiblings(tree, filteredRows, rowId);
            if (siblings.length === 0 || siblings.every(checkAllDescendantsSelected)) {
                const rowNode = tree[rowId];
                const parent = rowNode?.parent;
                if (parent != null && parent !== $0166dd44615cae0d$exports.GRID_ROOT_GROUP_ID && apiRef.current.isRowSelectable(parent)) {
                    addRow(parent);
                    selectedDescendants.add(parent);
                    traverseParents(parent);
                }
            }
        };
        // For root level rows, we don't need to traverse parents
        const rowNode = tree[selectedRow];
        if (!rowNode || rowNode.parent === $0166dd44615cae0d$exports.GRID_ROOT_GROUP_ID) return;
        traverseParents(selectedRow);
    }
};
$dae18049c8685698$exports.findRowsToSelect = $dae18049c8685698$var$findRowsToSelect;
const $dae18049c8685698$var$findRowsToDeselect = (apiRef, tree, deselectedRow, autoSelectDescendants, autoSelectParents, removeRow)=>{
    const rowSelectionManager = (0, $7a5249c135fd39c1$exports.gridRowSelectionManagerSelector)(apiRef);
    if (!autoSelectParents && !autoSelectDescendants) return;
    if (autoSelectParents) {
        const allParents = $dae18049c8685698$var$getRowNodeParents(tree, deselectedRow);
        allParents.forEach((parent)=>{
            const isSelected = rowSelectionManager.has(parent);
            if (isSelected) removeRow(parent);
        });
    }
    if (autoSelectDescendants) {
        const rowNode = tree[deselectedRow];
        if (rowNode?.type === 'group') {
            const descendants = $dae18049c8685698$var$getGridRowGroupSelectableDescendants(apiRef, deselectedRow);
            descendants.forEach((descendant)=>{
                removeRow(descendant);
            });
        }
    }
};
$dae18049c8685698$exports.findRowsToDeselect = $dae18049c8685698$var$findRowsToDeselect;



var $ayMG0 = parcelRequire("ayMG0");
const $b1dfb45352a7562a$var$_excluded = [
    "field",
    "id",
    "formattedValue",
    "row",
    "rowNode",
    "colDef",
    "isEditable",
    "cellMode",
    "hasFocus",
    "tabIndex",
    "api"
];
const $b1dfb45352a7562a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'checkboxInput'
        ]
    };
    return (0, $b1dfb45352a7562a$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $b1dfb45352a7562a$var$GridCellCheckboxForwardRef = $b1dfb45352a7562a$exports.GridCellCheckboxForwardRef = (0, $fYxgT.forwardRef)(function GridCellCheckboxRenderer(props, ref) {
    const { field: field, id: id, rowNode: rowNode, tabIndex: tabIndex } = props, other = (0, $b1dfb45352a7562a$var$_objectWithoutPropertiesLoose2.default)(props, $b1dfb45352a7562a$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = $b1dfb45352a7562a$var$useUtilityClasses(ownerState);
    const { isIndeterminate: isIndeterminate, isChecked: isChecked, isSelectable: isSelectable } = (0, $5sOMZ.useGridSelector)(apiRef, $dae18049c8685698$exports.checkboxPropsSelector, {
        groupId: id,
        autoSelectParents: rootProps.rowSelectionPropagation?.parents ?? false
    });
    const disabled = !isSelectable;
    const handleChange = (event)=>{
        if (disabled) return;
        const params = {
            value: event.target.checked,
            id: id
        };
        apiRef.current.publishEvent('rowSelectionCheckboxChange', params, event);
    };
    $b1dfb45352a7562a$var$React.useLayoutEffect(()=>{
        if (tabIndex === 0) {
            const element = apiRef.current.getCellElement(id, field);
            if (element) element.tabIndex = -1;
        }
    }, [
        apiRef,
        tabIndex,
        id,
        field
    ]);
    const handleKeyDown = (0, $b1dfb45352a7562a$var$_useEventCallback.default)((event)=>{
        if (event.key === ' ') // We call event.stopPropagation to avoid selecting the row and also scrolling to bottom
        // TODO: Remove and add a check inside useGridKeyboardNavigation
        event.stopPropagation();
        if (disabled) return;
    });
    const handleClick = (0, $b1dfb45352a7562a$var$_useEventCallback.default)((event)=>{
        if (disabled) {
            event.preventDefault();
            return;
        }
    });
    const handleMouseDown = (0, $b1dfb45352a7562a$var$_useEventCallback.default)(()=>{
        if (disabled) return;
    });
    if (rowNode.type === 'footer' || rowNode.type === 'pinnedRow') return null;
    const label = apiRef.current.getLocaleText(isChecked && !isIndeterminate ? 'checkboxSelectionUnselectRow' : 'checkboxSelectionSelectRow');
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseCheckbox, (0, $b1dfb45352a7562a$var$_extends2.default)({
        tabIndex: tabIndex,
        checked: isChecked && !isIndeterminate,
        onChange: handleChange,
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        className: (0, $b1dfb45352a7562a$var$_clsx.default)(classes.root, disabled && 'Mui-disabled'),
        material: {
            disableRipple: disabled
        },
        slotProps: {
            htmlInput: {
                'aria-disabled': disabled || undefined,
                'aria-label': label,
                name: 'select_row'
            }
        },
        onKeyDown: handleKeyDown,
        indeterminate: isIndeterminate
    }, rootProps.slotProps?.baseCheckbox, other, {
        ref: ref
    }));
});
$b1dfb45352a7562a$var$GridCellCheckboxForwardRef.displayName = "GridCellCheckboxForwardRef";
$b1dfb45352a7562a$var$GridCellCheckboxForwardRef.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * GridApi that let you manipulate the grid.
   */ api: $b1dfb45352a7562a$var$_propTypes.default.object.isRequired,
    /**
   * The mode of the cell.
   */ cellMode: $b1dfb45352a7562a$var$_propTypes.default.oneOf([
        'edit',
        'view'
    ]).isRequired,
    /**
   * The column of the row that the current cell belongs to.
   */ colDef: $b1dfb45352a7562a$var$_propTypes.default.object.isRequired,
    /**
   * The column field of the cell that triggered the event.
   */ field: $b1dfb45352a7562a$var$_propTypes.default.string.isRequired,
    /**
   * The cell value formatted with the column valueFormatter.
   */ formattedValue: $b1dfb45352a7562a$var$_propTypes.default.any,
    /**
   * If true, the cell is the active element.
   */ hasFocus: $b1dfb45352a7562a$var$_propTypes.default.bool.isRequired,
    /**
   * The grid row id.
   */ id: $b1dfb45352a7562a$var$_propTypes.default.oneOfType([
        $b1dfb45352a7562a$var$_propTypes.default.number,
        $b1dfb45352a7562a$var$_propTypes.default.string
    ]).isRequired,
    /**
   * If true, the cell is editable.
   */ isEditable: $b1dfb45352a7562a$var$_propTypes.default.bool,
    /**
   * The row model of the row that the current cell belongs to.
   */ row: $b1dfb45352a7562a$var$_propTypes.default.any.isRequired,
    /**
   * The node of the row that the current cell belongs to.
   */ rowNode: $b1dfb45352a7562a$var$_propTypes.default.object.isRequired,
    /**
   * the tabIndex value.
   */ tabIndex: $b1dfb45352a7562a$var$_propTypes.default.oneOf([
        -1,
        0
    ]).isRequired,
    /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */ value: $b1dfb45352a7562a$var$_propTypes.default.any
};
const $b1dfb45352a7562a$var$GridCellCheckboxRenderer = $b1dfb45352a7562a$exports.GridCellCheckboxRenderer = $b1dfb45352a7562a$var$GridCellCheckboxForwardRef;


var $328bc9e57e6b696b$exports = {};
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $328bc9e57e6b696b$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $328bc9e57e6b696b$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($328bc9e57e6b696b$exports, "__esModule", {
    value: true
});
$328bc9e57e6b696b$exports.GridHeaderCheckbox = void 0;

var $328bc9e57e6b696b$var$_extends2 = $328bc9e57e6b696b$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $328bc9e57e6b696b$var$_objectWithoutPropertiesLoose2 = $328bc9e57e6b696b$require$_interopRequireDefault((parcelRequire("c05no")));

var $328bc9e57e6b696b$var$React = $328bc9e57e6b696b$require$_interopRequireWildcard((parcelRequire("acw62")));

var $328bc9e57e6b696b$var$_propTypes = $328bc9e57e6b696b$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $328bc9e57e6b696b$var$_composeClasses = $328bc9e57e6b696b$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $fYxgT = parcelRequire("fYxgT");


var $5sOMZ = parcelRequire("5sOMZ");
var $9c9b8e89fddd633d$exports = {};
"use strict";
Object.defineProperty($9c9b8e89fddd633d$exports, "__esModule", {
    value: true
});
$9c9b8e89fddd633d$exports.gridTabIndexStateSelector = $9c9b8e89fddd633d$exports.gridTabIndexColumnHeaderSelector = $9c9b8e89fddd633d$exports.gridTabIndexColumnHeaderFilterSelector = $9c9b8e89fddd633d$exports.gridTabIndexColumnGroupHeaderSelector = $9c9b8e89fddd633d$exports.gridTabIndexCellSelector = $9c9b8e89fddd633d$exports.gridFocusStateSelector = $9c9b8e89fddd633d$exports.gridFocusColumnHeaderSelector = $9c9b8e89fddd633d$exports.gridFocusColumnHeaderFilterSelector = $9c9b8e89fddd633d$exports.gridFocusColumnGroupHeaderSelector = $9c9b8e89fddd633d$exports.gridFocusCellSelector = void 0;

const $9c9b8e89fddd633d$var$gridFocusStateSelector = $9c9b8e89fddd633d$exports.gridFocusStateSelector = (0, $8eef5f2af445e503$exports.createRootSelector)((state)=>state.focus);
const $9c9b8e89fddd633d$var$gridFocusCellSelector = $9c9b8e89fddd633d$exports.gridFocusCellSelector = (0, $8eef5f2af445e503$exports.createSelector)($9c9b8e89fddd633d$var$gridFocusStateSelector, (focusState)=>focusState.cell);
const $9c9b8e89fddd633d$var$gridFocusColumnHeaderSelector = $9c9b8e89fddd633d$exports.gridFocusColumnHeaderSelector = (0, $8eef5f2af445e503$exports.createSelector)($9c9b8e89fddd633d$var$gridFocusStateSelector, (focusState)=>focusState.columnHeader);
const $9c9b8e89fddd633d$var$gridFocusColumnHeaderFilterSelector = $9c9b8e89fddd633d$exports.gridFocusColumnHeaderFilterSelector = (0, $8eef5f2af445e503$exports.createSelector)($9c9b8e89fddd633d$var$gridFocusStateSelector, (focusState)=>focusState.columnHeaderFilter);
const $9c9b8e89fddd633d$var$gridFocusColumnGroupHeaderSelector = $9c9b8e89fddd633d$exports.gridFocusColumnGroupHeaderSelector = (0, $8eef5f2af445e503$exports.createSelector)($9c9b8e89fddd633d$var$gridFocusStateSelector, (focusState)=>focusState.columnGroupHeader);
const $9c9b8e89fddd633d$var$gridTabIndexStateSelector = $9c9b8e89fddd633d$exports.gridTabIndexStateSelector = (0, $8eef5f2af445e503$exports.createRootSelector)((state)=>state.tabIndex);
const $9c9b8e89fddd633d$var$gridTabIndexCellSelector = $9c9b8e89fddd633d$exports.gridTabIndexCellSelector = (0, $8eef5f2af445e503$exports.createSelector)($9c9b8e89fddd633d$var$gridTabIndexStateSelector, (state)=>state.cell);
const $9c9b8e89fddd633d$var$gridTabIndexColumnHeaderSelector = $9c9b8e89fddd633d$exports.gridTabIndexColumnHeaderSelector = (0, $8eef5f2af445e503$exports.createSelector)($9c9b8e89fddd633d$var$gridTabIndexStateSelector, (state)=>state.columnHeader);
const $9c9b8e89fddd633d$var$gridTabIndexColumnHeaderFilterSelector = $9c9b8e89fddd633d$exports.gridTabIndexColumnHeaderFilterSelector = (0, $8eef5f2af445e503$exports.createSelector)($9c9b8e89fddd633d$var$gridTabIndexStateSelector, (state)=>state.columnHeaderFilter);
const $9c9b8e89fddd633d$var$gridTabIndexColumnGroupHeaderSelector = $9c9b8e89fddd633d$exports.gridTabIndexColumnGroupHeaderSelector = (0, $8eef5f2af445e503$exports.createSelector)($9c9b8e89fddd633d$var$gridTabIndexStateSelector, (state)=>state.columnGroupHeader);




var $bDyDY = parcelRequire("bDyDY");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $c41ec74257ca380c$exports = {};
"use strict";
Object.defineProperty($c41ec74257ca380c$exports, "__esModule", {
    value: true
});
$c41ec74257ca380c$exports.gridVisibleRowsSelector = $c41ec74257ca380c$exports.gridPaginationSelector = $c41ec74257ca380c$exports.gridPaginationRowRangeSelector = $c41ec74257ca380c$exports.gridPaginationRowCountSelector = $c41ec74257ca380c$exports.gridPaginationModelSelector = $c41ec74257ca380c$exports.gridPaginationMetaSelector = $c41ec74257ca380c$exports.gridPaginationEnabledClientSideSelector = $c41ec74257ca380c$exports.gridPaginatedVisibleSortedGridRowIdsSelector = $c41ec74257ca380c$exports.gridPaginatedVisibleSortedGridRowEntriesSelector = $c41ec74257ca380c$exports.gridPageSizeSelector = $c41ec74257ca380c$exports.gridPageSelector = $c41ec74257ca380c$exports.gridPageCountSelector = void 0;



var $820f672e99dc58bd$exports = {};
"use strict";
Object.defineProperty($820f672e99dc58bd$exports, "__esModule", {
    value: true
});
$820f672e99dc58bd$exports.throwIfPageSizeExceedsTheLimit = $820f672e99dc58bd$exports.getValidPage = $820f672e99dc58bd$exports.getPageCount = $820f672e99dc58bd$exports.getDefaultGridPaginationModel = $820f672e99dc58bd$exports.defaultPageSize = void 0;

const $820f672e99dc58bd$var$MAX_PAGE_SIZE = 100;
const $820f672e99dc58bd$var$defaultPageSize = (autoPageSize)=>autoPageSize ? 0 : 100;
$820f672e99dc58bd$exports.defaultPageSize = $820f672e99dc58bd$var$defaultPageSize;
const $820f672e99dc58bd$var$getPageCount = (rowCount, pageSize, page)=>{
    if (pageSize > 0 && rowCount > 0) return Math.ceil(rowCount / pageSize);
    if (rowCount === -1) // With unknown row-count, we can assume a page after the current one
    return page + 2;
    return 0;
};
$820f672e99dc58bd$exports.getPageCount = $820f672e99dc58bd$var$getPageCount;
const $820f672e99dc58bd$var$getDefaultGridPaginationModel = (autoPageSize)=>({
        page: 0,
        pageSize: autoPageSize ? 0 : 100
    });
$820f672e99dc58bd$exports.getDefaultGridPaginationModel = $820f672e99dc58bd$var$getDefaultGridPaginationModel;
const $820f672e99dc58bd$var$getValidPage = (page, pageCount = 0)=>{
    if (pageCount === 0) return page;
    return Math.max(Math.min(page, pageCount - 1), 0);
};
$820f672e99dc58bd$exports.getValidPage = $820f672e99dc58bd$var$getValidPage;
const $820f672e99dc58bd$var$throwIfPageSizeExceedsTheLimit = (pageSize, signatureProp)=>{
    if (signatureProp === $dc886d040ec4e87c$exports.GridSignature.DataGrid && pageSize > $820f672e99dc58bd$var$MAX_PAGE_SIZE) throw new Error([
        'MUI X: `pageSize` cannot exceed 100 in the MIT version of the DataGrid.',
        'You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature.'
    ].join('\n'));
};
$820f672e99dc58bd$exports.throwIfPageSizeExceedsTheLimit = $820f672e99dc58bd$var$throwIfPageSizeExceedsTheLimit;


const $c41ec74257ca380c$var$ALL_RESULTS_PAGE_VALUE = -1;
/**
 * @category Pagination
 * @ignore - do not document.
 */ const $c41ec74257ca380c$var$gridPaginationSelector = $c41ec74257ca380c$exports.gridPaginationSelector = (0, $8eef5f2af445e503$exports.createRootSelector)((state)=>state.pagination);
/**
 * @category Pagination
 * @ignore - do not document.
 */ const $c41ec74257ca380c$var$gridPaginationEnabledClientSideSelector = $c41ec74257ca380c$exports.gridPaginationEnabledClientSideSelector = (0, $8eef5f2af445e503$exports.createSelector)($c41ec74257ca380c$var$gridPaginationSelector, (pagination)=>pagination.enabled && pagination.paginationMode === 'client');
/**
 * Get the pagination model
 * @category Pagination
 */ const $c41ec74257ca380c$var$gridPaginationModelSelector = $c41ec74257ca380c$exports.gridPaginationModelSelector = (0, $8eef5f2af445e503$exports.createSelector)($c41ec74257ca380c$var$gridPaginationSelector, (pagination)=>pagination.paginationModel);
/**
 * Get the row count
 * @category Pagination
 */ const $c41ec74257ca380c$var$gridPaginationRowCountSelector = $c41ec74257ca380c$exports.gridPaginationRowCountSelector = (0, $8eef5f2af445e503$exports.createSelector)($c41ec74257ca380c$var$gridPaginationSelector, (pagination)=>pagination.rowCount);
/**
 * Get the pagination meta
 * @category Pagination
 */ const $c41ec74257ca380c$var$gridPaginationMetaSelector = $c41ec74257ca380c$exports.gridPaginationMetaSelector = (0, $8eef5f2af445e503$exports.createSelector)($c41ec74257ca380c$var$gridPaginationSelector, (pagination)=>pagination.meta);
/**
 * Get the index of the page to render if the pagination is enabled
 * @category Pagination
 */ const $c41ec74257ca380c$var$gridPageSelector = $c41ec74257ca380c$exports.gridPageSelector = (0, $8eef5f2af445e503$exports.createSelector)($c41ec74257ca380c$var$gridPaginationModelSelector, (paginationModel)=>paginationModel.page);
/**
 * Get the maximum amount of rows to display on a single page if the pagination is enabled
 * @category Pagination
 */ const $c41ec74257ca380c$var$gridPageSizeSelector = $c41ec74257ca380c$exports.gridPageSizeSelector = (0, $8eef5f2af445e503$exports.createSelector)($c41ec74257ca380c$var$gridPaginationModelSelector, (paginationModel)=>paginationModel.pageSize);
/**
 * Get the amount of pages needed to display all the rows if the pagination is enabled
 * @category Pagination
 */ const $c41ec74257ca380c$var$gridPageCountSelector = $c41ec74257ca380c$exports.gridPageCountSelector = (0, $8eef5f2af445e503$exports.createSelector)($c41ec74257ca380c$var$gridPaginationModelSelector, $c41ec74257ca380c$var$gridPaginationRowCountSelector, (paginationModel, rowCount)=>(0, $820f672e99dc58bd$exports.getPageCount)(rowCount, paginationModel.pageSize, paginationModel.page));
/**
 * Get the index of the first and the last row to include in the current page if the pagination is enabled.
 * @category Pagination
 */ const $c41ec74257ca380c$var$gridPaginationRowRangeSelector = $c41ec74257ca380c$exports.gridPaginationRowRangeSelector = (0, $8eef5f2af445e503$exports.createSelectorMemoized)($c41ec74257ca380c$var$gridPaginationEnabledClientSideSelector, $c41ec74257ca380c$var$gridPaginationModelSelector, $befccaa56b49492d$exports.gridRowTreeSelector, $befccaa56b49492d$exports.gridRowMaximumTreeDepthSelector, $e95988b653de2e96$exports.gridExpandedSortedRowEntriesSelector, $e95988b653de2e96$exports.gridFilteredSortedTopLevelRowEntriesSelector, (clientSidePaginationEnabled, paginationModel, rowTree, rowTreeDepth, visibleSortedRowEntries, visibleSortedTopLevelRowEntries)=>{
    if (!clientSidePaginationEnabled) return null;
    const visibleTopLevelRowCount = visibleSortedTopLevelRowEntries.length;
    const topLevelFirstRowIndex = Math.min(paginationModel.pageSize * paginationModel.page, visibleTopLevelRowCount - 1);
    const topLevelLastRowIndex = paginationModel.pageSize === $c41ec74257ca380c$var$ALL_RESULTS_PAGE_VALUE ? visibleTopLevelRowCount - 1 : Math.min(topLevelFirstRowIndex + paginationModel.pageSize - 1, visibleTopLevelRowCount - 1);
    // The range contains no element
    if (topLevelFirstRowIndex === -1 || topLevelLastRowIndex === -1) return null;
    // The tree is flat, there is no need to look for children
    if (rowTreeDepth < 2) return {
        firstRowIndex: topLevelFirstRowIndex,
        lastRowIndex: topLevelLastRowIndex
    };
    const topLevelFirstRow = visibleSortedTopLevelRowEntries[topLevelFirstRowIndex];
    const topLevelRowsInCurrentPageCount = topLevelLastRowIndex - topLevelFirstRowIndex + 1;
    const firstRowIndex = visibleSortedRowEntries.findIndex((row)=>row.id === topLevelFirstRow.id);
    let lastRowIndex = firstRowIndex;
    let topLevelRowAdded = 0;
    while(lastRowIndex < visibleSortedRowEntries.length && topLevelRowAdded <= topLevelRowsInCurrentPageCount){
        const row = visibleSortedRowEntries[lastRowIndex];
        const depth = rowTree[row.id]?.depth;
        if (depth === undefined) lastRowIndex += 1;
        else {
            if (topLevelRowAdded < topLevelRowsInCurrentPageCount || depth > 0) lastRowIndex += 1;
            if (depth === 0) topLevelRowAdded += 1;
        }
    }
    return {
        firstRowIndex: firstRowIndex,
        lastRowIndex: lastRowIndex - 1
    };
});
/**
 * Get the id and the model of each row to include in the current page if the pagination is enabled.
 * @category Pagination
 */ const $c41ec74257ca380c$var$gridPaginatedVisibleSortedGridRowEntriesSelector = $c41ec74257ca380c$exports.gridPaginatedVisibleSortedGridRowEntriesSelector = (0, $8eef5f2af445e503$exports.createSelectorMemoized)($e95988b653de2e96$exports.gridExpandedSortedRowEntriesSelector, $c41ec74257ca380c$var$gridPaginationRowRangeSelector, (visibleSortedRowEntries, paginationRange)=>{
    if (!paginationRange) return [];
    return visibleSortedRowEntries.slice(paginationRange.firstRowIndex, paginationRange.lastRowIndex + 1);
});
/**
 * Get the id of each row to include in the current page if the pagination is enabled.
 * @category Pagination
 */ const $c41ec74257ca380c$var$gridPaginatedVisibleSortedGridRowIdsSelector = $c41ec74257ca380c$exports.gridPaginatedVisibleSortedGridRowIdsSelector = (0, $8eef5f2af445e503$exports.createSelectorMemoized)($e95988b653de2e96$exports.gridExpandedSortedRowIdsSelector, $c41ec74257ca380c$var$gridPaginationRowRangeSelector, (visibleSortedRowIds, paginationRange)=>{
    if (!paginationRange) return [];
    return visibleSortedRowIds.slice(paginationRange.firstRowIndex, paginationRange.lastRowIndex + 1);
});
/**
 * Get the rows, range and rowIndex lookup map after filtering and sorting.
 * Does not contain the collapsed children.
 * @category Pagination
 */ const $c41ec74257ca380c$var$gridVisibleRowsSelector = $c41ec74257ca380c$exports.gridVisibleRowsSelector = (0, $8eef5f2af445e503$exports.createSelectorMemoized)($c41ec74257ca380c$var$gridPaginationEnabledClientSideSelector, $c41ec74257ca380c$var$gridPaginationRowRangeSelector, $c41ec74257ca380c$var$gridPaginatedVisibleSortedGridRowEntriesSelector, $e95988b653de2e96$exports.gridExpandedSortedRowEntriesSelector, (clientPaginationEnabled, paginationRowRange, paginationRows, expandedSortedRowEntries)=>{
    if (clientPaginationEnabled) return {
        rows: paginationRows,
        range: paginationRowRange,
        rowIdToIndexMap: paginationRows.reduce((lookup, row, index)=>{
            lookup.set(row.id, index);
            return lookup;
        }, new Map())
    };
    return {
        rows: expandedSortedRowEntries,
        range: expandedSortedRowEntries.length === 0 ? null : {
            firstRowIndex: 0,
            lastRowIndex: expandedSortedRowEntries.length - 1
        },
        rowIdToIndexMap: expandedSortedRowEntries.reduce((lookup, row, index)=>{
            lookup.set(row.id, index);
            return lookup;
        }, new Map())
    };
});




var $ayMG0 = parcelRequire("ayMG0");
const $328bc9e57e6b696b$var$_excluded = [
    "field",
    "colDef"
];
const $328bc9e57e6b696b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'checkboxInput'
        ]
    };
    return (0, $328bc9e57e6b696b$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $328bc9e57e6b696b$var$GridHeaderCheckbox = $328bc9e57e6b696b$exports.GridHeaderCheckbox = (0, $fYxgT.forwardRef)(function GridHeaderCheckbox(props, ref) {
    const other = (0, $328bc9e57e6b696b$var$_objectWithoutPropertiesLoose2.default)(props, $328bc9e57e6b696b$var$_excluded);
    const [, forceUpdate] = $328bc9e57e6b696b$var$React.useState(false);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = $328bc9e57e6b696b$var$useUtilityClasses(ownerState);
    const tabIndexState = (0, $5sOMZ.useGridSelector)(apiRef, $9c9b8e89fddd633d$exports.gridTabIndexColumnHeaderSelector);
    const selection = (0, $5sOMZ.useGridSelector)(apiRef, $7a5249c135fd39c1$exports.gridRowSelectionStateSelector);
    const visibleRowIds = (0, $5sOMZ.useGridSelector)(apiRef, $e95988b653de2e96$exports.gridExpandedSortedRowIdsSelector);
    const paginatedVisibleRowIds = (0, $5sOMZ.useGridSelector)(apiRef, $c41ec74257ca380c$exports.gridPaginatedVisibleSortedGridRowIdsSelector);
    const filteredSelection = $328bc9e57e6b696b$var$React.useMemo(()=>{
        const isRowSelectable = rootProps.isRowSelectable;
        if (typeof isRowSelectable !== 'function') return selection;
        if (selection.type === 'exclude') return selection;
        // selection.type === 'include'
        const selectionModel = {
            type: 'include',
            ids: new Set()
        };
        for (const id of selection.ids){
            if (rootProps.keepNonExistentRowsSelected) selectionModel.ids.add(id);
            // The row might have been deleted
            if (!apiRef.current.getRow(id)) continue;
            if (isRowSelectable(apiRef.current.getRowParams(id))) selectionModel.ids.add(id);
        }
        return selectionModel;
    }, [
        apiRef,
        rootProps.isRowSelectable,
        rootProps.keepNonExistentRowsSelected,
        selection
    ]);
    // All the rows that could be selected / unselected by toggling this checkbox
    const selectionCandidates = $328bc9e57e6b696b$var$React.useMemo(()=>{
        const rowIds = !rootProps.pagination || !rootProps.checkboxSelectionVisibleOnly || rootProps.paginationMode === 'server' ? visibleRowIds : paginatedVisibleRowIds;
        // Convert to a Set to make O(1) checking if a row exists or not
        const candidates = new Set();
        for(let i = 0; i < rowIds.length; i += 1){
            const id = rowIds[i];
            if (!apiRef.current.getRow(id)) continue;
            if (apiRef.current.isRowSelectable(id)) candidates.add(id);
        }
        return candidates;
    }, [
        apiRef,
        rootProps.pagination,
        rootProps.paginationMode,
        rootProps.checkboxSelectionVisibleOnly,
        paginatedVisibleRowIds,
        visibleRowIds
    ]);
    // Amount of rows selected and that are visible in the current page
    const currentSelectionSize = $328bc9e57e6b696b$var$React.useMemo(()=>{
        const selectionManager = (0, $8ee7986d138c7e40$exports.createRowSelectionManager)(filteredSelection);
        let size = 0;
        for (const id of selectionCandidates)if (selectionManager.has(id)) size += 1;
        return size;
    }, [
        filteredSelection,
        selectionCandidates
    ]);
    const isIndeterminate = $328bc9e57e6b696b$var$React.useMemo(()=>{
        if (currentSelectionSize === 0) return false;
        const selectionManager = (0, $8ee7986d138c7e40$exports.createRowSelectionManager)(filteredSelection);
        for (const rowId of selectionCandidates){
            if (!selectionManager.has(rowId)) return true;
        }
        return false;
    }, [
        currentSelectionSize,
        filteredSelection,
        selectionCandidates
    ]);
    const isChecked = currentSelectionSize > 0;
    const handleChange = (event)=>{
        const params = {
            value: event.target.checked
        };
        apiRef.current.publishEvent('headerSelectionCheckboxChange', params);
    };
    const tabIndex = tabIndexState !== null && tabIndexState.field === props.field ? 0 : -1;
    $328bc9e57e6b696b$var$React.useLayoutEffect(()=>{
        const element = apiRef.current.getColumnHeaderElement(props.field);
        if (tabIndex === 0 && element) element.tabIndex = -1;
    }, [
        tabIndex,
        apiRef,
        props.field
    ]);
    const handleKeyDown = $328bc9e57e6b696b$var$React.useCallback((event)=>{
        if (event.key === ' ') // imperative toggle the checkbox because Space is disable by some preventDefault
        apiRef.current.publishEvent('headerSelectionCheckboxChange', {
            value: !isChecked
        });
    }, [
        apiRef,
        isChecked
    ]);
    const handleSelectionChange = $328bc9e57e6b696b$var$React.useCallback(()=>{
        forceUpdate((p)=>!p);
    }, []);
    $328bc9e57e6b696b$var$React.useEffect(()=>{
        return apiRef.current.subscribeEvent('rowSelectionChange', handleSelectionChange);
    }, [
        apiRef,
        handleSelectionChange
    ]);
    const label = apiRef.current.getLocaleText(isChecked && !isIndeterminate ? 'checkboxSelectionUnselectAllRows' : 'checkboxSelectionSelectAllRows');
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseCheckbox, (0, $328bc9e57e6b696b$var$_extends2.default)({
        indeterminate: isIndeterminate,
        checked: isChecked && !isIndeterminate,
        onChange: handleChange,
        className: classes.root,
        slotProps: {
            htmlInput: {
                'aria-label': label,
                name: 'select_all_rows'
            }
        },
        tabIndex: tabIndex,
        onKeyDown: handleKeyDown,
        disabled: !(0, $dae18049c8685698$exports.isMultipleRowSelectionEnabled)(rootProps)
    }, rootProps.slotProps?.baseCheckbox, other, {
        ref: ref
    }));
});
$328bc9e57e6b696b$var$GridHeaderCheckbox.displayName = "GridHeaderCheckbox";
$328bc9e57e6b696b$var$GridHeaderCheckbox.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * The column of the current header component.
   */ colDef: $328bc9e57e6b696b$var$_propTypes.default.object.isRequired,
    /**
   * The column field of the column that triggered the event
   */ field: $328bc9e57e6b696b$var$_propTypes.default.string.isRequired
};





var $ayMG0 = parcelRequire("ayMG0");
const $3c6ea315aeb792f9$var$GRID_CHECKBOX_SELECTION_FIELD = $3c6ea315aeb792f9$exports.GRID_CHECKBOX_SELECTION_FIELD = '__check__';
const $3c6ea315aeb792f9$var$GRID_CHECKBOX_SELECTION_COL_DEF = $3c6ea315aeb792f9$exports.GRID_CHECKBOX_SELECTION_COL_DEF = (0, $3c6ea315aeb792f9$var$_extends2.default)({}, $daf44030e7d36790$exports.GRID_BOOLEAN_COL_DEF, {
    type: 'custom',
    field: $3c6ea315aeb792f9$var$GRID_CHECKBOX_SELECTION_FIELD,
    width: 50,
    resizable: false,
    sortable: false,
    filterable: false,
    // @ts-ignore
    aggregable: false,
    chartable: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    getApplyQuickFilterFn: ()=>null,
    display: 'flex',
    valueGetter: (value, row, column, apiRef)=>{
        const rowId = (0, $0d26ce0880758663$exports.gridRowIdSelector)(apiRef, row);
        return apiRef.current.isRowSelected(rowId);
    },
    rowSpanValueGetter: (_, row, column, apiRef)=>(0, $0d26ce0880758663$exports.gridRowIdSelector)(apiRef, row),
    renderHeader: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)($328bc9e57e6b696b$exports.GridHeaderCheckbox, (0, $3c6ea315aeb792f9$var$_extends2.default)({}, params)),
    renderCell: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)($b1dfb45352a7562a$exports.GridCellCheckboxRenderer, (0, $3c6ea315aeb792f9$var$_extends2.default)({}, params))
});


Object.keys($3c6ea315aeb792f9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $a6506085715c5aff$exports && $a6506085715c5aff$exports[key] === $3c6ea315aeb792f9$exports[key]) return;
    Object.defineProperty($a6506085715c5aff$exports, key, {
        enumerable: true,
        get: function() {
            return $3c6ea315aeb792f9$exports[key];
        }
    });
});
var $7ac2b9e608be0423$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $7ac2b9e608be0423$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($7ac2b9e608be0423$exports, "__esModule", {
    value: true
});
$7ac2b9e608be0423$exports.gridDateTimeFormatter = $7ac2b9e608be0423$exports.gridDateFormatter = $7ac2b9e608be0423$exports.GRID_DATE_COL_DEF = $7ac2b9e608be0423$exports.GRID_DATETIME_COL_DEF = void 0;

var $7ac2b9e608be0423$var$_extends2 = $7ac2b9e608be0423$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $42483ac831686fc7$exports = {};
"use strict";
Object.defineProperty($42483ac831686fc7$exports, "__esModule", {
    value: true
});
$42483ac831686fc7$exports.getGridDateOperators = void 0;
var $40a3126b9e135d1e$exports = {};
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $40a3126b9e135d1e$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $40a3126b9e135d1e$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($40a3126b9e135d1e$exports, "__esModule", {
    value: true
});
$40a3126b9e135d1e$exports.GridFilterInputDate = $40a3126b9e135d1e$var$GridFilterInputDate;

var $40a3126b9e135d1e$var$_extends2 = $40a3126b9e135d1e$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $40a3126b9e135d1e$var$_objectWithoutPropertiesLoose2 = $40a3126b9e135d1e$require$_interopRequireDefault((parcelRequire("c05no")));

var $40a3126b9e135d1e$var$React = $40a3126b9e135d1e$require$_interopRequireWildcard((parcelRequire("acw62")));

var $40a3126b9e135d1e$var$_propTypes = $40a3126b9e135d1e$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $40a3126b9e135d1e$var$_useId = $40a3126b9e135d1e$require$_interopRequireDefault((parcelRequire("hwliF")));


var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $40a3126b9e135d1e$var$_excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "slotProps",
    "isFilterActive",
    "headerFilterMenu",
    "clearButton",
    "tabIndex",
    "disabled"
];
function $40a3126b9e135d1e$var$convertFilterItemValueToInputValue(itemValue, inputType) {
    if (itemValue == null) return '';
    const dateCopy = new Date(itemValue);
    if (Number.isNaN(dateCopy.getTime())) return '';
    if (inputType === 'date') return dateCopy.toISOString().substring(0, 10);
    if (inputType === 'datetime-local') {
        // The date picker expects the date to be in the local timezone.
        // But .toISOString() converts it to UTC with zero offset.
        // So we need to subtract the timezone offset.
        dateCopy.setMinutes(dateCopy.getMinutes() - dateCopy.getTimezoneOffset());
        return dateCopy.toISOString().substring(0, 19);
    }
    return dateCopy.toISOString().substring(0, 10);
}
function $40a3126b9e135d1e$var$GridFilterInputDate(props) {
    const { item: item, applyValue: applyValue, type: type, apiRef: apiRef, focusElementRef: focusElementRef, slotProps: slotProps, headerFilterMenu: headerFilterMenu, clearButton: clearButton, tabIndex: tabIndex, disabled: disabled } = props, other = (0, $40a3126b9e135d1e$var$_objectWithoutPropertiesLoose2.default)(props, $40a3126b9e135d1e$var$_excluded);
    const rootSlotProps = slotProps?.root.slotProps;
    const filterTimeout = (0, $3ede1456da2c476e$exports.useTimeout)();
    const [filterValueState, setFilterValueState] = $40a3126b9e135d1e$var$React.useState(()=>$40a3126b9e135d1e$var$convertFilterItemValueToInputValue(item.value, type));
    const [applying, setIsApplying] = $40a3126b9e135d1e$var$React.useState(false);
    const id = (0, $40a3126b9e135d1e$var$_useId.default)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const onFilterChange = $40a3126b9e135d1e$var$React.useCallback((event)=>{
        filterTimeout.clear();
        const value = event.target.value;
        setFilterValueState(value);
        setIsApplying(true);
        filterTimeout.start(rootProps.filterDebounceMs, ()=>{
            const date = new Date(value);
            applyValue((0, $40a3126b9e135d1e$var$_extends2.default)({}, item, {
                value: Number.isNaN(date.getTime()) ? undefined : date
            }));
            setIsApplying(false);
        });
    }, [
        applyValue,
        item,
        rootProps.filterDebounceMs,
        filterTimeout
    ]);
    $40a3126b9e135d1e$var$React.useEffect(()=>{
        const value = $40a3126b9e135d1e$var$convertFilterItemValueToInputValue(item.value, type);
        setFilterValueState(value);
    }, [
        item.value,
        type
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($40a3126b9e135d1e$var$React.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTextField, (0, $40a3126b9e135d1e$var$_extends2.default)({
                fullWidth: true,
                id: id,
                label: apiRef.current.getLocaleText('filterPanelInputLabel'),
                placeholder: apiRef.current.getLocaleText('filterPanelInputPlaceholder'),
                value: filterValueState,
                onChange: onFilterChange,
                type: type || 'text',
                disabled: disabled,
                inputRef: focusElementRef,
                slotProps: (0, $40a3126b9e135d1e$var$_extends2.default)({}, rootSlotProps, {
                    input: (0, $40a3126b9e135d1e$var$_extends2.default)({
                        endAdornment: applying ? /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.loadIcon, {
                            fontSize: "small",
                            color: "action"
                        }) : null
                    }, rootSlotProps?.input),
                    htmlInput: (0, $40a3126b9e135d1e$var$_extends2.default)({
                        max: type === 'datetime-local' ? '9999-12-31T23:59' : '9999-12-31',
                        tabIndex: tabIndex
                    }, rootSlotProps?.htmlInput)
                })
            }, rootProps.slotProps?.baseTextField, other, slotProps?.root)),
            headerFilterMenu,
            clearButton
        ]
    });
}
$40a3126b9e135d1e$var$GridFilterInputDate.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    apiRef: $40a3126b9e135d1e$var$_propTypes.default.shape({
        current: $40a3126b9e135d1e$var$_propTypes.default.object.isRequired
    }).isRequired,
    applyValue: $40a3126b9e135d1e$var$_propTypes.default.func.isRequired,
    className: $40a3126b9e135d1e$var$_propTypes.default.string,
    clearButton: $40a3126b9e135d1e$var$_propTypes.default.node,
    disabled: $40a3126b9e135d1e$var$_propTypes.default.bool,
    focusElementRef: $40a3126b9e135d1e$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $40a3126b9e135d1e$var$_propTypes.default.func,
        $40a3126b9e135d1e$var$_propTypes.default.object
    ]),
    headerFilterMenu: $40a3126b9e135d1e$var$_propTypes.default.node,
    inputRef: $40a3126b9e135d1e$var$_propTypes.default.oneOfType([
        $40a3126b9e135d1e$var$_propTypes.default.func,
        $40a3126b9e135d1e$var$_propTypes.default.shape({
            current: (props, propName)=>{
                if (props[propName] == null) return null;
                if (typeof props[propName] !== 'object' || props[propName].nodeType !== 1) return new Error(`Expected prop '${propName}' to be of type Element`);
                return null;
            }
        })
    ]),
    /**
   * It is `true` if the filter either has a value or an operator with no value
   * required is selected (for example `isEmpty`)
   */ isFilterActive: $40a3126b9e135d1e$var$_propTypes.default.bool,
    item: $40a3126b9e135d1e$var$_propTypes.default.shape({
        field: $40a3126b9e135d1e$var$_propTypes.default.string.isRequired,
        id: $40a3126b9e135d1e$var$_propTypes.default.oneOfType([
            $40a3126b9e135d1e$var$_propTypes.default.number,
            $40a3126b9e135d1e$var$_propTypes.default.string
        ]),
        operator: $40a3126b9e135d1e$var$_propTypes.default.string.isRequired,
        value: $40a3126b9e135d1e$var$_propTypes.default.any
    }).isRequired,
    onBlur: $40a3126b9e135d1e$var$_propTypes.default.func,
    onFocus: $40a3126b9e135d1e$var$_propTypes.default.func,
    slotProps: $40a3126b9e135d1e$var$_propTypes.default.object,
    tabIndex: $40a3126b9e135d1e$var$_propTypes.default.number,
    type: $40a3126b9e135d1e$var$_propTypes.default.oneOf([
        'date',
        'datetime-local'
    ])
};


function $42483ac831686fc7$var$buildApplyFilterFn(filterItem, compareFn, showTime, keepHours) {
    if (!filterItem.value) return null;
    const date = new Date(filterItem.value);
    if (showTime) date.setSeconds(0, 0);
    else {
        // In GMT-X timezone, the date will be one day behind.
        // For 2022-08-16:
        // GMT+2: Tue Aug 16 2022 02:00:00 GMT+0200
        // GMT-4: Mon Aug 15 2022 20:00:00 GMT-0400
        //
        // We need to add the offset before resetting the hours.
        date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
        date.setHours(0, 0, 0, 0);
    }
    const time = date.getTime();
    return (value)=>{
        if (!value) return false;
        if (keepHours) return compareFn(value.getTime(), time);
        // Make a copy of the date to not reset the hours in the original object
        const dateCopy = new Date(value);
        if (showTime) dateCopy.setSeconds(0, 0);
        else dateCopy.setHours(0, 0, 0, 0);
        return compareFn(dateCopy.getTime(), time);
    };
}
const $42483ac831686fc7$var$getGridDateOperators = (showTime)=>[
        {
            value: 'is',
            getApplyFilterFn: (filterItem)=>{
                return $42483ac831686fc7$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 === value2, showTime);
            },
            InputComponent: $40a3126b9e135d1e$exports.GridFilterInputDate,
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'not',
            getApplyFilterFn: (filterItem)=>{
                return $42483ac831686fc7$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 !== value2, showTime);
            },
            InputComponent: $40a3126b9e135d1e$exports.GridFilterInputDate,
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'after',
            getApplyFilterFn: (filterItem)=>{
                return $42483ac831686fc7$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 > value2, showTime);
            },
            InputComponent: $40a3126b9e135d1e$exports.GridFilterInputDate,
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'onOrAfter',
            getApplyFilterFn: (filterItem)=>{
                return $42483ac831686fc7$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 >= value2, showTime);
            },
            InputComponent: $40a3126b9e135d1e$exports.GridFilterInputDate,
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'before',
            getApplyFilterFn: (filterItem)=>{
                return $42483ac831686fc7$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 < value2, showTime, !showTime);
            },
            InputComponent: $40a3126b9e135d1e$exports.GridFilterInputDate,
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'onOrBefore',
            getApplyFilterFn: (filterItem)=>{
                return $42483ac831686fc7$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 <= value2, showTime);
            },
            InputComponent: $40a3126b9e135d1e$exports.GridFilterInputDate,
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'isEmpty',
            getApplyFilterFn: ()=>{
                return (value)=>{
                    return value == null;
                };
            },
            requiresFilterValue: false
        },
        {
            value: 'isNotEmpty',
            getApplyFilterFn: ()=>{
                return (value)=>{
                    return value != null;
                };
            },
            requiresFilterValue: false
        }
    ];
$42483ac831686fc7$exports.getGridDateOperators = $42483ac831686fc7$var$getGridDateOperators;



var $2a475a2a246869fc$exports = {};
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $2a475a2a246869fc$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $2a475a2a246869fc$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($2a475a2a246869fc$exports, "__esModule", {
    value: true
});
$2a475a2a246869fc$exports.GridEditDateCell = $2a475a2a246869fc$var$GridEditDateCell;
$2a475a2a246869fc$exports.renderEditDateCell = void 0;

var $2a475a2a246869fc$var$_extends2 = $2a475a2a246869fc$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $2a475a2a246869fc$var$_objectWithoutPropertiesLoose2 = $2a475a2a246869fc$require$_interopRequireDefault((parcelRequire("c05no")));

var $2a475a2a246869fc$var$React = $2a475a2a246869fc$require$_interopRequireWildcard((parcelRequire("acw62")));

var $2a475a2a246869fc$var$_propTypes = $2a475a2a246869fc$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $2a475a2a246869fc$var$_composeClasses = $2a475a2a246869fc$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $2a475a2a246869fc$var$_useEnhancedEffect = $2a475a2a246869fc$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $8xDHs = parcelRequire("8xDHs");


var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $bDyDY = parcelRequire("bDyDY");

var $ayMG0 = parcelRequire("ayMG0");
const $2a475a2a246869fc$var$_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "tabIndex",
    "hasFocus",
    "inputProps",
    "isValidating",
    "isProcessingProps",
    "onValueChange",
    "slotProps"
];
const $2a475a2a246869fc$var$StyledInputBase = (0, $8xDHs.styled)($dd66ac2a2c256d30$exports.NotRendered)({
    fontSize: 'inherit'
});
const $2a475a2a246869fc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'editInputCell'
        ]
    };
    return (0, $2a475a2a246869fc$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
function $2a475a2a246869fc$var$GridEditDateCell(props) {
    const { id: id, value: valueProp, field: field, colDef: colDef, hasFocus: hasFocus, onValueChange: onValueChange, slotProps: slotProps } = props, other = (0, $2a475a2a246869fc$var$_objectWithoutPropertiesLoose2.default)(props, $2a475a2a246869fc$var$_excluded);
    const isDateTime = colDef.type === 'dateTime';
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const inputRef = $2a475a2a246869fc$var$React.useRef(null);
    const valueTransformed = $2a475a2a246869fc$var$React.useMemo(()=>{
        let parsedDate;
        if (valueProp == null) parsedDate = null;
        else if (valueProp instanceof Date) parsedDate = valueProp;
        else parsedDate = new Date((valueProp ?? '').toString());
        let formattedDate;
        if (parsedDate == null || Number.isNaN(parsedDate.getTime())) formattedDate = '';
        else {
            const localDate = new Date(parsedDate.getTime() - parsedDate.getTimezoneOffset() * 60000);
            formattedDate = localDate.toISOString().substr(0, isDateTime ? 16 : 10);
        }
        return {
            parsed: parsedDate,
            formatted: formattedDate
        };
    }, [
        valueProp,
        isDateTime
    ]);
    const [valueState, setValueState] = $2a475a2a246869fc$var$React.useState(valueTransformed);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = $2a475a2a246869fc$var$useUtilityClasses(ownerState);
    const parseValueToDate = $2a475a2a246869fc$var$React.useCallback((value)=>{
        if (value === '') return null;
        const [date, time] = value.split('T');
        const [year, month, day] = date.split('-');
        const parsedDate = new Date();
        parsedDate.setFullYear(Number(year), Number(month) - 1, Number(day));
        parsedDate.setHours(0, 0, 0, 0);
        if (time) {
            const [hours, minutes] = time.split(':');
            parsedDate.setHours(Number(hours), Number(minutes), 0, 0);
        }
        return parsedDate;
    }, []);
    const handleChange = $2a475a2a246869fc$var$React.useCallback(async (event)=>{
        const newFormattedDate = event.target.value;
        const newParsedDate = parseValueToDate(newFormattedDate);
        if (onValueChange) await onValueChange(event, newParsedDate);
        setValueState({
            parsed: newParsedDate,
            formatted: newFormattedDate
        });
        apiRef.current.setEditCellValue({
            id: id,
            field: field,
            value: newParsedDate
        }, event);
    }, [
        apiRef,
        field,
        id,
        onValueChange,
        parseValueToDate
    ]);
    $2a475a2a246869fc$var$React.useEffect(()=>{
        setValueState((state)=>{
            if (valueTransformed.parsed !== state.parsed && valueTransformed.parsed?.getTime() !== state.parsed?.getTime()) return valueTransformed;
            return state;
        });
    }, [
        valueTransformed
    ]);
    (0, $2a475a2a246869fc$var$_useEnhancedEffect.default)(()=>{
        if (hasFocus) inputRef.current.focus();
    }, [
        hasFocus
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($2a475a2a246869fc$var$StyledInputBase, (0, $2a475a2a246869fc$var$_extends2.default)({
        as: rootProps.slots.baseInput,
        inputRef: inputRef,
        fullWidth: true,
        className: classes.root,
        type: isDateTime ? 'datetime-local' : 'date',
        value: valueState.formatted,
        onChange: handleChange
    }, other, slotProps?.root, {
        slotProps: {
            htmlInput: (0, $2a475a2a246869fc$var$_extends2.default)({
                max: isDateTime ? '9999-12-31T23:59' : '9999-12-31'
            }, slotProps?.root?.slotProps?.htmlInput)
        }
    }));
}
$2a475a2a246869fc$var$GridEditDateCell.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * GridApi that let you manipulate the grid.
   */ api: $2a475a2a246869fc$var$_propTypes.default.object.isRequired,
    /**
   * The mode of the cell.
   */ cellMode: $2a475a2a246869fc$var$_propTypes.default.oneOf([
        'edit',
        'view'
    ]).isRequired,
    changeReason: $2a475a2a246869fc$var$_propTypes.default.oneOf([
        'debouncedSetEditCellValue',
        'setEditCellValue'
    ]),
    /**
   * The column of the row that the current cell belongs to.
   */ colDef: $2a475a2a246869fc$var$_propTypes.default.object.isRequired,
    /**
   * The column field of the cell that triggered the event.
   */ field: $2a475a2a246869fc$var$_propTypes.default.string.isRequired,
    /**
   * The cell value formatted with the column valueFormatter.
   */ formattedValue: $2a475a2a246869fc$var$_propTypes.default.any,
    /**
   * If true, the cell is the active element.
   */ hasFocus: $2a475a2a246869fc$var$_propTypes.default.bool.isRequired,
    /**
   * The grid row id.
   */ id: $2a475a2a246869fc$var$_propTypes.default.oneOfType([
        $2a475a2a246869fc$var$_propTypes.default.number,
        $2a475a2a246869fc$var$_propTypes.default.string
    ]).isRequired,
    /**
   * If true, the cell is editable.
   */ isEditable: $2a475a2a246869fc$var$_propTypes.default.bool,
    isProcessingProps: $2a475a2a246869fc$var$_propTypes.default.bool,
    isValidating: $2a475a2a246869fc$var$_propTypes.default.bool,
    /**
   * Callback called when the value is changed by the user.
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * @param {Date | null} newValue The value that is going to be passed to `apiRef.current.setEditCellValue`.
   * @returns {Promise<void> | void} A promise to be awaited before calling `apiRef.current.setEditCellValue`
   */ onValueChange: $2a475a2a246869fc$var$_propTypes.default.func,
    /**
   * The row model of the row that the current cell belongs to.
   */ row: $2a475a2a246869fc$var$_propTypes.default.any.isRequired,
    /**
   * The node of the row that the current cell belongs to.
   */ rowNode: $2a475a2a246869fc$var$_propTypes.default.object.isRequired,
    slotProps: $2a475a2a246869fc$var$_propTypes.default.object,
    /**
   * the tabIndex value.
   */ tabIndex: $2a475a2a246869fc$var$_propTypes.default.oneOf([
        -1,
        0
    ]).isRequired,
    /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */ value: $2a475a2a246869fc$var$_propTypes.default.any
};
const $2a475a2a246869fc$var$renderEditDateCell = (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)($2a475a2a246869fc$var$GridEditDateCell, (0, $2a475a2a246869fc$var$_extends2.default)({}, params));
$2a475a2a246869fc$exports.renderEditDateCell = $2a475a2a246869fc$var$renderEditDateCell;
$2a475a2a246869fc$var$renderEditDateCell.displayName = "renderEditDateCell";




function $7ac2b9e608be0423$var$throwIfNotDateObject({ value: value, columnType: columnType, rowId: rowId, field: field }) {
    if (!(value instanceof Date)) throw new Error([
        `MUI X: \`${columnType}\` column type only accepts \`Date\` objects as values.`,
        'Use `valueGetter` to transform the value into a `Date` object.',
        `Row ID: ${rowId}, field: "${field}".`
    ].join('\n'));
}
const $7ac2b9e608be0423$var$gridDateFormatter = (value, row, column, apiRef)=>{
    if (!value) return '';
    const rowId = (0, $0d26ce0880758663$exports.gridRowIdSelector)(apiRef, row);
    if ((0, $0166dd44615cae0d$exports.isAutogeneratedRow)(row) && !(value instanceof Date)) return value;
    $7ac2b9e608be0423$var$throwIfNotDateObject({
        value: value,
        columnType: 'date',
        rowId: rowId,
        field: column.field
    });
    return value.toLocaleDateString();
};
$7ac2b9e608be0423$exports.gridDateFormatter = $7ac2b9e608be0423$var$gridDateFormatter;
const $7ac2b9e608be0423$var$gridDateTimeFormatter = (value, row, column, apiRef)=>{
    if (!value) return '';
    const rowId = (0, $0d26ce0880758663$exports.gridRowIdSelector)(apiRef, row);
    if ((0, $0166dd44615cae0d$exports.isAutogeneratedRow)(row) && !(value instanceof Date)) return value;
    $7ac2b9e608be0423$var$throwIfNotDateObject({
        value: value,
        columnType: 'dateTime',
        rowId: rowId,
        field: column.field
    });
    return value.toLocaleString();
};
$7ac2b9e608be0423$exports.gridDateTimeFormatter = $7ac2b9e608be0423$var$gridDateTimeFormatter;
const $7ac2b9e608be0423$var$GRID_DATE_COL_DEF = $7ac2b9e608be0423$exports.GRID_DATE_COL_DEF = (0, $7ac2b9e608be0423$var$_extends2.default)({}, $8a69393405f257b1$exports.GRID_STRING_COL_DEF, {
    type: 'date',
    sortComparator: $c78f90aae54b126e$exports.gridDateComparator,
    valueFormatter: $7ac2b9e608be0423$var$gridDateFormatter,
    filterOperators: (0, $42483ac831686fc7$exports.getGridDateOperators)(),
    renderEditCell: $2a475a2a246869fc$exports.renderEditDateCell,
    // @ts-ignore
    pastedValueParser: (value)=>new Date(value)
});
const $7ac2b9e608be0423$var$GRID_DATETIME_COL_DEF = $7ac2b9e608be0423$exports.GRID_DATETIME_COL_DEF = (0, $7ac2b9e608be0423$var$_extends2.default)({}, $8a69393405f257b1$exports.GRID_STRING_COL_DEF, {
    type: 'dateTime',
    sortComparator: $c78f90aae54b126e$exports.gridDateComparator,
    valueFormatter: $7ac2b9e608be0423$var$gridDateTimeFormatter,
    filterOperators: (0, $42483ac831686fc7$exports.getGridDateOperators)(true),
    renderEditCell: $2a475a2a246869fc$exports.renderEditDateCell,
    // @ts-ignore
    pastedValueParser: (value)=>new Date(value)
});


Object.keys($7ac2b9e608be0423$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $a6506085715c5aff$exports && $a6506085715c5aff$exports[key] === $7ac2b9e608be0423$exports[key]) return;
    Object.defineProperty($a6506085715c5aff$exports, key, {
        enumerable: true,
        get: function() {
            return $7ac2b9e608be0423$exports[key];
        }
    });
});
var $a4694bea3e886bc3$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a4694bea3e886bc3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($a4694bea3e886bc3$exports, "__esModule", {
    value: true
});
$a4694bea3e886bc3$exports.GRID_NUMERIC_COL_DEF = void 0;

var $a4694bea3e886bc3$var$_extends2 = $a4694bea3e886bc3$require$_interopRequireDefault((parcelRequire("3p9rK")));


var $67759673d54fca41$exports = {};
"use strict";
Object.defineProperty($67759673d54fca41$exports, "__esModule", {
    value: true
});
$67759673d54fca41$exports.getGridNumericQuickFilterFn = $67759673d54fca41$exports.getGridNumericOperators = void 0;


const $67759673d54fca41$var$parseNumericValue = (value)=>{
    if (value == null) return null;
    return Number(value);
};
const $67759673d54fca41$var$getGridNumericQuickFilterFn = (value)=>{
    if (value == null || Number.isNaN(value) || value === '') return null;
    return (columnValue)=>{
        return $67759673d54fca41$var$parseNumericValue(columnValue) === $67759673d54fca41$var$parseNumericValue(value);
    };
};
$67759673d54fca41$exports.getGridNumericQuickFilterFn = $67759673d54fca41$var$getGridNumericQuickFilterFn;
const $67759673d54fca41$var$getGridNumericOperators = ()=>[
        {
            value: '=',
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    return $67759673d54fca41$var$parseNumericValue(value) === filterItem.value;
                };
            },
            InputComponent: $bbbaea9771a9f69f$exports.GridFilterInputValue,
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: '!=',
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    return $67759673d54fca41$var$parseNumericValue(value) !== filterItem.value;
                };
            },
            InputComponent: $bbbaea9771a9f69f$exports.GridFilterInputValue,
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: '>',
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    if (value == null) return false;
                    return $67759673d54fca41$var$parseNumericValue(value) > filterItem.value;
                };
            },
            InputComponent: $bbbaea9771a9f69f$exports.GridFilterInputValue,
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: '>=',
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    if (value == null) return false;
                    return $67759673d54fca41$var$parseNumericValue(value) >= filterItem.value;
                };
            },
            InputComponent: $bbbaea9771a9f69f$exports.GridFilterInputValue,
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: '<',
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    if (value == null) return false;
                    return $67759673d54fca41$var$parseNumericValue(value) < filterItem.value;
                };
            },
            InputComponent: $bbbaea9771a9f69f$exports.GridFilterInputValue,
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: '<=',
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    if (value == null) return false;
                    return $67759673d54fca41$var$parseNumericValue(value) <= filterItem.value;
                };
            },
            InputComponent: $bbbaea9771a9f69f$exports.GridFilterInputValue,
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: 'isEmpty',
            getApplyFilterFn: ()=>{
                return (value)=>{
                    return value == null;
                };
            },
            requiresFilterValue: false
        },
        {
            value: 'isNotEmpty',
            getApplyFilterFn: ()=>{
                return (value)=>{
                    return value != null;
                };
            },
            requiresFilterValue: false
        },
        {
            value: 'isAnyOf',
            getApplyFilterFn: (filterItem)=>{
                if (!Array.isArray(filterItem.value) || filterItem.value.length === 0) return null;
                return (value)=>{
                    return value != null && filterItem.value.includes(Number(value));
                };
            },
            InputComponent: $4b64102825ff1e40$exports.GridFilterInputMultipleValue,
            InputComponentProps: {
                type: 'number'
            }
        }
    ];
$67759673d54fca41$exports.getGridNumericOperators = $67759673d54fca41$var$getGridNumericOperators;



const $a4694bea3e886bc3$var$GRID_NUMERIC_COL_DEF = $a4694bea3e886bc3$exports.GRID_NUMERIC_COL_DEF = (0, $a4694bea3e886bc3$var$_extends2.default)({}, $8a69393405f257b1$exports.GRID_STRING_COL_DEF, {
    type: 'number',
    align: 'right',
    headerAlign: 'right',
    sortComparator: $c78f90aae54b126e$exports.gridNumberComparator,
    valueParser: (value)=>value === '' ? null : Number(value),
    valueFormatter: (value)=>(0, $fe919794eb3b24e8$exports.isNumber)(value) ? value.toLocaleString() : value || '',
    filterOperators: (0, $67759673d54fca41$exports.getGridNumericOperators)(),
    getApplyQuickFilterFn: $67759673d54fca41$exports.getGridNumericQuickFilterFn
});


Object.keys($a4694bea3e886bc3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $a6506085715c5aff$exports && $a6506085715c5aff$exports[key] === $a4694bea3e886bc3$exports[key]) return;
    Object.defineProperty($a6506085715c5aff$exports, key, {
        enumerable: true,
        get: function() {
            return $a4694bea3e886bc3$exports[key];
        }
    });
});
var $203bce01501b8211$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $203bce01501b8211$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($203bce01501b8211$exports, "__esModule", {
    value: true
});
$203bce01501b8211$exports.GRID_SINGLE_SELECT_COL_DEF = void 0;

var $203bce01501b8211$var$_extends2 = $203bce01501b8211$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $53ef9bd93fd99a94$exports = {};
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $53ef9bd93fd99a94$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $53ef9bd93fd99a94$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($53ef9bd93fd99a94$exports, "__esModule", {
    value: true
});
$53ef9bd93fd99a94$exports.GridEditSingleSelectCell = $53ef9bd93fd99a94$var$GridEditSingleSelectCell;
$53ef9bd93fd99a94$exports.renderEditSingleSelectCell = void 0;

var $53ef9bd93fd99a94$var$_extends2 = $53ef9bd93fd99a94$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $53ef9bd93fd99a94$var$_objectWithoutPropertiesLoose2 = $53ef9bd93fd99a94$require$_interopRequireDefault((parcelRequire("c05no")));

var $53ef9bd93fd99a94$var$_react = $53ef9bd93fd99a94$require$_interopRequireWildcard((parcelRequire("acw62")));
var $53ef9bd93fd99a94$var$React = $53ef9bd93fd99a94$var$_react;

var $53ef9bd93fd99a94$var$_propTypes = $53ef9bd93fd99a94$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $53ef9bd93fd99a94$var$_useEnhancedEffect = $53ef9bd93fd99a94$require$_interopRequireDefault((parcelRequire("jdWO4")));


var $jDpXp = parcelRequire("jDpXp");

var $40d64af47d07faaf$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $40d64af47d07faaf$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($40d64af47d07faaf$exports, "__esModule", {
    value: true
});
$40d64af47d07faaf$exports.getValueFromValueOptions = $40d64af47d07faaf$var$getValueFromValueOptions;
$40d64af47d07faaf$exports.getValueOptions = $40d64af47d07faaf$var$getValueOptions;
$40d64af47d07faaf$exports.isSingleSelectColDef = $40d64af47d07faaf$var$isSingleSelectColDef;

var $40d64af47d07faaf$var$_extends2 = $40d64af47d07faaf$require$_interopRequireDefault((parcelRequire("3p9rK")));
function $40d64af47d07faaf$var$isSingleSelectColDef(colDef) {
    return colDef?.type === 'singleSelect';
}
function $40d64af47d07faaf$var$getValueOptions(column, additionalParams) {
    if (!column) return undefined;
    return typeof column.valueOptions === 'function' ? column.valueOptions((0, $40d64af47d07faaf$var$_extends2.default)({
        field: column.field
    }, additionalParams)) : column.valueOptions;
}
function $40d64af47d07faaf$var$getValueFromValueOptions(value, valueOptions, getOptionValue) {
    if (valueOptions === undefined) return undefined;
    const result = valueOptions.find((option)=>{
        const optionValue = getOptionValue(option);
        return String(optionValue) === String(value);
    });
    return getOptionValue(result);
}



var $bDyDY = parcelRequire("bDyDY");

var $ayMG0 = parcelRequire("ayMG0");
const $53ef9bd93fd99a94$var$_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "tabIndex",
    "className",
    "hasFocus",
    "isValidating",
    "isProcessingProps",
    "error",
    "onValueChange",
    "initialOpen",
    "slotProps"
];
function $53ef9bd93fd99a94$var$isKeyboardEvent(event) {
    return 'key' in event && !!event.key;
}
function $53ef9bd93fd99a94$var$GridEditSingleSelectCell(props) {
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const { id: id, value: valueProp, field: field, row: row, colDef: colDef, hasFocus: hasFocus, error: error, onValueChange: onValueChange, initialOpen: initialOpen = rootProps.editMode === $e139707caeafbfd6$exports.GridEditModes.Cell, slotProps: slotProps } = props, other = (0, $53ef9bd93fd99a94$var$_objectWithoutPropertiesLoose2.default)(props, $53ef9bd93fd99a94$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const ref = $53ef9bd93fd99a94$var$React.useRef(null);
    const inputRef = $53ef9bd93fd99a94$var$React.useRef(null);
    const [open, setOpen] = $53ef9bd93fd99a94$var$React.useState(initialOpen);
    const baseSelectProps = rootProps.slotProps?.baseSelect || {};
    const isSelectNative = baseSelectProps.native ?? false;
    (0, $53ef9bd93fd99a94$var$_useEnhancedEffect.default)(()=>{
        if (hasFocus) inputRef.current?.focus();
    }, [
        hasFocus
    ]);
    if (!(0, $40d64af47d07faaf$exports.isSingleSelectColDef)(colDef)) return null;
    const valueOptions = (0, $40d64af47d07faaf$exports.getValueOptions)(colDef, {
        id: id,
        row: row
    });
    if (!valueOptions) return null;
    const getOptionValue = colDef.getOptionValue;
    const getOptionLabel = colDef.getOptionLabel;
    const handleChange = async (event)=>{
        if (!(0, $40d64af47d07faaf$exports.isSingleSelectColDef)(colDef) || !valueOptions) return;
        setOpen(false);
        const target = event.target;
        // NativeSelect casts the value to a string.
        const formattedTargetValue = (0, $40d64af47d07faaf$exports.getValueFromValueOptions)(target.value, valueOptions, getOptionValue);
        if (onValueChange) await onValueChange(event, formattedTargetValue);
        await apiRef.current.setEditCellValue({
            id: id,
            field: field,
            value: formattedTargetValue
        }, event);
    };
    const handleClose = (event, reason)=>{
        if (rootProps.editMode === $e139707caeafbfd6$exports.GridEditModes.Row) {
            setOpen(false);
            return;
        }
        if (reason === 'backdropClick' || event.key === 'Escape') {
            const params = apiRef.current.getCellParams(id, field);
            apiRef.current.publishEvent('cellEditStop', (0, $53ef9bd93fd99a94$var$_extends2.default)({}, params, {
                reason: event.key === 'Escape' ? $dae8aa7db1c69e5a$exports.GridCellEditStopReasons.escapeKeyDown : $dae8aa7db1c69e5a$exports.GridCellEditStopReasons.cellFocusOut
            }));
        }
    };
    const handleOpen = (event)=>{
        if ($53ef9bd93fd99a94$var$isKeyboardEvent(event) && event.key === 'Enter') return;
        setOpen(true);
    };
    if (!valueOptions || !colDef) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseSelect, (0, $53ef9bd93fd99a94$var$_extends2.default)({
        ref: ref,
        value: valueProp,
        onChange: handleChange,
        open: open,
        onOpen: handleOpen,
        onClose: handleClose,
        error: error,
        native: isSelectNative,
        fullWidth: true,
        slotProps: {
            htmlInput: {
                ref: inputRef
            }
        }
    }, other, slotProps?.root, rootProps.slotProps?.baseSelect, {
        children: valueOptions.map((valueOption)=>{
            const value = getOptionValue(valueOption);
            return /*#__PURE__*/ (0, $53ef9bd93fd99a94$var$_react.createElement)(rootProps.slots.baseSelectOption, (0, $53ef9bd93fd99a94$var$_extends2.default)({}, rootProps.slotProps?.baseSelectOption || {}, {
                native: isSelectNative,
                key: value,
                value: value
            }), getOptionLabel(valueOption));
        })
    }));
}
$53ef9bd93fd99a94$var$GridEditSingleSelectCell.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * GridApi that let you manipulate the grid.
   */ api: $53ef9bd93fd99a94$var$_propTypes.default.object.isRequired,
    /**
   * The mode of the cell.
   */ cellMode: $53ef9bd93fd99a94$var$_propTypes.default.oneOf([
        'edit',
        'view'
    ]).isRequired,
    changeReason: $53ef9bd93fd99a94$var$_propTypes.default.oneOf([
        'debouncedSetEditCellValue',
        'setEditCellValue'
    ]),
    /**
   * The column of the row that the current cell belongs to.
   */ colDef: $53ef9bd93fd99a94$var$_propTypes.default.object.isRequired,
    /**
   * The column field of the cell that triggered the event.
   */ field: $53ef9bd93fd99a94$var$_propTypes.default.string.isRequired,
    /**
   * The cell value formatted with the column valueFormatter.
   */ formattedValue: $53ef9bd93fd99a94$var$_propTypes.default.any,
    /**
   * If true, the cell is the active element.
   */ hasFocus: $53ef9bd93fd99a94$var$_propTypes.default.bool.isRequired,
    /**
   * The grid row id.
   */ id: $53ef9bd93fd99a94$var$_propTypes.default.oneOfType([
        $53ef9bd93fd99a94$var$_propTypes.default.number,
        $53ef9bd93fd99a94$var$_propTypes.default.string
    ]).isRequired,
    /**
   * If true, the select opens by default.
   */ initialOpen: $53ef9bd93fd99a94$var$_propTypes.default.bool,
    /**
   * If true, the cell is editable.
   */ isEditable: $53ef9bd93fd99a94$var$_propTypes.default.bool,
    isProcessingProps: $53ef9bd93fd99a94$var$_propTypes.default.bool,
    isValidating: $53ef9bd93fd99a94$var$_propTypes.default.bool,
    /**
   * Callback called when the value is changed by the user.
   * @param {Event<any>} event The event source of the callback.
   * @param {any} newValue The value that is going to be passed to `apiRef.current.setEditCellValue`.
   * @returns {Promise<void> | void} A promise to be awaited before calling `apiRef.current.setEditCellValue`
   */ onValueChange: $53ef9bd93fd99a94$var$_propTypes.default.func,
    /**
   * The row model of the row that the current cell belongs to.
   */ row: $53ef9bd93fd99a94$var$_propTypes.default.any.isRequired,
    /**
   * The node of the row that the current cell belongs to.
   */ rowNode: $53ef9bd93fd99a94$var$_propTypes.default.object.isRequired,
    /**
   * the tabIndex value.
   */ tabIndex: $53ef9bd93fd99a94$var$_propTypes.default.oneOf([
        -1,
        0
    ]).isRequired,
    /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */ value: $53ef9bd93fd99a94$var$_propTypes.default.any
};
const $53ef9bd93fd99a94$var$renderEditSingleSelectCell = (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)($53ef9bd93fd99a94$var$GridEditSingleSelectCell, (0, $53ef9bd93fd99a94$var$_extends2.default)({}, params));
$53ef9bd93fd99a94$exports.renderEditSingleSelectCell = $53ef9bd93fd99a94$var$renderEditSingleSelectCell;
$53ef9bd93fd99a94$var$renderEditSingleSelectCell.displayName = "renderEditSingleSelectCell";


var $ce72b7e51ff8300c$exports = {};
"use strict";
Object.defineProperty($ce72b7e51ff8300c$exports, "__esModule", {
    value: true
});
$ce72b7e51ff8300c$exports.getGridSingleSelectOperators = void 0;
var $39421fe28cb0a5f3$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $39421fe28cb0a5f3$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $39421fe28cb0a5f3$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($39421fe28cb0a5f3$exports, "__esModule", {
    value: true
});
$39421fe28cb0a5f3$exports.GridFilterInputSingleSelect = $39421fe28cb0a5f3$var$GridFilterInputSingleSelect;

var $39421fe28cb0a5f3$var$_objectWithoutPropertiesLoose2 = $39421fe28cb0a5f3$require$_interopRequireDefault((parcelRequire("c05no")));

var $39421fe28cb0a5f3$var$_extends2 = $39421fe28cb0a5f3$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $39421fe28cb0a5f3$var$_react = $39421fe28cb0a5f3$require$_interopRequireWildcard((parcelRequire("acw62")));
var $39421fe28cb0a5f3$var$React = $39421fe28cb0a5f3$var$_react;

var $39421fe28cb0a5f3$var$_propTypes = $39421fe28cb0a5f3$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $39421fe28cb0a5f3$var$_useId = $39421fe28cb0a5f3$require$_interopRequireDefault((parcelRequire("hwliF")));

var $jDpXp = parcelRequire("jDpXp");


var $ayMG0 = parcelRequire("ayMG0");
const $39421fe28cb0a5f3$var$_excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "tabIndex",
    "isFilterActive",
    "clearButton",
    "headerFilterMenu",
    "slotProps"
];
const $39421fe28cb0a5f3$var$renderSingleSelectOptions = ({ column: column, OptionComponent: OptionComponent, getOptionLabel: getOptionLabel, getOptionValue: getOptionValue, isSelectNative: isSelectNative, baseSelectOptionProps: baseSelectOptionProps })=>{
    const iterableColumnValues = [
        '',
        ...(0, $40d64af47d07faaf$exports.getValueOptions)(column) || []
    ];
    return iterableColumnValues.map((option)=>{
        const value = getOptionValue(option);
        let label = getOptionLabel(option);
        if (label === '') label = "\u2003"; // To force the height of the empty option
        return /*#__PURE__*/ (0, $39421fe28cb0a5f3$var$_react.createElement)(OptionComponent, (0, $39421fe28cb0a5f3$var$_extends2.default)({}, baseSelectOptionProps, {
            native: isSelectNative,
            key: value,
            value: value
        }), label);
    });
};
function $39421fe28cb0a5f3$var$GridFilterInputSingleSelect(props) {
    const { item: item, applyValue: applyValue, type: type, apiRef: apiRef, focusElementRef: focusElementRef, tabIndex: tabIndex, clearButton: clearButton, headerFilterMenu: headerFilterMenu, slotProps: slotProps } = props, other = (0, $39421fe28cb0a5f3$var$_objectWithoutPropertiesLoose2.default)(props, $39421fe28cb0a5f3$var$_excluded);
    const filterValue = item.value ?? '';
    const id = (0, $39421fe28cb0a5f3$var$_useId.default)();
    const labelId = (0, $39421fe28cb0a5f3$var$_useId.default)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const isSelectNative = rootProps.slotProps?.baseSelect?.native ?? false;
    const resolvedColumn = apiRef.current.getColumn(item.field);
    const getOptionValue = resolvedColumn.getOptionValue;
    const getOptionLabel = resolvedColumn.getOptionLabel;
    const currentValueOptions = $39421fe28cb0a5f3$var$React.useMemo(()=>{
        return (0, $40d64af47d07faaf$exports.getValueOptions)(resolvedColumn);
    }, [
        resolvedColumn
    ]);
    const onFilterChange = $39421fe28cb0a5f3$var$React.useCallback((event)=>{
        let value = event.target.value;
        // NativeSelect casts the value to a string.
        value = (0, $40d64af47d07faaf$exports.getValueFromValueOptions)(value, currentValueOptions, getOptionValue);
        applyValue((0, $39421fe28cb0a5f3$var$_extends2.default)({}, item, {
            value: value
        }));
    }, [
        currentValueOptions,
        getOptionValue,
        applyValue,
        item
    ]);
    if (!resolvedColumn || !(0, $40d64af47d07faaf$exports.isSingleSelectColDef)(resolvedColumn)) return null;
    const label = slotProps?.root.label ?? apiRef.current.getLocaleText('filterPanelInputLabel');
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($39421fe28cb0a5f3$var$React.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseSelect, (0, $39421fe28cb0a5f3$var$_extends2.default)({
                fullWidth: true,
                id: id,
                label: label,
                labelId: labelId,
                value: filterValue,
                onChange: onFilterChange,
                slotProps: {
                    htmlInput: (0, $39421fe28cb0a5f3$var$_extends2.default)({
                        tabIndex: tabIndex,
                        ref: focusElementRef,
                        type: type || 'text',
                        placeholder: slotProps?.root.placeholder ?? apiRef.current.getLocaleText('filterPanelInputPlaceholder')
                    }, slotProps?.root.slotProps?.htmlInput)
                },
                native: isSelectNative
            }, rootProps.slotProps?.baseSelect, other, slotProps?.root, {
                children: $39421fe28cb0a5f3$var$renderSingleSelectOptions({
                    column: resolvedColumn,
                    OptionComponent: rootProps.slots.baseSelectOption,
                    getOptionLabel: getOptionLabel,
                    getOptionValue: getOptionValue,
                    isSelectNative: isSelectNative,
                    baseSelectOptionProps: rootProps.slotProps?.baseSelectOption
                })
            })),
            headerFilterMenu,
            clearButton
        ]
    });
}
$39421fe28cb0a5f3$var$GridFilterInputSingleSelect.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    apiRef: $39421fe28cb0a5f3$var$_propTypes.default.shape({
        current: $39421fe28cb0a5f3$var$_propTypes.default.object.isRequired
    }).isRequired,
    applyValue: $39421fe28cb0a5f3$var$_propTypes.default.func.isRequired,
    className: $39421fe28cb0a5f3$var$_propTypes.default.string,
    clearButton: $39421fe28cb0a5f3$var$_propTypes.default.node,
    disabled: $39421fe28cb0a5f3$var$_propTypes.default.bool,
    focusElementRef: $39421fe28cb0a5f3$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $39421fe28cb0a5f3$var$_propTypes.default.func,
        $39421fe28cb0a5f3$var$_propTypes.default.object
    ]),
    headerFilterMenu: $39421fe28cb0a5f3$var$_propTypes.default.node,
    inputRef: $39421fe28cb0a5f3$var$_propTypes.default.oneOfType([
        $39421fe28cb0a5f3$var$_propTypes.default.func,
        $39421fe28cb0a5f3$var$_propTypes.default.shape({
            current: (props, propName)=>{
                if (props[propName] == null) return null;
                if (typeof props[propName] !== 'object' || props[propName].nodeType !== 1) return new Error(`Expected prop '${propName}' to be of type Element`);
                return null;
            }
        })
    ]),
    /**
   * It is `true` if the filter either has a value or an operator with no value
   * required is selected (for example `isEmpty`)
   */ isFilterActive: $39421fe28cb0a5f3$var$_propTypes.default.bool,
    item: $39421fe28cb0a5f3$var$_propTypes.default.shape({
        field: $39421fe28cb0a5f3$var$_propTypes.default.string.isRequired,
        id: $39421fe28cb0a5f3$var$_propTypes.default.oneOfType([
            $39421fe28cb0a5f3$var$_propTypes.default.number,
            $39421fe28cb0a5f3$var$_propTypes.default.string
        ]),
        operator: $39421fe28cb0a5f3$var$_propTypes.default.string.isRequired,
        value: $39421fe28cb0a5f3$var$_propTypes.default.any
    }).isRequired,
    onBlur: $39421fe28cb0a5f3$var$_propTypes.default.func,
    onFocus: $39421fe28cb0a5f3$var$_propTypes.default.func,
    slotProps: $39421fe28cb0a5f3$var$_propTypes.default.object,
    tabIndex: $39421fe28cb0a5f3$var$_propTypes.default.number,
    type: $39421fe28cb0a5f3$var$_propTypes.default.oneOf([
        'singleSelect'
    ])
};


var $077d69ce451095d0$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $077d69ce451095d0$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $077d69ce451095d0$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($077d69ce451095d0$exports, "__esModule", {
    value: true
});
$077d69ce451095d0$exports.GridFilterInputMultipleSingleSelect = $077d69ce451095d0$var$GridFilterInputMultipleSingleSelect;

var $077d69ce451095d0$var$_extends2 = $077d69ce451095d0$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $077d69ce451095d0$var$_objectWithoutPropertiesLoose2 = $077d69ce451095d0$require$_interopRequireDefault((parcelRequire("c05no")));

var $077d69ce451095d0$var$React = $077d69ce451095d0$require$_interopRequireWildcard((parcelRequire("acw62")));

var $077d69ce451095d0$var$_propTypes = $077d69ce451095d0$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $077d69ce451095d0$var$_useId = $077d69ce451095d0$require$_interopRequireDefault((parcelRequire("hwliF")));

var $jDpXp = parcelRequire("jDpXp");


var $ayMG0 = parcelRequire("ayMG0");
const $077d69ce451095d0$var$_excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "slotProps"
];
function $077d69ce451095d0$var$GridFilterInputMultipleSingleSelect(props) {
    const { item: item, applyValue: applyValue, type: type, apiRef: apiRef, focusElementRef: focusElementRef, slotProps: slotProps } = props, other = (0, $077d69ce451095d0$var$_objectWithoutPropertiesLoose2.default)(props, $077d69ce451095d0$var$_excluded);
    const id = (0, $077d69ce451095d0$var$_useId.default)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const resolvedColumn = apiRef.current.getColumn(item.field);
    const getOptionValue = resolvedColumn.getOptionValue;
    const getOptionLabel = resolvedColumn.getOptionLabel;
    const isOptionEqualToValue = $077d69ce451095d0$var$React.useCallback((option, value)=>getOptionValue(option) === getOptionValue(value), [
        getOptionValue
    ]);
    const resolvedValueOptions = $077d69ce451095d0$var$React.useMemo(()=>{
        return (0, $40d64af47d07faaf$exports.getValueOptions)(resolvedColumn) || [];
    }, [
        resolvedColumn
    ]);
    // The value is computed from the item.value and used directly
    // If it was done by a useEffect/useState, the Autocomplete could receive incoherent value and options
    const filteredValues = $077d69ce451095d0$var$React.useMemo(()=>{
        if (!Array.isArray(item.value)) return [];
        return item.value.reduce((acc, value)=>{
            const resolvedValue = resolvedValueOptions.find((v)=>getOptionValue(v) === value);
            if (resolvedValue != null) acc.push(resolvedValue);
            return acc;
        }, []);
    }, [
        getOptionValue,
        item.value,
        resolvedValueOptions
    ]);
    const handleChange = $077d69ce451095d0$var$React.useCallback((event, value)=>{
        applyValue((0, $077d69ce451095d0$var$_extends2.default)({}, item, {
            value: value.map(getOptionValue)
        }));
    }, [
        applyValue,
        item,
        getOptionValue
    ]);
    if (!resolvedColumn || !(0, $40d64af47d07faaf$exports.isSingleSelectColDef)(resolvedColumn)) return null;
    const BaseAutocomplete = rootProps.slots.baseAutocomplete;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(BaseAutocomplete, (0, $077d69ce451095d0$var$_extends2.default)({
        multiple: true,
        options: resolvedValueOptions,
        isOptionEqualToValue: isOptionEqualToValue,
        id: id,
        value: filteredValues,
        onChange: handleChange,
        getOptionLabel: getOptionLabel,
        label: apiRef.current.getLocaleText('filterPanelInputLabel'),
        placeholder: apiRef.current.getLocaleText('filterPanelInputPlaceholder'),
        slotProps: {
            textField: {
                type: type || 'text',
                inputRef: focusElementRef
            }
        }
    }, other, slotProps?.root));
}
$077d69ce451095d0$var$GridFilterInputMultipleSingleSelect.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    apiRef: $077d69ce451095d0$var$_propTypes.default.shape({
        current: $077d69ce451095d0$var$_propTypes.default.object.isRequired
    }).isRequired,
    applyValue: $077d69ce451095d0$var$_propTypes.default.func.isRequired,
    className: $077d69ce451095d0$var$_propTypes.default.string,
    clearButton: $077d69ce451095d0$var$_propTypes.default.node,
    disabled: $077d69ce451095d0$var$_propTypes.default.bool,
    focusElementRef: $077d69ce451095d0$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $077d69ce451095d0$var$_propTypes.default.func,
        $077d69ce451095d0$var$_propTypes.default.object
    ]),
    headerFilterMenu: $077d69ce451095d0$var$_propTypes.default.node,
    inputRef: $077d69ce451095d0$var$_propTypes.default.oneOfType([
        $077d69ce451095d0$var$_propTypes.default.func,
        $077d69ce451095d0$var$_propTypes.default.shape({
            current: (props, propName)=>{
                if (props[propName] == null) return null;
                if (typeof props[propName] !== 'object' || props[propName].nodeType !== 1) return new Error(`Expected prop '${propName}' to be of type Element`);
                return null;
            }
        })
    ]),
    /**
   * It is `true` if the filter either has a value or an operator with no value
   * required is selected (for example `isEmpty`)
   */ isFilterActive: $077d69ce451095d0$var$_propTypes.default.bool,
    item: $077d69ce451095d0$var$_propTypes.default.shape({
        field: $077d69ce451095d0$var$_propTypes.default.string.isRequired,
        id: $077d69ce451095d0$var$_propTypes.default.oneOfType([
            $077d69ce451095d0$var$_propTypes.default.number,
            $077d69ce451095d0$var$_propTypes.default.string
        ]),
        operator: $077d69ce451095d0$var$_propTypes.default.string.isRequired,
        value: $077d69ce451095d0$var$_propTypes.default.any
    }).isRequired,
    onBlur: $077d69ce451095d0$var$_propTypes.default.func,
    onFocus: $077d69ce451095d0$var$_propTypes.default.func,
    slotProps: $077d69ce451095d0$var$_propTypes.default.object,
    tabIndex: $077d69ce451095d0$var$_propTypes.default.number,
    type: $077d69ce451095d0$var$_propTypes.default.oneOf([
        'singleSelect'
    ])
};



const $ce72b7e51ff8300c$var$parseObjectValue = (value)=>{
    if (value == null || !(0, $fe919794eb3b24e8$exports.isObject)(value)) return value;
    return value.value;
};
const $ce72b7e51ff8300c$var$getGridSingleSelectOperators = ()=>[
        {
            value: 'is',
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || filterItem.value === '') return null;
                return (value)=>$ce72b7e51ff8300c$var$parseObjectValue(value) === $ce72b7e51ff8300c$var$parseObjectValue(filterItem.value);
            },
            InputComponent: $39421fe28cb0a5f3$exports.GridFilterInputSingleSelect
        },
        {
            value: 'not',
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || filterItem.value === '') return null;
                return (value)=>$ce72b7e51ff8300c$var$parseObjectValue(value) !== $ce72b7e51ff8300c$var$parseObjectValue(filterItem.value);
            },
            InputComponent: $39421fe28cb0a5f3$exports.GridFilterInputSingleSelect
        },
        {
            value: 'isAnyOf',
            getApplyFilterFn: (filterItem)=>{
                if (!Array.isArray(filterItem.value) || filterItem.value.length === 0) return null;
                const filterItemValues = filterItem.value.map($ce72b7e51ff8300c$var$parseObjectValue);
                return (value)=>filterItemValues.includes($ce72b7e51ff8300c$var$parseObjectValue(value));
            },
            InputComponent: $077d69ce451095d0$exports.GridFilterInputMultipleSingleSelect
        }
    ];
$ce72b7e51ff8300c$exports.getGridSingleSelectOperators = $ce72b7e51ff8300c$var$getGridSingleSelectOperators;





const $203bce01501b8211$var$isArrayOfObjects = (options)=>{
    return typeof options[0] === 'object';
};
const $203bce01501b8211$var$defaultGetOptionValue = (value)=>{
    return (0, $fe919794eb3b24e8$exports.isObject)(value) ? value.value : value;
};
const $203bce01501b8211$var$defaultGetOptionLabel = (value)=>{
    return (0, $fe919794eb3b24e8$exports.isObject)(value) ? value.label : String(value);
};
const $203bce01501b8211$var$GRID_SINGLE_SELECT_COL_DEF = $203bce01501b8211$exports.GRID_SINGLE_SELECT_COL_DEF = (0, $203bce01501b8211$var$_extends2.default)({}, $8a69393405f257b1$exports.GRID_STRING_COL_DEF, {
    type: 'singleSelect',
    getOptionLabel: $203bce01501b8211$var$defaultGetOptionLabel,
    getOptionValue: $203bce01501b8211$var$defaultGetOptionValue,
    valueFormatter (value, row, colDef, apiRef) {
        const rowId = (0, $0d26ce0880758663$exports.gridRowIdSelector)(apiRef, row);
        if (!(0, $40d64af47d07faaf$exports.isSingleSelectColDef)(colDef)) return '';
        const valueOptions = (0, $40d64af47d07faaf$exports.getValueOptions)(colDef, {
            id: rowId,
            row: row
        });
        if (value == null) return '';
        if (!valueOptions) return value;
        if (!$203bce01501b8211$var$isArrayOfObjects(valueOptions)) return colDef.getOptionLabel(value);
        const valueOption = valueOptions.find((option)=>colDef.getOptionValue(option) === value);
        return valueOption ? colDef.getOptionLabel(valueOption) : '';
    },
    renderEditCell: $53ef9bd93fd99a94$exports.renderEditSingleSelectCell,
    filterOperators: (0, $ce72b7e51ff8300c$exports.getGridSingleSelectOperators)(),
    // @ts-ignore
    pastedValueParser: (value, row, column)=>{
        const colDef = column;
        const valueOptions = (0, $40d64af47d07faaf$exports.getValueOptions)(colDef) || [];
        const getOptionValue = colDef.getOptionValue;
        const valueOption = valueOptions.find((option)=>{
            if (getOptionValue(option) === value) return true;
            return false;
        });
        if (valueOption) return value;
        // do not paste the value if it is not in the valueOptions
        return undefined;
    }
});


Object.keys($203bce01501b8211$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $a6506085715c5aff$exports && $a6506085715c5aff$exports[key] === $203bce01501b8211$exports[key]) return;
    Object.defineProperty($a6506085715c5aff$exports, key, {
        enumerable: true,
        get: function() {
            return $203bce01501b8211$exports[key];
        }
    });
});

Object.keys($8a69393405f257b1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $a6506085715c5aff$exports && $a6506085715c5aff$exports[key] === $8a69393405f257b1$exports[key]) return;
    Object.defineProperty($a6506085715c5aff$exports, key, {
        enumerable: true,
        get: function() {
            return $8a69393405f257b1$exports[key];
        }
    });
});

Object.keys($e84ace6ba51eccb1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $a6506085715c5aff$exports && $a6506085715c5aff$exports[key] === $e84ace6ba51eccb1$exports[key]) return;
    Object.defineProperty($a6506085715c5aff$exports, key, {
        enumerable: true,
        get: function() {
            return $e84ace6ba51eccb1$exports[key];
        }
    });
});

Object.keys($42483ac831686fc7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $a6506085715c5aff$exports && $a6506085715c5aff$exports[key] === $42483ac831686fc7$exports[key]) return;
    Object.defineProperty($a6506085715c5aff$exports, key, {
        enumerable: true,
        get: function() {
            return $42483ac831686fc7$exports[key];
        }
    });
});

Object.keys($67759673d54fca41$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $a6506085715c5aff$exports && $a6506085715c5aff$exports[key] === $67759673d54fca41$exports[key]) return;
    Object.defineProperty($a6506085715c5aff$exports, key, {
        enumerable: true,
        get: function() {
            return $67759673d54fca41$exports[key];
        }
    });
});

Object.keys($ce72b7e51ff8300c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $a6506085715c5aff$exports && $a6506085715c5aff$exports[key] === $ce72b7e51ff8300c$exports[key]) return;
    Object.defineProperty($a6506085715c5aff$exports, key, {
        enumerable: true,
        get: function() {
            return $ce72b7e51ff8300c$exports[key];
        }
    });
});

Object.keys($ced5632839836707$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $a6506085715c5aff$exports && $a6506085715c5aff$exports[key] === $ced5632839836707$exports[key]) return;
    Object.defineProperty($a6506085715c5aff$exports, key, {
        enumerable: true,
        get: function() {
            return $ced5632839836707$exports[key];
        }
    });
});
var $3f7b10d3cc3b3307$exports = {};
"use strict";
Object.defineProperty($3f7b10d3cc3b3307$exports, "__esModule", {
    value: true
});
$3f7b10d3cc3b3307$exports.getGridDefaultColumnTypes = $3f7b10d3cc3b3307$exports.DEFAULT_GRID_COL_TYPE_KEY = void 0;






const $3f7b10d3cc3b3307$var$DEFAULT_GRID_COL_TYPE_KEY = $3f7b10d3cc3b3307$exports.DEFAULT_GRID_COL_TYPE_KEY = 'string';
const $3f7b10d3cc3b3307$var$getGridDefaultColumnTypes = ()=>{
    const nativeColumnTypes = {
        string: $8a69393405f257b1$exports.GRID_STRING_COL_DEF,
        number: $a4694bea3e886bc3$exports.GRID_NUMERIC_COL_DEF,
        date: $7ac2b9e608be0423$exports.GRID_DATE_COL_DEF,
        dateTime: $7ac2b9e608be0423$exports.GRID_DATETIME_COL_DEF,
        boolean: $daf44030e7d36790$exports.GRID_BOOLEAN_COL_DEF,
        singleSelect: $203bce01501b8211$exports.GRID_SINGLE_SELECT_COL_DEF,
        [$63c3e445c9bf0af1$exports.GRID_ACTIONS_COLUMN_TYPE]: $63c3e445c9bf0af1$exports.GRID_ACTIONS_COL_DEF,
        custom: $8a69393405f257b1$exports.GRID_STRING_COL_DEF
    };
    return nativeColumnTypes;
};
$3f7b10d3cc3b3307$exports.getGridDefaultColumnTypes = $3f7b10d3cc3b3307$var$getGridDefaultColumnTypes;


Object.keys($3f7b10d3cc3b3307$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $a6506085715c5aff$exports && $a6506085715c5aff$exports[key] === $3f7b10d3cc3b3307$exports[key]) return;
    Object.defineProperty($a6506085715c5aff$exports, key, {
        enumerable: true,
        get: function() {
            return $3f7b10d3cc3b3307$exports[key];
        }
    });
});





var $48c71b00043b47b4$exports = {};
"use strict";
Object.defineProperty($48c71b00043b47b4$exports, "__esModule", {
    value: true
});
$48c71b00043b47b4$exports.gridHeaderFilteringStateSelector = $48c71b00043b47b4$exports.gridHeaderFilteringMenuSelector = $48c71b00043b47b4$exports.gridHeaderFilteringEnabledSelector = $48c71b00043b47b4$exports.gridHeaderFilteringEditFieldSelector = void 0;

const $48c71b00043b47b4$var$gridHeaderFilteringStateSelector = $48c71b00043b47b4$exports.gridHeaderFilteringStateSelector = (0, $8eef5f2af445e503$exports.createRootSelector)((state)=>state.headerFiltering);
const $48c71b00043b47b4$var$gridHeaderFilteringEnabledSelector = $48c71b00043b47b4$exports.gridHeaderFilteringEnabledSelector = (0, $8eef5f2af445e503$exports.createSelector)($48c71b00043b47b4$var$gridHeaderFilteringStateSelector, // No initialization in MIT, so we need to default to false to be used by `getTotalHeaderHeight`
(headerFilteringState)=>headerFilteringState?.enabled ?? false);
const $48c71b00043b47b4$var$gridHeaderFilteringEditFieldSelector = $48c71b00043b47b4$exports.gridHeaderFilteringEditFieldSelector = (0, $8eef5f2af445e503$exports.createSelector)($48c71b00043b47b4$var$gridHeaderFilteringStateSelector, (headerFilteringState)=>headerFilteringState.editing);
const $48c71b00043b47b4$var$gridHeaderFilteringMenuSelector = $48c71b00043b47b4$exports.gridHeaderFilteringMenuSelector = (0, $8eef5f2af445e503$exports.createSelector)($48c71b00043b47b4$var$gridHeaderFilteringStateSelector, (headerFilteringState)=>headerFilteringState.menuOpen);


var $cf21d895912d975b$exports = {};
"use strict";
Object.defineProperty($cf21d895912d975b$exports, "__esModule", {
    value: true
});
$cf21d895912d975b$exports.gridColumnGroupsUnwrappedModelSelector = $cf21d895912d975b$exports.gridColumnGroupsLookupSelector = $cf21d895912d975b$exports.gridColumnGroupsHeaderStructureSelector = $cf21d895912d975b$exports.gridColumnGroupsHeaderMaxDepthSelector = $cf21d895912d975b$exports.gridColumnGroupingSelector = void 0;

/**
 * @category ColumnGrouping
 * @ignore - do not document.
 */ const $cf21d895912d975b$var$gridColumnGroupingSelector = $cf21d895912d975b$exports.gridColumnGroupingSelector = (0, $8eef5f2af445e503$exports.createRootSelector)((state)=>state.columnGrouping);
const $cf21d895912d975b$var$gridColumnGroupsUnwrappedModelSelector = $cf21d895912d975b$exports.gridColumnGroupsUnwrappedModelSelector = (0, $8eef5f2af445e503$exports.createSelectorMemoized)($cf21d895912d975b$var$gridColumnGroupingSelector, (columnGrouping)=>columnGrouping?.unwrappedGroupingModel ?? {});
const $cf21d895912d975b$var$gridColumnGroupsLookupSelector = $cf21d895912d975b$exports.gridColumnGroupsLookupSelector = (0, $8eef5f2af445e503$exports.createSelectorMemoized)($cf21d895912d975b$var$gridColumnGroupingSelector, (columnGrouping)=>columnGrouping?.lookup ?? {});
const $cf21d895912d975b$var$gridColumnGroupsHeaderStructureSelector = $cf21d895912d975b$exports.gridColumnGroupsHeaderStructureSelector = (0, $8eef5f2af445e503$exports.createSelectorMemoized)($cf21d895912d975b$var$gridColumnGroupingSelector, (columnGrouping)=>columnGrouping?.headerStructure ?? []);
const $cf21d895912d975b$var$gridColumnGroupsHeaderMaxDepthSelector = $cf21d895912d975b$exports.gridColumnGroupsHeaderMaxDepthSelector = (0, $8eef5f2af445e503$exports.createSelector)($cf21d895912d975b$var$gridColumnGroupingSelector, (columnGrouping)=>columnGrouping?.maxDepth ?? 0);


const $d1cd1e3fd8558ad5$var$COLUMNS_DIMENSION_PROPERTIES = $d1cd1e3fd8558ad5$exports.COLUMNS_DIMENSION_PROPERTIES = [
    'maxWidth',
    'minWidth',
    'width',
    'flex'
];
const $d1cd1e3fd8558ad5$var$COLUMN_TYPES = (0, $a6506085715c5aff$exports.getGridDefaultColumnTypes)();
/**
 * Computes width for flex columns.
 * Based on CSS Flexbox specification:
 * https://drafts.csswg.org/css-flexbox-1/#resolve-flexible-lengths
 */ function $d1cd1e3fd8558ad5$var$computeFlexColumnsWidth({ initialFreeSpace: initialFreeSpace, totalFlexUnits: totalFlexUnits, flexColumns: flexColumns }) {
    const uniqueFlexColumns = new Set(flexColumns.map((col)=>col.field));
    const flexColumnsLookup = {
        all: {},
        frozenFields: [],
        freeze: (field)=>{
            const value = flexColumnsLookup.all[field];
            if (value && value.frozen !== true) {
                flexColumnsLookup.all[field].frozen = true;
                flexColumnsLookup.frozenFields.push(field);
            }
        }
    };
    // Step 5 of https://drafts.csswg.org/css-flexbox-1/#resolve-flexible-lengths
    function loopOverFlexItems() {
        // 5a: If all the flex items on the line are frozen, free space has been distributed.
        if (flexColumnsLookup.frozenFields.length === uniqueFlexColumns.size) return;
        const violationsLookup = {
            min: {},
            max: {}
        };
        let remainingFreeSpace = initialFreeSpace;
        let flexUnits = totalFlexUnits;
        let totalViolation = 0;
        // 5b: Calculate the remaining free space
        flexColumnsLookup.frozenFields.forEach((field)=>{
            remainingFreeSpace -= flexColumnsLookup.all[field].computedWidth;
            flexUnits -= flexColumnsLookup.all[field].flex;
        });
        for(let i = 0; i < flexColumns.length; i += 1){
            const column = flexColumns[i];
            if (flexColumnsLookup.all[column.field] && flexColumnsLookup.all[column.field].frozen === true) continue;
            // 5c: Distribute remaining free space proportional to the flex factors
            const widthPerFlexUnit = remainingFreeSpace / flexUnits;
            let computedWidth = widthPerFlexUnit * column.flex;
            // 5d: Fix min/max violations
            if (computedWidth < column.minWidth) {
                totalViolation += column.minWidth - computedWidth;
                computedWidth = column.minWidth;
                violationsLookup.min[column.field] = true;
            } else if (computedWidth > column.maxWidth) {
                totalViolation += column.maxWidth - computedWidth;
                computedWidth = column.maxWidth;
                violationsLookup.max[column.field] = true;
            }
            flexColumnsLookup.all[column.field] = {
                frozen: false,
                computedWidth: computedWidth,
                flex: column.flex
            };
        }
        // 5e: Freeze over-flexed items
        if (totalViolation < 0) // Freeze all the items with max violations
        Object.keys(violationsLookup.max).forEach((field)=>{
            flexColumnsLookup.freeze(field);
        });
        else if (totalViolation > 0) // Freeze all the items with min violations
        Object.keys(violationsLookup.min).forEach((field)=>{
            flexColumnsLookup.freeze(field);
        });
        else // Freeze all items
        flexColumns.forEach(({ field: field })=>{
            flexColumnsLookup.freeze(field);
        });
        // 5f: Return to the start of this loop
        loopOverFlexItems();
    }
    loopOverFlexItems();
    return flexColumnsLookup.all;
}
/**
 * Compute the `computedWidth` (ie: the width the column should have during rendering) based on the `width` / `flex` / `minWidth` / `maxWidth` properties of `GridColDef`.
 * The columns already have been merged with there `type` default values for `minWidth`, `maxWidth` and `width`, thus the `!` for those properties below.
 * TODO: Unit test this function in depth and only keep basic cases for the whole grid testing.
 * TODO: Improve the `GridColDef` typing to reflect the fact that `minWidth` / `maxWidth` and `width` can't be null after the merge with the `type` default values.
 */ const $d1cd1e3fd8558ad5$var$hydrateColumnsWidth = (rawState, dimensions)=>{
    const columnsLookup = {};
    let totalFlexUnits = 0;
    let widthAllocatedBeforeFlex = 0;
    const flexColumns = [];
    // For the non-flex columns, compute their width
    // For the flex columns, compute their minimum width and how much width must be allocated during the flex allocation
    rawState.orderedFields.forEach((columnField)=>{
        let column = rawState.lookup[columnField];
        let computedWidth = 0;
        let isFlex = false;
        if (rawState.columnVisibilityModel[columnField] !== false) {
            if (column.flex && column.flex > 0) {
                totalFlexUnits += column.flex;
                isFlex = true;
            } else computedWidth = (0, $fe919794eb3b24e8$exports.clamp)(column.width || $a6506085715c5aff$exports.GRID_STRING_COL_DEF.width, column.minWidth || $a6506085715c5aff$exports.GRID_STRING_COL_DEF.minWidth, column.maxWidth || $a6506085715c5aff$exports.GRID_STRING_COL_DEF.maxWidth);
            widthAllocatedBeforeFlex += computedWidth;
        }
        if (column.computedWidth !== computedWidth) column = (0, $d1cd1e3fd8558ad5$var$_extends2.default)({}, column, {
            computedWidth: computedWidth
        });
        if (isFlex) flexColumns.push(column);
        columnsLookup[columnField] = column;
    });
    const availableWidth = dimensions === undefined ? 0 : dimensions.viewportOuterSize.width - (dimensions.hasScrollY ? dimensions.scrollbarSize : 0);
    const initialFreeSpace = Math.max(availableWidth - widthAllocatedBeforeFlex, 0);
    // Allocate the remaining space to the flex columns
    if (totalFlexUnits > 0 && availableWidth > 0) {
        const computedColumnWidths = $d1cd1e3fd8558ad5$var$computeFlexColumnsWidth({
            initialFreeSpace: initialFreeSpace,
            totalFlexUnits: totalFlexUnits,
            flexColumns: flexColumns
        });
        Object.keys(computedColumnWidths).forEach((field)=>{
            columnsLookup[field] = (0, $d1cd1e3fd8558ad5$var$_extends2.default)({}, columnsLookup[field], {
                computedWidth: computedColumnWidths[field].computedWidth
            });
        });
    }
    return (0, $d1cd1e3fd8558ad5$var$_extends2.default)({}, rawState, {
        lookup: columnsLookup
    });
};
/**
 * Apply the order and the dimensions of the initial state.
 * The columns not registered in `orderedFields` will be placed after the imported columns.
 */ $d1cd1e3fd8558ad5$exports.hydrateColumnsWidth = $d1cd1e3fd8558ad5$var$hydrateColumnsWidth;
const $d1cd1e3fd8558ad5$var$applyInitialState = (columnsState, initialState)=>{
    if (!initialState) return columnsState;
    const { orderedFields: orderedFields = [], dimensions: dimensions = {} } = initialState;
    const columnsWithUpdatedDimensions = Object.keys(dimensions);
    if (columnsWithUpdatedDimensions.length === 0 && orderedFields.length === 0) return columnsState;
    const orderedFieldsLookup = {};
    const cleanOrderedFields = [];
    for(let i = 0; i < orderedFields.length; i += 1){
        const field = orderedFields[i];
        // Ignores the fields in the initialState that matches no field on the current column state
        if (columnsState.lookup[field]) {
            orderedFieldsLookup[field] = true;
            cleanOrderedFields.push(field);
        }
    }
    const newOrderedFields = cleanOrderedFields.length === 0 ? columnsState.orderedFields : [
        ...cleanOrderedFields,
        ...columnsState.orderedFields.filter((field)=>!orderedFieldsLookup[field])
    ];
    const newColumnLookup = (0, $d1cd1e3fd8558ad5$var$_extends2.default)({}, columnsState.lookup);
    for(let i = 0; i < columnsWithUpdatedDimensions.length; i += 1){
        const field = columnsWithUpdatedDimensions[i];
        const newColDef = (0, $d1cd1e3fd8558ad5$var$_extends2.default)({}, newColumnLookup[field], {
            hasBeenResized: true
        });
        Object.entries(dimensions[field]).forEach(([key, value])=>{
            newColDef[key] = value === -1 ? Infinity : value;
        });
        newColumnLookup[field] = newColDef;
    }
    const newColumnsState = (0, $d1cd1e3fd8558ad5$var$_extends2.default)({}, columnsState, {
        orderedFields: newOrderedFields,
        lookup: newColumnLookup
    });
    return newColumnsState;
};
$d1cd1e3fd8558ad5$exports.applyInitialState = $d1cd1e3fd8558ad5$var$applyInitialState;
function $d1cd1e3fd8558ad5$var$getDefaultColTypeDef(type) {
    let colDef = $d1cd1e3fd8558ad5$var$COLUMN_TYPES[$a6506085715c5aff$exports.DEFAULT_GRID_COL_TYPE_KEY];
    if (type && $d1cd1e3fd8558ad5$var$COLUMN_TYPES[type]) colDef = $d1cd1e3fd8558ad5$var$COLUMN_TYPES[type];
    return colDef;
}
const $d1cd1e3fd8558ad5$var$createColumnsState = ({ apiRef: apiRef, columnsToUpsert: columnsToUpsert, initialState: initialState, columnVisibilityModel: columnVisibilityModel = (0, $e732684465924d20$exports.gridColumnVisibilityModelSelector)(apiRef), keepOnlyColumnsToUpsert: keepOnlyColumnsToUpsert = false, updateInitialVisibilityModel: updateInitialVisibilityModel = false })=>{
    const isInsideStateInitializer = !apiRef.current.state.columns;
    let columnsState;
    if (isInsideStateInitializer) columnsState = {
        orderedFields: [],
        lookup: {},
        columnVisibilityModel: columnVisibilityModel,
        initialColumnVisibilityModel: columnVisibilityModel
    };
    else {
        const currentState = (0, $e732684465924d20$exports.gridColumnsStateSelector)(apiRef);
        columnsState = {
            orderedFields: keepOnlyColumnsToUpsert ? [] : [
                ...currentState.orderedFields
            ],
            lookup: (0, $d1cd1e3fd8558ad5$var$_extends2.default)({}, currentState.lookup),
            columnVisibilityModel: // Will be cleaned later if keepOnlyColumnsToUpsert=true
            columnVisibilityModel,
            initialColumnVisibilityModel: updateInitialVisibilityModel ? columnVisibilityModel : currentState.initialColumnVisibilityModel
        };
    }
    const columnsToKeep = {};
    if (keepOnlyColumnsToUpsert && !isInsideStateInitializer) {
        for(const key in columnsState.lookup)if (Object.prototype.hasOwnProperty.call(columnsState.lookup, key)) columnsToKeep[key] = false;
    }
    const columnsToUpsertLookup = {};
    columnsToUpsert.forEach((newColumn)=>{
        const { field: field } = newColumn;
        columnsToUpsertLookup[field] = true;
        columnsToKeep[field] = true;
        let existingState = columnsState.lookup[field];
        if (existingState == null) {
            existingState = (0, $d1cd1e3fd8558ad5$var$_extends2.default)({}, $d1cd1e3fd8558ad5$var$getDefaultColTypeDef(newColumn.type), {
                field: field,
                hasBeenResized: false
            });
            columnsState.orderedFields.push(field);
        } else if (keepOnlyColumnsToUpsert) columnsState.orderedFields.push(field);
        // If the column type has changed - merge the existing state with the default column type definition
        if (existingState && existingState.type !== newColumn.type) existingState = (0, $d1cd1e3fd8558ad5$var$_extends2.default)({}, $d1cd1e3fd8558ad5$var$getDefaultColTypeDef(newColumn.type), {
            field: field
        });
        let hasBeenResized = existingState.hasBeenResized;
        $d1cd1e3fd8558ad5$var$COLUMNS_DIMENSION_PROPERTIES.forEach((key)=>{
            if (newColumn[key] !== undefined) {
                hasBeenResized = true;
                if (newColumn[key] === -1) newColumn[key] = Infinity;
            }
        });
        columnsState.lookup[field] = (0, $d1cd1e3fd8558ad5$var$_resolveProps.default)(existingState, (0, $d1cd1e3fd8558ad5$var$_extends2.default)({}, $d1cd1e3fd8558ad5$var$getDefaultColTypeDef(newColumn.type), newColumn, {
            hasBeenResized: hasBeenResized
        }));
    });
    if (keepOnlyColumnsToUpsert && !isInsideStateInitializer) Object.keys(columnsState.lookup).forEach((field)=>{
        if (!columnsToKeep[field]) delete columnsState.lookup[field];
    });
    const columnsStateWithPreProcessing = apiRef.current.unstable_applyPipeProcessors('hydrateColumns', columnsState);
    const columnsStateWithPortableColumns = $d1cd1e3fd8558ad5$var$applyInitialState(columnsStateWithPreProcessing, initialState);
    return $d1cd1e3fd8558ad5$var$hydrateColumnsWidth(columnsStateWithPortableColumns, apiRef.current.getRootDimensions?.() ?? undefined);
};
$d1cd1e3fd8558ad5$exports.createColumnsState = $d1cd1e3fd8558ad5$var$createColumnsState;
function $d1cd1e3fd8558ad5$var$getFirstNonSpannedColumnToRender({ firstColumnToRender: firstColumnToRender, apiRef: apiRef, firstRowToRender: firstRowToRender, lastRowToRender: lastRowToRender, visibleRows: visibleRows }) {
    let firstNonSpannedColumnToRender = firstColumnToRender;
    let foundStableColumn = false;
    // Keep checking columns until we find one that's not spanned in any visible row
    while(!foundStableColumn && firstNonSpannedColumnToRender >= 0){
        foundStableColumn = true;
        for(let i = firstRowToRender; i < lastRowToRender; i += 1){
            const row = visibleRows[i];
            if (row) {
                const rowId = visibleRows[i].id;
                const cellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, firstNonSpannedColumnToRender);
                if (cellColSpanInfo && cellColSpanInfo.spannedByColSpan && cellColSpanInfo.leftVisibleCellIndex < firstNonSpannedColumnToRender) {
                    firstNonSpannedColumnToRender = cellColSpanInfo.leftVisibleCellIndex;
                    foundStableColumn = false;
                    break; // Check the new column index against the visible rows, because it might be spanned
                }
            }
        }
    }
    return firstNonSpannedColumnToRender;
}
function $d1cd1e3fd8558ad5$var$getTotalHeaderHeight(apiRef, props) {
    if (props.listView) return 0;
    const densityFactor = (0, $b611aad21a5b677d$exports.gridDensityFactorSelector)(apiRef);
    const maxDepth = (0, $cf21d895912d975b$exports.gridColumnGroupsHeaderMaxDepthSelector)(apiRef);
    const isHeaderFilteringEnabled = (0, $48c71b00043b47b4$exports.gridHeaderFilteringEnabledSelector)(apiRef);
    const columnHeadersHeight = Math.floor(props.columnHeaderHeight * densityFactor);
    const columnGroupHeadersHeight = Math.floor((props.columnGroupHeaderHeight ?? props.columnHeaderHeight) * densityFactor);
    const filterHeadersHeight = isHeaderFilteringEnabled ? Math.floor((props.headerFilterHeight ?? props.columnHeaderHeight) * densityFactor) : 0;
    return columnHeadersHeight + columnGroupHeadersHeight * maxDepth + filterHeadersHeight;
}





var $ayMG0 = parcelRequire("ayMG0");
const $3b92023a13ae6811$var$CLIFF = 1;
const $3b92023a13ae6811$var$SLOP = 1.5;
const $3b92023a13ae6811$var$useUtilityClasses = (ownerState)=>{
    const { scrollDirection: scrollDirection, classes: classes } = ownerState;
    const slots = {
        root: [
            'scrollArea',
            `scrollArea--${scrollDirection}`
        ]
    };
    return (0, $3b92023a13ae6811$var$_composeClasses.default)(slots, $553c2bbb14fa5500$exports.getDataGridUtilityClass, classes);
};
const $3b92023a13ae6811$var$GridScrollAreaRawRoot = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'ScrollArea',
    overridesResolver: (props, styles)=>[
            {
                [`&.${$553c2bbb14fa5500$exports.gridClasses['scrollArea--left']}`]: styles['scrollArea--left']
            },
            {
                [`&.${$553c2bbb14fa5500$exports.gridClasses['scrollArea--right']}`]: styles['scrollArea--right']
            },
            {
                [`&.${$553c2bbb14fa5500$exports.gridClasses['scrollArea--up']}`]: styles['scrollArea--up']
            },
            {
                [`&.${$553c2bbb14fa5500$exports.gridClasses['scrollArea--down']}`]: styles['scrollArea--down']
            },
            styles.scrollArea
        ]
})(()=>({
        position: 'absolute',
        zIndex: 101,
        // Horizontal scroll areas
        [`&.${$553c2bbb14fa5500$exports.gridClasses['scrollArea--left']}`]: {
            top: 0,
            left: 0,
            width: 20,
            bottom: 0
        },
        [`&.${$553c2bbb14fa5500$exports.gridClasses['scrollArea--right']}`]: {
            top: 0,
            right: 0,
            width: 20,
            bottom: 0
        },
        // Vertical scroll areas
        [`&.${$553c2bbb14fa5500$exports.gridClasses['scrollArea--up']}`]: {
            top: 0,
            left: 0,
            right: 0,
            height: 20
        },
        [`&.${$553c2bbb14fa5500$exports.gridClasses['scrollArea--down']}`]: {
            bottom: 0,
            left: 0,
            right: 0,
            height: 20
        }
    }));
const $3b92023a13ae6811$var$offsetSelector = (0, $8eef5f2af445e503$exports.createSelector)($46349fe7fabb2b4d$exports.gridDimensionsSelector, (dimensions, direction)=>{
    if (direction === 'left') return dimensions.leftPinnedWidth;
    if (direction === 'right') return dimensions.rightPinnedWidth + (dimensions.hasScrollX ? dimensions.scrollbarSize : 0);
    // For vertical scroll areas, we don't need horizontal offset
    return 0;
});
function $3b92023a13ae6811$var$GridScrollAreaWrapper(props) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const [dragDirection, setDragDirection] = $3b92023a13ae6811$var$React.useState('none');
    // Listen for both column and row drag events
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'columnHeaderDragStart', ()=>setDragDirection('horizontal'));
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'columnHeaderDragEnd', ()=>setDragDirection('none'));
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'rowDragStart', ()=>setDragDirection('vertical'));
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'rowDragEnd', ()=>setDragDirection('none'));
    if (dragDirection === 'none') return null;
    if (dragDirection === 'horizontal') return /*#__PURE__*/ (0, $ayMG0.jsx)($3b92023a13ae6811$var$GridHorizontalScrollAreaContent, (0, $3b92023a13ae6811$var$_extends2.default)({}, props));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3b92023a13ae6811$var$GridVerticalScrollAreaContent, (0, $3b92023a13ae6811$var$_extends2.default)({}, props));
}
function $3b92023a13ae6811$var$GridHorizontalScrollAreaContent(props) {
    const { scrollDirection: scrollDirection, scrollPosition: scrollPosition } = props;
    const rootRef = $3b92023a13ae6811$var$React.useRef(null);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const timeout = (0, $3ede1456da2c476e$exports.useTimeout)();
    const densityFactor = (0, $5sOMZ.useGridSelector)(apiRef, $b611aad21a5b677d$exports.gridDensityFactorSelector);
    const columnsTotalWidth = (0, $5sOMZ.useGridSelector)(apiRef, $46349fe7fabb2b4d$exports.gridColumnsTotalWidthSelector);
    const sideOffset = (0, $5sOMZ.useGridSelector)(apiRef, $3b92023a13ae6811$var$offsetSelector, scrollDirection);
    const getCanScrollMore = ()=>{
        const dimensions = (0, $46349fe7fabb2b4d$exports.gridDimensionsSelector)(apiRef);
        if (scrollDirection === 'left') // Only render if the user has not reached yet the start of the list
        return scrollPosition.current.left > 0;
        if (scrollDirection === 'right') {
            // Only render if the user has not reached yet the end of the list
            const maxScrollLeft = columnsTotalWidth - dimensions.viewportInnerSize.width;
            return scrollPosition.current.left < maxScrollLeft;
        }
        return false;
    };
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const totalHeaderHeight = (0, $d1cd1e3fd8558ad5$exports.getTotalHeaderHeight)(apiRef, rootProps);
    const headerHeight = Math.floor(rootProps.columnHeaderHeight * densityFactor);
    const style = (0, $3b92023a13ae6811$var$_extends2.default)({
        height: headerHeight,
        top: totalHeaderHeight - headerHeight
    }, scrollDirection === 'left' ? {
        left: sideOffset
    } : {}, scrollDirection === 'right' ? {
        right: sideOffset
    } : {});
    const handleDragOver = (0, $3b92023a13ae6811$var$_useEventCallback.default)((event)=>{
        let offset;
        // Prevents showing the forbidden cursor
        event.preventDefault();
        if (scrollDirection === 'left') offset = event.clientX - rootRef.current.getBoundingClientRect().right;
        else if (scrollDirection === 'right') offset = Math.max(1, event.clientX - rootRef.current.getBoundingClientRect().left);
        else throw new Error('MUI X: Wrong drag direction');
        offset = (offset - $3b92023a13ae6811$var$CLIFF) * $3b92023a13ae6811$var$SLOP + $3b92023a13ae6811$var$CLIFF;
        // Avoid freeze and inertia.
        timeout.start(0, ()=>{
            apiRef.current.scroll({
                left: scrollPosition.current.left + offset,
                top: scrollPosition.current.top
            });
        });
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3b92023a13ae6811$var$GridScrollAreaContent, (0, $3b92023a13ae6811$var$_extends2.default)({}, props, {
        ref: rootRef,
        getCanScrollMore: getCanScrollMore,
        style: style,
        handleDragOver: handleDragOver
    }));
}
function $3b92023a13ae6811$var$GridVerticalScrollAreaContent(props) {
    const { scrollDirection: scrollDirection, scrollPosition: scrollPosition } = props;
    const rootRef = $3b92023a13ae6811$var$React.useRef(null);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const timeout = (0, $3ede1456da2c476e$exports.useTimeout)();
    const rowsMeta = (0, $5sOMZ.useGridSelector)(apiRef, $82a5a13765976ef2$exports.gridRowsMetaSelector);
    const getCanScrollMore = ()=>{
        const dimensions = (0, $46349fe7fabb2b4d$exports.gridDimensionsSelector)(apiRef);
        if (scrollDirection === 'up') // Only render if the user has not reached yet the top of the list
        return scrollPosition.current.top > 0;
        if (scrollDirection === 'down') {
            // Only render if the user has not reached yet the bottom of the list
            const totalRowsHeight = rowsMeta.currentPageTotalHeight || 0;
            const maxScrollTop = totalRowsHeight - dimensions.viewportInnerSize.height - (dimensions.hasScrollX ? dimensions.scrollbarSize : 0);
            return scrollPosition.current.top < maxScrollTop;
        }
        return false;
    };
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const totalHeaderHeight = (0, $d1cd1e3fd8558ad5$exports.getTotalHeaderHeight)(apiRef, rootProps);
    const style = {
        top: scrollDirection === 'up' ? totalHeaderHeight : undefined,
        bottom: scrollDirection === 'down' ? 0 : undefined
    };
    const handleDragOver = (0, $3b92023a13ae6811$var$_useEventCallback.default)((event)=>{
        let offset;
        // Prevents showing the forbidden cursor
        event.preventDefault();
        if (scrollDirection === 'up') offset = event.clientY - rootRef.current.getBoundingClientRect().bottom;
        else if (scrollDirection === 'down') offset = Math.max(1, event.clientY - rootRef.current.getBoundingClientRect().top);
        else throw new Error('MUI X: Wrong drag direction');
        offset = (offset - $3b92023a13ae6811$var$CLIFF) * $3b92023a13ae6811$var$SLOP + $3b92023a13ae6811$var$CLIFF;
        // Avoid freeze and inertia.
        timeout.start(0, ()=>{
            apiRef.current.scroll({
                left: scrollPosition.current.left,
                top: scrollPosition.current.top + offset
            });
        });
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3b92023a13ae6811$var$GridScrollAreaContent, (0, $3b92023a13ae6811$var$_extends2.default)({}, props, {
        ref: rootRef,
        getCanScrollMore: getCanScrollMore,
        style: style,
        handleDragOver: handleDragOver
    }));
}
const $3b92023a13ae6811$var$GridScrollAreaContent = (0, $fYxgT.forwardRef)(function GridScrollAreaContent(props, ref) {
    const { scrollDirection: scrollDirection, getCanScrollMore: getCanScrollMore, style: style, handleDragOver: handleDragOver } = props;
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const [canScrollMore, setCanScrollMore] = $3b92023a13ae6811$var$React.useState(getCanScrollMore);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = (0, $3b92023a13ae6811$var$_extends2.default)({}, rootProps, {
        scrollDirection: scrollDirection
    });
    const classes = $3b92023a13ae6811$var$useUtilityClasses(ownerState);
    const handleScrolling = ()=>{
        setCanScrollMore(getCanScrollMore);
    };
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'scrollPositionChange', handleScrolling);
    if (!canScrollMore) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3b92023a13ae6811$var$GridScrollAreaRawRoot, {
        ref: ref,
        className: classes.root,
        ownerState: ownerState,
        onDragOver: handleDragOver,
        style: style
    });
});
$3b92023a13ae6811$var$GridScrollAreaContent.displayName = "GridScrollAreaContent";
const $3b92023a13ae6811$var$GridScrollArea = $3b92023a13ae6811$exports.GridScrollArea = (0, $1bc1b286f3c678cc$exports.fastMemo)($3b92023a13ae6811$var$GridScrollAreaWrapper);



var $jDpXp = parcelRequire("jDpXp");

var $er55f = parcelRequire("er55f");

var $5sOMZ = parcelRequire("5sOMZ");

var $5H1vo = parcelRequire("5H1vo");
var $9ee3358fa4255e5b$exports = {};
"use strict";
Object.defineProperty($9ee3358fa4255e5b$exports, "__esModule", {
    value: true
});
$9ee3358fa4255e5b$exports.useGridOverlays = void 0;
var $431c82ec73ef367c$exports = {};
"use strict";
Object.defineProperty($431c82ec73ef367c$exports, "__esModule", {
    value: true
});
var $431c82ec73ef367c$var$_exportNames = {
    useGridEvent: true,
    useGridEventPriority: true,
    unstable_resetCleanupTracking: true,
    useGridSelector: true
};
Object.defineProperty($431c82ec73ef367c$exports, "unstable_resetCleanupTracking", {
    enumerable: true,
    get: function() {
        return $bc055d85bc2d0e70$exports.unstable_resetCleanupTracking;
    }
});
Object.defineProperty($431c82ec73ef367c$exports, "useGridEvent", {
    enumerable: true,
    get: function() {
        return $bc055d85bc2d0e70$exports.useGridEvent;
    }
});
Object.defineProperty($431c82ec73ef367c$exports, "useGridEventPriority", {
    enumerable: true,
    get: function() {
        return $bc055d85bc2d0e70$exports.useGridEventPriority;
    }
});
Object.defineProperty($431c82ec73ef367c$exports, "useGridSelector", {
    enumerable: true,
    get: function() {
        return $5sOMZ.useGridSelector;
    }
});
var $b66ef4c0407ba321$exports = {};
"use strict";
Object.defineProperty($b66ef4c0407ba321$exports, "__esModule", {
    value: true
});
var $59b062f6b1a80246$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $59b062f6b1a80246$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $59b062f6b1a80246$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($59b062f6b1a80246$exports, "__esModule", {
    value: true
});
$59b062f6b1a80246$exports.useRunOnce = void 0;

var $59b062f6b1a80246$var$React = $59b062f6b1a80246$require$_interopRequireWildcard((parcelRequire("acw62")));

var $59b062f6b1a80246$var$_useEnhancedEffect = $59b062f6b1a80246$require$_interopRequireDefault((parcelRequire("jdWO4")));
const $59b062f6b1a80246$var$noop = ()=>{};
/**
 * Runs an effect once, when `condition` is true.
 */ const $59b062f6b1a80246$var$useRunOnce = (condition, effect)=>{
    const didRun = $59b062f6b1a80246$var$React.useRef(false);
    (0, $59b062f6b1a80246$var$_useEnhancedEffect.default)(()=>{
        if (didRun.current || !condition) return $59b062f6b1a80246$var$noop;
        didRun.current = true;
        return effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        didRun.current || condition
    ]);
};
$59b062f6b1a80246$exports.useRunOnce = $59b062f6b1a80246$var$useRunOnce;


Object.keys($59b062f6b1a80246$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $b66ef4c0407ba321$exports && $b66ef4c0407ba321$exports[key] === $59b062f6b1a80246$exports[key]) return;
    Object.defineProperty($b66ef4c0407ba321$exports, key, {
        enumerable: true,
        get: function() {
            return $59b062f6b1a80246$exports[key];
        }
    });
});


Object.keys($b66ef4c0407ba321$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($431c82ec73ef367c$var$_exportNames, key)) return;
    if (key in $431c82ec73ef367c$exports && $431c82ec73ef367c$exports[key] === $b66ef4c0407ba321$exports[key]) return;
    Object.defineProperty($431c82ec73ef367c$exports, key, {
        enumerable: true,
        get: function() {
            return $b66ef4c0407ba321$exports[key];
        }
    });
});

var $d79b1aa4f5237e85$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d79b1aa4f5237e85$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $d79b1aa4f5237e85$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($d79b1aa4f5237e85$exports, "__esModule", {
    value: true
});
$d79b1aa4f5237e85$exports.useGridApiMethod = $d79b1aa4f5237e85$var$useGridApiMethod;

var $d79b1aa4f5237e85$var$React = $d79b1aa4f5237e85$require$_interopRequireWildcard((parcelRequire("acw62")));

var $d79b1aa4f5237e85$var$_useEnhancedEffect = $d79b1aa4f5237e85$require$_interopRequireDefault((parcelRequire("jdWO4")));
function $d79b1aa4f5237e85$var$useGridApiMethod(privateApiRef, apiMethods, visibility) {
    const isFirstRender = $d79b1aa4f5237e85$var$React.useRef(true);
    (0, $d79b1aa4f5237e85$var$_useEnhancedEffect.default)(()=>{
        isFirstRender.current = false;
        privateApiRef.current.register(visibility, apiMethods);
    }, [
        privateApiRef,
        visibility,
        apiMethods
    ]);
    if (isFirstRender.current) privateApiRef.current.register(visibility, apiMethods);
}


Object.keys($d79b1aa4f5237e85$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($431c82ec73ef367c$var$_exportNames, key)) return;
    if (key in $431c82ec73ef367c$exports && $431c82ec73ef367c$exports[key] === $d79b1aa4f5237e85$exports[key]) return;
    Object.defineProperty($431c82ec73ef367c$exports, key, {
        enumerable: true,
        get: function() {
            return $d79b1aa4f5237e85$exports[key];
        }
    });
});
var $fa53bf7350a63511$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $fa53bf7350a63511$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($fa53bf7350a63511$exports, "__esModule", {
    value: true
});
$fa53bf7350a63511$exports.useGridLogger = $fa53bf7350a63511$var$useGridLogger;

var $fa53bf7350a63511$var$React = $fa53bf7350a63511$require$_interopRequireWildcard((parcelRequire("acw62")));
function $fa53bf7350a63511$var$useGridLogger(privateApiRef, name) {
    const logger = $fa53bf7350a63511$var$React.useRef(null);
    if (logger.current) return logger.current;
    const newLogger = privateApiRef.current.getLogger(name);
    logger.current = newLogger;
    return newLogger;
}


Object.keys($fa53bf7350a63511$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($431c82ec73ef367c$var$_exportNames, key)) return;
    if (key in $431c82ec73ef367c$exports && $431c82ec73ef367c$exports[key] === $fa53bf7350a63511$exports[key]) return;
    Object.defineProperty($431c82ec73ef367c$exports, key, {
        enumerable: true,
        get: function() {
            return $fa53bf7350a63511$exports[key];
        }
    });
});

var $5sOMZ = parcelRequire("5sOMZ");
var $a17f600338696a2d$exports = {};
"use strict";
Object.defineProperty($a17f600338696a2d$exports, "__esModule", {
    value: true
});
$a17f600338696a2d$exports.useGridNativeEventListener = void 0;


const $a17f600338696a2d$var$useGridNativeEventListener = (apiRef, ref, eventName, handler, options)=>{
    const logger = (0, $fa53bf7350a63511$exports.useGridLogger)(apiRef, 'useNativeEventListener');
    (0, $bc055d85bc2d0e70$exports.useGridEventPriority)(apiRef, 'rootMount', ()=>{
        const targetElement = ref();
        if (!targetElement || !eventName) return undefined;
        logger.debug(`Binding native ${eventName} event`);
        targetElement.addEventListener(eventName, handler, options);
        return ()=>{
            logger.debug(`Clearing native ${eventName} event`);
            targetElement.removeEventListener(eventName, handler, options);
        };
    });
};
$a17f600338696a2d$exports.useGridNativeEventListener = $a17f600338696a2d$var$useGridNativeEventListener;


Object.keys($a17f600338696a2d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($431c82ec73ef367c$var$_exportNames, key)) return;
    if (key in $431c82ec73ef367c$exports && $431c82ec73ef367c$exports[key] === $a17f600338696a2d$exports[key]) return;
    Object.defineProperty($431c82ec73ef367c$exports, key, {
        enumerable: true,
        get: function() {
            return $a17f600338696a2d$exports[key];
        }
    });
});
var $82679e37231fe76f$exports = {};
"use strict";
Object.defineProperty($82679e37231fe76f$exports, "__esModule", {
    value: true
});
var $b9120b953d35198c$exports = {};
"use strict";
Object.defineProperty($b9120b953d35198c$exports, "__esModule", {
    value: true
});
var $a7f3d508cdc25770$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $a7f3d508cdc25770$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($a7f3d508cdc25770$exports, "__esModule", {
    value: true
});
$a7f3d508cdc25770$exports.useFirstRender = $a7f3d508cdc25770$var$useFirstRender;

var $a7f3d508cdc25770$var$React = $a7f3d508cdc25770$require$_interopRequireWildcard((parcelRequire("acw62")));
function $a7f3d508cdc25770$var$useFirstRender(callback) {
    const isFirstRender = $a7f3d508cdc25770$var$React.useRef(true);
    if (isFirstRender.current) {
        isFirstRender.current = false;
        callback();
    }
}


Object.keys($a7f3d508cdc25770$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $b9120b953d35198c$exports && $b9120b953d35198c$exports[key] === $a7f3d508cdc25770$exports[key]) return;
    Object.defineProperty($b9120b953d35198c$exports, key, {
        enumerable: true,
        get: function() {
            return $a7f3d508cdc25770$exports[key];
        }
    });
});


Object.keys($b9120b953d35198c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $82679e37231fe76f$exports && $82679e37231fe76f$exports[key] === $b9120b953d35198c$exports[key]) return;
    Object.defineProperty($82679e37231fe76f$exports, key, {
        enumerable: true,
        get: function() {
            return $b9120b953d35198c$exports[key];
        }
    });
});


Object.keys($82679e37231fe76f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($431c82ec73ef367c$var$_exportNames, key)) return;
    if (key in $431c82ec73ef367c$exports && $431c82ec73ef367c$exports[key] === $82679e37231fe76f$exports[key]) return;
    Object.defineProperty($431c82ec73ef367c$exports, key, {
        enumerable: true,
        get: function() {
            return $82679e37231fe76f$exports[key];
        }
    });
});
var $974e2ec20df6d801$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $974e2ec20df6d801$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($974e2ec20df6d801$exports, "__esModule", {
    value: true
});
Object.defineProperty($974e2ec20df6d801$exports, "useOnMount", {
    enumerable: true,
    get: function() {
        return $974e2ec20df6d801$var$_useOnMount.default;
    }
});

var $974e2ec20df6d801$var$_useOnMount = $974e2ec20df6d801$require$_interopRequireDefault((parcelRequire("fGtMU")));


Object.keys($974e2ec20df6d801$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($431c82ec73ef367c$var$_exportNames, key)) return;
    if (key in $431c82ec73ef367c$exports && $431c82ec73ef367c$exports[key] === $974e2ec20df6d801$exports[key]) return;
    Object.defineProperty($431c82ec73ef367c$exports, key, {
        enumerable: true,
        get: function() {
            return $974e2ec20df6d801$exports[key];
        }
    });
});
var $e3008c977e3d8041$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $e3008c977e3d8041$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($e3008c977e3d8041$exports, "__esModule", {
    value: true
});
$e3008c977e3d8041$exports.useRunOncePerLoop = $e3008c977e3d8041$var$useRunOncePerLoop;

var $e3008c977e3d8041$var$React = $e3008c977e3d8041$require$_interopRequireWildcard((parcelRequire("acw62")));
function $e3008c977e3d8041$var$useRunOncePerLoop(callback) {
    const scheduledCallbackRef = $e3008c977e3d8041$var$React.useRef(null);
    const schedule = $e3008c977e3d8041$var$React.useCallback((...args)=>{
        // for robustness, a fallback in case we don't react to state updates and layoutEffect is not run
        // if we react to state updates, layoutEffect will run before microtasks
        if (!scheduledCallbackRef.current) queueMicrotask(()=>{
            if (scheduledCallbackRef.current) scheduledCallbackRef.current();
        });
        scheduledCallbackRef.current = ()=>{
            scheduledCallbackRef.current = null;
            callback(...args);
        };
    }, [
        callback
    ]);
    $e3008c977e3d8041$var$React.useLayoutEffect(()=>{
        if (scheduledCallbackRef.current) scheduledCallbackRef.current();
    });
    return {
        schedule: schedule,
        cancel: ()=>{
            if (scheduledCallbackRef.current) {
                scheduledCallbackRef.current = null;
                return true;
            }
            return false;
        }
    };
}


Object.keys($e3008c977e3d8041$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($431c82ec73ef367c$var$_exportNames, key)) return;
    if (key in $431c82ec73ef367c$exports && $431c82ec73ef367c$exports[key] === $e3008c977e3d8041$exports[key]) return;
    Object.defineProperty($431c82ec73ef367c$exports, key, {
        enumerable: true,
        get: function() {
            return $e3008c977e3d8041$exports[key];
        }
    });
});


var $0c64e77f4c442b27$exports = {};
"use strict";
Object.defineProperty($0c64e77f4c442b27$exports, "__esModule", {
    value: true
});
Object.defineProperty($0c64e77f4c442b27$exports, "getDefaultGridFilterModel", {
    enumerable: true,
    get: function() {
        return $f582e8f6fdde33c9$exports.getDefaultGridFilterModel;
    }
});
Object.defineProperty($0c64e77f4c442b27$exports, "gridExpandedRowCountSelector", {
    enumerable: true,
    get: function() {
        return $e95988b653de2e96$exports.gridExpandedRowCountSelector;
    }
});
Object.defineProperty($0c64e77f4c442b27$exports, "gridExpandedSortedRowEntriesSelector", {
    enumerable: true,
    get: function() {
        return $e95988b653de2e96$exports.gridExpandedSortedRowEntriesSelector;
    }
});
Object.defineProperty($0c64e77f4c442b27$exports, "gridExpandedSortedRowIdsSelector", {
    enumerable: true,
    get: function() {
        return $e95988b653de2e96$exports.gridExpandedSortedRowIdsSelector;
    }
});
Object.defineProperty($0c64e77f4c442b27$exports, "gridExpandedSortedRowIndexLookupSelector", {
    enumerable: true,
    get: function() {
        return $e95988b653de2e96$exports.gridExpandedSortedRowIndexLookupSelector;
    }
});
Object.defineProperty($0c64e77f4c442b27$exports, "gridFilterActiveItemsLookupSelector", {
    enumerable: true,
    get: function() {
        return $e95988b653de2e96$exports.gridFilterActiveItemsLookupSelector;
    }
});
Object.defineProperty($0c64e77f4c442b27$exports, "gridFilterActiveItemsSelector", {
    enumerable: true,
    get: function() {
        return $e95988b653de2e96$exports.gridFilterActiveItemsSelector;
    }
});
Object.defineProperty($0c64e77f4c442b27$exports, "gridFilterModelSelector", {
    enumerable: true,
    get: function() {
        return $e95988b653de2e96$exports.gridFilterModelSelector;
    }
});
Object.defineProperty($0c64e77f4c442b27$exports, "gridFilteredDescendantCountLookupSelector", {
    enumerable: true,
    get: function() {
        return $e95988b653de2e96$exports.gridFilteredDescendantCountLookupSelector;
    }
});
Object.defineProperty($0c64e77f4c442b27$exports, "gridFilteredDescendantRowCountSelector", {
    enumerable: true,
    get: function() {
        return $e95988b653de2e96$exports.gridFilteredDescendantRowCountSelector;
    }
});
Object.defineProperty($0c64e77f4c442b27$exports, "gridFilteredRowCountSelector", {
    enumerable: true,
    get: function() {
        return $e95988b653de2e96$exports.gridFilteredRowCountSelector;
    }
});
Object.defineProperty($0c64e77f4c442b27$exports, "gridFilteredRowsLookupSelector", {
    enumerable: true,
    get: function() {
        return $e95988b653de2e96$exports.gridFilteredRowsLookupSelector;
    }
});
Object.defineProperty($0c64e77f4c442b27$exports, "gridFilteredSortedRowEntriesSelector", {
    enumerable: true,
    get: function() {
        return $e95988b653de2e96$exports.gridFilteredSortedRowEntriesSelector;
    }
});
Object.defineProperty($0c64e77f4c442b27$exports, "gridFilteredSortedRowIdsSelector", {
    enumerable: true,
    get: function() {
        return $e95988b653de2e96$exports.gridFilteredSortedRowIdsSelector;
    }
});
Object.defineProperty($0c64e77f4c442b27$exports, "gridFilteredSortedTopLevelRowEntriesSelector", {
    enumerable: true,
    get: function() {
        return $e95988b653de2e96$exports.gridFilteredSortedTopLevelRowEntriesSelector;
    }
});
Object.defineProperty($0c64e77f4c442b27$exports, "gridFilteredTopLevelRowCountSelector", {
    enumerable: true,
    get: function() {
        return $e95988b653de2e96$exports.gridFilteredTopLevelRowCountSelector;
    }
});
Object.defineProperty($0c64e77f4c442b27$exports, "gridQuickFilterValuesSelector", {
    enumerable: true,
    get: function() {
        return $e95988b653de2e96$exports.gridQuickFilterValuesSelector;
    }
});
Object.defineProperty($0c64e77f4c442b27$exports, "gridVisibleRowsLookupSelector", {
    enumerable: true,
    get: function() {
        return $e95988b653de2e96$exports.gridVisibleRowsLookupSelector;
    }
});







var $2d9bb9ae74999313$exports = {};
"use strict";
Object.defineProperty($2d9bb9ae74999313$exports, "__esModule", {
    value: true
});
var $f88d9e849ff2881a$exports = {};
"use strict";
Object.defineProperty($f88d9e849ff2881a$exports, "__esModule", {
    value: true
});


Object.keys($f88d9e849ff2881a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2d9bb9ae74999313$exports && $2d9bb9ae74999313$exports[key] === $f88d9e849ff2881a$exports[key]) return;
    Object.defineProperty($2d9bb9ae74999313$exports, key, {
        enumerable: true,
        get: function() {
            return $f88d9e849ff2881a$exports[key];
        }
    });
});
var $2623d93ce2942d3c$exports = {};
"use strict";
Object.defineProperty($2623d93ce2942d3c$exports, "__esModule", {
    value: true
});
$2623d93ce2942d3c$exports.gridPivotInitialColumnsSelector = $2623d93ce2942d3c$exports.gridPivotActiveSelector = void 0;

const $2623d93ce2942d3c$var$gridPivotingStateSelector = (0, $8eef5f2af445e503$exports.createRootSelector)(// @ts-ignore
(state)=>state.pivoting);
const $2623d93ce2942d3c$var$gridPivotActiveSelector = $2623d93ce2942d3c$exports.gridPivotActiveSelector = (0, $8eef5f2af445e503$exports.createSelector)($2623d93ce2942d3c$var$gridPivotingStateSelector, (pivoting)=>pivoting?.active);
const $2623d93ce2942d3c$var$emptyColumns = new Map();
const $2623d93ce2942d3c$var$gridPivotInitialColumnsSelector = $2623d93ce2942d3c$exports.gridPivotInitialColumnsSelector = (0, $8eef5f2af445e503$exports.createSelector)($2623d93ce2942d3c$var$gridPivotingStateSelector, (pivoting)=>pivoting?.initialColumns || $2623d93ce2942d3c$var$emptyColumns);


Object.keys($2623d93ce2942d3c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2d9bb9ae74999313$exports && $2d9bb9ae74999313$exports[key] === $2623d93ce2942d3c$exports[key]) return;
    Object.defineProperty($2d9bb9ae74999313$exports, key, {
        enumerable: true,
        get: function() {
            return $2623d93ce2942d3c$exports[key];
        }
    });
});


/**
 * Uses the grid state to determine which overlay to display.
 * Returns the active overlay type and the active loading overlay variant.
 */ const $9ee3358fa4255e5b$var$useGridOverlays = (apiRef, props)=>{
    const totalRowCount = (0, $431c82ec73ef367c$exports.useGridSelector)(apiRef, $aad5df8f504205b0$exports.gridRowCountSelector);
    const visibleRowCount = (0, $431c82ec73ef367c$exports.useGridSelector)(apiRef, $0c64e77f4c442b27$exports.gridExpandedRowCountSelector);
    const pinnedRowsCount = (0, $431c82ec73ef367c$exports.useGridSelector)(apiRef, $befccaa56b49492d$exports.gridPinnedRowsCountSelector);
    const visibleColumns = (0, $431c82ec73ef367c$exports.useGridSelector)(apiRef, $e3b5f2e67362f55f$exports.gridVisibleColumnDefinitionsSelector);
    const noRows = totalRowCount === 0 && pinnedRowsCount === 0;
    const loading = (0, $431c82ec73ef367c$exports.useGridSelector)(apiRef, $aad5df8f504205b0$exports.gridRowsLoadingSelector);
    const pivotActive = (0, $431c82ec73ef367c$exports.useGridSelector)(apiRef, $2d9bb9ae74999313$exports.gridPivotActiveSelector);
    const showNoRowsOverlay = !loading && noRows;
    const showNoResultsOverlay = !loading && totalRowCount > 0 && visibleRowCount === 0;
    const showNoColumnsOverlay = !loading && visibleColumns.length === 0;
    const showEmptyPivotOverlay = showNoRowsOverlay && pivotActive;
    let overlayType = null;
    let loadingOverlayVariant = null;
    if (showNoRowsOverlay) overlayType = 'noRowsOverlay';
    if (showNoColumnsOverlay) overlayType = 'noColumnsOverlay';
    if (showEmptyPivotOverlay) overlayType = 'emptyPivotOverlay';
    if (showNoResultsOverlay) overlayType = 'noResultsOverlay';
    if (loading) {
        overlayType = 'loadingOverlay';
        loadingOverlayVariant = props.slotProps?.loadingOverlay?.[noRows ? 'noRowsVariant' : 'variant'] ?? (noRows ? 'skeleton' : 'linear-progress');
    }
    return {
        overlayType: overlayType,
        loadingOverlayVariant: loadingOverlayVariant
    };
};
$9ee3358fa4255e5b$exports.useGridOverlays = $9ee3358fa4255e5b$var$useGridOverlays;


var $a193a1fff9f5c318$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a193a1fff9f5c318$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($a193a1fff9f5c318$exports, "__esModule", {
    value: true
});
$a193a1fff9f5c318$exports.GridHeaders = void 0;

var $a193a1fff9f5c318$var$_extends2 = $a193a1fff9f5c318$require$_interopRequireDefault((parcelRequire("3p9rK")));


var $er55f = parcelRequire("er55f");

var $5sOMZ = parcelRequire("5sOMZ");

var $jDpXp = parcelRequire("jDpXp");





var $ac7e2dd161e207a6$exports = {};
"use strict";
Object.defineProperty($ac7e2dd161e207a6$exports, "__esModule", {
    value: true
});
$ac7e2dd161e207a6$exports.gridColumnMenuSelector = void 0;

const $ac7e2dd161e207a6$var$gridColumnMenuSelector = $ac7e2dd161e207a6$exports.gridColumnMenuSelector = (0, $8eef5f2af445e503$exports.createRootSelector)((state)=>state.columnMenu);



var $ayMG0 = parcelRequire("ayMG0");
function $a193a1fff9f5c318$var$GridHeaders() {
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const visibleColumns = (0, $5sOMZ.useGridSelector)(apiRef, $e732684465924d20$exports.gridVisibleColumnDefinitionsSelector);
    const filterColumnLookup = (0, $5sOMZ.useGridSelector)(apiRef, $e95988b653de2e96$exports.gridFilterActiveItemsLookupSelector);
    const sortColumnLookup = (0, $5sOMZ.useGridSelector)(apiRef, $dc3028b3b629fae7$exports.gridSortColumnLookupSelector);
    const columnHeaderTabIndexState = (0, $5sOMZ.useGridSelector)(apiRef, $9c9b8e89fddd633d$exports.gridTabIndexColumnHeaderSelector);
    const hasNoCellTabIndexState = (0, $5sOMZ.useGridSelector)(apiRef, ()=>(0, $9c9b8e89fddd633d$exports.gridTabIndexCellSelector)(apiRef) === null);
    const columnGroupHeaderTabIndexState = (0, $5sOMZ.useGridSelector)(apiRef, $9c9b8e89fddd633d$exports.gridTabIndexColumnGroupHeaderSelector);
    const columnHeaderFocus = (0, $5sOMZ.useGridSelector)(apiRef, $9c9b8e89fddd633d$exports.gridFocusColumnHeaderSelector);
    const columnGroupHeaderFocus = (0, $5sOMZ.useGridSelector)(apiRef, $9c9b8e89fddd633d$exports.gridFocusColumnGroupHeaderSelector);
    const headerGroupingMaxDepth = (0, $5sOMZ.useGridSelector)(apiRef, $cf21d895912d975b$exports.gridColumnGroupsHeaderMaxDepthSelector);
    const columnMenuState = (0, $5sOMZ.useGridSelector)(apiRef, $ac7e2dd161e207a6$exports.gridColumnMenuSelector);
    const columnVisibility = (0, $5sOMZ.useGridSelector)(apiRef, $e732684465924d20$exports.gridColumnVisibilityModelSelector);
    const columnGroupsHeaderStructure = (0, $5sOMZ.useGridSelector)(apiRef, $cf21d895912d975b$exports.gridColumnGroupsHeaderStructureSelector);
    const hasOtherElementInTabSequence = !(columnGroupHeaderTabIndexState === null && columnHeaderTabIndexState === null && hasNoCellTabIndexState);
    const columnsContainerRef = apiRef.current.columnHeadersContainerRef;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnHeaders, (0, $a193a1fff9f5c318$var$_extends2.default)({
        ref: columnsContainerRef,
        visibleColumns: visibleColumns,
        filterColumnLookup: filterColumnLookup,
        sortColumnLookup: sortColumnLookup,
        columnHeaderTabIndexState: columnHeaderTabIndexState,
        columnGroupHeaderTabIndexState: columnGroupHeaderTabIndexState,
        columnHeaderFocus: columnHeaderFocus,
        columnGroupHeaderFocus: columnGroupHeaderFocus,
        headerGroupingMaxDepth: headerGroupingMaxDepth,
        columnMenuState: columnMenuState,
        columnVisibility: columnVisibility,
        columnGroupsHeaderStructure: columnGroupsHeaderStructure,
        hasOtherElementInTabSequence: hasOtherElementInTabSequence
    }, rootProps.slotProps?.columnHeaders));
}
const $a193a1fff9f5c318$var$MemoizedGridHeaders = $a193a1fff9f5c318$exports.GridHeaders = (0, $1bc1b286f3c678cc$exports.fastMemo)($a193a1fff9f5c318$var$GridHeaders);


var $eb3d8cbc702f4647$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $eb3d8cbc702f4647$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $eb3d8cbc702f4647$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($eb3d8cbc702f4647$exports, "__esModule", {
    value: true
});
$eb3d8cbc702f4647$exports.GridMainContainer = void 0;

var $eb3d8cbc702f4647$var$_extends2 = $eb3d8cbc702f4647$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $eb3d8cbc702f4647$var$React = $eb3d8cbc702f4647$require$_interopRequireWildcard((parcelRequire("acw62")));

var $izOUK = parcelRequire("izOUK");

var $fYxgT = parcelRequire("fYxgT");

var $jDpXp = parcelRequire("jDpXp");


var $ayMG0 = parcelRequire("ayMG0");
const $eb3d8cbc702f4647$var$GridPanelAnchor = (0, $izOUK.styled)('div')({
    position: 'absolute',
    top: `var(--DataGrid-headersTotalHeight)`,
    left: 0,
    width: 'calc(100% - (var(--DataGrid-hasScrollY) * var(--DataGrid-scrollbarSize)))'
});
const $eb3d8cbc702f4647$var$Element = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'Main',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState, loadingOverlayVariant: loadingOverlayVariant, overlayType: overlayType } = props;
        const hideContent = loadingOverlayVariant === 'skeleton' || overlayType === 'noColumnsOverlay';
        return [
            styles.main,
            ownerState.hasPinnedRight && styles['main--hasPinnedRight'],
            hideContent && styles['main--hiddenContent']
        ];
    }
})({
    flexGrow: 1,
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column'
});
const $eb3d8cbc702f4647$var$GridMainContainer = $eb3d8cbc702f4647$exports.GridMainContainer = (0, $fYxgT.forwardRef)((props, ref)=>{
    const { ownerState: ownerState } = props;
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const configuration = (0, $2b6c64068d1db0b4$exports.useGridConfiguration)();
    const ariaAttributes = configuration.hooks.useGridAriaAttributes();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($eb3d8cbc702f4647$var$Element, (0, $eb3d8cbc702f4647$var$_extends2.default)({
        ownerState: ownerState,
        className: props.className,
        tabIndex: -1
    }, ariaAttributes, rootProps.slotProps?.main, {
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($eb3d8cbc702f4647$var$GridPanelAnchor, {
                role: "presentation",
                "data-id": "gridPanelAnchor"
            }),
            props.children
        ]
    }));
});
$eb3d8cbc702f4647$var$GridMainContainer.displayName = "GridMainContainer";


var $63b75016458d5774$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $63b75016458d5774$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $63b75016458d5774$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($63b75016458d5774$exports, "__esModule", {
    value: true
});
$63b75016458d5774$exports.GridTopContainer = $63b75016458d5774$var$GridTopContainer;

var $63b75016458d5774$var$_extends2 = $63b75016458d5774$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $63b75016458d5774$var$React = $63b75016458d5774$require$_interopRequireWildcard((parcelRequire("acw62")));

var $63b75016458d5774$var$_clsx = $63b75016458d5774$require$_interopRequireDefault((parcelRequire("9QePP")));

var $izOUK = parcelRequire("izOUK");

var $63b75016458d5774$var$_composeClasses = $63b75016458d5774$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $5H1vo = parcelRequire("5H1vo");

var $ayMG0 = parcelRequire("ayMG0");
const $63b75016458d5774$var$useUtilityClasses = ()=>{
    const slots = {
        root: [
            'topContainer'
        ]
    };
    return (0, $63b75016458d5774$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, {});
};
const $63b75016458d5774$var$Element = (0, $izOUK.styled)('div')({
    position: 'sticky',
    zIndex: 40,
    top: 0
});
function $63b75016458d5774$var$GridTopContainer(props) {
    const classes = $63b75016458d5774$var$useUtilityClasses();
    return /*#__PURE__*/ (0, $ayMG0.jsx)($63b75016458d5774$var$Element, (0, $63b75016458d5774$var$_extends2.default)({}, props, {
        className: (0, $63b75016458d5774$var$_clsx.default)(classes.root, $5H1vo.gridClasses['container--top']),
        role: "presentation"
    }));
}


var $fd7f69586e4a3224$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $fd7f69586e4a3224$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $fd7f69586e4a3224$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($fd7f69586e4a3224$exports, "__esModule", {
    value: true
});
$fd7f69586e4a3224$exports.GridVirtualScrollerContent = void 0;

var $fd7f69586e4a3224$var$_extends2 = $fd7f69586e4a3224$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $fd7f69586e4a3224$var$React = $fd7f69586e4a3224$require$_interopRequireWildcard((parcelRequire("acw62")));

var $fd7f69586e4a3224$var$_clsx = $fd7f69586e4a3224$require$_interopRequireDefault((parcelRequire("9QePP")));

var $izOUK = parcelRequire("izOUK");

var $fd7f69586e4a3224$var$_composeClasses = $fd7f69586e4a3224$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $fYxgT = parcelRequire("fYxgT");

var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");

var $ayMG0 = parcelRequire("ayMG0");
const $fd7f69586e4a3224$var$useUtilityClasses = (props, overflowedContent)=>{
    const { classes: classes } = props;
    const slots = {
        root: [
            'virtualScrollerContent',
            overflowedContent && 'virtualScrollerContent--overflowed'
        ]
    };
    return (0, $fd7f69586e4a3224$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $fd7f69586e4a3224$var$VirtualScrollerContentRoot = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'VirtualScrollerContent',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.virtualScrollerContent,
            ownerState.overflowedContent && styles['virtualScrollerContent--overflowed']
        ];
    }
})({});
const $fd7f69586e4a3224$var$GridVirtualScrollerContent = $fd7f69586e4a3224$exports.GridVirtualScrollerContent = (0, $fYxgT.forwardRef)(function GridVirtualScrollerContent(props, ref) {
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const overflowedContent = !rootProps.autoHeight && props.style?.minHeight === 'auto';
    const classes = $fd7f69586e4a3224$var$useUtilityClasses(rootProps, overflowedContent);
    const ownerState = {
        classes: rootProps.classes,
        overflowedContent: overflowedContent
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($fd7f69586e4a3224$var$VirtualScrollerContentRoot, (0, $fd7f69586e4a3224$var$_extends2.default)({}, props, {
        ownerState: ownerState,
        className: (0, $fd7f69586e4a3224$var$_clsx.default)(classes.root, props.className),
        ref: ref
    }));
});
$fd7f69586e4a3224$var$GridVirtualScrollerContent.displayName = "GridVirtualScrollerContent";


var $7609a5f754a72e14$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $7609a5f754a72e14$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($7609a5f754a72e14$exports, "__esModule", {
    value: true
});
$7609a5f754a72e14$exports.GridVirtualScrollerFiller = void 0;

var $7609a5f754a72e14$var$React = $7609a5f754a72e14$require$_interopRequireWildcard((parcelRequire("acw62")));

var $izOUK = parcelRequire("izOUK");


var $hbuUJ = parcelRequire("hbuUJ");

var $5sOMZ = parcelRequire("5sOMZ");

var $bDyDY = parcelRequire("bDyDY");
var $d9a3301c6c2f6d8b$exports = {};
"use strict";
Object.defineProperty($d9a3301c6c2f6d8b$exports, "__esModule", {
    value: true
});
Object.defineProperty($d9a3301c6c2f6d8b$exports, "gridColumnsTotalWidthSelector", {
    enumerable: true,
    get: function() {
        return $46349fe7fabb2b4d$exports.gridColumnsTotalWidthSelector;
    }
});
Object.defineProperty($d9a3301c6c2f6d8b$exports, "gridDimensionsSelector", {
    enumerable: true,
    get: function() {
        return $46349fe7fabb2b4d$exports.gridDimensionsSelector;
    }
});





var $ayMG0 = parcelRequire("ayMG0");
const $7609a5f754a72e14$var$Filler = (0, $izOUK.styled)('div')({
    display: 'flex',
    flexDirection: 'row',
    width: 'var(--DataGrid-rowWidth)',
    boxSizing: 'border-box'
});
const $7609a5f754a72e14$var$Pinned = (0, $izOUK.styled)('div')({
    position: 'sticky',
    height: '100%',
    boxSizing: 'border-box',
    borderTop: '1px solid var(--rowBorderColor)',
    backgroundColor: $hbuUJ.vars.cell.background.pinned
});
const $7609a5f754a72e14$var$PinnedLeft = (0, $izOUK.styled)($7609a5f754a72e14$var$Pinned)({
    left: 0
});
const $7609a5f754a72e14$var$PinnedRight = (0, $izOUK.styled)($7609a5f754a72e14$var$Pinned)({
    right: 0
});
const $7609a5f754a72e14$var$Main = (0, $izOUK.styled)('div')({
    flexGrow: 1,
    borderTop: '1px solid var(--rowBorderColor)'
});
function $7609a5f754a72e14$var$GridVirtualScrollerFiller({ rowsLength: rowsLength }) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const { viewportOuterSize: viewportOuterSize, minimumSize: minimumSize, hasScrollX: hasScrollX, hasScrollY: hasScrollY, scrollbarSize: scrollbarSize, leftPinnedWidth: leftPinnedWidth, rightPinnedWidth: rightPinnedWidth } = (0, $5sOMZ.useGridSelector)(apiRef, $d9a3301c6c2f6d8b$exports.gridDimensionsSelector);
    const height = hasScrollX ? scrollbarSize : 0;
    const needsLastRowBorder = viewportOuterSize.height - minimumSize.height > 0;
    if (height === 0 && !needsLastRowBorder) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($7609a5f754a72e14$var$Filler, {
        className: $553c2bbb14fa5500$exports.gridClasses.filler,
        role: "presentation",
        style: {
            height: height,
            '--rowBorderColor': rowsLength === 0 ? 'transparent' : 'var(--DataGrid-rowBorderColor)'
        },
        children: [
            leftPinnedWidth > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)($7609a5f754a72e14$var$PinnedLeft, {
                className: $553c2bbb14fa5500$exports.gridClasses['filler--pinnedLeft'],
                style: {
                    width: leftPinnedWidth
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($7609a5f754a72e14$var$Main, {}),
            rightPinnedWidth > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)($7609a5f754a72e14$var$PinnedRight, {
                className: $553c2bbb14fa5500$exports.gridClasses['filler--pinnedRight'],
                style: {
                    width: rightPinnedWidth + (hasScrollY ? scrollbarSize : 0)
                }
            })
        ]
    });
}
const $7609a5f754a72e14$var$Memoized = $7609a5f754a72e14$exports.GridVirtualScrollerFiller = (0, $1bc1b286f3c678cc$exports.fastMemo)($7609a5f754a72e14$var$GridVirtualScrollerFiller);


var $401086177e70acda$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $401086177e70acda$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $401086177e70acda$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($401086177e70acda$exports, "__esModule", {
    value: true
});
$401086177e70acda$exports.GridVirtualScrollerRenderZone = void 0;

var $401086177e70acda$var$_extends2 = $401086177e70acda$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $401086177e70acda$var$React = $401086177e70acda$require$_interopRequireWildcard((parcelRequire("acw62")));

var $401086177e70acda$var$_clsx = $401086177e70acda$require$_interopRequireDefault((parcelRequire("9QePP")));

var $izOUK = parcelRequire("izOUK");

var $401086177e70acda$var$_composeClasses = $401086177e70acda$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $fYxgT = parcelRequire("fYxgT");

var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");

var $ayMG0 = parcelRequire("ayMG0");
const $401086177e70acda$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'virtualScrollerRenderZone'
        ]
    };
    return (0, $401086177e70acda$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $401086177e70acda$var$VirtualScrollerRenderZoneRoot = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'VirtualScrollerRenderZone'
})({
    position: 'absolute',
    display: 'flex',
    // Prevents margin collapsing when using `getRowSpacing`
    flexDirection: 'column'
});
const $401086177e70acda$var$GridVirtualScrollerRenderZone = $401086177e70acda$exports.GridVirtualScrollerRenderZone = (0, $fYxgT.forwardRef)(function GridVirtualScrollerRenderZone(props, ref) {
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $401086177e70acda$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($401086177e70acda$var$VirtualScrollerRenderZoneRoot, (0, $401086177e70acda$var$_extends2.default)({
        ownerState: rootProps
    }, props, {
        className: (0, $401086177e70acda$var$_clsx.default)(classes.root, props.className),
        ref: ref
    }));
});
$401086177e70acda$var$GridVirtualScrollerRenderZone.displayName = "GridVirtualScrollerRenderZone";


var $919ad8d5ff9ebb8c$exports = {};
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $919ad8d5ff9ebb8c$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $919ad8d5ff9ebb8c$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($919ad8d5ff9ebb8c$exports, "__esModule", {
    value: true
});
$919ad8d5ff9ebb8c$exports.scrollbarSizeCssExpression = $919ad8d5ff9ebb8c$exports.ScrollbarCorner = $919ad8d5ff9ebb8c$exports.GridVirtualScrollbar = void 0;

var $919ad8d5ff9ebb8c$var$React = $919ad8d5ff9ebb8c$require$_interopRequireWildcard((parcelRequire("acw62")));

var $izOUK = parcelRequire("izOUK");

var $919ad8d5ff9ebb8c$var$_useEventCallback = $919ad8d5ff9ebb8c$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $919ad8d5ff9ebb8c$var$_useForkRef = $919ad8d5ff9ebb8c$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $919ad8d5ff9ebb8c$var$_composeClasses = $919ad8d5ff9ebb8c$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $fYxgT = parcelRequire("fYxgT");


var $er55f = parcelRequire("er55f");
var $d8761d1e377450f5$exports = {};
"use strict";
Object.defineProperty($d8761d1e377450f5$exports, "__esModule", {
    value: true
});
var $cf0bc263bd6b8fa2$exports = {};
"use strict";
Object.defineProperty($cf0bc263bd6b8fa2$exports, "__esModule", {
    value: true
});
var $6d4751c30f119991$exports = {};
"use strict";
Object.defineProperty($6d4751c30f119991$exports, "__esModule", {
    value: true
});
var $3deb01af8d008d75$exports = {};
"use strict";
Object.defineProperty($3deb01af8d008d75$exports, "__esModule", {
    value: true
});


Object.keys($3deb01af8d008d75$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $6d4751c30f119991$exports && $6d4751c30f119991$exports[key] === $3deb01af8d008d75$exports[key]) return;
    Object.defineProperty($6d4751c30f119991$exports, key, {
        enumerable: true,
        get: function() {
            return $3deb01af8d008d75$exports[key];
        }
    });
});

Object.keys($ac7e2dd161e207a6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $6d4751c30f119991$exports && $6d4751c30f119991$exports[key] === $ac7e2dd161e207a6$exports[key]) return;
    Object.defineProperty($6d4751c30f119991$exports, key, {
        enumerable: true,
        get: function() {
            return $ac7e2dd161e207a6$exports[key];
        }
    });
});


Object.keys($6d4751c30f119991$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $cf0bc263bd6b8fa2$exports && $cf0bc263bd6b8fa2$exports[key] === $6d4751c30f119991$exports[key]) return;
    Object.defineProperty($cf0bc263bd6b8fa2$exports, key, {
        enumerable: true,
        get: function() {
            return $6d4751c30f119991$exports[key];
        }
    });
});

Object.keys($e3b5f2e67362f55f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $cf0bc263bd6b8fa2$exports && $cf0bc263bd6b8fa2$exports[key] === $e3b5f2e67362f55f$exports[key]) return;
    Object.defineProperty($cf0bc263bd6b8fa2$exports, key, {
        enumerable: true,
        get: function() {
            return $e3b5f2e67362f55f$exports[key];
        }
    });
});
var $ee15286bc75dbfa3$exports = {};
"use strict";
Object.defineProperty($ee15286bc75dbfa3$exports, "__esModule", {
    value: true
});

Object.keys($cf21d895912d975b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $ee15286bc75dbfa3$exports && $ee15286bc75dbfa3$exports[key] === $cf21d895912d975b$exports[key]) return;
    Object.defineProperty($ee15286bc75dbfa3$exports, key, {
        enumerable: true,
        get: function() {
            return $cf21d895912d975b$exports[key];
        }
    });
});


Object.keys($ee15286bc75dbfa3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $cf0bc263bd6b8fa2$exports && $cf0bc263bd6b8fa2$exports[key] === $ee15286bc75dbfa3$exports[key]) return;
    Object.defineProperty($cf0bc263bd6b8fa2$exports, key, {
        enumerable: true,
        get: function() {
            return $ee15286bc75dbfa3$exports[key];
        }
    });
});
var $8e734b0ea8c2815b$exports = {};
"use strict";
Object.defineProperty($8e734b0ea8c2815b$exports, "__esModule", {
    value: true
});
var $02dea0df2ecb5d58$exports = {};
"use strict";
Object.defineProperty($02dea0df2ecb5d58$exports, "__esModule", {
    value: true
});
$02dea0df2ecb5d58$exports.gridResizingColumnFieldSelector = $02dea0df2ecb5d58$exports.gridColumnResizeSelector = void 0;

const $02dea0df2ecb5d58$var$gridColumnResizeSelector = $02dea0df2ecb5d58$exports.gridColumnResizeSelector = (0, $8eef5f2af445e503$exports.createRootSelector)((state)=>state.columnResize);
const $02dea0df2ecb5d58$var$gridResizingColumnFieldSelector = $02dea0df2ecb5d58$exports.gridResizingColumnFieldSelector = (0, $8eef5f2af445e503$exports.createSelector)($02dea0df2ecb5d58$var$gridColumnResizeSelector, (columnResize)=>columnResize.resizingColumnField);


Object.keys($02dea0df2ecb5d58$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $8e734b0ea8c2815b$exports && $8e734b0ea8c2815b$exports[key] === $02dea0df2ecb5d58$exports[key]) return;
    Object.defineProperty($8e734b0ea8c2815b$exports, key, {
        enumerable: true,
        get: function() {
            return $02dea0df2ecb5d58$exports[key];
        }
    });
});
var $8e23e386d88ce772$exports = {};
"use strict";
Object.defineProperty($8e23e386d88ce772$exports, "__esModule", {
    value: true
});


Object.keys($8e23e386d88ce772$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $8e734b0ea8c2815b$exports && $8e734b0ea8c2815b$exports[key] === $8e23e386d88ce772$exports[key]) return;
    Object.defineProperty($8e734b0ea8c2815b$exports, key, {
        enumerable: true,
        get: function() {
            return $8e23e386d88ce772$exports[key];
        }
    });
});
var $49fbd9b1282fca98$exports = {};
"use strict";
Object.defineProperty($49fbd9b1282fca98$exports, "__esModule", {
    value: true
});
$49fbd9b1282fca98$exports.DEFAULT_GRID_AUTOSIZE_OPTIONS = void 0;
const $49fbd9b1282fca98$var$DEFAULT_GRID_AUTOSIZE_OPTIONS = $49fbd9b1282fca98$exports.DEFAULT_GRID_AUTOSIZE_OPTIONS = {
    includeHeaders: true,
    includeOutliers: false,
    outliersFactor: 1.5,
    expand: false,
    disableColumnVirtualization: true
}; /**
 * The Resize API interface that is available in the grid `apiRef`.
 */ 


Object.keys($49fbd9b1282fca98$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $8e734b0ea8c2815b$exports && $8e734b0ea8c2815b$exports[key] === $49fbd9b1282fca98$exports[key]) return;
    Object.defineProperty($8e734b0ea8c2815b$exports, key, {
        enumerable: true,
        get: function() {
            return $49fbd9b1282fca98$exports[key];
        }
    });
});


Object.keys($8e734b0ea8c2815b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $cf0bc263bd6b8fa2$exports && $cf0bc263bd6b8fa2$exports[key] === $8e734b0ea8c2815b$exports[key]) return;
    Object.defineProperty($cf0bc263bd6b8fa2$exports, key, {
        enumerable: true,
        get: function() {
            return $8e734b0ea8c2815b$exports[key];
        }
    });
});
var $c638c00d73ef894b$exports = {};
"use strict";
Object.defineProperty($c638c00d73ef894b$exports, "__esModule", {
    value: true
});
var $7ccddb64bfa6a5d3$exports = {};
"use strict";
Object.defineProperty($7ccddb64bfa6a5d3$exports, "__esModule", {
    value: true
});


Object.keys($7ccddb64bfa6a5d3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $c638c00d73ef894b$exports && $c638c00d73ef894b$exports[key] === $7ccddb64bfa6a5d3$exports[key]) return;
    Object.defineProperty($c638c00d73ef894b$exports, key, {
        enumerable: true,
        get: function() {
            return $7ccddb64bfa6a5d3$exports[key];
        }
    });
});

Object.keys($b611aad21a5b677d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $c638c00d73ef894b$exports && $c638c00d73ef894b$exports[key] === $b611aad21a5b677d$exports[key]) return;
    Object.defineProperty($c638c00d73ef894b$exports, key, {
        enumerable: true,
        get: function() {
            return $b611aad21a5b677d$exports[key];
        }
    });
});


Object.keys($c638c00d73ef894b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $cf0bc263bd6b8fa2$exports && $cf0bc263bd6b8fa2$exports[key] === $c638c00d73ef894b$exports[key]) return;
    Object.defineProperty($cf0bc263bd6b8fa2$exports, key, {
        enumerable: true,
        get: function() {
            return $c638c00d73ef894b$exports[key];
        }
    });
});
var $38b18440ab1462df$exports = {};
"use strict";
Object.defineProperty($38b18440ab1462df$exports, "__esModule", {
    value: true
});
var $443dd6b911893b50$exports = {};
"use strict";
Object.defineProperty($443dd6b911893b50$exports, "__esModule", {
    value: true
});
$443dd6b911893b50$exports.gridRowIsEditingSelector = $443dd6b911893b50$exports.gridEditRowsStateSelector = $443dd6b911893b50$exports.gridEditCellStateSelector = void 0;


/**
 * Select the row editing state.
 */ const $443dd6b911893b50$var$gridEditRowsStateSelector = $443dd6b911893b50$exports.gridEditRowsStateSelector = (0, $8eef5f2af445e503$exports.createRootSelector)((state)=>state.editRows);
const $443dd6b911893b50$var$gridRowIsEditingSelector = $443dd6b911893b50$exports.gridRowIsEditingSelector = (0, $8eef5f2af445e503$exports.createSelector)($443dd6b911893b50$var$gridEditRowsStateSelector, (editRows, { rowId: rowId, editMode: editMode })=>editMode === $e139707caeafbfd6$exports.GridEditModes.Row && Boolean(editRows[rowId]));
const $443dd6b911893b50$var$gridEditCellStateSelector = $443dd6b911893b50$exports.gridEditCellStateSelector = (0, $8eef5f2af445e503$exports.createSelector)($443dd6b911893b50$var$gridEditRowsStateSelector, (editRows, { rowId: rowId, field: field })=>editRows[rowId]?.[field] ?? null);


Object.keys($443dd6b911893b50$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $38b18440ab1462df$exports && $38b18440ab1462df$exports[key] === $443dd6b911893b50$exports[key]) return;
    Object.defineProperty($38b18440ab1462df$exports, key, {
        enumerable: true,
        get: function() {
            return $443dd6b911893b50$exports[key];
        }
    });
});


Object.keys($38b18440ab1462df$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $cf0bc263bd6b8fa2$exports && $cf0bc263bd6b8fa2$exports[key] === $38b18440ab1462df$exports[key]) return;
    Object.defineProperty($cf0bc263bd6b8fa2$exports, key, {
        enumerable: true,
        get: function() {
            return $38b18440ab1462df$exports[key];
        }
    });
});

Object.keys($0c64e77f4c442b27$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $cf0bc263bd6b8fa2$exports && $cf0bc263bd6b8fa2$exports[key] === $0c64e77f4c442b27$exports[key]) return;
    Object.defineProperty($cf0bc263bd6b8fa2$exports, key, {
        enumerable: true,
        get: function() {
            return $0c64e77f4c442b27$exports[key];
        }
    });
});
var $b6fed9c583d617da$exports = {};
"use strict";
Object.defineProperty($b6fed9c583d617da$exports, "__esModule", {
    value: true
});

Object.keys($9c9b8e89fddd633d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $b6fed9c583d617da$exports && $b6fed9c583d617da$exports[key] === $9c9b8e89fddd633d$exports[key]) return;
    Object.defineProperty($b6fed9c583d617da$exports, key, {
        enumerable: true,
        get: function() {
            return $9c9b8e89fddd633d$exports[key];
        }
    });
});
var $0470de2a1cf4f40c$exports = {};
"use strict";
Object.defineProperty($0470de2a1cf4f40c$exports, "__esModule", {
    value: true
});


Object.keys($0470de2a1cf4f40c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $b6fed9c583d617da$exports && $b6fed9c583d617da$exports[key] === $0470de2a1cf4f40c$exports[key]) return;
    Object.defineProperty($b6fed9c583d617da$exports, key, {
        enumerable: true,
        get: function() {
            return $0470de2a1cf4f40c$exports[key];
        }
    });
});


Object.keys($b6fed9c583d617da$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $cf0bc263bd6b8fa2$exports && $cf0bc263bd6b8fa2$exports[key] === $b6fed9c583d617da$exports[key]) return;
    Object.defineProperty($cf0bc263bd6b8fa2$exports, key, {
        enumerable: true,
        get: function() {
            return $b6fed9c583d617da$exports[key];
        }
    });
});

Object.keys($0a2279c071105276$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $cf0bc263bd6b8fa2$exports && $cf0bc263bd6b8fa2$exports[key] === $0a2279c071105276$exports[key]) return;
    Object.defineProperty($cf0bc263bd6b8fa2$exports, key, {
        enumerable: true,
        get: function() {
            return $0a2279c071105276$exports[key];
        }
    });
});
var $809f57c9ce5163f3$exports = {};
"use strict";
Object.defineProperty($809f57c9ce5163f3$exports, "__esModule", {
    value: true
});

Object.keys($c41ec74257ca380c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $809f57c9ce5163f3$exports && $809f57c9ce5163f3$exports[key] === $c41ec74257ca380c$exports[key]) return;
    Object.defineProperty($809f57c9ce5163f3$exports, key, {
        enumerable: true,
        get: function() {
            return $c41ec74257ca380c$exports[key];
        }
    });
});


Object.keys($809f57c9ce5163f3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $cf0bc263bd6b8fa2$exports && $cf0bc263bd6b8fa2$exports[key] === $809f57c9ce5163f3$exports[key]) return;
    Object.defineProperty($cf0bc263bd6b8fa2$exports, key, {
        enumerable: true,
        get: function() {
            return $809f57c9ce5163f3$exports[key];
        }
    });
});
var $6728e9ffb7926382$exports = {};
"use strict";
Object.defineProperty($6728e9ffb7926382$exports, "__esModule", {
    value: true
});
var $6728e9ffb7926382$var$_exportNames = {
    gridPreferencePanelStateSelector: true
};
Object.defineProperty($6728e9ffb7926382$exports, "gridPreferencePanelStateSelector", {
    enumerable: true,
    get: function() {
        return $50fa8e974bf84473$exports.gridPreferencePanelStateSelector;
    }
});
var $50fa8e974bf84473$exports = {};
"use strict";
Object.defineProperty($50fa8e974bf84473$exports, "__esModule", {
    value: true
});
$50fa8e974bf84473$exports.gridPreferencePanelStateSelector = $50fa8e974bf84473$exports.gridPreferencePanelSelectorWithLabel = void 0;

const $50fa8e974bf84473$var$gridPreferencePanelStateSelector = $50fa8e974bf84473$exports.gridPreferencePanelStateSelector = (0, $8eef5f2af445e503$exports.createRootSelector)((state)=>state.preferencePanel);
const $50fa8e974bf84473$var$gridPreferencePanelSelectorWithLabel = $50fa8e974bf84473$exports.gridPreferencePanelSelectorWithLabel = (0, $8eef5f2af445e503$exports.createSelector)($50fa8e974bf84473$var$gridPreferencePanelStateSelector, (panel, labelId)=>{
    if (panel.open && panel.labelId === labelId) return true;
    return false;
});


var $fd38e8991c08dfb2$exports = {};
"use strict";
Object.defineProperty($fd38e8991c08dfb2$exports, "__esModule", {
    value: true
});


Object.keys($fd38e8991c08dfb2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($6728e9ffb7926382$var$_exportNames, key)) return;
    if (key in $6728e9ffb7926382$exports && $6728e9ffb7926382$exports[key] === $fd38e8991c08dfb2$exports[key]) return;
    Object.defineProperty($6728e9ffb7926382$exports, key, {
        enumerable: true,
        get: function() {
            return $fd38e8991c08dfb2$exports[key];
        }
    });
});
var $2ca45f4bbfed6878$exports = {};
"use strict";
Object.defineProperty($2ca45f4bbfed6878$exports, "__esModule", {
    value: true
});
$2ca45f4bbfed6878$exports.GridPreferencePanelsValue = void 0;
var $2ca45f4bbfed6878$var$GridPreferencePanelsValue = $2ca45f4bbfed6878$exports.GridPreferencePanelsValue = /*#__PURE__*/ function(GridPreferencePanelsValue) {
    GridPreferencePanelsValue["filters"] = "filters";
    GridPreferencePanelsValue["columns"] = "columns";
    GridPreferencePanelsValue["aiAssistant"] = "aiAssistant";
    return GridPreferencePanelsValue;
}($2ca45f4bbfed6878$var$GridPreferencePanelsValue || {});


Object.keys($2ca45f4bbfed6878$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($6728e9ffb7926382$var$_exportNames, key)) return;
    if (key in $6728e9ffb7926382$exports && $6728e9ffb7926382$exports[key] === $2ca45f4bbfed6878$exports[key]) return;
    Object.defineProperty($6728e9ffb7926382$exports, key, {
        enumerable: true,
        get: function() {
            return $2ca45f4bbfed6878$exports[key];
        }
    });
});


Object.keys($6728e9ffb7926382$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $cf0bc263bd6b8fa2$exports && $cf0bc263bd6b8fa2$exports[key] === $6728e9ffb7926382$exports[key]) return;
    Object.defineProperty($cf0bc263bd6b8fa2$exports, key, {
        enumerable: true,
        get: function() {
            return $6728e9ffb7926382$exports[key];
        }
    });
});

Object.keys($aad5df8f504205b0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $cf0bc263bd6b8fa2$exports && $cf0bc263bd6b8fa2$exports[key] === $aad5df8f504205b0$exports[key]) return;
    Object.defineProperty($cf0bc263bd6b8fa2$exports, key, {
        enumerable: true,
        get: function() {
            return $aad5df8f504205b0$exports[key];
        }
    });
});
var $39b6b713fdb91ccd$exports = {};
"use strict";
Object.defineProperty($39b6b713fdb91ccd$exports, "__esModule", {
    value: true
});

Object.keys($7a5249c135fd39c1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $39b6b713fdb91ccd$exports && $39b6b713fdb91ccd$exports[key] === $7a5249c135fd39c1$exports[key]) return;
    Object.defineProperty($39b6b713fdb91ccd$exports, key, {
        enumerable: true,
        get: function() {
            return $7a5249c135fd39c1$exports[key];
        }
    });
});


Object.keys($39b6b713fdb91ccd$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $cf0bc263bd6b8fa2$exports && $cf0bc263bd6b8fa2$exports[key] === $39b6b713fdb91ccd$exports[key]) return;
    Object.defineProperty($cf0bc263bd6b8fa2$exports, key, {
        enumerable: true,
        get: function() {
            return $39b6b713fdb91ccd$exports[key];
        }
    });
});
var $1dc7f0a3aef5b9b4$exports = {};
"use strict";
Object.defineProperty($1dc7f0a3aef5b9b4$exports, "__esModule", {
    value: true
});
Object.defineProperty($1dc7f0a3aef5b9b4$exports, "gridDateComparator", {
    enumerable: true,
    get: function() {
        return $c78f90aae54b126e$exports.gridDateComparator;
    }
});
Object.defineProperty($1dc7f0a3aef5b9b4$exports, "gridNumberComparator", {
    enumerable: true,
    get: function() {
        return $c78f90aae54b126e$exports.gridNumberComparator;
    }
});
Object.defineProperty($1dc7f0a3aef5b9b4$exports, "gridSortColumnLookupSelector", {
    enumerable: true,
    get: function() {
        return $dc3028b3b629fae7$exports.gridSortColumnLookupSelector;
    }
});
Object.defineProperty($1dc7f0a3aef5b9b4$exports, "gridSortModelSelector", {
    enumerable: true,
    get: function() {
        return $dc3028b3b629fae7$exports.gridSortModelSelector;
    }
});
Object.defineProperty($1dc7f0a3aef5b9b4$exports, "gridSortedRowEntriesSelector", {
    enumerable: true,
    get: function() {
        return $dc3028b3b629fae7$exports.gridSortedRowEntriesSelector;
    }
});
Object.defineProperty($1dc7f0a3aef5b9b4$exports, "gridSortedRowIdsSelector", {
    enumerable: true,
    get: function() {
        return $dc3028b3b629fae7$exports.gridSortedRowIdsSelector;
    }
});
Object.defineProperty($1dc7f0a3aef5b9b4$exports, "gridStringOrNumberComparator", {
    enumerable: true,
    get: function() {
        return $c78f90aae54b126e$exports.gridStringOrNumberComparator;
    }
});




Object.keys($1dc7f0a3aef5b9b4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $cf0bc263bd6b8fa2$exports && $cf0bc263bd6b8fa2$exports[key] === $1dc7f0a3aef5b9b4$exports[key]) return;
    Object.defineProperty($cf0bc263bd6b8fa2$exports, key, {
        enumerable: true,
        get: function() {
            return $1dc7f0a3aef5b9b4$exports[key];
        }
    });
});

Object.keys($d9a3301c6c2f6d8b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $cf0bc263bd6b8fa2$exports && $cf0bc263bd6b8fa2$exports[key] === $d9a3301c6c2f6d8b$exports[key]) return;
    Object.defineProperty($cf0bc263bd6b8fa2$exports, key, {
        enumerable: true,
        get: function() {
            return $d9a3301c6c2f6d8b$exports[key];
        }
    });
});
var $e32c0f115c3443f6$exports = {};
"use strict";
Object.defineProperty($e32c0f115c3443f6$exports, "__esModule", {
    value: true
});


Object.keys($e32c0f115c3443f6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $cf0bc263bd6b8fa2$exports && $cf0bc263bd6b8fa2$exports[key] === $e32c0f115c3443f6$exports[key]) return;
    Object.defineProperty($cf0bc263bd6b8fa2$exports, key, {
        enumerable: true,
        get: function() {
            return $e32c0f115c3443f6$exports[key];
        }
    });
});
var $2eb9b8b1ea6246c2$exports = {};
"use strict";
Object.defineProperty($2eb9b8b1ea6246c2$exports, "__esModule", {
    value: true
});

Object.keys($48c71b00043b47b4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2eb9b8b1ea6246c2$exports && $2eb9b8b1ea6246c2$exports[key] === $48c71b00043b47b4$exports[key]) return;
    Object.defineProperty($2eb9b8b1ea6246c2$exports, key, {
        enumerable: true,
        get: function() {
            return $48c71b00043b47b4$exports[key];
        }
    });
});


Object.keys($2eb9b8b1ea6246c2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $cf0bc263bd6b8fa2$exports && $cf0bc263bd6b8fa2$exports[key] === $2eb9b8b1ea6246c2$exports[key]) return;
    Object.defineProperty($cf0bc263bd6b8fa2$exports, key, {
        enumerable: true,
        get: function() {
            return $2eb9b8b1ea6246c2$exports[key];
        }
    });
});
var $94d9a2be66e71282$exports = {};
"use strict";
Object.defineProperty($94d9a2be66e71282$exports, "__esModule", {
    value: true
});
var $94d9a2be66e71282$var$_exportNames = {
    EMPTY_RENDER_CONTEXT: true
};
Object.defineProperty($94d9a2be66e71282$exports, "EMPTY_RENDER_CONTEXT", {
    enumerable: true,
    get: function() {
        return $f627be570fb53c87$exports.EMPTY_RENDER_CONTEXT;
    }
});
var $f627be570fb53c87$exports = {};
/**
 * @mui/x-virtualizer v0.2.12
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
Object.defineProperty($f627be570fb53c87$exports, "__esModule", {
    value: true
});
var $d8a42ab8ec8ec106$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d8a42ab8ec8ec106$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($d8a42ab8ec8ec106$exports, "__esModule", {
    value: true
});
$d8a42ab8ec8ec106$exports.useVirtualizer = void 0;

var $d8a42ab8ec8ec106$var$_extends2 = $d8a42ab8ec8ec106$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $d8a42ab8ec8ec106$var$_useLazyRef = $d8a42ab8ec8ec106$require$_interopRequireDefault((parcelRequire("doV3C")));

var $5aceebfd588d01cb$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5aceebfd588d01cb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($5aceebfd588d01cb$exports, "__esModule", {
    value: true
});
$5aceebfd588d01cb$exports.Colspan = void 0;

var $5aceebfd588d01cb$var$_useEventCallback = $5aceebfd588d01cb$require$_interopRequireDefault((parcelRequire("6Lbjo")));
/* eslint-disable import/export, @typescript-eslint/no-redeclare */ const $5aceebfd588d01cb$var$selectors = {};
const $5aceebfd588d01cb$var$Colspan = $5aceebfd588d01cb$exports.Colspan = {
    initialize: $5aceebfd588d01cb$var$initializeState,
    use: $5aceebfd588d01cb$var$useColspan,
    selectors: $5aceebfd588d01cb$var$selectors
};
function $5aceebfd588d01cb$var$initializeState(_params) {
    return {
        colspanMap: new Map()
    };
}
function $5aceebfd588d01cb$var$useColspan(store, params, api) {
    const getColspan = params.colspan?.getColspan;
    const resetColSpan = ()=>{
        store.state.colspanMap = new Map();
    };
    const getCellColSpanInfo = (rowId, columnIndex)=>{
        return store.state.colspanMap.get(rowId)?.[columnIndex];
    };
    // Calculate `colSpan` for each cell in the row
    const calculateColSpan = (0, $5aceebfd588d01cb$var$_useEventCallback.default)(getColspan ? (rowId, minFirstColumn, maxLastColumn, columns)=>{
        for(let i = minFirstColumn; i < maxLastColumn; i += 1){
            const cellProps = $5aceebfd588d01cb$var$calculateCellColSpan(store.state.colspanMap, i, rowId, minFirstColumn, maxLastColumn, columns, getColspan);
            if (cellProps.colSpan > 1) i += cellProps.colSpan - 1;
        }
    } : ()=>{});
    api.calculateColSpan = calculateColSpan;
    return {
        resetColSpan: resetColSpan,
        getCellColSpanInfo: getCellColSpanInfo,
        calculateColSpan: calculateColSpan
    };
}
function $5aceebfd588d01cb$var$calculateCellColSpan(lookup, columnIndex, rowId, minFirstColumnIndex, maxLastColumnIndex, columns, getColspan) {
    const columnsLength = columns.length;
    const column = columns[columnIndex];
    const colSpan = getColspan(rowId, column, columnIndex);
    if (!colSpan || colSpan === 1) {
        $5aceebfd588d01cb$var$setCellColSpanInfo(lookup, rowId, columnIndex, {
            spannedByColSpan: false,
            cellProps: {
                colSpan: 1,
                width: column.computedWidth
            }
        });
        return {
            colSpan: 1
        };
    }
    let width = column.computedWidth;
    for(let j = 1; j < colSpan; j += 1){
        const nextColumnIndex = columnIndex + j;
        // Cells should be spanned only within their column section (left-pinned, right-pinned and unpinned).
        if (nextColumnIndex >= minFirstColumnIndex && nextColumnIndex < maxLastColumnIndex) {
            const nextColumn = columns[nextColumnIndex];
            width += nextColumn.computedWidth;
            $5aceebfd588d01cb$var$setCellColSpanInfo(lookup, rowId, columnIndex + j, {
                spannedByColSpan: true,
                rightVisibleCellIndex: Math.min(columnIndex + colSpan, columnsLength - 1),
                leftVisibleCellIndex: columnIndex
            });
        }
        $5aceebfd588d01cb$var$setCellColSpanInfo(lookup, rowId, columnIndex, {
            spannedByColSpan: false,
            cellProps: {
                colSpan: colSpan,
                width: width
            }
        });
    }
    return {
        colSpan: colSpan
    };
}
function $5aceebfd588d01cb$var$setCellColSpanInfo(colspanMap, rowId, columnIndex, cellColSpanInfo) {
    let columnInfo = colspanMap.get(rowId);
    if (!columnInfo) {
        columnInfo = {};
        colspanMap.set(rowId, columnInfo);
    }
    columnInfo[columnIndex] = cellColSpanInfo;
}


var $c7858fce4e25e1aa$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $c7858fce4e25e1aa$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $c7858fce4e25e1aa$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($c7858fce4e25e1aa$exports, "__esModule", {
    value: true
});
$c7858fce4e25e1aa$exports.Dimensions = void 0;
$c7858fce4e25e1aa$exports.observeRootNode = $c7858fce4e25e1aa$var$observeRootNode;

var $c7858fce4e25e1aa$var$_extends2 = $c7858fce4e25e1aa$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $c7858fce4e25e1aa$var$React = $c7858fce4e25e1aa$require$_interopRequireWildcard((parcelRequire("acw62")));

var $c7858fce4e25e1aa$var$_ownerDocument = $c7858fce4e25e1aa$require$_interopRequireDefault((parcelRequire("43fuO")));

var $c7858fce4e25e1aa$var$_useLazyRef = $c7858fce4e25e1aa$require$_interopRequireDefault((parcelRequire("doV3C")));

var $c7858fce4e25e1aa$var$_useEnhancedEffect = $c7858fce4e25e1aa$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $c7858fce4e25e1aa$var$_useEventCallback = $c7858fce4e25e1aa$require$_interopRequireDefault((parcelRequire("6Lbjo")));
var $6be97efd7b623082$exports = {};
"use strict";
Object.defineProperty($6be97efd7b623082$exports, "__esModule", {
    value: true
});
var $b40969c224b3d72c$exports = {};
"use strict";
Object.defineProperty($b40969c224b3d72c$exports, "__esModule", {
    value: true
});
$b40969c224b3d72c$exports.throttle = $b40969c224b3d72c$var$throttle;
function $b40969c224b3d72c$var$throttle(func, wait = 166) {
    let timeout;
    let lastArgs;
    const later = ()=>{
        timeout = undefined;
        func(...lastArgs);
    };
    function throttled(...args) {
        lastArgs = args;
        if (timeout === undefined) timeout = setTimeout(later, wait);
    }
    throttled.clear = ()=>{
        clearTimeout(timeout);
        timeout = undefined;
    };
    return throttled;
}


Object.keys($b40969c224b3d72c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $6be97efd7b623082$exports && $6be97efd7b623082$exports[key] === $b40969c224b3d72c$exports[key]) return;
    Object.defineProperty($6be97efd7b623082$exports, key, {
        enumerable: true,
        get: function() {
            return $b40969c224b3d72c$exports[key];
        }
    });
});


var $a4d2c99ef8ba2460$exports = {};
"use strict";
Object.defineProperty($a4d2c99ef8ba2460$exports, "__esModule", {
    value: true
});
var $9679444e8beccb55$exports = {};
"use strict";
Object.defineProperty($9679444e8beccb55$exports, "__esModule", {
    value: true
});
$9679444e8beccb55$exports.isDeepEqual = $9679444e8beccb55$var$isDeepEqual;
/**
 * Based on `fast-deep-equal`
 *
 * MIT License
 *
 * Copyright (c) 2017 Evgeny Poberezkin
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * Check if two values are deeply equal.
 */ function $9679444e8beccb55$var$isDeepEqual(a, b) {
    if (a === b) return true;
    if (a && b && typeof a === 'object' && typeof b === 'object') {
        if (a.constructor !== b.constructor) return false;
        if (Array.isArray(a)) {
            const length = a.length;
            if (length !== b.length) return false;
            for(let i = 0; i < length; i += 1){
                if (!$9679444e8beccb55$var$isDeepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        if (a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            const entriesA = Array.from(a.entries());
            for(let i = 0; i < entriesA.length; i += 1){
                if (!b.has(entriesA[i][0])) return false;
            }
            for(let i = 0; i < entriesA.length; i += 1){
                const entryA = entriesA[i];
                if (!$9679444e8beccb55$var$isDeepEqual(entryA[1], b.get(entryA[0]))) return false;
            }
            return true;
        }
        if (a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            const entries = Array.from(a.entries());
            for(let i = 0; i < entries.length; i += 1){
                if (!b.has(entries[i][0])) return false;
            }
            return true;
        }
        if (ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            const length = a.length;
            if (length !== b.length) return false;
            for(let i = 0; i < length; i += 1){
                if (a[i] !== b[i]) return false;
            }
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        const keys = Object.keys(a);
        const length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(let i = 0; i < length; i += 1){
            if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        }
        for(let i = 0; i < length; i += 1){
            const key = keys[i];
            if (!$9679444e8beccb55$var$isDeepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    // eslint-disable-next-line no-self-compare
    return a !== a && b !== b;
}


Object.keys($9679444e8beccb55$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $a4d2c99ef8ba2460$exports && $a4d2c99ef8ba2460$exports[key] === $9679444e8beccb55$exports[key]) return;
    Object.defineProperty($a4d2c99ef8ba2460$exports, key, {
        enumerable: true,
        get: function() {
            return $9679444e8beccb55$exports[key];
        }
    });
});


var $b5eb928c08dc82e9$exports = {};
"use strict";
Object.defineProperty($b5eb928c08dc82e9$exports, "__esModule", {
    value: true
});
$b5eb928c08dc82e9$exports.roundToDecimalPlaces = $b5eb928c08dc82e9$var$roundToDecimalPlaces;
function $b5eb928c08dc82e9$var$roundToDecimalPlaces(value, decimals) {
    return Math.round(value * 10 ** decimals) / 10 ** decimals;
}



var $48fd8d2da17ba217$exports = {};
"use strict";
Object.defineProperty($48fd8d2da17ba217$exports, "__esModule", {
    value: true
});
var $d0e8401b7b465117$exports = {};
"use strict";
Object.defineProperty($d0e8401b7b465117$exports, "__esModule", {
    value: true
});
$d0e8401b7b465117$exports.Size = $d0e8401b7b465117$exports.ScrollPosition = $d0e8401b7b465117$exports.ScrollDirection = $d0e8401b7b465117$exports.PinnedRows = $d0e8401b7b465117$exports.PinnedColumns = void 0;
/* eslint-disable @typescript-eslint/no-redeclare */ const $d0e8401b7b465117$var$Size = $d0e8401b7b465117$exports.Size = {
    EMPTY: {
        width: 0,
        height: 0
    },
    equals: (a, b)=>a.width === b.width && a.height === b.height
};
// TODO
const $d0e8401b7b465117$var$PinnedRows = $d0e8401b7b465117$exports.PinnedRows = {
    EMPTY: {
        top: [],
        bottom: []
    }
};
const $d0e8401b7b465117$var$PinnedColumns = $d0e8401b7b465117$exports.PinnedColumns = {
    EMPTY: {
        left: [],
        right: []
    }
};
const $d0e8401b7b465117$var$ScrollPosition = $d0e8401b7b465117$exports.ScrollPosition = {
    EMPTY: {
        top: 0,
        left: 0
    },
    equals: (a, b)=>a.top === b.top && a.left === b.left
};
let $d0e8401b7b465117$var$ScrollDirection = $d0e8401b7b465117$exports.ScrollDirection = /*#__PURE__*/ function(ScrollDirection) {
    ScrollDirection[ScrollDirection["NONE"] = 0] = "NONE";
    ScrollDirection[ScrollDirection["UP"] = 1] = "UP";
    ScrollDirection[ScrollDirection["DOWN"] = 2] = "DOWN";
    ScrollDirection[ScrollDirection["LEFT"] = 3] = "LEFT";
    ScrollDirection[ScrollDirection["RIGHT"] = 4] = "RIGHT";
    return ScrollDirection;
}({});
(function(_ScrollDirection) {
    function forDelta(dx, dy) {
        if (dx === 0 && dy === 0) return $d0e8401b7b465117$var$ScrollDirection.NONE;
        /* eslint-disable */ if (Math.abs(dy) >= Math.abs(dx)) {
            if (dy > 0) return $d0e8401b7b465117$var$ScrollDirection.DOWN;
            else return $d0e8401b7b465117$var$ScrollDirection.UP;
        } else {
            if (dx > 0) return $d0e8401b7b465117$var$ScrollDirection.RIGHT;
            else return $d0e8401b7b465117$var$ScrollDirection.LEFT;
        }
    /* eslint-enable */ }
    _ScrollDirection.forDelta = forDelta;
})($d0e8401b7b465117$var$ScrollDirection || ($d0e8401b7b465117$exports.ScrollDirection = $d0e8401b7b465117$var$ScrollDirection = {}));


Object.keys($d0e8401b7b465117$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $48fd8d2da17ba217$exports && $48fd8d2da17ba217$exports[key] === $d0e8401b7b465117$exports[key]) return;
    Object.defineProperty($48fd8d2da17ba217$exports, key, {
        enumerable: true,
        get: function() {
            return $d0e8401b7b465117$exports[key];
        }
    });
});
var $978a09e9e95face0$exports = {};
"use strict";
Object.defineProperty($978a09e9e95face0$exports, "__esModule", {
    value: true
});


Object.keys($978a09e9e95face0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $48fd8d2da17ba217$exports && $48fd8d2da17ba217$exports[key] === $978a09e9e95face0$exports[key]) return;
    Object.defineProperty($48fd8d2da17ba217$exports, key, {
        enumerable: true,
        get: function() {
            return $978a09e9e95face0$exports[key];
        }
    });
});
var $1d4bf1dc5f6036ba$exports = {};
"use strict";
Object.defineProperty($1d4bf1dc5f6036ba$exports, "__esModule", {
    value: true
});


Object.keys($1d4bf1dc5f6036ba$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $48fd8d2da17ba217$exports && $48fd8d2da17ba217$exports[key] === $1d4bf1dc5f6036ba$exports[key]) return;
    Object.defineProperty($48fd8d2da17ba217$exports, key, {
        enumerable: true,
        get: function() {
            return $1d4bf1dc5f6036ba$exports[key];
        }
    });
});
var $d428d57a99df53ab$exports = {};
"use strict";
Object.defineProperty($d428d57a99df53ab$exports, "__esModule", {
    value: true
});


Object.keys($d428d57a99df53ab$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $48fd8d2da17ba217$exports && $48fd8d2da17ba217$exports[key] === $d428d57a99df53ab$exports[key]) return;
    Object.defineProperty($48fd8d2da17ba217$exports, key, {
        enumerable: true,
        get: function() {
            return $d428d57a99df53ab$exports[key];
        }
    });
});


/* eslint-disable import/export, @typescript-eslint/no-redeclare */ /* eslint-disable no-underscore-dangle */ const $c7858fce4e25e1aa$var$EMPTY_DIMENSIONS = {
    isReady: false,
    root: $48fd8d2da17ba217$exports.Size.EMPTY,
    viewportOuterSize: $48fd8d2da17ba217$exports.Size.EMPTY,
    viewportInnerSize: $48fd8d2da17ba217$exports.Size.EMPTY,
    contentSize: $48fd8d2da17ba217$exports.Size.EMPTY,
    minimumSize: $48fd8d2da17ba217$exports.Size.EMPTY,
    hasScrollX: false,
    hasScrollY: false,
    scrollbarSize: 0,
    rowWidth: 0,
    rowHeight: 0,
    columnsTotalWidth: 0,
    leftPinnedWidth: 0,
    rightPinnedWidth: 0,
    topContainerHeight: 0,
    bottomContainerHeight: 0,
    autoHeight: false,
    minimalContentHeight: undefined
};
const $c7858fce4e25e1aa$var$selectors = {
    rootSize: (state)=>state.rootSize,
    dimensions: (state)=>state.dimensions,
    rowHeight: (state)=>state.dimensions.rowHeight,
    columnsTotalWidth: (state)=>state.dimensions.columnsTotalWidth,
    contentHeight: (state)=>state.dimensions.contentSize.height,
    autoHeight: (state)=>state.dimensions.autoHeight,
    minimalContentHeight: (state)=>state.dimensions.minimalContentHeight,
    rowsMeta: (state)=>state.rowsMeta,
    rowPositions: (state)=>state.rowsMeta.positions,
    columnPositions: (0, $66c3b1bd8ca83ba8$exports.createSelectorMemoized)((_, columns)=>{
        const positions = [];
        let currentPosition = 0;
        for(let i = 0; i < columns.length; i += 1){
            positions.push(currentPosition);
            currentPosition += columns[i].computedWidth;
        }
        return positions;
    }),
    needsHorizontalScrollbar: (state)=>state.dimensions.viewportOuterSize.width > 0 && state.dimensions.columnsTotalWidth > state.dimensions.viewportOuterSize.width
};
const $c7858fce4e25e1aa$var$Dimensions = $c7858fce4e25e1aa$exports.Dimensions = {
    initialize: $c7858fce4e25e1aa$var$initializeState,
    use: $c7858fce4e25e1aa$var$useDimensions,
    selectors: $c7858fce4e25e1aa$var$selectors
};
function $c7858fce4e25e1aa$var$initializeState(params) {
    const dimensions = (0, $c7858fce4e25e1aa$var$_extends2.default)({}, $c7858fce4e25e1aa$var$EMPTY_DIMENSIONS, params.dimensions, {
        autoHeight: params.dimensions.autoHeight,
        minimalContentHeight: params.dimensions.minimalContentHeight
    });
    const { rowCount: rowCount } = params;
    const { rowHeight: rowHeight } = dimensions;
    const rowsMeta = {
        currentPageTotalHeight: rowCount * rowHeight,
        positions: Array.from({
            length: rowCount
        }, (_, i)=>i * rowHeight),
        pinnedTopRowsTotalHeight: 0,
        pinnedBottomRowsTotalHeight: 0
    };
    const rowHeights = new Map();
    return {
        rootSize: $48fd8d2da17ba217$exports.Size.EMPTY,
        dimensions: dimensions,
        rowsMeta: rowsMeta,
        rowHeights: rowHeights
    };
}
function $c7858fce4e25e1aa$var$useDimensions(store, params, _api) {
    const isFirstSizing = $c7858fce4e25e1aa$var$React.useRef(true);
    const { layout: layout, dimensions: { rowHeight: rowHeight, columnsTotalWidth: columnsTotalWidth, leftPinnedWidth: leftPinnedWidth, rightPinnedWidth: rightPinnedWidth, topPinnedHeight: topPinnedHeight, bottomPinnedHeight: bottomPinnedHeight }, onResize: onResize } = params;
    const updateDimensions = $c7858fce4e25e1aa$var$React.useCallback((firstUpdate)=>{
        if (firstUpdate) isFirstSizing.current = false;
        if (isFirstSizing.current) return;
        const containerNode = layout.refs.container.current;
        const rootSize = $c7858fce4e25e1aa$var$selectors.rootSize(store.state);
        const rowsMeta = $c7858fce4e25e1aa$var$selectors.rowsMeta(store.state);
        // All the floating point dimensions should be rounded to .1 decimal places to avoid subpixel rendering issues
        // https://github.com/mui/mui-x/issues/9550#issuecomment-1619020477
        // https://github.com/mui/mui-x/issues/15721
        const scrollbarSize = $c7858fce4e25e1aa$var$measureScrollbarSize(containerNode, params.dimensions.scrollbarSize);
        const topContainerHeight = topPinnedHeight + rowsMeta.pinnedTopRowsTotalHeight;
        const bottomContainerHeight = bottomPinnedHeight + rowsMeta.pinnedBottomRowsTotalHeight;
        const contentSize = {
            width: columnsTotalWidth,
            height: (0, $b5eb928c08dc82e9$exports.roundToDecimalPlaces)(rowsMeta.currentPageTotalHeight, 1)
        };
        let viewportOuterSize;
        let viewportInnerSize;
        let hasScrollX = false;
        let hasScrollY = false;
        if (params.dimensions.autoHeight) {
            hasScrollY = false;
            hasScrollX = Math.round(columnsTotalWidth) > Math.round(rootSize.width);
            viewportOuterSize = {
                width: rootSize.width,
                height: topContainerHeight + bottomContainerHeight + contentSize.height
            };
            viewportInnerSize = {
                width: Math.max(0, viewportOuterSize.width - (hasScrollY ? scrollbarSize : 0)),
                height: Math.max(0, viewportOuterSize.height - (hasScrollX ? scrollbarSize : 0))
            };
        } else {
            viewportOuterSize = {
                width: rootSize.width,
                height: rootSize.height
            };
            viewportInnerSize = {
                width: Math.max(0, viewportOuterSize.width),
                height: Math.max(0, viewportOuterSize.height - topContainerHeight - bottomContainerHeight)
            };
            const content = contentSize;
            const container = viewportInnerSize;
            const hasScrollXIfNoYScrollBar = content.width > container.width;
            const hasScrollYIfNoXScrollBar = content.height > container.height;
            if (hasScrollXIfNoYScrollBar || hasScrollYIfNoXScrollBar) {
                hasScrollY = hasScrollYIfNoXScrollBar;
                hasScrollX = content.width + (hasScrollY ? scrollbarSize : 0) > container.width;
                // We recalculate the scroll y to consider the size of the x scrollbar.
                if (hasScrollX) hasScrollY = content.height + scrollbarSize > container.height;
            }
            if (hasScrollY) viewportInnerSize.width -= scrollbarSize;
            if (hasScrollX) viewportInnerSize.height -= scrollbarSize;
        }
        if (params.disableHorizontalScroll) hasScrollX = false;
        if (params.disableVerticalScroll) hasScrollY = false;
        const rowWidth = Math.max(viewportOuterSize.width, columnsTotalWidth + (hasScrollY ? scrollbarSize : 0));
        const minimumSize = {
            width: columnsTotalWidth,
            height: topContainerHeight + contentSize.height + bottomContainerHeight
        };
        const newDimensions = {
            isReady: true,
            root: rootSize,
            viewportOuterSize: viewportOuterSize,
            viewportInnerSize: viewportInnerSize,
            contentSize: contentSize,
            minimumSize: minimumSize,
            hasScrollX: hasScrollX,
            hasScrollY: hasScrollY,
            scrollbarSize: scrollbarSize,
            rowWidth: rowWidth,
            rowHeight: rowHeight,
            columnsTotalWidth: columnsTotalWidth,
            leftPinnedWidth: leftPinnedWidth,
            rightPinnedWidth: rightPinnedWidth,
            topContainerHeight: topContainerHeight,
            bottomContainerHeight: bottomContainerHeight,
            autoHeight: params.dimensions.autoHeight,
            minimalContentHeight: params.dimensions.minimalContentHeight
        };
        const prevDimensions = store.state.dimensions;
        if ((0, $a4d2c99ef8ba2460$exports.isDeepEqual)(prevDimensions, newDimensions)) return;
        store.update({
            dimensions: newDimensions
        });
        onResize?.(newDimensions.root);
    }, [
        store,
        layout.refs.container,
        params.dimensions.scrollbarSize,
        params.dimensions.autoHeight,
        params.dimensions.minimalContentHeight,
        params.disableHorizontalScroll,
        params.disableVerticalScroll,
        onResize,
        rowHeight,
        columnsTotalWidth,
        leftPinnedWidth,
        rightPinnedWidth,
        topPinnedHeight,
        bottomPinnedHeight
    ]);
    const { resizeThrottleMs: resizeThrottleMs } = params;
    const updateDimensionCallback = (0, $c7858fce4e25e1aa$var$_useEventCallback.default)(updateDimensions);
    const debouncedUpdateDimensions = $c7858fce4e25e1aa$var$React.useMemo(()=>resizeThrottleMs > 0 ? (0, $6be97efd7b623082$exports.throttle)(updateDimensionCallback, resizeThrottleMs) : undefined, [
        resizeThrottleMs,
        updateDimensionCallback
    ]);
    $c7858fce4e25e1aa$var$React.useEffect(()=>debouncedUpdateDimensions?.clear, [
        debouncedUpdateDimensions
    ]);
    (0, $c7858fce4e25e1aa$var$_useEnhancedEffect.default)(updateDimensions, [
        updateDimensions
    ]);
    (0, $c7858fce4e25e1aa$var$_useEnhancedEffect.default)(()=>{
        store.update({
            dimensions: (0, $c7858fce4e25e1aa$var$_extends2.default)({}, store.state.dimensions, {
                autoHeight: params.dimensions.autoHeight,
                minimalContentHeight: params.dimensions.minimalContentHeight
            })
        });
    }, [
        store,
        params.dimensions.autoHeight,
        params.dimensions.minimalContentHeight
    ]);
    const rowsMeta = $c7858fce4e25e1aa$var$useRowsMeta(store, params, updateDimensions);
    return {
        updateDimensions: updateDimensions,
        debouncedUpdateDimensions: debouncedUpdateDimensions,
        rowsMeta: rowsMeta
    };
}
function $c7858fce4e25e1aa$var$useRowsMeta(store, params, updateDimensions) {
    const heightCache = store.state.rowHeights;
    const { rows: rows, getRowHeight: getRowHeightProp, getRowSpacing: getRowSpacing, getEstimatedRowHeight: getEstimatedRowHeight } = params;
    const lastMeasuredRowIndex = $c7858fce4e25e1aa$var$React.useRef(-1);
    const hasRowWithAutoHeight = $c7858fce4e25e1aa$var$React.useRef(false);
    const isHeightMetaValid = $c7858fce4e25e1aa$var$React.useRef(false);
    const pinnedRows = params.pinnedRows;
    const rowHeight = (0, $66c3b1bd8ca83ba8$exports.useStore)(store, $c7858fce4e25e1aa$var$selectors.rowHeight);
    const getRowHeightEntry = (0, $c7858fce4e25e1aa$var$_useEventCallback.default)((rowId)=>{
        let entry = heightCache.get(rowId);
        if (entry === undefined) {
            entry = {
                content: store.state.dimensions.rowHeight,
                spacingTop: 0,
                spacingBottom: 0,
                detail: 0,
                autoHeight: false,
                needsFirstMeasurement: true
            };
            heightCache.set(rowId, entry);
        }
        return entry;
    });
    const { applyRowHeight: applyRowHeight } = params;
    const processHeightEntry = $c7858fce4e25e1aa$var$React.useCallback((row)=>{
        // HACK: rowHeight trails behind the most up-to-date value just enough to
        // mess the initial rowsMeta hydration :/
        $c7858fce4e25e1aa$var$eslintUseValue(rowHeight);
        const dimensions = $c7858fce4e25e1aa$var$selectors.dimensions(store.state);
        const baseRowHeight = dimensions.rowHeight;
        const entry = getRowHeightEntry(row.id);
        if (!getRowHeightProp) {
            entry.content = baseRowHeight;
            entry.needsFirstMeasurement = false;
        } else {
            const rowHeightFromUser = getRowHeightProp(row);
            if (rowHeightFromUser === 'auto') {
                if (entry.needsFirstMeasurement) {
                    const estimatedRowHeight = getEstimatedRowHeight ? getEstimatedRowHeight(row) : baseRowHeight;
                    // If the row was not measured yet use the estimated row height
                    entry.content = estimatedRowHeight ?? baseRowHeight;
                }
                hasRowWithAutoHeight.current = true;
                entry.autoHeight = true;
            } else {
                // Default back to base rowHeight if getRowHeight returns null value.
                entry.content = rowHeightFromUser ?? dimensions.rowHeight;
                entry.needsFirstMeasurement = false;
                entry.autoHeight = false;
            }
        }
        if (getRowSpacing) {
            const spacing = getRowSpacing(row);
            entry.spacingTop = spacing.top ?? 0;
            entry.spacingBottom = spacing.bottom ?? 0;
        } else {
            entry.spacingTop = 0;
            entry.spacingBottom = 0;
        }
        applyRowHeight?.(entry, row);
        return entry;
    }, [
        store,
        getRowHeightProp,
        getRowHeightEntry,
        getEstimatedRowHeight,
        rowHeight,
        getRowSpacing,
        applyRowHeight
    ]);
    const hydrateRowsMeta = $c7858fce4e25e1aa$var$React.useCallback(()=>{
        hasRowWithAutoHeight.current = false;
        const pinnedTopRowsTotalHeight = pinnedRows?.top.reduce((acc, row)=>{
            const entry = processHeightEntry(row);
            return acc + entry.content + entry.spacingTop + entry.spacingBottom + entry.detail;
        }, 0) ?? 0;
        const pinnedBottomRowsTotalHeight = pinnedRows?.bottom.reduce((acc, row)=>{
            const entry = processHeightEntry(row);
            return acc + entry.content + entry.spacingTop + entry.spacingBottom + entry.detail;
        }, 0) ?? 0;
        const positions = [];
        const currentPageTotalHeight = rows.reduce((acc, row)=>{
            positions.push(acc);
            const entry = processHeightEntry(row);
            const total = entry.content + entry.spacingTop + entry.spacingBottom + entry.detail;
            return acc + total;
        }, 0);
        if (!hasRowWithAutoHeight.current) // No row has height=auto, so all rows are already measured
        lastMeasuredRowIndex.current = Infinity;
        const didHeightsChange = pinnedTopRowsTotalHeight !== store.state.rowsMeta.pinnedTopRowsTotalHeight || pinnedBottomRowsTotalHeight !== store.state.rowsMeta.pinnedBottomRowsTotalHeight || currentPageTotalHeight !== store.state.rowsMeta.currentPageTotalHeight;
        const rowsMeta = {
            currentPageTotalHeight: currentPageTotalHeight,
            positions: positions,
            pinnedTopRowsTotalHeight: pinnedTopRowsTotalHeight,
            pinnedBottomRowsTotalHeight: pinnedBottomRowsTotalHeight
        };
        store.set('rowsMeta', rowsMeta);
        if (didHeightsChange) updateDimensions();
        isHeightMetaValid.current = true;
    }, [
        store,
        pinnedRows,
        rows,
        processHeightEntry,
        updateDimensions
    ]);
    const hydrateRowsMetaLatest = (0, $c7858fce4e25e1aa$var$_useEventCallback.default)(hydrateRowsMeta);
    const getRowHeight = (rowId)=>{
        return heightCache.get(rowId)?.content ?? $c7858fce4e25e1aa$var$selectors.rowHeight(store.state);
    };
    const storeRowHeightMeasurement = (id, height)=>{
        const entry = getRowHeightEntry(id);
        const didChange = entry.content !== height;
        entry.needsFirstMeasurement = false;
        entry.content = height;
        isHeightMetaValid.current && (isHeightMetaValid.current = !didChange);
    };
    const rowHasAutoHeight = (id)=>{
        return heightCache.get(id)?.autoHeight ?? false;
    };
    const getLastMeasuredRowIndex = ()=>{
        return lastMeasuredRowIndex.current;
    };
    const setLastMeasuredRowIndex = (index)=>{
        if (hasRowWithAutoHeight.current && index > lastMeasuredRowIndex.current) lastMeasuredRowIndex.current = index;
    };
    const resetRowHeights = ()=>{
        heightCache.clear();
        hydrateRowsMeta();
    };
    const resizeObserver = (0, $c7858fce4e25e1aa$var$_useLazyRef.default)(()=>typeof ResizeObserver === 'undefined' ? undefined : new ResizeObserver((entries)=>{
            for(let i = 0; i < entries.length; i += 1){
                const entry = entries[i];
                const height = entry.borderBoxSize && entry.borderBoxSize.length > 0 ? entry.borderBoxSize[0].blockSize : entry.contentRect.height;
                const rowId = entry.target.__mui_id;
                const focusedVirtualRowId = params.focusedVirtualCell?.()?.id;
                if (focusedVirtualRowId === rowId && height === 0) // Focused virtual row has 0 height.
                // We don't want to store it to avoid scroll jumping.
                // https://github.com/mui/mui-x/issues/14726
                return;
                storeRowHeightMeasurement(rowId, height);
            }
            if (!isHeightMetaValid.current) // Avoids "ResizeObserver loop completed with undelivered notifications" error
            requestAnimationFrame(()=>{
                hydrateRowsMetaLatest();
            });
        })).current;
    const observeRowHeight = (element, rowId)=>{
        element.__mui_id = rowId;
        resizeObserver?.observe(element);
        return ()=>resizeObserver?.unobserve(element);
    };
    // The effect is used to build the rows meta data - currentPageTotalHeight and positions.
    // Because of variable row height this is needed for the virtualization
    (0, $c7858fce4e25e1aa$var$_useEnhancedEffect.default)(()=>{
        hydrateRowsMeta();
    }, [
        hydrateRowsMeta
    ]);
    return {
        getRowHeight: getRowHeight,
        setLastMeasuredRowIndex: setLastMeasuredRowIndex,
        storeRowHeightMeasurement: storeRowHeightMeasurement,
        hydrateRowsMeta: hydrateRowsMeta,
        observeRowHeight: observeRowHeight,
        rowHasAutoHeight: rowHasAutoHeight,
        getRowHeightEntry: getRowHeightEntry,
        getLastMeasuredRowIndex: getLastMeasuredRowIndex,
        resetRowHeights: resetRowHeights
    };
}
function $c7858fce4e25e1aa$var$observeRootNode(node, store, setRootSize) {
    if (!node) return undefined;
    const bounds = node.getBoundingClientRect();
    const initialSize = {
        width: (0, $b5eb928c08dc82e9$exports.roundToDecimalPlaces)(bounds.width, 1),
        height: (0, $b5eb928c08dc82e9$exports.roundToDecimalPlaces)(bounds.height, 1)
    };
    if (store.state.rootSize === $48fd8d2da17ba217$exports.Size.EMPTY || !$48fd8d2da17ba217$exports.Size.equals(initialSize, store.state.rootSize)) setRootSize(initialSize);
    if (typeof ResizeObserver === 'undefined') return undefined;
    const observer = new ResizeObserver(([entry])=>{
        if (!entry) return;
        const rootSize = {
            width: (0, $b5eb928c08dc82e9$exports.roundToDecimalPlaces)(entry.contentRect.width, 1),
            height: (0, $b5eb928c08dc82e9$exports.roundToDecimalPlaces)(entry.contentRect.height, 1)
        };
        if (!$48fd8d2da17ba217$exports.Size.equals(rootSize, store.state.rootSize)) setRootSize(rootSize);
    });
    observer.observe(node);
    return ()=>{
        observer.disconnect();
    };
}
const $c7858fce4e25e1aa$var$scrollbarSizeCache = new WeakMap();
function $c7858fce4e25e1aa$var$measureScrollbarSize(element, scrollbarSize) {
    if (scrollbarSize !== undefined) return scrollbarSize;
    if (element === null) return 0;
    const cachedSize = $c7858fce4e25e1aa$var$scrollbarSizeCache.get(element);
    if (cachedSize !== undefined) return cachedSize;
    const doc = (0, $c7858fce4e25e1aa$var$_ownerDocument.default)(element);
    const scrollDiv = doc.createElement('div');
    scrollDiv.style.width = '99px';
    scrollDiv.style.height = '99px';
    scrollDiv.style.position = 'absolute';
    scrollDiv.style.overflow = 'scroll';
    scrollDiv.className = 'scrollDiv';
    element.appendChild(scrollDiv);
    const size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    element.removeChild(scrollDiv);
    $c7858fce4e25e1aa$var$scrollbarSizeCache.set(element, size);
    return size;
}
function $c7858fce4e25e1aa$var$eslintUseValue(_) {}


var $c930b9bb9e7ac1dd$exports = {};
"use strict";
Object.defineProperty($c930b9bb9e7ac1dd$exports, "__esModule", {
    value: true
});
$c930b9bb9e7ac1dd$exports.Keyboard = void 0;

var $07abedf34d4a8fef$exports = {};
"use strict";
Object.defineProperty($07abedf34d4a8fef$exports, "__esModule", {
    value: true
});
var $0cbdbd6cfbca1f04$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $0cbdbd6cfbca1f04$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $0cbdbd6cfbca1f04$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($0cbdbd6cfbca1f04$exports, "__esModule", {
    value: true
});
$0cbdbd6cfbca1f04$exports.LayoutList = $0cbdbd6cfbca1f04$exports.LayoutDataGridLegacy = $0cbdbd6cfbca1f04$exports.LayoutDataGrid = $0cbdbd6cfbca1f04$exports.Layout = void 0;

var $0cbdbd6cfbca1f04$var$_useForkRef = $0cbdbd6cfbca1f04$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $0cbdbd6cfbca1f04$var$_useEventCallback = $0cbdbd6cfbca1f04$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $0cbdbd6cfbca1f04$var$platform = $0cbdbd6cfbca1f04$require$_interopRequireWildcard((parcelRequire("44S7j")));


var $6f10b085fd1b645e$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $6f10b085fd1b645e$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $6f10b085fd1b645e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($6f10b085fd1b645e$exports, "__esModule", {
    value: true
});
$6f10b085fd1b645e$exports.Virtualization = $6f10b085fd1b645e$exports.EMPTY_RENDER_CONTEXT = void 0;
$6f10b085fd1b645e$exports.areRenderContextsEqual = $6f10b085fd1b645e$var$areRenderContextsEqual;
$6f10b085fd1b645e$exports.computeOffsetLeft = $6f10b085fd1b645e$var$computeOffsetLeft;
$6f10b085fd1b645e$exports.roundToDecimalPlaces = $6f10b085fd1b645e$var$roundToDecimalPlaces;

var $6f10b085fd1b645e$var$_extends2 = $6f10b085fd1b645e$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $6f10b085fd1b645e$var$React = $6f10b085fd1b645e$require$_interopRequireWildcard((parcelRequire("acw62")));

var $6f10b085fd1b645e$var$ReactDOM = $6f10b085fd1b645e$require$_interopRequireWildcard((parcelRequire("1u0KT")));

var $6f10b085fd1b645e$var$_useLazyRef = $6f10b085fd1b645e$require$_interopRequireDefault((parcelRequire("doV3C")));

var $6f10b085fd1b645e$var$_useTimeout = $6f10b085fd1b645e$require$_interopRequireDefault((parcelRequire("drY8V")));

var $6f10b085fd1b645e$var$_useEventCallback = $6f10b085fd1b645e$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $6f10b085fd1b645e$var$_useEnhancedEffect = $6f10b085fd1b645e$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $6f10b085fd1b645e$var$platform = $6f10b085fd1b645e$require$_interopRequireWildcard((parcelRequire("44S7j")));



var $6f10b085fd1b645e$var$_reactMajor = $6f10b085fd1b645e$require$_interopRequireDefault((parcelRequire("eKs5z")));



/* eslint-disable import/export, @typescript-eslint/no-redeclare */ const $6f10b085fd1b645e$var$clamp = (value, min, max)=>Math.max(min, Math.min(max, value));
const $6f10b085fd1b645e$var$MINIMUM_COLUMN_WIDTH = 50;
const $6f10b085fd1b645e$var$EMPTY_SCROLL_POSITION = {
    top: 0,
    left: 0
};
const $6f10b085fd1b645e$var$EMPTY_DETAIL_PANELS = Object.freeze(new Map());
const $6f10b085fd1b645e$var$EMPTY_RENDER_CONTEXT = $6f10b085fd1b645e$exports.EMPTY_RENDER_CONTEXT = {
    firstRowIndex: 0,
    lastRowIndex: 0,
    firstColumnIndex: 0,
    lastColumnIndex: 0
};
const $6f10b085fd1b645e$var$selectors = (()=>{
    const firstRowIndexSelector = (0, $66c3b1bd8ca83ba8$exports.createSelector)((state)=>state.virtualization.renderContext.firstRowIndex);
    return {
        store: (0, $66c3b1bd8ca83ba8$exports.createSelector)((state)=>state.virtualization),
        renderContext: (0, $66c3b1bd8ca83ba8$exports.createSelector)((state)=>state.virtualization.renderContext),
        enabledForRows: (0, $66c3b1bd8ca83ba8$exports.createSelector)((state)=>state.virtualization.enabledForRows),
        enabledForColumns: (0, $66c3b1bd8ca83ba8$exports.createSelector)((state)=>state.virtualization.enabledForColumns),
        offsetTop: (0, $66c3b1bd8ca83ba8$exports.createSelector)($c7858fce4e25e1aa$exports.Dimensions.selectors.rowPositions, firstRowIndexSelector, (rowPositions, firstRowIndex)=>rowPositions[firstRowIndex] ?? 0),
        context: (0, $66c3b1bd8ca83ba8$exports.createSelector)((state)=>state.virtualization.context),
        scrollPosition: (0, $66c3b1bd8ca83ba8$exports.createSelector)((state)=>state.virtualization.scrollPosition)
    };
})();
const $6f10b085fd1b645e$var$Virtualization = $6f10b085fd1b645e$exports.Virtualization = {
    initialize: $6f10b085fd1b645e$var$initializeState,
    use: $6f10b085fd1b645e$var$useVirtualization,
    selectors: $6f10b085fd1b645e$var$selectors
};
function $6f10b085fd1b645e$var$initializeState(params) {
    const state = {
        virtualization: (0, $6f10b085fd1b645e$var$_extends2.default)({
            enabled: !$6f10b085fd1b645e$var$platform.isJSDOM,
            enabledForRows: !$6f10b085fd1b645e$var$platform.isJSDOM,
            enabledForColumns: !$6f10b085fd1b645e$var$platform.isJSDOM,
            renderContext: $6f10b085fd1b645e$var$EMPTY_RENDER_CONTEXT,
            props: params.layout.constructor.elements.reduce((acc, key)=>(acc[key], acc), {}),
            context: {},
            scrollPosition: {
                current: $48fd8d2da17ba217$exports.ScrollPosition.EMPTY
            }
        }, params.initialState?.virtualization),
        // FIXME: refactor once the state shape is settled
        getters: null
    };
    return state;
}
/** APIs to override for colspan/rowspan */ function $6f10b085fd1b645e$var$useVirtualization(store, params, api) {
    const { layout: layout, dimensions: { rowHeight: rowHeight, columnsTotalWidth: columnsTotalWidth = 0 }, virtualization: { isRtl: isRtl = false, rowBufferPx: rowBufferPx = 150, columnBufferPx: columnBufferPx = 150 }, colspan: colspan, initialState: initialState, rows: rows, range: range, columns: columns, pinnedRows: pinnedRows = $d0e8401b7b465117$exports.PinnedRows.EMPTY, pinnedColumns: pinnedColumns = $d0e8401b7b465117$exports.PinnedColumns.EMPTY, onWheel: onWheel, onTouchMove: onTouchMove, onRenderContextChange: onRenderContextChange, onScrollChange: onScrollChange, scrollReset: scrollReset, renderRow: renderRow, renderInfiniteLoadingTrigger: renderInfiniteLoadingTrigger } = params;
    const hasBottomPinnedRows = pinnedRows.bottom.length > 0;
    const [panels, setPanels] = $6f10b085fd1b645e$var$React.useState($6f10b085fd1b645e$var$EMPTY_DETAIL_PANELS);
    const isUpdateScheduled = $6f10b085fd1b645e$var$React.useRef(false);
    const isRenderContextReady = $6f10b085fd1b645e$var$React.useRef(false);
    const renderContext = (0, $66c3b1bd8ca83ba8$exports.useStore)(store, $6f10b085fd1b645e$var$selectors.renderContext);
    const enabledForRows = (0, $66c3b1bd8ca83ba8$exports.useStore)(store, $6f10b085fd1b645e$var$selectors.enabledForRows);
    const enabledForColumns = (0, $66c3b1bd8ca83ba8$exports.useStore)(store, $6f10b085fd1b645e$var$selectors.enabledForColumns);
    const contentHeight = (0, $66c3b1bd8ca83ba8$exports.useStore)(store, $c7858fce4e25e1aa$exports.Dimensions.selectors.contentHeight);
    /*
   * Scroll context logic
   * ====================
   * We only render the cells contained in the `renderContext`. However, when the user starts scrolling the grid
   * in a direction, we want to render as many cells as possible in that direction, as to avoid presenting white
   * areas if the user scrolls too fast/far and the viewport ends up in a region we haven't rendered yet. To render
   * more cells, we store some offsets to add to the viewport in `scrollCache.buffer`. Those offsets make the render
   * context wider in the direction the user is going, but also makes the buffer around the viewport `0` for the
   * dimension (horizontal or vertical) in which the user is not scrolling. So if the normal viewport is 8 columns
   * wide, with a 1 column buffer (10 columns total), then we want it to be exactly 8 columns wide during vertical
   * scroll.
   * However, we don't want the rows in the old context to re-render from e.g. 10 columns to 8 columns, because that's
   * work that's not necessary. Thus we store the context at the start of the scroll in `frozenContext`, and the rows
   * that are part of this old context will keep their same render context as to avoid re-rendering.
   */ const scrollPosition = $6f10b085fd1b645e$var$React.useRef(initialState?.scroll ?? $6f10b085fd1b645e$var$EMPTY_SCROLL_POSITION);
    const ignoreNextScrollEvent = $6f10b085fd1b645e$var$React.useRef(false);
    const previousContextScrollPosition = $6f10b085fd1b645e$var$React.useRef($6f10b085fd1b645e$var$EMPTY_SCROLL_POSITION);
    const previousRowContext = $6f10b085fd1b645e$var$React.useRef($6f10b085fd1b645e$var$EMPTY_RENDER_CONTEXT);
    const scrollTimeout = (0, $6f10b085fd1b645e$var$_useTimeout.default)();
    const frozenContext = $6f10b085fd1b645e$var$React.useRef(undefined);
    const scrollCache = (0, $6f10b085fd1b645e$var$_useLazyRef.default)(()=>$6f10b085fd1b645e$var$createScrollCache(isRtl, rowBufferPx, columnBufferPx, rowHeight * 15, $6f10b085fd1b645e$var$MINIMUM_COLUMN_WIDTH * 6)).current;
    const updateRenderContext = $6f10b085fd1b645e$var$React.useCallback((nextRenderContext)=>{
        if (!$6f10b085fd1b645e$var$areRenderContextsEqual(nextRenderContext, store.state.virtualization.renderContext)) store.set('virtualization', (0, $6f10b085fd1b645e$var$_extends2.default)({}, store.state.virtualization, {
            renderContext: nextRenderContext,
            scrollPosition: {
                current: (0, $6f10b085fd1b645e$var$_extends2.default)({}, scrollPosition.current)
            }
        }));
        // The lazy-loading hook is listening to `renderedRowsIntervalChange`,
        // but only does something if we already have a render context, because
        // otherwise we would call an update directly on mount
        const isReady = $c7858fce4e25e1aa$exports.Dimensions.selectors.dimensions(store.state).isReady;
        const didRowsIntervalChange = nextRenderContext.firstRowIndex !== previousRowContext.current.firstRowIndex || nextRenderContext.lastRowIndex !== previousRowContext.current.lastRowIndex;
        if (isReady && didRowsIntervalChange) {
            previousRowContext.current = nextRenderContext;
            onRenderContextChange?.(nextRenderContext);
        }
        previousContextScrollPosition.current = scrollPosition.current;
    }, [
        store,
        onRenderContextChange
    ]);
    const triggerUpdateRenderContext = (0, $6f10b085fd1b645e$var$_useEventCallback.default)(()=>{
        const scroller = layout.refs.scroller.current;
        if (!scroller) return undefined;
        const dimensions = $c7858fce4e25e1aa$exports.Dimensions.selectors.dimensions(store.state);
        const maxScrollTop = Math.ceil(dimensions.contentSize.height - dimensions.viewportInnerSize.height);
        const maxScrollLeft = Math.ceil(dimensions.contentSize.width - dimensions.viewportInnerSize.width);
        // Clamp the scroll position to the viewport to avoid re-calculating the render context for scroll bounce
        const newScroll = {
            top: $6f10b085fd1b645e$var$clamp(scroller.scrollTop, 0, maxScrollTop),
            left: isRtl ? $6f10b085fd1b645e$var$clamp(scroller.scrollLeft, -Math.abs(maxScrollLeft), 0) : $6f10b085fd1b645e$var$clamp(scroller.scrollLeft, 0, maxScrollLeft)
        };
        const dx = newScroll.left - scrollPosition.current.left;
        const dy = newScroll.top - scrollPosition.current.top;
        const isScrolling = dx !== 0 || dy !== 0;
        scrollPosition.current = newScroll;
        const direction = isScrolling ? $48fd8d2da17ba217$exports.ScrollDirection.forDelta(dx, dy) : $48fd8d2da17ba217$exports.ScrollDirection.NONE;
        // Since previous render, we have scrolled...
        const rowScroll = Math.abs(scrollPosition.current.top - previousContextScrollPosition.current.top);
        const columnScroll = Math.abs(scrollPosition.current.left - previousContextScrollPosition.current.left);
        // PERF: use the computed minimum column width instead of a static one
        const didCrossThreshold = rowScroll >= rowHeight || columnScroll >= $6f10b085fd1b645e$var$MINIMUM_COLUMN_WIDTH;
        const didChangeDirection = scrollCache.direction !== direction;
        const shouldUpdate = didCrossThreshold || didChangeDirection;
        if (!shouldUpdate) {
            store.set('virtualization', (0, $6f10b085fd1b645e$var$_extends2.default)({}, store.state.virtualization, {
                scrollPosition: {
                    current: (0, $6f10b085fd1b645e$var$_extends2.default)({}, scrollPosition.current)
                }
            }));
            return renderContext;
        }
        // Render a new context
        if (didChangeDirection) switch(direction){
            case $48fd8d2da17ba217$exports.ScrollDirection.NONE:
            case $48fd8d2da17ba217$exports.ScrollDirection.LEFT:
            case $48fd8d2da17ba217$exports.ScrollDirection.RIGHT:
                frozenContext.current = undefined;
                break;
            default:
                frozenContext.current = renderContext;
                break;
        }
        scrollCache.direction = direction;
        scrollCache.buffer = $6f10b085fd1b645e$var$bufferForDirection(isRtl, direction, rowBufferPx, columnBufferPx, rowHeight * 15, $6f10b085fd1b645e$var$MINIMUM_COLUMN_WIDTH * 6);
        const inputs = $6f10b085fd1b645e$var$inputsSelector(store, params, api, enabledForRows, enabledForColumns);
        const nextRenderContext = $6f10b085fd1b645e$var$computeRenderContext(inputs, scrollPosition.current, scrollCache);
        if (!$6f10b085fd1b645e$var$areRenderContextsEqual(nextRenderContext, renderContext)) {
            // Prevents batching render context changes
            $6f10b085fd1b645e$var$ReactDOM.flushSync(()=>{
                updateRenderContext(nextRenderContext);
            });
            scrollTimeout.start(1000, triggerUpdateRenderContext);
        }
        return nextRenderContext;
    });
    const forceUpdateRenderContext = ()=>{
        // skip update if dimensions are not ready and virtualization is enabled
        if (!$c7858fce4e25e1aa$exports.Dimensions.selectors.dimensions(store.state).isReady && (enabledForRows || enabledForColumns)) return;
        const inputs = $6f10b085fd1b645e$var$inputsSelector(store, params, api, enabledForRows, enabledForColumns);
        const nextRenderContext = $6f10b085fd1b645e$var$computeRenderContext(inputs, scrollPosition.current, scrollCache);
        // Reset the frozen context when the render context changes, see the illustration in https://github.com/mui/mui-x/pull/12353
        frozenContext.current = undefined;
        updateRenderContext(nextRenderContext);
    };
    const forceUpdateRenderContextCallback = (0, $6f10b085fd1b645e$var$_useEventCallback.default)(forceUpdateRenderContext);
    (0, $66c3b1bd8ca83ba8$exports.useStoreEffect)(store, $c7858fce4e25e1aa$exports.Dimensions.selectors.dimensions, (previous, next)=>{
        if (next.isReady) forceUpdateRenderContext();
    });
    (0, $6f10b085fd1b645e$var$_useEnhancedEffect.default)(()=>{
        if (isUpdateScheduled.current) {
            forceUpdateRenderContext();
            isUpdateScheduled.current = false;
        }
    });
    const scheduleUpdateRenderContext = ()=>{
        isUpdateScheduled.current = true;
    };
    const handleScroll = (0, $6f10b085fd1b645e$var$_useEventCallback.default)(()=>{
        if (ignoreNextScrollEvent.current) {
            ignoreNextScrollEvent.current = false;
            return;
        }
        const nextRenderContext = triggerUpdateRenderContext();
        if (nextRenderContext) onScrollChange?.(scrollPosition.current, nextRenderContext);
    });
    /**
   * HACK: unstable_rowTree fixes the issue described below, but does it by tightly coupling this
   * section of code to the DataGrid's rowTree model. The `unstable_rowTree` param is a temporary
   * solution to decouple the code.
   */ const getRows = (rowParams = {}, unstable_rowTree)=>{
        if (!rowParams.rows && !range) return [];
        let baseRenderContext = renderContext;
        if (rowParams.renderContext) {
            baseRenderContext = rowParams.renderContext;
            baseRenderContext.firstColumnIndex = renderContext.firstColumnIndex;
            baseRenderContext.lastColumnIndex = renderContext.lastColumnIndex;
        }
        const isLastSection = !hasBottomPinnedRows && rowParams.position === undefined || hasBottomPinnedRows && rowParams.position === 'bottom';
        const isPinnedSection = rowParams.position !== undefined;
        let rowIndexOffset;
        switch(rowParams.position){
            case 'top':
                rowIndexOffset = 0;
                break;
            case 'bottom':
                rowIndexOffset = pinnedRows.top.length + rows.length;
                break;
            case undefined:
            default:
                rowIndexOffset = pinnedRows.top.length;
                break;
        }
        const rowModels = rowParams.rows ?? rows;
        const firstRowToRender = baseRenderContext.firstRowIndex;
        const lastRowToRender = Math.min(baseRenderContext.lastRowIndex, rowModels.length);
        const rowIndexes = rowParams.rows ? $6f10b085fd1b645e$var$createRange(0, rowParams.rows.length) : $6f10b085fd1b645e$var$createRange(firstRowToRender, lastRowToRender);
        let virtualRowIndex = -1;
        const focusedVirtualCell = params.focusedVirtualCell?.();
        if (!isPinnedSection && focusedVirtualCell) {
            if (focusedVirtualCell.rowIndex < firstRowToRender) {
                rowIndexes.unshift(focusedVirtualCell.rowIndex);
                virtualRowIndex = focusedVirtualCell.rowIndex;
            }
            if (focusedVirtualCell.rowIndex > lastRowToRender) {
                rowIndexes.push(focusedVirtualCell.rowIndex);
                virtualRowIndex = focusedVirtualCell.rowIndex;
            }
        }
        const rowElements = [];
        const columnPositions = $c7858fce4e25e1aa$exports.Dimensions.selectors.columnPositions(store.state, columns);
        rowIndexes.forEach((rowIndexInPage)=>{
            const { id: id, model: model } = rowModels[rowIndexInPage];
            // In certain cases, the state might already be updated and `params.rows` (which sets `rowModels`)
            // contains stale data.
            // In that case, skip any further row processing.
            // See:
            // - https://github.com/mui/mui-x/issues/16638
            // - https://github.com/mui/mui-x/issues/17022
            if (unstable_rowTree && !unstable_rowTree[id]) return;
            const rowIndex = (range?.firstRowIndex || 0) + rowIndexOffset + rowIndexInPage;
            // NOTE: This is an expensive feature, the colSpan code could be optimized.
            if (colspan?.enabled) {
                const minFirstColumn = pinnedColumns.left.length;
                const maxLastColumn = columns.length - pinnedColumns.right.length;
                api.calculateColSpan(id, minFirstColumn, maxLastColumn, columns);
                if (pinnedColumns.left.length > 0) api.calculateColSpan(id, 0, pinnedColumns.left.length, columns);
                if (pinnedColumns.right.length > 0) api.calculateColSpan(id, columns.length - pinnedColumns.right.length, columns.length, columns);
            }
            const baseRowHeight = !api.rowsMeta.rowHasAutoHeight(id) ? api.rowsMeta.getRowHeight(id) : 'auto';
            let isFirstVisible = false;
            if (rowParams.position === undefined) isFirstVisible = rowIndexInPage === 0;
            let isLastVisible = false;
            const isLastVisibleInSection = rowIndexInPage === rowModels.length - 1;
            if (isLastSection) {
                if (!isPinnedSection) {
                    const lastIndex = rows.length - 1;
                    const isLastVisibleRowIndex = rowIndexInPage === lastIndex;
                    if (isLastVisibleRowIndex) isLastVisible = true;
                } else isLastVisible = isLastVisibleInSection;
            }
            let currentRenderContext = baseRenderContext;
            if (frozenContext.current && rowIndexInPage >= frozenContext.current.firstRowIndex && rowIndexInPage < frozenContext.current.lastRowIndex) currentRenderContext = frozenContext.current;
            const isVirtualFocusRow = rowIndexInPage === virtualRowIndex;
            const isVirtualFocusColumn = focusedVirtualCell?.rowIndex === rowIndex;
            const offsetLeft = $6f10b085fd1b645e$var$computeOffsetLeft(columnPositions, currentRenderContext, pinnedColumns.left.length);
            const showBottomBorder = isLastVisibleInSection && rowParams.position === 'top';
            const firstColumnIndex = currentRenderContext.firstColumnIndex;
            const lastColumnIndex = currentRenderContext.lastColumnIndex;
            rowElements.push(renderRow({
                id: id,
                model: model,
                rowIndex: rowIndex,
                offsetLeft: offsetLeft,
                columnsTotalWidth: columnsTotalWidth,
                baseRowHeight: baseRowHeight,
                firstColumnIndex: firstColumnIndex,
                lastColumnIndex: lastColumnIndex,
                focusedColumnIndex: isVirtualFocusColumn ? focusedVirtualCell.columnIndex : undefined,
                isFirstVisible: isFirstVisible,
                isLastVisible: isLastVisible,
                isVirtualFocusRow: isVirtualFocusRow,
                showBottomBorder: showBottomBorder
            }));
            if (isVirtualFocusRow) return;
            const panel = panels.get(id);
            if (panel) rowElements.push(panel);
            if (rowParams.position === undefined && isLastVisibleInSection && renderInfiniteLoadingTrigger) rowElements.push(renderInfiniteLoadingTrigger(id));
        });
        return rowElements;
    };
    const scrollRestoreCallback = $6f10b085fd1b645e$var$React.useRef(null);
    (0, $6f10b085fd1b645e$var$_useEnhancedEffect.default)(()=>{
        if (!isRenderContextReady.current) return;
        forceUpdateRenderContextCallback();
    }, [
        enabledForColumns,
        enabledForRows,
        forceUpdateRenderContextCallback
    ]);
    (0, $6f10b085fd1b645e$var$_useEnhancedEffect.default)(()=>{
        if (layout.refs.scroller.current) layout.refs.scroller.current.scrollLeft = 0;
    }, [
        layout.refs.scroller,
        scrollReset
    ]);
    (0, $b66ef4c0407ba321$exports.useRunOnce)(renderContext !== $6f10b085fd1b645e$var$EMPTY_RENDER_CONTEXT, ()=>{
        onScrollChange?.(scrollPosition.current, renderContext);
        isRenderContextReady.current = true;
        if (initialState?.scroll && layout.refs.scroller.current) {
            const scroller = layout.refs.scroller.current;
            const { top: top, left: left } = initialState.scroll;
            const isScrollRestored = {
                top: !(top > 0),
                left: !(left > 0)
            };
            if (!isScrollRestored.left && columnsTotalWidth) {
                scroller.scrollLeft = left;
                isScrollRestored.left = true;
                ignoreNextScrollEvent.current = true;
            }
            // To restore the vertical scroll, we need to wait until the rows are available in the DOM (otherwise
            // there's nowhere to scroll). We still set the scrollTop to the initial value at this point in case
            // there already are rows rendered in the DOM, but we only confirm `isScrollRestored.top = true` in the
            // asynchronous callback below.
            if (!isScrollRestored.top && contentHeight) {
                scroller.scrollTop = top;
                ignoreNextScrollEvent.current = true;
            }
            if (!isScrollRestored.top || !isScrollRestored.left) scrollRestoreCallback.current = (columnsTotalWidthCurrent, contentHeightCurrent)=>{
                if (!isScrollRestored.left && columnsTotalWidthCurrent) {
                    scroller.scrollLeft = left;
                    isScrollRestored.left = true;
                    ignoreNextScrollEvent.current = true;
                }
                if (!isScrollRestored.top && contentHeightCurrent) {
                    scroller.scrollTop = top;
                    isScrollRestored.top = true;
                    ignoreNextScrollEvent.current = true;
                }
                if (isScrollRestored.left && isScrollRestored.top) scrollRestoreCallback.current = null;
            };
        }
    });
    (0, $66c3b1bd8ca83ba8$exports.useStoreEffect)(store, $c7858fce4e25e1aa$exports.Dimensions.selectors.dimensions, forceUpdateRenderContext);
    (0, $6f10b085fd1b645e$var$_useEnhancedEffect.default)(()=>{
        if (layout.refs.scroller) scrollRestoreCallback.current?.(columnsTotalWidth, contentHeight);
    }, [
        layout.refs.scroller,
        columnsTotalWidth,
        contentHeight
    ]);
    const isFirstSizing = $6f10b085fd1b645e$var$React.useRef(true);
    const containerRef = $6f10b085fd1b645e$var$useRefCallback((node)=>{
        layout.refs.container.current = node;
        const unsubscribe = (0, $c7858fce4e25e1aa$exports.observeRootNode)(node, store, (rootSize)=>{
            if (rootSize.width === 0 && rootSize.height === 0 && store.state.rootSize.height !== 0 && store.state.rootSize.width !== 0) return;
            store.state.rootSize = rootSize;
            if (isFirstSizing.current || !api.debouncedUpdateDimensions) {
                // We want to initialize the grid dimensions as soon as possible to avoid flickering
                api.updateDimensions(isFirstSizing.current);
                isFirstSizing.current = false;
            } else api.debouncedUpdateDimensions();
        });
        return ()=>{
            unsubscribe?.();
            layout.refs.container.current = null;
        };
    });
    const scrollerRef = $6f10b085fd1b645e$var$useRefCallback((node)=>{
        layout.refs.scroller.current = node;
        const opts = {
            passive: true
        };
        node.addEventListener('scroll', handleScroll, opts);
        node.addEventListener('wheel', onWheel, opts);
        node.addEventListener('touchmove', onTouchMove, opts);
        return ()=>{
            node.removeEventListener('scroll', handleScroll, opts);
            node.removeEventListener('wheel', onWheel, opts);
            node.removeEventListener('touchmove', onTouchMove, opts);
            layout.refs.scroller.current = null;
        };
    });
    const layoutParams = {
        containerRef: containerRef,
        scrollerRef: scrollerRef
    };
    const layoutAPI = layout.use(store, params, api, layoutParams);
    const getters = (0, $6f10b085fd1b645e$var$_extends2.default)({
        setPanels: setPanels,
        getRows: getRows,
        rows: params.rows
    }, layoutAPI);
    return (0, $6f10b085fd1b645e$var$_extends2.default)({
        getters: getters,
        setPanels: setPanels,
        forceUpdateRenderContext: forceUpdateRenderContext,
        scheduleUpdateRenderContext: scheduleUpdateRenderContext
    }, $6f10b085fd1b645e$var$createSpanningAPI());
}
function $6f10b085fd1b645e$var$useRefCallback(fn) {
    const refCleanup = $6f10b085fd1b645e$var$React.useRef(undefined);
    const refCallback = (0, $6f10b085fd1b645e$var$_useEventCallback.default)((node)=>{
        if (!node) {
            // Cleanup for R18
            refCleanup.current?.();
            return;
        }
        refCleanup.current = fn(node);
        if ($6f10b085fd1b645e$var$_reactMajor.default >= 19) /* eslint-disable-next-line consistent-return */ return refCleanup.current;
    });
    return refCallback;
}
function $6f10b085fd1b645e$var$inputsSelector(store, params, api, enabledForRows, enabledForColumns) {
    const dimensions = $c7858fce4e25e1aa$exports.Dimensions.selectors.dimensions(store.state);
    const rows = params.rows;
    const range = params.range;
    const columns = params.columns;
    const hiddenCellsOriginMap = api.getHiddenCellsOrigin();
    const lastRowId = params.rows.at(-1)?.id;
    const lastColumn = columns.at(-1);
    return {
        api: api,
        enabledForRows: enabledForRows,
        enabledForColumns: enabledForColumns,
        autoHeight: dimensions.autoHeight,
        rowBufferPx: params.virtualization.rowBufferPx,
        columnBufferPx: params.virtualization.columnBufferPx,
        leftPinnedWidth: dimensions.leftPinnedWidth,
        columnsTotalWidth: dimensions.columnsTotalWidth,
        viewportInnerWidth: dimensions.viewportInnerSize.width,
        viewportInnerHeight: dimensions.viewportInnerSize.height,
        lastRowHeight: lastRowId !== undefined ? api.rowsMeta.getRowHeight(lastRowId) : 0,
        lastColumnWidth: lastColumn?.computedWidth ?? 0,
        rowsMeta: $c7858fce4e25e1aa$exports.Dimensions.selectors.rowsMeta(store.state),
        columnPositions: $c7858fce4e25e1aa$exports.Dimensions.selectors.columnPositions(store.state, params.columns),
        rows: rows,
        range: range,
        pinnedColumns: params.pinnedColumns,
        columns: columns,
        hiddenCellsOriginMap: hiddenCellsOriginMap,
        virtualizeColumnsWithAutoRowHeight: params.virtualizeColumnsWithAutoRowHeight
    };
}
function $6f10b085fd1b645e$var$computeRenderContext(inputs, scrollPosition, scrollCache) {
    const renderContext = {
        firstRowIndex: 0,
        lastRowIndex: inputs.rows.length,
        firstColumnIndex: 0,
        lastColumnIndex: inputs.columns.length
    };
    const { top: top, left: left } = scrollPosition;
    const realLeft = Math.abs(left) + inputs.leftPinnedWidth;
    if (inputs.enabledForRows) {
        // Clamp the value because the search may return an index out of bounds.
        // In the last index, this is not needed because Array.slice doesn't include it.
        let firstRowIndex = Math.min($6f10b085fd1b645e$var$getNearestIndexToRender(inputs, top, {
            atStart: true,
            lastPosition: inputs.rowsMeta.positions[inputs.rowsMeta.positions.length - 1] + inputs.lastRowHeight
        }), inputs.rowsMeta.positions.length - 1);
        // If any of the cells in the `firstRowIndex` is hidden due to an extended row span,
        // Make sure the row from where the rowSpan is originated is visible.
        const rowSpanHiddenCellOrigin = inputs.hiddenCellsOriginMap[firstRowIndex];
        if (rowSpanHiddenCellOrigin) {
            const minSpannedRowIndex = Math.min(...Object.values(rowSpanHiddenCellOrigin));
            firstRowIndex = Math.min(firstRowIndex, minSpannedRowIndex);
        }
        const lastRowIndex = inputs.autoHeight ? firstRowIndex + inputs.rows.length : $6f10b085fd1b645e$var$getNearestIndexToRender(inputs, top + inputs.viewportInnerHeight);
        renderContext.firstRowIndex = firstRowIndex;
        renderContext.lastRowIndex = lastRowIndex;
    }
    // XXX
    // if (inputs.listView) {
    //   return {
    //     ...renderContext,
    //     lastColumnIndex: 1,
    //   };
    // }
    if (inputs.enabledForColumns) {
        let firstColumnIndex = 0;
        let lastColumnIndex = inputs.columnPositions.length;
        let hasRowWithAutoHeight = false;
        const [firstRowToRender, lastRowToRender] = $6f10b085fd1b645e$var$getIndexesToRender({
            firstIndex: renderContext.firstRowIndex,
            lastIndex: renderContext.lastRowIndex,
            minFirstIndex: 0,
            maxLastIndex: inputs.rows.length,
            bufferBefore: scrollCache.buffer.rowBefore,
            bufferAfter: scrollCache.buffer.rowAfter,
            positions: inputs.rowsMeta.positions,
            lastSize: inputs.lastRowHeight
        });
        if (!inputs.virtualizeColumnsWithAutoRowHeight) for(let i = firstRowToRender; i < lastRowToRender && !hasRowWithAutoHeight; i += 1){
            const row = inputs.rows[i];
            hasRowWithAutoHeight = inputs.api.rowsMeta.rowHasAutoHeight(row.id);
        }
        if (!hasRowWithAutoHeight || inputs.virtualizeColumnsWithAutoRowHeight) {
            firstColumnIndex = $6f10b085fd1b645e$var$binarySearch(realLeft, inputs.columnPositions, {
                atStart: true,
                lastPosition: inputs.columnsTotalWidth
            });
            lastColumnIndex = $6f10b085fd1b645e$var$binarySearch(realLeft + inputs.viewportInnerWidth, inputs.columnPositions);
        }
        renderContext.firstColumnIndex = firstColumnIndex;
        renderContext.lastColumnIndex = lastColumnIndex;
    }
    const actualRenderContext = $6f10b085fd1b645e$var$deriveRenderContext(inputs, renderContext, scrollCache);
    return actualRenderContext;
}
function $6f10b085fd1b645e$var$getNearestIndexToRender(inputs, offset, options) {
    const lastMeasuredIndexRelativeToAllRows = inputs.api.rowsMeta.getLastMeasuredRowIndex();
    let allRowsMeasured = lastMeasuredIndexRelativeToAllRows === Infinity;
    if (inputs.range?.lastRowIndex && !allRowsMeasured) // Check if all rows in this page are already measured
    allRowsMeasured = lastMeasuredIndexRelativeToAllRows >= inputs.range.lastRowIndex;
    const lastMeasuredIndexRelativeToCurrentPage = $6f10b085fd1b645e$var$clamp(lastMeasuredIndexRelativeToAllRows - (inputs.range?.firstRowIndex || 0), 0, inputs.rowsMeta.positions.length);
    if (allRowsMeasured || inputs.rowsMeta.positions[lastMeasuredIndexRelativeToCurrentPage] >= offset) // If all rows were measured (when no row has "auto" as height) or all rows before the offset
    // were measured, then use a binary search because it's faster.
    return $6f10b085fd1b645e$var$binarySearch(offset, inputs.rowsMeta.positions, options);
    // Otherwise, use an exponential search.
    // If rows have "auto" as height, their positions will be based on estimated heights.
    // In this case, we can skip several steps until we find a position higher than the offset.
    // Inspired by https://github.com/bvaughn/react-virtualized/blob/master/source/Grid/utils/CellSizeAndPositionManager.js
    return $6f10b085fd1b645e$var$exponentialSearch(offset, inputs.rowsMeta.positions, lastMeasuredIndexRelativeToCurrentPage, options);
}
/**
 * Accepts as input a raw render context (the area visible in the viewport) and adds
 * computes the actual render context based on pinned elements, buffer dimensions and
 * spanning.
 */ function $6f10b085fd1b645e$var$deriveRenderContext(inputs, nextRenderContext, scrollCache) {
    const [firstRowToRender, lastRowToRender] = $6f10b085fd1b645e$var$getIndexesToRender({
        firstIndex: nextRenderContext.firstRowIndex,
        lastIndex: nextRenderContext.lastRowIndex,
        minFirstIndex: 0,
        maxLastIndex: inputs.rows.length,
        bufferBefore: scrollCache.buffer.rowBefore,
        bufferAfter: scrollCache.buffer.rowAfter,
        positions: inputs.rowsMeta.positions,
        lastSize: inputs.lastRowHeight
    });
    const [initialFirstColumnToRender, lastColumnToRender] = $6f10b085fd1b645e$var$getIndexesToRender({
        firstIndex: nextRenderContext.firstColumnIndex,
        lastIndex: nextRenderContext.lastColumnIndex,
        minFirstIndex: inputs.pinnedColumns?.left.length ?? 0,
        maxLastIndex: inputs.columns.length - (inputs.pinnedColumns?.right.length ?? 0),
        bufferBefore: scrollCache.buffer.columnBefore,
        bufferAfter: scrollCache.buffer.columnAfter,
        positions: inputs.columnPositions,
        lastSize: inputs.lastColumnWidth
    });
    const firstColumnToRender = $6f10b085fd1b645e$var$getFirstNonSpannedColumnToRender({
        api: inputs.api,
        firstColumnToRender: initialFirstColumnToRender,
        firstRowToRender: firstRowToRender,
        lastRowToRender: lastRowToRender,
        visibleRows: inputs.rows
    });
    return {
        firstRowIndex: firstRowToRender,
        lastRowIndex: lastRowToRender,
        firstColumnIndex: firstColumnToRender,
        lastColumnIndex: lastColumnToRender
    };
}
/**
 * Use binary search to avoid looping through all possible positions.
 * The `options.atStart` provides the possibility to match for the first element that
 * intersects the screen, even if said element's start position is before `offset`. In
 * other words, we search for `offset + width`.
 */ function $6f10b085fd1b645e$var$binarySearch(offset, positions, options, sliceStart = 0, sliceEnd = positions.length) {
    if (positions.length <= 0) return -1;
    if (sliceStart >= sliceEnd) return sliceStart;
    const pivot = sliceStart + Math.floor((sliceEnd - sliceStart) / 2);
    const position = positions[pivot];
    let isBefore;
    if (options?.atStart) {
        const width = (pivot === positions.length - 1 ? options.lastPosition : positions[pivot + 1]) - position;
        isBefore = offset - width < position;
    } else isBefore = offset <= position;
    return isBefore ? $6f10b085fd1b645e$var$binarySearch(offset, positions, options, sliceStart, pivot) : $6f10b085fd1b645e$var$binarySearch(offset, positions, options, pivot + 1, sliceEnd);
}
function $6f10b085fd1b645e$var$exponentialSearch(offset, positions, index, options) {
    let interval = 1;
    while(index < positions.length && Math.abs(positions[index]) < offset){
        index += interval;
        interval *= 2;
    }
    return $6f10b085fd1b645e$var$binarySearch(offset, positions, options, Math.floor(index / 2), Math.min(index, positions.length));
}
function $6f10b085fd1b645e$var$getIndexesToRender({ firstIndex: firstIndex, lastIndex: lastIndex, bufferBefore: bufferBefore, bufferAfter: bufferAfter, minFirstIndex: minFirstIndex, maxLastIndex: maxLastIndex, positions: positions, lastSize: lastSize }) {
    const firstPosition = positions[firstIndex] - bufferBefore;
    const lastPosition = positions[lastIndex] + bufferAfter;
    const firstIndexPadded = $6f10b085fd1b645e$var$binarySearch(firstPosition, positions, {
        atStart: true,
        lastPosition: positions[positions.length - 1] + lastSize
    });
    const lastIndexPadded = $6f10b085fd1b645e$var$binarySearch(lastPosition, positions);
    return [
        $6f10b085fd1b645e$var$clamp(firstIndexPadded, minFirstIndex, maxLastIndex),
        $6f10b085fd1b645e$var$clamp(lastIndexPadded, minFirstIndex, maxLastIndex)
    ];
}
function $6f10b085fd1b645e$var$areRenderContextsEqual(context1, context2) {
    if (context1 === context2) return true;
    return context1.firstRowIndex === context2.firstRowIndex && context1.lastRowIndex === context2.lastRowIndex && context1.firstColumnIndex === context2.firstColumnIndex && context1.lastColumnIndex === context2.lastColumnIndex;
}
function $6f10b085fd1b645e$var$computeOffsetLeft(columnPositions, renderContext, pinnedLeftLength) {
    const left = (columnPositions[renderContext.firstColumnIndex] ?? 0) - (columnPositions[pinnedLeftLength] ?? 0);
    return Math.abs(left);
}
function $6f10b085fd1b645e$var$bufferForDirection(isRtl, direction, rowBufferPx, columnBufferPx, verticalBuffer, horizontalBuffer) {
    if (isRtl) switch(direction){
        case $48fd8d2da17ba217$exports.ScrollDirection.LEFT:
            direction = $48fd8d2da17ba217$exports.ScrollDirection.RIGHT;
            break;
        case $48fd8d2da17ba217$exports.ScrollDirection.RIGHT:
            direction = $48fd8d2da17ba217$exports.ScrollDirection.LEFT;
            break;
        default:
    }
    switch(direction){
        case $48fd8d2da17ba217$exports.ScrollDirection.NONE:
            return {
                rowAfter: rowBufferPx,
                rowBefore: rowBufferPx,
                columnAfter: columnBufferPx,
                columnBefore: columnBufferPx
            };
        case $48fd8d2da17ba217$exports.ScrollDirection.LEFT:
            return {
                rowAfter: 0,
                rowBefore: 0,
                columnAfter: 0,
                columnBefore: horizontalBuffer
            };
        case $48fd8d2da17ba217$exports.ScrollDirection.RIGHT:
            return {
                rowAfter: 0,
                rowBefore: 0,
                columnAfter: horizontalBuffer,
                columnBefore: 0
            };
        case $48fd8d2da17ba217$exports.ScrollDirection.UP:
            return {
                rowAfter: 0,
                rowBefore: verticalBuffer,
                columnAfter: 0,
                columnBefore: 0
            };
        case $48fd8d2da17ba217$exports.ScrollDirection.DOWN:
            return {
                rowAfter: verticalBuffer,
                rowBefore: 0,
                columnAfter: 0,
                columnBefore: 0
            };
        default:
            // eslint unable to figure out enum exhaustiveness
            throw new Error('unreachable');
    }
}
function $6f10b085fd1b645e$var$createScrollCache(isRtl, rowBufferPx, columnBufferPx, verticalBuffer, horizontalBuffer) {
    return {
        direction: $48fd8d2da17ba217$exports.ScrollDirection.NONE,
        buffer: $6f10b085fd1b645e$var$bufferForDirection(isRtl, $48fd8d2da17ba217$exports.ScrollDirection.NONE, rowBufferPx, columnBufferPx, verticalBuffer, horizontalBuffer)
    };
}
function $6f10b085fd1b645e$var$createRange(from, to) {
    return Array.from({
        length: to - from
    }).map((_, i)=>from + i);
}
function $6f10b085fd1b645e$var$getFirstNonSpannedColumnToRender({ api: api, firstColumnToRender: firstColumnToRender, firstRowToRender: firstRowToRender, lastRowToRender: lastRowToRender, visibleRows: visibleRows }) {
    let firstNonSpannedColumnToRender = firstColumnToRender;
    let foundStableColumn = false;
    // Keep checking columns until we find one that's not spanned in any visible row
    while(!foundStableColumn && firstNonSpannedColumnToRender >= 0){
        foundStableColumn = true;
        for(let i = firstRowToRender; i < lastRowToRender; i += 1){
            const row = visibleRows[i];
            if (row) {
                const rowId = visibleRows[i].id;
                const cellColSpanInfo = api.getCellColSpanInfo(rowId, firstNonSpannedColumnToRender);
                if (cellColSpanInfo && cellColSpanInfo.spannedByColSpan && cellColSpanInfo.leftVisibleCellIndex < firstNonSpannedColumnToRender) {
                    firstNonSpannedColumnToRender = cellColSpanInfo.leftVisibleCellIndex;
                    foundStableColumn = false;
                    break; // Check the new column index against the visible rows, because it might be spanned
                }
            }
        }
    }
    return firstNonSpannedColumnToRender;
}
/** Placeholder API functions for colspan & rowspan to re-implement */ function $6f10b085fd1b645e$var$createSpanningAPI() {
    const getCellColSpanInfo = ()=>{
        throw new Error('Unimplemented: colspan feature is required');
    };
    const calculateColSpan = ()=>{
        throw new Error('Unimplemented: colspan feature is required');
    };
    const getHiddenCellsOrigin = ()=>{
        throw new Error('Unimplemented: rowspan feature is required');
    };
    return {
        getCellColSpanInfo: getCellColSpanInfo,
        calculateColSpan: calculateColSpan,
        getHiddenCellsOrigin: getHiddenCellsOrigin
    };
}
function $6f10b085fd1b645e$var$roundToDecimalPlaces(value, decimals) {
    return Math.round(value * 10 ** decimals) / 10 ** decimals;
}


/* eslint-disable react-hooks/rules-of-hooks */ class $0cbdbd6cfbca1f04$var$Layout {
    static elements = [
        'scroller',
        'container'
    ];
    constructor(refs){
        this.refs = refs;
    }
    refSetter(name) {
        return (node)=>{
            if (node && this.refs[name].current !== node) this.refs[name].current = node;
        };
    }
}
$0cbdbd6cfbca1f04$exports.Layout = $0cbdbd6cfbca1f04$var$Layout;
class $0cbdbd6cfbca1f04$var$LayoutDataGrid extends $0cbdbd6cfbca1f04$var$Layout {
    static elements = [
        'scroller',
        'container',
        'content',
        'positioner',
        'scrollbarVertical',
        'scrollbarHorizontal'
    ];
    use(store, _params, _api, layoutParams) {
        const { scrollerRef: scrollerRef, containerRef: containerRef } = layoutParams;
        const scrollbarVerticalRef = (0, $0cbdbd6cfbca1f04$var$_useEventCallback.default)(this.refSetter('scrollbarVertical'));
        const scrollbarHorizontalRef = (0, $0cbdbd6cfbca1f04$var$_useEventCallback.default)(this.refSetter('scrollbarHorizontal'));
        store.state.virtualization.context = {
            scrollerRef: scrollerRef,
            containerRef: containerRef,
            scrollbarVerticalRef: scrollbarVerticalRef,
            scrollbarHorizontalRef: scrollbarHorizontalRef
        };
    }
    static selectors = {
        containerProps: (0, $66c3b1bd8ca83ba8$exports.createSelectorMemoized)($6f10b085fd1b645e$exports.Virtualization.selectors.context, (context)=>({
                ref: context.containerRef
            })),
        scrollerProps: (0, $66c3b1bd8ca83ba8$exports.createSelectorMemoized)($6f10b085fd1b645e$exports.Virtualization.selectors.context, $c7858fce4e25e1aa$exports.Dimensions.selectors.autoHeight, $c7858fce4e25e1aa$exports.Dimensions.selectors.needsHorizontalScrollbar, (context, autoHeight, needsHorizontalScrollbar)=>({
                ref: context.scrollerRef,
                style: {
                    overflowX: !needsHorizontalScrollbar ? 'hidden' : undefined,
                    overflowY: autoHeight ? 'hidden' : undefined
                },
                role: 'presentation',
                // `tabIndex` shouldn't be used along role=presentation, but it fixes a Firefox bug
                // https://github.com/mui/mui-x/pull/13891#discussion_r1683416024
                tabIndex: $0cbdbd6cfbca1f04$var$platform.isFirefox ? -1 : undefined
            })),
        contentProps: (0, $66c3b1bd8ca83ba8$exports.createSelectorMemoized)($c7858fce4e25e1aa$exports.Dimensions.selectors.contentHeight, $c7858fce4e25e1aa$exports.Dimensions.selectors.minimalContentHeight, $c7858fce4e25e1aa$exports.Dimensions.selectors.columnsTotalWidth, $c7858fce4e25e1aa$exports.Dimensions.selectors.needsHorizontalScrollbar, (contentHeight, minimalContentHeight, columnsTotalWidth, needsHorizontalScrollbar)=>({
                style: {
                    width: needsHorizontalScrollbar ? columnsTotalWidth : 'auto',
                    flexBasis: contentHeight === 0 ? minimalContentHeight : contentHeight,
                    flexShrink: 0
                },
                role: 'presentation'
            })),
        positionerProps: (0, $66c3b1bd8ca83ba8$exports.createSelectorMemoized)($6f10b085fd1b645e$exports.Virtualization.selectors.offsetTop, (offsetTop)=>({
                style: {
                    transform: `translate3d(0, ${offsetTop}px, 0)`
                }
            })),
        scrollbarHorizontalProps: (0, $66c3b1bd8ca83ba8$exports.createSelectorMemoized)($6f10b085fd1b645e$exports.Virtualization.selectors.context, $6f10b085fd1b645e$exports.Virtualization.selectors.scrollPosition, (context, scrollPosition)=>({
                ref: context.scrollbarHorizontalRef,
                scrollPosition: scrollPosition
            })),
        scrollbarVerticalProps: (0, $66c3b1bd8ca83ba8$exports.createSelectorMemoized)($6f10b085fd1b645e$exports.Virtualization.selectors.context, $6f10b085fd1b645e$exports.Virtualization.selectors.scrollPosition, (context, scrollPosition)=>({
                ref: context.scrollbarVerticalRef,
                scrollPosition: scrollPosition
            })),
        scrollAreaProps: (0, $66c3b1bd8ca83ba8$exports.createSelectorMemoized)($6f10b085fd1b645e$exports.Virtualization.selectors.scrollPosition, (scrollPosition)=>({
                scrollPosition: scrollPosition
            }))
    };
}
// The current virtualizer API is exposed on one of the DataGrid slots, so we need to keep
// the old API for backward compatibility. This API prevents using fine-grained reactivity
// as all props are returned in a single object, so everything re-renders on any change.
//
// TODO(v9): Remove the legacy API.
$0cbdbd6cfbca1f04$exports.LayoutDataGrid = $0cbdbd6cfbca1f04$var$LayoutDataGrid;
class $0cbdbd6cfbca1f04$var$LayoutDataGridLegacy extends $0cbdbd6cfbca1f04$var$LayoutDataGrid {
    use(store, _params, _api, layoutParams) {
        super.use(store, _params, _api, layoutParams);
        const containerProps = store.use($0cbdbd6cfbca1f04$var$LayoutDataGrid.selectors.containerProps);
        const scrollerProps = store.use($0cbdbd6cfbca1f04$var$LayoutDataGrid.selectors.scrollerProps);
        const contentProps = store.use($0cbdbd6cfbca1f04$var$LayoutDataGrid.selectors.contentProps);
        const positionerProps = store.use($0cbdbd6cfbca1f04$var$LayoutDataGrid.selectors.positionerProps);
        const scrollbarVerticalProps = store.use($0cbdbd6cfbca1f04$var$LayoutDataGrid.selectors.scrollbarVerticalProps);
        const scrollbarHorizontalProps = store.use($0cbdbd6cfbca1f04$var$LayoutDataGrid.selectors.scrollbarHorizontalProps);
        const scrollAreaProps = store.use($0cbdbd6cfbca1f04$var$LayoutDataGrid.selectors.scrollAreaProps);
        return {
            getContainerProps: ()=>containerProps,
            getScrollerProps: ()=>scrollerProps,
            getContentProps: ()=>contentProps,
            getPositionerProps: ()=>positionerProps,
            getScrollbarVerticalProps: ()=>scrollbarVerticalProps,
            getScrollbarHorizontalProps: ()=>scrollbarHorizontalProps,
            getScrollAreaProps: ()=>scrollAreaProps
        };
    }
}
$0cbdbd6cfbca1f04$exports.LayoutDataGridLegacy = $0cbdbd6cfbca1f04$var$LayoutDataGridLegacy;
class $0cbdbd6cfbca1f04$var$LayoutList extends $0cbdbd6cfbca1f04$var$Layout {
    static elements = [
        'scroller',
        'container',
        'content',
        'positioner'
    ];
    use(store, _params, _api, layoutParams) {
        const { scrollerRef: scrollerRef, containerRef: containerRef } = layoutParams;
        const mergedRef = (0, $0cbdbd6cfbca1f04$var$_useForkRef.default)(scrollerRef, containerRef);
        store.state.virtualization.context = {
            mergedRef: mergedRef
        };
    }
    static selectors = {
        containerProps: (0, $66c3b1bd8ca83ba8$exports.createSelectorMemoized)($6f10b085fd1b645e$exports.Virtualization.selectors.context, $c7858fce4e25e1aa$exports.Dimensions.selectors.autoHeight, $c7858fce4e25e1aa$exports.Dimensions.selectors.needsHorizontalScrollbar, (context, autoHeight, needsHorizontalScrollbar)=>({
                ref: context.mergedRef,
                style: {
                    overflowX: !needsHorizontalScrollbar ? 'hidden' : undefined,
                    overflowY: autoHeight ? 'hidden' : undefined,
                    position: 'relative'
                },
                role: 'presentation',
                // `tabIndex` shouldn't be used along role=presentation, but it fixes a Firefox bug
                // https://github.com/mui/mui-x/pull/13891#discussion_r1683416024
                tabIndex: $0cbdbd6cfbca1f04$var$platform.isFirefox ? -1 : undefined
            })),
        contentProps: (0, $66c3b1bd8ca83ba8$exports.createSelectorMemoized)($c7858fce4e25e1aa$exports.Dimensions.selectors.contentHeight, (contentHeight)=>{
            return {
                style: {
                    position: 'absolute',
                    display: 'inline-block',
                    width: '100%',
                    height: contentHeight,
                    top: 0,
                    left: 0,
                    zIndex: -1
                },
                role: 'presentation'
            };
        }),
        positionerProps: (0, $66c3b1bd8ca83ba8$exports.createSelectorMemoized)($6f10b085fd1b645e$exports.Virtualization.selectors.offsetTop, (offsetTop)=>({
                style: {
                    height: offsetTop
                }
            }))
    };
}
$0cbdbd6cfbca1f04$exports.LayoutList = $0cbdbd6cfbca1f04$var$LayoutList;


Object.keys($0cbdbd6cfbca1f04$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $07abedf34d4a8fef$exports && $07abedf34d4a8fef$exports[key] === $0cbdbd6cfbca1f04$exports[key]) return;
    Object.defineProperty($07abedf34d4a8fef$exports, key, {
        enumerable: true,
        get: function() {
            return $0cbdbd6cfbca1f04$exports[key];
        }
    });
});

Object.keys($6f10b085fd1b645e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $07abedf34d4a8fef$exports && $07abedf34d4a8fef$exports[key] === $6f10b085fd1b645e$exports[key]) return;
    Object.defineProperty($07abedf34d4a8fef$exports, key, {
        enumerable: true,
        get: function() {
            return $6f10b085fd1b645e$exports[key];
        }
    });
});


/* eslint-disable import/export, @typescript-eslint/no-redeclare */ const $c930b9bb9e7ac1dd$var$selectors = {};
const $c930b9bb9e7ac1dd$var$Keyboard = $c930b9bb9e7ac1dd$exports.Keyboard = {
    initialize: $c930b9bb9e7ac1dd$var$initializeState,
    use: $c930b9bb9e7ac1dd$var$useKeyboard,
    selectors: $c930b9bb9e7ac1dd$var$selectors
};
function $c930b9bb9e7ac1dd$var$initializeState(_params) {
    return {};
}
function $c930b9bb9e7ac1dd$var$useKeyboard(store, params, _api) {
    const getViewportPageSize = ()=>{
        const dimensions = $c7858fce4e25e1aa$exports.Dimensions.selectors.dimensions(store.state);
        if (!dimensions.isReady) return 0;
        // TODO: Use a combination of scrollTop, dimensions.viewportInnerSize.height and rowsMeta.possitions
        // to find out the maximum number of rows that can fit in the visible part of the grid
        if (params.getRowHeight) {
            const renderContext = $07abedf34d4a8fef$exports.Virtualization.selectors.renderContext(store.state);
            const viewportPageSize = renderContext.lastRowIndex - renderContext.firstRowIndex;
            return Math.min(viewportPageSize - 1, params.rows.length);
        }
        const maximumPageSizeWithoutScrollBar = Math.floor(dimensions.viewportInnerSize.height / dimensions.rowHeight);
        return Math.min(maximumPageSizeWithoutScrollBar, params.rows.length);
    };
    return {
        getViewportPageSize: getViewportPageSize
    };
}


var $22a64ccc246ff905$exports = {};
"use strict";
Object.defineProperty($22a64ccc246ff905$exports, "__esModule", {
    value: true
});
$22a64ccc246ff905$exports.Rowspan = void 0;
/* eslint-disable import/export, @typescript-eslint/no-redeclare */ const $22a64ccc246ff905$var$EMPTY_RANGE = {
    firstRowIndex: 0,
    lastRowIndex: 0
};
const $22a64ccc246ff905$var$EMPTY_CACHES = {
    spannedCells: {},
    hiddenCells: {},
    hiddenCellOriginMap: {}
};
const $22a64ccc246ff905$var$selectors = {
    state: (state)=>state.rowSpanning,
    hiddenCells: (state)=>state.rowSpanning.caches.hiddenCells,
    spannedCells: (state)=>state.rowSpanning.caches.spannedCells,
    hiddenCellsOriginMap: (state)=>state.rowSpanning.caches.hiddenCellOriginMap
};
const $22a64ccc246ff905$var$Rowspan = $22a64ccc246ff905$exports.Rowspan = {
    initialize: $22a64ccc246ff905$var$initializeState,
    use: $22a64ccc246ff905$var$useRowspan,
    selectors: $22a64ccc246ff905$var$selectors
};
function $22a64ccc246ff905$var$initializeState(params) {
    return {
        rowSpanning: params.initialState?.rowSpanning ?? {
            caches: $22a64ccc246ff905$var$EMPTY_CACHES,
            processedRange: $22a64ccc246ff905$var$EMPTY_RANGE
        }
    };
}
function $22a64ccc246ff905$var$useRowspan(store, _params, _api) {
    const getHiddenCellsOrigin = ()=>$22a64ccc246ff905$var$selectors.hiddenCellsOriginMap(store.state);
    return {
        getHiddenCellsOrigin: getHiddenCellsOrigin
    };
}



var $325eb7d3aa123984$exports = {};
"use strict";
Object.defineProperty($325eb7d3aa123984$exports, "__esModule", {
    value: true
});
$325eb7d3aa123984$exports.DEFAULT_PARAMS = $325eb7d3aa123984$exports.DEFAULT_COLUMNS = void 0;
const $325eb7d3aa123984$var$DEFAULT_COLUMNS = $325eb7d3aa123984$exports.DEFAULT_COLUMNS = [
    {
        field: 'DEFAULT_COLUMN'
    }
];
const $325eb7d3aa123984$var$DEFAULT_PARAMS = $325eb7d3aa123984$exports.DEFAULT_PARAMS = {
    resizeThrottleMs: 100,
    columns: $325eb7d3aa123984$var$DEFAULT_COLUMNS,
    dimensions: {
        autoHeight: false,
        columnsTotalWidth: 0,
        leftPinnedWidth: 0,
        rightPinnedWidth: 0,
        topPinnedHeight: 0,
        bottomPinnedHeight: 0
    },
    virtualization: {
        isRtl: false,
        rowBufferPx: 150,
        columnBufferPx: 150
    }
};


/* eslint-disable jsdoc/require-param-type */ /* eslint-disable jsdoc/require-param-description */ /* eslint-disable jsdoc/require-returns-type */ const $d8a42ab8ec8ec106$var$FEATURES = [
    $c7858fce4e25e1aa$exports.Dimensions,
    $07abedf34d4a8fef$exports.Virtualization,
    $5aceebfd588d01cb$exports.Colspan,
    $22a64ccc246ff905$exports.Rowspan,
    $c930b9bb9e7ac1dd$exports.Keyboard
];
const $d8a42ab8ec8ec106$var$useVirtualizer = (params)=>{
    const paramsWithDefault = $d8a42ab8ec8ec106$var$mergeDefaults(params, $325eb7d3aa123984$exports.DEFAULT_PARAMS);
    const store = (0, $d8a42ab8ec8ec106$var$_useLazyRef.default)(()=>{
        return new $66c3b1bd8ca83ba8$exports.Store($d8a42ab8ec8ec106$var$FEATURES.map((f)=>f.initialize(paramsWithDefault)).reduce((state, partial)=>Object.assign(state, partial), {}));
    }).current;
    const api = {};
    for (const feature of $d8a42ab8ec8ec106$var$FEATURES)Object.assign(api, feature.use(store, paramsWithDefault, api));
    return {
        store: store,
        api: api
    };
};
$d8a42ab8ec8ec106$exports.useVirtualizer = $d8a42ab8ec8ec106$var$useVirtualizer;
function $d8a42ab8ec8ec106$var$mergeDefaults(params, defaults) {
    const result = (0, $d8a42ab8ec8ec106$var$_extends2.default)({}, params);
    for(const key in defaults)if (Object.hasOwn(defaults, key)) {
        const value = defaults[key];
        if (value !== null && typeof value === 'object' && !Array.isArray(value)) result[key] = $d8a42ab8ec8ec106$var$mergeDefaults(params[key] ?? {}, value);
        else result[key] = params[key] ?? value;
    }
    return result;
}


Object.keys($d8a42ab8ec8ec106$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $f627be570fb53c87$exports && $f627be570fb53c87$exports[key] === $d8a42ab8ec8ec106$exports[key]) return;
    Object.defineProperty($f627be570fb53c87$exports, key, {
        enumerable: true,
        get: function() {
            return $d8a42ab8ec8ec106$exports[key];
        }
    });
});
var $853666c534a59d3f$exports = {};
"use strict";
Object.defineProperty($853666c534a59d3f$exports, "__esModule", {
    value: true
});

Object.keys($5aceebfd588d01cb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $853666c534a59d3f$exports && $853666c534a59d3f$exports[key] === $5aceebfd588d01cb$exports[key]) return;
    Object.defineProperty($853666c534a59d3f$exports, key, {
        enumerable: true,
        get: function() {
            return $5aceebfd588d01cb$exports[key];
        }
    });
});

Object.keys($c7858fce4e25e1aa$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $853666c534a59d3f$exports && $853666c534a59d3f$exports[key] === $c7858fce4e25e1aa$exports[key]) return;
    Object.defineProperty($853666c534a59d3f$exports, key, {
        enumerable: true,
        get: function() {
            return $c7858fce4e25e1aa$exports[key];
        }
    });
});

Object.keys($c930b9bb9e7ac1dd$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $853666c534a59d3f$exports && $853666c534a59d3f$exports[key] === $c930b9bb9e7ac1dd$exports[key]) return;
    Object.defineProperty($853666c534a59d3f$exports, key, {
        enumerable: true,
        get: function() {
            return $c930b9bb9e7ac1dd$exports[key];
        }
    });
});

Object.keys($22a64ccc246ff905$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $853666c534a59d3f$exports && $853666c534a59d3f$exports[key] === $22a64ccc246ff905$exports[key]) return;
    Object.defineProperty($853666c534a59d3f$exports, key, {
        enumerable: true,
        get: function() {
            return $22a64ccc246ff905$exports[key];
        }
    });
});

Object.keys($07abedf34d4a8fef$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $853666c534a59d3f$exports && $853666c534a59d3f$exports[key] === $07abedf34d4a8fef$exports[key]) return;
    Object.defineProperty($853666c534a59d3f$exports, key, {
        enumerable: true,
        get: function() {
            return $07abedf34d4a8fef$exports[key];
        }
    });
});


Object.keys($853666c534a59d3f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $f627be570fb53c87$exports && $f627be570fb53c87$exports[key] === $853666c534a59d3f$exports[key]) return;
    Object.defineProperty($f627be570fb53c87$exports, key, {
        enumerable: true,
        get: function() {
            return $853666c534a59d3f$exports[key];
        }
    });
});

Object.keys($325eb7d3aa123984$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $f627be570fb53c87$exports && $f627be570fb53c87$exports[key] === $325eb7d3aa123984$exports[key]) return;
    Object.defineProperty($f627be570fb53c87$exports, key, {
        enumerable: true,
        get: function() {
            return $325eb7d3aa123984$exports[key];
        }
    });
});


var $9a5858bc9bdcaed0$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $9a5858bc9bdcaed0$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $9a5858bc9bdcaed0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($9a5858bc9bdcaed0$exports, "__esModule", {
    value: true
});
$9a5858bc9bdcaed0$exports.useGridVirtualization = $9a5858bc9bdcaed0$var$useGridVirtualization;
$9a5858bc9bdcaed0$exports.virtualizationStateInitializer = void 0;

var $9a5858bc9bdcaed0$var$_extends2 = $9a5858bc9bdcaed0$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $9a5858bc9bdcaed0$var$React = $9a5858bc9bdcaed0$require$_interopRequireWildcard((parcelRequire("acw62")));

var $d10a1095bdae3394$exports = {};
"use strict";
Object.defineProperty($d10a1095bdae3394$exports, "__esModule", {
    value: true
});
$d10a1095bdae3394$exports.isJSDOM = void 0;
const $d10a1095bdae3394$var$isJSDOM = $d10a1095bdae3394$exports.isJSDOM = typeof window !== 'undefined' && /jsdom|HappyDOM/.test(window.navigator.userAgent);




const $9a5858bc9bdcaed0$var$HAS_LAYOUT = !$d10a1095bdae3394$exports.isJSDOM;
// HACK: Typescript doesn't use the alias name ("GridVirtualizationState") and changes
// the autogenerated docs result, but this would otherwise be just:
//   export type GridVirtualizationState = VirtualizationState;
// XXX: We want to use the virtualizer as the source of truth for its state, but this needs to
// stay because some parts of the grid require the `virtualization` state during initialization.
const $9a5858bc9bdcaed0$var$virtualizationStateInitializer = (state, props)=>{
    const { disableVirtualization: disableVirtualization, autoHeight: autoHeight } = props;
    const virtualization = {
        enabled: !disableVirtualization && $9a5858bc9bdcaed0$var$HAS_LAYOUT,
        enabledForColumns: !disableVirtualization && $9a5858bc9bdcaed0$var$HAS_LAYOUT,
        enabledForRows: !disableVirtualization && !autoHeight && $9a5858bc9bdcaed0$var$HAS_LAYOUT,
        renderContext: $f627be570fb53c87$exports.EMPTY_RENDER_CONTEXT
    };
    return (0, $9a5858bc9bdcaed0$var$_extends2.default)({}, state, {
        virtualization: virtualization
    });
};
$9a5858bc9bdcaed0$exports.virtualizationStateInitializer = $9a5858bc9bdcaed0$var$virtualizationStateInitializer;
function $9a5858bc9bdcaed0$var$useGridVirtualization(apiRef, rootProps) {
    const { autoHeight: autoHeight, disableVirtualization: disableVirtualization } = rootProps;
    /*
   * API METHODS
   */ const setVirtualization = (enabled)=>{
        const { virtualizer: virtualizer } = apiRef.current;
        enabled && (enabled = $9a5858bc9bdcaed0$var$HAS_LAYOUT);
        const snapshot = virtualizer.store.getSnapshot();
        if (snapshot.virtualization.enabled === enabled && snapshot.virtualization.enabledForRows === enabled && snapshot.virtualization.enabledForColumns === enabled) return;
        virtualizer.store.set('virtualization', (0, $9a5858bc9bdcaed0$var$_extends2.default)({}, virtualizer.store.state.virtualization, {
            enabled: enabled,
            enabledForColumns: enabled,
            enabledForRows: enabled && !autoHeight
        }));
    };
    const setColumnVirtualization = (enabled)=>{
        const { virtualizer: virtualizer } = apiRef.current;
        enabled && (enabled = $9a5858bc9bdcaed0$var$HAS_LAYOUT);
        const snapshot = virtualizer.store.getSnapshot();
        if (snapshot.virtualization.enabledForColumns === enabled) return;
        virtualizer.store.set('virtualization', (0, $9a5858bc9bdcaed0$var$_extends2.default)({}, virtualizer.store.state.virtualization, {
            enabledForColumns: enabled
        }));
    };
    const api = {
        unstable_setVirtualization: setVirtualization,
        unstable_setColumnVirtualization: setColumnVirtualization
    };
    (0, $d79b1aa4f5237e85$exports.useGridApiMethod)(apiRef, api, 'public');
    const forceUpdateRenderContext = ()=>{
        const { virtualizer: virtualizer } = apiRef.current;
        virtualizer?.api.scheduleUpdateRenderContext();
    };
    apiRef.current.register('private', {
        updateRenderContext: forceUpdateRenderContext
    });
    /*
   * EFFECTS
   */ (0, $431c82ec73ef367c$exports.useGridEventPriority)(apiRef, 'sortedRowsSet', forceUpdateRenderContext);
    (0, $431c82ec73ef367c$exports.useGridEventPriority)(apiRef, 'paginationModelChange', forceUpdateRenderContext);
    (0, $431c82ec73ef367c$exports.useGridEventPriority)(apiRef, 'columnsChange', forceUpdateRenderContext);
    /* eslint-disable react-hooks/exhaustive-deps */ $9a5858bc9bdcaed0$var$React.useEffect(()=>{
        if (!apiRef.current.virtualizer) return;
        setVirtualization(!rootProps.disableVirtualization);
    }, [
        apiRef,
        disableVirtualization,
        autoHeight
    ]);
/* eslint-enable react-hooks/exhaustive-deps */ }


Object.keys($9a5858bc9bdcaed0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($94d9a2be66e71282$var$_exportNames, key)) return;
    if (key in $94d9a2be66e71282$exports && $94d9a2be66e71282$exports[key] === $9a5858bc9bdcaed0$exports[key]) return;
    Object.defineProperty($94d9a2be66e71282$exports, key, {
        enumerable: true,
        get: function() {
            return $9a5858bc9bdcaed0$exports[key];
        }
    });
});
var $6e8ace88dee0fb7c$exports = {};
"use strict";
Object.defineProperty($6e8ace88dee0fb7c$exports, "__esModule", {
    value: true
});
$6e8ace88dee0fb7c$exports.gridVirtualizationSelector = $6e8ace88dee0fb7c$exports.gridVirtualizationRowEnabledSelector = $6e8ace88dee0fb7c$exports.gridVirtualizationEnabledSelector = $6e8ace88dee0fb7c$exports.gridVirtualizationColumnEnabledSelector = $6e8ace88dee0fb7c$exports.gridRenderContextSelector = $6e8ace88dee0fb7c$exports.gridRenderContextColumnsSelector = void 0;

/**
 * Get the columns state
 * @category Virtualization
 */ const $6e8ace88dee0fb7c$var$gridVirtualizationSelector = $6e8ace88dee0fb7c$exports.gridVirtualizationSelector = (0, $8eef5f2af445e503$exports.createRootSelector)((state)=>state.virtualization);
/**
 * Get the enabled state for virtualization
 * @category Virtualization
 * @deprecated Use `gridVirtualizationColumnEnabledSelector` and `gridVirtualizationRowEnabledSelector`
 */ const $6e8ace88dee0fb7c$var$gridVirtualizationEnabledSelector = $6e8ace88dee0fb7c$exports.gridVirtualizationEnabledSelector = (0, $8eef5f2af445e503$exports.createSelector)($6e8ace88dee0fb7c$var$gridVirtualizationSelector, (state)=>state.enabled);
/**
 * Get the enabled state for column virtualization
 * @category Virtualization
 */ const $6e8ace88dee0fb7c$var$gridVirtualizationColumnEnabledSelector = $6e8ace88dee0fb7c$exports.gridVirtualizationColumnEnabledSelector = (0, $8eef5f2af445e503$exports.createSelector)($6e8ace88dee0fb7c$var$gridVirtualizationSelector, (state)=>state.enabledForColumns);
/**
 * Get the enabled state for row virtualization
 * @category Virtualization
 */ const $6e8ace88dee0fb7c$var$gridVirtualizationRowEnabledSelector = $6e8ace88dee0fb7c$exports.gridVirtualizationRowEnabledSelector = (0, $8eef5f2af445e503$exports.createSelector)($6e8ace88dee0fb7c$var$gridVirtualizationSelector, (state)=>state.enabledForRows);
/**
 * Get the render context
 * @category Virtualization
 * @ignore - do not document.
 */ const $6e8ace88dee0fb7c$var$gridRenderContextSelector = $6e8ace88dee0fb7c$exports.gridRenderContextSelector = (0, $8eef5f2af445e503$exports.createSelector)($6e8ace88dee0fb7c$var$gridVirtualizationSelector, (state)=>state.renderContext);
const $6e8ace88dee0fb7c$var$firstColumnIndexSelector = (0, $8eef5f2af445e503$exports.createRootSelector)((state)=>state.virtualization.renderContext.firstColumnIndex);
const $6e8ace88dee0fb7c$var$lastColumnIndexSelector = (0, $8eef5f2af445e503$exports.createRootSelector)((state)=>state.virtualization.renderContext.lastColumnIndex);
/**
 * Get the render context, with only columns filled in.
 * This is cached, so it can be used to only re-render when the column interval changes.
 * @category Virtualization
 * @ignore - do not document.
 */ const $6e8ace88dee0fb7c$var$gridRenderContextColumnsSelector = $6e8ace88dee0fb7c$exports.gridRenderContextColumnsSelector = (0, $8eef5f2af445e503$exports.createSelectorMemoized)($6e8ace88dee0fb7c$var$firstColumnIndexSelector, $6e8ace88dee0fb7c$var$lastColumnIndexSelector, (firstColumnIndex, lastColumnIndex)=>({
        firstColumnIndex: firstColumnIndex,
        lastColumnIndex: lastColumnIndex
    }));


Object.keys($6e8ace88dee0fb7c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($94d9a2be66e71282$var$_exportNames, key)) return;
    if (key in $94d9a2be66e71282$exports && $94d9a2be66e71282$exports[key] === $6e8ace88dee0fb7c$exports[key]) return;
    Object.defineProperty($94d9a2be66e71282$exports, key, {
        enumerable: true,
        get: function() {
            return $6e8ace88dee0fb7c$exports[key];
        }
    });
});


Object.keys($94d9a2be66e71282$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $cf0bc263bd6b8fa2$exports && $cf0bc263bd6b8fa2$exports[key] === $94d9a2be66e71282$exports[key]) return;
    Object.defineProperty($cf0bc263bd6b8fa2$exports, key, {
        enumerable: true,
        get: function() {
            return $94d9a2be66e71282$exports[key];
        }
    });
});
var $797fe9b9aa089bbe$exports = {};
"use strict";
Object.defineProperty($797fe9b9aa089bbe$exports, "__esModule", {
    value: true
});
Object.defineProperty($797fe9b9aa089bbe$exports, "GridDataSourceCacheDefault", {
    enumerable: true,
    get: function() {
        return $5446b637625dfefc$exports.GridDataSourceCacheDefault;
    }
});
Object.defineProperty($797fe9b9aa089bbe$exports, "GridGetRowsError", {
    enumerable: true,
    get: function() {
        return $a65eba665b419180$exports.GridGetRowsError;
    }
});
Object.defineProperty($797fe9b9aa089bbe$exports, "GridUpdateRowError", {
    enumerable: true,
    get: function() {
        return $a65eba665b419180$exports.GridUpdateRowError;
    }
});
var $5446b637625dfefc$exports = {};
"use strict";
Object.defineProperty($5446b637625dfefc$exports, "__esModule", {
    value: true
});
$5446b637625dfefc$exports.GridDataSourceCacheDefault = void 0;
$5446b637625dfefc$exports.getKeyDefault = $5446b637625dfefc$var$getKeyDefault;
function $5446b637625dfefc$var$getKeyDefault(params) {
    return JSON.stringify([
        params.filterModel,
        params.sortModel,
        params.start,
        params.end
    ]);
}
class $5446b637625dfefc$var$GridDataSourceCacheDefault {
    constructor({ ttl: ttl = 300000, getKey: getKey = $5446b637625dfefc$var$getKeyDefault }){
        this.cache = {};
        this.ttl = ttl;
        this.getKey = getKey;
    }
    set(key, value) {
        const keyString = this.getKey(key);
        const expiry = Date.now() + this.ttl;
        this.cache[keyString] = {
            value: value,
            expiry: expiry
        };
    }
    get(key) {
        const keyString = this.getKey(key);
        const entry = this.cache[keyString];
        if (!entry) return undefined;
        if (Date.now() > entry.expiry) {
            delete this.cache[keyString];
            return undefined;
        }
        return entry.value;
    }
    clear() {
        this.cache = {};
    }
}
$5446b637625dfefc$exports.GridDataSourceCacheDefault = $5446b637625dfefc$var$GridDataSourceCacheDefault;


var $a65eba665b419180$exports = {};
"use strict";
Object.defineProperty($a65eba665b419180$exports, "__esModule", {
    value: true
});
$a65eba665b419180$exports.GridUpdateRowError = $a65eba665b419180$exports.GridGetRowsError = void 0;
class $a65eba665b419180$var$GridGetRowsError extends Error {
    /**
   * The parameters used in the failed request
   */ /**
   * The original error that caused this error
   */ constructor(options){
        super(options.message);
        this.name = 'GridGetRowsError';
        this.params = options.params;
        this.cause = options.cause;
    }
}
$a65eba665b419180$exports.GridGetRowsError = $a65eba665b419180$var$GridGetRowsError;
class $a65eba665b419180$var$GridUpdateRowError extends Error {
    /**
   * The parameters used in the failed request
   */ /**
   * The original error that caused this error
   */ constructor(options){
        super(options.message);
        this.name = 'GridUpdateRowError';
        this.params = options.params;
        this.cause = options.cause;
    }
}
$a65eba665b419180$exports.GridUpdateRowError = $a65eba665b419180$var$GridUpdateRowError;




Object.keys($797fe9b9aa089bbe$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $cf0bc263bd6b8fa2$exports && $cf0bc263bd6b8fa2$exports[key] === $797fe9b9aa089bbe$exports[key]) return;
    Object.defineProperty($cf0bc263bd6b8fa2$exports, key, {
        enumerable: true,
        get: function() {
            return $797fe9b9aa089bbe$exports[key];
        }
    });
});
var $97fac948ce0d1e76$exports = {};
"use strict";
Object.defineProperty($97fac948ce0d1e76$exports, "__esModule", {
    value: true
});


Object.keys($97fac948ce0d1e76$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $cf0bc263bd6b8fa2$exports && $cf0bc263bd6b8fa2$exports[key] === $97fac948ce0d1e76$exports[key]) return;
    Object.defineProperty($cf0bc263bd6b8fa2$exports, key, {
        enumerable: true,
        get: function() {
            return $97fac948ce0d1e76$exports[key];
        }
    });
});


Object.keys($cf0bc263bd6b8fa2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $d8761d1e377450f5$exports && $d8761d1e377450f5$exports[key] === $cf0bc263bd6b8fa2$exports[key]) return;
    Object.defineProperty($d8761d1e377450f5$exports, key, {
        enumerable: true,
        get: function() {
            return $cf0bc263bd6b8fa2$exports[key];
        }
    });
});

Object.keys($431c82ec73ef367c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $d8761d1e377450f5$exports && $d8761d1e377450f5$exports[key] === $431c82ec73ef367c$exports[key]) return;
    Object.defineProperty($d8761d1e377450f5$exports, key, {
        enumerable: true,
        get: function() {
            return $431c82ec73ef367c$exports[key];
        }
    });
});
var $70a5cce14357798b$exports = {};
"use strict";
Object.defineProperty($70a5cce14357798b$exports, "__esModule", {
    value: true
});
Object.defineProperty($70a5cce14357798b$exports, "gridRowIdSelector", {
    enumerable: true,
    get: function() {
        return $0d26ce0880758663$exports.gridRowIdSelector;
    }
});



Object.keys($70a5cce14357798b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $d8761d1e377450f5$exports && $d8761d1e377450f5$exports[key] === $70a5cce14357798b$exports[key]) return;
    Object.defineProperty($d8761d1e377450f5$exports, key, {
        enumerable: true,
        get: function() {
            return $70a5cce14357798b$exports[key];
        }
    });
});



var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");

var $ayMG0 = parcelRequire("ayMG0");
const $919ad8d5ff9ebb8c$var$useUtilityClasses = (ownerState, position)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'scrollbar',
            `scrollbar--${position}`
        ],
        content: [
            'scrollbarContent'
        ]
    };
    return (0, $919ad8d5ff9ebb8c$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
// In macOS Safari and Gnome Web, scrollbars are overlaid and don't affect the layout. So we consider
// their size to be 0px throughout all the calculations, but the floating scrollbar container does need
// to appear and have a real size. We set it to 14px because it seems like an acceptable value and we
// don't have a method to find the required size for scrollbars on those platforms.
const $919ad8d5ff9ebb8c$var$scrollbarSizeCssExpression = $919ad8d5ff9ebb8c$exports.scrollbarSizeCssExpression = 'calc(max(var(--DataGrid-scrollbarSize), 14px))';
const $919ad8d5ff9ebb8c$var$Scrollbar = (0, $izOUK.styled)('div')({
    position: 'absolute',
    display: 'inline-block',
    zIndex: 60,
    '&:hover': {
        zIndex: 70
    },
    '--size': $919ad8d5ff9ebb8c$var$scrollbarSizeCssExpression
});
const $919ad8d5ff9ebb8c$var$ScrollbarVertical = (0, $izOUK.styled)($919ad8d5ff9ebb8c$var$Scrollbar)({
    width: 'var(--size)',
    height: 'calc(var(--DataGrid-hasScrollY) * (100% - var(--DataGrid-headersTotalHeight) - var(--DataGrid-hasScrollX) * var(--DataGrid-scrollbarSize)))',
    overflowY: 'auto',
    overflowX: 'hidden',
    // Disable focus-visible style, it's a scrollbar.
    outline: 0,
    '& > div': {
        width: 'var(--size)'
    },
    top: 'var(--DataGrid-headersTotalHeight)',
    right: 0
});
const $919ad8d5ff9ebb8c$var$ScrollbarHorizontal = (0, $izOUK.styled)($919ad8d5ff9ebb8c$var$Scrollbar)({
    width: 'calc(var(--DataGrid-hasScrollX) * (100% - var(--DataGrid-hasScrollY) * var(--DataGrid-scrollbarSize)))',
    height: 'var(--size)',
    overflowY: 'hidden',
    overflowX: 'auto',
    // Disable focus-visible style, it's a scrollbar.
    outline: 0,
    '& > div': {
        height: 'var(--size)'
    },
    bottom: 0
});
const $919ad8d5ff9ebb8c$var$ScrollbarCorner = $919ad8d5ff9ebb8c$exports.ScrollbarCorner = (0, $izOUK.styled)($919ad8d5ff9ebb8c$var$Scrollbar)({
    width: 'var(--size)',
    height: 'var(--size)',
    right: 0,
    bottom: 0,
    overflow: 'scroll',
    '@media print': {
        display: 'none'
    }
});
const $919ad8d5ff9ebb8c$var$GridVirtualScrollbar = $919ad8d5ff9ebb8c$exports.GridVirtualScrollbar = (0, $fYxgT.forwardRef)(function GridVirtualScrollbar(props, ref) {
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const isLocked = $919ad8d5ff9ebb8c$var$React.useRef(false);
    const lastPosition = $919ad8d5ff9ebb8c$var$React.useRef(0);
    const scrollbarRef = $919ad8d5ff9ebb8c$var$React.useRef(null);
    const classes = $919ad8d5ff9ebb8c$var$useUtilityClasses(rootProps, props.position);
    const dimensions = (0, $d8761d1e377450f5$exports.useGridSelector)(apiRef, $d8761d1e377450f5$exports.gridDimensionsSelector);
    const propertyDimension = props.position === 'vertical' ? 'height' : 'width';
    const propertyScroll = props.position === 'vertical' ? 'scrollTop' : 'scrollLeft';
    const propertyScrollPosition = props.position === 'vertical' ? 'top' : 'left';
    const scrollbarInnerSize = props.position === 'horizontal' ? dimensions.minimumSize.width : dimensions.minimumSize.height - dimensions.headersTotalHeight;
    const onScrollerScroll = (0, $919ad8d5ff9ebb8c$var$_useEventCallback.default)(()=>{
        const scrollbar = scrollbarRef.current;
        const scrollPosition = props.scrollPosition.current;
        if (!scrollbar) return;
        if (scrollPosition[propertyScrollPosition] === lastPosition.current) return;
        lastPosition.current = scrollPosition[propertyScrollPosition];
        if (isLocked.current) {
            isLocked.current = false;
            return;
        }
        isLocked.current = true;
        scrollbar[propertyScroll] = props.scrollPosition.current[propertyScrollPosition];
    });
    const onScrollbarScroll = (0, $919ad8d5ff9ebb8c$var$_useEventCallback.default)(()=>{
        const scroller = apiRef.current.virtualScrollerRef.current;
        const scrollbar = scrollbarRef.current;
        if (!scrollbar) return;
        if (isLocked.current) {
            isLocked.current = false;
            return;
        }
        isLocked.current = true;
        scroller[propertyScroll] = scrollbar[propertyScroll];
    });
    (0, $974e2ec20df6d801$exports.useOnMount)(()=>{
        const scroller = apiRef.current.virtualScrollerRef.current;
        const scrollbar = scrollbarRef.current;
        const options = {
            passive: true
        };
        scroller.addEventListener('scroll', onScrollerScroll, options);
        scrollbar.addEventListener('scroll', onScrollbarScroll, options);
        return ()=>{
            scroller.removeEventListener('scroll', onScrollerScroll, options);
            scrollbar.removeEventListener('scroll', onScrollbarScroll, options);
        };
    });
    const Container = props.position === 'vertical' ? $919ad8d5ff9ebb8c$var$ScrollbarVertical : $919ad8d5ff9ebb8c$var$ScrollbarHorizontal;
    const scrollbarInnerStyle = $919ad8d5ff9ebb8c$var$React.useMemo(()=>({
            [propertyDimension]: `${scrollbarInnerSize}px`
        }), [
        propertyDimension,
        scrollbarInnerSize
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Container, {
        ref: (0, $919ad8d5ff9ebb8c$var$_useForkRef.default)(ref, scrollbarRef),
        className: classes.root,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: (event)=>{
            event.target.blur();
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: classes.content,
            style: scrollbarInnerStyle
        })
    });
});
$919ad8d5ff9ebb8c$var$GridVirtualScrollbar.displayName = "GridVirtualScrollbar";


var $3f27d5a87ea29815$exports = {};
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $3f27d5a87ea29815$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $3f27d5a87ea29815$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($3f27d5a87ea29815$exports, "__esModule", {
    value: true
});
$3f27d5a87ea29815$exports.GridScrollShadows = $3f27d5a87ea29815$var$GridScrollShadows;

var $3f27d5a87ea29815$var$React = $3f27d5a87ea29815$require$_interopRequireWildcard((parcelRequire("acw62")));

var $izOUK = parcelRequire("izOUK");

var $9uEev = parcelRequire("9uEev");

var $3f27d5a87ea29815$var$_composeClasses = $3f27d5a87ea29815$require$_interopRequireDefault((parcelRequire("3Hg1x")));



var $jDpXp = parcelRequire("jDpXp");

var $hbuUJ = parcelRequire("hbuUJ");

var $er55f = parcelRequire("er55f");



var $ayMG0 = parcelRequire("ayMG0");
const $3f27d5a87ea29815$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, position: position } = ownerState;
    const slots = {
        root: [
            'scrollShadow',
            `scrollShadow--${position}`
        ]
    };
    return (0, $3f27d5a87ea29815$var$_composeClasses.default)(slots, $553c2bbb14fa5500$exports.getDataGridUtilityClass, classes);
};
const $3f27d5a87ea29815$var$ScrollShadow = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'ScrollShadow',
    overridesResolver: (props, styles)=>[
            styles.root,
            styles[props.position]
        ]
})(({ theme: theme })=>({
        position: 'absolute',
        inset: 0,
        pointerEvents: 'none',
        transition: $hbuUJ.vars.transition([
            'box-shadow'
        ], {
            duration: $hbuUJ.vars.transitions.duration.short
        }),
        '--length': theme.palette.mode === 'dark' ? '8px' : '6px',
        '--length-inverse': 'calc(var(--length) * -1)',
        '--opacity': theme.palette.mode === 'dark' ? '0.7' : '0.18',
        '--blur': 'var(--length)',
        '--spread': 'calc(var(--length) * -1)',
        '--color': '0, 0, 0',
        '--color-start': 'rgba(var(--color), calc(var(--hasScrollStart) * var(--opacity)))',
        '--color-end': 'rgba(var(--color), calc(var(--hasScrollEnd) * var(--opacity)))',
        variants: [
            {
                props: {
                    position: 'vertical'
                },
                style: {
                    top: 'var(--DataGrid-topContainerHeight)',
                    bottom: 'calc(var(--DataGrid-bottomContainerHeight) + var(--DataGrid-hasScrollX) * var(--DataGrid-scrollbarSize))',
                    boxShadow: 'inset 0 var(--length) var(--blur) var(--spread) var(--color-start), inset 0 var(--length-inverse) var(--blur) var(--spread) var(--color-end)'
                }
            },
            {
                props: {
                    position: 'horizontal'
                },
                style: {
                    left: 'var(--DataGrid-leftPinnedWidth)',
                    right: 'calc(var(--DataGrid-rightPinnedWidth) + var(--DataGrid-hasScrollY) * var(--DataGrid-scrollbarSize))',
                    boxShadow: 'inset var(--length) 0 var(--blur) var(--spread) var(--color-start), inset var(--length-inverse) 0 var(--blur) var(--spread) var(--color-end)'
                }
            }
        ]
    }));
function $3f27d5a87ea29815$var$GridScrollShadows(props) {
    const { position: position } = props;
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = {
        classes: rootProps.classes,
        position: position
    };
    const classes = $3f27d5a87ea29815$var$useUtilityClasses(ownerState);
    const ref = $3f27d5a87ea29815$var$React.useRef(null);
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const hasScrollX = (0, $d8761d1e377450f5$exports.useGridSelector)(apiRef, $46349fe7fabb2b4d$exports.gridHasScrollXSelector);
    const hasScrollY = (0, $d8761d1e377450f5$exports.useGridSelector)(apiRef, $46349fe7fabb2b4d$exports.gridHasScrollYSelector);
    const pinnedRows = (0, $d8761d1e377450f5$exports.useGridSelector)(apiRef, $befccaa56b49492d$exports.gridPinnedRowsSelector);
    const pinnedColumns = (0, $d8761d1e377450f5$exports.useGridSelector)(apiRef, $d8761d1e377450f5$exports.gridPinnedColumnsSelector);
    const initialScrollable = position === 'vertical' ? hasScrollY && pinnedRows?.bottom?.length > 0 : hasScrollX && pinnedColumns?.right?.length !== undefined && pinnedColumns?.right?.length > 0;
    const isRtl = (0, $9uEev.useRtl)();
    const updateScrollShadowVisibility = $3f27d5a87ea29815$var$React.useCallback((scrollPosition)=>{
        if (!ref.current) return;
        // Math.abs to convert negative scroll position (RTL) to positive
        const scroll = Math.abs(Math.round(scrollPosition));
        const dimensions = (0, $d8761d1e377450f5$exports.gridDimensionsSelector)(apiRef);
        const maxScroll = Math.round(dimensions.contentSize[position === 'vertical' ? 'height' : 'width'] - dimensions.viewportInnerSize[position === 'vertical' ? 'height' : 'width']);
        const hasPinnedStart = position === 'vertical' ? pinnedRows?.top?.length > 0 : pinnedColumns?.left?.length !== undefined && pinnedColumns?.left?.length > 0;
        const hasPinnedEnd = position === 'vertical' ? pinnedRows?.bottom?.length > 0 : pinnedColumns?.right?.length !== undefined && pinnedColumns?.right?.length > 0;
        const scrollIsNotAtStart = isRtl ? scroll < maxScroll : scroll > 0;
        const scrollIsNotAtEnd = isRtl ? scroll > 0 : scroll < maxScroll;
        ref.current.style.setProperty('--hasScrollStart', hasPinnedStart && scrollIsNotAtStart ? '1' : '0');
        ref.current.style.setProperty('--hasScrollEnd', hasPinnedEnd && scrollIsNotAtEnd ? '1' : '0');
    }, [
        pinnedRows,
        pinnedColumns,
        isRtl,
        position,
        apiRef
    ]);
    const handleScrolling = (scrollParams)=>{
        updateScrollShadowVisibility(scrollParams[position === 'vertical' ? 'top' : 'left']);
    };
    const handleColumnResizeStop = ()=>{
        if (position === 'horizontal') updateScrollShadowVisibility(apiRef.current.virtualScrollerRef?.current?.scrollLeft || 0);
    };
    (0, $d8761d1e377450f5$exports.useGridEvent)(apiRef, 'scrollPositionChange', handleScrolling);
    (0, $d8761d1e377450f5$exports.useGridEvent)(apiRef, 'columnResizeStop', handleColumnResizeStop);
    $3f27d5a87ea29815$var$React.useEffect(()=>{
        updateScrollShadowVisibility((position === 'horizontal' ? apiRef.current.virtualScrollerRef?.current?.scrollLeft : apiRef.current.virtualScrollerRef?.current?.scrollTop) ?? 0);
    }, [
        updateScrollShadowVisibility,
        apiRef,
        position
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3f27d5a87ea29815$var$ScrollShadow, {
        className: classes.root,
        ownerState: ownerState,
        ref: ref,
        style: {
            '--hasScrollStart': 0,
            '--hasScrollEnd': initialScrollable ? '1' : '0'
        }
    });
}


var $4b0ca0cb82103871$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $4b0ca0cb82103871$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $4b0ca0cb82103871$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($4b0ca0cb82103871$exports, "__esModule", {
    value: true
});
$4b0ca0cb82103871$exports.GridOverlayWrapper = $4b0ca0cb82103871$var$GridOverlayWrapper;

var $4b0ca0cb82103871$var$_extends2 = $4b0ca0cb82103871$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $4b0ca0cb82103871$var$React = $4b0ca0cb82103871$require$_interopRequireWildcard((parcelRequire("acw62")));

var $4b0ca0cb82103871$var$_propTypes = $4b0ca0cb82103871$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $izOUK = parcelRequire("izOUK");

var $4b0ca0cb82103871$var$_composeClasses = $4b0ca0cb82103871$require$_interopRequireDefault((parcelRequire("3Hg1x")));


var $5sOMZ = parcelRequire("5sOMZ");


var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");

var $ayMG0 = parcelRequire("ayMG0");
const $4b0ca0cb82103871$var$GridOverlayWrapperRoot = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'OverlayWrapper',
    shouldForwardProp: (prop)=>prop !== 'overlayType' && prop !== 'loadingOverlayVariant' && prop !== 'right'
})(({ overlayType: overlayType, loadingOverlayVariant: loadingOverlayVariant, right: right })=>// Skeleton overlay should flow with the scroll container and not be sticky
    loadingOverlayVariant !== 'skeleton' ? {
        position: 'sticky',
        // To stay in place while scrolling
        top: 'var(--DataGrid-headersTotalHeight)',
        // TODO: take pinned rows into account
        left: 0,
        right: `${right}px`,
        width: 0,
        // To stay above the content instead of shifting it down
        height: 0,
        // To stay above the content instead of shifting it down
        zIndex: overlayType === 'loadingOverlay' ? 5 // Should be above pinned columns, pinned rows, and detail panel
         : 4 // Should be above pinned columns and detail panel
    } : {});
const $4b0ca0cb82103871$var$GridOverlayWrapperInner = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'OverlayWrapperInner',
    shouldForwardProp: (prop)=>prop !== 'overlayType' && prop !== 'loadingOverlayVariant'
})({});
const $4b0ca0cb82103871$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'overlayWrapper'
        ],
        inner: [
            'overlayWrapperInner'
        ]
    };
    return (0, $4b0ca0cb82103871$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
function $4b0ca0cb82103871$var$GridOverlayWrapper(props) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const dimensions = (0, $5sOMZ.useGridSelector)(apiRef, $d9a3301c6c2f6d8b$exports.gridDimensionsSelector);
    let height = Math.max(dimensions.viewportOuterSize.height - dimensions.topContainerHeight - dimensions.bottomContainerHeight - (dimensions.hasScrollX ? dimensions.scrollbarSize : 0), 0);
    if (height === 0) height = $0166dd44615cae0d$exports.minimalContentHeight;
    const classes = $4b0ca0cb82103871$var$useUtilityClasses((0, $4b0ca0cb82103871$var$_extends2.default)({}, props, {
        classes: rootProps.classes
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($4b0ca0cb82103871$var$GridOverlayWrapperRoot, (0, $4b0ca0cb82103871$var$_extends2.default)({
        className: classes.root
    }, props, {
        right: dimensions.columnsTotalWidth - dimensions.viewportOuterSize.width,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($4b0ca0cb82103871$var$GridOverlayWrapperInner, (0, $4b0ca0cb82103871$var$_extends2.default)({
            className: classes.inner,
            style: {
                height: height,
                width: dimensions.viewportOuterSize.width
            }
        }, props))
    }));
}
$4b0ca0cb82103871$var$GridOverlayWrapper.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    loadingOverlayVariant: $4b0ca0cb82103871$var$_propTypes.default.oneOf([
        'circular-progress',
        'linear-progress',
        'skeleton'
    ]),
    overlayType: $4b0ca0cb82103871$var$_propTypes.default.oneOf([
        'loadingOverlay',
        'noResultsOverlay',
        'noRowsOverlay',
        'noColumnsOverlay',
        'emptyPivotOverlay'
    ])
};


var $59ee6250fa043d54$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $59ee6250fa043d54$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $59ee6250fa043d54$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($59ee6250fa043d54$exports, "__esModule", {
    value: true
});
$59ee6250fa043d54$exports.useGridVirtualizer = $59ee6250fa043d54$var$useGridVirtualizer;

var $59ee6250fa043d54$var$_extends2 = $59ee6250fa043d54$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $59ee6250fa043d54$var$React = $59ee6250fa043d54$require$_interopRequireWildcard((parcelRequire("acw62")));

var $59ee6250fa043d54$var$_useLazyRef = $59ee6250fa043d54$require$_interopRequireDefault((parcelRequire("doV3C")));

var $59ee6250fa043d54$var$_useEventCallback = $59ee6250fa043d54$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $9uEev = parcelRequire("9uEev");

var $91b32b7177105fb1$exports = {};
"use strict";
Object.defineProperty($91b32b7177105fb1$exports, "__esModule", {
    value: true
});
Object.defineProperty($91b32b7177105fb1$exports, "lruMemoize", {
    enumerable: true,
    get: function() {
        return $375276bea32f9eda$export$d8ead1d92249919b;
    }
});








var $5sOMZ = parcelRequire("5sOMZ");




var $7d0a5941a1add073$exports = {};
"use strict";
Object.defineProperty($7d0a5941a1add073$exports, "__esModule", {
    value: true
});
$7d0a5941a1add073$exports.useGridVisibleRows = $7d0a5941a1add073$exports.getVisibleRows = void 0;


const $7d0a5941a1add073$var$getVisibleRows = (apiRef, props)=>{
    return (0, $c41ec74257ca380c$exports.gridVisibleRowsSelector)(apiRef);
};
/**
 * Computes the list of rows that are reachable by scroll.
 * Depending on whether pagination is enabled, it will return the rows in the current page.
 * - If the pagination is disabled or in server mode, it equals all the visible rows.
 * - If the row tree has several layers, it contains up to `state.pageSize` top level rows and all their descendants.
 * - If the row tree is flat, it only contains up to `state.pageSize` rows.
 */ $7d0a5941a1add073$exports.getVisibleRows = $7d0a5941a1add073$var$getVisibleRows;
const $7d0a5941a1add073$var$useGridVisibleRows = (apiRef, props)=>{
    return (0, $431c82ec73ef367c$exports.useGridSelector)(apiRef, $c41ec74257ca380c$exports.gridVisibleRowsSelector);
};
$7d0a5941a1add073$exports.useGridVisibleRows = $7d0a5941a1add073$var$useGridVisibleRows;



var $6a74c410c8e04714$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $6a74c410c8e04714$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($6a74c410c8e04714$exports, "__esModule", {
    value: true
});
$6a74c410c8e04714$exports.gridFocusedVirtualCellSelector = void 0;

var $6a74c410c8e04714$var$_extends2 = $6a74c410c8e04714$require$_interopRequireDefault((parcelRequire("3p9rK")));





const $6a74c410c8e04714$var$gridIsFocusedCellOutOfContext = (0, $8eef5f2af445e503$exports.createSelector)($b6fed9c583d617da$exports.gridFocusCellSelector, $6e8ace88dee0fb7c$exports.gridRenderContextSelector, $809f57c9ce5163f3$exports.gridVisibleRowsSelector, $e732684465924d20$exports.gridVisibleColumnDefinitionsSelector, (focusedCell, renderContext, currentPage, visibleColumns)=>{
    if (!focusedCell) return false;
    const rowIndex = currentPage.rowIdToIndexMap.get(focusedCell.id);
    const columnIndex = visibleColumns.slice(renderContext.firstColumnIndex, renderContext.lastColumnIndex).findIndex((column)=>column.field === focusedCell.field);
    const isInRenderContext = rowIndex !== undefined && columnIndex !== -1 && rowIndex >= renderContext.firstRowIndex && rowIndex <= renderContext.lastRowIndex;
    return !isInRenderContext;
});
const $6a74c410c8e04714$var$gridFocusedVirtualCellSelector = $6a74c410c8e04714$exports.gridFocusedVirtualCellSelector = (0, $8eef5f2af445e503$exports.createSelectorMemoized)($6a74c410c8e04714$var$gridIsFocusedCellOutOfContext, $e732684465924d20$exports.gridVisibleColumnDefinitionsSelector, $809f57c9ce5163f3$exports.gridVisibleRowsSelector, $b6fed9c583d617da$exports.gridFocusCellSelector, (isFocusedCellOutOfRenderContext, visibleColumns, currentPage, focusedCell)=>{
    if (!isFocusedCellOutOfRenderContext) return null;
    const rowIndex = currentPage.rowIdToIndexMap.get(focusedCell.id);
    if (rowIndex === undefined) return null;
    const columnIndex = visibleColumns.findIndex((column)=>column.field === focusedCell.field);
    if (columnIndex === -1) return null;
    return (0, $6a74c410c8e04714$var$_extends2.default)({}, focusedCell, {
        rowIndex: rowIndex,
        columnIndex: columnIndex
    });
});



var $0f96df060f8ddda5$exports = {};
"use strict";
Object.defineProperty($0f96df060f8ddda5$exports, "__esModule", {
    value: true
});
$0f96df060f8ddda5$exports.DATA_GRID_PROPS_DEFAULT_VALUES = void 0;

/**
 * The default values of `DataGridPropsWithDefaultValues` to inject in the props of DataGrid.
 */ const $0f96df060f8ddda5$var$DATA_GRID_PROPS_DEFAULT_VALUES = $0f96df060f8ddda5$exports.DATA_GRID_PROPS_DEFAULT_VALUES = {
    autoHeight: false,
    autoPageSize: false,
    autosizeOnMount: false,
    checkboxSelection: false,
    checkboxSelectionVisibleOnly: false,
    clipboardCopyCellDelimiter: '\t',
    columnBufferPx: 150,
    columnFilterDebounceMs: 150,
    columnHeaderHeight: 56,
    disableAutosize: false,
    disableColumnFilter: false,
    disableColumnMenu: false,
    disableColumnReorder: false,
    disableColumnResize: false,
    disableColumnSelector: false,
    disableColumnSorting: false,
    disableDensitySelector: false,
    disableEval: false,
    disableMultipleColumnsFiltering: false,
    disableMultipleColumnsSorting: false,
    disableMultipleRowSelection: false,
    disableRowSelectionOnClick: false,
    disableRowSelectionExcludeModel: false,
    disableVirtualization: false,
    editMode: $e139707caeafbfd6$exports.GridEditModes.Cell,
    filterDebounceMs: 150,
    filterMode: 'client',
    hideFooter: false,
    hideFooterPagination: false,
    hideFooterRowCount: false,
    hideFooterSelectedRowCount: false,
    ignoreDiacritics: false,
    ignoreValueFormatterDuringExport: false,
    keepColumnPositionIfDraggedOutside: false,
    keepNonExistentRowsSelected: false,
    loading: false,
    logger: console,
    logLevel: 'warn',
    pageSizeOptions: [
        25,
        50,
        100
    ],
    pagination: false,
    paginationMode: 'client',
    resizeThrottleMs: 60,
    rowBufferPx: 150,
    rowHeight: 52,
    rows: [],
    rowSelection: true,
    rowSpacingType: 'margin',
    rowSpanning: false,
    showCellVerticalBorder: false,
    showColumnVerticalBorder: false,
    showToolbar: false,
    sortingMode: 'client',
    sortingOrder: [
        'asc',
        'desc',
        null
    ],
    throttleRowsMs: 0,
    virtualizeColumnsWithAutoRowHeight: false,
    tabNavigation: 'none'
};






var $jDpXp = parcelRequire("jDpXp");

var $er55f = parcelRequire("er55f");
var $e46af192720967f4$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e46af192720967f4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($e46af192720967f4$exports, "__esModule", {
    value: true
});
$e46af192720967f4$exports.useGridRowsMeta = $e46af192720967f4$exports.rowsMetaStateInitializer = void 0;

var $e46af192720967f4$var$_extends2 = $e46af192720967f4$require$_interopRequireDefault((parcelRequire("3p9rK")));


var $1aa692cb9e262bac$exports = {};
"use strict";
Object.defineProperty($1aa692cb9e262bac$exports, "__esModule", {
    value: true
});
var $6d0e226264a5ce5a$exports = {};
"use strict";
Object.defineProperty($6d0e226264a5ce5a$exports, "__esModule", {
    value: true
});


Object.keys($6d0e226264a5ce5a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $1aa692cb9e262bac$exports && $1aa692cb9e262bac$exports[key] === $6d0e226264a5ce5a$exports[key]) return;
    Object.defineProperty($1aa692cb9e262bac$exports, key, {
        enumerable: true,
        get: function() {
            return $6d0e226264a5ce5a$exports[key];
        }
    });
});
var $8cb0ea30b515dc96$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $8cb0ea30b515dc96$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $8cb0ea30b515dc96$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($8cb0ea30b515dc96$exports, "__esModule", {
    value: true
});
$8cb0ea30b515dc96$exports.useGridPipeProcessing = void 0;

var $8cb0ea30b515dc96$var$_objectWithoutPropertiesLoose2 = $8cb0ea30b515dc96$require$_interopRequireDefault((parcelRequire("c05no")));

var $8cb0ea30b515dc96$var$_toPropertyKey2 = $8cb0ea30b515dc96$require$_interopRequireDefault((parcelRequire("5DKOa")));

var $8cb0ea30b515dc96$var$React = $8cb0ea30b515dc96$require$_interopRequireWildcard((parcelRequire("acw62")));

/**
 * Implement the Pipeline Pattern
 *
 * More information and detailed example in (TODO add link to technical doc when ready)
 *
 * Some plugins contains custom logic to enrich data provided by other plugins or components.
 * For instance, the row grouping plugin needs to add / remove the grouping columns when the grid columns are updated.
 *
 * =====================================================================================================================
 *
 * The plugin containing the custom logic must use:
 *
 * - `useGridRegisterPipeProcessor` to register their processor.
 *
 * - `apiRef.current.requestPipeProcessorsApplication` to imperatively re-apply a group.
 *   This method should be used in last resort.
 *   Most of the time, the application should be triggered by an update on the deps of the processor.
 *
 * =====================================================================================================================
 *
 * The plugin or component that needs to enrich its data must use:
 *
 * - `apiRef.current.unstable_applyPipeProcessors` to run in chain all the processors of a given group.
 *
 * - `useGridRegisterPipeApplier` to re-apply the whole pipe when requested.
 *   The applier will be called when:
 *   * a processor is registered.
 *   * `apiRef.current.requestPipeProcessorsApplication` is called for the given group.
 */ const $8cb0ea30b515dc96$var$useGridPipeProcessing = (apiRef)=>{
    const cache = $8cb0ea30b515dc96$var$React.useRef({});
    const isRunning = $8cb0ea30b515dc96$var$React.useRef(false);
    const runAppliers = $8cb0ea30b515dc96$var$React.useCallback((groupCache)=>{
        if (isRunning.current || !groupCache) return;
        isRunning.current = true;
        Object.values(groupCache.appliers).forEach((callback)=>{
            callback();
        });
        isRunning.current = false;
    }, []);
    const registerPipeProcessor = $8cb0ea30b515dc96$var$React.useCallback((group, id, processor)=>{
        if (!cache.current[group]) cache.current[group] = {
            processors: new Map(),
            processorsAsArray: [],
            appliers: {},
            processorsUpdated: false
        };
        const groupCache = cache.current[group];
        const oldProcessor = groupCache.processors.get(id);
        if (oldProcessor !== processor) {
            groupCache.processors.set(id, processor);
            groupCache.processorsAsArray = Array.from(cache.current[group].processors.values()).filter((processorValue)=>processorValue !== null);
            groupCache.processorsUpdated = true;
        }
        return ()=>{
            cache.current[group].processors.set(id, null);
            cache.current[group].processorsAsArray = Array.from(cache.current[group].processors.values()).filter((processorValue)=>processorValue !== null);
        };
    }, []);
    const registerPipeApplier = $8cb0ea30b515dc96$var$React.useCallback((group, id, applier)=>{
        if (!cache.current[group]) cache.current[group] = {
            processors: new Map(),
            processorsAsArray: [],
            appliers: {},
            processorsUpdated: false
        };
        cache.current[group].appliers[id] = applier;
        return ()=>{
            const _appliers = cache.current[group].appliers, otherAppliers = (0, $8cb0ea30b515dc96$var$_objectWithoutPropertiesLoose2.default)(_appliers, [
                id
            ].map($8cb0ea30b515dc96$var$_toPropertyKey2.default));
            cache.current[group].appliers = otherAppliers;
        };
    }, []);
    const requestPipeProcessorsApplication = $8cb0ea30b515dc96$var$React.useCallback((group)=>{
        runAppliers(cache.current[group]);
    }, [
        runAppliers
    ]);
    const runAppliersForPendingProcessors = $8cb0ea30b515dc96$var$React.useCallback(()=>{
        for(const group in cache.current){
            if (!Object.prototype.hasOwnProperty.call(cache.current, group)) continue;
            const groupCache = cache.current[group];
            if (groupCache.processorsUpdated) {
                groupCache.processorsUpdated = false;
                runAppliers(groupCache);
            }
        }
    }, [
        runAppliers
    ]);
    const applyPipeProcessors = $8cb0ea30b515dc96$var$React.useCallback((...args)=>{
        const [group, value, context] = args;
        if (!cache.current[group]) return value;
        const processors = cache.current[group].processorsAsArray;
        let result = value;
        for(let i = 0; i < processors.length; i += 1)result = processors[i](result, context);
        return result;
    }, []);
    const preProcessingPrivateApi = {
        registerPipeProcessor: registerPipeProcessor,
        registerPipeApplier: registerPipeApplier,
        requestPipeProcessorsApplication: requestPipeProcessorsApplication,
        runAppliersForPendingProcessors: runAppliersForPendingProcessors
    };
    const preProcessingPublicApi = {
        unstable_applyPipeProcessors: applyPipeProcessors
    };
    (0, $d79b1aa4f5237e85$exports.useGridApiMethod)(apiRef, preProcessingPrivateApi, 'private');
    (0, $d79b1aa4f5237e85$exports.useGridApiMethod)(apiRef, preProcessingPublicApi, 'public');
};
$8cb0ea30b515dc96$exports.useGridPipeProcessing = $8cb0ea30b515dc96$var$useGridPipeProcessing;


Object.keys($8cb0ea30b515dc96$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $1aa692cb9e262bac$exports && $1aa692cb9e262bac$exports[key] === $8cb0ea30b515dc96$exports[key]) return;
    Object.defineProperty($1aa692cb9e262bac$exports, key, {
        enumerable: true,
        get: function() {
            return $8cb0ea30b515dc96$exports[key];
        }
    });
});
var $1b17d17d1651bc2f$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $1b17d17d1651bc2f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($1b17d17d1651bc2f$exports, "__esModule", {
    value: true
});
$1b17d17d1651bc2f$exports.useGridRegisterPipeProcessor = void 0;

var $1b17d17d1651bc2f$var$React = $1b17d17d1651bc2f$require$_interopRequireWildcard((parcelRequire("acw62")));

const $1b17d17d1651bc2f$var$useGridRegisterPipeProcessor = (apiRef, group, callback, enabled = true)=>{
    const cleanup = $1b17d17d1651bc2f$var$React.useRef(null);
    const id = $1b17d17d1651bc2f$var$React.useRef(`mui-${Math.round(Math.random() * 1e9)}`);
    const registerPreProcessor = $1b17d17d1651bc2f$var$React.useCallback(()=>{
        cleanup.current = apiRef.current.registerPipeProcessor(group, id.current, callback);
    }, [
        apiRef,
        callback,
        group
    ]);
    (0, $82679e37231fe76f$exports.useFirstRender)(()=>{
        if (enabled) registerPreProcessor();
    });
    const isFirstRender = $1b17d17d1651bc2f$var$React.useRef(true);
    $1b17d17d1651bc2f$var$React.useEffect(()=>{
        if (isFirstRender.current) isFirstRender.current = false;
        else if (enabled) registerPreProcessor();
        return ()=>{
            if (cleanup.current) {
                cleanup.current();
                cleanup.current = null;
            }
        };
    }, [
        registerPreProcessor,
        enabled
    ]);
};
$1b17d17d1651bc2f$exports.useGridRegisterPipeProcessor = $1b17d17d1651bc2f$var$useGridRegisterPipeProcessor;


Object.keys($1b17d17d1651bc2f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $1aa692cb9e262bac$exports && $1aa692cb9e262bac$exports[key] === $1b17d17d1651bc2f$exports[key]) return;
    Object.defineProperty($1aa692cb9e262bac$exports, key, {
        enumerable: true,
        get: function() {
            return $1b17d17d1651bc2f$exports[key];
        }
    });
});
var $11f38a5cdcd4928d$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $11f38a5cdcd4928d$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($11f38a5cdcd4928d$exports, "__esModule", {
    value: true
});
$11f38a5cdcd4928d$exports.useGridRegisterPipeApplier = void 0;

var $11f38a5cdcd4928d$var$React = $11f38a5cdcd4928d$require$_interopRequireWildcard((parcelRequire("acw62")));

const $11f38a5cdcd4928d$var$useGridRegisterPipeApplier = (apiRef, group, callback)=>{
    const cleanup = $11f38a5cdcd4928d$var$React.useRef(null);
    const id = $11f38a5cdcd4928d$var$React.useRef(`mui-${Math.round(Math.random() * 1e9)}`);
    const registerPreProcessor = $11f38a5cdcd4928d$var$React.useCallback(()=>{
        cleanup.current = apiRef.current.registerPipeApplier(group, id.current, callback);
    }, [
        apiRef,
        callback,
        group
    ]);
    (0, $82679e37231fe76f$exports.useFirstRender)(()=>{
        registerPreProcessor();
    });
    const isFirstRender = $11f38a5cdcd4928d$var$React.useRef(true);
    $11f38a5cdcd4928d$var$React.useEffect(()=>{
        if (isFirstRender.current) isFirstRender.current = false;
        else registerPreProcessor();
        return ()=>{
            if (cleanup.current) {
                cleanup.current();
                cleanup.current = null;
            }
        };
    }, [
        registerPreProcessor
    ]);
};
$11f38a5cdcd4928d$exports.useGridRegisterPipeApplier = $11f38a5cdcd4928d$var$useGridRegisterPipeApplier;


Object.keys($11f38a5cdcd4928d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $1aa692cb9e262bac$exports && $1aa692cb9e262bac$exports[key] === $11f38a5cdcd4928d$exports[key]) return;
    Object.defineProperty($1aa692cb9e262bac$exports, key, {
        enumerable: true,
        get: function() {
            return $11f38a5cdcd4928d$exports[key];
        }
    });
});




const $e46af192720967f4$var$rowsMetaStateInitializer = (state, props, apiRef)=>{
    // FIXME: This should be handled in the virtualizer eventually, but there are interdependencies
    // between state initializers that need to be untangled carefully.
    const baseRowHeight = (0, $46349fe7fabb2b4d$exports.gridRowHeightSelector)(apiRef);
    const dataRowCount = (0, $befccaa56b49492d$exports.gridRowCountSelector)(apiRef);
    const pagination = (0, $c41ec74257ca380c$exports.gridPaginationSelector)(apiRef);
    const rowCount = Math.min(pagination.enabled ? pagination.paginationModel.pageSize : dataRowCount, dataRowCount);
    return (0, $e46af192720967f4$var$_extends2.default)({}, state, {
        rowsMeta: {
            currentPageTotalHeight: rowCount * baseRowHeight,
            positions: Array.from({
                length: rowCount
            }, (_, i)=>i * baseRowHeight),
            pinnedTopRowsTotalHeight: 0,
            pinnedBottomRowsTotalHeight: 0
        }
    });
};
/**
 * @requires useGridPageSize (method)
 * @requires useGridPage (method)
 */ $e46af192720967f4$exports.rowsMetaStateInitializer = $e46af192720967f4$var$rowsMetaStateInitializer;
const $e46af192720967f4$var$useGridRowsMeta = (apiRef, _props)=>{
    const virtualizer = apiRef.current.virtualizer;
    const { getRowHeight: getRowHeight, setLastMeasuredRowIndex: setLastMeasuredRowIndex, storeRowHeightMeasurement: storeRowHeightMeasurement, resetRowHeights: resetRowHeights, hydrateRowsMeta: hydrateRowsMeta, observeRowHeight: observeRowHeight, rowHasAutoHeight: rowHasAutoHeight, getRowHeightEntry: getRowHeightEntry, getLastMeasuredRowIndex: getLastMeasuredRowIndex } = virtualizer.api.rowsMeta;
    (0, $1aa692cb9e262bac$exports.useGridRegisterPipeApplier)(apiRef, 'rowHeight', hydrateRowsMeta);
    const rowsMetaApi = {
        unstable_getRowHeight: getRowHeight,
        unstable_setLastMeasuredRowIndex: setLastMeasuredRowIndex,
        unstable_storeRowHeightMeasurement: storeRowHeightMeasurement,
        resetRowHeights: resetRowHeights
    };
    const rowsMetaPrivateApi = {
        hydrateRowsMeta: hydrateRowsMeta,
        observeRowHeight: observeRowHeight,
        rowHasAutoHeight: rowHasAutoHeight,
        getRowHeightEntry: getRowHeightEntry,
        getLastMeasuredRowIndex: getLastMeasuredRowIndex
    };
    (0, $d79b1aa4f5237e85$exports.useGridApiMethod)(apiRef, rowsMetaApi, 'public');
    (0, $d79b1aa4f5237e85$exports.useGridApiMethod)(apiRef, rowsMetaPrivateApi, 'private');
};
$e46af192720967f4$exports.useGridRowsMeta = $e46af192720967f4$var$useGridRowsMeta;




var $ayMG0 = parcelRequire("ayMG0");
const $59ee6250fa043d54$var$columnsTotalWidthSelector = (0, $8eef5f2af445e503$exports.createSelector)($e732684465924d20$exports.gridVisibleColumnDefinitionsSelector, $e732684465924d20$exports.gridColumnPositionsSelector, (visibleColumns, positions)=>{
    const colCount = visibleColumns.length;
    if (colCount === 0) return 0;
    return (0, $b5eb928c08dc82e9$exports.roundToDecimalPlaces)(positions[colCount - 1] + visibleColumns[colCount - 1].computedWidth, 1);
});
/** Translates virtualizer state to grid state */ const $59ee6250fa043d54$var$addGridDimensionsCreator = ()=>(0, $91b32b7177105fb1$exports.lruMemoize)((dimensions, headerHeight, groupHeaderHeight, headerFilterHeight, headersTotalHeight)=>{
        return (0, $59ee6250fa043d54$var$_extends2.default)({}, dimensions, {
            headerHeight: headerHeight,
            groupHeaderHeight: groupHeaderHeight,
            headerFilterHeight: headerFilterHeight,
            headersTotalHeight: headersTotalHeight
        });
    }, {
        maxSize: 1
    });
/**
 * Virtualizer setup
 */ function $59ee6250fa043d54$var$useGridVirtualizer() {
    const isRtl = (0, $9uEev.useRtl)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const { listView: listView } = rootProps;
    const visibleColumns = (0, $5sOMZ.useGridSelector)(apiRef, $e732684465924d20$exports.gridVisibleColumnDefinitionsSelector);
    const pinnedRows = (0, $5sOMZ.useGridSelector)(apiRef, $befccaa56b49492d$exports.gridPinnedRowsSelector);
    const pinnedColumns = (0, $e732684465924d20$exports.gridVisiblePinnedColumnDefinitionsSelector)(apiRef);
    const rowSelectionManager = (0, $5sOMZ.useGridSelector)(apiRef, $39b6b713fdb91ccd$exports.gridRowSelectionManagerSelector);
    const isRowSelected = $59ee6250fa043d54$var$React.useCallback((id)=>rowSelectionManager.has(id) && apiRef.current.isRowSelectable(id), [
        rowSelectionManager,
        apiRef
    ]);
    const currentPage = (0, $7d0a5941a1add073$exports.useGridVisibleRows)(apiRef);
    const hasColSpan = (0, $5sOMZ.useGridSelector)(apiRef, $e732684465924d20$exports.gridHasColSpanSelector);
    const verticalScrollbarWidth = (0, $5sOMZ.useGridSelector)(apiRef, $46349fe7fabb2b4d$exports.gridVerticalScrollbarWidthSelector);
    const hasFiller = (0, $5sOMZ.useGridSelector)(apiRef, $46349fe7fabb2b4d$exports.gridHasFillerSelector);
    const { autoHeight: autoHeight } = rootProps;
    const scrollReset = listView;
    // <DIMENSIONS>
    const density = (0, $5sOMZ.useGridSelector)(apiRef, $c638c00d73ef894b$exports.gridDensityFactorSelector);
    const baseRowHeight = (0, $0166dd44615cae0d$exports.getValidRowHeight)(rootProps.rowHeight, $0f96df060f8ddda5$exports.DATA_GRID_PROPS_DEFAULT_VALUES.rowHeight, $0166dd44615cae0d$exports.rowHeightWarning);
    const rowHeight = Math.floor(baseRowHeight * density);
    const headerHeight = Math.floor(rootProps.columnHeaderHeight * density);
    const groupHeaderHeight = Math.floor((rootProps.columnGroupHeaderHeight ?? rootProps.columnHeaderHeight) * density);
    const headerFilterHeight = Math.floor((rootProps.headerFilterHeight ?? rootProps.columnHeaderHeight) * density);
    const columnsTotalWidth = (0, $5sOMZ.useGridSelector)(apiRef, $59ee6250fa043d54$var$columnsTotalWidthSelector);
    const headersTotalHeight = (0, $d1cd1e3fd8558ad5$exports.getTotalHeaderHeight)(apiRef, rootProps);
    const leftPinnedWidth = pinnedColumns.left.reduce((w, col)=>w + col.computedWidth, 0);
    const rightPinnedWidth = pinnedColumns.right.reduce((w, col)=>w + col.computedWidth, 0);
    const overlayState = (0, $9ee3358fa4255e5b$exports.useGridOverlays)(apiRef, rootProps);
    const dimensionsParams = {
        rowHeight: rowHeight,
        headerHeight: headerHeight,
        columnsTotalWidth: columnsTotalWidth,
        leftPinnedWidth: leftPinnedWidth,
        rightPinnedWidth: rightPinnedWidth,
        topPinnedHeight: headersTotalHeight,
        bottomPinnedHeight: 0,
        autoHeight: autoHeight,
        minimalContentHeight: $0166dd44615cae0d$exports.minimalContentHeight,
        scrollbarSize: rootProps.scrollbarSize
    };
    const addGridDimensions = (0, $59ee6250fa043d54$var$_useLazyRef.default)($59ee6250fa043d54$var$addGridDimensionsCreator).current;
    // </DIMENSIONS>
    // <ROWS_META>
    const dataRowCount = (0, $5sOMZ.useGridSelector)(apiRef, $befccaa56b49492d$exports.gridRowCountSelector);
    const pagination = (0, $5sOMZ.useGridSelector)(apiRef, $809f57c9ce5163f3$exports.gridPaginationSelector);
    const rowCount = Math.min(pagination.enabled ? pagination.paginationModel.pageSize : dataRowCount, dataRowCount);
    const { getRowHeight: getRowHeight, getEstimatedRowHeight: getEstimatedRowHeight, getRowSpacing: getRowSpacing } = rootProps;
    // </ROWS_META>
    const RowSlot = rootProps.slots.row;
    const rowSlotProps = rootProps.slotProps?.row;
    const focusedVirtualCell = (0, $5sOMZ.useGridSelector)(apiRef, $6a74c410c8e04714$exports.gridFocusedVirtualCellSelector);
    // We need it to trigger a new render, but rowsMeta needs access to the latest value, hence we cannot pass it to the focusedVirtualCell callback in the virtualizer params
    (0, $fe919794eb3b24e8$exports.eslintUseValue)(focusedVirtualCell);
    const layout = (0, $59ee6250fa043d54$var$_useLazyRef.default)(()=>new $f627be570fb53c87$exports.LayoutDataGridLegacy({
            container: apiRef.current.mainElementRef,
            scroller: apiRef.current.virtualScrollerRef,
            scrollbarVertical: apiRef.current.virtualScrollbarVerticalRef,
            scrollbarHorizontal: apiRef.current.virtualScrollbarHorizontalRef
        })).current;
    const virtualizer = (0, $f627be570fb53c87$exports.useVirtualizer)({
        layout: layout,
        dimensions: dimensionsParams,
        virtualization: {
            isRtl: isRtl,
            rowBufferPx: rootProps.rowBufferPx,
            columnBufferPx: rootProps.columnBufferPx
        },
        colspan: {
            enabled: hasColSpan,
            getColspan: $59ee6250fa043d54$var$React.useCallback((rowId, column)=>{
                if (typeof column.colSpan === 'function') {
                    const row = apiRef.current.getRow(rowId);
                    const value = apiRef.current.getRowValue(row, column);
                    return column.colSpan(value, row, column, apiRef) ?? 0;
                }
                return column.colSpan ?? 1;
            }, [
                apiRef
            ])
        },
        initialState: {
            scroll: rootProps.initialState?.scroll,
            rowSpanning: apiRef.current.state.rowSpanning,
            virtualization: apiRef.current.state.virtualization
        },
        rows: currentPage.rows,
        range: currentPage.range,
        rowCount: rowCount,
        columns: visibleColumns,
        pinnedRows: pinnedRows,
        pinnedColumns: pinnedColumns,
        disableHorizontalScroll: listView,
        disableVerticalScroll: overlayState.overlayType === 'noColumnsOverlay' || overlayState.loadingOverlayVariant === 'skeleton',
        getRowHeight: $59ee6250fa043d54$var$React.useMemo(()=>{
            if (!getRowHeight) return undefined;
            return (rowEntry)=>getRowHeight((0, $59ee6250fa043d54$var$_extends2.default)({}, rowEntry, {
                    densityFactor: density
                }));
        }, [
            getRowHeight,
            density
        ]),
        getEstimatedRowHeight: $59ee6250fa043d54$var$React.useMemo(()=>getEstimatedRowHeight ? (rowEntry)=>getEstimatedRowHeight((0, $59ee6250fa043d54$var$_extends2.default)({}, rowEntry, {
                    densityFactor: density
                })) : undefined, [
            getEstimatedRowHeight,
            density
        ]),
        getRowSpacing: $59ee6250fa043d54$var$React.useMemo(()=>getRowSpacing ? (rowEntry)=>{
                const indexRelativeToCurrentPage = currentPage.rowIdToIndexMap.get(rowEntry.id) ?? -1;
                const visibility = {
                    isFirstVisible: indexRelativeToCurrentPage === 0,
                    isLastVisible: indexRelativeToCurrentPage === currentPage.rows.length - 1,
                    indexRelativeToCurrentPage: indexRelativeToCurrentPage
                };
                return getRowSpacing((0, $59ee6250fa043d54$var$_extends2.default)({}, rowEntry, visibility, {
                    indexRelativeToCurrentPage: apiRef.current.getRowIndexRelativeToVisibleRows(rowEntry.id)
                }));
            } : undefined, [
            apiRef,
            getRowSpacing,
            currentPage.rows,
            currentPage.rowIdToIndexMap
        ]),
        applyRowHeight: (0, $59ee6250fa043d54$var$_useEventCallback.default)((entry, row)=>apiRef.current.unstable_applyPipeProcessors('rowHeight', entry, row)),
        virtualizeColumnsWithAutoRowHeight: rootProps.virtualizeColumnsWithAutoRowHeight,
        focusedVirtualCell: (0, $59ee6250fa043d54$var$_useEventCallback.default)(()=>(0, $6a74c410c8e04714$exports.gridFocusedVirtualCellSelector)(apiRef)),
        resizeThrottleMs: rootProps.resizeThrottleMs,
        onResize: (0, $59ee6250fa043d54$var$_useEventCallback.default)((size)=>apiRef.current.publishEvent('resize', size)),
        onWheel: (0, $59ee6250fa043d54$var$_useEventCallback.default)((event)=>{
            apiRef.current.publishEvent('virtualScrollerWheel', {}, event);
        }),
        onTouchMove: (0, $59ee6250fa043d54$var$_useEventCallback.default)((event)=>{
            apiRef.current.publishEvent('virtualScrollerTouchMove', {}, event);
        }),
        onRenderContextChange: (0, $59ee6250fa043d54$var$_useEventCallback.default)((nextRenderContext)=>{
            apiRef.current.publishEvent('renderedRowsIntervalChange', nextRenderContext);
        }),
        onScrollChange: $59ee6250fa043d54$var$React.useCallback((scrollPosition, nextRenderContext)=>{
            apiRef.current.publishEvent('scrollPositionChange', {
                top: scrollPosition.top,
                left: scrollPosition.left,
                renderContext: nextRenderContext
            });
        }, [
            apiRef
        ]),
        scrollReset: scrollReset,
        renderRow: $59ee6250fa043d54$var$React.useCallback((params)=>/*#__PURE__*/ (0, $ayMG0.jsx)(RowSlot, (0, $59ee6250fa043d54$var$_extends2.default)({
                row: params.model,
                rowId: params.id,
                index: params.rowIndex,
                selected: isRowSelected(params.id),
                offsetLeft: params.offsetLeft,
                columnsTotalWidth: columnsTotalWidth,
                rowHeight: params.baseRowHeight,
                pinnedColumns: pinnedColumns,
                visibleColumns: visibleColumns,
                firstColumnIndex: params.firstColumnIndex,
                lastColumnIndex: params.lastColumnIndex,
                focusedColumnIndex: params.focusedColumnIndex,
                isFirstVisible: params.isFirstVisible,
                isLastVisible: params.isLastVisible,
                isNotVisible: params.isVirtualFocusRow,
                showBottomBorder: params.showBottomBorder,
                scrollbarWidth: verticalScrollbarWidth,
                gridHasFiller: hasFiller
            }, rowSlotProps), params.id), [
            columnsTotalWidth,
            hasFiller,
            isRowSelected,
            pinnedColumns,
            RowSlot,
            rowSlotProps,
            verticalScrollbarWidth,
            visibleColumns
        ]),
        renderInfiniteLoadingTrigger: $59ee6250fa043d54$var$React.useCallback((id)=>apiRef.current.getInfiniteLoadingTriggerElement?.({
                lastRowId: id
            }), [
            apiRef
        ])
    });
    // HACK: Keep the grid's store in sync with the virtualizer store. We set up the
    // subscription in the render phase rather than in an effect because other grid
    // initialization code runs between those two moments.
    //
    // TODO(v9): Remove this
    (0, $82679e37231fe76f$exports.useFirstRender)(()=>{
        apiRef.current.store.state.dimensions = addGridDimensions(virtualizer.store.state.dimensions, headerHeight, groupHeaderHeight, headerFilterHeight, headersTotalHeight);
        apiRef.current.store.state.rowsMeta = virtualizer.store.state.rowsMeta;
        apiRef.current.store.state.virtualization = virtualizer.store.state.virtualization;
    });
    (0, $66c3b1bd8ca83ba8$exports.useStoreEffect)(virtualizer.store, $f627be570fb53c87$exports.Dimensions.selectors.dimensions, (_, dimensions)=>{
        if (!dimensions.isReady) return;
        apiRef.current.setState((gridState)=>(0, $59ee6250fa043d54$var$_extends2.default)({}, gridState, {
                dimensions: addGridDimensions(dimensions, headerHeight, groupHeaderHeight, headerFilterHeight, headersTotalHeight)
            }));
    });
    (0, $66c3b1bd8ca83ba8$exports.useStoreEffect)(virtualizer.store, $f627be570fb53c87$exports.Dimensions.selectors.rowsMeta, (_, rowsMeta)=>{
        if (rowsMeta !== apiRef.current.state.rowsMeta) apiRef.current.setState((gridState)=>(0, $59ee6250fa043d54$var$_extends2.default)({}, gridState, {
                rowsMeta: rowsMeta
            }));
    });
    (0, $66c3b1bd8ca83ba8$exports.useStoreEffect)(virtualizer.store, $f627be570fb53c87$exports.Virtualization.selectors.store, (_, virtualization)=>{
        if (virtualization.renderContext === $f627be570fb53c87$exports.EMPTY_RENDER_CONTEXT) return;
        if (virtualization !== apiRef.current.state.virtualization) apiRef.current.setState((gridState)=>(0, $59ee6250fa043d54$var$_extends2.default)({}, gridState, {
                virtualization: virtualization
            }));
    });
    apiRef.current.register('private', {
        virtualizer: virtualizer
    });
    (0, $e46af192720967f4$exports.useGridRowsMeta)(apiRef, rootProps);
    return virtualizer;
}



var $ayMG0 = parcelRequire("ayMG0");
const $0e5dd7e9e576a614$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, hasScrollX: hasScrollX, hasPinnedRight: hasPinnedRight, loadingOverlayVariant: loadingOverlayVariant, overlayType: overlayType } = ownerState;
    const hideContent = loadingOverlayVariant === 'skeleton' || overlayType === 'noColumnsOverlay';
    const slots = {
        root: [
            'main',
            hasPinnedRight && 'main--hasPinnedRight',
            hideContent && 'main--hiddenContent'
        ],
        scroller: [
            'virtualScroller',
            hasScrollX && 'virtualScroller--hasScrollX'
        ]
    };
    return (0, $0e5dd7e9e576a614$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $0e5dd7e9e576a614$var$Scroller = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'VirtualScroller',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.virtualScroller,
            ownerState.hasScrollX && styles['virtualScroller--hasScrollX']
        ];
    }
})({
    position: 'relative',
    height: '100%',
    flexGrow: 1,
    overflow: 'scroll',
    scrollbarWidth: 'none' /* Firefox */ ,
    display: 'flex',
    flexDirection: 'column',
    '&::-webkit-scrollbar': {
        display: 'none' /* Safari and Chrome */ 
    },
    '@media print': {
        overflow: 'hidden'
    },
    // See https://github.com/mui/mui-x/issues/10547
    zIndex: 0
});
const $0e5dd7e9e576a614$var$hasPinnedRightSelector = (apiRef)=>apiRef.current.state.dimensions.rightPinnedWidth > 0;
function $0e5dd7e9e576a614$var$GridVirtualScroller(props) {
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const hasScrollY = (0, $5sOMZ.useGridSelector)(apiRef, $46349fe7fabb2b4d$exports.gridHasScrollYSelector);
    const hasScrollX = (0, $5sOMZ.useGridSelector)(apiRef, $46349fe7fabb2b4d$exports.gridHasScrollXSelector);
    const hasPinnedRight = (0, $5sOMZ.useGridSelector)(apiRef, $0e5dd7e9e576a614$var$hasPinnedRightSelector);
    const hasBottomFiller = (0, $5sOMZ.useGridSelector)(apiRef, $46349fe7fabb2b4d$exports.gridHasBottomFillerSelector);
    const { overlayType: overlayType, loadingOverlayVariant: loadingOverlayVariant } = (0, $9ee3358fa4255e5b$exports.useGridOverlays)(apiRef, rootProps);
    const Overlay = rootProps.slots?.[overlayType];
    const ownerState = {
        classes: rootProps.classes,
        hasScrollX: hasScrollX,
        hasPinnedRight: hasPinnedRight,
        overlayType: overlayType,
        loadingOverlayVariant: loadingOverlayVariant
    };
    const classes = $0e5dd7e9e576a614$var$useUtilityClasses(ownerState);
    const virtualScroller = (0, $59ee6250fa043d54$exports.useGridVirtualizer)().api.getters;
    const { getContainerProps: getContainerProps, getScrollerProps: getScrollerProps, getContentProps: getContentProps, getPositionerProps: getPositionerProps, getScrollbarVerticalProps: getScrollbarVerticalProps, getScrollbarHorizontalProps: getScrollbarHorizontalProps, getRows: getRows, getScrollAreaProps: getScrollAreaProps } = virtualScroller;
    const rows = getRows(undefined, (0, $aad5df8f504205b0$exports.gridRowTreeSelector)(apiRef));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($eb3d8cbc702f4647$exports.GridMainContainer, (0, $0e5dd7e9e576a614$var$_extends2.default)({
        className: classes.root
    }, getContainerProps(), {
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($3b92023a13ae6811$exports.GridScrollArea, (0, $0e5dd7e9e576a614$var$_extends2.default)({
                scrollDirection: "left"
            }, getScrollAreaProps())),
            /*#__PURE__*/ (0, $ayMG0.jsx)($3b92023a13ae6811$exports.GridScrollArea, (0, $0e5dd7e9e576a614$var$_extends2.default)({
                scrollDirection: "right"
            }, getScrollAreaProps())),
            /*#__PURE__*/ (0, $ayMG0.jsx)($3b92023a13ae6811$exports.GridScrollArea, (0, $0e5dd7e9e576a614$var$_extends2.default)({
                scrollDirection: "up"
            }, getScrollAreaProps())),
            /*#__PURE__*/ (0, $ayMG0.jsx)($3b92023a13ae6811$exports.GridScrollArea, (0, $0e5dd7e9e576a614$var$_extends2.default)({
                scrollDirection: "down"
            }, getScrollAreaProps())),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($0e5dd7e9e576a614$var$Scroller, (0, $0e5dd7e9e576a614$var$_extends2.default)({
                className: classes.scroller
            }, getScrollerProps(), {
                ownerState: ownerState,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($63b75016458d5774$exports.GridTopContainer, {
                        children: [
                            !rootProps.listView && /*#__PURE__*/ (0, $ayMG0.jsx)($a193a1fff9f5c318$exports.GridHeaders, {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.pinnedRows, {
                                position: "top",
                                virtualScroller: virtualScroller
                            })
                        ]
                    }),
                    overlayType && /*#__PURE__*/ (0, $ayMG0.jsx)($4b0ca0cb82103871$exports.GridOverlayWrapper, {
                        overlayType: overlayType,
                        loadingOverlayVariant: loadingOverlayVariant,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Overlay, (0, $0e5dd7e9e576a614$var$_extends2.default)({}, rootProps.slotProps?.[overlayType]))
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($fd7f69586e4a3224$exports.GridVirtualScrollerContent, (0, $0e5dd7e9e576a614$var$_extends2.default)({}, getContentProps(), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($401086177e70acda$exports.GridVirtualScrollerRenderZone, (0, $0e5dd7e9e576a614$var$_extends2.default)({
                            role: "rowgroup"
                        }, getPositionerProps(), {
                            children: [
                                rows,
                                /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.detailPanels, {
                                    virtualScroller: virtualScroller
                                })
                            ]
                        }))
                    })),
                    hasBottomFiller && /*#__PURE__*/ (0, $ayMG0.jsx)($7609a5f754a72e14$exports.GridVirtualScrollerFiller, {
                        rowsLength: rows.length
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.bottomContainer, {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.pinnedRows, {
                            position: "bottom",
                            virtualScroller: virtualScroller
                        })
                    })
                ]
            })),
            hasScrollX && /*#__PURE__*/ (0, $ayMG0.jsxs)($0e5dd7e9e576a614$var$React.Fragment, {
                children: [
                    rootProps.pinnedColumnsSectionSeparator?.endsWith('shadow') && /*#__PURE__*/ (0, $ayMG0.jsx)($3f27d5a87ea29815$exports.GridScrollShadows, {
                        position: "horizontal"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($919ad8d5ff9ebb8c$exports.GridVirtualScrollbar, (0, $0e5dd7e9e576a614$var$_extends2.default)({
                        position: "horizontal"
                    }, getScrollbarHorizontalProps()))
                ]
            }),
            hasScrollY && /*#__PURE__*/ (0, $ayMG0.jsxs)($0e5dd7e9e576a614$var$React.Fragment, {
                children: [
                    rootProps.pinnedRowsSectionSeparator?.endsWith('shadow') && /*#__PURE__*/ (0, $ayMG0.jsx)($3f27d5a87ea29815$exports.GridScrollShadows, {
                        position: "vertical"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($919ad8d5ff9ebb8c$exports.GridVirtualScrollbar, (0, $0e5dd7e9e576a614$var$_extends2.default)({
                        position: "vertical"
                    }, getScrollbarVerticalProps()))
                ]
            }),
            hasScrollX && hasScrollY && /*#__PURE__*/ (0, $ayMG0.jsx)($919ad8d5ff9ebb8c$exports.ScrollbarCorner, {
                "aria-hidden": "true"
            }),
            props.children
        ]
    }));
}




Object.keys($f1c85321eab9b516$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $ecac20e02127a1f6$exports && $ecac20e02127a1f6$exports[key] === $f1c85321eab9b516$exports[key]) return;
    Object.defineProperty($ecac20e02127a1f6$exports, key, {
        enumerable: true,
        get: function() {
            return $f1c85321eab9b516$exports[key];
        }
    });
});
var $a916d8fa7c7fb6bb$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a916d8fa7c7fb6bb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($a916d8fa7c7fb6bb$exports, "__esModule", {
    value: true
});
$a916d8fa7c7fb6bb$exports.GridFooterPlaceholder = $a916d8fa7c7fb6bb$var$GridFooterPlaceholder;

var $a916d8fa7c7fb6bb$var$_extends2 = $a916d8fa7c7fb6bb$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
function $a916d8fa7c7fb6bb$var$GridFooterPlaceholder() {
    const rootProps = (0, $jDpXp.useGridRootProps)();
    if (rootProps.hideFooter) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.footer, (0, $a916d8fa7c7fb6bb$var$_extends2.default)({}, rootProps.slotProps?.footer /* FIXME: typing error */ ));
}


Object.keys($a916d8fa7c7fb6bb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $ecac20e02127a1f6$exports && $ecac20e02127a1f6$exports[key] === $a916d8fa7c7fb6bb$exports[key]) return;
    Object.defineProperty($ecac20e02127a1f6$exports, key, {
        enumerable: true,
        get: function() {
            return $a916d8fa7c7fb6bb$exports[key];
        }
    });
});


Object.keys($ecac20e02127a1f6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in $08eee520e810d520$exports && $08eee520e810d520$exports[key] === $ecac20e02127a1f6$exports[key]) return;
    Object.defineProperty($08eee520e810d520$exports, key, {
        enumerable: true,
        get: function() {
            return $ecac20e02127a1f6$exports[key];
        }
    });
});
var $51e9dbb1a242f696$exports = {};
"use strict";
Object.defineProperty($51e9dbb1a242f696$exports, "__esModule", {
    value: true
});
var $51e9dbb1a242f696$var$_exportNames = {
    GridCell: true
};
Object.defineProperty($51e9dbb1a242f696$exports, "GridCell", {
    enumerable: true,
    get: function() {
        return $50fa6cd6ff946acb$exports.GridCell;
    }
});
var $50fa6cd6ff946acb$exports = {};
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $50fa6cd6ff946acb$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $50fa6cd6ff946acb$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($50fa6cd6ff946acb$exports, "__esModule", {
    value: true
});
$50fa6cd6ff946acb$exports.gridPinnedColumnPositionLookup = $50fa6cd6ff946acb$exports.GridCell = void 0;

var $50fa6cd6ff946acb$var$_extends2 = $50fa6cd6ff946acb$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $50fa6cd6ff946acb$var$_objectWithoutPropertiesLoose2 = $50fa6cd6ff946acb$require$_interopRequireDefault((parcelRequire("c05no")));

var $50fa6cd6ff946acb$var$React = $50fa6cd6ff946acb$require$_interopRequireWildcard((parcelRequire("acw62")));

var $50fa6cd6ff946acb$var$_propTypes = $50fa6cd6ff946acb$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $50fa6cd6ff946acb$var$_clsx = $50fa6cd6ff946acb$require$_interopRequireDefault((parcelRequire("9QePP")));

var $50fa6cd6ff946acb$var$_useForkRef = $50fa6cd6ff946acb$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $50fa6cd6ff946acb$var$_composeClasses = $50fa6cd6ff946acb$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $50fa6cd6ff946acb$var$_ownerDocument = $50fa6cd6ff946acb$require$_interopRequireDefault((parcelRequire("43fuO")));

var $50fa6cd6ff946acb$var$_capitalize = $50fa6cd6ff946acb$require$_interopRequireDefault((parcelRequire("4O6za")));


var $9uEev = parcelRequire("9uEev");

var $fYxgT = parcelRequire("fYxgT");



var $50fa6cd6ff946acb$var$_useEnhancedEffect = $50fa6cd6ff946acb$require$_interopRequireDefault((parcelRequire("jdWO4")));
var $bad574edb71acea7$exports = {};
"use strict";
Object.defineProperty($bad574edb71acea7$exports, "__esModule", {
    value: true
});
$bad574edb71acea7$exports.doesSupportPreventScroll = $bad574edb71acea7$var$doesSupportPreventScroll;
// Based on https://stackoverflow.com/a/59518678
let $bad574edb71acea7$var$cachedSupportsPreventScroll;
function $bad574edb71acea7$var$doesSupportPreventScroll() {
    if ($bad574edb71acea7$var$cachedSupportsPreventScroll === undefined) document.createElement('div').focus({
        get preventScroll () {
            $bad574edb71acea7$var$cachedSupportsPreventScroll = true;
            return false;
        }
    });
    return $bad574edb71acea7$var$cachedSupportsPreventScroll;
}



var $5H1vo = parcelRequire("5H1vo");


var $5sOMZ = parcelRequire("5sOMZ");

var $jDpXp = parcelRequire("jDpXp");




var $er55f = parcelRequire("er55f");

var $69aaaa4d4ca0aa66$exports = {};
"use strict";
Object.defineProperty($69aaaa4d4ca0aa66$exports, "__esModule", {
    value: true
});
var $39f1439fa7b8d5d4$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $39f1439fa7b8d5d4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($39f1439fa7b8d5d4$exports, "__esModule", {
    value: true
});
$39f1439fa7b8d5d4$exports.computeSlots = $39f1439fa7b8d5d4$var$computeSlots;

var $39f1439fa7b8d5d4$var$_extends2 = $39f1439fa7b8d5d4$require$_interopRequireDefault((parcelRequire("3p9rK")));
function $39f1439fa7b8d5d4$var$computeSlots({ defaultSlots: defaultSlots, slots: slots }) {
    const overrides = slots;
    if (!overrides || Object.keys(overrides).length === 0) return defaultSlots;
    const result = (0, $39f1439fa7b8d5d4$var$_extends2.default)({}, defaultSlots);
    Object.keys(overrides).forEach((key)=>{
        const k = key;
        if (overrides[k] !== undefined) result[k] = overrides[k];
    });
    return result;
}


Object.keys($39f1439fa7b8d5d4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $69aaaa4d4ca0aa66$exports && $69aaaa4d4ca0aa66$exports[key] === $39f1439fa7b8d5d4$exports[key]) return;
    Object.defineProperty($69aaaa4d4ca0aa66$exports, key, {
        enumerable: true,
        get: function() {
            return $39f1439fa7b8d5d4$exports[key];
        }
    });
});
var $a1b65922f847acc6$exports = {};
"use strict";
Object.defineProperty($a1b65922f847acc6$exports, "__esModule", {
    value: true
});
$a1b65922f847acc6$exports.propValidatorsDataGrid = void 0;
$a1b65922f847acc6$exports.validateProps = $a1b65922f847acc6$var$validateProps;

var $9Y8Cp = parcelRequire("9Y8Cp");


const $a1b65922f847acc6$var$propValidatorsDataGrid = $a1b65922f847acc6$exports.propValidatorsDataGrid = [
    (props)=>props.autoPageSize && props.autoHeight && [
            'MUI X: `<DataGrid autoPageSize={true} autoHeight={true} />` are not valid props.',
            'You cannot use both the `autoPageSize` and `autoHeight` props at the same time because `autoHeight` scales the height of the Data Grid according to the `pageSize`.',
            '',
            'Please remove one of these two props.'
        ].join('\n') || undefined,
    (props)=>props.paginationMode === 'client' && props.paginationMeta != null && [
            'MUI X: Usage of the `paginationMeta` prop with client-side pagination (`paginationMode="client"`) has no effect.',
            '`paginationMeta` is only meant to be used with `paginationMode="server"`.'
        ].join('\n') || undefined,
    (props)=>props.signature === $dc886d040ec4e87c$exports.GridSignature.DataGrid && props.paginationMode === 'client' && (0, $fe919794eb3b24e8$exports.isNumber)(props.rowCount) && [
            'MUI X: Usage of the `rowCount` prop with client side pagination (`paginationMode="client"`) has no effect.',
            '`rowCount` is only meant to be used with `paginationMode="server"`.'
        ].join('\n') || undefined,
    (props)=>props.paginationMode === 'server' && props.rowCount == null && !props.dataSource && [
            "MUI X: The `rowCount` prop must be passed using `paginationMode='server'`",
            'For more detail, see http://mui.com/components/data-grid/pagination/#index-based-pagination'
        ].join('\n') || undefined
];
function $a1b65922f847acc6$var$validateProps(props, validators) {
    validators.forEach((validator)=>{
        const message = validator(props);
        if (message) (0, $9Y8Cp.warnOnce)(message, 'error');
    });
}


Object.keys($a1b65922f847acc6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $69aaaa4d4ca0aa66$exports && $69aaaa4d4ca0aa66$exports[key] === $a1b65922f847acc6$exports[key]) return;
    Object.defineProperty($69aaaa4d4ca0aa66$exports, key, {
        enumerable: true,
        get: function() {
            return $a1b65922f847acc6$exports[key];
        }
    });
});
var $c46389eb8540b1dc$exports = {};
"use strict";
Object.defineProperty($c46389eb8540b1dc$exports, "__esModule", {
    value: true
});
$c46389eb8540b1dc$exports.isGroupingColumn = $c46389eb8540b1dc$exports.getRowGroupingCriteriaFromGroupingField = void 0;

const $c46389eb8540b1dc$var$getRowGroupingCriteriaFromGroupingField = (groupingColDefField)=>{
    const match = groupingColDefField.match(/^__row_group_by_columns_group_(.*)__$/);
    if (!match) return null;
    return match[1];
};
$c46389eb8540b1dc$exports.getRowGroupingCriteriaFromGroupingField = $c46389eb8540b1dc$var$getRowGroupingCriteriaFromGroupingField;
const $c46389eb8540b1dc$var$isGroupingColumn = (field)=>field === $e8d35a7c12bdaa1d$exports.GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD || $c46389eb8540b1dc$var$getRowGroupingCriteriaFromGroupingField(field) !== null;
$c46389eb8540b1dc$exports.isGroupingColumn = $c46389eb8540b1dc$var$isGroupingColumn;


Object.keys($c46389eb8540b1dc$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $69aaaa4d4ca0aa66$exports && $69aaaa4d4ca0aa66$exports[key] === $c46389eb8540b1dc$exports[key]) return;
    Object.defineProperty($69aaaa4d4ca0aa66$exports, key, {
        enumerable: true,
        get: function() {
            return $c46389eb8540b1dc$exports[key];
        }
    });
});
var $edbf7a081e32bed0$exports = {};
"use strict";
Object.defineProperty($edbf7a081e32bed0$exports, "__esModule", {
    value: true
});
$edbf7a081e32bed0$exports.attachPinnedStyle = $edbf7a081e32bed0$var$attachPinnedStyle;
var $02cd8e055a355186$exports = {};
"use strict";
Object.defineProperty($02cd8e055a355186$exports, "__esModule", {
    value: true
});
$02cd8e055a355186$exports.rtlFlipSide = void 0;

const $02cd8e055a355186$var$rtlFlipSide = (position, isRtl)=>{
    if (!position) return undefined;
    if (!isRtl) {
        if (position === $e8d35a7c12bdaa1d$exports.PinnedColumnPosition.LEFT) return 'left';
        if (position === $e8d35a7c12bdaa1d$exports.PinnedColumnPosition.RIGHT) return 'right';
    } else {
        if (position === $e8d35a7c12bdaa1d$exports.PinnedColumnPosition.LEFT) return 'right';
        if (position === $e8d35a7c12bdaa1d$exports.PinnedColumnPosition.RIGHT) return 'left';
    }
    return undefined;
};
$02cd8e055a355186$exports.rtlFlipSide = $02cd8e055a355186$var$rtlFlipSide;


function $edbf7a081e32bed0$var$attachPinnedStyle(style, isRtl, pinnedPosition, pinnedOffset) {
    const side = (0, $02cd8e055a355186$exports.rtlFlipSide)(pinnedPosition, isRtl);
    if (!side || pinnedOffset === undefined) return style;
    style[side] = pinnedOffset;
    return style;
}


Object.keys($edbf7a081e32bed0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $69aaaa4d4ca0aa66$exports && $69aaaa4d4ca0aa66$exports[key] === $edbf7a081e32bed0$exports[key]) return;
    Object.defineProperty($69aaaa4d4ca0aa66$exports, key, {
        enumerable: true,
        get: function() {
            return $edbf7a081e32bed0$exports[key];
        }
    });
});
var $5c48116f72f2a548$exports = {};
"use strict";
Object.defineProperty($5c48116f72f2a548$exports, "__esModule", {
    value: true
});
$5c48116f72f2a548$exports.TestCache = void 0;

class $5c48116f72f2a548$var$TestCache {
    constructor(){
        this.cache = new Map();
    }
    set(key, value) {
        this.cache.set((0, $5446b637625dfefc$exports.getKeyDefault)(key), value);
    }
    get(key) {
        return this.cache.get((0, $5446b637625dfefc$exports.getKeyDefault)(key));
    }
    size() {
        return this.cache.size;
    }
    clear() {
        this.cache.clear();
    }
}
$5c48116f72f2a548$exports.TestCache = $5c48116f72f2a548$var$TestCache;


Object.keys($5c48116f72f2a548$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $69aaaa4d4ca0aa66$exports && $69aaaa4d4ca0aa66$exports[key] === $5c48116f72f2a548$exports[key]) return;
    Object.defineProperty($69aaaa4d4ca0aa66$exports, key, {
        enumerable: true,
        get: function() {
            return $5c48116f72f2a548$exports[key];
        }
    });
});




var $ayMG0 = parcelRequire("ayMG0");
const $50fa6cd6ff946acb$var$_excluded = [
    "column",
    "row",
    "rowId",
    "rowNode",
    "align",
    "children",
    "colIndex",
    "width",
    "className",
    "style",
    "colSpan",
    "disableDragEvents",
    "isNotVisible",
    "pinnedOffset",
    "pinnedPosition",
    "showRightBorder",
    "showLeftBorder",
    "onClick",
    "onDoubleClick",
    "onMouseDown",
    "onMouseUp",
    "onMouseOver",
    "onKeyDown",
    "onKeyUp",
    "onDragEnter",
    "onDragOver"
], $50fa6cd6ff946acb$var$_excluded2 = [
    "changeReason",
    "unstable_updateValueOnRender"
];
const $50fa6cd6ff946acb$var$gridPinnedColumnPositionLookup = $50fa6cd6ff946acb$exports.gridPinnedColumnPositionLookup = {
    [$e8d35a7c12bdaa1d$exports.PinnedColumnPosition.LEFT]: $3a32d3fdbf8b29fd$exports.GridPinnedColumnPosition.LEFT,
    [$e8d35a7c12bdaa1d$exports.PinnedColumnPosition.RIGHT]: $3a32d3fdbf8b29fd$exports.GridPinnedColumnPosition.RIGHT,
    [$e8d35a7c12bdaa1d$exports.PinnedColumnPosition.NONE]: undefined,
    [$e8d35a7c12bdaa1d$exports.PinnedColumnPosition.VIRTUAL]: undefined
};
const $50fa6cd6ff946acb$var$useUtilityClasses = (ownerState)=>{
    const { align: align, showLeftBorder: showLeftBorder, showRightBorder: showRightBorder, pinnedPosition: pinnedPosition, isEditable: isEditable, isSelected: isSelected, isSelectionMode: isSelectionMode, classes: classes } = ownerState;
    const slots = {
        root: [
            'cell',
            `cell--text${(0, $50fa6cd6ff946acb$var$_capitalize.default)(align)}`,
            isSelected && 'selected',
            isEditable && 'cell--editable',
            showLeftBorder && 'cell--withLeftBorder',
            showRightBorder && 'cell--withRightBorder',
            pinnedPosition === $e8d35a7c12bdaa1d$exports.PinnedColumnPosition.LEFT && 'cell--pinnedLeft',
            pinnedPosition === $e8d35a7c12bdaa1d$exports.PinnedColumnPosition.RIGHT && 'cell--pinnedRight',
            isSelectionMode && !isEditable && 'cell--selectionMode'
        ]
    };
    return (0, $50fa6cd6ff946acb$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
let $50fa6cd6ff946acb$var$warnedOnce = false;
// TODO(v7): Removing the wrapper will break the docs performance visualization demo.
const $50fa6cd6ff946acb$var$GridCell = (0, $fYxgT.forwardRef)(function GridCell(props, ref) {
    const { column: column, row: row, rowId: rowId, rowNode: rowNode, align: align, colIndex: colIndex, width: width, className: className, style: styleProp, colSpan: colSpan, disableDragEvents: disableDragEvents, isNotVisible: isNotVisible, pinnedOffset: pinnedOffset, pinnedPosition: pinnedPosition, showRightBorder: showRightBorder, showLeftBorder: showLeftBorder, onClick: onClick, onDoubleClick: onDoubleClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseOver: onMouseOver, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onDragEnter: onDragEnter, onDragOver: onDragOver } = props, other = (0, $50fa6cd6ff946acb$var$_objectWithoutPropertiesLoose2.default)(props, $50fa6cd6ff946acb$var$_excluded);
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const isRtl = (0, $9uEev.useRtl)();
    const field = column.field;
    const editCellState = (0, $5sOMZ.useGridSelector)(apiRef, $443dd6b911893b50$exports.gridEditCellStateSelector, {
        rowId: rowId,
        field: field
    });
    const config = (0, $2b6c64068d1db0b4$exports.useGridConfiguration)();
    const cellAggregationResult = config.hooks.useCellAggregationResult(rowId, field);
    const cellMode = editCellState ? $2f20061a3ca46e99$exports.GridCellModes.Edit : $2f20061a3ca46e99$exports.GridCellModes.View;
    const { value: forcedValue, formattedValue: forcedFormattedValue } = cellAggregationResult || {};
    const cellParams = apiRef.current.getCellParamsForRow(rowId, field, row, {
        colDef: column,
        cellMode: cellMode,
        rowNode: rowNode,
        tabIndex: (0, $5sOMZ.useGridSelector)(apiRef, ()=>{
            const cellTabIndex = (0, $9c9b8e89fddd633d$exports.gridTabIndexCellSelector)(apiRef);
            return cellTabIndex && cellTabIndex.field === field && cellTabIndex.id === rowId ? 0 : -1;
        }),
        hasFocus: (0, $5sOMZ.useGridSelector)(apiRef, ()=>{
            const focus = (0, $9c9b8e89fddd633d$exports.gridFocusCellSelector)(apiRef);
            return focus?.id === rowId && focus.field === field;
        }),
        value: forcedValue,
        formattedValue: forcedFormattedValue
    });
    cellParams.api = apiRef.current;
    // Subscribe to changes of the `isCellEditable` API result to ensure cells re-render.
    // We don't use the result.
    // Subscription will trigger a new call of `getCellParamsForRow` above which will recompute the correct value of `isEditable`.
    // This is to ensure both of the following cases work:
    // - https://github.com/mui/mui-x/issues/19732
    // - https://github.com/mui/mui-x/issues/20143
    (0, $5sOMZ.useGridSelector)(apiRef, ()=>apiRef.current.isCellEditable(cellParams));
    const isSelected = (0, $5sOMZ.useGridSelector)(apiRef, ()=>apiRef.current.unstable_applyPipeProcessors('isCellSelected', false, {
            id: rowId,
            field: field
        }));
    const store = apiRef.current.virtualizer.store;
    const hiddenCells = (0, $66c3b1bd8ca83ba8$exports.useStore)(store, $f627be570fb53c87$exports.Rowspan.selectors.hiddenCells);
    const spannedCells = (0, $66c3b1bd8ca83ba8$exports.useStore)(store, $f627be570fb53c87$exports.Rowspan.selectors.spannedCells);
    const { hasFocus: hasFocus, isEditable: isEditable = false, value: value } = cellParams;
    const tabIndex = (cellMode === 'view' || !isEditable) && column.type !== 'actions' ? cellParams.tabIndex : -1;
    const { classes: rootClasses, getCellClassName: getCellClassName } = rootProps;
    // There is a hidden grid state access in `applyPipeProcessor('cellClassName', ...)`
    const pipesClassName = (0, $5sOMZ.useGridSelector)(apiRef, ()=>apiRef.current.unstable_applyPipeProcessors('cellClassName', [], {
            id: rowId,
            field: field
        }).filter(Boolean).join(' '));
    const classNames = [
        pipesClassName
    ];
    if (column.cellClassName) classNames.push(typeof column.cellClassName === 'function' ? column.cellClassName(cellParams) : column.cellClassName);
    if (column.display === 'flex') classNames.push($5H1vo.gridClasses['cell--flex']);
    if (getCellClassName) classNames.push(getCellClassName(cellParams));
    const valueToRender = cellParams.formattedValue ?? value;
    const cellRef = $50fa6cd6ff946acb$var$React.useRef(null);
    const handleRef = (0, $50fa6cd6ff946acb$var$_useForkRef.default)(ref, cellRef);
    const isSelectionMode = rootProps.cellSelection ?? false;
    const ownerState = {
        align: align,
        showLeftBorder: showLeftBorder,
        showRightBorder: showRightBorder,
        isEditable: isEditable,
        classes: rootProps.classes,
        pinnedPosition: pinnedPosition,
        isSelected: isSelected,
        isSelectionMode: isSelectionMode
    };
    const classes = $50fa6cd6ff946acb$var$useUtilityClasses(ownerState);
    const publishMouseUp = $50fa6cd6ff946acb$var$React.useCallback((eventName)=>(event)=>{
            const params = apiRef.current.getCellParams(rowId, field || '');
            apiRef.current.publishEvent(eventName, params, event);
            if (onMouseUp) onMouseUp(event);
        }, [
        apiRef,
        field,
        onMouseUp,
        rowId
    ]);
    const publishMouseDown = $50fa6cd6ff946acb$var$React.useCallback((eventName)=>(event)=>{
            const params = apiRef.current.getCellParams(rowId, field || '');
            apiRef.current.publishEvent(eventName, params, event);
            if (onMouseDown) onMouseDown(event);
        }, [
        apiRef,
        field,
        onMouseDown,
        rowId
    ]);
    const publish = $50fa6cd6ff946acb$var$React.useCallback((eventName, propHandler)=>(event)=>{
            // The row might have been deleted during the click
            if (!apiRef.current.getRow(rowId)) return;
            const params = apiRef.current.getCellParams(rowId, field || '');
            apiRef.current.publishEvent(eventName, params, event);
            if (propHandler) propHandler(event);
        }, [
        apiRef,
        field,
        rowId
    ]);
    const isCellRowSpanned = hiddenCells[rowId]?.[colIndex] ?? false;
    const rowSpan = spannedCells[rowId]?.[colIndex] ?? 1;
    const style = $50fa6cd6ff946acb$var$React.useMemo(()=>{
        if (isNotVisible) return {
            padding: 0,
            opacity: 0,
            width: 0,
            height: 0,
            border: 0
        };
        const cellStyle = (0, $69aaaa4d4ca0aa66$exports.attachPinnedStyle)((0, $50fa6cd6ff946acb$var$_extends2.default)({
            '--width': `${width}px`
        }, styleProp), isRtl, pinnedPosition, pinnedOffset);
        const isLeftPinned = pinnedPosition === $e8d35a7c12bdaa1d$exports.PinnedColumnPosition.LEFT;
        const isRightPinned = pinnedPosition === $e8d35a7c12bdaa1d$exports.PinnedColumnPosition.RIGHT;
        if (rowSpan > 1) {
            cellStyle.height = `calc(var(--height) * ${rowSpan})`;
            cellStyle.zIndex = 10;
            if (isLeftPinned || isRightPinned) cellStyle.zIndex = 40;
        }
        return cellStyle;
    }, [
        width,
        isNotVisible,
        styleProp,
        pinnedOffset,
        pinnedPosition,
        isRtl,
        rowSpan
    ]);
    (0, $50fa6cd6ff946acb$var$_useEnhancedEffect.default)(()=>{
        if (!hasFocus || cellMode === $2f20061a3ca46e99$exports.GridCellModes.Edit) return;
        const doc = (0, $50fa6cd6ff946acb$var$_ownerDocument.default)(apiRef.current.rootElementRef.current);
        if (cellRef.current && !cellRef.current.contains(doc.activeElement)) {
            const focusableElement = cellRef.current.querySelector('[tabindex="0"]');
            const elementToFocus = focusableElement || cellRef.current;
            if ((0, $bad574edb71acea7$exports.doesSupportPreventScroll)()) elementToFocus.focus({
                preventScroll: true
            });
            else {
                const scrollPosition = apiRef.current.getScrollPosition();
                elementToFocus.focus();
                apiRef.current.scroll(scrollPosition);
            }
        }
    }, [
        hasFocus,
        cellMode,
        apiRef
    ]);
    if (isCellRowSpanned) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        "data-colindex": colIndex,
        role: "presentation",
        style: (0, $50fa6cd6ff946acb$var$_extends2.default)({
            width: 'var(--width)'
        }, style)
    });
    let handleFocus = other.onFocus;
    var event;
    let children;
    let title;
    if (editCellState === null && column.renderCell) children = column.renderCell(cellParams);
    if (editCellState !== null && column.renderEditCell) {
        const updatedRow = apiRef.current.getRowWithUpdatedValues(rowId, column.field);
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const editCellStateRest = (0, $50fa6cd6ff946acb$var$_objectWithoutPropertiesLoose2.default)(editCellState, $50fa6cd6ff946acb$var$_excluded2);
        const formattedValue = column.valueFormatter ? column.valueFormatter(editCellState.value, updatedRow, column, apiRef) : cellParams.formattedValue;
        const params = (0, $50fa6cd6ff946acb$var$_extends2.default)({}, cellParams, {
            row: updatedRow,
            formattedValue: formattedValue
        }, editCellStateRest);
        children = column.renderEditCell(params);
        classNames.push($5H1vo.gridClasses['cell--editing']);
        classNames.push(rootClasses?.['cell--editing']);
    }
    if (children === undefined) {
        const valueString = valueToRender?.toString();
        children = valueString;
        title = valueString;
    }
    const draggableEventHandlers = disableDragEvents ? null : {
        onDragEnter: publish('cellDragEnter', onDragEnter),
        onDragOver: publish('cellDragOver', onDragOver)
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", (0, $50fa6cd6ff946acb$var$_extends2.default)({
        className: (0, $50fa6cd6ff946acb$var$_clsx.default)(classes.root, classNames, className),
        role: "gridcell",
        "data-field": field,
        "data-colindex": colIndex,
        "aria-colindex": colIndex + 1,
        "aria-colspan": colSpan,
        "aria-rowspan": rowSpan,
        style: style,
        title: title,
        tabIndex: tabIndex,
        onClick: publish('cellClick', onClick),
        onDoubleClick: publish('cellDoubleClick', onDoubleClick),
        onMouseOver: publish('cellMouseOver', onMouseOver),
        onMouseDown: publishMouseDown('cellMouseDown'),
        onMouseUp: publishMouseUp('cellMouseUp'),
        onKeyDown: publish('cellKeyDown', onKeyDown),
        onKeyUp: publish('cellKeyUp', onKeyUp)
    }, draggableEventHandlers, other, {
        onFocus: handleFocus,
        ref: handleRef,
        children: children
    }));
});
$50fa6cd6ff946acb$var$GridCell.displayName = "GridCell";
$50fa6cd6ff946acb$var$GridCell.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    align: $50fa6cd6ff946acb$var$_propTypes.default.oneOf([
        'center',
        'left',
        'right'
    ]).isRequired,
    colIndex: $50fa6cd6ff946acb$var$_propTypes.default.number.isRequired,
    colSpan: $50fa6cd6ff946acb$var$_propTypes.default.number,
    column: $50fa6cd6ff946acb$var$_propTypes.default.object.isRequired,
    disableDragEvents: $50fa6cd6ff946acb$var$_propTypes.default.bool,
    isNotVisible: $50fa6cd6ff946acb$var$_propTypes.default.bool.isRequired,
    pinnedOffset: $50fa6cd6ff946acb$var$_propTypes.default.number,
    pinnedPosition: $50fa6cd6ff946acb$var$_propTypes.default.oneOf([
        0,
        1,
        2,
        3
    ]).isRequired,
    row: $50fa6cd6ff946acb$var$_propTypes.default.object.isRequired,
    rowId: $50fa6cd6ff946acb$var$_propTypes.default.oneOfType([
        $50fa6cd6ff946acb$var$_propTypes.default.number,
        $50fa6cd6ff946acb$var$_propTypes.default.string
    ]).isRequired,
    rowNode: $50fa6cd6ff946acb$var$_propTypes.default.object.isRequired,
    showLeftBorder: $50fa6cd6ff946acb$var$_propTypes.default.bool.isRequired,
    showRightBorder: $50fa6cd6ff946acb$var$_propTypes.default.bool.isRequired,
    width: $50fa6cd6ff946acb$var$_propTypes.default.number.isRequired
};
const $50fa6cd6ff946acb$var$MemoizedGridCell = $50fa6cd6ff946acb$exports.GridCell = (0, $1bc1b286f3c678cc$exports.fastMemo)($50fa6cd6ff946acb$var$GridCell);



Object.keys($6324800d89fce0fa$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($51e9dbb1a242f696$var$_exportNames, key)) return;
    if (key in $51e9dbb1a242f696$exports && $51e9dbb1a242f696$exports[key] === $6324800d89fce0fa$exports[key]) return;
    Object.defineProperty($51e9dbb1a242f696$exports, key, {
        enumerable: true,
        get: function() {
            return $6324800d89fce0fa$exports[key];
        }
    });
});

Object.keys($cb74606ec716e4c3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($51e9dbb1a242f696$var$_exportNames, key)) return;
    if (key in $51e9dbb1a242f696$exports && $51e9dbb1a242f696$exports[key] === $cb74606ec716e4c3$exports[key]) return;
    Object.defineProperty($51e9dbb1a242f696$exports, key, {
        enumerable: true,
        get: function() {
            return $cb74606ec716e4c3$exports[key];
        }
    });
});

Object.keys($2a475a2a246869fc$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($51e9dbb1a242f696$var$_exportNames, key)) return;
    if (key in $51e9dbb1a242f696$exports && $51e9dbb1a242f696$exports[key] === $2a475a2a246869fc$exports[key]) return;
    Object.defineProperty($51e9dbb1a242f696$exports, key, {
        enumerable: true,
        get: function() {
            return $2a475a2a246869fc$exports[key];
        }
    });
});

Object.keys($387abc8f0fc4c9a9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($51e9dbb1a242f696$var$_exportNames, key)) return;
    if (key in $51e9dbb1a242f696$exports && $51e9dbb1a242f696$exports[key] === $387abc8f0fc4c9a9$exports[key]) return;
    Object.defineProperty($51e9dbb1a242f696$exports, key, {
        enumerable: true,
        get: function() {
            return $387abc8f0fc4c9a9$exports[key];
        }
    });
});

Object.keys($53ef9bd93fd99a94$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($51e9dbb1a242f696$var$_exportNames, key)) return;
    if (key in $51e9dbb1a242f696$exports && $51e9dbb1a242f696$exports[key] === $53ef9bd93fd99a94$exports[key]) return;
    Object.defineProperty($51e9dbb1a242f696$exports, key, {
        enumerable: true,
        get: function() {
            return $53ef9bd93fd99a94$exports[key];
        }
    });
});

Object.keys($8e08f1e439e1e2b5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($51e9dbb1a242f696$var$_exportNames, key)) return;
    if (key in $51e9dbb1a242f696$exports && $51e9dbb1a242f696$exports[key] === $8e08f1e439e1e2b5$exports[key]) return;
    Object.defineProperty($51e9dbb1a242f696$exports, key, {
        enumerable: true,
        get: function() {
            return $8e08f1e439e1e2b5$exports[key];
        }
    });
});

Object.keys($5785bd871901a1ec$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($51e9dbb1a242f696$var$_exportNames, key)) return;
    if (key in $51e9dbb1a242f696$exports && $51e9dbb1a242f696$exports[key] === $5785bd871901a1ec$exports[key]) return;
    Object.defineProperty($51e9dbb1a242f696$exports, key, {
        enumerable: true,
        get: function() {
            return $5785bd871901a1ec$exports[key];
        }
    });
});
var $a8a876e822978977$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a8a876e822978977$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $a8a876e822978977$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($a8a876e822978977$exports, "__esModule", {
    value: true
});
$a8a876e822978977$exports.GridSkeletonCell = void 0;

var $a8a876e822978977$var$_extends2 = $a8a876e822978977$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $a8a876e822978977$var$_objectWithoutPropertiesLoose2 = $a8a876e822978977$require$_interopRequireDefault((parcelRequire("c05no")));

var $a8a876e822978977$var$React = $a8a876e822978977$require$_interopRequireWildcard((parcelRequire("acw62")));

var $a8a876e822978977$var$_propTypes = $a8a876e822978977$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $a8a876e822978977$var$_clsx = $a8a876e822978977$require$_interopRequireDefault((parcelRequire("9QePP")));

var $a8a876e822978977$var$_composeClasses = $a8a876e822978977$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $a8a876e822978977$var$_capitalize = $a8a876e822978977$require$_interopRequireDefault((parcelRequire("4O6za")));



var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");

var $ayMG0 = parcelRequire("ayMG0");
const $a8a876e822978977$var$_excluded = [
    "field",
    "type",
    "align",
    "width",
    "height",
    "empty",
    "style",
    "className"
];
const $a8a876e822978977$var$CIRCULAR_CONTENT_SIZE = '1.3em';
const $a8a876e822978977$var$CONTENT_HEIGHT = '1.2em';
const $a8a876e822978977$var$DEFAULT_CONTENT_WIDTH_RANGE = [
    40,
    80
];
const $a8a876e822978977$var$CONTENT_WIDTH_RANGE_BY_TYPE = {
    number: [
        40,
        60
    ],
    string: [
        40,
        80
    ],
    date: [
        40,
        60
    ],
    dateTime: [
        60,
        80
    ],
    singleSelect: [
        40,
        80
    ]
};
const $a8a876e822978977$var$useUtilityClasses = (ownerState)=>{
    const { align: align, classes: classes, empty: empty } = ownerState;
    const slots = {
        root: [
            'cell',
            'cellSkeleton',
            `cell--text${align ? (0, $a8a876e822978977$var$_capitalize.default)(align) : 'Left'}`,
            empty && 'cellEmpty'
        ]
    };
    return (0, $a8a876e822978977$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $a8a876e822978977$var$randomNumberGenerator = (0, $fe919794eb3b24e8$exports.createRandomNumberGenerator)(12345);
function $a8a876e822978977$var$GridSkeletonCell(props) {
    const { field: field, type: type, align: align, width: width, height: height, empty: empty = false, style: style, className: className } = props, other = (0, $a8a876e822978977$var$_objectWithoutPropertiesLoose2.default)(props, $a8a876e822978977$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = {
        classes: rootProps.classes,
        align: align,
        empty: empty
    };
    const classes = $a8a876e822978977$var$useUtilityClasses(ownerState);
    // Memo prevents the non-circular skeleton widths changing to random widths on every render
    const skeletonProps = $a8a876e822978977$var$React.useMemo(()=>{
        const isCircularContent = type === 'boolean' || type === 'actions';
        if (isCircularContent) return {
            variant: 'circular',
            width: $a8a876e822978977$var$CIRCULAR_CONTENT_SIZE,
            height: $a8a876e822978977$var$CIRCULAR_CONTENT_SIZE
        };
        // The width of the skeleton is a random number between the min and max values
        // The min and max values are determined by the type of the column
        const [min, max] = type ? $a8a876e822978977$var$CONTENT_WIDTH_RANGE_BY_TYPE[type] ?? $a8a876e822978977$var$DEFAULT_CONTENT_WIDTH_RANGE : $a8a876e822978977$var$DEFAULT_CONTENT_WIDTH_RANGE;
        return {
            variant: 'text',
            width: `${Math.round($a8a876e822978977$var$randomNumberGenerator(min, max))}%`,
            height: $a8a876e822978977$var$CONTENT_HEIGHT
        };
    }, [
        type
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", (0, $a8a876e822978977$var$_extends2.default)({
        "data-field": field,
        className: (0, $a8a876e822978977$var$_clsx.default)(classes.root, className),
        style: (0, $a8a876e822978977$var$_extends2.default)({
            height: height,
            maxWidth: width,
            minWidth: width
        }, style)
    }, other, {
        children: !empty && /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseSkeleton, (0, $a8a876e822978977$var$_extends2.default)({}, skeletonProps))
    }));
}
$a8a876e822978977$var$GridSkeletonCell.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    align: $a8a876e822978977$var$_propTypes.default.string,
    /**
   * If `true`, the cell will not display the skeleton but still reserve the cell space.
   * @default false
   */ empty: $a8a876e822978977$var$_propTypes.default.bool,
    field: $a8a876e822978977$var$_propTypes.default.string,
    height: $a8a876e822978977$var$_propTypes.default.oneOfType([
        $a8a876e822978977$var$_propTypes.default.oneOf([
            'auto'
        ]),
        $a8a876e822978977$var$_propTypes.default.number
    ]),
    type: $a8a876e822978977$var$_propTypes.default.oneOf([
        'actions',
        'boolean',
        'custom',
        'date',
        'dateTime',
        'number',
        'singleSelect',
        'string'
    ]),
    width: $a8a876e822978977$var$_propTypes.default.oneOfType([
        $a8a876e822978977$var$_propTypes.default.number,
        $a8a876e822978977$var$_propTypes.default.string
    ])
};
const $a8a876e822978977$var$Memoized = $a8a876e822978977$exports.GridSkeletonCell = (0, $1bc1b286f3c678cc$exports.fastMemo)($a8a876e822978977$var$GridSkeletonCell);


Object.keys($a8a876e822978977$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($51e9dbb1a242f696$var$_exportNames, key)) return;
    if (key in $51e9dbb1a242f696$exports && $51e9dbb1a242f696$exports[key] === $a8a876e822978977$exports[key]) return;
    Object.defineProperty($51e9dbb1a242f696$exports, key, {
        enumerable: true,
        get: function() {
            return $a8a876e822978977$exports[key];
        }
    });
});


Object.keys($51e9dbb1a242f696$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in $08eee520e810d520$exports && $08eee520e810d520$exports[key] === $51e9dbb1a242f696$exports[key]) return;
    Object.defineProperty($08eee520e810d520$exports, key, {
        enumerable: true,
        get: function() {
            return $51e9dbb1a242f696$exports[key];
        }
    });
});
var $f5ace3cc4f8b4ab7$exports = {};
"use strict";
Object.defineProperty($f5ace3cc4f8b4ab7$exports, "__esModule", {
    value: true
});
var $727133a3c635b8ae$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $727133a3c635b8ae$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $727133a3c635b8ae$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($727133a3c635b8ae$exports, "__esModule", {
    value: true
});
$727133a3c635b8ae$exports.GridRoot = void 0;

var $727133a3c635b8ae$var$_extends2 = $727133a3c635b8ae$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $727133a3c635b8ae$var$_objectWithoutPropertiesLoose2 = $727133a3c635b8ae$require$_interopRequireDefault((parcelRequire("c05no")));

var $727133a3c635b8ae$var$React = $727133a3c635b8ae$require$_interopRequireWildcard((parcelRequire("acw62")));

var $727133a3c635b8ae$var$_propTypes = $727133a3c635b8ae$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $727133a3c635b8ae$var$_clsx = $727133a3c635b8ae$require$_interopRequireDefault((parcelRequire("9QePP")));

var $727133a3c635b8ae$var$_useForkRef = $727133a3c635b8ae$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $727133a3c635b8ae$var$_capitalize = $727133a3c635b8ae$require$_interopRequireDefault((parcelRequire("4O6za")));

var $727133a3c635b8ae$var$_composeClasses = $727133a3c635b8ae$require$_interopRequireDefault((parcelRequire("3Hg1x")));


var $fYxgT = parcelRequire("fYxgT");

var $aOz2q = parcelRequire("aOz2q");


var $5sOMZ = parcelRequire("5sOMZ");

var $er55f = parcelRequire("er55f");

var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");

var $8b3c2a77bf85fdbc$exports = {};
"use strict";
Object.defineProperty($8b3c2a77bf85fdbc$exports, "__esModule", {
    value: true
});
$8b3c2a77bf85fdbc$exports.useIsSSR = void 0;

var $hfliI = parcelRequire("hfliI");
const $8b3c2a77bf85fdbc$var$emptySubscribe = ()=>()=>{};
const $8b3c2a77bf85fdbc$var$clientSnapshot = ()=>false;
const $8b3c2a77bf85fdbc$var$serverSnapshot = ()=>true;
const $8b3c2a77bf85fdbc$var$useIsSSR = ()=>(0, $hfliI.useSyncExternalStore)($8b3c2a77bf85fdbc$var$emptySubscribe, $8b3c2a77bf85fdbc$var$clientSnapshot, $8b3c2a77bf85fdbc$var$serverSnapshot);
$8b3c2a77bf85fdbc$exports.useIsSSR = $8b3c2a77bf85fdbc$var$useIsSSR;


var $ce2feaf42932ccbe$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $ce2feaf42932ccbe$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $ce2feaf42932ccbe$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($ce2feaf42932ccbe$exports, "__esModule", {
    value: true
});
$ce2feaf42932ccbe$exports.GridHeader = $ce2feaf42932ccbe$var$GridHeader;

var $ce2feaf42932ccbe$var$_extends2 = $ce2feaf42932ccbe$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $ce2feaf42932ccbe$var$React = $ce2feaf42932ccbe$require$_interopRequireWildcard((parcelRequire("acw62")));

var $jDpXp = parcelRequire("jDpXp");
var $05a239ae20a1382d$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $05a239ae20a1382d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($05a239ae20a1382d$exports, "__esModule", {
    value: true
});
$05a239ae20a1382d$exports.GridPreferencesPanel = $05a239ae20a1382d$var$GridPreferencesPanel;

var $05a239ae20a1382d$var$_extends2 = $05a239ae20a1382d$require$_interopRequireDefault((parcelRequire("3p9rK")));


var $5sOMZ = parcelRequire("5sOMZ");



var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");
var $546bc72d2cea638d$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $546bc72d2cea638d$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($546bc72d2cea638d$exports, "__esModule", {
    value: true
});
$546bc72d2cea638d$exports.GridPanelContext = void 0;
$546bc72d2cea638d$exports.GridPanelContextProvider = $546bc72d2cea638d$var$GridPanelContextProvider;
$546bc72d2cea638d$exports.useGridPanelContext = $546bc72d2cea638d$var$useGridPanelContext;

var $546bc72d2cea638d$var$React = $546bc72d2cea638d$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ayMG0 = parcelRequire("ayMG0");
const $546bc72d2cea638d$var$GridPanelContext = $546bc72d2cea638d$exports.GridPanelContext = /*#__PURE__*/ $546bc72d2cea638d$var$React.createContext(undefined);
$546bc72d2cea638d$var$GridPanelContext.displayName = "GridPanelContext";
function $546bc72d2cea638d$var$useGridPanelContext() {
    const context = $546bc72d2cea638d$var$React.useContext($546bc72d2cea638d$var$GridPanelContext);
    if (context === undefined) throw new Error('MUI X: Missing context.');
    return context;
}
function $546bc72d2cea638d$var$GridPanelContextProvider({ children: children }) {
    const columnsPanelTriggerRef = $546bc72d2cea638d$var$React.useRef(null);
    const filterPanelTriggerRef = $546bc72d2cea638d$var$React.useRef(null);
    const aiAssistantPanelTriggerRef = $546bc72d2cea638d$var$React.useRef(null);
    const value = $546bc72d2cea638d$var$React.useMemo(()=>({
            columnsPanelTriggerRef: columnsPanelTriggerRef,
            filterPanelTriggerRef: filterPanelTriggerRef,
            aiAssistantPanelTriggerRef: aiAssistantPanelTriggerRef
        }), []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($546bc72d2cea638d$var$GridPanelContext.Provider, {
        value: value,
        children: children
    });
}



var $ayMG0 = parcelRequire("ayMG0");
function $05a239ae20a1382d$var$GridPreferencesPanel() {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const columns = (0, $5sOMZ.useGridSelector)(apiRef, $e732684465924d20$exports.gridColumnDefinitionsSelector);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const preferencePanelState = (0, $5sOMZ.useGridSelector)(apiRef, $50fa8e974bf84473$exports.gridPreferencePanelStateSelector);
    const { columnsPanelTriggerRef: columnsPanelTriggerRef, filterPanelTriggerRef: filterPanelTriggerRef, aiAssistantPanelTriggerRef: aiAssistantPanelTriggerRef } = (0, $546bc72d2cea638d$exports.useGridPanelContext)();
    const panelContent = apiRef.current.unstable_applyPipeProcessors('preferencePanel', null, preferencePanelState.openedPanelValue ?? $2ca45f4bbfed6878$exports.GridPreferencePanelsValue.filters);
    let target = null;
    switch(preferencePanelState.openedPanelValue){
        case $2ca45f4bbfed6878$exports.GridPreferencePanelsValue.filters:
            target = filterPanelTriggerRef.current;
            break;
        case $2ca45f4bbfed6878$exports.GridPreferencePanelsValue.columns:
            target = columnsPanelTriggerRef.current;
            break;
        case $2ca45f4bbfed6878$exports.GridPreferencePanelsValue.aiAssistant:
            target = aiAssistantPanelTriggerRef.current;
            break;
        default:
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.panel, (0, $05a239ae20a1382d$var$_extends2.default)({
        id: preferencePanelState.panelId,
        open: columns.length > 0 && preferencePanelState.open,
        "aria-labelledby": preferencePanelState.labelId,
        target: target,
        onClose: ()=>apiRef.current.hidePreferences()
    }, rootProps.slotProps?.panel, {
        children: panelContent
    }));
}



var $ayMG0 = parcelRequire("ayMG0");
function $ce2feaf42932ccbe$var$GridHeader() {
    const rootProps = (0, $jDpXp.useGridRootProps)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($ce2feaf42932ccbe$var$React.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($05a239ae20a1382d$exports.GridPreferencesPanel, {}),
            rootProps.showToolbar && /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.toolbar, (0, $ce2feaf42932ccbe$var$_extends2.default)({}, rootProps.slotProps?.toolbar))
        ]
    });
}




var $ayMG0 = parcelRequire("ayMG0");
const $727133a3c635b8ae$var$_excluded = [
    "className",
    "children",
    "sidePanel"
];
const $727133a3c635b8ae$var$useUtilityClasses = (ownerState, density)=>{
    const { autoHeight: autoHeight, classes: classes, showCellVerticalBorder: showCellVerticalBorder } = ownerState;
    const slots = {
        root: [
            'root',
            autoHeight && 'autoHeight',
            `root--density${(0, $727133a3c635b8ae$var$_capitalize.default)(density)}`,
            ownerState.slots.toolbar === null && 'root--noToolbar',
            'withBorderColor',
            showCellVerticalBorder && 'withVerticalBorder'
        ]
    };
    return (0, $727133a3c635b8ae$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $727133a3c635b8ae$var$GridRoot = (0, $fYxgT.forwardRef)(function GridRoot(props, ref) {
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const { className: className, children: children, sidePanel: sidePanel } = props, other = (0, $727133a3c635b8ae$var$_objectWithoutPropertiesLoose2.default)(props, $727133a3c635b8ae$var$_excluded);
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const density = (0, $5sOMZ.useGridSelector)(apiRef, $b611aad21a5b677d$exports.gridDensitySelector);
    const rootElementRef = apiRef.current.rootElementRef;
    const rootMountCallback = $727133a3c635b8ae$var$React.useCallback((node)=>{
        if (node === null) return;
        apiRef.current.publishEvent('rootMount', node);
    }, [
        apiRef
    ]);
    const handleRef = (0, $727133a3c635b8ae$var$_useForkRef.default)(rootElementRef, ref, rootMountCallback);
    const ownerState = rootProps;
    const classes = $727133a3c635b8ae$var$useUtilityClasses(ownerState, density);
    const cssVariables = (0, $2a727ae4835cc807$exports.useCSSVariablesContext)();
    const isSSR = (0, $8b3c2a77bf85fdbc$exports.useIsSSR)();
    if (isSSR) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($aOz2q.GridRootStyles, (0, $727133a3c635b8ae$var$_extends2.default)({
        className: (0, $727133a3c635b8ae$var$_clsx.default)(classes.root, className, cssVariables.className, sidePanel && $5H1vo.gridClasses.withSidePanel),
        ownerState: ownerState
    }, other, {
        ref: handleRef,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: $5H1vo.gridClasses.mainContent,
                role: "presentation",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($ce2feaf42932ccbe$exports.GridHeader, {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($ecac20e02127a1f6$exports.GridBody, {
                        children: children
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($ecac20e02127a1f6$exports.GridFooterPlaceholder, {})
                ]
            }),
            sidePanel,
            cssVariables.tag
        ]
    }));
});
$727133a3c635b8ae$var$GridRoot.displayName = "GridRoot";
$727133a3c635b8ae$var$GridRoot.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    sidePanel: $727133a3c635b8ae$var$_propTypes.default.node,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $727133a3c635b8ae$var$_propTypes.default.oneOfType([
        $727133a3c635b8ae$var$_propTypes.default.arrayOf($727133a3c635b8ae$var$_propTypes.default.oneOfType([
            $727133a3c635b8ae$var$_propTypes.default.func,
            $727133a3c635b8ae$var$_propTypes.default.object,
            $727133a3c635b8ae$var$_propTypes.default.bool
        ])),
        $727133a3c635b8ae$var$_propTypes.default.func,
        $727133a3c635b8ae$var$_propTypes.default.object
    ])
};
const $727133a3c635b8ae$var$MemoizedGridRoot = $727133a3c635b8ae$exports.GridRoot = (0, $1bc1b286f3c678cc$exports.fastMemo)($727133a3c635b8ae$var$GridRoot);


Object.keys($727133a3c635b8ae$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $f5ace3cc4f8b4ab7$exports && $f5ace3cc4f8b4ab7$exports[key] === $727133a3c635b8ae$exports[key]) return;
    Object.defineProperty($f5ace3cc4f8b4ab7$exports, key, {
        enumerable: true,
        get: function() {
            return $727133a3c635b8ae$exports[key];
        }
    });
});
var $e05925554f74d684$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e05925554f74d684$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $e05925554f74d684$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($e05925554f74d684$exports, "__esModule", {
    value: true
});
$e05925554f74d684$exports.GridFooterContainer = void 0;

var $e05925554f74d684$var$_extends2 = $e05925554f74d684$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $e05925554f74d684$var$_objectWithoutPropertiesLoose2 = $e05925554f74d684$require$_interopRequireDefault((parcelRequire("c05no")));

var $e05925554f74d684$var$React = $e05925554f74d684$require$_interopRequireWildcard((parcelRequire("acw62")));

var $e05925554f74d684$var$_propTypes = $e05925554f74d684$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $e05925554f74d684$var$_clsx = $e05925554f74d684$require$_interopRequireDefault((parcelRequire("9QePP")));

var $e05925554f74d684$var$_composeClasses = $e05925554f74d684$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $izOUK = parcelRequire("izOUK");

var $fYxgT = parcelRequire("fYxgT");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $e05925554f74d684$var$_excluded = [
    "className"
];
const $e05925554f74d684$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'footerContainer',
            'withBorderColor'
        ]
    };
    return (0, $e05925554f74d684$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $e05925554f74d684$var$GridFooterContainerRoot = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'FooterContainer'
})({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: 52,
    borderTop: '1px solid'
});
const $e05925554f74d684$var$GridFooterContainer = $e05925554f74d684$exports.GridFooterContainer = (0, $fYxgT.forwardRef)(function GridFooterContainer(props, ref) {
    const { className: className } = props, other = (0, $e05925554f74d684$var$_objectWithoutPropertiesLoose2.default)(props, $e05925554f74d684$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $e05925554f74d684$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($e05925554f74d684$var$GridFooterContainerRoot, (0, $e05925554f74d684$var$_extends2.default)({
        className: (0, $e05925554f74d684$var$_clsx.default)(classes.root, className),
        ownerState: rootProps
    }, other, {
        ref: ref
    }));
});
$e05925554f74d684$var$GridFooterContainer.displayName = "GridFooterContainer";
$e05925554f74d684$var$GridFooterContainer.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    sx: $e05925554f74d684$var$_propTypes.default.oneOfType([
        $e05925554f74d684$var$_propTypes.default.arrayOf($e05925554f74d684$var$_propTypes.default.oneOfType([
            $e05925554f74d684$var$_propTypes.default.func,
            $e05925554f74d684$var$_propTypes.default.object,
            $e05925554f74d684$var$_propTypes.default.bool
        ])),
        $e05925554f74d684$var$_propTypes.default.func,
        $e05925554f74d684$var$_propTypes.default.object
    ])
};


Object.keys($e05925554f74d684$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $f5ace3cc4f8b4ab7$exports && $f5ace3cc4f8b4ab7$exports[key] === $e05925554f74d684$exports[key]) return;
    Object.defineProperty($f5ace3cc4f8b4ab7$exports, key, {
        enumerable: true,
        get: function() {
            return $e05925554f74d684$exports[key];
        }
    });
});
var $0180de2e65ebf290$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0180de2e65ebf290$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $0180de2e65ebf290$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($0180de2e65ebf290$exports, "__esModule", {
    value: true
});
$0180de2e65ebf290$exports.GridOverlay = void 0;

var $0180de2e65ebf290$var$_extends2 = $0180de2e65ebf290$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $0180de2e65ebf290$var$_objectWithoutPropertiesLoose2 = $0180de2e65ebf290$require$_interopRequireDefault((parcelRequire("c05no")));

var $0180de2e65ebf290$var$React = $0180de2e65ebf290$require$_interopRequireWildcard((parcelRequire("acw62")));

var $0180de2e65ebf290$var$_propTypes = $0180de2e65ebf290$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $0180de2e65ebf290$var$_clsx = $0180de2e65ebf290$require$_interopRequireDefault((parcelRequire("9QePP")));

var $0180de2e65ebf290$var$_composeClasses = $0180de2e65ebf290$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $izOUK = parcelRequire("izOUK");

var $fYxgT = parcelRequire("fYxgT");

var $hbuUJ = parcelRequire("hbuUJ");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $0180de2e65ebf290$var$_excluded = [
    "className"
];
const $0180de2e65ebf290$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'overlay'
        ]
    };
    return (0, $0180de2e65ebf290$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $0180de2e65ebf290$var$GridOverlayRoot = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'Overlay'
})({
    width: '100%',
    height: '100%',
    display: 'flex',
    gap: $hbuUJ.vars.spacing(1),
    flexDirection: 'column',
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    textWrap: 'balance',
    backgroundColor: $hbuUJ.vars.colors.background.backdrop
});
const $0180de2e65ebf290$var$GridOverlay = $0180de2e65ebf290$exports.GridOverlay = (0, $fYxgT.forwardRef)(function GridOverlay(props, ref) {
    const { className: className } = props, other = (0, $0180de2e65ebf290$var$_objectWithoutPropertiesLoose2.default)(props, $0180de2e65ebf290$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $0180de2e65ebf290$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($0180de2e65ebf290$var$GridOverlayRoot, (0, $0180de2e65ebf290$var$_extends2.default)({
        className: (0, $0180de2e65ebf290$var$_clsx.default)(classes.root, className),
        ownerState: rootProps
    }, other, {
        ref: ref
    }));
});
$0180de2e65ebf290$var$GridOverlay.displayName = "GridOverlay";
$0180de2e65ebf290$var$GridOverlay.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    sx: $0180de2e65ebf290$var$_propTypes.default.oneOfType([
        $0180de2e65ebf290$var$_propTypes.default.arrayOf($0180de2e65ebf290$var$_propTypes.default.oneOfType([
            $0180de2e65ebf290$var$_propTypes.default.func,
            $0180de2e65ebf290$var$_propTypes.default.object,
            $0180de2e65ebf290$var$_propTypes.default.bool
        ])),
        $0180de2e65ebf290$var$_propTypes.default.func,
        $0180de2e65ebf290$var$_propTypes.default.object
    ])
};


Object.keys($0180de2e65ebf290$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $f5ace3cc4f8b4ab7$exports && $f5ace3cc4f8b4ab7$exports[key] === $0180de2e65ebf290$exports[key]) return;
    Object.defineProperty($f5ace3cc4f8b4ab7$exports, key, {
        enumerable: true,
        get: function() {
            return $0180de2e65ebf290$exports[key];
        }
    });
});
var $0080d3bf74adddb6$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0080d3bf74adddb6$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $0080d3bf74adddb6$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($0080d3bf74adddb6$exports, "__esModule", {
    value: true
});
$0080d3bf74adddb6$exports.GridToolbarContainer = void 0;

var $0080d3bf74adddb6$var$_extends2 = $0080d3bf74adddb6$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $0080d3bf74adddb6$var$_objectWithoutPropertiesLoose2 = $0080d3bf74adddb6$require$_interopRequireDefault((parcelRequire("c05no")));

var $0080d3bf74adddb6$var$React = $0080d3bf74adddb6$require$_interopRequireWildcard((parcelRequire("acw62")));

var $0080d3bf74adddb6$var$_propTypes = $0080d3bf74adddb6$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $0080d3bf74adddb6$var$_clsx = $0080d3bf74adddb6$require$_interopRequireDefault((parcelRequire("9QePP")));

var $izOUK = parcelRequire("izOUK");

var $0080d3bf74adddb6$var$_composeClasses = $0080d3bf74adddb6$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $fYxgT = parcelRequire("fYxgT");

var $hbuUJ = parcelRequire("hbuUJ");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");
var $4aec1101d1789fa4$exports = {};
"use strict";
Object.defineProperty($4aec1101d1789fa4$exports, "__esModule", {
    value: true
});
var $d8c2e7e50975603c$exports = {};
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $d8c2e7e50975603c$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $d8c2e7e50975603c$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($d8c2e7e50975603c$exports, "__esModule", {
    value: true
});
$d8c2e7e50975603c$exports.Toolbar = void 0;

var $d8c2e7e50975603c$var$_extends2 = $d8c2e7e50975603c$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $d8c2e7e50975603c$var$_objectWithoutPropertiesLoose2 = $d8c2e7e50975603c$require$_interopRequireDefault((parcelRequire("c05no")));

var $d8c2e7e50975603c$var$React = $d8c2e7e50975603c$require$_interopRequireWildcard((parcelRequire("acw62")));

var $d8c2e7e50975603c$var$_propTypes = $d8c2e7e50975603c$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $izOUK = parcelRequire("izOUK");

var $d8c2e7e50975603c$var$_composeClasses = $d8c2e7e50975603c$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $d8c2e7e50975603c$var$_clsx = $d8c2e7e50975603c$require$_interopRequireDefault((parcelRequire("9QePP")));

var $fYxgT = parcelRequire("fYxgT");
var $09dd6c7e82941da8$exports = {};
"use strict";
Object.defineProperty($09dd6c7e82941da8$exports, "__esModule", {
    value: true
});
var $513cdd862df13332$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $513cdd862df13332$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $513cdd862df13332$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($513cdd862df13332$exports, "__esModule", {
    value: true
});
$513cdd862df13332$exports.useComponentRenderer = $513cdd862df13332$var$useComponentRenderer;

var $513cdd862df13332$var$_extends2 = $513cdd862df13332$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $513cdd862df13332$var$React = $513cdd862df13332$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * Resolves the rendering logic for a component.
 * Handles three scenarios:
 * 1. A render function that receives props and state
 * 2. A React element
 * 3. A default element
 *
 * @ignore - internal hook.
 */ function $513cdd862df13332$var$useComponentRenderer(defaultElement, render, props, state = {}) {
    if (typeof render === 'function') return render(props, state);
    if (render) {
        if (render.props.className) props.className = $513cdd862df13332$var$mergeClassNames(render.props.className, props.className);
        if (render.props.style || props.style) props.style = (0, $513cdd862df13332$var$_extends2.default)({}, props.style, render.props.style);
        return /*#__PURE__*/ $513cdd862df13332$var$React.cloneElement(render, props);
    }
    return /*#__PURE__*/ $513cdd862df13332$var$React.createElement(defaultElement, props);
}
function $513cdd862df13332$var$mergeClassNames(className, otherClassName) {
    if (!className || !otherClassName) return className || otherClassName;
    return `${className} ${otherClassName}`;
}


Object.keys($513cdd862df13332$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $09dd6c7e82941da8$exports && $09dd6c7e82941da8$exports[key] === $513cdd862df13332$exports[key]) return;
    Object.defineProperty($09dd6c7e82941da8$exports, key, {
        enumerable: true,
        get: function() {
            return $513cdd862df13332$exports[key];
        }
    });
});



var $hbuUJ = parcelRequire("hbuUJ");

var $5H1vo = parcelRequire("5H1vo");
var $9b0cca25f33cbe1b$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $9b0cca25f33cbe1b$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($9b0cca25f33cbe1b$exports, "__esModule", {
    value: true
});
$9b0cca25f33cbe1b$exports.ToolbarContext = void 0;
$9b0cca25f33cbe1b$exports.useToolbarContext = $9b0cca25f33cbe1b$var$useToolbarContext;

var $9b0cca25f33cbe1b$var$React = $9b0cca25f33cbe1b$require$_interopRequireWildcard((parcelRequire("acw62")));
const $9b0cca25f33cbe1b$var$ToolbarContext = $9b0cca25f33cbe1b$exports.ToolbarContext = /*#__PURE__*/ $9b0cca25f33cbe1b$var$React.createContext(undefined);
$9b0cca25f33cbe1b$var$ToolbarContext.displayName = "ToolbarContext";
function $9b0cca25f33cbe1b$var$useToolbarContext() {
    const context = $9b0cca25f33cbe1b$var$React.useContext($9b0cca25f33cbe1b$var$ToolbarContext);
    if (context === undefined) throw new Error('MUI X: Missing context. Toolbar subcomponents must be placed within a <Toolbar /> component.');
    return context;
}



var $jDpXp = parcelRequire("jDpXp");
var $755f2504bb16c6c8$exports = {};
"use strict";
Object.defineProperty($755f2504bb16c6c8$exports, "__esModule", {
    value: true
});
$755f2504bb16c6c8$exports.sortByDocumentPosition = $755f2504bb16c6c8$var$sortByDocumentPosition;
/* eslint-disable no-bitwise */ function $755f2504bb16c6c8$var$sortByDocumentPosition(a, b) {
    if (!a.ref.current || !b.ref.current) return 0;
    const position = a.ref.current.compareDocumentPosition(b.ref.current);
    if (!position) return 0;
    if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
    if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) return 1;
    return 0;
}



var $ayMG0 = parcelRequire("ayMG0");
const $d8c2e7e50975603c$var$_excluded = [
    "render",
    "className"
];
const $d8c2e7e50975603c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'toolbar'
        ]
    };
    return (0, $d8c2e7e50975603c$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $d8c2e7e50975603c$var$ToolbarRoot = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'Toolbar'
})({
    flex: '0 1 1px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'end',
    gap: $hbuUJ.vars.spacing(0.25),
    padding: $hbuUJ.vars.spacing(0.75),
    minHeight: 52,
    boxSizing: 'border-box',
    borderBottom: `1px solid ${$hbuUJ.vars.colors.border.base}`
});
/**
 * The top level Toolbar component that provides context to child components.
 * It renders a styled `<div />` element.
 *
 * Demos:
 *
 * - [Toolbar](https://mui.com/x/react-data-grid/components/toolbar/)
 *
 * API:
 *
 * - [Toolbar API](https://mui.com/x/api/data-grid/toolbar/)
 */ const $d8c2e7e50975603c$var$Toolbar = $d8c2e7e50975603c$exports.Toolbar = (0, $fYxgT.forwardRef)(function Toolbar(props, ref) {
    const { render: render, className: className } = props, other = (0, $d8c2e7e50975603c$var$_objectWithoutPropertiesLoose2.default)(props, $d8c2e7e50975603c$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $d8c2e7e50975603c$var$useUtilityClasses(rootProps);
    const [focusableItemId, setFocusableItemId] = $d8c2e7e50975603c$var$React.useState(null);
    const [items, setItems] = $d8c2e7e50975603c$var$React.useState([]);
    const getSortedItems = $d8c2e7e50975603c$var$React.useCallback(()=>items.sort($755f2504bb16c6c8$exports.sortByDocumentPosition), [
        items
    ]);
    const findEnabledItem = $d8c2e7e50975603c$var$React.useCallback((startIndex, step, wrap = true)=>{
        let index = startIndex;
        const sortedItems = getSortedItems();
        const itemCount = sortedItems.length;
        // Look for enabled items in the specified direction
        for(let i = 0; i < itemCount; i += 1){
            index += step;
            // Handle wrapping around the ends
            if (index >= itemCount) {
                if (!wrap) return -1;
                index = 0;
            } else if (index < 0) {
                if (!wrap) return -1;
                index = itemCount - 1;
            }
            // Return if we found an enabled item
            if (!sortedItems[index].ref.current?.disabled && sortedItems[index].ref.current?.ariaDisabled !== 'true') return index;
        }
        // If we've checked all items and found none enabled
        return -1;
    }, [
        getSortedItems
    ]);
    const registerItem = $d8c2e7e50975603c$var$React.useCallback((id, itemRef)=>{
        setItems((prevItems)=>[
                ...prevItems,
                {
                    id: id,
                    ref: itemRef
                }
            ]);
    }, []);
    const unregisterItem = $d8c2e7e50975603c$var$React.useCallback((id)=>{
        setItems((prevItems)=>prevItems.filter((i)=>i.id !== id));
    }, []);
    const onItemKeyDown = $d8c2e7e50975603c$var$React.useCallback((event)=>{
        if (!focusableItemId) return;
        const sortedItems = getSortedItems();
        const focusableItemIndex = sortedItems.findIndex((item)=>item.id === focusableItemId);
        let newIndex = -1;
        if (event.key === 'ArrowRight') {
            event.preventDefault();
            newIndex = findEnabledItem(focusableItemIndex, 1);
        } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            newIndex = findEnabledItem(focusableItemIndex, -1);
        } else if (event.key === 'Home') {
            event.preventDefault();
            newIndex = findEnabledItem(-1, 1, false);
        } else if (event.key === 'End') {
            event.preventDefault();
            newIndex = findEnabledItem(sortedItems.length, -1, false);
        }
        // TODO: Check why this is necessary
        if (newIndex >= 0 && newIndex < sortedItems.length) {
            const item = sortedItems[newIndex];
            setFocusableItemId(item.id);
            item.ref.current?.focus();
        }
    }, [
        getSortedItems,
        focusableItemId,
        findEnabledItem
    ]);
    const onItemFocus = $d8c2e7e50975603c$var$React.useCallback((id)=>{
        if (focusableItemId !== id) setFocusableItemId(id);
    }, [
        focusableItemId,
        setFocusableItemId
    ]);
    const onItemDisabled = $d8c2e7e50975603c$var$React.useCallback((id)=>{
        const sortedItems = getSortedItems();
        const currentIndex = sortedItems.findIndex((item)=>item.id === id);
        const newIndex = findEnabledItem(currentIndex, 1);
        if (newIndex >= 0 && newIndex < sortedItems.length) {
            const item = sortedItems[newIndex];
            setFocusableItemId(item.id);
            item.ref.current?.focus();
        }
    }, [
        getSortedItems,
        findEnabledItem
    ]);
    $d8c2e7e50975603c$var$React.useEffect(()=>{
        const sortedItems = getSortedItems();
        if (sortedItems.length > 0) {
            // Set initial focusable item
            if (!focusableItemId) {
                setFocusableItemId(sortedItems[0].id);
                return;
            }
            const focusableItemIndex = sortedItems.findIndex((item)=>item.id === focusableItemId);
            if (!sortedItems[focusableItemIndex]) {
                // Last item has been removed from the items array
                const item = sortedItems[sortedItems.length - 1];
                if (item) {
                    setFocusableItemId(item.id);
                    item.ref.current?.focus();
                }
            } else if (focusableItemIndex === -1) {
                // Focused item has been removed from the items array
                const item = sortedItems[focusableItemIndex];
                if (item) {
                    setFocusableItemId(item.id);
                    item.ref.current?.focus();
                }
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        getSortedItems,
        findEnabledItem
    ]);
    const contextValue = $d8c2e7e50975603c$var$React.useMemo(()=>({
            focusableItemId: focusableItemId,
            registerItem: registerItem,
            unregisterItem: unregisterItem,
            onItemKeyDown: onItemKeyDown,
            onItemFocus: onItemFocus,
            onItemDisabled: onItemDisabled
        }), [
        focusableItemId,
        registerItem,
        unregisterItem,
        onItemKeyDown,
        onItemFocus,
        onItemDisabled
    ]);
    const element = (0, $09dd6c7e82941da8$exports.useComponentRenderer)($d8c2e7e50975603c$var$ToolbarRoot, render, (0, $d8c2e7e50975603c$var$_extends2.default)({
        role: 'toolbar',
        'aria-orientation': 'horizontal',
        'aria-label': rootProps.label || undefined,
        className: (0, $d8c2e7e50975603c$var$_clsx.default)(classes.root, className)
    }, other, {
        ref: ref
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($9b0cca25f33cbe1b$exports.ToolbarContext.Provider, {
        value: contextValue,
        children: element
    });
});
$d8c2e7e50975603c$var$Toolbar.displayName = "Toolbar";
$d8c2e7e50975603c$var$Toolbar.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * A function to customize rendering of the component.
   */ render: $d8c2e7e50975603c$var$_propTypes.default.oneOfType([
        $d8c2e7e50975603c$var$_propTypes.default.element,
        $d8c2e7e50975603c$var$_propTypes.default.func
    ])
};


Object.keys($d8c2e7e50975603c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4aec1101d1789fa4$exports && $4aec1101d1789fa4$exports[key] === $d8c2e7e50975603c$exports[key]) return;
    Object.defineProperty($4aec1101d1789fa4$exports, key, {
        enumerable: true,
        get: function() {
            return $d8c2e7e50975603c$exports[key];
        }
    });
});
var $4c3478cdd4144942$exports = {};
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $4c3478cdd4144942$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $4c3478cdd4144942$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($4c3478cdd4144942$exports, "__esModule", {
    value: true
});
$4c3478cdd4144942$exports.ToolbarButton = void 0;

var $4c3478cdd4144942$var$_extends2 = $4c3478cdd4144942$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $4c3478cdd4144942$var$_objectWithoutPropertiesLoose2 = $4c3478cdd4144942$require$_interopRequireDefault((parcelRequire("c05no")));

var $4c3478cdd4144942$var$React = $4c3478cdd4144942$require$_interopRequireWildcard((parcelRequire("acw62")));

var $4c3478cdd4144942$var$_propTypes = $4c3478cdd4144942$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $4c3478cdd4144942$var$_useForkRef = $4c3478cdd4144942$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $4c3478cdd4144942$var$_useId = $4c3478cdd4144942$require$_interopRequireDefault((parcelRequire("hwliF")));

var $fYxgT = parcelRequire("fYxgT");


var $jDpXp = parcelRequire("jDpXp");


var $ayMG0 = parcelRequire("ayMG0");
const $4c3478cdd4144942$var$_excluded = [
    "render",
    "onKeyDown",
    "onFocus",
    "disabled",
    "aria-disabled"
];
/**
 * A button for performing actions from the toolbar.
 * It renders the `baseIconButton` slot.
 *
 * Demos:
 *
 * - [Toolbar](https://mui.com/x/react-data-grid/components/toolbar/)
 *
 * API:
 *
 * - [ToolbarButton API](https://mui.com/x/api/data-grid/toolbar-button/)
 */ const $4c3478cdd4144942$var$ToolbarButton = $4c3478cdd4144942$exports.ToolbarButton = (0, $fYxgT.forwardRef)(function ToolbarButton(props, ref) {
    const { render: render, onKeyDown: onKeyDown, onFocus: onFocus, disabled: disabled, 'aria-disabled': ariaDisabled } = props, other = (0, $4c3478cdd4144942$var$_objectWithoutPropertiesLoose2.default)(props, $4c3478cdd4144942$var$_excluded);
    const id = (0, $4c3478cdd4144942$var$_useId.default)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const buttonRef = $4c3478cdd4144942$var$React.useRef(null);
    const handleRef = (0, $4c3478cdd4144942$var$_useForkRef.default)(buttonRef, ref);
    const { focusableItemId: focusableItemId, registerItem: registerItem, unregisterItem: unregisterItem, onItemKeyDown: onItemKeyDown, onItemFocus: onItemFocus, onItemDisabled: onItemDisabled } = (0, $9b0cca25f33cbe1b$exports.useToolbarContext)();
    const handleKeyDown = (event)=>{
        onItemKeyDown(event);
        onKeyDown?.(event);
    };
    const handleFocus = (event)=>{
        onItemFocus(id);
        onFocus?.(event);
    };
    $4c3478cdd4144942$var$React.useEffect(()=>{
        registerItem(id, buttonRef);
        return ()=>unregisterItem(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const previousDisabled = $4c3478cdd4144942$var$React.useRef(disabled);
    $4c3478cdd4144942$var$React.useEffect(()=>{
        if (previousDisabled.current !== disabled && disabled === true) onItemDisabled(id, disabled);
        previousDisabled.current = disabled;
    }, [
        disabled,
        id,
        onItemDisabled
    ]);
    const previousAriaDisabled = $4c3478cdd4144942$var$React.useRef(ariaDisabled);
    $4c3478cdd4144942$var$React.useEffect(()=>{
        if (previousAriaDisabled.current !== ariaDisabled && ariaDisabled === true) onItemDisabled(id, true);
        previousAriaDisabled.current = ariaDisabled;
    }, [
        ariaDisabled,
        id,
        onItemDisabled
    ]);
    const element = (0, $09dd6c7e82941da8$exports.useComponentRenderer)(rootProps.slots.baseIconButton, render, (0, $4c3478cdd4144942$var$_extends2.default)({}, rootProps.slotProps?.baseIconButton, {
        tabIndex: focusableItemId === id ? 0 : -1
    }, other, {
        disabled: disabled,
        'aria-disabled': ariaDisabled,
        onKeyDown: handleKeyDown,
        onFocus: handleFocus,
        ref: handleRef
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($4c3478cdd4144942$var$React.Fragment, {
        children: element
    });
});
$4c3478cdd4144942$var$ToolbarButton.displayName = "ToolbarButton";
$4c3478cdd4144942$var$ToolbarButton.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    className: $4c3478cdd4144942$var$_propTypes.default.string,
    color: $4c3478cdd4144942$var$_propTypes.default.oneOf([
        'default',
        'inherit',
        'primary'
    ]),
    disabled: $4c3478cdd4144942$var$_propTypes.default.bool,
    edge: $4c3478cdd4144942$var$_propTypes.default.oneOf([
        'end',
        'start',
        false
    ]),
    id: $4c3478cdd4144942$var$_propTypes.default.string,
    label: $4c3478cdd4144942$var$_propTypes.default.string,
    /**
   * A function to customize rendering of the component.
   */ render: $4c3478cdd4144942$var$_propTypes.default.oneOfType([
        $4c3478cdd4144942$var$_propTypes.default.element,
        $4c3478cdd4144942$var$_propTypes.default.func
    ]),
    role: $4c3478cdd4144942$var$_propTypes.default.string,
    size: $4c3478cdd4144942$var$_propTypes.default.oneOf([
        'large',
        'medium',
        'small'
    ]),
    style: $4c3478cdd4144942$var$_propTypes.default.object,
    tabIndex: $4c3478cdd4144942$var$_propTypes.default.number,
    title: $4c3478cdd4144942$var$_propTypes.default.string,
    touchRippleRef: $4c3478cdd4144942$var$_propTypes.default.any
};


Object.keys($4c3478cdd4144942$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4aec1101d1789fa4$exports && $4aec1101d1789fa4$exports[key] === $4c3478cdd4144942$exports[key]) return;
    Object.defineProperty($4aec1101d1789fa4$exports, key, {
        enumerable: true,
        get: function() {
            return $4c3478cdd4144942$exports[key];
        }
    });
});



var $ayMG0 = parcelRequire("ayMG0");
const $0080d3bf74adddb6$var$_excluded = [
    "className",
    "children"
];
const $0080d3bf74adddb6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'toolbarContainer'
        ]
    };
    return (0, $0080d3bf74adddb6$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $0080d3bf74adddb6$var$GridToolbarContainerRoot = (0, $izOUK.styled)($4aec1101d1789fa4$exports.Toolbar, {
    name: 'MuiDataGrid',
    slot: 'ToolbarContainer',
    shouldForwardProp: (prop)=>prop !== 'ownerState'
})({
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: $hbuUJ.vars.spacing(1),
    padding: $hbuUJ.vars.spacing(0.5),
    minHeight: 'auto'
});
/**
 * @deprecated Use the {@link https://mui.com/x/react-data-grid/components/toolbar/ Toolbar} component instead. This component will be removed in a future major release.
 */ const $0080d3bf74adddb6$var$GridToolbarContainer = $0080d3bf74adddb6$exports.GridToolbarContainer = (0, $fYxgT.forwardRef)(function GridToolbarContainer(props, ref) {
    const { className: className, children: children } = props, other = (0, $0080d3bf74adddb6$var$_objectWithoutPropertiesLoose2.default)(props, $0080d3bf74adddb6$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $0080d3bf74adddb6$var$useUtilityClasses(rootProps);
    if (!children) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($0080d3bf74adddb6$var$GridToolbarContainerRoot, (0, $0080d3bf74adddb6$var$_extends2.default)({
        className: (0, $0080d3bf74adddb6$var$_clsx.default)(classes.root, className),
        ownerState: rootProps
    }, other, {
        ref: ref,
        children: children
    }));
});
$0080d3bf74adddb6$var$GridToolbarContainer.displayName = "GridToolbarContainer";
$0080d3bf74adddb6$var$GridToolbarContainer.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    sx: $0080d3bf74adddb6$var$_propTypes.default.oneOfType([
        $0080d3bf74adddb6$var$_propTypes.default.arrayOf($0080d3bf74adddb6$var$_propTypes.default.oneOfType([
            $0080d3bf74adddb6$var$_propTypes.default.func,
            $0080d3bf74adddb6$var$_propTypes.default.object,
            $0080d3bf74adddb6$var$_propTypes.default.bool
        ])),
        $0080d3bf74adddb6$var$_propTypes.default.func,
        $0080d3bf74adddb6$var$_propTypes.default.object
    ])
};


Object.keys($0080d3bf74adddb6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $f5ace3cc4f8b4ab7$exports && $f5ace3cc4f8b4ab7$exports[key] === $0080d3bf74adddb6$exports[key]) return;
    Object.defineProperty($f5ace3cc4f8b4ab7$exports, key, {
        enumerable: true,
        get: function() {
            return $0080d3bf74adddb6$exports[key];
        }
    });
});


Object.keys($f5ace3cc4f8b4ab7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in $08eee520e810d520$exports && $08eee520e810d520$exports[key] === $f5ace3cc4f8b4ab7$exports[key]) return;
    Object.defineProperty($08eee520e810d520$exports, key, {
        enumerable: true,
        get: function() {
            return $f5ace3cc4f8b4ab7$exports[key];
        }
    });
});
var $6b3687b80c76c896$exports = {};
"use strict";
Object.defineProperty($6b3687b80c76c896$exports, "__esModule", {
    value: true
});
var $83044eba4b8e40dc$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $83044eba4b8e40dc$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $83044eba4b8e40dc$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($83044eba4b8e40dc$exports, "__esModule", {
    value: true
});
$83044eba4b8e40dc$exports.GridColumnHeaderItem = void 0;

var $83044eba4b8e40dc$var$_extends2 = $83044eba4b8e40dc$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $83044eba4b8e40dc$var$React = $83044eba4b8e40dc$require$_interopRequireWildcard((parcelRequire("acw62")));

var $83044eba4b8e40dc$var$_propTypes = $83044eba4b8e40dc$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $83044eba4b8e40dc$var$_clsx = $83044eba4b8e40dc$require$_interopRequireDefault((parcelRequire("9QePP")));

var $83044eba4b8e40dc$var$_composeClasses = $83044eba4b8e40dc$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $83044eba4b8e40dc$var$_useId = $83044eba4b8e40dc$require$_interopRequireDefault((parcelRequire("hwliF")));


var $9uEev = parcelRequire("9uEev");


var $er55f = parcelRequire("er55f");
var $5187827afc33a627$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $5187827afc33a627$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $5187827afc33a627$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($5187827afc33a627$exports, "__esModule", {
    value: true
});
$5187827afc33a627$exports.ColumnHeaderMenuIcon = void 0;

var $5187827afc33a627$var$_extends2 = $5187827afc33a627$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $5187827afc33a627$var$React = $5187827afc33a627$require$_interopRequireWildcard((parcelRequire("acw62")));

var $5187827afc33a627$var$_composeClasses = $5187827afc33a627$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $bDyDY = parcelRequire("bDyDY");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $5187827afc33a627$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, open: open } = ownerState;
    const slots = {
        root: [
            'menuIcon',
            open && 'menuOpen'
        ],
        button: [
            'menuIconButton'
        ]
    };
    return (0, $5187827afc33a627$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $5187827afc33a627$var$ColumnHeaderMenuIcon = $5187827afc33a627$exports.ColumnHeaderMenuIcon = /*#__PURE__*/ $5187827afc33a627$var$React.memo((props)=>{
    const { colDef: colDef, open: open, columnMenuId: columnMenuId, columnMenuButtonId: columnMenuButtonId, iconButtonRef: iconButtonRef } = props;
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = (0, $5187827afc33a627$var$_extends2.default)({}, props, {
        classes: rootProps.classes
    });
    const classes = $5187827afc33a627$var$useUtilityClasses(ownerState);
    const handleMenuIconClick = $5187827afc33a627$var$React.useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        apiRef.current.toggleColumnMenu(colDef.field);
    }, [
        apiRef,
        colDef.field
    ]);
    const columnName = colDef.headerName ?? colDef.field;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: classes.root,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTooltip, (0, $5187827afc33a627$var$_extends2.default)({
            title: apiRef.current.getLocaleText('columnMenuLabel'),
            enterDelay: 1000
        }, rootProps.slotProps?.baseTooltip, {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseIconButton, (0, $5187827afc33a627$var$_extends2.default)({
                ref: iconButtonRef,
                tabIndex: -1,
                className: classes.button,
                "aria-label": apiRef.current.getLocaleText('columnMenuAriaLabel')(columnName),
                size: "small",
                onClick: handleMenuIconClick,
                "aria-haspopup": "menu",
                "aria-expanded": open,
                "aria-controls": open ? columnMenuId : undefined,
                id: columnMenuButtonId
            }, rootProps.slotProps?.baseIconButton, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnMenuIcon, {
                    fontSize: "inherit"
                })
            }))
        }))
    });
});
$5187827afc33a627$var$ColumnHeaderMenuIcon.displayName = "ColumnHeaderMenuIcon";


var $f741464eaaf59d11$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $f741464eaaf59d11$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $f741464eaaf59d11$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($f741464eaaf59d11$exports, "__esModule", {
    value: true
});
$f741464eaaf59d11$exports.GridColumnHeaderMenu = $f741464eaaf59d11$var$GridColumnHeaderMenu;

var $f741464eaaf59d11$var$_extends2 = $f741464eaaf59d11$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $f741464eaaf59d11$var$React = $f741464eaaf59d11$require$_interopRequireWildcard((parcelRequire("acw62")));

var $f741464eaaf59d11$var$_propTypes = $f741464eaaf59d11$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $f741464eaaf59d11$var$_useEventCallback = $f741464eaaf59d11$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $f741464eaaf59d11$var$_HTMLElementType = $f741464eaaf59d11$require$_interopRequireDefault((parcelRequire("cIfK5")));

var $bDyDY = parcelRequire("bDyDY");


var $ayMG0 = parcelRequire("ayMG0");
function $f741464eaaf59d11$var$GridColumnHeaderMenu({ columnMenuId: columnMenuId, columnMenuButtonId: columnMenuButtonId, ContentComponent: ContentComponent, contentComponentProps: contentComponentProps, field: field, open: open, target: target, onExited: onExited }) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const colDef = apiRef.current.getColumn(field);
    const hideMenu = (0, $f741464eaaf59d11$var$_useEventCallback.default)((event)=>{
        if (event) {
            // Prevent triggering the sorting
            event.stopPropagation();
            if (target?.contains(event.target)) return;
        }
        apiRef.current.hideColumnMenu();
    });
    if (!target || !colDef) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($8efc7911d5661cb8$exports.GridMenu, {
        position: `bottom-${colDef.align === 'right' ? 'start' : 'end'}`,
        open: open,
        target: target,
        onClose: hideMenu,
        onExited: onExited,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(ContentComponent, (0, $f741464eaaf59d11$var$_extends2.default)({
            colDef: colDef,
            hideMenu: hideMenu,
            open: open,
            id: columnMenuId,
            labelledby: columnMenuButtonId
        }, contentComponentProps))
    });
}
$f741464eaaf59d11$var$GridColumnHeaderMenu.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    columnMenuButtonId: $f741464eaaf59d11$var$_propTypes.default.string,
    columnMenuId: $f741464eaaf59d11$var$_propTypes.default.string,
    ContentComponent: $f741464eaaf59d11$var$_propTypes.default.elementType.isRequired,
    contentComponentProps: $f741464eaaf59d11$var$_propTypes.default.any,
    field: $f741464eaaf59d11$var$_propTypes.default.string.isRequired,
    onExited: $f741464eaaf59d11$var$_propTypes.default.func,
    open: $f741464eaaf59d11$var$_propTypes.default.bool.isRequired,
    target: $f741464eaaf59d11$var$_HTMLElementType.default
};



var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");
var $30ff34474d4fdbcc$exports = {};
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $30ff34474d4fdbcc$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $30ff34474d4fdbcc$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($30ff34474d4fdbcc$exports, "__esModule", {
    value: true
});
$30ff34474d4fdbcc$exports.GridGenericColumnHeaderItem = void 0;

var $30ff34474d4fdbcc$var$_extends2 = $30ff34474d4fdbcc$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $30ff34474d4fdbcc$var$_objectWithoutPropertiesLoose2 = $30ff34474d4fdbcc$require$_interopRequireDefault((parcelRequire("c05no")));

var $30ff34474d4fdbcc$var$React = $30ff34474d4fdbcc$require$_interopRequireWildcard((parcelRequire("acw62")));

var $30ff34474d4fdbcc$var$_clsx = $30ff34474d4fdbcc$require$_interopRequireDefault((parcelRequire("9QePP")));

var $30ff34474d4fdbcc$var$_useForkRef = $30ff34474d4fdbcc$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $fYxgT = parcelRequire("fYxgT");
var $1b091ef728f7a646$exports = {};
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $1b091ef728f7a646$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $1b091ef728f7a646$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($1b091ef728f7a646$exports, "__esModule", {
    value: true
});
$1b091ef728f7a646$exports.GridColumnHeaderTitle = $1b091ef728f7a646$var$GridColumnHeaderTitle;

var $1b091ef728f7a646$var$_extends2 = $1b091ef728f7a646$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $1b091ef728f7a646$var$_objectWithoutPropertiesLoose2 = $1b091ef728f7a646$require$_interopRequireDefault((parcelRequire("c05no")));

var $1b091ef728f7a646$var$React = $1b091ef728f7a646$require$_interopRequireWildcard((parcelRequire("acw62")));

var $1b091ef728f7a646$var$_propTypes = $1b091ef728f7a646$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $1b091ef728f7a646$var$_clsx = $1b091ef728f7a646$require$_interopRequireDefault((parcelRequire("9QePP")));

var $1b091ef728f7a646$var$_composeClasses = $1b091ef728f7a646$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $izOUK = parcelRequire("izOUK");

var $fYxgT = parcelRequire("fYxgT");
var $08bb4bf24f47b880$exports = {};
"use strict";
Object.defineProperty($08bb4bf24f47b880$exports, "__esModule", {
    value: true
});
$08bb4bf24f47b880$exports.escapeOperandAttributeSelector = $08bb4bf24f47b880$var$escapeOperandAttributeSelector;
$08bb4bf24f47b880$exports.findGridCellElementsFromCol = $08bb4bf24f47b880$var$findGridCellElementsFromCol;
$08bb4bf24f47b880$exports.findGridCells = $08bb4bf24f47b880$var$findGridCells;
$08bb4bf24f47b880$exports.findGridElement = $08bb4bf24f47b880$var$findGridElement;
$08bb4bf24f47b880$exports.findGridHeader = $08bb4bf24f47b880$var$findGridHeader;
$08bb4bf24f47b880$exports.findGroupHeaderElementsFromField = $08bb4bf24f47b880$var$findGroupHeaderElementsFromField;
$08bb4bf24f47b880$exports.findHeaderElementFromField = $08bb4bf24f47b880$var$findHeaderElementFromField;
$08bb4bf24f47b880$exports.findLeftPinnedCellsAfterCol = $08bb4bf24f47b880$var$findLeftPinnedCellsAfterCol;
$08bb4bf24f47b880$exports.findLeftPinnedHeadersAfterCol = $08bb4bf24f47b880$var$findLeftPinnedHeadersAfterCol;
$08bb4bf24f47b880$exports.findParentElementFromClassName = $08bb4bf24f47b880$var$findParentElementFromClassName;
$08bb4bf24f47b880$exports.findRightPinnedCellsBeforeCol = $08bb4bf24f47b880$var$findRightPinnedCellsBeforeCol;
$08bb4bf24f47b880$exports.findRightPinnedHeadersBeforeCol = $08bb4bf24f47b880$var$findRightPinnedHeadersBeforeCol;
$08bb4bf24f47b880$exports.getActiveElement = void 0;
$08bb4bf24f47b880$exports.getFieldFromHeaderElem = $08bb4bf24f47b880$var$getFieldFromHeaderElem;
$08bb4bf24f47b880$exports.getFieldsFromGroupHeaderElem = $08bb4bf24f47b880$var$getFieldsFromGroupHeaderElem;
$08bb4bf24f47b880$exports.getGridCellElement = $08bb4bf24f47b880$var$getGridCellElement;
$08bb4bf24f47b880$exports.getGridColumnHeaderElement = $08bb4bf24f47b880$var$getGridColumnHeaderElement;
$08bb4bf24f47b880$exports.getGridRowElement = $08bb4bf24f47b880$var$getGridRowElement;
$08bb4bf24f47b880$exports.isEventTargetInPortal = $08bb4bf24f47b880$var$isEventTargetInPortal;
$08bb4bf24f47b880$exports.isOverflown = $08bb4bf24f47b880$var$isOverflown;

var $5H1vo = parcelRequire("5H1vo");
function $08bb4bf24f47b880$var$isOverflown(element) {
    return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
}
function $08bb4bf24f47b880$var$findParentElementFromClassName(elem, className) {
    return elem.closest(`.${className}`);
}
// TODO, eventually replaces this function with CSS.escape, once available in jsdom, either added manually or built in
// https://github.com/jsdom/jsdom/issues/1550#issuecomment-236734471
function $08bb4bf24f47b880$var$escapeOperandAttributeSelector(operand) {
    return operand.replace(/["\\]/g, '\\$&');
}
function $08bb4bf24f47b880$var$getGridColumnHeaderElement(root, field) {
    return root.querySelector(`[role="columnheader"][data-field="${$08bb4bf24f47b880$var$escapeOperandAttributeSelector(field)}"]`);
}
function $08bb4bf24f47b880$var$getGridRowElementSelector(id) {
    return `.${$5H1vo.gridClasses.row}[data-id="${$08bb4bf24f47b880$var$escapeOperandAttributeSelector(String(id))}"]`;
}
function $08bb4bf24f47b880$var$getGridRowElement(root, id) {
    return root.querySelector($08bb4bf24f47b880$var$getGridRowElementSelector(id));
}
function $08bb4bf24f47b880$var$getGridCellElement(root, { id: id, field: field }) {
    const rowSelector = $08bb4bf24f47b880$var$getGridRowElementSelector(id);
    const cellSelector = `.${$5H1vo.gridClasses.cell}[data-field="${$08bb4bf24f47b880$var$escapeOperandAttributeSelector(field)}"]`;
    const selector = `${rowSelector} ${cellSelector}`;
    return root.querySelector(selector);
}
// https://www.abeautifulsite.net/posts/finding-the-active-element-in-a-shadow-root/
const $08bb4bf24f47b880$var$getActiveElement = (root = document)=>{
    const activeEl = root.activeElement;
    if (!activeEl) return null;
    if (activeEl.shadowRoot) return $08bb4bf24f47b880$var$getActiveElement(activeEl.shadowRoot);
    return activeEl;
};
$08bb4bf24f47b880$exports.getActiveElement = $08bb4bf24f47b880$var$getActiveElement;
function $08bb4bf24f47b880$var$isEventTargetInPortal(event) {
    if (// The target is not an element when triggered by a Select inside the cell
    // See https://github.com/mui/material-ui/issues/10534
    event.target.nodeType === 1 && !event.currentTarget.contains(event.target)) return true;
    return false;
}
function $08bb4bf24f47b880$var$getFieldFromHeaderElem(colCellEl) {
    return colCellEl.getAttribute('data-field');
}
function $08bb4bf24f47b880$var$findHeaderElementFromField(elem, field) {
    return elem.querySelector(`[data-field="${$08bb4bf24f47b880$var$escapeOperandAttributeSelector(field)}"]`);
}
function $08bb4bf24f47b880$var$getFieldsFromGroupHeaderElem(colCellEl) {
    return colCellEl.getAttribute('data-fields').slice(2, -2).split('-|-');
}
function $08bb4bf24f47b880$var$findGroupHeaderElementsFromField(elem, field) {
    return Array.from(elem.querySelectorAll(`[data-fields*="|-${$08bb4bf24f47b880$var$escapeOperandAttributeSelector(field)}-|"]`) ?? []);
}
function $08bb4bf24f47b880$var$findGridCellElementsFromCol(col, api) {
    const root = $08bb4bf24f47b880$var$findParentElementFromClassName(col, $5H1vo.gridClasses.root);
    if (!root) throw new Error('MUI X: The root element is not found.');
    const ariaColIndex = col.getAttribute('aria-colindex');
    if (!ariaColIndex) return [];
    const colIndex = Number(ariaColIndex) - 1;
    const cells = [];
    if (!api.virtualScrollerRef?.current) return [];
    $08bb4bf24f47b880$var$queryRows(api).forEach((rowElement)=>{
        const rowId = rowElement.getAttribute('data-id');
        if (!rowId) return;
        let columnIndex = colIndex;
        const cellColSpanInfo = api.unstable_getCellColSpanInfo(rowId, colIndex);
        if (cellColSpanInfo && cellColSpanInfo.spannedByColSpan) columnIndex = cellColSpanInfo.leftVisibleCellIndex;
        const cell = rowElement.querySelector(`[data-colindex="${columnIndex}"]`);
        if (cell) cells.push(cell);
    });
    return cells;
}
function $08bb4bf24f47b880$var$findGridElement(api, klass) {
    return api.rootElementRef.current.querySelector(`.${$5H1vo.gridClasses[klass]}`);
}
const $08bb4bf24f47b880$var$findPinnedCells = ({ api: api, colIndex: colIndex, position: position, filterFn: filterFn })=>{
    if (colIndex === null) return [];
    const cells = [];
    $08bb4bf24f47b880$var$queryRows(api).forEach((rowElement)=>{
        const rowId = rowElement.getAttribute('data-id');
        if (!rowId) return;
        rowElement.querySelectorAll(`.${$5H1vo.gridClasses[position === 'left' ? 'cell--pinnedLeft' : 'cell--pinnedRight']}`).forEach((cell)=>{
            const currentColIndex = $08bb4bf24f47b880$var$parseCellColIndex(cell);
            if (currentColIndex !== null && filterFn(currentColIndex)) cells.push(cell);
        });
    });
    return cells;
};
function $08bb4bf24f47b880$var$findLeftPinnedCellsAfterCol(api, col, isRtl) {
    const colIndex = $08bb4bf24f47b880$var$parseCellColIndex(col);
    return $08bb4bf24f47b880$var$findPinnedCells({
        api: api,
        colIndex: colIndex,
        position: isRtl ? 'right' : 'left',
        filterFn: (index)=>isRtl ? index < colIndex : index > colIndex
    });
}
function $08bb4bf24f47b880$var$findRightPinnedCellsBeforeCol(api, col, isRtl) {
    const colIndex = $08bb4bf24f47b880$var$parseCellColIndex(col);
    return $08bb4bf24f47b880$var$findPinnedCells({
        api: api,
        colIndex: colIndex,
        position: isRtl ? 'left' : 'right',
        filterFn: (index)=>isRtl ? index > colIndex : index < colIndex
    });
}
const $08bb4bf24f47b880$var$findPinnedHeaders = ({ api: api, colIndex: colIndex, position: position, filterFn: filterFn })=>{
    if (!api.columnHeadersContainerRef?.current) return [];
    if (colIndex === null) return [];
    const elements = [];
    api.columnHeadersContainerRef.current.querySelectorAll(`.${$5H1vo.gridClasses[position === 'left' ? 'columnHeader--pinnedLeft' : 'columnHeader--pinnedRight']}`).forEach((element)=>{
        const currentColIndex = $08bb4bf24f47b880$var$parseCellColIndex(element);
        if (currentColIndex !== null && filterFn(currentColIndex, element)) elements.push(element);
    });
    return elements;
};
function $08bb4bf24f47b880$var$findLeftPinnedHeadersAfterCol(api, col, isRtl) {
    const colIndex = $08bb4bf24f47b880$var$parseCellColIndex(col);
    return $08bb4bf24f47b880$var$findPinnedHeaders({
        api: api,
        position: isRtl ? 'right' : 'left',
        colIndex: colIndex,
        filterFn: (index)=>isRtl ? index < colIndex : index > colIndex
    });
}
function $08bb4bf24f47b880$var$findRightPinnedHeadersBeforeCol(api, col, isRtl) {
    const colIndex = $08bb4bf24f47b880$var$parseCellColIndex(col);
    return $08bb4bf24f47b880$var$findPinnedHeaders({
        api: api,
        position: isRtl ? 'left' : 'right',
        colIndex: colIndex,
        filterFn: (index, element)=>{
            if (element.classList.contains($5H1vo.gridClasses['columnHeader--last'])) return false;
            return isRtl ? index > colIndex : index < colIndex;
        }
    });
}
function $08bb4bf24f47b880$var$findGridHeader(api, field) {
    const headers = api.columnHeadersContainerRef.current;
    return headers.querySelector(`:scope > div > [data-field="${$08bb4bf24f47b880$var$escapeOperandAttributeSelector(field)}"][role="columnheader"]`);
}
function $08bb4bf24f47b880$var$findGridCells(api, field) {
    const container = api.virtualScrollerRef.current;
    return Array.from(container.querySelectorAll(`:scope > div > div > div > [data-field="${$08bb4bf24f47b880$var$escapeOperandAttributeSelector(field)}"][role="gridcell"]`));
}
function $08bb4bf24f47b880$var$queryRows(api) {
    return api.virtualScrollerRef.current.querySelectorAll(// Use > to ignore rows from nested Data Grids (for example in detail panel)
    `:scope > div > div > .${$5H1vo.gridClasses.row}`);
}
function $08bb4bf24f47b880$var$parseCellColIndex(col) {
    const ariaColIndex = col.getAttribute('aria-colindex');
    if (!ariaColIndex) return null;
    return Number(ariaColIndex) - 1;
}



var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $1b091ef728f7a646$var$_excluded = [
    "className",
    "aria-label"
];
const $1b091ef728f7a646$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'columnHeaderTitle'
        ]
    };
    return (0, $1b091ef728f7a646$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $1b091ef728f7a646$var$GridColumnHeaderTitleRoot = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnHeaderTitle'
})({
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    fontWeight: 'var(--unstable_DataGrid-headWeight)',
    lineHeight: 'normal'
});
const $1b091ef728f7a646$var$ColumnHeaderInnerTitle = (0, $fYxgT.forwardRef)(function ColumnHeaderInnerTitle(props, ref) {
    // Tooltip adds aria-label to the props, which is not needed since the children prop is a string
    // See https://github.com/mui/mui-x/pull/14482
    const { className: className } = props, other = (0, $1b091ef728f7a646$var$_objectWithoutPropertiesLoose2.default)(props, $1b091ef728f7a646$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $1b091ef728f7a646$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1b091ef728f7a646$var$GridColumnHeaderTitleRoot, (0, $1b091ef728f7a646$var$_extends2.default)({
        className: (0, $1b091ef728f7a646$var$_clsx.default)(classes.root, className),
        ownerState: rootProps
    }, other, {
        ref: ref
    }));
});
$1b091ef728f7a646$var$ColumnHeaderInnerTitle.displayName = "ColumnHeaderInnerTitle";
// No React.memo here as if we display the sort icon, we need to recalculate the isOver
function $1b091ef728f7a646$var$GridColumnHeaderTitle(props) {
    const { label: label, description: description } = props;
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const titleRef = $1b091ef728f7a646$var$React.useRef(null);
    const [tooltip, setTooltip] = $1b091ef728f7a646$var$React.useState('');
    const handleMouseOver = $1b091ef728f7a646$var$React.useCallback(()=>{
        if (!description && titleRef?.current) {
            const isOver = (0, $08bb4bf24f47b880$exports.isOverflown)(titleRef.current);
            if (isOver) setTooltip(label);
            else setTooltip('');
        }
    }, [
        description,
        label
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTooltip, (0, $1b091ef728f7a646$var$_extends2.default)({
        title: description || tooltip
    }, rootProps.slotProps?.baseTooltip, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($1b091ef728f7a646$var$ColumnHeaderInnerTitle, {
            onMouseOver: handleMouseOver,
            ref: titleRef,
            children: label
        })
    }));
}
$1b091ef728f7a646$var$GridColumnHeaderTitle.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    columnWidth: $1b091ef728f7a646$var$_propTypes.default.number.isRequired,
    description: $1b091ef728f7a646$var$_propTypes.default.node,
    label: $1b091ef728f7a646$var$_propTypes.default.string.isRequired
};


var $8be1f8ad99c6bade$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $8be1f8ad99c6bade$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $8be1f8ad99c6bade$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($8be1f8ad99c6bade$exports, "__esModule", {
    value: true
});
$8be1f8ad99c6bade$exports.GridColumnHeaderSeparatorSides = $8be1f8ad99c6bade$exports.GridColumnHeaderSeparator = void 0;

var $8be1f8ad99c6bade$var$_extends2 = $8be1f8ad99c6bade$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $8be1f8ad99c6bade$var$_objectWithoutPropertiesLoose2 = $8be1f8ad99c6bade$require$_interopRequireDefault((parcelRequire("c05no")));

var $8be1f8ad99c6bade$var$React = $8be1f8ad99c6bade$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8be1f8ad99c6bade$var$_propTypes = $8be1f8ad99c6bade$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8be1f8ad99c6bade$var$_composeClasses = $8be1f8ad99c6bade$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $8be1f8ad99c6bade$var$_capitalize = $8be1f8ad99c6bade$require$_interopRequireDefault((parcelRequire("4O6za")));

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $8be1f8ad99c6bade$var$_excluded = [
    "resizable",
    "resizing",
    "height",
    "side"
];
var $8be1f8ad99c6bade$var$GridColumnHeaderSeparatorSides = $8be1f8ad99c6bade$exports.GridColumnHeaderSeparatorSides = /*#__PURE__*/ function(GridColumnHeaderSeparatorSides) {
    GridColumnHeaderSeparatorSides["Left"] = "left";
    GridColumnHeaderSeparatorSides["Right"] = "right";
    return GridColumnHeaderSeparatorSides;
}($8be1f8ad99c6bade$var$GridColumnHeaderSeparatorSides || {});
const $8be1f8ad99c6bade$var$useUtilityClasses = (ownerState)=>{
    const { resizable: resizable, resizing: resizing, classes: classes, side: side } = ownerState;
    const slots = {
        root: [
            'columnSeparator',
            resizable && 'columnSeparator--resizable',
            resizing && 'columnSeparator--resizing',
            side && `columnSeparator--side${(0, $8be1f8ad99c6bade$var$_capitalize.default)(side)}`
        ],
        icon: [
            'iconSeparator'
        ]
    };
    return (0, $8be1f8ad99c6bade$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
function $8be1f8ad99c6bade$var$GridColumnHeaderSeparatorRaw(props) {
    const { height: height, side: side = $8be1f8ad99c6bade$var$GridColumnHeaderSeparatorSides.Right } = props, other = (0, $8be1f8ad99c6bade$var$_objectWithoutPropertiesLoose2.default)(props, $8be1f8ad99c6bade$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = (0, $8be1f8ad99c6bade$var$_extends2.default)({}, props, {
        side: side,
        classes: rootProps.classes
    });
    const classes = $8be1f8ad99c6bade$var$useUtilityClasses(ownerState);
    const stopClick = $8be1f8ad99c6bade$var$React.useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
    }, []);
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    (0, $ayMG0.jsx)("div", (0, $8be1f8ad99c6bade$var$_extends2.default)({
        className: classes.root,
        style: {
            minHeight: height
        }
    }, other, {
        onClick: stopClick,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnResizeIcon, {
            className: classes.icon
        })
    })));
}
const $8be1f8ad99c6bade$var$GridColumnHeaderSeparator = $8be1f8ad99c6bade$exports.GridColumnHeaderSeparator = /*#__PURE__*/ $8be1f8ad99c6bade$var$React.memo($8be1f8ad99c6bade$var$GridColumnHeaderSeparatorRaw);
$8be1f8ad99c6bade$var$GridColumnHeaderSeparator.displayName = "GridColumnHeaderSeparator";
$8be1f8ad99c6bade$var$GridColumnHeaderSeparatorRaw.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    height: $8be1f8ad99c6bade$var$_propTypes.default.number.isRequired,
    resizable: $8be1f8ad99c6bade$var$_propTypes.default.bool.isRequired,
    resizing: $8be1f8ad99c6bade$var$_propTypes.default.bool.isRequired,
    side: $8be1f8ad99c6bade$var$_propTypes.default.oneOf([
        'left',
        'right'
    ])
};



var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $30ff34474d4fdbcc$var$_excluded = [
    "classes",
    "columnMenuOpen",
    "colIndex",
    "height",
    "isResizing",
    "sortDirection",
    "hasFocus",
    "tabIndex",
    "separatorSide",
    "isDraggable",
    "headerComponent",
    "description",
    "elementId",
    "width",
    "columnMenuIconButton",
    "columnMenu",
    "columnTitleIconButtons",
    "headerClassName",
    "label",
    "resizable",
    "draggableContainerProps",
    "columnHeaderSeparatorProps",
    "style"
];
const $30ff34474d4fdbcc$var$GridGenericColumnHeaderItem = $30ff34474d4fdbcc$exports.GridGenericColumnHeaderItem = (0, $fYxgT.forwardRef)(function GridGenericColumnHeaderItem(props, ref) {
    const { classes: classes, colIndex: colIndex, height: height, isResizing: isResizing, sortDirection: sortDirection, tabIndex: tabIndex, separatorSide: separatorSide, isDraggable: isDraggable, headerComponent: headerComponent, description: description, width: width, columnMenuIconButton: columnMenuIconButton = null, columnMenu: columnMenu = null, columnTitleIconButtons: columnTitleIconButtons = null, headerClassName: headerClassName, label: label, resizable: resizable, draggableContainerProps: draggableContainerProps, columnHeaderSeparatorProps: columnHeaderSeparatorProps, style: style } = props, other = (0, $30ff34474d4fdbcc$var$_objectWithoutPropertiesLoose2.default)(props, $30ff34474d4fdbcc$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const headerCellRef = $30ff34474d4fdbcc$var$React.useRef(null);
    const handleRef = (0, $30ff34474d4fdbcc$var$_useForkRef.default)(headerCellRef, ref);
    let ariaSort = 'none';
    if (sortDirection != null) ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", (0, $30ff34474d4fdbcc$var$_extends2.default)({
        className: (0, $30ff34474d4fdbcc$var$_clsx.default)(classes.root, headerClassName),
        style: (0, $30ff34474d4fdbcc$var$_extends2.default)({}, style, {
            width: width
        }),
        role: "columnheader",
        tabIndex: tabIndex,
        "aria-colindex": colIndex + 1,
        "aria-sort": ariaSort
    }, other, {
        ref: handleRef,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", (0, $30ff34474d4fdbcc$var$_extends2.default)({
                className: classes.draggableContainer,
                draggable: isDraggable,
                role: "presentation"
            }, draggableContainerProps, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: classes.titleContainer,
                        role: "presentation",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: classes.titleContainerContent,
                                children: headerComponent !== undefined ? headerComponent : /*#__PURE__*/ (0, $ayMG0.jsx)($1b091ef728f7a646$exports.GridColumnHeaderTitle, {
                                    label: label,
                                    description: description,
                                    columnWidth: width
                                })
                            }),
                            columnTitleIconButtons
                        ]
                    }),
                    columnMenuIconButton
                ]
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)($8be1f8ad99c6bade$exports.GridColumnHeaderSeparator, (0, $30ff34474d4fdbcc$var$_extends2.default)({
                resizable: !rootProps.disableColumnResize && !!resizable,
                resizing: isResizing,
                height: height,
                side: separatorSide
            }, columnHeaderSeparatorProps)),
            columnMenu
        ]
    }));
});
$30ff34474d4fdbcc$var$GridGenericColumnHeaderItem.displayName = "GridGenericColumnHeaderItem";






var $ayMG0 = parcelRequire("ayMG0");
const $83044eba4b8e40dc$var$useUtilityClasses = (ownerState)=>{
    const { disableColumnSorting: disableColumnSorting } = (0, $jDpXp.useGridRootProps)();
    const { colDef: colDef, classes: classes, isDragging: isDragging, sortDirection: sortDirection, showRightBorder: showRightBorder, showLeftBorder: showLeftBorder, filterItemsCounter: filterItemsCounter, pinnedPosition: pinnedPosition, isSiblingFocused: isSiblingFocused } = ownerState;
    const isColumnSortable = colDef.sortable && !disableColumnSorting;
    const isColumnSorted = sortDirection != null;
    const isColumnFiltered = filterItemsCounter != null && filterItemsCounter > 0;
    // todo refactor to a prop on col isNumeric or ?? ie: coltype===price wont work
    const isColumnNumeric = colDef.type === 'number';
    const slots = {
        root: [
            'columnHeader',
            colDef.headerAlign === 'left' && 'columnHeader--alignLeft',
            colDef.headerAlign === 'center' && 'columnHeader--alignCenter',
            colDef.headerAlign === 'right' && 'columnHeader--alignRight',
            isColumnSortable && 'columnHeader--sortable',
            isDragging && 'columnHeader--moving',
            isColumnSorted && 'columnHeader--sorted',
            isColumnFiltered && 'columnHeader--filtered',
            isColumnNumeric && 'columnHeader--numeric',
            'withBorderColor',
            showRightBorder && 'columnHeader--withRightBorder',
            showLeftBorder && 'columnHeader--withLeftBorder',
            pinnedPosition === $e8d35a7c12bdaa1d$exports.PinnedColumnPosition.LEFT && 'columnHeader--pinnedLeft',
            pinnedPosition === $e8d35a7c12bdaa1d$exports.PinnedColumnPosition.RIGHT && 'columnHeader--pinnedRight',
            // TODO: Remove classes below and restore `:has` selectors when they are supported in jsdom
            // See https://github.com/mui/mui-x/pull/14559
            isSiblingFocused && 'columnHeader--siblingFocused'
        ],
        draggableContainer: [
            'columnHeaderDraggableContainer'
        ],
        titleContainer: [
            'columnHeaderTitleContainer'
        ],
        titleContainerContent: [
            'columnHeaderTitleContainerContent'
        ]
    };
    return (0, $83044eba4b8e40dc$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
function $83044eba4b8e40dc$var$GridColumnHeaderItem(props) {
    const { colDef: colDef, columnMenuOpen: columnMenuOpen, colIndex: colIndex, headerHeight: headerHeight, isResizing: isResizing, isLast: isLast, sortDirection: sortDirection, sortIndex: sortIndex, filterItemsCounter: filterItemsCounter, hasFocus: hasFocus, tabIndex: tabIndex, disableReorder: disableReorder, separatorSide: separatorSide, showLeftBorder: showLeftBorder, showRightBorder: showRightBorder, pinnedPosition: pinnedPosition, pinnedOffset: pinnedOffset } = props;
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const isRtl = (0, $9uEev.useRtl)();
    const headerCellRef = $83044eba4b8e40dc$var$React.useRef(null);
    const columnMenuId = (0, $83044eba4b8e40dc$var$_useId.default)();
    const columnMenuButtonId = (0, $83044eba4b8e40dc$var$_useId.default)();
    const iconButtonRef = $83044eba4b8e40dc$var$React.useRef(null);
    const [showColumnMenuIcon, setShowColumnMenuIcon] = $83044eba4b8e40dc$var$React.useState(columnMenuOpen);
    const isDraggable = !rootProps.disableColumnReorder && !disableReorder && !colDef.disableReorder;
    let headerComponent;
    if (colDef.renderHeader) headerComponent = colDef.renderHeader(apiRef.current.getColumnHeaderParams(colDef.field));
    const ownerState = (0, $83044eba4b8e40dc$var$_extends2.default)({}, props, {
        classes: rootProps.classes,
        showRightBorder: showRightBorder,
        showLeftBorder: showLeftBorder
    });
    const classes = $83044eba4b8e40dc$var$useUtilityClasses(ownerState);
    const publish = $83044eba4b8e40dc$var$React.useCallback((eventName)=>(event)=>{
            // Ignore portal
            // See https://github.com/mui/mui-x/issues/1721
            if ((0, $08bb4bf24f47b880$exports.isEventTargetInPortal)(event)) return;
            apiRef.current.publishEvent(eventName, apiRef.current.getColumnHeaderParams(colDef.field), event);
        }, [
        apiRef,
        colDef.field
    ]);
    const mouseEventsHandlers = $83044eba4b8e40dc$var$React.useMemo(()=>({
            onClick: publish('columnHeaderClick'),
            onContextMenu: publish('columnHeaderContextMenu'),
            onDoubleClick: publish('columnHeaderDoubleClick'),
            onMouseOver: publish('columnHeaderOver'),
            // TODO remove as it's not used
            onMouseOut: publish('columnHeaderOut'),
            // TODO remove as it's not used
            onMouseEnter: publish('columnHeaderEnter'),
            // TODO remove as it's not used
            onMouseLeave: publish('columnHeaderLeave'),
            // TODO remove as it's not used
            onKeyDown: publish('columnHeaderKeyDown'),
            onFocus: publish('columnHeaderFocus'),
            onBlur: publish('columnHeaderBlur')
        }), [
        publish
    ]);
    const draggableEventHandlers = $83044eba4b8e40dc$var$React.useMemo(()=>isDraggable ? {
            onDragStart: publish('columnHeaderDragStart'),
            onDragEnter: publish('columnHeaderDragEnter'),
            onDragOver: publish('columnHeaderDragOver'),
            onDragEndCapture: publish('columnHeaderDragEnd')
        } : {}, [
        isDraggable,
        publish
    ]);
    const columnHeaderSeparatorProps = $83044eba4b8e40dc$var$React.useMemo(()=>({
            onMouseDown: publish('columnSeparatorMouseDown'),
            onDoubleClick: publish('columnSeparatorDoubleClick')
        }), [
        publish
    ]);
    $83044eba4b8e40dc$var$React.useEffect(()=>{
        if (!showColumnMenuIcon && columnMenuOpen) setShowColumnMenuIcon(columnMenuOpen);
    }, [
        showColumnMenuIcon,
        columnMenuOpen
    ]);
    const handleExited = $83044eba4b8e40dc$var$React.useCallback(()=>{
        setShowColumnMenuIcon(false);
    }, []);
    const columnMenuIconButton = !rootProps.disableColumnMenu && !colDef.disableColumnMenu && /*#__PURE__*/ (0, $ayMG0.jsx)($5187827afc33a627$exports.ColumnHeaderMenuIcon, {
        colDef: colDef,
        columnMenuId: columnMenuId,
        columnMenuButtonId: columnMenuButtonId,
        open: showColumnMenuIcon,
        iconButtonRef: iconButtonRef
    });
    const columnMenu = /*#__PURE__*/ (0, $ayMG0.jsx)($f741464eaaf59d11$exports.GridColumnHeaderMenu, {
        columnMenuId: columnMenuId,
        columnMenuButtonId: columnMenuButtonId,
        field: colDef.field,
        open: columnMenuOpen,
        target: iconButtonRef.current,
        ContentComponent: rootProps.slots.columnMenu,
        contentComponentProps: rootProps.slotProps?.columnMenu,
        onExited: handleExited
    });
    const sortingOrder = colDef.sortingOrder ?? rootProps.sortingOrder;
    const showSortIcon = (colDef.sortable || sortDirection != null) && !colDef.hideSortIcons && !rootProps.disableColumnSorting;
    const columnTitleIconButtons = /*#__PURE__*/ (0, $ayMG0.jsxs)($83044eba4b8e40dc$var$React.Fragment, {
        children: [
            !rootProps.disableColumnFilter && /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnHeaderFilterIconButton, (0, $83044eba4b8e40dc$var$_extends2.default)({
                field: colDef.field,
                counter: filterItemsCounter
            }, rootProps.slotProps?.columnHeaderFilterIconButton)),
            showSortIcon && /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnHeaderSortIcon, (0, $83044eba4b8e40dc$var$_extends2.default)({
                field: colDef.field,
                direction: sortDirection,
                index: sortIndex,
                sortingOrder: sortingOrder,
                disabled: !colDef.sortable
            }, rootProps.slotProps?.columnHeaderSortIcon))
        ]
    });
    $83044eba4b8e40dc$var$React.useLayoutEffect(()=>{
        const columnMenuState = apiRef.current.state.columnMenu;
        if (hasFocus && !columnMenuState.open) {
            const focusableElement = headerCellRef.current.querySelector('[tabindex="0"]');
            const elementToFocus = focusableElement || headerCellRef.current;
            if (!elementToFocus) return;
            if ((0, $bad574edb71acea7$exports.doesSupportPreventScroll)()) elementToFocus.focus({
                preventScroll: true
            });
            else {
                const scrollPosition = apiRef.current.getScrollPosition();
                elementToFocus.focus();
                apiRef.current.scroll(scrollPosition);
            }
        }
    }, [
        apiRef,
        hasFocus
    ]);
    const headerClassName = typeof colDef.headerClassName === 'function' ? colDef.headerClassName({
        field: colDef.field,
        colDef: colDef
    }) : colDef.headerClassName;
    const label = colDef.headerName ?? colDef.field;
    const style = $83044eba4b8e40dc$var$React.useMemo(()=>(0, $69aaaa4d4ca0aa66$exports.attachPinnedStyle)((0, $83044eba4b8e40dc$var$_extends2.default)({}, props.style), isRtl, pinnedPosition, pinnedOffset), [
        pinnedPosition,
        pinnedOffset,
        props.style,
        isRtl
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($30ff34474d4fdbcc$exports.GridGenericColumnHeaderItem, (0, $83044eba4b8e40dc$var$_extends2.default)({
        ref: headerCellRef,
        classes: classes,
        columnMenuOpen: columnMenuOpen,
        colIndex: colIndex,
        height: headerHeight,
        isResizing: isResizing,
        sortDirection: sortDirection,
        hasFocus: hasFocus,
        tabIndex: tabIndex,
        separatorSide: separatorSide,
        isDraggable: isDraggable,
        headerComponent: headerComponent,
        description: colDef.description,
        elementId: colDef.field,
        width: colDef.computedWidth,
        columnMenuIconButton: columnMenuIconButton,
        columnTitleIconButtons: columnTitleIconButtons,
        headerClassName: (0, $83044eba4b8e40dc$var$_clsx.default)(headerClassName, isLast && $5H1vo.gridClasses['columnHeader--last']),
        label: label,
        resizable: !rootProps.disableColumnResize && !!colDef.resizable,
        "data-field": colDef.field,
        columnMenu: columnMenu,
        draggableContainerProps: draggableEventHandlers,
        columnHeaderSeparatorProps: columnHeaderSeparatorProps,
        style: style
    }, mouseEventsHandlers));
}
$83044eba4b8e40dc$var$GridColumnHeaderItem.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    colDef: $83044eba4b8e40dc$var$_propTypes.default.object.isRequired,
    colIndex: $83044eba4b8e40dc$var$_propTypes.default.number.isRequired,
    columnMenuOpen: $83044eba4b8e40dc$var$_propTypes.default.bool.isRequired,
    disableReorder: $83044eba4b8e40dc$var$_propTypes.default.bool,
    filterItemsCounter: $83044eba4b8e40dc$var$_propTypes.default.number,
    hasFocus: $83044eba4b8e40dc$var$_propTypes.default.bool,
    headerHeight: $83044eba4b8e40dc$var$_propTypes.default.number.isRequired,
    isDragging: $83044eba4b8e40dc$var$_propTypes.default.bool.isRequired,
    isLast: $83044eba4b8e40dc$var$_propTypes.default.bool.isRequired,
    isResizing: $83044eba4b8e40dc$var$_propTypes.default.bool.isRequired,
    isSiblingFocused: $83044eba4b8e40dc$var$_propTypes.default.bool.isRequired,
    pinnedOffset: $83044eba4b8e40dc$var$_propTypes.default.number,
    pinnedPosition: $83044eba4b8e40dc$var$_propTypes.default.oneOf([
        0,
        1,
        2,
        3
    ]),
    separatorSide: $83044eba4b8e40dc$var$_propTypes.default.oneOf([
        'left',
        'right'
    ]),
    showLeftBorder: $83044eba4b8e40dc$var$_propTypes.default.bool.isRequired,
    showRightBorder: $83044eba4b8e40dc$var$_propTypes.default.bool.isRequired,
    sortDirection: $83044eba4b8e40dc$var$_propTypes.default.oneOf([
        'asc',
        'desc'
    ]),
    sortIndex: $83044eba4b8e40dc$var$_propTypes.default.number,
    style: $83044eba4b8e40dc$var$_propTypes.default.object,
    tabIndex: $83044eba4b8e40dc$var$_propTypes.default.oneOf([
        -1,
        0
    ]).isRequired
};
const $83044eba4b8e40dc$var$Memoized = $83044eba4b8e40dc$exports.GridColumnHeaderItem = (0, $1bc1b286f3c678cc$exports.fastMemo)($83044eba4b8e40dc$var$GridColumnHeaderItem);


Object.keys($83044eba4b8e40dc$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $6b3687b80c76c896$exports && $6b3687b80c76c896$exports[key] === $83044eba4b8e40dc$exports[key]) return;
    Object.defineProperty($6b3687b80c76c896$exports, key, {
        enumerable: true,
        get: function() {
            return $83044eba4b8e40dc$exports[key];
        }
    });
});

Object.keys($8be1f8ad99c6bade$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $6b3687b80c76c896$exports && $6b3687b80c76c896$exports[key] === $8be1f8ad99c6bade$exports[key]) return;
    Object.defineProperty($6b3687b80c76c896$exports, key, {
        enumerable: true,
        get: function() {
            return $8be1f8ad99c6bade$exports[key];
        }
    });
});
var $69f527f26ff57ed6$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $69f527f26ff57ed6$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $69f527f26ff57ed6$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($69f527f26ff57ed6$exports, "__esModule", {
    value: true
});
$69f527f26ff57ed6$exports.GridColumnHeaderSortIcon = void 0;

var $69f527f26ff57ed6$var$_extends2 = $69f527f26ff57ed6$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $69f527f26ff57ed6$var$React = $69f527f26ff57ed6$require$_interopRequireWildcard((parcelRequire("acw62")));

var $69f527f26ff57ed6$var$_propTypes = $69f527f26ff57ed6$require$_interopRequireDefault((parcelRequire("c9Z8w")));
var $de180beae3cc7fe7$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $de180beae3cc7fe7$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $de180beae3cc7fe7$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($de180beae3cc7fe7$exports, "__esModule", {
    value: true
});
$de180beae3cc7fe7$exports.GridIconButtonContainer = void 0;

var $de180beae3cc7fe7$var$_extends2 = $de180beae3cc7fe7$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $de180beae3cc7fe7$var$_objectWithoutPropertiesLoose2 = $de180beae3cc7fe7$require$_interopRequireDefault((parcelRequire("c05no")));

var $de180beae3cc7fe7$var$React = $de180beae3cc7fe7$require$_interopRequireWildcard((parcelRequire("acw62")));

var $de180beae3cc7fe7$var$_clsx = $de180beae3cc7fe7$require$_interopRequireDefault((parcelRequire("9QePP")));

var $de180beae3cc7fe7$var$_composeClasses = $de180beae3cc7fe7$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $izOUK = parcelRequire("izOUK");

var $fYxgT = parcelRequire("fYxgT");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $de180beae3cc7fe7$var$_excluded = [
    "className"
];
const $de180beae3cc7fe7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'iconButtonContainer'
        ]
    };
    return (0, $de180beae3cc7fe7$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $de180beae3cc7fe7$var$GridIconButtonContainerRoot = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'IconButtonContainer'
})(()=>({
        display: 'flex',
        visibility: 'hidden',
        width: 0
    }));
const $de180beae3cc7fe7$var$GridIconButtonContainer = $de180beae3cc7fe7$exports.GridIconButtonContainer = (0, $fYxgT.forwardRef)(function GridIconButtonContainer(props, ref) {
    const { className: className } = props, other = (0, $de180beae3cc7fe7$var$_objectWithoutPropertiesLoose2.default)(props, $de180beae3cc7fe7$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $de180beae3cc7fe7$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($de180beae3cc7fe7$var$GridIconButtonContainerRoot, (0, $de180beae3cc7fe7$var$_extends2.default)({
        className: (0, $de180beae3cc7fe7$var$_clsx.default)(classes.root, className),
        ownerState: rootProps
    }, other, {
        ref: ref
    }));
});
$de180beae3cc7fe7$var$GridIconButtonContainer.displayName = "GridIconButtonContainer";


var $49d9e81a7977b781$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $49d9e81a7977b781$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $49d9e81a7977b781$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($49d9e81a7977b781$exports, "__esModule", {
    value: true
});
$49d9e81a7977b781$exports.GridColumnSortButton = $49d9e81a7977b781$var$GridColumnSortButton;

var $49d9e81a7977b781$var$_objectWithoutPropertiesLoose2 = $49d9e81a7977b781$require$_interopRequireDefault((parcelRequire("c05no")));

var $49d9e81a7977b781$var$_extends2 = $49d9e81a7977b781$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $49d9e81a7977b781$var$React = $49d9e81a7977b781$require$_interopRequireWildcard((parcelRequire("acw62")));

var $49d9e81a7977b781$var$_propTypes = $49d9e81a7977b781$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $49d9e81a7977b781$var$_composeClasses = $49d9e81a7977b781$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $izOUK = parcelRequire("izOUK");

var $49d9e81a7977b781$var$_clsx = $49d9e81a7977b781$require$_interopRequireDefault((parcelRequire("9QePP")));

var $bDyDY = parcelRequire("bDyDY");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $hbuUJ = parcelRequire("hbuUJ");


var $ayMG0 = parcelRequire("ayMG0");
const $49d9e81a7977b781$var$_excluded = [
    "direction",
    "index",
    "sortingOrder",
    "disabled",
    "className"
];
const $49d9e81a7977b781$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'sortButton'
        ],
        icon: [
            'sortIcon'
        ]
    };
    return (0, $49d9e81a7977b781$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $49d9e81a7977b781$var$GridColumnSortButtonRoot = (0, $izOUK.styled)($dd66ac2a2c256d30$exports.NotRendered, {
    name: 'MuiDataGrid',
    slot: 'SortButton'
})({
    transition: $hbuUJ.vars.transition([
        'opacity'
    ], {
        duration: $hbuUJ.vars.transitions.duration.short,
        easing: $hbuUJ.vars.transitions.easing.easeInOut
    })
});
function $49d9e81a7977b781$var$getIcon(icons, direction, className, sortingOrder) {
    let Icon;
    const iconProps = {};
    if (direction === 'asc') Icon = icons.columnSortedAscendingIcon;
    else if (direction === 'desc') Icon = icons.columnSortedDescendingIcon;
    else {
        Icon = icons.columnUnsortedIcon;
        iconProps.sortingOrder = sortingOrder;
    }
    return Icon ? /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, (0, $49d9e81a7977b781$var$_extends2.default)({
        fontSize: "small",
        className: className
    }, iconProps)) : null;
}
function $49d9e81a7977b781$var$GridColumnSortButton(props) {
    const { direction: direction, index: index, sortingOrder: sortingOrder, disabled: disabled, className: className } = props, other = (0, $49d9e81a7977b781$var$_objectWithoutPropertiesLoose2.default)(props, $49d9e81a7977b781$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = (0, $49d9e81a7977b781$var$_extends2.default)({}, props, {
        classes: rootProps.classes
    });
    const classes = $49d9e81a7977b781$var$useUtilityClasses(ownerState);
    const iconElement = $49d9e81a7977b781$var$getIcon(rootProps.slots, direction, classes.icon, sortingOrder);
    if (!iconElement) return null;
    const iconButton = /*#__PURE__*/ (0, $ayMG0.jsx)($49d9e81a7977b781$var$GridColumnSortButtonRoot, (0, $49d9e81a7977b781$var$_extends2.default)({
        as: rootProps.slots.baseIconButton,
        ownerState: ownerState,
        "aria-label": apiRef.current.getLocaleText('columnHeaderSortIconLabel'),
        size: "small",
        disabled: disabled,
        className: (0, $49d9e81a7977b781$var$_clsx.default)(classes.root, className)
    }, rootProps.slotProps?.baseIconButton, other, {
        children: iconElement
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTooltip, (0, $49d9e81a7977b781$var$_extends2.default)({
        title: apiRef.current.getLocaleText('columnHeaderSortIconLabel'),
        enterDelay: 1000
    }, rootProps.slotProps?.baseTooltip, {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
            children: [
                index != null && /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseBadge, {
                    badgeContent: index,
                    color: "default",
                    overlap: "circular",
                    children: iconButton
                }),
                index == null && iconButton
            ]
        })
    }));
}
$49d9e81a7977b781$var$GridColumnSortButton.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    direction: $49d9e81a7977b781$var$_propTypes.default.oneOf([
        'asc',
        'desc'
    ]),
    disabled: $49d9e81a7977b781$var$_propTypes.default.bool,
    field: $49d9e81a7977b781$var$_propTypes.default.string.isRequired,
    index: $49d9e81a7977b781$var$_propTypes.default.number,
    onClick: $49d9e81a7977b781$var$_propTypes.default.func,
    sortingOrder: $49d9e81a7977b781$var$_propTypes.default.arrayOf($49d9e81a7977b781$var$_propTypes.default.oneOf([
        'asc',
        'desc'
    ])).isRequired
};



var $ayMG0 = parcelRequire("ayMG0");
function $69f527f26ff57ed6$var$GridColumnHeaderSortIconRaw(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($de180beae3cc7fe7$exports.GridIconButtonContainer, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($49d9e81a7977b781$exports.GridColumnSortButton, (0, $69f527f26ff57ed6$var$_extends2.default)({}, props, {
            tabIndex: -1
        }))
    });
}
const $69f527f26ff57ed6$var$GridColumnHeaderSortIcon = $69f527f26ff57ed6$exports.GridColumnHeaderSortIcon = /*#__PURE__*/ $69f527f26ff57ed6$var$React.memo($69f527f26ff57ed6$var$GridColumnHeaderSortIconRaw);
$69f527f26ff57ed6$var$GridColumnHeaderSortIcon.displayName = "GridColumnHeaderSortIcon";
$69f527f26ff57ed6$var$GridColumnHeaderSortIconRaw.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    className: $69f527f26ff57ed6$var$_propTypes.default.string,
    color: $69f527f26ff57ed6$var$_propTypes.default.oneOf([
        'default',
        'inherit',
        'primary'
    ]),
    direction: $69f527f26ff57ed6$var$_propTypes.default.oneOf([
        'asc',
        'desc'
    ]),
    disabled: $69f527f26ff57ed6$var$_propTypes.default.bool,
    edge: $69f527f26ff57ed6$var$_propTypes.default.oneOf([
        'end',
        'start',
        false
    ]),
    field: $69f527f26ff57ed6$var$_propTypes.default.string.isRequired,
    id: $69f527f26ff57ed6$var$_propTypes.default.string,
    index: $69f527f26ff57ed6$var$_propTypes.default.number,
    label: $69f527f26ff57ed6$var$_propTypes.default.string,
    role: $69f527f26ff57ed6$var$_propTypes.default.string,
    size: $69f527f26ff57ed6$var$_propTypes.default.oneOf([
        'large',
        'medium',
        'small'
    ]),
    sortingOrder: $69f527f26ff57ed6$var$_propTypes.default.arrayOf($69f527f26ff57ed6$var$_propTypes.default.oneOf([
        'asc',
        'desc'
    ])).isRequired,
    style: $69f527f26ff57ed6$var$_propTypes.default.object,
    tabIndex: $69f527f26ff57ed6$var$_propTypes.default.number,
    title: $69f527f26ff57ed6$var$_propTypes.default.string,
    touchRippleRef: $69f527f26ff57ed6$var$_propTypes.default.any
};


Object.keys($69f527f26ff57ed6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $6b3687b80c76c896$exports && $6b3687b80c76c896$exports[key] === $69f527f26ff57ed6$exports[key]) return;
    Object.defineProperty($6b3687b80c76c896$exports, key, {
        enumerable: true,
        get: function() {
            return $69f527f26ff57ed6$exports[key];
        }
    });
});
var $ea8e70d6ac9b663f$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $ea8e70d6ac9b663f$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $ea8e70d6ac9b663f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($ea8e70d6ac9b663f$exports, "__esModule", {
    value: true
});
$ea8e70d6ac9b663f$exports.GridColumnHeaderFilterIconButton = $ea8e70d6ac9b663f$var$GridColumnHeaderFilterIconButtonWrapped;

var $ea8e70d6ac9b663f$var$_extends2 = $ea8e70d6ac9b663f$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $ea8e70d6ac9b663f$var$React = $ea8e70d6ac9b663f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ea8e70d6ac9b663f$var$_propTypes = $ea8e70d6ac9b663f$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $ea8e70d6ac9b663f$var$_composeClasses = $ea8e70d6ac9b663f$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $ea8e70d6ac9b663f$var$_useId = $ea8e70d6ac9b663f$require$_interopRequireDefault((parcelRequire("hwliF")));




var $bDyDY = parcelRequire("bDyDY");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");


var $ayMG0 = parcelRequire("ayMG0");
const $ea8e70d6ac9b663f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        icon: [
            'filterIcon'
        ]
    };
    return (0, $ea8e70d6ac9b663f$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
function $ea8e70d6ac9b663f$var$GridColumnHeaderFilterIconButtonWrapped(props) {
    if (!props.counter) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ea8e70d6ac9b663f$var$GridColumnHeaderFilterIconButton, (0, $ea8e70d6ac9b663f$var$_extends2.default)({}, props));
}
$ea8e70d6ac9b663f$var$GridColumnHeaderFilterIconButtonWrapped.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    counter: $ea8e70d6ac9b663f$var$_propTypes.default.number,
    field: $ea8e70d6ac9b663f$var$_propTypes.default.string.isRequired,
    onClick: $ea8e70d6ac9b663f$var$_propTypes.default.func
};
function $ea8e70d6ac9b663f$var$GridColumnHeaderFilterIconButton(props) {
    const { counter: counter, field: field, onClick: onClick } = props;
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = (0, $ea8e70d6ac9b663f$var$_extends2.default)({}, props, {
        classes: rootProps.classes
    });
    const classes = $ea8e70d6ac9b663f$var$useUtilityClasses(ownerState);
    const labelId = (0, $ea8e70d6ac9b663f$var$_useId.default)();
    const isOpen = (0, $d8761d1e377450f5$exports.useGridSelector)(apiRef, $50fa8e974bf84473$exports.gridPreferencePanelSelectorWithLabel, labelId);
    const panelId = (0, $ea8e70d6ac9b663f$var$_useId.default)();
    const toggleFilter = $ea8e70d6ac9b663f$var$React.useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        const { open: open, openedPanelValue: openedPanelValue } = (0, $50fa8e974bf84473$exports.gridPreferencePanelStateSelector)(apiRef);
        if (open && openedPanelValue === $2ca45f4bbfed6878$exports.GridPreferencePanelsValue.filters) apiRef.current.hideFilterPanel();
        else apiRef.current.showFilterPanel(undefined, panelId, labelId);
        if (onClick) onClick(apiRef.current.getColumnHeaderParams(field), event);
    }, [
        apiRef,
        field,
        onClick,
        panelId,
        labelId
    ]);
    if (!counter) return null;
    const iconButton = /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseIconButton, (0, $ea8e70d6ac9b663f$var$_extends2.default)({
        id: labelId,
        onClick: toggleFilter,
        "aria-label": apiRef.current.getLocaleText('columnHeaderFiltersLabel'),
        size: "small",
        tabIndex: -1,
        "aria-haspopup": "menu",
        "aria-expanded": isOpen,
        "aria-controls": isOpen ? panelId : undefined
    }, rootProps.slotProps?.baseIconButton, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnFilteredIcon, {
            className: classes.icon,
            fontSize: "small"
        })
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTooltip, (0, $ea8e70d6ac9b663f$var$_extends2.default)({
        title: apiRef.current.getLocaleText('columnHeaderFiltersTooltipActive')(counter),
        enterDelay: 1000
    }, rootProps.slotProps?.baseTooltip, {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($de180beae3cc7fe7$exports.GridIconButtonContainer, {
            children: [
                counter > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseBadge, {
                    badgeContent: counter,
                    color: "default",
                    children: iconButton
                }),
                counter === 1 && iconButton
            ]
        })
    }));
}
$ea8e70d6ac9b663f$var$GridColumnHeaderFilterIconButton.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    counter: $ea8e70d6ac9b663f$var$_propTypes.default.number,
    field: $ea8e70d6ac9b663f$var$_propTypes.default.string.isRequired,
    onClick: $ea8e70d6ac9b663f$var$_propTypes.default.func
};


Object.keys($ea8e70d6ac9b663f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $6b3687b80c76c896$exports && $6b3687b80c76c896$exports[key] === $ea8e70d6ac9b663f$exports[key]) return;
    Object.defineProperty($6b3687b80c76c896$exports, key, {
        enumerable: true,
        get: function() {
            return $ea8e70d6ac9b663f$exports[key];
        }
    });
});

Object.keys($1b091ef728f7a646$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $6b3687b80c76c896$exports && $6b3687b80c76c896$exports[key] === $1b091ef728f7a646$exports[key]) return;
    Object.defineProperty($6b3687b80c76c896$exports, key, {
        enumerable: true,
        get: function() {
            return $1b091ef728f7a646$exports[key];
        }
    });
});


Object.keys($6b3687b80c76c896$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in $08eee520e810d520$exports && $08eee520e810d520$exports[key] === $6b3687b80c76c896$exports[key]) return;
    Object.defineProperty($08eee520e810d520$exports, key, {
        enumerable: true,
        get: function() {
            return $6b3687b80c76c896$exports[key];
        }
    });
});
var $6009e4982991f67d$exports = {};
"use strict";
Object.defineProperty($6009e4982991f67d$exports, "__esModule", {
    value: true
});

Object.keys($b1dfb45352a7562a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $6009e4982991f67d$exports && $6009e4982991f67d$exports[key] === $b1dfb45352a7562a$exports[key]) return;
    Object.defineProperty($6009e4982991f67d$exports, key, {
        enumerable: true,
        get: function() {
            return $b1dfb45352a7562a$exports[key];
        }
    });
});

Object.keys($328bc9e57e6b696b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $6009e4982991f67d$exports && $6009e4982991f67d$exports[key] === $328bc9e57e6b696b$exports[key]) return;
    Object.defineProperty($6009e4982991f67d$exports, key, {
        enumerable: true,
        get: function() {
            return $328bc9e57e6b696b$exports[key];
        }
    });
});


Object.keys($6009e4982991f67d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in $08eee520e810d520$exports && $08eee520e810d520$exports[key] === $6009e4982991f67d$exports[key]) return;
    Object.defineProperty($08eee520e810d520$exports, key, {
        enumerable: true,
        get: function() {
            return $6009e4982991f67d$exports[key];
        }
    });
});

var $fWql6 = parcelRequire("fWql6");
Object.keys($fWql6).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in $08eee520e810d520$exports && $08eee520e810d520$exports[key] === $fWql6[key]) return;
    Object.defineProperty($08eee520e810d520$exports, key, {
        enumerable: true,
        get: function() {
            return $fWql6[key];
        }
    });
});
var $b0a931fb4e0448ba$exports = {};
"use strict";
Object.defineProperty($b0a931fb4e0448ba$exports, "__esModule", {
    value: true
});
var $5567793dda12fa70$exports = {};
"use strict";
Object.defineProperty($5567793dda12fa70$exports, "__esModule", {
    value: true
});
var $5567793dda12fa70$var$_exportNames = {
    GridGenericColumnMenu: true
};
Object.defineProperty($5567793dda12fa70$exports, "GridGenericColumnMenu", {
    enumerable: true,
    get: function() {
        return $3bffa0a776b5a050$exports.GridGenericColumnMenu;
    }
});

Object.keys($f741464eaaf59d11$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($5567793dda12fa70$var$_exportNames, key)) return;
    if (key in $5567793dda12fa70$exports && $5567793dda12fa70$exports[key] === $f741464eaaf59d11$exports[key]) return;
    Object.defineProperty($5567793dda12fa70$exports, key, {
        enumerable: true,
        get: function() {
            return $f741464eaaf59d11$exports[key];
        }
    });
});
var $67ea2c7cbe10cee5$exports = {};
"use strict";
Object.defineProperty($67ea2c7cbe10cee5$exports, "__esModule", {
    value: true
});


Object.keys($67ea2c7cbe10cee5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($5567793dda12fa70$var$_exportNames, key)) return;
    if (key in $5567793dda12fa70$exports && $5567793dda12fa70$exports[key] === $67ea2c7cbe10cee5$exports[key]) return;
    Object.defineProperty($5567793dda12fa70$exports, key, {
        enumerable: true,
        get: function() {
            return $67ea2c7cbe10cee5$exports[key];
        }
    });
});
var $51bb2a84253ecd2c$exports = {};
"use strict";
Object.defineProperty($51bb2a84253ecd2c$exports, "__esModule", {
    value: true
});


Object.keys($51bb2a84253ecd2c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($5567793dda12fa70$var$_exportNames, key)) return;
    if (key in $5567793dda12fa70$exports && $5567793dda12fa70$exports[key] === $51bb2a84253ecd2c$exports[key]) return;
    Object.defineProperty($5567793dda12fa70$exports, key, {
        enumerable: true,
        get: function() {
            return $51bb2a84253ecd2c$exports[key];
        }
    });
});
var $05b53142b9ab08e6$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $05b53142b9ab08e6$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $05b53142b9ab08e6$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($05b53142b9ab08e6$exports, "__esModule", {
    value: true
});
$05b53142b9ab08e6$exports.GridColumnMenuContainer = void 0;

var $05b53142b9ab08e6$var$_extends2 = $05b53142b9ab08e6$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $05b53142b9ab08e6$var$_objectWithoutPropertiesLoose2 = $05b53142b9ab08e6$require$_interopRequireDefault((parcelRequire("c05no")));

var $05b53142b9ab08e6$var$_clsx = $05b53142b9ab08e6$require$_interopRequireDefault((parcelRequire("9QePP")));

var $05b53142b9ab08e6$var$_propTypes = $05b53142b9ab08e6$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $05b53142b9ab08e6$var$React = $05b53142b9ab08e6$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8xDHs = parcelRequire("8xDHs");

var $fYxgT = parcelRequire("fYxgT");



var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $05b53142b9ab08e6$var$_excluded = [
    "hideMenu",
    "colDef",
    "id",
    "labelledby",
    "className",
    "children",
    "open"
];
const $05b53142b9ab08e6$var$StyledMenuList = (0, $8xDHs.styled)($dd66ac2a2c256d30$exports.NotRendered)(()=>({
        minWidth: 248
    }));
function $05b53142b9ab08e6$var$handleMenuScrollCapture(event) {
    if (!event.currentTarget.contains(event.target)) return;
    event.stopPropagation();
}
const $05b53142b9ab08e6$var$GridColumnMenuContainer = $05b53142b9ab08e6$exports.GridColumnMenuContainer = (0, $fYxgT.forwardRef)(function GridColumnMenuContainer(props, ref) {
    const { hideMenu: hideMenu, id: id, labelledby: labelledby, className: className, children: children, open: open } = props, other = (0, $05b53142b9ab08e6$var$_objectWithoutPropertiesLoose2.default)(props, $05b53142b9ab08e6$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const handleListKeyDown = $05b53142b9ab08e6$var$React.useCallback((event)=>{
        if (event.key === 'Tab') event.preventDefault();
        if ((0, $a08faead7d1bb429$exports.isHideMenuKey)(event.key)) hideMenu(event);
    }, [
        hideMenu
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($05b53142b9ab08e6$var$StyledMenuList, (0, $05b53142b9ab08e6$var$_extends2.default)({
        as: rootProps.slots.baseMenuList,
        id: id,
        className: (0, $05b53142b9ab08e6$var$_clsx.default)($5H1vo.gridClasses.menuList, className),
        "aria-labelledby": labelledby,
        onKeyDown: handleListKeyDown,
        onWheel: $05b53142b9ab08e6$var$handleMenuScrollCapture,
        onTouchMove: $05b53142b9ab08e6$var$handleMenuScrollCapture,
        autoFocus: open
    }, other, {
        ref: ref,
        children: children
    }));
});
$05b53142b9ab08e6$var$GridColumnMenuContainer.displayName = "GridColumnMenuContainer";
$05b53142b9ab08e6$var$GridColumnMenuContainer.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    colDef: $05b53142b9ab08e6$var$_propTypes.default.object.isRequired,
    hideMenu: $05b53142b9ab08e6$var$_propTypes.default.func.isRequired,
    id: $05b53142b9ab08e6$var$_propTypes.default.string,
    labelledby: $05b53142b9ab08e6$var$_propTypes.default.string,
    open: $05b53142b9ab08e6$var$_propTypes.default.bool.isRequired
};


Object.keys($05b53142b9ab08e6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($5567793dda12fa70$var$_exportNames, key)) return;
    if (key in $5567793dda12fa70$exports && $5567793dda12fa70$exports[key] === $05b53142b9ab08e6$exports[key]) return;
    Object.defineProperty($5567793dda12fa70$exports, key, {
        enumerable: true,
        get: function() {
            return $05b53142b9ab08e6$exports[key];
        }
    });
});
var $3bffa0a776b5a050$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3bffa0a776b5a050$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($3bffa0a776b5a050$exports, "__esModule", {
    value: true
});
$3bffa0a776b5a050$exports.GridGenericColumnMenu = $3bffa0a776b5a050$exports.GridColumnMenu = $3bffa0a776b5a050$exports.GRID_COLUMN_MENU_SLOT_PROPS = $3bffa0a776b5a050$exports.GRID_COLUMN_MENU_SLOTS = void 0;

var $3bffa0a776b5a050$var$_extends2 = $3bffa0a776b5a050$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $3bffa0a776b5a050$var$_objectWithoutPropertiesLoose2 = $3bffa0a776b5a050$require$_interopRequireDefault((parcelRequire("c05no")));

var $3bffa0a776b5a050$var$_propTypes = $3bffa0a776b5a050$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $fYxgT = parcelRequire("fYxgT");
var $e2bcf6b15e7fbab3$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e2bcf6b15e7fbab3$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $e2bcf6b15e7fbab3$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($e2bcf6b15e7fbab3$exports, "__esModule", {
    value: true
});
$e2bcf6b15e7fbab3$exports.useGridColumnMenuSlots = void 0;

var $e2bcf6b15e7fbab3$var$_objectWithoutPropertiesLoose2 = $e2bcf6b15e7fbab3$require$_interopRequireDefault((parcelRequire("c05no")));

var $e2bcf6b15e7fbab3$var$_extends2 = $e2bcf6b15e7fbab3$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $e2bcf6b15e7fbab3$var$React = $e2bcf6b15e7fbab3$require$_interopRequireWildcard((parcelRequire("acw62")));

var $jDpXp = parcelRequire("jDpXp");

var $er55f = parcelRequire("er55f");
const $e2bcf6b15e7fbab3$var$_excluded = [
    "displayOrder"
];
const $e2bcf6b15e7fbab3$var$useGridColumnMenuSlots = (props)=>{
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const { defaultSlots: defaultSlots, defaultSlotProps: defaultSlotProps, slots: slots = {}, slotProps: slotProps = {}, hideMenu: hideMenu, colDef: colDef, addDividers: addDividers = true } = props;
    const processedComponents = $e2bcf6b15e7fbab3$var$React.useMemo(()=>(0, $e2bcf6b15e7fbab3$var$_extends2.default)({}, defaultSlots, slots), [
        defaultSlots,
        slots
    ]);
    const processedSlotProps = $e2bcf6b15e7fbab3$var$React.useMemo(()=>{
        if (!slotProps || Object.keys(slotProps).length === 0) return defaultSlotProps;
        const mergedProps = (0, $e2bcf6b15e7fbab3$var$_extends2.default)({}, slotProps);
        Object.entries(defaultSlotProps).forEach(([key, currentSlotProps])=>{
            mergedProps[key] = (0, $e2bcf6b15e7fbab3$var$_extends2.default)({}, currentSlotProps, slotProps[key] || {});
        });
        return mergedProps;
    }, [
        defaultSlotProps,
        slotProps
    ]);
    const defaultItems = apiRef.current.unstable_applyPipeProcessors('columnMenu', [], props.colDef);
    const userItems = $e2bcf6b15e7fbab3$var$React.useMemo(()=>{
        const defaultComponentKeys = Object.keys(defaultSlots);
        return Object.keys(slots).filter((key)=>!defaultComponentKeys.includes(key));
    }, [
        slots,
        defaultSlots
    ]);
    return $e2bcf6b15e7fbab3$var$React.useMemo(()=>{
        const uniqueItems = Array.from(new Set([
            ...defaultItems,
            ...userItems
        ]));
        const cleansedItems = uniqueItems.filter((key)=>processedComponents[key] != null);
        const sorted = cleansedItems.sort((a, b)=>{
            const leftItemProps = processedSlotProps[a];
            const rightItemProps = processedSlotProps[b];
            const leftDisplayOrder = Number.isFinite(leftItemProps?.displayOrder) ? leftItemProps.displayOrder : 100;
            const rightDisplayOrder = Number.isFinite(rightItemProps?.displayOrder) ? rightItemProps.displayOrder : 100;
            return leftDisplayOrder - rightDisplayOrder;
        });
        return sorted.reduce((acc, key, index)=>{
            let itemProps = {
                colDef: colDef,
                onClick: hideMenu
            };
            const processedComponentProps = processedSlotProps[key];
            if (processedComponentProps) {
                const customProps = (0, $e2bcf6b15e7fbab3$var$_objectWithoutPropertiesLoose2.default)(processedComponentProps, $e2bcf6b15e7fbab3$var$_excluded);
                itemProps = (0, $e2bcf6b15e7fbab3$var$_extends2.default)({}, itemProps, customProps);
            }
            return addDividers && index !== sorted.length - 1 ? [
                ...acc,
                [
                    processedComponents[key],
                    itemProps
                ],
                [
                    rootProps.slots.baseDivider,
                    {}
                ]
            ] : [
                ...acc,
                [
                    processedComponents[key],
                    itemProps
                ]
            ];
        }, []);
    }, [
        addDividers,
        colDef,
        defaultItems,
        hideMenu,
        processedComponents,
        processedSlotProps,
        userItems,
        rootProps.slots.baseDivider
    ]);
};
$e2bcf6b15e7fbab3$exports.useGridColumnMenuSlots = $e2bcf6b15e7fbab3$var$useGridColumnMenuSlots;



var $480efc1ffdb54f08$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $480efc1ffdb54f08$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $480efc1ffdb54f08$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($480efc1ffdb54f08$exports, "__esModule", {
    value: true
});
$480efc1ffdb54f08$exports.GridColumnMenuColumnsItem = $480efc1ffdb54f08$var$GridColumnMenuColumnsItem;

var $480efc1ffdb54f08$var$_extends2 = $480efc1ffdb54f08$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $480efc1ffdb54f08$var$React = $480efc1ffdb54f08$require$_interopRequireWildcard((parcelRequire("acw62")));

var $480efc1ffdb54f08$var$_propTypes = $480efc1ffdb54f08$require$_interopRequireDefault((parcelRequire("c9Z8w")));
var $6e815fc52eaddbf2$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $6e815fc52eaddbf2$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $6e815fc52eaddbf2$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($6e815fc52eaddbf2$exports, "__esModule", {
    value: true
});
$6e815fc52eaddbf2$exports.GridColumnMenuHideItem = $6e815fc52eaddbf2$var$GridColumnMenuHideItem;

var $6e815fc52eaddbf2$var$React = $6e815fc52eaddbf2$require$_interopRequireWildcard((parcelRequire("acw62")));

var $6e815fc52eaddbf2$var$_propTypes = $6e815fc52eaddbf2$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");


var $ayMG0 = parcelRequire("ayMG0");
function $6e815fc52eaddbf2$var$GridColumnMenuHideItem(props) {
    const { colDef: colDef, onClick: onClick } = props;
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const visibleColumns = (0, $e3b5f2e67362f55f$exports.gridVisibleColumnDefinitionsSelector)(apiRef);
    const columnsWithMenu = visibleColumns.filter((col)=>col.disableColumnMenu !== true);
    // do not allow to hide the last column with menu
    const disabled = columnsWithMenu.length === 1;
    const toggleColumn = $6e815fc52eaddbf2$var$React.useCallback((event)=>{
        /**
     * Disabled `MenuItem` would trigger `click` event
     * after imperative `.click()` call on HTML element.
     * Also, click is triggered in testing environment as well.
     */ if (disabled) return;
        apiRef.current.setColumnVisibility(colDef.field, false);
        onClick(event);
    }, [
        apiRef,
        colDef.field,
        onClick,
        disabled
    ]);
    if (rootProps.disableColumnSelector) return null;
    if (colDef.hideable === false) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseMenuItem, {
        onClick: toggleColumn,
        disabled: disabled,
        iconStart: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnMenuHideIcon, {
            fontSize: "small"
        }),
        children: apiRef.current.getLocaleText('columnMenuHideColumn')
    });
}
$6e815fc52eaddbf2$var$GridColumnMenuHideItem.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    colDef: $6e815fc52eaddbf2$var$_propTypes.default.object.isRequired,
    onClick: $6e815fc52eaddbf2$var$_propTypes.default.func.isRequired
};


var $f0f5050f3d38da77$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f0f5050f3d38da77$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $f0f5050f3d38da77$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($f0f5050f3d38da77$exports, "__esModule", {
    value: true
});
$f0f5050f3d38da77$exports.GridColumnMenuManageItem = $f0f5050f3d38da77$var$GridColumnMenuManageItem;

var $f0f5050f3d38da77$var$React = $f0f5050f3d38da77$require$_interopRequireWildcard((parcelRequire("acw62")));

var $f0f5050f3d38da77$var$_propTypes = $f0f5050f3d38da77$require$_interopRequireDefault((parcelRequire("c9Z8w")));


var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
function $f0f5050f3d38da77$var$GridColumnMenuManageItem(props) {
    const { onClick: onClick } = props;
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const showColumns = $f0f5050f3d38da77$var$React.useCallback((event)=>{
        onClick(event); // hide column menu
        apiRef.current.showPreferences($2ca45f4bbfed6878$exports.GridPreferencePanelsValue.columns);
    }, [
        apiRef,
        onClick
    ]);
    if (rootProps.disableColumnSelector) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseMenuItem, {
        onClick: showColumns,
        iconStart: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnMenuManageColumnsIcon, {
            fontSize: "small"
        }),
        children: apiRef.current.getLocaleText('columnMenuManageColumns')
    });
}
$f0f5050f3d38da77$var$GridColumnMenuManageItem.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    colDef: $f0f5050f3d38da77$var$_propTypes.default.object.isRequired,
    onClick: $f0f5050f3d38da77$var$_propTypes.default.func.isRequired
};



var $ayMG0 = parcelRequire("ayMG0");
function $480efc1ffdb54f08$var$GridColumnMenuColumnsItem(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($480efc1ffdb54f08$var$React.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($6e815fc52eaddbf2$exports.GridColumnMenuHideItem, (0, $480efc1ffdb54f08$var$_extends2.default)({}, props)),
            /*#__PURE__*/ (0, $ayMG0.jsx)($f0f5050f3d38da77$exports.GridColumnMenuManageItem, (0, $480efc1ffdb54f08$var$_extends2.default)({}, props))
        ]
    });
}
$480efc1ffdb54f08$var$GridColumnMenuColumnsItem.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    colDef: $480efc1ffdb54f08$var$_propTypes.default.object.isRequired,
    onClick: $480efc1ffdb54f08$var$_propTypes.default.func.isRequired
};


var $97317925c823a2fa$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $97317925c823a2fa$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $97317925c823a2fa$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($97317925c823a2fa$exports, "__esModule", {
    value: true
});
$97317925c823a2fa$exports.GridColumnMenuFilterItem = $97317925c823a2fa$var$GridColumnMenuFilterItem;

var $97317925c823a2fa$var$React = $97317925c823a2fa$require$_interopRequireWildcard((parcelRequire("acw62")));

var $97317925c823a2fa$var$_propTypes = $97317925c823a2fa$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
function $97317925c823a2fa$var$GridColumnMenuFilterItem(props) {
    const { colDef: colDef, onClick: onClick } = props;
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const showFilter = $97317925c823a2fa$var$React.useCallback((event)=>{
        onClick(event);
        apiRef.current.showFilterPanel(colDef.field);
    }, [
        apiRef,
        colDef.field,
        onClick
    ]);
    if (rootProps.disableColumnFilter || !colDef.filterable) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseMenuItem, {
        onClick: showFilter,
        iconStart: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnMenuFilterIcon, {
            fontSize: "small"
        }),
        children: apiRef.current.getLocaleText('columnMenuFilter')
    });
}
$97317925c823a2fa$var$GridColumnMenuFilterItem.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    colDef: $97317925c823a2fa$var$_propTypes.default.object.isRequired,
    onClick: $97317925c823a2fa$var$_propTypes.default.func.isRequired
};


var $948a47da9ef72c3c$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $948a47da9ef72c3c$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $948a47da9ef72c3c$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($948a47da9ef72c3c$exports, "__esModule", {
    value: true
});
$948a47da9ef72c3c$exports.GridColumnMenuSortItem = $948a47da9ef72c3c$var$GridColumnMenuSortItem;

var $948a47da9ef72c3c$var$React = $948a47da9ef72c3c$require$_interopRequireWildcard((parcelRequire("acw62")));

var $948a47da9ef72c3c$var$_propTypes = $948a47da9ef72c3c$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $5sOMZ = parcelRequire("5sOMZ");


var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
function $948a47da9ef72c3c$var$GridColumnMenuSortItem(props) {
    const { colDef: colDef, onClick: onClick } = props;
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const sortModel = (0, $5sOMZ.useGridSelector)(apiRef, $dc3028b3b629fae7$exports.gridSortModelSelector);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const sortDirection = $948a47da9ef72c3c$var$React.useMemo(()=>{
        if (!colDef) return null;
        const sortItem = sortModel.find((item)=>item.field === colDef.field);
        return sortItem?.sort;
    }, [
        colDef,
        sortModel
    ]);
    const sortingOrder = colDef.sortingOrder ?? rootProps.sortingOrder;
    const onSortMenuItemClick = $948a47da9ef72c3c$var$React.useCallback((event)=>{
        onClick(event);
        const direction = event.currentTarget.getAttribute('data-value') || null;
        const allowMultipleSorting = rootProps.multipleColumnsSortingMode === 'always';
        apiRef.current.sortColumn(colDef.field, direction === sortDirection ? null : direction, allowMultipleSorting);
    }, [
        apiRef,
        colDef,
        onClick,
        sortDirection,
        rootProps.multipleColumnsSortingMode
    ]);
    if (rootProps.disableColumnSorting || !colDef || !colDef.sortable || !sortingOrder.some((item)=>!!item)) return null;
    const getLabel = (key)=>{
        const label = apiRef.current.getLocaleText(key);
        return typeof label === 'function' ? label(colDef) : label;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($948a47da9ef72c3c$var$React.Fragment, {
        children: [
            sortingOrder.includes('asc') && sortDirection !== 'asc' ? /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseMenuItem, {
                onClick: onSortMenuItemClick,
                "data-value": "asc",
                iconStart: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnMenuSortAscendingIcon, {
                    fontSize: "small"
                }),
                children: getLabel('columnMenuSortAsc')
            }) : null,
            sortingOrder.includes('desc') && sortDirection !== 'desc' ? /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseMenuItem, {
                onClick: onSortMenuItemClick,
                "data-value": "desc",
                iconStart: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnMenuSortDescendingIcon, {
                    fontSize: "small"
                }),
                children: getLabel('columnMenuSortDesc')
            }) : null,
            sortingOrder.includes(null) && sortDirection != null ? /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseMenuItem, {
                onClick: onSortMenuItemClick,
                iconStart: rootProps.slots.columnMenuUnsortIcon ? /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnMenuUnsortIcon, {
                    fontSize: "small"
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                children: apiRef.current.getLocaleText('columnMenuUnsort')
            }) : null
        ]
    });
}
$948a47da9ef72c3c$var$GridColumnMenuSortItem.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    colDef: $948a47da9ef72c3c$var$_propTypes.default.object.isRequired,
    onClick: $948a47da9ef72c3c$var$_propTypes.default.func.isRequired
};



var $ayMG0 = parcelRequire("ayMG0");
const $3bffa0a776b5a050$var$_excluded = [
    "defaultSlots",
    "defaultSlotProps",
    "slots",
    "slotProps"
];
const $3bffa0a776b5a050$var$GRID_COLUMN_MENU_SLOTS = $3bffa0a776b5a050$exports.GRID_COLUMN_MENU_SLOTS = {
    columnMenuSortItem: $948a47da9ef72c3c$exports.GridColumnMenuSortItem,
    columnMenuFilterItem: $97317925c823a2fa$exports.GridColumnMenuFilterItem,
    columnMenuColumnsItem: $480efc1ffdb54f08$exports.GridColumnMenuColumnsItem
};
const $3bffa0a776b5a050$var$GRID_COLUMN_MENU_SLOT_PROPS = $3bffa0a776b5a050$exports.GRID_COLUMN_MENU_SLOT_PROPS = {
    columnMenuSortItem: {
        displayOrder: 10
    },
    columnMenuFilterItem: {
        displayOrder: 20
    },
    columnMenuColumnsItem: {
        displayOrder: 30
    }
};
const $3bffa0a776b5a050$var$GridGenericColumnMenu = $3bffa0a776b5a050$exports.GridGenericColumnMenu = (0, $fYxgT.forwardRef)(function GridGenericColumnMenu(props, ref) {
    const { defaultSlots: defaultSlots, defaultSlotProps: defaultSlotProps, slots: slots, slotProps: slotProps } = props, other = (0, $3bffa0a776b5a050$var$_objectWithoutPropertiesLoose2.default)(props, $3bffa0a776b5a050$var$_excluded);
    const orderedSlots = (0, $e2bcf6b15e7fbab3$exports.useGridColumnMenuSlots)((0, $3bffa0a776b5a050$var$_extends2.default)({}, other, {
        defaultSlots: defaultSlots,
        defaultSlotProps: defaultSlotProps,
        slots: slots,
        slotProps: slotProps
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($05b53142b9ab08e6$exports.GridColumnMenuContainer, (0, $3bffa0a776b5a050$var$_extends2.default)({}, other, {
        ref: ref,
        children: orderedSlots.map(([Component, otherProps], index)=>/*#__PURE__*/ (0, $ayMG0.jsx)(Component, (0, $3bffa0a776b5a050$var$_extends2.default)({}, otherProps), index))
    }));
});
$3bffa0a776b5a050$var$GridGenericColumnMenu.displayName = "GridGenericColumnMenu";
$3bffa0a776b5a050$var$GridGenericColumnMenu.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    colDef: $3bffa0a776b5a050$var$_propTypes.default.object.isRequired,
    /**
   * Initial `slotProps` - it is internal, to be overrriden by Pro or Premium packages
   * @ignore - do not document.
   */ defaultSlotProps: $3bffa0a776b5a050$var$_propTypes.default.object.isRequired,
    /**
   * Initial `slots` - it is internal, to be overrriden by Pro or Premium packages
   * @ignore - do not document.
   */ defaultSlots: $3bffa0a776b5a050$var$_propTypes.default.object.isRequired,
    hideMenu: $3bffa0a776b5a050$var$_propTypes.default.func.isRequired,
    id: $3bffa0a776b5a050$var$_propTypes.default.string,
    labelledby: $3bffa0a776b5a050$var$_propTypes.default.string,
    open: $3bffa0a776b5a050$var$_propTypes.default.bool.isRequired,
    /**
   * Could be used to pass new props or override props specific to a column menu component
   * e.g. `displayOrder`
   */ slotProps: $3bffa0a776b5a050$var$_propTypes.default.object,
    /**
   * `slots` could be used to add new and (or) override default column menu items
   * If you register a nee component you must pass it's `displayOrder` in `slotProps`
   * or it will be placed in the end of the list
   */ slots: $3bffa0a776b5a050$var$_propTypes.default.object
};
const $3bffa0a776b5a050$var$GridColumnMenu = $3bffa0a776b5a050$exports.GridColumnMenu = (0, $fYxgT.forwardRef)(function GridColumnMenu(props, ref) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3bffa0a776b5a050$var$GridGenericColumnMenu, (0, $3bffa0a776b5a050$var$_extends2.default)({}, props, {
        ref: ref,
        defaultSlots: $3bffa0a776b5a050$var$GRID_COLUMN_MENU_SLOTS,
        defaultSlotProps: $3bffa0a776b5a050$var$GRID_COLUMN_MENU_SLOT_PROPS
    }));
});
$3bffa0a776b5a050$var$GridColumnMenu.displayName = "GridColumnMenu";
$3bffa0a776b5a050$var$GridColumnMenu.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    colDef: $3bffa0a776b5a050$var$_propTypes.default.object.isRequired,
    hideMenu: $3bffa0a776b5a050$var$_propTypes.default.func.isRequired,
    id: $3bffa0a776b5a050$var$_propTypes.default.string,
    labelledby: $3bffa0a776b5a050$var$_propTypes.default.string,
    open: $3bffa0a776b5a050$var$_propTypes.default.bool.isRequired,
    /**
   * Could be used to pass new props or override props specific to a column menu component
   * e.g. `displayOrder`
   */ slotProps: $3bffa0a776b5a050$var$_propTypes.default.object,
    /**
   * `slots` could be used to add new and (or) override default column menu items
   * If you register a nee component you must pass it's `displayOrder` in `slotProps`
   * or it will be placed in the end of the list
   */ slots: $3bffa0a776b5a050$var$_propTypes.default.object
};


var $b6562f2ae3807e9b$exports = {};
"use strict";
Object.defineProperty($b6562f2ae3807e9b$exports, "__esModule", {
    value: true
});

Object.keys($480efc1ffdb54f08$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $b6562f2ae3807e9b$exports && $b6562f2ae3807e9b$exports[key] === $480efc1ffdb54f08$exports[key]) return;
    Object.defineProperty($b6562f2ae3807e9b$exports, key, {
        enumerable: true,
        get: function() {
            return $480efc1ffdb54f08$exports[key];
        }
    });
});

Object.keys($f0f5050f3d38da77$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $b6562f2ae3807e9b$exports && $b6562f2ae3807e9b$exports[key] === $f0f5050f3d38da77$exports[key]) return;
    Object.defineProperty($b6562f2ae3807e9b$exports, key, {
        enumerable: true,
        get: function() {
            return $f0f5050f3d38da77$exports[key];
        }
    });
});

Object.keys($97317925c823a2fa$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $b6562f2ae3807e9b$exports && $b6562f2ae3807e9b$exports[key] === $97317925c823a2fa$exports[key]) return;
    Object.defineProperty($b6562f2ae3807e9b$exports, key, {
        enumerable: true,
        get: function() {
            return $97317925c823a2fa$exports[key];
        }
    });
});

Object.keys($6e815fc52eaddbf2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $b6562f2ae3807e9b$exports && $b6562f2ae3807e9b$exports[key] === $6e815fc52eaddbf2$exports[key]) return;
    Object.defineProperty($b6562f2ae3807e9b$exports, key, {
        enumerable: true,
        get: function() {
            return $6e815fc52eaddbf2$exports[key];
        }
    });
});

Object.keys($948a47da9ef72c3c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $b6562f2ae3807e9b$exports && $b6562f2ae3807e9b$exports[key] === $948a47da9ef72c3c$exports[key]) return;
    Object.defineProperty($b6562f2ae3807e9b$exports, key, {
        enumerable: true,
        get: function() {
            return $948a47da9ef72c3c$exports[key];
        }
    });
});


Object.keys($b6562f2ae3807e9b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($5567793dda12fa70$var$_exportNames, key)) return;
    if (key in $5567793dda12fa70$exports && $5567793dda12fa70$exports[key] === $b6562f2ae3807e9b$exports[key]) return;
    Object.defineProperty($5567793dda12fa70$exports, key, {
        enumerable: true,
        get: function() {
            return $b6562f2ae3807e9b$exports[key];
        }
    });
});


Object.keys($5567793dda12fa70$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $b0a931fb4e0448ba$exports && $b0a931fb4e0448ba$exports[key] === $5567793dda12fa70$exports[key]) return;
    Object.defineProperty($b0a931fb4e0448ba$exports, key, {
        enumerable: true,
        get: function() {
            return $5567793dda12fa70$exports[key];
        }
    });
});

Object.keys($8efc7911d5661cb8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $b0a931fb4e0448ba$exports && $b0a931fb4e0448ba$exports[key] === $8efc7911d5661cb8$exports[key]) return;
    Object.defineProperty($b0a931fb4e0448ba$exports, key, {
        enumerable: true,
        get: function() {
            return $8efc7911d5661cb8$exports[key];
        }
    });
});


Object.keys($b0a931fb4e0448ba$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in $08eee520e810d520$exports && $08eee520e810d520$exports[key] === $b0a931fb4e0448ba$exports[key]) return;
    Object.defineProperty($08eee520e810d520$exports, key, {
        enumerable: true,
        get: function() {
            return $b0a931fb4e0448ba$exports[key];
        }
    });
});
var $80a51ab5faf3eb45$exports = {};
"use strict";
Object.defineProperty($80a51ab5faf3eb45$exports, "__esModule", {
    value: true
});
var $f650cd2c2e66a414$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f650cd2c2e66a414$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($f650cd2c2e66a414$exports, "__esModule", {
    value: true
});
$f650cd2c2e66a414$exports.GridColumnsPanel = $f650cd2c2e66a414$var$GridColumnsPanel;

var $f650cd2c2e66a414$var$_extends2 = $f650cd2c2e66a414$require$_interopRequireDefault((parcelRequire("3p9rK")));
var $a133c015d593f0ef$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a133c015d593f0ef$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $a133c015d593f0ef$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($a133c015d593f0ef$exports, "__esModule", {
    value: true
});
$a133c015d593f0ef$exports.GridPanelWrapper = void 0;

var $a133c015d593f0ef$var$_extends2 = $a133c015d593f0ef$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $a133c015d593f0ef$var$_objectWithoutPropertiesLoose2 = $a133c015d593f0ef$require$_interopRequireDefault((parcelRequire("c05no")));

var $a133c015d593f0ef$var$React = $a133c015d593f0ef$require$_interopRequireWildcard((parcelRequire("acw62")));

var $a133c015d593f0ef$var$_clsx = $a133c015d593f0ef$require$_interopRequireDefault((parcelRequire("9QePP")));

var $8xDHs = parcelRequire("8xDHs");

var $a133c015d593f0ef$var$_composeClasses = $a133c015d593f0ef$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $fYxgT = parcelRequire("fYxgT");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $a133c015d593f0ef$var$_excluded = [
    "className"
];
const $a133c015d593f0ef$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'panelWrapper'
        ]
    };
    return (0, $a133c015d593f0ef$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $a133c015d593f0ef$var$GridPanelWrapperRoot = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'PanelWrapper'
})({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    '&:focus': {
        outline: 0
    }
});
const $a133c015d593f0ef$var$GridPanelWrapper = $a133c015d593f0ef$exports.GridPanelWrapper = (0, $fYxgT.forwardRef)(function GridPanelWrapper(props, ref) {
    const { className: className } = props, other = (0, $a133c015d593f0ef$var$_objectWithoutPropertiesLoose2.default)(props, $a133c015d593f0ef$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $a133c015d593f0ef$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a133c015d593f0ef$var$GridPanelWrapperRoot, (0, $a133c015d593f0ef$var$_extends2.default)({
        tabIndex: -1,
        className: (0, $a133c015d593f0ef$var$_clsx.default)(classes.root, className),
        ownerState: rootProps
    }, other, {
        ref: ref
    }));
});
$a133c015d593f0ef$var$GridPanelWrapper.displayName = "GridPanelWrapper";



var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
function $f650cd2c2e66a414$var$GridColumnsPanel(props) {
    const rootProps = (0, $jDpXp.useGridRootProps)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a133c015d593f0ef$exports.GridPanelWrapper, (0, $f650cd2c2e66a414$var$_extends2.default)({}, props, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnsManagement, (0, $f650cd2c2e66a414$var$_extends2.default)({}, rootProps.slotProps?.columnsManagement))
    }));
}


Object.keys($f650cd2c2e66a414$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $80a51ab5faf3eb45$exports && $80a51ab5faf3eb45$exports[key] === $f650cd2c2e66a414$exports[key]) return;
    Object.defineProperty($80a51ab5faf3eb45$exports, key, {
        enumerable: true,
        get: function() {
            return $f650cd2c2e66a414$exports[key];
        }
    });
});
var $ebcd112530bc7823$exports = {};
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $ebcd112530bc7823$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $ebcd112530bc7823$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($ebcd112530bc7823$exports, "__esModule", {
    value: true
});
$ebcd112530bc7823$exports.gridPanelClasses = $ebcd112530bc7823$exports.GridPanel = void 0;

var $ebcd112530bc7823$var$_extends2 = $ebcd112530bc7823$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $ebcd112530bc7823$var$_objectWithoutPropertiesLoose2 = $ebcd112530bc7823$require$_interopRequireDefault((parcelRequire("c05no")));

var $ebcd112530bc7823$var$React = $ebcd112530bc7823$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ebcd112530bc7823$var$_propTypes = $ebcd112530bc7823$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $ebcd112530bc7823$var$_clsx = $ebcd112530bc7823$require$_interopRequireDefault((parcelRequire("9QePP")));

var $8xDHs = parcelRequire("8xDHs");

var $ebcd112530bc7823$var$_generateUtilityClasses = $ebcd112530bc7823$require$_interopRequireDefault((parcelRequire("5nY49")));

var $ebcd112530bc7823$var$_useEventCallback = $ebcd112530bc7823$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $fYxgT = parcelRequire("fYxgT");

var $hbuUJ = parcelRequire("hbuUJ");


var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");


var $ayMG0 = parcelRequire("ayMG0");
const $ebcd112530bc7823$var$_excluded = [
    "children",
    "className",
    "classes",
    "onClose"
];
const $ebcd112530bc7823$var$gridPanelClasses = $ebcd112530bc7823$exports.gridPanelClasses = (0, $ebcd112530bc7823$var$_generateUtilityClasses.default)('MuiDataGrid', [
    'panel',
    'paper'
]);
const $ebcd112530bc7823$var$GridPanelRoot = (0, $8xDHs.styled)($dd66ac2a2c256d30$exports.NotRendered, {
    name: 'MuiDataGrid',
    slot: 'panel'
})({
    zIndex: $hbuUJ.vars.zIndex.panel
});
const $ebcd112530bc7823$var$GridPanelContent = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'panelContent'
})({
    backgroundColor: $hbuUJ.vars.colors.background.overlay,
    borderRadius: $hbuUJ.vars.radius.base,
    boxShadow: $hbuUJ.vars.shadows.overlay,
    display: 'flex',
    maxWidth: `calc(100vw - ${$hbuUJ.vars.spacing(2)})`,
    overflow: 'auto'
});
const $ebcd112530bc7823$var$GridPanel = $ebcd112530bc7823$exports.GridPanel = (0, $fYxgT.forwardRef)((props, ref)=>{
    const { children: children, className: className, onClose: onClose } = props, other = (0, $ebcd112530bc7823$var$_objectWithoutPropertiesLoose2.default)(props, $ebcd112530bc7823$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $ebcd112530bc7823$var$gridPanelClasses;
    const [isPlaced, setIsPlaced] = $ebcd112530bc7823$var$React.useState(false);
    const variablesClass = (0, $2a727ae4835cc807$exports.useCSSVariablesClass)();
    const onDidShow = (0, $ebcd112530bc7823$var$_useEventCallback.default)(()=>setIsPlaced(true));
    const onDidHide = (0, $ebcd112530bc7823$var$_useEventCallback.default)(()=>setIsPlaced(false));
    const handleClickAway = (0, $ebcd112530bc7823$var$_useEventCallback.default)(()=>{
        onClose?.();
    });
    const handleKeyDown = (0, $ebcd112530bc7823$var$_useEventCallback.default)((event)=>{
        if (event.key === 'Escape') onClose?.();
    });
    const [fallbackTarget, setFallbackTarget] = $ebcd112530bc7823$var$React.useState(null);
    $ebcd112530bc7823$var$React.useEffect(()=>{
        const panelAnchor = apiRef.current.rootElementRef?.current?.querySelector('[data-id="gridPanelAnchor"]');
        if (panelAnchor) setFallbackTarget(panelAnchor);
    }, [
        apiRef
    ]);
    if (!fallbackTarget) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ebcd112530bc7823$var$GridPanelRoot, (0, $ebcd112530bc7823$var$_extends2.default)({
        as: rootProps.slots.basePopper,
        ownerState: rootProps,
        placement: "bottom-end",
        className: (0, $ebcd112530bc7823$var$_clsx.default)(classes.panel, className, variablesClass),
        flip: true,
        onDidShow: onDidShow,
        onDidHide: onDidHide,
        onClickAway: handleClickAway,
        clickAwayMouseEvent: "onPointerUp",
        clickAwayTouchEvent: false,
        focusTrap: true
    }, other, rootProps.slotProps?.basePopper, {
        target: props.target ?? fallbackTarget,
        ref: ref,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($ebcd112530bc7823$var$GridPanelContent, {
            className: classes.paper,
            ownerState: rootProps,
            onKeyDown: handleKeyDown,
            children: isPlaced && children
        })
    }));
});
$ebcd112530bc7823$var$GridPanel.displayName = "GridPanel";
$ebcd112530bc7823$var$GridPanel.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    children: $ebcd112530bc7823$var$_propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $ebcd112530bc7823$var$_propTypes.default.object,
    className: $ebcd112530bc7823$var$_propTypes.default.string,
    flip: $ebcd112530bc7823$var$_propTypes.default.bool,
    id: $ebcd112530bc7823$var$_propTypes.default.string,
    onClose: $ebcd112530bc7823$var$_propTypes.default.func,
    open: $ebcd112530bc7823$var$_propTypes.default.bool.isRequired,
    target: $ebcd112530bc7823$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .any
};


Object.keys($ebcd112530bc7823$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $80a51ab5faf3eb45$exports && $80a51ab5faf3eb45$exports[key] === $ebcd112530bc7823$exports[key]) return;
    Object.defineProperty($80a51ab5faf3eb45$exports, key, {
        enumerable: true,
        get: function() {
            return $ebcd112530bc7823$exports[key];
        }
    });
});
var $c83c3bce08f2b302$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c83c3bce08f2b302$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $c83c3bce08f2b302$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($c83c3bce08f2b302$exports, "__esModule", {
    value: true
});
$c83c3bce08f2b302$exports.GridPanelContent = $c83c3bce08f2b302$var$GridPanelContent;

var $c83c3bce08f2b302$var$_extends2 = $c83c3bce08f2b302$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $c83c3bce08f2b302$var$_objectWithoutPropertiesLoose2 = $c83c3bce08f2b302$require$_interopRequireDefault((parcelRequire("c05no")));

var $c83c3bce08f2b302$var$React = $c83c3bce08f2b302$require$_interopRequireWildcard((parcelRequire("acw62")));

var $c83c3bce08f2b302$var$_propTypes = $c83c3bce08f2b302$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $c83c3bce08f2b302$var$_clsx = $c83c3bce08f2b302$require$_interopRequireDefault((parcelRequire("9QePP")));

var $izOUK = parcelRequire("izOUK");

var $c83c3bce08f2b302$var$_composeClasses = $c83c3bce08f2b302$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $hbuUJ = parcelRequire("hbuUJ");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $c83c3bce08f2b302$var$_excluded = [
    "className"
];
const $c83c3bce08f2b302$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'panelContent'
        ]
    };
    return (0, $c83c3bce08f2b302$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $c83c3bce08f2b302$var$GridPanelContentRoot = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'PanelContent'
})({
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    flex: '1 1',
    maxHeight: 400,
    padding: $hbuUJ.vars.spacing(2.5, 1.5, 2, 1),
    gap: $hbuUJ.vars.spacing(2.5)
});
function $c83c3bce08f2b302$var$GridPanelContent(props) {
    const { className: className } = props, other = (0, $c83c3bce08f2b302$var$_objectWithoutPropertiesLoose2.default)(props, $c83c3bce08f2b302$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $c83c3bce08f2b302$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($c83c3bce08f2b302$var$GridPanelContentRoot, (0, $c83c3bce08f2b302$var$_extends2.default)({
        className: (0, $c83c3bce08f2b302$var$_clsx.default)(classes.root, className),
        ownerState: rootProps
    }, other));
}
$c83c3bce08f2b302$var$GridPanelContent.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    sx: $c83c3bce08f2b302$var$_propTypes.default.oneOfType([
        $c83c3bce08f2b302$var$_propTypes.default.arrayOf($c83c3bce08f2b302$var$_propTypes.default.oneOfType([
            $c83c3bce08f2b302$var$_propTypes.default.func,
            $c83c3bce08f2b302$var$_propTypes.default.object,
            $c83c3bce08f2b302$var$_propTypes.default.bool
        ])),
        $c83c3bce08f2b302$var$_propTypes.default.func,
        $c83c3bce08f2b302$var$_propTypes.default.object
    ])
};


Object.keys($c83c3bce08f2b302$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $80a51ab5faf3eb45$exports && $80a51ab5faf3eb45$exports[key] === $c83c3bce08f2b302$exports[key]) return;
    Object.defineProperty($80a51ab5faf3eb45$exports, key, {
        enumerable: true,
        get: function() {
            return $c83c3bce08f2b302$exports[key];
        }
    });
});
var $d65d401151f46b4c$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d65d401151f46b4c$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $d65d401151f46b4c$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($d65d401151f46b4c$exports, "__esModule", {
    value: true
});
$d65d401151f46b4c$exports.GridPanelFooter = $d65d401151f46b4c$var$GridPanelFooter;

var $d65d401151f46b4c$var$_extends2 = $d65d401151f46b4c$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $d65d401151f46b4c$var$_objectWithoutPropertiesLoose2 = $d65d401151f46b4c$require$_interopRequireDefault((parcelRequire("c05no")));

var $d65d401151f46b4c$var$React = $d65d401151f46b4c$require$_interopRequireWildcard((parcelRequire("acw62")));

var $d65d401151f46b4c$var$_propTypes = $d65d401151f46b4c$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $d65d401151f46b4c$var$_clsx = $d65d401151f46b4c$require$_interopRequireDefault((parcelRequire("9QePP")));

var $8xDHs = parcelRequire("8xDHs");

var $d65d401151f46b4c$var$_composeClasses = $d65d401151f46b4c$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $hbuUJ = parcelRequire("hbuUJ");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $d65d401151f46b4c$var$_excluded = [
    "className"
];
const $d65d401151f46b4c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'panelFooter'
        ]
    };
    return (0, $d65d401151f46b4c$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $d65d401151f46b4c$var$GridPanelFooterRoot = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'PanelFooter'
})({
    padding: $hbuUJ.vars.spacing(1),
    display: 'flex',
    justifyContent: 'space-between',
    borderTop: `1px solid ${$hbuUJ.vars.colors.border.base}`
});
function $d65d401151f46b4c$var$GridPanelFooter(props) {
    const { className: className } = props, other = (0, $d65d401151f46b4c$var$_objectWithoutPropertiesLoose2.default)(props, $d65d401151f46b4c$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $d65d401151f46b4c$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($d65d401151f46b4c$var$GridPanelFooterRoot, (0, $d65d401151f46b4c$var$_extends2.default)({
        className: (0, $d65d401151f46b4c$var$_clsx.default)(classes.root, className),
        ownerState: rootProps
    }, other));
}
$d65d401151f46b4c$var$GridPanelFooter.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    sx: $d65d401151f46b4c$var$_propTypes.default.oneOfType([
        $d65d401151f46b4c$var$_propTypes.default.arrayOf($d65d401151f46b4c$var$_propTypes.default.oneOfType([
            $d65d401151f46b4c$var$_propTypes.default.func,
            $d65d401151f46b4c$var$_propTypes.default.object,
            $d65d401151f46b4c$var$_propTypes.default.bool
        ])),
        $d65d401151f46b4c$var$_propTypes.default.func,
        $d65d401151f46b4c$var$_propTypes.default.object
    ])
};


Object.keys($d65d401151f46b4c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $80a51ab5faf3eb45$exports && $80a51ab5faf3eb45$exports[key] === $d65d401151f46b4c$exports[key]) return;
    Object.defineProperty($80a51ab5faf3eb45$exports, key, {
        enumerable: true,
        get: function() {
            return $d65d401151f46b4c$exports[key];
        }
    });
});
var $90a3f4450bddbd27$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $90a3f4450bddbd27$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $90a3f4450bddbd27$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($90a3f4450bddbd27$exports, "__esModule", {
    value: true
});
$90a3f4450bddbd27$exports.GridPanelHeader = $90a3f4450bddbd27$var$GridPanelHeader;

var $90a3f4450bddbd27$var$_extends2 = $90a3f4450bddbd27$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $90a3f4450bddbd27$var$_objectWithoutPropertiesLoose2 = $90a3f4450bddbd27$require$_interopRequireDefault((parcelRequire("c05no")));

var $90a3f4450bddbd27$var$React = $90a3f4450bddbd27$require$_interopRequireWildcard((parcelRequire("acw62")));

var $90a3f4450bddbd27$var$_propTypes = $90a3f4450bddbd27$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $90a3f4450bddbd27$var$_clsx = $90a3f4450bddbd27$require$_interopRequireDefault((parcelRequire("9QePP")));

var $izOUK = parcelRequire("izOUK");

var $90a3f4450bddbd27$var$_composeClasses = $90a3f4450bddbd27$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $hbuUJ = parcelRequire("hbuUJ");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $90a3f4450bddbd27$var$_excluded = [
    "className"
];
const $90a3f4450bddbd27$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'panelHeader'
        ]
    };
    return (0, $90a3f4450bddbd27$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $90a3f4450bddbd27$var$GridPanelHeaderRoot = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'PanelHeader'
})({
    padding: $hbuUJ.vars.spacing(1)
});
function $90a3f4450bddbd27$var$GridPanelHeader(props) {
    const { className: className } = props, other = (0, $90a3f4450bddbd27$var$_objectWithoutPropertiesLoose2.default)(props, $90a3f4450bddbd27$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $90a3f4450bddbd27$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($90a3f4450bddbd27$var$GridPanelHeaderRoot, (0, $90a3f4450bddbd27$var$_extends2.default)({
        className: (0, $90a3f4450bddbd27$var$_clsx.default)(classes.root, className),
        ownerState: rootProps
    }, other));
}
$90a3f4450bddbd27$var$GridPanelHeader.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    sx: $90a3f4450bddbd27$var$_propTypes.default.oneOfType([
        $90a3f4450bddbd27$var$_propTypes.default.arrayOf($90a3f4450bddbd27$var$_propTypes.default.oneOfType([
            $90a3f4450bddbd27$var$_propTypes.default.func,
            $90a3f4450bddbd27$var$_propTypes.default.object,
            $90a3f4450bddbd27$var$_propTypes.default.bool
        ])),
        $90a3f4450bddbd27$var$_propTypes.default.func,
        $90a3f4450bddbd27$var$_propTypes.default.object
    ])
};


Object.keys($90a3f4450bddbd27$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $80a51ab5faf3eb45$exports && $80a51ab5faf3eb45$exports[key] === $90a3f4450bddbd27$exports[key]) return;
    Object.defineProperty($80a51ab5faf3eb45$exports, key, {
        enumerable: true,
        get: function() {
            return $90a3f4450bddbd27$exports[key];
        }
    });
});

Object.keys($a133c015d593f0ef$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $80a51ab5faf3eb45$exports && $80a51ab5faf3eb45$exports[key] === $a133c015d593f0ef$exports[key]) return;
    Object.defineProperty($80a51ab5faf3eb45$exports, key, {
        enumerable: true,
        get: function() {
            return $a133c015d593f0ef$exports[key];
        }
    });
});
var $770750dea3c0eca8$exports = {};
"use strict";
Object.defineProperty($770750dea3c0eca8$exports, "__esModule", {
    value: true
});
var $770750dea3c0eca8$var$_exportNames = {
    GridFilterInputValue: true,
    GridFilterInputBoolean: true,
    GridFilterPanel: true
};
Object.defineProperty($770750dea3c0eca8$exports, "GridFilterInputBoolean", {
    enumerable: true,
    get: function() {
        return $ccd0a0b443bb9406$exports.GridFilterInputBoolean;
    }
});
Object.defineProperty($770750dea3c0eca8$exports, "GridFilterInputValue", {
    enumerable: true,
    get: function() {
        return $bbbaea9771a9f69f$exports.GridFilterInputValue;
    }
});
Object.defineProperty($770750dea3c0eca8$exports, "GridFilterPanel", {
    enumerable: true,
    get: function() {
        return $f3ffbde2bea4efe2$exports.GridFilterPanel;
    }
});
var $7032bd7e5a458ec9$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $7032bd7e5a458ec9$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $7032bd7e5a458ec9$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($7032bd7e5a458ec9$exports, "__esModule", {
    value: true
});
$7032bd7e5a458ec9$exports.GridFilterForm = void 0;

var $7032bd7e5a458ec9$var$_extends2 = $7032bd7e5a458ec9$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $7032bd7e5a458ec9$var$_objectWithoutPropertiesLoose2 = $7032bd7e5a458ec9$require$_interopRequireDefault((parcelRequire("c05no")));

var $7032bd7e5a458ec9$var$_react = $7032bd7e5a458ec9$require$_interopRequireWildcard((parcelRequire("acw62")));
var $7032bd7e5a458ec9$var$React = $7032bd7e5a458ec9$var$_react;

var $7032bd7e5a458ec9$var$_propTypes = $7032bd7e5a458ec9$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $7032bd7e5a458ec9$var$_clsx = $7032bd7e5a458ec9$require$_interopRequireDefault((parcelRequire("9QePP")));

var $7032bd7e5a458ec9$var$_composeClasses = $7032bd7e5a458ec9$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $7032bd7e5a458ec9$var$_useId = $7032bd7e5a458ec9$require$_interopRequireDefault((parcelRequire("hwliF")));

var $7032bd7e5a458ec9$var$_capitalize = $7032bd7e5a458ec9$require$_interopRequireDefault((parcelRequire("4O6za")));

var $8xDHs = parcelRequire("8xDHs");

var $fYxgT = parcelRequire("fYxgT");

var $hbuUJ = parcelRequire("hbuUJ");



var $5sOMZ = parcelRequire("5sOMZ");


var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");



var $ayMG0 = parcelRequire("ayMG0");
const $7032bd7e5a458ec9$var$_excluded = [
    "item",
    "hasMultipleFilters",
    "deleteFilter",
    "applyFilterChanges",
    "showMultiFilterOperators",
    "disableMultiFilterOperator",
    "applyMultiFilterOperatorChanges",
    "focusElementRef",
    "logicOperators",
    "columnsSort",
    "filterColumns",
    "deleteIconProps",
    "logicOperatorInputProps",
    "operatorInputProps",
    "columnInputProps",
    "valueInputProps",
    "readOnly",
    "children"
], $7032bd7e5a458ec9$var$_excluded2 = [
    "InputComponentProps"
];
const $7032bd7e5a458ec9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'filterForm'
        ],
        deleteIcon: [
            'filterFormDeleteIcon'
        ],
        logicOperatorInput: [
            'filterFormLogicOperatorInput'
        ],
        columnInput: [
            'filterFormColumnInput'
        ],
        operatorInput: [
            'filterFormOperatorInput'
        ],
        valueInput: [
            'filterFormValueInput'
        ]
    };
    return (0, $7032bd7e5a458ec9$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $7032bd7e5a458ec9$var$GridFilterFormRoot = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterForm'
})({
    display: 'flex',
    gap: $hbuUJ.vars.spacing(1.5)
});
const $7032bd7e5a458ec9$var$FilterFormDeleteIcon = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterFormDeleteIcon'
})({
    flexShrink: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
const $7032bd7e5a458ec9$var$FilterFormLogicOperatorInput = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterFormLogicOperatorInput'
})({
    minWidth: 75,
    justifyContent: 'end'
});
const $7032bd7e5a458ec9$var$FilterFormColumnInput = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterFormColumnInput'
})({
    width: 150
});
const $7032bd7e5a458ec9$var$FilterFormOperatorInput = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterFormOperatorInput'
})({
    width: 150
});
const $7032bd7e5a458ec9$var$FilterFormValueInput = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterFormValueInput'
})({
    width: 190
});
const $7032bd7e5a458ec9$var$getLogicOperatorLocaleKey = (logicOperator)=>{
    switch(logicOperator){
        case $6c940a0517b1c6d5$exports.GridLogicOperator.And:
            return 'filterPanelOperatorAnd';
        case $6c940a0517b1c6d5$exports.GridLogicOperator.Or:
            return 'filterPanelOperatorOr';
        default:
            throw new Error('MUI X: Invalid `logicOperator` property in the `GridFilterPanel`.');
    }
};
const $7032bd7e5a458ec9$var$getColumnLabel = (col)=>col.headerName || col.field;
const $7032bd7e5a458ec9$var$collator = new Intl.Collator();
const $7032bd7e5a458ec9$var$GridFilterForm = $7032bd7e5a458ec9$exports.GridFilterForm = (0, $fYxgT.forwardRef)(function GridFilterForm(props, ref) {
    const { item: item, hasMultipleFilters: hasMultipleFilters, deleteFilter: deleteFilter, applyFilterChanges: applyFilterChanges, showMultiFilterOperators: showMultiFilterOperators, disableMultiFilterOperator: disableMultiFilterOperator, applyMultiFilterOperatorChanges: applyMultiFilterOperatorChanges, focusElementRef: focusElementRef, logicOperators: logicOperators = [
        $6c940a0517b1c6d5$exports.GridLogicOperator.And,
        $6c940a0517b1c6d5$exports.GridLogicOperator.Or
    ], columnsSort: columnsSort, filterColumns: filterColumns, deleteIconProps: deleteIconProps = {}, logicOperatorInputProps: logicOperatorInputProps = {}, operatorInputProps: operatorInputProps = {}, columnInputProps: columnInputProps = {}, valueInputProps: valueInputProps = {}, readOnly: readOnly } = props, other = (0, $7032bd7e5a458ec9$var$_objectWithoutPropertiesLoose2.default)(props, $7032bd7e5a458ec9$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const columnLookup = (0, $5sOMZ.useGridSelector)(apiRef, $e732684465924d20$exports.gridColumnLookupSelector);
    const filterableColumns = (0, $5sOMZ.useGridSelector)(apiRef, $e732684465924d20$exports.gridFilterableColumnDefinitionsSelector);
    const filterModel = (0, $5sOMZ.useGridSelector)(apiRef, $e95988b653de2e96$exports.gridFilterModelSelector);
    const columnSelectId = (0, $7032bd7e5a458ec9$var$_useId.default)();
    const columnSelectLabelId = (0, $7032bd7e5a458ec9$var$_useId.default)();
    const operatorSelectId = (0, $7032bd7e5a458ec9$var$_useId.default)();
    const operatorSelectLabelId = (0, $7032bd7e5a458ec9$var$_useId.default)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $7032bd7e5a458ec9$var$useUtilityClasses(rootProps);
    const valueRef = $7032bd7e5a458ec9$var$React.useRef(null);
    const filterSelectorRef = $7032bd7e5a458ec9$var$React.useRef(null);
    const multiFilterOperator = filterModel.logicOperator ?? $6c940a0517b1c6d5$exports.GridLogicOperator.And;
    const hasLogicOperatorColumn = hasMultipleFilters && logicOperators.length > 0;
    const baseSelectProps = rootProps.slotProps?.baseSelect || {};
    const isBaseSelectNative = baseSelectProps.native ?? false;
    const baseSelectOptionProps = rootProps.slotProps?.baseSelectOption || {};
    const { InputComponentProps: InputComponentProps } = valueInputProps, valueInputPropsOther = (0, $7032bd7e5a458ec9$var$_objectWithoutPropertiesLoose2.default)(valueInputProps, $7032bd7e5a458ec9$var$_excluded2);
    const pivotActive = (0, $5sOMZ.useGridSelector)(apiRef, $2d9bb9ae74999313$exports.gridPivotActiveSelector);
    const initialColumns = (0, $5sOMZ.useGridSelector)(apiRef, $2d9bb9ae74999313$exports.gridPivotInitialColumnsSelector);
    const { filteredColumns: filteredColumns, selectedField: selectedField } = $7032bd7e5a458ec9$var$React.useMemo(()=>{
        let itemField = item.field;
        // Yields a valid value if the current filter belongs to a column that is not filterable
        const selectedNonFilterableColumn = columnLookup[item.field].filterable === false ? columnLookup[item.field] : null;
        if (selectedNonFilterableColumn) return {
            filteredColumns: [
                selectedNonFilterableColumn
            ],
            selectedField: itemField
        };
        if (pivotActive) return {
            filteredColumns: filterableColumns.filter((column)=>initialColumns.get(column.field) !== undefined),
            selectedField: itemField
        };
        if (filterColumns === undefined || typeof filterColumns !== 'function') return {
            filteredColumns: filterableColumns,
            selectedField: itemField
        };
        const filteredFields = filterColumns({
            field: item.field,
            columns: filterableColumns,
            currentFilters: filterModel?.items || []
        });
        return {
            filteredColumns: filterableColumns.filter((column)=>{
                const isFieldIncluded = filteredFields.includes(column.field);
                if (column.field === item.field && !isFieldIncluded) itemField = undefined;
                return isFieldIncluded;
            }),
            selectedField: itemField
        };
    }, [
        item.field,
        columnLookup,
        pivotActive,
        filterColumns,
        filterableColumns,
        filterModel?.items,
        initialColumns
    ]);
    const sortedFilteredColumns = $7032bd7e5a458ec9$var$React.useMemo(()=>{
        switch(columnsSort){
            case 'asc':
                return filteredColumns.sort((a, b)=>$7032bd7e5a458ec9$var$collator.compare($7032bd7e5a458ec9$var$getColumnLabel(a), $7032bd7e5a458ec9$var$getColumnLabel(b)));
            case 'desc':
                return filteredColumns.sort((a, b)=>-$7032bd7e5a458ec9$var$collator.compare($7032bd7e5a458ec9$var$getColumnLabel(a), $7032bd7e5a458ec9$var$getColumnLabel(b)));
            default:
                return filteredColumns;
        }
    }, [
        filteredColumns,
        columnsSort
    ]);
    const currentColumn = item.field ? apiRef.current.getColumn(item.field) : null;
    const currentOperator = $7032bd7e5a458ec9$var$React.useMemo(()=>{
        if (!item.operator || !currentColumn) return null;
        return currentColumn.filterOperators?.find((operator)=>operator.value === item.operator);
    }, [
        item,
        currentColumn
    ]);
    const changeColumn = $7032bd7e5a458ec9$var$React.useCallback((event)=>{
        const field = event.target.value;
        const column = apiRef.current.getColumn(field);
        if (column.field === currentColumn.field) // column did not change
        return;
        // try to keep the same operator when column change
        const newOperator = column.filterOperators.find((operator)=>operator.value === item.operator) || column.filterOperators[0];
        // Erase filter value if the input component or filtered column type is modified
        const eraseFilterValue = !newOperator.InputComponent || newOperator.InputComponent !== currentOperator?.InputComponent || column.type !== currentColumn.type;
        let filterValue = eraseFilterValue ? undefined : item.value;
        // Check filter value against the new valueOptions
        if (column.type === 'singleSelect' && filterValue !== undefined) {
            const colDef = column;
            const valueOptions = (0, $40d64af47d07faaf$exports.getValueOptions)(colDef);
            if (Array.isArray(filterValue)) filterValue = filterValue.filter((val)=>{
                return(// Only keep values that are in the new value options
                (0, $40d64af47d07faaf$exports.getValueFromValueOptions)(val, valueOptions, colDef?.getOptionValue) !== undefined);
            });
            else if ((0, $40d64af47d07faaf$exports.getValueFromValueOptions)(item.value, valueOptions, colDef?.getOptionValue) === undefined) // Reset the filter value if it is not in the new value options
            filterValue = undefined;
        }
        applyFilterChanges((0, $7032bd7e5a458ec9$var$_extends2.default)({}, item, {
            field: field,
            operator: newOperator.value,
            value: filterValue
        }));
    }, [
        apiRef,
        applyFilterChanges,
        item,
        currentColumn,
        currentOperator
    ]);
    const changeOperator = $7032bd7e5a458ec9$var$React.useCallback((event)=>{
        const operator = event.target.value;
        const newOperator = currentColumn?.filterOperators.find((op)=>op.value === operator);
        const eraseItemValue = !newOperator?.InputComponent || newOperator?.InputComponent !== currentOperator?.InputComponent;
        applyFilterChanges((0, $7032bd7e5a458ec9$var$_extends2.default)({}, item, {
            operator: operator,
            value: eraseItemValue ? undefined : item.value
        }));
    }, [
        applyFilterChanges,
        item,
        currentColumn,
        currentOperator
    ]);
    const changeLogicOperator = $7032bd7e5a458ec9$var$React.useCallback((event)=>{
        const logicOperator = event.target.value === $6c940a0517b1c6d5$exports.GridLogicOperator.And.toString() ? $6c940a0517b1c6d5$exports.GridLogicOperator.And : $6c940a0517b1c6d5$exports.GridLogicOperator.Or;
        applyMultiFilterOperatorChanges(logicOperator);
    }, [
        applyMultiFilterOperatorChanges
    ]);
    const handleDeleteFilter = ()=>{
        deleteFilter(item);
    };
    $7032bd7e5a458ec9$var$React.useImperativeHandle(focusElementRef, ()=>({
            focus: ()=>{
                if (currentOperator?.InputComponent) valueRef?.current?.focus();
                else filterSelectorRef.current.focus();
            }
        }), [
        currentOperator
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($7032bd7e5a458ec9$var$GridFilterFormRoot, (0, $7032bd7e5a458ec9$var$_extends2.default)({
        className: classes.root,
        "data-id": item.id,
        ownerState: rootProps
    }, other, {
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($7032bd7e5a458ec9$var$FilterFormDeleteIcon, (0, $7032bd7e5a458ec9$var$_extends2.default)({}, deleteIconProps, {
                className: (0, $7032bd7e5a458ec9$var$_clsx.default)(classes.deleteIcon, deleteIconProps.className),
                ownerState: rootProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseIconButton, (0, $7032bd7e5a458ec9$var$_extends2.default)({
                    "aria-label": apiRef.current.getLocaleText('filterPanelDeleteIconLabel'),
                    title: apiRef.current.getLocaleText('filterPanelDeleteIconLabel'),
                    onClick: handleDeleteFilter,
                    size: "small",
                    disabled: readOnly
                }, rootProps.slotProps?.baseIconButton, {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.filterPanelDeleteIcon, {
                        fontSize: "small"
                    })
                }))
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)($7032bd7e5a458ec9$var$FilterFormLogicOperatorInput, (0, $7032bd7e5a458ec9$var$_extends2.default)({
                as: rootProps.slots.baseSelect,
                sx: [
                    hasLogicOperatorColumn ? {
                        display: 'flex'
                    } : {
                        display: 'none'
                    },
                    showMultiFilterOperators ? {
                        visibility: 'visible'
                    } : {
                        visibility: 'hidden'
                    },
                    logicOperatorInputProps.sx
                ],
                className: (0, $7032bd7e5a458ec9$var$_clsx.default)(classes.logicOperatorInput, logicOperatorInputProps.className),
                ownerState: rootProps
            }, logicOperatorInputProps, {
                size: "small",
                slotProps: {
                    htmlInput: {
                        'aria-label': apiRef.current.getLocaleText('filterPanelLogicOperator')
                    }
                },
                value: multiFilterOperator ?? '',
                onChange: changeLogicOperator,
                disabled: !!disableMultiFilterOperator || logicOperators.length === 1,
                native: isBaseSelectNative
            }, rootProps.slotProps?.baseSelect, {
                children: logicOperators.map((logicOperator)=>/*#__PURE__*/ (0, $7032bd7e5a458ec9$var$_react.createElement)(rootProps.slots.baseSelectOption, (0, $7032bd7e5a458ec9$var$_extends2.default)({}, baseSelectOptionProps, {
                        native: isBaseSelectNative,
                        key: logicOperator.toString(),
                        value: logicOperator.toString()
                    }), apiRef.current.getLocaleText($7032bd7e5a458ec9$var$getLogicOperatorLocaleKey(logicOperator))))
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)($7032bd7e5a458ec9$var$FilterFormColumnInput, (0, $7032bd7e5a458ec9$var$_extends2.default)({
                as: rootProps.slots.baseSelect
            }, columnInputProps, {
                className: (0, $7032bd7e5a458ec9$var$_clsx.default)(classes.columnInput, columnInputProps.className),
                ownerState: rootProps,
                size: "small",
                labelId: columnSelectLabelId,
                id: columnSelectId,
                label: apiRef.current.getLocaleText('filterPanelColumns'),
                value: selectedField ?? '',
                onChange: changeColumn,
                native: isBaseSelectNative,
                disabled: readOnly
            }, rootProps.slotProps?.baseSelect, {
                children: sortedFilteredColumns.map((col)=>/*#__PURE__*/ (0, $7032bd7e5a458ec9$var$_react.createElement)(rootProps.slots.baseSelectOption, (0, $7032bd7e5a458ec9$var$_extends2.default)({}, baseSelectOptionProps, {
                        native: isBaseSelectNative,
                        key: col.field,
                        value: col.field
                    }), $7032bd7e5a458ec9$var$getColumnLabel(col)))
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)($7032bd7e5a458ec9$var$FilterFormOperatorInput, (0, $7032bd7e5a458ec9$var$_extends2.default)({
                as: rootProps.slots.baseSelect,
                size: "small"
            }, operatorInputProps, {
                className: (0, $7032bd7e5a458ec9$var$_clsx.default)(classes.operatorInput, operatorInputProps.className),
                ownerState: rootProps,
                labelId: operatorSelectLabelId,
                label: apiRef.current.getLocaleText('filterPanelOperator'),
                id: operatorSelectId,
                value: item.operator,
                onChange: changeOperator,
                native: isBaseSelectNative,
                inputRef: filterSelectorRef,
                disabled: readOnly
            }, rootProps.slotProps?.baseSelect, {
                children: currentColumn?.filterOperators?.map((operator)=>/*#__PURE__*/ (0, $7032bd7e5a458ec9$var$_react.createElement)(rootProps.slots.baseSelectOption, (0, $7032bd7e5a458ec9$var$_extends2.default)({}, baseSelectOptionProps, {
                        native: isBaseSelectNative,
                        key: operator.value,
                        value: operator.value
                    }), operator.label || apiRef.current.getLocaleText(`filterOperator${(0, $7032bd7e5a458ec9$var$_capitalize.default)(operator.value)}`)))
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)($7032bd7e5a458ec9$var$FilterFormValueInput, (0, $7032bd7e5a458ec9$var$_extends2.default)({}, valueInputPropsOther, {
                className: (0, $7032bd7e5a458ec9$var$_clsx.default)(classes.valueInput, valueInputPropsOther.className),
                ownerState: rootProps,
                children: currentOperator?.InputComponent ? /*#__PURE__*/ (0, $ayMG0.jsx)(currentOperator.InputComponent, (0, $7032bd7e5a458ec9$var$_extends2.default)({
                    apiRef: apiRef,
                    item: item,
                    applyValue: applyFilterChanges,
                    focusElementRef: valueRef,
                    disabled: readOnly,
                    slotProps: {
                        root: {
                            size: 'small'
                        }
                    }
                }, currentOperator.InputComponentProps, InputComponentProps), item.field) : null
            }))
        ]
    }));
});
$7032bd7e5a458ec9$var$GridFilterForm.displayName = "GridFilterForm";
$7032bd7e5a458ec9$var$GridFilterForm.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * Callback called when the operator, column field or value is changed.
   * @param {GridFilterItem} item The updated [[GridFilterItem]].
   */ applyFilterChanges: $7032bd7e5a458ec9$var$_propTypes.default.func.isRequired,
    /**
   * Callback called when the logic operator is changed.
   * @param {GridLogicOperator} operator The new logic operator.
   */ applyMultiFilterOperatorChanges: $7032bd7e5a458ec9$var$_propTypes.default.func.isRequired,
    /**
   * @ignore - do not document.
   */ children: $7032bd7e5a458ec9$var$_propTypes.default.node,
    /**
   * Props passed to the column input component.
   * @default {}
   */ columnInputProps: $7032bd7e5a458ec9$var$_propTypes.default.any,
    /**
   * Changes how the options in the columns selector should be ordered.
   * If not specified, the order is derived from the `columns` prop.
   */ columnsSort: $7032bd7e5a458ec9$var$_propTypes.default.oneOf([
        'asc',
        'desc'
    ]),
    /**
   * Callback called when the delete button is clicked.
   * @param {GridFilterItem} item The deleted [[GridFilterItem]].
   */ deleteFilter: $7032bd7e5a458ec9$var$_propTypes.default.func.isRequired,
    /**
   * Props passed to the delete icon.
   * @default {}
   */ deleteIconProps: $7032bd7e5a458ec9$var$_propTypes.default.any,
    /**
   * If `true`, disables the logic operator field but still renders it.
   */ disableMultiFilterOperator: $7032bd7e5a458ec9$var$_propTypes.default.bool,
    /**
   * Allows to filter the columns displayed in the filter form.
   * @param {FilterColumnsArgs} args The columns of the grid and name of field.
   * @returns {GridColDef['field'][]} The filtered fields array.
   */ filterColumns: $7032bd7e5a458ec9$var$_propTypes.default.func,
    /**
   * A ref allowing to set imperative focus.
   * It can be passed to the el
   */ focusElementRef: $7032bd7e5a458ec9$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        $7032bd7e5a458ec9$var$_propTypes.default.func,
        $7032bd7e5a458ec9$var$_propTypes.default.object
    ]),
    /**
   * If `true`, the logic operator field is rendered.
   * The field will be invisible if `showMultiFilterOperators` is also `true`.
   */ hasMultipleFilters: $7032bd7e5a458ec9$var$_propTypes.default.bool.isRequired,
    /**
   * The [[GridFilterItem]] representing this form.
   */ item: $7032bd7e5a458ec9$var$_propTypes.default.shape({
        field: $7032bd7e5a458ec9$var$_propTypes.default.string.isRequired,
        id: $7032bd7e5a458ec9$var$_propTypes.default.oneOfType([
            $7032bd7e5a458ec9$var$_propTypes.default.number,
            $7032bd7e5a458ec9$var$_propTypes.default.string
        ]),
        operator: $7032bd7e5a458ec9$var$_propTypes.default.string.isRequired,
        value: $7032bd7e5a458ec9$var$_propTypes.default.any
    }).isRequired,
    /**
   * Props passed to the logic operator input component.
   * @default {}
   */ logicOperatorInputProps: $7032bd7e5a458ec9$var$_propTypes.default.any,
    /**
   * Sets the available logic operators.
   * @default [GridLogicOperator.And, GridLogicOperator.Or]
   */ logicOperators: $7032bd7e5a458ec9$var$_propTypes.default.arrayOf($7032bd7e5a458ec9$var$_propTypes.default.oneOf([
        'and',
        'or'
    ]).isRequired),
    /**
   * Props passed to the operator input component.
   * @default {}
   */ operatorInputProps: $7032bd7e5a458ec9$var$_propTypes.default.any,
    /**
   * `true` if the filter is disabled/read only.
   * i.e. `colDef.fiterable = false` but passed in `filterModel`
   * @default false
   */ readOnly: $7032bd7e5a458ec9$var$_propTypes.default.bool,
    /**
   * If `true`, the logic operator field is visible.
   */ showMultiFilterOperators: $7032bd7e5a458ec9$var$_propTypes.default.bool,
    /**
   * Props passed to the value input component.
   * @default {}
   */ valueInputProps: $7032bd7e5a458ec9$var$_propTypes.default.any
}; /**
 * Demos:
 * - [Filtering - overview](https://mui.com/x/react-data-grid/filtering/)
 *
 * API:
 * - [GridFilterForm API](https://mui.com/x/api/data-grid/grid-filter-form/)
 */ 


Object.keys($7032bd7e5a458ec9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($770750dea3c0eca8$var$_exportNames, key)) return;
    if (key in $770750dea3c0eca8$exports && $770750dea3c0eca8$exports[key] === $7032bd7e5a458ec9$exports[key]) return;
    Object.defineProperty($770750dea3c0eca8$exports, key, {
        enumerable: true,
        get: function() {
            return $7032bd7e5a458ec9$exports[key];
        }
    });
});


Object.keys($40a3126b9e135d1e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($770750dea3c0eca8$var$_exportNames, key)) return;
    if (key in $770750dea3c0eca8$exports && $770750dea3c0eca8$exports[key] === $40a3126b9e135d1e$exports[key]) return;
    Object.defineProperty($770750dea3c0eca8$exports, key, {
        enumerable: true,
        get: function() {
            return $40a3126b9e135d1e$exports[key];
        }
    });
});

Object.keys($39421fe28cb0a5f3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($770750dea3c0eca8$var$_exportNames, key)) return;
    if (key in $770750dea3c0eca8$exports && $770750dea3c0eca8$exports[key] === $39421fe28cb0a5f3$exports[key]) return;
    Object.defineProperty($770750dea3c0eca8$exports, key, {
        enumerable: true,
        get: function() {
            return $39421fe28cb0a5f3$exports[key];
        }
    });
});

var $f3ffbde2bea4efe2$exports = {};
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $f3ffbde2bea4efe2$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $f3ffbde2bea4efe2$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($f3ffbde2bea4efe2$exports, "__esModule", {
    value: true
});
$f3ffbde2bea4efe2$exports.getGridFilter = $f3ffbde2bea4efe2$exports.GridFilterPanel = void 0;

var $f3ffbde2bea4efe2$var$_extends2 = $f3ffbde2bea4efe2$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $f3ffbde2bea4efe2$var$_objectWithoutPropertiesLoose2 = $f3ffbde2bea4efe2$require$_interopRequireDefault((parcelRequire("c05no")));

var $f3ffbde2bea4efe2$var$React = $f3ffbde2bea4efe2$require$_interopRequireWildcard((parcelRequire("acw62")));

var $f3ffbde2bea4efe2$var$_propTypes = $f3ffbde2bea4efe2$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $fYxgT = parcelRequire("fYxgT");


var $bDyDY = parcelRequire("bDyDY");





var $jDpXp = parcelRequire("jDpXp");

var $5sOMZ = parcelRequire("5sOMZ");



var $ayMG0 = parcelRequire("ayMG0");
const $f3ffbde2bea4efe2$var$_excluded = [
    "logicOperators",
    "columnsSort",
    "filterFormProps",
    "getColumnForNewFilter",
    "children",
    "disableAddFilterButton",
    "disableRemoveAllButton"
];
const $f3ffbde2bea4efe2$var$getGridFilter = (col)=>({
        field: col.field,
        operator: col.filterOperators[0].value,
        id: Math.round(Math.random() * 1e5)
    });
$f3ffbde2bea4efe2$exports.getGridFilter = $f3ffbde2bea4efe2$var$getGridFilter;
const $f3ffbde2bea4efe2$var$GridFilterPanel = $f3ffbde2bea4efe2$exports.GridFilterPanel = (0, $fYxgT.forwardRef)(function GridFilterPanel(props, ref) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const filterModel = (0, $5sOMZ.useGridSelector)(apiRef, $e95988b653de2e96$exports.gridFilterModelSelector);
    const filterableColumns = (0, $5sOMZ.useGridSelector)(apiRef, $e732684465924d20$exports.gridFilterableColumnDefinitionsSelector);
    const filterableColumnsLookup = (0, $5sOMZ.useGridSelector)(apiRef, $e732684465924d20$exports.gridFilterableColumnLookupSelector);
    const lastFilterRef = $f3ffbde2bea4efe2$var$React.useRef(null);
    const placeholderFilter = $f3ffbde2bea4efe2$var$React.useRef(null);
    const { logicOperators: logicOperators = [
        $6c940a0517b1c6d5$exports.GridLogicOperator.And,
        $6c940a0517b1c6d5$exports.GridLogicOperator.Or
    ], columnsSort: columnsSort, filterFormProps: filterFormProps, getColumnForNewFilter: getColumnForNewFilter, disableAddFilterButton: disableAddFilterButton = false, disableRemoveAllButton: disableRemoveAllButton = false } = props, other = (0, $f3ffbde2bea4efe2$var$_objectWithoutPropertiesLoose2.default)(props, $f3ffbde2bea4efe2$var$_excluded);
    const applyFilter = apiRef.current.upsertFilterItem;
    const applyFilterLogicOperator = $f3ffbde2bea4efe2$var$React.useCallback((operator)=>{
        apiRef.current.setFilterLogicOperator(operator);
    }, [
        apiRef
    ]);
    const getDefaultFilter = $f3ffbde2bea4efe2$var$React.useCallback(()=>{
        let nextColumnWithOperator;
        if (getColumnForNewFilter && typeof getColumnForNewFilter === 'function') {
            // To allow override the column for default (first) filter
            const nextFieldName = getColumnForNewFilter({
                currentFilters: filterModel?.items || [],
                columns: filterableColumns
            });
            if (nextFieldName === null) return null;
            nextColumnWithOperator = filterableColumns.find(({ field: field })=>field === nextFieldName);
        } else nextColumnWithOperator = filterableColumns.find((colDef)=>colDef.filterOperators?.length);
        if (!nextColumnWithOperator) return null;
        return $f3ffbde2bea4efe2$var$getGridFilter(nextColumnWithOperator);
    }, [
        filterModel?.items,
        filterableColumns,
        getColumnForNewFilter
    ]);
    const getNewFilter = $f3ffbde2bea4efe2$var$React.useCallback(()=>{
        if (getColumnForNewFilter === undefined || typeof getColumnForNewFilter !== 'function') return getDefaultFilter();
        const currentFilters = filterModel.items.length ? filterModel.items : [
            getDefaultFilter()
        ].filter(Boolean);
        // If no items are there in filterModel, we have to pass defaultFilter
        const nextColumnFieldName = getColumnForNewFilter({
            currentFilters: currentFilters,
            columns: filterableColumns
        });
        if (nextColumnFieldName === null) return null;
        const nextColumnWithOperator = filterableColumns.find(({ field: field })=>field === nextColumnFieldName);
        if (!nextColumnWithOperator) return null;
        return $f3ffbde2bea4efe2$var$getGridFilter(nextColumnWithOperator);
    }, [
        filterModel.items,
        filterableColumns,
        getColumnForNewFilter,
        getDefaultFilter
    ]);
    const items = $f3ffbde2bea4efe2$var$React.useMemo(()=>{
        if (filterModel.items.length) return filterModel.items;
        if (!placeholderFilter.current) placeholderFilter.current = getDefaultFilter();
        return placeholderFilter.current ? [
            placeholderFilter.current
        ] : [];
    }, [
        filterModel.items,
        getDefaultFilter
    ]);
    const hasMultipleFilters = items.length > 1;
    const { readOnlyFilters: readOnlyFilters, validFilters: validFilters } = $f3ffbde2bea4efe2$var$React.useMemo(()=>items.reduce((acc, item)=>{
            if (filterableColumnsLookup[item.field]) acc.validFilters.push(item);
            else acc.readOnlyFilters.push(item);
            return acc;
        }, {
            readOnlyFilters: [],
            validFilters: []
        }), [
        items,
        filterableColumnsLookup
    ]);
    const addNewFilter = $f3ffbde2bea4efe2$var$React.useCallback(()=>{
        const newFilter = getNewFilter();
        if (!newFilter) return;
        apiRef.current.upsertFilterItems([
            ...items,
            newFilter
        ]);
    }, [
        apiRef,
        getNewFilter,
        items
    ]);
    const deleteFilter = $f3ffbde2bea4efe2$var$React.useCallback((item)=>{
        const shouldCloseFilterPanel = validFilters.length === 1;
        apiRef.current.deleteFilterItem(item);
        if (shouldCloseFilterPanel) apiRef.current.hideFilterPanel();
    }, [
        apiRef,
        validFilters.length
    ]);
    const handleRemoveAll = $f3ffbde2bea4efe2$var$React.useCallback(()=>{
        if (validFilters.length === 1 && validFilters[0].value === undefined) {
            apiRef.current.deleteFilterItem(validFilters[0]);
            return apiRef.current.hideFilterPanel();
        }
        return apiRef.current.setFilterModel((0, $f3ffbde2bea4efe2$var$_extends2.default)({}, filterModel, {
            items: readOnlyFilters
        }), 'removeAllFilterItems');
    }, [
        apiRef,
        readOnlyFilters,
        filterModel,
        validFilters
    ]);
    $f3ffbde2bea4efe2$var$React.useEffect(()=>{
        if (logicOperators.length > 0 && filterModel.logicOperator && !logicOperators.includes(filterModel.logicOperator)) applyFilterLogicOperator(logicOperators[0]);
    }, [
        logicOperators,
        applyFilterLogicOperator,
        filterModel.logicOperator
    ]);
    $f3ffbde2bea4efe2$var$React.useEffect(()=>{
        if (validFilters.length > 0) lastFilterRef.current.focus();
    }, [
        validFilters.length
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($a133c015d593f0ef$exports.GridPanelWrapper, (0, $f3ffbde2bea4efe2$var$_extends2.default)({}, other, {
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($c83c3bce08f2b302$exports.GridPanelContent, {
                children: [
                    readOnlyFilters.map((item, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)($7032bd7e5a458ec9$exports.GridFilterForm, (0, $f3ffbde2bea4efe2$var$_extends2.default)({
                            item: item,
                            applyFilterChanges: applyFilter,
                            deleteFilter: deleteFilter,
                            hasMultipleFilters: hasMultipleFilters,
                            showMultiFilterOperators: index > 0,
                            disableMultiFilterOperator: index !== 1,
                            applyMultiFilterOperatorChanges: applyFilterLogicOperator,
                            focusElementRef: null,
                            readOnly: true,
                            logicOperators: logicOperators,
                            columnsSort: columnsSort
                        }, filterFormProps), item.id == null ? index : item.id)),
                    validFilters.map((item, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)($7032bd7e5a458ec9$exports.GridFilterForm, (0, $f3ffbde2bea4efe2$var$_extends2.default)({
                            item: item,
                            applyFilterChanges: applyFilter,
                            deleteFilter: deleteFilter,
                            hasMultipleFilters: hasMultipleFilters,
                            showMultiFilterOperators: readOnlyFilters.length + index > 0,
                            disableMultiFilterOperator: readOnlyFilters.length + index !== 1,
                            applyMultiFilterOperatorChanges: applyFilterLogicOperator,
                            focusElementRef: index === validFilters.length - 1 ? lastFilterRef : null,
                            logicOperators: logicOperators,
                            columnsSort: columnsSort
                        }, filterFormProps), item.id == null ? index + readOnlyFilters.length : item.id))
                ]
            }),
            !rootProps.disableMultipleColumnsFiltering && !(disableAddFilterButton && disableRemoveAllButton) ? /*#__PURE__*/ (0, $ayMG0.jsxs)($d65d401151f46b4c$exports.GridPanelFooter, {
                children: [
                    !disableAddFilterButton ? /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseButton, (0, $f3ffbde2bea4efe2$var$_extends2.default)({
                        onClick: addNewFilter,
                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.filterPanelAddIcon, {})
                    }, rootProps.slotProps?.baseButton, {
                        children: apiRef.current.getLocaleText('filterPanelAddFilter')
                    })) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                    !disableRemoveAllButton && validFilters.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseButton, (0, $f3ffbde2bea4efe2$var$_extends2.default)({
                        onClick: handleRemoveAll,
                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.filterPanelRemoveAllIcon, {})
                    }, rootProps.slotProps?.baseButton, {
                        children: apiRef.current.getLocaleText('filterPanelRemoveAll')
                    })) : null
                ]
            }) : null
        ]
    }));
});
$f3ffbde2bea4efe2$var$GridFilterPanel.displayName = "GridFilterPanel";
$f3ffbde2bea4efe2$var$GridFilterPanel.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * @ignore - do not document.
   */ children: $f3ffbde2bea4efe2$var$_propTypes.default.node,
    /**
   * Changes how the options in the columns selector should be ordered.
   * If not specified, the order is derived from the `columns` prop.
   */ columnsSort: $f3ffbde2bea4efe2$var$_propTypes.default.oneOf([
        'asc',
        'desc'
    ]),
    /**
   * If `true`, the `Add filter` button will not be displayed.
   * @default false
   */ disableAddFilterButton: $f3ffbde2bea4efe2$var$_propTypes.default.bool,
    /**
   * If `true`, the `Remove all` button will be disabled
   * @default false
   */ disableRemoveAllButton: $f3ffbde2bea4efe2$var$_propTypes.default.bool,
    /**
   * Props passed to each filter form.
   */ filterFormProps: $f3ffbde2bea4efe2$var$_propTypes.default.shape({
        columnInputProps: $f3ffbde2bea4efe2$var$_propTypes.default.any,
        columnsSort: $f3ffbde2bea4efe2$var$_propTypes.default.oneOf([
            'asc',
            'desc'
        ]),
        deleteIconProps: $f3ffbde2bea4efe2$var$_propTypes.default.any,
        filterColumns: $f3ffbde2bea4efe2$var$_propTypes.default.func,
        logicOperatorInputProps: $f3ffbde2bea4efe2$var$_propTypes.default.any,
        operatorInputProps: $f3ffbde2bea4efe2$var$_propTypes.default.any,
        valueInputProps: $f3ffbde2bea4efe2$var$_propTypes.default.any
    }),
    /**
   * Function that returns the next filter item to be picked as default filter.
   * @param {GetColumnForNewFilterArgs} args Currently configured filters and columns.
   * @returns {GridColDef['field']} The field to be used for the next filter or `null` to prevent adding a filter.
   */ getColumnForNewFilter: $f3ffbde2bea4efe2$var$_propTypes.default.func,
    /**
   * Sets the available logic operators.
   * @default [GridLogicOperator.And, GridLogicOperator.Or]
   */ logicOperators: $f3ffbde2bea4efe2$var$_propTypes.default.arrayOf($f3ffbde2bea4efe2$var$_propTypes.default.oneOf([
        'and',
        'or'
    ]).isRequired),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $f3ffbde2bea4efe2$var$_propTypes.default.oneOfType([
        $f3ffbde2bea4efe2$var$_propTypes.default.arrayOf($f3ffbde2bea4efe2$var$_propTypes.default.oneOfType([
            $f3ffbde2bea4efe2$var$_propTypes.default.func,
            $f3ffbde2bea4efe2$var$_propTypes.default.object,
            $f3ffbde2bea4efe2$var$_propTypes.default.bool
        ])),
        $f3ffbde2bea4efe2$var$_propTypes.default.func,
        $f3ffbde2bea4efe2$var$_propTypes.default.object
    ])
}; /**
 * Demos:
 * - [Filtering - overview](https://mui.com/x/react-data-grid/filtering/)
 *
 * API:
 * - [GridFilterPanel API](https://mui.com/x/api/data-grid/grid-filter-panel/)
 */ 



Object.keys($4b64102825ff1e40$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($770750dea3c0eca8$var$_exportNames, key)) return;
    if (key in $770750dea3c0eca8$exports && $770750dea3c0eca8$exports[key] === $4b64102825ff1e40$exports[key]) return;
    Object.defineProperty($770750dea3c0eca8$exports, key, {
        enumerable: true,
        get: function() {
            return $4b64102825ff1e40$exports[key];
        }
    });
});

Object.keys($077d69ce451095d0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($770750dea3c0eca8$var$_exportNames, key)) return;
    if (key in $770750dea3c0eca8$exports && $770750dea3c0eca8$exports[key] === $077d69ce451095d0$exports[key]) return;
    Object.defineProperty($770750dea3c0eca8$exports, key, {
        enumerable: true,
        get: function() {
            return $077d69ce451095d0$exports[key];
        }
    });
});


Object.keys($770750dea3c0eca8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $80a51ab5faf3eb45$exports && $80a51ab5faf3eb45$exports[key] === $770750dea3c0eca8$exports[key]) return;
    Object.defineProperty($80a51ab5faf3eb45$exports, key, {
        enumerable: true,
        get: function() {
            return $770750dea3c0eca8$exports[key];
        }
    });
});


Object.keys($80a51ab5faf3eb45$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in $08eee520e810d520$exports && $08eee520e810d520$exports[key] === $80a51ab5faf3eb45$exports[key]) return;
    Object.defineProperty($08eee520e810d520$exports, key, {
        enumerable: true,
        get: function() {
            return $80a51ab5faf3eb45$exports[key];
        }
    });
});
var $3b186f61086657c7$exports = {};
"use strict";
Object.defineProperty($3b186f61086657c7$exports, "__esModule", {
    value: true
});
var $321281a63dc6186b$exports = {};
"use strict";
/* eslint-disable @typescript-eslint/no-use-before-define */ 'use client';

var $3pEGv = parcelRequire("3pEGv");
var $321281a63dc6186b$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $321281a63dc6186b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($321281a63dc6186b$exports, "__esModule", {
    value: true
});
$321281a63dc6186b$exports.GridColumnsManagement = $321281a63dc6186b$var$GridColumnsManagement;

var $321281a63dc6186b$var$_extends2 = $321281a63dc6186b$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $321281a63dc6186b$var$React = $321281a63dc6186b$require$_interopRequireWildcard((parcelRequire("acw62")));

var $321281a63dc6186b$var$_propTypes = $321281a63dc6186b$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $321281a63dc6186b$var$_composeClasses = $321281a63dc6186b$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $321281a63dc6186b$var$_debounce = $321281a63dc6186b$require$_interopRequireDefault((parcelRequire("9NXOO")));

var $8xDHs = parcelRequire("8xDHs");

var $9MvHs = parcelRequire("9MvHs");

var $hbuUJ = parcelRequire("hbuUJ");


var $5sOMZ = parcelRequire("5sOMZ");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");
var $85aa4911010e7c41$exports = {};
"use strict";
Object.defineProperty($85aa4911010e7c41$exports, "__esModule", {
    value: true
});
$85aa4911010e7c41$exports.defaultSearchPredicate = $85aa4911010e7c41$exports.checkColumnVisibilityModelsSame = void 0;
const $85aa4911010e7c41$var$checkColumnVisibilityModelsSame = (a, b)=>{
    // Filter `false` values only, as `true` and not having a key are the same
    const aFalseValues = new Set(Object.keys(a).filter((key)=>a[key] === false));
    const bFalseValues = new Set(Object.keys(b).filter((key)=>b[key] === false));
    if (aFalseValues.size !== bFalseValues.size) return false;
    let result = true;
    aFalseValues.forEach((key)=>{
        if (!bFalseValues.has(key)) result = false;
    });
    return result;
};
$85aa4911010e7c41$exports.checkColumnVisibilityModelsSame = $85aa4911010e7c41$var$checkColumnVisibilityModelsSame;
const $85aa4911010e7c41$var$defaultSearchPredicate = (column, searchValue)=>(column.headerName || column.field).toLowerCase().indexOf(searchValue) > -1;
$85aa4911010e7c41$exports.defaultSearchPredicate = $85aa4911010e7c41$var$defaultSearchPredicate;



var $5b8c70a8582b44e6$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5b8c70a8582b44e6$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $5b8c70a8582b44e6$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($5b8c70a8582b44e6$exports, "__esModule", {
    value: true
});
$5b8c70a8582b44e6$exports.GridShadowScrollArea = void 0;

var $5b8c70a8582b44e6$var$_extends2 = $5b8c70a8582b44e6$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $5b8c70a8582b44e6$var$_objectWithoutPropertiesLoose2 = $5b8c70a8582b44e6$require$_interopRequireDefault((parcelRequire("c05no")));

var $5b8c70a8582b44e6$var$React = $5b8c70a8582b44e6$require$_interopRequireWildcard((parcelRequire("acw62")));

var $5b8c70a8582b44e6$var$_propTypes = $5b8c70a8582b44e6$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $izOUK = parcelRequire("izOUK");

var $fYxgT = parcelRequire("fYxgT");

var $ayMG0 = parcelRequire("ayMG0");
const $5b8c70a8582b44e6$var$_excluded = [
    "children"
];
const $5b8c70a8582b44e6$var$reveal = (0, $izOUK.keyframes)({
    from: {
        opacity: 0
    },
    to: {
        opacity: 1
    }
});
const $5b8c70a8582b44e6$var$detectScroll = (0, $izOUK.keyframes)({
    'from, to': {
        '--scrollable': '" "'
    }
});
// This `styled()` function invokes keyframes. `styled-components` only supports keyframes
// in string templates. Do not convert these styles in JS object as it will break.
const $5b8c70a8582b44e6$var$ShadowScrollArea = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'ShadowScrollArea'
})`
  flex: 1;
  display: flex;
  flex-direction: column;
  animation: ${$5b8c70a8582b44e6$var$detectScroll};
  animation-timeline: --scroll-timeline;
  animation-fill-mode: none;
  box-sizing: border-box;
  overflow: auto;
  scrollbar-width: thin;
  scroll-timeline: --scroll-timeline block;

  &::before,
  &::after {
    content: '';
    flex-shrink: 0;
    display: block;
    position: sticky;
    left: 0;
    width: 100%;
    height: 4px;
    animation: ${$5b8c70a8582b44e6$var$reveal} linear both;
    animation-timeline: --scroll-timeline;

    // Custom property toggle trick:
    // - Detects if the element is scrollable
    // - https://css-tricks.com/the-css-custom-property-toggle-trick/
    --visibility-scrollable: var(--scrollable) visible;
    --visibility-not-scrollable: hidden;
    visibility: var(--visibility-scrollable, var(--visibility-not-scrollable));
  }

  &::before {
    top: 0;
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.05) 0, transparent 100%);
    animation-range: 0 4px;
  }

  &::after {
    bottom: 0;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.05) 0, transparent 100%);
    animation-direction: reverse;
    animation-range: calc(100% - 4px) 100%;
  }
`;
/**
 * Adds scroll shadows above and below content in a scrollable container.
 */ const $5b8c70a8582b44e6$var$GridShadowScrollArea = $5b8c70a8582b44e6$exports.GridShadowScrollArea = (0, $fYxgT.forwardRef)(function GridShadowScrollArea(props, ref) {
    const { children: children } = props, other = (0, $5b8c70a8582b44e6$var$_objectWithoutPropertiesLoose2.default)(props, $5b8c70a8582b44e6$var$_excluded);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5b8c70a8582b44e6$var$ShadowScrollArea, (0, $5b8c70a8582b44e6$var$_extends2.default)({}, other, {
        ref: ref,
        children: children
    }));
});
$5b8c70a8582b44e6$var$GridShadowScrollArea.displayName = "GridShadowScrollArea";
$5b8c70a8582b44e6$var$GridShadowScrollArea.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    children: $5b8c70a8582b44e6$var$_propTypes.default.node
};




var $ayMG0 = parcelRequire("ayMG0");
const $321281a63dc6186b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'columnsManagement'
        ],
        header: [
            'columnsManagementHeader'
        ],
        searchInput: [
            'columnsManagementSearchInput'
        ],
        footer: [
            'columnsManagementFooter'
        ],
        row: [
            'columnsManagementRow'
        ]
    };
    return (0, $321281a63dc6186b$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $321281a63dc6186b$var$collator = new Intl.Collator();
function $321281a63dc6186b$var$GridColumnsManagement(props) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const searchInputRef = $321281a63dc6186b$var$React.useRef(null);
    const initialColumnVisibilityModel = (0, $5sOMZ.useGridSelector)(apiRef, $e732684465924d20$exports.gridInitialColumnVisibilityModelSelector);
    const columnVisibilityModel = (0, $5sOMZ.useGridSelector)(apiRef, $e732684465924d20$exports.gridColumnVisibilityModelSelector);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const [searchValue, setSearchValue] = $321281a63dc6186b$var$React.useState('');
    const classes = $321281a63dc6186b$var$useUtilityClasses(rootProps);
    const columnDefinitions = (0, $5sOMZ.useGridSelector)(apiRef, $e732684465924d20$exports.gridColumnDefinitionsSelector);
    const pivotActive = (0, $5sOMZ.useGridSelector)(apiRef, $2623d93ce2942d3c$exports.gridPivotActiveSelector);
    const pivotInitialColumns = (0, $5sOMZ.useGridSelector)(apiRef, $2623d93ce2942d3c$exports.gridPivotInitialColumnsSelector);
    const columns = $321281a63dc6186b$var$React.useMemo(()=>pivotActive ? Array.from(pivotInitialColumns.values()) : columnDefinitions, [
        pivotActive,
        pivotInitialColumns,
        columnDefinitions
    ]);
    const { sort: sort, searchPredicate: searchPredicate = $85aa4911010e7c41$exports.defaultSearchPredicate, autoFocusSearchField: autoFocusSearchField = true, disableShowHideToggle: disableShowHideToggle = false, disableResetButton: disableResetButton = false, toggleAllMode: toggleAllMode = 'all', getTogglableColumns: getTogglableColumns, searchInputProps: searchInputProps, searchDebounceMs: searchDebounceMs = rootProps.columnFilterDebounceMs } = props;
    const debouncedFilter = $321281a63dc6186b$var$React.useMemo(()=>(0, $321281a63dc6186b$var$_debounce.default)((value)=>{
            setSearchValue(value);
        }, searchDebounceMs ?? 150), [
        searchDebounceMs
    ]);
    const isResetDisabled = $321281a63dc6186b$var$React.useMemo(()=>(0, $85aa4911010e7c41$exports.checkColumnVisibilityModelsSame)(columnVisibilityModel, initialColumnVisibilityModel), [
        columnVisibilityModel,
        initialColumnVisibilityModel
    ]);
    const sortedColumns = $321281a63dc6186b$var$React.useMemo(()=>{
        switch(sort){
            case 'asc':
                return [
                    ...columns
                ].sort((a, b)=>$321281a63dc6186b$var$collator.compare(a.headerName || a.field, b.headerName || b.field));
            case 'desc':
                return [
                    ...columns
                ].sort((a, b)=>-$321281a63dc6186b$var$collator.compare(a.headerName || a.field, b.headerName || b.field));
            default:
                return columns;
        }
    }, [
        columns,
        sort
    ]);
    const toggleColumn = (event)=>{
        const { name: field } = event.target;
        apiRef.current.setColumnVisibility(field, columnVisibilityModel[field] === false);
    };
    const currentColumns = $321281a63dc6186b$var$React.useMemo(()=>{
        const togglableColumns = getTogglableColumns ? getTogglableColumns(sortedColumns) : null;
        const togglableSortedColumns = togglableColumns ? sortedColumns.filter(({ field: field })=>togglableColumns.includes(field)) : sortedColumns;
        if (!searchValue) return togglableSortedColumns;
        return togglableSortedColumns.filter((column)=>searchPredicate(column, searchValue.toLowerCase()));
    }, [
        sortedColumns,
        searchValue,
        searchPredicate,
        getTogglableColumns
    ]);
    const toggleAllColumns = $321281a63dc6186b$var$React.useCallback((isVisible)=>{
        const currentModel = (0, $e732684465924d20$exports.gridColumnVisibilityModelSelector)(apiRef);
        const newModel = (0, $321281a63dc6186b$var$_extends2.default)({}, currentModel);
        const togglableColumns = getTogglableColumns ? getTogglableColumns(columns) : null;
        (toggleAllMode === 'filteredOnly' ? currentColumns : columns).forEach((col)=>{
            if (col.hideable && (togglableColumns == null || togglableColumns.includes(col.field))) {
                if (isVisible) // delete the key from the model instead of setting it to `true`
                delete newModel[col.field];
                else newModel[col.field] = false;
            }
        });
        return apiRef.current.setColumnVisibilityModel(newModel);
    }, [
        apiRef,
        columns,
        getTogglableColumns,
        toggleAllMode,
        currentColumns
    ]);
    const handleSearchValueChange = $321281a63dc6186b$var$React.useCallback((event)=>{
        debouncedFilter(event.target.value);
    }, [
        debouncedFilter
    ]);
    const hideableColumns = $321281a63dc6186b$var$React.useMemo(()=>currentColumns.filter((col)=>col.hideable), [
        currentColumns
    ]);
    const allHideableColumnsVisible = $321281a63dc6186b$var$React.useMemo(()=>hideableColumns.every((column)=>columnVisibilityModel[column.field] == null || columnVisibilityModel[column.field] !== false), [
        columnVisibilityModel,
        hideableColumns
    ]);
    const allHideableColumnsHidden = $321281a63dc6186b$var$React.useMemo(()=>hideableColumns.every((column)=>columnVisibilityModel[column.field] === false), [
        columnVisibilityModel,
        hideableColumns
    ]);
    const firstSwitchRef = $321281a63dc6186b$var$React.useRef(null);
    $321281a63dc6186b$var$React.useEffect(()=>{
        if (autoFocusSearchField) searchInputRef.current?.focus();
        else if (firstSwitchRef.current && typeof firstSwitchRef.current.focus === 'function') firstSwitchRef.current.focus();
    }, [
        autoFocusSearchField
    ]);
    let firstHideableColumnFound = false;
    const isFirstHideableColumn = (column)=>{
        if (firstHideableColumnFound === false && column.hideable !== false) {
            firstHideableColumnFound = true;
            return true;
        }
        return false;
    };
    const handleSearchReset = $321281a63dc6186b$var$React.useCallback(()=>{
        setSearchValue('');
        if (searchInputRef.current) {
            searchInputRef.current.value = '';
            searchInputRef.current.focus();
        }
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($321281a63dc6186b$var$React.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($321281a63dc6186b$var$GridColumnsManagementHeader, {
                className: classes.header,
                ownerState: rootProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($321281a63dc6186b$var$SearchInput, (0, $321281a63dc6186b$var$_extends2.default)({
                    as: rootProps.slots.baseTextField,
                    ownerState: rootProps,
                    placeholder: apiRef.current.getLocaleText('columnsManagementSearchTitle'),
                    inputRef: searchInputRef,
                    className: classes.searchInput,
                    onChange: handleSearchValueChange,
                    size: "small",
                    type: "search",
                    slotProps: {
                        input: {
                            startAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.quickFilterIcon, {
                                fontSize: "small"
                            }),
                            endAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseIconButton, (0, $321281a63dc6186b$var$_extends2.default)({
                                size: "small",
                                "aria-label": apiRef.current.getLocaleText('columnsManagementDeleteIconLabel'),
                                style: searchValue ? {
                                    visibility: 'visible'
                                } : {
                                    visibility: 'hidden'
                                },
                                tabIndex: -1,
                                onClick: handleSearchReset,
                                edge: "end"
                            }, rootProps.slotProps?.baseIconButton, {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.quickFilterClearIcon, {
                                    fontSize: "small"
                                })
                            }))
                        },
                        htmlInput: {
                            'aria-label': apiRef.current.getLocaleText('columnsManagementSearchTitle')
                        }
                    },
                    autoComplete: "off",
                    fullWidth: true
                }, rootProps.slotProps?.baseTextField, searchInputProps))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($321281a63dc6186b$var$GridColumnsManagementScrollArea, {
                ownerState: rootProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)($321281a63dc6186b$var$GridColumnsManagementBody, {
                    className: classes.root,
                    ownerState: rootProps,
                    children: [
                        currentColumns.map((column)=>/*#__PURE__*/ (0, $ayMG0.jsx)($321281a63dc6186b$var$GridColumnsManagementRow, (0, $321281a63dc6186b$var$_extends2.default)({
                                as: rootProps.slots.baseCheckbox,
                                className: classes.row,
                                disabled: column.hideable === false || pivotActive,
                                checked: columnVisibilityModel[column.field] !== false,
                                onChange: toggleColumn,
                                name: column.field,
                                inputRef: isFirstHideableColumn(column) ? firstSwitchRef : undefined,
                                label: column.headerName || column.field,
                                density: "compact",
                                fullWidth: true
                            }, rootProps.slotProps?.baseCheckbox), column.field)),
                        currentColumns.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)($321281a63dc6186b$var$GridColumnsManagementEmptyText, {
                            ownerState: rootProps,
                            children: apiRef.current.getLocaleText('columnsManagementNoColumns')
                        })
                    ]
                })
            }),
            !disableShowHideToggle || !disableResetButton ? /*#__PURE__*/ (0, $ayMG0.jsxs)($321281a63dc6186b$var$GridColumnsManagementFooter, {
                ownerState: rootProps,
                className: classes.footer,
                children: [
                    !disableShowHideToggle ? /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseCheckbox, (0, $321281a63dc6186b$var$_extends2.default)({
                        disabled: hideableColumns.length === 0 || pivotActive,
                        checked: allHideableColumnsVisible,
                        indeterminate: !allHideableColumnsVisible && !allHideableColumnsHidden,
                        onChange: ()=>toggleAllColumns(!allHideableColumnsVisible),
                        name: apiRef.current.getLocaleText('columnsManagementShowHideAllText'),
                        label: apiRef.current.getLocaleText('columnsManagementShowHideAllText'),
                        density: "compact"
                    }, rootProps.slotProps?.baseCheckbox)) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                    !disableResetButton ? /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseButton, (0, $321281a63dc6186b$var$_extends2.default)({
                        onClick: ()=>apiRef.current.setColumnVisibilityModel(initialColumnVisibilityModel),
                        disabled: isResetDisabled || pivotActive
                    }, rootProps.slotProps?.baseButton, {
                        children: apiRef.current.getLocaleText('columnsManagementReset')
                    })) : null
                ]
            }) : null
        ]
    });
}
$321281a63dc6186b$var$GridColumnsManagement.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * If `true`, the column search field will be focused automatically.
   * If `false`, the first column switch input will be focused automatically.
   * This helps to avoid input keyboard panel to popup automatically on touch devices.
   * @default true
   */ autoFocusSearchField: $321281a63dc6186b$var$_propTypes.default.bool,
    /**
   * If `true`, the `Reset` button will not be disabled
   * @default false
   */ disableResetButton: $321281a63dc6186b$var$_propTypes.default.bool,
    /**
   * If `true`, the `Show/Hide all` toggle checkbox will not be displayed.
   * @default false
   */ disableShowHideToggle: $321281a63dc6186b$var$_propTypes.default.bool,
    /**
   * Returns the list of togglable columns.
   * If used, only those columns will be displayed in the panel
   * which are passed as the return value of the function.
   * @param {GridColDef[]} columns The `ColDef` list of all columns.
   * @returns {GridColDef['field'][]} The list of togglable columns' field names.
   */ getTogglableColumns: $321281a63dc6186b$var$_propTypes.default.func,
    /**
   * The milliseconds delay to wait after a keystroke before triggering filtering in the columns menu.
   * @default 150
   */ searchDebounceMs: $321281a63dc6186b$var$_propTypes.default.number,
    searchInputProps: $321281a63dc6186b$var$_propTypes.default.object,
    searchPredicate: $321281a63dc6186b$var$_propTypes.default.func,
    sort: $321281a63dc6186b$var$_propTypes.default.oneOf([
        'asc',
        'desc'
    ]),
    /**
   * Changes the behavior of the `Show/Hide All` toggle when the search field is used:
   * - `all`: Will toggle all columns.
   * - `filteredOnly`: Will only toggle columns that match the search criteria.
   * @default 'all'
   */ toggleAllMode: $321281a63dc6186b$var$_propTypes.default.oneOf([
        'all',
        'filteredOnly'
    ])
};
const $321281a63dc6186b$var$GridColumnsManagementBody = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnsManagement'
})({
    display: 'flex',
    flexDirection: 'column',
    padding: $hbuUJ.vars.spacing(0.5, 1.5)
});
const $321281a63dc6186b$var$GridColumnsManagementScrollArea = (0, $8xDHs.styled)($5b8c70a8582b44e6$exports.GridShadowScrollArea, {
    name: 'MuiDataGrid',
    slot: 'ColumnsManagementScrollArea'
})({
    maxHeight: 300
});
const $321281a63dc6186b$var$GridColumnsManagementHeader = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnsManagementHeader'
})({
    padding: $hbuUJ.vars.spacing(1.5, 2),
    borderBottom: `1px solid ${$hbuUJ.vars.colors.border.base}`
});
const $321281a63dc6186b$var$SearchInput = (0, $8xDHs.styled)($dd66ac2a2c256d30$exports.NotRendered, {
    name: 'MuiDataGrid',
    slot: 'ColumnsManagementSearchInput'
})({
    [`& .${$9MvHs.inputBaseClasses.input}::-webkit-search-decoration,
      & .${$9MvHs.inputBaseClasses.input}::-webkit-search-cancel-button,
      & .${$9MvHs.inputBaseClasses.input}::-webkit-search-results-button,
      & .${$9MvHs.inputBaseClasses.input}::-webkit-search-results-decoration`]: {
        /* clears the 'X' icon from Chrome */ display: 'none'
    }
});
const $321281a63dc6186b$var$GridColumnsManagementFooter = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnsManagementFooter'
})({
    padding: $hbuUJ.vars.spacing(1, 1, 1, 1.5),
    display: 'flex',
    justifyContent: 'space-between',
    borderTop: `1px solid ${$hbuUJ.vars.colors.border.base}`
});
const $321281a63dc6186b$var$GridColumnsManagementEmptyText = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnsManagementEmptyText'
})({
    padding: $hbuUJ.vars.spacing(1, 0),
    alignSelf: 'center',
    font: $hbuUJ.vars.typography.font.body
});
const $321281a63dc6186b$var$GridColumnsManagementRow = (0, $8xDHs.styled)($dd66ac2a2c256d30$exports.NotRendered, {
    name: 'MuiDataGrid',
    slot: 'ColumnsManagementRow'
})({});


Object.keys($321281a63dc6186b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3b186f61086657c7$exports && $3b186f61086657c7$exports[key] === $321281a63dc6186b$exports[key]) return;
    Object.defineProperty($3b186f61086657c7$exports, key, {
        enumerable: true,
        get: function() {
            return $321281a63dc6186b$exports[key];
        }
    });
});


Object.keys($3b186f61086657c7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in $08eee520e810d520$exports && $08eee520e810d520$exports[key] === $3b186f61086657c7$exports[key]) return;
    Object.defineProperty($08eee520e810d520$exports, key, {
        enumerable: true,
        get: function() {
            return $3b186f61086657c7$exports[key];
        }
    });
});
var $db5176c392a1c83e$exports = {};
"use strict";
Object.defineProperty($db5176c392a1c83e$exports, "__esModule", {
    value: true
});
var $db5176c392a1c83e$var$_exportNames = {
    GridCsvExportMenuItem: true,
    GridPrintExportMenuItem: true,
    GridToolbarExport: true
};
Object.defineProperty($db5176c392a1c83e$exports, "GridCsvExportMenuItem", {
    enumerable: true,
    get: function() {
        return $117c70f90fd64960$exports.GridCsvExportMenuItem;
    }
});
Object.defineProperty($db5176c392a1c83e$exports, "GridPrintExportMenuItem", {
    enumerable: true,
    get: function() {
        return $117c70f90fd64960$exports.GridPrintExportMenuItem;
    }
});
Object.defineProperty($db5176c392a1c83e$exports, "GridToolbarExport", {
    enumerable: true,
    get: function() {
        return $117c70f90fd64960$exports.GridToolbarExport;
    }
});
var $3823b87e39c2fb28$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3823b87e39c2fb28$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($3823b87e39c2fb28$exports, "__esModule", {
    value: true
});
$3823b87e39c2fb28$exports.GridToolbar = void 0;

var $3823b87e39c2fb28$var$_extends2 = $3823b87e39c2fb28$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $3823b87e39c2fb28$var$_objectWithoutPropertiesLoose2 = $3823b87e39c2fb28$require$_interopRequireDefault((parcelRequire("c05no")));

var $3823b87e39c2fb28$var$_propTypes = $3823b87e39c2fb28$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $fYxgT = parcelRequire("fYxgT");

var $68dba7cc326760eb$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $68dba7cc326760eb$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $68dba7cc326760eb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($68dba7cc326760eb$exports, "__esModule", {
    value: true
});
$68dba7cc326760eb$exports.GridToolbarColumnsButton = void 0;

var $68dba7cc326760eb$var$_extends2 = $68dba7cc326760eb$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $68dba7cc326760eb$var$React = $68dba7cc326760eb$require$_interopRequireWildcard((parcelRequire("acw62")));

var $68dba7cc326760eb$var$_propTypes = $68dba7cc326760eb$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $68dba7cc326760eb$var$_useId = $68dba7cc326760eb$require$_interopRequireDefault((parcelRequire("hwliF")));

var $fYxgT = parcelRequire("fYxgT");

var $68dba7cc326760eb$var$_useForkRef = $68dba7cc326760eb$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $5sOMZ = parcelRequire("5sOMZ");



var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");


var $ayMG0 = parcelRequire("ayMG0");
/**
 * @deprecated Use the {@link https://mui.com/x/react-data-grid/components/columns-panel/ Columns Panel Trigger} component instead. This component will be removed in a future major release.
 */ const $68dba7cc326760eb$var$GridToolbarColumnsButton = $68dba7cc326760eb$exports.GridToolbarColumnsButton = (0, $fYxgT.forwardRef)(function GridToolbarColumnsButton(props, ref) {
    const { slotProps: slotProps = {} } = props;
    const buttonProps = slotProps.button || {};
    const tooltipProps = slotProps.tooltip || {};
    const columnButtonId = (0, $68dba7cc326760eb$var$_useId.default)();
    const columnPanelId = (0, $68dba7cc326760eb$var$_useId.default)();
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const { columnsPanelTriggerRef: columnsPanelTriggerRef } = (0, $546bc72d2cea638d$exports.useGridPanelContext)();
    const preferencePanel = (0, $5sOMZ.useGridSelector)(apiRef, $50fa8e974bf84473$exports.gridPreferencePanelStateSelector);
    const handleRef = (0, $68dba7cc326760eb$var$_useForkRef.default)(ref, columnsPanelTriggerRef);
    const showColumns = (event)=>{
        if (preferencePanel.open && preferencePanel.openedPanelValue === $2ca45f4bbfed6878$exports.GridPreferencePanelsValue.columns) apiRef.current.hidePreferences();
        else apiRef.current.showPreferences($2ca45f4bbfed6878$exports.GridPreferencePanelsValue.columns, columnPanelId, columnButtonId);
        buttonProps.onClick?.(event);
    };
    // Disable the button if the corresponding is disabled
    if (rootProps.disableColumnSelector) return null;
    const isOpen = preferencePanel.open && preferencePanel.panelId === columnPanelId;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTooltip, (0, $68dba7cc326760eb$var$_extends2.default)({
        title: apiRef.current.getLocaleText('toolbarColumnsLabel'),
        enterDelay: 1000
    }, rootProps.slotProps?.baseTooltip, tooltipProps, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseButton, (0, $68dba7cc326760eb$var$_extends2.default)({
            id: columnButtonId,
            size: "small",
            "aria-label": apiRef.current.getLocaleText('toolbarColumnsLabel'),
            "aria-haspopup": "menu",
            "aria-expanded": isOpen,
            "aria-controls": isOpen ? columnPanelId : undefined,
            startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnSelectorIcon, {})
        }, rootProps.slotProps?.baseButton, buttonProps, {
            onPointerUp: (event)=>{
                if (preferencePanel.open) event.stopPropagation();
                buttonProps.onPointerUp?.(event);
            },
            onClick: showColumns,
            ref: handleRef,
            children: apiRef.current.getLocaleText('toolbarColumns')
        }))
    }));
});
$68dba7cc326760eb$var$GridToolbarColumnsButton.displayName = "GridToolbarColumnsButton";
$68dba7cc326760eb$var$GridToolbarColumnsButton.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $68dba7cc326760eb$var$_propTypes.default.object
};


var $839090d5c761d720$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $839090d5c761d720$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $839090d5c761d720$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($839090d5c761d720$exports, "__esModule", {
    value: true
});
$839090d5c761d720$exports.GridToolbarDensitySelector = void 0;

var $839090d5c761d720$var$_extends2 = $839090d5c761d720$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $839090d5c761d720$var$React = $839090d5c761d720$require$_interopRequireWildcard((parcelRequire("acw62")));

var $839090d5c761d720$var$_propTypes = $839090d5c761d720$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $839090d5c761d720$var$_useId = $839090d5c761d720$require$_interopRequireDefault((parcelRequire("hwliF")));

var $839090d5c761d720$var$_useForkRef = $839090d5c761d720$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $fYxgT = parcelRequire("fYxgT");


var $bDyDY = parcelRequire("bDyDY");

var $5sOMZ = parcelRequire("5sOMZ");


var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @deprecated See {@link https://mui.com/x/react-data-grid/accessibility/#set-the-density-programmatically Accessibility—Set the density programmatically} for an example of adding a density selector to the toolbar. This component will be removed in a future major release.
 */ const $839090d5c761d720$var$GridToolbarDensitySelector = $839090d5c761d720$exports.GridToolbarDensitySelector = (0, $fYxgT.forwardRef)(function GridToolbarDensitySelector(props, ref) {
    const { slotProps: slotProps = {} } = props;
    const buttonProps = slotProps.button || {};
    const tooltipProps = slotProps.tooltip || {};
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const density = (0, $5sOMZ.useGridSelector)(apiRef, $b611aad21a5b677d$exports.gridDensitySelector);
    const densityButtonId = (0, $839090d5c761d720$var$_useId.default)();
    const densityMenuId = (0, $839090d5c761d720$var$_useId.default)();
    const [open, setOpen] = $839090d5c761d720$var$React.useState(false);
    const buttonRef = $839090d5c761d720$var$React.useRef(null);
    const handleRef = (0, $839090d5c761d720$var$_useForkRef.default)(ref, buttonRef);
    const densityOptions = [
        {
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.densityCompactIcon, {}),
            label: apiRef.current.getLocaleText('toolbarDensityCompact'),
            value: 'compact'
        },
        {
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.densityStandardIcon, {}),
            label: apiRef.current.getLocaleText('toolbarDensityStandard'),
            value: 'standard'
        },
        {
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.densityComfortableIcon, {}),
            label: apiRef.current.getLocaleText('toolbarDensityComfortable'),
            value: 'comfortable'
        }
    ];
    const startIcon = $839090d5c761d720$var$React.useMemo(()=>{
        switch(density){
            case 'compact':
                return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.densityCompactIcon, {});
            case 'comfortable':
                return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.densityComfortableIcon, {});
            default:
                return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.densityStandardIcon, {});
        }
    }, [
        density,
        rootProps
    ]);
    const handleDensitySelectorOpen = (event)=>{
        setOpen((prevOpen)=>!prevOpen);
        buttonProps.onClick?.(event);
    };
    const handleDensitySelectorClose = ()=>{
        setOpen(false);
    };
    const handleDensityUpdate = (newDensity)=>{
        apiRef.current.setDensity(newDensity);
        setOpen(false);
    };
    // Disable the button if the corresponding is disabled
    if (rootProps.disableDensitySelector) return null;
    const densityElements = densityOptions.map((option, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseMenuItem, {
            onClick: ()=>handleDensityUpdate(option.value),
            selected: option.value === density,
            iconStart: option.icon,
            children: option.label
        }, index));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($839090d5c761d720$var$React.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTooltip, (0, $839090d5c761d720$var$_extends2.default)({
                title: apiRef.current.getLocaleText('toolbarDensityLabel'),
                enterDelay: 1000
            }, rootProps.slotProps?.baseTooltip, tooltipProps, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseButton, (0, $839090d5c761d720$var$_extends2.default)({
                    size: "small",
                    startIcon: startIcon,
                    "aria-label": apiRef.current.getLocaleText('toolbarDensityLabel'),
                    "aria-haspopup": "menu",
                    "aria-expanded": open,
                    "aria-controls": open ? densityMenuId : undefined,
                    id: densityButtonId
                }, rootProps.slotProps?.baseButton, buttonProps, {
                    onClick: handleDensitySelectorOpen,
                    ref: handleRef,
                    children: apiRef.current.getLocaleText('toolbarDensity')
                }))
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)($8efc7911d5661cb8$exports.GridMenu, {
                open: open,
                target: buttonRef.current,
                onClose: handleDensitySelectorClose,
                position: "bottom-end",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseMenuList, {
                    id: densityMenuId,
                    className: $5H1vo.gridClasses.menuList,
                    "aria-labelledby": densityButtonId,
                    autoFocusItem: open,
                    children: densityElements
                })
            })
        ]
    });
});
$839090d5c761d720$var$GridToolbarDensitySelector.displayName = "GridToolbarDensitySelector";
$839090d5c761d720$var$GridToolbarDensitySelector.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $839090d5c761d720$var$_propTypes.default.object
};


var $552288f2e6707b2c$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $552288f2e6707b2c$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $552288f2e6707b2c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($552288f2e6707b2c$exports, "__esModule", {
    value: true
});
$552288f2e6707b2c$exports.GridToolbarFilterButton = void 0;

var $552288f2e6707b2c$var$_extends2 = $552288f2e6707b2c$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $552288f2e6707b2c$var$React = $552288f2e6707b2c$require$_interopRequireWildcard((parcelRequire("acw62")));

var $552288f2e6707b2c$var$_propTypes = $552288f2e6707b2c$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8xDHs = parcelRequire("8xDHs");

var $552288f2e6707b2c$var$_composeClasses = $552288f2e6707b2c$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $552288f2e6707b2c$var$_capitalize = $552288f2e6707b2c$require$_interopRequireDefault((parcelRequire("4O6za")));

var $552288f2e6707b2c$var$_useId = $552288f2e6707b2c$require$_interopRequireDefault((parcelRequire("hwliF")));

var $552288f2e6707b2c$var$_useForkRef = $552288f2e6707b2c$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $fYxgT = parcelRequire("fYxgT");

var $hbuUJ = parcelRequire("hbuUJ");


var $5sOMZ = parcelRequire("5sOMZ");




var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");


var $ayMG0 = parcelRequire("ayMG0");
const $552288f2e6707b2c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'toolbarFilterList'
        ]
    };
    return (0, $552288f2e6707b2c$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $552288f2e6707b2c$var$GridToolbarFilterListRoot = (0, $8xDHs.styled)('ul', {
    name: 'MuiDataGrid',
    slot: 'ToolbarFilterList'
})({
    margin: $hbuUJ.vars.spacing(1, 1, 0.5),
    padding: $hbuUJ.vars.spacing(0, 1)
});
/**
 * @deprecated Use the {@link https://mui.com/x/react-data-grid/components/filter-panel/ Filter Panel Trigger} component instead. This component will be removed in a future major release.
 */ const $552288f2e6707b2c$var$GridToolbarFilterButton = $552288f2e6707b2c$exports.GridToolbarFilterButton = (0, $fYxgT.forwardRef)(function GridToolbarFilterButton(props, ref) {
    const { slotProps: slotProps = {} } = props;
    const buttonProps = slotProps.button || {};
    const tooltipProps = slotProps.tooltip || {};
    const badgeProps = slotProps.badge || {};
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const activeFilters = (0, $5sOMZ.useGridSelector)(apiRef, $e95988b653de2e96$exports.gridFilterActiveItemsSelector);
    const lookup = (0, $5sOMZ.useGridSelector)(apiRef, $e732684465924d20$exports.gridColumnLookupSelector);
    const preferencePanel = (0, $5sOMZ.useGridSelector)(apiRef, $50fa8e974bf84473$exports.gridPreferencePanelStateSelector);
    const classes = $552288f2e6707b2c$var$useUtilityClasses(rootProps);
    const filterButtonId = (0, $552288f2e6707b2c$var$_useId.default)();
    const filterPanelId = (0, $552288f2e6707b2c$var$_useId.default)();
    const { filterPanelTriggerRef: filterPanelTriggerRef } = (0, $546bc72d2cea638d$exports.useGridPanelContext)();
    const handleRef = (0, $552288f2e6707b2c$var$_useForkRef.default)(ref, filterPanelTriggerRef);
    const tooltipContentNode = $552288f2e6707b2c$var$React.useMemo(()=>{
        if (preferencePanel.open) return apiRef.current.getLocaleText('toolbarFiltersTooltipHide');
        if (activeFilters.length === 0) return apiRef.current.getLocaleText('toolbarFiltersTooltipShow');
        const getOperatorLabel = (item)=>lookup[item.field].filterOperators.find((operator)=>operator.value === item.operator).label || apiRef.current.getLocaleText(`filterOperator${(0, $552288f2e6707b2c$var$_capitalize.default)(item.operator)}`).toString();
        const getFilterItemValue = (item)=>{
            const { getValueAsString: getValueAsString } = lookup[item.field].filterOperators.find((operator)=>operator.value === item.operator);
            return getValueAsString ? getValueAsString(item.value) : item.value;
        };
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                apiRef.current.getLocaleText('toolbarFiltersTooltipActive')(activeFilters.length),
                /*#__PURE__*/ (0, $ayMG0.jsx)($552288f2e6707b2c$var$GridToolbarFilterListRoot, {
                    className: classes.root,
                    ownerState: rootProps,
                    children: activeFilters.map((item, index)=>(0, $552288f2e6707b2c$var$_extends2.default)({}, lookup[item.field] && /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                            children: `${lookup[item.field].headerName || item.field}
                  ${getOperatorLabel(item)}
                  ${// implicit check for null and undefined
                            item.value != null ? getFilterItemValue(item) : ''}`
                        }, index)))
                })
            ]
        });
    }, [
        apiRef,
        rootProps,
        preferencePanel.open,
        activeFilters,
        lookup,
        classes
    ]);
    const toggleFilter = (event)=>{
        const { open: open, openedPanelValue: openedPanelValue } = preferencePanel;
        if (open && openedPanelValue === $2ca45f4bbfed6878$exports.GridPreferencePanelsValue.filters) apiRef.current.hidePreferences();
        else apiRef.current.showPreferences($2ca45f4bbfed6878$exports.GridPreferencePanelsValue.filters, filterPanelId, filterButtonId);
        buttonProps.onClick?.(event);
    };
    // Disable the button if the corresponding is disabled
    if (rootProps.disableColumnFilter) return null;
    const isOpen = preferencePanel.open && preferencePanel.panelId === filterPanelId;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTooltip, (0, $552288f2e6707b2c$var$_extends2.default)({
        title: tooltipContentNode,
        enterDelay: 1000
    }, rootProps.slotProps?.baseTooltip, tooltipProps, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseButton, (0, $552288f2e6707b2c$var$_extends2.default)({
            id: filterButtonId,
            size: "small",
            "aria-label": apiRef.current.getLocaleText('toolbarFiltersLabel'),
            "aria-controls": isOpen ? filterPanelId : undefined,
            "aria-expanded": isOpen,
            "aria-haspopup": true,
            startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseBadge, (0, $552288f2e6707b2c$var$_extends2.default)({
                badgeContent: activeFilters.length,
                color: "primary"
            }, rootProps.slotProps?.baseBadge, badgeProps, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.openFilterButtonIcon, {})
            }))
        }, rootProps.slotProps?.baseButton, buttonProps, {
            onClick: toggleFilter,
            onPointerUp: (event)=>{
                if (preferencePanel.open) event.stopPropagation();
                buttonProps.onPointerUp?.(event);
            },
            ref: handleRef,
            children: apiRef.current.getLocaleText('toolbarFilters')
        }))
    }));
});
$552288f2e6707b2c$var$GridToolbarFilterButton.displayName = "GridToolbarFilterButton";
$552288f2e6707b2c$var$GridToolbarFilterButton.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $552288f2e6707b2c$var$_propTypes.default.object
};


var $117c70f90fd64960$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $117c70f90fd64960$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $117c70f90fd64960$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($117c70f90fd64960$exports, "__esModule", {
    value: true
});
$117c70f90fd64960$exports.GridCsvExportMenuItem = $117c70f90fd64960$var$GridCsvExportMenuItem;
$117c70f90fd64960$exports.GridPrintExportMenuItem = $117c70f90fd64960$var$GridPrintExportMenuItem;
$117c70f90fd64960$exports.GridToolbarExport = void 0;

var $117c70f90fd64960$var$_extends2 = $117c70f90fd64960$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $117c70f90fd64960$var$_objectWithoutPropertiesLoose2 = $117c70f90fd64960$require$_interopRequireDefault((parcelRequire("c05no")));

var $117c70f90fd64960$var$React = $117c70f90fd64960$require$_interopRequireWildcard((parcelRequire("acw62")));

var $117c70f90fd64960$var$_propTypes = $117c70f90fd64960$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $fYxgT = parcelRequire("fYxgT");

var $jDpXp = parcelRequire("jDpXp");

var $bDyDY = parcelRequire("bDyDY");
var $00a23b3a9224b6aa$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $00a23b3a9224b6aa$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $00a23b3a9224b6aa$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($00a23b3a9224b6aa$exports, "__esModule", {
    value: true
});
$00a23b3a9224b6aa$exports.GridToolbarExportContainer = void 0;

var $00a23b3a9224b6aa$var$_extends2 = $00a23b3a9224b6aa$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $00a23b3a9224b6aa$var$React = $00a23b3a9224b6aa$require$_interopRequireWildcard((parcelRequire("acw62")));

var $00a23b3a9224b6aa$var$_propTypes = $00a23b3a9224b6aa$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $00a23b3a9224b6aa$var$_useId = $00a23b3a9224b6aa$require$_interopRequireDefault((parcelRequire("hwliF")));

var $00a23b3a9224b6aa$var$_useForkRef = $00a23b3a9224b6aa$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $fYxgT = parcelRequire("fYxgT");

var $bDyDY = parcelRequire("bDyDY");


var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");

var $ayMG0 = parcelRequire("ayMG0");
const $00a23b3a9224b6aa$var$GridToolbarExportContainer = $00a23b3a9224b6aa$exports.GridToolbarExportContainer = (0, $fYxgT.forwardRef)(function GridToolbarExportContainer(props, ref) {
    const { children: children, slotProps: slotProps = {} } = props;
    const buttonProps = slotProps.button || {};
    const tooltipProps = slotProps.tooltip || {};
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const exportButtonId = (0, $00a23b3a9224b6aa$var$_useId.default)();
    const exportMenuId = (0, $00a23b3a9224b6aa$var$_useId.default)();
    const [open, setOpen] = $00a23b3a9224b6aa$var$React.useState(false);
    const buttonRef = $00a23b3a9224b6aa$var$React.useRef(null);
    const handleRef = (0, $00a23b3a9224b6aa$var$_useForkRef.default)(ref, buttonRef);
    const handleMenuOpen = (event)=>{
        setOpen((prevOpen)=>!prevOpen);
        buttonProps.onClick?.(event);
    };
    const handleMenuClose = ()=>setOpen(false);
    if (children == null) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($00a23b3a9224b6aa$var$React.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTooltip, (0, $00a23b3a9224b6aa$var$_extends2.default)({
                title: apiRef.current.getLocaleText('toolbarExportLabel'),
                enterDelay: 1000
            }, rootProps.slotProps?.baseTooltip, tooltipProps, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseButton, (0, $00a23b3a9224b6aa$var$_extends2.default)({
                    size: "small",
                    startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.exportIcon, {}),
                    "aria-expanded": open,
                    "aria-label": apiRef.current.getLocaleText('toolbarExportLabel'),
                    "aria-haspopup": "menu",
                    "aria-controls": open ? exportMenuId : undefined,
                    id: exportButtonId
                }, rootProps.slotProps?.baseButton, buttonProps, {
                    onClick: handleMenuOpen,
                    ref: handleRef,
                    children: apiRef.current.getLocaleText('toolbarExport')
                }))
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)($8efc7911d5661cb8$exports.GridMenu, {
                open: open,
                target: buttonRef.current,
                onClose: handleMenuClose,
                position: "bottom-end",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseMenuList, {
                    id: exportMenuId,
                    className: $5H1vo.gridClasses.menuList,
                    "aria-labelledby": exportButtonId,
                    autoFocusItem: open,
                    children: $00a23b3a9224b6aa$var$React.Children.map(children, (child)=>{
                        if (!/*#__PURE__*/ $00a23b3a9224b6aa$var$React.isValidElement(child)) return child;
                        return /*#__PURE__*/ $00a23b3a9224b6aa$var$React.cloneElement(child, {
                            hideMenu: handleMenuClose
                        });
                    })
                })
            })
        ]
    });
});
$00a23b3a9224b6aa$var$GridToolbarExportContainer.displayName = "GridToolbarExportContainer";
$00a23b3a9224b6aa$var$GridToolbarExportContainer.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $00a23b3a9224b6aa$var$_propTypes.default.object
};



var $ayMG0 = parcelRequire("ayMG0");
const $117c70f90fd64960$var$_excluded = [
    "hideMenu",
    "options"
], $117c70f90fd64960$var$_excluded2 = [
    "hideMenu",
    "options"
], $117c70f90fd64960$var$_excluded3 = [
    "csvOptions",
    "printOptions",
    "excelOptions"
];
function $117c70f90fd64960$var$GridCsvExportMenuItem(props) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const { hideMenu: hideMenu, options: options } = props, other = (0, $117c70f90fd64960$var$_objectWithoutPropertiesLoose2.default)(props, $117c70f90fd64960$var$_excluded);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseMenuItem, (0, $117c70f90fd64960$var$_extends2.default)({
        onClick: ()=>{
            apiRef.current.exportDataAsCsv(options);
            hideMenu?.();
        }
    }, other, {
        children: apiRef.current.getLocaleText('toolbarExportCSV')
    }));
}
$117c70f90fd64960$var$GridCsvExportMenuItem.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    hideMenu: $117c70f90fd64960$var$_propTypes.default.func,
    options: $117c70f90fd64960$var$_propTypes.default.shape({
        allColumns: $117c70f90fd64960$var$_propTypes.default.bool,
        delimiter: $117c70f90fd64960$var$_propTypes.default.string,
        disableToolbarButton: $117c70f90fd64960$var$_propTypes.default.bool,
        escapeFormulas: $117c70f90fd64960$var$_propTypes.default.bool,
        fields: $117c70f90fd64960$var$_propTypes.default.arrayOf($117c70f90fd64960$var$_propTypes.default.string),
        fileName: $117c70f90fd64960$var$_propTypes.default.string,
        getRowsToExport: $117c70f90fd64960$var$_propTypes.default.func,
        includeColumnGroupsHeaders: $117c70f90fd64960$var$_propTypes.default.bool,
        includeHeaders: $117c70f90fd64960$var$_propTypes.default.bool,
        shouldAppendQuotes: $117c70f90fd64960$var$_propTypes.default.bool,
        utf8WithBom: $117c70f90fd64960$var$_propTypes.default.bool
    })
};
function $117c70f90fd64960$var$GridPrintExportMenuItem(props) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const { hideMenu: hideMenu, options: options } = props, other = (0, $117c70f90fd64960$var$_objectWithoutPropertiesLoose2.default)(props, $117c70f90fd64960$var$_excluded2);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseMenuItem, (0, $117c70f90fd64960$var$_extends2.default)({
        onClick: ()=>{
            apiRef.current.exportDataAsPrint(options);
            hideMenu?.();
        }
    }, other, {
        children: apiRef.current.getLocaleText('toolbarExportPrint')
    }));
}
$117c70f90fd64960$var$GridPrintExportMenuItem.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    hideMenu: $117c70f90fd64960$var$_propTypes.default.func,
    options: $117c70f90fd64960$var$_propTypes.default.shape({
        allColumns: $117c70f90fd64960$var$_propTypes.default.bool,
        bodyClassName: $117c70f90fd64960$var$_propTypes.default.string,
        copyStyles: $117c70f90fd64960$var$_propTypes.default.bool,
        disableToolbarButton: $117c70f90fd64960$var$_propTypes.default.bool,
        fields: $117c70f90fd64960$var$_propTypes.default.arrayOf($117c70f90fd64960$var$_propTypes.default.string),
        fileName: $117c70f90fd64960$var$_propTypes.default.string,
        getRowsToExport: $117c70f90fd64960$var$_propTypes.default.func,
        hideFooter: $117c70f90fd64960$var$_propTypes.default.bool,
        hideToolbar: $117c70f90fd64960$var$_propTypes.default.bool,
        includeCheckboxes: $117c70f90fd64960$var$_propTypes.default.bool,
        pageStyle: $117c70f90fd64960$var$_propTypes.default.oneOfType([
            $117c70f90fd64960$var$_propTypes.default.func,
            $117c70f90fd64960$var$_propTypes.default.string
        ])
    })
};
/**
 * @deprecated Use the {@link https://mui.com/x/react-data-grid/components/export/ Export} components instead. This component will be removed in a future major release.
 */ const $117c70f90fd64960$var$GridToolbarExport = $117c70f90fd64960$exports.GridToolbarExport = (0, $fYxgT.forwardRef)(function GridToolbarExport(props, ref) {
    const _ref = props, { csvOptions: csvOptions = {}, printOptions: printOptions = {}, excelOptions: excelOptions } = _ref, other = (0, $117c70f90fd64960$var$_objectWithoutPropertiesLoose2.default)(_ref, $117c70f90fd64960$var$_excluded3);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const preProcessedButtons = apiRef.current.unstable_applyPipeProcessors('exportMenu', [], {
        excelOptions: excelOptions,
        csvOptions: csvOptions,
        printOptions: printOptions
    }).sort((a, b)=>a.componentName > b.componentName ? 1 : -1);
    if (preProcessedButtons.length === 0) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($00a23b3a9224b6aa$exports.GridToolbarExportContainer, (0, $117c70f90fd64960$var$_extends2.default)({}, other, {
        ref: ref,
        children: preProcessedButtons.map((button, index)=>/*#__PURE__*/ $117c70f90fd64960$var$React.cloneElement(button.component, {
                key: index
            }))
    }));
});
$117c70f90fd64960$var$GridToolbarExport.displayName = "GridToolbarExport";
$117c70f90fd64960$var$GridToolbarExport.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    csvOptions: $117c70f90fd64960$var$_propTypes.default.object,
    printOptions: $117c70f90fd64960$var$_propTypes.default.object,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $117c70f90fd64960$var$_propTypes.default.object
};



var $jDpXp = parcelRequire("jDpXp");
var $0f88284c0023fb16$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0f88284c0023fb16$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($0f88284c0023fb16$exports, "__esModule", {
    value: true
});
$0f88284c0023fb16$exports.GridToolbarQuickFilter = $0f88284c0023fb16$var$GridToolbarQuickFilter;

var $0f88284c0023fb16$var$_extends2 = $0f88284c0023fb16$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $0f88284c0023fb16$var$_objectWithoutPropertiesLoose2 = $0f88284c0023fb16$require$_interopRequireDefault((parcelRequire("c05no")));

var $0f88284c0023fb16$var$_propTypes = $0f88284c0023fb16$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $0f88284c0023fb16$var$_composeClasses = $0f88284c0023fb16$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $izOUK = parcelRequire("izOUK");

var $0f88284c0023fb16$var$_clsx = $0f88284c0023fb16$require$_interopRequireDefault((parcelRequire("9QePP")));


var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");
var $b480793493089ce5$exports = {};
"use strict";
Object.defineProperty($b480793493089ce5$exports, "__esModule", {
    value: true
});
var $f1503dbb52e68089$exports = {};
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $f1503dbb52e68089$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $f1503dbb52e68089$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($f1503dbb52e68089$exports, "__esModule", {
    value: true
});
$f1503dbb52e68089$exports.QuickFilter = $f1503dbb52e68089$var$QuickFilter;

var $f1503dbb52e68089$var$_extends2 = $f1503dbb52e68089$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $f1503dbb52e68089$var$_objectWithoutPropertiesLoose2 = $f1503dbb52e68089$require$_interopRequireDefault((parcelRequire("c05no")));

var $f1503dbb52e68089$var$React = $f1503dbb52e68089$require$_interopRequireWildcard((parcelRequire("acw62")));

var $f1503dbb52e68089$var$_propTypes = $f1503dbb52e68089$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $f1503dbb52e68089$var$_debounce = $f1503dbb52e68089$require$_interopRequireDefault((parcelRequire("9NXOO")));

var $f1503dbb52e68089$var$_useEnhancedEffect = $f1503dbb52e68089$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $f1503dbb52e68089$var$_useId = $f1503dbb52e68089$require$_interopRequireDefault((parcelRequire("hwliF")));


var $3d92e8977302638c$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $3d92e8977302638c$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($3d92e8977302638c$exports, "__esModule", {
    value: true
});
$3d92e8977302638c$exports.QuickFilterContext = void 0;
$3d92e8977302638c$exports.useQuickFilterContext = $3d92e8977302638c$var$useQuickFilterContext;

var $3d92e8977302638c$var$React = $3d92e8977302638c$require$_interopRequireWildcard((parcelRequire("acw62")));
const $3d92e8977302638c$var$QuickFilterContext = $3d92e8977302638c$exports.QuickFilterContext = /*#__PURE__*/ $3d92e8977302638c$var$React.createContext(undefined);
$3d92e8977302638c$var$QuickFilterContext.displayName = "QuickFilterContext";
function $3d92e8977302638c$var$useQuickFilterContext() {
    const context = $3d92e8977302638c$var$React.useContext($3d92e8977302638c$var$QuickFilterContext);
    if (context === undefined) throw new Error('MUI X: Missing context. Quick Filter subcomponents must be placed within a <QuickFilter /> component.');
    return context;
}



var $bDyDY = parcelRequire("bDyDY");

var $5sOMZ = parcelRequire("5sOMZ");


var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $f1503dbb52e68089$var$_excluded = [
    "render",
    "className",
    "parser",
    "formatter",
    "debounceMs",
    "defaultExpanded",
    "expanded",
    "onExpandedChange"
];
const $f1503dbb52e68089$var$DEFAULT_PARSER = (searchText)=>searchText.split(' ').filter((word)=>word !== '');
const $f1503dbb52e68089$var$DEFAULT_FORMATTER = (values)=>values.join(' ');
/**
 * The top level Quick Filter component that provides context to child components.
 * It renders a `<div />` element.
 *
 * Demos:
 *
 * - [Quick Filter](https://mui.com/x/react-data-grid/components/quick-filter/)
 *
 * API:
 *
 * - [QuickFilter API](https://mui.com/x/api/data-grid/quick-filter/)
 */ function $f1503dbb52e68089$var$QuickFilter(props) {
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const { render: render, className: className, parser: parser = $f1503dbb52e68089$var$DEFAULT_PARSER, formatter: formatter = $f1503dbb52e68089$var$DEFAULT_FORMATTER, debounceMs: debounceMs = rootProps.filterDebounceMs, defaultExpanded: defaultExpanded, expanded: expanded, onExpandedChange: onExpandedChange } = props, other = (0, $f1503dbb52e68089$var$_objectWithoutPropertiesLoose2.default)(props, $f1503dbb52e68089$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const controlRef = $f1503dbb52e68089$var$React.useRef(null);
    const triggerRef = $f1503dbb52e68089$var$React.useRef(null);
    const quickFilterValues = (0, $5sOMZ.useGridSelector)(apiRef, $0c64e77f4c442b27$exports.gridQuickFilterValuesSelector);
    const [value, setValue] = $f1503dbb52e68089$var$React.useState(formatter(quickFilterValues ?? []));
    const [internalExpanded, setInternalExpanded] = $f1503dbb52e68089$var$React.useState(defaultExpanded ?? value.length > 0);
    const expandedValue = expanded ?? internalExpanded;
    const state = $f1503dbb52e68089$var$React.useMemo(()=>({
            value: value,
            expanded: expandedValue
        }), [
        value,
        expandedValue
    ]);
    const resolvedClassName = typeof className === 'function' ? className(state) : className;
    const ref = $f1503dbb52e68089$var$React.useRef(null);
    const controlId = (0, $f1503dbb52e68089$var$_useId.default)();
    const handleExpandedChange = $f1503dbb52e68089$var$React.useCallback((newExpanded)=>{
        if (onExpandedChange) onExpandedChange(newExpanded);
        if (expanded === undefined) setInternalExpanded(newExpanded);
    }, [
        onExpandedChange,
        expanded
    ]);
    const prevQuickFilterValuesRef = $f1503dbb52e68089$var$React.useRef(quickFilterValues);
    $f1503dbb52e68089$var$React.useEffect(()=>{
        if (!(0, $a4d2c99ef8ba2460$exports.isDeepEqual)(prevQuickFilterValuesRef.current, quickFilterValues)) {
            // The model of quick filter value has been updated
            prevQuickFilterValuesRef.current = quickFilterValues;
            // Update the input value if needed to match the new model
            setValue((prevSearchValue)=>(0, $a4d2c99ef8ba2460$exports.isDeepEqual)(parser(prevSearchValue), quickFilterValues) ? prevSearchValue : formatter(quickFilterValues ?? []));
        }
    }, [
        quickFilterValues,
        formatter,
        parser
    ]);
    const isFirstRender = $f1503dbb52e68089$var$React.useRef(true);
    const previousExpandedValue = $f1503dbb52e68089$var$React.useRef(expandedValue);
    $f1503dbb52e68089$var$React.useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        // Ensure the expanded state has actually changed before focusing
        if (previousExpandedValue.current !== expandedValue) {
            if (expandedValue) // Ensures the focus does not interupt CSS transitions and animations on the control
            requestAnimationFrame(()=>{
                controlRef.current?.focus({
                    preventScroll: true
                });
            });
            else triggerRef.current?.focus({
                preventScroll: true
            });
            previousExpandedValue.current = expandedValue;
        }
    }, [
        expandedValue
    ]);
    const setQuickFilterValueDebounced = $f1503dbb52e68089$var$React.useMemo(()=>(0, $f1503dbb52e68089$var$_debounce.default)((newValue)=>{
            const newQuickFilterValues = parser(newValue);
            prevQuickFilterValuesRef.current = newQuickFilterValues;
            apiRef.current.setQuickFilterValues(newQuickFilterValues);
        }, debounceMs), [
        apiRef,
        debounceMs,
        parser
    ]);
    $f1503dbb52e68089$var$React.useEffect(()=>setQuickFilterValueDebounced.clear, [
        setQuickFilterValueDebounced
    ]);
    const handleValueChange = $f1503dbb52e68089$var$React.useCallback((event)=>{
        const newValue = event.target.value;
        setValue(newValue);
        setQuickFilterValueDebounced(newValue);
    }, [
        setQuickFilterValueDebounced
    ]);
    const handleClearValue = $f1503dbb52e68089$var$React.useCallback(()=>{
        setValue('');
        apiRef.current.setQuickFilterValues([]);
        controlRef.current?.focus();
    }, [
        apiRef,
        controlRef
    ]);
    const contextValue = $f1503dbb52e68089$var$React.useMemo(()=>({
            controlRef: controlRef,
            triggerRef: triggerRef,
            state: state,
            controlId: controlId,
            clearValue: handleClearValue,
            onValueChange: handleValueChange,
            onExpandedChange: handleExpandedChange
        }), [
        controlId,
        state,
        handleValueChange,
        handleClearValue,
        handleExpandedChange
    ]);
    (0, $f1503dbb52e68089$var$_useEnhancedEffect.default)(()=>{
        if (ref.current && triggerRef.current) ref.current.style.setProperty('--trigger-width', `${triggerRef.current?.offsetWidth}px`);
    }, []);
    const element = (0, $09dd6c7e82941da8$exports.useComponentRenderer)('div', render, (0, $f1503dbb52e68089$var$_extends2.default)({
        className: resolvedClassName
    }, other, {
        ref: ref
    }), state);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3d92e8977302638c$exports.QuickFilterContext.Provider, {
        value: contextValue,
        children: element
    });
}
$f1503dbb52e68089$var$QuickFilter.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * Override or extend the styles applied to the component.
   */ className: $f1503dbb52e68089$var$_propTypes.default.oneOfType([
        $f1503dbb52e68089$var$_propTypes.default.func,
        $f1503dbb52e68089$var$_propTypes.default.string
    ]),
    /**
   * The debounce time in milliseconds.
   * @default 150
   */ debounceMs: $f1503dbb52e68089$var$_propTypes.default.number,
    /**
   * The default expanded state of the quick filter control.
   * @default false
   */ defaultExpanded: $f1503dbb52e68089$var$_propTypes.default.bool,
    /**
   * The expanded state of the quick filter control.
   */ expanded: $f1503dbb52e68089$var$_propTypes.default.bool,
    /**
   * Function responsible for formatting values of quick filter in a string when the model is modified
   * @param {any[]} values The new values passed to the quick filter model
   * @returns {string} The string to display in the text field
   * @default (values: string[]) => values.join(' ')
   */ formatter: $f1503dbb52e68089$var$_propTypes.default.func,
    /**
   * Callback function that is called when the quick filter input is expanded or collapsed.
   * @param {boolean} expanded The new expanded state of the quick filter control
   */ onExpandedChange: $f1503dbb52e68089$var$_propTypes.default.func,
    /**
   * Function responsible for parsing text input in an array of independent values for quick filtering.
   * @param {string} input The value entered by the user
   * @returns {any[]} The array of value on which quick filter is applied
   * @default (searchText: string) => searchText.split(' ').filter((word) => word !== '')
   */ parser: $f1503dbb52e68089$var$_propTypes.default.func,
    /**
   * A function to customize rendering of the component.
   */ render: $f1503dbb52e68089$var$_propTypes.default.oneOfType([
        $f1503dbb52e68089$var$_propTypes.default.element,
        $f1503dbb52e68089$var$_propTypes.default.func
    ])
};


Object.keys($f1503dbb52e68089$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $b480793493089ce5$exports && $b480793493089ce5$exports[key] === $f1503dbb52e68089$exports[key]) return;
    Object.defineProperty($b480793493089ce5$exports, key, {
        enumerable: true,
        get: function() {
            return $f1503dbb52e68089$exports[key];
        }
    });
});
var $b3790a443808d1d4$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $b3790a443808d1d4$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $b3790a443808d1d4$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($b3790a443808d1d4$exports, "__esModule", {
    value: true
});
$b3790a443808d1d4$exports.QuickFilterControl = void 0;

var $b3790a443808d1d4$var$_extends2 = $b3790a443808d1d4$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $b3790a443808d1d4$var$_objectWithoutPropertiesLoose2 = $b3790a443808d1d4$require$_interopRequireDefault((parcelRequire("c05no")));

var $b3790a443808d1d4$var$React = $b3790a443808d1d4$require$_interopRequireWildcard((parcelRequire("acw62")));

var $b3790a443808d1d4$var$_propTypes = $b3790a443808d1d4$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $b3790a443808d1d4$var$_useForkRef = $b3790a443808d1d4$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $fYxgT = parcelRequire("fYxgT");


var $jDpXp = parcelRequire("jDpXp");


var $ayMG0 = parcelRequire("ayMG0");
const $b3790a443808d1d4$var$_excluded = [
    "render",
    "className",
    "slotProps",
    "onKeyDown",
    "onChange"
];
/**
 * A component that takes user input and filters row data.
 * It renders the `baseTextField` slot.
 *
 * Demos:
 *
 * - [Quick Filter](https://mui.com/x/react-data-grid/components/quick-filter/)
 *
 * API:
 *
 * - [QuickFilterControl API](https://mui.com/x/api/data-grid/quick-filter-control/)
 */ const $b3790a443808d1d4$var$QuickFilterControl = $b3790a443808d1d4$exports.QuickFilterControl = (0, $fYxgT.forwardRef)(function QuickFilterControl(props, ref) {
    const { render: render, className: className, slotProps: slotProps, onKeyDown: onKeyDown, onChange: onChange } = props, other = (0, $b3790a443808d1d4$var$_objectWithoutPropertiesLoose2.default)(props, $b3790a443808d1d4$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const { state: state, controlId: controlId, controlRef: controlRef, onValueChange: onValueChange, onExpandedChange: onExpandedChange, clearValue: clearValue } = (0, $3d92e8977302638c$exports.useQuickFilterContext)();
    const resolvedClassName = typeof className === 'function' ? className(state) : className;
    const handleRef = (0, $b3790a443808d1d4$var$_useForkRef.default)(controlRef, ref);
    const handleKeyDown = (event)=>{
        if (event.key === 'Escape') {
            if (state.value === '') onExpandedChange(false);
            else clearValue();
        }
        onKeyDown?.(event);
    };
    const handleBlur = (event)=>{
        if (state.value === '') onExpandedChange(false);
        slotProps?.htmlInput?.onBlur?.(event);
    };
    const handleChange = (event)=>{
        if (!state.expanded) onExpandedChange(true);
        onValueChange(event);
        onChange?.(event);
    };
    const element = (0, $09dd6c7e82941da8$exports.useComponentRenderer)(rootProps.slots.baseTextField, render, (0, $b3790a443808d1d4$var$_extends2.default)({}, rootProps.slotProps?.baseTextField, {
        slotProps: (0, $b3790a443808d1d4$var$_extends2.default)({
            htmlInput: (0, $b3790a443808d1d4$var$_extends2.default)({
                role: 'searchbox',
                id: controlId,
                tabIndex: state.expanded ? undefined : -1
            }, slotProps?.htmlInput, {
                onBlur: handleBlur
            })
        }, slotProps),
        value: state.value,
        className: resolvedClassName
    }, other, {
        onChange: handleChange,
        onKeyDown: handleKeyDown,
        ref: handleRef
    }), state);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($b3790a443808d1d4$var$React.Fragment, {
        children: element
    });
});
$b3790a443808d1d4$var$QuickFilterControl.displayName = "QuickFilterControl";
$b3790a443808d1d4$var$QuickFilterControl.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    autoComplete: $b3790a443808d1d4$var$_propTypes.default.string,
    autoFocus: $b3790a443808d1d4$var$_propTypes.default.bool,
    /**
   * Override or extend the styles applied to the component.
   */ className: $b3790a443808d1d4$var$_propTypes.default.oneOfType([
        $b3790a443808d1d4$var$_propTypes.default.func,
        $b3790a443808d1d4$var$_propTypes.default.string
    ]),
    color: $b3790a443808d1d4$var$_propTypes.default.oneOf([
        'error',
        'primary'
    ]),
    disabled: $b3790a443808d1d4$var$_propTypes.default.bool,
    error: $b3790a443808d1d4$var$_propTypes.default.bool,
    fullWidth: $b3790a443808d1d4$var$_propTypes.default.bool,
    helperText: $b3790a443808d1d4$var$_propTypes.default.string,
    id: $b3790a443808d1d4$var$_propTypes.default.string,
    inputRef: $b3790a443808d1d4$var$_propTypes.default.oneOfType([
        $b3790a443808d1d4$var$_propTypes.default.func,
        $b3790a443808d1d4$var$_propTypes.default.shape({
            current: $b3790a443808d1d4$var$_propTypes.default.object
        })
    ]),
    label: $b3790a443808d1d4$var$_propTypes.default.node,
    multiline: $b3790a443808d1d4$var$_propTypes.default.bool,
    placeholder: $b3790a443808d1d4$var$_propTypes.default.string,
    /**
   * A function to customize rendering of the component.
   */ render: $b3790a443808d1d4$var$_propTypes.default.oneOfType([
        $b3790a443808d1d4$var$_propTypes.default.element,
        $b3790a443808d1d4$var$_propTypes.default.func
    ]),
    role: $b3790a443808d1d4$var$_propTypes.default.string,
    size: $b3790a443808d1d4$var$_propTypes.default.oneOf([
        'medium',
        'small'
    ]),
    slotProps: $b3790a443808d1d4$var$_propTypes.default.object,
    style: $b3790a443808d1d4$var$_propTypes.default.object,
    tabIndex: $b3790a443808d1d4$var$_propTypes.default.number,
    type: $b3790a443808d1d4$var$_propTypes.default.string,
    value: $b3790a443808d1d4$var$_propTypes.default.string
};


Object.keys($b3790a443808d1d4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $b480793493089ce5$exports && $b480793493089ce5$exports[key] === $b3790a443808d1d4$exports[key]) return;
    Object.defineProperty($b480793493089ce5$exports, key, {
        enumerable: true,
        get: function() {
            return $b3790a443808d1d4$exports[key];
        }
    });
});
var $4af2368034d886c8$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $4af2368034d886c8$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $4af2368034d886c8$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($4af2368034d886c8$exports, "__esModule", {
    value: true
});
$4af2368034d886c8$exports.QuickFilterClear = void 0;

var $4af2368034d886c8$var$_extends2 = $4af2368034d886c8$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $4af2368034d886c8$var$_objectWithoutPropertiesLoose2 = $4af2368034d886c8$require$_interopRequireDefault((parcelRequire("c05no")));

var $4af2368034d886c8$var$React = $4af2368034d886c8$require$_interopRequireWildcard((parcelRequire("acw62")));

var $4af2368034d886c8$var$_propTypes = $4af2368034d886c8$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $fYxgT = parcelRequire("fYxgT");


var $jDpXp = parcelRequire("jDpXp");


var $ayMG0 = parcelRequire("ayMG0");
const $4af2368034d886c8$var$_excluded = [
    "render",
    "className",
    "onClick"
];
/**
 * A button that resets the filter value.
 * It renders the `baseIconButton` slot.
 *
 * Demos:
 *
 * - [Quick Filter](https://mui.com/x/react-data-grid/components/quick-filter/)
 *
 * API:
 *
 * - [QuickFilterClear API](https://mui.com/x/api/data-grid/quick-filter-clear/)
 */ const $4af2368034d886c8$var$QuickFilterClear = $4af2368034d886c8$exports.QuickFilterClear = (0, $fYxgT.forwardRef)(function QuickFilterClear(props, ref) {
    const { render: render, className: className, onClick: onClick } = props, other = (0, $4af2368034d886c8$var$_objectWithoutPropertiesLoose2.default)(props, $4af2368034d886c8$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const { state: state, clearValue: clearValue } = (0, $3d92e8977302638c$exports.useQuickFilterContext)();
    const resolvedClassName = typeof className === 'function' ? className(state) : className;
    const handleClick = (event)=>{
        clearValue();
        onClick?.(event);
    };
    const element = (0, $09dd6c7e82941da8$exports.useComponentRenderer)(rootProps.slots.baseIconButton, render, (0, $4af2368034d886c8$var$_extends2.default)({}, rootProps.slotProps?.baseIconButton, {
        className: resolvedClassName,
        tabIndex: -1
    }, other, {
        onClick: handleClick,
        ref: ref
    }), state);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($4af2368034d886c8$var$React.Fragment, {
        children: element
    });
});
$4af2368034d886c8$var$QuickFilterClear.displayName = "QuickFilterClear";
$4af2368034d886c8$var$QuickFilterClear.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * Override or extend the styles applied to the component.
   */ className: $4af2368034d886c8$var$_propTypes.default.oneOfType([
        $4af2368034d886c8$var$_propTypes.default.func,
        $4af2368034d886c8$var$_propTypes.default.string
    ]),
    color: $4af2368034d886c8$var$_propTypes.default.oneOf([
        'default',
        'inherit',
        'primary'
    ]),
    disabled: $4af2368034d886c8$var$_propTypes.default.bool,
    edge: $4af2368034d886c8$var$_propTypes.default.oneOf([
        'end',
        'start',
        false
    ]),
    id: $4af2368034d886c8$var$_propTypes.default.string,
    label: $4af2368034d886c8$var$_propTypes.default.string,
    /**
   * A function to customize rendering of the component.
   */ render: $4af2368034d886c8$var$_propTypes.default.oneOfType([
        $4af2368034d886c8$var$_propTypes.default.element,
        $4af2368034d886c8$var$_propTypes.default.func
    ]),
    role: $4af2368034d886c8$var$_propTypes.default.string,
    size: $4af2368034d886c8$var$_propTypes.default.oneOf([
        'large',
        'medium',
        'small'
    ]),
    style: $4af2368034d886c8$var$_propTypes.default.object,
    tabIndex: $4af2368034d886c8$var$_propTypes.default.number,
    title: $4af2368034d886c8$var$_propTypes.default.string,
    touchRippleRef: $4af2368034d886c8$var$_propTypes.default.any
};


Object.keys($4af2368034d886c8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $b480793493089ce5$exports && $b480793493089ce5$exports[key] === $4af2368034d886c8$exports[key]) return;
    Object.defineProperty($b480793493089ce5$exports, key, {
        enumerable: true,
        get: function() {
            return $4af2368034d886c8$exports[key];
        }
    });
});
var $c369a7865021bd20$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c369a7865021bd20$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $c369a7865021bd20$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($c369a7865021bd20$exports, "__esModule", {
    value: true
});
$c369a7865021bd20$exports.QuickFilterTrigger = void 0;

var $c369a7865021bd20$var$_extends2 = $c369a7865021bd20$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $c369a7865021bd20$var$_objectWithoutPropertiesLoose2 = $c369a7865021bd20$require$_interopRequireDefault((parcelRequire("c05no")));

var $c369a7865021bd20$var$React = $c369a7865021bd20$require$_interopRequireWildcard((parcelRequire("acw62")));

var $c369a7865021bd20$var$_propTypes = $c369a7865021bd20$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $fYxgT = parcelRequire("fYxgT");


var $c369a7865021bd20$var$_useForkRef = $c369a7865021bd20$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $jDpXp = parcelRequire("jDpXp");


var $ayMG0 = parcelRequire("ayMG0");
const $c369a7865021bd20$var$_excluded = [
    "render",
    "className",
    "onClick"
];
/**
 * A button that expands/collapses the quick filter.
 * It renders the `baseButton` slot.
 *
 * Demos:
 *
 * - [Quick Filter](https://mui.com/x/react-data-grid/components/quick-filter/)
 *
 * API:
 *
 * - [QuickFilterTrigger API](https://mui.com/x/api/data-grid/quick-filter-trigger/)
 */ const $c369a7865021bd20$var$QuickFilterTrigger = $c369a7865021bd20$exports.QuickFilterTrigger = (0, $fYxgT.forwardRef)(function QuickFilterTrigger(props, ref) {
    const { render: render, className: className, onClick: onClick } = props, other = (0, $c369a7865021bd20$var$_objectWithoutPropertiesLoose2.default)(props, $c369a7865021bd20$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const { state: state, controlId: controlId, onExpandedChange: onExpandedChange, triggerRef: triggerRef } = (0, $3d92e8977302638c$exports.useQuickFilterContext)();
    const resolvedClassName = typeof className === 'function' ? className(state) : className;
    const handleRef = (0, $c369a7865021bd20$var$_useForkRef.default)(triggerRef, ref);
    const handleClick = (event)=>{
        onExpandedChange(!state.expanded);
        onClick?.(event);
    };
    const element = (0, $09dd6c7e82941da8$exports.useComponentRenderer)(rootProps.slots.baseButton, render, (0, $c369a7865021bd20$var$_extends2.default)({}, rootProps.slotProps?.baseButton, {
        className: resolvedClassName,
        'aria-controls': controlId,
        'aria-expanded': state.expanded
    }, other, {
        onClick: handleClick,
        ref: handleRef
    }), state);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($c369a7865021bd20$var$React.Fragment, {
        children: element
    });
});
$c369a7865021bd20$var$QuickFilterTrigger.displayName = "QuickFilterTrigger";
$c369a7865021bd20$var$QuickFilterTrigger.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * Override or extend the styles applied to the component.
   */ className: $c369a7865021bd20$var$_propTypes.default.oneOfType([
        $c369a7865021bd20$var$_propTypes.default.func,
        $c369a7865021bd20$var$_propTypes.default.string
    ]),
    disabled: $c369a7865021bd20$var$_propTypes.default.bool,
    id: $c369a7865021bd20$var$_propTypes.default.string,
    /**
   * A function to customize rendering of the component.
   */ render: $c369a7865021bd20$var$_propTypes.default.oneOfType([
        $c369a7865021bd20$var$_propTypes.default.element,
        $c369a7865021bd20$var$_propTypes.default.func
    ]),
    role: $c369a7865021bd20$var$_propTypes.default.string,
    size: $c369a7865021bd20$var$_propTypes.default.oneOf([
        'large',
        'medium',
        'small'
    ]),
    startIcon: $c369a7865021bd20$var$_propTypes.default.node,
    style: $c369a7865021bd20$var$_propTypes.default.object,
    tabIndex: $c369a7865021bd20$var$_propTypes.default.number,
    title: $c369a7865021bd20$var$_propTypes.default.string,
    touchRippleRef: $c369a7865021bd20$var$_propTypes.default.any
};


Object.keys($c369a7865021bd20$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $b480793493089ce5$exports && $b480793493089ce5$exports[key] === $c369a7865021bd20$exports[key]) return;
    Object.defineProperty($b480793493089ce5$exports, key, {
        enumerable: true,
        get: function() {
            return $c369a7865021bd20$exports[key];
        }
    });
});




var $hbuUJ = parcelRequire("hbuUJ");

var $ayMG0 = parcelRequire("ayMG0");
const $0f88284c0023fb16$var$_excluded = [
    "quickFilterParser",
    "quickFilterFormatter",
    "debounceMs",
    "className",
    "slotProps"
], $0f88284c0023fb16$var$_excluded2 = [
    "ref",
    "slotProps"
];
const $0f88284c0023fb16$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'toolbarQuickFilter'
        ],
        trigger: [
            'toolbarQuickFilterTrigger'
        ],
        control: [
            'toolbarQuickFilterControl'
        ]
    };
    return (0, $0f88284c0023fb16$var$_composeClasses.default)(slots, $553c2bbb14fa5500$exports.getDataGridUtilityClass, classes);
};
const $0f88284c0023fb16$var$GridQuickFilterRoot = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'ToolbarQuickFilter'
})({
    display: 'grid',
    alignItems: 'center'
});
const $0f88284c0023fb16$var$GridQuickFilterTrigger = (0, $izOUK.styled)($4aec1101d1789fa4$exports.ToolbarButton, {
    name: 'MuiDataGrid',
    slot: 'ToolbarQuickFilterTrigger'
})(({ ownerState: ownerState })=>({
        gridArea: '1 / 1',
        width: 'min-content',
        height: 'min-content',
        zIndex: 1,
        opacity: ownerState.expanded ? 0 : 1,
        pointerEvents: ownerState.expanded ? 'none' : 'auto',
        transition: $hbuUJ.vars.transition([
            'opacity'
        ])
    }));
// TODO: Use NotRendered from /utils/assert
// Currently causes react-docgen to fail
const $0f88284c0023fb16$var$GridQuickFilterTextField = (0, $izOUK.styled)((_props)=>{
    throw new Error('Failed assertion: should not be rendered');
}, {
    name: 'MuiDataGrid',
    slot: 'ToolbarQuickFilterControl'
})(({ ownerState: ownerState })=>({
        gridArea: '1 / 1',
        overflowX: 'clip',
        width: ownerState.expanded ? 260 : 'var(--trigger-width)',
        opacity: ownerState.expanded ? 1 : 0,
        transition: $hbuUJ.vars.transition([
            'width',
            'opacity'
        ])
    }));
/**
 * @deprecated Use the {@link https://mui.com/x/react-data-grid/components/quick-filter/ Quick Filter} component instead. This component will be removed in a future major release.
 */ function $0f88284c0023fb16$var$GridToolbarQuickFilter(props) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = {
        classes: rootProps.classes,
        expanded: false
    };
    const classes = $0f88284c0023fb16$var$useUtilityClasses(ownerState);
    const { quickFilterParser: quickFilterParser, quickFilterFormatter: quickFilterFormatter, debounceMs: debounceMs, className: className, slotProps: slotProps } = props, other = (0, $0f88284c0023fb16$var$_objectWithoutPropertiesLoose2.default)(props, $0f88284c0023fb16$var$_excluded);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($b480793493089ce5$exports.QuickFilter, {
        parser: quickFilterParser,
        formatter: quickFilterFormatter,
        debounceMs: debounceMs,
        render: (quickFilterProps, state)=>{
            const currentOwnerState = (0, $0f88284c0023fb16$var$_extends2.default)({}, ownerState, {
                expanded: state.expanded
            });
            return /*#__PURE__*/ (0, $ayMG0.jsxs)($0f88284c0023fb16$var$GridQuickFilterRoot, (0, $0f88284c0023fb16$var$_extends2.default)({}, quickFilterProps, {
                className: (0, $0f88284c0023fb16$var$_clsx.default)(classes.root, className),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($b480793493089ce5$exports.QuickFilterTrigger, {
                        render: (triggerProps)=>/*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTooltip, {
                                title: apiRef.current.getLocaleText('toolbarQuickFilterLabel'),
                                enterDelay: 0 // Prevents tooltip lagging behind transitioning trigger element
                                ,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($0f88284c0023fb16$var$GridQuickFilterTrigger, (0, $0f88284c0023fb16$var$_extends2.default)({
                                    className: classes.trigger
                                }, triggerProps, {
                                    ownerState: currentOwnerState,
                                    color: "default",
                                    "aria-disabled": state.expanded,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.quickFilterIcon, {
                                        fontSize: "small"
                                    })
                                }))
                            })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($b480793493089ce5$exports.QuickFilterControl, {
                        render: (_ref)=>{
                            let { ref: ref, slotProps: controlSlotProps } = _ref, controlProps = (0, $0f88284c0023fb16$var$_objectWithoutPropertiesLoose2.default)(_ref, $0f88284c0023fb16$var$_excluded2);
                            return /*#__PURE__*/ (0, $ayMG0.jsx)($0f88284c0023fb16$var$GridQuickFilterTextField, (0, $0f88284c0023fb16$var$_extends2.default)({
                                as: rootProps.slots.baseTextField,
                                className: classes.control,
                                ownerState: currentOwnerState,
                                inputRef: ref,
                                "aria-label": apiRef.current.getLocaleText('toolbarQuickFilterLabel'),
                                placeholder: apiRef.current.getLocaleText('toolbarQuickFilterPlaceholder'),
                                size: "small",
                                slotProps: (0, $0f88284c0023fb16$var$_extends2.default)({
                                    input: (0, $0f88284c0023fb16$var$_extends2.default)({
                                        startAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.quickFilterIcon, {
                                            fontSize: "small"
                                        }),
                                        endAdornment: controlProps.value ? /*#__PURE__*/ (0, $ayMG0.jsx)($b480793493089ce5$exports.QuickFilterClear, {
                                            render: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseIconButton, {
                                                size: "small",
                                                edge: "end",
                                                "aria-label": apiRef.current.getLocaleText('toolbarQuickFilterDeleteIconLabel'),
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.quickFilterClearIcon, {
                                                    fontSize: "small"
                                                })
                                            })
                                        }) : null
                                    }, controlSlotProps?.input)
                                }, controlSlotProps)
                            }, rootProps.slotProps?.baseTextField, controlProps, slotProps?.root, other));
                        }
                    })
                ]
            }));
        }
    });
}
$0f88284c0023fb16$var$GridToolbarQuickFilter.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    className: $0f88284c0023fb16$var$_propTypes.default.string,
    /**
   * The debounce time in milliseconds.
   * @default 150
   */ debounceMs: $0f88284c0023fb16$var$_propTypes.default.number,
    /**
   * Function responsible for formatting values of quick filter in a string when the model is modified
   * @param {any[]} values The new values passed to the quick filter model
   * @returns {string} The string to display in the text field
   * @default (values: string[]) => values.join(' ')
   */ quickFilterFormatter: $0f88284c0023fb16$var$_propTypes.default.func,
    /**
   * Function responsible for parsing text input in an array of independent values for quick filtering.
   * @param {string} input The value entered by the user
   * @returns {any[]} The array of value on which quick filter is applied
   * @default (searchText: string) => searchText
   *   .split(' ')
   *   .filter((word) => word !== '')
   */ quickFilterParser: $0f88284c0023fb16$var$_propTypes.default.func,
    slotProps: $0f88284c0023fb16$var$_propTypes.default.object
}; /**
 * Demos:
 * - [Filtering - overview](https://mui.com/x/react-data-grid/filtering/)
 * - [Filtering - quick filter](https://mui.com/x/react-data-grid/filtering/quick-filter/)
 *
 * API:
 * - [GridToolbarQuickFilter API](https://mui.com/x/api/data-grid/grid-toolbar-quick-filter/)
 */ 


var $a162346a6ee1b52f$exports = {};
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $a162346a6ee1b52f$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $a162346a6ee1b52f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($a162346a6ee1b52f$exports, "__esModule", {
    value: true
});
$a162346a6ee1b52f$exports.GridToolbar = $a162346a6ee1b52f$var$GridToolbar;
$a162346a6ee1b52f$exports.GridToolbarDivider = $a162346a6ee1b52f$var$GridToolbarDivider;
$a162346a6ee1b52f$exports.GridToolbarLabel = $a162346a6ee1b52f$var$GridToolbarLabel;

var $a162346a6ee1b52f$var$_extends2 = $a162346a6ee1b52f$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $a162346a6ee1b52f$var$_objectWithoutPropertiesLoose2 = $a162346a6ee1b52f$require$_interopRequireDefault((parcelRequire("c05no")));

var $a162346a6ee1b52f$var$React = $a162346a6ee1b52f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $a162346a6ee1b52f$var$_propTypes = $a162346a6ee1b52f$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $a162346a6ee1b52f$var$_useId = $a162346a6ee1b52f$require$_interopRequireDefault((parcelRequire("hwliF")));

var $izOUK = parcelRequire("izOUK");

var $a162346a6ee1b52f$var$_composeClasses = $a162346a6ee1b52f$require$_interopRequireDefault((parcelRequire("3Hg1x")));



var $9f39e34235240409$exports = {};
"use strict";
Object.defineProperty($9f39e34235240409$exports, "__esModule", {
    value: true
});
var $58a161c9a8edc0d0$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $58a161c9a8edc0d0$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $58a161c9a8edc0d0$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($58a161c9a8edc0d0$exports, "__esModule", {
    value: true
});
$58a161c9a8edc0d0$exports.FilterPanelTrigger = void 0;

var $58a161c9a8edc0d0$var$_extends2 = $58a161c9a8edc0d0$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $58a161c9a8edc0d0$var$_objectWithoutPropertiesLoose2 = $58a161c9a8edc0d0$require$_interopRequireDefault((parcelRequire("c05no")));

var $58a161c9a8edc0d0$var$React = $58a161c9a8edc0d0$require$_interopRequireWildcard((parcelRequire("acw62")));

var $58a161c9a8edc0d0$var$_propTypes = $58a161c9a8edc0d0$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $58a161c9a8edc0d0$var$_useId = $58a161c9a8edc0d0$require$_interopRequireDefault((parcelRequire("hwliF")));

var $fYxgT = parcelRequire("fYxgT");


var $58a161c9a8edc0d0$var$_useForkRef = $58a161c9a8edc0d0$require$_interopRequireDefault((parcelRequire("e4pKA")));


var $bDyDY = parcelRequire("bDyDY");


var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $58a161c9a8edc0d0$var$_excluded = [
    "render",
    "className",
    "onClick",
    "onPointerUp"
];
/**
 * A button that opens and closes the filter panel.
 * It renders the `baseButton` slot.
 *
 * Demos:
 *
 * - [Filter Panel](https://mui.com/x/react-data-grid/components/filter-panel/)
 *
 * API:
 *
 * - [FilterPanelTrigger API](https://mui.com/x/api/data-grid/filter-panel-trigger/)
 */ const $58a161c9a8edc0d0$var$FilterPanelTrigger = $58a161c9a8edc0d0$exports.FilterPanelTrigger = (0, $fYxgT.forwardRef)(function FilterPanelTrigger(props, ref) {
    const { render: render, className: className, onClick: onClick, onPointerUp: onPointerUp } = props, other = (0, $58a161c9a8edc0d0$var$_objectWithoutPropertiesLoose2.default)(props, $58a161c9a8edc0d0$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const buttonId = (0, $58a161c9a8edc0d0$var$_useId.default)();
    const panelId = (0, $58a161c9a8edc0d0$var$_useId.default)();
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const panelState = (0, $d8761d1e377450f5$exports.useGridSelector)(apiRef, $d8761d1e377450f5$exports.gridPreferencePanelStateSelector);
    const open = panelState.open && panelState.openedPanelValue === $d8761d1e377450f5$exports.GridPreferencePanelsValue.filters;
    const activeFilters = (0, $d8761d1e377450f5$exports.useGridSelector)(apiRef, $d8761d1e377450f5$exports.gridFilterActiveItemsSelector);
    const filterCount = activeFilters.length;
    const state = {
        open: open,
        filterCount: filterCount
    };
    const resolvedClassName = typeof className === 'function' ? className(state) : className;
    const { filterPanelTriggerRef: filterPanelTriggerRef } = (0, $546bc72d2cea638d$exports.useGridPanelContext)();
    const handleRef = (0, $58a161c9a8edc0d0$var$_useForkRef.default)(ref, filterPanelTriggerRef);
    const handleClick = (event)=>{
        if (open) apiRef.current.hidePreferences();
        else apiRef.current.showPreferences($d8761d1e377450f5$exports.GridPreferencePanelsValue.filters, panelId, buttonId);
        onClick?.(event);
    };
    const handlePointerUp = (event)=>{
        if (open) event.stopPropagation();
        onPointerUp?.(event);
    };
    const element = (0, $09dd6c7e82941da8$exports.useComponentRenderer)(rootProps.slots.baseButton, render, (0, $58a161c9a8edc0d0$var$_extends2.default)({}, rootProps.slotProps?.baseButton, {
        id: buttonId,
        'aria-haspopup': 'true',
        'aria-expanded': open ? 'true' : undefined,
        'aria-controls': open ? panelId : undefined,
        onClick: handleClick,
        onPointerUp: handlePointerUp,
        className: resolvedClassName
    }, other, {
        ref: handleRef
    }), state);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($58a161c9a8edc0d0$var$React.Fragment, {
        children: element
    });
});
$58a161c9a8edc0d0$var$FilterPanelTrigger.displayName = "FilterPanelTrigger";
$58a161c9a8edc0d0$var$FilterPanelTrigger.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * A function to customize rendering of the component.
   */ className: $58a161c9a8edc0d0$var$_propTypes.default.oneOfType([
        $58a161c9a8edc0d0$var$_propTypes.default.func,
        $58a161c9a8edc0d0$var$_propTypes.default.string
    ]),
    disabled: $58a161c9a8edc0d0$var$_propTypes.default.bool,
    id: $58a161c9a8edc0d0$var$_propTypes.default.string,
    /**
   * A function to customize rendering of the component.
   */ render: $58a161c9a8edc0d0$var$_propTypes.default.oneOfType([
        $58a161c9a8edc0d0$var$_propTypes.default.element,
        $58a161c9a8edc0d0$var$_propTypes.default.func
    ]),
    role: $58a161c9a8edc0d0$var$_propTypes.default.string,
    size: $58a161c9a8edc0d0$var$_propTypes.default.oneOf([
        'large',
        'medium',
        'small'
    ]),
    startIcon: $58a161c9a8edc0d0$var$_propTypes.default.node,
    style: $58a161c9a8edc0d0$var$_propTypes.default.object,
    tabIndex: $58a161c9a8edc0d0$var$_propTypes.default.number,
    title: $58a161c9a8edc0d0$var$_propTypes.default.string,
    touchRippleRef: $58a161c9a8edc0d0$var$_propTypes.default.any
};


Object.keys($58a161c9a8edc0d0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $9f39e34235240409$exports && $9f39e34235240409$exports[key] === $58a161c9a8edc0d0$exports[key]) return;
    Object.defineProperty($9f39e34235240409$exports, key, {
        enumerable: true,
        get: function() {
            return $58a161c9a8edc0d0$exports[key];
        }
    });
});


var $f2fd14510a79bbd4$exports = {};
"use strict";
Object.defineProperty($f2fd14510a79bbd4$exports, "__esModule", {
    value: true
});
var $331fa5ea82256f21$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $331fa5ea82256f21$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $331fa5ea82256f21$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($331fa5ea82256f21$exports, "__esModule", {
    value: true
});
$331fa5ea82256f21$exports.ColumnsPanelTrigger = void 0;

var $331fa5ea82256f21$var$_extends2 = $331fa5ea82256f21$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $331fa5ea82256f21$var$_objectWithoutPropertiesLoose2 = $331fa5ea82256f21$require$_interopRequireDefault((parcelRequire("c05no")));

var $331fa5ea82256f21$var$React = $331fa5ea82256f21$require$_interopRequireWildcard((parcelRequire("acw62")));

var $331fa5ea82256f21$var$_propTypes = $331fa5ea82256f21$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $331fa5ea82256f21$var$_useId = $331fa5ea82256f21$require$_interopRequireDefault((parcelRequire("hwliF")));

var $fYxgT = parcelRequire("fYxgT");

var $331fa5ea82256f21$var$_useForkRef = $331fa5ea82256f21$require$_interopRequireDefault((parcelRequire("e4pKA")));



var $bDyDY = parcelRequire("bDyDY");


var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $331fa5ea82256f21$var$_excluded = [
    "render",
    "className",
    "onClick",
    "onPointerUp"
];
/**
 * A button that opens and closes the columns panel.
 * It renders the `baseButton` slot.
 *
 * Demos:
 *
 * - [Columns Panel](https://mui.com/x/react-data-grid/components/columns-panel/)
 *
 * API:
 *
 * - [ColumnsPanelTrigger API](https://mui.com/x/api/data-grid/columns-panel-trigger/)
 */ const $331fa5ea82256f21$var$ColumnsPanelTrigger = $331fa5ea82256f21$exports.ColumnsPanelTrigger = (0, $fYxgT.forwardRef)(function ColumnsPanelTrigger(props, ref) {
    const { render: render, className: className, onClick: onClick, onPointerUp: onPointerUp } = props, other = (0, $331fa5ea82256f21$var$_objectWithoutPropertiesLoose2.default)(props, $331fa5ea82256f21$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const buttonId = (0, $331fa5ea82256f21$var$_useId.default)();
    const panelId = (0, $331fa5ea82256f21$var$_useId.default)();
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const panelState = (0, $d8761d1e377450f5$exports.useGridSelector)(apiRef, $d8761d1e377450f5$exports.gridPreferencePanelStateSelector);
    const open = panelState.open && panelState.openedPanelValue === $d8761d1e377450f5$exports.GridPreferencePanelsValue.columns;
    const state = {
        open: open
    };
    const resolvedClassName = typeof className === 'function' ? className(state) : className;
    const { columnsPanelTriggerRef: columnsPanelTriggerRef } = (0, $546bc72d2cea638d$exports.useGridPanelContext)();
    const handleRef = (0, $331fa5ea82256f21$var$_useForkRef.default)(ref, columnsPanelTriggerRef);
    const handleClick = (event)=>{
        if (open) apiRef.current.hidePreferences();
        else apiRef.current.showPreferences($d8761d1e377450f5$exports.GridPreferencePanelsValue.columns, panelId, buttonId);
        onClick?.(event);
    };
    const handlePointerUp = (event)=>{
        if (open) event.stopPropagation();
        onPointerUp?.(event);
    };
    const element = (0, $09dd6c7e82941da8$exports.useComponentRenderer)(rootProps.slots.baseButton, render, (0, $331fa5ea82256f21$var$_extends2.default)({}, rootProps.slotProps?.baseButton, {
        id: buttonId,
        'aria-haspopup': 'true',
        'aria-expanded': open ? 'true' : undefined,
        'aria-controls': open ? panelId : undefined,
        className: resolvedClassName
    }, other, {
        onPointerUp: handlePointerUp,
        onClick: handleClick,
        ref: handleRef
    }), state);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($331fa5ea82256f21$var$React.Fragment, {
        children: element
    });
});
$331fa5ea82256f21$var$ColumnsPanelTrigger.displayName = "ColumnsPanelTrigger";
$331fa5ea82256f21$var$ColumnsPanelTrigger.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * Override or extend the styles applied to the component.
   */ className: $331fa5ea82256f21$var$_propTypes.default.oneOfType([
        $331fa5ea82256f21$var$_propTypes.default.func,
        $331fa5ea82256f21$var$_propTypes.default.string
    ]),
    disabled: $331fa5ea82256f21$var$_propTypes.default.bool,
    id: $331fa5ea82256f21$var$_propTypes.default.string,
    /**
   * A function to customize rendering of the component.
   */ render: $331fa5ea82256f21$var$_propTypes.default.oneOfType([
        $331fa5ea82256f21$var$_propTypes.default.element,
        $331fa5ea82256f21$var$_propTypes.default.func
    ]),
    role: $331fa5ea82256f21$var$_propTypes.default.string,
    size: $331fa5ea82256f21$var$_propTypes.default.oneOf([
        'large',
        'medium',
        'small'
    ]),
    startIcon: $331fa5ea82256f21$var$_propTypes.default.node,
    style: $331fa5ea82256f21$var$_propTypes.default.object,
    tabIndex: $331fa5ea82256f21$var$_propTypes.default.number,
    title: $331fa5ea82256f21$var$_propTypes.default.string,
    touchRippleRef: $331fa5ea82256f21$var$_propTypes.default.any
};


Object.keys($331fa5ea82256f21$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $f2fd14510a79bbd4$exports && $f2fd14510a79bbd4$exports[key] === $331fa5ea82256f21$exports[key]) return;
    Object.defineProperty($f2fd14510a79bbd4$exports, key, {
        enumerable: true,
        get: function() {
            return $331fa5ea82256f21$exports[key];
        }
    });
});


var $c43d0959e479160d$exports = {};
"use strict";
Object.defineProperty($c43d0959e479160d$exports, "__esModule", {
    value: true
});
var $46c696c5f6e02a46$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $46c696c5f6e02a46$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $46c696c5f6e02a46$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($46c696c5f6e02a46$exports, "__esModule", {
    value: true
});
$46c696c5f6e02a46$exports.ExportCsv = void 0;

var $46c696c5f6e02a46$var$_extends2 = $46c696c5f6e02a46$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $46c696c5f6e02a46$var$_objectWithoutPropertiesLoose2 = $46c696c5f6e02a46$require$_interopRequireDefault((parcelRequire("c05no")));

var $46c696c5f6e02a46$var$React = $46c696c5f6e02a46$require$_interopRequireWildcard((parcelRequire("acw62")));

var $46c696c5f6e02a46$var$_propTypes = $46c696c5f6e02a46$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $fYxgT = parcelRequire("fYxgT");


var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $46c696c5f6e02a46$var$_excluded = [
    "render",
    "options",
    "onClick"
];
/**
 * A button that triggers a CSV export.
 * It renders the `baseButton` slot.
 *
 * Demos:
 *
 * - [Export](https://mui.com/x/react-data-grid/components/export/)
 *
 * API:
 *
 * - [ExportCsv API](https://mui.com/x/api/data-grid/export-csv/)
 */ const $46c696c5f6e02a46$var$ExportCsv = $46c696c5f6e02a46$exports.ExportCsv = (0, $fYxgT.forwardRef)(function ExportCsv(props, ref) {
    const { render: render, options: options, onClick: onClick } = props, other = (0, $46c696c5f6e02a46$var$_objectWithoutPropertiesLoose2.default)(props, $46c696c5f6e02a46$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const handleClick = (event)=>{
        apiRef.current.exportDataAsCsv(options);
        onClick?.(event);
    };
    const element = (0, $09dd6c7e82941da8$exports.useComponentRenderer)(rootProps.slots.baseButton, render, (0, $46c696c5f6e02a46$var$_extends2.default)({}, rootProps.slotProps?.baseButton, {
        onClick: handleClick
    }, other, {
        ref: ref
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($46c696c5f6e02a46$var$React.Fragment, {
        children: element
    });
});
$46c696c5f6e02a46$var$ExportCsv.displayName = "ExportCsv";
$46c696c5f6e02a46$var$ExportCsv.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    className: $46c696c5f6e02a46$var$_propTypes.default.string,
    disabled: $46c696c5f6e02a46$var$_propTypes.default.bool,
    id: $46c696c5f6e02a46$var$_propTypes.default.string,
    /**
   * The options to apply on the CSV export.
   * @demos
   *   - [CSV export](/x/react-data-grid/export/#csv-export)
   */ options: $46c696c5f6e02a46$var$_propTypes.default.shape({
        allColumns: $46c696c5f6e02a46$var$_propTypes.default.bool,
        delimiter: $46c696c5f6e02a46$var$_propTypes.default.string,
        escapeFormulas: $46c696c5f6e02a46$var$_propTypes.default.bool,
        fields: $46c696c5f6e02a46$var$_propTypes.default.arrayOf($46c696c5f6e02a46$var$_propTypes.default.string),
        fileName: $46c696c5f6e02a46$var$_propTypes.default.string,
        getRowsToExport: $46c696c5f6e02a46$var$_propTypes.default.func,
        includeColumnGroupsHeaders: $46c696c5f6e02a46$var$_propTypes.default.bool,
        includeHeaders: $46c696c5f6e02a46$var$_propTypes.default.bool,
        shouldAppendQuotes: $46c696c5f6e02a46$var$_propTypes.default.bool,
        utf8WithBom: $46c696c5f6e02a46$var$_propTypes.default.bool
    }),
    /**
   * A function to customize rendering of the component.
   */ render: $46c696c5f6e02a46$var$_propTypes.default.oneOfType([
        $46c696c5f6e02a46$var$_propTypes.default.element,
        $46c696c5f6e02a46$var$_propTypes.default.func
    ]),
    role: $46c696c5f6e02a46$var$_propTypes.default.string,
    size: $46c696c5f6e02a46$var$_propTypes.default.oneOf([
        'large',
        'medium',
        'small'
    ]),
    startIcon: $46c696c5f6e02a46$var$_propTypes.default.node,
    style: $46c696c5f6e02a46$var$_propTypes.default.object,
    tabIndex: $46c696c5f6e02a46$var$_propTypes.default.number,
    title: $46c696c5f6e02a46$var$_propTypes.default.string,
    touchRippleRef: $46c696c5f6e02a46$var$_propTypes.default.any
};


Object.keys($46c696c5f6e02a46$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $c43d0959e479160d$exports && $c43d0959e479160d$exports[key] === $46c696c5f6e02a46$exports[key]) return;
    Object.defineProperty($c43d0959e479160d$exports, key, {
        enumerable: true,
        get: function() {
            return $46c696c5f6e02a46$exports[key];
        }
    });
});
var $ea21c527355822bd$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ea21c527355822bd$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $ea21c527355822bd$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($ea21c527355822bd$exports, "__esModule", {
    value: true
});
$ea21c527355822bd$exports.ExportPrint = void 0;

var $ea21c527355822bd$var$_extends2 = $ea21c527355822bd$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $ea21c527355822bd$var$_objectWithoutPropertiesLoose2 = $ea21c527355822bd$require$_interopRequireDefault((parcelRequire("c05no")));

var $ea21c527355822bd$var$React = $ea21c527355822bd$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ea21c527355822bd$var$_propTypes = $ea21c527355822bd$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $fYxgT = parcelRequire("fYxgT");


var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $ea21c527355822bd$var$_excluded = [
    "render",
    "options",
    "onClick"
];
/**
 * A button that triggers a print export.
 * It renders the `baseButton` slot.
 *
 * Demos:
 *
 * - [Export](https://mui.com/x/react-data-grid/components/export/)
 *
 * API:
 *
 * - [ExportPrint API](https://mui.com/x/api/data-grid/export-print/)
 */ const $ea21c527355822bd$var$ExportPrint = $ea21c527355822bd$exports.ExportPrint = (0, $fYxgT.forwardRef)(function ExportPrint(props, ref) {
    const { render: render, options: options, onClick: onClick } = props, other = (0, $ea21c527355822bd$var$_objectWithoutPropertiesLoose2.default)(props, $ea21c527355822bd$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const handleClick = (event)=>{
        apiRef.current.exportDataAsPrint(options);
        onClick?.(event);
    };
    const element = (0, $09dd6c7e82941da8$exports.useComponentRenderer)(rootProps.slots.baseButton, render, (0, $ea21c527355822bd$var$_extends2.default)({}, rootProps.slotProps?.baseButton, {
        onClick: handleClick
    }, other, {
        ref: ref
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ea21c527355822bd$var$React.Fragment, {
        children: element
    });
});
$ea21c527355822bd$var$ExportPrint.displayName = "ExportPrint";
$ea21c527355822bd$var$ExportPrint.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    className: $ea21c527355822bd$var$_propTypes.default.string,
    disabled: $ea21c527355822bd$var$_propTypes.default.bool,
    id: $ea21c527355822bd$var$_propTypes.default.string,
    /**
   * The options to apply on the Print export.
   * @demos
   *   - [Print export](/x/react-data-grid/export/#print-export)
   */ options: $ea21c527355822bd$var$_propTypes.default.shape({
        allColumns: $ea21c527355822bd$var$_propTypes.default.bool,
        bodyClassName: $ea21c527355822bd$var$_propTypes.default.string,
        copyStyles: $ea21c527355822bd$var$_propTypes.default.bool,
        fields: $ea21c527355822bd$var$_propTypes.default.arrayOf($ea21c527355822bd$var$_propTypes.default.string),
        fileName: $ea21c527355822bd$var$_propTypes.default.string,
        getRowsToExport: $ea21c527355822bd$var$_propTypes.default.func,
        hideFooter: $ea21c527355822bd$var$_propTypes.default.bool,
        hideToolbar: $ea21c527355822bd$var$_propTypes.default.bool,
        includeCheckboxes: $ea21c527355822bd$var$_propTypes.default.bool,
        pageStyle: $ea21c527355822bd$var$_propTypes.default.oneOfType([
            $ea21c527355822bd$var$_propTypes.default.func,
            $ea21c527355822bd$var$_propTypes.default.string
        ])
    }),
    /**
   * A function to customize rendering of the component.
   */ render: $ea21c527355822bd$var$_propTypes.default.oneOfType([
        $ea21c527355822bd$var$_propTypes.default.element,
        $ea21c527355822bd$var$_propTypes.default.func
    ]),
    role: $ea21c527355822bd$var$_propTypes.default.string,
    size: $ea21c527355822bd$var$_propTypes.default.oneOf([
        'large',
        'medium',
        'small'
    ]),
    startIcon: $ea21c527355822bd$var$_propTypes.default.node,
    style: $ea21c527355822bd$var$_propTypes.default.object,
    tabIndex: $ea21c527355822bd$var$_propTypes.default.number,
    title: $ea21c527355822bd$var$_propTypes.default.string,
    touchRippleRef: $ea21c527355822bd$var$_propTypes.default.any
};


Object.keys($ea21c527355822bd$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $c43d0959e479160d$exports && $c43d0959e479160d$exports[key] === $ea21c527355822bd$exports[key]) return;
    Object.defineProperty($c43d0959e479160d$exports, key, {
        enumerable: true,
        get: function() {
            return $ea21c527355822bd$exports[key];
        }
    });
});




var $jDpXp = parcelRequire("jDpXp");

var $bDyDY = parcelRequire("bDyDY");


var $hbuUJ = parcelRequire("hbuUJ");

var $5H1vo = parcelRequire("5H1vo");

var $ayMG0 = parcelRequire("ayMG0");
const $a162346a6ee1b52f$var$_excluded = [
    "className"
], $a162346a6ee1b52f$var$_excluded2 = [
    "className"
], $a162346a6ee1b52f$var$_excluded3 = [
    "showQuickFilter",
    "quickFilterProps",
    "csvOptions",
    "printOptions",
    "additionalItems",
    "additionalExportMenuItems"
];
const $a162346a6ee1b52f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        divider: [
            'toolbarDivider'
        ],
        label: [
            'toolbarLabel'
        ]
    };
    return (0, $a162346a6ee1b52f$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $a162346a6ee1b52f$var$Divider = (0, $izOUK.styled)($dd66ac2a2c256d30$exports.NotRendered, {
    name: 'MuiDataGrid',
    slot: 'ToolbarDivider'
})({
    height: '50%',
    margin: $hbuUJ.vars.spacing(0, 0.5)
});
const $a162346a6ee1b52f$var$Label = (0, $izOUK.styled)('span', {
    name: 'MuiDataGrid',
    slot: 'ToolbarLabel'
})({
    flex: 1,
    font: $hbuUJ.vars.typography.font.large,
    fontWeight: $hbuUJ.vars.typography.fontWeight.medium,
    margin: $hbuUJ.vars.spacing(0, 0.5),
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});
function $a162346a6ee1b52f$var$GridToolbarDivider(props) {
    const other = (0, $a162346a6ee1b52f$var$_objectWithoutPropertiesLoose2.default)(props, $a162346a6ee1b52f$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $a162346a6ee1b52f$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a162346a6ee1b52f$var$Divider, (0, $a162346a6ee1b52f$var$_extends2.default)({
        as: rootProps.slots.baseDivider,
        orientation: "vertical",
        className: classes.divider
    }, other));
}
$a162346a6ee1b52f$var$GridToolbarDivider.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    className: $a162346a6ee1b52f$var$_propTypes.default.string,
    orientation: $a162346a6ee1b52f$var$_propTypes.default.oneOf([
        'horizontal',
        'vertical'
    ])
};
function $a162346a6ee1b52f$var$GridToolbarLabel(props) {
    const other = (0, $a162346a6ee1b52f$var$_objectWithoutPropertiesLoose2.default)(props, $a162346a6ee1b52f$var$_excluded2);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $a162346a6ee1b52f$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a162346a6ee1b52f$var$Label, (0, $a162346a6ee1b52f$var$_extends2.default)({
        className: classes.label
    }, other));
}
function $a162346a6ee1b52f$var$GridToolbar(props) {
    const { showQuickFilter: showQuickFilter = true, quickFilterProps: quickFilterProps, csvOptions: csvOptions, printOptions: printOptions, additionalItems: additionalItems, additionalExportMenuItems: additionalExportMenuItems } = props, other = (0, $a162346a6ee1b52f$var$_objectWithoutPropertiesLoose2.default)(props, $a162346a6ee1b52f$var$_excluded3);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const [exportMenuOpen, setExportMenuOpen] = $a162346a6ee1b52f$var$React.useState(false);
    const exportMenuTriggerRef = $a162346a6ee1b52f$var$React.useRef(null);
    const exportMenuId = (0, $a162346a6ee1b52f$var$_useId.default)();
    const exportMenuTriggerId = (0, $a162346a6ee1b52f$var$_useId.default)();
    const showExportMenu = !csvOptions?.disableToolbarButton || !printOptions?.disableToolbarButton || additionalExportMenuItems;
    const closeExportMenu = ()=>setExportMenuOpen(false);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($d8c2e7e50975603c$exports.Toolbar, (0, $a162346a6ee1b52f$var$_extends2.default)({}, other, {
        children: [
            rootProps.label && /*#__PURE__*/ (0, $ayMG0.jsx)($a162346a6ee1b52f$var$GridToolbarLabel, {
                children: rootProps.label
            }),
            !rootProps.disableColumnSelector && /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTooltip, {
                title: apiRef.current.getLocaleText('toolbarColumns'),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($f2fd14510a79bbd4$exports.ColumnsPanelTrigger, {
                    render: /*#__PURE__*/ (0, $ayMG0.jsx)($4c3478cdd4144942$exports.ToolbarButton, {}),
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnSelectorIcon, {
                        fontSize: "small"
                    })
                })
            }),
            !rootProps.disableColumnFilter && /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTooltip, {
                title: apiRef.current.getLocaleText('toolbarFilters'),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($9f39e34235240409$exports.FilterPanelTrigger, {
                    render: (triggerProps, state)=>/*#__PURE__*/ (0, $ayMG0.jsx)($4c3478cdd4144942$exports.ToolbarButton, (0, $a162346a6ee1b52f$var$_extends2.default)({}, triggerProps, {
                            color: state.filterCount > 0 ? 'primary' : 'default',
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseBadge, {
                                badgeContent: state.filterCount,
                                color: "primary",
                                variant: "dot",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.openFilterButtonIcon, {
                                    fontSize: "small"
                                })
                            })
                        }))
                })
            }),
            additionalItems,
            showExportMenu && (!rootProps.disableColumnFilter || !rootProps.disableColumnSelector) && /*#__PURE__*/ (0, $ayMG0.jsx)($a162346a6ee1b52f$var$GridToolbarDivider, {}),
            showExportMenu && /*#__PURE__*/ (0, $ayMG0.jsxs)($a162346a6ee1b52f$var$React.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTooltip, {
                        title: apiRef.current.getLocaleText('toolbarExport'),
                        disableInteractive: exportMenuOpen,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($4c3478cdd4144942$exports.ToolbarButton, {
                            ref: exportMenuTriggerRef,
                            id: exportMenuTriggerId,
                            "aria-controls": exportMenuId,
                            "aria-haspopup": "true",
                            "aria-expanded": exportMenuOpen ? 'true' : undefined,
                            onClick: ()=>setExportMenuOpen(!exportMenuOpen),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.exportIcon, {
                                fontSize: "small"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($8efc7911d5661cb8$exports.GridMenu, {
                        target: exportMenuTriggerRef.current,
                        open: exportMenuOpen,
                        onClose: closeExportMenu,
                        position: "bottom-end",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(rootProps.slots.baseMenuList, (0, $a162346a6ee1b52f$var$_extends2.default)({
                            id: exportMenuId,
                            "aria-labelledby": exportMenuTriggerId,
                            autoFocusItem: true
                        }, rootProps.slotProps?.baseMenuList, {
                            children: [
                                !printOptions?.disableToolbarButton && /*#__PURE__*/ (0, $ayMG0.jsx)($c43d0959e479160d$exports.ExportPrint, {
                                    render: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseMenuItem, (0, $a162346a6ee1b52f$var$_extends2.default)({}, rootProps.slotProps?.baseMenuItem)),
                                    options: printOptions,
                                    onClick: closeExportMenu,
                                    children: apiRef.current.getLocaleText('toolbarExportPrint')
                                }),
                                !csvOptions?.disableToolbarButton && /*#__PURE__*/ (0, $ayMG0.jsx)($c43d0959e479160d$exports.ExportCsv, {
                                    render: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseMenuItem, (0, $a162346a6ee1b52f$var$_extends2.default)({}, rootProps.slotProps?.baseMenuItem)),
                                    options: csvOptions,
                                    onClick: closeExportMenu,
                                    children: apiRef.current.getLocaleText('toolbarExportCSV')
                                }),
                                additionalExportMenuItems?.(closeExportMenu)
                            ]
                        }))
                    })
                ]
            }),
            showQuickFilter && /*#__PURE__*/ (0, $ayMG0.jsxs)($a162346a6ee1b52f$var$React.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($a162346a6ee1b52f$var$GridToolbarDivider, {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($0f88284c0023fb16$exports.GridToolbarQuickFilter, (0, $a162346a6ee1b52f$var$_extends2.default)({}, quickFilterProps))
                ]
            })
        ]
    }));
}
$a162346a6ee1b52f$var$GridToolbar.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    additionalExportMenuItems: $a162346a6ee1b52f$var$_propTypes.default.func,
    additionalItems: $a162346a6ee1b52f$var$_propTypes.default.node,
    csvOptions: $a162346a6ee1b52f$var$_propTypes.default.object,
    printOptions: $a162346a6ee1b52f$var$_propTypes.default.object,
    /**
   * Props passed to the quick filter component.
   */ quickFilterProps: $a162346a6ee1b52f$var$_propTypes.default.shape({
        className: $a162346a6ee1b52f$var$_propTypes.default.string,
        debounceMs: $a162346a6ee1b52f$var$_propTypes.default.number,
        quickFilterFormatter: $a162346a6ee1b52f$var$_propTypes.default.func,
        quickFilterParser: $a162346a6ee1b52f$var$_propTypes.default.func,
        slotProps: $a162346a6ee1b52f$var$_propTypes.default.object
    }),
    /**
   * Show the quick filter component.
   * @default true
   */ showQuickFilter: $a162346a6ee1b52f$var$_propTypes.default.bool,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $a162346a6ee1b52f$var$_propTypes.default.object,
    sx: $a162346a6ee1b52f$var$_propTypes.default.oneOfType([
        $a162346a6ee1b52f$var$_propTypes.default.arrayOf($a162346a6ee1b52f$var$_propTypes.default.oneOfType([
            $a162346a6ee1b52f$var$_propTypes.default.func,
            $a162346a6ee1b52f$var$_propTypes.default.object,
            $a162346a6ee1b52f$var$_propTypes.default.bool
        ])),
        $a162346a6ee1b52f$var$_propTypes.default.func,
        $a162346a6ee1b52f$var$_propTypes.default.object
    ])
};



var $ayMG0 = parcelRequire("ayMG0");
const $3823b87e39c2fb28$var$_excluded = [
    "className",
    "csvOptions",
    "printOptions",
    "excelOptions",
    "showQuickFilter",
    "quickFilterProps"
];
/**
 * @deprecated Use the `showToolbar` prop to show the default toolbar instead. This component will be removed in a future major release.
 */ const $3823b87e39c2fb28$var$GridToolbar = $3823b87e39c2fb28$exports.GridToolbar = (0, $fYxgT.forwardRef)(function GridToolbar(props, ref) {
    // TODO v7: think about where export option should be passed.
    // from slotProps={{ toolbarExport: { ...exportOption } }} seems to be more appropriate
    const _ref = props, { csvOptions: csvOptions, printOptions: printOptions, excelOptions: excelOptions, showQuickFilter: showQuickFilter = true, quickFilterProps: quickFilterProps = {} } = _ref, other = (0, $3823b87e39c2fb28$var$_objectWithoutPropertiesLoose2.default)(_ref, $3823b87e39c2fb28$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    if (rootProps.disableColumnFilter && rootProps.disableColumnSelector && rootProps.disableDensitySelector && !showQuickFilter) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($0080d3bf74adddb6$exports.GridToolbarContainer, (0, $3823b87e39c2fb28$var$_extends2.default)({}, other, {
        ref: ref,
        children: [
            rootProps.label && /*#__PURE__*/ (0, $ayMG0.jsx)($a162346a6ee1b52f$exports.GridToolbarLabel, {
                children: rootProps.label
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($68dba7cc326760eb$exports.GridToolbarColumnsButton, {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)($552288f2e6707b2c$exports.GridToolbarFilterButton, {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)($839090d5c761d720$exports.GridToolbarDensitySelector, {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)($117c70f90fd64960$exports.GridToolbarExport, {
                csvOptions: csvOptions,
                printOptions: printOptions,
                excelOptions: excelOptions
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    flex: 1
                }
            }),
            showQuickFilter && /*#__PURE__*/ (0, $ayMG0.jsx)($0f88284c0023fb16$exports.GridToolbarQuickFilter, (0, $3823b87e39c2fb28$var$_extends2.default)({}, quickFilterProps))
        ]
    }));
});
$3823b87e39c2fb28$var$GridToolbar.displayName = "GridToolbar";
$3823b87e39c2fb28$var$GridToolbar.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    csvOptions: $3823b87e39c2fb28$var$_propTypes.default.object,
    printOptions: $3823b87e39c2fb28$var$_propTypes.default.object,
    /**
   * Props passed to the quick filter component.
   */ quickFilterProps: $3823b87e39c2fb28$var$_propTypes.default.shape({
        className: $3823b87e39c2fb28$var$_propTypes.default.string,
        debounceMs: $3823b87e39c2fb28$var$_propTypes.default.number,
        quickFilterFormatter: $3823b87e39c2fb28$var$_propTypes.default.func,
        quickFilterParser: $3823b87e39c2fb28$var$_propTypes.default.func,
        slotProps: $3823b87e39c2fb28$var$_propTypes.default.object
    }),
    /**
   * Show the quick filter component.
   * @default true
   */ showQuickFilter: $3823b87e39c2fb28$var$_propTypes.default.bool,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: $3823b87e39c2fb28$var$_propTypes.default.object,
    sx: $3823b87e39c2fb28$var$_propTypes.default.oneOfType([
        $3823b87e39c2fb28$var$_propTypes.default.arrayOf($3823b87e39c2fb28$var$_propTypes.default.oneOfType([
            $3823b87e39c2fb28$var$_propTypes.default.func,
            $3823b87e39c2fb28$var$_propTypes.default.object,
            $3823b87e39c2fb28$var$_propTypes.default.bool
        ])),
        $3823b87e39c2fb28$var$_propTypes.default.func,
        $3823b87e39c2fb28$var$_propTypes.default.object
    ])
};


Object.keys($3823b87e39c2fb28$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($db5176c392a1c83e$var$_exportNames, key)) return;
    if (key in $db5176c392a1c83e$exports && $db5176c392a1c83e$exports[key] === $3823b87e39c2fb28$exports[key]) return;
    Object.defineProperty($db5176c392a1c83e$exports, key, {
        enumerable: true,
        get: function() {
            return $3823b87e39c2fb28$exports[key];
        }
    });
});

Object.keys($68dba7cc326760eb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($db5176c392a1c83e$var$_exportNames, key)) return;
    if (key in $db5176c392a1c83e$exports && $db5176c392a1c83e$exports[key] === $68dba7cc326760eb$exports[key]) return;
    Object.defineProperty($db5176c392a1c83e$exports, key, {
        enumerable: true,
        get: function() {
            return $68dba7cc326760eb$exports[key];
        }
    });
});

Object.keys($839090d5c761d720$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($db5176c392a1c83e$var$_exportNames, key)) return;
    if (key in $db5176c392a1c83e$exports && $db5176c392a1c83e$exports[key] === $839090d5c761d720$exports[key]) return;
    Object.defineProperty($db5176c392a1c83e$exports, key, {
        enumerable: true,
        get: function() {
            return $839090d5c761d720$exports[key];
        }
    });
});


Object.keys($552288f2e6707b2c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($db5176c392a1c83e$var$_exportNames, key)) return;
    if (key in $db5176c392a1c83e$exports && $db5176c392a1c83e$exports[key] === $552288f2e6707b2c$exports[key]) return;
    Object.defineProperty($db5176c392a1c83e$exports, key, {
        enumerable: true,
        get: function() {
            return $552288f2e6707b2c$exports[key];
        }
    });
});

Object.keys($00a23b3a9224b6aa$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($db5176c392a1c83e$var$_exportNames, key)) return;
    if (key in $db5176c392a1c83e$exports && $db5176c392a1c83e$exports[key] === $00a23b3a9224b6aa$exports[key]) return;
    Object.defineProperty($db5176c392a1c83e$exports, key, {
        enumerable: true,
        get: function() {
            return $00a23b3a9224b6aa$exports[key];
        }
    });
});

Object.keys($0f88284c0023fb16$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($db5176c392a1c83e$var$_exportNames, key)) return;
    if (key in $db5176c392a1c83e$exports && $db5176c392a1c83e$exports[key] === $0f88284c0023fb16$exports[key]) return;
    Object.defineProperty($db5176c392a1c83e$exports, key, {
        enumerable: true,
        get: function() {
            return $0f88284c0023fb16$exports[key];
        }
    });
});


Object.keys($db5176c392a1c83e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in $08eee520e810d520$exports && $08eee520e810d520$exports[key] === $db5176c392a1c83e$exports[key]) return;
    Object.defineProperty($08eee520e810d520$exports, key, {
        enumerable: true,
        get: function() {
            return $db5176c392a1c83e$exports[key];
        }
    });
});

var $YSznt = parcelRequire("YSznt");
Object.keys($YSznt).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in $08eee520e810d520$exports && $08eee520e810d520$exports[key] === $YSznt[key]) return;
    Object.defineProperty($08eee520e810d520$exports, key, {
        enumerable: true,
        get: function() {
            return $YSznt[key];
        }
    });
});
var $e5a1f44ff53ee1a6$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e5a1f44ff53ee1a6$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($e5a1f44ff53ee1a6$exports, "__esModule", {
    value: true
});
$e5a1f44ff53ee1a6$exports.GridFooter = void 0;

var $e5a1f44ff53ee1a6$var$_extends2 = $e5a1f44ff53ee1a6$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $e5a1f44ff53ee1a6$var$_propTypes = $e5a1f44ff53ee1a6$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $fYxgT = parcelRequire("fYxgT");

var $5sOMZ = parcelRequire("5sOMZ");




var $bDyDY = parcelRequire("bDyDY");
var $b80f871a1017d664$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $b80f871a1017d664$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $b80f871a1017d664$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($b80f871a1017d664$exports, "__esModule", {
    value: true
});
$b80f871a1017d664$exports.GridSelectedRowCount = void 0;

var $b80f871a1017d664$var$_extends2 = $b80f871a1017d664$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $b80f871a1017d664$var$_objectWithoutPropertiesLoose2 = $b80f871a1017d664$require$_interopRequireDefault((parcelRequire("c05no")));

var $b80f871a1017d664$var$React = $b80f871a1017d664$require$_interopRequireWildcard((parcelRequire("acw62")));

var $b80f871a1017d664$var$_propTypes = $b80f871a1017d664$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $b80f871a1017d664$var$_clsx = $b80f871a1017d664$require$_interopRequireDefault((parcelRequire("9QePP")));

var $b80f871a1017d664$var$_composeClasses = $b80f871a1017d664$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $izOUK = parcelRequire("izOUK");

var $fYxgT = parcelRequire("fYxgT");

var $hbuUJ = parcelRequire("hbuUJ");

var $bDyDY = parcelRequire("bDyDY");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $b80f871a1017d664$var$_excluded = [
    "className",
    "selectedRowCount"
];
const $b80f871a1017d664$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'selectedRowCount'
        ]
    };
    return (0, $b80f871a1017d664$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $b80f871a1017d664$var$GridSelectedRowCountRoot = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'SelectedRowCount'
})({
    alignItems: 'center',
    display: 'flex',
    margin: $hbuUJ.vars.spacing(0, 2),
    visibility: 'hidden',
    width: 0,
    height: 0,
    [$hbuUJ.vars.breakpoints.up('sm')]: {
        visibility: 'visible',
        width: 'auto',
        height: 'auto'
    }
});
const $b80f871a1017d664$var$GridSelectedRowCount = $b80f871a1017d664$exports.GridSelectedRowCount = (0, $fYxgT.forwardRef)(function GridSelectedRowCount(props, ref) {
    const { className: className, selectedRowCount: selectedRowCount } = props, other = (0, $b80f871a1017d664$var$_objectWithoutPropertiesLoose2.default)(props, $b80f871a1017d664$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const ownerState = (0, $jDpXp.useGridRootProps)();
    const classes = $b80f871a1017d664$var$useUtilityClasses(ownerState);
    const rowSelectedText = apiRef.current.getLocaleText('footerRowSelected')(selectedRowCount);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($b80f871a1017d664$var$GridSelectedRowCountRoot, (0, $b80f871a1017d664$var$_extends2.default)({
        className: (0, $b80f871a1017d664$var$_clsx.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        ref: ref,
        children: rowSelectedText
    }));
});
$b80f871a1017d664$var$GridSelectedRowCount.displayName = "GridSelectedRowCount";
$b80f871a1017d664$var$GridSelectedRowCount.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    selectedRowCount: $b80f871a1017d664$var$_propTypes.default.number.isRequired,
    sx: $b80f871a1017d664$var$_propTypes.default.oneOfType([
        $b80f871a1017d664$var$_propTypes.default.arrayOf($b80f871a1017d664$var$_propTypes.default.oneOfType([
            $b80f871a1017d664$var$_propTypes.default.func,
            $b80f871a1017d664$var$_propTypes.default.object,
            $b80f871a1017d664$var$_propTypes.default.bool
        ])),
        $b80f871a1017d664$var$_propTypes.default.func,
        $b80f871a1017d664$var$_propTypes.default.object
    ])
};




var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $e5a1f44ff53ee1a6$var$GridFooter = $e5a1f44ff53ee1a6$exports.GridFooter = (0, $fYxgT.forwardRef)(function GridFooter(props, ref) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const totalTopLevelRowCount = (0, $5sOMZ.useGridSelector)(apiRef, $befccaa56b49492d$exports.gridTopLevelRowCountSelector);
    const selectedRowCount = (0, $5sOMZ.useGridSelector)(apiRef, $7a5249c135fd39c1$exports.gridRowSelectionCountSelector);
    const visibleTopLevelRowCount = (0, $5sOMZ.useGridSelector)(apiRef, $e95988b653de2e96$exports.gridFilteredTopLevelRowCountSelector);
    const selectedRowCountElement = !rootProps.hideFooterSelectedRowCount && selectedRowCount > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)($b80f871a1017d664$exports.GridSelectedRowCount, {
        selectedRowCount: selectedRowCount
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {});
    const rowCountElement = !rootProps.hideFooterRowCount && !rootProps.pagination ? /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.footerRowCount, (0, $e5a1f44ff53ee1a6$var$_extends2.default)({}, rootProps.slotProps?.footerRowCount, {
        rowCount: totalTopLevelRowCount,
        visibleRowCount: visibleTopLevelRowCount
    })) : null;
    const paginationElement = rootProps.pagination && !rootProps.hideFooterPagination && rootProps.slots.pagination && /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.pagination, (0, $e5a1f44ff53ee1a6$var$_extends2.default)({}, rootProps.slotProps?.pagination));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($e05925554f74d684$exports.GridFooterContainer, (0, $e5a1f44ff53ee1a6$var$_extends2.default)({}, props, {
        ref: ref,
        children: [
            selectedRowCountElement,
            rowCountElement,
            paginationElement
        ]
    }));
});
$e5a1f44ff53ee1a6$var$GridFooter.displayName = "GridFooter";
$e5a1f44ff53ee1a6$var$GridFooter.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    sx: $e5a1f44ff53ee1a6$var$_propTypes.default.oneOfType([
        $e5a1f44ff53ee1a6$var$_propTypes.default.arrayOf($e5a1f44ff53ee1a6$var$_propTypes.default.oneOfType([
            $e5a1f44ff53ee1a6$var$_propTypes.default.func,
            $e5a1f44ff53ee1a6$var$_propTypes.default.object,
            $e5a1f44ff53ee1a6$var$_propTypes.default.bool
        ])),
        $e5a1f44ff53ee1a6$var$_propTypes.default.func,
        $e5a1f44ff53ee1a6$var$_propTypes.default.object
    ])
};


Object.keys($e5a1f44ff53ee1a6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in $08eee520e810d520$exports && $08eee520e810d520$exports[key] === $e5a1f44ff53ee1a6$exports[key]) return;
    Object.defineProperty($08eee520e810d520$exports, key, {
        enumerable: true,
        get: function() {
            return $e5a1f44ff53ee1a6$exports[key];
        }
    });
});

Object.keys($ce2feaf42932ccbe$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in $08eee520e810d520$exports && $08eee520e810d520$exports[key] === $ce2feaf42932ccbe$exports[key]) return;
    Object.defineProperty($08eee520e810d520$exports, key, {
        enumerable: true,
        get: function() {
            return $ce2feaf42932ccbe$exports[key];
        }
    });
});
var $3a075fc4ca1dcd85$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3a075fc4ca1dcd85$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $3a075fc4ca1dcd85$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($3a075fc4ca1dcd85$exports, "__esModule", {
    value: true
});
$3a075fc4ca1dcd85$exports.GridLoadingOverlay = void 0;

var $3a075fc4ca1dcd85$var$_extends2 = $3a075fc4ca1dcd85$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $3a075fc4ca1dcd85$var$_objectWithoutPropertiesLoose2 = $3a075fc4ca1dcd85$require$_interopRequireDefault((parcelRequire("c05no")));

var $3a075fc4ca1dcd85$var$React = $3a075fc4ca1dcd85$require$_interopRequireWildcard((parcelRequire("acw62")));

var $3a075fc4ca1dcd85$var$_propTypes = $3a075fc4ca1dcd85$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $fYxgT = parcelRequire("fYxgT");

var $jDpXp = parcelRequire("jDpXp");

var $d19b9e7dfc56bad3$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d19b9e7dfc56bad3$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $d19b9e7dfc56bad3$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($d19b9e7dfc56bad3$exports, "__esModule", {
    value: true
});
$d19b9e7dfc56bad3$exports.GridSkeletonLoadingOverlayInner = $d19b9e7dfc56bad3$exports.GridSkeletonLoadingOverlay = void 0;

var $d19b9e7dfc56bad3$var$_extends2 = $d19b9e7dfc56bad3$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $d19b9e7dfc56bad3$var$_objectWithoutPropertiesLoose2 = $d19b9e7dfc56bad3$require$_interopRequireDefault((parcelRequire("c05no")));

var $d19b9e7dfc56bad3$var$React = $d19b9e7dfc56bad3$require$_interopRequireWildcard((parcelRequire("acw62")));

var $d19b9e7dfc56bad3$var$_clsx = $d19b9e7dfc56bad3$require$_interopRequireDefault((parcelRequire("9QePP")));

var $izOUK = parcelRequire("izOUK");

var $d19b9e7dfc56bad3$var$_useForkRef = $d19b9e7dfc56bad3$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $d19b9e7dfc56bad3$var$_composeClasses = $d19b9e7dfc56bad3$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $9uEev = parcelRequire("9uEev");

var $fYxgT = parcelRequire("fYxgT");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");




var $5H1vo = parcelRequire("5H1vo");
var $e85ba38bf3b586f5$exports = {};
"use strict";
Object.defineProperty($e85ba38bf3b586f5$exports, "__esModule", {
    value: true
});
$e85ba38bf3b586f5$exports.getPinnedCellOffset = void 0;

const $e85ba38bf3b586f5$var$getPinnedCellOffset = (pinnedPosition, computedWidth, columnIndex, columnPositions, columnsTotalWidth, scrollbarWidth)=>{
    let pinnedOffset;
    switch(pinnedPosition){
        case $e8d35a7c12bdaa1d$exports.PinnedColumnPosition.LEFT:
            pinnedOffset = columnPositions[columnIndex];
            break;
        case $e8d35a7c12bdaa1d$exports.PinnedColumnPosition.RIGHT:
            pinnedOffset = columnsTotalWidth - columnPositions[columnIndex] - computedWidth + scrollbarWidth;
            break;
        default:
            pinnedOffset = undefined;
            break;
    }
    // XXX: fix this properly
    if (Number.isNaN(pinnedOffset)) pinnedOffset = undefined;
    return pinnedOffset;
};
$e85ba38bf3b586f5$exports.getPinnedCellOffset = $e85ba38bf3b586f5$var$getPinnedCellOffset;


var $f6d1081691c64c11$exports = {};
"use strict";
Object.defineProperty($f6d1081691c64c11$exports, "__esModule", {
    value: true
});
$f6d1081691c64c11$exports.shouldCellShowRightBorder = $f6d1081691c64c11$exports.shouldCellShowLeftBorder = void 0;

const $f6d1081691c64c11$var$shouldCellShowRightBorder = (pinnedPosition, indexInSection, sectionLength, showCellVerticalBorderRootProp, gridHasFiller, pinnedColumnsSectionSeparatorRootProp)=>{
    const isSectionLastCell = indexInSection === sectionLength - 1;
    if (pinnedColumnsSectionSeparatorRootProp?.startsWith('border') && pinnedPosition === $e8d35a7c12bdaa1d$exports.PinnedColumnPosition.LEFT && isSectionLastCell) return true;
    if (showCellVerticalBorderRootProp) {
        if (pinnedPosition === $e8d35a7c12bdaa1d$exports.PinnedColumnPosition.LEFT) return true;
        if (pinnedPosition === $e8d35a7c12bdaa1d$exports.PinnedColumnPosition.RIGHT) return !isSectionLastCell;
        // pinnedPosition === undefined, middle section
        return !isSectionLastCell || gridHasFiller;
    }
    return false;
};
$f6d1081691c64c11$exports.shouldCellShowRightBorder = $f6d1081691c64c11$var$shouldCellShowRightBorder;
const $f6d1081691c64c11$var$shouldCellShowLeftBorder = (pinnedPosition, indexInSection, showCellVerticalBorderRootProp, pinnedColumnsSectionSeparatorRootProp)=>{
    if (pinnedColumnsSectionSeparatorRootProp?.startsWith('border')) return pinnedPosition === $e8d35a7c12bdaa1d$exports.PinnedColumnPosition.RIGHT && indexInSection === 0;
    return showCellVerticalBorderRootProp && pinnedPosition === $e8d35a7c12bdaa1d$exports.PinnedColumnPosition.RIGHT && indexInSection === 0;
};
$f6d1081691c64c11$exports.shouldCellShowLeftBorder = $f6d1081691c64c11$var$shouldCellShowLeftBorder;






var $ayMG0 = parcelRequire("ayMG0");
const $d19b9e7dfc56bad3$var$_excluded = [
    "skeletonRowsCount",
    "visibleColumns",
    "showFirstRowBorder"
];
const $d19b9e7dfc56bad3$var$SkeletonOverlay = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'SkeletonLoadingOverlay'
})({
    minWidth: '100%',
    width: 'max-content',
    // prevents overflow: clip; cutting off the x axis
    height: '100%',
    overflow: 'clip' // y axis is hidden while the x axis is allowed to overflow
});
const $d19b9e7dfc56bad3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'skeletonLoadingOverlay'
        ]
    };
    return (0, $d19b9e7dfc56bad3$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $d19b9e7dfc56bad3$var$getColIndex = (el)=>parseInt(el.getAttribute('data-colindex'), 10);
const $d19b9e7dfc56bad3$var$GridSkeletonLoadingOverlayInner = $d19b9e7dfc56bad3$exports.GridSkeletonLoadingOverlayInner = (0, $fYxgT.forwardRef)(function GridSkeletonLoadingOverlayInner(props, forwardedRef) {
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const { slots: slots } = rootProps;
    const isRtl = (0, $9uEev.useRtl)();
    const classes = $d19b9e7dfc56bad3$var$useUtilityClasses({
        classes: rootProps.classes
    });
    const ref = $d19b9e7dfc56bad3$var$React.useRef(null);
    const handleRef = (0, $d19b9e7dfc56bad3$var$_useForkRef.default)(ref, forwardedRef);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const dimensions = (0, $d8761d1e377450f5$exports.useGridSelector)(apiRef, $d8761d1e377450f5$exports.gridDimensionsSelector);
    const totalWidth = (0, $d8761d1e377450f5$exports.useGridSelector)(apiRef, $46349fe7fabb2b4d$exports.gridColumnsTotalWidthSelector);
    const positions = (0, $d8761d1e377450f5$exports.useGridSelector)(apiRef, $d8761d1e377450f5$exports.gridColumnPositionsSelector);
    const inViewportCount = $d19b9e7dfc56bad3$var$React.useMemo(()=>positions.filter((value)=>value <= totalWidth).length, [
        totalWidth,
        positions
    ]);
    const { skeletonRowsCount: skeletonRowsCount, visibleColumns: visibleColumns, showFirstRowBorder: showFirstRowBorder } = props, other = (0, $d19b9e7dfc56bad3$var$_objectWithoutPropertiesLoose2.default)(props, $d19b9e7dfc56bad3$var$_excluded);
    const allVisibleColumns = (0, $d8761d1e377450f5$exports.useGridSelector)(apiRef, $d8761d1e377450f5$exports.gridVisibleColumnDefinitionsSelector);
    const columns = $d19b9e7dfc56bad3$var$React.useMemo(()=>allVisibleColumns.slice(0, inViewportCount), [
        allVisibleColumns,
        inViewportCount
    ]);
    const pinnedColumns = (0, $d8761d1e377450f5$exports.useGridSelector)(apiRef, $d8761d1e377450f5$exports.gridVisiblePinnedColumnDefinitionsSelector);
    const getPinnedPosition = $d19b9e7dfc56bad3$var$React.useCallback((field)=>{
        if (pinnedColumns.left.findIndex((col)=>col.field === field) !== -1) return $e8d35a7c12bdaa1d$exports.PinnedColumnPosition.LEFT;
        if (pinnedColumns.right.findIndex((col)=>col.field === field) !== -1) return $e8d35a7c12bdaa1d$exports.PinnedColumnPosition.RIGHT;
        return undefined;
    }, [
        pinnedColumns.left,
        pinnedColumns.right
    ]);
    const children = $d19b9e7dfc56bad3$var$React.useMemo(()=>{
        const array = [];
        for(let i = 0; i < skeletonRowsCount; i += 1){
            const rowCells = [];
            for(let colIndex = 0; colIndex < columns.length; colIndex += 1){
                const column = columns[colIndex];
                const pinnedPosition = getPinnedPosition(column.field);
                const isPinnedLeft = pinnedPosition === $e8d35a7c12bdaa1d$exports.PinnedColumnPosition.LEFT;
                const isPinnedRight = pinnedPosition === $e8d35a7c12bdaa1d$exports.PinnedColumnPosition.RIGHT;
                const pinnedSide = (0, $02cd8e055a355186$exports.rtlFlipSide)(pinnedPosition, isRtl);
                const sectionLength = pinnedSide ? pinnedColumns[pinnedSide].length // pinned section
                 : columns.length - pinnedColumns.left.length - pinnedColumns.right.length; // middle section
                const sectionIndex = pinnedSide ? pinnedColumns[pinnedSide].findIndex((col)=>col.field === column.field) // pinned section
                 : colIndex - pinnedColumns.left.length; // middle section
                const scrollbarWidth = dimensions.hasScrollY ? dimensions.scrollbarSize : 0;
                const pinnedStyle = (0, $69aaaa4d4ca0aa66$exports.attachPinnedStyle)({}, isRtl, pinnedPosition, (0, $e85ba38bf3b586f5$exports.getPinnedCellOffset)(pinnedPosition, column.computedWidth, colIndex, positions, dimensions.columnsTotalWidth, scrollbarWidth));
                const gridHasFiller = dimensions.columnsTotalWidth < dimensions.viewportOuterSize.width;
                const showRightBorder = (0, $f6d1081691c64c11$exports.shouldCellShowRightBorder)(pinnedPosition, sectionIndex, sectionLength, rootProps.showCellVerticalBorder, gridHasFiller, rootProps.pinnedColumnsSectionSeparator);
                const showLeftBorder = (0, $f6d1081691c64c11$exports.shouldCellShowLeftBorder)(pinnedPosition, sectionIndex, rootProps.showCellVerticalBorder, rootProps.pinnedColumnsSectionSeparator);
                const isLastColumn = colIndex === columns.length - 1;
                const isFirstPinnedRight = isPinnedRight && sectionIndex === 0;
                const hasFillerBefore = isFirstPinnedRight && gridHasFiller;
                const hasFillerAfter = isLastColumn && !isFirstPinnedRight && gridHasFiller;
                const expandedWidth = dimensions.viewportOuterSize.width - dimensions.columnsTotalWidth;
                const emptyCellWidth = Math.max(0, expandedWidth);
                const emptyCell = /*#__PURE__*/ (0, $ayMG0.jsx)(slots.skeletonCell, {
                    width: emptyCellWidth,
                    empty: true
                }, `skeleton-filler-column-${i}`);
                if (hasFillerBefore) rowCells.push(emptyCell);
                rowCells.push(/*#__PURE__*/ (0, $ayMG0.jsx)(slots.skeletonCell, {
                    field: column.field,
                    type: column.type,
                    align: column.align,
                    width: "var(--width)",
                    height: dimensions.rowHeight,
                    "data-colindex": colIndex,
                    empty: visibleColumns && !visibleColumns.has(column.field),
                    className: (0, $d19b9e7dfc56bad3$var$_clsx.default)(isPinnedLeft && $5H1vo.gridClasses['cell--pinnedLeft'], isPinnedRight && $5H1vo.gridClasses['cell--pinnedRight'], showRightBorder && $5H1vo.gridClasses['cell--withRightBorder'], showLeftBorder && $5H1vo.gridClasses['cell--withLeftBorder']),
                    style: (0, $d19b9e7dfc56bad3$var$_extends2.default)({
                        '--width': `${column.computedWidth}px`
                    }, pinnedStyle)
                }, `skeleton-column-${i}-${column.field}`));
                if (hasFillerAfter) rowCells.push(emptyCell);
            }
            array.push(/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, $d19b9e7dfc56bad3$var$_clsx.default)($5H1vo.gridClasses.row, $5H1vo.gridClasses.rowSkeleton, i === 0 && !showFirstRowBorder && $5H1vo.gridClasses['row--firstVisible']),
                children: rowCells
            }, `skeleton-row-${i}`));
        }
        return array;
    }, [
        skeletonRowsCount,
        columns,
        getPinnedPosition,
        isRtl,
        pinnedColumns,
        dimensions.hasScrollY,
        dimensions.scrollbarSize,
        dimensions.columnsTotalWidth,
        dimensions.viewportOuterSize.width,
        dimensions.rowHeight,
        positions,
        rootProps.showCellVerticalBorder,
        rootProps.pinnedColumnsSectionSeparator,
        slots,
        visibleColumns,
        showFirstRowBorder
    ]);
    // Sync the column resize of the overlay columns with the grid
    const handleColumnResize = (params)=>{
        const { colDef: colDef, width: width } = params;
        const cells = ref.current?.querySelectorAll(`[data-field="${(0, $08bb4bf24f47b880$exports.escapeOperandAttributeSelector)(colDef.field)}"]`);
        if (!cells) throw new Error('MUI X: Expected skeleton cells to be defined with `data-field` attribute.');
        const resizedColIndex = columns.findIndex((col)=>col.field === colDef.field);
        const pinnedPosition = getPinnedPosition(colDef.field);
        const isPinnedLeft = pinnedPosition === $e8d35a7c12bdaa1d$exports.PinnedColumnPosition.LEFT;
        const isPinnedRight = pinnedPosition === $e8d35a7c12bdaa1d$exports.PinnedColumnPosition.RIGHT;
        const currentWidth = getComputedStyle(cells[0]).getPropertyValue('--width');
        const delta = parseInt(currentWidth, 10) - width;
        if (cells) cells.forEach((element)=>{
            element.style.setProperty('--width', `${width}px`);
        });
        if (isPinnedLeft) {
            const pinnedCells = ref.current?.querySelectorAll(`.${$5H1vo.gridClasses['cell--pinnedLeft']}`);
            pinnedCells?.forEach((element)=>{
                const colIndex = $d19b9e7dfc56bad3$var$getColIndex(element);
                if (colIndex > resizedColIndex) element.style.left = `${parseInt(getComputedStyle(element).left, 10) - delta}px`;
            });
        }
        if (isPinnedRight) {
            const pinnedCells = ref.current?.querySelectorAll(`.${$5H1vo.gridClasses['cell--pinnedRight']}`);
            pinnedCells?.forEach((element)=>{
                const colIndex = $d19b9e7dfc56bad3$var$getColIndex(element);
                if (colIndex < resizedColIndex) element.style.right = `${parseInt(getComputedStyle(element).right, 10) + delta}px`;
            });
        }
    };
    (0, $d8761d1e377450f5$exports.useGridEvent)(apiRef, 'columnResize', handleColumnResize);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($d19b9e7dfc56bad3$var$SkeletonOverlay, (0, $d19b9e7dfc56bad3$var$_extends2.default)({
        className: classes.root
    }, other, {
        ref: handleRef,
        children: children
    }));
});
$d19b9e7dfc56bad3$var$GridSkeletonLoadingOverlayInner.displayName = "GridSkeletonLoadingOverlayInner";
const $d19b9e7dfc56bad3$var$GridSkeletonLoadingOverlay = $d19b9e7dfc56bad3$exports.GridSkeletonLoadingOverlay = (0, $fYxgT.forwardRef)(function GridSkeletonLoadingOverlay(props, forwardedRef) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const dimensions = (0, $d8761d1e377450f5$exports.useGridSelector)(apiRef, $d8761d1e377450f5$exports.gridDimensionsSelector);
    const viewportHeight = dimensions?.viewportInnerSize.height ?? 0;
    const skeletonRowsCount = Math.ceil(viewportHeight / dimensions.rowHeight);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($d19b9e7dfc56bad3$var$GridSkeletonLoadingOverlayInner, (0, $d19b9e7dfc56bad3$var$_extends2.default)({}, props, {
        skeletonRowsCount: skeletonRowsCount,
        ref: forwardedRef
    }));
});
$d19b9e7dfc56bad3$var$GridSkeletonLoadingOverlay.displayName = "GridSkeletonLoadingOverlay";



var $bDyDY = parcelRequire("bDyDY");


var $ayMG0 = parcelRequire("ayMG0");
const $3a075fc4ca1dcd85$var$_excluded = [
    "variant",
    "noRowsVariant",
    "style"
];
const $3a075fc4ca1dcd85$var$LOADING_VARIANTS = {
    'circular-progress': {
        component: (rootProps)=>rootProps.slots.baseCircularProgress,
        style: {}
    },
    'linear-progress': {
        component: (rootProps)=>rootProps.slots.baseLinearProgress,
        style: {
            display: 'block'
        }
    },
    skeleton: {
        component: ()=>$d19b9e7dfc56bad3$exports.GridSkeletonLoadingOverlay,
        style: {
            display: 'block'
        }
    }
};
const $3a075fc4ca1dcd85$var$GridLoadingOverlay = $3a075fc4ca1dcd85$exports.GridLoadingOverlay = (0, $fYxgT.forwardRef)(function GridLoadingOverlay(props, ref) {
    const { variant: variant = 'linear-progress', noRowsVariant: noRowsVariant = 'skeleton', style: style } = props, other = (0, $3a075fc4ca1dcd85$var$_objectWithoutPropertiesLoose2.default)(props, $3a075fc4ca1dcd85$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const rowsCount = (0, $d8761d1e377450f5$exports.useGridSelector)(apiRef, $d8761d1e377450f5$exports.gridRowCountSelector);
    const activeVariant = $3a075fc4ca1dcd85$var$LOADING_VARIANTS[rowsCount === 0 ? noRowsVariant : variant];
    const Component = activeVariant.component(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($0180de2e65ebf290$exports.GridOverlay, (0, $3a075fc4ca1dcd85$var$_extends2.default)({
        style: (0, $3a075fc4ca1dcd85$var$_extends2.default)({}, activeVariant.style, style)
    }, other, {
        ref: ref,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {})
    }));
});
$3a075fc4ca1dcd85$var$GridLoadingOverlay.displayName = "GridLoadingOverlay";
$3a075fc4ca1dcd85$var$GridLoadingOverlay.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * The variant of the overlay when no rows are displayed.
   * @default 'skeleton'
   */ noRowsVariant: $3a075fc4ca1dcd85$var$_propTypes.default.oneOf([
        'circular-progress',
        'linear-progress',
        'skeleton'
    ]),
    sx: $3a075fc4ca1dcd85$var$_propTypes.default.oneOfType([
        $3a075fc4ca1dcd85$var$_propTypes.default.arrayOf($3a075fc4ca1dcd85$var$_propTypes.default.oneOfType([
            $3a075fc4ca1dcd85$var$_propTypes.default.func,
            $3a075fc4ca1dcd85$var$_propTypes.default.object,
            $3a075fc4ca1dcd85$var$_propTypes.default.bool
        ])),
        $3a075fc4ca1dcd85$var$_propTypes.default.func,
        $3a075fc4ca1dcd85$var$_propTypes.default.object
    ]),
    /**
   * The variant of the overlay.
   * @default 'linear-progress'
   */ variant: $3a075fc4ca1dcd85$var$_propTypes.default.oneOf([
        'circular-progress',
        'linear-progress',
        'skeleton'
    ])
};


Object.keys($3a075fc4ca1dcd85$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in $08eee520e810d520$exports && $08eee520e810d520$exports[key] === $3a075fc4ca1dcd85$exports[key]) return;
    Object.defineProperty($08eee520e810d520$exports, key, {
        enumerable: true,
        get: function() {
            return $3a075fc4ca1dcd85$exports[key];
        }
    });
});
var $18efe9c687188074$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $18efe9c687188074$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($18efe9c687188074$exports, "__esModule", {
    value: true
});
$18efe9c687188074$exports.GridNoRowsOverlay = void 0;

var $18efe9c687188074$var$_extends2 = $18efe9c687188074$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $18efe9c687188074$var$_propTypes = $18efe9c687188074$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $fYxgT = parcelRequire("fYxgT");

var $bDyDY = parcelRequire("bDyDY");


var $ayMG0 = parcelRequire("ayMG0");
const $18efe9c687188074$var$GridNoRowsOverlay = $18efe9c687188074$exports.GridNoRowsOverlay = (0, $fYxgT.forwardRef)(function GridNoRowsOverlay(props, ref) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const noRowsLabel = apiRef.current.getLocaleText('noRowsLabel');
    return /*#__PURE__*/ (0, $ayMG0.jsx)($0180de2e65ebf290$exports.GridOverlay, (0, $18efe9c687188074$var$_extends2.default)({}, props, {
        ref: ref,
        children: noRowsLabel
    }));
});
$18efe9c687188074$var$GridNoRowsOverlay.displayName = "GridNoRowsOverlay";
$18efe9c687188074$var$GridNoRowsOverlay.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    sx: $18efe9c687188074$var$_propTypes.default.oneOfType([
        $18efe9c687188074$var$_propTypes.default.arrayOf($18efe9c687188074$var$_propTypes.default.oneOfType([
            $18efe9c687188074$var$_propTypes.default.func,
            $18efe9c687188074$var$_propTypes.default.object,
            $18efe9c687188074$var$_propTypes.default.bool
        ])),
        $18efe9c687188074$var$_propTypes.default.func,
        $18efe9c687188074$var$_propTypes.default.object
    ])
};


Object.keys($18efe9c687188074$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in $08eee520e810d520$exports && $08eee520e810d520$exports[key] === $18efe9c687188074$exports[key]) return;
    Object.defineProperty($08eee520e810d520$exports, key, {
        enumerable: true,
        get: function() {
            return $18efe9c687188074$exports[key];
        }
    });
});
var $0176544dd696ebe6$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0176544dd696ebe6$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($0176544dd696ebe6$exports, "__esModule", {
    value: true
});
$0176544dd696ebe6$exports.GridNoColumnsOverlay = void 0;

var $0176544dd696ebe6$var$_extends2 = $0176544dd696ebe6$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $0176544dd696ebe6$var$_propTypes = $0176544dd696ebe6$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $fYxgT = parcelRequire("fYxgT");

var $jDpXp = parcelRequire("jDpXp");

var $bDyDY = parcelRequire("bDyDY");




var $ayMG0 = parcelRequire("ayMG0");
const $0176544dd696ebe6$var$GridNoColumnsOverlay = $0176544dd696ebe6$exports.GridNoColumnsOverlay = (0, $fYxgT.forwardRef)(function GridNoColumnsOverlay(props, ref) {
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const columns = (0, $d8761d1e377450f5$exports.useGridSelector)(apiRef, $d8761d1e377450f5$exports.gridColumnFieldsSelector);
    const handleOpenManageColumns = ()=>{
        apiRef.current.showPreferences($2ca45f4bbfed6878$exports.GridPreferencePanelsValue.columns);
    };
    const showManageColumnsButton = !rootProps.disableColumnSelector && columns.length > 0;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($0180de2e65ebf290$exports.GridOverlay, (0, $0176544dd696ebe6$var$_extends2.default)({}, props, {
        ref: ref,
        children: [
            apiRef.current.getLocaleText('noColumnsOverlayLabel'),
            showManageColumnsButton && /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseButton, (0, $0176544dd696ebe6$var$_extends2.default)({
                size: "small"
            }, rootProps.slotProps?.baseButton, {
                onClick: handleOpenManageColumns,
                children: apiRef.current.getLocaleText('noColumnsOverlayManageColumns')
            }))
        ]
    }));
});
$0176544dd696ebe6$var$GridNoColumnsOverlay.displayName = "GridNoColumnsOverlay";
$0176544dd696ebe6$var$GridNoColumnsOverlay.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    sx: $0176544dd696ebe6$var$_propTypes.default.oneOfType([
        $0176544dd696ebe6$var$_propTypes.default.arrayOf($0176544dd696ebe6$var$_propTypes.default.oneOfType([
            $0176544dd696ebe6$var$_propTypes.default.func,
            $0176544dd696ebe6$var$_propTypes.default.object,
            $0176544dd696ebe6$var$_propTypes.default.bool
        ])),
        $0176544dd696ebe6$var$_propTypes.default.func,
        $0176544dd696ebe6$var$_propTypes.default.object
    ])
};


Object.keys($0176544dd696ebe6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in $08eee520e810d520$exports && $08eee520e810d520$exports[key] === $0176544dd696ebe6$exports[key]) return;
    Object.defineProperty($08eee520e810d520$exports, key, {
        enumerable: true,
        get: function() {
            return $0176544dd696ebe6$exports[key];
        }
    });
});
var $b46e33860b6061fb$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $b46e33860b6061fb$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $b46e33860b6061fb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($b46e33860b6061fb$exports, "__esModule", {
    value: true
});
$b46e33860b6061fb$exports.GridPagination = $b46e33860b6061fb$var$GridPagination;

var $b46e33860b6061fb$var$_extends2 = $b46e33860b6061fb$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $b46e33860b6061fb$var$React = $b46e33860b6061fb$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8xDHs = parcelRequire("8xDHs");

var $b46e33860b6061fb$var$_propTypes = $b46e33860b6061fb$require$_interopRequireDefault((parcelRequire("c9Z8w")));


var $5sOMZ = parcelRequire("5sOMZ");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");


var $ayMG0 = parcelRequire("ayMG0");
const $b46e33860b6061fb$var$GridPaginationRoot = (0, $8xDHs.styled)($dd66ac2a2c256d30$exports.NotRendered)({
    maxHeight: 'calc(100% + 1px)',
    // border width
    flexGrow: 1
});
function $b46e33860b6061fb$var$GridPagination() {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const paginationModel = (0, $5sOMZ.useGridSelector)(apiRef, $c41ec74257ca380c$exports.gridPaginationModelSelector);
    const rowCount = (0, $5sOMZ.useGridSelector)(apiRef, $c41ec74257ca380c$exports.gridPaginationRowCountSelector);
    const pageCount = (0, $5sOMZ.useGridSelector)(apiRef, $c41ec74257ca380c$exports.gridPageCountSelector);
    const { paginationMode: paginationMode, loading: loading } = rootProps;
    const disabled = rowCount === -1 && paginationMode === 'server' && loading;
    const lastPage = $b46e33860b6061fb$var$React.useMemo(()=>Math.max(0, pageCount - 1), [
        pageCount
    ]);
    const computedPage = $b46e33860b6061fb$var$React.useMemo(()=>{
        if (rowCount === -1) return paginationModel.page;
        return paginationModel.page <= lastPage ? paginationModel.page : lastPage;
    }, [
        lastPage,
        paginationModel.page,
        rowCount
    ]);
    const handlePageSizeChange = $b46e33860b6061fb$var$React.useCallback((pageSize)=>{
        apiRef.current.setPageSize(pageSize);
    }, [
        apiRef
    ]);
    const handlePageChange = $b46e33860b6061fb$var$React.useCallback((_, page)=>{
        apiRef.current.setPage(page);
    }, [
        apiRef
    ]);
    const isPageSizeIncludedInPageSizeOptions = (pageSize)=>{
        for(let i = 0; i < rootProps.pageSizeOptions.length; i += 1){
            const option = rootProps.pageSizeOptions[i];
            if (typeof option === 'number') {
                if (option === pageSize) return true;
            } else if (option.value === pageSize) return true;
        }
        return false;
    };
    {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const warnedOnceMissingInPageSizeOptions = $b46e33860b6061fb$var$React.useRef(false);
        const pageSize = rootProps.paginationModel?.pageSize ?? paginationModel.pageSize;
        if (!warnedOnceMissingInPageSizeOptions.current && !rootProps.autoPageSize && !isPageSizeIncludedInPageSizeOptions(pageSize)) {
            console.warn([
                `MUI X: The page size \`${paginationModel.pageSize}\` is not present in the \`pageSizeOptions\`.`,
                `Add it to show the pagination select.`
            ].join('\n'));
            warnedOnceMissingInPageSizeOptions.current = true;
        }
    }
    const pageSizeOptions = isPageSizeIncludedInPageSizeOptions(paginationModel.pageSize) ? rootProps.pageSizeOptions : [];
    return /*#__PURE__*/ (0, $ayMG0.jsx)($b46e33860b6061fb$var$GridPaginationRoot, (0, $b46e33860b6061fb$var$_extends2.default)({
        as: rootProps.slots.basePagination,
        count: rowCount,
        page: computedPage,
        rowsPerPageOptions: pageSizeOptions,
        rowsPerPage: paginationModel.pageSize,
        onPageChange: handlePageChange,
        onRowsPerPageChange: handlePageSizeChange,
        disabled: disabled
    }, rootProps.slotProps?.basePagination));
}
$b46e33860b6061fb$var$GridPagination.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    component: $b46e33860b6061fb$var$_propTypes.default.elementType
};


var $f5387d79a8532a8d$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f5387d79a8532a8d$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $f5387d79a8532a8d$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($f5387d79a8532a8d$exports, "__esModule", {
    value: true
});
$f5387d79a8532a8d$exports.GridRowCount = void 0;

var $f5387d79a8532a8d$var$_extends2 = $f5387d79a8532a8d$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $f5387d79a8532a8d$var$_objectWithoutPropertiesLoose2 = $f5387d79a8532a8d$require$_interopRequireDefault((parcelRequire("c05no")));

var $f5387d79a8532a8d$var$React = $f5387d79a8532a8d$require$_interopRequireWildcard((parcelRequire("acw62")));

var $f5387d79a8532a8d$var$_propTypes = $f5387d79a8532a8d$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $f5387d79a8532a8d$var$_clsx = $f5387d79a8532a8d$require$_interopRequireDefault((parcelRequire("9QePP")));

var $f5387d79a8532a8d$var$_composeClasses = $f5387d79a8532a8d$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $izOUK = parcelRequire("izOUK");

var $fYxgT = parcelRequire("fYxgT");

var $hbuUJ = parcelRequire("hbuUJ");

var $bDyDY = parcelRequire("bDyDY");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $f5387d79a8532a8d$var$_excluded = [
    "className",
    "rowCount",
    "visibleRowCount"
];
const $f5387d79a8532a8d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'rowCount'
        ]
    };
    return (0, $f5387d79a8532a8d$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $f5387d79a8532a8d$var$GridRowCountRoot = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'RowCount'
})({
    alignItems: 'center',
    display: 'flex',
    margin: $hbuUJ.vars.spacing(0, 2)
});
const $f5387d79a8532a8d$var$GridRowCount = $f5387d79a8532a8d$exports.GridRowCount = (0, $fYxgT.forwardRef)(function GridRowCount(props, ref) {
    const { className: className, rowCount: rowCount, visibleRowCount: visibleRowCount } = props, other = (0, $f5387d79a8532a8d$var$_objectWithoutPropertiesLoose2.default)(props, $f5387d79a8532a8d$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const ownerState = (0, $jDpXp.useGridRootProps)();
    const classes = $f5387d79a8532a8d$var$useUtilityClasses(ownerState);
    if (rowCount === 0) return null;
    const text = visibleRowCount < rowCount ? apiRef.current.getLocaleText('footerTotalVisibleRows')(visibleRowCount, rowCount) : rowCount.toLocaleString();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($f5387d79a8532a8d$var$GridRowCountRoot, (0, $f5387d79a8532a8d$var$_extends2.default)({
        className: (0, $f5387d79a8532a8d$var$_clsx.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        ref: ref,
        children: [
            apiRef.current.getLocaleText('footerTotalRows'),
            " ",
            text
        ]
    }));
});
$f5387d79a8532a8d$var$GridRowCount.displayName = "GridRowCount";
$f5387d79a8532a8d$var$GridRowCount.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    rowCount: $f5387d79a8532a8d$var$_propTypes.default.number.isRequired,
    sx: $f5387d79a8532a8d$var$_propTypes.default.oneOfType([
        $f5387d79a8532a8d$var$_propTypes.default.arrayOf($f5387d79a8532a8d$var$_propTypes.default.oneOfType([
            $f5387d79a8532a8d$var$_propTypes.default.func,
            $f5387d79a8532a8d$var$_propTypes.default.object,
            $f5387d79a8532a8d$var$_propTypes.default.bool
        ])),
        $f5387d79a8532a8d$var$_propTypes.default.func,
        $f5387d79a8532a8d$var$_propTypes.default.object
    ]),
    visibleRowCount: $f5387d79a8532a8d$var$_propTypes.default.number.isRequired
};


Object.keys($f5387d79a8532a8d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in $08eee520e810d520$exports && $08eee520e810d520$exports[key] === $f5387d79a8532a8d$exports[key]) return;
    Object.defineProperty($08eee520e810d520$exports, key, {
        enumerable: true,
        get: function() {
            return $f5387d79a8532a8d$exports[key];
        }
    });
});
var $f40172132c7a6c94$exports = {};
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $f40172132c7a6c94$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $f40172132c7a6c94$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($f40172132c7a6c94$exports, "__esModule", {
    value: true
});
$f40172132c7a6c94$exports.GridRow = void 0;

var $f40172132c7a6c94$var$_extends2 = $f40172132c7a6c94$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $f40172132c7a6c94$var$_objectWithoutPropertiesLoose2 = $f40172132c7a6c94$require$_interopRequireDefault((parcelRequire("c05no")));

var $f40172132c7a6c94$var$React = $f40172132c7a6c94$require$_interopRequireWildcard((parcelRequire("acw62")));

var $f40172132c7a6c94$var$_propTypes = $f40172132c7a6c94$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $f40172132c7a6c94$var$_clsx = $f40172132c7a6c94$require$_interopRequireDefault((parcelRequire("9QePP")));

var $f40172132c7a6c94$var$_useForkRef = $f40172132c7a6c94$require$_interopRequireDefault((parcelRequire("e4pKA")));


var $fYxgT = parcelRequire("fYxgT");



var $5H1vo = parcelRequire("5H1vo");
var $383097f5e5f6c068$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $383097f5e5f6c068$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($383097f5e5f6c068$exports, "__esModule", {
    value: true
});
$383097f5e5f6c068$exports.composeGridClasses = $383097f5e5f6c068$var$composeGridClasses;

var $383097f5e5f6c068$var$_composeClasses = $383097f5e5f6c068$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $5H1vo = parcelRequire("5H1vo");
function $383097f5e5f6c068$var$composeGridClasses(classes, slots) {
    return (0, $383097f5e5f6c068$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
}



var $jDpXp = parcelRequire("jDpXp");



var $5sOMZ = parcelRequire("5sOMZ");








var $61b0f70231b1e493$exports = {};
"use strict";
Object.defineProperty($61b0f70231b1e493$exports, "__esModule", {
    value: true
});
$61b0f70231b1e493$exports.gridRowReorderStateSelector = $61b0f70231b1e493$exports.gridRowDropTargetSelector = $61b0f70231b1e493$exports.gridRowDropTargetRowIdSelector = $61b0f70231b1e493$exports.gridRowDropPositionSelector = $61b0f70231b1e493$exports.gridIsRowDragActiveSelector = $61b0f70231b1e493$exports.gridDraggedRowIdSelector = void 0;

const $61b0f70231b1e493$var$gridRowReorderStateSelector = $61b0f70231b1e493$exports.gridRowReorderStateSelector = (0, $8eef5f2af445e503$exports.createRootSelector)((state)=>state.rowReorder);
const $61b0f70231b1e493$var$gridIsRowDragActiveSelector = $61b0f70231b1e493$exports.gridIsRowDragActiveSelector = (0, $8eef5f2af445e503$exports.createSelector)($61b0f70231b1e493$var$gridRowReorderStateSelector, (rowReorder)=>rowReorder?.isActive ?? false);
// Selector for the entire drop target state
const $61b0f70231b1e493$var$gridRowDropTargetSelector = $61b0f70231b1e493$exports.gridRowDropTargetSelector = (0, $8eef5f2af445e503$exports.createSelector)($61b0f70231b1e493$var$gridRowReorderStateSelector, (rowReorder)=>rowReorder?.dropTarget ?? {
        rowId: null,
        position: null
    });
const $61b0f70231b1e493$var$gridRowDropTargetRowIdSelector = $61b0f70231b1e493$exports.gridRowDropTargetRowIdSelector = (0, $8eef5f2af445e503$exports.createSelector)($61b0f70231b1e493$var$gridRowDropTargetSelector, (dropTarget)=>dropTarget.rowId ?? null);
// Selector for a specific row's drop position
const $61b0f70231b1e493$var$gridRowDropPositionSelector = $61b0f70231b1e493$exports.gridRowDropPositionSelector = (0, $8eef5f2af445e503$exports.createSelector)($61b0f70231b1e493$var$gridRowDropTargetSelector, (dropTarget, rowId)=>{
    if (dropTarget.rowId === rowId) return dropTarget.position;
    return null;
});
// Selector for the dragged row ID
const $61b0f70231b1e493$var$gridDraggedRowIdSelector = $61b0f70231b1e493$exports.gridDraggedRowIdSelector = (0, $8eef5f2af445e503$exports.createSelector)($61b0f70231b1e493$var$gridRowReorderStateSelector, (rowReorder)=>rowReorder?.draggedRowId ?? null);


var $27be4e54a8466a0c$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $27be4e54a8466a0c$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $27be4e54a8466a0c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($27be4e54a8466a0c$exports, "__esModule", {
    value: true
});
$27be4e54a8466a0c$exports.GridRowDragAndDropOverlay = void 0;

var $27be4e54a8466a0c$var$_extends2 = $27be4e54a8466a0c$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $27be4e54a8466a0c$var$React = $27be4e54a8466a0c$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8xDHs = parcelRequire("8xDHs");

var $bbeCr = parcelRequire("bbeCr");

var $er55f = parcelRequire("er55f");

var $5sOMZ = parcelRequire("5sOMZ");


var $ayMG0 = parcelRequire("ayMG0");
const $27be4e54a8466a0c$var$GridRowDragAndDropOverlayRoot = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'RowDragOverlay',
    shouldForwardProp: (prop)=>(0, $bbeCr.shouldForwardProp)(prop) && prop !== 'action'
})(({ theme: theme, action: action })=>(0, $27be4e54a8466a0c$var$_extends2.default)({
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        pointerEvents: 'none',
        zIndex: 1
    }, action === 'above' && {
        '&::before': {
            pointerEvents: 'none',
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '2px',
            backgroundColor: (theme.vars || theme).palette.primary.main
        }
    }, action === 'below' && {
        '&::after': {
            pointerEvents: 'none',
            content: '""',
            position: 'absolute',
            bottom: '-2px',
            left: 0,
            right: 0,
            height: '2px',
            backgroundColor: (theme.vars || theme).palette.primary.main
        }
    }, action === 'inside' && {
        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / 0.1)` : (0, $8xDHs.alpha)(theme.palette.primary.main, 0.1)
    }));
const $27be4e54a8466a0c$var$GridRowDragAndDropOverlay = $27be4e54a8466a0c$exports.GridRowDragAndDropOverlay = /*#__PURE__*/ $27be4e54a8466a0c$var$React.memo(function GridRowDragAndDropOverlay(props) {
    const { rowId: rowId, className: className } = props;
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const dropPosition = (0, $5sOMZ.useGridSelector)(apiRef, $61b0f70231b1e493$exports.gridRowDropPositionSelector, rowId);
    if (!dropPosition) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($27be4e54a8466a0c$var$GridRowDragAndDropOverlayRoot, {
        action: dropPosition,
        className: className
    });
});
$27be4e54a8466a0c$var$GridRowDragAndDropOverlay.displayName = "GridRowDragAndDropOverlay";





var $er55f = parcelRequire("er55f");


var $ayMG0 = parcelRequire("ayMG0");
const $f40172132c7a6c94$var$_excluded = [
    "selected",
    "rowId",
    "row",
    "index",
    "style",
    "rowHeight",
    "className",
    "visibleColumns",
    "pinnedColumns",
    "offsetLeft",
    "columnsTotalWidth",
    "firstColumnIndex",
    "lastColumnIndex",
    "focusedColumnIndex",
    "isFirstVisible",
    "isLastVisible",
    "isNotVisible",
    "showBottomBorder",
    "scrollbarWidth",
    "gridHasFiller",
    "onClick",
    "onDoubleClick",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseOut",
    "onMouseOver"
];
const $f40172132c7a6c94$var$isRowReorderingEnabledSelector = (0, $8eef5f2af445e503$exports.createSelector)($443dd6b911893b50$exports.gridEditRowsStateSelector, (editRows, { rowReordering: rowReordering, treeData: treeData })=>{
    if (!rowReordering || treeData) return false;
    const isEditingRows = !(0, $57908709a849d718$exports.isObjectEmpty)(editRows);
    return !isEditingRows;
});
const $f40172132c7a6c94$var$GridRow = (0, $fYxgT.forwardRef)(function GridRow(props, refProp) {
    const { selected: selected, rowId: rowId, row: row, index: index, style: styleProp, rowHeight: rowHeight, className: className, visibleColumns: visibleColumns, pinnedColumns: pinnedColumns, offsetLeft: offsetLeft, columnsTotalWidth: columnsTotalWidth, firstColumnIndex: firstColumnIndex, lastColumnIndex: lastColumnIndex, focusedColumnIndex: focusedColumnIndex, isFirstVisible: isFirstVisible, isLastVisible: isLastVisible, isNotVisible: isNotVisible, showBottomBorder: showBottomBorder, scrollbarWidth: scrollbarWidth, gridHasFiller: gridHasFiller, onClick: onClick, onDoubleClick: onDoubleClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseOut: onMouseOut, onMouseOver: onMouseOver } = props, other = (0, $f40172132c7a6c94$var$_objectWithoutPropertiesLoose2.default)(props, $f40172132c7a6c94$var$_excluded);
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const configuration = (0, $2b6c64068d1db0b4$exports.useGridConfiguration)();
    const ref = $f40172132c7a6c94$var$React.useRef(null);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const currentPage = (0, $7d0a5941a1add073$exports.useGridVisibleRows)(apiRef, rootProps);
    const sortModel = (0, $5sOMZ.useGridSelector)(apiRef, $dc3028b3b629fae7$exports.gridSortModelSelector);
    const columnPositions = (0, $5sOMZ.useGridSelector)(apiRef, $e732684465924d20$exports.gridColumnPositionsSelector);
    const rowReordering = rootProps.rowReordering;
    const treeData = rootProps.treeData;
    const isRowReorderingEnabled = (0, $5sOMZ.useGridSelector)(apiRef, $f40172132c7a6c94$var$isRowReorderingEnabledSelector, {
        rowReordering: rowReordering,
        treeData: treeData
    });
    const isRowDragActive = (0, $5sOMZ.useGridSelector)(apiRef, $61b0f70231b1e493$exports.gridIsRowDragActiveSelector);
    const handleRef = (0, $f40172132c7a6c94$var$_useForkRef.default)(ref, refProp);
    const rowNode = (0, $befccaa56b49492d$exports.gridRowNodeSelector)(apiRef, rowId);
    const editing = (0, $5sOMZ.useGridSelector)(apiRef, $443dd6b911893b50$exports.gridRowIsEditingSelector, {
        rowId: rowId,
        editMode: rootProps.editMode
    });
    const editable = rootProps.editMode === $e139707caeafbfd6$exports.GridEditModes.Row;
    const hasFocusCell = focusedColumnIndex !== undefined;
    const hasVirtualFocusCellLeft = hasFocusCell && focusedColumnIndex >= pinnedColumns.left.length && focusedColumnIndex < firstColumnIndex;
    const hasVirtualFocusCellRight = hasFocusCell && focusedColumnIndex < visibleColumns.length - pinnedColumns.right.length && focusedColumnIndex >= lastColumnIndex;
    const classes = (0, $383097f5e5f6c068$exports.composeGridClasses)(rootProps.classes, {
        root: [
            'row',
            selected && 'selected',
            editable && 'row--editable',
            editing && 'row--editing',
            isFirstVisible && 'row--firstVisible',
            isLastVisible && 'row--lastVisible',
            showBottomBorder && 'row--borderBottom',
            rowHeight === 'auto' && 'row--dynamicHeight'
        ]
    });
    const getRowAriaAttributes = configuration.hooks.useGridRowAriaAttributes();
    $f40172132c7a6c94$var$React.useLayoutEffect(()=>{
        if (currentPage.range) {
            const rowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(rowId);
            // Pinned rows are not part of the visible rows
            if (rowIndex !== undefined) apiRef.current.unstable_setLastMeasuredRowIndex(rowIndex);
        }
        if (ref.current && rowHeight === 'auto') return apiRef.current.observeRowHeight(ref.current, rowId);
        return undefined;
    }, [
        apiRef,
        currentPage.range,
        rowHeight,
        rowId
    ]);
    const publish = $f40172132c7a6c94$var$React.useCallback((eventName, propHandler)=>(event)=>{
            // Ignore portal
            if ((0, $08bb4bf24f47b880$exports.isEventTargetInPortal)(event)) return;
            // The row might have been deleted
            if (!apiRef.current.getRow(rowId)) return;
            apiRef.current.publishEvent(eventName, apiRef.current.getRowParams(rowId), event);
            if (propHandler) propHandler(event);
        }, [
        apiRef,
        rowId
    ]);
    const publishClick = $f40172132c7a6c94$var$React.useCallback((event)=>{
        const cell = (0, $08bb4bf24f47b880$exports.findParentElementFromClassName)(event.target, $5H1vo.gridClasses.cell);
        const field = cell?.getAttribute('data-field');
        // Check if the field is available because the cell that fills the empty
        // space of the row has no field.
        if (field) {
            // User clicked in the checkbox added by checkboxSelection
            if (field === $3c6ea315aeb792f9$exports.GRID_CHECKBOX_SELECTION_COL_DEF.field) return;
            // User opened a detail panel
            if (field === $e8d35a7c12bdaa1d$exports.GRID_DETAIL_PANEL_TOGGLE_FIELD) return;
            // User reorders a row
            if (field === '__reorder__') return;
            // User is editing a cell
            if (apiRef.current.getCellMode(rowId, field) === $e139707caeafbfd6$exports.GridCellModes.Edit) return;
            // User clicked a button from the "actions" column type
            const column = apiRef.current.getColumn(field);
            if (column?.type === $63c3e445c9bf0af1$exports.GRID_ACTIONS_COLUMN_TYPE) return;
        }
        publish('rowClick', onClick)(event);
    }, [
        apiRef,
        onClick,
        publish,
        rowId
    ]);
    const { slots: slots, slotProps: slotProps, disableColumnReorder: disableColumnReorder } = rootProps;
    const heightEntry = (0, $5sOMZ.useGridSelector)(apiRef, ()=>(0, $f40172132c7a6c94$var$_extends2.default)({}, apiRef.current.getRowHeightEntry(rowId)), undefined, $5sOMZ.objectShallowCompare);
    const style = $f40172132c7a6c94$var$React.useMemo(()=>{
        if (isNotVisible) return {
            opacity: 0,
            width: 0,
            height: 0
        };
        const rowStyle = (0, $f40172132c7a6c94$var$_extends2.default)({}, styleProp, {
            maxHeight: rowHeight === 'auto' ? 'none' : rowHeight,
            // max-height doesn't support "auto"
            minHeight: rowHeight,
            '--height': typeof rowHeight === 'number' ? `${rowHeight}px` : rowHeight
        });
        if (heightEntry.spacingTop) {
            const property = rootProps.rowSpacingType === 'border' ? 'borderTopWidth' : 'marginTop';
            rowStyle[property] = heightEntry.spacingTop;
        }
        if (heightEntry.spacingBottom) {
            const property = rootProps.rowSpacingType === 'border' ? 'borderBottomWidth' : 'marginBottom';
            let propertyValue = rowStyle[property];
            // avoid overriding existing value
            if (typeof propertyValue !== 'number') propertyValue = parseInt(propertyValue || '0', 10);
            propertyValue += heightEntry.spacingBottom;
            rowStyle[property] = propertyValue;
        }
        return rowStyle;
    }, [
        isNotVisible,
        rowHeight,
        styleProp,
        heightEntry.spacingTop,
        heightEntry.spacingBottom,
        rootProps.rowSpacingType
    ]);
    // HACK: Sometimes, the rowNode has already been removed from the state but the row is still rendered.
    if (!rowNode) return null;
    const rowClassNames = apiRef.current.unstable_applyPipeProcessors('rowClassName', [], rowId);
    const ariaAttributes = getRowAriaAttributes(rowNode, index);
    if (typeof rootProps.getRowClassName === 'function') {
        const indexRelativeToCurrentPage = index - (currentPage.range?.firstRowIndex || 0);
        const rowParams = (0, $f40172132c7a6c94$var$_extends2.default)({}, apiRef.current.getRowParams(rowId), {
            isFirstVisible: indexRelativeToCurrentPage === 0,
            isLastVisible: indexRelativeToCurrentPage === currentPage.rows.length - 1,
            indexRelativeToCurrentPage: indexRelativeToCurrentPage
        });
        rowClassNames.push(rootProps.getRowClassName(rowParams));
    }
    const getCell = (column, indexInSection, indexRelativeToAllColumns, sectionLength, pinnedPosition = $e8d35a7c12bdaa1d$exports.PinnedColumnPosition.NONE)=>{
        const cellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, indexRelativeToAllColumns);
        if (cellColSpanInfo?.spannedByColSpan) return null;
        const width = cellColSpanInfo?.cellProps.width ?? column.computedWidth;
        const colSpan = cellColSpanInfo?.cellProps.colSpan ?? 1;
        const pinnedOffset = (0, $e85ba38bf3b586f5$exports.getPinnedCellOffset)(pinnedPosition, column.computedWidth, indexRelativeToAllColumns, columnPositions, columnsTotalWidth, scrollbarWidth);
        if (rowNode.type === 'skeletonRow') return /*#__PURE__*/ (0, $ayMG0.jsx)(slots.skeletonCell, {
            type: column.type,
            width: width,
            height: rowHeight,
            field: column.field,
            align: column.align
        }, column.field);
        // when the cell is a reorder cell we are not allowing to reorder the col
        // fixes https://github.com/mui/mui-x/issues/11126
        const isReorderCell = column.field === '__reorder__';
        const canReorderColumn = !(disableColumnReorder || column.disableReorder);
        const canReorderRow = isRowReorderingEnabled && !sortModel.length;
        const disableDragEvents = !(canReorderColumn || isReorderCell && canReorderRow || isRowDragActive);
        const cellIsNotVisible = pinnedPosition === $e8d35a7c12bdaa1d$exports.PinnedColumnPosition.VIRTUAL;
        const showLeftBorder = (0, $f6d1081691c64c11$exports.shouldCellShowLeftBorder)(pinnedPosition, indexInSection, rootProps.showCellVerticalBorder, rootProps.pinnedColumnsSectionSeparator);
        const showRightBorder = (0, $f6d1081691c64c11$exports.shouldCellShowRightBorder)(pinnedPosition, indexInSection, sectionLength, rootProps.showCellVerticalBorder, gridHasFiller, rootProps.pinnedColumnsSectionSeparator);
        return /*#__PURE__*/ (0, $ayMG0.jsx)(slots.cell, (0, $f40172132c7a6c94$var$_extends2.default)({
            column: column,
            width: width,
            rowId: rowId,
            align: column.align || 'left',
            colIndex: indexRelativeToAllColumns,
            colSpan: colSpan,
            disableDragEvents: disableDragEvents,
            isNotVisible: cellIsNotVisible,
            pinnedOffset: pinnedOffset,
            pinnedPosition: pinnedPosition,
            showLeftBorder: showLeftBorder,
            showRightBorder: showRightBorder,
            row: row,
            rowNode: rowNode
        }, slotProps?.cell), column.field);
    };
    getCell.displayName = "getCell";
    const leftCells = pinnedColumns.left.map((column, i)=>{
        const indexRelativeToAllColumns = i;
        return getCell(column, i, indexRelativeToAllColumns, pinnedColumns.left.length, $e8d35a7c12bdaa1d$exports.PinnedColumnPosition.LEFT);
    });
    const rightCells = pinnedColumns.right.map((column, i)=>{
        const indexRelativeToAllColumns = visibleColumns.length - pinnedColumns.right.length + i;
        return getCell(column, i, indexRelativeToAllColumns, pinnedColumns.right.length, $e8d35a7c12bdaa1d$exports.PinnedColumnPosition.RIGHT);
    });
    const middleColumnsLength = visibleColumns.length - pinnedColumns.left.length - pinnedColumns.right.length;
    const cells = [];
    if (hasVirtualFocusCellLeft) cells.push(getCell(visibleColumns[focusedColumnIndex], focusedColumnIndex - pinnedColumns.left.length, focusedColumnIndex, middleColumnsLength, $e8d35a7c12bdaa1d$exports.PinnedColumnPosition.VIRTUAL));
    for(let i = firstColumnIndex; i < lastColumnIndex; i += 1){
        const column = visibleColumns[i];
        const indexInSection = i - pinnedColumns.left.length;
        if (!column) continue;
        cells.push(getCell(column, indexInSection, i, middleColumnsLength));
    }
    if (hasVirtualFocusCellRight) cells.push(getCell(visibleColumns[focusedColumnIndex], focusedColumnIndex - pinnedColumns.left.length, focusedColumnIndex, middleColumnsLength, $e8d35a7c12bdaa1d$exports.PinnedColumnPosition.VIRTUAL));
    const eventHandlers = row ? {
        onClick: publishClick,
        onDoubleClick: publish('rowDoubleClick', onDoubleClick),
        onMouseEnter: publish('rowMouseEnter', onMouseEnter),
        onMouseLeave: publish('rowMouseLeave', onMouseLeave),
        onMouseOut: publish('rowMouseOut', onMouseOut),
        onMouseOver: publish('rowMouseOver', onMouseOver)
    } : null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", (0, $f40172132c7a6c94$var$_extends2.default)({
        "data-id": rowId,
        "data-rowindex": index,
        role: "row",
        className: (0, $f40172132c7a6c94$var$_clsx.default)(...rowClassNames, classes.root, className),
        style: style
    }, ariaAttributes, eventHandlers, other, {
        ref: handleRef,
        children: [
            leftCells,
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "presentation",
                className: $5H1vo.gridClasses.cellOffsetLeft,
                style: {
                    width: offsetLeft
                }
            }),
            cells,
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "presentation",
                className: (0, $f40172132c7a6c94$var$_clsx.default)($5H1vo.gridClasses.cell, $5H1vo.gridClasses.cellEmpty)
            }),
            rightCells,
            /*#__PURE__*/ (0, $ayMG0.jsx)($27be4e54a8466a0c$exports.GridRowDragAndDropOverlay, {
                rowId: rowId
            })
        ]
    }));
});
$f40172132c7a6c94$var$GridRow.displayName = "GridRow";
$f40172132c7a6c94$var$GridRow.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    columnsTotalWidth: $f40172132c7a6c94$var$_propTypes.default.number.isRequired,
    firstColumnIndex: $f40172132c7a6c94$var$_propTypes.default.number.isRequired,
    /**
   * Determines which cell has focus.
   * If `null`, no cell in this row has focus.
   */ focusedColumnIndex: $f40172132c7a6c94$var$_propTypes.default.number,
    gridHasFiller: $f40172132c7a6c94$var$_propTypes.default.bool.isRequired,
    /**
   * Index of the row in the whole sorted and filtered dataset.
   * If some rows above have expanded children, this index also take those children into account.
   */ index: $f40172132c7a6c94$var$_propTypes.default.number.isRequired,
    isFirstVisible: $f40172132c7a6c94$var$_propTypes.default.bool.isRequired,
    isLastVisible: $f40172132c7a6c94$var$_propTypes.default.bool.isRequired,
    isNotVisible: $f40172132c7a6c94$var$_propTypes.default.bool.isRequired,
    lastColumnIndex: $f40172132c7a6c94$var$_propTypes.default.number.isRequired,
    offsetLeft: $f40172132c7a6c94$var$_propTypes.default.number.isRequired,
    onClick: $f40172132c7a6c94$var$_propTypes.default.func,
    onDoubleClick: $f40172132c7a6c94$var$_propTypes.default.func,
    onMouseEnter: $f40172132c7a6c94$var$_propTypes.default.func,
    onMouseLeave: $f40172132c7a6c94$var$_propTypes.default.func,
    pinnedColumns: $f40172132c7a6c94$var$_propTypes.default.object.isRequired,
    row: $f40172132c7a6c94$var$_propTypes.default.object.isRequired,
    rowHeight: $f40172132c7a6c94$var$_propTypes.default.oneOfType([
        $f40172132c7a6c94$var$_propTypes.default.oneOf([
            'auto'
        ]),
        $f40172132c7a6c94$var$_propTypes.default.number
    ]).isRequired,
    rowId: $f40172132c7a6c94$var$_propTypes.default.oneOfType([
        $f40172132c7a6c94$var$_propTypes.default.number,
        $f40172132c7a6c94$var$_propTypes.default.string
    ]).isRequired,
    scrollbarWidth: $f40172132c7a6c94$var$_propTypes.default.number.isRequired,
    selected: $f40172132c7a6c94$var$_propTypes.default.bool.isRequired,
    showBottomBorder: $f40172132c7a6c94$var$_propTypes.default.bool.isRequired,
    visibleColumns: $f40172132c7a6c94$var$_propTypes.default.arrayOf($f40172132c7a6c94$var$_propTypes.default.object).isRequired
};
const $f40172132c7a6c94$var$MemoizedGridRow = $f40172132c7a6c94$exports.GridRow = (0, $1bc1b286f3c678cc$exports.fastMemo)($f40172132c7a6c94$var$GridRow);


Object.keys($f40172132c7a6c94$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in $08eee520e810d520$exports && $08eee520e810d520$exports[key] === $f40172132c7a6c94$exports[key]) return;
    Object.defineProperty($08eee520e810d520$exports, key, {
        enumerable: true,
        get: function() {
            return $f40172132c7a6c94$exports[key];
        }
    });
});

Object.keys($b80f871a1017d664$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in $08eee520e810d520$exports && $08eee520e810d520$exports[key] === $b80f871a1017d664$exports[key]) return;
    Object.defineProperty($08eee520e810d520$exports, key, {
        enumerable: true,
        get: function() {
            return $b80f871a1017d664$exports[key];
        }
    });
});

Object.keys($5b8c70a8582b44e6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in $08eee520e810d520$exports && $08eee520e810d520$exports[key] === $5b8c70a8582b44e6$exports[key]) return;
    Object.defineProperty($08eee520e810d520$exports, key, {
        enumerable: true,
        get: function() {
            return $5b8c70a8582b44e6$exports[key];
        }
    });
});

Object.keys($f2fd14510a79bbd4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in $08eee520e810d520$exports && $08eee520e810d520$exports[key] === $f2fd14510a79bbd4$exports[key]) return;
    Object.defineProperty($08eee520e810d520$exports, key, {
        enumerable: true,
        get: function() {
            return $f2fd14510a79bbd4$exports[key];
        }
    });
});

Object.keys($c43d0959e479160d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in $08eee520e810d520$exports && $08eee520e810d520$exports[key] === $c43d0959e479160d$exports[key]) return;
    Object.defineProperty($08eee520e810d520$exports, key, {
        enumerable: true,
        get: function() {
            return $c43d0959e479160d$exports[key];
        }
    });
});

Object.keys($9f39e34235240409$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in $08eee520e810d520$exports && $08eee520e810d520$exports[key] === $9f39e34235240409$exports[key]) return;
    Object.defineProperty($08eee520e810d520$exports, key, {
        enumerable: true,
        get: function() {
            return $9f39e34235240409$exports[key];
        }
    });
});

Object.keys($4aec1101d1789fa4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in $08eee520e810d520$exports && $08eee520e810d520$exports[key] === $4aec1101d1789fa4$exports[key]) return;
    Object.defineProperty($08eee520e810d520$exports, key, {
        enumerable: true,
        get: function() {
            return $4aec1101d1789fa4$exports[key];
        }
    });
});

Object.keys($b480793493089ce5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in $08eee520e810d520$exports && $08eee520e810d520$exports[key] === $b480793493089ce5$exports[key]) return;
    Object.defineProperty($08eee520e810d520$exports, key, {
        enumerable: true,
        get: function() {
            return $b480793493089ce5$exports[key];
        }
    });
});


var $3fc22bf49019df83$exports = {};
"use strict";
Object.defineProperty($3fc22bf49019df83$exports, "__esModule", {
    value: true
});
$3fc22bf49019df83$exports.useGridAriaAttributes = void 0;


var $5sOMZ = parcelRequire("5sOMZ");

var $jDpXp = parcelRequire("jDpXp");



var $er55f = parcelRequire("er55f");


const $3fc22bf49019df83$var$useGridAriaAttributes = ()=>{
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const visibleColumns = (0, $5sOMZ.useGridSelector)(apiRef, $e732684465924d20$exports.gridVisibleColumnDefinitionsSelector);
    const accessibleRowCount = (0, $5sOMZ.useGridSelector)(apiRef, $e95988b653de2e96$exports.gridExpandedRowCountSelector);
    const headerGroupingMaxDepth = (0, $5sOMZ.useGridSelector)(apiRef, $cf21d895912d975b$exports.gridColumnGroupsHeaderMaxDepthSelector);
    const pinnedRowsCount = (0, $5sOMZ.useGridSelector)(apiRef, $befccaa56b49492d$exports.gridPinnedRowsCountSelector);
    const ariaLabel = rootProps['aria-label'];
    const ariaLabelledby = rootProps['aria-labelledby'];
    // `aria-label` and `aria-labelledby` should take precedence over `label`
    const shouldUseLabelAsAriaLabel = !ariaLabel && !ariaLabelledby && rootProps.label;
    return {
        role: 'grid',
        'aria-label': shouldUseLabelAsAriaLabel ? rootProps.label : ariaLabel,
        'aria-labelledby': ariaLabelledby,
        'aria-colcount': visibleColumns.length,
        'aria-rowcount': headerGroupingMaxDepth + 1 + pinnedRowsCount + accessibleRowCount,
        'aria-multiselectable': (0, $dae18049c8685698$exports.isMultipleRowSelectionEnabled)(rootProps)
    };
};
$3fc22bf49019df83$exports.useGridAriaAttributes = $3fc22bf49019df83$var$useGridAriaAttributes;


var $678bcf5a7d335a8a$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $678bcf5a7d335a8a$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($678bcf5a7d335a8a$exports, "__esModule", {
    value: true
});
$678bcf5a7d335a8a$exports.useGridRowAriaAttributes = void 0;

var $678bcf5a7d335a8a$var$React = $678bcf5a7d335a8a$require$_interopRequireWildcard((parcelRequire("acw62")));

var $5sOMZ = parcelRequire("5sOMZ");


var $er55f = parcelRequire("er55f");
const $678bcf5a7d335a8a$var$useGridRowAriaAttributes = ()=>{
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const headerGroupingMaxDepth = (0, $5sOMZ.useGridSelector)(apiRef, $cf21d895912d975b$exports.gridColumnGroupsHeaderMaxDepthSelector);
    return $678bcf5a7d335a8a$var$React.useCallback((rowNode, index)=>{
        const ariaAttributes = {};
        const ariaRowIndex = index + headerGroupingMaxDepth + 2; // 1 for the header row and 1 as it's 1-based
        ariaAttributes['aria-rowindex'] = ariaRowIndex;
        // XXX: fix this properly
        if (rowNode && apiRef.current.isRowSelectable(rowNode.id)) ariaAttributes['aria-selected'] = apiRef.current.isRowSelected(rowNode.id);
        return ariaAttributes;
    }, [
        apiRef,
        headerGroupingMaxDepth
    ]);
};
$678bcf5a7d335a8a$exports.useGridRowAriaAttributes = $678bcf5a7d335a8a$var$useGridRowAriaAttributes;


var $50188751eb2724d1$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $50188751eb2724d1$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $50188751eb2724d1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($50188751eb2724d1$exports, "__esModule", {
    value: true
});
$50188751eb2724d1$exports.useGridRowsOverridableMethods = void 0;

var $50188751eb2724d1$var$_extends2 = $50188751eb2724d1$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $50188751eb2724d1$var$React = $50188751eb2724d1$require$_interopRequireWildcard((parcelRequire("acw62")));



const $50188751eb2724d1$var$useGridRowsOverridableMethods = (apiRef)=>{
    const setRowPosition = $50188751eb2724d1$var$React.useCallback((sourceRowId, targetRowId, position)=>{
        const sourceNode = (0, $befccaa56b49492d$exports.gridRowNodeSelector)(apiRef, sourceRowId);
        const targetNode = (0, $befccaa56b49492d$exports.gridRowNodeSelector)(apiRef, targetRowId);
        if (!sourceNode) throw new Error(`MUI X: No row with id #${sourceRowId} found.`);
        if (!targetNode) throw new Error(`MUI X: No row with id #${targetRowId} found.`);
        if (sourceNode.type !== 'leaf') throw new Error(`MUI X: The row reordering does not support reordering of footer or grouping rows.`);
        if (position === 'inside') throw new Error(`MUI X: The 'inside' position is only supported for tree data. Use 'above' or 'below' for flat data.`);
        // Get the target index from the targetRowId using the lookup selector
        const sortedFilteredRowIndexLookup = (0, $e95988b653de2e96$exports.gridExpandedSortedRowIndexLookupSelector)(apiRef);
        const targetRowIndexUnadjusted = sortedFilteredRowIndexLookup[targetRowId];
        if (targetRowIndexUnadjusted === undefined) throw new Error(`MUI X: Target row with id #${targetRowId} not found in current view.`);
        const sourceRowIndex = sortedFilteredRowIndexLookup[sourceRowId];
        if (sourceRowIndex === undefined) throw new Error(`MUI X: Source row with id #${sourceRowId} not found in current view.`);
        const dragDirection = targetRowIndexUnadjusted < sourceRowIndex ? 'up' : 'down';
        let targetRowIndex;
        if (dragDirection === 'up') targetRowIndex = position === 'above' ? targetRowIndexUnadjusted : targetRowIndexUnadjusted + 1;
        else targetRowIndex = position === 'above' ? targetRowIndexUnadjusted - 1 : targetRowIndexUnadjusted;
        if (targetRowIndex === sourceRowIndex) return;
        apiRef.current.setState((state)=>{
            const group = (0, $befccaa56b49492d$exports.gridRowTreeSelector)(apiRef)[$0166dd44615cae0d$exports.GRID_ROOT_GROUP_ID];
            const allRows = group.children;
            const updatedRows = [
                ...allRows
            ];
            updatedRows.splice(targetRowIndex, 0, updatedRows.splice(sourceRowIndex, 1)[0]);
            return (0, $50188751eb2724d1$var$_extends2.default)({}, state, {
                rows: (0, $50188751eb2724d1$var$_extends2.default)({}, state.rows, {
                    tree: (0, $50188751eb2724d1$var$_extends2.default)({}, state.rows.tree, {
                        [$0166dd44615cae0d$exports.GRID_ROOT_GROUP_ID]: (0, $50188751eb2724d1$var$_extends2.default)({}, group, {
                            children: updatedRows
                        })
                    })
                })
            });
        });
        apiRef.current.publishEvent('rowsSet');
    }, [
        apiRef
    ]);
    const setRowIndex = $50188751eb2724d1$var$React.useCallback((rowId, targetIndex)=>{
        const node = (0, $befccaa56b49492d$exports.gridRowNodeSelector)(apiRef, rowId);
        if (!node) throw new Error(`MUI X: No row with id #${rowId} found.`);
        if (node.type !== 'leaf') throw new Error(`MUI X: The row reordering does not support reordering of footer or grouping rows.`);
        apiRef.current.setState((state)=>{
            const group = (0, $befccaa56b49492d$exports.gridRowTreeSelector)(apiRef)[$0166dd44615cae0d$exports.GRID_ROOT_GROUP_ID];
            const allRows = group.children;
            const oldIndex = allRows.findIndex((row)=>row === rowId);
            if (oldIndex === -1 || oldIndex === targetIndex) return state;
            const updatedRows = [
                ...allRows
            ];
            updatedRows.splice(targetIndex, 0, updatedRows.splice(oldIndex, 1)[0]);
            return (0, $50188751eb2724d1$var$_extends2.default)({}, state, {
                rows: (0, $50188751eb2724d1$var$_extends2.default)({}, state.rows, {
                    tree: (0, $50188751eb2724d1$var$_extends2.default)({}, state.rows.tree, {
                        [$0166dd44615cae0d$exports.GRID_ROOT_GROUP_ID]: (0, $50188751eb2724d1$var$_extends2.default)({}, group, {
                            children: updatedRows
                        })
                    })
                })
            });
        });
        apiRef.current.publishEvent('rowsSet');
    }, [
        apiRef
    ]);
    return {
        setRowIndex: setRowIndex,
        setRowPosition: setRowPosition
    };
};
$50188751eb2724d1$exports.useGridRowsOverridableMethods = $50188751eb2724d1$var$useGridRowsOverridableMethods;


var $603a3e97252d3bf4$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $603a3e97252d3bf4$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($603a3e97252d3bf4$exports, "__esModule", {
    value: true
});
$603a3e97252d3bf4$exports.useGridParamsOverridableMethods = void 0;

var $603a3e97252d3bf4$var$React = $603a3e97252d3bf4$require$_interopRequireWildcard((parcelRequire("acw62")));

const $603a3e97252d3bf4$var$useGridParamsOverridableMethods = (apiRef)=>{
    const getCellValue = $603a3e97252d3bf4$var$React.useCallback((id, field)=>{
        const colDef = apiRef.current.getColumn(field);
        const row = apiRef.current.getRow(id);
        if (!row) throw new Error(`No row with id #${id} found`);
        if (!colDef || !colDef.valueGetter) return row[field];
        return colDef.valueGetter(row[colDef.field], row, colDef, apiRef);
    }, [
        apiRef
    ]);
    const getRowValue = $603a3e97252d3bf4$var$React.useCallback((row, colDef)=>(0, $0166dd44615cae0d$exports.getRowValue)(row, colDef, apiRef), [
        apiRef
    ]);
    const getRowFormattedValue = $603a3e97252d3bf4$var$React.useCallback((row, colDef)=>{
        const value = getRowValue(row, colDef);
        if (!colDef || !colDef.valueFormatter) return value;
        return colDef.valueFormatter(value, row, colDef, apiRef);
    }, [
        apiRef,
        getRowValue
    ]);
    return {
        getCellValue: getCellValue,
        getRowValue: getRowValue,
        getRowFormattedValue: getRowFormattedValue
    };
};
$603a3e97252d3bf4$exports.useGridParamsOverridableMethods = $603a3e97252d3bf4$var$useGridParamsOverridableMethods;


var $095cd0a8de7ac37d$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $095cd0a8de7ac37d$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($095cd0a8de7ac37d$exports, "__esModule", {
    value: true
});
$095cd0a8de7ac37d$exports.useIsCellEditable = void 0;

var $095cd0a8de7ac37d$var$React = $095cd0a8de7ac37d$require$_interopRequireWildcard((parcelRequire("acw62")));

/**
 * Default implementation of the cell editable condition hook
 */ const $095cd0a8de7ac37d$var$useIsCellEditable = ()=>$095cd0a8de7ac37d$var$React.useCallback((params)=>!(0, $0166dd44615cae0d$exports.isAutogeneratedRowNode)(params.rowNode), []);
$095cd0a8de7ac37d$exports.useIsCellEditable = $095cd0a8de7ac37d$var$useIsCellEditable;


var $a8b96ca779d42ed2$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $a8b96ca779d42ed2$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($a8b96ca779d42ed2$exports, "__esModule", {
    value: true
});
$a8b96ca779d42ed2$exports.GridContextProvider = $a8b96ca779d42ed2$var$GridContextProvider;

var $a8b96ca779d42ed2$var$React = $a8b96ca779d42ed2$require$_interopRequireWildcard((parcelRequire("acw62")));

var $YSznt = parcelRequire("YSznt");

var $er55f = parcelRequire("er55f");

var $96LtV = parcelRequire("96LtV");




var $ayMG0 = parcelRequire("ayMG0");
function $a8b96ca779d42ed2$var$GridContextProvider({ privateApiRef: privateApiRef, configuration: configuration, props: props, children: children }) {
    const apiRef = $a8b96ca779d42ed2$var$React.useRef(privateApiRef.current.getPublicApi());
    return /*#__PURE__*/ (0, $ayMG0.jsx)($dfe2502031b16236$exports.GridConfigurationContext.Provider, {
        value: configuration,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($96LtV.GridRootPropsContext.Provider, {
            value: props,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($er55f.GridPrivateApiContext.Provider, {
                value: privateApiRef,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($YSznt.GridApiContext.Provider, {
                    value: apiRef,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($546bc72d2cea638d$exports.GridPanelContextProvider, {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($2a727ae4835cc807$exports.GridCSSVariablesContext, {
                            children: children
                        })
                    })
                })
            })
        })
    });
}


var $4524a6bb6d2f99a9$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $4524a6bb6d2f99a9$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($4524a6bb6d2f99a9$exports, "__esModule", {
    value: true
});
$4524a6bb6d2f99a9$exports.useDataGridComponent = void 0;

var $4524a6bb6d2f99a9$var$React = $4524a6bb6d2f99a9$require$_interopRequireWildcard((parcelRequire("acw62")));

var $1b57f47831f90cfc$exports = {};
"use strict";
Object.defineProperty($1b57f47831f90cfc$exports, "__esModule", {
    value: true
});
$1b57f47831f90cfc$exports.useGridInitialization = void 0;
var $7b6204383fd9652e$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $7b6204383fd9652e$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($7b6204383fd9652e$exports, "__esModule", {
    value: true
});
$7b6204383fd9652e$exports.useGridRefs = void 0;

var $7b6204383fd9652e$var$React = $7b6204383fd9652e$require$_interopRequireWildcard((parcelRequire("acw62")));
const $7b6204383fd9652e$var$useGridRefs = (apiRef)=>{
    const rootElementRef = $7b6204383fd9652e$var$React.useRef(null);
    const mainElementRef = $7b6204383fd9652e$var$React.useRef(null);
    const virtualScrollerRef = $7b6204383fd9652e$var$React.useRef(null);
    const virtualScrollbarVerticalRef = $7b6204383fd9652e$var$React.useRef(null);
    const virtualScrollbarHorizontalRef = $7b6204383fd9652e$var$React.useRef(null);
    const columnHeadersContainerRef = $7b6204383fd9652e$var$React.useRef(null);
    apiRef.current.register('public', {
        rootElementRef: rootElementRef
    });
    apiRef.current.register('private', {
        mainElementRef: mainElementRef,
        virtualScrollerRef: virtualScrollerRef,
        virtualScrollbarVerticalRef: virtualScrollbarVerticalRef,
        virtualScrollbarHorizontalRef: virtualScrollbarHorizontalRef,
        columnHeadersContainerRef: columnHeadersContainerRef
    });
};
$7b6204383fd9652e$exports.useGridRefs = $7b6204383fd9652e$var$useGridRefs;


var $c829845f6b031fe6$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $c829845f6b031fe6$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $c829845f6b031fe6$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($c829845f6b031fe6$exports, "__esModule", {
    value: true
});
$c829845f6b031fe6$exports.useGridIsRtl = void 0;

var $c829845f6b031fe6$var$_extends2 = $c829845f6b031fe6$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $c829845f6b031fe6$var$React = $c829845f6b031fe6$require$_interopRequireWildcard((parcelRequire("acw62")));

var $9uEev = parcelRequire("9uEev");
const $c829845f6b031fe6$var$useGridIsRtl = (apiRef)=>{
    const isRtl = (0, $9uEev.useRtl)();
    if (apiRef.current.state.isRtl === undefined) apiRef.current.state.isRtl = isRtl;
    const isFirstEffect = $c829845f6b031fe6$var$React.useRef(true);
    $c829845f6b031fe6$var$React.useEffect(()=>{
        if (isFirstEffect.current) isFirstEffect.current = false;
        else apiRef.current.setState((state)=>(0, $c829845f6b031fe6$var$_extends2.default)({}, state, {
                isRtl: isRtl
            }));
    }, [
        apiRef,
        isRtl
    ]);
};
$c829845f6b031fe6$exports.useGridIsRtl = $c829845f6b031fe6$var$useGridIsRtl;


var $aa6467766a16a196$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $aa6467766a16a196$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($aa6467766a16a196$exports, "__esModule", {
    value: true
});
$aa6467766a16a196$exports.useGridLoggerFactory = void 0;

var $aa6467766a16a196$var$React = $aa6467766a16a196$require$_interopRequireWildcard((parcelRequire("acw62")));


const $aa6467766a16a196$var$forceDebug = (0, $fe919794eb3b24e8$exports.localStorageAvailable)() && window.localStorage.getItem('DEBUG') != null;
const $aa6467766a16a196$var$noop = ()=>{};
const $aa6467766a16a196$var$noopLogger = {
    debug: $aa6467766a16a196$var$noop,
    info: $aa6467766a16a196$var$noop,
    warn: $aa6467766a16a196$var$noop,
    error: $aa6467766a16a196$var$noop
};
const $aa6467766a16a196$var$LOG_LEVELS = [
    'debug',
    'info',
    'warn',
    'error'
];
function $aa6467766a16a196$var$getAppender(name, logLevel, appender = console) {
    const minLogLevelIdx = $aa6467766a16a196$var$LOG_LEVELS.indexOf(logLevel);
    if (minLogLevelIdx === -1) throw new Error(`MUI X: Log level ${logLevel} not recognized.`);
    const logger = $aa6467766a16a196$var$LOG_LEVELS.reduce((loggerObj, method, idx)=>{
        if (idx >= minLogLevelIdx) loggerObj[method] = (...args)=>{
            const [message, ...other] = args;
            appender[method](`MUI X: ${name} - ${message}`, ...other);
        };
        else loggerObj[method] = $aa6467766a16a196$var$noop;
        return loggerObj;
    }, {});
    return logger;
}
const $aa6467766a16a196$var$useGridLoggerFactory = (apiRef, props)=>{
    const getLogger = $aa6467766a16a196$var$React.useCallback((name)=>{
        if ($aa6467766a16a196$var$forceDebug) return $aa6467766a16a196$var$getAppender(name, 'debug', props.logger);
        if (!props.logLevel) return $aa6467766a16a196$var$noopLogger;
        return $aa6467766a16a196$var$getAppender(name, props.logLevel.toString(), props.logger);
    }, [
        props.logLevel,
        props.logger
    ]);
    (0, $431c82ec73ef367c$exports.useGridApiMethod)(apiRef, {
        getLogger: getLogger
    }, 'private');
};
$aa6467766a16a196$exports.useGridLoggerFactory = $aa6467766a16a196$var$useGridLoggerFactory;


var $89c1602309335bde$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $89c1602309335bde$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($89c1602309335bde$exports, "__esModule", {
    value: true
});
$89c1602309335bde$exports.useGridLocaleText = void 0;

var $89c1602309335bde$var$React = $89c1602309335bde$require$_interopRequireWildcard((parcelRequire("acw62")));
const $89c1602309335bde$var$useGridLocaleText = (apiRef, props)=>{
    const getLocaleText = $89c1602309335bde$var$React.useCallback((key)=>{
        if (props.localeText[key] == null) throw new Error(`Missing translation for key ${key}.`);
        return props.localeText[key];
    }, [
        props.localeText
    ]);
    apiRef.current.register('public', {
        getLocaleText: getLocaleText
    });
};
$89c1602309335bde$exports.useGridLocaleText = $89c1602309335bde$var$useGridLocaleText;



var $41d629b2793a9305$exports = {};
"use strict";
Object.defineProperty($41d629b2793a9305$exports, "__esModule", {
    value: true
});
var $fdb7ac5a4616b4fe$exports = {};
"use strict";
Object.defineProperty($fdb7ac5a4616b4fe$exports, "__esModule", {
    value: true
});
$fdb7ac5a4616b4fe$exports.GridStrategyGroup = void 0;
let $fdb7ac5a4616b4fe$var$GridStrategyGroup = $fdb7ac5a4616b4fe$exports.GridStrategyGroup = /*#__PURE__*/ function(GridStrategyGroup) {
    GridStrategyGroup["DataSource"] = "dataSource";
    GridStrategyGroup["RowTree"] = "rowTree";
    return GridStrategyGroup;
}({});


Object.keys($fdb7ac5a4616b4fe$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $41d629b2793a9305$exports && $41d629b2793a9305$exports[key] === $fdb7ac5a4616b4fe$exports[key]) return;
    Object.defineProperty($41d629b2793a9305$exports, key, {
        enumerable: true,
        get: function() {
            return $fdb7ac5a4616b4fe$exports[key];
        }
    });
});
var $ed28c789ae16a4b3$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $ed28c789ae16a4b3$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($ed28c789ae16a4b3$exports, "__esModule", {
    value: true
});
$ed28c789ae16a4b3$exports.useGridRegisterStrategyProcessor = void 0;

var $ed28c789ae16a4b3$var$React = $ed28c789ae16a4b3$require$_interopRequireWildcard((parcelRequire("acw62")));

const $ed28c789ae16a4b3$var$useGridRegisterStrategyProcessor = (apiRef, strategyName, group, processor)=>{
    const registerPreProcessor = $ed28c789ae16a4b3$var$React.useCallback(()=>{
        apiRef.current.registerStrategyProcessor(strategyName, group, processor);
    }, [
        apiRef,
        processor,
        group,
        strategyName
    ]);
    (0, $82679e37231fe76f$exports.useFirstRender)(()=>{
        registerPreProcessor();
    });
    const isFirstRender = $ed28c789ae16a4b3$var$React.useRef(true);
    $ed28c789ae16a4b3$var$React.useEffect(()=>{
        if (isFirstRender.current) isFirstRender.current = false;
        else registerPreProcessor();
    }, [
        registerPreProcessor
    ]);
};
$ed28c789ae16a4b3$exports.useGridRegisterStrategyProcessor = $ed28c789ae16a4b3$var$useGridRegisterStrategyProcessor;


Object.keys($ed28c789ae16a4b3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $41d629b2793a9305$exports && $41d629b2793a9305$exports[key] === $ed28c789ae16a4b3$exports[key]) return;
    Object.defineProperty($41d629b2793a9305$exports, key, {
        enumerable: true,
        get: function() {
            return $ed28c789ae16a4b3$exports[key];
        }
    });
});
var $2f1a4898f1e92309$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $2f1a4898f1e92309$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $2f1a4898f1e92309$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($2f1a4898f1e92309$exports, "__esModule", {
    value: true
});
$2f1a4898f1e92309$exports.useGridStrategyProcessing = $2f1a4898f1e92309$exports.GRID_STRATEGIES_PROCESSORS = $2f1a4898f1e92309$exports.GRID_DEFAULT_STRATEGY = void 0;

var $2f1a4898f1e92309$var$_objectWithoutPropertiesLoose2 = $2f1a4898f1e92309$require$_interopRequireDefault((parcelRequire("c05no")));

var $2f1a4898f1e92309$var$_toPropertyKey2 = $2f1a4898f1e92309$require$_interopRequireDefault((parcelRequire("5DKOa")));

var $2f1a4898f1e92309$var$React = $2f1a4898f1e92309$require$_interopRequireWildcard((parcelRequire("acw62")));


const $2f1a4898f1e92309$var$GRID_DEFAULT_STRATEGY = $2f1a4898f1e92309$exports.GRID_DEFAULT_STRATEGY = 'none';
const $2f1a4898f1e92309$var$GRID_STRATEGIES_PROCESSORS = $2f1a4898f1e92309$exports.GRID_STRATEGIES_PROCESSORS = {
    dataSourceRowsUpdate: $fdb7ac5a4616b4fe$exports.GridStrategyGroup.DataSource,
    rowTreeCreation: $fdb7ac5a4616b4fe$exports.GridStrategyGroup.RowTree,
    filtering: $fdb7ac5a4616b4fe$exports.GridStrategyGroup.RowTree,
    sorting: $fdb7ac5a4616b4fe$exports.GridStrategyGroup.RowTree,
    visibleRowsLookupCreation: $fdb7ac5a4616b4fe$exports.GridStrategyGroup.RowTree
};
/**
 * Implements a variant of the Strategy Pattern (see https://en.wikipedia.org/wiki/Strategy_pattern)
 *
 * More information and detailed example in (TODO add link to technical doc when ready)
 *
 * Some plugins contains custom logic that must only be applied if the right strategy is active.
 * For instance, the row grouping plugin has a custom filtering algorithm.
 * This algorithm must be applied by the filtering plugin if the row grouping is the current way of grouping rows,
 * but not if the tree data is the current way of grouping rows.
 *
 * =====================================================================================================================
 *
 * The plugin containing the custom logic must use:
 *
 * - `useGridRegisterStrategyProcessor` to register their processor.
 *   When the processor of the active strategy changes, it will fire `"activeStrategyProcessorChange"` to re-apply the processor.
 *
 * - `apiRef.current.setStrategyAvailability` to tell if their strategy can be used.
 *
 * =====================================================================================================================
 *
 * The plugin or component that needs to apply the custom logic of the current strategy must use:
 *
 * - `apiRef.current.applyStrategyProcessor` to run the processor of the active strategy for a given processor name.
 *
 * - the "strategyAvailabilityChange" event to update something when the active strategy changes.
 *    Warning: Be careful not to apply the processor several times.
 *    For instance "rowsSet" is fired by `useGridRows` whenever the active strategy changes.
 *    So listening to both would most likely run your logic twice.
 *
 * - The "activeStrategyProcessorChange" event to update something when the processor of the active strategy changes.
 *
 * =====================================================================================================================
 *
 * Each processor name is part of a strategy group which can only have one active strategy at the time.
 * There are two active groups named `rowTree` and `dataSource`.
 */ const $2f1a4898f1e92309$var$useGridStrategyProcessing = (apiRef)=>{
    const availableStrategies = $2f1a4898f1e92309$var$React.useRef(new Map());
    const strategiesCache = $2f1a4898f1e92309$var$React.useRef({});
    const registerStrategyProcessor = $2f1a4898f1e92309$var$React.useCallback((strategyName, processorName, processor)=>{
        const cleanup = ()=>{
            const _ref = strategiesCache.current[processorName], otherProcessors = (0, $2f1a4898f1e92309$var$_objectWithoutPropertiesLoose2.default)(_ref, [
                strategyName
            ].map($2f1a4898f1e92309$var$_toPropertyKey2.default));
            strategiesCache.current[processorName] = otherProcessors;
        };
        if (!strategiesCache.current[processorName]) strategiesCache.current[processorName] = {};
        const groupPreProcessors = strategiesCache.current[processorName];
        const previousProcessor = groupPreProcessors[strategyName];
        groupPreProcessors[strategyName] = processor;
        if (!previousProcessor || previousProcessor === processor) return cleanup;
        if (strategyName === apiRef.current.getActiveStrategy($2f1a4898f1e92309$var$GRID_STRATEGIES_PROCESSORS[processorName])) apiRef.current.publishEvent('activeStrategyProcessorChange', processorName);
        return cleanup;
    }, [
        apiRef
    ]);
    const applyStrategyProcessor = $2f1a4898f1e92309$var$React.useCallback((processorName, params)=>{
        const activeStrategy = apiRef.current.getActiveStrategy($2f1a4898f1e92309$var$GRID_STRATEGIES_PROCESSORS[processorName]);
        if (activeStrategy == null) throw new Error("Can't apply a strategy processor before defining an active strategy");
        const groupCache = strategiesCache.current[processorName];
        if (!groupCache || !groupCache[activeStrategy]) throw new Error(`No processor found for processor "${processorName}" on strategy "${activeStrategy}"`);
        const processor = groupCache[activeStrategy];
        return processor(params);
    }, [
        apiRef
    ]);
    const getActiveStrategy = $2f1a4898f1e92309$var$React.useCallback((strategyGroup)=>{
        const strategyEntries = Array.from(availableStrategies.current.entries());
        const availableStrategyEntry = strategyEntries.find(([, strategy])=>{
            if (strategy.group !== strategyGroup) return false;
            return strategy.isAvailable();
        });
        return availableStrategyEntry?.[0] ?? $2f1a4898f1e92309$var$GRID_DEFAULT_STRATEGY;
    }, []);
    const setStrategyAvailability = $2f1a4898f1e92309$var$React.useCallback((strategyGroup, strategyName, isAvailable)=>{
        availableStrategies.current.set(strategyName, {
            group: strategyGroup,
            isAvailable: isAvailable
        });
        apiRef.current.publishEvent('strategyAvailabilityChange');
    }, [
        apiRef
    ]);
    const strategyProcessingApi = {
        registerStrategyProcessor: registerStrategyProcessor,
        applyStrategyProcessor: applyStrategyProcessor,
        getActiveStrategy: getActiveStrategy,
        setStrategyAvailability: setStrategyAvailability
    };
    (0, $d79b1aa4f5237e85$exports.useGridApiMethod)(apiRef, strategyProcessingApi, 'private');
};
$2f1a4898f1e92309$exports.useGridStrategyProcessing = $2f1a4898f1e92309$var$useGridStrategyProcessing;


Object.keys($2f1a4898f1e92309$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $41d629b2793a9305$exports && $41d629b2793a9305$exports[key] === $2f1a4898f1e92309$exports[key]) return;
    Object.defineProperty($41d629b2793a9305$exports, key, {
        enumerable: true,
        get: function() {
            return $2f1a4898f1e92309$exports[key];
        }
    });
});


var $83584edf0ae98213$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $83584edf0ae98213$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $83584edf0ae98213$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($83584edf0ae98213$exports, "__esModule", {
    value: true
});
$83584edf0ae98213$exports.useGridStateInitialization = void 0;

var $83584edf0ae98213$var$_extends2 = $83584edf0ae98213$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $83584edf0ae98213$var$React = $83584edf0ae98213$require$_interopRequireWildcard((parcelRequire("acw62")));


const $83584edf0ae98213$var$useGridStateInitialization = (apiRef)=>{
    const controlStateMapRef = $83584edf0ae98213$var$React.useRef({});
    const registerControlState = $83584edf0ae98213$var$React.useCallback((controlStateItem)=>{
        controlStateMapRef.current[controlStateItem.stateId] = controlStateItem;
    }, []);
    const setState = $83584edf0ae98213$var$React.useCallback((state, reason)=>{
        let newState;
        if ((0, $fe919794eb3b24e8$exports.isFunction)(state)) newState = state(apiRef.current.state);
        else newState = state;
        if (apiRef.current.state === newState) return false;
        const apiRefWithNewState = {
            current: {
                state: newState
            }
        };
        let ignoreSetState = false;
        // Apply the control state constraints
        const updatedControlStateIds = [];
        Object.keys(controlStateMapRef.current).forEach((stateId)=>{
            const controlState = controlStateMapRef.current[stateId];
            const oldSubState = controlState.stateSelector(apiRef);
            const newSubState = controlState.stateSelector(apiRefWithNewState);
            if (newSubState === oldSubState) return;
            updatedControlStateIds.push({
                stateId: controlState.stateId,
                hasPropChanged: newSubState !== controlState.propModel
            });
            // The state is controlled, the prop should always win
            if (controlState.propModel !== undefined && newSubState !== controlState.propModel) ignoreSetState = true;
        });
        if (updatedControlStateIds.length > 1) // Each hook modify its own state, and it should not leak
        // Events are here to forward to other hooks and apply changes.
        // You are trying to update several states in a no isolated way.
        throw new Error(`You're not allowed to update several sub-state in one transaction. You already updated ${updatedControlStateIds[0].stateId}, therefore, you're not allowed to update ${updatedControlStateIds.map((el)=>el.stateId).join(', ')} in the same transaction.`);
        if (!ignoreSetState) {
            // We always assign it as we mutate rows for perf reason.
            apiRef.current.state = newState;
            apiRef.current.publishEvent('stateChange', newState);
            apiRef.current.store.update(newState);
        }
        if (updatedControlStateIds.length === 1) {
            const { stateId: stateId, hasPropChanged: hasPropChanged } = updatedControlStateIds[0];
            const controlState = controlStateMapRef.current[stateId];
            const model = controlState.stateSelector(apiRefWithNewState);
            if (controlState.propOnChange && hasPropChanged) controlState.propOnChange(model, {
                reason: reason,
                api: apiRef.current
            });
            if (!ignoreSetState) apiRef.current.publishEvent(controlState.changeEvent, model, {
                reason: reason
            });
        }
        return !ignoreSetState;
    }, [
        apiRef
    ]);
    const updateControlState = $83584edf0ae98213$var$React.useCallback((key, state, reason)=>{
        return apiRef.current.setState((previousState)=>{
            return (0, $83584edf0ae98213$var$_extends2.default)({}, previousState, {
                [key]: state(previousState[key])
            });
        }, reason);
    }, [
        apiRef
    ]);
    const publicStateApi = {
        setState: setState
    };
    const privateStateApi = {
        updateControlState: updateControlState,
        registerControlState: registerControlState
    };
    (0, $431c82ec73ef367c$exports.useGridApiMethod)(apiRef, publicStateApi, 'public');
    (0, $431c82ec73ef367c$exports.useGridApiMethod)(apiRef, privateStateApi, 'private');
};
$83584edf0ae98213$exports.useGridStateInitialization = $83584edf0ae98213$var$useGridStateInitialization;


var $ffa021c6a8a175c3$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $ffa021c6a8a175c3$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $ffa021c6a8a175c3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($ffa021c6a8a175c3$exports, "__esModule", {
    value: true
});
$ffa021c6a8a175c3$exports.useGridProps = $ffa021c6a8a175c3$exports.propsStateInitializer = void 0;

var $ffa021c6a8a175c3$var$_extends2 = $ffa021c6a8a175c3$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $ffa021c6a8a175c3$var$React = $ffa021c6a8a175c3$require$_interopRequireWildcard((parcelRequire("acw62")));
const $ffa021c6a8a175c3$var$propsStateInitializer = (state, props)=>{
    return (0, $ffa021c6a8a175c3$var$_extends2.default)({}, state, {
        props: {
            listView: props.listView,
            getRowId: props.getRowId,
            isCellEditable: props.isCellEditable
        }
    });
};
$ffa021c6a8a175c3$exports.propsStateInitializer = $ffa021c6a8a175c3$var$propsStateInitializer;
const $ffa021c6a8a175c3$var$useGridProps = (apiRef, props)=>{
    const isFirstRender = $ffa021c6a8a175c3$var$React.useRef(true);
    $ffa021c6a8a175c3$var$React.useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        apiRef.current.setState((state)=>(0, $ffa021c6a8a175c3$var$_extends2.default)({}, state, {
                props: {
                    listView: props.listView,
                    getRowId: props.getRowId,
                    isCellEditable: props.isCellEditable,
                    isRowSelectable: props.isRowSelectable
                }
            }));
    }, [
        apiRef,
        props.listView,
        props.getRowId,
        props.isCellEditable,
        props.isRowSelectable
    ]);
};
$ffa021c6a8a175c3$exports.useGridProps = $ffa021c6a8a175c3$var$useGridProps;


/**
 * Initialize the technical pieces of the DataGrid (logger, state, ...) that any DataGrid implementation needs
 */ const $1b57f47831f90cfc$var$useGridInitialization = (privateApiRef, props)=>{
    (0, $7b6204383fd9652e$exports.useGridRefs)(privateApiRef);
    (0, $ffa021c6a8a175c3$exports.useGridProps)(privateApiRef, props);
    (0, $c829845f6b031fe6$exports.useGridIsRtl)(privateApiRef);
    (0, $aa6467766a16a196$exports.useGridLoggerFactory)(privateApiRef, props);
    (0, $83584edf0ae98213$exports.useGridStateInitialization)(privateApiRef);
    (0, $1aa692cb9e262bac$exports.useGridPipeProcessing)(privateApiRef);
    (0, $41d629b2793a9305$exports.useGridStrategyProcessing)(privateApiRef);
    (0, $89c1602309335bde$exports.useGridLocaleText)(privateApiRef, props);
    privateApiRef.current.register('private', {
        rootProps: props
    });
};
$1b57f47831f90cfc$exports.useGridInitialization = $1b57f47831f90cfc$var$useGridInitialization;


var $0457a051e38141f4$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $0457a051e38141f4$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($0457a051e38141f4$exports, "__esModule", {
    value: true
});
$0457a051e38141f4$exports.useGridInitializeState = void 0;

var $0457a051e38141f4$var$React = $0457a051e38141f4$require$_interopRequireWildcard((parcelRequire("acw62")));
const $0457a051e38141f4$var$useGridInitializeState = (initializer, privateApiRef, props, key)=>{
    const previousKey = $0457a051e38141f4$var$React.useRef(key);
    const isInitialized = $0457a051e38141f4$var$React.useRef(false);
    if (key !== previousKey.current) {
        isInitialized.current = false;
        previousKey.current = key;
    }
    if (!isInitialized.current) {
        privateApiRef.current.state = initializer(privateApiRef.current.state, props, privateApiRef);
        isInitialized.current = true;
    }
};
$0457a051e38141f4$exports.useGridInitializeState = $0457a051e38141f4$var$useGridInitializeState;


var $077743baf33b26c9$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $077743baf33b26c9$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($077743baf33b26c9$exports, "__esModule", {
    value: true
});
$077743baf33b26c9$exports.useGridClipboard = void 0;

var $077743baf33b26c9$var$React = $077743baf33b26c9$require$_interopRequireWildcard((parcelRequire("acw62")));


var $e9ecacf5d98b0bad$exports = {};
"use strict";
Object.defineProperty($e9ecacf5d98b0bad$exports, "__esModule", {
    value: true
});
$e9ecacf5d98b0bad$exports.buildCSV = $e9ecacf5d98b0bad$var$buildCSV;
$e9ecacf5d98b0bad$exports.serializeCellValue = void 0;

var $9Y8Cp = parcelRequire("9Y8Cp");

function $e9ecacf5d98b0bad$var$sanitizeCellValue(value, csvOptions) {
    if (value === null || value === undefined) return '';
    const valueStr = typeof value === 'string' ? value : `${value}`;
    if (csvOptions.shouldAppendQuotes || csvOptions.escapeFormulas) {
        const escapedValue = valueStr.replace(/"/g, '""');
        if (csvOptions.escapeFormulas) {
            // See https://owasp.org/www-community/attacks/CSV_Injection
            if ([
                '=',
                '+',
                '-',
                '@',
                '\t',
                '\r'
            ].includes(escapedValue[0])) return `"'${escapedValue}"`;
        }
        // Make sure value containing delimiter or line break won't be split into multiple cells
        if ([
            csvOptions.delimiter,
            '\n',
            '\r',
            '"'
        ].some((delimiter)=>valueStr.includes(delimiter))) return `"${escapedValue}"`;
        return escapedValue;
    }
    return valueStr;
}
const $e9ecacf5d98b0bad$var$serializeCellValue = (cellParams, options)=>{
    const { csvOptions: csvOptions, ignoreValueFormatter: ignoreValueFormatter } = options;
    let value;
    if (ignoreValueFormatter) {
        const columnType = cellParams.colDef.type;
        if (columnType === 'number') value = String(cellParams.value);
        else if (columnType === 'date' || columnType === 'dateTime') value = cellParams.value?.toISOString();
        else if (typeof cellParams.value?.toString === 'function') value = cellParams.value.toString();
        else value = cellParams.value;
    } else value = cellParams.formattedValue;
    return $e9ecacf5d98b0bad$var$sanitizeCellValue(value, csvOptions);
};
$e9ecacf5d98b0bad$exports.serializeCellValue = $e9ecacf5d98b0bad$var$serializeCellValue;
class $e9ecacf5d98b0bad$var$CSVRow {
    rowString = '';
    isEmpty = true;
    constructor(options){
        this.options = options;
    }
    addValue(value) {
        if (!this.isEmpty) this.rowString += this.options.csvOptions.delimiter;
        if (typeof this.options.sanitizeCellValue === 'function') this.rowString += this.options.sanitizeCellValue(value, this.options.csvOptions);
        else this.rowString += value;
        this.isEmpty = false;
    }
    getRowString() {
        return this.rowString;
    }
}
const $e9ecacf5d98b0bad$var$serializeRow = ({ id: id, columns: columns, getCellParams: getCellParams, csvOptions: csvOptions, ignoreValueFormatter: ignoreValueFormatter })=>{
    const row = new $e9ecacf5d98b0bad$var$CSVRow({
        csvOptions: csvOptions
    });
    columns.forEach((column)=>{
        const cellParams = getCellParams(id, column.field);
        if (String(cellParams.formattedValue) === '[object Object]') (0, $9Y8Cp.warnOnce)([
            'MUI X: When the value of a field is an object or a `renderCell` is provided, the CSV export might not display the value correctly.',
            'You can provide a `valueFormatter` with a string representation to be used.'
        ]);
        row.addValue($e9ecacf5d98b0bad$var$serializeCellValue(cellParams, {
            ignoreValueFormatter: ignoreValueFormatter,
            csvOptions: csvOptions
        }));
    });
    return row.getRowString();
};
function $e9ecacf5d98b0bad$var$buildCSV(options) {
    const { columns: columns, rowIds: rowIds, csvOptions: csvOptions, ignoreValueFormatter: ignoreValueFormatter, apiRef: apiRef } = options;
    const CSVBody = rowIds.reduce((acc, id)=>`${acc}${$e9ecacf5d98b0bad$var$serializeRow({
            id: id,
            columns: columns,
            getCellParams: apiRef.current.getCellParams,
            ignoreValueFormatter: ignoreValueFormatter,
            csvOptions: csvOptions
        })}\r\n`, '').trim();
    if (!csvOptions.includeHeaders) return CSVBody;
    const filteredColumns = columns.filter((column)=>column.field !== $a6506085715c5aff$exports.GRID_CHECKBOX_SELECTION_COL_DEF.field);
    const headerRows = [];
    if (csvOptions.includeColumnGroupsHeaders) {
        const columnGroupLookup = apiRef.current.getAllGroupDetails();
        let maxColumnGroupsDepth = 0;
        const columnGroupPathsLookup = filteredColumns.reduce((acc, column)=>{
            const columnGroupPath = apiRef.current.getColumnGroupPath(column.field);
            acc[column.field] = columnGroupPath;
            maxColumnGroupsDepth = Math.max(maxColumnGroupsDepth, columnGroupPath.length);
            return acc;
        }, {});
        for(let i = 0; i < maxColumnGroupsDepth; i += 1){
            const headerGroupRow = new $e9ecacf5d98b0bad$var$CSVRow({
                csvOptions: csvOptions,
                sanitizeCellValue: $e9ecacf5d98b0bad$var$sanitizeCellValue
            });
            headerRows.push(headerGroupRow);
            filteredColumns.forEach((column)=>{
                const columnGroupId = (columnGroupPathsLookup[column.field] || [])[i];
                const columnGroup = columnGroupLookup[columnGroupId];
                headerGroupRow.addValue(columnGroup ? columnGroup.headerName || columnGroup.groupId : '');
            });
        }
    }
    const mainHeaderRow = new $e9ecacf5d98b0bad$var$CSVRow({
        csvOptions: csvOptions,
        sanitizeCellValue: $e9ecacf5d98b0bad$var$sanitizeCellValue
    });
    filteredColumns.forEach((column)=>{
        mainHeaderRow.addValue(column.headerName || column.field);
    });
    headerRows.push(mainHeaderRow);
    const CSVHead = `${headerRows.map((row)=>row.getRowString()).join('\r\n')}\r\n`;
    return `${CSVHead}${CSVBody}`.trim();
}




function $077743baf33b26c9$var$writeToClipboardPolyfill(data) {
    const span = document.createElement('span');
    span.style.whiteSpace = 'pre';
    span.style.userSelect = 'all';
    span.style.opacity = '0px';
    span.textContent = data;
    document.body.appendChild(span);
    const range = document.createRange();
    range.selectNode(span);
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    try {
        document.execCommand('copy');
    } finally{
        document.body.removeChild(span);
    }
}
function $077743baf33b26c9$var$copyToClipboard(data) {
    if (navigator.clipboard) navigator.clipboard.writeText(data).catch(()=>{
        $077743baf33b26c9$var$writeToClipboardPolyfill(data);
    });
    else $077743baf33b26c9$var$writeToClipboardPolyfill(data);
}
function $077743baf33b26c9$var$hasNativeSelection(element) {
    // When getSelection is called on an <iframe> that is not displayed Firefox will return null.
    if (window.getSelection()?.toString()) return true;
    // window.getSelection() returns an empty string in Firefox for selections inside a form element.
    // See: https://bugzilla.mozilla.org/show_bug.cgi?id=85686.
    // Instead, we can use element.selectionStart that is only defined on form elements.
    if (element && (element.selectionEnd || 0) - (element.selectionStart || 0) > 0) return true;
    return false;
}
/**
 * @requires useGridCsvExport (method)
 * @requires useGridSelection (method)
 */ const $077743baf33b26c9$var$useGridClipboard = (apiRef, props)=>{
    const ignoreValueFormatterProp = props.ignoreValueFormatterDuringExport;
    const ignoreValueFormatter = (typeof ignoreValueFormatterProp === 'object' ? ignoreValueFormatterProp?.clipboardExport : ignoreValueFormatterProp) || false;
    const clipboardCopyCellDelimiter = props.clipboardCopyCellDelimiter;
    const handleCopy = $077743baf33b26c9$var$React.useCallback((event)=>{
        if (!(0, $a08faead7d1bb429$exports.isCopyShortcut)(event)) return;
        // Do nothing if there's a native selection
        if ($077743baf33b26c9$var$hasNativeSelection(event.target)) return;
        let textToCopy = '';
        const selectedRowsCount = (0, $39b6b713fdb91ccd$exports.gridRowSelectionCountSelector)(apiRef);
        if (selectedRowsCount > 0) textToCopy = apiRef.current.getDataAsCsv({
            includeHeaders: false,
            delimiter: clipboardCopyCellDelimiter,
            shouldAppendQuotes: false,
            escapeFormulas: false
        });
        else {
            const focusedCell = (0, $9c9b8e89fddd633d$exports.gridFocusCellSelector)(apiRef);
            if (focusedCell) {
                const cellParams = apiRef.current.getCellParams(focusedCell.id, focusedCell.field);
                textToCopy = (0, $e9ecacf5d98b0bad$exports.serializeCellValue)(cellParams, {
                    csvOptions: {
                        delimiter: clipboardCopyCellDelimiter,
                        shouldAppendQuotes: false,
                        escapeFormulas: false
                    },
                    ignoreValueFormatter: ignoreValueFormatter
                });
            }
        }
        textToCopy = apiRef.current.unstable_applyPipeProcessors('clipboardCopy', textToCopy);
        if (textToCopy) {
            $077743baf33b26c9$var$copyToClipboard(textToCopy);
            apiRef.current.publishEvent('clipboardCopy', textToCopy);
        }
    }, [
        apiRef,
        ignoreValueFormatter,
        clipboardCopyCellDelimiter
    ]);
    (0, $431c82ec73ef367c$exports.useGridNativeEventListener)(apiRef, ()=>apiRef.current.rootElementRef.current, 'keydown', handleCopy);
    (0, $431c82ec73ef367c$exports.useGridEventPriority)(apiRef, 'clipboardCopy', props.onClipboardCopy);
};
$077743baf33b26c9$exports.useGridClipboard = $077743baf33b26c9$var$useGridClipboard;


var $a83bee6df207757d$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $a83bee6df207757d$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $a83bee6df207757d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($a83bee6df207757d$exports, "__esModule", {
    value: true
});
$a83bee6df207757d$exports.useGridColumnMenu = $a83bee6df207757d$exports.columnMenuStateInitializer = void 0;

var $a83bee6df207757d$var$_extends2 = $a83bee6df207757d$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $a83bee6df207757d$var$React = $a83bee6df207757d$require$_interopRequireWildcard((parcelRequire("acw62")));



const $a83bee6df207757d$var$columnMenuStateInitializer = (state)=>(0, $a83bee6df207757d$var$_extends2.default)({}, state, {
        columnMenu: {
            open: false
        }
    });
/**
 * @requires useGridColumnResize (event)
 * @requires useGridInfiniteLoader (event)
 */ $a83bee6df207757d$exports.columnMenuStateInitializer = $a83bee6df207757d$var$columnMenuStateInitializer;
const $a83bee6df207757d$var$useGridColumnMenu = (apiRef)=>{
    const logger = (0, $431c82ec73ef367c$exports.useGridLogger)(apiRef, 'useGridColumnMenu');
    const subscriptionRefs = $a83bee6df207757d$var$React.useRef({});
    const unsubscribeFromScrollChange = $a83bee6df207757d$var$React.useCallback(()=>{
        subscriptionRefs.current.wheel?.();
        subscriptionRefs.current.touchMove?.();
    }, []);
    const subscribeToScrollChange = $a83bee6df207757d$var$React.useCallback(()=>{
        unsubscribeFromScrollChange();
        subscriptionRefs.current.wheel = apiRef.current.subscribeEvent('virtualScrollerWheel', apiRef.current.hideColumnMenu);
        subscriptionRefs.current.touchMove = apiRef.current.subscribeEvent('virtualScrollerTouchMove', apiRef.current.hideColumnMenu);
    }, [
        apiRef,
        unsubscribeFromScrollChange
    ]);
    /**
   * API METHODS
   */ const showColumnMenu = $a83bee6df207757d$var$React.useCallback((field)=>{
        const columnMenuState = (0, $ac7e2dd161e207a6$exports.gridColumnMenuSelector)(apiRef);
        const newState = {
            open: true,
            field: field
        };
        const shouldUpdate = newState.open !== columnMenuState.open || newState.field !== columnMenuState.field;
        if (shouldUpdate) {
            apiRef.current.setState((state)=>{
                if (state.columnMenu.open && state.columnMenu.field === field) return state;
                logger.debug('Opening Column Menu');
                subscribeToScrollChange();
                return (0, $a83bee6df207757d$var$_extends2.default)({}, state, {
                    columnMenu: {
                        open: true,
                        field: field
                    }
                });
            });
            apiRef.current.hidePreferences();
        }
    }, [
        apiRef,
        logger,
        subscribeToScrollChange
    ]);
    const hideColumnMenu = $a83bee6df207757d$var$React.useCallback(()=>{
        const columnMenuState = (0, $ac7e2dd161e207a6$exports.gridColumnMenuSelector)(apiRef);
        if (columnMenuState.field) {
            const columnLookup = (0, $e732684465924d20$exports.gridColumnLookupSelector)(apiRef);
            const columnVisibilityModel = (0, $e732684465924d20$exports.gridColumnVisibilityModelSelector)(apiRef);
            const orderedFields = (0, $e732684465924d20$exports.gridColumnFieldsSelector)(apiRef);
            let fieldToFocus = columnMenuState.field;
            // If the column was removed from the grid, we need to find the closest visible field
            if (!columnLookup[fieldToFocus]) fieldToFocus = orderedFields[0];
            // If the field to focus is hidden, we need to find the closest visible field
            if (columnVisibilityModel[fieldToFocus] === false) {
                // contains visible column fields + the field that was just hidden
                const visibleOrderedFields = orderedFields.filter((field)=>{
                    if (field === fieldToFocus) return true;
                    return columnVisibilityModel[field] !== false;
                });
                const fieldIndex = visibleOrderedFields.indexOf(fieldToFocus);
                fieldToFocus = visibleOrderedFields[fieldIndex + 1] || visibleOrderedFields[fieldIndex - 1];
            }
            apiRef.current.setColumnHeaderFocus(fieldToFocus);
        }
        const newState = {
            open: false,
            field: undefined
        };
        const shouldUpdate = newState.open !== columnMenuState.open || newState.field !== columnMenuState.field;
        if (shouldUpdate) apiRef.current.setState((state)=>{
            logger.debug('Hiding Column Menu');
            unsubscribeFromScrollChange();
            return (0, $a83bee6df207757d$var$_extends2.default)({}, state, {
                columnMenu: newState
            });
        });
    }, [
        apiRef,
        logger,
        unsubscribeFromScrollChange
    ]);
    const toggleColumnMenu = $a83bee6df207757d$var$React.useCallback((field)=>{
        logger.debug('Toggle Column Menu');
        const columnMenu = (0, $ac7e2dd161e207a6$exports.gridColumnMenuSelector)(apiRef);
        if (!columnMenu.open || columnMenu.field !== field) showColumnMenu(field);
        else hideColumnMenu();
    }, [
        apiRef,
        logger,
        showColumnMenu,
        hideColumnMenu
    ]);
    const columnMenuApi = {
        showColumnMenu: showColumnMenu,
        hideColumnMenu: hideColumnMenu,
        toggleColumnMenu: toggleColumnMenu
    };
    (0, $431c82ec73ef367c$exports.useGridApiMethod)(apiRef, columnMenuApi, 'public');
    (0, $431c82ec73ef367c$exports.useGridEvent)(apiRef, 'columnResizeStart', hideColumnMenu);
};
$a83bee6df207757d$exports.useGridColumnMenu = $a83bee6df207757d$var$useGridColumnMenu;


var $65c9ba4e90cd61b6$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $65c9ba4e90cd61b6$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $65c9ba4e90cd61b6$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($65c9ba4e90cd61b6$exports, "__esModule", {
    value: true
});
$65c9ba4e90cd61b6$exports.columnsStateInitializer = void 0;
$65c9ba4e90cd61b6$exports.useGridColumns = $65c9ba4e90cd61b6$var$useGridColumns;

var $65c9ba4e90cd61b6$var$_extends2 = $65c9ba4e90cd61b6$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $65c9ba4e90cd61b6$var$React = $65c9ba4e90cd61b6$require$_interopRequireWildcard((parcelRequire("acw62")));











var $ayMG0 = parcelRequire("ayMG0");
const $65c9ba4e90cd61b6$var$columnsStateInitializer = (state, props, apiRef)=>{
    apiRef.current.caches.columns = {
        lastColumnsProp: props.columns
    };
    const columnsState = (0, $d1cd1e3fd8558ad5$exports.createColumnsState)({
        apiRef: apiRef,
        columnsToUpsert: props.columns,
        initialState: props.initialState?.columns,
        columnVisibilityModel: props.columnVisibilityModel ?? props.initialState?.columns?.columnVisibilityModel ?? {},
        keepOnlyColumnsToUpsert: true
    });
    return (0, $65c9ba4e90cd61b6$var$_extends2.default)({}, state, {
        columns: columnsState,
        // In pro/premium, this part of the state is defined. We give it an empty but defined value
        // for the community version.
        pinnedColumns: state.pinnedColumns ?? $3a32d3fdbf8b29fd$exports.EMPTY_PINNED_COLUMN_FIELDS
    });
};
/**
 * @requires useGridParamsApi (method)
 * @requires useGridDimensions (method, event) - can be after
 * TODO: Impossible priority - useGridParamsApi also needs to be after useGridColumns
 */ $65c9ba4e90cd61b6$exports.columnsStateInitializer = $65c9ba4e90cd61b6$var$columnsStateInitializer;
function $65c9ba4e90cd61b6$var$useGridColumns(apiRef, props) {
    const logger = (0, $fa53bf7350a63511$exports.useGridLogger)(apiRef, 'useGridColumns');
    apiRef.current.registerControlState({
        stateId: 'visibleColumns',
        propModel: props.columnVisibilityModel,
        propOnChange: props.onColumnVisibilityModelChange,
        stateSelector: $e732684465924d20$exports.gridColumnVisibilityModelSelector,
        changeEvent: 'columnVisibilityModelChange'
    });
    const setGridColumnsState = $65c9ba4e90cd61b6$var$React.useCallback((columnsState)=>{
        logger.debug('Updating columns state.');
        apiRef.current.setState($65c9ba4e90cd61b6$var$mergeColumnsState(columnsState));
        apiRef.current.publishEvent('columnsChange', columnsState.orderedFields);
    }, [
        logger,
        apiRef
    ]);
    /**
   * API METHODS
   */ const getColumn = $65c9ba4e90cd61b6$var$React.useCallback((field)=>(0, $e732684465924d20$exports.gridColumnLookupSelector)(apiRef)[field], [
        apiRef
    ]);
    const getAllColumns = $65c9ba4e90cd61b6$var$React.useCallback(()=>(0, $e732684465924d20$exports.gridColumnDefinitionsSelector)(apiRef), [
        apiRef
    ]);
    const getVisibleColumns = $65c9ba4e90cd61b6$var$React.useCallback(()=>(0, $e732684465924d20$exports.gridVisibleColumnDefinitionsSelector)(apiRef), [
        apiRef
    ]);
    const getColumnIndex = $65c9ba4e90cd61b6$var$React.useCallback((field, useVisibleColumns = true)=>{
        const columns = useVisibleColumns ? (0, $e732684465924d20$exports.gridVisibleColumnDefinitionsSelector)(apiRef) : (0, $e732684465924d20$exports.gridColumnDefinitionsSelector)(apiRef);
        return columns.findIndex((col)=>col.field === field);
    }, [
        apiRef
    ]);
    const getColumnPosition = $65c9ba4e90cd61b6$var$React.useCallback((field)=>{
        const index = getColumnIndex(field);
        return (0, $e732684465924d20$exports.gridColumnPositionsSelector)(apiRef)[index];
    }, [
        apiRef,
        getColumnIndex
    ]);
    const setColumnVisibilityModel = $65c9ba4e90cd61b6$var$React.useCallback((model)=>{
        const currentModel = (0, $e732684465924d20$exports.gridColumnVisibilityModelSelector)(apiRef);
        if (currentModel !== model) {
            apiRef.current.setState((state)=>(0, $65c9ba4e90cd61b6$var$_extends2.default)({}, state, {
                    columns: (0, $d1cd1e3fd8558ad5$exports.createColumnsState)({
                        apiRef: apiRef,
                        columnsToUpsert: [],
                        initialState: undefined,
                        columnVisibilityModel: model,
                        keepOnlyColumnsToUpsert: false
                    })
                }));
            apiRef.current.updateRenderContext?.();
        }
    }, [
        apiRef
    ]);
    const updateColumns = $65c9ba4e90cd61b6$var$React.useCallback((columns)=>{
        let columnsToUpdate = columns;
        if ((0, $2623d93ce2942d3c$exports.gridPivotActiveSelector)(apiRef)) {
            const nonPivotColumns = [];
            const pivotColumns = [];
            const pivotInitialColumns = (0, $2623d93ce2942d3c$exports.gridPivotInitialColumnsSelector)(apiRef);
            columns.forEach((column)=>{
                const isNonPivotColumn = pivotInitialColumns.has(column.field);
                if (isNonPivotColumn) nonPivotColumns.push(column);
                else pivotColumns.push(column);
            });
            if (nonPivotColumns.length > 0) apiRef.current.updateNonPivotColumns(nonPivotColumns);
            if (pivotColumns.length === 0) return;
            columnsToUpdate = pivotColumns;
        }
        const columnsState = (0, $d1cd1e3fd8558ad5$exports.createColumnsState)({
            apiRef: apiRef,
            columnsToUpsert: columnsToUpdate,
            initialState: undefined,
            keepOnlyColumnsToUpsert: false,
            updateInitialVisibilityModel: true
        });
        setGridColumnsState(columnsState);
    }, [
        apiRef,
        setGridColumnsState
    ]);
    const setColumnVisibility = $65c9ba4e90cd61b6$var$React.useCallback((field, isVisible)=>{
        const columnVisibilityModel = (0, $e732684465924d20$exports.gridColumnVisibilityModelSelector)(apiRef);
        const isCurrentlyVisible = columnVisibilityModel[field] ?? true;
        if (isVisible !== isCurrentlyVisible) {
            const newModel = (0, $65c9ba4e90cd61b6$var$_extends2.default)({}, columnVisibilityModel, {
                [field]: isVisible
            });
            apiRef.current.setColumnVisibilityModel(newModel);
        }
    }, [
        apiRef
    ]);
    const getColumnIndexRelativeToVisibleColumns = $65c9ba4e90cd61b6$var$React.useCallback((field)=>{
        const allColumns = (0, $e732684465924d20$exports.gridColumnFieldsSelector)(apiRef);
        return allColumns.findIndex((col)=>col === field);
    }, [
        apiRef
    ]);
    const setColumnIndex = $65c9ba4e90cd61b6$var$React.useCallback((field, targetIndexPosition)=>{
        const allColumns = (0, $e732684465924d20$exports.gridColumnFieldsSelector)(apiRef);
        const oldIndexPosition = getColumnIndexRelativeToVisibleColumns(field);
        if (oldIndexPosition === targetIndexPosition) return;
        logger.debug(`Moving column ${field} to index ${targetIndexPosition}`);
        const updatedColumns = [
            ...allColumns
        ];
        const fieldRemoved = updatedColumns.splice(oldIndexPosition, 1)[0];
        updatedColumns.splice(targetIndexPosition, 0, fieldRemoved);
        setGridColumnsState((0, $65c9ba4e90cd61b6$var$_extends2.default)({}, (0, $e732684465924d20$exports.gridColumnsStateSelector)(apiRef), {
            orderedFields: updatedColumns
        }));
        const params = {
            column: apiRef.current.getColumn(field),
            targetIndex: apiRef.current.getColumnIndexRelativeToVisibleColumns(field),
            oldIndex: oldIndexPosition
        };
        apiRef.current.publishEvent('columnIndexChange', params);
    }, [
        apiRef,
        logger,
        setGridColumnsState,
        getColumnIndexRelativeToVisibleColumns
    ]);
    const setColumnWidth = $65c9ba4e90cd61b6$var$React.useCallback((field, width)=>{
        logger.debug(`Updating column ${field} width to ${width}`);
        const columnsState = (0, $e732684465924d20$exports.gridColumnsStateSelector)(apiRef);
        const column = columnsState.lookup[field];
        const newColumn = (0, $65c9ba4e90cd61b6$var$_extends2.default)({}, column, {
            width: width,
            hasBeenResized: true
        });
        setGridColumnsState((0, $d1cd1e3fd8558ad5$exports.hydrateColumnsWidth)((0, $65c9ba4e90cd61b6$var$_extends2.default)({}, columnsState, {
            lookup: (0, $65c9ba4e90cd61b6$var$_extends2.default)({}, columnsState.lookup, {
                [field]: newColumn
            })
        }), apiRef.current.getRootDimensions()));
        apiRef.current.publishEvent('columnWidthChange', {
            element: apiRef.current.getColumnHeaderElement(field),
            colDef: newColumn,
            width: width
        });
    }, [
        apiRef,
        logger,
        setGridColumnsState
    ]);
    const columnApi = {
        getColumn: getColumn,
        getAllColumns: getAllColumns,
        getColumnIndex: getColumnIndex,
        getColumnPosition: getColumnPosition,
        getVisibleColumns: getVisibleColumns,
        getColumnIndexRelativeToVisibleColumns: getColumnIndexRelativeToVisibleColumns,
        updateColumns: updateColumns,
        setColumnVisibilityModel: setColumnVisibilityModel,
        setColumnVisibility: setColumnVisibility,
        setColumnWidth: setColumnWidth
    };
    const columnReorderApi = {
        setColumnIndex: setColumnIndex
    };
    (0, $d79b1aa4f5237e85$exports.useGridApiMethod)(apiRef, columnApi, 'public');
    (0, $d79b1aa4f5237e85$exports.useGridApiMethod)(apiRef, columnReorderApi, props.signature === $dc886d040ec4e87c$exports.GridSignature.DataGrid ? 'private' : 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $65c9ba4e90cd61b6$var$React.useCallback((prevState, context)=>{
        const columnsStateToExport = {};
        const columnVisibilityModelToExport = (0, $e732684465924d20$exports.gridColumnVisibilityModelSelector)(apiRef);
        const shouldExportColumnVisibilityModel = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the model is controlled
        props.columnVisibilityModel != null || // Always export if the model has been initialized
        // TODO v6 Do a nullish check instead to export even if the initial model equals "{}"
        Object.keys(props.initialState?.columns?.columnVisibilityModel ?? {}).length > 0 || // Always export if the model is not empty
        Object.keys(columnVisibilityModelToExport).length > 0;
        if (shouldExportColumnVisibilityModel) columnsStateToExport.columnVisibilityModel = columnVisibilityModelToExport;
        columnsStateToExport.orderedFields = (0, $e732684465924d20$exports.gridColumnFieldsSelector)(apiRef);
        const columns = (0, $e732684465924d20$exports.gridColumnDefinitionsSelector)(apiRef);
        const dimensions = {};
        columns.forEach((colDef)=>{
            if (colDef.hasBeenResized) {
                const colDefDimensions = {};
                $d1cd1e3fd8558ad5$exports.COLUMNS_DIMENSION_PROPERTIES.forEach((propertyName)=>{
                    let propertyValue = colDef[propertyName];
                    if (propertyValue === Infinity) propertyValue = -1;
                    colDefDimensions[propertyName] = propertyValue;
                });
                dimensions[colDef.field] = colDefDimensions;
            }
        });
        if (Object.keys(dimensions).length > 0) columnsStateToExport.dimensions = dimensions;
        return (0, $65c9ba4e90cd61b6$var$_extends2.default)({}, prevState, {
            columns: columnsStateToExport
        });
    }, [
        apiRef,
        props.columnVisibilityModel,
        props.initialState?.columns
    ]);
    const stateRestorePreProcessing = $65c9ba4e90cd61b6$var$React.useCallback((params, context)=>{
        const initialState = context.stateToRestore.columns;
        const columnVisibilityModelToImport = initialState?.columnVisibilityModel;
        if (initialState == null) return params;
        const columnsState = (0, $d1cd1e3fd8558ad5$exports.createColumnsState)({
            apiRef: apiRef,
            columnsToUpsert: [],
            initialState: initialState,
            columnVisibilityModel: columnVisibilityModelToImport,
            keepOnlyColumnsToUpsert: false
        });
        if (initialState != null) apiRef.current.setState((prevState)=>(0, $65c9ba4e90cd61b6$var$_extends2.default)({}, prevState, {
                columns: (0, $65c9ba4e90cd61b6$var$_extends2.default)({}, prevState.columns, {
                    lookup: columnsState.lookup,
                    orderedFields: columnsState.orderedFields,
                    initialColumnVisibilityModel: columnsState.initialColumnVisibilityModel
                })
            }));
        // separate column visibility model state update as it can be controlled
        // https://github.com/mui/mui-x/issues/17681#issuecomment-3012528602
        if (columnVisibilityModelToImport != null) apiRef.current.setState((prevState)=>(0, $65c9ba4e90cd61b6$var$_extends2.default)({}, prevState, {
                columns: (0, $65c9ba4e90cd61b6$var$_extends2.default)({}, prevState.columns, {
                    columnVisibilityModel: columnVisibilityModelToImport
                })
            }));
        if (initialState != null) apiRef.current.publishEvent('columnsChange', columnsState.orderedFields);
        return params;
    }, [
        apiRef
    ]);
    const preferencePanelPreProcessing = $65c9ba4e90cd61b6$var$React.useCallback((initialValue, value)=>{
        if (value === $6728e9ffb7926382$exports.GridPreferencePanelsValue.columns) {
            const ColumnsPanel = props.slots.columnsPanel;
            return /*#__PURE__*/ (0, $ayMG0.jsx)(ColumnsPanel, (0, $65c9ba4e90cd61b6$var$_extends2.default)({}, props.slotProps?.columnsPanel));
        }
        return initialValue;
    }, [
        props.slots.columnsPanel,
        props.slotProps?.columnsPanel
    ]);
    const addColumnMenuItems = $65c9ba4e90cd61b6$var$React.useCallback((columnMenuItems)=>{
        const isPivotActive = (0, $2623d93ce2942d3c$exports.gridPivotActiveSelector)(apiRef);
        if (props.disableColumnSelector || isPivotActive) return columnMenuItems;
        return [
            ...columnMenuItems,
            'columnMenuColumnsItem'
        ];
    }, [
        props.disableColumnSelector,
        apiRef
    ]);
    (0, $1aa692cb9e262bac$exports.useGridRegisterPipeProcessor)(apiRef, 'columnMenu', addColumnMenuItems);
    (0, $1aa692cb9e262bac$exports.useGridRegisterPipeProcessor)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $1aa692cb9e262bac$exports.useGridRegisterPipeProcessor)(apiRef, 'restoreState', stateRestorePreProcessing);
    (0, $1aa692cb9e262bac$exports.useGridRegisterPipeProcessor)(apiRef, 'preferencePanel', preferencePanelPreProcessing);
    /*
   * EVENTS
   */ const prevInnerWidth = $65c9ba4e90cd61b6$var$React.useRef(null);
    const handleGridSizeChange = (size)=>{
        if (prevInnerWidth.current !== size.width) {
            prevInnerWidth.current = size.width;
            const hasFlexColumns = (0, $e732684465924d20$exports.gridVisibleColumnDefinitionsSelector)(apiRef).some((col)=>col.flex && col.flex > 0);
            if (!hasFlexColumns) return;
            setGridColumnsState((0, $d1cd1e3fd8558ad5$exports.hydrateColumnsWidth)((0, $e732684465924d20$exports.gridColumnsStateSelector)(apiRef), apiRef.current.getRootDimensions()));
        }
    };
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'viewportInnerSizeChange', handleGridSizeChange);
    /**
   * APPLIERS
   */ const hydrateColumns = $65c9ba4e90cd61b6$var$React.useCallback(()=>{
        logger.info(`Columns pipe processing have changed, regenerating the columns`);
        const columnsState = (0, $d1cd1e3fd8558ad5$exports.createColumnsState)({
            apiRef: apiRef,
            columnsToUpsert: [],
            initialState: undefined,
            keepOnlyColumnsToUpsert: false
        });
        setGridColumnsState(columnsState);
    }, [
        apiRef,
        logger,
        setGridColumnsState
    ]);
    (0, $1aa692cb9e262bac$exports.useGridRegisterPipeApplier)(apiRef, 'hydrateColumns', hydrateColumns);
    /*
   * EFFECTS
   */ // The effect do not track any value defined synchronously during the 1st render by hooks called after `useGridColumns`
    // As a consequence, the state generated by the 1st run of this useEffect will always be equal to the initialization one
    $65c9ba4e90cd61b6$var$React.useEffect(()=>{
        if (apiRef.current.caches.columns.lastColumnsProp === props.columns) return;
        apiRef.current.caches.columns.lastColumnsProp = props.columns;
        logger.info(`GridColumns have changed, new length ${props.columns.length}`);
        const columnsState = (0, $d1cd1e3fd8558ad5$exports.createColumnsState)({
            apiRef: apiRef,
            initialState: undefined,
            // If the user provides a model, we don't want to set it in the state here because it has it's dedicated `useEffect` which calls `setColumnVisibilityModel`
            columnsToUpsert: props.columns,
            keepOnlyColumnsToUpsert: true,
            updateInitialVisibilityModel: true,
            columnVisibilityModel: props.columnVisibilityModel
        });
        setGridColumnsState(columnsState);
    }, [
        logger,
        apiRef,
        setGridColumnsState,
        props.columns,
        props.columnVisibilityModel
    ]);
    $65c9ba4e90cd61b6$var$React.useEffect(()=>{
        if (props.columnVisibilityModel !== undefined) apiRef.current.setColumnVisibilityModel(props.columnVisibilityModel);
    }, [
        apiRef,
        logger,
        props.columnVisibilityModel
    ]);
}
function $65c9ba4e90cd61b6$var$mergeColumnsState(columnsState) {
    return (state)=>(0, $65c9ba4e90cd61b6$var$_extends2.default)({}, state, {
            columns: columnsState
        });
}


var $d846f35585bafc86$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $d846f35585bafc86$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $d846f35585bafc86$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($d846f35585bafc86$exports, "__esModule", {
    value: true
});
$d846f35585bafc86$exports.useGridDensity = $d846f35585bafc86$exports.densityStateInitializer = void 0;

var $d846f35585bafc86$var$_extends2 = $d846f35585bafc86$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $d846f35585bafc86$var$React = $d846f35585bafc86$require$_interopRequireWildcard((parcelRequire("acw62")));

var $d846f35585bafc86$var$_useEventCallback = $d846f35585bafc86$require$_interopRequireDefault((parcelRequire("6Lbjo")));




const $d846f35585bafc86$var$densityStateInitializer = (state, props)=>(0, $d846f35585bafc86$var$_extends2.default)({}, state, {
        density: props.initialState?.density ?? props.density ?? 'standard'
    });
$d846f35585bafc86$exports.densityStateInitializer = $d846f35585bafc86$var$densityStateInitializer;
const $d846f35585bafc86$var$useGridDensity = (apiRef, props)=>{
    const logger = (0, $fa53bf7350a63511$exports.useGridLogger)(apiRef, 'useDensity');
    apiRef.current.registerControlState({
        stateId: 'density',
        propModel: props.density,
        propOnChange: props.onDensityChange,
        stateSelector: $b611aad21a5b677d$exports.gridDensitySelector,
        changeEvent: 'densityChange'
    });
    const setDensity = (0, $d846f35585bafc86$var$_useEventCallback.default)((newDensity)=>{
        const currentDensity = (0, $b611aad21a5b677d$exports.gridDensitySelector)(apiRef);
        if (currentDensity === newDensity) return;
        logger.debug(`Set grid density to ${newDensity}`);
        apiRef.current.setState((state)=>(0, $d846f35585bafc86$var$_extends2.default)({}, state, {
                density: newDensity
            }));
    });
    const densityApi = {
        setDensity: setDensity
    };
    (0, $d79b1aa4f5237e85$exports.useGridApiMethod)(apiRef, densityApi, 'public');
    const stateExportPreProcessing = $d846f35585bafc86$var$React.useCallback((prevState, context)=>{
        const exportedDensity = (0, $b611aad21a5b677d$exports.gridDensitySelector)(apiRef);
        const shouldExportRowCount = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the `density` is controlled
        props.density != null || // Always export if the `density` has been initialized
        props.initialState?.density != null;
        if (!shouldExportRowCount) return prevState;
        return (0, $d846f35585bafc86$var$_extends2.default)({}, prevState, {
            density: exportedDensity
        });
    }, [
        apiRef,
        props.density,
        props.initialState?.density
    ]);
    const stateRestorePreProcessing = $d846f35585bafc86$var$React.useCallback((params, context)=>{
        const restoredDensity = context.stateToRestore?.density ? context.stateToRestore.density : (0, $b611aad21a5b677d$exports.gridDensitySelector)(apiRef);
        apiRef.current.setState((state)=>(0, $d846f35585bafc86$var$_extends2.default)({}, state, {
                density: restoredDensity
            }));
        return params;
    }, [
        apiRef
    ]);
    (0, $1aa692cb9e262bac$exports.useGridRegisterPipeProcessor)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $1aa692cb9e262bac$exports.useGridRegisterPipeProcessor)(apiRef, 'restoreState', stateRestorePreProcessing);
    $d846f35585bafc86$var$React.useEffect(()=>{
        if (props.density) apiRef.current.setDensity(props.density);
    }, [
        apiRef,
        props.density
    ]);
};
$d846f35585bafc86$exports.useGridDensity = $d846f35585bafc86$var$useGridDensity;


var $c4e86ef235136df5$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $c4e86ef235136df5$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($c4e86ef235136df5$exports, "__esModule", {
    value: true
});
$c4e86ef235136df5$exports.useGridCsvExport = void 0;

var $c4e86ef235136df5$var$React = $c4e86ef235136df5$require$_interopRequireWildcard((parcelRequire("acw62")));


var $5f52a64decff8320$exports = {};
"use strict";
Object.defineProperty($5f52a64decff8320$exports, "__esModule", {
    value: true
});
$5f52a64decff8320$exports.exportAs = $5f52a64decff8320$var$exportAs;
/**
 * I have hesitated to use https://github.com/eligrey/FileSaver.js.
 * If we get bug reports that this project solves, we should consider using it.
 *
 * Related resources.
 * https://blog.logrocket.com/programmatic-file-downloads-in-the-browser-9a5186298d5c/
 * https://github.com/mbrn/filefy/blob/ec4ed0b7415d93be7158c23029f2ea1fa0b8e2d9/src/core/BaseBuilder.ts
 * https://unpkg.com/browse/@progress/kendo-file-saver@1.0.7/dist/es/save-as.js
 * https://github.com/ag-grid/ag-grid/blob/9565c219b6210aa85fa833c929d0728f9d163a91/community-modules/csv-export/src/csvExport/downloader.ts
 */ function $5f52a64decff8320$var$exportAs(blob, extension = 'csv', filename = document.title || 'untitled') {
    const fullName = `${filename}.${extension}`;
    // Test download attribute first
    // https://github.com/eligrey/FileSaver.js/issues/193
    if ('download' in HTMLAnchorElement.prototype) {
        // Create an object URL for the blob object
        const url = URL.createObjectURL(blob);
        // Create a new anchor element
        const a = document.createElement('a');
        a.href = url;
        a.download = fullName;
        // Programmatically trigger a click on the anchor element
        // Useful if you want the download to happen automatically
        // Without attaching the anchor element to the DOM
        a.click();
        // https://github.com/eligrey/FileSaver.js/issues/205
        setTimeout(()=>{
            URL.revokeObjectURL(url);
        });
        return;
    }
    throw new Error('MUI X: exportAs not supported.');
}



var $e77bee9f62f5124d$exports = {};
"use strict";
Object.defineProperty($e77bee9f62f5124d$exports, "__esModule", {
    value: true
});
$e77bee9f62f5124d$exports.getColumnsToExport = $e77bee9f62f5124d$exports.defaultGetRowsToExport = void 0;




const $e77bee9f62f5124d$var$getColumnsToExport = ({ apiRef: apiRef, options: options })=>{
    const columns = (0, $e3b5f2e67362f55f$exports.gridColumnDefinitionsSelector)(apiRef);
    if (options.fields) return options.fields.reduce((currentColumns, field)=>{
        const column = columns.find((col)=>col.field === field);
        if (column) currentColumns.push(column);
        return currentColumns;
    }, []);
    const validColumns = options.allColumns ? columns : (0, $e3b5f2e67362f55f$exports.gridVisibleColumnDefinitionsSelector)(apiRef);
    return validColumns.filter((column)=>column.disableExport !== true);
};
$e77bee9f62f5124d$exports.getColumnsToExport = $e77bee9f62f5124d$var$getColumnsToExport;
const $e77bee9f62f5124d$var$defaultGetRowsToExport = ({ apiRef: apiRef })=>{
    const filteredSortedRowIds = (0, $0c64e77f4c442b27$exports.gridFilteredSortedRowIdsSelector)(apiRef);
    const rowTree = (0, $befccaa56b49492d$exports.gridRowTreeSelector)(apiRef);
    const selectedRowsCount = (0, $7a5249c135fd39c1$exports.gridRowSelectionCountSelector)(apiRef);
    const bodyRows = filteredSortedRowIds.filter((id)=>rowTree[id].type !== 'footer');
    const pinnedRows = (0, $befccaa56b49492d$exports.gridPinnedRowsSelector)(apiRef);
    const topPinnedRowsIds = pinnedRows?.top?.map((row)=>row.id) || [];
    const bottomPinnedRowsIds = pinnedRows?.bottom?.map((row)=>row.id) || [];
    bodyRows.unshift(...topPinnedRowsIds);
    bodyRows.push(...bottomPinnedRowsIds);
    if (selectedRowsCount > 0) {
        const selectedRows = (0, $7a5249c135fd39c1$exports.gridRowSelectionIdsSelector)(apiRef);
        return bodyRows.filter((id)=>selectedRows.has(id));
    }
    return bodyRows;
};
$e77bee9f62f5124d$exports.defaultGetRowsToExport = $e77bee9f62f5124d$var$defaultGetRowsToExport;





var $ayMG0 = parcelRequire("ayMG0");
/**
 * @requires useGridColumns (state)
 * @requires useGridFilter (state)
 * @requires useGridSorting (state)
 * @requires useGridSelection (state)
 * @requires useGridParamsApi (method)
 */ const $c4e86ef235136df5$var$useGridCsvExport = (apiRef, props)=>{
    const logger = (0, $fa53bf7350a63511$exports.useGridLogger)(apiRef, 'useGridCsvExport');
    const ignoreValueFormatterProp = props.ignoreValueFormatterDuringExport;
    const ignoreValueFormatter = (typeof ignoreValueFormatterProp === 'object' ? ignoreValueFormatterProp?.csvExport : ignoreValueFormatterProp) || false;
    const getDataAsCsv = $c4e86ef235136df5$var$React.useCallback((options = {})=>{
        logger.debug(`Get data as CSV`);
        const exportedColumns = (0, $e77bee9f62f5124d$exports.getColumnsToExport)({
            apiRef: apiRef,
            options: options
        });
        const getRowsToExport = options.getRowsToExport ?? $e77bee9f62f5124d$exports.defaultGetRowsToExport;
        const exportedRowIds = getRowsToExport({
            apiRef: apiRef
        });
        return (0, $e9ecacf5d98b0bad$exports.buildCSV)({
            columns: exportedColumns,
            rowIds: exportedRowIds,
            csvOptions: {
                delimiter: options.delimiter || ',',
                shouldAppendQuotes: options.shouldAppendQuotes ?? true,
                includeHeaders: options.includeHeaders ?? true,
                includeColumnGroupsHeaders: options.includeColumnGroupsHeaders ?? true,
                escapeFormulas: options.escapeFormulas ?? true
            },
            ignoreValueFormatter: ignoreValueFormatter,
            apiRef: apiRef
        });
    }, [
        logger,
        apiRef,
        ignoreValueFormatter
    ]);
    const exportDataAsCsv = $c4e86ef235136df5$var$React.useCallback((options)=>{
        logger.debug(`Export data as CSV`);
        const csv = getDataAsCsv(options);
        const blob = new Blob([
            options?.utf8WithBom ? new Uint8Array([
                0xef,
                0xbb,
                0xbf
            ]) : '',
            csv
        ], {
            type: 'text/csv'
        });
        (0, $5f52a64decff8320$exports.exportAs)(blob, 'csv', options?.fileName);
    }, [
        logger,
        getDataAsCsv
    ]);
    const csvExportApi = {
        getDataAsCsv: getDataAsCsv,
        exportDataAsCsv: exportDataAsCsv
    };
    (0, $d79b1aa4f5237e85$exports.useGridApiMethod)(apiRef, csvExportApi, 'public');
    /**
   * PRE-PROCESSING
   */ const addExportMenuButtons = $c4e86ef235136df5$var$React.useCallback((initialValue, options)=>{
        if (options.csvOptions?.disableToolbarButton) return initialValue;
        return [
            ...initialValue,
            {
                component: /*#__PURE__*/ (0, $ayMG0.jsx)($db5176c392a1c83e$exports.GridCsvExportMenuItem, {
                    options: options.csvOptions
                }),
                componentName: 'csvExport'
            }
        ];
    }, []);
    (0, $1aa692cb9e262bac$exports.useGridRegisterPipeProcessor)(apiRef, 'exportMenu', addExportMenuButtons);
};
$c4e86ef235136df5$exports.useGridCsvExport = $c4e86ef235136df5$var$useGridCsvExport;


var $35ed394581d01f61$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $35ed394581d01f61$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $35ed394581d01f61$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($35ed394581d01f61$exports, "__esModule", {
    value: true
});
$35ed394581d01f61$exports.useGridPrintExport = void 0;

var $35ed394581d01f61$var$_extends2 = $35ed394581d01f61$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $35ed394581d01f61$var$React = $35ed394581d01f61$require$_interopRequireWildcard((parcelRequire("acw62")));

var $35ed394581d01f61$var$_ownerDocument = $35ed394581d01f61$require$_interopRequireDefault((parcelRequire("43fuO")));
var $a8a6b9d9c2d653ec$exports = {};
"use strict";
Object.defineProperty($a8a6b9d9c2d653ec$exports, "__esModule", {
    value: true
});
Object.defineProperty($a8a6b9d9c2d653ec$exports, "loadStyleSheets", {
    enumerable: true,
    get: function() {
        return $979ab0ccf5767d07$exports.loadStyleSheets;
    }
});
var $979ab0ccf5767d07$exports = {};
"use strict";
Object.defineProperty($979ab0ccf5767d07$exports, "__esModule", {
    value: true
});
$979ab0ccf5767d07$exports.loadStyleSheets = $979ab0ccf5767d07$var$loadStyleSheets;
/**
 * Loads all stylesheets from the given root element into the document.
 * @returns an array of promises that resolve when each stylesheet is loaded
 * @param document Document to load stylesheets into
 * @param root Document or ShadowRoot to load stylesheets from
 * @param nonce Optional nonce to set on style elements for CSP compliance
 */ function $979ab0ccf5767d07$var$loadStyleSheets(document, root, nonce) {
    const stylesheetLoadPromises = [];
    const headStyleElements = root.querySelectorAll("style, link[rel='stylesheet']");
    for(let i = 0; i < headStyleElements.length; i += 1){
        const node = headStyleElements[i];
        const newHeadStyleElement = document.createElement(node.tagName);
        if (node.tagName === 'STYLE') {
            const sheet = node.sheet;
            if (sheet) {
                let styleCSS = '';
                for(let j = 0; j < sheet.cssRules.length; j += 1)if (typeof sheet.cssRules[j].cssText === 'string') styleCSS += `${sheet.cssRules[j].cssText}\r\n`;
                newHeadStyleElement.appendChild(document.createTextNode(styleCSS));
            }
        } else if (node.getAttribute('href')) {
            for(let j = 0; j < node.attributes.length; j += 1){
                const attr = node.attributes[j];
                if (attr) newHeadStyleElement.setAttribute(attr.nodeName, attr.nodeValue || '');
            }
            stylesheetLoadPromises.push(new Promise((resolve)=>{
                newHeadStyleElement.addEventListener('load', ()=>resolve());
            }));
        }
        if (nonce) newHeadStyleElement.setAttribute('nonce', nonce);
        document.head.appendChild(newHeadStyleElement);
        if (nonce) // I don't understand why we need to set the nonce again after appending the element, but I've tested it, and it's
        // the only way I could find to fix Chrome's warning about a CSP violation.
        newHeadStyleElement.setAttribute('nonce', nonce);
    }
    return stylesheetLoadPromises;
}








var $5H1vo = parcelRequire("5H1vo");



var $5e8e37726d5ba261$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $5e8e37726d5ba261$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $5e8e37726d5ba261$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($5e8e37726d5ba261$exports, "__esModule", {
    value: true
});
$5e8e37726d5ba261$exports.useGridPaginationModel = $5e8e37726d5ba261$exports.getDerivedPaginationModel = void 0;

var $5e8e37726d5ba261$var$_extends2 = $5e8e37726d5ba261$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $5e8e37726d5ba261$var$React = $5e8e37726d5ba261$require$_interopRequireWildcard((parcelRequire("acw62")));

var $5e8e37726d5ba261$var$_debounce = $5e8e37726d5ba261$require$_interopRequireDefault((parcelRequire("9NXOO")));







const $5e8e37726d5ba261$var$getDerivedPaginationModel = (paginationState, signature, paginationModelProp)=>{
    let paginationModel = paginationState.paginationModel;
    const rowCount = paginationState.rowCount;
    const pageSize = paginationModelProp?.pageSize ?? paginationModel.pageSize;
    const page = paginationModelProp?.page ?? paginationModel.page;
    const pageCount = (0, $820f672e99dc58bd$exports.getPageCount)(rowCount, pageSize, page);
    if (paginationModelProp && (paginationModelProp?.page !== paginationModel.page || paginationModelProp?.pageSize !== paginationModel.pageSize)) paginationModel = paginationModelProp;
    const validPage = pageSize === -1 ? 0 : (0, $820f672e99dc58bd$exports.getValidPage)(paginationModel.page, pageCount);
    if (validPage !== paginationModel.page) paginationModel = (0, $5e8e37726d5ba261$var$_extends2.default)({}, paginationModel, {
        page: validPage
    });
    (0, $820f672e99dc58bd$exports.throwIfPageSizeExceedsTheLimit)(paginationModel.pageSize, signature);
    return paginationModel;
};
/**
 * @requires useGridFilter (state)
 * @requires useGridDimensions (event) - can be after
 */ $5e8e37726d5ba261$exports.getDerivedPaginationModel = $5e8e37726d5ba261$var$getDerivedPaginationModel;
const $5e8e37726d5ba261$var$useGridPaginationModel = (apiRef, props)=>{
    const logger = (0, $431c82ec73ef367c$exports.useGridLogger)(apiRef, 'useGridPaginationModel');
    const densityFactor = (0, $431c82ec73ef367c$exports.useGridSelector)(apiRef, $c638c00d73ef894b$exports.gridDensityFactorSelector);
    const previousFilterModel = $5e8e37726d5ba261$var$React.useRef((0, $e95988b653de2e96$exports.gridFilterModelSelector)(apiRef));
    const rowHeight = Math.floor(props.rowHeight * densityFactor);
    apiRef.current.registerControlState({
        stateId: 'paginationModel',
        propModel: props.paginationModel,
        propOnChange: props.onPaginationModelChange,
        stateSelector: $c41ec74257ca380c$exports.gridPaginationModelSelector,
        changeEvent: 'paginationModelChange'
    });
    /**
   * API METHODS
   */ const setPage = $5e8e37726d5ba261$var$React.useCallback((page)=>{
        const currentModel = (0, $c41ec74257ca380c$exports.gridPaginationModelSelector)(apiRef);
        if (page === currentModel.page) return;
        logger.debug(`Setting page to ${page}`);
        apiRef.current.setPaginationModel({
            page: page,
            pageSize: currentModel.pageSize
        });
    }, [
        apiRef,
        logger
    ]);
    const debouncedSetPage = $5e8e37726d5ba261$var$React.useMemo(()=>(0, $5e8e37726d5ba261$var$_debounce.default)(setPage, 0), [
        setPage
    ]);
    const setPageSize = $5e8e37726d5ba261$var$React.useCallback((pageSize)=>{
        const currentModel = (0, $c41ec74257ca380c$exports.gridPaginationModelSelector)(apiRef);
        if (pageSize === currentModel.pageSize) return;
        logger.debug(`Setting page size to ${pageSize}`);
        apiRef.current.setPaginationModel({
            pageSize: pageSize,
            page: currentModel.page
        });
    }, [
        apiRef,
        logger
    ]);
    const setPaginationModel = $5e8e37726d5ba261$var$React.useCallback((paginationModel)=>{
        const currentModel = (0, $c41ec74257ca380c$exports.gridPaginationModelSelector)(apiRef);
        if (paginationModel === currentModel) return;
        logger.debug("Setting 'paginationModel' to", paginationModel);
        apiRef.current.setState((state)=>(0, $5e8e37726d5ba261$var$_extends2.default)({}, state, {
                pagination: (0, $5e8e37726d5ba261$var$_extends2.default)({}, state.pagination, {
                    paginationModel: $5e8e37726d5ba261$var$getDerivedPaginationModel(state.pagination, props.signature, paginationModel)
                })
            }), 'setPaginationModel');
    }, [
        apiRef,
        logger,
        props.signature
    ]);
    const paginationModelApi = {
        setPage: setPage,
        setPageSize: setPageSize,
        setPaginationModel: setPaginationModel
    };
    (0, $431c82ec73ef367c$exports.useGridApiMethod)(apiRef, paginationModelApi, 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $5e8e37726d5ba261$var$React.useCallback((prevState, context)=>{
        const paginationModel = (0, $c41ec74257ca380c$exports.gridPaginationModelSelector)(apiRef);
        const shouldExportPaginationModel = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the `paginationModel` is controlled
        props.paginationModel != null || // Always export if the `paginationModel` has been initialized
        props.initialState?.pagination?.paginationModel != null || // Export if `page` or `pageSize` is not equal to the default value
        paginationModel.page !== 0 && paginationModel.pageSize !== (0, $820f672e99dc58bd$exports.defaultPageSize)(props.autoPageSize);
        if (!shouldExportPaginationModel) return prevState;
        return (0, $5e8e37726d5ba261$var$_extends2.default)({}, prevState, {
            pagination: (0, $5e8e37726d5ba261$var$_extends2.default)({}, prevState.pagination, {
                paginationModel: paginationModel
            })
        });
    }, [
        apiRef,
        props.paginationModel,
        props.initialState?.pagination?.paginationModel,
        props.autoPageSize
    ]);
    const stateRestorePreProcessing = $5e8e37726d5ba261$var$React.useCallback((params, context)=>{
        const paginationModel = context.stateToRestore.pagination?.paginationModel ? (0, $5e8e37726d5ba261$var$_extends2.default)({}, (0, $820f672e99dc58bd$exports.getDefaultGridPaginationModel)(props.autoPageSize), context.stateToRestore.pagination?.paginationModel) : (0, $c41ec74257ca380c$exports.gridPaginationModelSelector)(apiRef);
        apiRef.current.setState((state)=>(0, $5e8e37726d5ba261$var$_extends2.default)({}, state, {
                pagination: (0, $5e8e37726d5ba261$var$_extends2.default)({}, state.pagination, {
                    paginationModel: $5e8e37726d5ba261$var$getDerivedPaginationModel(state.pagination, props.signature, paginationModel)
                })
            }), 'stateRestorePreProcessing');
        return params;
    }, [
        apiRef,
        props.autoPageSize,
        props.signature
    ]);
    (0, $1aa692cb9e262bac$exports.useGridRegisterPipeProcessor)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $1aa692cb9e262bac$exports.useGridRegisterPipeProcessor)(apiRef, 'restoreState', stateRestorePreProcessing);
    /**
   * EVENTS
   */ const handlePaginationModelChange = ()=>{
        const paginationModel = (0, $c41ec74257ca380c$exports.gridPaginationModelSelector)(apiRef);
        if (apiRef.current.virtualScrollerRef?.current) apiRef.current.scrollToIndexes({
            rowIndex: paginationModel.page * paginationModel.pageSize
        });
    };
    const handleUpdateAutoPageSize = $5e8e37726d5ba261$var$React.useCallback(()=>{
        if (!props.autoPageSize) return;
        const dimensions = apiRef.current.getRootDimensions();
        const maximumPageSizeWithoutScrollBar = Math.max(1, Math.floor(dimensions.viewportInnerSize.height / rowHeight));
        apiRef.current.setPageSize(maximumPageSizeWithoutScrollBar);
    }, [
        apiRef,
        props.autoPageSize,
        rowHeight
    ]);
    const handleRowCountChange = $5e8e37726d5ba261$var$React.useCallback((newRowCount)=>{
        if (newRowCount == null) return;
        const paginationModel = (0, $c41ec74257ca380c$exports.gridPaginationModelSelector)(apiRef);
        if (paginationModel.page === 0) return;
        const pageCount = (0, $c41ec74257ca380c$exports.gridPageCountSelector)(apiRef);
        if (paginationModel.page > pageCount - 1) queueMicrotask(()=>{
            debouncedSetPage(Math.max(0, pageCount - 1));
        });
    }, [
        apiRef,
        debouncedSetPage
    ]);
    /**
   * Goes to the first row of the grid
   */ const navigateToStart = $5e8e37726d5ba261$var$React.useCallback(()=>{
        const paginationModel = (0, $c41ec74257ca380c$exports.gridPaginationModelSelector)(apiRef);
        if (paginationModel.page !== 0) debouncedSetPage(0);
        // If the page was not changed it might be needed to scroll to the top
        const scrollPosition = apiRef.current.getScrollPosition();
        if (scrollPosition.top !== 0) apiRef.current.scroll({
            top: 0
        });
    }, [
        apiRef,
        debouncedSetPage
    ]);
    const debouncedNavigateToStart = $5e8e37726d5ba261$var$React.useMemo(()=>(0, $5e8e37726d5ba261$var$_debounce.default)(navigateToStart, 0), [
        navigateToStart
    ]);
    /**
   * Resets the page only if the active items or quick filter has changed from the last time.
   * This is to avoid resetting the page when the filter model is changed
   * because of and update of the operator from an item that does not have the value
   * or reseting when the filter panel is just opened
   */ const handleFilterModelChange = $5e8e37726d5ba261$var$React.useCallback((filterModel)=>{
        const currentActiveFilters = (0, $5e8e37726d5ba261$var$_extends2.default)({}, filterModel, {
            // replace items with the active items
            items: (0, $e95988b653de2e96$exports.gridFilterActiveItemsSelector)(apiRef)
        });
        if ((0, $a4d2c99ef8ba2460$exports.isDeepEqual)(currentActiveFilters, previousFilterModel.current)) return;
        previousFilterModel.current = currentActiveFilters;
        debouncedNavigateToStart();
    }, [
        apiRef,
        debouncedNavigateToStart
    ]);
    (0, $431c82ec73ef367c$exports.useGridEvent)(apiRef, 'viewportInnerSizeChange', handleUpdateAutoPageSize);
    (0, $431c82ec73ef367c$exports.useGridEvent)(apiRef, 'paginationModelChange', handlePaginationModelChange);
    (0, $431c82ec73ef367c$exports.useGridEvent)(apiRef, 'rowCountChange', handleRowCountChange);
    (0, $431c82ec73ef367c$exports.useGridEvent)(apiRef, 'sortModelChange', debouncedNavigateToStart);
    (0, $431c82ec73ef367c$exports.useGridEvent)(apiRef, 'filterModelChange', handleFilterModelChange);
    /**
   * EFFECTS
   */ const isFirstRender = $5e8e37726d5ba261$var$React.useRef(true);
    $5e8e37726d5ba261$var$React.useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        if (!props.pagination) return;
        apiRef.current.setState((state)=>(0, $5e8e37726d5ba261$var$_extends2.default)({}, state, {
                pagination: (0, $5e8e37726d5ba261$var$_extends2.default)({}, state.pagination, {
                    paginationModel: $5e8e37726d5ba261$var$getDerivedPaginationModel(state.pagination, props.signature, props.paginationModel)
                })
            }));
    }, [
        apiRef,
        props.paginationModel,
        props.signature,
        props.pagination
    ]);
    $5e8e37726d5ba261$var$React.useEffect(()=>{
        apiRef.current.setState((state)=>{
            const isEnabled = props.pagination === true;
            if (state.pagination.paginationMode === props.paginationMode && state.pagination.enabled === isEnabled) return state;
            return (0, $5e8e37726d5ba261$var$_extends2.default)({}, state, {
                pagination: (0, $5e8e37726d5ba261$var$_extends2.default)({}, state.pagination, {
                    paginationMode: props.paginationMode,
                    enabled: isEnabled
                })
            });
        });
    }, [
        apiRef,
        props.paginationMode,
        props.pagination
    ]);
    $5e8e37726d5ba261$var$React.useEffect(handleUpdateAutoPageSize, [
        handleUpdateAutoPageSize
    ]);
};
$5e8e37726d5ba261$exports.useGridPaginationModel = $5e8e37726d5ba261$var$useGridPaginationModel;







var $ayMG0 = parcelRequire("ayMG0");
const $35ed394581d01f61$var$DEBUG_MODE = false;
function $35ed394581d01f61$var$raf() {
    return new Promise((resolve)=>{
        requestAnimationFrame(()=>{
            resolve();
        });
    });
}
function $35ed394581d01f61$var$buildPrintWindow(title) {
    const iframeEl = document.createElement('iframe');
    iframeEl.style.position = 'absolute';
    iframeEl.style.width = '0px';
    iframeEl.style.height = '0px';
    if ($35ed394581d01f61$var$DEBUG_MODE) {
        iframeEl.style.width = '100%';
        iframeEl.style.height = '10000px';
    }
    iframeEl.title = title || document.title;
    return iframeEl;
}
/**
 * @requires useGridColumns (state)
 * @requires useGridFilter (state)
 * @requires useGridSorting (state)
 * @requires useGridParamsApi (method)
 */ const $35ed394581d01f61$var$useGridPrintExport = (apiRef, props)=>{
    const hasRootReference = apiRef.current.rootElementRef.current !== null;
    const logger = (0, $fa53bf7350a63511$exports.useGridLogger)(apiRef, 'useGridPrintExport');
    const doc = $35ed394581d01f61$var$React.useRef(null);
    const previousGridState = $35ed394581d01f61$var$React.useRef(null);
    const previousColumnVisibility = $35ed394581d01f61$var$React.useRef({});
    const previousRows = $35ed394581d01f61$var$React.useRef([]);
    const previousVirtualizationState = $35ed394581d01f61$var$React.useRef(null);
    $35ed394581d01f61$var$React.useEffect(()=>{
        doc.current = (0, $35ed394581d01f61$var$_ownerDocument.default)(apiRef.current.rootElementRef.current);
    }, [
        apiRef,
        hasRootReference
    ]);
    // Returns a promise because updateColumns triggers state update and
    // the new state needs to be in place before the grid can be sized correctly
    const updateGridColumnsForPrint = $35ed394581d01f61$var$React.useCallback((fields, allColumns, includeCheckboxes)=>new Promise((resolve)=>{
            const exportedColumnFields = (0, $e77bee9f62f5124d$exports.getColumnsToExport)({
                apiRef: apiRef,
                options: {
                    fields: fields,
                    allColumns: allColumns
                }
            }).map((column)=>column.field);
            const columns = (0, $e732684465924d20$exports.gridColumnDefinitionsSelector)(apiRef);
            const newColumnVisibilityModel = {};
            columns.forEach((column)=>{
                newColumnVisibilityModel[column.field] = exportedColumnFields.includes(column.field);
            });
            if (includeCheckboxes) newColumnVisibilityModel[$3c6ea315aeb792f9$exports.GRID_CHECKBOX_SELECTION_COL_DEF.field] = true;
            apiRef.current.setColumnVisibilityModel(newColumnVisibilityModel);
            resolve();
        }), [
        apiRef
    ]);
    const updateGridRowsForPrint = $35ed394581d01f61$var$React.useCallback((getRowsToExport)=>{
        const rowsToExportIds = getRowsToExport({
            apiRef: apiRef
        });
        const newRows = rowsToExportIds.reduce((acc, id)=>{
            const row = apiRef.current.getRow(id);
            if (!row[$0166dd44615cae0d$exports.GRID_ID_AUTOGENERATED]) acc.push(row);
            return acc;
        }, []);
        apiRef.current.setRows(newRows);
    }, [
        apiRef
    ]);
    const handlePrintWindowLoad = $35ed394581d01f61$var$React.useCallback((printWindow, options)=>{
        const normalizeOptions = (0, $35ed394581d01f61$var$_extends2.default)({
            copyStyles: true,
            hideToolbar: false,
            hideFooter: false,
            includeCheckboxes: false
        }, options);
        const printDoc = printWindow.contentDocument;
        if (!printDoc) return;
        const gridRootElement = apiRef.current.rootElementRef.current;
        const gridClone = gridRootElement.cloneNode(true);
        const virtualScrollerContent = gridClone.querySelector(`.${$5H1vo.gridClasses.virtualScrollerContent}`);
        // Allow to overflow to not hide the border of the last row
        const gridMain = gridClone.querySelector(`.${$5H1vo.gridClasses.main}`);
        gridMain.style.overflow = 'visible';
        gridClone.querySelector(`.${$5H1vo.gridClasses.virtualScrollerRenderZone}`).style.position = 'static';
        virtualScrollerContent.style.flexBasis = 'auto';
        gridClone.querySelector(`.${$5H1vo.gridClasses['scrollbar--vertical']}`)?.remove();
        if (!(virtualScrollerContent.nextSibling instanceof HTMLElement && virtualScrollerContent.nextSibling.classList.contains($5H1vo.gridClasses.filler))) {
            const filler = document.createElement('div');
            filler.style.height = $919ad8d5ff9ebb8c$exports.scrollbarSizeCssExpression;
            virtualScrollerContent.insertAdjacentElement('afterend', filler);
        }
        const gridFooterElement = gridClone.querySelector(`.${$5H1vo.gridClasses.footerContainer}`);
        if (normalizeOptions.hideToolbar) gridClone.querySelector(`.${$5H1vo.gridClasses.toolbar}`)?.remove();
        if (normalizeOptions.hideFooter && gridFooterElement) gridFooterElement.remove();
        gridClone.style.height = 'auto';
        // The height above does not include grid border width, so we need to exclude it
        gridClone.style.boxSizing = 'content-box';
        if (!normalizeOptions.hideFooter && gridFooterElement) // the footer is always being placed at the bottom of the page as if all rows are exported
        // so if getRowsToExport is being used to only export a subset of rows then we need to
        // adjust the footer position to be correctly placed at the bottom of the grid
        gridFooterElement.style.width = '100%';
        // printDoc.body.appendChild(gridClone); should be enough but a clone isolation bug in Safari
        // prevents us to do it
        const container = document.createElement('div');
        container.appendChild(gridClone);
        // To avoid an empty page in start on Chromium based browsers
        printDoc.body.style.marginTop = '0px';
        printDoc.body.innerHTML = container.innerHTML;
        const defaultPageStyle = typeof normalizeOptions.pageStyle === 'function' ? normalizeOptions.pageStyle() : normalizeOptions.pageStyle;
        if (typeof defaultPageStyle === 'string') {
            // TODO custom styles should always win
            const styleElement = printDoc.createElement('style');
            styleElement.appendChild(printDoc.createTextNode(defaultPageStyle));
            printDoc.head.appendChild(styleElement);
        }
        if (normalizeOptions.bodyClassName) printDoc.body.classList.add(...normalizeOptions.bodyClassName.split(' '));
        let stylesheetLoadPromises = [];
        if (normalizeOptions.copyStyles) {
            const rootCandidate = gridRootElement.getRootNode();
            const root = rootCandidate.constructor.name === 'ShadowRoot' ? rootCandidate : doc.current;
            stylesheetLoadPromises = (0, $a8a6b9d9c2d653ec$exports.loadStyleSheets)(printDoc, root);
        }
        // Trigger print
        if (!$35ed394581d01f61$var$DEBUG_MODE) // wait for remote stylesheets to load
        Promise.all(stylesheetLoadPromises).then(()=>{
            printWindow.contentWindow.print();
        });
    }, [
        apiRef,
        doc
    ]);
    const handlePrintWindowAfterPrint = $35ed394581d01f61$var$React.useCallback((printWindow)=>{
        // Remove the print iframe
        doc.current.body.removeChild(printWindow);
        // Revert grid to previous state
        apiRef.current.restoreState(previousGridState.current || {});
        if (!previousGridState.current?.columns?.columnVisibilityModel) // if the apiRef.current.exportState(); did not exported the column visibility, we update it
        apiRef.current.setColumnVisibilityModel(previousColumnVisibility.current);
        apiRef.current.setState((state)=>(0, $35ed394581d01f61$var$_extends2.default)({}, state, {
                virtualization: previousVirtualizationState.current
            }));
        apiRef.current.setRows(previousRows.current);
        // Clear local state
        previousGridState.current = null;
        previousColumnVisibility.current = {};
        previousRows.current = [];
    }, [
        apiRef
    ]);
    const exportDataAsPrint = $35ed394581d01f61$var$React.useCallback(async (options)=>{
        logger.debug(`Export data as Print`);
        if (!apiRef.current.rootElementRef.current) throw new Error('MUI X: No grid root element available.');
        previousGridState.current = apiRef.current.exportState();
        // It appends that the visibility model is not exported, especially if columnVisibility is not controlled
        previousColumnVisibility.current = (0, $e732684465924d20$exports.gridColumnVisibilityModelSelector)(apiRef);
        previousRows.current = apiRef.current.getSortedRows().filter((row)=>!row[$0166dd44615cae0d$exports.GRID_ID_AUTOGENERATED]);
        if (props.pagination) {
            const visibleRowCount = (0, $e95988b653de2e96$exports.gridExpandedRowCountSelector)(apiRef);
            const paginationModel = {
                page: 0,
                pageSize: visibleRowCount
            };
            apiRef.current.setState((state)=>(0, $35ed394581d01f61$var$_extends2.default)({}, state, {
                    pagination: (0, $35ed394581d01f61$var$_extends2.default)({}, state.pagination, {
                        paginationModel: (0, $5e8e37726d5ba261$exports.getDerivedPaginationModel)(state.pagination, // Using signature `DataGridPro` to allow more than 100 rows in the print export
                        'DataGridPro', paginationModel)
                    })
                }));
        }
        previousVirtualizationState.current = apiRef.current.state.virtualization;
        apiRef.current.unstable_setVirtualization(false);
        await updateGridColumnsForPrint(options?.fields, options?.allColumns, options?.includeCheckboxes);
        updateGridRowsForPrint(options?.getRowsToExport ?? $e77bee9f62f5124d$exports.defaultGetRowsToExport);
        await $35ed394581d01f61$var$raf(); // wait for the state changes to take action
        const printWindow = $35ed394581d01f61$var$buildPrintWindow(options?.fileName);
        printWindow.onload = ()=>{
            handlePrintWindowLoad(printWindow, options);
            const mediaQueryList = printWindow.contentWindow.matchMedia('print');
            mediaQueryList.addEventListener('change', (mql)=>{
                const isAfterPrint = mql.matches === false;
                if (isAfterPrint) handlePrintWindowAfterPrint(printWindow);
            });
        };
        doc.current.body.appendChild(printWindow);
    }, [
        props,
        logger,
        apiRef,
        handlePrintWindowLoad,
        handlePrintWindowAfterPrint,
        updateGridColumnsForPrint,
        updateGridRowsForPrint
    ]);
    const printExportApi = {
        exportDataAsPrint: exportDataAsPrint
    };
    (0, $d79b1aa4f5237e85$exports.useGridApiMethod)(apiRef, printExportApi, 'public');
    /**
   * PRE-PROCESSING
   */ const addExportMenuButtons = $35ed394581d01f61$var$React.useCallback((initialValue, options)=>{
        if (options.printOptions?.disableToolbarButton) return initialValue;
        return [
            ...initialValue,
            {
                component: /*#__PURE__*/ (0, $ayMG0.jsx)($db5176c392a1c83e$exports.GridPrintExportMenuItem, {
                    options: options.printOptions
                }),
                componentName: 'printExport'
            }
        ];
    }, []);
    (0, $1aa692cb9e262bac$exports.useGridRegisterPipeProcessor)(apiRef, 'exportMenu', addExportMenuButtons);
};
$35ed394581d01f61$exports.useGridPrintExport = $35ed394581d01f61$var$useGridPrintExport;


var $91ff0c015e83a086$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $91ff0c015e83a086$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $91ff0c015e83a086$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($91ff0c015e83a086$exports, "__esModule", {
    value: true
});
$91ff0c015e83a086$exports.useGridFilter = $91ff0c015e83a086$exports.filterStateInitializer = void 0;

var $91ff0c015e83a086$var$_extends2 = $91ff0c015e83a086$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $91ff0c015e83a086$var$React = $91ff0c015e83a086$require$_interopRequireWildcard((parcelRequire("acw62")));


var $91ff0c015e83a086$var$_useEnhancedEffect = $91ff0c015e83a086$require$_interopRequireDefault((parcelRequire("jdWO4")));


var $7O6ub = parcelRequire("7O6ub");













var $ayMG0 = parcelRequire("ayMG0");
const $91ff0c015e83a086$var$filterStateInitializer = (state, props, apiRef)=>{
    const filterModel = props.filterModel ?? props.initialState?.filter?.filterModel ?? (0, $f582e8f6fdde33c9$exports.getDefaultGridFilterModel)();
    return (0, $91ff0c015e83a086$var$_extends2.default)({}, state, {
        filter: (0, $91ff0c015e83a086$var$_extends2.default)({
            filterModel: (0, $0c70cf7c1343c218$exports.sanitizeFilterModel)(filterModel, props.disableMultipleColumnsFiltering, apiRef)
        }, $f582e8f6fdde33c9$exports.defaultGridFilterLookup),
        visibleRowsLookup: {}
    });
};
$91ff0c015e83a086$exports.filterStateInitializer = $91ff0c015e83a086$var$filterStateInitializer;
const $91ff0c015e83a086$var$getVisibleRowsLookup = (params)=>{
    // For flat tree, the `visibleRowsLookup` and the `filteredRowsLookup` are equals since no row is collapsed.
    return params.filteredRowsLookup;
};
function $91ff0c015e83a086$var$getVisibleRowsLookupState(apiRef, state) {
    return apiRef.current.applyStrategyProcessor('visibleRowsLookupCreation', {
        tree: state.rows.tree,
        filteredRowsLookup: state.filter.filteredRowsLookup
    });
}
function $91ff0c015e83a086$var$createMemoizedValues() {
    return (0, $91b32b7177105fb1$exports.lruMemoize)(Object.values);
}
/**
 * @requires useGridColumns (method, event)
 * @requires useGridParamsApi (method)
 * @requires useGridRows (event)
 */ const $91ff0c015e83a086$var$useGridFilter = (apiRef, props, configuration)=>{
    const logger = (0, $fa53bf7350a63511$exports.useGridLogger)(apiRef, 'useGridFilter');
    apiRef.current.registerControlState({
        stateId: 'filter',
        propModel: props.filterModel,
        propOnChange: props.onFilterModelChange,
        stateSelector: $e95988b653de2e96$exports.gridFilterModelSelector,
        changeEvent: 'filterModelChange'
    });
    const updateFilteredRows = $91ff0c015e83a086$var$React.useCallback(()=>{
        apiRef.current.setState((state)=>{
            const filterModel = (0, $e95988b653de2e96$exports.gridFilterModelSelector)(apiRef);
            const filterState = apiRef.current.getFilterState(filterModel);
            const newState = (0, $91ff0c015e83a086$var$_extends2.default)({}, state, {
                filter: (0, $91ff0c015e83a086$var$_extends2.default)({}, state.filter, filterState)
            });
            const visibleRowsLookupState = $91ff0c015e83a086$var$getVisibleRowsLookupState(apiRef, newState);
            return (0, $91ff0c015e83a086$var$_extends2.default)({}, newState, {
                visibleRowsLookup: visibleRowsLookupState
            });
        });
        apiRef.current.publishEvent('filteredRowsSet');
    }, [
        apiRef
    ]);
    const addColumnMenuItem = $91ff0c015e83a086$var$React.useCallback((columnMenuItems, colDef)=>{
        if (colDef == null || colDef.filterable === false || props.disableColumnFilter) return columnMenuItems;
        return [
            ...columnMenuItems,
            'columnMenuFilterItem'
        ];
    }, [
        props.disableColumnFilter
    ]);
    /**
   * API METHODS
   */ const upsertFilterItem = $91ff0c015e83a086$var$React.useCallback((item)=>{
        const filterModel = (0, $e95988b653de2e96$exports.gridFilterModelSelector)(apiRef);
        const items = [
            ...filterModel.items
        ];
        const itemIndex = items.findIndex((filterItem)=>filterItem.id === item.id);
        if (itemIndex === -1) items.push(item);
        else items[itemIndex] = item;
        apiRef.current.setFilterModel((0, $91ff0c015e83a086$var$_extends2.default)({}, filterModel, {
            items: items
        }), 'upsertFilterItem');
    }, [
        apiRef
    ]);
    const upsertFilterItems = $91ff0c015e83a086$var$React.useCallback((items)=>{
        const filterModel = (0, $e95988b653de2e96$exports.gridFilterModelSelector)(apiRef);
        const existingItems = [
            ...filterModel.items
        ];
        items.forEach((item)=>{
            const itemIndex = existingItems.findIndex((filterItem)=>filterItem.id === item.id);
            if (itemIndex === -1) existingItems.push(item);
            else existingItems[itemIndex] = item;
        });
        apiRef.current.setFilterModel((0, $91ff0c015e83a086$var$_extends2.default)({}, filterModel, {
            items: existingItems
        }), 'upsertFilterItems');
    }, [
        apiRef
    ]);
    const deleteFilterItem = $91ff0c015e83a086$var$React.useCallback((itemToDelete)=>{
        const filterModel = (0, $e95988b653de2e96$exports.gridFilterModelSelector)(apiRef);
        const items = filterModel.items.filter((item)=>item.id !== itemToDelete.id);
        if (items.length === filterModel.items.length) return;
        apiRef.current.setFilterModel((0, $91ff0c015e83a086$var$_extends2.default)({}, filterModel, {
            items: items
        }), 'deleteFilterItem');
    }, [
        apiRef
    ]);
    const showFilterPanel = $91ff0c015e83a086$var$React.useCallback((targetColumnField, panelId, labelId)=>{
        logger.debug('Displaying filter panel');
        if (targetColumnField) {
            const filterModel = (0, $e95988b653de2e96$exports.gridFilterModelSelector)(apiRef);
            const filterItemsWithValue = filterModel.items.filter((item)=>{
                if (item.value !== undefined) {
                    // Some filters like `isAnyOf` support array as `item.value`.
                    // If array is empty, we want to remove it from the filter model.
                    if (Array.isArray(item.value) && item.value.length === 0) return false;
                    return true;
                }
                const column = apiRef.current.getColumn(item.field);
                const filterOperator = column.filterOperators?.find((operator)=>operator.value === item.operator);
                const requiresFilterValue = typeof filterOperator?.requiresFilterValue === 'undefined' ? true : filterOperator?.requiresFilterValue;
                // Operators like `isEmpty` don't have and don't require `item.value`.
                // So we don't want to remove them from the filter model if `item.value === undefined`.
                // See https://github.com/mui/mui-x/issues/5402
                if (requiresFilterValue) return false;
                return true;
            });
            let newFilterItems;
            const filterItemOnTarget = filterItemsWithValue.find((item)=>item.field === targetColumnField);
            const targetColumn = apiRef.current.getColumn(targetColumnField);
            if (filterItemOnTarget) newFilterItems = filterItemsWithValue;
            else if (props.disableMultipleColumnsFiltering) newFilterItems = [
                (0, $0c70cf7c1343c218$exports.cleanFilterItem)({
                    field: targetColumnField,
                    operator: targetColumn.filterOperators[0].value
                }, apiRef)
            ];
            else newFilterItems = [
                ...filterItemsWithValue,
                (0, $0c70cf7c1343c218$exports.cleanFilterItem)({
                    field: targetColumnField,
                    operator: targetColumn.filterOperators[0].value
                }, apiRef)
            ];
            apiRef.current.setFilterModel((0, $91ff0c015e83a086$var$_extends2.default)({}, filterModel, {
                items: newFilterItems
            }));
        }
        apiRef.current.showPreferences($2ca45f4bbfed6878$exports.GridPreferencePanelsValue.filters, panelId, labelId);
    }, [
        apiRef,
        logger,
        props.disableMultipleColumnsFiltering
    ]);
    const hideFilterPanel = $91ff0c015e83a086$var$React.useCallback(()=>{
        logger.debug('Hiding filter panel');
        apiRef.current.hidePreferences();
    }, [
        apiRef,
        logger
    ]);
    const setFilterLogicOperator = $91ff0c015e83a086$var$React.useCallback((logicOperator)=>{
        const filterModel = (0, $e95988b653de2e96$exports.gridFilterModelSelector)(apiRef);
        if (filterModel.logicOperator === logicOperator) return;
        apiRef.current.setFilterModel((0, $91ff0c015e83a086$var$_extends2.default)({}, filterModel, {
            logicOperator: logicOperator
        }), 'changeLogicOperator');
    }, [
        apiRef
    ]);
    const setQuickFilterValues = $91ff0c015e83a086$var$React.useCallback((values)=>{
        const filterModel = (0, $e95988b653de2e96$exports.gridFilterModelSelector)(apiRef);
        if ((0, $a4d2c99ef8ba2460$exports.isDeepEqual)(filterModel.quickFilterValues, values)) return;
        apiRef.current.setFilterModel((0, $91ff0c015e83a086$var$_extends2.default)({}, filterModel, {
            quickFilterValues: [
                ...values
            ]
        }));
    }, [
        apiRef
    ]);
    const setFilterModel = $91ff0c015e83a086$var$React.useCallback((model, reason)=>{
        const currentModel = (0, $e95988b653de2e96$exports.gridFilterModelSelector)(apiRef);
        if (currentModel !== model) {
            logger.debug('Setting filter model');
            apiRef.current.updateControlState('filter', (0, $0c70cf7c1343c218$exports.mergeStateWithFilterModel)(model, props.disableMultipleColumnsFiltering, apiRef), reason);
            apiRef.current.unstable_applyFilters();
        }
    }, [
        apiRef,
        logger,
        props.disableMultipleColumnsFiltering
    ]);
    const getFilterState = $91ff0c015e83a086$var$React.useCallback((inputFilterModel)=>{
        const filterModel = (0, $0c70cf7c1343c218$exports.sanitizeFilterModel)(inputFilterModel, props.disableMultipleColumnsFiltering, apiRef);
        const filterValueGetter = configuration.hooks.useFilterValueGetter(apiRef, props);
        const isRowMatchingFilters = props.filterMode === 'client' ? (0, $0c70cf7c1343c218$exports.buildAggregatedFilterApplier)(filterModel, filterValueGetter, apiRef, props.disableEval) : null;
        const filterResult = apiRef.current.applyStrategyProcessor('filtering', {
            isRowMatchingFilters: isRowMatchingFilters,
            filterModel: filterModel ?? (0, $f582e8f6fdde33c9$exports.getDefaultGridFilterModel)(),
            filterValueGetter: filterValueGetter
        });
        return (0, $91ff0c015e83a086$var$_extends2.default)({}, filterResult, {
            filterModel: filterModel
        });
    }, [
        apiRef,
        configuration.hooks,
        props
    ]);
    const filterApi = {
        setFilterLogicOperator: setFilterLogicOperator,
        unstable_applyFilters: updateFilteredRows,
        deleteFilterItem: deleteFilterItem,
        upsertFilterItem: upsertFilterItem,
        upsertFilterItems: upsertFilterItems,
        setFilterModel: setFilterModel,
        showFilterPanel: showFilterPanel,
        hideFilterPanel: hideFilterPanel,
        setQuickFilterValues: setQuickFilterValues,
        ignoreDiacritics: props.ignoreDiacritics,
        getFilterState: getFilterState
    };
    (0, $d79b1aa4f5237e85$exports.useGridApiMethod)(apiRef, filterApi, 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $91ff0c015e83a086$var$React.useCallback((prevState, context)=>{
        const filterModelToExport = (0, $e95988b653de2e96$exports.gridFilterModelSelector)(apiRef);
        // Remove the additional `fromInput` property from the filter model
        filterModelToExport.items.forEach((item)=>{
            delete item.fromInput;
        });
        const shouldExportFilterModel = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the model is controlled
        props.filterModel != null || // Always export if the model has been initialized
        props.initialState?.filter?.filterModel != null || // Export if the model is not equal to the default value
        !(0, $a4d2c99ef8ba2460$exports.isDeepEqual)(filterModelToExport, (0, $f582e8f6fdde33c9$exports.getDefaultGridFilterModel)());
        if (!shouldExportFilterModel) return prevState;
        return (0, $91ff0c015e83a086$var$_extends2.default)({}, prevState, {
            filter: {
                filterModel: filterModelToExport
            }
        });
    }, [
        apiRef,
        props.filterModel,
        props.initialState?.filter?.filterModel
    ]);
    const stateRestorePreProcessing = $91ff0c015e83a086$var$React.useCallback((params, context)=>{
        const filterModel = context.stateToRestore.filter?.filterModel;
        if (filterModel == null) return params;
        apiRef.current.updateControlState('filter', (0, $0c70cf7c1343c218$exports.mergeStateWithFilterModel)(filterModel, props.disableMultipleColumnsFiltering, apiRef), 'restoreState');
        return (0, $91ff0c015e83a086$var$_extends2.default)({}, params, {
            callbacks: [
                ...params.callbacks,
                apiRef.current.unstable_applyFilters
            ]
        });
    }, [
        apiRef,
        props.disableMultipleColumnsFiltering
    ]);
    const preferencePanelPreProcessing = $91ff0c015e83a086$var$React.useCallback((initialValue, value)=>{
        if (value === $2ca45f4bbfed6878$exports.GridPreferencePanelsValue.filters) {
            const FilterPanel = props.slots.filterPanel;
            return /*#__PURE__*/ (0, $ayMG0.jsx)(FilterPanel, (0, $91ff0c015e83a086$var$_extends2.default)({}, props.slotProps?.filterPanel));
        }
        return initialValue;
    }, [
        props.slots.filterPanel,
        props.slotProps?.filterPanel
    ]);
    const { getRowId: getRowId } = props;
    const getRowsRef = (0, $7O6ub.useLazyRef)($91ff0c015e83a086$var$createMemoizedValues);
    const flatFilteringMethod = $91ff0c015e83a086$var$React.useCallback((params)=>{
        if (props.filterMode !== 'client' || !params.isRowMatchingFilters || !params.filterModel.items.length && !params.filterModel.quickFilterValues?.length) return $f582e8f6fdde33c9$exports.defaultGridFilterLookup;
        const dataRowIdToModelLookup = (0, $aad5df8f504205b0$exports.gridRowsLookupSelector)(apiRef);
        const filteredRowsLookup = {};
        const { isRowMatchingFilters: isRowMatchingFilters } = params;
        const filterCache = {};
        const result = {
            passingFilterItems: null,
            passingQuickFilterValues: null
        };
        const rows = getRowsRef.current(apiRef.current.state.rows.dataRowIdToModelLookup);
        for(let i = 0; i < rows.length; i += 1){
            const row = rows[i];
            const id = getRowId ? getRowId(row) : row.id;
            isRowMatchingFilters(row, undefined, result);
            const isRowPassing = (0, $0c70cf7c1343c218$exports.passFilterLogic)([
                result.passingFilterItems
            ], [
                result.passingQuickFilterValues
            ], params.filterModel, params.filterValueGetter, apiRef, filterCache);
            if (!isRowPassing) filteredRowsLookup[id] = isRowPassing;
        }
        const footerId = 'auto-generated-group-footer-root';
        const footer = dataRowIdToModelLookup[footerId];
        if (footer) filteredRowsLookup[footerId] = true;
        return {
            filteredRowsLookup: filteredRowsLookup,
            filteredChildrenCountLookup: {},
            filteredDescendantCountLookup: {}
        };
    }, [
        apiRef,
        props.filterMode,
        getRowId,
        getRowsRef
    ]);
    (0, $1aa692cb9e262bac$exports.useGridRegisterPipeProcessor)(apiRef, 'columnMenu', addColumnMenuItem);
    (0, $1aa692cb9e262bac$exports.useGridRegisterPipeProcessor)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $1aa692cb9e262bac$exports.useGridRegisterPipeProcessor)(apiRef, 'restoreState', stateRestorePreProcessing);
    (0, $1aa692cb9e262bac$exports.useGridRegisterPipeProcessor)(apiRef, 'preferencePanel', preferencePanelPreProcessing);
    (0, $41d629b2793a9305$exports.useGridRegisterStrategyProcessor)(apiRef, $41d629b2793a9305$exports.GRID_DEFAULT_STRATEGY, 'filtering', flatFilteringMethod);
    (0, $41d629b2793a9305$exports.useGridRegisterStrategyProcessor)(apiRef, $41d629b2793a9305$exports.GRID_DEFAULT_STRATEGY, 'visibleRowsLookupCreation', $91ff0c015e83a086$var$getVisibleRowsLookup);
    /**
   * EVENTS
   */ const handleColumnsChange = $91ff0c015e83a086$var$React.useCallback(()=>{
        logger.debug('onColUpdated - GridColumns changed, applying filters');
        const filterModel = (0, $e95988b653de2e96$exports.gridFilterModelSelector)(apiRef);
        const columnsLookup = (0, $e732684465924d20$exports.gridColumnLookupSelector)(apiRef);
        const newFilterItems = filterModel.items.filter((item)=>item.field && columnsLookup[item.field]);
        if (newFilterItems.length < filterModel.items.length) apiRef.current.setFilterModel((0, $91ff0c015e83a086$var$_extends2.default)({}, filterModel, {
            items: newFilterItems
        }));
    }, [
        apiRef,
        logger
    ]);
    const handleStrategyProcessorChange = $91ff0c015e83a086$var$React.useCallback((methodName)=>{
        if (methodName === 'filtering') apiRef.current.unstable_applyFilters();
    }, [
        apiRef
    ]);
    const updateVisibleRowsLookupState = $91ff0c015e83a086$var$React.useCallback(()=>{
        apiRef.current.setState((state)=>{
            return (0, $91ff0c015e83a086$var$_extends2.default)({}, state, {
                visibleRowsLookup: $91ff0c015e83a086$var$getVisibleRowsLookupState(apiRef, state)
            });
        });
    }, [
        apiRef
    ]);
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'rowsSet', updateFilteredRows);
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'columnsChange', handleColumnsChange);
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'activeStrategyProcessorChange', handleStrategyProcessorChange);
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'rowExpansionChange', updateVisibleRowsLookupState);
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'columnVisibilityModelChange', ()=>{
        const filterModel = (0, $e95988b653de2e96$exports.gridFilterModelSelector)(apiRef);
        if (filterModel.quickFilterValues?.length && (0, $0c70cf7c1343c218$exports.shouldQuickFilterExcludeHiddenColumns)(filterModel)) // re-apply filters because the quick filter results may have changed
        updateFilteredRows();
    });
    /**
   * 1ST RENDER
   */ (0, $82679e37231fe76f$exports.useFirstRender)(()=>{
        if (props.signature === 'DataGrid') updateFilteredRows();
    });
    /**
   * EFFECTS
   */ (0, $91ff0c015e83a086$var$_useEnhancedEffect.default)(()=>{
        if (props.filterModel !== undefined) apiRef.current.setFilterModel(props.filterModel);
    }, [
        apiRef,
        logger,
        props.filterModel
    ]);
};
$91ff0c015e83a086$exports.useGridFilter = $91ff0c015e83a086$var$useGridFilter;


var $0fc273bc52ff1742$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $0fc273bc52ff1742$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $0fc273bc52ff1742$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($0fc273bc52ff1742$exports, "__esModule", {
    value: true
});
$0fc273bc52ff1742$exports.useGridFocus = $0fc273bc52ff1742$exports.focusStateInitializer = void 0;

var $0fc273bc52ff1742$var$_extends2 = $0fc273bc52ff1742$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $0fc273bc52ff1742$var$React = $0fc273bc52ff1742$require$_interopRequireWildcard((parcelRequire("acw62")));

var $0fc273bc52ff1742$var$_debounce = $0fc273bc52ff1742$require$_interopRequireDefault((parcelRequire("9NXOO")));

var $0fc273bc52ff1742$var$_useEventCallback = $0fc273bc52ff1742$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $0fc273bc52ff1742$var$_ownerDocument = $0fc273bc52ff1742$require$_interopRequireDefault((parcelRequire("43fuO")));

var $5H1vo = parcelRequire("5H1vo");









const $0fc273bc52ff1742$var$focusStateInitializer = (state)=>(0, $0fc273bc52ff1742$var$_extends2.default)({}, state, {
        focus: {
            cell: null,
            columnHeader: null,
            columnHeaderFilter: null,
            columnGroupHeader: null
        },
        tabIndex: {
            cell: null,
            columnHeader: null,
            columnHeaderFilter: null,
            columnGroupHeader: null
        }
    });
/**
 * @requires useGridParamsApi (method)
 * @requires useGridRows (method)
 * @requires useGridEditing (event)
 */ $0fc273bc52ff1742$exports.focusStateInitializer = $0fc273bc52ff1742$var$focusStateInitializer;
const $0fc273bc52ff1742$var$useGridFocus = (apiRef, props)=>{
    const logger = (0, $fa53bf7350a63511$exports.useGridLogger)(apiRef, 'useGridFocus');
    const lastClickedCell = $0fc273bc52ff1742$var$React.useRef(null);
    const hasRootReference = apiRef.current.rootElementRef.current !== null;
    const publishCellFocusOut = $0fc273bc52ff1742$var$React.useCallback((cell, event)=>{
        if (cell) // The row might have been deleted
        {
            if (apiRef.current.getRow(cell.id)) apiRef.current.publishEvent('cellFocusOut', apiRef.current.getCellParams(cell.id, cell.field), event);
        }
    }, [
        apiRef
    ]);
    const setCellFocus = $0fc273bc52ff1742$var$React.useCallback((id, field)=>{
        const focusedCell = (0, $9c9b8e89fddd633d$exports.gridFocusCellSelector)(apiRef);
        if (focusedCell?.id === id && focusedCell?.field === field) return;
        apiRef.current.setState((state)=>{
            logger.debug(`Focusing on cell with id=${id} and field=${field}`);
            return (0, $0fc273bc52ff1742$var$_extends2.default)({}, state, {
                tabIndex: {
                    cell: {
                        id: id,
                        field: field
                    },
                    columnHeader: null,
                    columnHeaderFilter: null,
                    columnGroupHeader: null
                },
                focus: {
                    cell: {
                        id: id,
                        field: field
                    },
                    columnHeader: null,
                    columnHeaderFilter: null,
                    columnGroupHeader: null
                }
            });
        });
        // The row might have been deleted
        if (!apiRef.current.getRow(id)) return;
        if (focusedCell) // There's a focused cell but another cell was clicked
        // Publishes an event to notify that the focus was lost
        publishCellFocusOut(focusedCell, {});
        apiRef.current.publishEvent('cellFocusIn', apiRef.current.getCellParams(id, field));
    }, [
        apiRef,
        logger,
        publishCellFocusOut
    ]);
    const setColumnHeaderFocus = $0fc273bc52ff1742$var$React.useCallback((field, event = {})=>{
        const cell = (0, $9c9b8e89fddd633d$exports.gridFocusCellSelector)(apiRef);
        publishCellFocusOut(cell, event);
        apiRef.current.setState((state)=>{
            logger.debug(`Focusing on column header with colIndex=${field}`);
            return (0, $0fc273bc52ff1742$var$_extends2.default)({}, state, {
                tabIndex: {
                    columnHeader: {
                        field: field
                    },
                    columnHeaderFilter: null,
                    cell: null,
                    columnGroupHeader: null
                },
                focus: {
                    columnHeader: {
                        field: field
                    },
                    columnHeaderFilter: null,
                    cell: null,
                    columnGroupHeader: null
                }
            });
        });
    }, [
        apiRef,
        logger,
        publishCellFocusOut
    ]);
    const setColumnHeaderFilterFocus = $0fc273bc52ff1742$var$React.useCallback((field, event = {})=>{
        const cell = (0, $9c9b8e89fddd633d$exports.gridFocusCellSelector)(apiRef);
        publishCellFocusOut(cell, event);
        apiRef.current.setState((state)=>{
            logger.debug(`Focusing on column header filter with colIndex=${field}`);
            return (0, $0fc273bc52ff1742$var$_extends2.default)({}, state, {
                tabIndex: {
                    columnHeader: null,
                    columnHeaderFilter: {
                        field: field
                    },
                    cell: null,
                    columnGroupHeader: null
                },
                focus: {
                    columnHeader: null,
                    columnHeaderFilter: {
                        field: field
                    },
                    cell: null,
                    columnGroupHeader: null
                }
            });
        });
    }, [
        apiRef,
        logger,
        publishCellFocusOut
    ]);
    const setColumnGroupHeaderFocus = $0fc273bc52ff1742$var$React.useCallback((field, depth, event = {})=>{
        const cell = (0, $9c9b8e89fddd633d$exports.gridFocusCellSelector)(apiRef);
        if (cell) apiRef.current.publishEvent('cellFocusOut', apiRef.current.getCellParams(cell.id, cell.field), event);
        apiRef.current.setState((state)=>{
            return (0, $0fc273bc52ff1742$var$_extends2.default)({}, state, {
                tabIndex: {
                    columnGroupHeader: {
                        field: field,
                        depth: depth
                    },
                    columnHeader: null,
                    columnHeaderFilter: null,
                    cell: null
                },
                focus: {
                    columnGroupHeader: {
                        field: field,
                        depth: depth
                    },
                    columnHeader: null,
                    columnHeaderFilter: null,
                    cell: null
                }
            });
        });
    }, [
        apiRef
    ]);
    const getColumnGroupHeaderFocus = $0fc273bc52ff1742$var$React.useCallback(()=>(0, $9c9b8e89fddd633d$exports.gridFocusColumnGroupHeaderSelector)(apiRef), [
        apiRef
    ]);
    const moveFocusToRelativeCell = $0fc273bc52ff1742$var$React.useCallback((id, field, direction)=>{
        let columnIndexToFocus = apiRef.current.getColumnIndex(field);
        const visibleColumns = (0, $e732684465924d20$exports.gridVisibleColumnDefinitionsSelector)(apiRef);
        const currentPage = (0, $7d0a5941a1add073$exports.getVisibleRows)(apiRef, {
            pagination: props.pagination,
            paginationMode: props.paginationMode
        });
        const pinnedRows = (0, $befccaa56b49492d$exports.gridPinnedRowsSelector)(apiRef);
        // Include pinned rows as well
        const currentPageRows = [].concat(pinnedRows.top || [], currentPage.rows, pinnedRows.bottom || []);
        let rowIndexToFocus = currentPageRows.findIndex((row)=>row.id === id);
        if (direction === 'right') columnIndexToFocus += 1;
        else if (direction === 'left') columnIndexToFocus -= 1;
        else rowIndexToFocus += 1;
        if (columnIndexToFocus >= visibleColumns.length) {
            // Go to next row if we are after the last column
            rowIndexToFocus += 1;
            if (rowIndexToFocus < currentPageRows.length) // Go to first column of the next row if there's one more row
            columnIndexToFocus = 0;
        } else if (columnIndexToFocus < 0) {
            // Go to previous row if we are before the first column
            rowIndexToFocus -= 1;
            if (rowIndexToFocus >= 0) // Go to last column of the previous if there's one more row
            columnIndexToFocus = visibleColumns.length - 1;
        }
        rowIndexToFocus = (0, $fe919794eb3b24e8$exports.clamp)(rowIndexToFocus, 0, currentPageRows.length - 1);
        const rowToFocus = currentPageRows[rowIndexToFocus];
        if (!rowToFocus) return;
        const colSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowToFocus.id, columnIndexToFocus);
        if (colSpanInfo && colSpanInfo.spannedByColSpan) {
            if (direction === 'left' || direction === 'below') columnIndexToFocus = colSpanInfo.leftVisibleCellIndex;
            else if (direction === 'right') columnIndexToFocus = colSpanInfo.rightVisibleCellIndex;
        }
        columnIndexToFocus = (0, $fe919794eb3b24e8$exports.clamp)(columnIndexToFocus, 0, visibleColumns.length - 1);
        const columnToFocus = visibleColumns[columnIndexToFocus];
        apiRef.current.setCellFocus(rowToFocus.id, columnToFocus.field);
    }, [
        apiRef,
        props.pagination,
        props.paginationMode
    ]);
    const handleCellDoubleClick = $0fc273bc52ff1742$var$React.useCallback(({ id: id, field: field })=>{
        apiRef.current.setCellFocus(id, field);
    }, [
        apiRef
    ]);
    const handleCellKeyDown = $0fc273bc52ff1742$var$React.useCallback((params, event)=>{
        if (event.key === 'Enter' || event.key === 'Tab' || event.key === 'Shift' || (0, $a08faead7d1bb429$exports.isNavigationKey)(event.key)) return;
        apiRef.current.setCellFocus(params.id, params.field);
    }, [
        apiRef
    ]);
    const handleColumnHeaderFocus = $0fc273bc52ff1742$var$React.useCallback(({ field: field }, event)=>{
        if (event.target !== event.currentTarget) return;
        apiRef.current.setColumnHeaderFocus(field, event);
    }, [
        apiRef
    ]);
    const handleColumnGroupHeaderFocus = $0fc273bc52ff1742$var$React.useCallback(({ fields: fields, depth: depth }, event)=>{
        if (event.target !== event.currentTarget) return;
        const focusedColumnGroup = (0, $9c9b8e89fddd633d$exports.gridFocusColumnGroupHeaderSelector)(apiRef);
        if (focusedColumnGroup !== null && focusedColumnGroup.depth === depth && fields.includes(focusedColumnGroup.field)) // This group cell has already been focused
        return;
        apiRef.current.setColumnGroupHeaderFocus(fields[0], depth, event);
    }, [
        apiRef
    ]);
    const handleBlur = $0fc273bc52ff1742$var$React.useCallback((_, event)=>{
        if (event.relatedTarget?.getAttribute('class')?.includes($5H1vo.gridClasses.columnHeader)) return;
        logger.debug(`Clearing focus`);
        apiRef.current.setState((state)=>(0, $0fc273bc52ff1742$var$_extends2.default)({}, state, {
                focus: {
                    cell: null,
                    columnHeader: null,
                    columnHeaderFilter: null,
                    columnGroupHeader: null
                }
            }));
    }, [
        logger,
        apiRef
    ]);
    const handleCellMouseDown = $0fc273bc52ff1742$var$React.useCallback((params)=>{
        lastClickedCell.current = params;
    }, []);
    const handleDocumentClick = $0fc273bc52ff1742$var$React.useCallback((event)=>{
        const cellParams = lastClickedCell.current;
        lastClickedCell.current = null;
        const focusedCell = (0, $9c9b8e89fddd633d$exports.gridFocusCellSelector)(apiRef);
        const canUpdateFocus = apiRef.current.unstable_applyPipeProcessors('canUpdateFocus', true, {
            event: event,
            cell: cellParams
        });
        if (!canUpdateFocus) return;
        if (!focusedCell) {
            if (cellParams) apiRef.current.setCellFocus(cellParams.id, cellParams.field);
            return;
        }
        if (cellParams?.id === focusedCell.id && cellParams?.field === focusedCell.field) return;
        const cellElement = apiRef.current.getCellElement(focusedCell.id, focusedCell.field);
        if (cellElement?.contains(event.target)) return;
        if (cellParams) apiRef.current.setCellFocus(cellParams.id, cellParams.field);
        else {
            apiRef.current.setState((state)=>(0, $0fc273bc52ff1742$var$_extends2.default)({}, state, {
                    focus: {
                        cell: null,
                        columnHeader: null,
                        columnHeaderFilter: null,
                        columnGroupHeader: null
                    }
                }));
            // There's a focused cell but another element (not a cell) was clicked
            // Publishes an event to notify that the focus was lost
            publishCellFocusOut(focusedCell, event);
        }
    }, [
        apiRef,
        publishCellFocusOut
    ]);
    const handleCellModeChange = $0fc273bc52ff1742$var$React.useCallback((params)=>{
        if (params.cellMode === 'view') return;
        const cell = (0, $9c9b8e89fddd633d$exports.gridFocusCellSelector)(apiRef);
        if (cell?.id !== params.id || cell?.field !== params.field) apiRef.current.setCellFocus(params.id, params.field);
    }, [
        apiRef
    ]);
    const handleRowsSet = $0fc273bc52ff1742$var$React.useCallback(()=>{
        const cell = (0, $9c9b8e89fddd633d$exports.gridFocusCellSelector)(apiRef);
        // If the focused cell is in a row which does not exist anymore,
        // focus previous row or remove the focus
        if (cell && !apiRef.current.getRow(cell.id)) {
            const lastFocusedRowId = cell.id;
            let nextRowId = null;
            if (typeof lastFocusedRowId !== 'undefined') {
                const rowEl = apiRef.current.getRowElement(lastFocusedRowId);
                const lastFocusedRowIndex = rowEl?.dataset.rowindex ? Number(rowEl?.dataset.rowindex) : 0;
                const currentPage = (0, $7d0a5941a1add073$exports.getVisibleRows)(apiRef, {
                    pagination: props.pagination,
                    paginationMode: props.paginationMode
                });
                const nextRow = currentPage.rows[(0, $fe919794eb3b24e8$exports.clamp)(lastFocusedRowIndex, 0, currentPage.rows.length - 1)];
                nextRowId = nextRow?.id ?? null;
            }
            apiRef.current.setState((state)=>(0, $0fc273bc52ff1742$var$_extends2.default)({}, state, {
                    focus: {
                        cell: nextRowId === null ? null : {
                            id: nextRowId,
                            field: cell.field
                        },
                        columnHeader: null,
                        columnHeaderFilter: null,
                        columnGroupHeader: null
                    }
                }));
        }
    }, [
        apiRef,
        props.pagination,
        props.paginationMode
    ]);
    const debouncedHandleRowsSet = $0fc273bc52ff1742$var$React.useMemo(()=>(0, $0fc273bc52ff1742$var$_debounce.default)(handleRowsSet, 0), [
        handleRowsSet
    ]);
    const handlePaginationModelChange = (0, $0fc273bc52ff1742$var$_useEventCallback.default)(()=>{
        const currentFocusedCell = (0, $9c9b8e89fddd633d$exports.gridFocusCellSelector)(apiRef);
        if (!currentFocusedCell) return;
        const currentPage = (0, $7d0a5941a1add073$exports.getVisibleRows)(apiRef, {
            pagination: props.pagination,
            paginationMode: props.paginationMode
        });
        const rowIsInCurrentPage = currentPage.rows.find((row)=>row.id === currentFocusedCell.id);
        if (rowIsInCurrentPage || currentPage.rows.length === 0) return;
        const visibleColumns = (0, $e732684465924d20$exports.gridVisibleColumnDefinitionsSelector)(apiRef);
        apiRef.current.setState((state)=>{
            return (0, $0fc273bc52ff1742$var$_extends2.default)({}, state, {
                tabIndex: {
                    cell: {
                        id: currentPage.rows[0].id,
                        field: visibleColumns[0].field
                    },
                    columnGroupHeader: null,
                    columnHeader: null,
                    columnHeaderFilter: null
                }
            });
        });
    });
    const focusApi = {
        setCellFocus: setCellFocus,
        setColumnHeaderFocus: setColumnHeaderFocus,
        setColumnHeaderFilterFocus: setColumnHeaderFilterFocus
    };
    const focusPrivateApi = {
        moveFocusToRelativeCell: moveFocusToRelativeCell,
        setColumnGroupHeaderFocus: setColumnGroupHeaderFocus,
        getColumnGroupHeaderFocus: getColumnGroupHeaderFocus
    };
    (0, $d79b1aa4f5237e85$exports.useGridApiMethod)(apiRef, focusApi, 'public');
    (0, $d79b1aa4f5237e85$exports.useGridApiMethod)(apiRef, focusPrivateApi, 'private');
    $0fc273bc52ff1742$var$React.useEffect(()=>{
        const doc = (0, $0fc273bc52ff1742$var$_ownerDocument.default)(apiRef.current.rootElementRef.current);
        doc.addEventListener('mouseup', handleDocumentClick);
        return ()=>{
            doc.removeEventListener('mouseup', handleDocumentClick);
        };
    }, [
        apiRef,
        hasRootReference,
        handleDocumentClick
    ]);
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'columnHeaderBlur', handleBlur);
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'cellDoubleClick', handleCellDoubleClick);
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'cellMouseDown', handleCellMouseDown);
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'cellKeyDown', handleCellKeyDown);
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'cellModeChange', handleCellModeChange);
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'columnHeaderFocus', handleColumnHeaderFocus);
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'columnGroupHeaderFocus', handleColumnGroupHeaderFocus);
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'rowsSet', debouncedHandleRowsSet);
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'paginationModelChange', handlePaginationModelChange);
};
$0fc273bc52ff1742$exports.useGridFocus = $0fc273bc52ff1742$var$useGridFocus;


var $0c203bd54aeaf237$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $0c203bd54aeaf237$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($0c203bd54aeaf237$exports, "__esModule", {
    value: true
});
$0c203bd54aeaf237$exports.useGridKeyboardNavigation = void 0;

var $0c203bd54aeaf237$var$React = $0c203bd54aeaf237$require$_interopRequireWildcard((parcelRequire("acw62")));

var $9uEev = parcelRequire("9uEev");








var $5H1vo = parcelRequire("5H1vo");







var $24be03c588f8c679$exports = {};
"use strict";
Object.defineProperty($24be03c588f8c679$exports, "__esModule", {
    value: true
});
$24be03c588f8c679$exports.findNonRowSpannedCell = $24be03c588f8c679$var$findNonRowSpannedCell;
$24be03c588f8c679$exports.getRightColumnIndex = $24be03c588f8c679$exports.getLeftColumnIndex = void 0;


const $24be03c588f8c679$var$getLeftColumnIndex = ({ currentColIndex: currentColIndex, firstColIndex: firstColIndex, lastColIndex: lastColIndex, isRtl: isRtl })=>{
    if (isRtl) {
        if (currentColIndex < lastColIndex) return currentColIndex + 1;
    } else if (!isRtl) {
        if (currentColIndex > firstColIndex) return currentColIndex - 1;
    }
    return null;
};
$24be03c588f8c679$exports.getLeftColumnIndex = $24be03c588f8c679$var$getLeftColumnIndex;
const $24be03c588f8c679$var$getRightColumnIndex = ({ currentColIndex: currentColIndex, firstColIndex: firstColIndex, lastColIndex: lastColIndex, isRtl: isRtl })=>{
    if (isRtl) {
        if (currentColIndex > firstColIndex) return currentColIndex - 1;
    } else if (!isRtl) {
        if (currentColIndex < lastColIndex) return currentColIndex + 1;
    }
    return null;
};
$24be03c588f8c679$exports.getRightColumnIndex = $24be03c588f8c679$var$getRightColumnIndex;
function $24be03c588f8c679$var$findNonRowSpannedCell(apiRef, rowId, colIndex, rowSpanScanDirection) {
    const rowSpanHiddenCells = $f627be570fb53c87$exports.Rowspan.selectors.hiddenCells(apiRef.current.virtualizer.store.state);
    if (!rowSpanHiddenCells[rowId]?.[colIndex]) return rowId;
    const filteredSortedRowIds = (0, $e95988b653de2e96$exports.gridFilteredSortedRowIdsSelector)(apiRef);
    // find closest non row spanned cell in the given `rowSpanScanDirection`
    let nextRowIndex = filteredSortedRowIds.indexOf(rowId) + (rowSpanScanDirection === 'down' ? 1 : -1);
    while(nextRowIndex >= 0 && nextRowIndex < filteredSortedRowIds.length){
        const nextRowId = filteredSortedRowIds[nextRowIndex];
        if (!rowSpanHiddenCells[nextRowId]?.[colIndex]) return nextRowId;
        nextRowIndex += rowSpanScanDirection === 'down' ? 1 : -1;
    }
    return rowId;
}





const $0c203bd54aeaf237$var$gridVisibleRowsWithPinnedRowsSelector = (0, $8eef5f2af445e503$exports.createSelectorMemoized)($809f57c9ce5163f3$exports.gridVisibleRowsSelector, $befccaa56b49492d$exports.gridPinnedRowsSelector, (visibleRows, pinnedRows)=>{
    return (pinnedRows.top || []).concat(visibleRows.rows, pinnedRows.bottom || []);
});
/**
 * @requires useGridSorting (method) - can be after
 * @requires useGridFilter (state) - can be after
 * @requires useGridColumns (state, method) - can be after
 * @requires useGridDimensions (method) - can be after
 * @requires useGridFocus (method) - can be after
 * @requires useGridScroll (method) - can be after
 * @requires useGridColumnSpanning (method) - can be after
 */ const $0c203bd54aeaf237$var$useGridKeyboardNavigation = (apiRef, props)=>{
    const logger = (0, $fa53bf7350a63511$exports.useGridLogger)(apiRef, 'useGridKeyboardNavigation');
    const isRtl = (0, $9uEev.useRtl)();
    const getCurrentPageRows = $0c203bd54aeaf237$var$React.useCallback(()=>{
        return $0c203bd54aeaf237$var$gridVisibleRowsWithPinnedRowsSelector(apiRef);
    }, [
        apiRef
    ]);
    const headerFilteringEnabled = props.signature !== 'DataGrid' && props.headerFilters;
    /**
   * @param {number} colIndex Index of the column to focus
   * @param {GridRowId} rowId index of the row to focus
   * @param {string} closestColumnToUse Which closest column cell to use when the cell is spanned by `colSpan`.
   * @param {string} rowSpanScanDirection Which direction to search to find the next cell not hidden by `rowSpan`.
   * TODO replace with apiRef.current.moveFocusToRelativeCell()
   */ const goToCell = $0c203bd54aeaf237$var$React.useCallback((colIndex, rowId, closestColumnToUse = 'left', rowSpanScanDirection = 'up')=>{
        const visibleSortedRows = (0, $e95988b653de2e96$exports.gridExpandedSortedRowEntriesSelector)(apiRef);
        const nextCellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, colIndex);
        if (nextCellColSpanInfo && nextCellColSpanInfo.spannedByColSpan) {
            if (closestColumnToUse === 'left') colIndex = nextCellColSpanInfo.leftVisibleCellIndex;
            else if (closestColumnToUse === 'right') colIndex = nextCellColSpanInfo.rightVisibleCellIndex;
        }
        const field = (0, $e732684465924d20$exports.gridVisibleColumnFieldsSelector)(apiRef)[colIndex];
        const nonRowSpannedRowId = (0, $24be03c588f8c679$exports.findNonRowSpannedCell)(apiRef, rowId, colIndex, rowSpanScanDirection);
        // `scrollToIndexes` requires a rowIndex relative to all visible rows.
        // Those rows do not include pinned rows, but pinned rows do not need scroll anyway.
        const rowIndexRelativeToAllRows = visibleSortedRows.findIndex((row)=>row.id === nonRowSpannedRowId);
        logger.debug(`Navigating to cell row ${rowIndexRelativeToAllRows}, col ${colIndex}`);
        apiRef.current.scrollToIndexes({
            colIndex: colIndex,
            rowIndex: rowIndexRelativeToAllRows
        });
        apiRef.current.setCellFocus(nonRowSpannedRowId, field);
    }, [
        apiRef,
        logger
    ]);
    const goToHeader = $0c203bd54aeaf237$var$React.useCallback((colIndex, event)=>{
        logger.debug(`Navigating to header col ${colIndex}`);
        apiRef.current.scrollToIndexes({
            colIndex: colIndex
        });
        const field = apiRef.current.getVisibleColumns()[colIndex].field;
        apiRef.current.setColumnHeaderFocus(field, event);
    }, [
        apiRef,
        logger
    ]);
    const goToHeaderFilter = $0c203bd54aeaf237$var$React.useCallback((colIndex, event)=>{
        logger.debug(`Navigating to header filter col ${colIndex}`);
        apiRef.current.scrollToIndexes({
            colIndex: colIndex
        });
        const field = apiRef.current.getVisibleColumns()[colIndex].field;
        apiRef.current.setColumnHeaderFilterFocus(field, event);
    }, [
        apiRef,
        logger
    ]);
    const goToGroupHeader = $0c203bd54aeaf237$var$React.useCallback((colIndex, depth, event)=>{
        logger.debug(`Navigating to header col ${colIndex}`);
        apiRef.current.scrollToIndexes({
            colIndex: colIndex
        });
        const { field: field } = apiRef.current.getVisibleColumns()[colIndex];
        apiRef.current.setColumnGroupHeaderFocus(field, depth, event);
    }, [
        apiRef,
        logger
    ]);
    const getRowIdFromIndex = $0c203bd54aeaf237$var$React.useCallback((rowIndex)=>{
        return getCurrentPageRows()[rowIndex]?.id;
    }, [
        getCurrentPageRows
    ]);
    const handleColumnHeaderKeyDown = $0c203bd54aeaf237$var$React.useCallback((params, event)=>{
        const headerTitleNode = event.currentTarget.querySelector(`.${$5H1vo.gridClasses.columnHeaderTitleContainerContent}`);
        const isFromInsideContent = !!headerTitleNode && headerTitleNode.contains(event.target);
        if (isFromInsideContent && params.field !== $3c6ea315aeb792f9$exports.GRID_CHECKBOX_SELECTION_COL_DEF.field) // When focus is on a nested input, keyboard events have no effect to avoid conflicts with native events.
        // There is one exception for the checkBoxHeader
        return;
        if (!(0, $a08faead7d1bb429$exports.isNavigationKey)(event.key) && event.key !== 'Tab') return;
        // Tab key is only allowed if tabbing is enabled for header/all, or if we are tabbing to the content area while `tabNavigation` is enabled for content only
        if (event.key === 'Tab' && (props.tabNavigation === 'none' || props.tabNavigation === 'content' && event.shiftKey)) return;
        const currentPageRows = getCurrentPageRows();
        const viewportPageSize = apiRef.current.getViewportPageSize();
        const colIndexBefore = params.field ? apiRef.current.getColumnIndex(params.field) : 0;
        const firstRowIndexInPage = currentPageRows.length > 0 ? 0 : null;
        const lastRowIndexInPage = currentPageRows.length > 0 ? currentPageRows.length - 1 : null;
        const firstColIndex = 0;
        const lastColIndex = Math.max(0, (0, $e732684465924d20$exports.gridVisibleColumnDefinitionsSelector)(apiRef).length - 1);
        const columnGroupMaxDepth = (0, $cf21d895912d975b$exports.gridColumnGroupsHeaderMaxDepthSelector)(apiRef);
        let shouldPreventDefault = true;
        // If we are tabbing inside the header area while only content `tabNavigation` is enabled, go to the first cell
        if (event.key === 'Tab' && props.tabNavigation === 'content' && !event.shiftKey) {
            if (firstRowIndexInPage !== null) {
                goToCell(firstColIndex, getRowIdFromIndex(firstRowIndexInPage));
                event.preventDefault();
            }
            return;
        }
        switch(event.key){
            case 'ArrowDown':
                if (headerFilteringEnabled) goToHeaderFilter(colIndexBefore, event);
                else if (firstRowIndexInPage !== null) goToCell(colIndexBefore, getRowIdFromIndex(firstRowIndexInPage));
                break;
            case 'ArrowRight':
                {
                    const rightColIndex = (0, $24be03c588f8c679$exports.getRightColumnIndex)({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        isRtl: isRtl
                    });
                    if (rightColIndex !== null) goToHeader(rightColIndex, event);
                    break;
                }
            case 'ArrowLeft':
                {
                    const leftColIndex = (0, $24be03c588f8c679$exports.getLeftColumnIndex)({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        isRtl: isRtl
                    });
                    if (leftColIndex !== null) goToHeader(leftColIndex, event);
                    break;
                }
            case 'ArrowUp':
                if (columnGroupMaxDepth > 0) goToGroupHeader(colIndexBefore, columnGroupMaxDepth - 1, event);
                break;
            case 'PageDown':
                if (firstRowIndexInPage !== null && lastRowIndexInPage !== null) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(firstRowIndexInPage + viewportPageSize, lastRowIndexInPage)));
                break;
            case 'Home':
                goToHeader(firstColIndex, event);
                break;
            case 'End':
                goToHeader(lastColIndex, event);
                break;
            case 'Enter':
                if (event.ctrlKey || event.metaKey) apiRef.current.toggleColumnMenu(params.field);
                break;
            case 'Tab':
                if (event.shiftKey) {
                    // if the key is pressed on the first column header, Shift+Tab should go to the group header if it is there or allow default behavior
                    if (colIndexBefore === firstColIndex) {
                        if (columnGroupMaxDepth > 0) goToGroupHeader(lastColIndex, columnGroupMaxDepth - 1, event);
                        else shouldPreventDefault = false;
                    } else goToHeader(colIndexBefore - 1, event);
                } else if (colIndexBefore === lastColIndex) {
                    // the key is pressed at the last column header. go to the first header filter or the first cell
                    if (headerFilteringEnabled) goToHeaderFilter(firstColIndex, event);
                    else if (props.tabNavigation === 'all' && firstRowIndexInPage !== null) goToCell(firstColIndex, getRowIdFromIndex(firstRowIndexInPage));
                    else shouldPreventDefault = false;
                } else goToHeader(colIndexBefore + 1, event);
                break;
            case ' ':
                break;
            default:
                shouldPreventDefault = false;
        }
        if (shouldPreventDefault) event.preventDefault();
    }, [
        apiRef,
        props.tabNavigation,
        getCurrentPageRows,
        headerFilteringEnabled,
        goToHeaderFilter,
        goToCell,
        getRowIdFromIndex,
        isRtl,
        goToHeader,
        goToGroupHeader
    ]);
    const handleHeaderFilterKeyDown = $0c203bd54aeaf237$var$React.useCallback((params, event)=>{
        const isEditing = (0, $48c71b00043b47b4$exports.gridHeaderFilteringEditFieldSelector)(apiRef) === params.field;
        const isHeaderMenuOpen = (0, $48c71b00043b47b4$exports.gridHeaderFilteringMenuSelector)(apiRef) === params.field;
        if (isHeaderMenuOpen || isEditing && event.key !== 'Tab') return;
        if (!(0, $a08faead7d1bb429$exports.isNavigationKey)(event.key) && event.key !== 'Tab') return;
        // Tab key is only allowed if tabbing is enabled for header/all, or if we are tabbing to the content area while `tabNavigation` is enabled for content only
        if (event.key === 'Tab' && (props.tabNavigation === 'none' || props.tabNavigation === 'content' && event.shiftKey)) return;
        const currentPageRows = getCurrentPageRows();
        const viewportPageSize = apiRef.current.getViewportPageSize();
        const colIndexBefore = params.field ? apiRef.current.getColumnIndex(params.field) : 0;
        const firstRowIndexInPage = currentPageRows.length > 0 ? 0 : null;
        const lastRowIndexInPage = currentPageRows.length > 0 ? currentPageRows.length - 1 : null;
        const firstColIndex = 0;
        const lastColIndex = Math.max(0, (0, $e732684465924d20$exports.gridVisibleColumnDefinitionsSelector)(apiRef).length - 1);
        let shouldPreventDefault = true;
        // If we are tabbing inside the header area while only content `tabNavigation` is enabled, go to the first cell
        if (event.key === 'Tab' && props.tabNavigation === 'content' && !event.shiftKey) {
            if (firstRowIndexInPage !== null) {
                goToCell(firstColIndex, getRowIdFromIndex(firstRowIndexInPage));
                event.preventDefault();
            }
            return;
        }
        switch(event.key){
            case 'ArrowDown':
                if (firstRowIndexInPage !== null) goToCell(colIndexBefore, getRowIdFromIndex(firstRowIndexInPage));
                break;
            case 'ArrowRight':
                {
                    const rightColIndex = (0, $24be03c588f8c679$exports.getRightColumnIndex)({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        isRtl: isRtl
                    });
                    if (rightColIndex !== null) goToHeaderFilter(rightColIndex, event);
                    break;
                }
            case 'ArrowLeft':
                {
                    const leftColIndex = (0, $24be03c588f8c679$exports.getLeftColumnIndex)({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        isRtl: isRtl
                    });
                    if (leftColIndex !== null) goToHeaderFilter(leftColIndex, event);
                    else apiRef.current.setColumnHeaderFilterFocus(params.field, event);
                    break;
                }
            case 'ArrowUp':
                goToHeader(colIndexBefore, event);
                break;
            case 'PageDown':
                if (firstRowIndexInPage !== null && lastRowIndexInPage !== null) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(firstRowIndexInPage + viewportPageSize, lastRowIndexInPage)));
                break;
            case 'Home':
                goToHeaderFilter(firstColIndex, event);
                break;
            case 'End':
                goToHeaderFilter(lastColIndex, event);
                break;
            case 'Tab':
                if (event.shiftKey) {
                    // if the key is pressed on the first header filter, Shift+Tab should go to the column header
                    if (colIndexBefore === firstColIndex) goToHeader(lastColIndex, event);
                    else goToHeaderFilter(colIndexBefore - 1, event);
                } else if (colIndexBefore === lastColIndex) {
                    // the key is pressed at the last header filter.
                    // this point can be reached if `tabNavigation` is enabled for all content or just header.
                    // if it is not enabled for all content or there is no data, then do not focus on the first cell
                    if (props.tabNavigation === 'all' && firstRowIndexInPage !== null) goToCell(firstColIndex, getRowIdFromIndex(firstRowIndexInPage));
                    else shouldPreventDefault = false;
                } else goToHeaderFilter(colIndexBefore + 1, event);
                break;
            case ' ':
                break;
            default:
                shouldPreventDefault = false;
        }
        if (shouldPreventDefault) event.preventDefault();
    }, [
        apiRef,
        props.tabNavigation,
        getCurrentPageRows,
        goToHeaderFilter,
        isRtl,
        goToHeader,
        goToCell,
        getRowIdFromIndex
    ]);
    const handleColumnGroupHeaderKeyDown = $0c203bd54aeaf237$var$React.useCallback((params, event)=>{
        const focusedColumnGroup = (0, $b6fed9c583d617da$exports.gridFocusColumnGroupHeaderSelector)(apiRef);
        if (focusedColumnGroup === null) return;
        const { field: currentField, depth: currentDepth } = focusedColumnGroup;
        const { fields: fields, depth: depth, maxDepth: maxDepth } = params;
        if (!(0, $a08faead7d1bb429$exports.isNavigationKey)(event.key) && event.key !== 'Tab') return;
        // Tab key is only allowed if tabbing is enabled for header/all, or if we are tabbing to the content area while `tabNavigation` is enabled for content only
        if (event.key === 'Tab' && (props.tabNavigation === 'none' || props.tabNavigation === 'content' && event.shiftKey)) return;
        const currentPageRows = getCurrentPageRows();
        const viewportPageSize = apiRef.current.getViewportPageSize();
        const currentColIndex = apiRef.current.getColumnIndex(currentField);
        const colIndexBefore = currentField ? apiRef.current.getColumnIndex(currentField) : 0;
        const firstRowIndexInPage = currentPageRows.length > 0 ? 0 : null;
        const lastRowIndexInPage = currentPageRows.length > 0 ? currentPageRows.length - 1 : null;
        const firstColIndex = 0;
        const lastColIndex = Math.max(0, (0, $e732684465924d20$exports.gridVisibleColumnDefinitionsSelector)(apiRef).length - 1);
        let shouldPreventDefault = true;
        // If we are tabbing inside the header area while only content `tabNavigation` is enabled, go to the first cell
        if (event.key === 'Tab' && props.tabNavigation === 'content' && !event.shiftKey) {
            if (firstRowIndexInPage !== null) {
                goToCell(firstColIndex, getRowIdFromIndex(firstRowIndexInPage));
                event.preventDefault();
            }
            return;
        }
        switch(event.key){
            case 'ArrowDown':
                if (depth === maxDepth - 1) goToHeader(currentColIndex, event);
                else goToGroupHeader(currentColIndex, currentDepth + 1, event);
                break;
            case 'ArrowUp':
                if (depth > 0) goToGroupHeader(currentColIndex, currentDepth - 1, event);
                break;
            case 'ArrowRight':
                {
                    const remainingRightColumns = fields.length - fields.indexOf(currentField) - 1;
                    if (currentColIndex + remainingRightColumns + 1 <= lastColIndex) goToGroupHeader(currentColIndex + remainingRightColumns + 1, currentDepth, event);
                    break;
                }
            case 'ArrowLeft':
                {
                    const remainingLeftColumns = fields.indexOf(currentField);
                    if (currentColIndex - remainingLeftColumns - 1 >= firstColIndex) goToGroupHeader(currentColIndex - remainingLeftColumns - 1, currentDepth, event);
                    break;
                }
            case 'PageDown':
                if (firstRowIndexInPage !== null && lastRowIndexInPage !== null) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(firstRowIndexInPage + viewportPageSize, lastRowIndexInPage)));
                break;
            case 'Home':
                goToGroupHeader(firstColIndex, currentDepth, event);
                break;
            case 'End':
                goToGroupHeader(lastColIndex, currentDepth, event);
                break;
            case 'Tab':
                if (event.shiftKey) {
                    const remainingLeftColumns = fields.indexOf(currentField);
                    const targetColIndex = currentColIndex - remainingLeftColumns - 1;
                    if (targetColIndex < firstColIndex) {
                        if (depth === 0) // if the key is pressed on the first column group header at the top level, Shift+Tab should allow default behavior
                        shouldPreventDefault = false;
                        else // Navigate to last column group header at the previous depth
                        goToGroupHeader(lastColIndex, currentDepth - 1, event);
                    } else goToGroupHeader(targetColIndex, currentDepth, event);
                } else {
                    const remainingRightColumns = fields.length - fields.indexOf(currentField) - 1;
                    const targetColIndex = currentColIndex + remainingRightColumns + 1;
                    if (targetColIndex > lastColIndex && depth === maxDepth - 1) // the key is pressed at the last column group header at the deepest level. go to the first column header
                    goToHeader(firstColIndex, event);
                    else if (targetColIndex > lastColIndex) // go down a depth level
                    goToGroupHeader(firstColIndex, currentDepth + 1, event);
                    else goToGroupHeader(targetColIndex, currentDepth, event);
                }
                break;
            case ' ':
                break;
            default:
                shouldPreventDefault = false;
        }
        if (shouldPreventDefault) event.preventDefault();
    }, [
        apiRef,
        props.tabNavigation,
        getCurrentPageRows,
        goToHeader,
        goToGroupHeader,
        goToCell,
        getRowIdFromIndex
    ]);
    const handleCellKeyDown = $0c203bd54aeaf237$var$React.useCallback((params, event)=>{
        // Ignore portal
        if ((0, $08bb4bf24f47b880$exports.isEventTargetInPortal)(event)) return;
        // Get the most recent params because the cell mode may have changed by another listener
        const cellParams = apiRef.current.getCellParams(params.id, params.field);
        if (cellParams.cellMode === $e139707caeafbfd6$exports.GridCellModes.Edit || !(0, $a08faead7d1bb429$exports.isNavigationKey)(event.key) && event.key !== 'Tab') return;
        // Tab key is only allowed if tabbing is enabled or if we are tabbing to the header area while `tabNavigation` is enabled for header only (with Shift+Tab)
        if (event.key === 'Tab' && (props.tabNavigation === 'none' || props.tabNavigation === 'header' && !event.shiftKey)) return;
        const canUpdateFocus = apiRef.current.unstable_applyPipeProcessors('canUpdateFocus', true, {
            event: event,
            cell: cellParams
        });
        if (!canUpdateFocus) return;
        const currentPageRows = getCurrentPageRows();
        if (currentPageRows.length === 0) return;
        const previousAreaNavigationFn = headerFilteringEnabled ? goToHeaderFilter : goToHeader;
        const viewportPageSize = apiRef.current.getViewportPageSize();
        const colIndexBefore = params.field ? apiRef.current.getColumnIndex(params.field) : 0;
        const rowIndexBefore = currentPageRows.findIndex((row)=>row.id === params.id);
        const firstRowIndexInPage = 0;
        const lastRowIndexInPage = currentPageRows.length - 1;
        const firstColIndex = 0;
        const lastColIndex = Math.max(0, (0, $e732684465924d20$exports.gridVisibleColumnDefinitionsSelector)(apiRef).length - 1);
        let shouldPreventDefault = true;
        // If we are tabbing inside the content area while only header `tabNavigation` is enabled, go to the last header filter or column header
        if (event.key === 'Tab' && props.tabNavigation === 'header' && event.shiftKey) {
            previousAreaNavigationFn(lastColIndex, event);
            event.preventDefault();
            return;
        }
        switch(event.key){
            case 'ArrowDown':
                // "Enter" is only triggered by the row / cell editing feature
                if (rowIndexBefore < lastRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(rowIndexBefore + 1), isRtl ? 'right' : 'left', 'down');
                break;
            case 'ArrowUp':
                if (rowIndexBefore > firstRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(rowIndexBefore - 1));
                else previousAreaNavigationFn(colIndexBefore, event);
                break;
            case 'ArrowRight':
                {
                    const rightColIndex = (0, $24be03c588f8c679$exports.getRightColumnIndex)({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        isRtl: isRtl
                    });
                    if (rightColIndex !== null) goToCell(rightColIndex, getRowIdFromIndex(rowIndexBefore), isRtl ? 'left' : 'right');
                    break;
                }
            case 'ArrowLeft':
                {
                    const leftColIndex = (0, $24be03c588f8c679$exports.getLeftColumnIndex)({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        isRtl: isRtl
                    });
                    if (leftColIndex !== null) goToCell(leftColIndex, getRowIdFromIndex(rowIndexBefore), isRtl ? 'right' : 'left');
                    break;
                }
            case 'Tab':
                if (event.shiftKey) {
                    // if the key is pressed on the first cell, Shift+Tab should go to the last column header
                    // same is if `tabNavigation` is enabled for header only
                    if (colIndexBefore === firstColIndex && rowIndexBefore === firstRowIndexInPage) {
                        if (props.tabNavigation === 'all') previousAreaNavigationFn(lastColIndex, event);
                        else shouldPreventDefault = false;
                    } else if (colIndexBefore === firstColIndex) goToCell(lastColIndex, getRowIdFromIndex(rowIndexBefore - 1));
                    else goToCell(colIndexBefore - 1, getRowIdFromIndex(rowIndexBefore), 'left');
                } else if (colIndexBefore === lastColIndex) {
                    // the key is pressed at the last column. if it is also the last row, do not to anything to allow the default behavior
                    // otherwise, go to the first column of the next row
                    if (rowIndexBefore !== lastRowIndexInPage) goToCell(firstColIndex, getRowIdFromIndex(rowIndexBefore + 1));
                    else shouldPreventDefault = false;
                } else goToCell(colIndexBefore + 1, getRowIdFromIndex(rowIndexBefore), 'right');
                break;
            case ' ':
                {
                    const field = params.field;
                    if (field === $e8d35a7c12bdaa1d$exports.GRID_DETAIL_PANEL_TOGGLE_FIELD) break;
                    const colDef = params.colDef;
                    if (colDef && (colDef.field === $e8d35a7c12bdaa1d$exports.GRID_TREE_DATA_GROUPING_FIELD || (0, $c46389eb8540b1dc$exports.isGroupingColumn)(colDef.field))) break;
                    if (!event.shiftKey && rowIndexBefore < lastRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(rowIndexBefore + viewportPageSize, lastRowIndexInPage)));
                    break;
                }
            case 'PageDown':
                if (rowIndexBefore < lastRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(rowIndexBefore + viewportPageSize, lastRowIndexInPage)));
                break;
            case 'PageUp':
                {
                    // Go to the first row before going to header
                    const nextRowIndex = Math.max(rowIndexBefore - viewportPageSize, firstRowIndexInPage);
                    if (nextRowIndex !== rowIndexBefore && nextRowIndex >= firstRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(nextRowIndex));
                    else goToHeader(colIndexBefore, event);
                    break;
                }
            case 'Home':
                if (event.ctrlKey || event.metaKey || event.shiftKey) goToCell(firstColIndex, getRowIdFromIndex(firstRowIndexInPage));
                else goToCell(firstColIndex, getRowIdFromIndex(rowIndexBefore));
                break;
            case 'End':
                if (event.ctrlKey || event.metaKey || event.shiftKey) goToCell(lastColIndex, getRowIdFromIndex(lastRowIndexInPage));
                else goToCell(lastColIndex, getRowIdFromIndex(rowIndexBefore));
                break;
            default:
                shouldPreventDefault = false;
        }
        if (shouldPreventDefault) event.preventDefault();
    }, [
        apiRef,
        props.tabNavigation,
        getCurrentPageRows,
        isRtl,
        goToCell,
        getRowIdFromIndex,
        headerFilteringEnabled,
        goToHeaderFilter,
        goToHeader
    ]);
    const checkIfCanStartEditing = $0c203bd54aeaf237$var$React.useCallback((initialValue, { event: event })=>{
        if (event.key === ' ') // Space scrolls to the last row
        return false;
        return initialValue;
    }, []);
    (0, $1aa692cb9e262bac$exports.useGridRegisterPipeProcessor)(apiRef, 'canStartEditing', checkIfCanStartEditing);
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'columnHeaderKeyDown', handleColumnHeaderKeyDown);
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'headerFilterKeyDown', handleHeaderFilterKeyDown);
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'columnGroupHeaderKeyDown', handleColumnGroupHeaderKeyDown);
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'cellKeyDown', handleCellKeyDown);
};
$0c203bd54aeaf237$exports.useGridKeyboardNavigation = $0c203bd54aeaf237$var$useGridKeyboardNavigation;


var $2714c9ed9cdf2996$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $2714c9ed9cdf2996$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($2714c9ed9cdf2996$exports, "__esModule", {
    value: true
});
$2714c9ed9cdf2996$exports.useGridPagination = $2714c9ed9cdf2996$exports.paginationStateInitializer = void 0;

var $2714c9ed9cdf2996$var$_extends2 = $2714c9ed9cdf2996$require$_interopRequireDefault((parcelRequire("3p9rK")));


var $d0d393dcade2390b$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $d0d393dcade2390b$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $d0d393dcade2390b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($d0d393dcade2390b$exports, "__esModule", {
    value: true
});
$d0d393dcade2390b$exports.useGridRowCount = void 0;

var $d0d393dcade2390b$var$_extends2 = $d0d393dcade2390b$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $d0d393dcade2390b$var$React = $d0d393dcade2390b$require$_interopRequireWildcard((parcelRequire("acw62")));

var $d0d393dcade2390b$var$_useLazyRef = $d0d393dcade2390b$require$_interopRequireDefault((parcelRequire("doV3C")));





const $d0d393dcade2390b$var$useGridRowCount = (apiRef, props)=>{
    const logger = (0, $431c82ec73ef367c$exports.useGridLogger)(apiRef, 'useGridRowCount');
    const previousPageSize = (0, $d0d393dcade2390b$var$_useLazyRef.default)(()=>(0, $c41ec74257ca380c$exports.gridPaginationModelSelector)(apiRef).pageSize);
    apiRef.current.registerControlState({
        stateId: 'paginationRowCount',
        propModel: props.rowCount,
        propOnChange: props.onRowCountChange,
        stateSelector: $c41ec74257ca380c$exports.gridPaginationRowCountSelector,
        changeEvent: 'rowCountChange'
    });
    /**
   * API METHODS
   */ const setRowCount = $d0d393dcade2390b$var$React.useCallback((newRowCount)=>{
        const rowCountState = (0, $c41ec74257ca380c$exports.gridPaginationRowCountSelector)(apiRef);
        if (rowCountState === newRowCount) return;
        logger.debug("Setting 'rowCount' to", newRowCount);
        apiRef.current.setState((state)=>(0, $d0d393dcade2390b$var$_extends2.default)({}, state, {
                pagination: (0, $d0d393dcade2390b$var$_extends2.default)({}, state.pagination, {
                    rowCount: newRowCount
                })
            }));
    }, [
        apiRef,
        logger
    ]);
    const paginationRowCountApi = {
        setRowCount: setRowCount
    };
    (0, $431c82ec73ef367c$exports.useGridApiMethod)(apiRef, paginationRowCountApi, 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $d0d393dcade2390b$var$React.useCallback((prevState, context)=>{
        const exportedRowCount = (0, $c41ec74257ca380c$exports.gridPaginationRowCountSelector)(apiRef);
        const shouldExportRowCount = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the `rowCount` is controlled
        props.rowCount != null || // Always export if the `rowCount` has been initialized
        props.initialState?.pagination?.rowCount != null;
        if (!shouldExportRowCount) return prevState;
        return (0, $d0d393dcade2390b$var$_extends2.default)({}, prevState, {
            pagination: (0, $d0d393dcade2390b$var$_extends2.default)({}, prevState.pagination, {
                rowCount: exportedRowCount
            })
        });
    }, [
        apiRef,
        props.rowCount,
        props.initialState?.pagination?.rowCount
    ]);
    const stateRestorePreProcessing = $d0d393dcade2390b$var$React.useCallback((params, context)=>{
        const restoredRowCount = context.stateToRestore.pagination?.rowCount ? context.stateToRestore.pagination.rowCount : (0, $c41ec74257ca380c$exports.gridPaginationRowCountSelector)(apiRef);
        apiRef.current.setState((state)=>(0, $d0d393dcade2390b$var$_extends2.default)({}, state, {
                pagination: (0, $d0d393dcade2390b$var$_extends2.default)({}, state.pagination, {
                    rowCount: restoredRowCount
                })
            }));
        return params;
    }, [
        apiRef
    ]);
    (0, $1aa692cb9e262bac$exports.useGridRegisterPipeProcessor)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $1aa692cb9e262bac$exports.useGridRegisterPipeProcessor)(apiRef, 'restoreState', stateRestorePreProcessing);
    /**
   * EVENTS
   */ const handlePaginationModelChange = $d0d393dcade2390b$var$React.useCallback((model)=>{
        if (props.paginationMode === 'client' || !previousPageSize.current) return;
        if (model.pageSize !== previousPageSize.current) {
            previousPageSize.current = model.pageSize;
            const rowCountState = (0, $c41ec74257ca380c$exports.gridPaginationRowCountSelector)(apiRef);
            if (rowCountState === -1) // Row count unknown and page size changed, reset the page
            apiRef.current.setPage(0);
        }
    }, [
        props.paginationMode,
        previousPageSize,
        apiRef
    ]);
    (0, $431c82ec73ef367c$exports.useGridEvent)(apiRef, 'paginationModelChange', handlePaginationModelChange);
    /**
   * EFFECTS
   */ $d0d393dcade2390b$var$React.useEffect(()=>{
        if (props.paginationMode === 'server' && props.rowCount != null) apiRef.current.setRowCount(props.rowCount);
    }, [
        apiRef,
        props.paginationMode,
        props.rowCount
    ]);
    (0, $66c3b1bd8ca83ba8$exports.useStoreEffect)(// typings not supported currently, but methods work
    apiRef.current.store, ()=>{
        const isLastPage = (0, $c41ec74257ca380c$exports.gridPaginationMetaSelector)(apiRef).hasNextPage === false;
        if (isLastPage) return true;
        if (props.paginationMode === 'client') return (0, $0c64e77f4c442b27$exports.gridFilteredTopLevelRowCountSelector)(apiRef);
        return undefined;
    }, (_, isLastPageOrRowCount)=>{
        if (isLastPageOrRowCount === true && (0, $c41ec74257ca380c$exports.gridPaginationRowCountSelector)(apiRef) !== -1) {
            const visibleTopLevelRowCount = (0, $0c64e77f4c442b27$exports.gridFilteredTopLevelRowCountSelector)(apiRef);
            const paginationModel = (0, $c41ec74257ca380c$exports.gridPaginationModelSelector)(apiRef);
            apiRef.current.setRowCount(paginationModel.pageSize * paginationModel.page + visibleTopLevelRowCount);
        } else if (typeof isLastPageOrRowCount === 'number') apiRef.current.setRowCount(isLastPageOrRowCount);
    });
    $d0d393dcade2390b$var$React.useEffect(()=>{
        if (props.paginationMode === 'client') apiRef.current.setRowCount((0, $0c64e77f4c442b27$exports.gridFilteredTopLevelRowCountSelector)(apiRef));
    }, [
        apiRef,
        props.paginationMode
    ]);
};
$d0d393dcade2390b$exports.useGridRowCount = $d0d393dcade2390b$var$useGridRowCount;


var $d05a3dc983bf505e$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $d05a3dc983bf505e$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $d05a3dc983bf505e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($d05a3dc983bf505e$exports, "__esModule", {
    value: true
});
$d05a3dc983bf505e$exports.useGridPaginationMeta = void 0;

var $d05a3dc983bf505e$var$_extends2 = $d05a3dc983bf505e$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $d05a3dc983bf505e$var$React = $d05a3dc983bf505e$require$_interopRequireWildcard((parcelRequire("acw62")));



const $d05a3dc983bf505e$var$useGridPaginationMeta = (apiRef, props)=>{
    const logger = (0, $431c82ec73ef367c$exports.useGridLogger)(apiRef, 'useGridPaginationMeta');
    apiRef.current.registerControlState({
        stateId: 'paginationMeta',
        propModel: props.paginationMeta,
        propOnChange: props.onPaginationMetaChange,
        stateSelector: $c41ec74257ca380c$exports.gridPaginationMetaSelector,
        changeEvent: 'paginationMetaChange'
    });
    /**
   * API METHODS
   */ const setPaginationMeta = $d05a3dc983bf505e$var$React.useCallback((newPaginationMeta)=>{
        const paginationMeta = (0, $c41ec74257ca380c$exports.gridPaginationMetaSelector)(apiRef);
        if (paginationMeta === newPaginationMeta) return;
        logger.debug("Setting 'paginationMeta' to", newPaginationMeta);
        apiRef.current.setState((state)=>(0, $d05a3dc983bf505e$var$_extends2.default)({}, state, {
                pagination: (0, $d05a3dc983bf505e$var$_extends2.default)({}, state.pagination, {
                    meta: newPaginationMeta
                })
            }));
    }, [
        apiRef,
        logger
    ]);
    const paginationMetaApi = {
        setPaginationMeta: setPaginationMeta
    };
    (0, $431c82ec73ef367c$exports.useGridApiMethod)(apiRef, paginationMetaApi, 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $d05a3dc983bf505e$var$React.useCallback((prevState, context)=>{
        const exportedPaginationMeta = (0, $c41ec74257ca380c$exports.gridPaginationMetaSelector)(apiRef);
        const shouldExportRowCount = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the `paginationMeta` is controlled
        props.paginationMeta != null || // Always export if the `paginationMeta` has been initialized
        props.initialState?.pagination?.meta != null;
        if (!shouldExportRowCount) return prevState;
        return (0, $d05a3dc983bf505e$var$_extends2.default)({}, prevState, {
            pagination: (0, $d05a3dc983bf505e$var$_extends2.default)({}, prevState.pagination, {
                meta: exportedPaginationMeta
            })
        });
    }, [
        apiRef,
        props.paginationMeta,
        props.initialState?.pagination?.meta
    ]);
    const stateRestorePreProcessing = $d05a3dc983bf505e$var$React.useCallback((params, context)=>{
        const restoredPaginationMeta = context.stateToRestore.pagination?.meta ? context.stateToRestore.pagination.meta : (0, $c41ec74257ca380c$exports.gridPaginationMetaSelector)(apiRef);
        apiRef.current.setState((state)=>(0, $d05a3dc983bf505e$var$_extends2.default)({}, state, {
                pagination: (0, $d05a3dc983bf505e$var$_extends2.default)({}, state.pagination, {
                    meta: restoredPaginationMeta
                })
            }));
        return params;
    }, [
        apiRef
    ]);
    (0, $1aa692cb9e262bac$exports.useGridRegisterPipeProcessor)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $1aa692cb9e262bac$exports.useGridRegisterPipeProcessor)(apiRef, 'restoreState', stateRestorePreProcessing);
    /**
   * EFFECTS
   */ $d05a3dc983bf505e$var$React.useEffect(()=>{
        if (props.paginationMeta) apiRef.current.setPaginationMeta(props.paginationMeta);
    }, [
        apiRef,
        props.paginationMeta
    ]);
};
$d05a3dc983bf505e$exports.useGridPaginationMeta = $d05a3dc983bf505e$var$useGridPaginationMeta;


const $2714c9ed9cdf2996$var$paginationStateInitializer = (state, props)=>{
    const paginationModel = (0, $2714c9ed9cdf2996$var$_extends2.default)({}, (0, $820f672e99dc58bd$exports.getDefaultGridPaginationModel)(props.autoPageSize), props.paginationModel ?? props.initialState?.pagination?.paginationModel);
    (0, $820f672e99dc58bd$exports.throwIfPageSizeExceedsTheLimit)(paginationModel.pageSize, props.signature);
    const rowCount = props.rowCount ?? props.initialState?.pagination?.rowCount ?? (props.paginationMode === 'client' ? state.rows?.totalRowCount : undefined);
    const meta = props.paginationMeta ?? props.initialState?.pagination?.meta ?? {};
    return (0, $2714c9ed9cdf2996$var$_extends2.default)({}, state, {
        pagination: (0, $2714c9ed9cdf2996$var$_extends2.default)({}, state.pagination, {
            paginationModel: paginationModel,
            rowCount: rowCount,
            meta: meta,
            enabled: props.pagination === true,
            paginationMode: props.paginationMode
        })
    });
};
/**
 * @requires useGridFilter (state)
 * @requires useGridDimensions (event) - can be after
 */ $2714c9ed9cdf2996$exports.paginationStateInitializer = $2714c9ed9cdf2996$var$paginationStateInitializer;
const $2714c9ed9cdf2996$var$useGridPagination = (apiRef, props)=>{
    (0, $d05a3dc983bf505e$exports.useGridPaginationMeta)(apiRef, props);
    (0, $5e8e37726d5ba261$exports.useGridPaginationModel)(apiRef, props);
    (0, $d0d393dcade2390b$exports.useGridRowCount)(apiRef, props);
};
$2714c9ed9cdf2996$exports.useGridPagination = $2714c9ed9cdf2996$var$useGridPagination;


var $314c3f5b8282a42e$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $314c3f5b8282a42e$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $314c3f5b8282a42e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($314c3f5b8282a42e$exports, "__esModule", {
    value: true
});
$314c3f5b8282a42e$exports.useGridPreferencesPanel = $314c3f5b8282a42e$exports.preferencePanelStateInitializer = void 0;

var $314c3f5b8282a42e$var$_extends2 = $314c3f5b8282a42e$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $314c3f5b8282a42e$var$React = $314c3f5b8282a42e$require$_interopRequireWildcard((parcelRequire("acw62")));




const $314c3f5b8282a42e$var$preferencePanelStateInitializer = (state, props)=>(0, $314c3f5b8282a42e$var$_extends2.default)({}, state, {
        preferencePanel: props.initialState?.preferencePanel ?? {
            open: false
        }
    });
/**
 * TODO: Add a single `setPreferencePanel` method to avoid multiple `setState`
 */ $314c3f5b8282a42e$exports.preferencePanelStateInitializer = $314c3f5b8282a42e$var$preferencePanelStateInitializer;
const $314c3f5b8282a42e$var$useGridPreferencesPanel = (apiRef, props)=>{
    const logger = (0, $fa53bf7350a63511$exports.useGridLogger)(apiRef, 'useGridPreferencesPanel');
    /**
   * API METHODS
   */ const hidePreferences = $314c3f5b8282a42e$var$React.useCallback(()=>{
        apiRef.current.setState((state)=>{
            if (!state.preferencePanel.open) return state;
            logger.debug('Hiding Preferences Panel');
            const preferencePanelState = (0, $50fa8e974bf84473$exports.gridPreferencePanelStateSelector)(apiRef);
            apiRef.current.publishEvent('preferencePanelClose', {
                openedPanelValue: preferencePanelState.openedPanelValue
            });
            return (0, $314c3f5b8282a42e$var$_extends2.default)({}, state, {
                preferencePanel: {
                    open: false
                }
            });
        });
    }, [
        apiRef,
        logger
    ]);
    const showPreferences = $314c3f5b8282a42e$var$React.useCallback((newValue, panelId, labelId)=>{
        logger.debug('Opening Preferences Panel');
        apiRef.current.setState((state)=>(0, $314c3f5b8282a42e$var$_extends2.default)({}, state, {
                preferencePanel: (0, $314c3f5b8282a42e$var$_extends2.default)({}, state.preferencePanel, {
                    open: true,
                    openedPanelValue: newValue,
                    panelId: panelId,
                    labelId: labelId
                })
            }));
        apiRef.current.publishEvent('preferencePanelOpen', {
            openedPanelValue: newValue
        });
    }, [
        logger,
        apiRef
    ]);
    (0, $d79b1aa4f5237e85$exports.useGridApiMethod)(apiRef, {
        showPreferences: showPreferences,
        hidePreferences: hidePreferences
    }, 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $314c3f5b8282a42e$var$React.useCallback((prevState, context)=>{
        const preferencePanelToExport = (0, $50fa8e974bf84473$exports.gridPreferencePanelStateSelector)(apiRef);
        const shouldExportPreferencePanel = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the panel was initialized
        props.initialState?.preferencePanel != null || // Always export if the panel is opened
        preferencePanelToExport.open;
        if (!shouldExportPreferencePanel) return prevState;
        return (0, $314c3f5b8282a42e$var$_extends2.default)({}, prevState, {
            preferencePanel: preferencePanelToExport
        });
    }, [
        apiRef,
        props.initialState?.preferencePanel
    ]);
    const stateRestorePreProcessing = $314c3f5b8282a42e$var$React.useCallback((params, context)=>{
        const preferencePanel = context.stateToRestore.preferencePanel;
        if (preferencePanel != null) apiRef.current.setState((state)=>(0, $314c3f5b8282a42e$var$_extends2.default)({}, state, {
                preferencePanel: preferencePanel
            }));
        return params;
    }, [
        apiRef
    ]);
    (0, $1aa692cb9e262bac$exports.useGridRegisterPipeProcessor)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $1aa692cb9e262bac$exports.useGridRegisterPipeProcessor)(apiRef, 'restoreState', stateRestorePreProcessing);
};
$314c3f5b8282a42e$exports.useGridPreferencesPanel = $314c3f5b8282a42e$var$useGridPreferencesPanel;


var $b93545fe9a3b3245$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $b93545fe9a3b3245$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $b93545fe9a3b3245$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($b93545fe9a3b3245$exports, "__esModule", {
    value: true
});
$b93545fe9a3b3245$exports.useGridEditing = $b93545fe9a3b3245$exports.editingStateInitializer = void 0;

var $b93545fe9a3b3245$var$_extends2 = $b93545fe9a3b3245$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $b93545fe9a3b3245$var$React = $b93545fe9a3b3245$require$_interopRequireWildcard((parcelRequire("acw62")));

var $28b053c97cee4bd6$exports = {};
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $28b053c97cee4bd6$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $28b053c97cee4bd6$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($28b053c97cee4bd6$exports, "__esModule", {
    value: true
});
$28b053c97cee4bd6$exports.useGridCellEditing = void 0;

var $28b053c97cee4bd6$var$_objectWithoutPropertiesLoose2 = $28b053c97cee4bd6$require$_interopRequireDefault((parcelRequire("c05no")));

var $28b053c97cee4bd6$var$_toPropertyKey2 = $28b053c97cee4bd6$require$_interopRequireDefault((parcelRequire("5DKOa")));

var $28b053c97cee4bd6$var$_extends2 = $28b053c97cee4bd6$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $28b053c97cee4bd6$var$React = $28b053c97cee4bd6$require$_interopRequireWildcard((parcelRequire("acw62")));

var $9Y8Cp = parcelRequire("9Y8Cp");

var $28b053c97cee4bd6$var$_useEventCallback = $28b053c97cee4bd6$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $28b053c97cee4bd6$var$_useEnhancedEffect = $28b053c97cee4bd6$require$_interopRequireDefault((parcelRequire("jdWO4")));









var $7561702eaa720cf2$exports = {};
"use strict";
Object.defineProperty($7561702eaa720cf2$exports, "__esModule", {
    value: true
});
$7561702eaa720cf2$exports.getDefaultCellValue = void 0;
const $7561702eaa720cf2$var$getDefaultCellValue = (colDef)=>{
    switch(colDef.type){
        case 'boolean':
            return false;
        case 'date':
        case 'dateTime':
        case 'number':
            return undefined;
        case 'singleSelect':
            return null;
        case 'string':
        default:
            return '';
    }
};
$7561702eaa720cf2$exports.getDefaultCellValue = $7561702eaa720cf2$var$getDefaultCellValue;


const $28b053c97cee4bd6$var$_excluded = [
    "id",
    "field"
], $28b053c97cee4bd6$var$_excluded2 = [
    "id",
    "field"
];
const $28b053c97cee4bd6$var$useGridCellEditing = (apiRef, props)=>{
    const [cellModesModel, setCellModesModel] = $28b053c97cee4bd6$var$React.useState({});
    const cellModesModelRef = $28b053c97cee4bd6$var$React.useRef(cellModesModel);
    const prevCellModesModel = $28b053c97cee4bd6$var$React.useRef({});
    const { processRowUpdate: processRowUpdate, onProcessRowUpdateError: onProcessRowUpdateError, cellModesModel: cellModesModelProp, onCellModesModelChange: onCellModesModelChange } = props;
    const runIfEditModeIsCell = (callback)=>(...args)=>{
            if (props.editMode === $e139707caeafbfd6$exports.GridEditModes.Cell) callback(...args);
        };
    const throwIfNotEditable = $28b053c97cee4bd6$var$React.useCallback((id, field)=>{
        const params = apiRef.current.getCellParams(id, field);
        if (!apiRef.current.isCellEditable(params)) throw new Error(`MUI X: The cell with id=${id} and field=${field} is not editable.`);
    }, [
        apiRef
    ]);
    const throwIfNotInMode = $28b053c97cee4bd6$var$React.useCallback((id, field, mode)=>{
        if (apiRef.current.getCellMode(id, field) !== mode) throw new Error(`MUI X: The cell with id=${id} and field=${field} is not in ${mode} mode.`);
    }, [
        apiRef
    ]);
    const handleCellDoubleClick = $28b053c97cee4bd6$var$React.useCallback((params, event)=>{
        if (!params.isEditable) return;
        if (params.cellMode === $e139707caeafbfd6$exports.GridCellModes.Edit) return;
        const newParams = (0, $28b053c97cee4bd6$var$_extends2.default)({}, params, {
            reason: $dae8aa7db1c69e5a$exports.GridCellEditStartReasons.cellDoubleClick
        });
        apiRef.current.publishEvent('cellEditStart', newParams, event);
    }, [
        apiRef
    ]);
    const handleCellFocusOut = $28b053c97cee4bd6$var$React.useCallback((params, event)=>{
        if (params.cellMode === $e139707caeafbfd6$exports.GridCellModes.View) return;
        if (apiRef.current.getCellMode(params.id, params.field) === $e139707caeafbfd6$exports.GridCellModes.View) return;
        const newParams = (0, $28b053c97cee4bd6$var$_extends2.default)({}, params, {
            reason: $dae8aa7db1c69e5a$exports.GridCellEditStopReasons.cellFocusOut
        });
        apiRef.current.publishEvent('cellEditStop', newParams, event);
    }, [
        apiRef
    ]);
    const handleCellKeyDown = $28b053c97cee4bd6$var$React.useCallback((params, event)=>{
        if (params.cellMode === $e139707caeafbfd6$exports.GridCellModes.Edit) {
            // Wait until IME is settled for Asian languages like Japanese and Chinese
            // TODO: to replace at one point. See https://github.com/mui/material-ui/pull/39713#discussion_r1381678957.
            if (event.which === 229) return;
            let reason;
            if (event.key === 'Escape') reason = $dae8aa7db1c69e5a$exports.GridCellEditStopReasons.escapeKeyDown;
            else if (event.key === 'Enter') reason = $dae8aa7db1c69e5a$exports.GridCellEditStopReasons.enterKeyDown;
            else if (event.key === 'Tab') {
                reason = event.shiftKey ? $dae8aa7db1c69e5a$exports.GridCellEditStopReasons.shiftTabKeyDown : $dae8aa7db1c69e5a$exports.GridCellEditStopReasons.tabKeyDown;
                event.preventDefault(); // Prevent going to the next element in the tab sequence
            }
            if (reason) {
                const newParams = (0, $28b053c97cee4bd6$var$_extends2.default)({}, params, {
                    reason: reason
                });
                apiRef.current.publishEvent('cellEditStop', newParams, event);
            }
        } else if (params.isEditable) {
            let reason;
            const canStartEditing = apiRef.current.unstable_applyPipeProcessors('canStartEditing', true, {
                event: event,
                cellParams: params,
                editMode: 'cell'
            });
            if (!canStartEditing) return;
            if ((0, $a08faead7d1bb429$exports.isPrintableKey)(event)) reason = $dae8aa7db1c69e5a$exports.GridCellEditStartReasons.printableKeyDown;
            else if ((0, $a08faead7d1bb429$exports.isPasteShortcut)(event)) reason = $dae8aa7db1c69e5a$exports.GridCellEditStartReasons.pasteKeyDown;
            else if (event.key === 'Enter') reason = $dae8aa7db1c69e5a$exports.GridCellEditStartReasons.enterKeyDown;
            else if (event.key === 'Backspace' || event.key === 'Delete') reason = $dae8aa7db1c69e5a$exports.GridCellEditStartReasons.deleteKeyDown;
            if (reason) {
                const newParams = (0, $28b053c97cee4bd6$var$_extends2.default)({}, params, {
                    reason: reason,
                    key: event.key
                });
                apiRef.current.publishEvent('cellEditStart', newParams, event);
            }
        }
    }, [
        apiRef
    ]);
    const handleCellEditStart = $28b053c97cee4bd6$var$React.useCallback((params)=>{
        const { id: id, field: field, reason: reason } = params;
        const startCellEditModeParams = {
            id: id,
            field: field
        };
        if (reason === $dae8aa7db1c69e5a$exports.GridCellEditStartReasons.printableKeyDown || reason === $dae8aa7db1c69e5a$exports.GridCellEditStartReasons.deleteKeyDown || reason === $dae8aa7db1c69e5a$exports.GridCellEditStartReasons.pasteKeyDown) startCellEditModeParams.deleteValue = true;
        apiRef.current.startCellEditMode(startCellEditModeParams);
    }, [
        apiRef
    ]);
    const handleCellEditStop = $28b053c97cee4bd6$var$React.useCallback((params)=>{
        const { id: id, field: field, reason: reason } = params;
        apiRef.current.runPendingEditCellValueMutation(id, field);
        let cellToFocusAfter;
        if (reason === $dae8aa7db1c69e5a$exports.GridCellEditStopReasons.enterKeyDown) cellToFocusAfter = 'below';
        else if (reason === $dae8aa7db1c69e5a$exports.GridCellEditStopReasons.tabKeyDown) cellToFocusAfter = 'right';
        else if (reason === $dae8aa7db1c69e5a$exports.GridCellEditStopReasons.shiftTabKeyDown) cellToFocusAfter = 'left';
        const ignoreModifications = reason === 'escapeKeyDown';
        apiRef.current.stopCellEditMode({
            id: id,
            field: field,
            ignoreModifications: ignoreModifications,
            cellToFocusAfter: cellToFocusAfter
        });
    }, [
        apiRef
    ]);
    const runIfNoFieldErrors = (callback)=>async (...args)=>{
            if (callback) {
                const { id: id, field: field } = args[0];
                const editRowsState = apiRef.current.state.editRows;
                const hasFieldErrors = editRowsState[id][field]?.error;
                if (!hasFieldErrors) callback(...args);
            }
        };
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'cellDoubleClick', runIfEditModeIsCell(handleCellDoubleClick));
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'cellFocusOut', runIfEditModeIsCell(handleCellFocusOut));
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'cellKeyDown', runIfEditModeIsCell(handleCellKeyDown));
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'cellEditStart', runIfEditModeIsCell(handleCellEditStart));
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'cellEditStop', runIfEditModeIsCell(handleCellEditStop));
    (0, $bc055d85bc2d0e70$exports.useGridEventPriority)(apiRef, 'cellEditStart', props.onCellEditStart);
    (0, $bc055d85bc2d0e70$exports.useGridEventPriority)(apiRef, 'cellEditStop', runIfNoFieldErrors(props.onCellEditStop));
    const getCellMode = $28b053c97cee4bd6$var$React.useCallback((id, field)=>{
        const editingState = (0, $443dd6b911893b50$exports.gridEditRowsStateSelector)(apiRef);
        const isEditing = editingState[id] && editingState[id][field];
        return isEditing ? $e139707caeafbfd6$exports.GridCellModes.Edit : $e139707caeafbfd6$exports.GridCellModes.View;
    }, [
        apiRef
    ]);
    const updateCellModesModel = (0, $28b053c97cee4bd6$var$_useEventCallback.default)((newModel)=>{
        const isNewModelDifferentFromProp = newModel !== props.cellModesModel;
        if (onCellModesModelChange && isNewModelDifferentFromProp) onCellModesModelChange(newModel, {
            api: apiRef.current
        });
        if (props.cellModesModel && isNewModelDifferentFromProp) return; // The prop always win
        setCellModesModel(newModel);
        cellModesModelRef.current = newModel;
        apiRef.current.publishEvent('cellModesModelChange', newModel);
    });
    const updateFieldInCellModesModel = $28b053c97cee4bd6$var$React.useCallback((id, field, newProps)=>{
        // We use the ref because it always contain the up-to-date value, different from the state
        // that needs a rerender to reflect the new value
        const newModel = (0, $28b053c97cee4bd6$var$_extends2.default)({}, cellModesModelRef.current);
        if (newProps !== null) newModel[id] = (0, $28b053c97cee4bd6$var$_extends2.default)({}, newModel[id], {
            [field]: (0, $28b053c97cee4bd6$var$_extends2.default)({}, newProps)
        });
        else {
            const _newModel$id = newModel[id], otherFields = (0, $28b053c97cee4bd6$var$_objectWithoutPropertiesLoose2.default)(_newModel$id, [
                field
            ].map($28b053c97cee4bd6$var$_toPropertyKey2.default)); // Ensure that we have a new object, not a reference
            newModel[id] = otherFields;
            if (Object.keys(newModel[id]).length === 0) delete newModel[id];
        }
        updateCellModesModel(newModel);
    }, [
        updateCellModesModel
    ]);
    const updateOrDeleteFieldState = $28b053c97cee4bd6$var$React.useCallback((id, field, newProps)=>{
        apiRef.current.setState((state)=>{
            const newEditingState = (0, $28b053c97cee4bd6$var$_extends2.default)({}, state.editRows);
            if (newProps !== null) newEditingState[id] = (0, $28b053c97cee4bd6$var$_extends2.default)({}, newEditingState[id], {
                [field]: (0, $28b053c97cee4bd6$var$_extends2.default)({}, newProps)
            });
            else {
                delete newEditingState[id][field];
                if (Object.keys(newEditingState[id]).length === 0) delete newEditingState[id];
            }
            return (0, $28b053c97cee4bd6$var$_extends2.default)({}, state, {
                editRows: newEditingState
            });
        });
    }, [
        apiRef
    ]);
    const startCellEditMode = $28b053c97cee4bd6$var$React.useCallback((params)=>{
        const { id: id, field: field } = params, other = (0, $28b053c97cee4bd6$var$_objectWithoutPropertiesLoose2.default)(params, $28b053c97cee4bd6$var$_excluded);
        throwIfNotEditable(id, field);
        throwIfNotInMode(id, field, $e139707caeafbfd6$exports.GridCellModes.View);
        updateFieldInCellModesModel(id, field, (0, $28b053c97cee4bd6$var$_extends2.default)({
            mode: $e139707caeafbfd6$exports.GridCellModes.Edit
        }, other));
    }, [
        throwIfNotEditable,
        throwIfNotInMode,
        updateFieldInCellModesModel
    ]);
    const updateStateToStartCellEditMode = (0, $28b053c97cee4bd6$var$_useEventCallback.default)(async (params)=>{
        const { id: id, field: field, deleteValue: deleteValue, initialValue: initialValue } = params;
        const value = apiRef.current.getCellValue(id, field);
        let newValue = value;
        if (deleteValue) newValue = (0, $7561702eaa720cf2$exports.getDefaultCellValue)(apiRef.current.getColumn(field));
        else if (initialValue) newValue = initialValue;
        const column = apiRef.current.getColumn(field);
        const shouldProcessEditCellProps = !!column.preProcessEditCellProps && deleteValue;
        let newProps = {
            value: newValue,
            error: false,
            isProcessingProps: shouldProcessEditCellProps
        };
        updateOrDeleteFieldState(id, field, newProps);
        apiRef.current.setCellFocus(id, field);
        if (shouldProcessEditCellProps) {
            newProps = await Promise.resolve(column.preProcessEditCellProps({
                id: id,
                row: apiRef.current.getRow(id),
                props: newProps,
                hasChanged: newValue !== value
            }));
            // Check if still in edit mode before updating
            if (apiRef.current.getCellMode(id, field) === $e139707caeafbfd6$exports.GridCellModes.Edit) {
                const editingState = (0, $443dd6b911893b50$exports.gridEditRowsStateSelector)(apiRef);
                updateOrDeleteFieldState(id, field, (0, $28b053c97cee4bd6$var$_extends2.default)({}, newProps, {
                    value: editingState[id][field].value,
                    isProcessingProps: false
                }));
            }
        }
    });
    const stopCellEditMode = $28b053c97cee4bd6$var$React.useCallback((params)=>{
        const { id: id, field: field } = params, other = (0, $28b053c97cee4bd6$var$_objectWithoutPropertiesLoose2.default)(params, $28b053c97cee4bd6$var$_excluded2);
        throwIfNotInMode(id, field, $e139707caeafbfd6$exports.GridCellModes.Edit);
        updateFieldInCellModesModel(id, field, (0, $28b053c97cee4bd6$var$_extends2.default)({
            mode: $e139707caeafbfd6$exports.GridCellModes.View
        }, other));
    }, [
        throwIfNotInMode,
        updateFieldInCellModesModel
    ]);
    const updateStateToStopCellEditMode = (0, $28b053c97cee4bd6$var$_useEventCallback.default)(async (params)=>{
        const { id: id, field: field, ignoreModifications: ignoreModifications, cellToFocusAfter: cellToFocusAfter = 'none' } = params;
        throwIfNotInMode(id, field, $e139707caeafbfd6$exports.GridCellModes.Edit);
        apiRef.current.runPendingEditCellValueMutation(id, field);
        const finishCellEditMode = ()=>{
            updateOrDeleteFieldState(id, field, null);
            updateFieldInCellModesModel(id, field, null);
            if (cellToFocusAfter !== 'none') apiRef.current.moveFocusToRelativeCell(id, field, cellToFocusAfter);
        };
        if (ignoreModifications) {
            finishCellEditMode();
            return;
        }
        const editingState = (0, $443dd6b911893b50$exports.gridEditRowsStateSelector)(apiRef);
        const { error: error, isProcessingProps: isProcessingProps } = editingState[id][field];
        const row = apiRef.current.getRow(id);
        if (error || isProcessingProps) {
            // Attempt to change cell mode to "view" was not successful
            // Update previous mode to allow another attempt
            prevCellModesModel.current[id][field].mode = $e139707caeafbfd6$exports.GridCellModes.Edit;
            // Revert the mode in the cellModesModel prop back to "edit"
            updateFieldInCellModesModel(id, field, {
                mode: $e139707caeafbfd6$exports.GridCellModes.Edit
            });
            return;
        }
        const rowUpdate = apiRef.current.getRowWithUpdatedValuesFromCellEditing(id, field);
        if (props.dataSource?.updateRow) {
            if ((0, $a4d2c99ef8ba2460$exports.isDeepEqual)(row, rowUpdate)) {
                finishCellEditMode();
                return;
            }
            const handleError = ()=>{
                prevCellModesModel.current[id][field].mode = $e139707caeafbfd6$exports.GridCellModes.Edit;
                // Revert the mode in the cellModesModel prop back to "edit"
                updateFieldInCellModesModel(id, field, {
                    mode: $e139707caeafbfd6$exports.GridCellModes.Edit
                });
            };
            const updateRowParams = {
                rowId: id,
                updatedRow: rowUpdate,
                previousRow: row
            };
            try {
                await apiRef.current.dataSource.editRow(updateRowParams);
                finishCellEditMode();
            } catch  {
                handleError();
            }
        } else if (processRowUpdate) {
            const handleError = (errorThrown)=>{
                prevCellModesModel.current[id][field].mode = $e139707caeafbfd6$exports.GridCellModes.Edit;
                // Revert the mode in the cellModesModel prop back to "edit"
                updateFieldInCellModesModel(id, field, {
                    mode: $e139707caeafbfd6$exports.GridCellModes.Edit
                });
                if (onProcessRowUpdateError) onProcessRowUpdateError(errorThrown);
                else (0, $9Y8Cp.warnOnce)([
                    'MUI X: A call to `processRowUpdate()` threw an error which was not handled because `onProcessRowUpdateError()` is missing.',
                    'To handle the error pass a callback to the `onProcessRowUpdateError()` prop, for example `<DataGrid onProcessRowUpdateError={(error) => ...} />`.',
                    'For more detail, see https://mui.com/x/react-data-grid/editing/persistence/.'
                ], 'error');
            };
            try {
                Promise.resolve(processRowUpdate(rowUpdate, row, {
                    rowId: id
                })).then((finalRowUpdate)=>{
                    apiRef.current.updateRows([
                        finalRowUpdate
                    ]);
                    finishCellEditMode();
                }).catch(handleError);
            } catch (errorThrown) {
                handleError(errorThrown);
            }
        } else {
            apiRef.current.updateRows([
                rowUpdate
            ]);
            finishCellEditMode();
        }
    });
    const setCellEditingEditCellValue = $28b053c97cee4bd6$var$React.useCallback(async (params)=>{
        const { id: id, field: field, value: value, debounceMs: debounceMs, unstable_skipValueParser: skipValueParser } = params;
        throwIfNotEditable(id, field);
        throwIfNotInMode(id, field, $e139707caeafbfd6$exports.GridCellModes.Edit);
        const column = apiRef.current.getColumn(field);
        const row = apiRef.current.getRow(id);
        let parsedValue = value;
        if (column.valueParser && !skipValueParser) parsedValue = column.valueParser(value, row, column, apiRef);
        let editingState = (0, $443dd6b911893b50$exports.gridEditRowsStateSelector)(apiRef);
        let newProps = (0, $28b053c97cee4bd6$var$_extends2.default)({}, editingState[id][field], {
            value: parsedValue,
            changeReason: debounceMs ? 'debouncedSetEditCellValue' : 'setEditCellValue'
        });
        if (column.preProcessEditCellProps) {
            const hasChanged = value !== editingState[id][field].value;
            newProps = (0, $28b053c97cee4bd6$var$_extends2.default)({}, newProps, {
                isProcessingProps: true
            });
            updateOrDeleteFieldState(id, field, newProps);
            newProps = await Promise.resolve(column.preProcessEditCellProps({
                id: id,
                row: row,
                props: newProps,
                hasChanged: hasChanged
            }));
        }
        // Check again if the cell is in edit mode because the user may have
        // discarded the changes while the props were being processed.
        if (apiRef.current.getCellMode(id, field) === $e139707caeafbfd6$exports.GridCellModes.View) return false;
        editingState = (0, $443dd6b911893b50$exports.gridEditRowsStateSelector)(apiRef);
        newProps = (0, $28b053c97cee4bd6$var$_extends2.default)({}, newProps, {
            isProcessingProps: false
        });
        // We don't update the value with the one coming from the props pre-processing
        // because when the promise resolves it may be already outdated. The only
        // exception to this rule is when there's no pre-processing.
        newProps.value = column.preProcessEditCellProps ? editingState[id][field].value : parsedValue;
        updateOrDeleteFieldState(id, field, newProps);
        editingState = (0, $443dd6b911893b50$exports.gridEditRowsStateSelector)(apiRef);
        return !editingState[id]?.[field]?.error;
    }, [
        apiRef,
        throwIfNotEditable,
        throwIfNotInMode,
        updateOrDeleteFieldState
    ]);
    const getRowWithUpdatedValuesFromCellEditing = $28b053c97cee4bd6$var$React.useCallback((id, field)=>{
        const column = apiRef.current.getColumn(field);
        const editingState = (0, $443dd6b911893b50$exports.gridEditRowsStateSelector)(apiRef);
        const row = apiRef.current.getRow(id);
        if (!editingState[id] || !editingState[id][field]) return apiRef.current.getRow(id);
        const { value: value } = editingState[id][field];
        return column.valueSetter ? column.valueSetter(value, row, column, apiRef) : (0, $28b053c97cee4bd6$var$_extends2.default)({}, row, {
            [field]: value
        });
    }, [
        apiRef
    ]);
    const editingApi = {
        getCellMode: getCellMode,
        startCellEditMode: startCellEditMode,
        stopCellEditMode: stopCellEditMode
    };
    const editingPrivateApi = {
        setCellEditingEditCellValue: setCellEditingEditCellValue,
        getRowWithUpdatedValuesFromCellEditing: getRowWithUpdatedValuesFromCellEditing
    };
    (0, $d79b1aa4f5237e85$exports.useGridApiMethod)(apiRef, editingApi, 'public');
    (0, $d79b1aa4f5237e85$exports.useGridApiMethod)(apiRef, editingPrivateApi, 'private');
    $28b053c97cee4bd6$var$React.useEffect(()=>{
        if (cellModesModelProp) updateCellModesModel(cellModesModelProp);
    }, [
        cellModesModelProp,
        updateCellModesModel
    ]);
    // Run this effect synchronously so that the keyboard event can impact the yet-to-be-rendered input.
    (0, $28b053c97cee4bd6$var$_useEnhancedEffect.default)(()=>{
        const rowsLookup = (0, $befccaa56b49492d$exports.gridRowsLookupSelector)(apiRef);
        // Update the ref here because updateStateToStopCellEditMode may change it later
        const copyOfPrevCellModes = prevCellModesModel.current;
        prevCellModesModel.current = (0, $fe919794eb3b24e8$exports.deepClone)(cellModesModel); // Do a deep-clone because the attributes might be changed later
        Object.entries(cellModesModel).forEach(([id, fields])=>{
            Object.entries(fields).forEach(([field, params])=>{
                const prevMode = copyOfPrevCellModes[id]?.[field]?.mode || $e139707caeafbfd6$exports.GridCellModes.View;
                const originalId = rowsLookup[id] ? apiRef.current.getRowId(rowsLookup[id]) : id;
                if (params.mode === $e139707caeafbfd6$exports.GridCellModes.Edit && prevMode === $e139707caeafbfd6$exports.GridCellModes.View) updateStateToStartCellEditMode((0, $28b053c97cee4bd6$var$_extends2.default)({
                    id: originalId,
                    field: field
                }, params));
                else if (params.mode === $e139707caeafbfd6$exports.GridCellModes.View && prevMode === $e139707caeafbfd6$exports.GridCellModes.Edit) updateStateToStopCellEditMode((0, $28b053c97cee4bd6$var$_extends2.default)({
                    id: originalId,
                    field: field
                }, params));
            });
        });
    }, [
        apiRef,
        cellModesModel,
        updateStateToStartCellEditMode,
        updateStateToStopCellEditMode
    ]);
};
$28b053c97cee4bd6$exports.useGridCellEditing = $28b053c97cee4bd6$var$useGridCellEditing;



var $c726e745e154c244$exports = {};
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $c726e745e154c244$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $c726e745e154c244$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($c726e745e154c244$exports, "__esModule", {
    value: true
});
$c726e745e154c244$exports.useGridRowEditing = void 0;

var $c726e745e154c244$var$_toPropertyKey2 = $c726e745e154c244$require$_interopRequireDefault((parcelRequire("5DKOa")));

var $c726e745e154c244$var$_objectWithoutPropertiesLoose2 = $c726e745e154c244$require$_interopRequireDefault((parcelRequire("c05no")));

var $c726e745e154c244$var$_extends2 = $c726e745e154c244$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $c726e745e154c244$var$React = $c726e745e154c244$require$_interopRequireWildcard((parcelRequire("acw62")));

var $c726e745e154c244$var$_useEventCallback = $c726e745e154c244$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $c726e745e154c244$var$_useEnhancedEffect = $c726e745e154c244$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $9Y8Cp = parcelRequire("9Y8Cp");












const $c726e745e154c244$var$_excluded = [
    "id"
], $c726e745e154c244$var$_excluded2 = [
    "id"
];
const $c726e745e154c244$var$useGridRowEditing = (apiRef, props)=>{
    const [rowModesModel, setRowModesModel] = $c726e745e154c244$var$React.useState({});
    const rowModesModelRef = $c726e745e154c244$var$React.useRef(rowModesModel);
    const prevRowModesModel = $c726e745e154c244$var$React.useRef({});
    const prevRowValuesLookup = $c726e745e154c244$var$React.useRef({});
    const focusTimeout = $c726e745e154c244$var$React.useRef(undefined);
    const nextFocusedCell = $c726e745e154c244$var$React.useRef(null);
    const { processRowUpdate: processRowUpdate, onProcessRowUpdateError: onProcessRowUpdateError, rowModesModel: rowModesModelProp, onRowModesModelChange: onRowModesModelChange } = props;
    const runIfEditModeIsRow = (callback)=>(...args)=>{
            if (props.editMode === $e139707caeafbfd6$exports.GridEditModes.Row) callback(...args);
        };
    const throwIfNotEditable = $c726e745e154c244$var$React.useCallback((id, field)=>{
        const params = apiRef.current.getCellParams(id, field);
        if (!apiRef.current.isCellEditable(params)) throw new Error(`MUI X: The cell with id=${id} and field=${field} is not editable.`);
    }, [
        apiRef
    ]);
    const throwIfNotInMode = $c726e745e154c244$var$React.useCallback((id, mode)=>{
        if (apiRef.current.getRowMode(id) !== mode) throw new Error(`MUI X: The row with id=${id} is not in ${mode} mode.`);
    }, [
        apiRef
    ]);
    const hasFieldsWithErrors = $c726e745e154c244$var$React.useCallback((rowId)=>{
        const editingState = (0, $443dd6b911893b50$exports.gridEditRowsStateSelector)(apiRef);
        return Object.values(editingState[rowId]).some((fieldProps)=>fieldProps.error);
    }, [
        apiRef
    ]);
    const handleCellDoubleClick = $c726e745e154c244$var$React.useCallback((params, event)=>{
        if (!params.isEditable) return;
        if (apiRef.current.getRowMode(params.id) === $e139707caeafbfd6$exports.GridRowModes.Edit) return;
        const rowParams = apiRef.current.getRowParams(params.id);
        const newParams = (0, $c726e745e154c244$var$_extends2.default)({}, rowParams, {
            field: params.field,
            reason: $e03e8aca644cf2db$exports.GridRowEditStartReasons.cellDoubleClick
        });
        apiRef.current.publishEvent('rowEditStart', newParams, event);
    }, [
        apiRef
    ]);
    const handleCellFocusIn = $c726e745e154c244$var$React.useCallback((params)=>{
        nextFocusedCell.current = params;
    }, []);
    const handleCellFocusOut = $c726e745e154c244$var$React.useCallback((params, event)=>{
        if (!params.isEditable) return;
        if (apiRef.current.getRowMode(params.id) === $e139707caeafbfd6$exports.GridRowModes.View) return;
        // The mechanism to detect if we can stop editing a row is different from
        // the cell editing. Instead of triggering it when clicking outside a cell,
        // we must check if another cell in the same row was not clicked. To achieve
        // that, first we keep track of all cells that gained focus. When a cell loses
        // focus we check if the next cell that received focus is from a different row.
        nextFocusedCell.current = null;
        focusTimeout.current = setTimeout(()=>{
            if (nextFocusedCell.current?.id !== params.id) {
                // The row might have been deleted during the click
                if (!apiRef.current.getRow(params.id)) return;
                // The row may already changed its mode
                if (apiRef.current.getRowMode(params.id) === $e139707caeafbfd6$exports.GridRowModes.View) return;
                if (hasFieldsWithErrors(params.id)) return;
                const rowParams = apiRef.current.getRowParams(params.id);
                const newParams = (0, $c726e745e154c244$var$_extends2.default)({}, rowParams, {
                    field: params.field,
                    reason: $e03e8aca644cf2db$exports.GridRowEditStopReasons.rowFocusOut
                });
                apiRef.current.publishEvent('rowEditStop', newParams, event);
            }
        });
    }, [
        apiRef,
        hasFieldsWithErrors
    ]);
    $c726e745e154c244$var$React.useEffect(()=>{
        return ()=>{
            clearTimeout(focusTimeout.current);
        };
    }, []);
    const handleCellKeyDown = $c726e745e154c244$var$React.useCallback((params, event)=>{
        if (params.cellMode === $e139707caeafbfd6$exports.GridRowModes.Edit) {
            // Wait until IME is settled for Asian languages like Japanese and Chinese
            // TODO: to replace at one point. See https://github.com/mui/material-ui/pull/39713#discussion_r1381678957.
            if (event.which === 229) return;
            let reason;
            if (event.key === 'Escape') reason = $e03e8aca644cf2db$exports.GridRowEditStopReasons.escapeKeyDown;
            else if (event.key === 'Enter') reason = $e03e8aca644cf2db$exports.GridRowEditStopReasons.enterKeyDown;
            else if (event.key === 'Tab') {
                const columnFields = (0, $e732684465924d20$exports.gridVisibleColumnFieldsSelector)(apiRef).filter((field)=>{
                    const column = apiRef.current.getColumn(field);
                    if (column.type === $a6506085715c5aff$exports.GRID_ACTIONS_COLUMN_TYPE) return true;
                    return apiRef.current.isCellEditable(apiRef.current.getCellParams(params.id, field));
                });
                if (event.shiftKey) {
                    if (params.field === columnFields[0]) // Exit if user pressed Shift+Tab on the first field
                    reason = $e03e8aca644cf2db$exports.GridRowEditStopReasons.shiftTabKeyDown;
                } else if (params.field === columnFields[columnFields.length - 1]) // Exit if user pressed Tab on the last field
                reason = $e03e8aca644cf2db$exports.GridRowEditStopReasons.tabKeyDown;
                // Always prevent going to the next element in the tab sequence because the focus is
                // handled manually to support edit components rendered inside Portals
                event.preventDefault();
                if (!reason) {
                    const index = columnFields.findIndex((field)=>field === params.field);
                    const nextFieldToFocus = columnFields[event.shiftKey ? index - 1 : index + 1];
                    apiRef.current.setCellFocus(params.id, nextFieldToFocus);
                }
            }
            if (reason) {
                if (reason !== $e03e8aca644cf2db$exports.GridRowEditStopReasons.escapeKeyDown && hasFieldsWithErrors(params.id)) return;
                const newParams = (0, $c726e745e154c244$var$_extends2.default)({}, apiRef.current.getRowParams(params.id), {
                    reason: reason,
                    field: params.field
                });
                apiRef.current.publishEvent('rowEditStop', newParams, event);
            }
        } else if (params.isEditable) {
            let reason;
            const canStartEditing = apiRef.current.unstable_applyPipeProcessors('canStartEditing', true, {
                event: event,
                cellParams: params,
                editMode: 'row'
            });
            if (!canStartEditing) return;
            if ((0, $a08faead7d1bb429$exports.isPrintableKey)(event)) reason = $e03e8aca644cf2db$exports.GridRowEditStartReasons.printableKeyDown;
            else if ((0, $a08faead7d1bb429$exports.isPasteShortcut)(event)) reason = $e03e8aca644cf2db$exports.GridRowEditStartReasons.printableKeyDown;
            else if (event.key === 'Enter') reason = $e03e8aca644cf2db$exports.GridRowEditStartReasons.enterKeyDown;
            else if (event.key === 'Backspace' || event.key === 'Delete') reason = $e03e8aca644cf2db$exports.GridRowEditStartReasons.deleteKeyDown;
            if (reason) {
                const rowParams = apiRef.current.getRowParams(params.id);
                const newParams = (0, $c726e745e154c244$var$_extends2.default)({}, rowParams, {
                    field: params.field,
                    reason: reason
                });
                apiRef.current.publishEvent('rowEditStart', newParams, event);
            }
        }
    }, [
        apiRef,
        hasFieldsWithErrors
    ]);
    const handleRowEditStart = $c726e745e154c244$var$React.useCallback((params)=>{
        const { id: id, field: field, reason: reason } = params;
        const startRowEditModeParams = {
            id: id,
            fieldToFocus: field
        };
        if (reason === $e03e8aca644cf2db$exports.GridRowEditStartReasons.printableKeyDown || reason === $e03e8aca644cf2db$exports.GridRowEditStartReasons.deleteKeyDown) startRowEditModeParams.deleteValue = !!field;
        apiRef.current.startRowEditMode(startRowEditModeParams);
    }, [
        apiRef
    ]);
    const handleRowEditStop = $c726e745e154c244$var$React.useCallback((params)=>{
        const { id: id, reason: reason, field: field } = params;
        apiRef.current.runPendingEditCellValueMutation(id);
        let cellToFocusAfter;
        if (reason === $e03e8aca644cf2db$exports.GridRowEditStopReasons.enterKeyDown) cellToFocusAfter = 'below';
        else if (reason === $e03e8aca644cf2db$exports.GridRowEditStopReasons.tabKeyDown) cellToFocusAfter = 'right';
        else if (reason === $e03e8aca644cf2db$exports.GridRowEditStopReasons.shiftTabKeyDown) cellToFocusAfter = 'left';
        const ignoreModifications = reason === 'escapeKeyDown';
        apiRef.current.stopRowEditMode({
            id: id,
            ignoreModifications: ignoreModifications,
            field: field,
            cellToFocusAfter: cellToFocusAfter
        });
    }, [
        apiRef
    ]);
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'cellDoubleClick', runIfEditModeIsRow(handleCellDoubleClick));
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'cellFocusIn', runIfEditModeIsRow(handleCellFocusIn));
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'cellFocusOut', runIfEditModeIsRow(handleCellFocusOut));
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'cellKeyDown', runIfEditModeIsRow(handleCellKeyDown));
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'rowEditStart', runIfEditModeIsRow(handleRowEditStart));
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'rowEditStop', runIfEditModeIsRow(handleRowEditStop));
    (0, $bc055d85bc2d0e70$exports.useGridEventPriority)(apiRef, 'rowEditStart', props.onRowEditStart);
    (0, $bc055d85bc2d0e70$exports.useGridEventPriority)(apiRef, 'rowEditStop', props.onRowEditStop);
    const getRowMode = $c726e745e154c244$var$React.useCallback((id)=>{
        const isEditing = (0, $443dd6b911893b50$exports.gridRowIsEditingSelector)(apiRef, {
            rowId: id,
            editMode: props.editMode
        });
        return isEditing ? $e139707caeafbfd6$exports.GridRowModes.Edit : $e139707caeafbfd6$exports.GridRowModes.View;
    }, [
        apiRef,
        props.editMode
    ]);
    const updateRowModesModel = (0, $c726e745e154c244$var$_useEventCallback.default)((newModel)=>{
        const isNewModelDifferentFromProp = newModel !== props.rowModesModel;
        if (onRowModesModelChange && isNewModelDifferentFromProp) onRowModesModelChange(newModel, {
            api: apiRef.current
        });
        if (props.rowModesModel && isNewModelDifferentFromProp) return; // The prop always win
        setRowModesModel(newModel);
        rowModesModelRef.current = newModel;
        apiRef.current.publishEvent('rowModesModelChange', newModel);
    });
    const updateRowInRowModesModel = $c726e745e154c244$var$React.useCallback((id, newProps)=>{
        const newModel = (0, $c726e745e154c244$var$_extends2.default)({}, rowModesModelRef.current);
        if (newProps !== null) newModel[id] = (0, $c726e745e154c244$var$_extends2.default)({}, newProps);
        else delete newModel[id];
        updateRowModesModel(newModel);
    }, [
        updateRowModesModel
    ]);
    const updateOrDeleteRowState = $c726e745e154c244$var$React.useCallback((id, newProps)=>{
        apiRef.current.setState((state)=>{
            const newEditingState = (0, $c726e745e154c244$var$_extends2.default)({}, state.editRows);
            if (newProps !== null) newEditingState[id] = newProps;
            else delete newEditingState[id];
            return (0, $c726e745e154c244$var$_extends2.default)({}, state, {
                editRows: newEditingState
            });
        });
    }, [
        apiRef
    ]);
    const updateOrDeleteFieldState = $c726e745e154c244$var$React.useCallback((id, field, newProps)=>{
        apiRef.current.setState((state)=>{
            const newEditingState = (0, $c726e745e154c244$var$_extends2.default)({}, state.editRows);
            if (newProps !== null) newEditingState[id] = (0, $c726e745e154c244$var$_extends2.default)({}, newEditingState[id], {
                [field]: (0, $c726e745e154c244$var$_extends2.default)({}, newProps)
            });
            else {
                delete newEditingState[id][field];
                if (Object.keys(newEditingState[id]).length === 0) delete newEditingState[id];
            }
            return (0, $c726e745e154c244$var$_extends2.default)({}, state, {
                editRows: newEditingState
            });
        });
    }, [
        apiRef
    ]);
    const startRowEditMode = $c726e745e154c244$var$React.useCallback((params)=>{
        const { id: id } = params, other = (0, $c726e745e154c244$var$_objectWithoutPropertiesLoose2.default)(params, $c726e745e154c244$var$_excluded);
        throwIfNotInMode(id, $e139707caeafbfd6$exports.GridRowModes.View);
        updateRowInRowModesModel(id, (0, $c726e745e154c244$var$_extends2.default)({
            mode: $e139707caeafbfd6$exports.GridRowModes.Edit
        }, other));
    }, [
        throwIfNotInMode,
        updateRowInRowModesModel
    ]);
    const updateStateToStartRowEditMode = (0, $c726e745e154c244$var$_useEventCallback.default)((params)=>{
        const { id: id, fieldToFocus: fieldToFocus, deleteValue: deleteValue, initialValue: initialValue } = params;
        const row = apiRef.current.getRow(id);
        const columns = (0, $e732684465924d20$exports.gridColumnDefinitionsSelector)(apiRef);
        const newProps = columns.reduce((acc, col)=>{
            const field = col.field;
            const cellParams = apiRef.current.getCellParams(id, field);
            if (!cellParams.isEditable) return acc;
            const column = apiRef.current.getColumn(field);
            let newValue = apiRef.current.getCellValue(id, field);
            if (fieldToFocus === field && (deleteValue || initialValue)) {
                if (deleteValue) newValue = (0, $7561702eaa720cf2$exports.getDefaultCellValue)(column);
                else if (initialValue) newValue = initialValue;
            }
            acc[field] = {
                value: newValue,
                error: false,
                isProcessingProps: column.editable && !!column.preProcessEditCellProps && deleteValue
            };
            return acc;
        }, {});
        prevRowValuesLookup.current[id] = row;
        updateOrDeleteRowState(id, newProps);
        if (fieldToFocus) apiRef.current.setCellFocus(id, fieldToFocus);
        columns.filter((column)=>{
            const isCellEditable = apiRef.current.getCellParams(id, column.field).isEditable;
            return isCellEditable && column.editable && !!column.preProcessEditCellProps && deleteValue;
        }).forEach((column)=>{
            const field = column.field;
            const value = apiRef.current.getCellValue(id, field);
            const newValue = deleteValue ? (0, $7561702eaa720cf2$exports.getDefaultCellValue)(column) : initialValue ?? value;
            Promise.resolve(column.preProcessEditCellProps({
                id: id,
                row: row,
                props: newProps[field],
                hasChanged: newValue !== value
            })).then((processedProps)=>{
                // Check if still in edit mode before updating
                if (apiRef.current.getRowMode(id) === $e139707caeafbfd6$exports.GridRowModes.Edit) {
                    const editingState = (0, $443dd6b911893b50$exports.gridEditRowsStateSelector)(apiRef);
                    updateOrDeleteFieldState(id, field, (0, $c726e745e154c244$var$_extends2.default)({}, processedProps, {
                        value: editingState[id][field].value,
                        isProcessingProps: false
                    }));
                }
            });
        });
    });
    const stopRowEditMode = $c726e745e154c244$var$React.useCallback((params)=>{
        const { id: id } = params, other = (0, $c726e745e154c244$var$_objectWithoutPropertiesLoose2.default)(params, $c726e745e154c244$var$_excluded2);
        throwIfNotInMode(id, $e139707caeafbfd6$exports.GridRowModes.Edit);
        updateRowInRowModesModel(id, (0, $c726e745e154c244$var$_extends2.default)({
            mode: $e139707caeafbfd6$exports.GridRowModes.View
        }, other));
    }, [
        throwIfNotInMode,
        updateRowInRowModesModel
    ]);
    const updateStateToStopRowEditMode = (0, $c726e745e154c244$var$_useEventCallback.default)(async (params)=>{
        const { id: id, ignoreModifications: ignoreModifications, field: focusedField, cellToFocusAfter: cellToFocusAfter = 'none' } = params;
        apiRef.current.runPendingEditCellValueMutation(id);
        const finishRowEditMode = ()=>{
            if (cellToFocusAfter !== 'none' && focusedField) apiRef.current.moveFocusToRelativeCell(id, focusedField, cellToFocusAfter);
            updateOrDeleteRowState(id, null);
            updateRowInRowModesModel(id, null);
            delete prevRowValuesLookup.current[id];
        };
        if (ignoreModifications) {
            finishRowEditMode();
            return;
        }
        const editingState = (0, $443dd6b911893b50$exports.gridEditRowsStateSelector)(apiRef);
        const row = prevRowValuesLookup.current[id];
        const isSomeFieldProcessingProps = Object.values(editingState[id]).some((fieldProps)=>fieldProps.isProcessingProps);
        if (isSomeFieldProcessingProps) {
            prevRowModesModel.current[id].mode = $e139707caeafbfd6$exports.GridRowModes.Edit;
            return;
        }
        if (hasFieldsWithErrors(id)) {
            prevRowModesModel.current[id].mode = $e139707caeafbfd6$exports.GridRowModes.Edit;
            // Revert the mode in the rowModesModel prop back to "edit"
            updateRowInRowModesModel(id, {
                mode: $e139707caeafbfd6$exports.GridRowModes.Edit
            });
            return;
        }
        const rowUpdate = apiRef.current.getRowWithUpdatedValuesFromRowEditing(id);
        if (props.dataSource?.updateRow) {
            if ((0, $a4d2c99ef8ba2460$exports.isDeepEqual)(row, rowUpdate)) {
                finishRowEditMode();
                return;
            }
            const handleError = ()=>{
                prevRowModesModel.current[id].mode = $e139707caeafbfd6$exports.GridRowModes.Edit;
                // Revert the mode in the rowModesModel prop back to "edit"
                updateRowInRowModesModel(id, {
                    mode: $e139707caeafbfd6$exports.GridRowModes.Edit
                });
            };
            const updateRowParams = {
                rowId: id,
                updatedRow: rowUpdate,
                previousRow: row
            };
            try {
                await apiRef.current.dataSource.editRow(updateRowParams);
                finishRowEditMode();
            } catch  {
                handleError();
            }
        } else if (processRowUpdate) {
            const handleError = (errorThrown)=>{
                // The row might have been deleted
                if (prevRowModesModel.current[id]) {
                    prevRowModesModel.current[id].mode = $e139707caeafbfd6$exports.GridRowModes.Edit;
                    // Revert the mode in the rowModesModel prop back to "edit"
                    updateRowInRowModesModel(id, {
                        mode: $e139707caeafbfd6$exports.GridRowModes.Edit
                    });
                }
                if (onProcessRowUpdateError) onProcessRowUpdateError(errorThrown);
                else (0, $9Y8Cp.warnOnce)([
                    'MUI X: A call to `processRowUpdate()` threw an error which was not handled because `onProcessRowUpdateError()` is missing.',
                    'To handle the error pass a callback to the `onProcessRowUpdateError()` prop, for example `<DataGrid onProcessRowUpdateError={(error) => ...} />`.',
                    'For more detail, see https://mui.com/x/react-data-grid/editing/persistence/.'
                ], 'error');
            };
            try {
                Promise.resolve(processRowUpdate(rowUpdate, row, {
                    rowId: id
                })).then((finalRowUpdate)=>{
                    apiRef.current.updateRows([
                        finalRowUpdate
                    ]);
                    finishRowEditMode();
                }).catch(handleError);
            } catch (errorThrown) {
                handleError(errorThrown);
            }
        } else {
            apiRef.current.updateRows([
                rowUpdate
            ]);
            finishRowEditMode();
        }
    });
    const setRowEditingEditCellValue = $c726e745e154c244$var$React.useCallback((params)=>{
        const { id: id, field: field, value: value, debounceMs: debounceMs, unstable_skipValueParser: skipValueParser } = params;
        throwIfNotEditable(id, field);
        const column = apiRef.current.getColumn(field);
        const row = apiRef.current.getRow(id);
        let parsedValue = value;
        if (column.valueParser && !skipValueParser) parsedValue = column.valueParser(value, row, column, apiRef);
        let editingState = (0, $443dd6b911893b50$exports.gridEditRowsStateSelector)(apiRef);
        let newProps = (0, $c726e745e154c244$var$_extends2.default)({}, editingState[id][field], {
            value: parsedValue,
            changeReason: debounceMs ? 'debouncedSetEditCellValue' : 'setEditCellValue'
        });
        if (!column.preProcessEditCellProps) updateOrDeleteFieldState(id, field, newProps);
        return new Promise((resolve)=>{
            const promises = [];
            if (column.preProcessEditCellProps) {
                const hasChanged = newProps.value !== editingState[id][field].value;
                newProps = (0, $c726e745e154c244$var$_extends2.default)({}, newProps, {
                    isProcessingProps: true
                });
                updateOrDeleteFieldState(id, field, newProps);
                const _editingState$id = editingState[id], otherFieldsProps = (0, $c726e745e154c244$var$_objectWithoutPropertiesLoose2.default)(_editingState$id, [
                    field
                ].map($c726e745e154c244$var$_toPropertyKey2.default));
                const promise = Promise.resolve(column.preProcessEditCellProps({
                    id: id,
                    row: row,
                    props: newProps,
                    hasChanged: hasChanged,
                    otherFieldsProps: otherFieldsProps
                })).then((processedProps)=>{
                    // Check again if the row is in edit mode because the user may have
                    // discarded the changes while the props were being processed.
                    if (apiRef.current.getRowMode(id) === $e139707caeafbfd6$exports.GridRowModes.View) {
                        resolve(false);
                        return;
                    }
                    editingState = (0, $443dd6b911893b50$exports.gridEditRowsStateSelector)(apiRef);
                    processedProps = (0, $c726e745e154c244$var$_extends2.default)({}, processedProps, {
                        isProcessingProps: false
                    });
                    // We don't reuse the value from the props pre-processing because when the
                    // promise resolves it may be already outdated. The only exception to this rule
                    // is when there's no pre-processing.
                    processedProps.value = column.preProcessEditCellProps ? editingState[id][field].value : parsedValue;
                    updateOrDeleteFieldState(id, field, processedProps);
                });
                promises.push(promise);
            }
            Object.entries(editingState[id]).forEach(([thisField, fieldProps])=>{
                if (thisField === field) return;
                const fieldColumn = apiRef.current.getColumn(thisField);
                if (!fieldColumn.preProcessEditCellProps) return;
                fieldProps = (0, $c726e745e154c244$var$_extends2.default)({}, fieldProps, {
                    isProcessingProps: true
                });
                updateOrDeleteFieldState(id, thisField, fieldProps);
                editingState = (0, $443dd6b911893b50$exports.gridEditRowsStateSelector)(apiRef);
                const _editingState$id2 = editingState[id], otherFieldsProps = (0, $c726e745e154c244$var$_objectWithoutPropertiesLoose2.default)(_editingState$id2, [
                    thisField
                ].map($c726e745e154c244$var$_toPropertyKey2.default));
                const promise = Promise.resolve(fieldColumn.preProcessEditCellProps({
                    id: id,
                    row: row,
                    props: fieldProps,
                    hasChanged: false,
                    otherFieldsProps: otherFieldsProps
                })).then((processedProps)=>{
                    // Check again if the row is in edit mode because the user may have
                    // discarded the changes while the props were being processed.
                    if (apiRef.current.getRowMode(id) === $e139707caeafbfd6$exports.GridRowModes.View) {
                        resolve(false);
                        return;
                    }
                    processedProps = (0, $c726e745e154c244$var$_extends2.default)({}, processedProps, {
                        isProcessingProps: false
                    });
                    updateOrDeleteFieldState(id, thisField, processedProps);
                });
                promises.push(promise);
            });
            Promise.all(promises).then(()=>{
                if (apiRef.current.getRowMode(id) === $e139707caeafbfd6$exports.GridRowModes.Edit) {
                    editingState = (0, $443dd6b911893b50$exports.gridEditRowsStateSelector)(apiRef);
                    resolve(!editingState[id][field].error);
                } else resolve(false);
            });
        });
    }, [
        apiRef,
        throwIfNotEditable,
        updateOrDeleteFieldState
    ]);
    const getRowWithUpdatedValuesFromRowEditing = $c726e745e154c244$var$React.useCallback((id)=>{
        const editingState = (0, $443dd6b911893b50$exports.gridEditRowsStateSelector)(apiRef);
        const row = apiRef.current.getRow(id);
        if (!editingState[id]) return apiRef.current.getRow(id);
        let rowUpdate = (0, $c726e745e154c244$var$_extends2.default)({}, prevRowValuesLookup.current[id], row);
        Object.entries(editingState[id]).forEach(([field, fieldProps])=>{
            const column = apiRef.current.getColumn(field);
            // Column might have been removed
            // see https://github.com/mui/mui-x/pull/16888
            if (column?.valueSetter) rowUpdate = column.valueSetter(fieldProps.value, rowUpdate, column, apiRef);
            else rowUpdate[field] = fieldProps.value;
        });
        return rowUpdate;
    }, [
        apiRef
    ]);
    const editingApi = {
        getRowMode: getRowMode,
        startRowEditMode: startRowEditMode,
        stopRowEditMode: stopRowEditMode
    };
    const editingPrivateApi = {
        setRowEditingEditCellValue: setRowEditingEditCellValue,
        getRowWithUpdatedValuesFromRowEditing: getRowWithUpdatedValuesFromRowEditing
    };
    (0, $d79b1aa4f5237e85$exports.useGridApiMethod)(apiRef, editingApi, 'public');
    (0, $d79b1aa4f5237e85$exports.useGridApiMethod)(apiRef, editingPrivateApi, 'private');
    $c726e745e154c244$var$React.useEffect(()=>{
        if (rowModesModelProp) updateRowModesModel(rowModesModelProp);
    }, [
        rowModesModelProp,
        updateRowModesModel
    ]);
    // Run this effect synchronously so that the keyboard event can impact the yet-to-be-rendered input.
    (0, $c726e745e154c244$var$_useEnhancedEffect.default)(()=>{
        const rowsLookup = (0, $befccaa56b49492d$exports.gridRowsLookupSelector)(apiRef);
        // Update the ref here because updateStateToStopRowEditMode may change it later
        const copyOfPrevRowModesModel = prevRowModesModel.current;
        prevRowModesModel.current = (0, $fe919794eb3b24e8$exports.deepClone)(rowModesModel); // Do a deep-clone because the attributes might be changed later
        const ids = new Set([
            ...Object.keys(rowModesModel),
            ...Object.keys(copyOfPrevRowModesModel)
        ]);
        Array.from(ids).forEach((id)=>{
            const params = rowModesModel[id] ?? {
                mode: $e139707caeafbfd6$exports.GridRowModes.View
            };
            const prevMode = copyOfPrevRowModesModel[id]?.mode || $e139707caeafbfd6$exports.GridRowModes.View;
            const originalId = rowsLookup[id] ? apiRef.current.getRowId(rowsLookup[id]) : id;
            if (params.mode === $e139707caeafbfd6$exports.GridRowModes.Edit && prevMode === $e139707caeafbfd6$exports.GridRowModes.View) updateStateToStartRowEditMode((0, $c726e745e154c244$var$_extends2.default)({
                id: originalId
            }, params));
            else if (params.mode === $e139707caeafbfd6$exports.GridRowModes.View && prevMode === $e139707caeafbfd6$exports.GridRowModes.Edit) updateStateToStopRowEditMode((0, $c726e745e154c244$var$_extends2.default)({
                id: originalId
            }, params));
        });
    }, [
        apiRef,
        rowModesModel,
        updateStateToStartRowEditMode,
        updateStateToStopRowEditMode
    ]);
};
$c726e745e154c244$exports.useGridRowEditing = $c726e745e154c244$var$useGridRowEditing;



const $b93545fe9a3b3245$var$editingStateInitializer = (state)=>(0, $b93545fe9a3b3245$var$_extends2.default)({}, state, {
        editRows: {}
    });
$b93545fe9a3b3245$exports.editingStateInitializer = $b93545fe9a3b3245$var$editingStateInitializer;
const $b93545fe9a3b3245$var$useGridEditing = (apiRef, props, configuration)=>{
    (0, $28b053c97cee4bd6$exports.useGridCellEditing)(apiRef, props);
    (0, $c726e745e154c244$exports.useGridRowEditing)(apiRef, props);
    const debounceMap = $b93545fe9a3b3245$var$React.useRef({});
    const { isCellEditable: isCellEditableProp } = props;
    const isCellEditableFn = configuration.hooks.useIsCellEditable(apiRef, props);
    const isCellEditable = $b93545fe9a3b3245$var$React.useCallback((params)=>{
        if (!isCellEditableFn(params)) return false;
        if (!params.colDef.editable) return false;
        if (!params.colDef.renderEditCell) return false;
        if (isCellEditableProp) return isCellEditableProp(params);
        return true;
    }, [
        isCellEditableProp,
        isCellEditableFn
    ]);
    const maybeDebounce = (id, field, debounceMs, callback)=>{
        if (!debounceMs) {
            callback();
            return;
        }
        if (!debounceMap.current[id]) debounceMap.current[id] = {};
        if (debounceMap.current[id][field]) {
            const [timeout] = debounceMap.current[id][field];
            clearTimeout(timeout);
        }
        // To run the callback immediately without waiting the timeout
        const runImmediately = ()=>{
            const [timeout] = debounceMap.current[id][field];
            clearTimeout(timeout);
            callback();
            delete debounceMap.current[id][field];
        };
        const timeout = setTimeout(()=>{
            callback();
            delete debounceMap.current[id][field];
        }, debounceMs);
        debounceMap.current[id][field] = [
            timeout,
            runImmediately
        ];
    };
    $b93545fe9a3b3245$var$React.useEffect(()=>{
        const debounces = debounceMap.current;
        return ()=>{
            Object.entries(debounces).forEach(([id, fields])=>{
                Object.keys(fields).forEach((field)=>{
                    const [timeout] = debounces[id][field];
                    clearTimeout(timeout);
                    delete debounces[id][field];
                });
            });
        };
    }, []);
    const runPendingEditCellValueMutation = $b93545fe9a3b3245$var$React.useCallback((id, field)=>{
        if (!debounceMap.current[id]) return;
        if (!field) Object.keys(debounceMap.current[id]).forEach((debouncedField)=>{
            const [, runCallback] = debounceMap.current[id][debouncedField];
            runCallback();
        });
        else if (debounceMap.current[id][field]) {
            const [, runCallback] = debounceMap.current[id][field];
            runCallback();
        }
    }, []);
    const setEditCellValue = $b93545fe9a3b3245$var$React.useCallback((params)=>{
        const { id: id, field: field, debounceMs: debounceMs } = params;
        return new Promise((resolve)=>{
            maybeDebounce(id, field, debounceMs, async ()=>{
                const setEditCellValueToCall = props.editMode === $e139707caeafbfd6$exports.GridEditModes.Row ? apiRef.current.setRowEditingEditCellValue : apiRef.current.setCellEditingEditCellValue;
                // Check if the cell is in edit mode
                // By the time this callback runs the user may have cancelled the editing
                if (apiRef.current.getCellMode(id, field) === $e139707caeafbfd6$exports.GridCellModes.Edit) {
                    const result = await setEditCellValueToCall(params);
                    resolve(result);
                }
            });
        });
    }, [
        apiRef,
        props.editMode
    ]);
    const getRowWithUpdatedValues = $b93545fe9a3b3245$var$React.useCallback((id, field)=>{
        return props.editMode === $e139707caeafbfd6$exports.GridEditModes.Cell ? apiRef.current.getRowWithUpdatedValuesFromCellEditing(id, field) : apiRef.current.getRowWithUpdatedValuesFromRowEditing(id);
    }, [
        apiRef,
        props.editMode
    ]);
    const getEditCellMeta = $b93545fe9a3b3245$var$React.useCallback((id, field)=>{
        const editingState = (0, $443dd6b911893b50$exports.gridEditRowsStateSelector)(apiRef);
        return editingState[id]?.[field] ?? null;
    }, [
        apiRef
    ]);
    const editingSharedApi = {
        isCellEditable: isCellEditable,
        setEditCellValue: setEditCellValue,
        getRowWithUpdatedValues: getRowWithUpdatedValues,
        unstable_getEditCellMeta: getEditCellMeta
    };
    const editingSharedPrivateApi = {
        runPendingEditCellValueMutation: runPendingEditCellValueMutation
    };
    (0, $d79b1aa4f5237e85$exports.useGridApiMethod)(apiRef, editingSharedApi, 'public');
    (0, $d79b1aa4f5237e85$exports.useGridApiMethod)(apiRef, editingSharedPrivateApi, 'private');
};
$b93545fe9a3b3245$exports.useGridEditing = $b93545fe9a3b3245$var$useGridEditing;


var $206058c259ba36a5$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $206058c259ba36a5$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $206058c259ba36a5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($206058c259ba36a5$exports, "__esModule", {
    value: true
});
$206058c259ba36a5$exports.useGridRows = $206058c259ba36a5$exports.rowsStateInitializer = void 0;

var $206058c259ba36a5$var$_extends2 = $206058c259ba36a5$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $206058c259ba36a5$var$React = $206058c259ba36a5$require$_interopRequireWildcard((parcelRequire("acw62")));

var $206058c259ba36a5$var$_useLazyRef = $206058c259ba36a5$require$_interopRequireDefault((parcelRequire("doV3C")));















const $206058c259ba36a5$var$rowsStateInitializer = (state, props, apiRef)=>{
    const isDataSourceAvailable = !!props.dataSource;
    apiRef.current.caches.rows = (0, $0166dd44615cae0d$exports.createRowsInternalCache)({
        rows: isDataSourceAvailable ? [] : props.rows,
        getRowId: props.getRowId,
        loading: props.loading,
        rowCount: props.rowCount
    });
    return (0, $206058c259ba36a5$var$_extends2.default)({}, state, {
        rows: (0, $0166dd44615cae0d$exports.getRowsStateFromCache)({
            apiRef: apiRef,
            rowCountProp: props.rowCount,
            loadingProp: isDataSourceAvailable ? true : props.loading,
            previousTree: null,
            previousTreeDepths: null
        })
    });
};
$206058c259ba36a5$exports.rowsStateInitializer = $206058c259ba36a5$var$rowsStateInitializer;
const $206058c259ba36a5$var$useGridRows = (apiRef, props, configuration)=>{
    try {
        // Freeze the `rows` prop so developers have a fast failure if they try to use Array.prototype.push().
        Object.freeze(props.rows);
    } catch (error) {
    // Sometimes, it's impossible to freeze, so we give up on it.
    }
    const logger = (0, $fa53bf7350a63511$exports.useGridLogger)(apiRef, 'useGridRows');
    const lastUpdateMs = $206058c259ba36a5$var$React.useRef(Date.now());
    const lastRowCount = $206058c259ba36a5$var$React.useRef(props.rowCount);
    const timeout = (0, $3ede1456da2c476e$exports.useTimeout)();
    // Get overridable methods from configuration
    const { setRowIndex: setRowIndex, setRowPosition: setRowPosition } = configuration.hooks.useGridRowsOverridableMethods(apiRef, props);
    const getRow = $206058c259ba36a5$var$React.useCallback((id)=>{
        const model = (0, $befccaa56b49492d$exports.gridRowsLookupSelector)(apiRef)[id];
        if (model) return model;
        const node = (0, $befccaa56b49492d$exports.gridRowNodeSelector)(apiRef, id);
        if (node && (0, $0166dd44615cae0d$exports.isAutogeneratedRowNode)(node)) return {
            [$0166dd44615cae0d$exports.GRID_ID_AUTOGENERATED]: id
        };
        return null;
    }, [
        apiRef
    ]);
    const getRowId = $206058c259ba36a5$var$React.useCallback((row)=>(0, $0d26ce0880758663$exports.gridRowIdSelector)(apiRef, row), [
        apiRef
    ]);
    const throttledRowsChange = $206058c259ba36a5$var$React.useCallback(({ cache: cache, throttle: throttle })=>{
        const run = ()=>{
            lastUpdateMs.current = Date.now();
            apiRef.current.setState((state)=>(0, $206058c259ba36a5$var$_extends2.default)({}, state, {
                    rows: (0, $0166dd44615cae0d$exports.getRowsStateFromCache)({
                        apiRef: apiRef,
                        rowCountProp: props.rowCount,
                        loadingProp: props.loading,
                        previousTree: (0, $befccaa56b49492d$exports.gridRowTreeSelector)(apiRef),
                        previousTreeDepths: (0, $befccaa56b49492d$exports.gridRowTreeDepthsSelector)(apiRef),
                        previousGroupsToFetch: (0, $befccaa56b49492d$exports.gridRowGroupsToFetchSelector)(apiRef)
                    })
                }));
            apiRef.current.publishEvent('rowsSet');
        };
        timeout.clear();
        apiRef.current.caches.rows = cache;
        if (!throttle) {
            run();
            return;
        }
        const throttleRemainingTimeMs = props.throttleRowsMs - (Date.now() - lastUpdateMs.current);
        if (throttleRemainingTimeMs > 0) {
            timeout.start(throttleRemainingTimeMs, run);
            return;
        }
        run();
    }, [
        props.throttleRowsMs,
        props.rowCount,
        props.loading,
        apiRef,
        timeout
    ]);
    /**
   * API METHODS
   */ const setRows = $206058c259ba36a5$var$React.useCallback((rows)=>{
        logger.debug(`Updating all rows, new length ${rows.length}`);
        if (!props.dataSource && (0, $2d9bb9ae74999313$exports.gridPivotActiveSelector)(apiRef)) {
            apiRef.current.updateNonPivotRows(rows, false);
            return;
        }
        const cache = (0, $0166dd44615cae0d$exports.createRowsInternalCache)({
            rows: rows,
            getRowId: props.getRowId,
            loading: props.loading,
            rowCount: props.rowCount
        });
        const prevCache = apiRef.current.caches.rows;
        cache.rowsBeforePartialUpdates = prevCache.rowsBeforePartialUpdates;
        throttledRowsChange({
            cache: cache,
            throttle: true
        });
    }, [
        logger,
        props.getRowId,
        props.dataSource,
        props.loading,
        props.rowCount,
        throttledRowsChange,
        apiRef
    ]);
    const updateRows = $206058c259ba36a5$var$React.useCallback((updates)=>{
        if (props.signature === $dc886d040ec4e87c$exports.GridSignature.DataGrid && updates.length > 1) throw new Error([
            'MUI X: You cannot update several rows at once in `apiRef.current.updateRows` on the DataGrid.',
            'You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature.'
        ].join('\n'));
        if (!props.dataSource && (0, $2d9bb9ae74999313$exports.gridPivotActiveSelector)(apiRef)) {
            apiRef.current.updateNonPivotRows(updates);
            return;
        }
        const nonPinnedRowsUpdates = (0, $0166dd44615cae0d$exports.computeRowsUpdates)(apiRef, updates, props.getRowId);
        const cache = (0, $0166dd44615cae0d$exports.updateCacheWithNewRows)({
            updates: nonPinnedRowsUpdates,
            getRowId: props.getRowId,
            previousCache: apiRef.current.caches.rows
        });
        throttledRowsChange({
            cache: cache,
            throttle: true
        });
    }, [
        props.signature,
        props.dataSource,
        props.getRowId,
        throttledRowsChange,
        apiRef
    ]);
    const updateNestedRows = $206058c259ba36a5$var$React.useCallback((updates, groupKeys)=>{
        const nonPinnedRowsUpdates = (0, $0166dd44615cae0d$exports.computeRowsUpdates)(apiRef, updates, props.getRowId);
        const cache = (0, $0166dd44615cae0d$exports.updateCacheWithNewRows)({
            updates: nonPinnedRowsUpdates,
            getRowId: props.getRowId,
            previousCache: apiRef.current.caches.rows,
            groupKeys: groupKeys ?? []
        });
        throttledRowsChange({
            cache: cache,
            throttle: false
        });
    }, [
        props.getRowId,
        throttledRowsChange,
        apiRef
    ]);
    const setLoading = $206058c259ba36a5$var$React.useCallback((loading)=>{
        logger.debug(`Setting loading to ${loading}`);
        apiRef.current.setState((state)=>(0, $206058c259ba36a5$var$_extends2.default)({}, state, {
                rows: (0, $206058c259ba36a5$var$_extends2.default)({}, state.rows, {
                    loading: loading
                })
            }));
        apiRef.current.caches.rows.loadingPropBeforePartialUpdates = loading;
    }, [
        apiRef,
        logger
    ]);
    const getRowModels = $206058c259ba36a5$var$React.useCallback(()=>{
        const dataRows = (0, $befccaa56b49492d$exports.gridDataRowIdsSelector)(apiRef);
        const idRowsLookup = (0, $befccaa56b49492d$exports.gridRowsLookupSelector)(apiRef);
        return new Map(dataRows.map((id)=>[
                id,
                idRowsLookup[id] ?? {}
            ]));
    }, [
        apiRef
    ]);
    const getRowsCount = $206058c259ba36a5$var$React.useCallback(()=>(0, $befccaa56b49492d$exports.gridRowCountSelector)(apiRef), [
        apiRef
    ]);
    const getAllRowIds = $206058c259ba36a5$var$React.useCallback(()=>(0, $befccaa56b49492d$exports.gridDataRowIdsSelector)(apiRef), [
        apiRef
    ]);
    const getRowIndexRelativeToVisibleRows = $206058c259ba36a5$var$React.useCallback((id)=>{
        const { rowIdToIndexMap: rowIdToIndexMap } = (0, $7d0a5941a1add073$exports.getVisibleRows)(apiRef);
        return rowIdToIndexMap.get(id);
    }, [
        apiRef
    ]);
    const setRowChildrenExpansion = $206058c259ba36a5$var$React.useCallback((id, isExpanded)=>{
        const currentNode = (0, $befccaa56b49492d$exports.gridRowNodeSelector)(apiRef, id);
        if (!currentNode) throw new Error(`MUI X: No row with id #${id} found.`);
        if (currentNode.type !== 'group') throw new Error('MUI X: Only group nodes can be expanded or collapsed.');
        const newNode = (0, $206058c259ba36a5$var$_extends2.default)({}, currentNode, {
            childrenExpanded: isExpanded
        });
        apiRef.current.setState((state)=>{
            return (0, $206058c259ba36a5$var$_extends2.default)({}, state, {
                rows: (0, $206058c259ba36a5$var$_extends2.default)({}, state.rows, {
                    tree: (0, $206058c259ba36a5$var$_extends2.default)({}, state.rows.tree, {
                        [id]: newNode
                    })
                })
            });
        });
        apiRef.current.publishEvent('rowExpansionChange', newNode);
    }, [
        apiRef
    ]);
    const expandAllRows = $206058c259ba36a5$var$React.useCallback(()=>{
        const tree = (0, $206058c259ba36a5$var$_extends2.default)({}, (0, $befccaa56b49492d$exports.gridRowTreeSelector)(apiRef));
        const traverse = (nodeId)=>{
            const node = tree[nodeId];
            if (node?.type === 'group') {
                tree[nodeId] = (0, $206058c259ba36a5$var$_extends2.default)({}, node, {
                    childrenExpanded: true
                });
                node.children.forEach(traverse);
            }
        };
        traverse($0166dd44615cae0d$exports.GRID_ROOT_GROUP_ID);
        apiRef.current.setState((state)=>(0, $206058c259ba36a5$var$_extends2.default)({}, state, {
                rows: (0, $206058c259ba36a5$var$_extends2.default)({}, state.rows, {
                    tree: tree
                })
            }));
        apiRef.current.publishEvent('rowExpansionChange', tree[$0166dd44615cae0d$exports.GRID_ROOT_GROUP_ID]);
    }, [
        apiRef
    ]);
    const collapseAllRows = $206058c259ba36a5$var$React.useCallback(()=>{
        const tree = (0, $206058c259ba36a5$var$_extends2.default)({}, (0, $befccaa56b49492d$exports.gridRowTreeSelector)(apiRef));
        const traverse = (nodeId)=>{
            const node = tree[nodeId];
            if (node?.type === 'group') {
                tree[nodeId] = (0, $206058c259ba36a5$var$_extends2.default)({}, node, {
                    childrenExpanded: false
                });
                node.children.forEach(traverse);
            }
        };
        traverse($0166dd44615cae0d$exports.GRID_ROOT_GROUP_ID);
        apiRef.current.setState((state)=>(0, $206058c259ba36a5$var$_extends2.default)({}, state, {
                rows: (0, $206058c259ba36a5$var$_extends2.default)({}, state.rows, {
                    tree: tree
                })
            }));
        apiRef.current.publishEvent('rowExpansionChange', tree[$0166dd44615cae0d$exports.GRID_ROOT_GROUP_ID]);
    }, [
        apiRef
    ]);
    const getRowNode = $206058c259ba36a5$var$React.useCallback((id)=>(0, $befccaa56b49492d$exports.gridRowNodeSelector)(apiRef, id) ?? null, [
        apiRef
    ]);
    const getRowGroupChildren = $206058c259ba36a5$var$React.useCallback(({ skipAutoGeneratedRows: skipAutoGeneratedRows = true, groupId: groupId, applySorting: applySorting, applyFiltering: applyFiltering, directChildrenOnly: directChildrenOnly = false })=>{
        const tree = (0, $befccaa56b49492d$exports.gridRowTreeSelector)(apiRef);
        let children;
        if (applySorting) {
            const groupNode = tree[groupId];
            if (!groupNode) return [];
            const sortedRowIds = (0, $dc3028b3b629fae7$exports.gridSortedRowIdsSelector)(apiRef);
            children = [];
            const startIndex = sortedRowIds.findIndex((id)=>id === groupId) + 1;
            for(let index = startIndex; index < sortedRowIds.length && (directChildrenOnly ? tree[sortedRowIds[index]].depth === groupNode.depth + 1 : tree[sortedRowIds[index]].depth > groupNode.depth); index += 1){
                const id = sortedRowIds[index];
                if (!skipAutoGeneratedRows || !(0, $0166dd44615cae0d$exports.isAutogeneratedRowNode)(tree[id])) children.push(id);
            }
        } else children = (0, $0166dd44615cae0d$exports.getTreeNodeDescendants)(tree, groupId, skipAutoGeneratedRows, directChildrenOnly);
        if (applyFiltering) {
            const filteredRowsLookup = (0, $e95988b653de2e96$exports.gridFilteredRowsLookupSelector)(apiRef);
            children = (0, $57908709a849d718$exports.isObjectEmpty)(filteredRowsLookup) ? children : children.filter((childId)=>filteredRowsLookup[childId] !== false);
        }
        return children;
    }, [
        apiRef
    ]);
    const replaceRows = $206058c259ba36a5$var$React.useCallback((firstRowToRender, newRows)=>{
        if (props.signature === $dc886d040ec4e87c$exports.GridSignature.DataGrid && newRows.length > 1) throw new Error([
            'MUI X: You cannot replace rows using `apiRef.current.unstable_replaceRows` on the DataGrid.',
            'You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature.'
        ].join('\n'));
        if (newRows.length === 0) return;
        const treeDepth = (0, $befccaa56b49492d$exports.gridRowMaximumTreeDepthSelector)(apiRef);
        if (treeDepth > 1) throw new Error('`apiRef.current.unstable_replaceRows` is not compatible with tree data and row grouping');
        const tree = (0, $206058c259ba36a5$var$_extends2.default)({}, (0, $befccaa56b49492d$exports.gridRowTreeSelector)(apiRef));
        const dataRowIdToModelLookup = (0, $206058c259ba36a5$var$_extends2.default)({}, (0, $befccaa56b49492d$exports.gridRowsLookupSelector)(apiRef));
        const rootGroup = tree[$0166dd44615cae0d$exports.GRID_ROOT_GROUP_ID];
        const rootGroupChildren = [
            ...rootGroup.children
        ];
        const seenIds = new Set();
        for(let i = 0; i < newRows.length; i += 1){
            const rowModel = newRows[i];
            const rowId = (0, $0166dd44615cae0d$exports.getRowIdFromRowModel)(rowModel, props.getRowId, 'A row was provided without id when calling replaceRows().');
            const [removedRowId] = rootGroupChildren.splice(firstRowToRender + i, 1, rowId);
            if (!seenIds.has(removedRowId)) {
                delete dataRowIdToModelLookup[removedRowId];
                delete tree[removedRowId];
            }
            const rowTreeNodeConfig = {
                id: rowId,
                depth: 0,
                parent: $0166dd44615cae0d$exports.GRID_ROOT_GROUP_ID,
                type: 'leaf',
                groupingKey: null
            };
            dataRowIdToModelLookup[rowId] = rowModel;
            tree[rowId] = rowTreeNodeConfig;
            seenIds.add(rowId);
        }
        tree[$0166dd44615cae0d$exports.GRID_ROOT_GROUP_ID] = (0, $206058c259ba36a5$var$_extends2.default)({}, rootGroup, {
            children: rootGroupChildren
        });
        // Removes potential remaining skeleton rows from the dataRowIds.
        const dataRowIds = rootGroupChildren.filter((childId)=>tree[childId]?.type === 'leaf');
        apiRef.current.caches.rows.dataRowIdToModelLookup = dataRowIdToModelLookup;
        apiRef.current.setState((state)=>(0, $206058c259ba36a5$var$_extends2.default)({}, state, {
                rows: (0, $206058c259ba36a5$var$_extends2.default)({}, state.rows, {
                    loading: props.loading,
                    totalRowCount: Math.max(props.rowCount || 0, rootGroupChildren.length),
                    dataRowIdToModelLookup: dataRowIdToModelLookup,
                    dataRowIds: dataRowIds,
                    tree: tree
                })
            }));
        apiRef.current.publishEvent('rowsSet');
    }, [
        apiRef,
        props.signature,
        props.getRowId,
        props.loading,
        props.rowCount
    ]);
    const rowApi = {
        getRow: getRow,
        setLoading: setLoading,
        getRowId: getRowId,
        getRowModels: getRowModels,
        getRowsCount: getRowsCount,
        getAllRowIds: getAllRowIds,
        setRows: setRows,
        updateRows: updateRows,
        getRowNode: getRowNode,
        getRowIndexRelativeToVisibleRows: getRowIndexRelativeToVisibleRows,
        unstable_replaceRows: replaceRows
    };
    const rowProApi = {
        setRowIndex: setRowIndex,
        setRowPosition: setRowPosition,
        setRowChildrenExpansion: setRowChildrenExpansion,
        getRowGroupChildren: getRowGroupChildren,
        expandAllRows: expandAllRows,
        collapseAllRows: collapseAllRows
    };
    const rowProPrivateApi = {
        updateNestedRows: updateNestedRows
    };
    /**
   * EVENTS
   */ const groupRows = $206058c259ba36a5$var$React.useCallback(()=>{
        logger.info(`Row grouping pre-processing have changed, regenerating the row tree`);
        let cache;
        if (apiRef.current.caches.rows.rowsBeforePartialUpdates === props.rows) // The `props.rows` did not change since the last row grouping
        // We can use the current rows cache which contains the partial updates done recently.
        cache = (0, $206058c259ba36a5$var$_extends2.default)({}, apiRef.current.caches.rows, {
            updates: {
                type: 'full',
                rows: (0, $befccaa56b49492d$exports.gridDataRowIdsSelector)(apiRef)
            }
        });
        else // The `props.rows` has changed since the last row grouping
        // We must use the new `props.rows` on the new grouping
        // This occurs because this event is triggered before the `useEffect` on the rows when both the grouping pre-processing and the rows changes on the same render
        cache = (0, $0166dd44615cae0d$exports.createRowsInternalCache)({
            rows: props.rows,
            getRowId: props.getRowId,
            loading: props.loading,
            rowCount: props.rowCount
        });
        throttledRowsChange({
            cache: cache,
            throttle: false
        });
    }, [
        logger,
        apiRef,
        props.rows,
        props.getRowId,
        props.loading,
        props.rowCount,
        throttledRowsChange
    ]);
    const previousDataSource = (0, $206058c259ba36a5$var$_useLazyRef.default)(()=>props.dataSource);
    const handleStrategyProcessorChange = $206058c259ba36a5$var$React.useCallback((methodName)=>{
        if (props.dataSource && props.dataSource !== previousDataSource.current) {
            previousDataSource.current = props.dataSource;
            return;
        }
        if (methodName === 'rowTreeCreation') groupRows();
    }, [
        groupRows,
        previousDataSource,
        props.dataSource
    ]);
    const handleStrategyActivityChange = $206058c259ba36a5$var$React.useCallback(()=>{
        // `rowTreeCreation` is the only processor ran when `strategyAvailabilityChange` is fired.
        // All the other processors listen to `rowsSet` which will be published by the `groupRows` method below.
        if (apiRef.current.getActiveStrategy($41d629b2793a9305$exports.GridStrategyGroup.RowTree) !== (0, $befccaa56b49492d$exports.gridRowGroupingNameSelector)(apiRef)) groupRows();
    }, [
        apiRef,
        groupRows
    ]);
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'activeStrategyProcessorChange', handleStrategyProcessorChange);
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'strategyAvailabilityChange', handleStrategyActivityChange);
    /**
   * APPLIERS
   */ const applyHydrateRowsProcessor = $206058c259ba36a5$var$React.useCallback(()=>{
        apiRef.current.setState((state)=>{
            const response = apiRef.current.unstable_applyPipeProcessors('hydrateRows', {
                tree: (0, $befccaa56b49492d$exports.gridRowTreeSelector)(apiRef),
                treeDepths: (0, $befccaa56b49492d$exports.gridRowTreeDepthsSelector)(apiRef),
                dataRowIds: (0, $befccaa56b49492d$exports.gridDataRowIdsSelector)(apiRef),
                dataRowIdToModelLookup: (0, $befccaa56b49492d$exports.gridRowsLookupSelector)(apiRef)
            });
            return (0, $206058c259ba36a5$var$_extends2.default)({}, state, {
                rows: (0, $206058c259ba36a5$var$_extends2.default)({}, state.rows, response, {
                    totalTopLevelRowCount: (0, $0166dd44615cae0d$exports.getTopLevelRowCount)({
                        tree: response.tree,
                        rowCountProp: props.rowCount
                    })
                })
            });
        });
        apiRef.current.publishEvent('rowsSet');
    }, [
        apiRef,
        props.rowCount
    ]);
    (0, $1aa692cb9e262bac$exports.useGridRegisterPipeApplier)(apiRef, 'hydrateRows', applyHydrateRowsProcessor);
    (0, $d79b1aa4f5237e85$exports.useGridApiMethod)(apiRef, rowApi, 'public');
    (0, $d79b1aa4f5237e85$exports.useGridApiMethod)(apiRef, rowProApi, props.signature === $dc886d040ec4e87c$exports.GridSignature.DataGrid ? 'private' : 'public');
    (0, $d79b1aa4f5237e85$exports.useGridApiMethod)(apiRef, rowProPrivateApi, 'private');
    // The effect do not track any value defined synchronously during the 1st render by hooks called after `useGridRows`
    // As a consequence, the state generated by the 1st run of this useEffect will always be equal to the initialization one
    const isFirstRender = $206058c259ba36a5$var$React.useRef(true);
    $206058c259ba36a5$var$React.useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        let isRowCountPropUpdated = false;
        if (props.rowCount !== lastRowCount.current) {
            isRowCountPropUpdated = true;
            lastRowCount.current = props.rowCount;
        }
        const currentRows = props.dataSource ? (0, $befccaa56b49492d$exports.gridDataRowsSelector)(apiRef) : props.rows;
        const areNewRowsAlreadyInState = apiRef.current.caches.rows.rowsBeforePartialUpdates === currentRows;
        const isNewLoadingAlreadyInState = apiRef.current.caches.rows.loadingPropBeforePartialUpdates === props.loading;
        const isNewRowCountAlreadyInState = apiRef.current.caches.rows.rowCountPropBeforePartialUpdates === props.rowCount;
        // The new rows have already been applied (most likely in the `'rowGroupsPreProcessingChange'` listener)
        if (areNewRowsAlreadyInState) {
            // If the loading prop has changed, we need to update its value in the state because it won't be done by `throttledRowsChange`
            if (!isNewLoadingAlreadyInState) {
                apiRef.current.setState((state)=>(0, $206058c259ba36a5$var$_extends2.default)({}, state, {
                        rows: (0, $206058c259ba36a5$var$_extends2.default)({}, state.rows, {
                            loading: props.loading
                        })
                    }));
                apiRef.current.caches.rows.loadingPropBeforePartialUpdates = props.loading;
            }
            if (!isNewRowCountAlreadyInState) {
                apiRef.current.setState((state)=>(0, $206058c259ba36a5$var$_extends2.default)({}, state, {
                        rows: (0, $206058c259ba36a5$var$_extends2.default)({}, state.rows, {
                            totalRowCount: Math.max(props.rowCount || 0, state.rows.totalRowCount),
                            totalTopLevelRowCount: Math.max(props.rowCount || 0, state.rows.totalTopLevelRowCount)
                        })
                    }));
                apiRef.current.caches.rows.rowCountPropBeforePartialUpdates = props.rowCount;
            }
            if (!isRowCountPropUpdated) return;
        }
        logger.debug(`Updating all rows, new length ${currentRows?.length}`);
        throttledRowsChange({
            cache: (0, $0166dd44615cae0d$exports.createRowsInternalCache)({
                rows: currentRows,
                getRowId: props.getRowId,
                loading: props.loading,
                rowCount: props.rowCount
            }),
            throttle: false
        });
    }, [
        props.rows,
        props.rowCount,
        props.getRowId,
        props.loading,
        props.dataSource,
        logger,
        throttledRowsChange,
        apiRef
    ]);
};
$206058c259ba36a5$exports.useGridRows = $206058c259ba36a5$var$useGridRows;


var $3e4389cda192db48$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3e4389cda192db48$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($3e4389cda192db48$exports, "__esModule", {
    value: true
});
$3e4389cda192db48$exports.useGridRowsPreProcessors = void 0;

var $3e4389cda192db48$var$_extends2 = $3e4389cda192db48$require$_interopRequireDefault((parcelRequire("3p9rK")));


const $3e4389cda192db48$var$createFlatRowTree = (rows)=>{
    const tree = {
        [$0166dd44615cae0d$exports.GRID_ROOT_GROUP_ID]: (0, $3e4389cda192db48$var$_extends2.default)({}, (0, $0166dd44615cae0d$exports.buildRootGroup)(), {
            children: rows
        })
    };
    for(let i = 0; i < rows.length; i += 1){
        const rowId = rows[i];
        tree[rowId] = {
            id: rowId,
            depth: 0,
            parent: $0166dd44615cae0d$exports.GRID_ROOT_GROUP_ID,
            type: 'leaf',
            groupingKey: null
        };
    }
    return {
        groupingName: $41d629b2793a9305$exports.GRID_DEFAULT_STRATEGY,
        tree: tree,
        treeDepths: {
            0: rows.length
        },
        dataRowIds: rows
    };
};
const $3e4389cda192db48$var$updateFlatRowTree = ({ previousTree: previousTree, actions: actions })=>{
    const tree = (0, $3e4389cda192db48$var$_extends2.default)({}, previousTree);
    const idsToRemoveFromRootGroup = {};
    for(let i = 0; i < actions.remove.length; i += 1){
        const idToDelete = actions.remove[i];
        idsToRemoveFromRootGroup[idToDelete] = true;
        delete tree[idToDelete];
    }
    for(let i = 0; i < actions.insert.length; i += 1){
        const idToInsert = actions.insert[i];
        tree[idToInsert] = {
            id: idToInsert,
            depth: 0,
            parent: $0166dd44615cae0d$exports.GRID_ROOT_GROUP_ID,
            type: 'leaf',
            groupingKey: null
        };
    }
    // TODO rows v6: Support row unpinning
    const rootGroup = tree[$0166dd44615cae0d$exports.GRID_ROOT_GROUP_ID];
    let rootGroupChildren = [
        ...rootGroup.children,
        ...actions.insert
    ];
    if (Object.values(idsToRemoveFromRootGroup).length) rootGroupChildren = rootGroupChildren.filter((id)=>!idsToRemoveFromRootGroup[id]);
    tree[$0166dd44615cae0d$exports.GRID_ROOT_GROUP_ID] = (0, $3e4389cda192db48$var$_extends2.default)({}, rootGroup, {
        children: rootGroupChildren
    });
    return {
        groupingName: $41d629b2793a9305$exports.GRID_DEFAULT_STRATEGY,
        tree: tree,
        treeDepths: {
            0: rootGroupChildren.length
        },
        dataRowIds: rootGroupChildren
    };
};
const $3e4389cda192db48$var$flatRowTreeCreationMethod = (params)=>{
    if (params.updates.type === 'full') return $3e4389cda192db48$var$createFlatRowTree(params.updates.rows);
    return $3e4389cda192db48$var$updateFlatRowTree({
        previousTree: params.previousTree,
        actions: params.updates.actions
    });
};
const $3e4389cda192db48$var$useGridRowsPreProcessors = (apiRef)=>{
    (0, $41d629b2793a9305$exports.useGridRegisterStrategyProcessor)(apiRef, $41d629b2793a9305$exports.GRID_DEFAULT_STRATEGY, 'rowTreeCreation', $3e4389cda192db48$var$flatRowTreeCreationMethod);
};
$3e4389cda192db48$exports.useGridRowsPreProcessors = $3e4389cda192db48$var$useGridRowsPreProcessors;


var $4a9b8ce6e6853f0a$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $4a9b8ce6e6853f0a$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($4a9b8ce6e6853f0a$exports, "__esModule", {
    value: true
});
$4a9b8ce6e6853f0a$exports.MissingRowIdError = void 0;
$4a9b8ce6e6853f0a$exports.useGridParamsApi = $4a9b8ce6e6853f0a$var$useGridParamsApi;

var $4a9b8ce6e6853f0a$var$React = $4a9b8ce6e6853f0a$require$_interopRequireWildcard((parcelRequire("acw62")));





class $4a9b8ce6e6853f0a$var$MissingRowIdError extends Error {
}
/**
 * @requires useGridColumns (method)
 * @requires useGridRows (method)
 * @requires useGridFocus (state)
 * @requires useGridEditing (method)
 * TODO: Impossible priority - useGridEditing also needs to be after useGridParamsApi
 * TODO: Impossible priority - useGridFocus also needs to be after useGridParamsApi
 */ $4a9b8ce6e6853f0a$exports.MissingRowIdError = $4a9b8ce6e6853f0a$var$MissingRowIdError;
function $4a9b8ce6e6853f0a$var$useGridParamsApi(apiRef, props, configuration) {
    const getColumnHeaderParams = $4a9b8ce6e6853f0a$var$React.useCallback((field)=>({
            field: field,
            colDef: apiRef.current.getColumn(field)
        }), [
        apiRef
    ]);
    const getRowParams = $4a9b8ce6e6853f0a$var$React.useCallback((id)=>{
        const row = apiRef.current.getRow(id);
        if (!row) throw new $4a9b8ce6e6853f0a$var$MissingRowIdError(`No row with id #${id} found`);
        const params = {
            id: id,
            columns: apiRef.current.getAllColumns(),
            row: row
        };
        return params;
    }, [
        apiRef
    ]);
    const getCellParamsForRow = $4a9b8ce6e6853f0a$var$React.useCallback((id, field, row, { cellMode: cellMode, colDef: colDef, hasFocus: hasFocus, rowNode: rowNode, tabIndex: tabIndex, value: forcedValue, formattedValue: forcedFormattedValue })=>{
        const value = forcedValue !== undefined ? forcedValue : apiRef.current.getRowValue(row, colDef);
        const formattedValue = forcedFormattedValue !== undefined ? forcedFormattedValue : apiRef.current.getRowFormattedValue(row, colDef);
        const params = {
            id: id,
            field: field,
            row: row,
            rowNode: rowNode,
            colDef: colDef,
            cellMode: cellMode,
            hasFocus: hasFocus,
            tabIndex: tabIndex,
            value: value,
            formattedValue: formattedValue,
            isEditable: false,
            api: apiRef.current
        };
        params.isEditable = colDef && apiRef.current.isCellEditable(params);
        return params;
    }, [
        apiRef
    ]);
    const getCellParams = $4a9b8ce6e6853f0a$var$React.useCallback((id, field)=>{
        const row = apiRef.current.getRow(id);
        const rowNode = (0, $befccaa56b49492d$exports.gridRowNodeSelector)(apiRef, id);
        if (!row || !rowNode) throw new $4a9b8ce6e6853f0a$var$MissingRowIdError(`No row with id #${id} found`);
        const cellFocus = (0, $9c9b8e89fddd633d$exports.gridFocusCellSelector)(apiRef);
        const cellTabIndex = (0, $9c9b8e89fddd633d$exports.gridTabIndexCellSelector)(apiRef);
        const cellMode = apiRef.current.getCellMode(id, field);
        return apiRef.current.getCellParamsForRow(id, field, row, {
            colDef: props.listView && props.listViewColumn?.field === field ? (0, $6432707a9c80427e$exports.gridListColumnSelector)(apiRef) : apiRef.current.getColumn(field),
            rowNode: rowNode,
            hasFocus: cellFocus !== null && cellFocus.field === field && cellFocus.id === id,
            tabIndex: cellTabIndex && cellTabIndex.field === field && cellTabIndex.id === id ? 0 : -1,
            cellMode: cellMode
        });
    }, [
        apiRef,
        props.listView,
        props.listViewColumn?.field
    ]);
    const getColumnHeaderElement = $4a9b8ce6e6853f0a$var$React.useCallback((field)=>{
        if (!apiRef.current.rootElementRef.current) return null;
        return (0, $08bb4bf24f47b880$exports.getGridColumnHeaderElement)(apiRef.current.rootElementRef.current, field);
    }, [
        apiRef
    ]);
    const getRowElement = $4a9b8ce6e6853f0a$var$React.useCallback((id)=>{
        if (!apiRef.current.rootElementRef.current) return null;
        return (0, $08bb4bf24f47b880$exports.getGridRowElement)(apiRef.current.rootElementRef.current, id);
    }, [
        apiRef
    ]);
    const getCellElement = $4a9b8ce6e6853f0a$var$React.useCallback((id, field)=>{
        if (!apiRef.current.rootElementRef.current) return null;
        return (0, $08bb4bf24f47b880$exports.getGridCellElement)(apiRef.current.rootElementRef.current, {
            id: id,
            field: field
        });
    }, [
        apiRef
    ]);
    const overridableParamsMethods = configuration.hooks.useGridParamsOverridableMethods(apiRef);
    const paramsApi = {
        getCellValue: overridableParamsMethods.getCellValue,
        getCellParams: getCellParams,
        getCellElement: getCellElement,
        getRowValue: overridableParamsMethods.getRowValue,
        getRowFormattedValue: overridableParamsMethods.getRowFormattedValue,
        getRowParams: getRowParams,
        getRowElement: getRowElement,
        getColumnHeaderParams: getColumnHeaderParams,
        getColumnHeaderElement: getColumnHeaderElement
    };
    const paramsPrivateApi = {
        getCellParamsForRow: getCellParamsForRow
    };
    (0, $d79b1aa4f5237e85$exports.useGridApiMethod)(apiRef, paramsApi, 'public');
    (0, $d79b1aa4f5237e85$exports.useGridApiMethod)(apiRef, paramsPrivateApi, 'private');
}


var $9674296b6d32bca5$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $9674296b6d32bca5$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $9674296b6d32bca5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($9674296b6d32bca5$exports, "__esModule", {
    value: true
});
$9674296b6d32bca5$exports.useGridRowSelection = $9674296b6d32bca5$exports.rowSelectionStateInitializer = void 0;

var $9674296b6d32bca5$var$_extends2 = $9674296b6d32bca5$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $9674296b6d32bca5$var$React = $9674296b6d32bca5$require$_interopRequireWildcard((parcelRequire("acw62")));

var $9674296b6d32bca5$var$_useEventCallback = $9674296b6d32bca5$require$_interopRequireDefault((parcelRequire("6Lbjo")));





var $5sOMZ = parcelRequire("5sOMZ");










var $5H1vo = parcelRequire("5H1vo");




const $9674296b6d32bca5$var$emptyModel = {
    type: 'include',
    ids: new Set()
};
const $9674296b6d32bca5$var$rowSelectionStateInitializer = (state, props)=>(0, $9674296b6d32bca5$var$_extends2.default)({}, state, {
        rowSelection: props.rowSelection ? props.rowSelectionModel ?? $9674296b6d32bca5$var$emptyModel : $9674296b6d32bca5$var$emptyModel
    });
/**
 * @requires useGridRows (state, method) - can be after
 * @requires useGridParamsApi (method) - can be after
 * @requires useGridFocus (state) - can be after
 * @requires useGridKeyboardNavigation (`cellKeyDown` event must first be consumed by it)
 */ $9674296b6d32bca5$exports.rowSelectionStateInitializer = $9674296b6d32bca5$var$rowSelectionStateInitializer;
const $9674296b6d32bca5$var$useGridRowSelection = (apiRef, props)=>{
    const logger = (0, $fa53bf7350a63511$exports.useGridLogger)(apiRef, 'useGridSelection');
    const runIfRowSelectionIsEnabled = $9674296b6d32bca5$var$React.useCallback((callback)=>(...args)=>{
            if (props.rowSelection) callback(...args);
        }, [
        props.rowSelection
    ]);
    const isNestedData = (0, $5sOMZ.useGridSelector)(apiRef, $befccaa56b49492d$exports.gridRowMaximumTreeDepthSelector) > 1;
    const applyAutoSelection = props.signature !== $dc886d040ec4e87c$exports.GridSignature.DataGrid && (props.rowSelectionPropagation?.parents || props.rowSelectionPropagation?.descendants) && isNestedData;
    const propRowSelectionModel = $9674296b6d32bca5$var$React.useMemo(()=>{
        return props.rowSelectionModel;
    }, [
        props.rowSelectionModel
    ]);
    const lastRowToggled = $9674296b6d32bca5$var$React.useRef(null);
    apiRef.current.registerControlState({
        stateId: 'rowSelection',
        propModel: propRowSelectionModel,
        propOnChange: props.onRowSelectionModelChange,
        stateSelector: $7a5249c135fd39c1$exports.gridRowSelectionStateSelector,
        changeEvent: 'rowSelectionChange'
    });
    const { checkboxSelection: checkboxSelection, disableRowSelectionOnClick: disableRowSelectionOnClick, isRowSelectable: propIsRowSelectable } = props;
    const canHaveMultipleSelection = (0, $dae18049c8685698$exports.isMultipleRowSelectionEnabled)(props);
    const expandMouseRowRangeSelection = $9674296b6d32bca5$var$React.useCallback((id)=>{
        let endId = id;
        const startId = lastRowToggled.current ?? id;
        const isSelected = apiRef.current.isRowSelected(id);
        if (isSelected) {
            const visibleRowIds = (0, $e95988b653de2e96$exports.gridExpandedSortedRowIdsSelector)(apiRef);
            const startIndex = visibleRowIds.findIndex((rowId)=>rowId === startId);
            const endIndex = visibleRowIds.findIndex((rowId)=>rowId === endId);
            if (startIndex === endIndex) return;
            if (startIndex > endIndex) endId = visibleRowIds[endIndex + 1];
            else endId = visibleRowIds[endIndex - 1];
        }
        lastRowToggled.current = id;
        apiRef.current.selectRowRange({
            startId: startId,
            endId: endId
        }, !isSelected);
    }, [
        apiRef
    ]);
    const getRowsToBeSelected = (0, $9674296b6d32bca5$var$_useEventCallback.default)(()=>{
        const rowsToBeSelected = props.pagination && props.checkboxSelectionVisibleOnly && props.paginationMode === 'client' ? (0, $809f57c9ce5163f3$exports.gridPaginatedVisibleSortedGridRowIdsSelector)(apiRef) : (0, $e95988b653de2e96$exports.gridExpandedSortedRowIdsSelector)(apiRef);
        return rowsToBeSelected;
    });
    /*
   * API METHODS
   */ const setRowSelectionModel = $9674296b6d32bca5$var$React.useCallback((model, reason)=>{
        if (props.signature === $dc886d040ec4e87c$exports.GridSignature.DataGrid && !canHaveMultipleSelection && (model.type !== 'include' || model.ids.size > 1)) throw new Error([
            'MUI X: `rowSelectionModel` can only contain 1 item in DataGrid.',
            'You need to upgrade to DataGridPro or DataGridPremium component to unlock multiple selection.'
        ].join('\n'));
        const currentModel = (0, $7a5249c135fd39c1$exports.gridRowSelectionStateSelector)(apiRef);
        if (currentModel !== model) {
            logger.debug(`Setting selection model`);
            // clear the reference to the last selected row if that row is not in the model anymore
            if (lastRowToggled.current !== null) {
                const isInModel = model.ids.has(lastRowToggled.current);
                if (model.type === 'include' && !isInModel || model.type === 'exclude' && isInModel) lastRowToggled.current = null;
            }
            apiRef.current.setState((state)=>(0, $9674296b6d32bca5$var$_extends2.default)({}, state, {
                    rowSelection: props.rowSelection ? model : $9674296b6d32bca5$var$emptyModel
                }), reason);
        }
    }, [
        apiRef,
        logger,
        props.rowSelection,
        props.signature,
        canHaveMultipleSelection
    ]);
    const isRowSelected = $9674296b6d32bca5$var$React.useCallback((id)=>{
        const selectionManager = (0, $7a5249c135fd39c1$exports.gridRowSelectionManagerSelector)(apiRef);
        return selectionManager.has(id);
    }, [
        apiRef
    ]);
    const isRowSelectable = $9674296b6d32bca5$var$React.useCallback((id)=>{
        if (props.rowSelection === false) return false;
        if (propIsRowSelectable && !propIsRowSelectable(apiRef.current.getRowParams(id))) return false;
        const rowNode = (0, $befccaa56b49492d$exports.gridRowNodeSelector)(apiRef, id);
        if (rowNode?.type === 'footer' || rowNode?.type === 'pinnedRow') return false;
        return true;
    }, [
        apiRef,
        props.rowSelection,
        propIsRowSelectable
    ]);
    const getSelectedRows = $9674296b6d32bca5$var$React.useCallback(()=>(0, $7a5249c135fd39c1$exports.gridRowSelectionIdsSelector)(apiRef), [
        apiRef
    ]);
    const selectRow = $9674296b6d32bca5$var$React.useCallback((id, isSelected = true, resetSelection = false)=>{
        if (!apiRef.current.isRowSelectable(id)) return;
        const tree = (0, $befccaa56b49492d$exports.gridRowTreeSelector)(apiRef);
        lastRowToggled.current = isSelected ? id : null;
        if (resetSelection) {
            logger.debug(`Setting selection for row ${id}`);
            const newSelectionModel = {
                type: 'include',
                ids: new Set()
            };
            const addRow = (rowId)=>{
                newSelectionModel.ids.add(rowId);
            };
            if (isSelected) {
                addRow(id);
                if (applyAutoSelection) (0, $dae18049c8685698$exports.findRowsToSelect)(apiRef, tree, id, props.rowSelectionPropagation?.descendants ?? false, props.rowSelectionPropagation?.parents ?? false, addRow);
            }
            apiRef.current.setRowSelectionModel(newSelectionModel, 'singleRowSelection');
        } else {
            logger.debug(`Toggling selection for row ${id}`);
            const selectionModel = (0, $7a5249c135fd39c1$exports.gridRowSelectionStateSelector)(apiRef);
            const newSelectionModel = {
                type: selectionModel.type,
                ids: new Set(selectionModel.ids)
            };
            const selectionManager = (0, $8ee7986d138c7e40$exports.createRowSelectionManager)(newSelectionModel);
            selectionManager.unselect(id);
            const addRow = (rowId)=>{
                selectionManager.select(rowId);
            };
            const removeRow = (rowId)=>{
                selectionManager.unselect(rowId);
            };
            if (isSelected) {
                addRow(id);
                if (applyAutoSelection) (0, $dae18049c8685698$exports.findRowsToSelect)(apiRef, tree, id, props.rowSelectionPropagation?.descendants ?? false, props.rowSelectionPropagation?.parents ?? false, addRow);
            } else if (applyAutoSelection) (0, $dae18049c8685698$exports.findRowsToDeselect)(apiRef, tree, id, props.rowSelectionPropagation?.descendants ?? false, props.rowSelectionPropagation?.parents ?? false, removeRow);
            const isSelectionValid = newSelectionModel.type === 'include' && newSelectionModel.ids.size < 2 || canHaveMultipleSelection;
            if (isSelectionValid) apiRef.current.setRowSelectionModel(newSelectionModel, 'singleRowSelection');
        }
    }, [
        apiRef,
        logger,
        applyAutoSelection,
        props.rowSelectionPropagation?.descendants,
        props.rowSelectionPropagation?.parents,
        canHaveMultipleSelection
    ]);
    const selectRows = $9674296b6d32bca5$var$React.useCallback((ids, isSelected = true, resetSelection = false)=>{
        logger.debug(`Setting selection for several rows`);
        if (props.rowSelection === false) return;
        const tree = (0, $befccaa56b49492d$exports.gridRowTreeSelector)(apiRef);
        const selectableIds = new Set();
        for(let i = 0; i < ids.length; i += 1){
            const id = ids[i];
            if (apiRef.current.isRowSelectable(id)) selectableIds.add(id);
        }
        const currentSelectionModel = (0, $7a5249c135fd39c1$exports.gridRowSelectionStateSelector)(apiRef);
        let newSelectionModel;
        if (resetSelection) {
            newSelectionModel = {
                type: 'include',
                ids: selectableIds
            };
            if (isSelected) {
                const selectionManager = (0, $8ee7986d138c7e40$exports.createRowSelectionManager)(newSelectionModel);
                if (applyAutoSelection) {
                    const addRow = (rowId)=>{
                        selectionManager.select(rowId);
                    };
                    for (const id of selectableIds)(0, $dae18049c8685698$exports.findRowsToSelect)(apiRef, tree, id, props.rowSelectionPropagation?.descendants ?? false, props.rowSelectionPropagation?.parents ?? false, addRow);
                }
            } else newSelectionModel.ids = new Set();
            if (currentSelectionModel.type === newSelectionModel.type && newSelectionModel.ids.size === currentSelectionModel.ids.size && Array.from(newSelectionModel.ids).every((id)=>currentSelectionModel.ids.has(id))) return;
        } else {
            newSelectionModel = {
                type: currentSelectionModel.type,
                ids: new Set(currentSelectionModel.ids)
            };
            const selectionManager = (0, $8ee7986d138c7e40$exports.createRowSelectionManager)(newSelectionModel);
            const addRow = (rowId)=>{
                selectionManager.select(rowId);
            };
            const removeRow = (rowId)=>{
                selectionManager.unselect(rowId);
            };
            for (const id of selectableIds)if (isSelected) {
                selectionManager.select(id);
                if (applyAutoSelection) (0, $dae18049c8685698$exports.findRowsToSelect)(apiRef, tree, id, props.rowSelectionPropagation?.descendants ?? false, props.rowSelectionPropagation?.parents ?? false, addRow);
            } else {
                removeRow(id);
                if (applyAutoSelection) (0, $dae18049c8685698$exports.findRowsToDeselect)(apiRef, tree, id, props.rowSelectionPropagation?.descendants ?? false, props.rowSelectionPropagation?.parents ?? false, removeRow);
            }
        }
        const isSelectionValid = newSelectionModel.type === 'include' && newSelectionModel.ids.size < 2 || canHaveMultipleSelection;
        if (isSelectionValid) apiRef.current.setRowSelectionModel(newSelectionModel, 'multipleRowsSelection');
    }, [
        logger,
        applyAutoSelection,
        canHaveMultipleSelection,
        apiRef,
        props.rowSelectionPropagation?.descendants,
        props.rowSelectionPropagation?.parents,
        props.rowSelection
    ]);
    const getPropagatedRowSelectionModel = $9674296b6d32bca5$var$React.useCallback((inputSelectionModel)=>{
        if (!isNestedData || !applyAutoSelection || inputSelectionModel.type === 'exclude' || inputSelectionModel.ids.size === 0 && inputSelectionModel.type === 'include') return inputSelectionModel;
        const propagatedSelectionModel = {
            type: inputSelectionModel.type,
            ids: new Set(inputSelectionModel.ids)
        };
        const tree = (0, $befccaa56b49492d$exports.gridRowTreeSelector)(apiRef);
        const selectionManager = (0, $8ee7986d138c7e40$exports.createRowSelectionManager)(propagatedSelectionModel);
        const addRow = (rowId)=>{
            selectionManager.select(rowId);
        };
        for (const id of inputSelectionModel.ids)(0, $dae18049c8685698$exports.findRowsToSelect)(apiRef, tree, id, props.rowSelectionPropagation?.descendants ?? false, props.rowSelectionPropagation?.parents ?? false, addRow, selectionManager);
        return propagatedSelectionModel;
    }, [
        apiRef,
        props.rowSelectionPropagation?.descendants,
        props.rowSelectionPropagation?.parents,
        isNestedData,
        applyAutoSelection
    ]);
    const selectRowRange = $9674296b6d32bca5$var$React.useCallback(({ startId: startId, endId: endId }, isSelected = true, resetSelection = false)=>{
        if (!apiRef.current.getRow(startId) || !apiRef.current.getRow(endId)) return;
        logger.debug(`Expanding selection from row ${startId} to row ${endId}`);
        // Using rows from all pages allow to select a range across several pages
        const allPagesRowIds = (0, $e95988b653de2e96$exports.gridExpandedSortedRowIdsSelector)(apiRef);
        const startIndex = allPagesRowIds.indexOf(startId);
        const endIndex = allPagesRowIds.indexOf(endId);
        const [start, end] = startIndex > endIndex ? [
            endIndex,
            startIndex
        ] : [
            startIndex,
            endIndex
        ];
        const rowsBetweenStartAndEnd = allPagesRowIds.slice(start, end + 1);
        apiRef.current.selectRows(rowsBetweenStartAndEnd, isSelected, resetSelection);
    }, [
        apiRef,
        logger
    ]);
    const selectionPublicApi = {
        selectRow: selectRow,
        setRowSelectionModel: setRowSelectionModel,
        getSelectedRows: getSelectedRows,
        isRowSelected: isRowSelected,
        isRowSelectable: isRowSelectable
    };
    const selectionPrivateApi = {
        selectRows: selectRows,
        selectRowRange: selectRowRange,
        getPropagatedRowSelectionModel: getPropagatedRowSelectionModel
    };
    (0, $d79b1aa4f5237e85$exports.useGridApiMethod)(apiRef, selectionPublicApi, 'public');
    (0, $d79b1aa4f5237e85$exports.useGridApiMethod)(apiRef, selectionPrivateApi, props.signature === $dc886d040ec4e87c$exports.GridSignature.DataGrid ? 'private' : 'public');
    /*
   * EVENTS
   */ const isFirstRender = $9674296b6d32bca5$var$React.useRef(true);
    const removeOutdatedSelection = $9674296b6d32bca5$var$React.useCallback((sortModelUpdated = false)=>{
        if (isFirstRender.current) return;
        const currentSelection = (0, $7a5249c135fd39c1$exports.gridRowSelectionStateSelector)(apiRef);
        const rowsLookup = (0, $befccaa56b49492d$exports.gridRowsLookupSelector)(apiRef);
        const rowTree = (0, $befccaa56b49492d$exports.gridRowTreeSelector)(apiRef);
        const filteredRowsLookup = (0, $e95988b653de2e96$exports.gridFilteredRowsLookupSelector)(apiRef);
        const isNonExistent = (id)=>{
            if (props.filterMode === 'server') return !rowsLookup[id];
            return !rowTree[id] || filteredRowsLookup[id] === false;
        };
        const newSelectionModel = {
            type: currentSelection.type,
            ids: new Set(currentSelection.ids)
        };
        const selectionManager = (0, $8ee7986d138c7e40$exports.createRowSelectionManager)(newSelectionModel);
        let hasChanged = false;
        for (const id of currentSelection.ids){
            if (isNonExistent(id)) {
                if (props.keepNonExistentRowsSelected) continue;
                selectionManager.unselect(id);
                hasChanged = true;
                continue;
            }
            if (!props.rowSelectionPropagation?.parents) continue;
            const node = rowTree[id];
            if (node?.type === 'group') {
                const isAutoGenerated = node.isAutoGenerated;
                if (isAutoGenerated) {
                    selectionManager.unselect(id);
                    hasChanged = true;
                    continue;
                }
                // Keep previously selected tree data parents selected if all their children are filtered out
                if (!node.children.every((childId)=>filteredRowsLookup[childId] === false)) {
                    selectionManager.unselect(id);
                    hasChanged = true;
                }
            }
        }
        // For nested data, on row tree updation (filtering, adding rows, etc.) when the selection is
        // not empty, we need to re-run scanning of the tree to propagate the selection changes
        // Example: A parent whose de-selected children are filtered out should now be selected
        const shouldReapplyPropagation = isNestedData && props.rowSelectionPropagation?.parents && (newSelectionModel.ids.size > 0 || // In case of exclude selection, newSelectionModel.ids.size === 0 means all rows are selected
        newSelectionModel.type === 'exclude');
        if (hasChanged || shouldReapplyPropagation && !sortModelUpdated) {
            if (shouldReapplyPropagation) {
                if (newSelectionModel.type === 'exclude') {
                    const unfilteredSelectedRowIds = getRowsToBeSelected();
                    const selectedRowIds = [];
                    for(let i = 0; i < unfilteredSelectedRowIds.length; i += 1){
                        const rowId = unfilteredSelectedRowIds[i];
                        if ((props.keepNonExistentRowsSelected || !isNonExistent(rowId)) && selectionManager.has(rowId)) selectedRowIds.push(rowId);
                    }
                    apiRef.current.selectRows(selectedRowIds, true, true);
                } else apiRef.current.selectRows(Array.from(newSelectionModel.ids), true, true);
            } else apiRef.current.setRowSelectionModel(newSelectionModel, 'multipleRowsSelection');
        }
    }, [
        apiRef,
        isNestedData,
        props.rowSelectionPropagation?.parents,
        props.keepNonExistentRowsSelected,
        props.filterMode,
        getRowsToBeSelected
    ]);
    const handleSingleRowSelection = $9674296b6d32bca5$var$React.useCallback((id, event)=>{
        const hasCtrlKey = event.metaKey || event.ctrlKey;
        // multiple selection is only allowed if:
        // - it is a checkboxSelection
        // - it is a keyboard selection
        // - Ctrl is pressed
        const isMultipleSelectionDisabled = !checkboxSelection && !hasCtrlKey && !(0, $a08faead7d1bb429$exports.isKeyboardEvent)(event);
        const resetSelection = !canHaveMultipleSelection || isMultipleSelectionDisabled;
        const isSelected = apiRef.current.isRowSelected(id);
        const selectedRowsCount = (0, $7a5249c135fd39c1$exports.gridRowSelectionCountSelector)(apiRef);
        // Clicking on a row should toggle the selection except when a range of rows is already selected and the selection should reset
        // In that case, we want to keep the current row selected (https://github.com/mui/mui-x/pull/15509#discussion_r1878082687)
        const shouldStaySelected = selectedRowsCount > 1 && resetSelection;
        const newSelectionState = shouldStaySelected || !isSelected;
        apiRef.current.selectRow(id, newSelectionState, resetSelection);
    }, [
        apiRef,
        canHaveMultipleSelection,
        checkboxSelection
    ]);
    const handleRowClick = $9674296b6d32bca5$var$React.useCallback((params, event)=>{
        if (disableRowSelectionOnClick) return;
        const field = event.target.closest(`.${$5H1vo.gridClasses.cell}`)?.getAttribute('data-field');
        if (field === $a6506085715c5aff$exports.GRID_CHECKBOX_SELECTION_COL_DEF.field) // click on checkbox should not trigger row selection
        return;
        if (field === $e8d35a7c12bdaa1d$exports.GRID_DETAIL_PANEL_TOGGLE_FIELD) // click to open the detail panel should not select the row
        return;
        if (field) {
            const column = apiRef.current.getColumn(field);
            if (column?.type === $a6506085715c5aff$exports.GRID_ACTIONS_COLUMN_TYPE) return;
        }
        const rowNode = (0, $befccaa56b49492d$exports.gridRowNodeSelector)(apiRef, params.id);
        if (rowNode.type === 'pinnedRow') return;
        if (event.shiftKey && canHaveMultipleSelection) expandMouseRowRangeSelection(params.id);
        else handleSingleRowSelection(params.id, event);
    }, [
        disableRowSelectionOnClick,
        canHaveMultipleSelection,
        apiRef,
        expandMouseRowRangeSelection,
        handleSingleRowSelection
    ]);
    const preventSelectionOnShift = $9674296b6d32bca5$var$React.useCallback((params, event)=>{
        if (canHaveMultipleSelection && event.shiftKey) window.getSelection()?.removeAllRanges();
    }, [
        canHaveMultipleSelection
    ]);
    const handleRowSelectionCheckboxChange = $9674296b6d32bca5$var$React.useCallback((params, event)=>{
        if (canHaveMultipleSelection && event.nativeEvent.shiftKey) expandMouseRowRangeSelection(params.id);
        else apiRef.current.selectRow(params.id, params.value, !canHaveMultipleSelection);
    }, [
        apiRef,
        expandMouseRowRangeSelection,
        canHaveMultipleSelection
    ]);
    const toggleAllRows = $9674296b6d32bca5$var$React.useCallback((value)=>{
        const filterModel = (0, $e95988b653de2e96$exports.gridFilterModelSelector)(apiRef);
        const quickFilterModel = (0, $e95988b653de2e96$exports.gridQuickFilterValuesSelector)(apiRef);
        const hasFilters = filterModel.items.length > 0 || quickFilterModel?.some((val)=>val.length);
        if (!props.isRowSelectable && !props.checkboxSelectionVisibleOnly && (!isNestedData || props.rowSelectionPropagation?.descendants) && !hasFilters && !props.disableRowSelectionExcludeModel) apiRef.current.setRowSelectionModel({
            type: value ? 'exclude' : 'include',
            ids: new Set()
        }, 'multipleRowsSelection');
        else apiRef.current.selectRows(getRowsToBeSelected(), value);
    }, [
        apiRef,
        getRowsToBeSelected,
        props.checkboxSelectionVisibleOnly,
        props.isRowSelectable,
        props.rowSelectionPropagation?.descendants,
        props.disableRowSelectionExcludeModel,
        isNestedData
    ]);
    const handleHeaderSelectionCheckboxChange = $9674296b6d32bca5$var$React.useCallback((params)=>{
        toggleAllRows(params.value);
    }, [
        toggleAllRows
    ]);
    const handleCellKeyDown = $9674296b6d32bca5$var$React.useCallback((params, event)=>{
        // Get the most recent cell mode because it may have been changed by another listener
        if (apiRef.current.getCellMode(params.id, params.field) === $e139707caeafbfd6$exports.GridCellModes.Edit) return;
        // Ignore portal
        // Do not apply shortcuts if the focus is not on the cell root component
        if ((0, $08bb4bf24f47b880$exports.isEventTargetInPortal)(event)) return;
        if ((0, $a08faead7d1bb429$exports.isNavigationKey)(event.key) && event.shiftKey) {
            // The cell that has focus after the keyboard navigation
            const focusCell = (0, $9c9b8e89fddd633d$exports.gridFocusCellSelector)(apiRef);
            if (focusCell && focusCell.id !== params.id) {
                event.preventDefault();
                const isNextRowSelected = apiRef.current.isRowSelected(focusCell.id);
                if (!canHaveMultipleSelection) {
                    apiRef.current.selectRow(focusCell.id, !isNextRowSelected, true);
                    return;
                }
                const newRowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(focusCell.id);
                const previousRowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(params.id);
                let start;
                let end;
                if (newRowIndex > previousRowIndex) {
                    if (isNextRowSelected) {
                        // We are navigating to the bottom of the page and adding selected rows
                        start = previousRowIndex;
                        end = newRowIndex - 1;
                    } else {
                        // We are navigating to the bottom of the page and removing selected rows
                        start = previousRowIndex;
                        end = newRowIndex;
                    }
                } else // eslint-disable-next-line no-lonely-if
                if (isNextRowSelected) {
                    // We are navigating to the top of the page and removing selected rows
                    start = newRowIndex + 1;
                    end = previousRowIndex;
                } else {
                    // We are navigating to the top of the page and adding selected rows
                    start = newRowIndex;
                    end = previousRowIndex;
                }
                const visibleRows = (0, $7d0a5941a1add073$exports.getVisibleRows)(apiRef);
                const rowsBetweenStartAndEnd = [];
                for(let i = start; i <= end; i += 1)rowsBetweenStartAndEnd.push(visibleRows.rows[i].id);
                apiRef.current.selectRows(rowsBetweenStartAndEnd, !isNextRowSelected);
                return;
            }
        }
        if (event.key === ' ' && event.shiftKey) {
            event.preventDefault();
            handleSingleRowSelection(params.id, event);
            return;
        }
        if (String.fromCharCode(event.keyCode) === 'A' && (event.ctrlKey || event.metaKey)) {
            event.preventDefault();
            if (canHaveMultipleSelection) toggleAllRows(true);
        }
    }, [
        apiRef,
        canHaveMultipleSelection,
        handleSingleRowSelection,
        toggleAllRows
    ]);
    const syncControlledState = (0, $9674296b6d32bca5$var$_useEventCallback.default)(()=>{
        if (!props.rowSelection) {
            apiRef.current.setRowSelectionModel($9674296b6d32bca5$var$emptyModel);
            return;
        }
        if (propRowSelectionModel === undefined) return;
        if (!applyAutoSelection || !isNestedData || propRowSelectionModel.type === 'include' && propRowSelectionModel.ids.size === 0) {
            apiRef.current.setRowSelectionModel(propRowSelectionModel);
            return;
        }
        const newSelectionModel = apiRef.current.getPropagatedRowSelectionModel(propRowSelectionModel);
        if (newSelectionModel.type !== propRowSelectionModel.type || newSelectionModel.ids.size !== propRowSelectionModel.ids.size || !Array.from(propRowSelectionModel.ids).every((id)=>newSelectionModel.ids.has(id))) {
            apiRef.current.setRowSelectionModel(newSelectionModel);
            return;
        }
        apiRef.current.setRowSelectionModel(propRowSelectionModel);
    });
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'filteredRowsSet', runIfRowSelectionIsEnabled(()=>removeOutdatedSelection()));
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'rowClick', runIfRowSelectionIsEnabled(handleRowClick));
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'rowSelectionCheckboxChange', runIfRowSelectionIsEnabled(handleRowSelectionCheckboxChange));
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'headerSelectionCheckboxChange', handleHeaderSelectionCheckboxChange);
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'cellMouseDown', runIfRowSelectionIsEnabled(preventSelectionOnShift));
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'cellKeyDown', runIfRowSelectionIsEnabled(handleCellKeyDown));
    /*
   * EFFECTS
   */ $9674296b6d32bca5$var$React.useEffect(()=>{
        syncControlledState();
    }, [
        apiRef,
        propRowSelectionModel,
        props.rowSelection,
        syncControlledState
    ]);
    const isStateControlled = propRowSelectionModel != null;
    $9674296b6d32bca5$var$React.useEffect(()=>{
        if (isStateControlled || !props.rowSelection || typeof isRowSelectable !== 'function') return;
        // props.isRowSelectable changed
        const currentSelection = (0, $7a5249c135fd39c1$exports.gridRowSelectionStateSelector)(apiRef);
        if (currentSelection.type !== 'include') return;
        const selectableIds = new Set();
        for (const id of currentSelection.ids)if (isRowSelectable(id)) selectableIds.add(id);
        if (selectableIds.size < currentSelection.ids.size) apiRef.current.setRowSelectionModel({
            type: currentSelection.type,
            ids: selectableIds
        });
    }, [
        apiRef,
        isRowSelectable,
        isStateControlled,
        props.rowSelection
    ]);
    $9674296b6d32bca5$var$React.useEffect(()=>{
        if (!props.rowSelection || isStateControlled) return;
        const currentSelection = (0, $7a5249c135fd39c1$exports.gridRowSelectionStateSelector)(apiRef);
        if (!canHaveMultipleSelection && (currentSelection.type === 'include' && currentSelection.ids.size > 1 || currentSelection.type === 'exclude')) // See https://github.com/mui/mui-x/issues/8455
        apiRef.current.setRowSelectionModel($9674296b6d32bca5$var$emptyModel);
    }, [
        apiRef,
        canHaveMultipleSelection,
        checkboxSelection,
        isStateControlled,
        props.rowSelection
    ]);
    $9674296b6d32bca5$var$React.useEffect(()=>{
        runIfRowSelectionIsEnabled(removeOutdatedSelection);
    }, [
        removeOutdatedSelection,
        runIfRowSelectionIsEnabled
    ]);
    $9674296b6d32bca5$var$React.useEffect(()=>{
        if (isFirstRender.current) isFirstRender.current = false;
    }, []);
};
$9674296b6d32bca5$exports.useGridRowSelection = $9674296b6d32bca5$var$useGridRowSelection;


var $45340a55c38c89d7$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $45340a55c38c89d7$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $45340a55c38c89d7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($45340a55c38c89d7$exports, "__esModule", {
    value: true
});
$45340a55c38c89d7$exports.useGridRowSelectionPreProcessors = void 0;

var $45340a55c38c89d7$var$_extends2 = $45340a55c38c89d7$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $45340a55c38c89d7$var$React = $45340a55c38c89d7$require$_interopRequireWildcard((parcelRequire("acw62")));

var $45340a55c38c89d7$var$_composeClasses = $45340a55c38c89d7$require$_interopRequireDefault((parcelRequire("3Hg1x")));



const $45340a55c38c89d7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return $45340a55c38c89d7$var$React.useMemo(()=>{
        const slots = {
            cellCheckbox: [
                'cellCheckbox'
            ],
            columnHeaderCheckbox: [
                'columnHeaderCheckbox'
            ]
        };
        return (0, $45340a55c38c89d7$var$_composeClasses.default)(slots, $553c2bbb14fa5500$exports.getDataGridUtilityClass, classes);
    }, [
        classes
    ]);
};
const $45340a55c38c89d7$var$useGridRowSelectionPreProcessors = (apiRef, props)=>{
    const ownerState = {
        classes: props.classes
    };
    const classes = $45340a55c38c89d7$var$useUtilityClasses(ownerState);
    const updateSelectionColumn = $45340a55c38c89d7$var$React.useCallback((columnsState)=>{
        const selectionColumn = (0, $45340a55c38c89d7$var$_extends2.default)({}, $a6506085715c5aff$exports.GRID_CHECKBOX_SELECTION_COL_DEF, {
            cellClassName: classes.cellCheckbox,
            headerClassName: classes.columnHeaderCheckbox,
            headerName: apiRef.current.getLocaleText('checkboxSelectionHeaderName')
        });
        const shouldHaveSelectionColumn = props.checkboxSelection;
        const hasSelectionColumn = columnsState.lookup[$a6506085715c5aff$exports.GRID_CHECKBOX_SELECTION_FIELD] != null;
        if (shouldHaveSelectionColumn && !hasSelectionColumn) {
            columnsState.lookup[$a6506085715c5aff$exports.GRID_CHECKBOX_SELECTION_FIELD] = selectionColumn;
            columnsState.orderedFields = [
                $a6506085715c5aff$exports.GRID_CHECKBOX_SELECTION_FIELD,
                ...columnsState.orderedFields
            ];
        } else if (!shouldHaveSelectionColumn && hasSelectionColumn) {
            delete columnsState.lookup[$a6506085715c5aff$exports.GRID_CHECKBOX_SELECTION_FIELD];
            columnsState.orderedFields = columnsState.orderedFields.filter((field)=>field !== $a6506085715c5aff$exports.GRID_CHECKBOX_SELECTION_FIELD);
        } else if (shouldHaveSelectionColumn && hasSelectionColumn) {
            columnsState.lookup[$a6506085715c5aff$exports.GRID_CHECKBOX_SELECTION_FIELD] = (0, $45340a55c38c89d7$var$_extends2.default)({}, selectionColumn, columnsState.lookup[$a6506085715c5aff$exports.GRID_CHECKBOX_SELECTION_FIELD]);
            // If the column is not in the columns array (not a custom selection column), move it to the beginning of the column order
            if (!props.columns.some((col)=>col.field === $a6506085715c5aff$exports.GRID_CHECKBOX_SELECTION_FIELD)) columnsState.orderedFields = [
                $a6506085715c5aff$exports.GRID_CHECKBOX_SELECTION_FIELD,
                ...columnsState.orderedFields.filter((field)=>field !== $a6506085715c5aff$exports.GRID_CHECKBOX_SELECTION_FIELD)
            ];
        }
        return columnsState;
    }, [
        apiRef,
        classes,
        props.columns,
        props.checkboxSelection
    ]);
    (0, $1aa692cb9e262bac$exports.useGridRegisterPipeProcessor)(apiRef, 'hydrateColumns', updateSelectionColumn);
};
$45340a55c38c89d7$exports.useGridRowSelectionPreProcessors = $45340a55c38c89d7$var$useGridRowSelectionPreProcessors;


var $e6ca12cabeac117a$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $e6ca12cabeac117a$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $e6ca12cabeac117a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($e6ca12cabeac117a$exports, "__esModule", {
    value: true
});
$e6ca12cabeac117a$exports.useGridSorting = $e6ca12cabeac117a$exports.sortingStateInitializer = void 0;

var $e6ca12cabeac117a$var$_extends2 = $e6ca12cabeac117a$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $e6ca12cabeac117a$var$React = $e6ca12cabeac117a$require$_interopRequireWildcard((parcelRequire("acw62")));

var $e6ca12cabeac117a$var$_useEnhancedEffect = $e6ca12cabeac117a$require$_interopRequireDefault((parcelRequire("jdWO4")));











const $e6ca12cabeac117a$var$sortingStateInitializer = (state, props)=>{
    const sortModel = props.sortModel ?? props.initialState?.sorting?.sortModel ?? [];
    return (0, $e6ca12cabeac117a$var$_extends2.default)({}, state, {
        sorting: {
            sortModel: (0, $c78f90aae54b126e$exports.sanitizeSortModel)(sortModel, props.disableMultipleColumnsSorting),
            sortedRows: []
        }
    });
};
/**
 * @requires useGridRows (event)
 * @requires useGridColumns (event)
 */ $e6ca12cabeac117a$exports.sortingStateInitializer = $e6ca12cabeac117a$var$sortingStateInitializer;
const $e6ca12cabeac117a$var$useGridSorting = (apiRef, props)=>{
    const logger = (0, $fa53bf7350a63511$exports.useGridLogger)(apiRef, 'useGridSorting');
    apiRef.current.registerControlState({
        stateId: 'sortModel',
        propModel: props.sortModel,
        propOnChange: props.onSortModelChange,
        stateSelector: $dc3028b3b629fae7$exports.gridSortModelSelector,
        changeEvent: 'sortModelChange'
    });
    const upsertSortModel = $e6ca12cabeac117a$var$React.useCallback((field, sortItem)=>{
        const sortModel = (0, $dc3028b3b629fae7$exports.gridSortModelSelector)(apiRef);
        const existingIdx = sortModel.findIndex((c)=>c.field === field);
        let newSortModel = [
            ...sortModel
        ];
        if (existingIdx > -1) {
            if (sortItem?.sort == null) newSortModel.splice(existingIdx, 1);
            else newSortModel.splice(existingIdx, 1, sortItem);
        } else newSortModel = [
            ...sortModel,
            sortItem
        ];
        return newSortModel;
    }, [
        apiRef
    ]);
    const createSortItem = $e6ca12cabeac117a$var$React.useCallback((col, directionOverride)=>{
        const sortModel = (0, $dc3028b3b629fae7$exports.gridSortModelSelector)(apiRef);
        const existing = sortModel.find((c)=>c.field === col.field);
        if (existing) {
            const nextSort = directionOverride === undefined ? (0, $c78f90aae54b126e$exports.getNextGridSortDirection)(col.sortingOrder ?? props.sortingOrder, existing.sort) : directionOverride;
            return nextSort === undefined ? undefined : (0, $e6ca12cabeac117a$var$_extends2.default)({}, existing, {
                sort: nextSort
            });
        }
        return {
            field: col.field,
            sort: directionOverride === undefined ? (0, $c78f90aae54b126e$exports.getNextGridSortDirection)(col.sortingOrder ?? props.sortingOrder) : directionOverride
        };
    }, [
        apiRef,
        props.sortingOrder
    ]);
    const addColumnMenuItem = $e6ca12cabeac117a$var$React.useCallback((columnMenuItems, colDef)=>{
        if (colDef == null || colDef.sortable === false || props.disableColumnSorting) return columnMenuItems;
        const sortingOrder = colDef.sortingOrder || props.sortingOrder;
        if (sortingOrder.some((item)=>!!item)) return [
            ...columnMenuItems,
            'columnMenuSortItem'
        ];
        return columnMenuItems;
    }, [
        props.sortingOrder,
        props.disableColumnSorting
    ]);
    /**
   * API METHODS
   */ const applySorting = $e6ca12cabeac117a$var$React.useCallback(()=>{
        apiRef.current.setState((state)=>{
            if (props.sortingMode === 'server') {
                logger.debug('Skipping sorting rows as sortingMode = server');
                return (0, $e6ca12cabeac117a$var$_extends2.default)({}, state, {
                    sorting: (0, $e6ca12cabeac117a$var$_extends2.default)({}, state.sorting, {
                        sortedRows: (0, $0166dd44615cae0d$exports.getTreeNodeDescendants)((0, $aad5df8f504205b0$exports.gridRowTreeSelector)(apiRef), $aad5df8f504205b0$exports.GRID_ROOT_GROUP_ID, false)
                    })
                });
            }
            const sortModel = (0, $dc3028b3b629fae7$exports.gridSortModelSelector)(apiRef);
            const sortRowList = (0, $c78f90aae54b126e$exports.buildAggregatedSortingApplier)(sortModel, apiRef);
            const sortedRows = apiRef.current.applyStrategyProcessor('sorting', {
                sortRowList: sortRowList
            });
            return (0, $e6ca12cabeac117a$var$_extends2.default)({}, state, {
                sorting: (0, $e6ca12cabeac117a$var$_extends2.default)({}, state.sorting, {
                    sortedRows: sortedRows
                })
            });
        });
        apiRef.current.publishEvent('sortedRowsSet');
    }, [
        apiRef,
        logger,
        props.sortingMode
    ]);
    const setSortModel = $e6ca12cabeac117a$var$React.useCallback((model)=>{
        const currentModel = (0, $dc3028b3b629fae7$exports.gridSortModelSelector)(apiRef);
        if (currentModel !== model) {
            logger.debug(`Setting sort model`);
            apiRef.current.setState((0, $c78f90aae54b126e$exports.mergeStateWithSortModel)(model, props.disableMultipleColumnsSorting));
            apiRef.current.applySorting();
        }
    }, [
        apiRef,
        logger,
        props.disableMultipleColumnsSorting
    ]);
    const sortColumn = $e6ca12cabeac117a$var$React.useCallback((field, direction, allowMultipleSorting)=>{
        const column = apiRef.current.getColumn(field);
        const sortItem = createSortItem(column, direction);
        let sortModel;
        if (!allowMultipleSorting || props.disableMultipleColumnsSorting) sortModel = sortItem?.sort == null ? [] : [
            sortItem
        ];
        else sortModel = upsertSortModel(column.field, sortItem);
        apiRef.current.setSortModel(sortModel);
    }, [
        apiRef,
        upsertSortModel,
        createSortItem,
        props.disableMultipleColumnsSorting
    ]);
    const getSortModel = $e6ca12cabeac117a$var$React.useCallback(()=>(0, $dc3028b3b629fae7$exports.gridSortModelSelector)(apiRef), [
        apiRef
    ]);
    const getSortedRows = $e6ca12cabeac117a$var$React.useCallback(()=>{
        const sortedRows = (0, $dc3028b3b629fae7$exports.gridSortedRowEntriesSelector)(apiRef);
        return sortedRows.map((row)=>row.model);
    }, [
        apiRef
    ]);
    const getSortedRowIds = $e6ca12cabeac117a$var$React.useCallback(()=>(0, $dc3028b3b629fae7$exports.gridSortedRowIdsSelector)(apiRef), [
        apiRef
    ]);
    const getRowIdFromRowIndex = $e6ca12cabeac117a$var$React.useCallback((index)=>apiRef.current.getSortedRowIds()[index], [
        apiRef
    ]);
    const sortApi = {
        getSortModel: getSortModel,
        getSortedRows: getSortedRows,
        getSortedRowIds: getSortedRowIds,
        getRowIdFromRowIndex: getRowIdFromRowIndex,
        setSortModel: setSortModel,
        sortColumn: sortColumn,
        applySorting: applySorting
    };
    (0, $d79b1aa4f5237e85$exports.useGridApiMethod)(apiRef, sortApi, 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $e6ca12cabeac117a$var$React.useCallback((prevState, context)=>{
        const sortModelToExport = (0, $dc3028b3b629fae7$exports.gridSortModelSelector)(apiRef);
        const shouldExportSortModel = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the model is controlled
        props.sortModel != null || // Always export if the model has been initialized
        props.initialState?.sorting?.sortModel != null || // Export if the model is not empty
        sortModelToExport.length > 0;
        if (!shouldExportSortModel) return prevState;
        return (0, $e6ca12cabeac117a$var$_extends2.default)({}, prevState, {
            sorting: {
                sortModel: sortModelToExport
            }
        });
    }, [
        apiRef,
        props.sortModel,
        props.initialState?.sorting?.sortModel
    ]);
    const stateRestorePreProcessing = $e6ca12cabeac117a$var$React.useCallback((params, context)=>{
        const sortModel = context.stateToRestore.sorting?.sortModel;
        if (sortModel == null) return params;
        apiRef.current.setState((0, $c78f90aae54b126e$exports.mergeStateWithSortModel)(sortModel, props.disableMultipleColumnsSorting));
        return (0, $e6ca12cabeac117a$var$_extends2.default)({}, params, {
            callbacks: [
                ...params.callbacks,
                apiRef.current.applySorting
            ]
        });
    }, [
        apiRef,
        props.disableMultipleColumnsSorting
    ]);
    const flatSortingMethod = $e6ca12cabeac117a$var$React.useCallback((params)=>{
        const rowTree = (0, $aad5df8f504205b0$exports.gridRowTreeSelector)(apiRef);
        const rootGroupNode = rowTree[$aad5df8f504205b0$exports.GRID_ROOT_GROUP_ID];
        const sortedChildren = params.sortRowList ? params.sortRowList(rootGroupNode.children.map((childId)=>rowTree[childId])) : [
            ...rootGroupNode.children
        ];
        if (rootGroupNode.footerId != null) sortedChildren.push(rootGroupNode.footerId);
        return sortedChildren;
    }, [
        apiRef
    ]);
    (0, $1aa692cb9e262bac$exports.useGridRegisterPipeProcessor)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $1aa692cb9e262bac$exports.useGridRegisterPipeProcessor)(apiRef, 'restoreState', stateRestorePreProcessing);
    (0, $41d629b2793a9305$exports.useGridRegisterStrategyProcessor)(apiRef, $41d629b2793a9305$exports.GRID_DEFAULT_STRATEGY, 'sorting', flatSortingMethod);
    /**
   * EVENTS
   */ const handleColumnHeaderClick = $e6ca12cabeac117a$var$React.useCallback(({ field: field, colDef: colDef }, event)=>{
        if (!colDef.sortable || props.disableColumnSorting) return;
        const allowMultipleSorting = props.multipleColumnsSortingMode === 'always' || event.shiftKey || event.metaKey || event.ctrlKey;
        sortColumn(field, undefined, allowMultipleSorting);
    }, [
        sortColumn,
        props.disableColumnSorting,
        props.multipleColumnsSortingMode
    ]);
    const handleColumnHeaderKeyDown = $e6ca12cabeac117a$var$React.useCallback(({ field: field, colDef: colDef }, event)=>{
        if (!colDef.sortable || props.disableColumnSorting) return;
        // Ctrl + Enter opens the column menu
        if (event.key === 'Enter' && !event.ctrlKey && !event.metaKey) sortColumn(field, undefined, props.multipleColumnsSortingMode === 'always' || event.shiftKey);
    }, [
        sortColumn,
        props.disableColumnSorting,
        props.multipleColumnsSortingMode
    ]);
    const handleColumnsChange = $e6ca12cabeac117a$var$React.useCallback(()=>{
        // When the columns change we check that the sorted columns are still part of the dataset
        const sortModel = (0, $dc3028b3b629fae7$exports.gridSortModelSelector)(apiRef);
        const latestColumns = (0, $e732684465924d20$exports.gridColumnLookupSelector)(apiRef);
        if (sortModel.length > 0) {
            const newModel = sortModel.filter((sortItem)=>latestColumns[sortItem.field]);
            if (newModel.length < sortModel.length) apiRef.current.setSortModel(newModel);
        }
    }, [
        apiRef
    ]);
    const handleStrategyProcessorChange = $e6ca12cabeac117a$var$React.useCallback((methodName)=>{
        if (methodName === 'sorting') apiRef.current.applySorting();
    }, [
        apiRef
    ]);
    (0, $1aa692cb9e262bac$exports.useGridRegisterPipeProcessor)(apiRef, 'columnMenu', addColumnMenuItem);
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'columnHeaderClick', handleColumnHeaderClick);
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'columnHeaderKeyDown', handleColumnHeaderKeyDown);
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'rowsSet', apiRef.current.applySorting);
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'columnsChange', handleColumnsChange);
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'activeStrategyProcessorChange', handleStrategyProcessorChange);
    /**
   * 1ST RENDER
   */ (0, $82679e37231fe76f$exports.useFirstRender)(()=>{
        if (props.signature === 'DataGrid') apiRef.current.applySorting();
    });
    /**
   * EFFECTS
   */ (0, $e6ca12cabeac117a$var$_useEnhancedEffect.default)(()=>{
        if (props.sortModel !== undefined) apiRef.current.setSortModel(props.sortModel);
    }, [
        apiRef,
        props.sortModel
    ]);
};
$e6ca12cabeac117a$exports.useGridSorting = $e6ca12cabeac117a$var$useGridSorting;


var $bc5c7b440a851fd1$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $bc5c7b440a851fd1$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($bc5c7b440a851fd1$exports, "__esModule", {
    value: true
});
$bc5c7b440a851fd1$exports.useGridScroll = void 0;

var $bc5c7b440a851fd1$var$React = $bc5c7b440a851fd1$require$_interopRequireWildcard((parcelRequire("acw62")));

var $9uEev = parcelRequire("9uEev");








// Logic copied from https://www.w3.org/TR/wai-aria-practices/examples/listbox/js/listbox.js
// Similar to https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView
function $bc5c7b440a851fd1$var$scrollIntoView(dimensions) {
    const { containerSize: containerSize, scrollPosition: scrollPosition, elementSize: elementSize, elementOffset: elementOffset } = dimensions;
    const elementEnd = elementOffset + elementSize;
    // Always scroll to top when cell is higher than viewport to avoid scroll jump
    // See https://github.com/mui/mui-x/issues/4513 and https://github.com/mui/mui-x/issues/4514
    if (elementSize > containerSize) return elementOffset;
    if (elementEnd - containerSize > scrollPosition) return elementEnd - containerSize;
    if (elementOffset < scrollPosition) return elementOffset;
    return undefined;
}
/**
 * @requires useGridPagination (state) - can be after, async only
 * @requires useGridColumns (state) - can be after, async only
 * @requires useGridRows (state) - can be after, async only
 * @requires useGridRowsMeta (state) - can be after, async only
 * @requires useGridFilter (state)
 * @requires useGridColumnSpanning (method)
 */ const $bc5c7b440a851fd1$var$useGridScroll = (apiRef, props)=>{
    const isRtl = (0, $9uEev.useRtl)();
    const logger = (0, $fa53bf7350a63511$exports.useGridLogger)(apiRef, 'useGridScroll');
    const colRef = apiRef.current.columnHeadersContainerRef;
    const virtualScrollerRef = apiRef.current.virtualScrollerRef;
    const scrollToIndexes = $bc5c7b440a851fd1$var$React.useCallback((params)=>{
        const dimensions = (0, $d9a3301c6c2f6d8b$exports.gridDimensionsSelector)(apiRef);
        const totalRowCount = (0, $befccaa56b49492d$exports.gridRowCountSelector)(apiRef);
        const visibleColumns = (0, $e732684465924d20$exports.gridVisibleColumnDefinitionsSelector)(apiRef);
        const scrollToHeader = params.rowIndex == null;
        if (!scrollToHeader && totalRowCount === 0 || visibleColumns.length === 0) return false;
        logger.debug(`Scrolling to cell at row ${params.rowIndex}, col: ${params.colIndex} `);
        let scrollCoordinates = {};
        if (params.colIndex !== undefined) {
            const columnPositions = (0, $e732684465924d20$exports.gridColumnPositionsSelector)(apiRef);
            let cellWidth;
            if (typeof params.rowIndex !== 'undefined') {
                const visibleSortedRows = (0, $e95988b653de2e96$exports.gridExpandedSortedRowEntriesSelector)(apiRef);
                const rowId = visibleSortedRows[params.rowIndex]?.id;
                const cellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, params.colIndex);
                if (cellColSpanInfo && !cellColSpanInfo.spannedByColSpan) cellWidth = cellColSpanInfo.cellProps.width;
            }
            if (typeof cellWidth === 'undefined') cellWidth = visibleColumns[params.colIndex].computedWidth;
            // When using RTL, `scrollLeft` becomes negative, so we must ensure that we only compare values.
            scrollCoordinates.left = $bc5c7b440a851fd1$var$scrollIntoView({
                containerSize: dimensions.viewportOuterSize.width,
                scrollPosition: Math.abs(virtualScrollerRef.current.scrollLeft),
                elementSize: cellWidth,
                elementOffset: columnPositions[params.colIndex]
            });
        }
        if (params.rowIndex !== undefined) {
            const rowsMeta = (0, $82a5a13765976ef2$exports.gridRowsMetaSelector)(apiRef);
            const page = (0, $c41ec74257ca380c$exports.gridPageSelector)(apiRef);
            const pageSize = (0, $c41ec74257ca380c$exports.gridPageSizeSelector)(apiRef);
            const elementIndex = !props.pagination ? params.rowIndex : params.rowIndex - page * pageSize;
            const targetOffsetHeight = rowsMeta.positions[elementIndex + 1] ? rowsMeta.positions[elementIndex + 1] - rowsMeta.positions[elementIndex] : rowsMeta.currentPageTotalHeight - rowsMeta.positions[elementIndex];
            scrollCoordinates.top = $bc5c7b440a851fd1$var$scrollIntoView({
                containerSize: dimensions.viewportInnerSize.height,
                scrollPosition: virtualScrollerRef.current.scrollTop,
                elementSize: targetOffsetHeight,
                elementOffset: rowsMeta.positions[elementIndex]
            });
        }
        scrollCoordinates = apiRef.current.unstable_applyPipeProcessors('scrollToIndexes', scrollCoordinates, params);
        if (typeof scrollCoordinates.left !== 'undefined' || typeof scrollCoordinates.top !== 'undefined') {
            apiRef.current.scroll(scrollCoordinates);
            return true;
        }
        return false;
    }, [
        logger,
        apiRef,
        virtualScrollerRef,
        props.pagination
    ]);
    const scroll = $bc5c7b440a851fd1$var$React.useCallback((params)=>{
        if (virtualScrollerRef.current && params.left !== undefined && colRef.current) {
            const direction = isRtl ? -1 : 1;
            colRef.current.scrollLeft = params.left;
            virtualScrollerRef.current.scrollLeft = direction * params.left;
            logger.debug(`Scrolling left: ${params.left}`);
        }
        if (virtualScrollerRef.current && params.top !== undefined) {
            virtualScrollerRef.current.scrollTop = params.top;
            logger.debug(`Scrolling top: ${params.top}`);
        }
        logger.debug(`Scrolling, updating container, and viewport`);
    }, [
        virtualScrollerRef,
        isRtl,
        colRef,
        logger
    ]);
    const getScrollPosition = $bc5c7b440a851fd1$var$React.useCallback(()=>{
        if (!virtualScrollerRef?.current) return {
            top: 0,
            left: 0
        };
        return {
            top: virtualScrollerRef.current.scrollTop,
            left: virtualScrollerRef.current.scrollLeft
        };
    }, [
        virtualScrollerRef
    ]);
    const scrollApi = {
        scroll: scroll,
        scrollToIndexes: scrollToIndexes,
        getScrollPosition: getScrollPosition
    };
    (0, $d79b1aa4f5237e85$exports.useGridApiMethod)(apiRef, scrollApi, 'public');
};
$bc5c7b440a851fd1$exports.useGridScroll = $bc5c7b440a851fd1$var$useGridScroll;


var $1be25f585207520f$exports = {};
"use strict";
Object.defineProperty($1be25f585207520f$exports, "__esModule", {
    value: true
});
$1be25f585207520f$exports.useGridEvents = $1be25f585207520f$var$useGridEvents;

/**
 * @requires useGridFocus (event) - can be after, async only
 * @requires useGridColumns (event) - can be after, async only
 */ function $1be25f585207520f$var$useGridEvents(apiRef, props) {
    (0, $bc055d85bc2d0e70$exports.useGridEventPriority)(apiRef, 'columnHeaderClick', props.onColumnHeaderClick);
    (0, $bc055d85bc2d0e70$exports.useGridEventPriority)(apiRef, 'columnHeaderContextMenu', props.onColumnHeaderContextMenu);
    (0, $bc055d85bc2d0e70$exports.useGridEventPriority)(apiRef, 'columnHeaderDoubleClick', props.onColumnHeaderDoubleClick);
    (0, $bc055d85bc2d0e70$exports.useGridEventPriority)(apiRef, 'columnHeaderOver', props.onColumnHeaderOver);
    (0, $bc055d85bc2d0e70$exports.useGridEventPriority)(apiRef, 'columnHeaderOut', props.onColumnHeaderOut);
    (0, $bc055d85bc2d0e70$exports.useGridEventPriority)(apiRef, 'columnHeaderEnter', props.onColumnHeaderEnter);
    (0, $bc055d85bc2d0e70$exports.useGridEventPriority)(apiRef, 'columnHeaderLeave', props.onColumnHeaderLeave);
    (0, $bc055d85bc2d0e70$exports.useGridEventPriority)(apiRef, 'cellClick', props.onCellClick);
    (0, $bc055d85bc2d0e70$exports.useGridEventPriority)(apiRef, 'cellDoubleClick', props.onCellDoubleClick);
    (0, $bc055d85bc2d0e70$exports.useGridEventPriority)(apiRef, 'cellKeyDown', props.onCellKeyDown);
    (0, $bc055d85bc2d0e70$exports.useGridEventPriority)(apiRef, 'preferencePanelClose', props.onPreferencePanelClose);
    (0, $bc055d85bc2d0e70$exports.useGridEventPriority)(apiRef, 'preferencePanelOpen', props.onPreferencePanelOpen);
    (0, $bc055d85bc2d0e70$exports.useGridEventPriority)(apiRef, 'menuOpen', props.onMenuOpen);
    (0, $bc055d85bc2d0e70$exports.useGridEventPriority)(apiRef, 'menuClose', props.onMenuClose);
    (0, $bc055d85bc2d0e70$exports.useGridEventPriority)(apiRef, 'rowDoubleClick', props.onRowDoubleClick);
    (0, $bc055d85bc2d0e70$exports.useGridEventPriority)(apiRef, 'rowClick', props.onRowClick);
    (0, $bc055d85bc2d0e70$exports.useGridEventPriority)(apiRef, 'stateChange', props.onStateChange);
}


var $06d554a00cf6d24e$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $06d554a00cf6d24e$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $06d554a00cf6d24e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($06d554a00cf6d24e$exports, "__esModule", {
    value: true
});
$06d554a00cf6d24e$exports.dimensionsStateInitializer = void 0;
$06d554a00cf6d24e$exports.useGridDimensions = $06d554a00cf6d24e$var$useGridDimensions;

var $06d554a00cf6d24e$var$_extends2 = $06d554a00cf6d24e$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $06d554a00cf6d24e$var$React = $06d554a00cf6d24e$require$_interopRequireWildcard((parcelRequire("acw62")));











var $7751bfb0bc82a0cf$exports = {};
"use strict";
Object.defineProperty($7751bfb0bc82a0cf$exports, "__esModule", {
    value: true
});
Object.defineProperty($7751bfb0bc82a0cf$exports, "roundToDecimalPlaces", {
    enumerable: true,
    get: function() {
        return $b5eb928c08dc82e9$exports.roundToDecimalPlaces;
    }
});




const $06d554a00cf6d24e$var$EMPTY_SIZE = {
    width: 0,
    height: 0
};
const $06d554a00cf6d24e$var$EMPTY_DIMENSIONS = {
    isReady: false,
    root: $06d554a00cf6d24e$var$EMPTY_SIZE,
    viewportOuterSize: $06d554a00cf6d24e$var$EMPTY_SIZE,
    viewportInnerSize: $06d554a00cf6d24e$var$EMPTY_SIZE,
    contentSize: $06d554a00cf6d24e$var$EMPTY_SIZE,
    minimumSize: $06d554a00cf6d24e$var$EMPTY_SIZE,
    hasScrollX: false,
    hasScrollY: false,
    scrollbarSize: 0,
    headerHeight: 0,
    groupHeaderHeight: 0,
    headerFilterHeight: 0,
    rowWidth: 0,
    rowHeight: 0,
    columnsTotalWidth: 0,
    leftPinnedWidth: 0,
    rightPinnedWidth: 0,
    headersTotalHeight: 0,
    topContainerHeight: 0,
    bottomContainerHeight: 0,
    autoHeight: false,
    minimalContentHeight: undefined
};
const $06d554a00cf6d24e$var$dimensionsStateInitializer = (state, props, apiRef)=>{
    const dimensions = $06d554a00cf6d24e$var$EMPTY_DIMENSIONS;
    const density = (0, $c638c00d73ef894b$exports.gridDensityFactorSelector)(apiRef);
    const dimensionsWithStatic = (0, $06d554a00cf6d24e$var$_extends2.default)({}, dimensions, $06d554a00cf6d24e$var$getStaticDimensions(props, apiRef, density, (0, $e3b5f2e67362f55f$exports.gridVisiblePinnedColumnDefinitionsSelector)(apiRef)));
    apiRef.current.store.state.dimensions = dimensionsWithStatic;
    return (0, $06d554a00cf6d24e$var$_extends2.default)({}, state, {
        dimensions: dimensionsWithStatic
    });
};
$06d554a00cf6d24e$exports.dimensionsStateInitializer = $06d554a00cf6d24e$var$dimensionsStateInitializer;
const $06d554a00cf6d24e$var$columnsTotalWidthSelector = (0, $8eef5f2af445e503$exports.createSelector)($e3b5f2e67362f55f$exports.gridVisibleColumnDefinitionsSelector, $e3b5f2e67362f55f$exports.gridColumnPositionsSelector, (visibleColumns, positions)=>{
    const colCount = visibleColumns.length;
    if (colCount === 0) return 0;
    return (0, $7751bfb0bc82a0cf$exports.roundToDecimalPlaces)(positions[colCount - 1] + visibleColumns[colCount - 1].computedWidth, 1);
});
function $06d554a00cf6d24e$var$useGridDimensions(apiRef, props) {
    const getRootDimensions = $06d554a00cf6d24e$var$React.useCallback(()=>(0, $46349fe7fabb2b4d$exports.gridDimensionsSelector)(apiRef), [
        apiRef
    ]);
    const apiPublic = {
        getRootDimensions: getRootDimensions
    };
    const apiPrivate = {
        updateDimensions: ()=>{
            return apiRef.current.virtualizer.api.updateDimensions();
        },
        getViewportPageSize: ()=>{
            return apiRef.current.virtualizer.api.getViewportPageSize();
        }
    };
    (0, $d79b1aa4f5237e85$exports.useGridApiMethod)(apiRef, apiPublic, 'public');
    (0, $d79b1aa4f5237e85$exports.useGridApiMethod)(apiRef, apiPrivate, 'private');
    const handleRootMount = (root)=>{
        $06d554a00cf6d24e$var$setCSSVariables(root, (0, $46349fe7fabb2b4d$exports.gridDimensionsSelector)(apiRef));
    };
    (0, $bc055d85bc2d0e70$exports.useGridEventPriority)(apiRef, 'rootMount', handleRootMount);
    (0, $bc055d85bc2d0e70$exports.useGridEventPriority)(apiRef, 'debouncedResize', props.onResize);
    {
        /* eslint-disable react-hooks/rules-of-hooks */ const logger = (0, $fa53bf7350a63511$exports.useGridLogger)(apiRef, 'useResizeContainer');
        const errorShown = $06d554a00cf6d24e$var$React.useRef(false);
        (0, $bc055d85bc2d0e70$exports.useGridEventPriority)(apiRef, 'resize', (size)=>{
            if (!getRootDimensions().isReady) return;
            if (size.height === 0 && !errorShown.current && !props.autoHeight && !$d10a1095bdae3394$exports.isJSDOM) {
                logger.error([
                    'The parent DOM element of the Data Grid has an empty height.',
                    'Please make sure that this element has an intrinsic height.',
                    'The grid displays with a height of 0px.',
                    '',
                    'More details: https://mui.com/r/x-data-grid-no-dimensions.'
                ].join('\n'));
                errorShown.current = true;
            }
            if (size.width === 0 && !errorShown.current && !$d10a1095bdae3394$exports.isJSDOM) {
                logger.error([
                    'The parent DOM element of the Data Grid has an empty width.',
                    'Please make sure that this element has an intrinsic width.',
                    'The grid displays with a width of 0px.',
                    '',
                    'More details: https://mui.com/r/x-data-grid-no-dimensions.'
                ].join('\n'));
                errorShown.current = true;
            }
        });
    /* eslint-enable react-hooks/rules-of-hooks */ }
    (0, $66c3b1bd8ca83ba8$exports.useStoreEffect)(apiRef.current.store, (s)=>s.dimensions, (previous, next)=>{
        if (!next.isReady) return;
        if (apiRef.current.rootElementRef.current) $06d554a00cf6d24e$var$setCSSVariables(apiRef.current.rootElementRef.current, next);
        if (!$06d554a00cf6d24e$var$areElementSizesEqual(next.viewportInnerSize, previous.viewportInnerSize)) apiRef.current.publishEvent('viewportInnerSizeChange', next.viewportInnerSize);
        apiRef.current.publishEvent('debouncedResize', next.root);
    });
}
function $06d554a00cf6d24e$var$setCSSVariables(root, dimensions) {
    const set = (k, v)=>root.style.setProperty(k, v);
    set('--DataGrid-hasScrollX', `${Number(dimensions.hasScrollX)}`);
    set('--DataGrid-hasScrollY', `${Number(dimensions.hasScrollY)}`);
    set('--DataGrid-scrollbarSize', `${dimensions.scrollbarSize}px`);
    set('--DataGrid-rowWidth', `${dimensions.rowWidth}px`);
    set('--DataGrid-columnsTotalWidth', `${dimensions.columnsTotalWidth}px`);
    set('--DataGrid-leftPinnedWidth', `${dimensions.leftPinnedWidth}px`);
    set('--DataGrid-rightPinnedWidth', `${dimensions.rightPinnedWidth}px`);
    set('--DataGrid-headerHeight', `${dimensions.headerHeight}px`);
    set('--DataGrid-headersTotalHeight', `${dimensions.headersTotalHeight}px`);
    set('--DataGrid-topContainerHeight', `${dimensions.topContainerHeight}px`);
    set('--DataGrid-bottomContainerHeight', `${dimensions.bottomContainerHeight}px`);
    set('--height', `${dimensions.rowHeight}px`);
}
function $06d554a00cf6d24e$var$getStaticDimensions(props, apiRef, density, pinnedColumnns) {
    const validRowHeight = (0, $0166dd44615cae0d$exports.getValidRowHeight)(props.rowHeight, $0f96df060f8ddda5$exports.DATA_GRID_PROPS_DEFAULT_VALUES.rowHeight, $0166dd44615cae0d$exports.rowHeightWarning);
    return {
        rowHeight: Math.floor(validRowHeight * density),
        headerHeight: Math.floor(props.columnHeaderHeight * density),
        groupHeaderHeight: Math.floor((props.columnGroupHeaderHeight ?? props.columnHeaderHeight) * density),
        headerFilterHeight: Math.floor((props.headerFilterHeight ?? props.columnHeaderHeight) * density),
        columnsTotalWidth: $06d554a00cf6d24e$var$columnsTotalWidthSelector(apiRef),
        headersTotalHeight: (0, $d1cd1e3fd8558ad5$exports.getTotalHeaderHeight)(apiRef, props),
        leftPinnedWidth: pinnedColumnns.left.reduce((w, col)=>w + col.computedWidth, 0),
        rightPinnedWidth: pinnedColumnns.right.reduce((w, col)=>w + col.computedWidth, 0)
    };
}
function $06d554a00cf6d24e$var$areElementSizesEqual(a, b) {
    return a.width === b.width && a.height === b.height;
}



var $f6af98c761dea48b$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $f6af98c761dea48b$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($f6af98c761dea48b$exports, "__esModule", {
    value: true
});
$f6af98c761dea48b$exports.useGridStatePersistence = void 0;

var $f6af98c761dea48b$var$React = $f6af98c761dea48b$require$_interopRequireWildcard((parcelRequire("acw62")));

const $f6af98c761dea48b$var$useGridStatePersistence = (apiRef)=>{
    const exportState = $f6af98c761dea48b$var$React.useCallback((params = {})=>{
        const stateToExport = apiRef.current.unstable_applyPipeProcessors('exportState', {}, params);
        return stateToExport;
    }, [
        apiRef
    ]);
    const restoreState = $f6af98c761dea48b$var$React.useCallback((stateToRestore)=>{
        const response = apiRef.current.unstable_applyPipeProcessors('restoreState', {
            callbacks: []
        }, {
            stateToRestore: stateToRestore
        });
        response.callbacks.forEach((callback)=>{
            callback();
        });
    }, [
        apiRef
    ]);
    const statePersistenceApi = {
        exportState: exportState,
        restoreState: restoreState
    };
    (0, $431c82ec73ef367c$exports.useGridApiMethod)(apiRef, statePersistenceApi, 'public');
};
$f6af98c761dea48b$exports.useGridStatePersistence = $f6af98c761dea48b$var$useGridStatePersistence;


var $1f67185743ff4f77$exports = {};
"use strict";
Object.defineProperty($1f67185743ff4f77$exports, "__esModule", {
    value: true
});
$1f67185743ff4f77$exports.useGridColumnSpanning = void 0;


/**
 * @requires useGridColumns (method, event)
 * @requires useGridParamsApi (method)
 */ const $1f67185743ff4f77$var$useGridColumnSpanning = (apiRef)=>{
    const resetColSpan = ()=>{
        return apiRef.current.virtualizer.api.resetColSpan();
    };
    const getCellColSpanInfo = (...params)=>{
        return apiRef.current.virtualizer.api.getCellColSpanInfo(...params);
    };
    const calculateColSpan = (...params)=>{
        apiRef.current.virtualizer.api.calculateColSpan(...params);
    };
    const columnSpanningPublicApi = {
        unstable_getCellColSpanInfo: getCellColSpanInfo
    };
    const columnSpanningPrivateApi = {
        resetColSpan: resetColSpan,
        calculateColSpan: calculateColSpan
    };
    (0, $d79b1aa4f5237e85$exports.useGridApiMethod)(apiRef, columnSpanningPublicApi, 'public');
    (0, $d79b1aa4f5237e85$exports.useGridApiMethod)(apiRef, columnSpanningPrivateApi, 'private');
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'columnOrderChange', resetColSpan);
};
$1f67185743ff4f77$exports.useGridColumnSpanning = $1f67185743ff4f77$var$useGridColumnSpanning;


var $7c3e3abbe30f48e1$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $7c3e3abbe30f48e1$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $7c3e3abbe30f48e1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($7c3e3abbe30f48e1$exports, "__esModule", {
    value: true
});
$7c3e3abbe30f48e1$exports.useGridColumnGrouping = $7c3e3abbe30f48e1$exports.columnGroupsStateInitializer = void 0;

var $7c3e3abbe30f48e1$var$_extends2 = $7c3e3abbe30f48e1$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $7c3e3abbe30f48e1$var$React = $7c3e3abbe30f48e1$require$_interopRequireWildcard((parcelRequire("acw62")));


var $05eea8a1c02f601e$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $05eea8a1c02f601e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($05eea8a1c02f601e$exports, "__esModule", {
    value: true
});
$05eea8a1c02f601e$exports.unwrapGroupingColumnModel = $05eea8a1c02f601e$exports.getColumnGroupsHeaderStructure = $05eea8a1c02f601e$exports.createGroupLookup = void 0;

var $05eea8a1c02f601e$var$_extends2 = $05eea8a1c02f601e$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $05eea8a1c02f601e$var$_objectWithoutPropertiesLoose2 = $05eea8a1c02f601e$require$_interopRequireDefault((parcelRequire("c05no")));

const $05eea8a1c02f601e$var$_excluded = [
    "groupId",
    "children"
];
const $05eea8a1c02f601e$var$createGroupLookup = (columnGroupingModel)=>{
    const groupLookup = {};
    for(let i = 0; i < columnGroupingModel.length; i += 1){
        const node = columnGroupingModel[i];
        if ((0, $de4444ff1794c3fb$exports.isLeaf)(node)) continue;
        const { groupId: groupId, children: children } = node, other = (0, $05eea8a1c02f601e$var$_objectWithoutPropertiesLoose2.default)(node, $05eea8a1c02f601e$var$_excluded);
        if (!groupId) throw new Error('MUI X: An element of the columnGroupingModel does not have either `field` or `groupId`.');
        if (!children) console.warn(`MUI X: group groupId=${groupId} has no children.`);
        const groupParam = (0, $05eea8a1c02f601e$var$_extends2.default)({}, other, {
            groupId: groupId
        });
        const subTreeLookup = $05eea8a1c02f601e$var$createGroupLookup(children);
        if (subTreeLookup[groupId] !== undefined || groupLookup[groupId] !== undefined) throw new Error(`MUI X: The groupId ${groupId} is used multiple times in the columnGroupingModel.`);
        Object.assign(groupLookup, subTreeLookup);
        groupLookup[groupId] = groupParam;
    }
    return groupLookup;
};
// This is the recurrence function that help writing `unwrapGroupingColumnModel()`
$05eea8a1c02f601e$exports.createGroupLookup = $05eea8a1c02f601e$var$createGroupLookup;
const $05eea8a1c02f601e$var$recurrentUnwrapGroupingColumnModel = (columnGroupNode, parents, unwrappedGroupingModelToComplete)=>{
    if ((0, $de4444ff1794c3fb$exports.isLeaf)(columnGroupNode)) {
        if (unwrappedGroupingModelToComplete[columnGroupNode.field] !== undefined) throw new Error([
            `MUI X: columnGroupingModel contains duplicated field`,
            `column field ${columnGroupNode.field} occurs two times in the grouping model:`,
            `- ${unwrappedGroupingModelToComplete[columnGroupNode.field].join(' > ')}`,
            `- ${parents.join(' > ')}`
        ].join('\n'));
        unwrappedGroupingModelToComplete[columnGroupNode.field] = parents;
        return;
    }
    const { groupId: groupId, children: children } = columnGroupNode;
    children.forEach((child)=>{
        $05eea8a1c02f601e$var$recurrentUnwrapGroupingColumnModel(child, [
            ...parents,
            groupId
        ], unwrappedGroupingModelToComplete);
    });
};
/**
 * This is a function that provide for each column the array of its parents.
 * Parents are ordered from the root to the leaf.
 * @param columnGroupingModel The model such as provided in DataGrid props
 * @returns An object `{[field]: groupIds}` where `groupIds` is the parents of the column `field`
 */ const $05eea8a1c02f601e$var$unwrapGroupingColumnModel = (columnGroupingModel)=>{
    if (!columnGroupingModel) return {};
    const unwrappedSubTree = {};
    columnGroupingModel.forEach((columnGroupNode)=>{
        $05eea8a1c02f601e$var$recurrentUnwrapGroupingColumnModel(columnGroupNode, [], unwrappedSubTree);
    });
    return unwrappedSubTree;
};
$05eea8a1c02f601e$exports.unwrapGroupingColumnModel = $05eea8a1c02f601e$var$unwrapGroupingColumnModel;
const $05eea8a1c02f601e$var$getColumnGroupsHeaderStructure = (orderedColumns, unwrappedGroupingModel, pinnedFields)=>{
    const getParents = (field)=>unwrappedGroupingModel[field] ?? [];
    const groupingHeaderStructure = [];
    const maxDepth = Math.max(0, ...orderedColumns.map((field)=>getParents(field).length));
    const haveSameParents = (field1, field2, depth)=>{
        const a = getParents(field1);
        const b = getParents(field2);
        for(let i = 0; i <= depth; i += 1){
            if (a[i] !== b[i]) return false;
        }
        return true;
    };
    const haveDifferentContainers = (field1, field2)=>{
        const left = pinnedFields?.left;
        const right = pinnedFields?.right;
        const inLeft1 = !!left?.includes(field1);
        const inLeft2 = !!left?.includes(field2);
        const inRight1 = !!right?.includes(field1);
        const inRight2 = !!right?.includes(field2);
        return inLeft1 !== inLeft2 || inRight1 !== inRight2;
    };
    for(let depth = 0; depth < maxDepth; depth += 1){
        const depthStructure = [];
        for(let i = 0; i < orderedColumns.length; i += 1){
            const field = orderedColumns[i];
            const groupId = getParents(field)[depth] ?? null;
            if (depthStructure.length === 0) {
                depthStructure.push({
                    columnFields: [
                        field
                    ],
                    groupId: groupId
                });
                continue;
            }
            const lastGroup = depthStructure[depthStructure.length - 1];
            const prevField = lastGroup.columnFields[lastGroup.columnFields.length - 1];
            if (lastGroup.groupId !== groupId || !haveSameParents(prevField, field, depth) || haveDifferentContainers(prevField, field)) depthStructure.push({
                columnFields: [
                    field
                ],
                groupId: groupId
            });
            else lastGroup.columnFields.push(field);
        }
        groupingHeaderStructure.push(depthStructure);
    }
    return groupingHeaderStructure;
};
$05eea8a1c02f601e$exports.getColumnGroupsHeaderStructure = $05eea8a1c02f601e$var$getColumnGroupsHeaderStructure;




const $7c3e3abbe30f48e1$var$columnGroupsStateInitializer = (state, props, apiRef)=>{
    apiRef.current.caches.columnGrouping = {
        lastColumnGroupingModel: props.columnGroupingModel
    };
    if (!props.columnGroupingModel) return (0, $7c3e3abbe30f48e1$var$_extends2.default)({}, state, {
        columnGrouping: undefined
    });
    const columnFields = (0, $e3b5f2e67362f55f$exports.gridColumnFieldsSelector)(apiRef);
    const visibleColumnFields = (0, $e3b5f2e67362f55f$exports.gridVisibleColumnFieldsSelector)(apiRef);
    const groupLookup = (0, $05eea8a1c02f601e$exports.createGroupLookup)(props.columnGroupingModel ?? []);
    const unwrappedGroupingModel = (0, $05eea8a1c02f601e$exports.unwrapGroupingColumnModel)(props.columnGroupingModel ?? []);
    const columnGroupsHeaderStructure = (0, $05eea8a1c02f601e$exports.getColumnGroupsHeaderStructure)(columnFields, unwrappedGroupingModel, apiRef.current.state.pinnedColumns ?? {});
    const maxDepth = visibleColumnFields.length === 0 ? 0 : Math.max(...visibleColumnFields.map((field)=>unwrappedGroupingModel[field]?.length ?? 0));
    return (0, $7c3e3abbe30f48e1$var$_extends2.default)({}, state, {
        columnGrouping: {
            lookup: groupLookup,
            unwrappedGroupingModel: unwrappedGroupingModel,
            headerStructure: columnGroupsHeaderStructure,
            maxDepth: maxDepth
        }
    });
};
/**
 * @requires useGridColumns (method, event)
 * @requires useGridParamsApi (method)
 */ $7c3e3abbe30f48e1$exports.columnGroupsStateInitializer = $7c3e3abbe30f48e1$var$columnGroupsStateInitializer;
const $7c3e3abbe30f48e1$var$useGridColumnGrouping = (apiRef, props)=>{
    /**
   * API METHODS
   */ const getColumnGroupPath = $7c3e3abbe30f48e1$var$React.useCallback((field)=>{
        const unwrappedGroupingModel = (0, $cf21d895912d975b$exports.gridColumnGroupsUnwrappedModelSelector)(apiRef);
        return unwrappedGroupingModel[field] ?? [];
    }, [
        apiRef
    ]);
    const getAllGroupDetails = $7c3e3abbe30f48e1$var$React.useCallback(()=>{
        const columnGroupLookup = (0, $cf21d895912d975b$exports.gridColumnGroupsLookupSelector)(apiRef);
        return columnGroupLookup;
    }, [
        apiRef
    ]);
    const columnGroupingApi = {
        getColumnGroupPath: getColumnGroupPath,
        getAllGroupDetails: getAllGroupDetails
    };
    (0, $d79b1aa4f5237e85$exports.useGridApiMethod)(apiRef, columnGroupingApi, 'public');
    const handleColumnIndexChange = $7c3e3abbe30f48e1$var$React.useCallback(()=>{
        const unwrappedGroupingModel = (0, $05eea8a1c02f601e$exports.unwrapGroupingColumnModel)(props.columnGroupingModel ?? []);
        apiRef.current.setState((state)=>{
            const orderedFields = state.columns?.orderedFields ?? [];
            const pinnedColumns = state.pinnedColumns ?? {};
            const columnGroupsHeaderStructure = (0, $05eea8a1c02f601e$exports.getColumnGroupsHeaderStructure)(orderedFields, unwrappedGroupingModel, pinnedColumns);
            return (0, $7c3e3abbe30f48e1$var$_extends2.default)({}, state, {
                columnGrouping: (0, $7c3e3abbe30f48e1$var$_extends2.default)({}, state.columnGrouping, {
                    headerStructure: columnGroupsHeaderStructure
                })
            });
        });
    }, [
        apiRef,
        props.columnGroupingModel
    ]);
    const updateColumnGroupingState = $7c3e3abbe30f48e1$var$React.useCallback((columnGroupingModel)=>{
        if (!columnGroupingModel && !apiRef.current.caches.columnGrouping.lastColumnGroupingModel) return;
        apiRef.current.caches.columnGrouping.lastColumnGroupingModel = columnGroupingModel;
        // @ts-expect-error Move this logic to `Pro` package
        const pinnedColumns = apiRef.current.getPinnedColumns?.() ?? {};
        const columnFields = (0, $e3b5f2e67362f55f$exports.gridColumnFieldsSelector)(apiRef);
        const visibleColumnFields = (0, $e3b5f2e67362f55f$exports.gridVisibleColumnFieldsSelector)(apiRef);
        const groupLookup = (0, $05eea8a1c02f601e$exports.createGroupLookup)(columnGroupingModel ?? []);
        const unwrappedGroupingModel = (0, $05eea8a1c02f601e$exports.unwrapGroupingColumnModel)(columnGroupingModel ?? []);
        const columnGroupsHeaderStructure = (0, $05eea8a1c02f601e$exports.getColumnGroupsHeaderStructure)(columnFields, unwrappedGroupingModel, pinnedColumns);
        const maxDepth = visibleColumnFields.length === 0 ? 0 : Math.max(...visibleColumnFields.map((field)=>unwrappedGroupingModel[field]?.length ?? 0));
        apiRef.current.setState((state)=>{
            return (0, $7c3e3abbe30f48e1$var$_extends2.default)({}, state, {
                columnGrouping: {
                    lookup: groupLookup,
                    unwrappedGroupingModel: unwrappedGroupingModel,
                    headerStructure: columnGroupsHeaderStructure,
                    maxDepth: maxDepth
                }
            });
        });
    }, [
        apiRef
    ]);
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'columnIndexChange', handleColumnIndexChange);
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'columnsChange', ()=>{
        updateColumnGroupingState(props.columnGroupingModel);
    });
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'columnVisibilityModelChange', ()=>{
        updateColumnGroupingState(props.columnGroupingModel);
    });
    /**
   * EFFECTS
   */ $7c3e3abbe30f48e1$var$React.useEffect(()=>{
        if (props.columnGroupingModel === apiRef.current.caches.columnGrouping.lastColumnGroupingModel) return;
        updateColumnGroupingState(props.columnGroupingModel);
    }, [
        apiRef,
        updateColumnGroupingState,
        props.columnGroupingModel
    ]);
};
$7c3e3abbe30f48e1$exports.useGridColumnGrouping = $7c3e3abbe30f48e1$var$useGridColumnGrouping;



var $e4be7afefd9a1627$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $e4be7afefd9a1627$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $e4be7afefd9a1627$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($e4be7afefd9a1627$exports, "__esModule", {
    value: true
});
$e4be7afefd9a1627$exports.useGridColumnResize = $e4be7afefd9a1627$exports.columnResizeStateInitializer = void 0;

var $e4be7afefd9a1627$var$_extends2 = $e4be7afefd9a1627$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $e4be7afefd9a1627$var$React = $e4be7afefd9a1627$require$_interopRequireWildcard((parcelRequire("acw62")));

var $e4be7afefd9a1627$var$_useEventCallback = $e4be7afefd9a1627$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $e4be7afefd9a1627$var$_ownerDocument = $e4be7afefd9a1627$require$_interopRequireDefault((parcelRequire("43fuO")));

var $e4be7afefd9a1627$var$_useLazyRef = $e4be7afefd9a1627$require$_interopRequireDefault((parcelRequire("doV3C")));

var $9uEev = parcelRequire("9uEev");



var $5H1vo = parcelRequire("5H1vo");


var $15db17edb5d37fe8$exports = {};
"use strict";
Object.defineProperty($15db17edb5d37fe8$exports, "__esModule", {
    value: true
});
$15db17edb5d37fe8$exports.createControllablePromise = $15db17edb5d37fe8$var$createControllablePromise;
function $15db17edb5d37fe8$var$createControllablePromise() {
    let resolve;
    let reject;
    const promise = new Promise((_resolve, _reject)=>{
        resolve = _resolve;
        reject = _reject;
    });
    promise.resolve = resolve;
    promise.reject = reject;
    return promise;
}







function $e4be7afefd9a1627$var$trackFinger(event, currentTouchId) {
    if (currentTouchId !== undefined && event.changedTouches) {
        for(let i = 0; i < event.changedTouches.length; i += 1){
            const touch = event.changedTouches[i];
            if (touch.identifier === currentTouchId) return {
                x: touch.clientX,
                y: touch.clientY
            };
        }
        return false;
    }
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $e4be7afefd9a1627$var$computeNewWidth(initialOffsetToSeparator, clickX, columnBounds, resizeDirection) {
    let newWidth = initialOffsetToSeparator;
    if (resizeDirection === 'Right') newWidth += clickX - columnBounds.left;
    else newWidth += columnBounds.right - clickX;
    return Math.round(newWidth);
}
function $e4be7afefd9a1627$var$computeOffsetToSeparator(clickX, columnBounds, resizeDirection) {
    if (resizeDirection === 'Left') return clickX - columnBounds.left;
    return columnBounds.right - clickX;
}
function $e4be7afefd9a1627$var$flipResizeDirection(side) {
    if (side === 'Right') return 'Left';
    return 'Right';
}
function $e4be7afefd9a1627$var$getResizeDirection(separator, isRtl) {
    const side = separator.classList.contains($5H1vo.gridClasses['columnSeparator--sideRight']) ? 'Right' : 'Left';
    if (isRtl) // Resizing logic should be mirrored in the RTL case
    return $e4be7afefd9a1627$var$flipResizeDirection(side);
    return side;
}
function $e4be7afefd9a1627$var$getPinnedWidthProperty(isRtl, pinnedPosition) {
    if (pinnedPosition === $3a32d3fdbf8b29fd$exports.GridPinnedColumnPosition.LEFT) return isRtl ? '--DataGrid-rightPinnedWidth' : '--DataGrid-leftPinnedWidth';
    return isRtl ? '--DataGrid-leftPinnedWidth' : '--DataGrid-rightPinnedWidth';
}
function $e4be7afefd9a1627$var$getPinnedWidth(dimensions, isRtl, pinnedPosition) {
    if (pinnedPosition === $3a32d3fdbf8b29fd$exports.GridPinnedColumnPosition.LEFT) return isRtl ? dimensions.rightPinnedWidth : dimensions.leftPinnedWidth;
    return isRtl ? dimensions.leftPinnedWidth : dimensions.rightPinnedWidth;
}
function $e4be7afefd9a1627$var$preventClick(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}
/**
 * Checker that returns a promise that resolves when the column virtualization
 * is disabled.
 */ function $e4be7afefd9a1627$var$useColumnVirtualizationDisabled(apiRef) {
    const promise = $e4be7afefd9a1627$var$React.useRef(undefined);
    const selector = ()=>(0, $94d9a2be66e71282$exports.gridVirtualizationColumnEnabledSelector)(apiRef);
    const value = (0, $431c82ec73ef367c$exports.useGridSelector)(apiRef, selector);
    $e4be7afefd9a1627$var$React.useEffect(()=>{
        if (promise.current && value === false) {
            promise.current.resolve();
            promise.current = undefined;
        }
    });
    const asyncCheck = ()=>{
        if (!promise.current) {
            if (selector() === false) return Promise.resolve();
            promise.current = (0, $15db17edb5d37fe8$exports.createControllablePromise)();
        }
        return promise.current;
    };
    return asyncCheck;
}
/**
 * Basic statistical outlier detection, checks if the value is `F * IQR` away from
 * the Q1 and Q3 boundaries. IQR: interquartile range.
 */ function $e4be7afefd9a1627$var$excludeOutliers(inputValues, factor) {
    if (inputValues.length < 4) return inputValues;
    const values = inputValues.slice();
    values.sort((a, b)=>a - b);
    const q1 = values[Math.floor(values.length * 0.25)];
    const q3 = values[Math.floor(values.length * 0.75) - 1];
    const iqr = q3 - q1;
    // We make a small adjustment if `iqr < 5` for the cases where the IQR is
    // very small (for example zero) due to very close by values in the input data.
    // Otherwise, with an IQR of `0`, anything outside that would be considered
    // an outlier, but it makes more sense visually to allow for this 5px variance
    // rather than showing a cropped cell.
    const deviation = iqr < 5 ? 5 : iqr * factor;
    return values.filter((v)=>v > q1 - deviation && v < q3 + deviation);
}
function $e4be7afefd9a1627$var$extractColumnWidths(apiRef, options, columns) {
    const widthByField = {};
    const root = apiRef.current.rootElementRef.current;
    root.classList.add($5H1vo.gridClasses.autosizing);
    columns.forEach((column)=>{
        const cells = (0, $08bb4bf24f47b880$exports.findGridCells)(apiRef.current, column.field);
        const widths = cells.map((cell)=>{
            return cell.getBoundingClientRect().width ?? 0;
        });
        const filteredWidths = options.includeOutliers ? widths : $e4be7afefd9a1627$var$excludeOutliers(widths, options.outliersFactor);
        if (options.includeHeaders) {
            const header = (0, $08bb4bf24f47b880$exports.findGridHeader)(apiRef.current, column.field);
            if (header) {
                const titleContainer = header.querySelector(`.${$5H1vo.gridClasses.columnHeaderTitleContainer}`);
                const children = Array.from(titleContainer.children);
                const menuContainer = header.querySelector(`.${$5H1vo.gridClasses.menuIcon}`);
                const titleContainerStyle = window.getComputedStyle(titleContainer, null);
                const gap = parseInt(titleContainerStyle.gap, 10) || 0;
                const headerStyle = window.getComputedStyle(header, null);
                const paddingWidth = parseInt(headerStyle.paddingLeft, 10) + parseInt(headerStyle.paddingRight, 10);
                let totalChildren = 0;
                let childrenWidth = 0;
                for(let i = 0; i < children.length; i += 1){
                    const child = children[i];
                    if (child.clientWidth > 0) {
                        totalChildren += 1;
                        childrenWidth += child.scrollWidth;
                    }
                }
                childrenWidth += 1;
                const width = childrenWidth + gap * (totalChildren - 1) + paddingWidth + (menuContainer?.clientWidth ?? 0);
                filteredWidths.push(width);
            }
        }
        const hasColumnMin = column.minWidth !== -Infinity && column.minWidth !== undefined;
        const hasColumnMax = column.maxWidth !== Infinity && column.maxWidth !== undefined;
        const min = hasColumnMin ? column.minWidth : 0;
        const max = hasColumnMax ? column.maxWidth : Infinity;
        const maxContent = filteredWidths.length === 0 ? 0 : Math.max(...filteredWidths);
        widthByField[column.field] = (0, $fe919794eb3b24e8$exports.clamp)(maxContent, min, max);
    });
    root.classList.remove($5H1vo.gridClasses.autosizing);
    return widthByField;
}
const $e4be7afefd9a1627$var$columnResizeStateInitializer = (state)=>(0, $e4be7afefd9a1627$var$_extends2.default)({}, state, {
        columnResize: {
            resizingColumnField: ''
        }
    });
$e4be7afefd9a1627$exports.columnResizeStateInitializer = $e4be7afefd9a1627$var$columnResizeStateInitializer;
function $e4be7afefd9a1627$var$createResizeRefs() {
    return {
        colDef: undefined,
        initialColWidth: 0,
        initialTotalWidth: 0,
        previousMouseClickEvent: undefined,
        columnHeaderElement: undefined,
        headerFilterElement: undefined,
        groupHeaderElements: [],
        cellElements: [],
        leftPinnedCellsAfter: [],
        rightPinnedCellsBefore: [],
        fillerLeft: undefined,
        fillerRight: undefined,
        leftPinnedHeadersAfter: [],
        rightPinnedHeadersBefore: []
    };
}
/**
 * @requires useGridColumns (method, event)
 * TODO: improve experience for last column
 */ const $e4be7afefd9a1627$var$useGridColumnResize = (apiRef, props)=>{
    const isRtl = (0, $9uEev.useRtl)();
    const logger = (0, $431c82ec73ef367c$exports.useGridLogger)(apiRef, 'useGridColumnResize');
    const refs = (0, $e4be7afefd9a1627$var$_useLazyRef.default)($e4be7afefd9a1627$var$createResizeRefs).current;
    // To improve accessibility, the separator has padding on both sides.
    // Clicking inside the padding area should be treated as a click in the separator.
    // This ref stores the offset between the click and the separator.
    const initialOffsetToSeparator = $e4be7afefd9a1627$var$React.useRef(null);
    const resizeDirection = $e4be7afefd9a1627$var$React.useRef(null);
    const stopResizeEventTimeout = (0, $3ede1456da2c476e$exports.useTimeout)();
    const touchId = $e4be7afefd9a1627$var$React.useRef(undefined);
    const updateWidth = (newWidth)=>{
        logger.debug(`Updating width to ${newWidth} for col ${refs.colDef.field}`);
        const prevWidth = refs.columnHeaderElement.offsetWidth;
        const widthDiff = newWidth - prevWidth;
        const columnWidthDiff = newWidth - refs.initialColWidth;
        if (columnWidthDiff > 0) {
            const newTotalWidth = refs.initialTotalWidth + columnWidthDiff;
            apiRef.current.rootElementRef?.current?.style.setProperty('--DataGrid-rowWidth', `${newTotalWidth}px`);
        }
        refs.colDef.computedWidth = newWidth;
        refs.colDef.width = newWidth;
        refs.colDef.flex = 0;
        refs.columnHeaderElement.style.width = `${newWidth}px`;
        const headerFilterElement = refs.headerFilterElement;
        if (headerFilterElement) headerFilterElement.style.width = `${newWidth}px`;
        refs.groupHeaderElements.forEach((element)=>{
            const div = element;
            let finalWidth;
            if (div.getAttribute('aria-colspan') === '1') finalWidth = `${newWidth}px`;
            else // Cell with colspan > 1 cannot be just updated width new width.
            // Instead, we add width diff to the current width.
            finalWidth = `${div.offsetWidth + widthDiff}px`;
            div.style.width = finalWidth;
        });
        refs.cellElements.forEach((element)=>{
            const div = element;
            let finalWidth;
            if (div.getAttribute('aria-colspan') === '1') finalWidth = `${newWidth}px`;
            else // Cell with colspan > 1 cannot be just updated width new width.
            // Instead, we add width diff to the current width.
            finalWidth = `${div.offsetWidth + widthDiff}px`;
            div.style.setProperty('--width', finalWidth);
        });
        const dimensions = (0, $d9a3301c6c2f6d8b$exports.gridDimensionsSelector)(apiRef);
        const pinnedPosition = apiRef.current.unstable_applyPipeProcessors('isColumnPinned', false, refs.colDef.field);
        if (pinnedPosition === $3a32d3fdbf8b29fd$exports.GridPinnedColumnPosition.LEFT) {
            $e4be7afefd9a1627$var$updateProperty(refs.fillerLeft, 'width', widthDiff);
            refs.leftPinnedCellsAfter.forEach((cell)=>{
                $e4be7afefd9a1627$var$updateProperty(cell, 'left', widthDiff);
            });
            refs.leftPinnedHeadersAfter.forEach((header)=>{
                $e4be7afefd9a1627$var$updateProperty(header, 'left', widthDiff);
            });
            apiRef.current.rootElementRef?.current?.style.setProperty($e4be7afefd9a1627$var$getPinnedWidthProperty(isRtl, pinnedPosition), `${$e4be7afefd9a1627$var$getPinnedWidth(dimensions, isRtl, pinnedPosition) + columnWidthDiff}px`);
        }
        if (pinnedPosition === $3a32d3fdbf8b29fd$exports.GridPinnedColumnPosition.RIGHT) {
            $e4be7afefd9a1627$var$updateProperty(refs.fillerRight, 'width', widthDiff);
            refs.rightPinnedCellsBefore.forEach((cell)=>{
                $e4be7afefd9a1627$var$updateProperty(cell, 'right', widthDiff);
            });
            refs.rightPinnedHeadersBefore.forEach((header)=>{
                $e4be7afefd9a1627$var$updateProperty(header, 'right', widthDiff);
            });
            apiRef.current.rootElementRef?.current?.style.setProperty($e4be7afefd9a1627$var$getPinnedWidthProperty(isRtl, pinnedPosition), `${$e4be7afefd9a1627$var$getPinnedWidth(dimensions, isRtl, pinnedPosition) + columnWidthDiff}px`);
        }
    };
    const finishResize = (nativeEvent)=>{
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        stopListening();
        // Prevent double-clicks from being interpreted as two separate clicks
        if (refs.previousMouseClickEvent) {
            const prevEvent = refs.previousMouseClickEvent;
            const prevTimeStamp = prevEvent.timeStamp;
            const prevClientX = prevEvent.clientX;
            const prevClientY = prevEvent.clientY;
            // Check if the current event is part of a double-click
            if (nativeEvent.timeStamp - prevTimeStamp < 300 && nativeEvent.clientX === prevClientX && nativeEvent.clientY === prevClientY) {
                refs.previousMouseClickEvent = undefined;
                apiRef.current.publishEvent('columnResizeStop', null, nativeEvent);
                return;
            }
        }
        if (refs.colDef) {
            apiRef.current.setColumnWidth(refs.colDef.field, refs.colDef.width);
            logger.debug(`Updating col ${refs.colDef.field} with new width: ${refs.colDef.width}`);
            // Since during resizing we update the columns width outside of React, React is unable to
            // reapply the right style properties. We need to sync the state manually.
            // So we reapply the same logic as in https://github.com/mui/mui-x/blob/0511bf65543ca05d2602a5a3e0a6156f2fc8e759/packages/x-data-grid/src/hooks/features/columnHeaders/useGridColumnHeaders.tsx#L405
            const columnsState = (0, $e3b5f2e67362f55f$exports.gridColumnsStateSelector)(apiRef);
            refs.groupHeaderElements.forEach((element)=>{
                const fields = (0, $08bb4bf24f47b880$exports.getFieldsFromGroupHeaderElem)(element);
                const div = element;
                const newWidth = fields.reduce((acc, field)=>{
                    if (columnsState.columnVisibilityModel[field] !== false) return acc + columnsState.lookup[field].computedWidth;
                    return acc;
                }, 0);
                const finalWidth = `${newWidth}px`;
                div.style.width = finalWidth;
            });
        }
        stopResizeEventTimeout.start(0, ()=>{
            apiRef.current.publishEvent('columnResizeStop', null, nativeEvent);
        });
    };
    const storeReferences = (colDef, separator, xStart)=>{
        const root = apiRef.current.rootElementRef.current;
        refs.initialColWidth = colDef.computedWidth;
        refs.initialTotalWidth = apiRef.current.getRootDimensions().rowWidth;
        refs.colDef = colDef;
        refs.columnHeaderElement = (0, $08bb4bf24f47b880$exports.findHeaderElementFromField)(apiRef.current.columnHeadersContainerRef.current, colDef.field);
        const headerFilterElement = root.querySelector(`.${$5H1vo.gridClasses.headerFilterRow} [data-field="${(0, $08bb4bf24f47b880$exports.escapeOperandAttributeSelector)(colDef.field)}"]`);
        if (headerFilterElement) refs.headerFilterElement = headerFilterElement;
        refs.groupHeaderElements = (0, $08bb4bf24f47b880$exports.findGroupHeaderElementsFromField)(apiRef.current.columnHeadersContainerRef?.current, colDef.field);
        refs.cellElements = (0, $08bb4bf24f47b880$exports.findGridCellElementsFromCol)(refs.columnHeaderElement, apiRef.current);
        refs.fillerLeft = (0, $08bb4bf24f47b880$exports.findGridElement)(apiRef.current, isRtl ? 'filler--pinnedRight' : 'filler--pinnedLeft');
        refs.fillerRight = (0, $08bb4bf24f47b880$exports.findGridElement)(apiRef.current, isRtl ? 'filler--pinnedLeft' : 'filler--pinnedRight');
        const pinnedPosition = apiRef.current.unstable_applyPipeProcessors('isColumnPinned', false, refs.colDef.field);
        refs.leftPinnedCellsAfter = pinnedPosition !== $3a32d3fdbf8b29fd$exports.GridPinnedColumnPosition.LEFT ? [] : (0, $08bb4bf24f47b880$exports.findLeftPinnedCellsAfterCol)(apiRef.current, refs.columnHeaderElement, isRtl);
        refs.rightPinnedCellsBefore = pinnedPosition !== $3a32d3fdbf8b29fd$exports.GridPinnedColumnPosition.RIGHT ? [] : (0, $08bb4bf24f47b880$exports.findRightPinnedCellsBeforeCol)(apiRef.current, refs.columnHeaderElement, isRtl);
        refs.leftPinnedHeadersAfter = pinnedPosition !== $3a32d3fdbf8b29fd$exports.GridPinnedColumnPosition.LEFT ? [] : (0, $08bb4bf24f47b880$exports.findLeftPinnedHeadersAfterCol)(apiRef.current, refs.columnHeaderElement, isRtl);
        refs.rightPinnedHeadersBefore = pinnedPosition !== $3a32d3fdbf8b29fd$exports.GridPinnedColumnPosition.RIGHT ? [] : (0, $08bb4bf24f47b880$exports.findRightPinnedHeadersBeforeCol)(apiRef.current, refs.columnHeaderElement, isRtl);
        resizeDirection.current = $e4be7afefd9a1627$var$getResizeDirection(separator, isRtl);
        initialOffsetToSeparator.current = $e4be7afefd9a1627$var$computeOffsetToSeparator(xStart, refs.columnHeaderElement.getBoundingClientRect(), resizeDirection.current);
    };
    const handleResizeMouseUp = (0, $e4be7afefd9a1627$var$_useEventCallback.default)(finishResize);
    const handleResizeMouseMove = (0, $e4be7afefd9a1627$var$_useEventCallback.default)((nativeEvent)=>{
        // Cancel move in case some other element consumed a mouseup event and it was not fired.
        if (nativeEvent.buttons === 0) {
            handleResizeMouseUp(nativeEvent);
            return;
        }
        let newWidth = $e4be7afefd9a1627$var$computeNewWidth(initialOffsetToSeparator.current, nativeEvent.clientX, refs.columnHeaderElement.getBoundingClientRect(), resizeDirection.current);
        newWidth = (0, $fe919794eb3b24e8$exports.clamp)(newWidth, refs.colDef.minWidth, refs.colDef.maxWidth);
        updateWidth(newWidth);
        const params = {
            element: refs.columnHeaderElement,
            colDef: refs.colDef,
            width: newWidth
        };
        apiRef.current.publishEvent('columnResize', params, nativeEvent);
    });
    const handleTouchEnd = (0, $e4be7afefd9a1627$var$_useEventCallback.default)((nativeEvent)=>{
        const finger = $e4be7afefd9a1627$var$trackFinger(nativeEvent, touchId.current);
        if (!finger) return;
        finishResize(nativeEvent);
    });
    const handleTouchMove = (0, $e4be7afefd9a1627$var$_useEventCallback.default)((nativeEvent)=>{
        const finger = $e4be7afefd9a1627$var$trackFinger(nativeEvent, touchId.current);
        if (!finger) return;
        // Cancel move in case some other element consumed a touchmove event and it was not fired.
        if (nativeEvent.type === 'mousemove' && nativeEvent.buttons === 0) {
            handleTouchEnd(nativeEvent);
            return;
        }
        let newWidth = $e4be7afefd9a1627$var$computeNewWidth(initialOffsetToSeparator.current, finger.x, refs.columnHeaderElement.getBoundingClientRect(), resizeDirection.current);
        newWidth = (0, $fe919794eb3b24e8$exports.clamp)(newWidth, refs.colDef.minWidth, refs.colDef.maxWidth);
        updateWidth(newWidth);
        const params = {
            element: refs.columnHeaderElement,
            colDef: refs.colDef,
            width: newWidth
        };
        apiRef.current.publishEvent('columnResize', params, nativeEvent);
    });
    const handleTouchStart = (0, $e4be7afefd9a1627$var$_useEventCallback.default)((event)=>{
        const cellSeparator = (0, $08bb4bf24f47b880$exports.findParentElementFromClassName)(event.target, $5H1vo.gridClasses['columnSeparator--resizable']);
        // Let the event bubble if the target is not a col separator
        if (!cellSeparator) return;
        const touch = event.changedTouches[0];
        if (touch != null) // A number that uniquely identifies the current finger in the touch session.
        touchId.current = touch.identifier;
        const columnHeaderElement = (0, $08bb4bf24f47b880$exports.findParentElementFromClassName)(event.target, $5H1vo.gridClasses.columnHeader);
        const field = (0, $08bb4bf24f47b880$exports.getFieldFromHeaderElem)(columnHeaderElement);
        const colDef = apiRef.current.getColumn(field);
        logger.debug(`Start Resize on col ${colDef.field}`);
        apiRef.current.publishEvent('columnResizeStart', {
            field: field
        }, event);
        storeReferences(colDef, cellSeparator, touch.clientX);
        const doc = (0, $e4be7afefd9a1627$var$_ownerDocument.default)(event.currentTarget);
        doc.addEventListener('touchmove', handleTouchMove);
        doc.addEventListener('touchend', handleTouchEnd);
    });
    const stopListening = $e4be7afefd9a1627$var$React.useCallback(()=>{
        const doc = (0, $e4be7afefd9a1627$var$_ownerDocument.default)(apiRef.current.rootElementRef.current);
        doc.body.style.removeProperty('cursor');
        doc.removeEventListener('mousemove', handleResizeMouseMove);
        doc.removeEventListener('mouseup', handleResizeMouseUp);
        doc.removeEventListener('touchmove', handleTouchMove);
        doc.removeEventListener('touchend', handleTouchEnd);
        // The click event runs right after the mouseup event, we want to wait until it
        // has been canceled before removing our handler.
        setTimeout(()=>{
            doc.removeEventListener('click', $e4be7afefd9a1627$var$preventClick, true);
        }, 100);
        if (refs.columnHeaderElement) refs.columnHeaderElement.style.pointerEvents = 'unset';
    }, [
        apiRef,
        refs,
        handleResizeMouseMove,
        handleResizeMouseUp,
        handleTouchMove,
        handleTouchEnd
    ]);
    const handleResizeStart = $e4be7afefd9a1627$var$React.useCallback(({ field: field })=>{
        apiRef.current.setState((state)=>(0, $e4be7afefd9a1627$var$_extends2.default)({}, state, {
                columnResize: (0, $e4be7afefd9a1627$var$_extends2.default)({}, state.columnResize, {
                    resizingColumnField: field
                })
            }));
    }, [
        apiRef
    ]);
    const handleResizeStop = $e4be7afefd9a1627$var$React.useCallback(()=>{
        apiRef.current.setState((state)=>(0, $e4be7afefd9a1627$var$_extends2.default)({}, state, {
                columnResize: (0, $e4be7afefd9a1627$var$_extends2.default)({}, state.columnResize, {
                    resizingColumnField: ''
                })
            }));
    }, [
        apiRef
    ]);
    const handleColumnResizeMouseDown = (0, $e4be7afefd9a1627$var$_useEventCallback.default)(({ colDef: colDef }, event)=>{
        // Only handle left clicks
        if (event.button !== 0) return;
        // Skip if the column isn't resizable
        if (!event.currentTarget.classList.contains($5H1vo.gridClasses['columnSeparator--resizable'])) return;
        // Avoid text selection
        event.preventDefault();
        logger.debug(`Start Resize on col ${colDef.field}`);
        apiRef.current.publishEvent('columnResizeStart', {
            field: colDef.field
        }, event);
        storeReferences(colDef, event.currentTarget, event.clientX);
        const doc = (0, $e4be7afefd9a1627$var$_ownerDocument.default)(apiRef.current.rootElementRef.current);
        doc.body.style.cursor = 'col-resize';
        refs.previousMouseClickEvent = event.nativeEvent;
        doc.addEventListener('mousemove', handleResizeMouseMove);
        doc.addEventListener('mouseup', handleResizeMouseUp);
        // Prevent the click event if we have resized the column.
        // Fixes https://github.com/mui/mui-x/issues/4777
        doc.addEventListener('click', $e4be7afefd9a1627$var$preventClick, true);
    });
    const handleColumnSeparatorDoubleClick = (0, $e4be7afefd9a1627$var$_useEventCallback.default)((params, event)=>{
        if (props.disableAutosize) return;
        // Only handle left clicks
        if (event.button !== 0) return;
        const column = apiRef.current.state.columns.lookup[params.field];
        if (column.resizable === false) return;
        apiRef.current.autosizeColumns((0, $e4be7afefd9a1627$var$_extends2.default)({}, props.autosizeOptions, {
            disableColumnVirtualization: false,
            columns: [
                column.field
            ]
        }));
    });
    /**
   * API METHODS
   */ const columnVirtualizationDisabled = $e4be7afefd9a1627$var$useColumnVirtualizationDisabled(apiRef);
    const isAutosizingRef = $e4be7afefd9a1627$var$React.useRef(false);
    const autosizeColumns = $e4be7afefd9a1627$var$React.useCallback(async (userOptions)=>{
        const root = apiRef.current.rootElementRef?.current;
        if (!root) return;
        if (isAutosizingRef.current) return;
        isAutosizingRef.current = true;
        const state = (0, $e3b5f2e67362f55f$exports.gridColumnsStateSelector)(apiRef);
        const options = (0, $e4be7afefd9a1627$var$_extends2.default)({}, $49fbd9b1282fca98$exports.DEFAULT_GRID_AUTOSIZE_OPTIONS, userOptions, {
            columns: userOptions?.columns ?? state.orderedFields
        });
        options.columns = options.columns.filter((c)=>state.columnVisibilityModel[c] !== false);
        const columns = options.columns.map((c)=>apiRef.current.state.columns.lookup[c]);
        try {
            if (!props.disableVirtualization && options.disableColumnVirtualization) {
                apiRef.current.unstable_setColumnVirtualization(false);
                await columnVirtualizationDisabled();
            }
            const widthByField = $e4be7afefd9a1627$var$extractColumnWidths(apiRef, options, columns);
            const newColumns = columns.map((column)=>(0, $e4be7afefd9a1627$var$_extends2.default)({}, column, {
                    width: widthByField[column.field],
                    computedWidth: widthByField[column.field],
                    flex: 0
                }));
            if (options.expand) {
                const visibleColumns = state.orderedFields.map((field)=>state.lookup[field]).filter((c)=>state.columnVisibilityModel[c.field] !== false);
                const totalWidth = visibleColumns.reduce((total, column)=>total + (widthByField[column.field] ?? column.computedWidth ?? column.width), 0);
                const dimensions = apiRef.current.getRootDimensions();
                const availableWidth = dimensions.viewportInnerSize.width;
                const remainingWidth = availableWidth - totalWidth;
                if (remainingWidth > 0) {
                    const widthPerColumn = remainingWidth / (newColumns.length || 1);
                    newColumns.forEach((column)=>{
                        column.width += widthPerColumn;
                        column.computedWidth += widthPerColumn;
                    });
                }
            }
            apiRef.current.updateColumns(newColumns);
            newColumns.forEach((newColumn, index)=>{
                if (newColumn.width !== columns[index].width) {
                    const width = newColumn.width;
                    apiRef.current.publishEvent('columnWidthChange', {
                        element: apiRef.current.getColumnHeaderElement(newColumn.field),
                        colDef: newColumn,
                        width: width
                    });
                }
            });
        } finally{
            if (!props.disableVirtualization) apiRef.current.unstable_setColumnVirtualization(true);
            isAutosizingRef.current = false;
        }
    }, [
        apiRef,
        columnVirtualizationDisabled,
        props.disableVirtualization
    ]);
    /**
   * EFFECTS
   */ $e4be7afefd9a1627$var$React.useEffect(()=>stopListening, [
        stopListening
    ]);
    (0, $431c82ec73ef367c$exports.useOnMount)(()=>{
        if (props.autosizeOnMount) Promise.resolve().then(()=>{
            apiRef.current.autosizeColumns(props.autosizeOptions);
        });
    });
    (0, $431c82ec73ef367c$exports.useGridNativeEventListener)(apiRef, ()=>apiRef.current.columnHeadersContainerRef?.current, 'touchstart', handleTouchStart, {
        passive: true
    });
    (0, $431c82ec73ef367c$exports.useGridApiMethod)(apiRef, {
        autosizeColumns: autosizeColumns
    }, 'public');
    (0, $431c82ec73ef367c$exports.useGridEvent)(apiRef, 'columnResizeStop', handleResizeStop);
    (0, $431c82ec73ef367c$exports.useGridEvent)(apiRef, 'columnResizeStart', handleResizeStart);
    (0, $431c82ec73ef367c$exports.useGridEvent)(apiRef, 'columnSeparatorMouseDown', handleColumnResizeMouseDown);
    (0, $431c82ec73ef367c$exports.useGridEvent)(apiRef, 'columnSeparatorDoubleClick', handleColumnSeparatorDoubleClick);
    (0, $431c82ec73ef367c$exports.useGridEventPriority)(apiRef, 'columnResize', props.onColumnResize);
    (0, $431c82ec73ef367c$exports.useGridEventPriority)(apiRef, 'columnWidthChange', props.onColumnWidthChange);
};
$e4be7afefd9a1627$exports.useGridColumnResize = $e4be7afefd9a1627$var$useGridColumnResize;
function $e4be7afefd9a1627$var$updateProperty(element, property, delta) {
    if (!element) return;
    element.style[property] = `${Math.round(parseFloat(element.style[property])) + delta}px`;
}


var $0ffe7e50943bb4c1$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $0ffe7e50943bb4c1$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $0ffe7e50943bb4c1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($0ffe7e50943bb4c1$exports, "__esModule", {
    value: true
});
$0ffe7e50943bb4c1$exports.useGridRowSpanning = $0ffe7e50943bb4c1$exports.rowSpanningStateInitializer = void 0;

var $0ffe7e50943bb4c1$var$_extends2 = $0ffe7e50943bb4c1$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $0ffe7e50943bb4c1$var$React = $0ffe7e50943bb4c1$require$_interopRequireWildcard((parcelRequire("acw62")));




var $2134645d829cdaa1$exports = {};
"use strict";
Object.defineProperty($2134645d829cdaa1$exports, "__esModule", {
    value: true
});
$2134645d829cdaa1$exports.getCellValue = void 0;
$2134645d829cdaa1$exports.getUnprocessedRange = $2134645d829cdaa1$var$getUnprocessedRange;
$2134645d829cdaa1$exports.isRowContextInitialized = $2134645d829cdaa1$var$isRowContextInitialized;
$2134645d829cdaa1$exports.isRowRangeUpdated = $2134645d829cdaa1$var$isRowRangeUpdated;

function $2134645d829cdaa1$var$getUnprocessedRange(testRange, processedRange) {
    if (testRange.firstRowIndex >= processedRange.firstRowIndex && testRange.lastRowIndex <= processedRange.lastRowIndex) return null;
    // Overflowing at the end
    // Example: testRange={ firstRowIndex: 10, lastRowIndex: 20 }, processedRange={ firstRowIndex: 0, lastRowIndex: 15 }
    // Unprocessed Range={ firstRowIndex: 16, lastRowIndex: 20 }
    if (testRange.firstRowIndex >= processedRange.firstRowIndex && testRange.lastRowIndex > processedRange.lastRowIndex) return {
        firstRowIndex: processedRange.lastRowIndex,
        lastRowIndex: testRange.lastRowIndex
    };
    // Overflowing at the beginning
    // Example: testRange={ firstRowIndex: 0, lastRowIndex: 20 }, processedRange={ firstRowIndex: 16, lastRowIndex: 30 }
    // Unprocessed Range={ firstRowIndex: 0, lastRowIndex: 15 }
    if (testRange.firstRowIndex < processedRange.firstRowIndex && testRange.lastRowIndex <= processedRange.lastRowIndex) return {
        firstRowIndex: testRange.firstRowIndex,
        lastRowIndex: processedRange.firstRowIndex - 1
    };
    // TODO: Should return two ranges handle overflowing at both ends ?
    return testRange;
}
function $2134645d829cdaa1$var$isRowContextInitialized(renderContext) {
    return renderContext.firstRowIndex !== 0 || renderContext.lastRowIndex !== 0;
}
function $2134645d829cdaa1$var$isRowRangeUpdated(range1, range2) {
    return range1.firstRowIndex !== range2.firstRowIndex || range1.lastRowIndex !== range2.lastRowIndex;
}
const $2134645d829cdaa1$var$getCellValue = (row, colDef, apiRef)=>{
    if (!row) return null;
    const cellValue = row[colDef.field];
    if (colDef.rowSpanValueGetter) return colDef.rowSpanValueGetter(cellValue, row, colDef, apiRef);
    // This util is also called during the state initialization
    // Use util method directly instead of calling apiRef.current.getRowValue
    return (0, $0166dd44615cae0d$exports.getRowValue)(row, colDef, apiRef);
};
$2134645d829cdaa1$exports.getCellValue = $2134645d829cdaa1$var$getCellValue;





const $0ffe7e50943bb4c1$var$EMPTY_CACHES = {
    spannedCells: {},
    hiddenCells: {},
    hiddenCellOriginMap: {}
};
const $0ffe7e50943bb4c1$var$EMPTY_RANGE = {
    firstRowIndex: 0,
    lastRowIndex: 0
};
const $0ffe7e50943bb4c1$var$EMPTY_STATE = {
    caches: $0ffe7e50943bb4c1$var$EMPTY_CACHES,
    processedRange: $0ffe7e50943bb4c1$var$EMPTY_RANGE
};
const $0ffe7e50943bb4c1$var$computeRowSpanningState = (apiRef, colDefs, visibleRows, range, rangeToProcess, resetState)=>{
    const virtualizer = apiRef.current.virtualizer;
    const previousState = resetState ? $0ffe7e50943bb4c1$var$EMPTY_STATE : $853666c534a59d3f$exports.Rowspan.selectors.state(virtualizer.store.state);
    const spannedCells = (0, $0ffe7e50943bb4c1$var$_extends2.default)({}, previousState.caches.spannedCells);
    const hiddenCells = (0, $0ffe7e50943bb4c1$var$_extends2.default)({}, previousState.caches.hiddenCells);
    const hiddenCellOriginMap = (0, $0ffe7e50943bb4c1$var$_extends2.default)({}, previousState.caches.hiddenCellOriginMap);
    const processedRange = {
        firstRowIndex: Math.min(previousState.processedRange.firstRowIndex, rangeToProcess.firstRowIndex),
        lastRowIndex: Math.max(previousState.processedRange.lastRowIndex, rangeToProcess.lastRowIndex)
    };
    colDefs.forEach((colDef, columnIndex)=>{
        for(let index = rangeToProcess.firstRowIndex; index < rangeToProcess.lastRowIndex; index += 1){
            const row = visibleRows[index];
            if (hiddenCells[row.id]?.[columnIndex]) continue;
            const cellValue = (0, $2134645d829cdaa1$exports.getCellValue)(row.model, colDef, apiRef);
            if (cellValue == null) continue;
            let spannedRowId = row.id;
            let spannedRowIndex = index;
            let rowSpan = 0;
            // For first index, also scan in the previous rows to handle the reset state case e.g by sorting
            const backwardsHiddenCells = [];
            if (index === rangeToProcess.firstRowIndex) {
                let prevIndex = index - 1;
                let prevRowEntry = visibleRows[prevIndex];
                while(prevIndex >= range.firstRowIndex && prevRowEntry && (0, $2134645d829cdaa1$exports.getCellValue)(prevRowEntry.model, colDef, apiRef) === cellValue){
                    const currentRow = visibleRows[prevIndex + 1];
                    if (hiddenCells[currentRow.id]) hiddenCells[currentRow.id][columnIndex] = true;
                    else hiddenCells[currentRow.id] = {
                        [columnIndex]: true
                    };
                    backwardsHiddenCells.push(index);
                    rowSpan += 1;
                    spannedRowId = prevRowEntry.id;
                    spannedRowIndex = prevIndex;
                    prevIndex -= 1;
                    prevRowEntry = visibleRows[prevIndex];
                }
            }
            backwardsHiddenCells.forEach((hiddenCellIndex)=>{
                if (hiddenCellOriginMap[hiddenCellIndex]) hiddenCellOriginMap[hiddenCellIndex][columnIndex] = spannedRowIndex;
                else hiddenCellOriginMap[hiddenCellIndex] = {
                    [columnIndex]: spannedRowIndex
                };
            });
            // Scan the next rows
            let relativeIndex = index + 1;
            while(relativeIndex <= range.lastRowIndex && visibleRows[relativeIndex] && (0, $2134645d829cdaa1$exports.getCellValue)(visibleRows[relativeIndex].model, colDef, apiRef) === cellValue){
                const currentRow = visibleRows[relativeIndex];
                if (hiddenCells[currentRow.id]) hiddenCells[currentRow.id][columnIndex] = true;
                else hiddenCells[currentRow.id] = {
                    [columnIndex]: true
                };
                if (hiddenCellOriginMap[relativeIndex]) hiddenCellOriginMap[relativeIndex][columnIndex] = spannedRowIndex;
                else hiddenCellOriginMap[relativeIndex] = {
                    [columnIndex]: spannedRowIndex
                };
                relativeIndex += 1;
                rowSpan += 1;
            }
            if (rowSpan > 0) {
                if (spannedCells[spannedRowId]) spannedCells[spannedRowId][columnIndex] = rowSpan + 1;
                else spannedCells[spannedRowId] = {
                    [columnIndex]: rowSpan + 1
                };
            }
        }
    });
    return {
        caches: {
            spannedCells: spannedCells,
            hiddenCells: hiddenCells,
            hiddenCellOriginMap: hiddenCellOriginMap
        },
        processedRange: processedRange
    };
};
/**
 * @requires columnsStateInitializer (method) - should be initialized before
 * @requires rowsStateInitializer (method) - should be initialized before
 * @requires filterStateInitializer (method) - should be initialized before
 */ const $0ffe7e50943bb4c1$var$rowSpanningStateInitializer = (state)=>{
    return (0, $0ffe7e50943bb4c1$var$_extends2.default)({}, state, {
        rowSpanning: $0ffe7e50943bb4c1$var$EMPTY_STATE
    });
};
$0ffe7e50943bb4c1$exports.rowSpanningStateInitializer = $0ffe7e50943bb4c1$var$rowSpanningStateInitializer;
const $0ffe7e50943bb4c1$var$useGridRowSpanning = (apiRef, props)=>{
    const updateRowSpanningState = $0ffe7e50943bb4c1$var$React.useCallback((renderContext, resetState = false)=>{
        const store = apiRef.current.virtualizer.store;
        const { range: range, rows: visibleRows } = (0, $7d0a5941a1add073$exports.getVisibleRows)(apiRef);
        if (resetState) store.set('rowSpanning', $0ffe7e50943bb4c1$var$EMPTY_STATE);
        if (range === null || !(0, $2134645d829cdaa1$exports.isRowContextInitialized)(renderContext)) return;
        const previousState = resetState ? $0ffe7e50943bb4c1$var$EMPTY_STATE : $853666c534a59d3f$exports.Rowspan.selectors.state(store.state);
        const rangeToProcess = (0, $2134645d829cdaa1$exports.getUnprocessedRange)({
            firstRowIndex: renderContext.firstRowIndex,
            lastRowIndex: Math.min(renderContext.lastRowIndex, range.lastRowIndex - range.firstRowIndex + 1)
        }, previousState.processedRange);
        if (rangeToProcess === null) return;
        const colDefs = (0, $e732684465924d20$exports.gridVisibleColumnDefinitionsSelector)(apiRef);
        const newState = $0ffe7e50943bb4c1$var$computeRowSpanningState(apiRef, colDefs, visibleRows, range, rangeToProcess, resetState);
        const newSpannedCellsCount = Object.keys(newState.caches.spannedCells).length;
        const newHiddenCellsCount = Object.keys(newState.caches.hiddenCells).length;
        const previousSpannedCellsCount = Object.keys(previousState.caches.spannedCells).length;
        const previousHiddenCellsCount = Object.keys(previousState.caches.hiddenCells).length;
        const shouldUpdateState = resetState || newSpannedCellsCount !== previousSpannedCellsCount || newHiddenCellsCount !== previousHiddenCellsCount;
        const hasNoSpannedCells = newSpannedCellsCount === 0 && previousSpannedCellsCount === 0;
        if (!shouldUpdateState || hasNoSpannedCells) return;
        store.set('rowSpanning', newState);
    }, [
        apiRef
    ]);
    // Reset events trigger a full re-computation of the row spanning state:
    // - The `rowSpanning` prop is updated (feature flag)
    // - The filtering is applied
    // - The sorting is applied
    // - The `paginationModel` is updated
    // - The rows are updated
    const { schedule: deferredUpdateRowSpanningState, cancel: cancel } = (0, $e3008c977e3d8041$exports.useRunOncePerLoop)(updateRowSpanningState);
    const resetRowSpanningState = $0ffe7e50943bb4c1$var$React.useCallback(()=>{
        const renderContext = (0, $6e8ace88dee0fb7c$exports.gridRenderContextSelector)(apiRef);
        if (!(0, $2134645d829cdaa1$exports.isRowContextInitialized)(renderContext)) return;
        deferredUpdateRowSpanningState(renderContext, true);
    }, [
        apiRef,
        deferredUpdateRowSpanningState
    ]);
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'renderedRowsIntervalChange', (0, $fe919794eb3b24e8$exports.runIf)(props.rowSpanning, (renderContext)=>{
        const didHavePendingReset = cancel();
        updateRowSpanningState(renderContext, didHavePendingReset);
    }));
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'sortedRowsSet', (0, $fe919794eb3b24e8$exports.runIf)(props.rowSpanning, resetRowSpanningState));
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'paginationModelChange', (0, $fe919794eb3b24e8$exports.runIf)(props.rowSpanning, resetRowSpanningState));
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'filteredRowsSet', (0, $fe919794eb3b24e8$exports.runIf)(props.rowSpanning, resetRowSpanningState));
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'columnsChange', (0, $fe919794eb3b24e8$exports.runIf)(props.rowSpanning, resetRowSpanningState));
    $0ffe7e50943bb4c1$var$React.useEffect(()=>{
        const store = apiRef.current.virtualizer?.store;
        if (!store) return;
        if (!props.rowSpanning) {
            if (store.state.rowSpanning !== $0ffe7e50943bb4c1$var$EMPTY_STATE) store.set('rowSpanning', $0ffe7e50943bb4c1$var$EMPTY_STATE);
        } else if (store.state.rowSpanning === $0ffe7e50943bb4c1$var$EMPTY_STATE) updateRowSpanningState((0, $6e8ace88dee0fb7c$exports.gridRenderContextSelector)(apiRef));
    }, [
        apiRef,
        props.rowSpanning,
        updateRowSpanningState
    ]);
};
$0ffe7e50943bb4c1$exports.useGridRowSpanning = $0ffe7e50943bb4c1$var$useGridRowSpanning;


var $eb2af8a38b4a65a4$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $eb2af8a38b4a65a4$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $eb2af8a38b4a65a4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($eb2af8a38b4a65a4$exports, "__esModule", {
    value: true
});
$eb2af8a38b4a65a4$exports.listViewStateInitializer = void 0;
$eb2af8a38b4a65a4$exports.useGridListView = $eb2af8a38b4a65a4$var$useGridListView;

var $eb2af8a38b4a65a4$var$_extends2 = $eb2af8a38b4a65a4$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $eb2af8a38b4a65a4$var$React = $eb2af8a38b4a65a4$require$_interopRequireWildcard((parcelRequire("acw62")));

var $eb2af8a38b4a65a4$var$_useEnhancedEffect = $eb2af8a38b4a65a4$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $9Y8Cp = parcelRequire("9Y8Cp");


const $eb2af8a38b4a65a4$var$listViewStateInitializer = (state, props, apiRef)=>(0, $eb2af8a38b4a65a4$var$_extends2.default)({}, state, {
        listViewColumn: props.listViewColumn ? (0, $eb2af8a38b4a65a4$var$_extends2.default)({}, props.listViewColumn, {
            computedWidth: $eb2af8a38b4a65a4$var$getListColumnWidth(apiRef)
        }) : undefined
    });
$eb2af8a38b4a65a4$exports.listViewStateInitializer = $eb2af8a38b4a65a4$var$listViewStateInitializer;
function $eb2af8a38b4a65a4$var$useGridListView(apiRef, props) {
    /*
   * EVENTS
   */ const updateListColumnWidth = ()=>{
        apiRef.current.setState((state)=>{
            if (!state.listViewColumn) return state;
            return (0, $eb2af8a38b4a65a4$var$_extends2.default)({}, state, {
                listViewColumn: (0, $eb2af8a38b4a65a4$var$_extends2.default)({}, state.listViewColumn, {
                    computedWidth: $eb2af8a38b4a65a4$var$getListColumnWidth(apiRef)
                })
            });
        });
    };
    const prevInnerWidth = $eb2af8a38b4a65a4$var$React.useRef(null);
    const handleGridSizeChange = (viewportInnerSize)=>{
        if (prevInnerWidth.current !== viewportInnerSize.width) {
            prevInnerWidth.current = viewportInnerSize.width;
            updateListColumnWidth();
        }
    };
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'viewportInnerSizeChange', handleGridSizeChange);
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'columnVisibilityModelChange', updateListColumnWidth);
    /*
   * EFFECTS
   */ (0, $eb2af8a38b4a65a4$var$_useEnhancedEffect.default)(()=>{
        const listColumn = props.listViewColumn;
        if (listColumn) apiRef.current.setState((state)=>{
            return (0, $eb2af8a38b4a65a4$var$_extends2.default)({}, state, {
                listViewColumn: (0, $eb2af8a38b4a65a4$var$_extends2.default)({}, listColumn, {
                    computedWidth: $eb2af8a38b4a65a4$var$getListColumnWidth(apiRef)
                })
            });
        });
    }, [
        apiRef,
        props.listViewColumn
    ]);
    $eb2af8a38b4a65a4$var$React.useEffect(()=>{
        if (props.listView && !props.listViewColumn) (0, $9Y8Cp.warnOnce)([
            'MUI X: The `listViewColumn` prop must be set if `listView` is enabled.',
            'To fix, pass a column definition to the `listViewColumn` prop, e.g. `{ field: "example", renderCell: (params) => <div>{params.row.id}</div> }`.',
            'For more details, see https://mui.com/x/react-data-grid/list-view/'
        ]);
    }, [
        props.listView,
        props.listViewColumn
    ]);
}
function $eb2af8a38b4a65a4$var$getListColumnWidth(apiRef) {
    return (0, $d9a3301c6c2f6d8b$exports.gridDimensionsSelector)(apiRef).viewportInnerSize.width;
}



var $8181dc9d16d4286d$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $8181dc9d16d4286d$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($8181dc9d16d4286d$exports, "__esModule", {
    value: true
});
$8181dc9d16d4286d$exports.useGridDataSource = void 0;

var $8181dc9d16d4286d$var$React = $8181dc9d16d4286d$require$_interopRequireWildcard((parcelRequire("acw62")));



var $7f15f7d4e3cc4be4$exports = {};
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $7f15f7d4e3cc4be4$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $7f15f7d4e3cc4be4$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($7f15f7d4e3cc4be4$exports, "__esModule", {
    value: true
});
$7f15f7d4e3cc4be4$exports.useGridDataSourceBase = void 0;

var $7f15f7d4e3cc4be4$var$_extends2 = $7f15f7d4e3cc4be4$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $7f15f7d4e3cc4be4$var$_objectWithoutPropertiesLoose2 = $7f15f7d4e3cc4be4$require$_interopRequireDefault((parcelRequire("c05no")));

var $7f15f7d4e3cc4be4$var$React = $7f15f7d4e3cc4be4$require$_interopRequireWildcard((parcelRequire("acw62")));

var $7f15f7d4e3cc4be4$var$_useLazyRef = $7f15f7d4e3cc4be4$require$_interopRequireDefault((parcelRequire("doV3C")));

var $7f15f7d4e3cc4be4$var$_debounce = $7f15f7d4e3cc4be4$require$_interopRequireDefault((parcelRequire("9NXOO")));

var $9Y8Cp = parcelRequire("9Y8Cp");





var $5sOMZ = parcelRequire("5sOMZ");

var $4c1993bfb47621ad$exports = {};
"use strict";
Object.defineProperty($4c1993bfb47621ad$exports, "__esModule", {
    value: true
});
$4c1993bfb47621ad$exports.gridGetRowsParamsSelector = void 0;




const $4c1993bfb47621ad$var$gridGetRowsParamsSelector = $4c1993bfb47621ad$exports.gridGetRowsParamsSelector = (0, $8eef5f2af445e503$exports.createSelector)($e95988b653de2e96$exports.gridFilterModelSelector, $dc3028b3b629fae7$exports.gridSortModelSelector, $c41ec74257ca380c$exports.gridPaginationModelSelector, (filterModel, sortModel, paginationModel)=>({
        groupKeys: [],
        paginationModel: paginationModel,
        sortModel: sortModel,
        filterModel: filterModel,
        start: paginationModel.page * paginationModel.pageSize,
        end: paginationModel.page * paginationModel.pageSize + paginationModel.pageSize - 1
    }));


var $fbb4d3ca918c8598$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $fbb4d3ca918c8598$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($fbb4d3ca918c8598$exports, "__esModule", {
    value: true
});
$fbb4d3ca918c8598$exports.DataSourceRowsUpdateStrategy = $fbb4d3ca918c8598$exports.CacheChunkManager = void 0;

var $fbb4d3ca918c8598$var$_extends2 = $fbb4d3ca918c8598$require$_interopRequireDefault((parcelRequire("3p9rK")));
let $fbb4d3ca918c8598$var$DataSourceRowsUpdateStrategy = $fbb4d3ca918c8598$exports.DataSourceRowsUpdateStrategy = /*#__PURE__*/ function(DataSourceRowsUpdateStrategy) {
    DataSourceRowsUpdateStrategy["Default"] = "set-flat-rows";
    DataSourceRowsUpdateStrategy["LazyLoading"] = "replace-row-range";
    DataSourceRowsUpdateStrategy["GroupedData"] = "set-grouped-rows";
    return DataSourceRowsUpdateStrategy;
}({});
/**
 * Provides better cache hit rate by:
 * 1. Splitting the data into smaller chunks to be stored in the cache (cache `set`)
 * 2. Merging multiple cache entries into a single response to get the required chunk (cache `get`)
 */ class $fbb4d3ca918c8598$var$CacheChunkManager {
    /**
   * @param chunkSize The number of rows to store in each cache entry.
   * If not set, the whole array will be stored in a single cache entry.
   * Setting this value to smallest page size will result in better cache hit rate.
   * Has no effect if cursor pagination is used.
   */ constructor(chunkSize){
        this.chunkSize = chunkSize;
    }
    getCacheKeys = (key)=>{
        if (this.chunkSize < 1 || typeof key.start !== 'number') return [
            key
        ];
        // split the range into chunks
        const chunkedKeys = [];
        for(let i = key.start; i <= key.end; i += this.chunkSize){
            const end = Math.min(i + this.chunkSize - 1, key.end);
            chunkedKeys.push((0, $fbb4d3ca918c8598$var$_extends2.default)({}, key, {
                start: i,
                end: end
            }));
        }
        return chunkedKeys;
    };
    splitResponse = (key, response)=>{
        const cacheKeys = this.getCacheKeys(key);
        if (cacheKeys.length === 1) return new Map([
            [
                key,
                response
            ]
        ]);
        const responses = new Map();
        cacheKeys.forEach((chunkKey)=>{
            const isLastChunk = chunkKey.end === key.end;
            const responseSlice = (0, $fbb4d3ca918c8598$var$_extends2.default)({}, response, {
                pageInfo: (0, $fbb4d3ca918c8598$var$_extends2.default)({}, response.pageInfo, {
                    // If the original response had page info, update that information for all but last chunk and keep the original value for the last chunk
                    hasNextPage: response.pageInfo?.hasNextPage !== undefined && !isLastChunk ? true : response.pageInfo?.hasNextPage,
                    nextCursor: response.pageInfo?.nextCursor !== undefined && !isLastChunk ? response.rows[chunkKey.end + 1].id : response.pageInfo?.nextCursor
                }),
                rows: typeof chunkKey.start !== 'number' || typeof key.start !== 'number' ? response.rows : response.rows.slice(chunkKey.start - key.start, chunkKey.end - key.start + 1)
            });
            responses.set(chunkKey, responseSlice);
        });
        return responses;
    };
    static mergeResponses = (responses)=>{
        if (responses.length === 1) return responses[0];
        return responses.reduce((acc, response)=>(0, $fbb4d3ca918c8598$var$_extends2.default)({}, response, {
                rows: [
                    ...acc.rows,
                    ...response.rows
                ]
            }), {
            rows: [],
            rowCount: 0,
            pageInfo: {}
        });
    };
}
$fbb4d3ca918c8598$exports.CacheChunkManager = $fbb4d3ca918c8598$var$CacheChunkManager;




const $7f15f7d4e3cc4be4$var$_excluded = [
    "skipCache",
    "keepChildrenExpanded"
];
const $7f15f7d4e3cc4be4$var$noopCache = {
    clear: ()=>{},
    get: ()=>undefined,
    set: ()=>{}
};
function $7f15f7d4e3cc4be4$var$getCache(cacheProp, options = {}) {
    if (cacheProp === null) return $7f15f7d4e3cc4be4$var$noopCache;
    return cacheProp ?? new $5446b637625dfefc$exports.GridDataSourceCacheDefault(options);
}
const $7f15f7d4e3cc4be4$var$useGridDataSourceBase = (apiRef, props, options = {})=>{
    const setStrategyAvailability = $7f15f7d4e3cc4be4$var$React.useCallback(()=>{
        apiRef.current.setStrategyAvailability($41d629b2793a9305$exports.GridStrategyGroup.DataSource, $fbb4d3ca918c8598$exports.DataSourceRowsUpdateStrategy.Default, props.dataSource ? ()=>true : ()=>false);
    }, [
        apiRef,
        props.dataSource
    ]);
    const [currentStrategy, setCurrentStrategy] = $7f15f7d4e3cc4be4$var$React.useState(apiRef.current.getActiveStrategy($41d629b2793a9305$exports.GridStrategyGroup.DataSource));
    const standardRowsUpdateStrategyActive = $7f15f7d4e3cc4be4$var$React.useMemo(()=>{
        return currentStrategy === $fbb4d3ca918c8598$exports.DataSourceRowsUpdateStrategy.Default || currentStrategy === $fbb4d3ca918c8598$exports.DataSourceRowsUpdateStrategy.GroupedData;
    }, [
        currentStrategy
    ]);
    const paginationModel = (0, $5sOMZ.useGridSelector)(apiRef, $c41ec74257ca380c$exports.gridPaginationModelSelector);
    const lastRequestId = $7f15f7d4e3cc4be4$var$React.useRef(0);
    const onDataSourceErrorProp = props.onDataSourceError;
    const cacheChunkManager = (0, $7f15f7d4e3cc4be4$var$_useLazyRef.default)(()=>{
        if (!props.pagination) return new $fbb4d3ca918c8598$exports.CacheChunkManager(paginationModel.pageSize);
        const sortedPageSizeOptions = props.pageSizeOptions.map((option)=>typeof option === 'number' ? option : option.value).sort((a, b)=>a - b);
        const cacheChunkSize = Math.min(paginationModel.pageSize, sortedPageSizeOptions[0]);
        return new $fbb4d3ca918c8598$exports.CacheChunkManager(cacheChunkSize);
    }).current;
    const [cache, setCache] = $7f15f7d4e3cc4be4$var$React.useState(()=>$7f15f7d4e3cc4be4$var$getCache(props.dataSourceCache, options.cacheOptions));
    const fetchRows = $7f15f7d4e3cc4be4$var$React.useCallback(async (parentId, params)=>{
        const getRows = props.dataSource?.getRows;
        if (!getRows) return;
        if (parentId && parentId !== $0166dd44615cae0d$exports.GRID_ROOT_GROUP_ID && props.signature !== 'DataGrid') {
            options.fetchRowChildren?.([
                parentId
            ]);
            return;
        }
        options.clearDataSourceState?.();
        const _ref = params || {}, { skipCache: skipCache, keepChildrenExpanded: keepChildrenExpanded } = _ref, getRowsParams = (0, $7f15f7d4e3cc4be4$var$_objectWithoutPropertiesLoose2.default)(_ref, $7f15f7d4e3cc4be4$var$_excluded);
        const fetchParams = (0, $7f15f7d4e3cc4be4$var$_extends2.default)({}, (0, $4c1993bfb47621ad$exports.gridGetRowsParamsSelector)(apiRef), apiRef.current.unstable_applyPipeProcessors('getRowsParams', {}), getRowsParams);
        const cacheKeys = cacheChunkManager.getCacheKeys(fetchParams);
        const responses = cacheKeys.map((cacheKey)=>cache.get(cacheKey));
        if (!skipCache && responses.every((response)=>response !== undefined)) {
            apiRef.current.applyStrategyProcessor('dataSourceRowsUpdate', {
                response: $fbb4d3ca918c8598$exports.CacheChunkManager.mergeResponses(responses),
                fetchParams: fetchParams,
                options: {
                    skipCache: skipCache,
                    keepChildrenExpanded: keepChildrenExpanded
                }
            });
            return;
        }
        // Manage loading state only for the default strategy
        if (standardRowsUpdateStrategyActive || apiRef.current.getRowsCount() === 0) apiRef.current.setLoading(true);
        const requestId = lastRequestId.current + 1;
        lastRequestId.current = requestId;
        try {
            const getRowsResponse = await getRows(fetchParams);
            const cacheResponses = cacheChunkManager.splitResponse(fetchParams, getRowsResponse);
            cacheResponses.forEach((response, key)=>cache.set(key, response));
            if (lastRequestId.current === requestId) apiRef.current.applyStrategyProcessor('dataSourceRowsUpdate', {
                response: getRowsResponse,
                fetchParams: fetchParams,
                options: {
                    skipCache: skipCache,
                    keepChildrenExpanded: keepChildrenExpanded
                }
            });
        } catch (originalError) {
            if (lastRequestId.current === requestId) {
                apiRef.current.applyStrategyProcessor('dataSourceRowsUpdate', {
                    error: originalError,
                    fetchParams: fetchParams,
                    options: {
                        skipCache: skipCache,
                        keepChildrenExpanded: keepChildrenExpanded
                    }
                });
                if (typeof onDataSourceErrorProp === 'function') onDataSourceErrorProp(new $a65eba665b419180$exports.GridGetRowsError({
                    message: originalError?.message,
                    params: fetchParams,
                    cause: originalError
                }));
                else (0, $9Y8Cp.warnOnce)([
                    'MUI X: A call to `dataSource.getRows()` threw an error which was not handled because `onDataSourceError()` is missing.',
                    'To handle the error pass a callback to the `onDataSourceError` prop, for example `<DataGrid onDataSourceError={(error) => ...} />`.',
                    'For more detail, see https://mui.com/x/react-data-grid/server-side-data/#error-handling.'
                ], 'error');
            }
        } finally{
            if (standardRowsUpdateStrategyActive && lastRequestId.current === requestId) apiRef.current.setLoading(false);
        }
    }, [
        cacheChunkManager,
        cache,
        apiRef,
        standardRowsUpdateStrategyActive,
        props.dataSource?.getRows,
        onDataSourceErrorProp,
        options,
        props.signature
    ]);
    const handleStrategyActivityChange = $7f15f7d4e3cc4be4$var$React.useCallback(()=>{
        setCurrentStrategy(apiRef.current.getActiveStrategy($41d629b2793a9305$exports.GridStrategyGroup.DataSource));
    }, [
        apiRef
    ]);
    const handleDataUpdate = $7f15f7d4e3cc4be4$var$React.useCallback((params)=>{
        if ('error' in params) {
            apiRef.current.setRows([]);
            return;
        }
        const { response: response } = params;
        if (response.rowCount !== undefined) apiRef.current.setRowCount(response.rowCount);
        apiRef.current.setRows(response.rows);
        apiRef.current.unstable_applyPipeProcessors('processDataSourceRows', {
            params: params.fetchParams,
            response: response
        }, true);
    }, [
        apiRef
    ]);
    const dataSourceUpdateRow = props.dataSource?.updateRow;
    const handleEditRowOption = options.handleEditRow;
    const editRow = $7f15f7d4e3cc4be4$var$React.useCallback(async (params)=>{
        if (!dataSourceUpdateRow) return undefined;
        try {
            const finalRowUpdate = await dataSourceUpdateRow(params);
            if (typeof handleEditRowOption === 'function') {
                handleEditRowOption(params, finalRowUpdate);
                return finalRowUpdate;
            }
            if (finalRowUpdate && !(0, $a4d2c99ef8ba2460$exports.isDeepEqual)(finalRowUpdate, params.previousRow)) // Reset the outdated cache, only if the row is _actually_ updated
            apiRef.current.dataSource.cache.clear();
            apiRef.current.updateNestedRows([
                finalRowUpdate
            ], []);
            return finalRowUpdate;
        } catch (errorThrown) {
            if (typeof onDataSourceErrorProp === 'function') onDataSourceErrorProp(new $a65eba665b419180$exports.GridUpdateRowError({
                message: errorThrown?.message,
                params: params,
                cause: errorThrown
            }));
            else (0, $9Y8Cp.warnOnce)([
                'MUI X: A call to `dataSource.updateRow()` threw an error which was not handled because `onDataSourceError()` is missing.',
                'To handle the error pass a callback to the `onDataSourceError` prop, for example `<DataGrid onDataSourceError={(error) => ...} />`.',
                'For more detail, see https://mui.com/x/react-data-grid/server-side-data/#error-handling.'
            ], 'error');
            throw errorThrown; // Let the caller handle the error further
        }
    }, [
        apiRef,
        dataSourceUpdateRow,
        onDataSourceErrorProp,
        handleEditRowOption
    ]);
    const dataSourceApi = {
        dataSource: {
            fetchRows: fetchRows,
            cache: cache,
            editRow: editRow
        }
    };
    const debouncedFetchRows = $7f15f7d4e3cc4be4$var$React.useMemo(()=>(0, $7f15f7d4e3cc4be4$var$_debounce.default)(fetchRows, 0), [
        fetchRows
    ]);
    const isFirstRender = $7f15f7d4e3cc4be4$var$React.useRef(true);
    $7f15f7d4e3cc4be4$var$React.useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        if (props.dataSourceCache === undefined) return;
        const newCache = $7f15f7d4e3cc4be4$var$getCache(props.dataSourceCache, options.cacheOptions);
        setCache((prevCache)=>prevCache !== newCache ? newCache : prevCache);
    }, [
        props.dataSourceCache,
        options.cacheOptions
    ]);
    $7f15f7d4e3cc4be4$var$React.useEffect(()=>{
        // Return early if the proper strategy isn't set yet
        // Context: https://github.com/mui/mui-x/issues/19650
        if (currentStrategy !== $fbb4d3ca918c8598$exports.DataSourceRowsUpdateStrategy.Default && currentStrategy !== $fbb4d3ca918c8598$exports.DataSourceRowsUpdateStrategy.LazyLoading && currentStrategy !== $fbb4d3ca918c8598$exports.DataSourceRowsUpdateStrategy.GroupedData) return undefined;
        if (props.dataSource) {
            apiRef.current.dataSource.cache.clear();
            apiRef.current.dataSource.fetchRows();
        }
        return ()=>{
            // ignore the current request on unmount
            lastRequestId.current += 1;
        };
    }, [
        apiRef,
        props.dataSource,
        currentStrategy
    ]);
    return {
        api: {
            public: dataSourceApi
        },
        debouncedFetchRows: debouncedFetchRows,
        strategyProcessor: {
            strategyName: $fbb4d3ca918c8598$exports.DataSourceRowsUpdateStrategy.Default,
            group: 'dataSourceRowsUpdate',
            processor: handleDataUpdate
        },
        setStrategyAvailability: setStrategyAvailability,
        cacheChunkManager: cacheChunkManager,
        cache: cache,
        events: {
            strategyAvailabilityChange: handleStrategyActivityChange,
            sortModelChange: (0, $fe919794eb3b24e8$exports.runIf)(standardRowsUpdateStrategyActive, ()=>debouncedFetchRows()),
            filterModelChange: (0, $fe919794eb3b24e8$exports.runIf)(standardRowsUpdateStrategyActive, ()=>debouncedFetchRows()),
            paginationModelChange: (0, $fe919794eb3b24e8$exports.runIf)(standardRowsUpdateStrategyActive, ()=>debouncedFetchRows())
        }
    };
};
$7f15f7d4e3cc4be4$exports.useGridDataSourceBase = $7f15f7d4e3cc4be4$var$useGridDataSourceBase;


/**
 * Community version of the data source hook. Contains implementation of the `useGridDataSourceBase` hook.
 */ const $8181dc9d16d4286d$var$useGridDataSource = (apiRef, props)=>{
    const { api: api, strategyProcessor: strategyProcessor, events: events, setStrategyAvailability: setStrategyAvailability } = (0, $7f15f7d4e3cc4be4$exports.useGridDataSourceBase)(apiRef, props);
    (0, $d79b1aa4f5237e85$exports.useGridApiMethod)(apiRef, api.public, 'public');
    (0, $ed28c789ae16a4b3$exports.useGridRegisterStrategyProcessor)(apiRef, strategyProcessor.strategyName, strategyProcessor.group, strategyProcessor.processor);
    Object.entries(events).forEach(([event, handler])=>{
        (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, event, handler);
    });
    $8181dc9d16d4286d$var$React.useEffect(()=>{
        setStrategyAvailability();
    }, [
        setStrategyAvailability
    ]);
};
$8181dc9d16d4286d$exports.useGridDataSource = $8181dc9d16d4286d$var$useGridDataSource;


const $4524a6bb6d2f99a9$var$useDataGridComponent = (apiRef, props, configuration)=>{
    (0, $1b57f47831f90cfc$exports.useGridInitialization)(apiRef, props);
    /**
   * Register all pre-processors called during state initialization here.
   */ (0, $45340a55c38c89d7$exports.useGridRowSelectionPreProcessors)(apiRef, props);
    (0, $3e4389cda192db48$exports.useGridRowsPreProcessors)(apiRef);
    /**
   * Register all state initializers here.
   */ (0, $0457a051e38141f4$exports.useGridInitializeState)($ffa021c6a8a175c3$exports.propsStateInitializer, apiRef, props);
    (0, $0457a051e38141f4$exports.useGridInitializeState)($9674296b6d32bca5$exports.rowSelectionStateInitializer, apiRef, props);
    (0, $0457a051e38141f4$exports.useGridInitializeState)($65c9ba4e90cd61b6$exports.columnsStateInitializer, apiRef, props);
    (0, $0457a051e38141f4$exports.useGridInitializeState)($206058c259ba36a5$exports.rowsStateInitializer, apiRef, props);
    (0, $0457a051e38141f4$exports.useGridInitializeState)($2714c9ed9cdf2996$exports.paginationStateInitializer, apiRef, props);
    (0, $0457a051e38141f4$exports.useGridInitializeState)($b93545fe9a3b3245$exports.editingStateInitializer, apiRef, props);
    (0, $0457a051e38141f4$exports.useGridInitializeState)($0fc273bc52ff1742$exports.focusStateInitializer, apiRef, props);
    (0, $0457a051e38141f4$exports.useGridInitializeState)($e6ca12cabeac117a$exports.sortingStateInitializer, apiRef, props);
    (0, $0457a051e38141f4$exports.useGridInitializeState)($314c3f5b8282a42e$exports.preferencePanelStateInitializer, apiRef, props);
    (0, $0457a051e38141f4$exports.useGridInitializeState)($91ff0c015e83a086$exports.filterStateInitializer, apiRef, props);
    (0, $0457a051e38141f4$exports.useGridInitializeState)($0ffe7e50943bb4c1$exports.rowSpanningStateInitializer, apiRef, props);
    (0, $0457a051e38141f4$exports.useGridInitializeState)($d846f35585bafc86$exports.densityStateInitializer, apiRef, props);
    (0, $0457a051e38141f4$exports.useGridInitializeState)($e4be7afefd9a1627$exports.columnResizeStateInitializer, apiRef, props);
    (0, $0457a051e38141f4$exports.useGridInitializeState)($a83bee6df207757d$exports.columnMenuStateInitializer, apiRef, props);
    (0, $0457a051e38141f4$exports.useGridInitializeState)($7c3e3abbe30f48e1$exports.columnGroupsStateInitializer, apiRef, props);
    (0, $0457a051e38141f4$exports.useGridInitializeState)($94d9a2be66e71282$exports.virtualizationStateInitializer, apiRef, props);
    (0, $0457a051e38141f4$exports.useGridInitializeState)($06d554a00cf6d24e$exports.dimensionsStateInitializer, apiRef, props);
    (0, $0457a051e38141f4$exports.useGridInitializeState)($e46af192720967f4$exports.rowsMetaStateInitializer, apiRef, props);
    (0, $0457a051e38141f4$exports.useGridInitializeState)($eb2af8a38b4a65a4$exports.listViewStateInitializer, apiRef, props);
    (0, $0c203bd54aeaf237$exports.useGridKeyboardNavigation)(apiRef, props);
    (0, $9674296b6d32bca5$exports.useGridRowSelection)(apiRef, props);
    (0, $65c9ba4e90cd61b6$exports.useGridColumns)(apiRef, props);
    (0, $206058c259ba36a5$exports.useGridRows)(apiRef, props, configuration);
    (0, $0ffe7e50943bb4c1$exports.useGridRowSpanning)(apiRef, props);
    (0, $4a9b8ce6e6853f0a$exports.useGridParamsApi)(apiRef, props, configuration);
    (0, $1f67185743ff4f77$exports.useGridColumnSpanning)(apiRef);
    (0, $7c3e3abbe30f48e1$exports.useGridColumnGrouping)(apiRef, props);
    (0, $b93545fe9a3b3245$exports.useGridEditing)(apiRef, props, configuration);
    (0, $0fc273bc52ff1742$exports.useGridFocus)(apiRef, props);
    (0, $314c3f5b8282a42e$exports.useGridPreferencesPanel)(apiRef, props);
    (0, $91ff0c015e83a086$exports.useGridFilter)(apiRef, props, configuration);
    (0, $e6ca12cabeac117a$exports.useGridSorting)(apiRef, props);
    (0, $d846f35585bafc86$exports.useGridDensity)(apiRef, props);
    (0, $e4be7afefd9a1627$exports.useGridColumnResize)(apiRef, props);
    (0, $2714c9ed9cdf2996$exports.useGridPagination)(apiRef, props);
    (0, $bc5c7b440a851fd1$exports.useGridScroll)(apiRef, props);
    (0, $a83bee6df207757d$exports.useGridColumnMenu)(apiRef);
    (0, $c4e86ef235136df5$exports.useGridCsvExport)(apiRef, props);
    (0, $35ed394581d01f61$exports.useGridPrintExport)(apiRef, props);
    (0, $077743baf33b26c9$exports.useGridClipboard)(apiRef, props);
    (0, $06d554a00cf6d24e$exports.useGridDimensions)(apiRef, props);
    (0, $1be25f585207520f$exports.useGridEvents)(apiRef, props);
    (0, $f6af98c761dea48b$exports.useGridStatePersistence)(apiRef);
    (0, $94d9a2be66e71282$exports.useGridVirtualization)(apiRef, props);
    (0, $eb2af8a38b4a65a4$exports.useGridListView)(apiRef, props);
    (0, $8181dc9d16d4286d$exports.useGridDataSource)(apiRef, props);
    // Should be the last thing to run, because all pre-processors should have been registered by now.
    (0, $b9120b953d35198c$exports.useFirstRender)(()=>{
        apiRef.current.runAppliersForPendingProcessors();
    });
    $4524a6bb6d2f99a9$var$React.useEffect(()=>{
        apiRef.current.runAppliersForPendingProcessors();
    });
};
$4524a6bb6d2f99a9$exports.useDataGridComponent = $4524a6bb6d2f99a9$var$useDataGridComponent;


var $c9883683c395e213$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $c9883683c395e213$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $c9883683c395e213$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($c9883683c395e213$exports, "__esModule", {
    value: true
});
$c9883683c395e213$exports.useDataGridProps = void 0;

var $c9883683c395e213$var$_extends2 = $c9883683c395e213$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $c9883683c395e213$var$React = $c9883683c395e213$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8xDHs = parcelRequire("8xDHs");

var $izOUK = parcelRequire("izOUK");

var $b6014b2d4bf32573$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $b6014b2d4bf32573$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($b6014b2d4bf32573$exports, "__esModule", {
    value: true
});
$b6014b2d4bf32573$exports.DATA_GRID_DEFAULT_SLOTS_COMPONENTS = void 0;

var $b6014b2d4bf32573$var$_extends2 = $b6014b2d4bf32573$require$_interopRequireDefault((parcelRequire("3p9rK")));


var $056733ac91e6ea07$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $056733ac91e6ea07$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $056733ac91e6ea07$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($056733ac91e6ea07$exports, "__esModule", {
    value: true
});
$056733ac91e6ea07$exports.GridColumnHeaders = void 0;

var $056733ac91e6ea07$var$_extends2 = $056733ac91e6ea07$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $056733ac91e6ea07$var$_objectWithoutPropertiesLoose2 = $056733ac91e6ea07$require$_interopRequireDefault((parcelRequire("c05no")));

var $056733ac91e6ea07$var$React = $056733ac91e6ea07$require$_interopRequireWildcard((parcelRequire("acw62")));

var $056733ac91e6ea07$var$_propTypes = $056733ac91e6ea07$require$_interopRequireDefault((parcelRequire("c9Z8w")));


var $fYxgT = parcelRequire("fYxgT");
var $ca184fa0bded5702$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $ca184fa0bded5702$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $ca184fa0bded5702$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($ca184fa0bded5702$exports, "__esModule", {
    value: true
});
$ca184fa0bded5702$exports.useGridColumnHeaders = $ca184fa0bded5702$exports.GridColumnHeaderRow = void 0;

var $ca184fa0bded5702$var$_extends2 = $ca184fa0bded5702$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $ca184fa0bded5702$var$React = $ca184fa0bded5702$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ca184fa0bded5702$var$_clsx = $ca184fa0bded5702$require$_interopRequireDefault((parcelRequire("9QePP")));

var $8xDHs = parcelRequire("8xDHs");



var $jDpXp = parcelRequire("jDpXp");

var $er55f = parcelRequire("er55f");




var $efe60d7621886a65$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $efe60d7621886a65$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $efe60d7621886a65$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($efe60d7621886a65$exports, "__esModule", {
    value: true
});
$efe60d7621886a65$exports.GridColumnGroupHeader = $efe60d7621886a65$var$GridColumnGroupHeader;

var $efe60d7621886a65$var$_extends2 = $efe60d7621886a65$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $efe60d7621886a65$var$React = $efe60d7621886a65$require$_interopRequireWildcard((parcelRequire("acw62")));

var $efe60d7621886a65$var$_useId = $efe60d7621886a65$require$_interopRequireDefault((parcelRequire("hwliF")));

var $efe60d7621886a65$var$_composeClasses = $efe60d7621886a65$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $9uEev = parcelRequire("9uEev");


var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");


var $bDyDY = parcelRequire("bDyDY");

var $5sOMZ = parcelRequire("5sOMZ");





var $ayMG0 = parcelRequire("ayMG0");
const $efe60d7621886a65$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, headerAlign: headerAlign, isDragging: isDragging, isLastColumn: isLastColumn, showLeftBorder: showLeftBorder, showRightBorder: showRightBorder, groupId: groupId, pinnedPosition: pinnedPosition } = ownerState;
    const slots = {
        root: [
            'columnHeader',
            headerAlign === 'left' && 'columnHeader--alignLeft',
            headerAlign === 'center' && 'columnHeader--alignCenter',
            headerAlign === 'right' && 'columnHeader--alignRight',
            isDragging && 'columnHeader--moving',
            showRightBorder && 'columnHeader--withRightBorder',
            showLeftBorder && 'columnHeader--withLeftBorder',
            'withBorderColor',
            groupId === null ? 'columnHeader--emptyGroup' : 'columnHeader--filledGroup',
            pinnedPosition === $e8d35a7c12bdaa1d$exports.PinnedColumnPosition.LEFT && 'columnHeader--pinnedLeft',
            pinnedPosition === $e8d35a7c12bdaa1d$exports.PinnedColumnPosition.RIGHT && 'columnHeader--pinnedRight',
            isLastColumn && 'columnHeader--last'
        ],
        draggableContainer: [
            'columnHeaderDraggableContainer'
        ],
        titleContainer: [
            'columnHeaderTitleContainer',
            'withBorderColor'
        ],
        titleContainerContent: [
            'columnHeaderTitleContainerContent'
        ]
    };
    return (0, $efe60d7621886a65$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
function $efe60d7621886a65$var$GridColumnGroupHeader(props) {
    const { groupId: groupId, width: width, depth: depth, maxDepth: maxDepth, fields: fields, height: height, colIndex: colIndex, hasFocus: hasFocus, tabIndex: tabIndex, isLastColumn: isLastColumn, pinnedPosition: pinnedPosition, pinnedOffset: pinnedOffset } = props;
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const isRtl = (0, $9uEev.useRtl)();
    const headerCellRef = $efe60d7621886a65$var$React.useRef(null);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const columnGroupsLookup = (0, $5sOMZ.useGridSelector)(apiRef, $cf21d895912d975b$exports.gridColumnGroupsLookupSelector);
    const group = groupId ? columnGroupsLookup[groupId] : {};
    const { headerName: headerName = groupId ?? '', description: description = '', headerAlign: headerAlign } = group;
    let headerComponent;
    const render = groupId && columnGroupsLookup[groupId]?.renderHeaderGroup;
    const renderParams = $efe60d7621886a65$var$React.useMemo(()=>({
            groupId: groupId,
            headerName: headerName,
            description: description,
            depth: depth,
            maxDepth: maxDepth,
            fields: fields,
            colIndex: colIndex,
            isLastColumn: isLastColumn
        }), [
        groupId,
        headerName,
        description,
        depth,
        maxDepth,
        fields,
        colIndex,
        isLastColumn
    ]);
    if (groupId && render) headerComponent = render(renderParams);
    const ownerState = (0, $efe60d7621886a65$var$_extends2.default)({}, props, {
        classes: rootProps.classes,
        headerAlign: headerAlign,
        depth: depth,
        isDragging: false
    });
    const label = headerName ?? groupId;
    const id = (0, $efe60d7621886a65$var$_useId.default)();
    const elementId = groupId === null ? `empty-group-cell-${id}` : groupId;
    const classes = $efe60d7621886a65$var$useUtilityClasses(ownerState);
    $efe60d7621886a65$var$React.useLayoutEffect(()=>{
        if (hasFocus) {
            const focusableElement = headerCellRef.current.querySelector('[tabindex="0"]');
            const elementToFocus = focusableElement || headerCellRef.current;
            if (!elementToFocus) return;
            if ((0, $bad574edb71acea7$exports.doesSupportPreventScroll)()) elementToFocus.focus({
                preventScroll: true
            });
            else {
                const scrollPosition = apiRef.current.getScrollPosition();
                elementToFocus.focus();
                apiRef.current.scroll(scrollPosition);
            }
        }
    }, [
        apiRef,
        hasFocus
    ]);
    const publish = $efe60d7621886a65$var$React.useCallback((eventName)=>(event)=>{
            // Ignore portal
            // See https://github.com/mui/mui-x/issues/1721
            if ((0, $08bb4bf24f47b880$exports.isEventTargetInPortal)(event)) return;
            apiRef.current.publishEvent(eventName, renderParams, event);
        }, // For now this is stupid, because renderParams change all the time.
    // Need to move it's computation in the api, such that for a given depth+columnField, I can get the group parameters
    [
        apiRef,
        renderParams
    ]);
    const mouseEventsHandlers = $efe60d7621886a65$var$React.useMemo(()=>({
            onKeyDown: publish('columnGroupHeaderKeyDown'),
            onFocus: publish('columnGroupHeaderFocus'),
            onBlur: publish('columnGroupHeaderBlur')
        }), [
        publish
    ]);
    const headerClassName = typeof group.headerClassName === 'function' ? group.headerClassName(renderParams) : group.headerClassName;
    const style = $efe60d7621886a65$var$React.useMemo(()=>(0, $69aaaa4d4ca0aa66$exports.attachPinnedStyle)((0, $efe60d7621886a65$var$_extends2.default)({}, props.style), isRtl, pinnedPosition, pinnedOffset), [
        pinnedPosition,
        pinnedOffset,
        props.style,
        isRtl
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($30ff34474d4fdbcc$exports.GridGenericColumnHeaderItem, (0, $efe60d7621886a65$var$_extends2.default)({
        ref: headerCellRef,
        classes: classes,
        columnMenuOpen: false,
        colIndex: colIndex,
        height: height,
        isResizing: false,
        sortDirection: null,
        hasFocus: false,
        tabIndex: tabIndex,
        isDraggable: false,
        headerComponent: headerComponent,
        headerClassName: headerClassName,
        description: description,
        elementId: elementId,
        width: width,
        columnMenuIconButton: null,
        columnTitleIconButtons: null,
        resizable: false,
        label: label,
        "aria-colspan": fields.length,
        "data-fields": `|-${fields.join('-|-')}-|`,
        style: style
    }, mouseEventsHandlers));
}




var $917a7d0f9d31e9dd$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $917a7d0f9d31e9dd$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($917a7d0f9d31e9dd$exports, "__esModule", {
    value: true
});
$917a7d0f9d31e9dd$exports.GridScrollbarFillerCell = $917a7d0f9d31e9dd$var$GridScrollbarFillerCell;

var $917a7d0f9d31e9dd$var$_clsx = $917a7d0f9d31e9dd$require$_interopRequireDefault((parcelRequire("9QePP")));


var $ayMG0 = parcelRequire("ayMG0");
const $917a7d0f9d31e9dd$var$classes = {
    root: $553c2bbb14fa5500$exports.gridClasses.scrollbarFiller,
    pinnedRight: $553c2bbb14fa5500$exports.gridClasses['scrollbarFiller--pinnedRight']
};
function $917a7d0f9d31e9dd$var$GridScrollbarFillerCell({ pinnedRight: pinnedRight }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        role: "presentation",
        className: (0, $917a7d0f9d31e9dd$var$_clsx.default)($917a7d0f9d31e9dd$var$classes.root, pinnedRight && $917a7d0f9d31e9dd$var$classes.pinnedRight)
    });
}





var $5H1vo = parcelRequire("5H1vo");



var $ayMG0 = parcelRequire("ayMG0");
const $ca184fa0bded5702$var$GridColumnHeaderRow = $ca184fa0bded5702$exports.GridColumnHeaderRow = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnHeaderRow'
})({
    display: 'flex'
});
const $ca184fa0bded5702$var$useGridColumnHeaders = (props)=>{
    const { visibleColumns: visibleColumns, sortColumnLookup: sortColumnLookup, filterColumnLookup: filterColumnLookup, columnHeaderTabIndexState: columnHeaderTabIndexState, columnGroupHeaderTabIndexState: columnGroupHeaderTabIndexState, columnHeaderFocus: columnHeaderFocus, columnGroupHeaderFocus: columnGroupHeaderFocus, headerGroupingMaxDepth: headerGroupingMaxDepth, columnMenuState: columnMenuState, columnVisibility: columnVisibility, columnGroupsHeaderStructure: columnGroupsHeaderStructure, hasOtherElementInTabSequence: hasOtherElementInTabSequence } = props;
    const [dragCol, setDragCol] = $ca184fa0bded5702$var$React.useState('');
    const [resizeCol, setResizeCol] = $ca184fa0bded5702$var$React.useState('');
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const columnGroupsModel = (0, $431c82ec73ef367c$exports.useGridSelector)(apiRef, $cf21d895912d975b$exports.gridColumnGroupsUnwrappedModelSelector);
    const columnPositions = (0, $431c82ec73ef367c$exports.useGridSelector)(apiRef, $e3b5f2e67362f55f$exports.gridColumnPositionsSelector);
    const renderContext = (0, $431c82ec73ef367c$exports.useGridSelector)(apiRef, $94d9a2be66e71282$exports.gridRenderContextColumnsSelector);
    const pinnedColumns = (0, $431c82ec73ef367c$exports.useGridSelector)(apiRef, $e3b5f2e67362f55f$exports.gridVisiblePinnedColumnDefinitionsSelector);
    const columnsLookup = (0, $431c82ec73ef367c$exports.useGridSelector)(apiRef, $e3b5f2e67362f55f$exports.gridColumnLookupSelector);
    const offsetLeft = (0, $f627be570fb53c87$exports.computeOffsetLeft)(columnPositions, renderContext, pinnedColumns.left.length);
    const columnsTotalWidth = (0, $431c82ec73ef367c$exports.useGridSelector)(apiRef, $46349fe7fabb2b4d$exports.gridColumnsTotalWidthSelector);
    const gridHasFiller = (0, $431c82ec73ef367c$exports.useGridSelector)(apiRef, $46349fe7fabb2b4d$exports.gridHasFillerSelector);
    const headerHeight = (0, $431c82ec73ef367c$exports.useGridSelector)(apiRef, $46349fe7fabb2b4d$exports.gridHeaderHeightSelector);
    const groupHeaderHeight = (0, $431c82ec73ef367c$exports.useGridSelector)(apiRef, $46349fe7fabb2b4d$exports.gridGroupHeaderHeightSelector);
    const scrollbarWidth = (0, $431c82ec73ef367c$exports.useGridSelector)(apiRef, $46349fe7fabb2b4d$exports.gridVerticalScrollbarWidthSelector);
    const handleColumnResizeStart = $ca184fa0bded5702$var$React.useCallback((params)=>setResizeCol(params.field), []);
    const handleColumnResizeStop = $ca184fa0bded5702$var$React.useCallback(()=>setResizeCol(''), []);
    const handleColumnReorderStart = $ca184fa0bded5702$var$React.useCallback((params)=>setDragCol(params.field), []);
    const handleColumnReorderStop = $ca184fa0bded5702$var$React.useCallback(()=>setDragCol(''), []);
    const leftRenderContext = $ca184fa0bded5702$var$React.useMemo(()=>{
        return pinnedColumns.left.length ? {
            firstColumnIndex: 0,
            lastColumnIndex: pinnedColumns.left.length
        } : null;
    }, [
        pinnedColumns.left.length
    ]);
    const rightRenderContext = $ca184fa0bded5702$var$React.useMemo(()=>{
        return pinnedColumns.right.length ? {
            firstColumnIndex: visibleColumns.length - pinnedColumns.right.length,
            lastColumnIndex: visibleColumns.length
        } : null;
    }, [
        pinnedColumns.right.length,
        visibleColumns.length
    ]);
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'columnResizeStart', handleColumnResizeStart);
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'columnResizeStop', handleColumnResizeStop);
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'columnHeaderDragStart', handleColumnReorderStart);
    (0, $bc055d85bc2d0e70$exports.useGridEvent)(apiRef, 'columnHeaderDragEndNative', handleColumnReorderStop);
    // Helper for computation common between getColumnHeaders and getColumnGroupHeaders
    const getColumnsToRender = (params)=>{
        const { renderContext: currentContext = renderContext } = params || {};
        const firstColumnToRender = currentContext.firstColumnIndex;
        // HACK: renderContext ins't always synchronized, this should be handled properly.
        const lastColumnToRender = Math.min(currentContext.lastColumnIndex, visibleColumns.length);
        const renderedColumns = visibleColumns.slice(firstColumnToRender, lastColumnToRender);
        return {
            renderedColumns: renderedColumns,
            firstColumnToRender: firstColumnToRender,
            lastColumnToRender: lastColumnToRender
        };
    };
    const getFillers = (params, children, leftOverflow, borderBottom = false)=>{
        const isPinnedRight = params?.position === $e8d35a7c12bdaa1d$exports.PinnedColumnPosition.RIGHT;
        const isNotPinned = params?.position === undefined;
        const hasScrollbarFiller = pinnedColumns.right.length > 0 && isPinnedRight || pinnedColumns.right.length === 0 && isNotPinned;
        const leftOffsetWidth = offsetLeft - leftOverflow;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($ca184fa0bded5702$var$React.Fragment, {
            children: [
                isNotPinned && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    role: "presentation",
                    style: {
                        width: leftOffsetWidth
                    }
                }),
                children,
                isNotPinned && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    role: "presentation",
                    className: (0, $ca184fa0bded5702$var$_clsx.default)($5H1vo.gridClasses.filler, borderBottom && $5H1vo.gridClasses['filler--borderBottom'])
                }),
                hasScrollbarFiller && /*#__PURE__*/ (0, $ayMG0.jsx)($917a7d0f9d31e9dd$exports.GridScrollbarFillerCell, {
                    pinnedRight: isPinnedRight
                })
            ]
        });
    };
    getFillers.displayName = "getFillers";
    const getColumnHeaders = (params, other = {})=>{
        const { renderedColumns: renderedColumns, firstColumnToRender: firstColumnToRender } = getColumnsToRender(params);
        const columns = [];
        for(let i = 0; i < renderedColumns.length; i += 1){
            const colDef = renderedColumns[i];
            const columnIndex = firstColumnToRender + i;
            const isFirstColumn = columnIndex === 0;
            const tabIndex = columnHeaderTabIndexState !== null && columnHeaderTabIndexState.field === colDef.field || isFirstColumn && !hasOtherElementInTabSequence ? 0 : -1;
            const hasFocus = columnHeaderFocus !== null && columnHeaderFocus.field === colDef.field;
            const open = columnMenuState.open && columnMenuState.field === colDef.field;
            const pinnedPosition = params?.position;
            const pinnedOffset = (0, $e85ba38bf3b586f5$exports.getPinnedCellOffset)(pinnedPosition, colDef.computedWidth, columnIndex, columnPositions, columnsTotalWidth, scrollbarWidth);
            const siblingWithBorderingSeparator = pinnedPosition === $e8d35a7c12bdaa1d$exports.PinnedColumnPosition.RIGHT ? renderedColumns[i - 1] : renderedColumns[i + 1];
            const isSiblingFocused = siblingWithBorderingSeparator ? columnHeaderFocus !== null && columnHeaderFocus.field === siblingWithBorderingSeparator.field : false;
            const indexInSection = i;
            const sectionLength = renderedColumns.length;
            const showLeftBorder = (0, $f6d1081691c64c11$exports.shouldCellShowLeftBorder)(pinnedPosition, indexInSection, rootProps.showColumnVerticalBorder, rootProps.pinnedColumnsSectionSeparator);
            const showRightBorder = (0, $f6d1081691c64c11$exports.shouldCellShowRightBorder)(pinnedPosition, indexInSection, sectionLength, rootProps.showColumnVerticalBorder, gridHasFiller, rootProps.pinnedColumnsSectionSeparator);
            columns.push(/*#__PURE__*/ (0, $ayMG0.jsx)($83044eba4b8e40dc$exports.GridColumnHeaderItem, (0, $ca184fa0bded5702$var$_extends2.default)({}, sortColumnLookup[colDef.field], {
                columnMenuOpen: open,
                filterItemsCounter: filterColumnLookup[colDef.field] && filterColumnLookup[colDef.field].length,
                headerHeight: headerHeight,
                isDragging: colDef.field === dragCol,
                colDef: colDef,
                colIndex: columnIndex,
                isResizing: resizeCol === colDef.field,
                isLast: columnIndex === columnPositions.length - 1,
                hasFocus: hasFocus,
                tabIndex: tabIndex,
                pinnedPosition: pinnedPosition,
                pinnedOffset: pinnedOffset,
                isSiblingFocused: isSiblingFocused,
                showLeftBorder: showLeftBorder,
                showRightBorder: showRightBorder
            }, other), colDef.field));
        }
        return getFillers(params, columns, 0);
    };
    const getColumnHeadersRow = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($ca184fa0bded5702$var$GridColumnHeaderRow, {
            role: "row",
            "aria-rowindex": headerGroupingMaxDepth + 1,
            ownerState: rootProps,
            className: $5H1vo.gridClasses['row--borderBottom'],
            style: {
                height: headerHeight
            },
            children: [
                leftRenderContext && getColumnHeaders({
                    position: $e8d35a7c12bdaa1d$exports.PinnedColumnPosition.LEFT,
                    renderContext: leftRenderContext
                }, {
                    disableReorder: true
                }),
                getColumnHeaders({
                    renderContext: renderContext
                }),
                rightRenderContext && getColumnHeaders({
                    position: $e8d35a7c12bdaa1d$exports.PinnedColumnPosition.RIGHT,
                    renderContext: rightRenderContext
                }, {
                    disableReorder: true,
                    separatorSide: $8be1f8ad99c6bade$exports.GridColumnHeaderSeparatorSides.Left
                })
            ]
        });
    };
    getColumnHeadersRow.displayName = "getColumnHeadersRow";
    const getColumnGroupHeaders = ({ depth: depth, params: params })=>{
        const columnsToRender = getColumnsToRender(params);
        if (columnsToRender.renderedColumns.length === 0) return null;
        const { firstColumnToRender: firstColumnToRender, lastColumnToRender: lastColumnToRender } = columnsToRender;
        const rowStructure = columnGroupsHeaderStructure[depth];
        const firstColumnFieldToRender = visibleColumns[firstColumnToRender].field;
        const firstGroupToRender = columnGroupsModel[firstColumnFieldToRender]?.[depth] ?? null;
        const firstGroupIndex = rowStructure.findIndex(({ groupId: groupId, columnFields: columnFields })=>groupId === firstGroupToRender && columnFields.includes(firstColumnFieldToRender));
        const lastColumnFieldToRender = visibleColumns[lastColumnToRender - 1].field;
        const lastGroupToRender = columnGroupsModel[lastColumnFieldToRender]?.[depth] ?? null;
        const lastGroupIndex = rowStructure.findIndex(({ groupId: groupId, columnFields: columnFields })=>groupId === lastGroupToRender && columnFields.includes(lastColumnFieldToRender));
        const visibleColumnGroupHeader = rowStructure.slice(firstGroupIndex, lastGroupIndex + 1).map((groupStructure)=>{
            return (0, $ca184fa0bded5702$var$_extends2.default)({}, groupStructure, {
                columnFields: groupStructure.columnFields.filter((field)=>columnVisibility[field] !== false)
            });
        }).filter((groupStructure)=>groupStructure.columnFields.length > 0);
        const firstVisibleColumnIndex = visibleColumnGroupHeader[0].columnFields.indexOf(firstColumnFieldToRender);
        const hiddenGroupColumns = visibleColumnGroupHeader[0].columnFields.slice(0, firstVisibleColumnIndex);
        const leftOverflow = hiddenGroupColumns.reduce((acc, field)=>{
            const column = columnsLookup[field];
            return acc + (column.computedWidth ?? 0);
        }, 0);
        let columnIndex = firstColumnToRender;
        const children = visibleColumnGroupHeader.map(({ groupId: groupId, columnFields: columnFields }, index)=>{
            const hasFocus = columnGroupHeaderFocus !== null && columnGroupHeaderFocus.depth === depth && columnFields.includes(columnGroupHeaderFocus.field);
            const tabIndex = columnGroupHeaderTabIndexState !== null && columnGroupHeaderTabIndexState.depth === depth && columnFields.includes(columnGroupHeaderTabIndexState.field) ? 0 : -1;
            const headerInfo = {
                groupId: groupId,
                width: columnFields.reduce((acc, field)=>acc + columnsLookup[field].computedWidth, 0),
                fields: columnFields,
                colIndex: columnIndex,
                hasFocus: hasFocus,
                tabIndex: tabIndex
            };
            const pinnedPosition = params.position;
            const pinnedOffset = (0, $e85ba38bf3b586f5$exports.getPinnedCellOffset)(pinnedPosition, headerInfo.width, columnIndex, columnPositions, columnsTotalWidth, scrollbarWidth);
            columnIndex += columnFields.length;
            let indexInSection = index;
            if (pinnedPosition === $e8d35a7c12bdaa1d$exports.PinnedColumnPosition.LEFT) // Group headers can expand to multiple columns, we need to adjust the index
            indexInSection = columnIndex - 1;
            return /*#__PURE__*/ (0, $ayMG0.jsx)($efe60d7621886a65$exports.GridColumnGroupHeader, {
                groupId: groupId,
                width: headerInfo.width,
                fields: headerInfo.fields,
                colIndex: headerInfo.colIndex,
                depth: depth,
                isLastColumn: index === visibleColumnGroupHeader.length - 1,
                maxDepth: headerGroupingMaxDepth,
                height: groupHeaderHeight,
                hasFocus: hasFocus,
                tabIndex: tabIndex,
                pinnedPosition: pinnedPosition,
                pinnedOffset: pinnedOffset,
                showLeftBorder: (0, $f6d1081691c64c11$exports.shouldCellShowLeftBorder)(pinnedPosition, indexInSection, rootProps.showColumnVerticalBorder, rootProps.pinnedColumnsSectionSeparator),
                showRightBorder: (0, $f6d1081691c64c11$exports.shouldCellShowRightBorder)(pinnedPosition, indexInSection, visibleColumnGroupHeader.length, rootProps.showColumnVerticalBorder, gridHasFiller, rootProps.pinnedColumnsSectionSeparator)
            }, index);
        });
        return getFillers(params, children, leftOverflow);
    };
    const getColumnGroupHeadersRows = ()=>{
        if (headerGroupingMaxDepth === 0) return null;
        const headerRows = [];
        for(let depth = 0; depth < headerGroupingMaxDepth; depth += 1)headerRows.push(/*#__PURE__*/ (0, $ayMG0.jsxs)($ca184fa0bded5702$var$GridColumnHeaderRow, {
            role: "row",
            "aria-rowindex": depth + 1,
            ownerState: rootProps,
            style: {
                height: groupHeaderHeight
            },
            children: [
                leftRenderContext && getColumnGroupHeaders({
                    depth: depth,
                    params: {
                        position: $e8d35a7c12bdaa1d$exports.PinnedColumnPosition.LEFT,
                        renderContext: leftRenderContext,
                        maxLastColumn: leftRenderContext.lastColumnIndex
                    }
                }),
                getColumnGroupHeaders({
                    depth: depth,
                    params: {
                        renderContext: renderContext
                    }
                }),
                rightRenderContext && getColumnGroupHeaders({
                    depth: depth,
                    params: {
                        position: $e8d35a7c12bdaa1d$exports.PinnedColumnPosition.RIGHT,
                        renderContext: rightRenderContext,
                        maxLastColumn: rightRenderContext.lastColumnIndex
                    }
                })
            ]
        }, depth));
        return headerRows;
    };
    return {
        renderContext: renderContext,
        leftRenderContext: leftRenderContext,
        rightRenderContext: rightRenderContext,
        pinnedColumns: pinnedColumns,
        visibleColumns: visibleColumns,
        columnPositions: columnPositions,
        getFillers: getFillers,
        getColumnHeadersRow: getColumnHeadersRow,
        getColumnsToRender: getColumnsToRender,
        getColumnGroupHeadersRows: getColumnGroupHeadersRows,
        getPinnedCellOffset: $e85ba38bf3b586f5$exports.getPinnedCellOffset,
        isDragging: !!dragCol,
        getInnerProps: ()=>({
                role: 'rowgroup'
            })
    };
};
$ca184fa0bded5702$exports.useGridColumnHeaders = $ca184fa0bded5702$var$useGridColumnHeaders;


var $1a39131620112653$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $1a39131620112653$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $1a39131620112653$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($1a39131620112653$exports, "__esModule", {
    value: true
});
$1a39131620112653$exports.GridBaseColumnHeaders = void 0;

var $1a39131620112653$var$_extends2 = $1a39131620112653$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $1a39131620112653$var$_objectWithoutPropertiesLoose2 = $1a39131620112653$require$_interopRequireDefault((parcelRequire("c05no")));

var $1a39131620112653$var$React = $1a39131620112653$require$_interopRequireWildcard((parcelRequire("acw62")));

var $1a39131620112653$var$_clsx = $1a39131620112653$require$_interopRequireDefault((parcelRequire("9QePP")));

var $1a39131620112653$var$_composeClasses = $1a39131620112653$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $izOUK = parcelRequire("izOUK");

var $fYxgT = parcelRequire("fYxgT");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $1a39131620112653$var$_excluded = [
    "className"
];
const $1a39131620112653$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'columnHeaders'
        ]
    };
    return (0, $1a39131620112653$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $1a39131620112653$var$GridColumnHeadersRoot = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnHeaders'
})({
    display: 'flex',
    flexDirection: 'column',
    borderTopLeftRadius: 'var(--unstable_DataGrid-radius)',
    borderTopRightRadius: 'var(--unstable_DataGrid-radius)'
});
const $1a39131620112653$var$GridBaseColumnHeaders = $1a39131620112653$exports.GridBaseColumnHeaders = (0, $fYxgT.forwardRef)(function GridColumnHeaders(props, ref) {
    const { className: className } = props, other = (0, $1a39131620112653$var$_objectWithoutPropertiesLoose2.default)(props, $1a39131620112653$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $1a39131620112653$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1a39131620112653$var$GridColumnHeadersRoot, (0, $1a39131620112653$var$_extends2.default)({
        className: (0, $1a39131620112653$var$_clsx.default)(classes.root, className),
        ownerState: rootProps
    }, other, {
        role: "presentation",
        ref: ref
    }));
});
$1a39131620112653$var$GridBaseColumnHeaders.displayName = "GridBaseColumnHeaders";



var $ayMG0 = parcelRequire("ayMG0");
const $056733ac91e6ea07$var$_excluded = [
    "className",
    "visibleColumns",
    "sortColumnLookup",
    "filterColumnLookup",
    "columnHeaderTabIndexState",
    "columnGroupHeaderTabIndexState",
    "columnHeaderFocus",
    "columnGroupHeaderFocus",
    "headerGroupingMaxDepth",
    "columnMenuState",
    "columnVisibility",
    "columnGroupsHeaderStructure",
    "hasOtherElementInTabSequence"
];
const $056733ac91e6ea07$var$GridColumnHeaders = (0, $fYxgT.forwardRef)(function GridColumnHeaders(props, ref) {
    const { visibleColumns: visibleColumns, sortColumnLookup: sortColumnLookup, filterColumnLookup: filterColumnLookup, columnHeaderTabIndexState: columnHeaderTabIndexState, columnGroupHeaderTabIndexState: columnGroupHeaderTabIndexState, columnHeaderFocus: columnHeaderFocus, columnGroupHeaderFocus: columnGroupHeaderFocus, headerGroupingMaxDepth: headerGroupingMaxDepth, columnMenuState: columnMenuState, columnVisibility: columnVisibility, columnGroupsHeaderStructure: columnGroupsHeaderStructure, hasOtherElementInTabSequence: hasOtherElementInTabSequence } = props, other = (0, $056733ac91e6ea07$var$_objectWithoutPropertiesLoose2.default)(props, $056733ac91e6ea07$var$_excluded);
    const { getInnerProps: getInnerProps, getColumnHeadersRow: getColumnHeadersRow, getColumnGroupHeadersRows: getColumnGroupHeadersRows } = (0, $ca184fa0bded5702$exports.useGridColumnHeaders)({
        visibleColumns: visibleColumns,
        sortColumnLookup: sortColumnLookup,
        filterColumnLookup: filterColumnLookup,
        columnHeaderTabIndexState: columnHeaderTabIndexState,
        columnGroupHeaderTabIndexState: columnGroupHeaderTabIndexState,
        columnHeaderFocus: columnHeaderFocus,
        columnGroupHeaderFocus: columnGroupHeaderFocus,
        headerGroupingMaxDepth: headerGroupingMaxDepth,
        columnMenuState: columnMenuState,
        columnVisibility: columnVisibility,
        columnGroupsHeaderStructure: columnGroupsHeaderStructure,
        hasOtherElementInTabSequence: hasOtherElementInTabSequence
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($1a39131620112653$exports.GridBaseColumnHeaders, (0, $056733ac91e6ea07$var$_extends2.default)({}, other, getInnerProps(), {
        ref: ref,
        children: [
            getColumnGroupHeadersRows(),
            getColumnHeadersRow()
        ]
    }));
});
$056733ac91e6ea07$var$GridColumnHeaders.displayName = "GridColumnHeaders";
$056733ac91e6ea07$var$GridColumnHeaders.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    columnGroupHeaderFocus: $056733ac91e6ea07$var$_propTypes.default.shape({
        depth: $056733ac91e6ea07$var$_propTypes.default.number.isRequired,
        field: $056733ac91e6ea07$var$_propTypes.default.string.isRequired
    }),
    columnGroupHeaderTabIndexState: $056733ac91e6ea07$var$_propTypes.default.shape({
        depth: $056733ac91e6ea07$var$_propTypes.default.number.isRequired,
        field: $056733ac91e6ea07$var$_propTypes.default.string.isRequired
    }),
    columnGroupsHeaderStructure: $056733ac91e6ea07$var$_propTypes.default.arrayOf($056733ac91e6ea07$var$_propTypes.default.arrayOf($056733ac91e6ea07$var$_propTypes.default.shape({
        columnFields: $056733ac91e6ea07$var$_propTypes.default.arrayOf($056733ac91e6ea07$var$_propTypes.default.string).isRequired,
        groupId: $056733ac91e6ea07$var$_propTypes.default.string
    }))).isRequired,
    columnHeaderFocus: $056733ac91e6ea07$var$_propTypes.default.shape({
        field: $056733ac91e6ea07$var$_propTypes.default.string.isRequired
    }),
    columnHeaderTabIndexState: $056733ac91e6ea07$var$_propTypes.default.shape({
        field: $056733ac91e6ea07$var$_propTypes.default.string.isRequired
    }),
    columnMenuState: $056733ac91e6ea07$var$_propTypes.default.shape({
        field: $056733ac91e6ea07$var$_propTypes.default.string,
        open: $056733ac91e6ea07$var$_propTypes.default.bool.isRequired
    }).isRequired,
    columnVisibility: $056733ac91e6ea07$var$_propTypes.default.object.isRequired,
    filterColumnLookup: $056733ac91e6ea07$var$_propTypes.default.object.isRequired,
    hasOtherElementInTabSequence: $056733ac91e6ea07$var$_propTypes.default.bool.isRequired,
    headerGroupingMaxDepth: $056733ac91e6ea07$var$_propTypes.default.number.isRequired,
    sortColumnLookup: $056733ac91e6ea07$var$_propTypes.default.object.isRequired,
    visibleColumns: $056733ac91e6ea07$var$_propTypes.default.arrayOf($056733ac91e6ea07$var$_propTypes.default.object).isRequired
};
const $056733ac91e6ea07$var$MemoizedGridColumnHeaders = $056733ac91e6ea07$exports.GridColumnHeaders = (0, $1bc1b286f3c678cc$exports.fastMemo)($056733ac91e6ea07$var$GridColumnHeaders);



var $e2ff31365723feed$exports = {};
"use strict";
Object.defineProperty($e2ff31365723feed$exports, "__esModule", {
    value: true
});
$e2ff31365723feed$exports.GridDetailPanels = $e2ff31365723feed$var$GridDetailPanels;
function $e2ff31365723feed$var$GridDetailPanels(_) {
    return null;
}


var $284ebba9b1828a42$exports = {};
"use strict";
Object.defineProperty($284ebba9b1828a42$exports, "__esModule", {
    value: true
});
$284ebba9b1828a42$exports.GridPinnedRows = $284ebba9b1828a42$var$GridPinnedRows;
function $284ebba9b1828a42$var$GridPinnedRows(_) {
    return null;
}


var $a5125f04ce420a8f$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a5125f04ce420a8f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($a5125f04ce420a8f$exports, "__esModule", {
    value: true
});
$a5125f04ce420a8f$exports.GridNoResultsOverlay = void 0;

var $a5125f04ce420a8f$var$_extends2 = $a5125f04ce420a8f$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $fYxgT = parcelRequire("fYxgT");

var $bDyDY = parcelRequire("bDyDY");


var $ayMG0 = parcelRequire("ayMG0");
const $a5125f04ce420a8f$var$GridNoResultsOverlay = $a5125f04ce420a8f$exports.GridNoResultsOverlay = (0, $fYxgT.forwardRef)(function GridNoResultsOverlay(props, ref) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const noResultsOverlayLabel = apiRef.current.getLocaleText('noResultsOverlayLabel');
    return /*#__PURE__*/ (0, $ayMG0.jsx)($0180de2e65ebf290$exports.GridOverlay, (0, $a5125f04ce420a8f$var$_extends2.default)({}, props, {
        ref: ref,
        children: noResultsOverlayLabel
    }));
});
$a5125f04ce420a8f$var$GridNoResultsOverlay.displayName = "GridNoResultsOverlay";



var $b6014b2d4bf32573$var$_material = $b6014b2d4bf32573$require$_interopRequireDefault((parcelRequire("9lhjy")));
var $13b4c32d410c28d7$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $13b4c32d410c28d7$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $13b4c32d410c28d7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($13b4c32d410c28d7$exports, "__esModule", {
    value: true
});
$13b4c32d410c28d7$exports.GridBottomContainer = $13b4c32d410c28d7$var$GridBottomContainer;

var $13b4c32d410c28d7$var$_extends2 = $13b4c32d410c28d7$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $13b4c32d410c28d7$var$React = $13b4c32d410c28d7$require$_interopRequireWildcard((parcelRequire("acw62")));

var $13b4c32d410c28d7$var$_clsx = $13b4c32d410c28d7$require$_interopRequireDefault((parcelRequire("9QePP")));

var $izOUK = parcelRequire("izOUK");

var $13b4c32d410c28d7$var$_composeClasses = $13b4c32d410c28d7$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $5H1vo = parcelRequire("5H1vo");

var $ayMG0 = parcelRequire("ayMG0");
const $13b4c32d410c28d7$var$useUtilityClasses = ()=>{
    const slots = {
        root: [
            'bottomContainer'
        ]
    };
    return (0, $13b4c32d410c28d7$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, {});
};
const $13b4c32d410c28d7$var$Element = (0, $izOUK.styled)('div')({
    position: 'sticky',
    zIndex: 40,
    bottom: 'calc(var(--DataGrid-hasScrollX) * var(--DataGrid-scrollbarSize))'
});
function $13b4c32d410c28d7$var$GridBottomContainer(props) {
    const classes = $13b4c32d410c28d7$var$useUtilityClasses();
    return /*#__PURE__*/ (0, $ayMG0.jsx)($13b4c32d410c28d7$var$Element, (0, $13b4c32d410c28d7$var$_extends2.default)({}, props, {
        className: (0, $13b4c32d410c28d7$var$_clsx.default)(classes.root, $5H1vo.gridClasses['container--bottom']),
        role: "presentation"
    }));
}



// TODO: camelCase these key. It's a private helper now.
// Remove then need to call `uncapitalizeObjectKeys`.
const $b6014b2d4bf32573$var$DATA_GRID_DEFAULT_SLOTS_COMPONENTS = $b6014b2d4bf32573$exports.DATA_GRID_DEFAULT_SLOTS_COMPONENTS = (0, $b6014b2d4bf32573$var$_extends2.default)({}, $b6014b2d4bf32573$var$_material.default, {
    cell: $50fa6cd6ff946acb$exports.GridCell,
    skeletonCell: $08eee520e810d520$exports.GridSkeletonCell,
    columnHeaderFilterIconButton: $08eee520e810d520$exports.GridColumnHeaderFilterIconButton,
    columnHeaderSortIcon: $08eee520e810d520$exports.GridColumnHeaderSortIcon,
    columnMenu: $3bffa0a776b5a050$exports.GridColumnMenu,
    columnHeaders: $056733ac91e6ea07$exports.GridColumnHeaders,
    detailPanels: $e2ff31365723feed$exports.GridDetailPanels,
    bottomContainer: $13b4c32d410c28d7$exports.GridBottomContainer,
    footer: $08eee520e810d520$exports.GridFooter,
    footerRowCount: $08eee520e810d520$exports.GridRowCount,
    toolbar: $a162346a6ee1b52f$exports.GridToolbar,
    pinnedRows: $284ebba9b1828a42$exports.GridPinnedRows,
    loadingOverlay: $08eee520e810d520$exports.GridLoadingOverlay,
    noResultsOverlay: $a5125f04ce420a8f$exports.GridNoResultsOverlay,
    noRowsOverlay: $08eee520e810d520$exports.GridNoRowsOverlay,
    noColumnsOverlay: $08eee520e810d520$exports.GridNoColumnsOverlay,
    pagination: $08eee520e810d520$exports.GridPagination,
    filterPanel: $08eee520e810d520$exports.GridFilterPanel,
    columnsPanel: $08eee520e810d520$exports.GridColumnsPanel,
    columnsManagement: $08eee520e810d520$exports.GridColumnsManagement,
    panel: $08eee520e810d520$exports.GridPanel,
    row: $08eee520e810d520$exports.GridRow
});




const $c9883683c395e213$var$DATA_GRID_FORCED_PROPS = {
    disableMultipleColumnsFiltering: true,
    disableMultipleColumnsSorting: true,
    throttleRowsMs: undefined,
    hideFooterRowCount: false,
    pagination: true,
    checkboxSelectionVisibleOnly: false,
    disableColumnReorder: true,
    keepColumnPositionIfDraggedOutside: false,
    signature: 'DataGrid',
    listView: false
};
const $c9883683c395e213$var$getDataGridForcedProps = (themedProps)=>(0, $c9883683c395e213$var$_extends2.default)({}, $c9883683c395e213$var$DATA_GRID_FORCED_PROPS, themedProps.dataSource ? {
        filterMode: 'server',
        sortingMode: 'server',
        paginationMode: 'server'
    } : {});
const $c9883683c395e213$var$defaultSlots = $b6014b2d4bf32573$exports.DATA_GRID_DEFAULT_SLOTS_COMPONENTS;
const $c9883683c395e213$var$useDataGridProps = (inProps)=>{
    const theme = (0, $8xDHs.useTheme)();
    const themedProps = $c9883683c395e213$var$React.useMemo(()=>(0, $izOUK.getThemeProps)({
            props: inProps,
            theme: theme,
            name: 'MuiDataGrid'
        }), [
        theme,
        inProps
    ]);
    const localeText = $c9883683c395e213$var$React.useMemo(()=>(0, $c9883683c395e213$var$_extends2.default)({}, $553c2bbb14fa5500$exports.GRID_DEFAULT_LOCALE_TEXT, themedProps.localeText), [
        themedProps.localeText
    ]);
    const slots = $c9883683c395e213$var$React.useMemo(()=>(0, $69aaaa4d4ca0aa66$exports.computeSlots)({
            defaultSlots: $c9883683c395e213$var$defaultSlots,
            slots: themedProps.slots
        }), [
        themedProps.slots
    ]);
    const injectDefaultProps = $c9883683c395e213$var$React.useMemo(()=>{
        return Object.keys($0f96df060f8ddda5$exports.DATA_GRID_PROPS_DEFAULT_VALUES).reduce((acc, key)=>{
            // @ts-ignore
            acc[key] = themedProps[key] ?? $0f96df060f8ddda5$exports.DATA_GRID_PROPS_DEFAULT_VALUES[key];
            return acc;
        }, {});
    }, [
        themedProps
    ]);
    return $c9883683c395e213$var$React.useMemo(()=>(0, $c9883683c395e213$var$_extends2.default)({}, themedProps, injectDefaultProps, {
            localeText: localeText,
            slots: slots
        }, $c9883683c395e213$var$getDataGridForcedProps(themedProps)), [
        themedProps,
        localeText,
        slots,
        injectDefaultProps
    ]);
};
$c9883683c395e213$exports.useDataGridProps = $c9883683c395e213$var$useDataGridProps;




var $5LM2M = parcelRequire("5LM2M");
var $230820e73b0114fd$exports = {};
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $230820e73b0114fd$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($230820e73b0114fd$exports, "__esModule", {
    value: true
});
$230820e73b0114fd$exports.unwrapPrivateAPI = $230820e73b0114fd$var$unwrapPrivateAPI;
$230820e73b0114fd$exports.useGridApiInitialization = $230820e73b0114fd$var$useGridApiInitialization;

var $230820e73b0114fd$var$React = $230820e73b0114fd$require$_interopRequireWildcard((parcelRequire("acw62")));
var $f750bf0466183dbe$exports = {};
"use strict";
Object.defineProperty($f750bf0466183dbe$exports, "__esModule", {
    value: true
});
Object.defineProperty($f750bf0466183dbe$exports, "EventManager", {
    enumerable: true,
    get: function() {
        return $ef2a3ef580a6a077$exports.EventManager;
    }
});
var $ef2a3ef580a6a077$exports = {};
"use strict";
Object.defineProperty($ef2a3ef580a6a077$exports, "__esModule", {
    value: true
});
$ef2a3ef580a6a077$exports.EventManager = void 0;
// Used https://gist.github.com/mudge/5830382 as a starting point.
// See https://github.com/browserify/events/blob/master/events.js for
// the Node.js (https://nodejs.org/api/events.html) polyfill used by webpack.
class $ef2a3ef580a6a077$var$EventManager {
    maxListeners = 20;
    warnOnce = false;
    events = {};
    on(eventName, listener, options = {}) {
        let collection = this.events[eventName];
        if (!collection) {
            collection = {
                highPriority: new Map(),
                regular: new Map()
            };
            this.events[eventName] = collection;
        }
        if (options.isFirst) collection.highPriority.set(listener, true);
        else collection.regular.set(listener, true);
        {
            const collectionSize = collection.highPriority.size + collection.regular.size;
            if (collectionSize > this.maxListeners && !this.warnOnce) {
                this.warnOnce = true;
                console.warn([
                    `Possible EventEmitter memory leak detected. ${collectionSize} ${eventName} listeners added.`
                ].join('\n'));
            }
        }
    }
    removeListener(eventName, listener) {
        if (this.events[eventName]) {
            this.events[eventName].regular.delete(listener);
            this.events[eventName].highPriority.delete(listener);
        }
    }
    removeAllListeners() {
        this.events = {};
    }
    emit(eventName, ...args) {
        const collection = this.events[eventName];
        if (!collection) return;
        const highPriorityListeners = Array.from(collection.highPriority.keys());
        const regularListeners = Array.from(collection.regular.keys());
        for(let i = highPriorityListeners.length - 1; i >= 0; i -= 1){
            const listener = highPriorityListeners[i];
            if (collection.highPriority.has(listener)) listener.apply(this, args);
        }
        for(let i = 0; i < regularListeners.length; i += 1){
            const listener = regularListeners[i];
            if (collection.regular.has(listener)) listener.apply(this, args);
        }
    }
    once(eventName, listener) {
        // eslint-disable-next-line consistent-this
        const that = this;
        this.on(eventName, function oneTimeListener(...args) {
            that.removeListener(eventName, oneTimeListener);
            listener.apply(that, args);
        });
    }
}
$ef2a3ef580a6a077$exports.EventManager = $ef2a3ef580a6a077$var$EventManager;







const $230820e73b0114fd$var$SYMBOL_API_PRIVATE = Symbol('mui.api_private');
const $230820e73b0114fd$var$isSyntheticEvent = (event)=>{
    return event.isPropagationStopped !== undefined;
};
function $230820e73b0114fd$var$unwrapPrivateAPI(publicApi) {
    return publicApi[$230820e73b0114fd$var$SYMBOL_API_PRIVATE];
}
let $230820e73b0114fd$var$globalId = 0;
function $230820e73b0114fd$var$createPrivateAPI(publicApiRef) {
    const existingPrivateApi = publicApiRef.current?.[$230820e73b0114fd$var$SYMBOL_API_PRIVATE];
    if (existingPrivateApi) return existingPrivateApi;
    const state = {};
    const privateApi = {
        state: state,
        store: $66c3b1bd8ca83ba8$exports.Store.create(state),
        instanceId: {
            id: $230820e73b0114fd$var$globalId
        }
    };
    $230820e73b0114fd$var$globalId += 1;
    privateApi.getPublicApi = ()=>publicApiRef.current;
    privateApi.register = (visibility, methods)=>{
        Object.keys(methods).forEach((methodName)=>{
            const method = methods[methodName];
            const currentPrivateMethod = privateApi[methodName];
            if (currentPrivateMethod?.spying === true) currentPrivateMethod.target = method;
            else privateApi[methodName] = method;
            if (visibility === 'public') {
                const publicApi = publicApiRef.current;
                const currentPublicMethod = publicApi[methodName];
                if (currentPublicMethod?.spying === true) currentPublicMethod.target = method;
                else publicApi[methodName] = method;
            }
        });
    };
    privateApi.register('private', {
        caches: {},
        eventManager: new $f750bf0466183dbe$exports.EventManager()
    });
    return privateApi;
}
function $230820e73b0114fd$var$createPublicAPI(privateApiRef) {
    const publicApi = {
        get state () {
            return privateApiRef.current.state;
        },
        get store () {
            return privateApiRef.current.store;
        },
        get instanceId () {
            return privateApiRef.current.instanceId;
        },
        [$230820e73b0114fd$var$SYMBOL_API_PRIVATE]: privateApiRef.current
    };
    return publicApi;
}
function $230820e73b0114fd$var$useGridApiInitialization(inputApiRef, props) {
    const publicApiRef = $230820e73b0114fd$var$React.useRef(null);
    const privateApiRef = $230820e73b0114fd$var$React.useRef(null);
    if (!privateApiRef.current) privateApiRef.current = $230820e73b0114fd$var$createPrivateAPI(publicApiRef);
    if (!publicApiRef.current) publicApiRef.current = $230820e73b0114fd$var$createPublicAPI(privateApiRef);
    const publishEvent = $230820e73b0114fd$var$React.useCallback((...args)=>{
        const [name, params, event = {}] = args;
        event.defaultMuiPrevented = false;
        if ($230820e73b0114fd$var$isSyntheticEvent(event) && event.isPropagationStopped()) return;
        const details = props.signature === $dc886d040ec4e87c$exports.GridSignature.DataGridPro || props.signature === $dc886d040ec4e87c$exports.GridSignature.DataGridPremium ? {
            api: privateApiRef.current.getPublicApi()
        } : {};
        privateApiRef.current.eventManager.emit(name, params, event, details);
    }, [
        privateApiRef,
        props.signature
    ]);
    const subscribeEvent = $230820e73b0114fd$var$React.useCallback((event, handler, options)=>{
        privateApiRef.current.eventManager.on(event, handler, options);
        const api = privateApiRef.current;
        return ()=>{
            api.eventManager.removeListener(event, handler);
        };
    }, [
        privateApiRef
    ]);
    (0, $d79b1aa4f5237e85$exports.useGridApiMethod)(privateApiRef, {
        subscribeEvent: subscribeEvent,
        publishEvent: publishEvent
    }, 'public');
    if (inputApiRef && !inputApiRef.current?.state) inputApiRef.current = publicApiRef.current;
    $230820e73b0114fd$var$React.useImperativeHandle(inputApiRef, ()=>publicApiRef.current, [
        publicApiRef
    ]);
    $230820e73b0114fd$var$React.useEffect(()=>{
        const api = privateApiRef.current;
        return ()=>{
            api.publishEvent('unmount');
        };
    }, [
        privateApiRef
    ]);
    return privateApiRef;
}



var $ayMG0 = parcelRequire("ayMG0");
const $141bce2f2738cba8$var$configuration = {
    hooks: {
        useCSSVariables: $5LM2M.useMaterialCSSVariables,
        useGridAriaAttributes: $3fc22bf49019df83$exports.useGridAriaAttributes,
        useGridRowAriaAttributes: $678bcf5a7d335a8a$exports.useGridRowAriaAttributes,
        useGridRowsOverridableMethods: $50188751eb2724d1$exports.useGridRowsOverridableMethods,
        useGridParamsOverridableMethods: $603a3e97252d3bf4$exports.useGridParamsOverridableMethods,
        useIsCellEditable: $095cd0a8de7ac37d$exports.useIsCellEditable,
        useCellAggregationResult: ()=>null,
        useFilterValueGetter: (apiRef)=>apiRef.current.getRowValue
    }
};
const $141bce2f2738cba8$var$DataGridRaw = function DataGrid(inProps, ref) {
    const props = (0, $c9883683c395e213$exports.useDataGridProps)(inProps);
    const privateApiRef = (0, $230820e73b0114fd$exports.useGridApiInitialization)(props.apiRef, props);
    (0, $4524a6bb6d2f99a9$exports.useDataGridComponent)(privateApiRef, props, $141bce2f2738cba8$var$configuration);
    (0, $a1b65922f847acc6$exports.validateProps)(props, $a1b65922f847acc6$exports.propValidatorsDataGrid);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a8b96ca779d42ed2$exports.GridContextProvider, {
        privateApiRef: privateApiRef,
        configuration: $141bce2f2738cba8$var$configuration,
        props: props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($08eee520e810d520$exports.GridRoot, (0, $141bce2f2738cba8$var$_extends2.default)({
            className: props.className,
            style: props.style,
            sx: props.sx
        }, props.slotProps?.root, {
            ref: ref
        }))
    });
};
$141bce2f2738cba8$var$DataGridRaw.displayName = "DataGridRaw";
/**
 * Features:
 * - [DataGrid](https://mui.com/x/react-data-grid/features/)
 *
 * API:
 * - [DataGrid API](https://mui.com/x/api/data-grid/data-grid/)
 */ const $141bce2f2738cba8$var$DataGrid = $141bce2f2738cba8$exports.DataGrid = /*#__PURE__*/ $141bce2f2738cba8$var$React.memo((0, $fYxgT.forwardRef)($141bce2f2738cba8$var$DataGridRaw));
$141bce2f2738cba8$var$DataGrid.displayName = "DataGrid";
$141bce2f2738cba8$var$DataGridRaw.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * The ref object that allows Data Grid manipulation. Can be instantiated with `useGridApiRef()`.
   */ apiRef: $141bce2f2738cba8$var$_propTypes.default.shape({
        current: $141bce2f2738cba8$var$_propTypes.default.object
    }),
    /**
   * The `aria-label` of the Data Grid.
   */ 'aria-label': $141bce2f2738cba8$var$_propTypes.default.string,
    /**
   * The `id` of the element containing a label for the Data Grid.
   */ 'aria-labelledby': $141bce2f2738cba8$var$_propTypes.default.string,
    /**
   * If `true`, the Data Grid height is dynamic and follows the number of rows in the Data Grid.
   * @default false
   * @deprecated Use flex parent container instead: https://mui.com/x/react-data-grid/layout/#flex-parent-container
   * @example
   * <div style={{ display: 'flex', flexDirection: 'column' }}>
   *   <DataGrid />
   * </div>
   */ autoHeight: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * If `true`, the pageSize is calculated according to the container size and the max number of rows to avoid rendering a vertical scroll bar.
   * @default false
   */ autoPageSize: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * If `true`, columns are autosized after the datagrid is mounted.
   * @default false
   */ autosizeOnMount: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * The options for autosize when user-initiated.
   */ autosizeOptions: $141bce2f2738cba8$var$_propTypes.default.shape({
        columns: $141bce2f2738cba8$var$_propTypes.default.arrayOf($141bce2f2738cba8$var$_propTypes.default.string),
        disableColumnVirtualization: $141bce2f2738cba8$var$_propTypes.default.bool,
        expand: $141bce2f2738cba8$var$_propTypes.default.bool,
        includeHeaders: $141bce2f2738cba8$var$_propTypes.default.bool,
        includeOutliers: $141bce2f2738cba8$var$_propTypes.default.bool,
        outliersFactor: $141bce2f2738cba8$var$_propTypes.default.number
    }),
    /**
   * Controls the modes of the cells.
   */ cellModesModel: $141bce2f2738cba8$var$_propTypes.default.object,
    /**
   * If `true`, the Data Grid will display an extra column with checkboxes for selecting rows.
   * @default false
   */ checkboxSelection: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $141bce2f2738cba8$var$_propTypes.default.object,
    className: $141bce2f2738cba8$var$_propTypes.default.string,
    /**
   * The character used to separate cell values when copying to the clipboard.
   * @default '\t'
   */ clipboardCopyCellDelimiter: $141bce2f2738cba8$var$_propTypes.default.string,
    /**
   * Column region in pixels to render before/after the viewport
   * @default 150
   */ columnBufferPx: $141bce2f2738cba8$var$_propTypes.default.number,
    /**
   * The milliseconds delay to wait after a keystroke before triggering filtering in the columns menu.
   * @default 150
   */ columnFilterDebounceMs: $141bce2f2738cba8$var$_propTypes.default.number,
    /**
   * Sets the height in pixels of the column group headers in the Data Grid.
   * Inherits the `columnHeaderHeight` value if not set.
   */ columnGroupHeaderHeight: $141bce2f2738cba8$var$_propTypes.default.number,
    columnGroupingModel: $141bce2f2738cba8$var$_propTypes.default.arrayOf($141bce2f2738cba8$var$_propTypes.default.object),
    /**
   * Sets the height in pixel of the column headers in the Data Grid.
   * @default 56
   */ columnHeaderHeight: $141bce2f2738cba8$var$_propTypes.default.number,
    /**
   * Set of columns of type [[GridColDef]][].
   */ columns: $141bce2f2738cba8$var$_propTypes.default.arrayOf($141bce2f2738cba8$var$_propTypes.default.object).isRequired,
    /**
   * Set the column visibility model of the Data Grid.
   * If defined, the Data Grid will ignore the `hide` property in [[GridColDef]].
   */ columnVisibilityModel: $141bce2f2738cba8$var$_propTypes.default.object,
    /**
   * The data source object.
   */ dataSource: $141bce2f2738cba8$var$_propTypes.default.shape({
        getRows: $141bce2f2738cba8$var$_propTypes.default.func.isRequired,
        updateRow: $141bce2f2738cba8$var$_propTypes.default.func
    }),
    /**
   * Data source cache object.
   */ dataSourceCache: $141bce2f2738cba8$var$_propTypes.default.shape({
        clear: $141bce2f2738cba8$var$_propTypes.default.func.isRequired,
        get: $141bce2f2738cba8$var$_propTypes.default.func.isRequired,
        set: $141bce2f2738cba8$var$_propTypes.default.func.isRequired
    }),
    /**
   * Set the density of the Data Grid.
   * @default "standard"
   */ density: $141bce2f2738cba8$var$_propTypes.default.oneOf([
        'comfortable',
        'compact',
        'standard'
    ]),
    /**
   * If `true`, column autosizing on header separator double-click is disabled.
   * @default false
   */ disableAutosize: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * If `true`, column filters are disabled.
   * @default false
   */ disableColumnFilter: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * If `true`, the column menu is disabled.
   * @default false
   */ disableColumnMenu: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * If `true`, resizing columns is disabled.
   * @default false
   */ disableColumnResize: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * If `true`, hiding/showing columns is disabled.
   * @default false
   */ disableColumnSelector: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * If `true`, the column sorting feature will be disabled.
   * @default false
   */ disableColumnSorting: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * If `true`, the density selector is disabled.
   * @default false
   */ disableDensitySelector: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * If `true`, `eval()` is not used for performance optimization.
   * @default false
   */ disableEval: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * If `true`, multiple selection using the Ctrl/CMD or Shift key is disabled.
   * The MIT DataGrid will ignore this prop, unless `checkboxSelection` is enabled.
   * @default false (`!props.checkboxSelection` for MIT Data Grid)
   */ disableMultipleRowSelection: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * If `true`, the Data Grid will not use the exclude model optimization when selecting all rows.
   * @default false
   */ disableRowSelectionExcludeModel: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * If `true`, the selection on click on a row or cell is disabled.
   * @default false
   */ disableRowSelectionOnClick: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * If `true`, the virtualization is disabled.
   * @default false
   */ disableVirtualization: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * Controls whether to use the cell or row editing.
   * @default "cell"
   */ editMode: $141bce2f2738cba8$var$_propTypes.default.oneOf([
        'cell',
        'row'
    ]),
    /**
   * Use if the actual rowCount is not known upfront, but an estimation is available.
   * If some rows have children (for instance in the tree data), this number represents the amount of top level rows.
   * Applicable only with `paginationMode="server"` and when `rowCount="-1"`
   */ estimatedRowCount: $141bce2f2738cba8$var$_propTypes.default.number,
    /**
   * Unstable features, breaking changes might be introduced.
   * For each feature, if the flag is not explicitly set to `true`, the feature will be fully disabled and any property / method call will not have any effect.
   */ experimentalFeatures: $141bce2f2738cba8$var$_propTypes.default.shape({
        warnIfFocusStateIsNotSynced: $141bce2f2738cba8$var$_propTypes.default.bool
    }),
    /**
   * The milliseconds delay to wait after a keystroke before triggering filtering.
   * @default 150
   */ filterDebounceMs: $141bce2f2738cba8$var$_propTypes.default.number,
    /**
   * Filtering can be processed on the server or client-side.
   * Set it to 'server' if you would like to handle filtering on the server-side.
   * @default "client"
   */ filterMode: $141bce2f2738cba8$var$_propTypes.default.oneOf([
        'client',
        'server'
    ]),
    /**
   * Set the filter model of the Data Grid.
   */ filterModel: $141bce2f2738cba8$var$_propTypes.default.shape({
        items: $141bce2f2738cba8$var$_propTypes.default.arrayOf($141bce2f2738cba8$var$_propTypes.default.shape({
            field: $141bce2f2738cba8$var$_propTypes.default.string.isRequired,
            id: $141bce2f2738cba8$var$_propTypes.default.oneOfType([
                $141bce2f2738cba8$var$_propTypes.default.number,
                $141bce2f2738cba8$var$_propTypes.default.string
            ]),
            operator: $141bce2f2738cba8$var$_propTypes.default.string.isRequired,
            value: $141bce2f2738cba8$var$_propTypes.default.any
        })).isRequired,
        logicOperator: $141bce2f2738cba8$var$_propTypes.default.oneOf([
            'and',
            'or'
        ]),
        quickFilterExcludeHiddenColumns: $141bce2f2738cba8$var$_propTypes.default.bool,
        quickFilterLogicOperator: $141bce2f2738cba8$var$_propTypes.default.oneOf([
            'and',
            'or'
        ]),
        quickFilterValues: $141bce2f2738cba8$var$_propTypes.default.array
    }),
    /**
   * Function that applies CSS classes dynamically on cells.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @returns {string} The CSS class to apply to the cell.
   */ getCellClassName: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Function that returns the element to render in row detail.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @returns {React.JSX.Element} The row detail element.
   */ getDetailPanelContent: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Function that returns the estimated height for a row.
   * Only works if dynamic row height is used.
   * Once the row height is measured this value is discarded.
   * @param {GridRowHeightParams} params With all properties from [[GridRowHeightParams]].
   * @returns {number | null} The estimated row height value. If `null` or `undefined` then the default row height, based on the density, is applied.
   */ getEstimatedRowHeight: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Function that applies CSS classes dynamically on rows.
   * @param {GridRowClassNameParams} params With all properties from [[GridRowClassNameParams]].
   * @returns {string} The CSS class to apply to the row.
   */ getRowClassName: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Function that sets the row height per row.
   * @param {GridRowHeightParams} params With all properties from [[GridRowHeightParams]].
   * @returns {GridRowHeightReturnValue} The row height value. If `null` or `undefined` then the default row height is applied. If "auto" then the row height is calculated based on the content.
   */ getRowHeight: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Return the id of a given [[GridRowModel]].
   * Ensure the reference of this prop is stable to avoid performance implications.
   * It could be done by either defining the prop outside of the component or by memoizing it.
   */ getRowId: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Function that allows to specify the spacing between rows.
   * @param {GridRowSpacingParams} params With all properties from [[GridRowSpacingParams]].
   * @returns {GridRowSpacing} The row spacing values.
   */ getRowSpacing: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * If `true`, the footer component is hidden.
   * @default false
   */ hideFooter: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * If `true`, the pagination component in the footer is hidden.
   * @default false
   */ hideFooterPagination: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * If `true`, the selected row count in the footer is hidden.
   * @default false
   */ hideFooterSelectedRowCount: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * If `true`, the diacritics (accents) are ignored when filtering or quick filtering.
   * E.g. when filter value is `cafe`, the rows with `café` will be visible.
   * @default false
   */ ignoreDiacritics: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * If `true`, the Data Grid will not use `valueFormatter` when exporting to CSV or copying to clipboard.
   * If an object is provided, you can choose to ignore the `valueFormatter` for CSV export or clipboard export.
   * @default false
   */ ignoreValueFormatterDuringExport: $141bce2f2738cba8$var$_propTypes.default.oneOfType([
        $141bce2f2738cba8$var$_propTypes.default.shape({
            clipboardExport: $141bce2f2738cba8$var$_propTypes.default.bool,
            csvExport: $141bce2f2738cba8$var$_propTypes.default.bool
        }),
        $141bce2f2738cba8$var$_propTypes.default.bool
    ]),
    /**
   * The initial state of the DataGrid.
   * The data in it will be set in the state on initialization but will not be controlled.
   * If one of the data in `initialState` is also being controlled, then the control state wins.
   */ initialState: $141bce2f2738cba8$var$_propTypes.default.object,
    /**
   * Callback fired when a cell is rendered, returns true if the cell is editable.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @returns {boolean} A boolean indicating if the cell is editable.
   */ isCellEditable: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Determines if a row can be selected.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @returns {boolean} A boolean indicating if the row is selectable.
   */ isRowSelectable: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * If `true`, the selection model will retain selected rows that do not exist.
   * Useful when using server side pagination and row selections need to be retained
   * when changing pages.
   * @default false
   */ keepNonExistentRowsSelected: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * The label of the Data Grid.
   * If the `showToolbar` prop is `true`, the label will be displayed in the toolbar and applied to the `aria-label` attribute of the grid.
   * If the `showToolbar` prop is `false`, the label will not be visible but will be applied to the `aria-label` attribute of the grid.
   */ label: $141bce2f2738cba8$var$_propTypes.default.string,
    /**
   * If `true`, a loading overlay is displayed.
   * @default false
   */ loading: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * Set the locale text of the Data Grid.
   * You can find all the translation keys supported in [the source](https://github.com/mui/mui-x/blob/HEAD/packages/x-data-grid/src/constants/localeTextConstants.ts) in the GitHub repository.
   */ localeText: $141bce2f2738cba8$var$_propTypes.default.object,
    /**
   * Pass a custom logger in the components that implements the [[Logger]] interface.
   * @default console
   */ logger: $141bce2f2738cba8$var$_propTypes.default.shape({
        debug: $141bce2f2738cba8$var$_propTypes.default.func.isRequired,
        error: $141bce2f2738cba8$var$_propTypes.default.func.isRequired,
        info: $141bce2f2738cba8$var$_propTypes.default.func.isRequired,
        warn: $141bce2f2738cba8$var$_propTypes.default.func.isRequired
    }),
    /**
   * Allows to pass the logging level or false to turn off logging.
   * @default "error" ("warn" in dev mode)
   */ logLevel: $141bce2f2738cba8$var$_propTypes.default.oneOf([
        'debug',
        'error',
        'info',
        'warn',
        false
    ]),
    /**
   * Nonce of the inline styles for [Content Security Policy](https://www.w3.org/TR/2016/REC-CSP2-20161215/#script-src-the-nonce-attribute).
   */ nonce: $141bce2f2738cba8$var$_propTypes.default.string,
    /**
   * Callback fired when any cell is clicked.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onCellClick: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when a double click event comes from a cell element.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onCellDoubleClick: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when the cell turns to edit mode.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.KeyboardEvent | React.MouseEvent>} event The event that caused this prop to be called.
   */ onCellEditStart: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when the cell turns to view mode.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<MuiBaseEvent>} event The event that caused this prop to be called.
   */ onCellEditStop: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when a keydown event comes from a cell element.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.KeyboardEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onCellKeyDown: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when the `cellModesModel` prop changes.
   * @param {GridCellModesModel} cellModesModel Object containing which cells are in "edit" mode.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onCellModesModelChange: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback called when the data is copied to the clipboard.
   * @param {string} data The data copied to the clipboard.
   */ onClipboardCopy: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when a click event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderClick: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when a contextmenu event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   */ onColumnHeaderContextMenu: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when a double click event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderDoubleClick: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when a mouse enter event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderEnter: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when a mouse leave event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderLeave: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when a mouseout event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderOut: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when a mouseover event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderOver: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when a column is reordered.
   * @param {GridColumnOrderChangeParams} params With all properties from [[GridColumnOrderChangeParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnOrderChange: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired while a column is being resized.
   * @param {GridColumnResizeParams} params With all properties from [[GridColumnResizeParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnResize: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when the column visibility model changes.
   * @param {GridColumnVisibilityModel} model The new model.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnVisibilityModelChange: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when the width of a column is changed.
   * @param {GridColumnResizeParams} params With all properties from [[GridColumnResizeParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnWidthChange: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when a data source request fails.
   * @param {GridGetRowsError | GridUpdateRowError} error The data source error object.
   */ onDataSourceError: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when the density changes.
   * @param {GridDensity} density New density value.
   */ onDensityChange: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when the Filter model changes before the filters are applied.
   * @param {GridFilterModel} model With all properties from [[GridFilterModel]].
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onFilterModelChange: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when the menu is closed.
   * @param {GridMenuParams} params With all properties from [[GridMenuParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onMenuClose: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when the menu is opened.
   * @param {GridMenuParams} params With all properties from [[GridMenuParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onMenuOpen: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when the pagination meta has changed.
   * @param {GridPaginationMeta} paginationMeta Updated pagination meta.
   */ onPaginationMetaChange: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when the pagination model has changed.
   * @param {GridPaginationModel} model Updated pagination model.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onPaginationModelChange: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when the preferences panel is closed.
   * @param {GridPreferencePanelParams} params With all properties from [[GridPreferencePanelParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onPreferencePanelClose: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when the preferences panel is opened.
   * @param {GridPreferencePanelParams} params With all properties from [[GridPreferencePanelParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onPreferencePanelOpen: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback called when `processRowUpdate()` throws an error or rejects.
   * @param {any} error The error thrown.
   */ onProcessRowUpdateError: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when the Data Grid is resized.
   * @param {ElementSize} containerSize With all properties from [[ElementSize]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onResize: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when a row is clicked.
   * Not called if the target clicked is an interactive element added by the built-in columns.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onRowClick: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when the row count has changed.
   * @param {number} count Updated row count.
   */ onRowCountChange: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when a double click event comes from a row container element.
   * @param {GridRowParams} params With all properties from [[RowParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onRowDoubleClick: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when the row turns to edit mode.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @param {MuiEvent<React.KeyboardEvent | React.MouseEvent>} event The event that caused this prop to be called.
   */ onRowEditStart: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when the row turns to view mode.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @param {MuiEvent<MuiBaseEvent>} event The event that caused this prop to be called.
   */ onRowEditStop: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when the `rowModesModel` prop changes.
   * @param {GridRowModesModel} rowModesModel Object containing which rows are in "edit" mode.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onRowModesModelChange: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when the selection state of one or multiple rows changes.
   * @param {GridRowSelectionModel} rowSelectionModel With all the row ids [[GridSelectionModel]].
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onRowSelectionModelChange: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when the sort model changes before a column is sorted.
   * @param {GridSortModel} model With all properties from [[GridSortModel]].
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onSortModelChange: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when the state of the Data Grid is updated.
   * @param {GridState} state The new state.
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   * @ignore - do not document.
   */ onStateChange: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Select the pageSize dynamically using the component UI.
   * @default [25, 50, 100]
   */ pageSizeOptions: $141bce2f2738cba8$var$_propTypes.default.arrayOf($141bce2f2738cba8$var$_propTypes.default.oneOfType([
        $141bce2f2738cba8$var$_propTypes.default.number,
        $141bce2f2738cba8$var$_propTypes.default.shape({
            label: $141bce2f2738cba8$var$_propTypes.default.string.isRequired,
            value: $141bce2f2738cba8$var$_propTypes.default.number.isRequired
        })
    ]).isRequired),
    pagination: $141bce2f2738cba8$var$_propTypes.default.oneOf([
        true
    ]),
    /**
   * The extra information about the pagination state of the Data Grid.
   * Only applicable with `paginationMode="server"`.
   */ paginationMeta: $141bce2f2738cba8$var$_propTypes.default.shape({
        hasNextPage: $141bce2f2738cba8$var$_propTypes.default.bool
    }),
    /**
   * Pagination can be processed on the server or client-side.
   * Set it to 'client' if you would like to handle the pagination on the client-side.
   * Set it to 'server' if you would like to handle the pagination on the server-side.
   * @default "client"
   */ paginationMode: $141bce2f2738cba8$var$_propTypes.default.oneOf([
        'client',
        'server'
    ]),
    /**
   * The pagination model of type [[GridPaginationModel]] which refers to current `page` and `pageSize`.
   */ paginationModel: $141bce2f2738cba8$var$_propTypes.default.shape({
        page: $141bce2f2738cba8$var$_propTypes.default.number.isRequired,
        pageSize: $141bce2f2738cba8$var$_propTypes.default.number.isRequired
    }),
    /**
   * Callback called before updating a row with new values in the row and cell editing.
   * @template R
   * @param {R} newRow Row object with the new values.
   * @param {R} oldRow Row object with the old values.
   * @param {{ rowId: GridRowId }} params Additional parameters.
   * @returns {Promise<R> | R} The final values to update the row.
   */ processRowUpdate: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * The milliseconds throttle delay for resizing the grid.
   * @default 60
   */ resizeThrottleMs: $141bce2f2738cba8$var$_propTypes.default.number,
    /**
   * Row region in pixels to render before/after the viewport
   * @default 150
   */ rowBufferPx: $141bce2f2738cba8$var$_propTypes.default.number,
    /**
   * Set the total number of rows, if it is different from the length of the value `rows` prop.
   * If some rows have children (for instance in the tree data), this number represents the amount of top level rows.
   * Only works with `paginationMode="server"`, ignored when `paginationMode="client"`.
   */ rowCount: $141bce2f2738cba8$var$_propTypes.default.number,
    /**
   * Sets the height in pixel of a row in the Data Grid.
   * @default 52
   */ rowHeight: $141bce2f2738cba8$var$_propTypes.default.number,
    /**
   * Controls the modes of the rows.
   */ rowModesModel: $141bce2f2738cba8$var$_propTypes.default.object,
    /**
   * Set of rows of type [[GridRowsProp]].
   * @default []
   */ rows: $141bce2f2738cba8$var$_propTypes.default.arrayOf($141bce2f2738cba8$var$_propTypes.default.object),
    /**
   * If `false`, the row selection mode is disabled.
   * @default true
   */ rowSelection: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * Sets the row selection model of the Data Grid.
   */ rowSelectionModel: $141bce2f2738cba8$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .shape({
        ids: $141bce2f2738cba8$var$_propTypes.default.instanceOf(Set).isRequired,
        type: $141bce2f2738cba8$var$_propTypes.default.oneOf([
            'exclude',
            'include'
        ]).isRequired
    }),
    /**
   * Sets the type of space between rows added by `getRowSpacing`.
   * @default "margin"
   */ rowSpacingType: $141bce2f2738cba8$var$_propTypes.default.oneOf([
        'border',
        'margin'
    ]),
    /**
   * If `true`, the Data Grid will auto span the cells over the rows having the same value.
   * @default false
   */ rowSpanning: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * Override the height/width of the Data Grid inner scrollbar.
   */ scrollbarSize: $141bce2f2738cba8$var$_propTypes.default.number,
    /**
   * If `true`, vertical borders will be displayed between cells.
   * @default false
   */ showCellVerticalBorder: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * If `true`, vertical borders will be displayed between column header items.
   * @default false
   */ showColumnVerticalBorder: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * If `true`, the toolbar is displayed.
   * @default false
   */ showToolbar: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * Overridable components props dynamically passed to the component at rendering.
   */ slotProps: $141bce2f2738cba8$var$_propTypes.default.object,
    /**
   * Overridable components.
   */ slots: $141bce2f2738cba8$var$_propTypes.default.object,
    /**
   * Sorting can be processed on the server or client-side.
   * Set it to 'client' if you would like to handle sorting on the client-side.
   * Set it to 'server' if you would like to handle sorting on the server-side.
   * @default "client"
   */ sortingMode: $141bce2f2738cba8$var$_propTypes.default.oneOf([
        'client',
        'server'
    ]),
    /**
   * The order of the sorting sequence.
   * @default ['asc', 'desc', null]
   */ sortingOrder: $141bce2f2738cba8$var$_propTypes.default.arrayOf($141bce2f2738cba8$var$_propTypes.default.oneOf([
        'asc',
        'desc'
    ])),
    /**
   * Set the sort model of the Data Grid.
   */ sortModel: $141bce2f2738cba8$var$_propTypes.default.arrayOf($141bce2f2738cba8$var$_propTypes.default.shape({
        field: $141bce2f2738cba8$var$_propTypes.default.string.isRequired,
        sort: $141bce2f2738cba8$var$_propTypes.default.oneOf([
            'asc',
            'desc'
        ])
    })),
    style: $141bce2f2738cba8$var$_propTypes.default.object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $141bce2f2738cba8$var$_propTypes.default.oneOfType([
        $141bce2f2738cba8$var$_propTypes.default.arrayOf($141bce2f2738cba8$var$_propTypes.default.oneOfType([
            $141bce2f2738cba8$var$_propTypes.default.func,
            $141bce2f2738cba8$var$_propTypes.default.object,
            $141bce2f2738cba8$var$_propTypes.default.bool
        ])),
        $141bce2f2738cba8$var$_propTypes.default.func,
        $141bce2f2738cba8$var$_propTypes.default.object
    ]),
    /**
   * If `true`, the Data Grid enables column virtualization when `getRowHeight` is set to `() => 'auto'`.
   * By default, column virtualization is disabled when dynamic row height is enabled to measure the row height correctly.
   * For datasets with a large number of columns, this can cause performance issues.
   * The downside of enabling this prop is that the row height will be estimated based the cells that are currently rendered, which can cause row height change when scrolling horizontally.
   * @default false
   */ virtualizeColumnsWithAutoRowHeight: $141bce2f2738cba8$var$_propTypes.default.bool
};


Object.keys($141bce2f2738cba8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3d7c0613ecc5fc3b$exports && $3d7c0613ecc5fc3b$exports[key] === $141bce2f2738cba8$exports[key]) return;
    Object.defineProperty($3d7c0613ecc5fc3b$exports, key, {
        enumerable: true,
        get: function() {
            return $141bce2f2738cba8$exports[key];
        }
    });
});


Object.keys($3d7c0613ecc5fc3b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($808944a671b11c1c$var$_exportNames, key)) return;
    if (key in $808944a671b11c1c$exports && $808944a671b11c1c$exports[key] === $3d7c0613ecc5fc3b$exports[key]) return;
    Object.defineProperty($808944a671b11c1c$exports, key, {
        enumerable: true,
        get: function() {
            return $3d7c0613ecc5fc3b$exports[key];
        }
    });
});

Object.keys($08eee520e810d520$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($808944a671b11c1c$var$_exportNames, key)) return;
    if (key in $808944a671b11c1c$exports && $808944a671b11c1c$exports[key] === $08eee520e810d520$exports[key]) return;
    Object.defineProperty($808944a671b11c1c$exports, key, {
        enumerable: true,
        get: function() {
            return $08eee520e810d520$exports[key];
        }
    });
});

Object.keys($553c2bbb14fa5500$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($808944a671b11c1c$var$_exportNames, key)) return;
    if (key in $808944a671b11c1c$exports && $808944a671b11c1c$exports[key] === $553c2bbb14fa5500$exports[key]) return;
    Object.defineProperty($808944a671b11c1c$exports, key, {
        enumerable: true,
        get: function() {
            return $553c2bbb14fa5500$exports[key];
        }
    });
});

Object.keys($0f96df060f8ddda5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($808944a671b11c1c$var$_exportNames, key)) return;
    if (key in $808944a671b11c1c$exports && $808944a671b11c1c$exports[key] === $0f96df060f8ddda5$exports[key]) return;
    Object.defineProperty($808944a671b11c1c$exports, key, {
        enumerable: true,
        get: function() {
            return $0f96df060f8ddda5$exports[key];
        }
    });
});

Object.keys($d8761d1e377450f5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($808944a671b11c1c$var$_exportNames, key)) return;
    if (key in $808944a671b11c1c$exports && $808944a671b11c1c$exports[key] === $d8761d1e377450f5$exports[key]) return;
    Object.defineProperty($808944a671b11c1c$exports, key, {
        enumerable: true,
        get: function() {
            return $d8761d1e377450f5$exports[key];
        }
    });
});

Object.keys($2f20061a3ca46e99$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($808944a671b11c1c$var$_exportNames, key)) return;
    if (key in $808944a671b11c1c$exports && $808944a671b11c1c$exports[key] === $2f20061a3ca46e99$exports[key]) return;
    Object.defineProperty($808944a671b11c1c$exports, key, {
        enumerable: true,
        get: function() {
            return $2f20061a3ca46e99$exports[key];
        }
    });
});
var $fcd7c58fcc834272$exports = {};
"use strict";
Object.defineProperty($fcd7c58fcc834272$exports, "__esModule", {
    value: true
});

Object.keys($a8b96ca779d42ed2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $fcd7c58fcc834272$exports && $fcd7c58fcc834272$exports[key] === $a8b96ca779d42ed2$exports[key]) return;
    Object.defineProperty($fcd7c58fcc834272$exports, key, {
        enumerable: true,
        get: function() {
            return $a8b96ca779d42ed2$exports[key];
        }
    });
});


Object.keys($fcd7c58fcc834272$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($808944a671b11c1c$var$_exportNames, key)) return;
    if (key in $808944a671b11c1c$exports && $808944a671b11c1c$exports[key] === $fcd7c58fcc834272$exports[key]) return;
    Object.defineProperty($808944a671b11c1c$exports, key, {
        enumerable: true,
        get: function() {
            return $fcd7c58fcc834272$exports[key];
        }
    });
});

Object.keys($a6506085715c5aff$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($808944a671b11c1c$var$_exportNames, key)) return;
    if (key in $808944a671b11c1c$exports && $808944a671b11c1c$exports[key] === $a6506085715c5aff$exports[key]) return;
    Object.defineProperty($808944a671b11c1c$exports, key, {
        enumerable: true,
        get: function() {
            return $a6506085715c5aff$exports[key];
        }
    });
});
var $2238346a4bfa131f$exports = {};
"use strict";
Object.defineProperty($2238346a4bfa131f$exports, "__esModule", {
    value: true
});
Object.defineProperty($2238346a4bfa131f$exports, "GridPortalWrapper", {
    enumerable: true,
    get: function() {
        return $2a727ae4835cc807$exports.GridPortalWrapper;
    }
});



Object.keys($2238346a4bfa131f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($808944a671b11c1c$var$_exportNames, key)) return;
    if (key in $808944a671b11c1c$exports && $808944a671b11c1c$exports[key] === $2238346a4bfa131f$exports[key]) return;
    Object.defineProperty($808944a671b11c1c$exports, key, {
        enumerable: true,
        get: function() {
            return $2238346a4bfa131f$exports[key];
        }
    });
});

var $3703708d962d2564$exports = {};
"use strict";
Object.defineProperty($3703708d962d2564$exports, "__esModule", {
    value: true
});
Object.defineProperty($3703708d962d2564$exports, "GRID_COLUMN_MENU_SLOTS", {
    enumerable: true,
    get: function() {
        return $3bffa0a776b5a050$exports.GRID_COLUMN_MENU_SLOTS;
    }
});
Object.defineProperty($3703708d962d2564$exports, "GRID_COLUMN_MENU_SLOT_PROPS", {
    enumerable: true,
    get: function() {
        return $3bffa0a776b5a050$exports.GRID_COLUMN_MENU_SLOT_PROPS;
    }
});
Object.defineProperty($3703708d962d2564$exports, "GridColumnMenu", {
    enumerable: true,
    get: function() {
        return $3bffa0a776b5a050$exports.GridColumnMenu;
    }
});






var $juRJQ = parcelRequire("juRJQ");
function $ea54e87a26854b65$export$ea9dd768aad7aea8(data) {
    return {
        ...data,
        check_price: function() {
            return data.check_price_log?.filter((c)=>c.component_id == null).pop();
        },
        getBaseComponentList () {
            return this.components_list?.filter((c)=>c.base_component);
        },
        getComponentListByType (type) {
            return this.components_list?.filter((c)=>c.component_type_key === type);
        },
        getComponentsMap () {
            const map = new Map();
            this.components_list?.forEach((c)=>{
                const list = map.get(c.component_type_key) ?? [];
                map.set(c.component_type_key, [
                    ...list,
                    c
                ]);
            });
            return map;
        },
        getBaseComponentsCostPrice (type) {
            if (type === "erp") return this.erp_base_cost_price ?? 0;
            return this.configured_base_cost_price ?? 0;
        },
        getBaseComponentsRev4Price (type) {
            if (type === "erp") return (this.erp_base_retail_price ?? 0) + Math.abs(this.erp_base_discount_value ?? 0);
            return (this.configured_base_retail_price ?? 0) - Math.abs(this.configured_base_discount_value ?? 0);
        },
        getBaseComponentsResellerPrice (type) {
            if (type === "erp") return this.erp_base_retail_price ?? 0;
            return this.configured_base_retail_price ?? 0;
        },
        getBaseDiscountValue (type) {
            if (type === "erp") return this.erp_base_discount_value ?? 0;
            return this.configured_base_discount_value ?? 0;
        },
        getBaseDiscountRate (type) {
            if (type === "erp") return this.erp_base_discount_rate ?? 0;
            return this.configured_base_discount_rate ?? 0;
        },
        getResellerRecommendedMargin (type) {
            if (type === "erp") return this.erp_reseller_recommended_margin ?? 0;
            return this.configured_reseller_recommended_margin ?? 0;
        },
        getResellerGrossGainLevel (type) {
            if (type === "erp") return this.erp_reseller_gross_gain_level ?? 0;
            return this.configured_reseller_gross_gain_level ?? 0;
        },
        getResellerGrossGainValue (type) {
            if (type === "erp") return this.erp_reseller_gross_gain_value ?? 0;
            return this.configured_reseller_gross_gain_value ?? 0;
        },
        getPricePVPWithoutVat (type) {
            if (type === "erp") return this.erp_price_pvp_without_vat ?? 0;
            return this.configured_price_pvp_without_vat ?? 0;
        },
        getPricePVPWithVat (type) {
            if (type === "erp") return this.erp_price_pvp_with_vat ?? 0;
            return this.configured_price_pvp_with_vat ?? 0;
        },
        getAvailableUnits (type) {
            if (type === "erp") return this.erp_available_units ?? 0;
            return this.available_units ?? 0;
        },
        getComponentTypesWithoutOptional () {
            return Array.from(new Set((this.components_list ?? []).filter((c)=>!c.optional).map((c)=>c.component_type_key)));
        },
        getComponentTypesWithOptional () {
            return Array.from(new Set((this.components_list ?? []).filter((c)=>c.optional).map((c)=>c.component_type_key)));
        },
        getComponentTypesWithProducts () {
            return Array.from(new Set((this.components_list ?? []).filter((c)=>c.product_reference).map((c)=>c.component_type_key)));
        }
    };
}


const $ff8d9cc2fa36bd73$var$ListItems = ({ data: data, filters: filters, setFilters: setFilters, totalPages: totalPages, totalResults: totalResults, loading: loading, setModalScreen: setModalScreen, onView: onView, onEdit: onEdit, onDelete: onDelete })=>{
    const openModal = (selectedItem)=>{
        setModalScreen({
            title: `Log/Control de Pre\xe7o da importa\xe7\xe3o - ${selectedItem.id}`,
            state: "view",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "p-4",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "text-lg font-semibold mb-2",
                        children: [
                            "Refer\xeancia: ",
                            selectedItem.id
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "mb-2",
                        children: [
                            "Descri\xe7\xe3o: ",
                            selectedItem.description
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "mb-2 text-sm text-gray-600 justify-items-center",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "p-2",
                                children: [
                                    "PVP:",
                                    " ",
                                    (0, $1cec967d8d56bb4d$export$63ad841d70774900)(selectedItem.check_price().price).toLocaleString("pt-PT", {
                                        style: "currency",
                                        currency: selectedItem.price.currency
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "p-2",
                                children: [
                                    "Valor esperado:",
                                    " ",
                                    (0, $1cec967d8d56bb4d$export$63ad841d70774900)(selectedItem.check_price().expected_price).toLocaleString("pt-PT", {
                                        style: "currency",
                                        currency: selectedItem.price.currency
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "p-2",
                                children: [
                                    "Pre\xe7o de custo:",
                                    " ",
                                    (0, $1cec967d8d56bb4d$export$63ad841d70774900)(selectedItem.check_price().cost_price).toLocaleString("pt-PT", {
                                        style: "currency",
                                        currency: selectedItem.price.currency
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "p-2",
                                children: [
                                    "Desconto na margem:",
                                    " ",
                                    (0, $1cec967d8d56bb4d$export$c37640da124effef)(selectedItem.check_price().reseller_discount),
                                    " %"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "p-2",
                                children: [
                                    "Margin recomendada:",
                                    " ",
                                    (0, $1cec967d8d56bb4d$export$c37640da124effef)(selectedItem.check_price().recommended_margin),
                                    " %"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "mb-2",
                        children: [
                            "Erro na valida\xe7\xe3o:",
                            " ",
                            selectedItem.check_price_mismatch ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "text-red-600 font-semibold ",
                                children: "Sim"
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "text-green-600 font-semibold ",
                                children: "N\xe3o"
                            })
                        ]
                    }),
                    selectedItem.check_price_log && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mt-4",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "text-md font-semibold mb-2",
                                children: "Logs/Price Checks:"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                children: selectedItem.check_price_log.map((log, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        className: `mb-1 ${log.has_price_mismatch ? "text-red-600" : "text-green-600"}`,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "font-mono",
                                            children: log.message
                                        })
                                    }, index))
                            })
                        ]
                    })
                ]
            }),
            onClose: ()=>setModalScreen(null)
        });
    };
    const [showListedFields, setShowListedFields] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>{
        const session = sessionStorage.getItem("compounds_listed_fields");
        if (session) return new Map(JSON.parse(session));
        return new Map([
            [
                "categoria",
                true
            ],
            [
                "id",
                true
            ],
            [
                "description",
                true
            ],
            [
                "configured_base_cost_price",
                true
            ],
            [
                "configured_base_reseller_price",
                true
            ],
            [
                "configured_base_discount_rate",
                true
            ],
            [
                "configured_base_discount_value",
                true
            ],
            [
                "configured_base_retail_price",
                true
            ],
            [
                "configured_reseller_recommended_margin",
                true
            ],
            [
                "configured_price_pvp_with_vat",
                true
            ],
            [
                "erp_base_cost_price",
                true
            ],
            [
                "erp_base_reseller_price",
                true
            ],
            [
                "erp_base_retail_price",
                true
            ],
            [
                "erp_price_pvp_with_vat",
                true
            ],
            [
                "actions",
                true
            ]
        ]);
    });
    // Save showListedFields to sessionStorage when it changes
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        sessionStorage.setItem("compounds_listed_fields", JSON.stringify(Array.from(showListedFields.entries())));
    }, [
        showListedFields
    ]);
    const renderStatus = (status)=>{
        switch(status.toUpperCase()){
            case "DRAFT":
                return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-800",
                    children: "Rascunho"
                });
            case "PENDING":
                return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800",
                    children: "Pendente"
                });
            case "PUBLISHED":
                return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800",
                    children: "Publicado"
                });
            case "HIDDEN":
                return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-800",
                    children: "Oculto"
                });
            case "ARCHIVED":
                return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800",
                    children: "Arquivado"
                });
            default:
                return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-800",
                    children: "Desconhecido"
                });
        }
    };
    const columns = [
        {
            field: "category_slug",
            headerName: "Categoria",
            valueGetter: (value, row)=>row.category_name || "Sem categoria",
            minWidth: 150,
            sortable: true
        },
        {
            field: "id",
            headerName: "Refer\xeancia",
            minWidth: 100,
            sortable: true
        },
        {
            field: "description",
            headerName: "Descri\xe7\xe3o",
            flex: 2,
            minWidth: 200,
            sortable: true
        },
        {
            field: "tags",
            headerName: "Tags",
            minWidth: 120,
            sortable: false,
            renderCell: (params)=>{
                const tags = params.row.tags ?? [];
                if (tags.length === 0) return null;
                return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "whitespace-pre-line leading-4 py-1",
                    children: tags.join("\n")
                });
            }
        },
        {
            field: "configured_base_cost_price",
            headerName: "Pre\xe7o Custo (Base)",
            minWidth: 70,
            valueGetter: (_, row)=>row.getBaseComponentsCostPrice("configured")?.toLocaleString("pt-PT", {
                    style: "currency",
                    currency: "EUR"
                }),
            cellClassName: "font-mono force-text-right",
            sortable: false
        },
        {
            field: "configured_base_retail_price",
            headerName: "Pre\xe7o Rev4 (Base)",
            minWidth: 70,
            valueGetter: (value, row)=>row.getBaseComponentsResellerPrice("configured")?.toLocaleString("pt-PT", {
                    style: "currency",
                    currency: "EUR"
                }),
            cellClassName: "font-mono force-text-right",
            sortable: true
        },
        {
            field: "configured_base_discount_rate",
            headerName: "% Margem",
            minWidth: 70,
            valueGetter: (_, row)=>(0, $1cec967d8d56bb4d$export$c37640da124effef)(row.getBaseDiscountRate("configured") ?? 0) + " %",
            cellClassName: "font-mono force-text-right",
            sortable: true
        },
        {
            field: "configured_base_discount_value",
            headerName: "Redu\xe7\xe3o Revenda",
            minWidth: 70,
            valueGetter: (_, row)=>row.getBaseDiscountValue("configured")?.toLocaleString("pt-PT", {
                    style: "currency",
                    currency: "EUR"
                }),
            cellClassName: "font-mono force-text-right",
            sortable: false
        },
        {
            field: "configured_base_reseller_price",
            headerName: "Pre\xe7o Loja",
            minWidth: 70,
            valueGetter: (_, row)=>row.getBaseComponentsRev4Price("configured")?.toLocaleString("pt-PT", {
                    style: "currency",
                    currency: "EUR"
                }),
            cellClassName: "font-mono force-text-right",
            sortable: false
        },
        {
            field: "configured_reseller_recommended_margin",
            headerName: "Margem Recomendada",
            minWidth: 70,
            valueGetter: (value, row)=>(0, $1cec967d8d56bb4d$export$c37640da124effef)(row.getResellerRecommendedMargin("configured") ?? 0) + " %",
            cellClassName: "font-mono force-text-right",
            sortable: true
        },
        {
            field: "configured_price_pvp_with_vat",
            headerName: "PVP",
            minWidth: 70,
            valueGetter: (value, row)=>row.getPricePVPWithVat("configured")?.toLocaleString("pt-PT", {
                    style: "currency",
                    currency: "EUR"
                }),
            cellClassName: "font-mono force-text-right",
            sortable: true
        },
        {
            field: "erp_base_cost_price",
            headerName: "ERP - Pre\xe7o Custo (Base)",
            minWidth: 70,
            valueGetter: (_, row)=>row.getBaseComponentsCostPrice("erp")?.toLocaleString("pt-PT", {
                    style: "currency",
                    currency: "EUR"
                }),
            cellClassName: "font-mono force-text-right erp-data",
            sortable: false
        },
        {
            field: "erp_base_reseller_price",
            headerName: "ERP - Pre\xe7o Rev4 (Base)",
            minWidth: 70,
            valueGetter: (_, row)=>row.getBaseComponentsRev4Price("erp")?.toLocaleString("pt-PT", {
                    style: "currency",
                    currency: "EUR"
                }),
            cellClassName: "font-mono force-text-right erp-data",
            sortable: false
        },
        {
            field: "erp_base_retail_price",
            headerName: "ERP - Pre\xe7o Loja",
            minWidth: 70,
            valueGetter: (value, row)=>row.getBaseComponentsResellerPrice("erp")?.toLocaleString("pt-PT", {
                    style: "currency",
                    currency: "EUR"
                }),
            cellClassName: "font-mono force-text-right erp-data",
            sortable: true
        },
        {
            field: "erp_price_pvp_with_vat",
            headerName: "ERP - PVP",
            minWidth: 70,
            valueGetter: (value, row)=>row.getPricePVPWithVat("erp")?.toLocaleString("pt-PT", {
                    style: "currency",
                    currency: "EUR"
                }),
            cellClassName: "font-mono force-text-right erp-data",
            sortable: true
        },
        {
            field: "difference_cost_price",
            headerName: "Dif Custo",
            minWidth: 80,
            valueGetter: (_, row)=>{
                const configuredCost = row.getBaseComponentsCostPrice("configured") ?? 0;
                const erpCost = row.getBaseComponentsCostPrice("erp") ?? 0;
                if (erpCost === 0) return "N/A";
                const difference = configuredCost - erpCost;
                return `${difference.toLocaleString("pt-PT", {
                    style: "currency",
                    currency: "EUR"
                })}`;
            },
            cellClassName: "font-mono force-text-right analytic-data",
            sortable: false
        },
        {
            field: "difference",
            headerName: "Dif PVP",
            minWidth: 80,
            valueGetter: (_, row)=>{
                const configuredPVP = row.getPricePVPWithVat("configured") ?? 0;
                const erpPVP = row.getPricePVPWithVat("erp") ?? 0;
                if (erpPVP === 0) return "N/A";
                const difference = configuredPVP - erpPVP;
                return `${difference.toLocaleString("pt-PT", {
                    style: "currency",
                    currency: "EUR"
                })}`;
            },
            cellClassName: "font-mono force-text-right analytic-data",
            sortable: false
        },
        {
            field: "status",
            headerName: "Estado",
            minWidth: 100,
            renderCell: (params)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex items-center gap-1",
                    children: [
                        renderStatus(params.value),
                        params.row.in_campaign && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            "data-testid": "compound-in-campaign",
                            title: "Em campanha ativa ou agendada",
                            className: "px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-indigo-100 text-indigo-800",
                            children: "Campanha"
                        })
                    ]
                }),
            sortable: true
        },
        {
            field: "actions",
            headerName: "",
            width: 150,
            disableColumnMenu: true,
            sortable: false,
            renderCell: (params)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        params.row.check_price_mismatch && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$a6c7ac8248d6e38a), {
                            to: `#`,
                            "aria-label": `Ver ${params.row.name} Logs/Price Checks`,
                            onClick: (e)=>openModal(params.row),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "icon is-medium has-text-grey-light",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9a9bbf84fd0f8247$export$2e2bcd8739ae039), {})
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$a6c7ac8248d6e38a), {
                            to: `/pc/${encodeURIComponent(params.row.id)}`,
                            "aria-label": `Preview ${params.row.name}`,
                            onClick: (e)=>onView(params.row.id, e),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "icon is-medium has-text-info",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {})
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$a6c7ac8248d6e38a), {
                            to: `/catalog/compound/${encodeURIComponent(params.row.id)}`,
                            "aria-label": `Editar ${params.row.name}`,
                            onClick: (e)=>onEdit(params.row.id, e),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "icon is-medium has-text-primary",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $737c279b45d43939$export$2e2bcd8739ae039), {})
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$a6c7ac8248d6e38a), {
                            to: `#`,
                            "aria-label": `Excluir ${params.row.name}`,
                            onClick: (e)=>onDelete(params.row.id, e),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "icon is-medium has-text-danger",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1eaa8953d6f809f8$export$2e2bcd8739ae039), {})
                            })
                        })
                    ]
                })
        }
    ];
    const handlePerPageChange = (perPage)=>{
        setFilters({
            ...filters,
            per_page: perPage,
            page: 1
        });
    };
    const handlePageChange = (newPage)=>{
        setFilters({
            ...filters,
            page: newPage
        });
    };
    const handleFilterValueChange = (field)=>{
        return (value)=>setFilters({
                ...filters,
                [field]: value,
                page: 1
            });
    };
    const handlePaginationChange = (model)=>{
        if (model.pageSize !== filters.per_page) handlePerPageChange(model.pageSize);
        if (model.page + 1 !== filters.page) handlePageChange(model.page + 1);
    };
    const paginationState = {
        paginationMode: "server",
        paginationModel: {
            page: (filters.page ?? 1) - 1,
            pageSize: filters.per_page || 10
        },
        rowCount: totalResults || -1,
        enabled: true,
        meta: {
            hasNextPage: true
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "manage-page",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($juRJQ))), {
            sx: {
                width: "100%",
                overflow: "hidden"
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $808944a671b11c1c$exports.DataGrid), {
                rows: data.map((0, $ea54e87a26854b65$export$ea9dd768aad7aea8)),
                columns: columns,
                loading: loading,
                density: "standard",
                getRowHeight: ()=>"auto",
                initialState: {
                    pagination: paginationState
                },
                rowCount: totalResults || 0,
                paginationMode: "server",
                sortingMode: "server",
                disableColumnFilter: true,
                onPaginationModelChange: handlePaginationChange,
                onSortModelChange: (model)=>{
                    if (model.length > 0) {
                        const sortModel = model[0];
                        setFilters({
                            ...filters,
                            ["sort_direction"]: sortModel.sort || "asc",
                            ["sort_by"]: sortModel.field,
                            page: 1
                        });
                    }
                },
                columnVisibilityModel: Object.fromEntries(showListedFields),
                onColumnVisibilityModelChange: (newModel)=>{
                    const newMap = new Map(Object.entries(newModel));
                    setShowListedFields(newMap);
                },
                hideFooterSelectedRowCount: true,
                pageSizeOptions: [
                    10,
                    25,
                    50,
                    100
                ],
                rowSelection: false,
                localeText: {
                    columnsManagementSearchTitle: "Procurar",
                    columnsManagementNoColumns: "Sem colunas",
                    columnsManagementShowHideAllText: "Mostrar/Ocultar Todas",
                    columnsManagementReset: "Repor",
                    columnsManagementDeleteIconLabel: "Limpar",
                    columnMenuLabel: "Menu",
                    columnMenuAriaLabel: (columnName)=>`Menu da coluna ${columnName}`,
                    columnMenuShowColumns: "Mostrar colunas",
                    columnMenuManageColumns: "Gerir colunas",
                    columnMenuFilter: "Filtrar",
                    columnMenuHideColumn: "Ocultar coluna",
                    columnMenuUnsort: "Remover ordena\xe7\xe3o",
                    columnMenuSortAsc: "Ordenar por ASC",
                    columnMenuSortDesc: "Ordenar por DESC",
                    columnMenuManagePivot: "Gerir pivot",
                    paginationRowsPerPage: "Linhas por p\xe1gina:",
                    paginationDisplayedRows: ({ from: from, to: to, count: count, estimated: estimated })=>{
                        if (!estimated) return `${from}\u{2013}${to} de ${count !== -1 ? count : `mais de ${to}`}`;
                        const estimatedLabel = estimated && estimated > to ? `cerca de ${estimated}` : `mais de ${to}`;
                        return `${from}\u{2013}${to} de ${count !== -1 ? count : estimatedLabel}`;
                    }
                },
                getRowId: (row)=>row.id
            })
        })
    });
};
var $ff8d9cc2fa36bd73$export$2e2bcd8739ae039 = $ff8d9cc2fa36bd73$var$ListItems;



/**
 * Componente para realizar o upload de arquivos Excel para o backend.
 */ const $98525b551a56d1de$var$ImportExcelPage = ()=>{
    const navigate = (0, $585f8bce88e531c1$export$9770f232ac06a008)();
    const location = (0, $585f8bce88e531c1$export$45d76561a5302f2b)();
    const { userSettings: userSettings, setUserSettings: setUserSettings, systemError: systemError, setSystemError: setSystemError, loading: loading, setLoading: setLoading, error: error, setError: setError, success: success, setSuccess: setSuccess, modalScreen: modalScreen, setModalScreen: setModalScreen, page: page, setPage: setPage } = (0, $a55f2a94cd420149$export$c50e37a2f0a2b064)();
    const [file, setFile] = (0, $acw62.useState)(null);
    const [uploading, setUploading] = (0, $acw62.useState)(false);
    const [importedData, setImportedData] = (0, $acw62.useState)([]);
    const [filters, setFilters] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        search: "",
        page: 1,
        per_page: 100,
        sort_by: "name",
        sort_direction: "asc",
        stock_status: ""
    });
    const handleFileChange = (event)=>{
        setError(null); // Limpa qualquer erro anterior
        setFile(null);
        const selectedFile = event.target.files?.[0];
        if (selectedFile) {
            if (selectedFile.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || // .xlsx
            selectedFile.type === "application/vnd.ms-excel") setFile(selectedFile);
            else {
                setFile(null);
                setError("Tipo de arquivo inv\xe1lido. Por favor, selecione um arquivo .xlsx ou .xls.");
            }
        }
    };
    const handleUpload = async ()=>{
        if (!file) {
            setError("Por favor, selecione um arquivo para importar.");
            return;
        }
        setUploading(true);
        setError(null);
        const formData = new FormData();
        formData.append("file", file);
        try {
            const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).postForm((0, $cd93687958c8007e$export$bfe19bc25132bb7c).IMPORT, formData);
            if (response.status === 201 || response.status === 200) {
                setSuccess("Arquivo importado com sucesso!");
                setFile(null);
                setImportedData(response.data);
            } else {
                const errorMessage = await response.data;
                throw new Error(`Erro ao importar arquivo: ${response.status} - ${errorMessage}`);
            }
        } catch (err) {
            setError(err.message || "Ocorreu um erro ao enviar o arquivo.");
        } finally{
            setUploading(false);
            setFile(null);
        }
    };
    const handleViewItem = (id, e)=>{
        history.replaceState({
            fromImport: true,
            data: importedData
        }, "Import Excel Page");
    };
    const handleEditItem = (id, e)=>{
        history.replaceState({
            fromImport: true,
            data: importedData
        }, "Import Excel Page");
    };
    const handleDelete = async (id, e)=>{
        e?.preventDefault();
        if (window.confirm("Voc\xea tem certeza que deseja excluir este item?")) try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).delete(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).COMPOUNDS}/${encodeURIComponent(id)}`);
            setImportedData((prevData)=>prevData.filter((dataItem)=>dataItem.id !== id));
            setSuccess("Item exclu\xeddo com sucesso.");
        } catch (err) {
            setError(err.message || "Erro ao excluir o item.");
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (history.state?.fromImport) {
            setImportedData(history.state?.data);
            history.replaceState({}, "Import Excel Page");
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: importedData.length == 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "min-h-screen p-4 flex items-center justify-center",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bg-gray-800 rounded-xl shadow-2xl p-8 w-full max-w-md space-y-6",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "text-2xl font-bold text-white flex items-center gap-3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ce43cf1e11212652$export$2e2bcd8739ae039), {
                                className: "w-6 h-6 text-blue-400"
                            }),
                            "Importar PCs do Excel/CSV"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "space-y-4",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "file has-name",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                className: "file-label",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        className: "file-input",
                                        type: "file",
                                        name: "file",
                                        onChange: handleFileChange,
                                        accept: ".xlsx,.xls",
                                        disabled: uploading
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "file-cta",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "file-icon",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $53d93132fb4ab0c7$export$2e2bcd8739ae039), {
                                                    className: "w-4 h-4"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "file-label",
                                                children: "Escolher Arquivo\u2026"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "file-name",
                                        children: file ? file.name : "Nenhum arquivo selecionado"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48783e82a8986d7$exports.Button), {
                        onClick: handleUpload,
                        disabled: uploading,
                        className: `w-full ${uploading ? "is-loading" : "bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-md transition-colors duration-200"}`,
                        children: uploading ? "Enviando..." : "Importar"
                    })
                ]
            })
        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "container mx-auto p-4",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "p-4 overflow-auto",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "text-2xl font-bold mb-4",
                        children: "Itens Importados"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ff8d9cc2fa36bd73$export$2e2bcd8739ae039), {
                        data: importedData,
                        onDelete: handleDelete,
                        onView: handleViewItem,
                        onEdit: handleEditItem,
                        setModalScreen: setModalScreen,
                        totalResults: importedData.length,
                        totalPages: 1,
                        loading: false,
                        filters: filters,
                        setFilters: setFilters
                    })
                ]
            })
        })
    });
};
var $98525b551a56d1de$export$2e2bcd8739ae039 = $98525b551a56d1de$var$ImportExcelPage;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e52b122f04c04d7d$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M12 16v-4",
            key: "1dtifu"
        }
    ],
    [
        "path",
        {
            d: "M12 8h.01",
            key: "e9boi3"
        }
    ]
];
const $e52b122f04c04d7d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("info", $e52b122f04c04d7d$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c52b562f10363bcd$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "7",
            height: "7",
            x: "3",
            y: "3",
            rx: "1",
            key: "1g98yp"
        }
    ],
    [
        "rect",
        {
            width: "7",
            height: "7",
            x: "14",
            y: "3",
            rx: "1",
            key: "6d4xhi"
        }
    ],
    [
        "rect",
        {
            width: "7",
            height: "7",
            x: "14",
            y: "14",
            rx: "1",
            key: "nxv5o0"
        }
    ],
    [
        "rect",
        {
            width: "7",
            height: "7",
            x: "3",
            y: "14",
            rx: "1",
            key: "1bb6yr"
        }
    ]
];
const $c52b562f10363bcd$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("layout-grid", $c52b562f10363bcd$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $421821514841703f$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "7",
            height: "7",
            x: "3",
            y: "3",
            rx: "1",
            key: "1g98yp"
        }
    ],
    [
        "rect",
        {
            width: "7",
            height: "7",
            x: "3",
            y: "14",
            rx: "1",
            key: "1bb6yr"
        }
    ],
    [
        "path",
        {
            d: "M14 4h7",
            key: "3xa0d5"
        }
    ],
    [
        "path",
        {
            d: "M14 9h7",
            key: "1icrd9"
        }
    ],
    [
        "path",
        {
            d: "M14 15h7",
            key: "1mj8o2"
        }
    ],
    [
        "path",
        {
            d: "M14 20h7",
            key: "11slyb"
        }
    ]
];
const $421821514841703f$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("layout-list", $421821514841703f$export$3efd853dbb351e94);



var $5QQ7K = parcelRequire("5QQ7K");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



const $e7a78ebaa7ce2a4a$export$d4e22f05f73ea56b = (setIsLoading, setError)=>{
    const { setProfile: setProfile } = (0, $b622ef53e38024e7$export$1d39dc5b47e56ff0)();
    const login = async (loginRequest)=>{
        setIsLoading(true);
        setError(null);
        try {
            const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).post((0, $cd93687958c8007e$export$bfe19bc25132bb7c).LOGIN, loginRequest);
            const data = await response.data;
            if (!data) throw new Error("Login failed: No data received");
            setProfile(data);
            return data;
        } catch (err) {
            setError(err || new Error("An error occurred during login"));
        } finally{
            setIsLoading(false);
        }
    };
    const logout = async ()=>{
        setIsLoading(true);
        setError(null);
        try {
            // @ts-ignore
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).clearToken();
            setProfile(null);
        } catch (err) {
            setError(err || new Error("An error occurred during logout"));
        } finally{
            setIsLoading(false);
        }
    };
    return {
        login: login,
        logout: logout
    };
};



/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $29f3c9e10e93d9ba$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m20 13.7-2.1-2.1a2 2 0 0 0-2.8 0L9.7 17",
            key: "q6ojf0"
        }
    ],
    [
        "path",
        {
            d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
            key: "k3hazp"
        }
    ],
    [
        "circle",
        {
            cx: "10",
            cy: "8",
            r: "2",
            key: "2qkj4p"
        }
    ]
];
const $29f3c9e10e93d9ba$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("book-image", $29f3c9e10e93d9ba$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $adb270212de20834$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
            key: "1rqfz7"
        }
    ],
    [
        "path",
        {
            d: "M14 2v4a2 2 0 0 0 2 2h4",
            key: "tnqrlb"
        }
    ],
    [
        "path",
        {
            d: "M10 9H8",
            key: "b1mrlr"
        }
    ],
    [
        "path",
        {
            d: "M16 13H8",
            key: "t4e002"
        }
    ],
    [
        "path",
        {
            d: "M16 17H8",
            key: "z1uh3a"
        }
    ]
];
const $adb270212de20834$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("file-text", $adb270212de20834$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $9b51f4920eac1ba0$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20",
            key: "13o1zl"
        }
    ],
    [
        "path",
        {
            d: "M2 12h20",
            key: "9i4pu4"
        }
    ]
];
const $9b51f4920eac1ba0$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("globe", $9b51f4920eac1ba0$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $0d249cdd9355ee92$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m9 11-6 6v3h9l3-3",
            key: "1a3l36"
        }
    ],
    [
        "path",
        {
            d: "m22 12-4.6 4.6a2 2 0 0 1-2.8 0l-5.2-5.2a2 2 0 0 1 0-2.8L14 4",
            key: "14a9rk"
        }
    ]
];
const $0d249cdd9355ee92$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("highlighter", $0d249cdd9355ee92$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $40c424bab0bc0a95$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z",
            key: "zw3jo"
        }
    ],
    [
        "path",
        {
            d: "M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12",
            key: "1wduqc"
        }
    ],
    [
        "path",
        {
            d: "M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17",
            key: "kqbvx6"
        }
    ]
];
const $40c424bab0bc0a95$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("layers", $40c424bab0bc0a95$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $51e4773a12945ca1$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10 12h11",
            key: "6m4ad9"
        }
    ],
    [
        "path",
        {
            d: "M10 18h11",
            key: "11hvi2"
        }
    ],
    [
        "path",
        {
            d: "M10 6h11",
            key: "c7qv1k"
        }
    ],
    [
        "path",
        {
            d: "M4 10h2",
            key: "16xx2s"
        }
    ],
    [
        "path",
        {
            d: "M4 6h1v4",
            key: "cnovpq"
        }
    ],
    [
        "path",
        {
            d: "M6 18H4c0-1 2-2 2-3s-1-1.5-2-1",
            key: "m9a95d"
        }
    ]
];
const $51e4773a12945ca1$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("list-ordered", $51e4773a12945ca1$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c9173589173e62cb$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4",
            key: "u53s6r"
        }
    ],
    [
        "polyline",
        {
            points: "10 17 15 12 10 7",
            key: "1ail0h"
        }
    ],
    [
        "line",
        {
            x1: "15",
            x2: "3",
            y1: "12",
            y2: "12",
            key: "v6grx8"
        }
    ]
];
const $c9173589173e62cb$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("log-in", $c9173589173e62cb$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5473793717b51056$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4",
            key: "1uf3rs"
        }
    ],
    [
        "polyline",
        {
            points: "16 17 21 12 16 7",
            key: "1gabdz"
        }
    ],
    [
        "line",
        {
            x1: "21",
            x2: "9",
            y1: "12",
            y2: "12",
            key: "1uyos4"
        }
    ]
];
const $5473793717b51056$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("log-out", $5473793717b51056$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $198f0fcb2df6a37f$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z",
            key: "1lielz"
        }
    ]
];
const $198f0fcb2df6a37f$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("message-square", $198f0fcb2df6a37f$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e3a8f0b406639961$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M19 15v-2a2 2 0 1 0-4 0v2",
            key: "h3d1vz"
        }
    ],
    [
        "path",
        {
            d: "M9 17H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v3.5",
            key: "xsnnhn"
        }
    ],
    [
        "rect",
        {
            x: "13",
            y: "15",
            width: "8",
            height: "5",
            rx: "1",
            key: "1ccwuk"
        }
    ]
];
const $e3a8f0b406639961$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("message-square-lock", $e3a8f0b406639961$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $df8ae1eff5d02c3d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
            key: "e7tb2h"
        }
    ],
    [
        "path",
        {
            d: "m7.5 4.27 9 5.15",
            key: "1c824w"
        }
    ],
    [
        "polyline",
        {
            points: "3.29 7 12 12 20.71 7",
            key: "ousv84"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "22",
            y2: "12",
            key: "a4e8g8"
        }
    ],
    [
        "circle",
        {
            cx: "18.5",
            cy: "15.5",
            r: "2.5",
            key: "b5zd12"
        }
    ],
    [
        "path",
        {
            d: "M20.27 17.27 22 19",
            key: "1l4muz"
        }
    ]
];
const $df8ae1eff5d02c3d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("package-search", $df8ae1eff5d02c3d$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $7b97e024910b40ff$export$3efd853dbb351e94 = [
    [
        "line",
        {
            x1: "19",
            x2: "5",
            y1: "5",
            y2: "19",
            key: "1x9vlm"
        }
    ],
    [
        "circle",
        {
            cx: "6.5",
            cy: "6.5",
            r: "2.5",
            key: "4mh3h7"
        }
    ],
    [
        "circle",
        {
            cx: "17.5",
            cy: "17.5",
            r: "2.5",
            key: "1mdrzq"
        }
    ]
];
const $7b97e024910b40ff$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("percent", $7b97e024910b40ff$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $b42daf8f5fabfd7f$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z",
            key: "hou9p0"
        }
    ],
    [
        "path",
        {
            d: "M3 6h18",
            key: "d0wm0j"
        }
    ],
    [
        "path",
        {
            d: "M16 10a4 4 0 0 1-8 0",
            key: "1ltviw"
        }
    ]
];
const $b42daf8f5fabfd7f$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("shopping-bag", $b42daf8f5fabfd7f$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $04b006b04b8c21eb$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z",
            key: "r04s7s"
        }
    ]
];
const $04b006b04b8c21eb$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("star", $04b006b04b8c21eb$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $94451a36ffcee03b$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "10",
            cy: "7",
            r: "4",
            key: "e45bow"
        }
    ],
    [
        "path",
        {
            d: "M10.3 15H7a4 4 0 0 0-4 4v2",
            key: "3bnktk"
        }
    ],
    [
        "path",
        {
            d: "M15 15.5V14a2 2 0 0 1 4 0v1.5",
            key: "12ym5i"
        }
    ],
    [
        "rect",
        {
            width: "8",
            height: "5",
            x: "13",
            y: "16",
            rx: ".899",
            key: "4p176n"
        }
    ]
];
const $94451a36ffcee03b$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("user-lock", $94451a36ffcee03b$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5cf2930c043bd2d0$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m14.305 19.53.923-.382",
            key: "3m78fa"
        }
    ],
    [
        "path",
        {
            d: "m15.228 16.852-.923-.383",
            key: "npixar"
        }
    ],
    [
        "path",
        {
            d: "m16.852 15.228-.383-.923",
            key: "5xggr7"
        }
    ],
    [
        "path",
        {
            d: "m16.852 20.772-.383.924",
            key: "dpfhf9"
        }
    ],
    [
        "path",
        {
            d: "m19.148 15.228.383-.923",
            key: "1reyyz"
        }
    ],
    [
        "path",
        {
            d: "m19.53 21.696-.382-.924",
            key: "1goivc"
        }
    ],
    [
        "path",
        {
            d: "M2 21a8 8 0 0 1 10.434-7.62",
            key: "1yezr2"
        }
    ],
    [
        "path",
        {
            d: "m20.772 16.852.924-.383",
            key: "htqkph"
        }
    ],
    [
        "path",
        {
            d: "m20.772 19.148.924.383",
            key: "9w9pjp"
        }
    ],
    [
        "circle",
        {
            cx: "10",
            cy: "8",
            r: "5",
            key: "o932ke"
        }
    ],
    [
        "circle",
        {
            cx: "18",
            cy: "18",
            r: "3",
            key: "1xkwt0"
        }
    ]
];
const $5cf2930c043bd2d0$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("user-round-cog", $5cf2930c043bd2d0$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $26e74a24e9f2bb34$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M18 21a8 8 0 0 0-16 0",
            key: "3ypg7q"
        }
    ],
    [
        "circle",
        {
            cx: "10",
            cy: "8",
            r: "5",
            key: "o932ke"
        }
    ],
    [
        "path",
        {
            d: "M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3",
            key: "10s06x"
        }
    ]
];
const $26e74a24e9f2bb34$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("users-round", $26e74a24e9f2bb34$export$3efd853dbb351e94);


const $9bf0c5c273706e12$export$3d423776c18897a = ({ isAuthenticated: isAuthenticated, userSettings: userSettings })=>{
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const [loginRequest, setLoginRequest] = (0, $acw62.useState)({
        username: "",
        password: ""
    });
    const [menuState, setMenuState] = (0, $acw62.useState)(false);
    const { login: login } = (0, $e7a78ebaa7ce2a4a$export$d4e22f05f73ea56b)(setIsLoading, setError);
    const [showLoginWidget, setShowLoginWidget] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        setShowLoginWidget(!isAuthenticated);
    }, [
        isAuthenticated
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                id: "login-button",
                children: isAuthenticated ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "dropdown is-active is-right",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "dropdown-trigger",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                className: "button flex items-center is-primary has-text-black",
                                "aria-haspopup": "true",
                                "aria-controls": "dropdown-menu",
                                onClick: ()=>setMenuState(!menuState),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: "Menu"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "icon is-small",
                                        children: menuState ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b397e876e35a9277$export$2e2bcd8739ae039), {
                                            className: "w-4 h-4"
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                            className: "w-4 h-4"
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: `dropdown-menu ${!menuState ? "is-hidden" : ""}`,
                            id: "dropdown-menu",
                            role: "menu",
                            onClick: ()=>setMenuState(!menuState),
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "dropdown-content",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $585f8bce88e531c1$export$a6c7ac8248d6e38a), {
                                        to: "/",
                                        className: "dropdown-item flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "icon is-small mr-2",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $df8ae1eff5d02c3d$export$2e2bcd8739ae039), {
                                                    className: "w-5 h-5",
                                                    "aria-hidden": "true"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: "Catalog"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("hr", {
                                        className: "dropdown-divider"
                                    }),
                                    userSettings?.isOperatorUser() && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $585f8bce88e531c1$export$a6c7ac8248d6e38a), {
                                        to: "/offers",
                                        className: "dropdown-item flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "icon is-small mr-2 y-2",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $51e4773a12945ca1$export$2e2bcd8739ae039), {
                                                    className: "w-5 h-5",
                                                    "aria-hidden": "true"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: "Propostas"
                                            })
                                        ]
                                    }),
                                    (userSettings?.isAdmin() || userSettings?.isMainAccount() || userSettings?.isReseller() || userSettings?.isCommercial()) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $585f8bce88e531c1$export$a6c7ac8248d6e38a), {
                                        to: "/campaigns",
                                        className: "dropdown-item flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "icon is-small mr-2 y-2",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7b97e024910b40ff$export$2e2bcd8739ae039), {
                                                    className: "w-5 h-5",
                                                    "aria-hidden": "true"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: "Campanhas"
                                            })
                                        ]
                                    }),
                                    (userSettings?.isAdmin() || userSettings?.isMainAccount()) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $585f8bce88e531c1$export$a6c7ac8248d6e38a), {
                                        to: "/minisite",
                                        className: "dropdown-item flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "icon is-small mr-2 y-2",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $29f3c9e10e93d9ba$export$2e2bcd8739ae039), {
                                                    className: "w-5 h-5",
                                                    "aria-hidden": "true"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: "Microsite"
                                            })
                                        ]
                                    }),
                                    userSettings?.isOperatorUser() && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $585f8bce88e531c1$export$a6c7ac8248d6e38a), {
                                        to: "/settings",
                                        className: "dropdown-item flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "icon is-small mr-2 y-2",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5cf2930c043bd2d0$export$2e2bcd8739ae039), {
                                                    className: "w-5 h-5",
                                                    "aria-hidden": "true"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: "Configura\xe7\xf5es"
                                            })
                                        ]
                                    }),
                                    userSettings?.isOperatorUser() && /*#__PURE__*/ (0, $ayMG0.jsx)("hr", {
                                        className: "dropdown-divider"
                                    }),
                                    (userSettings?.isCommercial() || userSettings?.isAdmin()) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $585f8bce88e531c1$export$a6c7ac8248d6e38a), {
                                        to: "/orders",
                                        className: "dropdown-item flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "icon is-small mr-2 y-2",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $51e4773a12945ca1$export$2e2bcd8739ae039), {
                                                    className: "w-5 h-5",
                                                    "aria-hidden": "true"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: "Orders"
                                            })
                                        ]
                                    }),
                                    (userSettings?.isMainAccount() || userSettings?.isAdmin() || userSettings?.isCommercial()) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $585f8bce88e531c1$export$a6c7ac8248d6e38a), {
                                        to: "/users",
                                        className: "dropdown-item flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "icon is-small mr-2 y-2",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $26e74a24e9f2bb34$export$2e2bcd8739ae039), {
                                                    className: "w-5 h-5",
                                                    "aria-hidden": "true"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: "Users"
                                            })
                                        ]
                                    }),
                                    (userSettings?.isCommercial() || userSettings?.isAdmin()) && (userSettings?.chat_settings?.url ?? false) && (userSettings?.chat_settings?.token ?? false) && (userSettings?.chat_settings?.tenant_subdomain ?? false) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $585f8bce88e531c1$export$a6c7ac8248d6e38a), {
                                        to: userSettings?.chat_settings?.url + "/agent-dashboard?tenant_subdomain=" + userSettings?.chat_settings?.tenant_subdomain + "&token=" + userSettings?.chat_settings?.token,
                                        target: "_blank",
                                        className: "dropdown-item flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "icon is-small mr-2 y-2",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $198f0fcb2df6a37f$export$2e2bcd8739ae039), {
                                                    className: "w-5 h-5",
                                                    "aria-hidden": "true"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: "Chat"
                                            })
                                        ]
                                    }),
                                    userSettings?.isAdmin() && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $585f8bce88e531c1$export$a6c7ac8248d6e38a), {
                                        to: "/catalog",
                                        className: "dropdown-item flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "icon is-small mr-2 y-2",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $29f3c9e10e93d9ba$export$2e2bcd8739ae039), {
                                                    className: "w-5 h-5",
                                                    "aria-hidden": "true"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: "Catalog"
                                            })
                                        ]
                                    }),
                                    userSettings?.isAdmin() && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $585f8bce88e531c1$export$a6c7ac8248d6e38a), {
                                        to: "/highlights",
                                        className: "dropdown-item flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "icon is-small mr-2 y-2",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d249cdd9355ee92$export$2e2bcd8739ae039), {
                                                    className: "w-5 h-5",
                                                    "aria-hidden": "true"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: "Not\xedcias / Destaques"
                                            })
                                        ]
                                    }),
                                    userSettings?.isAdmin() && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $585f8bce88e531c1$export$a6c7ac8248d6e38a), {
                                        to: "/categories",
                                        className: "dropdown-item flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "icon is-small mr-2 y-2",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $40c424bab0bc0a95$export$2e2bcd8739ae039), {
                                                    className: "w-5 h-5",
                                                    "aria-hidden": "true"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: "Categorias"
                                            })
                                        ]
                                    }),
                                    (userSettings?.isAdmin() || userSettings?.isCommercial()) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $585f8bce88e531c1$export$a6c7ac8248d6e38a), {
                                        to: "/admin/reviews",
                                        className: "dropdown-item flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "icon is-small mr-2 y-2",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04b006b04b8c21eb$export$2e2bcd8739ae039), {
                                                    className: "w-5 h-5",
                                                    "aria-hidden": "true"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: "Avalia\xe7\xf5es"
                                            })
                                        ]
                                    }),
                                    (userSettings?.isAdmin() || userSettings?.isCommercial()) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $585f8bce88e531c1$export$a6c7ac8248d6e38a), {
                                        to: "/oms-orders",
                                        className: "dropdown-item flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "icon is-small mr-2 y-2",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b42daf8f5fabfd7f$export$2e2bcd8739ae039), {
                                                    className: "w-5 h-5",
                                                    "aria-hidden": "true"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: "Gestao de Encomendas"
                                            })
                                        ]
                                    }),
                                    (userSettings?.isAdmin() || userSettings?.isCommercial()) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $585f8bce88e531c1$export$a6c7ac8248d6e38a), {
                                        to: "/oms-proposals",
                                        className: "dropdown-item flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "icon is-small mr-2 y-2",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b42daf8f5fabfd7f$export$2e2bcd8739ae039), {
                                                    className: "w-5 h-5",
                                                    "aria-hidden": "true"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: "Propostas de Or\xe7amento"
                                            })
                                        ]
                                    }),
                                    userSettings?.isAdmin() && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $585f8bce88e531c1$export$a6c7ac8248d6e38a), {
                                        to: "/public-site",
                                        className: "dropdown-item flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "icon is-small mr-2 y-2",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9b51f4920eac1ba0$export$2e2bcd8739ae039), {
                                                    className: "w-5 h-5",
                                                    "aria-hidden": "true"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: "Gestao Site Publico"
                                            })
                                        ]
                                    }),
                                    userSettings?.isAdmin() && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $585f8bce88e531c1$export$a6c7ac8248d6e38a), {
                                        to: "/cms-admin",
                                        className: "dropdown-item flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "icon is-small mr-2 y-2",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $adb270212de20834$export$2e2bcd8739ae039), {
                                                    className: "w-5 h-5",
                                                    "aria-hidden": "true"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: "Gestao de Conteudos"
                                            })
                                        ]
                                    }),
                                    userSettings?.isAdmin() && (userSettings?.chat_settings?.url ?? false) && (userSettings?.chat_settings?.token ?? false) && (userSettings?.chat_settings?.tenant_subdomain ?? false) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $585f8bce88e531c1$export$a6c7ac8248d6e38a), {
                                        to: userSettings?.chat_settings?.url + "/admin-backoffice?tenant_subdomain=" + userSettings?.chat_settings?.tenant_subdomain + "&token=" + userSettings?.chat_settings?.token,
                                        target: "_blank",
                                        className: "dropdown-item flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "icon is-small mr-2 y-2",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e3a8f0b406639961$export$2e2bcd8739ae039), {
                                                    className: "w-5 h-5",
                                                    "aria-hidden": "true"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: "Chat Backoffice"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("hr", {
                                        className: "dropdown-divider"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $585f8bce88e531c1$export$a6c7ac8248d6e38a), {
                                        to: "/logout",
                                        className: "dropdown-item flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "icon is-small mr-2 y-2",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5473793717b51056$export$2e2bcd8739ae039), {
                                                    className: "w-5 h-5",
                                                    "aria-hidden": "true"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: "Logout"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    className: "bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600",
                    onClick: (e)=>{
                        e.preventDefault();
                        setShowLoginWidget(!showLoginWidget);
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $94451a36ffcee03b$export$2e2bcd8739ae039), {
                        className: "w-4 h-4 inline-block mr-2"
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                id: "login-widget",
                className: `w-100 absolute right-20 top-20 bg-white rounded-lg p-3 shadow-md z-50 ` + (showLoginWidget ? "flex" : "hidden"),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                    className: "bg-white p-3 w-full",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "control mb-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    children: "E-mail"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    type: "text",
                                    placeholder: "Username",
                                    className: "input is-small mr-2",
                                    onChange: (e)=>{
                                        setLoginRequest({
                                            ...loginRequest,
                                            username: e.target.value
                                        });
                                    },
                                    value: loginRequest.username
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "control mb-6",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    children: "Password"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    type: "password",
                                    placeholder: "Password",
                                    className: "input is-small mr-2",
                                    onChange: (e)=>{
                                        setLoginRequest({
                                            ...loginRequest,
                                            password: e.target.value
                                        });
                                    },
                                    value: loginRequest.password
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "flex is-justify-content-center",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                type: "submit",
                                className: "button is-small is-primary p-4 rounded-lg shadow-md",
                                onClick: (e)=>{
                                    e.preventDefault();
                                    login(loginRequest).then((result)=>{
                                        if (result) setShowLoginWidget(false);
                                        else setError("Utilizador ou password inv\xe1lido.");
                                    }).catch((err)=>{
                                        console.warn("Login error:", err);
                                    });
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c9173589173e62cb$export$2e2bcd8739ae039), {
                                        className: "w-6 h-6"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "ml-2",
                                        children: "Login"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "text-red-500 mt-2",
                            children: isLoading ? "Loading..." : error ? error : ""
                        })
                    ]
                })
            })
        ]
    });
};





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $00824d397ec63c04$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
            key: "wmoenq"
        }
    ],
    [
        "path",
        {
            d: "M12 9v4",
            key: "juzpu7"
        }
    ],
    [
        "path",
        {
            d: "M12 17h.01",
            key: "p32p05"
        }
    ]
];
const $00824d397ec63c04$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("triangle-alert", $00824d397ec63c04$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $839eea37a960d2b1$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "m15 9-6 6",
            key: "1uzhvr"
        }
    ],
    [
        "path",
        {
            d: "m9 9 6 6",
            key: "z0biqf"
        }
    ]
];
const $839eea37a960d2b1$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("circle-x", $839eea37a960d2b1$export$3efd853dbb351e94);


const $1b646c534a3e3fb6$var$ErrorMessage = ({ message: message, onClose: onClose })=>{
    if (!message) return null;
    if (typeof message !== "string") {
        console.error("ErrorMessage: message must be a string");
        return null;
    }
    if (message.length === 0) return null;
    if (message.length > 200) {
        console.warn("ErrorMessage: message is too long, truncating to 200 characters");
        message = message.substring(0, 200) + "...";
    }
    if (typeof onClose !== "function") {
        console.warn("ErrorMessage: onClose should be a function");
        return null;
    }
    (0, $acw62.useEffect)(()=>{
        const timer = setTimeout(onClose, 5000); // Auto close after 5 seconds
        return ()=>clearTimeout(timer); // Cleanup timer on unmount
    }, [
        onClose
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "fixed bottom-4 left-4 bg-red-100 border border-red-400 text-red-700 px-4 py-3 pr-4 rounded-md shadow-lg z-50000 flex items-center gap-2",
        role: "alert",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                className: "text-red-300 w-6 h-6"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                        className: "font-bold",
                        children: "Erro: "
                    }),
                    message
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                onClick: onClose,
                className: "ml-4 text-red-200 hover:text-white",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $839eea37a960d2b1$export$2e2bcd8739ae039), {
                    className: "w-4 h-4"
                })
            })
        ]
    });
};
var $1b646c534a3e3fb6$export$2e2bcd8739ae039 = $1b646c534a3e3fb6$var$ErrorMessage;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

const $6c1c0d52dc3ed5d3$var$SuccessMessage = ({ message: message, onClose: onClose })=>{
    if (!message) return null;
    if (typeof message !== "string") {
        console.warn("SuccessMessage: message should be a string");
        return null;
    }
    if (message.length > 100) {
        console.warn("SuccessMessage: message is too long");
        return null;
    }
    if (message.trim() === "") return null;
    if (typeof onClose !== "function") {
        console.warn("SuccessMessage: onClose should be a function");
        return null;
    }
    (0, $acw62.useEffect)(()=>{
        const timer = setTimeout(onClose, 5000); // Auto close after 5 seconds
        return ()=>clearTimeout(timer); // Cleanup timer on unmount or message change
    }, [
        message,
        onClose
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "fixed bottom-4 left-4 bg-green-600/90 text-white p-4 rounded-md shadow-lg z-40000 flex items-center gap-2",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                className: "text-green-300 w-6 h-6"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                children: message
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                onClick: onClose,
                className: "ml-4 text-green-200 hover:text-white",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $839eea37a960d2b1$export$2e2bcd8739ae039), {
                    className: "w-4 h-4"
                })
            })
        ]
    });
};
var $6c1c0d52dc3ed5d3$export$2e2bcd8739ae039 = $6c1c0d52dc3ed5d3$var$SuccessMessage;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $39f04136db3724b2$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21 12a9 9 0 1 1-6.219-8.56",
            key: "13zald"
        }
    ]
];
const $39f04136db3724b2$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("loader-circle", $39f04136db3724b2$export$3efd853dbb351e94);


const $22a8d83556d91eb0$var$LoadingScreen = ({ message: message, showSpinner: showSpinner, style: style })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `${style ?? "fixed"} inset-0 bg-black/30 flex items-center justify-center z-50`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                className: "animate-spin text-white text-4xl"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "sr-only",
                children: message ? message : "Carregando..."
            })
        ]
    });
var $22a8d83556d91eb0$export$2e2bcd8739ae039 = $22a8d83556d91eb0$var$LoadingScreen;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


const $6ca40d139217d071$var$ErrorScreen = ({ message: message, retryAfter: retryAfter, onClose: onClose, details: details, timestamp: timestamp, code: code })=>{
    if (!message) return null; // If no message is provided, do not render the component
    console.log("Rendering ErrorScreen with message:", message);
    console.debug("Details:", details);
    console.debug("Timestamp:", timestamp);
    console.debug("Code:", code);
    if (typeof retryAfter !== "function") console.warn("retryAfter is not a function, it should be a function that handles retry logic.");
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "fixed inset-0 bg-red-900/90 flex flex-col items-center justify-center z-50 p-4",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                className: "text-red-300 text-6xl mb-4"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                className: "text-red-200 text-2xl font-bold mb-4",
                children: "Erro"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "text-red-300 text-center mb-6 max-w-lg",
                children: message
            }),
            details && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "text-red-300 text-sm mb-2",
                children: details
            }),
            timestamp && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                className: "text-red-300 text-xs mb-2",
                children: [
                    "Ocorreu em: ",
                    new Date(timestamp).toLocaleString()
                ]
            }),
            code && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                className: "text-red-300 text-xs mb-4",
                children: [
                    "C\xf3digo: ",
                    code
                ]
            }),
            typeof retryAfter === "function" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48783e82a8986d7$exports.Button), {
                onClick: retryAfter,
                className: "is-danger",
                children: "Tentar Novamente"
            }),
            !retryAfter && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "text-red-300 text-sm mb-4",
                children: "Por favor, tente novamente mais tarde."
            }),
            typeof onClose === "function" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48783e82a8986d7$exports.Button), {
                onClick: onClose,
                className: "is-light mt-4",
                children: "Fechar"
            })
        ]
    });
};
var $6ca40d139217d071$export$2e2bcd8739ae039 = $6ca40d139217d071$var$ErrorScreen;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
/**
 * Taken from https://github.com/radix-ui/primitives/blob/main/packages/react/compose-refs/src/compose-refs.tsx
 */ /**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $e5de0e8b87a27aab$var$setRef(ref, value) {
    if (typeof ref === "function") return ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $e5de0e8b87a27aab$var$composeRefs(...refs) {
    return (node)=>{
        let hasCleanup = false;
        const cleanups = refs.map((ref)=>{
            const cleanup = $e5de0e8b87a27aab$var$setRef(ref, node);
            if (!hasCleanup && typeof cleanup === "function") hasCleanup = true;
            return cleanup;
        });
        // React <19 will log an error to the console if a callback ref returns a
        // value. We don't use ref cleanups internally so this will only happen if a
        // user's ref callback returns a value, which we only expect if they are
        // using the cleanup functionality added in React 19.
        if (hasCleanup) return ()=>{
            for(let i = 0; i < cleanups.length; i++){
                const cleanup = cleanups[i];
                if (typeof cleanup === "function") cleanup();
                else $e5de0e8b87a27aab$var$setRef(refs[i], null);
            }
        };
    };
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function $e5de0e8b87a27aab$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return $acw62.useCallback($e5de0e8b87a27aab$var$composeRefs(...refs), refs);
}


"use client";
/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ class $6f8c626e496e1918$var$PopChildMeasure extends $acw62.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const parent = element.offsetParent;
            const parentWidth = (0, $cbd7a6317a819185$export$1b3bfaa9684536aa)(parent) ? parent.offsetWidth || 0 : 0;
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
            size.right = parentWidth - size.width - size.left;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}
function $6f8c626e496e1918$export$1d6cdde0c6816c6d({ children: children, isPresent: isPresent, anchorX: anchorX, root: root }) {
    const id = (0, $acw62.useId)();
    const ref = (0, $acw62.useRef)(null);
    const size = (0, $acw62.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        right: 0
    });
    const { nonce: nonce } = (0, $acw62.useContext)((0, $3bbbde5b328b4154$export$22a697fb29aac98d));
    const composedRef = (0, $e5de0e8b87a27aab$export$c7b2cbe3552a0d05)(ref, children?.ref);
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, $acw62.useInsertionEffect)(()=>{
        const { width: width, height: height, top: top, left: left, right: right } = size.current;
        if (isPresent || !ref.current || !width || !height) return;
        const x = anchorX === "left" ? `left: ${left}` : `right: ${right}`;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        if (nonce) style.nonce = nonce;
        const parent = root ?? document.head;
        parent.appendChild(style);
        if (style.sheet) style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            ${x}px !important;
            top: ${top}px !important;
          }
        `);
        return ()=>{
            if (parent.contains(style)) parent.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return (0, $ayMG0.jsx)($6f8c626e496e1918$var$PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size,
        children: $acw62.cloneElement(children, {
            ref: composedRef
        })
    });
}


"use client";
const $f57f9e9f321f3a7c$export$979daf65881a382a = ({ children: children, initial: initial, isPresent: isPresent, onExitComplete: onExitComplete, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode, anchorX: anchorX, root: root })=>{
    const presenceChildren = (0, $40f5fd83135889a9$export$fe4300aa8eebea86)($f57f9e9f321f3a7c$var$newChildrenMap);
    const id = (0, $acw62.useId)();
    let isReusedContext = true;
    let context = (0, $acw62.useMemo)(()=>{
        isReusedContext = false;
        return {
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: (childId)=>{
                presenceChildren.set(childId, true);
                for (const isComplete of presenceChildren.values()){
                    if (!isComplete) return; // can stop searching when any is incomplete
                }
                onExitComplete && onExitComplete();
            },
            register: (childId)=>{
                presenceChildren.set(childId, false);
                return ()=>presenceChildren.delete(childId);
            }
        };
    }, [
        isPresent,
        presenceChildren,
        onExitComplete
    ]);
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ if (presenceAffectsLayout && isReusedContext) context = {
        ...context
    };
    (0, $acw62.useMemo)(()=>{
        presenceChildren.forEach((_, key)=>presenceChildren.set(key, false));
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $acw62.useEffect(()=>{
        !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
    }, [
        isPresent
    ]);
    if (mode === "popLayout") children = (0, $ayMG0.jsx)((0, $6f8c626e496e1918$export$1d6cdde0c6816c6d), {
        isPresent: isPresent,
        anchorX: anchorX,
        root: root,
        children: children
    });
    return (0, $ayMG0.jsx)((0, $dba5d94a982c4145$export$f224e4635b6f8ce2).Provider, {
        value: context,
        children: children
    });
};
function $f57f9e9f321f3a7c$var$newChildrenMap() {
    return new Map();
}




var $acw62 = parcelRequire("acw62");
const $2a41914a8628d3e4$export$10e61aed958678dd = (child)=>child.key || "";
function $2a41914a8628d3e4$export$872a3a1281f4b357(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $acw62.Children).forEach(children, (child)=>{
        if ((0, $acw62.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}


"use client";
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ const $06516233abcfeeff$export$3ae376d12526dd6f = ({ children: children, custom: custom, initial: initial = true, onExitComplete: onExitComplete, presenceAffectsLayout: presenceAffectsLayout = true, mode: mode = "sync", propagate: propagate = false, anchorX: anchorX = "left", root: root })=>{
    const [isParentPresent, safeToRemove] = (0, $bc77fac60b5d77cc$export$2a8c16d82a0a0e26)(propagate);
    /**
     * Filter any children that aren't ReactElements. We can only track components
     * between renders with a props.key.
     */ const presentChildren = (0, $acw62.useMemo)(()=>(0, $2a41914a8628d3e4$export$872a3a1281f4b357)(children), [
        children
    ]);
    /**
     * Track the keys of the currently rendered children. This is used to
     * determine which children are exiting.
     */ const presentKeys = propagate && !isParentPresent ? [] : presentChildren.map((0, $2a41914a8628d3e4$export$10e61aed958678dd));
    /**
     * If `initial={false}` we only want to pass this to components in the first render.
     */ const isInitialRender = (0, $acw62.useRef)(true);
    /**
     * A ref containing the currently present children. When all exit animations
     * are complete, we use this to re-render the component with the latest children
     * *committed* rather than the latest children *rendered*.
     */ const pendingPresentChildren = (0, $acw62.useRef)(presentChildren);
    /**
     * Track which exiting children have finished animating out.
     */ const exitComplete = (0, $40f5fd83135889a9$export$fe4300aa8eebea86)(()=>new Map());
    /**
     * Save children to render as React state. To ensure this component is concurrent-safe,
     * we check for exiting children via an effect.
     */ const [diffedChildren, setDiffedChildren] = (0, $acw62.useState)(presentChildren);
    const [renderedChildren, setRenderedChildren] = (0, $acw62.useState)(presentChildren);
    (0, $9c674755a93db746$export$700979bc83e7db82)(()=>{
        isInitialRender.current = false;
        pendingPresentChildren.current = presentChildren;
        /**
         * Update complete status of exiting children.
         */ for(let i = 0; i < renderedChildren.length; i++){
            const key = (0, $2a41914a8628d3e4$export$10e61aed958678dd)(renderedChildren[i]);
            if (!presentKeys.includes(key)) {
                if (exitComplete.get(key) !== true) exitComplete.set(key, false);
            } else exitComplete.delete(key);
        }
    }, [
        renderedChildren,
        presentKeys.length,
        presentKeys.join("-")
    ]);
    const exitingChildren = [];
    if (presentChildren !== diffedChildren) {
        let nextChildren = [
            ...presentChildren
        ];
        /**
         * Loop through all the currently rendered components and decide which
         * are exiting.
         */ for(let i = 0; i < renderedChildren.length; i++){
            const child = renderedChildren[i];
            const key = (0, $2a41914a8628d3e4$export$10e61aed958678dd)(child);
            if (!presentKeys.includes(key)) {
                nextChildren.splice(i, 0, child);
                exitingChildren.push(child);
            }
        }
        /**
         * If we're in "wait" mode, and we have exiting children, we want to
         * only render these until they've all exited.
         */ if (mode === "wait" && exitingChildren.length) nextChildren = exitingChildren;
        setRenderedChildren((0, $2a41914a8628d3e4$export$872a3a1281f4b357)(nextChildren));
        setDiffedChildren(presentChildren);
        /**
         * Early return to ensure once we've set state with the latest diffed
         * children, we can immediately re-render.
         */ return null;
    }
    if (mode === "wait" && renderedChildren.length > 1) console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`);
    /**
     * If we've been provided a forceRender function by the LayoutGroupContext,
     * we can use it to force a re-render amongst all surrounding components once
     * all components have finished animating out.
     */ const { forceRender: forceRender } = (0, $acw62.useContext)((0, $4ae202aab5791dbc$export$a3579ca508007a95));
    return (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: renderedChildren.map((child)=>{
            const key = (0, $2a41914a8628d3e4$export$10e61aed958678dd)(child);
            const isPresent = propagate && !isParentPresent ? false : presentChildren === renderedChildren || presentKeys.includes(key);
            const onExit = ()=>{
                if (exitComplete.has(key)) exitComplete.set(key, true);
                else return;
                let isEveryExitComplete = true;
                exitComplete.forEach((isExitComplete)=>{
                    if (!isExitComplete) isEveryExitComplete = false;
                });
                if (isEveryExitComplete) {
                    forceRender?.();
                    setRenderedChildren(pendingPresentChildren.current);
                    propagate && safeToRemove?.();
                    onExitComplete && onExitComplete();
                }
            };
            return (0, $ayMG0.jsx)((0, $f57f9e9f321f3a7c$export$979daf65881a382a), {
                isPresent: isPresent,
                initial: !isInitialRender.current || initial ? undefined : false,
                custom: custom,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode,
                root: root,
                onExitComplete: isPresent ? undefined : onExit,
                anchorX: anchorX,
                children: child
            }, key);
        })
    });
};



const $67ac64808127e67c$var$FOCUSABLE_SELECTOR = 'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
const $67ac64808127e67c$var$isVisible = (element, boundary)=>{
    let node = element;
    while(node && node !== boundary){
        if (node.hidden || node.getAttribute("aria-hidden") === "true") return false;
        const style = window.getComputedStyle(node);
        if (style.display === "none" || style.visibility === "hidden") return false;
        node = node.parentElement;
    }
    return true;
};
const $67ac64808127e67c$var$ModalScreen = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function ModalScreen({ className: className, children: children, footer: footer, childrenControlOverflow: childrenControlOverflow = false, title: title, state: state, onClose: onClose, onShow: onShow, dismissOnEscape: dismissOnEscape = false }, ref) {
    const [modalState, setModalState] = (0, $acw62.useState)(state);
    const panelRef = (0, $acw62.useRef)(null);
    const previouslyFocusedRef = (0, $acw62.useRef)(null);
    const titleId = (0, $acw62.useId)();
    const handleCloseModal = (0, $acw62.useCallback)(()=>{
        setModalState("closed");
        if (onClose) onClose();
    }, [
        onClose
    ]);
    (0, $acw62.useEffect)(()=>{
        if (modalState === "closed") return;
        previouslyFocusedRef.current = document.activeElement instanceof HTMLElement ? document.activeElement : null;
        panelRef.current?.focus();
        return ()=>{
            const target = previouslyFocusedRef.current;
            if (target?.isConnected) target.focus();
        };
    }, [
        modalState
    ]);
    (0, $acw62.useEffect)(()=>{
        if (modalState === "closed") return;
        const onKeyDown = (event)=>{
            // Never intercept keystrokes that belong to an IME composition.
            if (event.isComposing) return;
            const panel = panelRef.current;
            if (!panel) return;
            // Focus may sit on <body> after clicking non-interactive content, so the
            // handler lives on document rather than the panel.
            const target = event.target;
            const nested = target?.closest?.('[role="dialog"], [aria-modal="true"]');
            const nestedDialog = nested && nested !== panel && panel.contains(nested) ? nested : null;
            if (event.key === "Escape") {
                if (nestedDialog || !dismissOnEscape) return;
                event.stopPropagation();
                handleCloseModal();
                return;
            }
            if (event.key !== "Tab") return;
            const trapRoot = nestedDialog ?? panel;
            const focusable = Array.from(trapRoot.querySelectorAll($67ac64808127e67c$var$FOCUSABLE_SELECTOR)).filter((element)=>$67ac64808127e67c$var$isVisible(element, trapRoot));
            if (focusable.length === 0) {
                event.preventDefault();
                trapRoot.focus();
                return;
            }
            const first = focusable[0];
            const last = focusable[focusable.length - 1];
            const active = document.activeElement;
            if (!active || active === trapRoot || !trapRoot.contains(active)) {
                event.preventDefault();
                (event.shiftKey ? last : first).focus();
                return;
            }
            if (event.shiftKey && active === first) {
                event.preventDefault();
                last.focus();
            } else if (!event.shiftKey && active === last) {
                event.preventDefault();
                first.focus();
            }
        };
        document.addEventListener("keydown", onKeyDown);
        return ()=>document.removeEventListener("keydown", onKeyDown);
    }, [
        modalState,
        handleCloseModal,
        dismissOnEscape
    ]);
    const getWindowClassName = (0, $acw62.useCallback)(()=>{
        switch(modalState){
            case "confirm":
                return "bg-yellow-100 text-yellow-800 max-w-md";
            case "alert":
                return "bg-red-100 text-red-800 max-w-md";
            case "info":
                return "bg-blue-100 text-blue-800 max-w-md";
            case "view":
                return "bg-white w-full md:w-5/6 lg:w-3/6 lg:max-h-[80vh]";
            case "big-view":
            case "edit":
                return "bg-white w-full lg:w-4/6 lg:max-h-[80vh]";
            case "fullscreen":
                return "bg-white w-full h-full max-h-screen max-w-screen";
            default:
                return "bg-gray-100 text-gray-800";
        }
    }, [
        modalState
    ]);
    const getContentClassName = (0, $acw62.useCallback)(()=>{
        switch(modalState){
            case "confirm":
            case "alert":
            case "info":
                return "p-4 min-h-[64px] overflow-y-auto";
            case "big-view":
            case "view":
            case "edit":
                return "p-6 min-h-[64vh] overflow-y-auto w-full";
            case "fullscreen":
                return "p-0 h-full overflow-y-auto w-full";
            default:
                return "p-4";
        }
    }, [
        modalState
    ]);
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            close: handleCloseModal
        }), [
        handleCloseModal
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
        children: modalState !== "closed" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).div, {
            initial: {
                opacity: 0,
                x: 50
            },
            animate: {
                opacity: 1,
                x: 0
            },
            exit: {
                opacity: 0,
                x: -50
            },
            transition: {
                duration: 0.3
            },
            onMouseDown: (event)=>{
                if (event.target === event.currentTarget) panelRef.current?.focus();
            },
            className: "fixed inset-0 bg-black/50 flex items-center justify-center z-50 overflow-y-auto",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).div, {
                ref: panelRef,
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": title ? titleId : undefined,
                tabIndex: -1,
                initial: {
                    opacity: 0,
                    scale: 0.8
                },
                animate: {
                    opacity: 1,
                    scale: 1
                },
                exit: {
                    opacity: 0,
                    scale: 0.8
                },
                transition: {
                    duration: 0.2
                },
                className: `rounded-xl shadow-5xl overflow-y-auto outline-none ${className ?? ""} ${getWindowClassName()}`,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "p-3 sticky top-0 bg-gray-900/90 backdrop-blur-md text-white border-b modal-header",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex justify-between items-center",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    id: title ? titleId : undefined,
                                    className: "text-xl font-bold",
                                    children: title
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    type: "button",
                                    onClick: handleCloseModal,
                                    "aria-label": "Fechar",
                                    className: "is-large",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $839eea37a960d2b1$export$2e2bcd8739ae039), {
                                        className: "w-6 h-6",
                                        "aria-hidden": "true"
                                    })
                                })
                            ]
                        })
                    }),
                    childrenControlOverflow ? children : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: `max-h-full ${getContentClassName()}`,
                        children: children
                    }),
                    footer && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "sticky bottom-0 bg-gray-900/90 backdrop-blur-md text-white border-t modal-footer",
                        children: footer
                    })
                ]
            })
        })
    });
});
var $67ac64808127e67c$export$2e2bcd8739ae039 = $67ac64808127e67c$var$ModalScreen;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

/**
 * Catches render errors in a subtree so a single failing panel degrades to an
 * inline message instead of unmounting the whole app (which renders a blank
 * page, as happened when a facet payload was null).
 */ class $b2e01565dad3fb01$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error) {
        (0, $031177517a2d1428$export$b33b857ad1d9900e)("react.render", error, {
            component: "ErrorBoundary"
        });
    }
    render() {
        if (this.state.error) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "bg-red-50 text-red-700 border border-red-200 rounded p-4 text-sm",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "font-medium mb-1",
                    children: "Ocorreu um erro ao mostrar esta sec\xe7\xe3o."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "text-red-600 mb-3",
                    children: this.state.error.message
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    className: "button is-small",
                    onClick: ()=>this.setState({
                            error: null
                        }),
                    children: "Tentar novamente"
                })
            ]
        });
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            error: null
        };
    }
}
var $b2e01565dad3fb01$export$2e2bcd8739ae039 = $b2e01565dad3fb01$var$ErrorBoundary;


const $a3d53d3a3becf406$var$Layout = ({ children: children })=>{
    const { layoutListItem: layoutListItem, setLayoutListItem: setLayoutListItem } = (0, $a55f2a94cd420149$export$c50e37a2f0a2b064)();
    const navigate = (0, $585f8bce88e531c1$export$9770f232ac06a008)();
    const { pathname: pathname, state: state } = (0, $585f8bce88e531c1$export$45d76561a5302f2b)();
    const { isAuthenticated: isAuthenticated, profile: profile, profileData: profileData } = (0, $b622ef53e38024e7$export$1d39dc5b47e56ff0)();
    const { tasks: tasks, addTask: addTask, removeTask: removeTask } = (0, $a55f2a94cd420149$export$c50e37a2f0a2b064)();
    const { userSettings: userSettings, setUserSettings: setUserSettings, systemError: systemError, setSystemError: setSystemError, loading: loading, setLoading: setLoading, error: error, setError: setError, success: success, setSuccess: setSuccess, modalScreen: modalScreen, setModalScreen: setModalScreen, page: page, setPage: setPage, modalRef: modalRef } = (0, $a55f2a94cd420149$export$c50e37a2f0a2b064)();
    const [resellerView, _setResellerView] = (0, $acw62.useState)(false);
    // Every distinct modal object gets a fresh ModalScreen instance. This avoids
    // stale local state (e.g. an internal "closed" state) when a close and a new
    // open are batched into the same commit. A WeakMap keeps the key stable
    // across repeated renders of the same modal object (StrictMode/concurrent).
    const modalKeysRef = (0, $acw62.useRef)(new WeakMap());
    const nextModalKeyRef = (0, $acw62.useRef)(0);
    const [systemMessage, setSystemMessage] = (0, $acw62.useState)(null);
    const [profileError, setProfileError] = (0, $acw62.useState)(false);
    const fetchProfile = async ()=>{
        setProfileError(false);
        try {
            const profileData = await profile();
            setUserSettings(profileData ?? null);
        } catch  {
            // Keep the last known settings (graceful degradation). The fetch layer
            // already reports non-lifecycle failures via reportError.
            setProfileError(true);
        }
    };
    const setResellerView = (view)=>{
        _setResellerView(view);
        localStorage.setItem("resellerView", JSON.stringify(view));
    };
    (0, $acw62.useEffect)(()=>{
        const storedView = localStorage.getItem("resellerView");
        if (storedView) setResellerView(JSON.parse(storedView));
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (isAuthenticated()) fetchProfile();
        else navigate("/login", {
            state: {
                from: pathname
            }
        });
    }, [
        profile,
        isAuthenticated,
        profileData
    ]);
    (0, $acw62.useEffect)(()=>{
        const handlePopState = ()=>{
            const urlParams = new URLSearchParams(window.location.search);
            const pageParam = urlParams.get("page") ?? "1";
            if (pageParam) setPage(Number(pageParam));
        };
        handlePopState();
        window.addEventListener("popstate", handlePopState);
        return ()=>{
            window.removeEventListener("popstate", handlePopState);
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (state?.infoMsg) setSystemMessage({
            message: state.infoMsg,
            onClick: ()=>{
                setSystemMessage(null);
                navigate(state.from || "/");
            }
        });
        else if (userSettings?.profile.isCredentialsExpired && userSettings.isOperatorUser()) setSystemMessage({
            message: "As suas credenciais expiraram. Por favor, atualize a sua senha.",
            onClick: ()=>{
                navigate("/settings");
            }
        });
        else setSystemMessage(null);
    }, [
        userSettings,
        state
    ]);
    (0, $acw62.useEffect)(()=>{
        tasks.forEach((task)=>{
            const url = new URL(window.location.href);
            const currentModule = url.pathname.split("/")[1] || "store";
            if (task.allowedModules.length) {
                const hasAccess = task.allowedModules.some((module)=>module == currentModule);
                if (!hasAccess) {
                    if (confirm("Tem uma proposta aberta. Pretende fech\xe1-la antes de continuar?")) removeTask(task.id);
                    else history.go(-1);
                }
            }
        });
    // Only re-evaluate when the open tasks or the route change; running this on
    // every render re-opened the native confirm / popped history repeatedly.
    }, [
        tasks,
        pathname
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const renderTaskTip = (task)=>{
        const url = new URL(window.location.href);
        const currentModule = url.pathname.split("/")[1] || "store";
        if (task.tip[currentModule]) return " - " + task.tip[currentModule];
        return "";
    };
    const renderTasks = ()=>{
        if (tasks.length === 0) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "tasks container mx-auto px-4 py-2 notification is-info not-printable",
            children: tasks.map((task)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "task-item flex items-center space-x-2 is-justify-content-center p-2",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "task-name text-xl font-extrabold",
                            onClick: ()=>{
                                if (task.onSwitch) task.onSwitch();
                            },
                            children: task.name
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "task-tip text-sm italic text-gray-100 cursor-pointer",
                            onClick: ()=>{
                                if (task.onSwitch) task.onSwitch();
                            },
                            children: renderTaskTip(task)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>removeTask(task.id),
                            className: "task-close-button text-red-900 hover:text-gray-700 font-bold text-xl ml-4",
                            children: "\xd7"
                        })
                    ]
                }, task.id))
        });
    };
    const renderSystemMessage = ()=>{
        if (systemMessage && systemMessage.message) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: `bg-blue-100 text-blue-800 p-4 text-center cursor-pointer`,
            onClick: systemMessage.onClick,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e52b122f04c04d7d$export$2e2bcd8739ae039), {
                    className: "inline-block mr-2 w-5 h-5"
                }),
                systemMessage.message
            ]
        });
        return null;
    };
    const renderLoadingScreen = ()=>{
        if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $22a8d83556d91eb0$export$2e2bcd8739ae039), {
            message: loading.message,
            style: loading.style
        });
        return null;
    };
    const renderModalScreen = ()=>{
        if (modalScreen) {
            let modalKey = modalKeysRef.current.get(modalScreen);
            if (!modalKey) {
                modalKey = ++nextModalKeyRef.current;
                modalKeysRef.current.set(modalScreen, modalKey);
            }
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67ac64808127e67c$export$2e2bcd8739ae039), {
                ref: modalRef,
                className: modalScreen.className,
                title: modalScreen.title,
                state: modalScreen.state,
                onClose: modalScreen.onClose,
                onShow: modalScreen.onShow,
                footer: modalScreen.footer,
                childrenControlOverflow: modalScreen.childrenControlOverflow,
                dismissOnEscape: modalScreen.dismissOnEscape,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b2e01565dad3fb01$export$2e2bcd8739ae039), {
                    children: modalScreen.children
                })
            }, modalKey);
        }
        return null;
    };
    const renderSuccessMessage = ()=>{
        if (success) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6c1c0d52dc3ed5d3$export$2e2bcd8739ae039), {
            message: success,
            onClose: ()=>setSuccess(null)
        });
        return null;
    };
    const renderErrorMessage = ()=>{
        if (error) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b646c534a3e3fb6$export$2e2bcd8739ae039), {
            message: error,
            onClose: ()=>setError(null)
        });
        return null;
    };
    if (![
        "/login",
        "/register",
        "/reset-password"
    ].includes(pathname)) {
        if (!isAuthenticated()) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "flex items-center justify-center h-screen",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                className: "text-2xl font-bold",
                children: "Acesso Negado"
            })
        });
        if (isAuthenticated() && !userSettings) {
            if (profileError) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex flex-col items-center justify-center h-screen gap-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "text-lg font-medium text-gray-800",
                        children: "N\xe3o foi poss\xedvel carregar a sess\xe3o."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        type: "button",
                        onClick: ()=>void fetchProfile(),
                        className: "px-4 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-700 transition",
                        children: "Tentar novamente"
                    })
                ]
            });
            return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex items-center justify-center h-screen",
                children: "Loading..."
            });
        }
    }
    if (systemError) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ca40d139217d071$export$2e2bcd8739ae039), {
        message: systemError.message,
        details: systemError.details,
        retryAfter: systemError.retryAfter,
        onClose: ()=>setSystemError(null)
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `min-h-screen bg-gray-100${resellerView ? " reseller-view" : ""}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("header", {
                className: "bg-white shadow not-printable",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "container mx-auto px-4 py-4 flex justify-between items-center",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                className: "text-2xl font-bold",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$a6c7ac8248d6e38a), {
                                    to: "/",
                                    className: "text-gray-800 hover:text-blue-500",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "image-container  max-w-[150px] max-h-[100px]",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e87b4633e3445bd$export$2e2bcd8739ae039), {
                                            src: "http://iapc.pt/images/150/logo-IAPC.jpg",
                                            dataSrc: userSettings?.generalSettings?.company_logo_location,
                                            loading: "progressive",
                                            sizes: "150",
                                            alt: "Logo",
                                            className: "object-cover w-full h-10"
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("nav", {
                                className: "navbar",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "navbar-item px-4 py-2 is-hidden",
                                        children: [
                                            layoutListItem !== "grid" && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                className: `text-white hover:bg-gray-700 rounded`,
                                                onClick: ()=>setLayoutListItem("grid"),
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c52b562f10363bcd$export$2e2bcd8739ae039), {
                                                    className: "text-gray-400 w-8 h-8"
                                                })
                                            }),
                                            layoutListItem !== "list" && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                className: `text-white hover:bg-gray-700 rounded`,
                                                onClick: ()=>setLayoutListItem("list"),
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $421821514841703f$export$2e2bcd8739ae039), {
                                                    className: "text-gray-400 w-8 h-8"
                                                })
                                            })
                                        ]
                                    }),
                                    isAuthenticated() && userSettings?.isOperatorUser() && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "navbar-item px-4 py-2",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5QQ7K))), {
                                            value: resellerView,
                                            checked: resellerView,
                                            inputProps: {
                                                "aria-label": "Modo reseller"
                                            },
                                            onClick: (e)=>{
                                                e.preventDefault();
                                                setResellerView(!resellerView);
                                            },
                                            disabled: !userSettings?.generalSettings?.show_margin_slider && !userSettings?.generalSettings?.show_cost_price,
                                            className: ``
                                        })
                                    }),
                                    // if page is not /login, /register, or /reset-password hide the login widget
                                    ![
                                        "/login",
                                        "/register",
                                        "/reset-password"
                                    ].includes(pathname) && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "navbar-item px-4 py-2",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9bf0c5c273706e12$export$3d423776c18897a), {
                                            isAuthenticated: isAuthenticated() || false,
                                            userSettings: userSettings
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    renderTasks()
                ]
            }),
            renderSystemMessage(),
            renderLoadingScreen(),
            /*#__PURE__*/ (0, $ayMG0.jsx)("main", {
                className: "h-min-screen h-full",
                children: children
            }),
            renderErrorMessage(),
            renderSuccessMessage(),
            renderModalScreen()
        ]
    });
};
var $a3d53d3a3becf406$export$2e2bcd8739ae039 = $a3d53d3a3becf406$var$Layout;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");





/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $74c7893a6dd85e5c$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M16 12H8",
            key: "1fr5h0"
        }
    ],
    [
        "path",
        {
            d: "m12 8-4 4 4 4",
            key: "15vm53"
        }
    ]
];
const $74c7893a6dd85e5c$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("circle-arrow-left", $74c7893a6dd85e5c$export$3efd853dbb351e94);



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");





const $6812af06db045d33$var$ProductDetails = ({ reference: reference })=>{
    const [componentDetails, setComponentDetails] = (0, $acw62.useState)({});
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    const [selectedComponent, setSelectedComponent] = (0, $acw62.useState)(reference);
    const fetchComponentDetails = (0, $acw62.useCallback)(async (id)=>{
        try {
            const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).PRODUCTS + `/${id}`);
            return response.data;
        } catch (error) {
            if (error instanceof Error) {
                // @ts-ignore
                if (error.status === 404) {
                    console.warn(`Component with ID ${id} not found.`);
                    return null;
                }
                setError(error.message);
            } else setError("An unexpected error occurred");
            console.warn(`Error fetching component details for ID ${id}:`, error);
            return null;
        } finally{
            setLoading(false);
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        fetchComponentDetails(reference).then((component)=>{
            setComponentDetails((prevDetails)=>({
                    ...prevDetails,
                    [reference]: component
                }));
            setLoading(false);
        });
    }, [
        fetchComponentDetails,
        reference
    ]);
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $22a8d83556d91eb0$export$2e2bcd8739ae039), {});
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ca40d139217d071$export$2e2bcd8739ae039), {
        message: error
    });
    // @ts-ignore
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "components-details-view flex flex-col md:flex-row gap-4",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            id: "component-detail",
            className: "component-detail content w-full p-5 bg-white rounded-lg shadow-md",
            children: selectedComponent && componentDetails[selectedComponent] ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        className: "component-title font-extrabold text-3xl mb-4",
                        children: componentDetails[selectedComponent]?.name || "Component Details"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex flex-col md:flex-row gap-4",
                        children: [
                            componentDetails[selectedComponent]?.image && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "component-image mb-4 w-full md:w-1/2",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e87b4633e3445bd$export$2e2bcd8739ae039), {
                                    src: componentDetails[selectedComponent]?.image,
                                    alt: componentDetails[selectedComponent]?.name || "Component Image",
                                    sizes: "400",
                                    className: "max-w-full h-auto rounded-md"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "component-highlights p-3 w-full md:w-1/2",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                    className: "list-disc list-inside",
                                    children: componentDetails[selectedComponent]?.highlights.map((highlight, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            children: highlight
                                        }, index))
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "component-description mt-4",
                        children: [
                            componentDetails[selectedComponent]?.description || "No description available.",
                            componentDetails[selectedComponent]?.features && /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                className: "mt-4",
                                children: componentDetails[selectedComponent]?.features.map((feature, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("strong", {
                                                className: "font-semibold",
                                                children: [
                                                    feature.name,
                                                    ":"
                                                ]
                                            }),
                                            " ",
                                            feature.value
                                        ]
                                    }, index))
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "mt-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                        className: "font-semibold",
                                        children: "Stock:"
                                    }),
                                    " ",
                                    componentDetails[selectedComponent]?.stock || "N/A"
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                className: "component-title font-extrabold text-3xl mb-4",
                children: "N\xe3o foi poss\xedvel encontrar o componente selecionado."
            })
        })
    });
};
var $6812af06db045d33$export$2e2bcd8739ae039 = $6812af06db045d33$var$ProductDetails;






const $7181e2acc0f2e919$var$CompoundComparePage = ()=>{
    const { isAuthenticated: isAuthenticated } = (0, $b622ef53e38024e7$export$1d39dc5b47e56ff0)();
    const navigate = (0, $585f8bce88e531c1$export$9770f232ac06a008)();
    const { pathname: pathname } = (0, $585f8bce88e531c1$export$45d76561a5302f2b)();
    const { pcIds: pcIds } = (0, $585f8bce88e531c1$export$99eaa27ddbbb95ef)();
    const { setSystemError: setSystemError, setLoading: setLoading, setModalScreen: setModalScreen } = (0, $a55f2a94cd420149$export$c50e37a2f0a2b064)();
    const { selectedPCIdsToCompare: selectedPCIdsToCompare, handleAddToCompare: handleAddToCompare } = (0, $20c1d43c3adcec74$export$2e2bcd8739ae039)();
    const [pcsToCompare, setPcsToCompare] = (0, $acw62.useState)([]);
    const sortComponents = (0, $cd93687958c8007e$export$b6cd510719465167).map((item)=>item[0]);
    (0, $acw62.useEffect)(()=>{
        if (!isAuthenticated()) navigate("/login", {
            state: {
                from: pathname
            }
        });
    }, [
        isAuthenticated(),
        navigate,
        pathname
    ]);
    const fetchPCs = async (ids)=>{
        setLoading({
            showSpinner: true,
            style: "fixed"
        });
        setSystemError(null);
        try {
            const fetchedPCs = await Promise.all(ids.map(async (id)=>{
                return (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).CATALOG + `/${encodeURIComponent(id)}`);
            }));
            setPcsToCompare(fetchedPCs.map((res)=>res.data));
        } catch (err) {
            setSystemError({
                message: "N\xe3o foi poss\xedvel buscar as configura\xe7\xf5es para compara\xe7\xe3o.",
                code: err.code || "FETCH_ERROR",
                details: err.message || "Erro desconhecido ao buscar PCs.",
                retryAfter: ()=>{
                    if (!pcIds) {
                        navigate(-1);
                        return;
                    }
                    fetchPCs(pcIds.split(";").filter(Boolean));
                }
            });
            console.warn("Error fetching PCs for comparison:", err);
        } finally{
            setLoading(false);
        }
    };
    const showComponentDetails = (selectedProduct)=>{
        setModalScreen({
            state: "view",
            title: `Detalhes do componente`,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6812af06db045d33$export$2e2bcd8739ae039), {
                reference: selectedProduct.reference
            }),
            onClose: ()=>setModalScreen(null)
        });
    };
    const getComponentName = (pc, component)=>{
        return pc.filter((p)=>p.components?.[component]?.[0]?.baseComponent).map((p)=>p.components[component][0].type).pop();
    };
    const getOtherComponents = (pc)=>{
        return [
            ...new Set(pc.flatMap((p)=>Object.keys(p.components || {})))
        ].filter((key)=>!sortComponents.includes(key));
    };
    const getNestedProperty = (obj, path, defaultValue = "N/A")=>{
        return path.split(".").reduce((acc, part)=>{
            if (part.endsWith("[0]")) {
                const arrayKey = part.slice(0, -3);
                if (acc && Array.isArray(acc[arrayKey]) && acc[arrayKey].length > 0) return acc[arrayKey][0];
                return defaultValue;
            }
            return acc && acc[part] !== undefined ? acc[part] : defaultValue;
        }, obj);
    };
    (0, $acw62.useEffect)(()=>{
        if (pcIds) {
            const ids = pcIds.split(";").filter(Boolean);
            handleAddToCompare(ids);
            if (ids.length >= 2) {
                handleAddToCompare(ids);
                fetchPCs(ids);
            } else {
                setSystemError({
                    message: "Erro: \xc9 necess\xe1rio comparar pelo menos duas configura\xe7\xf5es.",
                    code: "INSUFFICIENT_PCS",
                    details: "Foram fornecidos menos de dois IDs de PCs para compara\xe7\xe3o.",
                    retryAfter: ()=>{
                        navigate(-1);
                    }
                });
                setLoading(false);
            }
        } else if (selectedPCIdsToCompare.length >= 2) fetchPCs(selectedPCIdsToCompare);
    }, [
        pcIds
    ]);
    const handleRemoveFromCompare = (id)=>{
        const updatedSelectedPCIds = selectedPCIdsToCompare.filter((pcId)=>pcId !== id);
        handleAddToCompare(updatedSelectedPCIds);
        setPcsToCompare(pcsToCompare.filter((pc)=>updatedSelectedPCIds.includes(pc.id)));
        history.replaceState({}, "", `/comparar/${updatedSelectedPCIds.join(";")}`);
    };
    const handleClose = ()=>{
        navigate(-1);
    };
    const displayComponentItem = (component, idx, componentName)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                    className: "px-4 py-2 font-semibold",
                    children: componentName
                }),
                pcsToCompare.map((pc)=>{
                    const quantity = getNestedProperty(pc, `components.${component}[0].quantity`);
                    const value = getNestedProperty(pc, `components.${component}[0].name`);
                    const reference = getNestedProperty(pc, `components.${component}[0].reference`, null);
                    const image = getNestedProperty(pc, `components.${component}[0].image`, null);
                    return /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        className: `px-4 py-2 ${reference ? "cursor-pointer" : ""}`,
                        onClick: ()=>{
                            reference && showComponentDetails({
                                reference: reference,
                                name: value
                            });
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            className: "w-full text-center block",
                            children: [
                                parseInt(quantity) > 1 ? quantity + " x " : "",
                                value
                            ]
                        })
                    }, pc.id);
                })
            ]
        }, idx);
    };
    if (!pcsToCompare || pcsToCompare.length < 2) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "bg-white p-6 rounded-lg shadow-md",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "text-red-500",
                children: "N\xe3o existe computadores para compara\xe7\xe3o"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48783e82a8986d7$exports.Button), {
                onClick: handleClose,
                className: "mt-4",
                children: "Close"
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "container mx-auto print-container",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "p-4 overflow-auto",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "text-2xl font-bold mb-4 pt-5 items-center",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$a6c7ac8248d6e38a), {
                        to: `/`,
                        className: "not-printable",
                        onClick: (e)=>{
                            e.preventDefault();
                            history.back();
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).button, {
                            whileHover: {
                                scale: 1.1
                            },
                            whileTap: {
                                scale: 0.9
                            },
                            className: "ml-5 mr-5 text-red-500 hover:text-red-700 flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c7893a6dd85e5c$export$2e2bcd8739ae039), {
                                    className: "w-7 h-7 inline-block"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "pl-2",
                                    children: "Voltar"
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "table-container overflow-x-auto bg-white rounded-lg shadow-md",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                        className: "min-w-full table is-narrow is-hoverable",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            className: "px-4 py-2 w-50"
                                        }),
                                        pcsToCompare.map((pc)=>/*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "px-4 py-2",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "flex justify-between items-start",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            className: "block w-full text-center",
                                                            onClick: ()=>{
                                                                navigate("/pc/" + pc.id);
                                                            },
                                                            children: [
                                                                pc.category_name,
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                pc.id
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "is-danger",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $839eea37a960d2b1$export$2e2bcd8739ae039), {
                                                                className: `inline-block w-6 h-6 ml-2 ${pcsToCompare.length <= 2 ? "text-gray-500 cursor-not-allowed" : "text-red-500 cursor-pointer"}`,
                                                                onClick: (e)=>{
                                                                    e.preventDefault();
                                                                    if (pcsToCompare.length <= 2) return;
                                                                    handleRemoveFromCompare(pc.id);
                                                                }
                                                            })
                                                        })
                                                    ]
                                                })
                                            }, pc.id))
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("tbody", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                className: "px-4 py-2  font-semibold"
                                            }),
                                            pcsToCompare.map((pc)=>/*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "px-4 py-2",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e87b4633e3445bd$export$2e2bcd8739ae039), {
                                                        onClick: ()=>{
                                                            navigate("/pc/" + pc.id);
                                                        },
                                                        loading: "progressive",
                                                        src: "https://placehold.co/400",
                                                        dataSrc: pc.image && pc.image.trim() !== "" ? pc.image.trim() : "https://placehold.co/400",
                                                        sizes: "400x400",
                                                        alt: pc.name ?? "PC Image",
                                                        className: "w-32 h-32 object-cover m-auto rounded"
                                                    })
                                                }, pc.id))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                className: "px-4 py-2  font-semibold",
                                                children: "Descri\xe7\xe3o"
                                            }),
                                            pcsToCompare.map((pc)=>/*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "px-4 py-2",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "block w-full text-center",
                                                        onClick: ()=>{
                                                            navigate("/pc/" + pc.id);
                                                        },
                                                        children: pc.description
                                                    })
                                                }, pc.id))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                className: "px-4 py-2  font-semibold",
                                                children: "Pre\xe7o"
                                            }),
                                            pcsToCompare.map((pc)=>{
                                                const value = getNestedProperty(pc, "price.value");
                                                const currency = getNestedProperty(pc, "price.currency");
                                                return /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "px-4 py-2  text-center",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "block w-full text-center",
                                                        onClick: ()=>{
                                                            navigate("/pc/" + pc.id);
                                                        },
                                                        children: [
                                                            Math.round(value * 100) / 100,
                                                            " ",
                                                            currency
                                                        ]
                                                    })
                                                }, pc.id);
                                            })
                                        ]
                                    }),
                                    sortComponents.map((component, idx)=>{
                                        const componentName = getComponentName(pcsToCompare, component);
                                        if (componentName) return displayComponentItem(component, idx, componentName);
                                        return null;
                                    }),
                                    getOtherComponents(pcsToCompare).map((component, idx)=>{
                                        const componentName = getComponentName(pcsToCompare, component);
                                        if (componentName) return displayComponentItem(component, idx, componentName);
                                        return null;
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $7181e2acc0f2e919$export$2e2bcd8739ae039 = $7181e2acc0f2e919$var$CompoundComparePage;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $6bfe12c41179c4f1$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
            key: "3c2336"
        }
    ],
    [
        "path",
        {
            d: "M7 12h5",
            key: "gblrwe"
        }
    ],
    [
        "path",
        {
            d: "M15 9.4a4 4 0 1 0 0 5.2",
            key: "1makmb"
        }
    ]
];
const $6bfe12c41179c4f1$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("badge-euro", $6bfe12c41179c4f1$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8240f8fcfc513968$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M20 6 9 17l-5-5",
            key: "1gmf2c"
        }
    ]
];
const $8240f8fcfc513968$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("check", $8240f8fcfc513968$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $d1c159efbf8295ba$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "3",
            rx: "2",
            key: "afitv7"
        }
    ],
    [
        "path",
        {
            d: "M11 9h4a2 2 0 0 0 2-2V3",
            key: "1ve2rv"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "9",
            r: "2",
            key: "af1f0g"
        }
    ],
    [
        "path",
        {
            d: "M7 21v-4a2 2 0 0 1 2-2h4",
            key: "1fwkro"
        }
    ],
    [
        "circle",
        {
            cx: "15",
            cy: "15",
            r: "2",
            key: "3i40o0"
        }
    ]
];
const $d1c159efbf8295ba$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("circuit-board", $d1c159efbf8295ba$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $514fc7cbbe3aa353$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "14",
            height: "8",
            x: "5",
            y: "2",
            rx: "2",
            key: "wc9tft"
        }
    ],
    [
        "rect",
        {
            width: "20",
            height: "8",
            x: "2",
            y: "14",
            rx: "2",
            key: "w68u3i"
        }
    ],
    [
        "path",
        {
            d: "M6 18h2",
            key: "rwmk9e"
        }
    ],
    [
        "path",
        {
            d: "M12 18h6",
            key: "aqd8w3"
        }
    ]
];
const $514fc7cbbe3aa353$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("computer", $514fc7cbbe3aa353$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e8859e855a5dc92a$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 20v2",
            key: "1lh1kg"
        }
    ],
    [
        "path",
        {
            d: "M12 2v2",
            key: "tus03m"
        }
    ],
    [
        "path",
        {
            d: "M17 20v2",
            key: "1rnc9c"
        }
    ],
    [
        "path",
        {
            d: "M17 2v2",
            key: "11trls"
        }
    ],
    [
        "path",
        {
            d: "M2 12h2",
            key: "1t8f8n"
        }
    ],
    [
        "path",
        {
            d: "M2 17h2",
            key: "7oei6x"
        }
    ],
    [
        "path",
        {
            d: "M2 7h2",
            key: "asdhe0"
        }
    ],
    [
        "path",
        {
            d: "M20 12h2",
            key: "1q8mjw"
        }
    ],
    [
        "path",
        {
            d: "M20 17h2",
            key: "1fpfkl"
        }
    ],
    [
        "path",
        {
            d: "M20 7h2",
            key: "1o8tra"
        }
    ],
    [
        "path",
        {
            d: "M7 20v2",
            key: "4gnj0m"
        }
    ],
    [
        "path",
        {
            d: "M7 2v2",
            key: "1i4yhu"
        }
    ],
    [
        "rect",
        {
            x: "4",
            y: "4",
            width: "16",
            height: "16",
            rx: "2",
            key: "1vbyd7"
        }
    ],
    [
        "rect",
        {
            x: "8",
            y: "8",
            width: "8",
            height: "8",
            rx: "1",
            key: "z9xiuo"
        }
    ]
];
const $e8859e855a5dc92a$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("cpu", $e8859e855a5dc92a$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $554c4787c44ee537$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10.827 16.379a6.082 6.082 0 0 1-8.618-7.002l5.412 1.45a6.082 6.082 0 0 1 7.002-8.618l-1.45 5.412a6.082 6.082 0 0 1 8.618 7.002l-5.412-1.45a6.082 6.082 0 0 1-7.002 8.618l1.45-5.412Z",
            key: "484a7f"
        }
    ],
    [
        "path",
        {
            d: "M12 12v.01",
            key: "u5ubse"
        }
    ]
];
const $554c4787c44ee537$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("fan", $554c4787c44ee537$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4e6e7c8f114d04e1$export$3efd853dbb351e94 = [
    [
        "line",
        {
            x1: "22",
            x2: "2",
            y1: "12",
            y2: "12",
            key: "1y58io"
        }
    ],
    [
        "path",
        {
            d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
            key: "oot6mr"
        }
    ],
    [
        "line",
        {
            x1: "6",
            x2: "6.01",
            y1: "16",
            y2: "16",
            key: "sgf278"
        }
    ],
    [
        "line",
        {
            x1: "10",
            x2: "10.01",
            y1: "16",
            y2: "16",
            key: "1l4acy"
        }
    ]
];
const $4e6e7c8f114d04e1$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("hard-drive", $4e6e7c8f114d04e1$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $2ebf99d6f8a58620$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10 8h.01",
            key: "1r9ogq"
        }
    ],
    [
        "path",
        {
            d: "M12 12h.01",
            key: "1mp3jc"
        }
    ],
    [
        "path",
        {
            d: "M14 8h.01",
            key: "1primd"
        }
    ],
    [
        "path",
        {
            d: "M16 12h.01",
            key: "1l6xoz"
        }
    ],
    [
        "path",
        {
            d: "M18 8h.01",
            key: "emo2bl"
        }
    ],
    [
        "path",
        {
            d: "M6 8h.01",
            key: "x9i8wu"
        }
    ],
    [
        "path",
        {
            d: "M7 16h10",
            key: "wp8him"
        }
    ],
    [
        "path",
        {
            d: "M8 12h.01",
            key: "czm47f"
        }
    ],
    [
        "rect",
        {
            width: "20",
            height: "16",
            x: "2",
            y: "4",
            rx: "2",
            key: "18n3k1"
        }
    ]
];
const $2ebf99d6f8a58620$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("keyboard", $2ebf99d6f8a58620$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $d6fe951f3901e9a6$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7",
            key: "132q7q"
        }
    ],
    [
        "rect",
        {
            x: "2",
            y: "4",
            width: "20",
            height: "16",
            rx: "2",
            key: "izxlao"
        }
    ]
];
const $d6fe951f3901e9a6$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("mail", $d6fe951f3901e9a6$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c978075baab28645$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
            key: "1r0f0z"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "10",
            r: "3",
            key: "ilqhr7"
        }
    ]
];
const $c978075baab28645$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("map-pin", $c978075baab28645$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $305d6e4c68cac6f3$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M6 19v-3",
            key: "1nvgqn"
        }
    ],
    [
        "path",
        {
            d: "M10 19v-3",
            key: "iu8nkm"
        }
    ],
    [
        "path",
        {
            d: "M14 19v-3",
            key: "kcehxu"
        }
    ],
    [
        "path",
        {
            d: "M18 19v-3",
            key: "1vh91z"
        }
    ],
    [
        "path",
        {
            d: "M8 11V9",
            key: "63erz4"
        }
    ],
    [
        "path",
        {
            d: "M16 11V9",
            key: "fru6f3"
        }
    ],
    [
        "path",
        {
            d: "M12 11V9",
            key: "ha00sb"
        }
    ],
    [
        "path",
        {
            d: "M2 15h20",
            key: "16ne18"
        }
    ],
    [
        "path",
        {
            d: "M2 7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v1.1a2 2 0 0 0 0 3.837V17a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-5.1a2 2 0 0 0 0-3.837Z",
            key: "lhddv3"
        }
    ]
];
const $305d6e4c68cac6f3$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("memory-stick", $305d6e4c68cac6f3$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e567cef82db71d0e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M18 12h2",
            key: "quuxs7"
        }
    ],
    [
        "path",
        {
            d: "M18 16h2",
            key: "zsn3lv"
        }
    ],
    [
        "path",
        {
            d: "M18 20h2",
            key: "9x5y9y"
        }
    ],
    [
        "path",
        {
            d: "M18 4h2",
            key: "1luxfb"
        }
    ],
    [
        "path",
        {
            d: "M18 8h2",
            key: "nxqzg"
        }
    ],
    [
        "path",
        {
            d: "M4 12h2",
            key: "1ltxp0"
        }
    ],
    [
        "path",
        {
            d: "M4 16h2",
            key: "8a5zha"
        }
    ],
    [
        "path",
        {
            d: "M4 20h2",
            key: "27dk57"
        }
    ],
    [
        "path",
        {
            d: "M4 4h2",
            key: "10groj"
        }
    ],
    [
        "path",
        {
            d: "M4 8h2",
            key: "18vq6w"
        }
    ],
    [
        "path",
        {
            d: "M8 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-1.5c-.276 0-.494.227-.562.495a2 2 0 0 1-3.876 0C9.994 2.227 9.776 2 9.5 2z",
            key: "1681fp"
        }
    ]
];
const $e567cef82db71d0e$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("microchip", $e567cef82db71d0e$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f633c0fb63f4b508$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "20",
            height: "14",
            x: "2",
            y: "3",
            rx: "2",
            key: "48i651"
        }
    ],
    [
        "line",
        {
            x1: "8",
            x2: "16",
            y1: "21",
            y2: "21",
            key: "1svkeh"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "17",
            y2: "21",
            key: "vw1qmm"
        }
    ]
];
const $f633c0fb63f4b508$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("monitor", $f633c0fb63f4b508$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $776c757559abfae2$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            x: "5",
            y: "2",
            width: "14",
            height: "20",
            rx: "7",
            key: "11ol66"
        }
    ],
    [
        "path",
        {
            d: "M12 6v4",
            key: "16clxf"
        }
    ]
];
const $776c757559abfae2$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("mouse", $776c757559abfae2$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $b798f41cb482ae86$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M2 6h4",
            key: "aawbzj"
        }
    ],
    [
        "path",
        {
            d: "M2 10h4",
            key: "l0bgd4"
        }
    ],
    [
        "path",
        {
            d: "M2 14h4",
            key: "1gsvsf"
        }
    ],
    [
        "path",
        {
            d: "M2 18h4",
            key: "1bu2t1"
        }
    ],
    [
        "rect",
        {
            width: "16",
            height: "20",
            x: "4",
            y: "2",
            rx: "2",
            key: "1nb95v"
        }
    ],
    [
        "path",
        {
            d: "M16 2v20",
            key: "rotuqe"
        }
    ]
];
const $b798f41cb482ae86$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("notebook", $b798f41cb482ae86$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $437c67a40c1b8279$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z",
            key: "1a0edw"
        }
    ],
    [
        "path",
        {
            d: "M12 22V12",
            key: "d0xqtd"
        }
    ],
    [
        "polyline",
        {
            points: "3.29 7 12 12 20.71 7",
            key: "ousv84"
        }
    ],
    [
        "path",
        {
            d: "m7.5 4.27 9 5.15",
            key: "1c824w"
        }
    ]
];
const $437c67a40c1b8279$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("package", $437c67a40c1b8279$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $cf972fdbc52e6ed1$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "14",
            height: "20",
            x: "5",
            y: "2",
            rx: "2",
            key: "1uq1d7"
        }
    ],
    [
        "path",
        {
            d: "M15 14h.01",
            key: "1kp3bh"
        }
    ],
    [
        "path",
        {
            d: "M9 6h6",
            key: "dgm16u"
        }
    ],
    [
        "path",
        {
            d: "M9 10h6",
            key: "9gxzsh"
        }
    ]
];
const $cf972fdbc52e6ed1$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("pc-case", $cf972fdbc52e6ed1$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $970c5cdf933ea69e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
            key: "foiqr5"
        }
    ]
];
const $970c5cdf933ea69e$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("phone", $970c5cdf933ea69e$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $bfe54799d1557409$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 2v10",
            key: "mnfbl"
        }
    ],
    [
        "path",
        {
            d: "M18.4 6.6a9 9 0 1 1-12.77.04",
            key: "obofu9"
        }
    ]
];
const $bfe54799d1557409$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("power", $bfe54799d1557409$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $10da79d8875e7dff$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z",
            key: "m3kijz"
        }
    ],
    [
        "path",
        {
            d: "m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z",
            key: "1fmvmk"
        }
    ],
    [
        "path",
        {
            d: "M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0",
            key: "1f8sc4"
        }
    ],
    [
        "path",
        {
            d: "M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5",
            key: "qeys4"
        }
    ]
];
const $10da79d8875e7dff$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("rocket", $10da79d8875e7dff$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $ee6f13a46cf9100a$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "8",
            cy: "21",
            r: "1",
            key: "jimo8o"
        }
    ],
    [
        "circle",
        {
            cx: "19",
            cy: "21",
            r: "1",
            key: "13723u"
        }
    ],
    [
        "path",
        {
            d: "M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12",
            key: "9zh506"
        }
    ]
];
const $ee6f13a46cf9100a$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("shopping-cart", $ee6f13a46cf9100a$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $ecb8e5bcb990e28a$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8Z",
            key: "qazsjp"
        }
    ],
    [
        "path",
        {
            d: "M15 3v4a2 2 0 0 0 2 2h4",
            key: "40519r"
        }
    ]
];
const $ecb8e5bcb990e28a$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("sticky-note", $ecb8e5bcb990e28a$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $0740549741641712$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "8",
            r: "5",
            key: "1hypcn"
        }
    ],
    [
        "path",
        {
            d: "M20 21a8 8 0 0 0-16 0",
            key: "rfgkzh"
        }
    ]
];
const $0740549741641712$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("user-round", $0740549741641712$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $b144e577f231bbf4$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 20h.01",
            key: "zekei9"
        }
    ],
    [
        "path",
        {
            d: "M2 8.82a15 15 0 0 1 20 0",
            key: "dnpr2z"
        }
    ],
    [
        "path",
        {
            d: "M5 12.859a10 10 0 0 1 14 0",
            key: "1x1e6c"
        }
    ],
    [
        "path",
        {
            d: "M8.5 16.429a5 5 0 0 1 7 0",
            key: "1bycff"
        }
    ]
];
const $b144e577f231bbf4$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("wifi", $b144e577f231bbf4$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $cfb3b3013a649f15$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M18 6 6 18",
            key: "1bl5f8"
        }
    ],
    [
        "path",
        {
            d: "m6 6 12 12",
            key: "d8bk6v"
        }
    ]
];
const $cfb3b3013a649f15$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("x", $cfb3b3013a649f15$export$3efd853dbb351e94);





const $331fdff9ce862c26$var$usePrintHtmlInNewWindow = (htmlContent, windowTitle = "Print Document")=>{
    const printWindow = window.open("", "_blank", "width=800,height=600");
    if (!printWindow) {
        alert("Failed to open print window. Please allow pop-ups for this site.");
        return;
    }
    try {
        printWindow.document.write(htmlContent);
        printWindow.document.close();
    } catch (error) {
        console.error("Failed to write to print window:", error);
        alert("Failed to prepare the print document. Please try again.");
        return;
    }
    printWindow.onload = ()=>{
        try {
            // Adicionando um listener para detectar quando a impressão é cancelada ou concluída
            const beforePrint = ()=>{
                console.log("Preparando para imprimir...");
            };
            const afterPrint = ()=>{
                console.log("Impress\xe3o conclu\xedda ou cancelada");
                // Fechar apenas se a janela ainda existir
                if (printWindow && !printWindow.closed) printWindow.close();
            };
            printWindow.addEventListener("beforeprint", beforePrint);
            printWindow.addEventListener("afterprint", afterPrint);
            // Iniciar a impressão
            printWindow.print();
        } catch (error) {
            if (error instanceof Error) {
                console.error("Print failed:", error.message);
                alert(`Printing failed: ${error.message}`);
            } else {
                console.error("Print failed:", error);
                alert("Printing failed. Please try again.");
            }
        }
    };
};
var $331fdff9ce862c26$export$2e2bcd8739ae039 = $331fdff9ce862c26$var$usePrintHtmlInNewWindow;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


const $e9b8fd613c8f8b46$var$CancelOfferConfirmation = ({ offerId: offerId, openModal: openModal, onClose: onClose, handleCancelProposal: handleCancelProposal })=>{
    if (!offerId) return null; // If no offerId is provided, do not render the modal
    const [cancelReason, setCancelReason] = (0, $acw62.useState)({
        reason: "",
        notes: ""
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (openModal) setCancelReason({
            reason: "",
            notes: ""
        });
    }, [
        openModal
    ]);
    const closeModal = ()=>{
        onClose();
    };
    if (!openModal) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67ac64808127e67c$export$2e2bcd8739ae039), {
        title: "Cancelar Proposta",
        onClose: closeModal,
        state: "confirm",
        footer: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex justify-end gap-2 p-4",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    className: "button is-white",
                    onClick: closeModal,
                    children: "Voltar"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                    className: "button is-danger",
                    disabled: !cancelReason.reason || cancelReason.reason === "other" && !cancelReason.notes.trim(),
                    onClick: ()=>{
                        handleCancelProposal(cancelReason);
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "icon is-small",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                className: "inline mr-1"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            children: "Confirmar Cancelamento"
                        })
                    ]
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "p-6",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "notification is-warning is-light mb-6 flex items-start",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "icon has-text-warning mr-3 mt-1",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                className: "fas fa-exclamation-triangle"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "font-bold text-gray-800",
                                    children: "Tem a certeza que deseja cancelar esta proposta?"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "text-sm mt-1 text-gray-600",
                                    children: "Esta a\xe7\xe3o n\xe3o pode ser facilmente revertida. Por favor, forne\xe7a um motivo para o cancelamento."
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "box shadow-sm border border-gray-100 p-4",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "field mb-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    className: "label text-xs uppercase tracking-wide font-semibold text-gray-500 mb-2",
                                    children: "Motivo do Cancelamento"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "control",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "select is-fullwidth",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                            value: cancelReason.reason,
                                            onChange: (e)=>setCancelReason({
                                                    ...cancelReason,
                                                    reason: e.target.value
                                                }),
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "",
                                                    children: "Selecione um motivo"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "out_of_stock",
                                                    children: "Fora de stock"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "client_choose",
                                                    children: "Cliente prefere outra op\xe7\xe3o"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "price_issue",
                                                    children: "Problema de pre\xe7o"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "technical_issue",
                                                    children: "Problema t\xe9cnico"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "logistics_issue",
                                                    children: "Problema log\xedstico"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "no_longer_needed",
                                                    children: "J\xe1 n\xe3o \xe9 necess\xe1rio"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "duplicate_offer",
                                                    children: "Oferta duplicada"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "internal_error",
                                                    children: "Erro interno"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "other",
                                                    children: "Outro"
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "field",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                    className: "label text-xs uppercase tracking-wide font-semibold text-gray-500 mb-2",
                                    children: [
                                        "Notas Adicionais",
                                        " ",
                                        cancelReason.reason === "other" && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "has-text-danger",
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "control",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                        className: "textarea",
                                        placeholder: cancelReason.reason === "other" ? "Por favor, especifique o motivo..." : "Informa\xe7\xf5es adicionais (opcional)",
                                        value: cancelReason.notes,
                                        onChange: (e)=>setCancelReason({
                                                ...cancelReason,
                                                notes: e.target.value
                                            }),
                                        rows: 3
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $e9b8fd613c8f8b46$export$2e2bcd8739ae039 = $e9b8fd613c8f8b46$var$CancelOfferConfirmation;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


const $dfb538d62fb33b43$var$ConfirmOrderConfirmation = ({ openModal: openModal, onClose: onClose, onConfirm: onConfirm, offer: offer })=>{
    if (!openModal) return null;
    const calculateTotals = ()=>{
        let totalCost = 0;
        let totalSellExVat = 0;
        let totalSellIncVat = 0;
        const getWithoutVat = (price)=>{
            if (price.without_vat && price.without_vat > 0) return price.without_vat;
            const vatRate = price.vat_rate !== undefined && price.vat_rate !== null ? price.vat_rate : 23;
            return price.value / (1 + vatRate / 100);
        };
        // Base Price (assuming compound price is the base)
        const basePrice = offer.compound.price;
        totalCost += basePrice.resell || 0;
        totalSellExVat += getWithoutVat(basePrice);
        totalSellIncVat += basePrice.value || 0;
        return {
            totalCost: totalCost,
            totalSellExVat: totalSellExVat,
            totalSellIncVat: totalSellIncVat
        };
    };
    const { totalCost: totalCost, totalSellExVat: totalSellExVat, totalSellIncVat: totalSellIncVat } = calculateTotals();
    const margin = totalSellExVat - totalCost;
    const marginPercent = totalCost > 0 ? margin / totalCost * 100 : 0;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67ac64808127e67c$export$2e2bcd8739ae039), {
        title: "Confirmar Encomenda",
        onClose: onClose,
        state: "confirm",
        footer: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex justify-end gap-2 p-4",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    className: "button is-white",
                    onClick: onClose,
                    children: "Cancelar"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                    className: "button is-success",
                    onClick: onConfirm,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "icon is-small",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                                className: "inline mr-1"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            children: "Confirmar Encomenda"
                        })
                    ]
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "p-6",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "notification is-warning is-light mb-6 flex items-start",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "icon has-text-warning mr-3 mt-1",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                className: "fas fa-exclamation-triangle"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "font-bold text-gray-800",
                                    children: "Tem a certeza que deseja criar uma encomenda?"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "text-sm mt-1 text-gray-600",
                                    children: "Esta a\xe7\xe3o ir\xe1 gerar uma encomenda no sistema. Verifique os valores abaixo antes de confirmar."
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "box shadow-sm border border-gray-100",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "title is-6 mb-4 border-b pb-2 text-gray-700",
                            children: "Resumo Financeiro"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "columns is-multiline is-mobile",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "column is-6-mobile is-6-tablet",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "field mb-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                className: "label text-xs uppercase tracking-wide font-semibold text-gray-500 mb-1",
                                                children: "O Seu Custo (Revenda)"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "control",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: "title is-5 text-gray-700 font-bold",
                                                    children: [
                                                        totalCost.toFixed(2),
                                                        " \u20AC"
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "column is-6-mobile is-6-tablet",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "field mb-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                className: "label text-xs uppercase tracking-wide font-semibold text-gray-500 mb-1",
                                                children: "Margem Estimada"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "control",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: `title is-5 font-bold ${margin >= 0 ? "text-green-600" : "text-red-600"}`,
                                                    children: [
                                                        margin.toFixed(2),
                                                        " \u20AC",
                                                        " ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            className: "text-sm font-normal text-gray-500",
                                                            children: [
                                                                "(",
                                                                marginPercent.toFixed(1),
                                                                "%)"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "column is-6-mobile is-6-tablet",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "field mb-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                className: "label text-xs uppercase tracking-wide font-semibold text-gray-500 mb-1",
                                                children: "Pre\xe7o Venda (s/ IVA)"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "control",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: "title is-5 text-blue-600 font-bold",
                                                    children: [
                                                        totalSellExVat.toFixed(2),
                                                        " \u20AC"
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "column is-6-mobile is-6-tablet",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "field mb-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                className: "label text-xs uppercase tracking-wide font-semibold text-gray-500 mb-1",
                                                children: "Pre\xe7o Venda (c/ IVA)"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "control",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: "title is-5 text-blue-800 font-bold",
                                                    children: [
                                                        totalSellIncVat.toFixed(2),
                                                        " \u20AC"
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $dfb538d62fb33b43$export$2e2bcd8739ae039 = $dfb538d62fb33b43$var$ConfirmOrderConfirmation;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


const $726defbc0778299a$var$AcceptOfferConfirmation = ({ openModal: openModal, onClose: onClose, onConfirm: onConfirm, offerProposal: offerProposal })=>{
    const closeModal = ()=>{
        onClose();
    };
    const handleConfirm = ()=>{
        onConfirm();
        closeModal();
    };
    // Calculate totals
    const totalValue = offerProposal.compound?.price?.value || 0;
    const totalWithoutVat = offerProposal.compound?.price?.without_vat || 0;
    const clientName = offerProposal.client?.name || "Cliente n\xe3o especificado";
    if (!openModal) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67ac64808127e67c$export$2e2bcd8739ae039), {
        title: "Aceitar Proposta",
        onClose: closeModal,
        state: "confirm",
        footer: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex justify-end gap-2 p-4",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    className: "button is-white",
                    onClick: closeModal,
                    children: "Cancelar"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                    className: "button is-success",
                    onClick: handleConfirm,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "icon is-small",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                                className: "inline mr-1"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            children: "Confirmar Aceita\xe7\xe3o"
                        })
                    ]
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "p-6",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "notification is-success is-light mb-6 flex items-start",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "icon has-text-success mr-3 mt-1",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                className: "fas fa-check-circle"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "font-bold text-gray-800",
                                    children: "Confirmar aceita\xe7\xe3o da proposta?"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "text-sm mt-1 text-gray-600",
                                    children: "Esta a\xe7\xe3o ir\xe1 criar uma encomenda no sistema. Por favor, verifique os dados abaixo antes de confirmar."
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "box shadow-sm border border-gray-100 p-4",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "title is-6 mb-4 border-b pb-2 text-gray-700",
                            children: "Detalhes da Proposta"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "field mb-3",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    className: "label text-xs uppercase tracking-wide font-semibold text-gray-500 mb-1",
                                    children: "Cliente"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "control",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "text-base text-gray-700 font-medium",
                                        children: clientName
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "field mb-3",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    className: "label text-xs uppercase tracking-wide font-semibold text-gray-500 mb-1",
                                    children: "Configura\xe7\xe3o"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "control",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "text-base text-gray-700 font-medium",
                                        children: offerProposal.compound?.name || "N/A"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "columns is-mobile",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "column is-6",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "field",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                className: "label text-xs uppercase tracking-wide font-semibold text-gray-500 mb-1",
                                                children: "Valor (s/ IVA)"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "control",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: "title is-5 text-blue-600 font-bold",
                                                    children: [
                                                        totalWithoutVat.toFixed(2),
                                                        " \u20AC"
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "column is-6",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "field",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                className: "label text-xs uppercase tracking-wide font-semibold text-gray-500 mb-1",
                                                children: "Valor (c/ IVA)"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "control",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: "title is-5 text-blue-800 font-bold",
                                                    children: [
                                                        totalValue.toFixed(2),
                                                        " \u20AC"
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $726defbc0778299a$export$2e2bcd8739ae039 = $726defbc0778299a$var$AcceptOfferConfirmation;


function $ea3aad6bc2f33b3b$export$df5c6cccb198f23(status) {
    if ([
        "accepted"
    ].includes(status)) return "text-green-600";
    if ([
        "requested"
    ].includes(status)) return "text-purple-600";
    if ([
        "in_progress",
        "draft"
    ].includes(status)) return "text-blue-600";
    if ([
        "cancelled",
        "completed",
        "expired",
        "deleted",
        "archived"
    ].includes(status)) return "text-gray-600";
    if ([
        "pending"
    ].includes(status)) return "text-orange-600";
    if (status === "rejected") return "text-red-600";
    return "text-yellow-600";
}
const $ea3aad6bc2f33b3b$export$5ec402b7fcf74398 = (status)=>{
    switch(status.toLowerCase()){
        case "requested":
            return "Solicitado pelo cliente";
        case "in_progress":
        case "draft":
            return "Em progresso";
        case "sent":
            return "Enviado para o cliente";
        case "expired":
            return "Expirado";
        case "cancelled":
            return "Cancelado";
        case "accepted":
            return "Aceite pelo cliente";
        case "pending":
            return "Encomenda - Pendente";
        case "confirmed":
            return "Encomenda - Confirmada";
        case "rejected":
            return "Encomenda - Rejeitada";
        case "shipped":
            return "Encomenda - Enviada";
        case "completed":
            return "Conclu\xeddo";
        case "archived":
            return "Arquivado";
        default:
            return status;
    }
};





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $b285ef0f6f9bf8bf$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
            key: "1nclc0"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "3",
            key: "1v7zrd"
        }
    ]
];
const $b285ef0f6f9bf8bf$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("eye", $b285ef0f6f9bf8bf$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $056e74b7b26d3329$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49",
            key: "ct8e1f"
        }
    ],
    [
        "path",
        {
            d: "M14.084 14.158a3 3 0 0 1-4.242-4.242",
            key: "151rxh"
        }
    ],
    [
        "path",
        {
            d: "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143",
            key: "13bj9a"
        }
    ],
    [
        "path",
        {
            d: "m2 2 20 20",
            key: "1ooewy"
        }
    ]
];
const $056e74b7b26d3329$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("eye-off", $056e74b7b26d3329$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $dbde4c3396582d11$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ],
    [
        "path",
        {
            d: "M12 5v14",
            key: "s699le"
        }
    ]
];
const $dbde4c3396582d11$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("plus", $dbde4c3396582d11$export$3efd853dbb351e94);



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

const $197508b61030f555$var$AddNoteModal = ({ isOpen: isOpen, onClose: onClose, onSubmit: onSubmit, orderId: orderId, entityType: entityType = "order", showVisibilityOption: showVisibilityOption = true })=>{
    const [content, setContent] = (0, $acw62.useState)("");
    const [visibleToReseller, setVisibleToReseller] = (0, $acw62.useState)(false);
    const [isSubmitting, setIsSubmitting] = (0, $acw62.useState)(false);
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (!content.trim()) return;
        setIsSubmitting(true);
        try {
            await onSubmit(content, visibleToReseller);
            setContent("");
            setVisibleToReseller(false);
            onClose();
        } catch (error) {
            console.error("Error adding note:", error);
        } finally{
            setIsSubmitting(false);
        }
    };
    const handleClose = ()=>{
        setContent("");
        setVisibleToReseller(false);
        onClose();
    };
    if (!isOpen) return null;
    const entityLabel = entityType === "order" ? "Encomenda" : "Proposta";
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "modal is-active",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "modal-background",
                onClick: handleClose
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).div, {
                initial: {
                    opacity: 0,
                    scale: 0.9
                },
                animate: {
                    opacity: 1,
                    scale: 1
                },
                exit: {
                    opacity: 0,
                    scale: 0.9
                },
                className: "modal-card",
                style: {
                    maxWidth: "600px"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("header", {
                        className: "modal-card-head",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "modal-card-title",
                                children: [
                                    "Adicionar Nota \xe0 ",
                                    entityLabel,
                                    " #",
                                    orderId
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "delete",
                                "aria-label": "close",
                                onClick: handleClose,
                                type: "button"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
                        className: "modal-card-body",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "field",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                            className: "label",
                                            children: [
                                                "Nota ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "has-text-danger",
                                                    children: "*"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "control",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                className: "textarea",
                                                placeholder: "Escreva a sua nota aqui...",
                                                value: content,
                                                onChange: (e)=>setContent(e.target.value),
                                                rows: 6,
                                                required: true,
                                                disabled: isSubmitting
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "help",
                                            children: "Campo obrigat\xf3rio"
                                        })
                                    ]
                                }),
                                showVisibilityOption && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "field",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "control",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                className: "checkbox",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "checkbox",
                                                        checked: visibleToReseller,
                                                        onChange: (e)=>setVisibleToReseller(e.target.checked),
                                                        disabled: isSubmitting
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "ml-2",
                                                        children: "Vis\xedvel para o revendedor"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "help",
                                            children: "Se marcado, o revendedor poder\xe1 ver esta nota"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("footer", {
                        className: "modal-card-foot",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).button, {
                                whileHover: {
                                    scale: 1.05
                                },
                                whileTap: {
                                    scale: 0.95
                                },
                                className: "button is-primary",
                                onClick: handleSubmit,
                                disabled: !content.trim() || isSubmitting,
                                type: "button",
                                children: isSubmitting ? "A adicionar..." : "Adicionar Nota"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "button",
                                onClick: handleClose,
                                disabled: isSubmitting,
                                type: "button",
                                children: "Fechar"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $197508b61030f555$export$2e2bcd8739ae039 = $197508b61030f555$var$AddNoteModal;




const $7d53f4121435a41a$var$NotesSection = ({ entityId: entityId, entityType: entityType, showVisibilityOption: showVisibilityOption = true })=>{
    const [isAddNoteModalOpen, setIsAddNoteModalOpen] = (0, $acw62.useState)(false);
    const [notes, setNotes] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    // Fetch notes from the new API
    (0, $acw62.useEffect)(()=>{
        const fetchNotes = async ()=>{
            if (!entityId) return; // Ensure entityId is valid
            try {
                setLoading(true);
                const params = entityType === "offer" ? {
                    offerId: entityId
                } : {
                    orderId: entityId
                };
                const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).NOTES, {
                    params: params
                });
                setNotes(response.data);
            } catch (error) {
                console.error("Error fetching notes:", error);
            } finally{
                setLoading(false);
            }
        };
        fetchNotes();
    }, [
        entityId,
        entityType
    ]);
    const handleAddNote = async (content, visibleToReseller)=>{
        try {
            const payload = {
                content: content,
                visible_to_reseller: visibleToReseller,
                ...entityType === "offer" ? {
                    offer_id: entityId
                } : {
                    order_id: entityId
                }
            };
            const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).post((0, $cd93687958c8007e$export$bfe19bc25132bb7c).NOTES, payload);
            setNotes([
                response.data,
                ...notes
            ]); // Add new note to the top
            setIsAddNoteModalOpen(false);
        } catch (error) {
            console.error("Error adding note:", error);
            alert("Failed to add note. Please try again.");
        }
    };
    const getStatusBadgeClass = (status)=>{
        if (!status) return "is-light";
        switch(status.toUpperCase()){
            case "PENDING":
                return "is-warning";
            case "CONFIRMED":
                return "is-info";
            case "REJECTED":
                return "is-danger";
            case "CANCELLED":
                return "is-dark";
            case "SHIPPED":
                return "is-link";
            case "COMPLETED":
                return "is-success";
            default:
                return "is-light";
        }
    };
    const entityLabel = entityType === "order" ? "Encomenda" : "Proposta";
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "notes-section",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "level mb-4",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "level-left",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "level-item",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                className: "title is-4",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ecb8e5bcb990e28a$export$2e2bcd8739ae039), {
                                        className: "icon is-small mr-2 inline"
                                    }),
                                    "Notas da ",
                                    entityLabel
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "level-right",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "level-item",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).button, {
                                whileHover: {
                                    scale: 1.05
                                },
                                whileTap: {
                                    scale: 0.95
                                },
                                className: "button is-primary",
                                type: "button",
                                onClick: ()=>setIsAddNoteModalOpen(true),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                        className: "icon is-small mr-1"
                                    }),
                                    "Adicionar Nota"
                                ]
                            })
                        })
                    })
                ]
            }),
            notes.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "notification is-light",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                    className: "has-text-centered",
                    children: [
                        "Nenhuma nota registada para esta ",
                        entityLabel.toLowerCase(),
                        "."
                    ]
                })
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "notes-list",
                children: notes.map((note, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "box mb-3",
                        style: {
                            borderLeft: note.offer_id && note.order_id ? "4px solid #3273dc" : note.offer_id ? "4px solid #48c774" : "4px solid #ffdd57"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "level mb-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "level-left",
                                        children: [
                                            note.status && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "level-item",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: `tag ${getStatusBadgeClass(note.status)}`,
                                                    children: note.status
                                                })
                                            }),
                                            showVisibilityOption && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "level-item",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "tag is-light",
                                                    children: note.visible_to_reseller ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039), {
                                                                className: "icon is-small mr-1",
                                                                size: 14
                                                            }),
                                                            "Vis\xedvel ao revendedor"
                                                        ]
                                                    }) : note.offer_id ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039), {
                                                                className: "icon is-small mr-1",
                                                                size: 14
                                                            }),
                                                            "Nota do vendedor"
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $056e74b7b26d3329$export$2e2bcd8739ae039), {
                                                                className: "icon is-small mr-1",
                                                                size: 14
                                                            }),
                                                            "Apenas interno"
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "level-right",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "level-item",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                                className: "has-text-grey",
                                                children: new Date(note.created_at).toLocaleString("pt-PT")
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "content",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    style: {
                                        whiteSpace: "pre-wrap"
                                    },
                                    children: note.content
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "has-text-grey is-size-7",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                        children: "Por:"
                                    }),
                                    " ",
                                    note.created_by
                                ]
                            })
                        ]
                    }, index))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $197508b61030f555$export$2e2bcd8739ae039), {
                isOpen: isAddNoteModalOpen,
                onClose: ()=>setIsAddNoteModalOpen(false),
                onSubmit: handleAddNote,
                showVisibilityOption: showVisibilityOption
            })
        ]
    });
};
var $7d53f4121435a41a$export$2e2bcd8739ae039 = $7d53f4121435a41a$var$NotesSection;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

const $3284ba32c053e053$export$2bb537800c1f1679 = [
    {
        value: "reference",
        label: "Refer\xeancia"
    },
    {
        value: "stock",
        label: "Stock"
    },
    {
        value: "cost_1",
        label: "Custo IAPC"
    },
    {
        value: "cost_2",
        label: "Custo 2"
    },
    {
        value: "our_proposal",
        label: "Nossa proposta"
    },
    {
        value: "local_rev3",
        label: "REV3 IAPC"
    },
    {
        value: "rev3",
        label: "REV3"
    },
    {
        value: "pvp_without_vat",
        label: "PVP sem IVA"
    },
    {
        value: "show_individual_pvp_without_vat",
        label: "Mostrar PVP sem IVA individual"
    }
];
const $3284ba32c053e053$export$a9d293d891dcecb1 = ()=>$3284ba32c053e053$export$2bb537800c1f1679.filter(({ value: value })=>value !== "show_individual_pvp_without_vat").map(({ value: value })=>value);
const $3284ba32c053e053$var$OfferExcelExportModal = ({ open: open, exporting: exporting, onClose: onClose, onExport: onExport })=>{
    const [selectedFields, setSelectedFields] = (0, $acw62.useState)($3284ba32c053e053$export$a9d293d891dcecb1);
    (0, $acw62.useEffect)(()=>{
        if (open) setSelectedFields($3284ba32c053e053$export$a9d293d891dcecb1());
    }, [
        open
    ]);
    if (!open) return null;
    const toggleField = (field)=>{
        setSelectedFields((current)=>current.includes(field) ? current.filter((value)=>value !== field) : [
                ...current,
                field
            ]);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67ac64808127e67c$export$2e2bcd8739ae039), {
        title: "Exportar proposta para Excel",
        state: "confirm",
        onClose: onClose,
        footer: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex justify-end gap-2 p-4",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    className: "button",
                    onClick: onClose,
                    disabled: exporting,
                    children: "Cancelar"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    className: "button is-success",
                    onClick: ()=>onExport(selectedFields),
                    disabled: exporting,
                    children: exporting ? "A exportar..." : "Exportar Excel"
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "p-6",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "mb-4",
                    children: "Selecione os campos internos adicionais a incluir no ficheiro."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "space-y-3",
                    children: $3284ba32c053e053$export$2bb537800c1f1679.map((field)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                            className: "checkbox block",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    type: "checkbox",
                                    checked: selectedFields.includes(field.value),
                                    onChange: ()=>toggleField(field.value),
                                    disabled: exporting
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "ml-2",
                                    children: field.label
                                })
                            ]
                        }, field.value))
                })
            ]
        })
    });
};
var $3284ba32c053e053$export$2e2bcd8739ae039 = $3284ba32c053e053$var$OfferExcelExportModal;


const $cf6f80a8b90b7901$var$ManageOffer = ({ offer: offer, initialUpdatedOffer: initialUpdatedOffer })=>{
    const navigate = (0, $585f8bce88e531c1$export$9770f232ac06a008)();
    const { userSettings: userSettings, setUserSettings: setUserSettings, systemError: systemError, setSystemError: setSystemError, tasks: tasks, removeTask: removeTask, loading: loading, setLoading: setLoading, error: error, setError: setError, success: success, setSuccess: setSuccess, modalScreen: modalScreen, setModalScreen: setModalScreen, page: page, setPage: setPage, isDevMode: isDevMode, modalRef: modalRef } = (0, $a55f2a94cd420149$export$c50e37a2f0a2b064)();
    const { addTask: addTask } = (0, $a55f2a94cd420149$export$c50e37a2f0a2b064)();
    const [offerProposal, setOfferProposal] = (0, $acw62.useState)(offer);
    const [updatedOffer, setUpdatedOffer] = (0, $acw62.useState)(initialUpdatedOffer ?? false);
    const [tabSelected, setTabSelected] = (0, $acw62.useState)(!offer.status || offer.status == "in_progress" ? "client" : "components");
    const [showCancelOfferModal, setShowCancelOfferModal] = (0, $acw62.useState)(false);
    const [showConfirmOrderModal, setShowConfirmOrderModal] = (0, $acw62.useState)(false);
    const [showAcceptOfferModal, setShowAcceptOfferModal] = (0, $acw62.useState)(false);
    const [showExcelExportModal, setShowExcelExportModal] = (0, $acw62.useState)(false);
    const [excelExporting, setExcelExporting] = (0, $acw62.useState)(false);
    const [lastOfferClient, setLastOfferClient] = (0, $acw62.useState)(null);
    const [showShippingAddress, setShowShippingAddress] = (0, $acw62.useState)(!offer.client.use_personal_as_shipping);
    const [showBillingAddress, setShowBillingAddress] = (0, $acw62.useState)(!offer.client.use_personal_as_billing);
    const [offerPreviewHtml, setOfferPreviewHtml] = (0, $acw62.useState)("");
    const updateClientField = (field, value)=>{
        setUpdatedOffer(true);
        setOfferProposal((prev)=>({
                ...prev,
                client: {
                    ...prev.client,
                    [field]: value
                }
            }));
    };
    const allowManageOffer = (0, $acw62.useCallback)(()=>{
        return !offer.erp_client_id || offer.erp_client_id == userSettings?.client?.id;
    }, [
        offer.erp_client_id,
        userSettings?.client?.id
    ]);
    (0, $acw62.useEffect)(()=>{
        const lastOfferClientRaw = localStorage.getItem("lastOfferClient");
        if (lastOfferClientRaw) {
            const lastOfferClientParsed = JSON.parse(lastOfferClientRaw);
            setLastOfferClient(lastOfferClientParsed);
        }
    }, [
        localStorage
    ]);
    const fetchHistory = ()=>{
        if (!offerProposal.id || !(userSettings?.isMainAccount() || userSettings?.isAdmin())) return;
        setLoading(true);
        setError(null);
        setSuccess(null);
        (0, $bac44633733ff026$export$2e2bcd8739ae039).get(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).OFFERS}/${offerProposal.id}/history`).then((res)=>{
            console.log("Hist\xf3rico carregado com sucesso!", res.data);
            setOfferProposal((prev)=>({
                    ...prev,
                    history: res.data || []
                }));
        }).catch(()=>{
            console.warn("Erro ao carregar hist\xf3rico");
            setError("Erro ao carregar hist\xf3rico. Tente novamente.");
        }).finally(()=>setLoading(false));
    };
    const fetchOffer = (offerId, resetNotifications)=>{
        if (resetNotifications) {
            setError(null);
            setSuccess(null);
        }
        setLoading(true);
        (0, $bac44633733ff026$export$2e2bcd8739ae039).get(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).OFFERS}/${offerId}`).then((res)=>{
            console.log("Proposta carregada com sucesso!", res.data);
            setOfferProposal(res.data);
            setUpdatedOffer(false);
        }).catch(()=>{
            console.warn("Erro ao carregar proposta");
            setError("Erro ao carregar proposta. Tente novamente.");
        }).finally(()=>setLoading(false));
    };
    const saveClientOnLocalStorage = (offerProposal)=>{
        const client = offerProposal.client;
        if (client.id?.trim() !== "" || client.name.trim() !== "" || client.email?.trim() !== "" || client.phone?.trim() !== "" || client.vat?.trim() !== "" || client.address?.trim() !== "" || client.city?.trim() !== "" || client.zip_code?.trim()) {
            localStorage.setItem("lastOfferClient", JSON.stringify(client));
            setLastOfferClient(client);
        }
    };
    const generateOfferPreview = (0, $acw62.useCallback)(async ()=>{
        try {
            const response = offerProposal.id && !updatedOffer ? await (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).OFFERS + "/" + offerProposal.id + "/_actions/review") : await (0, $bac44633733ff026$export$2e2bcd8739ae039).post((0, $cd93687958c8007e$export$bfe19bc25132bb7c).OFFERS + "/_actions/preview", offerProposal);
            console.log("Preview gerado com sucesso!", response.data);
            return response.data;
        } catch (error) {
            console.warn("Erro ao gerar preview:", error);
            setError("Erro ao gerar preview. Tente novamente.");
            return "";
        }
    }, [
        offerProposal,
        setError,
        allowManageOffer
    ]);
    const handleCreateProposal = async (e)=>{
        e.preventDefault();
        setError(null);
        setSuccess(null);
        setLoading(true);
        (0, $bac44633733ff026$export$2e2bcd8739ae039).post((0, $cd93687958c8007e$export$bfe19bc25132bb7c).OFFERS + "/", {
            ...offerProposal,
            status: "in_progress"
        }).then((res)=>{
            console.log("Proposta criada com sucesso!", res.data);
            setOfferProposal(res.data);
            saveClientOnLocalStorage(res.data);
            setUpdatedOffer(false);
            setTabSelected("components");
            setSuccess("Proposta criada com sucesso!");
        }).catch(()=>{
            console.warn("Erro ao criar proposta");
            setError("Erro ao criar proposta. Tente novamente.");
        }).finally(()=>setLoading(false));
    };
    const handleUpdateProposal = async (e)=>{
        e.preventDefault();
        if (!offerProposal.id) return;
        setError(null);
        setSuccess(null);
        setLoading(true);
        (0, $bac44633733ff026$export$2e2bcd8739ae039).put((0, $cd93687958c8007e$export$bfe19bc25132bb7c).OFFERS + "/" + offerProposal.id, offerProposal).then((res)=>{
            console.log("Proposta atualizada com sucesso!", res.data);
            setOfferProposal(res.data);
            saveClientOnLocalStorage(res.data);
            setUpdatedOffer(false);
            setSuccess("Proposta atualizada com sucesso!");
        }).catch((err)=>{
            console.warn("Erro ao atualizar proposta:", err);
            setError("Erro ao atualizar proposta. Tente novamente.");
        }).finally(()=>setLoading(null));
    };
    const handlePrintPropose = (e)=>{
        e.preventDefault();
        if (!offerProposal.id) return;
        setLoading(true);
        setError(null);
        setSuccess(null);
        (0, $bac44633733ff026$export$2e2bcd8739ae039).post((0, $cd93687958c8007e$export$bfe19bc25132bb7c).OFFERS + "/" + offerProposal.id + "/_actions/print").then((response)=>{
            console.log("Proposta preparada para impress\xe3o!", response.data);
            setSuccess("Proposta preparada para impress\xe3o!");
            (0, $331fdff9ce862c26$export$2e2bcd8739ae039)(response.data, "Proposta");
        }).catch((error)=>{
            console.warn("Erro ao preparar proposta para impress\xe3o:", error);
            setError("Erro ao preparar proposta para impress\xe3o. Tente novamente.");
        }).finally(()=>{
            if (offerProposal.id) fetchOffer(offerProposal.id, false);
        });
    };
    const handleExportExcel = async (fields)=>{
        setExcelExporting(true);
        setLoading(true);
        setError(null);
        try {
            const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).post((0, $cd93687958c8007e$export$bfe19bc25132bb7c).OFFERS + "/_actions/export-excel", offerProposal, {
                responseType: "blob",
                params: {
                    internalFields: fields.join(",")
                }
            });
            const url = window.URL.createObjectURL(new Blob([
                response.data
            ]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `proposta_${offerProposal.external_id || offerProposal.compound.id}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
            setShowExcelExportModal(false);
        } catch (error) {
            console.warn("Erro ao exportar proposta para Excel:", error);
            setError(error.message || "Erro ao exportar proposta para Excel.");
        } finally{
            setExcelExporting(false);
            setLoading(null);
        }
    };
    const handleSendEmail = (e)=>{
        e.preventDefault();
        if (!offerProposal) return;
        setError(null);
        setSuccess(null);
        setLoading(true);
        (0, $bac44633733ff026$export$2e2bcd8739ae039).post((0, $cd93687958c8007e$export$bfe19bc25132bb7c).OFFERS + "/" + offerProposal.id + "/_actions/send-email", {
            destination: offerProposal.client.email
        }).then((response)=>{
            console.log("Email enviado com sucesso!", response.data);
            setSuccess("Email enviado com sucesso!");
        }).catch((error)=>{
            setError(`Error a enviar email ${error.message}. Tente novamente.`);
            console.warn("Erro ao enviar email:", error);
        }).finally(()=>{
            setLoading(null);
        });
    };
    const handleNewOfferProposal = (e)=>{
        e.preventDefault();
        if (!offerProposal) return;
        addTask({
            name: "Alterar proposta",
            tip: {
                pc: "Alterar configura\xe7\xe3o dos componentes do PC ou Pre\xe7o.",
                store: "Alterar para outro PC pr\xe9-configurado da loja.",
                comparar: "Alterar para outro PC pr\xe9-configurado."
            },
            id: "offer::change-" + offerProposal.id,
            taskType: "offer::change",
            allowedModules: [
                "pc",
                "store",
                "comparar"
            ],
            getContext: ()=>{
                return {
                    offerProposal: offerProposal,
                    setOfferProposal: setOfferProposal
                };
            },
            onSwitch: ()=>{
                console.log("Abrindo modal para gerir proposta:", offerProposal.id);
                setModalScreen({
                    state: "edit",
                    title: `Gerir Proposta: #${offerProposal.external_id}`,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($cf6f80a8b90b7901$var$ManageOffer, {
                        offer: offerProposal
                    }),
                    onClose: ()=>{
                        setUpdatedOffer(false);
                        navigate("/offers");
                    }
                });
            },
            onAdd: ()=>{
                navigate("/pc/" + offerProposal.compound.id);
                setModalScreen(null);
            }
        });
    };
    const handleConfirmOrder = ()=>{
        setShowConfirmOrderModal(false);
        confirmAcceptOffer();
    };
    const handleAcceptOffer = (e)=>{
        e.preventDefault();
        if (!offerProposal) return;
        if (isHandlingOfferDisabled()) {
            setSuccess(null);
            setError("N\xe3o pode aceitar esta proposta. Verifique os dados do cliente.");
            return;
        }
        // Show confirmation modal instead of directly accepting
        setShowAcceptOfferModal(true);
    };
    const confirmAcceptOffer = ()=>{
        if (!offerProposal) return;
        setLoading(true);
        setError(null);
        setSuccess(null);
        (0, $bac44633733ff026$export$2e2bcd8739ae039).post((0, $cd93687958c8007e$export$bfe19bc25132bb7c).OFFERS + "/" + offerProposal.id + "/_actions/accept", {}).then((response)=>{
            console.log("Encomenda criada com sucesso!", response.data);
            setOfferProposal(response.data);
            setUpdatedOffer(false);
            setTabSelected("order");
            setSuccess("Encomenda criada com sucesso!");
            if (userSettings?.isAdmin() || userSettings?.isCommercial()) {
                navigate("/orders");
                modalRef?.current?.close();
            }
        }).catch((error)=>{
            console.warn("Erro ao aceitar a proposta:", error);
            setError("Erro ao aceitar a proposta. Tente novamente.");
        }).finally(()=>{
            setLoading(null);
        });
    };
    const handleCancelOffer = async (cancelReason)=>{
        if (!offerProposal.id) return;
        setError(null);
        setSuccess(null);
        setLoading(true);
        try {
            const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).post((0, $cd93687958c8007e$export$bfe19bc25132bb7c).OFFERS + "/" + offerProposal.id + "/_actions/cancel", cancelReason);
            console.log("Proposta cancelada com sucesso!", res.data);
            setOfferProposal(res.data);
            saveClientOnLocalStorage(res.data);
            setUpdatedOffer(false);
            setShowCancelOfferModal(false);
            setSuccess("Proposta cancelada com sucesso!");
        } catch (error) {
            console.warn("Erro ao cancelar proposta:", error);
            setError("Erro ao cancelar proposta. Tente novamente.");
        } finally{
            setLoading(null);
        }
    };
    const searchClientById = async (clientId)=>{
        if (!clientId || clientId.trim() === "") return;
        setLoading(true);
        setError(null);
        try {
            const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).USERS + `_actions/get_erp_client?client_id=${clientId}`);
            if (!response.data || !response.data.id) {
                setOfferProposal({
                    ...offerProposal,
                    match_client: false
                });
                return;
            }
            if (offerProposal.client_type == "end_customer") setSuccess("O cliente foi actualizado para revendedor.");
            setOfferProposal({
                ...offerProposal,
                match_client: true,
                client_type: "reseller",
                client: {
                    ...offerProposal.client,
                    id: offerProposal.client.id || response.data.id,
                    name: offerProposal.client.name || response.data.name,
                    email: offerProposal.client.email || response.data.email,
                    phone: offerProposal.client.phone || response.data.phone,
                    vat: offerProposal.client.vat || response.data.vat,
                    address: offerProposal.client.address || response.data.address,
                    city: offerProposal.client.city || response.data.city,
                    zip_code: offerProposal.client.zip_code || response.data.zip_code
                }
            });
        } catch (error) {
            console.warn("Erro ao buscar cliente:", error);
        } finally{
            setLoading(false);
        }
    };
    const handleRequestCancelOffer = (e)=>{
        e.preventDefault();
        setShowCancelOfferModal(true);
    };
    const isValidEmail = ()=>{
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+/;
        return re.test(String(offerProposal.client.email).toLowerCase());
    };
    const isValidPhone = ()=>{
        if (offerProposal.client?.phone?.startsWith("+351") || offerProposal.client?.phone?.startsWith("00351") || !offerProposal.client?.phone?.startsWith("+")) {
            const phoneWithoutCountryCode = offerProposal.client?.phone?.replace(/^(\+|00)351/, "").trim() ?? "";
            const phoneWithoutCountryCodeDigits = phoneWithoutCountryCode.replace(/[\s\-()]/g, ""); // replace whitespace, dashes, and parentheses
            if (phoneWithoutCountryCodeDigits.length !== 9) return false; // Must be exactly 9 digits
            const re = /^((91|92|93|96)\d{7}|(2)\d{8})$/;
            return re.test(phoneWithoutCountryCodeDigits);
        }
        const re = /^\+?[0-9\s\-()]+$/; // Basic phone number validation
        return re.test(String(offerProposal.client.phone).toLowerCase());
    };
    const isUpdateOfferEnabled = ()=>{
        if (!updatedOffer) return false;
        if (offerProposal.status == "requested") return false;
        return !isClientValid();
    };
    const isClientValid = ()=>{
        return (userSettings?.isReseller() || offerProposal.client.id?.trim() != "") && (!offerProposal.client?.email || isValidEmail()) && (!offerProposal.client?.phone || isValidPhone());
    };
    const isEmptyClient = (client)=>{
        return !client.id?.trim() && !client.name.trim() && !client.email?.trim() && !client.phone?.trim() && !client.vat?.trim() && !client.address?.trim() && !client.city?.trim() && !client.zip_code?.trim();
    };
    const isHandlingOfferDisabled = (0, $acw62.useCallback)(()=>{
        return ((userSettings?.isCommercial() || userSettings?.isAdmin()) && (offerProposal.status === "draft" || offerProposal.status === "requested" || !offerProposal.id || isEmptyClient(offerProposal.client) || !isClientValid())) ?? false;
    }, [
        userSettings,
        offerProposal.status,
        offerProposal.id,
        offerProposal.client
    ]);
    (0, $acw62.useEffect)(()=>{
        if (tasks.length > 0) {
            const changeOffersTasks = tasks.filter((t)=>t.taskType === "offer::change");
            if (changeOffersTasks.length > 0) changeOffersTasks.map((t)=>{
                console.log("automatically removing task:", t.id);
                removeTask(t.id);
            });
        }
    }, [
        tasks,
        offer?.id
    ]);
    (0, $acw62.useEffect)(()=>{
        generateOfferPreview().then((html)=>setOfferPreviewHtml(html));
    }, [
        generateOfferPreview
    ]);
    /**
  useEffect(() => {
    if (!offerProposal.id) return;
    const intervalId = setInterval(() => {
      fetchHistory();
    }, 2000);
    return () => clearInterval(intervalId);
  }, [offerProposal.id]);
  **/ const calculatedFinancials = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (!offerProposal?.compound) return null;
        const getWithoutVat = (price)=>{
            if (price.without_vat && price.without_vat > 0) return price.without_vat;
            const vatRate = price.vat_rate !== undefined && price.vat_rate !== null ? price.vat_rate : 23;
            return price.value / (1 + vatRate / 100);
        };
        let totalDiffs = {
            resell: 0,
            without_vat: 0,
            value: 0
        };
        const componentRows = Object.entries(offerProposal.compound.components || {}).map(([type, components])=>{
            // Find selected component
            let selectedComp = components.find((c)=>{
                if (offerProposal.compound.selected_components && offerProposal.compound.selected_components[type]) return c.id === offerProposal.compound.selected_components[type].id;
                return c.selected;
            });
            // Find base component
            const baseComp = components.find((c)=>c.baseComponent);
            if (!selectedComp) return null;
            if (selectedComp.name === "NENHUMA OP\xc7\xc3O SELECIONADA") return null;
            const isBase = selectedComp.baseComponent || selectedComp.id === baseComp?.id;
            let diff = {
                resell: 0,
                without_vat: 0,
                value: 0
            };
            if (!isBase) {
                const selectedWithoutVat = getWithoutVat(selectedComp.price);
                const baseWithoutVat = baseComp ? getWithoutVat(baseComp.price) : 0;
                diff.resell = (selectedComp.price.resell || 0) - (baseComp?.price.resell || 0);
                diff.without_vat = selectedWithoutVat - baseWithoutVat;
                diff.value = (selectedComp.price.value || 0) - (baseComp?.price.value || 0);
                totalDiffs.resell += diff.resell;
                totalDiffs.without_vat += diff.without_vat;
                totalDiffs.value += diff.value;
            }
            return {
                type: type,
                name: selectedComp.name,
                isBase: isBase,
                diff: diff
            };
        });
        // Derived Base Price = Total Price - Total Diffs
        const totalWithoutVat = getWithoutVat(offerProposal.compound.price);
        const derivedBasePrice = {
            resell: (offerProposal.compound.price.resell || 0) - totalDiffs.resell,
            without_vat: totalWithoutVat - totalDiffs.without_vat,
            value: (offerProposal.compound.price.value || 0) - totalDiffs.value
        };
        return {
            derivedBasePrice: derivedBasePrice,
            componentRows: componentRows
        };
    }, [
        offerProposal
    ]);
    const icons = {
        Cpu: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e8859e855a5dc92a$export$2e2bcd8739ae039), {
            className: "inline mr-1"
        }),
        Gpu: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e567cef82db71d0e$export$2e2bcd8739ae039), {
            className: "inline mr-1"
        }),
        CircuitBoard: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d1c159efbf8295ba$export$2e2bcd8739ae039), {
            className: "inline mr-1"
        }),
        MemoryStick: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $305d6e4c68cac6f3$export$2e2bcd8739ae039), {
            className: "inline mr-1"
        }),
        HardDrive: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4e6e7c8f114d04e1$export$2e2bcd8739ae039), {
            className: "inline mr-1"
        }),
        Fan: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $554c4787c44ee537$export$2e2bcd8739ae039), {
            className: "inline mr-1"
        }),
        PcCase: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cf972fdbc52e6ed1$export$2e2bcd8739ae039), {
            className: "inline mr-1"
        }),
        Wifi: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b144e577f231bbf4$export$2e2bcd8739ae039), {
            className: "inline mr-1"
        }),
        Monitor: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f633c0fb63f4b508$export$2e2bcd8739ae039), {
            className: "inline mr-1"
        }),
        Keyboard: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ebf99d6f8a58620$export$2e2bcd8739ae039), {
            className: "inline mr-1"
        }),
        Mouse: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $776c757559abfae2$export$2e2bcd8739ae039), {
            className: "inline mr-1"
        }),
        Power: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bfe54799d1557409$export$2e2bcd8739ae039), {
            className: "inline mr-1"
        }),
        Rocket: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10da79d8875e7dff$export$2e2bcd8739ae039), {
            className: "inline mr-1"
        })
    };
    if (!offer.compound) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "error-container",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
            className: "title is-4",
            children: "Configura\xe7\xe3o de PC n\xe3o encontrada."
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "overflow-y-auto",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("form", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "container box min-h-[65vh]",
                            children: [
                                !allowManageOffer() && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "notification is-warning",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        children: "N\xe3o tem permiss\xe3o para gerir esta proposta. Pode apenas visualizar."
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "proposal-review mb-10",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "title is-4",
                                            children: "Proposta de Configura\xe7\xe3o de PC"
                                        }),
                                        userSettings?.isOperatorUser() && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "subtitle is-6",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                    children: "Configura\xe7\xe3o:"
                                                }),
                                                " ",
                                                offerProposal.compound.name,
                                                " ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                    children: "Pre\xe7o Total:"
                                                }),
                                                " ",
                                                offerProposal.client_type === "end_customer" ? offerProposal.compound.price.value.toFixed(2) : (offerProposal.compound.price.resell ?? 0).toFixed(2),
                                                " ",
                                                "\u20AC ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                    children: "Estado:"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: `m-2 p-1 ${(0, $ea3aad6bc2f33b3b$export$df5c6cccb198f23)(offer.status)}`,
                                                    children: (0, $ea3aad6bc2f33b3b$export$5ec402b7fcf74398)(offerProposal.status)
                                                }),
                                                offerProposal.applied_campaign_name && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                            children: "Campanha:"
                                                        }),
                                                        " ",
                                                        offerProposal.applied_campaign_name
                                                    ]
                                                })
                                            ]
                                        }),
                                        userSettings?.isOperatorUser() && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "subtitle is-6 visibility-field flex items-center",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                    children: "Visibilidade:"
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                    id: "visibility",
                                                    className: "select",
                                                    value: offerProposal.visibility ?? "internal",
                                                    onChange: (e)=>{
                                                        setUpdatedOffer(true);
                                                        setOfferProposal({
                                                            ...offerProposal,
                                                            visibility: e.target.value
                                                        });
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: "public",
                                                            disabled: true,
                                                            children: "P\xfablica"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: "private",
                                                            children: "Privada"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: "internal",
                                                            children: "Interna"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: `m-2 p-1 text-shadow-slate-700 text-sm`,
                                                    children: offerProposal.visibility === "public" ? "Vis\xedvel para todos os utilizadores" : offerProposal.visibility === "private" ? "Vis\xedvel apenas para o utilizador que criou ou alterou a proposta" : "Vis\xedvel apenas para utilizadores internos"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "tabs is-boxed",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                        children: [
                                            (userSettings?.isOperatorUser() || offerProposal.status !== "in_progress") && /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: tabSelected === "components" ? "is-active" : "",
                                                onClick: ()=>setTabSelected("components"),
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "icon is-small",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $514fc7cbbe3aa353$export$2e2bcd8739ae039), {
                                                                className: "inline mr-1"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: "Pre-visualizar"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: tabSelected === "client" ? "is-active" : "",
                                                onClick: ()=>setTabSelected("client"),
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "icon is-small",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0740549741641712$export$2e2bcd8739ae039), {
                                                                className: "inline mr-1"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: "Cliente"
                                                        })
                                                    ]
                                                })
                                            }),
                                            offerProposal.id && /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: tabSelected === "notes" ? "is-active" : "",
                                                onClick: ()=>setTabSelected("notes"),
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "icon is-small",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ecb8e5bcb990e28a$export$2e2bcd8739ae039), {
                                                                className: "inline mr-1"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: "Notas"
                                                        })
                                                    ]
                                                })
                                            }),
                                            (userSettings?.isAdmin() || userSettings?.isMainAccount()) && offerProposal.status !== "draft" && /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: tabSelected === "order" ? "is-active" : "",
                                                onClick: ()=>{
                                                    if (offerProposal.history?.length == 0) fetchHistory();
                                                    setTabSelected("order");
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "icon is-small",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ee6f13a46cf9100a$export$2e2bcd8739ae039), {
                                                                className: "inline mr-1"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: "Hist\xf3rico/Tracking"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: `content min-h-screen flex flex-col ${tabSelected !== "components" ? "is-hidden" : ""}`,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("iframe", {
                                        srcDoc: offerPreviewHtml,
                                        className: "w-full h-full",
                                        style: {
                                            flex: 1,
                                            width: "100%",
                                            height: "100%"
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: `content ${tabSelected !== "review" ? "is-hidden" : ""}`,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "box",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                className: "title is-5 mb-4",
                                                children: "Detalhe Financeiro dos Componentes"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "table-container",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                                                    className: "table is-fullwidth is-striped is-hoverable",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                        children: "Componente"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                        className: "has-text-right",
                                                                        children: "Custo (Revenda)"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                        className: "has-text-right",
                                                                        children: "Venda (s/ IVA)"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                        className: "has-text-right",
                                                                        children: "Venda (c/ IVA)"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                                            children: calculatedFinancials && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                                        className: "is-selected",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("strong", {
                                                                                    children: [
                                                                                        offerProposal.compound.name,
                                                                                        " (Base)"
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                                                className: "has-text-right",
                                                                                children: [
                                                                                    calculatedFinancials.derivedBasePrice.resell.toFixed(2),
                                                                                    " ",
                                                                                    "\u20AC"
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                                                className: "has-text-right",
                                                                                children: [
                                                                                    calculatedFinancials.derivedBasePrice.without_vat.toFixed(2),
                                                                                    " ",
                                                                                    "\u20AC"
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                                                className: "has-text-right",
                                                                                children: [
                                                                                    calculatedFinancials.derivedBasePrice.value.toFixed(2),
                                                                                    " ",
                                                                                    "\u20AC"
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    calculatedFinancials.componentRows.map((row)=>{
                                                                        if (!row) return null;
                                                                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                            className: "text-sm text-gray-500 block uppercase text-xs font-bold",
                                                                                            children: row.type
                                                                                        }),
                                                                                        row.name
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                                    className: "has-text-right",
                                                                                    children: row.isBase ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: "text-gray-500 text-xs",
                                                                                        children: "Inclu\xeddo"
                                                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                        children: [
                                                                                            row.diff.resell > 0 ? "+" : "",
                                                                                            row.diff.resell.toFixed(2),
                                                                                            " \u20AC"
                                                                                        ]
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                                    className: "has-text-right",
                                                                                    children: row.isBase ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: "text-gray-500 text-xs",
                                                                                        children: "Inclu\xeddo"
                                                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                        children: [
                                                                                            row.diff.without_vat > 0 ? "+" : "",
                                                                                            row.diff.without_vat.toFixed(2),
                                                                                            " \u20AC"
                                                                                        ]
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                                    className: "has-text-right",
                                                                                    children: row.isBase ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: "text-gray-500 text-xs",
                                                                                        children: "Inclu\xeddo"
                                                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                        children: [
                                                                                            row.diff.value > 0 ? "+" : "",
                                                                                            row.diff.value.toFixed(2),
                                                                                            " \u20AC"
                                                                                        ]
                                                                                    })
                                                                                })
                                                                            ]
                                                                        }, row.type);
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("tfoot", {
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                        children: "TOTAL"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("th", {
                                                                        className: "has-text-right",
                                                                        children: [
                                                                            (offerProposal.compound.price.resell || 0).toFixed(2),
                                                                            " ",
                                                                            "\u20AC"
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("th", {
                                                                        className: "has-text-right",
                                                                        children: [
                                                                            (offerProposal.compound.price.without_vat || 0).toFixed(2),
                                                                            " ",
                                                                            "\u20AC"
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("th", {
                                                                        className: "has-text-right",
                                                                        children: [
                                                                            (offerProposal.compound.price.value || 0).toFixed(2),
                                                                            " ",
                                                                            "\u20AC"
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: `content ${tabSelected !== "client" ? "is-hidden" : ""}`,
                                    children: [
                                        userSettings?.isOperatorUser() && lastOfferClient && isEmptyClient(offerProposal.client) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "notification is-info flex items-center justify-between",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    children: [
                                                        "\xdaltimo cliente utilizado:",
                                                        " ",
                                                        (userSettings?.isAdmin() || userSettings?.isCommercial()) && lastOfferClient.id && /*#__PURE__*/ (0, $ayMG0.jsxs)("strong", {
                                                            className: "mr-2",
                                                            children: [
                                                                "Cliente: ",
                                                                lastOfferClient.id
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                            className: "mr-2",
                                                            children: lastOfferClient.name
                                                        }),
                                                        lastOfferClient.vat && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            children: [
                                                                "NIF: (",
                                                                lastOfferClient.vat,
                                                                ")"
                                                            ]
                                                        }),
                                                        lastOfferClient.email && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            children: [
                                                                "Email: ",
                                                                lastOfferClient.email
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    className: "button is-small is-primary is-right",
                                                    onClick: (e)=>{
                                                        e.preventDefault();
                                                        setOfferProposal({
                                                            ...offerProposal,
                                                            client: lastOfferClient
                                                        });
                                                        setUpdatedOffer(true);
                                                    },
                                                    children: "Reutilizar Cliente"
                                                })
                                            ]
                                        }),
                                        (userSettings?.isCommercial() || userSettings?.isAdmin()) && !offerProposal.match_client && offerProposal.client.id && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "notification is-warning flex items-center justify-between",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                children: [
                                                    offerProposal.client_type === "reseller" && "O cliente n\xe3o foi encontrado. ",
                                                    "Por favor, verifique os dados e confirme que o cliente for inserido no sistema e \xe9 v\xe1lido."
                                                ]
                                            })
                                        }),
                                        (userSettings?.isCommercial() || userSettings?.isAdmin()) && offerProposal.id && !offerProposal.client.id && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "notification is-warning flex items-center justify-between",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: "O cliente ainda n\xe3o foi definido. Por favor, insira os dados do cliente para continuar."
                                            })
                                        }),
                                        (userSettings?.isCommercial() || userSettings?.isAdmin()) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "field is-horizontal",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "field-label is-normal",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        className: "label",
                                                        children: "Tipo"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "field-body",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "field",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "control is-expanded has-icons-left",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                        type: "radio",
                                                                        value: "end_customer",
                                                                        name: "client_type_end_customer",
                                                                        id: "client_type_end_customer",
                                                                        checked: offerProposal.client_type === "end_customer",
                                                                        onChange: (e)=>{
                                                                            setUpdatedOffer(true);
                                                                            setOfferProposal({
                                                                                ...offerProposal,
                                                                                client_type: e.target.value
                                                                            });
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                        className: "radio ml-2",
                                                                        htmlFor: "client_type_end_customer",
                                                                        children: "Cliente Final"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "field",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "control is-expanded has-icons-left",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                        type: "radio",
                                                                        value: "reseller",
                                                                        name: "client_type_reseller",
                                                                        id: "client_type_reseller",
                                                                        checked: offerProposal.client_type === "reseller",
                                                                        onChange: (e)=>{
                                                                            setUpdatedOffer(true);
                                                                            setOfferProposal({
                                                                                ...offerProposal,
                                                                                client_type: e.target.value
                                                                            });
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                        className: "radio ml-2",
                                                                        htmlFor: "client_type_reseller",
                                                                        children: "Revendedor"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "field is-horizontal",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "field-label is-normal",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        className: "label",
                                                        children: "Cliente"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "field-body",
                                                    children: [
                                                        (userSettings?.isCommercial() || userSettings?.isAdmin()) && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "field",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "control is-expanded has-icons-left",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                        className: "input",
                                                                        placeholder: "N\xfamero de Cliente",
                                                                        value: offerProposal.client.id ?? "",
                                                                        onChange: (e)=>updateClientField("id", e.target.value),
                                                                        onBlur: (e)=>{
                                                                            if (e.target.value) searchClientById(e.target.value.trim());
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "icon is-small is-left",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b798f41cb482ae86$export$2e2bcd8739ae039), {
                                                                            className: "inline mr-1"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "field",
                                                            style: {
                                                                width: "60%"
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "control is-expanded has-icons-left",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                        className: "input",
                                                                        type: "text",
                                                                        placeholder: "Nome do Cliente",
                                                                        value: offerProposal.client.name ?? "",
                                                                        onChange: (e)=>updateClientField("name", e.target.value)
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "icon is-small is-left",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0740549741641712$export$2e2bcd8739ae039), {
                                                                            className: "inline mr-1"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "field",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "control is-expanded has-icons-left",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                        className: "input",
                                                                        type: "text",
                                                                        placeholder: "NIF do Cliente",
                                                                        value: offerProposal.client.vat ?? "",
                                                                        onChange: (e)=>updateClientField("vat", e.target.value)
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "icon is-small is-left",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6bfe12c41179c4f1$export$2e2bcd8739ae039), {
                                                                            className: "inline mr-1"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "field is-horizontal",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "field-label is-normal",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        className: "label",
                                                        children: "Morada"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "field-body",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "field",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            className: "control is-expanded",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                                rows: 3,
                                                                className: "textarea",
                                                                placeholder: "Morada do Cliente",
                                                                value: offerProposal.client.address ?? "",
                                                                onChange: (e)=>updateClientField("address", e.target.value)
                                                            })
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "field is-horizontal",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "field-label"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "field-body",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "field",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "control is-expanded",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                    className: "input",
                                                                    placeholder: "Codigo Postal",
                                                                    value: offerProposal.client.zip_code ?? "",
                                                                    onChange: (e)=>updateClientField("zip_code", e.target.value)
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "field",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "control is-expanded",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                    className: "input",
                                                                    type: "text",
                                                                    placeholder: "Cidade",
                                                                    value: offerProposal.client.city ?? "",
                                                                    onChange: (e)=>updateClientField("city", e.target.value)
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "field is-horizontal",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "field-label is-normal",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        className: "label",
                                                        children: "Contacto"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "field-body",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "field",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "control is-expanded has-icons-left has-icons-right",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                        className: "input",
                                                                        type: "tel",
                                                                        placeholder: "Telefone",
                                                                        value: offerProposal.client.phone ?? "",
                                                                        onChange: (e)=>updateClientField("phone", e.target.value)
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "icon is-small is-left",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $970c5cdf933ea69e$export$2e2bcd8739ae039), {
                                                                            className: "inline mr-1"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: `icon is-small is-right`,
                                                                        children: !!offerProposal.client.phone && isValidPhone() ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                                                                            className: "inline mr-1 text-green-500"
                                                                        }) : !!offerProposal.client.phone ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                                                            className: "inline mr-1 text-red-500"
                                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {})
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "field",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "control is-expanded has-icons-left has-icons-right",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                        className: "input",
                                                                        type: "email",
                                                                        placeholder: "Email",
                                                                        value: offerProposal.client.email ?? "",
                                                                        onChange: (e)=>updateClientField("email", e.target.value)
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "icon is-small is-left",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d6fe951f3901e9a6$export$2e2bcd8739ae039), {
                                                                            className: "inline mr-1"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: `icon is-small is-right`,
                                                                        children: !!offerProposal.client.email && isValidEmail() ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                                                                            className: "inline mr-1 text-green-500"
                                                                        }) : !!offerProposal.client.email ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                                                            className: "inline mr-1 text-red-500"
                                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {})
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "field is-horizontal mt-5",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "field-label is-normal",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        className: "label"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "field-body",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "field",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                            type: "button",
                                                            className: "button is-light is-fullwidth",
                                                            onClick: ()=>{
                                                                const newValue = !showShippingAddress;
                                                                setShowShippingAddress(newValue);
                                                                updateClientField("use_personal_as_shipping", !newValue);
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $437c67a40c1b8279$export$2e2bcd8739ae039), {
                                                                    className: "inline mr-2",
                                                                    size: 18
                                                                }),
                                                                "Morada de Envio",
                                                                showShippingAddress ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b397e876e35a9277$export$2e2bcd8739ae039), {
                                                                    className: "inline ml-2",
                                                                    size: 18
                                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                                                    className: "inline ml-2",
                                                                    size: 18
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        showShippingAddress && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "field is-horizontal",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "field-label is-normal",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                className: "label",
                                                                children: "Morada"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "field-body",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "field",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                    className: "control is-expanded has-icons-left",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                                            rows: 2,
                                                                            className: "textarea",
                                                                            placeholder: "Morada de Envio",
                                                                            value: offerProposal.client.shipping_address ?? "",
                                                                            onChange: (e)=>updateClientField("shipping_address", e.target.value)
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "icon is-small is-left",
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c978075baab28645$export$2e2bcd8739ae039), {
                                                                                className: "inline"
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "field is-horizontal",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "field-label"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "field-body",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "field",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                        className: "control is-expanded",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                            className: "input",
                                                                            placeholder: "C\xf3digo Postal",
                                                                            value: offerProposal.client.shipping_zip_code ?? "",
                                                                            onChange: (e)=>updateClientField("shipping_zip_code", e.target.value)
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "field",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                        className: "control is-expanded",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                            className: "input",
                                                                            placeholder: "Cidade",
                                                                            value: offerProposal.client.shipping_city ?? "",
                                                                            onChange: (e)=>updateClientField("shipping_city", e.target.value)
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "field",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                        className: "control is-expanded",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                            className: "input",
                                                                            placeholder: "Pa\xeds",
                                                                            value: offerProposal.client.shipping_country ?? "Portugal",
                                                                            onChange: (e)=>updateClientField("shipping_country", e.target.value)
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "field is-horizontal mt-4",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "field-label is-normal",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        className: "label"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "field-body",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "field",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                            type: "button",
                                                            className: "button is-light is-fullwidth",
                                                            onClick: ()=>{
                                                                const newValue = !showBillingAddress;
                                                                setShowBillingAddress(newValue);
                                                                updateClientField("use_personal_as_billing", !newValue);
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6bfe12c41179c4f1$export$2e2bcd8739ae039), {
                                                                    className: "inline mr-2",
                                                                    size: 18
                                                                }),
                                                                "Morada Fiscal / Fatura\xe7\xe3o",
                                                                showBillingAddress ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b397e876e35a9277$export$2e2bcd8739ae039), {
                                                                    className: "inline ml-2",
                                                                    size: 18
                                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                                                    className: "inline ml-2",
                                                                    size: 18
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        showBillingAddress && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "field is-horizontal",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "field-label is-normal",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                className: "label",
                                                                children: "Morada"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "field-body",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "field",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                    className: "control is-expanded has-icons-left",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                                            rows: 2,
                                                                            className: "textarea",
                                                                            placeholder: "Morada Fiscal",
                                                                            value: offerProposal.client.billing_address ?? "",
                                                                            onChange: (e)=>updateClientField("billing_address", e.target.value)
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "icon is-small is-left",
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c978075baab28645$export$2e2bcd8739ae039), {
                                                                                className: "inline"
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "field is-horizontal",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "field-label"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "field-body",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "field",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                        className: "control is-expanded",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                            className: "input",
                                                                            placeholder: "C\xf3digo Postal",
                                                                            value: offerProposal.client.billing_zip_code ?? "",
                                                                            onChange: (e)=>updateClientField("billing_zip_code", e.target.value)
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "field",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                        className: "control is-expanded",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                            className: "input",
                                                                            placeholder: "Cidade",
                                                                            value: offerProposal.client.billing_city ?? "",
                                                                            onChange: (e)=>updateClientField("billing_city", e.target.value)
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "field",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                        className: "control is-expanded",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                            className: "input",
                                                                            placeholder: "Pa\xeds",
                                                                            value: offerProposal.client.billing_country ?? "Portugal",
                                                                            onChange: (e)=>updateClientField("billing_country", e.target.value)
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "field is-horizontal",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "field-label is-normal",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                className: "label",
                                                                children: "NIF para Fatura\xe7\xe3o"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "field-body",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "field",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                    className: "control is-expanded has-icons-left",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                            className: "input",
                                                                            placeholder: "NIF para Fatura\xe7\xe3o",
                                                                            value: offerProposal.client.billing_vat_number ?? "",
                                                                            onChange: (e)=>updateClientField("billing_vat_number", e.target.value)
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "icon is-small is-left",
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6bfe12c41179c4f1$export$2e2bcd8739ae039), {
                                                                                className: "inline"
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "field is-horizontal",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "field-label is-normal",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                className: "label",
                                                                children: "Nome Fiscal"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "field-body",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "field",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                    className: "control is-expanded has-icons-left",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                        className: "input",
                                                                        placeholder: "Nome para Fatura\xe7\xe3o",
                                                                        value: offerProposal.client.billing_name ?? "",
                                                                        onChange: (e)=>updateClientField("billing_name", e.target.value)
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: `content ${tabSelected !== "notes" ? "is-hidden" : ""}`,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d53f4121435a41a$export$2e2bcd8739ae039), {
                                        entityId: Number(offerProposal.id) || 0,
                                        entityType: "offer",
                                        showVisibilityOption: offerProposal.client_type === "reseller"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: `content ${tabSelected !== "order" ? "is-hidden" : ""}`,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "title is-5",
                                            children: "Hist\xf3rico da Proposta"
                                        }),
                                        offerProposal.history && offerProposal.history.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                            className: "list-none p-0",
                                            children: offerProposal.history.map((item, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    className: "mb-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "text-gray-600",
                                                            children: new Date(item.created_at).toLocaleString()
                                                        }),
                                                        " ",
                                                        "- ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "font-bold",
                                                            children: item.message
                                                        })
                                                    ]
                                                }, index))
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            children: "Nenhum hist\xf3rico dispon\xedvel."
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3284ba32c053e053$export$2e2bcd8739ae039), {
                        open: showExcelExportModal,
                        exporting: excelExporting,
                        onClose: ()=>setShowExcelExportModal(false),
                        onExport: handleExportExcel
                    }),
                    showCancelOfferModal && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e9b8fd613c8f8b46$export$2e2bcd8739ae039), {
                        offerId: offerProposal.id ?? null,
                        onClose: ()=>setShowCancelOfferModal(false),
                        openModal: showCancelOfferModal,
                        handleCancelProposal: handleCancelOffer
                    }),
                    showConfirmOrderModal && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dfb538d62fb33b43$export$2e2bcd8739ae039), {
                        openModal: showConfirmOrderModal,
                        onClose: ()=>setShowConfirmOrderModal(false),
                        onConfirm: handleConfirmOrder,
                        offer: offerProposal
                    }),
                    showAcceptOfferModal && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $726defbc0778299a$export$2e2bcd8739ae039), {
                        openModal: showAcceptOfferModal,
                        onClose: ()=>setShowAcceptOfferModal(false),
                        onConfirm: confirmAcceptOffer,
                        offerProposal: offerProposal
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "sticky bottom-0 bg-gray-900/90 backdrop-blur-md text-white border-t modal-footer",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("footer", {
                    className: `p-4 ${loading ? "cursor-not-allowed" : ""}`,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex is-justify-content-center not-printable min-h-[40px]",
                        children: !allowManageOffer() ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).button, {
                            whileHover: {
                                scale: 1.1
                            },
                            whileTap: {
                                scale: 0.9
                            },
                            className: "bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded-full shadow-lg items-center gap-2",
                            onClick: ()=>{
                                setModalScreen(null);
                                setOfferProposal({
                                    ...offerProposal,
                                    id: undefined
                                });
                                setUpdatedOffer(false);
                                navigate("/offers");
                            },
                            children: "Voltar"
                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                !offerProposal.id && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).button, {
                                            whileHover: {
                                                scale: 1.1
                                            },
                                            whileTap: {
                                                scale: 0.9
                                            },
                                            className: "bg-blue-500 hover:bg-blue-700 disabled:bg-blue-200 text-white font-bold py-2 px-4 rounded-full shadow-lg items-center gap-2",
                                            disabled: !isClientValid(),
                                            onClick: handleCreateProposal,
                                            children: userSettings?.isNormalUser() ? "Continuar" : "Criar Proposta"
                                        }),
                                        (userSettings?.isAdmin() || userSettings?.isCommercial()) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).button, {
                                            whileHover: {
                                                scale: 1.1
                                            },
                                            whileTap: {
                                                scale: 0.9
                                            },
                                            className: "bg-green-700 hover:bg-green-800 text-white font-bold py-2 px-4 rounded-full shadow-lg items-center gap-2 ml-4",
                                            onClick: ()=>setShowExcelExportModal(true),
                                            children: "Exportar Excel"
                                        })
                                    ]
                                }),
                                !!offerProposal.id && updatedOffer && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).button, {
                                    whileHover: {
                                        scale: 1.1
                                    },
                                    whileTap: {
                                        scale: 0.9
                                    },
                                    className: "bg-blue-500 hover:bg-blue-700  disabled:bg-blue-200 text-white font-bold py-2 px-4 rounded-full shadow-lg items-center gap-2",
                                    onClick: handleUpdateProposal,
                                    disabled: isUpdateOfferEnabled(),
                                    children: userSettings?.isNormalUser() ? "Confirmar altera\xe7\xe3o" : "Guardar Proposta"
                                }),
                                !!offerProposal.id && !updatedOffer && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        [
                                            "draft",
                                            "requested",
                                            "in_progress"
                                        ].includes(offerProposal.status) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).button, {
                                                    whileHover: {
                                                        scale: 1.1
                                                    },
                                                    whileTap: {
                                                        scale: 0.9
                                                    },
                                                    className: "bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded-full shadow-lg items-center gap-2 ml-4",
                                                    onClick: handlePrintPropose,
                                                    children: "Imprimir"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).button, {
                                                    whileHover: {
                                                        scale: 1.1
                                                    },
                                                    whileTap: {
                                                        scale: 0.9
                                                    },
                                                    className: `bg-green-700 hover:bg-green-800 text-white font-bold py-2 px-4 rounded-full shadow-lg items-center gap-2 ml-4 ${!offerProposal.client.email ? "opacity-50 cursor-not-allowed" : ""}`,
                                                    disabled: !offerProposal.client.email || !isValidEmail(),
                                                    onClick: handleSendEmail,
                                                    children: [
                                                        " ",
                                                        "Enviar Email"
                                                    ]
                                                })
                                            ]
                                        }),
                                        [
                                            "in_progress",
                                            "requested",
                                            "sent"
                                        ].includes(offerProposal.status) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).button, {
                                                    whileHover: {
                                                        scale: 1.1
                                                    },
                                                    whileTap: {
                                                        scale: 0.9
                                                    },
                                                    className: "bg-yellow-500 hover:bg-yellow-700 text-white font-bold py-2 px-4 rounded-full shadow-lg items-center gap-2 ml-4",
                                                    onClick: handleNewOfferProposal,
                                                    children: "Alterar Proposta"
                                                }),
                                                userSettings?.isOperatorUser() && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).button, {
                                                            whileHover: {
                                                                scale: 1.1
                                                            },
                                                            whileTap: {
                                                                scale: 0.9
                                                            },
                                                            className: "bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded-full shadow-lg items-center gap-2 ml-4",
                                                            onClick: (e)=>{
                                                                e.preventDefault();
                                                                setShowConfirmOrderModal(true);
                                                            },
                                                            children: "Encomendar"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).button, {
                                                            whileHover: {
                                                                scale: 1.1
                                                            },
                                                            whileTap: {
                                                                scale: 0.9
                                                            },
                                                            className: "bg-red-400 hover:bg-red-600 text-white font-bold py-2 px-4 rounded-full shadow-lg items-center gap-2 ml-4",
                                                            onClick: handleRequestCancelOffer,
                                                            children: "Cancelar"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
var $cf6f80a8b90b7901$export$2e2bcd8739ae039 = $cf6f80a8b90b7901$var$ManageOffer;



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $68d48ea6a6653ccd$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "14",
            height: "14",
            x: "8",
            y: "8",
            rx: "2",
            ry: "2",
            key: "17jyea"
        }
    ],
    [
        "path",
        {
            d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2",
            key: "zix9uf"
        }
    ]
];
const $68d48ea6a6653ccd$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("copy", $68d48ea6a6653ccd$export$3efd853dbb351e94);



var $ayMG0 = parcelRequire("ayMG0");
/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $b1744696575b5a31$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m7 6 5 5 5-5",
            key: "1lc07p"
        }
    ],
    [
        "path",
        {
            d: "m7 13 5 5 5-5",
            key: "1d48rs"
        }
    ]
];
const $b1744696575b5a31$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("chevrons-down", $b1744696575b5a31$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $cc6d4a04c79ee84d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m17 11-5-5-5 5",
            key: "e8nh98"
        }
    ],
    [
        "path",
        {
            d: "m17 18-5-5-5 5",
            key: "2avn1x"
        }
    ]
];
const $cc6d4a04c79ee84d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("chevrons-up", $cc6d4a04c79ee84d$export$3efd853dbb351e94);


parcelRequire("acw62");
const $50b6964e2a1344c7$export$45ab7901d59a4408 = (str, maxLength)=>{
    if (str.length <= maxLength) return str;
    return str.slice(0, maxLength) + "...";
};
const $50b6964e2a1344c7$export$42a1e94961918ad5 = (sortBy, sortOrder, setSortOrder, setSortBy, field, label)=>{
    const handleSort = ()=>{
        if (sortBy === field) {
            if (sortOrder === "asc") setSortOrder("desc");
            else setSortOrder("asc");
        } else setSortBy(field);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
        className: `sort-action cursor-pointer ${sortBy == field ? "has-active" : ""}`,
        onClick: ()=>handleSort(),
        title: label,
        children: [
            label,
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "icon is-small ml-2 pt-4",
                children: sortOrder === "asc" && sortBy === field ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cc6d4a04c79ee84d$export$2e2bcd8739ae039), {
                    className: sortBy === field ? "animate-bounce" : "text-stone-400"
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b1744696575b5a31$export$2e2bcd8739ae039), {
                    className: sortBy === field ? "animate-bounce" : "text-stone-400"
                })
            })
        ]
    });
};




var $juRJQ = parcelRequire("juRJQ");
const $ae60669cec2762a5$var$ListOfferItems = ({ offers: offers, filters: filters, setFilters: setFilters, totalPages: totalPages, resellersList: resellersList, commercialsList: commercialsList, handleManageOffer: handleManageOffer, handleCopyOffer: handleCopyOffer, userSettings: userSettings, totalResults: totalResults, loading: loading })=>{
    const [showListedFields, setShowListedFields] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>{
        const session = sessionStorage.getItem("offers_listed_fields");
        if (session) return new Map(JSON.parse(session));
        return new Map([
            [
                "offer_type",
                true
            ],
            [
                "external_id",
                true
            ],
            [
                "item",
                true
            ],
            [
                "value",
                true
            ],
            [
                "client_name",
                true
            ],
            [
                "created_by",
                true
            ],
            [
                "created_by_role",
                true
            ],
            [
                "status",
                true
            ],
            [
                "reseller_cod",
                true
            ],
            [
                "reseller",
                true
            ],
            [
                "commercial_portfolio",
                true
            ],
            [
                "commercial_agent",
                true
            ],
            [
                "created_at",
                true
            ],
            [
                "expires_on",
                true
            ],
            [
                "actions",
                true
            ]
        ]);
    });
    // Save showListedFields to sessionStorage when it changes
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        sessionStorage.setItem("offers_listed_fields", JSON.stringify(Array.from(showListedFields.entries())));
    }, [
        showListedFields
    ]);
    const isAdmin = userSettings?.isAdmin() || false;
    const isCommercial = userSettings?.isCommercial() || false;
    const isAdminOrCommercial = isAdmin || isCommercial;
    const getOrderTypeLabel = (offer)=>{
        if (offer.offer_type === "DEFAULT") return "Revendedor";
        else if (offer.offer_type === "INTERNAL") {
            if (offer.client_type.toUpperCase() === "RESELLER") return "Comercial";
            else if (offer.client_type.toUpperCase() === "END_CUSTOMER") return "Interna";
        }
        return "Outro";
    };
    const getOrderTypeClass = (offer)=>{
        if (offer.offer_type === "DEFAULT") return "bg-amber-300";
        else if (offer.offer_type === "INTERNAL") {
            if (offer.client_type.toUpperCase() === "RESELLER") return "bg-blue-300";
            else if (offer.client_type.toUpperCase() === "END_CUSTOMER") return "bg-green-300";
        }
        return "bg-gray-300";
    };
    const getStyleCssForSellerRole = (role)=>{
        switch(role){
            case "ADMIN":
                return "bg-red-100 text-red-800";
            case "COMMERCIAL":
                return "bg-blue-100 text-blue-800";
            case "RESELLER":
                return "bg-green-100 text-green-800";
            case "USER":
                return "bg-yellow-100 text-yellow-800";
            default:
                return "bg-gray-100 text-gray-800";
        }
    };
    const getDisplayValueForSellerRole = (role)=>{
        switch(role){
            case "ADMIN":
                return "Administrador";
            case "COMMERCIAL":
                return "Comercial";
            case "RESELLER":
                return "Revendedor";
            case "USER":
                return "Self-Service";
            default:
                return "Desconhecido";
        }
    };
    const handlePerPageChange = (perPage)=>{
        setFilters({
            ...filters,
            per_page: perPage,
            page: 1
        });
    };
    const handlePageChange = (newPage)=>{
        setFilters({
            ...filters,
            page: newPage
        });
    };
    const handleFilterValueChange = (field)=>{
        return (value)=>setFilters({
                ...filters,
                [field]: value,
                page: 1
            });
    };
    const renderOrigemSelect = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "control flex-1 flex items-center gap-2 pl-10",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                    className: "label mb-0 whitespace-nowrap",
                    children: "Origem"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "select w-full",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                        value: filters.type,
                        onChange: (e)=>handleFilterValueChange("type")(e.target.value),
                        className: "border rounded px-2 py-1 bg-white",
                        style: {
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                value: "",
                                children: "Escolha a origem"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                value: "DEFAULT",
                                children: "Revendedor"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                value: "RESELLER",
                                children: "Comercial"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                value: "END_CUSTOMER",
                                children: "Interna"
                            })
                        ]
                    })
                })
            ]
        });
    };
    const renderCommercialSelect = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "control flex-1 flex items-center gap-2 pl-10",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                    className: "label mb-0 whitespace-nowrap",
                    children: "Cod Comercial"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "select w-full",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                        name: "reseller",
                        onChange: (e)=>{
                            handleFilterValueChange("commercial_id")(e.target.value);
                        },
                        className: "w-full",
                        value: filters.commercial_id || "",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                value: "",
                                children: "Todos"
                            }),
                            commercialsList.map((commercial)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                    value: commercial.id,
                                    children: commercial.description || "Sem comercial"
                                }, commercial.id))
                        ]
                    })
                })
            ]
        });
    };
    const renderResellerSelect = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "control flex-1 flex items-center gap-2 pl-10",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                    className: "label mb-0 whitespace-nowrap",
                    children: "Revendedor"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "select w-full",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                        name: "reseller",
                        onChange: (e)=>{
                            handleFilterValueChange("reseller_id")(e.target.value);
                        },
                        className: "w-full",
                        value: filters.reseller_id || "",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                value: "",
                                children: "Todos"
                            }),
                            resellersList.map((reseller)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                    value: reseller.id,
                                    children: reseller.description || "revendedor sem nome"
                                }, reseller.id))
                        ]
                    })
                })
            ]
        });
    };
    const renderFilterForm = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "grid grid-cols-1 md:grid-cols-8 gap-8",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "md:col-span-5",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                            htmlFor: "search",
                            className: "block text-sm font-medium text-gray-700 mb-2",
                            children: "Pesquisar"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "relative",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        className: "h-5 w-5 text-gray-400",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        stroke: "currentColor",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            strokeWidth: 2,
                                            d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    id: "search",
                                    type: "text",
                                    name: "search",
                                    placeholder: "ID, computador, cliente...",
                                    value: filters.search,
                                    onChange: (e)=>handleFilterValueChange("search")(e.target.value),
                                    className: "block w-full pl-10 pr-3 py-2.5 border border-gray-300 rounded-lg bg-gray-50 placeholder-gray-500 focus:outline-none focus:bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm transition-all duration-200",
                                    autoFocus: true
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                            htmlFor: "startDate",
                            className: "block text-sm font-medium text-gray-700 mb-2",
                            children: "Data de"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                            id: "startDate",
                            type: "date",
                            name: "startDate",
                            className: "block w-full px-3 py-2.5 border border-gray-300 rounded-lg bg-gray-50 text-gray-900 focus:outline-none focus:bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm transition-all duration-200",
                            value: filters.begin_date || new Date(Date.now() - 691200000).toISOString().split("T")[0],
                            onChange: (e)=>handleFilterValueChange("begin_date")(e.target.value)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                            htmlFor: "endDate",
                            className: "block text-sm font-medium text-gray-700 mb-2",
                            children: "at\xe9"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                            id: "endDate",
                            type: "date",
                            name: "endDate",
                            className: "block w-full px-3 py-2.5 border border-gray-300 rounded-lg bg-gray-50 text-gray-900 focus:outline-none focus:bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm transition-all duration-200",
                            value: filters.end_date || new Date().toISOString().split("T")[0],
                            onChange: (e)=>handleFilterValueChange("end_date")(e.target.value)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                            htmlFor: "status",
                            className: "block text-sm font-medium text-gray-700 mb-2",
                            children: "Estado"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                            id: "status",
                            name: "status",
                            className: "block w-full px-3 py-2.5 border border-gray-300 rounded-lg bg-gray-50 text-gray-900 focus:outline-none focus:bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm transition-all duration-200",
                            value: filters.status,
                            onChange: (e)=>handleFilterValueChange("status")(e.target.value),
                            children: [
                                "Todos",
                                "REQUESTED",
                                "DRAFT",
                                "SENT",
                                "ACCEPTED",
                                "CANCELLED",
                                "EXPIRED",
                                "PENDING",
                                "CONFIRMED",
                                "REJECTED",
                                "SHIPPED",
                                "COMPLETED",
                                "ARCHIVED"
                            ].map((status)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                    value: status === "Todos" ? "" : status,
                                    children: status === "Todos" ? "Todos" : (0, $ea3aad6bc2f33b3b$export$5ec402b7fcf74398)(status)
                                }, status))
                        })
                    ]
                })
            ]
        });
    };
    const renderAdminFilterForm = ()=>{
        return isAdminOrCommercial && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "grid grid-cols-1 md:grid-cols-3 gap-4 mt-5",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                            htmlFor: "origin",
                            className: "block text-sm font-medium text-gray-700 mb-2",
                            children: "Origem"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                            id: "origin",
                            value: filters.type,
                            onChange: (e)=>handleFilterValueChange("type")(e.target.value),
                            className: "block w-full px-3 py-2.5 border border-gray-300 rounded-lg bg-gray-50 text-gray-900 focus:outline-none focus:bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm transition-all duration-200",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                    value: "",
                                    children: "Todas as origens"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                    value: "DEFAULT",
                                    children: "Revendedor"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                    value: "RESELLER",
                                    children: "Comercial"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                    value: "END_CUSTOMER",
                                    children: "Interna"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                            htmlFor: "reseller",
                            className: "block text-sm font-medium text-gray-700 mb-2",
                            children: "Revendedor"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                            id: "reseller",
                            name: "reseller",
                            onChange: (e)=>{
                                handleFilterValueChange("reseller_id")(e.target.value);
                            },
                            className: "block w-full px-3 py-2.5 border border-gray-300 rounded-lg bg-gray-50 text-gray-900 focus:outline-none focus:bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm transition-all duration-200",
                            value: filters.reseller_id || "",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                    value: "",
                                    children: "Todos"
                                }),
                                resellersList.map((reseller)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: reseller.id,
                                        children: reseller.description || "revendedor sem nome"
                                    }, reseller.id))
                            ]
                        })
                    ]
                }),
                isAdmin && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                            htmlFor: "commercial",
                            className: "block text-sm font-medium text-gray-700 mb-2",
                            children: "Cod Comercial"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                            id: "commercial",
                            name: "commercial",
                            onChange: (e)=>{
                                handleFilterValueChange("commercial_id")(e.target.value);
                            },
                            className: "block w-full px-3 py-2.5 border border-gray-300 rounded-lg bg-gray-50 text-gray-900 focus:outline-none focus:bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm transition-all duration-200",
                            value: filters.commercial_id || "",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                    value: "",
                                    children: "Todos"
                                }),
                                commercialsList.map((commercial)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: commercial.id,
                                        children: commercial.description || "Sem comercial"
                                    }, commercial.id))
                            ]
                        })
                    ]
                })
            ]
        });
    };
    const renderOfferType = (offer)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("small", {
            className: `rounded-3xl px-2 p-1 has-text-weight-bold ${getOrderTypeClass(offer)}`,
            children: [
                " ",
                getOrderTypeLabel(offer),
                " "
            ]
        });
    };
    const renderValue = (offer)=>{
        return offer.compound.price.value.toLocaleString("pt-PT", {
            style: "currency",
            currency: "EUR"
        });
    };
    const renderCreatedRole = (offer)=>{
        const value = offer.created_by_role;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("small", {
            className: `rounded-3xl px-2 p-1 has-text-weight-bold ${getStyleCssForSellerRole(value)}`,
            children: [
                " ",
                getDisplayValueForSellerRole(value),
                " "
            ]
        });
    };
    const renderCommercialAgents = (offer)=>{
        return offer.commercial_agents.length > 0 ? offer.commercial_agents.map((agent)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "inline-block mr-1 rounded bg-blue-100 px-2 py-1 text-xs font-semibold text-blue-800",
                children: agent.name || agent.username
            }, agent.id)) : /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
            children: "-"
        });
    };
    const renderActions = (offer)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    className: "button is-small is-primary",
                    onClick: (e)=>{
                        e.stopPropagation();
                        handleManageOffer(offer);
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $737c279b45d43939$export$2e2bcd8739ae039), {
                        className: "w-4 h-4"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    className: "button is-small is-secondary ml-2",
                    onClick: (e)=>{
                        e.stopPropagation();
                        handleCopyOffer(offer);
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $68d48ea6a6653ccd$export$2e2bcd8739ae039), {
                        className: "w-4 h-4"
                    })
                })
            ]
        });
    };
    const columns = [
        {
            field: "offer_type",
            headerName: "Origem",
            width: 120,
            sortable: true,
            renderCell: (params)=>{
                return renderOfferType(params.row);
            }
        },
        {
            field: "external_id",
            headerName: "Proposta #",
            width: 200
        },
        {
            field: "item",
            headerName: "Computador",
            width: 200,
            sortable: true,
            valueGetter: (value, row)=>(0, $50b6964e2a1344c7$export$45ab7901d59a4408)(row.compound?.id, 30)
        },
        {
            field: "value",
            headerName: "Valor",
            width: 100,
            sortable: true,
            renderCell: (params)=>{
                return renderValue(params.row);
            }
        },
        {
            field: "client_name",
            headerName: "Nome do Cliente",
            width: 200,
            sortable: true,
            valueGetter: (value, row)=>(0, $50b6964e2a1344c7$export$45ab7901d59a4408)(row.client?.name || "n/a", 30)
        },
        {
            field: "created_by",
            headerName: "Vendedor",
            width: 150,
            sortable: true,
            valueGetter: (value, row)=>(0, $50b6964e2a1344c7$export$45ab7901d59a4408)(row.created_by_name || row.created_by || "Desconhecido", 15)
        },
        {
            field: "created_role",
            headerName: "Perfil do Vendedor",
            width: 150,
            sortable: true,
            renderCell: (params)=>{
                return renderCreatedRole(params.row);
            }
        },
        {
            field: "status",
            headerName: "Estado",
            width: 120,
            sortable: true,
            valueGetter: (value, row)=>(0, $ea3aad6bc2f33b3b$export$5ec402b7fcf74398)(row.status)
        },
        ...isAdminOrCommercial ? [
            {
                field: "reseller_cod",
                headerName: "Cod Revendedor",
                width: 100,
                sortable: true,
                valueGetter: (value, row)=>row.reseller_id || "-"
            },
            {
                field: "reseller",
                headerName: "Revendedor",
                width: 200,
                sortable: true,
                valueGetter: (value, row)=>(0, $50b6964e2a1344c7$export$45ab7901d59a4408)(row.reseller_name || "Revendedor desconhecido", 25)
            },
            {
                field: "commercial_portfolio",
                headerName: "Cod Comercial",
                width: 120,
                sortable: true,
                valueGetter: (value, row)=>row.commercial_portfolio || "-"
            },
            {
                field: "commercial_agent",
                headerName: "Comercial",
                width: 200,
                sortable: true,
                renderCell: (params)=>{
                    return renderCommercialAgents(params.row);
                }
            }
        ] : [],
        {
            field: "created_at",
            headerName: "Criada em",
            width: 140,
            sortable: true,
            valueGetter: (value, row)=>row?.created_at ? new Date(row.created_at).toLocaleString("pt-PT", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit"
                }) : ""
        },
        {
            field: "expires_on",
            headerName: "Expira em",
            width: 140,
            sortable: true,
            valueGetter: (value, row)=>row?.expires_on ? new Date(row.expires_on).toLocaleString("pt-PT", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit"
                }) : ""
        },
        {
            field: "actions",
            headerName: "",
            width: 150,
            sortable: false,
            disableColumnMenu: true,
            renderCell: (params)=>{
                return renderActions(params.row);
            }
        }
    ];
    const paginationState = {
        paginationMode: "server",
        paginationModel: {
            page: filters.page - 1,
            pageSize: filters.per_page || 10
        },
        rowCount: totalResults || -1,
        enabled: true,
        meta: {
            hasNextPage: true
        }
    };
    const handlePaginationChange = (model)=>{
        if (model.pageSize !== filters.per_page) handlePerPageChange(model.pageSize);
        if (model.page + 1 !== filters.page) handlePageChange(model.page + 1);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex flex-col gap-4",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "bg-white p-4 rounded-xl shadow-sm border border-gray-200",
                    children: [
                        renderFilterForm(),
                        renderAdminFilterForm()
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "manage-page mt-4",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($juRJQ))), {
                    sx: {
                        width: "100%",
                        overflow: "hidden"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $808944a671b11c1c$exports.DataGrid), {
                        rows: offers,
                        columns: columns,
                        loading: loading,
                        initialState: {
                            pagination: paginationState
                        },
                        rowCount: totalResults || 0,
                        paginationMode: "server",
                        disableColumnFilter: true,
                        onPaginationModelChange: handlePaginationChange,
                        onSortModelChange: (model)=>{
                            if (model.length > 0) {
                                const sortModel = model[0];
                                setFilters({
                                    ...filters,
                                    ["sort_direction"]: sortModel.sort || "asc",
                                    ["sort_by"]: sortModel.field,
                                    page: 1
                                });
                            }
                        },
                        columnVisibilityModel: Object.fromEntries(showListedFields),
                        onColumnVisibilityModelChange: (newModel)=>{
                            const newMap = new Map(Object.entries(newModel));
                            setShowListedFields(newMap);
                        },
                        hideFooterSelectedRowCount: true,
                        pageSizeOptions: [
                            5,
                            10,
                            20,
                            50,
                            100
                        ],
                        localeText: {
                            columnsManagementSearchTitle: "Procurar",
                            columnsManagementNoColumns: "Sem colunas",
                            columnsManagementShowHideAllText: "Mostrar/Ocultar Todas",
                            columnsManagementReset: "Repor",
                            columnsManagementDeleteIconLabel: "Limpar",
                            columnMenuLabel: "Menu",
                            columnMenuAriaLabel: (columnName)=>`Menu da coluna ${columnName}`,
                            columnMenuShowColumns: "Mostrar colunas",
                            columnMenuManageColumns: "Gerir colunas",
                            columnMenuFilter: "Filtrar",
                            columnMenuHideColumn: "Ocultar coluna",
                            columnMenuUnsort: "Remover ordena\xe7\xe3o",
                            columnMenuSortAsc: "Ordenar por ASC",
                            columnMenuSortDesc: "Ordenar por DESC",
                            columnMenuManagePivot: "Gerir pivot",
                            paginationRowsPerPage: "Linhas por p\xe1gina:",
                            paginationDisplayedRows: ({ from: from, to: to, count: count, estimated: estimated })=>{
                                if (!estimated) return `${from}\u{2013}${to} de ${count !== -1 ? count : `mais de ${to}`}`;
                                const estimatedLabel = estimated && estimated > to ? `cerca de ${estimated}` : `mais de ${to}`;
                                return `${from}\u{2013}${to} de ${count !== -1 ? count : estimatedLabel}`;
                            }
                        },
                        getCellClassName: (params)=>{
                            const fieldClasses = {
                                external_id: "font-mono",
                                value: "font-mono force-text-right",
                                status: (0, $ea3aad6bc2f33b3b$export$df5c6cccb198f23)(params.row.status),
                                offer_type: "force-text-center",
                                created_at: "font-mono text-xs",
                                expires_on: "font-mono text-xs"
                            };
                            return fieldClasses[params.field] || "";
                        },
                        getRowId: (row)=>row.id
                    })
                })
            })
        ]
    });
};
var $ae60669cec2762a5$export$2e2bcd8739ae039 = $ae60669cec2762a5$var$ListOfferItems;



const $dad5fa862effa7ab$var$OfferPage = ()=>{
    const { isAuthenticated: isAuthenticated } = (0, $b622ef53e38024e7$export$1d39dc5b47e56ff0)();
    const navigate = (0, $585f8bce88e531c1$export$9770f232ac06a008)();
    const { pathname: pathname } = (0, $585f8bce88e531c1$export$45d76561a5302f2b)();
    const { userSettings: userSettings, setUserSettings: setUserSettings, systemError: systemError, setSystemError: setSystemError, error: //loading,
    //setLoading,
    error, setError: setError, success: success, setSuccess: setSuccess, modalScreen: modalScreen, setModalScreen: setModalScreen } = (0, $a55f2a94cd420149$export$c50e37a2f0a2b064)();
    const { id: id } = (0, $585f8bce88e531c1$export$99eaa27ddbbb95ef)();
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [offerId, setOfferId] = (0, $acw62.useState)(id);
    const [offers, setOffers] = (0, $acw62.useState)([]);
    const [filters, setFilters] = (0, $acw62.useState)({
        search: window.location.search.includes("search=") ? new URLSearchParams(window.location.search).get("search") || "" : "",
        reseller_id: window.location.search.includes("reseller_id=") ? new URLSearchParams(window.location.search).get("reseller_id") || undefined : undefined,
        page: window.location.search.includes("page=") ? parseInt(new URLSearchParams(window.location.search).get("page") || "1", 10) : 1,
        per_page: window.location.search.includes("per_page=") ? parseInt(new URLSearchParams(window.location.search).get("per_page") || "10") : 10,
        sort_by: window.location.search.includes("sort_by=") ? new URLSearchParams(window.location.search).get("sort_by") || "created_at" : "created_at",
        sort_direction: window.location.search.includes("sort_direction=") ? (new URLSearchParams(window.location.search).get("sort_direction") || "desc") === "asc" ? "asc" : "desc" : "desc",
        begin_date: window.location.search.includes("begin_date=") ? new URLSearchParams(window.location.search).get("begin_date") || undefined : undefined,
        end_date: window.location.search.includes("end_date=") ? new URLSearchParams(window.location.search).get("end_date") || undefined : undefined,
        status: window.location.search.includes("status=") ? new URLSearchParams(window.location.search).get("status") || undefined : undefined
    });
    const [totalPages, setTotalPages] = (0, $acw62.useState)(1);
    const [totalResults, setTotalResults] = (0, $acw62.useState)(0);
    const [resellersList, setResellersList] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [commercialsList, setCommercialsList] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const fetchOffer = async (offerId)=>{
        setLoading(true);
        try {
            const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).OFFERS + "/" + offerId);
            handleManageOffer(response.data);
        } catch (error) {
            setSystemError(error.message || "Erro ao buscar proposta.");
            console.warn("Error fetching offer:", error.message);
        } finally{
            setLoading(false);
        }
    };
    const fetchOffers = async ()=>{
        const loading = ()=>{
            if (!id) {
                setLoading(true);
                return ()=>{
                    setTimeout(()=>setLoading(false), 500);
                };
            }
            setOffers([]);
            return ()=>{};
        };
        const closeLoading = loading();
        try {
            const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).OFFERS + `/?page=${filters.page}&per_page=${filters.per_page}` + `&sort_by=${filters.sort_by}&sort_direction=${filters.sort_direction}` + (filters.search ? `&search=${encodeURIComponent(filters.search)}` : "") + (filters.commercial_id ? `&commercial_id=${filters.commercial_id}` : "") + (filters.reseller_id ? `&reseller_id=${filters.reseller_id}` : "") + (filters.begin_date ? `&begin_date=${filters.begin_date}` : "") + (filters.end_date ? `&end_date=${filters.end_date}` : "") + (filters.status ? `&status=${filters.status}` : "") + (filters.type ? `&type=${filters.type}` : ""));
            setOffers(response.data.offers || []);
            setTotalPages(response.data.total_pages || 1);
            setTotalResults(response.data.total_results || 0);
        } catch (error) {
            console.warn("Error fetching offers:", error.message);
        } finally{
            closeLoading();
        }
    };
    const fetchResellers = async ()=>{
        if (!userSettings?.isAdmin() && !userSettings?.isCommercial()) return; // Only fetch if the user is an admin
        try {
            const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).OFFERS + "/_values/resellers?" + (filters.search ? `&search=${encodeURIComponent(filters.search)}` : "") + (filters.commercial_id ? `&commercial_id=${filters.commercial_id}` : "") + (filters.begin_date ? `&begin_date=${filters.begin_date}` : "") + (filters.end_date ? `&end_date=${filters.end_date}` : "") + (filters.status ? `&status=${filters.status}` : "") + (filters.type ? `&type=${filters.type}` : ""));
            const data = await response.data;
            setResellersList(data);
        } catch (error) {
            console.warn("Error fetching resellers:", error);
        }
    };
    const fetchCommercials = async ()=>{
        if (!userSettings?.isAdmin() && !userSettings?.isCommercial()) return; // Only fetch if the user is an admin
        try {
            const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).OFFERS + "/_values/commercials?" + (filters.search ? `&search=${encodeURIComponent(filters.search)}` : "") + (filters.reseller_id ? `&reseller_id=${filters.reseller_id}` : "") + (filters.begin_date ? `&begin_date=${filters.begin_date}` : "") + (filters.end_date ? `&end_date=${filters.end_date}` : "") + (filters.status ? `&status=${filters.status}` : "") + (filters.type ? `&type=${filters.type}` : ""));
            const data = await response.data;
            setCommercialsList(data);
        } catch (error) {
            console.warn("Error fetching commercials:", error);
        }
    };
    const buildQueryParams = (params)=>{
        const queryParams = new URLSearchParams();
        if (params.search) queryParams.set("search", params.search);
        if (params.reseller_id) queryParams.set("reseller_id", params.reseller_id);
        if (params.commercial_id) queryParams.set("commercial_id", params.commercial_id);
        if (params.page) queryParams.set("page", String(params.page));
        if (params.per_page) queryParams.set("per_page", String(params.per_page));
        if (params.sort_by) queryParams.set("sort_by", params.sort_by);
        if (params.sort_direction) queryParams.set("sort_direction", params.sort_direction);
        if (params.begin_date) queryParams.set("begin_date", params.begin_date);
        if (params.end_date) queryParams.set("end_date", params.end_date);
        if (params.status) queryParams.set("status", params.status);
        if (params.type) queryParams.set("type", params.type);
        return queryParams.toString();
    };
    const handleCloseModal = (0, $acw62.useCallback)(()=>{
        setOfferId(undefined);
        setModalScreen(null);
        history.pushState(history.state, "", "/offers?" + buildQueryParams(filters));
        fetchOffers(); // Refresh offers after managing
    }, [
        setModalScreen,
        filters
    ]);
    const handleManageOffer = (0, $acw62.useCallback)((offer)=>{
        setModalScreen({
            state: "view",
            title: `Ver Proposta: #${offer.id}`,
            childrenControlOverflow: true,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cf6f80a8b90b7901$export$2e2bcd8739ae039), {
                offer: offer
            }),
            onClose: handleCloseModal,
            onShow: ()=>{
                setOfferId(String(offer.id));
                history.pushState(history.state, "", `/offers/${offer.id}`);
            }
        });
    }, [
        setModalScreen,
        handleCloseModal
    ]);
    const handleCopyOffer = (0, $acw62.useCallback)((offer)=>{
        const newOffer = {
            external_id: undefined,
            id: undefined,
            status: "draft",
            compound: offer.compound,
            client_type: "end_customer",
            client: {
                name: ""
            }
        };
        setModalScreen({
            state: "edit",
            title: `Copiar Proposta: #${offer.id}`,
            childrenControlOverflow: true,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cf6f80a8b90b7901$export$2e2bcd8739ae039), {
                offer: newOffer
            }),
            onClose: handleCloseModal,
            onShow: ()=>{
                setOfferId(String(offer.id));
                history.pushState(history.state, "", `/offers/${offer.id}/copy`);
            }
        });
    }, [
        setModalScreen,
        handleCloseModal
    ]);
    (0, $acw62.useEffect)(()=>{
        history.pushState(history.state, "", "/offers?" + buildQueryParams(filters));
        Promise.all([
            fetchResellers(),
            fetchCommercials()
        ]);
    }, [
        history,
        userSettings,
        filters
    ]);
    (0, $acw62.useEffect)(()=>{
        console.info("start OfferPage useEffect");
        console.info("filters:", filters);
        if (!isAuthenticated()) navigate("/login", {
            state: {
                from: pathname
            }
        });
        fetchOffers();
        if (offerId) {
            console.log("open offer with id:", offerId);
            fetchOffer(offerId);
        }
    }, [
        filters,
        offerId,
        history,
        location,
        pathname,
        navigate,
        isAuthenticated
    ]);
    if (!isAuthenticated()) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: "You must be logged in to edit items."
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "container mx-auto p-6 max-w-7xl",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex flex-col gap-6",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex flex-col md:flex-row justify-between items-start md:items-center gap-4",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "text-3xl font-bold text-gray-900 tracking-tight",
                                    children: "Propostas"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "text-gray-500 mt-1",
                                    children: "Gerencie propostas comerciais e acompanhe o pipeline de vendas."
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "overflow-auto",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ae60669cec2762a5$export$2e2bcd8739ae039), {
                            offers: offers,
                            filters: filters,
                            setFilters: setFilters,
                            totalPages: totalPages,
                            totalResults: totalResults,
                            resellersList: resellersList,
                            commercialsList: commercialsList,
                            handleManageOffer: handleManageOffer,
                            handleCopyOffer: handleCopyOffer,
                            userSettings: userSettings,
                            loading: loading
                        })
                    })
                ]
            })
        })
    });
};
var $dad5fa862effa7ab$export$2e2bcd8739ae039 = $dad5fa862effa7ab$var$OfferPage;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");






/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5415d98bde6b29f1$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "8",
            y2: "12",
            key: "1pkeuh"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12.01",
            y1: "16",
            y2: "16",
            key: "4dfq90"
        }
    ]
];
const $5415d98bde6b29f1$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("circle-alert", $5415d98bde6b29f1$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $d252ca8c87a49232$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4",
            key: "ih7n3h"
        }
    ],
    [
        "polyline",
        {
            points: "7 10 12 15 17 10",
            key: "2ggqvy"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "15",
            y2: "3",
            key: "1vk2je"
        }
    ]
];
const $d252ca8c87a49232$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("download", $d252ca8c87a49232$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5a2da4e22d001166$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M9 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v.5",
            key: "1dkoa9"
        }
    ],
    [
        "path",
        {
            d: "M12 10v4h4",
            key: "1czhmt"
        }
    ],
    [
        "path",
        {
            d: "m12 14 1.535-1.605a5 5 0 0 1 8 1.5",
            key: "lvuxfi"
        }
    ],
    [
        "path",
        {
            d: "M22 22v-4h-4",
            key: "1ewp4q"
        }
    ],
    [
        "path",
        {
            d: "m22 18-1.535 1.605a5 5 0 0 1-8-1.5",
            key: "14ync0"
        }
    ]
];
const $5a2da4e22d001166$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("folder-sync", $5a2da4e22d001166$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $dcddce55b19e141b$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
            key: "e7tb2h"
        }
    ],
    [
        "path",
        {
            d: "m7.5 4.27 9 5.15",
            key: "1c824w"
        }
    ],
    [
        "polyline",
        {
            points: "3.29 7 12 12 20.71 7",
            key: "ousv84"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "22",
            y2: "12",
            key: "a4e8g8"
        }
    ],
    [
        "path",
        {
            d: "m17 13 5 5m-5 0 5-5",
            key: "im3w4b"
        }
    ]
];
const $dcddce55b19e141b$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("package-x", $dcddce55b19e141b$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4f68e7f5ef2ab511$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4",
            key: "ih7n3h"
        }
    ],
    [
        "polyline",
        {
            points: "17 8 12 3 7 8",
            key: "t8dd8p"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "3",
            y2: "15",
            key: "widbto"
        }
    ]
];
const $4f68e7f5ef2ab511$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("upload", $4f68e7f5ef2ab511$export$3efd853dbb351e94);


const $207fd09cab7d7eb8$var$CompoundManageListPage = ()=>{
    const { isAuthenticated: isAuthenticated } = (0, $b622ef53e38024e7$export$1d39dc5b47e56ff0)();
    const { pathname: pathname } = (0, $585f8bce88e531c1$export$45d76561a5302f2b)();
    const { setError: setError, setSuccess: setSuccess, setModalScreen: setModalScreen } = (0, $a55f2a94cd420149$export$c50e37a2f0a2b064)();
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [data, setData] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [filters, setFilters] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        search: window.location.search.includes("search=") ? new URLSearchParams(window.location.search).get("search") || "" : "",
        page: window.location.search.includes("page=") ? parseInt(new URLSearchParams(window.location.search).get("page") || "1", 10) : 1,
        per_page: window.location.search.includes("per_page=") ? parseInt(new URLSearchParams(window.location.search).get("per_page") || "10") : 10,
        sort_by: window.location.search.includes("sort_by=") ? new URLSearchParams(window.location.search).get("sort_by") || "category_slug" : "category_slug",
        sort_direction: window.location.search.includes("sort_direction=") ? (new URLSearchParams(window.location.search).get("sort_direction") || "desc") === "asc" ? "asc" : "desc" : "desc",
        stock_status: window.location.search.includes("stock_status=") ? new URLSearchParams(window.location.search).get("stock_status") || "" : ""
    });
    const [totalPages, setTotalPages] = (0, $acw62.useState)(1);
    const [totalResults, setTotalResults] = (0, $acw62.useState)(0);
    const fetchCatalogData = async ()=>{
        setLoading(true);
        setError(null);
        try {
            const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).post((0, $cd93687958c8007e$export$bfe19bc25132bb7c).COMPOUNDS + "/_search", {
                search_text: filters.search,
                page: filters.page,
                limit: filters.per_page,
                sort: `${filters.sort_by} ${filters.sort_direction}`,
                stock_status: filters.stock_status || null
            });
            setData(response.data.results || []);
            setTotalPages(response.data.total_pages || 1);
            setTotalResults(response.data.total_results || 1);
            updateURLParams();
        } catch (err) {
            setError(err.message || "Failed to fetch catalog data");
            console.warn("Error fetching catalog data:", err.message);
        } finally{
            setLoading(false);
        }
    };
    const updateURLParams = ()=>{
        const params = new URLSearchParams();
        if (filters.search) params.set("search", filters.search);
        params.set("page", filters.page.toString());
        params.set("per_page", filters.per_page.toString());
        params.set("sort_by", filters.sort_by);
        params.set("sort_direction", filters.sort_direction);
        if (filters.stock_status) params.set("stock_status", filters.stock_status);
        //navigate({ pathname, search: params.toString() });
        history.replaceState({}, "", `${pathname}?${params.toString()}`);
    };
    const refreshCatalogData = async ()=>{
        setLoading(true);
        setError(null);
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).post((0, $cd93687958c8007e$export$bfe19bc25132bb7c).COMPOUNDS + "/_actions/refresh", {});
            setSuccess("Catalog refreshed successfully.");
        } catch (err) {
            setError(err.message || "Failed to refresh catalog");
            console.warn("Error refreshing catalog:", err.message);
        } finally{
            fetchCatalogData();
            setLoading(false);
        }
    };
    const handleView = ()=>{
        history.replaceState({
            data: data,
            totalPages: totalPages,
            totalResults: totalResults,
            filters: filters
        }, "Manage List Page");
    };
    const handleEdit = ()=>{
        history.replaceState({
            data: data,
            totalPages: totalPages,
            totalResults: totalResults,
            filters: filters
        }, "Manage List Page");
    };
    const handleDelete = async (id, e)=>{
        e?.preventDefault();
        if (window.confirm("Are you sure you want to delete this item?")) try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).delete(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).COMPOUNDS}/${encodeURIComponent(id)}`);
            setSuccess("Item deleted successfully.");
            fetchCatalogData();
        } catch (err) {
            console.warn("Error deleting item:", err.message);
            setError("Failed to delete item.");
        }
    };
    const handleRefreshCatalog = async ()=>{
        if (!isAuthenticated()) {
            setError("You must be logged in to refresh the catalog.");
            return;
        }
        if (confirm("Tem certeza que deseja atualizar o cat\xe1logo?")) await refreshCatalogData();
    };
    const handleExportCatalog = async ()=>{
        if (!isAuthenticated()) {
            setError("You must be logged in to export the catalog.");
            return;
        }
        setLoading(true);
        setError(null);
        try {
            const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).COMPOUNDS + "/_export", {
                responseType: "blob"
            });
            // Create a download link and trigger download
            const url = window.URL.createObjectURL(new Blob([
                response.data
            ]));
            const link = document.createElement("a");
            link.href = url;
            const timestamp = new Date().toISOString().replace(/[:.]/g, "-").slice(0, -5);
            link.setAttribute("download", `catalog_export_${timestamp}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
            setSuccess("Catalog exported successfully.");
        } catch (err) {
            setError(err.message || "Failed to export catalog");
            console.warn("Error exporting catalog:", err.message);
        } finally{
            setLoading(false);
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        fetchCatalogData();
    }, [
        filters
    ]);
    const [isActionsOpen, setIsActionsOpen] = (0, $acw62.useState)(false);
    const dropdownRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const handleClickOutside = (event)=>{
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) setIsActionsOpen(false);
        };
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>document.removeEventListener("mousedown", handleClickOutside);
    }, []);
    if (!isAuthenticated()) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: "You must be logged in to edit items."
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "container mx-auto p-6 max-w-7xl",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex flex-col gap-6",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex flex-col md:flex-row justify-between items-start md:items-center gap-4",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "text-3xl font-bold text-gray-900 tracking-tight",
                                    children: "Gest\xe3o do Cat\xe1logo"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "text-gray-500 mt-1",
                                    children: "Gerencie seus compostos, pre\xe7os e estoque."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "flex items-center gap-3",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "relative",
                                ref: dropdownRef,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        onClick: ()=>setIsActionsOpen(!isActionsOpen),
                                        className: "inline-flex items-center px-4 py-2 bg-white border border-gray-300 hover:bg-gray-50 text-gray-700 text-sm font-medium rounded-lg transition-colors shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500",
                                        children: [
                                            "A\xe7\xf5es",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                className: `w-4 h-4 ml-2 transition-transform ${isActionsOpen ? "rotate-180" : ""}`,
                                                fill: "none",
                                                stroke: "currentColor",
                                                viewBox: "0 0 24 24",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round",
                                                    strokeWidth: 2,
                                                    d: "M19 9l-7 7-7-7"
                                                })
                                            })
                                        ]
                                    }),
                                    isActionsOpen && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 z-50 divide-y divide-gray-100 transform opacity-100 scale-100 transition-all duration-200 origin-top-right",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "py-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $585f8bce88e531c1$export$a6c7ac8248d6e38a), {
                                                        to: "/catalog/import",
                                                        className: "group flex w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900",
                                                        onClick: ()=>setIsActionsOpen(false),
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f68e7f5ef2ab511$export$2e2bcd8739ae039), {
                                                                className: "mr-3 h-4 w-4 text-gray-400 group-hover:text-gray-500"
                                                            }),
                                                            "Importar Items"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                        onClick: handleExportCatalog,
                                                        className: "group flex w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d252ca8c87a49232$export$2e2bcd8739ae039), {
                                                                className: "mr-3 h-4 w-4 text-gray-400 group-hover:text-gray-500"
                                                            }),
                                                            "Exportar Cat\xe1logo"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                        onClick: handleRefreshCatalog,
                                                        className: "group flex w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5a2da4e22d001166$export$2e2bcd8739ae039), {
                                                                className: "mr-3 h-4 w-4 text-gray-400 group-hover:text-gray-500"
                                                            }),
                                                            "Atualizar Dados"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "py-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $585f8bce88e531c1$export$a6c7ac8248d6e38a), {
                                                        to: "/catalog/show_components_mismatched_prices",
                                                        className: "group flex w-full items-center px-4 py-2 text-sm text-amber-700 hover:bg-amber-50",
                                                        onClick: ()=>setIsActionsOpen(false),
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                                                                className: "mr-3 h-4 w-4 text-amber-500 group-hover:text-amber-600"
                                                            }),
                                                            "Verificar Pre\xe7os"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $585f8bce88e531c1$export$a6c7ac8248d6e38a), {
                                                        to: "/catalog/show_components_out_of_stock",
                                                        className: "group flex w-full items-center px-4 py-2 text-sm text-red-700 hover:bg-red-50",
                                                        onClick: ()=>setIsActionsOpen(false),
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dcddce55b19e141b$export$2e2bcd8739ae039), {
                                                                className: "mr-3 h-4 w-4 text-red-500 group-hover:text-red-600"
                                                            }),
                                                            "Verificar Stock (Substituir)"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "bg-white p-4 rounded-xl shadow-sm border border-gray-200",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex flex-col sm:flex-row gap-3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "relative max-w-2xl flex-1",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                            className: "h-5 w-5 text-gray-400",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            stroke: "currentColor",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                strokeWidth: 2,
                                                d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        type: "text",
                                        className: "block w-full pl-10 pr-3 py-2.5 border border-gray-300 rounded-lg leading-5 bg-gray-50 placeholder-gray-500 focus:outline-none focus:bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm transition-all duration-200",
                                        placeholder: "Pesquisar por nome, descri\xe7\xe3o ou categoria...",
                                        value: filters.search,
                                        onChange: (e)=>setFilters({
                                                ...filters,
                                                search: e.target.value,
                                                page: 1
                                            }),
                                        autoFocus: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                value: filters.stock_status,
                                "aria-label": "Estado de Stock",
                                onChange: (e)=>setFilters({
                                        ...filters,
                                        stock_status: e.target.value,
                                        page: 1
                                    }),
                                className: "block w-full sm:w-56 px-3 py-2.5 border border-gray-300 rounded-lg leading-5 bg-gray-50 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm transition-all duration-200",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "",
                                        children: "Estado de Stock: Todos"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "last_units",
                                        children: "\xdaltimas Unidades (1-5)"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "out_of_stock",
                                        children: "Indispon\xedvel (0)"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "manage-page",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "overflow-auto",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ff8d9cc2fa36bd73$export$2e2bcd8739ae039), {
                            data: data,
                            loading: loading,
                            filters: filters,
                            setFilters: setFilters,
                            totalPages: totalPages,
                            totalResults: totalResults,
                            onEdit: handleEdit,
                            onDelete: handleDelete,
                            onView: handleView,
                            setModalScreen: setModalScreen
                        })
                    })
                })
            ]
        })
    });
};
var $207fd09cab7d7eb8$export$2e2bcd8739ae039 = $207fd09cab7d7eb8$var$CompoundManageListPage;



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");





var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

const $df7230ae6db3bf8c$var$PriceInput = ({ price: price, allowChangeCurrency: allowChangeCurrency = false, onChange: onChange, readOnly: readOnly, inputClassName: inputClassName = "input" })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "field has-addons has-addons-left",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "control",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                    name: "price",
                    className: inputClassName,
                    type: "number",
                    value: (0, $1cec967d8d56bb4d$export$63ad841d70774900)(price.value),
                    step: "0.01",
                    min: 0,
                    readOnly: readOnly ?? false,
                    disabled: readOnly ?? false,
                    onChange: (e)=>{
                        const price_with_vat = parseFloat(e.target.value ?? "");
                        onChange({
                            value: (0, $1cec967d8d56bb4d$export$63ad841d70774900)(price_with_vat)
                        });
                    }
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "control",
                children: allowChangeCurrency ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "control",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "select",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                            disabled: readOnly ?? false,
                            name: "currency",
                            value: price.currency,
                            onChange: (e)=>onChange({
                                    currency: e.target.value
                                }),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                value: "EUR",
                                children: "EUR"
                            })
                        })
                    })
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "is-disabled m-2 p-3",
                    children: price.currency
                })
            })
        ]
    });
};
var $df7230ae6db3bf8c$export$2e2bcd8739ae039 = $df7230ae6db3bf8c$var$PriceInput;




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e17c725e7c863883$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8",
            key: "1357e3"
        }
    ],
    [
        "path",
        {
            d: "M3 3v5h5",
            key: "1xhq8a"
        }
    ],
    [
        "path",
        {
            d: "M12 7v5l4 2",
            key: "1fdv2h"
        }
    ]
];
const $e17c725e7c863883$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("history", $e17c725e7c863883$export$3efd853dbb351e94);




async function $9bc6749c2d6559da$export$ce6becba065a67ce(compoundId, resellerErpRef) {
    const params = resellerErpRef ? {
        reseller_erp_ref: resellerErpRef
    } : undefined;
    const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).COMPOUNDS}/${encodeURIComponent(compoundId)}/price-history`, {
        params: params
    });
    return response.data;
}


const $a47955a5527e9f71$export$a1ef82c6c242ab71 = {
    ok: "bg-green-50 border-green-200 text-green-700",
    warn: "bg-amber-50 border-amber-200 text-amber-700",
    neg: "bg-red-50 border-red-200 text-red-700",
    neutral: "bg-gray-50 border-gray-200 text-gray-500"
};
// Determinístico (não depende do ICU do runtime — Node pequeno não agrupa
// milhares em pt-PT): agrupa com espaço regular e usa vírgula decimal.
function $a47955a5527e9f71$var$formatEur(value) {
    const [int, frac] = value.toFixed(2).split(".");
    const grouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    return `${grouped},${frac} \u{20AC}`;
}
function $a47955a5527e9f71$var$formatPct(fraction) {
    return `${(fraction * 100).toFixed(1).replace(".", ",")}%`;
}
const $a47955a5527e9f71$export$e18dec77288a7f6d = {
    format: $a47955a5527e9f71$var$formatEur
};
const $a47955a5527e9f71$export$702237c54c4bae27 = {
    format: $a47955a5527e9f71$var$formatPct
};
function $a47955a5527e9f71$export$777dd92714dee955(pctFraction) {
    if (pctFraction == null) return "neutral";
    if (pctFraction < 0) return "neg";
    if (pctFraction < 0.05) return "warn";
    return "ok";
}


const $901db23cbd278565$var$SOURCE_LABELS = {
    MANUAL_EDIT: "Edi\xe7\xe3o manual",
    EXCEL_IMPORT: "Importa\xe7\xe3o Excel",
    ERP_SYNC: "Sincroniza\xe7\xe3o ERP",
    PRICE_ENGINE: "Motor de pre\xe7os",
    COMPONENT_EDIT: "Edi\xe7\xe3o de componente",
    SYSTEM: "Sistema"
};
const $901db23cbd278565$var$PROMO_LABELS = {
    DISCOUNT_PERCENTAGE: "Desconto (%)",
    DISCOUNT_VALUE: "Desconto (\u20AC)",
    FIXED_PVP: "PVP Fixo"
};
const $901db23cbd278565$var$TARGET_LABELS = {
    NIPOSOM_MARGIN: "Niposom",
    RESELLER_MARGIN: "Reseller",
    BOTH: "Ambas"
};
function $901db23cbd278565$var$money(value) {
    return value != null ? (0, $a47955a5527e9f71$export$e18dec77288a7f6d).format(value) : "\u2014";
}
function $901db23cbd278565$var$samePrice(a, b) {
    return a.pvp_with_vat === (b.pvp ?? null) && a.reseller_price === (b.reseller ?? null);
}
function $901db23cbd278565$var$styleMargin(value, pctValue) {
    if (value == null) return "\u2014";
    const tone = (0, $a47955a5527e9f71$export$777dd92714dee955)(pctValue);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
        className: `inline-flex items-center gap-1 rounded px-1.5 py-0.5 ${(0, $a47955a5527e9f71$export$a1ef82c6c242ab71)[tone]}`,
        children: [
            (0, $a47955a5527e9f71$export$e18dec77288a7f6d).format(value),
            pctValue != null ? ` \xb7 ${(0, $a47955a5527e9f71$export$702237c54c4bae27).format(pctValue)}` : ""
        ]
    });
}
function $901db23cbd278565$var$formatDay(value) {
    return value ? new Date(value).toLocaleDateString("pt-PT") : "\u2014";
}
function $901db23cbd278565$var$formatDateTime(value) {
    return new Date(value).toLocaleString("pt-PT");
}
function $901db23cbd278565$var$formatWindow(starts, ends) {
    return `${$901db23cbd278565$var$formatDay(starts)} \u{2192} ${$901db23cbd278565$var$formatDay(ends)}`;
}
/** Background colour + label for a timeline row, by campaign state. */ function $901db23cbd278565$var$entryStyle(entry) {
    if (entry.reason === "CAMPAIGN_END") return {
        rowClass: "bg-gray-100",
        label: entry.campaign_name ? `Fim de campanha: ${entry.campaign_name}` : "Base"
    };
    if (entry.source !== "CAMPAIGN" || !entry.campaign_name) return {
        rowClass: "",
        label: "Base"
    };
    switch(entry.state){
        case "SCHEDULED":
            return {
                rowClass: "bg-blue-50",
                label: `Agendada: ${entry.campaign_name}`
            };
        case "ENDED":
            return {
                rowClass: "bg-gray-100",
                label: `Campanha (terminada): ${entry.campaign_name}`
            };
        default:
            return {
                rowClass: "bg-amber-50",
                label: `Em campanha: ${entry.campaign_name}`
            };
    }
}
function $901db23cbd278565$var$PriceRow({ at: at, pvp: pvp, reseller: reseller, rowClass: rowClass, label: label, isCurrent: isCurrent }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `flex flex-wrap items-center gap-x-6 gap-y-1 py-3 px-3 rounded ${rowClass ?? ""}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "min-w-[12rem]",
                children: isCurrent ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    className: "flex items-center gap-2",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "rounded-full bg-blue-600 px-2 py-0.5 text-xs font-semibold text-white",
                            children: "Agora"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "text-xs text-gray-500",
                            children: $901db23cbd278565$var$formatDateTime(at)
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "text-xs text-gray-500",
                    children: $901db23cbd278565$var$formatDateTime(at)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "min-w-[7rem] text-right",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "block text-xs text-gray-500",
                        children: "PVP c/IVA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "tabular-nums font-semibold text-green-700",
                        children: $901db23cbd278565$var$money(pvp)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "min-w-[8rem] text-right",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "block text-xs text-gray-500",
                        children: "Pre\xe7o Reseller (s/IVA)"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "tabular-nums",
                        children: $901db23cbd278565$var$money(reseller)
                    })
                ]
            }),
            label && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "text-xs text-gray-600",
                children: label
            })
        ]
    });
}
function $901db23cbd278565$var$ConsolidatedPriceList({ data: data }) {
    const timeline = data.timeline ?? [];
    const current = data.current_effective;
    const now = Date.now();
    const isFuture = (e)=>new Date(e.at).getTime() > now;
    const past = timeline.filter((e)=>!isFuture(e)); // already newest-first
    const future = timeline.filter(isFuture).slice().reverse(); // nearest first
    if (timeline.length === 0 && !current) return /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
        className: "text-gray-500 text-sm py-4",
        children: "Sem hist\xf3rico. O registo come\xe7a a partir da primeira altera\xe7\xe3o de pre\xe7o ou ativa\xe7\xe3o de campanha ap\xf3s esta vers\xe3o."
    });
    const currentFromTimeline = !current && past.length > 0 ? past[0] : null;
    // The row used as "Agora" must not repeat in the history list. When a live
    // current_effective is shown, also drop the campaign-end row of that same
    // campaign: a window edited after activation makes the frozen timeline end
    // before the live one, which would otherwise read "Agora: Em campanha X" right
    // above "Fim de campanha: X".
    let pastRows;
    if (current) {
        const withoutSameCampaignEnd = past.filter((e)=>!(e.reason === "CAMPAIGN_END" && e.campaign_id === current.campaign_id));
        pastRows = withoutSameCampaignEnd.length > 0 && $901db23cbd278565$var$samePrice(withoutSameCampaignEnd[0], {
            pvp: current.promotional_pvp_with_vat,
            reseller: current.promotional_reseller_price
        }) ? withoutSameCampaignEnd.slice(1) : withoutSameCampaignEnd;
    } else // past[0] is the "Agora" row in this case.
    pastRows = past.slice(1);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            current && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($901db23cbd278565$var$PriceRow, {
                    at: current.computed_at,
                    pvp: current.promotional_pvp_with_vat,
                    reseller: current.promotional_reseller_price,
                    isCurrent: true,
                    rowClass: current.campaign_name ? "bg-amber-50" : "",
                    label: current.campaign_name ? `Em campanha: ${current.campaign_name}` : "Base"
                })
            }),
            currentFromTimeline && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($901db23cbd278565$var$PriceRow, {
                    at: currentFromTimeline.at,
                    pvp: currentFromTimeline.pvp_with_vat,
                    reseller: currentFromTimeline.reseller_price,
                    isCurrent: true,
                    rowClass: $901db23cbd278565$var$entryStyle(currentFromTimeline).rowClass,
                    label: $901db23cbd278565$var$entryStyle(currentFromTimeline).label
                })
            }),
            pastRows.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                className: "divide-y",
                children: pastRows.map((e, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($901db23cbd278565$var$PriceRow, {
                            at: e.at,
                            pvp: e.pvp_with_vat,
                            reseller: e.reseller_price,
                            rowClass: $901db23cbd278565$var$entryStyle(e).rowClass,
                            label: $901db23cbd278565$var$entryStyle(e).label
                        })
                    }, `past-${e.at}-${e.source}-${e.campaign_id ?? 0}-${i}`))
            }),
            !current && !currentFromTimeline && future.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "text-gray-500 text-sm py-4",
                children: "Ainda sem pre\xe7o registado."
            }),
            future.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mt-4",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                        className: "text-sm font-medium text-gray-700 mb-1",
                        children: "Pr\xf3ximas altera\xe7\xf5es"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                        className: "divide-y",
                        children: future.map((e, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($901db23cbd278565$var$PriceRow, {
                                    at: e.at,
                                    pvp: e.pvp_with_vat,
                                    reseller: e.reseller_price,
                                    rowClass: $901db23cbd278565$var$entryStyle(e).rowClass,
                                    label: $901db23cbd278565$var$entryStyle(e).label
                                })
                            }, `future-${e.at}-${e.source}-${e.campaign_id ?? 0}-${i}`))
                    })
                ]
            })
        ]
    });
}
function $901db23cbd278565$var$DriftBadge({ baseCaptured: baseCaptured, mismatchFields: mismatchFields, erpComparable: erpComparable, configuredComparable: configuredComparable }) {
    if (!baseCaptured) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: "rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-600",
        children: "base n\xe3o capturada"
    });
    if (!configuredComparable) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: "rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-600",
        title: "Sem base configurada completa; alinhamento n\xe3o verific\xe1vel",
        children: "n\xe3o verific\xe1vel"
    });
    if (!erpComparable) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: "rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-600",
        title: "Sem refer\xeancia ERP; alinhamento n\xe3o verific\xe1vel",
        children: "n\xe3o verific\xe1vel"
    });
    if (mismatchFields.length > 0) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: "rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-800 ring-1 ring-inset ring-amber-300",
        children: "desalinhado"
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: "rounded-full bg-green-100 px-2 py-0.5 text-xs font-medium text-green-800",
        children: "ok"
    });
}
function $901db23cbd278565$var$BaseChangesTable({ rows: rows }) {
    if (rows.length === 0) return /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
        className: "text-sm text-gray-500 py-2",
        children: "Sem altera\xe7\xf5es de pre\xe7o base registadas."
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "overflow-x-auto",
        tabIndex: 0,
        role: "region",
        "aria-label": "Altera\xe7\xf5es de pre\xe7o base",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
            className: "w-full min-w-[60rem] text-sm",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("caption", {
                    className: "sr-only",
                    children: "Altera\xe7\xf5es de pre\xe7o base por data"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                        className: "border-b text-left",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                scope: "col",
                                className: "pb-2 font-medium",
                                children: "Data"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                scope: "col",
                                className: "pb-2 font-medium",
                                children: "Origem"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                scope: "col",
                                className: "pb-2 font-medium",
                                children: "Campos"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                scope: "col",
                                className: "pb-2 font-medium text-right",
                                children: "PVP c/IVA"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                scope: "col",
                                className: "pb-2 font-medium text-right",
                                children: "Pre\xe7o Reseller (s/IVA)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                scope: "col",
                                className: "pb-2 font-medium text-right",
                                children: "Margem Reseller"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                    children: rows.map((r)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                            className: "border-b",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                    scope: "row",
                                    className: "py-2 font-normal text-left whitespace-nowrap",
                                    children: $901db23cbd278565$var$formatDateTime(r.changed_at)
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                    className: "py-2",
                                    children: [
                                        $901db23cbd278565$var$SOURCE_LABELS[r.source] || r.source,
                                        r.actor && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "ml-1 text-xs text-gray-500",
                                            children: [
                                                "(",
                                                r.actor,
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                    className: "py-2 text-xs text-gray-600",
                                    children: r.changed_fields.join(", ")
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                    className: "py-2 text-right tabular-nums",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "text-gray-400 line-through mr-1",
                                            children: $901db23cbd278565$var$money(r.old_configured_pvp_with_vat)
                                        }),
                                        $901db23cbd278565$var$money(r.new_configured_pvp_with_vat)
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                    className: "py-2 text-right tabular-nums",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "text-gray-400 line-through mr-1",
                                            children: $901db23cbd278565$var$money(r.old_configured_base_retail_price)
                                        }),
                                        $901db23cbd278565$var$money(r.new_configured_base_retail_price)
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                    className: "py-2 text-right tabular-nums",
                                    children: $901db23cbd278565$var$styleMargin(r.reseller_margin_value, r.reseller_margin_pct)
                                })
                            ]
                        }, r.id))
                })
            ]
        })
    });
}
function $901db23cbd278565$var$ActivationStatus({ deactivatedAt: deactivatedAt, startsAt: startsAt, endsAt: endsAt }) {
    if (deactivatedAt) return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
        className: "rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-700",
        children: [
            "Encerrada em ",
            $901db23cbd278565$var$formatDay(deactivatedAt)
        ]
    });
    if (endsAt && new Date(endsAt).getTime() < Date.now()) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: "rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-800",
        children: "Expirada"
    });
    if (startsAt && new Date(startsAt).getTime() > Date.now()) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: "rounded-full bg-blue-100 px-2 py-0.5 text-xs font-medium text-blue-800",
        children: "Agendada"
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: "rounded-full bg-green-100 px-2 py-0.5 text-xs font-medium text-green-800",
        children: "Ativa"
    });
}
function $901db23cbd278565$var$ActivationsTable({ rows: rows }) {
    if (rows.length === 0) return /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
        className: "text-sm text-gray-500 py-2",
        children: "Sem ativa\xe7\xf5es de campanha registadas."
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "overflow-x-auto",
        tabIndex: 0,
        role: "region",
        "aria-label": "Ativa\xe7\xf5es de campanha",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
            className: "w-full min-w-[64rem] text-sm",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("caption", {
                    className: "sr-only",
                    children: "Ativa\xe7\xf5es de campanha que aplicaram este composto"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                        className: "border-b text-left",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                scope: "col",
                                className: "pb-2 font-medium",
                                children: "Ativada em"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                scope: "col",
                                className: "pb-2 font-medium",
                                children: "Estado"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                scope: "col",
                                className: "pb-2 font-medium",
                                children: "Campanha"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                scope: "col",
                                className: "pb-2 font-medium",
                                children: "Alvo"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                scope: "col",
                                className: "pb-2 font-medium text-right",
                                children: "PVP promo (c/IVA)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                scope: "col",
                                className: "pb-2 font-medium text-right",
                                children: "Pre\xe7o Reseller promo (s/IVA)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                scope: "col",
                                className: "pb-2 font-medium",
                                children: "ERP"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                    children: rows.map((a)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                            className: "border-b",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("th", {
                                    scope: "row",
                                    className: "py-2 font-normal text-left whitespace-nowrap",
                                    children: [
                                        $901db23cbd278565$var$formatDateTime(a.activated_at),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "block text-xs text-gray-500",
                                            children: a.is_global ? "Global" : a.reseller_erp_ref || "\u2014"
                                        }),
                                        (a.starts_at || a.ends_at) && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "block text-xs text-gray-500",
                                            title: "Janela agendada na ativa\xe7\xe3o; altera\xe7\xf5es posteriores da campanha em curso n\xe3o ficam registadas aqui",
                                            children: [
                                                "Janela: ",
                                                $901db23cbd278565$var$formatWindow(a.starts_at, a.ends_at)
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                    className: "py-2",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($901db23cbd278565$var$ActivationStatus, {
                                        deactivatedAt: a.deactivated_at,
                                        startsAt: a.starts_at,
                                        endsAt: a.ends_at
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                    className: "py-2",
                                    children: a.campaign_name
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                    className: "py-2",
                                    children: [
                                        a.discount_target ? $901db23cbd278565$var$TARGET_LABELS[a.discount_target] || a.discount_target : "\u2014",
                                        a.is_niposom_funded && a.discount_target === "BOTH" && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "ml-1 text-xs text-gray-500",
                                            children: "(financiado)"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "block text-xs text-gray-500",
                                            children: $901db23cbd278565$var$PROMO_LABELS[a.promo_type] || a.promo_type
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                    className: "py-2 text-right tabular-nums font-semibold text-green-700",
                                    children: [
                                        a.promotional_pvp_with_vat != null ? (0, $a47955a5527e9f71$export$e18dec77288a7f6d).format(a.promotional_pvp_with_vat) : "\u2014",
                                        a.is_niposom_funded && a.niposom_promo_margin_value != null && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "block text-xs font-normal text-gray-500",
                                            children: [
                                                "margem Niposom",
                                                " ",
                                                $901db23cbd278565$var$styleMargin(a.niposom_promo_margin_value, null)
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                    className: "py-2 text-right tabular-nums",
                                    children: [
                                        $901db23cbd278565$var$money(a.promotional_reseller_price),
                                        a.reseller_promo_margin_value != null && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "block text-xs text-gray-500",
                                            children: [
                                                "margem ",
                                                $901db23cbd278565$var$styleMargin(a.reseller_promo_margin_value, null)
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                    className: "py-2",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($901db23cbd278565$var$DriftBadge, {
                                        baseCaptured: a.base_captured,
                                        mismatchFields: a.mismatch_fields,
                                        configuredComparable: a.configured_pvp_with_vat != null && a.configured_pvp_without_vat != null && a.configured_base_retail_price != null && a.configured_base_cost_price != null,
                                        erpComparable: a.erp_price_pvp_with_vat != null && a.erp_price_pvp_without_vat != null && a.erp_base_retail_price != null && a.erp_base_cost_price != null
                                    })
                                })
                            ]
                        }, `${a.activation_id}-${a.item_id ?? 0}`))
                })
            ]
        })
    });
}
const $901db23cbd278565$var$CompoundPriceHistorySection = ({ compoundId: compoundId })=>{
    const [resellerErpRef, setResellerErpRef] = (0, $acw62.useState)("");
    const [data, setData] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const reqId = (0, $acw62.useRef)(0);
    const load = (0, $acw62.useCallback)(async (ref)=>{
        const id = ++reqId.current;
        setLoading(true);
        setError(null);
        try {
            const result = await (0, $9bc6749c2d6559da$export$ce6becba065a67ce)(compoundId, ref);
            if (id !== reqId.current) return;
            setData(result);
        } catch (err) {
            if (id !== reqId.current) return;
            setError(err.response?.data?.message || "Erro ao carregar hist\xf3rico de pre\xe7os");
        } finally{
            if (id === reqId.current) setLoading(false);
        }
    }, [
        compoundId
    ]);
    (0, $acw62.useEffect)(()=>{
        // Loaded on mount; the parent tab mounts this component only when active, so
        // each open reflects the latest prices.
        load();
    }, [
        load
    ]);
    const resellerOptions = data ? Array.from(new Set(data.activations.filter((a)=>!a.is_global && a.reseller_erp_ref).map((a)=>a.reseller_erp_ref))).sort() : [];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "bg-white rounded-lg shadow p-6",
        "aria-labelledby": "compound-price-history-heading",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                id: "compound-price-history-heading",
                className: "sr-only",
                children: "Hist\xf3rico de pre\xe7os"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex flex-wrap items-end gap-3 mb-4",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                        className: "text-sm",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "block font-medium text-gray-700 mb-1",
                                children: "Reseller (ERP Ref)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                value: resellerOptions.includes(resellerErpRef) ? resellerErpRef : "",
                                onChange: (e)=>{
                                    setResellerErpRef(e.target.value);
                                    load(e.target.value || undefined);
                                },
                                className: "border rounded-lg px-3 py-1.5",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "",
                                        children: "Global (sem reseller)"
                                    }),
                                    resellerOptions.map((ref)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                            value: ref,
                                            children: ref
                                        }, ref))
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                        className: "text-sm",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "block font-medium text-gray-700 mb-1",
                                children: "Outro (ERP Ref)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                type: "text",
                                value: resellerErpRef,
                                onChange: (e)=>setResellerErpRef(e.target.value),
                                className: "border rounded-lg px-3 py-1.5",
                                placeholder: "ex: R123"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        type: "button",
                        onClick: ()=>load(resellerErpRef || undefined),
                        disabled: loading,
                        className: "px-3 py-1.5 bg-blue-600 text-white rounded-lg text-sm hover:bg-blue-700 disabled:bg-gray-300",
                        children: "Aplicar"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "flex items-center gap-1 text-gray-500 text-sm ml-auto",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e17c725e7c863883$export$2e2bcd8739ae039), {
                                className: "w-4 h-4",
                                "aria-hidden": "true"
                            }),
                            "Pre\xe7o a cada momento"
                        ]
                    })
                ]
            }),
            loading && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                role: "status",
                className: "text-gray-500 py-4",
                children: "A carregar hist\xf3rico\u2026"
            }),
            error && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                role: "alert",
                className: "text-red-700 py-2",
                children: error
            }),
            !loading && data && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "space-y-6",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($901db23cbd278565$var$ConsolidatedPriceList, {
                        data: data
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("details", {
                        className: "border-t pt-4",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("summary", {
                                className: "cursor-pointer text-sm font-medium text-gray-700",
                                children: "Detalhe (altera\xe7\xf5es de base e ativa\xe7\xf5es com ERP)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "space-y-6 mt-4",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                className: "font-semibold mb-2",
                                                children: "Altera\xe7\xf5es de base"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($901db23cbd278565$var$BaseChangesTable, {
                                                rows: data.base_changes
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                className: "font-semibold mb-2",
                                                children: "Ativa\xe7\xf5es de campanha (todas)"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($901db23cbd278565$var$ActivationsTable, {
                                                rows: data.activations
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $901db23cbd278565$export$2e2bcd8739ae039 = $901db23cbd278565$var$CompoundPriceHistorySection;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


async function $d079bb02d222d078$export$96cbc24493abea27(compoundId) {
    const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).COMPOUNDS}/${encodeURIComponent(compoundId)}/campaigns`);
    return response.data;
}



function $efa59d6f62083a5c$export$2e2bcd8739ae039({ compoundId: compoundId }) {
    const [campaigns, setCampaigns] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        setLoading(true);
        (0, $d079bb02d222d078$export$96cbc24493abea27)(compoundId).then((data)=>{
            if (cancelled) return;
            setCampaigns(data);
            setError(null);
        }).catch((err)=>{
            if (cancelled) return;
            setError(err?.response?.data?.message || "N\xe3o foi poss\xedvel carregar as campanhas.");
        }).finally(()=>{
            if (!cancelled) setLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        compoundId
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "bg-white rounded-lg shadow p-6 mt-6",
        "aria-labelledby": "active-campaigns-heading",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                id: "active-campaigns-heading",
                className: "text-xl font-semibold mb-3",
                children: "Campanhas ativas"
            }),
            loading && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                role: "status",
                className: "text-sm text-gray-500",
                children: "A carregar campanhas\u2026"
            }),
            error && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                role: "alert",
                className: "text-sm text-red-600",
                children: error
            }),
            !loading && !error && campaigns.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "text-sm text-gray-500",
                children: "Sem campanhas ativas para este composto."
            }),
            !loading && campaigns.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "overflow-x-auto",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                    className: "w-full text-sm",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("caption", {
                            className: "sr-only",
                            children: "Campanhas ativas e pre\xe7os promocionais"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                className: "text-left text-gray-500 border-b",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        scope: "col",
                                        className: "py-2 pr-3",
                                        children: "Campanha"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        scope: "col",
                                        className: "py-2 pr-3",
                                        children: "\xc2mbito"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        scope: "col",
                                        className: "py-2 pr-3",
                                        children: "Per\xedodo"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        scope: "col",
                                        className: "py-2 pr-3 text-right",
                                        children: "PVP promocional"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        scope: "col",
                                        className: "py-2 text-right",
                                        children: "Pre\xe7o reseller"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                            children: campaigns.map((c)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                    className: "border-b",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "py-2 pr-3",
                                            children: c.name
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "py-2 pr-3",
                                            children: c.is_global ? "Global" : `Reseller ${c.reseller_erp_ref ?? "\u2014"}`
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                            className: "py-2 pr-3",
                                            children: [
                                                new Date(c.starts_at).toLocaleDateString("pt-PT"),
                                                " \u2014",
                                                " ",
                                                new Date(c.ends_at).toLocaleDateString("pt-PT")
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "py-2 pr-3 text-right tabular-nums",
                                            children: c.promotional_pvp_with_vat != null ? (0, $a47955a5527e9f71$export$e18dec77288a7f6d).format(c.promotional_pvp_with_vat) : "\u2014"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "py-2 text-right tabular-nums",
                                            children: c.promotional_reseller_price != null ? (0, $a47955a5527e9f71$export$e18dec77288a7f6d).format(c.promotional_reseller_price) : "\u2014"
                                        })
                                    ]
                                }, c.campaign_id))
                        })
                    ]
                })
            })
        ]
    });
}



/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8afc40d49a7e79bf$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 8V4H8",
            key: "hb8ula"
        }
    ],
    [
        "rect",
        {
            width: "16",
            height: "12",
            x: "4",
            y: "8",
            rx: "2",
            key: "enze0r"
        }
    ],
    [
        "path",
        {
            d: "M2 14h2",
            key: "vft8re"
        }
    ],
    [
        "path",
        {
            d: "M20 14h2",
            key: "4cs60a"
        }
    ],
    [
        "path",
        {
            d: "M15 13v2",
            key: "1xurst"
        }
    ],
    [
        "path",
        {
            d: "M9 13v2",
            key: "rq6x2g"
        }
    ]
];
const $8afc40d49a7e79bf$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("bot", $8afc40d49a7e79bf$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e20ffdae2aa9b33f$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "18",
            height: "11",
            x: "3",
            y: "11",
            rx: "2",
            ry: "2",
            key: "1w4ew1"
        }
    ],
    [
        "path",
        {
            d: "M7 11V7a5 5 0 0 1 10 0v4",
            key: "fwvmzm"
        }
    ]
];
const $e20ffdae2aa9b33f$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("lock", $e20ffdae2aa9b33f$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $6c2a827dd5c2d433$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
            key: "1a8usu"
        }
    ],
    [
        "path",
        {
            d: "m15 5 4 4",
            key: "1mk7zo"
        }
    ]
];
const $6c2a827dd5c2d433$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("pencil", $6c2a827dd5c2d433$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8a800148d042d893$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8",
            key: "v9h5vc"
        }
    ],
    [
        "path",
        {
            d: "M21 3v5h-5",
            key: "1q7to0"
        }
    ],
    [
        "path",
        {
            d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16",
            key: "3uifl3"
        }
    ],
    [
        "path",
        {
            d: "M8 16H3v5",
            key: "1cv678"
        }
    ]
];
const $8a800148d042d893$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("refresh-cw", $8a800148d042d893$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $948595fc4549df01$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m2 2 20 20",
            key: "1ooewy"
        }
    ],
    [
        "path",
        {
            d: "M5 5a1 1 0 0 0-1 1v7c0 5 3.5 7.5 7.67 8.94a1 1 0 0 0 .67.01c2.35-.82 4.48-1.97 5.9-3.71",
            key: "1jlk70"
        }
    ],
    [
        "path",
        {
            d: "M9.309 3.652A12.252 12.252 0 0 0 11.24 2.28a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1v7a9.784 9.784 0 0 1-.08 1.264",
            key: "18rp1v"
        }
    ]
];
const $948595fc4549df01$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("shield-off", $948595fc4549df01$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5faf23ec0b8e3e8e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z",
            key: "4pj2yx"
        }
    ],
    [
        "path",
        {
            d: "M20 3v4",
            key: "1olli1"
        }
    ],
    [
        "path",
        {
            d: "M22 5h-4",
            key: "1gvqau"
        }
    ],
    [
        "path",
        {
            d: "M4 17v2",
            key: "vumght"
        }
    ],
    [
        "path",
        {
            d: "M5 18H3",
            key: "zchphs"
        }
    ]
];
const $5faf23ec0b8e3e8e$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("sparkles", $5faf23ec0b8e3e8e$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $1d55a58c47e43a5b$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3 6h18",
            key: "d0wm0j"
        }
    ],
    [
        "path",
        {
            d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6",
            key: "4alrt4"
        }
    ],
    [
        "path",
        {
            d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2",
            key: "v07s0e"
        }
    ],
    [
        "line",
        {
            x1: "10",
            x2: "10",
            y1: "11",
            y2: "17",
            key: "1uufr5"
        }
    ],
    [
        "line",
        {
            x1: "14",
            x2: "14",
            y1: "11",
            y2: "17",
            key: "xtxkd"
        }
    ]
];
const $1d55a58c47e43a5b$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("trash-2", $1d55a58c47e43a5b$export$3efd853dbb351e94);




function $a90953901eac57a3$export$5cc558fbc99919c1(data) {
    return {
        ...data,
        getCostPrice (type = "configured") {
            if (type === "configured") return this.configured_cost_price;
            return this.erp_cost_price;
        },
        getRev4Price (type = "configured") {
            if (type === "configured") return this.configured_compound_reseller_price;
            return this.erp_compound_reseller_price;
        },
        getResellerPrice (type = "configured") {
            if (type === "configured") return this.configured_reseller_price;
            return this.erp_reseller_price;
        },
        getDiscountValue (type = "configured") {
            if (type === "configured") return this.configured_discount_value;
            return this.erp_discount_value;
        },
        getDiscountRate (type = "configured") {
            if (type === "configured") return this.configured_discount_rate;
            return this.erp_discount_rate;
        },
        getOverridePrice (type = "configured") {
            if (type === "configured") return this.configured_override_price;
            return this.erp_override_price;
        },
        getAvailableQuantity (type = "configured") {
            if (type === "configured") return this.configured_available_quantity;
            return this.erp_available_quantity;
        },
        checkPriceDifference () {
            const diff = (0, $1cec967d8d56bb4d$export$63ad841d70774900)(this.getResellerPrice("erp")) - (0, $1cec967d8d56bb4d$export$63ad841d70774900)(this.getResellerPrice("configured"));
            if (diff > 0.1 || diff < -0.1) {
                console.log(`Price difference for component ${this.component_name} (ID: ${this.id}): ERP Price = ${this.getResellerPrice("erp")}, Configured Price = ${this.getResellerPrice("configured")}, Difference = ${diff}`);
                return diff;
            }
            const diffCost = (0, $1cec967d8d56bb4d$export$63ad841d70774900)(this.getCostPrice("erp")) - (0, $1cec967d8d56bb4d$export$63ad841d70774900)(this.getCostPrice("configured"));
            if (diff > 0.1 || diff < -0.1) {
                console.log(`Cost price difference for component ${this.component_name} (ID: ${this.id}): ERP Cost Price = ${this.getCostPrice("erp")}, Configured Cost Price = ${this.getCostPrice("configured")}, Difference = ${diffCost}`);
                return diffCost;
            }
            return 0;
        }
    };
}




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $9ad14973a512851d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m21 21-4.34-4.34",
            key: "14j7rj"
        }
    ],
    [
        "circle",
        {
            cx: "11",
            cy: "11",
            r: "8",
            key: "4ej97u"
        }
    ]
];
const $9ad14973a512851d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("search", $9ad14973a512851d$export$3efd853dbb351e94);


const $cdfd57be71fcf6f6$export$da71685f71dc8f28 = {
    Processador: "222CPU",
    Motherboard: "222MBA",
    "Placa Gr\xe1fica": "222PGV",
    "Mem\xf3ria RAM": "222MEM",
    Armazenamento: "222HDD",
    "Fonte de Alimenta\xe7\xe3o": "222PSU",
    Caixa: "222CAX",
    Cooler: "222DIS"
};
const $cdfd57be71fcf6f6$var$ProductSearchInput = ({ value: value, onChange: onChange, onSelect: onSelect, placeholder: placeholder = "", className: className = "", componentType: componentType, allProducts: allProducts = false })=>{
    const [suggestions, setSuggestions] = (0, $acw62.useState)([]);
    const [showSuggestions, setShowSuggestions] = (0, $acw62.useState)(false);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [dropdownPosition, setDropdownPosition] = (0, $acw62.useState)({
        top: 0,
        left: 0,
        width: 0
    });
    const wrapperRef = (0, $acw62.useRef)(null);
    const inputRef = (0, $acw62.useRef)(null);
    const updateDropdownPosition = ()=>{
        if (inputRef.current) {
            const rect = inputRef.current.getBoundingClientRect();
            setDropdownPosition({
                top: rect.bottom,
                left: rect.left,
                width: rect.width
            });
        }
    };
    (0, $acw62.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) setShowSuggestions(false);
        };
        const handleScroll = ()=>{
            updateDropdownPosition();
        };
        document.addEventListener("mousedown", handleClickOutside);
        window.addEventListener("scroll", handleScroll, true);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
            window.removeEventListener("scroll", handleScroll, true);
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        const timerId = setTimeout(()=>{
            if (value.length >= 2) fetchSuggestions(value);
            else {
                setSuggestions([]);
                setShowSuggestions(false);
            }
        }, 500); // Debounce time
        return ()=>{
            clearTimeout(timerId);
        };
    }, [
        value,
        componentType
    ]);
    const fetchSuggestions = async (query)=>{
        setLoading(true);
        try {
            const rootCategoryId = componentType ? $cdfd57be71fcf6f6$export$da71685f71dc8f28[componentType] : undefined;
            // Always use GET /compounds/products/_search — pass rootCategoryId as query param when filtering by slot
            const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).COMPOUNDS + "/products/_search", {
                params: {
                    search: query,
                    limit: 10,
                    ...rootCategoryId ? {
                        rootCategoryId: rootCategoryId
                    } : {},
                    ...allProducts ? {
                        allProducts: true
                    } : {}
                }
            });
            const results = response.data?.results ?? [];
            setSuggestions(results);
            setShowSuggestions(true);
        } catch (error) {
            console.error("Error fetching products:", error);
            setSuggestions([]);
        } finally{
            setLoading(false);
        }
    };
    const handleSelect = (product)=>{
        onSelect(product);
        setShowSuggestions(false);
    // We might want to keep the value as the reference or name, depending on use case
    // For now, we let the parent handle the value update via onSelect -> parent state update -> value prop
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        ref: wrapperRef,
        className: `relative ${className}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        ref: inputRef,
                        type: "text",
                        className: "w-full border rounded px-2 py-1 text-gray-900 pr-8",
                        value: value,
                        onChange: (e)=>onChange(e.target.value),
                        placeholder: placeholder,
                        onFocus: ()=>{
                            updateDropdownPosition();
                            if (value.length >= 2) setShowSuggestions(true);
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400",
                        children: loading ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "animate-spin h-4 w-4 border-2 border-blue-500 rounded-full border-t-transparent"
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ad14973a512851d$export$2e2bcd8739ae039), {
                            size: 16
                        })
                    })
                ]
            }),
            showSuggestions && suggestions.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                className: "fixed z-50 min-w-96 bg-white border border-gray-300 rounded mt-1 shadow-lg max-h-60 overflow-y-auto",
                style: {
                    top: `${dropdownPosition.top}px`,
                    left: `${dropdownPosition.left}px`
                },
                children: suggestions.map((product)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                        className: "px-3 py-2 hover:bg-gray-100 cursor-pointer text-sm",
                        onClick: ()=>handleSelect(product),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "font-medium text-gray-900",
                                children: product.id
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "text-gray-500 text-xs truncate",
                                children: product.name
                            })
                        ]
                    }, product.id))
            }),
            showSuggestions && suggestions.length === 0 && !loading && value.length >= 2 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "fixed z-50 min-w-96 bg-white border border-gray-300 rounded mt-1 shadow-lg p-2 text-sm text-gray-500 text-center",
                style: {
                    top: `${dropdownPosition.top}px`,
                    left: `${dropdownPosition.left}px`
                },
                children: "Nenhum produto encontrado."
            })
        ]
    });
};
var $cdfd57be71fcf6f6$export$2e2bcd8739ae039 = $cdfd57be71fcf6f6$var$ProductSearchInput;




// ponytail: flat service — no IoC container needed for this scope
function $7bb5f02448dcd90f$var$normalizeComponent(c) {
    return {
        ...c,
        quantity: typeof c.quantity === "string" ? parseInt(c.quantity, 10) || 1 : c.quantity || 1,
        configured_compound_reseller_price: Number(c.configured_compound_reseller_price),
        configured_discount_rate: Number(c.configured_discount_rate),
        configured_discount_value: Number(c.configured_discount_value),
        configured_reseller_price: Number(c.configured_reseller_price),
        configured_cost_price: Number(c.configured_cost_price),
        erp_compound_reseller_price: Number(c.erp_compound_reseller_price),
        erp_discount_rate: Number(c.erp_discount_rate),
        erp_discount_value: Number(c.erp_discount_value),
        erp_reseller_price: Number(c.erp_reseller_price),
        erp_cost_price: Number(c.erp_cost_price),
        vat_rate: Number(c.vat_rate),
        configured_available_quantity: Number(c.configured_available_quantity),
        erp_available_quantity: Number(c.erp_available_quantity)
    };
}
async function $7bb5f02448dcd90f$export$17578421efdb3356(compoundId, component) {
    const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).post((0, $cd93687958c8007e$export$bfe19bc25132bb7c).COMPOUNDS + `/${encodeURIComponent(compoundId)}/components`, $7bb5f02448dcd90f$var$normalizeComponent(component));
    return res.data;
}
async function $7bb5f02448dcd90f$export$3d375ec46cfe3d13(compoundId, componentId, component) {
    const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).put((0, $cd93687958c8007e$export$bfe19bc25132bb7c).COMPOUNDS + `/${encodeURIComponent(compoundId)}/components/${encodeURIComponent(componentId)}`, $7bb5f02448dcd90f$var$normalizeComponent(component));
    return res.data;
}
async function $7bb5f02448dcd90f$export$b131bf5b3493873b(compoundId, componentId) {
    const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).delete((0, $cd93687958c8007e$export$bfe19bc25132bb7c).COMPOUNDS + `/${encodeURIComponent(compoundId)}/components/${encodeURIComponent(componentId)}`);
    return res.data;
}
async function $7bb5f02448dcd90f$export$df2b2ae2f1cb6afc(compoundId, body) {
    const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).put((0, $cd93687958c8007e$export$bfe19bc25132bb7c).COMPOUNDS + `/${encodeURIComponent(compoundId)}`, body);
    return res.data;
}


const $52125b4485a7e10a$var$CompoundManageEditPage = ()=>{
    const { id: id } = (0, $585f8bce88e531c1$export$99eaa27ddbbb95ef)();
    const { pathname: pathname } = (0, $585f8bce88e531c1$export$45d76561a5302f2b)();
    const navigate = (0, $585f8bce88e531c1$export$9770f232ac06a008)();
    const { isAuthenticated: isAuthenticated, isAdmin: isAdmin } = (0, $b622ef53e38024e7$export$1d39dc5b47e56ff0)();
    const { error: error, setError: setError, success: success, setSuccess: setSuccess, loading: loading, setLoading: setLoading } = (0, $a55f2a94cd420149$export$c50e37a2f0a2b064)();
    const [data, setData] = (0, $acw62.useState)(null);
    const [activeTab, setActiveTab] = (0, $acw62.useState)("components");
    const compoundTabRefs = (0, $acw62.useRef)({});
    const [items, setItems] = (0, $acw62.useState)([]); // This seems to be the list of components related to the compound
    const [file, setFile] = (0, $acw62.useState)(null);
    const [collapsedSections, setCollapsedSections] = (0, $acw62.useState)({});
    const [editingComponentId, setEditingComponentId] = (0, $acw62.useState)(null);
    const [editedComponentData, setEditedComponentData] = (0, $acw62.useState)(null);
    const [showAddComponentSection, setShowAddComponentSection] = (0, $acw62.useState)(false);
    const [newComponentType, setNewComponentType] = (0, $acw62.useState)("");
    const [categories, setCategories] = (0, $acw62.useState)([]);
    const [statusOptions] = (0, $acw62.useState)([
        {
            value: "DRAFT",
            label: "Rascunho"
        },
        {
            value: "PENDING",
            label: "Pendente"
        },
        {
            value: "PUBLISHED",
            label: "Publicado"
        },
        {
            value: "HIDDEN",
            label: "Oculto"
        },
        {
            value: "ARCHIVED",
            label: "Arquivado"
        }
    ]);
    const availableTags = [
        {
            value: "PROMOCAO",
            label: "Promo\xe7\xe3o",
            color: "bg-red-100 text-red-800 border-red-300"
        },
        {
            value: "NOVIDADE",
            label: "Novidade",
            color: "bg-blue-100 text-blue-800 border-blue-300"
        },
        {
            value: "DESTAQUE",
            label: "Destaque",
            color: "bg-yellow-100 text-yellow-800 border-yellow-300"
        },
        {
            value: "BEST_SELLER",
            label: "Best Seller",
            color: "bg-green-100 text-green-800 border-green-300"
        },
        {
            value: "OUTLET",
            label: "Outlet",
            color: "bg-purple-100 text-purple-800 border-purple-300"
        },
        {
            value: "IABUILDER",
            label: "IA Builder",
            color: "bg-cyan-100 text-cyan-800 border-cyan-300"
        }
    ];
    const [strategyPrice, setStrategyPrice] = (0, $acw62.useState)("configured");
    const [aiDescLoading, setAiDescLoading] = (0, $acw62.useState)(false);
    const [aiDescEditText, setAiDescEditText] = (0, $acw62.useState)(null);
    // Sync edit text when data.ai_description changes (e.g. after re-fetch)
    (0, $acw62.useEffect)(()=>{
        setAiDescEditText(null);
    }, [
        data?.ai_description
    ]);
    const fetchCategories = (0, $acw62.useCallback)(async ()=>{
        setError(null);
        (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).CATALOG + "/metadata/categories").then((res)=>{
            const categories = res.data.filter((category)=>category.is_filterable);
            setCategories(categories);
        }).catch((err)=>{
            setError("Ocorreu um erro ao buscar as categorias: " + err.message);
        }).finally(()=>setLoading(null));
    }, [
        setLoading,
        setError
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!isAuthenticated()) navigate("/login", {
            state: {
                from: pathname
            }
        });
        fetchData();
        fetchCategories();
    }, [
        id,
        isAuthenticated,
        navigate,
        pathname
    ]); // Added dependencies
    const fetchItems = (0, $acw62.useCallback)(async ()=>{
        try {
            const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).COMPOUNDS + `/${encodeURIComponent(id)}/items`);
            setItems(response.data);
        } catch (err) {
            setError(err.message || "Failed to fetch items"); // Re-enabled error logging for items fetch
            console.warn("Error fetching items:", err.message);
        }
    }, [
        id,
        setError
    ]); // Added dependencies
    const fetchData = (0, $acw62.useCallback)(async ()=>{
        setError(null);
        setLoading(true);
        try {
            if (!id) throw new Error("ID parameter is required");
            const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).COMPOUNDS + `/${encodeURIComponent(id)}`);
            setData((0, $ea54e87a26854b65$export$ea9dd768aad7aea8)(response.data));
            // Fetch items after fetching catalog data, but perhaps ensure `data` is set before `fetchItems` runs
            // Or pass `response.data.id` to fetchItems if it's immediately available and needed.
            // For now, keeping the await fetchItems() here assuming `id` is sufficient.
            await fetchItems();
        } catch (err) {
            setError(err.message || "Failed to fetch compound data");
            console.warn("Error fetching compound data:", err.message);
        } finally{
            setLoading(false);
        }
    }, [
        id,
        setError,
        setLoading,
        fetchItems
    ]); // Added dependencies
    const handleUpdate = async (e)=>{
        e.preventDefault(); // Prevent default form submission behavior
        setError(null);
        setSuccess(null); // Clear previous success messages
        setLoading(true);
        try {
            if (!data) throw new Error("No data to update.");
            if (!id) throw new Error("Compound ID is required.");
            if (strategyPrice == "erp") {
                const confirmation = confirm("Tem a certeza que pretende definir o pre\xe7o de todos os componentes para o pre\xe7o ERP?");
                if (!confirmation) {
                    setLoading(false);
                    return;
                }
            }
            // ponytail: auto-save component from inline editor (new or persisted)
            let editorSaved = false;
            if (editedComponentData) {
                if (editingComponentId) await $7bb5f02448dcd90f$export$3d375ec46cfe3d13(id, editingComponentId, editedComponentData);
                else await $7bb5f02448dcd90f$export$17578421efdb3356(id, editedComponentData);
                editorSaved = true;
            }
            // ponytail: save remaining unsaved components from list fallback,
            // skip the editor component to avoid double-save
            const editedRef = editorSaved ? editedComponentData?.product_reference : undefined;
            const unsavedComponents = data.components_list?.filter((c)=>!c.id && c.product_reference !== editedRef) ?? [];
            const saveErrors = [];
            for (const comp of unsavedComponents)try {
                await $7bb5f02448dcd90f$export$17578421efdb3356(id, comp);
            } catch (err) {
                saveErrors.push(`${comp.product_name || comp.component_type_key}: ${err.message}`);
            }
            if (saveErrors.length > 0) {
                setError("Alguns componentes n\xe3o foram guardados:\n" + saveErrors.join("\n"));
                setLoading(false);
                return;
            }
            await $7bb5f02448dcd90f$export$df2b2ae2f1cb6afc(id, {
                ...data,
                price_strategy: strategyPrice,
                components_list: undefined
            });
            await fetchData();
            setSuccess("Altera\xe7\xf5es guardadas com sucesso!");
        } catch (err) {
            setError(err.message || "Failed to update compound data");
            console.warn("Error updating compound data:", err.message);
        } finally{
            setLoading(false);
        }
    };
    const handleEditComponent = (component)=>{
        if (!editingComponentId && editedComponentData !== null) // If we are already adding a component, cancel the edit first
        handleCancelEdit();
        setEditingComponentId(component.id);
        setEditedComponentData((0, $a90953901eac57a3$export$5cc558fbc99919c1)({
            ...component
        })); // Create a mutable copy for editing
    };
    const handleCancelEdit = ()=>{
        if (!editingComponentId) setData((prev)=>{
            if (!prev) return prev;
            return {
                ...prev,
                components_list: prev.components_list?.filter((c)=>c.id !== editingComponentId) ?? []
            };
        });
        setEditingComponentId(null);
        setEditedComponentData(null);
    };
    const handleSaveComponent = async ()=>{
        if (!editedComponentData || !id) return;
        setError(null);
        setSuccess(null);
        setLoading(true);
        try {
            if (!editingComponentId) {
                await $7bb5f02448dcd90f$export$17578421efdb3356(id, editedComponentData);
                setSuccess("Componente adicionado com sucesso!");
            } else {
                await $7bb5f02448dcd90f$export$3d375ec46cfe3d13(id, editingComponentId, editedComponentData);
                setSuccess("Componente atualizado com sucesso!");
            }
            await fetchData();
            setEditingComponentId(null);
            setEditedComponentData(null);
        } catch (err) {
            setError(err.message || "Falha ao atualizar componente.");
            console.warn("Error updating component:", err.message);
        } finally{
            setLoading(false);
        }
    };
    const handleDeleteComponent = async (component)=>{
        setError(null);
        setSuccess(null);
        setLoading(true);
        try {
            await $7bb5f02448dcd90f$export$b131bf5b3493873b(id, component.id);
            await fetchData();
            setSuccess("Componente removido com sucesso!");
        } catch (err) {
            setError(err.message || "Falha ao remover componente.");
            console.warn("Error deleting component:", err.message);
        } finally{
            setLoading(false);
        }
    };
    const handleComponentInputChange = (e, field)=>{
        if (editedComponentData) setEditedComponentData((0, $a90953901eac57a3$export$5cc558fbc99919c1)({
            ...editedComponentData,
            [field]: field === "base_component" && e.target instanceof HTMLInputElement ? e.target.checked : e.target.value,
            ...field === "base_component" && e.target instanceof HTMLInputElement ? {
                optional: !e.target.checked
            } : {}
        }));
    };
    const handleAddComponent = (componentTypeKey)=>{
        // Lógica para adicionar um novo componente do tipo selecionado
        // Exemplo: abrir modal, ou adicionar linha de edição na tabela
        setShowAddComponentSection(false);
        if (!componentTypeKey) {
            setError("Por favor, selecione um tipo de componente.");
            return;
        }
        const newComponent = {
            id: "",
            // @ts-ignore
            component_type_key: componentTypeKey,
            component_name: (0, $cd93687958c8007e$export$96c53945a697e37)(componentTypeKey),
            product_name: "",
            product_reference: "",
            product_id: "",
            base_component: false,
            optional: true,
            price_pvp_with_vat: 0,
            price_pvp_without_vat: 0,
            vat_rate: (0, $cd93687958c8007e$export$59d79bb5806aec95),
            available_units: 0
        };
        setData((prevData)=>{
            if (!prevData) return prevData; // Ensure prevData is not null
            const updatedComponents = [
                ...prevData.components_list ?? [],
                newComponent
            ];
            return {
                ...prevData,
                components_list: updatedComponents
            };
        });
        handleEditComponent(newComponent); // Start editing the new component immediately
        // focus on div with id: section-{componentTypeKey}
        setTimeout(()=>{
            const sectionElement = document.getElementById(`section-${componentTypeKey}`);
            if (sectionElement) sectionElement.scrollIntoView({
                behavior: "smooth"
            });
        }, 250);
    };
    // Function to toggle collapse state for a given type
    const toggleCollapse = (type)=>{
        setCollapsedSections((prevState)=>({
                ...prevState,
                [type]: !prevState[type]
            }));
    };
    const icons = {
        // Explicitly typed icons object
        Cpu: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e8859e855a5dc92a$export$2e2bcd8739ae039), {
            className: "inline mr-2"
        }),
        Gpu: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e567cef82db71d0e$export$2e2bcd8739ae039), {
            className: "inline mr-2"
        }),
        CircuitBoard: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d1c159efbf8295ba$export$2e2bcd8739ae039), {
            className: "inline mr-2"
        }),
        MemoryStick: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $305d6e4c68cac6f3$export$2e2bcd8739ae039), {
            className: "inline mr-2"
        }),
        HardDrive: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4e6e7c8f114d04e1$export$2e2bcd8739ae039), {
            className: "inline mr-2"
        }),
        Fan: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $554c4787c44ee537$export$2e2bcd8739ae039), {
            className: "inline mr-2"
        }),
        PcCase: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cf972fdbc52e6ed1$export$2e2bcd8739ae039), {
            className: "inline mr-2"
        }),
        Wifi: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b144e577f231bbf4$export$2e2bcd8739ae039), {
            className: "inline mr-2"
        }),
        Monitor: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f633c0fb63f4b508$export$2e2bcd8739ae039), {
            className: "inline mr-2"
        }),
        Keyboard: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ebf99d6f8a58620$export$2e2bcd8739ae039), {
            className: "inline mr-2"
        }),
        Mouse: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $776c757559abfae2$export$2e2bcd8739ae039), {
            className: "inline mr-2"
        }),
        Power: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bfe54799d1557409$export$2e2bcd8739ae039), {
            className: "inline mr-2"
        }),
        Rocket: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10da79d8875e7dff$export$2e2bcd8739ae039), {
            className: "inline mr-2"
        }),
        Other: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $437c67a40c1b8279$export$2e2bcd8739ae039), {
            className: "inline mr-2"
        })
    };
    if (!isAuthenticated()) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex justify-center items-center h-screen bg-gray-100",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
            className: "text-xl text-gray-700",
            children: "Voc\xea deve estar logado para editar itens."
        })
    });
    const isLoadingActive = typeof loading === "object" ? !!loading?.message : loading;
    if (loading && !data) // Show initial loading state
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex justify-center items-center h-screen bg-gray-100",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
            className: "text-xl text-gray-700",
            children: "Carregando dados do computador..."
        })
    });
    if (error && !data) // Show initial error state
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex justify-center items-center h-screen bg-gray-100",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
            className: "text-xl text-red-600",
            children: [
                "Erro: ",
                error
            ]
        })
    });
    // Ensure data exists before rendering the main form
    if (!data) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex justify-center items-center h-screen bg-gray-100",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
            className: "text-xl text-gray-700",
            children: "Nenhum dado do computador encontrado."
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "container mx-auto p-8 bg-gray-50 min-h-screen font-sans",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("header", {
                className: "flex items-center gap-4 mb-8",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).button, {
                        type: "button",
                        whileHover: {
                            scale: 1.05
                        },
                        whileTap: {
                            scale: 0.95
                        },
                        onClick: ()=>history.back(),
                        className: "not-printable inline-flex items-center gap-2 px-3 py-2 rounded-lg text-red-600 hover:text-red-700 hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-offset-2 transition-colors duration-150 text-sm font-medium flex-shrink-0",
                        "aria-label": "Voltar \xe0 p\xe1gina anterior",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c7893a6dd85e5c$export$2e2bcd8739ae039), {
                                className: "w-5 h-5",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: "Voltar"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        className: "flex-1 text-3xl font-extrabold text-gray-900 leading-tight",
                        children: "Editar Computador"
                    })
                ]
            }),
            (success || error) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                "aria-live": "polite",
                "aria-atomic": "true",
                className: "mb-6 space-y-3",
                children: [
                    success && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).div, {
                        role: "alert",
                        initial: {
                            opacity: 0,
                            y: -8
                        },
                        animate: {
                            opacity: 1,
                            y: 0
                        },
                        className: "flex items-start gap-3 bg-emerald-50 border border-emerald-200 text-emerald-800 px-5 py-4 rounded-xl shadow-sm",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                className: "w-5 h-5 text-emerald-500 flex-shrink-0 mt-0.5",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex-1 min-w-0",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "font-semibold text-sm",
                                        children: "Opera\xe7\xe3o conclu\xedda com sucesso"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "text-sm mt-0.5 text-emerald-700",
                                        children: success
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                onClick: ()=>setSuccess(null),
                                className: "flex-shrink-0 p-1 rounded-md text-emerald-500 hover:text-emerald-700 hover:bg-emerald-100 focus:outline-none focus:ring-2 focus:ring-emerald-400 transition-colors",
                                "aria-label": "Fechar mensagem de sucesso",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                    className: "w-4 h-4",
                                    "aria-hidden": "true"
                                })
                            })
                        ]
                    }),
                    error && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).div, {
                        role: "alert",
                        initial: {
                            opacity: 0,
                            y: -8
                        },
                        animate: {
                            opacity: 1,
                            y: 0
                        },
                        className: "flex items-start gap-3 bg-red-50 border border-red-200 text-red-800 px-5 py-4 rounded-xl shadow-sm",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                                className: "w-5 h-5 text-red-500 flex-shrink-0 mt-0.5",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex-1 min-w-0",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "font-semibold text-sm",
                                        children: "Ocorreu um erro"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "text-sm mt-0.5 text-red-700",
                                        children: error
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                onClick: ()=>setError(null),
                                className: "flex-shrink-0 p-1 rounded-md text-red-500 hover:text-red-700 hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-red-400 transition-colors",
                                "aria-label": "Fechar mensagem de erro",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                    className: "w-4 h-4",
                                    "aria-hidden": "true"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                role: "tablist",
                "aria-label": "Sec\xe7\xf5es do composto",
                className: "flex gap-1 border-b mb-4",
                onKeyDown: (e)=>{
                    if (e.key !== "ArrowLeft" && e.key !== "ArrowRight") return;
                    const order = isAdmin && id ? [
                        "components",
                        "history"
                    ] : [
                        "components"
                    ];
                    const idx = order.indexOf(activeTab);
                    const next = e.key === "ArrowRight" ? (idx + 1) % order.length : (idx - 1 + order.length) % order.length;
                    e.preventDefault();
                    setActiveTab(order[next]);
                    compoundTabRefs.current[order[next]]?.focus();
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        type: "button",
                        role: "tab",
                        id: "tab-compound-components",
                        "aria-controls": "tabpanel-compound-components",
                        ref: (el)=>{
                            compoundTabRefs.current["components"] = el;
                        },
                        "aria-selected": activeTab === "components",
                        tabIndex: activeTab === "components" ? 0 : -1,
                        onClick: ()=>setActiveTab("components"),
                        className: `px-3 py-2 text-sm font-medium border-b-2 -mb-px ${activeTab === "components" ? "border-blue-600 text-blue-700" : "border-transparent text-gray-500 hover:text-gray-700"}`,
                        children: "Componentes"
                    }),
                    isAdmin && id && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        type: "button",
                        role: "tab",
                        id: "tab-compound-history",
                        "aria-controls": "tabpanel-compound-history",
                        ref: (el)=>{
                            compoundTabRefs.current["history"] = el;
                        },
                        "aria-selected": activeTab === "history",
                        tabIndex: activeTab === "history" ? 0 : -1,
                        onClick: ()=>setActiveTab("history"),
                        className: `px-3 py-2 text-sm font-medium border-b-2 -mb-px ${activeTab === "history" ? "border-blue-600 text-blue-700" : "border-transparent text-gray-500 hover:text-gray-700"}`,
                        children: "Hist\xf3rico de pre\xe7os"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                onSubmit: handleUpdate,
                role: "tabpanel",
                id: "tabpanel-compound-components",
                "aria-labelledby": "tab-compound-components",
                hidden: activeTab !== "components",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "bg-white shadow-lg rounded-xl p-8 mb-10",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex flex-col md:flex-row gap-8",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "w-full md:w-1/3 flex flex-col items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "w-full max-w-sm mb-6 bg-gray-100 rounded-lg overflow-hidden shadow-inner",
                                                children: file ? /*#__PURE__*/ (0, $ayMG0.jsx)("picture", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        src: URL.createObjectURL(file),
                                                        alt: "Selected Computer Image",
                                                        className: "w-full h-auto object-cover rounded-lg aspect-square"
                                                    })
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e87b4633e3445bd$export$2e2bcd8739ae039), {
                                                    src: `https://placehold.co/600x600/E5E7EB/4B5563?text=Nenhuma Imagem`,
                                                    loading: "progressive",
                                                    dataSrc: data.image,
                                                    alt: data.name ?? data.id,
                                                    className: "w-full h-auto object-cover rounded-lg aspect-square",
                                                    sizes: "600"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "w-full flex justify-center",
                                                children: file ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "flex space-x-4 w-full justify-center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            type: "button",
                                                            className: "px-3 py-3 bg-red-600 text-white rounded-lg shadow hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-75 transition duration-200 text-sm",
                                                            onClick: ()=>setFile(null),
                                                            children: "Remover Ficheiro"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            type: "button",
                                                            className: "px-3 py-3 bg-green-600 text-white rounded-lg shadow hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-75 transition duration-200 text-sm",
                                                            onClick: ()=>{
                                                                if (file) {
                                                                    const formData = new FormData();
                                                                    formData.append("image", file);
                                                                    setLoading(true);
                                                                    (0, $bac44633733ff026$export$2e2bcd8739ae039).put((0, $cd93687958c8007e$export$bfe19bc25132bb7c).COMPOUNDS + `/${encodeURIComponent(id)}/upload`, formData).then(()=>{
                                                                        setSuccess("Ficheiro guardado com sucesso.");
                                                                        fetchData(); // Re-fetch data to update image URL if backend returns new URL
                                                                        setFile(null);
                                                                    }).catch((err)=>{
                                                                        setError(err.message || "Failed to upload file");
                                                                    }).finally(()=>{
                                                                        setLoading(false);
                                                                    });
                                                                }
                                                            },
                                                            children: "Guardar Ficheiro"
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                    className: "cursor-pointer bg-blue-600 text-white px-6 py-3 rounded-lg shadow hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-75 transition duration-200 text-sm",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            className: "hidden" // Hide the default file input
                                                            ,
                                                            type: "file",
                                                            name: "image",
                                                            accept: "image/*",
                                                            onChange: (e)=>{
                                                                const selectedFile = e.target.files?.[0];
                                                                if (selectedFile) setFile(selectedFile);
                                                            }
                                                        }),
                                                        "Escolher Ficheiro..."
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "w-full md:w-2/3 space-y-6",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "grid grid-cols-1 gap-x-6 gap-y-4",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                            htmlFor: "name",
                                                            className: "block text-sm font-medium text-gray-700 mb-1",
                                                            children: "Nome"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            id: "name",
                                                            type: "text",
                                                            className: "mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm",
                                                            value: data.name,
                                                            onChange: (e)=>setData({
                                                                    ...data,
                                                                    name: e.target.value
                                                                }),
                                                            placeholder: "Nome do Computador"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                            htmlFor: "description",
                                                            className: "block text-sm font-medium text-gray-700 mb-1",
                                                            children: "Descri\xe7\xe3o"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            id: "description",
                                                            type: "text",
                                                            className: "mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm",
                                                            value: data.description,
                                                            onChange: (e)=>setData({
                                                                    ...data,
                                                                    description: e.target.value
                                                                }),
                                                            placeholder: "Descri\xe7\xe3o do Computador"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: `rounded-xl border shadow-sm overflow-hidden transition-colors ${data.ai_description_status === "APPROVED" ? "border-green-300 bg-green-50" : "border-indigo-200 bg-indigo-50"}`,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: `flex items-center gap-2.5 px-4 py-3 border-b ${data.ai_description_status === "APPROVED" ? "bg-green-100/60 border-green-200" : "bg-indigo-100/60 border-indigo-200"}`,
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: `flex items-center justify-center w-7 h-7 rounded-lg ${data.ai_description_status === "APPROVED" ? "bg-green-200 text-green-700" : "bg-indigo-200 text-indigo-700"}`,
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8afc40d49a7e79bf$export$2e2bcd8739ae039), {
                                                                        className: "w-4 h-4"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                                    className: `text-sm font-semibold ${data.ai_description_status === "APPROVED" ? "text-green-900" : "text-indigo-900"}`,
                                                                    children: "Descri\xe7\xe3o Gerada por IA"
                                                                }),
                                                                data.ai_description_status && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                    className: `ml-auto inline-flex items-center gap-1.5 text-xs font-semibold px-2.5 py-1 rounded-full border ${data.ai_description_status === "APPROVED" ? "bg-green-100 text-green-800 border-green-300" : data.ai_description_status === "GENERATED" ? "bg-yellow-100 text-yellow-800 border-yellow-300" : data.ai_description_status === "REJECTED" ? "bg-red-100 text-red-800 border-red-300" : "bg-gray-100 text-gray-500 border-gray-300"}`,
                                                                    children: [
                                                                        data.ai_description_status === "APPROVED" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                                                            className: "w-3.5 h-3.5"
                                                                        }),
                                                                        data.ai_description_status === "GENERATED" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                                                                            className: "w-3.5 h-3.5"
                                                                        }),
                                                                        data.ai_description_status === "REJECTED" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $839eea37a960d2b1$export$2e2bcd8739ae039), {
                                                                            className: "w-3.5 h-3.5"
                                                                        }),
                                                                        data.ai_description_status === "PENDING" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5faf23ec0b8e3e8e$export$2e2bcd8739ae039), {
                                                                            className: "w-3.5 h-3.5"
                                                                        }),
                                                                        data.ai_description_status === "APPROVED" && "Aprovada \u2014 publicada no site",
                                                                        data.ai_description_status === "GENERATED" && "Aguarda valida\xe7\xe3o",
                                                                        data.ai_description_status === "REJECTED" && "Rejeitada",
                                                                        data.ai_description_status === "PENDING" && "Pendente"
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "px-4 py-3",
                                                            children: aiDescLoading ? /* Loading skeleton */ /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "flex flex-col items-center justify-center gap-2 py-6 text-indigo-400",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                                                        className: "w-6 h-6 animate-spin"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "text-xs font-medium",
                                                                        children: "A processar\u2026"
                                                                    })
                                                                ]
                                                            }) : data.ai_description ? /* Text area — read-only when APPROVED */ /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "relative",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                                        className: `w-full text-sm rounded-lg px-3 py-2 resize-none transition-colors ${data.ai_description_status === "APPROVED" ? "bg-green-50 border border-green-200 text-green-900 cursor-not-allowed select-none" : "bg-white border border-indigo-200 text-gray-700 focus:ring-2 focus:ring-indigo-300 focus:border-indigo-400 outline-none"}`,
                                                                        rows: 5,
                                                                        readOnly: data.ai_description_status === "APPROVED",
                                                                        value: aiDescEditText !== null ? aiDescEditText : data.ai_description,
                                                                        onChange: (e)=>setAiDescEditText(e.target.value)
                                                                    }),
                                                                    data.ai_description_status === "APPROVED" && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "absolute top-2 right-2 flex items-center gap-1 bg-green-100 text-green-600 text-xs font-medium px-2 py-0.5 rounded-full border border-green-200 pointer-events-none",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e20ffdae2aa9b33f$export$2e2bcd8739ae039), {
                                                                                className: "w-3 h-3"
                                                                            }),
                                                                            "Bloqueado"
                                                                        ]
                                                                    })
                                                                ]
                                                            }) : /* Empty state */ /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "flex flex-col items-center justify-center gap-2 py-6 text-center",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "flex items-center justify-center w-10 h-10 rounded-full bg-indigo-100 text-indigo-400",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5faf23ec0b8e3e8e$export$2e2bcd8739ae039), {
                                                                            className: "w-5 h-5"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                        className: "text-sm font-medium text-indigo-700",
                                                                        children: "Nenhuma descri\xe7\xe3o gerada ainda"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                        className: "text-xs text-indigo-400 max-w-xs",
                                                                        children: [
                                                                            "Clique em",
                                                                            " ",
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "font-semibold",
                                                                                children: "Gerar descri\xe7\xe3o"
                                                                            }),
                                                                            " ",
                                                                            "para criar automaticamente um texto optimizado para o produto."
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: `flex flex-wrap items-center gap-2 px-4 py-3 border-t ${data.ai_description_status === "APPROVED" ? "bg-green-100/40 border-green-200" : "bg-indigo-100/40 border-indigo-200"}`,
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                    type: "button",
                                                                    disabled: aiDescLoading,
                                                                    onClick: async ()=>{
                                                                        if (data.ai_description_status === "APPROVED") {
                                                                            const confirmed = window.confirm("Esta descri\xe7\xe3o j\xe1 foi aprovada. Tem a certeza que quer regenerar e perder a aprova\xe7\xe3o?");
                                                                            if (!confirmed) return;
                                                                        }
                                                                        setAiDescLoading(true);
                                                                        try {
                                                                            const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).post((0, $cd93687958c8007e$export$bfe19bc25132bb7c).COMPOUNDS + `/${encodeURIComponent(id)}/ai-description/generate`);
                                                                            setData((0, $ea54e87a26854b65$export$ea9dd768aad7aea8)(res.data));
                                                                            setAiDescEditText(null);
                                                                        } catch (err) {
                                                                            setError(err.message || "Erro ao gerar descri\xe7\xe3o IA");
                                                                        } finally{
                                                                            setAiDescLoading(false);
                                                                        }
                                                                    },
                                                                    className: "inline-flex items-center gap-1.5 text-xs font-medium px-3 py-1.5 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 active:bg-indigo-800 disabled:opacity-50 disabled:cursor-not-allowed transition-colors shadow-sm",
                                                                    children: data.ai_description ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                                                                                className: "w-3.5 h-3.5"
                                                                            }),
                                                                            "Regenerar"
                                                                        ]
                                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5faf23ec0b8e3e8e$export$2e2bcd8739ae039), {
                                                                                className: "w-3.5 h-3.5"
                                                                            }),
                                                                            "Gerar descri\xe7\xe3o"
                                                                        ]
                                                                    })
                                                                }),
                                                                data.ai_description_status === "GENERATED" && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                    type: "button",
                                                                    disabled: aiDescLoading,
                                                                    onClick: async ()=>{
                                                                        setAiDescLoading(true);
                                                                        try {
                                                                            const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).patch((0, $cd93687958c8007e$export$bfe19bc25132bb7c).COMPOUNDS + `/${encodeURIComponent(id)}/ai-description`, {
                                                                                action: "approve",
                                                                                text: aiDescEditText ?? undefined
                                                                            });
                                                                            setData((0, $ea54e87a26854b65$export$ea9dd768aad7aea8)(res.data));
                                                                            setAiDescEditText(null);
                                                                            setSuccess("Descri\xe7\xe3o IA aprovada!");
                                                                        } catch (err) {
                                                                            setError(err.message || "Erro ao aprovar descri\xe7\xe3o IA");
                                                                        } finally{
                                                                            setAiDescLoading(false);
                                                                        }
                                                                    },
                                                                    className: "inline-flex items-center gap-1.5 text-xs font-medium px-3 py-1.5 bg-green-600 text-white rounded-lg hover:bg-green-700 active:bg-green-800 disabled:opacity-50 disabled:cursor-not-allowed transition-colors shadow-sm",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                                                            className: "w-3.5 h-3.5"
                                                                        }),
                                                                        "Aprovar"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "ml-auto flex items-center gap-2",
                                                                    children: [
                                                                        data.ai_description_status === "GENERATED" && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                            type: "button",
                                                                            disabled: aiDescLoading,
                                                                            onClick: async ()=>{
                                                                                setAiDescLoading(true);
                                                                                try {
                                                                                    const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).patch((0, $cd93687958c8007e$export$bfe19bc25132bb7c).COMPOUNDS + `/${encodeURIComponent(id)}/ai-description`, {
                                                                                        action: "reject"
                                                                                    });
                                                                                    setData((0, $ea54e87a26854b65$export$ea9dd768aad7aea8)(res.data));
                                                                                    setAiDescEditText(null);
                                                                                } catch (err) {
                                                                                    setError(err.message || "Erro ao rejeitar descri\xe7\xe3o IA");
                                                                                } finally{
                                                                                    setAiDescLoading(false);
                                                                                }
                                                                            },
                                                                            className: "inline-flex items-center gap-1.5 text-xs font-medium px-3 py-1.5 bg-white text-red-600 border border-red-300 rounded-lg hover:bg-red-50 active:bg-red-100 disabled:opacity-50 disabled:cursor-not-allowed transition-colors",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $839eea37a960d2b1$export$2e2bcd8739ae039), {
                                                                                    className: "w-3.5 h-3.5"
                                                                                }),
                                                                                "Rejeitar"
                                                                            ]
                                                                        }),
                                                                        data.ai_description_status === "APPROVED" && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                            type: "button",
                                                                            disabled: aiDescLoading,
                                                                            onClick: async ()=>{
                                                                                setAiDescLoading(true);
                                                                                try {
                                                                                    const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).patch((0, $cd93687958c8007e$export$bfe19bc25132bb7c).COMPOUNDS + `/${encodeURIComponent(id)}/ai-description`, {
                                                                                        action: "revoke"
                                                                                    });
                                                                                    setData((0, $ea54e87a26854b65$export$ea9dd768aad7aea8)(res.data));
                                                                                    setAiDescEditText(null);
                                                                                    setSuccess("Aprova\xe7\xe3o revogada \u2014 descri\xe7\xe3o retorna a GENERATED.");
                                                                                } catch (err) {
                                                                                    setError(err.message || "Erro ao revogar aprova\xe7\xe3o");
                                                                                } finally{
                                                                                    setAiDescLoading(false);
                                                                                }
                                                                            },
                                                                            className: "inline-flex items-center gap-1.5 text-xs font-medium px-3 py-1.5 bg-white text-orange-600 border border-orange-300 rounded-lg hover:bg-orange-50 active:bg-orange-100 disabled:opacity-50 disabled:cursor-not-allowed transition-colors",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $948595fc4549df01$export$2e2bcd8739ae039), {
                                                                                    className: "w-3.5 h-3.5"
                                                                                }),
                                                                                "Revogar aprova\xe7\xe3o"
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "bg-gray-50 p-6 rounded-xl border border-gray-200",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                            className: "text-lg font-semibold text-gray-800 mb-5",
                                                            children: "Informa\xe7\xf5es de Pre\xe7o"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("fieldset", {
                                                            className: "mb-5",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("legend", {
                                                                    className: "text-sm font-medium text-gray-700 mb-2",
                                                                    children: "Estrat\xe9gia de Pre\xe7o"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "flex gap-6",
                                                                    children: [
                                                                        "configured",
                                                                        "erp"
                                                                    ].map((val)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                            className: "inline-flex items-center gap-2 cursor-pointer group",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                    type: "radio",
                                                                                    name: "strategyPrice",
                                                                                    value: val,
                                                                                    checked: strategyPrice === val,
                                                                                    onChange: ()=>setStrategyPrice(val),
                                                                                    className: "w-4 h-4 text-blue-600 border-gray-300 focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 cursor-pointer"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "text-sm text-gray-700 group-hover:text-gray-900 transition-colors",
                                                                                    children: val === "configured" ? "Pre\xe7o Configurado" : "Pre\xe7o ERP"
                                                                                })
                                                                            ]
                                                                        }, val))
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("dl", {
                                                            className: "grid grid-cols-1 md:grid-cols-2 gap-3 mb-5",
                                                            children: [
                                                                {
                                                                    label: "Pre\xe7o Custo Niposom",
                                                                    value: `${(0, $1cec967d8d56bb4d$export$63ad841d70774900)(data.getBaseComponentsCostPrice(strategyPrice))} EUR`
                                                                },
                                                                {
                                                                    label: "Pre\xe7o REV4",
                                                                    value: `${(0, $1cec967d8d56bb4d$export$63ad841d70774900)(data.getBaseComponentsRev4Price(strategyPrice))} EUR`
                                                                },
                                                                {
                                                                    label: "Pre\xe7o Revendedor",
                                                                    value: `${(0, $1cec967d8d56bb4d$export$63ad841d70774900)(data.getBaseComponentsResellerPrice(strategyPrice))} EUR`
                                                                },
                                                                {
                                                                    label: "Desconto Revendedor (margem)",
                                                                    value: `${(0, $1cec967d8d56bb4d$export$c37640da124effef)(data.getBaseDiscountRate(strategyPrice))} %`
                                                                },
                                                                {
                                                                    label: "Margem Revendedor",
                                                                    value: `${(0, $1cec967d8d56bb4d$export$63ad841d70774900)(data.getResellerGrossGainValue(strategyPrice))} EUR`
                                                                },
                                                                {
                                                                    label: "Percentagem Margem",
                                                                    value: `${(0, $1cec967d8d56bb4d$export$c37640da124effef)(data.getResellerRecommendedMargin(strategyPrice))} %`
                                                                }
                                                            ].map(({ label: label, value: value })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "flex items-center justify-between px-4 py-3 bg-white rounded-lg border border-gray-100 shadow-sm",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("dt", {
                                                                            className: "text-sm font-medium text-gray-500",
                                                                            children: label
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("dd", {
                                                                            className: "text-sm font-semibold text-gray-900 tabular-nums ml-4",
                                                                            children: value
                                                                        })
                                                                    ]
                                                                }, label))
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "grid grid-cols-1 md:grid-cols-2 gap-3 mb-5",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "p-3 bg-white rounded-lg border border-gray-100 shadow-sm",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                            className: "block text-sm font-medium text-gray-600 mb-1",
                                                                            children: "Pre\xe7o sem IVA:"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $df7230ae6db3bf8c$export$2e2bcd8739ae039), {
                                                                            price: {
                                                                                value: data.getPricePVPWithoutVat(strategyPrice),
                                                                                currency: "EUR"
                                                                            },
                                                                            allowChangeCurrency: false,
                                                                            onChange: (updateValue)=>{
                                                                                const price_without_vat = updateValue.value ?? data.getPricePVPWithoutVat(strategyPrice) ?? 0;
                                                                                const price_with_vat = price_without_vat * (data?.vat_rate ?? (0, $cd93687958c8007e$export$59d79bb5806aec95));
                                                                                setData({
                                                                                    ...data,
                                                                                    configured_price_pvp_without_vat: (0, $1cec967d8d56bb4d$export$63ad841d70774900)(price_without_vat),
                                                                                    configured_price_pvp_with_vat: (0, $1cec967d8d56bb4d$export$63ad841d70774900)(price_with_vat)
                                                                                });
                                                                            },
                                                                            readOnly: true,
                                                                            inputClassName: "w-full text-base font-semibold text-gray-900 border-none focus:outline-none bg-transparent"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "p-3 bg-white rounded-lg border border-gray-100 shadow-sm",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                            className: "block text-sm font-medium text-gray-600 mb-1",
                                                                            children: [
                                                                                "Pre\xe7o com IVA (",
                                                                                (0, $1cec967d8d56bb4d$export$c37640da124effef)(data?.vat_rate ?? (0, $cd93687958c8007e$export$59d79bb5806aec95)),
                                                                                " %):"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $df7230ae6db3bf8c$export$2e2bcd8739ae039), {
                                                                            price: {
                                                                                value: data.getPricePVPWithVat(strategyPrice),
                                                                                currency: "EUR"
                                                                            },
                                                                            allowChangeCurrency: false,
                                                                            onChange: (updateValue)=>{
                                                                                const price_with_vat = updateValue.value ?? data.getPricePVPWithVat(strategyPrice) ?? 0;
                                                                                const price_without_vat = price_with_vat / (data?.vat_rate ?? (0, $cd93687958c8007e$export$59d79bb5806aec95));
                                                                                setData({
                                                                                    ...data,
                                                                                    configured_price_pvp_without_vat: (0, $1cec967d8d56bb4d$export$63ad841d70774900)(price_without_vat),
                                                                                    configured_price_pvp_with_vat: (0, $1cec967d8d56bb4d$export$63ad841d70774900)(price_with_vat)
                                                                                });
                                                                            },
                                                                            readOnly: true,
                                                                            inputClassName: "w-full text-base font-semibold text-gray-900 border-none focus:outline-none bg-transparent"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "border-t border-gray-200 pt-5",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                    className: "text-xs font-semibold text-gray-400 uppercase tracking-wider mb-4",
                                                                    children: "Campos Edit\xe1veis"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "grid grid-cols-1 md:grid-cols-3 gap-4",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                                    htmlFor: "available_units",
                                                                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                                                                    children: "Unidades Dispon\xedveis"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                    id: "available_units",
                                                                                    name: "available_units",
                                                                                    type: "number",
                                                                                    min: 0,
                                                                                    className: "block w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors",
                                                                                    value: data.getAvailableUnits(strategyPrice),
                                                                                    onChange: (e)=>setData({
                                                                                            ...data,
                                                                                            available_units: parseInt(e.target.value ?? "0", 10)
                                                                                        })
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                                    htmlFor: "category_slug",
                                                                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                                                                    children: "Categoria"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                                                    id: "category_slug",
                                                                                    defaultValue: data.category_slug,
                                                                                    onChange: (e)=>setData({
                                                                                            ...data,
                                                                                            category_slug: e.target.value
                                                                                        }),
                                                                                    className: "block w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm text-sm bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                                            value: "",
                                                                                            disabled: true,
                                                                                            children: "Selecione uma categoria"
                                                                                        }),
                                                                                        categories.map((category)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                                                value: category.slug,
                                                                                                children: category.name
                                                                                            }, category.slug))
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                                    htmlFor: "status",
                                                                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                                                                    children: "Estado"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                                                                                    id: "status",
                                                                                    defaultValue: data.status,
                                                                                    onChange: (e)=>setData({
                                                                                            ...data,
                                                                                            status: e.target.value
                                                                                        }),
                                                                                    className: "block w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm text-sm bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors",
                                                                                    children: statusOptions.map((option)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                                            value: option.value,
                                                                                            children: option.label
                                                                                        }, option.value))
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "mt-4",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                    className: "block text-sm font-medium text-gray-700 mb-2",
                                                                    children: "Tags"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "flex flex-wrap gap-2",
                                                                    children: availableTags.map((tag)=>{
                                                                        const isSelected = (data.tags ?? []).includes(tag.value);
                                                                        return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                            type: "button",
                                                                            onClick: ()=>{
                                                                                const currentTags = data.tags ?? [];
                                                                                const newTags = isSelected ? currentTags.filter((t)=>t !== tag.value) : [
                                                                                    ...currentTags,
                                                                                    tag.value
                                                                                ];
                                                                                setData({
                                                                                    ...data,
                                                                                    tags: newTags
                                                                                });
                                                                            },
                                                                            className: `px-3 py-1.5 rounded-full text-sm font-medium border transition-all cursor-pointer ${isSelected ? tag.color + " ring-2 ring-offset-1 ring-blue-400" : "bg-gray-50 text-gray-500 border-gray-200 hover:bg-gray-100"}`,
                                                                            children: tag.label
                                                                        }, tag.value);
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "flex justify-end mt-8",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    type: "submit",
                                    className: "px-8 py-4 bg-blue-600 text-white text-lg font-semibold rounded-xl shadow-lg hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-500 focus:ring-opacity-75 transition duration-300 transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed",
                                    disabled: !!loading?.message,
                                    children: !!loading?.message ? "A guardar..." : "Guardar Altera\xe7\xf5es"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "bg-white shadow-lg rounded-xl p-8 mb-10",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center justify-between mb-6",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                        className: "text-2xl font-bold text-gray-900",
                                        children: "Componentes do Computador"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        type: "button",
                                        className: "px-4 py-2 bg-green-600 text-white rounded-lg shadow hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-75 transition duration-200 text-sm disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-500",
                                        onClick: ()=>{
                                            if (!showAddComponentSection && !editedComponentData) setShowAddComponentSection(true);
                                        },
                                        disabled: !!loading?.message || showAddComponentSection || !!editedComponentData,
                                        children: "+ Adicionar Componente"
                                    })
                                ]
                            }),
                            showAddComponentSection && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mb-6 p-5 bg-blue-50 border border-blue-200 rounded-xl shadow-sm",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                        className: "text-sm font-semibold text-blue-800 mb-4",
                                        children: "Adicionar novo componente"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex flex-col md:flex-row gap-3 items-start md:items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                className: "block px-4 py-2 border border-gray-300 rounded-lg shadow-sm text-sm bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors",
                                                value: newComponentType,
                                                onChange: (e)=>setNewComponentType(e.target.value),
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                        value: "",
                                                        children: "Selecione o tipo"
                                                    }),
                                                    Object.entries((0, $cd93687958c8007e$export$b6cd510719465167)).map(([_, type])=>{
                                                        if (// @ts-ignore
                                                        data.getComponentTypesWithProducts().includes(type[0])) return null;
                                                        return /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: type[0],
                                                            children: type[2]
                                                        }, type[0]);
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                type: "button",
                                                className: "px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors",
                                                onClick: ()=>handleAddComponent(newComponentType),
                                                disabled: !newComponentType,
                                                children: "Adicionar"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                type: "button",
                                                className: "px-4 py-2 bg-white text-gray-600 border border-gray-300 text-sm font-medium rounded-lg shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-400 transition-colors",
                                                onClick: ()=>setShowAddComponentSection(false),
                                                children: "Cancelar"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            Object.entries((0, $cd93687958c8007e$export$b6cd510719465167)).map(([, item])=>{
                                const type = item[0];
                                // @ts-ignore
                                const componentsArray = data.getComponentListByType(type);
                                const isCollapsed = collapsedSections[type];
                                const baseComponent = componentsArray.find((c)=>c.base_component); // Find the base component
                                return componentsArray.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    id: `section-` + type,
                                    className: "bg-gray-50 rounded-lg shadow-sm p-2 mb-3",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex items-center justify-between mb-2 ",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "flex items-center cursor-pointer",
                                                    onClick: ()=>toggleCollapse(type),
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                            className: "text-xl font-semibold text-gray-800 flex items-center",
                                                            children: [
                                                                icons[type],
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "ml-2 capitalize",
                                                                    children: (0, $cd93687958c8007e$export$96c53945a697e37)(type)
                                                                }),
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            type: "button",
                                                            className: "ml-4 p-1 rounded-full text-gray-600 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500",
                                                            children: isCollapsed ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                                                size: 20
                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b397e876e35a9277$export$2e2bcd8739ae039), {
                                                                size: 20
                                                            })
                                                        })
                                                    ]
                                                }),
                                                isCollapsed ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "px-4 py-2",
                                                    children: baseComponent ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                            className: "font-semibold",
                                                            children: [
                                                                baseComponent.product_name,
                                                                " - Refer\xeancia:",
                                                                " ",
                                                                baseComponent.product_reference
                                                            ]
                                                        })
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "text-sm text-gray-500",
                                                        children: "Nenhum componente base definido para este tipo."
                                                    })
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    type: "button",
                                                    className: "px-4 py-2 bg-purple-600 text-white rounded-lg shadow hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-opacity-75 transition duration-200 text-sm disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-500",
                                                    onClick: ()=>{
                                                        if (!showAddComponentSection && !editedComponentData) handleAddComponent(type);
                                                    },
                                                    disabled: !!loading?.message || showAddComponentSection || !!editedComponentData,
                                                    children: "Adicionar Op\xe7\xe3o"
                                                })
                                            ]
                                        }),
                                        !isCollapsed && // Display full table when expanded
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "overflow-x-auto border-t border-gray-200",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                                                className: "min-w-full divide-y divide-gray-200",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                                        className: "bg-gray-100",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                    scope: "col",
                                                                    className: "px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                                                    children: "Base"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                    scope: "col",
                                                                    className: "px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                                                    children: "Refer\xeancia"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                    scope: "col",
                                                                    className: "px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                                                    children: "Nome"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                    scope: "col",
                                                                    className: "px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                                                    children: "Descri\xe7\xe3o"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                    scope: "col",
                                                                    className: "px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                                                    children: "Marca"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                    scope: "col",
                                                                    className: "px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                                                    children: "Quantidade"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                    scope: "col",
                                                                    className: "px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                                                    children: "Pre\xe7o Custo"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                    scope: "col",
                                                                    className: "px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                                                    children: "Pre\xe7o REV4"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                    scope: "col",
                                                                    className: "px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                                                    children: "Pre\xe7o Loja"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                    scope: "col",
                                                                    className: "px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                                                    children: "Pre\xe7o Especial"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                    scope: "col",
                                                                    className: "px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                                                    children: "Stock"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                    scope: "col",
                                                                    className: "px-3 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider",
                                                                    children: "A\xe7\xf5es"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("tbody", {
                                                        className: "bg-white divide-y divide-gray-200",
                                                        children: [
                                                            componentsArray.map((x, i)=>{
                                                                const c = (0, $a90953901eac57a3$export$5cc558fbc99919c1)(x);
                                                                const isEditing = editingComponentId === c.id;
                                                                const className = c.checkPriceDifference() > 0 ? "bg-green-100 text-green-800" : c.checkPriceDifference() < 0 ? "bg-red-100 text-red-800" : c.getOverridePrice("configured") ? "bg-yellow-50 text-yellow-800" : "";
                                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                                    className: `hover:bg-gray-50 ${className} ${isEditing ? "bg-gray-50" : ""}`,
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                            className: "px-3 py-4 whitespace-nowrap text-sm font-medium text-gray-900",
                                                                            children: isEditing ? /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                type: "checkbox",
                                                                                className: "form-checkbox h-4 w-4 text-green-600",
                                                                                checked: !!editedComponentData?.base_component,
                                                                                onChange: (e)=>handleComponentInputChange(e, "base_component")
                                                                            }) : c.base_component ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "text-green-600 font-bold",
                                                                                children: "SIM"
                                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "text-red-600",
                                                                                children: "N\xc3O"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                            className: "px-3 py-4 whitespace-nowrap text-sm text-gray-500",
                                                                            children: isEditing ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cdfd57be71fcf6f6$export$2e2bcd8739ae039), {
                                                                                allProducts: true,
                                                                                value: editedComponentData?.product_reference ?? "",
                                                                                onChange: (value)=>{
                                                                                    if (editedComponentData) setEditedComponentData((0, $a90953901eac57a3$export$5cc558fbc99919c1)({
                                                                                        ...editedComponentData,
                                                                                        product_reference: value
                                                                                    }));
                                                                                },
                                                                                onSelect: (product)=>{
                                                                                    if (editedComponentData) setEditedComponentData((0, $a90953901eac57a3$export$5cc558fbc99919c1)({
                                                                                        ...editedComponentData,
                                                                                        product_reference: product.id,
                                                                                        product_name: product.name,
                                                                                        product_description: product.short_description,
                                                                                        product_brand: product.brand,
                                                                                        configured_cost_price: product.cost_price,
                                                                                        erp_cost_price: product.cost_price,
                                                                                        erp_compound_reseller_price: product.rev4_price,
                                                                                        configured_compound_reseller_price: product.rev4_price,
                                                                                        configured_reseller_price: product.rev3_price,
                                                                                        erp_reseller_price: product.rev3_price,
                                                                                        quantity: 1,
                                                                                        configured_available_quantity: product.stock,
                                                                                        erp_available_quantity: product.stock
                                                                                    }));
                                                                                },
                                                                                placeholder: "Pesquisar por refer\xeancia..."
                                                                            }) : c.product_reference
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                            className: "px-3 py-4 whitespace-nowrap text-sm text-gray-900",
                                                                            children: isEditing ? /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                type: "text",
                                                                                className: "w-full border rounded px-2 py-1 text-gray-900",
                                                                                value: editedComponentData?.product_name ?? "",
                                                                                onChange: (e)=>handleComponentInputChange(e, "product_name")
                                                                            }) : c.product_name
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                            className: "px-3 py-4 whitespace-nowrap text-sm text-gray-900",
                                                                            children: isEditing ? /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                type: "text",
                                                                                className: "w-full border rounded px-2 py-1 text-gray-900",
                                                                                value: editedComponentData?.product_description ?? "",
                                                                                onChange: (e)=>handleComponentInputChange(e, "product_description")
                                                                            }) : c.product_description
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                            className: "px-3 py-4 whitespace-nowrap text-sm text-gray-500",
                                                                            children: isEditing ? /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                type: "text",
                                                                                className: "w-full border rounded px-2 py-1 text-gray-900",
                                                                                value: editedComponentData?.product_brand ?? "",
                                                                                onChange: (e)=>handleComponentInputChange(e, "product_brand")
                                                                            }) : c.product_brand ?? "N/A"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                            className: "px-3 py-4 whitespace-nowrap text-sm text-gray-500",
                                                                            children: isEditing ? /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                type: "number",
                                                                                className: "w-full border rounded px-2 py-1 text-gray-900",
                                                                                value: editedComponentData?.quantity ?? 0,
                                                                                onChange: (e)=>handleComponentInputChange(e, "quantity")
                                                                            }) : c.quantity
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                            className: "px-3 py-4 whitespace-nowrap text-sm text-gray-500",
                                                                            children: isEditing ? /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                type: "number",
                                                                                step: "0.01",
                                                                                className: "w-full border rounded px-2 py-1 text-gray-900",
                                                                                value: editedComponentData?.getCostPrice(strategyPrice),
                                                                                onChange: (e)=>handleComponentInputChange(e, "configured_cost_price")
                                                                            }) : (0, $1cec967d8d56bb4d$export$63ad841d70774900)(c.getCostPrice(strategyPrice)) + " EUR"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                            className: "px-3 py-4 whitespace-nowrap text-sm text-gray-500",
                                                                            children: isEditing ? /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                type: "number",
                                                                                step: "0.01",
                                                                                className: "w-full border rounded px-2 py-1 text-gray-900",
                                                                                value: editedComponentData?.getResellerPrice(strategyPrice),
                                                                                onChange: (e)=>handleComponentInputChange(e, "configured_reseller_price")
                                                                            }) : (0, $1cec967d8d56bb4d$export$63ad841d70774900)(c.getResellerPrice(strategyPrice)) + " EUR"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                            className: "px-3 py-4 whitespace-nowrap text-sm text-gray-500",
                                                                            children: isEditing ? /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                type: "number",
                                                                                step: "0.01",
                                                                                className: "w-full border rounded px-2 py-1 text-gray-900",
                                                                                value: editedComponentData?.getRev4Price(strategyPrice) ?? 0,
                                                                                onChange: (e)=>handleComponentInputChange(e, "configured_compound_reseller_price")
                                                                            }) : c.getRev4Price(strategyPrice) ?? true ? (0, $1cec967d8d56bb4d$export$63ad841d70774900)(c.getRev4Price(strategyPrice) ?? 0) + " EUR" : "--"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                            className: "px-3 py-4 whitespace-nowrap text-sm text-gray-500",
                                                                            children: isEditing ? /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                type: "number",
                                                                                step: "0.01",
                                                                                className: "w-full border rounded px-2 py-1 text-gray-900",
                                                                                value: editedComponentData?.getOverridePrice(strategyPrice) ?? 0,
                                                                                onChange: (e)=>handleComponentInputChange(e, "configured_override_price")
                                                                            }) : c.getOverridePrice(strategyPrice) ?? true ? (0, $1cec967d8d56bb4d$export$63ad841d70774900)(c.getOverridePrice(strategyPrice) ?? 0) + " EUR" : "--"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                            className: "px-3 py-4 whitespace-nowrap text-sm text-gray-500",
                                                                            children: isEditing ? /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                type: "number",
                                                                                className: "w-full border rounded px-2 py-1 text-gray-900",
                                                                                value: editedComponentData?.getAvailableQuantity(strategyPrice) ?? 0,
                                                                                onChange: (e)=>handleComponentInputChange(e, "configured_available_quantity")
                                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "flex items-center gap-1.5",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        children: c.getAvailableQuantity(strategyPrice)
                                                                                    }),
                                                                                    c.erp_synced_at ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: "px-1.5 py-0.5 rounded text-[10px] font-semibold bg-blue-100 text-blue-700",
                                                                                        title: "Stock sincronizado do SAG/ERP",
                                                                                        children: "SAG"
                                                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: "px-1.5 py-0.5 rounded text-[10px] font-semibold bg-amber-100 text-amber-700",
                                                                                        title: "Stock configurado manualmente (sem SAG)",
                                                                                        children: "Configurado"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                            className: "px-3 py-4 whitespace-nowrap text-right text-sm font-medium",
                                                                            children: isEditing ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "flex items-center justify-end gap-2",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                        type: "button",
                                                                                        className: "inline-flex items-center gap-1.5 px-3 py-1.5 bg-green-600 text-white text-xs font-medium rounded-lg hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors",
                                                                                        onClick: handleSaveComponent,
                                                                                        disabled: isLoadingActive,
                                                                                        children: "Guardar"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                        type: "button",
                                                                                        className: "inline-flex items-center gap-1.5 px-3 py-1.5 bg-white text-gray-600 border border-gray-300 text-xs font-medium rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors",
                                                                                        onClick: handleCancelEdit,
                                                                                        disabled: isLoadingActive,
                                                                                        children: "Cancelar"
                                                                                    })
                                                                                ]
                                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "flex items-center justify-end gap-2",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                                        type: "button",
                                                                                        className: "inline-flex items-center gap-1.5 px-2.5 py-1.5 text-indigo-600 border border-indigo-200 bg-indigo-50 text-xs font-medium rounded-lg hover:bg-indigo-100 disabled:opacity-50 disabled:cursor-not-allowed transition-colors",
                                                                                        onClick: ()=>handleEditComponent(c),
                                                                                        disabled: isLoadingActive,
                                                                                        "aria-label": `Editar ${c.product_name}`,
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6c2a827dd5c2d433$export$2e2bcd8739ae039), {
                                                                                                className: "w-3.5 h-3.5",
                                                                                                "aria-hidden": "true"
                                                                                            }),
                                                                                            "Editar"
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                                        type: "button",
                                                                                        className: "inline-flex items-center gap-1.5 px-2.5 py-1.5 text-red-600 border border-red-200 bg-red-50 text-xs font-medium rounded-lg hover:bg-red-100 disabled:opacity-50 disabled:cursor-not-allowed transition-colors",
                                                                                        onClick: ()=>{
                                                                                            if (window.confirm(`Tem a certeza que quer remover "${c.product_name}"? Esta ac\xe7\xe3o n\xe3o pode ser desfeita.`)) handleDeleteComponent(c);
                                                                                        },
                                                                                        disabled: isLoadingActive,
                                                                                        "aria-label": `Remover ${c.product_name}`,
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                                                                                className: "w-3.5 h-3.5",
                                                                                                "aria-hidden": "true"
                                                                                            }),
                                                                                            "Remover"
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                }, c.id || i);
                                                            }),
                                                            componentsArray.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                    colSpan: 7,
                                                                    className: "px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-center",
                                                                    children: "Nenhum componente encontrado para esta categoria."
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }, type);
                            }),
                            Array.from(data.getComponentsMap()).every(([key, components])=>components.length === 0) && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "text-center text-gray-600 p-4",
                                children: "Nenhum componente configurado para este computador."
                            })
                        ]
                    })
                ]
            }),
            isAdmin && id && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $efa59d6f62083a5c$export$2e2bcd8739ae039), {
                compoundId: id
            }, id),
            isAdmin && id && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "tabpanel",
                id: "tabpanel-compound-history",
                "aria-labelledby": "tab-compound-history",
                hidden: activeTab !== "history",
                children: activeTab === "history" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $901db23cbd278565$export$2e2bcd8739ae039), {
                    compoundId: id
                }, id)
            })
        ]
    });
};
var $52125b4485a7e10a$export$2e2bcd8739ae039 = $52125b4485a7e10a$var$CompoundManageEditPage;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f0cdbf97a5c8afc2$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z",
            key: "1s6t7t"
        }
    ],
    [
        "circle",
        {
            cx: "16.5",
            cy: "7.5",
            r: ".5",
            fill: "currentColor",
            key: "w0ekpg"
        }
    ]
];
const $f0cdbf97a5c8afc2$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("key-round", $f0cdbf97a5c8afc2$export$3efd853dbb351e94);




var $acw62 = parcelRequire("acw62");
var $8b78587e05097331$var$__defProp = Object.defineProperty;
var $8b78587e05097331$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $8b78587e05097331$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $8b78587e05097331$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $8b78587e05097331$var$__defNormalProp = (obj, key, value)=>key in obj ? $8b78587e05097331$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $8b78587e05097331$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($8b78587e05097331$var$__hasOwnProp.call(b, prop)) $8b78587e05097331$var$__defNormalProp(a, prop, b[prop]);
    if ($8b78587e05097331$var$__getOwnPropSymbols) {
        for (var prop of $8b78587e05097331$var$__getOwnPropSymbols(b))if ($8b78587e05097331$var$__propIsEnum.call(b, prop)) $8b78587e05097331$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $8b78587e05097331$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($8b78587e05097331$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $8b78587e05097331$var$__getOwnPropSymbols) {
        for (var prop of $8b78587e05097331$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $8b78587e05097331$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/third-party/qrcodegen/index.ts
/**
 * @license QR Code generator library (TypeScript)
 * Copyright (c) Project Nayuki.
 * SPDX-License-Identifier: MIT
 */ var $8b78587e05097331$var$qrcodegen;
((qrcodegen2)=>{
    const _QrCode = class _QrCode {
        /*-- Constructor (low level) and fields --*/ // Creates a new QR Code with the given version number,
        // error correction level, data codeword bytes, and mask number.
        // This is a low-level API that most users should not use directly.
        // A mid-level API is the encodeSegments() function.
        constructor(version, errorCorrectionLevel, dataCodewords, msk){
            this.version = version;
            this.errorCorrectionLevel = errorCorrectionLevel;
            // The modules of this QR Code (false = light, true = dark).
            // Immutable after constructor finishes. Accessed through getModule().
            this.modules = [];
            // Indicates function modules that are not subjected to masking. Discarded when constructor finishes.
            this.isFunction = [];
            if (version < _QrCode.MIN_VERSION || version > _QrCode.MAX_VERSION) throw new RangeError("Version value out of range");
            if (msk < -1 || msk > 7) throw new RangeError("Mask value out of range");
            this.size = version * 4 + 17;
            let row = [];
            for(let i = 0; i < this.size; i++)row.push(false);
            for(let i = 0; i < this.size; i++){
                this.modules.push(row.slice());
                this.isFunction.push(row.slice());
            }
            this.drawFunctionPatterns();
            const allCodewords = this.addEccAndInterleave(dataCodewords);
            this.drawCodewords(allCodewords);
            if (msk == -1) {
                let minPenalty = 1e9;
                for(let i = 0; i < 8; i++){
                    this.applyMask(i);
                    this.drawFormatBits(i);
                    const penalty = this.getPenaltyScore();
                    if (penalty < minPenalty) {
                        msk = i;
                        minPenalty = penalty;
                    }
                    this.applyMask(i);
                }
            }
            assert(0 <= msk && msk <= 7);
            this.mask = msk;
            this.applyMask(msk);
            this.drawFormatBits(msk);
            this.isFunction = [];
        }
        /*-- Static factory functions (high level) --*/ // Returns a QR Code representing the given Unicode text string at the given error correction level.
        // As a conservative upper bound, this function is guaranteed to succeed for strings that have 738 or fewer
        // Unicode code points (not UTF-16 code units) if the low error correction level is used. The smallest possible
        // QR Code version is automatically chosen for the output. The ECC level of the result may be higher than the
        // ecl argument if it can be done without increasing the version.
        static encodeText(text, ecl) {
            const segs = qrcodegen2.QrSegment.makeSegments(text);
            return _QrCode.encodeSegments(segs, ecl);
        }
        // Returns a QR Code representing the given binary data at the given error correction level.
        // This function always encodes using the binary segment mode, not any text mode. The maximum number of
        // bytes allowed is 2953. The smallest possible QR Code version is automatically chosen for the output.
        // The ECC level of the result may be higher than the ecl argument if it can be done without increasing the version.
        static encodeBinary(data, ecl) {
            const seg = qrcodegen2.QrSegment.makeBytes(data);
            return _QrCode.encodeSegments([
                seg
            ], ecl);
        }
        /*-- Static factory functions (mid level) --*/ // Returns a QR Code representing the given segments with the given encoding parameters.
        // The smallest possible QR Code version within the given range is automatically
        // chosen for the output. Iff boostEcl is true, then the ECC level of the result
        // may be higher than the ecl argument if it can be done without increasing the
        // version. The mask number is either between 0 to 7 (inclusive) to force that
        // mask, or -1 to automatically choose an appropriate mask (which may be slow).
        // This function allows the user to create a custom sequence of segments that switches
        // between modes (such as alphanumeric and byte) to encode text in less space.
        // This is a mid-level API; the high-level API is encodeText() and encodeBinary().
        static encodeSegments(segs, ecl, minVersion = 1, maxVersion = 40, mask = -1, boostEcl = true) {
            if (!(_QrCode.MIN_VERSION <= minVersion && minVersion <= maxVersion && maxVersion <= _QrCode.MAX_VERSION) || mask < -1 || mask > 7) throw new RangeError("Invalid value");
            let version;
            let dataUsedBits;
            for(version = minVersion;; version++){
                const dataCapacityBits2 = _QrCode.getNumDataCodewords(version, ecl) * 8;
                const usedBits = QrSegment.getTotalBits(segs, version);
                if (usedBits <= dataCapacityBits2) {
                    dataUsedBits = usedBits;
                    break;
                }
                if (version >= maxVersion) throw new RangeError("Data too long");
            }
            for (const newEcl of [
                _QrCode.Ecc.MEDIUM,
                _QrCode.Ecc.QUARTILE,
                _QrCode.Ecc.HIGH
            ])if (boostEcl && dataUsedBits <= _QrCode.getNumDataCodewords(version, newEcl) * 8) ecl = newEcl;
            let bb = [];
            for (const seg of segs){
                appendBits(seg.mode.modeBits, 4, bb);
                appendBits(seg.numChars, seg.mode.numCharCountBits(version), bb);
                for (const b of seg.getData())bb.push(b);
            }
            assert(bb.length == dataUsedBits);
            const dataCapacityBits = _QrCode.getNumDataCodewords(version, ecl) * 8;
            assert(bb.length <= dataCapacityBits);
            appendBits(0, Math.min(4, dataCapacityBits - bb.length), bb);
            appendBits(0, (8 - bb.length % 8) % 8, bb);
            assert(bb.length % 8 == 0);
            for(let padByte = 236; bb.length < dataCapacityBits; padByte ^= 253)appendBits(padByte, 8, bb);
            let dataCodewords = [];
            while(dataCodewords.length * 8 < bb.length)dataCodewords.push(0);
            bb.forEach((b, i)=>dataCodewords[i >>> 3] |= b << 7 - (i & 7));
            return new _QrCode(version, ecl, dataCodewords, mask);
        }
        /*-- Accessor methods --*/ // Returns the color of the module (pixel) at the given coordinates, which is false
        // for light or true for dark. The top left corner has the coordinates (x=0, y=0).
        // If the given coordinates are out of bounds, then false (light) is returned.
        getModule(x, y) {
            return 0 <= x && x < this.size && 0 <= y && y < this.size && this.modules[y][x];
        }
        // Modified to expose modules for easy access
        getModules() {
            return this.modules;
        }
        /*-- Private helper methods for constructor: Drawing function modules --*/ // Reads this object's version field, and draws and marks all function modules.
        drawFunctionPatterns() {
            for(let i = 0; i < this.size; i++){
                this.setFunctionModule(6, i, i % 2 == 0);
                this.setFunctionModule(i, 6, i % 2 == 0);
            }
            this.drawFinderPattern(3, 3);
            this.drawFinderPattern(this.size - 4, 3);
            this.drawFinderPattern(3, this.size - 4);
            const alignPatPos = this.getAlignmentPatternPositions();
            const numAlign = alignPatPos.length;
            for(let i = 0; i < numAlign; i++){
                for(let j = 0; j < numAlign; j++)if (!(i == 0 && j == 0 || i == 0 && j == numAlign - 1 || i == numAlign - 1 && j == 0)) this.drawAlignmentPattern(alignPatPos[i], alignPatPos[j]);
            }
            this.drawFormatBits(0);
            this.drawVersion();
        }
        // Draws two copies of the format bits (with its own error correction code)
        // based on the given mask and this object's error correction level field.
        drawFormatBits(mask) {
            const data = this.errorCorrectionLevel.formatBits << 3 | mask;
            let rem = data;
            for(let i = 0; i < 10; i++)rem = rem << 1 ^ (rem >>> 9) * 1335;
            const bits = (data << 10 | rem) ^ 21522;
            assert(bits >>> 15 == 0);
            for(let i = 0; i <= 5; i++)this.setFunctionModule(8, i, getBit(bits, i));
            this.setFunctionModule(8, 7, getBit(bits, 6));
            this.setFunctionModule(8, 8, getBit(bits, 7));
            this.setFunctionModule(7, 8, getBit(bits, 8));
            for(let i = 9; i < 15; i++)this.setFunctionModule(14 - i, 8, getBit(bits, i));
            for(let i = 0; i < 8; i++)this.setFunctionModule(this.size - 1 - i, 8, getBit(bits, i));
            for(let i = 8; i < 15; i++)this.setFunctionModule(8, this.size - 15 + i, getBit(bits, i));
            this.setFunctionModule(8, this.size - 8, true);
        }
        // Draws two copies of the version bits (with its own error correction code),
        // based on this object's version field, iff 7 <= version <= 40.
        drawVersion() {
            if (this.version < 7) return;
            let rem = this.version;
            for(let i = 0; i < 12; i++)rem = rem << 1 ^ (rem >>> 11) * 7973;
            const bits = this.version << 12 | rem;
            assert(bits >>> 18 == 0);
            for(let i = 0; i < 18; i++){
                const color = getBit(bits, i);
                const a = this.size - 11 + i % 3;
                const b = Math.floor(i / 3);
                this.setFunctionModule(a, b, color);
                this.setFunctionModule(b, a, color);
            }
        }
        // Draws a 9*9 finder pattern including the border separator,
        // with the center module at (x, y). Modules can be out of bounds.
        drawFinderPattern(x, y) {
            for(let dy = -4; dy <= 4; dy++)for(let dx = -4; dx <= 4; dx++){
                const dist = Math.max(Math.abs(dx), Math.abs(dy));
                const xx = x + dx;
                const yy = y + dy;
                if (0 <= xx && xx < this.size && 0 <= yy && yy < this.size) this.setFunctionModule(xx, yy, dist != 2 && dist != 4);
            }
        }
        // Draws a 5*5 alignment pattern, with the center module
        // at (x, y). All modules must be in bounds.
        drawAlignmentPattern(x, y) {
            for(let dy = -2; dy <= 2; dy++)for(let dx = -2; dx <= 2; dx++)this.setFunctionModule(x + dx, y + dy, Math.max(Math.abs(dx), Math.abs(dy)) != 1);
        }
        // Sets the color of a module and marks it as a function module.
        // Only used by the constructor. Coordinates must be in bounds.
        setFunctionModule(x, y, isDark) {
            this.modules[y][x] = isDark;
            this.isFunction[y][x] = true;
        }
        /*-- Private helper methods for constructor: Codewords and masking --*/ // Returns a new byte string representing the given data with the appropriate error correction
        // codewords appended to it, based on this object's version and error correction level.
        addEccAndInterleave(data) {
            const ver = this.version;
            const ecl = this.errorCorrectionLevel;
            if (data.length != _QrCode.getNumDataCodewords(ver, ecl)) throw new RangeError("Invalid argument");
            const numBlocks = _QrCode.NUM_ERROR_CORRECTION_BLOCKS[ecl.ordinal][ver];
            const blockEccLen = _QrCode.ECC_CODEWORDS_PER_BLOCK[ecl.ordinal][ver];
            const rawCodewords = Math.floor(_QrCode.getNumRawDataModules(ver) / 8);
            const numShortBlocks = numBlocks - rawCodewords % numBlocks;
            const shortBlockLen = Math.floor(rawCodewords / numBlocks);
            let blocks = [];
            const rsDiv = _QrCode.reedSolomonComputeDivisor(blockEccLen);
            for(let i = 0, k = 0; i < numBlocks; i++){
                let dat = data.slice(k, k + shortBlockLen - blockEccLen + (i < numShortBlocks ? 0 : 1));
                k += dat.length;
                const ecc = _QrCode.reedSolomonComputeRemainder(dat, rsDiv);
                if (i < numShortBlocks) dat.push(0);
                blocks.push(dat.concat(ecc));
            }
            let result = [];
            for(let i = 0; i < blocks[0].length; i++)blocks.forEach((block, j)=>{
                if (i != shortBlockLen - blockEccLen || j >= numShortBlocks) result.push(block[i]);
            });
            assert(result.length == rawCodewords);
            return result;
        }
        // Draws the given sequence of 8-bit codewords (data and error correction) onto the entire
        // data area of this QR Code. Function modules need to be marked off before this is called.
        drawCodewords(data) {
            if (data.length != Math.floor(_QrCode.getNumRawDataModules(this.version) / 8)) throw new RangeError("Invalid argument");
            let i = 0;
            for(let right = this.size - 1; right >= 1; right -= 2){
                if (right == 6) right = 5;
                for(let vert = 0; vert < this.size; vert++)for(let j = 0; j < 2; j++){
                    const x = right - j;
                    const upward = (right + 1 & 2) == 0;
                    const y = upward ? this.size - 1 - vert : vert;
                    if (!this.isFunction[y][x] && i < data.length * 8) {
                        this.modules[y][x] = getBit(data[i >>> 3], 7 - (i & 7));
                        i++;
                    }
                }
            }
            assert(i == data.length * 8);
        }
        // XORs the codeword modules in this QR Code with the given mask pattern.
        // The function modules must be marked and the codeword bits must be drawn
        // before masking. Due to the arithmetic of XOR, calling applyMask() with
        // the same mask value a second time will undo the mask. A final well-formed
        // QR Code needs exactly one (not zero, two, etc.) mask applied.
        applyMask(mask) {
            if (mask < 0 || mask > 7) throw new RangeError("Mask value out of range");
            for(let y = 0; y < this.size; y++)for(let x = 0; x < this.size; x++){
                let invert;
                switch(mask){
                    case 0:
                        invert = (x + y) % 2 == 0;
                        break;
                    case 1:
                        invert = y % 2 == 0;
                        break;
                    case 2:
                        invert = x % 3 == 0;
                        break;
                    case 3:
                        invert = (x + y) % 3 == 0;
                        break;
                    case 4:
                        invert = (Math.floor(x / 3) + Math.floor(y / 2)) % 2 == 0;
                        break;
                    case 5:
                        invert = x * y % 2 + x * y % 3 == 0;
                        break;
                    case 6:
                        invert = (x * y % 2 + x * y % 3) % 2 == 0;
                        break;
                    case 7:
                        invert = ((x + y) % 2 + x * y % 3) % 2 == 0;
                        break;
                    default:
                        throw new Error("Unreachable");
                }
                if (!this.isFunction[y][x] && invert) this.modules[y][x] = !this.modules[y][x];
            }
        }
        // Calculates and returns the penalty score based on state of this QR Code's current modules.
        // This is used by the automatic mask choice algorithm to find the mask pattern that yields the lowest score.
        getPenaltyScore() {
            let result = 0;
            for(let y = 0; y < this.size; y++){
                let runColor = false;
                let runX = 0;
                let runHistory = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ];
                for(let x = 0; x < this.size; x++)if (this.modules[y][x] == runColor) {
                    runX++;
                    if (runX == 5) result += _QrCode.PENALTY_N1;
                    else if (runX > 5) result++;
                } else {
                    this.finderPenaltyAddHistory(runX, runHistory);
                    if (!runColor) result += this.finderPenaltyCountPatterns(runHistory) * _QrCode.PENALTY_N3;
                    runColor = this.modules[y][x];
                    runX = 1;
                }
                result += this.finderPenaltyTerminateAndCount(runColor, runX, runHistory) * _QrCode.PENALTY_N3;
            }
            for(let x = 0; x < this.size; x++){
                let runColor = false;
                let runY = 0;
                let runHistory = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ];
                for(let y = 0; y < this.size; y++)if (this.modules[y][x] == runColor) {
                    runY++;
                    if (runY == 5) result += _QrCode.PENALTY_N1;
                    else if (runY > 5) result++;
                } else {
                    this.finderPenaltyAddHistory(runY, runHistory);
                    if (!runColor) result += this.finderPenaltyCountPatterns(runHistory) * _QrCode.PENALTY_N3;
                    runColor = this.modules[y][x];
                    runY = 1;
                }
                result += this.finderPenaltyTerminateAndCount(runColor, runY, runHistory) * _QrCode.PENALTY_N3;
            }
            for(let y = 0; y < this.size - 1; y++)for(let x = 0; x < this.size - 1; x++){
                const color = this.modules[y][x];
                if (color == this.modules[y][x + 1] && color == this.modules[y + 1][x] && color == this.modules[y + 1][x + 1]) result += _QrCode.PENALTY_N2;
            }
            let dark = 0;
            for (const row of this.modules)dark = row.reduce((sum, color)=>sum + (color ? 1 : 0), dark);
            const total = this.size * this.size;
            const k = Math.ceil(Math.abs(dark * 20 - total * 10) / total) - 1;
            assert(0 <= k && k <= 9);
            result += k * _QrCode.PENALTY_N4;
            assert(0 <= result && result <= 2568888);
            return result;
        }
        /*-- Private helper functions --*/ // Returns an ascending list of positions of alignment patterns for this version number.
        // Each position is in the range [0,177), and are used on both the x and y axes.
        // This could be implemented as lookup table of 40 variable-length lists of integers.
        getAlignmentPatternPositions() {
            if (this.version == 1) return [];
            else {
                const numAlign = Math.floor(this.version / 7) + 2;
                const step = this.version == 32 ? 26 : Math.ceil((this.version * 4 + 4) / (numAlign * 2 - 2)) * 2;
                let result = [
                    6
                ];
                for(let pos = this.size - 7; result.length < numAlign; pos -= step)result.splice(1, 0, pos);
                return result;
            }
        }
        // Returns the number of data bits that can be stored in a QR Code of the given version number, after
        // all function modules are excluded. This includes remainder bits, so it might not be a multiple of 8.
        // The result is in the range [208, 29648]. This could be implemented as a 40-entry lookup table.
        static getNumRawDataModules(ver) {
            if (ver < _QrCode.MIN_VERSION || ver > _QrCode.MAX_VERSION) throw new RangeError("Version number out of range");
            let result = (16 * ver + 128) * ver + 64;
            if (ver >= 2) {
                const numAlign = Math.floor(ver / 7) + 2;
                result -= (25 * numAlign - 10) * numAlign - 55;
                if (ver >= 7) result -= 36;
            }
            assert(208 <= result && result <= 29648);
            return result;
        }
        // Returns the number of 8-bit data (i.e. not error correction) codewords contained in any
        // QR Code of the given version number and error correction level, with remainder bits discarded.
        // This stateless pure function could be implemented as a (40*4)-cell lookup table.
        static getNumDataCodewords(ver, ecl) {
            return Math.floor(_QrCode.getNumRawDataModules(ver) / 8) - _QrCode.ECC_CODEWORDS_PER_BLOCK[ecl.ordinal][ver] * _QrCode.NUM_ERROR_CORRECTION_BLOCKS[ecl.ordinal][ver];
        }
        // Returns a Reed-Solomon ECC generator polynomial for the given degree. This could be
        // implemented as a lookup table over all possible parameter values, instead of as an algorithm.
        static reedSolomonComputeDivisor(degree) {
            if (degree < 1 || degree > 255) throw new RangeError("Degree out of range");
            let result = [];
            for(let i = 0; i < degree - 1; i++)result.push(0);
            result.push(1);
            let root = 1;
            for(let i = 0; i < degree; i++){
                for(let j = 0; j < result.length; j++){
                    result[j] = _QrCode.reedSolomonMultiply(result[j], root);
                    if (j + 1 < result.length) result[j] ^= result[j + 1];
                }
                root = _QrCode.reedSolomonMultiply(root, 2);
            }
            return result;
        }
        // Returns the Reed-Solomon error correction codeword for the given data and divisor polynomials.
        static reedSolomonComputeRemainder(data, divisor) {
            let result = divisor.map((_)=>0);
            for (const b of data){
                const factor = b ^ result.shift();
                result.push(0);
                divisor.forEach((coef, i)=>result[i] ^= _QrCode.reedSolomonMultiply(coef, factor));
            }
            return result;
        }
        // Returns the product of the two given field elements modulo GF(2^8/0x11D). The arguments and result
        // are unsigned 8-bit integers. This could be implemented as a lookup table of 256*256 entries of uint8.
        static reedSolomonMultiply(x, y) {
            if (x >>> 8 != 0 || y >>> 8 != 0) throw new RangeError("Byte out of range");
            let z = 0;
            for(let i = 7; i >= 0; i--){
                z = z << 1 ^ (z >>> 7) * 285;
                z ^= (y >>> i & 1) * x;
            }
            assert(z >>> 8 == 0);
            return z;
        }
        // Can only be called immediately after a light run is added, and
        // returns either 0, 1, or 2. A helper function for getPenaltyScore().
        finderPenaltyCountPatterns(runHistory) {
            const n = runHistory[1];
            assert(n <= this.size * 3);
            const core = n > 0 && runHistory[2] == n && runHistory[3] == n * 3 && runHistory[4] == n && runHistory[5] == n;
            return (core && runHistory[0] >= n * 4 && runHistory[6] >= n ? 1 : 0) + (core && runHistory[6] >= n * 4 && runHistory[0] >= n ? 1 : 0);
        }
        // Must be called at the end of a line (row or column) of modules. A helper function for getPenaltyScore().
        finderPenaltyTerminateAndCount(currentRunColor, currentRunLength, runHistory) {
            if (currentRunColor) {
                this.finderPenaltyAddHistory(currentRunLength, runHistory);
                currentRunLength = 0;
            }
            currentRunLength += this.size;
            this.finderPenaltyAddHistory(currentRunLength, runHistory);
            return this.finderPenaltyCountPatterns(runHistory);
        }
        // Pushes the given value to the front and drops the last value. A helper function for getPenaltyScore().
        finderPenaltyAddHistory(currentRunLength, runHistory) {
            if (runHistory[0] == 0) currentRunLength += this.size;
            runHistory.pop();
            runHistory.unshift(currentRunLength);
        }
    };
    /*-- Constants and tables --*/ // The minimum version number supported in the QR Code Model 2 standard.
    _QrCode.MIN_VERSION = 1;
    // The maximum version number supported in the QR Code Model 2 standard.
    _QrCode.MAX_VERSION = 40;
    // For use in getPenaltyScore(), when evaluating which mask is best.
    _QrCode.PENALTY_N1 = 3;
    _QrCode.PENALTY_N2 = 3;
    _QrCode.PENALTY_N3 = 40;
    _QrCode.PENALTY_N4 = 10;
    _QrCode.ECC_CODEWORDS_PER_BLOCK = [
        // Version: (note that index 0 is for padding, and is set to an illegal value)
        //0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40    Error correction level
        [
            -1,
            7,
            10,
            15,
            20,
            26,
            18,
            20,
            24,
            30,
            18,
            20,
            24,
            26,
            30,
            22,
            24,
            28,
            30,
            28,
            28,
            28,
            28,
            30,
            30,
            26,
            28,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30
        ],
        // Low
        [
            -1,
            10,
            16,
            26,
            18,
            24,
            16,
            18,
            22,
            22,
            26,
            30,
            22,
            22,
            24,
            24,
            28,
            28,
            26,
            26,
            26,
            26,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28
        ],
        // Medium
        [
            -1,
            13,
            22,
            18,
            26,
            18,
            24,
            18,
            22,
            20,
            24,
            28,
            26,
            24,
            20,
            30,
            24,
            28,
            28,
            26,
            30,
            28,
            30,
            30,
            30,
            30,
            28,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30
        ],
        // Quartile
        [
            -1,
            17,
            28,
            22,
            16,
            22,
            28,
            26,
            26,
            24,
            28,
            24,
            28,
            22,
            24,
            24,
            30,
            28,
            28,
            26,
            28,
            30,
            24,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30
        ]
    ];
    _QrCode.NUM_ERROR_CORRECTION_BLOCKS = [
        // Version: (note that index 0 is for padding, and is set to an illegal value)
        //0, 1, 2, 3, 4, 5, 6, 7, 8, 9,10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40    Error correction level
        [
            -1,
            1,
            1,
            1,
            1,
            1,
            2,
            2,
            2,
            2,
            4,
            4,
            4,
            4,
            4,
            6,
            6,
            6,
            6,
            7,
            8,
            8,
            9,
            9,
            10,
            12,
            12,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            19,
            20,
            21,
            22,
            24,
            25
        ],
        // Low
        [
            -1,
            1,
            1,
            1,
            2,
            2,
            4,
            4,
            4,
            5,
            5,
            5,
            8,
            9,
            9,
            10,
            10,
            11,
            13,
            14,
            16,
            17,
            17,
            18,
            20,
            21,
            23,
            25,
            26,
            28,
            29,
            31,
            33,
            35,
            37,
            38,
            40,
            43,
            45,
            47,
            49
        ],
        // Medium
        [
            -1,
            1,
            1,
            2,
            2,
            4,
            4,
            6,
            6,
            8,
            8,
            8,
            10,
            12,
            16,
            12,
            17,
            16,
            18,
            21,
            20,
            23,
            23,
            25,
            27,
            29,
            34,
            34,
            35,
            38,
            40,
            43,
            45,
            48,
            51,
            53,
            56,
            59,
            62,
            65,
            68
        ],
        // Quartile
        [
            -1,
            1,
            1,
            2,
            4,
            4,
            4,
            5,
            6,
            8,
            8,
            11,
            11,
            16,
            16,
            18,
            16,
            19,
            21,
            25,
            25,
            25,
            34,
            30,
            32,
            35,
            37,
            40,
            42,
            45,
            48,
            51,
            54,
            57,
            60,
            63,
            66,
            70,
            74,
            77,
            81
        ]
    ];
    let QrCode = _QrCode;
    qrcodegen2.QrCode = _QrCode;
    function appendBits(val, len, bb) {
        if (len < 0 || len > 31 || val >>> len != 0) throw new RangeError("Value out of range");
        for(let i = len - 1; i >= 0; i--)bb.push(val >>> i & 1);
    }
    function getBit(x, i) {
        return (x >>> i & 1) != 0;
    }
    function assert(cond) {
        if (!cond) throw new Error("Assertion error");
    }
    const _QrSegment = class _QrSegment {
        /*-- Constructor (low level) and fields --*/ // Creates a new QR Code segment with the given attributes and data.
        // The character count (numChars) must agree with the mode and the bit buffer length,
        // but the constraint isn't checked. The given bit buffer is cloned and stored.
        constructor(mode, numChars, bitData){
            this.mode = mode;
            this.numChars = numChars;
            this.bitData = bitData;
            if (numChars < 0) throw new RangeError("Invalid argument");
            this.bitData = bitData.slice();
        }
        /*-- Static factory functions (mid level) --*/ // Returns a segment representing the given binary data encoded in
        // byte mode. All input byte arrays are acceptable. Any text string
        // can be converted to UTF-8 bytes and encoded as a byte mode segment.
        static makeBytes(data) {
            let bb = [];
            for (const b of data)appendBits(b, 8, bb);
            return new _QrSegment(_QrSegment.Mode.BYTE, data.length, bb);
        }
        // Returns a segment representing the given string of decimal digits encoded in numeric mode.
        static makeNumeric(digits) {
            if (!_QrSegment.isNumeric(digits)) throw new RangeError("String contains non-numeric characters");
            let bb = [];
            for(let i = 0; i < digits.length;){
                const n = Math.min(digits.length - i, 3);
                appendBits(parseInt(digits.substring(i, i + n), 10), n * 3 + 1, bb);
                i += n;
            }
            return new _QrSegment(_QrSegment.Mode.NUMERIC, digits.length, bb);
        }
        // Returns a segment representing the given text string encoded in alphanumeric mode.
        // The characters allowed are: 0 to 9, A to Z (uppercase only), space,
        // dollar, percent, asterisk, plus, hyphen, period, slash, colon.
        static makeAlphanumeric(text) {
            if (!_QrSegment.isAlphanumeric(text)) throw new RangeError("String contains unencodable characters in alphanumeric mode");
            let bb = [];
            let i;
            for(i = 0; i + 2 <= text.length; i += 2){
                let temp = _QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)) * 45;
                temp += _QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i + 1));
                appendBits(temp, 11, bb);
            }
            if (i < text.length) appendBits(_QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)), 6, bb);
            return new _QrSegment(_QrSegment.Mode.ALPHANUMERIC, text.length, bb);
        }
        // Returns a new mutable list of zero or more segments to represent the given Unicode text string.
        // The result may use various segment modes and switch modes to optimize the length of the bit stream.
        static makeSegments(text) {
            if (text == "") return [];
            else if (_QrSegment.isNumeric(text)) return [
                _QrSegment.makeNumeric(text)
            ];
            else if (_QrSegment.isAlphanumeric(text)) return [
                _QrSegment.makeAlphanumeric(text)
            ];
            else return [
                _QrSegment.makeBytes(_QrSegment.toUtf8ByteArray(text))
            ];
        }
        // Returns a segment representing an Extended Channel Interpretation
        // (ECI) designator with the given assignment value.
        static makeEci(assignVal) {
            let bb = [];
            if (assignVal < 0) throw new RangeError("ECI assignment value out of range");
            else if (assignVal < 128) appendBits(assignVal, 8, bb);
            else if (assignVal < 16384) {
                appendBits(2, 2, bb);
                appendBits(assignVal, 14, bb);
            } else if (assignVal < 1e6) {
                appendBits(6, 3, bb);
                appendBits(assignVal, 21, bb);
            } else throw new RangeError("ECI assignment value out of range");
            return new _QrSegment(_QrSegment.Mode.ECI, 0, bb);
        }
        // Tests whether the given string can be encoded as a segment in numeric mode.
        // A string is encodable iff each character is in the range 0 to 9.
        static isNumeric(text) {
            return _QrSegment.NUMERIC_REGEX.test(text);
        }
        // Tests whether the given string can be encoded as a segment in alphanumeric mode.
        // A string is encodable iff each character is in the following set: 0 to 9, A to Z
        // (uppercase only), space, dollar, percent, asterisk, plus, hyphen, period, slash, colon.
        static isAlphanumeric(text) {
            return _QrSegment.ALPHANUMERIC_REGEX.test(text);
        }
        /*-- Methods --*/ // Returns a new copy of the data bits of this segment.
        getData() {
            return this.bitData.slice();
        }
        // (Package-private) Calculates and returns the number of bits needed to encode the given segments at
        // the given version. The result is infinity if a segment has too many characters to fit its length field.
        static getTotalBits(segs, version) {
            let result = 0;
            for (const seg of segs){
                const ccbits = seg.mode.numCharCountBits(version);
                if (seg.numChars >= 1 << ccbits) return Infinity;
                result += 4 + ccbits + seg.bitData.length;
            }
            return result;
        }
        // Returns a new array of bytes representing the given string encoded in UTF-8.
        static toUtf8ByteArray(str) {
            str = encodeURI(str);
            let result = [];
            for(let i = 0; i < str.length; i++)if (str.charAt(i) != "%") result.push(str.charCodeAt(i));
            else {
                result.push(parseInt(str.substring(i + 1, i + 3), 16));
                i += 2;
            }
            return result;
        }
    };
    /*-- Constants --*/ // Describes precisely all strings that are encodable in numeric mode.
    _QrSegment.NUMERIC_REGEX = /^[0-9]*$/;
    // Describes precisely all strings that are encodable in alphanumeric mode.
    _QrSegment.ALPHANUMERIC_REGEX = /^[A-Z0-9 $%*+.\/:-]*$/;
    // The set of all legal characters in alphanumeric mode,
    // where each character value maps to the index in the string.
    _QrSegment.ALPHANUMERIC_CHARSET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:";
    let QrSegment = _QrSegment;
    qrcodegen2.QrSegment = _QrSegment;
})($8b78587e05097331$var$qrcodegen || ($8b78587e05097331$var$qrcodegen = {}));
((qrcodegen2)=>{
    let QrCode;
    ((QrCode2)=>{
        const _Ecc = class _Ecc {
            // The QR Code can tolerate about 30% erroneous codewords
            /*-- Constructor and fields --*/ constructor(ordinal, formatBits){
                this.ordinal = ordinal;
                this.formatBits = formatBits;
            }
        };
        /*-- Constants --*/ _Ecc.LOW = new _Ecc(0, 1);
        // The QR Code can tolerate about  7% erroneous codewords
        _Ecc.MEDIUM = new _Ecc(1, 0);
        // The QR Code can tolerate about 15% erroneous codewords
        _Ecc.QUARTILE = new _Ecc(2, 3);
        // The QR Code can tolerate about 25% erroneous codewords
        _Ecc.HIGH = new _Ecc(3, 2);
        let Ecc = _Ecc;
        QrCode2.Ecc = _Ecc;
    })(QrCode = qrcodegen2.QrCode || (qrcodegen2.QrCode = {}));
})($8b78587e05097331$var$qrcodegen || ($8b78587e05097331$var$qrcodegen = {}));
((qrcodegen2)=>{
    let QrSegment;
    ((QrSegment2)=>{
        const _Mode = class _Mode {
            /*-- Constructor and fields --*/ constructor(modeBits, numBitsCharCount){
                this.modeBits = modeBits;
                this.numBitsCharCount = numBitsCharCount;
            }
            /*-- Method --*/ // (Package-private) Returns the bit width of the character count field for a segment in
            // this mode in a QR Code at the given version number. The result is in the range [0, 16].
            numCharCountBits(ver) {
                return this.numBitsCharCount[Math.floor((ver + 7) / 17)];
            }
        };
        /*-- Constants --*/ _Mode.NUMERIC = new _Mode(1, [
            10,
            12,
            14
        ]);
        _Mode.ALPHANUMERIC = new _Mode(2, [
            9,
            11,
            13
        ]);
        _Mode.BYTE = new _Mode(4, [
            8,
            16,
            16
        ]);
        _Mode.KANJI = new _Mode(8, [
            8,
            10,
            12
        ]);
        _Mode.ECI = new _Mode(7, [
            0,
            0,
            0
        ]);
        let Mode = _Mode;
        QrSegment2.Mode = _Mode;
    })(QrSegment = qrcodegen2.QrSegment || (qrcodegen2.QrSegment = {}));
})($8b78587e05097331$var$qrcodegen || ($8b78587e05097331$var$qrcodegen = {}));
var $8b78587e05097331$var$qrcodegen_default = $8b78587e05097331$var$qrcodegen;
// src/index.tsx
/**
 * @license qrcode.react
 * Copyright (c) Paul O'Shannessy
 * SPDX-License-Identifier: ISC
 */ var $8b78587e05097331$var$ERROR_LEVEL_MAP = {
    L: $8b78587e05097331$var$qrcodegen_default.QrCode.Ecc.LOW,
    M: $8b78587e05097331$var$qrcodegen_default.QrCode.Ecc.MEDIUM,
    Q: $8b78587e05097331$var$qrcodegen_default.QrCode.Ecc.QUARTILE,
    H: $8b78587e05097331$var$qrcodegen_default.QrCode.Ecc.HIGH
};
var $8b78587e05097331$var$DEFAULT_SIZE = 128;
var $8b78587e05097331$var$DEFAULT_LEVEL = "L";
var $8b78587e05097331$var$DEFAULT_BGCOLOR = "#FFFFFF";
var $8b78587e05097331$var$DEFAULT_FGCOLOR = "#000000";
var $8b78587e05097331$var$DEFAULT_INCLUDEMARGIN = false;
var $8b78587e05097331$var$DEFAULT_MINVERSION = 1;
var $8b78587e05097331$var$SPEC_MARGIN_SIZE = 4;
var $8b78587e05097331$var$DEFAULT_MARGIN_SIZE = 0;
var $8b78587e05097331$var$DEFAULT_IMG_SCALE = 0.1;
function $8b78587e05097331$var$generatePath(modules, margin = 0) {
    const ops = [];
    modules.forEach(function(row, y) {
        let start = null;
        row.forEach(function(cell, x) {
            if (!cell && start !== null) {
                ops.push(`M${start + margin} ${y + margin}h${x - start}v1H${start + margin}z`);
                start = null;
                return;
            }
            if (x === row.length - 1) {
                if (!cell) return;
                if (start === null) ops.push(`M${x + margin},${y + margin} h1v1H${x + margin}z`);
                else ops.push(`M${start + margin},${y + margin} h${x + 1 - start}v1H${start + margin}z`);
                return;
            }
            if (cell && start === null) start = x;
        });
    });
    return ops.join("");
}
function $8b78587e05097331$var$excavateModules(modules, excavation) {
    return modules.slice().map((row, y)=>{
        if (y < excavation.y || y >= excavation.y + excavation.h) return row;
        return row.map((cell, x)=>{
            if (x < excavation.x || x >= excavation.x + excavation.w) return cell;
            return false;
        });
    });
}
function $8b78587e05097331$var$getImageSettings(cells, size, margin, imageSettings) {
    if (imageSettings == null) return null;
    const numCells = cells.length + margin * 2;
    const defaultSize = Math.floor(size * $8b78587e05097331$var$DEFAULT_IMG_SCALE);
    const scale = numCells / size;
    const w = (imageSettings.width || defaultSize) * scale;
    const h = (imageSettings.height || defaultSize) * scale;
    const x = imageSettings.x == null ? cells.length / 2 - w / 2 : imageSettings.x * scale;
    const y = imageSettings.y == null ? cells.length / 2 - h / 2 : imageSettings.y * scale;
    const opacity = imageSettings.opacity == null ? 1 : imageSettings.opacity;
    let excavation = null;
    if (imageSettings.excavate) {
        let floorX = Math.floor(x);
        let floorY = Math.floor(y);
        let ceilW = Math.ceil(w + x - floorX);
        let ceilH = Math.ceil(h + y - floorY);
        excavation = {
            x: floorX,
            y: floorY,
            w: ceilW,
            h: ceilH
        };
    }
    const crossOrigin = imageSettings.crossOrigin;
    return {
        x: x,
        y: y,
        h: h,
        w: w,
        excavation: excavation,
        opacity: opacity,
        crossOrigin: crossOrigin
    };
}
function $8b78587e05097331$var$getMarginSize(includeMargin, marginSize) {
    if (marginSize != null) return Math.max(Math.floor(marginSize), 0);
    return includeMargin ? $8b78587e05097331$var$SPEC_MARGIN_SIZE : $8b78587e05097331$var$DEFAULT_MARGIN_SIZE;
}
function $8b78587e05097331$var$useQRCode({ value: value, level: level, minVersion: minVersion, includeMargin: includeMargin, marginSize: marginSize, imageSettings: imageSettings, size: size, boostLevel: boostLevel }) {
    let qrcode = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const values = Array.isArray(value) ? value : [
            value
        ];
        const segments = values.reduce((accum, v)=>{
            accum.push(...$8b78587e05097331$var$qrcodegen_default.QrSegment.makeSegments(v));
            return accum;
        }, []);
        return $8b78587e05097331$var$qrcodegen_default.QrCode.encodeSegments(segments, $8b78587e05097331$var$ERROR_LEVEL_MAP[level], minVersion, void 0, void 0, boostLevel);
    }, [
        value,
        level,
        minVersion,
        boostLevel
    ]);
    const { cells: cells, margin: margin, numCells: numCells, calculatedImageSettings: calculatedImageSettings } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        let cells2 = qrcode.getModules();
        const margin2 = $8b78587e05097331$var$getMarginSize(includeMargin, marginSize);
        const numCells2 = cells2.length + margin2 * 2;
        const calculatedImageSettings2 = $8b78587e05097331$var$getImageSettings(cells2, size, margin2, imageSettings);
        return {
            cells: cells2,
            margin: margin2,
            numCells: numCells2,
            calculatedImageSettings: calculatedImageSettings2
        };
    }, [
        qrcode,
        size,
        imageSettings,
        includeMargin,
        marginSize
    ]);
    return {
        qrcode: qrcode,
        margin: margin,
        cells: cells,
        numCells: numCells,
        calculatedImageSettings: calculatedImageSettings
    };
}
var $8b78587e05097331$var$SUPPORTS_PATH2D = function() {
    try {
        new Path2D().addPath(new Path2D());
    } catch (e) {
        return false;
    }
    return true;
}();
var $8b78587e05097331$export$7e3713cf0c0fe9d0 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function QRCodeCanvas2(props, forwardedRef) {
    const _a = props, { value: value, size: size = $8b78587e05097331$var$DEFAULT_SIZE, level: level = $8b78587e05097331$var$DEFAULT_LEVEL, bgColor: bgColor = $8b78587e05097331$var$DEFAULT_BGCOLOR, fgColor: fgColor = $8b78587e05097331$var$DEFAULT_FGCOLOR, includeMargin: includeMargin = $8b78587e05097331$var$DEFAULT_INCLUDEMARGIN, minVersion: minVersion = $8b78587e05097331$var$DEFAULT_MINVERSION, boostLevel: boostLevel, marginSize: marginSize, imageSettings: imageSettings } = _a, extraProps = $8b78587e05097331$var$__objRest(_a, [
        "value",
        "size",
        "level",
        "bgColor",
        "fgColor",
        "includeMargin",
        "minVersion",
        "boostLevel",
        "marginSize",
        "imageSettings"
    ]);
    const _b = extraProps, { style: style } = _b, otherProps = $8b78587e05097331$var$__objRest(_b, [
        "style"
    ]);
    const imgSrc = imageSettings == null ? void 0 : imageSettings.src;
    const _canvas = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const _image = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const setCanvasRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((node)=>{
        _canvas.current = node;
        if (typeof forwardedRef === "function") forwardedRef(node);
        else if (forwardedRef) forwardedRef.current = node;
    }, [
        forwardedRef
    ]);
    const [isImgLoaded, setIsImageLoaded] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const { margin: margin, cells: cells, numCells: numCells, calculatedImageSettings: calculatedImageSettings } = $8b78587e05097331$var$useQRCode({
        value: value,
        level: level,
        minVersion: minVersion,
        boostLevel: boostLevel,
        includeMargin: includeMargin,
        marginSize: marginSize,
        imageSettings: imageSettings,
        size: size
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (_canvas.current != null) {
            const canvas = _canvas.current;
            const ctx = canvas.getContext("2d");
            if (!ctx) return;
            let cellsToDraw = cells;
            const image = _image.current;
            const haveImageToRender = calculatedImageSettings != null && image !== null && image.complete && image.naturalHeight !== 0 && image.naturalWidth !== 0;
            if (haveImageToRender) {
                if (calculatedImageSettings.excavation != null) cellsToDraw = $8b78587e05097331$var$excavateModules(cells, calculatedImageSettings.excavation);
            }
            const pixelRatio = window.devicePixelRatio || 1;
            canvas.height = canvas.width = size * pixelRatio;
            const scale = size / numCells * pixelRatio;
            ctx.scale(scale, scale);
            ctx.fillStyle = bgColor;
            ctx.fillRect(0, 0, numCells, numCells);
            ctx.fillStyle = fgColor;
            if ($8b78587e05097331$var$SUPPORTS_PATH2D) ctx.fill(new Path2D($8b78587e05097331$var$generatePath(cellsToDraw, margin)));
            else cells.forEach(function(row, rdx) {
                row.forEach(function(cell, cdx) {
                    if (cell) ctx.fillRect(cdx + margin, rdx + margin, 1, 1);
                });
            });
            if (calculatedImageSettings) ctx.globalAlpha = calculatedImageSettings.opacity;
            if (haveImageToRender) ctx.drawImage(image, calculatedImageSettings.x + margin, calculatedImageSettings.y + margin, calculatedImageSettings.w, calculatedImageSettings.h);
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setIsImageLoaded(false);
    }, [
        imgSrc
    ]);
    const canvasStyle = $8b78587e05097331$var$__spreadValues({
        height: size,
        width: size
    }, style);
    let img = null;
    if (imgSrc != null) img = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: imgSrc,
        key: imgSrc,
        style: {
            display: "none"
        },
        onLoad: ()=>{
            setIsImageLoaded(true);
        },
        ref: _image,
        crossOrigin: calculatedImageSettings == null ? void 0 : calculatedImageSettings.crossOrigin
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("canvas", $8b78587e05097331$var$__spreadValues({
        style: canvasStyle,
        height: size,
        width: size,
        ref: setCanvasRef,
        role: "img"
    }, otherProps)), img);
});
$8b78587e05097331$export$7e3713cf0c0fe9d0.displayName = "QRCodeCanvas";
var $8b78587e05097331$export$10307208e61210e9 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function QRCodeSVG2(props, forwardedRef) {
    const _a = props, { value: value, size: size = $8b78587e05097331$var$DEFAULT_SIZE, level: level = $8b78587e05097331$var$DEFAULT_LEVEL, bgColor: bgColor = $8b78587e05097331$var$DEFAULT_BGCOLOR, fgColor: fgColor = $8b78587e05097331$var$DEFAULT_FGCOLOR, includeMargin: includeMargin = $8b78587e05097331$var$DEFAULT_INCLUDEMARGIN, minVersion: minVersion = $8b78587e05097331$var$DEFAULT_MINVERSION, boostLevel: boostLevel, title: title, marginSize: marginSize, imageSettings: imageSettings } = _a, otherProps = $8b78587e05097331$var$__objRest(_a, [
        "value",
        "size",
        "level",
        "bgColor",
        "fgColor",
        "includeMargin",
        "minVersion",
        "boostLevel",
        "title",
        "marginSize",
        "imageSettings"
    ]);
    const { margin: margin, cells: cells, numCells: numCells, calculatedImageSettings: calculatedImageSettings } = $8b78587e05097331$var$useQRCode({
        value: value,
        level: level,
        minVersion: minVersion,
        boostLevel: boostLevel,
        includeMargin: includeMargin,
        marginSize: marginSize,
        imageSettings: imageSettings,
        size: size
    });
    let cellsToDraw = cells;
    let image = null;
    if (imageSettings != null && calculatedImageSettings != null) {
        if (calculatedImageSettings.excavation != null) cellsToDraw = $8b78587e05097331$var$excavateModules(cells, calculatedImageSettings.excavation);
        image = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("image", {
            href: imageSettings.src,
            height: calculatedImageSettings.h,
            width: calculatedImageSettings.w,
            x: calculatedImageSettings.x + margin,
            y: calculatedImageSettings.y + margin,
            preserveAspectRatio: "none",
            opacity: calculatedImageSettings.opacity,
            crossOrigin: calculatedImageSettings.crossOrigin
        });
    }
    const fgPath = $8b78587e05097331$var$generatePath(cellsToDraw, margin);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $8b78587e05097331$var$__spreadValues({
        height: size,
        width: size,
        viewBox: `0 0 ${numCells} ${numCells}`,
        ref: forwardedRef,
        role: "img"
    }, otherProps), !!title && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: bgColor,
        d: `M0,0 h${numCells}v${numCells}H0z`,
        shapeRendering: "crispEdges"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: fgColor,
        d: fgPath,
        shapeRendering: "crispEdges"
    }), image);
});
$8b78587e05097331$export$10307208e61210e9.displayName = "QRCodeSVG";





const $426e52f8305c025b$var$LoginPage = ()=>{
    const navigate = (0, $585f8bce88e531c1$export$9770f232ac06a008)();
    const location = (0, $585f8bce88e531c1$export$45d76561a5302f2b)();
    const { isAuthenticated: isAuthenticated, setProfile: setProfile } = (0, $b622ef53e38024e7$export$1d39dc5b47e56ff0)();
    const [stage, setStage] = (0, $acw62.useState)("credentials");
    const [errorTitle, setErrorTitle] = (0, $acw62.useState)(null);
    const [error, setError] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [challengeToken, setChallengeToken] = (0, $acw62.useState)("");
    const [enroll, setEnroll] = (0, $acw62.useState)(null);
    const [code, setCode] = (0, $acw62.useState)("");
    const [resendCooldown, setResendCooldown] = (0, $acw62.useState)(0);
    const [trustDevice, setTrustDevice] = (0, $acw62.useState)(false);
    const [loginRequest, setLoginRequest] = (0, $acw62.useState)({
        username: "",
        password: ""
    });
    const handleError = (error)=>{
        if (!error) {
            setError(null);
            return;
        }
        if (error.response?.status === 401) setError("Acesso n\xe3o autorizado or expirado. Por favor, fa\xe7a login novamente.");
        else if (error.response?.status === 422) setError("Dados inv\xe1lidos. Por favor, verifique suas credenciais.");
        else if (error.response?.status === 403) {
            setErrorTitle("Acesso proibido.");
            setError("Por favor, contacte o suporte.");
        } else if (error.response?.status === 423) {
            const cookieLock = error.response?.data?.profile?.username || "unknown";
            setErrorTitle("Sess\xe3o Bloqueada");
            setError("Por favor, contacte o suporte para desbloquear o device: " + cookieLock);
        } else if (error.response?.status === 500) setError("Erro interno do servidor. Por favor, tente novamente mais tarde.");
        else if (error.response?.status === 503 || error.response?.status === 502) setError("Servi\xe7o indispon\xedvel. Por favor, tente novamente mais tarde.");
        else if (error.response?.status === 504) setError("Tempo limite de conex\xe3o excedido. Por favor, tente novamente mais tarde.");
        else setError(error?.message);
    };
    const completeLogin = (data)=>{
        setProfile(data);
        let goToUrl = location.state?.from || "/";
        if (goToUrl === "/login") goToUrl = "/";
        navigate(goToUrl, {
            replace: true
        });
    };
    const handleCredentials = async (e)=>{
        e.preventDefault();
        if (!loginRequest.username || !loginRequest.password) {
            setError("username and password s\xe3o obrigat\xf3rios");
            return;
        }
        setLoading(true);
        setError(null);
        try {
            const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).post((0, $cd93687958c8007e$export$bfe19bc25132bb7c).LOGIN, loginRequest);
            const data = response.data;
            if (data && data.mfa_required) {
                setChallengeToken(data.challenge_token);
                setStage("mfa");
                setCode("");
                setTrustDevice(false);
            } else completeLogin(data);
        } catch (err) {
            if (err.response?.status === 428) {
                const d = err.response?.data;
                setEnroll({
                    enrollToken: d.enroll_token,
                    secret: d.secret,
                    otpauthUri: d.otpauth_uri,
                    issuer: d.issuer,
                    account: d.account
                });
                setStage("enroll");
                setCode("");
            } else handleError(err);
        } finally{
            setLoading(false);
        }
    };
    const handleVerifyMfa = async (e)=>{
        e.preventDefault();
        if (!code) return;
        setLoading(true);
        setError(null);
        try {
            const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).post((0, $cd93687958c8007e$export$bfe19bc25132bb7c).MFA_VERIFY, {
                challenge_token: challengeToken,
                code: code,
                trust_device: trustDevice
            });
            completeLogin(response.data);
        } catch (err) {
            if (err.response?.status === 429) setError("Demasiadas tentativas. Aguarde e tente novamente.");
            else if (err.response?.status === 401) setError("C\xf3digo inv\xe1lido. Tente novamente.");
            else setError("N\xe3o foi poss\xedvel verificar o c\xf3digo. Tente novamente.");
        } finally{
            setLoading(false);
        }
    };
    const handleResendOtp = async (tokenField, token)=>{
        if (resendCooldown > 0) return;
        setError(null);
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).post((0, $cd93687958c8007e$export$bfe19bc25132bb7c).MFA_RESEND_OTP, {
                [tokenField]: token
            });
            setResendCooldown(30);
            const timer = setInterval(()=>{
                setResendCooldown((v)=>{
                    if (v <= 1) {
                        clearInterval(timer);
                        return 0;
                    }
                    return v - 1;
                });
            }, 1000);
        } catch  {
            setError("N\xe3o foi poss\xedvel enviar o c\xf3digo. Tente novamente.");
        }
    };
    const handleConfirmEnroll = async (e)=>{
        e.preventDefault();
        if (!enroll || !code) return;
        setLoading(true);
        setError(null);
        try {
            const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).post((0, $cd93687958c8007e$export$bfe19bc25132bb7c).MFA_ENROLL_CONFIRM, {
                enroll_token: enroll.enrollToken,
                code: code
            });
            completeLogin(response.data);
        } catch (err) {
            if (err.response?.status === 401) setError("C\xf3digo inv\xe1lido. Tente novamente.");
            else setError("N\xe3o foi poss\xedvel confirmar. Tente novamente.");
        } finally{
            setLoading(false);
        }
    };
    const copySecret = async ()=>{
        if (!enroll) return;
        try {
            await navigator.clipboard.writeText(enroll.secret);
        } catch  {
        // clipboard write failure is non-critical
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (location.pathname === "/logout") {
            // @ts-ignore
            (0, $bac44633733ff026$export$2e2bcd8739ae039).clearToken();
            setProfile(null);
            setError(null);
            setErrorTitle(null);
            navigate("/login", {
                replace: true
            });
        }
    }, [
        location.pathname,
        navigate,
        setProfile
    ]);
    if (isAuthenticated()) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex items-center justify-center min-h-screen bg-gray-100",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "bg-white p-8 rounded shadow-md w-96 text-center",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "text-2xl font-bold mb-6",
                    children: "Login bem-sucedido"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "mb-4",
                    children: "J\xe1 se encontra autenticado."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex gap-4",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48783e82a8986d7$exports.Button), {
                            color: "primary",
                            className: "flex-1",
                            style: {
                                width: "50%"
                            },
                            onClick: ()=>navigate(location.state?.from ?? "/", {
                                    replace: true
                                }),
                            children: "Ir para a aplica\xe7\xe3o."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48783e82a8986d7$exports.Button), {
                            color: "danger",
                            className: "flex-1",
                            style: {
                                width: "50%"
                            },
                            onClick: ()=>{
                                // @ts-ignore
                                (0, $bac44633733ff026$export$2e2bcd8739ae039).clearToken();
                                setProfile(null);
                                setError(null);
                                setErrorTitle(null);
                            },
                            children: "Sair"
                        })
                    ]
                })
            ]
        })
    });
    if (errorTitle) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex items-center justify-center min-h-screen bg-gray-100",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "bg-white p-8 rounded shadow-md w-96 text-center",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "text-2xl text-red-500 font-bold mb-6",
                    children: errorTitle
                }),
                error ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "text-red-500 mb-4",
                    children: error
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "mb-4",
                    children: "You must be logged in to access this page."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48783e82a8986d7$exports.Button), {
                    color: "primary",
                    fullwidth: true,
                    onClick: ()=>{
                        setError(null);
                        setErrorTitle(null);
                    },
                    children: "Voltar ao Login"
                })
            ]
        })
    });
    if (stage === "mfa") return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex items-center justify-center min-h-screen bg-gray-100",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
            onSubmit: handleVerifyMfa,
            className: "bg-white p-8 rounded shadow-md w-96",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "text-2xl font-bold mb-2 text-center",
                    children: "Verifica\xe7\xe3o em dois passos"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "text-sm text-gray-600 mb-6 text-center",
                    children: "Introduza o c\xf3digo de 6 d\xedgitos da sua aplica\xe7\xe3o de autentica\xe7\xe3o."
                }),
                error && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "text-red-500 mb-4",
                    children: error
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "control mb-6",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        type: "text",
                        inputMode: "numeric",
                        autoComplete: "one-time-code",
                        placeholder: "C\xf3digo de 6 d\xedgitos",
                        autoFocus: true,
                        maxLength: 6,
                        value: code,
                        onChange: (e)=>setCode(e.target.value.replace(/\D/g, "")),
                        onKeyDown: (e)=>{
                            if (e.key === "Enter" && !e.shiftKey && code.length === 6) handleVerifyMfa(e);
                        },
                        required: true,
                        className: "input text-center tracking-widest"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                    className: "flex items-center gap-2 mb-4 text-sm text-gray-600 cursor-pointer select-none",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                            type: "checkbox",
                            checked: trustDevice,
                            onChange: (e)=>setTrustDevice(e.target.checked),
                            className: "rounded"
                        }),
                        "Confiar neste dispositivo por 1 dia"
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c48783e82a8986d7$exports.Button), {
                    submit: true,
                    type: "submit",
                    color: "primary",
                    fullwidth: true,
                    disabled: loading || code.length !== 6,
                    onClick: handleVerifyMfa,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f0cdbf97a5c8afc2$export$2e2bcd8739ae039), {
                            className: "w-4 h-4 mr-2"
                        }),
                        loading ? "A verificar\u2026" : "Verificar"
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "text-center mt-4",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        type: "button",
                        onClick: ()=>handleResendOtp("challenge_token", challengeToken),
                        disabled: resendCooldown > 0,
                        className: "text-sm underline text-gray-500 hover:text-gray-700",
                        children: resendCooldown > 0 ? `Reenviar c\xf3digo por email (${resendCooldown}s)` : "N\xe3o tem acesso? Enviar c\xf3digo por email"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "text-center mt-3",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        type: "button",
                        onClick: ()=>{
                            setStage("credentials");
                            setError(null);
                        },
                        className: "text-sm underline text-gray-400 hover:text-gray-600",
                        children: "\u2190 Voltar ao login"
                    })
                })
            ]
        })
    });
    if (stage === "enroll" && enroll) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex items-center justify-center min-h-screen bg-gray-100",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
            onSubmit: handleConfirmEnroll,
            className: "bg-white p-8 rounded shadow-md w-96",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "text-2xl font-bold mb-2 text-center",
                    children: "Ativar verifica\xe7\xe3o em dois passos"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "text-sm text-gray-600 mb-4 text-center",
                    children: "A sua conta requer verifica\xe7\xe3o em dois passos. Digitalize o c\xf3digo QR abaixo com a sua aplica\xe7\xe3o de autentica\xe7\xe3o (ex.: Google Authenticator, 1Password) ou introduza a chave manualmente."
                }),
                error && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "text-red-500 mb-4",
                    children: error
                }),
                enroll.otpauthUri && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "flex justify-center mb-4",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "bg-white p-3 rounded border border-gray-200",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8b78587e05097331$export$10307208e61210e9), {
                            value: enroll.otpauthUri,
                            size: 160,
                            level: "M"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mb-4",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                            className: "block text-sm font-medium text-gray-700 mb-1",
                            children: "Chave secreta"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex gap-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("code", {
                                    className: "flex-1 p-2 bg-gray-100 rounded text-xs break-all",
                                    children: enroll.secret
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    type: "button",
                                    onClick: copySecret,
                                    className: "text-sm underline text-gray-500 hover:text-gray-700",
                                    children: "Copiar"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                            href: enroll.otpauthUri,
                            className: "text-xs underline text-gray-400 hover:text-gray-600 mt-1 inline-block",
                            children: "Abrir diretamente na aplica\xe7\xe3o"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "control mb-6",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        type: "text",
                        inputMode: "numeric",
                        placeholder: "C\xf3digo de confirma\xe7\xe3o",
                        autoFocus: true,
                        maxLength: 6,
                        value: code,
                        onChange: (e)=>setCode(e.target.value.replace(/\D/g, "")),
                        onKeyDown: (e)=>{
                            if (e.key === "Enter" && !e.shiftKey && code.length === 6) handleConfirmEnroll(e);
                        },
                        required: true,
                        className: "input text-center tracking-widest"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48783e82a8986d7$exports.Button), {
                    submit: true,
                    type: "submit",
                    color: "primary",
                    fullwidth: true,
                    disabled: loading || code.length !== 6,
                    onClick: handleConfirmEnroll,
                    children: loading ? "A confirmar\u2026" : "Confirmar e entrar"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "text-center mt-4",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        type: "button",
                        onClick: ()=>handleResendOtp("enroll_token", enroll.enrollToken),
                        disabled: resendCooldown > 0,
                        className: "text-sm underline text-gray-500 hover:text-gray-700",
                        children: resendCooldown > 0 ? `Reenviar c\xf3digo por email (${resendCooldown}s)` : "N\xe3o tem acesso \xe0 app? Enviar c\xf3digo por email"
                    })
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex items-center justify-center min-h-screen bg-gray-100",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
            onSubmit: handleCredentials,
            className: "bg-white p-8 rounded shadow-md w-96",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "text-2xl font-bold mb-6 text-center",
                    children: "Login"
                }),
                error && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "text-red-500 mb-4",
                    children: error
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "control mb-4",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        type: "text",
                        placeholder: "Username",
                        autoFocus: true,
                        onChange: (e)=>{
                            setLoginRequest({
                                ...loginRequest,
                                username: e.target.value
                            });
                        },
                        value: loginRequest.username,
                        onKeyDown: (e)=>{
                            if (e.key === "Enter" && !e.shiftKey && loginRequest.username && loginRequest.password) handleCredentials(e);
                        },
                        required: true,
                        className: "input"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "control mb-6",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        type: "password",
                        placeholder: "Password",
                        onChange: (e)=>{
                            setLoginRequest({
                                ...loginRequest,
                                password: e.target.value
                            });
                        },
                        value: loginRequest.password,
                        onKeyDown: (e)=>{
                            if (e.key === "Enter" && !e.shiftKey && loginRequest.username && loginRequest.password) handleCredentials(e);
                        },
                        required: true,
                        className: "input"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c48783e82a8986d7$exports.Button), {
                    submit: true,
                    type: "submit",
                    color: "primary",
                    fullwidth: true,
                    disabled: loading,
                    onClick: handleCredentials,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c9173589173e62cb$export$2e2bcd8739ae039), {
                            className: "w-4 h-4 mr-2"
                        }),
                        loading ? "A entrar\u2026" : "Login"
                    ]
                })
            ]
        })
    });
};
var $426e52f8305c025b$export$2e2bcd8739ae039 = $426e52f8305c025b$var$LoginPage;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $d41f89c0dd165c13$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3",
            key: "1u773s"
        }
    ],
    [
        "path",
        {
            d: "M12 17h.01",
            key: "p32p05"
        }
    ]
];
const $d41f89c0dd165c13$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("circle-help", $d41f89c0dd165c13$export$3efd853dbb351e94);




var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $99bb9698a2277115$var$ActionButtonsSettings = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "field is-grouped",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "control",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    className: "button is-primary",
                    type: "submit",
                    children: "Guardar Altera\xe7\xf5es"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "control",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    className: "button is-light",
                    type: "reset",
                    children: "Cancelar"
                })
            })
        ]
    });
};
var $99bb9698a2277115$export$2e2bcd8739ae039 = $99bb9698a2277115$var$ActionButtonsSettings;



const $6c12e11027ddf4fe$var$OfferSettings = ()=>{
    const { userSettings: userSettings, setUserSettings: setUserSettings, systemError: systemError, setSystemError: setSystemError, loading: loading, setLoading: setLoading, error: error, setError: setError, success: success, setSuccess: setSuccess, modalScreen: modalScreen, setModalScreen: setModalScreen, page: page, setPage: setPage } = (0, $a55f2a94cd420149$export$c50e37a2f0a2b064)();
    const { saveProfile: saveProfile } = (0, $b622ef53e38024e7$export$1d39dc5b47e56ff0)();
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setError(null);
        try {
            const updatedSettings = userSettings;
            if (!updatedSettings) {
                console.error("User settings not loaded");
                return;
            }
            console.log("Updated user settings:", updatedSettings);
            // Assuming you have an API endpoint to update the settings
            const returnUpdatedSettings = await saveProfile(updatedSettings);
            setUserSettings(returnUpdatedSettings);
            setSuccess("Configura\xe7\xf5es atualizadas com sucesso!");
        } catch (error) {
            console.warn("Error updating settings:", error);
            setError("Failed to update settings. Please try again later.");
        } finally{
            setLoading(null);
        }
    };
    if (!userSettings) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: "Loading..."
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
        onSubmit: handleSubmit,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "box",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("fieldset", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("legend", {
                            className: "title is-4",
                            children: "Mensagem Personalizada"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "field is-horizontal",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "field-label is-normal",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                        className: "label",
                                        children: [
                                            "Sauda\xe7\xe3o Inicial",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "has-tooltip-right has-tooltip-arrow",
                                                "data-tooltip": "Mensagem que aparece no in\xedcio da proposta",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d41f89c0dd165c13$export$2e2bcd8739ae039), {
                                                    className: "ml-1 has-text-info",
                                                    size: 16
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "field-body",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "field",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "control",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                    className: "textarea",
                                                    name: "offerCustomGreeting",
                                                    placeholder: "Ex: Prezado cliente, agradecemos o seu interesse...",
                                                    rows: 3,
                                                    defaultValue: userSettings?.offerSettings?.offerCustomGreeting || "",
                                                    onChange: (e)=>{
                                                        const updatedSettings = {
                                                            ...userSettings,
                                                            offerSettings: {
                                                                ...userSettings?.offerSettings,
                                                                offerCustomGreeting: e.target.value
                                                            },
                                                            profile: userSettings?.profile || {}
                                                        };
                                                        setUserSettings(updatedSettings);
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "control mt-2",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                    className: "checkbox",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            type: "checkbox",
                                                            name: "offerCustomGreetingEnabled",
                                                            style: {
                                                                marginRight: "8px"
                                                            },
                                                            defaultChecked: userSettings?.offerSettings?.offerCustomGreetingEnabled || false,
                                                            onChange: (e)=>{
                                                                const updatedSettings = {
                                                                    ...userSettings,
                                                                    offerSettings: {
                                                                        ...userSettings?.offerSettings,
                                                                        offerCustomGreetingEnabled: e.target.checked
                                                                    },
                                                                    profile: userSettings?.profile || {}
                                                                };
                                                                setUserSettings(updatedSettings);
                                                            }
                                                        }),
                                                        "Ativar sauda\xe7\xe3o personalizada"
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "field is-horizontal",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "field-label is-normal",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                        className: "label",
                                        children: [
                                            "Mensagem de Fecho",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "has-tooltip-right has-tooltip-arrow",
                                                "data-tooltip": "Mensagem que aparece no final da proposta",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d41f89c0dd165c13$export$2e2bcd8739ae039), {
                                                    className: "ml-1 has-text-info",
                                                    size: 16
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "field-body",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "field",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "control",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                    className: "textarea",
                                                    name: "offerCustomSignature",
                                                    placeholder: "Ex: Dispon\xedveis para esclarecimentos adicionais...",
                                                    rows: 3,
                                                    defaultValue: userSettings?.offerSettings?.offerCustomSignature || "",
                                                    onChange: (e)=>{
                                                        const updatedSettings = {
                                                            ...userSettings,
                                                            offerSettings: {
                                                                ...userSettings?.offerSettings,
                                                                offerCustomSignature: e.target.value
                                                            },
                                                            profile: userSettings?.profile || {}
                                                        };
                                                        setUserSettings(updatedSettings);
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "control mt-2",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                    className: "checkbox",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            type: "checkbox",
                                                            name: "offerCustomSignatureEnabled",
                                                            style: {
                                                                marginRight: "8px"
                                                            },
                                                            defaultChecked: userSettings?.offerSettings?.offerCustomSignatureEnabled || false,
                                                            onChange: (e)=>{
                                                                const updatedSettings = {
                                                                    ...userSettings,
                                                                    offerSettings: {
                                                                        ...userSettings?.offerSettings,
                                                                        offerCustomSignatureEnabled: e.target.checked
                                                                    },
                                                                    profile: userSettings?.profile || {}
                                                                };
                                                                setUserSettings(updatedSettings);
                                                            }
                                                        }),
                                                        "Ativar mensagem de fecho personalizada"
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "box",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("fieldset", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("legend", {
                            className: "title is-4",
                            children: "Dados da Empresa"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "field is-horizontal",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "field-label is-normal",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                        className: "label",
                                        children: "Nome da Empresa"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "field-body",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "field",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "control",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                className: "input",
                                                type: "text",
                                                name: "offerCompanyName",
                                                placeholder: "Nome oficial da empresa",
                                                defaultValue: userSettings?.offerSettings?.offerCompanyName || "",
                                                onChange: (e)=>{
                                                    const updatedSettings = {
                                                        ...userSettings,
                                                        offerSettings: {
                                                            ...userSettings?.offerSettings,
                                                            offerCompanyName: e.target.value
                                                        },
                                                        profile: userSettings?.profile || {}
                                                    };
                                                    setUserSettings(updatedSettings);
                                                }
                                            })
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "field is-horizontal",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "field-label is-normal",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                        className: "label",
                                        children: "Morada"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "field-body",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "field",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "control",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                className: "textarea",
                                                name: "offerCompanyAddress",
                                                placeholder: "Rua, n\xba, andar",
                                                rows: 3,
                                                defaultValue: userSettings?.offerSettings?.offerCompanyAddress || "",
                                                onChange: (e)=>{
                                                    const updatedSettings = {
                                                        ...userSettings,
                                                        offerSettings: {
                                                            ...userSettings?.offerSettings,
                                                            offerCompanyAddress: e.target.value
                                                        },
                                                        profile: userSettings?.profile || {}
                                                    };
                                                    setUserSettings(updatedSettings);
                                                }
                                            })
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "field is-horizontal",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "field-label is-normal",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                        className: "label",
                                        children: "Localidade e C\xf3digo"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "field-body",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "field is-grouped",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "control",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    className: "input",
                                                    type: "text",
                                                    name: "offerCompanyZipCode",
                                                    placeholder: "C\xf3digo Postal",
                                                    defaultValue: userSettings?.offerSettings?.offerCompanyZipCode || "",
                                                    onChange: (e)=>{
                                                        const updatedSettings = {
                                                            ...userSettings,
                                                            offerSettings: {
                                                                ...userSettings?.offerSettings,
                                                                offerCompanyZipCode: e.target.value
                                                            },
                                                            profile: userSettings?.profile || {}
                                                        };
                                                        setUserSettings(updatedSettings);
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "control is-expanded",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    className: "input",
                                                    type: "text",
                                                    name: "offerCompanyLocation",
                                                    placeholder: "Localidade",
                                                    defaultValue: userSettings?.offerSettings?.offerCompanyLocation || "",
                                                    onChange: (e)=>{
                                                        const updatedSettings = {
                                                            ...userSettings,
                                                            offerSettings: {
                                                                ...userSettings?.offerSettings,
                                                                offerCompanyLocation: e.target.value
                                                            },
                                                            profile: userSettings?.profile || {}
                                                        };
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "field is-horizontal",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "field-label is-normal",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                        className: "label",
                                        children: "Telefones"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "field-body",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "field is-grouped",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "control is-expanded",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    className: "input",
                                                    type: "text",
                                                    name: "offerCompanyPhone",
                                                    placeholder: "Telefone fixo",
                                                    defaultValue: userSettings?.offerSettings?.offerCompanyPhone || "",
                                                    onChange: (e)=>{
                                                        const updatedSettings = {
                                                            ...userSettings,
                                                            offerSettings: {
                                                                ...userSettings?.offerSettings,
                                                                offerCompanyPhone: e.target.value
                                                            },
                                                            profile: userSettings?.profile || {}
                                                        };
                                                        setUserSettings(updatedSettings);
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "control is-expanded",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    className: "input",
                                                    type: "text",
                                                    name: "offerCompanyMobile",
                                                    placeholder: "Telem\xf3vel",
                                                    defaultValue: userSettings?.offerSettings?.offerCompanyMobile || "",
                                                    onChange: (e)=>{
                                                        const updatedSettings = {
                                                            ...userSettings,
                                                            offerSettings: {
                                                                ...userSettings?.offerSettings,
                                                                offerCompanyMobile: e.target.value
                                                            },
                                                            profile: userSettings?.profile || {}
                                                        };
                                                        setUserSettings(updatedSettings);
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "control is-expanded",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    className: "input",
                                                    type: "text",
                                                    name: "offerCompanyFax",
                                                    placeholder: "Fax",
                                                    defaultValue: userSettings?.offerSettings?.offerCompanyFax || "",
                                                    onChange: (e)=>{
                                                        const updatedSettings = {
                                                            ...userSettings,
                                                            offerSettings: {
                                                                ...userSettings?.offerSettings,
                                                                offerCompanyFax: e.target.value
                                                            },
                                                            profile: userSettings?.profile || {}
                                                        };
                                                        setUserSettings(updatedSettings);
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "field is-horizontal",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "field-label is-normal",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                        className: "label",
                                        children: "Contactos Online"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "field-body",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "field is-grouped",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "control is-expanded",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    className: "input",
                                                    type: "email",
                                                    name: "offerCompanyEmail",
                                                    placeholder: "Email de contacto",
                                                    defaultValue: userSettings?.offerSettings?.offerCompanyEmail || "",
                                                    onChange: (e)=>{
                                                        const updatedSettings = {
                                                            ...userSettings,
                                                            offerSettings: {
                                                                ...userSettings?.offerSettings,
                                                                offerCompanyEmail: e.target.value
                                                            },
                                                            profile: userSettings?.profile || {}
                                                        };
                                                        setUserSettings(updatedSettings);
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "control is-expanded",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    className: "input",
                                                    type: "text",
                                                    name: "offerCompanyWebsite",
                                                    placeholder: "Website",
                                                    defaultValue: userSettings?.offerSettings?.offerCompanyWebsite || "",
                                                    onChange: (e)=>{
                                                        const updatedSettings = {
                                                            ...userSettings,
                                                            offerSettings: {
                                                                ...userSettings?.offerSettings,
                                                                offerCompanyWebsite: e.target.value
                                                            },
                                                            profile: userSettings?.profile || {}
                                                        };
                                                        setUserSettings(updatedSettings);
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $99bb9698a2277115$export$2e2bcd8739ae039), {})
        ]
    });
};
var $6c12e11027ddf4fe$export$2e2bcd8739ae039 = $6c12e11027ddf4fe$var$OfferSettings;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");



const $e29637da4a282b94$var$NotificationsSettings = ()=>{
    const { userSettings: userSettings, setUserSettings: setUserSettings, systemError: systemError, setSystemError: setSystemError, loading: loading, setLoading: setLoading, error: error, setError: setError, success: success, setSuccess: setSuccess, modalScreen: modalScreen, setModalScreen: setModalScreen, page: page, setPage: setPage } = (0, $a55f2a94cd420149$export$c50e37a2f0a2b064)();
    const { saveProfile: saveProfile } = (0, $b622ef53e38024e7$export$1d39dc5b47e56ff0)();
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setError(null);
        try {
            const updatedSettings = userSettings;
            if (!updatedSettings) {
                console.error("User settings not loaded");
                return;
            }
            console.log("Updated user settings:", updatedSettings);
            // Assuming you have an API endpoint to update the settings
            const returnUpdatedSettings = await saveProfile(updatedSettings);
            setUserSettings(returnUpdatedSettings);
            setSuccess("Configura\xe7\xf5es atualizadas com sucesso!");
        } catch (error) {
            console.warn("Error updating settings:", error);
            setError("Failed to update settings. Please try again later.");
        } finally{
            setLoading(null);
        }
    };
    if (!userSettings) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: "Loading..."
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
        onSubmit: handleSubmit,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "box",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("fieldset", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("legend", {
                            className: "title is-4",
                            children: "Notifica\xe7\xf5es sobre computadores"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "form-group",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "control",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        type: "checkbox",
                                        id: "new-compounds",
                                        name: "email-notifications",
                                        className: "checkbox",
                                        checked: userSettings?.notificationsSettings?.added_compounds_enabled ?? false,
                                        onChange: (e)=>{
                                            const updatedSettings = {
                                                ...userSettings,
                                                notificationsSettings: {
                                                    ...userSettings.notificationsSettings,
                                                    added_compounds_enabled: e.target.checked
                                                }
                                            };
                                            setUserSettings(updatedSettings);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                        htmlFor: "new-compounds",
                                        className: "ml-2",
                                        children: "Receber notifica\xe7\xf5es sobre novos computadores."
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "form-group",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "control",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        type: "checkbox",
                                        id: "update-compounds",
                                        name: "update-compounds",
                                        className: "checkbox",
                                        checked: userSettings?.notificationsSettings?.updated_compounds_enabled ?? false,
                                        onChange: (e)=>{
                                            const updatedSettings = {
                                                ...userSettings,
                                                notificationsSettings: {
                                                    ...userSettings.notificationsSettings,
                                                    updated_compounds_enabled: e.target.checked
                                                }
                                            };
                                            setUserSettings(updatedSettings);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                        htmlFor: "update-compounds",
                                        className: "ml-2",
                                        children: "Receber notifica\xe7\xf5es sobre actualiza\xe7\xe3o de computadores."
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "box",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("fieldset", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("legend", {
                            className: "title is-4",
                            children: "Notifica\xe7\xf5es Propostas"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "form-group",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "control",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        type: "checkbox",
                                        id: "offer-reminders",
                                        name: "offer-reminders",
                                        className: "checkbox",
                                        checked: userSettings?.notificationsSettings?.pending_offers_enabled ?? false,
                                        onChange: (e)=>{
                                            const updatedSettings = {
                                                ...userSettings,
                                                notificationsSettings: {
                                                    ...userSettings.notificationsSettings,
                                                    pending_offers_enabled: e.target.checked
                                                }
                                            };
                                            setUserSettings(updatedSettings);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                        htmlFor: "offer-reminders",
                                        className: "ml-2",
                                        children: "Receba lembretes para propostas pendentes diariamente."
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "form-group",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "control",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "checkbox",
                                            id: "offer-expiration",
                                            name: "offer-expiration",
                                            className: "checkbox",
                                            checked: userSettings?.notificationsSettings?.expiring_offers_enabled ?? false,
                                            onChange: (e)=>{
                                                const updatedSettings = {
                                                    ...userSettings,
                                                    notificationsSettings: {
                                                        ...userSettings.notificationsSettings,
                                                        expiring_offers_enabled: e.target.checked
                                                    }
                                                };
                                                setUserSettings(updatedSettings);
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            htmlFor: "offer-expiration",
                                            className: "ml-2",
                                            children: "Receba notifica\xe7\xf5es quando uma proposta estiver prestes a expirar (2 dias antes do dia de expira\xe7\xe3o)."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "form-group",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "control",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                type: "checkbox",
                                                id: "offer-notifications",
                                                name: "offer-notifications",
                                                className: "checkbox",
                                                checked: userSettings?.notificationsSettings?.new_orders_enabled ?? false,
                                                onChange: (e)=>{
                                                    const updatedSettings = {
                                                        ...userSettings,
                                                        notificationsSettings: {
                                                            ...userSettings.notificationsSettings,
                                                            new_orders_enabled: e.target.checked
                                                        }
                                                    };
                                                    setUserSettings(updatedSettings);
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                htmlFor: "offer-notifications",
                                                className: "ml-2",
                                                children: "Receba notifica\xe7\xf5es por e-mail sobre o estado das propostas (aceites/rejeitadas)."
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $99bb9698a2277115$export$2e2bcd8739ae039), {})
        ]
    });
};
var $e29637da4a282b94$export$2e2bcd8739ae039 = $e29637da4a282b94$var$NotificationsSettings;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



const $4c23f4f3b910156c$var$ProfileSettings = ()=>{
    const { userSettings: userSettings, setUserSettings: setUserSettings, systemError: systemError, setSystemError: setSystemError, loading: loading, setLoading: setLoading, error: error, setError: setError, success: success, setSuccess: setSuccess, modalScreen: modalScreen, setModalScreen: setModalScreen, page: page, setPage: setPage } = (0, $a55f2a94cd420149$export$c50e37a2f0a2b064)();
    const { saveProfile: saveProfile } = (0, $b622ef53e38024e7$export$1d39dc5b47e56ff0)();
    const [showPassword, setShowPassword] = (0, $acw62.useState)(false);
    const [password, setPassword] = (0, $acw62.useState)("");
    const [confirmPassword, setConfirmPassword] = (0, $acw62.useState)("");
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setError(null);
        setSuccess(null);
        try {
            const updatedSettings = userSettings;
            if (!updatedSettings) {
                console.warn("User settings not loaded");
                return;
            }
            if (password.trim().length > 0 && password !== confirmPassword) {
                alert("Passwords don't match");
                return;
            }
            // Update userSettings with the new password if provided
            if (password.trim().length > 0) updatedSettings.profile.password = password;
            console.log("Updated user settings:", updatedSettings);
            const returnUpdatedSettings = await saveProfile(updatedSettings);
            setUserSettings(returnUpdatedSettings);
            setPassword("");
            setConfirmPassword("");
            setSuccess("Perfil atualizado com sucesso!");
        } catch (error) {
            console.warn("Error updating profile:", error);
            setError("Failed to update profile");
        } finally{
            setLoading(null);
        }
    };
    if (!userSettings) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: "Loading..."
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
        onSubmit: handleSubmit,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "box",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("fieldset", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("legend", {
                            className: "title is-4",
                            children: "Dados Pessoais"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "field is-horizontal",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "field-label is-normal",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                        className: "label is-normal",
                                        children: "Nome"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "field-body",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "field is-grouped",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "control is-expanded",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    className: "input",
                                                    type: "text",
                                                    name: "firstName",
                                                    placeholder: "Primeiro nome",
                                                    defaultValue: userSettings?.profile.firstName || "",
                                                    required: true,
                                                    onChange: (e)=>{
                                                        if (userSettings) setUserSettings({
                                                            ...userSettings,
                                                            profile: {
                                                                ...userSettings.profile,
                                                                firstName: e.target.value
                                                            }
                                                        });
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "control is-expanded",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    className: "input",
                                                    type: "text",
                                                    name: "lastName",
                                                    placeholder: "Apelido",
                                                    defaultValue: userSettings?.profile.lastName || "",
                                                    onChange: (e)=>{
                                                        if (userSettings) setUserSettings({
                                                            ...userSettings,
                                                            profile: {
                                                                ...userSettings.profile,
                                                                lastName: e.target.value
                                                            }
                                                        });
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "field is-horizontal",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "field-label is-normal",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                        className: "label is-normal",
                                        children: "Email"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "field-body",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "field is-grouped",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "control is-expanded",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    className: "input",
                                                    type: "email",
                                                    name: "email",
                                                    required: true,
                                                    placeholder: "seu.email@exemplo.com",
                                                    defaultValue: userSettings?.profile.email || "",
                                                    onChange: (e)=>{
                                                        if (userSettings) setUserSettings({
                                                            ...userSettings,
                                                            profile: {
                                                                ...userSettings.profile,
                                                                email: e.target.value
                                                            }
                                                        });
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "field-label is-normal",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "label",
                                                    children: "Telefone"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "control is-expanded",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    className: "input",
                                                    type: "tel",
                                                    name: "phone",
                                                    placeholder: "123-456-7890",
                                                    defaultValue: userSettings?.profile.phoneNumber || "",
                                                    onChange: (e)=>{
                                                        if (userSettings) setUserSettings({
                                                            ...userSettings,
                                                            profile: {
                                                                ...userSettings.profile,
                                                                phoneNumber: e.target.value
                                                            }
                                                        });
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "field is-horizontal",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "field-label is-normal",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                        className: "label is-normal",
                                        children: "Palavra-passe"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "field-body",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "field is-grouped",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "control",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "field has-addons",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "control is-expanded",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                className: "input",
                                                                type: showPassword ? "text" : "password",
                                                                name: "password",
                                                                placeholder: "Palavra-passe",
                                                                defaultValue: password || "",
                                                                onChange: (e)=>setPassword(e.target.value)
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "control",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                type: "button",
                                                                className: "button",
                                                                onClick: ()=>setShowPassword(!showPassword),
                                                                children: showPassword ? "Ocultar" : "Mostrar"
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "field-label is-normal",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "label",
                                                    children: "Confirmar Palavra-passe"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "control",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "field has-addons",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "control is-expanded",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                className: "input",
                                                                type: showPassword ? "text" : "password",
                                                                name: "password",
                                                                placeholder: "Palavra-passe",
                                                                value: confirmPassword,
                                                                onChange: (e)=>setConfirmPassword(e.target.value)
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "control",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                type: "button",
                                                                className: "button",
                                                                onClick: ()=>setShowPassword(!showPassword),
                                                                children: showPassword ? "Ocultar" : "Mostrar"
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $99bb9698a2277115$export$2e2bcd8739ae039), {})
        ]
    });
};
var $4c23f4f3b910156c$export$2e2bcd8739ae039 = $4c23f4f3b910156c$var$ProfileSettings;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


const $3678a935ea45578e$var$EmailSettingsSection = ({ smtpSettings: smtpSettings, setSmtpSettings: setSmtpSettings, smtpSettingsChanged: smtpSettingsChanged, successTest: successTest, setSuccessTest: setSuccessTest })=>{
    const handleTestSmtp = (event)=>{
        event.preventDefault();
        if (!smtpSettings) {
            alert("Por favor, configure as op\xe7\xf5es de SMTP antes de testar.");
            return;
        }
        if (!smtpSettings.from_email || !smtpSettings.from_name || smtpSettings.from_email.trim() === "" || smtpSettings.from_name.trim() === "") {
            alert("Por favor, preencha o endere\xe7o e nome do remetente.");
            return;
        }
        if (!smtpSettings.use_custom_email) {
            alert("Para testar a configura\xe7\xe3o de SMTP, ative a op\xe7\xe3o 'Ativar Email Personalizado'.");
            return;
        }
        if (!smtpSettings.smtp_host || !smtpSettings.smtp_port || smtpSettings.smtp_authentication && (!smtpSettings.smtp_username || !smtpSettings.smtp_password)) {
            alert("Por favor, preencha todos os campos obrigat\xf3rios de SMTP.");
            return;
        }
        const button = event.currentTarget;
        button.disabled = true; // Desabilita o botão para evitar múltiplos cliques
        button.classList.add("is-loading"); // Adiciona a classe de loading
        const response = (0, $bac44633733ff026$export$2e2bcd8739ae039).post((0, $cd93687958c8007e$export$bfe19bc25132bb7c).SETTINGS + "/_action/smtp-test", smtpSettings);
        response.then((res)=>{
            if (res.data) {
                alert("Configura\xe7\xe3o de SMTP testada com sucesso!");
                setSuccessTest(true);
            } else {
                alert("Erro ao testar configura\xe7\xe3o de SMTP: " + res.data.message);
                setSuccessTest(false);
            }
        }).catch((error)=>{
            console.warn("Erro ao testar configura\xe7\xe3o de SMTP:", error);
            alert("Erro ao testar configura\xe7\xe3o de SMTP. Verifique o console para mais detalhes.");
            setSuccessTest(false);
        }).finally(()=>{
            button.disabled = false; // Reabilita o botão
            button.classList.remove("is-loading"); // Remove a classe de loading
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("fieldset", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("legend", {
                className: "title is-4",
                children: "Configura\xe7\xf5es de Email"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "field",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    className: "tip text-xs has-text-grey",
                    children: [
                        "O email ser\xe1 enviado atrav\xe9s do email padr\xe3o do sistema, no entanto, voc\xea pode personalizar o endere\xe7o de resposta aos emails enviados pelo sistema aos seus clientes.",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        'Se voc\xea quiser personalizar o remetente, ative a op\xe7\xe3o "Ativar Email Personalizado" e preencha os campos necess\xe1rios para configurar o seu servidor SMTP.'
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "field is-horizontal",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "field-label is-normal is-flex-grow-4",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                            className: "label",
                            children: "Ativar Email Personalizado"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "field-body",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "field is-grouped",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "control",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                        className: "radio",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                type: "radio",
                                                name: "useCustomSmtp",
                                                checked: smtpSettings?.use_custom_email === true,
                                                onChange: ()=>{
                                                    setSmtpSettings({
                                                        ...smtpSettings,
                                                        use_custom_email: true
                                                    });
                                                }
                                            }),
                                            "\xa0Sim"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                        className: "radio ml-4",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                type: "radio",
                                                name: "useCustomSmtp",
                                                checked: smtpSettings?.use_custom_email === false,
                                                onChange: ()=>{
                                                    setSmtpSettings({
                                                        ...smtpSettings,
                                                        use_custom_email: false
                                                    });
                                                }
                                            }),
                                            "\xa0N\xe3o"
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            smtpSettings?.use_custom_email ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "field is-horizontal",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "field-label is-normal is-flex-grow-4",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    className: "label",
                                    children: "Endere\xe7o do Remetente"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "field-body",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "field",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "control",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            className: `input ${smtpSettingsChanged && (smtpSettings.from_email?.trim() ?? "") === "" ? "is-danger" : ""}`,
                                            type: "email",
                                            name: "fromEmail",
                                            value: smtpSettings?.from_email || "",
                                            onChange: (e)=>setSmtpSettings({
                                                    ...smtpSettings,
                                                    from_email: e.target.value
                                                })
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "field is-horizontal",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "field-label is-normal is-flex-grow-4",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    className: "label",
                                    children: "Nome do Remetente"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "field-body",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "field",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "control",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            className: `input ${smtpSettingsChanged && (smtpSettings.from_name?.trim() ?? "") === "" ? "is-danger" : ""}`,
                                            type: "text",
                                            name: "fromName",
                                            value: smtpSettings?.from_name || "",
                                            onChange: (e)=>setSmtpSettings({
                                                    ...smtpSettings,
                                                    from_name: e.target.value
                                                })
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "field is-horizontal",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "field-label is-normal is-flex-grow-4",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    className: "label",
                                    children: "SMTP Endere\xe7o"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "field-body",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "field is-grouped",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "control is-expanded",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                className: `input ${smtpSettingsChanged && smtpSettings.use_custom_email && (smtpSettings.smtp_host?.trim() ?? "") === "" ? "is-danger" : ""}`,
                                                type: "text",
                                                name: "smtpHost",
                                                placeholder: "smtp.gmail.com",
                                                value: smtpSettings?.smtp_host || "",
                                                onChange: (e)=>setSmtpSettings({
                                                        ...smtpSettings,
                                                        smtp_host: e.target.value
                                                    })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "field-label is-normal",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                className: "label",
                                                children: "SMTP Porta"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "control w-24",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                className: `input ${smtpSettingsChanged && smtpSettings.use_custom_email && !smtpSettings.smtp_port ? "is-danger" : ""}`,
                                                type: "number",
                                                name: "smtpPort",
                                                placeholder: "587",
                                                value: smtpSettings?.smtp_port || "",
                                                onChange: (e)=>setSmtpSettings({
                                                        ...smtpSettings,
                                                        smtp_port: e.target.value ? Number(e.target.value) : null
                                                    })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "field is-horizontal",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "field-label is-normal is-flex-grow-4",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    className: "label",
                                    children: "Autentica\xe7\xe3o SMTP"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "field-body",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "field is-grouped",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "control",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                className: "radio",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "radio",
                                                        name: "smtpAuthentication",
                                                        checked: smtpSettings?.smtp_authentication === true,
                                                        onChange: ()=>{
                                                            setSmtpSettings({
                                                                ...smtpSettings,
                                                                smtp_authentication: true
                                                            });
                                                        }
                                                    }),
                                                    "\xa0Sim"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "control ml-4",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                className: "radio",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "radio",
                                                        name: "smtpNoAuthentication",
                                                        checked: smtpSettings?.smtp_authentication === false,
                                                        onChange: ()=>{
                                                            setSmtpSettings({
                                                                ...smtpSettings,
                                                                smtp_authentication: false
                                                            });
                                                        }
                                                    }),
                                                    "\xa0N\xe3o"
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "field is-horizontal",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "field-label is-normal is-flex-grow-4",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    className: "label",
                                    children: "Utilizador"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "field-body",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "field is-grouped",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "control is-expanded",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                className: `input ${smtpSettingsChanged && smtpSettings.smtp_authentication && (smtpSettings.smtp_username?.trim() ?? "") === "" ? "is-danger" : ""}`,
                                                type: "text",
                                                name: "smtpUsername",
                                                placeholder: "xxxxx@gmail.com",
                                                disabled: smtpSettings?.smtp_authentication === false,
                                                value: smtpSettings?.smtp_username || "",
                                                onChange: (e)=>setSmtpSettings({
                                                        ...smtpSettings,
                                                        smtp_username: e.target.value
                                                    })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "field-label is-normal",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                className: "label",
                                                children: "Chave"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "control is-expanded",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                className: `input ${smtpSettingsChanged && smtpSettings.smtp_authentication && (smtpSettings.smtp_password?.trim() ?? "") === "" ? "is-danger" : ""}`,
                                                type: "password",
                                                name: "smtpPassword",
                                                disabled: smtpSettings?.smtp_authentication === false,
                                                value: smtpSettings?.smtp_password || "",
                                                onChange: (e)=>setSmtpSettings({
                                                        ...smtpSettings,
                                                        smtp_password: e.target.value
                                                    })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "field is-horizontal",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "field-label is-normal is-flex-grow-4",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    className: "label",
                                    children: "Seguran\xe7a"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "field-body",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "field is-grouped",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "control",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                className: "radio",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "radio",
                                                        name: "smtpSecureTls",
                                                        checked: smtpSettings?.smtp_secure_tls === true,
                                                        onChange: ()=>{
                                                            setSmtpSettings({
                                                                ...smtpSettings,
                                                                smtp_secure_tls: true
                                                            });
                                                        }
                                                    }),
                                                    "\xa0TLS"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "control ml-4",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                className: "radio",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "radio",
                                                        name: "smtpSecureSsl",
                                                        checked: smtpSettings?.smtp_secure_ssl === true,
                                                        onChange: ()=>{
                                                            setSmtpSettings({
                                                                ...smtpSettings,
                                                                smtp_secure_ssl: true
                                                            });
                                                        }
                                                    }),
                                                    "\xa0SSL"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "control ml-4",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                className: "radio",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "radio",
                                                        name: "smtpNoSecurity",
                                                        checked: smtpSettings?.smtp_secure_tls === false && smtpSettings?.smtp_secure_ssl === false,
                                                        onChange: ()=>{
                                                            setSmtpSettings({
                                                                ...smtpSettings,
                                                                smtp_secure_tls: false,
                                                                smtp_secure_ssl: false
                                                            });
                                                        }
                                                    }),
                                                    "\xa0Nenhum"
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "field is-horizontal",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "field-label is-normal is-flex-grow-4"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "field-body",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "field is-grouped",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "control",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                className: "button is-primary",
                                                onClick: (event)=>{
                                                    handleTestSmtp(event);
                                                    event.preventDefault();
                                                },
                                                children: "Testar Configura\xe7\xe3o"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "control",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                className: "button is-light",
                                                onClick: (e)=>{
                                                    e.preventDefault();
                                                    if (!window.confirm("Tem a certeza que deseja limpar as configura\xe7\xf5es de SMTP?")) return;
                                                    setSmtpSettings({
                                                        ...smtpSettings,
                                                        use_custom_email: true,
                                                        from_email: null,
                                                        from_name: null,
                                                        smtp_host: null,
                                                        smtp_port: null,
                                                        smtp_authentication: false,
                                                        smtp_username: null,
                                                        smtp_password: null,
                                                        smtp_secure_tls: false,
                                                        smtp_secure_ssl: false
                                                    });
                                                },
                                                children: "Limpar Configura\xe7\xe3o"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "control",
                                            children: successTest !== null && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: `tag ${successTest ? "is-success" : "is-danger"}`,
                                                children: successTest ? "Teste bem-sucedido!" : "Teste falhou!"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "field is-horizontal",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "field-label is-normal is-flex-grow-4",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    className: "label",
                                    children: "Email de Resposta"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "field-body",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "field",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "control",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            className: `input ${smtpSettingsChanged && smtpSettings?.reply_to_email?.trim() === "" ? "is-danger" : ""}`,
                                            type: "email",
                                            name: "replyEmail",
                                            placeholder: "xxxx@gmail.com",
                                            value: smtpSettings?.reply_to_email || "",
                                            onChange: (e)=>setSmtpSettings({
                                                    ...smtpSettings,
                                                    reply_to_email: e.target.value
                                                })
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "field is-horizontal",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "field-label is-normal is-flex-grow-4",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    className: "label",
                                    children: "Nome do Endere\xe7o de Resposta"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "field-body",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "field",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "control",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            className: `input ${smtpSettingsChanged && smtpSettings?.reply_to_name?.trim() === "" ? "is-danger" : ""}`,
                                            type: "text",
                                            name: "replyName",
                                            placeholder: "O meu Nome",
                                            value: smtpSettings?.reply_to_name || "",
                                            onChange: (e)=>setSmtpSettings({
                                                    ...smtpSettings,
                                                    reply_to_name: e.target.value
                                                })
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $3678a935ea45578e$export$2e2bcd8739ae039 = $3678a935ea45578e$var$EmailSettingsSection;



const $16026b95f91bd2a3$var$GlobalSettings = ()=>{
    const { userSettings: userSettings, setUserSettings: setUserSettings, systemError: systemError, setSystemError: setSystemError, loading: loading, setLoading: setLoading, error: error, setError: setError, success: success, setSuccess: setSuccess, modalScreen: modalScreen, setModalScreen: setModalScreen, page: page, setPage: setPage } = (0, $a55f2a94cd420149$export$c50e37a2f0a2b064)();
    const { saveProfile: saveProfile } = (0, $b622ef53e38024e7$export$1d39dc5b47e56ff0)();
    const [internalUserSettings, setInternalUserSettings] = (0, $acw62.useState)(userSettings || {
        generalSettings: {},
        profile: {}
    });
    const [file, setFile] = (0, $acw62.useState)(null);
    const setInternalSettings = (settings)=>{
        setInternalUserSettings(settings);
        setUserSettings(settings);
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (!userSettings) {
            setError("Por favor, carregue as configura\xe7\xf5es do utilizador.");
            return;
        }
        const smtpConfig = userSettings.generalSettings?.smtp_configuration;
        if (userSettings.generalSettings?.smtp_settings_changed) {
            if (!smtpConfig) {
                setError("Por favor, configure as defini\xe7\xf5es de SMTP antes de guardar.");
                return;
            }
            if (smtpConfig.use_custom_email && !userSettings.generalSettings?.smtp_settings_valid) {
                setError("Por favor, teste as configura\xe7\xf5es de SMTP antes de guardar.");
                return;
            }
            if (!smtpConfig.use_custom_email && !smtpConfig.reply_to_email) {
                setError("Por favor, preencha o campo 'Email de Resposta' nas configura\xe7\xf5es de SMTP.");
                return;
            }
            if (!smtpConfig.use_custom_email && !smtpConfig.reply_to_name) {
                setError("Por favor, preencha o campo 'Nome do Endere\xe7o de Resposta' nas configura\xe7\xf5es de SMTP.");
                return;
            }
        }
        setError(null);
        try {
            const updatedSettings = userSettings;
            if (!updatedSettings) {
                console.error("User settings not loaded");
                return;
            }
            console.log("Updated user settings:", updatedSettings);
            const returnUpdatedSettings = await saveProfile(updatedSettings, file);
            setUserSettings(returnUpdatedSettings);
            setSuccess("Configura\xe7\xf5es atualizadas com sucesso!");
        } catch (error) {
            console.warn("Error updating settings:", error);
            setError("Failed to update settings. Please try again later.");
        } finally{
            setLoading(null);
        }
    };
    const handleSmtpConfigurationChange = (smtpSettings)=>{
        if (!userSettings) return;
        const updatedSettings = {
            ...userSettings,
            generalSettings: {
                ...userSettings.generalSettings,
                smtp_configuration: smtpSettings,
                company_logo_location: null,
                smtp_settings_changed: true,
                smtp_settings_valid: null
            },
            profile: userSettings?.profile || {}
        };
        // @ts-ignore
        setUserSettings(updatedSettings);
    };
    const defaultUserSmtpConfiguration = (userSettings)=>{
        return {
            use_custom_email: false,
            reply_to_email: userSettings.profile?.email,
            reply_to_name: userSettings.profile.firstName + " " + userSettings.profile.lastName,
            from_email: userSettings.profile?.email,
            from_name: userSettings.profile.firstName + " " + userSettings.profile.lastName,
            smtp_authentication: true
        };
    };
    if (!userSettings) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: "Loading..."
    });
    const renderMarginThresholds = ()=>{
        const readOnly = userSettings.generalSettings?.use_default_margin ?? true;
        const thresholds = internalUserSettings?.generalSettings?.margin_thresholds || [];
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "field-body pl-5",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "control w-full",
                children: [
                    thresholds.map((threshold, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "is-flex mb-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "mr-2",
                                    children: "De"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    type: "number",
                                    className: "input mr-2",
                                    value: idx > 0 ? thresholds[idx - 1].to ?? "" : 0,
                                    style: {
                                        width: 120
                                    },
                                    disabled: true
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "mr-2",
                                    children: "at\xe9"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    type: "number",
                                    className: "input mr-2",
                                    placeholder: idx === thresholds.length - 1 ? "\u221E" : "",
                                    value: threshold.to || "",
                                    min: (threshold.from ?? 0) + 1,
                                    step: 0.01,
                                    onChange: (e)=>{
                                        const value = e.target.value === "" ? null : parseFloat(e.target.value);
                                        const updated = [
                                            ...thresholds
                                        ];
                                        updated[idx].to = (value || 0) > 0 ? value : null;
                                        if (idx < thresholds.length - 1 && value !== null) updated[idx + 1].from = value + 0.01;
                                        setInternalSettings({
                                            ...userSettings,
                                            generalSettings: {
                                                ...userSettings.generalSettings,
                                                margin_thresholds: updated,
                                                company_logo_location: null
                                            }
                                        });
                                    },
                                    style: {
                                        width: 120
                                    },
                                    disabled: readOnly || threshold.to === null && idx === thresholds.length - 1
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "mr-2",
                                    children: "aplicar"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    type: "number",
                                    className: "input mr-2",
                                    placeholder: "%",
                                    value: threshold.margin,
                                    min: 0,
                                    max: 100,
                                    step: 0.01,
                                    disabled: readOnly,
                                    onChange: (e)=>{
                                        const value = parseFloat(e.target.value);
                                        if (!isNaN(value)) {
                                            const updated = [
                                                ...thresholds
                                            ];
                                            updated[idx].margin = value;
                                            setInternalSettings({
                                                ...userSettings,
                                                generalSettings: {
                                                    ...userSettings.generalSettings,
                                                    margin_thresholds: updated,
                                                    company_logo_location: null
                                                }
                                            });
                                        }
                                    },
                                    style: {
                                        width: 80
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "mr-2",
                                    children: "%"
                                }),
                                thresholds.length > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    type: "button",
                                    className: "button is-small is-danger is-light ml-2",
                                    disabled: readOnly,
                                    onClick: ()=>{
                                        const updated = [
                                            ...thresholds
                                        ];
                                        updated.splice(idx, 1);
                                        if (updated[idx] && idx > 0) updated[idx].from = (updated[idx - 1].to || 0) + 0.01;
                                        if (idx === thresholds.length - 1 && updated[idx - 1]) updated[idx - 1].to = null;
                                        if (idx === 0 && updated[0]) updated[0].from = 0;
                                        setInternalSettings({
                                            ...userSettings,
                                            generalSettings: {
                                                ...userSettings.generalSettings,
                                                margin_thresholds: updated,
                                                company_logo_location: null
                                            }
                                        });
                                    },
                                    children: "Remover"
                                })
                            ]
                        }, idx)),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        type: "button",
                        className: "button is-small is-link mt-2",
                        disabled: readOnly,
                        onClick: ()=>{
                            const updated = [
                                ...thresholds,
                                {
                                    from: (thresholds.length || 0) > 0 ? (thresholds[(thresholds.length || 0) - 1].to ?? 0) + 0.01 : 0,
                                    to: null,
                                    margin: 0
                                }
                            ];
                            setInternalSettings({
                                ...userSettings,
                                generalSettings: {
                                    ...userSettings.generalSettings,
                                    margin_thresholds: updated,
                                    company_logo_location: null
                                }
                            });
                        },
                        children: "Adicionar Threshold"
                    })
                ]
            })
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
        onSubmit: handleSubmit,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "box",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("fieldset", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("legend", {
                            className: "title is-4",
                            children: "Logotipo"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "field is-horizontal",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "field-label is-normal is-flex-grow-4",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            className: "label",
                                            children: "Log\xf3tipo da Empresa"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "tip text-xs has-text-grey",
                                            children: "O logotipo ser\xe1 utilizado em propostas e documentos"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "field-body",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "file has-name",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                            className: "file-label",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    className: "file-input",
                                                    type: "file",
                                                    name: "companyLogo",
                                                    accept: "image/*",
                                                    onChange: (e)=>{
                                                        const selectedFile = e.target.files?.[0];
                                                        if (selectedFile) setFile(selectedFile);
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "file-cta",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "file-label",
                                                        children: "Escolher ficheiro..."
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "file-name",
                                                    children: file ? file.name : "Nenhum ficheiro selecionado"
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "field is-horizontal",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "field-label is-normal is-flex-grow-4"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "field-body pl-5",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "control",
                                        children: file ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            style: {
                                                position: "relative"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("picture", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        src: URL.createObjectURL(file),
                                                        alt: "Selected Logo",
                                                        className: "mt-2",
                                                        style: {
                                                            maxWidth: "200px",
                                                            maxHeight: "100px"
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "tag is-info is-light",
                                                    style: {
                                                        position: "absolute",
                                                        top: "8px",
                                                        right: "8px"
                                                    },
                                                    children: "Preview"
                                                })
                                            ]
                                        }) : userSettings.generalSettings?.company_logo_location ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "image-container  max-w-[150px] max-h-[100px]",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e87b4633e3445bd$export$2e2bcd8739ae039), {
                                                src: "http://iapc.pt/images/150/logo-IAPC.jpg",
                                                dataSrc: userSettings?.generalSettings?.company_logo_location,
                                                loading: "progressive",
                                                sizes: "150",
                                                alt: "Logo",
                                                className: "object-cover w-full h-10"
                                            })
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "mt-2 has-text-grey",
                                            children: "Nenhum logotipo selecionado"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "box",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3678a935ea45578e$export$2e2bcd8739ae039), {
                    smtpSettings: userSettings?.generalSettings?.smtp_configuration ?? defaultUserSmtpConfiguration(userSettings),
                    setSmtpSettings: handleSmtpConfigurationChange,
                    smtpSettingsChanged: userSettings?.generalSettings?.smtp_settings_changed ?? false,
                    successTest: userSettings?.generalSettings?.smtp_settings_valid ?? null,
                    setSuccessTest: (success)=>{
                        const updatedSettings = {
                            ...userSettings,
                            generalSettings: {
                                ...userSettings.generalSettings,
                                smtp_settings_valid: success,
                                companyLogoLocation: null
                            },
                            profile: userSettings?.profile || {}
                        };
                        // @ts-ignore
                        setUserSettings(updatedSettings);
                    }
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "box",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("fieldset", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("legend", {
                            className: "title is-4",
                            children: "Configura\xe7\xf5es de IVA"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "field is-horizontal",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "field-label is-normal is-flex-grow-4",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            className: "label",
                                            htmlFor: "defaultLanguage",
                                            children: "Taxa de IVA"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "tip text-xs has-text-grey",
                                            children: "Taxa de IVA aplicada automaticamente nos c\xe1lculos de pre\xe7o"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "field-body",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "field is-grouped",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "control",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "select w-[380px]",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                    name: "iva_percentage",
                                                    value: userSettings.generalSettings?.vat_percentage ?? 23,
                                                    onChange: (e)=>{
                                                        const value = parseFloat(e.target.value);
                                                        if (!isNaN(value)) {
                                                            const updatedSettings = {
                                                                ...userSettings,
                                                                generalSettings: {
                                                                    ...userSettings.generalSettings,
                                                                    vat_percentage: value,
                                                                    company_logo_location: null
                                                                },
                                                                profile: userSettings?.profile || {}
                                                            };
                                                            // @ts-ignore
                                                            setUserSettings(updatedSettings);
                                                        }
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: "23",
                                                            children: "Taxa de 23% (Portugal Continental)"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: "22",
                                                            children: "Taxa de 22% (Regi\xe3o Aut\xf3noma da Madeira)"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: "16",
                                                            children: "Taxa de 16% (Regi\xe3o Aut\xf3noma dos A\xe7ores)"
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "box",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("fieldset", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("legend", {
                            className: "title is-4",
                            children: "Configura\xe7\xf5es de Margem"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "field is-horizontal",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "field-label is-normal  is-flex-grow-4",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            className: "label",
                                            htmlFor: "useRecommendedMargin",
                                            children: "Utilizar Margem Recomendada"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "tip text-xs has-text-grey",
                                            children: "Aplica automaticamente as margens sugeridas pelo sistema"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "field-body",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "field is-grouped",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "control",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                type: "checkbox",
                                                name: "useRecommendedMargin",
                                                className: "mr-2",
                                                checked: userSettings.generalSettings?.use_default_margin ?? true,
                                                onChange: (e)=>{
                                                    const checked = e.target.checked;
                                                    const updatedSettings = {
                                                        ...userSettings,
                                                        generalSettings: {
                                                            ...userSettings.generalSettings,
                                                            use_default_margin: checked,
                                                            company_logo_location: null
                                                        },
                                                        profile: userSettings?.profile || {}
                                                    };
                                                    // @ts-ignore
                                                    setUserSettings(updatedSettings);
                                                }
                                            })
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: `field is-horizontal ${userSettings.generalSettings?.use_default_margin ?? true ? " opacity-50 cursor-not-allowed " : ""}`,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "field-label is-normal is-flex-grow-4",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            className: "label",
                                            children: "Configura\xe7\xe3o de Margens por Tabela de Pre\xe7os"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "tip text-xs has-text-grey",
                                            children: "Defina os thresholds de pre\xe7o e as margens a aplicar"
                                        })
                                    ]
                                }),
                                renderMarginThresholds()
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "box",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("fieldset", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("legend", {
                            className: "title is-4",
                            children: "Configura\xe7\xf5es Adicionais"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "field is-horizontal",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "field-label is-normal  is-flex-grow-4",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            className: "label",
                                            htmlFor: "enableViewCostPrices",
                                            children: "Mostrar pre\xe7os de custo"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "tip text-xs has-text-grey",
                                            children: "Habilita funcionalidades visualiza\xe7\xe3o de pre\xe7os de custo"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "field-body",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "field is-grouped",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "control",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                className: "checkbox mt-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "checkbox",
                                                        name: "enableViewCostPrices",
                                                        className: "mr-2",
                                                        checked: userSettings.generalSettings?.show_cost_price ?? true,
                                                        onChange: (e)=>{
                                                            const checked = e.target.checked;
                                                            const updatedSettings = {
                                                                ...userSettings,
                                                                generalSettings: {
                                                                    ...userSettings.generalSettings,
                                                                    show_cost_price: checked,
                                                                    company_logo_location: null
                                                                },
                                                                profile: userSettings?.profile || {}
                                                            };
                                                            setUserSettings(updatedSettings);
                                                        }
                                                    }),
                                                    "Mostrar pre\xe7os de custo"
                                                ]
                                            })
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "field is-horizontal",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "field-label is-normal  is-flex-grow-4",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            className: "label",
                                            htmlFor: "enableAdvancedMode",
                                            children: "Ativar Modo Avan\xe7ado"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "tip text-xs has-text-grey",
                                            children: "Habilita funcionalidades avan\xe7adas de edi\xe7\xe3o de pre\xe7os"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "field-body",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "field is-grouped",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "control",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                className: "checkbox mt-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "checkbox",
                                                        name: "enableAdvancedMode",
                                                        className: "mr-2",
                                                        checked: userSettings.generalSettings?.show_margin_slider ?? true,
                                                        onChange: (e)=>{
                                                            const checked = e.target.checked;
                                                            const updatedSettings = {
                                                                ...userSettings,
                                                                generalSettings: {
                                                                    ...userSettings.generalSettings,
                                                                    show_margin_slider: checked,
                                                                    company_logo_location: null
                                                                },
                                                                profile: userSettings?.profile || {}
                                                            };
                                                            // @ts-ignore
                                                            setUserSettings(updatedSettings);
                                                        }
                                                    }),
                                                    "Configurador de margem"
                                                ]
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $99bb9698a2277115$export$2e2bcd8739ae039), {})
        ]
    });
};
var $16026b95f91bd2a3$export$2e2bcd8739ae039 = $16026b95f91bd2a3$var$GlobalSettings;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



const $d0e487848e56d317$var$MfaSettings = ()=>{
    const [enabled, setEnabled] = (0, $acw62.useState)(false);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [secret, setSecret] = (0, $acw62.useState)(null);
    const [otpauthUri, setOtpauthUri] = (0, $acw62.useState)(null);
    const [confirmCode, setConfirmCode] = (0, $acw62.useState)("");
    const [disableCode, setDisableCode] = (0, $acw62.useState)("");
    const [busy, setBusy] = (0, $acw62.useState)(false);
    const [message, setMessage] = (0, $acw62.useState)(null);
    const [error, setError] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        const load = async ()=>{
            try {
                const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).MFA_STATUS);
                setEnabled(res.data?.mfa_enabled === true);
            } catch  {
            // status fetch failure is non-critical; default to not enrolled
            } finally{
                setLoading(false);
            }
        };
        load();
    }, []);
    const startEnroll = async ()=>{
        setBusy(true);
        setError(null);
        setMessage(null);
        try {
            const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).post((0, $cd93687958c8007e$export$bfe19bc25132bb7c).MFA_ENROLL);
            setSecret(res.data.secret);
            setOtpauthUri(res.data.otpauth_uri);
            setConfirmCode("");
            setMessage("Chave gerada. Confirme o c\xf3digo da sua aplica\xe7\xe3o de autentica\xe7\xe3o.");
        } catch  {
            setError("N\xe3o foi poss\xedvel iniciar a ativa\xe7\xe3o. Tente novamente.");
        } finally{
            setBusy(false);
        }
    };
    const confirmEnroll = async (e)=>{
        e.preventDefault();
        if (confirmCode.length !== 6) return;
        setBusy(true);
        setError(null);
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).post((0, $cd93687958c8007e$export$bfe19bc25132bb7c).MFA_CONFIRM, {
                code: confirmCode
            });
            setEnabled(true);
            setSecret(null);
            setOtpauthUri(null);
            setMessage("Verifica\xe7\xe3o em dois passos ativada com sucesso.");
        } catch  {
            setError("C\xf3digo inv\xe1lido. Tente novamente.");
        } finally{
            setBusy(false);
        }
    };
    const disable = async (e)=>{
        e.preventDefault();
        if (disableCode.length !== 6) return;
        setBusy(true);
        setError(null);
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).post((0, $cd93687958c8007e$export$bfe19bc25132bb7c).MFA_DISABLE, {
                code: disableCode
            });
            setEnabled(false);
            setDisableCode("");
            setMessage("Verifica\xe7\xe3o em dois passos desativada.");
        } catch  {
            setError("C\xf3digo inv\xe1lido. Tente novamente.");
        } finally{
            setBusy(false);
        }
    };
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "box",
        children: "A carregar\u2026"
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "box",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("legend", {
                className: "title is-4",
                children: "Seguran\xe7a"
            }),
            message && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "notification is-success is-light",
                children: message
            }),
            error && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "notification is-danger is-light",
                children: error
            }),
            enabled ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "tag is-success",
                                children: "Ativada"
                            }),
                            " A verifica\xe7\xe3o em dois passos est\xe1 ativa na sua conta."
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                        onSubmit: disable,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "field",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                        className: "label",
                                        children: "C\xf3digo de 6 d\xedgitos para desativar"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "control",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            className: "input",
                                            type: "text",
                                            inputMode: "numeric",
                                            maxLength: 6,
                                            value: disableCode,
                                            onChange: (e)=>setDisableCode(e.target.value.replace(/\D/g, "")),
                                            placeholder: "000000"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "button is-danger",
                                type: "submit",
                                disabled: busy || disableCode.length !== 6,
                                children: "Desativar"
                            })
                        ]
                    })
                ]
            }) : secret && otpauthUri ? /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                onSubmit: confirmEnroll,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "mb-3",
                        children: "Digitalize o c\xf3digo QR abaixo com a sua aplica\xe7\xe3o de autentica\xe7\xe3o (Google Authenticator, 1Password, \u2026) ou adicione a chave manualmente."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "field has-text-centered mb-4",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "p-3 has-background-white is-inline-block border rounded",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8b78587e05097331$export$10307208e61210e9), {
                                value: otpauthUri,
                                size: 160,
                                level: "M"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "field",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                className: "label",
                                children: "Chave secreta"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "control",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("code", {
                                    className: "is-family-monospace has-background-light p-2 is-block",
                                    style: {
                                        wordBreak: "break-all"
                                    },
                                    children: secret
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                href: otpauthUri,
                                className: "is-size-7",
                                children: "Abrir diretamente na aplica\xe7\xe3o"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "field",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                className: "label",
                                children: "C\xf3digo de confirma\xe7\xe3o"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "control",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    className: "input",
                                    type: "text",
                                    inputMode: "numeric",
                                    maxLength: 6,
                                    value: confirmCode,
                                    onChange: (e)=>setConfirmCode(e.target.value.replace(/\D/g, "")),
                                    placeholder: "000000"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "field is-grouped",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "button is-primary",
                                type: "submit",
                                disabled: busy || confirmCode.length !== 6,
                                children: "Confirmar e ativar"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "button",
                                type: "button",
                                onClick: ()=>{
                                    setSecret(null);
                                    setOtpauthUri(null);
                                    setMessage(null);
                                    setError(null);
                                },
                                children: "Cancelar"
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "mb-3",
                        children: "Proteja a sua conta com um segundo fator de autentica\xe7\xe3o."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "button is-primary",
                        onClick: startEnroll,
                        disabled: busy,
                        children: "Ativar verifica\xe7\xe3o em dois passos"
                    })
                ]
            })
        ]
    });
};
var $d0e487848e56d317$export$2e2bcd8739ae039 = $d0e487848e56d317$var$MfaSettings;





const $97e9c2760dd1027f$var$Settings = ()=>{
    const { isAuthenticated: isAuthenticated } = (0, $b622ef53e38024e7$export$1d39dc5b47e56ff0)();
    const navigate = (0, $585f8bce88e531c1$export$9770f232ac06a008)();
    const { pathname: pathname } = (0, $585f8bce88e531c1$export$45d76561a5302f2b)();
    const { userSettings: userSettings, setUserSettings: setUserSettings, systemError: systemError, setSystemError: setSystemError, loading: loading, setLoading: setLoading, error: error, setError: setError, success: success, setSuccess: setSuccess, modalScreen: modalScreen, setModalScreen: setModalScreen, page: page, setPage: setPage } = (0, $a55f2a94cd420149$export$c50e37a2f0a2b064)();
    const [activeTab, setActiveTab] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("profile");
    (0, $acw62.useEffect)(()=>{
        if (!isAuthenticated) navigate("/login", {
            state: {
                from: pathname
            }
        });
    }, [
        isAuthenticated,
        navigate,
        pathname
    ]);
    if (!isAuthenticated) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "container mx-auto p-4",
        children: "Acesso n\xe3o autorizado."
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "container mx-auto p-4",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "p-4 overflow-auto",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex flex-col md:flex-row justify-between items-start md:items-center gap-4",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "text-3xl font-bold text-gray-900 tracking-tight",
                                    children: "Configura\xe7\xf5es"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "text-gray-500 mt-1",
                                    children: "Gerencie suas configura\xe7\xf5es de perfil, propostas e notifica\xe7\xf5es."
                                })
                            ]
                        })
                    }),
                    loading ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "text-center",
                        children: "Loading..."
                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "tabs is-right",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            className: `is-${activeTab === "profile" ? "active" : ""}`,
                                            onClick: ()=>setActiveTab("profile"),
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                children: "Profile"
                                            })
                                        }),
                                        (userSettings?.isMainAccount() || userSettings?.isAdmin()) && /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            className: `is-${activeTab === "offers" ? "active" : ""}`,
                                            onClick: ()=>setActiveTab("offers"),
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                children: "Propostas"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            className: `is-${activeTab === "notifications" ? "active" : ""}`,
                                            onClick: ()=>setActiveTab("notifications"),
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                children: "Notifica\xe7\xf5es"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            className: `is-${activeTab === "security" ? "active" : ""}`,
                                            onClick: ()=>setActiveTab("security"),
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                children: "Seguran\xe7a"
                                            })
                                        }),
                                        (userSettings?.isMainAccount() || userSettings?.isAdmin()) && /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            className: `is-${activeTab === "settings" ? "active" : ""}`,
                                            onClick: ()=>setActiveTab("settings"),
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                children: "Configura\xe7\xf5es Globais"
                                            })
                                        })
                                    ]
                                })
                            }),
                            activeTab === "profile" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4c23f4f3b910156c$export$2e2bcd8739ae039), {}),
                            activeTab === "offers" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6c12e11027ddf4fe$export$2e2bcd8739ae039), {}),
                            activeTab === "notifications" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e29637da4a282b94$export$2e2bcd8739ae039), {}),
                            activeTab === "security" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d0e487848e56d317$export$2e2bcd8739ae039), {}),
                            activeTab === "settings" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $16026b95f91bd2a3$export$2e2bcd8739ae039), {})
                        ]
                    })
                ]
            })
        })
    });
};
var $97e9c2760dd1027f$export$2e2bcd8739ae039 = $97e9c2760dd1027f$var$Settings;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $d128fcc4f8f3b7c7$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M2 21a8 8 0 0 1 10.821-7.487",
            key: "1c8h7z"
        }
    ],
    [
        "path",
        {
            d: "M21.378 16.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
            key: "1817ys"
        }
    ],
    [
        "circle",
        {
            cx: "10",
            cy: "8",
            r: "5",
            key: "o932ke"
        }
    ]
];
const $d128fcc4f8f3b7c7$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("user-round-pen", $d128fcc4f8f3b7c7$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5a03486bccdd1e87$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M2 21a8 8 0 0 1 11.873-7",
            key: "74fkxq"
        }
    ],
    [
        "circle",
        {
            cx: "10",
            cy: "8",
            r: "5",
            key: "o932ke"
        }
    ],
    [
        "path",
        {
            d: "m17 17 5 5",
            key: "p7ous7"
        }
    ],
    [
        "path",
        {
            d: "m22 17-5 5",
            key: "gqnmv0"
        }
    ]
];
const $5a03486bccdd1e87$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("user-round-x", $5a03486bccdd1e87$export$3efd853dbb351e94);




const $7ec500b3b7c0dbe7$export$cea3d5a701e9afd3 = (role)=>{
    switch(role){
        case "admin":
        case "ROLE_ADMIN":
            return "Administrador";
        case "reseller":
        case "ROLE_RESELLER":
            return "Revendedor";
        case "commercial":
        case "ROLE_COMMERCIAL":
            return "Comercial";
        case "user":
        case "ROLE_USER":
            return "Utilizador";
        case "guest":
        case "ROLE_GUEST":
            return "An\xf3nimo";
        default:
            return role;
    }
};
const $7ec500b3b7c0dbe7$export$84bcd5e7c80654ea = (user)=>{
    if (user.type === "admin") return "Administrador";
    if (user.type === "commercial") return "Comercial";
    if (user.type === "reseller") return "Revendedor";
    if (user.type === "user") return "Utilizador";
    return "An\xf3nimo";
};
const $7ec500b3b7c0dbe7$export$f6a4faccd88f6ce6 = (username)=>{
    return (username?.length ?? 0) >= 3 && /^[A-Za-z0-9_.]+$/.test(username);
};
const $7ec500b3b7c0dbe7$export$371e338370561054 = (email)=>{
    return !!email?.match(new RegExp("^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+$"));
};
const $7ec500b3b7c0dbe7$export$1cf356d314abea16 = (password)=>{
    return (password?.length ?? 0) >= 6;
};
const $7ec500b3b7c0dbe7$export$5765e04613581599 = (firstName)=>{
    return !!firstName && firstName.trim().length > 0;
};




const $38cfe2e0dce05ee9$var$ListItems = ({ userProfile: userProfile, data: data, searchTerm: searchTerm, setSearchTerm: setSearchTerm, roleFilterSelected: roleFilterSelected, setRoleFilterSelected: setRoleFilterSelected, commercialAgentFilterSelected: commercialAgentFilterSelected, setCommercialAgentFilterSelected: setCommercialAgentFilterSelected, currentPage: currentPage, perPage: perPage, setPerPage: setPerPage, totalPages: totalPages, sortBy: sortBy, sortOrder: sortOrder, setSortBy: setSortBy, setSortOrder: setSortOrder, onPageChange: onPageChange, setError: setError, setCheckUser: setCheckUser, handleManageItem: handleManageItem, handleDeleteItem: handleDeleteItem, handlePasswordReset: handlePasswordReset, handleMfaReset: handleMfaReset, handleCreateItem: handleCreateItem })=>{
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [commercialAgents, setCommercialAgents] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [userToDelete, setUserToDelete] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [showDeleteModal, setShowDeleteModal] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const isMainAccount = userProfile?.isMainAccount() || false;
    const isAdmin = userProfile?.isAdmin() || false;
    const isCommercial = userProfile?.isCommercial() || false;
    const isAdminOrMainAccount = isAdmin || isMainAccount;
    const isAdminOrCommercial = isAdmin || isCommercial;
    const remainingSubaccountsAllowed = userProfile?.profile.remainingSubaccountsAllowed || 0;
    const isAllowedToCreateUser = isAdminOrMainAccount && remainingSubaccountsAllowed > 0;
    const handleDeleteClick = (item)=>{
        setUserToDelete(item);
        setShowDeleteModal(true);
    };
    const confirmDeleteUser = ()=>{
        if (!userToDelete) return;
        setShowDeleteModal(false);
        setLoading(true);
        (0, $bac44633733ff026$export$2e2bcd8739ae039).delete((0, $cd93687958c8007e$export$bfe19bc25132bb7c).USERS + `${userToDelete.id}`).then((response)=>{
            if (response.status === 200) handleDeleteItem(userToDelete);
            else {
                console.warn("Erro ao apagar o utilizador:", response.data);
                setError("Erro ao apagar o utilizador. Por favor, tente novamente.");
            }
        }).catch((error)=>{
            console.warn("Erro ao apagar o utilizador:", error);
            setError("Erro ao apagar o utilizador. Por favor, tente novamente.");
        }).finally(()=>{
            setLoading(false);
            setUserToDelete(null);
        });
    };
    const fetchCommercialAgents = ()=>{
        setLoading(true);
        (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).USERS + `_values/commercial_agents`).then((response)=>{
            if (response.status === 200) setCommercialAgents(response.data);
            else {
                console.warn("Erro ao buscar agentes comerciais:", response.data);
                setError("Erro ao buscar agentes comerciais. Por favor, tente novamente.");
            }
        }).catch((error)=>{
            console.warn("Erro ao buscar agentes comerciais:", error);
            setError("Erro ao buscar agentes comerciais. Por favor, tente novamente.");
        }).finally(()=>setLoading(false));
    };
    const handleSelectCommercialAgentFocus = (e)=>{
        e.preventDefault();
        if (commercialAgents.length === 0) fetchCommercialAgents();
    };
    const renderSortButton = (field, label)=>(0, $50b6964e2a1344c7$export$42a1e94961918ad5)(sortBy, sortOrder, setSortOrder, setSortBy, field, label);
    const renderActionButtons = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex flex-wrap items-center justify-between gap-3",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex items-center gap-3",
                    children: [
                        isAdmin && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>setCheckUser(true),
                            className: "px-4 py-2.5 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors",
                            "aria-label": "Validar utilizador",
                            children: "Validar Utilizador"
                        }),
                        (isAllowedToCreateUser || isAdmin) && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: handleCreateItem,
                            className: "px-4 py-2.5 bg-green-600 text-white font-medium rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition-colors",
                            "aria-label": "Adicionar novo utilizador",
                            children: "Adicionar Utilizador"
                        })
                    ]
                }),
                isMainAccount && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "text-sm text-gray-600 bg-gray-100 px-4 py-2 rounded-lg",
                    children: remainingSubaccountsAllowed > 0 ? `Restam ${remainingSubaccountsAllowed} utilizadores` : "Limite de utilizadores atingido"
                })
            ]
        });
    };
    const renderFilters = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "grid grid-cols-1 md:grid-cols-3 gap-4",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "md:col-span-1",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                            htmlFor: "search",
                            className: "block text-sm font-medium text-gray-700 mb-2",
                            children: "Pesquisar"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "relative",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        className: "h-5 w-5 text-gray-400",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        stroke: "currentColor",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            strokeWidth: 2,
                                            d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    type: "text",
                                    id: "search",
                                    name: "search",
                                    placeholder: "Nome, utilizador, email ou telefone...",
                                    value: searchTerm,
                                    onChange: (e)=>setSearchTerm(e.target.value),
                                    className: "block w-full pl-10 pr-3 py-2.5 border border-gray-300 rounded-lg bg-gray-50 placeholder-gray-500 focus:outline-none focus:bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm transition-all duration-200"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                            htmlFor: "role",
                            className: "block text-sm font-medium text-gray-700 mb-2",
                            children: "Perfil"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                            id: "role",
                            name: "role",
                            onChange: (e)=>setRoleFilterSelected(e.target.value),
                            className: "block w-full px-3 py-2.5 border border-gray-300 rounded-lg bg-gray-50 text-gray-900 focus:outline-none focus:bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm transition-all duration-200",
                            value: roleFilterSelected,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                    value: "",
                                    children: "Todos"
                                }),
                                isAdmin && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                            value: "admin",
                                            children: "Administrador"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                            value: "commercial",
                                            children: "Comercial"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                    value: "reseller",
                                    children: "Revendedor"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                    value: "user",
                                    children: "Convidado"
                                })
                            ]
                        })
                    ]
                }),
                isAdmin && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                            htmlFor: "commercial",
                            className: "block text-sm font-medium text-gray-700 mb-2",
                            children: "Comercial"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                            id: "commercial",
                            name: "commercial_agent",
                            onChange: (e)=>setCommercialAgentFilterSelected(e.target.value),
                            className: "block w-full px-3 py-2.5 border border-gray-300 rounded-lg bg-gray-50 text-gray-900 focus:outline-none focus:bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm transition-all duration-200",
                            value: commercialAgentFilterSelected,
                            onFocus: handleSelectCommercialAgentFocus,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                    value: "",
                                    children: "Todos"
                                }),
                                commercialAgents.map((agent)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: agent.value?.toString(),
                                        children: agent.label
                                    }, agent.value?.toString()))
                            ]
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bg-white rounded-xl shadow-sm border border-gray-200 p-6 space-y-6 mb-6",
                children: [
                    renderActionButtons(),
                    renderFilters()
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "overflow-auto",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                            className: "min-w-full divide-y divide-gray-200",
                            style: {
                                width: "auto"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                    className: "bg-gray-50",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                        children: [
                                            isAdminOrCommercial && /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "px-3 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider",
                                                align: "center",
                                                children: renderSortButton("erp_client_id", "Cliente")
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-32",
                                                children: renderSortButton("username", "Utilizador")
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                                children: renderSortButton("first_name", "Nome")
                                            }),
                                            isAdminOrCommercial && /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                                align: "center",
                                                children: renderSortButton("company", "Empresa")
                                            }),
                                            isAdminOrCommercial && /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                                align: "center",
                                                children: renderSortButton("commercial_agent_ref", isAdmin ? "Comercial" : "Cod. Comercial")
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "px-3 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider",
                                                align: "center",
                                                children: renderSortButton("role", "Perfil")
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "px-3 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider",
                                                align: "center",
                                                children: renderSortButton("last_login_at", "Ultimo Login")
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "px-3 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider w-24",
                                                align: "center",
                                                children: "Estado"
                                            }),
                                            isAdminOrMainAccount && /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("tbody", {
                                    className: "bg-white divide-y divide-gray-200",
                                    children: [
                                        data.map((item, k)=>{
                                            if (item) return /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                className: "hover:bg-gray-50 transition-colors",
                                                children: [
                                                    isAdminOrCommercial && /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                        className: "px-3 py-3 whitespace-nowrap text-sm text-gray-900",
                                                        align: "center",
                                                        children: [
                                                            item.erpUserReference ?? "N/A",
                                                            item.isMainAccount && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "text-gray-500 text-xs",
                                                                        children: "Conta Principal"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        className: "px-3 py-3 whitespace-nowrap text-sm font-medium text-gray-900 w-32",
                                                        children: item.username
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        className: "px-3 py-3 whitespace-nowrap text-sm text-gray-900",
                                                        children: (item.firstName?.length ?? 0) > (isAdminOrCommercial ? 15 : 45) ? item.firstName?.substring(0, isAdminOrCommercial ? 15 : 45) + "..." : item.firstName || "N/A"
                                                    }),
                                                    isAdminOrCommercial && /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        className: "px-3 py-3 whitespace-nowrap text-sm text-gray-900",
                                                        children: (item.client?.name?.length ?? 0) > (isAdminOrCommercial ? 32 : 45) ? item.client?.name?.substring(0, isAdminOrCommercial ? 32 : 45) + "..." : item.client?.name || "N/A"
                                                    }),
                                                    isAdminOrCommercial && /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        className: "px-3 py-3 whitespace-nowrap text-sm text-gray-900",
                                                        children: item.erpUserReference == "NIPOSOM" ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "text-xs",
                                                            children: "n/a"
                                                        }) : (item.commercial_agent_id ?? 0) > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                            children: [
                                                                isAdmin && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            children: (item.commercial_agent_name ?? "").trim() != "" ? (0, $50b6964e2a1344c7$export$45ab7901d59a4408)(item.commercial_agent_name ?? "", 32) : /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                                                                className: "text-xs",
                                                                                children: item.commercial_agent_email
                                                                            })
                                                                        }),
                                                                        " - "
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                                                    className: "text-xs font-mono px-3",
                                                                    children: (item.commercial_agent_portfolio ?? "").trim() != "" ? item.commercial_agent_portfolio : "-"
                                                                })
                                                            ]
                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "text-xs",
                                                            children: (item.commercial_agent_portfolio ?? "").trim() != "" ? item.commercial_agent_portfolio : "-"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        className: "px-3 py-3 whitespace-nowrap text-sm text-gray-900",
                                                        align: "center",
                                                        children: (0, $7ec500b3b7c0dbe7$export$84bcd5e7c80654ea)(item)
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        className: "px-3 py-3 whitespace-nowrap text-sm text-gray-500",
                                                        align: "center",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "text-xs font-mono",
                                                            children: item.lastLoginAt ? new Date(item.lastLoginAt || "").toLocaleDateString("pt-PT", {
                                                                year: "numeric",
                                                                month: "2-digit",
                                                                day: "2-digit",
                                                                hour: "2-digit",
                                                                minute: "2-digit"
                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                children: "Ainda n\xe3o fez login"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        className: "px-3 py-3 whitespace-nowrap text-sm text-gray-900 w-24",
                                                        align: "center",
                                                        children: item.locked ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $839eea37a960d2b1$export$2e2bcd8739ae039), {
                                                            size: 24,
                                                            className: "has-text-danger"
                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                                            size: 24,
                                                            className: "has-text-success"
                                                        })
                                                    }),
                                                    isAdminOrMainAccount && /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                        className: "px-3 py-3 whitespace-nowrap text-sm font-medium",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$a6c7ac8248d6e38a), {
                                                                to: `#`,
                                                                "aria-label": "Gerir utilizador",
                                                                onClick: (e)=>{
                                                                    e.preventDefault();
                                                                    handleManageItem(item);
                                                                },
                                                                className: "text-green-600 hover:text-green-900 transition-colors",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "inline-flex items-center",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d128fcc4f8f3b7c7$export$2e2bcd8739ae039), {
                                                                        size: 20
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$a6c7ac8248d6e38a), {
                                                                to: `#`,
                                                                "aria-label": "Redefinir senha",
                                                                onClick: (e)=>{
                                                                    e.preventDefault();
                                                                    handlePasswordReset(item);
                                                                },
                                                                className: "text-orange-500 hover:text-orange-700 transition-colors ml-3",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "inline-flex items-center",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $94451a36ffcee03b$export$2e2bcd8739ae039), {
                                                                        size: 20
                                                                    })
                                                                })
                                                            }),
                                                            isAdmin && handleMfaReset && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$a6c7ac8248d6e38a), {
                                                                to: `#`,
                                                                "aria-label": "Repor MFA",
                                                                onClick: (e)=>{
                                                                    e.preventDefault();
                                                                    handleMfaReset(item);
                                                                },
                                                                className: "text-purple-600 hover:text-purple-900 transition-colors ml-3",
                                                                title: "Repor MFA (Verifica\xe7\xe3o em 2 Passos)",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "inline-flex items-center",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $948595fc4549df01$export$2e2bcd8739ae039), {
                                                                        size: 20
                                                                    })
                                                                })
                                                            }),
                                                            isAdmin && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$a6c7ac8248d6e38a), {
                                                                to: `#`,
                                                                "aria-label": "Apagar utilizador",
                                                                onClick: (e)=>{
                                                                    e.preventDefault();
                                                                    handleDeleteClick(item);
                                                                },
                                                                className: "text-red-600 hover:text-red-900 transition-colors ml-3",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "inline-flex items-center",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5a03486bccdd1e87$export$2e2bcd8739ae039), {
                                                                        size: 20
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, k);
                                        }),
                                        data.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                colSpan: isAdmin ? 9 : isMainAccount ? 6 : 8,
                                                className: "text-center py-4",
                                                children: searchTerm ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                    children: "Nenhum utilizador encontrado."
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                    children: "Nenhum utilizador cadastrado."
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex justify-center items-center m-4",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b38f3f5e0e7c2086$export$2e2bcd8739ae039), {
                            currentPage: currentPage,
                            totalPages: totalPages,
                            perPage: perPage,
                            setPerPage: setPerPage,
                            onPageChange: onPageChange
                        })
                    })
                ]
            }),
            showDeleteModal && userToDelete && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67ac64808127e67c$export$2e2bcd8739ae039), {
                title: "Confirmar Exclus\xe3o",
                onClose: ()=>setShowDeleteModal(false),
                state: "alert",
                footer: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex justify-end gap-2 p-4",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "px-4 py-2 bg-white text-gray-700 font-medium rounded-lg border border-gray-300 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-200 transition-colors",
                            onClick: ()=>setShowDeleteModal(false),
                            children: "Cancelar"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                            className: "px-4 py-2 bg-red-600 text-white font-medium rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 transition-colors flex items-center",
                            onClick: confirmDeleteUser,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "mr-2",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5a03486bccdd1e87$export$2e2bcd8739ae039), {
                                        size: 18
                                    })
                                }),
                                "Apagar Utilizador"
                            ]
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "p-6",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "bg-red-50 border-l-4 border-red-500 p-4 mb-4",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex items-start",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "flex-shrink-0",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                                        className: "h-5 w-5 text-red-500"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "ml-3",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            className: "text-sm font-medium text-red-800",
                                            children: "Aten\xe7\xe3o: A\xe7\xe3o Irrevers\xedvel"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "mt-2 text-sm text-red-700",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    children: [
                                                        "Tem certeza que deseja apagar o utilizador",
                                                        " ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                            children: userToDelete.username
                                                        }),
                                                        "?"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "mt-1",
                                                    children: "Esta a\xe7\xe3o n\xe3o pode ser desfeita e o utilizador perder\xe1 o acesso ao sistema imediatamente."
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
var $38cfe2e0dce05ee9$export$2e2bcd8739ae039 = $38cfe2e0dce05ee9$var$ListItems;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");





const $b075a587ebae651d$var$ManageUser = ({ user: user, onUserUpdate: onUserUpdate, isAdmin: isAdmin, isMainAccount: isMainAccount, setError: setError, setSuccess: setSuccess })=>{
    const [managementUser, setManagementUser] = (0, $acw62.useState)(user);
    const [erpClient, setErpClient] = (0, $acw62.useState)(null);
    const [erpUserReferenceSuggestions, setErpUserReferenceSuggestions] = (0, $acw62.useState)([]);
    const [usernameAvailable, setUsernameAvailable] = (0, $acw62.useState)(true);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const checkUsernameAvailable = async (username)=>{
        if (!managementUser.id && (0, $7ec500b3b7c0dbe7$export$f6a4faccd88f6ce6)(username)) (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).USERS + `_actions/check_username_available?username=${username}`).then((response)=>{
            setUsernameAvailable(response.data.available);
        });
        else setUsernameAvailable(true);
    };
    const fetchSuggestClient = async (erpUserReference)=>{
        if (erpUserReference && !managementUser.id) try {
            const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).USERS + `_actions/search_erp_client?client_id=${erpUserReference}`);
            if (response.data.length > 0) {
                setErpUserReferenceSuggestions(response.data || []);
                setErpClient(null);
            }
            if (response.data.length == 1 && response.data[0].erpUserReference.toLowerCase() == erpUserReference.toLowerCase()) {
                setErpClient(response.data[0]);
                if ((managementUser?.username ?? "") == "") setManagementUser({
                    ...managementUser,
                    username: isAdmin ? response.data[0].erpUserReference : "",
                    type: "reseller",
                    firstName: response.data[0].firstName || "",
                    email: response.data[0].email || "",
                    phoneNumber: response.data[0].phoneNumber || "",
                    commercial_agent_portfolio: response.data[0].commercial_agent_portfolio || ""
                });
            }
        } catch (error) {
            console.warn("Error fetching ERP user references:", error.message);
        }
        else setErpUserReferenceSuggestions([]);
    };
    const handleDeviceLockToggle = async (deviceToken, locked)=>{
        if (!isAdmin) {
            setError("Apenas administradores podem bloquear/desbloquear dispositivos. Por favor, contacte o suporte.");
            return;
        }
        setError(null);
        setSuccess(null);
        try {
            const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).post((0, $cd93687958c8007e$export$bfe19bc25132bb7c).USERS + `${managementUser?.id}/devices`, {
                token: deviceToken,
                locked: locked
            });
            if (!!response.data) {
                setSuccess(`Dispositivo ${locked ? "bloqueado" : "desbloqueado"} com sucesso!`);
                setManagementUser(response.data);
                onUserUpdate(response.data); // Notify parent component of the update
            }
        } catch (error) {
            setError(`Erro ao ${locked ? "bloquear" : "desbloquear"} dispositivo: ${error.message}`);
            console.warn("Error toggling device lock:", error.message);
        }
    };
    const handleSubmit = async ()=>{
        setLoading(true);
        setError(null);
        setSuccess(null);
        const missingFields = [
            !managementUser.id && !managementUser.username && "Nome de utilizador",
            !managementUser.id && !managementUser.password && "Palavra-passe",
            !managementUser.id && !managementUser.confirmPassword && "Confirma\xe7\xe3o de Palavra-passe",
            !managementUser.firstName && "Primeiro nome",
            !managementUser.email && "Email",
            managementUser.type === "reseller" && !managementUser.erpUserReference && !erpClient?.id && "Refer\xeancia do cliente no ERP",
            !managementUser.type && "Tipo de utilizador"
        ].filter(Boolean);
        const validRulesFields = [
            !(0, $7ec500b3b7c0dbe7$export$5765e04613581599)(managementUser.firstName || "") && "Primeiro nome",
            !(0, $7ec500b3b7c0dbe7$export$371e338370561054)(managementUser.email || "") && "Email",
            !(0, $7ec500b3b7c0dbe7$export$f6a4faccd88f6ce6)(managementUser.username || "") && "Nome de utilizador",
            !managementUser.id && !(0, $7ec500b3b7c0dbe7$export$1cf356d314abea16)(managementUser.password || "") && "Palavra-passe",
            !managementUser.id && managementUser.confirmPassword !== managementUser.password && "Confirma\xe7\xe3o de Palavra-passe"
        ].filter(Boolean);
        if (missingFields.length > 0) {
            setError(`Os seguintes campos s\xe3o obrigat\xf3rios: ${missingFields.join(", ")}`);
            setLoading(false);
            return;
        }
        if (validRulesFields.length > 0) {
            setError(`Os seguintes campos n\xe3o est\xe3o v\xe1lidos: ${validRulesFields.join(", ")}`);
            setLoading(false);
            return;
        }
        if (!managementUser.id && !usernameAvailable) {
            setError("O nome de utilizador j\xe1 est\xe1 em uso.");
            setLoading(false);
            return;
        }
        try {
            const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).post((0, $cd93687958c8007e$export$bfe19bc25132bb7c).USERS + (managementUser.id ?? ""), managementUser);
            if (response.data) {
                setManagementUser(response.data);
                onUserUpdate(response.data); // Notify parent component of the update
            }
        } catch (error) {
            setError(`Erro ao ${managementUser.id ? "atualizar" : "criar"} utilizador: ${error.message}`);
            console.warn("Error submitting user data:", error.message);
        } finally{
            setLoading(false);
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (managementUser.erpUserReference != erpClient?.erpUserReference) setErpClient(null);
        fetchSuggestClient(managementUser.erpUserReference || "");
    }, [
        managementUser.erpUserReference
    ]);
    (0, $acw62.useEffect)(()=>{
        checkUsernameAvailable(managementUser.username || "");
    }, [
        managementUser.username,
        managementUser.id
    ]);
    (0, $acw62.useEffect)(()=>{
        if (managementUser.username == managementUser.erpUserReference) setManagementUser({
            ...managementUser,
            type: "reseller",
            firstName: managementUser.firstName || erpClient?.firstName || "",
            email: managementUser.email || erpClient?.email || "",
            phoneNumber: managementUser.phoneNumber || erpClient?.phoneNumber || "",
            commercial_agent_portfolio: managementUser.commercial_agent_portfolio || erpClient?.commercial_agent_portfolio || ""
        });
    }, [
        managementUser.username,
        managementUser.erpUserReference
    ]);
    // @ts-ignore
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: loading ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "text-center",
            children: "Loading..."
        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("form", {
            onSubmit: async (e)=>{
                e.preventDefault();
                handleSubmit();
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "box model-card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "field is-horizontal",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "field-body",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "field w-1/3 relative",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "label",
                                                    htmlFor: "username",
                                                    children: "Nome de Utilizador"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "control is-expanded",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        className: `input ${managementUser.id ? "is-static" : (0, $7ec500b3b7c0dbe7$export$f6a4faccd88f6ce6)(managementUser.username) && usernameAvailable ? "" : "is-danger"}`,
                                                        type: "text",
                                                        id: "username",
                                                        name: "username",
                                                        placeholder: "Username",
                                                        readOnly: !!managementUser.id,
                                                        onChange: (e)=>{
                                                            setManagementUser({
                                                                ...managementUser,
                                                                username: e.target.value
                                                            });
                                                        },
                                                        value: managementUser.username ?? ""
                                                    })
                                                }),
                                                !managementUser.id && !(0, $7ec500b3b7c0dbe7$export$f6a4faccd88f6ce6)(managementUser.username) && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "help is-danger",
                                                    children: "O nome de utilizador deve ter pelo menos 3 caracteres e conter apenas letras, n\xfameros, pontos e underscores."
                                                }),
                                                !managementUser.id && !usernameAvailable && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "help is-danger",
                                                    children: "O nome de utilizador j\xe1 est\xe1 em uso."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "field w-2/3 relative",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "label",
                                                    htmlFor: "erpUserReference",
                                                    children: "Cliente Orimat #"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "control is-expanded",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "field has-addons",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                    className: `input ${managementUser.id || !isAdmin ? "is-static" : ""}`,
                                                                    style: {
                                                                        width: "25%"
                                                                    },
                                                                    type: "text",
                                                                    id: "erpUserReference",
                                                                    name: "erpUserReference",
                                                                    placeholder: "Refer\xeancia do cliente no ERP",
                                                                    readOnly: !!managementUser.id || !isAdmin,
                                                                    value: managementUser.erpUserReference ?? "",
                                                                    onChange: (e)=>setManagementUser({
                                                                            ...managementUser,
                                                                            erpUserReference: e.target.value
                                                                        })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                    className: `input is-static pl-5`,
                                                                    style: {
                                                                        width: "70%"
                                                                    },
                                                                    children: erpClient?.firstName || managementUser.client?.name
                                                                })
                                                            ]
                                                        }),
                                                        !managementUser.id && isAdmin && /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                                            className: "list-results is-hoverable absolute z-50 bg-cyan-100 w-[100%]",
                                                            children: erpUserReferenceSuggestions && !erpClient?.firstName && erpUserReferenceSuggestions.map((suggestion)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                                    className: "list-item hover:bg-cyan-200",
                                                                    onClick: ()=>{
                                                                        setErpClient(suggestion);
                                                                        setManagementUser({
                                                                            ...managementUser,
                                                                            erpUserReference: suggestion.erpUserReference,
                                                                            type: "reseller"
                                                                        });
                                                                    },
                                                                    children: [
                                                                        suggestion.erpUserReference,
                                                                        " -",
                                                                        " ",
                                                                        suggestion.firstName
                                                                    ]
                                                                }, suggestion.erpUserReference))
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            !managementUser.id && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "field is-horizontal",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "field-body",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "field",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "label",
                                                    htmlFor: "password",
                                                    children: "Palavra-passe"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "control is-expanded",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        className: `input ${managementUser.id ? "is-hidden" : (0, $7ec500b3b7c0dbe7$export$1cf356d314abea16)(managementUser.password) ? "" : "is-danger"}`,
                                                        type: "password",
                                                        id: "password",
                                                        name: "password",
                                                        placeholder: "********",
                                                        onChange: (e)=>setManagementUser({
                                                                ...managementUser,
                                                                // @ts-ignore
                                                                password: e.target.value
                                                            })
                                                    })
                                                }),
                                                !managementUser.id && !(0, $7ec500b3b7c0dbe7$export$1cf356d314abea16)(managementUser.password) && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "help is-danger",
                                                    children: "A palavra-passe deve ter pelo menos 6 caracteres."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "field",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "label",
                                                    htmlFor: "confirmPassword",
                                                    children: "Confira a Palavra-passe"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "control is-expanded",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        className: `input ${managementUser.id ? "is-hidden" : managementUser.confirmPassword !== managementUser.password ? "is-danger" : ""}`,
                                                        type: "password",
                                                        id: "confirmPassword",
                                                        name: "confirmPassword",
                                                        placeholder: "********",
                                                        onChange: (e)=>setManagementUser({
                                                                ...managementUser,
                                                                // @ts-ignore
                                                                confirmPassword: e.target.value
                                                            })
                                                    })
                                                }),
                                                managementUser.confirmPassword !== managementUser.password && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "help is-danger",
                                                    children: "As palavras-passe n\xe3o coincidem."
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "field is-horizontal",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "field-body",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "field",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "label",
                                                    htmlFor: "firstName",
                                                    children: "Primeiro Nome"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "control",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        className: `input ${(0, $7ec500b3b7c0dbe7$export$5765e04613581599)(managementUser.firstName ?? "") ? "" : "is-danger"}`,
                                                        type: "text",
                                                        id: "firstName",
                                                        name: "firstName",
                                                        value: managementUser.firstName ?? "",
                                                        onChange: (e)=>setManagementUser({
                                                                ...managementUser,
                                                                firstName: e.target.value
                                                            })
                                                    })
                                                }),
                                                !(0, $7ec500b3b7c0dbe7$export$5765e04613581599)(managementUser.firstName ?? "") && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "help is-danger",
                                                    children: "O primeiro nome \xe9 obrigat\xf3rio."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "field",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "label",
                                                    htmlFor: "lastName",
                                                    children: "Ultimo Nome"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "control",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        className: "input",
                                                        type: "text",
                                                        id: "lastName",
                                                        name: "lastName",
                                                        value: managementUser.lastName ?? "",
                                                        onChange: (e)=>setManagementUser({
                                                                ...managementUser,
                                                                lastName: e.target.value
                                                            })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "field is-horizontal",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "field-body",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "field",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "label",
                                                    htmlFor: "email",
                                                    children: "Email"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "control",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        className: `input ${(0, $7ec500b3b7c0dbe7$export$371e338370561054)(managementUser.email ?? "") ? "" : "is-danger"}`,
                                                        type: "email",
                                                        id: "email",
                                                        name: "email",
                                                        value: managementUser.email ?? "",
                                                        onChange: (e)=>setManagementUser({
                                                                ...managementUser,
                                                                email: e.target.value
                                                            })
                                                    })
                                                }),
                                                !(0, $7ec500b3b7c0dbe7$export$371e338370561054)(managementUser.email ?? "") && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "help is-danger",
                                                    children: "O email \xe9 obrigat\xf3rio e deve ser v\xe1lido."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "field",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "label",
                                                    htmlFor: "phone",
                                                    children: "Telefone"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "control",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        className: "input",
                                                        type: "tel",
                                                        id: "phone",
                                                        name: "phone",
                                                        value: managementUser.phoneNumber ?? "",
                                                        onChange: (e)=>setManagementUser({
                                                                ...managementUser,
                                                                phoneNumber: e.target.value
                                                            })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "box model-card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "field is-horizontal",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "field-body",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "field",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "label",
                                                    htmlFor: "type",
                                                    children: "Tipo de Utilizador"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "control is-expanded",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                        className: `select ${managementUser.type ? "" : "is-danger"}`,
                                                        id: "type",
                                                        name: "type",
                                                        value: managementUser.type,
                                                        onChange: (e)=>setManagementUser({
                                                                ...managementUser,
                                                                type: e.target.value
                                                            }),
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "guest",
                                                                disabled: true,
                                                                children: "An\xf3nimo"
                                                            }),
                                                            (isMainAccount || isAdmin) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                        value: "user",
                                                                        children: "Site / Self-Service"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                        value: "reseller",
                                                                        children: "Revendedor"
                                                                    })
                                                                ]
                                                            }),
                                                            isAdmin && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                        value: "commercial",
                                                                        children: "Comercial"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                        value: "admin",
                                                                        children: "Administrador"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        isAdmin && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "field",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "label",
                                                    htmlFor: "client",
                                                    children: "Carteira de Comercial"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "control is-expanded",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "text",
                                                        className: `input`,
                                                        id: "client",
                                                        name: "client",
                                                        value: managementUser.commercial_agent_portfolio || erpClient?.commercial_agent_ref || "",
                                                        onChange: (e)=>setManagementUser({
                                                                ...managementUser,
                                                                commercial_agent_portfolio: e.target.value
                                                            })
                                                    })
                                                })
                                            ]
                                        }),
                                        isAdmin && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "field",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "label",
                                                    htmlFor: "locked",
                                                    children: "Subcontas"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "control is-expanded",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "number",
                                                        className: "input",
                                                        id: "number_subaccounts_allowed",
                                                        name: "number_subaccounts_allowed",
                                                        min: "0",
                                                        max: "10",
                                                        disabled: managementUser.type != "reseller" || !(0, $7ec500b3b7c0dbe7$export$f6a4faccd88f6ce6)(managementUser.username) || managementUser.username?.toLowerCase() != managementUser.erpUserReference?.toLowerCase(),
                                                        value: managementUser.number_subaccounts_allowed || 0,
                                                        onChange: (e)=>setManagementUser({
                                                                ...managementUser,
                                                                number_subaccounts_allowed: parseInt(e.target.value ?? 0, 10)
                                                            })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "field is-horizontal",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "field-body",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "field",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "label",
                                                    htmlFor: "isCredentialsExpired",
                                                    children: "Password Expirada"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "control is-expanded",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            type: "checkbox",
                                                            className: "checkbox",
                                                            id: "isCredentialsExpired",
                                                            name: "isCredentialsExpired",
                                                            disabled: !managementUser.id,
                                                            readOnly: !managementUser.id,
                                                            checked: managementUser.credentialsExpired ?? false,
                                                            onChange: (e)=>setManagementUser({
                                                                    ...managementUser,
                                                                    credentialsExpired: e.target.checked
                                                                })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                            htmlFor: "isCredentialsExpired",
                                                            className: "ml-2",
                                                            children: "For\xe7ar troca de senha no pr\xf3ximo login"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "field",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "label",
                                                    htmlFor: "isEnabled",
                                                    children: "Ativar/Desativar usu\xe1rio"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "control is-expanded",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            type: "checkbox",
                                                            className: "checkbox",
                                                            id: "isEnabled",
                                                            name: "isEnabled",
                                                            checked: managementUser.enabled ?? true,
                                                            onChange: (e)=>setManagementUser({
                                                                    ...managementUser,
                                                                    enabled: e.target.checked
                                                                })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                            htmlFor: "isEnabled",
                                                            className: "ml-2",
                                                            children: "Ativo"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    managementUser.id && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "box model-card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "subtitle is-4",
                                children: "Dispositivos"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                                className: "table is-fullwidth",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                    children: "Dispositivo"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                    className: "w-1/6",
                                                    children: "Endere\xe7o de IP"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                    className: "w-2/6",
                                                    children: "Ultimo Login"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                    className: "actions w-60px"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                        children: managementUser.userDevice && managementUser.userDevice.length > 0 ? managementUser.userDevice?.map((device)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        className: "text-ellipsis",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "font-mono",
                                                            title: device.user_agent,
                                                            children: device.token.split(".")[0]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        className: "text-ellipsis",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "font-mono",
                                                            title: device.ip_address,
                                                            children: device.ip_address
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        className: "font-mono",
                                                        children: device.last_login_at ? new Date(device.last_login_at).toLocaleString() : "Never"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$a6c7ac8248d6e38a), {
                                                            to: `#`,
                                                            onClick: (e)=>{
                                                                handleDeviceLockToggle(device.token, !device.locked);
                                                                e.preventDefault();
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "icon is-medium has-text-primary",
                                                                children: device.locked ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $839eea37a960d2b1$export$2e2bcd8739ae039), {
                                                                    size: 24,
                                                                    className: "has-text-danger"
                                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                                                    size: 24,
                                                                    className: "has-text-success"
                                                                })
                                                            })
                                                        })
                                                    })
                                                ]
                                            }, device.token)) : /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                colSpan: 4,
                                                className: "has-text-centered",
                                                children: "N\xe3o existe dispositivos / N\xe3o foram feitos acessos."
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "field",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "control",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "submit",
                                className: "button is-primary",
                                children: managementUser.id ? "Altera utilizador" : "Cria utilizador"
                            })
                        })
                    })
                ]
            })
        })
    });
};
var $b075a587ebae651d$export$2e2bcd8739ae039 = $b075a587ebae651d$var$ManageUser;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");





const $e853e6d5e93ee88a$var$ResetPassword = ({ user: user, onResetPassword: onResetPassword })=>{
    const [newPassword, setNewPassword] = (0, $acw62.useState)("");
    const [confirmPassword, setConfirmPassword] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [showConfirmModal, setShowConfirmModal] = (0, $acw62.useState)(false);
    const handleResetClick = ()=>{
        if (newPassword !== confirmPassword) {
            setError("As senhas n\xe3o coincidem.");
            return;
        }
        if (!(0, $7ec500b3b7c0dbe7$export$1cf356d314abea16)(newPassword)) {
            setError("A senha deve ter pelo menos 6 caracteres.");
            return;
        }
        setShowConfirmModal(true);
    };
    const confirmReset = ()=>{
        setShowConfirmModal(false);
        setLoading(true);
        (0, $bac44633733ff026$export$2e2bcd8739ae039).put((0, $cd93687958c8007e$export$bfe19bc25132bb7c).USERS + `${user.id}/_actions/reset_password`, {
            new_password: newPassword
        }).then((response)=>{
            if (response.status === 200) {
                onResetPassword(user);
                setNewPassword("");
                setConfirmPassword("");
                setError("");
            } else setError("Erro ao redefinir a senha.");
        }).catch((error)=>{
            console.warn("Erro ao redefinir a senha:", error);
            setError("Erro ao redefinir a senha.");
        }).finally(()=>setLoading(false));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "reset-password-modal container",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "field",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                className: "label",
                                children: "Nova Senha"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "control",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    type: "password",
                                    className: `input ${!(0, $7ec500b3b7c0dbe7$export$1cf356d314abea16)(newPassword) ? "is-danger" : ""}`,
                                    value: newPassword,
                                    placeholder: "Digite a nova senha",
                                    onFocus: ()=>setError(""),
                                    disabled: loading,
                                    onChange: (e)=>setNewPassword(e.target.value)
                                })
                            }),
                            !(0, $7ec500b3b7c0dbe7$export$1cf356d314abea16)(newPassword) && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "help is-danger",
                                children: "A senha deve ter pelo menos 6 caracteres."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "field",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                className: "label",
                                children: "Confirmar Senha"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "control",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    type: "password",
                                    className: `input ${confirmPassword !== newPassword ? "is-danger" : ""}`,
                                    value: confirmPassword,
                                    placeholder: "Confirme a nova senha",
                                    onFocus: ()=>setError(""),
                                    disabled: loading,
                                    onChange: (e)=>setConfirmPassword(e.target.value)
                                })
                            }),
                            confirmPassword !== newPassword && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "help is-danger",
                                children: "As senhas n\xe3o coincidem."
                            })
                        ]
                    }),
                    error && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "error has-text-danger",
                        children: error
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex justify-center mt-4",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "button is-primary",
                            onClick: handleResetClick,
                            disabled: loading,
                            children: loading ? "Redefinindo..." : "Redefinir Senha"
                        })
                    })
                ]
            }),
            showConfirmModal && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67ac64808127e67c$export$2e2bcd8739ae039), {
                title: "Confirmar Redefini\xe7\xe3o de Senha",
                onClose: ()=>setShowConfirmModal(false),
                state: "confirm",
                footer: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex justify-end gap-2 p-4",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "button is-white",
                            onClick: ()=>setShowConfirmModal(false),
                            children: "Cancelar"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                            className: "button is-primary",
                            onClick: confirmReset,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "icon is-small",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                                        className: "inline mr-1"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    children: "Confirmar Redefini\xe7\xe3o"
                                })
                            ]
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "p-6",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "notification is-warning is-light mb-6 flex items-start",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "icon has-text-warning mr-3 mt-1",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                    className: "fas fa-exclamation-triangle"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "font-bold text-gray-800",
                                        children: "Tem certeza que deseja redefinir a senha?"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        className: "text-sm mt-1 text-gray-600",
                                        children: [
                                            "Esta a\xe7\xe3o ir\xe1 alterar a senha do utilizador",
                                            " ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                children: user.username || user.email
                                            }),
                                            ". O utilizador precisar\xe1 usar a nova senha para fazer login."
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $e853e6d5e93ee88a$export$2e2bcd8739ae039 = $e853e6d5e93ee88a$var$ResetPassword;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


const $71dfc152b0deca48$var$CheckUser = ({ setError: setError, setSuccess: setSuccess })=>{
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [loginRequest, setLoginRequest] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        username: "",
        password: ""
    });
    const [userInfo, setUserInfo] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const validateUser = async ()=>{
        if (!loginRequest.username || !loginRequest.password) {
            setError("Por favor, preencha todos os campos.");
            return;
        }
        setError(null);
        setSuccess(null);
        setLoading(true);
        (0, $bac44633733ff026$export$2e2bcd8739ae039).post((0, $cd93687958c8007e$export$bfe19bc25132bb7c).USERS + "_actions/check_username", loginRequest).then((response)=>{
            if (response.status === 200) {
                const data = response.data;
                console.log("User validation successful:", data);
                setUserInfo(data);
                setSuccess("Utilizador validado com sucesso.");
            } else {
                setError("Erro ao validar o utilizador. Por favor, tente novamente.");
                console.warn("Unexpected response status:", response.status);
            }
        }).catch((error)=>{
            setError("Erro ao validar o utilizador. Por favor, tente novamente.");
            console.warn("Error validating user:", error);
        // Handle error here
        }).finally(()=>setLoading(false));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("form", {
                    onSubmit: (e)=>{
                        e.preventDefault();
                        validateUser();
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "box model-card mt-10",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "text-2xl font-bold mb-4",
                                children: "Validar credenciais de utilizador"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "field is-horizontal",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "field-body",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "field",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "label",
                                                    htmlFor: "username",
                                                    children: "Nome de Utilizador"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "control is-expanded",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "text",
                                                        placeholder: "Introduza o nome de utilizador",
                                                        className: "input",
                                                        autoFocus: true,
                                                        onChange: (e)=>setLoginRequest({
                                                                ...loginRequest,
                                                                username: e.target.value
                                                            }),
                                                        value: loginRequest.username,
                                                        required: true,
                                                        onKeyDown: (e)=>{
                                                            if (e.key === "Enter" && !e.shiftKey && loginRequest.username && loginRequest.password) {
                                                                e.preventDefault();
                                                                validateUser();
                                                            }
                                                        }
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "field",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "label",
                                                    htmlFor: "password",
                                                    children: "Palavra-passe"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "control is-expanded",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        id: "password",
                                                        type: "password",
                                                        placeholder: "Introduza a palavra-passe",
                                                        className: "input",
                                                        onChange: (e)=>setLoginRequest({
                                                                ...loginRequest,
                                                                password: e.target.value
                                                            }),
                                                        value: loginRequest.password,
                                                        required: true,
                                                        onKeyDown: (e)=>{
                                                            if (e.key === "Enter" && !e.shiftKey && loginRequest.username && loginRequest.password) {
                                                                e.preventDefault();
                                                                validateUser();
                                                            }
                                                        }
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "control",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "button is-primary is-fullwidth",
                                    children: "Validar"
                                })
                            })
                        ]
                    })
                }),
                loading && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "box model-card mt-10",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "loading-spinner"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: "A validar utilizador..."
                        })
                    ]
                }),
                userInfo && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "box model-card mt-10",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "text-xl font-bold mb-2",
                            children: "Informa\xe7\xf5es do Utilizador"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                    children: "Nome de Utilizador:"
                                }),
                                " ",
                                userInfo.username
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("strong", {
                                children: [
                                    "Password v\xe1lida:",
                                    " ",
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: userInfo.is_password_valid ? "has-text-success" : "has-text-danger",
                                        children: [
                                            " ",
                                            userInfo.is_password_valid ? "Sim" : "N\xe3o"
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("details", {
                            className: "mt-2",
                            open: true,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("summary", {
                                    children: "Detalhes"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                    children: "Existe na BD:"
                                                }),
                                                " ",
                                                userInfo.user_exists_in_db ? "Sim" : "N\xe3o"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                    children: "Criado em:"
                                                }),
                                                " ",
                                                userInfo.user_created_at ?? "N/A"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                    children: "J\xe1 migrado:"
                                                }),
                                                " ",
                                                userInfo.already_migrated ? "Sim" : "N\xe3o"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                    children: "Utilizador ativo:"
                                                }),
                                                " ",
                                                userInfo.is_active_user ? "Sim" : "N\xe3o"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                            className: "mt-4",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                    children: "Existe no Orimat:"
                                                }),
                                                " ",
                                                userInfo.user_exists_in_orimat ? "Sim" : "N\xe3o"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                    children: "Password legacy v\xe1lida:"
                                                }),
                                                " ",
                                                userInfo.is_legacy_password ? "Sim" : "N\xe3o"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                    children: "Utilizador Orimat ativo:"
                                                }),
                                                " ",
                                                userInfo.is_active_orimat_user ? "Sim" : "N\xe3o"
                                            ]
                                        }),
                                        userInfo.user_exists_in_orimat && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    className: "mt-4",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                            children: "Nome no Orimat:"
                                                        }),
                                                        " ",
                                                        userInfo.name_on_orimat ?? "N/A"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                            children: "Email no Orimat:"
                                                        }),
                                                        " ",
                                                        userInfo.email_on_orimat ?? "N/A"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                            children: "Telefone no Orimat:"
                                                        }),
                                                        " ",
                                                        userInfo.phone_on_orimat ?? "N/A"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $71dfc152b0deca48$export$2e2bcd8739ae039 = $71dfc152b0deca48$var$CheckUser;



const $3c985caf6fe449d7$var$UsersManagementPage = ()=>{
    const { isAuthenticated: isAuthenticated } = (0, $b622ef53e38024e7$export$1d39dc5b47e56ff0)();
    const navigate = (0, $585f8bce88e531c1$export$9770f232ac06a008)();
    const { pathname: pathname } = (0, $585f8bce88e531c1$export$45d76561a5302f2b)();
    const { userSettings: userSettings, setUserSettings: setUserSettings, systemError: systemError, setSystemError: setSystemError, loading: loading, setLoading: setLoading, error: error, setError: setError, success: success, setSuccess: setSuccess, modalScreen: modalScreen, setModalScreen: setModalScreen, page: page, setPage: setPage } = (0, $a55f2a94cd420149$export$c50e37a2f0a2b064)();
    const [users, setUsers] = (0, $acw62.useState)([]);
    const [searchTerm, setSearchTerm] = (0, $acw62.useState)("");
    const [roleFilter, setRoleFilter] = (0, $acw62.useState)("");
    const [commercialAgentFilter, setCommercialAgentFilter] = (0, $acw62.useState)("");
    const [perPage, setPerPage] = (0, $acw62.useState)(10);
    const [sortBy, setSortBy] = (0, $acw62.useState)("username");
    const [sortOrder, setSortOrder] = (0, $acw62.useState)("asc");
    const [totalPages, setTotalPages] = (0, $acw62.useState)(1);
    const [remainingSubaccountsAllowed, setRemainingSubaccountsAllowed] = (0, $acw62.useState)(userSettings?.profile.remainingSubaccountsAllowed ?? 0);
    const fetchUsers = async ()=>{
        if (users.length === 0) setLoading(true);
        setError(null);
        setSuccess(null);
        try {
            const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).USERS + `?search=` + searchTerm + `&role=` + (roleFilter || "") + `&commercial_agent=` + (commercialAgentFilter || "") + `&sort_by=` + sortBy + `&sort_order=` + sortOrder + `&page=` + page + `&per_page=${perPage}`);
            setUsers(response.data.users || []);
            setTotalPages(response.data.total_pages || 1);
        } catch (error) {
            console.warn("Error fetching users:", error.message);
        } finally{
            setLoading(false);
        }
    };
    const handleSearchChange = (0, $acw62.useCallback)((searchTerm)=>{
        setSearchTerm(searchTerm);
        setPage(1);
        history.pushState(history.state, "", pathname + `?page=1`);
    }, [
        pathname,
        setPage
    ]);
    const handleUserUpdated = (0, $acw62.useCallback)(async (user)=>{
        const existingUser = users.find((u)=>u.id === user.id);
        if (!existingUser) {
            setUsers((prevUsers)=>[
                    ...prevUsers,
                    user
                ]);
            setSuccess(`Utilizador ${user.username} criado com sucesso!`);
            setRemainingSubaccountsAllowed(remainingSubaccountsAllowed - 1);
        } else {
            setUsers((prevUsers)=>{
                return prevUsers.map((u)=>u.id === user.id ? user : u);
            });
            setSuccess(`Utilizador ${user.username} atualizado com sucesso!`);
        }
    }, [
        users,
        setSuccess,
        setRemainingSubaccountsAllowed,
        remainingSubaccountsAllowed
    ]);
    const handleUserDeleted = (user)=>{
        const newUsers = users.filter((u)=>u.id !== user.id);
        setUsers(newUsers);
        setSuccess(`Utilizador ${user.username} apagado com sucesso!`);
        if (newUsers.length === 0 && page > 1) {
            setPage(page - 1);
            history.pushState(history.state, "", pathname + `?page=${page - 1}`);
        }
    };
    const openManageUser = (user)=>{
        setModalScreen({
            state: "edit",
            title: user.id ? `Gerir utilizador: #${user.username}` : "Criar novo utilizador",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b075a587ebae651d$export$2e2bcd8739ae039), {
                user: user,
                onUserUpdate: handleUserUpdated,
                isAdmin: userSettings?.isAdmin() ?? false,
                isMainAccount: userSettings?.isMainAccount() ?? false,
                setError: setError,
                setSuccess: setSuccess
            }),
            onClose: ()=>{
                setModalScreen(null);
            }
        });
    };
    const openPasswordReset = async (user)=>{
        setModalScreen({
            state: "confirm",
            title: `Alterar senha para utilizador ${user.username}`,
            className: "max-w-[400px] max-h-[37vh] bg-white",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e853e6d5e93ee88a$export$2e2bcd8739ae039), {
                user: user,
                onResetPassword: (updatedUser)=>{
                    setSuccess("Senha redefinida com sucesso!");
                    setModalScreen(null);
                    handleUserUpdated(updatedUser);
                }
            }),
            onClose: ()=>{
                setModalScreen(null);
            }
        });
    };
    const openMfaReset = (user)=>{
        setModalScreen({
            state: "confirm",
            title: `Repor MFA para utilizador ${user.username}`,
            className: "max-w-[420px] bg-white",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "p-4 text-center",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "mb-3 text-gray-800 font-medium",
                        children: [
                            "Tem certeza de que deseja repor a verifica\xe7\xe3o em dois passos (MFA) para ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                children: user.username
                            }),
                            "?"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "text-xs text-gray-500 mb-6",
                        children: "O utilizador ter\xe1 de reconfigurar a sua aplica\xe7\xe3o de autentica\xe7\xe3o no pr\xf3ximo login."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex justify-end gap-3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                className: "px-4 py-2 bg-gray-100 text-gray-700 font-medium rounded-lg hover:bg-gray-200 transition-colors",
                                onClick: ()=>setModalScreen(null),
                                children: "Cancelar"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                className: "px-4 py-2 bg-purple-600 text-white font-medium rounded-lg hover:bg-purple-700 transition-colors",
                                onClick: async ()=>{
                                    try {
                                        const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).post(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).USERS}${user.id}/_actions/reset_mfa`);
                                        setSuccess(`MFA do utilizador ${user.username} reposto com sucesso!`);
                                        setModalScreen(null);
                                        handleUserUpdated(res.data);
                                    } catch  {
                                        setError("N\xe3o foi poss\xedvel repor o MFA do utilizador.");
                                        setModalScreen(null);
                                    }
                                },
                                children: "Confirmar Reposi\xe7\xe3o"
                            })
                        ]
                    })
                ]
            }),
            onClose: ()=>setModalScreen(null)
        });
    };
    const openCheckUser = ()=>{
        if (!userSettings?.isAdmin()) {
            setSystemError({
                message: "Apenas utilizadores administradores podem validar utilizadores.",
                code: "NOT_AUTHORIZED",
                details: "Tentativa de valida\xe7\xe3o de utilizador por um utilizador n\xe3o administrador.",
                retryAfter: ()=>{
                    setModalScreen(null);
                }
            });
            return;
        }
        setModalScreen({
            state: "edit",
            title: "Validar utilizador",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71dfc152b0deca48$export$2e2bcd8739ae039), {
                setError: setError,
                setSuccess: setSuccess
            }),
            onClose: ()=>setModalScreen(null)
        });
    };
    const handlePageChange = (newPage)=>{
        setPage(newPage);
        history.pushState(history.state, "", `/users?page=${newPage}`);
    };
    (0, $acw62.useEffect)(()=>{
        if (isAuthenticated()) fetchUsers();
    }, [
        userSettings,
        page,
        perPage,
        searchTerm,
        roleFilter,
        commercialAgentFilter,
        sortBy,
        sortOrder
    ]);
    if (!userSettings?.isAdmin() && !userSettings?.isMainAccount() && !userSettings?.isCommercial()) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "container mx-auto p-4",
        children: "Apenas administradores e contas principais podem gerenciar utilizadores."
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "container mx-auto p-6 max-w-7xl",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex flex-col gap-6",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex flex-col md:flex-row justify-between items-start md:items-center gap-4",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "text-3xl font-bold text-gray-900 tracking-tight",
                                    children: "Utilizadores"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "text-gray-500 mt-1",
                                    children: "Gerencie utilizadores e permiss\xf5es do sistema."
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "overflow-auto",
                        children: loading ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "bg-white rounded-xl shadow-sm border border-gray-200 p-12",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "text-center",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "mt-4 text-gray-600",
                                        children: "A carregar utilizadores..."
                                    })
                                ]
                            })
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $38cfe2e0dce05ee9$export$2e2bcd8739ae039), {
                            data: users,
                            userProfile: userSettings,
                            searchTerm: searchTerm,
                            setSearchTerm: handleSearchChange,
                            roleFilterSelected: roleFilter,
                            setRoleFilterSelected: setRoleFilter,
                            commercialAgentFilterSelected: commercialAgentFilter,
                            setCommercialAgentFilterSelected: setCommercialAgentFilter,
                            currentPage: page,
                            perPage: perPage,
                            setPerPage: setPerPage,
                            totalPages: totalPages,
                            sortBy: sortBy,
                            setSortBy: setSortBy,
                            sortOrder: sortOrder,
                            setSortOrder: setSortOrder,
                            remainingItems: remainingSubaccountsAllowed,
                            setError: setError,
                            onPageChange: handlePageChange,
                            setCheckUser: openCheckUser,
                            handleManageItem: openManageUser,
                            handleDeleteItem: handleUserDeleted,
                            handlePasswordReset: openPasswordReset,
                            handleMfaReset: openMfaReset,
                            handleCreateItem: ()=>openManageUser({
                                    type: userSettings?.isMainAccount() ? "reseller" : "guest",
                                    credentialsExpired: true,
                                    enabled: true,
                                    erpUserReference: userSettings?.isMainAccount() ? userSettings?.client?.id : null,
                                    client: userSettings?.isMainAccount() ? userSettings?.client : null
                                })
                        })
                    })
                ]
            })
        })
    });
};
var $3c985caf6fe449d7$export$2e2bcd8739ae039 = $3c985caf6fe449d7$var$UsersManagementPage;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

const $f2c236c700eed7f6$var$containerStyle = {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    background: "#f9f9f9",
    color: "#333",
    textAlign: "center"
};
const $f2c236c700eed7f6$var$titleStyle = {
    fontSize: "8rem",
    margin: 0
};
const $f2c236c700eed7f6$var$messageStyle = {
    fontSize: "1.5rem",
    margin: "1rem 0"
};
const $f2c236c700eed7f6$var$linkStyle = {
    display: "inline-block",
    marginTop: "1rem",
    padding: "0.75rem 1.5rem",
    background: "#007bff",
    color: "#fff",
    textDecoration: "none",
    borderRadius: "4px"
};
const $f2c236c700eed7f6$var$NotFoundPage = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: $f2c236c700eed7f6$var$containerStyle,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                style: $f2c236c700eed7f6$var$titleStyle,
                children: "404"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                style: $f2c236c700eed7f6$var$messageStyle,
                children: "Oops! The page you're looking for can't be found."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$a6c7ac8248d6e38a), {
                to: "/",
                style: $f2c236c700eed7f6$var$linkStyle,
                children: "Return Home"
            })
        ]
    });
var $f2c236c700eed7f6$export$2e2bcd8739ae039 = $f2c236c700eed7f6$var$NotFoundPage;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $91a4e72629291447$exports = {};
/**
 * @mui/material v7.3.11
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $91a4e72629291447$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $91a4e72629291447$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($91a4e72629291447$exports, "__esModule", {
    value: true
});
var $91a4e72629291447$var$_exportNames = {
    colors: true,
    Accordion: true,
    AccordionActions: true,
    AccordionDetails: true,
    AccordionSummary: true,
    Alert: true,
    AlertTitle: true,
    AppBar: true,
    Autocomplete: true,
    Avatar: true,
    AvatarGroup: true,
    Backdrop: true,
    Badge: true,
    BottomNavigation: true,
    BottomNavigationAction: true,
    Box: true,
    Breadcrumbs: true,
    Button: true,
    ButtonBase: true,
    ButtonGroup: true,
    Card: true,
    CardActionArea: true,
    CardActions: true,
    CardContent: true,
    CardHeader: true,
    CardMedia: true,
    Checkbox: true,
    Chip: true,
    CircularProgress: true,
    ClickAwayListener: true,
    Collapse: true,
    Container: true,
    CssBaseline: true,
    darkScrollbar: true,
    Dialog: true,
    DialogActions: true,
    DialogContent: true,
    DialogContentText: true,
    DialogTitle: true,
    Divider: true,
    Drawer: true,
    Fab: true,
    Fade: true,
    FilledInput: true,
    FormControl: true,
    FormControlLabel: true,
    FormGroup: true,
    FormHelperText: true,
    FormLabel: true,
    GridLegacy: true,
    Grid: true,
    Grow: true,
    Icon: true,
    IconButton: true,
    ImageList: true,
    ImageListItem: true,
    ImageListItemBar: true,
    Input: true,
    InputAdornment: true,
    InputBase: true,
    InputLabel: true,
    LinearProgress: true,
    Link: true,
    List: true,
    ListItem: true,
    ListItemAvatar: true,
    ListItemButton: true,
    ListItemIcon: true,
    ListItemSecondaryAction: true,
    ListItemText: true,
    ListSubheader: true,
    Menu: true,
    MenuItem: true,
    MenuList: true,
    MobileStepper: true,
    Modal: true,
    NativeSelect: true,
    NoSsr: true,
    OutlinedInput: true,
    Pagination: true,
    PaginationItem: true,
    Paper: true,
    Popover: true,
    Popper: true,
    Portal: true,
    Radio: true,
    RadioGroup: true,
    Rating: true,
    ScopedCssBaseline: true,
    Select: true,
    Skeleton: true,
    Slide: true,
    Slider: true,
    Snackbar: true,
    SnackbarContent: true,
    SpeedDial: true,
    SpeedDialAction: true,
    SpeedDialIcon: true,
    Stack: true,
    Step: true,
    StepButton: true,
    StepConnector: true,
    StepContent: true,
    StepIcon: true,
    StepLabel: true,
    Stepper: true,
    SvgIcon: true,
    SwipeableDrawer: true,
    Switch: true,
    Tab: true,
    Table: true,
    TableBody: true,
    TableCell: true,
    TableContainer: true,
    TableFooter: true,
    TableHead: true,
    TablePagination: true,
    TablePaginationActions: true,
    TableRow: true,
    TableSortLabel: true,
    Tabs: true,
    TabScrollButton: true,
    TextField: true,
    TextareaAutosize: true,
    ToggleButton: true,
    ToggleButtonGroup: true,
    Toolbar: true,
    Tooltip: true,
    Typography: true,
    useMediaQuery: true,
    usePagination: true,
    useScrollTrigger: true,
    Zoom: true,
    useAutocomplete: true,
    GlobalStyles: true,
    unstable_composeClasses: true,
    generateUtilityClass: true,
    generateUtilityClasses: true,
    Unstable_TrapFocus: true,
    InitColorSchemeScript: true
};
Object.defineProperty($91a4e72629291447$exports, "Accordion", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Accordion.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "AccordionActions", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_AccordionActions.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "AccordionDetails", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_AccordionDetails.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "AccordionSummary", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_AccordionSummary.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Alert", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Alert.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "AlertTitle", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_AlertTitle.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "AppBar", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_AppBar.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Autocomplete", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Autocomplete.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Avatar", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Avatar.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "AvatarGroup", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_AvatarGroup.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Backdrop", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Backdrop.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Badge", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Badge.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "BottomNavigation", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_BottomNavigation.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "BottomNavigationAction", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_BottomNavigationAction.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Box", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Box.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Breadcrumbs", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Breadcrumbs.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Button", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Button.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "ButtonBase", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_ButtonBase.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "ButtonGroup", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_ButtonGroup.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Card", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Card.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "CardActionArea", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_CardActionArea.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "CardActions", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_CardActions.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "CardContent", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_CardContent.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "CardHeader", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_CardHeader.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "CardMedia", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_CardMedia.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Checkbox", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Checkbox.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Chip", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Chip.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "CircularProgress", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_CircularProgress.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "ClickAwayListener", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_ClickAwayListener.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Collapse", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Collapse.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Container", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Container.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "CssBaseline", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_CssBaseline.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Dialog", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Dialog.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "DialogActions", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_DialogActions.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "DialogContent", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_DialogContent.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "DialogContentText", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_DialogContentText.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "DialogTitle", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_DialogTitle.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Divider", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Divider.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Drawer", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Drawer.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Fab", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Fab.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Fade", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Fade.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "FilledInput", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_FilledInput.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "FormControl", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_FormControl.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "FormControlLabel", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_FormControlLabel.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "FormGroup", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_FormGroup.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "FormHelperText", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_FormHelperText.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "FormLabel", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_FormLabel.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "GlobalStyles", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_GlobalStyles.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Grid", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Grid.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "GridLegacy", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_GridLegacy.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Grow", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Grow.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Icon", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Icon.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "IconButton", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_IconButton.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "ImageList", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_ImageList.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "ImageListItem", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_ImageListItem.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "ImageListItemBar", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_ImageListItemBar.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "InitColorSchemeScript", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_InitColorSchemeScript.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Input", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Input.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "InputAdornment", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_InputAdornment.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "InputBase", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_InputBase.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "InputLabel", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_InputLabel.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "LinearProgress", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_LinearProgress.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Link", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Link.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "List", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_List.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "ListItem", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_ListItem.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "ListItemAvatar", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_ListItemAvatar.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "ListItemButton", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_ListItemButton.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "ListItemIcon", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_ListItemIcon.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "ListItemSecondaryAction", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_ListItemSecondaryAction.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "ListItemText", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_ListItemText.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "ListSubheader", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_ListSubheader.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Menu", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Menu.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "MenuItem", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_MenuItem.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "MenuList", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_MenuList.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "MobileStepper", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_MobileStepper.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Modal", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Modal.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "NativeSelect", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_NativeSelect.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "NoSsr", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_NoSsr.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "OutlinedInput", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_OutlinedInput.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Pagination", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Pagination.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "PaginationItem", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_PaginationItem.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Paper", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Paper.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Popover", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Popover.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Popper", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Popper.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Portal", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Portal.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Radio", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Radio.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "RadioGroup", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_RadioGroup.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Rating", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Rating.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "ScopedCssBaseline", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_ScopedCssBaseline.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Select", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Select.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Skeleton", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Skeleton.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Slide", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Slide.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Slider", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Slider.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Snackbar", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Snackbar.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "SnackbarContent", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_SnackbarContent.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "SpeedDial", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_SpeedDial.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "SpeedDialAction", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_SpeedDialAction.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "SpeedDialIcon", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_SpeedDialIcon.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Stack", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Stack.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Step", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Step.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "StepButton", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_StepButton.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "StepConnector", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_StepConnector.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "StepContent", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_StepContent.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "StepIcon", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_StepIcon.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "StepLabel", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_StepLabel.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Stepper", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Stepper.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "SvgIcon", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_SvgIcon.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "SwipeableDrawer", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_SwipeableDrawer.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Switch", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Switch.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Tab", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Tab.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "TabScrollButton", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_TabScrollButton.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Table", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Table.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "TableBody", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_TableBody.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "TableCell", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_TableCell.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "TableContainer", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_TableContainer.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "TableFooter", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_TableFooter.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "TableHead", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_TableHead.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "TablePagination", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_TablePagination.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "TablePaginationActions", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_TablePaginationActions.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "TableRow", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_TableRow.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "TableSortLabel", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_TableSortLabel.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Tabs", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Tabs.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "TextField", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_TextField.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "TextareaAutosize", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_TextareaAutosize.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "ToggleButton", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_ToggleButton.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "ToggleButtonGroup", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_ToggleButtonGroup.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Toolbar", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Toolbar.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Tooltip", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Tooltip.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Typography", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Typography.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Unstable_TrapFocus", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Unstable_TrapFocus.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "Zoom", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Zoom.default;
    }
});
$91a4e72629291447$exports.colors = void 0;
Object.defineProperty($91a4e72629291447$exports, "darkScrollbar", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_darkScrollbar.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "generateUtilityClass", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_generateUtilityClass.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "generateUtilityClasses", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_generateUtilityClasses.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "unstable_composeClasses", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_composeClasses.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "useAutocomplete", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_useAutocomplete.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "useMediaQuery", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_useMediaQuery.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "usePagination", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_usePagination.default;
    }
});
Object.defineProperty($91a4e72629291447$exports, "useScrollTrigger", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_useScrollTrigger.default;
    }
});

var $91a4e72629291447$var$colors = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("2PSrq")));
$91a4e72629291447$exports.colors = $91a4e72629291447$var$colors;

var $8xDHs = parcelRequire("8xDHs");
Object.keys($8xDHs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $8xDHs[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $8xDHs[key];
        }
    });
});

var $hGPki = parcelRequire("hGPki");
Object.keys($hGPki).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $hGPki[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $hGPki[key];
        }
    });
});

var $91a4e72629291447$var$_Accordion = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("lH1DK")));
Object.keys($91a4e72629291447$var$_Accordion).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Accordion[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Accordion[key];
        }
    });
});

var $91a4e72629291447$var$_AccordionActions = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("qjHPG")));
Object.keys($91a4e72629291447$var$_AccordionActions).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_AccordionActions[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_AccordionActions[key];
        }
    });
});

var $91a4e72629291447$var$_AccordionDetails = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("e5H02")));
Object.keys($91a4e72629291447$var$_AccordionDetails).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_AccordionDetails[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_AccordionDetails[key];
        }
    });
});

var $91a4e72629291447$var$_AccordionSummary = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("6QcED")));
Object.keys($91a4e72629291447$var$_AccordionSummary).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_AccordionSummary[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_AccordionSummary[key];
        }
    });
});

var $91a4e72629291447$var$_Alert = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("16wD6")));
Object.keys($91a4e72629291447$var$_Alert).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Alert[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Alert[key];
        }
    });
});

var $91a4e72629291447$var$_AlertTitle = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("bkkWw")));
Object.keys($91a4e72629291447$var$_AlertTitle).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_AlertTitle[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_AlertTitle[key];
        }
    });
});

var $91a4e72629291447$var$_AppBar = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("kvdH6")));
Object.keys($91a4e72629291447$var$_AppBar).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_AppBar[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_AppBar[key];
        }
    });
});

var $91a4e72629291447$var$_Autocomplete = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("aBB4t")));
Object.keys($91a4e72629291447$var$_Autocomplete).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Autocomplete[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Autocomplete[key];
        }
    });
});

var $91a4e72629291447$var$_Avatar = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("kpeRy")));
Object.keys($91a4e72629291447$var$_Avatar).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Avatar[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Avatar[key];
        }
    });
});

var $91a4e72629291447$var$_AvatarGroup = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("aHDU0")));
Object.keys($91a4e72629291447$var$_AvatarGroup).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_AvatarGroup[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_AvatarGroup[key];
        }
    });
});

var $91a4e72629291447$var$_Backdrop = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("bXwVR")));
Object.keys($91a4e72629291447$var$_Backdrop).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Backdrop[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Backdrop[key];
        }
    });
});

var $91a4e72629291447$var$_Badge = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("lgIyK")));
Object.keys($91a4e72629291447$var$_Badge).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Badge[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Badge[key];
        }
    });
});

var $91a4e72629291447$var$_BottomNavigation = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("jIzBR")));
Object.keys($91a4e72629291447$var$_BottomNavigation).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_BottomNavigation[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_BottomNavigation[key];
        }
    });
});

var $91a4e72629291447$var$_BottomNavigationAction = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("e9QPA")));
Object.keys($91a4e72629291447$var$_BottomNavigationAction).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_BottomNavigationAction[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_BottomNavigationAction[key];
        }
    });
});

var $91a4e72629291447$var$_Box = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("e5o5x")));
Object.keys($91a4e72629291447$var$_Box).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Box[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Box[key];
        }
    });
});

var $91a4e72629291447$var$_Breadcrumbs = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("63l7x")));
Object.keys($91a4e72629291447$var$_Breadcrumbs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Breadcrumbs[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Breadcrumbs[key];
        }
    });
});

var $91a4e72629291447$var$_Button = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("bBQKz")));
Object.keys($91a4e72629291447$var$_Button).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Button[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Button[key];
        }
    });
});

var $91a4e72629291447$var$_ButtonBase = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("hhs3r")));
Object.keys($91a4e72629291447$var$_ButtonBase).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_ButtonBase[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_ButtonBase[key];
        }
    });
});

var $91a4e72629291447$var$_ButtonGroup = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("8Jh2o")));
Object.keys($91a4e72629291447$var$_ButtonGroup).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_ButtonGroup[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_ButtonGroup[key];
        }
    });
});

var $91a4e72629291447$var$_Card = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("3HHKi")));
Object.keys($91a4e72629291447$var$_Card).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Card[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Card[key];
        }
    });
});

var $91a4e72629291447$var$_CardActionArea = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("kIb8C")));
Object.keys($91a4e72629291447$var$_CardActionArea).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_CardActionArea[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_CardActionArea[key];
        }
    });
});

var $91a4e72629291447$var$_CardActions = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("Hi2UE")));
Object.keys($91a4e72629291447$var$_CardActions).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_CardActions[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_CardActions[key];
        }
    });
});

var $91a4e72629291447$var$_CardContent = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("lQHMI")));
Object.keys($91a4e72629291447$var$_CardContent).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_CardContent[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_CardContent[key];
        }
    });
});

var $91a4e72629291447$var$_CardHeader = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("4DqKh")));
Object.keys($91a4e72629291447$var$_CardHeader).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_CardHeader[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_CardHeader[key];
        }
    });
});

var $91a4e72629291447$var$_CardMedia = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("epQZV")));
Object.keys($91a4e72629291447$var$_CardMedia).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_CardMedia[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_CardMedia[key];
        }
    });
});

var $91a4e72629291447$var$_Checkbox = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("aGDqy")));
Object.keys($91a4e72629291447$var$_Checkbox).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Checkbox[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Checkbox[key];
        }
    });
});

var $91a4e72629291447$var$_Chip = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("6p5K7")));
Object.keys($91a4e72629291447$var$_Chip).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Chip[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Chip[key];
        }
    });
});

var $91a4e72629291447$var$_CircularProgress = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("1sBf1")));
Object.keys($91a4e72629291447$var$_CircularProgress).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_CircularProgress[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_CircularProgress[key];
        }
    });
});

var $91a4e72629291447$var$_ClickAwayListener = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("7Ke9B")));
Object.keys($91a4e72629291447$var$_ClickAwayListener).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_ClickAwayListener[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_ClickAwayListener[key];
        }
    });
});

var $91a4e72629291447$var$_Collapse = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("gsEuH")));
Object.keys($91a4e72629291447$var$_Collapse).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Collapse[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Collapse[key];
        }
    });
});

var $91a4e72629291447$var$_Container = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("9GQ55")));
Object.keys($91a4e72629291447$var$_Container).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Container[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Container[key];
        }
    });
});

var $91a4e72629291447$var$_CssBaseline = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("bl1Nj")));
Object.keys($91a4e72629291447$var$_CssBaseline).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_CssBaseline[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_CssBaseline[key];
        }
    });
});

var $91a4e72629291447$var$_darkScrollbar = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("4tB5n")));
Object.keys($91a4e72629291447$var$_darkScrollbar).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_darkScrollbar[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_darkScrollbar[key];
        }
    });
});

var $91a4e72629291447$var$_Dialog = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("iZIMH")));
Object.keys($91a4e72629291447$var$_Dialog).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Dialog[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Dialog[key];
        }
    });
});

var $91a4e72629291447$var$_DialogActions = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("l5BZB")));
Object.keys($91a4e72629291447$var$_DialogActions).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_DialogActions[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_DialogActions[key];
        }
    });
});

var $91a4e72629291447$var$_DialogContent = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("hJoSv")));
Object.keys($91a4e72629291447$var$_DialogContent).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_DialogContent[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_DialogContent[key];
        }
    });
});

var $91a4e72629291447$var$_DialogContentText = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("aX9Qs")));
Object.keys($91a4e72629291447$var$_DialogContentText).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_DialogContentText[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_DialogContentText[key];
        }
    });
});

var $91a4e72629291447$var$_DialogTitle = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("lIycJ")));
Object.keys($91a4e72629291447$var$_DialogTitle).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_DialogTitle[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_DialogTitle[key];
        }
    });
});

var $91a4e72629291447$var$_Divider = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("g6BeY")));
Object.keys($91a4e72629291447$var$_Divider).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Divider[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Divider[key];
        }
    });
});

var $91a4e72629291447$var$_Drawer = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("cPtMf")));
Object.keys($91a4e72629291447$var$_Drawer).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Drawer[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Drawer[key];
        }
    });
});

var $91a4e72629291447$var$_Fab = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("2r6m0")));
Object.keys($91a4e72629291447$var$_Fab).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Fab[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Fab[key];
        }
    });
});

var $91a4e72629291447$var$_Fade = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("5iZHj")));
Object.keys($91a4e72629291447$var$_Fade).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Fade[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Fade[key];
        }
    });
});

var $91a4e72629291447$var$_FilledInput = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("hE2RV")));
Object.keys($91a4e72629291447$var$_FilledInput).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_FilledInput[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_FilledInput[key];
        }
    });
});

var $91a4e72629291447$var$_FormControl = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("iA4iQ")));
Object.keys($91a4e72629291447$var$_FormControl).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_FormControl[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_FormControl[key];
        }
    });
});

var $91a4e72629291447$var$_FormControlLabel = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("i48ne")));
Object.keys($91a4e72629291447$var$_FormControlLabel).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_FormControlLabel[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_FormControlLabel[key];
        }
    });
});

var $91a4e72629291447$var$_FormGroup = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("buuiu")));
Object.keys($91a4e72629291447$var$_FormGroup).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_FormGroup[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_FormGroup[key];
        }
    });
});

var $91a4e72629291447$var$_FormHelperText = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("4xkW2")));
Object.keys($91a4e72629291447$var$_FormHelperText).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_FormHelperText[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_FormHelperText[key];
        }
    });
});

var $91a4e72629291447$var$_FormLabel = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("d7nZ1")));
Object.keys($91a4e72629291447$var$_FormLabel).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_FormLabel[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_FormLabel[key];
        }
    });
});

var $91a4e72629291447$var$_GridLegacy = $91a4e72629291447$require$_interopRequireDefault((parcelRequire("jNkhK")));

var $91a4e72629291447$var$_Grid = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("7Zchb")));
Object.keys($91a4e72629291447$var$_Grid).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Grid[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Grid[key];
        }
    });
});

var $91a4e72629291447$var$_Grow = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("6dJ4n")));
Object.keys($91a4e72629291447$var$_Grow).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Grow[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Grow[key];
        }
    });
});

var $91a4e72629291447$var$_Icon = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("3IKLG")));
Object.keys($91a4e72629291447$var$_Icon).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Icon[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Icon[key];
        }
    });
});

var $91a4e72629291447$var$_IconButton = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("825Zh")));
Object.keys($91a4e72629291447$var$_IconButton).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_IconButton[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_IconButton[key];
        }
    });
});

var $91a4e72629291447$var$_ImageList = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("dGTe0")));
Object.keys($91a4e72629291447$var$_ImageList).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_ImageList[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_ImageList[key];
        }
    });
});

var $91a4e72629291447$var$_ImageListItem = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("cJR6h")));
Object.keys($91a4e72629291447$var$_ImageListItem).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_ImageListItem[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_ImageListItem[key];
        }
    });
});

var $91a4e72629291447$var$_ImageListItemBar = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("2yXyU")));
Object.keys($91a4e72629291447$var$_ImageListItemBar).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_ImageListItemBar[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_ImageListItemBar[key];
        }
    });
});

var $91a4e72629291447$var$_Input = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("eAJp9")));
Object.keys($91a4e72629291447$var$_Input).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Input[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Input[key];
        }
    });
});

var $91a4e72629291447$var$_InputAdornment = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("9bswS")));
Object.keys($91a4e72629291447$var$_InputAdornment).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_InputAdornment[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_InputAdornment[key];
        }
    });
});

var $91a4e72629291447$var$_InputBase = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("9MvHs")));
Object.keys($91a4e72629291447$var$_InputBase).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_InputBase[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_InputBase[key];
        }
    });
});

var $91a4e72629291447$var$_InputLabel = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("k9xmz")));
Object.keys($91a4e72629291447$var$_InputLabel).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_InputLabel[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_InputLabel[key];
        }
    });
});

var $91a4e72629291447$var$_LinearProgress = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("2vsem")));
Object.keys($91a4e72629291447$var$_LinearProgress).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_LinearProgress[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_LinearProgress[key];
        }
    });
});

var $91a4e72629291447$var$_Link = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("fyPI4")));
Object.keys($91a4e72629291447$var$_Link).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Link[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Link[key];
        }
    });
});

var $91a4e72629291447$var$_List = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("ib3g2")));
Object.keys($91a4e72629291447$var$_List).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_List[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_List[key];
        }
    });
});

var $91a4e72629291447$var$_ListItem = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("hOLYA")));
Object.keys($91a4e72629291447$var$_ListItem).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_ListItem[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_ListItem[key];
        }
    });
});

var $91a4e72629291447$var$_ListItemAvatar = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("6HgAC")));
Object.keys($91a4e72629291447$var$_ListItemAvatar).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_ListItemAvatar[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_ListItemAvatar[key];
        }
    });
});

var $91a4e72629291447$var$_ListItemButton = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("iVzhN")));
Object.keys($91a4e72629291447$var$_ListItemButton).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_ListItemButton[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_ListItemButton[key];
        }
    });
});

var $91a4e72629291447$var$_ListItemIcon = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("2fe4K")));
Object.keys($91a4e72629291447$var$_ListItemIcon).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_ListItemIcon[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_ListItemIcon[key];
        }
    });
});

var $91a4e72629291447$var$_ListItemSecondaryAction = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("4LntB")));
Object.keys($91a4e72629291447$var$_ListItemSecondaryAction).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_ListItemSecondaryAction[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_ListItemSecondaryAction[key];
        }
    });
});

var $91a4e72629291447$var$_ListItemText = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("djLZl")));
Object.keys($91a4e72629291447$var$_ListItemText).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_ListItemText[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_ListItemText[key];
        }
    });
});

var $91a4e72629291447$var$_ListSubheader = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("1hfjF")));
Object.keys($91a4e72629291447$var$_ListSubheader).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_ListSubheader[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_ListSubheader[key];
        }
    });
});

var $91a4e72629291447$var$_Menu = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("kCnQI")));
Object.keys($91a4e72629291447$var$_Menu).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Menu[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Menu[key];
        }
    });
});

var $91a4e72629291447$var$_MenuItem = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("iZ4W7")));
Object.keys($91a4e72629291447$var$_MenuItem).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_MenuItem[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_MenuItem[key];
        }
    });
});

var $91a4e72629291447$var$_MenuList = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("8qqwQ")));
Object.keys($91a4e72629291447$var$_MenuList).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_MenuList[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_MenuList[key];
        }
    });
});

var $91a4e72629291447$var$_MobileStepper = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("1e1yc")));
Object.keys($91a4e72629291447$var$_MobileStepper).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_MobileStepper[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_MobileStepper[key];
        }
    });
});

var $91a4e72629291447$var$_Modal = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("8vVVd")));
Object.keys($91a4e72629291447$var$_Modal).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Modal[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Modal[key];
        }
    });
});

var $91a4e72629291447$var$_NativeSelect = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("24k8B")));
Object.keys($91a4e72629291447$var$_NativeSelect).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_NativeSelect[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_NativeSelect[key];
        }
    });
});

var $91a4e72629291447$var$_NoSsr = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("cQC3m")));
Object.keys($91a4e72629291447$var$_NoSsr).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_NoSsr[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_NoSsr[key];
        }
    });
});

var $91a4e72629291447$var$_OutlinedInput = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("in82R")));
Object.keys($91a4e72629291447$var$_OutlinedInput).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_OutlinedInput[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_OutlinedInput[key];
        }
    });
});

var $91a4e72629291447$var$_Pagination = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("lAj4Z")));
Object.keys($91a4e72629291447$var$_Pagination).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Pagination[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Pagination[key];
        }
    });
});

var $91a4e72629291447$var$_PaginationItem = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("5SUZl")));
Object.keys($91a4e72629291447$var$_PaginationItem).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_PaginationItem[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_PaginationItem[key];
        }
    });
});

var $91a4e72629291447$var$_Paper = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("juRJQ")));
Object.keys($91a4e72629291447$var$_Paper).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Paper[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Paper[key];
        }
    });
});

var $91a4e72629291447$var$_Popover = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("32yuL")));
Object.keys($91a4e72629291447$var$_Popover).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Popover[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Popover[key];
        }
    });
});

var $91a4e72629291447$var$_Popper = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("eWJe7")));
Object.keys($91a4e72629291447$var$_Popper).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Popper[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Popper[key];
        }
    });
});

var $91a4e72629291447$var$_Portal = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("cJgE8")));
Object.keys($91a4e72629291447$var$_Portal).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Portal[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Portal[key];
        }
    });
});

var $91a4e72629291447$var$_Radio = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("5Gk0e")));
Object.keys($91a4e72629291447$var$_Radio).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Radio[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Radio[key];
        }
    });
});

var $91a4e72629291447$var$_RadioGroup = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("31l3D")));
Object.keys($91a4e72629291447$var$_RadioGroup).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_RadioGroup[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_RadioGroup[key];
        }
    });
});

var $91a4e72629291447$var$_Rating = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("lNr9b")));
Object.keys($91a4e72629291447$var$_Rating).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Rating[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Rating[key];
        }
    });
});

var $91a4e72629291447$var$_ScopedCssBaseline = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("ePchM")));
Object.keys($91a4e72629291447$var$_ScopedCssBaseline).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_ScopedCssBaseline[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_ScopedCssBaseline[key];
        }
    });
});

var $91a4e72629291447$var$_Select = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("dALxx")));
Object.keys($91a4e72629291447$var$_Select).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Select[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Select[key];
        }
    });
});

var $91a4e72629291447$var$_Skeleton = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("eTbCT")));
Object.keys($91a4e72629291447$var$_Skeleton).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Skeleton[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Skeleton[key];
        }
    });
});

var $91a4e72629291447$var$_Slide = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("bQRpD")));
Object.keys($91a4e72629291447$var$_Slide).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Slide[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Slide[key];
        }
    });
});

var $91a4e72629291447$var$_Slider = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("1WNCH")));
Object.keys($91a4e72629291447$var$_Slider).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Slider[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Slider[key];
        }
    });
});

var $91a4e72629291447$var$_Snackbar = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("b3tNC")));
Object.keys($91a4e72629291447$var$_Snackbar).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Snackbar[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Snackbar[key];
        }
    });
});

var $91a4e72629291447$var$_SnackbarContent = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("8BKxX")));
Object.keys($91a4e72629291447$var$_SnackbarContent).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_SnackbarContent[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_SnackbarContent[key];
        }
    });
});

var $91a4e72629291447$var$_SpeedDial = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("kqAaP")));
Object.keys($91a4e72629291447$var$_SpeedDial).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_SpeedDial[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_SpeedDial[key];
        }
    });
});

var $91a4e72629291447$var$_SpeedDialAction = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("2Pq3d")));
Object.keys($91a4e72629291447$var$_SpeedDialAction).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_SpeedDialAction[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_SpeedDialAction[key];
        }
    });
});

var $91a4e72629291447$var$_SpeedDialIcon = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("6LxK9")));
Object.keys($91a4e72629291447$var$_SpeedDialIcon).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_SpeedDialIcon[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_SpeedDialIcon[key];
        }
    });
});

var $91a4e72629291447$var$_Stack = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("jkhql")));
Object.keys($91a4e72629291447$var$_Stack).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Stack[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Stack[key];
        }
    });
});

var $91a4e72629291447$var$_Step = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("fxSW4")));
Object.keys($91a4e72629291447$var$_Step).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Step[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Step[key];
        }
    });
});

var $91a4e72629291447$var$_StepButton = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("k1pY1")));
Object.keys($91a4e72629291447$var$_StepButton).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_StepButton[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_StepButton[key];
        }
    });
});

var $91a4e72629291447$var$_StepConnector = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("jjQoZ")));
Object.keys($91a4e72629291447$var$_StepConnector).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_StepConnector[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_StepConnector[key];
        }
    });
});

var $91a4e72629291447$var$_StepContent = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("b3U7M")));
Object.keys($91a4e72629291447$var$_StepContent).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_StepContent[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_StepContent[key];
        }
    });
});

var $91a4e72629291447$var$_StepIcon = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("2K1qt")));
Object.keys($91a4e72629291447$var$_StepIcon).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_StepIcon[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_StepIcon[key];
        }
    });
});

var $91a4e72629291447$var$_StepLabel = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("cD4Pq")));
Object.keys($91a4e72629291447$var$_StepLabel).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_StepLabel[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_StepLabel[key];
        }
    });
});

var $91a4e72629291447$var$_Stepper = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("5kBLW")));
Object.keys($91a4e72629291447$var$_Stepper).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Stepper[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Stepper[key];
        }
    });
});

var $91a4e72629291447$var$_SvgIcon = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("loOwp")));
Object.keys($91a4e72629291447$var$_SvgIcon).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_SvgIcon[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_SvgIcon[key];
        }
    });
});

var $91a4e72629291447$var$_SwipeableDrawer = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("fuux0")));
Object.keys($91a4e72629291447$var$_SwipeableDrawer).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_SwipeableDrawer[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_SwipeableDrawer[key];
        }
    });
});

var $91a4e72629291447$var$_Switch = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("5QQ7K")));
Object.keys($91a4e72629291447$var$_Switch).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Switch[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Switch[key];
        }
    });
});

var $91a4e72629291447$var$_Tab = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("90blG")));
Object.keys($91a4e72629291447$var$_Tab).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Tab[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Tab[key];
        }
    });
});

var $91a4e72629291447$var$_Table = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("bGe9g")));
Object.keys($91a4e72629291447$var$_Table).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Table[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Table[key];
        }
    });
});

var $91a4e72629291447$var$_TableBody = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("5hLrb")));
Object.keys($91a4e72629291447$var$_TableBody).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_TableBody[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_TableBody[key];
        }
    });
});

var $91a4e72629291447$var$_TableCell = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("hjoMW")));
Object.keys($91a4e72629291447$var$_TableCell).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_TableCell[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_TableCell[key];
        }
    });
});

var $91a4e72629291447$var$_TableContainer = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("12YAp")));
Object.keys($91a4e72629291447$var$_TableContainer).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_TableContainer[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_TableContainer[key];
        }
    });
});

var $91a4e72629291447$var$_TableFooter = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("7fYtl")));
Object.keys($91a4e72629291447$var$_TableFooter).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_TableFooter[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_TableFooter[key];
        }
    });
});

var $91a4e72629291447$var$_TableHead = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("g2Lhl")));
Object.keys($91a4e72629291447$var$_TableHead).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_TableHead[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_TableHead[key];
        }
    });
});

var $91a4e72629291447$var$_TablePagination = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("b3HhA")));
Object.keys($91a4e72629291447$var$_TablePagination).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_TablePagination[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_TablePagination[key];
        }
    });
});

var $91a4e72629291447$var$_TablePaginationActions = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("lqVz5")));
Object.keys($91a4e72629291447$var$_TablePaginationActions).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_TablePaginationActions[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_TablePaginationActions[key];
        }
    });
});

var $91a4e72629291447$var$_TableRow = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("7IILB")));
Object.keys($91a4e72629291447$var$_TableRow).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_TableRow[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_TableRow[key];
        }
    });
});

var $91a4e72629291447$var$_TableSortLabel = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("Zain6")));
Object.keys($91a4e72629291447$var$_TableSortLabel).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_TableSortLabel[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_TableSortLabel[key];
        }
    });
});

var $91a4e72629291447$var$_Tabs = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("dKcJh")));
Object.keys($91a4e72629291447$var$_Tabs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Tabs[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Tabs[key];
        }
    });
});

var $91a4e72629291447$var$_TabScrollButton = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("b1hEL")));
Object.keys($91a4e72629291447$var$_TabScrollButton).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_TabScrollButton[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_TabScrollButton[key];
        }
    });
});

var $91a4e72629291447$var$_TextField = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("hABDe")));
Object.keys($91a4e72629291447$var$_TextField).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_TextField[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_TextField[key];
        }
    });
});

var $91a4e72629291447$var$_TextareaAutosize = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("3vH0x")));
Object.keys($91a4e72629291447$var$_TextareaAutosize).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_TextareaAutosize[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_TextareaAutosize[key];
        }
    });
});

var $91a4e72629291447$var$_ToggleButton = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("xwCPt")));
Object.keys($91a4e72629291447$var$_ToggleButton).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_ToggleButton[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_ToggleButton[key];
        }
    });
});

var $91a4e72629291447$var$_ToggleButtonGroup = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("6GVj6")));
Object.keys($91a4e72629291447$var$_ToggleButtonGroup).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_ToggleButtonGroup[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_ToggleButtonGroup[key];
        }
    });
});

var $91a4e72629291447$var$_Toolbar = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("dfjP7")));
Object.keys($91a4e72629291447$var$_Toolbar).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Toolbar[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Toolbar[key];
        }
    });
});

var $91a4e72629291447$var$_Tooltip = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("tEWAm")));
Object.keys($91a4e72629291447$var$_Tooltip).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Tooltip[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Tooltip[key];
        }
    });
});

var $91a4e72629291447$var$_Typography = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("2dUd7")));
Object.keys($91a4e72629291447$var$_Typography).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Typography[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Typography[key];
        }
    });
});

var $91a4e72629291447$var$_useMediaQuery = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("18tt9")));
Object.keys($91a4e72629291447$var$_useMediaQuery).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_useMediaQuery[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_useMediaQuery[key];
        }
    });
});

var $91a4e72629291447$var$_usePagination = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("8WIPv")));
Object.keys($91a4e72629291447$var$_usePagination).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_usePagination[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_usePagination[key];
        }
    });
});

var $91a4e72629291447$var$_useScrollTrigger = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("dL2y2")));
Object.keys($91a4e72629291447$var$_useScrollTrigger).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_useScrollTrigger[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_useScrollTrigger[key];
        }
    });
});

var $91a4e72629291447$var$_Zoom = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("3uqi7")));
Object.keys($91a4e72629291447$var$_Zoom).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_Zoom[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Zoom[key];
        }
    });
});

var $91a4e72629291447$var$_useAutocomplete = $91a4e72629291447$require$_interopRequireDefault((parcelRequire("g924V")));

var $91a4e72629291447$var$_GlobalStyles = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("kjVW8")));
Object.keys($91a4e72629291447$var$_GlobalStyles).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_GlobalStyles[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_GlobalStyles[key];
        }
    });
});

var $91a4e72629291447$var$_composeClasses = $91a4e72629291447$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $91a4e72629291447$var$_generateUtilityClass = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("e9Nv0")));
Object.keys($91a4e72629291447$var$_generateUtilityClass).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $91a4e72629291447$var$_generateUtilityClass[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_generateUtilityClass[key];
        }
    });
});

var $91a4e72629291447$var$_generateUtilityClasses = $91a4e72629291447$require$_interopRequireDefault((parcelRequire("c2K5x")));

var $91a4e72629291447$var$_Unstable_TrapFocus = $91a4e72629291447$require$_interopRequireDefault((parcelRequire("c94Y8")));
var $acb29f90a3f05c5b$exports = {};
"use strict";
Object.defineProperty($acb29f90a3f05c5b$exports, "__esModule", {
    value: true
});
$acb29f90a3f05c5b$exports.version = $acb29f90a3f05c5b$exports.prerelease = $acb29f90a3f05c5b$exports.patch = $acb29f90a3f05c5b$exports.minor = $acb29f90a3f05c5b$exports.major = $acb29f90a3f05c5b$exports.default = void 0;
const $acb29f90a3f05c5b$var$version = $acb29f90a3f05c5b$exports.version = "7.3.11";
const $acb29f90a3f05c5b$var$major = $acb29f90a3f05c5b$exports.major = Number("7");
const $acb29f90a3f05c5b$var$minor = $acb29f90a3f05c5b$exports.minor = Number("3");
const $acb29f90a3f05c5b$var$patch = $acb29f90a3f05c5b$exports.patch = Number("11");
const $acb29f90a3f05c5b$var$prerelease = $acb29f90a3f05c5b$exports.prerelease = undefined;
var $acb29f90a3f05c5b$var$_default = $acb29f90a3f05c5b$exports.default = $acb29f90a3f05c5b$var$version;


Object.keys($acb29f90a3f05c5b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in $91a4e72629291447$exports && $91a4e72629291447$exports[key] === $acb29f90a3f05c5b$exports[key]) return;
    Object.defineProperty($91a4e72629291447$exports, key, {
        enumerable: true,
        get: function() {
            return $acb29f90a3f05c5b$exports[key];
        }
    });
});

var $91a4e72629291447$var$_InitColorSchemeScript = $91a4e72629291447$require$_interopRequireDefault((parcelRequire("2bNdG")));



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $dALxx = parcelRequire("dALxx");

const $13d8dceb097c825b$var$SelectCustomizationComponent = ({ componentType: componentType, components: components, selectedComponent: selectedComponent, margin: margin, vatRate: vatRate, currency: currency, onChange: onChange, showCosts: showCosts })=>{
    const [defaultComponent, setDefaultComponent] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [component, setComponent] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // NOTE: All hooks MUST be declared before any conditional early return,
    // otherwise React's hook-ordering invariants are violated and sibling
    // instances of this component may end up sharing state slots — which
    // manifested as "selecting a monitor also marks the keyboard as selected".
    // See: https://react.dev/reference/rules/rules-of-hooks
    (0, $acw62.useEffect)(()=>{
        if (!components || components.length === 0) {
            setDefaultComponent(null);
            setComponent(null);
            return;
        }
        const defaultComp = components.find((c)=>c.baseComponent) || null;
        setDefaultComponent(defaultComp);
        const findById = (id)=>id ? components.find((c)=>c.id === id) || null : null;
        setComponent(findById(selectedComponent?.id ?? null));
    }, [
        components,
        selectedComponent
    ]);
    if (!components || components.length === 0) return null;
    if (!components.some((c)=>c.optional)) return null;
    const isBaseComponent = (componentId)=>{
        if (null === componentId || componentId === "empty_option") return true;
        return defaultComponent?.id === componentId;
    };
    // API prices are differentials from the base component (Kotlin's
    // adjustComponentPricesUsingBaseComponentAsReference). price.value is
    // already the total differential PVP with VAT — includes quantity and
    // base subtraction. No quantity multiplication needed.
    const getCustomizationCost = (component)=>{
        if (!component) return 0;
        const sel = component.price.value || 0;
        const base = defaultComponent?.price?.value || 0;
        return (0, $1cec967d8d56bb4d$export$63ad841d70774900)(sel - base);
    };
    // PVP in the dropdown uses price.pvp_with_vat directly (total
    // differential with VAT and margin, matches aggregate header).
    // Keep getCustomizationCost as the Custo source; PVP derives from cost
    // via margin+vat for display, or falls back to raw pvp_with_vat diff.
    const getCustomizationPVP = (component)=>{
        if (!component) return 0;
        const sel = component.price?.pvp_with_vat ?? 0;
        const base = defaultComponent?.price?.pvp_with_vat ?? 0;
        return (0, $1cec967d8d56bb4d$export$63ad841d70774900)(sel - base);
    };
    const getCurrentCustomizationCost = ()=>{
        return getCustomizationCost(component);
    };
    const getCurrentCustomizationPVP = ()=>{
        return getCustomizationPVP(component);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
        className: "columns is-multiline component-list-item",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "column is-3 md:text-right text-gray-800 font-bold lg:text-xl pt-4",
                children: components[0]?.type ?? ""
            }),
            (components.length > 1 || components[0]?.optional) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dALxx))), {
                className: `not-printable w-full text-ellipsis z-0.9 ${components.length > 1 || components[0]?.optional ? "" : "is-hidden"}`,
                displayEmpty: true,
                value: selectedComponent?.id ?? "empty_option",
                slotProps: {
                    root: {
                        className: "text-xs column is-9 p-0"
                    },
                    input: {
                        className: "text-xs"
                    }
                },
                onChange: (event)=>onChange(event, componentType),
                children: components// ponytail: sort by catalog PVP for UI ordering (not reseller cost)
                .sort((a, b)=>(a?.price?.value || 0) - (b?.price?.value || 0)).map((option, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.MenuItem), {
                        value: option.id,
                        style: {
                            display: "block"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "text-gray-800 font-bold",
                                children: [
                                    option.quantity > 1 ? `${option.quantity} x ` : "",
                                    option.description
                                ]
                            }),
                            !isBaseComponent(option?.id ?? null) ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "float-right text-gray-400 text-xs",
                                children: getCustomizationPVP(option).toLocaleString("pt-PT", {
                                    style: "currency",
                                    currency: currency
                                })
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "float-right text-gray-400 text-xs",
                                children: "Base"
                            })
                        ]
                    }, index))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: `column is-9 text-left text-gray-400 text pt-4 force-print ${components.length > 1 || components[0]?.optional ? "is-hidden" : ""}`,
                children: components[0]?.description ?? ""
            }),
            !isBaseComponent(selectedComponent?.id ?? null) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "text column is-offset-3 is-3 font-bold text-red-400 cost",
                        children: [
                            (getCurrentCustomizationPVP() || 0) > 0 ? "+" : " ",
                            getCurrentCustomizationPVP().toLocaleString("pt-PT", {
                                style: "currency",
                                currency: currency
                            })
                        ]
                    }),
                    showCosts && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "text column is-offset-1 is-5 font-bold text-gray-400 reseller-cost",
                        children: [
                            "Custo: ",
                            (getCurrentCustomizationCost() || 0) > 0 ? "+" : " ",
                            getCurrentCustomizationCost().toLocaleString("pt-PT", {
                                style: "currency",
                                currency: currency
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $13d8dceb097c825b$export$2e2bcd8739ae039 = $13d8dceb097c825b$var$SelectCustomizationComponent;





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");





const $39b0f862602415b1$var$ProductComponentsDetail = ({ pcConfig: pcConfig })=>{
    const relevantComponentsOrder = (0, $cd93687958c8007e$export$b6cd510719465167).map((item)=>item[0]);
    const [componentDetails, setComponentDetails] = (0, $acw62.useState)({}); // Allow null
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    const [selectedComponent, setSelectedComponent] = (0, $acw62.useState)(null);
    const componentListRef = (0, $acw62.useRef)(null);
    const fetchComponentDetails = (0, $acw62.useCallback)(async (id)=>{
        try {
            const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).PRODUCTS + `/${id}`);
            if (response.status != 200) {
                console.warn(`Failed to fetch component details for ID ${id}: ${response.status} ${response.statusText}`);
                return null; // Return null on failure
            }
            return response.data;
        } catch (error) {
            console.warn(`Error fetching component details for ID ${id}:`, error);
            return null; // Return null on error
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        const fetchAllComponents = async ()=>{
            setLoading(true);
            setError(null);
            try {
                const fetchedComponentDetails = {};
                await Promise.all(Object.entries(pcConfig.selected_components ?? {}).map(async ([key, value])=>{
                    const component = pcConfig.components[key].find((c)=>c.id === value?.id);
                    if (component?.id) {
                        const details = await fetchComponentDetails(component.reference);
                        fetchedComponentDetails[key] = details ? {
                            ...details,
                            type: pcConfig.components[key][0].type
                        } : null;
                    }
                }));
                const orderedComponentDetails = relevantComponentsOrder.reduce((acc, key)=>{
                    if (fetchedComponentDetails[key]) acc[key] = fetchedComponentDetails[key];
                    return acc;
                }, {});
                Object.entries(fetchedComponentDetails).forEach(([key, value])=>{
                    if (!relevantComponentsOrder.includes(key)) orderedComponentDetails[key] = value;
                });
                setComponentDetails(orderedComponentDetails);
                setSelectedComponent(Object.keys(orderedComponentDetails)[0] || null);
            } catch (error) {
                setError(error instanceof Error ? error.message : "An unexpected error occurred");
            } finally{
                setLoading(false);
            }
        };
        fetchAllComponents();
    }, [
        pcConfig,
        fetchComponentDetails
    ]);
    const handleComponentClick = (key)=>{
        setSelectedComponent(key);
        if (componentListRef.current) componentListRef.current.scrollTop = 0;
    };
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $22a8d83556d91eb0$export$2e2bcd8739ae039), {});
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ca40d139217d071$export$2e2bcd8739ae039), {
        message: error
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "components-details-view flex flex-col md:flex-row gap-4 overflow-y-auto",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "components-list w-full md:w-1/4",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                    ref: componentListRef,
                    className: "space-y-2 relative",
                    children: Object.entries(componentDetails).map(([key, component])=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                            className: `component-item cursor-pointer p-2 rounded hover:text-red-500 ${selectedComponent === key ? "bg-blue-100 border-2 border-blue-500" : ""}`,
                            onClick: ()=>handleComponentClick(key),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "component-name pb-2 font-semibold",
                                children: component?.type || key
                            })
                        }, key))
                })
            }),
            selectedComponent && componentDetails[selectedComponent] ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                id: "component-detail",
                className: "component-detail content w-full md:w-3/4 p-5 bg-white rounded-lg shadow-md",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        className: "component-title font-extrabold text-3xl mb-4",
                        children: componentDetails[selectedComponent]?.name || "Component Details"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex flex-col md:flex-row gap-4",
                        children: [
                            " ",
                            componentDetails[selectedComponent]?.image && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "component-image mb-4 w-full md:w-1/3",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e87b4633e3445bd$export$2e2bcd8739ae039), {
                                    src: `https://placehold.co/500x500/B3B1A9/000000?text=${componentDetails[selectedComponent]?.name ?? "Component Image"}`,
                                    dataSrc: componentDetails[selectedComponent]?.image,
                                    loading: "progressive",
                                    alt: componentDetails[selectedComponent]?.name || "Component Image",
                                    sizes: "500",
                                    className: "max-w-full h-auto rounded-md"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "component-highlights w-full md:w-2/3",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                    className: "list-disc list-inside",
                                    children: componentDetails[selectedComponent]?.highlights.map((highlight, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            children: highlight
                                        }, index))
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "component-description mt-4",
                        children: [
                            componentDetails[selectedComponent]?.description || "No description available.",
                            componentDetails[selectedComponent]?.features && /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                className: "mt-4",
                                children: componentDetails[selectedComponent]?.features.map((feature, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("strong", {
                                                className: "font-semibold",
                                                children: [
                                                    feature.name,
                                                    ":"
                                                ]
                                            }),
                                            " ",
                                            feature.value
                                        ]
                                    }, index))
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "mt-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                        className: "font-semibold",
                                        children: "Stock:"
                                    }),
                                    " ",
                                    componentDetails[selectedComponent]?.stock || "N/A"
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "component-detail content w-full md:w-3/4 p-5 bg-white rounded-lg shadow-md",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    children: "Select a component to view its details."
                })
            })
        ]
    });
};
var $39b0f862602415b1$export$2e2bcd8739ae039 = $39b0f862602415b1$var$ProductComponentsDetail;







var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
// Derive the widget CDN base from the API URL: replace /api/v1 suffix with /widget/v1.
// Falls back to the tst URL so local dev without .env still works.
const $4160262678d76153$var$API_URL = "https://api.tst.carreira.cloud/reviews/api/v1";
const $4160262678d76153$var$WIDGET_BASE = $4160262678d76153$var$API_URL.replace(/\/api\/v1$/, "/widget/v1");
function $4160262678d76153$var$loadWidgetAssets() {
    return new Promise((resolve)=>{
        const cssId = "reviews-widget-css";
        const jsId = "reviews-widget-js";
        if (!document.getElementById(cssId)) {
            const link = document.createElement("link");
            link.id = cssId;
            link.rel = "stylesheet";
            link.href = `${$4160262678d76153$var$WIDGET_BASE}/reviews-widget.css`;
            document.head.appendChild(link);
        }
        if (document.getElementById(jsId)) {
            resolve();
            return;
        }
        const script = document.createElement("script");
        script.id = jsId;
        script.src = `${$4160262678d76153$var$WIDGET_BASE}/reviews-widget.js`;
        script.onload = ()=>resolve();
        document.head.appendChild(script);
    });
}
const $4160262678d76153$var$ReviewsWidget = ({ entityId: entityId, entityType: entityType, customerName: customerName, customerEmail: customerEmail, authToken: authToken, locale: locale = "pt" })=>{
    const containerRef = (0, $acw62.useRef)(null);
    const apiGwKey = "ak_a85c88b070aa3b7ee132de0c2d77aadb47221331dc86cf6c";
    (0, $acw62.useEffect)(()=>{
        $4160262678d76153$var$loadWidgetAssets().then(()=>{
            if (containerRef.current && window.ReviewsWidget) window.ReviewsWidget.init({
                apiKey: apiGwKey,
                apiUrl: $4160262678d76153$var$API_URL,
                container: containerRef.current,
                entityId: entityId,
                entityType: entityType,
                customerName: customerName,
                customerEmail: customerEmail,
                authToken: authToken,
                locale: locale,
                allowSubmit: true,
                showStats: true
            });
        });
    }, [
        entityId,
        entityType,
        customerName,
        customerEmail,
        authToken,
        locale
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        ref: containerRef,
        id: "reviews-widget",
        className: "mt-8"
    });
};
var $4160262678d76153$export$2e2bcd8739ae039 = $4160262678d76153$var$ReviewsWidget;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $81ceca20bfa327e1$var$PriceDisplayResellerView = ({ compound: compound, currency: currency, customizationPrice: customizationPrice, previousResellerPrice: previousResellerPrice, basePricePVPInput: basePricePVPInput, customizationPricePVPInput: customizationPricePVPInput, handleManualEdit: handleManualEdit, handleAutomaticEdit: handleAutomaticEdit, handleBasePriceChange: handleBasePriceChange, handleCustomizationPriceChange: handleCustomizationPriceChange, hasCustomization: hasCustomization, allowEditPrices: allowEditPrices, showCostPrice: showCostPrice })=>{
    const promoPrice = compound.price.promotional_pvp_with_vat;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            promoPrice != null && promoPrice > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bg-green-100 border border-green-300 rounded-lg px-3 py-2 mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "text-sm font-medium text-green-800",
                        children: [
                            "\uD83C\uDFF7\uFE0F Pre\xe7o Promocional:",
                            " ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "font-bold",
                                children: promoPrice.toLocaleString("pt-PT", {
                                    style: "currency",
                                    currency: currency
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "text-xs text-gray-500 ml-2 line-through",
                        children: [
                            "(",
                            compound.price.value.toLocaleString("pt-PT", {
                                style: "currency",
                                currency: currency
                            }),
                            ")"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "text-red-400 is-display-block font-extrabold w-[450px]",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "",
                        children: "Configura\xe7\xe3o base:"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex is-inline-flex float-end",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                id: "base-price-input",
                                type: "number",
                                style: {
                                    width: "120px"
                                },
                                className: "text-right px-2 cursor-text hover:text-red-600 focus:text-red-600 focus:outline-none",
                                step: 0.01,
                                min: compound.price.resell ?? 0,
                                onFocus: handleManualEdit,
                                onBlur: handleAutomaticEdit,
                                value: basePricePVPInput,
                                onChange: handleBasePriceChange,
                                readOnly: !allowEditPrices
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    marginLeft: 4
                                },
                                children: compound.price.currency || currency
                            })
                        ]
                    })
                ]
            }),
            hasCustomization() && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "text-red-400 is-display-block font-extrabold w-[450px]",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "",
                        children: " Valor com os opcionais:"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex is-inline-flex float-end",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                id: "customization-price-input",
                                type: "number",
                                style: {
                                    width: "120px"
                                },
                                className: "text-right px-2 cursor-text hover:text-red-600 focus:text-red-600 focus:outline-none",
                                step: 0.01,
                                onFocus: handleManualEdit,
                                onBlur: handleAutomaticEdit,
                                value: customizationPricePVPInput,
                                onChange: handleCustomizationPriceChange,
                                readOnly: !allowEditPrices
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    marginLeft: 4
                                },
                                children: compound.price.currency || currency
                            })
                        ]
                    })
                ]
            }),
            showCostPrice && customizationPrice && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                className: "text-sm font-bold text-gray-400 reseller-cost not-printable",
                children: [
                    "Custo:",
                    " ",
                    customizationPrice.toLocaleString("pt-PT", {
                        // Use finalPrice here
                        style: "currency",
                        currency: currency
                    }),
                    " ",
                    "(sem IVA)",
                    previousResellerPrice != null && previousResellerPrice > customizationPrice && /*#__PURE__*/ (0, $ayMG0.jsx)("del", {
                        className: "ml-2 text-xs",
                        title: "Pre\xe7o anterior",
                        children: previousResellerPrice.toLocaleString("pt-PT", {
                            style: "currency",
                            currency: currency
                        })
                    })
                ]
            })
        ]
    });
};
var $81ceca20bfa327e1$export$2e2bcd8739ae039 = $81ceca20bfa327e1$var$PriceDisplayResellerView;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $4b0d0a3610d874cb$var$PriceDisplayCommercialView = ({ compound: compound, currency: currency, customizationPrice: customizationPrice, previousResellerPrice: previousResellerPrice, basePricePVPInput: basePricePVPInput, customizationPricePVPInput: customizationPricePVPInput, handleManualEdit: handleManualEdit, handleAutomaticEdit: handleAutomaticEdit, handleBasePriceChange: handleBasePriceChange, handleCustomizationPriceChange: handleCustomizationPriceChange, hasCustomization: hasCustomization, allowEditPrices: allowEditPrices })=>{
    const promoPrice = compound.price.promotional_pvp_with_vat;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            promoPrice != null && promoPrice > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bg-green-100 border border-green-300 rounded-lg px-3 py-2 mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "text-sm font-medium text-green-800",
                        children: [
                            "\uD83C\uDFF7\uFE0F Pre\xe7o Promocional:",
                            " ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "font-bold",
                                children: promoPrice.toLocaleString("pt-PT", {
                                    style: "currency",
                                    currency: currency
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "text-xs text-gray-500 ml-2 line-through",
                        children: [
                            "(",
                            compound.price.value.toLocaleString("pt-PT", {
                                style: "currency",
                                currency: currency
                            }),
                            ")"
                        ]
                    })
                ]
            }),
            customizationPrice && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid-cols-5 gap-2 font-extrabold  text-red-400 mb-10",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "row-span-2 w-max whitespace-nowrap",
                        children: "Pre\xe7o Revenda:"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "col-span-4",
                        children: [
                            customizationPrice.toLocaleString("pt-PT", {
                                style: "currency",
                                currency: currency
                            }),
                            " ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "text-xs",
                                children: "(IVA n\xe3o inclu\xeddo)"
                            }),
                            previousResellerPrice != null && previousResellerPrice > customizationPrice && /*#__PURE__*/ (0, $ayMG0.jsx)("del", {
                                className: "ml-2 text-xs",
                                title: "Pre\xe7o anterior",
                                children: previousResellerPrice.toLocaleString("pt-PT", {
                                    style: "currency",
                                    currency: currency
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "col-span-4",
                        children: [
                            (customizationPrice * (1 + compound.price.vat_rate)).toLocaleString("pt-PT", {
                                style: "currency",
                                currency: currency
                            }),
                            " ",
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "text-xs",
                                children: [
                                    "(IVA inclu\xeddo, taxa de ",
                                    compound.price.vat_rate * 100,
                                    "% aplicada)"
                                ]
                            })
                        ]
                    })
                ]
            }),
            compound.price.value && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "text-sm font-bold text-gray-400  is-display-block w-[450px]",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "",
                        children: "PVP recomendado (configura\xe7\xe3o base):"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex is-inline-flex float-end",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                id: "base-price-input",
                                type: "number",
                                style: {
                                    width: "120px"
                                },
                                className: "text-right px-2 cursor-text hover:text-gray-600 focus:text-gray-600 focus:outline-none",
                                step: 0.01,
                                onFocus: handleManualEdit,
                                onBlur: handleAutomaticEdit,
                                value: basePricePVPInput,
                                onChange: handleBasePriceChange,
                                readOnly: !allowEditPrices
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    marginLeft: 0
                                },
                                children: "\u20AC"
                            })
                        ]
                    })
                ]
            }),
            hasCustomization() && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "text-sm font-bold text-gray-400 is-display-block w-[450px]",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "",
                        children: "PVP com os opcionais:"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex is-inline-flex float-end",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                id: "customization-price-input",
                                type: "number",
                                style: {
                                    width: "120px"
                                },
                                className: "text-right px-2 cursor-text hover:text-gray-600 focus:text-gray-600 focus:outline-none",
                                step: 0.01,
                                onFocus: handleManualEdit,
                                onBlur: handleAutomaticEdit,
                                value: customizationPricePVPInput,
                                onChange: handleCustomizationPriceChange,
                                readOnly: !allowEditPrices
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    marginLeft: 0
                                },
                                children: "\u20AC"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $4b0d0a3610d874cb$export$2e2bcd8739ae039 = $4b0d0a3610d874cb$var$PriceDisplayCommercialView;




const $ccaa2522ab1042a6$var$CompoundDetailPage = ()=>{
    const { id: id } = (0, $585f8bce88e531c1$export$99eaa27ddbbb95ef)();
    const { pathname: pathname } = (0, $585f8bce88e531c1$export$45d76561a5302f2b)();
    const navigate = (0, $585f8bce88e531c1$export$9770f232ac06a008)();
    const { isAuthenticated: isAuthenticated } = (0, $b622ef53e38024e7$export$1d39dc5b47e56ff0)();
    const { tasks: tasks, userSettings: userSettings, setUserSettings: setUserSettings, systemError: systemError, setSystemError: setSystemError, loading: loading, setLoading: setLoading, error: error, setError: setError, success: success, setSuccess: setSuccess, modalScreen: modalScreen, setModalScreen: setModalScreen } = (0, $a55f2a94cd420149$export$c50e37a2f0a2b064)();
    const [compound, setCompound] = (0, $acw62.useState)(null);
    const [initialMargin, setInitialMargin] = (0, $acw62.useState)(0);
    const isAtInitialMargin = (value)=>Math.abs(value - initialMargin) < 0.05;
    const [margin, setMargin] = (0, $acw62.useState)(null);
    const [customizationPrice, setCustomizationPrice] = (0, $acw62.useState)(0);
    const [basePricePVPInput, setBasePricePVPInput] = (0, $acw62.useState)(0);
    const [customizationPricePVPInput, setCustomizationPricePVPInput] = (0, $acw62.useState)(0);
    const [manualPriceEdit, setManualPriceEdit] = (0, $acw62.useState)(false);
    const [currentOffer, setCurrentOffer] = (0, $acw62.useState)(null);
    const round2 = (n)=>Math.round(n * 100) / 100;
    (0, $acw62.useEffect)(()=>{
        if (!isAuthenticated()) navigate("/login", {
            state: {
                from: pathname
            }
        });
        if (id) fetchPCDetails(id);
    }, [
        isAuthenticated(),
        navigate,
        pathname,
        id
    ]);
    const fetchPCDetails = (0, $acw62.useCallback)(async (id)=>{
        setError(null);
        setLoading(true);
        (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).CATALOG + `/${encodeURIComponent(id)}`).then((result)=>{
            if (result.data) {
                const compoundData = {
                    ...result.data
                };
                // Normalize selected_components costs to deltas against their base
                // component — the API returns full reseller prices, but
                // getCurrentConfigurationResellerPrice adds them on top of the
                // (possibly promotional) base reseller price, causing double-counting.
                const normalizedSelected = {};
                Object.entries(compoundData.selected_components || {}).forEach(([type, entry])=>{
                    if (!entry) return;
                    const componentsForType = compoundData.components?.[type];
                    if (!componentsForType) return; // skip keys not in catalog
                    const selected = componentsForType?.find((c)=>c.id === entry.id);
                    if (!selected) console.warn(`[CompoundDetail] fetchPCDetails: component ${entry.id} (type ${type}) not found in catalog \u{2014} delta set to 0`);
                    normalizedSelected[type] = {
                        id: entry.id,
                        cost: (0, $1cec967d8d56bb4d$export$a2cc5fc5ea7ea67b)(componentsForType, selected)
                    };
                });
                compoundData.selected_components = normalizedSelected;
                const initialMarginPercentage = (0, $1cec967d8d56bb4d$export$f728be4ab20cbf1f)((0, $1cec967d8d56bb4d$export$d0fa95c6a6348eca)(compoundData) * 10000) / 100;
                setCompound(compoundData);
                setInitialMargin(initialMarginPercentage);
                setCustomizationPrice((0, $1cec967d8d56bb4d$export$2274474197183b21)(compoundData));
                setMargin(initialMarginPercentage);
            }
        }).catch((err)=>{
            setError(err.message || "An error occurred while fetching PC details.");
            console.warn(err);
        }).finally(()=>setLoading(false));
    }, [
        setError,
        setLoading
    ]);
    const createOfferProposalInstance = (0, $acw62.useCallback)(()=>{
        if (!compound) {
            setError("Detalhes da configura\xe7\xe3o ou proposta n\xe3o dispon\xedveis.");
            return null;
        }
        const offerMargin = typeof margin === "number" && Number.isFinite(margin) ? margin : null;
        const effectiveMargin = offerMargin ?? initialMargin;
        const adjustedBase = !isAtInitialMargin(effectiveMargin) ? (0, $1cec967d8d56bb4d$export$8c4251099de346b0)(compound, effectiveMargin) : (0, $1cec967d8d56bb4d$export$5aa74e344e478425)(compound);
        // Customizations are priced at the catalog PVP delta (matches the
        // storefront); only the base compound reacts to the margin slider.
        const upgradeDelta = (0, $1cec967d8d56bb4d$export$89ef2f2a3b3c42de)(compound);
        const adjustedValue = adjustedBase + upgradeDelta;
        return {
            client_type: "end_customer",
            client: {
                name: "",
                email: "",
                phone: "",
                address: "",
                city: "",
                zip_code: "",
                vat: ""
            },
            notes: [],
            compound: {
                id: compound.id,
                name: compound.name,
                price: {
                    value: adjustedValue,
                    resell: (0, $1cec967d8d56bb4d$export$2274474197183b21)(compound),
                    margin: offerMargin,
                    without_vat: adjustedValue / (1 + compound.price.vat_rate),
                    currency: compound.price.currency,
                    vat_rate: compound.price.vat_rate,
                    cost: (0, $1cec967d8d56bb4d$export$2274474197183b21)(compound)
                },
                components: compound.components,
                selected_components: compound.selected_components
            },
            status: "in_progress"
        };
    }, [
        compound,
        margin,
        initialMargin,
        setError
    ]);
    const updateOfferProposal = (0, $acw62.useCallback)(()=>{
        if (!compound || !currentOffer) {
            setError("Detalhes da configura\xe7\xe3o ou proposta n\xe3o dispon\xedveis.");
            return null;
        }
        const offerMargin = typeof margin === "number" && Number.isFinite(margin) ? margin : null;
        const effectiveMargin = offerMargin ?? initialMargin;
        const adjustedBase = !isAtInitialMargin(effectiveMargin) ? (0, $1cec967d8d56bb4d$export$8c4251099de346b0)(compound, effectiveMargin) : (0, $1cec967d8d56bb4d$export$5aa74e344e478425)(compound);
        // Customizations are priced at the catalog PVP delta (matches the
        // storefront); only the base compound reacts to the margin slider.
        const upgradeDelta = (0, $1cec967d8d56bb4d$export$89ef2f2a3b3c42de)(compound);
        const adjustedValue = adjustedBase + upgradeDelta;
        return {
            ...currentOffer,
            compound: {
                id: compound.id,
                price: {
                    value: adjustedValue,
                    resell: (0, $1cec967d8d56bb4d$export$2274474197183b21)(compound),
                    margin: offerMargin,
                    without_vat: adjustedValue / (1 + compound.price.vat_rate),
                    currency: compound.price.currency,
                    vat_rate: compound.price.vat_rate,
                    cost: (0, $1cec967d8d56bb4d$export$2274474197183b21)(compound)
                },
                components: compound.components,
                selected_components: compound.selected_components
            }
        };
    }, [
        compound,
        margin,
        initialMargin,
        currentOffer,
        setError
    ]);
    const hasCustomization = ()=>{
        return Object.values(compound?.components ?? {}).some((components)=>components.some((c)=>c.selected && !c.baseComponent && c.id !== "empty_option"));
    };
    (0, $acw62.useEffect)(()=>{
        if (manualPriceEdit) {
            console.warn("Manual price edit is enabled, skipping price update using margin calculations.");
            return;
        }
        if (!compound) {
            console.warn("PC data is not available, using initial values.");
            setBasePricePVPInput(0);
            setCustomizationPricePVPInput(0);
            return;
        }
        // Fallback to initialMargin when margin is 0/NaN so that the price effect
        // always runs. Previously `if (!margin) return;` left the displayed PVP
        // stale whenever margin was unset, which masked option-selection changes.
        const effectiveMargin = margin ?? initialMargin;
        setCustomizationPrice((0, $1cec967d8d56bb4d$export$2274474197183b21)(compound));
        // Campaign-aware margin: the base PVP derives from the promotional
        // reseller price, so no extra promo ratio is applied on top.
        const promoAdjustedBase = !isAtInitialMargin(effectiveMargin) ? (0, $1cec967d8d56bb4d$export$8c4251099de346b0)(compound, effectiveMargin) : (0, $1cec967d8d56bb4d$export$5aa74e344e478425)(compound);
        setBasePricePVPInput(round2(promoAdjustedBase));
        // Customizations are priced at the catalog PVP delta exactly like the
        // storefront (lib/storefront/compound.ts), independent of the margin slider.
        const upgradeDelta = (0, $1cec967d8d56bb4d$export$89ef2f2a3b3c42de)(compound);
        if (hasCustomization()) setCustomizationPricePVPInput(round2(promoAdjustedBase + upgradeDelta));
        else setCustomizationPricePVPInput(0);
    }, [
        margin,
        compound,
        initialMargin,
        manualPriceEdit
    ]);
    const handleSliderChange = (_, newValue)=>{
        if (manualPriceEdit) return;
        const min = Math.min(0.1, initialMargin);
        if (newValue < min || newValue > 99.9) {
            setError(`Margin must be between ${min} and 99.9.`);
            return;
        }
        if (isNaN(newValue)) {
            setError("Invalid margin value.");
            return;
        }
        setMargin(newValue);
    };
    const handleChangeComponent = (event, componentType)=>{
        setCompound((prev)=>{
            if (!prev) return null;
            const selectedValue = event.target.value;
            const updatedComponents = prev.components[componentType].map((c)=>c.id === selectedValue ? {
                    ...c,
                    selected: true
                } : {
                    ...c,
                    selected: false
                });
            const selectedComponent = prev.components[componentType].find((c)=>c.id === selectedValue);
            // Cost stored in selected_components must be the reseller delta
            // against the base component (no VAT) — getCurrentConfigurationResellerPrice
            // starts from the (possibly promotional) base reseller price (also no VAT)
            // and sums these deltas.
            // Previously we stored price.value (PVP with VAT), mixing units and
            // double-counting the base component.
            const deltaCost = (0, $1cec967d8d56bb4d$export$a2cc5fc5ea7ea67b)(prev.components[componentType], selectedComponent);
            const newSelectedComponents = {
                ...prev.selected_components
            };
            if (selectedComponent && selectedValue !== "empty_option") newSelectedComponents[componentType] = {
                id: selectedValue,
                cost: deltaCost
            };
            else delete newSelectedComponents[componentType];
            return {
                ...prev,
                components: {
                    ...prev.components,
                    [componentType]: updatedComponents
                },
                selected_components: newSelectedComponents
            };
        });
    };
    const handleShowFullDetails = (0, $acw62.useCallback)(()=>{
        if (!compound) {
            setError("Detalhes da configura\xe7\xe3o n\xe3o dispon\xedveis.");
            return;
        }
        setModalScreen({
            state: "big-view",
            title: "Detalhes da Configura\xe7\xe3o",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $39b0f862602415b1$export$2e2bcd8739ae039), {
                pcConfig: compound
            }),
            onClose: ()=>{
                setModalScreen(null);
            }
        });
    }, [
        compound,
        setError,
        setModalScreen
    ]);
    const handleShowCreateProposal = (0, $acw62.useCallback)(()=>{
        if (!compound) {
            setError("Detalhes da configura\xe7\xe3o n\xe3o dispon\xedveis.");
            return;
        }
        const newProposal = createOfferProposalInstance();
        if (!newProposal) {
            setError("N\xe3o foi poss\xedvel criar a proposta. Verifique os dados da configura\xe7\xe3o.");
            return;
        }
        setModalScreen({
            state: "edit",
            title: `Criar Proposta: ${newProposal.compound.id}`,
            childrenControlOverflow: true,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cf6f80a8b90b7901$export$2e2bcd8739ae039), {
                offer: newProposal,
                initialUpdatedOffer: false
            }),
            onClose: ()=>{
                setModalScreen(null);
            }
        });
    }, [
        setError,
        setModalScreen,
        compound,
        createOfferProposalInstance
    ]);
    const handleShowUpdateProposal = (0, $acw62.useCallback)(()=>{
        if (!compound || !currentOffer) {
            setError("Detalhes da configura\xe7\xe3o ou proposta n\xe3o dispon\xedveis.");
            return;
        }
        const updatedProposal = updateOfferProposal();
        if (!updatedProposal) {
            setError("N\xe3o foi poss\xedvel atualizar a proposta. Verifique os dados da configura\xe7\xe3o.");
            return;
        }
        setModalScreen({
            state: "edit",
            title: `Alterar Proposta: #${updatedProposal.external_id}`,
            childrenControlOverflow: true,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cf6f80a8b90b7901$export$2e2bcd8739ae039), {
                offer: updatedProposal,
                initialUpdatedOffer: true
            }),
            onClose: ()=>{
                setModalScreen(null);
            }
        });
        setCurrentOffer(null); // Clear current offer after showing the modal
    }, [
        setError,
        setModalScreen,
        compound,
        currentOffer,
        updateOfferProposal
    ]);
    const handleBasePriceChange = (event)=>{
        if (!compound) return;
        if (manualPriceEdit) {
            const value = parseFloat(event.target.value);
            if (isNaN(value) || value <= 0) {
                setError("Base price must be a positive number.");
                return;
            }
            setBasePricePVPInput(value);
            const newMargin = (0, $1cec967d8d56bb4d$export$54f7b4b156bb5661)(compound, value);
            setMargin(newMargin);
            console.log("new margin: ", newMargin);
        }
        event.preventDefault();
    };
    const handleCustomizationPriceChange = (event)=>{
        if (!compound) return;
        if (manualPriceEdit) {
            const value = parseFloat(event.target.value);
            if (isNaN(value) || value <= 0) {
                setError("Customization price must be a positive number.");
                return;
            }
            setCustomizationPricePVPInput(value);
            const newMargin = (0, $1cec967d8d56bb4d$export$55530814c1a6ecfc)(compound, value);
            setMargin(Math.round(newMargin * 10000) / 100);
        }
        event.preventDefault();
    };
    const handleManualEdit = (event)=>{
        event.preventDefault();
        console.log("Manual price edit enabled");
        setManualPriceEdit(true);
    };
    const handleAutomaticEdit = (event)=>{
        event.preventDefault();
        if (margin != null && margin < Math.min(initialMargin, 0) - 0.01) {
            console.warn("Margin is negative, cannot reset prices.");
            alert("A margem n\xe3o pode ser inferior \xe0 margem da campanha, alterado para o valor inicial.");
            setMargin(initialMargin);
        }
        console.log("Manual price edit disabled");
        setManualPriceEdit(false);
        if (!compound || margin === null) {
            console.warn("PC data or margin is not available, cannot reset prices.");
            return;
        }
        const effectiveMargin = margin ?? initialMargin;
        // Customizations are priced at the catalog PVP delta (matches the
        // storefront); only the base compound reacts to the margin slider.
        const autoUpgradeDelta = (0, $1cec967d8d56bb4d$export$89ef2f2a3b3c42de)(compound);
        const autoPromoBase = !isAtInitialMargin(effectiveMargin) ? (0, $1cec967d8d56bb4d$export$8c4251099de346b0)(compound, effectiveMargin) : (0, $1cec967d8d56bb4d$export$5aa74e344e478425)(compound);
        setBasePricePVPInput(round2(autoPromoBase));
        if (hasCustomization()) setCustomizationPricePVPInput(round2(autoPromoBase + autoUpgradeDelta));
        else setCustomizationPricePVPInput(0);
    };
    (0, $acw62.useEffect)(()=>{
        if (tasks.length > 0) {
            const changeOffersTasks = tasks.filter((t)=>t.taskType === "offer::change");
            if (changeOffersTasks.length > 0) {
                const openTaskProposalToCompound = changeOffersTasks.find((t)=>t.getContext().offerProposal.compound.id === compound?.id);
                if (openTaskProposalToCompound) {
                    setCurrentOffer(openTaskProposalToCompound.getContext().offerProposal);
                    const offerCompound = openTaskProposalToCompound.getContext().offerProposal.compound;
                    const newVersion = {
                        ...compound,
                        selected_components: Object.entries(offerCompound.selected_components || {}).reduce((acc, [key, value])=>{
                            // @ts-ignore
                            if (value && typeof value.id === "string") //@ts-ignore
                            acc[key] = {
                                ...value,
                                id: value.id
                            };
                            return acc;
                        }, {})
                    };
                    // Normalize offer's selected_components costs to deltas against
                    // the base component — the offer API returns full reseller prices
                    // but getCurrentConfigurationResellerPrice expects deltas.
                    // The offer API may include display-name keys (e.g. "Processador")
                    // alongside snake_case keys — skip anything not in the catalog.
                    const normalizedSelected = {};
                    Object.entries(newVersion.selected_components || {}).forEach(([type, entry])=>{
                        if (!entry) return;
                        const componentsForType = newVersion.components?.[type];
                        if (!componentsForType) return; // skip display-name duplicates
                        const selected = componentsForType?.find((c)=>c.id === entry.id);
                        if (!selected) console.warn(`[CompoundDetail] offer::change: component ${entry.id} (type ${type}) not found in catalog \u{2014} delta set to 0`);
                        normalizedSelected[type] = {
                            id: entry.id,
                            cost: (0, $1cec967d8d56bb4d$export$a2cc5fc5ea7ea67b)(componentsForType, selected)
                        };
                    });
                    newVersion.selected_components = normalizedSelected;
                    // Update components with selected state based on offerCompound
                    Object.entries(newVersion.components).map((item)=>{
                        const selectedComponent = offerCompound.selected_components[item[0]];
                        if (selectedComponent) item[1].forEach((component)=>{
                            component.selected = selectedComponent.id === component.id;
                        });
                    });
                    const margin = (0, $1cec967d8d56bb4d$export$55530814c1a6ecfc)(newVersion, offerCompound.price.value);
                    setCompound(newVersion);
                    setMargin(margin);
                } else setCurrentOffer(changeOffersTasks[0].getContext().offerProposal);
            }
        } else setCurrentOffer(null);
    }, [
        tasks,
        compound?.id
    ]);
    const currency = compound?.price.currency || "EUR";
    const icons = {
        Cpu: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e8859e855a5dc92a$export$2e2bcd8739ae039), {
            className: "inline mr-1"
        }),
        Gpu: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e567cef82db71d0e$export$2e2bcd8739ae039), {
            className: "inline mr-1"
        }),
        CircuitBoard: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d1c159efbf8295ba$export$2e2bcd8739ae039), {
            className: "inline mr-1"
        }),
        MemoryStick: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $305d6e4c68cac6f3$export$2e2bcd8739ae039), {
            className: "inline mr-1"
        }),
        HardDrive: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4e6e7c8f114d04e1$export$2e2bcd8739ae039), {
            className: "inline mr-1"
        }),
        Fan: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $554c4787c44ee537$export$2e2bcd8739ae039), {
            className: "inline mr-1"
        }),
        PcCase: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cf972fdbc52e6ed1$export$2e2bcd8739ae039), {
            className: "inline mr-1"
        }),
        Wifi: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b144e577f231bbf4$export$2e2bcd8739ae039), {
            className: "inline mr-1"
        }),
        Monitor: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f633c0fb63f4b508$export$2e2bcd8739ae039), {
            className: "inline mr-1"
        }),
        Keyboard: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ebf99d6f8a58620$export$2e2bcd8739ae039), {
            className: "inline mr-1"
        }),
        Mouse: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $776c757559abfae2$export$2e2bcd8739ae039), {
            className: "inline mr-1"
        }),
        Power: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bfe54799d1557409$export$2e2bcd8739ae039), {
            className: "inline mr-1"
        }),
        Rocket: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10da79d8875e7dff$export$2e2bcd8739ae039), {
            className: "inline mr-1"
        })
    };
    const showCosts = function() {
        return userSettings?.generalSettings?.show_cost_price ?? false;
    };
    if (!isAuthenticated()) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: "You must be logged in to edit items."
    });
    return !compound ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            children: "Carregando detalhes do PC..."
        })
    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "container mx-auto not-printable",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "p-4 overflow-auto",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "text-2xl font-bold mb-4 pt-5 items-center",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$a6c7ac8248d6e38a), {
                                to: `/`,
                                className: "not-printable",
                                onClick: (e)=>{
                                    e.preventDefault();
                                    if (currentOffer) navigate("/");
                                    else history.back();
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).button, {
                                    whileHover: {
                                        scale: 1.1
                                    },
                                    whileTap: {
                                        scale: 0.9
                                    },
                                    className: "ml-5 mr-5 text-red-500 hover:text-red-700 flex items-center",
                                    children: [
                                        " ",
                                        currentOffer ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                                                    className: "w-7 h-7 inline-block"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "pl-2",
                                                    children: "Escolher outro computador"
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c7893a6dd85e5c$export$2e2bcd8739ae039), {
                                                    className: "w-7 h-7 inline-block"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "pl-2",
                                                    children: "Voltar"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex items-start flex-col md:flex-row pb-30",
                            children: [
                                compound.image && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "w-full md:shrink-0 md:w-1/3 md:sticky md:top-0 p-4 not-printable",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e87b4633e3445bd$export$2e2bcd8739ae039), {
                                        src: `https://placehold.co/600x600/B3B1A9/000000?text=${compound.description}`,
                                        loading: "progressive",
                                        dataSrc: compound.image,
                                        alt: compound.name,
                                        className: "rounded-lg object-cover w-full",
                                        sizes: "600",
                                        version: compound.version
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex-grow ml-0 md:ml-4 print-content",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "p-4 md:sticky configuration-header",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "text-xl font-extrabold",
                                                    children: compound.name
                                                }),
                                                compound.description && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "text-xl  mb-2",
                                                    children: compound.description
                                                }),
                                                Object.keys(compound.components).length > 0 && (0, $cd93687958c8007e$export$b6cd510719465167).map((key)=>{
                                                    let component = compound.components[key[0]]?.find((c)=>!c.optional);
                                                    if (component && component.name.trim() !== "") return /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        className: "text-sm font-bold text-gray-400 p-1 not-printable",
                                                        children: [
                                                            // @ts-ignore
                                                            icons[key[1]] || null,
                                                            component.quantity > 1 ? `${component.quantity} x ` : "",
                                                            component.description
                                                        ]
                                                    }, key[0]);
                                                    return null;
                                                }),
                                                userSettings?.isCommercial() || currentOffer?.client_type == "reseller" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4b0d0a3610d874cb$export$2e2bcd8739ae039), {
                                                    compound: compound,
                                                    currency: currency,
                                                    hasCustomization: hasCustomization,
                                                    customizationPrice: customizationPrice,
                                                    previousResellerPrice: (0, $1cec967d8d56bb4d$export$118cceac05e63f57)(compound),
                                                    basePricePVPInput: basePricePVPInput,
                                                    customizationPricePVPInput: customizationPricePVPInput,
                                                    handleManualEdit: handleManualEdit,
                                                    handleAutomaticEdit: handleAutomaticEdit,
                                                    handleBasePriceChange: handleBasePriceChange,
                                                    handleCustomizationPriceChange: handleCustomizationPriceChange,
                                                    allowEditPrices: !userSettings?.isNormalUser()
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $81ceca20bfa327e1$export$2e2bcd8739ae039), {
                                                    compound: compound,
                                                    currency: currency,
                                                    hasCustomization: hasCustomization,
                                                    customizationPrice: customizationPrice,
                                                    previousResellerPrice: (0, $1cec967d8d56bb4d$export$118cceac05e63f57)(compound),
                                                    basePricePVPInput: basePricePVPInput,
                                                    customizationPricePVPInput: customizationPricePVPInput,
                                                    handleManualEdit: handleManualEdit,
                                                    handleAutomaticEdit: handleAutomaticEdit,
                                                    handleBasePriceChange: handleBasePriceChange,
                                                    handleCustomizationPriceChange: handleCustomizationPriceChange,
                                                    allowEditPrices: !userSettings?.isNormalUser(),
                                                    showCostPrice: showCosts()
                                                }),
                                                (userSettings?.generalSettings?.show_margin_slider ?? false) && (userSettings?.generalSettings?.show_cost_price ?? false) && !!compound.price.margin && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "text-xs font-bold text-gray-400 reseller-margin not-printable",
                                                    children: [
                                                        "Margem: ",
                                                        margin ?? initialMargin,
                                                        " %",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Slider), {
                                                            min: Math.min(0.1, initialMargin),
                                                            max: 99.9,
                                                            value: Math.max(Math.min(0.1, initialMargin), Math.min(99.9, margin ?? initialMargin)),
                                                            valueLabelDisplay: "auto",
                                                            step: 0.1,
                                                            valueLabelFormat: (value)=>`${value} %`,
                                                            color: (margin ?? initialMargin) >= initialMargin - 1 && (margin ?? initialMargin) <= initialMargin + 1 ? "success" : (margin ?? initialMargin) > 100 ? "error" : (margin ?? initialMargin) < initialMargin - initialMargin / 2 ? "warning" : (margin ?? initialMargin) < initialMargin * 2 - initialMargin / 2 ? "primary" : "secondary",
                                                            marks: initialMargin >= 0.1 && initialMargin <= 99.9 ? [
                                                                {
                                                                    value: initialMargin,
                                                                    label: "Recomendado: " + initialMargin + " %"
                                                                }
                                                            ] : [],
                                                            onChange: handleSliderChange
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        compound.allow_customization && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "text-xl font-bold text-gray-900 p-2 mt-2 not-printable text-center",
                                                    children: "Personalize a sua configura\xe7\xe3o"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                                    className: "grid grid-cols-1 gap-4 p-4",
                                                    children: Object.entries(compound.components).map(([componentType, components])=>{
                                                        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $13d8dceb097c825b$export$2e2bcd8739ae039), {
                                                            componentType: componentType,
                                                            components: components,
                                                            selectedComponent: compound.selected_components?.[componentType] ?? null,
                                                            margin: margin ?? initialMargin,
                                                            vatRate: compound.price.vat_rate,
                                                            currency: currency,
                                                            onChange: handleChangeComponent,
                                                            showCosts: showCosts()
                                                        }, componentType);
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex is-justify-content-center mt-4 not-printable",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).button, {
                                                    whileHover: {
                                                        scale: 1.1
                                                    },
                                                    whileTap: {
                                                        scale: 0.9
                                                    },
                                                    className: "bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full shadow-lg items-center gap-2",
                                                    onClick: handleShowFullDetails,
                                                    children: "Mais Detalhes"
                                                }),
                                                isAuthenticated() && (currentOffer ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).button, {
                                                    whileHover: {
                                                        scale: 1.1
                                                    },
                                                    whileTap: {
                                                        scale: 0.9
                                                    },
                                                    className: "bg-red-400 hover:bg-red-600 text-white font-bold py-2 px-4 rounded-full shadow-lg items-center gap-2 ml-4",
                                                    onClick: handleShowUpdateProposal,
                                                    children: "Alterar Proposta Actual"
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).button, {
                                                    whileHover: {
                                                        scale: 1.1
                                                    },
                                                    whileTap: {
                                                        scale: 0.9
                                                    },
                                                    className: "bg-red-400 hover:bg-red-600 text-white font-bold py-2 px-4 rounded-full shadow-lg items-center gap-2 ml-4",
                                                    onClick: handleShowCreateProposal,
                                                    children: "Criar Proposta"
                                                }))
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "container mx-auto px-4 not-printable",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4160262678d76153$export$2e2bcd8739ae039), {
                    entityId: compound.id,
                    entityType: "product",
                    customerName: userSettings?.profile?.firstName || undefined,
                    customerEmail: userSettings?.profile?.email || undefined,
                    authToken: localStorage.getItem("authToken") || undefined,
                    locale: "pt"
                })
            })
        ]
    });
};
var $ccaa2522ab1042a6$export$2e2bcd8739ae039 = $ccaa2522ab1042a6$var$CompoundDetailPage;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $juRJQ = parcelRequire("juRJQ");
const $e21dd6fe324734f1$var$ListOrderItems = ({ orders: orders, page: page, perPage: perPage, setPerPage: setPerPage, totalPages: totalPages, sortBy: sortBy, setSortBy: setSortBy, sortOrder: sortOrder, setSortOrder: setSortOrder, handlePageChange: handlePageChange, openManageOrderModal: openManageOrderModal, totalResults: totalResults, loading: loading })=>{
    const [showListedFields, setShowListedFields] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>{
        const session = sessionStorage.getItem("orders_listed_fields");
        if (session) return new Map(JSON.parse(session));
        return new Map([
            [
                "id",
                true
            ],
            [
                "offer_external_id",
                true
            ],
            [
                "type",
                true
            ],
            [
                "compound_name",
                true
            ],
            [
                "customer_id",
                true
            ],
            [
                "customer_name",
                true
            ],
            [
                "requested_by",
                true
            ],
            [
                "commercial_portfolio",
                true
            ],
            [
                "commercial_agent",
                true
            ],
            [
                "amount",
                true
            ],
            [
                "status",
                true
            ],
            [
                "created_at",
                true
            ],
            [
                "updated_at",
                true
            ]
        ]);
    });
    function getOrderTypeLabel(order) {
        if (order.order_type === "DEFAULT") return "Revendedor";
        else if (order.order_type === "INTERNAL") {
            if (order.offer_client_type === "RESELLER") return "Comercial";
            else if (order.offer_client_type === "END_CUSTOMER") return "Interna";
        }
        return "Outro";
    }
    function getOrderTypeClass(order) {
        if (order.order_type === "DEFAULT") return "bg-amber-300";
        else if (order.order_type === "INTERNAL") {
            if (order.offer_client_type === "RESELLER") return "bg-blue-300";
            else if (order.offer_client_type === "END_CUSTOMER") return "bg-green-300";
        }
        return "bg-gray-300";
    }
    function getStatusLabel(status) {
        switch(status){
            case "PENDING":
                return "Pendente";
            case "CONFIRMED":
                return "Confirmada";
            case "REJECTED":
                return "Rejeitada";
            case "SHIPPED":
                return "Enviada";
            case "COMPLETED":
                return "Conclu\xedda";
            default:
                return "status desconhecido";
        }
    }
    const columns = [
        {
            field: "id",
            headerName: "ID",
            width: 70,
            sortable: true,
            valueGetter: (value, row)=>row.id || "n/a"
        },
        {
            field: "offer_external_id",
            headerName: "Proposta",
            width: 120,
            sortable: true,
            valueGetter: (value, row)=>row.offer_external_id || "n/a"
        },
        {
            field: "type",
            headerName: "Origem",
            width: 110,
            sortable: true,
            renderCell: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                    className: `rounded-3xl px-2 p-1 has-text-weight-bold ${getOrderTypeClass(params.row)}`,
                    children: getOrderTypeLabel(params.row)
                })
        },
        {
            field: "compound_name",
            headerName: "Computador",
            width: 130,
            sortable: true,
            valueGetter: (value, row)=>row.items[0]?.compound_id || "n/a"
        },
        {
            field: "customer_id",
            headerName: "Cod Cliente",
            width: 120,
            sortable: true,
            valueGetter: (value, row)=>row.order_type == "DEFAULT" ? row.erp_client_id : row.offer_client?.id ?? "n/a"
        },
        {
            field: "customer_name",
            headerName: "Nome do Cliente",
            width: 160,
            sortable: true,
            valueGetter: (value, row)=>row.order_type == "DEFAULT" ? row.client?.name : row.offer_client?.name ?? "-"
        },
        {
            field: "requested_by",
            headerName: "Vendedor",
            width: 120,
            sortable: true,
            valueGetter: (value, row)=>row.requested_by_name || row.requested_by
        },
        {
            field: "commercial_portfolio",
            headerName: "Cod Comercial",
            width: 120,
            sortable: true,
            valueGetter: (value, row)=>row.commercial_portfolio || "-"
        },
        {
            field: "commercial_agent",
            headerName: "Comercial",
            width: 160,
            sortable: true,
            renderCell: (params)=>params.row.commercial_agents.length > 0 ? params.row.commercial_agents.map((agent)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "inline-block mr-1 rounded bg-blue-100 px-2 py-1 text-xs font-semibold text-blue-800",
                        children: agent.name || agent.username
                    }, agent.id)) : /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                    children: "-"
                })
        },
        {
            field: "amount",
            headerName: "Valor Total",
            width: 120,
            sortable: true,
            type: "number",
            valueGetter: (value, row)=>row.total_amount.toLocaleString("pt-PT", {
                    style: "currency",
                    currency: "EUR"
                })
        },
        {
            field: "status",
            headerName: "Estado",
            width: 110,
            sortable: true,
            valueGetter: (value, row)=>getStatusLabel(row.status)
        },
        {
            field: "created_at",
            headerName: "Criada em",
            width: 140,
            sortable: true,
            valueGetter: (value, row)=>row?.created_at ? new Date(row.created_at).toLocaleString("pt-PT", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit"
                }) : ""
        },
        {
            field: "updated_at",
            headerName: "Alterada em",
            width: 140,
            sortable: true,
            valueGetter: (value, row)=>row?.updated_at ? new Date(row.updated_at).toLocaleString("pt-PT", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit"
                }) : ""
        }
    ];
    const paginationState = {
        paginationMode: "server",
        paginationModel: {
            page: page - 1,
            pageSize: perPage || 10
        },
        rowCount: totalResults || -1,
        enabled: true,
        meta: {
            hasNextPage: true
        }
    };
    const handlePaginationChange = (model)=>{
        if (model.pageSize !== perPage && setPerPage) setPerPage(model.pageSize);
        if (model.page + 1 !== page) handlePageChange(model.page + 1);
    };
    // Save showListedFields to sessionStorage when it changes
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        sessionStorage.setItem("orders_listed_fields", JSON.stringify(Array.from(showListedFields.entries())));
    }, [
        showListedFields
    ]);
    console.log("Current totalResults:", totalResults);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($juRJQ))), {
        sx: {
            height: "screen",
            width: "100%"
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $808944a671b11c1c$exports.DataGrid), {
            rows: orders,
            columns: columns,
            loading: loading,
            density: "standard",
            initialState: {
                pagination: paginationState
            },
            rowCount: totalResults || 0,
            paginationMode: "server",
            sortingMode: "server",
            disableColumnFilter: true,
            onPaginationModelChange: handlePaginationChange,
            onSortModelChange: (model)=>{
                if (model.length > 0) {
                    const sortModel = model[0];
                    setSortBy(sortModel.field);
                    setSortOrder(sortModel.sort || "asc");
                }
            },
            onRowClick: (handleRowClick)=>openManageOrderModal(handleRowClick.row),
            columnVisibilityModel: Object.fromEntries(showListedFields),
            onColumnVisibilityModelChange: (newModel)=>{
                const newMap = new Map(Object.entries(newModel));
                setShowListedFields(newMap);
            },
            hideFooterSelectedRowCount: true,
            pageSizeOptions: [
                5,
                10,
                20,
                50,
                100
            ],
            localeText: {
                columnsManagementSearchTitle: "Procurar",
                columnsManagementNoColumns: "Sem colunas",
                columnsManagementShowHideAllText: "Mostrar/Ocultar Todas",
                columnsManagementReset: "Repor",
                columnsManagementDeleteIconLabel: "Limpar",
                columnMenuLabel: "Menu",
                columnMenuAriaLabel: (columnName)=>`Menu da coluna ${columnName}`,
                columnMenuShowColumns: "Mostrar colunas",
                columnMenuManageColumns: "Gerir colunas",
                columnMenuFilter: "Filtrar",
                columnMenuHideColumn: "Ocultar coluna",
                columnMenuUnsort: "Remover ordena\xe7\xe3o",
                columnMenuSortAsc: "Ordenar por ASC",
                columnMenuSortDesc: "Ordenar por DESC",
                columnMenuManagePivot: "Gerir pivot",
                paginationRowsPerPage: "Linhas por p\xe1gina:",
                paginationDisplayedRows: ({ from: from, to: to, count: count, estimated: estimated })=>{
                    if (!estimated) return `${from}\u{2013}${to} de ${count !== -1 ? count : `mais de ${to}`}`;
                    const estimatedLabel = estimated && estimated > to ? `cerca de ${estimated}` : `mais de ${to}`;
                    return `${from}\u{2013}${to} de ${count !== -1 ? count : estimatedLabel}`;
                }
            },
            getCellClassName: (params)=>{
                const fieldClasses = {
                    status: "font-semibold",
                    commercial_portfolio: "font-mono text-xs text-gray-600 force-text-center",
                    customer_id: "font-mono text-xs text-gray-600 force-text-center",
                    id: "font-mono",
                    offer_external_id: "font-mono",
                    created_at: "text-xs text-gray-600",
                    updated_at: "text-xs text-gray-600",
                    amount: "font-mono text-xs text-gray-600 force-text-right"
                };
                return params.isEditable || params.row ? fieldClasses[params.field] || "" : "";
            },
            sx: {
                border: 0
            }
        })
    });
};
var $e21dd6fe324734f1$export$2e2bcd8739ae039 = $e21dd6fe324734f1$var$ListOrderItems;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $131c05e6196e399a$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m3 17 2 2 4-4",
            key: "1jhpwq"
        }
    ],
    [
        "path",
        {
            d: "m3 7 2 2 4-4",
            key: "1obspn"
        }
    ],
    [
        "path",
        {
            d: "M13 6h8",
            key: "15sg57"
        }
    ],
    [
        "path",
        {
            d: "M13 12h8",
            key: "h98zly"
        }
    ],
    [
        "path",
        {
            d: "M13 18h8",
            key: "oe0vm4"
        }
    ]
];
const $131c05e6196e399a$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("list-checks", $131c05e6196e399a$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c3986c8917bbd6fd$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "20",
            height: "8",
            x: "2",
            y: "2",
            rx: "2",
            ry: "2",
            key: "ngkwjq"
        }
    ],
    [
        "rect",
        {
            width: "20",
            height: "8",
            x: "2",
            y: "14",
            rx: "2",
            ry: "2",
            key: "iecqi9"
        }
    ],
    [
        "line",
        {
            x1: "6",
            x2: "6.01",
            y1: "6",
            y2: "6",
            key: "16zg32"
        }
    ],
    [
        "line",
        {
            x1: "6",
            x2: "6.01",
            y1: "18",
            y2: "18",
            key: "nzw8ys"
        }
    ]
];
const $c3986c8917bbd6fd$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("server", $c3986c8917bbd6fd$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $a669a529cc227421$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "3",
            rx: "2",
            key: "afitv7"
        }
    ],
    [
        "path",
        {
            d: "M16 8.9V7H8l4 5-4 5h8v-1.9",
            key: "9nih0i"
        }
    ]
];
const $a669a529cc227421$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("square-sigma", $a669a529cc227421$export$3efd853dbb351e94);





// cost_price/rev3_price are per-unit; component.price is already the line total
const $6802079231d88d17$var$costTotal = (c)=>(c.cost_price ?? 0) * (c.quantity ?? 0);
const $6802079231d88d17$var$rev3Total = (c)=>(c.rev3_price ?? 0) * (c.quantity ?? 0);
const $6802079231d88d17$var$ManageOrder = ({ order: order, onAddNote: onAddNote })=>{
    const [tab, setTab] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("order");
    const [offerReviewHtml, setOfferReviewHtml] = (0, $acw62.useState)("");
    const generateOfferPreview = (0, $acw62.useCallback)(async ()=>{
        try {
            const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).OFFERS + "/" + order.offer_id + "/_actions/review");
            console.log("Preview gerado com sucesso!", response.data);
            return response.data;
        } catch (error) {
            console.warn("Erro ao gerar preview:", error);
            return "";
        }
    }, [
        order.offer_id
    ]);
    (0, $acw62.useEffect)(()=>{
        generateOfferPreview().then((html)=>setOfferReviewHtml(html));
    }, [
        generateOfferPreview
    ]);
    function getPriceToShow() {
        if (order.offer_client_type === "END_CUSTOMER" && order.order_type === "INTERNAL") return order.items[0].customer_price;
        return order.total_amount;
    }
    function renderClientInfo(client) {
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "column",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                    className: "title is-4 mb-2",
                    children: client?.name
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                    className: "mb-1",
                    children: [
                        client?.id && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            className: "w-5/12 is-inline-block",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                    children: "N\xba Cliente:"
                                }),
                                " ",
                                client?.id ? client?.id : /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                    children: "n/a"
                                })
                            ]
                        }),
                        client?.vat && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            className: "w-5/12 is-inline-block",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                    children: "NIF:"
                                }),
                                " ",
                                client?.vat ? client?.vat : /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                    children: "n/a"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                    className: "mb-1",
                    children: [
                        client?.phone && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            className: "w-5/12 is-inline-block",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                    children: "Telefone:"
                                }),
                                " ",
                                client?.phone ? client?.phone : /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                    children: "n/a"
                                }),
                                " "
                            ]
                        }),
                        client?.email && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            className: "w-5/12 is-inline-block",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                    children: "Email:"
                                }),
                                " ",
                                client?.email ? client?.email : /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                    children: "n/a"
                                }),
                                " "
                            ]
                        })
                    ]
                }),
                (client?.address || client?.zip_code || client?.city) && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                    className: "mb-1",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                            children: "Morada:"
                        }),
                        " ",
                        client?.address,
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        " ",
                        client?.zip_code,
                        " ",
                        client?.city
                    ]
                })
            ]
        });
    }
    function renderSummaryInfo() {
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "column has-text-left",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                    children: "Origem da Encomenda:"
                                }),
                                " ",
                                order.order_type === "INTERNAL" ? "Comercial" : "Revendedor"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        order.order_type === "INTERNAL" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                            children: "Tipo de Cliente:"
                                        }),
                                        " ",
                                        order.offer_client_type === "RESELLER" ? "Revendedor" : order.offer_client_type === "END_CUSTOMER" ? "Cliente Final" : "Outro"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {})
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                    children: "Proposta:"
                                }),
                                " ",
                                order.offer_external_id
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                    children: "Comercial:"
                                }),
                                " ",
                                order.commercial_portfolio,
                                " -",
                                " ",
                                order.commercial_agents.map((c)=>c.name || c.username).join(", ")
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "column is-narrow has-text-right",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "tag is-info is-medium mb-3",
                            children: getPriceToShow().toLocaleString("pt-PT", {
                                style: "currency",
                                currency: "EUR"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("small", {
                            children: [
                                "Criada a: ",
                                new Date(order.created_at).toLocaleString("pt-PT")
                            ]
                        })
                    ]
                })
            ]
        });
    }
    function renderErpStatus() {
        if (order.status === "PENDING" || order.status === "REJECTED" || order.status === "CANCELLED") return null;
        const status = order.erp_submission_status;
        const config = {
            SENT: {
                label: "Enviada para o ERP",
                cls: "has-text-success"
            },
            PENDING: {
                label: "A enviar para o ERP",
                cls: "has-text-warning"
            },
            SENDING: {
                label: "A enviar para o ERP",
                cls: "has-text-warning"
            },
            UNKNOWN: {
                label: "Estado no ERP por confirmar",
                cls: "has-text-warning",
                hint: "O ERP pode j\xe1 ter criado a encomenda. Confirme no ERP antes de reenviar."
            },
            FAILED: {
                label: "Falha ao enviar para o ERP",
                cls: "has-text-danger"
            }
        };
        const current = status ? config[status] ?? {
            label: "Estado no ERP desconhecido",
            cls: "has-text-grey"
        } : order.erp_submission_enabled === false ? {
            label: "Integra\xe7\xe3o ERP desativada",
            cls: "has-text-grey"
        } : {
            label: "Sem registo de envio no ERP",
            cls: "has-text-grey"
        };
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "box has-background-light p-4 mb-4",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "columns is-align-items-start",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "column is-narrow",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c3986c8917bbd6fd$export$2e2bcd8739ae039), {
                            className: `icon is-medium ${current.cls}`
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "column",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                        children: "ERP: "
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: current.cls,
                                        children: current.label
                                    }),
                                    order.erp_order_number && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            " ",
                                            "\u2014 N\xba ERP",
                                            " ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "font-mono",
                                                children: order.erp_order_number
                                            })
                                        ]
                                    })
                                ]
                            }),
                            current.hint && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "is-size-7 has-text-grey mt-1",
                                children: current.hint
                            })
                        ]
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "overflow-y-auto",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "box",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                    className: "title is-2",
                    children: [
                        "Encomenda #",
                        order.id,
                        " - ",
                        order.status
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "tabs is-boxed",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                className: tab === "order" ? "is-active" : "",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                    onClick: ()=>setTab("order"),
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "icon is-small",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ee6f13a46cf9100a$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            children: "Encomenda"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                className: tab === "offer-review" ? "is-active" : "",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                    onClick: ()=>setTab("offer-review"),
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "icon is-small",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6bfe12c41179c4f1$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            children: [
                                                "Proposta",
                                                " ",
                                                order.order_type == "DEFAULT" ? "do revendedor ao cliente" : order.offer_client_type == "END_CUSTOMER" ? "ao cliente final" : "ao revendedor"
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                className: tab === "notes" ? "is-active" : "",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                    onClick: ()=>setTab("notes"),
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "icon is-small",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ecb8e5bcb990e28a$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            children: "Notas"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: `content ${tab === "order" ? "" : "is-hidden"}  min-h-[75vh] flex flex-col`,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "resume-card box has-background-light p-4 mb-4",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "columns is-align-items-start",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "column is-narrow",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a669a529cc227421$export$2e2bcd8739ae039), {
                                            className: "icon is-medium has-text-primary"
                                        })
                                    }),
                                    renderSummaryInfo()
                                ]
                            })
                        }),
                        renderErpStatus(),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "client-card box has-background-light p-4 mt-4 mb-4",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "columns is-align-items-start",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "column is-narrow",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0740549741641712$export$2e2bcd8739ae039), {
                                            className: "icon is-medium has-text-primary"
                                        })
                                    }),
                                    order.order_type === "INTERNAL" ? renderClientInfo(order.offer_client) : renderClientInfo(order.client)
                                ]
                            })
                        }),
                        order.items.map((item, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "item-card",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "item-card",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "item-info-card box has-background-light p-4 mb-4",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "columns is-align-items-start",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "column is-narrow",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $131c05e6196e399a$export$2e2bcd8739ae039), {
                                                            className: "icon is-medium has-text-primary"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "column",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "grid grid-cols-5 gap-4 items-start",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                                                children: "Refer\xeancia:"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "font-mono",
                                                                                children: item.compound_id
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                                                children: "Custo Niposom:"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                className: "font-mono",
                                                                                children: [
                                                                                    item.selected_components.reduce((sum, comp)=>sum + $6802079231d88d17$var$costTotal(comp), 0).toLocaleString("pt-PT", {
                                                                                        style: "currency",
                                                                                        currency: "EUR"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                                                                        children: "(valor sem IVA)"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                                                children: "Pre\xe7o de REV3:"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                className: "font-mono",
                                                                                children: [
                                                                                    item.selected_components.reduce((sum, comp)=>sum + $6802079231d88d17$var$rev3Total(comp), 0).toLocaleString("pt-PT", {
                                                                                        style: "currency",
                                                                                        currency: "EUR"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                                                                        children: "(valor sem IVA)"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                                                children: "Desconto na margem:"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                className: "font-mono",
                                                                                children: [
                                                                                    item.discount_value,
                                                                                    " %"
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                                                children: "Quantidade:"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "font-mono",
                                                                                children: item.quantity
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "grid grid-cols-5 gap-4 items-start mt-4",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {}),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                                                children: "PVP da venda:"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                className: "font-mono",
                                                                                children: [
                                                                                    (item.customer_price ?? 0).toLocaleString("pt-PT", {
                                                                                        style: "currency",
                                                                                        currency: "EUR"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                                                                        children: "(valor com IVA)"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                                                children: "Pre\xe7o Loja (Base):"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                className: "font-mono",
                                                                                children: [
                                                                                    (item.base_price ?? 0).toLocaleString("pt-PT", {
                                                                                        style: "currency",
                                                                                        currency: "EUR"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                                                                        children: "(valor sem IVA)"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                                                children: "Pre\xe7o Loja (Opcionais):"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                className: "font-mono",
                                                                                children: [
                                                                                    (item.sell_price ?? 0).toLocaleString("pt-PT", {
                                                                                        style: "currency",
                                                                                        currency: "EUR"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                                                                        children: "(valor sem IVA)"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                                                children: "Margem do Revendedor:"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                className: "font-mono",
                                                                                children: [
                                                                                    (0, $1cec967d8d56bb4d$export$63ad841d70774900)(item.margin_reseller),
                                                                                    " %"
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }, item.compound_id),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "components-info-card p-4 mb-4",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "table-container overflow-x-auto",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                                                className: "table is-bordered is-striped is-narrow is-hoverable is-fullwidth font-mono",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                            className: "has-text-centered has-text-weight-bold bg-slate-400",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                    children: "Componente"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                    children: "Refer\xeancia"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                    children: "Nome"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                    children: "Qde"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                    children: "Valor unit."
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                    children: "Custo (total)"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                    children: "REV3 (total)"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                    children: "Valor"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                                        children: item.selected_components.map((component)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                        children: component.product_type
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                        children: component.product_reference
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                        children: component.product_name
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                        align: "center",
                                                                        children: component.quantity
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                        align: "right",
                                                                        children: (component.price / component.quantity).toLocaleString("pt-PT", {
                                                                            style: "currency",
                                                                            currency: "EUR"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                        align: "right",
                                                                        children: $6802079231d88d17$var$costTotal(component).toLocaleString("pt-PT", {
                                                                            style: "currency",
                                                                            currency: "EUR"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                        align: "right",
                                                                        children: $6802079231d88d17$var$rev3Total(component).toLocaleString("pt-PT", {
                                                                            style: "currency",
                                                                            currency: "EUR"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                        align: "right",
                                                                        children: (component.price ?? 0).toLocaleString("pt-PT", {
                                                                            style: "currency",
                                                                            currency: "EUR"
                                                                        })
                                                                    })
                                                                ]
                                                            }, component.component_id))
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("tfoot", {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                            className: "has-text-centered has-text-weight-bold bg-slate-200",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                    colSpan: 5,
                                                                    children: "Total"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                    align: "right",
                                                                    children: item.selected_components.reduce((sum, comp)=>sum + $6802079231d88d17$var$costTotal(comp), 0).toLocaleString("pt-PT", {
                                                                        style: "currency",
                                                                        currency: "EUR"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                    align: "right",
                                                                    children: item.selected_components.reduce((sum, comp)=>sum + $6802079231d88d17$var$rev3Total(comp), 0).toLocaleString("pt-PT", {
                                                                        style: "currency",
                                                                        currency: "EUR"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                    align: "right",
                                                                    children: item.selected_components.reduce((sum, comp)=>sum + (comp.price ?? 0), 0).toLocaleString("pt-PT", {
                                                                        style: "currency",
                                                                        currency: "EUR"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }, item.compound_id))
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: `content ${tab === "offer-review" ? "" : "is-hidden"} min-h-[75vh] flex flex-col`,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("iframe", {
                        srcDoc: offerReviewHtml,
                        className: "w-full h-full",
                        style: {
                            flex: 1,
                            width: "100%",
                            height: "100%"
                        }
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: `content ${tab === "notes" ? "" : "is-hidden"} min-h-[75vh]`,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d53f4121435a41a$export$2e2bcd8739ae039), {
                        entityId: Number(order.id) || 0,
                        entityType: "order",
                        showVisibilityOption: true
                    })
                })
            ]
        })
    });
};
var $6802079231d88d17$export$2e2bcd8739ae039 = $6802079231d88d17$var$ManageOrder;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");




const $a065279d4dbd6ce6$var$ManageOrderActions = ({ order: order, handleConfirmOrder: handleConfirmOrder, onOpenRejectModal: onOpenRejectModal, onOpenCancelModal: onOpenCancelModal, onResubmitToErp: onResubmitToErp })=>{
    const { setError: setError, setLoading: setLoading, userSettings: userSettings } = (0, $a55f2a94cd420149$export$c50e37a2f0a2b064)();
    const handleExportExcel = async ()=>{
        setLoading(true);
        setError(null);
        try {
            const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).post((0, $cd93687958c8007e$export$bfe19bc25132bb7c).ORDERS + "/_actions/export-excel", order, {
                responseType: "blob"
            });
            const url = window.URL.createObjectURL(new Blob([
                response.data
            ]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `encomenda_${order.id}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.warn("Erro ao exportar encomenda para Excel:", error);
            setError(error.message || "Erro ao exportar encomenda para Excel.");
        } finally{
            setLoading(null);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("footer", {
        className: "p-4",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex is-justify-content-center",
            children: [
                (userSettings?.isAdmin() || userSettings?.isCommercial()) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).button, {
                    whileHover: {
                        scale: 1.1
                    },
                    whileTap: {
                        scale: 0.9
                    },
                    className: "bg-green-700 hover:bg-green-800 text-white font-bold py-2 px-4 rounded-full shadow-lg items-center gap-2 ml-4",
                    onClick: handleExportExcel,
                    children: "Exportar Excel"
                }),
                userSettings?.isAdmin() && [
                    "CONFIRMED",
                    "SHIPPED",
                    "COMPLETED"
                ].includes(order.status) && order.erp_submission_status !== "SENT" && order.erp_submission_status !== "PENDING" && order.erp_submission_status !== "SENDING" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).button, {
                    whileHover: {
                        scale: 1.1
                    },
                    whileTap: {
                        scale: 0.9
                    },
                    className: "bg-sky-600 hover:bg-sky-700 text-white font-bold py-2 px-4 rounded-full shadow-lg items-center gap-2 ml-4",
                    onClick: ()=>onResubmitToErp(order.id, order.erp_submission_status === "UNKNOWN"),
                    children: order.erp_submission_status === "FAILED" || order.erp_submission_status === "UNKNOWN" ? "Reenviar para o ERP" : "Enviar para o ERP"
                }),
                order.status === "PENDING" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).button, {
                            whileHover: {
                                scale: 1.1
                            },
                            whileTap: {
                                scale: 0.9
                            },
                            className: `bg-green-700 hover:bg-green-800 text-white font-bold py-2 px-4 rounded-full shadow-lg items-center gap-2 ml-4`,
                            onClick: ()=>handleConfirmOrder(order.id),
                            children: "Aceitar Encomenda"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).button, {
                            whileHover: {
                                scale: 1.1
                            },
                            whileTap: {
                                scale: 0.9
                            },
                            className: "bg-red-400 hover:bg-red-600 text-white font-bold py-2 px-4 rounded-full shadow-lg items-center gap-2 ml-4",
                            onClick: onOpenRejectModal,
                            children: "Rejeitar Encomenda"
                        })
                    ]
                }),
                order.status === "CONFIRMED" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).button, {
                            whileHover: {
                                scale: 1.1
                            },
                            whileTap: {
                                scale: 0.9
                            },
                            className: "bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full shadow-lg items-center gap-2 ml-4",
                            children: "Enviar Encomenda"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).button, {
                            whileHover: {
                                scale: 1.1
                            },
                            whileTap: {
                                scale: 0.9
                            },
                            className: "bg-orange-500 hover:bg-orange-700 text-white font-bold py-2 px-4 rounded-full shadow-lg items-center gap-2 ml-4",
                            onClick: onOpenCancelModal,
                            children: "Cancelar Encomenda"
                        })
                    ]
                }),
                order.status === "SHIPPED" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).button, {
                    whileHover: {
                        scale: 1.1
                    },
                    whileTap: {
                        scale: 0.9
                    },
                    className: "bg-orange-500 hover:bg-orange-700 text-white font-bold py-2 px-4 rounded-full shadow-lg items-center gap-2 ml-4",
                    onClick: onOpenCancelModal,
                    children: "Cancelar Encomenda"
                })
            ]
        })
    });
};
var $a065279d4dbd6ce6$export$2e2bcd8739ae039 = $a065279d4dbd6ce6$var$ManageOrderActions;




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


const $91fdd63a7a7b52c4$var$OrderFilters = ({ initialOrderSearchParams: initialOrderSearchParams, onFilterChange: onFilterChange, loading: loading })=>{
    const [customerOptions, setCustomerOptions] = (0, $acw62.useState)([]);
    const [selectedStatus, setSelectedStatus] = (0, $acw62.useState)(initialOrderSearchParams.status ?? "");
    const [selectedCustomer, setSelectedCustomer] = (0, $acw62.useState)(initialOrderSearchParams.customer ?? "");
    const [selectedType, setSelectedType] = (0, $acw62.useState)(initialOrderSearchParams.type ?? "");
    const fetchCustomerOptions = async ()=>{
        const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).ORDERS + "/_view/customers/distinct" + (selectedType ? `?type=${selectedType}` : "") + (selectedStatus ? `?status=${selectedStatus}` : ""));
        setCustomerOptions(response.data || []);
    };
    const setFilterValue = (0, $acw62.useCallback)((key, value)=>{
        const newFilters = {
            ...initialOrderSearchParams,
            [key]: value
        };
        onFilterChange(newFilters);
        if (key === "status") setSelectedStatus(value);
        else if (key === "customer") setSelectedCustomer(value);
        else if (key === "type") setSelectedType(value);
    }, [
        initialOrderSearchParams,
        onFilterChange
    ]);
    (0, $acw62.useEffect)(()=>{
        fetchCustomerOptions();
    }, [
        selectedStatus,
        selectedType
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "bg-white p-4 rounded-xl shadow-sm border border-gray-200",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "grid grid-cols-1 md:grid-cols-3 gap-4",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                            htmlFor: "selectedType",
                            className: "block text-sm font-medium text-gray-700 mb-2",
                            children: "Origem"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                            id: "selectedType",
                            value: selectedType,
                            onChange: (e)=>setFilterValue("type", e.target.value),
                            disabled: loading,
                            className: "block w-full px-3 py-2.5 border border-gray-300 rounded-lg bg-gray-50 text-gray-900 focus:outline-none focus:bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                    value: "",
                                    children: "Todas as origens"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                    value: "DEFAULT",
                                    children: "Revendedor"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                    value: "RESELLER",
                                    children: "Comercial"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                    value: "END_CUSTOMER",
                                    children: "Interna"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                            htmlFor: "customer",
                            className: "block text-sm font-medium text-gray-700 mb-2",
                            children: "Cliente"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                            id: "customer",
                            value: selectedCustomer,
                            onChange: (e)=>setFilterValue("customer", e.target.value),
                            onFocus: fetchCustomerOptions,
                            disabled: loading,
                            className: "block w-full px-3 py-2.5 border border-gray-300 rounded-lg bg-gray-50 text-gray-900 focus:outline-none focus:bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                    value: "",
                                    children: "Todos os clientes"
                                }),
                                customerOptions.map((opt, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: opt.value?.toString(),
                                        children: opt.label
                                    }, idx))
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                            htmlFor: "status",
                            className: "block text-sm font-medium text-gray-700 mb-2",
                            children: "Estado"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                            id: "status",
                            value: selectedStatus,
                            onChange: (e)=>setFilterValue("status", e.target.value),
                            disabled: loading,
                            className: "block w-full px-3 py-2.5 border border-gray-300 rounded-lg bg-gray-50 text-gray-900 focus:outline-none focus:bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                    value: "",
                                    children: "Todos os estados"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                    value: "PENDING",
                                    children: "Pendente"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                    value: "CONFIRMED",
                                    children: "Confirmada"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                    value: "REJECTED",
                                    children: "Rejeitada"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                    value: "SHIPPED",
                                    children: "Enviada"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                    value: "COMPLETED",
                                    children: "Conclu\xedda"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $91fdd63a7a7b52c4$export$2e2bcd8739ae039 = $91fdd63a7a7b52c4$var$OrderFilters;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

const $4c7c412c3d6b21da$var$OrderRejectCancelModal = ({ isOpen: isOpen, onClose: onClose, onSubmit: onSubmit, actionType: actionType, orderId: orderId })=>{
    const [reason, setReason] = (0, $acw62.useState)("");
    const [notes, setNotes] = (0, $acw62.useState)("");
    const [visibleToReseller, setVisibleToReseller] = (0, $acw62.useState)(false);
    const [isSubmitting, setIsSubmitting] = (0, $acw62.useState)(false);
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (!reason.trim()) return;
        setIsSubmitting(true);
        try {
            await onSubmit(reason, notes, visibleToReseller);
            setReason("");
            setNotes("");
            setVisibleToReseller(false);
            onClose();
        } catch (error) {
            console.error(`Error ${actionType}ing order:`, error);
        } finally{
            setIsSubmitting(false);
        }
    };
    const handleClose = ()=>{
        setReason("");
        setNotes("");
        setVisibleToReseller(false);
        onClose();
    };
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "modal is-active",
        style: {
            zIndex: 9999
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "modal-background",
                onClick: handleClose
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).div, {
                initial: {
                    opacity: 0,
                    scale: 0.9
                },
                animate: {
                    opacity: 1,
                    scale: 1
                },
                exit: {
                    opacity: 0,
                    scale: 0.9
                },
                className: "modal-card",
                style: {
                    maxWidth: "600px"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("header", {
                        className: "modal-card-head",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "modal-card-title",
                                children: [
                                    actionType === "reject" ? "Rejeitar" : "Cancelar",
                                    " Encomenda #",
                                    orderId
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "delete",
                                "aria-label": "close",
                                onClick: handleClose
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
                        className: "modal-card-body",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                            onSubmit: handleSubmit,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "field",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                            className: "label",
                                            children: [
                                                "Motivo ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "has-text-danger",
                                                    children: "*"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "control",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                className: "input",
                                                type: "text",
                                                placeholder: `Motivo para ${actionType === "reject" ? "rejeitar" : "cancelar"} a encomenda`,
                                                value: reason,
                                                onChange: (e)=>setReason(e.target.value),
                                                required: true,
                                                disabled: isSubmitting
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "help",
                                            children: "Campo obrigat\xf3rio"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "field",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            className: "label",
                                            children: "Notas Adicionais"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "control",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                className: "textarea",
                                                placeholder: "Informa\xe7\xf5es adicionais (opcional)",
                                                value: notes,
                                                onChange: (e)=>setNotes(e.target.value),
                                                rows: 4,
                                                disabled: isSubmitting
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "field",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "control",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                className: "checkbox",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "checkbox",
                                                        checked: visibleToReseller,
                                                        onChange: (e)=>setVisibleToReseller(e.target.checked),
                                                        disabled: isSubmitting
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "ml-2",
                                                        children: "Vis\xedvel para o revendedor"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "help",
                                            children: "Se marcado, o revendedor poder\xe1 ver o motivo e as notas"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("footer", {
                        className: "modal-card-foot",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).button, {
                                whileHover: {
                                    scale: 1.05
                                },
                                whileTap: {
                                    scale: 0.95
                                },
                                className: `button ${actionType === "reject" ? "is-danger" : "is-warning"}`,
                                onClick: handleSubmit,
                                disabled: !reason.trim() || isSubmitting,
                                children: isSubmitting ? "A processar..." : actionType === "reject" ? "Rejeitar Encomenda" : "Cancelar Encomenda"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "button",
                                onClick: handleClose,
                                disabled: isSubmitting,
                                children: "Fechar"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $4c7c412c3d6b21da$export$2e2bcd8739ae039 = $4c7c412c3d6b21da$var$OrderRejectCancelModal;


const $8475c91e39555ea7$var$OrderPage = ()=>{
    const { isAuthenticated: isAuthenticated } = (0, $b622ef53e38024e7$export$1d39dc5b47e56ff0)();
    const navigate = (0, $585f8bce88e531c1$export$9770f232ac06a008)();
    const { pathname: pathname } = (0, $585f8bce88e531c1$export$45d76561a5302f2b)();
    const { userSettings: userSettings, setUserSettings: setUserSettings, systemError: systemError, setSystemError: setSystemError, error: //loading,
    //setLoading,
    error, setError: setError, success: success, setSuccess: setSuccess, modalScreen: modalScreen, setModalScreen: setModalScreen, page: page, setPage: setPage } = (0, $a55f2a94cd420149$export$c50e37a2f0a2b064)();
    const { id: id } = (0, $585f8bce88e531c1$export$99eaa27ddbbb95ef)();
    const [orderId, setOrderId] = (0, $acw62.useState)(id);
    const [orders, setOrders] = (0, $acw62.useState)([]);
    const [filters, setFilters] = (0, $acw62.useState)({
        status: window.location.search.includes("status=") ? new URLSearchParams(window.location.search).get("status") || "" : "",
        customer: window.location.search.includes("customer=") ? new URLSearchParams(window.location.search).get("customer") || "" : "",
        type: window.location.search.includes("type=") ? new URLSearchParams(window.location.search).get("type") || "" : ""
    });
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [totalPages, setTotalPages] = (0, $acw62.useState)(1);
    const [totalResults, setTotalResults] = (0, $acw62.useState)(0);
    const [perPage, setPerPage] = (0, $acw62.useState)(window.location.search.includes("per_page=") ? parseInt(new URLSearchParams(window.location.search).get("per_page") || "10") : 10);
    const [sortBy, setSortBy] = (0, $acw62.useState)("created_at");
    const [sortOrder, setSortOrder] = (0, $acw62.useState)("desc");
    const [isRejectModalOpen, setIsRejectModalOpen] = (0, $acw62.useState)(false);
    const [isCancelModalOpen, setIsCancelModalOpen] = (0, $acw62.useState)(false);
    const [currentOrder, setCurrentOrder] = (0, $acw62.useState)(null);
    const fetchOrder = async (orderId, silent = false)=>{
        if (!silent) setLoading(true);
        try {
            const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).ORDERS + `/${orderId}`);
            setCurrentOrder(response.data);
            setModalScreen({
                state: "edit",
                title: `Gerir Encomenda: #${response.data.id}`,
                childrenControlOverflow: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6802079231d88d17$export$2e2bcd8739ae039), {
                    order: response.data,
                    onAddNote: handleAddNote
                }),
                footer: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a065279d4dbd6ce6$export$2e2bcd8739ae039), {
                    order: response.data,
                    handleConfirmOrder: handleConfirmOrder,
                    handleRejectOrder: handleRejectOrder,
                    handleCancelOrder: handleCancelOrder,
                    onOpenRejectModal: ()=>setIsRejectModalOpen(true),
                    onOpenCancelModal: ()=>setIsCancelModalOpen(true),
                    onResubmitToErp: handleResubmitToErp
                }),
                onShow: ()=>{
                    handleManageOrder(response.data);
                },
                onClose: handleCloseModal
            });
        } catch (error) {
            if (!silent) setSystemError(error.message || "Erro ao buscar encomenda.");
            console.warn("Error fetching order:", error.message);
        } finally{
            if (!silent) setLoading(false);
        }
    };
    // Poll while the ERP submission is in flight so the status card updates without a reload.
    (0, $acw62.useEffect)(()=>{
        const status = currentOrder?.erp_submission_status;
        if (!orderId || status !== "PENDING" && status !== "SENDING") return;
        const timer = setInterval(()=>{
            fetchOrder(orderId, true);
        }, 3000);
        return ()=>clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentOrder?.erp_submission_status,
        orderId
    ]);
    const fetchOrders = async ()=>{
        const loading = ()=>{
            if (!id) {
                setLoading(true);
                return ()=>{
                    setTimeout(()=>setLoading(false), 500);
                };
            }
            setOrders([]);
            return ()=>{};
        };
        const closeLoading = loading();
        try {
            const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).ORDERS + `/?page=${page}&per_page=${perPage}` + (filters.status ? `&status=${encodeURIComponent(filters.status)}` : "") + (filters.customer ? `&customer=${encodeURIComponent(filters.customer)}` : "") + (filters.type ? `&type=${encodeURIComponent(filters.type)}` : "") + `&sort_by=${sortBy}&sort_direction=${sortOrder}`);
            setOrders(response.data.orders || []);
            setTotalPages(response.data.total_pages || 1);
            setTotalResults(response.data.total_results || 0);
        } catch (error) {
            console.warn("Error fetching offers:", error.message);
        } finally{
            closeLoading();
        }
    };
    const handleConfirmOrder = async (orderId)=>{
        setLoading(true);
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).post((0, $cd93687958c8007e$export$bfe19bc25132bb7c).ORDERS + `/${orderId}/_actions/confirm`);
            fetchOrder(orderId); // Refresh orders after accepting
        } catch (error) {
            console.warn("Error accepting order:", error.message);
        } finally{
            setLoading(false);
        }
    };
    const handleRejectOrder = async (orderId, reason, notes, visibleToReseller)=>{
        setLoading(true);
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).post((0, $cd93687958c8007e$export$bfe19bc25132bb7c).ORDERS + `/${orderId}/_actions/reject?reason=${encodeURIComponent(reason)}` + (notes ? `&notes=${encodeURIComponent(notes)}` : "") + `&visible_to_reseller=${visibleToReseller}`);
            setIsRejectModalOpen(false);
            fetchOrder(orderId); // Refresh order after rejecting
        } catch (error) {
            console.warn("Error rejecting order:", error.message);
        } finally{
            setLoading(false);
        }
    };
    const handleCancelOrder = async (orderId, reason, notes, visibleToReseller)=>{
        setLoading(true);
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).post((0, $cd93687958c8007e$export$bfe19bc25132bb7c).ORDERS + `/${orderId}/_actions/cancel?reason=${encodeURIComponent(reason)}` + (notes ? `&notes=${encodeURIComponent(notes)}` : "") + `&visible_to_reseller=${visibleToReseller}`);
            setIsCancelModalOpen(false);
            fetchOrder(orderId); // Refresh order after canceling
        } catch (error) {
            console.warn("Error canceling order:", error.message);
        } finally{
            setLoading(false);
        }
    };
    const handleAddNote = async (content, visibleToReseller)=>{
        if (!currentOrder) return;
        setLoading(true);
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).post((0, $cd93687958c8007e$export$bfe19bc25132bb7c).ORDERS + `/${currentOrder.id}/_actions/add-note?content=${encodeURIComponent(content)}&visible_to_reseller=${visibleToReseller}`);
            fetchOrder(currentOrder.id); // Refresh order after adding note
        } catch (error) {
            console.warn("Error adding note:", error.message);
        } finally{
            setLoading(false);
        }
    };
    const handleResubmitToErp = async (orderId, acknowledgeDuplicateRisk)=>{
        // UNKNOWN means the ERP may already have created the order — require an explicit ack.
        if (acknowledgeDuplicateRisk) {
            const ok = window.confirm("Esta encomenda est\xe1 com estado UNKNOWN no ERP: o ERP pode j\xe1 a ter criado. Reenviar pode duplicar a encomenda. Confirmar o reenvio?");
            if (!ok) return;
        }
        setLoading(true);
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).post((0, $cd93687958c8007e$export$bfe19bc25132bb7c).ORDERS + `/${orderId}/_actions/erp-resubmit?acknowledge_duplicate_risk=${acknowledgeDuplicateRisk}`);
            fetchOrder(orderId); // Refresh order after resubmitting
        } catch (error) {
            console.warn("Error resubmitting order to ERP:", error.message);
            setError(error?.response?.data?.message || error?.response?.data?.reason || error.message || "Erro ao reenviar a encomenda para o ERP.");
        } finally{
            setLoading(false);
        }
    };
    const handleManageOrder = (order)=>{
        setOrderId(order.id);
        setCurrentOrder(order);
        setModalScreen({
            state: "edit",
            title: `Gerir Encomenda: #${order.id}`,
            childrenControlOverflow: true,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6802079231d88d17$export$2e2bcd8739ae039), {
                order: order,
                onAddNote: handleAddNote
            }),
            footer: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a065279d4dbd6ce6$export$2e2bcd8739ae039), {
                order: order,
                handleConfirmOrder: handleConfirmOrder,
                handleRejectOrder: handleRejectOrder,
                handleCancelOrder: handleCancelOrder,
                onOpenRejectModal: ()=>setIsRejectModalOpen(true),
                onOpenCancelModal: ()=>setIsCancelModalOpen(true),
                onResubmitToErp: handleResubmitToErp
            }),
            onShow: ()=>{
                handleManageOrder(order);
            },
            onClose: handleCloseModal
        });
        history.pushState(history.state, "", `/orders/${order.id}`);
    };
    const handleCloseModal = (0, $acw62.useCallback)(()=>{
        setOrderId(undefined);
        setModalScreen(null);
        history.pushState(history.state, "", `/orders?page=${page}&per_page=${perPage}` + (filters.status ? `&status=${encodeURIComponent(filters.status)}` : "") + (filters.customer ? `&customer=${encodeURIComponent(filters.customer)}` : "") + (filters.type ? `&type=${encodeURIComponent(filters.type)}` : ""));
        fetchOrders(); // Refresh offers after managing
    }, [
        page,
        perPage,
        filters,
        setModalScreen
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!isAuthenticated()) navigate("/login", {
            state: {
                from: pathname
            }
        });
        if (orderId) {
            console.log("open order with id:", orderId);
            fetchOrder(orderId);
        }
        fetchOrders();
    }, [
        orderId,
        page,
        perPage,
        sortOrder,
        sortBy
    ]);
    (0, $acw62.useEffect)(()=>{
        if (page !== 1) setPage(1);
        else fetchOrders();
    }, [
        filters
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!orderId) history.replaceState(history.state, "", `/orders?page=${page}&per_page=${perPage}` + (filters.status ? `&status=${encodeURIComponent(filters.status)}` : "") + (filters.customer ? `&customer=${encodeURIComponent(filters.customer)}` : "") + (filters.type ? `&type=${encodeURIComponent(filters.type)}` : ""));
    }, [
        perPage,
        filters
    ]);
    const handlePageChange = (newPage)=>{
        setPage(newPage);
        history.pushState(history.state, "", `/orders?page=${newPage}&per_page=${perPage}` + (filters.status ? `&status=${encodeURIComponent(filters.status)}` : "") + (filters.customer ? `&customer=${encodeURIComponent(filters.customer)}` : "") + (filters.type ? `&type=${encodeURIComponent(filters.type)}` : ""));
    };
    if (!isAuthenticated()) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: "You must be logged in to edit items."
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "container mx-auto p-6 max-w-7xl",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex flex-col gap-6",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "flex flex-col md:flex-row justify-between items-start md:items-center gap-4",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "text-3xl font-bold text-gray-900 tracking-tight",
                                        children: "Encomendas"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "text-gray-600 mt-1",
                                        children: "Gerencie encomendas, confirma\xe7\xf5es e acompanhe o status de entrega."
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex flex-col gap-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91fdd63a7a7b52c4$export$2e2bcd8739ae039), {
                                    initialOrderSearchParams: filters,
                                    onFilterChange: setFilters,
                                    loading: orders.length == 0 && totalPages > 0
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "overflow-auto",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e21dd6fe324734f1$export$2e2bcd8739ae039), {
                                        orders: orders,
                                        page: page,
                                        totalPages: totalPages,
                                        perPage: perPage,
                                        setPerPage: setPerPage,
                                        setSortBy: setSortBy,
                                        sortBy: sortBy,
                                        setSortOrder: setSortOrder,
                                        sortOrder: sortOrder,
                                        handlePageChange: handlePageChange,
                                        openManageOrderModal: handleManageOrder,
                                        totalResults: totalResults,
                                        loading: loading
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            currentOrder && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4c7c412c3d6b21da$export$2e2bcd8739ae039), {
                        isOpen: isRejectModalOpen,
                        onClose: ()=>setIsRejectModalOpen(false),
                        onSubmit: (reason, notes, visibleToReseller)=>handleRejectOrder(currentOrder.id, reason, notes, visibleToReseller),
                        actionType: "reject",
                        orderId: currentOrder.id
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4c7c412c3d6b21da$export$2e2bcd8739ae039), {
                        isOpen: isCancelModalOpen,
                        onClose: ()=>setIsCancelModalOpen(false),
                        onSubmit: (reason, notes, visibleToReseller)=>handleCancelOrder(currentOrder.id, reason, notes, visibleToReseller),
                        actionType: "cancel",
                        orderId: currentOrder.id
                    })
                ]
            })
        ]
    });
};
var $8475c91e39555ea7$export$2e2bcd8739ae039 = $8475c91e39555ea7$var$OrderPage;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");





/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f36710bd138be5d0$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "m9 12 2 2 4-4",
            key: "dzmm74"
        }
    ]
];
const $f36710bd138be5d0$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("circle-check", $f36710bd138be5d0$export$3efd853dbb351e94);



const $f2352b268a4165fb$var$CompoundManageMismatchedPrices = ()=>{
    const { isAuthenticated: isAuthenticated } = (0, $b622ef53e38024e7$export$1d39dc5b47e56ff0)();
    const navigate = (0, $585f8bce88e531c1$export$9770f232ac06a008)();
    const { pathname: pathname } = (0, $585f8bce88e531c1$export$45d76561a5302f2b)();
    const { error: error, setError: setError, success: success, setSuccess: setSuccess, setLoading: setLoading } = (0, $a55f2a94cd420149$export$c50e37a2f0a2b064)();
    const [data, setData] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [updatingComponent, setUpdatingComponent] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [expandedComponents, setExpandedComponents] = (0, $acw62.useState)(new Set());
    const toggleComponent = (key)=>{
        const newExpanded = new Set(expandedComponents);
        if (newExpanded.has(key)) newExpanded.delete(key);
        else newExpanded.add(key);
        setExpandedComponents(newExpanded);
    };
    const fetchMismatchedPrices = async ()=>{
        setLoading(true);
        (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).COMPOUNDS + "/_view/mismatch_price_reseller").then((response)=>{
            setData(response.data || []);
        }, (error)=>{
            setError(error.message || "Failed to fetch mismatched prices");
            console.warn("Error fetching mismatched prices:", error.message);
        }).catch((err)=>{
            setError(err.message || "Failed to fetch mismatched prices");
            console.warn("Error fetching mismatched prices:", err.message);
        }).finally(()=>setLoading(false));
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (isAuthenticated()) fetchMismatchedPrices();
        else navigate("/login", {
            state: {
                from: pathname
            }
        });
    }, [
        isAuthenticated,
        pathname,
        navigate
    ]);
    const [successResult, setSuccessResult] = (0, $acw62.useState)(()=>{
        const saved = sessionStorage.getItem("mismatchedPrices_successResult");
        return saved ? JSON.parse(saved) : null;
    });
    (0, $acw62.useEffect)(()=>{
        if (successResult) sessionStorage.setItem("mismatchedPrices_successResult", JSON.stringify(successResult));
        else sessionStorage.removeItem("mismatchedPrices_successResult");
    }, [
        successResult
    ]);
    const [confirmModal, setConfirmModal] = (0, $acw62.useState)(null);
    const handleFixPriceClick = (event, productReference, componentTypeKey, compoundIds)=>{
        event.preventDefault();
        event.stopPropagation();
        setConfirmModal({
            isOpen: true,
            productReference: productReference,
            componentTypeKey: componentTypeKey,
            compoundIds: compoundIds
        });
    };
    const executeFixPrice = async ()=>{
        if (!confirmModal) return;
        const { productReference: productReference, componentTypeKey: componentTypeKey, compoundIds: compoundIds } = confirmModal;
        const componentKey = `${productReference}-${componentTypeKey}-${compoundIds.join(",")}`;
        setConfirmModal(null); // Close modal
        setUpdatingComponent(componentKey);
        setError(null);
        setSuccess(null);
        setSuccessResult(null);
        try {
            const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).post((0, $cd93687958c8007e$export$bfe19bc25132bb7c).COMPOUNDS + "/_actions/fix_component_price", null, {
                params: {
                    productReference: productReference,
                    componentTypeKey: componentTypeKey,
                    compoundIds: compoundIds.join(",")
                }
            });
            if (response.data.success) {
                setSuccessResult({
                    count: response.data.updatedCompounds,
                    ids: response.data.updatedCompoundIds || []
                });
                setSuccess(`Pre\xe7os atualizados com sucesso em ${response.data.updatedCompounds} computador(es)!`);
                // Refresh the data to remove the fixed component from the list
                await fetchMismatchedPrices();
            } else setError(response.data.message || "Falha ao atualizar pre\xe7os");
        } catch (err) {
            setError(err.response?.data?.message || err.message || "Falha ao atualizar pre\xe7os do componente");
            console.error("Error fixing component price:", err);
        } finally{
            setUpdatingComponent(null);
        }
    };
    if (!data) return null;
    if (!isAuthenticated()) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex items-center justify-center min-h-screen bg-gray-50",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "text-center",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                    className: "text-2xl font-bold text-gray-900 mb-2",
                    children: "Acesso Negado"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "text-gray-600",
                    children: "Voc\xea deve estar logado para visualizar esta p\xe1gina."
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "container mx-auto p-6 max-w-7xl",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex flex-col gap-6",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "flex flex-col md:flex-row justify-between items-start md:items-center gap-4",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "text-3xl font-bold text-gray-900 tracking-tight",
                                children: "Componentes com Pre\xe7os Diferentes do ERP"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "text-gray-500 mt-1",
                                children: "Lista de componentes cujos pre\xe7os configurados diferem dos pre\xe7os atuais no sistema ERP (diferen\xe7a superior a 1\u20AC)"
                            })
                        ]
                    })
                }),
                data.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "bg-white rounded-lg shadow-sm border border-gray-200 p-12 text-center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f36710bd138be5d0$export$2e2bcd8739ae039), {
                            className: "h-16 w-16 text-green-500 mx-auto mb-4"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "text-xl font-semibold text-gray-900 mb-2",
                            children: "Nenhum Componente com Diferen\xe7as de Pre\xe7o"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "text-gray-600",
                            children: "Todos os componentes est\xe3o sincronizados com os pre\xe7os do ERP."
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "grid grid-cols-1 gap-6",
                    children: data.map((item, key)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "bg-white border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "border-b border-gray-200 px-6 py-4 bg-gray-50 rounded-t-lg flex justify-between items-center cursor-pointer",
                                    onClick: ()=>toggleComponent(key),
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex items-center",
                                            children: [
                                                expandedComponents.has(key) ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b397e876e35a9277$export$2e2bcd8739ae039), {
                                                    className: "h-5 w-5 text-gray-600 mr-3"
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                                    className: "h-5 w-5 text-gray-600 mr-3"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                            className: "text-xl font-semibold text-gray-900",
                                                            children: item.component_name
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                            className: "text-sm text-gray-600 mt-1",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "font-medium",
                                                                    children: "Refer\xeancia:"
                                                                }),
                                                                " ",
                                                                item.product_reference,
                                                                " \u2022",
                                                                " ",
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "font-medium",
                                                                    children: "Produto:"
                                                                }),
                                                                " ",
                                                                item.product_name
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        item.price_mismatch_with_compound.length >= 1 && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                            onClick: (e)=>{
                                                if (!expandedComponents.has(key)) return;
                                                e.stopPropagation();
                                                const allCompoundIds = item.price_mismatch_with_compound.flatMap((m)=>m.compounds.map((c)=>c.compound_id));
                                                handleFixPriceClick(e, item.product_reference, item.component_type_key, allCompoundIds);
                                            },
                                            className: `flex items-center px-4 py-2 text-white rounded-lg transition-colors text-sm font-medium shadow-sm 
                        ${item.price_mismatch_with_compound.length > 1 ? "bg-blue-600 hover:bg-blue-700 cursor-pointer" : "bg-blue-400 hover:bg-blue-700"} 
                        ${expandedComponents.has(key) ? "" : "cursor-not-allowed opacity-50"}
                        `,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                                                    className: "h-4 w-4 mr-2"
                                                }),
                                                "Corrigir Todos (",
                                                item.price_mismatch_with_compound.reduce((acc, curr)=>acc + curr.compounds.length, 0),
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                expandedComponents.has(key) && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "p-6 space-y-6",
                                    children: item.price_mismatch_with_compound.map((mismatch, idx)=>{
                                        const componentKey = `${item.product_reference} -${item.component_type_key} `;
                                        const isUpdating = updatingComponent === componentKey;
                                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "border border-gray-200 rounded-lg p-5 bg-gray-50",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "grid grid-cols-1 md:grid-cols-2 gap-6 mb-4",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "space-y-3",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                                    className: "font-semibold text-gray-700 text-sm uppercase tracking-wide",
                                                                    children: "Pre\xe7os REV4"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "space-y-2",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: "flex justify-between items-center",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "text-sm text-gray-600",
                                                                                    children: "Configurado:"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                    className: "text-sm font-medium text-gray-900",
                                                                                    children: [
                                                                                        mismatch.defined_rev_price.toFixed(2),
                                                                                        " \u20AC"
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: "flex justify-between items-center",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "text-sm text-gray-600",
                                                                                    children: "ERP Atual:"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                    className: "text-sm font-medium text-gray-900",
                                                                                    children: [
                                                                                        mismatch.erp_rev_price.toFixed(2),
                                                                                        " \u20AC"
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        mismatch.price_override && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: "flex justify-between items-center pt-2 border-t border-gray-300",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "text-sm text-gray-600",
                                                                                    children: "Pre\xe7o Redefinido:"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                    className: "text-sm font-medium text-purple-600",
                                                                                    children: [
                                                                                        mismatch.price_override.toFixed(2),
                                                                                        " \u20AC"
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: "flex justify-between items-center pt-2 border-t border-gray-300",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "text-sm font-semibold text-gray-700",
                                                                                    children: "Diferen\xe7a:"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                    className: `text - sm font - bold ${mismatch.difference_rev_price > 0 ? "text-yellow-600" : "text-red-600"} `,
                                                                                    children: [
                                                                                        mismatch.difference_rev_price > 0 ? "+" : "",
                                                                                        mismatch.difference_rev_price.toFixed(2),
                                                                                        " \u20AC"
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "space-y-3",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                                    className: "font-semibold text-gray-700 text-sm uppercase tracking-wide",
                                                                    children: "Pre\xe7os de Custo"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "space-y-2",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: "flex justify-between items-center",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "text-sm text-gray-600",
                                                                                    children: "Configurado:"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                    className: "text-sm font-medium text-gray-900",
                                                                                    children: [
                                                                                        mismatch.defined_cost_price.toFixed(2),
                                                                                        " \u20AC"
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: "flex justify-between items-center",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "text-sm text-gray-600",
                                                                                    children: "ERP Atual:"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                    className: "text-sm font-medium text-gray-900",
                                                                                    children: [
                                                                                        mismatch.erp_cost_price.toFixed(2),
                                                                                        " \u20AC"
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: "flex justify-between items-center pt-4 border-t border-gray-300",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "text-sm font-semibold text-gray-700",
                                                                                    children: "Diferen\xe7a:"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                    className: `text - sm font - bold ${mismatch.difference_cost_price > 0 ? "text-yellow-600" : "text-red-600"} `,
                                                                                    children: [
                                                                                        mismatch.difference_cost_price > 0 ? "+" : "",
                                                                                        mismatch.difference_cost_price.toFixed(2),
                                                                                        " ",
                                                                                        "\u20AC"
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "flex items-center justify-between pt-4 border-t border-gray-200",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            onClick: (e)=>handleFixPriceClick(e, item.product_reference, item.component_type_key, mismatch.compounds.map((c)=>c.compound_id)),
                                                            disabled: isUpdating,
                                                            className: `flex items-center px-4 py-2 rounded-lg font-medium text-sm transition-all duration-200 ${isUpdating ? "bg-gray-300 text-gray-500 cursor-not-allowed" : "bg-blue-600 text-white hover:bg-blue-700 hover:shadow-md active:scale-95"} `,
                                                            children: isUpdating ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                                                                        className: "animate-spin h-4 w-4 mr-2"
                                                                    }),
                                                                    "A Atualizar..."
                                                                ]
                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                                                                        className: "h-5 w-5 mr-2"
                                                                    }),
                                                                    "Corrigir Pre\xe7o (",
                                                                    mismatch.compounds.length,
                                                                    " ",
                                                                    mismatch.compounds.length === 1 ? "computador" : "computadores",
                                                                    ")"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("details", {
                                                            className: "group",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("summary", {
                                                                    className: "cursor-pointer text-sm font-medium text-blue-600 hover:text-blue-700 list-none",
                                                                    children: [
                                                                        "Ver Computadores (",
                                                                        mismatch.compounds.length,
                                                                        ")"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "mt-3 max-h-48 overflow-y-auto bg-white border border-gray-200 rounded-md p-3",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                                                        className: "space-y-1",
                                                                        children: mismatch.compounds.map((compound, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                                                onClick: ()=>navigate("/catalog/compound/" + encodeURIComponent(compound.compound_id)),
                                                                                className: "text-xs font-mono text-gray-700 hover:text-blue-600 hover:bg-blue-50 px-2 py-1 rounded cursor-pointer transition-colors",
                                                                                children: [
                                                                                    compound.compound_id,
                                                                                    " \u2022",
                                                                                    " ",
                                                                                    compound.optional ? "Opcional" : "Base",
                                                                                    " ",
                                                                                    "\u2022 ",
                                                                                    compound.status
                                                                                ]
                                                                            }, index))
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, idx);
                                    })
                                })
                            ]
                        }, key))
                }),
                confirmModal && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67ac64808127e67c$export$2e2bcd8739ae039), {
                    title: "Confirmar Atualiza\xe7\xe3o",
                    state: confirmModal.isOpen ? "confirm" : "closed",
                    onClose: ()=>setConfirmModal(null),
                    footer: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex justify-end space-x-3 p-4",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>setConfirmModal(null),
                                className: "px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors font-medium",
                                children: "Cancelar"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: executeFixPrice,
                                className: "px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium",
                                children: "Confirmar"
                            })
                        ]
                    }),
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "p-4",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "text-gray-700 mb-4",
                                children: [
                                    "Tem a certeza que pretende atualizar os pre\xe7os deste componente em",
                                    " ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "font-bold",
                                        children: confirmModal.compoundIds.length
                                    }),
                                    " ",
                                    "computador(es)?"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "bg-yellow-50 border-l-4 border-yellow-400 p-4",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "font-medium text-yellow-800 mb-2",
                                        children: "Esta a\xe7\xe3o ir\xe1:"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                        className: "list-disc list-inside text-sm text-yellow-700 space-y-1",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Atualizar o pre\xe7o configurado para o pre\xe7o ERP atual"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Remover qualquer pre\xe7o redefinido"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Aplicar as altera\xe7\xf5es apenas aos computadores selecionados"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                updatingComponent && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "fixed inset-0 bg-black/50 flex items-center justify-center z-50",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "bg-white p-6 rounded-lg shadow-xl flex flex-col items-center",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                                className: "h-10 w-10 text-blue-600 animate-spin mb-4"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                className: "text-lg font-semibold text-gray-900",
                                children: "A atualizar pre\xe7os..."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "text-sm text-gray-500 mt-2",
                                children: "Por favor aguarde enquanto processamos a atualiza\xe7\xe3o."
                            })
                        ]
                    })
                }),
                successResult && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67ac64808127e67c$export$2e2bcd8739ae039), {
                    title: "Atualiza\xe7\xe3o Conclu\xedda",
                    state: "info",
                    onClose: ()=>setSuccessResult(null),
                    footer: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex justify-end p-4",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>setSuccessResult(null),
                            className: "px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium",
                            children: "Fechar"
                        })
                    }),
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "p-4",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center mb-4 text-green-600",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f36710bd138be5d0$export$2e2bcd8739ae039), {
                                        className: "h-6 w-6 mr-2"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "font-semibold text-lg",
                                        children: [
                                            successResult.count,
                                            " computador(es) atualizado(s) com sucesso!"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "text-gray-600 mb-4",
                                children: "Os seguintes computadores foram atualizados e recalculados:"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "bg-gray-50 rounded-lg border border-gray-200 max-h-60 overflow-y-auto",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                    className: "divide-y divide-gray-200",
                                    children: successResult.ids.map((id)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                            className: "p-3 hover:bg-gray-100 transition-colors flex justify-between items-center",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "font-mono text-sm font-medium text-gray-700",
                                                    children: id
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                    href: `/catalog/compound/${encodeURIComponent(id)}`,
                                                    rel: "noopener noreferrer",
                                                    className: "text-blue-600 hover:text-blue-800 text-sm font-medium hover:underline",
                                                    children: "Ver / Editar"
                                                })
                                            ]
                                        }, id))
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $f2352b268a4165fb$export$2e2bcd8739ae039 = $f2352b268a4165fb$var$CompoundManageMismatchedPrices;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");





/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $24cff55063beeb2a$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M14 4a2 2 0 0 1 2-2",
            key: "1w2hp7"
        }
    ],
    [
        "path",
        {
            d: "M16 10a2 2 0 0 1-2-2",
            key: "shjach"
        }
    ],
    [
        "path",
        {
            d: "M20 2a2 2 0 0 1 2 2",
            key: "188mtx"
        }
    ],
    [
        "path",
        {
            d: "M22 8a2 2 0 0 1-2 2",
            key: "ddf4tu"
        }
    ],
    [
        "path",
        {
            d: "m3 7 3 3 3-3",
            key: "x25e72"
        }
    ],
    [
        "path",
        {
            d: "M6 10V5a3 3 0 0 1 3-3h1",
            key: "3y3t5z"
        }
    ],
    [
        "rect",
        {
            x: "2",
            y: "14",
            width: "8",
            height: "8",
            rx: "2",
            key: "4rksxw"
        }
    ]
];
const $24cff55063beeb2a$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("replace", $24cff55063beeb2a$export$3efd853dbb351e94);



function $47facc52c81cf178$export$109361fea24c3125(equivalents, sortBy) {
    const sorted = [
        ...equivalents
    ];
    switch(sortBy){
        case "price":
            sorted.sort((a, b)=>{
                const pa = a.rev4_price ?? Number.POSITIVE_INFINITY;
                const pb = b.rev4_price ?? Number.POSITIVE_INFINITY;
                return pa - pb;
            });
            break;
        case "name":
            sorted.sort((a, b)=>a.name.localeCompare(b.name, "pt"));
            break;
        case "stock":
            sorted.sort((a, b)=>(b.stock ?? 0) - (a.stock ?? 0));
            break;
    }
    return sorted;
}


const $9eaf012e3d5a9bf1$var$STOCK_THRESHOLD = 5;
const $9eaf012e3d5a9bf1$var$CompoundManageStockReplacement = ()=>{
    const { isAuthenticated: isAuthenticated } = (0, $b622ef53e38024e7$export$1d39dc5b47e56ff0)();
    const navigate = (0, $585f8bce88e531c1$export$9770f232ac06a008)();
    const { pathname: pathname } = (0, $585f8bce88e531c1$export$45d76561a5302f2b)();
    const { error: error, loading: loading, setError: setError, setSuccess: setSuccess, setLoading: setLoading } = (0, $a55f2a94cd420149$export$c50e37a2f0a2b064)();
    const [data, setData] = (0, $acw62.useState)([]);
    const [expandedComponents, setExpandedComponents] = (0, $acw62.useState)(new Set());
    const [equivalentsModal, setEquivalentsModal] = (0, $acw62.useState)(null);
    const [equivalents, setEquivalents] = (0, $acw62.useState)([]);
    const [equivalentsSort, setEquivalentsSort] = (0, $acw62.useState)("price");
    const [loadingEquivalents, setLoadingEquivalents] = (0, $acw62.useState)(false);
    const [equivalentsError, setEquivalentsError] = (0, $acw62.useState)(null);
    const [selectedEquivalent, setSelectedEquivalent] = (0, $acw62.useState)(null);
    const [confirmModal, setConfirmModal] = (0, $acw62.useState)(null);
    const itemKey = (item)=>`${item.product_reference}:${item.component_type_key}`;
    const toggleComponent = (key)=>{
        const newExpanded = new Set(expandedComponents);
        if (newExpanded.has(key)) newExpanded.delete(key);
        else newExpanded.add(key);
        setExpandedComponents(newExpanded);
    };
    const fetchLowStock = async ()=>{
        setLoading(true);
        setError(null);
        setSuccess(null);
        try {
            const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).COMPOUNDS + "/_view/components_low_stock", {
                params: {
                    maxStock: $9eaf012e3d5a9bf1$var$STOCK_THRESHOLD
                }
            });
            setData(response.data || []);
            return true;
        } catch (err) {
            setError(err.message || "Failed to fetch low stock components");
            console.warn("Error fetching low stock components:", err.message);
            return false;
        } finally{
            setLoading(false);
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (isAuthenticated()) fetchLowStock();
        else navigate("/login", {
            state: {
                from: pathname
            }
        });
    }, [
        isAuthenticated,
        pathname,
        navigate
    ]);
    const openEquivalents = async (item)=>{
        setEquivalentsModal({
            item: item
        });
        setSelectedEquivalent(null);
        setEquivalents([]);
        setEquivalentsSort("price");
        setEquivalentsError(null);
        setLoadingEquivalents(true);
        setError(null);
        setSuccess(null);
        try {
            const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).COMPOUNDS + "/_view/component_stock_equivalents", {
                params: {
                    productReference: item.product_reference,
                    componentTypeKey: item.component_type_key
                }
            });
            setEquivalents(response.data || []);
        } catch (err) {
            setEquivalentsError(err.message || "Falha ao carregar equivalentes");
            setError(err.message || "Failed to fetch equivalents");
        } finally{
            setLoadingEquivalents(false);
        }
    };
    const requestReplace = (candidate)=>{
        if (!equivalentsModal) return;
        const { item: item } = equivalentsModal;
        setEquivalentsModal(null);
        setConfirmModal({
            fromProductReference: item.product_reference,
            componentTypeKey: item.component_type_key,
            toProductReference: candidate.id,
            compoundIds: item.compounds.map((c)=>c.compound_id)
        });
    };
    const executeReplace = async ()=>{
        if (!confirmModal) return;
        const { fromProductReference: fromProductReference, componentTypeKey: componentTypeKey, toProductReference: toProductReference, compoundIds: compoundIds } = confirmModal;
        setConfirmModal(null);
        setError(null);
        setSuccess(null);
        setLoading(true);
        try {
            const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).post((0, $cd93687958c8007e$export$bfe19bc25132bb7c).COMPOUNDS + "/_actions/replace_component", null, {
                params: {
                    fromProductReference: fromProductReference,
                    componentTypeKey: componentTypeKey,
                    toProductReference: toProductReference,
                    compoundIds: compoundIds.join(",")
                }
            });
            // Refresh first so the error/success toast set below isn't immediately cleared
            // by fetchLowStock()'s setError(null).
            const refreshed = await fetchLowStock();
            const updated = response.data.updatedCompounds ?? 0;
            const failed = response.data.failedCompounds ?? 0;
            if (!response.data.success || updated === 0) setError(response.data.message || "Falha ao substituir componente (0 m\xe1quinas)");
            else if (!refreshed) setError(`Componente substitu\xeddo em ${updated} computador(es), mas a lista n\xe3o p\xf4de ser atualizada`);
            else if (failed > 0) setSuccess(`Componente substitu\xeddo em ${updated} computador(es), ${failed} falha(s)!`);
            else setSuccess(`Componente substitu\xeddo em ${updated} computador(es)!`);
        } catch (err) {
            setError(err.response?.data?.message || err.message || "Falha ao substituir componente");
            console.error("Error replacing component:", err);
        } finally{
            setLoading(false);
        }
    };
    if (!isAuthenticated()) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex items-center justify-center min-h-screen bg-gray-50",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "text-center",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                    className: "text-2xl font-bold text-gray-900 mb-2",
                    children: "Acesso Negado"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "text-gray-600",
                    children: "Voc\xea deve estar logado para visualizar esta p\xe1gina."
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "container mx-auto p-6 max-w-7xl",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex flex-col gap-6",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex flex-col md:flex-row justify-between items-start md:items-center gap-4",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "text-3xl font-bold text-gray-900 tracking-tight",
                                    children: "Componentes sem Stock (SAG)"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "text-gray-500 mt-1",
                                    children: [
                                        "Componentes com stock SAG igual ou abaixo de ",
                                        $9eaf012e3d5a9bf1$var$STOCK_THRESHOLD,
                                        " ",
                                        "unidades, presentes nas m\xe1quinas do cat\xe1logo. Substitua por um equivalente com stock."
                                    ]
                                })
                            ]
                        })
                    }),
                    loading ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "bg-white rounded-lg shadow-sm border border-gray-200 p-12 text-center text-gray-600",
                        children: "A carregar componentes..."
                    }) : data.length === 0 ? error ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "bg-white rounded-lg shadow-sm border border-gray-200 p-12 text-center text-gray-600",
                        children: "N\xe3o foi poss\xedvel carregar a lista de componentes."
                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "bg-white rounded-lg shadow-sm border border-gray-200 p-12 text-center",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f36710bd138be5d0$export$2e2bcd8739ae039), {
                                className: "h-16 w-16 text-green-500 mx-auto mb-4"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                className: "text-xl font-semibold text-gray-900 mb-2",
                                children: "Nenhum Componente Sem Stock"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "text-gray-600",
                                children: "Todos os componentes das m\xe1quinas t\xeam stock suficiente no SAG."
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "grid grid-cols-1 gap-6",
                        children: data.map((item)=>{
                            const key = itemKey(item);
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "bg-white border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "border-b border-gray-200 px-6 py-4 bg-gray-50 rounded-t-lg flex flex-wrap items-center justify-between gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                type: "button",
                                                "aria-expanded": expandedComponents.has(key),
                                                "aria-controls": `${key}-machines`,
                                                onClick: ()=>toggleComponent(key),
                                                className: "flex items-center flex-1 min-w-0 text-left cursor-pointer",
                                                children: [
                                                    expandedComponents.has(key) ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b397e876e35a9277$export$2e2bcd8739ae039), {
                                                        className: "h-5 w-5 text-gray-600 mr-3 shrink-0"
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                                        className: "h-5 w-5 text-gray-600 mr-3 shrink-0"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                                className: "text-xl font-semibold text-gray-900",
                                                                children: item.component_name || item.product_name
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "text-sm text-gray-600 mt-1",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "font-medium",
                                                                        children: "Refer\xeancia:"
                                                                    }),
                                                                    " ",
                                                                    item.product_reference,
                                                                    " \u2022",
                                                                    " ",
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "font-medium",
                                                                        children: "Produto:"
                                                                    }),
                                                                    " ",
                                                                    item.product_name
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex items-center gap-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: `tag is-light text-xs font-bold ${item.erp_stock === 0 ? "is-danger" : "is-warning"}`,
                                                        children: [
                                                            "Stock SAG: ",
                                                            item.erp_stock
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                        onClick: ()=>openEquivalents(item),
                                                        className: "flex items-center px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors text-sm font-medium shadow-sm",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $24cff55063beeb2a$export$2e2bcd8739ae039), {
                                                                className: "h-4 w-4 mr-2"
                                                            }),
                                                            "Substituir por Equivalente (",
                                                            item.compounds.length,
                                                            ")"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    expandedComponents.has(key) && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        id: `${key}-machines`,
                                        className: "p-6 space-y-4",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("details", {
                                            className: "group",
                                            open: true,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("summary", {
                                                    className: "cursor-pointer text-sm font-medium text-blue-600 hover:text-blue-700 list-none",
                                                    children: [
                                                        "Ver Computadores (",
                                                        item.compounds.length,
                                                        ")"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "mt-3 max-h-56 overflow-y-auto bg-white border border-gray-200 rounded-md p-3",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                                        className: "space-y-1",
                                                        children: item.compounds.map((compound, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                    onClick: ()=>navigate("/catalog/compound/" + encodeURIComponent(compound.compound_id)),
                                                                    className: "w-full text-left text-xs font-mono text-gray-700 hover:text-blue-600 hover:bg-blue-50 px-2 py-1 rounded cursor-pointer transition-colors",
                                                                    children: [
                                                                        compound.compound_id,
                                                                        " \u2022",
                                                                        " ",
                                                                        compound.optional ? "Opcional" : "Base",
                                                                        " \u2022",
                                                                        " ",
                                                                        compound.status
                                                                    ]
                                                                })
                                                            }, index))
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }, key);
                        })
                    })
                ]
            }),
            equivalentsModal && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67ac64808127e67c$export$2e2bcd8739ae039), {
                title: "Encontrar Equivalente",
                state: "view",
                onClose: ()=>setEquivalentsModal(null),
                footer: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex justify-end space-x-3 p-4",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>setEquivalentsModal(null),
                            className: "px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors font-medium",
                            children: "Cancelar"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>selectedEquivalent && requestReplace(selectedEquivalent),
                            disabled: !selectedEquivalent,
                            className: `px-4 py-2 rounded-lg transition-colors font-medium ${selectedEquivalent ? "bg-blue-600 text-white hover:bg-blue-700" : "bg-gray-300 text-gray-500 cursor-not-allowed"}`,
                            children: "Continuar"
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "p-4",
                    children: [
                        equivalentsModal && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mb-4 p-4 bg-gray-50 border border-gray-200 rounded-lg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "text-xs uppercase tracking-wide text-gray-500 font-semibold mb-2",
                                    children: "Componente atual"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "text-sm",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "font-medium text-gray-700",
                                            children: "Refer\xeancia:"
                                        }),
                                        " ",
                                        equivalentsModal.item.product_reference
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "text-sm",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "font-medium text-gray-700",
                                            children: "Modelo:"
                                        }),
                                        " ",
                                        equivalentsModal.item.product_name
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex gap-4 mt-1 text-xs text-gray-700",
                                    children: [
                                        equivalentsModal.item.rev4_price != null && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            children: [
                                                "Pre\xe7o Rev4:",
                                                " ",
                                                equivalentsModal.item.rev4_price.toLocaleString("pt-PT", {
                                                    style: "currency",
                                                    currency: "EUR"
                                                })
                                            ]
                                        }),
                                        equivalentsModal.item.cost_price != null && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            children: [
                                                "Pre\xe7o Custo:",
                                                " ",
                                                equivalentsModal.item.cost_price.toLocaleString("pt-PT", {
                                                    style: "currency",
                                                    currency: "EUR"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "text-sm mt-1",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "font-medium text-gray-700",
                                            children: "Stock SAG:"
                                        }),
                                        " ",
                                        equivalentsModal.item.erp_stock
                                    ]
                                })
                            ]
                        }),
                        loadingEquivalents ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex items-center justify-center py-12",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                                    className: "animate-spin h-6 w-6 text-gray-500 mr-2"
                                }),
                                "A carregar equivalentes..."
                            ]
                        }) : equivalentsError ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "text-center py-12 text-gray-600",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dcddce55b19e141b$export$2e2bcd8739ae039), {
                                    className: "h-12 w-12 text-gray-400 mx-auto mb-3"
                                }),
                                "Falha ao carregar os equivalentes: ",
                                equivalentsError
                            ]
                        }) : equivalents.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "text-center py-12 text-gray-600",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dcddce55b19e141b$export$2e2bcd8739ae039), {
                                    className: "h-12 w-12 text-gray-400 mx-auto mb-3"
                                }),
                                "N\xe3o foram encontrados equivalentes com stock dispon\xedvel."
                            ]
                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex items-center gap-2 mb-3",
                                    role: "group",
                                    "aria-label": "Ordenar equivalentes",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "text-xs text-gray-500 font-medium",
                                            children: "Ordenar:"
                                        }),
                                        [
                                            "price",
                                            "name",
                                            "stock"
                                        ].map((key)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                type: "button",
                                                "aria-pressed": equivalentsSort === key,
                                                onClick: ()=>setEquivalentsSort(key),
                                                className: `px-2 py-1 text-xs rounded border transition-colors ${equivalentsSort === key ? "bg-blue-600 text-white border-blue-600" : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"}`,
                                                children: key === "price" ? "Pre\xe7o" : key === "name" ? "Nome" : "Stock"
                                            }, key))
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "space-y-2",
                                    role: "radiogroup",
                                    "aria-label": "Equivalentes",
                                    children: (0, $47facc52c81cf178$export$109361fea24c3125)(equivalents, equivalentsSort).map((candidate)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                            className: `flex items-start gap-3 p-3 border rounded-lg cursor-pointer transition-colors ${selectedEquivalent?.id === candidate.id ? "border-blue-500 bg-blue-50" : "border-gray-200 hover:bg-gray-50"}`,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "radio",
                                                    name: "equivalent",
                                                    value: candidate.id,
                                                    checked: selectedEquivalent?.id === candidate.id,
                                                    onChange: ()=>setSelectedEquivalent(candidate),
                                                    className: "mt-1"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "flex-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "flex justify-between items-start",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                            className: "font-medium text-gray-900",
                                                                            children: candidate.name
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                            className: "text-xs text-gray-600",
                                                                            children: [
                                                                                candidate.brand && `Marca: ${candidate.brand}`,
                                                                                candidate.categoryName && ` \u{2022} ${candidate.categoryName}`
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                    className: `tag is-light text-xs font-bold ${candidate.stock > 0 ? "is-success" : "is-danger"}`,
                                                                    children: [
                                                                        "Stock: ",
                                                                        candidate.stock
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "flex gap-4 mt-2 text-xs text-gray-700",
                                                            children: [
                                                                candidate.rev4_price != null && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                    children: [
                                                                        "Rev4:",
                                                                        " ",
                                                                        candidate.rev4_price.toLocaleString("pt-PT", {
                                                                            style: "currency",
                                                                            currency: "EUR"
                                                                        })
                                                                    ]
                                                                }),
                                                                candidate.cost_price != null && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                    children: [
                                                                        "Custo:",
                                                                        " ",
                                                                        candidate.cost_price.toLocaleString("pt-PT", {
                                                                            style: "currency",
                                                                            currency: "EUR"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, candidate.id))
                                })
                            ]
                        })
                    ]
                })
            }),
            confirmModal && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67ac64808127e67c$export$2e2bcd8739ae039), {
                title: "Confirmar Substitui\xe7\xe3o",
                state: "confirm",
                onClose: ()=>setConfirmModal(null),
                footer: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex justify-end space-x-3 p-4",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>setConfirmModal(null),
                            className: "px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors font-medium",
                            children: "Cancelar"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: executeReplace,
                            className: "px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium",
                            children: "Confirmar"
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "p-4",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "text-gray-700 mb-4",
                            children: [
                                "Tem a certeza que pretende substituir este componente em",
                                " ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "font-bold",
                                    children: confirmModal.compoundIds.length
                                }),
                                " ",
                                "computador(es)?"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "bg-yellow-50 border-l-4 border-yellow-400 p-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "font-medium text-yellow-800 mb-2",
                                    children: "Esta a\xe7\xe3o ir\xe1:"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                    className: "list-disc list-inside text-sm text-yellow-700 space-y-1",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            children: "Substituir a refer\xeancia pelo equivalente selecionado"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            children: "Aplicar os pre\xe7os ERP do novo produto"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            children: "Recalcular os pre\xe7os da m\xe1quina (price engine)"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            children: "Remover qualquer pre\xe7o redefinido"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $9eaf012e3d5a9bf1$export$2e2bcd8739ae039 = $9eaf012e3d5a9bf1$var$CompoundManageStockReplacement;



var $ayMG0 = parcelRequire("ayMG0");



var $acw62 = parcelRequire("acw62");



/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $9bfa6564caba0fd2$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "9",
            cy: "12",
            r: "3",
            key: "u3jwor"
        }
    ],
    [
        "rect",
        {
            width: "20",
            height: "14",
            x: "2",
            y: "5",
            rx: "7",
            key: "g7kal2"
        }
    ]
];
const $9bfa6564caba0fd2$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("toggle-left", $9bfa6564caba0fd2$export$3efd853dbb351e94);



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $bBQKz = parcelRequire("bBQKz");

var $8xDHs = parcelRequire("8xDHs");

var $32yuL = parcelRequire("32yuL");

var $1WNCH = parcelRequire("1WNCH");

var $e5o5x = parcelRequire("e5o5x");

var $hABDe = parcelRequire("hABDe");

var $9bswS = parcelRequire("9bswS");
const $7adb3183a4fada57$var$$t = "linear-gradient(45deg, #ccc 25%, transparent 25%), linear-gradient(135deg, #ccc 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #ccc 75%), linear-gradient(135deg, transparent 75%, #ccc 75%) /*! @noflip */", $7adb3183a4fada57$var$It = "linear-gradient(to top, #000000, transparent), linear-gradient(to right, #ffffff, transparent) /*! @noflip */", $7adb3183a4fada57$var$Bt = {
    Button: (0, $8xDHs.styled)((0, (/*@__PURE__*/$parcel$interopDefault($bBQKz))))(()=>({
            backgroundSize: "8px 8px",
            backgroundPosition: "0 0, 4px 0, 4px -4px, 0px 4px",
            transition: "none",
            boxShadow: "0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08)",
            border: 0,
            borderRadius: 4,
            width: "24px",
            aspectRatio: "1 / 1",
            height: "24px",
            minWidth: 0
        }))
}, $7adb3183a4fada57$export$30f8104594140054 = (r)=>{
    const { bgColor: e, className: t, disablePopover: n, isBgColorValid: i, ...s } = r;
    return /* @__PURE__ */ (0, $ayMG0.jsx)($7adb3183a4fada57$var$Bt.Button, {
        disableTouchRipple: !0,
        style: {
            backgroundColor: i ? e : void 0,
            backgroundImage: i ? void 0 : $7adb3183a4fada57$var$$t,
            cursor: n ? "default" : void 0
        },
        className: `MuiColorInput-Button ${t || ""}`,
        variant: "text",
        disableElevation: !1,
        ...s
    });
}, $7adb3183a4fada57$var$Pt = {
    Container: (0, $8xDHs.styled)("div")(()=>({
            width: 300,
            padding: 8
        }))
}, $7adb3183a4fada57$var$Et = ({ children: r, className: e, position: t = "start", ...n })=>/* @__PURE__ */ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($32yuL))), {
        className: `MuiColorInput-Popover ${e || ""}`,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: t === "start" ? "left" : "right"
        },
        transformOrigin: {
            vertical: "top",
            horizontal: t === "start" ? "left" : "right"
        },
        ...n,
        children: /* @__PURE__ */ (0, $ayMG0.jsx)($7adb3183a4fada57$var$Pt.Container, {
            children: r
        })
    }), $7adb3183a4fada57$var$Nt = {
    Slider: (0, $8xDHs.styled)((0, (/*@__PURE__*/$parcel$interopDefault($1WNCH))), {
        shouldForwardProp: (r)=>r !== "$rgbaFrom" && r !== "$rgbaTo"
    })(()=>({
            height: 8,
            "& .MuiSlider-rail": {
                opacity: 1,
                // TODO: find better way for perf
                background: "linear-gradient(to right, rgba(var(--rgb-r), var(--rgb-g), var(--rgb-b), 0) 0%, rgba(var(--rgb-r), var(--rgb-g), var(--rgb-b), 1) 100%)"
            },
            "& .MuiSlider-track": {
                color: "transparent",
                border: 0
            },
            "& .MuiSlider-thumb": {
                backgroundColor: "#ffffff",
                border: "3px solid currentColor"
            }
        }))
}, $7adb3183a4fada57$var$Vt = (r)=>{
    const { rgbColor: e, style: t, className: n, ...i } = r, s = {
        "--rgb-r": e.r,
        "--rgb-g": e.g,
        "--rgb-b": e.b,
        ...t
    };
    return /* @__PURE__ */ (0, $ayMG0.jsx)($7adb3183a4fada57$var$Nt.Slider, {
        className: `MuiColorInput-AlphaSlider ${n || ""}`,
        style: s,
        ...i
    });
}, $7adb3183a4fada57$var$L = {
    up: "ArrowUp",
    down: "ArrowDown",
    left: "ArrowLeft",
    right: "ArrowRight"
}, $7adb3183a4fada57$var$Tt = {
    ArrowUp: {
        type: "hsvV",
        value: 1
    },
    ArrowDown: {
        type: "hsvV",
        value: -1
    },
    ArrowLeft: {
        type: "hsvS",
        value: -1
    },
    ArrowRight: {
        type: "hsvS",
        value: 1
    }
};
function $7adb3183a4fada57$var$Ot(r) {
    return r === $7adb3183a4fada57$var$L.up || r === $7adb3183a4fada57$var$L.down || r === $7adb3183a4fada57$var$L.left || r === $7adb3183a4fada57$var$L.right;
}
function $7adb3183a4fada57$var$W(r, e, t) {
    return Math.max(e, Math.min(r, t));
}
function $7adb3183a4fada57$var$et(r) {
    return typeof r == "number";
}
function $7adb3183a4fada57$var$rt(r, e, t) {
    const n = r.toLocaleString("en", {
        useGrouping: !1,
        minimumFractionDigits: e,
        maximumFractionDigits: t
    });
    return Number(n);
}
function $7adb3183a4fada57$var$Dt(r, e, t) {
    const n = r.getBoundingClientRect(), i = e - n.left, s = t - n.top;
    return {
        x: $7adb3183a4fada57$var$W(i / n.width, 0, 1),
        y: $7adb3183a4fada57$var$W(1 - s / n.height, 0, 1)
    };
}
function $7adb3183a4fada57$var$Lt(r) {
    const e = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(void 0);
    return e.current = r, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((...t)=>e.current?.(...t), []);
}
const $7adb3183a4fada57$var$nt = {
    Space: (0, $8xDHs.styled)("div")(()=>({
            width: "100%",
            height: "180px",
            boxSizing: "border-box",
            outline: 0,
            position: "relative",
            backgroundImage: $7adb3183a4fada57$var$It
        })),
    Thumb: (0, $8xDHs.styled)("div")(()=>({
            position: "absolute",
            border: "3px solid #ffffff",
            borderRadius: "50%",
            width: "20px",
            height: "20px",
            marginLeft: "-10px /*! @noflip */",
            marginBottom: "-10px /*! @noflip */",
            outline: 0,
            boxSizing: "border-box",
            willChange: "left, bottom",
            transition: "box-shadow 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
            "&:hover": {
                boxShadow: "0px 0px 0px 4px rgba(255 255 255 / 0.16)"
            },
            "&.MuiColorInput-Thumb-active": {
                boxShadow: "0px 0px 0px 8px rgba(255 255 255 / 0.16)"
            },
            "@media (hover: none)": {
                boxShadow: "none"
            }
        }))
}, $7adb3183a4fada57$var$jt = (r)=>{
    const { hsv: e, onChange: t, currentHue: n } = r, i = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(!1), s = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null), [a, o] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(!1), u = $7adb3183a4fada57$var$Lt((b, k)=>{
        if (!s.current) return;
        const { x: $, y: A } = $7adb3183a4fada57$var$Dt(s.current, b, k);
        t({
            s: $,
            v: A
        }), s.current && document.activeElement !== s.current && s.current.focus();
    }), w = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        i.current && (i.current = !1, o(!1));
    }, []), p = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((b)=>{
        i.current && u(b.clientX, b.clientY);
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>(document.addEventListener("pointermove", p, !1), document.addEventListener("pointerup", w, !1), ()=>{
            document.removeEventListener("pointermove", p, !1), document.removeEventListener("pointerup", w, !1);
        }), [
        w,
        p
    ]);
    const m = (b)=>{
        b.preventDefault(), i.current = !0, u(b.clientX, b.clientY), o(!0);
    }, y = (b)=>{
        if ($7adb3183a4fada57$var$Ot(b.key)) {
            b.preventDefault();
            const { type: k, value: $ } = $7adb3183a4fada57$var$Tt[b.key], A = b.shiftKey ? 10 : 1, T = k === "hsvS" ? e.s : e.v, E = $7adb3183a4fada57$var$W(T + $ * A * 0.01, 0, 1);
            o(!0), t({
                s: k === "hsvS" ? E : e.s,
                v: k === "hsvV" ? E : e.v
            });
        }
    }, M = e.s * 100, H = e.v * 100;
    return /* @__PURE__ */ (0, $ayMG0.jsx)($7adb3183a4fada57$var$nt.Space, {
        onPointerDown: m,
        ref: s,
        className: "MuiColorInput-ColorSpace",
        style: {
            backgroundColor: `hsl(${n} 100% 50%)`,
            touchAction: "none"
        },
        role: "slider",
        "aria-valuetext": `Saturation ${$7adb3183a4fada57$var$rt(M, 0, 0)}%, Brightness ${$7adb3183a4fada57$var$rt(H, 0, 0)}%`,
        onKeyDown: y,
        tabIndex: 0,
        children: /* @__PURE__ */ (0, $ayMG0.jsx)($7adb3183a4fada57$var$nt.Thumb, {
            "aria-label": "Color space thumb",
            className: a ? "MuiColorInput-Thumb-active" : "",
            style: {
                left: `${M}%`,
                bottom: `${H}%`
            }
        })
    });
}, $7adb3183a4fada57$var$Gt = {
    Slider: (0, $8xDHs.styled)((0, (/*@__PURE__*/$parcel$interopDefault($1WNCH))))(()=>({
            height: 8,
            "& .MuiSlider-rail": {
                opacity: 1,
                background: "linear-gradient(to right, rgb(255, 0, 0) 0%, rgb(255, 255, 0) 17%, rgb(0, 255, 0) 33%, rgb(0, 255, 255) 50%, rgb(0, 0, 255) 67%, rgb(255, 0, 255) 83%, rgb(255, 0, 0) 100%) /*! @noflip */"
            },
            "& .MuiSlider-track": {
                color: "transparent",
                border: 0
            },
            "& .MuiSlider-thumb": {
                backgroundColor: "#ffffff",
                border: "3px solid currentColor"
            }
        }))
}, $7adb3183a4fada57$var$qt = (r)=>{
    const { className: e, ...t } = r;
    return /* @__PURE__ */ (0, $ayMG0.jsx)($7adb3183a4fada57$var$Gt.Slider, {
        className: `MuiColorInput-HueSlider ${e || ""}`,
        ...t
    });
};
function $7adb3183a4fada57$var$Wt(r) {
    return typeof r == "string";
}
function $7adb3183a4fada57$var$g(r, e) {
    $7adb3183a4fada57$var$Kt(r) && (r = "100%");
    const t = $7adb3183a4fada57$var$Ut(r);
    return r = e === 360 ? r : Math.min(e, Math.max(0, parseFloat(r))), t && (r = parseInt(String(r * e), 10) / 100), Math.abs(r - e) < 1e-6 ? 1 : (e === 360 ? r = (r < 0 ? r % e + e : r % e) / parseFloat(String(e)) : r = r % e / parseFloat(String(e)), r);
}
function $7adb3183a4fada57$var$j(r) {
    return Math.min(1, Math.max(0, r));
}
function $7adb3183a4fada57$var$Kt(r) {
    return typeof r == "string" && r.indexOf(".") !== -1 && parseFloat(r) === 1;
}
function $7adb3183a4fada57$var$Ut(r) {
    return typeof r == "string" && r.indexOf("%") !== -1;
}
function $7adb3183a4fada57$var$dt(r) {
    return r = parseFloat(r), (isNaN(r) || r < 0 || r > 1) && (r = 1), r;
}
function $7adb3183a4fada57$var$G(r) {
    return Number(r) <= 1 ? `${Number(r) * 100}%` : r;
}
function $7adb3183a4fada57$var$R(r) {
    return r.length === 1 ? "0" + r : String(r);
}
function $7adb3183a4fada57$var$zt(r, e, t) {
    return {
        r: $7adb3183a4fada57$var$g(r, 255) * 255,
        g: $7adb3183a4fada57$var$g(e, 255) * 255,
        b: $7adb3183a4fada57$var$g(t, 255) * 255
    };
}
function $7adb3183a4fada57$var$st(r, e, t) {
    r = $7adb3183a4fada57$var$g(r, 255), e = $7adb3183a4fada57$var$g(e, 255), t = $7adb3183a4fada57$var$g(t, 255);
    const n = Math.max(r, e, t), i = Math.min(r, e, t);
    let s = 0, a = 0;
    const o = (n + i) / 2;
    if (n === i) a = 0, s = 0;
    else {
        const u = n - i;
        switch(a = o > 0.5 ? u / (2 - n - i) : u / (n + i), n){
            case r:
                s = (e - t) / u + (e < t ? 6 : 0);
                break;
            case e:
                s = (t - r) / u + 2;
                break;
            case t:
                s = (r - e) / u + 4;
                break;
        }
        s /= 6;
    }
    return {
        h: s,
        s: a,
        l: o
    };
}
function $7adb3183a4fada57$var$Y(r, e, t) {
    return t < 0 && (t += 1), t > 1 && (t -= 1), t < 1 / 6 ? r + (e - r) * (6 * t) : t < 0.5 ? e : t < 2 / 3 ? r + (e - r) * (2 / 3 - t) * 6 : r;
}
function $7adb3183a4fada57$var$Yt(r, e, t) {
    let n, i, s;
    if (r = $7adb3183a4fada57$var$g(r, 360), e = $7adb3183a4fada57$var$g(e, 100), t = $7adb3183a4fada57$var$g(t, 100), e === 0) i = t, s = t, n = t;
    else {
        const a = t < 0.5 ? t * (1 + e) : t + e - t * e, o = 2 * t - a;
        n = $7adb3183a4fada57$var$Y(o, a, r + 1 / 3), i = $7adb3183a4fada57$var$Y(o, a, r), s = $7adb3183a4fada57$var$Y(o, a, r - 1 / 3);
    }
    return {
        r: n * 255,
        g: i * 255,
        b: s * 255
    };
}
function $7adb3183a4fada57$var$it(r, e, t) {
    r = $7adb3183a4fada57$var$g(r, 255), e = $7adb3183a4fada57$var$g(e, 255), t = $7adb3183a4fada57$var$g(t, 255);
    const n = Math.max(r, e, t), i = Math.min(r, e, t);
    let s = 0;
    const a = n, o = n - i, u = n === 0 ? 0 : o / n;
    if (n === i) s = 0;
    else {
        switch(n){
            case r:
                s = (e - t) / o + (e < t ? 6 : 0);
                break;
            case e:
                s = (t - r) / o + 2;
                break;
            case t:
                s = (r - e) / o + 4;
                break;
        }
        s /= 6;
    }
    return {
        h: s,
        s: u,
        v: a
    };
}
function $7adb3183a4fada57$var$Xt(r, e, t) {
    r = $7adb3183a4fada57$var$g(r, 360) * 6, e = $7adb3183a4fada57$var$g(e, 100), t = $7adb3183a4fada57$var$g(t, 100);
    const n = Math.floor(r), i = r - n, s = t * (1 - e), a = t * (1 - i * e), o = t * (1 - (1 - i) * e), u = n % 6, w = [
        t,
        a,
        s,
        s,
        o,
        t
    ][u], p = [
        o,
        t,
        t,
        a,
        s,
        s
    ][u], m = [
        s,
        s,
        o,
        t,
        t,
        a
    ][u];
    return {
        r: w * 255,
        g: p * 255,
        b: m * 255
    };
}
function $7adb3183a4fada57$var$at(r, e, t, n) {
    const i = [
        $7adb3183a4fada57$var$R(Math.round(r).toString(16)),
        $7adb3183a4fada57$var$R(Math.round(e).toString(16)),
        $7adb3183a4fada57$var$R(Math.round(t).toString(16))
    ];
    return n && i[0].startsWith(i[0].charAt(1)) && i[1].startsWith(i[1].charAt(1)) && i[2].startsWith(i[2].charAt(1)) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) : i.join("");
}
function $7adb3183a4fada57$var$Zt(r, e, t, n, i) {
    const s = [
        $7adb3183a4fada57$var$R(Math.round(r).toString(16)),
        $7adb3183a4fada57$var$R(Math.round(e).toString(16)),
        $7adb3183a4fada57$var$R(Math.round(t).toString(16)),
        $7adb3183a4fada57$var$R($7adb3183a4fada57$var$Qt(n))
    ];
    return i && s[0].startsWith(s[0].charAt(1)) && s[1].startsWith(s[1].charAt(1)) && s[2].startsWith(s[2].charAt(1)) && s[3].startsWith(s[3].charAt(1)) ? s[0].charAt(0) + s[1].charAt(0) + s[2].charAt(0) + s[3].charAt(0) : s.join("");
}
function $7adb3183a4fada57$var$Jt(r, e, t, n) {
    const i = r / 100, s = e / 100, a = t / 100, o = n / 100, u = 255 * (1 - i) * (1 - o), w = 255 * (1 - s) * (1 - o), p = 255 * (1 - a) * (1 - o);
    return {
        r: u,
        g: w,
        b: p
    };
}
function $7adb3183a4fada57$var$ot(r, e, t) {
    let n = 1 - r / 255, i = 1 - e / 255, s = 1 - t / 255, a = Math.min(n, i, s);
    return a === 1 ? (n = 0, i = 0, s = 0) : (n = (n - a) / (1 - a) * 100, i = (i - a) / (1 - a) * 100, s = (s - a) / (1 - a) * 100), a *= 100, {
        c: Math.round(n),
        m: Math.round(i),
        y: Math.round(s),
        k: Math.round(a)
    };
}
function $7adb3183a4fada57$var$Qt(r) {
    return Math.round(parseFloat(r) * 255).toString(16);
}
function $7adb3183a4fada57$var$ht(r) {
    return $7adb3183a4fada57$var$S(r) / 255;
}
function $7adb3183a4fada57$var$S(r) {
    return parseInt(r, 16);
}
function $7adb3183a4fada57$var$_t(r) {
    return {
        r: r >> 16,
        g: (r & 65280) >> 8,
        b: r & 255
    };
}
const $7adb3183a4fada57$var$Z = {
    aliceblue: "#f0f8ff",
    antiquewhite: "#faebd7",
    aqua: "#00ffff",
    aquamarine: "#7fffd4",
    azure: "#f0ffff",
    beige: "#f5f5dc",
    bisque: "#ffe4c4",
    black: "#000000",
    blanchedalmond: "#ffebcd",
    blue: "#0000ff",
    blueviolet: "#8a2be2",
    brown: "#a52a2a",
    burlywood: "#deb887",
    cadetblue: "#5f9ea0",
    chartreuse: "#7fff00",
    chocolate: "#d2691e",
    coral: "#ff7f50",
    cornflowerblue: "#6495ed",
    cornsilk: "#fff8dc",
    crimson: "#dc143c",
    cyan: "#00ffff",
    darkblue: "#00008b",
    darkcyan: "#008b8b",
    darkgoldenrod: "#b8860b",
    darkgray: "#a9a9a9",
    darkgreen: "#006400",
    darkgrey: "#a9a9a9",
    darkkhaki: "#bdb76b",
    darkmagenta: "#8b008b",
    darkolivegreen: "#556b2f",
    darkorange: "#ff8c00",
    darkorchid: "#9932cc",
    darkred: "#8b0000",
    darksalmon: "#e9967a",
    darkseagreen: "#8fbc8f",
    darkslateblue: "#483d8b",
    darkslategray: "#2f4f4f",
    darkslategrey: "#2f4f4f",
    darkturquoise: "#00ced1",
    darkviolet: "#9400d3",
    deeppink: "#ff1493",
    deepskyblue: "#00bfff",
    dimgray: "#696969",
    dimgrey: "#696969",
    dodgerblue: "#1e90ff",
    firebrick: "#b22222",
    floralwhite: "#fffaf0",
    forestgreen: "#228b22",
    fuchsia: "#ff00ff",
    gainsboro: "#dcdcdc",
    ghostwhite: "#f8f8ff",
    goldenrod: "#daa520",
    gold: "#ffd700",
    gray: "#808080",
    green: "#008000",
    greenyellow: "#adff2f",
    grey: "#808080",
    honeydew: "#f0fff0",
    hotpink: "#ff69b4",
    indianred: "#cd5c5c",
    indigo: "#4b0082",
    ivory: "#fffff0",
    khaki: "#f0e68c",
    lavenderblush: "#fff0f5",
    lavender: "#e6e6fa",
    lawngreen: "#7cfc00",
    lemonchiffon: "#fffacd",
    lightblue: "#add8e6",
    lightcoral: "#f08080",
    lightcyan: "#e0ffff",
    lightgoldenrodyellow: "#fafad2",
    lightgray: "#d3d3d3",
    lightgreen: "#90ee90",
    lightgrey: "#d3d3d3",
    lightpink: "#ffb6c1",
    lightsalmon: "#ffa07a",
    lightseagreen: "#20b2aa",
    lightskyblue: "#87cefa",
    lightslategray: "#778899",
    lightslategrey: "#778899",
    lightsteelblue: "#b0c4de",
    lightyellow: "#ffffe0",
    lime: "#00ff00",
    limegreen: "#32cd32",
    linen: "#faf0e6",
    magenta: "#ff00ff",
    maroon: "#800000",
    mediumaquamarine: "#66cdaa",
    mediumblue: "#0000cd",
    mediumorchid: "#ba55d3",
    mediumpurple: "#9370db",
    mediumseagreen: "#3cb371",
    mediumslateblue: "#7b68ee",
    mediumspringgreen: "#00fa9a",
    mediumturquoise: "#48d1cc",
    mediumvioletred: "#c71585",
    midnightblue: "#191970",
    mintcream: "#f5fffa",
    mistyrose: "#ffe4e1",
    moccasin: "#ffe4b5",
    navajowhite: "#ffdead",
    navy: "#000080",
    oldlace: "#fdf5e6",
    olive: "#808000",
    olivedrab: "#6b8e23",
    orange: "#ffa500",
    orangered: "#ff4500",
    orchid: "#da70d6",
    palegoldenrod: "#eee8aa",
    palegreen: "#98fb98",
    paleturquoise: "#afeeee",
    palevioletred: "#db7093",
    papayawhip: "#ffefd5",
    peachpuff: "#ffdab9",
    peru: "#cd853f",
    pink: "#ffc0cb",
    plum: "#dda0dd",
    powderblue: "#b0e0e6",
    purple: "#800080",
    rebeccapurple: "#663399",
    red: "#ff0000",
    rosybrown: "#bc8f8f",
    royalblue: "#4169e1",
    saddlebrown: "#8b4513",
    salmon: "#fa8072",
    sandybrown: "#f4a460",
    seagreen: "#2e8b57",
    seashell: "#fff5ee",
    sienna: "#a0522d",
    silver: "#c0c0c0",
    skyblue: "#87ceeb",
    slateblue: "#6a5acd",
    slategray: "#708090",
    slategrey: "#708090",
    snow: "#fffafa",
    springgreen: "#00ff7f",
    steelblue: "#4682b4",
    tan: "#d2b48c",
    teal: "#008080",
    thistle: "#d8bfd8",
    tomato: "#ff6347",
    turquoise: "#40e0d0",
    violet: "#ee82ee",
    wheat: "#f5deb3",
    white: "#ffffff",
    whitesmoke: "#f5f5f5",
    yellow: "#ffff00",
    yellowgreen: "#9acd32"
};
function $7adb3183a4fada57$var$te(r) {
    let e = {
        r: 0,
        g: 0,
        b: 0
    }, t = 1, n = null, i = null, s = null, a = !1, o = !1;
    return typeof r == "string" && (r = $7adb3183a4fada57$var$ne(r)), typeof r == "object" && ($7adb3183a4fada57$var$x(r.r) && $7adb3183a4fada57$var$x(r.g) && $7adb3183a4fada57$var$x(r.b) ? (e = $7adb3183a4fada57$var$zt(r.r, r.g, r.b), a = !0, o = String(r.r).substr(-1) === "%" ? "prgb" : "rgb") : $7adb3183a4fada57$var$x(r.h) && $7adb3183a4fada57$var$x(r.s) && $7adb3183a4fada57$var$x(r.v) ? (n = $7adb3183a4fada57$var$G(r.s), i = $7adb3183a4fada57$var$G(r.v), e = $7adb3183a4fada57$var$Xt(r.h, n, i), a = !0, o = "hsv") : $7adb3183a4fada57$var$x(r.h) && $7adb3183a4fada57$var$x(r.s) && $7adb3183a4fada57$var$x(r.l) ? (n = $7adb3183a4fada57$var$G(r.s), s = $7adb3183a4fada57$var$G(r.l), e = $7adb3183a4fada57$var$Yt(r.h, n, s), a = !0, o = "hsl") : $7adb3183a4fada57$var$x(r.c) && $7adb3183a4fada57$var$x(r.m) && $7adb3183a4fada57$var$x(r.y) && $7adb3183a4fada57$var$x(r.k) && (e = $7adb3183a4fada57$var$Jt(r.c, r.m, r.y, r.k), a = !0, o = "cmyk"), Object.prototype.hasOwnProperty.call(r, "a") && (t = r.a)), t = $7adb3183a4fada57$var$dt(t), {
        ok: a,
        format: r.format || o,
        r: Math.min(255, Math.max(e.r, 0)),
        g: Math.min(255, Math.max(e.g, 0)),
        b: Math.min(255, Math.max(e.b, 0)),
        a: t
    };
}
const $7adb3183a4fada57$var$ee = "[-\\+]?\\d+%?", $7adb3183a4fada57$var$re = "[-\\+]?\\d*\\.\\d+%?", $7adb3183a4fada57$var$C = "(?:" + $7adb3183a4fada57$var$re + ")|(?:" + $7adb3183a4fada57$var$ee + ")", $7adb3183a4fada57$var$X = "[\\s|\\(]+(" + $7adb3183a4fada57$var$C + ")[,|\\s]+(" + $7adb3183a4fada57$var$C + ")[,|\\s]+(" + $7adb3183a4fada57$var$C + ")\\s*\\)?", $7adb3183a4fada57$var$q = // eslint-disable-next-line prettier/prettier
"[\\s|\\(]+(" + $7adb3183a4fada57$var$C + ")[,|\\s]+(" + $7adb3183a4fada57$var$C + ")[,|\\s]+(" + $7adb3183a4fada57$var$C + ")[,|\\s]+(" + $7adb3183a4fada57$var$C + ")\\s*\\)?", $7adb3183a4fada57$var$v = {
    CSS_UNIT: new RegExp($7adb3183a4fada57$var$C),
    rgb: new RegExp("rgb" + $7adb3183a4fada57$var$X),
    rgba: new RegExp("rgba" + $7adb3183a4fada57$var$q),
    hsl: new RegExp("hsl" + $7adb3183a4fada57$var$X),
    hsla: new RegExp("hsla" + $7adb3183a4fada57$var$q),
    hsv: new RegExp("hsv" + $7adb3183a4fada57$var$X),
    hsva: new RegExp("hsva" + $7adb3183a4fada57$var$q),
    cmyk: new RegExp("cmyk" + $7adb3183a4fada57$var$q),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function $7adb3183a4fada57$var$ne(r) {
    if (r = r.trim().toLowerCase(), r.length === 0) return !1;
    let e = !1;
    if ($7adb3183a4fada57$var$Z[r]) r = $7adb3183a4fada57$var$Z[r], e = !0;
    else if (r === "transparent") return {
        r: 0,
        g: 0,
        b: 0,
        a: 0,
        format: "name"
    };
    let t = $7adb3183a4fada57$var$v.rgb.exec(r);
    return t ? {
        r: t[1],
        g: t[2],
        b: t[3]
    } : (t = $7adb3183a4fada57$var$v.rgba.exec(r), t ? {
        r: t[1],
        g: t[2],
        b: t[3],
        a: t[4]
    } : (t = $7adb3183a4fada57$var$v.hsl.exec(r), t ? {
        h: t[1],
        s: t[2],
        l: t[3]
    } : (t = $7adb3183a4fada57$var$v.hsla.exec(r), t ? {
        h: t[1],
        s: t[2],
        l: t[3],
        a: t[4]
    } : (t = $7adb3183a4fada57$var$v.hsv.exec(r), t ? {
        h: t[1],
        s: t[2],
        v: t[3]
    } : (t = $7adb3183a4fada57$var$v.hsva.exec(r), t ? {
        h: t[1],
        s: t[2],
        v: t[3],
        a: t[4]
    } : (t = $7adb3183a4fada57$var$v.cmyk.exec(r), t ? {
        c: t[1],
        m: t[2],
        y: t[3],
        k: t[4]
    } : (t = $7adb3183a4fada57$var$v.hex8.exec(r), t ? {
        r: $7adb3183a4fada57$var$S(t[1]),
        g: $7adb3183a4fada57$var$S(t[2]),
        b: $7adb3183a4fada57$var$S(t[3]),
        a: $7adb3183a4fada57$var$ht(t[4]),
        format: e ? "name" : "hex8"
    } : (t = $7adb3183a4fada57$var$v.hex6.exec(r), t ? {
        r: $7adb3183a4fada57$var$S(t[1]),
        g: $7adb3183a4fada57$var$S(t[2]),
        b: $7adb3183a4fada57$var$S(t[3]),
        format: e ? "name" : "hex"
    } : (t = $7adb3183a4fada57$var$v.hex4.exec(r), t ? {
        r: $7adb3183a4fada57$var$S(t[1] + t[1]),
        g: $7adb3183a4fada57$var$S(t[2] + t[2]),
        b: $7adb3183a4fada57$var$S(t[3] + t[3]),
        a: $7adb3183a4fada57$var$ht(t[4] + t[4]),
        format: e ? "name" : "hex8"
    } : (t = $7adb3183a4fada57$var$v.hex3.exec(r), t ? {
        r: $7adb3183a4fada57$var$S(t[1] + t[1]),
        g: $7adb3183a4fada57$var$S(t[2] + t[2]),
        b: $7adb3183a4fada57$var$S(t[3] + t[3]),
        format: e ? "name" : "hex"
    } : !1))))))))));
}
function $7adb3183a4fada57$var$x(r) {
    return typeof r == "number" ? !Number.isNaN(r) : $7adb3183a4fada57$var$v.CSS_UNIT.test(r);
}
class $7adb3183a4fada57$var$h {
    constructor(e = "", t = {}){
        if (e instanceof $7adb3183a4fada57$var$h) return e;
        typeof e == "number" && (e = $7adb3183a4fada57$var$_t(e)), this.originalInput = e;
        const n = $7adb3183a4fada57$var$te(e);
        this.originalInput = e, this.r = n.r, this.g = n.g, this.b = n.b, this.a = n.a, this.roundA = Math.round(100 * this.a) / 100, this.format = t.format ?? n.format, this.gradientType = t.gradientType, this.r < 1 && (this.r = Math.round(this.r)), this.g < 1 && (this.g = Math.round(this.g)), this.b < 1 && (this.b = Math.round(this.b)), this.isValid = n.ok;
    }
    isDark() {
        return this.getBrightness() < 128;
    }
    isLight() {
        return !this.isDark();
    }
    /**
   * Returns the perceived brightness of the color, from 0-255.
   */ getBrightness() {
        const e = this.toRgb();
        return (e.r * 299 + e.g * 587 + e.b * 114) / 1e3;
    }
    /**
   * Returns the perceived luminance of a color, from 0-1.
   */ getLuminance() {
        const e = this.toRgb();
        let t, n, i;
        const s = e.r / 255, a = e.g / 255, o = e.b / 255;
        return s <= 0.03928 ? t = s / 12.92 : t = Math.pow((s + 0.055) / 1.055, 2.4), a <= 0.03928 ? n = a / 12.92 : n = Math.pow((a + 0.055) / 1.055, 2.4), o <= 0.03928 ? i = o / 12.92 : i = Math.pow((o + 0.055) / 1.055, 2.4), 0.2126 * t + 0.7152 * n + 0.0722 * i;
    }
    /**
   * Returns the alpha value of a color, from 0-1.
   */ getAlpha() {
        return this.a;
    }
    /**
   * Sets the alpha value on the current color.
   *
   * @param alpha - The new alpha value. The accepted range is 0-1.
   */ setAlpha(e) {
        return this.a = $7adb3183a4fada57$var$dt(e), this.roundA = Math.round(100 * this.a) / 100, this;
    }
    /**
   * Returns whether the color is monochrome.
   */ isMonochrome() {
        const { s: e } = this.toHsl();
        return e === 0;
    }
    /**
   * Returns the object as a HSVA object.
   */ toHsv() {
        const e = $7adb3183a4fada57$var$it(this.r, this.g, this.b);
        return {
            h: e.h * 360,
            s: e.s,
            v: e.v,
            a: this.a
        };
    }
    /**
   * Returns the hsva values interpolated into a string with the following format:
   * "hsva(xxx, xxx, xxx, xx)".
   */ toHsvString() {
        const e = $7adb3183a4fada57$var$it(this.r, this.g, this.b), t = Math.round(e.h * 360), n = Math.round(e.s * 100), i = Math.round(e.v * 100);
        return this.a === 1 ? `hsv(${t}, ${n}%, ${i}%)` : `hsva(${t}, ${n}%, ${i}%, ${this.roundA})`;
    }
    /**
   * Returns the object as a HSLA object.
   */ toHsl() {
        const e = $7adb3183a4fada57$var$st(this.r, this.g, this.b);
        return {
            h: e.h * 360,
            s: e.s,
            l: e.l,
            a: this.a
        };
    }
    /**
   * Returns the hsla values interpolated into a string with the following format:
   * "hsla(xxx, xxx, xxx, xx)".
   */ toHslString() {
        const e = $7adb3183a4fada57$var$st(this.r, this.g, this.b), t = Math.round(e.h * 360), n = Math.round(e.s * 100), i = Math.round(e.l * 100);
        return this.a === 1 ? `hsl(${t}, ${n}%, ${i}%)` : `hsla(${t}, ${n}%, ${i}%, ${this.roundA})`;
    }
    /**
   * Returns the hex value of the color.
   * @param allow3Char will shorten hex value to 3 char if possible
   */ toHex(e = !1) {
        return $7adb3183a4fada57$var$at(this.r, this.g, this.b, e);
    }
    /**
   * Returns the hex value of the color -with a # prefixed.
   * @param allow3Char will shorten hex value to 3 char if possible
   */ toHexString(e = !1) {
        return "#" + this.toHex(e);
    }
    /**
   * Returns the hex 8 value of the color.
   * @param allow4Char will shorten hex value to 4 char if possible
   */ toHex8(e = !1) {
        return $7adb3183a4fada57$var$Zt(this.r, this.g, this.b, this.a, e);
    }
    /**
   * Returns the hex 8 value of the color -with a # prefixed.
   * @param allow4Char will shorten hex value to 4 char if possible
   */ toHex8String(e = !1) {
        return "#" + this.toHex8(e);
    }
    /**
   * Returns the shorter hex value of the color depends on its alpha -with a # prefixed.
   * @param allowShortChar will shorten hex value to 3 or 4 char if possible
   */ toHexShortString(e = !1) {
        return this.a === 1 ? this.toHexString(e) : this.toHex8String(e);
    }
    /**
   * Returns the object as a RGBA object.
   */ toRgb() {
        return {
            r: Math.round(this.r),
            g: Math.round(this.g),
            b: Math.round(this.b),
            a: this.a
        };
    }
    /**
   * Returns the RGBA values interpolated into a string with the following format:
   * "RGBA(xxx, xxx, xxx, xx)".
   */ toRgbString() {
        const e = Math.round(this.r), t = Math.round(this.g), n = Math.round(this.b);
        return this.a === 1 ? `rgb(${e}, ${t}, ${n})` : `rgba(${e}, ${t}, ${n}, ${this.roundA})`;
    }
    /**
   * Returns the object as a RGBA object.
   */ toPercentageRgb() {
        const e = (t)=>`${Math.round($7adb3183a4fada57$var$g(t, 255) * 100)}%`;
        return {
            r: e(this.r),
            g: e(this.g),
            b: e(this.b),
            a: this.a
        };
    }
    /**
   * Returns the RGBA relative values interpolated into a string
   */ toPercentageRgbString() {
        const e = (t)=>Math.round($7adb3183a4fada57$var$g(t, 255) * 100);
        return this.a === 1 ? `rgb(${e(this.r)}%, ${e(this.g)}%, ${e(this.b)}%)` : `rgba(${e(this.r)}%, ${e(this.g)}%, ${e(this.b)}%, ${this.roundA})`;
    }
    toCmyk() {
        return {
            ...$7adb3183a4fada57$var$ot(this.r, this.g, this.b)
        };
    }
    toCmykString() {
        const { c: e, m: t, y: n, k: i } = $7adb3183a4fada57$var$ot(this.r, this.g, this.b);
        return `cmyk(${e}, ${t}, ${n}, ${i})`;
    }
    /**
   * The 'real' name of the color -if there is one.
   */ toName() {
        if (this.a === 0) return "transparent";
        if (this.a < 1) return !1;
        const e = "#" + $7adb3183a4fada57$var$at(this.r, this.g, this.b, !1);
        for (const [t, n] of Object.entries($7adb3183a4fada57$var$Z))if (e === n) return t;
        return !1;
    }
    toString(e) {
        const t = !!e;
        e = e ?? this.format;
        let n = !1;
        const i = this.a < 1 && this.a >= 0;
        return !t && i && (e.startsWith("hex") || e === "name") ? e === "name" && this.a === 0 ? this.toName() : this.toRgbString() : (e === "rgb" && (n = this.toRgbString()), e === "prgb" && (n = this.toPercentageRgbString()), (e === "hex" || e === "hex6") && (n = this.toHexString()), e === "hex3" && (n = this.toHexString(!0)), e === "hex4" && (n = this.toHex8String(!0)), e === "hex8" && (n = this.toHex8String()), e === "name" && (n = this.toName()), e === "hsl" && (n = this.toHslString()), e === "hsv" && (n = this.toHsvString()), e === "cmyk" && (n = this.toCmykString()), n || this.toHexString());
    }
    toNumber() {
        return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
    }
    clone() {
        return new $7adb3183a4fada57$var$h(this.toString());
    }
    /**
   * Lighten the color a given amount. Providing 100 will always return white.
   * @param amount - valid between 1-100
   */ lighten(e = 10) {
        const t = this.toHsl();
        return t.l += e / 100, t.l = $7adb3183a4fada57$var$j(t.l), new $7adb3183a4fada57$var$h(t);
    }
    /**
   * Brighten the color a given amount, from 0 to 100.
   * @param amount - valid between 1-100
   */ brighten(e = 10) {
        const t = this.toRgb();
        return t.r = Math.max(0, Math.min(255, t.r - Math.round(255 * -(e / 100)))), t.g = Math.max(0, Math.min(255, t.g - Math.round(255 * -(e / 100)))), t.b = Math.max(0, Math.min(255, t.b - Math.round(255 * -(e / 100)))), new $7adb3183a4fada57$var$h(t);
    }
    /**
   * Darken the color a given amount, from 0 to 100.
   * Providing 100 will always return black.
   * @param amount - valid between 1-100
   */ darken(e = 10) {
        const t = this.toHsl();
        return t.l -= e / 100, t.l = $7adb3183a4fada57$var$j(t.l), new $7adb3183a4fada57$var$h(t);
    }
    /**
   * Mix the color with pure white, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return white.
   * @param amount - valid between 1-100
   */ tint(e = 10) {
        return this.mix("white", e);
    }
    /**
   * Mix the color with pure black, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return black.
   * @param amount - valid between 1-100
   */ shade(e = 10) {
        return this.mix("black", e);
    }
    /**
   * Desaturate the color a given amount, from 0 to 100.
   * Providing 100 will is the same as calling greyscale
   * @param amount - valid between 1-100
   */ desaturate(e = 10) {
        const t = this.toHsl();
        return t.s -= e / 100, t.s = $7adb3183a4fada57$var$j(t.s), new $7adb3183a4fada57$var$h(t);
    }
    /**
   * Saturate the color a given amount, from 0 to 100.
   * @param amount - valid between 1-100
   */ saturate(e = 10) {
        const t = this.toHsl();
        return t.s += e / 100, t.s = $7adb3183a4fada57$var$j(t.s), new $7adb3183a4fada57$var$h(t);
    }
    /**
   * Completely desaturates a color into greyscale.
   * Same as calling `desaturate(100)`
   */ greyscale() {
        return this.desaturate(100);
    }
    /**
   * Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
   * Values outside of this range will be wrapped into this range.
   */ spin(e) {
        const t = this.toHsl(), n = (t.h + e) % 360;
        return t.h = n < 0 ? 360 + n : n, new $7adb3183a4fada57$var$h(t);
    }
    /**
   * Mix the current color a given amount with another color, from 0 to 100.
   * 0 means no mixing (return current color).
   */ mix(e, t = 50) {
        const n = this.toRgb(), i = new $7adb3183a4fada57$var$h(e).toRgb(), s = t / 100, a = {
            r: (i.r - n.r) * s + n.r,
            g: (i.g - n.g) * s + n.g,
            b: (i.b - n.b) * s + n.b,
            a: (i.a - n.a) * s + n.a
        };
        return new $7adb3183a4fada57$var$h(a);
    }
    analogous(e = 6, t = 30) {
        const n = this.toHsl(), i = 360 / t, s = [
            this
        ];
        for(n.h = (n.h - (i * e >> 1) + 720) % 360; --e;)n.h = (n.h + i) % 360, s.push(new $7adb3183a4fada57$var$h(n));
        return s;
    }
    /**
   * taken from https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js
   */ complement() {
        const e = this.toHsl();
        return e.h = (e.h + 180) % 360, new $7adb3183a4fada57$var$h(e);
    }
    monochromatic(e = 6) {
        const t = this.toHsv(), { h: n } = t, { s: i } = t;
        let { v: s } = t;
        const a = [], o = 1 / e;
        for(; e--;)a.push(new $7adb3183a4fada57$var$h({
            h: n,
            s: i,
            v: s
        })), s = (s + o) % 1;
        return a;
    }
    splitcomplement() {
        const e = this.toHsl(), { h: t } = e;
        return [
            this,
            new $7adb3183a4fada57$var$h({
                h: (t + 72) % 360,
                s: e.s,
                l: e.l
            }),
            new $7adb3183a4fada57$var$h({
                h: (t + 216) % 360,
                s: e.s,
                l: e.l
            })
        ];
    }
    /**
   * Compute how the color would appear on a background
   */ onBackground(e) {
        const t = this.toRgb(), n = new $7adb3183a4fada57$var$h(e).toRgb(), i = t.a + n.a * (1 - t.a);
        return new $7adb3183a4fada57$var$h({
            r: (t.r * t.a + n.r * n.a * (1 - t.a)) / i,
            g: (t.g * t.a + n.g * n.a * (1 - t.a)) / i,
            b: (t.b * t.a + n.b * n.a * (1 - t.a)) / i,
            a: i
        });
    }
    /**
   * Alias for `polyad(3)`
   */ triad() {
        return this.polyad(3);
    }
    /**
   * Alias for `polyad(4)`
   */ tetrad() {
        return this.polyad(4);
    }
    /**
   * Get polyad colors, like (for 1, 2, 3, 4, 5, 6, 7, 8, etc...)
   * monad, dyad, triad, tetrad, pentad, hexad, heptad, octad, etc...
   */ polyad(e) {
        const t = this.toHsl(), { h: n } = t, i = [
            this
        ], s = 360 / e;
        for(let a = 1; a < e; a++)i.push(new $7adb3183a4fada57$var$h({
            h: (n + a * s) % 360,
            s: t.s,
            l: t.l
        }));
        return i;
    }
    /**
   * compare color vs current color
   */ equals(e) {
        const t = new $7adb3183a4fada57$var$h(e);
        return this.format === "cmyk" || t.format === "cmyk" ? this.toCmykString() === t.toCmykString() : this.toRgbString() === t.toRgbString();
    }
}
function $7adb3183a4fada57$var$F(r, e) {
    return r.isValid ? r.toString(e) : r.originalInput.toString();
}
function $7adb3183a4fada57$var$ut(r, e) {
    return new $7adb3183a4fada57$var$h(r, e);
}
function $7adb3183a4fada57$var$se(r) {
    return $7adb3183a4fada57$var$Wt(r) ? r : new $7adb3183a4fada57$var$h(r).toString();
}
const $7adb3183a4fada57$var$ie = (r)=>{
    const { currentColor: e, format: t, onChange: n, isAlphaHidden: i } = r, [s, a] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(e.toHsv()), o = (p, m)=>{
        if (!$7adb3183a4fada57$var$et(m)) return;
        const y = $7adb3183a4fada57$var$W(360 * m / 100, 0, 359);
        a((H)=>({
                ...H,
                h: y
            }));
        const M = new $7adb3183a4fada57$var$h({
            ...s,
            a: e.toHsv().a,
            h: y
        });
        n?.($7adb3183a4fada57$var$F(M, t));
    }, u = (p, m)=>{
        if (!$7adb3183a4fada57$var$et(m)) return;
        const y = e.clone().setAlpha(m);
        n?.($7adb3183a4fada57$var$F(y, t));
    }, w = ({ s: p, v: m })=>{
        const y = new $7adb3183a4fada57$var$h({
            h: s.h,
            a: e.toHsv().a,
            s: p,
            v: m
        });
        a((M)=>({
                ...M,
                s: p,
                v: m
            })), n?.($7adb3183a4fada57$var$F(y, t));
    };
    return /* @__PURE__ */ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($e5o5x))), {
        className: "MuiColorInput-PopoverBody",
        children: [
            /* @__PURE__ */ (0, $ayMG0.jsx)($7adb3183a4fada57$var$jt, {
                currentHue: s.h,
                hsv: s,
                onChange: w
            }),
            /* @__PURE__ */ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e5o5x))), {
                mt: "10px",
                px: "3px",
                children: /* @__PURE__ */ (0, $ayMG0.jsx)($7adb3183a4fada57$var$qt, {
                    min: 0,
                    max: 100,
                    step: 1,
                    onChange: o,
                    "aria-label": "hue",
                    value: s.h * 100 / 360
                })
            }),
            i ? null : /* @__PURE__ */ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e5o5x))), {
                mt: "10px",
                px: "3px",
                children: /* @__PURE__ */ (0, $ayMG0.jsx)($7adb3183a4fada57$var$Vt, {
                    min: 0,
                    max: 1,
                    step: 0.01,
                    "aria-label": "alpha",
                    rgbColor: e.toRgb(),
                    onChange: u,
                    value: e.getAlpha()
                })
            })
        ]
    });
}, $7adb3183a4fada57$var$ae = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((r, e)=>{
    const { className: t, ...n } = r;
    return /* @__PURE__ */ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hABDe))), {
        className: `MuiColorInput-TextField ${t || ""}`,
        ref: e,
        ...n
    });
}), $7adb3183a4fada57$var$oe = "rgb";
function $7adb3183a4fada57$var$he(r) {
    return typeof r == "object" && !Array.isArray(r) && r !== null;
}
function $7adb3183a4fada57$var$ft(r, e) {
    typeof e == "function" ? e(r) : e && $7adb3183a4fada57$var$he(e) && "current" in e && (e.current = r);
}
function $7adb3183a4fada57$export$ea7662cd66cffda6(r) {
    return new $7adb3183a4fada57$var$h(r).isValid;
}
const $7adb3183a4fada57$export$ed5bd2c23e384de = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ value: r, format: e, onChange: t, adornmentPosition: n = "start", PopoverProps: i, Adornment: s = $7adb3183a4fada57$export$30f8104594140054, fallbackValue: a, isAlphaHidden: o, disablePopover: u, ...w }, p)=>{
    const { onBlur: m, slotProps: y, ...M } = w, { onClose: H, ...b } = i || {}, k = M.disabled || !1, $ = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null), A = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null), [T, E] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null), I = e || $7adb3183a4fada57$var$oe, K = $7adb3183a4fada57$var$ut(r, {
        format: I
    }), [O, N] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(r), [J, V] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(r), gt = (f)=>{
        f.preventDefault(), f.stopPropagation(), !k && !u && E($.current);
    }, D = (f)=>{
        const c = new $7adb3183a4fada57$var$h(f);
        t?.(f, {
            hex: c.isValid ? c.toHexString() : "",
            hsv: c.isValid ? c.toHsvString() : "",
            hsl: c.isValid ? c.toHslString() : "",
            rgb: c.isValid ? c.toRgbString() : "",
            hex8: c.isValid ? c.toHex8String() : ""
        });
    }, bt = (f)=>{
        const c = f.target.value;
        if (N(c), c === "") V(""), D("");
        else {
            const U = new $7adb3183a4fada57$var$h(c), B = $7adb3183a4fada57$var$F(U, I);
            V(B), D(B);
        }
    }, pt = (...f)=>{
        H?.(...f), E(null), queueMicrotask(()=>{
            A.current?.focus();
        });
    }, mt = (f)=>{
        m?.(f);
        const c = new $7adb3183a4fada57$var$h(O);
        if (c.isValid) c.format !== I && N($7adb3183a4fada57$var$F(c, I));
        else {
            if (O === "") return;
            if (a) {
                const U = new $7adb3183a4fada57$var$h(a), B = $7adb3183a4fada57$var$F(U, I);
                N(B), V(B), D(B);
            }
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (r !== J) {
            const c = $7adb3183a4fada57$var$ut(r).originalInput;
            V(c), N(c);
        }
    }, [
        r,
        J
    ]);
    const xt = (f)=>{
        N(f), V(f), D(f);
    }, St = (f)=>{
        $.current = f, $7adb3183a4fada57$var$ft(f, p);
    }, vt = (f)=>{
        A.current = f, $7adb3183a4fada57$var$ft(f, A);
    }, Q = !!T, _ = Q ? "color-popover" : void 0, tt = /* @__PURE__ */ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9bswS))), {
        position: n,
        children: /* @__PURE__ */ (0, $ayMG0.jsx)(s, {
            disabled: k,
            "aria-describedby": _,
            disablePopover: u || !1,
            component: u ? "span" : void 0,
            bgColor: K.toString(),
            isBgColorValid: !!(O !== "" && K.isValid),
            onClick: u ? void 0 : gt
        })
    }), { input: wt, ...yt } = y || {}, Mt = {
        startAdornment: n === "start" ? tt : void 0,
        endAdornment: n === "end" ? tt : void 0,
        // eslint-disable-next-line @typescript-eslint/no-misused-spread
        ...wt
    };
    return /* @__PURE__ */ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /* @__PURE__ */ (0, $ayMG0.jsx)($7adb3183a4fada57$var$ae, {
                ref: St,
                spellCheck: "false",
                type: "text",
                autoComplete: "off",
                onChange: bt,
                value: $7adb3183a4fada57$var$se(O),
                onBlur: mt,
                inputRef: vt,
                disabled: k,
                slotProps: {
                    input: Mt,
                    ...yt
                },
                ...M
            }),
            u ? null : /* @__PURE__ */ (0, $ayMG0.jsx)($7adb3183a4fada57$var$Et, {
                id: _,
                open: Q,
                position: n,
                anchorEl: T,
                onClose: pt,
                ...b,
                children: /* @__PURE__ */ (0, $ayMG0.jsx)($7adb3183a4fada57$var$ie, {
                    onChange: xt,
                    currentColor: K,
                    format: I,
                    isAlphaHidden: o
                })
            })
        ]
    });
});



var $dKcJh = parcelRequire("dKcJh");

var $e5o5x = parcelRequire("e5o5x");

const $970f571137db010d$var$MiniSiteSettings = ()=>{
    const { userSettings: userSettings, setUserSettings: setUserSettings, systemError: systemError, setSystemError: setSystemError, loading: loading, setLoading: setLoading, error: error, setError: setError, success: success, setSuccess: setSuccess, modalScreen: modalScreen, setModalScreen: setModalScreen, page: page, setPage: setPage } = (0, $a55f2a94cd420149$export$c50e37a2f0a2b064)();
    const { saveProfile: saveProfile } = (0, $b622ef53e38024e7$export$1d39dc5b47e56ff0)();
    const [internalUserSettings, setInternalUserSettings] = (0, $acw62.useState)(userSettings || {
        generalSettings: {},
        profile: {}
    });
    const [file, setFile] = (0, $acw62.useState)(null);
    const [users, setUsers] = (0, $acw62.useState)([]);
    const [configuration, setConfiguration] = (0, $acw62.useState)(null);
    const [collapsedFielsets, setCollapsedFields] = (0, $acw62.useState)({});
    const [tabsEnabled, setTabsEnabled] = (0, $acw62.useState)({});
    const fetchUsers = async ()=>{
        const filterUserRef = configuration?.erp_user_reference || userSettings?.client?.id;
        const availableUsersResponse = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).USERS + "?erp_user_reference=" + filterUserRef);
        setUsers(availableUsersResponse.data.users || []);
    };
    const fetchMiniSiteSettings = async ()=>{
        const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).MINISITE_CONFIG);
        setConfiguration(response.data);
    };
    const saveMiniSiteSettings = async ()=>{
        if (!configuration) return;
        const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).put((0, $cd93687958c8007e$export$bfe19bc25132bb7c).MINISITE_CONFIG, configuration);
        setConfiguration(response.data);
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setLoading(true);
        setError(null);
        setSuccess(null);
        saveMiniSiteSettings().then(async ()=>{
            if (file) {
                const formData = new FormData();
                formData.append("file", file);
                formData.append("data", JSON.stringify(formData));
                return await (0, $bac44633733ff026$export$2e2bcd8739ae039).put((0, $cd93687958c8007e$export$bfe19bc25132bb7c).MINISITE_CONFIG + "/custom_logo_location", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                });
            }
            setSuccess("Configura\xe7\xf5es do MiniSite salvas com sucesso.");
        }).catch((error)=>{
            setError("Erro ao salvar configura\xe7\xf5es do MiniSite: " + error.message);
        }).finally(()=>{
            setLoading(false);
        });
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setLoading(true);
        fetchMiniSiteSettings().then(()=>{
            fetchUsers().catch((err)=>{
                setError("Erro ao carregar utilizadores: " + err.message);
            });
        }).catch((err)=>{
            setError("Erro ao carregar configura\xe7\xe3o do MiniSite: " + err.message);
        }).finally(()=>{
            setLoading(false);
        });
    }, []);
    const renderColorCustomInput = (label, id, defaultColor, configuration)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "grid grid-cols-1 md:grid-cols-2 gap-4 items-start",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                        className: "block text-sm font-medium text-gray-900",
                        htmlFor: id,
                        children: label
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7adb3183a4fada57$export$ed5bd2c23e384de), {
                        format: "hsl",
                        id: id,
                        value: configuration[id]?.toString() || defaultColor || "",
                        onChange: (color)=>setConfiguration({
                                ...configuration,
                                [id]: color
                            }),
                        className: "w-full",
                        size: "small"
                    })
                })
            ]
        });
    };
    const renderInput = (id, label, tip, value, onChange, type = "text")=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "space-y-2",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "flex items-start justify-between",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex-1",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                className: "block text-sm font-medium text-gray-900",
                                htmlFor: id,
                                children: label
                            }),
                            tip && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "text-xs text-gray-500 mt-1",
                                children: tip
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "mt-2",
                    children: type === "checkbox" ? /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                        className: "inline-flex items-center space-x-2 cursor-pointer",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                type: "checkbox",
                                id: id,
                                className: "w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2",
                                checked: value === "Sim",
                                onChange: onChange
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "text-sm text-gray-700",
                                children: "Ativar"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        type: type,
                        id: id,
                        className: "block w-full px-4 py-2.5 text-gray-900 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors",
                        value: value,
                        onChange: onChange
                    })
                })
            ]
        });
    const renderTextarea = (id, label, tip, value, onChange, rows = 3)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "space-y-2",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "flex items-start justify-between",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex-1",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                className: "block text-sm font-medium text-gray-900",
                                htmlFor: id,
                                children: label
                            }),
                            tip && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "text-xs text-gray-500 mt-1",
                                children: tip
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "mt-2",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                        rows: rows,
                        id: id,
                        className: "block w-full px-4 py-2.5 text-gray-900 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors resize-y",
                        value: value,
                        onChange: onChange
                    })
                })
            ]
        });
    if (!userSettings || !configuration) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: "Loading..."
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "container mx-auto p-6 max-w-7xl",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex flex-col gap-6",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex flex-col md:flex-row justify-between items-start md:items-center gap-4",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "text-3xl font-bold text-gray-900 tracking-tight",
                                    children: "Configura\xe7\xf5es do MiniSite"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "text-gray-500 mt-1",
                                    children: "Personalize a apar\xeancia e funcionalidades do seu MiniSite"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "overflow-auto",
                        children: loading ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "bg-white rounded-xl shadow-sm border border-gray-200 p-12",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "text-center",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "mt-4 text-gray-600",
                                        children: "A carregar configura\xe7\xf5es..."
                                    })
                                ]
                            })
                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                            onSubmit: handleSubmit,
                            className: "space-y-6",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("fieldset", {
                                        className: `collapsible ${collapsedFielsets["generalSettings"] ? "is-collapsed" : ""}`,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("legend", {
                                                className: "flex items-center justify-between p-6 cursor-pointer hover:bg-gray-50 transition-colors border-b border-gray-200",
                                                onClick: ()=>setCollapsedFields({
                                                        ...collapsedFielsets,
                                                        generalSettings: !collapsedFielsets["generalSettings"]
                                                    }),
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                        className: "text-xl font-semibold text-gray-900",
                                                        children: "Configura\xe7\xf5es Gerais"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9bfa6564caba0fd2$export$2e2bcd8739ae039), {
                                                        className: `w-6 h-6 text-gray-400 transition-transform ${collapsedFielsets["generalSettings"] ? "rotate-180" : ""}`
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("main", {
                                                className: "p-6 space-y-6",
                                                children: [
                                                    renderInput("minisite_enabled", "MiniSite Ativo", "Ativa ou desativa o MiniSite.", configuration.minisite_enabled ? "Sim" : "N\xe3o", (e)=>setConfiguration({
                                                            ...configuration,
                                                            minisite_enabled: e.target.checked
                                                        }), "checkbox"),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "space-y-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "flex items-start justify-between",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "flex-1",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                            className: "block text-sm font-medium text-gray-900",
                                                                            htmlFor: "associated_user_id",
                                                                            children: "Utilizador associado"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                            className: "text-xs text-gray-500 mt-1",
                                                                            children: [
                                                                                "O utilizador associado ao MiniSite.",
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                                "Este utilizador ser\xe1 utilizado para cria\xe7\xe3o de propostas; recomendados um utilizador guest."
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "mt-2",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                                    id: "associated_user_id",
                                                                    className: "block w-full px-4 py-2.5 text-gray-900 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors",
                                                                    value: configuration.minisite_associated_user || "",
                                                                    onChange: (e)=>setConfiguration({
                                                                            ...configuration,
                                                                            minisite_associated_user: e.target.value
                                                                        }),
                                                                    children: [
                                                                        users.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                            disabled: true,
                                                                            value: "",
                                                                            children: "Nenhum utilizador dispon\xedvel"
                                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                            disabled: true,
                                                                            value: "",
                                                                            children: "Selecione um utilizador"
                                                                        }),
                                                                        users?.map((user)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("option", {
                                                                                value: user.username,
                                                                                children: [
                                                                                    user.firstName,
                                                                                    " ",
                                                                                    user.lastName,
                                                                                    " (",
                                                                                    user.type,
                                                                                    ")"
                                                                                ]
                                                                            }, user.id))
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    renderInput("minisite_hostname", "Site Customizado", "Endere\xe7o do MiniSite no subdom\xednio iapc.pt.", configuration.minisite_hostname, (e)=>setConfiguration({
                                                            ...configuration,
                                                            minisite_hostname: e.target.value
                                                        })),
                                                    renderInput("minisite_cross_domain", "Dom\xednio Customizado", "Dom\xednio customizado para o MiniSite. Deve ser um dom\xednio v\xe1lido e estar configurado para apontar para o subdom\xednio do iapc.pt.", configuration.minisite_cross_domain || "", (e)=>setConfiguration({
                                                            ...configuration,
                                                            minisite_cross_domain: e.target.value
                                                        })),
                                                    renderInput("minisite_iframe_enabled", "Usar Iframe", "Se habilitado, o microsite ser\xe1 carregado dentro de um iframe.", configuration.minisite_iframe_enabled ? "Sim" : "N\xe3o", (e)=>setConfiguration({
                                                            ...configuration,
                                                            minisite_iframe_enabled: e.target.checked
                                                        }), "checkbox")
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("fieldset", {
                                        className: `collapsible ${collapsedFielsets["customContacts"] ? "is-collapsed" : ""}`,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("legend", {
                                                className: "flex items-center justify-between p-6 cursor-pointer hover:bg-gray-50 transition-colors border-b border-gray-200",
                                                onClick: ()=>setCollapsedFields({
                                                        ...collapsedFielsets,
                                                        customContacts: !collapsedFielsets["customContacts"]
                                                    }),
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                        className: "text-xl font-semibold text-gray-900",
                                                        children: "Contactos"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9bfa6564caba0fd2$export$2e2bcd8739ae039), {
                                                        className: `w-6 h-6 text-gray-400 transition-transform ${collapsedFielsets["customContacts"] ? "rotate-180" : ""}`
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("main", {
                                                className: "p-6 space-y-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e5o5x))), {
                                                        sx: {
                                                            borderBottom: 1,
                                                            marginBottom: 4,
                                                            borderColor: "divider"
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($dKcJh))), {
                                                            value: typeof tabsEnabled["contacts"] === "number" ? tabsEnabled["contacts"] ?? 0 : 0,
                                                            onChange: (event, newValue)=>{
                                                                setTabsEnabled({
                                                                    ...tabsEnabled,
                                                                    ["contacts"]: newValue
                                                                });
                                                            },
                                                            "aria-label": "contacts-mode",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Tab), {
                                                                    label: "normal",
                                                                    "aria-controls": "tab-contacts-normal",
                                                                    id: "tabpanel-contacts-normal",
                                                                    tabIndex: 0
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Tab), {
                                                                    label: "avan\xe7ado",
                                                                    "aria-controls": "tab-contacts-advance",
                                                                    id: "tabpanel-contact-advance",
                                                                    tabIndex: 1
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        role: "tabpanel",
                                                        hidden: (tabsEnabled["contacts"] ?? 0) !== 0,
                                                        id: "tab-contacts-normal",
                                                        "aria-labelledby": "tabpanel-contacts-normal",
                                                        tabIndex: 0,
                                                        children: [
                                                            renderTextarea("contact_address", "Morada de Contacto", "A morada de contacto ser\xe1 utilizada na p\xe1gina de contactos.", configuration.contact_address || "", (e)=>setConfiguration({
                                                                    ...configuration,
                                                                    contact_address: e.target.value
                                                                })),
                                                            renderTextarea("contact_map_embed_code", "C\xf3digo de Incorpora\xe7\xe3o do Mapa", "O c\xf3digo de incorpora\xe7\xe3o do mapa ser\xe1 utilizado na p\xe1gina de contactos.", configuration.contact_map_embed_code || "", (e)=>setConfiguration({
                                                                    ...configuration,
                                                                    contact_map_embed_code: e.target.value
                                                                }), 5),
                                                            renderInput("contact_email", "Email de Contacto", "O email de contacto ser\xe1 utilizado na p\xe1gina de contactos.", configuration.contact_email || "", (e)=>setConfiguration({
                                                                    ...configuration,
                                                                    contact_email: e.target.value
                                                                })),
                                                            renderInput("contact_phone", "Telefone de Contacto", "O telefone de contacto ser\xe1 utilizado na p\xe1gina de contactos.", configuration.contact_phone || "", (e)=>setConfiguration({
                                                                    ...configuration,
                                                                    contact_phone: e.target.value
                                                                })),
                                                            renderInput("contact_whatsapp", "WhatsApp", "Link para o WhatsApp da empresa.", configuration.contact_whatsapp || "", (e)=>setConfiguration({
                                                                    ...configuration,
                                                                    contact_whatsapp: e.target.value
                                                                })),
                                                            renderInput("contact_facebook", "Facebook", "Link para o Facebook da empresa.", configuration.contact_facebook || "", (e)=>setConfiguration({
                                                                    ...configuration,
                                                                    contact_facebook: e.target.value
                                                                })),
                                                            renderInput("contact_twitter", "Twitter", "Link para o Twitter da empresa.", configuration.contact_twitter || "", (e)=>setConfiguration({
                                                                    ...configuration,
                                                                    contact_twitter: e.target.value
                                                                })),
                                                            renderInput("contact_instagram", "Instagram", "Link para o Instagram da empresa.", configuration.contact_instagram || "", (e)=>setConfiguration({
                                                                    ...configuration,
                                                                    contact_instagram: e.target.value
                                                                })),
                                                            renderInput("contact_linkedin", "LinkedIn", "Link para o LinkedIn da empresa.", configuration.contact_linkedin || "", (e)=>setConfiguration({
                                                                    ...configuration,
                                                                    contact_linkedin: e.target.value
                                                                })),
                                                            renderInput("contact_youtube", "YouTube", "Link para o YouTube da empresa.", configuration.contact_youtube || "", (e)=>setConfiguration({
                                                                    ...configuration,
                                                                    contact_youtube: e.target.value
                                                                }))
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        role: "tabpanel",
                                                        hidden: tabsEnabled["contacts"] !== 1,
                                                        id: "tab-contacts-advance",
                                                        "aria-labelledby": "tabpanel-contacts-advance",
                                                        tabIndex: 1,
                                                        children: [
                                                            renderInput("enable_custom_contact_html", "Habilitar HTML Customizado", "Habilita o uso de HTML customizado na p\xe1gina de contactos.", configuration.enable_custom_contact_html ? "Sim" : "N\xe3o", (e)=>setConfiguration({
                                                                    ...configuration,
                                                                    enable_custom_contact_html: e.target.checked
                                                                }), "checkbox"),
                                                            renderTextarea("contact_custom_html", "HTML Customizado", "O HTML customizado ser\xe1 utilizado na p\xe1gina de contactos.", configuration.contact_custom_html || "", (e)=>setConfiguration({
                                                                    ...configuration,
                                                                    contact_custom_html: e.target.value
                                                                }), 15)
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("fieldset", {
                                        className: `collapsible ${collapsedFielsets["customSettings"] ? "is-collapsed" : ""}`,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("legend", {
                                                className: "flex items-center justify-between p-6 cursor-pointer hover:bg-gray-50 transition-colors border-b border-gray-200",
                                                onClick: ()=>setCollapsedFields({
                                                        ...collapsedFielsets,
                                                        customSettings: !collapsedFielsets["customSettings"]
                                                    }),
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                        className: "text-xl font-semibold text-gray-900",
                                                        children: "Apar\xeancia"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9bfa6564caba0fd2$export$2e2bcd8739ae039), {
                                                        className: `w-6 h-6 text-gray-400 transition-transform ${collapsedFielsets["customSettings"] ? "rotate-180" : ""}`
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("main", {
                                                className: "p-6 space-y-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "space-y-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "flex items-start justify-between",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "flex-1",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                            className: "block text-sm font-medium text-gray-900",
                                                                            htmlFor: "logoUrl",
                                                                            children: "Log\xf3tipo a exibir no site"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                            className: "text-xs text-gray-500 mt-1",
                                                                            children: "O logotipo ser\xe1 utilizado no cabe\xe7alho do MiniSite."
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "mt-2",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "flex items-center gap-4",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                            className: "flex items-center px-4 py-2.5 bg-white border border-gray-300 rounded-lg cursor-pointer hover:bg-gray-50 transition-colors",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                    className: "hidden",
                                                                                    type: "file",
                                                                                    name: "companyLogo",
                                                                                    accept: "image/*",
                                                                                    onChange: (e)=>{
                                                                                        const selectedFile = e.target.files?.[0];
                                                                                        if (selectedFile) setFile(selectedFile);
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "text-sm font-medium text-gray-700",
                                                                                    children: "Escolher ficheiro..."
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "text-sm text-gray-600",
                                                                            children: file ? file.name : "Nenhum ficheiro selecionado"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "space-y-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "flex items-start justify-between",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "flex-1",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                        className: "block text-sm font-medium text-gray-900",
                                                                        children: "Pr\xe9-visualiza\xe7\xe3o do Log\xf3tipo"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "mt-2",
                                                                children: file ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "relative inline-block",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("picture", {
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                src: URL.createObjectURL(file),
                                                                                alt: "Selected Logo",
                                                                                className: "rounded-lg border border-gray-200",
                                                                                style: {
                                                                                    maxWidth: "200px",
                                                                                    maxHeight: "100px"
                                                                                }
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "absolute top-2 right-2 px-2 py-1 bg-blue-100 text-blue-700 text-xs font-medium rounded",
                                                                            children: "Preview"
                                                                        })
                                                                    ]
                                                                }) : configuration.custom_logo_location ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "inline-block max-w-[150px] max-h-[100px]",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e87b4633e3445bd$export$2e2bcd8739ae039), {
                                                                        src: "http://iapc.pt/images/150/logo-IAPC.jpg",
                                                                        dataSrc: configuration.custom_logo_location,
                                                                        loading: "progressive",
                                                                        sizes: "150",
                                                                        alt: "Logo",
                                                                        className: "object-cover rounded-lg border border-gray-200"
                                                                    })
                                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                    className: "text-sm text-gray-500",
                                                                    children: "Nenhum logotipo selecionado"
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "space-y-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "flex items-start justify-between",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "flex-1",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                            className: "block text-sm font-medium text-gray-900",
                                                                            htmlFor: "custom_title",
                                                                            children: "Nome a exibir no site"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                            className: "text-xs text-gray-500 mt-1",
                                                                            children: "O nome ser\xe1 utilizado no cabe\xe7alho do MiniSite."
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "mt-2",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                    type: "text",
                                                                    id: "custom_title",
                                                                    className: "block w-full px-4 py-2.5 text-gray-900 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors",
                                                                    value: configuration.custom_title || "",
                                                                    onChange: (e)=>setConfiguration({
                                                                            ...configuration,
                                                                            custom_title: e.target.value
                                                                        })
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "space-y-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "flex items-start justify-between",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "flex-1",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                            className: "block text-sm font-medium text-gray-900",
                                                                            htmlFor: "custom_subtitle",
                                                                            children: "Subt\xedtulo a exibir no site"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                            className: "text-xs text-gray-500 mt-1",
                                                                            children: "O subt\xedtulo ser\xe1 utilizado no cabe\xe7alho do MiniSite."
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "mt-2",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                    type: "text",
                                                                    id: "custom_subtitle",
                                                                    className: "block w-full px-4 py-2.5 text-gray-900 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors",
                                                                    value: configuration.custom_subtitle || "",
                                                                    onChange: (e)=>setConfiguration({
                                                                            ...configuration,
                                                                            custom_subtitle: e.target.value
                                                                        })
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "space-y-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "flex items-start justify-between",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "flex-1",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                            className: "block text-sm font-medium text-gray-900",
                                                                            htmlFor: "custom_welcome_message",
                                                                            children: "Mensagem de Boas Vindas a exibir no site"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                            className: "text-xs text-gray-500 mt-1",
                                                                            children: "A mensagem de boas vindas ser\xe1 utilizada na p\xe1gina inicial do MiniSite."
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "mt-2",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                                    rows: 5,
                                                                    id: "custom_welcome_message",
                                                                    className: "block w-full px-4 py-2.5 text-gray-900 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors resize-y",
                                                                    value: configuration.custom_welcome_message || "",
                                                                    onChange: (e)=>setConfiguration({
                                                                            ...configuration,
                                                                            custom_welcome_message: e.target.value
                                                                        })
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "space-y-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "flex items-start justify-between",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "flex-1",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                            className: "block text-sm font-medium text-gray-900",
                                                                            htmlFor: "custom_footer_text",
                                                                            children: "Texto de Rodap\xe9 a exibir no site"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                            className: "text-xs text-gray-500 mt-1",
                                                                            children: "O texto de rodap\xe9 ser\xe1 utilizado no rodap\xe9 do MiniSite."
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "mt-2",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                                    rows: 3,
                                                                    id: "custom_footer_text",
                                                                    className: "block w-full px-4 py-2.5 text-gray-900 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors resize-y",
                                                                    value: configuration.custom_footer_text || "",
                                                                    onChange: (e)=>setConfiguration({
                                                                            ...configuration,
                                                                            custom_footer_text: e.target.value
                                                                        })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("fieldset", {
                                        className: `collapsible ${collapsedFielsets["customThemeSettings"] ? "is-collapsed" : ""}`,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("legend", {
                                                className: "flex items-center justify-between p-6 cursor-pointer hover:bg-gray-50 transition-colors border-b border-gray-200",
                                                onClick: ()=>setCollapsedFields({
                                                        ...collapsedFielsets,
                                                        customThemeSettings: !collapsedFielsets["customThemeSettings"]
                                                    }),
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                        className: "text-xl font-semibold text-gray-900",
                                                        children: "Tema e Cores"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9bfa6564caba0fd2$export$2e2bcd8739ae039), {
                                                        className: `w-6 h-6 text-gray-400 transition-transform ${collapsedFielsets["customThemeSettings"] ? "rotate-180" : ""}`
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("main", {
                                                className: "p-6 space-y-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e5o5x))), {
                                                        sx: {
                                                            borderBottom: 1,
                                                            marginBottom: 4,
                                                            borderColor: "divider"
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($dKcJh))), {
                                                            value: typeof tabsEnabled["theme"] === "number" ? tabsEnabled["theme"] ?? 0 : 0,
                                                            onChange: (event, newValue)=>{
                                                                setTabsEnabled({
                                                                    ...tabsEnabled,
                                                                    ["theme"]: newValue
                                                                });
                                                            },
                                                            "aria-label": "theme-mode",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Tab), {
                                                                    label: "normal",
                                                                    "aria-controls": "tab-theme-normal",
                                                                    id: "tabpanel-theme-normal",
                                                                    tabIndex: 0
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Tab), {
                                                                    label: "avan\xe7ado",
                                                                    "aria-controls": "tab-theme-advance",
                                                                    id: "tabpanel-theme-advance",
                                                                    tabIndex: 1
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        role: "tabpanel",
                                                        hidden: (tabsEnabled["theme"] ?? 0) !== 0,
                                                        id: "tab-theme-normal",
                                                        "aria-labelledby": "tabpanel-theme-normal",
                                                        tabIndex: 0,
                                                        children: [
                                                            renderColorCustomInput("Cor de Fundo", "custom_background_color", "#ffffff", configuration),
                                                            renderColorCustomInput("Cor de Fundo Secund\xe1ria", "custom_background_secondary_color", "#f7f8fd", configuration),
                                                            renderColorCustomInput("Cor do Texto", "custom_text_color", "#232a4a", configuration),
                                                            renderColorCustomInput("Cor do Texto Claro", "custom_text_light_color", "#6e7be6", configuration),
                                                            renderColorCustomInput("Cor do Texto dos Bot\xf5es", "custom_button_text_color", "#232a4a", configuration),
                                                            renderColorCustomInput("Cor Prim\xe1ria", "custom_primary_color", "#232a4a", configuration),
                                                            renderColorCustomInput("Cor Secund\xe1ria", "custom_secondary_color", "#6e7be6", configuration),
                                                            renderColorCustomInput("Cor de Sucesso", "custom_success_color", "#3adca7", configuration),
                                                            renderColorCustomInput("Cor dos Bot\xf5es", "custom_button_color", "#00d1b2", configuration),
                                                            renderColorCustomInput("Cor do Bot\xe3o ao Passar o Mouse", "custom_button_hover_color", "#00b89c", configuration),
                                                            renderColorCustomInput("Cor do Bot\xe3o ao Clicar", "custom_button_active_color", "#009e87", configuration),
                                                            renderColorCustomInput("Cor do Link", "custom_link_text_color", "#3273dc", configuration),
                                                            renderColorCustomInput("Cor do Link ao Passar o Mouse", "custom_link_hover_color", "#2759a5", configuration),
                                                            renderColorCustomInput("Cor do Link ao Clicar", "custom_link_active_color", "#1c3d73", configuration)
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        role: "tabpanel",
                                                        hidden: tabsEnabled["theme"] !== 1,
                                                        id: "tab-theme-advance",
                                                        "aria-labelledby": "tabpanel-theme-advance",
                                                        tabIndex: 1,
                                                        children: [
                                                            renderTextarea("custom_css", "CSS Avan\xe7ado", "O CSS avan\xe7ado ser\xe1 adicionado ao final do ficheiro CSS.", configuration.custom_css || "", (e)=>setConfiguration({
                                                                    ...configuration,
                                                                    custom_css: e.target.value
                                                                }), 15),
                                                            renderTextarea("custom_js", "JS Avan\xe7ado", "O JS avan\xe7ado ser\xe1 adicionado ao final do ficheiro JS.", configuration.custom_js || "", (e)=>setConfiguration({
                                                                    ...configuration,
                                                                    custom_js: e.target.value
                                                                }), 15)
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("fieldset", {
                                        className: `collapsible ${collapsedFielsets["customSeo"] ? "is-collapsed" : ""}`,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("legend", {
                                                className: "flex items-center justify-between p-6 cursor-pointer hover:bg-gray-50 transition-colors border-b border-gray-200",
                                                onClick: ()=>setCollapsedFields({
                                                        ...collapsedFielsets,
                                                        customSeo: !collapsedFielsets["customSeo"]
                                                    }),
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                        className: "text-xl font-semibold text-gray-900",
                                                        children: "SEO e Analytics"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9bfa6564caba0fd2$export$2e2bcd8739ae039), {
                                                        className: `w-6 h-6 text-gray-400 transition-transform ${collapsedFielsets["customSeo"] ? "rotate-180" : ""}`
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("main", {
                                                className: "p-6 space-y-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "space-y-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "flex items-start justify-between",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "flex-1",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                            className: "block text-sm font-medium text-gray-900",
                                                                            htmlFor: "seo_meta_title",
                                                                            children: "Meta T\xedtulo"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                            className: "text-xs text-gray-500 mt-1",
                                                                            children: "O meta t\xedtulo ser\xe1 utilizado para SEO."
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "mt-2",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                    type: "text",
                                                                    id: "seo_meta_title",
                                                                    className: "block w-full px-4 py-2.5 text-gray-900 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors",
                                                                    value: configuration.seo_meta_title || "",
                                                                    onChange: (e)=>setConfiguration({
                                                                            ...configuration,
                                                                            seo_meta_title: e.target.value
                                                                        })
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "space-y-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "flex items-start justify-between",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "flex-1",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                            className: "block text-sm font-medium text-gray-900",
                                                                            htmlFor: "seo_meta_description",
                                                                            children: "Meta Descri\xe7\xe3o"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                            className: "text-xs text-gray-500 mt-1",
                                                                            children: "A meta descri\xe7\xe3o ser\xe1 utilizada para SEO."
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "mt-2",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                                    rows: 3,
                                                                    id: "seo_meta_description",
                                                                    className: "block w-full px-4 py-2.5 text-gray-900 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors resize-y",
                                                                    value: configuration.seo_meta_description || "",
                                                                    onChange: (e)=>setConfiguration({
                                                                            ...configuration,
                                                                            seo_meta_description: e.target.value
                                                                        })
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "space-y-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "flex items-start justify-between",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "flex-1",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                            className: "block text-sm font-medium text-gray-900",
                                                                            htmlFor: "seo_meta_keywords",
                                                                            children: "Meta Keywords"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                            className: "text-xs text-gray-500 mt-1",
                                                                            children: "As meta keywords ser\xe3o utilizadas para SEO."
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "mt-2",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                    type: "text",
                                                                    id: "seo_meta_keywords",
                                                                    className: "block w-full px-4 py-2.5 text-gray-900 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors",
                                                                    value: configuration.seo_meta_keywords || "",
                                                                    onChange: (e)=>setConfiguration({
                                                                            ...configuration,
                                                                            seo_meta_keywords: e.target.value
                                                                        })
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "space-y-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "flex items-start justify-between",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "flex-1",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                            className: "block text-sm font-medium text-gray-900",
                                                                            htmlFor: "analytics_enabled",
                                                                            children: "Ativar Google Analytics"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                            className: "text-xs text-gray-500 mt-1",
                                                                            children: "Ativa ou desativa o Google Analytics."
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "mt-2",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                    className: "inline-flex items-center space-x-2 cursor-pointer",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                            type: "checkbox",
                                                                            id: "analytics_enabled",
                                                                            className: "w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2",
                                                                            checked: configuration.analytics_enabled || false,
                                                                            onChange: (e)=>setConfiguration({
                                                                                    ...configuration,
                                                                                    analytics_enabled: e.target.checked
                                                                                })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "text-sm text-gray-700",
                                                                            children: "Habilitar Google Analytics"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "space-y-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "flex items-start justify-between",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "flex-1",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                            className: "block text-sm font-medium text-gray-900",
                                                                            htmlFor: "google_analytics_id",
                                                                            children: "Google Analytics ID"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                            className: "text-xs text-gray-500 mt-1",
                                                                            children: "O Google Analytics ID ser\xe1 utilizado para rastreamento."
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "mt-2",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                    type: "text",
                                                                    id: "google_analytics_id",
                                                                    className: "block w-full px-4 py-2.5 text-gray-900 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors disabled:bg-gray-100 disabled:cursor-not-allowed",
                                                                    required: configuration.analytics_enabled || false,
                                                                    placeholder: "UA-XXXXX-Y ou G-XXXXXXX",
                                                                    readOnly: !configuration.analytics_enabled || false,
                                                                    value: configuration.analytics_tracking_id || "",
                                                                    onChange: (e)=>setConfiguration({
                                                                            ...configuration,
                                                                            analytics_tracking_id: e.target.value
                                                                        })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "bg-white rounded-xl shadow-sm border border-gray-200 p-6",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "text-sm text-gray-600",
                                                    children: "N\xe3o se esque\xe7a de guardar as suas altera\xe7\xf5es"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                type: "submit",
                                                className: `px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors ${loading ? "opacity-50 cursor-not-allowed" : ""}`,
                                                disabled: loading || !!error,
                                                children: loading ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: "flex items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                            className: "animate-spin h-5 w-5",
                                                            viewBox: "0 0 24 24",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                    className: "opacity-25",
                                                                    cx: "12",
                                                                    cy: "12",
                                                                    r: "10",
                                                                    stroke: "currentColor",
                                                                    strokeWidth: "4",
                                                                    fill: "none"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    className: "opacity-75",
                                                                    fill: "currentColor",
                                                                    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                                })
                                                            ]
                                                        }),
                                                        "A guardar..."
                                                    ]
                                                }) : "Guardar Configura\xe7\xf5es"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
var $970f571137db010d$export$2e2bcd8739ae039 = $970f571137db010d$var$MiniSiteSettings;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


const $6ad8734dfcdf3d44$var$OAuthCallback = ()=>{
    const navigate = (0, $585f8bce88e531c1$export$9770f232ac06a008)();
    const [searchParams] = (0, $585f8bce88e531c1$export$f1a78c17382fe22a)();
    (0, $acw62.useEffect)(()=>{
        const handleCallback = async ()=>{
            const code = searchParams.get("code");
            const state = searchParams.get("state");
            if (!code || !state) {
                console.log("Missing code or state parameter");
                // window.location.href = '/';
                return;
            }
            // Parse state to get tenantId, provider, and optional redirectUrl
            // State format: "tenantId:provider" or "tenantId:provider:redirectUrl"
            let tenantId = state;
            let provider = "google";
            let redirectUrl = null;
            if (state.includes(":")) {
                const parts = state.split(":");
                tenantId = parts[0];
                provider = parts[1];
                // If there's a third part, it's the redirect URL
                if (parts.length > 2) redirectUrl = parts.slice(2).join(":"); // Join in case URL contains colons
            }
            try {
                // Exchange code for token via backend
                const response = await fetch(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).API_BASE_URL}/api/microsite/auth/callback/${provider}`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        code: code,
                        tenant_id: tenantId,
                        provider: provider.toUpperCase()
                    })
                });
                if (!response.ok) throw new Error("OAuth callback failed");
                const data = await response.json();
                // Redirect to tenant subdomain with token and optional redirect URL
                const protocol = window.location.protocol;
                const port = window.location.port;
                const host = window.location.hostname;
                let subdomainUrl = `${protocol}//${tenantId}.${host}:${port}/auth/set-token?token=${data.token}`;
                if (redirectUrl) subdomainUrl += `&redirect_url=${encodeURIComponent(redirectUrl)}`;
                window.location.href = subdomainUrl;
            } catch (error) {
                console.log("Authentication error:", error);
            // window.location.href = '/';
            }
        };
        handleCallback();
    }, [
        searchParams
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: "flex",
            minHeight: "100vh",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#f9fafb"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    textAlign: "center"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            marginBottom: "1rem",
                            display: "inline-block",
                            height: "3rem",
                            width: "3rem",
                            border: "4px solid #3b82f6",
                            borderTopColor: "transparent",
                            borderRadius: "50%",
                            animation: "spin 1s linear infinite"
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        style: {
                            fontSize: "1.125rem",
                            color: "#374151"
                        },
                        children: "A autenticar..."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("style", {
                children: `
                @keyframes spin {
                    to { transform: rotate(360deg); }
                }
            `
            })
        ]
    });
};
var $6ad8734dfcdf3d44$export$2e2bcd8739ae039 = $6ad8734dfcdf3d44$var$OAuthCallback;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

const $b0a06eab9218803f$var$HIGHLIGHT_DURATION_MS = 3000;
const $b0a06eab9218803f$export$f8347cdb2826a65c = ()=>{
    const [searchParams] = (0, $585f8bce88e531c1$export$f1a78c17382fe22a)();
    const commentId = searchParams.get("highlight");
    const [highlightActive, setHighlightActive] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (!commentId) return;
        setHighlightActive(true);
        const timer = setTimeout(()=>{
            setHighlightActive(false);
        }, $b0a06eab9218803f$var$HIGHLIGHT_DURATION_MS);
        return ()=>clearTimeout(timer);
    }, [
        commentId
    ]);
    return {
        commentId: commentId,
        highlightActive: highlightActive
    };
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $7bf700af73572f15$var$HIGHLIGHT_CLASS = "comment-highlight";
const $7bf700af73572f15$var$HIGHLIGHT_DURATION_MS = 3000;
const $7bf700af73572f15$export$77f020f416ed76b7 = ({ active: active, children: children })=>{
    const ref = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (!active || !ref.current) return;
        ref.current.classList.add($7bf700af73572f15$var$HIGHLIGHT_CLASS);
        ref.current.scrollIntoView({
            behavior: "smooth",
            block: "center"
        });
        const timer = setTimeout(()=>{
            ref.current?.classList.remove($7bf700af73572f15$var$HIGHLIGHT_CLASS);
        }, $7bf700af73572f15$var$HIGHLIGHT_DURATION_MS);
        return ()=>{
            clearTimeout(timer);
            ref.current?.classList.remove($7bf700af73572f15$var$HIGHLIGHT_CLASS);
        };
    }, [
        active
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        ref: ref,
        children: children
    });
};


const $50d6ea96af6e95ce$var$DeepLinkResolverPage = ()=>{
    const { reviewId: reviewId } = (0, $585f8bce88e531c1$export$99eaa27ddbbb95ef)();
    const { commentId: commentId, highlightActive: highlightActive } = (0, $b0a06eab9218803f$export$f8347cdb2826a65c)();
    const [review, setReview] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [notFound, setNotFound] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (!reviewId) {
            setNotFound(true);
            setLoading(false);
            return;
        }
        const apiUrl = "https://api.tst.carreira.cloud/reviews/api/v1";
        const authToken = localStorage.getItem("authToken") || sessionStorage.getItem("authToken");
        fetch(`${apiUrl}/reviews/${reviewId}`, {
            headers: {
                ...authToken ? {
                    Authorization: `Bearer ${authToken}`
                } : {}
            }
        }).then((res)=>{
            if (!res.ok) throw Object.assign(new Error("Not found"), {
                status: res.status
            });
            return res.json();
        }).then((data)=>{
            setReview(data);
        }).catch(()=>{
            setNotFound(true);
        }).finally(()=>{
            setLoading(false);
        });
    }, [
        reviewId
    ]);
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex items-center justify-center min-h-screen",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
            className: "text-gray-500",
            children: "Loading review..."
        })
    });
    if (notFound || !review) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex items-center justify-center min-h-screen",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
            className: "text-gray-500",
            children: "Review not found."
        })
    });
    const targetComment = commentId ? review.comments.find((c)=>c.id === commentId) : null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "max-w-2xl mx-auto px-4 py-8",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-6",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        className: "text-xl font-semibold text-gray-900",
                        children: "Review"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "text-sm text-gray-500 mt-1",
                        children: [
                            "by ",
                            review.authorName
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt-3 text-gray-700",
                        children: review.content
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mt-1 text-sm text-yellow-600",
                        children: [
                            "Rating: ",
                            review.rating,
                            " / 5"
                        ]
                    })
                ]
            }),
            review.comments.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "space-y-4",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "text-sm font-medium text-gray-700 uppercase tracking-wide",
                        children: "Comments"
                    }),
                    review.comments.map((comment)=>{
                        const isTarget = comment.id === commentId;
                        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7bf700af73572f15$export$77f020f416ed76b7), {
                            active: isTarget && highlightActive,
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "p-3 rounded border border-gray-200 bg-white",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "text-sm font-medium text-gray-800",
                                        children: comment.authorName
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "text-sm text-gray-600 mt-1",
                                        children: comment.content
                                    })
                                ]
                            })
                        }, comment.id);
                    })
                ]
            }),
            commentId && !targetComment && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "text-sm text-gray-400 mt-4",
                children: "The linked comment could not be found."
            })
        ]
    });
};
var $50d6ea96af6e95ce$export$2e2bcd8739ae039 = $50d6ea96af6e95ce$var$DeepLinkResolverPage;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
// Derive the widget CDN base from the API URL: replace /api/v1 suffix with /widget/v1.
// Falls back to the tst URL so local dev without .env still works.
const $687338b1d2c8b49e$var$API_URL = "https://api.tst.carreira.cloud/reviews/api/v1";
const $687338b1d2c8b49e$var$WIDGET_BASE = $687338b1d2c8b49e$var$API_URL.replace(/\/api\/v1$/, "/widget/v1");
function $687338b1d2c8b49e$var$loadAdminWidgetAssets() {
    return new Promise((resolve)=>{
        const cssId = "reviews-admin-widget-css";
        const jsId = "reviews-admin-widget-js";
        if (!document.getElementById(cssId)) {
            const link = document.createElement("link");
            link.id = cssId;
            link.rel = "stylesheet";
            link.href = `${$687338b1d2c8b49e$var$WIDGET_BASE}/reviews-admin-widget.css`;
            document.head.appendChild(link);
        }
        if (document.getElementById(jsId)) {
            resolve();
            return;
        }
        const script = document.createElement("script");
        script.id = jsId;
        script.src = `${$687338b1d2c8b49e$var$WIDGET_BASE}/reviews-admin-widget.js`;
        script.onload = ()=>resolve();
        document.head.appendChild(script);
    });
}
const $687338b1d2c8b49e$var$ReviewsAdminWidget = ({ authToken: authToken, locale: locale = "pt" })=>{
    const containerRef = (0, $acw62.useRef)(null);
    const apiGwKey = "ak_a85c88b070aa3b7ee132de0c2d77aadb47221331dc86cf6c";
    (0, $acw62.useEffect)(()=>{
        $687338b1d2c8b49e$var$loadAdminWidgetAssets().then(()=>{
            if (containerRef.current && window.ReviewsAdminWidget) window.ReviewsAdminWidget.init({
                apiKey: apiGwKey,
                apiUrl: $687338b1d2c8b49e$var$API_URL,
                container: containerRef.current,
                authToken: authToken,
                locale: locale
            });
        });
    }, [
        authToken,
        locale
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        ref: containerRef,
        id: "reviews-admin-widget",
        className: "mt-4"
    });
};
var $687338b1d2c8b49e$export$2e2bcd8739ae039 = $687338b1d2c8b49e$var$ReviewsAdminWidget;


const $7dccff3eb6cbef5a$var$ReviewsAdminPage = ()=>{
    const { profile: profile, isAuthenticated: isAuthenticated } = (0, $b622ef53e38024e7$export$1d39dc5b47e56ff0)();
    const [userProfile, setUserProfile] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        profile().then((p)=>{
            setUserProfile(p);
            setLoading(false);
        }).catch(()=>setLoading(false));
    }, [
        profile
    ]);
    if (!isAuthenticated()) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$444b3ab0cb9aec40), {
        to: "/login",
        replace: true
    });
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex items-center justify-center p-12 text-gray-500",
        children: "A carregar..."
    });
    // Client-side gate — real enforcement is api-gw + reviews-ms ModeratorJIT
    if (!userProfile?.isAdmin() && !userProfile?.isCommercial()) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$444b3ab0cb9aec40), {
        to: "/",
        replace: true
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "container mx-auto px-4 py-8",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "bg-white shadow rounded-lg p-6",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                    className: "text-2xl font-bold mb-2 text-gray-800",
                    children: "Gest\xe3o de Avalia\xe7\xf5es"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "mb-6 text-gray-500 text-sm",
                    children: "Aprove, rejeite ou remova avalia\xe7\xf5es de clientes. As avalia\xe7\xf5es aprovadas ficam vis\xedveis nas p\xe1ginas dos compostos."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $687338b1d2c8b49e$export$2e2bcd8739ae039), {
                    authToken: localStorage.getItem("authToken") || undefined,
                    locale: "pt"
                })
            ]
        })
    });
};
var $7dccff3eb6cbef5a$export$2e2bcd8739ae039 = $7dccff3eb6cbef5a$var$ReviewsAdminPage;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");






var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



const $ebedeb17de3e1f27$var$ListHighlightItems = ({ data: data, handleManageItem: handleManageItem, handleDeleteItem: handleDeleteItem, setError: setError })=>{
    const [deletingId, setDeletingId] = (0, $acw62.useState)(null);
    const handleDelete = async (highlight)=>{
        if (!window.confirm(`Tem certeza que deseja apagar "${highlight.title}"?`)) return;
        setDeletingId(highlight.id);
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).delete(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).HIGHLIGHTS}/${highlight.id}`);
            handleDeleteItem(highlight);
        } catch (error) {
            console.error("Error deleting highlight:", error);
            setError(`Erro ao apagar destaque: ${error.message}`);
        } finally{
            setDeletingId(null);
        }
    };
    const formatDate = (dateString)=>{
        return new Date(dateString).toLocaleDateString("pt-PT", {
            year: "numeric",
            month: "short",
            day: "numeric"
        });
    };
    const isActive = (highlight)=>{
        const now = new Date();
        const beginDate = new Date(highlight.begin_date);
        const endDate = new Date(highlight.end_date);
        return highlight.is_active && now >= beginDate && now <= endDate;
    };
    if (data.length === 0) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "bg-white rounded-xl shadow-sm border border-gray-200 p-12 text-center",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "text-gray-500",
                children: "Nenhum destaque encontrado."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "text-sm text-gray-400 mt-2",
                children: 'Clique em "Criar Destaque" para adicionar um novo.'
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
            className: "min-w-full divide-y divide-gray-200",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                    className: "bg-gray-50",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                children: "Ordem"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                children: "Imagem"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                children: "T\xedtulo"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                children: "Per\xedodo"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                children: "Estado"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                children: "Link"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                className: "px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider",
                                children: "A\xe7\xf5es"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                    className: "bg-white divide-y divide-gray-200",
                    children: data.map((highlight)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                            className: "hover:bg-gray-50 transition",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                    className: "px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900",
                                    children: highlight.display_order
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                    className: "px-6 py-4 whitespace-nowrap",
                                    children: highlight.images && highlight.images.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "relative",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                src: highlight.images[0],
                                                alt: highlight.title,
                                                className: "h-12 w-12 object-cover rounded"
                                            }),
                                            highlight.images.length > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "absolute -bottom-1 -right-1 bg-blue-600 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center",
                                                children: highlight.images.length
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "h-12 w-12 bg-gray-200 rounded flex items-center justify-center text-gray-400 text-xs",
                                        children: "Sem imagem"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                    className: "px-6 py-4",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "text-sm font-medium text-gray-900",
                                            children: highlight.title
                                        }),
                                        highlight.description && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "text-sm text-gray-500 truncate max-w-xs",
                                            children: [
                                                highlight.description.substring(0, 60),
                                                highlight.description.length > 60 && "..."
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                    className: "px-6 py-4 whitespace-nowrap text-sm text-gray-500",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex items-center gap-1",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30050f52d874b8f2$export$2e2bcd8739ae039), {
                                                    className: "w-4 h-4"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    children: formatDate(highlight.begin_date)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "flex items-center gap-1 text-xs",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                children: [
                                                    "at\xe9 ",
                                                    formatDate(highlight.end_date)
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                    className: "px-6 py-4 whitespace-nowrap",
                                    children: isActive(highlight) ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039), {
                                                className: "w-3 h-3 mr-1"
                                            }),
                                            "Ativo"
                                        ]
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $056e74b7b26d3329$export$2e2bcd8739ae039), {
                                                className: "w-3 h-3 mr-1"
                                            }),
                                            "Inativo"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                    className: "px-6 py-4 whitespace-nowrap text-sm text-gray-500",
                                    children: [
                                        highlight.compound_id && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "text-blue-600",
                                            title: `PC: ${highlight.compound_id}`,
                                            children: "Produto"
                                        }),
                                        highlight.link_url && /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                            href: highlight.link_url,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            className: "text-blue-600 hover:text-blue-800 flex items-center gap-1",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3c35b0991cad9668$export$2e2bcd8739ae039), {
                                                    className: "w-3 h-3"
                                                }),
                                                "Link externo"
                                            ]
                                        }),
                                        !highlight.compound_id && !highlight.link_url && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "text-gray-400",
                                            children: "\u2014"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                    className: "px-6 py-4 whitespace-nowrap text-right text-sm font-medium",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex gap-2 justify-end",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                onClick: ()=>handleManageItem(highlight),
                                                className: "text-blue-600 hover:text-blue-900 p-1.5 hover:bg-blue-50 rounded transition",
                                                title: "Editar",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $737c279b45d43939$export$2e2bcd8739ae039), {
                                                    className: "w-4 h-4"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                onClick: ()=>handleDelete(highlight),
                                                disabled: deletingId === highlight.id,
                                                className: "text-red-600 hover:text-red-900 p-1.5 hover:bg-red-50 rounded transition disabled:opacity-50",
                                                title: "Apagar",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                                    className: "w-4 h-4"
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }, highlight.id))
                })
            ]
        })
    });
};
var $ebedeb17de3e1f27$export$2e2bcd8739ae039 = $ebedeb17de3e1f27$var$ListHighlightItems;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



const $6d3616b3392aab2a$var$ManageHighlight = ({ highlight: highlight, onHighlightUpdate: onHighlightUpdate, setError: setError, setSuccess: setSuccess })=>{
    const [formData, setFormData] = (0, $acw62.useState)({
        title: "",
        description: "",
        images: [],
        compound_id: "",
        link_url: "",
        begin_date: new Date().toISOString().slice(0, 16),
        end_date: new Date(Date.now() + 2592000000).toISOString().slice(0, 16),
        is_active: true,
        display_order: 0
    });
    const [uploading, setUploading] = (0, $acw62.useState)(false);
    const [saving, setSaving] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (highlight) setFormData({
            ...highlight,
            images: highlight.images || [],
            begin_date: new Date(highlight.begin_date).toISOString().slice(0, 16),
            end_date: new Date(highlight.end_date).toISOString().slice(0, 16)
        });
    }, [
        highlight
    ]);
    const handleInputChange = (e)=>{
        const { name: name, value: value, type: type } = e.target;
        const checked = e.target.checked;
        setFormData((prev)=>({
                ...prev,
                [name]: type === "checkbox" ? checked : value
            }));
    };
    const handleImageUpload = async (files)=>{
        if (!files || files.length === 0) return;
        const currentImages = formData.images || [];
        if (currentImages.length + files.length > 5) {
            setError("M\xe1ximo de 5 imagens permitidas");
            return;
        }
        setUploading(true);
        const uploadedUrls = [];
        try {
            for(let i = 0; i < files.length; i++){
                const file = files[i];
                const formDataUpload = new FormData();
                formDataUpload.append("file", file);
                const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).post(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).HIGHLIGHTS}/upload-image`, formDataUpload, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                });
                uploadedUrls.push(response.data.image_url);
            }
            setFormData((prev)=>({
                    ...prev,
                    images: [
                        ...prev.images || [],
                        ...uploadedUrls
                    ]
                }));
        } catch (error) {
            console.error("Error uploading images:", error);
            setError(`Erro ao fazer upload das imagens: ${error.message}`);
        } finally{
            setUploading(false);
        }
    };
    const removeImage = (index)=>{
        setFormData((prev)=>({
                ...prev,
                images: (prev.images || []).filter((_, i)=>i !== index)
            }));
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        // Validation
        if (!formData.title?.trim()) {
            setError("O t\xedtulo \xe9 obrigat\xf3rio");
            return;
        }
        if (!formData.begin_date || !formData.end_date) {
            setError("As datas de in\xedcio e fim s\xe3o obrigat\xf3rias");
            return;
        }
        const beginDate = new Date(formData.begin_date);
        const endDate = new Date(formData.end_date);
        if (beginDate > endDate) {
            setError("A data de in\xedcio deve ser anterior \xe0 data de fim");
            return;
        }
        setSaving(true);
        setError(null);
        try {
            const dataToSave = {
                ...formData,
                begin_date: new Date(formData.begin_date).toISOString(),
                end_date: new Date(formData.end_date).toISOString()
            };
            let response;
            if (highlight?.id) // Update existing
            response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).put(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).HIGHLIGHTS}/${highlight.id}`, dataToSave);
            else // Create new
            response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).post((0, $cd93687958c8007e$export$bfe19bc25132bb7c).HIGHLIGHTS, dataToSave);
            onHighlightUpdate(response.data);
        } catch (error) {
            console.error("Error saving highlight:", error);
            setError(`Erro ao guardar destaque: ${error.response?.data?.message || error.message}`);
        } finally{
            setSaving(false);
        }
    };
    const remainingSlots = 5 - (formData.images?.length || 0);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
        onSubmit: handleSubmit,
        className: "space-y-6 p-6",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                        className: "block text-sm font-medium text-gray-700 mb-2",
                        children: "T\xedtulo *"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        type: "text",
                        name: "title",
                        value: formData.title,
                        onChange: handleInputChange,
                        required: true,
                        className: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500",
                        placeholder: "T\xedtulo do destaque"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                        className: "block text-sm font-medium text-gray-700 mb-2",
                        children: "Descri\xe7\xe3o"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                        name: "description",
                        value: formData.description,
                        onChange: handleInputChange,
                        rows: 4,
                        className: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500",
                        placeholder: "Descri\xe7\xe3o detalhada do destaque"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                        className: "block text-sm font-medium text-gray-700 mb-2",
                        children: "Imagens (m\xe1ximo 5)"
                    }),
                    formData.images && formData.images.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "grid grid-cols-3 gap-4 mb-4",
                        children: formData.images.map((url, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: url,
                                        alt: `Image ${index + 1}`,
                                        className: "w-full h-32 object-cover rounded border"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>removeImage(index),
                                        className: "absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                            className: "w-4 h-4"
                                        })
                                    })
                                ]
                            }, index))
                    }),
                    remainingSlots > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                        className: "flex flex-col items-center justify-center w-full h-32 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex flex-col items-center justify-center pt-5 pb-6",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f68e7f5ef2ab511$export$2e2bcd8739ae039), {
                                        className: "w-8 h-8 text-gray-400 mb-2"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "text-sm text-gray-500",
                                        children: uploading ? "A carregar..." : `Clique para adicionar imagens (${remainingSlots} restantes)`
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "text-xs text-gray-400",
                                        children: "PNG, JPG, GIF (m\xe1x. 10MB)"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                type: "file",
                                className: "hidden",
                                accept: "image/*",
                                multiple: true,
                                disabled: uploading,
                                onChange: (e)=>handleImageUpload(e.target.files)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                        className: "block text-sm font-medium text-gray-700 mb-2",
                        children: "ID do Composto (Produto)"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        type: "text",
                        name: "compound_id",
                        value: formData.compound_id,
                        onChange: handleInputChange,
                        className: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500",
                        placeholder: "ID do produto relacionado (opcional)"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "text-xs text-gray-500 mt-1",
                        children: "Deixe vazio se n\xe3o quiser vincular a um produto"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                        className: "block text-sm font-medium text-gray-700 mb-2",
                        children: "Link Externo"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        type: "url",
                        name: "link_url",
                        value: formData.link_url,
                        onChange: handleInputChange,
                        className: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500",
                        placeholder: "https://exemplo.com (opcional)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid-cols-2 gap-4",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                className: "block text-sm font-medium text-gray-700 mb-2",
                                children: "Data de In\xedcio *"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                type: "datetime-local",
                                name: "begin_date",
                                value: formData.begin_date,
                                onChange: handleInputChange,
                                required: true,
                                className: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                className: "block text-sm font-medium text-gray-700 mb-2",
                                children: "Data de Fim *"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                type: "datetime-local",
                                name: "end_date",
                                value: formData.end_date,
                                onChange: handleInputChange,
                                required: true,
                                className: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid-cols-2 gap-4",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                className: "block text-sm font-medium text-gray-700 mb-2",
                                children: "Ordem de Exibi\xe7\xe3o"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                type: "number",
                                name: "display_order",
                                value: formData.display_order,
                                onChange: handleInputChange,
                                className: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500",
                                placeholder: "0"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "text-xs text-gray-500 mt-1",
                                children: "Menor n\xfamero aparece primeiro"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex items-end",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                            className: "flex items-center gap-2 cursor-pointer",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    type: "checkbox",
                                    name: "is_active",
                                    checked: formData.is_active,
                                    onChange: handleInputChange,
                                    className: "w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "text-sm font-medium text-gray-700",
                                    children: "Ativo"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex gap-3 pt-4 border-t",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    type: "submit",
                    disabled: saving || uploading,
                    className: "flex-1 bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition",
                    children: saving ? "A guardar..." : uploading ? "A carregar imagens..." : highlight?.id ? "Atualizar" : "Criar"
                })
            })
        ]
    });
};
var $6d3616b3392aab2a$export$2e2bcd8739ae039 = $6d3616b3392aab2a$var$ManageHighlight;


const $9eec85814b628b75$var$HighlightsManagementPage = ()=>{
    const { isAuthenticated: isAuthenticated } = (0, $b622ef53e38024e7$export$1d39dc5b47e56ff0)();
    const navigate = (0, $585f8bce88e531c1$export$9770f232ac06a008)();
    const { pathname: pathname } = (0, $585f8bce88e531c1$export$45d76561a5302f2b)();
    const { setSystemError: setSystemError, setLoading: setLoading, setError: setError, setSuccess: setSuccess, setModalScreen: setModalScreen } = (0, $a55f2a94cd420149$export$c50e37a2f0a2b064)();
    const [highlights, setHighlights] = (0, $acw62.useState)([]);
    const [loading, setLocalLoading] = (0, $acw62.useState)(false);
    const fetchHighlights = async ()=>{
        if (highlights.length === 0) setLocalLoading(true);
        setError(null);
        setSuccess(null);
        try {
            const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).HIGHLIGHTS);
            setHighlights(response.data || []);
        } catch (error) {
            console.log("Error fetching highlights:", error.message);
            setError("Erro ao carregar destaques");
        } finally{
            setLocalLoading(false);
        }
    };
    const handleHighlightUpdated = (0, $acw62.useCallback)(async (highlight)=>{
        const existingHighlight = highlights.find((h)=>h.id === highlight.id);
        if (!existingHighlight) {
            setHighlights((prev)=>[
                    highlight,
                    ...prev
                ]);
            setSuccess(`Destaque "${highlight.title}" criado com sucesso!`);
        } else {
            setHighlights((prev)=>prev.map((h)=>h.id === highlight.id ? highlight : h));
            setSuccess(`Destaque "${highlight.title}" atualizado com sucesso!`);
        }
    }, [
        highlights,
        setSuccess
    ]);
    const handleHighlightDeleted = (highlight)=>{
        setHighlights((prev)=>prev.filter((h)=>h.id !== highlight.id));
        setSuccess(`Destaque "${highlight.title}" apagado com sucesso!`);
    };
    const openManageHighlight = (highlight)=>{
        setModalScreen({
            state: "edit",
            title: highlight?.id ? `Editar destaque: ${highlight.title}` : "Criar novo destaque",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6d3616b3392aab2a$export$2e2bcd8739ae039), {
                highlight: highlight,
                onHighlightUpdate: handleHighlightUpdated,
                setError: setError,
                setSuccess: setSuccess
            }),
            onClose: ()=>{
                setModalScreen(null);
            }
        });
    };
    (0, $acw62.useEffect)(()=>{
        if (!isAuthenticated()) navigate("/login", {
            state: {
                from: pathname
            }
        });
        fetchHighlights();
    }, []);
    if (!isAuthenticated()) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: "You must be logged in to manage highlights."
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "container mx-auto p-6 max-w-7xl",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex flex-col gap-6",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex flex-col md:flex-row justify-between items-start md:items-center gap-4",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "text-3xl font-bold text-gray-900 tracking-tight",
                                    children: "Destaques"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "text-gray-500 mt-1",
                                    children: "Gerencie os destaques exibidos na p\xe1gina inicial."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>openManageHighlight(),
                            className: "bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg font-medium transition",
                            children: "+ Criar Destaque"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "overflow-auto",
                    children: loading ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "bg-white rounded-xl shadow-sm border border-gray-200 p-12",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "text-center",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "mt-4 text-gray-600",
                                    children: "A carregar destaques..."
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebedeb17de3e1f27$export$2e2bcd8739ae039), {
                        data: highlights,
                        handleManageItem: openManageHighlight,
                        handleDeleteItem: handleHighlightDeleted,
                        setError: setError
                    })
                })
            ]
        })
    });
};
var $9eec85814b628b75$export$2e2bcd8739ae039 = $9eec85814b628b75$var$HighlightsManagementPage;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");






var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
var $65a71072f828da5a$export$cae9addff84deec1 = /*#__PURE__*/ function(MetadataStatus) {
    MetadataStatus["DRAFT"] = "DRAFT";
    MetadataStatus["PENDING"] = "PENDING";
    MetadataStatus["PUBLISHED"] = "PUBLISHED";
    MetadataStatus["HIDDEN"] = "HIDDEN";
    MetadataStatus["ARCHIVED"] = "ARCHIVED";
    return MetadataStatus;
}({});
var $65a71072f828da5a$export$d4f428a61c37ddfa = /*#__PURE__*/ function(Locale) {
    Locale["PT"] = "PT";
    Locale["EN"] = "EN";
    Locale["ES"] = "ES";
    Locale["FR"] = "FR";
    return Locale;
}({});
const $65a71072f828da5a$export$ef3eda4fb271eaaa = [
    {
        key: "screen_size_min",
        label: "Ecr\xe3 (m\xedn, polegadas)",
        kind: "number"
    },
    {
        key: "screen_size_max",
        label: "Ecr\xe3 (m\xe1x, polegadas)",
        kind: "number"
    },
    {
        key: "brand",
        label: "Marca (produto)",
        kind: "text"
    },
    {
        key: "search_text",
        label: "Pesquisa por texto",
        kind: "text"
    },
    {
        key: "cpu_brand",
        label: "Marca CPU (Intel/AMD)",
        kind: "text"
    },
    {
        key: "gpu_brand",
        label: "Marca GPU (NVIDIA/AMD)",
        kind: "text"
    },
    {
        key: "memory",
        label: "RAM",
        kind: "text"
    },
    {
        key: "storage",
        label: "Disco",
        kind: "text"
    },
    {
        key: "tags",
        label: "Tags",
        kind: "csv"
    },
    {
        key: "price_range",
        label: "Pre\xe7o (m\xedn/m\xe1x)",
        kind: "range"
    },
    {
        key: "cpu",
        label: "CPU(s)",
        kind: "csv"
    },
    {
        key: "gpu",
        label: "GPU(s)",
        kind: "csv"
    },
    {
        key: "stock_status",
        label: "Disponibilidade",
        kind: "select",
        options: [
            {
                value: "in_stock",
                label: "Em stock"
            },
            {
                value: "last_units",
                label: "\xdaltimas unidades"
            },
            {
                value: "out_of_stock",
                label: "Sem stock"
            }
        ]
    }
];
const $65a71072f828da5a$export$ccb793a3cec36cab = [
    {
        value: "screen_size",
        label: "Tamanho Ecr\xe3"
    },
    {
        value: "brand",
        label: "Marca"
    },
    {
        value: "memory",
        label: "RAM"
    },
    {
        value: "storage",
        label: "Disco"
    },
    {
        value: "cpu",
        label: "CPU"
    },
    {
        value: "gpu",
        label: "GPU"
    },
    {
        value: "stock",
        label: "Disponibilidade"
    },
    {
        value: "price",
        label: "Pre\xe7o"
    },
    {
        value: "tags",
        label: "Tags"
    }
];



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

const $d78f0185ed8c1ba1$var$kindOf = (key)=>(0, $65a71072f828da5a$export$ef3eda4fb271eaaa).find((o)=>o.key === key);
function $d78f0185ed8c1ba1$var$toRows(filters) {
    if (!filters || typeof filters !== "object") return [];
    const search = filters.search && typeof filters.search === "object" && !Array.isArray(filters.search) ? filters.search : {};
    return Object.entries(search).map(([key, value], i)=>{
        if ($d78f0185ed8c1ba1$var$kindOf(key)?.kind === "range" && Array.isArray(value) && value.length > 0 && value[0] && typeof value[0] === "object" && !Array.isArray(value[0])) {
            const r = value[0];
            return {
                id: `${key}-${i}`,
                key: key,
                raw: "",
                min: r.min_price != null ? String(r.min_price) : "",
                max: r.max_price != null ? String(r.max_price) : ""
            };
        }
        const isPrimitive = (candidate)=>typeof candidate === "string" || typeof candidate === "number";
        return {
            id: `${key}-${i}`,
            key: key,
            raw: Array.isArray(value) ? value.filter(isPrimitive).join(", ") : isPrimitive(value) ? String(value) : "",
            min: "",
            max: ""
        };
    });
}
function $d78f0185ed8c1ba1$var$toFilters(rows, lockedFacets) {
    const search = {};
    for (const row of rows){
        if (!row.key) continue;
        const kind = $d78f0185ed8c1ba1$var$kindOf(row.key)?.kind;
        if (kind === "number") {
            if (row.raw.trim() === "" || Number.isNaN(Number(row.raw))) continue;
            search[row.key] = Number(row.raw);
        } else if (kind === "csv") {
            const items = row.raw.split(",").map((s)=>s.trim()).filter(Boolean);
            if (items.length) search[row.key] = items;
        } else if (kind === "range") {
            const range = {};
            if (row.min.trim() !== "") {
                const min = Number(row.min);
                if (!Number.isNaN(min)) range.min_price = min;
            }
            if (row.max.trim() !== "") {
                const max = Number(row.max);
                if (!Number.isNaN(max)) range.max_price = max;
            }
            // Keep whichever bound is valid instead of discarding the whole row.
            if (Object.keys(range).length > 0) search[row.key] = [
                range
            ];
        } else if (row.raw.trim() !== "") search[row.key] = row.raw.trim();
    }
    const locked = lockedFacets.filter(Boolean);
    if (Object.keys(search).length === 0 && locked.length === 0) return null;
    return {
        search: search,
        lockedFacets: locked
    };
}
let $d78f0185ed8c1ba1$var$rowSeq = 0;
const $d78f0185ed8c1ba1$var$nextId = ()=>`f${$d78f0185ed8c1ba1$var$rowSeq++}`;
const $d78f0185ed8c1ba1$var$CategoryFiltersEditor = ({ value: value, onChange: onChange })=>{
    const [rows, setRows] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>$d78f0185ed8c1ba1$var$toRows(value));
    const [locked, setLocked] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>Array.isArray(value?.lockedFacets) ? value.lockedFacets.filter((facet)=>typeof facet === "string") : []);
    const commit = (nextRows, nextLocked)=>{
        setRows(nextRows);
        setLocked(nextLocked);
        onChange($d78f0185ed8c1ba1$var$toFilters(nextRows, nextLocked));
    };
    const updateRow = (id, patch)=>commit(rows.map((r)=>r.id === id ? {
                ...r,
                ...patch
            } : r), locked);
    const addRow = ()=>commit([
            ...rows,
            {
                id: $d78f0185ed8c1ba1$var$nextId(),
                key: "",
                raw: "",
                min: "",
                max: ""
            }
        ], locked);
    const removeRow = (id)=>commit(rows.filter((r)=>r.id !== id), locked);
    const toggleLocked = (facet)=>{
        const next = locked.includes(facet) ? locked.filter((f)=>f !== facet) : [
            ...locked,
            facet
        ];
        commit(rows, next);
    };
    const usedKeys = new Set(rows.map((r)=>r.key).filter(Boolean));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "border-t pt-6 space-y-4",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        className: "text-lg font-medium text-gray-900",
                        children: "Categoria Virtual"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "text-sm text-gray-500 mt-1",
                        children: "Opcional. Aplica filtros \xe0 categoria pai e esconde os filtros correspondentes no frontoffice. Deixa vazio para uma categoria normal."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center justify-between mb-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                className: "block text-sm font-medium text-gray-700",
                                children: "Filtros de pesquisa"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                onClick: addRow,
                                className: "text-sm font-medium text-blue-600 hover:text-blue-700",
                                children: "+ Adicionar filtro"
                            })
                        ]
                    }),
                    rows.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "text-sm text-gray-400",
                        children: "Sem filtros aplicados."
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "space-y-2",
                        children: rows.map((row)=>{
                            const option = $d78f0185ed8c1ba1$var$kindOf(row.key);
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-start gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                        value: row.key,
                                        onChange: (e)=>updateRow(row.id, {
                                                key: e.target.value,
                                                raw: "",
                                                min: "",
                                                max: ""
                                            }),
                                        className: "w-48 px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                value: "",
                                                children: "Selecionar..."
                                            }),
                                            (0, $65a71072f828da5a$export$ef3eda4fb271eaaa).map((o)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: o.key,
                                                    disabled: o.key !== row.key && usedKeys.has(o.key),
                                                    children: o.label
                                                }, o.key))
                                        ]
                                    }),
                                    option?.kind === "range" ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex flex-1 items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                type: "number",
                                                value: row.min,
                                                onChange: (e)=>updateRow(row.id, {
                                                        min: e.target.value
                                                    }),
                                                placeholder: "m\xedn",
                                                className: "w-24 px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "text-gray-400",
                                                children: "\u2013"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                type: "number",
                                                value: row.max,
                                                onChange: (e)=>updateRow(row.id, {
                                                        max: e.target.value
                                                    }),
                                                placeholder: "m\xe1x",
                                                className: "w-24 px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                                            })
                                        ]
                                    }) : option?.kind === "select" ? /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                        value: row.raw,
                                        onChange: (e)=>updateRow(row.id, {
                                                raw: e.target.value
                                            }),
                                        className: "flex-1 px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                value: "",
                                                children: "Selecionar..."
                                            }),
                                            option.options?.map((o)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: o.value,
                                                    children: o.label
                                                }, o.value))
                                        ]
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        type: option?.kind === "number" ? "number" : "text",
                                        value: row.raw,
                                        onChange: (e)=>updateRow(row.id, {
                                                raw: e.target.value
                                            }),
                                        placeholder: option?.kind === "csv" ? "valor1, valor2" : "Valor",
                                        disabled: !row.key,
                                        className: "flex-1 px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-50"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>removeRow(row.id),
                                        "aria-label": "Remover filtro",
                                        className: "mt-1 h-6 w-6 shrink-0 text-gray-400 hover:text-red-600 focus:outline-none",
                                        children: "\u2715"
                                    })
                                ]
                            }, row.id);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                        className: "block text-sm font-medium text-gray-700 mb-2",
                        children: "Filtros bloqueados no frontoffice"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "grid grid-cols-2 gap-2 md:grid-cols-3",
                        children: (0, $65a71072f828da5a$export$ccb793a3cec36cab).map((f)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                className: "flex items-center gap-2 cursor-pointer",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        type: "checkbox",
                                        checked: locked.includes(f.value),
                                        onChange: ()=>toggleLocked(f.value),
                                        className: "w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "text-sm text-gray-700",
                                        children: f.label
                                    })
                                ]
                            }, f.value))
                    })
                ]
            })
        ]
    });
};
var $d78f0185ed8c1ba1$export$2e2bcd8739ae039 = $d78f0185ed8c1ba1$var$CategoryFiltersEditor;





const $0440242d86d68f79$var$isObject = (value)=>typeof value === "object" && value !== null && !Array.isArray(value);
function $0440242d86d68f79$var$parseFilters(raw) {
    if (!raw) return null;
    try {
        const parsed = JSON.parse(raw);
        if (!$0440242d86d68f79$var$isObject(parsed)) return null;
        const search = $0440242d86d68f79$var$isObject(parsed.search) ? parsed.search : {};
        const lockedFacets = Array.isArray(parsed.lockedFacets) ? parsed.lockedFacets.filter((facet)=>typeof facet === "string") : [];
        return {
            search: search,
            lockedFacets: lockedFacets
        };
    } catch  {
        return null;
    }
}
function $0440242d86d68f79$var$slugify(value) {
    return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
}
async function $0440242d86d68f79$var$revalidateStorefront() {
    const controller = new AbortController();
    const timeout = setTimeout(()=>controller.abort(), 2000);
    try {
        const response = await fetch("/api/internal/revalidate-storefront", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                tags: [
                    "categories"
                ]
            }),
            signal: controller.signal
        });
        if (!response.ok) (0, $031177517a2d1428$export$b33b857ad1d9900e)("categories.revalidate", new Error(`HTTP ${response.status}`), {
            "http.status": response.status
        });
    } catch (error) {
        (0, $031177517a2d1428$export$b33b857ad1d9900e)("categories.revalidate", error);
    } finally{
        clearTimeout(timeout);
    }
}
const $0440242d86d68f79$var$ManageCategory = ({ category: category, onCategoryUpdate: onCategoryUpdate, setError: setError, setSuccess: setSuccess, categories: categories })=>{
    const [formData, setFormData] = (0, $acw62.useState)(()=>({
            slug: category?.slug ?? "",
            name: category?.name ?? "",
            order: category?.order ?? 0,
            image: category?.image ?? "",
            icon: category?.icon ?? "",
            showcase: category?.showcase ?? true,
            searchable: category?.searchable ?? true,
            filterable: category?.filterable ?? true,
            minisite: category?.minisite ?? false,
            navigation: category?.navigation ?? false,
            status: category?.status ?? (0, $65a71072f828da5a$export$cae9addff84deec1).PUBLISHED,
            parentId: category?.parentId,
            display_name: {
                [(0, $65a71072f828da5a$export$d4f428a61c37ddfa).PT]: "",
                ...category?.display_name ?? {}
            },
            description: {
                [(0, $65a71072f828da5a$export$d4f428a61c37ddfa).PT]: "",
                ...category?.description ?? {}
            },
            filters: category?.filters ?? null
        }));
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const submittingRef = (0, $acw62.useRef)(false);
    const abortRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>()=>{
            // Cancels the request if the modal closes/switches before it settles.
            abortRef.current?.abort();
        }, []);
    const [filters, setFilters] = (0, $acw62.useState)(()=>$0440242d86d68f79$var$parseFilters(category?.filters));
    // Existing categories keep their published slug unless the admin edits the
    // slug field directly. New categories follow the name until the slug is touched.
    const [slugTouched, setSlugTouched] = (0, $acw62.useState)(!!category?.slug);
    const handleChange = (e)=>{
        const { name: name, value: value, type: type } = e.target;
        if (type === "checkbox") {
            const checked = e.target.checked;
            setFormData((prev)=>({
                    ...prev,
                    [name]: checked
                }));
        } else {
            if (name === "slug") setSlugTouched(true);
            setFormData((prev)=>{
                const next = {
                    ...prev,
                    [name]: value
                };
                if (name === "name" && !slugTouched) next.slug = $0440242d86d68f79$var$slugify(value);
                return next;
            });
        }
    };
    const handleLocaleChange = (field, locale, value)=>{
        setFormData((prev)=>({
                ...prev,
                [field]: {
                    ...prev[field],
                    [locale]: value
                }
            }));
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (submittingRef.current) return;
        submittingRef.current = true;
        setLoading(true);
        setError(null);
        setSuccess(null);
        const controller = new AbortController();
        abortRef.current = controller;
        try {
            // Explicit whitelist: never echo `id`/`children` or unvalidated fields
            // from the server payload back to the API.
            const payload = {
                slug: formData.slug,
                name: formData.name,
                order: Number(formData.order) || 0,
                image: formData.image ?? null,
                icon: formData.icon ?? null,
                showcase: formData.showcase,
                searchable: formData.searchable,
                filterable: formData.filterable,
                minisite: formData.minisite,
                navigation: formData.navigation,
                status: formData.status,
                parentId: formData.parentId ?? null,
                display_name: formData.display_name ?? {},
                description: formData.description ?? {},
                filters: filters ? JSON.stringify(filters) : null
            };
            const config = {
                timeout: 20000,
                signal: controller.signal
            };
            let response;
            if (category?.id != null) response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).put(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).CATEGORIES}/${category.id}`, payload, config);
            else response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).post((0, $cd93687958c8007e$export$bfe19bc25132bb7c).CATEGORIES, payload, config);
            // Best-effort: purge the storefront's cached category tree so the recipe
            // (noindex/resolution) applies immediately instead of up to 1h later.
            // It must never block the save or the modal close.
            onCategoryUpdate(response.data);
            $0440242d86d68f79$var$revalidateStorefront();
        } catch (error) {
            const canceled = error?.code === "ERR_CANCELED" || error?.name === "CanceledError" || error?.name === "AbortError";
            if (canceled) return;
            const status = error.response?.status;
            const backendMessage = error.response?.data?.message;
            const message = status === 409 ? "J\xe1 existe uma categoria com este slug." : backendMessage || (error.request ? "N\xe3o foi poss\xedvel contactar o servidor." : error.message) || "Erro desconhecido";
            (0, $031177517a2d1428$export$b33b857ad1d9900e)("categories.save", error, {
                "http.status": status,
                "category.id": category?.id
            });
            setError(`Erro ao guardar categoria: ${message}`);
        } finally{
            submittingRef.current = false;
            if (abortRef.current === controller) abortRef.current = null;
            setLoading(false);
        }
    };
    const parentOptions = (0, $acw62.useMemo)(()=>{
        const result = [];
        const walk = (nodes, prefix)=>{
            for (const node of nodes){
                // Skip the edited node and its whole subtree (prevents cycles).
                if (node.id === category?.id) continue;
                if (node.id != null) result.push({
                    id: node.id,
                    name: prefix + node.name
                });
                if (node.children?.length) walk(node.children, `${prefix}-- `);
            }
        };
        walk(categories, "");
        return result;
    }, [
        categories,
        category?.id
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
        onSubmit: handleSubmit,
        className: "space-y-6 p-6",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid-cols-1 md:grid-cols-2 gap-6",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                className: "block text-sm font-medium text-gray-700 mb-2",
                                children: "Nome (Interno) *"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                type: "text",
                                name: "name",
                                value: formData.name,
                                onChange: handleChange,
                                required: true,
                                maxLength: 120,
                                className: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500",
                                placeholder: "Nome interno da categoria"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                className: "block text-sm font-medium text-gray-700 mb-2",
                                children: "Slug *"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                type: "text",
                                name: "slug",
                                value: formData.slug,
                                onChange: handleChange,
                                required: true,
                                maxLength: 160,
                                className: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500",
                                placeholder: "slug-da-categoria"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                className: "block text-sm font-medium text-gray-700 mb-2",
                                children: "Ordem"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                type: "number",
                                name: "order",
                                value: formData.order,
                                onChange: handleChange,
                                className: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                className: "block text-sm font-medium text-gray-700 mb-2",
                                children: "Status"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                                name: "status",
                                value: formData.status,
                                onChange: handleChange,
                                className: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500",
                                children: Object.values((0, $65a71072f828da5a$export$cae9addff84deec1)).map((status)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: status,
                                        children: status
                                    }, status))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "md:col-span-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                className: "block text-sm font-medium text-gray-700 mb-2",
                                children: "Categoria Pai"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                name: "parentId",
                                value: formData.parentId || "",
                                onChange: (e)=>setFormData((prev)=>({
                                            ...prev,
                                            parentId: e.target.value ? Number(e.target.value) : undefined
                                        })),
                                className: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "",
                                        children: "Nenhuma (Raiz)"
                                    }),
                                    parentOptions.map((opt)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                            value: opt.id,
                                            children: opt.name
                                        }, opt.id))
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid-cols-2 md:grid-cols-4 gap-4 pt-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                        className: "flex items-center gap-2 cursor-pointer",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                type: "checkbox",
                                name: "showcase",
                                checked: formData.showcase,
                                onChange: handleChange,
                                className: "w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "text-sm font-medium text-gray-700",
                                children: "Showcase"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                        className: "flex items-center gap-2 cursor-pointer",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                type: "checkbox",
                                name: "searchable",
                                checked: formData.searchable,
                                onChange: handleChange,
                                className: "w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "text-sm font-medium text-gray-700",
                                children: "Pesquis\xe1vel"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                        className: "flex items-center gap-2 cursor-pointer",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                type: "checkbox",
                                name: "filterable",
                                checked: formData.filterable,
                                onChange: handleChange,
                                className: "w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "text-sm font-medium text-gray-700",
                                children: "Filtr\xe1vel"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                        className: "flex items-center gap-2 cursor-pointer",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                type: "checkbox",
                                name: "minisite",
                                checked: formData.minisite,
                                onChange: handleChange,
                                className: "w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "text-sm font-medium text-gray-700",
                                children: "Minisite"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                        className: "flex items-center gap-2 cursor-pointer",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                type: "checkbox",
                                name: "navigation",
                                checked: formData.navigation,
                                onChange: handleChange,
                                className: "w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "text-sm font-medium text-gray-700",
                                children: "Navega\xe7\xe3o"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d78f0185ed8c1ba1$export$2e2bcd8739ae039), {
                value: filters,
                onChange: setFilters
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "border-t pt-6",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        className: "text-lg font-medium text-gray-900 mb-4",
                        children: "Tradu\xe7\xf5es"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "space-y-6",
                        children: Object.values((0, $65a71072f828da5a$export$d4f428a61c37ddfa)).map((locale)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "bg-gray-50 p-4 rounded-lg border border-gray-200",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                        className: "font-medium text-sm text-gray-900 mb-3 flex items-center gap-2",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "uppercase bg-white px-2 py-0.5 rounded border text-xs",
                                            children: locale
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "grid grid-cols-1 gap-4",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        className: "block text-xs font-medium text-gray-500 mb-1",
                                                        children: "Nome de Exibi\xe7\xe3o"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "text",
                                                        value: formData.display_name[locale] || "",
                                                        onChange: (e)=>handleLocaleChange("display_name", locale, e.target.value),
                                                        maxLength: 120,
                                                        className: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm",
                                                        placeholder: `Nome em ${locale}`
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        className: "block text-xs font-medium text-gray-500 mb-1",
                                                        children: "Descri\xe7\xe3o"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                        value: formData.description[locale] || "",
                                                        onChange: (e)=>handleLocaleChange("description", locale, e.target.value),
                                                        rows: 2,
                                                        maxLength: 2000,
                                                        className: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm",
                                                        placeholder: `Descri\xe7\xe3o em ${locale}`
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, locale))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex justify-end pt-4 border-t",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    type: "submit",
                    disabled: loading,
                    className: "bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 transition font-medium",
                    children: loading ? "A guardar..." : category?.id ? "Atualizar Categoria" : "Criar Categoria"
                })
            })
        ]
    });
};
var $0440242d86d68f79$export$2e2bcd8739ae039 = $0440242d86d68f79$var$ManageCategory;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


const $d00652f0b71c3667$var$normalize = (value)=>value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();
const $d00652f0b71c3667$var$displayNameOf = (category)=>{
    const names = category.display_name ?? {};
    return names[(0, $65a71072f828da5a$export$d4f428a61c37ddfa).PT] ?? names[(0, $65a71072f828da5a$export$d4f428a61c37ddfa).PT.toLowerCase()] ?? "";
};
const $d00652f0b71c3667$var$matchesQuery = (category, query)=>$d00652f0b71c3667$var$normalize(category.name).includes(query) || $d00652f0b71c3667$var$normalize(category.slug ?? "").includes(query) || $d00652f0b71c3667$var$normalize($d00652f0b71c3667$var$displayNameOf(category)).includes(query);
const $d00652f0b71c3667$var$filterTree = (nodes, query)=>{
    if (!query) return nodes;
    const result = [];
    for (const node of nodes){
        if ($d00652f0b71c3667$var$matchesQuery(node, query)) {
            // A matching parent brings its whole subtree with it.
            result.push(node);
            continue;
        }
        const children = $d00652f0b71c3667$var$filterTree(node.children ?? [], query);
        if (children.length > 0) result.push({
            ...node,
            children: children
        });
    }
    return result;
};
const $d00652f0b71c3667$var$collectParentIds = (nodes, acc = new Set())=>{
    for (const node of nodes)if (node.children?.length) {
        if (node.id != null) acc.add(node.id);
        $d00652f0b71c3667$var$collectParentIds(node.children, acc);
    }
    return acc;
};
const $d00652f0b71c3667$var$countNodes = (nodes)=>nodes.reduce((total, node)=>total + 1 + $d00652f0b71c3667$var$countNodes(node.children ?? []), 0);
const $d00652f0b71c3667$var$EMPTY_IDS = new Set();
const $d00652f0b71c3667$var$areCategoryRowsEqual = (prev, next)=>{
    if (prev.category !== next.category) return false;
    if (prev.level !== next.level) return false;
    if (prev.toggleDisabled !== next.toggleDisabled) return false;
    if (prev.deletingIds !== next.deletingIds) return false;
    if (prev.collapsedIds !== next.collapsedIds) return false;
    if (prev.onToggle !== next.onToggle) return false;
    if (prev.onManage !== next.onManage) return false;
    if (prev.onDelete !== next.onDelete) return false;
    return true;
};
const $d00652f0b71c3667$var$CategoryRow = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(function CategoryRow({ category: category, level: level, collapsedIds: collapsedIds, toggleDisabled: toggleDisabled, deletingIds: deletingIds, onToggle: onToggle, onManage: onManage, onDelete: onDelete }) {
    const hasChildren = !!category.children?.length;
    const canToggle = hasChildren && category.id != null;
    const expanded = canToggle && !collapsedIds.has(category.id);
    const deleteDisabled = category.id != null && deletingIds.has(category.id);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                className: "hover:bg-gray-50 transition border-b border-gray-100 last:border-0",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        className: "px-6 py-4 whitespace-nowrap text-sm text-gray-900",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex items-center gap-2",
                            style: {
                                paddingLeft: `${level * 20}px`
                            },
                            children: [
                                canToggle ? /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>onToggle(category.id),
                                    disabled: toggleDisabled,
                                    "aria-expanded": expanded,
                                    "aria-label": `${expanded ? "Recolher" : "Expandir"} ${category.name}`,
                                    className: "text-gray-500 hover:text-gray-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 rounded disabled:opacity-40 disabled:cursor-not-allowed",
                                    children: expanded ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                        size: 16
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                                        size: 16
                                    })
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "w-4",
                                    "aria-hidden": "true"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "font-medium",
                                    children: category.name
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        className: "px-6 py-4 whitespace-nowrap text-sm text-gray-500",
                        children: $d00652f0b71c3667$var$displayNameOf(category) || /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "text-gray-300",
                            children: "\u2014"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        className: "px-6 py-4 whitespace-nowrap text-sm text-gray-500",
                        children: category.slug
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        className: "px-6 py-4 whitespace-nowrap text-sm text-gray-500",
                        children: category.order
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        className: "px-6 py-4 whitespace-nowrap",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: `inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${category.status === "PUBLISHED" ? "bg-green-100 text-green-800" : "bg-yellow-100 text-yellow-800"}`,
                            children: category.status
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        className: "px-6 py-4 whitespace-nowrap text-right text-sm font-medium",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex gap-2 justify-end",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>onManage(category),
                                    className: "text-blue-600 hover:text-blue-900 p-1.5 hover:bg-blue-50 rounded transition focus-visible:ring-2 focus-visible:ring-blue-500",
                                    title: "Editar",
                                    "aria-label": `Editar ${category.name}`,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $737c279b45d43939$export$2e2bcd8739ae039), {
                                        className: "w-4 h-4"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>onDelete(category),
                                    disabled: deleteDisabled,
                                    className: "text-red-600 hover:text-red-900 p-1.5 hover:bg-red-50 rounded transition focus-visible:ring-2 focus-visible:ring-red-500 disabled:opacity-40 disabled:cursor-not-allowed",
                                    title: "Apagar",
                                    "aria-label": `Apagar ${category.name}`,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                        className: "w-4 h-4"
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            expanded && category.children.map((child)=>/*#__PURE__*/ (0, $ayMG0.jsx)(CategoryRow, {
                    category: child,
                    level: level + 1,
                    collapsedIds: collapsedIds,
                    toggleDisabled: toggleDisabled,
                    deletingIds: deletingIds,
                    onToggle: onToggle,
                    onManage: onManage,
                    onDelete: onDelete
                }, child.id))
        ]
    });
}, $d00652f0b71c3667$var$areCategoryRowsEqual);
const $d00652f0b71c3667$var$ListCategoryItems = ({ data: data, handleManageItem: handleManageItem, handleDeleteItem: handleDeleteItem, deletingIds: deletingIds = $d00652f0b71c3667$var$EMPTY_IDS })=>{
    const [query, setQuery] = (0, $acw62.useState)("");
    const [collapsedIds, setCollapsedIds] = (0, $acw62.useState)(()=>new Set());
    const deferredQuery = (0, $acw62.useDeferredValue)(query);
    const normalizedQuery = $d00652f0b71c3667$var$normalize(deferredQuery);
    const isSearching = $d00652f0b71c3667$var$normalize(query).length > 0;
    const visibleData = (0, $acw62.useMemo)(()=>$d00652f0b71c3667$var$filterTree(data, normalizedQuery), [
        data,
        normalizedQuery
    ]);
    const visibleCount = (0, $acw62.useMemo)(()=>$d00652f0b71c3667$var$countNodes(visibleData), [
        visibleData
    ]);
    const totalCount = (0, $acw62.useMemo)(()=>$d00652f0b71c3667$var$countNodes(data), [
        data
    ]);
    const effectiveCollapsedIds = isSearching ? $d00652f0b71c3667$var$EMPTY_IDS : collapsedIds;
    const toggle = (0, $acw62.useCallback)((id)=>{
        setCollapsedIds((prev)=>{
            const next = new Set(prev);
            if (next.has(id)) next.delete(id);
            else next.add(id);
            return next;
        });
    }, []);
    const expandAll = (0, $acw62.useCallback)(()=>setCollapsedIds(new Set()), []);
    const collapseAll = (0, $acw62.useCallback)(()=>setCollapsedIds($d00652f0b71c3667$var$collectParentIds(data)), [
        data
    ]);
    if (data.length === 0) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "bg-white rounded-xl shadow-sm border border-gray-200 p-12 text-center",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "text-gray-500",
                children: "Nenhuma categoria encontrada."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "text-sm text-gray-400 mt-2",
                children: 'Clique em "Nova Categoria" para adicionar uma nova.'
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex flex-col gap-3 p-4 border-b border-gray-200 md:flex-row md:items-center md:justify-between",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "relative w-full md:max-w-sm",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ad14973a512851d$export$2e2bcd8739ae039), {
                                className: "absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                type: "search",
                                value: query,
                                onChange: (e)=>setQuery(e.target.value),
                                placeholder: "Pesquisar por nome ou slug",
                                "aria-label": "Pesquisar categorias",
                                className: "w-full pl-9 pr-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex flex-wrap items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "text-sm text-gray-500 mr-auto md:mr-0",
                                children: [
                                    "A mostrar ",
                                    visibleCount,
                                    " de ",
                                    totalCount,
                                    " categoria",
                                    totalCount === 1 ? "" : "s"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                onClick: expandAll,
                                disabled: isSearching,
                                className: "px-3 py-1.5 text-sm rounded-md border border-gray-300 text-gray-700 hover:bg-gray-50 transition disabled:opacity-50 disabled:cursor-not-allowed",
                                children: "Expandir tudo"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                onClick: collapseAll,
                                disabled: isSearching,
                                className: "px-3 py-1.5 text-sm rounded-md border border-gray-300 text-gray-700 hover:bg-gray-50 transition disabled:opacity-50 disabled:cursor-not-allowed",
                                children: "Recolher tudo"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                className: "min-w-full divide-y divide-gray-200",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                        className: "bg-gray-50",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                    className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                    children: "Nome"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                    className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                    children: "Nome (loja)"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                    className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                    children: "Slug"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                    className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                    children: "Ordem"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                    className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                    children: "Estado"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                    className: "px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider",
                                    children: "A\xe7\xf5es"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                        className: "bg-white divide-y divide-gray-200",
                        children: visibleData.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                colSpan: 6,
                                className: "px-6 py-12 text-center text-sm text-gray-500",
                                children: [
                                    'Sem categorias para "',
                                    query,
                                    '".'
                                ]
                            })
                        }) : visibleData.map((category)=>/*#__PURE__*/ (0, $ayMG0.jsx)($d00652f0b71c3667$var$CategoryRow, {
                                category: category,
                                level: 0,
                                collapsedIds: effectiveCollapsedIds,
                                toggleDisabled: isSearching,
                                deletingIds: deletingIds,
                                onToggle: toggle,
                                onManage: handleManageItem,
                                onDelete: handleDeleteItem
                            }, category.id))
                    })
                ]
            })
        ]
    });
};
var $d00652f0b71c3667$export$2e2bcd8739ae039 = $d00652f0b71c3667$var$ListCategoryItems;




const $c3267fb74548c051$var$MAX_DEPTH = 64;
const $c3267fb74548c051$var$isObject = (value)=>typeof value === "object" && value !== null && !Array.isArray(value);
const $c3267fb74548c051$var$asString = (value, fallback = "")=>typeof value === "string" ? value : fallback;
const $c3267fb74548c051$var$asBoolean = (value, fallback)=>typeof value === "boolean" ? value : fallback;
const $c3267fb74548c051$var$asNumber = (value, fallback = 0)=>typeof value === "number" && Number.isFinite(value) ? value : fallback;
const $c3267fb74548c051$var$asLocaleMap = (value)=>{
    if (!$c3267fb74548c051$var$isObject(value)) return {};
    const result = {};
    for (const [locale, text] of Object.entries(value))if (typeof text === "string") result[locale] = text;
    return result;
};
const $c3267fb74548c051$var$asStatus = (value)=>{
    if (typeof value !== "string") return null;
    const normalized = value.toUpperCase();
    return Object.values((0, $65a71072f828da5a$export$cae9addff84deec1)).includes(normalized) ? normalized : null;
};
const $c3267fb74548c051$var$asId = (value)=>typeof value === "number" && Number.isSafeInteger(value) && value > 0 ? value : null;
const $c3267fb74548c051$var$countSubtree = (value, depth = 0)=>{
    if (!Array.isArray(value) || depth > $c3267fb74548c051$var$MAX_DEPTH) return 0;
    let count = 0;
    for (const child of value){
        count += 1;
        if ($c3267fb74548c051$var$isObject(child)) count += $c3267fb74548c051$var$countSubtree(child.children, depth + 1);
    }
    return count;
};
const $c3267fb74548c051$export$66f6acc2b205b278 = (input)=>{
    if (!Array.isArray(input)) return {
        categories: [],
        valid: false,
        dropped: 0
    };
    const seen = new Set();
    let dropped = 0;
    const walk = (nodes, depth)=>{
        if (depth > $c3267fb74548c051$var$MAX_DEPTH) {
            dropped += nodes.length;
            return [];
        }
        const result = [];
        for (const raw of nodes){
            if (!$c3267fb74548c051$var$isObject(raw)) {
                dropped += 1;
                continue;
            }
            const id = $c3267fb74548c051$var$asId(raw.id);
            if (id == null || seen.has(id)) {
                dropped += 1 + $c3267fb74548c051$var$countSubtree(raw.children);
                continue;
            }
            const status = $c3267fb74548c051$var$asStatus(raw.status);
            if (status == null) {
                dropped += 1 + $c3267fb74548c051$var$countSubtree(raw.children);
                continue;
            }
            const parentId = $c3267fb74548c051$var$asId(raw.parentId);
            if (raw.parentId != null && parentId == null) {
                dropped += 1 + $c3267fb74548c051$var$countSubtree(raw.children);
                continue;
            }
            seen.add(id);
            const children = Array.isArray(raw.children) ? walk(raw.children, depth + 1) : [];
            result.push({
                id: id,
                slug: $c3267fb74548c051$var$asString(raw.slug),
                name: $c3267fb74548c051$var$asString(raw.name),
                order: $c3267fb74548c051$var$asNumber(raw.order),
                image: typeof raw.image === "string" ? raw.image : undefined,
                icon: typeof raw.icon === "string" ? raw.icon : undefined,
                showcase: $c3267fb74548c051$var$asBoolean(raw.showcase, true),
                searchable: $c3267fb74548c051$var$asBoolean(raw.searchable, true),
                filterable: $c3267fb74548c051$var$asBoolean(raw.filterable, true),
                minisite: $c3267fb74548c051$var$asBoolean(raw.minisite, false),
                navigation: $c3267fb74548c051$var$asBoolean(raw.navigation, false),
                status: status,
                parentId: parentId ?? undefined,
                display_name: $c3267fb74548c051$var$asLocaleMap(raw.display_name),
                description: $c3267fb74548c051$var$asLocaleMap(raw.description),
                children: children,
                filters: typeof raw.filters === "string" ? raw.filters : null
            });
        }
        return result;
    };
    return {
        categories: walk(input, 0),
        valid: true,
        dropped: dropped
    };
};


const $5e9e435a10d3c9d3$var$isCanceled = (error)=>error?.code === "ERR_CANCELED" || error?.name === "CanceledError" || error?.name === "AbortError";
const $5e9e435a10d3c9d3$var$CATEGORIES_TIMEOUT_MS = 15000;
const $5e9e435a10d3c9d3$var$findCategoryById = (categories, id)=>{
    for (const category of categories){
        if (category.id === id) return category;
        const child = category.children ? $5e9e435a10d3c9d3$var$findCategoryById(category.children, id) : undefined;
        if (child) return child;
    }
    return undefined;
};
const $5e9e435a10d3c9d3$var$countDescendants = (category)=>(category.children ?? []).reduce((total, child)=>total + 1 + $5e9e435a10d3c9d3$var$countDescendants(child), 0);
const $5e9e435a10d3c9d3$var$CategoriesManagementPage = ()=>{
    const { isAuthenticated: isAuthenticated } = (0, $b622ef53e38024e7$export$1d39dc5b47e56ff0)();
    const navigate = (0, $585f8bce88e531c1$export$9770f232ac06a008)();
    const { pathname: pathname } = (0, $585f8bce88e531c1$export$45d76561a5302f2b)();
    const [searchParams, setSearchParams] = (0, $585f8bce88e531c1$export$f1a78c17382fe22a)();
    const { setModalScreen: setModalScreen, setError: setError, setSuccess: setSuccess } = (0, $a55f2a94cd420149$export$c50e37a2f0a2b064)();
    const [categories, setCategories] = (0, $acw62.useState)([]);
    const [hasLoaded, setHasLoaded] = (0, $acw62.useState)(false);
    const [loadError, setLoadError] = (0, $acw62.useState)(null);
    const [deletingIds, setDeletingIds] = (0, $acw62.useState)(()=>new Set());
    // Ref mirror of the modal key derived from the URL. It prevents the effect
    // below from reopening the same modal whenever `categories` or the callbacks
    // change identity; only a new URL-derived key opens a new modal.
    const openModalKey = (0, $acw62.useRef)(null);
    const openModalToken = (0, $acw62.useRef)(null);
    const requestId = (0, $acw62.useRef)(0);
    const mountedRef = (0, $acw62.useRef)(true);
    const deletingIdsRef = (0, $acw62.useRef)(new Set());
    const activeFetchRef = (0, $acw62.useRef)(null);
    const activeDeleteRef = (0, $acw62.useRef)(null);
    const fetchCategories = (0, $acw62.useCallback)(async ()=>{
        activeFetchRef.current?.abort();
        const controller = new AbortController();
        activeFetchRef.current = controller;
        const request = ++requestId.current;
        try {
            const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).CATEGORIES, {
                timeout: $5e9e435a10d3c9d3$var$CATEGORIES_TIMEOUT_MS,
                signal: controller.signal
            });
            if (request !== requestId.current) return "stale";
            const normalized = (0, $c3267fb74548c051$export$66f6acc2b205b278)(response.data);
            if (!normalized.valid) {
                (0, $031177517a2d1428$export$b33b857ad1d9900e)("categories.list", new Error("Resposta inv\xe1lida do servidor"));
                setLoadError("Resposta inv\xe1lida do servidor");
                return "error";
            }
            if (normalized.dropped > 0) (0, $031177517a2d1428$export$b33b857ad1d9900e)("categories.normalize", new Error("Categorias inv\xe1lidas"), {
                dropped: normalized.dropped
            });
            if (normalized.categories.length === 0 && normalized.dropped > 0) {
                setLoadError("Resposta inv\xe1lida do servidor");
                return "error";
            }
            setCategories(normalized.categories);
            setLoadError(normalized.dropped > 0 ? `Alguns registos n\xe3o puderam ser apresentados (${normalized.dropped} ignorado${normalized.dropped === 1 ? "" : "s"}).` : null);
            return "ok";
        } catch (error) {
            if ($5e9e435a10d3c9d3$var$isCanceled(error)) return "stale";
            if (request !== requestId.current) return "stale";
            (0, $031177517a2d1428$export$b33b857ad1d9900e)("categories.list", error, {
                "http.status": error.response?.status
            });
            setLoadError("Erro ao carregar categorias");
            return "error";
        } finally{
            if (activeFetchRef.current === controller) activeFetchRef.current = null;
            if (request === requestId.current) setHasLoaded(true);
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        mountedRef.current = true;
        if (!isAuthenticated()) {
            navigate("/login", {
                state: {
                    from: pathname
                }
            });
            return;
        }
        fetchCategories();
        return ()=>{
            // The modal lives in LayoutContext (above the router), so it must be
            // closed explicitly when this page unmounts. The request token makes
            // any in-flight fetch a no-op.
            mountedRef.current = false;
            requestId.current += 1;
            activeFetchRef.current?.abort();
            activeFetchRef.current = null;
            activeDeleteRef.current?.abort();
            activeDeleteRef.current = null;
            openModalKey.current = null;
            openModalToken.current = null;
            setModalScreen(null);
        };
    }, [
        isAuthenticated,
        navigate,
        pathname,
        fetchCategories,
        setModalScreen
    ]);
    const clearModalParams = (0, $acw62.useCallback)(()=>{
        const next = new URLSearchParams(searchParams);
        next.delete("edit");
        next.delete("new");
        setSearchParams(next, {
            replace: true
        });
    }, [
        searchParams,
        setSearchParams
    ]);
    const closeModal = (0, $acw62.useCallback)(()=>{
        openModalKey.current = null;
        openModalToken.current = null;
        setModalScreen(null);
        clearModalParams();
    }, [
        clearModalParams,
        setModalScreen
    ]);
    const handleCategoryUpdated = (0, $acw62.useCallback)(async (updatedCategory, token)=>{
        if (!mountedRef.current) return;
        // Only close the modal instance that initiated this save. If the operator
        // moved to another category (or the create form) meanwhile, leave it open.
        if (openModalToken.current === token) closeModal();
        const result = await fetchCategories();
        if (!mountedRef.current) return;
        if (result === "error") setError(`Categoria "${updatedCategory.name}" guardada, mas a lista n\xe3o foi atualizada. Recarregue a p\xe1gina.`);
        else setSuccess(`Categoria "${updatedCategory.name}" guardada com sucesso!`);
    }, [
        closeModal,
        fetchCategories,
        setError,
        setSuccess
    ]);
    const handleDeleteCategory = (0, $acw62.useCallback)(async (category)=>{
        if (category.id == null || deletingIdsRef.current.has(category.id)) return;
        deletingIdsRef.current.add(category.id);
        setDeletingIds(new Set(deletingIdsRef.current));
        const controller = new AbortController();
        activeDeleteRef.current = controller;
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).delete(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).CATEGORIES}/${category.id}`, {
                timeout: 20000,
                signal: controller.signal
            });
            if (!mountedRef.current) return;
            const result = await fetchCategories();
            if (!mountedRef.current) return;
            if (result === "error") setError(`Categoria "${category.name}" apagada, mas a lista n\xe3o foi atualizada. Recarregue a p\xe1gina.`);
            else setSuccess(`Categoria "${category.name}" apagada com sucesso!`);
        } catch (error) {
            if ($5e9e435a10d3c9d3$var$isCanceled(error)) return;
            if (!mountedRef.current) return;
            (0, $031177517a2d1428$export$b33b857ad1d9900e)("categories.delete", error, {
                "http.status": error.response?.status,
                "category.id": category.id
            });
            setError(error.response?.data?.message || "Erro ao apagar categoria");
        } finally{
            if (activeDeleteRef.current === controller) activeDeleteRef.current = null;
            if (category.id != null) {
                deletingIdsRef.current.delete(category.id);
                if (mountedRef.current) setDeletingIds(new Set(deletingIdsRef.current));
            }
        }
    }, [
        fetchCategories,
        setError,
        setSuccess
    ]);
    const confirmDeleteCategory = (0, $acw62.useCallback)((category)=>{
        const descendants = $5e9e435a10d3c9d3$var$countDescendants(category);
        const blocked = descendants > 0;
        setModalScreen({
            state: blocked ? "alert" : "confirm",
            title: "Apagar categoria",
            dismissOnEscape: true,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "space-y-4 p-6",
                children: [
                    blocked ? /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "text-sm text-gray-700",
                        children: [
                            "A categoria ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                children: category.name
                            }),
                            " tem ",
                            descendants,
                            " ",
                            "subcategoria",
                            descendants === 1 ? "" : "s",
                            ". Apague ou mova-as primeiro \u2014 a base de dados n\xe3o apaga os filhos em cascata."
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "text-sm text-gray-700",
                        children: [
                            "Tem a certeza que deseja apagar a categoria",
                            " ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                children: category.name
                            }),
                            "? Esta a\xe7\xe3o n\xe3o pode ser revertida."
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex justify-end gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                onClick: ()=>setModalScreen(null),
                                className: "px-4 py-2 rounded-md border border-gray-300 text-gray-700 hover:bg-gray-50 transition",
                                children: blocked ? "Fechar" : "Cancelar"
                            }),
                            !blocked && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                onClick: ()=>{
                                    setModalScreen(null);
                                    handleDeleteCategory(category);
                                },
                                className: "px-4 py-2 rounded-md bg-red-600 text-white hover:bg-red-700 transition",
                                children: "Apagar"
                            })
                        ]
                    })
                ]
            }),
            onClose: ()=>setModalScreen(null)
        });
    }, [
        handleDeleteCategory,
        setModalScreen
    ]);
    const openManageModal = (0, $acw62.useCallback)((category)=>{
        const token = {};
        openModalToken.current = token;
        setModalScreen({
            state: "edit",
            title: category ? `Editar Categoria: ${category.name}` : "Criar Nova Categoria",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0440242d86d68f79$export$2e2bcd8739ae039), {
                category: category,
                onCategoryUpdate: (updatedCategory)=>handleCategoryUpdated(updatedCategory, token),
                setError: setError,
                setSuccess: setSuccess,
                categories: categories
            }, category?.id ?? "new"),
            onClose: closeModal
        });
    }, [
        categories,
        closeModal,
        handleCategoryUpdated,
        setError,
        setModalScreen,
        setSuccess
    ]);
    const editParam = searchParams.get("edit");
    const isNew = searchParams.get("new") === "1";
    (0, $acw62.useEffect)(()=>{
        if (!isAuthenticated() || !hasLoaded) return;
        // Normalise hand-crafted URLs before opening anything.
        if (isNew && editParam !== null) {
            const next = new URLSearchParams(searchParams);
            next.delete("edit");
            setSearchParams(next, {
                replace: true
            });
            return;
        }
        if (!isNew && editParam === "") {
            clearModalParams();
            return;
        }
        const desiredKey = isNew ? "new" : editParam ? `edit:${editParam}` : null;
        if (!desiredKey) {
            if (openModalKey.current) {
                openModalKey.current = null;
                openModalToken.current = null;
                setModalScreen(null);
            }
            return;
        }
        if (openModalKey.current === desiredKey) return;
        const failedLoad = !!loadError && categories.length === 0;
        if (failedLoad) return;
        if (isNew) {
            openModalKey.current = desiredKey;
            openManageModal();
            return;
        }
        const editId = Number(editParam);
        const validEditId = /^\d+$/.test(editParam ?? "") && Number.isSafeInteger(editId);
        if (!validEditId) {
            openModalKey.current = null;
            openModalToken.current = null;
            setError("Categoria n\xe3o encontrada");
            clearModalParams();
            return;
        }
        const found = $5e9e435a10d3c9d3$var$findCategoryById(categories, editId);
        if (!found) {
            openModalKey.current = null;
            openModalToken.current = null;
            setError("Categoria n\xe3o encontrada");
            clearModalParams();
            return;
        }
        openModalKey.current = desiredKey;
        openManageModal(found);
    }, [
        editParam,
        isNew,
        categories,
        hasLoaded,
        loadError,
        isAuthenticated,
        openManageModal,
        setModalScreen,
        setError,
        clearModalParams,
        searchParams,
        setSearchParams
    ]);
    const openCreateCategory = (0, $acw62.useCallback)(()=>{
        const next = new URLSearchParams(searchParams);
        next.delete("edit");
        next.set("new", "1");
        setSearchParams(next);
    }, [
        searchParams,
        setSearchParams
    ]);
    const openEditCategory = (0, $acw62.useCallback)((category)=>{
        if (category.id == null) return;
        const next = new URLSearchParams(searchParams);
        next.delete("new");
        next.set("edit", String(category.id));
        setSearchParams(next);
    }, [
        searchParams,
        setSearchParams
    ]);
    const retryLoad = (0, $acw62.useCallback)(()=>{
        if (categories.length === 0) setHasLoaded(false);
        setLoadError(null);
        fetchCategories();
    }, [
        categories.length,
        fetchCategories
    ]);
    if (!isAuthenticated()) return null;
    const showLoadError = hasLoaded && !!loadError && categories.length === 0;
    const showRefreshWarning = hasLoaded && !!loadError && categories.length > 0;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "container mx-auto p-6 max-w-7xl",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex flex-col gap-6",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex flex-col md:flex-row justify-between items-start md:items-center gap-4",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                    className: "text-3xl font-bold text-gray-900 tracking-tight",
                                    children: "Categorias"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "text-gray-500 mt-1",
                                    children: "Gerencie a estrutura de categorias da loja."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            type: "button",
                            onClick: openCreateCategory,
                            disabled: !hasLoaded || showLoadError,
                            className: "bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg font-medium transition disabled:opacity-50 disabled:cursor-not-allowed",
                            children: "+ Nova Categoria"
                        })
                    ]
                }),
                showRefreshWarning && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "bg-amber-50 border border-amber-200 text-amber-800 rounded-xl p-4 flex flex-col sm:flex-row sm:items-center justify-between gap-3",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "text-sm",
                            children: loadError
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            type: "button",
                            onClick: retryLoad,
                            className: "px-3 py-1.5 text-sm rounded-md border border-amber-300 bg-white hover:bg-amber-100 transition",
                            children: "Tentar novamente"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "overflow-auto",
                    children: !hasLoaded ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "bg-white rounded-xl shadow-sm border border-gray-200 p-12",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "text-center",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "mt-4 text-gray-600",
                                    children: "A carregar categorias..."
                                })
                            ]
                        })
                    }) : showLoadError ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "bg-white rounded-xl shadow-sm border border-gray-200 p-12 text-center",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "text-gray-700 font-medium",
                                children: "N\xe3o foi poss\xedvel carregar as categorias."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "text-sm text-gray-500 mt-2",
                                children: "Verifique a liga\xe7\xe3o e tente novamente."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                onClick: retryLoad,
                                className: "mt-4 px-4 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-700 transition",
                                children: "Tentar novamente"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d00652f0b71c3667$export$2e2bcd8739ae039), {
                        data: categories,
                        handleManageItem: openEditCategory,
                        handleDeleteItem: confirmDeleteCategory,
                        deletingIds: deletingIds
                    })
                })
            ]
        })
    });
};
var $5e9e435a10d3c9d3$export$2e2bcd8739ae039 = $5e9e435a10d3c9d3$var$CategoriesManagementPage;




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");






var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

// ── Component snapshot types (mirrored from OMS model.StorefrontSnapshot) ──────
function $d4c9f6e063c54583$var$asAddress(value) {
    if (!value || typeof value !== "object" || Array.isArray(value)) return undefined;
    const a = value;
    const str = (...keys)=>{
        for (const k of keys){
            const v = a[k];
            if (v == null) continue;
            const t = (typeof v === "string" ? v : String(v)).trim();
            if (t !== "") return t;
        }
        return undefined;
    };
    return {
        line1: str("line1"),
        line2: str("line2"),
        city: str("city"),
        postal_code: str("postal_code"),
        country: str("country")
    };
}
function $d4c9f6e063c54583$export$9a5a9828f9cb05b8(raw) {
    if (!raw || raw === "{}") return {};
    let data;
    try {
        data = typeof raw === "string" ? JSON.parse(raw) : raw;
    } catch  {
        return {};
    }
    if (!data || typeof data !== "object" || Array.isArray(data)) return {};
    const d = data;
    const billing = d.billing_address;
    const shipping = d.shipping_address;
    const str = (v)=>v != null && v !== "" ? String(v) : undefined;
    const phoneRaw = d.phone ?? d.phone_number ?? d.phoneNumber ?? billing?.phone ?? billing?.phone_number ?? shipping?.phone ?? shipping?.phone_number ?? d.contact_phone;
    const nifRaw = d.nif ?? d.vat_number ?? d.vatNumber ?? billing?.nif ?? billing?.vat_number;
    const first = typeof d.first_name === "string" ? d.first_name : undefined;
    const last = typeof d.last_name === "string" ? d.last_name : undefined;
    return {
        first_name: first,
        last_name: last,
        name: str(d.name ?? (first || last ? [
            first,
            last
        ].filter(Boolean).join(" ") : undefined)),
        email: str(d.email),
        phone: str(phoneRaw),
        nif: str(nifRaw),
        billing_address: $d4c9f6e063c54583$var$asAddress(billing),
        shipping_address: $d4c9f6e063c54583$var$asAddress(shipping)
    };
}


function $e98c8bf0e2cd41b0$export$cabcea02431fc6a8(raw) {
    if (!raw) return undefined;
    try {
        const v = JSON.parse(raw)?.order_id;
        return v == null || v === "" ? undefined : String(v);
    } catch  {
        return undefined;
    }
}
function $e98c8bf0e2cd41b0$export$41ef3ca59a237516(attempt, scope) {
    const metaOrder = $e98c8bf0e2cd41b0$export$cabcea02431fc6a8(attempt.metadata);
    if (metaOrder) return metaOrder === scope.orderId;
    return attempt.session_id === scope.orderId || !!scope.session && attempt.session_id === scope.session || attempt.id === scope.attemptId;
}




/**
 * Short customer-facing order reference — first 8 chars of the OMS order id,
 * uppercased (e.g. "02995a1a-81cb-4077-923d-fac586b4feff" → "02995A1A").
 *
 * Mirrors eurosys-site/src/lib/orders/orderRef.ts shortOrderRef. The customer
 * sees this exact string in the builder confirmation and WhatsApp messages, so
 * the intranet must render the same ref for staff to correlate.
 */ function $d4c0c44600ee9d94$export$7c020bda1e17fd0d(orderId) {
    if (!orderId) return "";
    return orderId.slice(0, 8).toUpperCase();
}



// ── Helpers ────────────────────────────────────────────────────────────────
function $da62e50cd6d5a3b2$var$formatCents(cents, currency) {
    return new Intl.NumberFormat("pt-PT", {
        style: "currency",
        currency: currency || "EUR"
    }).format(cents / 100);
}
function $da62e50cd6d5a3b2$var$formatDate(iso) {
    return new Date(iso).toLocaleString("pt-PT");
}
const $da62e50cd6d5a3b2$var$AddressBlock = ({ address: address })=>{
    const str = (v)=>typeof v === "string" && v.trim() !== "" ? v.trim() : undefined;
    const city = str(address?.city);
    const postal = str(address?.postal_code);
    const country = str(address?.country);
    const lines = [
        str(address?.line1),
        str(address?.line2)
    ];
    if (postal || city) lines.push([
        postal,
        city
    ].filter(Boolean).join(" "));
    if (country) lines.push(country);
    const visible = lines.filter((l)=>l !== undefined);
    if (visible.length === 0) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: "text-gray-400",
        children: "\u2014"
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("address", {
        className: "not-italic text-sm text-gray-600 leading-relaxed",
        children: visible.map((line, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: line
            }, idx))
    });
};
// ── Status maps ────────────────────────────────────────────────────────────
const $da62e50cd6d5a3b2$var$ORDER_STATUS_LABELS = {
    PENDING_OFFER: "Pendente Proposta",
    PAYMENT_PENDING: "Pagamento Pendente",
    PAID: "Pago",
    FULFILLMENT_INIT: "A Processar",
    PAID_PENDING_FULFILLMENT: "Pago \u2014 Fulfillment Pendente",
    COMPLETED: "Conclu\xeddo",
    REFUNDED: "Reembolsado",
    FAILED: "Falhado",
    CANCELLED: "Cancelado",
    OFFER_SENT: "Proposta Enviada"
};
const $da62e50cd6d5a3b2$var$ORDER_STATUS_COLORS = {
    PENDING_OFFER: "bg-yellow-100 text-yellow-800",
    PAYMENT_PENDING: "bg-orange-100 text-orange-800",
    PAID: "bg-blue-100 text-blue-800",
    FULFILLMENT_INIT: "bg-indigo-100 text-indigo-800",
    PAID_PENDING_FULFILLMENT: "bg-purple-100 text-purple-800",
    COMPLETED: "bg-green-100 text-green-800",
    REFUNDED: "bg-gray-200 text-gray-700",
    FAILED: "bg-red-100 text-red-800",
    CANCELLED: "bg-red-50 text-red-700",
    OFFER_SENT: "bg-cyan-100 text-cyan-800"
};
const $da62e50cd6d5a3b2$var$FULFILLMENT_STATUS_LABELS = {
    PENDING: "Pendente",
    CREATED: "Criado",
    ACCEPTED: "Aceite",
    CONFIRMED: "Confirmado",
    CANCELLED: "Cancelado",
    FAILED: "Falhado"
};
const $da62e50cd6d5a3b2$var$FULFILLMENT_STATUS_COLORS = {
    PENDING: "bg-gray-100 text-gray-700",
    CREATED: "bg-blue-100 text-blue-700",
    ACCEPTED: "bg-indigo-100 text-indigo-700",
    CONFIRMED: "bg-green-100 text-green-700",
    CANCELLED: "bg-yellow-100 text-yellow-800",
    FAILED: "bg-red-100 text-red-800"
};
const $da62e50cd6d5a3b2$var$PAYMENT_STATUS_LABELS = {
    pending: "Pendente",
    processing: "A processar",
    succeeded: "Pago",
    failed: "Falhado",
    cancelled: "Cancelado"
};
const $da62e50cd6d5a3b2$var$PAYMENT_STATUS_COLORS = {
    pending: "bg-yellow-100 text-yellow-800",
    processing: "bg-blue-100 text-blue-800",
    succeeded: "bg-green-100 text-green-800",
    failed: "bg-red-100 text-red-800",
    cancelled: "bg-gray-100 text-gray-700"
};
// ── Component snapshot helpers ───────────────────────────────────────────
/**
 * Parse the storefront_snapshot JSON field from an order item.
 * Returns null when absent or malformed.
 */ function $da62e50cd6d5a3b2$var$parseStorefrontSnapshot(item) {
    if (!item.storefront_snapshot) return null;
    try {
        const raw = JSON.parse(item.storefront_snapshot);
        // H-3: guard — if selected_components_snapshot is present but not an array
        // (e.g. legacy shape mismatch), drop it so we degrade to the ID fallback.
        if (raw.selected_components_snapshot !== undefined && !Array.isArray(raw.selected_components_snapshot)) raw.selected_components_snapshot = undefined;
        return raw;
    } catch  {
        return null;
    }
}
/**
 * Renders the component breakdown for a single fulfillment item.
 * Uses the rich storefront_snapshot when available (has names + prices);
 * falls back to the raw selected_components IDs map.
 * Returns null when the item has no component data.
 */ const $da62e50cd6d5a3b2$var$ItemComponentLines = ({ item: item, currency: currency })=>{
    const snap = $da62e50cd6d5a3b2$var$parseStorefrontSnapshot(item);
    if (snap?.selected_components_snapshot?.length) // Rich snapshot — show type label, component name and price.
    return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
        className: "mt-1 space-y-0.5",
        "aria-label": "Componentes inclu\xeddos",
        children: snap.selected_components_snapshot.map((entry, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                className: "flex items-center justify-between min-w-0 text-xs text-gray-500 pl-2 border-l-2 border-gray-200",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "font-medium text-gray-600 mr-1 shrink-0",
                        children: [
                            entry.type_label || entry.type_key,
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "flex-1 truncate min-w-0",
                        title: entry.name,
                        children: entry.name
                    }),
                    typeof entry.unit_price_cents === "number" && entry.unit_price_cents > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "ml-2 text-gray-400 whitespace-nowrap shrink-0",
                        children: $da62e50cd6d5a3b2$var$formatCents(entry.unit_price_cents, currency)
                    })
                ]
            }, `${entry.type_key}-${idx}`))
    });
    // Fallback: parse selected_components IDs (no names available)
    let rawComponents = null;
    if (snap?.selected_components) rawComponents = snap.selected_components;
    else if (item.selected_components) try {
        rawComponents = JSON.parse(item.selected_components);
    } catch  {
        rawComponents = null;
    }
    if (!rawComponents || Object.keys(rawComponents).length === 0) {
        // Builder-quote checkout orders store no component data at checkout time.
        // Show a fallback badge so staff knows this is a custom build.
        if (item.compound_id === "generic_custom_build") return /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
            className: "text-xs text-gray-400 italic mt-1 pl-2 border-l-2 border-gray-200",
            children: "Or\xe7amento personalizado \u2014 componentes dispon\xedveis no detalhe do or\xe7amento"
        });
        return null;
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
        className: "mt-1 space-y-0.5",
        "aria-label": "Componentes (IDs)",
        children: Object.entries(rawComponents).map(([typeKey, componentId], idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                className: "flex items-center min-w-0 text-xs text-gray-400 pl-2 border-l-2 border-gray-200",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "font-medium text-gray-500 mr-1 shrink-0",
                        children: [
                            (0, $cd93687958c8007e$export$96c53945a697e37)(typeKey),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "truncate min-w-0 font-mono",
                        title: componentId,
                        children: componentId
                    })
                ]
            }, `${typeKey}-${idx}`))
    });
};
// ── StatusBadge ────────────────────────────────────────────────────────────
const $da62e50cd6d5a3b2$var$StatusBadge = ({ label: label, colorClass: colorClass })=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: `inline-block px-2 py-0.5 rounded text-xs font-semibold ${colorClass}`,
        children: label
    });
const $da62e50cd6d5a3b2$var$OmsOrderDetail = ({ order: initialOrder, onOrderUpdated: onOrderUpdated })=>{
    const [order, setOrder] = (0, $acw62.useState)(initialOrder);
    const [actionLoading, setActionLoading] = (0, $acw62.useState)(null);
    const [activeTab, setActiveTab] = (0, $acw62.useState)("order");
    const { setSuccess: setSuccess, setError: setError, setModalScreen: setModalScreen } = (0, $a55f2a94cd420149$export$c50e37a2f0a2b064)();
    const navigate = (0, $585f8bce88e531c1$export$9770f232ac06a008)();
    // ── Refresh order on mount (garantir dados frescos da API) ────────────
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        (0, $bac44633733ff026$export$2e2bcd8739ae039).get(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).OMS_ADMIN_ORDERS}/${initialOrder.id}`).then((res)=>{
            if (!cancelled) setOrder(res.data);
        }).catch(()=>{
        /* non-fatal — use initial prop as fallback */ });
        return ()=>{
            cancelled = true;
        };
    }, [
        initialOrder.id
    ]);
    // Payment tab state
    const [payments, setPayments] = (0, $acw62.useState)([]);
    const [paymentsLoading, setPaymentsLoading] = (0, $acw62.useState)(false);
    const [paymentsFetched, setPaymentsFetched] = (0, $acw62.useState)(false);
    // ── Fetch payments when tab opens ─────────────────────────────────────
    const fetchPayments = async ()=>{
        if (paymentsFetched) return;
        setPaymentsLoading(true);
        try {
            // A API de listagem é tenant-wide (ignora session_id) — o escopo à
            // ordem é feito no cliente em isAttemptForOrder.
            const params = new URLSearchParams();
            params.set("page_size", "50");
            const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).PAYMENT_ATTEMPTS}?${params}`);
            const scoped = (res.data.data || []).filter((p)=>(0, $e98c8bf0e2cd41b0$export$41ef3ca59a237516)(p, {
                    orderId: order.id,
                    session: order.checkout_session_id || undefined,
                    attemptId: order.payment_attempt_id || undefined
                }));
            setPayments(scoped);
            setPaymentsFetched(true);
        } catch (e) {
            setError(e?.response?.data?.error || "Erro ao carregar pagamentos.");
        } finally{
            setPaymentsLoading(false);
        }
    };
    const handleTabChange = (tab)=>{
        setActiveTab(tab);
        if (tab === "payment") fetchPayments();
    };
    // ── Actions ───────────────────────────────────────────────────────────
    const handleCancelItem = async (item)=>{
        setActionLoading(`cancel-${item.id}`);
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).delete(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).OMS_ADMIN_ORDERS}/${order.id}/items/${item.id}`);
            const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).OMS_ADMIN_ORDERS}/${order.id}`);
            setOrder(res.data);
            onOrderUpdated(res.data);
            setSuccess(`Item "${item.display_name}" cancelado com sucesso.`);
        } catch (e) {
            setError(e?.response?.data?.error || "Erro ao cancelar item.");
        } finally{
            setActionLoading(null);
        }
    };
    const handleRetryItem = async (item)=>{
        setActionLoading(`retry-${item.id}`);
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).post(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).OMS_ADMIN_ORDERS}/${order.id}/items/${item.id}/retry`);
            const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).OMS_ADMIN_ORDERS}/${order.id}`);
            setOrder(res.data);
            onOrderUpdated(res.data);
            setSuccess(`Item "${item.display_name}" reprocessado com sucesso.`);
        } catch (e) {
            setError(e?.response?.data?.error || "Erro ao reprocessar item.");
        } finally{
            setActionLoading(null);
        }
    };
    const handleConfirmPayment = async ()=>{
        setActionLoading("confirm-payment");
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).patch(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).OMS_ADMIN_ORDERS}/${order.id}/confirm-payment`);
            const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).OMS_ADMIN_ORDERS}/${order.id}`);
            setOrder(res.data);
            onOrderUpdated(res.data);
            setSuccess("Pagamento confirmado manualmente.");
        } catch (e) {
            setError(e?.response?.data?.error || "Erro ao confirmar pagamento.");
        } finally{
            setActionLoading(null);
        }
    };
    // ── Derived ───────────────────────────────────────────────────────────
    const orderStatusColor = $da62e50cd6d5a3b2$var$ORDER_STATUS_COLORS[order.status] || "bg-gray-100 text-gray-700";
    const orderStatusLabel = $da62e50cd6d5a3b2$var$ORDER_STATUS_LABELS[order.status] || order.status;
    const aggStatusColor = $da62e50cd6d5a3b2$var$FULFILLMENT_STATUS_COLORS[order.aggregate_status] || "bg-gray-100 text-gray-700";
    const aggStatusLabel = $da62e50cd6d5a3b2$var$FULFILLMENT_STATUS_LABELS[order.aggregate_status] || order.aggregate_status;
    const customerBlob = (0, $acw62.useMemo)(()=>(0, $d4c9f6e063c54583$export$9a5a9828f9cb05b8)(order.customer_data), [
        order.customer_data
    ]);
    const shippingAddress = customerBlob.shipping_address;
    // Referência Niposom/IAPC: em builder-quote orders a offer pré-aprovada vive
    // ao nível da encomenda; em checkout orders o fan-out cria uma offer por item
    // niposom (usamos a 1ª). provider_type vazio/nulo = fan-out niposom legado
    // (dual-write do OMS não preenche o campo em ordens antigas) — ainda é ref
    // de offer válida. Refs de providers webhook não linkam /offers.
    const niposomOfferRef = order.niposom_offer_id ?? order.items?.find((it)=>{
        const isLegacyNiposom = it.provider_type === "niposom" || it.provider_type == null || it.provider_type === "";
        return isLegacyNiposom && it.provider_reference;
    })?.provider_reference;
    // ── IAPC order deep-link ──────────────────────────────────────────────
    const handleOpenIapcOrder = async ()=>{
        if (actionLoading) return;
        // modalScreen é app-level (Layout), acima das rotas: fechar SEMPRE antes de
        // navegar, senão o modal opaco sobrevive à troca de rota e o onClose ainda
        // faz pushState de volta para a listagem (URL desincronizado do conteúdo).
        const go = (path)=>{
            setModalScreen(null);
            navigate(path, {
                replace: true
            });
        };
        if (!niposomOfferRef) {
            go("/orders");
            return;
        }
        setActionLoading("open-iap-order");
        try {
            // Resolve a order IAPC cuja offer (fan-out Niposom) é esta ref e abre o
            // detalhe /orders/:id. Sem ordem (ex.: antes do accept) a API responde
            // 404 — mantemos a página e informamos o staff.
            const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).ORDERS}/by-offer/${niposomOfferRef}`);
            const orderId = res.data?.id;
            if (orderId) go(`/orders/${orderId}`);
            else setError("Ordem IAPC n\xe3o encontrada para esta proposta.");
        } catch (e) {
            if (e?.response?.status === 404) setError("Ainda n\xe3o existe ordem IAPC \u2014 \xe9 criada automaticamente quando a proposta \xe9 aceite, ap\xf3s o pagamento ser confirmado.");
            else setError(e?.response?.data?.error || "Erro ao procurar ordem IAPC.");
        } finally{
            setActionLoading(null);
        }
    };
    // ── Render ────────────────────────────────────────────────────────────
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex flex-col h-full",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex border-b border-gray-200 px-4 pt-2 shrink-0",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: `px-5 py-2 text-sm font-medium border-b-2 transition-colors ${activeTab === "order" ? "border-blue-600 text-blue-700" : "border-transparent text-gray-500 hover:text-gray-700"}`,
                        onClick: ()=>handleTabChange("order"),
                        children: "Encomenda"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: `px-5 py-2 text-sm font-medium border-b-2 transition-colors ${activeTab === "payment" ? "border-blue-600 text-blue-700" : "border-transparent text-gray-500 hover:text-gray-700"}`,
                        onClick: ()=>handleTabChange("payment"),
                        children: "Pagamento"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex-1 overflow-y-auto p-4",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: activeTab === "order" ? "" : "hidden",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex flex-col gap-6",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "bg-gray-50 rounded-lg p-4 flex flex-col gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex items-center gap-3 flex-wrap",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "font-mono text-xs text-gray-400",
                                                    children: order.id
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)($da62e50cd6d5a3b2$var$StatusBadge, {
                                                    label: orderStatusLabel,
                                                    colorClass: orderStatusColor
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)($da62e50cd6d5a3b2$var$StatusBadge, {
                                                    label: `Fulfillment: ${aggStatusLabel}`,
                                                    colorClass: aggStatusColor
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "grid grid-cols-2 gap-x-6 gap-y-1 text-sm mt-2",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "text-gray-500",
                                                            children: "Ref.:"
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "font-mono font-medium",
                                                            children: (0, $d4c0c44600ee9d94$export$7c020bda1e17fd0d)(order.id)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "text-gray-500",
                                                            children: "M\xe9todo de pagamento:"
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: order.payment_method || "\u2014"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "text-gray-500",
                                                            children: "M\xe9todo de envio:"
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: order.delivery_method?.label || "\u2014"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "text-gray-500",
                                                            children: "Cliente:"
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "font-medium",
                                                            children: order.customer_name
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "text-gray-500",
                                                            children: "Email:"
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "font-medium",
                                                            children: order.customer_email
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "text-gray-500",
                                                            children: "Subtotal:"
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: $da62e50cd6d5a3b2$var$formatCents(order.subtotal_cents, order.currency)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "text-gray-500",
                                                            children: "Envio:"
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: $da62e50cd6d5a3b2$var$formatCents(order.shipping_cents, order.currency)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "text-gray-500",
                                                            children: "Total:"
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "font-bold text-gray-800",
                                                            children: $da62e50cd6d5a3b2$var$formatCents(order.total_cents, order.currency)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "text-gray-500",
                                                            children: "Criado:"
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: $da62e50cd6d5a3b2$var$formatDate(order.created_at)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "text-gray-500",
                                                            children: "Atualizado:"
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: $da62e50cd6d5a3b2$var$formatDate(order.updated_at)
                                                        })
                                                    ]
                                                }),
                                                order.notes && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "col-span-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "text-gray-500",
                                                            children: "Notas:"
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: order.notes
                                                        })
                                                    ]
                                                }),
                                                order.failure_reason && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "col-span-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "text-red-500",
                                                            children: "Motivo de falha:"
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "text-red-700",
                                                            children: order.failure_reason
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                shippingAddress?.line1 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "bg-gray-50 rounded-lg p-3",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                            className: "text-xs font-semibold text-gray-500 uppercase mb-1",
                                            children: "Morada de Envio"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($da62e50cd6d5a3b2$var$AddressBlock, {
                                            address: shippingAddress
                                        })
                                    ]
                                }),
                                order.selected_poi && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "bg-gray-50 rounded-lg p-3",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                            className: "text-xs font-semibold text-gray-500 uppercase mb-1",
                                            children: "Ponto de Levantamento"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "text-sm font-medium text-gray-700 mb-1",
                                            children: order.selected_poi.label
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($da62e50cd6d5a3b2$var$AddressBlock, {
                                            address: {
                                                line1: order.selected_poi.line1,
                                                line2: order.selected_poi.line2,
                                                city: order.selected_poi.city,
                                                postal_code: order.selected_poi.postal_code,
                                                country: order.selected_poi.country
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex flex-wrap items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "text-sm text-gray-500",
                                            children: "IAPC:"
                                        }),
                                        niposomOfferRef && /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                            className: "button is-small is-outlined",
                                            href: `/offers/${niposomOfferRef}`,
                                            title: `Proposta IAPC ${niposomOfferRef}`,
                                            children: "Ver proposta"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            className: "button is-small is-outlined",
                                            onClick: handleOpenIapcOrder,
                                            disabled: !!actionLoading,
                                            title: "Abrir a ordem correspondente no IAPC",
                                            children: actionLoading === "open-iap-order" ? "A abrir\u2026" : "Ver ordem IAPC"
                                        })
                                    ]
                                }),
                                order.status === "PAYMENT_PENDING" && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        className: "button is-success is-small",
                                        disabled: actionLoading === "confirm-payment",
                                        onClick: handleConfirmPayment,
                                        children: actionLoading === "confirm-payment" ? "A confirmar..." : "Confirmar Pagamento Manualmente"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                            className: "text-sm font-semibold text-gray-700 mb-2",
                                            children: [
                                                "Itens da Encomenda (",
                                                order.items?.length ?? 0,
                                                ")"
                                            ]
                                        }),
                                        !order.items || order.items.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "text-sm text-gray-400 italic",
                                            children: "Sem itens."
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "overflow-x-auto",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                                                className: "w-full text-sm border-collapse",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                            className: "bg-gray-100 text-left text-xs text-gray-600 uppercase",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                    className: "px-3 py-2",
                                                                    children: "Artigo"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                    className: "px-3 py-2",
                                                                    children: "Pre\xe7o Unit."
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                    className: "px-3 py-2",
                                                                    children: "Estado"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                    className: "px-3 py-2",
                                                                    children: "Provider"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                    className: "px-3 py-2",
                                                                    children: "A\xe7\xf5es"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                                        children: order.items.map((item)=>{
                                                            const fsColor = $da62e50cd6d5a3b2$var$FULFILLMENT_STATUS_COLORS[item.fulfillment_status] || "bg-gray-100 text-gray-700";
                                                            const fsLabel = $da62e50cd6d5a3b2$var$FULFILLMENT_STATUS_LABELS[item.fulfillment_status] || item.fulfillment_status;
                                                            const canCancel = ![
                                                                "CANCELLED",
                                                                "CONFIRMED",
                                                                "FAILED"
                                                            ].includes(item.fulfillment_status);
                                                            const canRetry = item.fulfillment_status === "FAILED";
                                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                                className: "border-t border-gray-100 hover:bg-gray-50",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                                        className: "px-3 py-2 font-medium",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                children: item.display_name
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)($da62e50cd6d5a3b2$var$ItemComponentLines, {
                                                                                item: item,
                                                                                currency: order.currency
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                        className: "px-3 py-2",
                                                                        children: $da62e50cd6d5a3b2$var$formatCents(item.unit_price_cents, order.currency)
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                        className: "px-3 py-2",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($da62e50cd6d5a3b2$var$StatusBadge, {
                                                                            label: fsLabel,
                                                                            colorClass: fsColor
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                                        className: "px-3 py-2 text-xs text-gray-500",
                                                                        children: [
                                                                            item.provider_type || "\u2014",
                                                                            item.provider_reference ? ` \xb7 ${item.provider_reference}` : ""
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                                        className: "px-3 py-2 flex gap-2",
                                                                        children: [
                                                                            canCancel && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                className: "button is-danger is-small is-outlined",
                                                                                disabled: actionLoading === `cancel-${item.id}`,
                                                                                onClick: ()=>handleCancelItem(item),
                                                                                children: actionLoading === `cancel-${item.id}` ? "..." : "Cancelar"
                                                                            }),
                                                                            canRetry && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                className: "button is-warning is-small is-outlined",
                                                                                disabled: actionLoading === `retry-${item.id}`,
                                                                                onClick: ()=>handleRetryItem(item),
                                                                                children: actionLoading === `retry-${item.id}` ? "..." : "Retry"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }, item.id);
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: activeTab === "payment" ? "" : "hidden",
                        children: paymentsLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "text-gray-400 py-8 text-center",
                            children: "A carregar pagamentos..."
                        }) : payments.length === 0 && paymentsFetched ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "text-gray-400 py-8 text-center italic",
                            children: "Sem registos de pagamento para esta encomenda."
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "flex flex-col gap-4",
                            children: payments.map((attempt)=>{
                                const statusLabel = $da62e50cd6d5a3b2$var$PAYMENT_STATUS_LABELS[attempt.status] || attempt.status;
                                const statusColor = $da62e50cd6d5a3b2$var$PAYMENT_STATUS_COLORS[attempt.status] || "bg-gray-100 text-gray-700";
                                let parsedMeta = null;
                                try {
                                    if (attempt.metadata) parsedMeta = JSON.parse(attempt.metadata);
                                } catch  {
                                // ignore
                                }
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "bg-gray-50 rounded-lg p-4 border border-gray-100",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex items-center gap-3 mb-3 flex-wrap",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "font-mono text-xs text-gray-400",
                                                    children: attempt.id
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)($da62e50cd6d5a3b2$var$StatusBadge, {
                                                    label: statusLabel,
                                                    colorClass: statusColor
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "grid grid-cols-2 gap-x-6 gap-y-1 text-sm",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "text-gray-500",
                                                            children: "Montante:"
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "font-bold text-gray-800",
                                                            children: $da62e50cd6d5a3b2$var$formatCents(attempt.amount, attempt.currency)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "text-gray-500",
                                                            children: "Moeda:"
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: attempt.currency
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "text-gray-500",
                                                            children: "Ref. Provider:"
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "font-mono text-xs",
                                                            children: attempt.provider_ref || "\u2014"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "text-gray-500",
                                                            children: "Idempotency Key:"
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "font-mono text-xs break-all",
                                                            children: attempt.idempotency_key
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "text-gray-500",
                                                            children: "Criado:"
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: $da62e50cd6d5a3b2$var$formatDate(attempt.created_at)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "text-gray-500",
                                                            children: "Atualizado:"
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: $da62e50cd6d5a3b2$var$formatDate(attempt.updated_at)
                                                        })
                                                    ]
                                                }),
                                                attempt.failure_reason && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "col-span-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "text-red-500",
                                                            children: "Motivo de falha:"
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "text-red-700",
                                                            children: attempt.failure_reason
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        parsedMeta && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "mt-3",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                    className: "text-xs font-semibold text-gray-500 uppercase mb-1",
                                                    children: "Metadata"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("pre", {
                                                    className: "bg-white rounded border border-gray-100 p-3 text-xs overflow-x-auto text-gray-700",
                                                    children: JSON.stringify(parsedMeta, null, 2)
                                                })
                                            ]
                                        })
                                    ]
                                }, attempt.id);
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $da62e50cd6d5a3b2$export$2e2bcd8739ae039 = $da62e50cd6d5a3b2$var$OmsOrderDetail;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $juRJQ = parcelRequire("juRJQ");

const $ace7dc2d2f36ba5a$var$ORDER_STATUS_LABELS = {
    PENDING_OFFER: "Pendente Proposta",
    PAYMENT_PENDING: "Pag. Pendente",
    PAID: "Pago",
    FULFILLMENT_INIT: "A Processar",
    PAID_PENDING_FULFILLMENT: "Pago \u2014 Ful. Pendente",
    COMPLETED: "Conclu\xeddo",
    REFUNDED: "Reembolsado",
    FAILED: "Falhado",
    CANCELLED: "Cancelado",
    OFFER_SENT: "Proposta Enviada"
};
const $ace7dc2d2f36ba5a$var$ORDER_STATUS_COLORS = {
    PENDING_OFFER: "bg-yellow-100 text-yellow-800",
    PAYMENT_PENDING: "bg-orange-100 text-orange-800",
    PAID: "bg-blue-100 text-blue-800",
    FULFILLMENT_INIT: "bg-indigo-100 text-indigo-800",
    PAID_PENDING_FULFILLMENT: "bg-purple-100 text-purple-800",
    COMPLETED: "bg-green-100 text-green-800",
    REFUNDED: "bg-gray-200 text-gray-700",
    FAILED: "bg-red-100 text-red-800",
    CANCELLED: "bg-red-50 text-red-700",
    OFFER_SENT: "bg-cyan-100 text-cyan-800"
};
const $ace7dc2d2f36ba5a$var$FULFILLMENT_STATUS_LABELS = {
    PENDING: "Pendente",
    CREATED: "Criado",
    ACCEPTED: "Aceite",
    CONFIRMED: "Confirmado",
    CANCELLED: "Cancelado",
    FAILED: "Falhado"
};
const $ace7dc2d2f36ba5a$var$FULFILLMENT_STATUS_COLORS = {
    PENDING: "bg-gray-100 text-gray-700",
    CREATED: "bg-blue-100 text-blue-700",
    ACCEPTED: "bg-indigo-100 text-indigo-700",
    CONFIRMED: "bg-green-100 text-green-700",
    CANCELLED: "bg-yellow-100 text-yellow-800",
    FAILED: "bg-red-100 text-red-800"
};
function $ace7dc2d2f36ba5a$var$formatCents(cents, currency) {
    return new Intl.NumberFormat("pt-PT", {
        style: "currency",
        currency: currency || "EUR"
    }).format(cents / 100);
}
const $ace7dc2d2f36ba5a$var$StatusBadge = ({ label: label, colorClass: colorClass })=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: `inline-block px-2 py-0.5 rounded text-xs font-semibold ${colorClass}`,
        children: label
    });
const $ace7dc2d2f36ba5a$var$ListOmsOrderItems = ({ orders: orders, page: page, perPage: perPage, setPerPage: setPerPage, totalPages: totalPages, sortBy: sortBy, setSortBy: setSortBy, sortOrder: sortOrder, setSortOrder: setSortOrder, handlePageChange: handlePageChange, openOrderDetail: openOrderDetail, totalResults: totalResults, loading: loading })=>{
    const [showListedFields, setShowListedFields] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>{
        const session = sessionStorage.getItem("oms_orders_listed_fields");
        if (session) return new Map(JSON.parse(session));
        return new Map([
            [
                "id",
                true
            ],
            [
                "customer_name",
                true
            ],
            [
                "customer_email",
                true
            ],
            [
                "payment_method",
                true
            ],
            [
                "total_cents",
                true
            ],
            [
                "status",
                true
            ],
            [
                "aggregate_status",
                true
            ],
            [
                "idempotency_key",
                true
            ],
            [
                "created_at",
                true
            ],
            [
                "updated_at",
                false
            ]
        ]);
    });
    // Save showListedFields to sessionStorage when it changes
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        sessionStorage.setItem("oms_orders_listed_fields", JSON.stringify(Array.from(showListedFields.entries())));
    }, [
        showListedFields
    ]);
    const columns = [
        {
            field: "id",
            headerName: "Ref.",
            width: 130,
            sortable: true,
            valueGetter: (_value, row)=>(0, $d4c0c44600ee9d94$export$7c020bda1e17fd0d)(row.id),
            renderCell: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "font-mono text-xs text-gray-500",
                    children: params.value
                })
        },
        {
            field: "idempotency_key",
            headerName: "Chave idempot.",
            width: 120,
            sortable: true,
            valueGetter: (_value, row)=>row.idempotency_key || "\u2014",
            renderCell: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "font-mono text-xs",
                    children: params.value
                })
        },
        {
            field: "customer_name",
            headerName: "Cliente",
            width: 180,
            sortable: true,
            valueGetter: (_value, row)=>row.customer_name || "\u2014"
        },
        {
            field: "customer_email",
            headerName: "Email",
            width: 200,
            sortable: true,
            valueGetter: (_value, row)=>row.customer_email || "\u2014"
        },
        {
            field: "payment_method",
            headerName: "Pagamento",
            width: 120,
            sortable: true,
            valueGetter: (_value, row)=>row.payment_method || "\u2014"
        },
        {
            field: "total_cents",
            headerName: "Total",
            width: 110,
            sortable: true,
            type: "number",
            valueGetter: (_value, row)=>$ace7dc2d2f36ba5a$var$formatCents(row.total_cents ?? 0, row.currency)
        },
        {
            field: "status",
            headerName: "Estado",
            width: 140,
            sortable: true,
            renderCell: (params)=>{
                const status = params.row.status;
                return /*#__PURE__*/ (0, $ayMG0.jsx)($ace7dc2d2f36ba5a$var$StatusBadge, {
                    label: $ace7dc2d2f36ba5a$var$ORDER_STATUS_LABELS[status] || status,
                    colorClass: $ace7dc2d2f36ba5a$var$ORDER_STATUS_COLORS[status] || "bg-gray-100 text-gray-700"
                });
            }
        },
        {
            field: "aggregate_status",
            headerName: "Fulfillment",
            width: 130,
            sortable: true,
            renderCell: (params)=>{
                const status = params.row.aggregate_status;
                return /*#__PURE__*/ (0, $ayMG0.jsx)($ace7dc2d2f36ba5a$var$StatusBadge, {
                    label: $ace7dc2d2f36ba5a$var$FULFILLMENT_STATUS_LABELS[status] || status,
                    colorClass: $ace7dc2d2f36ba5a$var$FULFILLMENT_STATUS_COLORS[status] || "bg-gray-100 text-gray-700"
                });
            }
        },
        {
            field: "created_at",
            headerName: "Criada em",
            width: 140,
            sortable: true,
            valueGetter: (_value, row)=>row?.created_at ? new Date(row.created_at).toLocaleString("pt-PT", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit"
                }) : ""
        },
        {
            field: "updated_at",
            headerName: "Alterada em",
            width: 140,
            sortable: true,
            valueGetter: (_value, row)=>row?.updated_at ? new Date(row.updated_at).toLocaleString("pt-PT", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit"
                }) : ""
        }
    ];
    const paginationState = {
        paginationMode: "server",
        paginationModel: {
            page: page - 1,
            pageSize: perPage || 20
        },
        rowCount: totalResults || -1,
        enabled: true,
        meta: {
            hasNextPage: true
        }
    };
    const handlePaginationChange = (model)=>{
        if (model.pageSize !== perPage && setPerPage) setPerPage(model.pageSize);
        if (model.page + 1 !== page) handlePageChange(model.page + 1);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($juRJQ))), {
        sx: {
            width: "100%"
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $808944a671b11c1c$exports.DataGrid), {
            rows: orders,
            columns: columns,
            loading: loading,
            density: "standard",
            initialState: {
                pagination: paginationState
            },
            rowCount: totalResults || 0,
            paginationMode: "server",
            sortingMode: "server",
            disableColumnFilter: true,
            onPaginationModelChange: handlePaginationChange,
            onSortModelChange: (model)=>{
                if (model.length > 0) {
                    const sortModel = model[0];
                    setSortBy(sortModel.field);
                    setSortOrder(sortModel.sort || "asc");
                }
            },
            onRowClick: (params)=>openOrderDetail(params.row),
            columnVisibilityModel: Object.fromEntries(showListedFields),
            onColumnVisibilityModelChange: (newModel)=>{
                const newMap = new Map(Object.entries(newModel));
                setShowListedFields(newMap);
            },
            hideFooterSelectedRowCount: true,
            pageSizeOptions: [
                10,
                20,
                50,
                100
            ],
            localeText: {
                columnsManagementSearchTitle: "Procurar",
                columnsManagementNoColumns: "Sem colunas",
                columnsManagementShowHideAllText: "Mostrar/Ocultar Todas",
                columnsManagementReset: "Repor",
                columnsManagementDeleteIconLabel: "Limpar",
                columnMenuLabel: "Menu",
                columnMenuAriaLabel: (columnName)=>`Menu da coluna ${columnName}`,
                columnMenuShowColumns: "Mostrar colunas",
                columnMenuManageColumns: "Gerir colunas",
                columnMenuFilter: "Filtrar",
                columnMenuHideColumn: "Ocultar coluna",
                columnMenuUnsort: "Remover ordena\xe7\xe3o",
                columnMenuSortAsc: "Ordenar por ASC",
                columnMenuSortDesc: "Ordenar por DESC",
                columnMenuManagePivot: "Gerir pivot",
                paginationRowsPerPage: "Linhas por p\xe1gina:",
                paginationDisplayedRows: ({ from: from, to: to, count: count, estimated: estimated })=>{
                    if (!estimated) return `${from}\u{2013}${to} de ${count !== -1 ? count : `mais de ${to}`}`;
                    const estimatedLabel = estimated && estimated > to ? `cerca de ${estimated}` : `mais de ${to}`;
                    return `${from}\u{2013}${to} de ${count !== -1 ? count : estimatedLabel}`;
                },
                noRowsLabel: "Sem encomendas",
                noResultsOverlayLabel: "Sem resultados",
                footerRowSelected: (count)=>`${count} linha(s) selecionada(s)`
            },
            getCellClassName: (params)=>{
                const fieldClasses = {
                    id: "font-mono text-xs text-gray-500",
                    idempotency_key: "font-mono text-xs",
                    total_cents: "font-mono text-xs force-text-right",
                    created_at: "text-xs text-gray-600",
                    updated_at: "text-xs text-gray-600"
                };
                return params.row ? fieldClasses[params.field] || "" : "";
            },
            sx: {
                border: 0
            }
        })
    });
};
var $ace7dc2d2f36ba5a$export$2e2bcd8739ae039 = $ace7dc2d2f36ba5a$var$ListOmsOrderItems;




var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $d9e71da29c945043$var$DEFAULT_LABEL_CLASS = "block text-sm font-medium text-gray-700 mb-2";
const $d9e71da29c945043$var$DEFAULT_SELECT_CLASS = "block w-full px-3 py-2.5 border border-gray-300 rounded-lg bg-gray-50 text-gray-900 focus:outline-none focus:bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm transition-all duration-200";
/**
 * ADR-021 tenant picker (backoffice standard, Tailwind).
 *
 * Renders nothing when the operator has a single grant — there is nothing to
 * choose. Pair with useTenantSelection(); on change, refetch the page's
 * tenant-scoped data.
 */ const $d9e71da29c945043$var$TenantSelector = ({ tenants: tenants, value: value, onChange: onChange, className: className, labelClassName: labelClassName = $d9e71da29c945043$var$DEFAULT_LABEL_CLASS, selectClassName: selectClassName = $d9e71da29c945043$var$DEFAULT_SELECT_CLASS, id: id = "tenant-selector" })=>{
    if (tenants.length <= 1) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                htmlFor: id,
                className: labelClassName,
                children: "Tenant"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                id: id,
                className: selectClassName,
                value: value,
                onChange: (e)=>onChange(e.target.value),
                children: tenants.map((t)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                        value: t.id,
                        children: t.name || t.id
                    }, t.id))
            })
        ]
    });
};
var $d9e71da29c945043$export$2e2bcd8739ae039 = $d9e71da29c945043$var$TenantSelector;



var $acw62 = parcelRequire("acw62");

/**
 * Multi-tenant backoffice selection (ADR-021).
 *
 * The selected tenant is persisted and forwarded as `X-Selected-Tenant-ID`
 * (see hooks/api.tsx). The api-gw validates it against the caller's
 * server-derived grant and returns 403 if not allowed — the client never
 * authorises itself, it only *expresses* a choice.
 */ const $fa4f678391511d86$var$STORAGE_KEY = "selectedTenantId";
function $fa4f678391511d86$export$1ecd0fcbd5c95df3() {
    return localStorage.getItem($fa4f678391511d86$var$STORAGE_KEY);
}
function $fa4f678391511d86$export$c7bbdec6c9fd62f3(tenantId) {
    if (tenantId) localStorage.setItem($fa4f678391511d86$var$STORAGE_KEY, tenantId);
    else localStorage.removeItem($fa4f678391511d86$var$STORAGE_KEY);
}
async function $fa4f678391511d86$export$e5808fc6e30f4d36() {
    try {
        // The CDN routes /api/auth-mgmt/* to the api-gw (→ auth-ms /auth/me/tenants).
        // /api/auth/* on the niposom host goes to the niposom backend, so a distinct
        // prefix is required for auth-ms (see infra CDN nginx-config).
        const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get("/auth-mgmt/me/tenants");
        // Prefer the enriched projection (friendly names); fall back to bare IDs
        // for older auth-ms builds that only return tenantIds.
        if (res.data.tenants?.length) return res.data.tenants;
        return (res.data.tenantIds ?? []).map((id)=>({
                id: id,
                name: id
            }));
    } catch  {
        // Non-fatal: without the list we simply don't render a selector and keep
        // the single-tenant behaviour (the token's own tenant).
        return [];
    }
}


function $d3c233bd9ac99dda$export$d4c94cedb7152d21() {
    const [tenants, setTenants] = (0, $acw62.useState)([]);
    const [selectedTenant, setSelectedTenantState] = (0, $acw62.useState)(()=>(0, $fa4f678391511d86$export$1ecd0fcbd5c95df3)() ?? "");
    (0, $acw62.useEffect)(()=>{
        let active = true;
        (0, $fa4f678391511d86$export$e5808fc6e30f4d36)().then((list)=>{
            if (!active) return;
            setTenants(list);
            if (!(0, $fa4f678391511d86$export$1ecd0fcbd5c95df3)() && list.length > 0) {
                (0, $fa4f678391511d86$export$c7bbdec6c9fd62f3)(list[0].id);
                setSelectedTenantState(list[0].id);
            }
        });
        return ()=>{
            active = false;
        };
    }, []);
    const selectTenant = (0, $acw62.useCallback)((tenantId)=>{
        (0, $fa4f678391511d86$export$c7bbdec6c9fd62f3)(tenantId);
        setSelectedTenantState(tenantId);
    }, []);
    return {
        tenants: tenants,
        selectedTenant: selectedTenant,
        selectTenant: selectTenant
    };
}
var $d3c233bd9ac99dda$export$2e2bcd8739ae039 = $d3c233bd9ac99dda$export$d4c94cedb7152d21;


const $b3abea07440ed551$var$ORDER_STATUS_LABELS = {
    PENDING_OFFER: "Pendente Proposta",
    PAYMENT_PENDING: "Pag. Pendente",
    PAID: "Pago",
    FULFILLMENT_INIT: "A Processar",
    PAID_PENDING_FULFILLMENT: "Pago \u2014 Ful. Pendente",
    COMPLETED: "Conclu\xeddo",
    REFUNDED: "Reembolsado",
    FAILED: "Falhado",
    CANCELLED: "Cancelado",
    OFFER_SENT: "Proposta Enviada"
};
const $b3abea07440ed551$var$FIELD_CLASS = "block w-full px-3 py-2.5 border border-gray-300 rounded-lg bg-gray-50 text-gray-900 focus:outline-none focus:bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm transition-all duration-200";
const $b3abea07440ed551$var$LABEL_CLASS = "block text-sm font-medium text-gray-700 mb-2";
const $b3abea07440ed551$var$PRIMARY_BUTTON_CLASS = "px-4 py-2.5 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors";
const $b3abea07440ed551$var$SECONDARY_BUTTON_CLASS = "px-4 py-2.5 bg-gray-100 text-gray-700 font-medium rounded-lg hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2 transition-colors";
// ── Helpers ────────────────────────────────────────────────────────────────
function $b3abea07440ed551$var$getInitialParam(key, fallback = "") {
    return new URLSearchParams(window.location.search).get(key) ?? fallback;
}
function $b3abea07440ed551$var$getInitialPage() {
    const p = parseInt($b3abea07440ed551$var$getInitialParam("page", "1"), 10);
    return isNaN(p) || p < 1 ? 1 : p;
}
// ── Page ───────────────────────────────────────────────────────────────────
const $b3abea07440ed551$var$OmsOrdersPage = ()=>{
    const { profile: profile, isAuthenticated: isAuthenticated } = (0, $b622ef53e38024e7$export$1d39dc5b47e56ff0)();
    const { setModalScreen: setModalScreen, setError: setError } = (0, $a55f2a94cd420149$export$c50e37a2f0a2b064)();
    const navigate = (0, $585f8bce88e531c1$export$9770f232ac06a008)();
    const location = (0, $585f8bce88e531c1$export$45d76561a5302f2b)();
    const { orderId: orderId } = (0, $585f8bce88e531c1$export$99eaa27ddbbb95ef)();
    const authed = isAuthenticated();
    const [userProfile, setUserProfile] = (0, $acw62.useState)(null);
    const [profileLoading, setProfileLoading] = (0, $acw62.useState)(true);
    const [needsRelogin, setNeedsRelogin] = (0, $acw62.useState)(false);
    // List state
    const [orders, setOrders] = (0, $acw62.useState)([]);
    const [ordersTotal, setOrdersTotal] = (0, $acw62.useState)(0);
    const [ordersPage, setOrdersPage] = (0, $acw62.useState)($b3abea07440ed551$var$getInitialPage);
    const [ordersTotalPages, setOrdersTotalPages] = (0, $acw62.useState)(1);
    const [ordersLoading, setOrdersLoading] = (0, $acw62.useState)(false);
    const [perPage, setPerPage] = (0, $acw62.useState)(20);
    // Sort state
    const [sortBy, setSortBy] = (0, $acw62.useState)("created_at");
    const [sortOrder, setSortOrder] = (0, $acw62.useState)("desc");
    // Filter state — initialised from URL
    const [search, setSearch] = (0, $acw62.useState)(()=>$b3abea07440ed551$var$getInitialParam("search"));
    const [statusFilter, setStatusFilter] = (0, $acw62.useState)(()=>{
        const raw = $b3abea07440ed551$var$getInitialParam("status");
        // Guard against hand-edited ?status=FOO (select with no matching option
        // would render blank + send the bogus value to the API).
        return raw in $b3abea07440ed551$var$ORDER_STATUS_LABELS ? raw : "";
    });
    const [dateFrom, setDateFrom] = (0, $acw62.useState)(()=>$b3abea07440ed551$var$getInitialParam("from"));
    const [dateTo, setDateTo] = (0, $acw62.useState)(()=>$b3abea07440ed551$var$getInitialParam("to"));
    // ── Multi-tenant selection (ADR-021) ─────────────────────────────────────
    const { tenants: manageableTenants, selectedTenant: selectedTenant, selectTenant: selectTenant } = (0, $d3c233bd9ac99dda$export$d4c94cedb7152d21)();
    // ── Profile ──────────────────────────────────────────────────────────────
    (0, $acw62.useEffect)(()=>{
        profile().then((p)=>{
            setUserProfile(p);
            setProfileLoading(false);
        }).catch(()=>setProfileLoading(false));
    }, [
        profile
    ]);
    // ── Auth guard: preserve deep link across login ─────────────────────────
    (0, $acw62.useEffect)(()=>{
        if (!authed) // Same pattern as other pages (e.g. CategoriesManagementPage): LoginPage
        // reads location.state.from and navigates back after successful login.
        navigate("/login", {
            state: {
                from: location.pathname + location.search
            },
            replace: true
        });
    }, [
        authed,
        navigate,
        location.pathname,
        location.search
    ]);
    // ── URL sync ─────────────────────────────────────────────────────────────
    const buildQueryString = (0, $acw62.useCallback)((page, filters)=>{
        const s = filters?.search ?? search;
        const sf = filters?.statusFilter ?? statusFilter;
        const from = filters?.dateFrom ?? dateFrom;
        const to = filters?.dateTo ?? dateTo;
        const params = new URLSearchParams();
        params.set("page", String(page));
        if (s) params.set("search", s);
        if (sf) params.set("status", sf);
        if (from) params.set("from", from);
        if (to) params.set("to", to);
        return params.toString();
    }, [
        search,
        statusFilter,
        dateFrom,
        dateTo
    ]);
    // ── Fetch ─────────────────────────────────────────────────────────────────
    const fetchOrders = (0, $acw62.useCallback)(async (page, filters)=>{
        setOrdersLoading(true);
        try {
            const s = filters?.search ?? search;
            const sf = filters?.statusFilter ?? statusFilter;
            const from = filters?.dateFrom ?? dateFrom;
            const to = filters?.dateTo ?? dateTo;
            const params = new URLSearchParams();
            params.set("page", String(page));
            params.set("per_page", String(perPage));
            if (s) params.set("search", s);
            if (sf) params.set("status", sf);
            if (from) params.set("from", from);
            if (to) params.set("to", to);
            if (sortBy) params.set("sort_by", sortBy);
            if (sortOrder) params.set("sort_dir", sortOrder);
            const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).OMS_ADMIN_ORDERS}?${params}`);
            setOrders(res.data.orders || []);
            setOrdersTotal(res.data.total || 0);
            setOrdersTotalPages(res.data.total_pages || 1);
            setOrdersPage(page);
            history.replaceState(history.state, "", `/oms-orders?${buildQueryString(page, {
                search: s,
                statusFilter: sf,
                dateFrom: from,
                dateTo: to
            })}`);
        } catch (e) {
            if ([
                401,
                403
            ].includes(e?.response?.status)) setNeedsRelogin(true);
            else setError(e?.response?.data?.error || "Erro ao carregar encomendas.");
        } finally{
            setOrdersLoading(false);
        }
    }, [
        search,
        statusFilter,
        dateFrom,
        dateTo,
        sortBy,
        sortOrder,
        perPage,
        buildQueryString,
        setError
    ]);
    // Initial load and re-fetch when sort/perPage change
    (0, $acw62.useEffect)(()=>{
        if (!profileLoading && userProfile) fetchOrders(ordersPage);
    // intentionally omit ordersPage to avoid double-fetch on page change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        profileLoading,
        userProfile,
        sortBy,
        sortOrder,
        perPage
    ]);
    // ── Detail modal ─────────────────────────────────────────────────────────
    const openOrderDetail = (order)=>{
        const detailPath = `/oms-orders/${order.id}`;
        // When arriving via deep link the URL already is the detail path — don't
        // push a duplicate history entry (would make Back reopen the modal after
        // close). Only push when navigating from the list.
        if (window.location.pathname !== detailPath) history.pushState(history.state, "", detailPath);
        setModalScreen({
            title: `Encomenda ${(0, $d4c0c44600ee9d94$export$7c020bda1e17fd0d)(order.id)}`,
            state: "big-view",
            childrenControlOverflow: true,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da62e50cd6d5a3b2$export$2e2bcd8739ae039), {
                order: order,
                onOrderUpdated: (updated)=>{
                    setOrders((prev)=>prev.map((o)=>o.id === updated.id ? updated : o));
                }
            }),
            onClose: ()=>{
                // replaceState (not pushState): the detail entry is replaced by the
                // list URL so browser Back after closing doesn't reopen the modal.
                history.replaceState(history.state, "", `/oms-orders?${buildQueryString(ordersPage)}`);
                setModalScreen(null);
            }
        });
    };
    // ── Deep link: /oms-orders/:orderId opens the detail directly ────────────
    const deepLinkOpenedRef = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        if (!orderId || profileLoading || !userProfile) return;
        if (!userProfile.isAdmin() && !userProfile.isCommercial()) return;
        if (deepLinkOpenedRef.current) return;
        deepLinkOpenedRef.current = true;
        let cancelled = false;
        (0, $bac44633733ff026$export$2e2bcd8739ae039).get(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).OMS_ADMIN_ORDERS}/${orderId}`).then((res)=>{
            if (!cancelled) openOrderDetail(res.data);
        }).catch((e)=>{
            if (cancelled) return;
            // Unknown/invalid order — fall back to the list with an error banner.
            history.replaceState(history.state, "", `/oms-orders?${buildQueryString(1)}`);
            setError(e?.response?.status === 404 ? "Encomenda n\xe3o encontrada." : e?.response?.data?.error || "Erro ao abrir a encomenda.");
        });
        return ()=>{
            cancelled = true;
        };
    // openOrderDetail is recreated per render; the ref gate guarantees a
    // single run per orderId.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        orderId,
        profileLoading,
        userProfile
    ]);
    // ── Guards ────────────────────────────────────────────────────────────────
    if (!authed) return null;
    if (profileLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex items-center justify-center p-12 text-gray-500",
        children: "A carregar..."
    });
    if (!userProfile?.isAdmin() && !userProfile?.isCommercial()) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$444b3ab0cb9aec40), {
        to: "/",
        replace: true
    });
    if (needsRelogin) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "container mx-auto p-6 max-w-7xl",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "bg-white rounded-xl shadow-sm border border-gray-200 p-8 text-center",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "text-lg font-semibold text-gray-700 mb-2",
                    children: "Sess\xe3o desatualizada"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "text-gray-500 text-sm mb-4",
                    children: "A sua sess\xe3o foi emitida antes das permiss\xf5es de encomendas serem configuradas. Por favor, fa\xe7a logout e volte a entrar para continuar."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                    href: "/logout",
                    className: $b3abea07440ed551$var$PRIMARY_BUTTON_CLASS,
                    children: "Fazer logout"
                })
            ]
        })
    });
    // ── Render ────────────────────────────────────────────────────────────────
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "container mx-auto p-6 max-w-7xl",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex flex-col gap-6",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-3xl font-bold text-gray-900 tracking-tight",
                            children: "Gest\xe3o de Encomendas"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "text-gray-500 mt-1",
                            children: "Consulte e gira encomendas do canal online."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "bg-white rounded-xl shadow-sm border border-gray-200 p-4",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "grid grid-cols-1 md:grid-cols-3 gap-4",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9e71da29c945043$export$2e2bcd8739ae039), {
                                tenants: manageableTenants,
                                value: selectedTenant,
                                onChange: (t)=>{
                                    selectTenant(t);
                                    // The interceptor reads the selection from storage, so the
                                    // refetch is scoped to the newly selected tenant.
                                    fetchOrders(1);
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                        htmlFor: "oms-search",
                                        className: $b3abea07440ed551$var$LABEL_CLASS,
                                        children: "Pesquisar"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        id: "oms-search",
                                        type: "text",
                                        className: $b3abea07440ed551$var$FIELD_CLASS,
                                        placeholder: "Nome, email, ref\u2026",
                                        value: search,
                                        onChange: (e)=>setSearch(e.target.value),
                                        onKeyDown: (e)=>e.key === "Enter" && fetchOrders(1)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                        htmlFor: "oms-status",
                                        className: $b3abea07440ed551$var$LABEL_CLASS,
                                        children: "Estado"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                        id: "oms-status",
                                        className: $b3abea07440ed551$var$FIELD_CLASS,
                                        value: statusFilter,
                                        onChange: (e)=>setStatusFilter(e.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                value: "",
                                                children: "Todos os estados"
                                            }),
                                            Object.keys($b3abea07440ed551$var$ORDER_STATUS_LABELS).map((s)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: s,
                                                    children: $b3abea07440ed551$var$ORDER_STATUS_LABELS[s]
                                                }, s))
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                        htmlFor: "oms-from",
                                        className: $b3abea07440ed551$var$LABEL_CLASS,
                                        children: "De"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        id: "oms-from",
                                        type: "date",
                                        className: $b3abea07440ed551$var$FIELD_CLASS,
                                        value: dateFrom,
                                        onChange: (e)=>setDateFrom(e.target.value)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                        htmlFor: "oms-to",
                                        className: $b3abea07440ed551$var$LABEL_CLASS,
                                        children: "At\xe9"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        id: "oms-to",
                                        type: "date",
                                        className: $b3abea07440ed551$var$FIELD_CLASS,
                                        value: dateTo,
                                        onChange: (e)=>setDateTo(e.target.value)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-end gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        className: $b3abea07440ed551$var$PRIMARY_BUTTON_CLASS,
                                        onClick: ()=>fetchOrders(1),
                                        children: "Pesquisar"
                                    }),
                                    (search || statusFilter || dateFrom || dateTo) && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        className: $b3abea07440ed551$var$SECONDARY_BUTTON_CLASS,
                                        onClick: ()=>{
                                            setSearch("");
                                            setStatusFilter("");
                                            setDateFrom("");
                                            setDateTo("");
                                            // Fetch with explicit empty filters — the state closure would
                                            // refetch with the pre-clear values.
                                            fetchOrders(1, {
                                                search: "",
                                                statusFilter: "",
                                                dateFrom: "",
                                                dateTo: ""
                                            });
                                        },
                                        children: "Limpar filtros"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "overflow-auto",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ace7dc2d2f36ba5a$export$2e2bcd8739ae039), {
                        orders: orders,
                        page: ordersPage,
                        perPage: perPage,
                        setPerPage: (p)=>{
                            setPerPage(p);
                        },
                        sortBy: sortBy,
                        setSortBy: (f)=>{
                            setSortBy(f);
                        },
                        sortOrder: sortOrder,
                        setSortOrder: (o)=>{
                            setSortOrder(o);
                        },
                        totalPages: ordersTotalPages,
                        totalResults: ordersTotal,
                        loading: ordersLoading,
                        handlePageChange: (p)=>fetchOrders(p),
                        openOrderDetail: openOrderDetail
                    })
                })
            ]
        })
    });
};
var $b3abea07440ed551$export$2e2bcd8739ae039 = $b3abea07440ed551$var$OmsOrdersPage;


/**
 * OmsProposalsPage — dedicated view for builder_quote proposals (F-2.0 Phase 4+5).
 *
 * Filters:
 *  - source=builder_quote (fixed, always)
 *  - proposal_status (dropdown)
 *  - search, date range (inherited from base orders pattern)
 *
 * Role guard: isCommercial() || isAdmin() (same as OmsOrdersPage)
 * Clicking a row opens ProposalDetail modal (not OmsOrderDetail).
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");








// F-2.0 Proposal Management — TypeScript models
// Mirrors OMS model.ProposalRevision and Order proposal fields (ADR-013 D5-D7)
// F2-VR (Valor Referência): reference_type + rev3_cents snapshot (ADR-PVR Decisions 1-8)
const $92abc7e5184dde18$export$78db43792bea60f2 = {
    DRAFT: "Rascunho",
    DRAFT_SENT: "Enviada",
    ACCEPTED: "Aceite",
    DECLINED: "Recusada",
    CHANGE_REQUESTED: "Altera\xe7\xf5es Pedidas",
    EXPIRED: "Expirada",
    CANCELLED: "Cancelada"
};
const $92abc7e5184dde18$export$573ea6aa903cf99f = {
    DRAFT: "default",
    DRAFT_SENT: "primary",
    ACCEPTED: "success",
    DECLINED: "error",
    CHANGE_REQUESTED: "warning",
    EXPIRED: "default",
    CANCELLED: "error"
};
function $92abc7e5184dde18$export$d6c6eacc616f0fb6(items) {
    return items.reduce((acc, i)=>acc + i.pvp_cents * i.quantity, 0);
}
function $92abc7e5184dde18$export$5469c988647fcb7b(status) {
    return !status || status === "DRAFT" || status === "CHANGE_REQUESTED";
}
function $92abc7e5184dde18$export$4df5bd8ecb22f22b(status) {
    return status === "DRAFT";
}
function $92abc7e5184dde18$export$a7ebb9d34cd91279(status) {
    return status === "CHANGE_REQUESTED";
}
function $92abc7e5184dde18$export$fcd90031df3f450a(status) {
    return status === "DRAFT_SENT";
}
function $92abc7e5184dde18$export$23cdcb77113ad168(type) {
    return type ?? "COST";
}
function $92abc7e5184dde18$export$3926a790307af4f1(type) {
    return type === null || type === undefined;
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $6p5K7 = parcelRequire("6p5K7");

// Exact hex overrides matching WCAG 2.2 AA spec.
// #B91C1C (red-700, 5.08:1 on white) for declined/cancelled states.
// #166534 (green-800, ~5.1:1 on white) for accepted — one step darker than
// #15803D (green-700, 4.54:1) to provide margin above the 4.5:1 AA threshold.
const $002d06b4eb083fb3$var$STATUS_SX = {
    DECLINED: {
        bgcolor: "#B91C1C",
        color: "#fff"
    },
    CANCELLED: {
        bgcolor: "#B91C1C",
        color: "#fff"
    },
    ACCEPTED: {
        bgcolor: "#166534",
        color: "#fff"
    }
};
const $002d06b4eb083fb3$var$ProposalStatusChip = ({ status: status, size: size = "small" })=>{
    if (!status) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6p5K7))), {
        label: (0, $92abc7e5184dde18$export$78db43792bea60f2)[status] ?? status,
        color: (0, $92abc7e5184dde18$export$573ea6aa903cf99f)[status] ?? "default",
        size: size,
        sx: {
            fontWeight: 600,
            letterSpacing: "0.02em",
            ...$002d06b4eb083fb3$var$STATUS_SX[status]
        }
    });
};
var $002d06b4eb083fb3$export$2e2bcd8739ae039 = $002d06b4eb083fb3$var$ProposalStatusChip;


/**
 * ProposalDetail — modal content for a proposal order.
 *
 * State machine rendering (F-2.0 Plan Phase 5+7):
 * - No revision yet  → ProposalEditor (new, version=0)
 * - DRAFT            → ProposalEditor (edit) + ProposalActions (send) — actions always visible
 * - DRAFT_SENT       → ProposalRevisionView (read-only) + ProposalActions (accept/decline)
 * - CHANGE_REQUESTED → ProposalRevisionView + change-request justification banner + ProposalActions (revise)
 * - In revise mode   → ProposalEditor pre-filled from latest + POST /revise
 * - ACCEPTED/DECLINED/EXPIRED → ProposalRevisionView (read-only, no actions)
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");





/**
 * PR 6a — Phase 1.5 — API client boundary for proposal responses.
 *
 * Bridges wire-format payloads from the OMS Go backend (via api-gw) into the
 * frontend-canonical `ProposalResponse` discriminated union. The role
 * discriminator is JWT-derived from the authenticated `Profile`, not taken
 * from the wire payload.
 *
 * Defence-in-depth: `stripAdminFields` removes `cost_cents` / `margin_pct`
 * for comercial responses even when the backend leaks them. See oms#91
 * (`GetLatestRevision`) for the active leak this guards against.
 *
 * Wire role conventions:
 *   - OMS Go middleware emits "ADMIN" | "COMMERCIAL" via `X-User-Scopes`.
 *   - Spring services emit "ROLE_ADMIN" | "ROLE_COMMERCIAL".
 *   - Anything else (RESELLER, empty, unknown) is conservatively mapped to
 *     "comercial" — never escalate privilege from an unrecognised value.
 *
 * See ADR PR 6a, decision A1 and Convenções §3.
 */ function $632e0f20877ec90f$export$e7f68fe8caaaa712(wire) {
    if (!wire) return "comercial";
    const normalised = wire.toUpperCase().replace(/^ROLE_/, "");
    if (normalised === "ADMIN") return "admin";
    // Everything else (COMMERCIAL, RESELLER, USER, GUEST, unknown) → comercial.
    return "comercial";
}
function $632e0f20877ec90f$export$d4865dbdffbac6c1(profile) {
    if (!profile) return "comercial";
    const roles = profile.roles ?? [];
    for (const r of roles){
        if ($632e0f20877ec90f$export$e7f68fe8caaaa712(r) === "admin") return "admin";
    }
    return "comercial";
}
/** Explicit allowlist of fields visible to comercial role. Sourced from
 *  `BaseItemDTO` in `model/Proposal.ts`. Any new field added to the backend
 *  payload that is NOT on this list will be silently dropped — this is the
 *  intended fail-closed behaviour. When adding a new comercial-safe field,
 *  extend BOTH `BaseItemDTO` and this list. */ const $632e0f20877ec90f$var$COMERCIAL_ITEM_KEYS = [
    "product_id",
    "name",
    "reference",
    "component_type",
    "component_type_key",
    "rev3_cents",
    "rev4_cents",
    "pvp_cents",
    "unit_price_cents",
    "min_price_cents",
    "margin_at_risk",
    "quantity",
    "vat_rate_pct",
    "vat_regime"
];
const $632e0f20877ec90f$var$_allowlistCompleteness = true;
function $632e0f20877ec90f$export$e372dcc8dc2d1673(items) {
    return items.map((item)=>{
        const safe = {};
        for (const key of $632e0f20877ec90f$var$COMERCIAL_ITEM_KEYS)if (key in item) {
            const value = item[key];
            if (value !== undefined) safe[key] = value;
        }
        return safe;
    });
}
function $632e0f20877ec90f$export$86e8e662b44fe016(profile, adminRevision) {
    const role = $632e0f20877ec90f$export$d4865dbdffbac6c1(profile);
    if (role === "admin") return {
        role: "admin",
        revision: adminRevision
    };
    const comercialRevision = {
        version: adminRevision.version,
        reference_type: adminRevision.reference_type,
        total_cents: adminRevision.total_cents,
        // Metadata fields are non-sensitive (authorship + workflow state) and
        // visible to both roles. Forwarded as-is; missing values stay missing.
        notes: adminRevision.notes,
        created_by: adminRevision.created_by,
        created_at: adminRevision.created_at,
        change_request_justification: adminRevision.change_request_justification,
        preview_url: adminRevision.preview_url,
        items: $632e0f20877ec90f$export$e372dcc8dc2d1673(adminRevision.items),
        // KPI subset without the admin-only margin field.
        kpis: adminRevision.kpis ? {
            above_rev3_pct: adminRevision.kpis.above_rev3_pct,
            above_min_pct: adminRevision.kpis.above_min_pct
        } : undefined
    };
    return {
        role: "comercial",
        revision: comercialRevision
    };
}




/**
 * ProposalRevisionView — read-only display of a saved proposal revision.
 *
 * PR 6b — Phase 3 migration: consumes the discriminated `ProposalResponse`
 * union (admin / comercial) instead of the legacy `ProposalRevision` model.
 * Role-aware columns: admin sees Custo unit + Margem; comercial does not.
 * Both roles see Tipo, Produto, Qty, Rev4 unit., Valor ref., Rev3 unit.,
 * Subtotal, and a per-row `margin_at_risk` chip.
 *
 * Subtotal semantics: column reflects the NEGOTIATED price
 * (`unit_price_cents × qty`), NOT the catalog PVP × qty. PVP stays as the
 * "PVP unit." reference column so the discount magnitude is still visible.
 * The footer "Preço final" uses `revision.total_cents` straight from the
 * backend — never recomputed client-side, so admin and comercial agree.
 *
 * Reference badge: F2-VR — renders a Chip with the effective reference type
 * (REV3 / COST / REV4). Legacy revisions (reference_type null/undefined) are
 * treated as COST and tagged "(legacy)".
 *
 * Role narrowing convention (ADR PR 6a): narrow `response.role` BEFORE
 * reading `response.revision`. The discriminator is on response, not on
 * revision.
 */ 
var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


/**
 * PR 6b — Phase 2 — DTO type-guard helpers for proposal items.
 *
 * Bridges the gap between the discriminated DTO union (`AdminItemDTO` |
 * `ComercialItemDTO`) and call sites that need to render admin-only fields
 * (cost_cents, margin_pct, min_margin_pct) without leaking those fields to
 * comercial users.
 *
 * Why type guards and not casts:
 *   - `(item as AdminItemDTO).cost_cents` is a runtime trap door — the field
 *     might be undefined when the backend strips it for comercial.
 *   - A user-defined type guard (`item is AdminItemDTO`) narrows the union
 *     in the consumer's lexical scope and surfaces the absent-field case
 *     as a compile error instead of `undefined` at runtime.
 *
 * The discriminator is the PRESENCE of `cost_cents` (and the related
 * `margin_pct`). This matches what `stripAdminFields` does in proposalApi.ts:
 * it deletes those keys on the comercial path, so `hasCostCents` agrees with
 * `role === "admin"` for any response that passed through the API client.
 *
 * Defence-in-depth: callers MUST still gate on `response.role === "admin"`
 * BEFORE rendering admin-only columns. The type guard is for narrowing
 * inside `.items.map((item) => …)`, not as a role substitute.
 *
 * See ADR PR 6b, decision C1 ("Type-guard helper module"), and Convenções §4.
 */ function $6affcad8e0e04b21$export$a0018a5524ae4092(item) {
    // `in` is the safe discriminator — `(item as any).cost_cents !== undefined`
    // would also match a leaked `cost_cents: 0`, which we explicitly DO want
    // to narrow (cost of zero is still admin-only information).
    return "cost_cents" in item && typeof item.cost_cents === "number";
}
function $6affcad8e0e04b21$export$dbd814d99ef0899(item) {
    return "margin_pct" in item && typeof item.margin_pct === "number";
}
function $6affcad8e0e04b21$export$8d9953d44e24495a(item) {
    return $6affcad8e0e04b21$export$a0018a5524ae4092(item) ? item.cost_cents : null;
}
function $6affcad8e0e04b21$export$42cc842cc6dfdbd7(item) {
    return $6affcad8e0e04b21$export$dbd814d99ef0899(item) ? item.margin_pct : null;
}


function $b6ac59eb08352764$var$formatCents(cents) {
    return `${(cents / 100).toFixed(2)} \u{20AC}`;
}
/** Format a 0..1 margin pct as a pt-PT percentage. */ const $b6ac59eb08352764$var$MARGIN_FORMATTER = new Intl.NumberFormat("pt-PT", {
    style: "percent",
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
    signDisplay: "exceptZero"
});
/** Per-unit reference value in cents, or undefined when no value is available.
 *  Both DTO shapes (admin/comercial) carry rev3_cents; only admin carries
 *  cost_cents. For comercial under COST mode we fall back to rev3_cents —
 *  comercial role cannot see cost. Server-side is the source of truth
 *  (`min_price_cents` is already computed against the correct reference);
 *  this client-side function is presentational only. */ function $b6ac59eb08352764$var$itemRefUnit(item, effective) {
    if (effective === "REV3") return item.rev3_cents;
    if (effective === "REV4") {
        // Free reference: REV4 → REV3 → cost (admin only) fallback chain.
        if (item.rev4_cents !== undefined) return item.rev4_cents;
        if (item.rev3_cents !== undefined) return item.rev3_cents;
        // Admin branch: prefer cost when both rev3 and rev4 absent.
        if ("cost_cents" in item) return item.cost_cents;
        return undefined;
    }
    // COST mode. Comercial doesn't carry cost — fall back to rev3.
    if ("cost_cents" in item) return item.cost_cents;
    return item.rev3_cents;
}
const $b6ac59eb08352764$var$ProposalRevisionView = ({ response: response, showChangeRequestJustification: showChangeRequestJustification })=>{
    // Narrow on role FIRST. After this branch, response.revision.items is
    // either AdminItemDTO[] or ComercialItemDTO[] — never the union.
    const isAdmin = response.role === "admin";
    const { revision: revision } = response;
    const items = revision.items;
    const effective = (0, $92abc7e5184dde18$export$23cdcb77113ad168)(revision.reference_type);
    const legacy = (0, $92abc7e5184dde18$export$3926a790307af4f1)(revision.reference_type);
    const refColumnLabel = effective === "REV3" ? "Valor ref. (Rev3)" : effective === "REV4" ? "Valor ref. (Rev4)" : "Valor ref. (Custo)";
    const badgeLabel = legacy ? "Ref: Custo (legacy)" : effective === "REV3" ? "Ref: Rev3" : effective === "REV4" ? "Ref: Rev4" : "Ref: Custo";
    const badgeColor = legacy ? "warning" : effective === "REV3" ? "primary" : effective === "REV4" ? "info" : "default";
    const badgeSx = !legacy && effective === "COST" ? {
        bgcolor: "#6B7280",
        color: "#fff",
        fontWeight: 600
    } : {
        fontWeight: 600
    };
    const badgeTooltip = legacy ? "Revis\xe3o anterior \xe0 migra\xe7\xe3o F2-VR \u2014 tratada como Custo" : effective === "REV3" ? "Valor de refer\xeancia: pre\xe7o Rev3 (lista revendedor)" : effective === "REV4" ? "Valor de refer\xeancia: pre\xe7o Rev4 (revendedor)" : "Valor de refer\xeancia: custo de cat\xe1logo";
    const subtotalUnitCents = (item)=>item.unit_price_cents * item.quantity;
    const totalRefCents = items.reduce((sum, i)=>{
        const ref = $b6ac59eb08352764$var$itemRefUnit(i, effective);
        if (ref === undefined) return sum;
        return (sum ?? 0) + ref * i.quantity;
    }, undefined);
    const totalRev4Cents = items.some((i)=>i.rev4_cents !== undefined) ? items.reduce((sum, i)=>sum + (i.rev4_cents ?? 0) * i.quantity, 0) : undefined;
    const totalRev3Cents = items.reduce((sum, i)=>sum + (i.rev3_cents ?? i.pvp_cents ?? 0) * i.quantity, 0);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Box), {
        "data-testid": "proposal-revision-view",
        "data-role": response.role,
        children: [
            showChangeRequestJustification && revision.change_request_justification && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Alert), {
                severity: "warning",
                sx: {
                    mb: 2
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                        children: "Pedido de altera\xe7\xe3o:"
                    }),
                    " ",
                    revision.change_request_justification
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Box), {
                display: "flex",
                justifyContent: "flex-end",
                mb: 1,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Tooltip), {
                    title: badgeTooltip,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Chip), {
                        label: badgeLabel,
                        color: badgeColor,
                        size: "small",
                        sx: badgeSx,
                        "data-testid": "reference-type-badge",
                        "aria-label": badgeTooltip
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Table), {
                size: "small",
                sx: {
                    mb: 2
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableHead), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.TableRow), {
                            sx: {
                                "& th": {
                                    fontWeight: 700,
                                    bgcolor: "#f5f5f5"
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                    sx: {
                                        width: 140
                                    },
                                    children: "Tipo"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                    children: "Produto"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                    align: "right",
                                    children: "Qty"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                    align: "right",
                                    children: "Rev4 unit."
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.TableCell), {
                                    align: "right",
                                    children: [
                                        refColumnLabel,
                                        " unit."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                    align: "right",
                                    children: "PVP/Rev3 unit."
                                }),
                                isAdmin && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                    align: "right",
                                    "data-testid": "header-cost",
                                    children: "Custo unit."
                                }),
                                isAdmin && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                    align: "right",
                                    "data-testid": "header-margin",
                                    children: "Margem"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                    align: "right",
                                    children: "Subtotal"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableBody), {
                        children: items.map((item, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.TableRow), {
                                "data-testid": `row-${item.product_id}`,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                        sx: {
                                            color: "text.secondary",
                                            fontSize: 13
                                        },
                                        children: item.component_type ?? "\u2014"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Box), {
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 0.75,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Box), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Typography), {
                                                            variant: "body2",
                                                            fontWeight: 600,
                                                            children: item.product_id
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Typography), {
                                                            variant: "caption",
                                                            color: "text.secondary",
                                                            component: "div",
                                                            children: item.name
                                                        })
                                                    ]
                                                }),
                                                item.margin_at_risk && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Tooltip), {
                                                    title: "Pre\xe7o unit\xe1rio abaixo do m\xednimo permitido \u2014 margem em risco",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Chip), {
                                                        label: "Margem em risco",
                                                        size: "small",
                                                        role: "img",
                                                        tabIndex: 0,
                                                        "aria-label": "Margem em risco: pre\xe7o abaixo do m\xednimo permitido",
                                                        "data-testid": `margin-at-risk-${item.product_id}`,
                                                        sx: {
                                                            bgcolor: "#92400E",
                                                            color: "white",
                                                            fontWeight: 600,
                                                            height: 20,
                                                            fontSize: 11
                                                        }
                                                    })
                                                }),
                                                item.rev3_cents !== undefined && item.rev3_cents === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Tooltip), {
                                                    title: "Pre\xe7o Rev3 n\xe3o definido para este produto",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Chip), {
                                                        label: "Sem Rev3",
                                                        size: "small",
                                                        role: "img",
                                                        "aria-label": "Produto sem pre\xe7o Rev3 definido no cat\xe1logo",
                                                        "data-testid": `no-rev3-${item.product_id}`,
                                                        sx: {
                                                            bgcolor: "#D97706",
                                                            color: "white",
                                                            fontWeight: 600,
                                                            height: 20,
                                                            fontSize: 11
                                                        }
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                        align: "right",
                                        children: item.quantity
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                        align: "right",
                                        sx: {
                                            color: "text.secondary"
                                        },
                                        children: item.rev4_cents !== undefined ? $b6ac59eb08352764$var$formatCents(item.rev4_cents) : "\u2014"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                        align: "right",
                                        sx: {
                                            color: "text.secondary"
                                        },
                                        children: (()=>{
                                            const ref = $b6ac59eb08352764$var$itemRefUnit(item, effective);
                                            return ref !== undefined ? $b6ac59eb08352764$var$formatCents(ref) : "\u2014";
                                        })()
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                        align: "right",
                                        sx: {
                                            color: "text.secondary"
                                        },
                                        children: item.rev3_cents !== undefined || item.pvp_cents !== undefined ? $b6ac59eb08352764$var$formatCents(item.rev3_cents ?? item.pvp_cents ?? 0) : "\u2014"
                                    }),
                                    isAdmin && (0, $6affcad8e0e04b21$export$a0018a5524ae4092)(item) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                        align: "right",
                                        sx: {
                                            color: "text.secondary"
                                        },
                                        "data-testid": `cell-cost-${item.product_id}`,
                                        children: $b6ac59eb08352764$var$formatCents(item.cost_cents)
                                    }),
                                    isAdmin && (0, $6affcad8e0e04b21$export$dbd814d99ef0899)(item) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                        align: "right",
                                        "data-testid": `cell-margin-${item.product_id}`,
                                        sx: {
                                            color: item.margin_pct < 0 ? "#B91C1C" : "text.secondary",
                                            fontVariantNumeric: "tabular-nums"
                                        },
                                        children: $b6ac59eb08352764$var$MARGIN_FORMATTER.format(item.margin_pct)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                        align: "right",
                                        sx: {
                                            fontWeight: 600
                                        },
                                        children: $b6ac59eb08352764$var$formatCents(subtotalUnitCents(item))
                                    })
                                ]
                            }, item.product_id + idx))
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableFooter), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.TableRow), {
                            sx: {
                                "& td": {
                                    fontWeight: 700,
                                    bgcolor: "#f5f5f5"
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                    colSpan: 3,
                                    children: "Total"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                    align: "right",
                                    children: totalRev4Cents !== undefined ? $b6ac59eb08352764$var$formatCents(totalRev4Cents) : "\u2014"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                    align: "right",
                                    children: totalRefCents !== undefined ? $b6ac59eb08352764$var$formatCents(totalRefCents) : "\u2014"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                    align: "right",
                                    children: $b6ac59eb08352764$var$formatCents(totalRev3Cents)
                                }),
                                isAdmin && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {}),
                                isAdmin && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                    align: "right",
                                    children: $b6ac59eb08352764$var$formatCents(revision.total_cents)
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Box), {
                display: "flex",
                justifyContent: "flex-end",
                mb: 1,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Box), {
                    sx: {
                        bgcolor: "primary.main",
                        color: "primary.contrastText",
                        borderRadius: 2,
                        px: 3,
                        py: 1,
                        textAlign: "right"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Typography), {
                            variant: "caption",
                            sx: {
                                opacity: 0.85,
                                display: "block"
                            },
                            children: "Pre\xe7o Final da Proposta"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Typography), {
                            variant: "h6",
                            fontWeight: 700,
                            children: $b6ac59eb08352764$var$formatCents(revision.total_cents)
                        })
                    ]
                })
            }),
            revision.notes && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Box), {
                sx: {
                    bgcolor: "#fffde7",
                    border: "1px solid #f9a825",
                    borderRadius: 1,
                    p: 1.5,
                    mb: 1
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Typography), {
                        variant: "caption",
                        color: "text.secondary",
                        display: "block",
                        children: "Notas internas"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Typography), {
                        variant: "body2",
                        children: revision.notes
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Typography), {
                variant: "caption",
                color: "text.secondary",
                children: [
                    "Revis\xe3o v",
                    revision.version,
                    " \u2014 guardada por ",
                    revision.created_by || "\u2014",
                    revision.created_at ? ` em ${new Date(revision.created_at).toLocaleString("pt-PT")}` : ""
                ]
            })
        ]
    });
};
var $b6ac59eb08352764$export$2e2bcd8739ae039 = $b6ac59eb08352764$var$ProposalRevisionView;


/**
 * ProposalEditor — inline editor for creating/updating a proposal revision.
 *
 * Features (F-2.0 Plan, Phase 6):
 * - Items table with ProductSearchInput (D3 spike confirmed)
 * - qty field, pvp_cents editable, cost_cents read-only (snapshot)
 * - PricePanel: margin slider + final price + zone badge (Phase 6.6)
 * - Real-time total calculation
 * - Notes textarea
 * - Validates price >= cost
 * - Sends POST /admin/orders/:id/proposal with optimistic lock (version)
 * - useDirtyState exit guard: prompts before discarding unsaved changes
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $2b4e1963b712d6d0$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $2b4e1963b712d6d0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($2b4e1963b712d6d0$exports, "__esModule", {
    value: true
});
$2b4e1963b712d6d0$exports.default = void 0;

var $2b4e1963b712d6d0$var$_createSvgIcon = $2b4e1963b712d6d0$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $2b4e1963b712d6d0$var$_default = $2b4e1963b712d6d0$exports.default = (0, $2b4e1963b712d6d0$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M9.01 14H2v2h7.01v3L13 15l-3.99-4zm5.98-1v-3H22V8h-7.01V5L11 9z"
}), 'CompareArrows');






/**
 * StaleConflictDialog — Task 7.3 (F-2.0 Phase 7)
 *
 * Shown when:
 *   A) POST /orders/:id/proposal returns 409 {error:"stale_version", current_version:N}
 *      → non-blocking diff: user's items vs server's latest revision
 *   B) POST /orders/:id/proposal returns 422 {error:"stale_item_price", items:[...]}
 *      → highlights stale rows inline (borda vermelha + ⚠️ ícone)
 *
 * Decisions (plan Phase 7):
 *   - 409: side-by-side view; "Adoptar versão servidor" | "Manter as minhas alterações (forçar)"
 *   - 422: list of stale items with old vs new cost; user must acknowledge before re-saving
 *   - Never silently discard user's work
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $2be2d5fda6f09cee$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $2be2d5fda6f09cee$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($2be2d5fda6f09cee$exports, "__esModule", {
    value: true
});
$2be2d5fda6f09cee$exports.default = void 0;

var $2be2d5fda6f09cee$var$_createSvgIcon = $2be2d5fda6f09cee$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $2be2d5fda6f09cee$var$_default = $2be2d5fda6f09cee$exports.default = (0, $2be2d5fda6f09cee$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M12 5.99 19.53 19H4.47zM12 2 1 21h22z"
    }, "0"),
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M13 16h-2v2h2zm0-6h-2v5h2z"
    }, "1")
], 'WarningAmber');


// ── shared helper ──────────────────────────────────────────────────────────────
function $208d18acbdc98c7c$var$fmt(cents) {
    return (cents / 100).toFixed(2) + " \u20AC";
}
const $208d18acbdc98c7c$export$d070577284818d17 = ({ open: open, userItems: userItems, userNotes: userNotes, userTotalCents: userTotalCents, serverRevision: serverRevision, onAdoptServer: onAdoptServer, onKeepMine: onKeepMine, onClose: onClose })=>{
    const serverItems = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (!serverRevision?.items) return [];
        return serverRevision.items.map((i)=>({
                ...i,
                _localId: crypto.randomUUID()
            }));
    }, [
        serverRevision
    ]);
    const serverVersion = serverRevision?.version ?? 0;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Dialog), {
        open: open,
        onClose: onClose,
        maxWidth: "lg",
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.DialogTitle), {
                sx: {
                    bgcolor: "warning.main",
                    color: "warning.contrastText"
                },
                children: "\u26A0\uFE0F Conflito de vers\xe3o \u2014 a tua revis\xe3o est\xe1 desactualizada"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.DialogContent), {
                dividers: true,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Alert), {
                        severity: "warning",
                        sx: {
                            mb: 2
                        },
                        children: [
                            "Algu\xe9m guardou uma revis\xe3o mais recente (v",
                            serverVersion,
                            ") entretanto. Compara as diferen\xe7as e escolhe como continuar."
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Box), {
                        sx: {
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            gap: 3
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Box), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Typography), {
                                        variant: "subtitle1",
                                        fontWeight: 700,
                                        mb: 1,
                                        children: "As tuas altera\xe7\xf5es"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($208d18acbdc98c7c$var$ItemsTable, {
                                        items: userItems
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Typography), {
                                        variant: "body2",
                                        mt: 1,
                                        color: "text.secondary",
                                        children: [
                                            "Total: ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                children: $208d18acbdc98c7c$var$fmt(userTotalCents)
                                            })
                                        ]
                                    }),
                                    userNotes && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Typography), {
                                        variant: "body2",
                                        mt: 0.5,
                                        color: "text.secondary",
                                        children: [
                                            "Notas: ",
                                            userNotes
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Box), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Typography), {
                                        variant: "subtitle1",
                                        fontWeight: 700,
                                        mb: 1,
                                        children: [
                                            "Vers\xe3o do servidor (v",
                                            serverVersion,
                                            ")"
                                        ]
                                    }),
                                    serverRevision ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($208d18acbdc98c7c$var$ItemsTable, {
                                                items: serverItems
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Typography), {
                                                variant: "body2",
                                                mt: 1,
                                                color: "text.secondary",
                                                children: [
                                                    "Total: ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                        children: $208d18acbdc98c7c$var$fmt(serverRevision.total_cents)
                                                    })
                                                ]
                                            }),
                                            serverRevision.notes && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Typography), {
                                                variant: "body2",
                                                mt: 0.5,
                                                color: "text.secondary",
                                                children: [
                                                    "Notas: ",
                                                    serverRevision.notes
                                                ]
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Typography), {
                                        color: "text.secondary",
                                        variant: "body2",
                                        children: "A carregar revis\xe3o do servidor\u2026"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.DialogActions), {
                sx: {
                    justifyContent: "space-between",
                    px: 3,
                    py: 2
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Button), {
                        onClick: onClose,
                        color: "inherit",
                        children: "Cancelar"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Box), {
                        sx: {
                            display: "flex",
                            gap: 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Button), {
                                variant: "outlined",
                                onClick: onAdoptServer,
                                disabled: !serverRevision,
                                children: "Adoptar vers\xe3o servidor"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Button), {
                                variant: "contained",
                                color: "warning",
                                onClick: ()=>onKeepMine(serverVersion),
                                disabled: !serverRevision,
                                children: "Manter as minhas altera\xe7\xf5es"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $208d18acbdc98c7c$export$d7c0b8e582bfae1f = ({ open: open, staleItems: staleItems, onAcknowledge: onAcknowledge, onClose: onClose })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Dialog), {
        open: open,
        onClose: onClose,
        maxWidth: "sm",
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.DialogTitle), {
                sx: {
                    bgcolor: "error.main",
                    color: "error.contrastText"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2be2d5fda6f09cee$exports))), {
                        sx: {
                            verticalAlign: "middle",
                            mr: 1
                        }
                    }),
                    "Pre\xe7os desactualizados"
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.DialogContent), {
                dividers: true,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Alert), {
                        severity: "error",
                        sx: {
                            mb: 2
                        },
                        children: [
                            "O pre\xe7o de ",
                            staleItems.length,
                            " componente(s) mudou desde que carregaste o editor. Confirma os valores actualizados antes de guardar."
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Table), {
                        size: "small",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableHead), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.TableRow), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                children: "Produto"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                            align: "right",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                children: "Custo anterior"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                            align: "right",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                children: "Custo actual"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                            align: "right",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                children: "\u0394"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableBody), {
                                children: staleItems.map((item)=>{
                                    const delta = item.new_cost_cents - item.old_cost_cents;
                                    const isIncrease = delta > 0;
                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.TableRow), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Box), {
                                                    sx: {
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 0.5
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2be2d5fda6f09cee$exports))), {
                                                            sx: {
                                                                fontSize: 16,
                                                                color: "error.main"
                                                            }
                                                        }),
                                                        item.name
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                                align: "right",
                                                sx: {
                                                    color: "text.secondary"
                                                },
                                                children: $208d18acbdc98c7c$var$fmt(item.old_cost_cents)
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                                align: "right",
                                                sx: {
                                                    fontWeight: 700
                                                },
                                                children: $208d18acbdc98c7c$var$fmt(item.new_cost_cents)
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                                align: "right",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Chip), {
                                                    label: `${isIncrease ? "+" : ""}${$208d18acbdc98c7c$var$fmt(delta)}`,
                                                    color: isIncrease ? "error" : "success",
                                                    size: "small"
                                                })
                                            })
                                        ]
                                    }, item.product_id);
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.DialogActions), {
                sx: {
                    px: 3,
                    py: 2
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Button), {
                        onClick: onClose,
                        color: "inherit",
                        children: "Rever manualmente"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Button), {
                        variant: "contained",
                        color: "error",
                        onClick: onAcknowledge,
                        children: "Confirmo \u2014 guardar com pre\xe7os actualizados"
                    })
                ]
            })
        ]
    });
};
// ── shared sub-component ──────────────────────────────────────────────────────
const $208d18acbdc98c7c$var$ItemsTable = ({ items: items })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Table), {
        size: "small",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableHead), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.TableRow), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                children: "Produto"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                            align: "right",
                            children: "Qty"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                            align: "right",
                            children: "PVP"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                            align: "right",
                            children: "Custo"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableBody), {
                children: items.map((item, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.TableRow), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                children: item.name || item.product_id
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                align: "right",
                                children: item.quantity
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                align: "right",
                                children: $208d18acbdc98c7c$var$fmt(item.pvp_cents)
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                align: "right",
                                children: $208d18acbdc98c7c$var$fmt(item.cost_cents)
                            })
                        ]
                    }, item.product_id || idx))
            })
        ]
    });


/**
 * PricePanel — margin & final price control panel (F-2.0 Plan Phase 6.6,
 * extended in PR 6a Phase 5).
 *
 * Consumes useMarginCalculator to provide:
 *   - Reference total display (read-only) — switches between Rev3 / Rev4 / Custo
 *   - Reference type toggle (header) — REV4 free; Custo locked to admin
 *   - Margin slider (0–50%, marks at 0/5/10/15/25/50)
 *   - Margin inline label "X.X% (€ Y,YY)"
 *   - Final price input (editable — drives margin backwards)
 *   - Margin zone badge (loss/low/healthy/high)
 *   - Weighted Rev4 average display
 *
 * PR 6a Phase 5 additions:
 *   - REV4 ToggleButton inserted between REV3 and Custo (free for all roles).
 *   - IVA label (semantic <button> with Tooltip) shown when `vatRate` set.
 *     Replaces the previous <Box tabIndex={0}> a11y anti-pattern.
 *   - ProposalKpiBlock integrated above the header — opt-in via `role` prop.
 *
 * KPI block — internal shim (Phase 5 design decision):
 *   The hook useProposalKpis expects a canonical `ProposalResponse` with
 *   unit_price_cents + min_price_cents per line. PricePanel only knows the
 *   F2-VR shape (`Rev4Item[]` + a single `priceCents` total), so we build a
 *   synthetic shim **for the KPI block only**:
 *     - unit_price = priceCents distributed proportionally to each line's
 *       reference total (Rev3, fallback Rev4, fallback Cost). Preserves
 *       relative weights of the chosen reference.
 *     - min_price_cents = MAX(rev4 ?? rev3 ?? cost, ROUND(cost × 1.05)).
 *       Default 5% floor — we don't know the category here. The server
 *       authoritative value (per-category margin from the catalog) flows
 *       through in Phase 6 once ProposalEditor passes the real response.
 *   These KPIs are therefore a *preview* — order of magnitude correct, but
 *   not byte-identical to what the server will surface on Save. Acceptable
 *   for in-form feedback; the final view (revision page) shows server-canon.
 *
 * Invariant R1 (Phase 4 review): the `role` passed here MUST match the
 * role used to build the actual proposal response upstream. The caller is
 * responsible — typically `deriveProposalRole(useAuth().profile)`.
 *
 * F2-VR backwards compatibility: callers that don't pass `role` or `vatRate`
 * get the legacy 2-toggle / no-IVA / no-KPI surface unchanged.
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
/** Returns 15 if costCents < thresholdCents (default 150 000), else 10. */ function $9ecafeb0572fff14$export$c014e0140446a084(costCents, thresholdCents = 150000) {
    return costCents < thresholdCents ? 15 : 10;
}
function $9ecafeb0572fff14$export$c35659abd6afdebb(costCents, marginPct) {
    if (marginPct >= 100) return costCents * 10; // guard
    return Math.round(costCents / (1 - marginPct / 100));
}
function $9ecafeb0572fff14$export$ee3d0e620bf4dd53(costCents, priceCents) {
    if (priceCents <= 0) return 0;
    return Math.round((priceCents - costCents) / priceCents * 1000) / 10;
}
function $9ecafeb0572fff14$export$98ef2d5a5ce2bead(pvpCents, costCents) {
    if (pvpCents <= 0) return 0;
    return Math.round((pvpCents - costCents) / pvpCents * 1000) / 10;
}
/** Exhaustive narrowing helper. Compile-time error if `ReferenceType` gains
 *  a new case that is not handled by the caller's switch. */ function $9ecafeb0572fff14$var$assertNever(x) {
    throw new Error(`Unhandled reference type: ${String(x)}`);
}
function $9ecafeb0572fff14$export$43bd3f13e74a447c(item, type) {
    switch(type){
        case "REV4":
            return item.rev4_cents ?? item.rev3_cents ?? item.cost_cents;
        case "REV3":
            return item.rev3_cents ?? item.cost_cents;
        case "COST":
            return item.cost_cents;
        default:
            return $9ecafeb0572fff14$var$assertNever(type);
    }
}
function $9ecafeb0572fff14$export$c0942d327351729(items, type) {
    return items.reduce((acc, item)=>acc + $9ecafeb0572fff14$export$43bd3f13e74a447c(item, type) * item.quantity, 0);
}
function $9ecafeb0572fff14$export$3f1f2f18b1aa1707(priceCents, referenceCents) {
    return priceCents - referenceCents;
}
function $9ecafeb0572fff14$export$be91b3c9820b3c22(unitCents, costCents) {
    if (costCents === undefined || costCents <= 0) return undefined;
    return (unitCents - costCents) / costCents;
}
function $9ecafeb0572fff14$export$8e799d06c67922d0(unitCents, rev3Cents) {
    if (rev3Cents === undefined || rev3Cents <= 0) return undefined;
    return (unitCents - rev3Cents) / rev3Cents;
}
function $9ecafeb0572fff14$export$cff4a54a6fc14f50(items) {
    const total = items.reduce((s, i)=>s + i.quantity, 0);
    if (total === 0) return 0;
    const weighted = items.reduce((s, i)=>s + $9ecafeb0572fff14$export$98ef2d5a5ce2bead(i.pvp_cents, i.cost_cents) * i.quantity, 0);
    return Math.round(weighted / total * 10) / 10;
}
function $9ecafeb0572fff14$export$722a938cf36fd9f2(marginPct) {
    if (marginPct < 0) return "loss";
    if (marginPct < 5) return "low";
    if (marginPct < 25) return "healthy";
    return "high";
}
function $9ecafeb0572fff14$export$457abefd55a909ab(items, finalTotalCents) {
    if (items.length === 0) return items;
    const currentTotal = items.reduce((s, i)=>s + i.pvp_cents * i.quantity, 0);
    if (currentTotal === 0) {
        // Distribute evenly when all prices are 0.
        const perUnit = Math.round(finalTotalCents / items.reduce((s, i)=>s + i.quantity, 0));
        return items.map((item)=>({
                ...item,
                pvp_cents: perUnit
            }));
    }
    let allocated = 0;
    const result = items.map((item, idx)=>{
        const isLast = idx === items.length - 1;
        const itemTotal = item.pvp_cents * item.quantity;
        const share = isLast ? finalTotalCents - allocated : Math.round(itemTotal / currentTotal * finalTotalCents);
        allocated += share;
        const pvp_cents = Math.max(item.cost_cents, Math.round(share / item.quantity));
        return {
            ...item,
            pvp_cents: pvp_cents
        };
    });
    return result;
}


function $fb237450052eff8a$export$583e60a3c04cfd81(items, referenceType = "COST") {
    const referenceCents = (0, $9ecafeb0572fff14$export$c0942d327351729)(items, referenceType);
    const defaultMargin = (0, $9ecafeb0572fff14$export$c014e0140446a084)(referenceCents);
    const [margin, setMarginState] = (0, $acw62.useState)(defaultMargin);
    const [priceCents, setPriceCents] = (0, $acw62.useState)((0, $9ecafeb0572fff14$export$c35659abd6afdebb)(referenceCents, defaultMargin));
    const [intent, setIntent] = (0, $acw62.useState)("margin");
    // Track the previous referenceCents to detect threshold crossings.
    const prevRefRef = (0, $acw62.useRef)(referenceCents);
    const THRESHOLD = 150000;
    (0, $acw62.useEffect)(()=>{
        const prev = prevRefRef.current;
        prevRefRef.current = referenceCents;
        const crossedThreshold = prev < THRESHOLD && referenceCents >= THRESHOLD || prev >= THRESHOLD && referenceCents < THRESHOLD;
        if (crossedThreshold) {
            // Threshold crossed → reset to new default regardless of intent.
            const dm = (0, $9ecafeb0572fff14$export$c014e0140446a084)(referenceCents);
            setMarginState(dm);
            setPriceCents((0, $9ecafeb0572fff14$export$c35659abd6afdebb)(referenceCents, dm));
            return;
        }
        // No threshold crossing — respect intent.
        if (intent === "margin") // Pilot by margin: recalculate price to keep margin stable.
        setPriceCents((0, $9ecafeb0572fff14$export$c35659abd6afdebb)(referenceCents, margin));
        else // Pilot by price: recalculate margin to keep price stable.
        setMarginState((0, $9ecafeb0572fff14$export$ee3d0e620bf4dd53)(referenceCents, priceCents));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        referenceCents
    ]);
    const setMargin = (m)=>{
        setIntent("margin");
        setMarginState(m);
        setPriceCents((0, $9ecafeb0572fff14$export$c35659abd6afdebb)(referenceCents, m));
    };
    const setPrice = (p)=>{
        setIntent("price");
        setPriceCents(p);
        setMarginState((0, $9ecafeb0572fff14$export$ee3d0e620bf4dd53)(referenceCents, p));
    };
    const isInvalid = priceCents < referenceCents;
    return {
        costCents: referenceCents,
        referenceCents: referenceCents,
        referenceType: referenceType,
        defaultMargin: defaultMargin,
        margin: margin,
        setMargin: setMargin,
        priceCents: priceCents,
        setPrice: setPrice,
        intent: intent,
        setIntent: setIntent,
        rev4Avg: (0, $9ecafeb0572fff14$export$cff4a54a6fc14f50)(items),
        isInvalid: isInvalid,
        marginAbsCents: (0, $9ecafeb0572fff14$export$3f1f2f18b1aa1707)(priceCents, referenceCents)
    };
}



/**
 * PR 6a — Phase 3 — useProposalKpis: aggregate the 3 KPIs displayed in
 * ProposalKpiBlock (Phase 4).
 *
 * Aggregation: weighted mean over unit × qty.
 *   aboveRev3Pct = Σ((unit − rev3) × qty) / Σ(rev3 × qty)
 *   aboveMinPct  = Σ((unit − min) × qty)  / Σ(min × qty)
 *   realGrossMarginPct (admin only) = Σ((unit − cost) × qty) / Σ(unit × qty)
 *
 * Sign is preserved (no clamp at zero) — a comercial under rev3 must surface
 * as a negative chip in the KPI block.
 *
 * Memoization dep: [role, version, items.length]. The response object itself
 * is a brand-new instance every fetch (Axios returns fresh objects), so
 * referencing `response` would defeat memoization. Version is the durable
 * identity of a revision; items.length covers add/remove. This is acceptable
 * because items can never mutate in place within a single version — every
 * write creates a new revision (oms invariant).
 *
 * NOTE for shim callers: components that build a ProposalResponse locally
 * (e.g. PricePanel preview, where unit_price_cents mutates within a single
 * logical "revision") MUST use a synthetic monotonic `version` token that
 * changes whenever the inputs change. Hard-coding `version: 0` will freeze
 * the memo on the first render. See PricePanel.buildKpiShim for the canonical
 * pattern (`syntheticVersion = priceCents`).
 *
 * Roles:
 *   - admin → all 3 KPIs computed.
 *   - comercial → realGrossMarginPct is always undefined.
 *
 * Edge cases:
 *   - empty items → all undefined.
 *   - denominator === 0 → that KPI is undefined (avoid /0 NaN leaking to UI).
 */ 
var $acw62 = parcelRequire("acw62");
const $f5d8cf61e500969f$var$EMPTY = {
    aboveRev3Pct: undefined,
    aboveMinPct: undefined,
    realGrossMarginPct: undefined
};
function $f5d8cf61e500969f$var$weightedRatio(num, den) {
    if (den === 0) return undefined;
    return num / den;
}
function $f5d8cf61e500969f$var$aggregateCommon(items) {
    let rev3Num = 0;
    let rev3Den = 0;
    let minNum = 0;
    let minDen = 0;
    for (const it of items){
        const qty = it.quantity;
        const unit = it.unit_price_cents;
        if (it.rev3_cents !== undefined) {
            rev3Num += (unit - it.rev3_cents) * qty;
            rev3Den += it.rev3_cents * qty;
        }
        minNum += (unit - it.min_price_cents) * qty;
        minDen += it.min_price_cents * qty;
    }
    return {
        aboveRev3Pct: $f5d8cf61e500969f$var$weightedRatio(rev3Num, rev3Den),
        aboveMinPct: $f5d8cf61e500969f$var$weightedRatio(minNum, minDen)
    };
}
function $f5d8cf61e500969f$var$aggregateAdminMargin(items) {
    let num = 0;
    let den = 0;
    for (const it of items){
        const qty = it.quantity;
        const unit = it.unit_price_cents;
        num += (unit - it.cost_cents) * qty;
        den += unit * qty;
    }
    return $f5d8cf61e500969f$var$weightedRatio(num, den);
}
function $f5d8cf61e500969f$var$aggregate(response) {
    if (response.role === "admin") {
        const items = response.revision.items;
        if (items.length === 0) return $f5d8cf61e500969f$var$EMPTY;
        const common = $f5d8cf61e500969f$var$aggregateCommon(items);
        return {
            ...common,
            realGrossMarginPct: $f5d8cf61e500969f$var$aggregateAdminMargin(items)
        };
    }
    // comercial branch
    const items = response.revision.items;
    if (items.length === 0) return $f5d8cf61e500969f$var$EMPTY;
    const common = $f5d8cf61e500969f$var$aggregateCommon(items);
    return {
        ...common,
        realGrossMarginPct: undefined
    };
}
function $f5d8cf61e500969f$export$c15a2865170c00b5(response) {
    return (0, $acw62.useMemo)(()=>$f5d8cf61e500969f$var$aggregate(response), // eslint-disable-next-line react-hooks/exhaustive-deps -- response object is replaced every fetch; identity comes from (role, version, items.length) per oms revision invariant (items immutable within a single version)
    [
        response.role,
        response.revision.version,
        response.revision.items.length
    ]);
}


/**
 * PR 6a — Phase 4 — ProposalKpiBlock.
 *
 * Displays 2 or 3 weighted-mean KPIs computed by `useProposalKpis`:
 *   1. aboveRev3Pct       — both roles
 *   2. aboveMinPct        — both roles (any negative = margin_at_risk → major)
 *   3. realGrossMarginPct — admin only (driven by `role` prop, NOT by value)
 *
 * Visual contract:
 *   - Each KPI is a focusable MUI Chip with a Tooltip explaining the metric.
 *   - Sign preserved with Intl.NumberFormat signDisplay: "exceptZero" — a
 *     negative aboveMinPct surfaces as "−5,2%" (margin at risk territory).
 *   - Severity colour is KIND-AWARE:
 *       • "rev3" and "margin": tri-band (≥0 ok, (−5%, 0) minor, ≤−5% major).
 *       • "min": bi-band (≥0 ok, <0 major) — per spec CA9, any unit price
 *         below min_price is `margin_at_risk`, not a "minor" warning.
 *   - prefers-reduced-motion: GAP CONHECIDO. MUI Tooltip usa Grow transition
 *     por defeito e NÃO respeita `prefers-reduced-motion: reduce` out of the
 *     box. Fix exige theme-level override (criar ThemeProvider em src/App.tsx
 *     — actualmente não existe um — com `createTheme({ components: {
 *     MuiTooltip: { defaultProps: { TransitionProps: { timeout: 0 } } } } })`
 *     guarded por media query). Decisão deferida para Phase 7 a11y audit.
 *
 * Why props are { kpis, role } and not { response }:
 *   - Keeps the component pure and trivially testable.
 *   - Caller controls re-compute timing via useProposalKpis(response).
 *   - `role` is REQUIRED to satisfy spec CA1: admin role with empty items
 *     must still render 3 chips (with "—"), not 2. We cannot infer role
 *     from `kpis.realGrossMarginPct === undefined` because that's also
 *     the empty-items state.
 *
 * Loading / empty:
 *   - `kpis.aboveRev3Pct === undefined` may mean (a) empty items, (b) denom
 *     = 0, or (c) no item carries rev3_cents. The chip shows "—" in all
 *     three. Loading is the caller's responsibility (this component is
 *     pure); the caller should pass a Skeleton wrapper if it needs to
 *     distinguish loading from empty.
 */ 
var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

const $1104ab3a8fa3c4f8$var$PCT_FORMATTER = new Intl.NumberFormat("pt-PT", {
    style: "percent",
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
    signDisplay: "exceptZero"
});
/** Minor-vs-major threshold for tri-band KPIs (rev3, margin).
 *  Aligned with the backend drift severity scale (cost/rev3 drift uses
 *  the same −5% pivot). NOT applicable to aboveMinPct, which is bi-band
 *  per spec CA9 (any negative = margin_at_risk = major). */ const $1104ab3a8fa3c4f8$var$MINOR_THRESHOLD = -0.05;
/** Hex tokens locked by the spec.
 *  Bypasses the MUI theme palette intentionally — these are domain
 *  semantics (drift severity), not theme decoration. */ const $1104ab3a8fa3c4f8$var$COLOR_MAJOR = "#B91C1C";
const $1104ab3a8fa3c4f8$var$COLOR_MINOR = "#B45309";
const $1104ab3a8fa3c4f8$var$COLOR_OK = "#15803D";
const $1104ab3a8fa3c4f8$var$COLOR_NEUTRAL_BG = "rgba(0,0,0,0.08)";
const $1104ab3a8fa3c4f8$var$COLOR_NEUTRAL_FG = "rgba(0,0,0,0.6)";
function $1104ab3a8fa3c4f8$var$severityColor(pct, kind) {
    if (pct === undefined) return undefined;
    if (pct >= 0) return $1104ab3a8fa3c4f8$var$COLOR_OK;
    if (kind === "biBand") return $1104ab3a8fa3c4f8$var$COLOR_MAJOR;
    // triBand
    if (pct > $1104ab3a8fa3c4f8$var$MINOR_THRESHOLD) return $1104ab3a8fa3c4f8$var$COLOR_MINOR;
    return $1104ab3a8fa3c4f8$var$COLOR_MAJOR;
}
function $1104ab3a8fa3c4f8$var$formatPct(pct) {
    if (pct === undefined) return "\u2014";
    return $1104ab3a8fa3c4f8$var$PCT_FORMATTER.format(pct);
}
const $1104ab3a8fa3c4f8$var$KpiChip = ({ label: label, tooltip: tooltip, value: value, kind: kind, testId: testId })=>{
    const semanticColor = $1104ab3a8fa3c4f8$var$severityColor(value, kind);
    const display = $1104ab3a8fa3c4f8$var$formatPct(value);
    const isNeutral = semanticColor === undefined;
    const borderColor = semanticColor ?? $1104ab3a8fa3c4f8$var$COLOR_NEUTRAL_BG;
    const bgColor = semanticColor ? `${semanticColor}14` : $1104ab3a8fa3c4f8$var$COLOR_NEUTRAL_BG;
    const fgColor = semanticColor ?? $1104ab3a8fa3c4f8$var$COLOR_NEUTRAL_FG;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Tooltip), {
        title: tooltip,
        arrow: true,
        placement: "top",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Chip), {
            "data-testid": testId,
            label: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Stack), {
                direction: "row",
                spacing: 1,
                alignItems: "baseline",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Typography), {
                        component: "span",
                        variant: "caption",
                        sx: {
                            fontWeight: 500
                        },
                        children: label
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Typography), {
                        component: "span",
                        variant: "body2",
                        sx: {
                            fontWeight: 700,
                            fontVariantNumeric: "tabular-nums"
                        },
                        children: display
                    })
                ]
            }),
            // Focusable for tooltip reachability by keyboard. role="status" was
            // REMOVED: it implies a live region (aria-live="polite") which would
            // cause AT to re-announce on every PricePanel re-render. The
            // `aria-label` alone carries the semantic for AT users.
            tabIndex: 0,
            "aria-label": `${label}: ${display}`,
            // Inline style — these are domain-semantic colours (drift severity
            // tokens locked by the spec), NOT theme decoration. Keeping them
            // inline survives palette swaps and is grep-able in QA. The 8-digit
            // hex `${color}14` encodes ~8% alpha (0x14/0xFF ≈ 0.078); supported
            // in Chromium ≥ 62 / Firefox ≥ 49 / Safari ≥ 9.1.
            style: {
                backgroundColor: bgColor,
                border: `1px solid ${borderColor}`,
                color: isNeutral ? $1104ab3a8fa3c4f8$var$COLOR_NEUTRAL_FG : fgColor
            },
            sx: {
                height: "auto",
                py: 0.5,
                px: 1,
                "& .MuiChip-label": {
                    px: 1
                }
            }
        })
    });
};
const $1104ab3a8fa3c4f8$var$ProposalKpiBlock = ({ kpis: kpis, role: role, className: className })=>{
    // CA1: admin renders exactly 3 chips, even with empty items (3rd shows "—").
    // Comercial renders exactly 2 chips. Visibility is role-driven, NOT
    // value-driven, to disambiguate "comercial" from "admin + empty".
    const showRealMargin = role === "admin";
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Stack), {
        direction: {
            xs: "column",
            sm: "row"
        },
        spacing: 1.5,
        alignItems: {
            xs: "stretch",
            sm: "center"
        },
        flexWrap: "wrap",
        className: className,
        "data-testid": "proposal-kpi-block",
        role: "group",
        "aria-label": "Indicadores de margem",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($1104ab3a8fa3c4f8$var$KpiChip, {
                label: "Acima REV3",
                tooltip: "Diferen\xe7a m\xe9dia ponderada entre pre\xe7o unit\xe1rio e REV3, por quantidade. Negativo = abaixo da refer\xeancia comercial.",
                value: kpis.aboveRev3Pct,
                kind: "triBand",
                testId: "kpi-above-rev3"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($1104ab3a8fa3c4f8$var$KpiChip, {
                label: "Acima m\xednimo",
                tooltip: "Diferen\xe7a m\xe9dia ponderada entre pre\xe7o unit\xe1rio e pre\xe7o m\xednimo permitido. Qualquer negativo = margem em risco.",
                value: kpis.aboveMinPct,
                kind: "biBand",
                testId: "kpi-above-min"
            }),
            showRealMargin && /*#__PURE__*/ (0, $ayMG0.jsx)($1104ab3a8fa3c4f8$var$KpiChip, {
                label: "Margem real",
                tooltip: "Margem bruta real (sobre pre\xe7o de venda). Vis\xedvel apenas a admin.",
                value: kpis.realGrossMarginPct,
                kind: "triBand",
                testId: "kpi-real-margin"
            })
        ]
    });
};
var $1104ab3a8fa3c4f8$export$2e2bcd8739ae039 = $1104ab3a8fa3c4f8$var$ProposalKpiBlock;


const $6114eefbdd4cb273$var$SLIDER_MARKS = [
    {
        value: 0,
        label: "0%"
    },
    {
        value: 5,
        label: "5%"
    },
    {
        value: 10,
        label: "10%"
    },
    {
        value: 15,
        label: "15%"
    },
    {
        value: 25,
        label: "25%"
    },
    {
        value: 50,
        label: "50%"
    }
];
const $6114eefbdd4cb273$var$ZONE_COLOR = {
    loss: "error",
    low: "warning",
    healthy: "success",
    high: "info"
};
const $6114eefbdd4cb273$var$ZONE_LABEL = {
    loss: "Preju\xedzo",
    low: "Margem baixa",
    healthy: "Margem saud\xe1vel",
    high: "Margem alta"
};
/** Default min-margin floor used when no per-category data is available. */ const $6114eefbdd4cb273$var$DEFAULT_MIN_MARGIN = 0.05;
function $6114eefbdd4cb273$var$formatCents(cents) {
    return (cents / 100).toFixed(2);
}
function $6114eefbdd4cb273$var$formatEuros(cents) {
    // pt-PT — comma decimal separator
    return $6114eefbdd4cb273$var$formatCents(cents).replace(".", ",");
}
function $6114eefbdd4cb273$var$refTotalLabelFor(type) {
    switch(type){
        case "REV3":
            return "Rev3";
        case "REV4":
            return "Rev4";
        case "COST":
            return "Custo";
        default:
            return type;
    }
}
function $6114eefbdd4cb273$var$refTotalTooltipFor(type) {
    switch(type){
        case "REV3":
            return "Total Rev3 (pre\xe7o lista revendedor) \u2014 snapshot ao adicionar produtos";
        case "REV4":
            return "Total Rev4 (pre\xe7o lista revendedor secund\xe1rio) \u2014 snapshot ao adicionar produtos";
        case "COST":
            return "Custo total de cat\xe1logo (snapshot, s\xf3 admin)";
        default:
            return "";
    }
}
/**
 * Build an internal KPI shim from F2-VR `Rev4Item[]` + a single `priceCents`
 * total. See file-header rationale; this is an approximation, not server-canon.
 *
 * Shape note: this builds objects that satisfy AdminItemDTO/ComercialItemDTO
 * structurally. Fields not used by useProposalKpis (e.g. `pvp_cents`, `name`,
 * `vat_rate`, `vat_regime`, `margin_at_risk`, `margin_pct`) are filled with
 * benign defaults — they're never displayed because the shim never leaves
 * this hook chain.
 */ function $6114eefbdd4cb273$var$buildKpiShim(items, priceCents, referenceType, role) {
    // Reference per line — Rev3 → Rev4 → Cost — for proportional price split.
    const refPerLine = items.map((it)=>it.rev3_cents ?? it.rev4_cents ?? it.cost_cents);
    const refTotal = refPerLine.reduce((acc, ref, i)=>acc + ref * items[i].quantity, 0);
    // Distribute the total price proportionally. If refTotal is 0 (degenerate
    // input), split evenly across quantities.
    const totalQty = items.reduce((a, it)=>a + it.quantity, 0) || 1;
    const buildAdminItem = (it, idx)=>{
        const ref = refPerLine[idx];
        const weight = refTotal > 0 ? ref * it.quantity / refTotal : it.quantity / totalQty;
        const lineTotal = Math.round(priceCents * weight);
        const unit = it.quantity > 0 ? Math.round(lineTotal / it.quantity) : lineTotal;
        const minFromCost = Math.round(it.cost_cents * (1 + $6114eefbdd4cb273$var$DEFAULT_MIN_MARGIN));
        const minFloor = it.rev4_cents ?? it.rev3_cents ?? it.cost_cents;
        const minPrice = Math.max(minFloor, minFromCost);
        const marginPct = unit > 0 ? (unit - it.cost_cents) / unit : 0;
        return {
            // Synthetic ids — never sent to wire.
            product_id: `shim-${idx}`,
            name: "",
            pvp_cents: it.pvp_cents,
            unit_price_cents: unit,
            min_price_cents: minPrice,
            margin_at_risk: unit < minPrice,
            quantity: it.quantity,
            vat_rate_pct: 0,
            vat_regime: "",
            rev3_cents: it.rev3_cents,
            rev4_cents: it.rev4_cents,
            cost_cents: it.cost_cents,
            margin_pct: marginPct
        };
    };
    const buildComercialItem = (it, idx)=>{
        const admin = buildAdminItem(it, idx);
        // Comercial = BaseItemDTO — strip cost_cents + margin_pct only.
        return {
            product_id: admin.product_id,
            name: admin.name,
            pvp_cents: admin.pvp_cents,
            unit_price_cents: admin.unit_price_cents,
            min_price_cents: admin.min_price_cents,
            margin_at_risk: admin.margin_at_risk,
            quantity: admin.quantity,
            vat_rate_pct: admin.vat_rate_pct,
            vat_regime: admin.vat_regime,
            rev3_cents: admin.rev3_cents,
            rev4_cents: admin.rev4_cents
        };
    };
    // Synthetic version = priceCents. `useProposalKpis` memoizes on
    // [role, version, items.length] (oms invariant: real revisions bump version
    // whenever unit_price_cents changes). The shim mutates unit_price_cents
    // within a single logical "revision", so we use priceCents itself as a
    // monotonic identity token to invalidate the memo on every price change.
    // This convention is shim-local — real backend responses use the actual
    // revision.version. See useProposalKpis JSDoc.
    const syntheticVersion = priceCents;
    // Sentinel metadata for shim revisions. `created_by` and `created_at` are
    // required on the wire contract (BaseRevisionDTO) — when synthesising a
    // response locally for KPI computation, we emit empty strings to signal
    // "no authorship; do not display". `ProposalRevisionView` and any other
    // consumer reading these fields MUST treat "" / falsy as "absent".
    const SHIM_CREATED_BY = "";
    const SHIM_CREATED_AT = "";
    if (role === "admin") return {
        role: "admin",
        revision: {
            version: syntheticVersion,
            reference_type: referenceType,
            total_cents: priceCents,
            created_by: SHIM_CREATED_BY,
            created_at: SHIM_CREATED_AT,
            items: items.map(buildAdminItem)
        }
    };
    return {
        role: "comercial",
        revision: {
            version: syntheticVersion,
            reference_type: referenceType,
            total_cents: priceCents,
            created_by: SHIM_CREATED_BY,
            created_at: SHIM_CREATED_AT,
            items: items.map(buildComercialItem)
        }
    };
}
const $6114eefbdd4cb273$var$PricePanel = ({ items: items, externalPriceCents: externalPriceCents, onPriceChange: onPriceChange, referenceType: referenceType = "REV3", onReferenceTypeChange: onReferenceTypeChange, isAdmin: isAdmin = false, referenceLocked: referenceLocked = false, role: role, vatRate: vatRate, vatRegime: vatRegime })=>{
    const calc = (0, $fb237450052eff8a$export$583e60a3c04cfd81)(items, referenceType);
    const zone = (0, $9ecafeb0572fff14$export$722a938cf36fd9f2)(calc.margin);
    // PR 6a — KPI shim. Hook is called unconditionally to keep hook order
    // stable; we feed an empty-items response when role is absent so the hook
    // is cheap and returns EMPTY KPIs that the JSX gate suppresses anyway.
    const kpiResponse = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>role !== undefined ? $6114eefbdd4cb273$var$buildKpiShim(items, calc.priceCents, referenceType, role) : {
            role: "comercial",
            revision: {
                version: 0,
                reference_type: referenceType,
                total_cents: 0,
                // Empty-state shim — same sentinel convention as buildKpiShim.
                created_by: "",
                created_at: "",
                items: []
            }
        }, [
        items,
        calc.priceCents,
        referenceType,
        role
    ]);
    const kpis = (0, $f5d8cf61e500969f$export$c15a2865170c00b5)(kpiResponse);
    // Sync external price into calculator when it changes (e.g. loaded from revision)
    const prevExternalRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(undefined);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (externalPriceCents !== undefined && externalPriceCents !== prevExternalRef.current && externalPriceCents !== calc.priceCents) calc.setPrice(externalPriceCents);
        prevExternalRef.current = externalPriceCents;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        externalPriceCents
    ]);
    const handleSliderChange = (_, value)=>{
        const m = Array.isArray(value) ? value[0] : value;
        calc.setMargin(m);
        const newPrice = (0, $9ecafeb0572fff14$export$c35659abd6afdebb)(calc.referenceCents, m);
        onPriceChange?.(newPrice);
    };
    const handlePriceInput = (e)=>{
        const euros = parseFloat(e.target.value);
        if (isNaN(euros)) return;
        const cents = Math.round(euros * 100);
        calc.setPrice(cents);
        onPriceChange?.(cents);
    };
    const handleReferenceTypeChange = (_, newType)=>{
        if (!newType || newType === referenceType) return;
        onReferenceTypeChange?.(newType);
    };
    const refTypeLabel = $6114eefbdd4cb273$var$refTotalLabelFor(referenceType);
    const refTotalLabel = `Valor ref. total (${refTypeLabel})`;
    const refTotalTooltip = $6114eefbdd4cb273$var$refTotalTooltipFor(referenceType);
    const toggleDisabled = referenceLocked;
    const costButtonDisabled = !isAdmin;
    const helperBelowRef = referenceType === "COST" ? "Abaixo do custo \u2014 ajusta antes de guardar." : `Abaixo do valor de refer\xeancia ${refTypeLabel} \u{2014} ajusta antes de guardar.`;
    const helperOk = "Este \xe9 o \xfanico valor edit\xe1vel. Os pre\xe7os das linhas s\xe3o refer\xeancia de cat\xe1logo.";
    // PR 6a — IVA label is rounded for display. Math.round = half-away-from-zero.
    const vatPctDisplay = vatRate !== undefined ? Math.round(vatRate * 100) : undefined;
    const vatTooltipText = vatRegime ? `Regime: ${vatRegime}. IVA aplicado sobre o pre\xe7o final.` : "IVA aplicado sobre o pre\xe7o final.";
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Box), {
        sx: {
            border: "1px solid",
            borderColor: calc.isInvalid ? "error.main" : "divider",
            borderRadius: 2,
            p: 2,
            bgcolor: "background.paper"
        },
        children: [
            role !== undefined && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Box), {
                mb: 1.5,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1104ab3a8fa3c4f8$export$2e2bcd8739ae039), {
                    kpis: kpis,
                    role: role
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Box), {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 1.5,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Typography), {
                        variant: "subtitle2",
                        fontWeight: 700,
                        children: "Painel de margem"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Tooltip), {
                        title: toggleDisabled ? "Tipo de refer\xeancia trancado pela revis\xe3o anterior" : costButtonDisabled ? "A op\xe7\xe3o Custo s\xf3 est\xe1 dispon\xedvel para admin. REV4 \xe9 livre para todos." : "Escolhe o valor de refer\xeancia: Rev3, Rev4 ou Custo",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.ToggleButtonGroup), {
                                size: "small",
                                exclusive: true,
                                value: referenceType,
                                onChange: handleReferenceTypeChange,
                                disabled: toggleDisabled,
                                "aria-label": "Tipo de refer\xeancia",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.ToggleButton), {
                                        value: "REV3",
                                        "aria-label": "Rev3",
                                        children: "Rev3"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.ToggleButton), {
                                        value: "REV4",
                                        "aria-label": "Rev4",
                                        children: "Rev4"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.ToggleButton), {
                                        value: "COST",
                                        "aria-label": "Custo",
                                        disabled: costButtonDisabled,
                                        children: "Custo"
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Box), {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 1.5,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Tooltip), {
                        title: refTotalTooltip,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Box), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Typography), {
                                    variant: "caption",
                                    color: "text.secondary",
                                    children: refTotalLabel
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Typography), {
                                    variant: "body1",
                                    fontWeight: 600,
                                    children: [
                                        $6114eefbdd4cb273$var$formatCents(calc.referenceCents),
                                        " \u20AC"
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Chip), {
                        label: $6114eefbdd4cb273$var$ZONE_LABEL[zone],
                        color: $6114eefbdd4cb273$var$ZONE_COLOR[zone],
                        size: "small",
                        sx: {
                            fontWeight: 600
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Box), {
                mb: 1,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Typography), {
                        variant: "caption",
                        color: "text.secondary",
                        children: [
                            "Margem:",
                            " ",
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("strong", {
                                children: [
                                    calc.margin.toFixed(1),
                                    "% (\u20AC ",
                                    $6114eefbdd4cb273$var$formatEuros(calc.marginAbsCents),
                                    ")"
                                ]
                            }),
                            calc.intent === "price" && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    marginLeft: 6,
                                    fontSize: "0.7rem",
                                    color: "#888"
                                },
                                children: "(calculada pelo pre\xe7o final)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Slider), {
                        value: calc.margin,
                        min: 0,
                        max: 50,
                        step: 0.5,
                        marks: $6114eefbdd4cb273$var$SLIDER_MARKS,
                        onChange: handleSliderChange,
                        color: calc.isInvalid ? "error" : "primary",
                        sx: {
                            mt: 0.5,
                            mb: 0
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Box), {
                display: "flex",
                alignItems: "center",
                gap: 2,
                mt: 1.5,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Box), {
                        flex: 1,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Typography), {
                                variant: "caption",
                                color: "text.secondary",
                                children: [
                                    "Pre\xe7o Final da Proposta",
                                    " ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                        children: "(valor apresentado ao cliente)"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TextField), {
                                type: "number",
                                size: "small",
                                fullWidth: true,
                                value: $6114eefbdd4cb273$var$formatCents(calc.priceCents),
                                onChange: handlePriceInput,
                                error: calc.isInvalid,
                                helperText: calc.isInvalid ? helperBelowRef : helperOk,
                                inputProps: {
                                    min: 0,
                                    step: "0.01"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Box), {
                        textAlign: "right",
                        minWidth: 80,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Typography), {
                                variant: "caption",
                                color: "text.secondary",
                                children: "Rev4 m\xe9dio"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Typography), {
                                variant: "body1",
                                fontWeight: 600,
                                children: [
                                    calc.rev4Avg.toFixed(1),
                                    "%"
                                ]
                            })
                        ]
                    }),
                    vatPctDisplay !== undefined && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Tooltip), {
                        title: vatTooltipText,
                        arrow: true,
                        placement: "top",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Button), {
                            "data-testid": "price-panel-vat",
                            variant: "outlined",
                            size: "small",
                            "aria-label": `IVA: ${vatPctDisplay}%${vatRegime ? ` \u{2014} regime ${vatRegime}` : ""}`,
                            sx: {
                                minWidth: 0,
                                textTransform: "none",
                                fontWeight: 600,
                                py: 0.5,
                                px: 1
                            },
                            children: [
                                "IVA: ",
                                vatPctDisplay,
                                "%"
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $6114eefbdd4cb273$export$2e2bcd8739ae039 = $6114eefbdd4cb273$var$PricePanel;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

/**
 * Computes a shallow list of keys that differ between two objects of the same
 * type. Works for plain record-like objects (one level deep).
 */ function $0154b750eb7fdda7$var$shallowDirtyFields(initial, current) {
    const keys = new Set([
        ...Object.keys(initial),
        ...Object.keys(current)
    ]);
    const dirty = [];
    keys.forEach((k)=>{
        if (JSON.stringify(initial[k]) !== JSON.stringify(current[k])) dirty.push(k);
    });
    return dirty;
}
function $0154b750eb7fdda7$export$6e2bb77f56272282(initial) {
    const [initialValue, setInitialValue] = (0, $acw62.useState)(initial);
    const [currentValue, setCurrentValue] = (0, $acw62.useState)(initial);
    const [dialogOpen, setDialogOpen] = (0, $acw62.useState)(false);
    const onConfirmRef = (0, $acw62.useRef)(null);
    const isDirty = JSON.stringify(currentValue) !== JSON.stringify(initialValue);
    const dirtyFields = isDirty && typeof initialValue === "object" && initialValue !== null && typeof currentValue === "object" && currentValue !== null ? $0154b750eb7fdda7$var$shallowDirtyFields(initialValue, currentValue) : [];
    const reset = (0, $acw62.useCallback)((newInitial)=>{
        const v = newInitial !== undefined ? newInitial : initialValue;
        setInitialValue(v);
        setCurrentValue(v);
    }, [
        initialValue
    ]);
    const requestExit = (0, $acw62.useCallback)((onConfirm)=>{
        if (!isDirty) {
            onConfirm();
            return;
        }
        onConfirmRef.current = onConfirm;
        setDialogOpen(true);
    }, [
        isDirty
    ]);
    // Guard browser refresh / tab close when dirty.
    (0, $acw62.useEffect)(()=>{
        if (!isDirty) return;
        const handler = (e)=>{
            e.preventDefault();
            e.returnValue = "";
        };
        window.addEventListener("beforeunload", handler);
        return ()=>window.removeEventListener("beforeunload", handler);
    }, [
        isDirty
    ]);
    const handleDiscard = ()=>{
        setDialogOpen(false);
        onConfirmRef.current?.();
        onConfirmRef.current = null;
    };
    const handleKeep = ()=>{
        setDialogOpen(false);
        onConfirmRef.current = null;
    };
    const ExitGuardDialog = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Dialog), {
            open: dialogOpen,
            onClose: handleKeep,
            maxWidth: "xs",
            fullWidth: true,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.DialogTitle), {
                    children: "Altera\xe7\xf5es por guardar"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.DialogContent), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Typography), {
                            variant: "body2",
                            children: "Tens altera\xe7\xf5es por guardar. Se sa\xedres agora v\xe3o ser perdidas."
                        }),
                        dirtyFields.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Typography), {
                            variant: "caption",
                            color: "text.secondary",
                            sx: {
                                mt: 1,
                                display: "block"
                            },
                            children: [
                                "Campos alterados: ",
                                dirtyFields.join(", ")
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.DialogActions), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Button), {
                            onClick: handleKeep,
                            variant: "outlined",
                            color: "inherit",
                            children: "Cancelar"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Button), {
                            onClick: handleDiscard,
                            variant: "contained",
                            color: "error",
                            children: "Sair sem guardar"
                        })
                    ]
                })
            ]
        });
    return {
        isDirty: isDirty,
        dirtyFields: dirtyFields,
        currentValue: currentValue,
        setCurrentValue: setCurrentValue,
        reset: reset,
        requestExit: requestExit,
        ExitGuardDialog: ExitGuardDialog
    };
}



/**
 * ProposalItemsTable — presentational table for a proposal's items.
 *
 * Extracted from ProposalEditor (PR 0b) to keep ProposalEditor below
 * 500 lines and split orchestration from presentation. All state lives
 * in the parent; this component is purely controlled.
 */ 
var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $14b4fcb0e549e7b0$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $14b4fcb0e549e7b0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($14b4fcb0e549e7b0$exports, "__esModule", {
    value: true
});
$14b4fcb0e549e7b0$exports.default = void 0;

var $14b4fcb0e549e7b0$var$_createSvgIcon = $14b4fcb0e549e7b0$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $14b4fcb0e549e7b0$var$_default = $14b4fcb0e549e7b0$exports.default = (0, $14b4fcb0e549e7b0$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z"
}), 'Delete');


var $570fd50501d08ed5$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $570fd50501d08ed5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($570fd50501d08ed5$exports, "__esModule", {
    value: true
});
$570fd50501d08ed5$exports.default = void 0;

var $570fd50501d08ed5$var$_createSvgIcon = $570fd50501d08ed5$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $570fd50501d08ed5$var$_default = $570fd50501d08ed5$exports.default = (0, $570fd50501d08ed5$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
}), 'Add');



/**
 * DriftChip — compact inline indicator shown next to items that have drift.
 *
 * PR 6b Phase 2. Renders nothing when severity is undefined/null so callers
 * can always render <DriftChip severity={…} onClick={…} /> without checking.
 *
 * Severity → colour/label mapping:
 *   minor         → warning (amber)   label "Drift"
 *   major         → error (red)       label "Drift"
 *   orphan        → error outlined    label "Drift"   (item gone from catalog)
 *   indeterminate → default           label "?"       (catalog service unavailable)
 */ 
var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

const $702833c222b0b356$var$INDETERMINATE_TOOLTIP = "Drift indeterminado \u2014 servi\xe7o de cat\xe1logo indispon\xedvel";
const $702833c222b0b356$var$DriftChip = ({ severity: severity, onClick: onClick })=>{
    if (!severity) return null;
    if (severity === "indeterminate") return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Tooltip), {
        title: $702833c222b0b356$var$INDETERMINATE_TOOLTIP,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Chip), {
            label: "?",
            size: "small",
            color: "default",
            onClick: onClick,
            clickable: true,
            role: "button",
            "aria-label": $702833c222b0b356$var$INDETERMINATE_TOOLTIP,
            "data-testid": "drift-chip-indeterminate",
            sx: {
                ml: 0.5,
                cursor: "pointer"
            }
        })
    });
    const colorMap = {
        minor: "warning",
        major: "error",
        orphan: "error"
    };
    const ariaLabelMap = {
        minor: "Drift menor detectado",
        major: "Drift maior detectado",
        orphan: "Item n\xe3o encontrado no cat\xe1logo"
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Chip), {
        label: "Drift",
        size: "small",
        color: colorMap[severity],
        variant: severity === "orphan" ? "outlined" : "filled",
        onClick: onClick,
        clickable: true,
        role: "button",
        "aria-label": ariaLabelMap[severity],
        "data-testid": `drift-chip-${severity}`,
        sx: {
            ml: 0.5,
            cursor: "pointer"
        }
    });
};
var $702833c222b0b356$export$2e2bcd8739ae039 = $702833c222b0b356$var$DriftChip;


function $f1fe53460611102d$var$formatCents(cents) {
    return (cents / 100).toFixed(2);
}
const $f1fe53460611102d$var$ProposalItemsTable = ({ items: items, searchValues: searchValues, setSearchValues: setSearchValues, updateItem: updateItem, removeItem: removeItem, addItem: addItem, driftItems: driftItems, onDriftClick: onDriftClick, isAdmin: isAdmin = false })=>{
    const totalRev4 = items.reduce((sum, i)=>sum + (i.rev4_cents ?? 0) * i.quantity, 0);
    const totalPvp = items.reduce((sum, i)=>sum + i.pvp_cents * i.quantity, 0);
    const totalCost = items.reduce((sum, i)=>sum + i.cost_cents * i.quantity, 0);
    const hasEmptyRow = items.some((i)=>!i.product_id);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Table), {
                size: "small",
                sx: {
                    mb: 1
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableHead), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.TableRow), {
                            sx: {
                                "& th": {
                                    fontWeight: 700,
                                    bgcolor: "#f5f5f5"
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                    sx: {
                                        width: 160
                                    },
                                    children: "Tipo (slot)"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                    sx: {
                                        minWidth: 220
                                    },
                                    children: "Produto"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                    align: "right",
                                    sx: {
                                        width: 70
                                    },
                                    children: "Qty"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                    align: "right",
                                    sx: {
                                        width: 110
                                    },
                                    children: "Rev4 (\u20AC)"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                    align: "right",
                                    sx: {
                                        width: 110
                                    },
                                    children: "PVP cat\xe1logo (\u20AC)"
                                }),
                                isAdmin && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                    align: "right",
                                    sx: {
                                        width: 110
                                    },
                                    children: "Custo (\u20AC)"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                    sx: {
                                        width: 48
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableBody), {
                        children: items.map((item)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.TableRow), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.FormControl), {
                                            size: "small",
                                            fullWidth: true,
                                            variant: "standard",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Select), {
                                                value: item.component_type ?? "",
                                                displayEmpty: true,
                                                onChange: (e)=>{
                                                    updateItem(item._localId, {
                                                        component_type: e.target.value || undefined,
                                                        // Clear product when slot changes so filter applies correctly
                                                        product_id: "",
                                                        name: "",
                                                        rev4_cents: undefined,
                                                        pvp_cents: 0,
                                                        cost_cents: 0
                                                    });
                                                    setSearchValues((prev)=>({
                                                            ...prev,
                                                            [item._localId]: ""
                                                        }));
                                                },
                                                sx: {
                                                    fontSize: 13
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.MenuItem), {
                                                        value: "",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("em", {
                                                            children: "\u2014 sem tipo \u2014"
                                                        })
                                                    }),
                                                    Object.keys((0, $cdfd57be71fcf6f6$export$da71685f71dc8f28)).map((ct)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.MenuItem), {
                                                            value: ct,
                                                            sx: {
                                                                fontSize: 13
                                                            },
                                                            children: ct
                                                        }, ct))
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.TableCell), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cdfd57be71fcf6f6$export$2e2bcd8739ae039), {
                                                value: searchValues[item._localId] ?? item.product_id,
                                                onChange: (v)=>setSearchValues((prev)=>({
                                                            ...prev,
                                                            [item._localId]: v
                                                        })),
                                                onSelect: (p)=>{
                                                    updateItem(item._localId, {
                                                        product_id: p.id,
                                                        name: p.name,
                                                        component_type: item.component_type,
                                                        rev4_cents: Math.round((p.rev4_price ?? 0) * 100),
                                                        rev3_cents: Math.round((p.rev3_price ?? 0) * 100),
                                                        pvp_cents: Math.round((p.pvp_price ?? p.rev4_price ?? 0) * 100),
                                                        cost_cents: Math.round(p.cost_price * 100),
                                                        stock: p.stock ?? undefined
                                                    });
                                                    setSearchValues((prev)=>({
                                                            ...prev,
                                                            [item._localId]: p.id
                                                        }));
                                                },
                                                componentType: item.component_type,
                                                placeholder: "Ref. produto\u2026"
                                            }),
                                            item.name && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Typography), {
                                                variant: "caption",
                                                color: "text.secondary",
                                                children: item.name
                                            }),
                                            item.product_id && item.stock !== undefined && item.stock === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Tooltip), {
                                                title: "Produto sem stock dispon\xedvel no cat\xe1logo",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Chip), {
                                                    label: "Sem stock",
                                                    size: "small",
                                                    role: "img",
                                                    "aria-label": "Produto sem stock dispon\xedvel",
                                                    "data-testid": `no-stock-${item.product_id}`,
                                                    sx: {
                                                        bgcolor: "#DC2626",
                                                        color: "white",
                                                        fontWeight: 600,
                                                        height: 18,
                                                        fontSize: 10
                                                    }
                                                })
                                            }),
                                            item.product_id && item.rev3_cents !== undefined && item.rev3_cents === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Tooltip), {
                                                title: "Este produto n\xe3o tem pre\xe7o Rev3 definido no cat\xe1logo",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Chip), {
                                                    label: "Sem Rev3",
                                                    size: "small",
                                                    role: "img",
                                                    "aria-label": "Produto sem pre\xe7o Rev3 definido no cat\xe1logo",
                                                    "data-testid": `no-rev3-${item.product_id}`,
                                                    sx: {
                                                        bgcolor: "#D97706",
                                                        color: "white",
                                                        fontWeight: 600,
                                                        height: 18,
                                                        fontSize: 10,
                                                        ml: 0.5
                                                    }
                                                })
                                            }),
                                            driftItems && driftItems.some((d)=>d.compound_id === item.product_id) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $702833c222b0b356$export$2e2bcd8739ae039), {
                                                severity: driftItems.find((d)=>d.compound_id === item.product_id)?.severity,
                                                onClick: ()=>onDriftClick?.()
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                        align: "right",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TextField), {
                                            type: "number",
                                            size: "small",
                                            value: item.quantity,
                                            inputProps: {
                                                min: 1,
                                                style: {
                                                    textAlign: "right",
                                                    width: 50
                                                }
                                            },
                                            onChange: (e)=>updateItem(item._localId, {
                                                    quantity: Math.max(1, parseInt(e.target.value, 10) || 1)
                                                }),
                                            variant: "standard"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                        align: "right",
                                        sx: {
                                            color: "text.secondary"
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Tooltip), {
                                            title: "Pre\xe7o Rev4 de cat\xe1logo (refer\xeancia, s\xf3 leitura)",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: item.rev4_cents != null ? $f1fe53460611102d$var$formatCents(item.rev4_cents) : "\u2014"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                        align: "right",
                                        sx: {
                                            color: "text.secondary"
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Tooltip), {
                                            title: "PVP de cat\xe1logo (refer\xeancia, s\xf3 leitura). O pre\xe7o final da proposta \xe9 definido no painel abaixo.",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: item.pvp_cents > 0 ? $f1fe53460611102d$var$formatCents(item.pvp_cents) : "\u2014"
                                            })
                                        })
                                    }),
                                    isAdmin && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                        align: "right",
                                        sx: {
                                            color: "text.secondary"
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Tooltip), {
                                            title: "Custo de cat\xe1logo (s\xf3 leitura)",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                children: [
                                                    $f1fe53460611102d$var$formatCents(item.cost_cents),
                                                    " \u20AC"
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.IconButton), {
                                            size: "small",
                                            onClick: ()=>removeItem(item._localId),
                                            disabled: items.length === 1,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($14b4fcb0e549e7b0$exports))), {
                                                fontSize: "small"
                                            })
                                        })
                                    })
                                ]
                            }, item._localId))
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableFooter), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.TableRow), {
                            sx: {
                                "& td": {
                                    fontWeight: 700,
                                    bgcolor: "#f5f5f5"
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                    sx: {
                                        width: 160
                                    },
                                    colSpan: 3,
                                    children: "Total"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                    align: "right",
                                    sx: {
                                        width: 110
                                    },
                                    children: $f1fe53460611102d$var$formatCents(totalRev4)
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                    align: "right",
                                    sx: {
                                        width: 110
                                    },
                                    children: $f1fe53460611102d$var$formatCents(totalPvp)
                                }),
                                isAdmin && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                    align: "right",
                                    sx: {
                                        width: 110
                                    },
                                    children: $f1fe53460611102d$var$formatCents(totalCost)
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                    sx: {
                                        width: 48
                                    }
                                })
                            ]
                        })
                    })
                ]
            }),
            hasEmptyRow && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Box), {
                sx: {
                    bgcolor: "#fff3e0",
                    border: "1px solid #ffb74d",
                    borderRadius: 1,
                    px: 1.5,
                    py: 0.5,
                    mb: 1
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Typography), {
                    variant: "caption",
                    color: "warning.main",
                    children: "\u26A0 Linhas sem produto ser\xe3o ignoradas ao guardar."
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Box), {
                display: "flex",
                gap: 1,
                mb: 2,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Button), {
                    startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($570fd50501d08ed5$exports))), {}),
                    size: "small",
                    variant: "outlined",
                    onClick: addItem,
                    children: "Adicionar linha"
                })
            })
        ]
    });
};
var $f1fe53460611102d$export$2e2bcd8739ae039 = $f1fe53460611102d$var$ProposalItemsTable;


/**
 * ProposalEditorActions — notes textarea + error alert + Cancel/Save buttons.
 *
 * Extracted from ProposalEditor (PR 0b). Purely controlled.
 */ 
var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

const $eb020dcc1394e0a2$var$ProposalEditorActions = ({ notes: notes, setNotes: setNotes, error: error, saving: saving, onCancel: onCancel, handleCancel: handleCancel, handleSave: handleSave })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TextField), {
                label: "Notas internas",
                multiline: true,
                minRows: 2,
                maxRows: 5,
                fullWidth: true,
                size: "small",
                value: notes,
                onChange: (e)=>setNotes(e.target.value),
                sx: {
                    mb: 2
                },
                placeholder: "Observa\xe7\xf5es vis\xedveis apenas internamente\u2026"
            }),
            error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Alert), {
                severity: "error",
                sx: {
                    mb: 1
                },
                children: error
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Box), {
                display: "flex",
                gap: 1,
                justifyContent: "flex-end",
                children: [
                    onCancel && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Button), {
                        variant: "outlined",
                        color: "inherit",
                        onClick: handleCancel,
                        disabled: saving,
                        children: "Cancelar"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Button), {
                        variant: "contained",
                        color: "primary",
                        onClick: handleSave,
                        disabled: saving,
                        startIcon: saving ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.CircularProgress), {
                            size: 16,
                            color: "inherit"
                        }) : undefined,
                        children: saving ? "A guardar\u2026" : "Guardar rascunho"
                    })
                ]
            })
        ]
    });
var $eb020dcc1394e0a2$export$2e2bcd8739ae039 = $eb020dcc1394e0a2$var$ProposalEditorActions;


/**
 * DriftInspectorDrawer — right-side drawer showing the full drift report for a
 * proposal revision.
 *
 * PR 6b Phase 2. Role-aware:
 *   - "admin"     → sees cost, rev3, name fields
 *   - "comercial" → sees rev3, name only — cost is NEVER rendered
 *
 * Strategy actions at the bottom of each compound group:
 *   accept_current      — adopt live catalog values
 *   create_new_revision — copy proposal into a new revision with live values
 *   keep_snapshot       — record an explicit "accepted as-is" decision
 *
 * Accessibility: focus trap via MUI Drawer, ESC closes (onClose), aria-label
 * on drawer root, close button with aria-label.
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $9c5eb05f9740712a$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $9c5eb05f9740712a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($9c5eb05f9740712a$exports, "__esModule", {
    value: true
});
$9c5eb05f9740712a$exports.default = void 0;

var $9c5eb05f9740712a$var$_createSvgIcon = $9c5eb05f9740712a$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $9c5eb05f9740712a$var$_default = $9c5eb05f9740712a$exports.default = (0, $9c5eb05f9740712a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');


var $1c8ff95a3ff850ab$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $1c8ff95a3ff850ab$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($1c8ff95a3ff850ab$exports, "__esModule", {
    value: true
});
$1c8ff95a3ff850ab$exports.default = void 0;

var $1c8ff95a3ff850ab$var$_createSvgIcon = $1c8ff95a3ff850ab$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $1c8ff95a3ff850ab$var$_default = $1c8ff95a3ff850ab$exports.default = (0, $1c8ff95a3ff850ab$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4z"
}), 'Refresh');


/**
 * PR 6b — Phase 1 — Drift API service module.
 *
 * Module-level functions (ADR-6b §A1) that wrap the OMS drift endpoints
 * exposed via api-gw under `/oms/admin/orders/:id/proposal/{drift,
 * refresh-drift, resolve-drift}`. All functions:
 *
 *   - Take the axios singleton from `hooks/api.tsx` (Accept-Version is
 *     injected by the interceptor, callers don't pass it).
 *   - Return typed payloads from `model/Proposal.ts` on success.
 *   - Reject with a typed `ApiError` (helpers/apiErrors.ts) on failure —
 *     never a raw AxiosError, so UI switch statements stay exhaustive.
 *
 * Naming convention: `*Api.ts` for service modules in `helpers/` (matches
 * `proposalApi.ts`). Not React-aware — usable from any layer.
 *
 * Backend routes (OMS Go, `cmd/server/main.go:266-268`):
 *   GET    /admin/orders/:id/proposal/drift          → GetProposalDrift
 *   POST   /admin/orders/:id/proposal/refresh-drift  → RefreshProposalDrift
 *   POST   /admin/orders/:id/proposal/resolve-drift  → ResolveProposalDrift
 *
 * The `X-Bulk-Accept-All: true` header on resolve is the wire contract
 * (NOT a body field); we expose it as a parameter so callers don't have
 * to remember the header name.
 *
 * See ADR-6b §C1 (optimistic toggle + revert) and §E1 (Alert inline
 * feedback) for UI-side semantics.
 */ 
/**
 * PR 6b — Phase 1 — Typed API error envelope.
 *
 * Bridges raw `AxiosError` instances from OMS calls into a discriminated
 * `ApiError` union the UI can switch on. Centralised here so every service
 * (`driftApi.ts`, future ones) maps errors the same way and UI components
 * don't need to spelunk into `error.response.data.error` strings.
 *
 * Backend reference: OMS Go handlers in
 * `microservices/oms-microservice/internal/handler/admin_proposal.go` always
 * respond with `{ "error": "<code>", "detail"?: "<human>" }` (see
 * `respondJSON` patterns at e.g. lines 134, 491, 537, 542). Status code
 * partitioning:
 *
 *   400  — validation / malformed body
 *   401  — token missing/expired (auth interceptor in `api.tsx` handles re-login)
 *   403  — forbidden (RBAC, e.g. comercial requesting admin field)
 *   404  — order/revision not found
 *   406  — `Accept-Version` mismatch
 *   409  — domain conflict (`invalid_status_transition`, `margin_at_risk_blocked`,
 *          `reference_type_forbidden_for_role` lives as 403 — keep both)
 *   422  — semantic validation (e.g. justification too short)
 *   429  — rate-limited
 *   5xx  — server / network
 *
 * Network-level failures (no response object: timeout, DNS, offline) map to
 * `{ kind: "network" }`.
 *
 * Convention: callers use `if (err.kind === "..." )` not instanceof. The
 * raw AxiosError is preserved as `.raw` for debugging / Sentry reporting,
 * but UI MUST NOT branch on it.
 */ 
function $1dc90ddccfa14c0f$export$4a49f4fbe4e62fe9(err) {
    // Non-AxiosError shouldn't reach here in practice (services always axios),
    // but be defensive: wrap as network so the UI shows a generic message.
    if (!(err instanceof (0, $b302555736d21bd7$export$c1fbed17c2f6a328))) return {
        kind: "network",
        detail: err instanceof Error ? err.message : "unknown error",
        raw: new (0, $b302555736d21bd7$export$c1fbed17c2f6a328)(err instanceof Error ? err.message : "unknown error")
    };
    // No response → DNS, timeout, offline, CORS-pre-flight failure.
    if (!err.response) return {
        kind: "network",
        detail: err.message,
        raw: err
    };
    const status = err.response.status;
    const body = err.response.data ?? {};
    const code = typeof body.error === "string" ? body.error : undefined;
    const detail = typeof body.detail === "string" ? body.detail : undefined;
    let kind;
    switch(status){
        case 400:
            kind = "validation";
            break;
        case 401:
            kind = "unauthorized";
            break;
        case 403:
            kind = "forbidden";
            break;
        case 404:
            kind = "not_found";
            break;
        case 406:
            kind = "version_mismatch";
            break;
        case 409:
            kind = "conflict";
            break;
        case 422:
            kind = "unprocessable";
            break;
        case 429:
            kind = "rate_limited";
            break;
        default:
            kind = status >= 500 ? "server" : "server";
            break;
    }
    return {
        kind: kind,
        code: code,
        detail: detail,
        status: status,
        raw: err
    };
}
function $1dc90ddccfa14c0f$export$177538dcce53db3a(err) {
    if (err.detail) return err.detail;
    switch(err.kind){
        case "validation":
            return "Pedido inv\xe1lido.";
        case "unauthorized":
            return "Sess\xe3o expirada. Refaz o login.";
        case "forbidden":
            return "Sem permiss\xe3o para esta ac\xe7\xe3o.";
        case "not_found":
            return "N\xe3o encontrado.";
        case "version_mismatch":
            return "Vers\xe3o da API incompat\xedvel. Recarrega a p\xe1gina.";
        case "conflict":
            return "Conflito de estado. Refresca e tenta de novo.";
        case "unprocessable":
            return "Dados insuficientes ou inv\xe1lidos.";
        case "rate_limited":
            return "Demasiados pedidos. Aguarda alguns segundos.";
        case "server":
            return "Erro do servidor. Tenta de novo.";
        case "network":
            return "Sem liga\xe7\xe3o. Verifica a rede.";
    }
}
function $1dc90ddccfa14c0f$export$d6cf8ca521a17a2(e, fallback) {
    if (typeof e === "object" && e !== null) {
        // AxiosError shape: response.data.error
        if ("response" in e) {
            const resp = e.response;
            if (resp?.data?.error) return resp.data.error;
        }
        // Standard Error
        if (e instanceof Error) return e.message;
    }
    return fallback;
}


const $72613ec719b3b46e$var$OMS_ORDERS_PREFIX = "/oms/admin/orders";
async function $72613ec719b3b46e$export$904759e95ee82bc(orderId) {
    try {
        const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get(`${$72613ec719b3b46e$var$OMS_ORDERS_PREFIX}/${encodeURIComponent(orderId)}/proposal/drift`);
        return res.data;
    } catch (err) {
        throw (0, $1dc90ddccfa14c0f$export$4a49f4fbe4e62fe9)(err);
    }
}
async function $72613ec719b3b46e$export$d1ded74a02156a87(orderId) {
    try {
        const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).post(`${$72613ec719b3b46e$var$OMS_ORDERS_PREFIX}/${encodeURIComponent(orderId)}/proposal/refresh-drift`);
        return res.data;
    } catch (err) {
        throw (0, $1dc90ddccfa14c0f$export$4a49f4fbe4e62fe9)(err);
    }
}
async function $72613ec719b3b46e$export$f5ff760e5f5b4624(orderId, body, opts = {}) {
    try {
        const headers = {};
        if (opts.bulkAcceptAll) headers["X-Bulk-Accept-All"] = "true";
        const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).post(`${$72613ec719b3b46e$var$OMS_ORDERS_PREFIX}/${encodeURIComponent(orderId)}/proposal/resolve-drift`, body, {
            headers: headers
        });
        return res.data;
    } catch (err) {
        throw (0, $1dc90ddccfa14c0f$export$4a49f4fbe4e62fe9)(err);
    }
}
function $72613ec719b3b46e$export$89d83cc97c52a37(value) {
    return typeof value === "object" && value !== null && "kind" in value && "raw" in value;
}



// ── Helpers ──────────────────────────────────────────────────────────────────
function $2236ebc33ab65f2a$var$formatCentValue(val) {
    if (val === undefined || val === null) return "\u2014";
    const num = typeof val === "string" ? parseFloat(val) : val;
    if (isNaN(num)) return String(val);
    return (num / 100).toFixed(2) + " \u20AC";
}
function $2236ebc33ab65f2a$var$formatDelta(delta) {
    if (delta === undefined || delta === null) return "";
    const pct = delta * 100;
    const sign = pct >= 0 ? "+" : "";
    return `${sign}${pct.toFixed(1)}%`;
}
const $2236ebc33ab65f2a$var$FIELD_LABELS = {
    cost: "Custo",
    rev3: "Rev3",
    name: "Nome"
};
function $2236ebc33ab65f2a$var$severityColor(sev) {
    switch(sev){
        case "minor":
            return "warning";
        case "major":
            return "error";
        case "orphan":
            return "error";
        case "indeterminate":
            return "default";
    }
}
function $2236ebc33ab65f2a$var$severityLabel(sev) {
    return sev === "indeterminate" ? "?" : "Drift";
}
const $2236ebc33ab65f2a$var$DriftItemRow = ({ item: item, role: role })=>{
    // Role filter: comercial never sees cost field
    if (item.field === "cost" && role !== "admin") return null;
    const isOrphanOrIndet = item.severity === "orphan" || item.severity === "indeterminate";
    let deltaDisplay;
    if (item.severity === "orphan") deltaDisplay = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Typography), {
        variant: "caption",
        color: "text.secondary",
        children: "Item n\xe3o encontrado no cat\xe1logo"
    });
    else if (item.severity === "indeterminate") deltaDisplay = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Typography), {
        variant: "caption",
        color: "text.secondary",
        children: "Indeterminado"
    });
    else if (item.field === "name") // name drift: show old → new text, no delta_pct
    deltaDisplay = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Typography), {
        variant: "caption",
        color: "text.secondary",
        children: [
            String(item.snapshot_val),
            " \u2192 ",
            String(item.current_val ?? "\u2014")
        ]
    });
    else {
        const delta = $2236ebc33ab65f2a$var$formatDelta(item.delta_pct);
        deltaDisplay = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Typography), {
            variant: "caption",
            color: item.severity === "major" ? "error.main" : item.severity === "minor" ? "warning.main" : "text.secondary",
            sx: {
                fontWeight: 600
            },
            children: [
                $2236ebc33ab65f2a$var$formatCentValue(item.snapshot_val),
                " \u2192",
                " ",
                $2236ebc33ab65f2a$var$formatCentValue(item.current_val),
                " ",
                delta && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    children: [
                        "(",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            style: {
                                color: item.delta_pct > 0 ? "#B45309" : item.delta_pct < 0 ? "#0369A1" : undefined
                            },
                            children: delta
                        }),
                        ")"
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Box), {
        sx: {
            display: "flex",
            alignItems: "flex-start",
            gap: 1,
            py: 0.5
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Chip), {
                label: $2236ebc33ab65f2a$var$severityLabel(item.severity),
                size: "small",
                color: $2236ebc33ab65f2a$var$severityColor(item.severity),
                variant: item.severity === "orphan" ? "outlined" : "filled",
                sx: {
                    minWidth: 48,
                    flexShrink: 0
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Box), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Typography), {
                        variant: "caption",
                        sx: {
                            fontWeight: 700,
                            mr: 0.5
                        },
                        children: [
                            $2236ebc33ab65f2a$var$FIELD_LABELS[item.field] ?? item.field,
                            !isOrphanOrIndet && ":"
                        ]
                    }),
                    deltaDisplay
                ]
            })
        ]
    });
};
const $2236ebc33ab65f2a$var$ResolveActions = ({ resolving: resolving, onResolve: onResolve })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Stack), {
        direction: "row",
        spacing: 1,
        flexWrap: "wrap",
        useFlexGap: true,
        sx: {
            mt: 1
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Button), {
                size: "small",
                variant: "outlined",
                color: "success",
                disabled: resolving,
                onClick: ()=>onResolve("accept_current"),
                "aria-label": "Aceitar valores actuais do cat\xe1logo",
                children: [
                    resolving ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.CircularProgress), {
                        size: 14,
                        sx: {
                            mr: 0.5
                        }
                    }) : null,
                    "Aceitar valores actuais"
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Button), {
                size: "small",
                variant: "outlined",
                color: "primary",
                disabled: resolving,
                onClick: ()=>onResolve("create_new_revision"),
                "aria-label": "Criar nova revis\xe3o com valores actuais",
                children: "Criar nova revis\xe3o"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Button), {
                size: "small",
                variant: "outlined",
                color: "warning",
                disabled: resolving,
                onClick: ()=>onResolve("keep_snapshot"),
                "aria-label": "Manter valores do snapshot actual",
                children: "Manter snapshot"
            })
        ]
    });
const $2236ebc33ab65f2a$var$DriftInspectorDrawer = ({ open: open, onClose: onClose, orderId: orderId, revisionVersion: revisionVersion, role: role, onResolved: onResolved })=>{
    const [loadState, setLoadState] = (0, $acw62.useState)("idle");
    const [report, setReport] = (0, $acw62.useState)(null);
    const [apiError, setApiError] = (0, $acw62.useState)(null);
    const [refreshing, setRefreshing] = (0, $acw62.useState)(false);
    const [resolving, setResolving] = (0, $acw62.useState)(false);
    const [resolveError, setResolveError] = (0, $acw62.useState)(null);
    const load = (0, $acw62.useCallback)(async ()=>{
        setLoadState("loading");
        setApiError(null);
        setResolveError(null);
        try {
            const data = await (0, $72613ec719b3b46e$export$904759e95ee82bc)(orderId);
            setReport(data);
            setLoadState("success");
        } catch (err) {
            setApiError(err);
            setLoadState("error");
        }
    }, [
        orderId
    ]);
    // Fetch when drawer opens
    (0, $acw62.useEffect)(()=>{
        if (open) load();
        else {
            // Reset on close so next open shows fresh loading state
            setLoadState("idle");
            setReport(null);
            setApiError(null);
            setResolveError(null);
        }
    }, [
        open,
        load
    ]);
    const handleRefresh = async ()=>{
        setRefreshing(true);
        setApiError(null);
        try {
            const data = await (0, $72613ec719b3b46e$export$d1ded74a02156a87)(orderId);
            setReport(data);
            setLoadState("success");
        } catch (err) {
            setApiError(err);
            setLoadState("error");
        } finally{
            setRefreshing(false);
        }
    };
    const handleResolve = async (strategy)=>{
        setResolving(true);
        setResolveError(null);
        try {
            const res = await (0, $72613ec719b3b46e$export$f5ff760e5f5b4624)(orderId, {
                strategy: strategy
            });
            onResolved(res);
        } catch (err) {
            setResolveError(err);
        } finally{
            setResolving(false);
        }
    };
    // Group drift items by compound_id
    const grouped = new Map();
    if (report?.items) for (const item of report.items){
        const arr = grouped.get(item.compound_id) ?? [];
        arr.push(item);
        grouped.set(item.compound_id, arr);
    }
    // ── Drawer content ──────────────────────────────────────────────────────────
    const renderContent = ()=>{
        if (loadState === "loading") return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Stack), {
            spacing: 2,
            sx: {
                p: 2
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Skeleton), {
                    variant: "rectangular",
                    height: 48
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Skeleton), {
                    variant: "rectangular",
                    height: 48
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Skeleton), {
                    variant: "rectangular",
                    height: 48
                })
            ]
        });
        if (loadState === "error" && apiError) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Box), {
            sx: {
                p: 2
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Alert), {
                severity: "error",
                action: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Button), {
                    size: "small",
                    color: "inherit",
                    onClick: load,
                    "aria-label": "Tentar novamente carregar drift",
                    children: "Tentar novamente"
                }),
                children: (0, $1dc90ddccfa14c0f$export$177538dcce53db3a)(apiError)
            })
        });
        if (loadState === "success" && report) {
            if (report.items.length === 0) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Box), {
                sx: {
                    p: 2
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Alert), {
                        severity: "success",
                        sx: {
                            mb: 2
                        },
                        children: "Sem drift detectado \u2014 todos os pre\xe7os est\xe3o actualizados."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Button), {
                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1c8ff95a3ff850ab$exports))), {}),
                        size: "small",
                        variant: "outlined",
                        onClick: handleRefresh,
                        disabled: refreshing,
                        "aria-label": "Refrescar an\xe1lise de drift",
                        children: refreshing ? "A refrescar\u2026" : "Refrescar"
                    })
                ]
            });
            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Box), {
                sx: {
                    p: 2
                },
                children: [
                    Array.from(grouped.entries()).map(([compoundId, items], idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Box), {
                            children: [
                                idx > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Divider), {
                                    sx: {
                                        my: 1.5
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Typography), {
                                    variant: "subtitle2",
                                    sx: {
                                        fontWeight: 700,
                                        mb: 0.5,
                                        fontFamily: "monospace"
                                    },
                                    children: compoundId
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Stack), {
                                    spacing: 0.25,
                                    children: items.map((item, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($2236ebc33ab65f2a$var$DriftItemRow, {
                                            item: item,
                                            role: role
                                        }, `${item.field}-${i}`))
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($2236ebc33ab65f2a$var$ResolveActions, {
                                    orderId: orderId,
                                    resolving: resolving,
                                    onResolve: handleResolve
                                })
                            ]
                        }, compoundId)),
                    resolveError && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Alert), {
                        severity: "error",
                        sx: {
                            mt: 2
                        },
                        children: (0, $1dc90ddccfa14c0f$export$177538dcce53db3a)(resolveError)
                    })
                ]
            });
        }
        return null;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Drawer), {
        anchor: "right",
        open: open,
        onClose: onClose,
        "aria-label": "Inspetor de drift",
        PaperProps: {
            sx: {
                width: 480,
                display: "flex",
                flexDirection: "column"
            }
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Box), {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    px: 2,
                    py: 1.5,
                    borderBottom: "1px solid",
                    borderColor: "divider",
                    flexShrink: 0
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Box), {
                        sx: {
                            flex: 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Typography), {
                                variant: "h6",
                                component: "h2",
                                children: "Inspetor de Drift"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Typography), {
                                variant: "caption",
                                color: "text.secondary",
                                children: [
                                    "Ordem ",
                                    orderId,
                                    " \xb7 Revis\xe3o ",
                                    revisionVersion
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Tooltip), {
                        title: "Refrescar",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.IconButton), {
                                size: "small",
                                onClick: handleRefresh,
                                disabled: refreshing || loadState === "loading",
                                "aria-label": "Refrescar an\xe1lise de drift",
                                sx: {
                                    mr: 0.5
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1c8ff95a3ff850ab$exports))), {
                                    fontSize: "small"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.IconButton), {
                        size: "small",
                        onClick: onClose,
                        "aria-label": "Fechar inspetor de drift",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9c5eb05f9740712a$exports))), {
                            fontSize: "small"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Box), {
                sx: {
                    flex: 1,
                    overflowY: "auto"
                },
                children: renderContent()
            })
        ]
    });
};
var $2236ebc33ab65f2a$export$2e2bcd8739ae039 = $2236ebc33ab65f2a$var$DriftInspectorDrawer;


function $db59d5920f132b30$var$newEmptyItem() {
    return {
        _localId: crypto.randomUUID(),
        product_id: "",
        name: "",
        pvp_cents: 0,
        cost_cents: 0,
        quantity: 1
    };
}
function $db59d5920f132b30$var$formatCents(cents) {
    return (cents / 100).toFixed(2);
}
const $db59d5920f132b30$var$ProposalEditor = ({ orderId: orderId, currentVersion: currentVersion, initialItems: initialItems = [], initialNotes: initialNotes = "", initialReferenceType: initialReferenceType, onSaved: onSaved, onCancel: onCancel })=>{
    const { profile: profile } = (0, $b622ef53e38024e7$export$1d39dc5b47e56ff0)();
    const [isAdmin, setIsAdmin] = (0, $acw62.useState)(false);
    // PR 6a Phase 6 — proposal role derived from the same Profile that drives
    // isAdmin. Invariant R1: this role MUST match the role used to build any
    // ProposalResponse passed downstream. Default "comercial" until profile
    // resolves — never escalates to admin by accident.
    const [proposalRole, setProposalRole] = (0, $acw62.useState)("comercial");
    (0, $acw62.useEffect)(()=>{
        profile().then((p)=>{
            setIsAdmin(p.isAdmin?.() ?? false);
            // ProfileAndSettings nests the actual Profile (with .roles) under .profile.
            setProposalRole((0, $632e0f20877ec90f$export$d4865dbdffbac6c1)(p.profile));
        }).catch(()=>{
            setIsAdmin(false);
            setProposalRole("comercial");
        });
    }, [
        profile
    ]);
    // F2-VR: reference type state. Default REV3 for all revisions without a
    // persisted reference_type (new AND legacy). Comercial never has cost_cents,
    // so defaulting to COST for legacy/pre-filled revisions causes 0.00 € in the
    // reference total. REV3 is the safe default for every role.
    const initialRefType = initialReferenceType ?? "REV3";
    const [referenceType, setReferenceType] = (0, $acw62.useState)(initialRefType);
    // F2-VR: COMMERCIAL users cannot switch reference type away from COST on
    // revisions that were originally created in COST mode (admin-only).
    const referenceLocked = !isAdmin && initialReferenceType === "COST";
    const [items, setItems] = (0, $acw62.useState)(initialItems.length > 0 ? initialItems.map((i)=>({
            ...i,
            _localId: crypto.randomUUID()
        })) : [
        $db59d5920f132b30$var$newEmptyItem()
    ]);
    const [notes, setNotes] = (0, $acw62.useState)(initialNotes);
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    // Task 7.3 — stale_version conflict dialog state
    const [staleVersionOpen, setStaleVersionOpen] = (0, $acw62.useState)(false);
    const [serverRevision, setServerRevision] = (0, $acw62.useState)(null);
    const [forcedVersion, setForcedVersion] = (0, $acw62.useState)(null);
    // Task 7.3 — stale_item_price dialog state
    const [staleItemsOpen, setStaleItemsOpen] = (0, $acw62.useState)(false);
    const [staleItems, setStaleItems] = (0, $acw62.useState)([]);
    const [pendingForceSave, setPendingForceSave] = (0, $acw62.useState)(false);
    const [searchValues, setSearchValues] = (0, $acw62.useState)({});
    // PR 6b Phase 2 — drift drawer state
    const [driftDrawerOpen, setDriftDrawerOpen] = (0, $acw62.useState)(false);
    const [driftSnackbar, setDriftSnackbar] = (0, $acw62.useState)(null);
    const [driftItems, setDriftItems] = (0, $acw62.useState)([]);
    // G3 — finalTotalCents is the ONLY price the user edits (via PricePanel).
    // It is decoupled from pvp_cents on items (which are catalog reference values).
    const catalogCostCents = items.filter((i)=>i.product_id).reduce((s, i)=>s + i.cost_cents * i.quantity, 0);
    const catalogPvpCents = items.filter((i)=>i.product_id).reduce((s, i)=>s + i.pvp_cents * i.quantity, 0);
    const [finalTotalCents, setFinalTotalCents] = (0, $acw62.useState)(null);
    // Initialise finalTotalCents from initialItems total or default margin
    (0, $acw62.useEffect)(()=>{
        if (finalTotalCents !== null) return; // already set
        const hasCatalogPvp = catalogPvpCents > 0;
        if (hasCatalogPvp) setFinalTotalCents(catalogPvpCents);
        else if (catalogCostCents > 0) {
            const dm = (0, $9ecafeb0572fff14$export$c014e0140446a084)(catalogCostCents);
            setFinalTotalCents((0, $9ecafeb0572fff14$export$c35659abd6afdebb)(catalogCostCents, dm));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        catalogCostCents,
        catalogPvpCents
    ]);
    // G3 — dirty state exit guard
    const dirtyState = (0, $0154b750eb7fdda7$export$6e2bb77f56272282)({
        items: items,
        notes: notes
    });
    const { ExitGuardDialog: ExitGuardDialog } = dirtyState;
    // Keep dirty tracker in sync with editor state
    (0, $acw62.useEffect)(()=>{
        dirtyState.setCurrentValue({
            items: items,
            notes: notes
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        items,
        notes
    ]);
    // Strip "builder:" prefix from a product_id before using as search query.
    // OMS builder-quote orders store product_id as "builder:<reference>" but the
    // Niposom catalog search expects only the bare reference (e.g. "A1700I3-12100FB").
    const stripBuilderPrefix = (id)=>id.replace(/^builder:/, "");
    // Enrich all items that were loaded from an existing revision with full
    // catalog data: name, rev4_cents, pvp_cents, cost_cents. Runs once on mount.
    (0, $acw62.useEffect)(()=>{
        const itemsToEnrich = items.filter((i)=>i.product_id);
        if (itemsToEnrich.length === 0) return;
        itemsToEnrich.forEach(async (item)=>{
            try {
                const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).COMPOUNDS + "/products/_search", {
                    params: {
                        search: stripBuilderPrefix(item.product_id),
                        limit: 1
                    }
                });
                const p = res.data?.results?.[0];
                if (!p) return;
                updateItem(item._localId, {
                    name: item.name || p.name,
                    rev4_cents: item.rev4_cents ?? Math.round((p.rev4_price ?? 0) * 100),
                    rev3_cents: item.rev3_cents ?? Math.round((p.rev3_price ?? 0) * 100),
                    pvp_cents: item.pvp_cents > 0 ? item.pvp_cents : Math.round((p.pvp_price ?? p.rev4_price ?? 0) * 100),
                    cost_cents: item.cost_cents > 0 ? item.cost_cents : Math.round(p.cost_price * 100)
                });
            } catch  {
            // non-fatal: item stays with existing values
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Sync searchValues when items change
    (0, $acw62.useEffect)(()=>{
        const next = {};
        items.forEach((i)=>{
            next[i._localId] = searchValues[i._localId] ?? stripBuilderPrefix(i.product_id ?? "");
        });
        setSearchValues(next);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        items.map((i)=>i._localId).join(",")
    ]);
    const updateItem = (0, $acw62.useCallback)((localId, patch)=>{
        setItems((prev)=>prev.map((i)=>i._localId === localId ? {
                    ...i,
                    ...patch
                } : i));
    }, []);
    const removeItem = (0, $acw62.useCallback)((localId)=>{
        setItems((prev)=>prev.filter((i)=>i._localId !== localId));
    }, []);
    const addItem = (0, $acw62.useCallback)(()=>{
        setItems((prev)=>[
                ...prev,
                $db59d5920f132b30$var$newEmptyItem()
            ]);
    }, []);
    const validate = ()=>{
        const filled = items.filter((i)=>i.product_id);
        if (filled.length === 0) return "Adiciona pelo menos 1 produto.";
        for (const item of filled){
            if (item.quantity < 1) return `Qty inv\xe1lida no produto ${item.product_id}.`;
        }
        const total = finalTotalCents ?? 0;
        if (total <= 0) return "Define o Pre\xe7o Final da Proposta no painel abaixo.";
        if (total < catalogCostCents) return `Pre\xe7o final (${$db59d5920f132b30$var$formatCents(total)} \u{20AC}) est\xe1 abaixo do custo total (${$db59d5920f132b30$var$formatCents(catalogCostCents)} \u{20AC}). A proposta geraria preju\xedzo.`;
        return null;
    };
    const handleSave = async ()=>{
        const validationErr = validate();
        if (validationErr) {
            setError(validationErr);
            return;
        }
        setError(null);
        setSaving(true);
        try {
            const payload = {
                version: forcedVersion ?? currentVersion,
                items: items.filter((i)=>i.product_id).map(({ _localId: _l, ...rest })=>rest),
                total_cents: finalTotalCents ?? catalogPvpCents,
                notes: notes,
                reference_type: referenceType
            };
            const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).post(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).OMS_ADMIN_ORDERS}/${orderId}/proposal`, payload);
            setForcedVersion(null);
            dirtyState.reset({
                items: items,
                notes: notes
            });
            onSaved(res.data.version);
        } catch (e) {
            const code = e?.response?.data?.error;
            if (code === "stale_version") {
                // 409 — fetch server's latest revision and show diff dialog
                const serverVersion = e.response.data.current_version ?? currentVersion + 1;
                try {
                    const revRes = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).OMS_ADMIN_ORDERS}/${orderId}/proposal`);
                    setServerRevision(revRes.data);
                } catch  {
                    setServerRevision({
                        version: serverVersion,
                        items: [],
                        total_cents: 0,
                        notes: "",
                        created_by: "",
                        created_at: new Date().toISOString()
                    });
                }
                setStaleVersionOpen(true);
            } else if (code === "stale_item_price") {
                // 422 — highlight stale rows
                const rawItems = e?.response?.data?.items ?? [];
                setStaleItems(rawItems);
                setStaleItemsOpen(true);
                setPendingForceSave(true);
            } else if (code === "price_below_cost") setError("PVP total est\xe1 abaixo do custo total dos artigos.");
            else if (code === "price_below_reference") {
                const refLabel = referenceType === "REV3" ? "Rev3" : "custo";
                setError(`Pre\xe7o final est\xe1 abaixo do valor de refer\xeancia (${refLabel}). Ajusta antes de guardar.`);
            } else setError(e?.response?.data?.error ?? "Erro ao guardar revis\xe3o.");
        } finally{
            setSaving(false);
        }
    };
    // Task 7.3 — adopt server version: replace local items with server's
    const handleAdoptServer = ()=>{
        if (!serverRevision) return;
        const serverItems = (serverRevision.items ?? []).map((i)=>({
                ...i,
                _localId: crypto.randomUUID()
            }));
        setItems(serverItems);
        setNotes(serverRevision.notes ?? "");
        setForcedVersion(serverRevision.version);
        setFinalTotalCents(serverRevision.total_cents || null);
        setStaleVersionOpen(false);
        setServerRevision(null);
    };
    // Task 7.3 — keep user changes but bump version to server's latest
    const handleKeepMine = (newForcedVersion)=>{
        setForcedVersion(newForcedVersion);
        setStaleVersionOpen(false);
        setServerRevision(null);
    };
    // Task 7.3 — acknowledge stale prices and re-save
    const handleAcknowledgeStaleItems = async ()=>{
        setStaleItemsOpen(false);
        setPendingForceSave(false);
        if (pendingForceSave) await handleSave();
    };
    // G3 — cancel via exit guard
    const handleCancel = ()=>{
        if (!onCancel) return;
        dirtyState.requestExit(onCancel);
    };
    // PR 6b Phase 2 — drift resolved callback
    const handleDriftResolved = (0, $acw62.useCallback)((response)=>{
        setDriftDrawerOpen(false);
        setDriftItems([]);
        const strategyLabel = {
            accept_current: "Valores actuais aceites.",
            create_new_revision: "Nova revis\xe3o criada.",
            keep_snapshot: "Snapshot mantido."
        };
        setDriftSnackbar(strategyLabel[response.strategy] ?? "Drift resolvido.");
        onSaved(response.new_revision_id ?? currentVersion);
    }, [
        onSaved,
        currentVersion
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Box), {
        children: [
            currentVersion > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Box), {
                display: "flex",
                justifyContent: "flex-end",
                mb: 1,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Tooltip), {
                    title: "Ver relat\xf3rio de drift de pre\xe7os",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.IconButton), {
                        size: "small",
                        onClick: ()=>setDriftDrawerOpen(true),
                        "aria-label": "Ver relat\xf3rio de drift de pre\xe7os",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2b4e1963b712d6d0$exports))), {
                            fontSize: "small"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f1fe53460611102d$export$2e2bcd8739ae039), {
                items: items,
                searchValues: searchValues,
                setSearchValues: setSearchValues,
                updateItem: updateItem,
                removeItem: removeItem,
                addItem: addItem,
                driftItems: driftItems,
                onDriftClick: ()=>setDriftDrawerOpen(true),
                isAdmin: isAdmin
            }),
            items.some((i)=>i.product_id) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Box), {
                mb: 2,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6114eefbdd4cb273$export$2e2bcd8739ae039), {
                    items: items.filter((i)=>i.product_id),
                    externalPriceCents: finalTotalCents ?? undefined,
                    onPriceChange: (cents)=>setFinalTotalCents(cents),
                    referenceType: referenceType,
                    onReferenceTypeChange: setReferenceType,
                    isAdmin: isAdmin,
                    referenceLocked: referenceLocked,
                    role: proposalRole
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eb020dcc1394e0a2$export$2e2bcd8739ae039), {
                notes: notes,
                setNotes: setNotes,
                error: error,
                saving: saving,
                onCancel: onCancel,
                handleCancel: handleCancel,
                handleSave: handleSave
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $208d18acbdc98c7c$export$d070577284818d17), {
                open: staleVersionOpen,
                userItems: items,
                userNotes: notes,
                userTotalCents: finalTotalCents ?? catalogPvpCents,
                serverRevision: serverRevision,
                onAdoptServer: handleAdoptServer,
                onKeepMine: handleKeepMine,
                onClose: ()=>setStaleVersionOpen(false)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $208d18acbdc98c7c$export$d7c0b8e582bfae1f), {
                open: staleItemsOpen,
                staleItems: staleItems,
                onAcknowledge: handleAcknowledgeStaleItems,
                onClose: ()=>{
                    setStaleItemsOpen(false);
                    setPendingForceSave(false);
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(ExitGuardDialog, {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2236ebc33ab65f2a$export$2e2bcd8739ae039), {
                open: driftDrawerOpen,
                onClose: ()=>setDriftDrawerOpen(false),
                orderId: orderId,
                revisionVersion: currentVersion,
                role: proposalRole,
                onResolved: handleDriftResolved
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Snackbar), {
                open: driftSnackbar !== null,
                autoHideDuration: 4000,
                onClose: ()=>setDriftSnackbar(null),
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Alert), {
                    severity: "success",
                    onClose: ()=>setDriftSnackbar(null),
                    variant: "filled",
                    children: driftSnackbar
                })
            })
        ]
    });
};
var $db59d5920f132b30$export$2e2bcd8739ae039 = $db59d5920f132b30$var$ProposalEditor;


/**
 * ProposalActions — contextual action buttons for a proposal.
 *
 * F-2.0 Plan Phase 7:
 * - DRAFT         → [Guardar rascunho (in editor)] + [Enviar proposta]
 * - DRAFT_SENT    → [Aceitar (staff)] [Recusar (staff)]
 * - CHANGE_REQUESTED → [Iniciar revisão]
 * - ACCEPTED/DECLINED/EXPIRED → read-only, no actions
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $9dba68affd3371e4$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $9dba68affd3371e4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($9dba68affd3371e4$exports, "__esModule", {
    value: true
});
$9dba68affd3371e4$exports.default = void 0;

var $9dba68affd3371e4$var$_createSvgIcon = $9dba68affd3371e4$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $9dba68affd3371e4$var$_default = $9dba68affd3371e4$exports.default = (0, $9dba68affd3371e4$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M2.01 21 23 12 2.01 3 2 10l15 2-15 2z"
}), 'Send');


var $ca4fd08777d4e412$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $ca4fd08777d4e412$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($ca4fd08777d4e412$exports, "__esModule", {
    value: true
});
$ca4fd08777d4e412$exports.default = void 0;

var $ca4fd08777d4e412$var$_createSvgIcon = $ca4fd08777d4e412$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $ca4fd08777d4e412$var$_default = $ca4fd08777d4e412$exports.default = (0, $ca4fd08777d4e412$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z"
}), 'CheckCircle');


var $79f00c956e46f4d6$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $79f00c956e46f4d6$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($79f00c956e46f4d6$exports, "__esModule", {
    value: true
});
$79f00c956e46f4d6$exports.default = void 0;

var $79f00c956e46f4d6$var$_createSvgIcon = $79f00c956e46f4d6$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $79f00c956e46f4d6$var$_default = $79f00c956e46f4d6$exports.default = (0, $79f00c956e46f4d6$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12z"
}), 'Cancel');


var $8c6ad197f63b3f3e$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $8c6ad197f63b3f3e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($8c6ad197f63b3f3e$exports, "__esModule", {
    value: true
});
$8c6ad197f63b3f3e$exports.default = void 0;

var $8c6ad197f63b3f3e$var$_createSvgIcon = $8c6ad197f63b3f3e$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $8c6ad197f63b3f3e$var$_default = $8c6ad197f63b3f3e$exports.default = (0, $8c6ad197f63b3f3e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"
}), 'Edit');


var $611927cd5409b9fd$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $611927cd5409b9fd$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($611927cd5409b9fd$exports, "__esModule", {
    value: true
});
$611927cd5409b9fd$exports.default = void 0;

var $611927cd5409b9fd$var$_createSvgIcon = $611927cd5409b9fd$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $611927cd5409b9fd$var$_default = $611927cd5409b9fd$exports.default = (0, $611927cd5409b9fd$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8"
}), 'Undo');


var $9a1ce50a9da629a8$exports = {};
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $9a1ce50a9da629a8$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $9a1ce50a9da629a8$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($9a1ce50a9da629a8$exports, "__esModule", {
    value: true
});
$9a1ce50a9da629a8$exports.default = void 0;

var $9a1ce50a9da629a8$var$React = $9a1ce50a9da629a8$require$_interopRequireWildcard((parcelRequire("acw62")));

var $9a1ce50a9da629a8$var$_createSvgIcon = $9a1ce50a9da629a8$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $9a1ce50a9da629a8$var$_default = $9a1ce50a9da629a8$exports.default = (0, $9a1ce50a9da629a8$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M16.75 13.96c.25.13.41.2.46.3.06.11.04.61-.21 1.18-.2.56-1.24 1.1-1.7 1.12-.46.02-.47.36-2.96-.73-2.49-1.09-3.99-3.75-4.11-3.92-.12-.17-.96-1.38-.92-2.61.05-1.22.69-1.8.95-2.04.24-.26.51-.29.68-.26h.47c.15 0 .36-.06.55.45l.69 1.87c.06.13.1.28.01.44l-.27.41-.39.42c-.12.12-.26.25-.12.5.12.26.62 1.09 1.32 1.78.91.88 1.71 1.17 1.95 1.3.24.14.39.12.54-.04l.81-.94c.19-.25.35-.19.58-.11l1.67.88M12 2a10 10 0 0 1 10 10 10 10 0 0 1-10 10c-1.97 0-3.8-.57-5.35-1.55L2 22l1.55-4.65A9.969 9.969 0 0 1 2 12 10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8c0 1.72.54 3.31 1.46 4.61L4.5 19.5l2.89-.96A7.95 7.95 0 0 0 12 20a8 8 0 0 0 8-8 8 8 0 0 0-8-8z"
}), 'WhatsApp');





/**
 * Sanitizes phone numbers to E.164 format without leading zeros or '+' for wa.me.
 * Defaults to country code '351' (Portugal) if a 9-digit local number is provided.
 * Mirrors eurosys-site/src/lib/builder/whatsAppLink.ts sanitizePhone — keep in sync.
 */ function $cb6342ed0f6d41de$export$dfbcd9832e9f2b04(rawPhone) {
    if (!rawPhone) return "";
    const digits = String(rawPhone).replace(/[^\d]/g, "");
    if (!digits) return "";
    // International prefix 00 → strip (00351… → 351…, 0034… → 34…).
    if (digits.startsWith("00")) return digits.slice(2);
    // Legacy leading zero on a national number (09… → 9…) before the 9-digit rule.
    if (digits.length === 10 && digits.startsWith("0")) return `351${digits.slice(1)}`;
    // 9-digit local number → default PT country code.
    if (digits.length === 9 && /^[23789]/.test(digits)) return `351${digits}`;
    // A 9-digit number starting with 0 is neither a PT national number nor a
    // valid E.164 — reject (return "") so the caller hides the CTA.
    if (digits.length === 9 && digits.startsWith("0")) return "";
    return digits;
}


const $4d8941c6784b1735$var$ProposalActions = ({ orderId: orderId, proposalStatus: proposalStatus, proposalVersion: proposalVersion, onStatusChanged: onStatusChanged, onReviseStarted: onReviseStarted, customerPhone: customerPhone, customerName: customerName, previewUrl: previewUrlProp })=>{
    const [sendLoading, setSendLoading] = (0, $acw62.useState)(false);
    const [sendError, setSendError] = (0, $acw62.useState)(null);
    // Local override for the just-sent link; the prop covers reloads.
    const [sentPreviewUrl, setSentPreviewUrl] = (0, $acw62.useState)(null);
    // Only show the WhatsApp reply link while the proposal is actually sent —
    // a stale link must not survive DRAFT_SENT → DRAFT/CHANGE_REQUESTED flips.
    const previewUrl = proposalStatus === "DRAFT_SENT" ? sentPreviewUrl ?? previewUrlProp ?? null : null;
    // Decline dialog
    const [cancelOpen, setCancelOpen] = (0, $acw62.useState)(false);
    const [cancelReason, setCancelReason] = (0, $acw62.useState)("");
    const [cancelError, setCancelError] = (0, $acw62.useState)(null);
    const [declineOpen, setDeclineOpen] = (0, $acw62.useState)(false);
    const [justification, setJustification] = (0, $acw62.useState)("");
    const [justError, setJustError] = (0, $acw62.useState)(null);
    const [respondLoading, setRespondLoading] = (0, $acw62.useState)(false);
    const handleCancel = async ()=>{
        if (cancelReason.trim().length < 3) return;
        setRespondLoading(true);
        setCancelError(null);
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).patch(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).OMS_ADMIN_ORDERS}/${orderId}/proposal/cancel`, {
                reason: cancelReason.trim()
            });
            // OMS moves DRAFT_SENT → CANCELLED (terminal); resuming needs admin
            // reopen. Reflect the real state so the UI doesn't offer send/editor.
            setSentPreviewUrl(null);
            onStatusChanged("CANCELLED");
            closeCancelDialog();
        } catch (e) {
            setCancelError(e?.response?.data?.error ?? "Erro ao retirar proposta.");
        } finally{
            setRespondLoading(false);
        }
    };
    const handleSend = async ()=>{
        setSendLoading(true);
        setSendError(null);
        try {
            const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).post(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).OMS_ADMIN_ORDERS}/${orderId}/proposal/send`);
            if (res.data?.preview_url) setSentPreviewUrl(res.data.preview_url);
            onStatusChanged("DRAFT_SENT");
        } catch (e) {
            setSendError(e?.response?.data?.error ?? "Erro ao enviar proposta.");
        } finally{
            setSendLoading(false);
        }
    };
    const handleRespond = async (action)=>{
        if (action === "decline") {
            if (justification.trim().length < 10) {
                setJustError("Justifica\xe7\xe3o deve ter pelo menos 10 caracteres.");
                return;
            }
        }
        setRespondLoading(true);
        setJustError(null);
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).patch(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).OMS_ADMIN_ORDERS}/${orderId}/proposal/respond`, {
                action: action,
                justification: action === "decline" ? justification.trim() : undefined
            });
            onStatusChanged(action === "accept" ? "ACCEPTED" : "DECLINED");
            closeDeclineDialog();
        } catch (e) {
            setJustError(e?.response?.data?.error ?? "Erro ao processar resposta.");
        } finally{
            setRespondLoading(false);
        }
    };
    if (!proposalStatus || proposalStatus === "ACCEPTED" || proposalStatus === "DECLINED" || proposalStatus === "EXPIRED" || proposalStatus === "CANCELLED") return null;
    const closeCancelDialog = ()=>{
        setCancelOpen(false);
        setCancelReason("");
        setCancelError(null);
    };
    const closeDeclineDialog = ()=>{
        setDeclineOpen(false);
        setJustification("");
        setJustError(null);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Box), {
        display: "flex",
        gap: 1,
        flexWrap: "wrap",
        mt: 1,
        children: [
            (0, $92abc7e5184dde18$export$4df5bd8ecb22f22b)(proposalStatus) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Box), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Button), {
                        variant: "contained",
                        color: "success",
                        size: "small",
                        startIcon: sendLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.CircularProgress), {
                            size: 14,
                            color: "inherit"
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9dba68affd3371e4$exports))), {}),
                        onClick: handleSend,
                        disabled: sendLoading || !proposalVersion,
                        title: !proposalVersion ? "Guarda o rascunho primeiro." : undefined,
                        children: sendLoading ? "A enviar\u2026" : "Enviar proposta"
                    }),
                    sendError && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Typography), {
                        variant: "caption",
                        color: "error",
                        display: "block",
                        mt: 0.5,
                        children: sendError
                    })
                ]
            }),
            (()=>{
                if (!previewUrl) return null;
                const waPhone = (0, $cb6342ed0f6d41de$export$dfbcd9832e9f2b04)(customerPhone);
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Button), {
                    variant: "contained",
                    size: "small",
                    startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9a1ce50a9da629a8$exports))), {}),
                    ...waPhone ? {
                        href: `https://wa.me/${waPhone}?text=${encodeURIComponent(`Ol\xe1 ${customerName?.split(" ")[0] ?? "cliente"}, a sua proposta est\xe1 pronta: ${previewUrl}`)}`,
                        target: "_blank",
                        rel: "noopener noreferrer"
                    } : {},
                    disabled: !waPhone,
                    title: waPhone ? "Abrir WhatsApp com o link da proposta" : "Cliente sem telefone registado",
                    children: "Enviar link por WhatsApp"
                });
            })(),
            (0, $92abc7e5184dde18$export$fcd90031df3f450a)(proposalStatus) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Button), {
                        variant: "contained",
                        color: "success",
                        size: "small",
                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ca4fd08777d4e412$exports))), {}),
                        onClick: ()=>handleRespond("accept"),
                        disabled: respondLoading,
                        children: "Aceitar (staff)"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Button), {
                        variant: "outlined",
                        color: "error",
                        size: "small",
                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($79f00c956e46f4d6$exports))), {}),
                        onClick: ()=>setDeclineOpen(true),
                        disabled: respondLoading,
                        children: "Recusar (staff)"
                    })
                ]
            }),
            proposalStatus === "DRAFT_SENT" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Button), {
                variant: "outlined",
                color: "warning",
                size: "small",
                startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($611927cd5409b9fd$exports))), {}),
                onClick: ()=>setCancelOpen(true),
                disabled: respondLoading,
                children: "Retirar proposta"
            }),
            proposalStatus === "CHANGE_REQUESTED" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Button), {
                variant: "contained",
                color: "warning",
                size: "small",
                startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8c6ad197f63b3f3e$exports))), {}),
                onClick: onReviseStarted,
                children: "Iniciar revis\xe3o"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Dialog), {
                open: cancelOpen,
                onClose: closeCancelDialog,
                maxWidth: "sm",
                fullWidth: true,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.DialogTitle), {
                        children: "Retirar proposta"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.DialogContent), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Typography), {
                                variant: "body2",
                                color: "text.secondary",
                                mb: 2,
                                children: [
                                    "A proposta fica ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                        children: "cancelada"
                                    }),
                                    ". S\xf3 um administrador pode reabri-la."
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TextField), {
                                autoFocus: true,
                                label: "Motivo",
                                fullWidth: true,
                                value: cancelReason,
                                onChange: (e)=>setCancelReason(e.target.value),
                                helperText: "Motivo interno (n\xe3o enviado ao cliente)"
                            }),
                            cancelError && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Alert), {
                                severity: "error",
                                sx: {
                                    mt: 1
                                },
                                children: cancelError
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.DialogActions), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Button), {
                                onClick: closeCancelDialog,
                                disabled: respondLoading,
                                children: "Cancelar"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Button), {
                                variant: "contained",
                                color: "warning",
                                onClick: handleCancel,
                                disabled: respondLoading || cancelReason.trim().length < 3,
                                children: "Confirmar"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Dialog), {
                open: declineOpen,
                onClose: closeDeclineDialog,
                maxWidth: "sm",
                fullWidth: true,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.DialogTitle), {
                        children: "Recusar proposta (em nome do cliente)"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.DialogContent), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Typography), {
                                variant: "body2",
                                color: "text.secondary",
                                mb: 2,
                                children: "Esta ac\xe7\xe3o regista uma recusa em nome do cliente (ex: comunicada por telefone). A justifica\xe7\xe3o fica no hist\xf3rico."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TextField), {
                                autoFocus: true,
                                label: "Justifica\xe7\xe3o",
                                multiline: true,
                                minRows: 3,
                                fullWidth: true,
                                value: justification,
                                onChange: (e)=>setJustification(e.target.value),
                                error: !!justError,
                                helperText: justError ?? "M\xednimo 10 caracteres."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.DialogActions), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Button), {
                                onClick: closeDeclineDialog,
                                disabled: respondLoading,
                                children: "Cancelar"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Button), {
                                variant: "contained",
                                color: "error",
                                onClick: ()=>handleRespond("decline"),
                                disabled: respondLoading || justification.trim().length < 10,
                                startIcon: respondLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.CircularProgress), {
                                    size: 14,
                                    color: "inherit"
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($79f00c956e46f4d6$exports))), {}),
                                children: "Confirmar recusa"
                            })
                        ]
                    }),
                    justError && justification.trim().length >= 10 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Alert), {
                        severity: "error",
                        sx: {
                            mx: 2,
                            mb: 1
                        },
                        children: justError
                    })
                ]
            })
        ]
    });
};
var $4d8941c6784b1735$export$2e2bcd8739ae039 = $4d8941c6784b1735$var$ProposalActions;


const $2e14f8355e8eb0bd$var$ProposalDetail = ({ order: order, userProfile: userProfile, onOrderUpdated: onOrderUpdated })=>{
    const quoteCustomer = (0, $d4c9f6e063c54583$export$9a5a9828f9cb05b8)(order.customer_data);
    const [revision, setRevision] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    const [mode, setMode] = (0, $acw62.useState)("view");
    // Tracks whether the initial mode has been set from server data.
    // Subsequent fetchRevision calls (after save/revise/status-change) must NOT
    // override the mode that was explicitly set by the action handler.
    const initialModeSet = (0, $acw62.useRef)(false);
    // Local copies of proposal_status and proposal_version — updated immediately
    // by action handlers so the UI reacts without waiting for the parent to
    // re-render (the modal JSX is captured once at open time, so the `order` prop
    // is stale after any mutation).
    const [localStatus, setLocalStatus] = (0, $acw62.useState)(order.proposal_status ?? null);
    const [localVersion, setLocalVersion] = (0, $acw62.useState)(order.proposal_version ?? undefined);
    const proposalStatus = localStatus;
    /** Customer preview link — from the fetched revision (survives reload,
   *  OMS re-issues it when DRAFT_SENT) or directly after send. */ const previewUrl = revision?.preview_url ?? null;
    /** Discriminated `ProposalResponse` — role derived from JWT via
   *  `buildProposalResponse`; comercial branch strips admin-only fields.
   *  Recomputed only when the fetched `revision` or `userProfile.profile` changes. */ const response = (0, $acw62.useMemo)(()=>{
        if (!revision) return null;
        return (0, $632e0f20877ec90f$export$86e8e662b44fe016)(userProfile.profile, revision);
    }, [
        revision,
        userProfile.profile
    ]);
    const fetchRevision = (0, $acw62.useCallback)(async ()=>{
        setLoading(true);
        setError(null);
        try {
            const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).OMS_ADMIN_ORDERS}/${order.id}/proposal`);
            setRevision(res.data);
        } catch (e) {
            if (e?.response?.status === 404) setRevision(null); // no revision yet — show blank editor
            else setError(e?.response?.data?.error ?? "Erro ao carregar proposta.");
        } finally{
            setLoading(false);
        }
    }, [
        order.id
    ]);
    (0, $acw62.useEffect)(()=>{
        fetchRevision();
    }, [
        fetchRevision
    ]);
    // After saving a new revision → refresh + switch to view
    const handleRevisionSaved = (newVersion)=>{
        setLocalStatus("DRAFT");
        setLocalVersion(newVersion);
        onOrderUpdated({
            ...order,
            proposal_status: "DRAFT",
            proposal_version: newVersion
        });
        fetchRevision();
        setMode("view");
    };
    // After "Iniciar revisão" → create revision via /revise endpoint
    const handleReviseStarted = async ()=>{
        if (!revision) return;
        try {
            const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).post(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).OMS_ADMIN_ORDERS}/${order.id}/proposal/revise`, {
                source_version: revision.version
            });
            setLocalStatus("DRAFT");
            setLocalVersion(res.data.version);
            onOrderUpdated({
                ...order,
                proposal_status: "DRAFT",
                proposal_version: res.data.version
            });
            fetchRevision();
            setMode("edit");
        } catch (e) {
            setError(e?.response?.data?.error ?? "Erro ao iniciar revis\xe3o.");
        }
    };
    const handleStatusChanged = (newStatus)=>{
        setLocalStatus(newStatus);
        onOrderUpdated({
            ...order,
            proposal_status: newStatus
        });
        setMode("view");
        fetchRevision();
    };
    // Decide initial mode from status — runs only once on first load.
    // revision.version === 0 means synthetic draft (no saved revision yet) —
    // treat it the same as revision===null for mode decision purposes.
    const isSyntheticDraft = revision !== null && revision.version === 0;
    (0, $acw62.useEffect)(()=>{
        if (!loading && !initialModeSet.current) {
            initialModeSet.current = true;
            if ((!revision || isSyntheticDraft) && !proposalStatus) setMode("edit"); // first ever save (null or synthetic v0)
            else if (proposalStatus && (0, $92abc7e5184dde18$export$5469c988647fcb7b)(proposalStatus) && proposalStatus !== "CHANGE_REQUESTED") setMode("edit"); // DRAFT → open editor
            else setMode("view");
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        loading
    ]);
    // ── Render ────────────────────────────────────────────────────────────────
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Box), {
        p: 2,
        minWidth: 560,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Box), {
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                mb: 2,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Typography), {
                        variant: "h6",
                        fontWeight: 700,
                        children: "Proposta"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $002d06b4eb083fb3$export$2e2bcd8739ae039), {
                        status: proposalStatus,
                        size: "medium"
                    }),
                    localVersion != null && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Chip), {
                        label: `v${localVersion}`,
                        size: "small",
                        variant: "outlined",
                        sx: {
                            fontFamily: "monospace"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Box), {
                sx: {
                    bgcolor: "#f8f9fa",
                    border: "1px solid #e9ecef",
                    borderRadius: 1,
                    p: 1.5,
                    mb: 2
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Typography), {
                    variant: "body2",
                    color: "text.secondary",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                            children: "Encomenda:"
                        }),
                        " ",
                        (0, $d4c0c44600ee9d94$export$7c020bda1e17fd0d)(order.id),
                        " \xa0\xb7\xa0",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                            children: "Cliente:"
                        }),
                        " ",
                        order.customer_name,
                        " (",
                        order.customer_email,
                        ")",
                        quoteCustomer.phone && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                " ",
                                "\xa0\xb7\xa0",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                    children: "Tel:"
                                }),
                                " ",
                                quoteCustomer.phone
                            ]
                        }),
                        order.proposal_sent_at && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                " ",
                                "\xa0\xb7\xa0",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                    children: "Enviada:"
                                }),
                                " ",
                                new Date(order.proposal_sent_at).toLocaleString("pt-PT")
                            ]
                        })
                    ]
                })
            }),
            loading && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Box), {
                display: "flex",
                justifyContent: "center",
                py: 4,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.CircularProgress), {
                    size: 32
                })
            }),
            !loading && error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Alert), {
                severity: "error",
                sx: {
                    mb: 2
                },
                children: error
            }),
            !loading && !error && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    (mode === "edit" || mode === "revise") && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            mode === "revise" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Alert), {
                                severity: "info",
                                sx: {
                                    mb: 2
                                },
                                children: "Est\xe1s em modo revis\xe3o \u2014 os artigos foram pr\xe9-carregados da vers\xe3o anterior. Edita e guarda o novo rascunho."
                            }),
                            mode === "edit" && isSyntheticDraft && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Alert), {
                                severity: "info",
                                sx: {
                                    mb: 2
                                },
                                children: [
                                    "Artigos pr\xe9-carregados do or\xe7amento submetido pelo cliente. Preenche o ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                        children: "custo unit\xe1rio"
                                    }),
                                    " de cada artigo e ajusta os pre\xe7os antes de guardar."
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $db59d5920f132b30$export$2e2bcd8739ae039), {
                                orderId: order.id,
                                currentVersion: revision?.version ?? 0,
                                initialItems: revision ? revision.items.map((it)=>({
                                        _localId: crypto.randomUUID(),
                                        product_id: it.product_id,
                                        name: it.name,
                                        reference: it.reference,
                                        component_type: it.component_type,
                                        // pvp_cents in the draft editor = the editable price.
                                        // Prefer the saved selling price (unit_price_cents on
                                        // the wire) so editing keeps the negotiated value;
                                        // fall back to catalog PVP / rev3 for legacy payloads.
                                        pvp_cents: it.unit_price_cents ?? it.pvp_cents ?? it.rev3_cents ?? 0,
                                        cost_cents: it.cost_cents ?? 0,
                                        quantity: it.quantity,
                                        rev3_cents: it.rev3_cents,
                                        rev4_cents: it.rev4_cents
                                    })) : [] // backend synthesizes v0 drafts; empty fallback is unreachable with items
                                ,
                                initialNotes: revision?.notes,
                                initialReferenceType: revision?.reference_type,
                                onSaved: handleRevisionSaved,
                                onCancel: revision && !isSyntheticDraft ? ()=>setMode("view") : undefined
                            })
                        ]
                    }),
                    mode === "view" && response && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b6ac59eb08352764$export$2e2bcd8739ae039), {
                        response: response,
                        showChangeRequestJustification: proposalStatus === "CHANGE_REQUESTED"
                    }),
                    mode === "view" && !revision && !proposalStatus && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Alert), {
                        severity: "info",
                        children: "Ainda n\xe3o existe proposta para esta encomenda."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Divider), {
                                sx: {
                                    my: 2
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4d8941c6784b1735$export$2e2bcd8739ae039), {
                                orderId: order.id,
                                proposalStatus: proposalStatus,
                                proposalVersion: localVersion,
                                onStatusChanged: handleStatusChanged,
                                onReviseStarted: (0, $92abc7e5184dde18$export$a7ebb9d34cd91279)(proposalStatus) ? handleReviseStarted : ()=>setMode("revise"),
                                customerPhone: quoteCustomer.phone,
                                customerName: order.customer_name,
                                previewUrl: previewUrl
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $2e14f8355e8eb0bd$export$2e2bcd8739ae039 = $2e14f8355e8eb0bd$var$ProposalDetail;



const $2bfc9d2123736d07$var$ALL_PROPOSAL_STATUSES = [
    "DRAFT",
    "DRAFT_SENT",
    "ACCEPTED",
    "DECLINED",
    "CHANGE_REQUESTED",
    "EXPIRED",
    "CANCELLED"
];
function $2bfc9d2123736d07$var$getInitialParam(key, fallback = "") {
    return new URLSearchParams(window.location.search).get(key) ?? fallback;
}
const $2bfc9d2123736d07$var$OmsProposalsPage = ()=>{
    const { profile: profile, isAuthenticated: isAuthenticated } = (0, $b622ef53e38024e7$export$1d39dc5b47e56ff0)();
    const { setModalScreen: setModalScreen, setError: setError } = (0, $a55f2a94cd420149$export$c50e37a2f0a2b064)();
    const navigate = (0, $585f8bce88e531c1$export$9770f232ac06a008)();
    const location = (0, $585f8bce88e531c1$export$45d76561a5302f2b)();
    const { id: proposalId } = (0, $585f8bce88e531c1$export$99eaa27ddbbb95ef)();
    const authed = isAuthenticated();
    const [userProfile, setUserProfile] = (0, $acw62.useState)(null);
    const [profileLoading, setProfileLoading] = (0, $acw62.useState)(true);
    const [orders, setOrders] = (0, $acw62.useState)([]);
    const [total, setTotal] = (0, $acw62.useState)(0);
    const [page, setPage] = (0, $acw62.useState)(1);
    const [totalPages, setTotalPages] = (0, $acw62.useState)(1);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [fetchError, setFetchError] = (0, $acw62.useState)(null);
    const [search, setSearch] = (0, $acw62.useState)(()=>$2bfc9d2123736d07$var$getInitialParam("search"));
    const [proposalStatus, setProposalStatus] = (0, $acw62.useState)(()=>{
        const raw = $2bfc9d2123736d07$var$getInitialParam("proposal_status");
        // Guard against hand-edited ?proposal_status=FOO (MUI Select with no
        // matching MenuItem would warn and render an empty dropdown).
        return $2bfc9d2123736d07$var$ALL_PROPOSAL_STATUSES.includes(raw) ? raw : "";
    });
    const [dateFrom, setDateFrom] = (0, $acw62.useState)(()=>$2bfc9d2123736d07$var$getInitialParam("from"));
    const [dateTo, setDateTo] = (0, $acw62.useState)(()=>$2bfc9d2123736d07$var$getInitialParam("to"));
    // ── Multi-tenant selection (ADR-021) ─────────────────────────────────────
    // The builder_quote orders live under the operator's resolved tenant; the
    // selector lets them switch to it when a different tenant is persisted from
    // another page (the interceptor forwards X-Selected-Tenant-ID globally).
    const { tenants: tenants, selectedTenant: selectedTenant, selectTenant: selectTenant } = (0, $d3c233bd9ac99dda$export$d4c94cedb7152d21)();
    (0, $acw62.useEffect)(()=>{
        profile().then((p)=>{
            setUserProfile(p);
            setProfileLoading(false);
        }).catch(()=>setProfileLoading(false));
    }, [
        profile
    ]);
    // ── Auth guard: preserve deep link across login ─────────────────────────
    (0, $acw62.useEffect)(()=>{
        if (!authed) // Same pattern as other pages (e.g. CategoriesManagementPage): LoginPage
        // reads location.state.from and navigates back after successful login.
        navigate("/login", {
            state: {
                from: location.pathname + location.search
            },
            replace: true
        });
    }, [
        authed,
        navigate,
        location.pathname,
        location.search
    ]);
    const fetchOrders = (0, $acw62.useCallback)(async (p, filters)=>{
        setLoading(true);
        setFetchError(null);
        try {
            const s = filters?.search ?? search;
            const ps = filters?.proposalStatus ?? proposalStatus;
            const from = filters?.dateFrom ?? dateFrom;
            const to = filters?.dateTo ?? dateTo;
            const params = new URLSearchParams({
                page: String(p),
                per_page: "25",
                source: "builder_quote",
                sort_by: "created_at",
                sort_dir: "desc"
            });
            if (s) params.set("search", s);
            if (ps) params.set("proposal_status", ps);
            if (from) params.set("from", from);
            if (to) params.set("to", to);
            // Sync the browser URL with the effective filters so searches are
            // bookmarkable/shareable (mirrors OmsOrdersPage behaviour).
            history.replaceState(history.state, "", `/oms-proposals?${params.toString()}`);
            const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).OMS_ADMIN_ORDERS}?${params}`);
            setOrders(res.data.orders || []);
            setTotal(res.data.total || 0);
            setTotalPages(res.data.total_pages || 1);
            setPage(p);
        } catch (e) {
            if ([
                401,
                403
            ].includes(e?.response?.status)) setError("Sem permiss\xe3o para aceder \xe0s propostas.");
            else setFetchError(e?.response?.data?.error || "Erro ao carregar propostas.");
        } finally{
            setLoading(false);
        }
    }, [
        search,
        proposalStatus,
        dateFrom,
        dateTo,
        setError
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!profileLoading && userProfile) fetchOrders(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        profileLoading,
        userProfile
    ]);
    const openProposalDetail = (order)=>{
        // userProfile is guaranteed non-null here — row click is only reachable
        // after the role gate below. The early return is purely a TypeScript
        // narrowing aid.
        if (!userProfile) return;
        const detailPath = `/oms-proposals/${order.id}`;
        // When arriving via deep link the URL already is the detail path — don't
        // push a duplicate history entry (would make Back reopen the modal after
        // close). Only push when navigating from the list.
        if (window.location.pathname !== detailPath) history.pushState(history.state, "", detailPath);
        setModalScreen({
            title: `Proposta \u{2014} ${(0, $d4c0c44600ee9d94$export$7c020bda1e17fd0d)(order.id)}`,
            state: "big-view",
            childrenControlOverflow: true,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2e14f8355e8eb0bd$export$2e2bcd8739ae039), {
                order: order,
                userProfile: userProfile,
                onOrderUpdated: (updated)=>{
                    setOrders((prev)=>prev.map((o)=>o.id === updated.id ? updated : o));
                }
            }),
            onClose: ()=>{
                // Restore the list URL with the active filters intact (fetchOrders
                // syncs them via replaceState; don't wipe them on modal close).
                // replaceState (not pushState): the detail entry is replaced so browser
                // Back after closing doesn't reopen the modal.
                const params = new URLSearchParams({
                    page: String(page),
                    per_page: "25"
                });
                if (search) params.set("search", search);
                if (proposalStatus) params.set("proposal_status", proposalStatus);
                if (dateFrom) params.set("from", dateFrom);
                if (dateTo) params.set("to", dateTo);
                history.replaceState(history.state, "", `/oms-proposals?${params.toString()}`);
                setModalScreen(null);
            }
        });
    };
    // ── Deep link: /oms-proposals/:id opens the detail directly ─────────────
    const deepLinkOpenedRef = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        if (!proposalId || profileLoading || !userProfile) return;
        if (!userProfile.isAdmin() && !userProfile.isCommercial()) return;
        if (deepLinkOpenedRef.current) return;
        deepLinkOpenedRef.current = true;
        let cancelled = false;
        (0, $bac44633733ff026$export$2e2bcd8739ae039).get(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).OMS_ADMIN_ORDERS}/${proposalId}`).then((res)=>{
            if (!cancelled) openProposalDetail(res.data);
        }).catch((e)=>{
            if (cancelled) return;
            // Unknown/invalid proposal — fall back to the list with an error banner.
            history.replaceState(history.state, "", "/oms-proposals");
            setError(e?.response?.status === 404 ? "Proposta n\xe3o encontrada." : e?.response?.data?.error || "Erro ao abrir a proposta.");
        });
        return ()=>{
            cancelled = true;
        };
    // openProposalDetail is recreated per render; the ref gate guarantees a
    // single run per proposalId.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        proposalId,
        profileLoading,
        userProfile
    ]);
    if (!authed) return null;
    if (profileLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Box), {
        display: "flex",
        justifyContent: "center",
        p: 6,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.CircularProgress), {})
    });
    if (!userProfile?.isAdmin() && !userProfile?.isCommercial()) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$444b3ab0cb9aec40), {
        to: "/",
        replace: true
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Box), {
        p: 4,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Paper), {
            elevation: 1,
            sx: {
                p: 3
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Typography), {
                    variant: "h5",
                    fontWeight: 700,
                    mb: 0.5,
                    children: "Propostas de Or\xe7amento"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Typography), {
                    variant: "body2",
                    color: "text.secondary",
                    mb: 3,
                    children: "Encomendas do canal builder_quote. Cria, envia e gere propostas."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Box), {
                    display: "flex",
                    gap: 2,
                    flexWrap: "wrap",
                    mb: 3,
                    alignItems: "flex-end",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9e71da29c945043$export$2e2bcd8739ae039), {
                            tenants: tenants,
                            value: selectedTenant,
                            onChange: (t)=>{
                                selectTenant(t);
                                fetchOrders(1);
                            },
                            className: "min-w-[180px]"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TextField), {
                            label: "Pesquisar",
                            size: "small",
                            value: search,
                            onChange: (e)=>setSearch(e.target.value),
                            onKeyDown: (e)=>e.key === "Enter" && fetchOrders(1),
                            sx: {
                                minWidth: 220
                            },
                            placeholder: "nome, email, ref\u2026"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.FormControl), {
                            size: "small",
                            sx: {
                                minWidth: 180
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.InputLabel), {
                                    children: "Estado proposta"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Select), {
                                    label: "Estado proposta",
                                    value: proposalStatus,
                                    onChange: (e)=>setProposalStatus(e.target.value),
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.MenuItem), {
                                            value: "",
                                            children: "Todos"
                                        }),
                                        $2bfc9d2123736d07$var$ALL_PROPOSAL_STATUSES.map((s)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.MenuItem), {
                                                value: s,
                                                children: (0, $92abc7e5184dde18$export$78db43792bea60f2)[s]
                                            }, s))
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TextField), {
                            label: "De",
                            type: "date",
                            size: "small",
                            value: dateFrom,
                            onChange: (e)=>setDateFrom(e.target.value),
                            InputLabelProps: {
                                shrink: true
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TextField), {
                            label: "At\xe9",
                            type: "date",
                            size: "small",
                            value: dateTo,
                            onChange: (e)=>setDateTo(e.target.value),
                            InputLabelProps: {
                                shrink: true
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Box), {
                            display: "flex",
                            gap: 1,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "button is-primary is-small",
                                    onClick: ()=>fetchOrders(1),
                                    children: "Pesquisar"
                                }),
                                (search || proposalStatus || dateFrom || dateTo) && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "button is-light is-small",
                                    onClick: ()=>{
                                        setSearch("");
                                        setProposalStatus("");
                                        setDateFrom("");
                                        setDateTo("");
                                        // Fetch with explicit empty filters — using the state
                                        // closure here would refetch with the pre-clear values.
                                        fetchOrders(1, {
                                            search: "",
                                            proposalStatus: "",
                                            dateFrom: "",
                                            dateTo: ""
                                        });
                                    },
                                    children: "Limpar"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Typography), {
                    variant: "caption",
                    color: "text.secondary",
                    display: "block",
                    mb: 1,
                    children: loading ? "A carregar\u2026" : `${total} resultado(s)`
                }),
                fetchError && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Alert), {
                    severity: "error",
                    sx: {
                        mb: 2
                    },
                    children: fetchError
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableContainer), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.Table), {
                        size: "small",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableHead), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.TableRow), {
                                    sx: {
                                        "& th": {
                                            fontWeight: 700,
                                            bgcolor: "#f5f5f5"
                                        }
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                            children: "Ref."
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                            children: "Cliente"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                            children: "Estado proposta"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                            children: "Vers\xe3o"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                            align: "right",
                                            children: "Total"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                            children: "Criada em"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.TableBody), {
                                children: [
                                    loading && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableRow), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                            colSpan: 6,
                                            align: "center",
                                            sx: {
                                                py: 4
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.CircularProgress), {
                                                size: 24
                                            })
                                        })
                                    }),
                                    !loading && orders.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableRow), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                            colSpan: 6,
                                            align: "center",
                                            sx: {
                                                py: 4,
                                                color: "text.secondary"
                                            },
                                            children: "Nenhuma proposta encontrada."
                                        })
                                    }),
                                    !loading && orders.map((order)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.TableRow), {
                                            hover: true,
                                            sx: {
                                                cursor: "pointer"
                                            },
                                            onClick: ()=>openProposalDetail(order),
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                                    sx: {
                                                        fontFamily: "monospace",
                                                        fontSize: 13
                                                    },
                                                    children: (0, $d4c0c44600ee9d94$export$7c020bda1e17fd0d)(order.id)
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.TableCell), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Typography), {
                                                            variant: "body2",
                                                            fontWeight: 600,
                                                            children: order.customer_name
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Typography), {
                                                            variant: "caption",
                                                            color: "text.secondary",
                                                            children: order.customer_email
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                                    children: order.proposal_status ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $002d06b4eb083fb3$export$2e2bcd8739ae039), {
                                                        status: order.proposal_status
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Chip), {
                                                        label: "Sem proposta",
                                                        size: "small"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                                    sx: {
                                                        fontFamily: "monospace"
                                                    },
                                                    children: order.proposal_version != null ? `v${order.proposal_version}` : "\u2014"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $91a4e72629291447$exports.TableCell), {
                                                    align: "right",
                                                    children: [
                                                        ((order.total_cents ?? 0) / 100).toFixed(2),
                                                        " \u20AC"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.TableCell), {
                                                    children: new Date(order.created_at).toLocaleDateString("pt-PT")
                                                })
                                            ]
                                        }, order.id))
                                ]
                            })
                        ]
                    })
                }),
                totalPages > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Box), {
                    display: "flex",
                    justifyContent: "center",
                    mt: 2,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91a4e72629291447$exports.Pagination), {
                        count: totalPages,
                        page: page,
                        onChange: (_, p)=>fetchOrders(p),
                        color: "primary",
                        size: "small"
                    })
                })
            ]
        })
    });
};
var $2bfc9d2123736d07$export$2e2bcd8739ae039 = $2bfc9d2123736d07$var$OmsProposalsPage;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");





var $dKcJh = parcelRequire("dKcJh");

var $90blG = parcelRequire("90blG");

var $e5o5x = parcelRequire("e5o5x");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



const $b3dfb4747c3a1283$var$CARRIER_SLUGS = [
    "ctt",
    "ctt_express",
    "dhl",
    "ups",
    "fedex",
    "gls",
    "dpd",
    "seur",
    "manual"
];
const $b3dfb4747c3a1283$var$ShippingCarrierForm = ({ carrier: carrier, onClose: onClose })=>{
    const isEdit = !!carrier;
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const [carrierSlug, setCarrierSlug] = (0, $acw62.useState)(carrier?.carrierSlug || "");
    const [displayName, setDisplayName] = (0, $acw62.useState)(carrier?.displayName || "");
    const [testMode, setTestMode] = (0, $acw62.useState)(carrier?.testMode ?? false);
    const [isDefault, setIsDefault] = (0, $acw62.useState)(carrier?.isDefault ?? false);
    const [weightUnit, setWeightUnit] = (0, $acw62.useState)(carrier?.weightUnit || "kg");
    const [dimensionUnit, setDimensionUnit] = (0, $acw62.useState)(carrier?.dimensionUnit || "cm");
    const [insuranceEnabled, setInsuranceEnabled] = (0, $acw62.useState)(carrier?.insuranceEnabled ?? false);
    const [signatureRequired, setSignatureRequired] = (0, $acw62.useState)(carrier?.signatureRequired ?? false);
    const [accountNumber, setAccountNumber] = (0, $acw62.useState)(carrier?.accountNumber || "");
    const [credentialsJson, setCredentialsJson] = (0, $acw62.useState)("{}");
    const handleSave = async ()=>{
        setSaving(true);
        setError(null);
        try {
            let creds = {};
            try {
                creds = JSON.parse(credentialsJson);
            } catch  {
                setError("Credenciais invalidas (JSON).");
                setSaving(false);
                return;
            }
            if (isEdit) {
                const body = {
                    displayName: displayName,
                    testMode: testMode,
                    isDefault: isDefault,
                    weightUnit: weightUnit,
                    dimensionUnit: dimensionUnit,
                    insuranceEnabled: insuranceEnabled,
                    signatureRequired: signatureRequired,
                    accountNumber: accountNumber
                };
                if (credentialsJson !== "{}") body.credentials = creds;
                await (0, $bac44633733ff026$export$2e2bcd8739ae039).patch(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).SHIPPING_CARRIERS}/${carrier.id}`, body);
            } else {
                const body = {
                    carrierSlug: carrierSlug,
                    displayName: displayName,
                    credentials: creds,
                    testMode: testMode,
                    isDefault: isDefault,
                    weightUnit: weightUnit,
                    dimensionUnit: dimensionUnit,
                    insuranceEnabled: insuranceEnabled,
                    signatureRequired: signatureRequired,
                    accountNumber: accountNumber
                };
                await (0, $bac44633733ff026$export$2e2bcd8739ae039).post((0, $cd93687958c8007e$export$bfe19bc25132bb7c).SHIPPING_CARRIERS, body);
            }
            onClose(true);
        } catch (e) {
            setError(e?.response?.data?.error || "Erro ao guardar.");
        } finally{
            setSaving(false);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "fixed inset-0 bg-black/40 z-50 flex items-center justify-center",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "bg-white rounded-lg shadow-xl w-full max-w-lg max-h-[90vh] overflow-y-auto",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex justify-between items-center p-4 border-b",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "text-lg font-semibold",
                            children: isEdit ? "Editar Transportadora" : "Nova Transportadora"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>onClose(false),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                className: "w-5 h-5 text-gray-500"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "p-4 space-y-4",
                    children: [
                        error && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "bg-red-50 text-red-700 px-3 py-2 rounded text-sm",
                            children: error
                        }),
                        !isEdit && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                    children: "Carrier Slug"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                    className: "block w-full px-3 py-2 border border-gray-300 rounded-lg text-sm",
                                    value: carrierSlug,
                                    onChange: (e)=>setCarrierSlug(e.target.value),
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                            value: "",
                                            children: "Selecionar..."
                                        }),
                                        $b3dfb4747c3a1283$var$CARRIER_SLUGS.map((s)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                value: s,
                                                children: s
                                            }, s))
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                    children: "Nome de Exibicao"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    type: "text",
                                    className: "block w-full px-3 py-2 border border-gray-300 rounded-lg text-sm",
                                    value: displayName,
                                    onChange: (e)=>setDisplayName(e.target.value)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                    children: "Numero de Conta"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    type: "text",
                                    className: "block w-full px-3 py-2 border border-gray-300 rounded-lg text-sm",
                                    value: accountNumber,
                                    onChange: (e)=>setAccountNumber(e.target.value)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "grid grid-cols-2 gap-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            className: "block text-sm font-medium text-gray-700 mb-1",
                                            children: "Unidade de Peso"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                            className: "block w-full px-3 py-2 border border-gray-300 rounded-lg text-sm",
                                            value: weightUnit,
                                            onChange: (e)=>setWeightUnit(e.target.value),
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "kg",
                                                    children: "kg"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "g",
                                                    children: "g"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "lb",
                                                    children: "lb"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            className: "block text-sm font-medium text-gray-700 mb-1",
                                            children: "Unidade de Dimensao"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                            className: "block w-full px-3 py-2 border border-gray-300 rounded-lg text-sm",
                                            value: dimensionUnit,
                                            onChange: (e)=>setDimensionUnit(e.target.value),
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "cm",
                                                    children: "cm"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "in",
                                                    children: "in"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "grid grid-cols-2 gap-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                    className: "flex items-center gap-2 text-sm",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "checkbox",
                                            checked: testMode,
                                            onChange: (e)=>setTestMode(e.target.checked),
                                            className: "w-4 h-4"
                                        }),
                                        "Modo Teste"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                    className: "flex items-center gap-2 text-sm",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "checkbox",
                                            checked: isDefault,
                                            onChange: (e)=>setIsDefault(e.target.checked),
                                            className: "w-4 h-4"
                                        }),
                                        "Default"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                    className: "flex items-center gap-2 text-sm",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "checkbox",
                                            checked: insuranceEnabled,
                                            onChange: (e)=>setInsuranceEnabled(e.target.checked),
                                            className: "w-4 h-4"
                                        }),
                                        "Seguro"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                    className: "flex items-center gap-2 text-sm",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "checkbox",
                                            checked: signatureRequired,
                                            onChange: (e)=>setSignatureRequired(e.target.checked),
                                            className: "w-4 h-4"
                                        }),
                                        "Assinatura"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                    children: "Credenciais (JSON)"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    className: "block w-full px-3 py-2 border border-gray-300 rounded-lg text-sm font-mono",
                                    rows: 3,
                                    value: credentialsJson,
                                    onChange: (e)=>setCredentialsJson(e.target.value),
                                    placeholder: '{"api_key": "...", "secret": "..."}'
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex justify-end gap-2 p-4 border-t",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "button is-light is-small",
                            onClick: ()=>onClose(false),
                            disabled: saving,
                            children: "Cancelar"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "button is-primary is-small",
                            onClick: handleSave,
                            disabled: saving,
                            children: saving ? "A guardar..." : "Guardar"
                        })
                    ]
                })
            ]
        })
    });
};
var $b3dfb4747c3a1283$export$2e2bcd8739ae039 = $b3dfb4747c3a1283$var$ShippingCarrierForm;


/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $b7bdb8b3d2137917$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "15",
            cy: "12",
            r: "3",
            key: "1afu0r"
        }
    ],
    [
        "rect",
        {
            width: "20",
            height: "14",
            x: "2",
            y: "5",
            rx: "7",
            key: "g7kal2"
        }
    ]
];
const $b7bdb8b3d2137917$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("toggle-right", $b7bdb8b3d2137917$export$3efd853dbb351e94);


const $770e70f1f4bf883e$var$ShippingCarrierList = ()=>{
    const [carriers, setCarriers] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    const [editingCarrier, setEditingCarrier] = (0, $acw62.useState)(null);
    const [showForm, setShowForm] = (0, $acw62.useState)(false);
    const fetchCarriers = (0, $acw62.useCallback)(async ()=>{
        setLoading(true);
        setError(null);
        try {
            const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).SHIPPING_CARRIERS);
            setCarriers(res.data?.data || res.data || []);
        } catch (e) {
            setError(e?.response?.data?.error || "Erro ao carregar transportadoras.");
        } finally{
            setLoading(false);
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        fetchCarriers();
    }, [
        fetchCarriers
    ]);
    const handleToggleActive = async (carrier)=>{
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).patch(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).SHIPPING_CARRIERS}/${carrier.id}`, {
                isActive: !carrier.isActive
            });
            await fetchCarriers();
        } catch (e) {
            setError(e?.response?.data?.error || "Erro ao atualizar estado.");
        }
    };
    const handleDelete = async (carrier)=>{
        if (!confirm(`Eliminar transportadora "${carrier.displayName}"?`)) return;
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).delete(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).SHIPPING_CARRIERS}/${carrier.id}`);
            await fetchCarriers();
        } catch (e) {
            setError(e?.response?.data?.error || "Erro ao eliminar.");
        }
    };
    const handleFormClose = (saved)=>{
        setShowForm(false);
        setEditingCarrier(null);
        if (saved) fetchCarriers();
    };
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "text-gray-500 py-4",
        children: "A carregar..."
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            error && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "bg-red-50 text-red-700 px-4 py-2 rounded mb-4 text-sm",
                children: error
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex justify-between items-center mb-4",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "text-lg font-semibold text-gray-800",
                        children: "Transportadoras"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        className: "button is-primary is-small flex items-center gap-1",
                        onClick: ()=>{
                            setEditingCarrier(null);
                            setShowForm(true);
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                className: "w-4 h-4"
                            }),
                            " Adicionar"
                        ]
                    })
                ]
            }),
            carriers.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "text-gray-500 text-sm",
                children: "Nenhuma transportadora configurada."
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "overflow-x-auto",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                    className: "min-w-full text-sm",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                className: "border-b text-left text-gray-500",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "py-2 px-3",
                                        children: "Nome"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "py-2 px-3",
                                        children: "Slug"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "py-2 px-3",
                                        children: "Unidade Peso"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "py-2 px-3",
                                        children: "Modo Teste"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "py-2 px-3",
                                        children: "Default"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "py-2 px-3",
                                        children: "Estado"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "py-2 px-3 text-right",
                                        children: "Acoes"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                            children: carriers.map((c)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                    className: "border-b hover:bg-gray-50",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "py-2 px-3 font-medium",
                                            children: c.displayName
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "py-2 px-3 text-gray-600",
                                            children: c.carrierSlug
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "py-2 px-3",
                                            children: c.weightUnit
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "py-2 px-3",
                                            children: c.testMode ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "text-amber-600",
                                                children: "Sim"
                                            }) : "Nao"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "py-2 px-3",
                                            children: c.isDefault ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "text-blue-600 font-medium",
                                                children: "Sim"
                                            }) : "Nao"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "py-2 px-3",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                onClick: ()=>handleToggleActive(c),
                                                className: "flex items-center gap-1",
                                                title: c.isActive ? "Desativar" : "Ativar",
                                                children: [
                                                    c.isActive ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b7bdb8b3d2137917$export$2e2bcd8739ae039), {
                                                        className: "w-5 h-5 text-green-600"
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9bfa6564caba0fd2$export$2e2bcd8739ae039), {
                                                        className: "w-5 h-5 text-gray-400"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: c.isActive ? "text-green-600" : "text-gray-400",
                                                        children: c.isActive ? "Ativo" : "Inativo"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "py-2 px-3 text-right",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex justify-end gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        className: "text-blue-600 hover:text-blue-800",
                                                        title: "Editar",
                                                        onClick: ()=>{
                                                            setEditingCarrier(c);
                                                            setShowForm(true);
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6c2a827dd5c2d433$export$2e2bcd8739ae039), {
                                                            className: "w-4 h-4"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        className: "text-red-500 hover:text-red-700",
                                                        title: "Eliminar",
                                                        onClick: ()=>handleDelete(c),
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                                            className: "w-4 h-4"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }, c.id))
                        })
                    ]
                })
            }),
            showForm && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b3dfb4747c3a1283$export$2e2bcd8739ae039), {
                carrier: editingCarrier,
                onClose: handleFormClose
            })
        ]
    });
};
var $770e70f1f4bf883e$export$2e2bcd8739ae039 = $770e70f1f4bf883e$var$ShippingCarrierList;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



const $bb41f92fd4716015$var$ShippingZoneForm = ({ zone: zone, onClose: onClose })=>{
    const isEdit = !!zone;
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const [name, setName] = (0, $acw62.useState)(zone?.name || "");
    const [description, setDescription] = (0, $acw62.useState)(zone?.description || "");
    const [countriesInput, setCountriesInput] = (0, $acw62.useState)(zone?.countries?.join(", ") || "");
    const [postcodePrefixesInput, setPostcodePrefixesInput] = (0, $acw62.useState)(zone?.postcodePrefixes?.join(", ") || "");
    const [isActive, setIsActive] = (0, $acw62.useState)(zone?.isActive ?? true);
    const [sortOrder, setSortOrder] = (0, $acw62.useState)(zone?.sortOrder ?? 0);
    const parseCommaSeparated = (val)=>val.split(",").map((s)=>s.trim()).filter(Boolean);
    const handleSave = async ()=>{
        setSaving(true);
        setError(null);
        try {
            const countries = parseCommaSeparated(countriesInput);
            const postcodePrefixes = parseCommaSeparated(postcodePrefixesInput);
            if (isEdit) {
                const body = {
                    name: name,
                    description: description,
                    countries: countries,
                    postcodePrefixes: postcodePrefixes,
                    isActive: isActive,
                    sortOrder: sortOrder
                };
                await (0, $bac44633733ff026$export$2e2bcd8739ae039).put(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).SHIPPING_ZONES}/${zone.id}`, body);
            } else {
                const body = {
                    name: name,
                    description: description,
                    countries: countries,
                    postcodePrefixes: postcodePrefixes,
                    isActive: isActive,
                    sortOrder: sortOrder
                };
                await (0, $bac44633733ff026$export$2e2bcd8739ae039).post((0, $cd93687958c8007e$export$bfe19bc25132bb7c).SHIPPING_ZONES, body);
            }
            onClose(true);
        } catch (e) {
            setError(e?.response?.data?.error || "Erro ao guardar zona.");
        } finally{
            setSaving(false);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "fixed inset-0 bg-black/40 z-50 flex items-center justify-center",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "bg-white rounded-lg shadow-xl w-full max-w-lg max-h-[90vh] overflow-y-auto",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex justify-between items-center p-4 border-b",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "text-lg font-semibold",
                            children: isEdit ? "Editar Zona" : "Nova Zona"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>onClose(false),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                className: "w-5 h-5 text-gray-500"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "p-4 space-y-4",
                    children: [
                        error && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "bg-red-50 text-red-700 px-3 py-2 rounded text-sm",
                            children: error
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                    children: "Nome"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    type: "text",
                                    className: "block w-full px-3 py-2 border border-gray-300 rounded-lg text-sm",
                                    value: name,
                                    onChange: (e)=>setName(e.target.value)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                    children: "Descricao"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    className: "block w-full px-3 py-2 border border-gray-300 rounded-lg text-sm",
                                    rows: 2,
                                    value: description,
                                    onChange: (e)=>setDescription(e.target.value)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                    children: "Paises (codigos ISO, separados por virgula)"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    type: "text",
                                    className: "block w-full px-3 py-2 border border-gray-300 rounded-lg text-sm",
                                    value: countriesInput,
                                    onChange: (e)=>setCountriesInput(e.target.value),
                                    placeholder: "PT, ES, FR"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                    children: "Prefixos de Codigo Postal (separados por virgula)"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    type: "text",
                                    className: "block w-full px-3 py-2 border border-gray-300 rounded-lg text-sm",
                                    value: postcodePrefixesInput,
                                    onChange: (e)=>setPostcodePrefixesInput(e.target.value),
                                    placeholder: "1000, 2000, 3000"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "grid grid-cols-2 gap-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            className: "block text-sm font-medium text-gray-700 mb-1",
                                            children: "Ordem"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "number",
                                            className: "block w-full px-3 py-2 border border-gray-300 rounded-lg text-sm",
                                            value: sortOrder,
                                            onChange: (e)=>setSortOrder(parseInt(e.target.value) || 0)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                    className: "flex items-center gap-2 text-sm mt-6",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "checkbox",
                                            checked: isActive,
                                            onChange: (e)=>setIsActive(e.target.checked),
                                            className: "w-4 h-4"
                                        }),
                                        "Ativa"
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex justify-end gap-2 p-4 border-t",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "button is-light is-small",
                            onClick: ()=>onClose(false),
                            disabled: saving,
                            children: "Cancelar"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "button is-primary is-small",
                            onClick: handleSave,
                            disabled: saving,
                            children: saving ? "A guardar..." : "Guardar"
                        })
                    ]
                })
            ]
        })
    });
};
var $bb41f92fd4716015$export$2e2bcd8739ae039 = $bb41f92fd4716015$var$ShippingZoneForm;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



const $536ee35283aa9fa7$var$ShippingRateForm = ({ zoneId: zoneId, rate: rate, carriers: carriers, onClose: onClose })=>{
    const isEdit = !!rate;
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const [carrierConfigId, setCarrierConfigId] = (0, $acw62.useState)(rate?.carrierConfigId || "");
    const [serviceLevel, setServiceLevel] = (0, $acw62.useState)(rate?.serviceLevel || "");
    const [serviceName, setServiceName] = (0, $acw62.useState)(rate?.serviceName || "");
    const [minWeightGrams, setMinWeightGrams] = (0, $acw62.useState)(rate?.minWeightGrams ?? 0);
    const [maxWeightGrams, setMaxWeightGrams] = (0, $acw62.useState)(rate?.maxWeightGrams ?? 0);
    const [priceEuros, setPriceEuros] = (0, $acw62.useState)(rate ? (rate.priceAmount / 100).toFixed(2) : "");
    const [currency, setCurrency] = (0, $acw62.useState)(rate?.currency || "EUR");
    const [transitDaysMin, setTransitDaysMin] = (0, $acw62.useState)(rate?.transitDaysMin ?? 1);
    const [transitDaysMax, setTransitDaysMax] = (0, $acw62.useState)(rate?.transitDaysMax ?? 5);
    const [isActive, setIsActive] = (0, $acw62.useState)(rate?.isActive ?? true);
    const [freeShippingEuros, setFreeShippingEuros] = (0, $acw62.useState)(rate ? (rate.freeShippingThreshold / 100).toFixed(2) : "0");
    const eurosToCents = (val)=>Math.round(parseFloat(val || "0") * 100);
    const handleSave = async ()=>{
        setSaving(true);
        setError(null);
        try {
            if (isEdit) {
                const body = {
                    serviceLevel: serviceLevel,
                    serviceName: serviceName,
                    minWeightGrams: minWeightGrams,
                    maxWeightGrams: maxWeightGrams,
                    priceAmount: eurosToCents(priceEuros),
                    currency: currency,
                    transitDaysMin: transitDaysMin,
                    transitDaysMax: transitDaysMax,
                    isActive: isActive,
                    freeShippingThreshold: eurosToCents(freeShippingEuros)
                };
                await (0, $bac44633733ff026$export$2e2bcd8739ae039).put(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).SHIPPING_ZONES}/${zoneId}/rates/${rate.id}`, body);
            } else {
                const body = {
                    carrierConfigId: carrierConfigId,
                    serviceLevel: serviceLevel,
                    serviceName: serviceName,
                    minWeightGrams: minWeightGrams,
                    maxWeightGrams: maxWeightGrams,
                    priceAmount: eurosToCents(priceEuros),
                    currency: currency,
                    transitDaysMin: transitDaysMin,
                    transitDaysMax: transitDaysMax,
                    isActive: isActive,
                    freeShippingThreshold: eurosToCents(freeShippingEuros)
                };
                await (0, $bac44633733ff026$export$2e2bcd8739ae039).post(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).SHIPPING_ZONES}/${zoneId}/rates`, body);
            }
            onClose(true);
        } catch (e) {
            setError(e?.response?.data?.error || "Erro ao guardar tarifa.");
        } finally{
            setSaving(false);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "fixed inset-0 bg-black/40 z-50 flex items-center justify-center",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "bg-white rounded-lg shadow-xl w-full max-w-lg max-h-[90vh] overflow-y-auto",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex justify-between items-center p-4 border-b",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "text-lg font-semibold",
                            children: isEdit ? "Editar Tarifa" : "Nova Tarifa"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>onClose(false),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                className: "w-5 h-5 text-gray-500"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "p-4 space-y-4",
                    children: [
                        error && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "bg-red-50 text-red-700 px-3 py-2 rounded text-sm",
                            children: error
                        }),
                        !isEdit && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                    children: "Transportadora"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                    className: "block w-full px-3 py-2 border border-gray-300 rounded-lg text-sm",
                                    value: carrierConfigId,
                                    onChange: (e)=>setCarrierConfigId(e.target.value),
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                            value: "",
                                            children: "Selecionar..."
                                        }),
                                        carriers.filter((c)=>c.isActive).map((c)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("option", {
                                                value: c.id,
                                                children: [
                                                    c.displayName,
                                                    " (",
                                                    c.carrierSlug,
                                                    ")"
                                                ]
                                            }, c.id))
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "grid grid-cols-2 gap-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            className: "block text-sm font-medium text-gray-700 mb-1",
                                            children: "Nivel de Servico"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "text",
                                            className: "block w-full px-3 py-2 border border-gray-300 rounded-lg text-sm",
                                            value: serviceLevel,
                                            onChange: (e)=>setServiceLevel(e.target.value),
                                            placeholder: "standard, express..."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            className: "block text-sm font-medium text-gray-700 mb-1",
                                            children: "Nome do Servico"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "text",
                                            className: "block w-full px-3 py-2 border border-gray-300 rounded-lg text-sm",
                                            value: serviceName,
                                            onChange: (e)=>setServiceName(e.target.value),
                                            placeholder: "Envio Standard"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "grid grid-cols-2 gap-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            className: "block text-sm font-medium text-gray-700 mb-1",
                                            children: "Peso Min. (gramas)"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "number",
                                            className: "block w-full px-3 py-2 border border-gray-300 rounded-lg text-sm",
                                            value: minWeightGrams,
                                            onChange: (e)=>setMinWeightGrams(parseInt(e.target.value) || 0)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            className: "block text-sm font-medium text-gray-700 mb-1",
                                            children: "Peso Max. (gramas, 0=sem limite)"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "number",
                                            className: "block w-full px-3 py-2 border border-gray-300 rounded-lg text-sm",
                                            value: maxWeightGrams,
                                            onChange: (e)=>setMaxWeightGrams(parseInt(e.target.value) || 0)
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "grid grid-cols-2 gap-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            className: "block text-sm font-medium text-gray-700 mb-1",
                                            children: "Preco (EUR)"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "text",
                                            className: "block w-full px-3 py-2 border border-gray-300 rounded-lg text-sm",
                                            value: priceEuros,
                                            onChange: (e)=>setPriceEuros(e.target.value),
                                            placeholder: "4.99"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            className: "block text-sm font-medium text-gray-700 mb-1",
                                            children: "Moeda"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "text",
                                            className: "block w-full px-3 py-2 border border-gray-300 rounded-lg text-sm",
                                            value: currency,
                                            onChange: (e)=>setCurrency(e.target.value)
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "grid grid-cols-2 gap-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            className: "block text-sm font-medium text-gray-700 mb-1",
                                            children: "Dias Transito Min"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "number",
                                            className: "block w-full px-3 py-2 border border-gray-300 rounded-lg text-sm",
                                            value: transitDaysMin,
                                            onChange: (e)=>setTransitDaysMin(parseInt(e.target.value) || 1)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            className: "block text-sm font-medium text-gray-700 mb-1",
                                            children: "Dias Transito Max"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "number",
                                            className: "block w-full px-3 py-2 border border-gray-300 rounded-lg text-sm",
                                            value: transitDaysMax,
                                            onChange: (e)=>setTransitDaysMax(parseInt(e.target.value) || 5)
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "grid grid-cols-2 gap-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            className: "block text-sm font-medium text-gray-700 mb-1",
                                            children: "Gratis a partir de (EUR, 0=desativado)"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "text",
                                            className: "block w-full px-3 py-2 border border-gray-300 rounded-lg text-sm",
                                            value: freeShippingEuros,
                                            onChange: (e)=>setFreeShippingEuros(e.target.value),
                                            placeholder: "50.00"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                    className: "flex items-center gap-2 text-sm mt-6",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "checkbox",
                                            checked: isActive,
                                            onChange: (e)=>setIsActive(e.target.checked),
                                            className: "w-4 h-4"
                                        }),
                                        "Ativa"
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex justify-end gap-2 p-4 border-t",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "button is-light is-small",
                            onClick: ()=>onClose(false),
                            disabled: saving,
                            children: "Cancelar"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "button is-primary is-small",
                            onClick: handleSave,
                            disabled: saving,
                            children: saving ? "A guardar..." : "Guardar"
                        })
                    ]
                })
            ]
        })
    });
};
var $536ee35283aa9fa7$export$2e2bcd8739ae039 = $536ee35283aa9fa7$var$ShippingRateForm;



const $04ba2a5719906201$var$ShippingZoneList = ()=>{
    const [zones, setZones] = (0, $acw62.useState)([]);
    const [carriers, setCarriers] = (0, $acw62.useState)([]);
    const [rates, setRates] = (0, $acw62.useState)({});
    const [expandedZones, setExpandedZones] = (0, $acw62.useState)(new Set());
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    const [editingZone, setEditingZone] = (0, $acw62.useState)(null);
    const [showZoneForm, setShowZoneForm] = (0, $acw62.useState)(false);
    const [editingRate, setEditingRate] = (0, $acw62.useState)(null);
    const [rateZoneId, setRateZoneId] = (0, $acw62.useState)(null);
    const [showRateForm, setShowRateForm] = (0, $acw62.useState)(false);
    const fetchZones = (0, $acw62.useCallback)(async ()=>{
        setLoading(true);
        setError(null);
        try {
            const [zonesRes, carriersRes] = await Promise.all([
                (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).SHIPPING_ZONES),
                (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).SHIPPING_CARRIERS)
            ]);
            setZones(zonesRes.data?.data || zonesRes.data || []);
            setCarriers(carriersRes.data?.data || carriersRes.data || []);
        } catch (e) {
            setError(e?.response?.data?.error || "Erro ao carregar zonas.");
        } finally{
            setLoading(false);
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        fetchZones();
    }, [
        fetchZones
    ]);
    const fetchRates = async (zoneId)=>{
        try {
            const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).SHIPPING_ZONES}/${zoneId}/rates`);
            setRates((prev)=>({
                    ...prev,
                    [zoneId]: res.data?.data || res.data || []
                }));
        } catch (e) {
            setError(e?.response?.data?.error || "Erro ao carregar tarifas.");
        }
    };
    const toggleExpand = (zoneId)=>{
        const next = new Set(expandedZones);
        if (next.has(zoneId)) next.delete(zoneId);
        else {
            next.add(zoneId);
            if (!rates[zoneId]) fetchRates(zoneId);
        }
        setExpandedZones(next);
    };
    const handleDeleteZone = async (zone)=>{
        if (!confirm(`Eliminar zona "${zone.name}"?`)) return;
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).delete(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).SHIPPING_ZONES}/${zone.id}`);
            await fetchZones();
        } catch (e) {
            setError(e?.response?.data?.error || "Erro ao eliminar zona.");
        }
    };
    const handleDeleteRate = async (zoneId, rateId)=>{
        if (!confirm("Eliminar esta tarifa?")) return;
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).delete(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).SHIPPING_ZONES}/${zoneId}/rates/${rateId}`);
            await fetchRates(zoneId);
        } catch (e) {
            setError(e?.response?.data?.error || "Erro ao eliminar tarifa.");
        }
    };
    const handleToggleZoneActive = async (zone)=>{
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).put(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).SHIPPING_ZONES}/${zone.id}`, {
                isActive: !zone.isActive
            });
            await fetchZones();
        } catch (e) {
            setError(e?.response?.data?.error || "Erro ao atualizar estado.");
        }
    };
    const carrierName = (id)=>carriers.find((c)=>c.id === id)?.displayName || id.slice(0, 8);
    const formatCents = (cents)=>(cents / 100).toFixed(2).replace(".", ",") + " EUR";
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "text-gray-500 py-4",
        children: "A carregar..."
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            error && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "bg-red-50 text-red-700 px-4 py-2 rounded mb-4 text-sm",
                children: error
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex justify-between items-center mb-4",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "text-lg font-semibold text-gray-800",
                        children: "Zonas de Envio"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        className: "button is-primary is-small flex items-center gap-1",
                        onClick: ()=>{
                            setEditingZone(null);
                            setShowZoneForm(true);
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                className: "w-4 h-4"
                            }),
                            " Adicionar Zona"
                        ]
                    })
                ]
            }),
            zones.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "text-gray-500 text-sm",
                children: "Nenhuma zona configurada."
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "space-y-2",
                children: zones.map((zone)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "border rounded-lg overflow-hidden",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center justify-between px-4 py-3 bg-gray-50 hover:bg-gray-100 cursor-pointer",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center gap-2 flex-1",
                                        onClick: ()=>toggleExpand(zone.id),
                                        children: [
                                            expandedZones.has(zone.id) ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                                className: "w-4 h-4 text-gray-500"
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                                                className: "w-4 h-4 text-gray-500"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "font-medium text-gray-800",
                                                children: zone.name
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "text-xs text-gray-500",
                                                children: zone.countries?.join(", ")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                onClick: ()=>handleToggleZoneActive(zone),
                                                title: zone.isActive ? "Desativar" : "Ativar",
                                                children: zone.isActive ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b7bdb8b3d2137917$export$2e2bcd8739ae039), {
                                                    className: "w-5 h-5 text-green-600"
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9bfa6564caba0fd2$export$2e2bcd8739ae039), {
                                                    className: "w-5 h-5 text-gray-400"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                className: "text-blue-600 hover:text-blue-800",
                                                title: "Editar",
                                                onClick: ()=>{
                                                    setEditingZone(zone);
                                                    setShowZoneForm(true);
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6c2a827dd5c2d433$export$2e2bcd8739ae039), {
                                                    className: "w-4 h-4"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                className: "text-red-500 hover:text-red-700",
                                                title: "Eliminar",
                                                onClick: ()=>handleDeleteZone(zone),
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                                    className: "w-4 h-4"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            expandedZones.has(zone.id) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "px-4 py-3 border-t",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex justify-between items-center mb-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "text-sm font-medium text-gray-600",
                                                children: "Tarifas"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                className: "text-sm text-blue-600 hover:text-blue-800 flex items-center gap-1",
                                                onClick: ()=>{
                                                    setEditingRate(null);
                                                    setRateZoneId(zone.id);
                                                    setShowRateForm(true);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                                        className: "w-3 h-3"
                                                    }),
                                                    " Adicionar Tarifa"
                                                ]
                                            })
                                        ]
                                    }),
                                    !rates[zone.id] ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "text-gray-400 text-sm",
                                        children: "A carregar..."
                                    }) : rates[zone.id].length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "text-gray-400 text-sm",
                                        children: "Sem tarifas configuradas."
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                                        className: "min-w-full text-sm",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                    className: "text-left text-gray-500 border-b",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                            className: "py-1 px-2",
                                                            children: "Transportadora"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                            className: "py-1 px-2",
                                                            children: "Servico"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                            className: "py-1 px-2",
                                                            children: "Peso (g)"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                            className: "py-1 px-2",
                                                            children: "Preco"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                            className: "py-1 px-2",
                                                            children: "Transito"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                            className: "py-1 px-2",
                                                            children: "Gratis desde"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                            className: "py-1 px-2 text-right",
                                                            children: "Acoes"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                                children: rates[zone.id].map((rate)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                        className: "border-b hover:bg-gray-50",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                className: "py-1 px-2",
                                                                children: carrierName(rate.carrierConfigId)
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                className: "py-1 px-2",
                                                                children: rate.serviceName || rate.serviceLevel
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                                className: "py-1 px-2",
                                                                children: [
                                                                    rate.minWeightGrams,
                                                                    "-",
                                                                    rate.maxWeightGrams || "inf"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                className: "py-1 px-2",
                                                                children: formatCents(rate.priceAmount)
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                                className: "py-1 px-2",
                                                                children: [
                                                                    rate.transitDaysMin,
                                                                    "-",
                                                                    rate.transitDaysMax,
                                                                    "d"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                className: "py-1 px-2",
                                                                children: rate.freeShippingThreshold > 0 ? formatCents(rate.freeShippingThreshold) : "-"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                className: "py-1 px-2 text-right",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "flex justify-end gap-2",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                            className: "text-blue-600 hover:text-blue-800",
                                                                            title: "Editar",
                                                                            onClick: ()=>{
                                                                                setEditingRate(rate);
                                                                                setRateZoneId(zone.id);
                                                                                setShowRateForm(true);
                                                                            },
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6c2a827dd5c2d433$export$2e2bcd8739ae039), {
                                                                                className: "w-3.5 h-3.5"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                            className: "text-red-500 hover:text-red-700",
                                                                            title: "Eliminar",
                                                                            onClick: ()=>handleDeleteRate(zone.id, rate.id),
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                                                                className: "w-3.5 h-3.5"
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }, rate.id))
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, zone.id))
            }),
            showZoneForm && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bb41f92fd4716015$export$2e2bcd8739ae039), {
                zone: editingZone,
                onClose: (saved)=>{
                    setShowZoneForm(false);
                    setEditingZone(null);
                    if (saved) fetchZones();
                }
            }),
            showRateForm && rateZoneId && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $536ee35283aa9fa7$export$2e2bcd8739ae039), {
                zoneId: rateZoneId,
                rate: editingRate,
                carriers: carriers,
                onClose: (saved)=>{
                    setShowRateForm(false);
                    setEditingRate(null);
                    if (saved && rateZoneId) fetchRates(rateZoneId);
                    setRateZoneId(null);
                }
            })
        ]
    });
};
var $04ba2a5719906201$export$2e2bcd8739ae039 = $04ba2a5719906201$var$ShippingZoneList;


const $fec7736d870f8edb$var$ShippingManager = ()=>{
    const [section, setSection] = (0, $acw62.useState)("carriers");
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex gap-2 mb-4",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: `px-4 py-2 rounded text-sm font-medium ${section === "carriers" ? "bg-blue-600 text-white" : "bg-gray-100 text-gray-700 hover:bg-gray-200"}`,
                        onClick: ()=>setSection("carriers"),
                        children: "Transportadoras"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: `px-4 py-2 rounded text-sm font-medium ${section === "zones" ? "bg-blue-600 text-white" : "bg-gray-100 text-gray-700 hover:bg-gray-200"}`,
                        onClick: ()=>setSection("zones"),
                        children: "Zonas e Tarifas"
                    })
                ]
            }),
            section === "carriers" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $770e70f1f4bf883e$export$2e2bcd8739ae039), {}),
            section === "zones" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04ba2a5719906201$export$2e2bcd8739ae039), {})
        ]
    });
};
var $fec7736d870f8edb$export$2e2bcd8739ae039 = $fec7736d870f8edb$var$ShippingManager;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


// ── Provider Config ─────────────────────────────────────────────────────────
const $919ffafbc2ebec26$export$6a1946998a6f9b63 = [
    "stripe",
    "manual",
    "ifthenpay",
    "paypal",
    "adyen",
    "easypay",
    "eupago",
    "sequra"
];
const $919ffafbc2ebec26$export$d6e58abbbec7e1ac = [
    "credit_card",
    "mbway",
    "multibanco",
    "bank_transfer",
    "apple_pay",
    "google_pay",
    "cheque",
    "floa",
    "sequra"
];
const $919ffafbc2ebec26$export$50a1ee6753bccfcb = {
    stripe: "Stripe",
    manual: "Transferencia Bancaria",
    ifthenpay: "IfthenPay",
    paypal: "PayPal",
    adyen: "Adyen",
    easypay: "Easypay",
    eupago: "EuPago",
    sequra: "SeQura"
};
const $919ffafbc2ebec26$export$9df043cd05acf7a4 = {
    credit_card: "Cartao de Credito",
    mbway: "MB WAY",
    multibanco: "Multibanco",
    bank_transfer: "Transferencia Bancaria",
    apple_pay: "Apple Pay",
    google_pay: "Google Pay",
    cheque: "Cheque",
    floa: "FLOA (3x)",
    sequra: "SeQura"
};
function $919ffafbc2ebec26$export$f25be5456d5508cc(requireAuth, nifRequirement, nifPrefixes) {
    const rules = [];
    if (requireAuth) rules.push({
        type: "authenticated"
    });
    if (nifRequirement === "any") rules.push({
        type: "nif"
    });
    else if (nifRequirement === "company" || nifRequirement === "individual") rules.push({
        type: "nif",
        kind: nifRequirement
    });
    const prefixes = nifPrefixes.split(",").map((s)=>s.trim()).filter(Boolean);
    if (prefixes.length > 0) rules.push({
        type: "nif_prefix",
        prefixes: prefixes
    });
    return rules;
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




const $a9a3b8e788ff76cd$var$CREDENTIAL_FIELDS = {
    stripe: {
        apiKeyLabel: "Chave Secreta (Secret Key)",
        apiKeyPlaceholder: "sk_live_...",
        webhookLabel: "Segredo do Webhook",
        webhookPlaceholder: "whsec_...",
        extraFields: [
            {
                key: "publishable_key",
                label: "Chave Publicavel (Publishable Key)",
                placeholder: "pk_live_..."
            }
        ]
    },
    paypal: {
        apiKeyLabel: "Client ID",
        apiKeyPlaceholder: "client_id...",
        webhookLabel: "Client Secret",
        webhookPlaceholder: "client_secret..."
    },
    adyen: {
        apiKeyLabel: "API Key",
        apiKeyPlaceholder: "AQEyhmft...",
        webhookLabel: "HMAC Key (Webhook)",
        webhookPlaceholder: "hmac_key..."
    },
    ifthenpay: {
        apiKeyLabel: "IfthenPay Key",
        apiKeyPlaceholder: "ifthenpay_key...",
        webhookLabel: "Webhook Secret",
        webhookPlaceholder: "whsec_..."
    },
    easypay: {
        apiKeyLabel: "Chave de API (ApiKey)",
        apiKeyPlaceholder: "api_key...",
        webhookLabel: "Webhook Secret",
        webhookPlaceholder: "whsec_..."
    },
    eupago: {
        apiKeyLabel: "Chave de API",
        apiKeyPlaceholder: "api_key...",
        webhookLabel: "Webhook Secret",
        webhookPlaceholder: "whsec_..."
    },
    sequra: {
        apiKeyLabel: "Credenciais (MerchantRef|Username|Secret)",
        apiKeyPlaceholder: "merchant_ref|username|secret",
        webhookLabel: "Signature Secret (HMAC Webhook)",
        webhookPlaceholder: "signature_secret..."
    }
};
const $a9a3b8e788ff76cd$var$PaymentProviderForm = ({ provider: provider, onClose: onClose })=>{
    const isEdit = !!provider;
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const [providerName, setProviderName] = (0, $acw62.useState)(provider?.provider_name || "");
    const [isEnabled, setIsEnabled] = (0, $acw62.useState)(provider?.is_enabled ?? true);
    const [environment, setEnvironment] = (0, $acw62.useState)(provider?.environment || "test");
    const [apiKey, setApiKey] = (0, $acw62.useState)("");
    const [webhookSecret, setWebhookSecret] = (0, $acw62.useState)("");
    const [publishableKey, setPublishableKey] = (0, $acw62.useState)(provider?.publishable_key || "");
    // Manual provider fields
    const [manualBankName, setManualBankName] = (0, $acw62.useState)(provider?.manual_bank_name || "");
    const [manualIban, setManualIban] = (0, $acw62.useState)(provider?.manual_iban || "");
    const [manualBic, setManualBic] = (0, $acw62.useState)(provider?.manual_bic || "");
    const [manualAccountHolder, setManualAccountHolder] = (0, $acw62.useState)(provider?.manual_account_holder || "");
    const [manualPayableTo, setManualPayableTo] = (0, $acw62.useState)(provider?.manual_payable_to || "");
    const [manualMailingAddress, setManualMailingAddress] = (0, $acw62.useState)(provider?.manual_mailing_address || "");
    const [manualTtlHours, setManualTtlHours] = (0, $acw62.useState)(provider?.manual_ttl_hours ?? 72);
    const isManual = providerName === "manual";
    const isAutoProvider = providerName === "stripe" || providerName === "paypal" || providerName === "adyen" || providerName === "ifthenpay" || providerName === "easypay" || providerName === "eupago" || providerName === "sequra";
    const credentialConfig = $a9a3b8e788ff76cd$var$CREDENTIAL_FIELDS[providerName];
    const handleSave = async ()=>{
        const label = (0, $919ffafbc2ebec26$export$50a1ee6753bccfcb)[providerName] || providerName;
        const rotating = !isManual && (apiKey.length > 0 || webhookSecret.length > 0);
        const confirmed = window.confirm(rotating ? `Guardar novas credenciais para "${label}"? As chaves atuais s\xe3o substitu\xeddas imediatamente e os pagamentos passam a usar as novas.` : `Guardar a configura\xe7\xe3o de "${label}"?`);
        if (!confirmed) return;
        setSaving(true);
        setError(null);
        try {
            const body = {
                provider_name: providerName,
                is_enabled: isEnabled,
                environment: environment
            };
            if (apiKey) body.api_key = apiKey;
            if (webhookSecret) body.webhook_secret = webhookSecret;
            if (publishableKey) body.publishable_key = publishableKey;
            if (isManual) {
                body.manual_bank_name = manualBankName;
                body.manual_iban = manualIban;
                body.manual_bic = manualBic;
                body.manual_account_holder = manualAccountHolder;
                body.manual_payable_to = manualPayableTo;
                body.manual_mailing_address = manualMailingAddress;
                body.manual_ttl_hours = manualTtlHours;
            }
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).put((0, $cd93687958c8007e$export$bfe19bc25132bb7c).PAYMENT_PROVIDER_CONFIGS, body);
            onClose(true);
        } catch (e) {
            setError(e?.response?.data?.error || "Erro ao guardar.");
        } finally{
            setSaving(false);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "fixed inset-0 bg-black/40 z-50 flex items-center justify-center",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "bg-white rounded-lg shadow-xl w-full max-w-lg max-h-[90vh] overflow-y-auto",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex justify-between items-center p-4 border-b",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "text-lg font-semibold",
                            children: isEdit ? "Editar Fornecedor" : "Novo Fornecedor"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>onClose(false),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                className: "w-5 h-5 text-gray-500"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "p-4 space-y-4",
                    children: [
                        error && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "bg-red-50 text-red-700 px-3 py-2 rounded text-sm",
                            children: error
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "select is-fullwidth",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                value: providerName,
                                onChange: (e)=>setProviderName(e.target.value),
                                disabled: isEdit,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "",
                                        children: "Selecionar..."
                                    }),
                                    (0, $919ffafbc2ebec26$export$6a1946998a6f9b63).map((n)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                            value: n,
                                            children: (0, $919ffafbc2ebec26$export$50a1ee6753bccfcb)[n]
                                        }, n))
                                ]
                            })
                        }),
                        providerName && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "grid grid-cols-2 gap-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "select is-fullwidth",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                        value: environment,
                                        onChange: (e)=>setEnvironment(e.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                value: "test",
                                                children: "Test"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                value: "live",
                                                children: "Live"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                    className: "flex items-center gap-2 text-sm",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "checkbox",
                                            checked: isEnabled,
                                            onChange: (e)=>setIsEnabled(e.target.checked),
                                            className: "w-4 h-4"
                                        }),
                                        "Ativo"
                                    ]
                                })
                            ]
                        }),
                        isAutoProvider && credentialConfig && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                            className: "block text-sm font-medium text-gray-700 mb-1",
                                            children: [
                                                credentialConfig.apiKeyLabel,
                                                " ",
                                                isEdit && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "text-gray-400 font-normal",
                                                    children: "(deixe vazio para manter)"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "password",
                                            className: "input",
                                            value: apiKey,
                                            onChange: (e)=>setApiKey(e.target.value),
                                            placeholder: isEdit ? provider?.api_key_masked || "****" : credentialConfig.apiKeyPlaceholder
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                            className: "block text-sm font-medium text-gray-700 mb-1",
                                            children: [
                                                credentialConfig.webhookLabel,
                                                " ",
                                                isEdit && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "text-gray-400 font-normal",
                                                    children: "(deixe vazio para manter)"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "password",
                                            className: "input",
                                            value: webhookSecret,
                                            onChange: (e)=>setWebhookSecret(e.target.value),
                                            placeholder: credentialConfig.webhookPlaceholder
                                        })
                                    ]
                                }),
                                credentialConfig.extraFields?.map((field)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                className: "block text-sm font-medium text-gray-700 mb-1",
                                                children: field.label
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                type: "text",
                                                className: "input",
                                                value: field.key === "publishable_key" ? publishableKey : "",
                                                onChange: (e)=>{
                                                    if (field.key === "publishable_key") setPublishableKey(e.target.value);
                                                },
                                                placeholder: field.placeholder
                                            })
                                        ]
                                    }, field.key))
                            ]
                        }),
                        isManual && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            className: "block text-sm font-medium text-gray-700 mb-1",
                                            children: "Nome do Banco"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "text",
                                            className: "input",
                                            value: manualBankName,
                                            onChange: (e)=>setManualBankName(e.target.value)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "grid grid-cols-2 gap-4",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                                    children: "IBAN"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "text",
                                                    className: "input",
                                                    value: manualIban,
                                                    onChange: (e)=>setManualIban(e.target.value)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                                    children: "BIC/SWIFT"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "text",
                                                    className: "input",
                                                    value: manualBic,
                                                    onChange: (e)=>setManualBic(e.target.value)
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            className: "block text-sm font-medium text-gray-700 mb-1",
                                            children: "Titular da Conta"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "text",
                                            className: "input",
                                            value: manualAccountHolder,
                                            onChange: (e)=>setManualAccountHolder(e.target.value)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            className: "block text-sm font-medium text-gray-700 mb-1",
                                            children: "Pagavel a"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "text",
                                            className: "input",
                                            value: manualPayableTo,
                                            onChange: (e)=>setManualPayableTo(e.target.value)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            className: "block text-sm font-medium text-gray-700 mb-1",
                                            children: "Morada para Envio"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                            className: "textarea",
                                            rows: 2,
                                            value: manualMailingAddress,
                                            onChange: (e)=>setManualMailingAddress(e.target.value)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            className: "block text-sm font-medium text-gray-700 mb-1",
                                            children: "TTL Horas (prazo para pagamento)"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "number",
                                            className: "input",
                                            value: manualTtlHours,
                                            onChange: (e)=>setManualTtlHours(parseInt(e.target.value) || 72)
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex justify-end gap-2 p-4 border-t",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "button is-light is-small",
                            onClick: ()=>onClose(false),
                            disabled: saving,
                            children: "Cancelar"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "button is-primary is-small",
                            onClick: handleSave,
                            disabled: saving || !providerName,
                            children: saving ? "A guardar..." : "Guardar"
                        })
                    ]
                })
            ]
        })
    });
};
var $a9a3b8e788ff76cd$export$2e2bcd8739ae039 = $a9a3b8e788ff76cd$var$PaymentProviderForm;



const $d1d4888b24ab3767$var$PaymentProviderList = ()=>{
    const [providers, setProviders] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    const [editingProvider, setEditingProvider] = (0, $acw62.useState)(null);
    const [showForm, setShowForm] = (0, $acw62.useState)(false);
    const fetchProviders = (0, $acw62.useCallback)(async ()=>{
        setLoading(true);
        setError(null);
        try {
            const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).PAYMENT_PROVIDER_CONFIGS);
            setProviders(res.data?.data || res.data || []);
        } catch (e) {
            setError(e?.response?.data?.error || "Erro ao carregar fornecedores.");
        } finally{
            setLoading(false);
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        fetchProviders();
    }, [
        fetchProviders
    ]);
    const handleToggleEnabled = async (provider)=>{
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).put((0, $cd93687958c8007e$export$bfe19bc25132bb7c).PAYMENT_PROVIDER_CONFIGS, {
                provider_name: provider.provider_name,
                is_enabled: !provider.is_enabled,
                environment: provider.environment
            });
            await fetchProviders();
        } catch (e) {
            setError(e?.response?.data?.error || "Erro ao atualizar estado.");
        }
    };
    const handleDelete = async (provider)=>{
        if (!confirm(`Eliminar fornecedor "${(0, $919ffafbc2ebec26$export$50a1ee6753bccfcb)[provider.provider_name] || provider.provider_name}"?`)) return;
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).delete(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).PAYMENT_PROVIDER_CONFIGS}/${provider.provider_name}`);
            await fetchProviders();
        } catch (e) {
            setError(e?.response?.data?.error || "Erro ao eliminar.");
        }
    };
    const handleFormClose = (saved)=>{
        setShowForm(false);
        setEditingProvider(null);
        if (saved) fetchProviders();
    };
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "text-gray-500 py-4",
        children: "A carregar..."
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            error && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "bg-red-50 text-red-700 px-4 py-2 rounded mb-4 text-sm",
                children: error
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex justify-between items-center mb-4",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "text-lg font-semibold text-gray-800",
                        children: "Fornecedores de Pagamento"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        className: "button is-primary is-small flex items-center gap-1",
                        onClick: ()=>{
                            setEditingProvider(null);
                            setShowForm(true);
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                className: "w-4 h-4"
                            }),
                            " Adicionar"
                        ]
                    })
                ]
            }),
            providers.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "text-gray-500 text-sm",
                children: "Nenhum fornecedor configurado."
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "overflow-x-auto",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                    className: "min-w-full text-sm",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                className: "border-b text-left text-gray-500",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "py-2 px-3",
                                        children: "Fornecedor"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "py-2 px-3",
                                        children: "Ambiente"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "py-2 px-3",
                                        children: "API Key"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "py-2 px-3",
                                        children: "Estado"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "py-2 px-3 text-right",
                                        children: "Acoes"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                            children: providers.map((p)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                    className: "border-b hover:bg-gray-50",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "py-2 px-3 font-medium",
                                            children: (0, $919ffafbc2ebec26$export$50a1ee6753bccfcb)[p.provider_name] || p.provider_name
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "py-2 px-3",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: `px-2 py-0.5 rounded text-xs font-medium ${p.environment === "live" ? "bg-green-100 text-green-700" : "bg-amber-100 text-amber-700"}`,
                                                children: p.environment
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "py-2 px-3 text-gray-500 font-mono text-xs",
                                            children: p.api_key_masked || "-"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "py-2 px-3",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                onClick: ()=>handleToggleEnabled(p),
                                                className: "flex items-center gap-1",
                                                title: p.is_enabled ? "Desativar" : "Ativar",
                                                children: [
                                                    p.is_enabled ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b7bdb8b3d2137917$export$2e2bcd8739ae039), {
                                                        className: "w-5 h-5 text-green-600"
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9bfa6564caba0fd2$export$2e2bcd8739ae039), {
                                                        className: "w-5 h-5 text-gray-400"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: p.is_enabled ? "text-green-600" : "text-gray-400",
                                                        children: p.is_enabled ? "Ativo" : "Inativo"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "py-2 px-3 text-right",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex justify-end gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        className: "text-blue-600 hover:text-blue-800",
                                                        title: "Editar",
                                                        onClick: ()=>{
                                                            setEditingProvider(p);
                                                            setShowForm(true);
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6c2a827dd5c2d433$export$2e2bcd8739ae039), {
                                                            className: "w-4 h-4"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        className: "text-red-500 hover:text-red-700",
                                                        title: "Eliminar",
                                                        onClick: ()=>handleDelete(p),
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                                            className: "w-4 h-4"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }, p.id))
                        })
                    ]
                })
            }),
            showForm && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a9a3b8e788ff76cd$export$2e2bcd8739ae039), {
                provider: editingProvider,
                onClose: handleFormClose
            })
        ]
    });
};
var $d1d4888b24ab3767$export$2e2bcd8739ae039 = $d1d4888b24ab3767$var$PaymentProviderList;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




const $0a5548074c249aa8$var$PaymentMethodForm = ({ route: route, providers: providers, onClose: onClose })=>{
    const isEdit = !!route;
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const [paymentMethodType, setPaymentMethodType] = (0, $acw62.useState)(route?.payment_method_type || "");
    const [providerName, setProviderName] = (0, $acw62.useState)(route?.provider_name || "");
    const [isEnabled, setIsEnabled] = (0, $acw62.useState)(route?.is_enabled ?? true);
    const [priority, setPriority] = (0, $acw62.useState)(route?.priority ?? 0);
    const [displayName, setDisplayName] = (0, $acw62.useState)(route?.display_name || "");
    const [description, setDescription] = (0, $acw62.useState)(route?.description || "");
    const [icon, setIcon] = (0, $acw62.useState)(route?.icon || "");
    const initialRules = route?.availability_rules ?? [];
    const [requireAuth, setRequireAuth] = (0, $acw62.useState)(initialRules.some((r)=>r.type === "authenticated"));
    const nifRule = initialRules.find((r)=>r.type === "nif");
    const [nifRequirement, setNifRequirement] = (0, $acw62.useState)(nifRule ? nifRule.kind ?? "any" : "");
    const prefixRule = initialRules.find((r)=>r.type === "nif_prefix");
    const [nifPrefixes, setNifPrefixes] = (0, $acw62.useState)((prefixRule?.prefixes ?? []).join(","));
    const handleSave = async ()=>{
        setSaving(true);
        setError(null);
        try {
            const body = {
                payment_method_type: paymentMethodType,
                provider_name: providerName,
                is_enabled: isEnabled,
                priority: priority,
                display_name: displayName || undefined,
                description: description || undefined,
                icon: icon || undefined,
                availability_rules: (0, $919ffafbc2ebec26$export$f25be5456d5508cc)(requireAuth, nifRequirement, nifPrefixes)
            };
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).put((0, $cd93687958c8007e$export$bfe19bc25132bb7c).PAYMENT_ROUTES, body);
            onClose(true);
        } catch (e) {
            setError(e?.response?.data?.error || "Erro ao guardar.");
        } finally{
            setSaving(false);
        }
    };
    const enabledProviders = providers.filter((p)=>p.is_enabled);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "fixed inset-0 bg-black/40 z-50 flex items-center justify-center",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "bg-white rounded-lg shadow-xl w-full max-w-lg max-h-[90vh] overflow-y-auto",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex justify-between items-center p-4 border-b",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "text-lg font-semibold",
                            children: isEdit ? "Editar Metodo" : "Novo Metodo de Pagamento"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>onClose(false),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                className: "w-5 h-5 text-gray-500"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "p-4 space-y-4",
                    children: [
                        error && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "bg-red-50 text-red-700 px-3 py-2 rounded text-sm",
                            children: error
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "select is-fullwidth",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                value: paymentMethodType,
                                onChange: (e)=>setPaymentMethodType(e.target.value),
                                disabled: isEdit,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "",
                                        children: "Selecionar..."
                                    }),
                                    (0, $919ffafbc2ebec26$export$d6e58abbbec7e1ac).map((t)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                            value: t,
                                            children: (0, $919ffafbc2ebec26$export$9df043cd05acf7a4)[t]
                                        }, t))
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "select is-fullwidth",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                value: providerName,
                                onChange: (e)=>setProviderName(e.target.value),
                                disabled: isEdit,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "",
                                        children: "Selecionar..."
                                    }),
                                    enabledProviders.map((p)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                            value: p.provider_name,
                                            children: (0, $919ffafbc2ebec26$export$50a1ee6753bccfcb)[p.provider_name] || p.provider_name
                                        }, p.provider_name))
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                    children: "Nome de Exibicao"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    type: "text",
                                    className: "block w-full px-3 py-2 border border-gray-300 rounded-lg text-sm",
                                    value: displayName,
                                    onChange: (e)=>setDisplayName(e.target.value),
                                    placeholder: "Cartao Visa/Mastercard"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                    children: "Descricao"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    className: "block w-full px-3 py-2 border border-gray-300 rounded-lg text-sm",
                                    rows: 2,
                                    value: description,
                                    onChange: (e)=>setDescription(e.target.value),
                                    placeholder: "Pagamento seguro via cartao de credito/debito"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                    children: "Icone (URL ou identificador)"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    type: "text",
                                    className: "block w-full px-3 py-2 border border-gray-300 rounded-lg text-sm",
                                    value: icon,
                                    onChange: (e)=>setIcon(e.target.value),
                                    placeholder: "credit-card"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "grid grid-cols-2 gap-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            className: "block text-sm font-medium text-gray-700 mb-1",
                                            children: "Prioridade (maior = preferido)"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "number",
                                            className: "block w-full px-3 py-2 border border-gray-300 rounded-lg text-sm",
                                            value: priority,
                                            onChange: (e)=>setPriority(parseInt(e.target.value) || 0)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                    className: "flex items-center gap-2 text-sm mt-6",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "checkbox",
                                            checked: isEnabled,
                                            onChange: (e)=>setIsEnabled(e.target.checked),
                                            className: "w-4 h-4"
                                        }),
                                        "Ativo"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "border-t border-gray-200 pt-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    className: "text-sm font-semibold text-gray-700 mb-3",
                                    children: "Regras de Disponibilidade"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                    className: "flex items-center gap-2 text-sm mb-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "checkbox",
                                            checked: requireAuth,
                                            onChange: (e)=>setRequireAuth(e.target.checked),
                                            className: "w-4 h-4"
                                        }),
                                        "Requer cliente autenticado"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mb-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            className: "block text-sm font-medium text-gray-700 mb-1",
                                            children: "Requisito de NIF"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "select is-fullwidth",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                value: nifRequirement,
                                                onChange: (e)=>setNifRequirement(e.target.value),
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                        value: "",
                                                        children: "Nenhum"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                        value: "any",
                                                        children: "NIF PT valido"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                        value: "company",
                                                        children: "NIF de Empresa"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                        value: "individual",
                                                        children: "NIF Particular"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            className: "block text-sm font-medium text-gray-700 mb-1",
                                            children: "Prefixo(s) de NIF (separados por virgula)"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "text",
                                            className: "block w-full px-3 py-2 border border-gray-300 rounded-lg text-sm",
                                            value: nifPrefixes,
                                            onChange: (e)=>setNifPrefixes(e.target.value),
                                            placeholder: "5, 6, 7, 8, 9"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex justify-end gap-2 p-4 border-t",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "button is-light is-small",
                            onClick: ()=>onClose(false),
                            disabled: saving,
                            children: "Cancelar"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "button is-primary is-small",
                            onClick: handleSave,
                            disabled: saving,
                            children: saving ? "A guardar..." : "Guardar"
                        })
                    ]
                })
            ]
        })
    });
};
var $0a5548074c249aa8$export$2e2bcd8739ae039 = $0a5548074c249aa8$var$PaymentMethodForm;



const $7dec004d4c201a04$var$formatRule = (rule)=>{
    switch(rule.type){
        case "authenticated":
            return "Auth";
        case "nif":
            return rule.kind === "company" ? "NIF Empresa" : rule.kind === "individual" ? "NIF Particular" : "NIF PT";
        case "nif_prefix":
            return `NIF prefixo ${(rule.prefixes ?? []).join(", ")}`;
        default:
            return rule.type;
    }
};
const $7dec004d4c201a04$var$PaymentMethodList = ()=>{
    const [routes, setRoutes] = (0, $acw62.useState)([]);
    const [providers, setProviders] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    const [editingRoute, setEditingRoute] = (0, $acw62.useState)(null);
    const [showForm, setShowForm] = (0, $acw62.useState)(false);
    const fetchData = (0, $acw62.useCallback)(async ()=>{
        setLoading(true);
        setError(null);
        try {
            const [routesRes, providersRes] = await Promise.all([
                (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).PAYMENT_ROUTES),
                (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).PAYMENT_PROVIDER_CONFIGS)
            ]);
            setRoutes(routesRes.data?.data || routesRes.data || []);
            setProviders(providersRes.data?.data || providersRes.data || []);
        } catch (e) {
            setError(e?.response?.data?.error || "Erro ao carregar metodos.");
        } finally{
            setLoading(false);
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    const handleToggleEnabled = async (route)=>{
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).put((0, $cd93687958c8007e$export$bfe19bc25132bb7c).PAYMENT_ROUTES, {
                payment_method_type: route.payment_method_type,
                provider_name: route.provider_name,
                is_enabled: !route.is_enabled,
                priority: route.priority,
                display_name: route.display_name,
                description: route.description,
                icon: route.icon,
                availability_rules: route.availability_rules
            });
            await fetchData();
        } catch (e) {
            setError(e?.response?.data?.error || "Erro ao atualizar estado.");
        }
    };
    const handleDelete = async (route)=>{
        if (!confirm(`Eliminar metodo "${route.display_name || route.payment_method_type}"?`)) return;
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).delete(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).PAYMENT_ROUTES}/${route.id}`);
            await fetchData();
        } catch (e) {
            setError(e?.response?.data?.error || "Erro ao eliminar.");
        }
    };
    const handleFormClose = (saved)=>{
        setShowForm(false);
        setEditingRoute(null);
        if (saved) fetchData();
    };
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "text-gray-500 py-4",
        children: "A carregar..."
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            error && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "bg-red-50 text-red-700 px-4 py-2 rounded mb-4 text-sm",
                children: error
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex justify-between items-center mb-4",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "text-lg font-semibold text-gray-800",
                        children: "Metodos de Pagamento"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        className: "button is-primary is-small flex items-center gap-1",
                        onClick: ()=>{
                            setEditingRoute(null);
                            setShowForm(true);
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                className: "w-4 h-4"
                            }),
                            " Adicionar"
                        ]
                    })
                ]
            }),
            routes.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "text-gray-500 text-sm",
                children: "Nenhum metodo de pagamento configurado."
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "overflow-x-auto",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                    className: "min-w-full text-sm",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                className: "border-b text-left text-gray-500",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "py-2 px-3",
                                        children: "Metodo"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "py-2 px-3",
                                        children: "Fornecedor"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "py-2 px-3",
                                        children: "Nome Exibicao"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "py-2 px-3",
                                        children: "Prioridade"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "py-2 px-3",
                                        children: "Regras"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "py-2 px-3",
                                        children: "Estado"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "py-2 px-3 text-right",
                                        children: "Acoes"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                            children: routes.sort((a, b)=>b.priority - a.priority).map((r)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                    className: "border-b hover:bg-gray-50",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "py-2 px-3 font-medium",
                                            children: (0, $919ffafbc2ebec26$export$9df043cd05acf7a4)[r.payment_method_type] || r.payment_method_type
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "py-2 px-3",
                                            children: (0, $919ffafbc2ebec26$export$50a1ee6753bccfcb)[r.provider_name] || r.provider_name
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "py-2 px-3 text-gray-600",
                                            children: r.display_name || "-"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "py-2 px-3",
                                            children: r.priority
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "py-2 px-3",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "flex flex-wrap gap-1",
                                                children: (r.availability_rules ?? []).length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "text-gray-400 text-xs",
                                                    children: "-"
                                                }) : (r.availability_rules ?? []).map((rule, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "px-1.5 py-0.5 bg-gray-100 text-gray-600 rounded text-xs",
                                                        children: $7dec004d4c201a04$var$formatRule(rule)
                                                    }, i))
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "py-2 px-3",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                onClick: ()=>handleToggleEnabled(r),
                                                className: "flex items-center gap-1",
                                                title: r.is_enabled ? "Desativar" : "Ativar",
                                                children: [
                                                    r.is_enabled ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b7bdb8b3d2137917$export$2e2bcd8739ae039), {
                                                        className: "w-5 h-5 text-green-600"
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9bfa6564caba0fd2$export$2e2bcd8739ae039), {
                                                        className: "w-5 h-5 text-gray-400"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: r.is_enabled ? "text-green-600" : "text-gray-400",
                                                        children: r.is_enabled ? "Ativo" : "Inativo"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "py-2 px-3 text-right",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex justify-end gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        className: "text-blue-600 hover:text-blue-800",
                                                        title: "Editar",
                                                        onClick: ()=>{
                                                            setEditingRoute(r);
                                                            setShowForm(true);
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6c2a827dd5c2d433$export$2e2bcd8739ae039), {
                                                            className: "w-4 h-4"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        className: "text-red-500 hover:text-red-700",
                                                        title: "Eliminar",
                                                        onClick: ()=>handleDelete(r),
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                                            className: "w-4 h-4"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }, r.id))
                        })
                    ]
                })
            }),
            showForm && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0a5548074c249aa8$export$2e2bcd8739ae039), {
                route: editingRoute,
                providers: providers,
                onClose: handleFormClose
            })
        ]
    });
};
var $7dec004d4c201a04$export$2e2bcd8739ae039 = $7dec004d4c201a04$var$PaymentMethodList;


const $8d2199f43a373341$var$PaymentManager = ()=>{
    const [section, setSection] = (0, $acw62.useState)("providers");
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex gap-2 mb-4",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: `px-4 py-2 rounded text-sm font-medium ${section === "providers" ? "bg-blue-600 text-white" : "bg-gray-100 text-gray-700 hover:bg-gray-200"}`,
                        onClick: ()=>setSection("providers"),
                        children: "Fornecedores"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: `px-4 py-2 rounded text-sm font-medium ${section === "methods" ? "bg-blue-600 text-white" : "bg-gray-100 text-gray-700 hover:bg-gray-200"}`,
                        onClick: ()=>setSection("methods"),
                        children: "Metodos de Pagamento"
                    })
                ]
            }),
            section === "providers" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d1d4888b24ab3767$export$2e2bcd8739ae039), {}),
            section === "methods" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7dec004d4c201a04$export$2e2bcd8739ae039), {})
        ]
    });
};
var $8d2199f43a373341$export$2e2bcd8739ae039 = $8d2199f43a373341$var$PaymentManager;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $357b00fa120a5c4e$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "20",
            height: "5",
            x: "2",
            y: "3",
            rx: "1",
            key: "1wp1u1"
        }
    ],
    [
        "path",
        {
            d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8",
            key: "1s80jp"
        }
    ],
    [
        "path",
        {
            d: "M10 12h4",
            key: "a56b0p"
        }
    ]
];
const $357b00fa120a5c4e$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("archive", $357b00fa120a5c4e$export$3efd853dbb351e94);


const $747266722164c268$var$PAYMENT_METHOD_OPTIONS = [
    {
        code: "mbway",
        label: "MB WAY"
    },
    {
        code: "multibanco",
        label: "Multibanco"
    },
    {
        code: "card",
        label: "Cart\xe3o"
    },
    {
        code: "transfer",
        label: "Transfer\xeancia"
    },
    {
        code: "cheque",
        label: "Cheque"
    },
    {
        code: "floa",
        label: "FLOA"
    },
    {
        code: "sequra",
        label: "SeQura"
    }
];
const $747266722164c268$var$DAYS_PT = [
    {
        key: "monday",
        label: "Segunda-feira",
        abrev: "Seg"
    },
    {
        key: "tuesday",
        label: "Ter\xe7a-feira",
        abrev: "Ter"
    },
    {
        key: "wednesday",
        label: "Quarta-feira",
        abrev: "Qua"
    },
    {
        key: "thursday",
        label: "Quinta-feira",
        abrev: "Qui"
    },
    {
        key: "friday",
        label: "Sexta-feira",
        abrev: "Sex"
    },
    {
        key: "saturday",
        label: "S\xe1bado",
        abrev: "S\xe1b"
    },
    {
        key: "sunday",
        label: "Domingo",
        abrev: "Dom"
    }
];
const $747266722164c268$var$DeliveryMethodsManager = ()=>{
    const [methods, setMethods] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    const [success, setSuccess] = (0, $acw62.useState)(null);
    const [showForm, setShowForm] = (0, $acw62.useState)(false);
    const [editingMethod, setEditingMethod] = (0, $acw62.useState)(null);
    const [isSaving, setIsSaving] = (0, $acw62.useState)(false);
    const [paymentLinksModal, setPaymentLinksModal] = (0, $acw62.useState)(null);
    const [paymentLinks, setPaymentLinks] = (0, $acw62.useState)([]);
    const [pois, setPois] = (0, $acw62.useState)([]);
    const [poisModal, setPoisModal] = (0, $acw62.useState)(null);
    const [poiForm, setPoiForm] = (0, $acw62.useState)(null);
    const [isPoiSaving, setIsPoiSaving] = (0, $acw62.useState)(false);
    // Auto-dismiss success after 4s
    (0, $acw62.useEffect)(()=>{
        if (!success) return;
        const t = setTimeout(()=>setSuccess(null), 4000);
        return ()=>clearTimeout(t);
    }, [
        success
    ]);
    const showSuccess = (msg)=>{
        setSuccess(msg);
        setError(null);
    };
    const fetchMethods = (0, $acw62.useCallback)(async ()=>{
        setLoading(true);
        setError(null);
        try {
            const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).OMS_DELIVERY_METHODS);
            setMethods(res.data?.methods || res.data || []);
        } catch (e) {
            setError(e?.response?.data?.error || "Erro ao carregar m\xe9todos de entrega.");
        } finally{
            setLoading(false);
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        fetchMethods();
    }, [
        fetchMethods
    ]);
    const handleToggleActive = async (m)=>{
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).patch(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).OMS_DELIVERY_METHODS}/${m.id}/status`, {
                is_active: !m.is_active
            });
            showSuccess(`M\xe9todo "${m.label}" ${m.is_active ? "desativado" : "ativado"}.`);
            await fetchMethods();
        } catch (e) {
            setError(e?.response?.data?.error || "Erro ao atualizar estado.");
        }
    };
    const handleArchive = async (m)=>{
        if (!confirm(`Arquivar "${m.label}"? Ficar\xe1 inativo mas os dados s\xe3o preservados.`)) return;
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).patch(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).OMS_DELIVERY_METHODS}/${m.id}/status`, {
                is_active: false
            });
            showSuccess(`M\xe9todo "${m.label}" arquivado.`);
            await fetchMethods();
        } catch (e) {
            setError(e?.response?.data?.error || "Erro ao arquivar.");
        }
    };
    const validateForm = (data)=>{
        const errs = {};
        if (!data.code?.trim()) errs.code = "O c\xf3digo \xe9 obrigat\xf3rio.";
        else if (!/^[a-z0-9_-]+$/.test(data.code)) errs.code = "Apenas min\xfasculas, n\xfameros, h\xedfen e underscore.";
        if (!data.label?.trim()) errs.label = "O nome \xe9 obrigat\xf3rio.";
        if (data.has_sub_options && !data.sub_options_label?.trim()) errs.sub_options_label = "Indique o r\xf3tulo das sub-op\xe7\xf5es.";
        return errs;
    };
    const [fieldErrors, setFieldErrors] = (0, $acw62.useState)({});
    const handleSave = async (data)=>{
        const errs = validateForm(data);
        setFieldErrors(errs);
        if (Object.keys(errs).length > 0) return;
        setIsSaving(true);
        try {
            if (data.id) {
                await (0, $bac44633733ff026$export$2e2bcd8739ae039).put(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).OMS_DELIVERY_METHODS}/${data.id}`, data);
                showSuccess("M\xe9todo de entrega atualizado.");
            } else {
                await (0, $bac44633733ff026$export$2e2bcd8739ae039).post((0, $cd93687958c8007e$export$bfe19bc25132bb7c).OMS_DELIVERY_METHODS, data);
                showSuccess("M\xe9todo de entrega criado.");
            }
            setShowForm(false);
            setEditingMethod(null);
            setFieldErrors({});
            await fetchMethods();
        } catch (e) {
            setError(e?.response?.data?.error || "Erro ao guardar.");
        } finally{
            setIsSaving(false);
        }
    };
    const fetchPaymentLinks = async (methodId)=>{
        try {
            const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).OMS_DELIVERY_METHODS}/${methodId}/payment-links`);
            setPaymentLinks(res.data?.codes || []);
            setPaymentLinksModal(methodId);
        } catch  {
            setError("Erro ao carregar m\xe9todos de pagamento.");
        }
    };
    const savePaymentLinks = async ()=>{
        if (!paymentLinksModal) return;
        setIsSaving(true);
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).post(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).OMS_DELIVERY_METHODS}/${paymentLinksModal}/payment-links`, {
                codes: paymentLinks
            });
            showSuccess("M\xe9todos de pagamento compat\xedveis atualizados.");
            setPaymentLinksModal(null);
        } catch (e) {
            setError(e?.response?.data?.error || "Erro ao guardar.");
        } finally{
            setIsSaving(false);
        }
    };
    const togglePaymentLink = (code)=>{
        setPaymentLinks((prev)=>prev.includes(code) ? prev.filter((c)=>c !== code) : [
                ...prev,
                code
            ]);
    };
    const fetchPois = async (methodId)=>{
        try {
            const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).OMS_DELIVERY_METHODS}/${methodId}/pois`);
            setPois(res.data?.pois || []);
            setPoisModal(methodId);
        } catch  {
            setError("Erro ao carregar pontos de recolha.");
        }
    };
    const validatePoiForm = (data)=>{
        const errs = {};
        if (!data.code?.trim()) errs.code = "O c\xf3digo \xe9 obrigat\xf3rio.";
        if (!data.label?.trim()) errs.label = "O nome \xe9 obrigat\xf3rio.";
        if (!data.address_line1?.trim()) errs.address_line1 = "A morada \xe9 obrigat\xf3ria.";
        if (!data.city?.trim()) errs.city = "A cidade \xe9 obrigat\xf3ria.";
        if (data.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) errs.email = "Email inv\xe1lido.";
        if (data.capacity !== undefined && data.capacity < 0) errs.capacity = "Capacidade n\xe3o pode ser negativa.";
        return errs;
    };
    const handleSavePoi = async ()=>{
        if (!poiForm || !poisModal) return;
        const errs = validatePoiForm(poiForm);
        setFieldErrors(errs);
        if (Object.keys(errs).length > 0) return;
        setIsPoiSaving(true);
        try {
            if (poiForm.id) {
                await (0, $bac44633733ff026$export$2e2bcd8739ae039).put(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).OMS_DELIVERY_METHODS}/${poisModal}/pois/${poiForm.id}`, poiForm);
                showSuccess("Ponto de recolha atualizado.");
            } else {
                await (0, $bac44633733ff026$export$2e2bcd8739ae039).post(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).OMS_DELIVERY_METHODS}/${poisModal}/pois`, poiForm);
                showSuccess("Ponto de recolha adicionado.");
            }
            setPoiForm(null);
            setFieldErrors({});
            await fetchPois(poisModal);
        } catch (e) {
            setError(e?.response?.data?.error || "Erro ao guardar POI.");
        } finally{
            setIsPoiSaving(false);
        }
    };
    const handleArchivePoi = async (poiId)=>{
        if (!poisModal) return;
        if (!confirm("Arquivar ponto de recolha? Ficar\xe1 inativo.")) return;
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).delete(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).OMS_DELIVERY_METHODS}/${poisModal}/pois/${poiId}`);
            showSuccess("Ponto de recolha removido.");
            await fetchPois(poisModal);
        } catch (e) {
            setError(e?.response?.data?.error || "Erro ao remover POI.");
        }
    };
    const handleTogglePoiActive = async (poi)=>{
        if (!poisModal) return;
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).put(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).OMS_DELIVERY_METHODS}/${poisModal}/pois/${poi.id}`, {
                ...poi,
                is_active: !poi.is_active
            });
            showSuccess(`Ponto de recolha ${poi.is_active ? "desativado" : "ativado"}.`);
            await fetchPois(poisModal);
        } catch (e) {
            setError(e?.response?.data?.error || "Erro ao atualizar estado.");
        }
    };
    const updatePoiField = (key, value)=>{
        setPoiForm((prev)=>prev ? {
                ...prev,
                [key]: value
            } : null);
        setFieldErrors((prev)=>({
                ...prev,
                [key]: ""
            }));
    };
    const toggleDayHours = (day)=>{
        setPoiForm((prev)=>{
            if (!prev) return prev;
            const hours = {
                ...prev.operating_hours || {}
            };
            if (hours[day]?.length) delete hours[day];
            else hours[day] = [
                {
                    open: "09:00",
                    close: "18:00"
                }
            ];
            return {
                ...prev,
                operating_hours: hours
            };
        });
    };
    const setDaySlot = (day, slotIdx, field, value)=>{
        setPoiForm((prev)=>{
            if (!prev) return prev;
            const hours = {
                ...prev.operating_hours || {}
            };
            const slots = [
                ...hours[day] || []
            ];
            if (!slots[slotIdx]) slots[slotIdx] = {
                open: "09:00",
                close: "18:00"
            };
            slots[slotIdx] = {
                ...slots[slotIdx],
                [field]: value
            };
            hours[day] = slots;
            return {
                ...prev,
                operating_hours: hours
            };
        });
    };
    const addDaySlot = (day)=>{
        setPoiForm((prev)=>{
            if (!prev) return prev;
            const hours = {
                ...prev.operating_hours || {}
            };
            const slots = [
                ...hours[day] || []
            ];
            if (slots.length >= 2) return prev;
            slots.push({
                open: "14:00",
                close: "19:00"
            });
            hours[day] = slots;
            return {
                ...prev,
                operating_hours: hours
            };
        });
    };
    const removeDaySlot = (day, slotIdx)=>{
        setPoiForm((prev)=>{
            if (!prev) return prev;
            const hours = {
                ...prev.operating_hours || {}
            };
            const slots = [
                ...hours[day] || []
            ];
            slots.splice(slotIdx, 1);
            if (slots.length === 0) delete hours[day];
            else hours[day] = slots;
            return {
                ...prev,
                operating_hours: hours
            };
        });
    };
    const copyToWeekdays = ()=>{
        if (!poiForm?.operating_hours?.monday) return;
        const mon = poiForm.operating_hours.monday;
        setPoiForm((prev)=>{
            if (!prev) return prev;
            const hours = {
                ...prev.operating_hours || {}
            };
            for (const d of [
                "tuesday",
                "wednesday",
                "thursday",
                "friday"
            ])hours[d] = [
                ...mon
            ];
            return {
                ...prev,
                operating_hours: hours
            };
        });
    };
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "text-gray-500 py-4",
        children: "A carregar..."
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            (success || error) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: `px-4 py-2 rounded mb-4 text-sm flex items-center gap-2 ${success ? "bg-green-50 text-green-700 border border-green-200" : "bg-red-50 text-red-700"}`,
                children: [
                    success ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                        className: "w-4 h-4 shrink-0"
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                        className: "w-4 h-4 shrink-0"
                    }),
                    success || error
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex justify-between items-center mb-4",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "text-lg font-semibold text-gray-800",
                        children: "M\xe9todos de Entrega"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        className: "button is-primary is-small flex items-center gap-1",
                        onClick: ()=>{
                            setEditingMethod(null);
                            setShowForm(true);
                            setFieldErrors({});
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                className: "w-4 h-4"
                            }),
                            " Adicionar"
                        ]
                    })
                ]
            }),
            methods.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "text-gray-500 text-sm",
                children: "Nenhum m\xe9todo configurado."
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "overflow-x-auto",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                    className: "min-w-full text-sm",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                className: "border-b text-left text-gray-500",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "py-2 px-3",
                                        children: "Nome"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "py-2 px-3",
                                        children: "C\xf3digo"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "py-2 px-3",
                                        children: "Sub-op\xe7\xf5es"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "py-2 px-3",
                                        children: "Estado"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "py-2 px-3",
                                        children: "Pagamentos"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "py-2 px-3 text-right",
                                        children: "A\xe7\xf5es"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                            children: methods.map((m)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                    className: "border-b hover:bg-gray-50",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "py-2 px-3 font-medium",
                                            children: m.label
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "py-2 px-3 text-gray-600 font-mono text-xs",
                                            children: m.code
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "py-2 px-3",
                                            children: m.has_sub_options ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "inline-block bg-blue-100 text-blue-700 text-xs font-medium px-2 py-0.5 rounded-full",
                                                children: "Pickup"
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "text-gray-400",
                                                children: "\u2014"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "py-2 px-3",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                onClick: ()=>handleToggleActive(m),
                                                className: "flex items-center gap-1",
                                                title: m.is_active ? "Desativar" : "Ativar",
                                                children: [
                                                    m.is_active ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b7bdb8b3d2137917$export$2e2bcd8739ae039), {
                                                        className: "w-5 h-5 text-green-600"
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9bfa6564caba0fd2$export$2e2bcd8739ae039), {
                                                        className: "w-5 h-5 text-gray-400"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: m.is_active ? "text-green-600" : "text-gray-400",
                                                        children: m.is_active ? "Ativo" : "Inativo"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "py-2 px-3",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                className: "text-indigo-600 hover:text-indigo-800 text-xs underline",
                                                onClick: ()=>fetchPaymentLinks(m.id),
                                                children: "Configurar"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "py-2 px-3 text-right",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex justify-end gap-2 items-center",
                                                children: [
                                                    m.has_sub_options && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        className: "text-amber-600 hover:text-amber-800",
                                                        title: "Pontos de recolha",
                                                        onClick: ()=>fetchPois(m.id),
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c978075baab28645$export$2e2bcd8739ae039), {
                                                            className: "w-4 h-4"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        className: "text-blue-600 hover:text-blue-800",
                                                        title: "Editar",
                                                        onClick: ()=>{
                                                            setEditingMethod(m);
                                                            setShowForm(true);
                                                            setFieldErrors({});
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6c2a827dd5c2d433$export$2e2bcd8739ae039), {
                                                            className: "w-4 h-4"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        className: "text-amber-600 hover:text-amber-800",
                                                        title: "Arquivar",
                                                        onClick: ()=>handleArchive(m),
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $357b00fa120a5c4e$export$2e2bcd8739ae039), {
                                                            className: "w-4 h-4"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }, m.id))
                        })
                    ]
                })
            }),
            showForm && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "fixed inset-0 bg-black/40 flex items-center justify-center z-50",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "bg-white rounded-xl shadow-lg max-w-lg w-full p-6",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                            className: "font-semibold text-lg mb-4",
                            children: [
                                editingMethod ? "Editar" : "Novo",
                                " M\xe9todo de Entrega"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($747266722164c268$var$FormBody, {
                            initial: editingMethod || undefined,
                            onSave: handleSave,
                            onCancel: ()=>{
                                setShowForm(false);
                                setEditingMethod(null);
                                setFieldErrors({});
                            },
                            errors: fieldErrors,
                            isSaving: isSaving
                        })
                    ]
                })
            }),
            paymentLinksModal && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "fixed inset-0 bg-black/40 flex items-center justify-center z-50",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "bg-white rounded-xl shadow-lg max-w-md w-full p-6",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex justify-between items-center mb-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    className: "font-semibold text-lg",
                                    children: "M\xe9todos de Pagamento Compat\xedveis"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: ()=>setPaymentLinksModal(null),
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                        className: "w-5 h-5 text-gray-500"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "space-y-2 mb-4",
                            children: $747266722164c268$var$PAYMENT_METHOD_OPTIONS.map((pm)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                    className: "flex items-center gap-3 p-2 rounded hover:bg-gray-50 cursor-pointer",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "checkbox",
                                            checked: paymentLinks.includes(pm.code),
                                            onChange: ()=>togglePaymentLink(pm.code),
                                            className: "w-4 h-4"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "text-sm",
                                            children: pm.label
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("code", {
                                            className: "text-xs text-gray-400 ml-auto",
                                            children: pm.code
                                        })
                                    ]
                                }, pm.code))
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex gap-2 justify-end",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "button is-light is-small",
                                    onClick: ()=>setPaymentLinksModal(null),
                                    children: "Cancelar"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "button is-primary is-small flex items-center gap-1",
                                    disabled: isSaving,
                                    onClick: savePaymentLinks,
                                    children: isSaving ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                                className: "w-3 h-3 animate-spin"
                                            }),
                                            " A guardar..."
                                        ]
                                    }) : "Guardar"
                                })
                            ]
                        })
                    ]
                })
            }),
            poisModal && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "fixed inset-0 bg-black/40 flex items-center justify-center z-50",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "bg-white rounded-xl shadow-lg max-w-2xl w-full p-6 max-h-[90vh] overflow-y-auto",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex justify-between items-center mb-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    className: "font-semibold text-lg",
                                    children: "Pontos de Recolha"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: ()=>{
                                        setPoisModal(null);
                                        setPoiForm(null);
                                        setFieldErrors({});
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                        className: "w-5 h-5 text-gray-500"
                                    })
                                })
                            ]
                        }),
                        pois.length === 0 && !poiForm && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "text-gray-500 text-sm mb-4",
                            children: "Nenhum ponto de recolha configurado."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "grid grid-cols-1 md:grid-cols-2 gap-3 mb-4",
                            children: pois.map((p)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "border border-gray-200 rounded-lg p-3 bg-white",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex justify-between items-start mb-1",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                    className: "font-medium text-sm",
                                                    children: p.label
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: `text-xs font-medium px-2 py-0.5 rounded-full ${p.is_active ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-500"}`,
                                                    children: p.is_active ? "Ativo" : "Inativo"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "text-xs text-gray-500",
                                            children: [
                                                p.address_line1,
                                                ", ",
                                                p.postal_code,
                                                " ",
                                                p.city
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex items-center gap-2 text-xs text-gray-400 mt-1",
                                            children: [
                                                p.phone && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    children: [
                                                        "\uD83D\uDCDE ",
                                                        p.phone
                                                    ]
                                                }),
                                                p.email && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    children: [
                                                        "\u2709 ",
                                                        p.email
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex gap-3 mt-2 pt-2 border-t border-gray-100",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                    className: "text-blue-600 hover:text-blue-800 text-xs flex items-center gap-1",
                                                    onClick: ()=>{
                                                        setPoiForm(p);
                                                        setFieldErrors({});
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6c2a827dd5c2d433$export$2e2bcd8739ae039), {
                                                            className: "w-3 h-3"
                                                        }),
                                                        " Editar"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                    className: `text-xs flex items-center gap-1 ${p.is_active ? "text-gray-500 hover:text-gray-700" : "text-green-600 hover:text-green-800"}`,
                                                    onClick: ()=>handleTogglePoiActive(p),
                                                    title: p.is_active ? "Desativar" : "Ativar",
                                                    children: [
                                                        p.is_active ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b7bdb8b3d2137917$export$2e2bcd8739ae039), {
                                                            className: "w-3 h-3"
                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9bfa6564caba0fd2$export$2e2bcd8739ae039), {
                                                            className: "w-3 h-3"
                                                        }),
                                                        p.is_active ? "Desativar" : "Ativar"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                    className: "text-amber-600 hover:text-amber-800 text-xs flex items-center gap-1",
                                                    onClick: ()=>handleArchivePoi(p.id),
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $357b00fa120a5c4e$export$2e2bcd8739ae039), {
                                                            className: "w-3 h-3"
                                                        }),
                                                        " Arquivar"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }, p.id))
                        }),
                        poiForm ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "border rounded-lg p-4 space-y-3 bg-gray-50",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                                    className: "font-medium text-sm",
                                    children: [
                                        poiForm.id ? "Editar" : "Novo",
                                        " Ponto de Recolha"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "grid grid-cols-2 gap-3",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($747266722164c268$var$Field, {
                                            label: "C\xf3digo",
                                            value: poiForm.code || "",
                                            onChange: (v)=>updatePoiField("code", v),
                                            error: fieldErrors.code,
                                            required: true
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($747266722164c268$var$Field, {
                                            label: "Nome",
                                            value: poiForm.label || "",
                                            onChange: (v)=>updatePoiField("label", v),
                                            error: fieldErrors.label,
                                            required: true
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($747266722164c268$var$Field, {
                                            label: "Telefone",
                                            value: poiForm.phone || "",
                                            onChange: (v)=>updatePoiField("phone", v)
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($747266722164c268$var$Field, {
                                            label: "Email",
                                            value: poiForm.email || "",
                                            onChange: (v)=>updatePoiField("email", v),
                                            error: fieldErrors.email
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "col-span-2",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($747266722164c268$var$Field, {
                                                label: "Morada",
                                                value: poiForm.address_line1 || "",
                                                onChange: (v)=>updatePoiField("address_line1", v),
                                                error: fieldErrors.address_line1,
                                                required: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($747266722164c268$var$Field, {
                                            label: "Cidade",
                                            value: poiForm.city || "",
                                            onChange: (v)=>updatePoiField("city", v),
                                            error: fieldErrors.city,
                                            required: true
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($747266722164c268$var$Field, {
                                            label: "C\xf3digo Postal",
                                            value: poiForm.postal_code || "",
                                            onChange: (v)=>updatePoiField("postal_code", v)
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($747266722164c268$var$Field, {
                                            label: "Latitude",
                                            value: poiForm.latitude?.toString() || "",
                                            onChange: (v)=>updatePoiField("latitude", v ? parseFloat(v) : undefined),
                                            type: "number",
                                            step: "any"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($747266722164c268$var$Field, {
                                            label: "Longitude",
                                            value: poiForm.longitude?.toString() || "",
                                            onChange: (v)=>updatePoiField("longitude", v ? parseFloat(v) : undefined),
                                            type: "number",
                                            step: "any"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($747266722164c268$var$Field, {
                                            label: "Capacidade (0=ilimitado)",
                                            value: poiForm.capacity?.toString() || "0",
                                            onChange: (v)=>updatePoiField("capacity", parseInt(v) || 0),
                                            type: "number"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    className: "textarea block w-full text-sm mt-2",
                                    placeholder: "Notas / instru\xe7\xf5es de acesso",
                                    rows: 2,
                                    value: poiForm.notes || "",
                                    onChange: (e)=>updatePoiField("notes", e.target.value)
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "border rounded p-3 bg-white mt-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                                            className: "text-sm font-medium mb-2",
                                            children: "Hor\xe1rio de Funcionamento"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "space-y-1",
                                            children: $747266722164c268$var$DAYS_PT.map((day)=>{
                                                const slots = poiForm.operating_hours?.[day.key] || [];
                                                const isOpen = slots.length > 0;
                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "flex items-center gap-2 text-xs",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                            className: "flex items-center gap-1 cursor-pointer w-28 shrink-0",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                    type: "checkbox",
                                                                    checked: isOpen,
                                                                    onChange: ()=>toggleDayHours(day.key),
                                                                    className: "w-3 h-3"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: isOpen ? "font-medium" : "text-gray-400",
                                                                    children: day.abrev
                                                                })
                                                            ]
                                                        }),
                                                        isOpen ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "flex items-center gap-1 flex-wrap",
                                                            children: slots.map((slot, si)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                    className: "flex items-center gap-1",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                            type: "time",
                                                                            value: slot.open,
                                                                            onChange: (e)=>setDaySlot(day.key, si, "open", e.target.value),
                                                                            className: "border border-gray-300 rounded px-1 py-0.5 w-16 text-center"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "text-gray-400",
                                                                            children: "\u2013"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                            type: "time",
                                                                            value: slot.close,
                                                                            onChange: (e)=>setDaySlot(day.key, si, "close", e.target.value),
                                                                            className: "border border-gray-300 rounded px-1 py-0.5 w-16 text-center"
                                                                        }),
                                                                        si === 0 && slots.length < 2 && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                            className: "text-blue-500 hover:text-blue-700",
                                                                            onClick: ()=>addDaySlot(day.key),
                                                                            title: "Adicionar per\xedodo",
                                                                            children: "+"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                            className: "text-red-400 hover:text-red-600",
                                                                            onClick: ()=>removeDaySlot(day.key, si),
                                                                            title: "Remover per\xedodo",
                                                                            children: "\xd7"
                                                                        })
                                                                    ]
                                                                }, si))
                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "text-gray-400",
                                                            children: "Fechado"
                                                        })
                                                    ]
                                                }, day.key);
                                            })
                                        }),
                                        poiForm.operating_hours?.monday?.length ? /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            className: "text-xs text-blue-600 hover:text-blue-800 mt-2",
                                            onClick: copyToWeekdays,
                                            children: "Copiar hor\xe1rio de Segunda para dias \xfateis"
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex gap-2 justify-end pt-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            className: "button is-light is-small",
                                            onClick: ()=>{
                                                setPoiForm(null);
                                                setFieldErrors({});
                                            },
                                            children: "Cancelar"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            className: "button is-primary is-small flex items-center gap-1",
                                            disabled: isPoiSaving,
                                            onClick: handleSavePoi,
                                            children: isPoiSaving ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                                        className: "w-3 h-3 animate-spin"
                                                    }),
                                                    " A guardar..."
                                                ]
                                            }) : poiForm.id ? "Atualizar" : "Criar"
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                            className: "button is-primary is-small flex items-center gap-1",
                            onClick: ()=>{
                                setPoiForm({
                                    code: "",
                                    label: "",
                                    address_line1: "",
                                    city: "",
                                    country: "PT",
                                    operating_hours: {}
                                });
                                setFieldErrors({});
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                    className: "w-4 h-4"
                                }),
                                " Novo Ponto de Recolha"
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* Field helper */ const $747266722164c268$var$Field = ({ label: label, value: value, onChange: onChange, error: error, required: required, type: type = "text", step: step })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                className: "block text-xs font-medium text-gray-700 mb-0.5",
                children: [
                    label,
                    " ",
                    required && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "text-red-500",
                        children: "*"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                type: type,
                step: step,
                className: `input block w-full text-sm ${error ? "border-red-400" : ""}`,
                value: value,
                onChange: (e)=>onChange(e.target.value)
            }),
            error && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                className: "text-red-600 text-xs mt-0.5 flex items-center gap-1",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                        className: "w-3 h-3"
                    }),
                    error
                ]
            })
        ]
    });
/* Inline form for delivery method create/edit */ const $747266722164c268$var$FormBody = ({ initial: initial, onSave: onSave, onCancel: onCancel, errors: errors, isSaving: isSaving })=>{
    const [code, setCode] = (0, $acw62.useState)(initial?.code || "");
    const [label, setLabel] = (0, $acw62.useState)(initial?.label || "");
    const [desc, setDesc] = (0, $acw62.useState)(initial?.description || "");
    const [hasSub, setHasSub] = (0, $acw62.useState)(initial?.has_sub_options || false);
    const [subLabel, setSubLabel] = (0, $acw62.useState)(initial?.sub_options_label || "");
    const [sortOrder, setSortOrder] = (0, $acw62.useState)(initial?.sort_order || 0);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "space-y-3",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex gap-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex-1",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                className: "block text-xs font-medium text-gray-700 mb-0.5",
                                children: [
                                    "C\xf3digo ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "text-red-500",
                                        children: "*"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                className: `input w-full text-sm ${errors.code ? "border-red-400" : ""}`,
                                placeholder: "Ex: standard",
                                value: code,
                                onChange: (e)=>setCode(e.target.value),
                                disabled: !!initial
                            }),
                            errors.code && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "text-red-600 text-xs mt-0.5 flex items-center gap-1",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                                        className: "w-3 h-3"
                                    }),
                                    errors.code
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "w-20",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                className: "block text-xs font-medium text-gray-700 mb-0.5",
                                children: "Ordem"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                className: "input w-full text-sm",
                                type: "number",
                                value: sortOrder,
                                onChange: (e)=>setSortOrder(parseInt(e.target.value) || 0)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                        className: "block text-xs font-medium text-gray-700 mb-0.5",
                        children: [
                            "Nome ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "text-red-500",
                                children: "*"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        className: `input block w-full text-sm ${errors.label ? "border-red-400" : ""}`,
                        placeholder: "Ex: Envio Standard",
                        value: label,
                        onChange: (e)=>setLabel(e.target.value)
                    }),
                    errors.label && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "text-red-600 text-xs mt-0.5 flex items-center gap-1",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                                className: "w-3 h-3"
                            }),
                            errors.label
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                        className: "block text-xs font-medium text-gray-700 mb-0.5",
                        children: "Descri\xe7\xe3o"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                        className: "textarea block w-full text-sm",
                        placeholder: "Descri\xe7\xe3o vis\xedvel no checkout",
                        rows: 2,
                        value: desc,
                        onChange: (e)=>setDesc(e.target.value)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                className: "flex items-center gap-2 text-sm cursor-pointer",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        type: "checkbox",
                        checked: hasSub,
                        onChange: (e)=>setHasSub(e.target.checked)
                    }),
                    "Tem sub-op\xe7\xf5es (pickup)?"
                ]
            }),
            hasSub && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                        className: "block text-xs font-medium text-gray-700 mb-0.5",
                        children: [
                            "R\xf3tulo das sub-op\xe7\xf5es ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "text-red-500",
                                children: "*"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        className: `input block w-full text-sm ${errors.sub_options_label ? "border-red-400" : ""}`,
                        placeholder: "Ex: Selecione o local de levantamento",
                        value: subLabel,
                        onChange: (e)=>setSubLabel(e.target.value)
                    }),
                    errors.sub_options_label && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "text-red-600 text-xs mt-0.5 flex items-center gap-1",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                                className: "w-3 h-3"
                            }),
                            errors.sub_options_label
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex gap-2 justify-end pt-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "button is-light is-small",
                        onClick: onCancel,
                        children: "Cancelar"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "button is-primary is-small flex items-center gap-1",
                        disabled: isSaving,
                        onClick: ()=>onSave({
                                ...initial ? {
                                    id: initial.id
                                } : {},
                                code: code,
                                label: label,
                                description: desc,
                                has_sub_options: hasSub,
                                sub_options_label: subLabel,
                                sort_order: sortOrder
                            }),
                        children: isSaving ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                    className: "w-3 h-3 animate-spin"
                                }),
                                " A guardar..."
                            ]
                        }) : initial ? "Atualizar" : "Criar"
                    })
                ]
            })
        ]
    });
};
var $747266722164c268$export$2e2bcd8739ae039 = $747266722164c268$var$DeliveryMethodsManager;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $008e11cf932a0927$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 5v14",
            key: "s699le"
        }
    ],
    [
        "path",
        {
            d: "m19 12-7 7-7-7",
            key: "1idqje"
        }
    ]
];
const $008e11cf932a0927$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("arrow-down", $008e11cf932a0927$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4f05f6a77fc593bc$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m5 12 7-7 7 7",
            key: "hav0vg"
        }
    ],
    [
        "path",
        {
            d: "M12 19V5",
            key: "x0mq9r"
        }
    ]
];
const $4f05f6a77fc593bc$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("arrow-up", $4f05f6a77fc593bc$export$3efd853dbb351e94);


const $f9fba5b9b663705e$var$TYPE_OPTIONS = [
    {
        value: "fold",
        label: "Agrupar varia\xe7\xf5es (formato)"
    },
    {
        value: "numeric",
        label: "Intervalos num\xe9ricos"
    },
    {
        value: "tokens",
        label: "Separar listas de caracter\xedsticas"
    },
    {
        value: "raw",
        label: "Valor exato"
    },
    {
        value: "ai",
        label: "Agrupar por significado (IA)"
    }
];
const $f9fba5b9b663705e$var$STATUS_OPTIONS = [
    {
        value: "approved",
        label: "Aprovado"
    },
    {
        value: "proposed",
        label: "Proposto"
    },
    {
        value: "rejected",
        label: "Rejeitado"
    }
];
const $f9fba5b9b663705e$var$STATUS_CLASS = {
    approved: "bg-green-100 text-green-700",
    proposed: "bg-amber-100 text-amber-700",
    rejected: "bg-red-100 text-red-700"
};
const $f9fba5b9b663705e$var$typeLabel = (v)=>$f9fba5b9b663705e$var$TYPE_OPTIONS.find((t)=>t.value === v)?.label ?? v;
const $f9fba5b9b663705e$var$statusLabel = (v)=>$f9fba5b9b663705e$var$STATUS_OPTIONS.find((s)=>s.value === v)?.label ?? v;
const $f9fba5b9b663705e$var$base = (code)=>`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).CATALOG_ADMIN}/categories/${encodeURIComponent(code)}`;
/** Facet manager for one category: curate props (order/type/status/rename),
 * edit canonical options, and recompute. */ const $f9fba5b9b663705e$var$FacetManager = ({ categoryCode: categoryCode })=>{
    const [facets, setFacets] = (0, $acw62.useState)({
        proposals: [],
        options: {}
    });
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    const [busy, setBusy] = (0, $acw62.useState)(false);
    const [expanded, setExpanded] = (0, $acw62.useState)(null);
    const [addOpen, setAddOpen] = (0, $acw62.useState)(false);
    const [newProp, setNewProp] = (0, $acw62.useState)("");
    const [newName, setNewName] = (0, $acw62.useState)("");
    const [recomputing, setRecomputing] = (0, $acw62.useState)(false);
    const [lastUpdated, setLastUpdated] = (0, $acw62.useState)(null);
    const pollRef = (0, $acw62.useRef)(null);
    const load = (0, $acw62.useCallback)(async ()=>{
        setLoading(true);
        setError(null);
        try {
            const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get(`${$f9fba5b9b663705e$var$base(categoryCode)}/facets`);
            const d = res.data;
            // Never trust the shape: a null/missing list must degrade to [] so a
            // render never throws on `.length` (that blanked the whole app before).
            setFacets({
                proposals: Array.isArray(d?.proposals) ? d.proposals : [],
                options: d && typeof d.options === "object" && d.options !== null ? d.options : {}
            });
            setLastUpdated(new Date());
        } catch (e) {
            setError(e?.response?.data?.error || "Erro ao carregar facets.");
        } finally{
            setLoading(false);
        }
    }, [
        categoryCode
    ]);
    (0, $acw62.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    (0, $acw62.useEffect)(()=>()=>{
            if (pollRef.current) window.clearInterval(pollRef.current);
        }, []);
    const patchLocal = (prop, patch)=>{
        setFacets((f)=>({
                ...f,
                proposals: f.proposals.map((p)=>p.prop_code === prop ? {
                        ...p,
                        ...patch
                    } : p)
            }));
    };
    const saveProp = async (p)=>{
        setBusy(true);
        setError(null);
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).put(`${$f9fba5b9b663705e$var$base(categoryCode)}/facets/${encodeURIComponent(p.prop_code)}`, {
                prop_name: p.prop_name,
                rank: p.rank,
                facet_type: p.facet_type,
                status: p.status
            });
            await load();
        } catch (e) {
            setError(e?.response?.data?.error || "Erro ao guardar facet.");
        } finally{
            setBusy(false);
        }
    };
    const rejectProp = async (prop)=>{
        const p = facets.proposals.find((x)=>x.prop_code === prop);
        if (!p) return;
        if (!confirm(`Rejeitar o facet "${prop}"? (pode restaurar mudando o estado)`)) return;
        setBusy(true);
        setError(null);
        try {
            // Reject rather than delete: a deleted prop is re-inserted by the next
            // recompute/backfill; 'rejected' is durable and restorable.
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).put(`${$f9fba5b9b663705e$var$base(categoryCode)}/facets/${encodeURIComponent(prop)}`, {
                prop_name: p.prop_name,
                rank: p.rank,
                facet_type: p.facet_type,
                status: "rejected"
            });
            await load();
        } catch (e) {
            setError(e?.response?.data?.error || "Erro ao rejeitar.");
        } finally{
            setBusy(false);
        }
    };
    // Reassign sequential ranks by array order; PUT only the rows that changed.
    const move = async (i, dir)=>{
        const j = i + dir;
        if (j < 0 || j >= facets.proposals.length) return;
        const reordered = [
            ...facets.proposals
        ];
        const [item] = reordered.splice(i, 1);
        reordered.splice(j, 0, item);
        setBusy(true);
        setError(null);
        try {
            for(let k = 0; k < reordered.length; k++){
                const p = reordered[k];
                if (p.rank !== k) await (0, $bac44633733ff026$export$2e2bcd8739ae039).put(`${$f9fba5b9b663705e$var$base(categoryCode)}/facets/${encodeURIComponent(p.prop_code)}`, {
                    prop_name: p.prop_name,
                    rank: k,
                    facet_type: p.facet_type,
                    status: p.status
                });
            }
            await load();
        } catch (e) {
            setError(e?.response?.data?.error || "Erro ao reordenar.");
        } finally{
            setBusy(false);
        }
    };
    const addProp = async ()=>{
        const code = newProp.trim();
        if (!code) return;
        setBusy(true);
        setError(null);
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).put(`${$f9fba5b9b663705e$var$base(categoryCode)}/facets/${encodeURIComponent(code)}`, {
                prop_name: newName.trim() || code,
                rank: facets.proposals.length,
                facet_type: "fold",
                status: "approved"
            });
            setNewProp("");
            setNewName("");
            setAddOpen(false);
            await load();
        } catch (e) {
            setError(e?.response?.data?.error || "Erro ao adicionar.");
        } finally{
            setBusy(false);
        }
    };
    const setOptions = async (prop, members)=>{
        setBusy(true);
        setError(null);
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).put(`${$f9fba5b9b663705e$var$base(categoryCode)}/facets/${encodeURIComponent(prop)}/options`, {
                members: members.filter((m)=>m.option_key && m.raw_value)
            });
            await load();
        } catch (e) {
            setError(e?.response?.data?.error || "Erro ao guardar op\xe7\xf5es.");
        } finally{
            setBusy(false);
        }
    };
    const recompute = async ()=>{
        setBusy(true);
        setError(null);
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).post(`${$f9fba5b9b663705e$var$base(categoryCode)}/recompute-facets`);
            setRecomputing(true);
            // The job is async and can take a while; poll a few times then stop.
            let ticks = 0;
            if (pollRef.current) window.clearInterval(pollRef.current);
            pollRef.current = window.setInterval(async ()=>{
                ticks++;
                await load();
                if (ticks >= 6) {
                    if (pollRef.current) window.clearInterval(pollRef.current);
                    setRecomputing(false);
                }
            }, 5000);
        } catch (e) {
            setError(e?.response?.data?.error || "Erro ao recomputar.");
            setRecomputing(false);
        } finally{
            setBusy(false);
        }
    };
    if (loading && !lastUpdated) return /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
        className: "text-gray-500 text-sm",
        children: "A carregar facets..."
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            error && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bg-red-50 text-red-700 px-3 py-2 rounded mb-3 text-sm flex items-center justify-between gap-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: error
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "button is-small",
                        onClick: load,
                        children: "Tentar novamente"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center justify-between mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "text-sm font-medium text-gray-700",
                        children: [
                            "Facets (",
                            facets.proposals.length,
                            ")",
                            lastUpdated && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "ml-2 text-xs font-normal text-gray-400",
                                children: [
                                    "atualizado ",
                                    lastUpdated.toLocaleTimeString("pt-PT")
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                className: "button is-small flex items-center gap-1",
                                onClick: ()=>setAddOpen((v)=>!v),
                                disabled: busy,
                                title: "Adicionar prop",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                        className: "w-3.5 h-3.5"
                                    }),
                                    " Prop"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                className: "button is-small flex items-center gap-1",
                                onClick: recompute,
                                disabled: busy || recomputing,
                                title: "Recalcular propostas + op\xe7\xf5es (usa o tipo de cada prop; os props 'ai' s\xe3o agrupados pelo modelo)",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                                        className: "w-3.5 h-3.5 " + (recomputing ? "animate-spin" : "")
                                    }),
                                    recomputing ? "A recalcular\u2026" : "Recomputar"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                className: "text-xs text-gray-500 mb-2",
                children: [
                    "O ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                        children: "tipo"
                    }),
                    " decide como os valores ERP se transformam em op\xe7\xf5es:",
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                        children: "Separar listas"
                    }),
                    ' divide "ATX;Micro-ATX" em op\xe7\xf5es distintas; ',
                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                        children: "Agrupar por significado (IA)"
                    }),
                    " junta valores que dizem o mesmo. Muda o tipo e ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                        children: "Recomputar"
                    }),
                    ", ou adiciona uma op\xe7\xe3o manual (valor \u2192 etiqueta)."
                ]
            }),
            addOpen && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex gap-2 mb-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        className: "input flex-1",
                        placeholder: "c\xf3digo do prop (ex.: NSAID)",
                        "aria-label": "C\xf3digo do prop",
                        value: newProp,
                        onChange: (e)=>setNewProp(e.target.value)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        className: "input flex-1",
                        placeholder: "nome (opcional)",
                        "aria-label": "Nome do prop",
                        value: newName,
                        onChange: (e)=>setNewName(e.target.value)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "button is-small is-primary",
                        onClick: addProp,
                        disabled: busy,
                        children: "Adicionar"
                    })
                ]
            }),
            facets.proposals.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "text-gray-500 text-sm",
                children: 'Sem facets. Use "Recomputar" para gerar candidatos.'
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "space-y-2",
                children: facets.proposals.map((p, i)=>{
                    const open = expanded === p.prop_code;
                    const members = facets.options[p.prop_code] || [];
                    const looksLikeList = members.slice(0, 30).some((m)=>/[;]/.test(m.raw_value) || /, /.test(m.raw_value));
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "border rounded",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex flex-wrap items-center gap-2 px-2 py-1.5",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex flex-col",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                className: "text-gray-400 hover:text-gray-700 disabled:opacity-30",
                                                onClick: ()=>move(i, -1),
                                                disabled: busy || i === 0,
                                                title: "Subir",
                                                "aria-label": "Mover para cima",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f05f6a77fc593bc$export$2e2bcd8739ae039), {
                                                    className: "w-3.5 h-3.5"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                className: "text-gray-400 hover:text-gray-700 disabled:opacity-30",
                                                onClick: ()=>move(i, 1),
                                                disabled: busy || i === facets.proposals.length - 1,
                                                title: "Descer",
                                                "aria-label": "Mover para baixo",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $008e11cf932a0927$export$2e2bcd8739ae039), {
                                                    className: "w-3.5 h-3.5"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        className: "text-gray-400 hover:text-gray-700",
                                        onClick: ()=>setExpanded(open ? null : p.prop_code),
                                        title: "Op\xe7\xf5es",
                                        "aria-label": open ? "Colapsar op\xe7\xf5es" : "Expandir op\xe7\xf5es",
                                        "aria-expanded": open,
                                        children: open ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                            className: "w-4 h-4"
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                                            className: "w-4 h-4"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        className: "input flex-1 min-w-[10rem] text-sm",
                                        value: p.prop_name,
                                        onChange: (e)=>patchLocal(p.prop_code, {
                                                prop_name: e.target.value
                                            }),
                                        "aria-label": "Nome do facet"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "text-xs text-gray-500 font-mono shrink-0",
                                        children: p.prop_code
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "text-xs px-2 py-0.5 rounded-full shrink-0 " + ($f9fba5b9b663705e$var$STATUS_CLASS[p.status] || "bg-gray-100 text-gray-600"),
                                        children: $f9fba5b9b663705e$var$statusLabel(p.status)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                                        className: "input text-xs",
                                        value: p.facet_type,
                                        onChange: (e)=>patchLocal(p.prop_code, {
                                                facet_type: e.target.value
                                            }),
                                        "aria-label": "Tipo do facet",
                                        title: $f9fba5b9b663705e$var$typeLabel(p.facet_type),
                                        children: $f9fba5b9b663705e$var$TYPE_OPTIONS.map((t)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                value: t.value,
                                                children: t.label
                                            }, t.value))
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                                        className: "input text-xs",
                                        value: p.status,
                                        onChange: (e)=>patchLocal(p.prop_code, {
                                                status: e.target.value
                                            }),
                                        "aria-label": "Estado do facet",
                                        children: $f9fba5b9b663705e$var$STATUS_OPTIONS.map((s)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                value: s.value,
                                                children: s.label
                                            }, s.value))
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        className: "button is-small is-primary",
                                        onClick: ()=>saveProp(p),
                                        disabled: busy,
                                        children: "Guardar"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        className: "text-red-500 hover:text-red-700",
                                        onClick: ()=>rejectProp(p.prop_code),
                                        disabled: busy,
                                        title: "Rejeitar",
                                        "aria-label": "Rejeitar facet",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                            className: "w-4 h-4"
                                        })
                                    })
                                ]
                            }),
                            looksLikeList && p.facet_type === "fold" && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "px-3 pb-1 text-xs text-amber-700",
                                children: [
                                    'Detet\xe1mos valores com ";" \u2014 o tipo',
                                    " ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        children: "Separar listas"
                                    }),
                                    " divide-os em v\xe1rias op\xe7\xf5es."
                                ]
                            }),
                            open && /*#__PURE__*/ (0, $ayMG0.jsx)($f9fba5b9b663705e$var$OptionsEditor, {
                                members: members,
                                busy: busy,
                                onSave: (m)=>setOptions(p.prop_code, m)
                            })
                        ]
                    }, p.prop_code);
                })
            })
        ]
    });
};
const $f9fba5b9b663705e$var$manualOf = (m)=>m.filter((x)=>x.source !== "computed");
const $f9fba5b9b663705e$export$4905f0f3a49b0a47 = (groups)=>groups.flatMap((g)=>g.raws.map((r)=>({
                option_key: g.key,
                option_label: g.label,
                raw_value: r,
                source: "manual"
            })));
// One canonical (computed) option: its label plus the raw ERP values it covers.
const $f9fba5b9b663705e$var$ComputedOptionRow = ({ group: group })=>{
    const [open, setOpen] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "text-xs",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                type: "button",
                className: "flex w-full items-center gap-1 text-left text-gray-700 hover:text-gray-900",
                onClick: ()=>setOpen((v)=>!v),
                "aria-expanded": open,
                children: [
                    open ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                        className: "w-3 h-3 shrink-0"
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                        className: "w-3 h-3 shrink-0"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "font-medium truncate",
                        children: group.label || group.key
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "text-gray-500 shrink-0",
                        children: [
                            "(",
                            group.raws.length,
                            ")"
                        ]
                    })
                ]
            }),
            open && /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                className: "ml-4 mt-0.5 text-gray-600",
                children: group.raws.map((r, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                        className: "truncate",
                        title: r,
                        children: [
                            "\xb7 ",
                            r
                        ]
                    }, i))
            })
        ]
    });
};
const $f9fba5b9b663705e$var$OptionsEditor = ({ members: members, busy: busy, onSave: onSave })=>{
    // Only manual rows are editable/saved; the computed set is read-only (the
    // nightly backfill owns it). Saving sends the manual rows only.
    const computed = members.filter((m)=>m.source === "computed");
    // Group the computed members by canonical option, so the operator can see
    // which raw ERP values each option covers.
    const computedGroups = (()=>{
        const byKey = new Map();
        for (const m of computed){
            const g = byKey.get(m.option_key) ?? {
                key: m.option_key,
                label: m.option_label,
                raws: []
            };
            g.raws.push(m.raw_value);
            byKey.set(m.option_key, g);
        }
        return [
            ...byKey.values()
        ].sort((a, b)=>b.raws.length - a.raws.length || a.key.localeCompare(b.key));
    })();
    const [rows, setRows] = (0, $acw62.useState)($f9fba5b9b663705e$var$manualOf(members));
    (0, $acw62.useEffect)(()=>{
        setRows($f9fba5b9b663705e$var$manualOf(members));
    }, [
        members
    ]);
    const upd = (i, patch)=>setRows((r)=>r.map((m, k)=>k === i ? {
                    ...m,
                    ...patch
                } : m));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "border-t px-2 py-2 bg-gray-50",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center justify-between mb-1",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "text-xs font-medium text-gray-500",
                        children: "Op\xe7\xf5es can\xf3nicas"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "button is-small",
                                onClick: ()=>setRows((r)=>r.length === 0 && computedGroups.length > 0 ? $f9fba5b9b663705e$export$4905f0f3a49b0a47(computedGroups) : [
                                            ...r,
                                            {
                                                option_key: "",
                                                option_label: "",
                                                raw_value: "",
                                                source: "manual"
                                            }
                                        ]),
                                title: "A primeira linha converte as op\xe7\xf5es geradas em linhas edit\xe1veis",
                                children: "+ Linha"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "button is-small is-primary",
                                onClick: ()=>onSave(rows),
                                disabled: busy,
                                children: "Guardar op\xe7\xf5es"
                            })
                        ]
                    })
                ]
            }),
            computedGroups.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "text-xs text-gray-500",
                        children: [
                            "Geradas automaticamente (s\xf3 leitura) \u2014 ",
                            computedGroups.length,
                            " ",
                            "op\xe7\xf5es \xb7 ",
                            computed.length,
                            " valores"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt-1 max-h-56 overflow-y-auto space-y-0.5 pr-1",
                        children: computedGroups.map((g)=>/*#__PURE__*/ (0, $ayMG0.jsx)($f9fba5b9b663705e$var$ComputedOptionRow, {
                                group: g
                            }, g.key))
                    })
                ]
            }),
            rows.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                className: "text-xs text-gray-500",
                children: [
                    "Sem op\xe7\xf5es manuais (usam-se as geradas). Carrega em ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                        children: "+ Linha"
                    }),
                    " ",
                    "para converter as ",
                    computedGroups.length,
                    " op\xe7\xf5es geradas em linhas edit\xe1veis."
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "space-y-1",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "grid grid-cols-[1fr_1fr_1.5fr_24px] gap-1 text-[10px] uppercase text-gray-500",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: "Chave"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: "Etiqueta"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: "Valor ERP"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {})
                        ]
                    }),
                    rows.map((m, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "grid grid-cols-[1fr_1fr_1.5fr_24px] gap-1",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    className: "input text-xs",
                                    placeholder: "chave",
                                    "aria-label": "Chave da op\xe7\xe3o",
                                    value: m.option_key,
                                    onChange: (e)=>upd(i, {
                                            option_key: e.target.value
                                        })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    className: "input text-xs",
                                    placeholder: "etiqueta",
                                    "aria-label": "Etiqueta",
                                    value: m.option_label,
                                    onChange: (e)=>upd(i, {
                                            option_label: e.target.value
                                        })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    className: "input text-xs",
                                    placeholder: "valor ERP exato",
                                    "aria-label": "Valor ERP",
                                    value: m.raw_value,
                                    onChange: (e)=>upd(i, {
                                            raw_value: e.target.value
                                        })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "text-red-500 hover:text-red-700",
                                    onClick: ()=>setRows(rows.filter((_, k)=>k !== i)),
                                    "aria-label": "Remover linha",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                        className: "w-3.5 h-3.5"
                                    })
                                })
                            ]
                        }, i))
                ]
            })
        ]
    });
};
var $f9fba5b9b663705e$export$2e2bcd8739ae039 = $f9fba5b9b663705e$var$FacetManager;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $34b0275521c9fef3$var$labelOf = (c)=>c.name ? `${c.name} (${c.erp_ref})` : c.erp_ref;
const $34b0275521c9fef3$var$MAX_RESULTS = 50;
/**
 * Typeahead that ADDS an ERP client to a list (the visibility "Clientes B2B
 * com acesso" allowlist). Same interaction as the campaigns ResellerCombobox
 * (keyboard nav + ARIA listbox) but add-oriented: selecting clears the input so
 * the operator can add several; free text is never accepted.
 */ const $34b0275521c9fef3$var$ClientSearchCombobox = ({ id: id, options: options, onAdd: onAdd, disabled: disabled, loading: loading, placeholder: placeholder })=>{
    const [query, setQuery] = (0, $acw62.useState)("");
    const [open, setOpen] = (0, $acw62.useState)(false);
    const [highlight, setHighlight] = (0, $acw62.useState)(0);
    const rootRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        const onDocMouseDown = (e)=>{
            if (rootRef.current && !rootRef.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener("mousedown", onDocMouseDown);
        return ()=>document.removeEventListener("mousedown", onDocMouseDown);
    }, []);
    const filtered = (0, $acw62.useMemo)(()=>{
        const q = query.trim().toLowerCase();
        const pool = q ? options.filter((o)=>`${o.erp_ref} ${o.name ?? ""}`.toLowerCase().includes(q)) : options;
        return pool.slice(0, $34b0275521c9fef3$var$MAX_RESULTS);
    }, [
        query,
        options
    ]);
    const select = (c)=>{
        onAdd(c.erp_ref);
        setQuery("");
        setOpen(false);
        setHighlight(0);
    };
    const onKeyDown = (e)=>{
        if (e.key === "ArrowDown") {
            e.preventDefault();
            if (!open) {
                setOpen(true);
                setHighlight(0);
            } else setHighlight((h)=>Math.min(h + 1, filtered.length - 1));
        } else if (e.key === "ArrowUp") {
            e.preventDefault();
            setHighlight((h)=>Math.max(h - 1, 0));
        } else if (e.key === "Enter") {
            if (open && filtered[highlight]) {
                e.preventDefault();
                select(filtered[highlight]);
            }
        } else if (e.key === "Escape") setOpen(false);
    };
    const activeOption = open ? filtered[highlight] : undefined;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        ref: rootRef,
        className: "relative",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                id: id,
                type: "text",
                role: "combobox",
                "aria-expanded": open,
                "aria-controls": `${id}-listbox`,
                "aria-autocomplete": "list",
                "aria-activedescendant": activeOption ? `${id}-opt-${activeOption.erp_ref}` : undefined,
                autoComplete: "off",
                disabled: disabled,
                value: query,
                placeholder: placeholder ?? (loading ? "A carregar clientes\u2026" : "Procurar cliente ERP\u2026"),
                onChange: (e)=>{
                    setQuery(e.target.value);
                    setOpen(true);
                    setHighlight(0);
                },
                onFocus: ()=>setOpen(true),
                onKeyDown: onKeyDown,
                onBlur: ()=>setQuery(""),
                className: "input w-full"
            }),
            open && !disabled && /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                id: `${id}-listbox`,
                role: "listbox",
                "aria-label": "Clientes ERP",
                className: "absolute z-50 mt-1 max-h-64 w-full overflow-auto rounded-lg border border-gray-200 bg-white shadow-lg",
                children: filtered.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                    className: "px-3 py-2 text-sm text-gray-500",
                    children: "Sem resultados."
                }) : filtered.map((c, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                        id: `${id}-opt-${c.erp_ref}`,
                        role: "option",
                        "aria-selected": i === highlight,
                        onMouseEnter: ()=>setHighlight(i),
                        onMouseDown: (e)=>{
                            // Keep focus on the input so blur doesn't close first.
                            e.preventDefault();
                            select(c);
                        },
                        className: "cursor-pointer px-3 py-2 text-sm text-gray-800 " + (i === highlight ? "bg-blue-50" : ""),
                        children: $34b0275521c9fef3$var$labelOf(c)
                    }, c.erp_ref))
            })
        ]
    });
};
var $34b0275521c9fef3$export$2e2bcd8739ae039 = $34b0275521c9fef3$var$ClientSearchCombobox;


const $5e5a5e916a4baa23$var$MODE_LABEL = {
    public: "P\xfablico",
    restricted: "Restrito",
    hidden: "Oculto",
    inherit: "Herdado"
};
const $5e5a5e916a4baa23$var$MODE_CLASS = {
    public: "bg-green-100 text-green-700",
    restricted: "bg-amber-100 text-amber-700",
    hidden: "bg-red-100 text-red-700",
    inherit: "bg-gray-100 text-gray-600"
};
const $5e5a5e916a4baa23$var$RANK_LABEL = {
    1: "Departamento",
    2: "Fam\xedlia",
    3: "Subfam\xedlia"
};
const $5e5a5e916a4baa23$var$trimmed = (s)=>(s || "").trim();
function $5e5a5e916a4baa23$var$buildTree(cats) {
    // ERP codes are hierarchical by prefix (222 / 222CAB / 222MBAAK7DIV), but the
    // `parent` link often points at a code that is not in the table (or at
    // itself); fall back to the longest existing prefix so subfamilies nest.
    const clean = cats.map((c)=>({
            ...c,
            code: $5e5a5e916a4baa23$var$trimmed(c.code),
            parent: $5e5a5e916a4baa23$var$trimmed(c.parent)
        }));
    const byCode = new Map(clean.map((c)=>[
            c.code,
            c
        ]));
    const nodes = new Map();
    for (const c of clean)nodes.set(c.code, {
        cat: c,
        children: []
    });
    const roots = [];
    for (const c of clean){
        let parentCode = "";
        if (c.parent && c.parent !== c.code && byCode.has(c.parent)) parentCode = c.parent;
        else for(let i = c.code.length - 1; i >= 1; i--){
            const p = c.code.slice(0, i);
            if (byCode.has(p)) {
                parentCode = p;
                break;
            }
        }
        const node = nodes.get(c.code);
        if (parentCode && parentCode !== c.code) nodes.get(parentCode).children.push(node);
        else roots.push(node);
    }
    return roots;
}
// Effective served visibility per category: walk the parent chain to the nearest
// rule; with no rule anywhere the category is hidden (opt-in default).
function $5e5a5e916a4baa23$var$computeEffective(cats, rules) {
    const byCode = new Map(cats.map((c)=>[
            $5e5a5e916a4baa23$var$trimmed(c.code),
            c
        ]));
    const eff = new Map();
    const resolve = (code)=>{
        const cached = eff.get(code);
        if (cached) return cached;
        const rule = rules[code];
        if (rule) {
            const v = {
                mode: rule.mode,
                source: null
            };
            eff.set(code, v);
            return v;
        }
        const c = byCode.get(code);
        const parent = c ? $5e5a5e916a4baa23$var$trimmed(c.parent) : "";
        if (parent && parent !== code && byCode.has(parent)) {
            const p = resolve(parent);
            const v = {
                mode: p.mode,
                source: p.source ?? parent
            };
            eff.set(code, v);
            return v;
        }
        const v = {
            mode: "hidden",
            source: null
        };
        eff.set(code, v);
        return v;
    };
    for (const c of cats)resolve($5e5a5e916a4baa23$var$trimmed(c.code));
    return eff;
}
function $5e5a5e916a4baa23$var$nodeMatches(node, q) {
    if (!q) return true;
    if (node.cat.code.toLowerCase().includes(q) || node.cat.name.toLowerCase().includes(q)) return true;
    return node.children.some((c)=>$5e5a5e916a4baa23$var$nodeMatches(c, q));
}
const $5e5a5e916a4baa23$var$CategoryNode = ({ node: node, depth: depth, q: q, expanded: expanded, toggle: toggle, selected: selected, onSelect: onSelect, rules: rules, effective: effective })=>{
    if (!$5e5a5e916a4baa23$var$nodeMatches(node, q)) return null;
    const code = node.cat.code;
    const hasChildren = node.children.length > 0;
    const isOpen = expanded.has(code) || !!q && hasChildren;
    const eff = effective.get(code);
    const ownRule = rules[code];
    const badge = eff ? eff.mode : "hidden";
    const isSelected = selected === code;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                role: "treeitem",
                "aria-level": depth + 1,
                "aria-expanded": hasChildren ? isOpen : undefined,
                "aria-selected": isSelected,
                tabIndex: -1,
                className: "group flex items-center gap-1 pr-2 py-1.5 cursor-pointer hover:bg-gray-50 focus-within:bg-blue-50" + (isSelected ? " bg-blue-50 border-l-2 border-blue-500" : " border-l-2 border-transparent"),
                style: {
                    paddingLeft: `${depth * 16 + 6}px`
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        type: "button",
                        className: "text-gray-400 w-5 h-5 flex items-center justify-center shrink-0 rounded hover:bg-gray-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500",
                        onClick: (e)=>{
                            e.stopPropagation();
                            if (hasChildren) toggle(code);
                        },
                        tabIndex: hasChildren ? 0 : -1,
                        "aria-label": hasChildren ? isOpen ? "Colapsar" : "Expandir" : undefined,
                        children: hasChildren ? isOpen ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                            className: "w-3.5 h-3.5"
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                            className: "w-3.5 h-3.5"
                        }) : null
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        type: "button",
                        className: "flex-1 text-left min-w-0 flex items-center gap-2",
                        onClick: ()=>onSelect(code),
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            className: "min-w-0",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "block text-sm font-medium truncate",
                                    children: node.cat.name
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    className: "block text-xs text-gray-500 truncate",
                                    children: [
                                        code,
                                        $5e5a5e916a4baa23$var$RANK_LABEL[node.cat.rank] ? ` \xb7 ${$5e5a5e916a4baa23$var$RANK_LABEL[node.cat.rank]}` : "",
                                        hasChildren ? ` \xb7 ${node.children.length}` : ""
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "text-xs px-2 py-0.5 rounded-full shrink-0 w-20 text-center " + $5e5a5e916a4baa23$var$MODE_CLASS[badge],
                        title: ownRule ? "Regra pr\xf3pria" : eff && eff.source ? `Herdado de ${eff.source}` : "Oculto por defeito (sem regra)",
                        children: $5e5a5e916a4baa23$var$MODE_LABEL[badge]
                    })
                ]
            }),
            isOpen && hasChildren && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "border-l border-gray-200",
                style: {
                    marginLeft: `${depth * 16 + 16}px`
                },
                children: node.children.map((child)=>/*#__PURE__*/ (0, $ayMG0.jsx)($5e5a5e916a4baa23$var$CategoryNode, {
                        node: child,
                        depth: depth + 1,
                        q: q,
                        expanded: expanded,
                        toggle: toggle,
                        selected: selected,
                        onSelect: onSelect,
                        rules: rules,
                        effective: effective
                    }, child.cat.code))
            })
        ]
    });
};
/**
 * Backoffice tab: category tree (with the EFFECTIVE visibility per node), a rule
 * editor, and the facet manager for the selected category.
 */ const $5e5a5e916a4baa23$var$CategoryVisibilityManager = ()=>{
    const [categories, setCategories] = (0, $acw62.useState)([]);
    const [rules, setRules] = (0, $acw62.useState)({});
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    const [success, setSuccess] = (0, $acw62.useState)(null);
    const [search, setSearch] = (0, $acw62.useState)("");
    const [selected, setSelected] = (0, $acw62.useState)(null);
    const [expanded, setExpanded] = (0, $acw62.useState)(new Set());
    const [mode, setMode] = (0, $acw62.useState)("inherit");
    const [clients, setClients] = (0, $acw62.useState)([]);
    const [clientOptions, setClientOptions] = (0, $acw62.useState)([]);
    const [clientsLoading, setClientsLoading] = (0, $acw62.useState)(false);
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const load = (0, $acw62.useCallback)(async ()=>{
        setLoading(true);
        setError(null);
        try {
            const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).CATALOG_ADMIN}/categories`);
            const cats = Array.isArray(res.data?.categories) ? res.data.categories : [];
            setCategories(cats);
            const map = {};
            for (const r of res.data?.rules || [])map[$5e5a5e916a4baa23$var$trimmed(r.category_code)] = r;
            setRules(map);
        } catch (e) {
            setError(e?.response?.data?.error || "Erro ao carregar categorias.");
        } finally{
            setLoading(false);
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    // The restricted-client allowlist uses the same cached ERP client directory
    // as the campaigns reseller picker (b2b_user -> {erp_ref, name}).
    (0, $acw62.useEffect)(()=>{
        let alive = true;
        setClientsLoading(true);
        (0, $bac44633733ff026$export$2e2bcd8739ae039).get(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).CAMPAIGNS}/_values/resellers`).then((r)=>{
            if (alive) setClientOptions(Array.isArray(r.data) ? r.data : []);
        }).catch(()=>{
            if (alive) setClientOptions([]);
        }).finally(()=>{
            if (alive) setClientsLoading(false);
        });
        return ()=>{
            alive = false;
        };
    }, []);
    const tree = (0, $acw62.useMemo)(()=>$5e5a5e916a4baa23$var$buildTree(categories), [
        categories
    ]);
    const effective = (0, $acw62.useMemo)(()=>$5e5a5e916a4baa23$var$computeEffective(categories, rules), [
        categories,
        rules
    ]);
    // Expand the roots once the tree is available.
    (0, $acw62.useEffect)(()=>{
        if (tree.length > 0) setExpanded(new Set(tree.map((n)=>n.cat.code)));
    }, [
        tree.length
    ]);
    const toggle = (0, $acw62.useCallback)((code)=>{
        setExpanded((prev)=>{
            const next = new Set(prev);
            if (next.has(code)) next.delete(code);
            else next.add(code);
            return next;
        });
    }, []);
    const expandAll = (0, $acw62.useCallback)(()=>{
        setExpanded(new Set(categories.map((c)=>$5e5a5e916a4baa23$var$trimmed(c.code))));
    }, [
        categories
    ]);
    const collapseAll = (0, $acw62.useCallback)(()=>setExpanded(new Set()), []);
    const selectCategory = (0, $acw62.useCallback)((code)=>{
        setSelected(code);
        setSuccess(null);
        setError(null);
        const rule = rules[code];
        setMode(rule ? rule.mode : "inherit");
        setClients(rule?.clients || []);
    }, [
        rules
    ]);
    const addClient = (ref)=>{
        if (!ref) return;
        setClients((prev)=>prev.includes(ref) ? prev : [
                ...prev,
                ref
            ]);
    };
    const save = async ()=>{
        if (!selected) return;
        if (mode === "restricted" && clients.length === 0) {
            setError("Modo Restrito exige pelo menos um cliente ERP.");
            return;
        }
        setSaving(true);
        setError(null);
        setSuccess(null);
        try {
            if (mode === "inherit") await (0, $bac44633733ff026$export$2e2bcd8739ae039).delete(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).CATALOG_ADMIN}/visibility/${encodeURIComponent(selected)}`);
            else await (0, $bac44633733ff026$export$2e2bcd8739ae039).put(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).CATALOG_ADMIN}/visibility/${encodeURIComponent(selected)}`, {
                mode: mode,
                erp_clients: mode === "restricted" ? clients : []
            });
            await load();
            // Best-effort: purge the storefront's cached category tree so the
            // slug→ERP-code map (/catalogo/<slug>) reflects the new visibility now,
            // instead of 404ing until the 1h cache expires. A purge failure must not
            // fail the save — the rule is already persisted.
            let purged = false;
            try {
                const res = await fetch("/api/internal/revalidate-storefront", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        tags: [
                            "categories"
                        ]
                    })
                });
                purged = res.ok;
            } catch  {
            /* ignored — best-effort cache purge */ }
            setSuccess(purged ? "Regra guardada. Cache da loja renovada." : "Regra guardada.");
        } catch (e) {
            setError(e?.response?.data?.error || "Erro ao guardar regra.");
        } finally{
            setSaving(false);
        }
    };
    // trim both sides: the API may pad codes, the tree stores them trimmed.
    const selectedCategory = (0, $acw62.useMemo)(()=>categories.find((c)=>$5e5a5e916a4baa23$var$trimmed(c.code) === selected), [
        categories,
        selected
    ]);
    const selectedEff = selectedCategory ? effective.get($5e5a5e916a4baa23$var$trimmed(selectedCategory.code)) : undefined;
    const ancestorBlocking = selectedEff && selectedEff.mode !== "public" && mode === "public";
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "text-gray-500 py-6",
        children: "A carregar..."
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            error && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bg-red-50 text-red-700 px-4 py-2 rounded mb-4 text-sm flex items-center justify-between gap-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: error
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "button is-small",
                        onClick: load,
                        children: "Tentar novamente"
                    })
                ]
            }),
            success && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "bg-green-50 text-green-700 px-4 py-2 rounded mb-4 text-sm",
                children: success
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                className: "text-gray-500 text-sm mb-4",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                        children: "Opt-in:"
                    }),
                    " nada \xe9 p\xfablico at\xe9 ser publicado. Uma regra \xe9 herdada pela sub\xe1rvore; uma regra mais espec\xedfica num descendente sobrep\xf5e-se."
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid-cols-1 lg:grid-cols-[minmax(20rem,2fr)_minmax(0,3fr)] gap-6",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "relative mb-3",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ad14973a512851d$export$2e2bcd8739ae039), {
                                        className: "w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        className: "input pl-9 w-full",
                                        placeholder: "Pesquisar por c\xf3digo ou nome...",
                                        value: search,
                                        onChange: (e)=>setSearch(e.target.value)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center justify-between text-xs text-gray-500 mb-1",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        children: [
                                            categories.length,
                                            " categorias"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                className: "hover:text-gray-800",
                                                onClick: expandAll,
                                                children: "Expandir tudo"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                className: "hover:text-gray-800",
                                                onClick: collapseAll,
                                                children: "Colapsar tudo"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "max-h-[32rem] overflow-y-auto border rounded",
                                role: "tree",
                                children: tree.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "text-gray-500 text-sm p-3",
                                    children: search ? `Sem resultados para "${search}".` : "Nenhuma categoria."
                                }) : tree.map((node)=>/*#__PURE__*/ (0, $ayMG0.jsx)($5e5a5e916a4baa23$var$CategoryNode, {
                                        node: node,
                                        depth: 0,
                                        q: search.trim().toLowerCase(),
                                        expanded: expanded,
                                        toggle: toggle,
                                        selected: selected,
                                        onSelect: selectCategory,
                                        rules: rules,
                                        effective: effective
                                    }, node.cat.code))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "border rounded p-4 lg:max-h-[calc(100vh-8rem)] lg:overflow-y-auto",
                        children: !selectedCategory ? /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "text-gray-500 text-sm",
                            children: [
                                "Selecione uma categoria para gerir a visibilidade e os facets. Sem regra, a categoria fica ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    children: "oculta"
                                }),
                                "."
                            ]
                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    className: "text-base font-semibold text-gray-800",
                                    children: selectedCategory.name
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "text-xs text-gray-500 mb-1",
                                    children: [
                                        selectedCategory.code,
                                        " \xb7",
                                        " ",
                                        $5e5a5e916a4baa23$var$RANK_LABEL[selectedCategory.rank] || `rank ${selectedCategory.rank}`
                                    ]
                                }),
                                selectedEff && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "text-xs text-gray-500 mb-4",
                                    children: [
                                        "Efetivo:",
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "px-1.5 py-0.5 rounded " + $5e5a5e916a4baa23$var$MODE_CLASS[selectedEff.mode],
                                            children: $5e5a5e916a4baa23$var$MODE_LABEL[selectedEff.mode]
                                        }),
                                        selectedEff.source ? ` (herdado de ${selectedEff.source})` : rules[$5e5a5e916a4baa23$var$trimmed(selectedCategory.code)] ? " (regra pr\xf3pria)" : " (sem regra em nenhum ascendente)"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mb-4",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "block text-sm font-medium text-gray-700 mb-2",
                                            children: "Visibilidade"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "flex flex-wrap gap-3",
                                            children: [
                                                "inherit",
                                                "public",
                                                "restricted",
                                                "hidden"
                                            ].map((m)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                    className: "flex items-center gap-1 text-sm cursor-pointer",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            type: "radio",
                                                            name: "visibility-mode",
                                                            checked: mode === m,
                                                            onChange: ()=>setMode(m)
                                                        }),
                                                        $5e5a5e916a4baa23$var$MODE_LABEL[m]
                                                    ]
                                                }, m))
                                        }),
                                        mode === "inherit" && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "text-xs text-gray-500 mt-1",
                                            children: [
                                                "Remove a regra pr\xf3pria; passa a herdar do ascendente mais pr\xf3ximo",
                                                selectedEff && selectedEff.source ? ` (${selectedEff.source} \u{2192} ${$5e5a5e916a4baa23$var$MODE_LABEL[selectedEff.mode]})` : " (ou fica oculta, se nenhum ascendente tiver regra)",
                                                "."
                                            ]
                                        }),
                                        ancestorBlocking && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "text-xs text-amber-700 mt-1",
                                            children: "Aten\xe7\xe3o: um ascendente impede a publica\xe7\xe3o \u2014 mesmo sendo P\xfablico, este ramo n\xe3o ser\xe1 servido enquanto o ascendente n\xe3o for p\xfablico."
                                        })
                                    ]
                                }),
                                mode === "restricted" && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mb-4",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "block text-sm font-medium text-gray-700 mb-2",
                                            children: "Clientes B2B com acesso"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex flex-wrap gap-2 mb-2",
                                            children: [
                                                clients.map((cl)=>{
                                                    const opt = clientOptions.find((o)=>o.erp_ref.toLowerCase() === cl.toLowerCase());
                                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "inline-flex items-center gap-1 bg-amber-100 text-amber-800 text-xs px-2 py-1 rounded-full",
                                                        title: cl,
                                                        children: [
                                                            opt?.name ? `${opt.name} (${cl})` : cl,
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                onClick: ()=>setClients(clients.filter((x)=>x !== cl)),
                                                                "aria-label": `Remover ${cl}`,
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                                                    className: "w-3 h-3"
                                                                })
                                                            })
                                                        ]
                                                    }, cl);
                                                }),
                                                clients.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "text-xs text-gray-400",
                                                    children: "Nenhum cliente selecionado."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $34b0275521c9fef3$export$2e2bcd8739ae039), {
                                            id: "restricted-client",
                                            options: clientOptions,
                                            onAdd: addClient,
                                            loading: clientsLoading
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "text-xs text-gray-500 mt-1",
                                            children: "Acesso por cliente \xe9 informativo: a identidade do cliente ainda n\xe3o \xe9 verificada no gateway."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "button is-primary is-small",
                                    onClick: save,
                                    disabled: saving,
                                    children: saving ? "A guardar..." : "Guardar regra"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "mt-5 border-t pt-4",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f9fba5b9b663705e$export$2e2bcd8739ae039), {
                                        categoryCode: selectedCategory.code
                                    }, selectedCategory.code)
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $5e5a5e916a4baa23$export$2e2bcd8739ae039 = $5e5a5e916a4baa23$var$CategoryVisibilityManager;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $dKcJh = parcelRequire("dKcJh");

var $90blG = parcelRequire("90blG");

var $e5o5x = parcelRequire("e5o5x");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $bfbb65af5bdc7218$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            x: "14",
            y: "4",
            width: "4",
            height: "16",
            rx: "1",
            key: "zuxfzm"
        }
    ],
    [
        "rect",
        {
            x: "6",
            y: "4",
            width: "4",
            height: "16",
            rx: "1",
            key: "1okwgv"
        }
    ]
];
const $bfbb65af5bdc7218$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("pause", $bfbb65af5bdc7218$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $9b547c0f28739ad4$export$3efd853dbb351e94 = [
    [
        "polygon",
        {
            points: "6 3 20 12 6 21 6 3",
            key: "1oa8hb"
        }
    ]
];
const $9b547c0f28739ad4$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("play", $9b547c0f28739ad4$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c38b5b11d1e2b813$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
            key: "1yyitq"
        }
    ],
    [
        "path",
        {
            d: "M16 3.128a4 4 0 0 1 0 7.744",
            key: "16gr8j"
        }
    ],
    [
        "path",
        {
            d: "M22 21v-2a4 4 0 0 0-3-3.87",
            key: "kshegd"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "7",
            r: "4",
            key: "nufk8"
        }
    ]
];
const $c38b5b11d1e2b813$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("users", $c38b5b11d1e2b813$export$3efd853dbb351e94);


const $29ad8a0d5f6e875d$export$4429537025aeeb07 = {
    pending: "Pendente",
    active: "Ativo",
    suspended: "Suspenso",
    unsubscribed: "Cancelado"
};
const $29ad8a0d5f6e875d$export$fce5400eb9b3fa56 = {
    pending: "bg-amber-100 text-amber-700",
    active: "bg-green-100 text-green-700",
    suspended: "bg-gray-200 text-gray-700",
    unsubscribed: "bg-red-100 text-red-700"
};
const $29ad8a0d5f6e875d$export$79c34b902d621576 = {
    subscribed: "Subscri\xe7\xe3o",
    confirmed: "Confirma\xe7\xe3o",
    unsubscribed: "Cancelamento",
    suspended: "Suspens\xe3o",
    reactivated: "Reativa\xe7\xe3o",
    deleted: "Remo\xe7\xe3o",
    group_created: "Grupo criado",
    group_updated: "Grupo atualizado",
    group_deleted: "Grupo removido",
    group_assigned: "Grupos alterados",
    imported: "Importa\xe7\xe3o",
    exported: "Exporta\xe7\xe3o",
    name_updated: "Nome atualizado"
};


const $5e2dd976737086fc$var$PER_PAGE = 25;
const $5e2dd976737086fc$var$base = ()=>`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).NEWSLETTER_ADMIN}/admin`;
const $5e2dd976737086fc$var$statusOptions = [
    {
        value: "",
        label: "Todos os estados"
    },
    {
        value: "active",
        label: "Ativos"
    },
    {
        value: "pending",
        label: "Pendentes"
    },
    {
        value: "suspended",
        label: "Suspensos"
    },
    {
        value: "unsubscribed",
        label: "Cancelados"
    }
];
const $5e2dd976737086fc$var$inputClass = "w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500";
const $5e2dd976737086fc$var$buttonPrimary = "inline-flex items-center gap-2 rounded-lg bg-blue-600 px-3 py-2 text-sm font-medium text-white hover:bg-blue-700 disabled:opacity-50";
const $5e2dd976737086fc$var$buttonSecondary = "inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50";
function $5e2dd976737086fc$var$formatDate(value) {
    if (!value) return "\u2014";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "\u2014";
    return date.toLocaleString("pt-PT");
}
function $5e2dd976737086fc$var$errorMessage(err) {
    return err?.response?.data?.error || "Ocorreu um erro. Tente novamente.";
}
const $5e2dd976737086fc$var$NewsletterManager = ()=>{
    const [subscribers, setSubscribers] = (0, $acw62.useState)([]);
    const [groups, setGroups] = (0, $acw62.useState)([]);
    const [total, setTotal] = (0, $acw62.useState)(0);
    const [page, setPage] = (0, $acw62.useState)(1);
    const [query, setQuery] = (0, $acw62.useState)("");
    const [debouncedQuery, setDebouncedQuery] = (0, $acw62.useState)("");
    const [status, setStatus] = (0, $acw62.useState)("");
    const [groupFilter, setGroupFilter] = (0, $acw62.useState)("");
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    const [success, setSuccess] = (0, $acw62.useState)(null);
    const [addOpen, setAddOpen] = (0, $acw62.useState)(false);
    const [addEmail, setAddEmail] = (0, $acw62.useState)("");
    const [addName, setAddName] = (0, $acw62.useState)("");
    const [addStatus, setAddStatus] = (0, $acw62.useState)("active");
    const [addSendConfirmation, setAddSendConfirmation] = (0, $acw62.useState)(false);
    const [addGroups, setAddGroups] = (0, $acw62.useState)([]);
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [groupName, setGroupName] = (0, $acw62.useState)("");
    const [importOpen, setImportOpen] = (0, $acw62.useState)(false);
    const [importFile, setImportFile] = (0, $acw62.useState)(null);
    const [importing, setImporting] = (0, $acw62.useState)(false);
    const [importResult, setImportResult] = (0, $acw62.useState)(null);
    const [groupEditSubscriber, setGroupEditSubscriber] = (0, $acw62.useState)(null);
    const [groupEditSelection, setGroupEditSelection] = (0, $acw62.useState)([]);
    const [auditSubscriber, setAuditSubscriber] = (0, $acw62.useState)(null);
    const [subscriberAudit, setSubscriberAudit] = (0, $acw62.useState)([]);
    const [auditEvents, setAuditEvents] = (0, $acw62.useState)([]);
    const [auditAction, setAuditAction] = (0, $acw62.useState)("");
    const [auditLoading, setAuditLoading] = (0, $acw62.useState)(false);
    const requestSeq = (0, $acw62.useRef)(0);
    const showSuccess = (0, $acw62.useCallback)((message)=>{
        setSuccess(message);
        setError(null);
    }, []);
    (0, $acw62.useEffect)(()=>{
        const timer = setTimeout(()=>setDebouncedQuery(query), 300);
        return ()=>clearTimeout(timer);
    }, [
        query
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!success) return;
        const timer = setTimeout(()=>setSuccess(null), 6000);
        return ()=>clearTimeout(timer);
    }, [
        success
    ]);
    const loadGroups = (0, $acw62.useCallback)(async ()=>{
        try {
            const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get(`${$5e2dd976737086fc$var$base()}/groups`);
            setGroups(res.data?.data || []);
        } catch (e) {
            setError($5e2dd976737086fc$var$errorMessage(e));
        }
    }, []);
    const loadSubscribers = (0, $acw62.useCallback)(async ()=>{
        const seq = ++requestSeq.current;
        setLoading(true);
        setError(null);
        try {
            const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get(`${$5e2dd976737086fc$var$base()}/subscribers`, {
                params: {
                    page: page,
                    per_page: $5e2dd976737086fc$var$PER_PAGE,
                    q: debouncedQuery || undefined,
                    status: status || undefined,
                    group: groupFilter || undefined
                }
            });
            if (seq !== requestSeq.current) return;
            setSubscribers(res.data.data || []);
            setTotal(res.data.total || 0);
        } catch (e) {
            if (seq !== requestSeq.current) return;
            setError($5e2dd976737086fc$var$errorMessage(e));
        } finally{
            if (seq === requestSeq.current) setLoading(false);
        }
    }, [
        page,
        debouncedQuery,
        status,
        groupFilter
    ]);
    const loadAudit = (0, $acw62.useCallback)(async ()=>{
        setAuditLoading(true);
        try {
            const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get(`${$5e2dd976737086fc$var$base()}/audit`, {
                params: {
                    page: 1,
                    per_page: $5e2dd976737086fc$var$PER_PAGE,
                    action: auditAction || undefined
                }
            });
            setAuditEvents(res.data?.data || []);
        } catch (e) {
            setError($5e2dd976737086fc$var$errorMessage(e));
        } finally{
            setAuditLoading(false);
        }
    }, [
        auditAction
    ]);
    (0, $acw62.useEffect)(()=>{
        loadGroups();
    }, [
        loadGroups
    ]);
    (0, $acw62.useEffect)(()=>{
        loadSubscribers();
    }, [
        loadSubscribers
    ]);
    (0, $acw62.useEffect)(()=>{
        loadAudit();
    }, [
        loadAudit
    ]);
    const pageCount = Math.max(1, Math.ceil(total / $5e2dd976737086fc$var$PER_PAGE));
    const groupOptions = (0, $acw62.useMemo)(()=>groups.map((group)=>({
                value: group.id,
                label: group.name
            })), [
        groups
    ]);
    const resetAddForm = ()=>{
        setAddEmail("");
        setAddName("");
        setAddStatus("active");
        setAddSendConfirmation(false);
        setAddGroups([]);
    };
    const handleAdd = async (event)=>{
        event.preventDefault();
        setSaving(true);
        setError(null);
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).post(`${$5e2dd976737086fc$var$base()}/subscribers`, {
                email: addEmail,
                name: addName.trim() || undefined,
                status: addStatus,
                sendConfirmation: addSendConfirmation,
                groups: addGroups,
                storeName: "Newsletter"
            });
            setAddOpen(false);
            resetAddForm();
            showSuccess("Subscritor adicionado.");
            await loadSubscribers();
            await loadGroups();
            await loadAudit();
        } catch (e) {
            setError($5e2dd976737086fc$var$errorMessage(e));
        } finally{
            setSaving(false);
        }
    };
    const handleToggleStatus = async (subscriber)=>{
        let next = "active";
        let sendConfirmation = false;
        if (subscriber.status === "active") next = "suspended";
        else if (subscriber.status === "suspended") next = "active";
        else if (subscriber.status === "unsubscribed") {
            next = "pending";
            sendConfirmation = true;
        } else if (subscriber.status === "pending") {
            if (!confirm(`Ativar manualmente ${subscriber.email}? Isto dispensa a confirma\xe7\xe3o por email.`)) return;
            next = "active";
        }
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).patch(`${$5e2dd976737086fc$var$base()}/subscribers/${subscriber.id}`, {
                status: next,
                sendConfirmation: sendConfirmation,
                storeName: "Newsletter"
            });
            showSuccess(`Estado alterado para ${(0, $29ad8a0d5f6e875d$export$4429537025aeeb07)[next].toLowerCase()}.`);
            await loadSubscribers();
            await loadAudit();
        } catch (e) {
            setError($5e2dd976737086fc$var$errorMessage(e));
        }
    };
    const handleRenameSubscriber = async (subscriber)=>{
        const name = prompt("Nome do subscritor", subscriber.name || "");
        if (name === null) return;
        if ([
            ...name.trim()
        ].length > 120) {
            setError("O nome n\xe3o pode exceder 120 caracteres.");
            return;
        }
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).patch(`${$5e2dd976737086fc$var$base()}/subscribers/${subscriber.id}`, {
                name: name
            });
            showSuccess("Nome atualizado.");
            await loadSubscribers();
            await loadAudit();
        } catch (e) {
            setError($5e2dd976737086fc$var$errorMessage(e));
        }
    };
    const handleDelete = async (subscriber)=>{
        if (!confirm(`Remover permanentemente ${subscriber.email}? Esta a\xe7\xe3o n\xe3o pode ser revertida.`)) return;
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).delete(`${$5e2dd976737086fc$var$base()}/subscribers/${subscriber.id}`);
            showSuccess("Subscritor removido.");
            await loadSubscribers();
            await loadGroups();
            await loadAudit();
        } catch (e) {
            setError($5e2dd976737086fc$var$errorMessage(e));
        }
    };
    const handleExport = async ()=>{
        try {
            const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get(`${$5e2dd976737086fc$var$base()}/subscribers/export`, {
                params: {
                    status: status || undefined,
                    group: groupFilter || undefined
                },
                responseType: "blob"
            });
            const blob = new Blob([
                res.data
            ], {
                type: "text/csv;charset=utf-8"
            });
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = `newsletter-${new Date().toISOString().slice(0, 10)}.csv`;
            document.body.appendChild(link);
            link.click();
            link.remove();
            URL.revokeObjectURL(link.href);
            showSuccess("Exporta\xe7\xe3o iniciada.");
            await loadAudit();
        } catch (e) {
            setError($5e2dd976737086fc$var$errorMessage(e));
        }
    };
    const handleImport = async (event)=>{
        event.preventDefault();
        if (!importFile) return;
        setImporting(true);
        setError(null);
        setImportResult(null);
        try {
            const formData = new FormData();
            formData.append("file", importFile);
            const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).post(`${$5e2dd976737086fc$var$base()}/subscribers/import`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            });
            setImportResult(res.data);
            await loadSubscribers();
            await loadGroups();
            await loadAudit();
        } catch (e) {
            setError($5e2dd976737086fc$var$errorMessage(e));
        } finally{
            setImporting(false);
        }
    };
    const handleCreateGroup = async (event)=>{
        event.preventDefault();
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).post(`${$5e2dd976737086fc$var$base()}/groups`, {
                name: groupName
            });
            setGroupName("");
            showSuccess("Grupo criado.");
            await loadGroups();
            await loadAudit();
        } catch (e) {
            setError($5e2dd976737086fc$var$errorMessage(e));
        }
    };
    const handleRenameGroup = async (group)=>{
        const name = prompt("Novo nome do grupo", group.name);
        if (!name || name.trim() === "" || name === group.name) return;
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).put(`${$5e2dd976737086fc$var$base()}/groups/${group.id}`, {
                name: name
            });
            showSuccess("Grupo atualizado.");
            await loadGroups();
            await loadAudit();
        } catch (e) {
            setError($5e2dd976737086fc$var$errorMessage(e));
        }
    };
    const handleDeleteGroup = async (group)=>{
        if (!confirm(`Remover o grupo "${group.name}"? Os subscritores permanecem, apenas a associa\xe7\xe3o \xe9 removida.`)) return;
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).delete(`${$5e2dd976737086fc$var$base()}/groups/${group.id}`);
            showSuccess("Grupo removido.");
            await loadGroups();
            await loadAudit();
        } catch (e) {
            setError($5e2dd976737086fc$var$errorMessage(e));
        }
    };
    const openGroupEditor = (subscriber)=>{
        setGroupEditSubscriber(subscriber);
        setGroupEditSelection((subscriber.groups || []).map((group)=>group.id));
    };
    const handleSaveGroups = async ()=>{
        if (!groupEditSubscriber) return;
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).patch(`${$5e2dd976737086fc$var$base()}/subscribers/${groupEditSubscriber.id}`, {
                groups: groupEditSelection
            });
            setGroupEditSubscriber(null);
            showSuccess("Grupos atualizados.");
            await loadSubscribers();
            await loadGroups();
            await loadAudit();
        } catch (e) {
            setError($5e2dd976737086fc$var$errorMessage(e));
        }
    };
    const openAudit = async (subscriber)=>{
        setAuditSubscriber(subscriber);
        setSubscriberAudit([]);
        try {
            const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get(`${$5e2dd976737086fc$var$base()}/subscribers/${subscriber.id}/audit`);
            setSubscriberAudit(res.data?.data || []);
        } catch (e) {
            setError($5e2dd976737086fc$var$errorMessage(e));
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "space-y-6",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex flex-wrap items-start justify-between gap-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "text-lg font-semibold text-gray-800",
                                children: "Newsletter"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "text-sm text-gray-500",
                                children: [
                                    total,
                                    " subscritor",
                                    total === 1 ? "" : "es",
                                    " neste tenant."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex flex-wrap gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                type: "button",
                                className: $5e2dd976737086fc$var$buttonPrimary,
                                onClick: ()=>setAddOpen(true),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                        size: 16,
                                        "aria-hidden": "true"
                                    }),
                                    " Adicionar"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                type: "button",
                                className: $5e2dd976737086fc$var$buttonSecondary,
                                onClick: ()=>{
                                    setImportOpen(true);
                                    setImportResult(null);
                                    setImportFile(null);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f68e7f5ef2ab511$export$2e2bcd8739ae039), {
                                        size: 16,
                                        "aria-hidden": "true"
                                    }),
                                    " Importar CSV"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                type: "button",
                                className: $5e2dd976737086fc$var$buttonSecondary,
                                onClick: handleExport,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d252ca8c87a49232$export$2e2bcd8739ae039), {
                                        size: 16,
                                        "aria-hidden": "true"
                                    }),
                                    " Exportar CSV"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                "aria-live": "polite",
                children: [
                    success && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-2 rounded-lg bg-green-50 px-3 py-2 text-sm text-green-700",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                size: 16,
                                "aria-hidden": "true"
                            }),
                            " ",
                            success
                        ]
                    }),
                    error && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        role: "alert",
                        className: "flex items-center gap-2 rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                                size: 16,
                                "aria-hidden": "true"
                            }),
                            " ",
                            error
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid gap-3 sm:grid-cols-2 lg:grid-cols-4",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        className: $5e2dd976737086fc$var$inputClass,
                        placeholder: "Pesquisar por email",
                        value: query,
                        onChange: (event)=>{
                            setPage(1);
                            setQuery(event.target.value);
                        },
                        "aria-label": "Pesquisar por email"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                        className: $5e2dd976737086fc$var$inputClass,
                        value: status,
                        onChange: (event)=>{
                            setPage(1);
                            setStatus(event.target.value);
                        },
                        "aria-label": "Filtrar por estado",
                        children: $5e2dd976737086fc$var$statusOptions.map((option)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                value: option.value,
                                children: option.label
                            }, option.value))
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                        className: $5e2dd976737086fc$var$inputClass,
                        value: groupFilter,
                        onChange: (event)=>{
                            setPage(1);
                            setGroupFilter(event.target.value);
                        },
                        "aria-label": "Filtrar por grupo",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                value: "",
                                children: "Todos os grupos"
                            }),
                            groupOptions.map((option)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                    value: groups.find((g)=>g.id === option.value)?.slug || "",
                                    children: option.label
                                }, option.value))
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        type: "button",
                        className: $5e2dd976737086fc$var$buttonSecondary,
                        onClick: ()=>{
                            setPage(1);
                            setQuery("");
                            setStatus("");
                            setGroupFilter("");
                        },
                        children: "Limpar filtros"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "overflow-x-auto rounded-lg border border-gray-200",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                    "aria-label": "Subscritores da newsletter",
                    className: "min-w-full divide-y divide-gray-200 text-sm",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                            className: "bg-gray-50 text-left text-xs font-semibold uppercase tracking-wide text-gray-500",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        scope: "col",
                                        className: "px-3 py-2",
                                        children: "Email"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        scope: "col",
                                        className: "px-3 py-2",
                                        children: "Estado"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        scope: "col",
                                        className: "px-3 py-2",
                                        children: "Grupos"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        scope: "col",
                                        className: "px-3 py-2",
                                        children: "Criado"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        scope: "col",
                                        className: "px-3 py-2 text-right",
                                        children: "A\xe7\xf5es"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                            className: "divide-y divide-gray-100",
                            children: loading ? /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                    colSpan: 5,
                                    className: "px-3 py-8 text-center text-gray-500",
                                    role: "status",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                            className: "mx-auto animate-spin",
                                            size: 20,
                                            "aria-hidden": "true"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "sr-only",
                                            children: "A carregar subscritores\u2026"
                                        })
                                    ]
                                })
                            }) : subscribers.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                    colSpan: 5,
                                    className: "px-3 py-8 text-center text-gray-500",
                                    children: "Sem subscritores para os filtros selecionados."
                                })
                            }) : subscribers.map((subscriber)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                    className: "hover:bg-gray-50",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                            className: "px-3 py-2 font-medium text-gray-800",
                                            children: [
                                                subscriber.name && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "block text-gray-900",
                                                    children: subscriber.name
                                                }),
                                                subscriber.email
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "px-3 py-2",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: `inline-flex rounded-full px-2 py-0.5 text-xs font-semibold ${(0, $29ad8a0d5f6e875d$export$fce5400eb9b3fa56)[subscriber.status]}`,
                                                children: (0, $29ad8a0d5f6e875d$export$4429537025aeeb07)[subscriber.status]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "px-3 py-2 text-gray-600",
                                            children: (subscriber.groups || []).length > 0 ? (subscriber.groups || []).map((group)=>group.name).join(", ") : "\u2014"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "px-3 py-2 text-gray-500",
                                            children: $5e2dd976737086fc$var$formatDate(subscriber.created_at)
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "px-3 py-2",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex justify-end gap-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        type: "button",
                                                        className: "rounded p-1.5 text-gray-500 hover:bg-gray-100 hover:text-gray-800",
                                                        onClick: ()=>handleToggleStatus(subscriber),
                                                        "aria-label": subscriber.status === "active" ? `Suspender ${subscriber.email}` : subscriber.status === "pending" ? `Ativar ${subscriber.email}` : `Reativar ${subscriber.email}`,
                                                        title: subscriber.status === "active" ? "Suspender" : subscriber.status === "pending" ? "Ativar" : "Reativar",
                                                        children: subscriber.status === "active" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bfbb65af5bdc7218$export$2e2bcd8739ae039), {
                                                            size: 16,
                                                            "aria-hidden": "true"
                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9b547c0f28739ad4$export$2e2bcd8739ae039), {
                                                            size: 16,
                                                            "aria-hidden": "true"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        type: "button",
                                                        className: "rounded p-1.5 text-gray-500 hover:bg-gray-100 hover:text-gray-800",
                                                        onClick: ()=>handleRenameSubscriber(subscriber),
                                                        "aria-label": `Editar nome de ${subscriber.email}`,
                                                        title: "Editar nome",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6c2a827dd5c2d433$export$2e2bcd8739ae039), {
                                                            size: 16,
                                                            "aria-hidden": "true"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        type: "button",
                                                        className: "rounded p-1.5 text-gray-500 hover:bg-gray-100 hover:text-gray-800",
                                                        onClick: ()=>openGroupEditor(subscriber),
                                                        "aria-label": `Editar grupos de ${subscriber.email}`,
                                                        title: "Grupos",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c38b5b11d1e2b813$export$2e2bcd8739ae039), {
                                                            size: 16,
                                                            "aria-hidden": "true"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        type: "button",
                                                        className: "rounded p-1.5 text-gray-500 hover:bg-gray-100 hover:text-gray-800",
                                                        onClick: ()=>openAudit(subscriber),
                                                        "aria-label": `Ver hist\xf3rico de ${subscriber.email}`,
                                                        title: "Hist\xf3rico",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e17c725e7c863883$export$2e2bcd8739ae039), {
                                                            size: 16,
                                                            "aria-hidden": "true"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        type: "button",
                                                        className: "rounded p-1.5 text-red-500 hover:bg-red-50 hover:text-red-700",
                                                        onClick: ()=>handleDelete(subscriber),
                                                        "aria-label": `Remover ${subscriber.email}`,
                                                        title: "Remover",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                                            size: 16,
                                                            "aria-hidden": "true"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }, subscriber.id))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center justify-between text-sm text-gray-600",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        children: [
                            "P\xe1gina ",
                            page,
                            " de ",
                            pageCount
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex gap-1",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                className: $5e2dd976737086fc$var$buttonSecondary,
                                disabled: page <= 1,
                                onClick: ()=>setPage((current)=>Math.max(1, current - 1)),
                                "aria-label": "P\xe1gina anterior",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c31db635520dc385$export$2e2bcd8739ae039), {
                                    size: 16,
                                    "aria-hidden": "true"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                className: $5e2dd976737086fc$var$buttonSecondary,
                                disabled: page >= pageCount,
                                onClick: ()=>setPage((current)=>Math.min(pageCount, current + 1)),
                                "aria-label": "P\xe1gina seguinte",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                                    size: 16,
                                    "aria-hidden": "true"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                className: "rounded-lg border border-gray-200 p-4",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mb-3 flex items-center justify-between",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "text-sm font-semibold uppercase tracking-wide text-gray-500",
                            children: "Grupos / perfis"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                        onSubmit: handleCreateGroup,
                        className: "mb-3 flex gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                className: $5e2dd976737086fc$var$inputClass,
                                placeholder: "Novo grupo (ex.: VIP, Testes)",
                                value: groupName,
                                onChange: (event)=>setGroupName(event.target.value),
                                "aria-label": "Nome do novo grupo"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                type: "submit",
                                className: $5e2dd976737086fc$var$buttonPrimary,
                                disabled: !groupName.trim(),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                        size: 16,
                                        "aria-hidden": "true"
                                    }),
                                    " Criar"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex flex-wrap gap-2",
                        children: [
                            groups.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "text-sm text-gray-500",
                                children: "Ainda n\xe3o existem grupos."
                            }),
                            groups.map((group)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    className: "inline-flex items-center gap-2 rounded-full bg-gray-100 px-3 py-1 text-sm text-gray-700",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "font-medium",
                                            children: group.name
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "text-xs text-gray-500",
                                            children: group.subscriber_count
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>handleRenameGroup(group),
                                            className: "rounded p-1.5 text-gray-500 hover:bg-gray-200 hover:text-gray-800",
                                            "aria-label": `Renomear grupo ${group.name}`,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6c2a827dd5c2d433$export$2e2bcd8739ae039), {
                                                size: 14,
                                                "aria-hidden": "true"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>handleDeleteGroup(group),
                                            className: "rounded p-1.5 text-red-500 hover:bg-red-50 hover:text-red-700",
                                            "aria-label": `Remover grupo ${group.name}`,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                                size: 14,
                                                "aria-hidden": "true"
                                            })
                                        })
                                    ]
                                }, group.id))
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                className: "rounded-lg border border-gray-200 p-4",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mb-3 flex flex-wrap items-center justify-between gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                className: "text-sm font-semibold uppercase tracking-wide text-gray-500",
                                children: "Hist\xf3rico de auditoria"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                className: `${$5e2dd976737086fc$var$inputClass} max-w-xs`,
                                value: auditAction,
                                onChange: (event)=>setAuditAction(event.target.value),
                                "aria-label": "Filtrar hist\xf3rico por a\xe7\xe3o",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "",
                                        children: "Todas as a\xe7\xf5es"
                                    }),
                                    Object.entries((0, $29ad8a0d5f6e875d$export$79c34b902d621576)).map(([value, label])=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                            value: value,
                                            children: label
                                        }, value))
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "overflow-x-auto",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                            "aria-label": "Hist\xf3rico de auditoria da newsletter",
                            className: "min-w-full divide-y divide-gray-200 text-sm",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                    className: "bg-gray-50 text-left text-xs font-semibold uppercase tracking-wide text-gray-500",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                scope: "col",
                                                className: "px-3 py-2",
                                                children: "Data"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                scope: "col",
                                                className: "px-3 py-2",
                                                children: "A\xe7\xe3o"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                scope: "col",
                                                className: "px-3 py-2",
                                                children: "Email"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                scope: "col",
                                                className: "px-3 py-2",
                                                children: "Ator"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                    className: "divide-y divide-gray-100",
                                    children: auditLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            colSpan: 4,
                                            className: "px-3 py-6 text-center text-gray-500",
                                            role: "status",
                                            children: "A carregar hist\xf3rico\u2026"
                                        })
                                    }) : auditEvents.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            colSpan: 4,
                                            className: "px-3 py-6 text-center text-gray-500",
                                            children: "Sem eventos."
                                        })
                                    }) : auditEvents.map((event)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "px-3 py-2 text-gray-500",
                                                    children: $5e2dd976737086fc$var$formatDate(event.created_at)
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "px-3 py-2 text-gray-700",
                                                    children: (0, $29ad8a0d5f6e875d$export$79c34b902d621576)[event.action] || event.action
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "px-3 py-2 text-gray-600",
                                                    children: event.email_masked || "\u2014"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                    className: "px-3 py-2 text-gray-500",
                                                    children: [
                                                        event.actor_type,
                                                        event.actor_id ? ` (${event.actor_id})` : ""
                                                    ]
                                                })
                                            ]
                                        }, event.id))
                                })
                            ]
                        })
                    })
                ]
            }),
            addOpen && /*#__PURE__*/ (0, $ayMG0.jsx)($5e2dd976737086fc$var$Modal, {
                title: "Adicionar subscritor",
                onClose: ()=>setAddOpen(false),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                    onSubmit: handleAdd,
                    className: "space-y-4",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    htmlFor: "newsletter-add-email",
                                    className: "mb-1 block text-sm font-medium text-gray-700",
                                    children: "Email"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    id: "newsletter-add-email",
                                    autoFocus: true,
                                    type: "email",
                                    required: true,
                                    className: $5e2dd976737086fc$var$inputClass,
                                    value: addEmail,
                                    onChange: (event)=>setAddEmail(event.target.value)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    htmlFor: "newsletter-add-name",
                                    className: "mb-1 block text-sm font-medium text-gray-700",
                                    children: "Nome (opcional)"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    id: "newsletter-add-name",
                                    className: $5e2dd976737086fc$var$inputClass,
                                    value: addName,
                                    onChange: (event)=>setAddName(event.target.value),
                                    maxLength: 120
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "grid gap-3 sm:grid-cols-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            htmlFor: "newsletter-add-status",
                                            className: "mb-1 block text-sm font-medium text-gray-700",
                                            children: "Estado"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                            id: "newsletter-add-status",
                                            className: $5e2dd976737086fc$var$inputClass,
                                            value: addStatus,
                                            onChange: (event)=>setAddStatus(event.target.value),
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "active",
                                                    children: "Ativo"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "pending",
                                                    children: "Pendente (enviar confirma\xe7\xe3o)"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "suspended",
                                                    children: "Suspenso"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "unsubscribed",
                                                    children: "Cancelado"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                    className: "flex items-end gap-2 pb-2 text-sm text-gray-700",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "checkbox",
                                            checked: addSendConfirmation,
                                            onChange: (event)=>setAddSendConfirmation(event.target.checked)
                                        }),
                                        "Enviar email de confirma\xe7\xe3o"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("fieldset", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("legend", {
                                    className: "mb-2 text-sm font-medium text-gray-700",
                                    children: "Grupos"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex flex-wrap gap-3",
                                    children: [
                                        groups.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "text-sm text-gray-500",
                                            children: "Crie grupos na sec\xe7\xe3o abaixo."
                                        }),
                                        groups.map((group)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                className: "flex items-center gap-2 text-sm text-gray-700",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "checkbox",
                                                        checked: addGroups.includes(group.id),
                                                        onChange: (event)=>{
                                                            setAddGroups((current)=>event.target.checked ? [
                                                                    ...current,
                                                                    group.id
                                                                ] : current.filter((id)=>id !== group.id));
                                                        }
                                                    }),
                                                    group.name
                                                ]
                                            }, group.id))
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex justify-end gap-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    type: "button",
                                    className: $5e2dd976737086fc$var$buttonSecondary,
                                    onClick: ()=>setAddOpen(false),
                                    children: "Cancelar"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    type: "submit",
                                    className: $5e2dd976737086fc$var$buttonPrimary,
                                    disabled: saving,
                                    children: [
                                        saving && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                            size: 16,
                                            className: "animate-spin",
                                            "aria-hidden": "true"
                                        }),
                                        "Guardar"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            importOpen && /*#__PURE__*/ (0, $ayMG0.jsx)($5e2dd976737086fc$var$Modal, {
                title: "Importar CSV",
                onClose: ()=>setImportOpen(false),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                    onSubmit: handleImport,
                    className: "space-y-4",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "text-sm text-gray-600",
                            children: [
                                "Formato: ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("code", {
                                    children: "email,name,status,groups"
                                }),
                                ". O nome \xe9 opcional. Os grupos s\xe3o separados por",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("code", {
                                    children: " ;"
                                }),
                                ". M\xe1ximo 10 MB / 50 000 linhas."
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                            type: "file",
                            accept: ".csv,text/csv",
                            onChange: (event)=>setImportFile(event.target.files?.[0] || null),
                            "aria-label": "Ficheiro CSV"
                        }),
                        importResult && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "rounded-lg bg-gray-50 p-3 text-sm text-gray-700",
                            "aria-live": "polite",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    children: [
                                        "Inseridos: ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                            children: importResult.inserted
                                        }),
                                        " \xb7 Atualizados: ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                            children: importResult.updated
                                        }),
                                        " \xb7 Ignorados: ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                            children: importResult.skipped
                                        })
                                    ]
                                }),
                                importResult.errors.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                    className: "mt-2 list-disc pl-5 text-red-700",
                                    children: importResult.errors.map((item)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                            children: [
                                                "Linha ",
                                                item.line,
                                                ": ",
                                                item.reason,
                                                item.email ? ` (${item.email})` : ""
                                            ]
                                        }, `${item.line}-${item.email || ""}`))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex justify-end gap-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    type: "button",
                                    className: $5e2dd976737086fc$var$buttonSecondary,
                                    onClick: ()=>setImportOpen(false),
                                    children: "Fechar"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    type: "submit",
                                    className: $5e2dd976737086fc$var$buttonPrimary,
                                    disabled: !importFile || importing,
                                    children: [
                                        importing && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                            size: 16,
                                            className: "animate-spin",
                                            "aria-hidden": "true"
                                        }),
                                        "Importar"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            groupEditSubscriber && /*#__PURE__*/ (0, $ayMG0.jsx)($5e2dd976737086fc$var$Modal, {
                title: `Grupos de ${groupEditSubscriber.email}`,
                onClose: ()=>setGroupEditSubscriber(null),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "space-y-4",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("fieldset", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("legend", {
                                    className: "mb-2 text-sm font-medium text-gray-700",
                                    children: "Grupos"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex flex-wrap gap-3",
                                    children: [
                                        groups.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "text-sm text-gray-500",
                                            children: "Ainda n\xe3o existem grupos."
                                        }),
                                        groups.map((group)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                className: "flex items-center gap-2 text-sm text-gray-700",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "checkbox",
                                                        checked: groupEditSelection.includes(group.id),
                                                        onChange: (event)=>{
                                                            setGroupEditSelection((current)=>event.target.checked ? [
                                                                    ...current,
                                                                    group.id
                                                                ] : current.filter((id)=>id !== group.id));
                                                        }
                                                    }),
                                                    group.name
                                                ]
                                            }, group.id))
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex justify-end gap-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    type: "button",
                                    className: $5e2dd976737086fc$var$buttonSecondary,
                                    onClick: ()=>setGroupEditSubscriber(null),
                                    children: "Cancelar"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    type: "button",
                                    className: $5e2dd976737086fc$var$buttonPrimary,
                                    onClick: handleSaveGroups,
                                    children: "Guardar"
                                })
                            ]
                        })
                    ]
                })
            }),
            auditSubscriber && /*#__PURE__*/ (0, $ayMG0.jsx)($5e2dd976737086fc$var$Modal, {
                title: `Hist\xf3rico de ${auditSubscriber.email}`,
                onClose: ()=>setAuditSubscriber(null),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "max-h-96 overflow-y-auto",
                    children: subscriberAudit.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "text-sm text-gray-500",
                        children: "Sem eventos."
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                        className: "space-y-2",
                        children: subscriberAudit.map((event)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                className: "rounded-lg border border-gray-200 p-2 text-sm",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center justify-between gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "font-medium text-gray-800",
                                                children: (0, $29ad8a0d5f6e875d$export$79c34b902d621576)[event.action] || event.action
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "text-xs text-gray-500",
                                                children: $5e2dd976737086fc$var$formatDate(event.created_at)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        className: "text-xs text-gray-500",
                                        children: [
                                            event.actor_type,
                                            event.actor_id ? ` (${event.actor_id})` : ""
                                        ]
                                    })
                                ]
                            }, event.id))
                    })
                })
            })
        ]
    });
};
const $5e2dd976737086fc$var$Modal = ({ title: title, onClose: onClose, children: children })=>{
    const titleId = (0, $acw62.useId)();
    const dialogRef = (0, $acw62.useRef)(null);
    const previousFocus = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        previousFocus.current = document.activeElement;
        const node = dialogRef.current;
        if (node) {
            const first = node.querySelector('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
            (first ?? node).focus();
        }
        return ()=>{
            previousFocus.current?.focus();
        };
    }, []);
    const handleKeyDown = (event)=>{
        if (event.key === "Escape") {
            event.preventDefault();
            onClose();
            return;
        }
        if (event.key !== "Tab") return;
        const node = dialogRef.current;
        if (!node) return;
        const focusable = Array.from(node.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter((element)=>element.offsetParent !== null);
        if (focusable.length === 0) {
            event.preventDefault();
            node.focus();
            return;
        }
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            ref: dialogRef,
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": titleId,
            tabIndex: -1,
            onKeyDown: handleKeyDown,
            className: "w-full max-w-lg rounded-xl bg-white p-5 shadow-xl",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mb-4 flex items-start justify-between gap-3",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            id: titleId,
                            className: "text-base font-semibold text-gray-800",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            type: "button",
                            onClick: onClose,
                            "aria-label": "Fechar",
                            className: "rounded p-1 text-gray-500 hover:bg-gray-100 hover:text-gray-800",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                size: 18,
                                "aria-hidden": "true"
                            })
                        })
                    ]
                }),
                children
            ]
        })
    });
};
var $5e2dd976737086fc$export$2e2bcd8739ae039 = $5e2dd976737086fc$var$NewsletterManager;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c6e669e1fd7e7ff8$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8",
            key: "1357e3"
        }
    ],
    [
        "path",
        {
            d: "M3 3v5h5",
            key: "1xhq8a"
        }
    ]
];
const $c6e669e1fd7e7ff8$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("rotate-ccw", $c6e669e1fd7e7ff8$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $84e37213187279fb$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z",
            key: "1ffxy3"
        }
    ],
    [
        "path",
        {
            d: "m21.854 2.147-10.94 10.939",
            key: "12cjpa"
        }
    ]
];
const $84e37213187279fb$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("send", $84e37213187279fb$export$3efd853dbb351e94);


const $aeac9d4d6c5314ab$export$ccd27753061c3111 = ()=>typeof crypto !== "undefined" && "randomUUID" in crypto ? crypto.randomUUID() : Math.random().toString(36).slice(2);
const $aeac9d4d6c5314ab$export$fe45465a5955e63b = (blocks)=>{
    const seen = new Set();
    return blocks.map((block)=>{
        let id = block.id;
        while(!id || seen.has(id))id = $aeac9d4d6c5314ab$export$ccd27753061c3111();
        seen.add(id);
        return {
            ...block,
            id: id
        };
    });
};
const $aeac9d4d6c5314ab$export$6ce387f0beb69b17 = {
    draft: "Rascunho",
    scheduled: "Agendada",
    sending: "A enviar",
    sent: "Enviada",
    partial: "Enviada com erros",
    failed: "Falhou",
    cancelled: "Cancelada"
};
const $aeac9d4d6c5314ab$export$97217b25a647d75f = {
    draft: "bg-gray-100 text-gray-700",
    scheduled: "bg-blue-100 text-blue-700",
    sending: "bg-amber-100 text-amber-700",
    sent: "bg-green-100 text-green-700",
    partial: "bg-amber-100 text-amber-800",
    failed: "bg-red-100 text-red-700",
    cancelled: "bg-gray-200 text-gray-600"
};




const $960c9b628f3a45c7$var$base = ()=>`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).NEWSLETTER_ADMIN}/admin`;
async function $960c9b628f3a45c7$export$dee01639ac25372e() {
    const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get(`${$960c9b628f3a45c7$var$base()}/templates`);
    return res.data?.data || [];
}
async function $960c9b628f3a45c7$export$b0d25eef603fcaca(input) {
    const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).post(`${$960c9b628f3a45c7$var$base()}/templates`, input);
    return res.data;
}
async function $960c9b628f3a45c7$export$27784ae1da8c995e(id, input) {
    const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).put(`${$960c9b628f3a45c7$var$base()}/templates/${id}`, input);
    return res.data;
}
async function $960c9b628f3a45c7$export$94eb32baeb3053a1(id) {
    await (0, $bac44633733ff026$export$2e2bcd8739ae039).delete(`${$960c9b628f3a45c7$var$base()}/templates/${id}`);
}
async function $960c9b628f3a45c7$export$53c973989aafd2c9(params) {
    const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get(`${$960c9b628f3a45c7$var$base()}/newsletters`, {
        params: {
            status: params?.status || undefined,
            page: params?.page || 1,
            per_page: params?.perPage || 25
        }
    });
    return {
        data: res.data?.data || [],
        total: res.data?.total || 0
    };
}
async function $960c9b628f3a45c7$export$b0552fa6c7505f44(input) {
    const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).post(`${$960c9b628f3a45c7$var$base()}/newsletters`, input);
    return res.data;
}
async function $960c9b628f3a45c7$export$ba4b1f74ee4d82b3(id, input) {
    const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).put(`${$960c9b628f3a45c7$var$base()}/newsletters/${id}`, input);
    return res.data;
}
async function $960c9b628f3a45c7$export$4b5d20d7b1023607(id) {
    await (0, $bac44633733ff026$export$2e2bcd8739ae039).delete(`${$960c9b628f3a45c7$var$base()}/newsletters/${id}`);
}
async function $960c9b628f3a45c7$export$f9a645fab5ae3927(id) {
    const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).post(`${$960c9b628f3a45c7$var$base()}/newsletters/${id}/preview`);
    return res.data?.html || "";
}
async function $960c9b628f3a45c7$export$fd3b3a326420c15(id, scheduledAt) {
    const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).post(`${$960c9b628f3a45c7$var$base()}/newsletters/${id}/schedule`, {
        scheduled_at: scheduledAt
    });
    return res.data;
}
async function $960c9b628f3a45c7$export$4649d35127941565(id) {
    const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).post(`${$960c9b628f3a45c7$var$base()}/newsletters/${id}/send`);
    return res.data;
}
async function $960c9b628f3a45c7$export$7dd5e5bc8cc6fa4b(id) {
    const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).post(`${$960c9b628f3a45c7$var$base()}/newsletters/${id}/cancel`);
    return res.data;
}
async function $960c9b628f3a45c7$export$5f81bc2ea916d278(id) {
    const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).post(`${$960c9b628f3a45c7$var$base()}/newsletters/${id}/retry-failed`);
    return res.data;
}
function $960c9b628f3a45c7$export$2065e5c5c4b2dbcb(err) {
    const status = err?.response?.status;
    const raw = err?.response?.data?.error;
    if (status === 400) return "Dados inv\xe1lidos. Verifica os campos obrigat\xf3rios e a lista de destinat\xe1rios.";
    if (status === 409) return "Esta a\xe7\xe3o n\xe3o \xe9 permitida no estado atual da newsletter.";
    if (status === 503) return "O servi\xe7o de campanhas est\xe1 indispon\xedvel. Tenta novamente.";
    return raw || "Ocorreu um erro. Tente novamente.";
}
async function $960c9b628f3a45c7$export$43c210209173fc72(id) {
    const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get(`${$960c9b628f3a45c7$var$base()}/newsletters/${id}/stats`);
    return res.data;
}
async function $960c9b628f3a45c7$export$b4bd2a9b55b20c02(id) {
    const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get(`${$960c9b628f3a45c7$var$base()}/newsletters/${id}/recipients`, {
        params: {
            page: 1,
            per_page: 100
        }
    });
    return {
        data: res.data?.data || [],
        total: res.data?.total || 0
    };
}
async function $960c9b628f3a45c7$export$c25be3ee593c2c59() {
    const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get(`${$960c9b628f3a45c7$var$base()}/niposom/campaigns`);
    return res.data?.data || [];
}
async function $960c9b628f3a45c7$export$84762c899acbd6cc(file) {
    const formData = new FormData();
    formData.append("file", file);
    const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).post("/newsletter-media/upload", formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
    return res.data?.url || "";
}
async function $960c9b628f3a45c7$export$b302f1cceae7e9e7() {
    const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get(`${$960c9b628f3a45c7$var$base()}/groups`);
    return res.data?.data || [];
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $578293164592f2cd$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "9",
            cy: "12",
            r: "1",
            key: "1vctgf"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "5",
            r: "1",
            key: "hp0tcf"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "19",
            r: "1",
            key: "fkjjf6"
        }
    ],
    [
        "circle",
        {
            cx: "15",
            cy: "12",
            r: "1",
            key: "1tmaij"
        }
    ],
    [
        "circle",
        {
            cx: "15",
            cy: "5",
            r: "1",
            key: "19l28e"
        }
    ],
    [
        "circle",
        {
            cx: "15",
            cy: "19",
            r: "1",
            key: "f4zoj3"
        }
    ]
];
const $578293164592f2cd$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("grip-vertical", $578293164592f2cd$export$3efd853dbb351e94);




const $1438c7c20c309b95$var$inputClass = "w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500";
const $1438c7c20c309b95$var$smallInputClass = "w-full rounded-lg border border-gray-300 bg-white px-2 py-1 text-xs text-gray-900 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500";
const $1438c7c20c309b95$var$buttonSecondary = "inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50";
const $1438c7c20c309b95$var$BLOCK_LABELS = {
    header: "Cabe\xe7alho",
    heading: "T\xedtulo",
    text: "Texto",
    image: "Imagem",
    "image-text": "Imagem + Texto",
    button: "Bot\xe3o",
    spacer: "Espa\xe7o",
    divider: "Separador",
    products: "Produtos",
    campaign: "Campanha",
    coupon: "Cup\xe3o",
    social: "Redes sociais",
    html: "HTML",
    footer: "Rodap\xe9"
};
const $1438c7c20c309b95$var$ADDABLE = [
    "header",
    "heading",
    "text",
    "image",
    "image-text",
    "button",
    "products",
    "campaign",
    "coupon",
    "social",
    "spacer",
    "divider",
    "html",
    "footer"
];
const $1438c7c20c309b95$var$SOCIAL_NETWORKS = [
    "instagram",
    "facebook",
    "linkedin",
    "x",
    "youtube",
    "tiktok",
    "whatsapp",
    "website"
];
const $1438c7c20c309b95$var$newBlock = (type)=>{
    switch(type){
        case "header":
            return {
                type: type,
                store_name: "",
                logo_url: ""
            };
        case "heading":
            return {
                type: type,
                text: "T\xedtulo"
            };
        case "text":
            return {
                type: type,
                html: "<p>Escreve aqui o teu texto.</p>"
            };
        case "image":
            return {
                type: type,
                src: "",
                alt: ""
            };
        case "image-text":
            return {
                type: type,
                src: "",
                alt: "",
                image_position: "left",
                title: "",
                html: "<p>Escreve aqui o teu texto.</p>"
            };
        case "button":
            return {
                type: type,
                label: "Saber mais",
                href: "https://"
            };
        case "spacer":
            return {
                type: type,
                height: 24
            };
        case "products":
            return {
                type: type,
                layout: "grid2",
                items: []
            };
        case "campaign":
            return {
                type: type,
                campaign_id: "",
                layout: "grid2",
                items: []
            };
        case "coupon":
            return {
                type: type,
                coupon_code: "BEMVINDO10",
                coupon_description: "10% de desconto",
                coupon_expires: "",
                coupon_cta_label: "Comprar agora",
                coupon_cta_href: ""
            };
        case "social":
            return {
                type: type,
                social: [
                    {
                        network: "instagram",
                        url: ""
                    }
                ]
            };
        case "html":
            return {
                type: type,
                html: "<p></p>"
            };
        case "footer":
            return {
                type: type,
                store_name: "Niposom",
                unsubscribe_label: "Cancelar subscri\xe7\xe3o"
            };
        default:
            return {
                type: type
            };
    }
};
const $1438c7c20c309b95$var$StyleFields = ({ block: block, onChange: onChange })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "grid gap-2 sm:grid-cols-6",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                className: "text-xs text-gray-600",
                children: [
                    "Fundo",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        className: $1438c7c20c309b95$var$smallInputClass,
                        placeholder: "#f9fafb",
                        value: block.background || "",
                        onChange: (e)=>onChange({
                                background: e.target.value
                            }),
                        "aria-label": "Cor de fundo"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                className: "text-xs text-gray-600",
                children: [
                    "Texto",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        className: $1438c7c20c309b95$var$smallInputClass,
                        placeholder: "#111827",
                        value: block.text_color || "",
                        onChange: (e)=>onChange({
                                text_color: e.target.value
                            }),
                        "aria-label": "Cor do texto"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                className: "text-xs text-gray-600",
                children: [
                    "Alinhamento",
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                        className: $1438c7c20c309b95$var$smallInputClass,
                        value: block.align || "",
                        onChange: (e)=>onChange({
                                align: e.target.value || undefined
                            }),
                        "aria-label": "Alinhamento",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                value: "",
                                children: "Padr\xe3o"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                value: "left",
                                children: "Esquerda"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                value: "center",
                                children: "Centro"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                value: "right",
                                children: "Direita"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                className: "text-xs text-gray-600",
                children: [
                    "Padding (px)",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        className: $1438c7c20c309b95$var$smallInputClass,
                        type: "number",
                        min: 0,
                        max: 64,
                        value: block.padding ?? 0,
                        onChange: (e)=>onChange({
                                padding: Number(e.target.value) || 0
                            }),
                        "aria-label": "Padding"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                className: "text-xs text-gray-600",
                children: [
                    "Margem (px)",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        className: $1438c7c20c309b95$var$smallInputClass,
                        type: "number",
                        min: 0,
                        max: 64,
                        value: block.margin ?? 0,
                        onChange: (e)=>onChange({
                                margin: Number(e.target.value) || 0
                            }),
                        "aria-label": "Margem"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                className: "text-xs text-gray-600",
                children: [
                    "Raio (px)",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        className: $1438c7c20c309b95$var$smallInputClass,
                        type: "number",
                        min: 0,
                        max: 24,
                        value: block.radius ?? 0,
                        onChange: (e)=>onChange({
                                radius: Number(e.target.value) || 0
                            }),
                        "aria-label": "Raio"
                    })
                ]
            })
        ]
    });
const $1438c7c20c309b95$var$NewsletterBlockEditor = ({ blocks: blocks, onChange: onChange, campaigns: campaigns })=>{
    const [dragIndex, setDragIndex] = (0, $acw62.useState)(null);
    const [uploadError, setUploadError] = (0, $acw62.useState)(null);
    const blocksRef = (0, $acw62.useRef)(blocks);
    blocksRef.current = blocks;
    const update = (index, patch)=>{
        const next = blocks.map((block, i)=>i === index ? {
                ...block,
                ...patch
            } : block);
        onChange(next);
    };
    const move = (index, delta)=>{
        const target = index + delta;
        if (target < 0 || target >= blocks.length) return;
        const next = [
            ...blocks
        ];
        [next[index], next[target]] = [
            next[target],
            next[index]
        ];
        onChange(next);
    };
    const dropAt = (target)=>{
        if (dragIndex === null || dragIndex === target) {
            setDragIndex(null);
            return;
        }
        const next = [
            ...blocks
        ];
        const [moved] = next.splice(dragIndex, 1);
        next.splice(target, 0, moved);
        onChange(next);
        setDragIndex(null);
    };
    const remove = (index)=>{
        if (!confirm("Remover este bloco?")) return;
        onChange(blocks.filter((_, i)=>i !== index));
    };
    const importCampaignItems = (index, campaignId)=>{
        const campaign = campaigns.find((c)=>String(c.id) === campaignId);
        const items = (campaign?.items || []).map((item)=>({
                id: item.compound_id,
                name: item.name || item.compound_id,
                image: item.image,
                price: item.price_pvp_with_vat,
                currency: item.currency,
                href: ""
            }));
        update(index, {
            campaign_id: campaignId,
            items: items
        });
    };
    const handleUpload = async (index, field, event)=>{
        const file = event.target.files?.[0];
        if (!file) return;
        const blockId = blocksRef.current[index]?.id;
        setUploadError(null);
        try {
            const url = await (0, $960c9b628f3a45c7$export$84762c899acbd6cc)(file);
            // Apply against the CURRENT blocks: the user may have edited or
            // reordered while the upload was in flight.
            const current = blocksRef.current;
            const targetIndex = blockId ? current.findIndex((block)=>block.id === blockId) : index;
            if (targetIndex < 0) return;
            onChange(current.map((block, i)=>i === targetIndex ? {
                    ...block,
                    [field]: url
                } : block));
        } catch (e) {
            setUploadError(e?.response?.data?.error || "N\xe3o foi poss\xedvel carregar a imagem.");
        } finally{
            event.target.value = "";
        }
    };
    const updateSocial = (index, socialIndex, patch)=>{
        const social = [
            ...blocks[index].social || []
        ];
        social[socialIndex] = {
            ...social[socialIndex],
            ...patch
        };
        update(index, {
            social: social
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "space-y-3",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex flex-wrap gap-2",
                children: $1438c7c20c309b95$var$ADDABLE.map((type)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        type: "button",
                        className: $1438c7c20c309b95$var$buttonSecondary,
                        onClick: ()=>onChange([
                                ...blocks,
                                {
                                    ...$1438c7c20c309b95$var$newBlock(type),
                                    id: (0, $aeac9d4d6c5314ab$export$ccd27753061c3111)()
                                }
                            ]),
                        children: [
                            "+ ",
                            $1438c7c20c309b95$var$BLOCK_LABELS[type] || type
                        ]
                    }, type))
            }),
            uploadError && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "alert",
                className: "rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700",
                children: uploadError
            }),
            blocks.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "text-sm text-gray-500",
                children: "Adiciona blocos para construir a newsletter."
            }),
            blocks.map((block, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    "data-testid": "newsletter-block",
                    onDragOver: (event)=>event.preventDefault(),
                    onDrop: (event)=>{
                        event.preventDefault();
                        dropAt(index);
                    },
                    className: `rounded-lg border bg-gray-50 p-3 ${dragIndex === index ? "border-blue-400 ring-2 ring-blue-200" : "border-gray-200"}`,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mb-2 flex items-center justify-between",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    className: "flex items-center gap-1 text-xs font-semibold uppercase tracking-wide text-gray-500",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            draggable: true,
                                            onDragStart: (event)=>{
                                                event.dataTransfer.setData("text/plain", String(index));
                                                setDragIndex(index);
                                            },
                                            onDragEnd: ()=>setDragIndex(null),
                                            className: "cursor-grab",
                                            "aria-label": "Arrastar para reordenar",
                                            title: "Arrastar para reordenar",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $578293164592f2cd$export$2e2bcd8739ae039), {
                                                size: 14,
                                                className: "text-gray-400",
                                                "aria-hidden": "true"
                                            })
                                        }),
                                        $1438c7c20c309b95$var$BLOCK_LABELS[block.type] || block.type
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex gap-1",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            type: "button",
                                            className: "rounded p-1 text-gray-500 hover:bg-white disabled:opacity-30",
                                            onClick: ()=>move(index, -1),
                                            "aria-label": "Mover para cima",
                                            disabled: index === 0,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f05f6a77fc593bc$export$2e2bcd8739ae039), {
                                                size: 14
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            type: "button",
                                            className: "rounded p-1 text-gray-500 hover:bg-white disabled:opacity-30",
                                            onClick: ()=>move(index, 1),
                                            "aria-label": "Mover para baixo",
                                            disabled: index === blocks.length - 1,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $008e11cf932a0927$export$2e2bcd8739ae039), {
                                                size: 14
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            type: "button",
                                            className: "rounded p-1 text-red-600 hover:bg-white",
                                            onClick: ()=>remove(index),
                                            "aria-label": "Remover bloco",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                                size: 14
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        (block.type === "heading" || block.type === "text") && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    className: $1438c7c20c309b95$var$inputClass,
                                    rows: block.type === "heading" ? 1 : 4,
                                    value: block.type === "heading" ? block.text || "" : block.html || "",
                                    onChange: (e)=>update(index, block.type === "heading" ? {
                                            text: e.target.value
                                        } : {
                                            html: e.target.value
                                        })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "mt-2",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($1438c7c20c309b95$var$StyleFields, {
                                        block: block,
                                        onChange: (patch)=>update(index, patch)
                                    })
                                })
                            ]
                        }),
                        block.type === "html" && /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                            className: `${$1438c7c20c309b95$var$inputClass} font-mono`,
                            rows: 6,
                            "aria-label": "HTML",
                            value: block.html || "",
                            onChange: (e)=>update(index, {
                                    html: e.target.value
                                })
                        }),
                        block.type === "image" && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "grid gap-2 sm:grid-cols-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    className: $1438c7c20c309b95$var$inputClass,
                                    placeholder: "URL da imagem",
                                    "aria-label": "URL da imagem",
                                    value: block.src || "",
                                    onChange: (e)=>update(index, {
                                            src: e.target.value
                                        })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    className: $1438c7c20c309b95$var$inputClass,
                                    placeholder: "Texto alternativo",
                                    "aria-label": "Texto alternativo",
                                    value: block.alt || "",
                                    onChange: (e)=>update(index, {
                                            alt: e.target.value
                                        })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    className: $1438c7c20c309b95$var$inputClass,
                                    placeholder: "Link (opcional)",
                                    "aria-label": "Link (opcional)",
                                    value: block.href || "",
                                    onChange: (e)=>update(index, {
                                            href: e.target.value
                                        })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                    className: $1438c7c20c309b95$var$buttonSecondary,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f68e7f5ef2ab511$export$2e2bcd8739ae039), {
                                            size: 14
                                        }),
                                        " Carregar imagem",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "file",
                                            accept: "image/png,image/jpeg,image/gif,image/svg+xml,.svg",
                                            className: "sr-only",
                                            "aria-label": "Carregar imagem",
                                            onChange: (e)=>handleUpload(index, "src", e)
                                        })
                                    ]
                                })
                            ]
                        }),
                        block.type === "image-text" && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "space-y-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "grid gap-2 sm:grid-cols-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            className: $1438c7c20c309b95$var$inputClass,
                                            placeholder: "URL da imagem",
                                            "aria-label": "URL da imagem",
                                            value: block.src || "",
                                            onChange: (e)=>update(index, {
                                                    src: e.target.value
                                                })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            className: $1438c7c20c309b95$var$inputClass,
                                            placeholder: "Texto alternativo",
                                            "aria-label": "Texto alternativo",
                                            value: block.alt || "",
                                            onChange: (e)=>update(index, {
                                                    alt: e.target.value
                                                })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                            className: $1438c7c20c309b95$var$inputClass,
                                            value: block.image_position || "left",
                                            onChange: (e)=>update(index, {
                                                    image_position: e.target.value
                                                }),
                                            "aria-label": "Posi\xe7\xe3o da imagem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "left",
                                                    children: "Imagem \xe0 esquerda"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "right",
                                                    children: "Imagem \xe0 direita"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                            className: $1438c7c20c309b95$var$buttonSecondary,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f68e7f5ef2ab511$export$2e2bcd8739ae039), {
                                                    size: 14
                                                }),
                                                " Carregar imagem",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "file",
                                                    accept: "image/png,image/jpeg,image/gif,image/svg+xml,.svg",
                                                    className: "sr-only",
                                                    "aria-label": "Carregar imagem",
                                                    onChange: (e)=>handleUpload(index, "src", e)
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    className: $1438c7c20c309b95$var$inputClass,
                                    placeholder: "T\xedtulo",
                                    "aria-label": "T\xedtulo",
                                    value: block.title || "",
                                    onChange: (e)=>update(index, {
                                            title: e.target.value
                                        })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    className: $1438c7c20c309b95$var$inputClass,
                                    rows: 3,
                                    placeholder: "Texto",
                                    "aria-label": "Texto",
                                    value: block.html || "",
                                    onChange: (e)=>update(index, {
                                            html: e.target.value
                                        })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "grid gap-2 sm:grid-cols-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            className: $1438c7c20c309b95$var$inputClass,
                                            placeholder: "Texto do bot\xe3o",
                                            "aria-label": "Texto do bot\xe3o",
                                            value: block.label || "",
                                            onChange: (e)=>update(index, {
                                                    label: e.target.value
                                                })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            className: $1438c7c20c309b95$var$inputClass,
                                            placeholder: "Link do bot\xe3o",
                                            "aria-label": "Link do bot\xe3o",
                                            value: block.href || "",
                                            onChange: (e)=>update(index, {
                                                    href: e.target.value
                                                })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($1438c7c20c309b95$var$StyleFields, {
                                    block: block,
                                    onChange: (patch)=>update(index, patch)
                                })
                            ]
                        }),
                        block.type === "button" && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "space-y-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "grid gap-2 sm:grid-cols-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            className: $1438c7c20c309b95$var$inputClass,
                                            placeholder: "Texto do bot\xe3o",
                                            "aria-label": "Texto do bot\xe3o",
                                            value: block.label || "",
                                            onChange: (e)=>update(index, {
                                                    label: e.target.value
                                                })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            className: $1438c7c20c309b95$var$inputClass,
                                            placeholder: "Link",
                                            "aria-label": "Link",
                                            value: block.href || "",
                                            onChange: (e)=>update(index, {
                                                    href: e.target.value
                                                })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($1438c7c20c309b95$var$StyleFields, {
                                    block: block,
                                    onChange: (patch)=>update(index, patch)
                                })
                            ]
                        }),
                        block.type === "spacer" && /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                            className: $1438c7c20c309b95$var$inputClass,
                            type: "number",
                            min: 4,
                            max: 120,
                            value: block.height || 24,
                            onChange: (e)=>update(index, {
                                    height: Number(e.target.value) || 24
                                })
                        }),
                        (block.type === "products" || block.type === "campaign") && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "space-y-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "grid gap-2 sm:grid-cols-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                            className: $1438c7c20c309b95$var$inputClass,
                                            "aria-label": "Layout dos produtos",
                                            value: block.layout || "grid2",
                                            onChange: (e)=>update(index, {
                                                    layout: e.target.value
                                                }),
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "grid1",
                                                    children: "1 coluna"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "grid2",
                                                    children: "2 colunas"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "grid3",
                                                    children: "3 colunas"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                            className: $1438c7c20c309b95$var$inputClass,
                                            "aria-label": "Campanha de produtos",
                                            value: block.campaign_id || "",
                                            onChange: (e)=>importCampaignItems(index, e.target.value),
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "",
                                                    children: "Selecionar campanha\u2026"
                                                }),
                                                campaigns.map((c)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                        value: String(c.id),
                                                        children: c.name
                                                    }, c.id))
                                            ]
                                        })
                                    ]
                                }),
                                block.type === "campaign" && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "grid gap-2 sm:grid-cols-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            className: $1438c7c20c309b95$var$inputClass,
                                            placeholder: "T\xedtulo",
                                            "aria-label": "T\xedtulo",
                                            value: block.title || "",
                                            onChange: (e)=>update(index, {
                                                    title: e.target.value
                                                })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            className: $1438c7c20c309b95$var$inputClass,
                                            placeholder: "Subt\xedtulo",
                                            "aria-label": "Subt\xedtulo",
                                            value: block.subtitle || "",
                                            onChange: (e)=>update(index, {
                                                    subtitle: e.target.value
                                                })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "text-xs text-gray-500",
                                    children: [
                                        (block.items || []).length,
                                        " produto(s). Numa campanha, os produtos e pre\xe7os s\xe3o atualizados no momento do envio."
                                    ]
                                }),
                                (block.items || []).map((item, itemIndex)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "grid gap-2 sm:grid-cols-3",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                className: $1438c7c20c309b95$var$inputClass,
                                                "aria-label": "Nome do produto",
                                                value: item.name,
                                                onChange: (e)=>{
                                                    const items = [
                                                        ...block.items || []
                                                    ];
                                                    items[itemIndex] = {
                                                        ...items[itemIndex],
                                                        name: e.target.value
                                                    };
                                                    update(index, {
                                                        items: items
                                                    });
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                className: $1438c7c20c309b95$var$inputClass,
                                                type: "number",
                                                step: "0.01",
                                                "aria-label": "Pre\xe7o do produto",
                                                value: item.price ?? 0,
                                                onChange: (e)=>{
                                                    const items = [
                                                        ...block.items || []
                                                    ];
                                                    items[itemIndex] = {
                                                        ...items[itemIndex],
                                                        price: Number(e.target.value) || 0
                                                    };
                                                    update(index, {
                                                        items: items
                                                    });
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                className: $1438c7c20c309b95$var$inputClass,
                                                "aria-label": "Link do produto",
                                                value: item.href || "",
                                                onChange: (e)=>{
                                                    const items = [
                                                        ...block.items || []
                                                    ];
                                                    items[itemIndex] = {
                                                        ...items[itemIndex],
                                                        href: e.target.value
                                                    };
                                                    update(index, {
                                                        items: items
                                                    });
                                                }
                                            })
                                        ]
                                    }, item.id || itemIndex))
                            ]
                        }),
                        block.type === "coupon" && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "space-y-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "grid gap-2 sm:grid-cols-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            className: $1438c7c20c309b95$var$inputClass,
                                            placeholder: "C\xf3digo do cup\xe3o",
                                            "aria-label": "C\xf3digo do cup\xe3o",
                                            value: block.coupon_code || "",
                                            onChange: (e)=>update(index, {
                                                    coupon_code: e.target.value
                                                })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            className: $1438c7c20c309b95$var$inputClass,
                                            placeholder: "Validade (ex.: 31/12)",
                                            "aria-label": "Validade (ex.: 31/12)",
                                            value: block.coupon_expires || "",
                                            onChange: (e)=>update(index, {
                                                    coupon_expires: e.target.value
                                                })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    className: $1438c7c20c309b95$var$inputClass,
                                    placeholder: "T\xedtulo (opcional)",
                                    "aria-label": "T\xedtulo (opcional)",
                                    value: block.title || "",
                                    onChange: (e)=>update(index, {
                                            title: e.target.value
                                        })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    className: $1438c7c20c309b95$var$inputClass,
                                    placeholder: "Descri\xe7\xe3o (opcional)",
                                    "aria-label": "Descri\xe7\xe3o (opcional)",
                                    value: block.coupon_description || "",
                                    onChange: (e)=>update(index, {
                                            coupon_description: e.target.value
                                        })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "grid gap-2 sm:grid-cols-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            className: $1438c7c20c309b95$var$inputClass,
                                            placeholder: "Texto do bot\xe3o",
                                            "aria-label": "Texto do bot\xe3o",
                                            value: block.coupon_cta_label || "",
                                            onChange: (e)=>update(index, {
                                                    coupon_cta_label: e.target.value
                                                })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            className: $1438c7c20c309b95$var$inputClass,
                                            placeholder: "Link do bot\xe3o",
                                            "aria-label": "Link do bot\xe3o",
                                            value: block.coupon_cta_href || "",
                                            onChange: (e)=>update(index, {
                                                    coupon_cta_href: e.target.value
                                                })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($1438c7c20c309b95$var$StyleFields, {
                                    block: block,
                                    onChange: (patch)=>update(index, patch)
                                })
                            ]
                        }),
                        block.type === "social" && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "space-y-2",
                            children: [
                                (block.social || []).map((social, socialIndex)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex flex-wrap items-end gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                                                className: $1438c7c20c309b95$var$smallInputClass,
                                                value: social.network,
                                                onChange: (e)=>updateSocial(index, socialIndex, {
                                                        network: e.target.value
                                                    }),
                                                "aria-label": "Rede social",
                                                children: $1438c7c20c309b95$var$SOCIAL_NETWORKS.map((network)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                        value: network,
                                                        children: network
                                                    }, network))
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                className: $1438c7c20c309b95$var$smallInputClass,
                                                placeholder: "https://...",
                                                value: social.url,
                                                onChange: (e)=>updateSocial(index, socialIndex, {
                                                        url: e.target.value
                                                    }),
                                                "aria-label": "URL da rede social"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                type: "button",
                                                className: "rounded p-1 text-red-600 hover:bg-white",
                                                onClick: ()=>{
                                                    const social = (block.social || []).filter((_, i)=>i !== socialIndex);
                                                    update(index, {
                                                        social: social
                                                    });
                                                },
                                                "aria-label": "Remover rede social",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                                    size: 14
                                                })
                                            })
                                        ]
                                    }, socialIndex)),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    type: "button",
                                    className: $1438c7c20c309b95$var$buttonSecondary,
                                    onClick: ()=>update(index, {
                                            social: [
                                                ...block.social || [],
                                                {
                                                    network: "instagram",
                                                    url: ""
                                                }
                                            ]
                                        }),
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                            size: 14
                                        }),
                                        " Adicionar rede"
                                    ]
                                })
                            ]
                        }),
                        (block.type === "header" || block.type === "footer") && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "space-y-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "grid gap-2 sm:grid-cols-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            className: $1438c7c20c309b95$var$inputClass,
                                            placeholder: "Nome da loja",
                                            "aria-label": "Nome da loja",
                                            value: block.store_name || "",
                                            onChange: (e)=>update(index, {
                                                    store_name: e.target.value
                                                })
                                        }),
                                        block.type === "header" ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    className: $1438c7c20c309b95$var$inputClass,
                                                    placeholder: "URL do log\xf3tipo",
                                                    "aria-label": "URL do log\xf3tipo",
                                                    value: block.logo_url || "",
                                                    onChange: (e)=>update(index, {
                                                            logo_url: e.target.value
                                                        })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                    className: $1438c7c20c309b95$var$buttonSecondary,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f68e7f5ef2ab511$export$2e2bcd8739ae039), {
                                                            size: 14
                                                        }),
                                                        " Carregar log\xf3tipo",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            type: "file",
                                                            accept: "image/png,image/jpeg,image/gif,image/svg+xml,.svg",
                                                            className: "sr-only",
                                                            "aria-label": "Carregar log\xf3tipo",
                                                            onChange: (e)=>handleUpload(index, "logo_url", e)
                                                        })
                                                    ]
                                                }),
                                                block.logo_url && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    src: block.logo_url,
                                                    alt: "Pr\xe9-visualiza\xe7\xe3o do log\xf3tipo",
                                                    className: "max-h-12 max-w-[160px] object-contain"
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            className: $1438c7c20c309b95$var$inputClass,
                                            placeholder: "Endere\xe7o",
                                            "aria-label": "Endere\xe7o",
                                            value: block.address || "",
                                            onChange: (e)=>update(index, {
                                                    address: e.target.value
                                                })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($1438c7c20c309b95$var$StyleFields, {
                                    block: block,
                                    onChange: (patch)=>update(index, patch)
                                })
                            ]
                        })
                    ]
                }, block.id || index))
        ]
    });
};
var $1438c7c20c309b95$export$2e2bcd8739ae039 = $1438c7c20c309b95$var$NewsletterBlockEditor;


const $45e3a53c1a23fe70$var$inputClass = "w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500";
const $45e3a53c1a23fe70$var$buttonPrimary = "inline-flex items-center gap-2 rounded-lg bg-blue-600 px-3 py-2 text-sm font-medium text-white hover:bg-blue-700 disabled:opacity-50";
const $45e3a53c1a23fe70$var$buttonSecondary = "inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50";
const $45e3a53c1a23fe70$var$MERGE_TAGS = [
    "{{ first_name }}",
    "{{ name }}",
    "{{ email }}",
    "{{ store_name }}",
    "{{ unsubscribe_url }}",
    "{{ campaign.name }}"
];
const $45e3a53c1a23fe70$var$NewsletterCampaigns = ()=>{
    const [newsletters, setNewsletters] = (0, $acw62.useState)([]);
    const [templates, setTemplates] = (0, $acw62.useState)([]);
    const [groups, setGroups] = (0, $acw62.useState)([]);
    const [campaigns, setCampaigns] = (0, $acw62.useState)([]);
    const [campaignsError, setCampaignsError] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    const [success, setSuccess] = (0, $acw62.useState)(null);
    const [editing, setEditing] = (0, $acw62.useState)(null);
    const [name, setName] = (0, $acw62.useState)("");
    const [subject, setSubject] = (0, $acw62.useState)("");
    const [templateId, setTemplateId] = (0, $acw62.useState)("");
    const [blocks, setBlocks] = (0, $acw62.useState)([]);
    const [groupIds, setGroupIds] = (0, $acw62.useState)([]);
    const [trackingEnabled, setTrackingEnabled] = (0, $acw62.useState)(true);
    const [scheduledAt, setScheduledAt] = (0, $acw62.useState)("");
    const [preview, setPreview] = (0, $acw62.useState)(null);
    const [stats, setStats] = (0, $acw62.useState)(null);
    const [failedRecipients, setFailedRecipients] = (0, $acw62.useState)([]);
    const [busy, setBusy] = (0, $acw62.useState)(false);
    const [copiedTag, setCopiedTag] = (0, $acw62.useState)(null);
    const busyRef = (0, $acw62.useRef)(false);
    const loadSeq = (0, $acw62.useRef)(0);
    const campaignsSeq = (0, $acw62.useRef)(0);
    const loadCampaigns = (0, $acw62.useCallback)(async ()=>{
        const seq = ++campaignsSeq.current;
        try {
            const list = await (0, $960c9b628f3a45c7$export$c25be3ee593c2c59)();
            if (seq !== campaignsSeq.current) return;
            setCampaigns(list);
            setCampaignsError(null);
        } catch  {
            if (seq !== campaignsSeq.current) return;
            setCampaigns([]);
            setCampaignsError("Campanhas indispon\xedveis \u2014 verifica a liga\xe7\xe3o ao cat\xe1logo Niposom.");
        }
    }, []);
    const refreshNewsletters = (0, $acw62.useCallback)(async ()=>{
        try {
            const list = await (0, $960c9b628f3a45c7$export$53c973989aafd2c9)({
                page: 1,
                perPage: 50
            });
            setNewsletters(list.data);
        } catch  {
        // Keep the stale list; the next explicit load surfaces the error.
        }
    }, []);
    const load = (0, $acw62.useCallback)(async ()=>{
        const seq = ++loadSeq.current;
        setLoading(true);
        setError(null);
        try {
            const [list, tpls, grps] = await Promise.all([
                (0, $960c9b628f3a45c7$export$53c973989aafd2c9)({
                    page: 1,
                    perPage: 50
                }),
                (0, $960c9b628f3a45c7$export$dee01639ac25372e)(),
                (0, $960c9b628f3a45c7$export$b302f1cceae7e9e7)()
            ]);
            if (seq !== loadSeq.current) return;
            setNewsletters(list.data);
            setTemplates(tpls);
            setGroups(grps);
            loadCampaigns();
        } catch (e) {
            if (seq !== loadSeq.current) return;
            setError((0, $960c9b628f3a45c7$export$2065e5c5c4b2dbcb)(e));
        } finally{
            if (seq === loadSeq.current) setLoading(false);
        }
    }, [
        loadCampaigns
    ]);
    (0, $acw62.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    // Poll only the campaign list while something is sending, without flipping
    // the table to a spinner or refetching templates/groups/campaigns.
    const anySending = newsletters.some((n)=>n.status === "sending");
    (0, $acw62.useEffect)(()=>{
        if (!anySending) return;
        const timer = setInterval(()=>{
            refreshNewsletters();
        }, 5000);
        return ()=>clearInterval(timer);
    }, [
        anySending,
        refreshNewsletters
    ]);
    const copyMergeTag = async (tag)=>{
        if (!navigator.clipboard) {
            setCopiedTag(null);
            return;
        }
        try {
            await navigator.clipboard?.writeText(tag);
            setCopiedTag(tag);
            window.setTimeout(()=>setCopiedTag(null), 1500);
        } catch  {
            setCopiedTag(null);
        }
    };
    const resetEditor = ()=>{
        setEditing(null);
        setName("");
        setSubject("");
        setTemplateId("");
        setBlocks([]);
        setGroupIds([]);
        setTrackingEnabled(true);
        setScheduledAt("");
        setPreview(null);
    };
    const closeEditor = ()=>{
        const dirty = Boolean(name || subject || blocks.length > 0 || groupIds.length > 0);
        if (dirty && !confirm("Descartar as altera\xe7\xf5es n\xe3o guardadas?")) return;
        resetEditor();
    };
    const openNew = ()=>{
        resetEditor();
        setEditing({
            id: "",
            tenant_id: "",
            name: "",
            subject: "",
            blocks: [],
            status: "draft",
            group_ids: [],
            tracking_enabled: true,
            created_at: "",
            updated_at: ""
        });
    };
    const openEdit = (item)=>{
        setEditing(item);
        setName(item.name);
        setSubject(item.subject);
        setTemplateId(item.template_id || "");
        setBlocks((0, $aeac9d4d6c5314ab$export$fe45465a5955e63b)(item.blocks || []));
        setGroupIds(item.group_ids || []);
        setTrackingEnabled(item.tracking_enabled);
        setScheduledAt(toLocalDateTimeInput(item.scheduled_at));
        setPreview(null);
    };
    const applyTemplate = (id)=>{
        const template = templates.find((t)=>t.id === id);
        if (template && blocks.length > 0 && !confirm("Substituir os blocos atuais pelo template?")) return;
        setTemplateId(id);
        if (template) setBlocks((0, $aeac9d4d6c5314ab$export$fe45465a5955e63b)(JSON.parse(JSON.stringify(template.blocks || []))));
    };
    const run = async (action)=>{
        if (busyRef.current) return;
        busyRef.current = true;
        setBusy(true);
        setError(null);
        setSuccess(null);
        try {
            await action();
        } catch (e) {
            setError((0, $960c9b628f3a45c7$export$2065e5c5c4b2dbcb)(e));
        } finally{
            busyRef.current = false;
            setBusy(false);
        }
    };
    const toLocalDateTimeInput = (value)=>{
        if (!value) return "";
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return "";
        const pad = (n)=>String(n).padStart(2, "0");
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
    };
    const save = async ()=>{
        if (!editing) return null;
        setError(null);
        const payload = {
            name: name,
            subject: subject,
            template_id: templateId || null,
            blocks: blocks,
            group_ids: groupIds,
            tracking_enabled: trackingEnabled
        };
        try {
            const saved = editing.id ? await (0, $960c9b628f3a45c7$export$ba4b1f74ee4d82b3)(editing.id, payload) : await (0, $960c9b628f3a45c7$export$b0552fa6c7505f44)(payload);
            setEditing(saved);
            setSuccess("Newsletter guardada.");
            await load();
            return saved;
        } catch (e) {
            setError((0, $960c9b628f3a45c7$export$2065e5c5c4b2dbcb)(e));
            return null;
        }
    };
    const audienceSummary = ()=>{
        const names = groups.filter((g)=>groupIds.includes(g.id)).map((g)=>g.name).join(", ");
        return `${groupIds.length} lista(s): ${names}`;
    };
    const handlePreview = ()=>run(async ()=>{
            const saved = await save();
            if (!saved) return;
            setPreview(await (0, $960c9b628f3a45c7$export$f9a645fab5ae3927)(saved.id));
        });
    const handleSend = ()=>run(async ()=>{
            if (groupIds.length === 0) {
                setError("Seleciona pelo menos uma lista de destinat\xe1rios.");
                return;
            }
            if (!confirm(`Enviar agora para ${audienceSummary()}?

Esta a\xe7\xe3o n\xe3o pode ser anulada.`)) return;
            const saved = await save();
            if (!saved) return;
            await (0, $960c9b628f3a45c7$export$4649d35127941565)(saved.id);
            setSuccess("Envio iniciado.");
            await load();
            resetEditor();
        });
    const handleSchedule = ()=>run(async ()=>{
            if (groupIds.length === 0) {
                setError("Seleciona pelo menos uma lista de destinat\xe1rios.");
                return;
            }
            if (!scheduledAt) {
                setError("Escolhe uma data e hora.");
                return;
            }
            if (!confirm(`Agendar para ${new Date(scheduledAt).toLocaleString("pt-PT")} \u{2014} ${audienceSummary()}?`)) return;
            const saved = await save();
            if (!saved) return;
            await (0, $960c9b628f3a45c7$export$fd3b3a326420c15)(saved.id, new Date(scheduledAt).toISOString());
            setSuccess("Newsletter agendada.");
            await load();
            resetEditor();
        });
    const handleCancel = (item)=>run(async ()=>{
            if (!confirm("Cancelar esta newsletter?")) return;
            await (0, $960c9b628f3a45c7$export$7dd5e5bc8cc6fa4b)(item.id);
            setSuccess("Newsletter cancelada.");
            await load();
        });
    const handleDelete = (item)=>run(async ()=>{
            if (!confirm(`Eliminar a newsletter "${item.name}"?`)) return;
            await (0, $960c9b628f3a45c7$export$4b5d20d7b1023607)(item.id);
            setSuccess("Newsletter eliminada.");
            await load();
        });
    const handleRetryFailed = (item)=>run(async ()=>{
            if (!confirm(`Reenviar apenas os destinat\xe1rios falhados de "${item.name}"?`)) return;
            await (0, $960c9b628f3a45c7$export$5f81bc2ea916d278)(item.id);
            setSuccess("Reenvio dos destinat\xe1rios falhados iniciado.");
            await load();
        });
    const handleStats = (item)=>run(async ()=>{
            const [st, recs] = await Promise.all([
                (0, $960c9b628f3a45c7$export$43c210209173fc72)(item.id),
                (0, $960c9b628f3a45c7$export$b4bd2a9b55b20c02)(item.id)
            ]);
            setStats(st);
            setFailedRecipients(recs.data.filter((r)=>r.status === "failed"));
        });
    const groupOptions = (0, $acw62.useMemo)(()=>groups.map((g)=>({
                id: g.id,
                name: g.name
            })), [
        groups
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex flex-wrap items-center justify-between gap-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "text-lg font-semibold text-gray-800",
                                children: "Newsletters"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "text-sm text-gray-500",
                                children: [
                                    newsletters.length,
                                    " campanha(s) neste tenant."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        type: "button",
                        className: $45e3a53c1a23fe70$var$buttonPrimary,
                        onClick: openNew,
                        disabled: busy,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                size: 16
                            }),
                            " Nova newsletter"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                "aria-live": "polite",
                children: [
                    success && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-2 rounded-lg bg-green-50 px-3 py-2 text-sm text-green-700",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                size: 16
                            }),
                            " ",
                            success
                        ]
                    }),
                    error && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        role: "alert",
                        className: "flex items-center gap-2 rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                                size: 16
                            }),
                            " ",
                            error
                        ]
                    }),
                    campaignsError && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        role: "alert",
                        className: "flex items-center gap-2 rounded-lg bg-amber-50 px-3 py-2 text-sm text-amber-800",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                                size: 16
                            }),
                            " ",
                            campaignsError,
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                className: "ml-auto rounded border border-amber-300 px-2 py-1 text-xs",
                                onClick: ()=>loadCampaigns(),
                                children: "Tentar novamente"
                            })
                        ]
                    })
                ]
            }),
            !editing && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "overflow-x-auto rounded-lg border border-gray-200",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                    className: "min-w-full divide-y divide-gray-200 text-sm",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                            className: "bg-gray-50 text-left text-xs font-semibold uppercase tracking-wide text-gray-500",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "px-3 py-2",
                                        children: "Nome"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "px-3 py-2",
                                        children: "Assunto"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "px-3 py-2",
                                        children: "Estado"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "px-3 py-2",
                                        children: "Agendada"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "px-3 py-2 text-right",
                                        children: "A\xe7\xf5es"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                            className: "divide-y divide-gray-100",
                            children: loading ? /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                    colSpan: 5,
                                    className: "px-3 py-8 text-center text-gray-500",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                        className: "mx-auto animate-spin",
                                        size: 20
                                    })
                                })
                            }) : newsletters.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                    colSpan: 5,
                                    className: "px-3 py-8 text-center text-gray-500",
                                    children: "Ainda n\xe3o h\xe1 newsletters."
                                })
                            }) : newsletters.map((item)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "px-3 py-2 font-medium text-gray-800",
                                            children: item.name
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "px-3 py-2 text-gray-600",
                                            children: item.subject
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                            className: "px-3 py-2",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: `inline-flex rounded-full px-2 py-0.5 text-xs font-semibold ${(0, $aeac9d4d6c5314ab$export$97217b25a647d75f)[item.status]}`,
                                                    children: (0, $aeac9d4d6c5314ab$export$6ce387f0beb69b17)[item.status]
                                                }),
                                                item.failure_reason && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "mt-1 text-xs text-red-700",
                                                    children: item.failure_reason
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "px-3 py-2 text-gray-500",
                                            children: item.scheduled_at ? new Date(item.scheduled_at).toLocaleString("pt-PT") : "\u2014"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "px-3 py-2",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex justify-end gap-1",
                                                children: [
                                                    (item.status === "draft" || item.status === "cancelled") && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        type: "button",
                                                        className: "rounded p-1.5 text-gray-500 hover:bg-gray-100",
                                                        onClick: ()=>openEdit(item),
                                                        title: "Editar",
                                                        "aria-label": `Editar ${item.name}`,
                                                        disabled: busy,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6c2a827dd5c2d433$export$2e2bcd8739ae039), {
                                                            size: 16
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        type: "button",
                                                        className: "rounded p-1.5 text-gray-500 hover:bg-gray-100",
                                                        onClick: ()=>handleStats(item),
                                                        title: "Estat\xedsticas",
                                                        "aria-label": `Estat\xedsticas de ${item.name}`,
                                                        disabled: busy,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039), {
                                                            size: 16
                                                        })
                                                    }),
                                                    (item.status === "scheduled" || item.status === "sending") && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        type: "button",
                                                        className: "rounded p-1.5 text-gray-500 hover:bg-gray-100",
                                                        onClick: ()=>handleCancel(item),
                                                        title: "Cancelar",
                                                        "aria-label": `Cancelar ${item.name}`,
                                                        disabled: busy,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                                            size: 16
                                                        })
                                                    }),
                                                    (item.status === "partial" || item.status === "failed") && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        type: "button",
                                                        className: "rounded p-1.5 text-amber-700 hover:bg-gray-100",
                                                        onClick: ()=>handleRetryFailed(item),
                                                        title: "Reenviar falhados",
                                                        "aria-label": `Reenviar falhados de ${item.name}`,
                                                        disabled: busy,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c6e669e1fd7e7ff8$export$2e2bcd8739ae039), {
                                                            size: 16
                                                        })
                                                    }),
                                                    (item.status === "draft" || item.status === "cancelled") && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        type: "button",
                                                        className: "rounded p-1.5 text-red-600 hover:bg-gray-100",
                                                        onClick: ()=>handleDelete(item),
                                                        title: "Eliminar",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                                            size: 16
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }, item.id))
                        })
                    ]
                })
            }),
            editing && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "space-y-4 rounded-lg border border-gray-200 p-4",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                className: "text-md font-semibold text-gray-800",
                                children: editing.id ? "Editar newsletter" : "Nova newsletter"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                type: "button",
                                className: $45e3a53c1a23fe70$var$buttonSecondary,
                                onClick: closeEditor,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                        size: 16
                                    }),
                                    " Fechar"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "grid gap-3 sm:grid-cols-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                className: $45e3a53c1a23fe70$var$inputClass,
                                placeholder: "Nome interno",
                                "aria-label": "Nome interno",
                                value: name,
                                onChange: (e)=>{
                                    setName(e.target.value);
                                    setPreview(null);
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                className: $45e3a53c1a23fe70$var$inputClass,
                                placeholder: "Assunto do email",
                                "aria-label": "Assunto do email",
                                value: subject,
                                onChange: (e)=>{
                                    setSubject(e.target.value);
                                    setPreview(null);
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                className: $45e3a53c1a23fe70$var$inputClass,
                                "aria-label": "Template",
                                value: templateId,
                                onChange: (e)=>applyTemplate(e.target.value),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "",
                                        children: "Sem template"
                                    }),
                                    templates.map((t)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("option", {
                                            value: t.id,
                                            children: [
                                                t.name,
                                                t.is_system ? " (base)" : ""
                                            ]
                                        }, t.id))
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                className: "flex items-center gap-2 text-sm text-gray-700",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        type: "checkbox",
                                        checked: trackingEnabled,
                                        onChange: (e)=>setTrackingEnabled(e.target.checked)
                                    }),
                                    "Registar aberturas e cliques"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "mb-1 text-sm font-medium text-gray-700",
                                children: "Listas de destinat\xe1rios"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex flex-wrap gap-3",
                                children: [
                                    groupOptions.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "text-sm text-gray-500",
                                        children: "Cria grupos no separador Subscritores."
                                    }),
                                    groupOptions.map((group)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                            className: "flex items-center gap-2 text-sm text-gray-700",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "checkbox",
                                                    checked: groupIds.includes(group.id),
                                                    onChange: (e)=>setGroupIds((current)=>e.target.checked ? [
                                                                ...current,
                                                                group.id
                                                            ] : current.filter((id)=>id !== group.id))
                                                }),
                                                group.name
                                            ]
                                        }, group.id))
                                ]
                            })
                        ]
                    }),
                    groupIds.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "mt-1 text-sm text-amber-700",
                        children: "Seleciona pelo menos uma lista. Sem lista n\xe3o \xe9 poss\xedvel enviar."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1438c7c20c309b95$export$2e2bcd8739ae039), {
                        blocks: blocks,
                        onChange: (next)=>{
                            setBlocks(next);
                            setPreview(null);
                        },
                        campaigns: campaigns
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "rounded-lg border border-gray-200 bg-gray-50 p-3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "mb-2 text-xs font-medium text-gray-700",
                                children: "Vari\xe1veis (clica para copiar e cola no texto):"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "flex flex-wrap gap-2",
                                children: $45e3a53c1a23fe70$var$MERGE_TAGS.map((tag)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>copyMergeTag(tag),
                                        className: "rounded border border-gray-300 bg-white px-2 py-1 font-mono text-xs text-gray-700 hover:bg-gray-100",
                                        children: tag
                                    }, tag))
                            }),
                            copiedTag && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "mt-1 text-xs text-green-700",
                                role: "status",
                                children: [
                                    "Copiado: ",
                                    copiedTag
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "mt-2 text-xs text-gray-500",
                                children: "Pr\xe9-visualiza\xe7\xe3o usa Maria Silva (maria@example.com)."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex flex-wrap items-end gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                className: $45e3a53c1a23fe70$var$buttonPrimary,
                                onClick: ()=>run(async ()=>{
                                        await save();
                                    }),
                                disabled: busy,
                                children: "Guardar"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                type: "button",
                                className: $45e3a53c1a23fe70$var$buttonSecondary,
                                onClick: handlePreview,
                                disabled: busy,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039), {
                                        size: 16
                                    }),
                                    " Pr\xe9-visualizar"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                type: "button",
                                className: $45e3a53c1a23fe70$var$buttonSecondary,
                                onClick: handleSend,
                                disabled: busy,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $84e37213187279fb$export$2e2bcd8739ae039), {
                                        size: 16
                                    }),
                                    " Enviar agora"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-end gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        className: $45e3a53c1a23fe70$var$inputClass,
                                        type: "datetime-local",
                                        "aria-label": "Data e hora de agendamento",
                                        value: scheduledAt,
                                        onChange: (e)=>setScheduledAt(e.target.value)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        type: "button",
                                        className: $45e3a53c1a23fe70$var$buttonSecondary,
                                        onClick: handleSchedule,
                                        disabled: busy,
                                        children: "Agendar"
                                    })
                                ]
                            })
                        ]
                    }),
                    preview && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "mb-1 text-sm font-medium text-gray-700",
                                children: "Pr\xe9-visualiza\xe7\xe3o"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("iframe", {
                                title: "Pr\xe9-visualiza\xe7\xe3o da newsletter",
                                srcDoc: preview,
                                sandbox: "",
                                className: "h-96 w-full rounded-lg border border-gray-200"
                            })
                        ]
                    })
                ]
            }),
            stats && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "rounded-lg border border-gray-200 p-4",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mb-2 flex items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                className: "text-md font-semibold text-gray-800",
                                children: [
                                    "Estat\xedsticas \u2014 ",
                                    (0, $aeac9d4d6c5314ab$export$6ce387f0beb69b17)[stats.status]
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                type: "button",
                                className: $45e3a53c1a23fe70$var$buttonSecondary,
                                onClick: ()=>{
                                    setStats(null);
                                    setFailedRecipients([]);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                        size: 16
                                    }),
                                    " Fechar"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "grid grid-cols-2 gap-2 text-sm sm:grid-cols-4",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    "Total: ",
                                    stats.total
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    "Enviados: ",
                                    stats.sent
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    "Falhados: ",
                                    stats.failed
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    "Pendentes: ",
                                    stats.pending
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    "Aberturas \xfanicas: ",
                                    stats.unique_opens
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    "Cliques \xfanicos: ",
                                    stats.unique_clicks
                                ]
                            })
                        ]
                    }),
                    failedRecipients.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mt-3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "mb-1 text-sm font-medium text-gray-700",
                                children: [
                                    "Destinat\xe1rios falhados (",
                                    failedRecipients.length,
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                className: "max-h-48 space-y-1 overflow-auto text-xs text-red-700",
                                children: failedRecipients.map((recipient)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                        children: [
                                            recipient.email,
                                            recipient.error ? ` \u{2014} ${recipient.error}` : ""
                                        ]
                                    }, recipient.id))
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $45e3a53c1a23fe70$export$2e2bcd8739ae039 = $45e3a53c1a23fe70$var$NewsletterCampaigns;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




const $bb93f1511bf3ac47$var$inputClass = "w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500";
const $bb93f1511bf3ac47$var$buttonPrimary = "inline-flex items-center gap-2 rounded-lg bg-blue-600 px-3 py-2 text-sm font-medium text-white hover:bg-blue-700 disabled:opacity-50";
const $bb93f1511bf3ac47$var$buttonSecondary = "inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50";
const $bb93f1511bf3ac47$var$NewsletterTemplates = ()=>{
    const [templates, setTemplates] = (0, $acw62.useState)([]);
    const [campaigns, setCampaigns] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    const [success, setSuccess] = (0, $acw62.useState)(null);
    const [campaignsError, setCampaignsError] = (0, $acw62.useState)(null);
    const [editing, setEditing] = (0, $acw62.useState)(null);
    const [name, setName] = (0, $acw62.useState)("");
    const [blocks, setBlocks] = (0, $acw62.useState)([]);
    const [busy, setBusy] = (0, $acw62.useState)(false);
    const busyRef = (0, $acw62.useRef)(false);
    const loadCampaigns = (0, $acw62.useCallback)(async ()=>{
        try {
            setCampaigns(await (0, $960c9b628f3a45c7$export$c25be3ee593c2c59)());
            setCampaignsError(null);
        } catch  {
            setCampaigns([]);
            setCampaignsError("Campanhas indispon\xedveis \u2014 verifica a liga\xe7\xe3o ao cat\xe1logo Niposom.");
        }
    }, []);
    const load = (0, $acw62.useCallback)(async ()=>{
        setLoading(true);
        setError(null);
        try {
            setTemplates(await (0, $960c9b628f3a45c7$export$dee01639ac25372e)());
            loadCampaigns();
        } catch (e) {
            setError((0, $960c9b628f3a45c7$export$2065e5c5c4b2dbcb)(e));
        } finally{
            setLoading(false);
        }
    }, [
        loadCampaigns
    ]);
    (0, $acw62.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    const openNew = ()=>{
        setEditing({
            id: "",
            tenant_id: "",
            name: "",
            slug: "",
            blocks: [],
            is_system: false,
            created_at: "",
            updated_at: ""
        });
        setName("");
        setBlocks([]);
    };
    const openEdit = (template)=>{
        setEditing(template);
        setName(template.name);
        setBlocks((0, $aeac9d4d6c5314ab$export$fe45465a5955e63b)(JSON.parse(JSON.stringify(template.blocks || []))));
    };
    const run = async (action)=>{
        if (busyRef.current) return;
        busyRef.current = true;
        setBusy(true);
        setError(null);
        try {
            await action();
        } catch (e) {
            setError((0, $960c9b628f3a45c7$export$2065e5c5c4b2dbcb)(e));
        } finally{
            busyRef.current = false;
            setBusy(false);
        }
    };
    const save = ()=>run(async ()=>{
            if (!editing) return;
            if (editing.id) await (0, $960c9b628f3a45c7$export$27784ae1da8c995e)(editing.id, {
                name: name,
                blocks: blocks,
                html_source: editing.html_source || ""
            });
            else await (0, $960c9b628f3a45c7$export$b0d25eef603fcaca)({
                name: name,
                blocks: blocks,
                html_source: ""
            });
            setSuccess("Template guardado.");
            setEditing(null);
            await load();
        });
    const remove = (template)=>run(async ()=>{
            if (!confirm(`Eliminar o template "${template.name}"?`)) return;
            await (0, $960c9b628f3a45c7$export$94eb32baeb3053a1)(template.id);
            setSuccess("Template eliminado.");
            await load();
        });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex flex-wrap items-center justify-between gap-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "text-lg font-semibold text-gray-800",
                                children: "Templates"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "text-sm text-gray-500",
                                children: "Templates base prontos a usar e templates personalizados."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        type: "button",
                        className: $bb93f1511bf3ac47$var$buttonPrimary,
                        onClick: openNew,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                size: 16
                            }),
                            " Novo template"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                "aria-live": "polite",
                children: [
                    success && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-2 rounded-lg bg-green-50 px-3 py-2 text-sm text-green-700",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                size: 16
                            }),
                            " ",
                            success
                        ]
                    }),
                    error && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        role: "alert",
                        className: "flex items-center gap-2 rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                                size: 16
                            }),
                            " ",
                            error
                        ]
                    }),
                    campaignsError && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        role: "alert",
                        className: "flex items-center gap-2 rounded-lg bg-amber-50 px-3 py-2 text-sm text-amber-800",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                                size: 16
                            }),
                            " ",
                            campaignsError,
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                className: "ml-auto rounded border border-amber-300 px-2 py-1 text-xs",
                                onClick: ()=>loadCampaigns(),
                                children: "Tentar novamente"
                            })
                        ]
                    })
                ]
            }),
            !editing && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "grid gap-3 sm:grid-cols-2 lg:grid-cols-3",
                children: loading ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "col-span-full py-8 text-center text-gray-500",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                        className: "mx-auto animate-spin",
                        size: 20
                    })
                }) : templates.map((template)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "rounded-lg border border-gray-200 p-3",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex items-start justify-between gap-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "font-medium text-gray-800",
                                            children: template.name
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "text-xs text-gray-500",
                                            children: [
                                                template.is_system ? "Template base (edit\xe1vel)" : "Personalizado",
                                                " ",
                                                "\xb7 ",
                                                (template.blocks || []).length,
                                                " bloco(s)"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex gap-1",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            type: "button",
                                            className: "rounded p-1.5 text-gray-500 hover:bg-gray-100",
                                            onClick: ()=>openEdit(template),
                                            title: "Editar",
                                            "aria-label": `Editar ${template.name}`,
                                            disabled: busy,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6c2a827dd5c2d433$export$2e2bcd8739ae039), {
                                                size: 16
                                            })
                                        }),
                                        !template.is_system && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            type: "button",
                                            className: "rounded p-1.5 text-red-600 hover:bg-gray-100",
                                            onClick: ()=>remove(template),
                                            title: "Eliminar",
                                            "aria-label": `Eliminar ${template.name}`,
                                            disabled: busy,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                                size: 16
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }, template.id))
            }),
            editing && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "space-y-4 rounded-lg border border-gray-200 p-4",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                className: "text-md font-semibold text-gray-800",
                                children: editing.id ? "Editar template" : "Novo template"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                type: "button",
                                className: $bb93f1511bf3ac47$var$buttonSecondary,
                                onClick: ()=>setEditing(null),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                        size: 16
                                    }),
                                    " Fechar"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        className: $bb93f1511bf3ac47$var$inputClass,
                        placeholder: "Nome do template",
                        value: name,
                        onChange: (e)=>setName(e.target.value)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1438c7c20c309b95$export$2e2bcd8739ae039), {
                        blocks: blocks,
                        onChange: setBlocks,
                        campaigns: campaigns
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        type: "button",
                        className: $bb93f1511bf3ac47$var$buttonPrimary,
                        onClick: save,
                        disabled: busy,
                        children: "Guardar template"
                    })
                ]
            })
        ]
    });
};
var $bb93f1511bf3ac47$export$2e2bcd8739ae039 = $bb93f1511bf3ac47$var$NewsletterTemplates;


const $011adbed29b33da8$var$NewsletterSection = ()=>{
    const [tab, setTab] = (0, $acw62.useState)(0);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e5o5x))), {
                sx: {
                    borderBottom: 1,
                    borderColor: "divider",
                    mb: 3
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($dKcJh))), {
                    value: tab,
                    onChange: (_e, value)=>setTab(value),
                    "aria-label": "newsletter-tabs",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($90blG))), {
                            label: "Subscritores",
                            id: "tab-newsletter-subscribers",
                            "aria-controls": "panel-newsletter-subscribers"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($90blG))), {
                            label: "Campanhas",
                            id: "tab-newsletter-campaigns",
                            "aria-controls": "panel-newsletter-campaigns"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($90blG))), {
                            label: "Templates",
                            id: "tab-newsletter-templates",
                            "aria-controls": "panel-newsletter-templates"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "tabpanel",
                id: "panel-newsletter-subscribers",
                "aria-labelledby": "tab-newsletter-subscribers",
                hidden: tab !== 0,
                children: tab === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5e2dd976737086fc$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "tabpanel",
                id: "panel-newsletter-campaigns",
                "aria-labelledby": "tab-newsletter-campaigns",
                hidden: tab !== 1,
                children: tab === 1 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $45e3a53c1a23fe70$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "tabpanel",
                id: "panel-newsletter-templates",
                "aria-labelledby": "tab-newsletter-templates",
                hidden: tab !== 2,
                children: tab === 2 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bb93f1511bf3ac47$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $011adbed29b33da8$export$2e2bcd8739ae039 = $011adbed29b33da8$var$NewsletterSection;



const $15141d21a167b494$var$PublicSiteManagementPage = ()=>{
    const { profile: profile, isAuthenticated: isAuthenticated } = (0, $b622ef53e38024e7$export$1d39dc5b47e56ff0)();
    const [userProfile, setUserProfile] = (0, $acw62.useState)(null);
    const [profileLoading, setProfileLoading] = (0, $acw62.useState)(true);
    const [activeTab, setActiveTab] = (0, $acw62.useState)(0);
    // ── Multi-tenant selection (ADR-021) ─────────────────────────────────────
    // Shipping/payment/delivery config is per-tenant; the keyed remount below
    // refetches when the operator switches tenant.
    const { tenants: tenants, selectedTenant: selectedTenant, selectTenant: selectTenant } = (0, $d3c233bd9ac99dda$export$d4c94cedb7152d21)();
    (0, $acw62.useEffect)(()=>{
        profile().then((p)=>{
            setUserProfile(p);
            setProfileLoading(false);
        }).catch(()=>setProfileLoading(false));
    }, [
        profile
    ]);
    if (!isAuthenticated()) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$444b3ab0cb9aec40), {
        to: "/login",
        replace: true
    });
    if (profileLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex items-center justify-center p-12 text-gray-500",
        children: "A carregar..."
    });
    if (!userProfile?.isAdmin()) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$444b3ab0cb9aec40), {
        to: "/",
        replace: true
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "container mx-auto px-4 py-8",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "bg-white shadow rounded-lg p-6",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                    className: "text-2xl font-bold mb-1 text-gray-800",
                    children: "Gest\xe3o do Site P\xfablico"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "text-gray-500 text-sm mb-6",
                    children: "Configure envios, m\xe9todos de pagamento, locais de recolha, a visibilidade do cat\xe1logo p\xfablico e as subscri\xe7\xf5es de newsletter."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "mb-6 max-w-xs",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9e71da29c945043$export$2e2bcd8739ae039), {
                        tenants: tenants,
                        value: selectedTenant,
                        onChange: selectTenant
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e5o5x))), {
                    sx: {
                        borderBottom: 1,
                        borderColor: "divider",
                        mb: 3
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($dKcJh))), {
                        value: activeTab,
                        onChange: (_e, v)=>setActiveTab(v),
                        "aria-label": "public-site-tabs",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($90blG))), {
                                label: "Envios",
                                id: "tab-shipping",
                                "aria-controls": "panel-shipping"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($90blG))), {
                                label: "Pagamentos",
                                id: "tab-payments",
                                "aria-controls": "panel-payments"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($90blG))), {
                                label: "Entrega",
                                id: "tab-delivery",
                                "aria-controls": "panel-delivery"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($90blG))), {
                                label: "Cat\xe1logo",
                                id: "tab-catalog",
                                "aria-controls": "panel-catalog"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($90blG))), {
                                label: "Newsletter",
                                id: "tab-newsletter",
                                "aria-controls": "panel-newsletter"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    role: "tabpanel",
                    id: "panel-shipping",
                    "aria-labelledby": "tab-shipping",
                    hidden: activeTab !== 0,
                    children: activeTab === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b2e01565dad3fb01$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fec7736d870f8edb$export$2e2bcd8739ae039), {}, selectedTenant)
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    role: "tabpanel",
                    id: "panel-payments",
                    "aria-labelledby": "tab-payments",
                    hidden: activeTab !== 1,
                    children: activeTab === 1 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b2e01565dad3fb01$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8d2199f43a373341$export$2e2bcd8739ae039), {}, selectedTenant)
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    role: "tabpanel",
                    id: "panel-delivery",
                    "aria-labelledby": "tab-delivery",
                    hidden: activeTab !== 2,
                    children: activeTab === 2 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b2e01565dad3fb01$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $747266722164c268$export$2e2bcd8739ae039), {}, selectedTenant)
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    role: "tabpanel",
                    id: "panel-catalog",
                    "aria-labelledby": "tab-catalog",
                    hidden: activeTab !== 3,
                    children: activeTab === 3 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b2e01565dad3fb01$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5e5a5e916a4baa23$export$2e2bcd8739ae039), {}, selectedTenant)
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    role: "tabpanel",
                    id: "panel-newsletter",
                    "aria-labelledby": "tab-newsletter",
                    hidden: activeTab !== 4,
                    children: activeTab === 4 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b2e01565dad3fb01$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $011adbed29b33da8$export$2e2bcd8739ae039), {}, selectedTenant)
                    })
                })
            ]
        })
    });
};
var $15141d21a167b494$export$2e2bcd8739ae039 = $15141d21a167b494$var$PublicSiteManagementPage;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");








var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $0f45c1e8ae52ad76$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2",
            key: "975kel"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "7",
            r: "4",
            key: "17ys0d"
        }
    ]
];
const $0f45c1e8ae52ad76$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("user", $0f45c1e8ae52ad76$export$3efd853dbb351e94);


const $6a35de6f2206db83$var$STATUS_LABELS = {
    DRAFT: "Rascunho",
    ACTIVE: "Ativa",
    ARCHIVED: "Arquivada"
};
const $6a35de6f2206db83$var$STATUS_COLORS = {
    DRAFT: "bg-gray-100 text-gray-700",
    ACTIVE: "bg-green-100 text-green-800",
    ARCHIVED: "bg-gray-200 text-gray-700"
};
const $6a35de6f2206db83$var$ListCampaignItems = ({ data: data, filter: filter, onFilterChange: onFilterChange, searchTerm: searchTerm, onSearchChange: onSearchChange, canEdit: canEdit })=>{
    const navigate = (0, $585f8bce88e531c1$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "p-4 border-b border-gray-100 flex flex-col sm:flex-row gap-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "relative flex-1",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ad14973a512851d$export$2e2bcd8739ae039), {
                                className: "absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                type: "text",
                                value: searchTerm,
                                onChange: (e)=>onSearchChange(e.target.value),
                                placeholder: "Pesquisar campanhas...",
                                "aria-label": "Pesquisar campanhas",
                                className: "w-full pl-9 pr-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex gap-2",
                        role: "group",
                        "aria-label": "Filtrar por estado",
                        children: [
                            "all",
                            "ACTIVE",
                            "DRAFT",
                            "ARCHIVED"
                        ].map((s)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>onFilterChange(s),
                                "aria-pressed": filter === s,
                                className: `px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${filter === s ? "bg-blue-600 text-white" : "bg-gray-100 text-gray-600 hover:bg-gray-200"}`,
                                children: s === "all" ? "Todas" : $6a35de6f2206db83$var$STATUS_LABELS[s] || s
                            }, s))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "divide-y divide-gray-100",
                children: data.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "p-12 text-center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $437c67a40c1b8279$export$2e2bcd8739ae039), {
                            className: "w-12 h-12 mx-auto mb-3 text-gray-300"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "text-gray-500 font-medium",
                            children: "Nenhuma campanha encontrada."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "text-gray-400 text-sm mt-1",
                            children: searchTerm ? "Tenta ajustar a pesquisa ou os filtros." : "Cria uma nova campanha para come\xe7ar."
                        })
                    ]
                }) : data.map((campaign)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "p-4 flex items-center gap-4 hover:bg-gray-50 transition-colors",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex-1 min-w-0",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center gap-2 mb-1",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "text-sm font-semibold text-gray-900 truncate",
                                                children: campaign.name
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: `px-2 py-0.5 rounded text-xs font-medium shrink-0 ${$6a35de6f2206db83$var$STATUS_COLORS[campaign.status] || "bg-gray-100 text-gray-600"}`,
                                                children: $6a35de6f2206db83$var$STATUS_LABELS[campaign.status] || campaign.status
                                            }),
                                            campaign.is_currently_active && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium bg-green-50 text-green-700 shrink-0",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f36710bd138be5d0$export$2e2bcd8739ae039), {
                                                        className: "w-3 h-3"
                                                    }),
                                                    "Em vigor"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center gap-3 text-xs text-gray-500",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "flex items-center gap-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30050f52d874b8f2$export$2e2bcd8739ae039), {
                                                        className: "w-3 h-3"
                                                    }),
                                                    new Date(campaign.starts_at).toLocaleDateString("pt-PT"),
                                                    " \u2014 ",
                                                    new Date(campaign.ends_at).toLocaleDateString("pt-PT")
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                children: [
                                                    campaign.items.length,
                                                    " ",
                                                    campaign.items.length === 1 ? "composto" : "compostos"
                                                ]
                                            }),
                                            campaign.is_global ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "flex items-center gap-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9b51f4920eac1ba0$export$2e2bcd8739ae039), {
                                                        className: "w-3 h-3"
                                                    }),
                                                    "Global"
                                                ]
                                            }) : campaign.reseller_erp_ref && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "flex items-center gap-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0f45c1e8ae52ad76$export$2e2bcd8739ae039), {
                                                        className: "w-3 h-3"
                                                    }),
                                                    campaign.reseller_erp_ref
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center gap-1 shrink-0",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: ()=>navigate(`/campaigns/${campaign.id}`),
                                        className: "min-h-11 min-w-11 inline-flex items-center justify-center text-gray-500 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors",
                                        "aria-label": `Ver campanha ${campaign.name}`,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039), {
                                            className: "w-4 h-4"
                                        })
                                    }),
                                    canEdit && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: ()=>navigate(`/campaigns/${campaign.id}?edit=true`),
                                        className: "min-h-11 min-w-11 inline-flex items-center justify-center text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors",
                                        "aria-label": `Editar campanha ${campaign.name}`,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6c2a827dd5c2d433$export$2e2bcd8739ae039), {
                                            className: "w-4 h-4"
                                        })
                                    })
                                ]
                            })
                        ]
                    }, campaign.id))
            })
        ]
    });
};
var $6a35de6f2206db83$export$2e2bcd8739ae039 = $6a35de6f2206db83$var$ListCampaignItems;


const $308104e624282612$var$CampaignsListPage = ()=>{
    const navigate = (0, $585f8bce88e531c1$export$9770f232ac06a008)();
    const { profile: profile } = (0, $b622ef53e38024e7$export$1d39dc5b47e56ff0)();
    const { setLoading: setLoading, setError: setError, setSuccess: setSuccess } = (0, $a55f2a94cd420149$export$c50e37a2f0a2b064)();
    const [campaigns, setCampaigns] = (0, $acw62.useState)([]);
    const [profileData, setProfileData] = (0, $acw62.useState)(null);
    const [filter, setFilter] = (0, $acw62.useState)("all");
    const [searchTerm, setSearchTerm] = (0, $acw62.useState)("");
    const loadProfile = async ()=>{
        try {
            const p = await profile();
            setProfileData(p);
        } catch  {
            console.warn("Failed to load profile");
        }
    };
    const loadCampaigns = async ()=>{
        setLoading({
            message: "A carregar campanhas..."
        });
        try {
            const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).CAMPAIGNS);
            setCampaigns(response.data);
        } catch (err) {
            setError(err.response?.data?.message || "Erro ao carregar campanhas");
        } finally{
            setLoading(null);
        }
    };
    (0, $acw62.useEffect)(()=>{
        loadProfile();
        loadCampaigns();
    }, []);
    const canCreate = !!(profileData?.isAdmin() || profileData?.isMainAccount());
    const canEdit = !!(profileData?.isAdmin() || profileData?.isMainAccount());
    const filteredCampaigns = campaigns.filter((c)=>filter === "all" || c.status === filter).filter((c)=>!searchTerm || c.name.toLowerCase().includes(searchTerm.toLowerCase())).sort((a, b)=>new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "container mx-auto p-6 max-w-7xl",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex flex-col gap-6",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex flex-col md:flex-row justify-between items-start md:items-center gap-4",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex items-center gap-3",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7b97e024910b40ff$export$2e2bcd8739ae039), {
                                    className: "w-7 h-7 text-blue-500"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                            className: "text-3xl font-bold text-gray-900 tracking-tight",
                                            children: "Campanhas Promocionais"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "text-gray-500 mt-1",
                                            children: canCreate ? "Cria e gere campanhas promocionais para os teus clientes." : "Visualiza as campanhas promocionais dispon\xedveis."
                                        })
                                    ]
                                })
                            ]
                        }),
                        canCreate && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).button, {
                            whileHover: {
                                scale: 1.02
                            },
                            whileTap: {
                                scale: 0.98
                            },
                            onClick: ()=>navigate("/campaigns/new"),
                            className: "bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center gap-2 shrink-0",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                    className: "w-4 h-4"
                                }),
                                "Nova Campanha"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "overflow-auto",
                    children: campaigns.length === 0 && !searchTerm && filter === "all" ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "bg-white rounded-xl shadow-sm border border-gray-200 p-12 text-center",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7b97e024910b40ff$export$2e2bcd8739ae039), {
                                className: "w-16 h-16 mx-auto mb-4 text-gray-200"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "text-lg font-medium text-gray-500",
                                children: "Nenhuma campanha encontrada."
                            }),
                            canCreate && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).button, {
                                whileHover: {
                                    scale: 1.02
                                },
                                whileTap: {
                                    scale: 0.98
                                },
                                onClick: ()=>navigate("/campaigns/new"),
                                className: "mt-4 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 inline-flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                        className: "w-4 h-4"
                                    }),
                                    "Criar primeira campanha"
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).div, {
                        initial: {
                            opacity: 0,
                            y: 8
                        },
                        animate: {
                            opacity: 1,
                            y: 0
                        },
                        transition: {
                            duration: 0.2
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6a35de6f2206db83$export$2e2bcd8739ae039), {
                            data: filteredCampaigns,
                            filter: filter,
                            onFilterChange: setFilter,
                            searchTerm: searchTerm,
                            onSearchChange: setSearchTerm,
                            canEdit: canEdit
                        })
                    })
                })
            ]
        })
    });
};
var $308104e624282612$export$2e2bcd8739ae039 = $308104e624282612$var$CampaignsListPage;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $7b20c5205e441d74$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m12 19-7-7 7-7",
            key: "1l729n"
        }
    ],
    [
        "path",
        {
            d: "M19 12H5",
            key: "x3x0zl"
        }
    ]
];
const $7b20c5205e441d74$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("arrow-left", $7b20c5205e441d74$export$3efd853dbb351e94);




var $acw62 = parcelRequire("acw62");


"use client";
/**
 * A hook that returns `true` if we should be using reduced motion based on the current device's Reduced Motion setting.
 *
 * This can be used to implement changes to your UI based on Reduced Motion. For instance, replacing motion-sickness inducing
 * `x`/`y` animations with `opacity`, disabling the autoplay of background videos, or turning off parallax motion.
 *
 * It will actively respond to changes and re-render your components with the latest setting.
 *
 * ```jsx
 * export function Sidebar({ isOpen }) {
 *   const shouldReduceMotion = useReducedMotion()
 *   const closedX = shouldReduceMotion ? 0 : "-100%"
 *
 *   return (
 *     <motion.div animate={{
 *       opacity: isOpen ? 1 : 0,
 *       x: isOpen ? 0 : closedX
 *     }} />
 *   )
 * }
 * ```
 *
 * @return boolean
 *
 * @public
 */ function $0ba870ee19d9ff90$export$6a42007cf1e7b6f8() {
    /**
     * Lazy initialisation of prefersReducedMotion
     */ !(0, $5d1c3a7750a03ec7$export$6476d16e2fd2d0db).current && (0, $402b11b96c54cb2c$export$ca9f41fb23dded3d)();
    const [shouldReduceMotion] = (0, $acw62.useState)((0, $5d1c3a7750a03ec7$export$ff7706047246b98b).current);
    (0, $6e5dff638919bf7c$export$5b28268982f175ba)(shouldReduceMotion !== true, "You have Reduced Motion enabled on your device. Animations may not appear as expected.", "reduced-motion-disabled");
    /**
     * TODO See if people miss automatically updating shouldReduceMotion setting
     */ return shouldReduceMotion;
}







var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c9921f4f81a419f0$export$3efd853dbb351e94 = [
    [
        "polyline",
        {
            points: "22 7 13.5 15.5 8.5 10.5 2 17",
            key: "126l90"
        }
    ],
    [
        "polyline",
        {
            points: "16 7 22 7 22 13",
            key: "kwv8wd"
        }
    ]
];
const $c9921f4f81a419f0$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("trending-up", $c9921f4f81a419f0$export$3efd853dbb351e94);



function $41a75e95e3d8f2fb$var$MarginCard({ label: label, before: before, beforePct: beforePct, after: after, afterPct: afterPct }) {
    if (before == null) return null;
    const hasImpact = after != null && afterPct != null && (after !== before || afterPct !== beforePct);
    const current = after ?? before;
    const currentPct = afterPct ?? beforePct;
    const tone = (0, $a47955a5527e9f71$export$777dd92714dee955)(currentPct);
    const Icon = tone === "neg" ? (0, $00824d397ec63c04$export$2e2bcd8739ae039) : (0, $c9921f4f81a419f0$export$2e2bcd8739ae039);
    const deltaValue = hasImpact ? current - before : null;
    const deltaPct = hasImpact && beforePct != null ? currentPct - beforePct : null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("article", {
        className: `rounded-lg border p-3 ${(0, $a47955a5527e9f71$export$a1ef82c6c242ab71)[tone]}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "text-xs font-medium uppercase tracking-wide text-gray-600",
                children: label
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                className: "mt-1 text-lg font-semibold tabular-nums",
                children: [
                    hasImpact && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "mr-2 text-sm font-normal text-gray-500 line-through tabular-nums",
                        children: (0, $a47955a5527e9f71$export$e18dec77288a7f6d).format(before)
                    }),
                    (0, $a47955a5527e9f71$export$e18dec77288a7f6d).format(current)
                ]
            }),
            currentPct != null && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                className: "text-sm font-medium tabular-nums",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {
                        className: "mr-1 inline h-3.5 w-3.5",
                        "aria-hidden": "true"
                    }),
                    (0, $a47955a5527e9f71$export$702237c54c4bae27).format(currentPct),
                    deltaValue != null && deltaPct != null && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "ml-2 text-xs font-normal",
                        children: [
                            "\u0394 ",
                            deltaValue > 0 ? "+" : "",
                            (0, $a47955a5527e9f71$export$e18dec77288a7f6d).format(deltaValue),
                            " \xb7 ",
                            deltaPct > 0 ? "+" : "",
                            (0, $a47955a5527e9f71$export$702237c54c4bae27).format(deltaPct)
                        ]
                    })
                ]
            })
        ]
    });
}
const $41a75e95e3d8f2fb$var$CampaignItemErpPanel = ({ item: item, isAdmin: isAdmin, showErpComparison: showErpComparison = true })=>{
    const c = item.compound;
    const rows = [
        {
            label: "Custo",
            configured: c?.base_cost_price,
            erp: c?.erp_base_cost_price,
            field: "cost",
            adminOnly: true
        },
        {
            label: "Pre\xe7o Reseller",
            configured: c?.base_retail_price,
            erp: c?.erp_base_retail_price,
            field: "base_retail_price",
            adminOnly: false
        },
        {
            label: "PVP s/IVA",
            configured: c?.price_pvp_without_vat,
            erp: c?.erp_price_pvp_without_vat,
            field: "pvp_without_vat",
            adminOnly: false
        },
        {
            label: "PVP c/IVA",
            configured: c?.price_pvp_with_vat,
            erp: c?.erp_price_pvp_with_vat,
            field: "pvp_with_vat",
            adminOnly: false
        }
    ].filter((r)=>!r.adminOnly || isAdmin);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `grid grid-cols-1 gap-4 ${showErpComparison ? "lg:grid-cols-[minmax(0,2fr)_minmax(0,3fr)]" : ""}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid-cols-[repeat(auto-fit,minmax(11rem,1fr))] gap-3",
                children: [
                    isAdmin && /*#__PURE__*/ (0, $ayMG0.jsx)($41a75e95e3d8f2fb$var$MarginCard, {
                        label: "Margem Niposom",
                        before: c?.niposom_margin_value,
                        beforePct: c?.niposom_margin_pct,
                        after: c?.niposom_promo_margin_value,
                        afterPct: c?.niposom_promo_margin_pct
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($41a75e95e3d8f2fb$var$MarginCard, {
                        label: "Margem Reseller",
                        before: c?.reseller_margin_value,
                        beforePct: c?.reseller_margin_pct,
                        after: c?.reseller_promo_margin_value,
                        afterPct: c?.reseller_promo_margin_pct
                    })
                ]
            }),
            showErpComparison && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center justify-between mb-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "text-xs font-medium uppercase tracking-wide text-gray-500",
                                children: "Configured vs ERP"
                            }),
                            c?.erp_synced_at && /*#__PURE__*/ (0, $ayMG0.jsxs)("time", {
                                className: "text-xs text-gray-500",
                                dateTime: c.erp_synced_at,
                                children: [
                                    "ERP sync: ",
                                    new Date(c.erp_synced_at).toLocaleString("pt-PT")
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "overflow-x-auto -mx-4 px-4",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                            className: "w-full text-sm",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                        className: "border-b text-left",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                scope: "col",
                                                className: "pb-1 pr-2 font-medium",
                                                children: "Campo"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                scope: "col",
                                                className: "pb-1 pr-2 font-medium text-right",
                                                children: "Configured"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                scope: "col",
                                                className: "pb-1 pr-2 font-medium text-right",
                                                children: "ERP"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                scope: "col",
                                                className: "pb-1 pr-2 font-medium text-right",
                                                children: "\u0394"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                scope: "col",
                                                className: "pb-1 font-medium",
                                                children: "Estado"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                    children: rows.map((r)=>{
                                        const hasBoth = r.configured != null && r.erp != null;
                                        const delta = hasBoth ? r.configured - r.erp : null;
                                        const mismatched = c?.mismatch_fields?.includes(r.field);
                                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                            className: "border-b",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                    scope: "row",
                                                    className: "py-1 pr-2 font-medium text-left",
                                                    children: r.label
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "py-1 pr-2 text-right tabular-nums",
                                                    children: r.configured != null ? (0, $a47955a5527e9f71$export$e18dec77288a7f6d).format(r.configured) : "\u2014"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "py-1 pr-2 text-right tabular-nums",
                                                    children: r.erp != null ? (0, $a47955a5527e9f71$export$e18dec77288a7f6d).format(r.erp) : "\u2014"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "py-1 pr-2 text-right tabular-nums",
                                                    children: delta != null ? (0, $a47955a5527e9f71$export$e18dec77288a7f6d).format(delta) : "\u2014"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "py-1",
                                                    children: mismatched ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "inline-flex items-center gap-1 rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-800 ring-1 ring-inset ring-amber-300",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                                                                className: "h-3.5 w-3.5",
                                                                "aria-hidden": "true"
                                                            }),
                                                            "desalinhado"
                                                        ]
                                                    }) : r.erp == null ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "inline-flex items-center gap-1 rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-600",
                                                        children: "sem dados"
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "inline-flex items-center gap-1 rounded-full bg-green-100 px-2 py-0.5 text-xs font-medium text-green-800",
                                                        children: "ok"
                                                    })
                                                })
                                            ]
                                        }, r.field);
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "mt-2 flex items-start gap-1 text-xs text-gray-500",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e52b122f04c04d7d$export$2e2bcd8739ae039), {
                                className: "mt-0.5 h-3.5 w-3.5 shrink-0",
                                "aria-hidden": "true"
                            }),
                            "Um desconto na margem Niposom reduz o pre\xe7o de compra do reseller, n\xe3o apenas o PVP de exibi\xe7\xe3o."
                        ]
                    })
                ]
            })
        ]
    });
};
var $41a75e95e3d8f2fb$export$2e2bcd8739ae039 = $41a75e95e3d8f2fb$var$CampaignItemErpPanel;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



async function $1ca25f6a76b6e4c2$export$11e33c1c244ba17f(campaignId) {
    const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).CAMPAIGNS}/${campaignId}/history`);
    return response.data;
}



const $012941f735240ef4$var$TARGET_LABELS = {
    NIPOSOM_MARGIN: "Niposom",
    RESELLER_MARGIN: "Reseller",
    BOTH: "Ambas"
};
function $012941f735240ef4$var$discountLabel(s) {
    if (s.promo_type === "DISCOUNT_PERCENTAGE" && s.discount_percentage != null) return `${s.discount_percentage}%`;
    if (s.promo_type === "DISCOUNT_VALUE" && s.discount_value != null) return (0, $a47955a5527e9f71$export$e18dec77288a7f6d).format(s.discount_value);
    if (s.promo_type === "FIXED_PVP" && s.fixed_pvp != null) return `PVP fixo: ${(0, $a47955a5527e9f71$export$e18dec77288a7f6d).format(s.fixed_pvp)}`;
    return "\u2014";
}
function $012941f735240ef4$var$Money({ value: value }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: value != null ? (0, $a47955a5527e9f71$export$e18dec77288a7f6d).format(value) : "\u2014"
    });
}
function $012941f735240ef4$var$MarginCell({ value: value, pctValue: pctValue }) {
    if (value == null) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: "\u2014"
    });
    const tone = (0, $a47955a5527e9f71$export$777dd92714dee955)(pctValue);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
        className: `inline-flex items-center gap-1 rounded px-1.5 py-0.5 ${(0, $a47955a5527e9f71$export$a1ef82c6c242ab71)[tone]}`,
        children: [
            (0, $a47955a5527e9f71$export$e18dec77288a7f6d).format(value),
            pctValue != null && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                children: [
                    "\xb7 ",
                    (0, $a47955a5527e9f71$export$702237c54c4bae27).format(pctValue)
                ]
            })
        ]
    });
}
function $012941f735240ef4$var$ActivationSection({ activation: activation }) {
    const windowLabel = `${new Date(activation.starts_at).toLocaleDateString("pt-PT")} \u{2192} ${new Date(activation.ends_at).toLocaleDateString("pt-PT")}`;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "bg-white rounded-lg shadow p-4",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("header", {
                className: "flex flex-wrap items-center gap-x-3 gap-y-1 mb-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                        className: "font-semibold",
                        children: [
                            "Ativada em ",
                            new Date(activation.activated_at).toLocaleString("pt-PT")
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "text-xs text-gray-500",
                        children: [
                            "por ",
                            activation.activated_by
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "text-xs text-gray-500",
                        children: [
                            "Janela: ",
                            windowLabel
                        ]
                    }),
                    activation.deactivated_at && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-700",
                        children: [
                            "Encerrada em",
                            " ",
                            new Date(activation.deactivated_at).toLocaleDateString("pt-PT")
                        ]
                    }),
                    activation.is_global ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "rounded-full bg-blue-100 px-2 py-0.5 text-xs font-medium text-blue-800",
                        children: "Global"
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-700",
                        children: activation.reseller_erp_ref ?? "\u2014"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "text-xs text-gray-500",
                        children: [
                            activation.items.length,
                            " ",
                            activation.items.length === 1 ? "composto" : "compostos"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "overflow-x-auto -mx-4 px-4",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                    className: "w-full min-w-[64rem] text-sm",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                className: "border-b text-left",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        scope: "col",
                                        className: "pb-2 font-medium",
                                        children: "Composto"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        scope: "col",
                                        className: "pb-2 font-medium text-right",
                                        children: "PVP config."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        scope: "col",
                                        className: "pb-2 font-medium text-right",
                                        children: "PVP promo"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        scope: "col",
                                        className: "pb-2 font-medium",
                                        children: "Desconto / PVP"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        scope: "col",
                                        className: "pb-2 font-medium",
                                        children: "Alvo"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        scope: "col",
                                        className: "pb-2 font-medium text-right",
                                        children: "Pre\xe7o reseller"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        scope: "col",
                                        className: "pb-2 font-medium text-right",
                                        children: "Margem Niposom"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        scope: "col",
                                        className: "pb-2 font-medium text-right",
                                        children: "Margem Reseller"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        scope: "col",
                                        className: "pb-2 font-medium",
                                        children: "ERP"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                            children: activation.items.map((s)=>{
                                const target = s.discount_target ? $012941f735240ef4$var$TARGET_LABELS[s.discount_target] || s.discount_target : "\u2014";
                                const resellerPrice = s.promotional_reseller_price ?? s.configured_base_retail_price;
                                const drifted = (s.mismatch_fields?.length ?? 0) > 0;
                                // A null field is never compared, so "no mismatch" must not be read
                                // as "verified": both the configured base AND the ERP reference must
                                // be present before an `ok` verdict is shown.
                                const comparable = s.configured_pvp_with_vat != null && s.configured_pvp_without_vat != null && s.configured_base_retail_price != null && s.configured_base_cost_price != null;
                                const erpComparable = s.erp_price_pvp_with_vat != null && s.erp_price_pvp_without_vat != null && s.erp_base_retail_price != null && s.erp_base_cost_price != null;
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                    className: "border-b",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("th", {
                                            scope: "row",
                                            className: "py-2 font-normal text-left",
                                            children: [
                                                s.compound_name || s.compound_id,
                                                !s.base_captured && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "ml-1 rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-600",
                                                    title: "Base lida do composto no momento da ativa\xe7\xe3o (item anterior a esta vers\xe3o)",
                                                    children: "base n\xe3o capturada"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "py-2 text-right tabular-nums",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($012941f735240ef4$var$Money, {
                                                value: s.configured_pvp_with_vat
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "py-2 text-right tabular-nums font-semibold text-green-700",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($012941f735240ef4$var$Money, {
                                                value: s.promotional_pvp_with_vat
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "py-2",
                                            children: $012941f735240ef4$var$discountLabel(s)
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                            className: "py-2",
                                            children: [
                                                target,
                                                s.discount_target === "BOTH" && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "ml-1 text-xs text-gray-500",
                                                    children: "(financiado pela Niposom)"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "py-2 text-right tabular-nums",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($012941f735240ef4$var$Money, {
                                                value: resellerPrice
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "py-2 text-right tabular-nums",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($012941f735240ef4$var$MarginCell, {
                                                value: s.niposom_promo_margin_value ?? s.niposom_margin_value,
                                                pctValue: s.niposom_promo_margin_pct ?? s.niposom_margin_pct
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "py-2 text-right tabular-nums",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($012941f735240ef4$var$MarginCell, {
                                                value: s.reseller_promo_margin_value ?? s.reseller_margin_value,
                                                pctValue: s.reseller_promo_margin_pct ?? s.reseller_margin_pct
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "py-2",
                                            children: !s.base_captured || !comparable || !erpComparable ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "inline-flex items-center gap-1 rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-600",
                                                title: "Base incompleta no momento do item; o alinhamento com o ERP n\xe3o \xe9 verific\xe1vel",
                                                children: "n\xe3o verific\xe1vel"
                                            }) : drifted ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "inline-flex items-center gap-1 rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-800 ring-1 ring-inset ring-amber-300",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                                                        className: "h-3.5 w-3.5",
                                                        "aria-hidden": "true"
                                                    }),
                                                    "desalinhado"
                                                ]
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "inline-flex items-center gap-1 rounded-full bg-green-100 px-2 py-0.5 text-xs font-medium text-green-800",
                                                children: "ok"
                                            })
                                        })
                                    ]
                                }, s.compound_id);
                            })
                        })
                    ]
                })
            })
        ]
    });
}
const $012941f735240ef4$var$CampaignHistoryTab = ({ campaignId: campaignId, active: active = true })=>{
    const [history, setHistory] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    const [itemFilter, setItemFilter] = (0, $acw62.useState)("");
    (0, $acw62.useEffect)(()=>{
        setItemFilter("");
    }, [
        campaignId
    ]);
    (0, $acw62.useEffect)(()=>{
        // Skip while the tab is hidden; refetch each time it becomes active so an
        // activation done on another tab is reflected here.
        if (!active) return;
        let cancelled = false;
        setLoading(true);
        setError(null);
        (0, $1ca25f6a76b6e4c2$export$11e33c1c244ba17f)(campaignId).then((data)=>{
            if (!cancelled) setHistory(data);
        }).catch((err)=>{
            if (!cancelled) setError(err.response?.data?.message || "Erro ao carregar hist\xf3rico");
        }).finally(()=>{
            if (!cancelled) setLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        campaignId,
        active
    ]);
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
        role: "status",
        className: "text-gray-500 py-8 text-center",
        children: "A carregar hist\xf3rico\u2026"
    });
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
        role: "alert",
        className: "text-red-700 py-4",
        children: error
    });
    const activations = history?.activations ?? [];
    if (activations.length === 0) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "bg-white rounded-lg shadow p-6 text-center text-gray-500",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e17c725e7c863883$export$2e2bcd8739ae039), {
                className: "w-6 h-6 mx-auto mb-2 text-gray-400",
                "aria-hidden": "true"
            }),
            "Sem hist\xf3rico de ativa\xe7\xe3o. Os registos come\xe7am a partir da primeira ativa\xe7\xe3o ap\xf3s esta vers\xe3o."
        ]
    });
    const compounds = Array.from(new Map(activations.flatMap((a)=>a.items.map((i)=>[
                i.compound_id,
                i.compound_name || i.compound_id
            ]))).entries()).sort((x, y)=>x[1].localeCompare(y[1], "pt-PT"));
    const filtered = itemFilter ? activations.map((a)=>({
            ...a,
            items: a.items.filter((i)=>i.compound_id === itemFilter)
        })).filter((a)=>a.items.length > 0) : activations;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "space-y-4",
        children: [
            compounds.length > 1 && /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                className: "flex items-center gap-2 text-sm",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "font-medium text-gray-700",
                        children: "Composto"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                        value: itemFilter,
                        onChange: (e)=>setItemFilter(e.target.value),
                        className: "border rounded-lg px-3 py-1.5",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                value: "",
                                children: "Todos"
                            }),
                            compounds.map(([id, name])=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                    value: id,
                                    children: name
                                }, id))
                        ]
                    })
                ]
            }),
            filtered.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "text-gray-500 text-sm",
                children: "Nenhum item corresponde ao filtro selecionado."
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "space-y-6",
                children: filtered.map((activation)=>/*#__PURE__*/ (0, $ayMG0.jsx)($012941f735240ef4$var$ActivationSection, {
                        activation: activation
                    }, activation.id))
            })
        ]
    });
};
var $012941f735240ef4$export$2e2bcd8739ae039 = $012941f735240ef4$var$CampaignHistoryTab;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $e8ef03ed3ad64dec$var$labelOf = (r)=>r.name ? `${r.name} (${r.erp_ref})` : r.erp_ref;
const $e8ef03ed3ad64dec$var$MAX_RESULTS = 50;
function $e8ef03ed3ad64dec$export$2e2bcd8739ae039({ id: id, value: value, onChange: onChange, options: options, disabled: disabled, placeholder: placeholder }) {
    const selected = options.find((o)=>o.erp_ref === value) ?? null;
    const [query, setQuery] = (0, $acw62.useState)(selected ? $e8ef03ed3ad64dec$var$labelOf(selected) : "");
    const [open, setOpen] = (0, $acw62.useState)(false);
    const [highlight, setHighlight] = (0, $acw62.useState)(0);
    const rootRef = (0, $acw62.useRef)(null);
    // Reflect an externally-set value (e.g. reset).
    (0, $acw62.useEffect)(()=>{
        const current = options.find((o)=>o.erp_ref === value);
        setQuery(current ? $e8ef03ed3ad64dec$var$labelOf(current) : "");
    }, [
        value,
        options
    ]);
    const filtered = (0, $acw62.useMemo)(()=>{
        const q = query.trim().toLowerCase();
        const pool = q ? options.filter((o)=>`${o.erp_ref} ${o.name ?? ""}`.toLowerCase().includes(q)) : options;
        return pool.slice(0, $e8ef03ed3ad64dec$var$MAX_RESULTS);
    }, [
        query,
        options
    ]);
    (0, $acw62.useEffect)(()=>{
        const onDocMouseDown = (e)=>{
            if (rootRef.current && !rootRef.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener("mousedown", onDocMouseDown);
        return ()=>document.removeEventListener("mousedown", onDocMouseDown);
    }, []);
    const select = (r)=>{
        onChange(r.erp_ref);
        setQuery($e8ef03ed3ad64dec$var$labelOf(r));
        setOpen(false);
    };
    const handleBlur = ()=>{
        // No free text: revert to the selected label, or clear if emptied.
        if (query.trim() === "") onChange("");
        else if (selected) setQuery($e8ef03ed3ad64dec$var$labelOf(selected));
    };
    const onKeyDown = (e)=>{
        if (e.key === "ArrowDown") {
            e.preventDefault();
            if (!open) {
                setOpen(true);
                setHighlight(0);
            } else setHighlight((h)=>Math.min(h + 1, filtered.length - 1));
        } else if (e.key === "ArrowUp") {
            e.preventDefault();
            setHighlight((h)=>Math.max(h - 1, 0));
        } else if (e.key === "Enter") {
            if (open && filtered[highlight]) {
                e.preventDefault();
                select(filtered[highlight]);
            }
        } else if (e.key === "Escape") setOpen(false);
    };
    const activeOption = open ? filtered[highlight] : undefined;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        ref: rootRef,
        className: "relative",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                id: id,
                type: "text",
                role: "combobox",
                "aria-expanded": open,
                "aria-controls": `${id}-listbox`,
                "aria-autocomplete": "list",
                "aria-activedescendant": activeOption ? `${id}-opt-${activeOption.erp_ref}` : undefined,
                autoComplete: "off",
                disabled: disabled,
                value: query,
                placeholder: placeholder ?? "Procurar reseller\u2026",
                onChange: (e)=>{
                    setQuery(e.target.value);
                    setOpen(true);
                    setHighlight(0);
                },
                onFocus: ()=>setOpen(true),
                onKeyDown: onKeyDown,
                onBlur: handleBlur,
                className: "w-full border rounded-lg px-3 py-2 disabled:bg-gray-100"
            }),
            open && !disabled && /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                id: `${id}-listbox`,
                role: "listbox",
                "aria-label": "Resellers",
                className: "absolute z-50 mt-1 max-h-64 w-full overflow-auto rounded-lg border border-gray-200 bg-white shadow-lg",
                children: filtered.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                    className: "px-3 py-2 text-sm text-gray-500",
                    children: "Sem resultados."
                }) : filtered.map((r, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                        id: `${id}-opt-${r.erp_ref}`,
                        role: "option",
                        "aria-selected": r.erp_ref === value,
                        onMouseEnter: ()=>setHighlight(i),
                        onMouseDown: (e)=>{
                            // Keep focus on the input so blur-revert doesn't fire first.
                            e.preventDefault();
                            select(r);
                        },
                        className: `cursor-pointer px-3 py-2 text-sm ${i === highlight ? "bg-blue-50" : ""} ${r.erp_ref === value ? "font-medium text-blue-700" : "text-gray-800"}`,
                        children: $e8ef03ed3ad64dec$var$labelOf(r)
                    }, r.erp_ref))
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


function $18680f5e3e58b787$export$f531b7b059c85d29({ item: item }) {
    if (!item.invalidated) return null;
    const reason = item.invalidated_reason || "pre\xe7o base alterado";
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
        "aria-label": `Bloqueado: ${reason}`,
        title: reason,
        "data-testid": "campaign-item-invalidated",
        className: "inline-flex items-center gap-1 rounded-full bg-red-100 px-2 py-0.5 text-xs font-medium text-red-800 ring-1 ring-inset ring-red-300",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                className: "h-3.5 w-3.5",
                "aria-hidden": "true"
            }),
            "Bloqueado \u2014 base alterada",
            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                className: "sr-only",
                children: [
                    "Motivo: ",
                    reason
                ]
            })
        ]
    });
}
function $18680f5e3e58b787$export$d25e68d304caf12({ item: item }) {
    const others = item.other_campaigns ?? [];
    if (others.length === 0) return null;
    const winner = others.find((c)=>c.is_effective);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mt-3 text-xs text-gray-600",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "font-medium text-gray-700",
                children: [
                    "Tamb\xe9m em ",
                    others.length,
                    " ",
                    others.length === 1 ? "campanha" : "campanhas",
                    " (mesmo composto):"
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                className: "mt-1 space-y-0.5",
                children: others.map((c)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                        className: "flex items-center gap-1",
                        children: [
                            c.is_global ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9b51f4920eac1ba0$export$2e2bcd8739ae039), {
                                className: "h-3 w-3",
                                "aria-hidden": "true"
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "text-gray-400",
                                children: "\u2022"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: c.name
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "text-gray-400",
                                children: c.is_global ? "global" : `reseller ${c.reseller_erp_ref ?? "\u2014"}`
                            }),
                            c.promotional_pvp_with_vat != null && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "tabular-nums",
                                children: (0, $a47955a5527e9f71$export$e18dec77288a7f6d).format(c.promotional_pvp_with_vat)
                            }),
                            c.is_effective && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "rounded bg-green-50 px-1.5 py-0.5 font-medium text-green-700",
                                children: "efetiva"
                            }),
                            c.invalidated && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "rounded bg-red-50 px-1.5 py-0.5 font-medium text-red-700",
                                children: "bloqueada"
                            })
                        ]
                    }, c.campaign_id))
            }),
            winner && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                className: "mt-1 text-amber-700",
                children: [
                    "Esta campanha \xe9 sobreposta por \u201C",
                    winner.name,
                    "\u201D (",
                    winner.promotional_pvp_with_vat != null ? (0, $a47955a5527e9f71$export$e18dec77288a7f6d).format(winner.promotional_pvp_with_vat) : "pre\xe7o efetivo",
                    "). O pre\xe7o desta campanha n\xe3o ser\xe1 servido."
                ]
            })
        ]
    });
}
function $18680f5e3e58b787$export$c2fc38ef7aab8351({ item: item, pending: pending, onRevalidate: onRevalidate }) {
    if (!item.invalidated) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
        type: "button",
        disabled: pending,
        onClick: ()=>onRevalidate(item),
        "aria-label": `Revalidar ${item.compound?.name || item.compound_id}`,
        title: "Revalidar com o pre\xe7o base atual",
        className: "min-h-11 min-w-11 inline-flex items-center justify-center text-amber-700 hover:text-amber-800 hover:bg-amber-50 rounded-lg disabled:opacity-50",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
            className: `w-4 h-4 ${pending ? "animate-spin" : ""}`
        })
    });
}


const $d489bc22fe049c93$export$fbf44e31ae9c19ff = "RESELLER_MARGIN";
const $d489bc22fe049c93$export$b386ef0e6983edd2 = 50;
function $d489bc22fe049c93$export$e7ea06c321cc0492(item) {
    return {
        promoType: item.promo_type,
        discountPct: item.discount_percentage ?? null,
        discountValue: item.discount_value ?? null,
        fixedPvp: item.fixed_pvp ?? null,
        discountTarget: item.discount_target ?? $d489bc22fe049c93$export$fbf44e31ae9c19ff,
        niposomSplitPct: item.niposom_split_pct ?? $d489bc22fe049c93$export$b386ef0e6983edd2
    };
}
function $d489bc22fe049c93$export$2db22e0bdc420cd6(params) {
    const body = {
        compound_id: params.compoundId,
        promo_type: params.promoType
    };
    if (params.editingItemId != null) body.item_id = params.editingItemId;
    if (params.isAdmin) {
        body.discount_target = params.discountTarget;
        if (params.discountTarget === "BOTH") body.niposom_split_pct = params.niposomSplitPct;
    }
    if (params.promoType === "DISCOUNT_PERCENTAGE") body.discount_percentage = params.discountPct;
    else if (params.promoType === "DISCOUNT_VALUE") body.discount_value = params.discountValue;
    else if (params.promoType === "FIXED_PVP") body.fixed_pvp = params.fixedPvp;
    return body;
}



const $3d4abd160bf87ee5$var$PROMO_TYPE_LABELS = {
    DISCOUNT_PERCENTAGE: "Desconto (%)",
    DISCOUNT_VALUE: "Desconto (\u20AC)",
    FIXED_PVP: "PVP Fixo"
};
const $3d4abd160bf87ee5$var$DISCOUNT_TARGET_LABELS = {
    NIPOSOM_MARGIN: "Niposom",
    RESELLER_MARGIN: "Reseller",
    BOTH: "Ambas"
};
const $3d4abd160bf87ee5$var$CampaignDetailPage = ()=>{
    const { id: id } = (0, $585f8bce88e531c1$export$99eaa27ddbbb95ef)();
    const [searchParams] = (0, $585f8bce88e531c1$export$f1a78c17382fe22a)();
    const navigate = (0, $585f8bce88e531c1$export$9770f232ac06a008)();
    const { profile: profile } = (0, $b622ef53e38024e7$export$1d39dc5b47e56ff0)();
    const { setLoading: setLoading, setError: setError, setSuccess: setSuccess } = (0, $a55f2a94cd420149$export$c50e37a2f0a2b064)();
    const isEditMode = !!id;
    const isEditing = searchParams.get("edit") === "true" || !isEditMode;
    const [profileData, setProfileData] = (0, $acw62.useState)(null);
    const [campaign, setCampaign] = (0, $acw62.useState)(null);
    const [name, setName] = (0, $acw62.useState)("");
    const [description, setDescription] = (0, $acw62.useState)("");
    const [startsAt, setStartsAt] = (0, $acw62.useState)("");
    const [endsAt, setEndsAt] = (0, $acw62.useState)("");
    const [resellerErpRef, setResellerErpRef] = (0, $acw62.useState)("");
    const [resellers, setResellers] = (0, $acw62.useState)([]);
    const [isGlobal, setIsGlobal] = (0, $acw62.useState)(false);
    const [items, setItems] = (0, $acw62.useState)([]);
    const [editingItem, setEditingItem] = (0, $acw62.useState)(null);
    const [preview, setPreview] = (0, $acw62.useState)(null);
    const [activeTab, setActiveTab] = (0, $acw62.useState)("details");
    const [previewError, setPreviewError] = (0, $acw62.useState)(null);
    const [previewPending, setPreviewPending] = (0, $acw62.useState)(false);
    const [showAddModal, setShowAddModal] = (0, $acw62.useState)(false);
    const [searchQuery, setSearchQuery] = (0, $acw62.useState)("");
    const [searchResults, setSearchResults] = (0, $acw62.useState)([]);
    const [selectedCompoundId, setSelectedCompoundId] = (0, $acw62.useState)(null);
    const [newPromoType, setNewPromoType] = (0, $acw62.useState)("DISCOUNT_PERCENTAGE");
    const [newDiscountPct, setNewDiscountPct] = (0, $acw62.useState)(null);
    const [newDiscountValue, setNewDiscountValue] = (0, $acw62.useState)(null);
    const [newFixedPvp, setNewFixedPvp] = (0, $acw62.useState)(null);
    const [newDiscountTarget, setNewDiscountTarget] = (0, $acw62.useState)("RESELLER_MARGIN");
    const [newNiposomSplitPct, setNewNiposomSplitPct] = (0, $acw62.useState)(50);
    const [expandedItemId, setExpandedItemId] = (0, $acw62.useState)(null);
    const [revalidatePendingId, setRevalidatePendingId] = (0, $acw62.useState)(null);
    const modalRef = (0, $acw62.useRef)(null);
    const tabRefs = (0, $acw62.useRef)({});
    const modalTriggerRef = (0, $acw62.useRef)(null);
    const reduceMotion = (0, $0ba870ee19d9ff90$export$6a42007cf1e7b6f8)();
    (0, $acw62.useEffect)(()=>{
        if (showAddModal) // Skip the sr-only target radios so focus lands on a visible control.
        modalRef.current?.querySelector('input[type="number"], input[type="text"], button')?.focus();
    }, [
        showAddModal
    ]);
    const loadProfile = async ()=>{
        try {
            const p = await profile();
            setProfileData(p);
        } catch (err) {
            console.warn("Failed to load profile:", err);
        }
    };
    const loadCampaign = async ()=>{
        if (!id) return;
        setLoading({
            message: "A carregar campanha..."
        });
        try {
            const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).CAMPAIGNS}/${id}`);
            const data = response.data;
            setCampaign(data);
            setName(data.name);
            setDescription(data.description || "");
            setStartsAt(formatDateForInput(data.starts_at));
            setEndsAt(formatDateForInput(data.ends_at));
            setResellerErpRef(data.reseller_erp_ref || "");
            setIsGlobal(data.is_global);
            setItems(data.items || []);
        } catch (err) {
            setError(err.response?.data?.message || "Erro ao carregar campanha");
        } finally{
            setLoading(null);
        }
    };
    const formatDateForInput = (iso)=>{
        const d = new Date(iso);
        if (isNaN(d.getTime())) return "";
        const pad = (n)=>n.toString().padStart(2, "0");
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
    };
    const toLocalInput = (d)=>{
        const pad = (n)=>n.toString().padStart(2, "0");
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
    };
    // Earliest allowed start/end: "now" (campaigns cannot be created in the past).
    const minStart = toLocalInput(new Date());
    const minEnd = startsAt || minStart;
    const canEdit = profileData?.isAdmin() || profileData?.isMainAccount() && !campaign?.is_global;
    (0, $acw62.useEffect)(()=>{
        loadProfile();
        if (isEditMode) loadCampaign();
    }, [
        id
    ]);
    // Reseller picker (admins only): list active ERP resellers.
    (0, $acw62.useEffect)(()=>{
        if (!profileData?.isAdmin()) return;
        (0, $bac44633733ff026$export$2e2bcd8739ae039).get(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).CAMPAIGNS}/_values/resellers`).then((r)=>setResellers(r.data)).catch((err)=>console.warn("Failed to load resellers:", err));
    }, [
        profileData
    ]);
    // React Router keeps this component mounted when only :id changes.
    (0, $acw62.useEffect)(()=>{
        setActiveTab("details");
    }, [
        id
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!isEditMode && profileData && !profileData.isAdmin()) setResellerErpRef("");
    }, [
        profileData,
        isEditMode
    ]);
    const searchCompounds = async (query)=>{
        if (query.length < 2) {
            setSearchResults([]);
            return;
        }
        try {
            const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).post(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).CATALOG}/_search`, {
                search_text: query,
                limit: 10,
                page: 1
            });
            setSearchResults(response.data?.results || []);
        } catch (err) {
            console.warn("Search error:", err);
            setSearchResults([]);
        }
    };
    (0, $acw62.useEffect)(()=>{
        const timer = setTimeout(()=>{
            searchCompounds(searchQuery);
        }, 300);
        return ()=>clearTimeout(timer);
    }, [
        searchQuery
    ]);
    const handleSave = async ()=>{
        if (!name.trim()) {
            setError("Nome da campanha \xe9 obrigat\xf3rio");
            return;
        }
        if (!startsAt || !endsAt) {
            setError("Datas de in\xedcio e fim s\xe3o obrigat\xf3rias");
            return;
        }
        if (new Date(startsAt) >= new Date(endsAt)) {
            setError("Data de in\xedcio deve ser anterior \xe0 data de fim");
            return;
        }
        if (!isEditMode && new Date(startsAt).getTime() < Date.now() - 60000) {
            setError("A data de in\xedcio n\xe3o pode estar no passado");
            return;
        }
        setLoading({
            message: isEditMode ? "A atualizar campanha..." : "A criar campanha..."
        });
        try {
            const body = {
                name: name.trim(),
                description: description.trim() || null,
                starts_at: new Date(startsAt).toISOString(),
                ends_at: new Date(endsAt).toISOString()
            };
            if (isGlobal) body.is_global = true;
            else if (profileData?.isAdmin() && !isEditMode && resellerErpRef.trim()) body.reseller_erp_ref = resellerErpRef.trim();
            if (isEditMode) {
                await (0, $bac44633733ff026$export$2e2bcd8739ae039).put(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).CAMPAIGNS}/${id}`, body);
                setSuccess("Campanha atualizada com sucesso!");
            } else {
                const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).post((0, $cd93687958c8007e$export$bfe19bc25132bb7c).CAMPAIGNS, body);
                const created = response.data;
                setCampaign(created);
                setSuccess("Campanha criada com sucesso!");
                navigate(`/campaigns/${created.id}?edit=true`, {
                    replace: true
                });
            }
        } catch (err) {
            setError(err.response?.data?.message || "Erro ao guardar campanha");
        } finally{
            setLoading(null);
        }
    };
    const handleStatusChange = async (newStatus)=>{
        if (!id) return;
        setLoading({
            message: "A alterar estado..."
        });
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).put(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).CAMPAIGNS}/${id}/status`, {
                status: newStatus
            });
            setSuccess("Estado alterado com sucesso!");
            loadCampaign();
        } catch (err) {
            setError(err.response?.data?.message || "Erro ao alterar estado");
        } finally{
            setLoading(null);
        }
    };
    const handleDelete = async ()=>{
        if (!id) return;
        if (!confirm("Tem a certeza que deseja eliminar esta campanha?")) return;
        setLoading({
            message: "A eliminar campanha..."
        });
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).delete(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).CAMPAIGNS}/${id}`);
            setSuccess("Campanha eliminada!");
            navigate("/campaigns", {
                replace: true
            });
        } catch (err) {
            setError(err.response?.data?.message || "Erro ao eliminar campanha");
        } finally{
            setLoading(null);
        }
    };
    const buildItemBody = (0, $acw62.useCallback)(()=>{
        const compoundId = editingItem?.compound_id ?? selectedCompoundId;
        if (!compoundId) return null;
        return (0, $d489bc22fe049c93$export$2db22e0bdc420cd6)({
            compoundId: compoundId,
            editingItemId: editingItem?.id ?? null,
            isAdmin: !!profileData?.isAdmin(),
            promoType: newPromoType,
            discountPct: newDiscountPct,
            discountValue: newDiscountValue,
            fixedPvp: newFixedPvp,
            discountTarget: newDiscountTarget,
            niposomSplitPct: newNiposomSplitPct
        });
    }, [
        editingItem,
        selectedCompoundId,
        profileData,
        newPromoType,
        newDiscountPct,
        newDiscountValue,
        newFixedPvp,
        newDiscountTarget,
        newNiposomSplitPct
    ]);
    const handleSubmitItem = async ()=>{
        const body = buildItemBody();
        if (!body || !id) return;
        setLoading({
            message: editingItem ? "A atualizar composto..." : "A adicionar compound..."
        });
        try {
            if (editingItem) {
                const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).put(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).CAMPAIGNS}/${id}/items/${editingItem.id}`, body);
                setItems(items.map((i)=>i.id === editingItem.id ? response.data : i));
                setSuccess("Composto atualizado!");
            } else {
                const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).post(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).CAMPAIGNS}/${id}/items`, body);
                setItems([
                    ...items,
                    response.data
                ]);
                setSuccess("Compound adicionado \xe0 campanha!");
            }
            closeItemModal();
        } catch (err) {
            setError(err.response?.data?.message || (editingItem ? "Erro ao atualizar composto" : "Erro ao adicionar compound"));
        } finally{
            setLoading(null);
        }
    };
    const openAddItemModal = ()=>{
        modalTriggerRef.current = document.activeElement;
        resetAddForm();
        setEditingItem(null);
        setPreview(null);
        setPreviewError(null);
        setPreviewPending(false);
        setShowAddModal(true);
    };
    const openEditItemModal = (item)=>{
        modalTriggerRef.current = document.activeElement;
        const form = (0, $d489bc22fe049c93$export$e7ea06c321cc0492)(item);
        setSelectedCompoundId(item.compound_id);
        setNewPromoType(form.promoType);
        setNewDiscountPct(form.discountPct);
        setNewDiscountValue(form.discountValue);
        setNewFixedPvp(form.fixedPvp);
        setNewDiscountTarget(form.discountTarget);
        setNewNiposomSplitPct(form.niposomSplitPct);
        setSearchQuery("");
        setSearchResults([]);
        setEditingItem(item);
        setPreview(item);
        setPreviewError(null);
        setPreviewPending(false);
        setShowAddModal(true);
    };
    const closeItemModal = ()=>{
        setShowAddModal(false);
        setEditingItem(null);
        setPreview(null);
        setPreviewError(null);
        setPreviewPending(false);
        resetAddForm();
        modalTriggerRef.current?.focus?.();
    };
    // Live margin preview: the backend recomputes promotional PVP / margins /
    // reseller price from the same configured-price code path used on save, so
    // what the operator sees here is exactly what gets persisted (no conf/ERP drift).
    (0, $acw62.useEffect)(()=>{
        if (!showAddModal || !id) return;
        const body = buildItemBody();
        if (!body) {
            setPreview(null);
            setPreviewError(null);
            setPreviewPending(false);
            return;
        }
        setPreviewError(null);
        setPreviewPending(true);
        let cancelled = false;
        const timer = setTimeout(async ()=>{
            try {
                const response = await (0, $bac44633733ff026$export$2e2bcd8739ae039).post(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).CAMPAIGNS}/${id}/items/_preview`, body);
                if (cancelled) return;
                setPreview(response.data);
                setPreviewError(null);
                setPreviewPending(false);
            } catch (err) {
                if (cancelled) return;
                console.warn("Campaign item preview failed:", err);
                setPreviewPending(false);
                // Keep the last good preview; surface the reason instead of vanishing.
                setPreviewError(err.response?.data?.message || "N\xe3o foi poss\xedvel pr\xe9-visualizar.");
            }
        }, 250);
        return ()=>{
            cancelled = true;
            clearTimeout(timer);
        };
    }, [
        showAddModal,
        id,
        buildItemBody
    ]);
    const handleRemoveItem = async (itemId)=>{
        if (!id) return;
        if (!confirm("Remover este compound da campanha?")) return;
        setLoading({
            message: "A remover compound..."
        });
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).delete(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).CAMPAIGNS}/${id}/items/${itemId}`);
            setItems(items.filter((i)=>i.id !== itemId));
            setSuccess("Compound removido!");
        } catch (err) {
            setError(err.response?.data?.message || "Erro ao remover compound");
        } finally{
            setLoading(null);
        }
    };
    const handleRevalidate = async (item)=>{
        if (!id) return;
        const label = item.compound?.name || item.compound_id;
        if (!confirm(`Revalidar "${label}" com o pre\xe7o base atual? O pre\xe7o promocional ser\xe1 recalculado.`)) return;
        setRevalidatePendingId(item.id);
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).post(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).CAMPAIGNS}/${id}/items/${item.id}/_revalidate`);
            // Re-fetch so the enriched other_campaigns / effective flags stay correct.
            await loadCampaign();
            setSuccess("Item revalidado com o pre\xe7o base atual.");
        } catch (err) {
            setError(err.response?.data?.message || "Erro ao revalidar item");
        } finally{
            setRevalidatePendingId(null);
        }
    };
    const resetAddForm = ()=>{
        setSelectedCompoundId(null);
        setNewPromoType("DISCOUNT_PERCENTAGE");
        setNewDiscountPct(null);
        setNewDiscountValue(null);
        setNewFixedPvp(null);
        setNewDiscountTarget("RESELLER_MARGIN");
        setNewNiposomSplitPct(50);
        setSearchQuery("");
        setSearchResults([]);
    };
    const calculatePromoPrice = (item)=>{
        if (item.promotional_pvp_with_vat != null) return (0, $a47955a5527e9f71$export$e18dec77288a7f6d).format(item.promotional_pvp_with_vat);
        const basePvp = item.compound?.configured_price_pvp_with_vat;
        if (!basePvp) return "\u2014";
        switch(item.promo_type){
            case "DISCOUNT_PERCENTAGE":
                if (item.discount_percentage != null) {
                    const discount = basePvp * (item.discount_percentage / 100);
                    return (0, $a47955a5527e9f71$export$e18dec77288a7f6d).format(basePvp - discount);
                }
                return "\u2014";
            case "DISCOUNT_VALUE":
                if (item.discount_value != null) return (0, $a47955a5527e9f71$export$e18dec77288a7f6d).format(basePvp - item.discount_value);
                return "\u2014";
            case "FIXED_PVP":
                if (item.fixed_pvp != null) return (0, $a47955a5527e9f71$export$e18dec77288a7f6d).format(item.fixed_pvp);
                return "\u2014";
            default:
                return "\u2014";
        }
    };
    const isReadonly = isEditMode && (!canEdit || !isEditing);
    // Document-level so the trap also holds after a backdrop click moves focus to <body>.
    (0, $acw62.useEffect)(()=>{
        if (!showAddModal) return;
        const onKeyDown = (e)=>{
            if (e.key === "Escape") {
                closeItemModal();
                return;
            }
            if (e.key !== "Tab") return;
            const focusable = modalRef.current?.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
            if (!focusable || focusable.length === 0) return;
            const first = focusable[0];
            const last = focusable[focusable.length - 1];
            // Focus escaped (e.g. backdrop click moved it to <body>): pull it back in.
            if (!modalRef.current?.contains(document.activeElement)) {
                e.preventDefault();
                (e.shiftKey ? last : first).focus();
                return;
            }
            if (e.shiftKey && document.activeElement === first) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
                e.preventDefault();
                first.focus();
            }
        };
        document.addEventListener("keydown", onKeyDown);
        return ()=>document.removeEventListener("keydown", onKeyDown);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        showAddModal
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "container mx-auto px-4 py-6",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).button, {
                whileHover: reduceMotion ? undefined : {
                    x: -3
                },
                onClick: ()=>navigate("/campaigns"),
                className: "flex items-center gap-1 text-blue-500 hover:text-blue-700 mb-4",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7b20c5205e441d74$export$2e2bcd8739ae039), {
                        className: "w-4 h-4"
                    }),
                    "Voltar"
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center gap-3 mb-6",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7b97e024910b40ff$export$2e2bcd8739ae039), {
                        className: "w-7 h-7 text-blue-500"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        className: "text-2xl font-bold",
                        children: isEditMode ? campaign?.name || "Campanha" : "Nova Campanha"
                    })
                ]
            }),
            isEditMode && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                role: "tablist",
                "aria-label": "Sec\xe7\xf5es da campanha",
                className: "flex gap-1 border-b mb-4",
                onKeyDown: (e)=>{
                    if (e.key !== "ArrowLeft" && e.key !== "ArrowRight") return;
                    const order = profileData?.isAdmin() ? [
                        "details",
                        "history"
                    ] : [
                        "details"
                    ];
                    const idx = order.indexOf(activeTab);
                    const next = e.key === "ArrowRight" ? (idx + 1) % order.length : (idx - 1 + order.length) % order.length;
                    e.preventDefault();
                    setActiveTab(order[next]);
                    tabRefs.current[order[next]]?.focus();
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        role: "tab",
                        id: "tab-details",
                        "aria-controls": "tabpanel-details",
                        ref: (el)=>{
                            tabRefs.current["details"] = el;
                        },
                        "aria-selected": activeTab === "details",
                        tabIndex: activeTab === "details" ? 0 : -1,
                        onClick: ()=>setActiveTab("details"),
                        className: `px-3 py-2 text-sm font-medium border-b-2 -mb-px ${activeTab === "details" ? "border-blue-600 text-blue-700" : "border-transparent text-gray-500 hover:text-gray-700"}`,
                        children: "Detalhes"
                    }),
                    profileData?.isAdmin() && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        role: "tab",
                        id: "tab-history",
                        "aria-controls": "tabpanel-history",
                        ref: (el)=>{
                            tabRefs.current["history"] = el;
                        },
                        "aria-selected": activeTab === "history",
                        tabIndex: activeTab === "history" ? 0 : -1,
                        onClick: ()=>setActiveTab("history"),
                        className: `px-3 py-2 text-sm font-medium border-b-2 -mb-px ${activeTab === "history" ? "border-blue-600 text-blue-700" : "border-transparent text-gray-500 hover:text-gray-700"}`,
                        children: "Hist\xf3rico"
                    })
                ]
            }),
            isEditMode && id && profileData?.isAdmin() && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "tabpanel",
                id: "tabpanel-history",
                "aria-labelledby": "tab-history",
                hidden: activeTab !== "history",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $012941f735240ef4$export$2e2bcd8739ae039), {
                    campaignId: id,
                    active: activeTab === "history"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                role: isEditMode ? "tabpanel" : undefined,
                id: isEditMode ? "tabpanel-details" : undefined,
                "aria-labelledby": isEditMode ? "tab-details" : undefined,
                hidden: isEditMode ? activeTab !== "details" : undefined,
                children: [
                    isEditMode && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex gap-2 mb-4",
                        children: [
                            campaign?.status !== "ARCHIVED" && canEdit && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    campaign?.status === "DRAFT" && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: ()=>handleStatusChange("ACTIVE"),
                                        className: "bg-green-700 text-white px-3 py-1 rounded-lg text-sm hover:bg-green-800",
                                        children: "Ativar"
                                    }),
                                    campaign?.status === "ACTIVE" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                onClick: ()=>handleStatusChange("DRAFT"),
                                                className: "bg-amber-700 text-white px-3 py-1 rounded-lg text-sm hover:bg-amber-800",
                                                children: "Voltar a Rascunho"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                onClick: ()=>{
                                                    if (confirm("Tem a certeza que deseja arquivar esta campanha? J\xe1 n\xe3o estar\xe1 ativa e n\xe3o pode ser reativada.")) handleStatusChange("ARCHIVED");
                                                },
                                                className: "border border-gray-300 text-gray-700 px-3 py-1 rounded-lg text-sm hover:bg-gray-100",
                                                children: "Arquivar"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            campaign?.status === "DRAFT" && canEdit && !campaign?.has_history && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                onClick: handleDelete,
                                className: "flex items-center gap-1 text-red-700 border border-red-200 px-3 py-1 rounded-lg text-sm hover:bg-red-50",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                        className: "w-4 h-4"
                                    }),
                                    "Eliminar"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "bg-white rounded-lg shadow p-6 mb-6",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "grid grid-cols-1 md:grid-cols-2 gap-4 mb-4",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "md:col-span-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                htmlFor: "campaign-name",
                                                className: "block text-sm font-medium text-gray-700 mb-1",
                                                children: "Nome"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                id: "campaign-name",
                                                type: "text",
                                                value: name,
                                                onChange: (e)=>setName(e.target.value),
                                                disabled: isReadonly,
                                                className: "w-full border rounded-lg px-3 py-2 disabled:bg-gray-100",
                                                placeholder: "Ex: Campanha Ver\xe3o 2025"
                                            })
                                        ]
                                    }),
                                    profileData?.isAdmin() && !isEditMode && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "mb-4 col-span-full",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                            className: "flex items-center gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "checkbox",
                                                    checked: isGlobal,
                                                    onChange: (e)=>setIsGlobal(e.target.checked),
                                                    className: "rounded border-gray-300"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "text-sm font-medium text-gray-700",
                                                    children: "Campanha Global (aplica-se a todos os resellers)"
                                                })
                                            ]
                                        })
                                    }),
                                    !isGlobal && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "md:col-span-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                htmlFor: "campaign-reseller",
                                                className: "block text-sm font-medium text-gray-700 mb-1",
                                                children: "Reseller (ERP Ref)"
                                            }),
                                            profileData?.isAdmin() && !isEditMode ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e8ef03ed3ad64dec$export$2e2bcd8739ae039), {
                                                id: "campaign-reseller",
                                                value: resellerErpRef,
                                                onChange: setResellerErpRef,
                                                options: resellers,
                                                placeholder: resellers.length > 0 ? `Procurar entre ${resellers.length} resellers\u{2026}` : "A carregar resellers\u2026"
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                id: "campaign-reseller",
                                                type: "text",
                                                value: resellerErpRef,
                                                disabled: true,
                                                className: "w-full border rounded-lg px-3 py-2 disabled:bg-gray-100",
                                                placeholder: "Autom\xe1tico (seu perfil)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "md:col-span-2 grid grid-cols-2 gap-4",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        htmlFor: "campaign-starts-at",
                                                        className: "block text-sm font-medium text-gray-700 mb-1",
                                                        children: "Data de in\xedcio"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        id: "campaign-starts-at",
                                                        type: "datetime-local",
                                                        value: startsAt,
                                                        min: minStart,
                                                        onChange: (e)=>setStartsAt(e.target.value),
                                                        disabled: isReadonly,
                                                        className: "w-full border rounded-lg px-3 py-2 disabled:bg-gray-100"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        htmlFor: "campaign-ends-at",
                                                        className: "block text-sm font-medium text-gray-700 mb-1",
                                                        children: "Data de fim"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        id: "campaign-ends-at",
                                                        type: "datetime-local",
                                                        value: endsAt,
                                                        min: minEnd,
                                                        onChange: (e)=>setEndsAt(e.target.value),
                                                        disabled: isReadonly,
                                                        className: "w-full border rounded-lg px-3 py-2 disabled:bg-gray-100"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mb-4",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                        htmlFor: "campaign-description",
                                        className: "block text-sm font-medium text-gray-700 mb-1",
                                        children: "Descri\xe7\xe3o"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                        id: "campaign-description",
                                        value: description,
                                        onChange: (e)=>setDescription(e.target.value),
                                        disabled: isReadonly,
                                        className: "w-full border rounded-lg px-3 py-2 disabled:bg-gray-100",
                                        rows: 3,
                                        placeholder: "Descri\xe7\xe3o opcional da campanha"
                                    })
                                ]
                            }),
                            !isReadonly && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "flex gap-2",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: handleSave,
                                    className: "bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700",
                                    children: isEditMode ? "Guardar Altera\xe7\xf5es" : "Criar Campanha"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "bg-white rounded-lg shadow p-6",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex justify-between items-center mb-4",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                        className: "text-xl font-semibold",
                                        children: [
                                            "Compostos na Campanha (",
                                            items.length,
                                            ")"
                                        ]
                                    }),
                                    isEditMode && canEdit && !isReadonly && campaign?.status === "DRAFT" && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        onClick: openAddItemModal,
                                        className: "bg-blue-600 text-white px-3 py-1 rounded-lg text-sm hover:bg-blue-700 flex items-center gap-1",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                                className: "w-4 h-4"
                                            }),
                                            "Adicionar Composto"
                                        ]
                                    })
                                ]
                            }),
                            items.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "text-gray-500 text-center py-8",
                                children: "Nenhum composto adicionado a esta campanha."
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "overflow-x-auto -mx-4 px-4 sm:mx-0 sm:px-0",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                                    className: "w-full min-w-[52rem] text-sm",
                                    "aria-label": "Compostos na campanha",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                className: "border-b text-left",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        scope: "col",
                                                        className: "pb-2 font-medium w-11",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "sr-only",
                                                            children: "Detalhes"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        scope: "col",
                                                        className: "pb-2 font-medium",
                                                        children: "Composto"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        scope: "col",
                                                        className: "pb-2 font-medium text-right",
                                                        children: "PVP Normal"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        scope: "col",
                                                        className: "pb-2 font-medium",
                                                        children: "Tipo"
                                                    }),
                                                    profileData?.isAdmin() && /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        scope: "col",
                                                        className: "pb-2 font-medium",
                                                        children: "Alvo"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        scope: "col",
                                                        className: "pb-2 font-medium text-right",
                                                        children: "Valor"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        scope: "col",
                                                        className: "pb-2 font-medium text-right",
                                                        children: "PVP Promocional"
                                                    }),
                                                    canEdit && !isReadonly && campaign?.status === "DRAFT" && /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        scope: "col",
                                                        className: "pb-2 font-medium",
                                                        children: "A\xe7\xf5es"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                            children: items.map((item)=>{
                                                const open = expandedItemId === item.id;
                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                            className: "border-b",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                    className: "py-2",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                        type: "button",
                                                                        onClick: ()=>setExpandedItemId(open ? null : item.id),
                                                                        "aria-expanded": open,
                                                                        "aria-controls": `erp-panel-${item.id}`,
                                                                        "aria-label": `Detalhes ERP e margens de ${item.compound?.name || item.compound_id}`,
                                                                        className: "min-h-11 min-w-11 p-2 text-gray-400 hover:text-blue-500 rounded-lg",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                                                                            className: `w-4 h-4 transition-transform ${open ? "rotate-90" : ""}`,
                                                                            "aria-hidden": "true"
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                    scope: "row",
                                                                    className: "py-2 font-normal text-left",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "flex items-center gap-2",
                                                                        children: [
                                                                            item.compound?.image && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                src: item.compound.image,
                                                                                alt: "",
                                                                                className: "w-8 h-8 object-contain rounded"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                children: item.compound?.name || item.compound_id
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $18680f5e3e58b787$export$f531b7b059c85d29), {
                                                                                item: item
                                                                            }),
                                                                            item.invalidated && canEdit && !isReadonly && campaign?.status !== "ARCHIVED" && (profileData?.isAdmin() || !item.niposom_funded) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $18680f5e3e58b787$export$c2fc38ef7aab8351), {
                                                                                item: item,
                                                                                pending: revalidatePendingId === item.id,
                                                                                onRevalidate: handleRevalidate
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                    className: "py-2 text-right tabular-nums",
                                                                    children: item.compound?.configured_price_pvp_with_vat != null ? (0, $a47955a5527e9f71$export$e18dec77288a7f6d).format(item.compound.configured_price_pvp_with_vat) : "\u2014"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                    className: "py-2",
                                                                    children: $3d4abd160bf87ee5$var$PROMO_TYPE_LABELS[item.promo_type] || item.promo_type
                                                                }),
                                                                profileData?.isAdmin() && /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                    className: "py-2",
                                                                    children: item.discount_target ? $3d4abd160bf87ee5$var$DISCOUNT_TARGET_LABELS[item.discount_target] + (item.discount_target === "BOTH" && item.niposom_split_pct != null ? ` \xb7 Niposom ${item.niposom_split_pct}% / Reseller ${100 - item.niposom_split_pct}%` : "") : "\u2014"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                    className: "py-2 text-right tabular-nums",
                                                                    children: item.promo_type === "DISCOUNT_PERCENTAGE" && item.discount_percentage != null ? `${item.discount_percentage}%` : item.promo_type === "DISCOUNT_VALUE" && item.discount_value != null ? (0, $a47955a5527e9f71$export$e18dec77288a7f6d).format(item.discount_value) : item.promo_type === "FIXED_PVP" && item.fixed_pvp != null ? (0, $a47955a5527e9f71$export$e18dec77288a7f6d).format(item.fixed_pvp) : "\u2014"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                    className: "py-2 font-semibold text-green-700 text-right tabular-nums",
                                                                    children: calculatePromoPrice(item)
                                                                }),
                                                                canEdit && !isReadonly && campaign?.status === "DRAFT" && /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                    className: "py-2",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "flex items-center gap-1",
                                                                        children: (profileData?.isAdmin() || !item.niposom_funded) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                    onClick: ()=>openEditItemModal(item),
                                                                                    className: "min-h-11 min-w-11 inline-flex items-center justify-center text-blue-600 hover:text-blue-700 hover:bg-blue-50 rounded-lg",
                                                                                    title: "Editar desconto e alvo",
                                                                                    "aria-label": `Editar desconto de ${item.compound?.name || item.compound_id}`,
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6c2a827dd5c2d433$export$2e2bcd8739ae039), {
                                                                                        className: "w-4 h-4"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                    onClick: ()=>handleRemoveItem(item.id),
                                                                                    className: "min-h-11 min-w-11 inline-flex items-center justify-center text-red-600 hover:text-red-700 hover:bg-red-50 rounded-lg",
                                                                                    title: "Remover",
                                                                                    "aria-label": `Remover ${item.compound?.name || item.compound_id} da campanha`,
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                                                                        className: "w-4 h-4"
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        open && /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                                                            className: "border-b bg-gray-50",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                                id: `erp-panel-${item.id}`,
                                                                colSpan: 6 + (profileData?.isAdmin() ? 1 : 0) + (canEdit && !isReadonly && campaign?.status === "DRAFT" ? 1 : 0),
                                                                className: "p-4",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $41a75e95e3d8f2fb$export$2e2bcd8739ae039), {
                                                                        item: item,
                                                                        isAdmin: !!profileData?.isAdmin()
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $18680f5e3e58b787$export$d25e68d304caf12), {
                                                                        item: item
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }, item.id);
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
                children: showAddModal && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).div, {
                    ref: modalRef,
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-labelledby": "add-compound-modal-title",
                    initial: {
                        opacity: 0
                    },
                    animate: {
                        opacity: 1
                    },
                    exit: {
                        opacity: 0
                    },
                    transition: {
                        duration: reduceMotion ? 0 : 0.18
                    },
                    className: "fixed inset-0 bg-black/50 flex items-center justify-center z-50",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).div, {
                        initial: {
                            opacity: 0,
                            scale: 0.95,
                            y: 10
                        },
                        animate: {
                            opacity: 1,
                            scale: 1,
                            y: 0
                        },
                        exit: {
                            opacity: 0,
                            scale: 0.95,
                            y: 10
                        },
                        transition: {
                            duration: reduceMotion ? 0 : 0.2
                        },
                        className: "bg-white rounded-lg p-6 w-full max-w-lg mx-4 shadow-xl max-h-[90dvh] overflow-y-auto",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                id: "add-compound-modal-title",
                                className: "text-lg font-semibold mb-4",
                                children: editingItem ? "Editar Composto" : "Adicionar Composto"
                            }),
                            !editingItem && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mb-4",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                        htmlFor: "compound-search-input",
                                        className: "block text-sm font-medium mb-1",
                                        children: "Procurar Composto"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "flex gap-2",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            id: "compound-search-input",
                                            type: "text",
                                            value: searchQuery,
                                            onChange: (e)=>setSearchQuery(e.target.value),
                                            "aria-controls": "compound-search-results",
                                            "aria-autocomplete": "list",
                                            className: "flex-1 border rounded-lg px-3 py-2",
                                            placeholder: "Nome do composto..."
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "sr-only",
                                        "aria-live": "polite",
                                        children: searchQuery ? `${searchResults.length} resultados` : ""
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        children: searchResults.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "mt-2 border rounded-lg max-h-40 overflow-y-auto",
                                            id: "compound-search-results",
                                            role: "listbox",
                                            "aria-label": "Resultados da pesquisa",
                                            children: searchResults.map((compound)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    role: "option",
                                                    tabIndex: 0,
                                                    "aria-selected": selectedCompoundId === compound.id,
                                                    onClick: ()=>setSelectedCompoundId(compound.id),
                                                    onKeyDown: (e)=>{
                                                        if (e.key === "Enter" || e.key === " ") {
                                                            e.preventDefault();
                                                            setSelectedCompoundId(compound.id);
                                                        }
                                                    },
                                                    className: `px-3 py-2 cursor-pointer hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-blue-500 ${selectedCompoundId === compound.id ? "bg-blue-100" : ""}`,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "flex items-center gap-2",
                                                        children: [
                                                            compound.image && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                src: compound.image,
                                                                alt: "",
                                                                className: "w-6 h-6 object-contain rounded"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                        className: "text-sm font-medium",
                                                                        children: compound.name
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                        className: "text-xs text-gray-500",
                                                                        children: [
                                                                            "PVP:",
                                                                            " ",
                                                                            compound.price?.value != null ? (0, $a47955a5527e9f71$export$e18dec77288a7f6d).format(compound.price.value) : "\u2014"
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }, compound.id))
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mb-4",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                        htmlFor: "promo-type-select",
                                        className: "block text-sm font-medium mb-1",
                                        children: "Tipo de Promo\xe7\xe3o"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                        id: "promo-type-select",
                                        value: newPromoType,
                                        onChange: (e)=>setNewPromoType(e.target.value),
                                        className: "w-full border rounded-lg px-3 py-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                value: "DISCOUNT_PERCENTAGE",
                                                children: "Desconto (%)"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                value: "DISCOUNT_VALUE",
                                                children: "Desconto (\u20AC)"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                value: "FIXED_PVP",
                                                children: "PVP Fixo"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            profileData?.isAdmin() && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mb-4",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("fieldset", {
                                        className: "rounded-lg border border-gray-200 p-1 inline-flex gap-1",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("legend", {
                                                className: "sr-only",
                                                children: "Alvo do desconto"
                                            }),
                                            [
                                                {
                                                    id: "RESELLER_MARGIN",
                                                    label: "Reseller"
                                                },
                                                {
                                                    id: "NIPOSOM_MARGIN",
                                                    label: "Niposom"
                                                },
                                                {
                                                    id: "BOTH",
                                                    label: "Ambas"
                                                }
                                            ].map((a)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                    className: `cursor-pointer rounded-md px-3 py-2 min-h-11 flex items-center gap-2 focus-within:ring-2 focus-within:ring-blue-500 ${newDiscountTarget === a.id ? "bg-blue-50 text-blue-700" : "text-gray-600"}`,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            type: "radio",
                                                            name: "discount-target",
                                                            value: a.id,
                                                            checked: newDiscountTarget === a.id,
                                                            onChange: ()=>setNewDiscountTarget(a.id),
                                                            className: "sr-only"
                                                        }),
                                                        a.label
                                                    ]
                                                }, a.id))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "mt-1 text-xs text-gray-500",
                                        children: "A que margem o desconto se aplica. Niposom/Ambas baixam o pre\xe7o de compra do reseller."
                                    }),
                                    newDiscountTarget === "BOTH" && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "mt-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                htmlFor: "split-niposom",
                                                className: "block text-sm font-medium mb-1",
                                                children: [
                                                    "Split do desconto \u2014 Niposom ",
                                                    newNiposomSplitPct,
                                                    "% \xb7 Reseller ",
                                                    100 - newNiposomSplitPct,
                                                    "%"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                id: "split-niposom",
                                                type: "range",
                                                min: 5,
                                                max: 100,
                                                step: 5,
                                                value: newNiposomSplitPct,
                                                onChange: (e)=>setNewNiposomSplitPct(Number(e.target.value)),
                                                "aria-label": "Percentagem do desconto aplicada \xe0 margem Niposom",
                                                "aria-valuetext": `${newNiposomSplitPct} por cento Niposom, ${100 - newNiposomSplitPct} por cento Reseller`,
                                                className: "w-full accent-blue-500 min-h-11"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            newPromoType === "DISCOUNT_PERCENTAGE" && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mb-4",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                        htmlFor: "discount-pct-input",
                                        className: "block text-sm font-medium mb-1",
                                        children: "Percentagem de desconto"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        id: "discount-pct-input",
                                        type: "number",
                                        value: newDiscountPct ?? "",
                                        onChange: (e)=>setNewDiscountPct(e.target.value === "" ? null : Number(e.target.value)),
                                        className: "w-full border rounded-lg px-3 py-2",
                                        placeholder: "Ex: 10",
                                        min: "0",
                                        max: "99.99",
                                        step: "0.01"
                                    })
                                ]
                            }),
                            newPromoType === "DISCOUNT_VALUE" && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mb-4",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                        htmlFor: "discount-value-input",
                                        className: "block text-sm font-medium mb-1",
                                        children: "Valor de desconto (\u20AC)"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        id: "discount-value-input",
                                        type: "number",
                                        value: newDiscountValue ?? "",
                                        onChange: (e)=>setNewDiscountValue(e.target.value === "" ? null : Number(e.target.value)),
                                        className: "w-full border rounded-lg px-3 py-2",
                                        placeholder: "Ex: 50",
                                        min: "0",
                                        step: "0.01"
                                    })
                                ]
                            }),
                            newPromoType === "FIXED_PVP" && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mb-4",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                        htmlFor: "fixed-pvp-input",
                                        className: "block text-sm font-medium mb-1",
                                        children: "PVP Fixo (\u20AC)"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        id: "fixed-pvp-input",
                                        type: "number",
                                        value: newFixedPvp ?? "",
                                        onChange: (e)=>setNewFixedPvp(e.target.value === "" ? null : Number(e.target.value)),
                                        className: "w-full border rounded-lg px-3 py-2",
                                        placeholder: "Ex: 999",
                                        min: "0.01",
                                        step: "0.01"
                                    })
                                ]
                            }),
                            (editingItem || selectedCompoundId != null) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mb-4 p-3 bg-gray-50 rounded-lg text-sm",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                                        className: "mb-2 text-xs font-medium uppercase tracking-wide text-gray-600",
                                        children: [
                                            "Pr\xe9-visualiza\xe7\xe3o",
                                            previewPending ? " \xb7 A atualizar\u2026" : ""
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        children: [
                                            "Composto selecionado:",
                                            " ",
                                            editingItem ? editingItem.compound?.name || editingItem.compound_id : searchResults.find((r)=>r.id === selectedCompoundId)?.name ?? preview?.compound?.name
                                        ]
                                    }),
                                    previewError && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        role: "alert",
                                        className: "mt-1 text-xs text-red-700",
                                        children: previewError
                                    }),
                                    preview?.compound?.configured_price_pvp_with_vat != null && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        className: "mt-1",
                                        "aria-live": "polite",
                                        children: [
                                            "PVP Normal:",
                                            " ",
                                            preview.promotional_pvp_with_vat != null && preview.promotional_pvp_with_vat !== preview.compound.configured_price_pvp_with_vat ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "line-through",
                                                        children: (0, $a47955a5527e9f71$export$e18dec77288a7f6d).format(preview.compound.configured_price_pvp_with_vat)
                                                    }),
                                                    " \u2192 ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "text-green-700 font-semibold",
                                                        children: (0, $a47955a5527e9f71$export$e18dec77288a7f6d).format(preview.promotional_pvp_with_vat)
                                                    })
                                                ]
                                            }) : (0, $a47955a5527e9f71$export$e18dec77288a7f6d).format(preview.compound.configured_price_pvp_with_vat)
                                        ]
                                    }),
                                    preview?.compound && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: `mt-3 border-t pt-3 transition-opacity motion-reduce:transition-none ${previewPending ? "opacity-60" : ""}`,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $41a75e95e3d8f2fb$export$2e2bcd8739ae039), {
                                            item: preview,
                                            isAdmin: !!profileData?.isAdmin(),
                                            showErpComparison: false
                                        })
                                    }),
                                    preview?.compound && (preview.compound.reseller_promo_margin_value != null && preview.compound.reseller_promo_margin_value < 0 || profileData?.isAdmin() && preview.compound.niposom_promo_margin_value != null && preview.compound.niposom_promo_margin_value < 0) && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        role: "alert",
                                        className: "mt-2 text-xs text-red-700",
                                        children: "Aten\xe7\xe3o: com este desconto h\xe1 margem negativa. Rev\xea o valor ou o alvo."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex justify-end gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: closeItemModal,
                                        className: "px-4 py-2 text-gray-600 hover:bg-gray-100 rounded-lg",
                                        children: "Cancelar"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: handleSubmitItem,
                                        disabled: editingItem ? false : selectedCompoundId == null,
                                        className: "px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-300",
                                        children: editingItem ? "Guardar Altera\xe7\xf5es" : "Adicionar"
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $3d4abd160bf87ee5$export$2e2bcd8739ae039 = $3d4abd160bf87ee5$var$CampaignDetailPage;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");









var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




const $b03ff2b972a18f42$var$SITE_BASE_URL = undefined ?? "https://new.eurosys.pt";
function $b03ff2b972a18f42$var$formatDate(dateStr) {
    if (!dateStr) return "\u2014";
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return "\u2014";
    return d.toLocaleString("pt-PT", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
    });
}
const $b03ff2b972a18f42$var$CmsPagesList = ({ pages: pages, loading: loading, onEdit: onEdit, onDelete: onDelete, setError: setError })=>{
    const [deletingSlug, setDeletingSlug] = (0, $acw62.useState)(null);
    const [confirmSlug, setConfirmSlug] = (0, $acw62.useState)(null);
    const handleDelete = async (page)=>{
        setConfirmSlug(null);
        setDeletingSlug(page.slug);
        try {
            await (0, $bac44633733ff026$export$2e2bcd8739ae039).delete(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).CMS_ADMIN}/${page.slug}`);
            onDelete(page);
        } catch (e) {
            setError((0, $1dc90ddccfa14c0f$export$d6cf8ca521a17a2)(e, "Erro ao apagar p\xe1gina."));
        } finally{
            setDeletingSlug(null);
        }
    };
    const previewUrl = (slug)=>slug === "home" ? $b03ff2b972a18f42$var$SITE_BASE_URL : `${$b03ff2b972a18f42$var$SITE_BASE_URL}/${slug}`;
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "bg-white rounded-xl shadow-sm border border-gray-200 p-12 text-center",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "mt-4 text-gray-600",
                children: "A carregar p\xe1ginas..."
            })
        ]
    });
    if (pages.length === 0) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "bg-white rounded-xl shadow-sm border border-gray-200 p-12 text-center",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "text-gray-500",
                children: "Nenhuma p\xe1gina encontrada."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "text-sm text-gray-400 mt-2",
                children: 'Clique em "+ Nova P\xe1gina" para criar a primeira.'
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
            className: "min-w-full divide-y divide-gray-200",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                    className: "bg-gray-50",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                children: "Slug"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                children: "T\xedtulo"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                children: "SEO Title"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                children: "Sec\xe7\xf5es"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                children: "Atualizada"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                className: "px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider",
                                children: "A\xe7\xf5es"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                    className: "bg-white divide-y divide-gray-200",
                    children: pages.map((page)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                            className: "hover:bg-gray-50 transition",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                    className: "px-6 py-4 whitespace-nowrap text-sm font-mono text-gray-900",
                                    children: page.slug
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                    className: "px-6 py-4 text-sm text-gray-900 max-w-xs truncate",
                                    children: page.title || /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "text-gray-400 italic",
                                        children: "Sem t\xedtulo"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                    className: "px-6 py-4 text-sm text-gray-500 max-w-xs truncate",
                                    children: page.seo_title || /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "text-gray-400 italic",
                                        children: "\u2014"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                    className: "px-6 py-4 whitespace-nowrap text-sm text-gray-500",
                                    children: Array.isArray(page.sections) ? page.sections.length : 0
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                    className: "px-6 py-4 whitespace-nowrap text-sm text-gray-500",
                                    children: $b03ff2b972a18f42$var$formatDate(page.updated_at)
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                    className: "px-6 py-4 whitespace-nowrap text-right text-sm font-medium",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex gap-2 justify-end items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                href: previewUrl(page.slug),
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                className: "text-gray-400 hover:text-gray-600 p-1.5 hover:bg-gray-100 rounded transition",
                                                title: "Ver no site",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3c35b0991cad9668$export$2e2bcd8739ae039), {
                                                    className: "w-4 h-4"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                onClick: ()=>onEdit(page),
                                                className: "text-blue-600 hover:text-blue-900 p-1.5 hover:bg-blue-50 rounded transition",
                                                title: "Editar",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $737c279b45d43939$export$2e2bcd8739ae039), {
                                                    className: "w-4 h-4"
                                                })
                                            }),
                                            confirmSlug === page.slug ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "flex items-center gap-1.5 text-xs bg-red-50 px-2 py-1 rounded-md whitespace-nowrap",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "text-red-600",
                                                        children: "Apagar?"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        onClick: ()=>handleDelete(page),
                                                        disabled: deletingSlug === page.slug,
                                                        className: "text-red-700 font-medium hover:underline disabled:opacity-50",
                                                        children: "Sim"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        onClick: ()=>setConfirmSlug(null),
                                                        className: "text-gray-500 hover:underline",
                                                        children: "N\xe3o"
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                onClick: ()=>setConfirmSlug(page.slug),
                                                disabled: deletingSlug !== null,
                                                className: "text-red-600 hover:text-red-900 p-1.5 hover:bg-red-50 rounded transition disabled:opacity-50",
                                                title: "Apagar",
                                                children: deletingSlug === page.slug ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "inline-block animate-spin rounded-full h-4 w-4 border-b-2 border-red-600"
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                                    className: "w-4 h-4"
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }, page.slug))
                })
            ]
        })
    });
};
var $b03ff2b972a18f42$export$2e2bcd8739ae039 = $b03ff2b972a18f42$var$CmsPagesList;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f9e50e5a44fb11e0$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ],
    [
        "path",
        {
            d: "m12 5 7 7-7 7",
            key: "xquz4c"
        }
    ]
];
const $f9e50e5a44fb11e0$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("arrow-right", $f9e50e5a44fb11e0$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $cd622ab0b3556c79$export$3efd853dbb351e94 = [
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "20",
            y2: "10",
            key: "1vz5eb"
        }
    ],
    [
        "line",
        {
            x1: "18",
            x2: "18",
            y1: "20",
            y2: "4",
            key: "cun8e5"
        }
    ],
    [
        "line",
        {
            x1: "6",
            x2: "6",
            y1: "20",
            y2: "16",
            key: "hq0ia6"
        }
    ]
];
const $cd622ab0b3556c79$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("chart-no-axes-column-increasing", $cd622ab0b3556c79$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e1cfd183b457f6f1$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 7v14",
            key: "1akyts"
        }
    ],
    [
        "path",
        {
            d: "M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z",
            key: "ruj8y"
        }
    ]
];
const $e1cfd183b457f6f1$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("book-open", $e1cfd183b457f6f1$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $34c3e517ec92034a$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16",
            key: "jecpp"
        }
    ],
    [
        "rect",
        {
            width: "20",
            height: "14",
            x: "2",
            y: "6",
            rx: "2",
            key: "i6l2r4"
        }
    ]
];
const $34c3e517ec92034a$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("briefcase", $34c3e517ec92034a$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $224502d93617e0e1$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z",
            key: "1b4qmf"
        }
    ],
    [
        "path",
        {
            d: "M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2",
            key: "i71pzd"
        }
    ],
    [
        "path",
        {
            d: "M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2",
            key: "10jefs"
        }
    ],
    [
        "path",
        {
            d: "M10 6h4",
            key: "1itunk"
        }
    ],
    [
        "path",
        {
            d: "M10 10h4",
            key: "tcdvrf"
        }
    ],
    [
        "path",
        {
            d: "M10 14h4",
            key: "kelpxr"
        }
    ],
    [
        "path",
        {
            d: "M10 18h4",
            key: "1ulq68"
        }
    ]
];
const $224502d93617e0e1$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("building-2", $224502d93617e0e1$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f792549e0db201dc$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5",
            key: "laymnq"
        }
    ],
    [
        "path",
        {
            d: "M8.5 8.5v.01",
            key: "ue8clq"
        }
    ],
    [
        "path",
        {
            d: "M16 15.5v.01",
            key: "14dtrp"
        }
    ],
    [
        "path",
        {
            d: "M12 12v.01",
            key: "u5ubse"
        }
    ],
    [
        "path",
        {
            d: "M11 17v.01",
            key: "1hyl5a"
        }
    ],
    [
        "path",
        {
            d: "M7 14v.01",
            key: "uct60s"
        }
    ]
];
const $f792549e0db201dc$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("cookie", $f792549e0db201dc$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $1299b0a605d22052$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "20",
            height: "14",
            x: "2",
            y: "5",
            rx: "2",
            key: "ynyp8z"
        }
    ],
    [
        "line",
        {
            x1: "2",
            x2: "22",
            y1: "10",
            y2: "10",
            key: "1b3vmo"
        }
    ]
];
const $1299b0a605d22052$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("credit-card", $1299b0a605d22052$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $199a795aa57ac65f$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m11 17 2 2a1 1 0 1 0 3-3",
            key: "efffak"
        }
    ],
    [
        "path",
        {
            d: "m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4",
            key: "9pr0kb"
        }
    ],
    [
        "path",
        {
            d: "m21 3 1 11h-2",
            key: "1tisrp"
        }
    ],
    [
        "path",
        {
            d: "M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3",
            key: "1uvwmv"
        }
    ],
    [
        "path",
        {
            d: "M3 4h8",
            key: "1ep09j"
        }
    ]
];
const $199a795aa57ac65f$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("handshake", $199a795aa57ac65f$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $605221d737bd0cfe$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3 11h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5Zm0 0a9 9 0 1 1 18 0m0 0v5a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3Z",
            key: "12oyoe"
        }
    ],
    [
        "path",
        {
            d: "M21 16v2a4 4 0 0 1-4 4h-5",
            key: "1x7m43"
        }
    ]
];
const $605221d737bd0cfe$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("headset", $605221d737bd0cfe$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $ef166891ec0b7b3f$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3 12h.01",
            key: "nlz23k"
        }
    ],
    [
        "path",
        {
            d: "M3 18h.01",
            key: "1tta3j"
        }
    ],
    [
        "path",
        {
            d: "M3 6h.01",
            key: "1rqtza"
        }
    ],
    [
        "path",
        {
            d: "M8 12h13",
            key: "1za7za"
        }
    ],
    [
        "path",
        {
            d: "M8 18h13",
            key: "1lx6n3"
        }
    ],
    [
        "path",
        {
            d: "M8 6h13",
            key: "ik3vkj"
        }
    ]
];
const $ef166891ec0b7b3f$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("list", $ef166891ec0b7b3f$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $da03c070d837b197$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z",
            key: "1qme2f"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "3",
            key: "1v7zrd"
        }
    ]
];
const $da03c070d837b197$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("settings", $da03c070d837b197$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $960b709ecb4ade55$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
            key: "oel41y"
        }
    ]
];
const $960b709ecb4ade55$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("shield", $960b709ecb4ade55$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e325251f2797f6cf$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
            key: "oel41y"
        }
    ],
    [
        "path",
        {
            d: "m9 12 2 2 4-4",
            key: "dzmm74"
        }
    ]
];
const $e325251f2797f6cf$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("shield-check", $e325251f2797f6cf$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $3f17d085e2e0469d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7",
            key: "ztvudi"
        }
    ],
    [
        "path",
        {
            d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8",
            key: "1b2hhj"
        }
    ],
    [
        "path",
        {
            d: "M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4",
            key: "2ebpfo"
        }
    ],
    [
        "path",
        {
            d: "M2 7h20",
            key: "1fcdvo"
        }
    ],
    [
        "path",
        {
            d: "M22 7v3a2 2 0 0 1-2 2a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 16 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 12 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 8 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 4 12a2 2 0 0 1-2-2V7",
            key: "6c3vgh"
        }
    ]
];
const $3f17d085e2e0469d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("store", $3f17d085e2e0469d$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $392fe89eaa6d43ad$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2",
            key: "wrbu53"
        }
    ],
    [
        "path",
        {
            d: "M15 18H9",
            key: "1lyqi6"
        }
    ],
    [
        "path",
        {
            d: "M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14",
            key: "lysw3i"
        }
    ],
    [
        "circle",
        {
            cx: "17",
            cy: "18",
            r: "2",
            key: "332jqn"
        }
    ],
    [
        "circle",
        {
            cx: "7",
            cy: "18",
            r: "2",
            key: "19iecd"
        }
    ]
];
const $392fe89eaa6d43ad$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("truck", $392fe89eaa6d43ad$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $33b542e8915cec79$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1",
            key: "18etb6"
        }
    ],
    [
        "path",
        {
            d: "M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4",
            key: "xoc0q4"
        }
    ]
];
const $33b542e8915cec79$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("wallet", $33b542e8915cec79$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $888d8be60abebd94$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z",
            key: "cbrjhi"
        }
    ]
];
const $888d8be60abebd94$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("wrench", $888d8be60abebd94$export$3efd853dbb351e94);



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $3p9rK = parcelRequire("3p9rK");

var $c05no = parcelRequire("c05no");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
// These are filled with ranges (rangeFrom[i] up to but not including
// rangeTo[i]) of code points that count as extending characters.
let $08c4544bca527ef0$var$rangeFrom = [], $08c4544bca527ef0$var$rangeTo = [];
(()=>{
    // Compressed representation of the Grapheme_Cluster_Break=Extend
    // information from
    // http://www.unicode.org/Public/16.0.0/ucd/auxiliary/GraphemeBreakProperty.txt.
    // Each pair of elements represents a range, as an offet from the
    // previous range and a length. Numbers are in base-36, with the empty
    // string being a shorthand for 1.
    let numbers = "lc,34,7n,7,7b,19,,,,2,,2,,,20,b,1c,l,g,,2t,7,2,6,2,2,,4,z,,u,r,2j,b,1m,9,9,,o,4,,9,,3,,5,17,3,3b,f,,w,1j,,,,4,8,4,,3,7,a,2,t,,1m,,,,2,4,8,,9,,a,2,q,,2,2,1l,,4,2,4,2,2,3,3,,u,2,3,,b,2,1l,,4,5,,2,4,,k,2,m,6,,,1m,,,2,,4,8,,7,3,a,2,u,,1n,,,,c,,9,,14,,3,,1l,3,5,3,,4,7,2,b,2,t,,1m,,2,,2,,3,,5,2,7,2,b,2,s,2,1l,2,,,2,4,8,,9,,a,2,t,,20,,4,,2,3,,,8,,29,,2,7,c,8,2q,,2,9,b,6,22,2,r,,,,,,1j,e,,5,,2,5,b,,10,9,,2u,4,,6,,2,2,2,p,2,4,3,g,4,d,,2,2,6,,f,,jj,3,qa,3,t,3,t,2,u,2,1s,2,,7,8,,2,b,9,,19,3,3b,2,y,,3a,3,4,2,9,,6,3,63,2,2,,1m,,,7,,,,,2,8,6,a,2,,1c,h,1r,4,1c,7,,,5,,14,9,c,2,w,4,2,2,,3,1k,,,2,3,,,3,1m,8,2,2,48,3,,d,,7,4,,6,,3,2,5i,1m,,5,ek,,5f,x,2da,3,3x,,2o,w,fe,6,2x,2,n9w,4,,a,w,2,28,2,7k,,3,,4,,p,2,5,,47,2,q,i,d,,12,8,p,b,1a,3,1c,,2,4,2,2,13,,1v,6,2,2,2,2,c,,8,,1b,,1f,,,3,2,2,5,2,,,16,2,8,,6m,,2,,4,,fn4,,kh,g,g,g,a6,2,gt,,6a,,45,5,1ae,3,,2,5,4,14,3,4,,4l,2,fx,4,ar,2,49,b,4w,,1i,f,1k,3,1d,4,2,2,1x,3,10,5,,8,1q,,c,2,1g,9,a,4,2,,2n,3,2,,,2,6,,4g,,3,8,l,2,1l,2,,,,,m,,e,7,3,5,5f,8,2,3,,,n,,29,,2,6,,,2,,,2,,2,6j,,2,4,6,2,,2,r,2,2d,8,2,,,2,2y,,,,2,6,,,2t,3,2,4,,5,77,9,,2,6t,,a,2,,,4,,40,4,2,2,4,,w,a,14,6,2,4,8,,9,6,2,3,1a,d,,2,ba,7,,6,,,2a,m,2,7,,2,,2,3e,6,3,,,2,,7,,,20,2,3,,,,9n,2,f0b,5,1n,7,t4,,1r,4,29,,f5k,2,43q,,,3,4,5,8,8,2,7,u,4,44,3,1iz,1j,4,1e,8,,e,,m,5,,f,11s,7,,h,2,7,,2,,5,79,7,c5,4,15s,7,31,7,240,5,gx7k,2o,3k,6o".split(",").map((s)=>s ? parseInt(s, 36) : 1);
    for(let i = 0, n = 0; i < numbers.length; i++)(i % 2 ? $08c4544bca527ef0$var$rangeTo : $08c4544bca527ef0$var$rangeFrom).push(n = n + numbers[i]);
})();
function $08c4544bca527ef0$export$5ff7ae0b7231f50b(code) {
    if (code < 768) return false;
    for(let from = 0, to = $08c4544bca527ef0$var$rangeFrom.length;;){
        let mid = from + to >> 1;
        if (code < $08c4544bca527ef0$var$rangeFrom[mid]) to = mid;
        else if (code >= $08c4544bca527ef0$var$rangeTo[mid]) from = mid + 1;
        else return true;
        if (from == to) return false;
    }
}
function $08c4544bca527ef0$var$isRegionalIndicator(code) {
    return code >= 0x1F1E6 && code <= 0x1F1FF;
}
function $08c4544bca527ef0$var$check(code) {
    for(let i = 0; i < $08c4544bca527ef0$var$rangeFrom.length; i++){
        if ($08c4544bca527ef0$var$rangeTo[i] > code) return $08c4544bca527ef0$var$rangeFrom[i] <= code;
    }
    return false;
}
const $08c4544bca527ef0$var$ZWJ = 0x200d;
function $08c4544bca527ef0$export$a0fa439fd515e1ed(str, pos, forward = true, includeExtending = true) {
    return (forward ? $08c4544bca527ef0$var$nextClusterBreak : $08c4544bca527ef0$var$prevClusterBreak)(str, pos, includeExtending);
}
function $08c4544bca527ef0$var$nextClusterBreak(str, pos, includeExtending) {
    if (pos == str.length) return pos;
    // If pos is in the middle of a surrogate pair, move to its start
    if (pos && $08c4544bca527ef0$var$surrogateLow(str.charCodeAt(pos)) && $08c4544bca527ef0$var$surrogateHigh(str.charCodeAt(pos - 1))) pos--;
    let prev = $08c4544bca527ef0$var$codePointAt(str, pos);
    pos += $08c4544bca527ef0$var$codePointSize(prev);
    while(pos < str.length){
        let next = $08c4544bca527ef0$var$codePointAt(str, pos);
        if (prev == $08c4544bca527ef0$var$ZWJ || next == $08c4544bca527ef0$var$ZWJ || includeExtending && $08c4544bca527ef0$export$5ff7ae0b7231f50b(next)) {
            pos += $08c4544bca527ef0$var$codePointSize(next);
            prev = next;
        } else if ($08c4544bca527ef0$var$isRegionalIndicator(next)) {
            let countBefore = 0, i = pos - 2;
            while(i >= 0 && $08c4544bca527ef0$var$isRegionalIndicator($08c4544bca527ef0$var$codePointAt(str, i))){
                countBefore++;
                i -= 2;
            }
            if (countBefore % 2 == 0) break;
            else pos += 2;
        } else break;
    }
    return pos;
}
function $08c4544bca527ef0$var$prevClusterBreak(str, pos, includeExtending) {
    while(pos > 0){
        let found = $08c4544bca527ef0$var$nextClusterBreak(str, pos - 2, includeExtending);
        if (found < pos) return found;
        pos--;
    }
    return 0;
}
function $08c4544bca527ef0$var$codePointAt(str, pos) {
    let code0 = str.charCodeAt(pos);
    if (!$08c4544bca527ef0$var$surrogateHigh(code0) || pos + 1 == str.length) return code0;
    let code1 = str.charCodeAt(pos + 1);
    if (!$08c4544bca527ef0$var$surrogateLow(code1)) return code0;
    return (code0 - 0xd800 << 10) + (code1 - 0xdc00) + 0x10000;
}
function $08c4544bca527ef0$var$surrogateLow(ch) {
    return ch >= 0xDC00 && ch < 0xE000;
}
function $08c4544bca527ef0$var$surrogateHigh(ch) {
    return ch >= 0xD800 && ch < 0xDC00;
}
function $08c4544bca527ef0$var$codePointSize(code) {
    return code < 0x10000 ? 1 : 2;
}


/**
The data structure for documents. @nonabstract
*/ class $6295c6875f57e3ee$export$5f1af8db9871e1d6 {
    /**
    Get the line description around the given position.
    */ lineAt(pos) {
        if (pos < 0 || pos > this.length) throw new RangeError(`Invalid position ${pos} in document of length ${this.length}`);
        return this.lineInner(pos, false, 1, 0);
    }
    /**
    Get the description for the given (1-based) line number.
    */ line(n) {
        if (n < 1 || n > this.lines) throw new RangeError(`Invalid line number ${n} in ${this.lines}-line document`);
        return this.lineInner(n, true, 1, 0);
    }
    /**
    Replace a range of the text with the given content.
    */ replace(from, to, text) {
        [from, to] = $6295c6875f57e3ee$var$clip(this, from, to);
        let parts = [];
        this.decompose(0, from, parts, 2 /* Open.To */ );
        if (text.length) text.decompose(0, text.length, parts, 3 /* Open.To */ );
        this.decompose(to, this.length, parts, 1 /* Open.From */ );
        return $6295c6875f57e3ee$var$TextNode.from(parts, this.length - (to - from) + text.length);
    }
    /**
    Append another document to this one.
    */ append(other) {
        return this.replace(this.length, this.length, other);
    }
    /**
    Retrieve the text between the given points.
    */ slice(from, to = this.length) {
        [from, to] = $6295c6875f57e3ee$var$clip(this, from, to);
        let parts = [];
        this.decompose(from, to, parts, 0);
        return $6295c6875f57e3ee$var$TextNode.from(parts, to - from);
    }
    /**
    Test whether this text is equal to another instance.
    */ eq(other) {
        if (other == this) return true;
        if (other.length != this.length || other.lines != this.lines) return false;
        let start = this.scanIdentical(other, 1), end = this.length - this.scanIdentical(other, -1);
        let a = new $6295c6875f57e3ee$var$RawTextCursor(this), b = new $6295c6875f57e3ee$var$RawTextCursor(other);
        for(let skip = start, pos = start;;){
            a.next(skip);
            b.next(skip);
            skip = 0;
            if (a.lineBreak != b.lineBreak || a.done != b.done || a.value != b.value) return false;
            pos += a.value.length;
            if (a.done || pos >= end) return true;
        }
    }
    /**
    Iterate over the text. When `dir` is `-1`, iteration happens
    from end to start. This will return lines and the breaks between
    them as separate strings.
    */ iter(dir = 1) {
        return new $6295c6875f57e3ee$var$RawTextCursor(this, dir);
    }
    /**
    Iterate over a range of the text. When `from` > `to`, the
    iterator will run in reverse.
    */ iterRange(from, to = this.length) {
        return new $6295c6875f57e3ee$var$PartialTextCursor(this, from, to);
    }
    /**
    Return a cursor that iterates over the given range of lines,
    _without_ returning the line breaks between, and yielding empty
    strings for empty lines.
    
    When `from` and `to` are given, they should be 1-based line numbers.
    */ iterLines(from, to) {
        let inner;
        if (from == null) inner = this.iter();
        else {
            if (to == null) to = this.lines + 1;
            let start = this.line(from).from;
            inner = this.iterRange(start, Math.max(start, to == this.lines + 1 ? this.length : to <= 1 ? 0 : this.line(to - 1).to));
        }
        return new $6295c6875f57e3ee$var$LineCursor(inner);
    }
    /**
    Return the document as a string, using newline characters to
    separate lines.
    */ toString() {
        return this.sliceString(0);
    }
    /**
    Convert the document to an array of lines (which can be
    deserialized again via [`Text.of`](https://codemirror.net/6/docs/ref/#state.Text^of)).
    */ toJSON() {
        let lines = [];
        this.flatten(lines);
        return lines;
    }
    /**
    @internal
    */ constructor(){}
    /**
    Create a `Text` instance for the given array of lines.
    */ static of(text) {
        if (text.length == 0) throw new RangeError("A document must have at least one line");
        if (text.length == 1 && !text[0]) return $6295c6875f57e3ee$export$5f1af8db9871e1d6.empty;
        return text.length <= 32 /* Tree.Branch */  ? new $6295c6875f57e3ee$var$TextLeaf(text) : $6295c6875f57e3ee$var$TextNode.from($6295c6875f57e3ee$var$TextLeaf.split(text, []));
    }
}
// Leaves store an array of line strings. There are always line breaks
// between these strings. Leaves are limited in size and have to be
// contained in TextNode instances for bigger documents.
class $6295c6875f57e3ee$var$TextLeaf extends $6295c6875f57e3ee$export$5f1af8db9871e1d6 {
    constructor(text, length = $6295c6875f57e3ee$var$textLength(text)){
        super();
        this.text = text;
        this.length = length;
    }
    get lines() {
        return this.text.length;
    }
    get children() {
        return null;
    }
    lineInner(target, isLine, line, offset) {
        for(let i = 0;; i++){
            let string = this.text[i], end = offset + string.length;
            if ((isLine ? line : end) >= target) return new $6295c6875f57e3ee$export$17d680238e50603e(offset, end, line, string);
            offset = end + 1;
            line++;
        }
    }
    decompose(from, to, target, open) {
        let text = from <= 0 && to >= this.length ? this : new $6295c6875f57e3ee$var$TextLeaf($6295c6875f57e3ee$var$sliceText(this.text, from, to), Math.min(to, this.length) - Math.max(0, from));
        if (open & 1 /* Open.From */ ) {
            let prev = target.pop();
            let joined = $6295c6875f57e3ee$var$appendText(text.text, prev.text.slice(), 0, text.length);
            if (joined.length <= 32 /* Tree.Branch */ ) target.push(new $6295c6875f57e3ee$var$TextLeaf(joined, prev.length + text.length));
            else {
                let mid = joined.length >> 1;
                target.push(new $6295c6875f57e3ee$var$TextLeaf(joined.slice(0, mid)), new $6295c6875f57e3ee$var$TextLeaf(joined.slice(mid)));
            }
        } else target.push(text);
    }
    replace(from, to, text) {
        if (!(text instanceof $6295c6875f57e3ee$var$TextLeaf)) return super.replace(from, to, text);
        [from, to] = $6295c6875f57e3ee$var$clip(this, from, to);
        let lines = $6295c6875f57e3ee$var$appendText(this.text, $6295c6875f57e3ee$var$appendText(text.text, $6295c6875f57e3ee$var$sliceText(this.text, 0, from)), to);
        let newLen = this.length + text.length - (to - from);
        if (lines.length <= 32 /* Tree.Branch */ ) return new $6295c6875f57e3ee$var$TextLeaf(lines, newLen);
        return $6295c6875f57e3ee$var$TextNode.from($6295c6875f57e3ee$var$TextLeaf.split(lines, []), newLen);
    }
    sliceString(from, to = this.length, lineSep = "\n") {
        [from, to] = $6295c6875f57e3ee$var$clip(this, from, to);
        let result = "";
        for(let pos = 0, i = 0; pos <= to && i < this.text.length; i++){
            let line = this.text[i], end = pos + line.length;
            if (pos > from && i) result += lineSep;
            if (from < end && to > pos) result += line.slice(Math.max(0, from - pos), to - pos);
            pos = end + 1;
        }
        return result;
    }
    flatten(target) {
        for (let line of this.text)target.push(line);
    }
    scanIdentical() {
        return 0;
    }
    static split(text, target) {
        let part = [], len = -1;
        for (let line of text){
            part.push(line);
            len += line.length + 1;
            if (part.length == 32 /* Tree.Branch */ ) {
                target.push(new $6295c6875f57e3ee$var$TextLeaf(part, len));
                part = [];
                len = -1;
            }
        }
        if (len > -1) target.push(new $6295c6875f57e3ee$var$TextLeaf(part, len));
        return target;
    }
}
// Nodes provide the tree structure of the `Text` type. They store a
// number of other nodes or leaves, taking care to balance themselves
// on changes. There are implied line breaks _between_ the children of
// a node (but not before the first or after the last child).
class $6295c6875f57e3ee$var$TextNode extends $6295c6875f57e3ee$export$5f1af8db9871e1d6 {
    constructor(children, length){
        super();
        this.children = children;
        this.length = length;
        this.lines = 0;
        for (let child of children)this.lines += child.lines;
    }
    lineInner(target, isLine, line, offset) {
        for(let i = 0;; i++){
            let child = this.children[i], end = offset + child.length, endLine = line + child.lines - 1;
            if ((isLine ? endLine : end) >= target) return child.lineInner(target, isLine, line, offset);
            offset = end + 1;
            line = endLine + 1;
        }
    }
    decompose(from, to, target, open) {
        for(let i = 0, pos = 0; pos <= to && i < this.children.length; i++){
            let child = this.children[i], end = pos + child.length;
            if (from <= end && to >= pos) {
                let childOpen = open & ((pos <= from ? 1 /* Open.From */  : 0) | (end >= to ? 2 /* Open.To */  : 0));
                if (pos >= from && end <= to && !childOpen) target.push(child);
                else child.decompose(from - pos, to - pos, target, childOpen);
            }
            pos = end + 1;
        }
    }
    replace(from, to, text) {
        [from, to] = $6295c6875f57e3ee$var$clip(this, from, to);
        if (text.lines < this.lines) for(let i = 0, pos = 0; i < this.children.length; i++){
            let child = this.children[i], end = pos + child.length;
            // Fast path: if the change only affects one child and the
            // child's size remains in the acceptable range, only update
            // that child
            if (from >= pos && to <= end) {
                let updated = child.replace(from - pos, to - pos, text);
                let totalLines = this.lines - child.lines + updated.lines;
                if (updated.lines < totalLines >> 4 && updated.lines > totalLines >> 6) {
                    let copy = this.children.slice();
                    copy[i] = updated;
                    return new $6295c6875f57e3ee$var$TextNode(copy, this.length - (to - from) + text.length);
                }
                return super.replace(pos, end, updated);
            }
            pos = end + 1;
        }
        return super.replace(from, to, text);
    }
    sliceString(from, to = this.length, lineSep = "\n") {
        [from, to] = $6295c6875f57e3ee$var$clip(this, from, to);
        let result = "";
        for(let i = 0, pos = 0; i < this.children.length && pos <= to; i++){
            let child = this.children[i], end = pos + child.length;
            if (pos > from && i) result += lineSep;
            if (from < end && to > pos) result += child.sliceString(from - pos, to - pos, lineSep);
            pos = end + 1;
        }
        return result;
    }
    flatten(target) {
        for (let child of this.children)child.flatten(target);
    }
    scanIdentical(other, dir) {
        if (!(other instanceof $6295c6875f57e3ee$var$TextNode)) return 0;
        let length = 0;
        let [iA, iB, eA, eB] = dir > 0 ? [
            0,
            0,
            this.children.length,
            other.children.length
        ] : [
            this.children.length - 1,
            other.children.length - 1,
            -1,
            -1
        ];
        for(;; iA += dir, iB += dir){
            if (iA == eA || iB == eB) return length;
            let chA = this.children[iA], chB = other.children[iB];
            if (chA != chB) return length + chA.scanIdentical(chB, dir);
            length += chA.length + 1;
        }
    }
    static from(children, length = children.reduce((l, ch)=>l + ch.length + 1, -1)) {
        let lines = 0;
        for (let ch of children)lines += ch.lines;
        if (lines < 32 /* Tree.Branch */ ) {
            let flat = [];
            for (let ch of children)ch.flatten(flat);
            return new $6295c6875f57e3ee$var$TextLeaf(flat, length);
        }
        let chunk = Math.max(32 /* Tree.Branch */ , lines >> 5 /* Tree.BranchShift */ ), maxChunk = chunk << 1, minChunk = chunk >> 1;
        let chunked = [], currentLines = 0, currentLen = -1, currentChunk = [];
        function add(child) {
            let last;
            if (child.lines > maxChunk && child instanceof $6295c6875f57e3ee$var$TextNode) for (let node of child.children)add(node);
            else if (child.lines > minChunk && (currentLines > minChunk || !currentLines)) {
                flush();
                chunked.push(child);
            } else if (child instanceof $6295c6875f57e3ee$var$TextLeaf && currentLines && (last = currentChunk[currentChunk.length - 1]) instanceof $6295c6875f57e3ee$var$TextLeaf && child.lines + last.lines <= 32 /* Tree.Branch */ ) {
                currentLines += child.lines;
                currentLen += child.length + 1;
                currentChunk[currentChunk.length - 1] = new $6295c6875f57e3ee$var$TextLeaf(last.text.concat(child.text), last.length + 1 + child.length);
            } else {
                if (currentLines + child.lines > chunk) flush();
                currentLines += child.lines;
                currentLen += child.length + 1;
                currentChunk.push(child);
            }
        }
        function flush() {
            if (currentLines == 0) return;
            chunked.push(currentChunk.length == 1 ? currentChunk[0] : $6295c6875f57e3ee$var$TextNode.from(currentChunk, currentLen));
            currentLen = -1;
            currentLines = currentChunk.length = 0;
        }
        for (let child of children)add(child);
        flush();
        return chunked.length == 1 ? chunked[0] : new $6295c6875f57e3ee$var$TextNode(chunked, length);
    }
}
$6295c6875f57e3ee$export$5f1af8db9871e1d6.empty = /*@__PURE__*/ new $6295c6875f57e3ee$var$TextLeaf([
    ""
], 0);
function $6295c6875f57e3ee$var$textLength(text) {
    let length = -1;
    for (let line of text)length += line.length + 1;
    return length;
}
function $6295c6875f57e3ee$var$appendText(text, target, from = 0, to = 1e9) {
    for(let pos = 0, i = 0, first = true; i < text.length && pos <= to; i++){
        let line = text[i], end = pos + line.length;
        if (end >= from) {
            if (end > to) line = line.slice(0, to - pos);
            if (pos < from) line = line.slice(from - pos);
            if (first) {
                target[target.length - 1] += line;
                first = false;
            } else target.push(line);
        }
        pos = end + 1;
    }
    return target;
}
function $6295c6875f57e3ee$var$sliceText(text, from, to) {
    return $6295c6875f57e3ee$var$appendText(text, [
        ""
    ], from, to);
}
class $6295c6875f57e3ee$var$RawTextCursor {
    constructor(text, dir = 1){
        this.dir = dir;
        this.done = false;
        this.lineBreak = false;
        this.value = "";
        this.nodes = [
            text
        ];
        this.offsets = [
            dir > 0 ? 1 : (text instanceof $6295c6875f57e3ee$var$TextLeaf ? text.text.length : text.children.length) << 1
        ];
    }
    nextInner(skip, dir) {
        this.done = this.lineBreak = false;
        for(;;){
            let last = this.nodes.length - 1;
            let top = this.nodes[last], offsetValue = this.offsets[last], offset = offsetValue >> 1;
            let size = top instanceof $6295c6875f57e3ee$var$TextLeaf ? top.text.length : top.children.length;
            if (offset == (dir > 0 ? size : 0)) {
                if (last == 0) {
                    this.done = true;
                    this.value = "";
                    return this;
                }
                if (dir > 0) this.offsets[last - 1]++;
                this.nodes.pop();
                this.offsets.pop();
            } else if ((offsetValue & 1) == (dir > 0 ? 0 : 1)) {
                this.offsets[last] += dir;
                if (skip == 0) {
                    this.lineBreak = true;
                    this.value = "\n";
                    return this;
                }
                skip--;
            } else if (top instanceof $6295c6875f57e3ee$var$TextLeaf) {
                // Move to the next string
                let next = top.text[offset + (dir < 0 ? -1 : 0)];
                this.offsets[last] += dir;
                if (next.length > Math.max(0, skip)) {
                    this.value = skip == 0 ? next : dir > 0 ? next.slice(skip) : next.slice(0, next.length - skip);
                    return this;
                }
                skip -= next.length;
            } else {
                let next = top.children[offset + (dir < 0 ? -1 : 0)];
                if (skip > next.length) {
                    skip -= next.length;
                    this.offsets[last] += dir;
                } else {
                    if (dir < 0) this.offsets[last]--;
                    this.nodes.push(next);
                    this.offsets.push(dir > 0 ? 1 : (next instanceof $6295c6875f57e3ee$var$TextLeaf ? next.text.length : next.children.length) << 1);
                }
            }
        }
    }
    next(skip = 0) {
        if (skip < 0) {
            this.nextInner(-skip, -this.dir);
            skip = this.value.length;
        }
        return this.nextInner(skip, this.dir);
    }
}
class $6295c6875f57e3ee$var$PartialTextCursor {
    constructor(text, start, end){
        this.value = "";
        this.done = false;
        this.cursor = new $6295c6875f57e3ee$var$RawTextCursor(text, start > end ? -1 : 1);
        this.pos = start > end ? text.length : 0;
        this.from = Math.min(start, end);
        this.to = Math.max(start, end);
    }
    nextInner(skip, dir) {
        if (dir < 0 ? this.pos <= this.from : this.pos >= this.to) {
            this.value = "";
            this.done = true;
            return this;
        }
        skip += Math.max(0, dir < 0 ? this.pos - this.to : this.from - this.pos);
        let limit = dir < 0 ? this.pos - this.from : this.to - this.pos;
        if (skip > limit) skip = limit;
        limit -= skip;
        let { value: value } = this.cursor.next(skip);
        this.pos += (value.length + skip) * dir;
        this.value = value.length <= limit ? value : dir < 0 ? value.slice(value.length - limit) : value.slice(0, limit);
        this.done = !this.value;
        return this;
    }
    next(skip = 0) {
        if (skip < 0) skip = Math.max(skip, this.from - this.pos);
        else if (skip > 0) skip = Math.min(skip, this.to - this.pos);
        return this.nextInner(skip, this.cursor.dir);
    }
    get lineBreak() {
        return this.cursor.lineBreak && this.value != "";
    }
}
class $6295c6875f57e3ee$var$LineCursor {
    constructor(inner){
        this.inner = inner;
        this.afterBreak = true;
        this.value = "";
        this.done = false;
    }
    next(skip = 0) {
        let { done: done, lineBreak: lineBreak, value: value } = this.inner.next(skip);
        if (done && this.afterBreak) {
            this.value = "";
            this.afterBreak = false;
        } else if (done) {
            this.done = true;
            this.value = "";
        } else if (lineBreak) {
            if (this.afterBreak) this.value = "";
            else {
                this.afterBreak = true;
                this.next();
            }
        } else {
            this.value = value;
            this.afterBreak = false;
        }
        return this;
    }
    get lineBreak() {
        return false;
    }
}
if (typeof Symbol != "undefined") {
    $6295c6875f57e3ee$export$5f1af8db9871e1d6.prototype[Symbol.iterator] = function() {
        return this.iter();
    };
    $6295c6875f57e3ee$var$RawTextCursor.prototype[Symbol.iterator] = $6295c6875f57e3ee$var$PartialTextCursor.prototype[Symbol.iterator] = $6295c6875f57e3ee$var$LineCursor.prototype[Symbol.iterator] = function() {
        return this;
    };
}
/**
This type describes a line in the document. It is created
on-demand when lines are [queried](https://codemirror.net/6/docs/ref/#state.Text.lineAt).
*/ class $6295c6875f57e3ee$export$17d680238e50603e {
    /**
    @internal
    */ constructor(/**
    The position of the start of the line.
    */ from, /**
    The position at the end of the line (_before_ the line break,
    or at the end of document for the last line).
    */ to, /**
    This line's line number (1-based).
    */ number, /**
    The line's content.
    */ text){
        this.from = from;
        this.to = to;
        this.number = number;
        this.text = text;
    }
    /**
    The length of the line (not including any line break after it).
    */ get length() {
        return this.to - this.from;
    }
}
function $6295c6875f57e3ee$var$clip(text, from, to) {
    from = Math.max(0, Math.min(text.length, from));
    return [
        from,
        Math.max(from, Math.min(text.length, to))
    ];
}
/**
Returns a next grapheme cluster break _after_ (not equal to)
`pos`, if `forward` is true, or before otherwise. Returns `pos`
itself if no further cluster break is available in the string.
Moves across surrogate pairs, extending characters (when
`includeExtending` is true), characters joined with zero-width
joiners, and flag emoji.
*/ function $6295c6875f57e3ee$export$a0fa439fd515e1ed(str, pos, forward = true, includeExtending = true) {
    return (0, $08c4544bca527ef0$export$a0fa439fd515e1ed)(str, pos, forward, includeExtending);
}
function $6295c6875f57e3ee$var$surrogateLow(ch) {
    return ch >= 0xDC00 && ch < 0xE000;
}
function $6295c6875f57e3ee$var$surrogateHigh(ch) {
    return ch >= 0xD800 && ch < 0xDC00;
}
/**
Find the code point at the given position in a string (like the
[`codePointAt`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/codePointAt)
string method).
*/ function $6295c6875f57e3ee$export$42977f40461e1360(str, pos) {
    let code0 = str.charCodeAt(pos);
    if (!$6295c6875f57e3ee$var$surrogateHigh(code0) || pos + 1 == str.length) return code0;
    let code1 = str.charCodeAt(pos + 1);
    if (!$6295c6875f57e3ee$var$surrogateLow(code1)) return code0;
    return (code0 - 0xd800 << 10) + (code1 - 0xdc00) + 0x10000;
}
/**
Given a Unicode codepoint, return the JavaScript string that
respresents it (like
[`String.fromCodePoint`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/fromCodePoint)).
*/ function $6295c6875f57e3ee$export$73bfc63873071f74(code) {
    if (code <= 0xffff) return String.fromCharCode(code);
    code -= 0x10000;
    return String.fromCharCode((code >> 10) + 0xd800, (code & 1023) + 0xdc00);
}
/**
The amount of positions a character takes up in a JavaScript string.
*/ function $6295c6875f57e3ee$export$a870abf234f6353c(code) {
    return code < 0x10000 ? 1 : 2;
}
const $6295c6875f57e3ee$var$DefaultSplit = /\r\n?|\n/;
/**
Distinguishes different ways in which positions can be mapped.
*/ var $6295c6875f57e3ee$export$39cf3280165f92aa = /*@__PURE__*/ function(MapMode) {
    /**
    Map a position to a valid new position, even when its context
    was deleted.
    */ MapMode[MapMode["Simple"] = 0] = "Simple";
    /**
    Return null if deletion happens across the position.
    */ MapMode[MapMode["TrackDel"] = 1] = "TrackDel";
    /**
    Return null if the character _before_ the position is deleted.
    */ MapMode[MapMode["TrackBefore"] = 2] = "TrackBefore";
    /**
    Return null if the character _after_ the position is deleted.
    */ MapMode[MapMode["TrackAfter"] = 3] = "TrackAfter";
    return MapMode;
}($6295c6875f57e3ee$export$39cf3280165f92aa || ($6295c6875f57e3ee$export$39cf3280165f92aa = {}));
/**
A change description is a variant of [change set](https://codemirror.net/6/docs/ref/#state.ChangeSet)
that doesn't store the inserted text. As such, it can't be
applied, but is cheaper to store and manipulate.
*/ class $6295c6875f57e3ee$export$34b6a936f2bb06a2 {
    // Sections are encoded as pairs of integers. The first is the
    // length in the current document, and the second is -1 for
    // unaffected sections, and the length of the replacement content
    // otherwise. So an insertion would be (0, n>0), a deletion (n>0,
    // 0), and a replacement two positive numbers.
    /**
    @internal
    */ constructor(/**
    @internal
    */ sections){
        this.sections = sections;
    }
    /**
    The length of the document before the change.
    */ get length() {
        let result = 0;
        for(let i = 0; i < this.sections.length; i += 2)result += this.sections[i];
        return result;
    }
    /**
    The length of the document after the change.
    */ get newLength() {
        let result = 0;
        for(let i = 0; i < this.sections.length; i += 2){
            let ins = this.sections[i + 1];
            result += ins < 0 ? this.sections[i] : ins;
        }
        return result;
    }
    /**
    False when there are actual changes in this set.
    */ get empty() {
        return this.sections.length == 0 || this.sections.length == 2 && this.sections[1] < 0;
    }
    /**
    Iterate over the unchanged parts left by these changes. `posA`
    provides the position of the range in the old document, `posB`
    the new position in the changed document.
    */ iterGaps(f) {
        for(let i = 0, posA = 0, posB = 0; i < this.sections.length;){
            let len = this.sections[i++], ins = this.sections[i++];
            if (ins < 0) {
                f(posA, posB, len);
                posB += len;
            } else posB += ins;
            posA += len;
        }
    }
    /**
    Iterate over the ranges changed by these changes. (See
    [`ChangeSet.iterChanges`](https://codemirror.net/6/docs/ref/#state.ChangeSet.iterChanges) for a
    variant that also provides you with the inserted text.)
    `fromA`/`toA` provides the extent of the change in the starting
    document, `fromB`/`toB` the extent of the replacement in the
    changed document.
    
    When `individual` is true, adjacent changes (which are kept
    separate for [position mapping](https://codemirror.net/6/docs/ref/#state.ChangeDesc.mapPos)) are
    reported separately.
    */ iterChangedRanges(f, individual = false) {
        $6295c6875f57e3ee$var$iterChanges(this, f, individual);
    }
    /**
    Get a description of the inverted form of these changes.
    */ get invertedDesc() {
        let sections = [];
        for(let i = 0; i < this.sections.length;){
            let len = this.sections[i++], ins = this.sections[i++];
            if (ins < 0) sections.push(len, ins);
            else sections.push(ins, len);
        }
        return new $6295c6875f57e3ee$export$34b6a936f2bb06a2(sections);
    }
    /**
    Compute the combined effect of applying another set of changes
    after this one. The length of the document after this set should
    match the length before `other`.
    */ composeDesc(other) {
        return this.empty ? other : other.empty ? this : $6295c6875f57e3ee$var$composeSets(this, other);
    }
    /**
    Map this description, which should start with the same document
    as `other`, over another set of changes, so that it can be
    applied after it. When `before` is true, map as if the changes
    in `this` happened before the ones in `other`.
    */ mapDesc(other, before = false) {
        return other.empty ? this : $6295c6875f57e3ee$var$mapSet(this, other, before);
    }
    mapPos(pos, assoc = -1, mode = $6295c6875f57e3ee$export$39cf3280165f92aa.Simple) {
        let posA = 0, posB = 0;
        for(let i = 0; i < this.sections.length;){
            let len = this.sections[i++], ins = this.sections[i++], endA = posA + len;
            if (ins < 0) {
                if (endA > pos) return posB + (pos - posA);
                posB += len;
            } else {
                if (mode != $6295c6875f57e3ee$export$39cf3280165f92aa.Simple && endA >= pos && (mode == $6295c6875f57e3ee$export$39cf3280165f92aa.TrackDel && posA < pos && endA > pos || mode == $6295c6875f57e3ee$export$39cf3280165f92aa.TrackBefore && posA < pos || mode == $6295c6875f57e3ee$export$39cf3280165f92aa.TrackAfter && endA > pos)) return null;
                if (endA > pos || endA == pos && assoc < 0 && !len) return pos == posA || assoc < 0 ? posB : posB + ins;
                posB += ins;
            }
            posA = endA;
        }
        if (pos > posA) throw new RangeError(`Position ${pos} is out of range for changeset of length ${posA}`);
        return posB;
    }
    /**
    Check whether these changes touch a given range. When one of the
    changes entirely covers the range, the string `"cover"` is
    returned.
    */ touchesRange(from, to = from) {
        for(let i = 0, pos = 0; i < this.sections.length && pos <= to;){
            let len = this.sections[i++], ins = this.sections[i++], end = pos + len;
            if (ins >= 0 && pos <= to && end >= from) return pos < from && end > to ? "cover" : true;
            pos = end;
        }
        return false;
    }
    /**
    @internal
    */ toString() {
        let result = "";
        for(let i = 0; i < this.sections.length;){
            let len = this.sections[i++], ins = this.sections[i++];
            result += (result ? " " : "") + len + (ins >= 0 ? ":" + ins : "");
        }
        return result;
    }
    /**
    Serialize this change desc to a JSON-representable value.
    */ toJSON() {
        return this.sections;
    }
    /**
    Create a change desc from its JSON representation (as produced
    by [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeDesc.toJSON).
    */ static fromJSON(json) {
        if (!Array.isArray(json) || json.length % 2 || json.some((a)=>typeof a != "number")) throw new RangeError("Invalid JSON representation of ChangeDesc");
        return new $6295c6875f57e3ee$export$34b6a936f2bb06a2(json);
    }
    /**
    @internal
    */ static create(sections) {
        return new $6295c6875f57e3ee$export$34b6a936f2bb06a2(sections);
    }
}
/**
A change set represents a group of modifications to a document. It
stores the document length, and can only be applied to documents
with exactly that length.
*/ class $6295c6875f57e3ee$export$29d7fbdcb1f8b71c extends $6295c6875f57e3ee$export$34b6a936f2bb06a2 {
    constructor(sections, /**
    @internal
    */ inserted){
        super(sections);
        this.inserted = inserted;
    }
    /**
    Apply the changes to a document, returning the modified
    document.
    */ apply(doc) {
        if (this.length != doc.length) throw new RangeError("Applying change set to a document with the wrong length");
        $6295c6875f57e3ee$var$iterChanges(this, (fromA, toA, fromB, _toB, text)=>doc = doc.replace(fromB, fromB + (toA - fromA), text), false);
        return doc;
    }
    mapDesc(other, before = false) {
        return $6295c6875f57e3ee$var$mapSet(this, other, before, true);
    }
    /**
    Given the document as it existed _before_ the changes, return a
    change set that represents the inverse of this set, which could
    be used to go from the document created by the changes back to
    the document as it existed before the changes.
    */ invert(doc) {
        let sections = this.sections.slice(), inserted = [];
        for(let i = 0, pos = 0; i < sections.length; i += 2){
            let len = sections[i], ins = sections[i + 1];
            if (ins >= 0) {
                sections[i] = ins;
                sections[i + 1] = len;
                let index = i >> 1;
                while(inserted.length < index)inserted.push($6295c6875f57e3ee$export$5f1af8db9871e1d6.empty);
                inserted.push(len ? doc.slice(pos, pos + len) : $6295c6875f57e3ee$export$5f1af8db9871e1d6.empty);
            }
            pos += len;
        }
        return new $6295c6875f57e3ee$export$29d7fbdcb1f8b71c(sections, inserted);
    }
    /**
    Combine two subsequent change sets into a single set. `other`
    must start in the document produced by `this`. If `this` goes
    `docA` → `docB` and `other` represents `docB` → `docC`, the
    returned value will represent the change `docA` → `docC`.
    */ compose(other) {
        return this.empty ? other : other.empty ? this : $6295c6875f57e3ee$var$composeSets(this, other, true);
    }
    /**
    Given another change set starting in the same document, maps this
    change set over the other, producing a new change set that can be
    applied to the document produced by applying `other`. When
    `before` is `true`, order changes as if `this` comes before
    `other`, otherwise (the default) treat `other` as coming first.
    
    Given two changes `A` and `B`, `A.compose(B.map(A))` and
    `B.compose(A.map(B, true))` will produce the same document. This
    provides a basic form of [operational
    transformation](https://en.wikipedia.org/wiki/Operational_transformation),
    and can be used for collaborative editing.
    */ map(other, before = false) {
        return other.empty ? this : $6295c6875f57e3ee$var$mapSet(this, other, before, true);
    }
    /**
    Iterate over the changed ranges in the document, calling `f` for
    each, with the range in the original document (`fromA`-`toA`)
    and the range that replaces it in the new document
    (`fromB`-`toB`).
    
    When `individual` is true, adjacent changes are reported
    separately.
    */ iterChanges(f, individual = false) {
        $6295c6875f57e3ee$var$iterChanges(this, f, individual);
    }
    /**
    Get a [change description](https://codemirror.net/6/docs/ref/#state.ChangeDesc) for this change
    set.
    */ get desc() {
        return $6295c6875f57e3ee$export$34b6a936f2bb06a2.create(this.sections);
    }
    /**
    @internal
    */ filter(ranges) {
        let resultSections = [], resultInserted = [], filteredSections = [];
        let iter = new $6295c6875f57e3ee$var$SectionIter(this);
        done: for(let i = 0, pos = 0;;){
            let next = i == ranges.length ? 1e9 : ranges[i++];
            while(pos < next || pos == next && iter.len == 0){
                if (iter.done) break done;
                let len = Math.min(iter.len, next - pos);
                $6295c6875f57e3ee$var$addSection(filteredSections, len, -1);
                let ins = iter.ins == -1 ? -1 : iter.off == 0 ? iter.ins : 0;
                $6295c6875f57e3ee$var$addSection(resultSections, len, ins);
                if (ins > 0) $6295c6875f57e3ee$var$addInsert(resultInserted, resultSections, iter.text);
                iter.forward(len);
                pos += len;
            }
            let end = ranges[i++];
            while(pos < end){
                if (iter.done) break done;
                let len = Math.min(iter.len, end - pos);
                $6295c6875f57e3ee$var$addSection(resultSections, len, -1);
                $6295c6875f57e3ee$var$addSection(filteredSections, len, iter.ins == -1 ? -1 : iter.off == 0 ? iter.ins : 0);
                iter.forward(len);
                pos += len;
            }
        }
        return {
            changes: new $6295c6875f57e3ee$export$29d7fbdcb1f8b71c(resultSections, resultInserted),
            filtered: $6295c6875f57e3ee$export$34b6a936f2bb06a2.create(filteredSections)
        };
    }
    /**
    Serialize this change set to a JSON-representable value.
    */ toJSON() {
        let parts = [];
        for(let i = 0; i < this.sections.length; i += 2){
            let len = this.sections[i], ins = this.sections[i + 1];
            if (ins < 0) parts.push(len);
            else if (ins == 0) parts.push([
                len
            ]);
            else parts.push([
                len
            ].concat(this.inserted[i >> 1].toJSON()));
        }
        return parts;
    }
    /**
    Create a change set for the given changes, for a document of the
    given length, using `lineSep` as line separator.
    */ static of(changes, length, lineSep) {
        let sections = [], inserted = [], pos = 0;
        let total = null;
        function flush(force = false) {
            if (!force && !sections.length) return;
            if (pos < length) $6295c6875f57e3ee$var$addSection(sections, length - pos, -1);
            let set = new $6295c6875f57e3ee$export$29d7fbdcb1f8b71c(sections, inserted);
            total = total ? total.compose(set.map(total)) : set;
            sections = [];
            inserted = [];
            pos = 0;
        }
        function process(spec) {
            if (Array.isArray(spec)) for (let sub of spec)process(sub);
            else if (spec instanceof $6295c6875f57e3ee$export$29d7fbdcb1f8b71c) {
                if (spec.length != length) throw new RangeError(`Mismatched change set length (got ${spec.length}, expected ${length})`);
                flush();
                total = total ? total.compose(spec.map(total)) : spec;
            } else {
                let { from: from, to: to = from, insert: insert } = spec;
                if (from > to || from < 0 || to > length) throw new RangeError(`Invalid change range ${from} to ${to} (in doc of length ${length})`);
                let insText = !insert ? $6295c6875f57e3ee$export$5f1af8db9871e1d6.empty : typeof insert == "string" ? $6295c6875f57e3ee$export$5f1af8db9871e1d6.of(insert.split(lineSep || $6295c6875f57e3ee$var$DefaultSplit)) : insert;
                let insLen = insText.length;
                if (from == to && insLen == 0) return;
                if (from < pos) flush();
                if (from > pos) $6295c6875f57e3ee$var$addSection(sections, from - pos, -1);
                $6295c6875f57e3ee$var$addSection(sections, to - from, insLen);
                $6295c6875f57e3ee$var$addInsert(inserted, sections, insText);
                pos = to;
            }
        }
        process(changes);
        flush(!total);
        return total;
    }
    /**
    Create an empty changeset of the given length.
    */ static empty(length) {
        return new $6295c6875f57e3ee$export$29d7fbdcb1f8b71c(length ? [
            length,
            -1
        ] : [], []);
    }
    /**
    Create a changeset from its JSON representation (as produced by
    [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeSet.toJSON).
    */ static fromJSON(json) {
        if (!Array.isArray(json)) throw new RangeError("Invalid JSON representation of ChangeSet");
        let sections = [], inserted = [];
        for(let i = 0; i < json.length; i++){
            let part = json[i];
            if (typeof part == "number") sections.push(part, -1);
            else if (!Array.isArray(part) || typeof part[0] != "number" || part.some((e, i)=>i && typeof e != "string")) throw new RangeError("Invalid JSON representation of ChangeSet");
            else if (part.length == 1) sections.push(part[0], 0);
            else {
                while(inserted.length < i)inserted.push($6295c6875f57e3ee$export$5f1af8db9871e1d6.empty);
                inserted[i] = $6295c6875f57e3ee$export$5f1af8db9871e1d6.of(part.slice(1));
                sections.push(part[0], inserted[i].length);
            }
        }
        return new $6295c6875f57e3ee$export$29d7fbdcb1f8b71c(sections, inserted);
    }
    /**
    @internal
    */ static createSet(sections, inserted) {
        return new $6295c6875f57e3ee$export$29d7fbdcb1f8b71c(sections, inserted);
    }
}
function $6295c6875f57e3ee$var$addSection(sections, len, ins, forceJoin = false) {
    if (len == 0 && ins <= 0) return;
    let last = sections.length - 2;
    if (last >= 0 && ins <= 0 && ins == sections[last + 1]) sections[last] += len;
    else if (last >= 0 && len == 0 && sections[last] == 0) sections[last + 1] += ins;
    else if (forceJoin) {
        sections[last] += len;
        sections[last + 1] += ins;
    } else sections.push(len, ins);
}
function $6295c6875f57e3ee$var$addInsert(values, sections, value) {
    if (value.length == 0) return;
    let index = sections.length - 2 >> 1;
    if (index < values.length) values[values.length - 1] = values[values.length - 1].append(value);
    else {
        while(values.length < index)values.push($6295c6875f57e3ee$export$5f1af8db9871e1d6.empty);
        values.push(value);
    }
}
function $6295c6875f57e3ee$var$iterChanges(desc, f, individual) {
    let inserted = desc.inserted;
    for(let posA = 0, posB = 0, i = 0; i < desc.sections.length;){
        let len = desc.sections[i++], ins = desc.sections[i++];
        if (ins < 0) {
            posA += len;
            posB += len;
        } else {
            let endA = posA, endB = posB, text = $6295c6875f57e3ee$export$5f1af8db9871e1d6.empty;
            for(;;){
                endA += len;
                endB += ins;
                if (ins && inserted) text = text.append(inserted[i - 2 >> 1]);
                if (individual || i == desc.sections.length || desc.sections[i + 1] < 0) break;
                len = desc.sections[i++];
                ins = desc.sections[i++];
            }
            f(posA, endA, posB, endB, text);
            posA = endA;
            posB = endB;
        }
    }
}
function $6295c6875f57e3ee$var$mapSet(setA, setB, before, mkSet = false) {
    // Produce a copy of setA that applies to the document after setB
    // has been applied (assuming both start at the same document).
    let sections = [], insert = mkSet ? [] : null;
    let a = new $6295c6875f57e3ee$var$SectionIter(setA), b = new $6295c6875f57e3ee$var$SectionIter(setB);
    // Iterate over both sets in parallel. inserted tracks, for changes
    // in A that have to be processed piece-by-piece, whether their
    // content has been inserted already, and refers to the section
    // index.
    for(let inserted = -1;;){
        if (a.done && b.len || b.done && a.len) throw new Error("Mismatched change set lengths");
        else if (a.ins == -1 && b.ins == -1) {
            // Move across ranges skipped by both sets.
            let len = Math.min(a.len, b.len);
            $6295c6875f57e3ee$var$addSection(sections, len, -1);
            a.forward(len);
            b.forward(len);
        } else if (b.ins >= 0 && (a.ins < 0 || inserted == a.i || a.off == 0 && (b.len < a.len || b.len == a.len && !before))) {
            // If there's a change in B that comes before the next change in
            // A (ordered by start pos, then len, then before flag), skip
            // that (and process any changes in A it covers).
            let len = b.len;
            $6295c6875f57e3ee$var$addSection(sections, b.ins, -1);
            while(len){
                let piece = Math.min(a.len, len);
                if (a.ins >= 0 && inserted < a.i && a.len <= piece) {
                    $6295c6875f57e3ee$var$addSection(sections, 0, a.ins);
                    if (insert) $6295c6875f57e3ee$var$addInsert(insert, sections, a.text);
                    inserted = a.i;
                }
                a.forward(piece);
                len -= piece;
            }
            b.next();
        } else if (a.ins >= 0) {
            // Process the part of a change in A up to the start of the next
            // non-deletion change in B (if overlapping).
            let len = 0, left = a.len;
            while(left){
                if (b.ins == -1) {
                    let piece = Math.min(left, b.len);
                    len += piece;
                    left -= piece;
                    b.forward(piece);
                } else if (b.ins == 0 && b.len < left) {
                    left -= b.len;
                    b.next();
                } else break;
            }
            $6295c6875f57e3ee$var$addSection(sections, len, inserted < a.i ? a.ins : 0);
            if (insert && inserted < a.i) $6295c6875f57e3ee$var$addInsert(insert, sections, a.text);
            inserted = a.i;
            a.forward(a.len - left);
        } else if (a.done && b.done) return insert ? $6295c6875f57e3ee$export$29d7fbdcb1f8b71c.createSet(sections, insert) : $6295c6875f57e3ee$export$34b6a936f2bb06a2.create(sections);
        else throw new Error("Mismatched change set lengths");
    }
}
function $6295c6875f57e3ee$var$composeSets(setA, setB, mkSet = false) {
    let sections = [];
    let insert = mkSet ? [] : null;
    let a = new $6295c6875f57e3ee$var$SectionIter(setA), b = new $6295c6875f57e3ee$var$SectionIter(setB);
    for(let open = false;;){
        if (a.done && b.done) return insert ? $6295c6875f57e3ee$export$29d7fbdcb1f8b71c.createSet(sections, insert) : $6295c6875f57e3ee$export$34b6a936f2bb06a2.create(sections);
        else if (a.ins == 0) {
            $6295c6875f57e3ee$var$addSection(sections, a.len, 0, open);
            a.next();
        } else if (b.len == 0 && !b.done) {
            $6295c6875f57e3ee$var$addSection(sections, 0, b.ins, open);
            if (insert) $6295c6875f57e3ee$var$addInsert(insert, sections, b.text);
            b.next();
        } else if (a.done || b.done) throw new Error("Mismatched change set lengths");
        else {
            let len = Math.min(a.len2, b.len), sectionLen = sections.length;
            if (a.ins == -1) {
                let insB = b.ins == -1 ? -1 : b.off ? 0 : b.ins;
                $6295c6875f57e3ee$var$addSection(sections, len, insB, open);
                if (insert && insB) $6295c6875f57e3ee$var$addInsert(insert, sections, b.text);
            } else if (b.ins == -1) {
                $6295c6875f57e3ee$var$addSection(sections, a.off ? 0 : a.len, len, open);
                if (insert) $6295c6875f57e3ee$var$addInsert(insert, sections, a.textBit(len));
            } else {
                $6295c6875f57e3ee$var$addSection(sections, a.off ? 0 : a.len, b.off ? 0 : b.ins, open);
                if (insert && !b.off) $6295c6875f57e3ee$var$addInsert(insert, sections, b.text);
            }
            open = (a.ins > len || b.ins >= 0 && b.len > len) && (open || sections.length > sectionLen);
            a.forward2(len);
            b.forward(len);
        }
    }
}
class $6295c6875f57e3ee$var$SectionIter {
    constructor(set){
        this.set = set;
        this.i = 0;
        this.next();
    }
    next() {
        let { sections: sections } = this.set;
        if (this.i < sections.length) {
            this.len = sections[this.i++];
            this.ins = sections[this.i++];
        } else {
            this.len = 0;
            this.ins = -2;
        }
        this.off = 0;
    }
    get done() {
        return this.ins == -2;
    }
    get len2() {
        return this.ins < 0 ? this.len : this.ins;
    }
    get text() {
        let { inserted: inserted } = this.set, index = this.i - 2 >> 1;
        return index >= inserted.length ? $6295c6875f57e3ee$export$5f1af8db9871e1d6.empty : inserted[index];
    }
    textBit(len) {
        let { inserted: inserted } = this.set, index = this.i - 2 >> 1;
        return index >= inserted.length && !len ? $6295c6875f57e3ee$export$5f1af8db9871e1d6.empty : inserted[index].slice(this.off, len == null ? undefined : this.off + len);
    }
    forward(len) {
        if (len == this.len) this.next();
        else {
            this.len -= len;
            this.off += len;
        }
    }
    forward2(len) {
        if (this.ins == -1) this.forward(len);
        else if (len == this.ins) this.next();
        else {
            this.ins -= len;
            this.off += len;
        }
    }
}
/**
A single selection range. When
[`allowMultipleSelections`](https://codemirror.net/6/docs/ref/#state.EditorState^allowMultipleSelections)
is enabled, a [selection](https://codemirror.net/6/docs/ref/#state.EditorSelection) may hold
multiple ranges. By default, selections hold exactly one range.
*/ class $6295c6875f57e3ee$export$7bd1839c3c5d5bd4 {
    constructor(/**
    The lower boundary of the range.
    */ from, /**
    The upper boundary of the range.
    */ to, flags){
        this.from = from;
        this.to = to;
        this.flags = flags;
    }
    /**
    The anchor of the range—the side that doesn't move when you
    extend it.
    */ get anchor() {
        return this.flags & 32 /* RangeFlag.Inverted */  ? this.to : this.from;
    }
    /**
    The head of the range, which is moved when the range is
    [extended](https://codemirror.net/6/docs/ref/#state.SelectionRange.extend).
    */ get head() {
        return this.flags & 32 /* RangeFlag.Inverted */  ? this.from : this.to;
    }
    /**
    True when `anchor` and `head` are at the same position.
    */ get empty() {
        return this.from == this.to;
    }
    /**
    If this is a cursor that is explicitly associated with the
    character on one of its sides, this returns the side. -1 means
    the character before its position, 1 the character after, and 0
    means no association.
    */ get assoc() {
        return this.flags & 8 /* RangeFlag.AssocBefore */  ? -1 : this.flags & 16 /* RangeFlag.AssocAfter */  ? 1 : 0;
    }
    /**
    The bidirectional text level associated with this cursor, if
    any.
    */ get bidiLevel() {
        let level = this.flags & 7 /* RangeFlag.BidiLevelMask */ ;
        return level == 7 ? null : level;
    }
    /**
    The goal column (stored vertical offset) associated with a
    cursor. This is used to preserve the vertical position when
    [moving](https://codemirror.net/6/docs/ref/#view.EditorView.moveVertically) across
    lines of different length.
    */ get goalColumn() {
        let value = this.flags >> 6 /* RangeFlag.GoalColumnOffset */ ;
        return value == 16777215 /* RangeFlag.NoGoalColumn */  ? undefined : value;
    }
    /**
    Map this range through a change, producing a valid range in the
    updated document.
    */ map(change, assoc = -1) {
        let from, to;
        if (this.empty) from = to = change.mapPos(this.from, assoc);
        else {
            from = change.mapPos(this.from, 1);
            to = change.mapPos(this.to, -1);
        }
        return from == this.from && to == this.to ? this : new $6295c6875f57e3ee$export$7bd1839c3c5d5bd4(from, to, this.flags);
    }
    /**
    Extend this range to cover at least `from` to `to`.
    */ extend(from, to = from, assoc = 0) {
        if (from <= this.anchor && to >= this.anchor) return $6295c6875f57e3ee$export$3bb1bd44aee62999.range(from, to, undefined, undefined, assoc);
        let head = Math.abs(from - this.anchor) > Math.abs(to - this.anchor) ? from : to;
        return $6295c6875f57e3ee$export$3bb1bd44aee62999.range(this.anchor, head, undefined, undefined, assoc);
    }
    /**
    Compare this range to another range.
    */ eq(other, includeAssoc = false) {
        return this.anchor == other.anchor && this.head == other.head && this.goalColumn == other.goalColumn && (!includeAssoc || !this.empty || this.assoc == other.assoc);
    }
    /**
    Return a JSON-serializable object representing the range.
    */ toJSON() {
        return {
            anchor: this.anchor,
            head: this.head
        };
    }
    /**
    Convert a JSON representation of a range to a `SelectionRange`
    instance.
    */ static fromJSON(json) {
        if (!json || typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid JSON representation for SelectionRange");
        return $6295c6875f57e3ee$export$3bb1bd44aee62999.range(json.anchor, json.head);
    }
    /**
    @internal
    */ static create(from, to, flags) {
        return new $6295c6875f57e3ee$export$7bd1839c3c5d5bd4(from, to, flags);
    }
}
/**
An editor selection holds one or more selection ranges.
*/ class $6295c6875f57e3ee$export$3bb1bd44aee62999 {
    constructor(/**
    The ranges in the selection, sorted by position. Ranges cannot
    overlap (but they may touch, if they aren't empty).
    */ ranges, /**
    The index of the _main_ range in the selection (which is
    usually the range that was added last).
    */ mainIndex){
        this.ranges = ranges;
        this.mainIndex = mainIndex;
    }
    /**
    Map a selection through a change. Used to adjust the selection
    position for changes.
    */ map(change, assoc = -1) {
        if (change.empty) return this;
        return $6295c6875f57e3ee$export$3bb1bd44aee62999.create(this.ranges.map((r)=>r.map(change, assoc)), this.mainIndex);
    }
    /**
    Compare this selection to another selection. By default, ranges
    are compared only by position. When `includeAssoc` is true,
    cursor ranges must also have the same
    [`assoc`](https://codemirror.net/6/docs/ref/#state.SelectionRange.assoc) value.
    */ eq(other, includeAssoc = false) {
        if (this.ranges.length != other.ranges.length || this.mainIndex != other.mainIndex) return false;
        for(let i = 0; i < this.ranges.length; i++)if (!this.ranges[i].eq(other.ranges[i], includeAssoc)) return false;
        return true;
    }
    /**
    Get the primary selection range. Usually, you should make sure
    your code applies to _all_ ranges, by using methods like
    [`changeByRange`](https://codemirror.net/6/docs/ref/#state.EditorState.changeByRange).
    */ get main() {
        return this.ranges[this.mainIndex];
    }
    /**
    Make sure the selection only has one range. Returns a selection
    holding only the main range from this selection.
    */ asSingle() {
        return this.ranges.length == 1 ? this : new $6295c6875f57e3ee$export$3bb1bd44aee62999([
            this.main
        ], 0);
    }
    /**
    Extend this selection with an extra range.
    */ addRange(range, main = true) {
        return $6295c6875f57e3ee$export$3bb1bd44aee62999.create([
            range
        ].concat(this.ranges), main ? 0 : this.mainIndex + 1);
    }
    /**
    Replace a given range with another range, and then normalize the
    selection to merge and sort ranges if necessary.
    */ replaceRange(range, which = this.mainIndex) {
        let ranges = this.ranges.slice();
        ranges[which] = range;
        return $6295c6875f57e3ee$export$3bb1bd44aee62999.create(ranges, this.mainIndex);
    }
    /**
    Convert this selection to an object that can be serialized to
    JSON.
    */ toJSON() {
        return {
            ranges: this.ranges.map((r)=>r.toJSON()),
            main: this.mainIndex
        };
    }
    /**
    Create a selection from a JSON representation.
    */ static fromJSON(json) {
        if (!json || !Array.isArray(json.ranges) || typeof json.main != "number" || json.main >= json.ranges.length) throw new RangeError("Invalid JSON representation for EditorSelection");
        return new $6295c6875f57e3ee$export$3bb1bd44aee62999(json.ranges.map((r)=>$6295c6875f57e3ee$export$7bd1839c3c5d5bd4.fromJSON(r)), json.main);
    }
    /**
    Create a selection holding a single range.
    */ static single(anchor, head = anchor) {
        return new $6295c6875f57e3ee$export$3bb1bd44aee62999([
            $6295c6875f57e3ee$export$3bb1bd44aee62999.range(anchor, head)
        ], 0);
    }
    /**
    Sort and merge the given set of ranges, creating a valid
    selection.
    */ static create(ranges, mainIndex = 0) {
        if (ranges.length == 0) throw new RangeError("A selection needs at least one range");
        for(let pos = 0, i = 0; i < ranges.length; i++){
            let range = ranges[i];
            if (range.empty ? range.from <= pos : range.from < pos) return $6295c6875f57e3ee$export$3bb1bd44aee62999.normalized(ranges.slice(), mainIndex);
            pos = range.to;
        }
        return new $6295c6875f57e3ee$export$3bb1bd44aee62999(ranges, mainIndex);
    }
    /**
    Create a cursor selection range at the given position. You can
    safely ignore the optional arguments in most situations.
    */ static cursor(pos, assoc = 0, bidiLevel, goalColumn) {
        return $6295c6875f57e3ee$export$7bd1839c3c5d5bd4.create(pos, pos, (assoc == 0 ? 0 : assoc < 0 ? 8 /* RangeFlag.AssocBefore */  : 16 /* RangeFlag.AssocAfter */ ) | (bidiLevel == null ? 7 : Math.min(6, bidiLevel)) | (goalColumn !== null && goalColumn !== void 0 ? goalColumn : 16777215 /* RangeFlag.NoGoalColumn */ ) << 6 /* RangeFlag.GoalColumnOffset */ );
    }
    /**
    Create a selection range.
    */ static range(anchor, head, goalColumn, bidiLevel, assoc) {
        let flags = (goalColumn !== null && goalColumn !== void 0 ? goalColumn : 16777215 /* RangeFlag.NoGoalColumn */ ) << 6 /* RangeFlag.GoalColumnOffset */  | (bidiLevel == null ? 7 : Math.min(6, bidiLevel));
        if (!assoc && anchor != head) assoc = head < anchor ? 1 : -1;
        return head < anchor ? $6295c6875f57e3ee$export$7bd1839c3c5d5bd4.create(head, anchor, 48 /* RangeFlag.AssocAfter */  | flags) : $6295c6875f57e3ee$export$7bd1839c3c5d5bd4.create(anchor, head, (!assoc ? 0 : assoc < 0 ? 8 /* RangeFlag.AssocBefore */  : 16 /* RangeFlag.AssocAfter */ ) | flags);
    }
    /**
    @internal
    */ static normalized(ranges, mainIndex = 0) {
        let main = ranges[mainIndex];
        ranges.sort((a, b)=>a.from - b.from);
        mainIndex = ranges.indexOf(main);
        for(let i = 1; i < ranges.length; i++){
            let range = ranges[i], prev = ranges[i - 1];
            if (range.empty ? range.from <= prev.to : range.from < prev.to) {
                let from = prev.from, to = Math.max(range.to, prev.to);
                if (i <= mainIndex) mainIndex--;
                ranges.splice(--i, 2, range.anchor > range.head ? $6295c6875f57e3ee$export$3bb1bd44aee62999.range(to, from) : $6295c6875f57e3ee$export$3bb1bd44aee62999.range(from, to));
            }
        }
        return new $6295c6875f57e3ee$export$3bb1bd44aee62999(ranges, mainIndex);
    }
}
function $6295c6875f57e3ee$var$checkSelection(selection, docLength) {
    for (let range of selection.ranges)if (range.to > docLength) throw new RangeError("Selection points outside of document");
}
let $6295c6875f57e3ee$var$nextID = 0;
/**
A facet is a labeled value that is associated with an editor
state. It takes inputs from any number of extensions, and combines
those into a single output value.

Examples of uses of facets are the [tab
size](https://codemirror.net/6/docs/ref/#state.EditorState^tabSize), [editor
attributes](https://codemirror.net/6/docs/ref/#view.EditorView^editorAttributes), and [update
listeners](https://codemirror.net/6/docs/ref/#view.EditorView^updateListener).

Note that `Facet` instances can be used anywhere where
[`FacetReader`](https://codemirror.net/6/docs/ref/#state.FacetReader) is expected.
*/ class $6295c6875f57e3ee$export$ef7d5e9b79fa1504 {
    constructor(/**
    @internal
    */ combine, /**
    @internal
    */ compareInput, /**
    @internal
    */ compare, isStatic, enables){
        this.combine = combine;
        this.compareInput = compareInput;
        this.compare = compare;
        this.isStatic = isStatic;
        /**
        @internal
        */ this.id = $6295c6875f57e3ee$var$nextID++;
        this.default = combine([]);
        this.extensions = typeof enables == "function" ? enables(this) : enables;
    }
    /**
    Returns a facet reader for this facet, which can be used to
    [read](https://codemirror.net/6/docs/ref/#state.EditorState.facet) it but not to define values for it.
    */ get reader() {
        return this;
    }
    /**
    Define a new facet.
    */ static define(config = {}) {
        return new $6295c6875f57e3ee$export$ef7d5e9b79fa1504(config.combine || ((a)=>a), config.compareInput || ((a, b)=>a === b), config.compare || (!config.combine ? $6295c6875f57e3ee$var$sameArray : (a, b)=>a === b), !!config.static, config.enables);
    }
    /**
    Returns an extension that adds the given value to this facet.
    */ of(value) {
        return new $6295c6875f57e3ee$var$FacetProvider([], this, 0 /* Provider.Static */ , value);
    }
    /**
    Create an extension that computes a value for the facet from a
    state. You must take care to declare the parts of the state that
    this value depends on, since your function is only called again
    for a new state when one of those parts changed.
    
    In cases where your value depends only on a single field, you'll
    want to use the [`from`](https://codemirror.net/6/docs/ref/#state.Facet.from) method instead.
    */ compute(deps, get) {
        if (this.isStatic) throw new Error("Can't compute a static facet");
        return new $6295c6875f57e3ee$var$FacetProvider(deps, this, 1 /* Provider.Single */ , get);
    }
    /**
    Create an extension that computes zero or more values for this
    facet from a state.
    */ computeN(deps, get) {
        if (this.isStatic) throw new Error("Can't compute a static facet");
        return new $6295c6875f57e3ee$var$FacetProvider(deps, this, 2 /* Provider.Multi */ , get);
    }
    from(field, get) {
        if (!get) get = (x)=>x;
        return this.compute([
            field
        ], (state)=>get(state.field(field)));
    }
}
function $6295c6875f57e3ee$var$sameArray(a, b) {
    return a == b || a.length == b.length && a.every((e, i)=>e === b[i]);
}
class $6295c6875f57e3ee$var$FacetProvider {
    constructor(dependencies, facet, type, value){
        this.dependencies = dependencies;
        this.facet = facet;
        this.type = type;
        this.value = value;
        this.id = $6295c6875f57e3ee$var$nextID++;
    }
    dynamicSlot(addresses) {
        var _a;
        let getter = this.value;
        let compare = this.facet.compareInput;
        let id = this.id, idx = addresses[id] >> 1, multi = this.type == 2 /* Provider.Multi */ ;
        let depDoc = false, depSel = false, depAddrs = [];
        for (let dep of this.dependencies){
            if (dep == "doc") depDoc = true;
            else if (dep == "selection") depSel = true;
            else if ((((_a = addresses[dep.id]) !== null && _a !== void 0 ? _a : 1) & 1) == 0) depAddrs.push(addresses[dep.id]);
        }
        return {
            create (state) {
                state.values[idx] = getter(state);
                return 1 /* SlotStatus.Changed */ ;
            },
            update (state, tr) {
                if (depDoc && tr.docChanged || depSel && (tr.docChanged || tr.selection) || $6295c6875f57e3ee$var$ensureAll(state, depAddrs)) {
                    let newVal = getter(state);
                    if (multi ? !$6295c6875f57e3ee$var$compareArray(newVal, state.values[idx], compare) : !compare(newVal, state.values[idx])) {
                        state.values[idx] = newVal;
                        return 1 /* SlotStatus.Changed */ ;
                    }
                }
                return 0;
            },
            reconfigure: (state, oldState)=>{
                let newVal, oldAddr = oldState.config.address[id];
                if (oldAddr != null) {
                    let oldVal = $6295c6875f57e3ee$var$getAddr(oldState, oldAddr);
                    if (this.dependencies.every((dep)=>{
                        return dep instanceof $6295c6875f57e3ee$export$ef7d5e9b79fa1504 ? oldState.facet(dep) === state.facet(dep) : dep instanceof $6295c6875f57e3ee$export$34381b1ce2130245 ? oldState.field(dep, false) == state.field(dep, false) : true;
                    }) || (multi ? $6295c6875f57e3ee$var$compareArray(newVal = getter(state), oldVal, compare) : compare(newVal = getter(state), oldVal))) {
                        state.values[idx] = oldVal;
                        return 0;
                    }
                } else newVal = getter(state);
                state.values[idx] = newVal;
                return 1 /* SlotStatus.Changed */ ;
            }
        };
    }
}
function $6295c6875f57e3ee$var$compareArray(a, b, compare) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (!compare(a[i], b[i])) return false;
    return true;
}
function $6295c6875f57e3ee$var$ensureAll(state, addrs) {
    let changed = false;
    for (let addr of addrs)if ($6295c6875f57e3ee$var$ensureAddr(state, addr) & 1 /* SlotStatus.Changed */ ) changed = true;
    return changed;
}
function $6295c6875f57e3ee$var$dynamicFacetSlot(addresses, facet, providers) {
    let providerAddrs = providers.map((p)=>addresses[p.id]);
    let providerTypes = providers.map((p)=>p.type);
    let dynamic = providerAddrs.filter((p)=>!(p & 1));
    let idx = addresses[facet.id] >> 1;
    function get(state) {
        let values = [];
        for(let i = 0; i < providerAddrs.length; i++){
            let value = $6295c6875f57e3ee$var$getAddr(state, providerAddrs[i]);
            if (providerTypes[i] == 2 /* Provider.Multi */ ) for (let val of value)values.push(val);
            else values.push(value);
        }
        return facet.combine(values);
    }
    return {
        create (state) {
            for (let addr of providerAddrs)$6295c6875f57e3ee$var$ensureAddr(state, addr);
            state.values[idx] = get(state);
            return 1 /* SlotStatus.Changed */ ;
        },
        update (state, tr) {
            if (!$6295c6875f57e3ee$var$ensureAll(state, dynamic)) return 0;
            let value = get(state);
            if (facet.compare(value, state.values[idx])) return 0;
            state.values[idx] = value;
            return 1 /* SlotStatus.Changed */ ;
        },
        reconfigure (state, oldState) {
            let depChanged = $6295c6875f57e3ee$var$ensureAll(state, providerAddrs);
            let oldProviders = oldState.config.facets[facet.id], oldValue = oldState.facet(facet);
            if (oldProviders && !depChanged && $6295c6875f57e3ee$var$sameArray(providers, oldProviders)) {
                state.values[idx] = oldValue;
                return 0;
            }
            let value = get(state);
            if (facet.compare(value, oldValue)) {
                state.values[idx] = oldValue;
                return 0;
            }
            state.values[idx] = value;
            return 1 /* SlotStatus.Changed */ ;
        }
    };
}
const $6295c6875f57e3ee$var$initField = /*@__PURE__*/ $6295c6875f57e3ee$export$ef7d5e9b79fa1504.define({
    static: true
});
/**
Fields can store additional information in an editor state, and
keep it in sync with the rest of the state.
*/ class $6295c6875f57e3ee$export$34381b1ce2130245 {
    constructor(/**
    @internal
    */ id, createF, updateF, compareF, /**
    @internal
    */ spec){
        this.id = id;
        this.createF = createF;
        this.updateF = updateF;
        this.compareF = compareF;
        this.spec = spec;
        /**
        @internal
        */ this.provides = undefined;
    }
    /**
    Define a state field.
    */ static define(config) {
        let field = new $6295c6875f57e3ee$export$34381b1ce2130245($6295c6875f57e3ee$var$nextID++, config.create, config.update, config.compare || ((a, b)=>a === b), config);
        if (config.provide) field.provides = config.provide(field);
        return field;
    }
    create(state) {
        let init = state.facet($6295c6875f57e3ee$var$initField).find((i)=>i.field == this);
        return ((init === null || init === void 0 ? void 0 : init.create) || this.createF)(state);
    }
    /**
    @internal
    */ slot(addresses) {
        let idx = addresses[this.id] >> 1;
        return {
            create: (state)=>{
                state.values[idx] = this.create(state);
                return 1 /* SlotStatus.Changed */ ;
            },
            update: (state, tr)=>{
                let oldVal = state.values[idx];
                let value = this.updateF(oldVal, tr);
                if (this.compareF(oldVal, value)) return 0;
                state.values[idx] = value;
                return 1 /* SlotStatus.Changed */ ;
            },
            reconfigure: (state, oldState)=>{
                let init = state.facet($6295c6875f57e3ee$var$initField), oldInit = oldState.facet($6295c6875f57e3ee$var$initField), reInit;
                if ((reInit = init.find((i)=>i.field == this)) && reInit != oldInit.find((i)=>i.field == this)) {
                    state.values[idx] = reInit.create(state);
                    return 1 /* SlotStatus.Changed */ ;
                }
                if (oldState.config.address[this.id] != null) {
                    state.values[idx] = oldState.field(this);
                    return 0;
                }
                state.values[idx] = this.create(state);
                return 1 /* SlotStatus.Changed */ ;
            }
        };
    }
    /**
    Returns an extension that enables this field and overrides the
    way it is initialized. Can be useful when you need to provide a
    non-default starting value for the field.
    */ init(create) {
        return [
            this,
            $6295c6875f57e3ee$var$initField.of({
                field: this,
                create: create
            })
        ];
    }
    /**
    State field instances can be used as
    [`Extension`](https://codemirror.net/6/docs/ref/#state.Extension) values to enable the field in a
    given state.
    */ get extension() {
        return this;
    }
}
const $6295c6875f57e3ee$var$Prec_ = {
    lowest: 4,
    low: 3,
    default: 2,
    high: 1,
    highest: 0
};
function $6295c6875f57e3ee$var$prec(value) {
    return (ext)=>new $6295c6875f57e3ee$var$PrecExtension(ext, value);
}
/**
By default extensions are registered in the order they are found
in the flattened form of nested array that was provided.
Individual extension values can be assigned a precedence to
override this. Extensions that do not have a precedence set get
the precedence of the nearest parent with a precedence, or
[`default`](https://codemirror.net/6/docs/ref/#state.Prec.default) if there is no such parent. The
final ordering of extensions is determined by first sorting by
precedence and then by order within each precedence.
*/ const $6295c6875f57e3ee$export$b92464a736444411 = {
    /**
    The highest precedence level, for extensions that should end up
    near the start of the precedence ordering.
    */ highest: /*@__PURE__*/ $6295c6875f57e3ee$var$prec($6295c6875f57e3ee$var$Prec_.highest),
    /**
    A higher-than-default precedence, for extensions that should
    come before those with default precedence.
    */ high: /*@__PURE__*/ $6295c6875f57e3ee$var$prec($6295c6875f57e3ee$var$Prec_.high),
    /**
    The default precedence, which is also used for extensions
    without an explicit precedence.
    */ default: /*@__PURE__*/ $6295c6875f57e3ee$var$prec($6295c6875f57e3ee$var$Prec_.default),
    /**
    A lower-than-default precedence.
    */ low: /*@__PURE__*/ $6295c6875f57e3ee$var$prec($6295c6875f57e3ee$var$Prec_.low),
    /**
    The lowest precedence level. Meant for things that should end up
    near the end of the extension order.
    */ lowest: /*@__PURE__*/ $6295c6875f57e3ee$var$prec($6295c6875f57e3ee$var$Prec_.lowest)
};
class $6295c6875f57e3ee$var$PrecExtension {
    constructor(inner, prec){
        this.inner = inner;
        this.prec = prec;
    }
}
/**
Extension compartments can be used to make a configuration
dynamic. By [wrapping](https://codemirror.net/6/docs/ref/#state.Compartment.of) part of your
configuration in a compartment, you can later
[replace](https://codemirror.net/6/docs/ref/#state.Compartment.reconfigure) that part through a
transaction.
*/ class $6295c6875f57e3ee$export$d51c0172eb2c2431 {
    /**
    Create an instance of this compartment to add to your [state
    configuration](https://codemirror.net/6/docs/ref/#state.EditorStateConfig.extensions).
    */ of(ext) {
        return new $6295c6875f57e3ee$var$CompartmentInstance(this, ext);
    }
    /**
    Create an [effect](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) that
    reconfigures this compartment.
    */ reconfigure(content) {
        return $6295c6875f57e3ee$export$d51c0172eb2c2431.reconfigure.of({
            compartment: this,
            extension: content
        });
    }
    /**
    Get the current content of the compartment in the state, or
    `undefined` if it isn't present.
    */ get(state) {
        return state.config.compartments.get(this);
    }
}
class $6295c6875f57e3ee$var$CompartmentInstance {
    constructor(compartment, inner){
        this.compartment = compartment;
        this.inner = inner;
    }
}
class $6295c6875f57e3ee$var$Configuration {
    constructor(base, compartments, dynamicSlots, address, staticValues, facets){
        this.base = base;
        this.compartments = compartments;
        this.dynamicSlots = dynamicSlots;
        this.address = address;
        this.staticValues = staticValues;
        this.facets = facets;
        this.statusTemplate = [];
        while(this.statusTemplate.length < dynamicSlots.length)this.statusTemplate.push(0 /* SlotStatus.Unresolved */ );
    }
    staticFacet(facet) {
        let addr = this.address[facet.id];
        return addr == null ? facet.default : this.staticValues[addr >> 1];
    }
    static resolve(base, compartments, oldState) {
        let fields = [];
        let facets = Object.create(null);
        let newCompartments = new Map();
        for (let ext of $6295c6875f57e3ee$var$flatten(base, compartments, newCompartments))if (ext instanceof $6295c6875f57e3ee$export$34381b1ce2130245) fields.push(ext);
        else (facets[ext.facet.id] || (facets[ext.facet.id] = [])).push(ext);
        let address = Object.create(null);
        let staticValues = [];
        let dynamicSlots = [];
        for (let field of fields){
            address[field.id] = dynamicSlots.length << 1;
            dynamicSlots.push((a)=>field.slot(a));
        }
        let oldFacets = oldState === null || oldState === void 0 ? void 0 : oldState.config.facets;
        for(let id in facets){
            let providers = facets[id], facet = providers[0].facet;
            let oldProviders = oldFacets && oldFacets[id] || [];
            if (providers.every((p)=>p.type == 0 /* Provider.Static */ )) {
                address[facet.id] = staticValues.length << 1 | 1;
                if ($6295c6875f57e3ee$var$sameArray(oldProviders, providers)) staticValues.push(oldState.facet(facet));
                else {
                    let value = facet.combine(providers.map((p)=>p.value));
                    staticValues.push(oldState && facet.compare(value, oldState.facet(facet)) ? oldState.facet(facet) : value);
                }
            } else {
                for (let p of providers)if (p.type == 0 /* Provider.Static */ ) {
                    address[p.id] = staticValues.length << 1 | 1;
                    staticValues.push(p.value);
                } else {
                    address[p.id] = dynamicSlots.length << 1;
                    dynamicSlots.push((a)=>p.dynamicSlot(a));
                }
                address[facet.id] = dynamicSlots.length << 1;
                dynamicSlots.push((a)=>$6295c6875f57e3ee$var$dynamicFacetSlot(a, facet, providers));
            }
        }
        let dynamic = dynamicSlots.map((f)=>f(address));
        return new $6295c6875f57e3ee$var$Configuration(base, newCompartments, dynamic, address, staticValues, facets);
    }
}
function $6295c6875f57e3ee$var$flatten(extension, compartments, newCompartments) {
    let result = [
        [],
        [],
        [],
        [],
        []
    ];
    let seen = new Map();
    function inner(ext, prec) {
        let known = seen.get(ext);
        if (known != null) {
            if (known <= prec) return;
            let found = result[known].indexOf(ext);
            if (found > -1) result[known].splice(found, 1);
            if (ext instanceof $6295c6875f57e3ee$var$CompartmentInstance) newCompartments.delete(ext.compartment);
        }
        seen.set(ext, prec);
        if (Array.isArray(ext)) for (let e of ext)inner(e, prec);
        else if (ext instanceof $6295c6875f57e3ee$var$CompartmentInstance) {
            if (newCompartments.has(ext.compartment)) throw new RangeError(`Duplicate use of compartment in extensions`);
            let content = compartments.get(ext.compartment) || ext.inner;
            newCompartments.set(ext.compartment, content);
            inner(content, prec);
        } else if (ext instanceof $6295c6875f57e3ee$var$PrecExtension) inner(ext.inner, ext.prec);
        else if (ext instanceof $6295c6875f57e3ee$export$34381b1ce2130245) {
            result[prec].push(ext);
            if (ext.provides) inner(ext.provides, prec);
        } else if (ext instanceof $6295c6875f57e3ee$var$FacetProvider) {
            result[prec].push(ext);
            if (ext.facet.extensions) inner(ext.facet.extensions, $6295c6875f57e3ee$var$Prec_.default);
        } else {
            let content = ext.extension;
            if (!content) throw new Error(`Unrecognized extension value in extension set (${ext}). This sometimes happens because multiple instances of @codemirror/state are loaded, breaking instanceof checks.`);
            inner(content, prec);
        }
    }
    inner(extension, $6295c6875f57e3ee$var$Prec_.default);
    return result.reduce((a, b)=>a.concat(b));
}
function $6295c6875f57e3ee$var$ensureAddr(state, addr) {
    if (addr & 1) return 2 /* SlotStatus.Computed */ ;
    let idx = addr >> 1;
    let status = state.status[idx];
    if (status == 4 /* SlotStatus.Computing */ ) throw new Error("Cyclic dependency between fields and/or facets");
    if (status & 2 /* SlotStatus.Computed */ ) return status;
    state.status[idx] = 4 /* SlotStatus.Computing */ ;
    let changed = state.computeSlot(state, state.config.dynamicSlots[idx]);
    return state.status[idx] = 2 /* SlotStatus.Computed */  | changed;
}
function $6295c6875f57e3ee$var$getAddr(state, addr) {
    return addr & 1 ? state.config.staticValues[addr >> 1] : state.values[addr >> 1];
}
const $6295c6875f57e3ee$var$languageData = /*@__PURE__*/ $6295c6875f57e3ee$export$ef7d5e9b79fa1504.define();
const $6295c6875f57e3ee$var$allowMultipleSelections = /*@__PURE__*/ $6295c6875f57e3ee$export$ef7d5e9b79fa1504.define({
    combine: (values)=>values.some((v)=>v),
    static: true
});
const $6295c6875f57e3ee$var$lineSeparator = /*@__PURE__*/ $6295c6875f57e3ee$export$ef7d5e9b79fa1504.define({
    combine: (values)=>values.length ? values[0] : undefined,
    static: true
});
const $6295c6875f57e3ee$var$changeFilter = /*@__PURE__*/ $6295c6875f57e3ee$export$ef7d5e9b79fa1504.define();
const $6295c6875f57e3ee$var$transactionFilter = /*@__PURE__*/ $6295c6875f57e3ee$export$ef7d5e9b79fa1504.define();
const $6295c6875f57e3ee$var$transactionExtender = /*@__PURE__*/ $6295c6875f57e3ee$export$ef7d5e9b79fa1504.define();
const $6295c6875f57e3ee$var$readOnly = /*@__PURE__*/ $6295c6875f57e3ee$export$ef7d5e9b79fa1504.define({
    combine: (values)=>values.length ? values[0] : false
});
/**
Annotations are tagged values that are used to add metadata to
transactions in an extensible way. They should be used to model
things that effect the entire transaction (such as its [time
stamp](https://codemirror.net/6/docs/ref/#state.Transaction^time) or information about its
[origin](https://codemirror.net/6/docs/ref/#state.Transaction^userEvent)). For effects that happen
_alongside_ the other changes made by the transaction, [state
effects](https://codemirror.net/6/docs/ref/#state.StateEffect) are more appropriate.
*/ class $6295c6875f57e3ee$export$9279461326b8700a {
    /**
    @internal
    */ constructor(/**
    The annotation type.
    */ type, /**
    The value of this annotation.
    */ value){
        this.type = type;
        this.value = value;
    }
    /**
    Define a new type of annotation.
    */ static define() {
        return new $6295c6875f57e3ee$export$f50c3066a53a6f2c();
    }
}
/**
Marker that identifies a type of [annotation](https://codemirror.net/6/docs/ref/#state.Annotation).
*/ class $6295c6875f57e3ee$export$f50c3066a53a6f2c {
    /**
    Create an instance of this annotation.
    */ of(value) {
        return new $6295c6875f57e3ee$export$9279461326b8700a(this, value);
    }
}
/**
Representation of a type of state effect. Defined with
[`StateEffect.define`](https://codemirror.net/6/docs/ref/#state.StateEffect^define).
*/ class $6295c6875f57e3ee$export$e41ff6bd17cc4417 {
    /**
    @internal
    */ constructor(// The `any` types in these function types are there to work
    // around TypeScript issue #37631, where the type guard on
    // `StateEffect.is` mysteriously stops working when these properly
    // have type `Value`.
    /**
    @internal
    */ map){
        this.map = map;
    }
    /**
    Create a [state effect](https://codemirror.net/6/docs/ref/#state.StateEffect) instance of this
    type.
    */ of(value) {
        return new $6295c6875f57e3ee$export$95000d4efaa4321f(this, value);
    }
}
/**
State effects can be used to represent additional effects
associated with a [transaction](https://codemirror.net/6/docs/ref/#state.Transaction.effects). They
are often useful to model changes to custom [state
fields](https://codemirror.net/6/docs/ref/#state.StateField), when those changes aren't implicit in
document or selection changes.
*/ class $6295c6875f57e3ee$export$95000d4efaa4321f {
    /**
    @internal
    */ constructor(/**
    @internal
    */ type, /**
    The value of this effect.
    */ value){
        this.type = type;
        this.value = value;
    }
    /**
    Map this effect through a position mapping. Will return
    `undefined` when that ends up deleting the effect.
    */ map(mapping) {
        let mapped = this.type.map(this.value, mapping);
        return mapped === undefined ? undefined : mapped == this.value ? this : new $6295c6875f57e3ee$export$95000d4efaa4321f(this.type, mapped);
    }
    /**
    Tells you whether this effect object is of a given
    [type](https://codemirror.net/6/docs/ref/#state.StateEffectType).
    */ is(type) {
        return this.type == type;
    }
    /**
    Define a new effect type. The type parameter indicates the type
    of values that his effect holds. It should be a type that
    doesn't include `undefined`, since that is used in
    [mapping](https://codemirror.net/6/docs/ref/#state.StateEffect.map) to indicate that an effect is
    removed.
    */ static define(spec = {}) {
        return new $6295c6875f57e3ee$export$e41ff6bd17cc4417(spec.map || ((v)=>v));
    }
    /**
    Map an array of effects through a change set.
    */ static mapEffects(effects, mapping) {
        if (!effects.length) return effects;
        let result = [];
        for (let effect of effects){
            let mapped = effect.map(mapping);
            if (mapped) result.push(mapped);
        }
        return result;
    }
}
/**
This effect can be used to reconfigure the root extensions of
the editor. Doing this will discard any extensions
[appended](https://codemirror.net/6/docs/ref/#state.StateEffect^appendConfig), but does not reset
the content of [reconfigured](https://codemirror.net/6/docs/ref/#state.Compartment.reconfigure)
compartments.
*/ $6295c6875f57e3ee$export$95000d4efaa4321f.reconfigure = /*@__PURE__*/ $6295c6875f57e3ee$export$95000d4efaa4321f.define();
/**
Append extensions to the top-level configuration of the editor.
*/ $6295c6875f57e3ee$export$95000d4efaa4321f.appendConfig = /*@__PURE__*/ $6295c6875f57e3ee$export$95000d4efaa4321f.define();
/**
Changes to the editor state are grouped into transactions.
Typically, a user action creates a single transaction, which may
contain any number of document changes, may change the selection,
or have other effects. Create a transaction by calling
[`EditorState.update`](https://codemirror.net/6/docs/ref/#state.EditorState.update), or immediately
dispatch one by calling
[`EditorView.dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch).
*/ class $6295c6875f57e3ee$export$febc5573c75cefb0 {
    constructor(/**
    The state from which the transaction starts.
    */ startState, /**
    The document changes made by this transaction.
    */ changes, /**
    The selection set by this transaction, or undefined if it
    doesn't explicitly set a selection.
    */ selection, /**
    The effects added to the transaction.
    */ effects, /**
    @internal
    */ annotations, /**
    Whether the selection should be scrolled into view after this
    transaction is dispatched.
    */ scrollIntoView){
        this.startState = startState;
        this.changes = changes;
        this.selection = selection;
        this.effects = effects;
        this.annotations = annotations;
        this.scrollIntoView = scrollIntoView;
        /**
        @internal
        */ this._doc = null;
        /**
        @internal
        */ this._state = null;
        if (selection) $6295c6875f57e3ee$var$checkSelection(selection, changes.newLength);
        if (!annotations.some((a)=>a.type == $6295c6875f57e3ee$export$febc5573c75cefb0.time)) this.annotations = annotations.concat($6295c6875f57e3ee$export$febc5573c75cefb0.time.of(Date.now()));
    }
    /**
    @internal
    */ static create(startState, changes, selection, effects, annotations, scrollIntoView) {
        return new $6295c6875f57e3ee$export$febc5573c75cefb0(startState, changes, selection, effects, annotations, scrollIntoView);
    }
    /**
    The new document produced by the transaction. Contrary to
    [`.state`](https://codemirror.net/6/docs/ref/#state.Transaction.state)`.doc`, accessing this won't
    force the entire new state to be computed right away, so it is
    recommended that [transaction
    filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) use this getter
    when they need to look at the new document.
    */ get newDoc() {
        return this._doc || (this._doc = this.changes.apply(this.startState.doc));
    }
    /**
    The new selection produced by the transaction. If
    [`this.selection`](https://codemirror.net/6/docs/ref/#state.Transaction.selection) is undefined,
    this will [map](https://codemirror.net/6/docs/ref/#state.EditorSelection.map) the start state's
    current selection through the changes made by the transaction.
    */ get newSelection() {
        return this.selection || this.startState.selection.map(this.changes);
    }
    /**
    The new state created by the transaction. Computed on demand
    (but retained for subsequent access), so it is recommended not to
    access it in [transaction
    filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) when possible.
    */ get state() {
        if (!this._state) this.startState.applyTransaction(this);
        return this._state;
    }
    /**
    Get the value of the given annotation type, if any.
    */ annotation(type) {
        for (let ann of this.annotations)if (ann.type == type) return ann.value;
        return undefined;
    }
    /**
    Indicates whether the transaction changed the document.
    */ get docChanged() {
        return !this.changes.empty;
    }
    /**
    Indicates whether this transaction reconfigures the state
    (through a [configuration compartment](https://codemirror.net/6/docs/ref/#state.Compartment) or
    with a top-level configuration
    [effect](https://codemirror.net/6/docs/ref/#state.StateEffect^reconfigure).
    */ get reconfigured() {
        return this.startState.config != this.state.config;
    }
    /**
    Returns true if the transaction has a [user
    event](https://codemirror.net/6/docs/ref/#state.Transaction^userEvent) annotation that is equal to
    or more specific than `event`. For example, if the transaction
    has `"select.pointer"` as user event, `"select"` and
    `"select.pointer"` will match it.
    */ isUserEvent(event) {
        let e = this.annotation($6295c6875f57e3ee$export$febc5573c75cefb0.userEvent);
        return !!(e && (e == event || e.length > event.length && e.slice(0, event.length) == event && e[event.length] == "."));
    }
}
/**
Annotation used to store transaction timestamps. Automatically
added to every transaction, holding `Date.now()`.
*/ $6295c6875f57e3ee$export$febc5573c75cefb0.time = /*@__PURE__*/ $6295c6875f57e3ee$export$9279461326b8700a.define();
/**
Annotation used to associate a transaction with a user interface
event. Holds a string identifying the event, using a
dot-separated format to support attaching more specific
information. The events used by the core libraries are:

 - `"input"` when content is entered
   - `"input.type"` for typed input
     - `"input.type.compose"` for composition
   - `"input.paste"` for pasted input
   - `"input.drop"` when adding content with drag-and-drop
   - `"input.complete"` when autocompleting
 - `"delete"` when the user deletes content
   - `"delete.selection"` when deleting the selection
   - `"delete.forward"` when deleting forward from the selection
   - `"delete.backward"` when deleting backward from the selection
   - `"delete.cut"` when cutting to the clipboard
 - `"move"` when content is moved
   - `"move.drop"` when content is moved within the editor through drag-and-drop
 - `"select"` when explicitly changing the selection
   - `"select.pointer"` when selecting with a mouse or other pointing device
 - `"undo"` and `"redo"` for history actions

Use [`isUserEvent`](https://codemirror.net/6/docs/ref/#state.Transaction.isUserEvent) to check
whether the annotation matches a given event.
*/ $6295c6875f57e3ee$export$febc5573c75cefb0.userEvent = /*@__PURE__*/ $6295c6875f57e3ee$export$9279461326b8700a.define();
/**
Annotation indicating whether a transaction should be added to
the undo history or not.
*/ $6295c6875f57e3ee$export$febc5573c75cefb0.addToHistory = /*@__PURE__*/ $6295c6875f57e3ee$export$9279461326b8700a.define();
/**
Annotation indicating (when present and true) that a transaction
represents a change made by some other actor, not the user. This
is used, for example, to tag other people's changes in
collaborative editing.
*/ $6295c6875f57e3ee$export$febc5573c75cefb0.remote = /*@__PURE__*/ $6295c6875f57e3ee$export$9279461326b8700a.define();
function $6295c6875f57e3ee$var$joinRanges(a, b) {
    let result = [];
    for(let iA = 0, iB = 0;;){
        let from, to;
        if (iA < a.length && (iB == b.length || b[iB] >= a[iA])) {
            from = a[iA++];
            to = a[iA++];
        } else if (iB < b.length) {
            from = b[iB++];
            to = b[iB++];
        } else return result;
        if (!result.length || result[result.length - 1] < from) result.push(from, to);
        else if (result[result.length - 1] < to) result[result.length - 1] = to;
    }
}
function $6295c6875f57e3ee$var$mergeTransaction(a, b, sequential) {
    var _a;
    let mapForA, mapForB, changes;
    if (sequential) {
        mapForA = b.changes;
        mapForB = $6295c6875f57e3ee$export$29d7fbdcb1f8b71c.empty(b.changes.length);
        changes = a.changes.compose(b.changes);
    } else {
        mapForA = b.changes.map(a.changes);
        mapForB = a.changes.mapDesc(b.changes, true);
        changes = a.changes.compose(mapForA);
    }
    return {
        changes: changes,
        selection: b.selection ? b.selection.map(mapForB) : (_a = a.selection) === null || _a === void 0 ? void 0 : _a.map(mapForA),
        effects: $6295c6875f57e3ee$export$95000d4efaa4321f.mapEffects(a.effects, mapForA).concat($6295c6875f57e3ee$export$95000d4efaa4321f.mapEffects(b.effects, mapForB)),
        annotations: a.annotations.length ? a.annotations.concat(b.annotations) : b.annotations,
        scrollIntoView: a.scrollIntoView || b.scrollIntoView
    };
}
function $6295c6875f57e3ee$var$resolveTransactionInner(state, spec, docSize) {
    let sel = spec.selection, annotations = $6295c6875f57e3ee$var$asArray(spec.annotations);
    if (spec.userEvent) annotations = annotations.concat($6295c6875f57e3ee$export$febc5573c75cefb0.userEvent.of(spec.userEvent));
    return {
        changes: spec.changes instanceof $6295c6875f57e3ee$export$29d7fbdcb1f8b71c ? spec.changes : $6295c6875f57e3ee$export$29d7fbdcb1f8b71c.of(spec.changes || [], docSize, state.facet($6295c6875f57e3ee$var$lineSeparator)),
        selection: sel && (sel instanceof $6295c6875f57e3ee$export$3bb1bd44aee62999 ? sel : $6295c6875f57e3ee$export$3bb1bd44aee62999.single(sel.anchor, sel.head)),
        effects: $6295c6875f57e3ee$var$asArray(spec.effects),
        annotations: annotations,
        scrollIntoView: !!spec.scrollIntoView
    };
}
function $6295c6875f57e3ee$var$resolveTransaction(state, specs, filter) {
    let s = $6295c6875f57e3ee$var$resolveTransactionInner(state, specs.length ? specs[0] : {}, state.doc.length);
    if (specs.length && specs[0].filter === false) filter = false;
    for(let i = 1; i < specs.length; i++){
        if (specs[i].filter === false) filter = false;
        let seq = !!specs[i].sequential;
        s = $6295c6875f57e3ee$var$mergeTransaction(s, $6295c6875f57e3ee$var$resolveTransactionInner(state, specs[i], seq ? s.changes.newLength : state.doc.length), seq);
    }
    let tr = $6295c6875f57e3ee$export$febc5573c75cefb0.create(state, s.changes, s.selection, s.effects, s.annotations, s.scrollIntoView);
    return $6295c6875f57e3ee$var$extendTransaction(filter ? $6295c6875f57e3ee$var$filterTransaction(tr) : tr);
}
// Finish a transaction by applying filters if necessary.
function $6295c6875f57e3ee$var$filterTransaction(tr) {
    let state = tr.startState;
    // Change filters
    let result = true;
    for (let filter of state.facet($6295c6875f57e3ee$var$changeFilter)){
        let value = filter(tr);
        if (value === false) {
            result = false;
            break;
        }
        if (Array.isArray(value)) result = result === true ? value : $6295c6875f57e3ee$var$joinRanges(result, value);
    }
    if (result !== true) {
        let changes, back;
        if (result === false) {
            back = tr.changes.invertedDesc;
            changes = $6295c6875f57e3ee$export$29d7fbdcb1f8b71c.empty(state.doc.length);
        } else {
            let filtered = tr.changes.filter(result);
            changes = filtered.changes;
            back = filtered.filtered.mapDesc(filtered.changes).invertedDesc;
        }
        tr = $6295c6875f57e3ee$export$febc5573c75cefb0.create(state, changes, tr.selection && tr.selection.map(back), $6295c6875f57e3ee$export$95000d4efaa4321f.mapEffects(tr.effects, back), tr.annotations, tr.scrollIntoView);
    }
    // Transaction filters
    let filters = state.facet($6295c6875f57e3ee$var$transactionFilter);
    for(let i = filters.length - 1; i >= 0; i--){
        let filtered = filters[i](tr);
        if (filtered instanceof $6295c6875f57e3ee$export$febc5573c75cefb0) tr = filtered;
        else if (Array.isArray(filtered) && filtered.length == 1 && filtered[0] instanceof $6295c6875f57e3ee$export$febc5573c75cefb0) tr = filtered[0];
        else tr = $6295c6875f57e3ee$var$resolveTransaction(state, $6295c6875f57e3ee$var$asArray(filtered), false);
    }
    return tr;
}
function $6295c6875f57e3ee$var$extendTransaction(tr) {
    let state = tr.startState, extenders = state.facet($6295c6875f57e3ee$var$transactionExtender), spec = tr;
    for(let i = extenders.length - 1; i >= 0; i--){
        let extension = extenders[i](tr);
        if (extension && Object.keys(extension).length) spec = $6295c6875f57e3ee$var$mergeTransaction(spec, $6295c6875f57e3ee$var$resolveTransactionInner(state, extension, tr.changes.newLength), true);
    }
    return spec == tr ? tr : $6295c6875f57e3ee$export$febc5573c75cefb0.create(state, tr.changes, tr.selection, spec.effects, spec.annotations, spec.scrollIntoView);
}
const $6295c6875f57e3ee$var$none = [];
function $6295c6875f57e3ee$var$asArray(value) {
    return value == null ? $6295c6875f57e3ee$var$none : Array.isArray(value) ? value : [
        value
    ];
}
/**
The categories produced by a [character
categorizer](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer). These are used
do things like selecting by word.
*/ var $6295c6875f57e3ee$export$239a3d59567c1401 = /*@__PURE__*/ function(CharCategory) {
    /**
    Word characters.
    */ CharCategory[CharCategory["Word"] = 0] = "Word";
    /**
    Whitespace.
    */ CharCategory[CharCategory["Space"] = 1] = "Space";
    /**
    Anything else.
    */ CharCategory[CharCategory["Other"] = 2] = "Other";
    return CharCategory;
}($6295c6875f57e3ee$export$239a3d59567c1401 || ($6295c6875f57e3ee$export$239a3d59567c1401 = {}));
const $6295c6875f57e3ee$var$nonASCIISingleCaseWordChar = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
let $6295c6875f57e3ee$var$wordChar;
try {
    $6295c6875f57e3ee$var$wordChar = /*@__PURE__*/ new RegExp("[\\p{Alphabetic}\\p{Number}_]", "u");
} catch (_) {}
function $6295c6875f57e3ee$var$hasWordChar(str) {
    if ($6295c6875f57e3ee$var$wordChar) return $6295c6875f57e3ee$var$wordChar.test(str);
    for(let i = 0; i < str.length; i++){
        let ch = str[i];
        if (/\w/.test(ch) || ch > "\x80" && (ch.toUpperCase() != ch.toLowerCase() || $6295c6875f57e3ee$var$nonASCIISingleCaseWordChar.test(ch))) return true;
    }
    return false;
}
function $6295c6875f57e3ee$var$makeCategorizer(wordChars) {
    return (char)=>{
        if (!/\S/.test(char)) return $6295c6875f57e3ee$export$239a3d59567c1401.Space;
        if ($6295c6875f57e3ee$var$hasWordChar(char)) return $6295c6875f57e3ee$export$239a3d59567c1401.Word;
        for(let i = 0; i < wordChars.length; i++)if (char.indexOf(wordChars[i]) > -1) return $6295c6875f57e3ee$export$239a3d59567c1401.Word;
        return $6295c6875f57e3ee$export$239a3d59567c1401.Other;
    };
}
/**
The editor state class is a persistent (immutable) data structure.
To update a state, you [create](https://codemirror.net/6/docs/ref/#state.EditorState.update) a
[transaction](https://codemirror.net/6/docs/ref/#state.Transaction), which produces a _new_ state
instance, without modifying the original object.

As such, _never_ mutate properties of a state directly. That'll
just break things.
*/ class $6295c6875f57e3ee$export$afa855cbfaff27f2 {
    constructor(/**
    @internal
    */ config, /**
    The current document.
    */ doc, /**
    The current selection.
    */ selection, /**
    @internal
    */ values, computeSlot, tr){
        this.config = config;
        this.doc = doc;
        this.selection = selection;
        this.values = values;
        this.status = config.statusTemplate.slice();
        this.computeSlot = computeSlot;
        // Fill in the computed state immediately, so that further queries
        // for it made during the update return this state
        if (tr) tr._state = this;
        for(let i = 0; i < this.config.dynamicSlots.length; i++)$6295c6875f57e3ee$var$ensureAddr(this, i << 1);
        this.computeSlot = null;
    }
    field(field, require = true) {
        let addr = this.config.address[field.id];
        if (addr == null) {
            if (require) throw new RangeError("Field is not present in this state");
            return undefined;
        }
        $6295c6875f57e3ee$var$ensureAddr(this, addr);
        return $6295c6875f57e3ee$var$getAddr(this, addr);
    }
    /**
    Create a [transaction](https://codemirror.net/6/docs/ref/#state.Transaction) that updates this
    state. Any number of [transaction specs](https://codemirror.net/6/docs/ref/#state.TransactionSpec)
    can be passed. Unless
    [`sequential`](https://codemirror.net/6/docs/ref/#state.TransactionSpec.sequential) is set, the
    [changes](https://codemirror.net/6/docs/ref/#state.TransactionSpec.changes) (if any) of each spec
    are assumed to start in the _current_ document (not the document
    produced by previous specs), and its
    [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection) and
    [effects](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) are assumed to refer
    to the document created by its _own_ changes. The resulting
    transaction contains the combined effect of all the different
    specs. For [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection), later
    specs take precedence over earlier ones.
    */ update(...specs) {
        return $6295c6875f57e3ee$var$resolveTransaction(this, specs, true);
    }
    /**
    @internal
    */ applyTransaction(tr) {
        let conf = this.config, { base: base, compartments: compartments } = conf;
        for (let effect of tr.effects){
            if (effect.is($6295c6875f57e3ee$export$d51c0172eb2c2431.reconfigure)) {
                if (conf) {
                    compartments = new Map;
                    conf.compartments.forEach((val, key)=>compartments.set(key, val));
                    conf = null;
                }
                compartments.set(effect.value.compartment, effect.value.extension);
            } else if (effect.is($6295c6875f57e3ee$export$95000d4efaa4321f.reconfigure)) {
                conf = null;
                base = effect.value;
            } else if (effect.is($6295c6875f57e3ee$export$95000d4efaa4321f.appendConfig)) {
                conf = null;
                base = $6295c6875f57e3ee$var$asArray(base).concat(effect.value);
            }
        }
        let startValues;
        if (!conf) {
            conf = $6295c6875f57e3ee$var$Configuration.resolve(base, compartments, this);
            let intermediateState = new $6295c6875f57e3ee$export$afa855cbfaff27f2(conf, this.doc, this.selection, conf.dynamicSlots.map(()=>null), (state, slot)=>slot.reconfigure(state, this), null);
            startValues = intermediateState.values;
        } else startValues = tr.startState.values.slice();
        let selection = tr.startState.facet($6295c6875f57e3ee$var$allowMultipleSelections) ? tr.newSelection : tr.newSelection.asSingle();
        new $6295c6875f57e3ee$export$afa855cbfaff27f2(conf, tr.newDoc, selection, startValues, (state, slot)=>slot.update(state, tr), tr);
    }
    /**
    Create a [transaction spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec) that
    replaces every selection range with the given content.
    */ replaceSelection(text) {
        if (typeof text == "string") text = this.toText(text);
        return this.changeByRange((range)=>({
                changes: {
                    from: range.from,
                    to: range.to,
                    insert: text
                },
                range: $6295c6875f57e3ee$export$3bb1bd44aee62999.cursor(range.from + text.length)
            }));
    }
    /**
    Create a set of changes and a new selection by running the given
    function for each range in the active selection. The function
    can return an optional set of changes (in the coordinate space
    of the start document), plus an updated range (in the coordinate
    space of the document produced by the call's own changes). This
    method will merge all the changes and ranges into a single
    changeset and selection, and return it as a [transaction
    spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec), which can be passed to
    [`update`](https://codemirror.net/6/docs/ref/#state.EditorState.update).
    */ changeByRange(f) {
        let sel = this.selection;
        let result1 = f(sel.ranges[0]);
        let changes = this.changes(result1.changes), ranges = [
            result1.range
        ];
        let effects = $6295c6875f57e3ee$var$asArray(result1.effects);
        for(let i = 1; i < sel.ranges.length; i++){
            let result = f(sel.ranges[i]);
            let newChanges = this.changes(result.changes), newMapped = newChanges.map(changes);
            for(let j = 0; j < i; j++)ranges[j] = ranges[j].map(newMapped);
            let mapBy = changes.mapDesc(newChanges, true);
            ranges.push(result.range.map(mapBy));
            changes = changes.compose(newMapped);
            effects = $6295c6875f57e3ee$export$95000d4efaa4321f.mapEffects(effects, newMapped).concat($6295c6875f57e3ee$export$95000d4efaa4321f.mapEffects($6295c6875f57e3ee$var$asArray(result.effects), mapBy));
        }
        return {
            changes: changes,
            selection: $6295c6875f57e3ee$export$3bb1bd44aee62999.create(ranges, sel.mainIndex),
            effects: effects
        };
    }
    /**
    Create a [change set](https://codemirror.net/6/docs/ref/#state.ChangeSet) from the given change
    description, taking the state's document length and line
    separator into account.
    */ changes(spec = []) {
        if (spec instanceof $6295c6875f57e3ee$export$29d7fbdcb1f8b71c) return spec;
        return $6295c6875f57e3ee$export$29d7fbdcb1f8b71c.of(spec, this.doc.length, this.facet($6295c6875f57e3ee$export$afa855cbfaff27f2.lineSeparator));
    }
    /**
    Using the state's [line
    separator](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator), create a
    [`Text`](https://codemirror.net/6/docs/ref/#state.Text) instance from the given string.
    */ toText(string) {
        return $6295c6875f57e3ee$export$5f1af8db9871e1d6.of(string.split(this.facet($6295c6875f57e3ee$export$afa855cbfaff27f2.lineSeparator) || $6295c6875f57e3ee$var$DefaultSplit));
    }
    /**
    Return the given range of the document as a string.
    */ sliceDoc(from = 0, to = this.doc.length) {
        return this.doc.sliceString(from, to, this.lineBreak);
    }
    /**
    Get the value of a state [facet](https://codemirror.net/6/docs/ref/#state.Facet).
    */ facet(facet) {
        let addr = this.config.address[facet.id];
        if (addr == null) return facet.default;
        $6295c6875f57e3ee$var$ensureAddr(this, addr);
        return $6295c6875f57e3ee$var$getAddr(this, addr);
    }
    /**
    Convert this state to a JSON-serializable object. When custom
    fields should be serialized, you can pass them in as an object
    mapping property names (in the resulting object, which should
    not use `doc` or `selection`) to fields.
    */ toJSON(fields) {
        let result = {
            doc: this.sliceDoc(),
            selection: this.selection.toJSON()
        };
        if (fields) for(let prop in fields){
            let value = fields[prop];
            if (value instanceof $6295c6875f57e3ee$export$34381b1ce2130245 && this.config.address[value.id] != null) result[prop] = value.spec.toJSON(this.field(fields[prop]), this);
        }
        return result;
    }
    /**
    Deserialize a state from its JSON representation. When custom
    fields should be deserialized, pass the same object you passed
    to [`toJSON`](https://codemirror.net/6/docs/ref/#state.EditorState.toJSON) when serializing as
    third argument.
    */ static fromJSON(json, config = {}, fields) {
        if (!json || typeof json.doc != "string") throw new RangeError("Invalid JSON representation for EditorState");
        let fieldInit = [];
        if (fields) {
            for(let prop in fields)if (Object.prototype.hasOwnProperty.call(json, prop)) {
                let field = fields[prop], value = json[prop];
                fieldInit.push(field.init((state)=>field.spec.fromJSON(value, state)));
            }
        }
        return $6295c6875f57e3ee$export$afa855cbfaff27f2.create({
            doc: json.doc,
            selection: $6295c6875f57e3ee$export$3bb1bd44aee62999.fromJSON(json.selection),
            extensions: config.extensions ? fieldInit.concat([
                config.extensions
            ]) : fieldInit
        });
    }
    /**
    Create a new state. You'll usually only need this when
    initializing an editor—updated states are created by applying
    transactions.
    */ static create(config = {}) {
        let configuration = $6295c6875f57e3ee$var$Configuration.resolve(config.extensions || [], new Map);
        let doc = config.doc instanceof $6295c6875f57e3ee$export$5f1af8db9871e1d6 ? config.doc : $6295c6875f57e3ee$export$5f1af8db9871e1d6.of((config.doc || "").split(configuration.staticFacet($6295c6875f57e3ee$export$afa855cbfaff27f2.lineSeparator) || $6295c6875f57e3ee$var$DefaultSplit));
        let selection = !config.selection ? $6295c6875f57e3ee$export$3bb1bd44aee62999.single(0) : config.selection instanceof $6295c6875f57e3ee$export$3bb1bd44aee62999 ? config.selection : $6295c6875f57e3ee$export$3bb1bd44aee62999.single(config.selection.anchor, config.selection.head);
        $6295c6875f57e3ee$var$checkSelection(selection, doc.length);
        if (!configuration.staticFacet($6295c6875f57e3ee$var$allowMultipleSelections)) selection = selection.asSingle();
        return new $6295c6875f57e3ee$export$afa855cbfaff27f2(configuration, doc, selection, configuration.dynamicSlots.map(()=>null), (state, slot)=>slot.create(state), null);
    }
    /**
    The size (in columns) of a tab in the document, determined by
    the [`tabSize`](https://codemirror.net/6/docs/ref/#state.EditorState^tabSize) facet.
    */ get tabSize() {
        return this.facet($6295c6875f57e3ee$export$afa855cbfaff27f2.tabSize);
    }
    /**
    Get the proper [line-break](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator)
    string for this state.
    */ get lineBreak() {
        return this.facet($6295c6875f57e3ee$export$afa855cbfaff27f2.lineSeparator) || "\n";
    }
    /**
    Returns true when the editor is
    [configured](https://codemirror.net/6/docs/ref/#state.EditorState^readOnly) to be read-only.
    */ get readOnly() {
        return this.facet($6295c6875f57e3ee$var$readOnly);
    }
    /**
    Look up a translation for the given phrase (via the
    [`phrases`](https://codemirror.net/6/docs/ref/#state.EditorState^phrases) facet), or return the
    original string if no translation is found.
    
    If additional arguments are passed, they will be inserted in
    place of markers like `$1` (for the first value) and `$2`, etc.
    A single `$` is equivalent to `$1`, and `$$` will produce a
    literal dollar sign.
    */ phrase(phrase, ...insert) {
        for (let map of this.facet($6295c6875f57e3ee$export$afa855cbfaff27f2.phrases))if (Object.prototype.hasOwnProperty.call(map, phrase)) {
            phrase = map[phrase];
            break;
        }
        if (insert.length) phrase = phrase.replace(/\$(\$|\d*)/g, (m, i)=>{
            if (i == "$") return "$";
            let n = +(i || 1);
            return !n || n > insert.length ? m : insert[n - 1];
        });
        return phrase;
    }
    /**
    Find the values for a given language data field, provided by the
    the [`languageData`](https://codemirror.net/6/docs/ref/#state.EditorState^languageData) facet.
    
    Examples of language data fields are...
    
    - [`"commentTokens"`](https://codemirror.net/6/docs/ref/#commands.CommentTokens) for specifying
      comment syntax.
    - [`"autocomplete"`](https://codemirror.net/6/docs/ref/#autocomplete.autocompletion^config.override)
      for providing language-specific completion sources.
    - [`"wordChars"`](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) for adding
      characters that should be considered part of words in this
      language.
    - [`"closeBrackets"`](https://codemirror.net/6/docs/ref/#autocomplete.CloseBracketConfig) controls
      bracket closing behavior.
    */ languageDataAt(name, pos, side = -1) {
        let values = [];
        for (let provider of this.facet($6295c6875f57e3ee$var$languageData)){
            for (let result of provider(this, pos, side))if (Object.prototype.hasOwnProperty.call(result, name)) values.push(result[name]);
        }
        return values;
    }
    /**
    Return a function that can categorize strings (expected to
    represent a single [grapheme cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak))
    into one of:
    
     - Word (contains an alphanumeric character or a character
       explicitly listed in the local language's `"wordChars"`
       language data, which should be a string)
     - Space (contains only whitespace)
     - Other (anything else)
    */ charCategorizer(at) {
        let chars = this.languageDataAt("wordChars", at);
        return $6295c6875f57e3ee$var$makeCategorizer(chars.length ? chars[0] : "");
    }
    /**
    Find the word at the given position, meaning the range
    containing all [word](https://codemirror.net/6/docs/ref/#state.CharCategory.Word) characters
    around it. If no word characters are adjacent to the position,
    this returns null.
    */ wordAt(pos) {
        let { text: text, from: from, length: length } = this.doc.lineAt(pos);
        let cat = this.charCategorizer(pos);
        let start = pos - from, end = pos - from;
        while(start > 0){
            let prev = $6295c6875f57e3ee$export$a0fa439fd515e1ed(text, start, false);
            if (cat(text.slice(prev, start)) != $6295c6875f57e3ee$export$239a3d59567c1401.Word) break;
            start = prev;
        }
        while(end < length){
            let next = $6295c6875f57e3ee$export$a0fa439fd515e1ed(text, end);
            if (cat(text.slice(end, next)) != $6295c6875f57e3ee$export$239a3d59567c1401.Word) break;
            end = next;
        }
        return start == end ? null : $6295c6875f57e3ee$export$3bb1bd44aee62999.range(start + from, end + from);
    }
}
/**
A facet that, when enabled, causes the editor to allow multiple
ranges to be selected. Be careful though, because by default the
editor relies on the native DOM selection, which cannot handle
multiple selections. An extension like
[`drawSelection`](https://codemirror.net/6/docs/ref/#view.drawSelection) can be used to make
secondary selections visible to the user.
*/ $6295c6875f57e3ee$export$afa855cbfaff27f2.allowMultipleSelections = $6295c6875f57e3ee$var$allowMultipleSelections;
/**
Configures the tab size to use in this state. The first
(highest-precedence) value of the facet is used. If no value is
given, this defaults to 4.
*/ $6295c6875f57e3ee$export$afa855cbfaff27f2.tabSize = /*@__PURE__*/ $6295c6875f57e3ee$export$ef7d5e9b79fa1504.define({
    combine: (values)=>values.length ? values[0] : 4
});
/**
The line separator to use. By default, any of `"\n"`, `"\r\n"`
and `"\r"` is treated as a separator when splitting lines, and
lines are joined with `"\n"`.

When you configure a value here, only that precise separator
will be used, allowing you to round-trip documents through the
editor without normalizing line separators.
*/ $6295c6875f57e3ee$export$afa855cbfaff27f2.lineSeparator = $6295c6875f57e3ee$var$lineSeparator;
/**
This facet controls the value of the
[`readOnly`](https://codemirror.net/6/docs/ref/#state.EditorState.readOnly) getter, which is
consulted by commands and extensions that implement editing
functionality to determine whether they should apply. It
defaults to false, but when its highest-precedence value is
`true`, such functionality disables itself.

Not to be confused with
[`EditorView.editable`](https://codemirror.net/6/docs/ref/#view.EditorView^editable), which
controls whether the editor's DOM is set to be editable (and
thus focusable).
*/ $6295c6875f57e3ee$export$afa855cbfaff27f2.readOnly = $6295c6875f57e3ee$var$readOnly;
/**
Registers translation phrases. The
[`phrase`](https://codemirror.net/6/docs/ref/#state.EditorState.phrase) method will look through
all objects registered with this facet to find translations for
its argument.
*/ $6295c6875f57e3ee$export$afa855cbfaff27f2.phrases = /*@__PURE__*/ $6295c6875f57e3ee$export$ef7d5e9b79fa1504.define({
    compare (a, b) {
        let kA = Object.keys(a), kB = Object.keys(b);
        return kA.length == kB.length && kA.every((k)=>a[k] == b[k]);
    }
});
/**
A facet used to register [language
data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt) providers.
*/ $6295c6875f57e3ee$export$afa855cbfaff27f2.languageData = $6295c6875f57e3ee$var$languageData;
/**
Facet used to register change filters, which are called for each
transaction (unless explicitly
[disabled](https://codemirror.net/6/docs/ref/#state.TransactionSpec.filter)), and can suppress
part of the transaction's changes.

Such a function can return `true` to indicate that it doesn't
want to do anything, `false` to completely stop the changes in
the transaction, or a set of ranges in which changes should be
suppressed. Such ranges are represented as an array of numbers,
with each pair of two numbers indicating the start and end of a
range. So for example `[10, 20, 100, 110]` suppresses changes
between 10 and 20, and between 100 and 110.
*/ $6295c6875f57e3ee$export$afa855cbfaff27f2.changeFilter = $6295c6875f57e3ee$var$changeFilter;
/**
Facet used to register a hook that gets a chance to update or
replace transaction specs before they are applied. This will
only be applied for transactions that don't have
[`filter`](https://codemirror.net/6/docs/ref/#state.TransactionSpec.filter) set to `false`. You
can either return a single transaction spec (possibly the input
transaction), or an array of specs (which will be combined in
the same way as the arguments to
[`EditorState.update`](https://codemirror.net/6/docs/ref/#state.EditorState.update)).

When possible, it is recommended to avoid accessing
[`Transaction.state`](https://codemirror.net/6/docs/ref/#state.Transaction.state) in a filter,
since it will force creation of a state that will then be
discarded again, if the transaction is actually filtered.

(This functionality should be used with care. Indiscriminately
modifying transaction is likely to break something or degrade
the user experience.)
*/ $6295c6875f57e3ee$export$afa855cbfaff27f2.transactionFilter = $6295c6875f57e3ee$var$transactionFilter;
/**
This is a more limited form of
[`transactionFilter`](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter),
which can only add
[annotations](https://codemirror.net/6/docs/ref/#state.TransactionSpec.annotations) and
[effects](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects). _But_, this type
of filter runs even if the transaction has disabled regular
[filtering](https://codemirror.net/6/docs/ref/#state.TransactionSpec.filter), making it suitable
for effects that don't need to touch the changes or selection,
but do want to process every transaction.

Extenders run _after_ filters, when both are present.
*/ $6295c6875f57e3ee$export$afa855cbfaff27f2.transactionExtender = $6295c6875f57e3ee$var$transactionExtender;
$6295c6875f57e3ee$export$d51c0172eb2c2431.reconfigure = /*@__PURE__*/ $6295c6875f57e3ee$export$95000d4efaa4321f.define();
/**
Utility function for combining behaviors to fill in a config
object from an array of provided configs. `defaults` should hold
default values for all optional fields in `Config`.

The function will, by default, error
when a field gets two values that aren't `===`-equal, but you can
provide combine functions per field to do something else.
*/ function $6295c6875f57e3ee$export$4e19c0b693794a7e(configs, defaults, combine = {}) {
    let result = {};
    for (let config of configs)for (let key of Object.keys(config)){
        let value = config[key], current = result[key];
        if (current === undefined) result[key] = value;
        else if (current === value || value === undefined) ; // No conflict
        else if (Object.hasOwnProperty.call(combine, key)) result[key] = combine[key](current, value);
        else throw new Error("Config merge conflict for field " + key);
    }
    for(let key in defaults)if (result[key] === undefined) result[key] = defaults[key];
    return result;
}
/**
Each range is associated with a value, which must inherit from
this class.
*/ class $6295c6875f57e3ee$export$d60f08ed93a48611 {
    /**
    Compare this value with another value. Used when comparing
    rangesets. The default implementation compares by identity.
    Unless you are only creating a fixed number of unique instances
    of your value type, it is a good idea to implement this
    properly.
    */ eq(other) {
        return this == other;
    }
    /**
    Create a [range](https://codemirror.net/6/docs/ref/#state.Range) with this value.
    */ range(from, to = from) {
        return $6295c6875f57e3ee$export$9a58ef0d7ad3278c.create(from, to, this);
    }
}
$6295c6875f57e3ee$export$d60f08ed93a48611.prototype.startSide = $6295c6875f57e3ee$export$d60f08ed93a48611.prototype.endSide = 0;
$6295c6875f57e3ee$export$d60f08ed93a48611.prototype.point = false;
$6295c6875f57e3ee$export$d60f08ed93a48611.prototype.mapMode = $6295c6875f57e3ee$export$39cf3280165f92aa.TrackDel;
function $6295c6875f57e3ee$var$cmpVal(a, b) {
    return a == b || a.constructor == b.constructor && a.eq(b);
}
/**
A range associates a value with a range of positions.
*/ class $6295c6875f57e3ee$export$9a58ef0d7ad3278c {
    constructor(/**
    The range's start position.
    */ from, /**
    Its end position.
    */ to, /**
    The value associated with this range.
    */ value){
        this.from = from;
        this.to = to;
        this.value = value;
    }
    /**
    @internal
    */ static create(from, to, value) {
        return new $6295c6875f57e3ee$export$9a58ef0d7ad3278c(from, to, value);
    }
}
function $6295c6875f57e3ee$var$cmpRange(a, b) {
    return a.from - b.from || a.value.startSide - b.value.startSide;
}
class $6295c6875f57e3ee$var$Chunk {
    constructor(from, to, value, // Chunks are marked with the largest point that occurs
    // in them (or -1 for no points), so that scans that are
    // only interested in points (such as the
    // heightmap-related logic) can skip range-only chunks.
    maxPoint){
        this.from = from;
        this.to = to;
        this.value = value;
        this.maxPoint = maxPoint;
    }
    get length() {
        return this.to[this.to.length - 1];
    }
    // Find the index of the given position and side. Use the ranges'
    // `from` pos when `end == false`, `to` when `end == true`.
    findIndex(pos, side, end, startAt = 0) {
        let arr = end ? this.to : this.from;
        for(let lo = startAt, hi = arr.length;;){
            if (lo == hi) return lo;
            let mid = lo + hi >> 1;
            let diff = arr[mid] - pos || (end ? this.value[mid].endSide : this.value[mid].startSide) - side;
            if (mid == lo) return diff >= 0 ? lo : hi;
            if (diff >= 0) hi = mid;
            else lo = mid + 1;
        }
    }
    between(offset, from, to, f) {
        for(let i = this.findIndex(from, -1000000000 /* C.Far */ , true), e = this.findIndex(to, 1000000000 /* C.Far */ , false, i); i < e; i++)if (f(this.from[i] + offset, this.to[i] + offset, this.value[i]) === false) return false;
    }
    map(offset, changes) {
        let value = [], from = [], to = [], newPos = -1, maxPoint = -1;
        for(let i = 0; i < this.value.length; i++){
            let val = this.value[i], curFrom = this.from[i] + offset, curTo = this.to[i] + offset, newFrom, newTo;
            if (curFrom == curTo) {
                let mapped = changes.mapPos(curFrom, val.startSide, val.mapMode);
                if (mapped == null) continue;
                newFrom = newTo = mapped;
                if (val.startSide != val.endSide) {
                    newTo = changes.mapPos(curFrom, val.endSide);
                    if (newTo < newFrom) continue;
                }
            } else {
                newFrom = changes.mapPos(curFrom, val.startSide);
                newTo = changes.mapPos(curTo, val.endSide);
                if (newFrom > newTo || newFrom == newTo && val.startSide > 0 && val.endSide <= 0) continue;
            }
            if ((newTo - newFrom || val.endSide - val.startSide) < 0) continue;
            if (newPos < 0) newPos = newFrom;
            if (val.point) maxPoint = Math.max(maxPoint, newTo - newFrom);
            value.push(val);
            from.push(newFrom - newPos);
            to.push(newTo - newPos);
        }
        return {
            mapped: value.length ? new $6295c6875f57e3ee$var$Chunk(from, to, value, maxPoint) : null,
            pos: newPos
        };
    }
}
/**
A range set stores a collection of [ranges](https://codemirror.net/6/docs/ref/#state.Range) in a
way that makes them efficient to [map](https://codemirror.net/6/docs/ref/#state.RangeSet.map) and
[update](https://codemirror.net/6/docs/ref/#state.RangeSet.update). This is an immutable data
structure.
*/ class $6295c6875f57e3ee$export$34cb5241245008dd {
    constructor(/**
    @internal
    */ chunkPos, /**
    @internal
    */ chunk, /**
    @internal
    */ nextLayer, /**
    @internal
    */ maxPoint){
        this.chunkPos = chunkPos;
        this.chunk = chunk;
        this.nextLayer = nextLayer;
        this.maxPoint = maxPoint;
    }
    /**
    @internal
    */ static create(chunkPos, chunk, nextLayer, maxPoint) {
        return new $6295c6875f57e3ee$export$34cb5241245008dd(chunkPos, chunk, nextLayer, maxPoint);
    }
    /**
    @internal
    */ get length() {
        let last = this.chunk.length - 1;
        return last < 0 ? 0 : Math.max(this.chunkEnd(last), this.nextLayer.length);
    }
    /**
    The number of ranges in the set.
    */ get size() {
        if (this.isEmpty) return 0;
        let size = this.nextLayer.size;
        for (let chunk of this.chunk)size += chunk.value.length;
        return size;
    }
    /**
    @internal
    */ chunkEnd(index) {
        return this.chunkPos[index] + this.chunk[index].length;
    }
    /**
    Update the range set, optionally adding new ranges or filtering
    out existing ones.
    
    (Note: The type parameter is just there as a kludge to work
    around TypeScript variance issues that prevented `RangeSet<X>`
    from being a subtype of `RangeSet<Y>` when `X` is a subtype of
    `Y`.)
    */ update(updateSpec) {
        let { add: add = [], sort: sort = false, filterFrom: filterFrom = 0, filterTo: filterTo = this.length } = updateSpec;
        let filter = updateSpec.filter;
        if (add.length == 0 && !filter) return this;
        if (sort) add = add.slice().sort($6295c6875f57e3ee$var$cmpRange);
        if (this.isEmpty) return add.length ? $6295c6875f57e3ee$export$34cb5241245008dd.of(add) : this;
        let cur = new $6295c6875f57e3ee$var$LayerCursor(this, null, -1).goto(0), i = 0, spill = [];
        let builder = new $6295c6875f57e3ee$export$89e09ce03c7e8594();
        while(cur.value || i < add.length){
            if (i < add.length && (cur.from - add[i].from || cur.startSide - add[i].value.startSide) >= 0) {
                let range = add[i++];
                if (!builder.addInner(range.from, range.to, range.value)) spill.push(range);
            } else if (cur.rangeIndex == 1 && cur.chunkIndex < this.chunk.length && (i == add.length || this.chunkEnd(cur.chunkIndex) < add[i].from) && (!filter || filterFrom > this.chunkEnd(cur.chunkIndex) || filterTo < this.chunkPos[cur.chunkIndex]) && builder.addChunk(this.chunkPos[cur.chunkIndex], this.chunk[cur.chunkIndex])) cur.nextChunk();
            else {
                if (!filter || filterFrom > cur.to || filterTo < cur.from || filter(cur.from, cur.to, cur.value)) {
                    if (!builder.addInner(cur.from, cur.to, cur.value)) spill.push($6295c6875f57e3ee$export$9a58ef0d7ad3278c.create(cur.from, cur.to, cur.value));
                }
                cur.next();
            }
        }
        return builder.finishInner(this.nextLayer.isEmpty && !spill.length ? $6295c6875f57e3ee$export$34cb5241245008dd.empty : this.nextLayer.update({
            add: spill,
            filter: filter,
            filterFrom: filterFrom,
            filterTo: filterTo
        }));
    }
    /**
    Map this range set through a set of changes, return the new set.
    */ map(changes) {
        if (changes.empty || this.isEmpty) return this;
        let chunks = [], chunkPos = [], maxPoint = -1;
        for(let i = 0; i < this.chunk.length; i++){
            let start = this.chunkPos[i], chunk = this.chunk[i];
            let touch = changes.touchesRange(start, start + chunk.length);
            if (touch === false) {
                maxPoint = Math.max(maxPoint, chunk.maxPoint);
                chunks.push(chunk);
                chunkPos.push(changes.mapPos(start));
            } else if (touch === true) {
                let { mapped: mapped, pos: pos } = chunk.map(start, changes);
                if (mapped) {
                    maxPoint = Math.max(maxPoint, mapped.maxPoint);
                    chunks.push(mapped);
                    chunkPos.push(pos);
                }
            }
        }
        let next = this.nextLayer.map(changes);
        return chunks.length == 0 ? next : new $6295c6875f57e3ee$export$34cb5241245008dd(chunkPos, chunks, next || $6295c6875f57e3ee$export$34cb5241245008dd.empty, maxPoint);
    }
    /**
    Iterate over the ranges that touch the region `from` to `to`,
    calling `f` for each. There is no guarantee that the ranges will
    be reported in any specific order. When the callback returns
    `false`, iteration stops.
    */ between(from, to, f) {
        if (this.isEmpty) return;
        for(let i = 0; i < this.chunk.length; i++){
            let start = this.chunkPos[i], chunk = this.chunk[i];
            if (to >= start && from <= start + chunk.length && chunk.between(start, from - start, to - start, f) === false) return;
        }
        this.nextLayer.between(from, to, f);
    }
    /**
    Iterate over the ranges in this set, in order, including all
    ranges that end at or after `from`.
    */ iter(from = 0) {
        return $6295c6875f57e3ee$var$HeapCursor.from([
            this
        ]).goto(from);
    }
    /**
    @internal
    */ get isEmpty() {
        return this.nextLayer == this;
    }
    /**
    Iterate over the ranges in a collection of sets, in order,
    starting from `from`.
    */ static iter(sets, from = 0) {
        return $6295c6875f57e3ee$var$HeapCursor.from(sets).goto(from);
    }
    /**
    Iterate over two groups of sets, calling methods on `comparator`
    to notify it of possible differences.
    */ static compare(oldSets, newSets, /**
    This indicates how the underlying data changed between these
    ranges, and is needed to synchronize the iteration.
    */ textDiff, comparator, /**
    Can be used to ignore all non-point ranges, and points below
    the given size. When -1, all ranges are compared.
    */ minPointSize = -1) {
        let a = oldSets.filter((set)=>set.maxPoint > 0 || !set.isEmpty && set.maxPoint >= minPointSize);
        let b = newSets.filter((set)=>set.maxPoint > 0 || !set.isEmpty && set.maxPoint >= minPointSize);
        let sharedChunks = $6295c6875f57e3ee$var$findSharedChunks(a, b, textDiff);
        let sideA = new $6295c6875f57e3ee$var$SpanCursor(a, sharedChunks, minPointSize);
        let sideB = new $6295c6875f57e3ee$var$SpanCursor(b, sharedChunks, minPointSize);
        textDiff.iterGaps((fromA, fromB, length)=>$6295c6875f57e3ee$var$compare(sideA, fromA, sideB, fromB, length, comparator));
        if (textDiff.empty && textDiff.length == 0) $6295c6875f57e3ee$var$compare(sideA, 0, sideB, 0, 0, comparator);
    }
    /**
    Compare the contents of two groups of range sets, returning true
    if they are equivalent in the given range.
    */ static eq(oldSets, newSets, from = 0, to) {
        if (to == null) to = 999999999;
        let a = oldSets.filter((set)=>!set.isEmpty && newSets.indexOf(set) < 0);
        let b = newSets.filter((set)=>!set.isEmpty && oldSets.indexOf(set) < 0);
        if (a.length != b.length) return false;
        if (!a.length) return true;
        let sharedChunks = $6295c6875f57e3ee$var$findSharedChunks(a, b);
        let sideA = new $6295c6875f57e3ee$var$SpanCursor(a, sharedChunks, 0).goto(from), sideB = new $6295c6875f57e3ee$var$SpanCursor(b, sharedChunks, 0).goto(from);
        for(;;){
            if (sideA.to != sideB.to || !$6295c6875f57e3ee$var$sameValues(sideA.active, sideB.active) || sideA.point && (!sideB.point || !$6295c6875f57e3ee$var$cmpVal(sideA.point, sideB.point))) return false;
            if (sideA.to > to) return true;
            sideA.next();
            sideB.next();
        }
    }
    /**
    Iterate over a group of range sets at the same time, notifying
    the iterator about the ranges covering every given piece of
    content. Returns the open count (see
    [`SpanIterator.span`](https://codemirror.net/6/docs/ref/#state.SpanIterator.span)) at the end
    of the iteration.
    */ static spans(sets, from, to, iterator, /**
    When given and greater than -1, only points of at least this
    size are taken into account.
    */ minPointSize = -1) {
        let cursor = new $6295c6875f57e3ee$var$SpanCursor(sets, null, minPointSize).goto(from), pos = from;
        let openRanges = cursor.openStart;
        for(;;){
            let curTo = Math.min(cursor.to, to);
            if (cursor.point) {
                let active = cursor.activeForPoint(cursor.to);
                let openCount = cursor.pointFrom < from ? active.length + 1 : cursor.point.startSide < 0 ? active.length : Math.min(active.length, openRanges);
                iterator.point(pos, curTo, cursor.point, active, openCount, cursor.pointRank);
                openRanges = Math.min(cursor.openEnd(curTo), active.length);
            } else if (curTo > pos) {
                iterator.span(pos, curTo, cursor.active, openRanges);
                openRanges = cursor.openEnd(curTo);
            }
            if (cursor.to > to) return openRanges + (cursor.point && cursor.to > to ? 1 : 0);
            pos = cursor.to;
            cursor.next();
        }
    }
    /**
    Create a range set for the given range or array of ranges. By
    default, this expects the ranges to be _sorted_ (by start
    position and, if two start at the same position,
    `value.startSide`). You can pass `true` as second argument to
    cause the method to sort them.
    */ static of(ranges, sort = false) {
        let build = new $6295c6875f57e3ee$export$89e09ce03c7e8594();
        for (let range of ranges instanceof $6295c6875f57e3ee$export$9a58ef0d7ad3278c ? [
            ranges
        ] : sort ? $6295c6875f57e3ee$var$lazySort(ranges) : ranges)build.add(range.from, range.to, range.value);
        return build.finish();
    }
    /**
    Join an array of range sets into a single set.
    */ static join(sets) {
        if (!sets.length) return $6295c6875f57e3ee$export$34cb5241245008dd.empty;
        let result = sets[sets.length - 1];
        for(let i = sets.length - 2; i >= 0; i--)for(let layer = sets[i]; layer != $6295c6875f57e3ee$export$34cb5241245008dd.empty; layer = layer.nextLayer)result = new $6295c6875f57e3ee$export$34cb5241245008dd(layer.chunkPos, layer.chunk, result, Math.max(layer.maxPoint, result.maxPoint));
        return result;
    }
}
/**
The empty set of ranges.
*/ $6295c6875f57e3ee$export$34cb5241245008dd.empty = /*@__PURE__*/ new $6295c6875f57e3ee$export$34cb5241245008dd([], [], null, -1);
function $6295c6875f57e3ee$var$lazySort(ranges) {
    if (ranges.length > 1) for(let prev = ranges[0], i = 1; i < ranges.length; i++){
        let cur = ranges[i];
        if ($6295c6875f57e3ee$var$cmpRange(prev, cur) > 0) return ranges.slice().sort($6295c6875f57e3ee$var$cmpRange);
        prev = cur;
    }
    return ranges;
}
$6295c6875f57e3ee$export$34cb5241245008dd.empty.nextLayer = $6295c6875f57e3ee$export$34cb5241245008dd.empty;
/**
A range set builder is a data structure that helps build up a
[range set](https://codemirror.net/6/docs/ref/#state.RangeSet) directly, without first allocating
an array of [`Range`](https://codemirror.net/6/docs/ref/#state.Range) objects.
*/ class $6295c6875f57e3ee$export$89e09ce03c7e8594 {
    finishChunk(newArrays) {
        this.chunks.push(new $6295c6875f57e3ee$var$Chunk(this.from, this.to, this.value, this.maxPoint));
        this.chunkPos.push(this.chunkStart);
        this.chunkStart = -1;
        this.setMaxPoint = Math.max(this.setMaxPoint, this.maxPoint);
        this.maxPoint = -1;
        if (newArrays) {
            this.from = [];
            this.to = [];
            this.value = [];
        }
    }
    /**
    Create an empty builder.
    */ constructor(){
        this.chunks = [];
        this.chunkPos = [];
        this.chunkStart = -1;
        this.last = null;
        this.lastFrom = -1000000000 /* C.Far */ ;
        this.lastTo = -1000000000 /* C.Far */ ;
        this.from = [];
        this.to = [];
        this.value = [];
        this.maxPoint = -1;
        this.setMaxPoint = -1;
        this.nextLayer = null;
    }
    /**
    Add a range. Ranges should be added in sorted (by `from` and
    `value.startSide`) order.
    */ add(from, to, value) {
        if (!this.addInner(from, to, value)) (this.nextLayer || (this.nextLayer = new $6295c6875f57e3ee$export$89e09ce03c7e8594)).add(from, to, value);
    }
    /**
    @internal
    */ addInner(from, to, value) {
        let diff = from - this.lastTo || value.startSide - this.last.endSide;
        if (diff <= 0 && (from - this.lastFrom || value.startSide - this.last.startSide) < 0) throw new Error("Ranges must be added sorted by `from` position and `startSide`");
        if (diff < 0) return false;
        if (this.from.length == 250 /* C.ChunkSize */ ) this.finishChunk(true);
        if (this.chunkStart < 0) this.chunkStart = from;
        this.from.push(from - this.chunkStart);
        this.to.push(to - this.chunkStart);
        this.last = value;
        this.lastFrom = from;
        this.lastTo = to;
        this.value.push(value);
        if (value.point) this.maxPoint = Math.max(this.maxPoint, to - from);
        return true;
    }
    /**
    @internal
    */ addChunk(from, chunk) {
        if ((from - this.lastTo || chunk.value[0].startSide - this.last.endSide) < 0) return false;
        if (this.from.length) this.finishChunk(true);
        this.setMaxPoint = Math.max(this.setMaxPoint, chunk.maxPoint);
        this.chunks.push(chunk);
        this.chunkPos.push(from);
        let last = chunk.value.length - 1;
        this.last = chunk.value[last];
        this.lastFrom = chunk.from[last] + from;
        this.lastTo = chunk.to[last] + from;
        return true;
    }
    /**
    Finish the range set. Returns the new set. The builder can't be
    used anymore after this has been called.
    */ finish() {
        return this.finishInner($6295c6875f57e3ee$export$34cb5241245008dd.empty);
    }
    /**
    @internal
    */ finishInner(next) {
        if (this.from.length) this.finishChunk(false);
        if (this.chunks.length == 0) return next;
        let result = $6295c6875f57e3ee$export$34cb5241245008dd.create(this.chunkPos, this.chunks, this.nextLayer ? this.nextLayer.finishInner(next) : next, this.setMaxPoint);
        this.from = null; // Make sure further `add` calls produce errors
        return result;
    }
}
function $6295c6875f57e3ee$var$findSharedChunks(a, b, textDiff) {
    let inA = new Map();
    for (let set of a)for(let i = 0; i < set.chunk.length; i++)if (set.chunk[i].maxPoint <= 0) inA.set(set.chunk[i], set.chunkPos[i]);
    let shared = new Set();
    for (let set of b)for(let i = 0; i < set.chunk.length; i++){
        let known = inA.get(set.chunk[i]);
        if (known != null && (textDiff ? textDiff.mapPos(known) : known) == set.chunkPos[i] && !(textDiff === null || textDiff === void 0 ? void 0 : textDiff.touchesRange(known, known + set.chunk[i].length))) shared.add(set.chunk[i]);
    }
    return shared;
}
class $6295c6875f57e3ee$var$LayerCursor {
    constructor(layer, skip, minPoint, rank = 0){
        this.layer = layer;
        this.skip = skip;
        this.minPoint = minPoint;
        this.rank = rank;
    }
    get startSide() {
        return this.value ? this.value.startSide : 0;
    }
    get endSide() {
        return this.value ? this.value.endSide : 0;
    }
    goto(pos, side = -1000000000 /* C.Far */ ) {
        this.chunkIndex = this.rangeIndex = 0;
        this.gotoInner(pos, side, false);
        return this;
    }
    gotoInner(pos, side, forward) {
        while(this.chunkIndex < this.layer.chunk.length){
            let next = this.layer.chunk[this.chunkIndex];
            if (!(this.skip && this.skip.has(next) || this.layer.chunkEnd(this.chunkIndex) < pos || next.maxPoint < this.minPoint)) break;
            this.chunkIndex++;
            forward = false;
        }
        if (this.chunkIndex < this.layer.chunk.length) {
            let rangeIndex = this.layer.chunk[this.chunkIndex].findIndex(pos - this.layer.chunkPos[this.chunkIndex], side, true);
            if (!forward || this.rangeIndex < rangeIndex) this.setRangeIndex(rangeIndex);
        }
        this.next();
    }
    forward(pos, side) {
        if ((this.to - pos || this.endSide - side) < 0) this.gotoInner(pos, side, true);
    }
    next() {
        for(;;)if (this.chunkIndex == this.layer.chunk.length) {
            this.from = this.to = 1000000000 /* C.Far */ ;
            this.value = null;
            break;
        } else {
            let chunkPos = this.layer.chunkPos[this.chunkIndex], chunk = this.layer.chunk[this.chunkIndex];
            let from = chunkPos + chunk.from[this.rangeIndex];
            this.from = from;
            this.to = chunkPos + chunk.to[this.rangeIndex];
            this.value = chunk.value[this.rangeIndex];
            this.setRangeIndex(this.rangeIndex + 1);
            if (this.minPoint < 0 || this.value.point && this.to - this.from >= this.minPoint) break;
        }
    }
    setRangeIndex(index) {
        if (index == this.layer.chunk[this.chunkIndex].value.length) {
            this.chunkIndex++;
            if (this.skip) while(this.chunkIndex < this.layer.chunk.length && this.skip.has(this.layer.chunk[this.chunkIndex]))this.chunkIndex++;
            this.rangeIndex = 0;
        } else this.rangeIndex = index;
    }
    nextChunk() {
        this.chunkIndex++;
        this.rangeIndex = 0;
        this.next();
    }
    compare(other) {
        return this.from - other.from || this.startSide - other.startSide || this.rank - other.rank || this.to - other.to || this.endSide - other.endSide;
    }
}
class $6295c6875f57e3ee$var$HeapCursor {
    constructor(heap){
        this.heap = heap;
    }
    static from(sets, skip = null, minPoint = -1) {
        let heap = [];
        for(let i = 0; i < sets.length; i++){
            for(let cur = sets[i]; !cur.isEmpty; cur = cur.nextLayer)if (cur.maxPoint >= minPoint) heap.push(new $6295c6875f57e3ee$var$LayerCursor(cur, skip, minPoint, i));
        }
        return heap.length == 1 ? heap[0] : new $6295c6875f57e3ee$var$HeapCursor(heap);
    }
    get startSide() {
        return this.value ? this.value.startSide : 0;
    }
    goto(pos, side = -1000000000 /* C.Far */ ) {
        for (let cur of this.heap)cur.goto(pos, side);
        for(let i = this.heap.length >> 1; i >= 0; i--)$6295c6875f57e3ee$var$heapBubble(this.heap, i);
        this.next();
        return this;
    }
    forward(pos, side) {
        for (let cur of this.heap)cur.forward(pos, side);
        for(let i = this.heap.length >> 1; i >= 0; i--)$6295c6875f57e3ee$var$heapBubble(this.heap, i);
        if ((this.to - pos || this.value.endSide - side) < 0) this.next();
    }
    next() {
        if (this.heap.length == 0) {
            this.from = this.to = 1000000000 /* C.Far */ ;
            this.value = null;
            this.rank = -1;
        } else {
            let top = this.heap[0];
            this.from = top.from;
            this.to = top.to;
            this.value = top.value;
            this.rank = top.rank;
            if (top.value) top.next();
            $6295c6875f57e3ee$var$heapBubble(this.heap, 0);
        }
    }
}
function $6295c6875f57e3ee$var$heapBubble(heap, index) {
    for(let cur = heap[index];;){
        let childIndex = (index << 1) + 1;
        if (childIndex >= heap.length) break;
        let child = heap[childIndex];
        if (childIndex + 1 < heap.length && child.compare(heap[childIndex + 1]) >= 0) {
            child = heap[childIndex + 1];
            childIndex++;
        }
        if (cur.compare(child) < 0) break;
        heap[childIndex] = cur;
        heap[index] = child;
        index = childIndex;
    }
}
class $6295c6875f57e3ee$var$SpanCursor {
    constructor(sets, skip, minPoint){
        this.minPoint = minPoint;
        this.active = [];
        this.activeTo = [];
        this.activeRank = [];
        this.minActive = -1;
        // A currently active point range, if any
        this.point = null;
        this.pointFrom = 0;
        this.pointRank = 0;
        this.to = -1000000000 /* C.Far */ ;
        this.endSide = 0;
        // The amount of open active ranges at the start of the iterator.
        // Not including points.
        this.openStart = -1;
        this.cursor = $6295c6875f57e3ee$var$HeapCursor.from(sets, skip, minPoint);
    }
    goto(pos, side = -1000000000 /* C.Far */ ) {
        this.cursor.goto(pos, side);
        this.active.length = this.activeTo.length = this.activeRank.length = 0;
        this.minActive = -1;
        this.to = pos;
        this.endSide = side;
        this.openStart = -1;
        this.next();
        return this;
    }
    forward(pos, side) {
        while(this.minActive > -1 && (this.activeTo[this.minActive] - pos || this.active[this.minActive].endSide - side) < 0)this.removeActive(this.minActive);
        this.cursor.forward(pos, side);
    }
    removeActive(index) {
        $6295c6875f57e3ee$var$remove(this.active, index);
        $6295c6875f57e3ee$var$remove(this.activeTo, index);
        $6295c6875f57e3ee$var$remove(this.activeRank, index);
        this.minActive = $6295c6875f57e3ee$var$findMinIndex(this.active, this.activeTo);
    }
    addActive(trackOpen) {
        let i = 0, { value: value, to: to, rank: rank } = this.cursor;
        // Organize active marks by rank first, then by size
        while(i < this.activeRank.length && (rank - this.activeRank[i] || to - this.activeTo[i]) > 0)i++;
        $6295c6875f57e3ee$var$insert(this.active, i, value);
        $6295c6875f57e3ee$var$insert(this.activeTo, i, to);
        $6295c6875f57e3ee$var$insert(this.activeRank, i, rank);
        if (trackOpen) $6295c6875f57e3ee$var$insert(trackOpen, i, this.cursor.from);
        this.minActive = $6295c6875f57e3ee$var$findMinIndex(this.active, this.activeTo);
    }
    // After calling this, if `this.point` != null, the next range is a
    // point. Otherwise, it's a regular range, covered by `this.active`.
    next() {
        let from = this.to, wasPoint = this.point;
        this.point = null;
        let trackOpen = this.openStart < 0 ? [] : null;
        for(;;){
            let a = this.minActive;
            if (a > -1 && (this.activeTo[a] - this.cursor.from || this.active[a].endSide - this.cursor.startSide) < 0) {
                if (this.activeTo[a] > from) {
                    this.to = this.activeTo[a];
                    this.endSide = this.active[a].endSide;
                    break;
                }
                this.removeActive(a);
                if (trackOpen) $6295c6875f57e3ee$var$remove(trackOpen, a);
            } else if (!this.cursor.value) {
                this.to = this.endSide = 1000000000 /* C.Far */ ;
                break;
            } else if (this.cursor.from > from) {
                this.to = this.cursor.from;
                this.endSide = this.cursor.startSide;
                break;
            } else {
                let nextVal = this.cursor.value;
                if (!nextVal.point) {
                    this.addActive(trackOpen);
                    this.cursor.next();
                } else if (wasPoint && this.cursor.to == this.to && this.cursor.from < this.cursor.to) // Ignore any non-empty points that end precisely at the end of the prev point
                this.cursor.next();
                else {
                    this.point = nextVal;
                    this.pointFrom = this.cursor.from;
                    this.pointRank = this.cursor.rank;
                    this.to = this.cursor.to;
                    this.endSide = nextVal.endSide;
                    this.cursor.next();
                    this.forward(this.to, this.endSide);
                    break;
                }
            }
        }
        if (trackOpen) {
            this.openStart = 0;
            for(let i = trackOpen.length - 1; i >= 0 && trackOpen[i] < from; i--)this.openStart++;
        }
    }
    activeForPoint(to) {
        if (!this.active.length) return this.active;
        let active = [];
        for(let i = this.active.length - 1; i >= 0; i--){
            if (this.activeRank[i] < this.pointRank) break;
            if (this.activeTo[i] > to || this.activeTo[i] == to && this.active[i].endSide >= this.point.endSide) active.push(this.active[i]);
        }
        return active.reverse();
    }
    openEnd(to) {
        let open = 0;
        for(let i = this.activeTo.length - 1; i >= 0 && this.activeTo[i] > to; i--)open++;
        return open;
    }
}
function $6295c6875f57e3ee$var$compare(a, startA, b, startB, length, comparator) {
    a.goto(startA);
    b.goto(startB);
    let endB = startB + length;
    let pos = startB, dPos = startB - startA;
    let bounds = !!comparator.boundChange;
    for(let boundChange = false;;){
        let dEnd = a.to + dPos - b.to, diff = dEnd || a.endSide - b.endSide;
        let end = diff < 0 ? a.to + dPos : b.to, clipEnd = Math.min(end, endB);
        let point = a.point || b.point;
        if (point) {
            if (!(a.point && b.point && $6295c6875f57e3ee$var$cmpVal(a.point, b.point) && $6295c6875f57e3ee$var$sameValues(a.activeForPoint(a.to), b.activeForPoint(b.to)))) comparator.comparePoint(pos, clipEnd, a.point, b.point);
            boundChange = false;
        } else {
            if (boundChange) comparator.boundChange(pos);
            if (clipEnd > pos && !$6295c6875f57e3ee$var$sameValues(a.active, b.active)) comparator.compareRange(pos, clipEnd, a.active, b.active);
            if (bounds && clipEnd < endB && (dEnd || a.openEnd(end) != b.openEnd(end))) boundChange = true;
        }
        if (end > endB) break;
        pos = end;
        if (diff <= 0) a.next();
        if (diff >= 0) b.next();
    }
}
function $6295c6875f57e3ee$var$sameValues(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (a[i] != b[i] && !$6295c6875f57e3ee$var$cmpVal(a[i], b[i])) return false;
    return true;
}
function $6295c6875f57e3ee$var$remove(array, index) {
    for(let i = index, e = array.length - 1; i < e; i++)array[i] = array[i + 1];
    array.pop();
}
function $6295c6875f57e3ee$var$insert(array, index, value) {
    for(let i = array.length - 1; i >= index; i--)array[i + 1] = array[i];
    array[index] = value;
}
function $6295c6875f57e3ee$var$findMinIndex(value, array) {
    let found = -1, foundPos = 1000000000 /* C.Far */ ;
    for(let i = 0; i < array.length; i++)if ((array[i] - foundPos || value[i].endSide - value[found].endSide) < 0) {
        found = i;
        foundPos = array[i];
    }
    return found;
}
/**
Count the column position at the given offset into the string,
taking extending characters and tab size into account.
*/ function $6295c6875f57e3ee$export$20b4ab289374d0ac(string, tabSize, to = string.length) {
    let n = 0;
    for(let i = 0; i < to && i < string.length;)if (string.charCodeAt(i) == 9) {
        n += tabSize - n % tabSize;
        i++;
    } else {
        n++;
        i = $6295c6875f57e3ee$export$a0fa439fd515e1ed(string, i);
    }
    return n;
}
/**
Find the offset that corresponds to the given column position in a
string, taking extending characters and tab size into account. By
default, the string length is returned when it is too short to
reach the column. Pass `strict` true to make it return -1 in that
situation.
*/ function $6295c6875f57e3ee$export$718b3d71c384ca05(string, col, tabSize, strict) {
    for(let i = 0, n = 0;;){
        if (n >= col) return i;
        if (i == string.length) break;
        n += string.charCodeAt(i) == 9 ? tabSize - n % tabSize : 1;
        i = $6295c6875f57e3ee$export$a0fa439fd515e1ed(string, i);
    }
    return strict === true ? -1 : string.length;
}



const $afd7c6da9f842a17$var$C = "\u037c";
const $afd7c6da9f842a17$var$COUNT = typeof Symbol == "undefined" ? "__" + $afd7c6da9f842a17$var$C : Symbol.for($afd7c6da9f842a17$var$C);
const $afd7c6da9f842a17$var$SET = typeof Symbol == "undefined" ? "__styleSet" + Math.floor(Math.random() * 1e8) : Symbol("styleSet");
const $afd7c6da9f842a17$var$top = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : {};
class $afd7c6da9f842a17$export$b920c662d2efee20 {
    // :: (Object<Style>, ?{finish: ?(string) → string})
    // Create a style module from the given spec.
    //
    // When `finish` is given, it is called on regular (non-`@`)
    // selectors (after `&` expansion) to compute the final selector.
    constructor(spec, options){
        this.rules = [];
        let { finish: finish } = options || {};
        function splitSelector(selector) {
            return /^@/.test(selector) ? [
                selector
            ] : selector.split(/,\s*/);
        }
        function render(selectors, spec, target, isKeyframes) {
            let local = [], isAt = /^@(\w+)\b/.exec(selectors[0]), keyframes = isAt && isAt[1] == "keyframes";
            if (isAt && spec == null) return target.push(selectors[0] + ";");
            for(let prop in spec){
                let value = spec[prop];
                if (/&/.test(prop)) render(prop.split(/,\s*/).map((part)=>selectors.map((sel)=>part.replace(/&/, sel))).reduce((a, b)=>a.concat(b)), value, target);
                else if (value && typeof value == "object") {
                    if (!isAt) throw new RangeError("The value of a property (" + prop + ") should be a primitive value.");
                    render(splitSelector(prop), value, local, keyframes);
                } else if (value != null) local.push(prop.replace(/_.*/, "").replace(/[A-Z]/g, (l)=>"-" + l.toLowerCase()) + ": " + value + ";");
            }
            if (local.length || keyframes) target.push((finish && !isAt && !isKeyframes ? selectors.map(finish) : selectors).join(", ") + " {" + local.join(" ") + "}");
        }
        for(let prop in spec)render(splitSelector(prop), spec[prop], this.rules);
    }
    // :: () → string
    // Returns a string containing the module's CSS rules.
    getRules() {
        return this.rules.join("\n");
    }
    // :: () → string
    // Generate a new unique CSS class name.
    static newName() {
        let id = $afd7c6da9f842a17$var$top[$afd7c6da9f842a17$var$COUNT] || 1;
        $afd7c6da9f842a17$var$top[$afd7c6da9f842a17$var$COUNT] = id + 1;
        return $afd7c6da9f842a17$var$C + id.toString(36);
    }
    // :: (union<Document, ShadowRoot>, union<[StyleModule], StyleModule>, ?{nonce: ?string})
    //
    // Mount the given set of modules in the given DOM root, which ensures
    // that the CSS rules defined by the module are available in that
    // context.
    //
    // Rules are only added to the document once per root.
    //
    // Rule order will follow the order of the modules, so that rules from
    // modules later in the array take precedence of those from earlier
    // modules. If you call this function multiple times for the same root
    // in a way that changes the order of already mounted modules, the old
    // order will be changed.
    //
    // If a Content Security Policy nonce is provided, it is added to
    // the `<style>` tag generated by the library.
    static mount(root, modules, options) {
        let set = root[$afd7c6da9f842a17$var$SET], nonce = options && options.nonce;
        if (!set) set = new $afd7c6da9f842a17$var$StyleSet(root, nonce);
        else if (nonce) set.setNonce(nonce);
        set.mount(Array.isArray(modules) ? modules : [
            modules
        ], root);
    }
}
let $afd7c6da9f842a17$var$adoptedSet = new Map //<Document, StyleSet>
;
class $afd7c6da9f842a17$var$StyleSet {
    constructor(root, nonce){
        let doc = root.ownerDocument || root, win = doc.defaultView;
        if (!root.head && root.adoptedStyleSheets && win.CSSStyleSheet) {
            let adopted = $afd7c6da9f842a17$var$adoptedSet.get(doc);
            if (adopted) return root[$afd7c6da9f842a17$var$SET] = adopted;
            this.sheet = new win.CSSStyleSheet;
            $afd7c6da9f842a17$var$adoptedSet.set(doc, this);
        } else {
            this.styleTag = doc.createElement("style");
            if (nonce) this.styleTag.setAttribute("nonce", nonce);
        }
        this.modules = [];
        root[$afd7c6da9f842a17$var$SET] = this;
    }
    mount(modules, root) {
        let sheet = this.sheet;
        let pos = 0 /* Current rule offset */ , j = 0 /* Index into this.modules */ ;
        for(let i = 0; i < modules.length; i++){
            let mod = modules[i], index = this.modules.indexOf(mod);
            if (index < j && index > -1) {
                this.modules.splice(index, 1);
                j--;
                index = -1;
            }
            if (index == -1) {
                this.modules.splice(j++, 0, mod);
                if (sheet) for(let k = 0; k < mod.rules.length; k++)sheet.insertRule(mod.rules[k], pos++);
            } else {
                while(j < index)pos += this.modules[j++].rules.length;
                pos += mod.rules.length;
                j++;
            }
        }
        if (sheet) {
            if (root.adoptedStyleSheets.indexOf(this.sheet) < 0) root.adoptedStyleSheets = [
                this.sheet,
                ...root.adoptedStyleSheets
            ];
        } else {
            let text = "";
            for(let i = 0; i < this.modules.length; i++)text += this.modules[i].getRules() + "\n";
            this.styleTag.textContent = text;
            let target = root.head || root;
            if (this.styleTag.parentNode != target) target.insertBefore(this.styleTag, target.firstChild);
        }
    }
    setNonce(nonce) {
        if (this.styleTag && this.styleTag.getAttribute("nonce") != nonce) this.styleTag.setAttribute("nonce", nonce);
    }
} // Style::Object<union<Style,string>>
 //
 // A style is an object that, in the simple case, maps CSS property
 // names to strings holding their values, as in `{color: "red",
 // fontWeight: "bold"}`. The property names can be given in
 // camel-case—the library will insert a dash before capital letters
 // when converting them to CSS.
 //
 // If you include an underscore in a property name, it and everything
 // after it will be removed from the output, which can be useful when
 // providing a property multiple times, for browser compatibility
 // reasons.
 //
 // A property in a style object can also be a sub-selector, which
 // extends the current context to add a pseudo-selector or a child
 // selector. Such a property should contain a `&` character, which
 // will be replaced by the current selector. For example `{"&:before":
 // {content: '"hi"'}}`. Sub-selectors and regular properties can
 // freely be mixed in a given object. Any property containing a `&` is
 // assumed to be a sub-selector.
 //
 // Finally, a property can specify an @-block to be wrapped around the
 // styles defined inside the object that's the property's value. For
 // example to create a media query you can do `{"@media screen and
 // (min-width: 400px)": {...}}`.


var $68b9e7c405929963$export$e2253033e6e1df16 = {
    8: "Backspace",
    9: "Tab",
    10: "Enter",
    12: "NumLock",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    44: "PrintScreen",
    45: "Insert",
    46: "Delete",
    59: ";",
    61: "=",
    91: "Meta",
    92: "Meta",
    106: "*",
    107: "+",
    108: ",",
    109: "-",
    110: ".",
    111: "/",
    144: "NumLock",
    145: "ScrollLock",
    160: "Shift",
    161: "Shift",
    162: "Control",
    163: "Control",
    164: "Alt",
    165: "Alt",
    173: "-",
    186: ";",
    187: "=",
    188: ",",
    189: "-",
    190: ".",
    191: "/",
    192: "`",
    219: "[",
    220: "\\",
    221: "]",
    222: "'"
};
var $68b9e7c405929963$export$fba63a578e423eb = {
    48: ")",
    49: "!",
    50: "@",
    51: "#",
    52: "$",
    53: "%",
    54: "^",
    55: "&",
    56: "*",
    57: "(",
    59: ":",
    61: "+",
    173: "_",
    186: ":",
    187: "+",
    188: "<",
    189: "_",
    190: ">",
    191: "?",
    192: "~",
    219: "{",
    220: "|",
    221: "}",
    222: "\""
};
var $68b9e7c405929963$var$mac = typeof navigator != "undefined" && /Mac/.test(navigator.platform);
var $68b9e7c405929963$var$ie = typeof navigator != "undefined" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
// Fill in the digit keys
for(var $68b9e7c405929963$var$i = 0; $68b9e7c405929963$var$i < 10; $68b9e7c405929963$var$i++)$68b9e7c405929963$export$e2253033e6e1df16[48 + $68b9e7c405929963$var$i] = $68b9e7c405929963$export$e2253033e6e1df16[96 + $68b9e7c405929963$var$i] = String($68b9e7c405929963$var$i);
// The function keys
for(var $68b9e7c405929963$var$i = 1; $68b9e7c405929963$var$i <= 24; $68b9e7c405929963$var$i++)$68b9e7c405929963$export$e2253033e6e1df16[$68b9e7c405929963$var$i + 111] = "F" + $68b9e7c405929963$var$i;
// And the alphabetic keys
for(var $68b9e7c405929963$var$i = 65; $68b9e7c405929963$var$i <= 90; $68b9e7c405929963$var$i++){
    $68b9e7c405929963$export$e2253033e6e1df16[$68b9e7c405929963$var$i] = String.fromCharCode($68b9e7c405929963$var$i + 32);
    $68b9e7c405929963$export$fba63a578e423eb[$68b9e7c405929963$var$i] = String.fromCharCode($68b9e7c405929963$var$i);
}
// For each code that doesn't have a shift-equivalent, copy the base name
for(var $68b9e7c405929963$var$code in $68b9e7c405929963$export$e2253033e6e1df16)if (!$68b9e7c405929963$export$fba63a578e423eb.hasOwnProperty($68b9e7c405929963$var$code)) $68b9e7c405929963$export$fba63a578e423eb[$68b9e7c405929963$var$code] = $68b9e7c405929963$export$e2253033e6e1df16[$68b9e7c405929963$var$code];
function $68b9e7c405929963$export$fb33aafd75404f4c(event) {
    // On macOS, keys held with Shift and Cmd don't reflect the effect of Shift in `.key`.
    // On IE, shift effect is never included in `.key`.
    var ignoreKey = $68b9e7c405929963$var$mac && event.metaKey && event.shiftKey && !event.ctrlKey && !event.altKey || $68b9e7c405929963$var$ie && event.shiftKey && event.key && event.key.length == 1 || event.key == "Unidentified";
    var name = !ignoreKey && event.key || (event.shiftKey ? $68b9e7c405929963$export$fba63a578e423eb : $68b9e7c405929963$export$e2253033e6e1df16)[event.keyCode] || event.key || "Unidentified";
    // Edge sometimes produces wrong names (Issue #3)
    if (name == "Esc") name = "Escape";
    if (name == "Del") name = "Delete";
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8860571/
    if (name == "Left") name = "ArrowLeft";
    if (name == "Up") name = "ArrowUp";
    if (name == "Right") name = "ArrowRight";
    if (name == "Down") name = "ArrowDown";
    return name;
}


function $2d3e4571bc0b9f5f$export$2e2bcd8739ae039() {
    var elt = arguments[0];
    if (typeof elt == "string") elt = document.createElement(elt);
    var i = 1, next = arguments[1];
    if (next && typeof next == "object" && next.nodeType == null && !Array.isArray(next)) {
        for(var name in next)if (Object.prototype.hasOwnProperty.call(next, name)) {
            var value = next[name];
            if (typeof value == "string") elt.setAttribute(name, value);
            else if (value != null) elt[name] = value;
        }
        i++;
    }
    for(; i < arguments.length; i++)$2d3e4571bc0b9f5f$var$add(elt, arguments[i]);
    return elt;
}
function $2d3e4571bc0b9f5f$var$add(elt, child) {
    if (typeof child == "string") elt.appendChild(document.createTextNode(child));
    else if (child == null) ;
    else if (child.nodeType != null) elt.appendChild(child);
    else if (Array.isArray(child)) for(var i = 0; i < child.length; i++)$2d3e4571bc0b9f5f$var$add(elt, child[i]);
    else throw new RangeError("Unsupported child node: " + child);
}


let $7beee9608540d2c3$var$nav = typeof navigator != "undefined" ? navigator : {
    userAgent: "",
    vendor: "",
    platform: ""
};
let $7beee9608540d2c3$var$doc = typeof document != "undefined" ? document : {
    documentElement: {
        style: {}
    }
};
const $7beee9608540d2c3$var$ie_edge = /*@__PURE__*/ /Edge\/(\d+)/.exec($7beee9608540d2c3$var$nav.userAgent);
const $7beee9608540d2c3$var$ie_upto10 = /*@__PURE__*/ /MSIE \d/.test($7beee9608540d2c3$var$nav.userAgent);
const $7beee9608540d2c3$var$ie_11up = /*@__PURE__*/ /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec($7beee9608540d2c3$var$nav.userAgent);
const $7beee9608540d2c3$var$ie = !!($7beee9608540d2c3$var$ie_upto10 || $7beee9608540d2c3$var$ie_11up || $7beee9608540d2c3$var$ie_edge);
const $7beee9608540d2c3$var$gecko = !$7beee9608540d2c3$var$ie && /*@__PURE__*/ /gecko\/(\d+)/i.test($7beee9608540d2c3$var$nav.userAgent);
const $7beee9608540d2c3$var$chrome = !$7beee9608540d2c3$var$ie && /*@__PURE__*/ /Chrome\/(\d+)/.exec($7beee9608540d2c3$var$nav.userAgent);
const $7beee9608540d2c3$var$webkit = "webkitFontSmoothing" in $7beee9608540d2c3$var$doc.documentElement.style;
const $7beee9608540d2c3$var$safari = !$7beee9608540d2c3$var$ie && /*@__PURE__*/ /Apple Computer/.test($7beee9608540d2c3$var$nav.vendor);
const $7beee9608540d2c3$var$ios = $7beee9608540d2c3$var$safari && /*@__PURE__*/ (/Mobile\/\w+/.test($7beee9608540d2c3$var$nav.userAgent) || $7beee9608540d2c3$var$nav.maxTouchPoints > 2);
var $7beee9608540d2c3$var$browser = {
    mac: $7beee9608540d2c3$var$ios || /*@__PURE__*/ /Mac/.test($7beee9608540d2c3$var$nav.platform),
    windows: /*@__PURE__*/ /Win/.test($7beee9608540d2c3$var$nav.platform),
    linux: /*@__PURE__*/ /Linux|X11/.test($7beee9608540d2c3$var$nav.platform),
    ie: $7beee9608540d2c3$var$ie,
    ie_version: $7beee9608540d2c3$var$ie_upto10 ? $7beee9608540d2c3$var$doc.documentMode || 6 : $7beee9608540d2c3$var$ie_11up ? +$7beee9608540d2c3$var$ie_11up[1] : $7beee9608540d2c3$var$ie_edge ? +$7beee9608540d2c3$var$ie_edge[1] : 0,
    gecko: $7beee9608540d2c3$var$gecko,
    gecko_version: $7beee9608540d2c3$var$gecko ? +/*@__PURE__*/ (/Firefox\/(\d+)/.exec($7beee9608540d2c3$var$nav.userAgent) || [
        0,
        0
    ])[1] : 0,
    chrome: !!$7beee9608540d2c3$var$chrome,
    chrome_version: $7beee9608540d2c3$var$chrome ? +$7beee9608540d2c3$var$chrome[1] : 0,
    ios: $7beee9608540d2c3$var$ios,
    android: /*@__PURE__*/ /Android\b/.test($7beee9608540d2c3$var$nav.userAgent),
    webkit: $7beee9608540d2c3$var$webkit,
    webkit_version: $7beee9608540d2c3$var$webkit ? +/*@__PURE__*/ (/\bAppleWebKit\/(\d+)/.exec($7beee9608540d2c3$var$nav.userAgent) || [
        0,
        0
    ])[1] : 0,
    safari: $7beee9608540d2c3$var$safari,
    safari_version: $7beee9608540d2c3$var$safari ? +/*@__PURE__*/ (/\bVersion\/(\d+(\.\d+)?)/.exec($7beee9608540d2c3$var$nav.userAgent) || [
        0,
        0
    ])[1] : 0,
    tabSize: $7beee9608540d2c3$var$doc.documentElement.style.tabSize != null ? "tab-size" : "-moz-tab-size"
};
function $7beee9608540d2c3$var$combineAttrs(source, target) {
    for(let name in source){
        if (name == "class" && target.class) target.class += " " + source.class;
        else if (name == "style" && target.style) target.style += ";" + source.style;
        else target[name] = source[name];
    }
    return target;
}
const $7beee9608540d2c3$var$noAttrs = /*@__PURE__*/ Object.create(null);
function $7beee9608540d2c3$var$attrsEq(a, b, ignore) {
    if (a == b) return true;
    if (!a) a = $7beee9608540d2c3$var$noAttrs;
    if (!b) b = $7beee9608540d2c3$var$noAttrs;
    let keysA = Object.keys(a), keysB = Object.keys(b);
    if (keysA.length - (ignore && keysA.indexOf(ignore) > -1 ? 1 : 0) != keysB.length - (ignore && keysB.indexOf(ignore) > -1 ? 1 : 0)) return false;
    for (let key of keysA){
        if (key != ignore && (keysB.indexOf(key) == -1 || a[key] !== b[key])) return false;
    }
    return true;
}
function $7beee9608540d2c3$var$setAttrs(dom, attrs) {
    for(let i = dom.attributes.length - 1; i >= 0; i--){
        let name = dom.attributes[i].name;
        if (attrs[name] == null) dom.removeAttribute(name);
    }
    for(let name in attrs){
        let value = attrs[name];
        if (name == "style") dom.style.cssText = value;
        else if (dom.getAttribute(name) != value) dom.setAttribute(name, value);
    }
}
function $7beee9608540d2c3$var$updateAttrs(dom, prev, attrs) {
    let changed = false;
    if (prev) {
        for(let name in prev)if (!(attrs && name in attrs)) {
            changed = true;
            if (name == "style") dom.style.cssText = "";
            else dom.removeAttribute(name);
        }
    }
    if (attrs) {
        for(let name in attrs)if (!(prev && prev[name] == attrs[name])) {
            changed = true;
            if (name == "style") dom.style.cssText = attrs[name];
            else dom.setAttribute(name, attrs[name]);
        }
    }
    return changed;
}
function $7beee9608540d2c3$var$getAttrs(dom) {
    let attrs = Object.create(null);
    for(let i = 0; i < dom.attributes.length; i++){
        let attr = dom.attributes[i];
        attrs[attr.name] = attr.value;
    }
    return attrs;
}
/**
Widgets added to the content are described by subclasses of this
class. Using a description object like that makes it possible to
delay creating of the DOM structure for a widget until it is
needed, and to avoid redrawing widgets even if the decorations
that define them are recreated.
*/ class $7beee9608540d2c3$export$95cdd842edb044c5 {
    /**
    Compare this instance to another instance of the same type.
    (TypeScript can't express this, but only instances of the same
    specific class will be passed to this method.) This is used to
    avoid redrawing widgets when they are replaced by a new
    decoration of the same type. The default implementation just
    returns `false`, which will cause new instances of the widget to
    always be redrawn.
    */ eq(widget) {
        return false;
    }
    /**
    Update a DOM element created by a widget of the same type (but
    different, non-`eq` content) to reflect this widget. May return
    true to indicate that it could update, false to indicate it
    couldn't (in which case the widget will be redrawn). The default
    implementation just returns false.
    */ updateDOM(dom, view, from) {
        return false;
    }
    /**
    @internal
    */ compare(other) {
        return this == other || this.constructor == other.constructor && this.eq(other);
    }
    /**
    The estimated height this widget will have, to be used when
    estimating the height of content that hasn't been drawn. May
    return -1 to indicate you don't know. The default implementation
    returns -1.
    */ get estimatedHeight() {
        return -1;
    }
    /**
    For inline widgets that are displayed inline (as opposed to
    `inline-block`) and introduce line breaks (through `<br>` tags
    or textual newlines), this must indicate the amount of line
    breaks they introduce. Defaults to 0.
    */ get lineBreaks() {
        return 0;
    }
    /**
    Can be used to configure which kinds of events inside the widget
    should be ignored by the editor. The default is to ignore all
    events.
    */ ignoreEvent(event) {
        return true;
    }
    /**
    Override the way screen coordinates for positions at/in the
    widget are found. `pos` will be the offset into the widget, and
    `side` the side of the position that is being queried—less than
    zero for before, greater than zero for after, and zero for
    directly at that position.
    */ coordsAt(dom, pos, side) {
        return null;
    }
    /**
    @internal
    */ get isHidden() {
        return false;
    }
    /**
    @internal
    */ get editable() {
        return false;
    }
    /**
    This is called when the an instance of the widget is removed
    from the editor view.
    */ destroy(dom) {}
}
/**
The different types of blocks that can occur in an editor view.
*/ var $7beee9608540d2c3$export$48808c686fe495c4 = /*@__PURE__*/ function(BlockType) {
    /**
    A line of text.
    */ BlockType[BlockType["Text"] = 0] = "Text";
    /**
    A block widget associated with the position after it.
    */ BlockType[BlockType["WidgetBefore"] = 1] = "WidgetBefore";
    /**
    A block widget associated with the position before it.
    */ BlockType[BlockType["WidgetAfter"] = 2] = "WidgetAfter";
    /**
    A block widget [replacing](https://codemirror.net/6/docs/ref/#view.Decoration^replace) a range of content.
    */ BlockType[BlockType["WidgetRange"] = 3] = "WidgetRange";
    return BlockType;
}($7beee9608540d2c3$export$48808c686fe495c4 || ($7beee9608540d2c3$export$48808c686fe495c4 = {}));
/**
A decoration provides information on how to draw or style a piece
of content. You'll usually use it wrapped in a
[`Range`](https://codemirror.net/6/docs/ref/#state.Range), which adds a start and end position.
@nonabstract
*/ class $7beee9608540d2c3$export$10e30b733df217ea extends (0, $6295c6875f57e3ee$export$d60f08ed93a48611) {
    constructor(/**
    @internal
    */ startSide, /**
    @internal
    */ endSide, /**
    @internal
    */ widget, /**
    The config object used to create this decoration. You can
    include additional properties in there to store metadata about
    your decoration.
    */ spec){
        super();
        this.startSide = startSide;
        this.endSide = endSide;
        this.widget = widget;
        this.spec = spec;
    }
    /**
    @internal
    */ get heightRelevant() {
        return false;
    }
    /**
    Create a mark decoration, which influences the styling of the
    content in its range. Nested mark decorations will cause nested
    DOM elements to be created. Nesting order is determined by
    precedence of the [facet](https://codemirror.net/6/docs/ref/#view.EditorView^decorations), with
    the higher-precedence decorations creating the inner DOM nodes.
    Such elements are split on line boundaries and on the boundaries
    of lower-precedence decorations.
    */ static mark(spec) {
        return new $7beee9608540d2c3$var$MarkDecoration(spec);
    }
    /**
    Create a widget decoration, which displays a DOM element at the
    given position.
    */ static widget(spec) {
        let side = Math.max(-10000, Math.min(10000, spec.side || 0)), block = !!spec.block;
        side += block && !spec.inlineOrder ? side > 0 ? 300000000 /* Side.BlockAfter */  : -400000000 /* Side.BlockBefore */  : side > 0 ? 100000000 /* Side.InlineAfter */  : -100000000 /* Side.InlineBefore */ ;
        return new $7beee9608540d2c3$var$PointDecoration(spec, side, side, block, spec.widget || null, false);
    }
    /**
    Create a replace decoration which replaces the given range with
    a widget, or simply hides it.
    */ static replace(spec) {
        let block = !!spec.block, startSide, endSide;
        if (spec.isBlockGap) {
            startSide = -500000000 /* Side.GapStart */ ;
            endSide = 400000000 /* Side.GapEnd */ ;
        } else {
            let { start: start, end: end } = $7beee9608540d2c3$var$getInclusive(spec, block);
            startSide = (start ? block ? -300000000 /* Side.BlockIncStart */  : -1 /* Side.InlineIncStart */  : 500000000 /* Side.NonIncStart */ ) - 1;
            endSide = (end ? block ? 200000000 /* Side.BlockIncEnd */  : 1 /* Side.InlineIncEnd */  : -600000000 /* Side.NonIncEnd */ ) + 1;
        }
        return new $7beee9608540d2c3$var$PointDecoration(spec, startSide, endSide, block, spec.widget || null, true);
    }
    /**
    Create a line decoration, which can add DOM attributes to the
    line starting at the given position.
    */ static line(spec) {
        return new $7beee9608540d2c3$var$LineDecoration(spec);
    }
    /**
    Build a [`DecorationSet`](https://codemirror.net/6/docs/ref/#view.DecorationSet) from the given
    decorated range or ranges. If the ranges aren't already sorted,
    pass `true` for `sort` to make the library sort them for you.
    */ static set(of, sort = false) {
        return (0, $6295c6875f57e3ee$export$34cb5241245008dd).of(of, sort);
    }
    /**
    @internal
    */ hasHeight() {
        return this.widget ? this.widget.estimatedHeight > -1 : false;
    }
}
/**
The empty set of decorations.
*/ $7beee9608540d2c3$export$10e30b733df217ea.none = (0, $6295c6875f57e3ee$export$34cb5241245008dd).empty;
class $7beee9608540d2c3$var$MarkDecoration extends $7beee9608540d2c3$export$10e30b733df217ea {
    constructor(spec){
        let { start: start, end: end } = $7beee9608540d2c3$var$getInclusive(spec);
        super(start ? -1 /* Side.InlineIncStart */  : 500000000 /* Side.NonIncStart */ , end ? 1 /* Side.InlineIncEnd */  : -600000000 /* Side.NonIncEnd */ , null, spec);
        this.tagName = spec.tagName || "span";
        this.attrs = spec.class && spec.attributes ? $7beee9608540d2c3$var$combineAttrs(spec.attributes, {
            class: spec.class
        }) : spec.class ? {
            class: spec.class
        } : spec.attributes || $7beee9608540d2c3$var$noAttrs;
    }
    eq(other) {
        return this == other || other instanceof $7beee9608540d2c3$var$MarkDecoration && this.tagName == other.tagName && $7beee9608540d2c3$var$attrsEq(this.attrs, other.attrs);
    }
    range(from, to = from) {
        if (from >= to) throw new RangeError("Mark decorations may not be empty");
        return super.range(from, to);
    }
}
$7beee9608540d2c3$var$MarkDecoration.prototype.point = false;
class $7beee9608540d2c3$var$LineDecoration extends $7beee9608540d2c3$export$10e30b733df217ea {
    constructor(spec){
        super(-200000000 /* Side.Line */ , -200000000 /* Side.Line */ , null, spec);
    }
    eq(other) {
        return other instanceof $7beee9608540d2c3$var$LineDecoration && this.spec.class == other.spec.class && $7beee9608540d2c3$var$attrsEq(this.spec.attributes, other.spec.attributes);
    }
    range(from, to = from) {
        if (to != from) throw new RangeError("Line decoration ranges must be zero-length");
        return super.range(from, to);
    }
}
$7beee9608540d2c3$var$LineDecoration.prototype.mapMode = (0, $6295c6875f57e3ee$export$39cf3280165f92aa).TrackBefore;
$7beee9608540d2c3$var$LineDecoration.prototype.point = true;
class $7beee9608540d2c3$var$PointDecoration extends $7beee9608540d2c3$export$10e30b733df217ea {
    constructor(spec, startSide, endSide, block, widget, isReplace){
        super(startSide, endSide, widget, spec);
        this.block = block;
        this.isReplace = isReplace;
        this.mapMode = !block ? (0, $6295c6875f57e3ee$export$39cf3280165f92aa).TrackDel : startSide <= 0 ? (0, $6295c6875f57e3ee$export$39cf3280165f92aa).TrackBefore : (0, $6295c6875f57e3ee$export$39cf3280165f92aa).TrackAfter;
    }
    // Only relevant when this.block == true
    get type() {
        return this.startSide != this.endSide ? $7beee9608540d2c3$export$48808c686fe495c4.WidgetRange : this.startSide <= 0 ? $7beee9608540d2c3$export$48808c686fe495c4.WidgetBefore : $7beee9608540d2c3$export$48808c686fe495c4.WidgetAfter;
    }
    get heightRelevant() {
        return this.block || !!this.widget && (this.widget.estimatedHeight >= 5 || this.widget.lineBreaks > 0);
    }
    eq(other) {
        return other instanceof $7beee9608540d2c3$var$PointDecoration && $7beee9608540d2c3$var$widgetsEq(this.widget, other.widget) && this.block == other.block && this.startSide == other.startSide && this.endSide == other.endSide;
    }
    range(from, to = from) {
        if (this.isReplace && (from > to || from == to && this.startSide > 0 && this.endSide <= 0)) throw new RangeError("Invalid range for replacement decoration");
        if (!this.isReplace && to != from) throw new RangeError("Widget decorations can only have zero-length ranges");
        return super.range(from, to);
    }
}
$7beee9608540d2c3$var$PointDecoration.prototype.point = true;
function $7beee9608540d2c3$var$getInclusive(spec, block = false) {
    let { inclusiveStart: start, inclusiveEnd: end } = spec;
    if (start == null) start = spec.inclusive;
    if (end == null) end = spec.inclusive;
    return {
        start: start !== null && start !== void 0 ? start : block,
        end: end !== null && end !== void 0 ? end : block
    };
}
function $7beee9608540d2c3$var$widgetsEq(a, b) {
    return a == b || !!(a && b && a.compare(b));
}
function $7beee9608540d2c3$var$addRange(from, to, ranges, margin = 0) {
    let last = ranges.length - 1;
    if (last >= 0 && ranges[last] + margin >= from) ranges[last] = Math.max(ranges[last], to);
    else ranges.push(from, to);
}
/**
A block wrapper defines a DOM node that wraps lines or other block
wrappers at the top of the document. It affects any line or block
widget that starts inside its range, including blocks starting
directly at `from` but not including `to`.
*/ class $7beee9608540d2c3$export$b9b108b497733374 extends (0, $6295c6875f57e3ee$export$d60f08ed93a48611) {
    constructor(/**
    @internal
    */ tagName, /**
    @internal
    */ attributes, /**
    @internal
    */ rank){
        super();
        this.tagName = tagName;
        this.attributes = attributes;
        this.rank = rank;
    }
    eq(other) {
        return other == this || other instanceof $7beee9608540d2c3$export$b9b108b497733374 && this.tagName == other.tagName && $7beee9608540d2c3$var$attrsEq(this.attributes, other.attributes);
    }
    /**
    Create a block wrapper object with the given tag name and
    attributes.
    */ static create(spec) {
        return new $7beee9608540d2c3$export$b9b108b497733374(spec.tagName, spec.attributes || $7beee9608540d2c3$var$noAttrs, spec.rank == null ? 50 : Math.max(0, Math.min(spec.rank, 100)));
    }
    /**
    Create a range set from the given block wrapper ranges.
    */ static set(of, sort = false) {
        return (0, $6295c6875f57e3ee$export$34cb5241245008dd).of(of, sort);
    }
}
$7beee9608540d2c3$export$b9b108b497733374.prototype.startSide = $7beee9608540d2c3$export$b9b108b497733374.prototype.endSide = -1;
function $7beee9608540d2c3$var$getSelection(root) {
    let target;
    // Browsers differ on whether shadow roots have a getSelection
    // method. If it exists, use that, otherwise, call it on the
    // document.
    if (root.nodeType == 11) target = root.getSelection ? root : root.ownerDocument;
    else target = root;
    return target.getSelection();
}
function $7beee9608540d2c3$var$contains(dom, node) {
    return node ? dom == node || dom.contains(node.nodeType != 1 ? node.parentNode : node) : false;
}
function $7beee9608540d2c3$var$hasSelection(dom, selection) {
    if (!selection.anchorNode) return false;
    try {
        // Firefox will raise 'permission denied' errors when accessing
        // properties of `sel.anchorNode` when it's in a generated CSS
        // element.
        return $7beee9608540d2c3$var$contains(dom, selection.anchorNode);
    } catch (_) {
        return false;
    }
}
function $7beee9608540d2c3$var$clientRectsFor(dom) {
    if (dom.nodeType == 3) return $7beee9608540d2c3$var$textRange(dom, 0, dom.nodeValue.length).getClientRects();
    else if (dom.nodeType == 1) return dom.getClientRects();
    else return [];
}
// Scans forward and backward through DOM positions equivalent to the
// given one to see if the two are in the same place (i.e. after a
// text node vs at the end of that text node)
function $7beee9608540d2c3$var$isEquivalentPosition(node, off, targetNode, targetOff) {
    return targetNode ? $7beee9608540d2c3$var$scanFor(node, off, targetNode, targetOff, -1) || $7beee9608540d2c3$var$scanFor(node, off, targetNode, targetOff, 1) : false;
}
function $7beee9608540d2c3$var$domIndex(node) {
    for(var index = 0;; index++){
        node = node.previousSibling;
        if (!node) return index;
    }
}
function $7beee9608540d2c3$var$isBlockElement(node) {
    return node.nodeType == 1 && /^(DIV|P|LI|UL|OL|BLOCKQUOTE|DD|DT|H\d|SECTION|PRE)$/.test(node.nodeName);
}
function $7beee9608540d2c3$var$scanFor(node, off, targetNode, targetOff, dir) {
    for(;;){
        if (node == targetNode && off == targetOff) return true;
        if (off == (dir < 0 ? 0 : $7beee9608540d2c3$var$maxOffset(node))) {
            if (node.nodeName == "DIV") return false;
            let parent = node.parentNode;
            if (!parent || parent.nodeType != 1) return false;
            off = $7beee9608540d2c3$var$domIndex(node) + (dir < 0 ? 0 : 1);
            node = parent;
        } else if (node.nodeType == 1) {
            node = node.childNodes[off + (dir < 0 ? -1 : 0)];
            if (node.nodeType == 1 && node.contentEditable == "false") return false;
            off = dir < 0 ? $7beee9608540d2c3$var$maxOffset(node) : 0;
        } else return false;
    }
}
function $7beee9608540d2c3$var$maxOffset(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $7beee9608540d2c3$var$flattenRect(rect, left) {
    let x = left ? rect.left : rect.right;
    return {
        left: x,
        right: x,
        top: rect.top,
        bottom: rect.bottom
    };
}
function $7beee9608540d2c3$var$windowRect(win) {
    let vp = win.visualViewport;
    if (vp) return {
        left: 0,
        right: vp.width,
        top: 0,
        bottom: vp.height
    };
    return {
        left: 0,
        right: win.innerWidth,
        top: 0,
        bottom: win.innerHeight
    };
}
function $7beee9608540d2c3$var$getScale(elt, rect) {
    let scaleX = rect.width / elt.offsetWidth;
    let scaleY = rect.height / elt.offsetHeight;
    if (scaleX > 0.995 && scaleX < 1.005 || !isFinite(scaleX) || Math.abs(rect.width - elt.offsetWidth) < 1) scaleX = 1;
    if (scaleY > 0.995 && scaleY < 1.005 || !isFinite(scaleY) || Math.abs(rect.height - elt.offsetHeight) < 1) scaleY = 1;
    return {
        scaleX: scaleX,
        scaleY: scaleY
    };
}
function $7beee9608540d2c3$var$scrollRectIntoView(dom, rect, side, x, y, xMargin, yMargin, ltr) {
    let doc = dom.ownerDocument, win = doc.defaultView || window;
    for(let cur = dom, stop = false; cur && !stop;){
        if (cur.nodeType == 1) {
            let bounding, top = cur == doc.body;
            let scaleX = 1, scaleY = 1;
            if (top) bounding = $7beee9608540d2c3$var$windowRect(win);
            else {
                if (/^(fixed|sticky)$/.test(getComputedStyle(cur).position)) stop = true;
                if (cur.scrollHeight <= cur.clientHeight && cur.scrollWidth <= cur.clientWidth) {
                    cur = cur.assignedSlot || cur.parentNode;
                    continue;
                }
                let rect = cur.getBoundingClientRect();
                ({ scaleX: scaleX, scaleY: scaleY } = $7beee9608540d2c3$var$getScale(cur, rect));
                // Make sure scrollbar width isn't included in the rectangle
                bounding = {
                    left: rect.left,
                    right: rect.left + cur.clientWidth * scaleX,
                    top: rect.top,
                    bottom: rect.top + cur.clientHeight * scaleY
                };
            }
            let moveX = 0, moveY = 0;
            if (y == "nearest") {
                if (rect.top < bounding.top + yMargin) {
                    moveY = rect.top - (bounding.top + yMargin);
                    if (side > 0 && rect.bottom > bounding.bottom + moveY) moveY = rect.bottom - bounding.bottom + yMargin;
                } else if (rect.bottom > bounding.bottom - yMargin) {
                    moveY = rect.bottom - bounding.bottom + yMargin;
                    if (side < 0 && rect.top - moveY < bounding.top) moveY = rect.top - (bounding.top + yMargin);
                }
            } else {
                let rectHeight = rect.bottom - rect.top, boundingHeight = bounding.bottom - bounding.top;
                let targetTop = y == "center" && rectHeight <= boundingHeight ? rect.top + rectHeight / 2 - boundingHeight / 2 : y == "start" || y == "center" && side < 0 ? rect.top - yMargin : rect.bottom - boundingHeight + yMargin;
                moveY = targetTop - bounding.top;
            }
            if (x == "nearest") {
                if (rect.left < bounding.left + xMargin) {
                    moveX = rect.left - (bounding.left + xMargin);
                    if (side > 0 && rect.right > bounding.right + moveX) moveX = rect.right - bounding.right + xMargin;
                } else if (rect.right > bounding.right - xMargin) {
                    moveX = rect.right - bounding.right + xMargin;
                    if (side < 0 && rect.left < bounding.left + moveX) moveX = rect.left - (bounding.left + xMargin);
                }
            } else {
                let targetLeft = x == "center" ? rect.left + (rect.right - rect.left) / 2 - (bounding.right - bounding.left) / 2 : x == "start" == ltr ? rect.left - xMargin : rect.right - (bounding.right - bounding.left) + xMargin;
                moveX = targetLeft - bounding.left;
            }
            if (moveX || moveY) {
                if (top) win.scrollBy(moveX, moveY);
                else {
                    let movedX = 0, movedY = 0;
                    if (moveY) {
                        let start = cur.scrollTop;
                        cur.scrollTop += moveY / scaleY;
                        movedY = (cur.scrollTop - start) * scaleY;
                    }
                    if (moveX) {
                        let start = cur.scrollLeft;
                        cur.scrollLeft += moveX / scaleX;
                        movedX = (cur.scrollLeft - start) * scaleX;
                    }
                    rect = {
                        left: rect.left - movedX,
                        top: rect.top - movedY,
                        right: rect.right - movedX,
                        bottom: rect.bottom - movedY
                    };
                    if (movedX && Math.abs(movedX - moveX) < 1) x = "nearest";
                    if (movedY && Math.abs(movedY - moveY) < 1) y = "nearest";
                }
            }
            if (top) break;
            if (rect.top < bounding.top || rect.bottom > bounding.bottom || rect.left < bounding.left || rect.right > bounding.right) rect = {
                left: Math.max(rect.left, bounding.left),
                right: Math.min(rect.right, bounding.right),
                top: Math.max(rect.top, bounding.top),
                bottom: Math.min(rect.bottom, bounding.bottom)
            };
            cur = cur.assignedSlot || cur.parentNode;
        } else if (cur.nodeType == 11) cur = cur.host;
        else break;
    }
}
function $7beee9608540d2c3$var$scrollableParents(dom, getX = true) {
    let doc = dom.ownerDocument, x = null, y = null;
    for(let cur = dom.parentNode; cur;){
        if (cur == doc.body || (!getX || x) && y) break;
        else if (cur.nodeType == 1) {
            if (!y && cur.scrollHeight > cur.clientHeight) y = cur;
            if (getX && !x && cur.scrollWidth > cur.clientWidth) x = cur;
            cur = cur.assignedSlot || cur.parentNode;
        } else if (cur.nodeType == 11) cur = cur.host;
        else break;
    }
    return {
        x: x,
        y: y
    };
}
class $7beee9608540d2c3$var$DOMSelectionState {
    constructor(){
        this.anchorNode = null;
        this.anchorOffset = 0;
        this.focusNode = null;
        this.focusOffset = 0;
    }
    eq(domSel) {
        return this.anchorNode == domSel.anchorNode && this.anchorOffset == domSel.anchorOffset && this.focusNode == domSel.focusNode && this.focusOffset == domSel.focusOffset;
    }
    setRange(range) {
        let { anchorNode: anchorNode, focusNode: focusNode } = range;
        // Clip offsets to node size to avoid crashes when Safari reports bogus offsets (#1152)
        this.set(anchorNode, Math.min(range.anchorOffset, anchorNode ? $7beee9608540d2c3$var$maxOffset(anchorNode) : 0), focusNode, Math.min(range.focusOffset, focusNode ? $7beee9608540d2c3$var$maxOffset(focusNode) : 0));
    }
    set(anchorNode, anchorOffset, focusNode, focusOffset) {
        this.anchorNode = anchorNode;
        this.anchorOffset = anchorOffset;
        this.focusNode = focusNode;
        this.focusOffset = focusOffset;
    }
}
let $7beee9608540d2c3$var$preventScrollSupported = null;
// Safari 26 breaks preventScroll support
if ($7beee9608540d2c3$var$browser.safari && $7beee9608540d2c3$var$browser.safari_version >= 26) $7beee9608540d2c3$var$preventScrollSupported = false;
// Feature-detects support for .focus({preventScroll: true}), and uses
// a fallback kludge when not supported.
function $7beee9608540d2c3$var$focusPreventScroll(dom) {
    if (dom.setActive) return dom.setActive(); // in IE
    if ($7beee9608540d2c3$var$preventScrollSupported) return dom.focus($7beee9608540d2c3$var$preventScrollSupported);
    let stack = [];
    for(let cur = dom; cur; cur = cur.parentNode){
        stack.push(cur, cur.scrollTop, cur.scrollLeft);
        if (cur == cur.ownerDocument) break;
    }
    dom.focus($7beee9608540d2c3$var$preventScrollSupported == null ? {
        get preventScroll () {
            $7beee9608540d2c3$var$preventScrollSupported = {
                preventScroll: true
            };
            return true;
        }
    } : undefined);
    if (!$7beee9608540d2c3$var$preventScrollSupported) {
        $7beee9608540d2c3$var$preventScrollSupported = false;
        for(let i = 0; i < stack.length;){
            let elt = stack[i++], top = stack[i++], left = stack[i++];
            if (elt.scrollTop != top) elt.scrollTop = top;
            if (elt.scrollLeft != left) elt.scrollLeft = left;
        }
    }
}
let $7beee9608540d2c3$var$scratchRange;
function $7beee9608540d2c3$var$textRange(node, from, to = from) {
    let range = $7beee9608540d2c3$var$scratchRange || ($7beee9608540d2c3$var$scratchRange = document.createRange());
    range.setEnd(node, to);
    range.setStart(node, from);
    return range;
}
function $7beee9608540d2c3$var$dispatchKey(elt, name, code, mods) {
    let options = {
        key: name,
        code: name,
        keyCode: code,
        which: code,
        cancelable: true
    };
    if (mods) ({ altKey: options.altKey, ctrlKey: options.ctrlKey, shiftKey: options.shiftKey, metaKey: options.metaKey } = mods);
    let down = new KeyboardEvent("keydown", options);
    down.synthetic = true;
    elt.dispatchEvent(down);
    let up = new KeyboardEvent("keyup", options);
    up.synthetic = true;
    elt.dispatchEvent(up);
    return down.defaultPrevented || up.defaultPrevented;
}
function $7beee9608540d2c3$var$getRoot(node) {
    while(node){
        if (node && (node.nodeType == 9 || node.nodeType == 11 && node.host)) return node;
        node = node.assignedSlot || node.parentNode;
    }
    return null;
}
function $7beee9608540d2c3$var$atElementStart(doc, selection) {
    let node = selection.focusNode, offset = selection.focusOffset;
    if (!node || selection.anchorNode != node || selection.anchorOffset != offset) return false;
    // Safari can report bogus offsets (#1152)
    offset = Math.min(offset, $7beee9608540d2c3$var$maxOffset(node));
    for(;;){
        if (offset) {
            if (node.nodeType != 1) return false;
            let prev = node.childNodes[offset - 1];
            if (prev.contentEditable == "false") offset--;
            else {
                node = prev;
                offset = $7beee9608540d2c3$var$maxOffset(node);
            }
        } else if (node == doc) return true;
        else {
            offset = $7beee9608540d2c3$var$domIndex(node);
            node = node.parentNode;
        }
    }
}
function $7beee9608540d2c3$var$isScrolledToBottom(elt) {
    if (elt instanceof Window) return elt.pageYOffset > Math.max(0, elt.document.documentElement.scrollHeight - elt.innerHeight - 4);
    return elt.scrollTop > Math.max(1, elt.scrollHeight - elt.clientHeight - 4);
}
function $7beee9608540d2c3$var$textNodeBefore(startNode, startOffset) {
    for(let node = startNode, offset = startOffset;;){
        if (node.nodeType == 3 && offset > 0) return {
            node: node,
            offset: offset
        };
        else if (node.nodeType == 1 && offset > 0) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset - 1];
            offset = $7beee9608540d2c3$var$maxOffset(node);
        } else if (node.parentNode && !$7beee9608540d2c3$var$isBlockElement(node)) {
            offset = $7beee9608540d2c3$var$domIndex(node);
            node = node.parentNode;
        } else return null;
    }
}
function $7beee9608540d2c3$var$textNodeAfter(startNode, startOffset) {
    for(let node = startNode, offset = startOffset;;){
        if (node.nodeType == 3 && offset < node.nodeValue.length) return {
            node: node,
            offset: offset
        };
        else if (node.nodeType == 1 && offset < node.childNodes.length) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset];
            offset = 0;
        } else if (node.parentNode && !$7beee9608540d2c3$var$isBlockElement(node)) {
            offset = $7beee9608540d2c3$var$domIndex(node) + 1;
            node = node.parentNode;
        } else return null;
    }
}
class $7beee9608540d2c3$var$DOMPos {
    constructor(node, offset, precise = true){
        this.node = node;
        this.offset = offset;
        this.precise = precise;
    }
    static before(dom, precise) {
        return new $7beee9608540d2c3$var$DOMPos(dom.parentNode, $7beee9608540d2c3$var$domIndex(dom), precise);
    }
    static after(dom, precise) {
        return new $7beee9608540d2c3$var$DOMPos(dom.parentNode, $7beee9608540d2c3$var$domIndex(dom) + 1, precise);
    }
}
/**
Used to indicate [text direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection).
*/ var $7beee9608540d2c3$export$cacd6541cfeeb6c1 = /*@__PURE__*/ function(Direction) {
    // (These are chosen to match the base levels, in bidi algorithm
    // terms, of spans in that direction.)
    /**
    Left-to-right.
    */ Direction[Direction["LTR"] = 0] = "LTR";
    /**
    Right-to-left.
    */ Direction[Direction["RTL"] = 1] = "RTL";
    return Direction;
}($7beee9608540d2c3$export$cacd6541cfeeb6c1 || ($7beee9608540d2c3$export$cacd6541cfeeb6c1 = {}));
const $7beee9608540d2c3$var$LTR = $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR, $7beee9608540d2c3$var$RTL = $7beee9608540d2c3$export$cacd6541cfeeb6c1.RTL;
// Decode a string with each type encoded as log2(type)
function $7beee9608540d2c3$var$dec(str) {
    let result = [];
    for(let i = 0; i < str.length; i++)result.push(1 << +str[i]);
    return result;
}
// Character types for codepoints 0 to 0xf8
const $7beee9608540d2c3$var$LowTypes = /*@__PURE__*/ $7beee9608540d2c3$var$dec("88888888888888888888888888888888888666888888787833333333337888888000000000000000000000000008888880000000000000000000000000088888888888888888888888888888888888887866668888088888663380888308888800000000000000000000000800000000000000000000000000000008");
// Character types for codepoints 0x600 to 0x6f9
const $7beee9608540d2c3$var$ArabicTypes = /*@__PURE__*/ $7beee9608540d2c3$var$dec("4444448826627288999999999992222222222222222222222222222222222222222222222229999999999999999999994444444444644222822222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222999999949999999229989999223333333333");
const $7beee9608540d2c3$var$Brackets = /*@__PURE__*/ Object.create(null), $7beee9608540d2c3$var$BracketStack = [];
// There's a lot more in
// https://www.unicode.org/Public/UCD/latest/ucd/BidiBrackets.txt,
// which are left out to keep code size down.
for (let p of [
    "()",
    "[]",
    "{}"
]){
    let l = /*@__PURE__*/ p.charCodeAt(0), r = /*@__PURE__*/ p.charCodeAt(1);
    $7beee9608540d2c3$var$Brackets[l] = r;
    $7beee9608540d2c3$var$Brackets[r] = -l;
}
function $7beee9608540d2c3$var$charType(ch) {
    return ch <= 0xf7 ? $7beee9608540d2c3$var$LowTypes[ch] : 0x590 <= ch && ch <= 0x5f4 ? 2 /* T.R */  : 0x600 <= ch && ch <= 0x6f9 ? $7beee9608540d2c3$var$ArabicTypes[ch - 0x600] : 0x6ee <= ch && ch <= 0x8ac ? 4 /* T.AL */  : 0x2000 <= ch && ch <= 0x200c ? 256 /* T.NI */  : 0xfb50 <= ch && ch <= 0xfdff ? 4 /* T.AL */  : 1 /* T.L */ ;
}
const $7beee9608540d2c3$var$BidiRE = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\ufb50-\ufdff]/;
/**
Represents a contiguous range of text that has a single direction
(as in left-to-right or right-to-left).
*/ class $7beee9608540d2c3$export$e1ed96b746bb516a {
    /**
    The direction of this span.
    */ get dir() {
        return this.level % 2 ? $7beee9608540d2c3$var$RTL : $7beee9608540d2c3$var$LTR;
    }
    /**
    @internal
    */ constructor(/**
    The start of the span (relative to the start of the line).
    */ from, /**
    The end of the span.
    */ to, /**
    The ["bidi
    level"](https://unicode.org/reports/tr9/#Basic_Display_Algorithm)
    of the span (in this context, 0 means
    left-to-right, 1 means right-to-left, 2 means left-to-right
    number inside right-to-left text).
    */ level){
        this.from = from;
        this.to = to;
        this.level = level;
    }
    /**
    @internal
    */ side(end, dir) {
        return this.dir == dir == end ? this.to : this.from;
    }
    /**
    @internal
    */ forward(forward, dir) {
        return forward == (this.dir == dir);
    }
    /**
    @internal
    */ static find(order, index, level, assoc) {
        let maybe = -1;
        for(let i = 0; i < order.length; i++){
            let span = order[i];
            if (span.from <= index && span.to >= index) {
                if (span.level == level) return i;
                // When multiple spans match, if assoc != 0, take the one that
                // covers that side, otherwise take the one with the minimum
                // level.
                if (maybe < 0 || (assoc != 0 ? assoc < 0 ? span.from < index : span.to > index : order[maybe].level > span.level)) maybe = i;
            }
        }
        if (maybe < 0) throw new RangeError("Index out of range");
        return maybe;
    }
}
function $7beee9608540d2c3$var$isolatesEq(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++){
        let iA = a[i], iB = b[i];
        if (iA.from != iB.from || iA.to != iB.to || iA.direction != iB.direction || !$7beee9608540d2c3$var$isolatesEq(iA.inner, iB.inner)) return false;
    }
    return true;
}
// Reused array of character types
const $7beee9608540d2c3$var$types = [];
// Fill in the character types (in `types`) from `from` to `to` and
// apply W normalization rules.
function $7beee9608540d2c3$var$computeCharTypes(line, rFrom, rTo, isolates, outerType) {
    for(let iI = 0; iI <= isolates.length; iI++){
        let from = iI ? isolates[iI - 1].to : rFrom, to = iI < isolates.length ? isolates[iI].from : rTo;
        let prevType = iI ? 256 /* T.NI */  : outerType;
        // W1. Examine each non-spacing mark (NSM) in the level run, and
        // change the type of the NSM to the type of the previous
        // character. If the NSM is at the start of the level run, it will
        // get the type of sor.
        // W2. Search backwards from each instance of a European number
        // until the first strong type (R, L, AL, or sor) is found. If an
        // AL is found, change the type of the European number to Arabic
        // number.
        // W3. Change all ALs to R.
        // (Left after this: L, R, EN, AN, ET, CS, NI)
        for(let i = from, prev = prevType, prevStrong = prevType; i < to; i++){
            let type = $7beee9608540d2c3$var$charType(line.charCodeAt(i));
            if (type == 512 /* T.NSM */ ) type = prev;
            else if (type == 8 /* T.EN */  && prevStrong == 4 /* T.AL */ ) type = 16 /* T.AN */ ;
            $7beee9608540d2c3$var$types[i] = type == 4 /* T.AL */  ? 2 /* T.R */  : type;
            if (type & 7 /* T.Strong */ ) prevStrong = type;
            prev = type;
        }
        // W5. A sequence of European terminators adjacent to European
        // numbers changes to all European numbers.
        // W6. Otherwise, separators and terminators change to Other
        // Neutral.
        // W7. Search backwards from each instance of a European number
        // until the first strong type (R, L, or sor) is found. If an L is
        // found, then change the type of the European number to L.
        // (Left after this: L, R, EN+AN, NI)
        for(let i = from, prev = prevType, prevStrong = prevType; i < to; i++){
            let type = $7beee9608540d2c3$var$types[i];
            if (type == 128 /* T.CS */ ) {
                if (i < to - 1 && prev == $7beee9608540d2c3$var$types[i + 1] && prev & 24 /* T.Num */ ) type = $7beee9608540d2c3$var$types[i] = prev;
                else $7beee9608540d2c3$var$types[i] = 256 /* T.NI */ ;
            } else if (type == 64 /* T.ET */ ) {
                let end = i + 1;
                while(end < to && $7beee9608540d2c3$var$types[end] == 64 /* T.ET */ )end++;
                let replace = i && prev == 8 /* T.EN */  || end < rTo && $7beee9608540d2c3$var$types[end] == 8 /* T.EN */  ? prevStrong == 1 /* T.L */  ? 1 /* T.L */  : 8 /* T.EN */  : 256 /* T.NI */ ;
                for(let j = i; j < end; j++)$7beee9608540d2c3$var$types[j] = replace;
                i = end - 1;
            } else if (type == 8 /* T.EN */  && prevStrong == 1 /* T.L */ ) $7beee9608540d2c3$var$types[i] = 1 /* T.L */ ;
            prev = type;
            if (type & 7 /* T.Strong */ ) prevStrong = type;
        }
    }
}
// Process brackets throughout a run sequence.
function $7beee9608540d2c3$var$processBracketPairs(line, rFrom, rTo, isolates, outerType) {
    let oppositeType = outerType == 1 /* T.L */  ? 2 /* T.R */  : 1 /* T.L */ ;
    for(let iI = 0, sI = 0, context = 0; iI <= isolates.length; iI++){
        let from = iI ? isolates[iI - 1].to : rFrom, to = iI < isolates.length ? isolates[iI].from : rTo;
        // N0. Process bracket pairs in an isolating run sequence
        // sequentially in the logical order of the text positions of the
        // opening paired brackets using the logic given below. Within this
        // scope, bidirectional types EN and AN are treated as R.
        for(let i = from, ch, br, type; i < to; i++){
            // Keeps [startIndex, type, strongSeen] triples for each open
            // bracket on BracketStack.
            if (br = $7beee9608540d2c3$var$Brackets[ch = line.charCodeAt(i)]) {
                if (br < 0) {
                    for(let sJ = sI - 3; sJ >= 0; sJ -= 3)if ($7beee9608540d2c3$var$BracketStack[sJ + 1] == -br) {
                        let flags = $7beee9608540d2c3$var$BracketStack[sJ + 2];
                        let type = flags & 2 /* Bracketed.EmbedInside */  ? outerType : !(flags & 4 /* Bracketed.OppositeInside */ ) ? 0 : flags & 1 /* Bracketed.OppositeBefore */  ? oppositeType : outerType;
                        if (type) $7beee9608540d2c3$var$types[i] = $7beee9608540d2c3$var$types[$7beee9608540d2c3$var$BracketStack[sJ]] = type;
                        sI = sJ;
                        break;
                    }
                } else if ($7beee9608540d2c3$var$BracketStack.length == 189 /* Bracketed.MaxDepth */ ) break;
                else {
                    $7beee9608540d2c3$var$BracketStack[sI++] = i;
                    $7beee9608540d2c3$var$BracketStack[sI++] = ch;
                    $7beee9608540d2c3$var$BracketStack[sI++] = context;
                }
            } else if ((type = $7beee9608540d2c3$var$types[i]) == 2 /* T.R */  || type == 1 /* T.L */ ) {
                let embed = type == outerType;
                context = embed ? 0 : 1 /* Bracketed.OppositeBefore */ ;
                for(let sJ = sI - 3; sJ >= 0; sJ -= 3){
                    let cur = $7beee9608540d2c3$var$BracketStack[sJ + 2];
                    if (cur & 2 /* Bracketed.EmbedInside */ ) break;
                    if (embed) $7beee9608540d2c3$var$BracketStack[sJ + 2] |= 2 /* Bracketed.EmbedInside */ ;
                    else {
                        if (cur & 4 /* Bracketed.OppositeInside */ ) break;
                        $7beee9608540d2c3$var$BracketStack[sJ + 2] |= 4 /* Bracketed.OppositeInside */ ;
                    }
                }
            }
        }
    }
}
function $7beee9608540d2c3$var$processNeutrals(rFrom, rTo, isolates, outerType) {
    for(let iI = 0, prev = outerType; iI <= isolates.length; iI++){
        let from = iI ? isolates[iI - 1].to : rFrom, to = iI < isolates.length ? isolates[iI].from : rTo;
        // N1. A sequence of neutrals takes the direction of the
        // surrounding strong text if the text on both sides has the same
        // direction. European and Arabic numbers act as if they were R in
        // terms of their influence on neutrals. Start-of-level-run (sor)
        // and end-of-level-run (eor) are used at level run boundaries.
        // N2. Any remaining neutrals take the embedding direction.
        // (Left after this: L, R, EN+AN)
        for(let i = from; i < to;){
            let type = $7beee9608540d2c3$var$types[i];
            if (type == 256 /* T.NI */ ) {
                let end = i + 1;
                for(;;){
                    if (end == to) {
                        if (iI == isolates.length) break;
                        end = isolates[iI++].to;
                        to = iI < isolates.length ? isolates[iI].from : rTo;
                    } else if ($7beee9608540d2c3$var$types[end] == 256 /* T.NI */ ) end++;
                    else break;
                }
                let beforeL = prev == 1 /* T.L */ ;
                let afterL = (end < rTo ? $7beee9608540d2c3$var$types[end] : outerType) == 1 /* T.L */ ;
                let replace = beforeL == afterL ? beforeL ? 1 /* T.L */  : 2 /* T.R */  : outerType;
                for(let j = end, jI = iI, fromJ = jI ? isolates[jI - 1].to : rFrom; j > i;){
                    if (j == fromJ) {
                        j = isolates[--jI].from;
                        fromJ = jI ? isolates[jI - 1].to : rFrom;
                    }
                    $7beee9608540d2c3$var$types[--j] = replace;
                }
                i = end;
            } else {
                prev = type;
                i++;
            }
        }
    }
}
// Find the contiguous ranges of character types in a given range, and
// emit spans for them. Flip the order of the spans as appropriate
// based on the level, and call through to compute the spans for
// isolates at the proper point.
function $7beee9608540d2c3$var$emitSpans(line, from, to, level, baseLevel, isolates, order) {
    let ourType = level % 2 ? 2 /* T.R */  : 1 /* T.L */ ;
    if (level % 2 == baseLevel % 2) for(let iCh = from, iI = 0; iCh < to;){
        // Scan a section of characters in direction ourType, unless
        // there's another type of char right after iCh, in which case
        // we scan a section of other characters (which, if ourType ==
        // T.L, may contain both T.R and T.AN chars).
        let sameDir = true, isNum = false;
        if (iI == isolates.length || iCh < isolates[iI].from) {
            let next = $7beee9608540d2c3$var$types[iCh];
            if (next != ourType) {
                sameDir = false;
                isNum = next == 16 /* T.AN */ ;
            }
        }
        // Holds an array of isolates to pass to a recursive call if we
        // must recurse (to distinguish T.AN inside an RTL section in
        // LTR text), null if we can emit directly
        let recurse = !sameDir && ourType == 1 /* T.L */  ? [] : null;
        let localLevel = sameDir ? level : level + 1;
        let iScan = iCh;
        run: for(;;){
            if (iI < isolates.length && iScan == isolates[iI].from) {
                if (isNum) break run;
                let iso = isolates[iI];
                // Scan ahead to verify that there is another char in this dir after the isolate(s)
                if (!sameDir) for(let upto = iso.to, jI = iI + 1;;){
                    if (upto == to) break run;
                    if (jI < isolates.length && isolates[jI].from == upto) upto = isolates[jI++].to;
                    else if ($7beee9608540d2c3$var$types[upto] == ourType) break run;
                    else break;
                }
                iI++;
                if (recurse) recurse.push(iso);
                else {
                    if (iso.from > iCh) order.push(new $7beee9608540d2c3$export$e1ed96b746bb516a(iCh, iso.from, localLevel));
                    let dirSwap = iso.direction == $7beee9608540d2c3$var$LTR != !(localLevel % 2);
                    $7beee9608540d2c3$var$computeSectionOrder(line, dirSwap ? level + 1 : level, baseLevel, iso.inner, iso.from, iso.to, order);
                    iCh = iso.to;
                }
                iScan = iso.to;
            } else if (iScan == to || (sameDir ? $7beee9608540d2c3$var$types[iScan] != ourType : $7beee9608540d2c3$var$types[iScan] == ourType)) break;
            else iScan++;
        }
        if (recurse) $7beee9608540d2c3$var$emitSpans(line, iCh, iScan, level + 1, baseLevel, recurse, order);
        else if (iCh < iScan) order.push(new $7beee9608540d2c3$export$e1ed96b746bb516a(iCh, iScan, localLevel));
        iCh = iScan;
    }
    else // Iterate in reverse to flip the span order. Same code again, but
    // going from the back of the section to the front
    for(let iCh = to, iI = isolates.length; iCh > from;){
        let sameDir = true, isNum = false;
        if (!iI || iCh > isolates[iI - 1].to) {
            let next = $7beee9608540d2c3$var$types[iCh - 1];
            if (next != ourType) {
                sameDir = false;
                isNum = next == 16 /* T.AN */ ;
            }
        }
        let recurse = !sameDir && ourType == 1 /* T.L */  ? [] : null;
        let localLevel = sameDir ? level : level + 1;
        let iScan = iCh;
        run: for(;;){
            if (iI && iScan == isolates[iI - 1].to) {
                if (isNum) break run;
                let iso = isolates[--iI];
                // Scan ahead to verify that there is another char in this dir after the isolate(s)
                if (!sameDir) for(let upto = iso.from, jI = iI;;){
                    if (upto == from) break run;
                    if (jI && isolates[jI - 1].to == upto) upto = isolates[--jI].from;
                    else if ($7beee9608540d2c3$var$types[upto - 1] == ourType) break run;
                    else break;
                }
                if (recurse) recurse.push(iso);
                else {
                    if (iso.to < iCh) order.push(new $7beee9608540d2c3$export$e1ed96b746bb516a(iso.to, iCh, localLevel));
                    let dirSwap = iso.direction == $7beee9608540d2c3$var$LTR != !(localLevel % 2);
                    $7beee9608540d2c3$var$computeSectionOrder(line, dirSwap ? level + 1 : level, baseLevel, iso.inner, iso.from, iso.to, order);
                    iCh = iso.from;
                }
                iScan = iso.from;
            } else if (iScan == from || (sameDir ? $7beee9608540d2c3$var$types[iScan - 1] != ourType : $7beee9608540d2c3$var$types[iScan - 1] == ourType)) break;
            else iScan--;
        }
        if (recurse) $7beee9608540d2c3$var$emitSpans(line, iScan, iCh, level + 1, baseLevel, recurse, order);
        else if (iScan < iCh) order.push(new $7beee9608540d2c3$export$e1ed96b746bb516a(iScan, iCh, localLevel));
        iCh = iScan;
    }
}
function $7beee9608540d2c3$var$computeSectionOrder(line, level, baseLevel, isolates, from, to, order) {
    let outerType = level % 2 ? 2 /* T.R */  : 1 /* T.L */ ;
    $7beee9608540d2c3$var$computeCharTypes(line, from, to, isolates, outerType);
    $7beee9608540d2c3$var$processBracketPairs(line, from, to, isolates, outerType);
    $7beee9608540d2c3$var$processNeutrals(from, to, isolates, outerType);
    $7beee9608540d2c3$var$emitSpans(line, from, to, level, baseLevel, isolates, order);
}
function $7beee9608540d2c3$var$computeOrder(line, direction, isolates) {
    if (!line) return [
        new $7beee9608540d2c3$export$e1ed96b746bb516a(0, 0, direction == $7beee9608540d2c3$var$RTL ? 1 : 0)
    ];
    if (direction == $7beee9608540d2c3$var$LTR && !isolates.length && !$7beee9608540d2c3$var$BidiRE.test(line)) return $7beee9608540d2c3$var$trivialOrder(line.length);
    if (isolates.length) while(line.length > $7beee9608540d2c3$var$types.length)$7beee9608540d2c3$var$types[$7beee9608540d2c3$var$types.length] = 256 /* T.NI */ ; // Make sure types array has no gaps
    let order = [], level = direction == $7beee9608540d2c3$var$LTR ? 0 : 1;
    $7beee9608540d2c3$var$computeSectionOrder(line, level, level, isolates, 0, line.length, order);
    return order;
}
function $7beee9608540d2c3$var$trivialOrder(length) {
    return [
        new $7beee9608540d2c3$export$e1ed96b746bb516a(0, length, 0)
    ];
}
let $7beee9608540d2c3$var$movedOver = "";
// This implementation moves strictly visually, without concern for a
// traversal visiting every logical position in the string. It will
// still do so for simple input, but situations like multiple isolates
// with the same level next to each other, or text going against the
// main dir at the end of the line, will make some positions
// unreachable with this motion. Each visible cursor position will
// correspond to the lower-level bidi span that touches it.
//
// The alternative would be to solve an order globally for a given
// line, making sure that it includes every position, but that would
// require associating non-canonical (higher bidi span level)
// positions with a given visual position, which is likely to confuse
// people. (And would generally be a lot more complicated.)
function $7beee9608540d2c3$var$moveVisually(line, order, dir, start, forward) {
    var _a;
    let startIndex = start.head - line.from;
    let spanI = $7beee9608540d2c3$export$e1ed96b746bb516a.find(order, startIndex, (_a = start.bidiLevel) !== null && _a !== void 0 ? _a : -1, start.assoc);
    let span = order[spanI], spanEnd = span.side(forward, dir);
    // End of span
    if (startIndex == spanEnd) {
        let nextI = spanI += forward ? 1 : -1;
        if (nextI < 0 || nextI >= order.length) return null;
        span = order[spanI = nextI];
        startIndex = span.side(!forward, dir);
        spanEnd = span.side(forward, dir);
    }
    let nextIndex = (0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(line.text, startIndex, span.forward(forward, dir));
    if (nextIndex < span.from || nextIndex > span.to) nextIndex = spanEnd;
    $7beee9608540d2c3$var$movedOver = line.text.slice(Math.min(startIndex, nextIndex), Math.max(startIndex, nextIndex));
    let nextSpan = spanI == (forward ? order.length - 1 : 0) ? null : order[spanI + (forward ? 1 : -1)];
    if (nextSpan && nextIndex == spanEnd && nextSpan.level + (forward ? 0 : 1) < span.level) return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(nextSpan.side(!forward, dir) + line.from, nextSpan.forward(forward, dir) ? 1 : -1, nextSpan.level);
    return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(nextIndex + line.from, span.forward(forward, dir) ? -1 : 1, span.level);
}
function $7beee9608540d2c3$var$autoDirection(text, from, to) {
    for(let i = from; i < to; i++){
        let type = $7beee9608540d2c3$var$charType(text.charCodeAt(i));
        if (type == 1 /* T.L */ ) return $7beee9608540d2c3$var$LTR;
        if (type == 2 /* T.R */  || type == 4 /* T.AL */ ) return $7beee9608540d2c3$var$RTL;
    }
    return $7beee9608540d2c3$var$LTR;
}
const $7beee9608540d2c3$var$clickAddsSelectionRange = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$dragMovesSelection$1 = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$mouseSelectionStyle = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$exceptionSink = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$updateListener = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$inputHandler = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$focusChangeEffect = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$clipboardInputFilter = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$clipboardOutputFilter = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$perLineTextDirection = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine: (values)=>values.some((x)=>x)
});
const $7beee9608540d2c3$var$nativeSelectionHidden = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine: (values)=>values.some((x)=>x)
});
const $7beee9608540d2c3$var$scrollHandler = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
class $7beee9608540d2c3$var$ScrollTarget {
    constructor(range, y, x, yMargin, xMargin, // This data structure is abused to also store precise scroll
    // snapshots, instead of a `scrollIntoView` request. When this
    // flag is `true`, `range` points at a position in the reference
    // line, `yMargin` holds the difference between the top of that
    // line and the top of the editor, and `xMargin` holds the
    // editor's `scrollLeft`.
    isSnapshot = false){
        this.range = range;
        this.y = y;
        this.x = x;
        this.yMargin = yMargin;
        this.xMargin = xMargin;
        this.isSnapshot = isSnapshot;
    }
    map(changes) {
        return changes.empty ? this : new $7beee9608540d2c3$var$ScrollTarget(this.range.map(changes), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
    }
    clip(state) {
        return this.range.to <= state.doc.length ? this : new $7beee9608540d2c3$var$ScrollTarget((0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(state.doc.length), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
    }
}
const $7beee9608540d2c3$var$scrollIntoView = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define({
    map: (t, ch)=>t.map(ch)
});
const $7beee9608540d2c3$var$setEditContextFormatting = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
/**
Log or report an unhandled exception in client code. Should
probably only be used by extension code that allows client code to
provide functions, and calls those functions in a context where an
exception can't be propagated to calling code in a reasonable way
(for example when in an event handler).

Either calls a handler registered with
[`EditorView.exceptionSink`](https://codemirror.net/6/docs/ref/#view.EditorView^exceptionSink),
`window.onerror`, if defined, or `console.error` (in which case
it'll pass `context`, when given, as first argument).
*/ function $7beee9608540d2c3$export$f86b2a1a2ce291b3(state, exception, context) {
    let handler = state.facet($7beee9608540d2c3$var$exceptionSink);
    if (handler.length) handler[0](exception);
    else if (window.onerror && window.onerror(String(exception), context, undefined, undefined, exception)) ;
    else if (context) console.error(context + ":", exception);
    else console.error(exception);
}
const $7beee9608540d2c3$var$editable = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine: (values)=>values.length ? values[0] : true
});
let $7beee9608540d2c3$var$nextPluginID = 0;
const $7beee9608540d2c3$var$viewPlugin = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (plugins) {
        return plugins.filter((p, i)=>{
            for(let j = 0; j < i; j++)if (plugins[j].plugin == p.plugin) return false;
            return true;
        });
    }
});
/**
View plugins associate stateful values with a view. They can
influence the way the content is drawn, and are notified of things
that happen in the view. They optionally take an argument, in
which case you need to call [`of`](https://codemirror.net/6/docs/ref/#view.ViewPlugin.of) to create
an extension for the plugin. When the argument type is undefined,
you can use the plugin instance as an extension directly.
*/ class $7beee9608540d2c3$export$44d5eccfd62adda7 {
    constructor(/**
    @internal
    */ id, /**
    @internal
    */ create, /**
    @internal
    */ domEventHandlers, /**
    @internal
    */ domEventObservers, buildExtensions){
        this.id = id;
        this.create = create;
        this.domEventHandlers = domEventHandlers;
        this.domEventObservers = domEventObservers;
        this.baseExtensions = buildExtensions(this);
        this.extension = this.baseExtensions.concat($7beee9608540d2c3$var$viewPlugin.of({
            plugin: this,
            arg: undefined
        }));
    }
    /**
    Create an extension for this plugin with the given argument.
    */ of(arg) {
        return this.baseExtensions.concat($7beee9608540d2c3$var$viewPlugin.of({
            plugin: this,
            arg: arg
        }));
    }
    /**
    Define a plugin from a constructor function that creates the
    plugin's value, given an editor view.
    */ static define(create, spec) {
        const { eventHandlers: eventHandlers, eventObservers: eventObservers, provide: provide, decorations: deco } = spec || {};
        return new $7beee9608540d2c3$export$44d5eccfd62adda7($7beee9608540d2c3$var$nextPluginID++, create, eventHandlers, eventObservers, (plugin)=>{
            let ext = [];
            if (deco) ext.push($7beee9608540d2c3$var$decorations.of((view)=>{
                let pluginInst = view.plugin(plugin);
                return pluginInst ? deco(pluginInst) : $7beee9608540d2c3$export$10e30b733df217ea.none;
            }));
            if (provide) ext.push(provide(plugin));
            return ext;
        });
    }
    /**
    Create a plugin for a class whose constructor takes a single
    editor view as argument.
    */ static fromClass(cls, spec) {
        return $7beee9608540d2c3$export$44d5eccfd62adda7.define((view, arg)=>new cls(view, arg), spec);
    }
}
class $7beee9608540d2c3$var$PluginInstance {
    constructor(spec){
        this.spec = spec;
        // When starting an update, all plugins have this field set to the
        // update object, indicating they need to be updated. When finished
        // updating, it is set to `null`. Retrieving a plugin that needs to
        // be updated with `view.plugin` forces an eager update.
        this.mustUpdate = null;
        // This is null when the plugin is initially created, but
        // initialized on the first update.
        this.value = null;
    }
    get plugin() {
        return this.spec && this.spec.plugin;
    }
    update(view) {
        if (!this.value) {
            if (this.spec) try {
                this.value = this.spec.plugin.create(view, this.spec.arg);
            } catch (e) {
                $7beee9608540d2c3$export$f86b2a1a2ce291b3(view.state, e, "CodeMirror plugin crashed");
                this.deactivate();
            }
        } else if (this.mustUpdate) {
            let update = this.mustUpdate;
            this.mustUpdate = null;
            if (this.value.update) try {
                this.value.update(update);
            } catch (e) {
                $7beee9608540d2c3$export$f86b2a1a2ce291b3(update.state, e, "CodeMirror plugin crashed");
                if (this.value.destroy) try {
                    this.value.destroy();
                } catch (_) {}
                this.deactivate();
            }
        }
        return this;
    }
    destroy(view) {
        var _a;
        if ((_a = this.value) === null || _a === void 0 ? void 0 : _a.destroy) try {
            this.value.destroy();
        } catch (e) {
            $7beee9608540d2c3$export$f86b2a1a2ce291b3(view.state, e, "CodeMirror plugin crashed");
        }
    }
    deactivate() {
        this.spec = this.value = null;
    }
}
const $7beee9608540d2c3$var$editorAttributes = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$contentAttributes = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
// Provide decorations
const $7beee9608540d2c3$var$decorations = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$blockWrappers = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$outerDecorations = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$atomicRanges = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$bidiIsolatedRanges = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
function $7beee9608540d2c3$var$getIsolatedRanges(view, line) {
    let isolates = view.state.facet($7beee9608540d2c3$var$bidiIsolatedRanges);
    if (!isolates.length) return isolates;
    let sets = isolates.map((i)=>i instanceof Function ? i(view) : i);
    let result = [];
    (0, $6295c6875f57e3ee$export$34cb5241245008dd).spans(sets, line.from, line.to, {
        point () {},
        span (fromDoc, toDoc, active, open) {
            let from = fromDoc - line.from, to = toDoc - line.from;
            let level = result;
            for(let i = active.length - 1; i >= 0; i--, open--){
                let direction = active[i].spec.bidiIsolate, update;
                if (direction == null) direction = $7beee9608540d2c3$var$autoDirection(line.text, from, to);
                if (open > 0 && level.length && (update = level[level.length - 1]).to == from && update.direction == direction) {
                    update.to = to;
                    level = update.inner;
                } else {
                    let add = {
                        from: from,
                        to: to,
                        direction: direction,
                        inner: []
                    };
                    level.push(add);
                    level = add.inner;
                }
            }
        }
    });
    return result;
}
const $7beee9608540d2c3$var$scrollMargins = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
function $7beee9608540d2c3$var$getScrollMargins(view) {
    let left = 0, right = 0, top = 0, bottom = 0;
    for (let source of view.state.facet($7beee9608540d2c3$var$scrollMargins)){
        let m = source(view);
        if (m) {
            if (m.left != null) left = Math.max(left, m.left);
            if (m.right != null) right = Math.max(right, m.right);
            if (m.top != null) top = Math.max(top, m.top);
            if (m.bottom != null) bottom = Math.max(bottom, m.bottom);
        }
    }
    return {
        left: left,
        right: right,
        top: top,
        bottom: bottom
    };
}
const $7beee9608540d2c3$var$styleModule = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
class $7beee9608540d2c3$var$ChangedRange {
    constructor(fromA, toA, fromB, toB){
        this.fromA = fromA;
        this.toA = toA;
        this.fromB = fromB;
        this.toB = toB;
    }
    join(other) {
        return new $7beee9608540d2c3$var$ChangedRange(Math.min(this.fromA, other.fromA), Math.max(this.toA, other.toA), Math.min(this.fromB, other.fromB), Math.max(this.toB, other.toB));
    }
    addToSet(set) {
        let i = set.length, me = this;
        for(; i > 0; i--){
            let range = set[i - 1];
            if (range.fromA > me.toA) continue;
            if (range.toA < me.fromA) break;
            me = me.join(range);
            set.splice(i - 1, 1);
        }
        set.splice(i, 0, me);
        return set;
    }
    // Extend a set to cover all the content in `ranges`, which is a
    // flat array with each pair of numbers representing fromB/toB
    // positions. These pairs are generated in unchanged ranges, so the
    // offset between doc A and doc B is the same for their start and
    // end points.
    static extendWithRanges(diff, ranges) {
        if (ranges.length == 0) return diff;
        let result = [];
        for(let dI = 0, rI = 0, off = 0;;){
            let nextD = dI < diff.length ? diff[dI].fromB : 1e9;
            let nextR = rI < ranges.length ? ranges[rI] : 1e9;
            let fromB = Math.min(nextD, nextR);
            if (fromB == 1e9) break;
            let fromA = fromB + off, toB = fromB, toA = fromA;
            for(;;){
                if (rI < ranges.length && ranges[rI] <= toB) {
                    let end = ranges[rI + 1];
                    rI += 2;
                    toB = Math.max(toB, end);
                    for(let i = dI; i < diff.length && diff[i].fromB <= toB; i++)off = diff[i].toA - diff[i].toB;
                    toA = Math.max(toA, end + off);
                } else if (dI < diff.length && diff[dI].fromB <= toB) {
                    let next = diff[dI++];
                    toB = Math.max(toB, next.toB);
                    toA = Math.max(toA, next.toA);
                    off = next.toA - next.toB;
                } else break;
            }
            result.push(new $7beee9608540d2c3$var$ChangedRange(fromA, toA, fromB, toB));
        }
        return result;
    }
}
/**
View [plugins](https://codemirror.net/6/docs/ref/#view.ViewPlugin) are given instances of this
class, which describe what happened, whenever the view is updated.
*/ class $7beee9608540d2c3$export$b5b084f95c87edf7 {
    constructor(/**
    The editor view that the update is associated with.
    */ view, /**
    The new editor state.
    */ state, /**
    The transactions involved in the update. May be empty.
    */ transactions){
        this.view = view;
        this.state = state;
        this.transactions = transactions;
        /**
        @internal
        */ this.flags = 0;
        this.startState = view.state;
        this.changes = (0, $6295c6875f57e3ee$export$29d7fbdcb1f8b71c).empty(this.startState.doc.length);
        for (let tr of transactions)this.changes = this.changes.compose(tr.changes);
        let changedRanges = [];
        this.changes.iterChangedRanges((fromA, toA, fromB, toB)=>changedRanges.push(new $7beee9608540d2c3$var$ChangedRange(fromA, toA, fromB, toB)));
        this.changedRanges = changedRanges;
    }
    /**
    @internal
    */ static create(view, state, transactions) {
        return new $7beee9608540d2c3$export$b5b084f95c87edf7(view, state, transactions);
    }
    /**
    Tells you whether the [viewport](https://codemirror.net/6/docs/ref/#view.EditorView.viewport) or
    [visible ranges](https://codemirror.net/6/docs/ref/#view.EditorView.visibleRanges) changed in this
    update.
    */ get viewportChanged() {
        return (this.flags & 4 /* UpdateFlag.Viewport */ ) > 0;
    }
    /**
    Returns true when
    [`viewportChanged`](https://codemirror.net/6/docs/ref/#view.ViewUpdate.viewportChanged) is true
    and the viewport change is not just the result of mapping it in
    response to document changes.
    */ get viewportMoved() {
        return (this.flags & 8 /* UpdateFlag.ViewportMoved */ ) > 0;
    }
    /**
    Indicates whether the height of a block element in the editor
    changed in this update.
    */ get heightChanged() {
        return (this.flags & 2 /* UpdateFlag.Height */ ) > 0;
    }
    /**
    Returns true when the document was modified or the size of the
    editor, or elements within the editor, changed.
    */ get geometryChanged() {
        return this.docChanged || (this.flags & 18 /* UpdateFlag.Height */ ) > 0;
    }
    /**
    True when this update indicates a focus change.
    */ get focusChanged() {
        return (this.flags & 1 /* UpdateFlag.Focus */ ) > 0;
    }
    /**
    Whether the document changed in this update.
    */ get docChanged() {
        return !this.changes.empty;
    }
    /**
    Whether the selection was explicitly set in this update.
    */ get selectionSet() {
        return this.transactions.some((tr)=>tr.selection);
    }
    /**
    @internal
    */ get empty() {
        return this.flags == 0 && this.transactions.length == 0;
    }
}
const $7beee9608540d2c3$var$noChildren = [];
class $7beee9608540d2c3$var$Tile {
    constructor(dom, length, flags = 0){
        this.dom = dom;
        this.length = length;
        this.flags = flags;
        this.parent = null;
        dom.cmTile = this;
    }
    get breakAfter() {
        return this.flags & 1 /* TileFlag.BreakAfter */ ;
    }
    get children() {
        return $7beee9608540d2c3$var$noChildren;
    }
    isWidget() {
        return false;
    }
    get isHidden() {
        return false;
    }
    isComposite() {
        return false;
    }
    isLine() {
        return false;
    }
    isText() {
        return false;
    }
    isBlock() {
        return false;
    }
    get domAttrs() {
        return null;
    }
    sync(track) {
        this.flags |= 2 /* TileFlag.Synced */ ;
        if (this.flags & 4 /* TileFlag.AttrsDirty */ ) {
            this.flags &= -5 /* TileFlag.AttrsDirty */ ;
            let attrs = this.domAttrs;
            if (attrs) $7beee9608540d2c3$var$setAttrs(this.dom, attrs);
        }
    }
    toString() {
        return this.constructor.name + (this.children.length ? `(${this.children})` : "") + (this.breakAfter ? "#" : "");
    }
    destroy() {
        this.parent = null;
    }
    setDOM(dom) {
        this.dom = dom;
        dom.cmTile = this;
    }
    get posAtStart() {
        return this.parent ? this.parent.posBefore(this) : 0;
    }
    get posAtEnd() {
        return this.posAtStart + this.length;
    }
    posBefore(tile, start = this.posAtStart) {
        let pos = start;
        for (let child of this.children){
            if (child == tile) return pos;
            pos += child.length + child.breakAfter;
        }
        throw new RangeError("Invalid child in posBefore");
    }
    posAfter(tile) {
        return this.posBefore(tile) + tile.length;
    }
    covers(side) {
        return true;
    }
    coordsIn(pos, side) {
        return null;
    }
    domPosFor(off, side) {
        let index = $7beee9608540d2c3$var$domIndex(this.dom);
        let after = this.length ? off > 0 : side > 0;
        return new $7beee9608540d2c3$var$DOMPos(this.parent.dom, index + (after ? 1 : 0), off == 0 || off == this.length);
    }
    markDirty(attrs) {
        this.flags &= -3 /* TileFlag.Synced */ ;
        if (attrs) this.flags |= 4 /* TileFlag.AttrsDirty */ ;
        if (this.parent && this.parent.flags & 2 /* TileFlag.Synced */ ) this.parent.markDirty(false);
    }
    get overrideDOMText() {
        return null;
    }
    get root() {
        for(let t = this; t; t = t.parent)if (t instanceof $7beee9608540d2c3$var$DocTile) return t;
        return null;
    }
    static get(dom) {
        return dom.cmTile;
    }
}
class $7beee9608540d2c3$var$CompositeTile extends $7beee9608540d2c3$var$Tile {
    constructor(dom){
        super(dom, 0);
        this._children = [];
    }
    isComposite() {
        return true;
    }
    get children() {
        return this._children;
    }
    get lastChild() {
        return this.children.length ? this.children[this.children.length - 1] : null;
    }
    append(child) {
        this.children.push(child);
        child.parent = this;
    }
    sync(track) {
        if (this.flags & 2 /* TileFlag.Synced */ ) return;
        super.sync(track);
        let parent = this.dom, prev = null, next;
        let tracking = (track === null || track === void 0 ? void 0 : track.node) == parent ? track : null;
        let length = 0;
        for (let child of this.children){
            child.sync(track);
            length += child.length + child.breakAfter;
            next = prev ? prev.nextSibling : parent.firstChild;
            if (tracking && next != child.dom) tracking.written = true;
            if (child.dom.parentNode == parent) while(next && next != child.dom)next = $7beee9608540d2c3$var$rm$1(next);
            else parent.insertBefore(child.dom, next);
            prev = child.dom;
        }
        next = prev ? prev.nextSibling : parent.firstChild;
        if (tracking && next) tracking.written = true;
        while(next)next = $7beee9608540d2c3$var$rm$1(next);
        this.length = length;
    }
}
// Remove a DOM node and return its next sibling.
function $7beee9608540d2c3$var$rm$1(dom) {
    let next = dom.nextSibling;
    dom.parentNode.removeChild(dom);
    return next;
}
// The top-level tile. Its dom property equals view.contentDOM.
class $7beee9608540d2c3$var$DocTile extends $7beee9608540d2c3$var$CompositeTile {
    constructor(view, dom){
        super(dom);
        this.view = view;
    }
    owns(tile) {
        for(; tile; tile = tile.parent)if (tile == this) return true;
        return false;
    }
    isBlock() {
        return true;
    }
    nearest(dom) {
        for(;;){
            if (!dom) return null;
            let tile = $7beee9608540d2c3$var$Tile.get(dom);
            if (tile && this.owns(tile)) return tile;
            dom = dom.parentNode;
        }
    }
    blockTiles(f) {
        for(let stack = [], cur = this, i = 0, pos = 0;;)if (i == cur.children.length) {
            if (!stack.length) return;
            cur = cur.parent;
            if (cur.breakAfter) pos++;
            i = stack.pop();
        } else {
            let next = cur.children[i++];
            if (next instanceof $7beee9608540d2c3$var$BlockWrapperTile) {
                stack.push(i);
                cur = next;
                i = 0;
            } else {
                let end = pos + next.length;
                let result = f(next, pos);
                if (result !== undefined) return result;
                pos = end + next.breakAfter;
            }
        }
    }
    // Find the block at the given position. If side < -1, make sure to
    // stay before block widgets at that position, if side > 1, after
    // such widgets (used for selection drawing, which needs to be able
    // to get coordinates for positions that aren't valid cursor positions).
    resolveBlock(pos, side) {
        let before, beforeOff = -1, after, afterOff = -1;
        this.blockTiles((tile, off)=>{
            let end = off + tile.length;
            if (pos >= off && pos <= end) {
                if (tile.isWidget() && side >= -1 && side <= 1) {
                    if (tile.flags & 32 /* TileFlag.After */ ) return true;
                    if (tile.flags & 16 /* TileFlag.Before */ ) before = undefined;
                }
                if ((off < pos || pos == end && (side < -1 ? tile.length : tile.covers(1))) && (!before || !tile.isWidget() && before.isWidget())) {
                    before = tile;
                    beforeOff = pos - off;
                }
                if ((end > pos || pos == off && (side > 1 ? tile.length : tile.covers(-1))) && (!after || !tile.isWidget() && after.isWidget())) {
                    after = tile;
                    afterOff = pos - off;
                }
            }
        });
        if (!before && !after) throw new Error("No tile at position " + pos);
        return before && side < 0 || !after ? {
            tile: before,
            offset: beforeOff
        } : {
            tile: after,
            offset: afterOff
        };
    }
}
class $7beee9608540d2c3$var$BlockWrapperTile extends $7beee9608540d2c3$var$CompositeTile {
    constructor(dom, wrapper){
        super(dom);
        this.wrapper = wrapper;
    }
    isBlock() {
        return true;
    }
    covers(side) {
        if (!this.children.length) return false;
        return side < 0 ? this.children[0].covers(-1) : this.lastChild.covers(1);
    }
    get domAttrs() {
        return this.wrapper.attributes;
    }
    static of(wrapper, dom) {
        let tile = new $7beee9608540d2c3$var$BlockWrapperTile(dom || document.createElement(wrapper.tagName), wrapper);
        if (!dom) tile.flags |= 4 /* TileFlag.AttrsDirty */ ;
        return tile;
    }
}
class $7beee9608540d2c3$var$LineTile extends $7beee9608540d2c3$var$CompositeTile {
    constructor(dom, attrs){
        super(dom);
        this.attrs = attrs;
    }
    isLine() {
        return true;
    }
    static start(attrs, dom, keepAttrs) {
        let line = new $7beee9608540d2c3$var$LineTile(dom || document.createElement("div"), attrs);
        if (!dom || !keepAttrs) line.flags |= 4 /* TileFlag.AttrsDirty */ ;
        return line;
    }
    get domAttrs() {
        return this.attrs;
    }
    // Find the tile associated with a given position in this line.
    resolveInline(pos, side, forCoords) {
        let before = null, beforeOff = -1, after = null, afterOff = -1;
        function scan(tile, pos) {
            for(let i = 0, off = 0; i < tile.children.length && off <= pos; i++){
                let child = tile.children[i], end = off + child.length;
                if (end >= pos) {
                    if (child.isComposite()) scan(child, pos - off);
                    else if ((!after || after.isHidden && (side > 0 || forCoords && $7beee9608540d2c3$var$onSameLine(after, child))) && (end > pos || child.flags & 32 /* TileFlag.After */ )) {
                        after = child;
                        afterOff = pos - off;
                    } else if (off < pos || child.flags & 16 /* TileFlag.Before */  && !child.isHidden) {
                        before = child;
                        beforeOff = pos - off;
                    }
                }
                off = end;
            }
        }
        scan(this, pos);
        let target = (side < 0 ? before : after) || before || after;
        return target ? {
            tile: target,
            offset: target == before ? beforeOff : afterOff
        } : null;
    }
    coordsIn(pos, side) {
        let found = this.resolveInline(pos, side, true);
        if (!found) return $7beee9608540d2c3$var$fallbackRect(this);
        return found.tile.coordsIn(Math.max(0, found.offset), side);
    }
    domIn(pos, side) {
        let found = this.resolveInline(pos, side);
        if (found) {
            let { tile: tile, offset: offset } = found;
            if (this.dom.contains(tile.dom)) {
                if (tile.isText()) return new $7beee9608540d2c3$var$DOMPos(tile.dom, Math.min(tile.dom.nodeValue.length, offset));
                return tile.domPosFor(offset, tile.flags & 16 /* TileFlag.Before */  ? 1 : tile.flags & 32 /* TileFlag.After */  ? -1 : side);
            }
            let parent = found.tile.parent, saw = false;
            for (let ch of parent.children){
                if (saw) return new $7beee9608540d2c3$var$DOMPos(ch.dom, 0);
                if (ch == found.tile) saw = true;
            }
        }
        return new $7beee9608540d2c3$var$DOMPos(this.dom, 0);
    }
}
function $7beee9608540d2c3$var$fallbackRect(tile) {
    let last = tile.dom.lastChild;
    if (!last) return tile.dom.getBoundingClientRect();
    let rects = $7beee9608540d2c3$var$clientRectsFor(last);
    return rects[rects.length - 1] || null;
}
function $7beee9608540d2c3$var$onSameLine(a, b) {
    let posA = a.coordsIn(0, 1), posB = b.coordsIn(0, 1);
    return posA && posB && posB.top < posA.bottom;
}
class $7beee9608540d2c3$var$MarkTile extends $7beee9608540d2c3$var$CompositeTile {
    constructor(dom, mark){
        super(dom);
        this.mark = mark;
    }
    get domAttrs() {
        return this.mark.attrs;
    }
    static of(mark, dom) {
        let tile = new $7beee9608540d2c3$var$MarkTile(dom || document.createElement(mark.tagName), mark);
        if (!dom) tile.flags |= 4 /* TileFlag.AttrsDirty */ ;
        return tile;
    }
}
class $7beee9608540d2c3$var$TextTile extends $7beee9608540d2c3$var$Tile {
    constructor(dom, text){
        super(dom, text.length);
        this.text = text;
    }
    sync(track) {
        if (this.flags & 2 /* TileFlag.Synced */ ) return;
        super.sync(track);
        if (this.dom.nodeValue != this.text) {
            if (track && track.node == this.dom) track.written = true;
            this.dom.nodeValue = this.text;
        }
    }
    isText() {
        return true;
    }
    toString() {
        return JSON.stringify(this.text);
    }
    coordsIn(pos, side) {
        let length = this.dom.nodeValue.length;
        if (pos > length) pos = length;
        let from = pos, to = pos, flatten = 0;
        if (pos == 0 && side < 0 || pos == length && side >= 0) {
            if (!($7beee9608540d2c3$var$browser.chrome || $7beee9608540d2c3$var$browser.gecko)) {
                if (pos) {
                    from--;
                    flatten = 1;
                } else if (to < length) {
                    to++;
                    flatten = -1;
                }
            }
        } else {
            if (side < 0) from--;
            else if (to < length) to++;
        }
        let rects = $7beee9608540d2c3$var$textRange(this.dom, from, to).getClientRects();
        if (!rects.length) return null;
        let rect = rects[(flatten ? flatten < 0 : side >= 0) ? 0 : rects.length - 1];
        if ($7beee9608540d2c3$var$browser.safari && !flatten && rect.width == 0) rect = Array.prototype.find.call(rects, (r)=>r.width) || rect;
        return flatten ? $7beee9608540d2c3$var$flattenRect(rect, flatten < 0) : rect || null;
    }
    static of(text, dom) {
        let tile = new $7beee9608540d2c3$var$TextTile(dom || document.createTextNode(text), text);
        if (!dom) tile.flags |= 2 /* TileFlag.Synced */ ;
        return tile;
    }
}
class $7beee9608540d2c3$var$WidgetTile extends $7beee9608540d2c3$var$Tile {
    constructor(dom, length, widget, flags){
        super(dom, length, flags);
        this.widget = widget;
    }
    isWidget() {
        return true;
    }
    get isHidden() {
        return this.widget.isHidden;
    }
    covers(side) {
        if (this.flags & 48 /* TileFlag.PointWidget */ ) return false;
        return (this.flags & (side < 0 ? 64 /* TileFlag.IncStart */  : 128 /* TileFlag.IncEnd */ )) > 0;
    }
    coordsIn(pos, side) {
        return this.coordsInWidget(pos, side, false);
    }
    coordsInWidget(pos, side, block) {
        let custom = this.widget.coordsAt(this.dom, pos, side);
        if (custom) return custom;
        if (block) return $7beee9608540d2c3$var$flattenRect(this.dom.getBoundingClientRect(), this.length ? pos == 0 : side <= 0);
        else {
            let rects = this.dom.getClientRects(), rect = null;
            if (!rects.length) return null;
            let fromBack = this.flags & 16 /* TileFlag.Before */  ? true : this.flags & 32 /* TileFlag.After */  ? false : pos > 0;
            for(let i = fromBack ? rects.length - 1 : 0;; i += fromBack ? -1 : 1){
                rect = rects[i];
                if (pos > 0 ? i == 0 : i == rects.length - 1 || rect.top < rect.bottom) break;
            }
            return $7beee9608540d2c3$var$flattenRect(rect, !fromBack);
        }
    }
    get overrideDOMText() {
        if (!this.length) return (0, $6295c6875f57e3ee$export$5f1af8db9871e1d6).empty;
        let { root: root } = this;
        if (!root) return (0, $6295c6875f57e3ee$export$5f1af8db9871e1d6).empty;
        let start = this.posAtStart;
        return root.view.state.doc.slice(start, start + this.length);
    }
    destroy() {
        super.destroy();
        this.widget.destroy(this.dom);
    }
    static of(widget, view, length, flags, dom) {
        if (!dom) {
            dom = widget.toDOM(view);
            if (!widget.editable) dom.contentEditable = "false";
        }
        return new $7beee9608540d2c3$var$WidgetTile(dom, length, widget, flags);
    }
}
// These are drawn around uneditable widgets to avoid a number of
// browser bugs that show up when the cursor is directly next to
// uneditable inline content.
class $7beee9608540d2c3$var$WidgetBufferTile extends $7beee9608540d2c3$var$Tile {
    constructor(flags){
        let img = document.createElement("img");
        img.className = "cm-widgetBuffer";
        img.setAttribute("aria-hidden", "true");
        super(img, 0, flags);
    }
    get isHidden() {
        return true;
    }
    get overrideDOMText() {
        return (0, $6295c6875f57e3ee$export$5f1af8db9871e1d6).empty;
    }
    coordsIn(pos) {
        return this.dom.getBoundingClientRect();
    }
}
// Represents a position in the tile tree.
class $7beee9608540d2c3$var$TilePointer {
    constructor(top){
        this.index = 0;
        this.beforeBreak = false;
        this.parents = [];
        this.tile = top;
    }
    // Advance by the given distance. If side is -1, stop leaving or
    // entering tiles, or skipping zero-length tiles, once the distance
    // has been traversed. When side is 1, leave, enter, or skip
    // everything at the end position.
    advance(dist, side, walker) {
        let { tile: tile, index: index, beforeBreak: beforeBreak, parents: parents } = this;
        while(dist || side > 0){
            if (!tile.isComposite()) {
                if (index == tile.length) {
                    beforeBreak = !!tile.breakAfter;
                    ({ tile: tile, index: index } = parents.pop());
                    index++;
                } else if (!dist) break;
                else {
                    let take = Math.min(dist, tile.length - index);
                    if (walker) walker.skip(tile, index, index + take);
                    dist -= take;
                    index += take;
                }
            } else if (beforeBreak) {
                if (!dist) break;
                if (walker) walker.break();
                dist--;
                beforeBreak = false;
            } else if (index == tile.children.length) {
                if (!dist && !parents.length) break;
                if (walker) walker.leave(tile);
                beforeBreak = !!tile.breakAfter;
                ({ tile: tile, index: index } = parents.pop());
                index++;
            } else {
                let next = tile.children[index], brk = next.breakAfter;
                if ((side > 0 ? next.length <= dist : next.length < dist) && (!walker || walker.skip(next, 0, next.length) !== false || !next.isComposite)) {
                    beforeBreak = !!brk;
                    index++;
                    dist -= next.length;
                } else {
                    parents.push({
                        tile: tile,
                        index: index
                    });
                    tile = next;
                    index = 0;
                    if (walker && next.isComposite()) walker.enter(next);
                }
            }
        }
        this.tile = tile;
        this.index = index;
        this.beforeBreak = beforeBreak;
        return this;
    }
    get root() {
        return this.parents.length ? this.parents[0].tile : this.tile;
    }
}
// Used to track open block wrappers
class $7beee9608540d2c3$var$OpenWrapper {
    constructor(from, to, wrapper, rank){
        this.from = from;
        this.to = to;
        this.wrapper = wrapper;
        this.rank = rank;
    }
}
// This class builds up a new document tile using input from either
// iteration over the old tree or iteration over the document +
// decorations. The add* methods emit elements into the tile
// structure. To avoid awkward synchronization issues, marks and block
// wrappers are treated as belonging to to their content, rather than
// opened/closed independently.
//
// All composite tiles that are touched by changes are rebuilt,
// reusing as much of the old tree (either whole nodes or just DOM
// elements) as possible. The new tree is built without the Synced
// flag, and then synced (during which DOM parent/child relations are
// fixed up, text nodes filled in, and attributes added) in a second
// phase.
class $7beee9608540d2c3$var$TileBuilder {
    constructor(cache, root, blockWrappers){
        this.cache = cache;
        this.root = root;
        this.blockWrappers = blockWrappers;
        this.curLine = null;
        this.lastBlock = null;
        this.afterWidget = null;
        this.pos = 0;
        this.wrappers = [];
        this.wrapperPos = 0;
    }
    addText(text, marks, openStart, tile) {
        var _a;
        this.flushBuffer();
        let parent = this.ensureMarks(marks, openStart);
        let prev = parent.lastChild;
        if (prev && prev.isText() && !(prev.flags & 8 /* TileFlag.Composition */ ) && prev.length + text.length < 512 /* C.Chunk */ ) {
            this.cache.reused.set(prev, 2 /* Reused.DOM */ );
            let tile = parent.children[parent.children.length - 1] = new $7beee9608540d2c3$var$TextTile(prev.dom, prev.text + text);
            tile.parent = parent;
        } else parent.append(tile || $7beee9608540d2c3$var$TextTile.of(text, (_a = this.cache.find($7beee9608540d2c3$var$TextTile)) === null || _a === void 0 ? void 0 : _a.dom));
        this.pos += text.length;
        this.afterWidget = null;
    }
    addComposition(composition, context) {
        let line = this.curLine;
        if (line.dom != context.line.dom) {
            line.setDOM(this.cache.reused.has(context.line) ? $7beee9608540d2c3$var$freeNode(context.line.dom) : context.line.dom);
            this.cache.reused.set(context.line, 2 /* Reused.DOM */ );
        }
        let head = line;
        for(let i = context.marks.length - 1; i >= 0; i--){
            let mark = context.marks[i];
            let last = head.lastChild;
            if (last instanceof $7beee9608540d2c3$var$MarkTile && last.mark.eq(mark.mark)) {
                if (last.dom != mark.dom) last.setDOM($7beee9608540d2c3$var$freeNode(mark.dom));
                head = last;
            } else {
                if (this.cache.reused.get(mark)) {
                    let tile = $7beee9608540d2c3$var$Tile.get(mark.dom);
                    if (tile) tile.setDOM($7beee9608540d2c3$var$freeNode(mark.dom));
                }
                let nw = $7beee9608540d2c3$var$MarkTile.of(mark.mark, mark.dom);
                head.append(nw);
                head = nw;
            }
            this.cache.reused.set(mark, 2 /* Reused.DOM */ );
        }
        let oldTile = $7beee9608540d2c3$var$Tile.get(composition.text);
        if (oldTile) this.cache.reused.set(oldTile, 2 /* Reused.DOM */ );
        let text = new $7beee9608540d2c3$var$TextTile(composition.text, composition.text.nodeValue);
        text.flags |= 8 /* TileFlag.Composition */ ;
        this.pos = composition.range.toB;
        head.append(text);
    }
    addInlineWidget(widget, marks, openStart) {
        // Adjacent same-side-facing non-replacing widgets don't need buffers between them
        let noSpace = this.afterWidget && widget.flags & 48 /* TileFlag.PointWidget */  && (this.afterWidget.flags & 48 /* TileFlag.PointWidget */ ) == (widget.flags & 48 /* TileFlag.PointWidget */ );
        if (!noSpace) this.flushBuffer();
        let parent = this.ensureMarks(marks, openStart);
        if (!noSpace && !(widget.flags & 16 /* TileFlag.Before */ )) parent.append(this.getBuffer(1));
        parent.append(widget);
        this.pos += widget.length;
        this.afterWidget = widget;
    }
    addMark(tile, marks, openStart) {
        this.flushBuffer();
        let parent = this.ensureMarks(marks, openStart);
        parent.append(tile);
        this.pos += tile.length;
        this.afterWidget = null;
    }
    addBlockWidget(widget) {
        this.getBlockPos().append(widget);
        this.pos += widget.length;
        this.lastBlock = widget;
        this.endLine();
    }
    continueWidget(length) {
        let widget = this.afterWidget || this.lastBlock;
        widget.length += length;
        this.pos += length;
    }
    addLineStart(attrs, dom) {
        var _a;
        if (!attrs) attrs = $7beee9608540d2c3$var$lineBaseAttrs;
        let tile = $7beee9608540d2c3$var$LineTile.start(attrs, dom || ((_a = this.cache.find($7beee9608540d2c3$var$LineTile)) === null || _a === void 0 ? void 0 : _a.dom), !!dom);
        this.getBlockPos().append(this.lastBlock = this.curLine = tile);
    }
    addLine(tile) {
        this.getBlockPos().append(tile);
        this.pos += tile.length;
        this.lastBlock = tile;
        this.endLine();
    }
    addBreak() {
        this.lastBlock.flags |= 1 /* TileFlag.BreakAfter */ ;
        this.endLine();
        this.pos++;
    }
    addLineStartIfNotCovered(attrs) {
        if (!this.blockPosCovered()) this.addLineStart(attrs);
    }
    ensureLine(attrs) {
        if (!this.curLine) this.addLineStart(attrs);
    }
    ensureMarks(marks, openStart) {
        var _a;
        let parent = this.curLine;
        for(let i = marks.length - 1; i >= 0; i--){
            let mark = marks[i], last;
            if (openStart > 0 && (last = parent.lastChild) && last instanceof $7beee9608540d2c3$var$MarkTile && last.mark.eq(mark)) {
                parent = last;
                openStart--;
            } else {
                let tile = $7beee9608540d2c3$var$MarkTile.of(mark, (_a = this.cache.find($7beee9608540d2c3$var$MarkTile, (m)=>m.mark.eq(mark))) === null || _a === void 0 ? void 0 : _a.dom);
                parent.append(tile);
                parent = tile;
                openStart = 0;
            }
        }
        return parent;
    }
    endLine() {
        if (this.curLine) {
            this.flushBuffer();
            let last = this.curLine.lastChild;
            if (!last || !$7beee9608540d2c3$var$hasContent(this.curLine, false) || last.dom.nodeName != "BR" && last.isWidget() && !($7beee9608540d2c3$var$browser.ios && $7beee9608540d2c3$var$hasContent(this.curLine, true))) this.curLine.append(this.cache.findWidget($7beee9608540d2c3$var$BreakWidget, 0, 32 /* TileFlag.After */ ) || new $7beee9608540d2c3$var$WidgetTile($7beee9608540d2c3$var$BreakWidget.toDOM(), 0, $7beee9608540d2c3$var$BreakWidget, 32 /* TileFlag.After */ ));
            this.curLine = this.afterWidget = null;
        }
    }
    updateBlockWrappers() {
        if (this.wrapperPos > this.pos + 10000 /* C.WrapperReset */ ) {
            this.blockWrappers.goto(this.pos);
            this.wrappers.length = 0;
        }
        for(let i = this.wrappers.length - 1; i >= 0; i--)if (this.wrappers[i].to < this.pos) this.wrappers.splice(i, 1);
        for(let cur = this.blockWrappers; cur.value && cur.from <= this.pos; cur.next())if (cur.to >= this.pos) {
            let rank = cur.rank * 102 + cur.value.rank;
            let wrap = new $7beee9608540d2c3$var$OpenWrapper(cur.from, cur.to, cur.value, rank), i = this.wrappers.length;
            while(i > 0 && (this.wrappers[i - 1].rank - wrap.rank || this.wrappers[i - 1].to - wrap.to) < 0)i--;
            this.wrappers.splice(i, 0, wrap);
        }
        this.wrapperPos = this.pos;
    }
    getBlockPos() {
        var _a;
        this.updateBlockWrappers();
        let parent = this.root;
        for (let wrap of this.wrappers){
            let last = parent.lastChild;
            if (wrap.from < this.pos && last instanceof $7beee9608540d2c3$var$BlockWrapperTile && last.wrapper.eq(wrap.wrapper)) parent = last;
            else {
                let tile = $7beee9608540d2c3$var$BlockWrapperTile.of(wrap.wrapper, (_a = this.cache.find($7beee9608540d2c3$var$BlockWrapperTile, (t)=>t.wrapper.eq(wrap.wrapper))) === null || _a === void 0 ? void 0 : _a.dom);
                parent.append(tile);
                parent = tile;
            }
        }
        return parent;
    }
    blockPosCovered() {
        let last = this.lastBlock;
        return last != null && !last.breakAfter && (!last.isWidget() || (last.flags & 160 /* TileFlag.IncEnd */ ) > 0);
    }
    getBuffer(side) {
        let flags = 2 /* TileFlag.Synced */  | (side < 0 ? 16 /* TileFlag.Before */  : 32 /* TileFlag.After */ );
        let found = this.cache.find($7beee9608540d2c3$var$WidgetBufferTile, undefined, 1 /* Reused.Full */ );
        if (found) found.flags = flags;
        return found || new $7beee9608540d2c3$var$WidgetBufferTile(flags);
    }
    flushBuffer() {
        if (this.afterWidget && !(this.afterWidget.flags & 32 /* TileFlag.After */ )) {
            this.afterWidget.parent.append(this.getBuffer(-1));
            this.afterWidget = null;
        }
    }
}
// Helps getting efficient access to the document text.
class $7beee9608540d2c3$var$TextStream {
    constructor(doc){
        this.skipCount = 0;
        this.text = "";
        this.textOff = 0;
        this.cursor = doc.iter();
    }
    skip(len) {
        // Advance the iterator past the replaced content
        if (this.textOff + len <= this.text.length) this.textOff += len;
        else {
            this.skipCount += len - (this.text.length - this.textOff);
            this.text = "";
            this.textOff = 0;
        }
    }
    next(maxLen) {
        if (this.textOff == this.text.length) {
            let { value: value, lineBreak: lineBreak, done: done } = this.cursor.next(this.skipCount);
            this.skipCount = 0;
            if (done) throw new Error("Ran out of text content when drawing inline views");
            this.text = value;
            let len = this.textOff = Math.min(maxLen, value.length);
            return lineBreak ? null : value.slice(0, len);
        }
        let end = Math.min(this.text.length, this.textOff + maxLen);
        let chars = this.text.slice(this.textOff, end);
        this.textOff = end;
        return chars;
    }
}
// Assign the tile classes bucket numbers for caching.
const $7beee9608540d2c3$var$buckets = [
    $7beee9608540d2c3$var$WidgetTile,
    $7beee9608540d2c3$var$LineTile,
    $7beee9608540d2c3$var$TextTile,
    $7beee9608540d2c3$var$MarkTile,
    $7beee9608540d2c3$var$WidgetBufferTile,
    $7beee9608540d2c3$var$BlockWrapperTile,
    $7beee9608540d2c3$var$DocTile
];
for(let i = 0; i < $7beee9608540d2c3$var$buckets.length; i++)$7beee9608540d2c3$var$buckets[i].bucket = i;
// Leaf tiles and line tiles may be reused in their entirety. All
// others will get new tiles allocated, using the old DOM when
// possible.
class $7beee9608540d2c3$var$TileCache {
    constructor(view){
        this.view = view;
        // Buckets are circular buffers, using `index` as the current
        // position.
        this.buckets = $7beee9608540d2c3$var$buckets.map(()=>[]);
        this.index = $7beee9608540d2c3$var$buckets.map(()=>0);
        this.reused = new Map;
    }
    // Put a tile in the cache.
    add(tile) {
        let i = tile.constructor.bucket, bucket = this.buckets[i];
        if (bucket.length < 6 /* C.Bucket */ ) bucket.push(tile);
        else bucket[this.index[i] = (this.index[i] + 1) % 6 /* C.Bucket */ ] = tile;
    }
    find(cls, test, type = 2 /* Reused.DOM */ ) {
        let i = cls.bucket;
        let bucket = this.buckets[i], off = this.index[i];
        for(let j = bucket.length - 1; j >= 0; j--){
            // Look at the most recently added items first (last-in, first-out)
            let index = (j + off) % bucket.length, tile = bucket[index];
            if ((!test || test(tile)) && !this.reused.has(tile)) {
                bucket.splice(index, 1);
                if (index < off) this.index[i]--;
                this.reused.set(tile, type);
                return tile;
            }
        }
        return null;
    }
    findWidget(widget, length, flags) {
        let widgets = this.buckets[0];
        if (widgets.length) for(let i = 0, pass = 0;; i++){
            if (i == widgets.length) {
                if (pass) return null;
                pass = 1;
                i = 0;
            }
            let tile = widgets[i];
            if (!this.reused.has(tile) && (pass == 0 ? tile.widget.compare(widget) : tile.widget.constructor == widget.constructor && widget.updateDOM(tile.dom, this.view, tile.widget))) {
                widgets.splice(i, 1);
                if (i < this.index[0]) this.index[0]--;
                if (tile.widget == widget && tile.length == length && (tile.flags & 497 /* TileFlag.BreakAfter */ ) == flags) {
                    this.reused.set(tile, 1 /* Reused.Full */ );
                    return tile;
                } else {
                    this.reused.set(tile, 2 /* Reused.DOM */ );
                    return new $7beee9608540d2c3$var$WidgetTile(tile.dom, length, widget, tile.flags & -498 | flags);
                }
            }
        }
    }
    reuse(tile) {
        this.reused.set(tile, 1 /* Reused.Full */ );
        return tile;
    }
    maybeReuse(tile, type = 2 /* Reused.DOM */ ) {
        if (this.reused.has(tile)) return undefined;
        this.reused.set(tile, type);
        return tile.dom;
    }
    clear() {
        for(let i = 0; i < this.buckets.length; i++)this.buckets[i].length = this.index[i] = 0;
    }
}
// This class organizes a pass over the document, guided by the array
// of replaced ranges. For ranges that haven't changed, it iterates
// the old tree and copies its content into the new document. For
// changed ranges, it runs a decoration iterator to guide generation
// of content.
class $7beee9608540d2c3$var$TileUpdate {
    constructor(view, old, blockWrappers, decorations, disallowBlockEffectsFor){
        this.view = view;
        this.decorations = decorations;
        this.disallowBlockEffectsFor = disallowBlockEffectsFor;
        this.openWidget = false;
        this.openMarks = 0;
        this.cache = new $7beee9608540d2c3$var$TileCache(view);
        this.text = new $7beee9608540d2c3$var$TextStream(view.state.doc);
        this.builder = new $7beee9608540d2c3$var$TileBuilder(this.cache, new $7beee9608540d2c3$var$DocTile(view, view.contentDOM), (0, $6295c6875f57e3ee$export$34cb5241245008dd).iter(blockWrappers));
        this.cache.reused.set(old, 2 /* Reused.DOM */ );
        this.old = new $7beee9608540d2c3$var$TilePointer(old);
        this.reuseWalker = {
            skip: (tile, from, to)=>{
                this.cache.add(tile);
                if (tile.isComposite()) return false;
            },
            enter: (tile)=>this.cache.add(tile),
            leave: ()=>{},
            break: ()=>{}
        };
    }
    run(changes, composition) {
        let compositionContext = composition && this.getCompositionContext(composition.text);
        for(let posA = 0, posB = 0, i = 0;;){
            let next = i < changes.length ? changes[i++] : null;
            let skipA = next ? next.fromA : this.old.root.length;
            if (skipA > posA) {
                let len = skipA - posA;
                this.preserve(len, !i, !next);
                posA = skipA;
                posB += len;
            }
            if (!next) break;
            // Compositions need to be handled specially, forcing the
            // focused text node and its parent nodes to remain stable at
            // that point in the document.
            if (composition && next.fromA <= composition.range.fromA && next.toA >= composition.range.toA) {
                this.forward(next.fromA, composition.range.fromA, composition.range.fromA < composition.range.toA ? 1 : -1);
                this.emit(posB, composition.range.fromB);
                this.builder.flushBuffer();
                this.cache.clear(); // Must not reuse DOM across composition
                this.builder.addComposition(composition, compositionContext);
                this.text.skip(composition.range.toB - composition.range.fromB);
                this.forward(composition.range.fromA, next.toA);
                this.emit(composition.range.toB, next.toB);
            } else {
                this.forward(next.fromA, next.toA);
                this.emit(posB, next.toB);
            }
            posB = next.toB;
            posA = next.toA;
        }
        if (this.builder.curLine) this.builder.endLine();
        return this.builder.root;
    }
    preserve(length, incStart, incEnd) {
        let activeMarks = $7beee9608540d2c3$var$getMarks(this.old), openMarks = this.openMarks;
        this.old.advance(length, incEnd ? 1 : -1, {
            skip: (tile, from, to)=>{
                if (tile.isWidget()) {
                    if (this.openWidget) this.builder.continueWidget(to - from);
                    else {
                        let widget = to > 0 || from < tile.length ? $7beee9608540d2c3$var$WidgetTile.of(tile.widget, this.view, to - from, tile.flags & 496 /* TileFlag.Widget */ , this.cache.maybeReuse(tile)) : this.cache.reuse(tile);
                        if (widget.flags & 256 /* TileFlag.Block */ ) {
                            widget.flags &= -2 /* TileFlag.BreakAfter */ ;
                            this.builder.addBlockWidget(widget);
                        } else {
                            this.builder.ensureLine(null);
                            this.builder.addInlineWidget(widget, activeMarks, openMarks);
                            openMarks = activeMarks.length;
                        }
                    }
                } else if (tile.isText()) {
                    this.builder.ensureLine(null);
                    if (!from && to == tile.length && !this.cache.reused.has(tile)) this.builder.addText(tile.text, activeMarks, openMarks, this.cache.reuse(tile));
                    else {
                        this.cache.add(tile);
                        this.builder.addText(tile.text.slice(from, to), activeMarks, openMarks);
                    }
                    openMarks = activeMarks.length;
                } else if (tile.isLine()) {
                    tile.flags &= -2 /* TileFlag.BreakAfter */ ;
                    this.cache.reused.set(tile, 1 /* Reused.Full */ );
                    this.builder.addLine(tile);
                } else if (tile instanceof $7beee9608540d2c3$var$WidgetBufferTile) this.cache.add(tile);
                else if (tile instanceof $7beee9608540d2c3$var$MarkTile) {
                    this.builder.ensureLine(null);
                    this.builder.addMark(tile, activeMarks, openMarks);
                    this.cache.reused.set(tile, 1 /* Reused.Full */ );
                    openMarks = activeMarks.length;
                } else return false;
                this.openWidget = false;
            },
            enter: (tile)=>{
                if (tile.isLine()) this.builder.addLineStart(tile.attrs, this.cache.maybeReuse(tile));
                else {
                    this.cache.add(tile);
                    if (tile instanceof $7beee9608540d2c3$var$MarkTile) activeMarks.unshift(tile.mark);
                }
                this.openWidget = false;
            },
            leave: (tile)=>{
                if (tile.isLine()) {
                    if (activeMarks.length) activeMarks.length = openMarks = 0;
                } else if (tile instanceof $7beee9608540d2c3$var$MarkTile) {
                    activeMarks.shift();
                    openMarks = Math.min(openMarks, activeMarks.length);
                }
            },
            break: ()=>{
                this.builder.addBreak();
                this.openWidget = false;
            }
        });
        this.text.skip(length);
    }
    emit(from, to) {
        let pendingLineAttrs = null;
        let b = this.builder, markCount = 0;
        let openEnd = (0, $6295c6875f57e3ee$export$34cb5241245008dd).spans(this.decorations, from, to, {
            point: (from, to, deco, active, openStart, index)=>{
                if (deco instanceof $7beee9608540d2c3$var$PointDecoration) {
                    if (this.disallowBlockEffectsFor[index]) {
                        if (deco.block) throw new RangeError("Block decorations may not be specified via plugins");
                        if (to > this.view.state.doc.lineAt(from).to) throw new RangeError("Decorations that replace line breaks may not be specified via plugins");
                    }
                    markCount = active.length;
                    if (openStart > active.length) b.continueWidget(to - from);
                    else {
                        let widget = deco.widget || (deco.block ? $7beee9608540d2c3$var$NullWidget.block : $7beee9608540d2c3$var$NullWidget.inline);
                        let flags = $7beee9608540d2c3$var$widgetFlags(deco);
                        let tile = this.cache.findWidget(widget, to - from, flags) || $7beee9608540d2c3$var$WidgetTile.of(widget, this.view, to - from, flags);
                        if (deco.block) {
                            if (deco.startSide > 0) b.addLineStartIfNotCovered(pendingLineAttrs);
                            b.addBlockWidget(tile);
                        } else {
                            b.ensureLine(pendingLineAttrs);
                            b.addInlineWidget(tile, active, openStart);
                        }
                    }
                    pendingLineAttrs = null;
                } else pendingLineAttrs = $7beee9608540d2c3$var$addLineDeco(pendingLineAttrs, deco);
                if (to > from) this.text.skip(to - from);
            },
            span: (from, to, active, openStart)=>{
                for(let pos = from; pos < to;){
                    let chars = this.text.next(Math.min(512 /* C.Chunk */ , to - pos));
                    if (chars == null) {
                        b.addLineStartIfNotCovered(pendingLineAttrs);
                        b.addBreak();
                        pos++;
                    } else {
                        b.ensureLine(pendingLineAttrs);
                        b.addText(chars, active, pos == from ? openStart : active.length);
                        pos += chars.length;
                    }
                    pendingLineAttrs = null;
                }
            }
        });
        b.addLineStartIfNotCovered(pendingLineAttrs);
        this.openWidget = openEnd > markCount;
        this.openMarks = openEnd;
    }
    forward(from, to, side = 1) {
        if (to - from <= 10) this.old.advance(to - from, side, this.reuseWalker);
        else {
            this.old.advance(5, -1, this.reuseWalker);
            this.old.advance(to - from - 10, -1);
            this.old.advance(5, side, this.reuseWalker);
        }
    }
    getCompositionContext(text) {
        let marks = [], line = null;
        for(let parent = text.parentNode;; parent = parent.parentNode){
            let tile = $7beee9608540d2c3$var$Tile.get(parent);
            if (parent == this.view.contentDOM) break;
            if (tile instanceof $7beee9608540d2c3$var$MarkTile) marks.push(tile);
            else if (tile === null || tile === void 0 ? void 0 : tile.isLine()) line = tile;
            else if (tile instanceof $7beee9608540d2c3$var$BlockWrapperTile) ; // Ignore
            else if (parent.nodeName == "DIV" && !line && parent != this.view.contentDOM) line = new $7beee9608540d2c3$var$LineTile(parent, $7beee9608540d2c3$var$lineBaseAttrs);
            else if (!line) marks.push($7beee9608540d2c3$var$MarkTile.of(new $7beee9608540d2c3$var$MarkDecoration({
                tagName: parent.nodeName.toLowerCase(),
                attributes: $7beee9608540d2c3$var$getAttrs(parent)
            }), parent));
        }
        return {
            line: line,
            marks: marks
        };
    }
}
function $7beee9608540d2c3$var$hasContent(tile, requireText) {
    let scan = (tile)=>{
        for (let ch of tile.children)if ((requireText ? ch.isText() : ch.length) || scan(ch)) return true;
        return false;
    };
    return scan(tile);
}
function $7beee9608540d2c3$var$widgetFlags(deco) {
    let flags = deco.isReplace ? (deco.startSide < 0 ? 64 /* TileFlag.IncStart */  : 0) | (deco.endSide > 0 ? 128 /* TileFlag.IncEnd */  : 0) : deco.startSide > 0 ? 32 /* TileFlag.After */  : 16 /* TileFlag.Before */ ;
    if (deco.block) flags |= 256 /* TileFlag.Block */ ;
    return flags;
}
const $7beee9608540d2c3$var$lineBaseAttrs = {
    class: "cm-line"
};
function $7beee9608540d2c3$var$addLineDeco(value, deco) {
    let attrs = deco.spec.attributes, cls = deco.spec.class;
    if (!attrs && !cls) return value;
    if (!value) value = {
        class: "cm-line"
    };
    if (attrs) $7beee9608540d2c3$var$combineAttrs(attrs, value);
    if (cls) value.class += " " + cls;
    return value;
}
function $7beee9608540d2c3$var$getMarks(ptr) {
    let found = [];
    for(let i = ptr.parents.length; i > 1; i--){
        let tile = i == ptr.parents.length ? ptr.tile : ptr.parents[i].tile;
        if (tile instanceof $7beee9608540d2c3$var$MarkTile) found.push(tile.mark);
    }
    return found;
}
function $7beee9608540d2c3$var$freeNode(node) {
    let tile = $7beee9608540d2c3$var$Tile.get(node);
    if (tile) tile.setDOM(node.cloneNode());
    return node;
}
class $7beee9608540d2c3$var$NullWidget extends $7beee9608540d2c3$export$95cdd842edb044c5 {
    constructor(tag){
        super();
        this.tag = tag;
    }
    eq(other) {
        return other.tag == this.tag;
    }
    toDOM() {
        return document.createElement(this.tag);
    }
    updateDOM(elt) {
        return elt.nodeName.toLowerCase() == this.tag;
    }
    get isHidden() {
        return true;
    }
}
$7beee9608540d2c3$var$NullWidget.inline = /*@__PURE__*/ new $7beee9608540d2c3$var$NullWidget("span");
$7beee9608540d2c3$var$NullWidget.block = /*@__PURE__*/ new $7beee9608540d2c3$var$NullWidget("div");
const $7beee9608540d2c3$var$BreakWidget = /*@__PURE__*/ new class extends $7beee9608540d2c3$export$95cdd842edb044c5 {
    toDOM() {
        return document.createElement("br");
    }
    get isHidden() {
        return true;
    }
    get editable() {
        return true;
    }
};
class $7beee9608540d2c3$var$DocView {
    constructor(view){
        this.view = view;
        this.decorations = [];
        this.blockWrappers = [];
        this.dynamicDecorationMap = [
            false
        ];
        this.domChanged = null;
        this.hasComposition = null;
        this.editContextFormatting = $7beee9608540d2c3$export$10e30b733df217ea.none;
        this.lastCompositionAfterCursor = false;
        // Track a minimum width for the editor. When measuring sizes in
        // measureVisibleLineHeights, this is updated to point at the width
        // of a given element and its extent in the document. When a change
        // happens in that range, these are reset. That way, once we've seen
        // a line/element of a given length, we keep the editor wide enough
        // to fit at least that element, until it is changed, at which point
        // we forget it again.
        this.minWidth = 0;
        this.minWidthFrom = 0;
        this.minWidthTo = 0;
        // Track whether the DOM selection was set in a lossy way, so that
        // we don't mess it up when reading it back it
        this.impreciseAnchor = null;
        this.impreciseHead = null;
        this.forceSelection = false;
        // Used by the resize observer to ignore resizes that we caused
        // ourselves
        this.lastUpdate = Date.now();
        this.updateDeco();
        this.tile = new $7beee9608540d2c3$var$DocTile(view, view.contentDOM);
        this.updateInner([
            new $7beee9608540d2c3$var$ChangedRange(0, 0, 0, view.state.doc.length)
        ], null);
    }
    // Update the document view to a given state.
    update(update) {
        var _a;
        let changedRanges = update.changedRanges;
        if (this.minWidth > 0 && changedRanges.length) {
            if (!changedRanges.every(({ fromA: fromA, toA: toA })=>toA < this.minWidthFrom || fromA > this.minWidthTo)) this.minWidth = this.minWidthFrom = this.minWidthTo = 0;
            else {
                this.minWidthFrom = update.changes.mapPos(this.minWidthFrom, 1);
                this.minWidthTo = update.changes.mapPos(this.minWidthTo, 1);
            }
        }
        this.updateEditContextFormatting(update);
        let readCompositionAt = -1;
        if (this.view.inputState.composing >= 0 && !this.view.observer.editContext) {
            if ((_a = this.domChanged) === null || _a === void 0 ? void 0 : _a.newSel) readCompositionAt = this.domChanged.newSel.head;
            else if (!$7beee9608540d2c3$var$touchesComposition(update.changes, this.hasComposition) && !update.selectionSet) readCompositionAt = update.state.selection.main.head;
        }
        let composition = readCompositionAt > -1 ? $7beee9608540d2c3$var$findCompositionRange(this.view, update.changes, readCompositionAt) : null;
        this.domChanged = null;
        if (this.hasComposition) {
            let { from: from, to: to } = this.hasComposition;
            changedRanges = new $7beee9608540d2c3$var$ChangedRange(from, to, update.changes.mapPos(from, -1), update.changes.mapPos(to, 1)).addToSet(changedRanges.slice());
        }
        this.hasComposition = composition ? {
            from: composition.range.fromB,
            to: composition.range.toB
        } : null;
        // When the DOM nodes around the selection are moved to another
        // parent, Chrome sometimes reports a different selection through
        // getSelection than the one that it actually shows to the user.
        // This forces a selection update when lines are joined to work
        // around that. Issue #54
        if (($7beee9608540d2c3$var$browser.ie || $7beee9608540d2c3$var$browser.chrome) && !composition && update && update.state.doc.lines != update.startState.doc.lines) this.forceSelection = true;
        let prevDeco = this.decorations, prevWrappers = this.blockWrappers;
        this.updateDeco();
        let decoDiff = $7beee9608540d2c3$var$findChangedDeco(prevDeco, this.decorations, update.changes);
        if (decoDiff.length) changedRanges = $7beee9608540d2c3$var$ChangedRange.extendWithRanges(changedRanges, decoDiff);
        let blockDiff = $7beee9608540d2c3$var$findChangedWrappers(prevWrappers, this.blockWrappers, update.changes);
        if (blockDiff.length) changedRanges = $7beee9608540d2c3$var$ChangedRange.extendWithRanges(changedRanges, blockDiff);
        if (composition && !changedRanges.some((r)=>r.fromA <= composition.range.fromA && r.toA >= composition.range.toA)) changedRanges = composition.range.addToSet(changedRanges.slice());
        if (this.tile.flags & 2 /* TileFlag.Synced */  && changedRanges.length == 0) return false;
        else {
            this.updateInner(changedRanges, composition);
            if (update.transactions.length) this.lastUpdate = Date.now();
            return true;
        }
    }
    // Used by update and the constructor do perform the actual DOM
    // update
    updateInner(changes, composition) {
        this.view.viewState.mustMeasureContent = true;
        let { observer: observer } = this.view;
        observer.ignore(()=>{
            if (composition || changes.length) {
                let oldTile = this.tile;
                let builder = new $7beee9608540d2c3$var$TileUpdate(this.view, oldTile, this.blockWrappers, this.decorations, this.dynamicDecorationMap);
                if (composition && $7beee9608540d2c3$var$Tile.get(composition.text)) builder.cache.reused.set($7beee9608540d2c3$var$Tile.get(composition.text), 2 /* Reused.DOM */ );
                this.tile = builder.run(changes, composition);
                $7beee9608540d2c3$var$destroyDropped(oldTile, builder.cache.reused);
            }
            // Lock the height during redrawing, since Chrome sometimes
            // messes with the scroll position during DOM mutation (though
            // no relayout is triggered and I cannot imagine how it can
            // recompute the scroll position without a layout)
            this.tile.dom.style.height = this.view.viewState.contentHeight / this.view.scaleY + "px";
            this.tile.dom.style.flexBasis = this.minWidth ? this.minWidth + "px" : "";
            // Chrome will sometimes, when DOM mutations occur directly
            // around the selection, get confused and report a different
            // selection from the one it displays (issue #218). This tries
            // to detect that situation.
            let track = $7beee9608540d2c3$var$browser.chrome || $7beee9608540d2c3$var$browser.ios ? {
                node: observer.selectionRange.focusNode,
                written: false
            } : undefined;
            this.tile.sync(track);
            if (track && (track.written || observer.selectionRange.focusNode != track.node || !this.tile.dom.contains(track.node))) this.forceSelection = true;
            this.tile.dom.style.height = "";
        });
        let gaps = [];
        if (this.view.viewport.from || this.view.viewport.to < this.view.state.doc.length) {
            for (let child of this.tile.children)if (child.isWidget() && child.widget instanceof $7beee9608540d2c3$var$BlockGapWidget) gaps.push(child.dom);
        }
        observer.updateGaps(gaps);
    }
    updateEditContextFormatting(update) {
        this.editContextFormatting = this.editContextFormatting.map(update.changes);
        for (let tr of update.transactions)for (let effect of tr.effects)if (effect.is($7beee9608540d2c3$var$setEditContextFormatting)) this.editContextFormatting = effect.value;
    }
    // Sync the DOM selection to this.state.selection
    updateSelection(mustRead = false, fromPointer = false) {
        if (mustRead || !this.view.observer.selectionRange.focusNode) this.view.observer.readSelectionRange();
        let { dom: dom } = this.tile;
        let activeElt = this.view.root.activeElement, focused = activeElt == dom;
        let selectionNotFocus = !focused && !(this.view.state.facet($7beee9608540d2c3$var$editable) || dom.tabIndex > -1) && $7beee9608540d2c3$var$hasSelection(dom, this.view.observer.selectionRange) && !(activeElt && dom.contains(activeElt));
        if (!(focused || fromPointer || selectionNotFocus)) return;
        let force = this.forceSelection;
        this.forceSelection = false;
        let main = this.view.state.selection.main, anchor, head;
        if (main.empty) head = anchor = this.inlineDOMNearPos(main.anchor, main.assoc || 1);
        else {
            head = this.inlineDOMNearPos(main.head, main.head == main.from ? 1 : -1);
            anchor = this.inlineDOMNearPos(main.anchor, main.anchor == main.from ? 1 : -1);
        }
        // Always reset on Firefox when next to an uneditable node to
        // avoid invisible cursor bugs (#111)
        if ($7beee9608540d2c3$var$browser.gecko && main.empty && !this.hasComposition && $7beee9608540d2c3$var$betweenUneditable(anchor)) {
            let dummy = document.createTextNode("");
            this.view.observer.ignore(()=>anchor.node.insertBefore(dummy, anchor.node.childNodes[anchor.offset] || null));
            anchor = head = new $7beee9608540d2c3$var$DOMPos(dummy, 0);
            force = true;
        }
        let domSel = this.view.observer.selectionRange;
        // If the selection is already here, or in an equivalent position, don't touch it
        if (force || !domSel.focusNode || (!$7beee9608540d2c3$var$isEquivalentPosition(anchor.node, anchor.offset, domSel.anchorNode, domSel.anchorOffset) || !$7beee9608540d2c3$var$isEquivalentPosition(head.node, head.offset, domSel.focusNode, domSel.focusOffset)) && !this.suppressWidgetCursorChange(domSel, main)) {
            this.view.observer.ignore(()=>{
                // Chrome Android will hide the virtual keyboard when tapping
                // inside an uneditable node, and not bring it back when we
                // move the cursor to its proper position. This tries to
                // restore the keyboard by cycling focus.
                if ($7beee9608540d2c3$var$browser.android && $7beee9608540d2c3$var$browser.chrome && dom.contains(domSel.focusNode) && $7beee9608540d2c3$var$inUneditable(domSel.focusNode, dom)) {
                    dom.blur();
                    dom.focus({
                        preventScroll: true
                    });
                }
                let rawSel = $7beee9608540d2c3$var$getSelection(this.view.root);
                if (!rawSel) ;
                else if (main.empty) {
                    // Work around https://bugzilla.mozilla.org/show_bug.cgi?id=1612076
                    if ($7beee9608540d2c3$var$browser.gecko) {
                        let nextTo = $7beee9608540d2c3$var$nextToUneditable(anchor.node, anchor.offset);
                        if (nextTo && nextTo != 3 /* NextTo.After */ ) {
                            let text = (nextTo == 1 /* NextTo.Before */  ? $7beee9608540d2c3$var$textNodeBefore : $7beee9608540d2c3$var$textNodeAfter)(anchor.node, anchor.offset);
                            if (text) anchor = new $7beee9608540d2c3$var$DOMPos(text.node, text.offset);
                        }
                    }
                    rawSel.collapse(anchor.node, anchor.offset);
                    if (main.bidiLevel != null && rawSel.caretBidiLevel !== undefined) rawSel.caretBidiLevel = main.bidiLevel;
                } else if (rawSel.extend) {
                    // Selection.extend can be used to create an 'inverted' selection
                    // (one where the focus is before the anchor), but not all
                    // browsers support it yet.
                    rawSel.collapse(anchor.node, anchor.offset);
                    // Safari will ignore the call above when the editor is
                    // hidden, and then raise an error on the call to extend
                    // (#940).
                    try {
                        rawSel.extend(head.node, head.offset);
                    } catch (_) {}
                } else {
                    // Primitive (IE) way
                    let range = document.createRange();
                    if (main.anchor > main.head) [anchor, head] = [
                        head,
                        anchor
                    ];
                    range.setEnd(head.node, head.offset);
                    range.setStart(anchor.node, anchor.offset);
                    rawSel.removeAllRanges();
                    rawSel.addRange(range);
                }
                if (selectionNotFocus && this.view.root.activeElement == dom) {
                    dom.blur();
                    if (activeElt) activeElt.focus();
                }
            });
            this.view.observer.setSelectionRange(anchor, head);
        }
        this.impreciseAnchor = anchor.precise ? null : new $7beee9608540d2c3$var$DOMPos(domSel.anchorNode, domSel.anchorOffset);
        this.impreciseHead = head.precise ? null : new $7beee9608540d2c3$var$DOMPos(domSel.focusNode, domSel.focusOffset);
    }
    // If a zero-length widget is inserted next to the cursor during
    // composition, avoid moving it across it and disrupting the
    // composition.
    suppressWidgetCursorChange(sel, cursor) {
        return this.hasComposition && cursor.empty && $7beee9608540d2c3$var$isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset) && this.posFromDOM(sel.focusNode, sel.focusOffset) == cursor.head;
    }
    enforceCursorAssoc() {
        if (this.hasComposition) return;
        let { view: view } = this, cursor = view.state.selection.main;
        let sel = $7beee9608540d2c3$var$getSelection(view.root);
        let { anchorNode: anchorNode, anchorOffset: anchorOffset } = view.observer.selectionRange;
        if (!sel || !cursor.empty || !cursor.assoc || !sel.modify) return;
        let line = this.lineAt(cursor.head, cursor.assoc);
        if (!line) return;
        let lineStart = line.posAtStart;
        if (cursor.head == lineStart || cursor.head == lineStart + line.length) return;
        let before = this.coordsAt(cursor.head, -1), after = this.coordsAt(cursor.head, 1);
        if (!before || !after || before.bottom > after.top) return;
        let dom = this.domAtPos(cursor.head + cursor.assoc, cursor.assoc);
        sel.collapse(dom.node, dom.offset);
        sel.modify("move", cursor.assoc < 0 ? "forward" : "backward", "lineboundary");
        // This can go wrong in corner cases like single-character lines,
        // so check and reset if necessary.
        view.observer.readSelectionRange();
        let newRange = view.observer.selectionRange;
        if (view.docView.posFromDOM(newRange.anchorNode, newRange.anchorOffset) != cursor.from) sel.collapse(anchorNode, anchorOffset);
    }
    posFromDOM(node, offset) {
        let tile = this.tile.nearest(node);
        if (!tile) return this.tile.dom.compareDocumentPosition(node) & 2 /* PRECEDING */  ? 0 : this.view.state.doc.length;
        let start = tile.posAtStart;
        if (tile.isComposite()) {
            let after;
            if (node == tile.dom) after = tile.dom.childNodes[offset];
            else {
                let bias = $7beee9608540d2c3$var$maxOffset(node) == 0 ? 0 : offset == 0 ? -1 : 1;
                for(;;){
                    let parent = node.parentNode;
                    if (parent == tile.dom) break;
                    if (bias == 0 && parent.firstChild != parent.lastChild) {
                        if (node == parent.firstChild) bias = -1;
                        else bias = 1;
                    }
                    node = parent;
                }
                if (bias < 0) after = node;
                else after = node.nextSibling;
            }
            if (after == tile.dom.firstChild) return start;
            while(after && !$7beee9608540d2c3$var$Tile.get(after))after = after.nextSibling;
            if (!after) return start + tile.length;
            for(let i = 0, pos = start;; i++){
                let child = tile.children[i];
                if (child.dom == after) return pos;
                pos += child.length + child.breakAfter;
            }
        } else if (tile.isText()) return node == tile.dom ? start + offset : start + (offset ? tile.length : 0);
        else return start;
    }
    domAtPos(pos, side) {
        let { tile: tile, offset: offset } = this.tile.resolveBlock(pos, side);
        if (tile.isWidget()) return tile.domPosFor(pos, side);
        return tile.domIn(offset, side);
    }
    inlineDOMNearPos(pos, side) {
        let before, beforeOff = -1, beforeBad = false;
        let after, afterOff = -1, afterBad = false;
        this.tile.blockTiles((tile, off)=>{
            if (tile.isWidget()) {
                if (tile.flags & 32 /* TileFlag.After */  && off >= pos) return true;
                if (tile.flags & 16 /* TileFlag.Before */ ) beforeBad = true;
            } else {
                let end = off + tile.length;
                if (off <= pos) {
                    before = tile;
                    beforeOff = pos - off;
                    beforeBad = end < pos;
                }
                if (end >= pos && !after) {
                    after = tile;
                    afterOff = pos - off;
                    afterBad = off > pos;
                }
                if (off > pos && after) return true;
            }
        });
        if (!before && !after) return this.domAtPos(pos, side);
        if (beforeBad && after) before = null;
        else if (afterBad && before) after = null;
        return before && side < 0 || !after ? before.domIn(beforeOff, side) : after.domIn(afterOff, side);
    }
    coordsAt(pos, side) {
        let { tile: tile, offset: offset } = this.tile.resolveBlock(pos, side);
        if (tile.isWidget()) {
            if (tile.widget instanceof $7beee9608540d2c3$var$BlockGapWidget) return null;
            return tile.coordsInWidget(offset, side, true);
        }
        return tile.coordsIn(offset, side);
    }
    lineAt(pos, side) {
        let { tile: tile } = this.tile.resolveBlock(pos, side);
        return tile.isLine() ? tile : null;
    }
    coordsForChar(pos) {
        let { tile: tile, offset: offset } = this.tile.resolveBlock(pos, 1);
        if (!tile.isLine()) return null;
        function scan(tile, offset) {
            if (tile.isComposite()) for (let ch of tile.children){
                if (ch.length >= offset) {
                    let found = scan(ch, offset);
                    if (found) return found;
                }
                offset -= ch.length;
                if (offset < 0) break;
            }
            else if (tile.isText() && offset < tile.length) {
                let end = (0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(tile.text, offset);
                if (end == offset) return null;
                let rects = $7beee9608540d2c3$var$textRange(tile.dom, offset, end).getClientRects();
                for(let i = 0; i < rects.length; i++){
                    let rect = rects[i];
                    if (i == rects.length - 1 || rect.top < rect.bottom && rect.left < rect.right) return rect;
                }
            }
            return null;
        }
        return scan(tile, offset);
    }
    measureVisibleLineHeights(viewport) {
        let result = [], { from: from, to: to } = viewport;
        let contentWidth = this.view.contentDOM.clientWidth;
        let isWider = contentWidth > Math.max(this.view.scrollDOM.clientWidth, this.minWidth) + 1;
        let widest = -1, ltr = this.view.textDirection == $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR;
        let spaceAbove = 0;
        let scan = (tile, pos, measureBounds)=>{
            for(let i = 0; i < tile.children.length; i++){
                if (pos > to) break;
                let child = tile.children[i], end = pos + child.length;
                let childRect = child.dom.getBoundingClientRect(), { height: height } = childRect;
                if (measureBounds && !i) spaceAbove += childRect.top - measureBounds.top;
                if (child instanceof $7beee9608540d2c3$var$BlockWrapperTile) {
                    if (end > from) scan(child, pos, childRect);
                } else if (pos >= from) {
                    if (spaceAbove > 0) result.push(-spaceAbove);
                    result.push(height + spaceAbove);
                    spaceAbove = 0;
                    if (isWider) {
                        let last = child.dom.lastChild;
                        let rects = last ? $7beee9608540d2c3$var$clientRectsFor(last) : [];
                        if (rects.length) {
                            let rect = rects[rects.length - 1];
                            let width = ltr ? rect.right - childRect.left : childRect.right - rect.left;
                            if (width > widest) {
                                widest = width;
                                this.minWidth = contentWidth;
                                this.minWidthFrom = pos;
                                this.minWidthTo = end;
                            }
                        }
                    }
                }
                if (measureBounds && i == tile.children.length - 1) spaceAbove += measureBounds.bottom - childRect.bottom;
                pos = end + child.breakAfter;
            }
        };
        scan(this.tile, 0, null);
        return result;
    }
    textDirectionAt(pos) {
        let { tile: tile } = this.tile.resolveBlock(pos, 1);
        return getComputedStyle(tile.dom).direction == "rtl" ? $7beee9608540d2c3$export$cacd6541cfeeb6c1.RTL : $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR;
    }
    measureTextSize() {
        let lineMeasure = this.tile.blockTiles((tile)=>{
            if (tile.isLine() && tile.children.length && tile.length <= 20) {
                let totalWidth = 0, textHeight;
                for (let child of tile.children){
                    if (!child.isText() || /[^ -~]/.test(child.text)) return undefined;
                    let rects = $7beee9608540d2c3$var$clientRectsFor(child.dom);
                    if (rects.length != 1) return undefined;
                    totalWidth += rects[0].width;
                    textHeight = rects[0].height;
                }
                if (totalWidth) return {
                    lineHeight: tile.dom.getBoundingClientRect().height,
                    charWidth: totalWidth / tile.length,
                    textHeight: textHeight
                };
            }
        });
        if (lineMeasure) return lineMeasure;
        // If no workable line exists, force a layout of a measurable element
        let dummy = document.createElement("div"), lineHeight, charWidth, textHeight;
        dummy.className = "cm-line";
        dummy.style.width = "99999px";
        dummy.style.position = "absolute";
        dummy.textContent = "abc def ghi jkl mno pqr stu";
        this.view.observer.ignore(()=>{
            this.tile.dom.appendChild(dummy);
            let rect = $7beee9608540d2c3$var$clientRectsFor(dummy.firstChild)[0];
            lineHeight = dummy.getBoundingClientRect().height;
            charWidth = rect && rect.width ? rect.width / 27 : 7;
            textHeight = rect && rect.height ? rect.height : lineHeight;
            dummy.remove();
        });
        return {
            lineHeight: lineHeight,
            charWidth: charWidth,
            textHeight: textHeight
        };
    }
    computeBlockGapDeco() {
        let deco = [], vs = this.view.viewState;
        for(let pos = 0, i = 0;; i++){
            let next = i == vs.viewports.length ? null : vs.viewports[i];
            let end = next ? next.from - 1 : this.view.state.doc.length;
            if (end > pos) {
                let height = (vs.lineBlockAt(end).bottom - vs.lineBlockAt(pos).top) / this.view.scaleY;
                deco.push($7beee9608540d2c3$export$10e30b733df217ea.replace({
                    widget: new $7beee9608540d2c3$var$BlockGapWidget(height),
                    block: true,
                    inclusive: true,
                    isBlockGap: true
                }).range(pos, end));
            }
            if (!next) break;
            pos = next.to + 1;
        }
        return $7beee9608540d2c3$export$10e30b733df217ea.set(deco);
    }
    updateDeco() {
        let i = 1;
        let allDeco = this.view.state.facet($7beee9608540d2c3$var$decorations).map((d)=>{
            let dynamic = this.dynamicDecorationMap[i++] = typeof d == "function";
            return dynamic ? d(this.view) : d;
        });
        let dynamicOuter = false, outerDeco = this.view.state.facet($7beee9608540d2c3$var$outerDecorations).map((d, i)=>{
            let dynamic = typeof d == "function";
            if (dynamic) dynamicOuter = true;
            return dynamic ? d(this.view) : d;
        });
        if (outerDeco.length) {
            this.dynamicDecorationMap[i++] = dynamicOuter;
            allDeco.push((0, $6295c6875f57e3ee$export$34cb5241245008dd).join(outerDeco));
        }
        this.decorations = [
            this.editContextFormatting,
            ...allDeco,
            this.computeBlockGapDeco(),
            this.view.viewState.lineGapDeco
        ];
        while(i < this.decorations.length)this.dynamicDecorationMap[i++] = false;
        this.blockWrappers = this.view.state.facet($7beee9608540d2c3$var$blockWrappers).map((v)=>typeof v == "function" ? v(this.view) : v);
    }
    scrollIntoView(target) {
        var _a;
        if (target.isSnapshot) {
            let ref = this.view.viewState.lineBlockAt(target.range.head);
            this.view.scrollDOM.scrollTop = ref.top - target.yMargin;
            this.view.scrollDOM.scrollLeft = target.xMargin;
            return;
        }
        for (let handler of this.view.state.facet($7beee9608540d2c3$var$scrollHandler))try {
            if (handler(this.view, target.range, target)) return true;
        } catch (e) {
            $7beee9608540d2c3$export$f86b2a1a2ce291b3(this.view.state, e, "scroll handler");
        }
        let { range: range } = target;
        let rect = this.coordsAt(range.head, (_a = range.assoc) !== null && _a !== void 0 ? _a : range.empty ? 0 : range.head > range.anchor ? -1 : 1), other;
        if (!rect) return;
        if (!range.empty && (other = this.coordsAt(range.anchor, range.anchor > range.head ? -1 : 1))) rect = {
            left: Math.min(rect.left, other.left),
            top: Math.min(rect.top, other.top),
            right: Math.max(rect.right, other.right),
            bottom: Math.max(rect.bottom, other.bottom)
        };
        let margins = $7beee9608540d2c3$var$getScrollMargins(this.view);
        let targetRect = {
            left: rect.left - margins.left,
            top: rect.top - margins.top,
            right: rect.right + margins.right,
            bottom: rect.bottom + margins.bottom
        };
        let { offsetWidth: offsetWidth, offsetHeight: offsetHeight } = this.view.scrollDOM;
        $7beee9608540d2c3$var$scrollRectIntoView(this.view.scrollDOM, targetRect, range.head < range.anchor ? -1 : 1, target.x, target.y, Math.max(Math.min(target.xMargin, offsetWidth), -offsetWidth), Math.max(Math.min(target.yMargin, offsetHeight), -offsetHeight), this.view.textDirection == $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR);
        // On mobile browsers, the visual viewport may be smaller than the
        // actual reported viewport, causing scrollRectIntoView to fail to
        // scroll properly. Unfortunately, this visual viewport cannot be
        // updated directly, and scrollIntoView is the only way a script
        // can affect it. So this tries to kludge around the problem by
        // calling scrollIntoView on the scroll target's line.
        if (window.visualViewport && window.innerHeight - window.visualViewport.height > 1 && (rect.top > window.pageYOffset + window.visualViewport.offsetTop + window.visualViewport.height || rect.bottom < window.pageYOffset + window.visualViewport.offsetTop)) {
            let line = this.view.docView.lineAt(range.head, 1);
            if (line) line.dom.scrollIntoView({
                block: "nearest"
            });
        }
    }
    lineHasWidget(pos) {
        let scan = (child)=>child.isWidget() || child.children.some(scan);
        return scan(this.tile.resolveBlock(pos, 1).tile);
    }
    destroy() {
        $7beee9608540d2c3$var$destroyDropped(this.tile);
    }
}
function $7beee9608540d2c3$var$destroyDropped(tile, reused) {
    let r = reused === null || reused === void 0 ? void 0 : reused.get(tile);
    if (r != 1 /* Reused.Full */ ) {
        if (r == null) tile.destroy();
        for (let ch of tile.children)$7beee9608540d2c3$var$destroyDropped(ch, reused);
    }
}
function $7beee9608540d2c3$var$betweenUneditable(pos) {
    return pos.node.nodeType == 1 && pos.node.firstChild && (pos.offset == 0 || pos.node.childNodes[pos.offset - 1].contentEditable == "false") && (pos.offset == pos.node.childNodes.length || pos.node.childNodes[pos.offset].contentEditable == "false");
}
function $7beee9608540d2c3$var$findCompositionNode(view, headPos) {
    let sel = view.observer.selectionRange;
    if (!sel.focusNode) return null;
    let textBefore = $7beee9608540d2c3$var$textNodeBefore(sel.focusNode, sel.focusOffset);
    let textAfter = $7beee9608540d2c3$var$textNodeAfter(sel.focusNode, sel.focusOffset);
    let textNode = textBefore || textAfter;
    if (textAfter && textBefore && textAfter.node != textBefore.node) {
        let tileAfter = $7beee9608540d2c3$var$Tile.get(textAfter.node);
        if (!tileAfter || tileAfter.isText() && tileAfter.text != textAfter.node.nodeValue) textNode = textAfter;
        else if (view.docView.lastCompositionAfterCursor) {
            let tileBefore = $7beee9608540d2c3$var$Tile.get(textBefore.node);
            if (!(!tileBefore || tileBefore.isText() && tileBefore.text != textBefore.node.nodeValue)) textNode = textAfter;
        }
    }
    view.docView.lastCompositionAfterCursor = textNode != textBefore;
    if (!textNode) return null;
    let from = headPos - textNode.offset;
    return {
        from: from,
        to: from + textNode.node.nodeValue.length,
        node: textNode.node
    };
}
function $7beee9608540d2c3$var$findCompositionRange(view, changes, headPos) {
    let found = $7beee9608540d2c3$var$findCompositionNode(view, headPos);
    if (!found) return null;
    let { node: textNode, from: from, to: to } = found, text = textNode.nodeValue;
    // Don't try to preserve multi-line compositions
    if (/[\n\r]/.test(text)) return null;
    if (view.state.doc.sliceString(found.from, found.to) != text) return null;
    let inv = changes.invertedDesc;
    return {
        range: new $7beee9608540d2c3$var$ChangedRange(inv.mapPos(from), inv.mapPos(to), from, to),
        text: textNode
    };
}
function $7beee9608540d2c3$var$nextToUneditable(node, offset) {
    if (node.nodeType != 1) return 0;
    return (offset && node.childNodes[offset - 1].contentEditable == "false" ? 1 /* NextTo.Before */  : 0) | (offset < node.childNodes.length && node.childNodes[offset].contentEditable == "false" ? 2 /* NextTo.After */  : 0);
}
let $7beee9608540d2c3$var$DecorationComparator$1 = class DecorationComparator {
    constructor(){
        this.changes = [];
    }
    compareRange(from, to) {
        $7beee9608540d2c3$var$addRange(from, to, this.changes);
    }
    comparePoint(from, to) {
        $7beee9608540d2c3$var$addRange(from, to, this.changes);
    }
    boundChange(pos) {
        $7beee9608540d2c3$var$addRange(pos, pos, this.changes);
    }
};
function $7beee9608540d2c3$var$findChangedDeco(a, b, diff) {
    let comp = new $7beee9608540d2c3$var$DecorationComparator$1;
    (0, $6295c6875f57e3ee$export$34cb5241245008dd).compare(a, b, diff, comp);
    return comp.changes;
}
class $7beee9608540d2c3$var$WrapperComparator {
    constructor(){
        this.changes = [];
    }
    compareRange(from, to) {
        $7beee9608540d2c3$var$addRange(from, to, this.changes);
    }
    comparePoint() {}
    boundChange(pos) {
        $7beee9608540d2c3$var$addRange(pos, pos, this.changes);
    }
}
function $7beee9608540d2c3$var$findChangedWrappers(a, b, diff) {
    let comp = new $7beee9608540d2c3$var$WrapperComparator;
    (0, $6295c6875f57e3ee$export$34cb5241245008dd).compare(a, b, diff, comp);
    return comp.changes;
}
function $7beee9608540d2c3$var$inUneditable(node, inside) {
    for(let cur = node; cur && cur != inside; cur = cur.assignedSlot || cur.parentNode){
        if (cur.nodeType == 1 && cur.contentEditable == 'false') return true;
    }
    return false;
}
function $7beee9608540d2c3$var$touchesComposition(changes, composition) {
    let touched = false;
    if (composition) changes.iterChangedRanges((from, to)=>{
        if (from < composition.to && to > composition.from) touched = true;
    });
    return touched;
}
class $7beee9608540d2c3$var$BlockGapWidget extends $7beee9608540d2c3$export$95cdd842edb044c5 {
    constructor(height){
        super();
        this.height = height;
    }
    toDOM() {
        let elt = document.createElement("div");
        elt.className = "cm-gap";
        this.updateDOM(elt);
        return elt;
    }
    eq(other) {
        return other.height == this.height;
    }
    updateDOM(elt) {
        elt.style.height = this.height + "px";
        return true;
    }
    get editable() {
        return true;
    }
    get estimatedHeight() {
        return this.height;
    }
    ignoreEvent() {
        return false;
    }
}
function $7beee9608540d2c3$var$groupAt(state, pos, bias = 1) {
    let categorize = state.charCategorizer(pos);
    let line = state.doc.lineAt(pos), linePos = pos - line.from;
    if (line.length == 0) return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(pos);
    if (linePos == 0) bias = 1;
    else if (linePos == line.length) bias = -1;
    let from = linePos, to = linePos;
    if (bias < 0) from = (0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(line.text, linePos, false);
    else to = (0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(line.text, linePos);
    let cat = categorize(line.text.slice(from, to));
    while(from > 0){
        let prev = (0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(line.text, from, false);
        if (categorize(line.text.slice(prev, from)) != cat) break;
        from = prev;
    }
    while(to < line.length){
        let next = (0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(line.text, to);
        if (categorize(line.text.slice(to, next)) != cat) break;
        to = next;
    }
    return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(from + line.from, to + line.from);
}
function $7beee9608540d2c3$var$posAtCoordsImprecise(view, contentRect, block, x, y) {
    let into = Math.round((x - contentRect.left) * view.defaultCharacterWidth);
    if (view.lineWrapping && block.height > view.defaultLineHeight * 1.5) {
        let textHeight = view.viewState.heightOracle.textHeight;
        let line = Math.floor((y - block.top - (view.defaultLineHeight - textHeight) * 0.5) / textHeight);
        into += line * view.viewState.heightOracle.lineLength;
    }
    let content = view.state.sliceDoc(block.from, block.to);
    return block.from + (0, $6295c6875f57e3ee$export$718b3d71c384ca05)(content, into, view.state.tabSize);
}
function $7beee9608540d2c3$var$blockAt(view, pos, side) {
    let line = view.lineBlockAt(pos);
    if (Array.isArray(line.type)) {
        let best;
        for (let l of line.type){
            if (l.from > pos) break;
            if (l.to < pos) continue;
            if (l.from < pos && l.to > pos) return l;
            if (!best || l.type == $7beee9608540d2c3$export$48808c686fe495c4.Text && (best.type != l.type || (side < 0 ? l.from < pos : l.to > pos))) best = l;
        }
        return best || line;
    }
    return line;
}
function $7beee9608540d2c3$var$moveToLineBoundary(view, start, forward, includeWrap) {
    let line = $7beee9608540d2c3$var$blockAt(view, start.head, start.assoc || -1);
    let coords = !includeWrap || line.type != $7beee9608540d2c3$export$48808c686fe495c4.Text || !(view.lineWrapping || line.widgetLineBreaks) ? null : view.coordsAtPos(start.assoc < 0 && start.head > line.from ? start.head - 1 : start.head);
    if (coords) {
        let editorRect = view.dom.getBoundingClientRect();
        let direction = view.textDirectionAt(line.from);
        let pos = view.posAtCoords({
            x: forward == (direction == $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR) ? editorRect.right - 1 : editorRect.left + 1,
            y: (coords.top + coords.bottom) / 2
        });
        if (pos != null) return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(pos, forward ? -1 : 1);
    }
    return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(forward ? line.to : line.from, forward ? -1 : 1);
}
function $7beee9608540d2c3$var$moveByChar(view, start, forward, by) {
    let line = view.state.doc.lineAt(start.head), spans = view.bidiSpans(line);
    let direction = view.textDirectionAt(line.from);
    for(let cur = start, check = null;;){
        let next = $7beee9608540d2c3$var$moveVisually(line, spans, direction, cur, forward), char = $7beee9608540d2c3$var$movedOver;
        if (!next) {
            if (line.number == (forward ? view.state.doc.lines : 1)) return cur;
            char = "\n";
            line = view.state.doc.line(line.number + (forward ? 1 : -1));
            spans = view.bidiSpans(line);
            next = view.visualLineSide(line, !forward);
        }
        if (!check) {
            if (!by) return next;
            check = by(char);
        } else if (!check(char)) return cur;
        cur = next;
    }
}
function $7beee9608540d2c3$var$byGroup(view, pos, start) {
    let categorize = view.state.charCategorizer(pos);
    let cat = categorize(start);
    return (next)=>{
        let nextCat = categorize(next);
        if (cat == (0, $6295c6875f57e3ee$export$239a3d59567c1401).Space) cat = nextCat;
        return cat == nextCat;
    };
}
function $7beee9608540d2c3$var$moveVertically(view, start, forward, distance) {
    let startPos = start.head, dir = forward ? 1 : -1;
    if (startPos == (forward ? view.state.doc.length : 0)) return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(startPos, start.assoc);
    let goal = start.goalColumn, startY;
    let rect = view.contentDOM.getBoundingClientRect();
    let startCoords = view.coordsAtPos(startPos, start.assoc || ((start.empty ? forward : start.head == start.from) ? 1 : -1));
    let docTop = view.documentTop;
    if (startCoords) {
        if (goal == null) goal = startCoords.left - rect.left;
        startY = dir < 0 ? startCoords.top : startCoords.bottom;
    } else {
        let line = view.viewState.lineBlockAt(startPos);
        if (goal == null) goal = Math.min(rect.right - rect.left, view.defaultCharacterWidth * (startPos - line.from));
        startY = (dir < 0 ? line.top : line.bottom) + docTop;
    }
    let resolvedGoal = rect.left + goal;
    let halfText = view.viewState.heightOracle.textHeight >> 1, dist = distance !== null && distance !== void 0 ? distance : halfText;
    for(let scan = 0;; scan += halfText){
        let y = startY + (dist + scan) * dir;
        let pos = $7beee9608540d2c3$var$posAtCoords(view, {
            x: resolvedGoal,
            y: y
        }, false, dir);
        if (forward ? y > rect.bottom : y < rect.top) return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(pos.pos, pos.assoc);
        let posCoords = view.coordsAtPos(pos.pos, pos.assoc), mid = posCoords ? (posCoords.top + posCoords.bottom) / 2 : 0;
        if (!posCoords || (forward ? mid > startY : mid < startY)) return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(pos.pos, pos.assoc, undefined, goal);
    }
}
function $7beee9608540d2c3$var$skipAtomicRanges(atoms, pos, bias) {
    for(;;){
        let moved = 0;
        for (let set of atoms)set.between(pos - 1, pos + 1, (from, to, value)=>{
            if (pos > from && pos < to) {
                let side = moved || bias || (pos - from < to - pos ? -1 : 1);
                pos = side < 0 ? from : to;
                moved = side;
            }
        });
        if (!moved) return pos;
    }
}
function $7beee9608540d2c3$var$skipAtomsForSelection(atoms, sel) {
    let ranges = null;
    for(let i = 0; i < sel.ranges.length; i++){
        let range = sel.ranges[i], updated = null;
        if (range.empty) {
            let pos = $7beee9608540d2c3$var$skipAtomicRanges(atoms, range.from, 0);
            if (pos != range.from) updated = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(pos, -1);
        } else {
            let from = $7beee9608540d2c3$var$skipAtomicRanges(atoms, range.from, -1);
            let to = $7beee9608540d2c3$var$skipAtomicRanges(atoms, range.to, 1);
            if (from != range.from || to != range.to) updated = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(range.from == range.anchor ? from : to, range.from == range.head ? from : to);
        }
        if (updated) {
            if (!ranges) ranges = sel.ranges.slice();
            ranges[i] = updated;
        }
    }
    return ranges ? (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create(ranges, sel.mainIndex) : sel;
}
function $7beee9608540d2c3$var$skipAtoms(view, oldPos, pos) {
    let newPos = $7beee9608540d2c3$var$skipAtomicRanges(view.state.facet($7beee9608540d2c3$var$atomicRanges).map((f)=>f(view)), pos.from, oldPos.head > pos.from ? -1 : 1);
    return newPos == pos.from ? pos : (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(newPos, newPos < pos.from ? 1 : -1);
}
class $7beee9608540d2c3$var$PosAssoc {
    constructor(pos, assoc){
        this.pos = pos;
        this.assoc = assoc;
    }
}
function $7beee9608540d2c3$var$posAtCoords(view, coords, precise, scanY) {
    let content = view.contentDOM.getBoundingClientRect(), docTop = content.top + view.viewState.paddingTop;
    let { x: x, y: y } = coords, yOffset = y - docTop, block;
    // First find the block at the given Y position, if any. If scanY is
    // given (used for vertical cursor motion), try to skip widgets and
    // line padding.
    for(;;){
        if (yOffset < 0) return new $7beee9608540d2c3$var$PosAssoc(0, 1);
        if (yOffset > view.viewState.docHeight) return new $7beee9608540d2c3$var$PosAssoc(view.state.doc.length, -1);
        block = view.elementAtHeight(yOffset);
        if (scanY == null) break;
        if (block.type == $7beee9608540d2c3$export$48808c686fe495c4.Text) {
            if (scanY < 0 ? block.to < view.viewport.from : block.from > view.viewport.to) break;
            // Check whether we aren't landing on the top/bottom padding of the line
            let rect = view.docView.coordsAt(scanY < 0 ? block.from : block.to, scanY > 0 ? -1 : 1);
            if (rect && (scanY < 0 ? rect.top <= yOffset + docTop : rect.bottom >= yOffset + docTop)) break;
        }
        let halfLine = view.viewState.heightOracle.textHeight / 2;
        yOffset = scanY > 0 ? block.bottom + halfLine : block.top - halfLine;
    }
    // If outside the viewport, return null if precise==true, an
    // estimate otherwise.
    if (view.viewport.from >= block.to || view.viewport.to <= block.from) {
        if (precise) return null;
        if (block.type == $7beee9608540d2c3$export$48808c686fe495c4.Text) {
            let pos = $7beee9608540d2c3$var$posAtCoordsImprecise(view, content, block, x, y);
            return new $7beee9608540d2c3$var$PosAssoc(pos, pos == block.from ? 1 : -1);
        }
    }
    if (block.type != $7beee9608540d2c3$export$48808c686fe495c4.Text) return yOffset < (block.top + block.bottom) / 2 ? new $7beee9608540d2c3$var$PosAssoc(block.from, 1) : new $7beee9608540d2c3$var$PosAssoc(block.to, -1);
    // Here we know we're in a line, so run the logic for inline layout
    let line = view.docView.lineAt(block.from, 2);
    if (!line || line.length != block.length) line = view.docView.lineAt(block.from, -2);
    return new $7beee9608540d2c3$var$InlineCoordsScan(view, x, y, view.textDirectionAt(block.from)).scanTile(line, block.from);
}
class $7beee9608540d2c3$var$InlineCoordsScan {
    constructor(view, x, y, baseDir){
        this.view = view;
        this.x = x;
        this.y = y;
        this.baseDir = baseDir;
        // Cached bidi info
        this.line = null;
        this.spans = null;
    }
    bidiSpansAt(pos) {
        if (!this.line || this.line.from > pos || this.line.to < pos) {
            this.line = this.view.state.doc.lineAt(pos);
            this.spans = this.view.bidiSpans(this.line);
        }
        return this;
    }
    baseDirAt(pos, side) {
        let { line: line, spans: spans } = this.bidiSpansAt(pos);
        let level = spans[$7beee9608540d2c3$export$e1ed96b746bb516a.find(spans, pos - line.from, -1, side)].level;
        return level == this.baseDir;
    }
    dirAt(pos, side) {
        let { line: line, spans: spans } = this.bidiSpansAt(pos);
        return spans[$7beee9608540d2c3$export$e1ed96b746bb516a.find(spans, pos - line.from, -1, side)].dir;
    }
    // Used to short-circuit bidi tests for content with a uniform direction
    bidiIn(from, to) {
        let { spans: spans, line: line } = this.bidiSpansAt(from);
        return spans.length > 1 || spans.length && (spans[0].level != this.baseDir || spans[0].to + line.from < to);
    }
    // Scan through the rectangles for the content of a tile with inline
    // content, looking for one that overlaps the queried position
    // vertically and is closest horizontally. The caller is responsible
    // for dividing its content into N pieces, and pass an array with
    // N+1 positions (including the position after the last piece). For
    // a text tile, these will be character clusters, for a composite
    // tile, these will be child tiles.
    scan(positions, getRects, recursed = false) {
        let lo = 0, hi = positions.length - 1, seen = new Set();
        let bidi = this.bidiIn(positions[0], positions[hi]);
        let above, below;
        let closestI = -1, closestDx = 1e9, closestRect;
        // Because, when the content is bidirectional, a regular binary
        // search is hard to perform (the content order does not
        // correspond to visual order), this loop does something between a
        // regular binary search and a full scan, depending on what it can
        // get away with. The outer hi/lo bounds are only adjusted for
        // elements that are part of the base order.
        //
        // To make sure all elements inside those bounds are visited,
        // eventually, we keep a set of seen indices, and if the midpoint
        // has already been handled, we start in a random index within the
        // current bounds and scan forward until we find an index that
        // hasn't been seen yet.
        search: while(lo < hi){
            let dist = hi - lo, mid = lo + hi >> 1;
            adjust: if (seen.has(mid)) {
                let scan = lo + Math.floor(Math.random() * dist);
                for(let i = 0; i < dist; i++){
                    if (!seen.has(scan)) {
                        mid = scan;
                        break adjust;
                    }
                    scan++;
                    if (scan == hi) scan = lo; // Wrap around
                }
                break search; // No index found, we're done
            }
            seen.add(mid);
            let rects = getRects(mid);
            if (rects) for(let i = 0; i < rects.length; i++){
                let rect = rects[i], side = 0;
                // Ignore empty rectangles when there are other rectangles
                if (rect.width == 0 && rects.length > 1) continue;
                if (rect.bottom < this.y) {
                    if (!above || above.bottom < rect.bottom) above = rect;
                    side = 1;
                } else if (rect.top > this.y) {
                    if (!below || below.top > rect.top) below = rect;
                    side = -1;
                } else {
                    let off = rect.left > this.x ? this.x - rect.left : rect.right < this.x ? this.x - rect.right : 0;
                    let dx = Math.abs(off);
                    if (dx < closestDx) {
                        closestI = mid;
                        closestDx = dx;
                        closestRect = rect;
                    }
                    if (off) side = off < 0 == (this.baseDir == $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR) ? -1 : 1;
                }
                // Narrow binary search when it is safe to do so
                if (side == -1 && (!bidi || this.baseDirAt(positions[mid], 1))) hi = mid;
                else if (side == 1 && (!bidi || this.baseDirAt(positions[mid + 1], -1))) lo = mid + 1;
            }
        }
        // If no element with y overlap is found, find the nearest element
        // on the y axis, move this.y into it, and retry the scan.
        if (!closestRect) {
            if (!below && !above) return {
                i: positions[0],
                after: false
            };
            let side = above && (!below || this.y - above.bottom < below.top - this.y) ? above : below;
            this.y = (side.top + side.bottom) / 2;
            return this.scan(positions, getRects, true);
        }
        // Handle the case where closest matched a higher element on the
        // same line as an element below/above the coords
        if (closestDx && !recursed) {
            let { top: top, bottom: bottom } = closestRect;
            if (above && above.bottom > (top + top + bottom) / 3) {
                this.y = above.bottom - 1;
                return this.scan(positions, getRects, true);
            }
            if (below && below.top < (top + bottom + bottom) / 3) {
                this.y = below.top + 1;
                return this.scan(positions, getRects, true);
            }
        }
        let ltr = (bidi ? this.dirAt(positions[closestI], 1) : this.baseDir) == $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR;
        return {
            i: closestI,
            // Test whether x is closes to the start or end of this element
            after: this.x > (closestRect.left + closestRect.right) / 2 == ltr
        };
    }
    scanText(tile, offset) {
        let positions = [];
        for(let i = 0; i < tile.length; i = (0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(tile.text, i))positions.push(offset + i);
        positions.push(offset + tile.length);
        let scan = this.scan(positions, (i)=>{
            let off = positions[i] - offset, end = positions[i + 1] - offset;
            return $7beee9608540d2c3$var$textRange(tile.dom, off, end).getClientRects();
        });
        return scan.after ? new $7beee9608540d2c3$var$PosAssoc(positions[scan.i + 1], -1) : new $7beee9608540d2c3$var$PosAssoc(positions[scan.i], 1);
    }
    scanTile(tile, offset) {
        if (!tile.length) return new $7beee9608540d2c3$var$PosAssoc(offset, 1);
        if (tile.children.length == 1) {
            let child = tile.children[0];
            if (child.isText()) return this.scanText(child, offset);
            else if (child.isComposite()) return this.scanTile(child, offset);
        }
        let positions = [
            offset
        ];
        for(let i = 0, pos = offset; i < tile.children.length; i++)positions.push(pos += tile.children[i].length);
        let scan = this.scan(positions, (i)=>{
            let child = tile.children[i];
            if (child.flags & 48 /* TileFlag.PointWidget */ ) return null;
            return (child.dom.nodeType == 1 ? child.dom : $7beee9608540d2c3$var$textRange(child.dom, 0, child.length)).getClientRects();
        });
        let child = tile.children[scan.i], pos = positions[scan.i];
        if (child.isText()) return this.scanText(child, pos);
        if (child.isComposite()) return this.scanTile(child, pos);
        return scan.after ? new $7beee9608540d2c3$var$PosAssoc(positions[scan.i + 1], -1) : new $7beee9608540d2c3$var$PosAssoc(pos, 1);
    }
}
const $7beee9608540d2c3$var$LineBreakPlaceholder = "\uffff";
class $7beee9608540d2c3$var$DOMReader {
    constructor(points, view){
        this.points = points;
        this.view = view;
        this.text = "";
        this.lineSeparator = view.state.facet((0, $6295c6875f57e3ee$export$afa855cbfaff27f2).lineSeparator);
    }
    append(text) {
        this.text += text;
    }
    lineBreak() {
        this.text += $7beee9608540d2c3$var$LineBreakPlaceholder;
    }
    readRange(start, end) {
        if (!start) return this;
        let parent = start.parentNode;
        for(let cur = start;;){
            this.findPointBefore(parent, cur);
            let oldLen = this.text.length;
            this.readNode(cur);
            let tile = $7beee9608540d2c3$var$Tile.get(cur), next = cur.nextSibling;
            if (next == end) {
                if ((tile === null || tile === void 0 ? void 0 : tile.breakAfter) && !next && parent != this.view.contentDOM) this.lineBreak();
                break;
            }
            let nextTile = $7beee9608540d2c3$var$Tile.get(next);
            if ((tile && nextTile ? tile.breakAfter : (tile ? tile.breakAfter : $7beee9608540d2c3$var$isBlockElement(cur)) || $7beee9608540d2c3$var$isBlockElement(next) && (cur.nodeName != "BR" || (tile === null || tile === void 0 ? void 0 : tile.isWidget())) && this.text.length > oldLen) && !$7beee9608540d2c3$var$isEmptyToEnd(next, end)) this.lineBreak();
            cur = next;
        }
        this.findPointBefore(parent, end);
        return this;
    }
    readTextNode(node) {
        let text = node.nodeValue;
        for (let point of this.points)if (point.node == node) point.pos = this.text.length + Math.min(point.offset, text.length);
        for(let off = 0, re = this.lineSeparator ? null : /\r\n?|\n/g;;){
            let nextBreak = -1, breakSize = 1, m;
            if (this.lineSeparator) {
                nextBreak = text.indexOf(this.lineSeparator, off);
                breakSize = this.lineSeparator.length;
            } else if (m = re.exec(text)) {
                nextBreak = m.index;
                breakSize = m[0].length;
            }
            this.append(text.slice(off, nextBreak < 0 ? text.length : nextBreak));
            if (nextBreak < 0) break;
            this.lineBreak();
            if (breakSize > 1) {
                for (let point of this.points)if (point.node == node && point.pos > this.text.length) point.pos -= breakSize - 1;
            }
            off = nextBreak + breakSize;
        }
    }
    readNode(node) {
        let tile = $7beee9608540d2c3$var$Tile.get(node);
        let fromView = tile && tile.overrideDOMText;
        if (fromView != null) {
            this.findPointInside(node, fromView.length);
            for(let i = fromView.iter(); !i.next().done;)if (i.lineBreak) this.lineBreak();
            else this.append(i.value);
        } else if (node.nodeType == 3) this.readTextNode(node);
        else if (node.nodeName == "BR") {
            if (node.nextSibling) this.lineBreak();
        } else if (node.nodeType == 1) this.readRange(node.firstChild, null);
    }
    findPointBefore(node, next) {
        for (let point of this.points)if (point.node == node && node.childNodes[point.offset] == next) point.pos = this.text.length;
    }
    findPointInside(node, length) {
        for (let point of this.points)if (node.nodeType == 3 ? point.node == node : node.contains(point.node)) point.pos = this.text.length + ($7beee9608540d2c3$var$isAtEnd(node, point.node, point.offset) ? length : 0);
    }
}
function $7beee9608540d2c3$var$isAtEnd(parent, node, offset) {
    for(;;){
        if (!node || offset < $7beee9608540d2c3$var$maxOffset(node)) return false;
        if (node == parent) return true;
        offset = $7beee9608540d2c3$var$domIndex(node) + 1;
        node = node.parentNode;
    }
}
function $7beee9608540d2c3$var$isEmptyToEnd(node, end) {
    let widgets;
    for(;; node = node.nextSibling){
        if (node == end || !node) break;
        let view = $7beee9608540d2c3$var$Tile.get(node);
        if (!(view === null || view === void 0 ? void 0 : view.isWidget())) return false;
        if (view) (widgets || (widgets = [])).push(view);
    }
    if (widgets) for (let w of widgets){
        let override = w.overrideDOMText;
        if (override === null || override === void 0 ? void 0 : override.length) return false;
    }
    return true;
}
class $7beee9608540d2c3$var$DOMPoint {
    constructor(node, offset){
        this.node = node;
        this.offset = offset;
        this.pos = -1;
    }
}
class $7beee9608540d2c3$var$DOMChange {
    constructor(view, start, end, typeOver){
        this.typeOver = typeOver;
        this.bounds = null;
        this.text = "";
        this.domChanged = start > -1;
        let { impreciseHead: iHead, impreciseAnchor: iAnchor } = view.docView, curSel = view.state.selection;
        if (view.state.readOnly && start > -1) // Ignore changes when the editor is read-only
        this.newSel = null;
        else if (start > -1 && (this.bounds = $7beee9608540d2c3$var$domBoundsAround(view.docView.tile, start, end, 0))) {
            let selPoints = iHead || iAnchor ? [] : $7beee9608540d2c3$var$selectionPoints(view);
            let reader = new $7beee9608540d2c3$var$DOMReader(selPoints, view);
            reader.readRange(this.bounds.startDOM, this.bounds.endDOM);
            this.text = reader.text;
            this.newSel = $7beee9608540d2c3$var$selectionFromPoints(selPoints, this.bounds.from);
        } else {
            let domSel = view.observer.selectionRange;
            let head = iHead && iHead.node == domSel.focusNode && iHead.offset == domSel.focusOffset || !$7beee9608540d2c3$var$contains(view.contentDOM, domSel.focusNode) ? curSel.main.head : view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset);
            let anchor = iAnchor && iAnchor.node == domSel.anchorNode && iAnchor.offset == domSel.anchorOffset || !$7beee9608540d2c3$var$contains(view.contentDOM, domSel.anchorNode) ? curSel.main.anchor : view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset);
            // iOS will refuse to select the block gaps when doing
            // select-all.
            // Chrome will put the selection *inside* them, confusing
            // posFromDOM
            let vp = view.viewport;
            if (($7beee9608540d2c3$var$browser.ios || $7beee9608540d2c3$var$browser.chrome) && curSel.main.empty && head != anchor && (vp.from > 0 || vp.to < view.state.doc.length)) {
                let from = Math.min(head, anchor), to = Math.max(head, anchor);
                let offFrom = vp.from - from, offTo = vp.to - to;
                if ((offFrom == 0 || offFrom == 1 || from == 0) && (offTo == 0 || offTo == -1 || to == view.state.doc.length)) {
                    head = 0;
                    anchor = view.state.doc.length;
                }
            }
            if (view.inputState.composing > -1 && curSel.ranges.length > 1) this.newSel = curSel.replaceRange((0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(anchor, head));
            else if (view.lineWrapping && anchor == head && !(curSel.main.empty && curSel.main.head == head) && view.inputState.lastTouchTime > Date.now() - 100) {
                // If this is a cursor selection change in a line-wrapping
                // editor that may have been a touch, use the last touch
                // position to assign a side to the cursor.
                let before = view.coordsAtPos(head, -1), assoc = 0;
                if (before) assoc = view.inputState.lastTouchY <= before.bottom ? -1 : 1;
                this.newSel = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create([
                    (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(head, assoc)
                ]);
            } else this.newSel = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).single(anchor, head);
        }
    }
}
function $7beee9608540d2c3$var$domBoundsAround(tile, from, to, offset) {
    if (tile.isComposite()) {
        let fromI = -1, fromStart = -1, toI = -1, toEnd = -1;
        for(let i = 0, pos = offset, prevEnd = offset; i < tile.children.length; i++){
            let child = tile.children[i], end = pos + child.length;
            if (pos < from && end > to) return $7beee9608540d2c3$var$domBoundsAround(child, from, to, pos);
            if (end >= from && fromI == -1) {
                fromI = i;
                fromStart = pos;
            }
            if (pos > to && child.dom.parentNode == tile.dom) {
                toI = i;
                toEnd = prevEnd;
                break;
            }
            prevEnd = end;
            pos = end + child.breakAfter;
        }
        return {
            from: fromStart,
            to: toEnd < 0 ? offset + tile.length : toEnd,
            startDOM: (fromI ? tile.children[fromI - 1].dom.nextSibling : null) || tile.dom.firstChild,
            endDOM: toI < tile.children.length && toI >= 0 ? tile.children[toI].dom : null
        };
    } else if (tile.isText()) return {
        from: offset,
        to: offset + tile.length,
        startDOM: tile.dom,
        endDOM: tile.dom.nextSibling
    };
    else return null;
}
function $7beee9608540d2c3$var$applyDOMChange(view, domChange) {
    let change;
    let { newSel: newSel } = domChange, { state: state } = view, sel = state.selection.main;
    let lastKey = view.inputState.lastKeyTime > Date.now() - 100 ? view.inputState.lastKeyCode : -1;
    if (domChange.bounds) {
        let { from: from, to: to } = domChange.bounds;
        let preferredPos = sel.from, preferredSide = null;
        // Prefer anchoring to end when Backspace is pressed (or, on
        // Android, when something was deleted)
        if (lastKey === 8 || $7beee9608540d2c3$var$browser.android && domChange.text.length < to - from) {
            preferredPos = sel.to;
            preferredSide = "end";
        }
        let cmp = state.doc.sliceString(from, to, $7beee9608540d2c3$var$LineBreakPlaceholder), selEnd, diff;
        if (!sel.empty && sel.from >= from && sel.to <= to && (domChange.typeOver || cmp != domChange.text) && cmp.slice(0, sel.from - from) == domChange.text.slice(0, sel.from - from) && cmp.slice(sel.to - from) == domChange.text.slice(selEnd = domChange.text.length - (cmp.length - (sel.to - from)))) // This looks like a selection replacement
        change = {
            from: sel.from,
            to: sel.to,
            insert: (0, $6295c6875f57e3ee$export$5f1af8db9871e1d6).of(domChange.text.slice(sel.from - from, selEnd).split($7beee9608540d2c3$var$LineBreakPlaceholder))
        };
        else if (diff = $7beee9608540d2c3$var$findDiff(cmp, domChange.text, preferredPos - from, preferredSide)) {
            // Chrome inserts two newlines when pressing shift-enter at the
            // end of a line. DomChange drops one of those.
            if ($7beee9608540d2c3$var$browser.chrome && lastKey == 13 && diff.toB == diff.from + 2 && domChange.text.slice(diff.from, diff.toB) == $7beee9608540d2c3$var$LineBreakPlaceholder + $7beee9608540d2c3$var$LineBreakPlaceholder) diff.toB--;
            change = {
                from: from + diff.from,
                to: from + diff.toA,
                insert: (0, $6295c6875f57e3ee$export$5f1af8db9871e1d6).of(domChange.text.slice(diff.from, diff.toB).split($7beee9608540d2c3$var$LineBreakPlaceholder))
            };
        }
    } else if (newSel && (!view.hasFocus && state.facet($7beee9608540d2c3$var$editable) || $7beee9608540d2c3$var$sameSelPos(newSel, sel))) newSel = null;
    if (!change && !newSel) return false;
    if (($7beee9608540d2c3$var$browser.mac || $7beee9608540d2c3$var$browser.android) && change && change.from == change.to && change.from == sel.head - 1 && /^\. ?$/.test(change.insert.toString()) && view.contentDOM.getAttribute("autocorrect") == "off") {
        // Detect insert-period-on-double-space Mac and Android behavior,
        // and transform it into a regular space insert.
        if (newSel && change.insert.length == 2) newSel = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).single(newSel.main.anchor - 1, newSel.main.head - 1);
        change = {
            from: change.from,
            to: change.to,
            insert: (0, $6295c6875f57e3ee$export$5f1af8db9871e1d6).of([
                change.insert.toString().replace(".", " ")
            ])
        };
    } else if (state.doc.lineAt(sel.from).to < sel.to && view.docView.lineHasWidget(sel.to) && view.inputState.insertingTextAt > Date.now() - 50) // For a cross-line insertion, Chrome and Safari will crudely take
    // the text of the line after the selection, flattening any
    // widgets, and move it into the joined line. This tries to detect
    // such a situation, and replaces the change with a selection
    // replace of the text provided by the beforeinput event.
    change = {
        from: sel.from,
        to: sel.to,
        insert: state.toText(view.inputState.insertingText)
    };
    else if ($7beee9608540d2c3$var$browser.chrome && change && change.from == change.to && change.from == sel.head && change.insert.toString() == "\n " && view.lineWrapping) {
        // In Chrome, if you insert a space at the start of a wrapped
        // line, it will actually insert a newline and a space, causing a
        // bogus new line to be created in CodeMirror (#968)
        if (newSel) newSel = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).single(newSel.main.anchor - 1, newSel.main.head - 1);
        change = {
            from: sel.from,
            to: sel.to,
            insert: (0, $6295c6875f57e3ee$export$5f1af8db9871e1d6).of([
                " "
            ])
        };
    }
    if (change) return $7beee9608540d2c3$var$applyDOMChangeInner(view, change, newSel, lastKey);
    else if (newSel && !$7beee9608540d2c3$var$sameSelPos(newSel, sel)) {
        let scrollIntoView = false, userEvent = "select";
        if (view.inputState.lastSelectionTime > Date.now() - 50) {
            if (view.inputState.lastSelectionOrigin == "select") scrollIntoView = true;
            userEvent = view.inputState.lastSelectionOrigin;
            if (userEvent == "select.pointer") newSel = $7beee9608540d2c3$var$skipAtomsForSelection(state.facet($7beee9608540d2c3$var$atomicRanges).map((f)=>f(view)), newSel);
        }
        view.dispatch({
            selection: newSel,
            scrollIntoView: scrollIntoView,
            userEvent: userEvent
        });
        return true;
    } else return false;
}
function $7beee9608540d2c3$var$applyDOMChangeInner(view, change, newSel, lastKey = -1) {
    if ($7beee9608540d2c3$var$browser.ios && view.inputState.flushIOSKey(change)) return true;
    let sel = view.state.selection.main;
    // Android browsers don't fire reasonable key events for enter,
    // backspace, or delete. So this detects changes that look like
    // they're caused by those keys, and reinterprets them as key
    // events. (Some of these keys are also handled by beforeinput
    // events and the pendingAndroidKey mechanism, but that's not
    // reliable in all situations.)
    if ($7beee9608540d2c3$var$browser.android && (change.to == sel.to && // GBoard will sometimes remove a space it just inserted
    // after a completion when you press enter
    (change.from == sel.from || change.from == sel.from - 1 && view.state.sliceDoc(change.from, sel.from) == " ") && change.insert.length == 1 && change.insert.lines == 2 && $7beee9608540d2c3$var$dispatchKey(view.contentDOM, "Enter", 13) || (change.from == sel.from - 1 && change.to == sel.to && change.insert.length == 0 || lastKey == 8 && change.insert.length < change.to - change.from && change.to > sel.head) && $7beee9608540d2c3$var$dispatchKey(view.contentDOM, "Backspace", 8) || change.from == sel.from && change.to == sel.to + 1 && change.insert.length == 0 && $7beee9608540d2c3$var$dispatchKey(view.contentDOM, "Delete", 46))) return true;
    let text = change.insert.toString();
    if (view.inputState.composing >= 0) view.inputState.composing++;
    let defaultTr;
    let defaultInsert = ()=>defaultTr || (defaultTr = $7beee9608540d2c3$var$applyDefaultInsert(view, change, newSel));
    if (!view.state.facet($7beee9608540d2c3$var$inputHandler).some((h)=>h(view, change.from, change.to, text, defaultInsert))) view.dispatch(defaultInsert());
    return true;
}
function $7beee9608540d2c3$var$applyDefaultInsert(view, change, newSel) {
    let tr, startState = view.state, sel = startState.selection.main, inAtomic = -1;
    if (change.from == change.to && change.from < sel.from || change.from > sel.to) {
        let side = change.from < sel.from ? -1 : 1, pos = side < 0 ? sel.from : sel.to;
        let moved = $7beee9608540d2c3$var$skipAtomicRanges(startState.facet($7beee9608540d2c3$var$atomicRanges).map((f)=>f(view)), pos, side);
        if (change.from == moved) inAtomic = moved;
    }
    if (inAtomic > -1) tr = {
        changes: change,
        selection: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(change.from + change.insert.length, -1)
    };
    else if (change.from >= sel.from && change.to <= sel.to && change.to - change.from >= (sel.to - sel.from) / 3 && (!newSel || newSel.main.empty && newSel.main.from == change.from + change.insert.length) && view.inputState.composing < 0) {
        let before = sel.from < change.from ? startState.sliceDoc(sel.from, change.from) : "";
        let after = sel.to > change.to ? startState.sliceDoc(change.to, sel.to) : "";
        tr = startState.replaceSelection(view.state.toText(before + change.insert.sliceString(0, undefined, view.state.lineBreak) + after));
    } else {
        let changes = startState.changes(change);
        let mainSel = newSel && newSel.main.to <= changes.newLength ? newSel.main : undefined;
        // Try to apply a composition change to all cursors
        if (startState.selection.ranges.length > 1 && (view.inputState.composing >= 0 || view.inputState.compositionPendingChange) && change.to <= sel.to + 10 && change.to >= sel.to - 10) {
            let replaced = view.state.sliceDoc(change.from, change.to);
            let compositionRange, composition = newSel && $7beee9608540d2c3$var$findCompositionNode(view, newSel.main.head);
            if (composition) {
                let dLen = change.insert.length - (change.to - change.from);
                compositionRange = {
                    from: composition.from,
                    to: composition.to - dLen
                };
            } else compositionRange = view.state.doc.lineAt(sel.head);
            let offset = sel.to - change.to;
            tr = startState.changeByRange((range)=>{
                if (range.from == sel.from && range.to == sel.to) return {
                    changes: changes,
                    range: mainSel || range.map(changes)
                };
                let to = range.to - offset, from = to - replaced.length;
                if (view.state.sliceDoc(from, to) != replaced || // Unfortunately, there's no way to make multiple
                // changes in the same node work without aborting
                // composition, so cursors in the composition range are
                // ignored.
                to >= compositionRange.from && from <= compositionRange.to) return {
                    range: range
                };
                let rangeChanges = startState.changes({
                    from: from,
                    to: to,
                    insert: change.insert
                }), selOff = range.to - sel.to;
                return {
                    changes: rangeChanges,
                    range: !mainSel ? range.map(rangeChanges) : (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(Math.max(0, mainSel.anchor + selOff), Math.max(0, mainSel.head + selOff))
                };
            });
        } else tr = {
            changes: changes,
            selection: mainSel && startState.selection.replaceRange(mainSel)
        };
    }
    let userEvent = "input.type";
    if (view.composing || view.inputState.compositionPendingChange && view.inputState.compositionEndedAt > Date.now() - 50) {
        view.inputState.compositionPendingChange = false;
        userEvent += ".compose";
        if (view.inputState.compositionFirstChange) {
            userEvent += ".start";
            view.inputState.compositionFirstChange = false;
        }
    }
    return startState.update(tr, {
        userEvent: userEvent,
        scrollIntoView: true
    });
}
function $7beee9608540d2c3$var$findDiff(a, b, preferredPos, preferredSide) {
    let minLen = Math.min(a.length, b.length);
    let from = 0;
    while(from < minLen && a.charCodeAt(from) == b.charCodeAt(from))from++;
    if (from == minLen && a.length == b.length) return null;
    let toA = a.length, toB = b.length;
    while(toA > 0 && toB > 0 && a.charCodeAt(toA - 1) == b.charCodeAt(toB - 1)){
        toA--;
        toB--;
    }
    if (preferredSide == "end") {
        let adjust = Math.max(0, from - Math.min(toA, toB));
        preferredPos -= toA + adjust - from;
    }
    if (toA < from && a.length < b.length) {
        let move = preferredPos <= from && preferredPos >= toA ? from - preferredPos : 0;
        from -= move;
        toB = from + (toB - toA);
        toA = from;
    } else if (toB < from) {
        let move = preferredPos <= from && preferredPos >= toB ? from - preferredPos : 0;
        from -= move;
        toA = from + (toA - toB);
        toB = from;
    }
    return {
        from: from,
        toA: toA,
        toB: toB
    };
}
function $7beee9608540d2c3$var$selectionPoints(view) {
    let result = [];
    if (view.root.activeElement != view.contentDOM) return result;
    let { anchorNode: anchorNode, anchorOffset: anchorOffset, focusNode: focusNode, focusOffset: focusOffset } = view.observer.selectionRange;
    if (anchorNode) {
        result.push(new $7beee9608540d2c3$var$DOMPoint(anchorNode, anchorOffset));
        if (focusNode != anchorNode || focusOffset != anchorOffset) result.push(new $7beee9608540d2c3$var$DOMPoint(focusNode, focusOffset));
    }
    return result;
}
function $7beee9608540d2c3$var$selectionFromPoints(points, base) {
    if (points.length == 0) return null;
    let anchor = points[0].pos, head = points.length == 2 ? points[1].pos : anchor;
    return anchor > -1 && head > -1 ? (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).single(anchor + base, head + base) : null;
}
function $7beee9608540d2c3$var$sameSelPos(selection, range) {
    return range.head == selection.main.head && range.anchor == selection.main.anchor;
}
class $7beee9608540d2c3$var$InputState {
    setSelectionOrigin(origin) {
        this.lastSelectionOrigin = origin;
        this.lastSelectionTime = Date.now();
    }
    constructor(view){
        this.view = view;
        this.lastKeyCode = 0;
        this.lastKeyTime = 0;
        this.lastTouchTime = 0;
        this.lastTouchX = 0;
        this.lastTouchY = 0;
        this.lastFocusTime = 0;
        this.lastScrollTop = 0;
        this.lastScrollLeft = 0;
        this.lastWheelEvent = 0;
        // On iOS, some keys need to have their default behavior happen
        // (after which we retroactively handle them and reset the DOM) to
        // avoid messing up the virtual keyboard state.
        this.pendingIOSKey = undefined;
        /**
        When enabled (>-1), tab presses are not given to key handlers,
        leaving the browser's default behavior. If >0, the mode expires
        at that timestamp, and any other keypress clears it.
        Esc enables temporary tab focus mode for two seconds when not
        otherwise handled.
        */ this.tabFocusMode = -1;
        this.lastSelectionOrigin = null;
        this.lastSelectionTime = 0;
        this.lastContextMenu = 0;
        this.scrollHandlers = [];
        this.handlers = Object.create(null);
        // -1 means not in a composition. Otherwise, this counts the number
        // of changes made during the composition. The count is used to
        // avoid treating the start state of the composition, before any
        // changes have been made, as part of the composition.
        this.composing = -1;
        // Tracks whether the next change should be marked as starting the
        // composition (null means no composition, true means next is the
        // first, false means first has already been marked for this
        // composition)
        this.compositionFirstChange = null;
        // End time of the previous composition
        this.compositionEndedAt = 0;
        // Used in a kludge to detect when an Enter keypress should be
        // considered part of the composition on Safari, which fires events
        // in the wrong order
        this.compositionPendingKey = false;
        // Used to categorize changes as part of a composition, even when
        // the mutation events fire shortly after the compositionend event
        this.compositionPendingChange = false;
        // Set by beforeinput, used in DOM change reader
        this.insertingText = "";
        this.insertingTextAt = 0;
        this.mouseSelection = null;
        // When a drag from the editor is active, this points at the range
        // being dragged.
        this.draggedContent = null;
        this.handleEvent = this.handleEvent.bind(this);
        this.notifiedFocused = view.hasFocus;
        // On Safari adding an input event handler somehow prevents an
        // issue where the composition vanishes when you press enter.
        if ($7beee9608540d2c3$var$browser.safari) view.contentDOM.addEventListener("input", ()=>null);
        if ($7beee9608540d2c3$var$browser.gecko) $7beee9608540d2c3$var$firefoxCopyCutHack(view.contentDOM.ownerDocument);
    }
    handleEvent(event) {
        if (!$7beee9608540d2c3$var$eventBelongsToEditor(this.view, event) || this.ignoreDuringComposition(event)) return;
        if (event.type == "keydown" && this.keydown(event)) return;
        if (this.view.updateState != 0 /* UpdateState.Idle */ ) Promise.resolve().then(()=>this.runHandlers(event.type, event));
        else this.runHandlers(event.type, event);
    }
    runHandlers(type, event) {
        let handlers = this.handlers[type];
        if (handlers) {
            for (let observer of handlers.observers)observer(this.view, event);
            for (let handler of handlers.handlers){
                if (event.defaultPrevented) break;
                if (handler(this.view, event)) {
                    event.preventDefault();
                    break;
                }
            }
        }
    }
    ensureHandlers(plugins) {
        let handlers = $7beee9608540d2c3$var$computeHandlers(plugins), prev = this.handlers, dom = this.view.contentDOM;
        for(let type in handlers)if (type != "scroll") {
            let passive = !handlers[type].handlers.length;
            let exists = prev[type];
            if (exists && passive != !exists.handlers.length) {
                dom.removeEventListener(type, this.handleEvent);
                exists = null;
            }
            if (!exists) dom.addEventListener(type, this.handleEvent, {
                passive: passive
            });
        }
        for(let type in prev)if (type != "scroll" && !handlers[type]) dom.removeEventListener(type, this.handleEvent);
        this.handlers = handlers;
    }
    keydown(event) {
        // Must always run, even if a custom handler handled the event
        this.lastKeyCode = event.keyCode;
        this.lastKeyTime = Date.now();
        if (event.keyCode == 9 && this.tabFocusMode > -1 && (!this.tabFocusMode || Date.now() <= this.tabFocusMode)) return true;
        if (this.tabFocusMode > 0 && event.keyCode != 27 && $7beee9608540d2c3$var$modifierCodes.indexOf(event.keyCode) < 0) this.tabFocusMode = -1;
        // Chrome for Android usually doesn't fire proper key events, but
        // occasionally does, usually surrounded by a bunch of complicated
        // composition changes. When an enter or backspace key event is
        // seen, hold off on handling DOM events for a bit, and then
        // dispatch it.
        if ($7beee9608540d2c3$var$browser.android && $7beee9608540d2c3$var$browser.chrome && !event.synthetic && (event.keyCode == 13 || event.keyCode == 8)) {
            this.view.observer.delayAndroidKey(event.key, event.keyCode);
            return true;
        }
        // Preventing the default behavior of Enter on iOS makes the
        // virtual keyboard get stuck in the wrong (lowercase)
        // state. So we let it go through, and then, in
        // applyDOMChange, notify key handlers of it and reset to
        // the state they produce.
        let pending;
        if ($7beee9608540d2c3$var$browser.ios && !event.synthetic && !event.altKey && !event.metaKey && !event.shiftKey && ((pending = $7beee9608540d2c3$var$PendingKeys.find((key)=>key.keyCode == event.keyCode)) && !event.ctrlKey || $7beee9608540d2c3$var$EmacsyPendingKeys.indexOf(event.key) > -1 && event.ctrlKey)) {
            this.pendingIOSKey = pending || event;
            setTimeout(()=>this.flushIOSKey(), 250);
            return true;
        }
        if (event.keyCode != 229) this.view.observer.forceFlush();
        return false;
    }
    flushIOSKey(change) {
        let key = this.pendingIOSKey;
        if (!key) return false;
        // This looks like an autocorrection before Enter
        if (key.key == "Enter" && change && change.from < change.to && /^\S+$/.test(change.insert.toString())) return false;
        this.pendingIOSKey = undefined;
        return $7beee9608540d2c3$var$dispatchKey(this.view.contentDOM, key.key, key.keyCode, key instanceof KeyboardEvent ? key : undefined);
    }
    ignoreDuringComposition(event) {
        if (!/^key/.test(event.type) || event.synthetic) return false;
        if (this.composing > 0) return true;
        // See https://www.stum.de/2016/06/24/handling-ime-events-in-javascript/.
        // On some input method editors (IMEs), the Enter key is used to
        // confirm character selection. On Safari, when Enter is pressed,
        // compositionend and keydown events are sometimes emitted in the
        // wrong order. The key event should still be ignored, even when
        // it happens after the compositionend event.
        if ($7beee9608540d2c3$var$browser.safari && !$7beee9608540d2c3$var$browser.ios && this.compositionPendingKey && Date.now() - this.compositionEndedAt < 100) {
            this.compositionPendingKey = false;
            return true;
        }
        return false;
    }
    startMouseSelection(mouseSelection) {
        if (this.mouseSelection) this.mouseSelection.destroy();
        this.mouseSelection = mouseSelection;
    }
    update(update) {
        this.view.observer.update(update);
        if (this.mouseSelection) this.mouseSelection.update(update);
        if (this.draggedContent && update.docChanged) this.draggedContent = this.draggedContent.map(update.changes);
        if (update.transactions.length) this.lastKeyCode = this.lastSelectionTime = 0;
    }
    destroy() {
        if (this.mouseSelection) this.mouseSelection.destroy();
    }
}
function $7beee9608540d2c3$var$bindHandler(plugin, handler) {
    return (view, event)=>{
        try {
            return handler.call(plugin, event, view);
        } catch (e) {
            $7beee9608540d2c3$export$f86b2a1a2ce291b3(view.state, e);
        }
    };
}
function $7beee9608540d2c3$var$computeHandlers(plugins) {
    let result = Object.create(null);
    function record(type) {
        return result[type] || (result[type] = {
            observers: [],
            handlers: []
        });
    }
    for (let plugin of plugins){
        let spec = plugin.spec, handlers = spec && spec.plugin.domEventHandlers, observers = spec && spec.plugin.domEventObservers;
        if (handlers) for(let type in handlers){
            let f = handlers[type];
            if (f) record(type).handlers.push($7beee9608540d2c3$var$bindHandler(plugin.value, f));
        }
        if (observers) for(let type in observers){
            let f = observers[type];
            if (f) record(type).observers.push($7beee9608540d2c3$var$bindHandler(plugin.value, f));
        }
    }
    for(let type in $7beee9608540d2c3$var$handlers)record(type).handlers.push($7beee9608540d2c3$var$handlers[type]);
    for(let type in $7beee9608540d2c3$var$observers)record(type).observers.push($7beee9608540d2c3$var$observers[type]);
    return result;
}
const $7beee9608540d2c3$var$PendingKeys = [
    {
        key: "Backspace",
        keyCode: 8,
        inputType: "deleteContentBackward"
    },
    {
        key: "Enter",
        keyCode: 13,
        inputType: "insertParagraph"
    },
    {
        key: "Enter",
        keyCode: 13,
        inputType: "insertLineBreak"
    },
    {
        key: "Delete",
        keyCode: 46,
        inputType: "deleteContentForward"
    }
];
const $7beee9608540d2c3$var$EmacsyPendingKeys = "dthko";
// Key codes for modifier keys
const $7beee9608540d2c3$var$modifierCodes = [
    16,
    17,
    18,
    20,
    91,
    92,
    224,
    225
];
const $7beee9608540d2c3$var$dragScrollMargin = 6;
function $7beee9608540d2c3$var$dragScrollSpeed(dist) {
    return Math.max(0, dist) * 0.7 + 8;
}
function $7beee9608540d2c3$var$dist(a, b) {
    return Math.max(Math.abs(a.clientX - b.clientX), Math.abs(a.clientY - b.clientY));
}
class $7beee9608540d2c3$var$MouseSelection {
    constructor(view, startEvent, style, mustSelect){
        this.view = view;
        this.startEvent = startEvent;
        this.style = style;
        this.mustSelect = mustSelect;
        this.scrollSpeed = {
            x: 0,
            y: 0
        };
        this.scrolling = -1;
        this.lastEvent = startEvent;
        this.scrollParents = $7beee9608540d2c3$var$scrollableParents(view.contentDOM);
        this.atoms = view.state.facet($7beee9608540d2c3$var$atomicRanges).map((f)=>f(view));
        let doc = view.contentDOM.ownerDocument;
        doc.addEventListener("mousemove", this.move = this.move.bind(this));
        doc.addEventListener("mouseup", this.up = this.up.bind(this));
        this.extend = startEvent.shiftKey;
        this.multiple = view.state.facet((0, $6295c6875f57e3ee$export$afa855cbfaff27f2).allowMultipleSelections) && $7beee9608540d2c3$var$addsSelectionRange(view, startEvent);
        this.dragging = $7beee9608540d2c3$var$isInPrimarySelection(view, startEvent) && $7beee9608540d2c3$var$getClickType(startEvent) == 1 ? null : false;
    }
    start(event) {
        // When clicking outside of the selection, immediately apply the
        // effect of starting the selection
        if (this.dragging === false) this.select(event);
    }
    move(event) {
        if (event.buttons == 0) return this.destroy();
        if (this.dragging || this.dragging == null && $7beee9608540d2c3$var$dist(this.startEvent, event) < 10) return;
        this.select(this.lastEvent = event);
        let sx = 0, sy = 0;
        let left = 0, top = 0, right = this.view.win.innerWidth, bottom = this.view.win.innerHeight;
        if (this.scrollParents.x) ({ left: left, right: right } = this.scrollParents.x.getBoundingClientRect());
        if (this.scrollParents.y) ({ top: top, bottom: bottom } = this.scrollParents.y.getBoundingClientRect());
        let margins = $7beee9608540d2c3$var$getScrollMargins(this.view);
        if (event.clientX - margins.left <= left + $7beee9608540d2c3$var$dragScrollMargin) sx = -$7beee9608540d2c3$var$dragScrollSpeed(left - event.clientX);
        else if (event.clientX + margins.right >= right - $7beee9608540d2c3$var$dragScrollMargin) sx = $7beee9608540d2c3$var$dragScrollSpeed(event.clientX - right);
        if (event.clientY - margins.top <= top + $7beee9608540d2c3$var$dragScrollMargin) sy = -$7beee9608540d2c3$var$dragScrollSpeed(top - event.clientY);
        else if (event.clientY + margins.bottom >= bottom - $7beee9608540d2c3$var$dragScrollMargin) sy = $7beee9608540d2c3$var$dragScrollSpeed(event.clientY - bottom);
        this.setScrollSpeed(sx, sy);
    }
    up(event) {
        if (this.dragging == null) this.select(this.lastEvent);
        if (!this.dragging) event.preventDefault();
        this.destroy();
    }
    destroy() {
        this.setScrollSpeed(0, 0);
        let doc = this.view.contentDOM.ownerDocument;
        doc.removeEventListener("mousemove", this.move);
        doc.removeEventListener("mouseup", this.up);
        this.view.inputState.mouseSelection = this.view.inputState.draggedContent = null;
    }
    setScrollSpeed(sx, sy) {
        this.scrollSpeed = {
            x: sx,
            y: sy
        };
        if (sx || sy) {
            if (this.scrolling < 0) this.scrolling = setInterval(()=>this.scroll(), 50);
        } else if (this.scrolling > -1) {
            clearInterval(this.scrolling);
            this.scrolling = -1;
        }
    }
    scroll() {
        let { x: x, y: y } = this.scrollSpeed;
        if (x && this.scrollParents.x) {
            this.scrollParents.x.scrollLeft += x;
            x = 0;
        }
        if (y && this.scrollParents.y) {
            this.scrollParents.y.scrollTop += y;
            y = 0;
        }
        if (x || y) this.view.win.scrollBy(x, y);
        if (this.dragging === false) this.select(this.lastEvent);
    }
    select(event) {
        let { view: view } = this, selection = $7beee9608540d2c3$var$skipAtomsForSelection(this.atoms, this.style.get(event, this.extend, this.multiple));
        if (this.mustSelect || !selection.eq(view.state.selection, this.dragging === false)) this.view.dispatch({
            selection: selection,
            userEvent: "select.pointer"
        });
        this.mustSelect = false;
    }
    update(update) {
        if (update.transactions.some((tr)=>tr.isUserEvent("input.type"))) this.destroy();
        else if (this.style.update(update)) setTimeout(()=>this.select(this.lastEvent), 20);
    }
}
function $7beee9608540d2c3$var$addsSelectionRange(view, event) {
    let facet = view.state.facet($7beee9608540d2c3$var$clickAddsSelectionRange);
    return facet.length ? facet[0](event) : $7beee9608540d2c3$var$browser.mac ? event.metaKey : event.ctrlKey;
}
function $7beee9608540d2c3$var$dragMovesSelection(view, event) {
    let facet = view.state.facet($7beee9608540d2c3$var$dragMovesSelection$1);
    return facet.length ? facet[0](event) : $7beee9608540d2c3$var$browser.mac ? !event.altKey : !event.ctrlKey;
}
function $7beee9608540d2c3$var$isInPrimarySelection(view, event) {
    let { main: main } = view.state.selection;
    if (main.empty) return false;
    // On boundary clicks, check whether the coordinates are inside the
    // selection's client rectangles
    let sel = $7beee9608540d2c3$var$getSelection(view.root);
    if (!sel || sel.rangeCount == 0) return true;
    let rects = sel.getRangeAt(0).getClientRects();
    for(let i = 0; i < rects.length; i++){
        let rect = rects[i];
        if (rect.left <= event.clientX && rect.right >= event.clientX && rect.top <= event.clientY && rect.bottom >= event.clientY) return true;
    }
    return false;
}
function $7beee9608540d2c3$var$eventBelongsToEditor(view, event) {
    if (!event.bubbles) return true;
    if (event.defaultPrevented) return false;
    for(let node = event.target, tile; node != view.contentDOM; node = node.parentNode)if (!node || node.nodeType == 11 || (tile = $7beee9608540d2c3$var$Tile.get(node)) && tile.isWidget() && !tile.isHidden && tile.widget.ignoreEvent(event)) return false;
    return true;
}
const $7beee9608540d2c3$var$handlers = /*@__PURE__*/ Object.create(null);
const $7beee9608540d2c3$var$observers = /*@__PURE__*/ Object.create(null);
// This is very crude, but unfortunately both these browsers _pretend_
// that they have a clipboard API—all the objects and methods are
// there, they just don't work, and they are hard to test.
const $7beee9608540d2c3$var$brokenClipboardAPI = $7beee9608540d2c3$var$browser.ie && $7beee9608540d2c3$var$browser.ie_version < 15 || $7beee9608540d2c3$var$browser.ios && $7beee9608540d2c3$var$browser.webkit_version < 604;
function $7beee9608540d2c3$var$capturePaste(view) {
    let parent = view.dom.parentNode;
    if (!parent) return;
    let target = parent.appendChild(document.createElement("textarea"));
    target.style.cssText = "position: fixed; left: -10000px; top: 10px";
    target.focus();
    setTimeout(()=>{
        view.focus();
        target.remove();
        $7beee9608540d2c3$var$doPaste(view, target.value);
    }, 50);
}
function $7beee9608540d2c3$var$textFilter(state, facet, text) {
    for (let filter of state.facet(facet))text = filter(text, state);
    return text;
}
function $7beee9608540d2c3$var$doPaste(view, input) {
    input = $7beee9608540d2c3$var$textFilter(view.state, $7beee9608540d2c3$var$clipboardInputFilter, input);
    let { state: state } = view, changes, i = 1, text = state.toText(input);
    let byLine = text.lines == state.selection.ranges.length;
    let linewise = $7beee9608540d2c3$var$lastLinewiseCopy != null && state.selection.ranges.every((r)=>r.empty) && $7beee9608540d2c3$var$lastLinewiseCopy == text.toString();
    if (linewise) {
        let lastLine = -1;
        changes = state.changeByRange((range)=>{
            let line = state.doc.lineAt(range.from);
            if (line.from == lastLine) return {
                range: range
            };
            lastLine = line.from;
            let insert = state.toText((byLine ? text.line(i++).text : input) + state.lineBreak);
            return {
                changes: {
                    from: line.from,
                    insert: insert
                },
                range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(range.from + insert.length)
            };
        });
    } else if (byLine) changes = state.changeByRange((range)=>{
        let line = text.line(i++);
        return {
            changes: {
                from: range.from,
                to: range.to,
                insert: line.text
            },
            range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(range.from + line.length)
        };
    });
    else changes = state.replaceSelection(text);
    view.dispatch(changes, {
        userEvent: "input.paste",
        scrollIntoView: true
    });
}
$7beee9608540d2c3$var$observers.scroll = (view)=>{
    view.inputState.lastScrollTop = view.scrollDOM.scrollTop;
    view.inputState.lastScrollLeft = view.scrollDOM.scrollLeft;
};
$7beee9608540d2c3$var$observers.wheel = $7beee9608540d2c3$var$observers.mousewheel = (view)=>{
    view.inputState.lastWheelEvent = Date.now();
};
$7beee9608540d2c3$var$handlers.keydown = (view, event)=>{
    view.inputState.setSelectionOrigin("select");
    if (event.keyCode == 27 && view.inputState.tabFocusMode != 0) view.inputState.tabFocusMode = Date.now() + 2000;
    return false;
};
$7beee9608540d2c3$var$observers.touchstart = (view, e)=>{
    let iState = view.inputState, touch = e.targetTouches[0];
    iState.lastTouchTime = Date.now();
    if (touch) {
        iState.lastTouchX = touch.clientX;
        iState.lastTouchY = touch.clientY;
    }
    iState.setSelectionOrigin("select.pointer");
};
$7beee9608540d2c3$var$observers.touchmove = (view)=>{
    view.inputState.setSelectionOrigin("select.pointer");
};
$7beee9608540d2c3$var$handlers.mousedown = (view, event)=>{
    view.observer.flush();
    if (view.inputState.lastTouchTime > Date.now() - 2000) return false; // Ignore touch interaction
    let style = null;
    for (let makeStyle of view.state.facet($7beee9608540d2c3$var$mouseSelectionStyle)){
        style = makeStyle(view, event);
        if (style) break;
    }
    if (!style && event.button == 0) style = $7beee9608540d2c3$var$basicMouseSelection(view, event);
    if (style) {
        let mustFocus = !view.hasFocus;
        view.inputState.startMouseSelection(new $7beee9608540d2c3$var$MouseSelection(view, event, style, mustFocus));
        if (mustFocus) view.observer.ignore(()=>{
            $7beee9608540d2c3$var$focusPreventScroll(view.contentDOM);
            let active = view.root.activeElement;
            if (active && !active.contains(view.contentDOM)) active.blur();
        });
        let mouseSel = view.inputState.mouseSelection;
        if (mouseSel) {
            mouseSel.start(event);
            return mouseSel.dragging === false;
        }
    } else view.inputState.setSelectionOrigin("select.pointer");
    return false;
};
function $7beee9608540d2c3$var$rangeForClick(view, pos, bias, type) {
    if (type == 1) return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(pos, bias);
    else if (type == 2) return $7beee9608540d2c3$var$groupAt(view.state, pos, bias);
    else {
        let visual = view.docView.lineAt(pos, bias), line = view.state.doc.lineAt(visual ? visual.posAtEnd : pos);
        let from = visual ? visual.posAtStart : line.from, to = visual ? visual.posAtEnd : line.to;
        if (to < view.state.doc.length && to == line.to) to++;
        return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(from, to);
    }
}
const $7beee9608540d2c3$var$BadMouseDetail = $7beee9608540d2c3$var$browser.ie && $7beee9608540d2c3$var$browser.ie_version <= 11;
let $7beee9608540d2c3$var$lastMouseDown = null, $7beee9608540d2c3$var$lastMouseDownCount = 0, $7beee9608540d2c3$var$lastMouseDownTime = 0;
function $7beee9608540d2c3$var$getClickType(event) {
    if (!$7beee9608540d2c3$var$BadMouseDetail) return event.detail;
    let last = $7beee9608540d2c3$var$lastMouseDown, lastTime = $7beee9608540d2c3$var$lastMouseDownTime;
    $7beee9608540d2c3$var$lastMouseDown = event;
    $7beee9608540d2c3$var$lastMouseDownTime = Date.now();
    return $7beee9608540d2c3$var$lastMouseDownCount = !last || lastTime > Date.now() - 400 && Math.abs(last.clientX - event.clientX) < 2 && Math.abs(last.clientY - event.clientY) < 2 ? ($7beee9608540d2c3$var$lastMouseDownCount + 1) % 3 : 1;
}
function $7beee9608540d2c3$var$basicMouseSelection(view, event) {
    let start = view.posAndSideAtCoords({
        x: event.clientX,
        y: event.clientY
    }, false), type = $7beee9608540d2c3$var$getClickType(event);
    let startSel = view.state.selection;
    return {
        update (update) {
            if (update.docChanged) {
                start.pos = update.changes.mapPos(start.pos);
                startSel = startSel.map(update.changes);
            }
        },
        get (event, extend, multiple) {
            let cur = view.posAndSideAtCoords({
                x: event.clientX,
                y: event.clientY
            }, false), removed;
            let range = $7beee9608540d2c3$var$rangeForClick(view, cur.pos, cur.assoc, type);
            if (start.pos != cur.pos && !extend) {
                let startRange = $7beee9608540d2c3$var$rangeForClick(view, start.pos, start.assoc, type);
                let from = Math.min(startRange.from, range.from), to = Math.max(startRange.to, range.to);
                range = from < range.from ? (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(from, to, range.assoc) : (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(to, from, range.assoc);
            }
            if (extend) return startSel.replaceRange(startSel.main.extend(range.from, range.to, range.assoc));
            else if (multiple && type == 1 && startSel.ranges.length > 1 && (removed = $7beee9608540d2c3$var$removeRangeAround(startSel, cur.pos))) return removed;
            else if (multiple) return startSel.addRange(range);
            else return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create([
                range
            ]);
        }
    };
}
function $7beee9608540d2c3$var$removeRangeAround(sel, pos) {
    for(let i = 0; i < sel.ranges.length; i++){
        let { from: from, to: to } = sel.ranges[i];
        if (from <= pos && to >= pos) return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create(sel.ranges.slice(0, i).concat(sel.ranges.slice(i + 1)), sel.mainIndex == i ? 0 : sel.mainIndex - (sel.mainIndex > i ? 1 : 0));
    }
    return null;
}
$7beee9608540d2c3$var$handlers.dragstart = (view, event)=>{
    let { selection: { main: range } } = view.state;
    if (event.target.draggable) {
        let tile = view.docView.tile.nearest(event.target);
        if (tile && tile.isWidget()) {
            let from = tile.posAtStart, to = from + tile.length;
            if (from >= range.to || to <= range.from) range = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(from, to);
        }
    }
    let { inputState: inputState } = view;
    if (inputState.mouseSelection) inputState.mouseSelection.dragging = true;
    inputState.draggedContent = range;
    if (event.dataTransfer) {
        event.dataTransfer.setData("Text", $7beee9608540d2c3$var$textFilter(view.state, $7beee9608540d2c3$var$clipboardOutputFilter, view.state.sliceDoc(range.from, range.to)));
        event.dataTransfer.effectAllowed = "copyMove";
    }
    return false;
};
$7beee9608540d2c3$var$handlers.dragend = (view)=>{
    view.inputState.draggedContent = null;
    return false;
};
function $7beee9608540d2c3$var$dropText(view, event, text, direct) {
    text = $7beee9608540d2c3$var$textFilter(view.state, $7beee9608540d2c3$var$clipboardInputFilter, text);
    if (!text) return;
    let dropPos = view.posAtCoords({
        x: event.clientX,
        y: event.clientY
    }, false);
    let { draggedContent: draggedContent } = view.inputState;
    let del = direct && draggedContent && $7beee9608540d2c3$var$dragMovesSelection(view, event) ? {
        from: draggedContent.from,
        to: draggedContent.to
    } : null;
    let ins = {
        from: dropPos,
        insert: text
    };
    let changes = view.state.changes(del ? [
        del,
        ins
    ] : ins);
    view.focus();
    view.dispatch({
        changes: changes,
        selection: {
            anchor: changes.mapPos(dropPos, -1),
            head: changes.mapPos(dropPos, 1)
        },
        userEvent: del ? "move.drop" : "input.drop"
    });
    view.inputState.draggedContent = null;
}
$7beee9608540d2c3$var$handlers.drop = (view, event)=>{
    if (!event.dataTransfer) return false;
    if (view.state.readOnly) return true;
    let files = event.dataTransfer.files;
    if (files && files.length) {
        let text = Array(files.length), read = 0;
        let finishFile = ()=>{
            if (++read == files.length) $7beee9608540d2c3$var$dropText(view, event, text.filter((s)=>s != null).join(view.state.lineBreak), false);
        };
        for(let i = 0; i < files.length; i++){
            let reader = new FileReader;
            reader.onerror = finishFile;
            reader.onload = ()=>{
                if (!/[\x00-\x08\x0e-\x1f]{2}/.test(reader.result)) text[i] = reader.result;
                finishFile();
            };
            reader.readAsText(files[i]);
        }
        return true;
    } else {
        let text = event.dataTransfer.getData("Text");
        if (text) {
            $7beee9608540d2c3$var$dropText(view, event, text, true);
            return true;
        }
    }
    return false;
};
$7beee9608540d2c3$var$handlers.paste = (view, event)=>{
    if (view.state.readOnly) return true;
    view.observer.flush();
    let data = $7beee9608540d2c3$var$brokenClipboardAPI ? null : event.clipboardData;
    if (data) {
        $7beee9608540d2c3$var$doPaste(view, data.getData("text/plain") || data.getData("text/uri-list"));
        return true;
    } else {
        $7beee9608540d2c3$var$capturePaste(view);
        return false;
    }
};
function $7beee9608540d2c3$var$captureCopy(view, text) {
    // The extra wrapper is somehow necessary on IE/Edge to prevent the
    // content from being mangled when it is put onto the clipboard
    let parent = view.dom.parentNode;
    if (!parent) return;
    let target = parent.appendChild(document.createElement("textarea"));
    target.style.cssText = "position: fixed; left: -10000px; top: 10px";
    target.value = text;
    target.focus();
    target.selectionEnd = text.length;
    target.selectionStart = 0;
    setTimeout(()=>{
        target.remove();
        view.focus();
    }, 50);
}
function $7beee9608540d2c3$var$copiedRange(state) {
    let content = [], ranges = [], linewise = false;
    for (let range of state.selection.ranges)if (!range.empty) {
        content.push(state.sliceDoc(range.from, range.to));
        ranges.push(range);
    }
    if (!content.length) {
        // Nothing selected, do a line-wise copy
        let upto = -1;
        for (let { from: from } of state.selection.ranges){
            let line = state.doc.lineAt(from);
            if (line.number > upto) {
                content.push(line.text);
                ranges.push({
                    from: line.from,
                    to: Math.min(state.doc.length, line.to + 1)
                });
            }
            upto = line.number;
        }
        linewise = true;
    }
    return {
        text: $7beee9608540d2c3$var$textFilter(state, $7beee9608540d2c3$var$clipboardOutputFilter, content.join(state.lineBreak)),
        ranges: ranges,
        linewise: linewise
    };
}
let $7beee9608540d2c3$var$lastLinewiseCopy = null;
$7beee9608540d2c3$var$handlers.copy = $7beee9608540d2c3$var$handlers.cut = (view, event)=>{
    // If the DOM selection is outside this editor, don't intercept.
    // This happens when a parent editor (like ProseMirror) selects content that
    // spans multiple elements including this CodeMirror. The copy event may
    // bubble through CodeMirror (e.g. when CodeMirror is the first or the last
    // element in the selection), but we should let the parent handle it.
    if (!$7beee9608540d2c3$var$hasSelection(view.contentDOM, view.observer.selectionRange)) return false;
    let { text: text, ranges: ranges, linewise: linewise } = $7beee9608540d2c3$var$copiedRange(view.state);
    if (!text && !linewise) return false;
    $7beee9608540d2c3$var$lastLinewiseCopy = linewise ? text : null;
    if (event.type == "cut" && !view.state.readOnly) view.dispatch({
        changes: ranges,
        scrollIntoView: true,
        userEvent: "delete.cut"
    });
    let data = $7beee9608540d2c3$var$brokenClipboardAPI ? null : event.clipboardData;
    if (data) {
        data.clearData();
        data.setData("text/plain", text);
        return true;
    } else {
        $7beee9608540d2c3$var$captureCopy(view, text);
        return false;
    }
};
const $7beee9608540d2c3$var$isFocusChange = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$9279461326b8700a).define();
function $7beee9608540d2c3$var$focusChangeTransaction(state, focus) {
    let effects = [];
    for (let getEffect of state.facet($7beee9608540d2c3$var$focusChangeEffect)){
        let effect = getEffect(state, focus);
        if (effect) effects.push(effect);
    }
    return effects.length ? state.update({
        effects: effects,
        annotations: $7beee9608540d2c3$var$isFocusChange.of(true)
    }) : null;
}
function $7beee9608540d2c3$var$updateForFocusChange(view) {
    setTimeout(()=>{
        let focus = view.hasFocus;
        if (focus != view.inputState.notifiedFocused) {
            let tr = $7beee9608540d2c3$var$focusChangeTransaction(view.state, focus);
            if (tr) view.dispatch(tr);
            else view.update([]);
        }
    }, 10);
}
$7beee9608540d2c3$var$observers.focus = (view)=>{
    view.inputState.lastFocusTime = Date.now();
    // When focusing reset the scroll position, move it back to where it was
    if (!view.scrollDOM.scrollTop && (view.inputState.lastScrollTop || view.inputState.lastScrollLeft)) {
        view.scrollDOM.scrollTop = view.inputState.lastScrollTop;
        view.scrollDOM.scrollLeft = view.inputState.lastScrollLeft;
    }
    $7beee9608540d2c3$var$updateForFocusChange(view);
};
$7beee9608540d2c3$var$observers.blur = (view)=>{
    view.observer.clearSelectionRange();
    $7beee9608540d2c3$var$updateForFocusChange(view);
};
$7beee9608540d2c3$var$observers.compositionstart = $7beee9608540d2c3$var$observers.compositionupdate = (view)=>{
    if (view.observer.editContext) return; // Composition handled by edit context
    if (view.inputState.compositionFirstChange == null) view.inputState.compositionFirstChange = true;
    if (view.inputState.composing < 0) // FIXME possibly set a timeout to clear it again on Android
    view.inputState.composing = 0;
};
$7beee9608540d2c3$var$observers.compositionend = (view)=>{
    if (view.observer.editContext) return; // Composition handled by edit context
    view.inputState.composing = -1;
    view.inputState.compositionEndedAt = Date.now();
    view.inputState.compositionPendingKey = true;
    view.inputState.compositionPendingChange = view.observer.pendingRecords().length > 0;
    view.inputState.compositionFirstChange = null;
    if ($7beee9608540d2c3$var$browser.chrome && $7beee9608540d2c3$var$browser.android) // Delay flushing for a bit on Android because it'll often fire a
    // bunch of contradictory changes in a row at end of composition
    view.observer.flushSoon();
    else if (view.inputState.compositionPendingChange) // If we found pending records, schedule a flush.
    Promise.resolve().then(()=>view.observer.flush());
    else // Otherwise, make sure that, if no changes come in soon, the
    // composition view is cleared.
    setTimeout(()=>{
        if (view.inputState.composing < 0 && view.docView.hasComposition) view.update([]);
    }, 50);
};
$7beee9608540d2c3$var$observers.contextmenu = (view)=>{
    view.inputState.lastContextMenu = Date.now();
};
$7beee9608540d2c3$var$handlers.beforeinput = (view, event)=>{
    var _a, _b;
    if (event.inputType == "insertText" || event.inputType == "insertCompositionText") {
        view.inputState.insertingText = event.data;
        view.inputState.insertingTextAt = Date.now();
    }
    // In EditContext mode, we must handle insertReplacementText events
    // directly, to make spell checking corrections work
    if (event.inputType == "insertReplacementText" && view.observer.editContext) {
        let text = (_a = event.dataTransfer) === null || _a === void 0 ? void 0 : _a.getData("text/plain"), ranges = event.getTargetRanges();
        if (text && ranges.length) {
            let r = ranges[0];
            let from = view.posAtDOM(r.startContainer, r.startOffset), to = view.posAtDOM(r.endContainer, r.endOffset);
            $7beee9608540d2c3$var$applyDOMChangeInner(view, {
                from: from,
                to: to,
                insert: view.state.toText(text)
            }, null);
            return true;
        }
    }
    // Because Chrome Android doesn't fire useful key events, use
    // beforeinput to detect backspace (and possibly enter and delete,
    // but those usually don't even seem to fire beforeinput events at
    // the moment) and fake a key event for it.
    //
    // (preventDefault on beforeinput, though supported in the spec,
    // seems to do nothing at all on Chrome).
    let pending;
    if ($7beee9608540d2c3$var$browser.chrome && $7beee9608540d2c3$var$browser.android && (pending = $7beee9608540d2c3$var$PendingKeys.find((key)=>key.inputType == event.inputType))) {
        view.observer.delayAndroidKey(pending.key, pending.keyCode);
        if (pending.key == "Backspace" || pending.key == "Delete") {
            let startViewHeight = ((_b = window.visualViewport) === null || _b === void 0 ? void 0 : _b.height) || 0;
            setTimeout(()=>{
                var _a;
                // Backspacing near uneditable nodes on Chrome Android sometimes
                // closes the virtual keyboard. This tries to crudely detect
                // that and refocus to get it back.
                if ((((_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.height) || 0) > startViewHeight + 10 && view.hasFocus) {
                    view.contentDOM.blur();
                    view.focus();
                }
            }, 100);
        }
    }
    if ($7beee9608540d2c3$var$browser.ios && event.inputType == "deleteContentForward") // For some reason, DOM changes (and beforeinput) happen _before_
    // the key event for ctrl-d on iOS when using an external
    // keyboard.
    view.observer.flushSoon();
    // Safari will occasionally forget to fire compositionend at the end of a dead-key composition
    if ($7beee9608540d2c3$var$browser.safari && event.inputType == "insertText" && view.inputState.composing >= 0) setTimeout(()=>$7beee9608540d2c3$var$observers.compositionend(view, event), 20);
    return false;
};
const $7beee9608540d2c3$var$appliedFirefoxHack = /*@__PURE__*/ new Set;
// In Firefox, when cut/copy handlers are added to the document, that
// somehow avoids a bug where those events aren't fired when the
// selection is empty. See issue #1082 and
// https://bugzilla.mozilla.org/show_bug.cgi?id=995961
function $7beee9608540d2c3$var$firefoxCopyCutHack(doc) {
    if (!$7beee9608540d2c3$var$appliedFirefoxHack.has(doc)) {
        $7beee9608540d2c3$var$appliedFirefoxHack.add(doc);
        doc.addEventListener("copy", ()=>{});
        doc.addEventListener("cut", ()=>{});
    }
}
const $7beee9608540d2c3$var$wrappingWhiteSpace = [
    "pre-wrap",
    "normal",
    "pre-line",
    "break-spaces"
];
// Used to track, during updateHeight, if any actual heights changed
let $7beee9608540d2c3$var$heightChangeFlag = false;
function $7beee9608540d2c3$var$clearHeightChangeFlag() {
    $7beee9608540d2c3$var$heightChangeFlag = false;
}
class $7beee9608540d2c3$var$HeightOracle {
    constructor(lineWrapping){
        this.lineWrapping = lineWrapping;
        this.doc = (0, $6295c6875f57e3ee$export$5f1af8db9871e1d6).empty;
        this.heightSamples = {};
        this.lineHeight = 14; // The height of an entire line (line-height)
        this.charWidth = 7;
        this.textHeight = 14; // The height of the actual font (font-size)
        this.lineLength = 30;
    }
    heightForGap(from, to) {
        let lines = this.doc.lineAt(to).number - this.doc.lineAt(from).number + 1;
        if (this.lineWrapping) lines += Math.max(0, Math.ceil((to - from - lines * this.lineLength * 0.5) / this.lineLength));
        return this.lineHeight * lines;
    }
    heightForLine(length) {
        if (!this.lineWrapping) return this.lineHeight;
        let lines = 1 + Math.max(0, Math.ceil((length - this.lineLength) / Math.max(1, this.lineLength - 5)));
        return lines * this.lineHeight;
    }
    setDoc(doc) {
        this.doc = doc;
        return this;
    }
    mustRefreshForWrapping(whiteSpace) {
        return $7beee9608540d2c3$var$wrappingWhiteSpace.indexOf(whiteSpace) > -1 != this.lineWrapping;
    }
    mustRefreshForHeights(lineHeights) {
        let newHeight = false;
        for(let i = 0; i < lineHeights.length; i++){
            let h = lineHeights[i];
            if (h < 0) i++;
            else if (!this.heightSamples[Math.floor(h * 10)]) {
                newHeight = true;
                this.heightSamples[Math.floor(h * 10)] = true;
            }
        }
        return newHeight;
    }
    refresh(whiteSpace, lineHeight, charWidth, textHeight, lineLength, knownHeights) {
        let lineWrapping = $7beee9608540d2c3$var$wrappingWhiteSpace.indexOf(whiteSpace) > -1;
        let changed = Math.abs(lineHeight - this.lineHeight) > 0.3 || this.lineWrapping != lineWrapping;
        this.lineWrapping = lineWrapping;
        this.lineHeight = lineHeight;
        this.charWidth = charWidth;
        this.textHeight = textHeight;
        this.lineLength = lineLength;
        if (changed) {
            this.heightSamples = {};
            for(let i = 0; i < knownHeights.length; i++){
                let h = knownHeights[i];
                if (h < 0) i++;
                else this.heightSamples[Math.floor(h * 10)] = true;
            }
        }
        return changed;
    }
}
// This object is used by `updateHeight` to make DOM measurements
// arrive at the right nodes. The `heights` array is a sequence of
// block heights, starting from position `from`.
class $7beee9608540d2c3$var$MeasuredHeights {
    constructor(from, heights){
        this.from = from;
        this.heights = heights;
        this.index = 0;
    }
    get more() {
        return this.index < this.heights.length;
    }
}
/**
Record used to represent information about a block-level element
in the editor view.
*/ class $7beee9608540d2c3$export$ddfdc4ccfe9512bd {
    /**
    @internal
    */ constructor(/**
    The start of the element in the document.
    */ from, /**
    The length of the element.
    */ length, /**
    The top position of the element (relative to the top of the
    document).
    */ top, /**
    Its height.
    */ height, /**
    @internal Weird packed field that holds an array of children
    for composite blocks, a decoration for block widgets, and a
    number indicating the amount of widget-created line breaks for
    text blocks.
    */ _content){
        this.from = from;
        this.length = length;
        this.top = top;
        this.height = height;
        this._content = _content;
    }
    /**
    The type of element this is. When querying lines, this may be
    an array of all the blocks that make up the line.
    */ get type() {
        return typeof this._content == "number" ? $7beee9608540d2c3$export$48808c686fe495c4.Text : Array.isArray(this._content) ? this._content : this._content.type;
    }
    /**
    The end of the element as a document position.
    */ get to() {
        return this.from + this.length;
    }
    /**
    The bottom position of the element.
    */ get bottom() {
        return this.top + this.height;
    }
    /**
    If this is a widget block, this will return the widget
    associated with it.
    */ get widget() {
        return this._content instanceof $7beee9608540d2c3$var$PointDecoration ? this._content.widget : null;
    }
    /**
    If this is a textblock, this holds the number of line breaks
    that appear in widgets inside the block.
    */ get widgetLineBreaks() {
        return typeof this._content == "number" ? this._content : 0;
    }
    /**
    @internal
    */ join(other) {
        let content = (Array.isArray(this._content) ? this._content : [
            this
        ]).concat(Array.isArray(other._content) ? other._content : [
            other
        ]);
        return new $7beee9608540d2c3$export$ddfdc4ccfe9512bd(this.from, this.length + other.length, this.top, this.height + other.height, content);
    }
}
var $7beee9608540d2c3$var$QueryType = /*@__PURE__*/ function(QueryType) {
    QueryType[QueryType["ByPos"] = 0] = "ByPos";
    QueryType[QueryType["ByHeight"] = 1] = "ByHeight";
    QueryType[QueryType["ByPosNoHeight"] = 2] = "ByPosNoHeight";
    return QueryType;
}($7beee9608540d2c3$var$QueryType || ($7beee9608540d2c3$var$QueryType = {}));
const $7beee9608540d2c3$var$Epsilon = 1e-3;
class $7beee9608540d2c3$var$HeightMap {
    constructor(length, height, flags = 2 /* Flag.Outdated */ ){
        this.length = length;
        this.height = height;
        this.flags = flags;
    }
    get outdated() {
        return (this.flags & 2 /* Flag.Outdated */ ) > 0;
    }
    set outdated(value) {
        this.flags = (value ? 2 /* Flag.Outdated */  : 0) | this.flags & -3 /* Flag.Outdated */ ;
    }
    setHeight(height) {
        if (this.height != height) {
            if (Math.abs(this.height - height) > $7beee9608540d2c3$var$Epsilon) $7beee9608540d2c3$var$heightChangeFlag = true;
            this.height = height;
        }
    }
    // Base case is to replace a leaf node, which simply builds a tree
    // from the new nodes and returns that (HeightMapBranch and
    // HeightMapGap override this to actually use from/to)
    replace(_from, _to, nodes) {
        return $7beee9608540d2c3$var$HeightMap.of(nodes);
    }
    // Again, these are base cases, and are overridden for branch and gap nodes.
    decomposeLeft(_to, result) {
        result.push(this);
    }
    decomposeRight(_from, result) {
        result.push(this);
    }
    applyChanges(decorations, oldDoc, oracle, changes) {
        let me = this, doc = oracle.doc;
        for(let i = changes.length - 1; i >= 0; i--){
            let { fromA: fromA, toA: toA, fromB: fromB, toB: toB } = changes[i];
            let start = me.lineAt(fromA, $7beee9608540d2c3$var$QueryType.ByPosNoHeight, oracle.setDoc(oldDoc), 0, 0);
            let end = start.to >= toA ? start : me.lineAt(toA, $7beee9608540d2c3$var$QueryType.ByPosNoHeight, oracle, 0, 0);
            toB += end.to - toA;
            toA = end.to;
            while(i > 0 && start.from <= changes[i - 1].toA){
                fromA = changes[i - 1].fromA;
                fromB = changes[i - 1].fromB;
                i--;
                if (fromA < start.from) start = me.lineAt(fromA, $7beee9608540d2c3$var$QueryType.ByPosNoHeight, oracle, 0, 0);
            }
            fromB += start.from - fromA;
            fromA = start.from;
            let nodes = $7beee9608540d2c3$var$NodeBuilder.build(oracle.setDoc(doc), decorations, fromB, toB);
            me = $7beee9608540d2c3$var$replace(me, me.replace(fromA, toA, nodes));
        }
        return me.updateHeight(oracle, 0);
    }
    static empty() {
        return new $7beee9608540d2c3$var$HeightMapText(0, 0, 0);
    }
    // nodes uses null values to indicate the position of line breaks.
    // There are never line breaks at the start or end of the array, or
    // two line breaks next to each other, and the array isn't allowed
    // to be empty (same restrictions as return value from the builder).
    static of(nodes) {
        if (nodes.length == 1) return nodes[0];
        let i = 0, j = nodes.length, before = 0, after = 0;
        for(;;){
            if (i == j) {
                if (before > after * 2) {
                    let split = nodes[i - 1];
                    if (split.break) nodes.splice(--i, 1, split.left, null, split.right);
                    else nodes.splice(--i, 1, split.left, split.right);
                    j += 1 + split.break;
                    before -= split.size;
                } else if (after > before * 2) {
                    let split = nodes[j];
                    if (split.break) nodes.splice(j, 1, split.left, null, split.right);
                    else nodes.splice(j, 1, split.left, split.right);
                    j += 2 + split.break;
                    after -= split.size;
                } else break;
            } else if (before < after) {
                let next = nodes[i++];
                if (next) before += next.size;
            } else {
                let next = nodes[--j];
                if (next) after += next.size;
            }
        }
        let brk = 0;
        if (nodes[i - 1] == null) {
            brk = 1;
            i--;
        } else if (nodes[i] == null) {
            brk = 1;
            j++;
        }
        return new $7beee9608540d2c3$var$HeightMapBranch($7beee9608540d2c3$var$HeightMap.of(nodes.slice(0, i)), brk, $7beee9608540d2c3$var$HeightMap.of(nodes.slice(j)));
    }
}
function $7beee9608540d2c3$var$replace(old, val) {
    if (old == val) return old;
    if (old.constructor != val.constructor) $7beee9608540d2c3$var$heightChangeFlag = true;
    return val;
}
$7beee9608540d2c3$var$HeightMap.prototype.size = 1;
const $7beee9608540d2c3$var$SpaceDeco = /*@__PURE__*/ $7beee9608540d2c3$export$10e30b733df217ea.replace({});
class $7beee9608540d2c3$var$HeightMapBlock extends $7beee9608540d2c3$var$HeightMap {
    constructor(length, height, deco){
        super(length, height);
        this.deco = deco;
        this.spaceAbove = 0;
    }
    mainBlock(top, offset) {
        return new $7beee9608540d2c3$export$ddfdc4ccfe9512bd(offset, this.length, top + this.spaceAbove, this.height - this.spaceAbove, this.deco || 0);
    }
    blockAt(height, _oracle, top, offset) {
        return this.spaceAbove && height < top + this.spaceAbove ? new $7beee9608540d2c3$export$ddfdc4ccfe9512bd(offset, 0, top, this.spaceAbove, $7beee9608540d2c3$var$SpaceDeco) : this.mainBlock(top, offset);
    }
    lineAt(_value, _type, oracle, top, offset) {
        let main = this.mainBlock(top, offset);
        return this.spaceAbove ? this.blockAt(0, oracle, top, offset).join(main) : main;
    }
    forEachLine(from, to, oracle, top, offset, f) {
        if (from <= offset + this.length && to >= offset) f(this.lineAt(0, $7beee9608540d2c3$var$QueryType.ByPos, oracle, top, offset));
    }
    setMeasuredHeight(measured) {
        let next = measured.heights[measured.index++];
        if (next < 0) {
            this.spaceAbove = -next;
            next = measured.heights[measured.index++];
        } else this.spaceAbove = 0;
        this.setHeight(next);
    }
    updateHeight(oracle, offset = 0, _force = false, measured) {
        if (measured && measured.from <= offset && measured.more) this.setMeasuredHeight(measured);
        this.outdated = false;
        return this;
    }
    toString() {
        return `block(${this.length})`;
    }
}
class $7beee9608540d2c3$var$HeightMapText extends $7beee9608540d2c3$var$HeightMapBlock {
    constructor(length, height, above){
        super(length, height, null);
        this.collapsed = 0; // Amount of collapsed content in the line
        this.widgetHeight = 0; // Maximum inline widget height
        this.breaks = 0; // Number of widget-introduced line breaks on the line
        this.spaceAbove = above;
    }
    mainBlock(top, offset) {
        return new $7beee9608540d2c3$export$ddfdc4ccfe9512bd(offset, this.length, top + this.spaceAbove, this.height - this.spaceAbove, this.breaks);
    }
    replace(_from, _to, nodes) {
        let node = nodes[0];
        if (nodes.length == 1 && (node instanceof $7beee9608540d2c3$var$HeightMapText || node instanceof $7beee9608540d2c3$var$HeightMapGap && node.flags & 4 /* Flag.SingleLine */ ) && Math.abs(this.length - node.length) < 10) {
            if (node instanceof $7beee9608540d2c3$var$HeightMapGap) node = new $7beee9608540d2c3$var$HeightMapText(node.length, this.height, this.spaceAbove);
            else node.height = this.height;
            if (!this.outdated) node.outdated = false;
            return node;
        } else return $7beee9608540d2c3$var$HeightMap.of(nodes);
    }
    updateHeight(oracle, offset = 0, force = false, measured) {
        if (measured && measured.from <= offset && measured.more) this.setMeasuredHeight(measured);
        else if (force || this.outdated) {
            this.spaceAbove = 0;
            this.setHeight(Math.max(this.widgetHeight, oracle.heightForLine(this.length - this.collapsed)) + this.breaks * oracle.lineHeight);
        }
        this.outdated = false;
        return this;
    }
    toString() {
        return `line(${this.length}${this.collapsed ? -this.collapsed : ""}${this.widgetHeight ? ":" + this.widgetHeight : ""})`;
    }
}
class $7beee9608540d2c3$var$HeightMapGap extends $7beee9608540d2c3$var$HeightMap {
    constructor(length){
        super(length, 0);
    }
    heightMetrics(oracle, offset) {
        let firstLine = oracle.doc.lineAt(offset).number, lastLine = oracle.doc.lineAt(offset + this.length).number;
        let lines = lastLine - firstLine + 1;
        let perLine, perChar = 0;
        if (oracle.lineWrapping) {
            let totalPerLine = Math.min(this.height, oracle.lineHeight * lines);
            perLine = totalPerLine / lines;
            if (this.length > lines + 1) perChar = (this.height - totalPerLine) / (this.length - lines - 1);
        } else perLine = this.height / lines;
        return {
            firstLine: firstLine,
            lastLine: lastLine,
            perLine: perLine,
            perChar: perChar
        };
    }
    blockAt(height, oracle, top, offset) {
        let { firstLine: firstLine, lastLine: lastLine, perLine: perLine, perChar: perChar } = this.heightMetrics(oracle, offset);
        if (oracle.lineWrapping) {
            let guess = offset + (height < oracle.lineHeight ? 0 : Math.round(Math.max(0, Math.min(1, (height - top) / this.height)) * this.length));
            let line = oracle.doc.lineAt(guess), lineHeight = perLine + line.length * perChar;
            let lineTop = Math.max(top, height - lineHeight / 2);
            return new $7beee9608540d2c3$export$ddfdc4ccfe9512bd(line.from, line.length, lineTop, lineHeight, 0);
        } else {
            let line = Math.max(0, Math.min(lastLine - firstLine, Math.floor((height - top) / perLine)));
            let { from: from, length: length } = oracle.doc.line(firstLine + line);
            return new $7beee9608540d2c3$export$ddfdc4ccfe9512bd(from, length, top + perLine * line, perLine, 0);
        }
    }
    lineAt(value, type, oracle, top, offset) {
        if (type == $7beee9608540d2c3$var$QueryType.ByHeight) return this.blockAt(value, oracle, top, offset);
        if (type == $7beee9608540d2c3$var$QueryType.ByPosNoHeight) {
            let { from: from, to: to } = oracle.doc.lineAt(value);
            return new $7beee9608540d2c3$export$ddfdc4ccfe9512bd(from, to - from, 0, 0, 0);
        }
        let { firstLine: firstLine, perLine: perLine, perChar: perChar } = this.heightMetrics(oracle, offset);
        let line = oracle.doc.lineAt(value), lineHeight = perLine + line.length * perChar;
        let linesAbove = line.number - firstLine;
        let lineTop = top + perLine * linesAbove + perChar * (line.from - offset - linesAbove);
        return new $7beee9608540d2c3$export$ddfdc4ccfe9512bd(line.from, line.length, Math.max(top, Math.min(lineTop, top + this.height - lineHeight)), lineHeight, 0);
    }
    forEachLine(from, to, oracle, top, offset, f) {
        from = Math.max(from, offset);
        to = Math.min(to, offset + this.length);
        let { firstLine: firstLine, perLine: perLine, perChar: perChar } = this.heightMetrics(oracle, offset);
        for(let pos = from, lineTop = top; pos <= to;){
            let line = oracle.doc.lineAt(pos);
            if (pos == from) {
                let linesAbove = line.number - firstLine;
                lineTop += perLine * linesAbove + perChar * (from - offset - linesAbove);
            }
            let lineHeight = perLine + perChar * line.length;
            f(new $7beee9608540d2c3$export$ddfdc4ccfe9512bd(line.from, line.length, lineTop, lineHeight, 0));
            lineTop += lineHeight;
            pos = line.to + 1;
        }
    }
    replace(from, to, nodes) {
        let after = this.length - to;
        if (after > 0) {
            let last = nodes[nodes.length - 1];
            if (last instanceof $7beee9608540d2c3$var$HeightMapGap) nodes[nodes.length - 1] = new $7beee9608540d2c3$var$HeightMapGap(last.length + after);
            else nodes.push(null, new $7beee9608540d2c3$var$HeightMapGap(after - 1));
        }
        if (from > 0) {
            let first = nodes[0];
            if (first instanceof $7beee9608540d2c3$var$HeightMapGap) nodes[0] = new $7beee9608540d2c3$var$HeightMapGap(from + first.length);
            else nodes.unshift(new $7beee9608540d2c3$var$HeightMapGap(from - 1), null);
        }
        return $7beee9608540d2c3$var$HeightMap.of(nodes);
    }
    decomposeLeft(to, result) {
        result.push(new $7beee9608540d2c3$var$HeightMapGap(to - 1), null);
    }
    decomposeRight(from, result) {
        result.push(null, new $7beee9608540d2c3$var$HeightMapGap(this.length - from - 1));
    }
    updateHeight(oracle, offset = 0, force = false, measured) {
        let end = offset + this.length;
        if (measured && measured.from <= offset + this.length && measured.more) {
            // Fill in part of this gap with measured lines. We know there
            // can't be widgets or collapsed ranges in those lines, because
            // they would already have been added to the heightmap (gaps
            // only contain plain text).
            let nodes = [], pos = Math.max(offset, measured.from), singleHeight = -1;
            if (measured.from > offset) nodes.push(new $7beee9608540d2c3$var$HeightMapGap(measured.from - offset - 1).updateHeight(oracle, offset));
            while(pos <= end && measured.more){
                let len = oracle.doc.lineAt(pos).length;
                if (nodes.length) nodes.push(null);
                let height = measured.heights[measured.index++], above = 0;
                if (height < 0) {
                    above = -height;
                    height = measured.heights[measured.index++];
                }
                if (singleHeight == -1) singleHeight = height;
                else if (Math.abs(height - singleHeight) >= $7beee9608540d2c3$var$Epsilon) singleHeight = -2;
                let line = new $7beee9608540d2c3$var$HeightMapText(len, height, above);
                line.outdated = false;
                nodes.push(line);
                pos += len + 1;
            }
            if (pos <= end) nodes.push(null, new $7beee9608540d2c3$var$HeightMapGap(end - pos).updateHeight(oracle, pos));
            let result = $7beee9608540d2c3$var$HeightMap.of(nodes);
            if (singleHeight < 0 || Math.abs(result.height - this.height) >= $7beee9608540d2c3$var$Epsilon || Math.abs(singleHeight - this.heightMetrics(oracle, offset).perLine) >= $7beee9608540d2c3$var$Epsilon) $7beee9608540d2c3$var$heightChangeFlag = true;
            return $7beee9608540d2c3$var$replace(this, result);
        } else if (force || this.outdated) {
            this.setHeight(oracle.heightForGap(offset, offset + this.length));
            this.outdated = false;
        }
        return this;
    }
    toString() {
        return `gap(${this.length})`;
    }
}
class $7beee9608540d2c3$var$HeightMapBranch extends $7beee9608540d2c3$var$HeightMap {
    constructor(left, brk, right){
        super(left.length + brk + right.length, left.height + right.height, brk | (left.outdated || right.outdated ? 2 /* Flag.Outdated */  : 0));
        this.left = left;
        this.right = right;
        this.size = left.size + right.size;
    }
    get break() {
        return this.flags & 1 /* Flag.Break */ ;
    }
    blockAt(height, oracle, top, offset) {
        let mid = top + this.left.height;
        return height < mid ? this.left.blockAt(height, oracle, top, offset) : this.right.blockAt(height, oracle, mid, offset + this.left.length + this.break);
    }
    lineAt(value, type, oracle, top, offset) {
        let rightTop = top + this.left.height, rightOffset = offset + this.left.length + this.break;
        let left = type == $7beee9608540d2c3$var$QueryType.ByHeight ? value < rightTop : value < rightOffset;
        let base = left ? this.left.lineAt(value, type, oracle, top, offset) : this.right.lineAt(value, type, oracle, rightTop, rightOffset);
        if (this.break || (left ? base.to < rightOffset : base.from > rightOffset)) return base;
        let subQuery = type == $7beee9608540d2c3$var$QueryType.ByPosNoHeight ? $7beee9608540d2c3$var$QueryType.ByPosNoHeight : $7beee9608540d2c3$var$QueryType.ByPos;
        if (left) return base.join(this.right.lineAt(rightOffset, subQuery, oracle, rightTop, rightOffset));
        else return this.left.lineAt(rightOffset, subQuery, oracle, top, offset).join(base);
    }
    forEachLine(from, to, oracle, top, offset, f) {
        let rightTop = top + this.left.height, rightOffset = offset + this.left.length + this.break;
        if (this.break) {
            if (from < rightOffset) this.left.forEachLine(from, to, oracle, top, offset, f);
            if (to >= rightOffset) this.right.forEachLine(from, to, oracle, rightTop, rightOffset, f);
        } else {
            let mid = this.lineAt(rightOffset, $7beee9608540d2c3$var$QueryType.ByPos, oracle, top, offset);
            if (from < mid.from) this.left.forEachLine(from, mid.from - 1, oracle, top, offset, f);
            if (mid.to >= from && mid.from <= to) f(mid);
            if (to > mid.to) this.right.forEachLine(mid.to + 1, to, oracle, rightTop, rightOffset, f);
        }
    }
    replace(from, to, nodes) {
        let rightStart = this.left.length + this.break;
        if (to < rightStart) return this.balanced(this.left.replace(from, to, nodes), this.right);
        if (from > this.left.length) return this.balanced(this.left, this.right.replace(from - rightStart, to - rightStart, nodes));
        let result = [];
        if (from > 0) this.decomposeLeft(from, result);
        let left = result.length;
        for (let node of nodes)result.push(node);
        if (from > 0) $7beee9608540d2c3$var$mergeGaps(result, left - 1);
        if (to < this.length) {
            let right = result.length;
            this.decomposeRight(to, result);
            $7beee9608540d2c3$var$mergeGaps(result, right);
        }
        return $7beee9608540d2c3$var$HeightMap.of(result);
    }
    decomposeLeft(to, result) {
        let left = this.left.length;
        if (to <= left) return this.left.decomposeLeft(to, result);
        result.push(this.left);
        if (this.break) {
            left++;
            if (to >= left) result.push(null);
        }
        if (to > left) this.right.decomposeLeft(to - left, result);
    }
    decomposeRight(from, result) {
        let left = this.left.length, right = left + this.break;
        if (from >= right) return this.right.decomposeRight(from - right, result);
        if (from < left) this.left.decomposeRight(from, result);
        if (this.break && from < right) result.push(null);
        result.push(this.right);
    }
    balanced(left, right) {
        if (left.size > 2 * right.size || right.size > 2 * left.size) return $7beee9608540d2c3$var$HeightMap.of(this.break ? [
            left,
            null,
            right
        ] : [
            left,
            right
        ]);
        this.left = $7beee9608540d2c3$var$replace(this.left, left);
        this.right = $7beee9608540d2c3$var$replace(this.right, right);
        this.setHeight(left.height + right.height);
        this.outdated = left.outdated || right.outdated;
        this.size = left.size + right.size;
        this.length = left.length + this.break + right.length;
        return this;
    }
    updateHeight(oracle, offset = 0, force = false, measured) {
        let { left: left, right: right } = this, rightStart = offset + left.length + this.break, rebalance = null;
        if (measured && measured.from <= offset + left.length && measured.more) rebalance = left = left.updateHeight(oracle, offset, force, measured);
        else left.updateHeight(oracle, offset, force);
        if (measured && measured.from <= rightStart + right.length && measured.more) rebalance = right = right.updateHeight(oracle, rightStart, force, measured);
        else right.updateHeight(oracle, rightStart, force);
        if (rebalance) return this.balanced(left, right);
        this.height = this.left.height + this.right.height;
        this.outdated = false;
        return this;
    }
    toString() {
        return this.left + (this.break ? " " : "-") + this.right;
    }
}
function $7beee9608540d2c3$var$mergeGaps(nodes, around) {
    let before, after;
    if (nodes[around] == null && (before = nodes[around - 1]) instanceof $7beee9608540d2c3$var$HeightMapGap && (after = nodes[around + 1]) instanceof $7beee9608540d2c3$var$HeightMapGap) nodes.splice(around - 1, 3, new $7beee9608540d2c3$var$HeightMapGap(before.length + 1 + after.length));
}
const $7beee9608540d2c3$var$relevantWidgetHeight = 5;
class $7beee9608540d2c3$var$NodeBuilder {
    constructor(pos, oracle){
        this.pos = pos;
        this.oracle = oracle;
        this.nodes = [];
        this.lineStart = -1;
        this.lineEnd = -1;
        this.covering = null;
        this.writtenTo = pos;
    }
    get isCovered() {
        return this.covering && this.nodes[this.nodes.length - 1] == this.covering;
    }
    span(_from, to) {
        if (this.lineStart > -1) {
            let end = Math.min(to, this.lineEnd), last = this.nodes[this.nodes.length - 1];
            if (last instanceof $7beee9608540d2c3$var$HeightMapText) last.length += end - this.pos;
            else if (end > this.pos || !this.isCovered) this.nodes.push(new $7beee9608540d2c3$var$HeightMapText(end - this.pos, -1, 0));
            this.writtenTo = end;
            if (to > end) {
                this.nodes.push(null);
                this.writtenTo++;
                this.lineStart = -1;
            }
        }
        this.pos = to;
    }
    point(from, to, deco) {
        if (from < to || deco.heightRelevant) {
            let height = deco.widget ? deco.widget.estimatedHeight : 0;
            let breaks = deco.widget ? deco.widget.lineBreaks : 0;
            if (height < 0) height = this.oracle.lineHeight;
            let len = to - from;
            if (deco.block) this.addBlock(new $7beee9608540d2c3$var$HeightMapBlock(len, height, deco));
            else if (len || breaks || height >= $7beee9608540d2c3$var$relevantWidgetHeight) this.addLineDeco(height, breaks, len);
        } else if (to > from) this.span(from, to);
        if (this.lineEnd > -1 && this.lineEnd < this.pos) this.lineEnd = this.oracle.doc.lineAt(this.pos).to;
    }
    enterLine() {
        if (this.lineStart > -1) return;
        let { from: from, to: to } = this.oracle.doc.lineAt(this.pos);
        this.lineStart = from;
        this.lineEnd = to;
        if (this.writtenTo < from) {
            if (this.writtenTo < from - 1 || this.nodes[this.nodes.length - 1] == null) this.nodes.push(this.blankContent(this.writtenTo, from - 1));
            this.nodes.push(null);
        }
        if (this.pos > from) this.nodes.push(new $7beee9608540d2c3$var$HeightMapText(this.pos - from, -1, 0));
        this.writtenTo = this.pos;
    }
    blankContent(from, to) {
        let gap = new $7beee9608540d2c3$var$HeightMapGap(to - from);
        if (this.oracle.doc.lineAt(from).to == to) gap.flags |= 4 /* Flag.SingleLine */ ;
        return gap;
    }
    ensureLine() {
        this.enterLine();
        let last = this.nodes.length ? this.nodes[this.nodes.length - 1] : null;
        if (last instanceof $7beee9608540d2c3$var$HeightMapText) return last;
        let line = new $7beee9608540d2c3$var$HeightMapText(0, -1, 0);
        this.nodes.push(line);
        return line;
    }
    addBlock(block) {
        this.enterLine();
        let deco = block.deco;
        if (deco && deco.startSide > 0 && !this.isCovered) this.ensureLine();
        this.nodes.push(block);
        this.writtenTo = this.pos = this.pos + block.length;
        if (deco && deco.endSide > 0) this.covering = block;
    }
    addLineDeco(height, breaks, length) {
        let line = this.ensureLine();
        line.length += length;
        line.collapsed += length;
        line.widgetHeight = Math.max(line.widgetHeight, height);
        line.breaks += breaks;
        this.writtenTo = this.pos = this.pos + length;
    }
    finish(from) {
        let last = this.nodes.length == 0 ? null : this.nodes[this.nodes.length - 1];
        if (this.lineStart > -1 && !(last instanceof $7beee9608540d2c3$var$HeightMapText) && !this.isCovered) this.nodes.push(new $7beee9608540d2c3$var$HeightMapText(0, -1, 0));
        else if (this.writtenTo < this.pos || last == null) this.nodes.push(this.blankContent(this.writtenTo, this.pos));
        let pos = from;
        for (let node of this.nodes){
            if (node instanceof $7beee9608540d2c3$var$HeightMapText) node.updateHeight(this.oracle, pos);
            pos += node ? node.length : 1;
        }
        return this.nodes;
    }
    // Always called with a region that on both sides either stretches
    // to a line break or the end of the document.
    // The returned array uses null to indicate line breaks, but never
    // starts or ends in a line break, or has multiple line breaks next
    // to each other.
    static build(oracle, decorations, from, to) {
        let builder = new $7beee9608540d2c3$var$NodeBuilder(from, oracle);
        (0, $6295c6875f57e3ee$export$34cb5241245008dd).spans(decorations, from, to, builder, 0);
        return builder.finish(from);
    }
}
function $7beee9608540d2c3$var$heightRelevantDecoChanges(a, b, diff) {
    let comp = new $7beee9608540d2c3$var$DecorationComparator;
    (0, $6295c6875f57e3ee$export$34cb5241245008dd).compare(a, b, diff, comp, 0);
    return comp.changes;
}
class $7beee9608540d2c3$var$DecorationComparator {
    constructor(){
        this.changes = [];
    }
    compareRange() {}
    comparePoint(from, to, a, b) {
        if (from < to || a && a.heightRelevant || b && b.heightRelevant) $7beee9608540d2c3$var$addRange(from, to, this.changes, 5);
    }
}
function $7beee9608540d2c3$var$visiblePixelRange(dom, paddingTop) {
    let rect = dom.getBoundingClientRect();
    let doc = dom.ownerDocument, win = doc.defaultView || window;
    let left = Math.max(0, rect.left), right = Math.min(win.innerWidth, rect.right);
    let top = Math.max(0, rect.top), bottom = Math.min(win.innerHeight, rect.bottom);
    for(let parent = dom.parentNode; parent && parent != doc.body;){
        if (parent.nodeType == 1) {
            let elt = parent;
            let style = window.getComputedStyle(elt);
            if ((elt.scrollHeight > elt.clientHeight || elt.scrollWidth > elt.clientWidth) && style.overflow != "visible") {
                let parentRect = elt.getBoundingClientRect();
                left = Math.max(left, parentRect.left);
                right = Math.min(right, parentRect.right);
                top = Math.max(top, parentRect.top);
                bottom = Math.min(parent == dom.parentNode ? win.innerHeight : bottom, parentRect.bottom);
            }
            parent = style.position == "absolute" || style.position == "fixed" ? elt.offsetParent : elt.parentNode;
        } else if (parent.nodeType == 11) parent = parent.host;
        else break;
    }
    return {
        left: left - rect.left,
        right: Math.max(left, right) - rect.left,
        top: top - (rect.top + paddingTop),
        bottom: Math.max(top, bottom) - (rect.top + paddingTop)
    };
}
function $7beee9608540d2c3$var$inWindow(elt) {
    let rect = elt.getBoundingClientRect(), win = elt.ownerDocument.defaultView || window;
    return rect.left < win.innerWidth && rect.right > 0 && rect.top < win.innerHeight && rect.bottom > 0;
}
function $7beee9608540d2c3$var$fullPixelRange(dom, paddingTop) {
    let rect = dom.getBoundingClientRect();
    return {
        left: 0,
        right: rect.right - rect.left,
        top: paddingTop,
        bottom: rect.bottom - (rect.top + paddingTop)
    };
}
// Line gaps are placeholder widgets used to hide pieces of overlong
// lines within the viewport, as a kludge to keep the editor
// responsive when a ridiculously long line is loaded into it.
class $7beee9608540d2c3$var$LineGap {
    constructor(from, to, size, displaySize){
        this.from = from;
        this.to = to;
        this.size = size;
        this.displaySize = displaySize;
    }
    static same(a, b) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++){
            let gA = a[i], gB = b[i];
            if (gA.from != gB.from || gA.to != gB.to || gA.size != gB.size) return false;
        }
        return true;
    }
    draw(viewState, wrapping) {
        return $7beee9608540d2c3$export$10e30b733df217ea.replace({
            widget: new $7beee9608540d2c3$var$LineGapWidget(this.displaySize * (wrapping ? viewState.scaleY : viewState.scaleX), wrapping)
        }).range(this.from, this.to);
    }
}
class $7beee9608540d2c3$var$LineGapWidget extends $7beee9608540d2c3$export$95cdd842edb044c5 {
    constructor(size, vertical){
        super();
        this.size = size;
        this.vertical = vertical;
    }
    eq(other) {
        return other.size == this.size && other.vertical == this.vertical;
    }
    toDOM() {
        let elt = document.createElement("div");
        if (this.vertical) elt.style.height = this.size + "px";
        else {
            elt.style.width = this.size + "px";
            elt.style.height = "2px";
            elt.style.display = "inline-block";
        }
        return elt;
    }
    get estimatedHeight() {
        return this.vertical ? this.size : -1;
    }
}
class $7beee9608540d2c3$var$ViewState {
    constructor(view, state){
        this.view = view;
        this.state = state;
        // These are contentDOM-local coordinates
        this.pixelViewport = {
            left: 0,
            right: window.innerWidth,
            top: 0,
            bottom: 0
        };
        this.inView = true;
        this.paddingTop = 0; // Padding above the document, scaled
        this.paddingBottom = 0; // Padding below the document, scaled
        this.contentDOMWidth = 0; // contentDOM.getBoundingClientRect().width
        this.contentDOMHeight = 0; // contentDOM.getBoundingClientRect().height
        this.editorHeight = 0; // scrollDOM.clientHeight, unscaled
        this.editorWidth = 0; // scrollDOM.clientWidth, unscaled
        // The CSS-transformation scale of the editor (transformed size /
        // concrete size)
        this.scaleX = 1;
        this.scaleY = 1;
        // Last seen vertical offset of the element at the top of the scroll
        // container, or top of the window if there's no wrapping scroller
        this.scrollOffset = 0;
        this.scrolledToBottom = false;
        // The vertical position (document-relative) to which to anchor the
        // scroll position. -1 means anchor to the end of the document.
        this.scrollAnchorPos = 0;
        // The height at the anchor position. Set by the DOM update phase.
        // -1 means no height available.
        this.scrollAnchorHeight = -1;
        // See VP.MaxDOMHeight
        this.scaler = $7beee9608540d2c3$var$IdScaler;
        this.scrollTarget = null;
        // Briefly set to true when printing, to disable viewport limiting
        this.printing = false;
        // Flag set when editor content was redrawn, so that the next
        // measure stage knows it must read DOM layout
        this.mustMeasureContent = true;
        this.defaultTextDirection = $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR;
        this.visibleRanges = [];
        // Cursor 'assoc' is only significant when the cursor is on a line
        // wrap point, where it must stick to the character that it is
        // associated with. Since browsers don't provide a reasonable
        // interface to set or query this, when a selection is set that
        // might cause this to be significant, this flag is set. The next
        // measure phase will check whether the cursor is on a line-wrapping
        // boundary and, if so, reset it to make sure it is positioned in
        // the right place.
        this.mustEnforceCursorAssoc = false;
        let guessWrapping = state.facet($7beee9608540d2c3$var$contentAttributes).some((v)=>typeof v != "function" && v.class == "cm-lineWrapping");
        this.heightOracle = new $7beee9608540d2c3$var$HeightOracle(guessWrapping);
        this.stateDeco = $7beee9608540d2c3$var$staticDeco(state);
        this.heightMap = $7beee9608540d2c3$var$HeightMap.empty().applyChanges(this.stateDeco, (0, $6295c6875f57e3ee$export$5f1af8db9871e1d6).empty, this.heightOracle.setDoc(state.doc), [
            new $7beee9608540d2c3$var$ChangedRange(0, 0, 0, state.doc.length)
        ]);
        for(let i = 0; i < 2; i++){
            this.viewport = this.getViewport(0, null);
            if (!this.updateForViewport()) break;
        }
        this.updateViewportLines();
        this.lineGaps = this.ensureLineGaps([]);
        this.lineGapDeco = $7beee9608540d2c3$export$10e30b733df217ea.set(this.lineGaps.map((gap)=>gap.draw(this, false)));
        this.scrollParent = view.scrollDOM;
        this.computeVisibleRanges();
    }
    updateForViewport() {
        let viewports = [
            this.viewport
        ], { main: main } = this.state.selection;
        for(let i = 0; i <= 1; i++){
            let pos = i ? main.head : main.anchor;
            if (!viewports.some(({ from: from, to: to })=>pos >= from && pos <= to)) {
                let { from: from, to: to } = this.lineBlockAt(pos);
                viewports.push(new $7beee9608540d2c3$var$Viewport(from, to));
            }
        }
        this.viewports = viewports.sort((a, b)=>a.from - b.from);
        return this.updateScaler();
    }
    updateScaler() {
        let scaler = this.scaler;
        this.scaler = this.heightMap.height <= 7000000 /* VP.MaxDOMHeight */  ? $7beee9608540d2c3$var$IdScaler : new $7beee9608540d2c3$var$BigScaler(this.heightOracle, this.heightMap, this.viewports);
        return scaler.eq(this.scaler) ? 0 : 2 /* UpdateFlag.Height */ ;
    }
    updateViewportLines() {
        this.viewportLines = [];
        this.heightMap.forEachLine(this.viewport.from, this.viewport.to, this.heightOracle.setDoc(this.state.doc), 0, 0, (block)=>{
            this.viewportLines.push($7beee9608540d2c3$var$scaleBlock(block, this.scaler));
        });
    }
    update(update, scrollTarget = null) {
        this.state = update.state;
        let prevDeco = this.stateDeco;
        this.stateDeco = $7beee9608540d2c3$var$staticDeco(this.state);
        let contentChanges = update.changedRanges;
        let heightChanges = $7beee9608540d2c3$var$ChangedRange.extendWithRanges(contentChanges, $7beee9608540d2c3$var$heightRelevantDecoChanges(prevDeco, this.stateDeco, update ? update.changes : (0, $6295c6875f57e3ee$export$29d7fbdcb1f8b71c).empty(this.state.doc.length)));
        let prevHeight = this.heightMap.height;
        let scrollAnchor = this.scrolledToBottom ? null : this.scrollAnchorAt(this.scrollOffset);
        $7beee9608540d2c3$var$clearHeightChangeFlag();
        this.heightMap = this.heightMap.applyChanges(this.stateDeco, update.startState.doc, this.heightOracle.setDoc(this.state.doc), heightChanges);
        if (this.heightMap.height != prevHeight || $7beee9608540d2c3$var$heightChangeFlag) update.flags |= 2 /* UpdateFlag.Height */ ;
        if (scrollAnchor) {
            this.scrollAnchorPos = update.changes.mapPos(scrollAnchor.from, -1);
            this.scrollAnchorHeight = scrollAnchor.top;
        } else {
            this.scrollAnchorPos = -1;
            this.scrollAnchorHeight = prevHeight;
        }
        let viewport = heightChanges.length ? this.mapViewport(this.viewport, update.changes) : this.viewport;
        if (scrollTarget && (scrollTarget.range.head < viewport.from || scrollTarget.range.head > viewport.to) || !this.viewportIsAppropriate(viewport)) viewport = this.getViewport(0, scrollTarget);
        let viewportChange = viewport.from != this.viewport.from || viewport.to != this.viewport.to;
        this.viewport = viewport;
        update.flags |= this.updateForViewport();
        if (viewportChange || !update.changes.empty || update.flags & 2 /* UpdateFlag.Height */ ) this.updateViewportLines();
        if (this.lineGaps.length || this.viewport.to - this.viewport.from > 4000) this.updateLineGaps(this.ensureLineGaps(this.mapLineGaps(this.lineGaps, update.changes)));
        update.flags |= this.computeVisibleRanges(update.changes);
        if (scrollTarget) this.scrollTarget = scrollTarget;
        if (!this.mustEnforceCursorAssoc && (update.selectionSet || update.focusChanged) && update.view.lineWrapping && update.state.selection.main.empty && update.state.selection.main.assoc && !update.state.facet($7beee9608540d2c3$var$nativeSelectionHidden)) this.mustEnforceCursorAssoc = true;
    }
    measure() {
        let { view: view } = this, dom = view.contentDOM, style = window.getComputedStyle(dom);
        let oracle = this.heightOracle;
        let whiteSpace = style.whiteSpace;
        this.defaultTextDirection = style.direction == "rtl" ? $7beee9608540d2c3$export$cacd6541cfeeb6c1.RTL : $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR;
        let refresh = this.heightOracle.mustRefreshForWrapping(whiteSpace) || this.mustMeasureContent === "refresh";
        let domRect = dom.getBoundingClientRect();
        let measureContent = refresh || this.mustMeasureContent || this.contentDOMHeight != domRect.height;
        this.contentDOMHeight = domRect.height;
        this.mustMeasureContent = false;
        let result = 0, bias = 0;
        if (domRect.width && domRect.height) {
            let { scaleX: scaleX, scaleY: scaleY } = $7beee9608540d2c3$var$getScale(dom, domRect);
            if (scaleX > .005 && Math.abs(this.scaleX - scaleX) > .005 || scaleY > .005 && Math.abs(this.scaleY - scaleY) > .005) {
                this.scaleX = scaleX;
                this.scaleY = scaleY;
                result |= 16 /* UpdateFlag.Geometry */ ;
                refresh = measureContent = true;
            }
        }
        // Vertical padding
        let paddingTop = (parseInt(style.paddingTop) || 0) * this.scaleY;
        let paddingBottom = (parseInt(style.paddingBottom) || 0) * this.scaleY;
        if (this.paddingTop != paddingTop || this.paddingBottom != paddingBottom) {
            this.paddingTop = paddingTop;
            this.paddingBottom = paddingBottom;
            result |= 18 /* UpdateFlag.Height */ ;
        }
        if (this.editorWidth != view.scrollDOM.clientWidth) {
            if (oracle.lineWrapping) measureContent = true;
            this.editorWidth = view.scrollDOM.clientWidth;
            result |= 16 /* UpdateFlag.Geometry */ ;
        }
        let scrollParent = $7beee9608540d2c3$var$scrollableParents(this.view.contentDOM, false).y;
        if (scrollParent != this.scrollParent) {
            this.scrollParent = scrollParent;
            this.scrollAnchorHeight = -1;
            this.scrollOffset = 0;
        }
        let scrollOffset = this.getScrollOffset();
        if (this.scrollOffset != scrollOffset) {
            this.scrollAnchorHeight = -1;
            this.scrollOffset = scrollOffset;
        }
        this.scrolledToBottom = $7beee9608540d2c3$var$isScrolledToBottom(this.scrollParent || view.win);
        // Pixel viewport
        let pixelViewport = (this.printing ? $7beee9608540d2c3$var$fullPixelRange : $7beee9608540d2c3$var$visiblePixelRange)(dom, this.paddingTop);
        let dTop = pixelViewport.top - this.pixelViewport.top, dBottom = pixelViewport.bottom - this.pixelViewport.bottom;
        this.pixelViewport = pixelViewport;
        let inView = this.pixelViewport.bottom > this.pixelViewport.top && this.pixelViewport.right > this.pixelViewport.left;
        if (inView != this.inView) {
            this.inView = inView;
            if (inView) measureContent = true;
        }
        if (!this.inView && !this.scrollTarget && !$7beee9608540d2c3$var$inWindow(view.dom)) return 0;
        let contentWidth = domRect.width;
        if (this.contentDOMWidth != contentWidth || this.editorHeight != view.scrollDOM.clientHeight) {
            this.contentDOMWidth = domRect.width;
            this.editorHeight = view.scrollDOM.clientHeight;
            result |= 16 /* UpdateFlag.Geometry */ ;
        }
        if (measureContent) {
            let lineHeights = view.docView.measureVisibleLineHeights(this.viewport);
            if (oracle.mustRefreshForHeights(lineHeights)) refresh = true;
            if (refresh || oracle.lineWrapping && Math.abs(contentWidth - this.contentDOMWidth) > oracle.charWidth) {
                let { lineHeight: lineHeight, charWidth: charWidth, textHeight: textHeight } = view.docView.measureTextSize();
                refresh = lineHeight > 0 && oracle.refresh(whiteSpace, lineHeight, charWidth, textHeight, Math.max(5, contentWidth / charWidth), lineHeights);
                if (refresh) {
                    view.docView.minWidth = 0;
                    result |= 16 /* UpdateFlag.Geometry */ ;
                }
            }
            if (dTop > 0 && dBottom > 0) bias = Math.max(dTop, dBottom);
            else if (dTop < 0 && dBottom < 0) bias = Math.min(dTop, dBottom);
            $7beee9608540d2c3$var$clearHeightChangeFlag();
            for (let vp of this.viewports){
                let heights = vp.from == this.viewport.from ? lineHeights : view.docView.measureVisibleLineHeights(vp);
                this.heightMap = (refresh ? $7beee9608540d2c3$var$HeightMap.empty().applyChanges(this.stateDeco, (0, $6295c6875f57e3ee$export$5f1af8db9871e1d6).empty, this.heightOracle, [
                    new $7beee9608540d2c3$var$ChangedRange(0, 0, 0, view.state.doc.length)
                ]) : this.heightMap).updateHeight(oracle, 0, refresh, new $7beee9608540d2c3$var$MeasuredHeights(vp.from, heights));
            }
            if ($7beee9608540d2c3$var$heightChangeFlag) result |= 2 /* UpdateFlag.Height */ ;
        }
        let viewportChange = !this.viewportIsAppropriate(this.viewport, bias) || this.scrollTarget && (this.scrollTarget.range.head < this.viewport.from || this.scrollTarget.range.head > this.viewport.to);
        if (viewportChange) {
            if (result & 2 /* UpdateFlag.Height */ ) result |= this.updateScaler();
            this.viewport = this.getViewport(bias, this.scrollTarget);
            result |= this.updateForViewport();
        }
        if (result & 2 /* UpdateFlag.Height */  || viewportChange) this.updateViewportLines();
        if (this.lineGaps.length || this.viewport.to - this.viewport.from > 4000) this.updateLineGaps(this.ensureLineGaps(refresh ? [] : this.lineGaps, view));
        result |= this.computeVisibleRanges();
        if (this.mustEnforceCursorAssoc) {
            this.mustEnforceCursorAssoc = false;
            // This is done in the read stage, because moving the selection
            // to a line end is going to trigger a layout anyway, so it
            // can't be a pure write. It should be rare that it does any
            // writing.
            view.docView.enforceCursorAssoc();
        }
        return result;
    }
    get visibleTop() {
        return this.scaler.fromDOM(this.pixelViewport.top);
    }
    get visibleBottom() {
        return this.scaler.fromDOM(this.pixelViewport.bottom);
    }
    getViewport(bias, scrollTarget) {
        // This will divide VP.Margin between the top and the
        // bottom, depending on the bias (the change in viewport position
        // since the last update). It'll hold a number between 0 and 1
        let marginTop = 0.5 - Math.max(-0.5, Math.min(0.5, bias / 1000 /* VP.Margin */  / 2));
        let map = this.heightMap, oracle = this.heightOracle;
        let { visibleTop: visibleTop, visibleBottom: visibleBottom } = this;
        let viewport = new $7beee9608540d2c3$var$Viewport(map.lineAt(visibleTop - marginTop * 1000 /* VP.Margin */ , $7beee9608540d2c3$var$QueryType.ByHeight, oracle, 0, 0).from, map.lineAt(visibleBottom + (1 - marginTop) * 1000 /* VP.Margin */ , $7beee9608540d2c3$var$QueryType.ByHeight, oracle, 0, 0).to);
        // If scrollTarget is given, make sure the viewport includes that position
        if (scrollTarget) {
            let { head: head } = scrollTarget.range;
            if (head < viewport.from || head > viewport.to) {
                let viewHeight = Math.min(this.editorHeight, this.pixelViewport.bottom - this.pixelViewport.top);
                let block = map.lineAt(head, $7beee9608540d2c3$var$QueryType.ByPos, oracle, 0, 0), topPos;
                if (scrollTarget.y == "center") topPos = (block.top + block.bottom) / 2 - viewHeight / 2;
                else if (scrollTarget.y == "start" || scrollTarget.y == "nearest" && head < viewport.from) topPos = block.top;
                else topPos = block.bottom - viewHeight;
                viewport = new $7beee9608540d2c3$var$Viewport(map.lineAt(topPos - 500, $7beee9608540d2c3$var$QueryType.ByHeight, oracle, 0, 0).from, map.lineAt(topPos + viewHeight + 500, $7beee9608540d2c3$var$QueryType.ByHeight, oracle, 0, 0).to);
            }
        }
        return viewport;
    }
    mapViewport(viewport, changes) {
        let from = changes.mapPos(viewport.from, -1), to = changes.mapPos(viewport.to, 1);
        return new $7beee9608540d2c3$var$Viewport(this.heightMap.lineAt(from, $7beee9608540d2c3$var$QueryType.ByPos, this.heightOracle, 0, 0).from, this.heightMap.lineAt(to, $7beee9608540d2c3$var$QueryType.ByPos, this.heightOracle, 0, 0).to);
    }
    // Checks if a given viewport covers the visible part of the
    // document and not too much beyond that.
    viewportIsAppropriate({ from: from, to: to }, bias = 0) {
        if (!this.inView) return true;
        let { top: top } = this.heightMap.lineAt(from, $7beee9608540d2c3$var$QueryType.ByPos, this.heightOracle, 0, 0);
        let { bottom: bottom } = this.heightMap.lineAt(to, $7beee9608540d2c3$var$QueryType.ByPos, this.heightOracle, 0, 0);
        let { visibleTop: visibleTop, visibleBottom: visibleBottom } = this;
        return (from == 0 || top <= visibleTop - Math.max(10 /* VP.MinCoverMargin */ , Math.min(-bias, 250 /* VP.MaxCoverMargin */ ))) && (to == this.state.doc.length || bottom >= visibleBottom + Math.max(10 /* VP.MinCoverMargin */ , Math.min(bias, 250 /* VP.MaxCoverMargin */ ))) && top > visibleTop - 2000 /* VP.Margin */  && bottom < visibleBottom + 2000 /* VP.Margin */ ;
    }
    mapLineGaps(gaps, changes) {
        if (!gaps.length || changes.empty) return gaps;
        let mapped = [];
        for (let gap of gaps)if (!changes.touchesRange(gap.from, gap.to)) mapped.push(new $7beee9608540d2c3$var$LineGap(changes.mapPos(gap.from), changes.mapPos(gap.to), gap.size, gap.displaySize));
        return mapped;
    }
    // Computes positions in the viewport where the start or end of a
    // line should be hidden, trying to reuse existing line gaps when
    // appropriate to avoid unneccesary redraws.
    // Uses crude character-counting for the positioning and sizing,
    // since actual DOM coordinates aren't always available and
    // predictable. Relies on generous margins (see LG.Margin) to hide
    // the artifacts this might produce from the user.
    ensureLineGaps(current, mayMeasure) {
        let wrapping = this.heightOracle.lineWrapping;
        let margin = wrapping ? 10000 /* LG.MarginWrap */  : 2000 /* LG.Margin */ , halfMargin = margin >> 1, doubleMargin = margin << 1;
        // The non-wrapping logic won't work at all in predominantly right-to-left text.
        if (this.defaultTextDirection != $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR && !wrapping) return [];
        let gaps = [];
        let addGap = (from, to, line, structure)=>{
            if (to - from < halfMargin) return;
            let sel = this.state.selection.main, avoid = [
                sel.from
            ];
            if (!sel.empty) avoid.push(sel.to);
            for (let pos of avoid)if (pos > from && pos < to) {
                addGap(from, pos - 10 /* LG.SelectionMargin */ , line, structure);
                addGap(pos + 10 /* LG.SelectionMargin */ , to, line, structure);
                return;
            }
            let gap = $7beee9608540d2c3$var$find(current, (gap)=>gap.from >= line.from && gap.to <= line.to && Math.abs(gap.from - from) < halfMargin && Math.abs(gap.to - to) < halfMargin && !avoid.some((pos)=>gap.from < pos && gap.to > pos));
            if (!gap) {
                // When scrolling down, snap gap ends to line starts to avoid shifts in wrapping
                if (to < line.to && mayMeasure && wrapping && mayMeasure.visibleRanges.some((r)=>r.from <= to && r.to >= to)) {
                    let lineStart = mayMeasure.moveToLineBoundary((0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(to), false, true).head;
                    if (lineStart > from) to = lineStart;
                }
                let size = this.gapSize(line, from, to, structure);
                let displaySize = wrapping || size < 2000000 /* VP.MaxHorizGap */  ? size : 2000000 /* VP.MaxHorizGap */ ;
                gap = new $7beee9608540d2c3$var$LineGap(from, to, size, displaySize);
            }
            gaps.push(gap);
        };
        let checkLine = (line)=>{
            if (line.length < doubleMargin || line.type != $7beee9608540d2c3$export$48808c686fe495c4.Text) return;
            let structure = $7beee9608540d2c3$var$lineStructure(line.from, line.to, this.stateDeco);
            if (structure.total < doubleMargin) return;
            let target = this.scrollTarget ? this.scrollTarget.range.head : null;
            let viewFrom, viewTo;
            if (wrapping) {
                let marginHeight = margin / this.heightOracle.lineLength * this.heightOracle.lineHeight;
                let top, bot;
                if (target != null) {
                    let targetFrac = $7beee9608540d2c3$var$findFraction(structure, target);
                    let spaceFrac = ((this.visibleBottom - this.visibleTop) / 2 + marginHeight) / line.height;
                    top = targetFrac - spaceFrac;
                    bot = targetFrac + spaceFrac;
                } else {
                    top = (this.visibleTop - line.top - marginHeight) / line.height;
                    bot = (this.visibleBottom - line.top + marginHeight) / line.height;
                }
                viewFrom = $7beee9608540d2c3$var$findPosition(structure, top);
                viewTo = $7beee9608540d2c3$var$findPosition(structure, bot);
            } else {
                let totalWidth = structure.total * this.heightOracle.charWidth;
                let marginWidth = margin * this.heightOracle.charWidth;
                let horizOffset = 0;
                if (totalWidth > 2000000 /* VP.MaxHorizGap */ ) {
                    for (let old of current)if (old.from >= line.from && old.from < line.to && old.size != old.displaySize && old.from * this.heightOracle.charWidth + horizOffset < this.pixelViewport.left) horizOffset = old.size - old.displaySize;
                }
                let pxLeft = this.pixelViewport.left + horizOffset, pxRight = this.pixelViewport.right + horizOffset;
                let left, right;
                if (target != null) {
                    let targetFrac = $7beee9608540d2c3$var$findFraction(structure, target);
                    let spaceFrac = ((pxRight - pxLeft) / 2 + marginWidth) / totalWidth;
                    left = targetFrac - spaceFrac;
                    right = targetFrac + spaceFrac;
                } else {
                    left = (pxLeft - marginWidth) / totalWidth;
                    right = (pxRight + marginWidth) / totalWidth;
                }
                viewFrom = $7beee9608540d2c3$var$findPosition(structure, left);
                viewTo = $7beee9608540d2c3$var$findPosition(structure, right);
            }
            if (viewFrom > line.from) addGap(line.from, viewFrom, line, structure);
            if (viewTo < line.to) addGap(viewTo, line.to, line, structure);
        };
        for (let line of this.viewportLines)if (Array.isArray(line.type)) line.type.forEach(checkLine);
        else checkLine(line);
        return gaps;
    }
    gapSize(line, from, to, structure) {
        let fraction = $7beee9608540d2c3$var$findFraction(structure, to) - $7beee9608540d2c3$var$findFraction(structure, from);
        if (this.heightOracle.lineWrapping) return line.height * fraction;
        else return structure.total * this.heightOracle.charWidth * fraction;
    }
    updateLineGaps(gaps) {
        if (!$7beee9608540d2c3$var$LineGap.same(gaps, this.lineGaps)) {
            this.lineGaps = gaps;
            this.lineGapDeco = $7beee9608540d2c3$export$10e30b733df217ea.set(gaps.map((gap)=>gap.draw(this, this.heightOracle.lineWrapping)));
        }
    }
    computeVisibleRanges(changes) {
        let deco = this.stateDeco;
        if (this.lineGaps.length) deco = deco.concat(this.lineGapDeco);
        let ranges = [];
        (0, $6295c6875f57e3ee$export$34cb5241245008dd).spans(deco, this.viewport.from, this.viewport.to, {
            span (from, to) {
                ranges.push({
                    from: from,
                    to: to
                });
            },
            point () {}
        }, 20);
        let changed = 0;
        if (ranges.length != this.visibleRanges.length) changed = 12 /* UpdateFlag.Viewport */ ;
        else for(let i = 0; i < ranges.length && !(changed & 8 /* UpdateFlag.ViewportMoved */ ); i++){
            let old = this.visibleRanges[i], nw = ranges[i];
            if (old.from != nw.from || old.to != nw.to) {
                changed |= 4 /* UpdateFlag.Viewport */ ;
                if (!(changes && changes.mapPos(old.from, -1) == nw.from && changes.mapPos(old.to, 1) == nw.to)) changed |= 8 /* UpdateFlag.ViewportMoved */ ;
            }
        }
        this.visibleRanges = ranges;
        return changed;
    }
    lineBlockAt(pos) {
        return pos >= this.viewport.from && pos <= this.viewport.to && this.viewportLines.find((b)=>b.from <= pos && b.to >= pos) || $7beee9608540d2c3$var$scaleBlock(this.heightMap.lineAt(pos, $7beee9608540d2c3$var$QueryType.ByPos, this.heightOracle, 0, 0), this.scaler);
    }
    lineBlockAtHeight(height) {
        return height >= this.viewportLines[0].top && height <= this.viewportLines[this.viewportLines.length - 1].bottom && this.viewportLines.find((l)=>l.top <= height && l.bottom >= height) || $7beee9608540d2c3$var$scaleBlock(this.heightMap.lineAt(this.scaler.fromDOM(height), $7beee9608540d2c3$var$QueryType.ByHeight, this.heightOracle, 0, 0), this.scaler);
    }
    getScrollOffset() {
        let base = this.scrollParent == this.view.scrollDOM ? this.scrollParent.scrollTop : (this.scrollParent ? this.scrollParent.getBoundingClientRect().top : 0) - this.view.contentDOM.getBoundingClientRect().top;
        return base * this.scaleY;
    }
    scrollAnchorAt(scrollOffset) {
        let block = this.lineBlockAtHeight(scrollOffset + 8);
        return block.from >= this.viewport.from || this.viewportLines[0].top - scrollOffset > 200 ? block : this.viewportLines[0];
    }
    elementAtHeight(height) {
        return $7beee9608540d2c3$var$scaleBlock(this.heightMap.blockAt(this.scaler.fromDOM(height), this.heightOracle, 0, 0), this.scaler);
    }
    get docHeight() {
        return this.scaler.toDOM(this.heightMap.height);
    }
    get contentHeight() {
        return this.docHeight + this.paddingTop + this.paddingBottom;
    }
}
class $7beee9608540d2c3$var$Viewport {
    constructor(from, to){
        this.from = from;
        this.to = to;
    }
}
function $7beee9608540d2c3$var$lineStructure(from, to, stateDeco) {
    let ranges = [], pos = from, total = 0;
    (0, $6295c6875f57e3ee$export$34cb5241245008dd).spans(stateDeco, from, to, {
        span () {},
        point (from, to) {
            if (from > pos) {
                ranges.push({
                    from: pos,
                    to: from
                });
                total += from - pos;
            }
            pos = to;
        }
    }, 20); // We're only interested in collapsed ranges of a significant size
    if (pos < to) {
        ranges.push({
            from: pos,
            to: to
        });
        total += to - pos;
    }
    return {
        total: total,
        ranges: ranges
    };
}
function $7beee9608540d2c3$var$findPosition({ total: total, ranges: ranges }, ratio) {
    if (ratio <= 0) return ranges[0].from;
    if (ratio >= 1) return ranges[ranges.length - 1].to;
    let dist = Math.floor(total * ratio);
    for(let i = 0;; i++){
        let { from: from, to: to } = ranges[i], size = to - from;
        if (dist <= size) return from + dist;
        dist -= size;
    }
}
function $7beee9608540d2c3$var$findFraction(structure, pos) {
    let counted = 0;
    for (let { from: from, to: to } of structure.ranges){
        if (pos <= to) {
            counted += pos - from;
            break;
        }
        counted += to - from;
    }
    return counted / structure.total;
}
function $7beee9608540d2c3$var$find(array, f) {
    for (let val of array)if (f(val)) return val;
    return undefined;
}
// Don't scale when the document height is within the range of what
// the DOM can handle.
const $7beee9608540d2c3$var$IdScaler = {
    toDOM (n) {
        return n;
    },
    fromDOM (n) {
        return n;
    },
    scale: 1,
    eq (other) {
        return other == this;
    }
};
function $7beee9608540d2c3$var$staticDeco(state) {
    let deco = state.facet($7beee9608540d2c3$var$decorations).filter((d)=>typeof d != "function");
    let outer = state.facet($7beee9608540d2c3$var$outerDecorations).filter((d)=>typeof d != "function");
    if (outer.length) deco.push((0, $6295c6875f57e3ee$export$34cb5241245008dd).join(outer));
    return deco;
}
// When the height is too big (> VP.MaxDOMHeight), scale down the
// regions outside the viewports so that the total height is
// VP.MaxDOMHeight.
class $7beee9608540d2c3$var$BigScaler {
    constructor(oracle, heightMap, viewports){
        let vpHeight = 0, base = 0, domBase = 0;
        this.viewports = viewports.map(({ from: from, to: to })=>{
            let top = heightMap.lineAt(from, $7beee9608540d2c3$var$QueryType.ByPos, oracle, 0, 0).top;
            let bottom = heightMap.lineAt(to, $7beee9608540d2c3$var$QueryType.ByPos, oracle, 0, 0).bottom;
            vpHeight += bottom - top;
            return {
                from: from,
                to: to,
                top: top,
                bottom: bottom,
                domTop: 0,
                domBottom: 0
            };
        });
        this.scale = (7000000 /* VP.MaxDOMHeight */  - vpHeight) / (heightMap.height - vpHeight);
        for (let obj of this.viewports){
            obj.domTop = domBase + (obj.top - base) * this.scale;
            domBase = obj.domBottom = obj.domTop + (obj.bottom - obj.top);
            base = obj.bottom;
        }
    }
    toDOM(n) {
        for(let i = 0, base = 0, domBase = 0;; i++){
            let vp = i < this.viewports.length ? this.viewports[i] : null;
            if (!vp || n < vp.top) return domBase + (n - base) * this.scale;
            if (n <= vp.bottom) return vp.domTop + (n - vp.top);
            base = vp.bottom;
            domBase = vp.domBottom;
        }
    }
    fromDOM(n) {
        for(let i = 0, base = 0, domBase = 0;; i++){
            let vp = i < this.viewports.length ? this.viewports[i] : null;
            if (!vp || n < vp.domTop) return base + (n - domBase) / this.scale;
            if (n <= vp.domBottom) return vp.top + (n - vp.domTop);
            base = vp.bottom;
            domBase = vp.domBottom;
        }
    }
    eq(other) {
        if (!(other instanceof $7beee9608540d2c3$var$BigScaler)) return false;
        return this.scale == other.scale && this.viewports.length == other.viewports.length && this.viewports.every((vp, i)=>vp.from == other.viewports[i].from && vp.to == other.viewports[i].to);
    }
}
function $7beee9608540d2c3$var$scaleBlock(block, scaler) {
    if (scaler.scale == 1) return block;
    let bTop = scaler.toDOM(block.top), bBottom = scaler.toDOM(block.bottom);
    return new $7beee9608540d2c3$export$ddfdc4ccfe9512bd(block.from, block.length, bTop, bBottom - bTop, Array.isArray(block._content) ? block._content.map((b)=>$7beee9608540d2c3$var$scaleBlock(b, scaler)) : block._content);
}
const $7beee9608540d2c3$var$theme = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine: (strs)=>strs.join(" ")
});
const $7beee9608540d2c3$var$darkTheme = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine: (values)=>values.indexOf(true) > -1
});
const $7beee9608540d2c3$var$baseThemeID = /*@__PURE__*/ (0, $afd7c6da9f842a17$export$b920c662d2efee20).newName(), $7beee9608540d2c3$var$baseLightID = /*@__PURE__*/ (0, $afd7c6da9f842a17$export$b920c662d2efee20).newName(), $7beee9608540d2c3$var$baseDarkID = /*@__PURE__*/ (0, $afd7c6da9f842a17$export$b920c662d2efee20).newName();
const $7beee9608540d2c3$var$lightDarkIDs = {
    "&light": "." + $7beee9608540d2c3$var$baseLightID,
    "&dark": "." + $7beee9608540d2c3$var$baseDarkID
};
function $7beee9608540d2c3$var$buildTheme(main, spec, scopes) {
    return new (0, $afd7c6da9f842a17$export$b920c662d2efee20)(spec, {
        finish (sel) {
            return /&/.test(sel) ? sel.replace(/&\w*/, (m)=>{
                if (m == "&") return main;
                if (!scopes || !scopes[m]) throw new RangeError(`Unsupported selector: ${m}`);
                return scopes[m];
            }) : main + " " + sel;
        }
    });
}
const $7beee9608540d2c3$var$baseTheme$1 = /*@__PURE__*/ $7beee9608540d2c3$var$buildTheme("." + $7beee9608540d2c3$var$baseThemeID, {
    "&": {
        position: "relative !important",
        boxSizing: "border-box",
        "&.cm-focused": {
            // Provide a simple default outline to make sure a focused
            // editor is visually distinct. Can't leave the default behavior
            // because that will apply to the content element, which is
            // inside the scrollable container and doesn't include the
            // gutters. We also can't use an 'auto' outline, since those
            // are, for some reason, drawn behind the element content, which
            // will cause things like the active line background to cover
            // the outline (#297).
            outline: "1px dotted #212121"
        },
        display: "flex !important",
        flexDirection: "column"
    },
    ".cm-scroller": {
        display: "flex !important",
        alignItems: "flex-start !important",
        fontFamily: "monospace",
        lineHeight: 1.4,
        height: "100%",
        overflowX: "auto",
        position: "relative",
        zIndex: 0,
        overflowAnchor: "none"
    },
    ".cm-content": {
        margin: 0,
        flexGrow: 2,
        flexShrink: 0,
        display: "block",
        whiteSpace: "pre",
        wordWrap: "normal",
        boxSizing: "border-box",
        minHeight: "100%",
        padding: "4px 0",
        outline: "none",
        "&[contenteditable=true]": {
            WebkitUserModify: "read-write-plaintext-only"
        }
    },
    ".cm-lineWrapping": {
        whiteSpace_fallback: "pre-wrap",
        whiteSpace: "break-spaces",
        wordBreak: "break-word",
        overflowWrap: "anywhere",
        flexShrink: 1
    },
    "&light .cm-content": {
        caretColor: "black"
    },
    "&dark .cm-content": {
        caretColor: "white"
    },
    ".cm-line": {
        display: "block",
        padding: "0 2px 0 6px"
    },
    ".cm-layer": {
        userSelect: "none",
        position: "absolute",
        left: 0,
        top: 0,
        contain: "size style",
        "& > *": {
            position: "absolute"
        }
    },
    "&light .cm-selectionBackground": {
        background: "#d9d9d9"
    },
    "&dark .cm-selectionBackground": {
        background: "#222"
    },
    "&light.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
        background: "#d7d4f0"
    },
    "&dark.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
        background: "#233"
    },
    ".cm-cursorLayer": {
        pointerEvents: "none"
    },
    "&.cm-focused > .cm-scroller > .cm-cursorLayer": {
        animation: "steps(1) cm-blink 1.2s infinite"
    },
    // Two animations defined so that we can switch between them to
    // restart the animation without forcing another style
    // recomputation.
    "@keyframes cm-blink": {
        "0%": {},
        "50%": {
            opacity: 0
        },
        "100%": {}
    },
    "@keyframes cm-blink2": {
        "0%": {},
        "50%": {
            opacity: 0
        },
        "100%": {}
    },
    ".cm-cursor, .cm-dropCursor": {
        borderLeft: "1.2px solid black",
        marginLeft: "-0.6px",
        pointerEvents: "none"
    },
    ".cm-cursor": {
        display: "none"
    },
    "&dark .cm-cursor": {
        borderLeftColor: "#ddd"
    },
    ".cm-selectionHandle": {
        backgroundColor: "currentColor",
        width: "1.5px"
    },
    ".cm-selectionHandle-start::before, .cm-selectionHandle-end::before": {
        content: '""',
        backgroundColor: "inherit",
        borderRadius: "50%",
        width: "8px",
        height: "8px",
        position: "absolute",
        left: "-3.25px"
    },
    ".cm-selectionHandle-start::before": {
        top: "-8px"
    },
    ".cm-selectionHandle-end::before": {
        bottom: "-8px"
    },
    ".cm-dropCursor": {
        position: "absolute"
    },
    "&.cm-focused > .cm-scroller > .cm-cursorLayer .cm-cursor": {
        display: "block"
    },
    ".cm-iso": {
        unicodeBidi: "isolate"
    },
    ".cm-announced": {
        position: "fixed",
        top: "-10000px"
    },
    "@media print": {
        ".cm-announced": {
            display: "none"
        }
    },
    "&light .cm-activeLine": {
        backgroundColor: "#cceeff44"
    },
    "&dark .cm-activeLine": {
        backgroundColor: "#99eeff33"
    },
    "&light .cm-specialChar": {
        color: "red"
    },
    "&dark .cm-specialChar": {
        color: "#f78"
    },
    ".cm-gutters": {
        flexShrink: 0,
        display: "flex",
        height: "100%",
        boxSizing: "border-box",
        zIndex: 200
    },
    ".cm-gutters-before": {
        insetInlineStart: 0
    },
    ".cm-gutters-after": {
        insetInlineEnd: 0
    },
    "&light .cm-gutters": {
        backgroundColor: "#f5f5f5",
        color: "#6c6c6c",
        border: "0px solid #ddd",
        "&.cm-gutters-before": {
            borderRightWidth: "1px"
        },
        "&.cm-gutters-after": {
            borderLeftWidth: "1px"
        }
    },
    "&dark .cm-gutters": {
        backgroundColor: "#333338",
        color: "#ccc"
    },
    ".cm-gutter": {
        display: "flex !important",
        flexDirection: "column",
        flexShrink: 0,
        boxSizing: "border-box",
        minHeight: "100%",
        overflow: "hidden"
    },
    ".cm-gutterElement": {
        boxSizing: "border-box"
    },
    ".cm-lineNumbers .cm-gutterElement": {
        padding: "0 3px 0 5px",
        minWidth: "20px",
        textAlign: "right",
        whiteSpace: "nowrap"
    },
    "&light .cm-activeLineGutter": {
        backgroundColor: "#e2f2ff"
    },
    "&dark .cm-activeLineGutter": {
        backgroundColor: "#222227"
    },
    ".cm-panels": {
        boxSizing: "border-box",
        position: "sticky",
        left: 0,
        right: 0,
        zIndex: 300
    },
    "&light .cm-panels": {
        backgroundColor: "#f5f5f5",
        color: "black"
    },
    "&light .cm-panels-top": {
        borderBottom: "1px solid #ddd"
    },
    "&light .cm-panels-bottom": {
        borderTop: "1px solid #ddd"
    },
    "&dark .cm-panels": {
        backgroundColor: "#333338",
        color: "white"
    },
    ".cm-dialog": {
        padding: "2px 19px 4px 6px",
        position: "relative",
        "& label": {
            fontSize: "80%"
        }
    },
    ".cm-dialog-close": {
        position: "absolute",
        top: "3px",
        right: "4px",
        backgroundColor: "inherit",
        border: "none",
        font: "inherit",
        fontSize: "14px",
        padding: "0"
    },
    ".cm-tab": {
        display: "inline-block",
        overflow: "hidden",
        verticalAlign: "bottom"
    },
    ".cm-widgetBuffer": {
        verticalAlign: "text-top",
        height: "1em",
        width: 0,
        display: "inline"
    },
    ".cm-placeholder": {
        color: "#888",
        display: "inline-block",
        verticalAlign: "top",
        userSelect: "none"
    },
    ".cm-highlightSpace": {
        backgroundImage: "radial-gradient(circle at 50% 55%, #aaa 20%, transparent 5%)",
        backgroundPosition: "center"
    },
    ".cm-highlightTab": {
        backgroundImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="20"><path stroke="%23888" stroke-width="1" fill="none" d="M1 10H196L190 5M190 15L196 10M197 4L197 16"/></svg>')`,
        backgroundSize: "auto 100%",
        backgroundPosition: "right 90%",
        backgroundRepeat: "no-repeat"
    },
    ".cm-trailingSpace": {
        backgroundColor: "#ff332255"
    },
    ".cm-button": {
        verticalAlign: "middle",
        color: "inherit",
        fontSize: "70%",
        padding: ".2em 1em",
        borderRadius: "1px"
    },
    "&light .cm-button": {
        backgroundImage: "linear-gradient(#eff1f5, #d9d9df)",
        border: "1px solid #888",
        "&:active": {
            backgroundImage: "linear-gradient(#b4b4b4, #d0d3d6)"
        }
    },
    "&dark .cm-button": {
        backgroundImage: "linear-gradient(#393939, #111)",
        border: "1px solid #888",
        "&:active": {
            backgroundImage: "linear-gradient(#111, #333)"
        }
    },
    ".cm-textfield": {
        verticalAlign: "middle",
        color: "inherit",
        fontSize: "70%",
        border: "1px solid silver",
        padding: ".2em .5em"
    },
    "&light .cm-textfield": {
        backgroundColor: "white"
    },
    "&dark .cm-textfield": {
        border: "1px solid #555",
        backgroundColor: "inherit"
    }
}, $7beee9608540d2c3$var$lightDarkIDs);
const $7beee9608540d2c3$var$observeOptions = {
    childList: true,
    characterData: true,
    subtree: true,
    attributes: true,
    characterDataOldValue: true
};
// IE11 has very broken mutation observers, so we also listen to
// DOMCharacterDataModified there
const $7beee9608540d2c3$var$useCharData = $7beee9608540d2c3$var$browser.ie && $7beee9608540d2c3$var$browser.ie_version <= 11;
class $7beee9608540d2c3$var$DOMObserver {
    constructor(view){
        this.view = view;
        this.active = false;
        this.editContext = null;
        // The known selection. Kept in our own object, as opposed to just
        // directly accessing the selection because:
        //  - Safari doesn't report the right selection in shadow DOM
        //  - Reading from the selection forces a DOM layout
        //  - This way, we can ignore selectionchange events if we have
        //    already seen the 'new' selection
        this.selectionRange = new $7beee9608540d2c3$var$DOMSelectionState;
        // Set when a selection change is detected, cleared on flush
        this.selectionChanged = false;
        this.delayedFlush = -1;
        this.resizeTimeout = -1;
        this.queue = [];
        this.delayedAndroidKey = null;
        this.flushingAndroidKey = -1;
        this.lastChange = 0;
        this.scrollTargets = [];
        this.intersection = null;
        this.resizeScroll = null;
        this.intersecting = false;
        this.gapIntersection = null;
        this.gaps = [];
        this.printQuery = null;
        // Timeout for scheduling check of the parents that need scroll handlers
        this.parentCheck = -1;
        this.dom = view.contentDOM;
        this.observer = new MutationObserver((mutations)=>{
            for (let mut of mutations)this.queue.push(mut);
            // IE11 will sometimes (on typing over a selection or
            // backspacing out a single character text node) call the
            // observer callback before actually updating the DOM.
            //
            // Unrelatedly, iOS Safari will, when ending a composition,
            // sometimes first clear it, deliver the mutations, and then
            // reinsert the finished text. CodeMirror's handling of the
            // deletion will prevent the reinsertion from happening,
            // breaking composition.
            if (($7beee9608540d2c3$var$browser.ie && $7beee9608540d2c3$var$browser.ie_version <= 11 || $7beee9608540d2c3$var$browser.ios && view.composing) && mutations.some((m)=>m.type == "childList" && m.removedNodes.length || m.type == "characterData" && m.oldValue.length > m.target.nodeValue.length)) this.flushSoon();
            else this.flush();
        });
        if (window.EditContext && $7beee9608540d2c3$var$browser.android && view.constructor.EDIT_CONTEXT !== false && // Chrome <126 doesn't support inverted selections in edit context (#1392)
        !($7beee9608540d2c3$var$browser.chrome && $7beee9608540d2c3$var$browser.chrome_version < 126)) {
            this.editContext = new $7beee9608540d2c3$var$EditContextManager(view);
            if (view.state.facet($7beee9608540d2c3$var$editable)) view.contentDOM.editContext = this.editContext.editContext;
        }
        if ($7beee9608540d2c3$var$useCharData) this.onCharData = (event)=>{
            this.queue.push({
                target: event.target,
                type: "characterData",
                oldValue: event.prevValue
            });
            this.flushSoon();
        };
        this.onSelectionChange = this.onSelectionChange.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onPrint = this.onPrint.bind(this);
        this.onScroll = this.onScroll.bind(this);
        if (window.matchMedia) this.printQuery = window.matchMedia("print");
        if (typeof ResizeObserver == "function") {
            this.resizeScroll = new ResizeObserver(()=>{
                var _a;
                if (((_a = this.view.docView) === null || _a === void 0 ? void 0 : _a.lastUpdate) < Date.now() - 75) this.onResize();
            });
            this.resizeScroll.observe(view.scrollDOM);
        }
        this.addWindowListeners(this.win = view.win);
        this.start();
        if (typeof IntersectionObserver == "function") {
            this.intersection = new IntersectionObserver((entries)=>{
                if (this.parentCheck < 0) this.parentCheck = setTimeout(this.listenForScroll.bind(this), 1000);
                if (entries.length > 0 && entries[entries.length - 1].intersectionRatio > 0 != this.intersecting) {
                    this.intersecting = !this.intersecting;
                    if (this.intersecting != this.view.inView) this.onScrollChanged(document.createEvent("Event"));
                }
            }, {
                threshold: [
                    0,
                    .001
                ]
            });
            this.intersection.observe(this.dom);
            this.gapIntersection = new IntersectionObserver((entries)=>{
                if (entries.length > 0 && entries[entries.length - 1].intersectionRatio > 0) this.onScrollChanged(document.createEvent("Event"));
            }, {});
        }
        this.listenForScroll();
        this.readSelectionRange();
    }
    onScrollChanged(e) {
        this.view.inputState.runHandlers("scroll", e);
        if (this.intersecting) this.view.measure();
    }
    onScroll(e) {
        if (this.intersecting) this.flush(false);
        if (this.editContext) this.view.requestMeasure(this.editContext.measureReq);
        this.onScrollChanged(e);
    }
    onResize() {
        if (this.resizeTimeout < 0) this.resizeTimeout = setTimeout(()=>{
            this.resizeTimeout = -1;
            this.view.requestMeasure();
        }, 50);
    }
    onPrint(event) {
        if ((event.type == "change" || !event.type) && !event.matches) return;
        this.view.viewState.printing = true;
        this.view.measure();
        setTimeout(()=>{
            this.view.viewState.printing = false;
            this.view.requestMeasure();
        }, 500);
    }
    updateGaps(gaps) {
        if (this.gapIntersection && (gaps.length != this.gaps.length || this.gaps.some((g, i)=>g != gaps[i]))) {
            this.gapIntersection.disconnect();
            for (let gap of gaps)this.gapIntersection.observe(gap);
            this.gaps = gaps;
        }
    }
    onSelectionChange(event) {
        let wasChanged = this.selectionChanged;
        if (!this.readSelectionRange() || this.delayedAndroidKey) return;
        let { view: view } = this, sel = this.selectionRange;
        if (view.state.facet($7beee9608540d2c3$var$editable) ? view.root.activeElement != this.dom : !$7beee9608540d2c3$var$hasSelection(this.dom, sel)) return;
        let context = sel.anchorNode && view.docView.tile.nearest(sel.anchorNode);
        if (context && context.isWidget() && context.widget.ignoreEvent(event)) {
            if (!wasChanged) this.selectionChanged = false;
            return;
        }
        // Deletions on IE11 fire their events in the wrong order, giving
        // us a selection change event before the DOM changes are
        // reported.
        // Chrome Android has a similar issue when backspacing out a
        // selection (#645).
        if (($7beee9608540d2c3$var$browser.ie && $7beee9608540d2c3$var$browser.ie_version <= 11 || $7beee9608540d2c3$var$browser.android && $7beee9608540d2c3$var$browser.chrome) && !view.state.selection.main.empty && // (Selection.isCollapsed isn't reliable on IE)
        sel.focusNode && $7beee9608540d2c3$var$isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset)) this.flushSoon();
        else this.flush(false);
    }
    readSelectionRange() {
        let { view: view } = this;
        // The Selection object is broken in shadow roots in Safari. See
        // issue #414
        let selection = $7beee9608540d2c3$var$getSelection(view.root);
        if (!selection) return false;
        let range = $7beee9608540d2c3$var$browser.safari && view.root.nodeType == 11 && view.root.activeElement == this.dom && $7beee9608540d2c3$var$safariSelectionRangeHack(this.view, selection) || selection;
        if (!range || this.selectionRange.eq(range)) return false;
        let local = $7beee9608540d2c3$var$hasSelection(this.dom, range);
        // Detect the situation where the browser has, on focus, moved the
        // selection to the start of the content element. Reset it to the
        // position from the editor state.
        if (local && !this.selectionChanged && view.inputState.lastFocusTime > Date.now() - 200 && view.inputState.lastTouchTime < Date.now() - 300 && $7beee9608540d2c3$var$atElementStart(this.dom, range)) {
            this.view.inputState.lastFocusTime = 0;
            view.docView.updateSelection();
            return false;
        }
        this.selectionRange.setRange(range);
        if (local) this.selectionChanged = true;
        return true;
    }
    setSelectionRange(anchor, head) {
        this.selectionRange.set(anchor.node, anchor.offset, head.node, head.offset);
        this.selectionChanged = false;
    }
    clearSelectionRange() {
        this.selectionRange.set(null, 0, null, 0);
    }
    listenForScroll() {
        this.parentCheck = -1;
        let i = 0, changed = null;
        for(let dom = this.dom; dom;){
            if (dom.nodeType == 1) {
                if (!changed && i < this.scrollTargets.length && this.scrollTargets[i] == dom) i++;
                else if (!changed) changed = this.scrollTargets.slice(0, i);
                if (changed) changed.push(dom);
                dom = dom.assignedSlot || dom.parentNode;
            } else if (dom.nodeType == 11) dom = dom.host;
            else break;
        }
        if (i < this.scrollTargets.length && !changed) changed = this.scrollTargets.slice(0, i);
        if (changed) {
            for (let dom of this.scrollTargets)dom.removeEventListener("scroll", this.onScroll);
            for (let dom of this.scrollTargets = changed)dom.addEventListener("scroll", this.onScroll);
        }
    }
    ignore(f) {
        if (!this.active) return f();
        try {
            this.stop();
            return f();
        } finally{
            this.start();
            this.clear();
        }
    }
    start() {
        if (this.active) return;
        this.observer.observe(this.dom, $7beee9608540d2c3$var$observeOptions);
        if ($7beee9608540d2c3$var$useCharData) this.dom.addEventListener("DOMCharacterDataModified", this.onCharData);
        this.active = true;
    }
    stop() {
        if (!this.active) return;
        this.active = false;
        this.observer.disconnect();
        if ($7beee9608540d2c3$var$useCharData) this.dom.removeEventListener("DOMCharacterDataModified", this.onCharData);
    }
    // Throw away any pending changes
    clear() {
        this.processRecords();
        this.queue.length = 0;
        this.selectionChanged = false;
    }
    // Chrome Android, especially in combination with GBoard, not only
    // doesn't reliably fire regular key events, but also often
    // surrounds the effect of enter or backspace with a bunch of
    // composition events that, when interrupted, cause text duplication
    // or other kinds of corruption. This hack makes the editor back off
    // from handling DOM changes for a moment when such a key is
    // detected (via beforeinput or keydown), and then tries to flush
    // them or, if that has no effect, dispatches the given key.
    delayAndroidKey(key, keyCode) {
        var _a;
        if (!this.delayedAndroidKey) {
            let flush = ()=>{
                let key = this.delayedAndroidKey;
                if (key) {
                    this.clearDelayedAndroidKey();
                    this.view.inputState.lastKeyCode = key.keyCode;
                    this.view.inputState.lastKeyTime = Date.now();
                    let flushed = this.flush();
                    if (!flushed && key.force) $7beee9608540d2c3$var$dispatchKey(this.dom, key.key, key.keyCode);
                }
            };
            this.flushingAndroidKey = this.view.win.requestAnimationFrame(flush);
        }
        // Since backspace beforeinput is sometimes signalled spuriously,
        // Enter always takes precedence.
        if (!this.delayedAndroidKey || key == "Enter") this.delayedAndroidKey = {
            key: key,
            keyCode: keyCode,
            // Only run the key handler when no changes are detected if
            // this isn't coming right after another change, in which case
            // it is probably part of a weird chain of updates, and should
            // be ignored if it returns the DOM to its previous state.
            force: this.lastChange < Date.now() - 50 || !!((_a = this.delayedAndroidKey) === null || _a === void 0 ? void 0 : _a.force)
        };
    }
    clearDelayedAndroidKey() {
        this.win.cancelAnimationFrame(this.flushingAndroidKey);
        this.delayedAndroidKey = null;
        this.flushingAndroidKey = -1;
    }
    flushSoon() {
        if (this.delayedFlush < 0) this.delayedFlush = this.view.win.requestAnimationFrame(()=>{
            this.delayedFlush = -1;
            this.flush();
        });
    }
    forceFlush() {
        if (this.delayedFlush >= 0) {
            this.view.win.cancelAnimationFrame(this.delayedFlush);
            this.delayedFlush = -1;
        }
        this.flush();
    }
    pendingRecords() {
        for (let mut of this.observer.takeRecords())this.queue.push(mut);
        return this.queue;
    }
    processRecords() {
        let records = this.pendingRecords();
        if (records.length) this.queue = [];
        let from = -1, to = -1, typeOver = false;
        for (let record of records){
            let range = this.readMutation(record);
            if (!range) continue;
            if (range.typeOver) typeOver = true;
            if (from == -1) ({ from: from, to: to } = range);
            else {
                from = Math.min(range.from, from);
                to = Math.max(range.to, to);
            }
        }
        return {
            from: from,
            to: to,
            typeOver: typeOver
        };
    }
    readChange() {
        let { from: from, to: to, typeOver: typeOver } = this.processRecords();
        let newSel = this.selectionChanged && $7beee9608540d2c3$var$hasSelection(this.dom, this.selectionRange);
        if (from < 0 && !newSel) return null;
        if (from > -1) this.lastChange = Date.now();
        this.view.inputState.lastFocusTime = 0;
        this.selectionChanged = false;
        let change = new $7beee9608540d2c3$var$DOMChange(this.view, from, to, typeOver);
        this.view.docView.domChanged = {
            newSel: change.newSel ? change.newSel.main : null
        };
        return change;
    }
    // Apply pending changes, if any
    flush(readSelection = true) {
        // Completely hold off flushing when pending keys are set—the code
        // managing those will make sure processRecords is called and the
        // view is resynchronized after
        if (this.delayedFlush >= 0 || this.delayedAndroidKey) return false;
        if (readSelection) this.readSelectionRange();
        let domChange = this.readChange();
        if (!domChange) {
            this.view.requestMeasure();
            return false;
        }
        let startState = this.view.state;
        let handled = $7beee9608540d2c3$var$applyDOMChange(this.view, domChange);
        // The view wasn't updated but DOM/selection changes were seen. Reset the view.
        if (this.view.state == startState && (domChange.domChanged || domChange.newSel && !$7beee9608540d2c3$var$sameSelPos(this.view.state.selection, domChange.newSel.main))) this.view.update([]);
        return handled;
    }
    readMutation(rec) {
        let tile = this.view.docView.tile.nearest(rec.target);
        if (!tile || tile.isWidget()) return null;
        tile.markDirty(rec.type == "attributes");
        if (rec.type == "childList") {
            let childBefore = $7beee9608540d2c3$var$findChild(tile, rec.previousSibling || rec.target.previousSibling, -1);
            let childAfter = $7beee9608540d2c3$var$findChild(tile, rec.nextSibling || rec.target.nextSibling, 1);
            return {
                from: childBefore ? tile.posAfter(childBefore) : tile.posAtStart,
                to: childAfter ? tile.posBefore(childAfter) : tile.posAtEnd,
                typeOver: false
            };
        } else if (rec.type == "characterData") return {
            from: tile.posAtStart,
            to: tile.posAtEnd,
            typeOver: rec.target.nodeValue == rec.oldValue
        };
        else return null;
    }
    setWindow(win) {
        if (win != this.win) {
            this.removeWindowListeners(this.win);
            this.win = win;
            this.addWindowListeners(this.win);
        }
    }
    addWindowListeners(win) {
        win.addEventListener("resize", this.onResize);
        if (this.printQuery) {
            if (this.printQuery.addEventListener) this.printQuery.addEventListener("change", this.onPrint);
            else this.printQuery.addListener(this.onPrint);
        } else win.addEventListener("beforeprint", this.onPrint);
        win.addEventListener("scroll", this.onScroll);
        win.document.addEventListener("selectionchange", this.onSelectionChange);
    }
    removeWindowListeners(win) {
        win.removeEventListener("scroll", this.onScroll);
        win.removeEventListener("resize", this.onResize);
        if (this.printQuery) {
            if (this.printQuery.removeEventListener) this.printQuery.removeEventListener("change", this.onPrint);
            else this.printQuery.removeListener(this.onPrint);
        } else win.removeEventListener("beforeprint", this.onPrint);
        win.document.removeEventListener("selectionchange", this.onSelectionChange);
    }
    update(update) {
        if (this.editContext) {
            this.editContext.update(update);
            if (update.startState.facet($7beee9608540d2c3$var$editable) != update.state.facet($7beee9608540d2c3$var$editable)) update.view.contentDOM.editContext = update.state.facet($7beee9608540d2c3$var$editable) ? this.editContext.editContext : null;
        }
    }
    destroy() {
        var _a, _b, _c;
        this.stop();
        (_a = this.intersection) === null || _a === void 0 || _a.disconnect();
        (_b = this.gapIntersection) === null || _b === void 0 || _b.disconnect();
        (_c = this.resizeScroll) === null || _c === void 0 || _c.disconnect();
        for (let dom of this.scrollTargets)dom.removeEventListener("scroll", this.onScroll);
        this.removeWindowListeners(this.win);
        clearTimeout(this.parentCheck);
        clearTimeout(this.resizeTimeout);
        this.win.cancelAnimationFrame(this.delayedFlush);
        this.win.cancelAnimationFrame(this.flushingAndroidKey);
        if (this.editContext) {
            this.view.contentDOM.editContext = null;
            this.editContext.destroy();
        }
    }
}
function $7beee9608540d2c3$var$findChild(tile, dom, dir) {
    while(dom){
        let curTile = $7beee9608540d2c3$var$Tile.get(dom);
        if (curTile && curTile.parent == tile) return curTile;
        let parent = dom.parentNode;
        dom = parent != tile.dom ? parent : dir > 0 ? dom.nextSibling : dom.previousSibling;
    }
    return null;
}
function $7beee9608540d2c3$var$buildSelectionRangeFromRange(view, range) {
    let anchorNode = range.startContainer, anchorOffset = range.startOffset;
    let focusNode = range.endContainer, focusOffset = range.endOffset;
    let curAnchor = view.docView.domAtPos(view.state.selection.main.anchor, 1);
    // Since such a range doesn't distinguish between anchor and head,
    // use a heuristic that flips it around if its end matches the
    // current anchor.
    if ($7beee9608540d2c3$var$isEquivalentPosition(curAnchor.node, curAnchor.offset, focusNode, focusOffset)) [anchorNode, anchorOffset, focusNode, focusOffset] = [
        focusNode,
        focusOffset,
        anchorNode,
        anchorOffset
    ];
    return {
        anchorNode: anchorNode,
        anchorOffset: anchorOffset,
        focusNode: focusNode,
        focusOffset: focusOffset
    };
}
// Used to work around a Safari Selection/shadow DOM bug (#414)
function $7beee9608540d2c3$var$safariSelectionRangeHack(view, selection) {
    if (selection.getComposedRanges) {
        let range = selection.getComposedRanges(view.root)[0];
        if (range) return $7beee9608540d2c3$var$buildSelectionRangeFromRange(view, range);
    }
    let found = null;
    // Because Safari (at least in 2018-2021) doesn't provide regular
    // access to the selection inside a shadowroot, we have to perform a
    // ridiculous hack to get at it—using `execCommand` to trigger a
    // `beforeInput` event so that we can read the target range from the
    // event.
    function read(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        found = event.getTargetRanges()[0];
    }
    view.contentDOM.addEventListener("beforeinput", read, true);
    view.dom.ownerDocument.execCommand("indent");
    view.contentDOM.removeEventListener("beforeinput", read, true);
    return found ? $7beee9608540d2c3$var$buildSelectionRangeFromRange(view, found) : null;
}
class $7beee9608540d2c3$var$EditContextManager {
    constructor(view){
        // The document window for which the text in the context is
        // maintained. For large documents, this may be smaller than the
        // editor document. This window always includes the selection head.
        this.from = 0;
        this.to = 0;
        // When applying a transaction, this is used to compare the change
        // made to the context content to the change in the transaction in
        // order to make the minimal changes to the context (since touching
        // that sometimes breaks series of multiple edits made for a single
        // user action on some Android keyboards)
        this.pendingContextChange = null;
        this.handlers = Object.create(null);
        // Kludge to work around the fact that EditContext does not respond
        // well to having its content updated during a composition (see #1472)
        this.composing = null;
        this.resetRange(view.state);
        let context = this.editContext = new window.EditContext({
            text: view.state.doc.sliceString(this.from, this.to),
            selectionStart: this.toContextPos(Math.max(this.from, Math.min(this.to, view.state.selection.main.anchor))),
            selectionEnd: this.toContextPos(view.state.selection.main.head)
        });
        this.handlers.textupdate = (e)=>{
            let main = view.state.selection.main, { anchor: anchor, head: head } = main;
            let from = this.toEditorPos(e.updateRangeStart), to = this.toEditorPos(e.updateRangeEnd);
            if (view.inputState.composing >= 0 && !this.composing) this.composing = {
                contextBase: e.updateRangeStart,
                editorBase: from,
                drifted: false
            };
            let deletes = to - from > e.text.length;
            // If the window doesn't include the anchor, assume changes
            // adjacent to a side go up to the anchor.
            if (from == this.from && anchor < this.from) from = anchor;
            else if (to == this.to && anchor > this.to) to = anchor;
            let diff = $7beee9608540d2c3$var$findDiff(view.state.sliceDoc(from, to), e.text, (deletes ? main.from : main.to) - from, deletes ? "end" : null);
            // Edit contexts sometimes fire empty changes
            if (!diff) {
                let newSel = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).single(this.toEditorPos(e.selectionStart), this.toEditorPos(e.selectionEnd));
                if (!$7beee9608540d2c3$var$sameSelPos(newSel, main)) view.dispatch({
                    selection: newSel,
                    userEvent: "select"
                });
                return;
            }
            let change = {
                from: diff.from + from,
                to: diff.toA + from,
                insert: (0, $6295c6875f57e3ee$export$5f1af8db9871e1d6).of(e.text.slice(diff.from, diff.toB).split("\n"))
            };
            if (($7beee9608540d2c3$var$browser.mac || $7beee9608540d2c3$var$browser.android) && change.from == head - 1 && /^\. ?$/.test(e.text) && view.contentDOM.getAttribute("autocorrect") == "off") change = {
                from: from,
                to: to,
                insert: (0, $6295c6875f57e3ee$export$5f1af8db9871e1d6).of([
                    e.text.replace(".", " ")
                ])
            };
            this.pendingContextChange = change;
            if (!view.state.readOnly) {
                let newLen = this.to - this.from + (change.to - change.from + change.insert.length);
                $7beee9608540d2c3$var$applyDOMChangeInner(view, change, (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).single(this.toEditorPos(e.selectionStart, newLen), this.toEditorPos(e.selectionEnd, newLen)));
            }
            // If the transaction didn't flush our change, revert it so
            // that the context is in sync with the editor state again.
            if (this.pendingContextChange) {
                this.revertPending(view.state);
                this.setSelection(view.state);
            }
            // Work around missed compositionend events. See https://discuss.codemirror.net/t/a/9514
            if (change.from < change.to && !change.insert.length && view.inputState.composing >= 0 && !/[\\p{Alphabetic}\\p{Number}_]/.test(context.text.slice(Math.max(0, e.updateRangeStart - 1), Math.min(context.text.length, e.updateRangeStart + 1)))) this.handlers.compositionend(e);
        };
        this.handlers.characterboundsupdate = (e)=>{
            let rects = [], prev = null;
            for(let i = this.toEditorPos(e.rangeStart), end = this.toEditorPos(e.rangeEnd); i < end; i++){
                let rect = view.coordsForChar(i);
                prev = rect && new DOMRect(rect.left, rect.top, rect.right - rect.left, rect.bottom - rect.top) || prev || new DOMRect;
                rects.push(prev);
            }
            context.updateCharacterBounds(e.rangeStart, rects);
        };
        this.handlers.textformatupdate = (e)=>{
            let deco = [];
            for (let format of e.getTextFormats()){
                let lineStyle = format.underlineStyle, thickness = format.underlineThickness;
                if (!/none/i.test(lineStyle) && !/none/i.test(thickness)) {
                    let from = this.toEditorPos(format.rangeStart), to = this.toEditorPos(format.rangeEnd);
                    if (from < to) {
                        // These values changed from capitalized custom strings to lower-case CSS keywords in 2025
                        let style = `text-decoration: underline ${/^[a-z]/.test(lineStyle) ? lineStyle + " " : lineStyle == "Dashed" ? "dashed " : lineStyle == "Squiggle" ? "wavy " : ""}${/thin/i.test(thickness) ? 1 : 2}px`;
                        deco.push($7beee9608540d2c3$export$10e30b733df217ea.mark({
                            attributes: {
                                style: style
                            }
                        }).range(from, to));
                    }
                }
            }
            view.dispatch({
                effects: $7beee9608540d2c3$var$setEditContextFormatting.of($7beee9608540d2c3$export$10e30b733df217ea.set(deco))
            });
        };
        this.handlers.compositionstart = ()=>{
            if (view.inputState.composing < 0) {
                view.inputState.composing = 0;
                view.inputState.compositionFirstChange = true;
            }
        };
        this.handlers.compositionend = ()=>{
            view.inputState.composing = -1;
            view.inputState.compositionFirstChange = null;
            if (this.composing) {
                let { drifted: drifted } = this.composing;
                this.composing = null;
                if (drifted) this.reset(view.state);
            }
        };
        for(let event in this.handlers)context.addEventListener(event, this.handlers[event]);
        this.measureReq = {
            read: (view)=>{
                this.editContext.updateControlBounds(view.contentDOM.getBoundingClientRect());
                let sel = $7beee9608540d2c3$var$getSelection(view.root);
                if (sel && sel.rangeCount) this.editContext.updateSelectionBounds(sel.getRangeAt(0).getBoundingClientRect());
            }
        };
    }
    applyEdits(update) {
        let off = 0, abort = false, pending = this.pendingContextChange;
        update.changes.iterChanges((fromA, toA, _fromB, _toB, insert)=>{
            if (abort) return;
            let dLen = insert.length - (toA - fromA);
            if (pending && toA >= pending.to) {
                if (pending.from == fromA && pending.to == toA && pending.insert.eq(insert)) {
                    pending = this.pendingContextChange = null; // Match
                    off += dLen;
                    this.to += dLen;
                    return;
                } else {
                    pending = null;
                    this.revertPending(update.state);
                }
            }
            fromA += off;
            toA += off;
            if (toA <= this.from) {
                this.from += dLen;
                this.to += dLen;
            } else if (fromA < this.to) {
                if (fromA < this.from || toA > this.to || this.to - this.from + insert.length > 30000 /* CxVp.MaxSize */ ) {
                    abort = true;
                    return;
                }
                this.editContext.updateText(this.toContextPos(fromA), this.toContextPos(toA), insert.toString());
                this.to += dLen;
            }
            off += dLen;
        });
        if (pending && !abort) this.revertPending(update.state);
        return !abort;
    }
    update(update) {
        let reverted = this.pendingContextChange, startSel = update.startState.selection.main;
        if (this.composing && (this.composing.drifted || !update.changes.touchesRange(startSel.from, startSel.to) && update.transactions.some((tr)=>!tr.isUserEvent("input.type") && tr.changes.touchesRange(this.from, this.to)))) {
            this.composing.drifted = true;
            this.composing.editorBase = update.changes.mapPos(this.composing.editorBase);
        } else if (!this.applyEdits(update) || !this.rangeIsValid(update.state)) {
            this.pendingContextChange = null;
            this.reset(update.state);
        } else if (update.docChanged || update.selectionSet || reverted) this.setSelection(update.state);
        if (update.geometryChanged || update.docChanged || update.selectionSet) update.view.requestMeasure(this.measureReq);
    }
    resetRange(state) {
        let { head: head } = state.selection.main;
        this.from = Math.max(0, head - 10000 /* CxVp.Margin */ );
        this.to = Math.min(state.doc.length, head + 10000 /* CxVp.Margin */ );
    }
    reset(state) {
        this.resetRange(state);
        this.editContext.updateText(0, this.editContext.text.length, state.doc.sliceString(this.from, this.to));
        this.setSelection(state);
    }
    revertPending(state) {
        let pending = this.pendingContextChange;
        this.pendingContextChange = null;
        this.editContext.updateText(this.toContextPos(pending.from), this.toContextPos(pending.from + pending.insert.length), state.doc.sliceString(pending.from, pending.to));
    }
    setSelection(state) {
        let { main: main } = state.selection;
        let start = this.toContextPos(Math.max(this.from, Math.min(this.to, main.anchor)));
        let end = this.toContextPos(main.head);
        if (this.editContext.selectionStart != start || this.editContext.selectionEnd != end) this.editContext.updateSelection(start, end);
    }
    rangeIsValid(state) {
        let { head: head } = state.selection.main;
        return !(this.from > 0 && head - this.from < 500 /* CxVp.MinMargin */  || this.to < state.doc.length && this.to - head < 500 /* CxVp.MinMargin */  || this.to - this.from > 30000);
    }
    toEditorPos(contextPos, clipLen = this.to - this.from) {
        contextPos = Math.min(contextPos, clipLen);
        let c = this.composing;
        return c && c.drifted ? c.editorBase + (contextPos - c.contextBase) : contextPos + this.from;
    }
    toContextPos(editorPos) {
        let c = this.composing;
        return c && c.drifted ? c.contextBase + (editorPos - c.editorBase) : editorPos - this.from;
    }
    destroy() {
        for(let event in this.handlers)this.editContext.removeEventListener(event, this.handlers[event]);
    }
}
// The editor's update state machine looks something like this:
//
//     Idle → Updating ⇆ Idle (unchecked) → Measuring → Idle
//                                         ↑      ↓
//                                         Updating (measure)
//
// The difference between 'Idle' and 'Idle (unchecked)' lies in
// whether a layout check has been scheduled. A regular update through
// the `update` method updates the DOM in a write-only fashion, and
// relies on a check (scheduled with `requestAnimationFrame`) to make
// sure everything is where it should be and the viewport covers the
// visible code. That check continues to measure and then optionally
// update until it reaches a coherent state.
/**
An editor view represents the editor's user interface. It holds
the editable DOM surface, and possibly other elements such as the
line number gutter. It handles events and dispatches state
transactions for editing actions.
*/ class $7beee9608540d2c3$export$eece2fccabbb77c5 {
    /**
    The current editor state.
    */ get state() {
        return this.viewState.state;
    }
    /**
    To be able to display large documents without consuming too much
    memory or overloading the browser, CodeMirror only draws the
    code that is visible (plus a margin around it) to the DOM. This
    property tells you the extent of the current drawn viewport, in
    document positions.
    */ get viewport() {
        return this.viewState.viewport;
    }
    /**
    When there are, for example, large collapsed ranges in the
    viewport, its size can be a lot bigger than the actual visible
    content. Thus, if you are doing something like styling the
    content in the viewport, it is preferable to only do so for
    these ranges, which are the subset of the viewport that is
    actually drawn.
    */ get visibleRanges() {
        return this.viewState.visibleRanges;
    }
    /**
    Returns false when the editor is entirely scrolled out of view
    or otherwise hidden.
    */ get inView() {
        return this.viewState.inView;
    }
    /**
    Indicates whether the user is currently composing text via
    [IME](https://en.wikipedia.org/wiki/Input_method), and at least
    one change has been made in the current composition.
    */ get composing() {
        return !!this.inputState && this.inputState.composing > 0;
    }
    /**
    Indicates whether the user is currently in composing state. Note
    that on some platforms, like Android, this will be the case a
    lot, since just putting the cursor on a word starts a
    composition there.
    */ get compositionStarted() {
        return !!this.inputState && this.inputState.composing >= 0;
    }
    /**
    The document or shadow root that the view lives in.
    */ get root() {
        return this._root;
    }
    /**
    @internal
    */ get win() {
        return this.dom.ownerDocument.defaultView || window;
    }
    /**
    Construct a new view. You'll want to either provide a `parent`
    option, or put `view.dom` into your document after creating a
    view, so that the user can see the editor.
    */ constructor(config = {}){
        var _a;
        this.plugins = [];
        this.pluginMap = new Map;
        this.editorAttrs = {};
        this.contentAttrs = {};
        this.bidiCache = [];
        this.destroyed = false;
        /**
        @internal
        */ this.updateState = 2 /* UpdateState.Updating */ ;
        /**
        @internal
        */ this.measureScheduled = -1;
        /**
        @internal
        */ this.measureRequests = [];
        this.contentDOM = document.createElement("div");
        this.scrollDOM = document.createElement("div");
        this.scrollDOM.tabIndex = -1;
        this.scrollDOM.className = "cm-scroller";
        this.scrollDOM.appendChild(this.contentDOM);
        this.announceDOM = document.createElement("div");
        this.announceDOM.className = "cm-announced";
        this.announceDOM.setAttribute("aria-live", "polite");
        this.dom = document.createElement("div");
        this.dom.appendChild(this.announceDOM);
        this.dom.appendChild(this.scrollDOM);
        if (config.parent) config.parent.appendChild(this.dom);
        let { dispatch: dispatch } = config;
        this.dispatchTransactions = config.dispatchTransactions || dispatch && ((trs)=>trs.forEach((tr)=>dispatch(tr, this))) || ((trs)=>this.update(trs));
        this.dispatch = this.dispatch.bind(this);
        this._root = config.root || $7beee9608540d2c3$var$getRoot(config.parent) || document;
        this.viewState = new $7beee9608540d2c3$var$ViewState(this, config.state || (0, $6295c6875f57e3ee$export$afa855cbfaff27f2).create(config));
        if (config.scrollTo && config.scrollTo.is($7beee9608540d2c3$var$scrollIntoView)) this.viewState.scrollTarget = config.scrollTo.value.clip(this.viewState.state);
        this.plugins = this.state.facet($7beee9608540d2c3$var$viewPlugin).map((spec)=>new $7beee9608540d2c3$var$PluginInstance(spec));
        for (let plugin of this.plugins)plugin.update(this);
        this.observer = new $7beee9608540d2c3$var$DOMObserver(this);
        this.inputState = new $7beee9608540d2c3$var$InputState(this);
        this.inputState.ensureHandlers(this.plugins);
        this.docView = new $7beee9608540d2c3$var$DocView(this);
        this.mountStyles();
        this.updateAttrs();
        this.updateState = 0 /* UpdateState.Idle */ ;
        this.requestMeasure();
        if ((_a = document.fonts) === null || _a === void 0 ? void 0 : _a.ready) document.fonts.ready.then(()=>{
            this.viewState.mustMeasureContent = "refresh";
            this.requestMeasure();
        });
    }
    dispatch(...input) {
        let trs = input.length == 1 && input[0] instanceof (0, $6295c6875f57e3ee$export$febc5573c75cefb0) ? input : input.length == 1 && Array.isArray(input[0]) ? input[0] : [
            this.state.update(...input)
        ];
        this.dispatchTransactions(trs, this);
    }
    /**
    Update the view for the given array of transactions. This will
    update the visible document and selection to match the state
    produced by the transactions, and notify view plugins of the
    change. You should usually call
    [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead, which uses this
    as a primitive.
    */ update(transactions) {
        if (this.updateState != 0 /* UpdateState.Idle */ ) throw new Error("Calls to EditorView.update are not allowed while an update is in progress");
        let redrawn = false, attrsChanged = false, update;
        let state = this.state;
        for (let tr of transactions){
            if (tr.startState != state) throw new RangeError("Trying to update state with a transaction that doesn't start from the previous state.");
            state = tr.state;
        }
        if (this.destroyed) {
            this.viewState.state = state;
            return;
        }
        let focus = this.hasFocus, focusFlag = 0, dispatchFocus = null;
        if (transactions.some((tr)=>tr.annotation($7beee9608540d2c3$var$isFocusChange))) {
            this.inputState.notifiedFocused = focus;
            // If a focus-change transaction is being dispatched, set this update flag.
            focusFlag = 1 /* UpdateFlag.Focus */ ;
        } else if (focus != this.inputState.notifiedFocused) {
            this.inputState.notifiedFocused = focus;
            // Schedule a separate focus transaction if necessary, otherwise
            // add a flag to this update
            dispatchFocus = $7beee9608540d2c3$var$focusChangeTransaction(state, focus);
            if (!dispatchFocus) focusFlag = 1 /* UpdateFlag.Focus */ ;
        }
        // If there was a pending DOM change, eagerly read it and try to
        // apply it after the given transactions.
        let pendingKey = this.observer.delayedAndroidKey, domChange = null;
        if (pendingKey) {
            this.observer.clearDelayedAndroidKey();
            domChange = this.observer.readChange();
            // Only try to apply DOM changes if the transactions didn't
            // change the doc or selection.
            if (domChange && !this.state.doc.eq(state.doc) || !this.state.selection.eq(state.selection)) domChange = null;
        } else this.observer.clear();
        // When the phrases change, redraw the editor
        if (state.facet((0, $6295c6875f57e3ee$export$afa855cbfaff27f2).phrases) != this.state.facet((0, $6295c6875f57e3ee$export$afa855cbfaff27f2).phrases)) return this.setState(state);
        update = $7beee9608540d2c3$export$b5b084f95c87edf7.create(this, state, transactions);
        update.flags |= focusFlag;
        let scrollTarget = this.viewState.scrollTarget;
        try {
            this.updateState = 2 /* UpdateState.Updating */ ;
            for (let tr of transactions){
                if (scrollTarget) scrollTarget = scrollTarget.map(tr.changes);
                if (tr.scrollIntoView) {
                    let { main: main } = tr.state.selection;
                    let { x: x, y: y } = this.state.facet($7beee9608540d2c3$export$eece2fccabbb77c5.cursorScrollMargin);
                    scrollTarget = new $7beee9608540d2c3$var$ScrollTarget(main.empty ? main : (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(main.head, main.head > main.anchor ? -1 : 1), "nearest", "nearest", y, x);
                }
                for (let e of tr.effects)if (e.is($7beee9608540d2c3$var$scrollIntoView)) scrollTarget = e.value.clip(this.state);
            }
            this.viewState.update(update, scrollTarget);
            this.bidiCache = $7beee9608540d2c3$var$CachedOrder.update(this.bidiCache, update.changes);
            if (!update.empty) {
                this.updatePlugins(update);
                this.inputState.update(update);
            }
            redrawn = this.docView.update(update);
            if (this.state.facet($7beee9608540d2c3$var$styleModule) != this.styleModules) this.mountStyles();
            attrsChanged = this.updateAttrs();
            this.showAnnouncements(transactions);
            this.docView.updateSelection(redrawn, transactions.some((tr)=>tr.isUserEvent("select.pointer")));
        } finally{
            this.updateState = 0 /* UpdateState.Idle */ ;
        }
        if (update.startState.facet($7beee9608540d2c3$var$theme) != update.state.facet($7beee9608540d2c3$var$theme)) this.viewState.mustMeasureContent = true;
        if (redrawn || attrsChanged || scrollTarget || this.viewState.mustEnforceCursorAssoc || this.viewState.mustMeasureContent) this.requestMeasure();
        if (redrawn) this.docViewUpdate();
        if (!update.empty) for (let listener of this.state.facet($7beee9608540d2c3$var$updateListener))try {
            listener(update);
        } catch (e) {
            $7beee9608540d2c3$export$f86b2a1a2ce291b3(this.state, e, "update listener");
        }
        if (dispatchFocus || domChange) Promise.resolve().then(()=>{
            if (dispatchFocus && this.state == dispatchFocus.startState) this.dispatch(dispatchFocus);
            if (domChange) {
                if (!$7beee9608540d2c3$var$applyDOMChange(this, domChange) && pendingKey.force) $7beee9608540d2c3$var$dispatchKey(this.contentDOM, pendingKey.key, pendingKey.keyCode);
            }
        });
    }
    /**
    Reset the view to the given state. (This will cause the entire
    document to be redrawn and all view plugins to be reinitialized,
    so you should probably only use it when the new state isn't
    derived from the old state. Otherwise, use
    [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead.)
    */ setState(newState) {
        if (this.updateState != 0 /* UpdateState.Idle */ ) throw new Error("Calls to EditorView.setState are not allowed while an update is in progress");
        if (this.destroyed) {
            this.viewState.state = newState;
            return;
        }
        this.updateState = 2 /* UpdateState.Updating */ ;
        let hadFocus = this.hasFocus;
        try {
            for (let plugin of this.plugins)plugin.destroy(this);
            this.viewState = new $7beee9608540d2c3$var$ViewState(this, newState);
            this.plugins = newState.facet($7beee9608540d2c3$var$viewPlugin).map((spec)=>new $7beee9608540d2c3$var$PluginInstance(spec));
            this.pluginMap.clear();
            for (let plugin of this.plugins)plugin.update(this);
            this.docView.destroy();
            this.docView = new $7beee9608540d2c3$var$DocView(this);
            this.inputState.ensureHandlers(this.plugins);
            this.mountStyles();
            this.updateAttrs();
            this.bidiCache = [];
        } finally{
            this.updateState = 0 /* UpdateState.Idle */ ;
        }
        if (hadFocus) this.focus();
        this.requestMeasure();
    }
    updatePlugins(update) {
        let prevSpecs = update.startState.facet($7beee9608540d2c3$var$viewPlugin), specs = update.state.facet($7beee9608540d2c3$var$viewPlugin);
        if (prevSpecs != specs) {
            let newPlugins = [];
            for (let spec of specs){
                let found = prevSpecs.indexOf(spec);
                if (found < 0) newPlugins.push(new $7beee9608540d2c3$var$PluginInstance(spec));
                else {
                    let plugin = this.plugins[found];
                    plugin.mustUpdate = update;
                    newPlugins.push(plugin);
                }
            }
            for (let plugin of this.plugins)if (plugin.mustUpdate != update) plugin.destroy(this);
            this.plugins = newPlugins;
            this.pluginMap.clear();
        } else for (let p of this.plugins)p.mustUpdate = update;
        for(let i = 0; i < this.plugins.length; i++)this.plugins[i].update(this);
        if (prevSpecs != specs) this.inputState.ensureHandlers(this.plugins);
    }
    docViewUpdate() {
        for (let plugin of this.plugins){
            let val = plugin.value;
            if (val && val.docViewUpdate) try {
                val.docViewUpdate(this);
            } catch (e) {
                $7beee9608540d2c3$export$f86b2a1a2ce291b3(this.state, e, "doc view update listener");
            }
        }
    }
    /**
    @internal
    */ measure(flush = true) {
        if (this.destroyed) return;
        if (this.measureScheduled > -1) this.win.cancelAnimationFrame(this.measureScheduled);
        if (this.observer.delayedAndroidKey) {
            this.measureScheduled = -1;
            this.requestMeasure();
            return;
        }
        this.measureScheduled = 0; // Prevent requestMeasure calls from scheduling another animation frame
        if (flush) this.observer.forceFlush();
        let updated = null;
        let scroll = this.viewState.scrollParent, scrollOffset = this.viewState.getScrollOffset();
        let { scrollAnchorPos: scrollAnchorPos, scrollAnchorHeight: scrollAnchorHeight } = this.viewState;
        if (Math.abs(scrollOffset - this.viewState.scrollOffset) > 1) scrollAnchorHeight = -1;
        this.viewState.scrollAnchorHeight = -1;
        try {
            for(let i = 0;; i++){
                if (scrollAnchorHeight < 0) {
                    if ($7beee9608540d2c3$var$isScrolledToBottom(scroll || this.win)) {
                        scrollAnchorPos = -1;
                        scrollAnchorHeight = this.viewState.heightMap.height;
                    } else {
                        let block = this.viewState.scrollAnchorAt(scrollOffset);
                        scrollAnchorPos = block.from;
                        scrollAnchorHeight = block.top;
                    }
                }
                this.updateState = 1 /* UpdateState.Measuring */ ;
                let changed = this.viewState.measure();
                if (!changed && !this.measureRequests.length && this.viewState.scrollTarget == null) break;
                if (i > 5) {
                    console.warn(this.measureRequests.length ? "Measure loop restarted more than 5 times" : "Viewport failed to stabilize");
                    break;
                }
                let measuring = [];
                // Only run measure requests in this cycle when the viewport didn't change
                if (!(changed & 4 /* UpdateFlag.Viewport */ )) [this.measureRequests, measuring] = [
                    measuring,
                    this.measureRequests
                ];
                let measured = measuring.map((m)=>{
                    try {
                        return m.read(this);
                    } catch (e) {
                        $7beee9608540d2c3$export$f86b2a1a2ce291b3(this.state, e);
                        return $7beee9608540d2c3$var$BadMeasure;
                    }
                });
                let update = $7beee9608540d2c3$export$b5b084f95c87edf7.create(this, this.state, []), redrawn = false;
                update.flags |= changed;
                if (!updated) updated = update;
                else updated.flags |= changed;
                this.updateState = 2 /* UpdateState.Updating */ ;
                if (!update.empty) {
                    this.updatePlugins(update);
                    this.inputState.update(update);
                    this.updateAttrs();
                    redrawn = this.docView.update(update);
                    if (redrawn) this.docViewUpdate();
                }
                for(let i = 0; i < measuring.length; i++)if (measured[i] != $7beee9608540d2c3$var$BadMeasure) try {
                    let m = measuring[i];
                    if (m.write) m.write(measured[i], this);
                } catch (e) {
                    $7beee9608540d2c3$export$f86b2a1a2ce291b3(this.state, e);
                }
                if (redrawn) this.docView.updateSelection(true);
                if (!update.viewportChanged && this.measureRequests.length == 0) {
                    if (this.viewState.editorHeight) {
                        if (this.viewState.scrollTarget) {
                            this.docView.scrollIntoView(this.viewState.scrollTarget);
                            this.viewState.scrollTarget = null;
                            scrollAnchorHeight = -1;
                            continue;
                        } else {
                            let newAnchorHeight = scrollAnchorPos < 0 ? this.viewState.heightMap.height : this.viewState.lineBlockAt(scrollAnchorPos).top;
                            let diff = (newAnchorHeight - scrollAnchorHeight) / this.scaleY;
                            if ((diff > 1 || diff < -1) && (scroll == this.scrollDOM || this.hasFocus || Math.max(this.inputState.lastWheelEvent, this.inputState.lastTouchTime) > Date.now() - 100)) {
                                scrollOffset = scrollOffset + diff;
                                if (scroll) scroll.scrollTop += diff;
                                else this.win.scrollBy(0, diff);
                                scrollAnchorHeight = -1;
                                continue;
                            }
                        }
                    }
                    break;
                }
            }
        } finally{
            this.updateState = 0 /* UpdateState.Idle */ ;
            this.measureScheduled = -1;
        }
        if (updated && !updated.empty) for (let listener of this.state.facet($7beee9608540d2c3$var$updateListener))listener(updated);
    }
    /**
    Get the CSS classes for the currently active editor themes.
    */ get themeClasses() {
        return $7beee9608540d2c3$var$baseThemeID + " " + (this.state.facet($7beee9608540d2c3$var$darkTheme) ? $7beee9608540d2c3$var$baseDarkID : $7beee9608540d2c3$var$baseLightID) + " " + this.state.facet($7beee9608540d2c3$var$theme);
    }
    updateAttrs() {
        let editorAttrs = $7beee9608540d2c3$var$attrsFromFacet(this, $7beee9608540d2c3$var$editorAttributes, {
            class: "cm-editor" + (this.hasFocus ? " cm-focused " : " ") + this.themeClasses
        });
        let contentAttrs = {
            spellcheck: "false",
            autocorrect: "off",
            autocapitalize: "off",
            writingsuggestions: "false",
            translate: "no",
            contenteditable: !this.state.facet($7beee9608540d2c3$var$editable) ? "false" : "true",
            class: "cm-content",
            style: `${$7beee9608540d2c3$var$browser.tabSize}: ${this.state.tabSize}`,
            role: "textbox",
            "aria-multiline": "true"
        };
        if (this.state.readOnly) contentAttrs["aria-readonly"] = "true";
        $7beee9608540d2c3$var$attrsFromFacet(this, $7beee9608540d2c3$var$contentAttributes, contentAttrs);
        let changed = this.observer.ignore(()=>{
            let changedContent = $7beee9608540d2c3$var$updateAttrs(this.contentDOM, this.contentAttrs, contentAttrs);
            let changedEditor = $7beee9608540d2c3$var$updateAttrs(this.dom, this.editorAttrs, editorAttrs);
            return changedContent || changedEditor;
        });
        this.editorAttrs = editorAttrs;
        this.contentAttrs = contentAttrs;
        return changed;
    }
    showAnnouncements(trs) {
        let first = true;
        for (let tr of trs)for (let effect of tr.effects)if (effect.is($7beee9608540d2c3$export$eece2fccabbb77c5.announce)) {
            if (first) this.announceDOM.textContent = "";
            first = false;
            let div = this.announceDOM.appendChild(document.createElement("div"));
            div.textContent = effect.value;
        }
    }
    mountStyles() {
        this.styleModules = this.state.facet($7beee9608540d2c3$var$styleModule);
        let nonce = this.state.facet($7beee9608540d2c3$export$eece2fccabbb77c5.cspNonce);
        (0, $afd7c6da9f842a17$export$b920c662d2efee20).mount(this.root, this.styleModules.concat($7beee9608540d2c3$var$baseTheme$1).reverse(), nonce ? {
            nonce: nonce
        } : undefined);
    }
    readMeasured() {
        if (this.updateState == 2 /* UpdateState.Updating */ ) throw new Error("Reading the editor layout isn't allowed during an update");
        if (this.updateState == 0 /* UpdateState.Idle */  && this.measureScheduled > -1) this.measure(false);
    }
    /**
    Schedule a layout measurement, optionally providing callbacks to
    do custom DOM measuring followed by a DOM write phase. Using
    this is preferable reading DOM layout directly from, for
    example, an event handler, because it'll make sure measuring and
    drawing done by other components is synchronized, avoiding
    unnecessary DOM layout computations.
    */ requestMeasure(request) {
        if (this.measureScheduled < 0) this.measureScheduled = this.win.requestAnimationFrame(()=>this.measure());
        if (request) {
            if (this.measureRequests.indexOf(request) > -1) return;
            if (request.key != null) {
                for(let i = 0; i < this.measureRequests.length; i++)if (this.measureRequests[i].key === request.key) {
                    this.measureRequests[i] = request;
                    return;
                }
            }
            this.measureRequests.push(request);
        }
    }
    /**
    Get the value of a specific plugin, if present. Note that
    plugins that crash can be dropped from a view, so even when you
    know you registered a given plugin, it is recommended to check
    the return value of this method.
    */ plugin(plugin) {
        let known = this.pluginMap.get(plugin);
        if (known === undefined || known && known.plugin != plugin) this.pluginMap.set(plugin, known = this.plugins.find((p)=>p.plugin == plugin) || null);
        return known && known.update(this).value;
    }
    /**
    The top position of the document, in screen coordinates. This
    may be negative when the editor is scrolled down. Points
    directly to the top of the first line, not above the padding.
    */ get documentTop() {
        return this.contentDOM.getBoundingClientRect().top + this.viewState.paddingTop;
    }
    /**
    Reports the padding above and below the document.
    */ get documentPadding() {
        return {
            top: this.viewState.paddingTop,
            bottom: this.viewState.paddingBottom
        };
    }
    /**
    If the editor is transformed with CSS, this provides the scale
    along the X axis. Otherwise, it will just be 1. Note that
    transforms other than translation and scaling are not supported.
    */ get scaleX() {
        return this.viewState.scaleX;
    }
    /**
    Provide the CSS transformed scale along the Y axis.
    */ get scaleY() {
        return this.viewState.scaleY;
    }
    /**
    Find the text line or block widget at the given vertical
    position (which is interpreted as relative to the [top of the
    document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop)).
    */ elementAtHeight(height) {
        this.readMeasured();
        return this.viewState.elementAtHeight(height);
    }
    /**
    Find the line block (see
    [`lineBlockAt`](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt)) at the given
    height, again interpreted relative to the [top of the
    document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop).
    */ lineBlockAtHeight(height) {
        this.readMeasured();
        return this.viewState.lineBlockAtHeight(height);
    }
    /**
    Get the extent and vertical position of all [line
    blocks](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt) in the viewport. Positions
    are relative to the [top of the
    document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop);
    */ get viewportLineBlocks() {
        return this.viewState.viewportLines;
    }
    /**
    Find the line block around the given document position. A line
    block is a range delimited on both sides by either a
    non-[hidden](https://codemirror.net/6/docs/ref/#view.Decoration^replace) line break, or the
    start/end of the document. It will usually just hold a line of
    text, but may be broken into multiple textblocks by block
    widgets.
    */ lineBlockAt(pos) {
        return this.viewState.lineBlockAt(pos);
    }
    /**
    The editor's total content height.
    */ get contentHeight() {
        return this.viewState.contentHeight;
    }
    /**
    Move a cursor position by [grapheme
    cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak). `forward` determines whether
    the motion is away from the line start, or towards it. In
    bidirectional text, the line is traversed in visual order, using
    the editor's [text direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection).
    When the start position was the last one on the line, the
    returned position will be across the line break. If there is no
    further line, the original position is returned.
    
    By default, this method moves over a single cluster. The
    optional `by` argument can be used to move across more. It will
    be called with the first cluster as argument, and should return
    a predicate that determines, for each subsequent cluster,
    whether it should also be moved over.
    */ moveByChar(start, forward, by) {
        return $7beee9608540d2c3$var$skipAtoms(this, start, $7beee9608540d2c3$var$moveByChar(this, start, forward, by));
    }
    /**
    Move a cursor position across the next group of either
    [letters](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) or non-letter
    non-whitespace characters.
    */ moveByGroup(start, forward) {
        return $7beee9608540d2c3$var$skipAtoms(this, start, $7beee9608540d2c3$var$moveByChar(this, start, forward, (initial)=>$7beee9608540d2c3$var$byGroup(this, start.head, initial)));
    }
    /**
    Get the cursor position visually at the start or end of a line.
    Note that this may differ from the _logical_ position at its
    start or end (which is simply at `line.from`/`line.to`) if text
    at the start or end goes against the line's base text direction.
    */ visualLineSide(line, end) {
        let order = this.bidiSpans(line), dir = this.textDirectionAt(line.from);
        let span = order[end ? order.length - 1 : 0];
        return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(span.side(end, dir) + line.from, span.forward(!end, dir) ? 1 : -1);
    }
    /**
    Move to the next line boundary in the given direction. If
    `includeWrap` is true, line wrapping is on, and there is a
    further wrap point on the current line, the wrap point will be
    returned. Otherwise this function will return the start or end
    of the line.
    */ moveToLineBoundary(start, forward, includeWrap = true) {
        return $7beee9608540d2c3$var$moveToLineBoundary(this, start, forward, includeWrap);
    }
    /**
    Move a cursor position vertically. When `distance` isn't given,
    it defaults to moving to the next line (including wrapped
    lines). Otherwise, `distance` should provide a positive distance
    in pixels.
    
    When `start` has a
    [`goalColumn`](https://codemirror.net/6/docs/ref/#state.SelectionRange.goalColumn), the vertical
    motion will use that as a target horizontal position. Otherwise,
    the cursor's own horizontal position is used. The returned
    cursor will have its goal column set to whichever column was
    used.
    */ moveVertically(start, forward, distance) {
        return $7beee9608540d2c3$var$skipAtoms(this, start, $7beee9608540d2c3$var$moveVertically(this, start, forward, distance));
    }
    /**
    Find the DOM parent node and offset (child offset if `node` is
    an element, character offset when it is a text node) at the
    given document position.
    
    Note that for positions that aren't currently in
    `visibleRanges`, the resulting DOM position isn't necessarily
    meaningful (it may just point before or after a placeholder
    element).
    */ domAtPos(pos, side = 1) {
        return this.docView.domAtPos(pos, side);
    }
    /**
    Find the document position at the given DOM node. Can be useful
    for associating positions with DOM events. Will raise an error
    when `node` isn't part of the editor content.
    */ posAtDOM(node, offset = 0) {
        return this.docView.posFromDOM(node, offset);
    }
    posAtCoords(coords, precise = true) {
        this.readMeasured();
        let found = $7beee9608540d2c3$var$posAtCoords(this, coords, precise);
        return found && found.pos;
    }
    posAndSideAtCoords(coords, precise = true) {
        this.readMeasured();
        return $7beee9608540d2c3$var$posAtCoords(this, coords, precise);
    }
    /**
    Get the screen coordinates at the given document position.
    `side` determines whether the coordinates are based on the
    element before (-1) or after (1) the position (if no element is
    available on the given side, the method will transparently use
    another strategy to get reasonable coordinates).
    */ coordsAtPos(pos, side = 1) {
        this.readMeasured();
        let rect = this.docView.coordsAt(pos, side);
        if (!rect || rect.left == rect.right) return rect;
        let line = this.state.doc.lineAt(pos), order = this.bidiSpans(line);
        let span = order[$7beee9608540d2c3$export$e1ed96b746bb516a.find(order, pos - line.from, -1, side)];
        return $7beee9608540d2c3$var$flattenRect(rect, span.dir == $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR == side > 0);
    }
    /**
    Return the rectangle around a given character. If `pos` does not
    point in front of a character that is in the viewport and
    rendered (i.e. not replaced, not a line break), this will return
    null. For space characters that are a line wrap point, this will
    return the position before the line break.
    */ coordsForChar(pos) {
        this.readMeasured();
        return this.docView.coordsForChar(pos);
    }
    /**
    The default width of a character in the editor. May not
    accurately reflect the width of all characters (given variable
    width fonts or styling of invididual ranges).
    */ get defaultCharacterWidth() {
        return this.viewState.heightOracle.charWidth;
    }
    /**
    The default height of a line in the editor. May not be accurate
    for all lines.
    */ get defaultLineHeight() {
        return this.viewState.heightOracle.lineHeight;
    }
    /**
    The text direction
    ([`direction`](https://developer.mozilla.org/en-US/docs/Web/CSS/direction)
    CSS property) of the editor's content element.
    */ get textDirection() {
        return this.viewState.defaultTextDirection;
    }
    /**
    Find the text direction of the block at the given position, as
    assigned by CSS. If
    [`perLineTextDirection`](https://codemirror.net/6/docs/ref/#view.EditorView^perLineTextDirection)
    isn't enabled, or the given position is outside of the viewport,
    this will always return the same as
    [`textDirection`](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection). Note that
    this may trigger a DOM layout.
    */ textDirectionAt(pos) {
        let perLine = this.state.facet($7beee9608540d2c3$var$perLineTextDirection);
        if (!perLine || pos < this.viewport.from || pos > this.viewport.to) return this.textDirection;
        this.readMeasured();
        return this.docView.textDirectionAt(pos);
    }
    /**
    Whether this editor [wraps lines](https://codemirror.net/6/docs/ref/#view.EditorView.lineWrapping)
    (as determined by the
    [`white-space`](https://developer.mozilla.org/en-US/docs/Web/CSS/white-space)
    CSS property of its content element).
    */ get lineWrapping() {
        return this.viewState.heightOracle.lineWrapping;
    }
    /**
    Returns the bidirectional text structure of the given line
    (which should be in the current document) as an array of span
    objects. The order of these spans matches the [text
    direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection)—if that is
    left-to-right, the leftmost spans come first, otherwise the
    rightmost spans come first.
    */ bidiSpans(line) {
        if (line.length > $7beee9608540d2c3$var$MaxBidiLine) return $7beee9608540d2c3$var$trivialOrder(line.length);
        let dir = this.textDirectionAt(line.from), isolates;
        for (let entry of this.bidiCache){
            if (entry.from == line.from && entry.dir == dir && (entry.fresh || $7beee9608540d2c3$var$isolatesEq(entry.isolates, isolates = $7beee9608540d2c3$var$getIsolatedRanges(this, line)))) return entry.order;
        }
        if (!isolates) isolates = $7beee9608540d2c3$var$getIsolatedRanges(this, line);
        let order = $7beee9608540d2c3$var$computeOrder(line.text, dir, isolates);
        this.bidiCache.push(new $7beee9608540d2c3$var$CachedOrder(line.from, line.to, dir, isolates, true, order));
        return order;
    }
    /**
    Check whether the editor has focus.
    */ get hasFocus() {
        var _a;
        // Safari return false for hasFocus when the context menu is open
        // or closing, which leads us to ignore selection changes from the
        // context menu because it looks like the editor isn't focused.
        // This kludges around that.
        return (this.dom.ownerDocument.hasFocus() || $7beee9608540d2c3$var$browser.safari && ((_a = this.inputState) === null || _a === void 0 ? void 0 : _a.lastContextMenu) > Date.now() - 3e4) && this.root.activeElement == this.contentDOM;
    }
    /**
    Put focus on the editor.
    */ focus() {
        this.observer.ignore(()=>{
            $7beee9608540d2c3$var$focusPreventScroll(this.contentDOM);
            this.docView.updateSelection();
        });
    }
    /**
    Update the [root](https://codemirror.net/6/docs/ref/##view.EditorViewConfig.root) in which the editor lives. This is only
    necessary when moving the editor's existing DOM to a new window or shadow root.
    */ setRoot(root) {
        if (this._root != root) {
            this._root = root;
            this.observer.setWindow((root.nodeType == 9 ? root : root.ownerDocument).defaultView || window);
            this.mountStyles();
        }
    }
    /**
    Clean up this editor view, removing its element from the
    document, unregistering event handlers, and notifying
    plugins. The view instance can no longer be used after
    calling this.
    */ destroy() {
        if (this.root.activeElement == this.contentDOM) this.contentDOM.blur();
        for (let plugin of this.plugins)plugin.destroy(this);
        this.plugins = [];
        this.inputState.destroy();
        this.docView.destroy();
        this.dom.remove();
        this.observer.destroy();
        if (this.measureScheduled > -1) this.win.cancelAnimationFrame(this.measureScheduled);
        this.destroyed = true;
    }
    /**
    Returns an effect that can be
    [added](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) to a transaction to
    cause it to scroll the given position or range into view.
    */ static scrollIntoView(pos, options = {}) {
        var _a, _b, _c, _d;
        return $7beee9608540d2c3$var$scrollIntoView.of(new $7beee9608540d2c3$var$ScrollTarget(typeof pos == "number" ? (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(pos) : pos, (_a = options.y) !== null && _a !== void 0 ? _a : "nearest", (_b = options.x) !== null && _b !== void 0 ? _b : "nearest", (_c = options.yMargin) !== null && _c !== void 0 ? _c : 5, (_d = options.xMargin) !== null && _d !== void 0 ? _d : 5));
    }
    /**
    Return an effect that resets the editor to its current (at the
    time this method was called) scroll position. Note that this
    only affects the editor's own scrollable element, not parents.
    See also
    [`EditorViewConfig.scrollTo`](https://codemirror.net/6/docs/ref/#view.EditorViewConfig.scrollTo).
    
    The effect should be used with a document identical to the one
    it was created for. Failing to do so is not an error, but may
    not scroll to the expected position. You can
    [map](https://codemirror.net/6/docs/ref/#state.StateEffect.map) the effect to account for changes.
    */ scrollSnapshot() {
        let { scrollTop: scrollTop, scrollLeft: scrollLeft } = this.scrollDOM;
        let ref = this.viewState.scrollAnchorAt(scrollTop);
        return $7beee9608540d2c3$var$scrollIntoView.of(new $7beee9608540d2c3$var$ScrollTarget((0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(ref.from), "start", "start", ref.top - scrollTop, scrollLeft, true));
    }
    /**
    Enable or disable tab-focus mode, which disables key bindings
    for Tab and Shift-Tab, letting the browser's default
    focus-changing behavior go through instead. This is useful to
    prevent trapping keyboard users in your editor.
    
    Without argument, this toggles the mode. With a boolean, it
    enables (true) or disables it (false). Given a number, it
    temporarily enables the mode until that number of milliseconds
    have passed or another non-Tab key is pressed.
    */ setTabFocusMode(to) {
        if (to == null) this.inputState.tabFocusMode = this.inputState.tabFocusMode < 0 ? 0 : -1;
        else if (typeof to == "boolean") this.inputState.tabFocusMode = to ? 0 : -1;
        else if (this.inputState.tabFocusMode != 0) this.inputState.tabFocusMode = Date.now() + to;
    }
    /**
    Returns an extension that can be used to add DOM event handlers.
    The value should be an object mapping event names to handler
    functions. For any given event, such functions are ordered by
    extension precedence, and the first handler to return true will
    be assumed to have handled that event, and no other handlers or
    built-in behavior will be activated for it. These are registered
    on the [content element](https://codemirror.net/6/docs/ref/#view.EditorView.contentDOM), except
    for `scroll` handlers, which will be called any time the
    editor's [scroll element](https://codemirror.net/6/docs/ref/#view.EditorView.scrollDOM) or one of
    its parent nodes is scrolled.
    */ static domEventHandlers(handlers) {
        return $7beee9608540d2c3$export$44d5eccfd62adda7.define(()=>({}), {
            eventHandlers: handlers
        });
    }
    /**
    Create an extension that registers DOM event observers. Contrary
    to event [handlers](https://codemirror.net/6/docs/ref/#view.EditorView^domEventHandlers),
    observers can't be prevented from running by a higher-precedence
    handler returning true. They also don't prevent other handlers
    and observers from running when they return true, and should not
    call `preventDefault`.
    */ static domEventObservers(observers) {
        return $7beee9608540d2c3$export$44d5eccfd62adda7.define(()=>({}), {
            eventObservers: observers
        });
    }
    /**
    Create a theme extension. The first argument can be a
    [`style-mod`](https://code.haverbeke.berlin/marijn/style-mod#documentation)
    style spec providing the styles for the theme. These will be
    prefixed with a generated class for the style.
    
    Because the selectors will be prefixed with a scope class, rule
    that directly match the editor's [wrapper
    element](https://codemirror.net/6/docs/ref/#view.EditorView.dom)—to which the scope class will be
    added—need to be explicitly differentiated by adding an `&` to
    the selector for that element—for example
    `&.cm-focused`.
    
    When `dark` is set to true, the theme will be marked as dark,
    which will cause the `&dark` rules from [base
    themes](https://codemirror.net/6/docs/ref/#view.EditorView^baseTheme) to be used (as opposed to
    `&light` when a light theme is active).
    */ static theme(spec, options) {
        let prefix = (0, $afd7c6da9f842a17$export$b920c662d2efee20).newName();
        let result = [
            $7beee9608540d2c3$var$theme.of(prefix),
            $7beee9608540d2c3$var$styleModule.of($7beee9608540d2c3$var$buildTheme(`.${prefix}`, spec))
        ];
        if (options && options.dark) result.push($7beee9608540d2c3$var$darkTheme.of(true));
        return result;
    }
    /**
    Create an extension that adds styles to the base theme. Like
    with [`theme`](https://codemirror.net/6/docs/ref/#view.EditorView^theme), use `&` to indicate the
    place of the editor wrapper element when directly targeting
    that. You can also use `&dark` or `&light` instead to only
    target editors with a dark or light theme.
    */ static baseTheme(spec) {
        return (0, $6295c6875f57e3ee$export$b92464a736444411).lowest($7beee9608540d2c3$var$styleModule.of($7beee9608540d2c3$var$buildTheme("." + $7beee9608540d2c3$var$baseThemeID, spec, $7beee9608540d2c3$var$lightDarkIDs)));
    }
    /**
    Retrieve an editor view instance from the view's DOM
    representation.
    */ static findFromDOM(dom) {
        var _a;
        let content = dom.querySelector(".cm-content");
        let tile = content && $7beee9608540d2c3$var$Tile.get(content) || $7beee9608540d2c3$var$Tile.get(dom);
        return ((_a = tile === null || tile === void 0 ? void 0 : tile.root) === null || _a === void 0 ? void 0 : _a.view) || null;
    }
}
/**
Facet to add a [style
module](https://code.haverbeke.berlin/marijn/style-mod#documentation) to
an editor view. The view will ensure that the module is
mounted in its [document
root](https://codemirror.net/6/docs/ref/#view.EditorView.constructor^config.root).
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.styleModule = $7beee9608540d2c3$var$styleModule;
/**
An input handler can override the way changes to the editable
DOM content are handled. Handlers are passed the document
positions between which the change was found, and the new
content. When one returns true, no further input handlers are
called and the default behavior is prevented.

The `insert` argument can be used to get the default transaction
that would be applied for this input. This can be useful when
dispatching the custom behavior as a separate transaction.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.inputHandler = $7beee9608540d2c3$var$inputHandler;
/**
Functions provided in this facet will be used to transform text
pasted or dropped into the editor.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.clipboardInputFilter = $7beee9608540d2c3$var$clipboardInputFilter;
/**
Transform text copied or dragged from the editor.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.clipboardOutputFilter = $7beee9608540d2c3$var$clipboardOutputFilter;
/**
Scroll handlers can override how things are scrolled into view.
If they return `true`, no further handling happens for the
scrolling. If they return false, the default scroll behavior is
applied. Scroll handlers should never initiate editor updates.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.scrollHandler = $7beee9608540d2c3$var$scrollHandler;
/**
This facet can be used to provide functions that create effects
to be dispatched when the editor's focus state changes.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.focusChangeEffect = $7beee9608540d2c3$var$focusChangeEffect;
/**
By default, the editor assumes all its content has the same
[text direction](https://codemirror.net/6/docs/ref/#view.Direction). Configure this with a `true`
value to make it read the text direction of every (rendered)
line separately.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.perLineTextDirection = $7beee9608540d2c3$var$perLineTextDirection;
/**
Allows you to provide a function that should be called when the
library catches an exception from an extension (mostly from view
plugins, but may be used by other extensions to route exceptions
from user-code-provided callbacks). This is mostly useful for
debugging and logging. See [`logException`](https://codemirror.net/6/docs/ref/#view.logException).
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.exceptionSink = $7beee9608540d2c3$var$exceptionSink;
/**
A facet that can be used to register a function to be called
every time the view updates.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.updateListener = $7beee9608540d2c3$var$updateListener;
/**
Facet that controls whether the editor content DOM is editable.
When its highest-precedence value is `false`, the element will
not have its `contenteditable` attribute set. (Note that this
doesn't affect API calls that change the editor content, even
when those are bound to keys or buttons. See the
[`readOnly`](https://codemirror.net/6/docs/ref/#state.EditorState.readOnly) facet for that.)
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.editable = $7beee9608540d2c3$var$editable;
/**
Allows you to influence the way mouse selection happens. The
functions in this facet will be called for a `mousedown` event
on the editor, and can return an object that overrides the way a
selection is computed from that mouse click or drag.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.mouseSelectionStyle = $7beee9608540d2c3$var$mouseSelectionStyle;
/**
Facet used to configure whether a given selection drag event
should move or copy the selection. The given predicate will be
called with the `mousedown` event, and can return `true` when
the drag should move the content.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.dragMovesSelection = $7beee9608540d2c3$var$dragMovesSelection$1;
/**
Facet used to configure whether a given selecting click adds a
new range to the existing selection or replaces it entirely. The
default behavior is to check `event.metaKey` on macOS, and
`event.ctrlKey` elsewhere.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.clickAddsSelectionRange = $7beee9608540d2c3$var$clickAddsSelectionRange;
/**
A facet that determines which [decorations](https://codemirror.net/6/docs/ref/#view.Decoration)
are shown in the view. Decorations can be provided in two
ways—directly, or via a function that takes an editor view.

Only decoration sets provided directly are allowed to influence
the editor's vertical layout structure. The ones provided as
functions are called _after_ the new viewport has been computed,
and thus **must not** introduce block widgets or replacing
decorations that cover line breaks.

If you want decorated ranges to behave like atomic units for
cursor motion and deletion purposes, also provide the range set
containing the decorations to
[`EditorView.atomicRanges`](https://codemirror.net/6/docs/ref/#view.EditorView^atomicRanges).
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.decorations = $7beee9608540d2c3$var$decorations;
/**
[Block wrappers](https://codemirror.net/6/docs/ref/#view.BlockWrapper) provide a way to add DOM
structure around editor lines and block widgets. Sets of
wrappers are provided in a similar way to decorations, and are
nested in a similar way when they overlap. A wrapper affects all
lines and block widgets that start inside its range.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.blockWrappers = $7beee9608540d2c3$var$blockWrappers;
/**
Facet that works much like
[`decorations`](https://codemirror.net/6/docs/ref/#view.EditorView^decorations), but puts its
inputs at the very bottom of the precedence stack, meaning mark
decorations provided here will only be split by other, partially
overlapping `outerDecorations` ranges, and wrap around all
regular decorations. Use this for mark elements that should, as
much as possible, remain in one piece.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.outerDecorations = $7beee9608540d2c3$var$outerDecorations;
/**
Used to provide ranges that should be treated as atoms as far as
cursor motion is concerned. This causes methods like
[`moveByChar`](https://codemirror.net/6/docs/ref/#view.EditorView.moveByChar) and
[`moveVertically`](https://codemirror.net/6/docs/ref/#view.EditorView.moveVertically) (and the
commands built on top of them) to skip across such regions when
a selection endpoint would enter them. This does _not_ prevent
direct programmatic [selection
updates](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection) from moving into such
regions.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.atomicRanges = $7beee9608540d2c3$var$atomicRanges;
/**
When range decorations add a `unicode-bidi: isolate` style, they
should also include a
[`bidiIsolate`](https://codemirror.net/6/docs/ref/#view.MarkDecorationSpec.bidiIsolate) property
in their decoration spec, and be exposed through this facet, so
that the editor can compute the proper text order. (Other values
for `unicode-bidi`, except of course `normal`, are not
supported.)
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.bidiIsolatedRanges = $7beee9608540d2c3$var$bidiIsolatedRanges;
/**
Can be used to specify the distance that scrolling cursor into
view keeps it away from the sides of the editor, either as a
single pixel number or two different values for the different
axes. Defaults to 5 pixels on both axes.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.cursorScrollMargin = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine: (inputs)=>{
        let x = 5, y = 5;
        for (let i of inputs)if (typeof i == "number") x = y = i;
        else ({ x: x, y: y } = i);
        return {
            x: x,
            y: y
        };
    }
});
/**
Facet that allows extensions to provide additional scroll
margins (space around the sides of the scrolling element that
should be considered invisible). This can be useful when the
plugin introduces elements that cover part of that element (for
example a horizontally fixed gutter). Not to be confused with
[`cursorScrollMargin`](https://codemirror.net/6/docs/ref/#view.EditorView^cursorScrollMargin).
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.scrollMargins = $7beee9608540d2c3$var$scrollMargins;
/**
This facet records whether a dark theme is active. The extension
returned by [`theme`](https://codemirror.net/6/docs/ref/#view.EditorView^theme) automatically
includes an instance of this when the `dark` option is set to
true.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.darkTheme = $7beee9608540d2c3$var$darkTheme;
/**
Provides a Content Security Policy nonce to use when creating
the style sheets for the editor. Holds the empty string when no
nonce has been provided.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.cspNonce = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine: (values)=>values.length ? values[0] : ""
});
/**
Facet that provides additional DOM attributes for the editor's
editable DOM element.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.contentAttributes = $7beee9608540d2c3$var$contentAttributes;
/**
Facet that provides DOM attributes for the editor's outer
element.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.editorAttributes = $7beee9608540d2c3$var$editorAttributes;
/**
An extension that enables line wrapping in the editor (by
setting CSS `white-space` to `pre-wrap` in the content).
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.lineWrapping = /*@__PURE__*/ $7beee9608540d2c3$export$eece2fccabbb77c5.contentAttributes.of({
    "class": "cm-lineWrapping"
});
/**
State effect used to include screen reader announcements in a
transaction. These will be added to the DOM in a visually hidden
element with `aria-live="polite"` set, and should be used to
describe effects that are visually obvious but may not be
noticed by screen reader users (such as moving to the next
search match).
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.announce = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
// Maximum line length for which we compute accurate bidi info
const $7beee9608540d2c3$var$MaxBidiLine = 4096;
const $7beee9608540d2c3$var$BadMeasure = {};
class $7beee9608540d2c3$var$CachedOrder {
    constructor(from, to, dir, isolates, fresh, order){
        this.from = from;
        this.to = to;
        this.dir = dir;
        this.isolates = isolates;
        this.fresh = fresh;
        this.order = order;
    }
    static update(cache, changes) {
        if (changes.empty && !cache.some((c)=>c.fresh)) return cache;
        let result = [], lastDir = cache.length ? cache[cache.length - 1].dir : $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR;
        for(let i = Math.max(0, cache.length - 10); i < cache.length; i++){
            let entry = cache[i];
            if (entry.dir == lastDir && !changes.touchesRange(entry.from, entry.to)) result.push(new $7beee9608540d2c3$var$CachedOrder(changes.mapPos(entry.from, 1), changes.mapPos(entry.to, -1), entry.dir, entry.isolates, false, entry.order));
        }
        return result;
    }
}
function $7beee9608540d2c3$var$attrsFromFacet(view, facet, base) {
    for(let sources = view.state.facet(facet), i = sources.length - 1; i >= 0; i--){
        let source = sources[i], value = typeof source == "function" ? source(view) : source;
        if (value) $7beee9608540d2c3$var$combineAttrs(value, base);
    }
    return base;
}
const $7beee9608540d2c3$var$currentPlatform = $7beee9608540d2c3$var$browser.mac ? "mac" : $7beee9608540d2c3$var$browser.windows ? "win" : $7beee9608540d2c3$var$browser.linux ? "linux" : "key";
function $7beee9608540d2c3$var$normalizeKeyName(name, platform) {
    const parts = name.split(/-(?!$)/);
    let result = parts[parts.length - 1];
    if (result == "Space") result = " ";
    let alt, ctrl, shift, meta;
    for(let i = 0; i < parts.length - 1; ++i){
        const mod = parts[i];
        if (/^(cmd|meta|m)$/i.test(mod)) meta = true;
        else if (/^a(lt)?$/i.test(mod)) alt = true;
        else if (/^(c|ctrl|control)$/i.test(mod)) ctrl = true;
        else if (/^s(hift)?$/i.test(mod)) shift = true;
        else if (/^mod$/i.test(mod)) {
            if (platform == "mac") meta = true;
            else ctrl = true;
        } else throw new Error("Unrecognized modifier name: " + mod);
    }
    if (alt) result = "Alt-" + result;
    if (ctrl) result = "Ctrl-" + result;
    if (meta) result = "Meta-" + result;
    if (shift) result = "Shift-" + result;
    return result;
}
function $7beee9608540d2c3$var$modifiers(name, event, shift) {
    if (event.altKey) name = "Alt-" + name;
    if (event.ctrlKey) name = "Ctrl-" + name;
    if (event.metaKey) name = "Meta-" + name;
    if (shift !== false && event.shiftKey) name = "Shift-" + name;
    return name;
}
const $7beee9608540d2c3$var$handleKeyEvents = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$b92464a736444411).default(/*@__PURE__*/ $7beee9608540d2c3$export$eece2fccabbb77c5.domEventHandlers({
    keydown (event, view) {
        return $7beee9608540d2c3$var$runHandlers($7beee9608540d2c3$var$getKeymap(view.state), event, view, "editor");
    }
}));
/**
Facet used for registering keymaps.

You can add multiple keymaps to an editor. Their priorities
determine their precedence (the ones specified early or with high
priority get checked first). When a handler has returned `true`
for a given key, no further handlers are called.
*/ const $7beee9608540d2c3$export$5043418e2ef368d5 = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    enables: $7beee9608540d2c3$var$handleKeyEvents
});
const $7beee9608540d2c3$var$Keymaps = /*@__PURE__*/ new WeakMap();
// This is hidden behind an indirection, rather than directly computed
// by the facet, to keep internal types out of the facet's type.
function $7beee9608540d2c3$var$getKeymap(state) {
    let bindings = state.facet($7beee9608540d2c3$export$5043418e2ef368d5);
    let map = $7beee9608540d2c3$var$Keymaps.get(bindings);
    if (!map) $7beee9608540d2c3$var$Keymaps.set(bindings, map = $7beee9608540d2c3$var$buildKeymap(bindings.reduce((a, b)=>a.concat(b), [])));
    return map;
}
/**
Run the key handlers registered for a given scope. The event
object should be a `"keydown"` event. Returns true if any of the
handlers handled it.
*/ function $7beee9608540d2c3$export$bce154f45536286e(view, event, scope) {
    return $7beee9608540d2c3$var$runHandlers($7beee9608540d2c3$var$getKeymap(view.state), event, view, scope);
}
let $7beee9608540d2c3$var$storedPrefix = null;
const $7beee9608540d2c3$var$PrefixTimeout = 4000;
function $7beee9608540d2c3$var$buildKeymap(bindings, platform = $7beee9608540d2c3$var$currentPlatform) {
    let bound = Object.create(null);
    let isPrefix = Object.create(null);
    let checkPrefix = (name, is)=>{
        let current = isPrefix[name];
        if (current == null) isPrefix[name] = is;
        else if (current != is) throw new Error("Key binding " + name + " is used both as a regular binding and as a multi-stroke prefix");
    };
    let add = (scope, key, command, preventDefault, stopPropagation)=>{
        var _a, _b;
        let scopeObj = bound[scope] || (bound[scope] = Object.create(null));
        let parts = key.split(/ (?!$)/).map((k)=>$7beee9608540d2c3$var$normalizeKeyName(k, platform));
        for(let i = 1; i < parts.length; i++){
            let prefix = parts.slice(0, i).join(" ");
            checkPrefix(prefix, true);
            if (!scopeObj[prefix]) scopeObj[prefix] = {
                preventDefault: true,
                stopPropagation: false,
                run: [
                    (view)=>{
                        let ourObj = $7beee9608540d2c3$var$storedPrefix = {
                            view: view,
                            prefix: prefix,
                            scope: scope
                        };
                        setTimeout(()=>{
                            if ($7beee9608540d2c3$var$storedPrefix == ourObj) $7beee9608540d2c3$var$storedPrefix = null;
                        }, $7beee9608540d2c3$var$PrefixTimeout);
                        return true;
                    }
                ]
            };
        }
        let full = parts.join(" ");
        checkPrefix(full, false);
        let binding = scopeObj[full] || (scopeObj[full] = {
            preventDefault: false,
            stopPropagation: false,
            run: ((_b = (_a = scopeObj._any) === null || _a === void 0 ? void 0 : _a.run) === null || _b === void 0 ? void 0 : _b.slice()) || []
        });
        if (command) binding.run.push(command);
        if (preventDefault) binding.preventDefault = true;
        if (stopPropagation) binding.stopPropagation = true;
    };
    for (let b of bindings){
        let scopes = b.scope ? b.scope.split(" ") : [
            "editor"
        ];
        if (b.any) for (let scope of scopes){
            let scopeObj = bound[scope] || (bound[scope] = Object.create(null));
            if (!scopeObj._any) scopeObj._any = {
                preventDefault: false,
                stopPropagation: false,
                run: []
            };
            let { any: any } = b;
            for(let key in scopeObj)scopeObj[key].run.push((view)=>any(view, $7beee9608540d2c3$var$currentKeyEvent));
        }
        let name = b[platform] || b.key;
        if (!name) continue;
        for (let scope of scopes){
            add(scope, name, b.run, b.preventDefault, b.stopPropagation);
            if (b.shift) add(scope, "Shift-" + name, b.shift, b.preventDefault, b.stopPropagation);
        }
    }
    return bound;
}
let $7beee9608540d2c3$var$currentKeyEvent = null;
function $7beee9608540d2c3$var$runHandlers(map, event, view, scope) {
    $7beee9608540d2c3$var$currentKeyEvent = event;
    let name = (0, $68b9e7c405929963$export$fb33aafd75404f4c)(event);
    let charCode = (0, $6295c6875f57e3ee$export$42977f40461e1360)(name, 0), isChar = (0, $6295c6875f57e3ee$export$a870abf234f6353c)(charCode) == name.length && name != " ";
    let prefix = "", handled = false, prevented = false, stopPropagation = false;
    if ($7beee9608540d2c3$var$storedPrefix && $7beee9608540d2c3$var$storedPrefix.view == view && $7beee9608540d2c3$var$storedPrefix.scope == scope) {
        prefix = $7beee9608540d2c3$var$storedPrefix.prefix + " ";
        if ($7beee9608540d2c3$var$modifierCodes.indexOf(event.keyCode) < 0) {
            prevented = true;
            $7beee9608540d2c3$var$storedPrefix = null;
        }
    }
    let ran = new Set;
    let runFor = (binding)=>{
        if (binding) {
            for (let cmd of binding.run)if (!ran.has(cmd)) {
                ran.add(cmd);
                if (cmd(view)) {
                    if (binding.stopPropagation) stopPropagation = true;
                    return true;
                }
            }
            if (binding.preventDefault) {
                if (binding.stopPropagation) stopPropagation = true;
                prevented = true;
            }
        }
        return false;
    };
    let scopeObj = map[scope], baseName, shiftName;
    if (scopeObj) {
        if (runFor(scopeObj[prefix + $7beee9608540d2c3$var$modifiers(name, event, !isChar)])) handled = true;
        else if (isChar && (event.altKey || event.metaKey || event.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
        !($7beee9608540d2c3$var$browser.windows && event.ctrlKey && event.altKey) && // Alt-combinations on macOS tend to be typed characters
        !($7beee9608540d2c3$var$browser.mac && event.altKey && !(event.ctrlKey || event.metaKey)) && (baseName = (0, $68b9e7c405929963$export$e2253033e6e1df16)[event.keyCode]) && baseName != name) {
            if (runFor(scopeObj[prefix + $7beee9608540d2c3$var$modifiers(baseName, event, true)])) handled = true;
            else if (event.shiftKey && (shiftName = (0, $68b9e7c405929963$export$fba63a578e423eb)[event.keyCode]) != name && shiftName != baseName && runFor(scopeObj[prefix + $7beee9608540d2c3$var$modifiers(shiftName, event, false)])) handled = true;
        } else if (isChar && event.shiftKey && runFor(scopeObj[prefix + $7beee9608540d2c3$var$modifiers(name, event, true)])) handled = true;
        if (!handled && runFor(scopeObj._any)) handled = true;
    }
    if (prevented) handled = true;
    if (handled && stopPropagation) event.stopPropagation();
    $7beee9608540d2c3$var$currentKeyEvent = null;
    return handled;
}
/**
Implementation of [`LayerMarker`](https://codemirror.net/6/docs/ref/#view.LayerMarker) that creates
a rectangle at a given set of coordinates.
*/ class $7beee9608540d2c3$export$9ddce7bd14f42a78 {
    /**
    Create a marker with the given class and dimensions. If `width`
    is null, the DOM element will get no width style.
    */ constructor(className, /**
    The left position of the marker (in pixels, document-relative).
    */ left, /**
    The top position of the marker.
    */ top, /**
    The width of the marker, or null if it shouldn't get a width assigned.
    */ width, /**
    The height of the marker.
    */ height){
        this.className = className;
        this.left = left;
        this.top = top;
        this.width = width;
        this.height = height;
    }
    draw() {
        let elt = document.createElement("div");
        elt.className = this.className;
        this.adjust(elt);
        return elt;
    }
    update(elt, prev) {
        if (prev.className != this.className) return false;
        this.adjust(elt);
        return true;
    }
    adjust(elt) {
        elt.style.left = this.left + "px";
        elt.style.top = this.top + "px";
        if (this.width != null) elt.style.width = this.width + "px";
        elt.style.height = this.height + "px";
    }
    eq(p) {
        return this.left == p.left && this.top == p.top && this.width == p.width && this.height == p.height && this.className == p.className;
    }
    /**
    Create a set of rectangles for the given selection range,
    assigning them theclass`className`. Will create a single
    rectangle for empty ranges, and a set of selection-style
    rectangles covering the range's content (in a bidi-aware
    way) for non-empty ones.
    */ static forRange(view, className, range) {
        if (range.empty) {
            let pos = view.coordsAtPos(range.head, range.assoc || 1);
            if (!pos) return [];
            let base = $7beee9608540d2c3$var$getBase(view);
            return [
                new $7beee9608540d2c3$export$9ddce7bd14f42a78(className, pos.left - base.left, pos.top - base.top, null, pos.bottom - pos.top)
            ];
        } else return $7beee9608540d2c3$var$rectanglesForRange(view, className, range);
    }
}
function $7beee9608540d2c3$var$getBase(view) {
    let rect = view.scrollDOM.getBoundingClientRect();
    let left = view.textDirection == $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR ? rect.left : rect.right - view.scrollDOM.clientWidth * view.scaleX;
    return {
        left: left - view.scrollDOM.scrollLeft * view.scaleX,
        top: rect.top - view.scrollDOM.scrollTop * view.scaleY
    };
}
function $7beee9608540d2c3$var$wrappedLine(view, pos, side, inside) {
    let coords = view.coordsAtPos(pos, side * 2);
    if (!coords) return inside;
    let editorRect = view.dom.getBoundingClientRect();
    let y = (coords.top + coords.bottom) / 2;
    let left = view.posAtCoords({
        x: editorRect.left + 1,
        y: y
    });
    let right = view.posAtCoords({
        x: editorRect.right - 1,
        y: y
    });
    if (left == null || right == null) return inside;
    return {
        from: Math.max(inside.from, Math.min(left, right)),
        to: Math.min(inside.to, Math.max(left, right))
    };
}
function $7beee9608540d2c3$var$rectanglesForRange(view, className, range) {
    if (range.to <= view.viewport.from || range.from >= view.viewport.to) return [];
    let from = Math.max(range.from, view.viewport.from), to = Math.min(range.to, view.viewport.to);
    let ltr = view.textDirection == $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR;
    let content = view.contentDOM, contentRect = content.getBoundingClientRect(), base = $7beee9608540d2c3$var$getBase(view);
    let lineElt = content.querySelector(".cm-line"), lineStyle = lineElt && window.getComputedStyle(lineElt);
    let leftSide = contentRect.left + (lineStyle ? parseInt(lineStyle.paddingLeft) + Math.min(0, parseInt(lineStyle.textIndent)) : 0);
    let rightSide = contentRect.right - (lineStyle ? parseInt(lineStyle.paddingRight) : 0);
    let startBlock = $7beee9608540d2c3$var$blockAt(view, from, 1), endBlock = $7beee9608540d2c3$var$blockAt(view, to, -1);
    let visualStart = startBlock.type == $7beee9608540d2c3$export$48808c686fe495c4.Text ? startBlock : null;
    let visualEnd = endBlock.type == $7beee9608540d2c3$export$48808c686fe495c4.Text ? endBlock : null;
    if (visualStart && (view.lineWrapping || startBlock.widgetLineBreaks)) visualStart = $7beee9608540d2c3$var$wrappedLine(view, from, 1, visualStart);
    if (visualEnd && (view.lineWrapping || endBlock.widgetLineBreaks)) visualEnd = $7beee9608540d2c3$var$wrappedLine(view, to, -1, visualEnd);
    if (visualStart && visualEnd && visualStart.from == visualEnd.from && visualStart.to == visualEnd.to) return pieces(drawForLine(range.from, range.to, visualStart));
    else {
        let top = visualStart ? drawForLine(range.from, null, visualStart) : drawForWidget(startBlock, false);
        let bottom = visualEnd ? drawForLine(null, range.to, visualEnd) : drawForWidget(endBlock, true);
        let between = [];
        if ((visualStart || startBlock).to < (visualEnd || endBlock).from - (visualStart && visualEnd ? 1 : 0) || startBlock.widgetLineBreaks > 1 && top.bottom + view.defaultLineHeight / 2 < bottom.top) between.push(piece(leftSide, top.bottom, rightSide, bottom.top));
        else if (top.bottom < bottom.top && view.elementAtHeight((top.bottom + bottom.top) / 2).type == $7beee9608540d2c3$export$48808c686fe495c4.Text) top.bottom = bottom.top = (top.bottom + bottom.top) / 2;
        return pieces(top).concat(between).concat(pieces(bottom));
    }
    function piece(left, top, right, bottom) {
        return new $7beee9608540d2c3$export$9ddce7bd14f42a78(className, left - base.left, top - base.top, Math.max(0, right - left), bottom - top);
    }
    function pieces({ top: top, bottom: bottom, horizontal: horizontal }) {
        let pieces = [];
        for(let i = 0; i < horizontal.length; i += 2)pieces.push(piece(horizontal[i], top, horizontal[i + 1], bottom));
        return pieces;
    }
    // Gets passed from/to in line-local positions
    function drawForLine(from, to, line) {
        let top = 1e9, bottom = -1000000000, horizontal = [];
        function addSpan(from, fromOpen, to, toOpen, dir) {
            // Passing 2/-2 is a kludge to force the view to return
            // coordinates on the proper side of block widgets, since
            // normalizing the side there, though appropriate for most
            // coordsAtPos queries, would break selection drawing.
            let fromCoords = view.coordsAtPos(from, from == line.to ? -2 : 2);
            let toCoords = view.coordsAtPos(to, to == line.from ? 2 : -2);
            if (!fromCoords || !toCoords) return;
            top = Math.min(fromCoords.top, toCoords.top, top);
            bottom = Math.max(fromCoords.bottom, toCoords.bottom, bottom);
            if (dir == $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR) horizontal.push(ltr && fromOpen ? leftSide : fromCoords.left, ltr && toOpen ? rightSide : toCoords.right);
            else horizontal.push(!ltr && toOpen ? leftSide : toCoords.left, !ltr && fromOpen ? rightSide : fromCoords.right);
        }
        let start = from !== null && from !== void 0 ? from : line.from, end = to !== null && to !== void 0 ? to : line.to;
        // Split the range by visible range and document line
        for (let r of view.visibleRanges)if (r.to > start && r.from < end) for(let pos = Math.max(r.from, start), endPos = Math.min(r.to, end);;){
            let docLine = view.state.doc.lineAt(pos);
            for (let span of view.bidiSpans(docLine)){
                let spanFrom = span.from + docLine.from, spanTo = span.to + docLine.from;
                if (spanFrom >= endPos) break;
                if (spanTo > pos) addSpan(Math.max(spanFrom, pos), from == null && spanFrom <= start, Math.min(spanTo, endPos), to == null && spanTo >= end, span.dir);
            }
            pos = docLine.to + 1;
            if (pos >= endPos) break;
        }
        if (horizontal.length == 0) addSpan(start, from == null, end, to == null, view.textDirection);
        return {
            top: top,
            bottom: bottom,
            horizontal: horizontal
        };
    }
    function drawForWidget(block, top) {
        let y = contentRect.top + (top ? block.top : block.bottom);
        return {
            top: y,
            bottom: y,
            horizontal: []
        };
    }
}
function $7beee9608540d2c3$var$sameMarker(a, b) {
    return a.constructor == b.constructor && a.eq(b);
}
class $7beee9608540d2c3$var$LayerView {
    constructor(view, layer){
        this.view = view;
        this.layer = layer;
        this.drawn = [];
        this.scaleX = 1;
        this.scaleY = 1;
        this.measureReq = {
            read: this.measure.bind(this),
            write: this.draw.bind(this)
        };
        this.dom = view.scrollDOM.appendChild(document.createElement("div"));
        this.dom.classList.add("cm-layer");
        if (layer.above) this.dom.classList.add("cm-layer-above");
        if (layer.class) this.dom.classList.add(layer.class);
        this.scale();
        this.dom.setAttribute("aria-hidden", "true");
        this.setOrder(view.state);
        view.requestMeasure(this.measureReq);
        if (layer.mount) layer.mount(this.dom, view);
    }
    update(update) {
        if (update.startState.facet($7beee9608540d2c3$var$layerOrder) != update.state.facet($7beee9608540d2c3$var$layerOrder)) this.setOrder(update.state);
        if (this.layer.update(update, this.dom) || update.geometryChanged) {
            this.scale();
            update.view.requestMeasure(this.measureReq);
        }
    }
    docViewUpdate(view) {
        if (this.layer.updateOnDocViewUpdate !== false) view.requestMeasure(this.measureReq);
    }
    setOrder(state) {
        let pos = 0, order = state.facet($7beee9608540d2c3$var$layerOrder);
        while(pos < order.length && order[pos] != this.layer)pos++;
        this.dom.style.zIndex = String((this.layer.above ? 150 : -1) - pos);
    }
    measure() {
        return this.layer.markers(this.view);
    }
    scale() {
        let { scaleX: scaleX, scaleY: scaleY } = this.view;
        if (scaleX != this.scaleX || scaleY != this.scaleY) {
            this.scaleX = scaleX;
            this.scaleY = scaleY;
            this.dom.style.transform = `scale(${1 / scaleX}, ${1 / scaleY})`;
        }
    }
    draw(markers) {
        if (markers.length != this.drawn.length || markers.some((p, i)=>!$7beee9608540d2c3$var$sameMarker(p, this.drawn[i]))) {
            let old = this.dom.firstChild, oldI = 0;
            for (let marker of markers)if (marker.update && old && marker.constructor && this.drawn[oldI].constructor && marker.update(old, this.drawn[oldI])) {
                old = old.nextSibling;
                oldI++;
            } else this.dom.insertBefore(marker.draw(), old);
            while(old){
                let next = old.nextSibling;
                old.remove();
                old = next;
            }
            this.drawn = markers;
            if ($7beee9608540d2c3$var$browser.webkit) this.dom.style.display = this.dom.firstChild ? "" : "none";
        }
    }
    destroy() {
        if (this.layer.destroy) this.layer.destroy(this.dom, this.view);
        this.dom.remove();
    }
}
const $7beee9608540d2c3$var$layerOrder = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
/**
Define a layer.
*/ function $7beee9608540d2c3$export$50a222d9023da98b(config) {
    return [
        $7beee9608540d2c3$export$44d5eccfd62adda7.define((v)=>new $7beee9608540d2c3$var$LayerView(v, config)),
        $7beee9608540d2c3$var$layerOrder.of(config)
    ];
}
const $7beee9608540d2c3$var$selectionConfig = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        return (0, $6295c6875f57e3ee$export$4e19c0b693794a7e)(configs, {
            cursorBlinkRate: 1200,
            drawRangeCursor: true,
            iosSelectionHandles: true
        }, {
            cursorBlinkRate: (a, b)=>Math.min(a, b),
            drawRangeCursor: (a, b)=>a || b
        });
    }
});
/**
Returns an extension that hides the browser's native selection and
cursor, replacing the selection with a background behind the text
(with the `cm-selectionBackground` class), and the
cursors with elements overlaid over the code (using
`cm-cursor-primary` and `cm-cursor-secondary`).

This allows the editor to display secondary selection ranges, and
tends to produce a type of selection more in line with that users
expect in a text editor (the native selection styling will often
leave gaps between lines and won't fill the horizontal space after
a line when the selection continues past it).

It does have a performance cost, in that it requires an extra DOM
layout cycle for many updates (the selection is drawn based on DOM
layout information that's only available after laying out the
content).
*/ function $7beee9608540d2c3$export$17a3d0ab3687347d(config = {}) {
    return [
        $7beee9608540d2c3$var$selectionConfig.of(config),
        $7beee9608540d2c3$var$cursorLayer,
        $7beee9608540d2c3$var$selectionLayer,
        $7beee9608540d2c3$var$hideNativeSelection,
        $7beee9608540d2c3$var$nativeSelectionHidden.of(true)
    ];
}
/**
Retrieve the [`drawSelection`](https://codemirror.net/6/docs/ref/#view.drawSelection) configuration
for this state. (Note that this will return a set of defaults even
if `drawSelection` isn't enabled.)
*/ function $7beee9608540d2c3$export$74e411a7b5f41f23(state) {
    return state.facet($7beee9608540d2c3$var$selectionConfig);
}
function $7beee9608540d2c3$var$configChanged(update) {
    return update.startState.facet($7beee9608540d2c3$var$selectionConfig) != update.state.facet($7beee9608540d2c3$var$selectionConfig);
}
const $7beee9608540d2c3$var$cursorLayer = /*@__PURE__*/ $7beee9608540d2c3$export$50a222d9023da98b({
    above: true,
    markers (view) {
        let { state: state } = view, conf = state.facet($7beee9608540d2c3$var$selectionConfig);
        let cursors = [];
        for (let r of state.selection.ranges){
            let prim = r == state.selection.main;
            if (r.empty || conf.drawRangeCursor && !(prim && $7beee9608540d2c3$var$browser.ios && conf.iosSelectionHandles)) {
                let className = prim ? "cm-cursor cm-cursor-primary" : "cm-cursor cm-cursor-secondary";
                let cursor = r.empty ? r : (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(r.head, r.assoc);
                for (let piece of $7beee9608540d2c3$export$9ddce7bd14f42a78.forRange(view, className, cursor))cursors.push(piece);
            }
        }
        return cursors;
    },
    update (update, dom) {
        if (update.transactions.some((tr)=>tr.selection)) dom.style.animationName = dom.style.animationName == "cm-blink" ? "cm-blink2" : "cm-blink";
        let confChange = $7beee9608540d2c3$var$configChanged(update);
        if (confChange) $7beee9608540d2c3$var$setBlinkRate(update.state, dom);
        return update.docChanged || update.selectionSet || confChange;
    },
    mount (dom, view) {
        $7beee9608540d2c3$var$setBlinkRate(view.state, dom);
    },
    class: "cm-cursorLayer"
});
function $7beee9608540d2c3$var$setBlinkRate(state, dom) {
    dom.style.animationDuration = state.facet($7beee9608540d2c3$var$selectionConfig).cursorBlinkRate + "ms";
}
const $7beee9608540d2c3$var$selectionLayer = /*@__PURE__*/ $7beee9608540d2c3$export$50a222d9023da98b({
    above: false,
    markers (view) {
        let markers = [], { main: main, ranges: ranges } = view.state.selection;
        for (let r of ranges)if (!r.empty) for (let marker of $7beee9608540d2c3$export$9ddce7bd14f42a78.forRange(view, "cm-selectionBackground", r))markers.push(marker);
        if ($7beee9608540d2c3$var$browser.ios && !main.empty && view.state.facet($7beee9608540d2c3$var$selectionConfig).iosSelectionHandles) {
            for (let piece of $7beee9608540d2c3$export$9ddce7bd14f42a78.forRange(view, "cm-selectionHandle cm-selectionHandle-start", (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(main.from, 1)))markers.push(piece);
            for (let piece of $7beee9608540d2c3$export$9ddce7bd14f42a78.forRange(view, "cm-selectionHandle cm-selectionHandle-end", (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(main.to, 1)))markers.push(piece);
        }
        return markers;
    },
    update (update, dom) {
        return update.docChanged || update.selectionSet || update.viewportChanged || $7beee9608540d2c3$var$configChanged(update);
    },
    class: "cm-selectionLayer"
});
const $7beee9608540d2c3$var$hideNativeSelection = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$b92464a736444411).highest(/*@__PURE__*/ $7beee9608540d2c3$export$eece2fccabbb77c5.theme({
    ".cm-line": {
        "& ::selection, &::selection": {
            backgroundColor: "transparent !important"
        },
        caretColor: "transparent !important"
    },
    ".cm-content": {
        caretColor: "transparent !important",
        "& :focus": {
            caretColor: "initial !important",
            "&::selection, & ::selection": {
                backgroundColor: "Highlight !important"
            }
        }
    }
}));
const $7beee9608540d2c3$var$setDropCursorPos = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define({
    map (pos, mapping) {
        return pos == null ? null : mapping.mapPos(pos);
    }
});
const $7beee9608540d2c3$var$dropCursorPos = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$34381b1ce2130245).define({
    create () {
        return null;
    },
    update (pos, tr) {
        if (pos != null) pos = tr.changes.mapPos(pos);
        return tr.effects.reduce((pos, e)=>e.is($7beee9608540d2c3$var$setDropCursorPos) ? e.value : pos, pos);
    }
});
const $7beee9608540d2c3$var$drawDropCursor = /*@__PURE__*/ $7beee9608540d2c3$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.view = view;
        this.cursor = null;
        this.measureReq = {
            read: this.readPos.bind(this),
            write: this.drawCursor.bind(this)
        };
    }
    update(update) {
        var _a;
        let cursorPos = update.state.field($7beee9608540d2c3$var$dropCursorPos);
        if (cursorPos == null) {
            if (this.cursor != null) {
                (_a = this.cursor) === null || _a === void 0 || _a.remove();
                this.cursor = null;
            }
        } else {
            if (!this.cursor) {
                this.cursor = this.view.scrollDOM.appendChild(document.createElement("div"));
                this.cursor.className = "cm-dropCursor";
            }
            if (update.startState.field($7beee9608540d2c3$var$dropCursorPos) != cursorPos || update.docChanged || update.geometryChanged) this.view.requestMeasure(this.measureReq);
        }
    }
    readPos() {
        let { view: view } = this;
        let pos = view.state.field($7beee9608540d2c3$var$dropCursorPos);
        let rect = pos != null && view.coordsAtPos(pos);
        if (!rect) return null;
        let outer = view.scrollDOM.getBoundingClientRect();
        return {
            left: rect.left - outer.left + view.scrollDOM.scrollLeft * view.scaleX,
            top: rect.top - outer.top + view.scrollDOM.scrollTop * view.scaleY,
            height: rect.bottom - rect.top
        };
    }
    drawCursor(pos) {
        if (this.cursor) {
            let { scaleX: scaleX, scaleY: scaleY } = this.view;
            if (pos) {
                this.cursor.style.left = pos.left / scaleX + "px";
                this.cursor.style.top = pos.top / scaleY + "px";
                this.cursor.style.height = pos.height / scaleY + "px";
            } else this.cursor.style.left = "-100000px";
        }
    }
    destroy() {
        if (this.cursor) this.cursor.remove();
    }
    setDropPos(pos) {
        if (this.view.state.field($7beee9608540d2c3$var$dropCursorPos) != pos) this.view.dispatch({
            effects: $7beee9608540d2c3$var$setDropCursorPos.of(pos)
        });
    }
}, {
    eventObservers: {
        dragover (event) {
            this.setDropPos(this.view.posAtCoords({
                x: event.clientX,
                y: event.clientY
            }));
        },
        dragleave (event) {
            if (event.target == this.view.contentDOM || !this.view.contentDOM.contains(event.relatedTarget)) this.setDropPos(null);
        },
        dragend () {
            this.setDropPos(null);
        },
        drop () {
            this.setDropPos(null);
        }
    }
});
/**
Draws a cursor at the current drop position when something is
dragged over the editor.
*/ function $7beee9608540d2c3$export$b8e3092a3bfa2062() {
    return [
        $7beee9608540d2c3$var$dropCursorPos,
        $7beee9608540d2c3$var$drawDropCursor
    ];
}
function $7beee9608540d2c3$var$iterMatches(doc, re, from, to, f) {
    re.lastIndex = 0;
    for(let cursor = doc.iterRange(from, to), pos = from, m; !cursor.next().done; pos += cursor.value.length){
        if (!cursor.lineBreak) while(m = re.exec(cursor.value))f(pos + m.index, m);
    }
}
function $7beee9608540d2c3$var$matchRanges(view, maxLength) {
    let visible = view.visibleRanges;
    if (visible.length == 1 && visible[0].from == view.viewport.from && visible[0].to == view.viewport.to) return visible;
    let result = [];
    for (let { from: from, to: to } of visible){
        from = Math.max(view.state.doc.lineAt(from).from, from - maxLength);
        to = Math.min(view.state.doc.lineAt(to).to, to + maxLength);
        if (result.length && result[result.length - 1].to >= from) result[result.length - 1].to = to;
        else result.push({
            from: from,
            to: to
        });
    }
    return result;
}
/**
Helper class used to make it easier to maintain decorations on
visible code that matches a given regular expression. To be used
in a [view plugin](https://codemirror.net/6/docs/ref/#view.ViewPlugin). Instances of this object
represent a matching configuration.
*/ class $7beee9608540d2c3$export$9b928b0ca20b25cb {
    /**
    Create a decorator.
    */ constructor(config){
        const { regexp: regexp, decoration: decoration, decorate: decorate, boundary: boundary, maxLength: maxLength = 1000 } = config;
        if (!regexp.global) throw new RangeError("The regular expression given to MatchDecorator should have its 'g' flag set");
        this.regexp = regexp;
        if (decorate) this.addMatch = (match, view, from, add)=>decorate(add, from, from + match[0].length, match, view);
        else if (typeof decoration == "function") this.addMatch = (match, view, from, add)=>{
            let deco = decoration(match, view, from);
            if (deco) add(from, from + match[0].length, deco);
        };
        else if (decoration) this.addMatch = (match, _view, from, add)=>add(from, from + match[0].length, decoration);
        else throw new RangeError("Either 'decorate' or 'decoration' should be provided to MatchDecorator");
        this.boundary = boundary;
        this.maxLength = maxLength;
    }
    /**
    Compute the full set of decorations for matches in the given
    view's viewport. You'll want to call this when initializing your
    plugin.
    */ createDeco(view) {
        let build = new (0, $6295c6875f57e3ee$export$89e09ce03c7e8594)(), add = build.add.bind(build);
        for (let { from: from, to: to } of $7beee9608540d2c3$var$matchRanges(view, this.maxLength))$7beee9608540d2c3$var$iterMatches(view.state.doc, this.regexp, from, to, (from, m)=>this.addMatch(m, view, from, add));
        return build.finish();
    }
    /**
    Update a set of decorations for a view update. `deco` _must_ be
    the set of decorations produced by _this_ `MatchDecorator` for
    the view state before the update.
    */ updateDeco(update, deco) {
        let changeFrom = 1e9, changeTo = -1;
        if (update.docChanged) update.changes.iterChanges((_f, _t, from, to)=>{
            if (to >= update.view.viewport.from && from <= update.view.viewport.to) {
                changeFrom = Math.min(from, changeFrom);
                changeTo = Math.max(to, changeTo);
            }
        });
        if (update.viewportMoved || changeTo - changeFrom > 1000) return this.createDeco(update.view);
        if (changeTo > -1) return this.updateRange(update.view, deco.map(update.changes), changeFrom, changeTo);
        return deco;
    }
    updateRange(view, deco, updateFrom, updateTo) {
        for (let r of view.visibleRanges){
            let from = Math.max(r.from, updateFrom), to = Math.min(r.to, updateTo);
            if (to >= from) {
                let fromLine = view.state.doc.lineAt(from), toLine = fromLine.to < to ? view.state.doc.lineAt(to) : fromLine;
                let start = Math.max(r.from, fromLine.from), end = Math.min(r.to, toLine.to);
                if (this.boundary) {
                    for(; from > fromLine.from; from--)if (this.boundary.test(fromLine.text[from - 1 - fromLine.from])) {
                        start = from;
                        break;
                    }
                    for(; to < toLine.to; to++)if (this.boundary.test(toLine.text[to - toLine.from])) {
                        end = to;
                        break;
                    }
                }
                let ranges = [], m;
                let add = (from, to, deco)=>ranges.push(deco.range(from, to));
                if (fromLine == toLine) {
                    this.regexp.lastIndex = start - fromLine.from;
                    while((m = this.regexp.exec(fromLine.text)) && m.index < end - fromLine.from)this.addMatch(m, view, m.index + fromLine.from, add);
                } else $7beee9608540d2c3$var$iterMatches(view.state.doc, this.regexp, start, end, (from, m)=>this.addMatch(m, view, from, add));
                deco = deco.update({
                    filterFrom: start,
                    filterTo: end,
                    filter: (from, to)=>from < start || to > end,
                    add: ranges
                });
            }
        }
        return deco;
    }
}
const $7beee9608540d2c3$var$UnicodeRegexpSupport = /x/.unicode != null ? "gu" : "g";
const $7beee9608540d2c3$var$Specials = /*@__PURE__*/ new RegExp("[\u0000-\u0008\u000a-\u001f\u007f-\u009f\u00ad\u061c\u200b\u200e\u200f\u2028\u2029\u202d\u202e\u2066\u2067\u2069\ufeff\ufff9-\ufffc]", $7beee9608540d2c3$var$UnicodeRegexpSupport);
const $7beee9608540d2c3$var$Names = {
    0: "null",
    7: "bell",
    8: "backspace",
    10: "newline",
    11: "vertical tab",
    13: "carriage return",
    27: "escape",
    8203: "zero width space",
    8204: "zero width non-joiner",
    8205: "zero width joiner",
    8206: "left-to-right mark",
    8207: "right-to-left mark",
    8232: "line separator",
    8237: "left-to-right override",
    8238: "right-to-left override",
    8294: "left-to-right isolate",
    8295: "right-to-left isolate",
    8297: "pop directional isolate",
    8233: "paragraph separator",
    65279: "zero width no-break space",
    65532: "object replacement"
};
let $7beee9608540d2c3$var$_supportsTabSize = null;
function $7beee9608540d2c3$var$supportsTabSize() {
    var _a;
    if ($7beee9608540d2c3$var$_supportsTabSize == null && typeof document != "undefined" && document.body) {
        let styles = document.body.style;
        $7beee9608540d2c3$var$_supportsTabSize = ((_a = styles.tabSize) !== null && _a !== void 0 ? _a : styles.MozTabSize) != null;
    }
    return $7beee9608540d2c3$var$_supportsTabSize || false;
}
const $7beee9608540d2c3$var$specialCharConfig = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        let config = (0, $6295c6875f57e3ee$export$4e19c0b693794a7e)(configs, {
            render: null,
            specialChars: $7beee9608540d2c3$var$Specials,
            addSpecialChars: null
        });
        if (config.replaceTabs = !$7beee9608540d2c3$var$supportsTabSize()) config.specialChars = new RegExp("\t|" + config.specialChars.source, $7beee9608540d2c3$var$UnicodeRegexpSupport);
        if (config.addSpecialChars) config.specialChars = new RegExp(config.specialChars.source + "|" + config.addSpecialChars.source, $7beee9608540d2c3$var$UnicodeRegexpSupport);
        return config;
    }
});
/**
Returns an extension that installs highlighting of special
characters.
*/ function $7beee9608540d2c3$export$76dc0899547f659c(/**
Configuration options.
*/ config = {}) {
    return [
        $7beee9608540d2c3$var$specialCharConfig.of(config),
        $7beee9608540d2c3$var$specialCharPlugin()
    ];
}
let $7beee9608540d2c3$var$_plugin = null;
function $7beee9608540d2c3$var$specialCharPlugin() {
    return $7beee9608540d2c3$var$_plugin || ($7beee9608540d2c3$var$_plugin = $7beee9608540d2c3$export$44d5eccfd62adda7.fromClass(class {
        constructor(view){
            this.view = view;
            this.decorations = $7beee9608540d2c3$export$10e30b733df217ea.none;
            this.decorationCache = Object.create(null);
            this.decorator = this.makeDecorator(view.state.facet($7beee9608540d2c3$var$specialCharConfig));
            this.decorations = this.decorator.createDeco(view);
        }
        makeDecorator(conf) {
            return new $7beee9608540d2c3$export$9b928b0ca20b25cb({
                regexp: conf.specialChars,
                decoration: (m, view, pos)=>{
                    let { doc: doc } = view.state;
                    let code = (0, $6295c6875f57e3ee$export$42977f40461e1360)(m[0], 0);
                    if (code == 9) {
                        let line = doc.lineAt(pos);
                        let size = view.state.tabSize, col = (0, $6295c6875f57e3ee$export$20b4ab289374d0ac)(line.text, size, pos - line.from);
                        return $7beee9608540d2c3$export$10e30b733df217ea.replace({
                            widget: new $7beee9608540d2c3$var$TabWidget((size - col % size) * this.view.defaultCharacterWidth / this.view.scaleX)
                        });
                    }
                    return this.decorationCache[code] || (this.decorationCache[code] = $7beee9608540d2c3$export$10e30b733df217ea.replace({
                        widget: new $7beee9608540d2c3$var$SpecialCharWidget(conf, code)
                    }));
                },
                boundary: conf.replaceTabs ? undefined : /[^]/
            });
        }
        update(update) {
            let conf = update.state.facet($7beee9608540d2c3$var$specialCharConfig);
            if (update.startState.facet($7beee9608540d2c3$var$specialCharConfig) != conf) {
                this.decorator = this.makeDecorator(conf);
                this.decorations = this.decorator.createDeco(update.view);
            } else this.decorations = this.decorator.updateDeco(update, this.decorations);
        }
    }, {
        decorations: (v)=>v.decorations
    }));
}
const $7beee9608540d2c3$var$DefaultPlaceholder = "\u2022";
// Assigns placeholder characters from the Control Pictures block to
// ASCII control characters
function $7beee9608540d2c3$var$placeholder$1(code) {
    if (code >= 32) return $7beee9608540d2c3$var$DefaultPlaceholder;
    if (code == 10) return "\u2424";
    return String.fromCharCode(9216 + code);
}
class $7beee9608540d2c3$var$SpecialCharWidget extends $7beee9608540d2c3$export$95cdd842edb044c5 {
    constructor(options, code){
        super();
        this.options = options;
        this.code = code;
    }
    eq(other) {
        return other.code == this.code;
    }
    toDOM(view) {
        let ph = $7beee9608540d2c3$var$placeholder$1(this.code);
        let desc = view.state.phrase("Control character") + " " + ($7beee9608540d2c3$var$Names[this.code] || "0x" + this.code.toString(16));
        let custom = this.options.render && this.options.render(this.code, desc, ph);
        if (custom) return custom;
        let span = document.createElement("span");
        span.textContent = ph;
        span.title = desc;
        span.setAttribute("aria-label", desc);
        span.className = "cm-specialChar";
        return span;
    }
    ignoreEvent() {
        return false;
    }
}
class $7beee9608540d2c3$var$TabWidget extends $7beee9608540d2c3$export$95cdd842edb044c5 {
    constructor(width){
        super();
        this.width = width;
    }
    eq(other) {
        return other.width == this.width;
    }
    toDOM() {
        let span = document.createElement("span");
        span.textContent = "\t";
        span.className = "cm-tab";
        span.style.width = this.width + "px";
        return span;
    }
    ignoreEvent() {
        return false;
    }
}
const $7beee9608540d2c3$var$plugin = /*@__PURE__*/ $7beee9608540d2c3$export$44d5eccfd62adda7.fromClass(class {
    constructor(){
        this.height = 1000;
        this.attrs = {
            style: "padding-bottom: 1000px"
        };
    }
    update(update) {
        let { view: view } = update;
        let height = view.viewState.editorHeight - view.defaultLineHeight - view.documentPadding.top - 0.5;
        if (height >= 0 && height != this.height) {
            this.height = height;
            this.attrs = {
                style: `padding-bottom: ${height}px`
            };
        }
    }
});
/**
Returns an extension that makes sure the content has a bottom
margin equivalent to the height of the editor, minus one line
height, so that every line in the document can be scrolled to the
top of the editor.

This is only meaningful when the editor is scrollable, and should
not be enabled in editors that take the size of their content.
*/ function $7beee9608540d2c3$export$1f905ef5d6deb4f() {
    return [
        $7beee9608540d2c3$var$plugin,
        $7beee9608540d2c3$var$contentAttributes.of((view)=>{
            var _a;
            return ((_a = view.plugin($7beee9608540d2c3$var$plugin)) === null || _a === void 0 ? void 0 : _a.attrs) || null;
        })
    ];
}
/**
Mark lines that have a cursor on them with the `"cm-activeLine"`
DOM class.
*/ function $7beee9608540d2c3$export$1a7e096bee9035c() {
    return $7beee9608540d2c3$var$activeLineHighlighter;
}
const $7beee9608540d2c3$var$lineDeco = /*@__PURE__*/ $7beee9608540d2c3$export$10e30b733df217ea.line({
    class: "cm-activeLine"
});
const $7beee9608540d2c3$var$activeLineHighlighter = /*@__PURE__*/ $7beee9608540d2c3$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.decorations = this.getDeco(view);
    }
    update(update) {
        if (update.docChanged || update.selectionSet) this.decorations = this.getDeco(update.view);
    }
    getDeco(view) {
        let lastLineStart = -1, deco = [];
        for (let r of view.state.selection.ranges){
            let line = view.lineBlockAt(r.head);
            if (line.from > lastLineStart) {
                deco.push($7beee9608540d2c3$var$lineDeco.range(line.from));
                lastLineStart = line.from;
            }
        }
        return $7beee9608540d2c3$export$10e30b733df217ea.set(deco);
    }
}, {
    decorations: (v)=>v.decorations
});
class $7beee9608540d2c3$var$Placeholder extends $7beee9608540d2c3$export$95cdd842edb044c5 {
    constructor(content){
        super();
        this.content = content;
    }
    toDOM(view) {
        let wrap = document.createElement("span");
        wrap.className = "cm-placeholder";
        wrap.style.pointerEvents = "none";
        wrap.appendChild(typeof this.content == "string" ? document.createTextNode(this.content) : typeof this.content == "function" ? this.content(view) : this.content.cloneNode(true));
        wrap.setAttribute("aria-hidden", "true");
        return wrap;
    }
    coordsAt(dom) {
        let rects = dom.firstChild ? $7beee9608540d2c3$var$clientRectsFor(dom.firstChild) : [];
        if (!rects.length) return null;
        let style = window.getComputedStyle(dom.parentNode);
        let rect = $7beee9608540d2c3$var$flattenRect(rects[0], style.direction != "rtl");
        let lineHeight = parseInt(style.lineHeight);
        if (rect.bottom - rect.top > lineHeight * 1.5) return {
            left: rect.left,
            right: rect.right,
            top: rect.top,
            bottom: rect.top + lineHeight
        };
        return rect;
    }
    ignoreEvent() {
        return false;
    }
}
/**
Extension that enables a placeholder—a piece of example content
to show when the editor is empty.
*/ function $7beee9608540d2c3$export$c7187bbd1a7a9244(content) {
    let plugin = $7beee9608540d2c3$export$44d5eccfd62adda7.fromClass(class {
        constructor(view){
            this.view = view;
            this.placeholder = content ? $7beee9608540d2c3$export$10e30b733df217ea.set([
                $7beee9608540d2c3$export$10e30b733df217ea.widget({
                    widget: new $7beee9608540d2c3$var$Placeholder(content),
                    side: 1
                }).range(0)
            ]) : $7beee9608540d2c3$export$10e30b733df217ea.none;
        }
        get decorations() {
            return this.view.state.doc.length ? $7beee9608540d2c3$export$10e30b733df217ea.none : this.placeholder;
        }
    }, {
        decorations: (v)=>v.decorations
    });
    return typeof content == "string" ? [
        plugin,
        $7beee9608540d2c3$export$eece2fccabbb77c5.contentAttributes.of({
            "aria-placeholder": content
        })
    ] : plugin;
}
// Don't compute precise column positions for line offsets above this
// (since it could get expensive). Assume offset==column for them.
const $7beee9608540d2c3$var$MaxOff = 2000;
function $7beee9608540d2c3$var$rectangleFor(state, a, b) {
    let startLine = Math.min(a.line, b.line), endLine = Math.max(a.line, b.line);
    let ranges = [];
    if (a.off > $7beee9608540d2c3$var$MaxOff || b.off > $7beee9608540d2c3$var$MaxOff || a.col < 0 || b.col < 0) {
        let startOff = Math.min(a.off, b.off), endOff = Math.max(a.off, b.off);
        for(let i = startLine; i <= endLine; i++){
            let line = state.doc.line(i);
            if (line.length <= endOff) ranges.push((0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(line.from + startOff, line.to + endOff));
        }
    } else {
        let startCol = Math.min(a.col, b.col), endCol = Math.max(a.col, b.col);
        for(let i = startLine; i <= endLine; i++){
            let line = state.doc.line(i);
            let start = (0, $6295c6875f57e3ee$export$718b3d71c384ca05)(line.text, startCol, state.tabSize, true);
            if (start < 0) ranges.push((0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(line.to));
            else {
                let end = (0, $6295c6875f57e3ee$export$718b3d71c384ca05)(line.text, endCol, state.tabSize);
                ranges.push((0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(line.from + start, line.from + end));
            }
        }
    }
    return ranges;
}
function $7beee9608540d2c3$var$absoluteColumn(view, x) {
    let ref = view.coordsAtPos(view.viewport.from);
    return ref ? Math.round(Math.abs((ref.left - x) / view.defaultCharacterWidth)) : -1;
}
function $7beee9608540d2c3$var$getPos(view, event) {
    let offset = view.posAtCoords({
        x: event.clientX,
        y: event.clientY
    }, false);
    let line = view.state.doc.lineAt(offset), off = offset - line.from;
    let col = off > $7beee9608540d2c3$var$MaxOff ? -1 : off == line.length ? $7beee9608540d2c3$var$absoluteColumn(view, event.clientX) : (0, $6295c6875f57e3ee$export$20b4ab289374d0ac)(line.text, view.state.tabSize, offset - line.from);
    return {
        line: line.number,
        col: col,
        off: off
    };
}
function $7beee9608540d2c3$var$rectangleSelectionStyle(view, event) {
    let start = $7beee9608540d2c3$var$getPos(view, event), startSel = view.state.selection;
    if (!start) return null;
    return {
        update (update) {
            if (update.docChanged) {
                let newStart = update.changes.mapPos(update.startState.doc.line(start.line).from);
                let newLine = update.state.doc.lineAt(newStart);
                start = {
                    line: newLine.number,
                    col: start.col,
                    off: Math.min(start.off, newLine.length)
                };
                startSel = startSel.map(update.changes);
            }
        },
        get (event, _extend, multiple) {
            let cur = $7beee9608540d2c3$var$getPos(view, event);
            if (!cur) return startSel;
            let ranges = $7beee9608540d2c3$var$rectangleFor(view.state, start, cur);
            if (!ranges.length) return startSel;
            if (multiple) return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create(ranges.concat(startSel.ranges));
            else return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create(ranges);
        }
    };
}
/**
Create an extension that enables rectangular selections. By
default, it will react to left mouse drag with the Alt key held
down. When such a selection occurs, the text within the rectangle
that was dragged over will be selected, as one selection
[range](https://codemirror.net/6/docs/ref/#state.SelectionRange) per line.
*/ function $7beee9608540d2c3$export$dd482925db1aabd3(options) {
    let filter = (options === null || options === void 0 ? void 0 : options.eventFilter) || ((e)=>e.altKey && e.button == 0);
    return $7beee9608540d2c3$export$eece2fccabbb77c5.mouseSelectionStyle.of((view, event)=>filter(event) ? $7beee9608540d2c3$var$rectangleSelectionStyle(view, event) : null);
}
const $7beee9608540d2c3$var$keys = {
    Alt: [
        18,
        (e)=>!!e.altKey
    ],
    Control: [
        17,
        (e)=>!!e.ctrlKey
    ],
    Shift: [
        16,
        (e)=>!!e.shiftKey
    ],
    Meta: [
        91,
        (e)=>!!e.metaKey
    ]
};
const $7beee9608540d2c3$var$showCrosshair = {
    style: "cursor: crosshair"
};
/**
Returns an extension that turns the pointer cursor into a
crosshair when a given modifier key, defaulting to Alt, is held
down. Can serve as a visual hint that rectangular selection is
going to happen when paired with
[`rectangularSelection`](https://codemirror.net/6/docs/ref/#view.rectangularSelection).
*/ function $7beee9608540d2c3$export$9b6525222ac3b7fb(options = {}) {
    let [code, getter] = $7beee9608540d2c3$var$keys[options.key || "Alt"];
    let plugin = $7beee9608540d2c3$export$44d5eccfd62adda7.fromClass(class {
        constructor(view){
            this.view = view;
            this.isDown = false;
        }
        set(isDown) {
            if (this.isDown != isDown) {
                this.isDown = isDown;
                this.view.update([]);
            }
        }
    }, {
        eventObservers: {
            keydown (e) {
                this.set(e.keyCode == code || getter(e));
            },
            keyup (e) {
                if (e.keyCode == code || !getter(e)) this.set(false);
            },
            mousemove (e) {
                this.set(getter(e));
            }
        }
    });
    return [
        plugin,
        $7beee9608540d2c3$export$eece2fccabbb77c5.contentAttributes.of((view)=>{
            var _a;
            return ((_a = view.plugin(plugin)) === null || _a === void 0 ? void 0 : _a.isDown) ? $7beee9608540d2c3$var$showCrosshair : null;
        })
    ];
}
const $7beee9608540d2c3$var$Outside = "-10000px";
class $7beee9608540d2c3$var$TooltipViewManager {
    constructor(view, facet, createTooltipView, removeTooltipView){
        this.facet = facet;
        this.createTooltipView = createTooltipView;
        this.removeTooltipView = removeTooltipView;
        this.input = view.state.facet(facet);
        this.tooltips = this.input.filter((t)=>t);
        let prev = null;
        this.tooltipViews = this.tooltips.map((t)=>prev = createTooltipView(t, prev));
    }
    update(update, above) {
        var _a;
        let input = update.state.facet(this.facet);
        let tooltips = input.filter((x)=>x);
        if (input === this.input) {
            for (let t of this.tooltipViews)if (t.update) t.update(update);
            return false;
        }
        let tooltipViews = [], newAbove = above ? [] : null;
        for(let i = 0; i < tooltips.length; i++){
            let tip = tooltips[i], known = -1;
            if (!tip) continue;
            for(let i = 0; i < this.tooltips.length; i++){
                let other = this.tooltips[i];
                if (other && other.create == tip.create) known = i;
            }
            if (known < 0) {
                tooltipViews[i] = this.createTooltipView(tip, i ? tooltipViews[i - 1] : null);
                if (newAbove) newAbove[i] = !!tip.above;
            } else {
                let tooltipView = tooltipViews[i] = this.tooltipViews[known];
                if (newAbove) newAbove[i] = above[known];
                if (tooltipView.update) tooltipView.update(update);
            }
        }
        for (let t of this.tooltipViews)if (tooltipViews.indexOf(t) < 0) {
            this.removeTooltipView(t);
            (_a = t.destroy) === null || _a === void 0 || _a.call(t);
        }
        if (above) {
            newAbove.forEach((val, i)=>above[i] = val);
            above.length = newAbove.length;
        }
        this.input = input;
        this.tooltips = tooltips;
        this.tooltipViews = tooltipViews;
        return true;
    }
}
/**
Creates an extension that configures tooltip behavior.
*/ function $7beee9608540d2c3$export$1fc29293196e3bc(config = {}) {
    return $7beee9608540d2c3$var$tooltipConfig.of(config);
}
function $7beee9608540d2c3$var$windowSpace(view) {
    let docElt = view.dom.ownerDocument.documentElement;
    return {
        top: 0,
        left: 0,
        bottom: docElt.clientHeight,
        right: docElt.clientWidth
    };
}
const $7beee9608540d2c3$var$tooltipConfig = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine: (values)=>{
        var _a, _b, _c;
        return {
            position: $7beee9608540d2c3$var$browser.ios ? "absolute" : ((_a = values.find((conf)=>conf.position)) === null || _a === void 0 ? void 0 : _a.position) || "fixed",
            parent: ((_b = values.find((conf)=>conf.parent)) === null || _b === void 0 ? void 0 : _b.parent) || null,
            tooltipSpace: ((_c = values.find((conf)=>conf.tooltipSpace)) === null || _c === void 0 ? void 0 : _c.tooltipSpace) || $7beee9608540d2c3$var$windowSpace
        };
    }
});
const $7beee9608540d2c3$var$knownHeight = /*@__PURE__*/ new WeakMap();
const $7beee9608540d2c3$var$tooltipPlugin = /*@__PURE__*/ $7beee9608540d2c3$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.view = view;
        this.above = [];
        this.inView = true;
        this.madeAbsolute = false;
        this.lastTransaction = 0;
        this.measureTimeout = -1;
        let config = view.state.facet($7beee9608540d2c3$var$tooltipConfig);
        this.position = config.position;
        this.parent = config.parent;
        this.classes = view.themeClasses;
        this.createContainer();
        this.measureReq = {
            read: this.readMeasure.bind(this),
            write: this.writeMeasure.bind(this),
            key: this
        };
        this.resizeObserver = typeof ResizeObserver == "function" ? new ResizeObserver(()=>this.measureSoon()) : null;
        this.manager = new $7beee9608540d2c3$var$TooltipViewManager(view, $7beee9608540d2c3$export$dba11b50e1aa3c12, (t, p)=>this.createTooltip(t, p), (t)=>{
            if (this.resizeObserver) this.resizeObserver.unobserve(t.dom);
            t.dom.remove();
        });
        this.above = this.manager.tooltips.map((t)=>!!t.above);
        this.intersectionObserver = typeof IntersectionObserver == "function" ? new IntersectionObserver((entries)=>{
            if (Date.now() > this.lastTransaction - 50 && entries.length > 0 && entries[entries.length - 1].intersectionRatio < 1) this.measureSoon();
        }, {
            threshold: [
                1
            ]
        }) : null;
        this.observeIntersection();
        view.win.addEventListener("resize", this.measureSoon = this.measureSoon.bind(this));
        this.maybeMeasure();
    }
    createContainer() {
        if (this.parent) {
            this.container = document.createElement("div");
            this.container.style.position = "relative";
            this.container.className = this.view.themeClasses;
            this.parent.appendChild(this.container);
        } else this.container = this.view.dom;
    }
    observeIntersection() {
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            for (let tooltip of this.manager.tooltipViews)this.intersectionObserver.observe(tooltip.dom);
        }
    }
    measureSoon() {
        if (this.measureTimeout < 0) this.measureTimeout = setTimeout(()=>{
            this.measureTimeout = -1;
            this.maybeMeasure();
        }, 50);
    }
    update(update) {
        if (update.transactions.length) this.lastTransaction = Date.now();
        let updated = this.manager.update(update, this.above);
        if (updated) this.observeIntersection();
        let shouldMeasure = updated || update.geometryChanged;
        let newConfig = update.state.facet($7beee9608540d2c3$var$tooltipConfig);
        if (newConfig.position != this.position && !this.madeAbsolute) {
            this.position = newConfig.position;
            for (let t of this.manager.tooltipViews)t.dom.style.position = this.position;
            shouldMeasure = true;
        }
        if (newConfig.parent != this.parent) {
            if (this.parent) this.container.remove();
            this.parent = newConfig.parent;
            this.createContainer();
            for (let t of this.manager.tooltipViews)this.container.appendChild(t.dom);
            shouldMeasure = true;
        } else if (this.parent && this.view.themeClasses != this.classes) this.classes = this.container.className = this.view.themeClasses;
        if (shouldMeasure) this.maybeMeasure();
    }
    createTooltip(tooltip, prev) {
        let tooltipView = tooltip.create(this.view);
        let before = prev ? prev.dom : null;
        tooltipView.dom.classList.add("cm-tooltip");
        if (tooltip.arrow && !tooltipView.dom.querySelector(".cm-tooltip > .cm-tooltip-arrow")) {
            let arrow = document.createElement("div");
            arrow.className = "cm-tooltip-arrow";
            tooltipView.dom.appendChild(arrow);
        }
        tooltipView.dom.style.position = this.position;
        tooltipView.dom.style.top = $7beee9608540d2c3$var$Outside;
        tooltipView.dom.style.left = "0px";
        this.container.insertBefore(tooltipView.dom, before);
        if (tooltipView.mount) tooltipView.mount(this.view);
        if (this.resizeObserver) this.resizeObserver.observe(tooltipView.dom);
        return tooltipView;
    }
    destroy() {
        var _a, _b, _c;
        this.view.win.removeEventListener("resize", this.measureSoon);
        for (let tooltipView of this.manager.tooltipViews){
            tooltipView.dom.remove();
            (_a = tooltipView.destroy) === null || _a === void 0 || _a.call(tooltipView);
        }
        if (this.parent) this.container.remove();
        (_b = this.resizeObserver) === null || _b === void 0 || _b.disconnect();
        (_c = this.intersectionObserver) === null || _c === void 0 || _c.disconnect();
        clearTimeout(this.measureTimeout);
    }
    readMeasure() {
        let scaleX = 1, scaleY = 1, makeAbsolute = false;
        if (this.position == "fixed" && this.manager.tooltipViews.length) {
            let { dom: dom } = this.manager.tooltipViews[0];
            if ($7beee9608540d2c3$var$browser.safari) {
                // Safari always sets offsetParent to null, even if a fixed
                // element is positioned relative to a transformed parent. So
                // we use this kludge to try and detect this.
                let rect = dom.getBoundingClientRect();
                makeAbsolute = Math.abs(rect.top + 10000) > 1 || Math.abs(rect.left) > 1;
            } else // More conforming browsers will set offsetParent to the
            // transformed element.
            makeAbsolute = !!dom.offsetParent && dom.offsetParent != this.container.ownerDocument.body;
        }
        if (makeAbsolute || this.position == "absolute") {
            if (this.parent) {
                let rect = this.parent.getBoundingClientRect();
                if (rect.width && rect.height) {
                    scaleX = rect.width / this.parent.offsetWidth;
                    scaleY = rect.height / this.parent.offsetHeight;
                }
            } else ({ scaleX: scaleX, scaleY: scaleY } = this.view.viewState);
        }
        let visible = this.view.scrollDOM.getBoundingClientRect(), margins = $7beee9608540d2c3$var$getScrollMargins(this.view);
        return {
            visible: {
                left: visible.left + margins.left,
                top: visible.top + margins.top,
                right: visible.right - margins.right,
                bottom: visible.bottom - margins.bottom
            },
            parent: this.parent ? this.container.getBoundingClientRect() : this.view.dom.getBoundingClientRect(),
            pos: this.manager.tooltips.map((t, i)=>{
                let tv = this.manager.tooltipViews[i];
                return tv.getCoords ? tv.getCoords(t.pos) : this.view.coordsAtPos(t.pos);
            }),
            size: this.manager.tooltipViews.map(({ dom: dom })=>dom.getBoundingClientRect()),
            space: this.view.state.facet($7beee9608540d2c3$var$tooltipConfig).tooltipSpace(this.view),
            scaleX: scaleX,
            scaleY: scaleY,
            makeAbsolute: makeAbsolute
        };
    }
    writeMeasure(measured) {
        var _a;
        if (measured.makeAbsolute) {
            this.madeAbsolute = true;
            this.position = "absolute";
            for (let t of this.manager.tooltipViews)t.dom.style.position = "absolute";
        }
        let { visible: visible, space: space, scaleX: scaleX, scaleY: scaleY } = measured;
        let others = [];
        for(let i = 0; i < this.manager.tooltips.length; i++){
            let tooltip = this.manager.tooltips[i], tView = this.manager.tooltipViews[i], { dom: dom } = tView;
            let pos = measured.pos[i], size = measured.size[i];
            // Hide tooltips that are outside of the editor.
            if (!pos || tooltip.clip !== false && (pos.bottom <= Math.max(visible.top, space.top) || pos.top >= Math.min(visible.bottom, space.bottom) || pos.right < Math.max(visible.left, space.left) - .1 || pos.left > Math.min(visible.right, space.right) + .1)) {
                dom.style.top = $7beee9608540d2c3$var$Outside;
                continue;
            }
            let arrow = tooltip.arrow ? tView.dom.querySelector(".cm-tooltip-arrow") : null;
            let arrowHeight = arrow ? 7 /* Arrow.Size */  : 0;
            let width = size.right - size.left, height = (_a = $7beee9608540d2c3$var$knownHeight.get(tView)) !== null && _a !== void 0 ? _a : size.bottom - size.top;
            let offset = tView.offset || $7beee9608540d2c3$var$noOffset, ltr = this.view.textDirection == $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR;
            let left = size.width > space.right - space.left ? ltr ? space.left : space.right - size.width : ltr ? Math.max(space.left, Math.min(pos.left - (arrow ? 14 /* Arrow.Offset */  : 0) + offset.x, space.right - width)) : Math.min(Math.max(space.left, pos.left - width + (arrow ? 14 /* Arrow.Offset */  : 0) - offset.x), space.right - width);
            let above = this.above[i];
            if (!tooltip.strictSide && (above ? pos.top - height - arrowHeight - offset.y < space.top : pos.bottom + height + arrowHeight + offset.y > space.bottom) && above == space.bottom - pos.bottom > pos.top - space.top) above = this.above[i] = !above;
            let spaceVert = (above ? pos.top - space.top : space.bottom - pos.bottom) - arrowHeight;
            if (spaceVert < height && tView.resize !== false) {
                if (spaceVert < this.view.defaultLineHeight) {
                    dom.style.top = $7beee9608540d2c3$var$Outside;
                    continue;
                }
                $7beee9608540d2c3$var$knownHeight.set(tView, height);
                dom.style.height = (height = spaceVert) / scaleY + "px";
            } else if (dom.style.height) dom.style.height = "";
            let top = above ? pos.top - height - arrowHeight - offset.y : pos.bottom + arrowHeight + offset.y;
            let right = left + width;
            if (tView.overlap !== true) {
                for (let r of others)if (r.left < right && r.right > left && r.top < top + height && r.bottom > top) top = above ? r.top - height - 2 - arrowHeight : r.bottom + arrowHeight + 2;
            }
            if (this.position == "absolute") {
                dom.style.top = (top - measured.parent.top) / scaleY + "px";
                $7beee9608540d2c3$var$setLeftStyle(dom, (left - measured.parent.left) / scaleX);
            } else {
                dom.style.top = top / scaleY + "px";
                $7beee9608540d2c3$var$setLeftStyle(dom, left / scaleX);
            }
            if (arrow) {
                let arrowLeft = pos.left + (ltr ? offset.x : -offset.x) - (left + 14 /* Arrow.Offset */  - 7 /* Arrow.Size */ );
                arrow.style.left = arrowLeft / scaleX + "px";
            }
            if (tView.overlap !== true) others.push({
                left: left,
                top: top,
                right: right,
                bottom: top + height
            });
            dom.classList.toggle("cm-tooltip-above", above);
            dom.classList.toggle("cm-tooltip-below", !above);
            if (tView.positioned) tView.positioned(measured.space);
        }
    }
    maybeMeasure() {
        if (this.manager.tooltips.length) {
            if (this.view.inView) this.view.requestMeasure(this.measureReq);
            if (this.inView != this.view.inView) {
                this.inView = this.view.inView;
                if (!this.inView) for (let tv of this.manager.tooltipViews)tv.dom.style.top = $7beee9608540d2c3$var$Outside;
            }
        }
    }
}, {
    eventObservers: {
        scroll () {
            this.maybeMeasure();
        }
    }
});
function $7beee9608540d2c3$var$setLeftStyle(elt, value) {
    let current = parseInt(elt.style.left, 10);
    if (isNaN(current) || Math.abs(value - current) > 1) elt.style.left = value + "px";
}
const $7beee9608540d2c3$var$baseTheme = /*@__PURE__*/ $7beee9608540d2c3$export$eece2fccabbb77c5.baseTheme({
    ".cm-tooltip": {
        zIndex: 500,
        boxSizing: "border-box"
    },
    "&light .cm-tooltip": {
        border: "1px solid #bbb",
        backgroundColor: "#f5f5f5"
    },
    "&light .cm-tooltip-section:not(:first-child)": {
        borderTop: "1px solid #bbb"
    },
    "&dark .cm-tooltip": {
        backgroundColor: "#333338",
        color: "white"
    },
    ".cm-tooltip-arrow": {
        height: `${7 /* Arrow.Size */ }px`,
        width: `${14}px`,
        position: "absolute",
        zIndex: -1,
        overflow: "hidden",
        "&:before, &:after": {
            content: "''",
            position: "absolute",
            width: 0,
            height: 0,
            borderLeft: `${7 /* Arrow.Size */ }px solid transparent`,
            borderRight: `${7 /* Arrow.Size */ }px solid transparent`
        },
        ".cm-tooltip-above &": {
            bottom: `-${7 /* Arrow.Size */ }px`,
            "&:before": {
                borderTop: `${7 /* Arrow.Size */ }px solid #bbb`
            },
            "&:after": {
                borderTop: `${7 /* Arrow.Size */ }px solid #f5f5f5`,
                bottom: "1px"
            }
        },
        ".cm-tooltip-below &": {
            top: `-${7 /* Arrow.Size */ }px`,
            "&:before": {
                borderBottom: `${7 /* Arrow.Size */ }px solid #bbb`
            },
            "&:after": {
                borderBottom: `${7 /* Arrow.Size */ }px solid #f5f5f5`,
                top: "1px"
            }
        }
    },
    "&dark .cm-tooltip .cm-tooltip-arrow": {
        "&:before": {
            borderTopColor: "#333338",
            borderBottomColor: "#333338"
        },
        "&:after": {
            borderTopColor: "transparent",
            borderBottomColor: "transparent"
        }
    }
});
const $7beee9608540d2c3$var$noOffset = {
    x: 0,
    y: 0
};
/**
Facet to which an extension can add a value to show a tooltip.
*/ const $7beee9608540d2c3$export$dba11b50e1aa3c12 = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    enables: [
        $7beee9608540d2c3$var$tooltipPlugin,
        $7beee9608540d2c3$var$baseTheme
    ]
});
const $7beee9608540d2c3$var$showHoverTooltip = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine: (inputs)=>inputs.reduce((a, i)=>a.concat(i), [])
});
class $7beee9608540d2c3$var$HoverTooltipHost {
    // Needs to be static so that host tooltip instances always match
    static create(view) {
        return new $7beee9608540d2c3$var$HoverTooltipHost(view);
    }
    constructor(view){
        this.view = view;
        this.mounted = false;
        this.dom = document.createElement("div");
        this.dom.classList.add("cm-tooltip-hover");
        this.manager = new $7beee9608540d2c3$var$TooltipViewManager(view, $7beee9608540d2c3$var$showHoverTooltip, (t, p)=>this.createHostedView(t, p), (t)=>t.dom.remove());
    }
    createHostedView(tooltip, prev) {
        let hostedView = tooltip.create(this.view);
        hostedView.dom.classList.add("cm-tooltip-section");
        this.dom.insertBefore(hostedView.dom, prev ? prev.dom.nextSibling : this.dom.firstChild);
        if (this.mounted && hostedView.mount) hostedView.mount(this.view);
        return hostedView;
    }
    mount(view) {
        for (let hostedView of this.manager.tooltipViews)if (hostedView.mount) hostedView.mount(view);
        this.mounted = true;
    }
    positioned(space) {
        for (let hostedView of this.manager.tooltipViews)if (hostedView.positioned) hostedView.positioned(space);
    }
    update(update) {
        this.manager.update(update);
    }
    destroy() {
        var _a;
        for (let t of this.manager.tooltipViews)(_a = t.destroy) === null || _a === void 0 || _a.call(t);
    }
    passProp(name) {
        let value = undefined;
        for (let view of this.manager.tooltipViews){
            let given = view[name];
            if (given !== undefined) {
                if (value === undefined) value = given;
                else if (value !== given) return undefined;
            }
        }
        return value;
    }
    get offset() {
        return this.passProp("offset");
    }
    get getCoords() {
        return this.passProp("getCoords");
    }
    get overlap() {
        return this.passProp("overlap");
    }
    get resize() {
        return this.passProp("resize");
    }
}
const $7beee9608540d2c3$var$showHoverTooltipHost = /*@__PURE__*/ $7beee9608540d2c3$export$dba11b50e1aa3c12.compute([
    $7beee9608540d2c3$var$showHoverTooltip
], (state)=>{
    let tooltips = state.facet($7beee9608540d2c3$var$showHoverTooltip);
    if (tooltips.length === 0) return null;
    return {
        pos: Math.min(...tooltips.map((t)=>t.pos)),
        end: Math.max(...tooltips.map((t)=>{
            var _a;
            return (_a = t.end) !== null && _a !== void 0 ? _a : t.pos;
        })),
        create: $7beee9608540d2c3$var$HoverTooltipHost.create,
        above: tooltips[0].above,
        arrow: tooltips.some((t)=>t.arrow)
    };
});
const $7beee9608540d2c3$var$hoverPlugin = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
class $7beee9608540d2c3$var$HoverPlugin {
    constructor(view, source, field, locked, setHover, hoverTime){
        this.view = view;
        this.source = source;
        this.field = field;
        this.locked = locked;
        this.setHover = setHover;
        this.hoverTime = hoverTime;
        this.hoverTimeout = -1;
        this.restartTimeout = -1;
        this.pending = null;
        this.lastMove = {
            x: 0,
            y: 0,
            target: view.dom,
            time: 0
        };
        this.checkHover = this.checkHover.bind(this);
        view.dom.addEventListener("mouseleave", this.mouseleave = this.mouseleave.bind(this));
        view.dom.addEventListener("mousemove", this.mousemove = this.mousemove.bind(this));
    }
    update(update) {
        if (this.pending) {
            this.pending = null;
            clearTimeout(this.restartTimeout);
            this.restartTimeout = setTimeout(()=>this.startHover(), 20);
        }
    }
    get active() {
        return this.view.state.field(this.field);
    }
    checkHover() {
        this.hoverTimeout = -1;
        if (this.active.length) return;
        let hovered = Date.now() - this.lastMove.time;
        if (hovered < this.hoverTime) this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime - hovered);
        else this.startHover();
    }
    startHover() {
        clearTimeout(this.restartTimeout);
        let { view: view, lastMove: lastMove } = this;
        let tile = view.docView.tile.nearest(lastMove.target);
        if (!tile) return;
        let pos, side = 1;
        if (tile.isWidget()) pos = tile.posAtStart;
        else {
            pos = view.posAtCoords(lastMove);
            if (pos == null) return;
            let posCoords = view.coordsAtPos(pos);
            if (!posCoords || lastMove.y < posCoords.top || lastMove.y > posCoords.bottom || lastMove.x < posCoords.left - view.defaultCharacterWidth || lastMove.x > posCoords.right + view.defaultCharacterWidth) return;
            let bidi = view.bidiSpans(view.state.doc.lineAt(pos)).find((s)=>s.from <= pos && s.to >= pos);
            let rtl = bidi && bidi.dir == $7beee9608540d2c3$export$cacd6541cfeeb6c1.RTL ? -1 : 1;
            side = lastMove.x < posCoords.left ? -rtl : rtl;
        }
        this.activateHover(view, pos, side);
    }
    activateHover(view, pos, side, locked) {
        let open = this.source(view, pos, side);
        let done = (value)=>{
            if (value && !(Array.isArray(value) && !value.length)) {
                let tooltips = Array.isArray(value) ? value : [
                    value
                ];
                if (locked) this.locked.set(tooltips, locked);
                view.dispatch({
                    effects: this.setHover.of(tooltips)
                });
            }
        };
        if (open && "then" in open) {
            let pending = this.pending = {
                pos: pos
            };
            open.then((result)=>{
                if (this.pending == pending) {
                    this.pending = null;
                    done(result);
                }
            }, (e)=>$7beee9608540d2c3$export$f86b2a1a2ce291b3(view.state, e, "hover tooltip"));
        } else done(open);
    }
    get tooltip() {
        let plugin = this.view.plugin($7beee9608540d2c3$var$tooltipPlugin);
        let index = plugin ? plugin.manager.tooltips.findIndex((t)=>t.create == $7beee9608540d2c3$var$HoverTooltipHost.create) : -1;
        return index > -1 ? plugin.manager.tooltipViews[index] : null;
    }
    mousemove(event) {
        var _a, _b;
        this.lastMove = {
            x: event.clientX,
            y: event.clientY,
            target: event.target,
            time: Date.now()
        };
        if (this.hoverTimeout < 0) this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime);
        let { active: active, tooltip: tooltip } = this;
        if (active.length && !this.locked.has(active) && tooltip && !$7beee9608540d2c3$var$isInTooltip(tooltip.dom, event) || this.pending) {
            let { pos: pos } = active[0] || this.pending, end = (_b = (_a = active[0]) === null || _a === void 0 ? void 0 : _a.end) !== null && _b !== void 0 ? _b : pos;
            if (pos == end ? this.view.posAtCoords(this.lastMove) != pos : !$7beee9608540d2c3$var$isOverRange(this.view, pos, end, event.clientX, event.clientY)) {
                this.view.dispatch({
                    effects: this.setHover.of([])
                });
                this.pending = null;
            }
        }
    }
    mouseleave(event) {
        clearTimeout(this.hoverTimeout);
        this.hoverTimeout = -1;
        let { active: active } = this;
        if (active.length && !this.locked.has(active)) {
            let { tooltip: tooltip } = this;
            let inTooltip = tooltip && tooltip.dom.contains(event.relatedTarget);
            if (!inTooltip) this.view.dispatch({
                effects: this.setHover.of([])
            });
            else this.watchTooltipLeave(tooltip.dom);
        }
    }
    watchTooltipLeave(tooltip) {
        let watch = (event)=>{
            tooltip.removeEventListener("mouseleave", watch);
            let { active: active } = this;
            if (active.length && !this.locked.has(active) && !this.view.dom.contains(event.relatedTarget)) this.view.dispatch({
                effects: this.setHover.of([])
            });
        };
        tooltip.addEventListener("mouseleave", watch);
    }
    destroy() {
        clearTimeout(this.hoverTimeout);
        clearTimeout(this.restartTimeout);
        this.view.dom.removeEventListener("mouseleave", this.mouseleave);
        this.view.dom.removeEventListener("mousemove", this.mousemove);
    }
}
const $7beee9608540d2c3$var$tooltipMargin = 4;
function $7beee9608540d2c3$var$isInTooltip(tooltip, event) {
    let { left: left, right: right, top: top, bottom: bottom } = tooltip.getBoundingClientRect(), arrow;
    if (arrow = tooltip.querySelector(".cm-tooltip-arrow")) {
        let arrowRect = arrow.getBoundingClientRect();
        top = Math.min(arrowRect.top, top);
        bottom = Math.max(arrowRect.bottom, bottom);
    }
    return event.clientX >= left - $7beee9608540d2c3$var$tooltipMargin && event.clientX <= right + $7beee9608540d2c3$var$tooltipMargin && event.clientY >= top - $7beee9608540d2c3$var$tooltipMargin && event.clientY <= bottom + $7beee9608540d2c3$var$tooltipMargin;
}
function $7beee9608540d2c3$var$isOverRange(view, from, to, x, y, margin) {
    let rect = view.scrollDOM.getBoundingClientRect();
    let docBottom = view.documentTop + view.documentPadding.top + view.contentHeight;
    if (rect.left > x || rect.right < x || rect.top > y || Math.min(rect.bottom, docBottom) < y) return false;
    let pos = view.posAtCoords({
        x: x,
        y: y
    }, false);
    return pos >= from && pos <= to;
}
/**
Set up a hover tooltip, which shows up when the pointer hovers
over ranges of text. The callback is called when the mouse hovers
over the document text. It should, if there is a tooltip
associated with position `pos`, return the tooltip description
(either directly or in a promise). The `side` argument indicates
on which side of the position the pointer is—it will be -1 if the
pointer is before the position, 1 if after the position.

Note that all hover tooltips are hosted within a single tooltip
container element. This allows multiple tooltips over the same
range to be "merged" together without overlapping.

The return value is a valid [editor extension](https://codemirror.net/6/docs/ref/#state.Extension)
but also provides an `active` property holding a state field that
can be used to read the currently active tooltips produced by this
extension.
*/ function $7beee9608540d2c3$export$69f8d9e63c4aa884(source, options = {}) {
    let setHover = (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
    // This would be better stored in the state field, but we've set
    // down the type of the field in our interface, so it's indirectly
    // stored by array identity.
    let locked = new WeakMap();
    let hoverState = (0, $6295c6875f57e3ee$export$34381b1ce2130245).define({
        create () {
            return [];
        },
        update (value, tr) {
            let lock = locked.get(value);
            if (value.length) {
                if (options.hideOnChange && (tr.docChanged || tr.selection)) value = [];
                else if (lock && lock(tr)) value = [];
                else if (options.hideOn) value = value.filter((v)=>!options.hideOn(tr, v));
            }
            if (tr.docChanged && value.length) {
                let mapped = [];
                for (let tooltip of value){
                    let newPos = tr.changes.mapPos(tooltip.pos, -1, (0, $6295c6875f57e3ee$export$39cf3280165f92aa).TrackDel);
                    if (newPos != null) {
                        let copy = Object.assign(Object.create(null), tooltip);
                        copy.pos = newPos;
                        if (copy.end != null) copy.end = tr.changes.mapPos(copy.end);
                        mapped.push(copy);
                    }
                }
                value = mapped;
            }
            for (let effect of tr.effects){
                if (effect.is(setHover)) {
                    value = effect.value;
                    lock = undefined;
                }
                if (effect.is($7beee9608540d2c3$var$closeHoverTooltipEffect) && !effect.value || effect.value == hoverState) value = [];
            }
            if (value.length && lock) locked.set(value, lock);
            return value;
        },
        provide: (f)=>$7beee9608540d2c3$var$showHoverTooltip.from(f)
    });
    const plugin = $7beee9608540d2c3$export$44d5eccfd62adda7.define((view)=>new $7beee9608540d2c3$var$HoverPlugin(view, source, hoverState, locked, setHover, options.hoverTime || 300 /* Hover.Time */ ));
    return {
        active: hoverState,
        extension: [
            hoverState,
            plugin,
            $7beee9608540d2c3$var$hoverPlugin.of(plugin),
            $7beee9608540d2c3$var$showHoverTooltipHost
        ]
    };
}
/**
Activate hover tooltips for the given position and side. If you
provide a specific hover tooltip (the value returned from
[`hoverTooltip`](https://codemirror.net/6/docs/ref/#view.hoverTooltip)), only that one will be
activated. If not given, all hover tooltips at the given position
are triggered.

Note that tooltips opened this way don't close automatically, and
you'll want to pass an `until` callback or use
[`closeHoverTooltip`](https://codemirror.net/6/docs/ref/#view.closeHoverTooltip)/[`closeHoverTooltips`](https://codemirror.net/6/docs/ref/#view.closeHoverTooltips)
to deactivate them.
*/ function $7beee9608540d2c3$export$a34e0ba9d4697396(view, pos, side, options = {}) {
    var _a;
    let plugins = view.state.facet($7beee9608540d2c3$var$hoverPlugin).map((p)=>view.plugin(p)).filter((p)=>!!p);
    if (options.tooltip && options.tooltip.active) {
        let found = plugins.find((p)=>p.field == options.tooltip.active);
        if (found) plugins = [
            found
        ];
    }
    for (let plugin of plugins)plugin.activateHover(view, pos, side, (_a = options.until) !== null && _a !== void 0 ? _a : ()=>false);
}
/**
Get the active tooltip view for a given tooltip, if available.
*/ function $7beee9608540d2c3$export$46455b4476d4b8e1(view, tooltip) {
    let plugin = view.plugin($7beee9608540d2c3$var$tooltipPlugin);
    if (!plugin) return null;
    let found = plugin.manager.tooltips.indexOf(tooltip);
    return found < 0 ? null : plugin.manager.tooltipViews[found];
}
/**
Returns true if any hover tooltips are currently active.
*/ function $7beee9608540d2c3$export$7864d875805bc1b0(state) {
    return state.facet($7beee9608540d2c3$var$showHoverTooltip).some((x)=>x);
}
const $7beee9608540d2c3$var$closeHoverTooltipEffect = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
/**
Transaction effect that closes all hover tooltips.
*/ const $7beee9608540d2c3$export$f6974094db6525a = /*@__PURE__*/ $7beee9608540d2c3$var$closeHoverTooltipEffect.of(null);
/**
Transaction effect that closes a specific hover tooltip.
*/ function $7beee9608540d2c3$export$8ad7caa9981c5ca8(tooltip) {
    return $7beee9608540d2c3$var$closeHoverTooltipEffect.of(tooltip.active);
}
/**
Tell the tooltip extension to recompute the position of the active
tooltips. This can be useful when something happens (such as a
re-positioning or CSS change affecting the editor) that could
invalidate the existing tooltip positions.
*/ function $7beee9608540d2c3$export$912859096d593b90(view) {
    let plugin = view.plugin($7beee9608540d2c3$var$tooltipPlugin);
    if (plugin) plugin.maybeMeasure();
}
const $7beee9608540d2c3$var$panelConfig = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        let topContainer, bottomContainer;
        for (let c of configs){
            topContainer = topContainer || c.topContainer;
            bottomContainer = bottomContainer || c.bottomContainer;
        }
        return {
            topContainer: topContainer,
            bottomContainer: bottomContainer
        };
    }
});
/**
Configures the panel-managing extension.
*/ function $7beee9608540d2c3$export$8128819a2322681a(config) {
    return config ? [
        $7beee9608540d2c3$var$panelConfig.of(config)
    ] : [];
}
/**
Get the active panel created by the given constructor, if any.
This can be useful when you need access to your panels' DOM
structure.
*/ function $7beee9608540d2c3$export$7361ed18ff57179e(view, panel) {
    let plugin = view.plugin($7beee9608540d2c3$var$panelPlugin);
    let index = plugin ? plugin.specs.indexOf(panel) : -1;
    return index > -1 ? plugin.panels[index] : null;
}
const $7beee9608540d2c3$var$panelPlugin = /*@__PURE__*/ $7beee9608540d2c3$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.input = view.state.facet($7beee9608540d2c3$export$e89c3c9af31c1e3b);
        this.specs = this.input.filter((s)=>s);
        this.panels = this.specs.map((spec)=>spec(view));
        let conf = view.state.facet($7beee9608540d2c3$var$panelConfig);
        this.top = new $7beee9608540d2c3$var$PanelGroup(view, true, conf.topContainer);
        this.bottom = new $7beee9608540d2c3$var$PanelGroup(view, false, conf.bottomContainer);
        this.top.sync(this.panels.filter((p)=>p.top));
        this.bottom.sync(this.panels.filter((p)=>!p.top));
        for (let p of this.panels){
            p.dom.classList.add("cm-panel");
            if (p.mount) p.mount();
        }
    }
    update(update) {
        let conf = update.state.facet($7beee9608540d2c3$var$panelConfig);
        if (this.top.container != conf.topContainer) {
            this.top.sync([]);
            this.top = new $7beee9608540d2c3$var$PanelGroup(update.view, true, conf.topContainer);
        }
        if (this.bottom.container != conf.bottomContainer) {
            this.bottom.sync([]);
            this.bottom = new $7beee9608540d2c3$var$PanelGroup(update.view, false, conf.bottomContainer);
        }
        this.top.syncClasses();
        this.bottom.syncClasses();
        let input = update.state.facet($7beee9608540d2c3$export$e89c3c9af31c1e3b);
        if (input != this.input) {
            let specs = input.filter((x)=>x);
            let panels = [], top = [], bottom = [], mount = [];
            for (let spec of specs){
                let known = this.specs.indexOf(spec), panel;
                if (known < 0) {
                    panel = spec(update.view);
                    mount.push(panel);
                } else {
                    panel = this.panels[known];
                    if (panel.update) panel.update(update);
                }
                panels.push(panel);
                (panel.top ? top : bottom).push(panel);
            }
            this.specs = specs;
            this.panels = panels;
            this.top.sync(top);
            this.bottom.sync(bottom);
            for (let p of mount){
                p.dom.classList.add("cm-panel");
                if (p.mount) p.mount();
            }
        } else {
            for (let p of this.panels)if (p.update) p.update(update);
        }
    }
    destroy() {
        this.top.sync([]);
        this.bottom.sync([]);
    }
}, {
    provide: (plugin)=>$7beee9608540d2c3$export$eece2fccabbb77c5.scrollMargins.of((view)=>{
            let value = view.plugin(plugin);
            return value && {
                top: value.top.scrollMargin(),
                bottom: value.bottom.scrollMargin()
            };
        })
});
class $7beee9608540d2c3$var$PanelGroup {
    constructor(view, top, container){
        this.view = view;
        this.top = top;
        this.container = container;
        this.dom = undefined;
        this.classes = "";
        this.panels = [];
        this.syncClasses();
    }
    sync(panels) {
        for (let p of this.panels)if (p.destroy && panels.indexOf(p) < 0) p.destroy();
        this.panels = panels;
        this.syncDOM();
    }
    syncDOM() {
        if (this.panels.length == 0) {
            if (this.dom) {
                this.dom.remove();
                this.dom = undefined;
            }
            return;
        }
        if (!this.dom) {
            this.dom = document.createElement("div");
            this.dom.className = this.top ? "cm-panels cm-panels-top" : "cm-panels cm-panels-bottom";
            this.dom.style[this.top ? "top" : "bottom"] = "0";
            let parent = this.container || this.view.dom;
            parent.insertBefore(this.dom, this.top ? parent.firstChild : null);
        }
        let curDOM = this.dom.firstChild;
        for (let panel of this.panels)if (panel.dom.parentNode == this.dom) {
            while(curDOM != panel.dom)curDOM = $7beee9608540d2c3$var$rm(curDOM);
            curDOM = curDOM.nextSibling;
        } else this.dom.insertBefore(panel.dom, curDOM);
        while(curDOM)curDOM = $7beee9608540d2c3$var$rm(curDOM);
    }
    scrollMargin() {
        return !this.dom || this.container ? 0 : Math.max(0, this.top ? this.dom.getBoundingClientRect().bottom - Math.max(0, this.view.scrollDOM.getBoundingClientRect().top) : Math.min(innerHeight, this.view.scrollDOM.getBoundingClientRect().bottom) - this.dom.getBoundingClientRect().top);
    }
    syncClasses() {
        if (!this.container || this.classes == this.view.themeClasses) return;
        for (let cls of this.classes.split(" "))if (cls) this.container.classList.remove(cls);
        for (let cls of (this.classes = this.view.themeClasses).split(" "))if (cls) this.container.classList.add(cls);
    }
}
function $7beee9608540d2c3$var$rm(node) {
    let next = node.nextSibling;
    node.remove();
    return next;
}
/**
Opening a panel is done by providing a constructor function for
the panel through this facet. (The panel is closed again when its
constructor is no longer provided.) Values of `null` are ignored.
*/ const $7beee9608540d2c3$export$e89c3c9af31c1e3b = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    enables: $7beee9608540d2c3$var$panelPlugin
});
/**
Show a panel above or below the editor to show the user a message
or prompt them for input. Returns an effect that can be dispatched
to close the dialog, and a promise that resolves when the dialog
is closed or a form inside of it is submitted.

You are encouraged, if your handling of the result of the promise
dispatches a transaction, to include the `close` effect in it. If
you don't, this function will automatically dispatch a separate
transaction right after.
*/ function $7beee9608540d2c3$export$61e0a65f251cfdb3(view, config) {
    let resolve;
    let promise = new Promise((r)=>resolve = r);
    let panelCtor = (view)=>$7beee9608540d2c3$var$createDialog(view, config, resolve);
    if (view.state.field($7beee9608540d2c3$var$dialogField, false)) view.dispatch({
        effects: $7beee9608540d2c3$var$openDialogEffect.of(panelCtor)
    });
    else view.dispatch({
        effects: (0, $6295c6875f57e3ee$export$95000d4efaa4321f).appendConfig.of($7beee9608540d2c3$var$dialogField.init(()=>[
                panelCtor
            ]))
    });
    let close = $7beee9608540d2c3$var$closeDialogEffect.of(panelCtor);
    return {
        close: close,
        result: promise.then((form)=>{
            let queue = view.win.queueMicrotask || ((f)=>view.win.setTimeout(f, 10));
            queue(()=>{
                if (view.state.field($7beee9608540d2c3$var$dialogField).indexOf(panelCtor) > -1) view.dispatch({
                    effects: close
                });
            });
            return form;
        })
    };
}
/**
Find the [`Panel`](https://codemirror.net/6/docs/ref/#view.Panel) for an open dialog, using a class
name as identifier.
*/ function $7beee9608540d2c3$export$add6d5f54f9ab5a8(view, className) {
    let dialogs = view.state.field($7beee9608540d2c3$var$dialogField, false) || [];
    for (let open of dialogs){
        let panel = $7beee9608540d2c3$export$7361ed18ff57179e(view, open);
        if (panel && panel.dom.classList.contains(className)) return panel;
    }
    return null;
}
const $7beee9608540d2c3$var$dialogField = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$34381b1ce2130245).define({
    create () {
        return [];
    },
    update (dialogs, tr) {
        for (let e of tr.effects){
            if (e.is($7beee9608540d2c3$var$openDialogEffect)) dialogs = [
                e.value
            ].concat(dialogs);
            else if (e.is($7beee9608540d2c3$var$closeDialogEffect)) dialogs = dialogs.filter((d)=>d != e.value);
        }
        return dialogs;
    },
    provide: (f)=>$7beee9608540d2c3$export$e89c3c9af31c1e3b.computeN([
            f
        ], (state)=>state.field(f))
});
const $7beee9608540d2c3$var$openDialogEffect = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
const $7beee9608540d2c3$var$closeDialogEffect = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
function $7beee9608540d2c3$var$createDialog(view, config, result) {
    let content = config.content ? config.content(view, ()=>done(null)) : null;
    if (!content) {
        content = (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("form");
        if (config.input) {
            let input = (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("input", config.input);
            if (/^(text|password|number|email|tel|url)$/.test(input.type)) input.classList.add("cm-textfield");
            if (!input.name) input.name = "input";
            content.appendChild((0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("label", (config.label || "") + ": ", input));
        } else content.appendChild(document.createTextNode(config.label || ""));
        content.appendChild(document.createTextNode(" "));
        content.appendChild((0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("button", {
            class: "cm-button",
            type: "submit"
        }, config.submitLabel || "OK"));
    }
    let forms = content.nodeName == "FORM" ? [
        content
    ] : content.querySelectorAll("form");
    for(let i = 0; i < forms.length; i++){
        let form = forms[i];
        form.addEventListener("keydown", (event)=>{
            if (event.keyCode == 27) {
                event.preventDefault();
                done(null);
            } else if (event.keyCode == 13) {
                event.preventDefault();
                done(form);
            }
        });
        form.addEventListener("submit", (event)=>{
            event.preventDefault();
            done(form);
        });
    }
    let panel = (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("div", content, (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("button", {
        onclick: ()=>done(null),
        "aria-label": view.state.phrase("close"),
        class: "cm-dialog-close",
        type: "button"
    }, [
        "\xd7"
    ]));
    if (config.class) panel.className = config.class;
    panel.classList.add("cm-dialog");
    function done(form) {
        if (panel.contains(panel.ownerDocument.activeElement)) view.focus();
        result(form);
    }
    return {
        dom: panel,
        top: config.top,
        mount: ()=>{
            if (config.focus) {
                let focus;
                if (typeof config.focus == "string") focus = content.querySelector(config.focus);
                else focus = content.querySelector("input") || content.querySelector("button");
                if (focus && "select" in focus) focus.select();
                else if (focus && "focus" in focus) focus.focus();
            }
        }
    };
}
/**
A gutter marker represents a bit of information attached to a line
in a specific gutter. Your own custom markers have to extend this
class.
*/ class $7beee9608540d2c3$export$591ab4c909549043 extends (0, $6295c6875f57e3ee$export$d60f08ed93a48611) {
    /**
    @internal
    */ compare(other) {
        return this == other || this.constructor == other.constructor && this.eq(other);
    }
    /**
    Compare this marker to another marker of the same type.
    */ eq(other) {
        return false;
    }
    /**
    Called if the marker has a `toDOM` method and its representation
    was removed from a gutter.
    */ destroy(dom) {}
}
$7beee9608540d2c3$export$591ab4c909549043.prototype.elementClass = "";
$7beee9608540d2c3$export$591ab4c909549043.prototype.toDOM = undefined;
$7beee9608540d2c3$export$591ab4c909549043.prototype.mapMode = (0, $6295c6875f57e3ee$export$39cf3280165f92aa).TrackBefore;
$7beee9608540d2c3$export$591ab4c909549043.prototype.startSide = $7beee9608540d2c3$export$591ab4c909549043.prototype.endSide = -1;
$7beee9608540d2c3$export$591ab4c909549043.prototype.point = true;
/**
Facet used to add a class to all gutter elements for a given line.
Markers given to this facet should _only_ define an
[`elementclass`](https://codemirror.net/6/docs/ref/#view.GutterMarker.elementClass), not a
[`toDOM`](https://codemirror.net/6/docs/ref/#view.GutterMarker.toDOM) (or the marker will appear
in all gutters for the line).
*/ const $7beee9608540d2c3$export$113bd64f27ac1172 = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
/**
Facet used to add a class to all gutter elements next to a widget.
Should not provide widgets with a `toDOM` method.
*/ const $7beee9608540d2c3$export$6dd229d2c0925f7a = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$defaults = {
    class: "",
    renderEmptyElements: false,
    elementStyle: "",
    markers: ()=>(0, $6295c6875f57e3ee$export$34cb5241245008dd).empty,
    lineMarker: ()=>null,
    widgetMarker: ()=>null,
    lineMarkerChange: null,
    initialSpacer: null,
    updateSpacer: null,
    domEventHandlers: {},
    side: "before"
};
const $7beee9608540d2c3$var$activeGutters = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
/**
Define an editor gutter. The order in which the gutters appear is
determined by their extension priority.
*/ function $7beee9608540d2c3$export$f2b922cb4a245974(config) {
    return [
        $7beee9608540d2c3$export$ec15ef01b8fbae61(),
        $7beee9608540d2c3$var$activeGutters.of({
            ...$7beee9608540d2c3$var$defaults,
            ...config
        })
    ];
}
const $7beee9608540d2c3$var$unfixGutters = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine: (values)=>values.some((x)=>x)
});
/**
The gutter-drawing plugin is automatically enabled when you add a
gutter, but you can use this function to explicitly configure it.

Unless `fixed` is explicitly set to `false`, the gutters are
fixed, meaning they don't scroll along with the content
horizontally (except on Internet Explorer, which doesn't support
CSS [`position:
sticky`](https://developer.mozilla.org/en-US/docs/Web/CSS/position#sticky)).
*/ function $7beee9608540d2c3$export$ec15ef01b8fbae61(config) {
    let result = [
        $7beee9608540d2c3$var$gutterView
    ];
    if (config && config.fixed === false) result.push($7beee9608540d2c3$var$unfixGutters.of(true));
    return result;
}
const $7beee9608540d2c3$var$gutterView = /*@__PURE__*/ $7beee9608540d2c3$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.view = view;
        this.domAfter = null;
        this.prevViewport = view.viewport;
        this.dom = document.createElement("div");
        this.dom.className = "cm-gutters cm-gutters-before";
        this.dom.setAttribute("aria-hidden", "true");
        this.dom.style.minHeight = this.view.contentHeight / this.view.scaleY + "px";
        this.gutters = view.state.facet($7beee9608540d2c3$var$activeGutters).map((conf)=>new $7beee9608540d2c3$var$SingleGutterView(view, conf));
        this.fixed = !view.state.facet($7beee9608540d2c3$var$unfixGutters);
        for (let gutter of this.gutters)if (gutter.config.side == "after") this.getDOMAfter().appendChild(gutter.dom);
        else this.dom.appendChild(gutter.dom);
        if (this.fixed) // FIXME IE11 fallback, which doesn't support position: sticky,
        // by using position: relative + event handlers that realign the
        // gutter (or just force fixed=false on IE11?)
        this.dom.style.position = "sticky";
        this.syncGutters(false);
        view.scrollDOM.insertBefore(this.dom, view.contentDOM);
    }
    getDOMAfter() {
        if (!this.domAfter) {
            this.domAfter = document.createElement("div");
            this.domAfter.className = "cm-gutters cm-gutters-after";
            this.domAfter.setAttribute("aria-hidden", "true");
            this.domAfter.style.minHeight = this.view.contentHeight / this.view.scaleY + "px";
            this.domAfter.style.position = this.fixed ? "sticky" : "";
            this.view.scrollDOM.appendChild(this.domAfter);
        }
        return this.domAfter;
    }
    update(update) {
        if (this.updateGutters(update)) {
            // Detach during sync when the viewport changed significantly
            // (such as during scrolling), since for large updates that is
            // faster.
            let vpA = this.prevViewport, vpB = update.view.viewport;
            let vpOverlap = Math.min(vpA.to, vpB.to) - Math.max(vpA.from, vpB.from);
            this.syncGutters(vpOverlap < (vpB.to - vpB.from) * 0.8);
        }
        if (update.geometryChanged) {
            let min = this.view.contentHeight / this.view.scaleY + "px";
            this.dom.style.minHeight = min;
            if (this.domAfter) this.domAfter.style.minHeight = min;
        }
        if (this.view.state.facet($7beee9608540d2c3$var$unfixGutters) != !this.fixed) {
            this.fixed = !this.fixed;
            this.dom.style.position = this.fixed ? "sticky" : "";
            if (this.domAfter) this.domAfter.style.position = this.fixed ? "sticky" : "";
        }
        this.prevViewport = update.view.viewport;
    }
    syncGutters(detach) {
        let after = this.dom.nextSibling;
        if (detach) {
            this.dom.remove();
            if (this.domAfter) this.domAfter.remove();
        }
        let lineClasses = (0, $6295c6875f57e3ee$export$34cb5241245008dd).iter(this.view.state.facet($7beee9608540d2c3$export$113bd64f27ac1172), this.view.viewport.from);
        let classSet = [];
        let contexts = this.gutters.map((gutter)=>new $7beee9608540d2c3$var$UpdateContext(gutter, this.view.viewport, -this.view.documentPadding.top));
        for (let line of this.view.viewportLineBlocks){
            if (classSet.length) classSet = [];
            if (Array.isArray(line.type)) {
                let first = true;
                for (let b of line.type){
                    if (b.type == $7beee9608540d2c3$export$48808c686fe495c4.Text && first) {
                        $7beee9608540d2c3$var$advanceCursor(lineClasses, classSet, b.from);
                        for (let cx of contexts)cx.line(this.view, b, classSet);
                        first = false;
                    } else if (b.widget) for (let cx of contexts)cx.widget(this.view, b);
                }
            } else if (line.type == $7beee9608540d2c3$export$48808c686fe495c4.Text) {
                $7beee9608540d2c3$var$advanceCursor(lineClasses, classSet, line.from);
                for (let cx of contexts)cx.line(this.view, line, classSet);
            } else if (line.widget) for (let cx of contexts)cx.widget(this.view, line);
        }
        for (let cx of contexts)cx.finish();
        if (detach) {
            this.view.scrollDOM.insertBefore(this.dom, after);
            if (this.domAfter) this.view.scrollDOM.appendChild(this.domAfter);
        }
    }
    updateGutters(update) {
        let prev = update.startState.facet($7beee9608540d2c3$var$activeGutters), cur = update.state.facet($7beee9608540d2c3$var$activeGutters);
        let change = update.docChanged || update.heightChanged || update.viewportChanged || !(0, $6295c6875f57e3ee$export$34cb5241245008dd).eq(update.startState.facet($7beee9608540d2c3$export$113bd64f27ac1172), update.state.facet($7beee9608540d2c3$export$113bd64f27ac1172), update.view.viewport.from, update.view.viewport.to);
        if (prev == cur) {
            for (let gutter of this.gutters)if (gutter.update(update)) change = true;
        } else {
            change = true;
            let gutters = [];
            for (let conf of cur){
                let known = prev.indexOf(conf);
                if (known < 0) gutters.push(new $7beee9608540d2c3$var$SingleGutterView(this.view, conf));
                else {
                    this.gutters[known].update(update);
                    gutters.push(this.gutters[known]);
                }
            }
            for (let g of this.gutters){
                g.dom.remove();
                if (gutters.indexOf(g) < 0) g.destroy();
            }
            for (let g of gutters)if (g.config.side == "after") this.getDOMAfter().appendChild(g.dom);
            else this.dom.appendChild(g.dom);
            this.gutters = gutters;
        }
        return change;
    }
    destroy() {
        for (let view of this.gutters)view.destroy();
        this.dom.remove();
        if (this.domAfter) this.domAfter.remove();
    }
}, {
    provide: (plugin)=>$7beee9608540d2c3$export$eece2fccabbb77c5.scrollMargins.of((view)=>{
            let value = view.plugin(plugin);
            if (!value || value.gutters.length == 0 || !value.fixed) return null;
            let before = value.dom.offsetWidth * view.scaleX, after = value.domAfter ? value.domAfter.offsetWidth * view.scaleX : 0;
            return view.textDirection == $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR ? {
                left: before,
                right: after
            } : {
                right: before,
                left: after
            };
        })
});
function $7beee9608540d2c3$var$asArray(val) {
    return Array.isArray(val) ? val : [
        val
    ];
}
function $7beee9608540d2c3$var$advanceCursor(cursor, collect, pos) {
    while(cursor.value && cursor.from <= pos){
        if (cursor.from == pos) collect.push(cursor.value);
        cursor.next();
    }
}
class $7beee9608540d2c3$var$UpdateContext {
    constructor(gutter, viewport, height){
        this.gutter = gutter;
        this.height = height;
        this.i = 0;
        this.cursor = (0, $6295c6875f57e3ee$export$34cb5241245008dd).iter(gutter.markers, viewport.from);
    }
    addElement(view, block, markers) {
        let { gutter: gutter } = this, above = (block.top - this.height) / view.scaleY, height = block.height / view.scaleY;
        if (this.i == gutter.elements.length) {
            let newElt = new $7beee9608540d2c3$var$GutterElement(view, height, above, markers);
            gutter.elements.push(newElt);
            gutter.dom.appendChild(newElt.dom);
        } else gutter.elements[this.i].update(view, height, above, markers);
        this.height = block.bottom;
        this.i++;
    }
    line(view, line, extraMarkers) {
        let localMarkers = [];
        $7beee9608540d2c3$var$advanceCursor(this.cursor, localMarkers, line.from);
        if (extraMarkers.length) localMarkers = localMarkers.concat(extraMarkers);
        let forLine = this.gutter.config.lineMarker(view, line, localMarkers);
        if (forLine) localMarkers.unshift(forLine);
        let gutter = this.gutter;
        if (localMarkers.length == 0 && !gutter.config.renderEmptyElements) return;
        this.addElement(view, line, localMarkers);
    }
    widget(view, block) {
        let marker = this.gutter.config.widgetMarker(view, block.widget, block), markers = marker ? [
            marker
        ] : null;
        for (let cls of view.state.facet($7beee9608540d2c3$export$6dd229d2c0925f7a)){
            let marker = cls(view, block.widget, block);
            if (marker) (markers || (markers = [])).push(marker);
        }
        if (markers) this.addElement(view, block, markers);
    }
    finish() {
        let gutter = this.gutter;
        while(gutter.elements.length > this.i){
            let last = gutter.elements.pop();
            gutter.dom.removeChild(last.dom);
            last.destroy();
        }
    }
}
class $7beee9608540d2c3$var$SingleGutterView {
    constructor(view, config){
        this.view = view;
        this.config = config;
        this.elements = [];
        this.spacer = null;
        this.dom = document.createElement("div");
        this.dom.className = "cm-gutter" + (this.config.class ? " " + this.config.class : "");
        for(let prop in config.domEventHandlers)this.dom.addEventListener(prop, (event)=>{
            let target = event.target, y;
            if (target != this.dom && this.dom.contains(target)) {
                while(target.parentNode != this.dom)target = target.parentNode;
                let rect = target.getBoundingClientRect();
                y = (rect.top + rect.bottom) / 2;
            } else y = event.clientY;
            let line = view.lineBlockAtHeight(y - view.documentTop);
            if (config.domEventHandlers[prop](view, line, event)) event.preventDefault();
        });
        this.markers = $7beee9608540d2c3$var$asArray(config.markers(view));
        if (config.initialSpacer) {
            this.spacer = new $7beee9608540d2c3$var$GutterElement(view, 0, 0, [
                config.initialSpacer(view)
            ]);
            this.dom.appendChild(this.spacer.dom);
            this.spacer.dom.style.cssText += "visibility: hidden; pointer-events: none";
        }
    }
    update(update) {
        let prevMarkers = this.markers;
        this.markers = $7beee9608540d2c3$var$asArray(this.config.markers(update.view));
        if (this.spacer && this.config.updateSpacer) {
            let updated = this.config.updateSpacer(this.spacer.markers[0], update);
            if (updated != this.spacer.markers[0]) this.spacer.update(update.view, 0, 0, [
                updated
            ]);
        }
        let vp = update.view.viewport;
        return !(0, $6295c6875f57e3ee$export$34cb5241245008dd).eq(this.markers, prevMarkers, vp.from, vp.to) || (this.config.lineMarkerChange ? this.config.lineMarkerChange(update) : false);
    }
    destroy() {
        for (let elt of this.elements)elt.destroy();
    }
}
class $7beee9608540d2c3$var$GutterElement {
    constructor(view, height, above, markers){
        this.height = -1;
        this.above = 0;
        this.markers = [];
        this.dom = document.createElement("div");
        this.dom.className = "cm-gutterElement";
        this.update(view, height, above, markers);
    }
    update(view, height, above, markers) {
        if (this.height != height) {
            this.height = height;
            this.dom.style.height = height + "px";
        }
        if (this.above != above) this.dom.style.marginTop = (this.above = above) ? above + "px" : "";
        if (!$7beee9608540d2c3$var$sameMarkers(this.markers, markers)) this.setMarkers(view, markers);
    }
    setMarkers(view, markers) {
        let cls = "cm-gutterElement", domPos = this.dom.firstChild;
        for(let iNew = 0, iOld = 0;;){
            let skipTo = iOld, marker = iNew < markers.length ? markers[iNew++] : null, matched = false;
            if (marker) {
                let c = marker.elementClass;
                if (c) cls += " " + c;
                for(let i = iOld; i < this.markers.length; i++)if (this.markers[i].compare(marker)) {
                    skipTo = i;
                    matched = true;
                    break;
                }
            } else skipTo = this.markers.length;
            while(iOld < skipTo){
                let next = this.markers[iOld++];
                if (next.toDOM) {
                    next.destroy(domPos);
                    let after = domPos.nextSibling;
                    domPos.remove();
                    domPos = after;
                }
            }
            if (!marker) break;
            if (marker.toDOM) {
                if (matched) domPos = domPos.nextSibling;
                else this.dom.insertBefore(marker.toDOM(view), domPos);
            }
            if (matched) iOld++;
        }
        this.dom.className = cls;
        this.markers = markers;
    }
    destroy() {
        this.setMarkers(null, []); // First argument not used unless creating markers
    }
}
function $7beee9608540d2c3$var$sameMarkers(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (!a[i].compare(b[i])) return false;
    return true;
}
/**
Facet used to provide markers to the line number gutter.
*/ const $7beee9608540d2c3$export$dd0c91e0a7121f5f = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
/**
Facet used to create markers in the line number gutter next to widgets.
*/ const $7beee9608540d2c3$export$510194e22d36ff6c = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$lineNumberConfig = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (values) {
        return (0, $6295c6875f57e3ee$export$4e19c0b693794a7e)(values, {
            formatNumber: String,
            domEventHandlers: {}
        }, {
            domEventHandlers (a, b) {
                let result = Object.assign({}, a);
                for(let event in b){
                    let exists = result[event], add = b[event];
                    result[event] = exists ? (view, line, event)=>exists(view, line, event) || add(view, line, event) : add;
                }
                return result;
            }
        });
    }
});
class $7beee9608540d2c3$var$NumberMarker extends $7beee9608540d2c3$export$591ab4c909549043 {
    constructor(number){
        super();
        this.number = number;
    }
    eq(other) {
        return this.number == other.number;
    }
    toDOM() {
        return document.createTextNode(this.number);
    }
}
function $7beee9608540d2c3$var$formatNumber(view, number) {
    return view.state.facet($7beee9608540d2c3$var$lineNumberConfig).formatNumber(number, view.state);
}
const $7beee9608540d2c3$var$lineNumberGutter = /*@__PURE__*/ $7beee9608540d2c3$var$activeGutters.compute([
    $7beee9608540d2c3$var$lineNumberConfig
], (state)=>({
        class: "cm-lineNumbers",
        renderEmptyElements: false,
        markers (view) {
            return view.state.facet($7beee9608540d2c3$export$dd0c91e0a7121f5f);
        },
        lineMarker (view, line, others) {
            if (others.some((m)=>m.toDOM)) return null;
            return new $7beee9608540d2c3$var$NumberMarker($7beee9608540d2c3$var$formatNumber(view, view.state.doc.lineAt(line.from).number));
        },
        widgetMarker: (view, widget, block)=>{
            for (let m of view.state.facet($7beee9608540d2c3$export$510194e22d36ff6c)){
                let result = m(view, widget, block);
                if (result) return result;
            }
            return null;
        },
        lineMarkerChange: (update)=>update.startState.facet($7beee9608540d2c3$var$lineNumberConfig) != update.state.facet($7beee9608540d2c3$var$lineNumberConfig),
        initialSpacer (view) {
            return new $7beee9608540d2c3$var$NumberMarker($7beee9608540d2c3$var$formatNumber(view, $7beee9608540d2c3$var$maxLineNumber(view.state.doc.lines)));
        },
        updateSpacer (spacer, update) {
            let max = $7beee9608540d2c3$var$formatNumber(update.view, $7beee9608540d2c3$var$maxLineNumber(update.view.state.doc.lines));
            return max == spacer.number ? spacer : new $7beee9608540d2c3$var$NumberMarker(max);
        },
        domEventHandlers: state.facet($7beee9608540d2c3$var$lineNumberConfig).domEventHandlers,
        side: "before"
    }));
/**
Create a line number gutter extension.
*/ function $7beee9608540d2c3$export$1a8cf111682eaa7d(config = {}) {
    return [
        $7beee9608540d2c3$var$lineNumberConfig.of(config),
        $7beee9608540d2c3$export$ec15ef01b8fbae61(),
        $7beee9608540d2c3$var$lineNumberGutter
    ];
}
function $7beee9608540d2c3$var$maxLineNumber(lines) {
    let last = 9;
    while(last < lines)last = last * 10 + 9;
    return last;
}
const $7beee9608540d2c3$var$activeLineGutterMarker = /*@__PURE__*/ new class extends $7beee9608540d2c3$export$591ab4c909549043 {
    constructor(){
        super(...arguments);
        this.elementClass = "cm-activeLineGutter";
    }
};
const $7beee9608540d2c3$var$activeLineGutterHighlighter = /*@__PURE__*/ $7beee9608540d2c3$export$113bd64f27ac1172.compute([
    "selection"
], (state)=>{
    let marks = [], last = -1;
    for (let range of state.selection.ranges){
        let linePos = state.doc.lineAt(range.head).from;
        if (linePos > last) {
            last = linePos;
            marks.push($7beee9608540d2c3$var$activeLineGutterMarker.range(linePos));
        }
    }
    return (0, $6295c6875f57e3ee$export$34cb5241245008dd).of(marks);
});
/**
Returns an extension that adds a `cm-activeLineGutter` class to
all gutter elements on the [active
line](https://codemirror.net/6/docs/ref/#view.highlightActiveLine).
*/ function $7beee9608540d2c3$export$93b52f08bb2c759c() {
    return $7beee9608540d2c3$var$activeLineGutterHighlighter;
}
function $7beee9608540d2c3$var$matcher(decorator) {
    return $7beee9608540d2c3$export$44d5eccfd62adda7.define((view)=>({
            decorations: decorator.createDeco(view),
            update (u) {
                this.decorations = decorator.updateDeco(u, this.decorations);
            }
        }), {
        decorations: (v)=>v.decorations
    });
}
const $7beee9608540d2c3$var$tabDeco = /*@__PURE__*/ $7beee9608540d2c3$export$10e30b733df217ea.mark({
    class: "cm-highlightTab"
});
const $7beee9608540d2c3$var$spaceDeco = /*@__PURE__*/ $7beee9608540d2c3$export$10e30b733df217ea.mark({
    class: "cm-highlightSpace"
});
const $7beee9608540d2c3$var$whitespaceHighlighter = /*@__PURE__*/ $7beee9608540d2c3$var$matcher(/*@__PURE__*/ new $7beee9608540d2c3$export$9b928b0ca20b25cb({
    regexp: /\t| /g,
    decoration: (match)=>match[0] == "\t" ? $7beee9608540d2c3$var$tabDeco : $7beee9608540d2c3$var$spaceDeco,
    boundary: /\S/
}));
/**
Returns an extension that highlights whitespace, adding a
`cm-highlightSpace` class to stretches of spaces, and a
`cm-highlightTab` class to individual tab characters. By default,
the former are shown as faint dots, and the latter as arrows.
*/ function $7beee9608540d2c3$export$beeff585f23bdb79() {
    return $7beee9608540d2c3$var$whitespaceHighlighter;
}
const $7beee9608540d2c3$var$trailingHighlighter = /*@__PURE__*/ $7beee9608540d2c3$var$matcher(/*@__PURE__*/ new $7beee9608540d2c3$export$9b928b0ca20b25cb({
    regexp: /\s+$/g,
    decoration: /*@__PURE__*/ $7beee9608540d2c3$export$10e30b733df217ea.mark({
        class: "cm-trailingSpace"
    })
}));
/**
Returns an extension that adds a `cm-trailingSpace` class to all
trailing whitespace.
*/ function $7beee9608540d2c3$export$6e66b0e142f44c26() {
    return $7beee9608540d2c3$var$trailingHighlighter;
}
/**
@internal
*/ const $7beee9608540d2c3$export$91afc2cf83e15b44 = {
    HeightMap: $7beee9608540d2c3$var$HeightMap,
    HeightOracle: $7beee9608540d2c3$var$HeightOracle,
    MeasuredHeights: $7beee9608540d2c3$var$MeasuredHeights,
    QueryType: $7beee9608540d2c3$var$QueryType,
    ChangedRange: $7beee9608540d2c3$var$ChangedRange,
    computeOrder: $7beee9608540d2c3$var$computeOrder,
    moveVisually: $7beee9608540d2c3$var$moveVisually,
    clearHeightChangeFlag: $7beee9608540d2c3$var$clearHeightChangeFlag,
    getHeightChangeFlag: ()=>$7beee9608540d2c3$var$heightChangeFlag
};




/**
The default maximum length of a `TreeBuffer` node.
*/ const $ed739beecf769914$export$de305a849879ffa = 1024;
let $ed739beecf769914$var$nextPropID = 0;
class $ed739beecf769914$var$Range {
    constructor(from, to){
        this.from = from;
        this.to = to;
    }
}
/**
Each [node type](#common.NodeType) or [individual tree](#common.Tree)
can have metadata associated with it in props. Instances of this
class represent prop names.
*/ class $ed739beecf769914$export$b8034b9bc18acd90 {
    /**
    Create a new node prop type.
    */ constructor(config = {}){
        this.id = $ed739beecf769914$var$nextPropID++;
        this.perNode = !!config.perNode;
        this.deserialize = config.deserialize || (()=>{
            throw new Error("This node type doesn't define a deserialize function");
        });
        this.combine = config.combine || null;
    }
    /**
    This is meant to be used with
    [`NodeSet.extend`](#common.NodeSet.extend) or
    [`LRParser.configure`](#lr.ParserConfig.props) to compute
    prop values for each node type in the set. Takes a [match
    object](#common.NodeType^match) or function that returns undefined
    if the node type doesn't get this prop, and the prop's value if
    it does.
    */ add(match) {
        if (this.perNode) throw new RangeError("Can't add per-node props to node types");
        if (typeof match != "function") match = $ed739beecf769914$export$f06e977173f1857c.match(match);
        return (type)=>{
            let result = match(type);
            return result === undefined ? null : [
                this,
                result
            ];
        };
    }
}
/**
Prop that is used to describe matching delimiters. For opening
delimiters, this holds an array of node names (written as a
space-separated string when declaring this prop in a grammar)
for the node types of closing delimiters that match it.
*/ $ed739beecf769914$export$b8034b9bc18acd90.closedBy = new $ed739beecf769914$export$b8034b9bc18acd90({
    deserialize: (str)=>str.split(" ")
});
/**
The inverse of [`closedBy`](#common.NodeProp^closedBy). This is
attached to closing delimiters, holding an array of node names
of types of matching opening delimiters.
*/ $ed739beecf769914$export$b8034b9bc18acd90.openedBy = new $ed739beecf769914$export$b8034b9bc18acd90({
    deserialize: (str)=>str.split(" ")
});
/**
Used to assign node types to groups (for example, all node
types that represent an expression could be tagged with an
`"Expression"` group).
*/ $ed739beecf769914$export$b8034b9bc18acd90.group = new $ed739beecf769914$export$b8034b9bc18acd90({
    deserialize: (str)=>str.split(" ")
});
/**
Attached to nodes to indicate these should be
[displayed](https://codemirror.net/docs/ref/#language.syntaxTree)
in a bidirectional text isolate, so that direction-neutral
characters on their sides don't incorrectly get associated with
surrounding text. You'll generally want to set this for nodes
that contain arbitrary text, like strings and comments, and for
nodes that appear _inside_ arbitrary text, like HTML tags. When
not given a value, in a grammar declaration, defaults to
`"auto"`.
*/ $ed739beecf769914$export$b8034b9bc18acd90.isolate = new $ed739beecf769914$export$b8034b9bc18acd90({
    deserialize: (value)=>{
        if (value && value != "rtl" && value != "ltr" && value != "auto") throw new RangeError("Invalid value for isolate: " + value);
        return value || "auto";
    }
});
/**
The hash of the [context](#lr.ContextTracker.constructor)
that the node was parsed in, if any. Used to limit reuse of
contextual nodes.
*/ $ed739beecf769914$export$b8034b9bc18acd90.contextHash = new $ed739beecf769914$export$b8034b9bc18acd90({
    perNode: true
});
/**
The distance beyond the end of the node that the tokenizer
looked ahead for any of the tokens inside the node. (The LR
parser only stores this when it is larger than 25, for
efficiency reasons.)
*/ $ed739beecf769914$export$b8034b9bc18acd90.lookAhead = new $ed739beecf769914$export$b8034b9bc18acd90({
    perNode: true
});
/**
This per-node prop is used to replace a given node, or part of a
node, with another tree. This is useful to include trees from
different languages in mixed-language parsers.
*/ $ed739beecf769914$export$b8034b9bc18acd90.mounted = new $ed739beecf769914$export$b8034b9bc18acd90({
    perNode: true
});
/**
A mounted tree, which can be [stored](#common.NodeProp^mounted) on
a tree node to indicate that parts of its content are
represented by another tree.
*/ class $ed739beecf769914$export$358cdd8bd77577cc {
    constructor(/**
    The inner tree.
    */ tree, /**
    If this is null, this tree replaces the entire node (it will
    be included in the regular iteration instead of its host
    node). If not, only the given ranges are considered to be
    covered by this tree. This is used for trees that are mixed in
    a way that isn't strictly hierarchical. Such mounted trees are
    only entered by [`resolveInner`](#common.Tree.resolveInner)
    and [`enter`](#common.SyntaxNode.enter).
    */ overlay, /**
    The parser used to create this subtree.
    */ parser, /**
    [Indicates](#common.IterMode.EnterBracketed) that the nested
    content is delineated with some kind
    of bracket token.
    */ bracketed = false){
        this.tree = tree;
        this.overlay = overlay;
        this.parser = parser;
        this.bracketed = bracketed;
    }
    /**
    @internal
    */ static get(tree) {
        return tree && tree.props && tree.props[$ed739beecf769914$export$b8034b9bc18acd90.mounted.id];
    }
}
const $ed739beecf769914$var$noProps = Object.create(null);
/**
Each node in a syntax tree has a node type associated with it.
*/ class $ed739beecf769914$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name of the node type. Not necessarily unique, but if the
    grammar was written properly, different node types with the
    same name within a node set should play the same semantic
    role.
    */ name, /**
    @internal
    */ props, /**
    The id of this node in its set. Corresponds to the term ids
    used in the parser.
    */ id, /**
    @internal
    */ flags = 0){
        this.name = name;
        this.props = props;
        this.id = id;
        this.flags = flags;
    }
    /**
    Define a node type.
    */ static define(spec) {
        let props = spec.props && spec.props.length ? Object.create(null) : $ed739beecf769914$var$noProps;
        let flags = (spec.top ? 1 /* NodeFlag.Top */  : 0) | (spec.skipped ? 2 /* NodeFlag.Skipped */  : 0) | (spec.error ? 4 /* NodeFlag.Error */  : 0) | (spec.name == null ? 8 /* NodeFlag.Anonymous */  : 0);
        let type = new $ed739beecf769914$export$f06e977173f1857c(spec.name || "", props, spec.id, flags);
        if (spec.props) for (let src of spec.props){
            if (!Array.isArray(src)) src = src(type);
            if (src) {
                if (src[0].perNode) throw new RangeError("Can't store a per-node prop on a node type");
                props[src[0].id] = src[1];
            }
        }
        return type;
    }
    /**
    Retrieves a node prop for this type. Will return `undefined` if
    the prop isn't present on this node.
    */ prop(prop) {
        return this.props[prop.id];
    }
    /**
    True when this is the top node of a grammar.
    */ get isTop() {
        return (this.flags & 1 /* NodeFlag.Top */ ) > 0;
    }
    /**
    True when this node is produced by a skip rule.
    */ get isSkipped() {
        return (this.flags & 2 /* NodeFlag.Skipped */ ) > 0;
    }
    /**
    Indicates whether this is an error node.
    */ get isError() {
        return (this.flags & 4 /* NodeFlag.Error */ ) > 0;
    }
    /**
    When true, this node type doesn't correspond to a user-declared
    named node, for example because it is used to cache repetition.
    */ get isAnonymous() {
        return (this.flags & 8 /* NodeFlag.Anonymous */ ) > 0;
    }
    /**
    Returns true when this node's name or one of its
    [groups](#common.NodeProp^group) matches the given string.
    */ is(name) {
        if (typeof name == 'string') {
            if (this.name == name) return true;
            let group = this.prop($ed739beecf769914$export$b8034b9bc18acd90.group);
            return group ? group.indexOf(name) > -1 : false;
        }
        return this.id == name;
    }
    /**
    Create a function from node types to arbitrary values by
    specifying an object whose property names are node or
    [group](#common.NodeProp^group) names. Often useful with
    [`NodeProp.add`](#common.NodeProp.add). You can put multiple
    names, separated by spaces, in a single property name to map
    multiple node names to a single value.
    */ static match(map) {
        let direct = Object.create(null);
        for(let prop in map)for (let name of prop.split(" "))direct[name] = map[prop];
        return (node)=>{
            for(let groups = node.prop($ed739beecf769914$export$b8034b9bc18acd90.group), i = -1; i < (groups ? groups.length : 0); i++){
                let found = direct[i < 0 ? node.name : groups[i]];
                if (found) return found;
            }
        };
    }
}
/**
An empty dummy node type to use when no actual type is available.
*/ $ed739beecf769914$export$f06e977173f1857c.none = new $ed739beecf769914$export$f06e977173f1857c("", Object.create(null), 0, 8 /* NodeFlag.Anonymous */ );
/**
A node set holds a collection of node types. It is used to
compactly represent trees by storing their type ids, rather than a
full pointer to the type object, in a numeric array. Each parser
[has](#lr.LRParser.nodeSet) a node set, and [tree
buffers](#common.TreeBuffer) can only store collections of nodes
from the same set. A set can have a maximum of 2**16 (65536) node
types in it, so that the ids fit into 16-bit typed array slots.
*/ class $ed739beecf769914$export$7fad5fb00d8de02c {
    /**
    Create a set with the given types. The `id` property of each
    type should correspond to its position within the array.
    */ constructor(/**
    The node types in this set, by id.
    */ types){
        this.types = types;
        for(let i = 0; i < types.length; i++)if (types[i].id != i) throw new RangeError("Node type ids should correspond to array positions when creating a node set");
    }
    /**
    Create a copy of this set with some node properties added. The
    arguments to this method can be created with
    [`NodeProp.add`](#common.NodeProp.add).
    */ extend(...props) {
        let newTypes = [];
        for (let type of this.types){
            let newProps = null;
            for (let source of props){
                let add = source(type);
                if (add) {
                    if (!newProps) newProps = Object.assign({}, type.props);
                    let value = add[1], prop = add[0];
                    if (prop.combine && prop.id in newProps) value = prop.combine(newProps[prop.id], value);
                    newProps[prop.id] = value;
                }
            }
            newTypes.push(newProps ? new $ed739beecf769914$export$f06e977173f1857c(type.name, newProps, type.id, type.flags) : type);
        }
        return new $ed739beecf769914$export$7fad5fb00d8de02c(newTypes);
    }
}
const $ed739beecf769914$var$CachedNode = new WeakMap(), $ed739beecf769914$var$CachedInnerNode = new WeakMap();
/**
Options that control iteration. Can be combined with the `|`
operator to enable multiple ones.
*/ var $ed739beecf769914$export$b0e28367f55837aa;
(function(IterMode) {
    /**
    When enabled, iteration will only visit [`Tree`](#common.Tree)
    objects, not nodes packed into
    [`TreeBuffer`](#common.TreeBuffer)s.
    */ IterMode[IterMode["ExcludeBuffers"] = 1] = "ExcludeBuffers";
    /**
    Enable this to make iteration include anonymous nodes (such as
    the nodes that wrap repeated grammar constructs into a balanced
    tree).
    */ IterMode[IterMode["IncludeAnonymous"] = 2] = "IncludeAnonymous";
    /**
    By default, regular [mounted](#common.NodeProp^mounted) nodes
    replace their base node in iteration. Enable this to ignore them
    instead.
    */ IterMode[IterMode["IgnoreMounts"] = 4] = "IgnoreMounts";
    /**
    This option only applies in
    [`enter`](#common.SyntaxNode.enter)-style methods. It tells the
    library to not enter mounted overlays if one covers the given
    position.
    */ IterMode[IterMode["IgnoreOverlays"] = 8] = "IgnoreOverlays";
    /**
    When set, positions on the boundary of a mounted overlay tree
    that has its [`bracketed`](#common.NestedParse.bracketed) flag
    set will enter that tree regardless of side. Only supported in
    [`enter`](#common.SyntaxNode.enter), not in cursors.
    */ IterMode[IterMode["EnterBracketed"] = 16] = "EnterBracketed";
})($ed739beecf769914$export$b0e28367f55837aa || ($ed739beecf769914$export$b0e28367f55837aa = {}));
/**
A piece of syntax tree. There are two ways to approach these
trees: the way they are actually stored in memory, and the
convenient way.

Syntax trees are stored as a tree of `Tree` and `TreeBuffer`
objects. By packing detail information into `TreeBuffer` leaf
nodes, the representation is made a lot more memory-efficient.

However, when you want to actually work with tree nodes, this
representation is very awkward, so most client code will want to
use the [`TreeCursor`](#common.TreeCursor) or
[`SyntaxNode`](#common.SyntaxNode) interface instead, which provides
a view on some part of this data structure, and can be used to
move around to adjacent nodes.
*/ class $ed739beecf769914$export$7fbedc92909ed28e {
    /**
    Construct a new tree. See also [`Tree.build`](#common.Tree^build).
    */ constructor(/**
    The type of the top node.
    */ type, /**
    This node's child nodes.
    */ children, /**
    The positions (offsets relative to the start of this tree) of
    the children.
    */ positions, /**
    The total length of this tree
    */ length, /**
    Per-node [node props](#common.NodeProp) to associate with this node.
    */ props){
        this.type = type;
        this.children = children;
        this.positions = positions;
        this.length = length;
        /**
        @internal
        */ this.props = null;
        if (props && props.length) {
            this.props = Object.create(null);
            for (let [prop, value] of props)this.props[typeof prop == "number" ? prop : prop.id] = value;
        }
    }
    /**
    @internal
    */ toString() {
        let mounted = $ed739beecf769914$export$358cdd8bd77577cc.get(this);
        if (mounted && !mounted.overlay) return mounted.tree.toString();
        let children = "";
        for (let ch of this.children){
            let str = ch.toString();
            if (str) {
                if (children) children += ",";
                children += str;
            }
        }
        return !this.type.name ? children : (/\W/.test(this.type.name) && !this.type.isError ? JSON.stringify(this.type.name) : this.type.name) + (children.length ? "(" + children + ")" : "");
    }
    /**
    Get a [tree cursor](#common.TreeCursor) positioned at the top of
    the tree. Mode can be used to [control](#common.IterMode) which
    nodes the cursor visits.
    */ cursor(mode = 0) {
        return new $ed739beecf769914$export$3ae4554f36e54a34(this.topNode, mode);
    }
    /**
    Get a [tree cursor](#common.TreeCursor) pointing into this tree
    at the given position and side (see
    [`moveTo`](#common.TreeCursor.moveTo).
    */ cursorAt(pos, side = 0, mode = 0) {
        let scope = $ed739beecf769914$var$CachedNode.get(this) || this.topNode;
        let cursor = new $ed739beecf769914$export$3ae4554f36e54a34(scope);
        cursor.moveTo(pos, side);
        $ed739beecf769914$var$CachedNode.set(this, cursor._tree);
        return cursor;
    }
    /**
    Get a [syntax node](#common.SyntaxNode) object for the top of the
    tree.
    */ get topNode() {
        return new $ed739beecf769914$var$TreeNode(this, 0, 0, null);
    }
    /**
    Get the [syntax node](#common.SyntaxNode) at the given position.
    If `side` is -1, this will move into nodes that end at the
    position. If 1, it'll move into nodes that start at the
    position. With 0, it'll only enter nodes that cover the position
    from both sides.
    
    Note that this will not enter
    [overlays](#common.MountedTree.overlay), and you often want
    [`resolveInner`](#common.Tree.resolveInner) instead.
    */ resolve(pos, side = 0) {
        let node = $ed739beecf769914$var$resolveNode($ed739beecf769914$var$CachedNode.get(this) || this.topNode, pos, side, false);
        $ed739beecf769914$var$CachedNode.set(this, node);
        return node;
    }
    /**
    Like [`resolve`](#common.Tree.resolve), but will enter
    [overlaid](#common.MountedTree.overlay) nodes, producing a syntax node
    pointing into the innermost overlaid tree at the given position
    (with parent links going through all parent structure, including
    the host trees).
    */ resolveInner(pos, side = 0) {
        let node = $ed739beecf769914$var$resolveNode($ed739beecf769914$var$CachedInnerNode.get(this) || this.topNode, pos, side, true);
        $ed739beecf769914$var$CachedInnerNode.set(this, node);
        return node;
    }
    /**
    In some situations, it can be useful to iterate through all
    nodes around a position, including those in overlays that don't
    directly cover the position. This method gives you an iterator
    that will produce all nodes, from small to big, around the given
    position.
    */ resolveStack(pos, side = 0) {
        return $ed739beecf769914$var$stackIterator(this, pos, side);
    }
    /**
    Iterate over the tree and its children, calling `enter` for any
    node that touches the `from`/`to` region (if given) before
    running over such a node's children, and `leave` (if given) when
    leaving the node. When `enter` returns `false`, that node will
    not have its children iterated over (or `leave` called).
    */ iterate(spec) {
        let { enter: enter, leave: leave, from: from = 0, to: to = this.length } = spec;
        let mode = spec.mode || 0, anon = (mode & $ed739beecf769914$export$b0e28367f55837aa.IncludeAnonymous) > 0;
        for(let c = this.cursor(mode | $ed739beecf769914$export$b0e28367f55837aa.IncludeAnonymous);;){
            let entered = false;
            if (c.from <= to && c.to >= from && (!anon && c.type.isAnonymous || enter(c) !== false)) {
                if (c.firstChild()) continue;
                entered = true;
            }
            for(;;){
                if (entered && leave && (anon || !c.type.isAnonymous)) leave(c);
                if (c.nextSibling()) break;
                if (!c.parent()) return;
                entered = true;
            }
        }
    }
    /**
    Get the value of the given [node prop](#common.NodeProp) for this
    node. Works with both per-node and per-type props.
    */ prop(prop) {
        return !prop.perNode ? this.type.prop(prop) : this.props ? this.props[prop.id] : undefined;
    }
    /**
    Returns the node's [per-node props](#common.NodeProp.perNode) in a
    format that can be passed to the [`Tree`](#common.Tree)
    constructor.
    */ get propValues() {
        let result = [];
        if (this.props) for(let id in this.props)result.push([
            +id,
            this.props[id]
        ]);
        return result;
    }
    /**
    Balance the direct children of this tree, producing a copy of
    which may have children grouped into subtrees with type
    [`NodeType.none`](#common.NodeType^none).
    */ balance(config = {}) {
        return this.children.length <= 8 /* Balance.BranchFactor */  ? this : $ed739beecf769914$var$balanceRange($ed739beecf769914$export$f06e977173f1857c.none, this.children, this.positions, 0, this.children.length, 0, this.length, (children, positions, length)=>new $ed739beecf769914$export$7fbedc92909ed28e(this.type, children, positions, length, this.propValues), config.makeTree || ((children, positions, length)=>new $ed739beecf769914$export$7fbedc92909ed28e($ed739beecf769914$export$f06e977173f1857c.none, children, positions, length)));
    }
    /**
    Build a tree from a postfix-ordered buffer of node information,
    or a cursor over such a buffer.
    */ static build(data) {
        return $ed739beecf769914$var$buildTree(data);
    }
}
/**
The empty tree
*/ $ed739beecf769914$export$7fbedc92909ed28e.empty = new $ed739beecf769914$export$7fbedc92909ed28e($ed739beecf769914$export$f06e977173f1857c.none, [], [], 0);
class $ed739beecf769914$var$FlatBufferCursor {
    constructor(buffer, index){
        this.buffer = buffer;
        this.index = index;
    }
    get id() {
        return this.buffer[this.index - 4];
    }
    get start() {
        return this.buffer[this.index - 3];
    }
    get end() {
        return this.buffer[this.index - 2];
    }
    get size() {
        return this.buffer[this.index - 1];
    }
    get pos() {
        return this.index;
    }
    next() {
        this.index -= 4;
    }
    fork() {
        return new $ed739beecf769914$var$FlatBufferCursor(this.buffer, this.index);
    }
}
/**
Tree buffers contain (type, start, end, endIndex) quads for each
node. In such a buffer, nodes are stored in prefix order (parents
before children, with the endIndex of the parent indicating which
children belong to it).
*/ class $ed739beecf769914$export$33300581b70be371 {
    /**
    Create a tree buffer.
    */ constructor(/**
    The buffer's content.
    */ buffer, /**
    The total length of the group of nodes in the buffer.
    */ length, /**
    The node set used in this buffer.
    */ set){
        this.buffer = buffer;
        this.length = length;
        this.set = set;
    }
    /**
    @internal
    */ get type() {
        return $ed739beecf769914$export$f06e977173f1857c.none;
    }
    /**
    @internal
    */ toString() {
        let result = [];
        for(let index = 0; index < this.buffer.length;){
            result.push(this.childString(index));
            index = this.buffer[index + 3];
        }
        return result.join(",");
    }
    /**
    @internal
    */ childString(index) {
        let id = this.buffer[index], endIndex = this.buffer[index + 3];
        let type = this.set.types[id], result = type.name;
        if (/\W/.test(result) && !type.isError) result = JSON.stringify(result);
        index += 4;
        if (endIndex == index) return result;
        let children = [];
        while(index < endIndex){
            children.push(this.childString(index));
            index = this.buffer[index + 3];
        }
        return result + "(" + children.join(",") + ")";
    }
    /**
    @internal
    */ findChild(startIndex, endIndex, dir, pos, side) {
        let { buffer: buffer } = this, pick = -1;
        for(let i = startIndex; i != endIndex; i = buffer[i + 3])if ($ed739beecf769914$var$checkSide(side, pos, buffer[i + 1], buffer[i + 2])) {
            pick = i;
            if (dir > 0) break;
        }
        return pick;
    }
    /**
    @internal
    */ slice(startI, endI, from) {
        let b = this.buffer;
        let copy = new Uint16Array(endI - startI), len = 0;
        for(let i = startI, j = 0; i < endI;){
            copy[j++] = b[i++];
            copy[j++] = b[i++] - from;
            let to = copy[j++] = b[i++] - from;
            copy[j++] = b[i++] - startI;
            len = Math.max(len, to);
        }
        return new $ed739beecf769914$export$33300581b70be371(copy, len, this.set);
    }
}
function $ed739beecf769914$var$checkSide(side, pos, from, to) {
    switch(side){
        case -2 /* Side.Before */ :
            return from < pos;
        case -1 /* Side.AtOrBefore */ :
            return to >= pos && from < pos;
        case 0 /* Side.Around */ :
            return from < pos && to > pos;
        case 1 /* Side.AtOrAfter */ :
            return from <= pos && to > pos;
        case 2 /* Side.After */ :
            return to > pos;
        case 4 /* Side.DontCare */ :
            return true;
    }
}
function $ed739beecf769914$var$resolveNode(node, pos, side, overlays) {
    var _a;
    // Move up to a node that actually holds the position, if possible
    while(node.from == node.to || (side < 1 ? node.from >= pos : node.from > pos) || (side > -1 ? node.to <= pos : node.to < pos)){
        let parent = !overlays && node instanceof $ed739beecf769914$var$TreeNode && node.index < 0 ? null : node.parent;
        if (!parent) return node;
        node = parent;
    }
    let mode = overlays ? 0 : $ed739beecf769914$export$b0e28367f55837aa.IgnoreOverlays;
    // Must go up out of overlays when those do not overlap with pos
    if (overlays) {
        for(let scan = node, parent = scan.parent; parent; scan = parent, parent = scan.parent)if (scan instanceof $ed739beecf769914$var$TreeNode && scan.index < 0 && ((_a = parent.enter(pos, side, mode)) === null || _a === void 0 ? void 0 : _a.from) != scan.from) node = parent;
    }
    for(;;){
        let inner = node.enter(pos, side, mode);
        if (!inner) return node;
        node = inner;
    }
}
class $ed739beecf769914$var$BaseNode {
    cursor(mode = 0) {
        return new $ed739beecf769914$export$3ae4554f36e54a34(this, mode);
    }
    getChild(type, before = null, after = null) {
        let r = $ed739beecf769914$var$getChildren(this, type, before, after);
        return r.length ? r[0] : null;
    }
    getChildren(type, before = null, after = null) {
        return $ed739beecf769914$var$getChildren(this, type, before, after);
    }
    resolve(pos, side = 0) {
        return $ed739beecf769914$var$resolveNode(this, pos, side, false);
    }
    resolveInner(pos, side = 0) {
        return $ed739beecf769914$var$resolveNode(this, pos, side, true);
    }
    matchContext(context) {
        return $ed739beecf769914$var$matchNodeContext(this.parent, context);
    }
    enterUnfinishedNodesBefore(pos) {
        let scan = this.childBefore(pos), node = this;
        while(scan){
            let last = scan.lastChild;
            if (!last || last.to != scan.to) break;
            if (last.type.isError && last.from == last.to) {
                node = scan;
                scan = last.prevSibling;
            } else scan = last;
        }
        return node;
    }
    get node() {
        return this;
    }
    get next() {
        return this.parent;
    }
}
class $ed739beecf769914$var$TreeNode extends $ed739beecf769914$var$BaseNode {
    constructor(_tree, from, // Index in parent node, set to -1 if the node is not a direct child of _parent.node (overlay)
    index, _parent){
        super();
        this._tree = _tree;
        this.from = from;
        this.index = index;
        this._parent = _parent;
    }
    get type() {
        return this._tree.type;
    }
    get name() {
        return this._tree.type.name;
    }
    get to() {
        return this.from + this._tree.length;
    }
    nextChild(i, dir, pos, side, mode = 0) {
        for(let parent = this;;){
            for(let { children: children, positions: positions } = parent._tree, e = dir > 0 ? children.length : -1; i != e; i += dir){
                let next = children[i], start = positions[i] + parent.from, mounted;
                if (!(mode & $ed739beecf769914$export$b0e28367f55837aa.EnterBracketed && next instanceof $ed739beecf769914$export$7fbedc92909ed28e && (mounted = $ed739beecf769914$export$358cdd8bd77577cc.get(next)) && !mounted.overlay && mounted.bracketed && pos >= start && pos <= start + next.length) && !$ed739beecf769914$var$checkSide(side, pos, start, start + next.length)) continue;
                if (next instanceof $ed739beecf769914$export$33300581b70be371) {
                    if (mode & $ed739beecf769914$export$b0e28367f55837aa.ExcludeBuffers) continue;
                    let index = next.findChild(0, next.buffer.length, dir, pos - start, side);
                    if (index > -1) return new $ed739beecf769914$var$BufferNode(new $ed739beecf769914$var$BufferContext(parent, next, i, start), null, index);
                } else if (mode & $ed739beecf769914$export$b0e28367f55837aa.IncludeAnonymous || !next.type.isAnonymous || $ed739beecf769914$var$hasChild(next)) {
                    let mounted;
                    if (!(mode & $ed739beecf769914$export$b0e28367f55837aa.IgnoreMounts) && (mounted = $ed739beecf769914$export$358cdd8bd77577cc.get(next)) && !mounted.overlay) return new $ed739beecf769914$var$TreeNode(mounted.tree, start, i, parent);
                    let inner = new $ed739beecf769914$var$TreeNode(next, start, i, parent);
                    return mode & $ed739beecf769914$export$b0e28367f55837aa.IncludeAnonymous || !inner.type.isAnonymous ? inner : inner.nextChild(dir < 0 ? next.children.length - 1 : 0, dir, pos, side, mode);
                }
            }
            if (mode & $ed739beecf769914$export$b0e28367f55837aa.IncludeAnonymous || !parent.type.isAnonymous) return null;
            if (parent.index >= 0) i = parent.index + dir;
            else i = dir < 0 ? -1 : parent._parent._tree.children.length;
            parent = parent._parent;
            if (!parent) return null;
        }
    }
    get firstChild() {
        return this.nextChild(0, 1, 0, 4 /* Side.DontCare */ );
    }
    get lastChild() {
        return this.nextChild(this._tree.children.length - 1, -1, 0, 4 /* Side.DontCare */ );
    }
    childAfter(pos) {
        return this.nextChild(0, 1, pos, 2 /* Side.After */ );
    }
    childBefore(pos) {
        return this.nextChild(this._tree.children.length - 1, -1, pos, -2 /* Side.Before */ );
    }
    prop(prop) {
        return this._tree.prop(prop);
    }
    enter(pos, side, mode = 0) {
        let mounted;
        if (!(mode & $ed739beecf769914$export$b0e28367f55837aa.IgnoreOverlays) && (mounted = $ed739beecf769914$export$358cdd8bd77577cc.get(this._tree)) && mounted.overlay) {
            let rPos = pos - this.from, enterBracketed = mode & $ed739beecf769914$export$b0e28367f55837aa.EnterBracketed && mounted.bracketed;
            for (let { from: from, to: to } of mounted.overlay){
                if ((side > 0 || enterBracketed ? from <= rPos : from < rPos) && (side < 0 || enterBracketed ? to >= rPos : to > rPos)) return new $ed739beecf769914$var$TreeNode(mounted.tree, mounted.overlay[0].from + this.from, -1, this);
            }
        }
        return this.nextChild(0, 1, pos, side, mode);
    }
    nextSignificantParent() {
        let val = this;
        while(val.type.isAnonymous && val._parent)val = val._parent;
        return val;
    }
    get parent() {
        return this._parent ? this._parent.nextSignificantParent() : null;
    }
    get nextSibling() {
        return this._parent && this.index >= 0 ? this._parent.nextChild(this.index + 1, 1, 0, 4 /* Side.DontCare */ ) : null;
    }
    get prevSibling() {
        return this._parent && this.index >= 0 ? this._parent.nextChild(this.index - 1, -1, 0, 4 /* Side.DontCare */ ) : null;
    }
    get tree() {
        return this._tree;
    }
    toTree() {
        return this._tree;
    }
    /**
    @internal
    */ toString() {
        return this._tree.toString();
    }
}
function $ed739beecf769914$var$getChildren(node, type, before, after) {
    let cur = node.cursor(), result = [];
    if (!cur.firstChild()) return result;
    if (before != null) for(let found = false; !found;){
        found = cur.type.is(before);
        if (!cur.nextSibling()) return result;
    }
    for(;;){
        if (after != null && cur.type.is(after)) return result;
        if (cur.type.is(type)) result.push(cur.node);
        if (!cur.nextSibling()) return after == null ? result : [];
    }
}
function $ed739beecf769914$var$matchNodeContext(node, context, i = context.length - 1) {
    for(let p = node; i >= 0; p = p.parent){
        if (!p) return false;
        if (!p.type.isAnonymous) {
            if (context[i] && context[i] != p.name) return false;
            i--;
        }
    }
    return true;
}
class $ed739beecf769914$var$BufferContext {
    constructor(parent, buffer, index, start){
        this.parent = parent;
        this.buffer = buffer;
        this.index = index;
        this.start = start;
    }
}
class $ed739beecf769914$var$BufferNode extends $ed739beecf769914$var$BaseNode {
    get name() {
        return this.type.name;
    }
    get from() {
        return this.context.start + this.context.buffer.buffer[this.index + 1];
    }
    get to() {
        return this.context.start + this.context.buffer.buffer[this.index + 2];
    }
    constructor(context, _parent, index){
        super();
        this.context = context;
        this._parent = _parent;
        this.index = index;
        this.type = context.buffer.set.types[context.buffer.buffer[index]];
    }
    child(dir, pos, side) {
        let { buffer: buffer } = this.context;
        let index = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], dir, pos - this.context.start, side);
        return index < 0 ? null : new $ed739beecf769914$var$BufferNode(this.context, this, index);
    }
    get firstChild() {
        return this.child(1, 0, 4 /* Side.DontCare */ );
    }
    get lastChild() {
        return this.child(-1, 0, 4 /* Side.DontCare */ );
    }
    childAfter(pos) {
        return this.child(1, pos, 2 /* Side.After */ );
    }
    childBefore(pos) {
        return this.child(-1, pos, -2 /* Side.Before */ );
    }
    prop(prop) {
        return this.type.prop(prop);
    }
    enter(pos, side, mode = 0) {
        if (mode & $ed739beecf769914$export$b0e28367f55837aa.ExcludeBuffers) return null;
        let { buffer: buffer } = this.context;
        let index = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], side > 0 ? 1 : -1, pos - this.context.start, side);
        return index < 0 ? null : new $ed739beecf769914$var$BufferNode(this.context, this, index);
    }
    get parent() {
        return this._parent || this.context.parent.nextSignificantParent();
    }
    externalSibling(dir) {
        return this._parent ? null : this.context.parent.nextChild(this.context.index + dir, dir, 0, 4 /* Side.DontCare */ );
    }
    get nextSibling() {
        let { buffer: buffer } = this.context;
        let after = buffer.buffer[this.index + 3];
        if (after < (this._parent ? buffer.buffer[this._parent.index + 3] : buffer.buffer.length)) return new $ed739beecf769914$var$BufferNode(this.context, this._parent, after);
        return this.externalSibling(1);
    }
    get prevSibling() {
        let { buffer: buffer } = this.context;
        let parentStart = this._parent ? this._parent.index + 4 : 0;
        if (this.index == parentStart) return this.externalSibling(-1);
        return new $ed739beecf769914$var$BufferNode(this.context, this._parent, buffer.findChild(parentStart, this.index, -1, 0, 4 /* Side.DontCare */ ));
    }
    get tree() {
        return null;
    }
    toTree() {
        let children = [], positions = [];
        let { buffer: buffer } = this.context;
        let startI = this.index + 4, endI = buffer.buffer[this.index + 3];
        if (endI > startI) {
            let from = buffer.buffer[this.index + 1];
            children.push(buffer.slice(startI, endI, from));
            positions.push(0);
        }
        return new $ed739beecf769914$export$7fbedc92909ed28e(this.type, children, positions, this.to - this.from);
    }
    /**
    @internal
    */ toString() {
        return this.context.buffer.childString(this.index);
    }
}
function $ed739beecf769914$var$iterStack(heads) {
    if (!heads.length) return null;
    let pick = 0, picked = heads[0];
    for(let i = 1; i < heads.length; i++){
        let node = heads[i];
        if (node.from > picked.from || node.to < picked.to) {
            picked = node;
            pick = i;
        }
    }
    let next = picked instanceof $ed739beecf769914$var$TreeNode && picked.index < 0 ? null : picked.parent;
    let newHeads = heads.slice();
    if (next) newHeads[pick] = next;
    else newHeads.splice(pick, 1);
    return new $ed739beecf769914$var$StackIterator(newHeads, picked);
}
class $ed739beecf769914$var$StackIterator {
    constructor(heads, node){
        this.heads = heads;
        this.node = node;
    }
    get next() {
        return $ed739beecf769914$var$iterStack(this.heads);
    }
}
function $ed739beecf769914$var$stackIterator(tree, pos, side) {
    let inner = tree.resolveInner(pos, side), layers = null;
    for(let scan = inner instanceof $ed739beecf769914$var$TreeNode ? inner : inner.context.parent; scan; scan = scan.parent)if (scan.index < 0) {
        let parent = scan.parent;
        (layers || (layers = [
            inner
        ])).push(parent.resolve(pos, side));
        scan = parent;
    } else {
        let mount = $ed739beecf769914$export$358cdd8bd77577cc.get(scan.tree);
        // Relevant overlay branching off
        if (mount && mount.overlay && mount.overlay[0].from <= pos && mount.overlay[mount.overlay.length - 1].to >= pos) {
            let root = new $ed739beecf769914$var$TreeNode(mount.tree, mount.overlay[0].from + scan.from, -1, scan);
            (layers || (layers = [
                inner
            ])).push($ed739beecf769914$var$resolveNode(root, pos, side, false));
        }
    }
    return layers ? $ed739beecf769914$var$iterStack(layers) : inner;
}
/**
A tree cursor object focuses on a given node in a syntax tree, and
allows you to move to adjacent nodes.
*/ class $ed739beecf769914$export$3ae4554f36e54a34 {
    /**
    Shorthand for `.type.name`.
    */ get name() {
        return this.type.name;
    }
    /**
    @internal
    */ constructor(node, mode = 0){
        /**
        @internal
        */ this.buffer = null;
        this.stack = [];
        /**
        @internal
        */ this.index = 0;
        this.bufferNode = null;
        this.mode = mode & ~$ed739beecf769914$export$b0e28367f55837aa.EnterBracketed;
        if (node instanceof $ed739beecf769914$var$TreeNode) this.yieldNode(node);
        else {
            this._tree = node.context.parent;
            this.buffer = node.context;
            for(let n = node._parent; n; n = n._parent)this.stack.unshift(n.index);
            this.bufferNode = node;
            this.yieldBuf(node.index);
        }
    }
    yieldNode(node) {
        if (!node) return false;
        this._tree = node;
        this.type = node.type;
        this.from = node.from;
        this.to = node.to;
        return true;
    }
    yieldBuf(index, type) {
        this.index = index;
        let { start: start, buffer: buffer } = this.buffer;
        this.type = type || buffer.set.types[buffer.buffer[index]];
        this.from = start + buffer.buffer[index + 1];
        this.to = start + buffer.buffer[index + 2];
        return true;
    }
    /**
    @internal
    */ yield(node) {
        if (!node) return false;
        if (node instanceof $ed739beecf769914$var$TreeNode) {
            this.buffer = null;
            return this.yieldNode(node);
        }
        this.buffer = node.context;
        return this.yieldBuf(node.index, node.type);
    }
    /**
    @internal
    */ toString() {
        return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
    }
    /**
    @internal
    */ enterChild(dir, pos, side) {
        if (!this.buffer) return this.yield(this._tree.nextChild(dir < 0 ? this._tree._tree.children.length - 1 : 0, dir, pos, side, this.mode));
        let { buffer: buffer } = this.buffer;
        let index = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], dir, pos - this.buffer.start, side);
        if (index < 0) return false;
        this.stack.push(this.index);
        return this.yieldBuf(index);
    }
    /**
    Move the cursor to this node's first child. When this returns
    false, the node has no child, and the cursor has not been moved.
    */ firstChild() {
        return this.enterChild(1, 0, 4 /* Side.DontCare */ );
    }
    /**
    Move the cursor to this node's last child.
    */ lastChild() {
        return this.enterChild(-1, 0, 4 /* Side.DontCare */ );
    }
    /**
    Move the cursor to the first child that ends after `pos`.
    */ childAfter(pos) {
        return this.enterChild(1, pos, 2 /* Side.After */ );
    }
    /**
    Move to the last child that starts before `pos`.
    */ childBefore(pos) {
        return this.enterChild(-1, pos, -2 /* Side.Before */ );
    }
    /**
    Move the cursor to the child around `pos`. If side is -1 the
    child may end at that position, when 1 it may start there. This
    will also enter [overlaid](#common.MountedTree.overlay)
    [mounted](#common.NodeProp^mounted) trees unless `overlays` is
    set to false.
    */ enter(pos, side, mode = this.mode) {
        if (!this.buffer) return this.yield(this._tree.enter(pos, side, mode));
        return mode & $ed739beecf769914$export$b0e28367f55837aa.ExcludeBuffers ? false : this.enterChild(1, pos, side);
    }
    /**
    Move to the node's parent node, if this isn't the top node.
    */ parent() {
        if (!this.buffer) return this.yieldNode(this.mode & $ed739beecf769914$export$b0e28367f55837aa.IncludeAnonymous ? this._tree._parent : this._tree.parent);
        if (this.stack.length) return this.yieldBuf(this.stack.pop());
        let parent = this.mode & $ed739beecf769914$export$b0e28367f55837aa.IncludeAnonymous ? this.buffer.parent : this.buffer.parent.nextSignificantParent();
        this.buffer = null;
        return this.yieldNode(parent);
    }
    /**
    @internal
    */ sibling(dir) {
        if (!this.buffer) return !this._tree._parent ? false : this.yield(this._tree.index < 0 ? null : this._tree._parent.nextChild(this._tree.index + dir, dir, 0, 4 /* Side.DontCare */ , this.mode));
        let { buffer: buffer } = this.buffer, d = this.stack.length - 1;
        if (dir < 0) {
            let parentStart = d < 0 ? 0 : this.stack[d] + 4;
            if (this.index != parentStart) return this.yieldBuf(buffer.findChild(parentStart, this.index, -1, 0, 4 /* Side.DontCare */ ));
        } else {
            let after = buffer.buffer[this.index + 3];
            if (after < (d < 0 ? buffer.buffer.length : buffer.buffer[this.stack[d] + 3])) return this.yieldBuf(after);
        }
        return d < 0 ? this.yield(this.buffer.parent.nextChild(this.buffer.index + dir, dir, 0, 4 /* Side.DontCare */ , this.mode)) : false;
    }
    /**
    Move to this node's next sibling, if any.
    */ nextSibling() {
        return this.sibling(1);
    }
    /**
    Move to this node's previous sibling, if any.
    */ prevSibling() {
        return this.sibling(-1);
    }
    atLastNode(dir) {
        let index, parent, { buffer: buffer } = this;
        if (buffer) {
            if (dir > 0) {
                if (this.index < buffer.buffer.buffer.length) return false;
            } else {
                for(let i = 0; i < this.index; i++)if (buffer.buffer.buffer[i + 3] < this.index) return false;
            }
            ({ index: index, parent: parent } = buffer);
        } else ({ index: index, _parent: parent } = this._tree);
        for(; parent; { index: index, _parent: parent } = parent){
            if (index > -1) for(let i = index + dir, e = dir < 0 ? -1 : parent._tree.children.length; i != e; i += dir){
                let child = parent._tree.children[i];
                if (this.mode & $ed739beecf769914$export$b0e28367f55837aa.IncludeAnonymous || child instanceof $ed739beecf769914$export$33300581b70be371 || !child.type.isAnonymous || $ed739beecf769914$var$hasChild(child)) return false;
            }
        }
        return true;
    }
    move(dir, enter) {
        if (enter && this.enterChild(dir, 0, 4 /* Side.DontCare */ )) return true;
        for(;;){
            if (this.sibling(dir)) return true;
            if (this.atLastNode(dir) || !this.parent()) return false;
        }
    }
    /**
    Move to the next node in a
    [pre-order](https://en.wikipedia.org/wiki/Tree_traversal#Pre-order,_NLR)
    traversal, going from a node to its first child or, if the
    current node is empty or `enter` is false, its next sibling or
    the next sibling of the first parent node that has one.
    */ next(enter = true) {
        return this.move(1, enter);
    }
    /**
    Move to the next node in a last-to-first pre-order traversal. A
    node is followed by its last child or, if it has none, its
    previous sibling or the previous sibling of the first parent
    node that has one.
    */ prev(enter = true) {
        return this.move(-1, enter);
    }
    /**
    Move the cursor to the innermost node that covers `pos`. If
    `side` is -1, it will enter nodes that end at `pos`. If it is 1,
    it will enter nodes that start at `pos`.
    */ moveTo(pos, side = 0) {
        // Move up to a node that actually holds the position, if possible
        while(this.from == this.to || (side < 1 ? this.from >= pos : this.from > pos) || (side > -1 ? this.to <= pos : this.to < pos))if (!this.parent()) break;
        // Then scan down into child nodes as far as possible
        while(this.enterChild(1, pos, side));
        return this;
    }
    /**
    Get a [syntax node](#common.SyntaxNode) at the cursor's current
    position.
    */ get node() {
        if (!this.buffer) return this._tree;
        let cache = this.bufferNode, result = null, depth = 0;
        if (cache && cache.context == this.buffer) scan: for(let index = this.index, d = this.stack.length; d >= 0;){
            for(let c = cache; c; c = c._parent)if (c.index == index) {
                if (index == this.index) return c;
                result = c;
                depth = d + 1;
                break scan;
            }
            index = this.stack[--d];
        }
        for(let i = depth; i < this.stack.length; i++)result = new $ed739beecf769914$var$BufferNode(this.buffer, result, this.stack[i]);
        return this.bufferNode = new $ed739beecf769914$var$BufferNode(this.buffer, result, this.index);
    }
    /**
    Get the [tree](#common.Tree) that represents the current node, if
    any. Will return null when the node is in a [tree
    buffer](#common.TreeBuffer).
    */ get tree() {
        return this.buffer ? null : this._tree._tree;
    }
    /**
    Iterate over the current node and all its descendants, calling
    `enter` when entering a node and `leave`, if given, when leaving
    one. When `enter` returns `false`, any children of that node are
    skipped, and `leave` isn't called for it.
    */ iterate(enter, leave) {
        for(let depth = 0;;){
            let mustLeave = false;
            if (this.type.isAnonymous || enter(this) !== false) {
                if (this.firstChild()) {
                    depth++;
                    continue;
                }
                if (!this.type.isAnonymous) mustLeave = true;
            }
            for(;;){
                if (mustLeave && leave) leave(this);
                mustLeave = this.type.isAnonymous;
                if (!depth) return;
                if (this.nextSibling()) break;
                this.parent();
                depth--;
                mustLeave = true;
            }
        }
    }
    /**
    Test whether the current node matches a given context—a sequence
    of direct parent node names. Empty strings in the context array
    are treated as wildcards.
    */ matchContext(context) {
        if (!this.buffer) return $ed739beecf769914$var$matchNodeContext(this.node.parent, context);
        let { buffer: buffer } = this.buffer, { types: types } = buffer.set;
        for(let i = context.length - 1, d = this.stack.length - 1; i >= 0; d--){
            if (d < 0) return $ed739beecf769914$var$matchNodeContext(this._tree, context, i);
            let type = types[buffer.buffer[this.stack[d]]];
            if (!type.isAnonymous) {
                if (context[i] && context[i] != type.name) return false;
                i--;
            }
        }
        return true;
    }
}
function $ed739beecf769914$var$hasChild(tree) {
    return tree.children.some((ch)=>ch instanceof $ed739beecf769914$export$33300581b70be371 || !ch.type.isAnonymous || $ed739beecf769914$var$hasChild(ch));
}
function $ed739beecf769914$var$buildTree(data) {
    var _a;
    let { buffer: buffer, nodeSet: nodeSet, maxBufferLength: maxBufferLength = $ed739beecf769914$export$de305a849879ffa, reused: reused = [], minRepeatType: minRepeatType = nodeSet.types.length } = data;
    let cursor = Array.isArray(buffer) ? new $ed739beecf769914$var$FlatBufferCursor(buffer, buffer.length) : buffer;
    let types = nodeSet.types;
    let contextHash = 0, lookAhead = 0;
    function takeNode(parentStart, minPos, children, positions, inRepeat, depth) {
        let { id: id, start: start, end: end, size: size } = cursor;
        let lookAheadAtStart = lookAhead, contextAtStart = contextHash;
        if (size < 0) {
            cursor.next();
            if (size == -1 /* SpecialRecord.Reuse */ ) {
                let node = reused[id];
                children.push(node);
                positions.push(start - parentStart);
                return;
            } else if (size == -3 /* SpecialRecord.ContextChange */ ) {
                contextHash = id;
                return;
            } else if (size == -4 /* SpecialRecord.LookAhead */ ) {
                lookAhead = id;
                return;
            } else throw new RangeError(`Unrecognized record size: ${size}`);
        }
        let type = types[id], node, buffer;
        let startPos = start - parentStart;
        if (end - start <= maxBufferLength && (buffer = findBufferSize(cursor.pos - minPos, inRepeat))) {
            // Small enough for a buffer, and no reused nodes inside
            let data = new Uint16Array(buffer.size - buffer.skip);
            let endPos = cursor.pos - buffer.size, index = data.length;
            while(cursor.pos > endPos)index = copyToBuffer(buffer.start, data, index);
            node = new $ed739beecf769914$export$33300581b70be371(data, end - buffer.start, nodeSet);
            startPos = buffer.start - parentStart;
        } else {
            let endPos = cursor.pos - size;
            cursor.next();
            let localChildren = [], localPositions = [];
            let localInRepeat = id >= minRepeatType ? id : -1;
            let lastGroup = 0, lastEnd = end;
            while(cursor.pos > endPos){
                if (localInRepeat >= 0 && cursor.id == localInRepeat && cursor.size >= 0) {
                    if (cursor.end <= lastEnd - maxBufferLength) {
                        makeRepeatLeaf(localChildren, localPositions, start, lastGroup, cursor.end, lastEnd, localInRepeat, lookAheadAtStart, contextAtStart);
                        lastGroup = localChildren.length;
                        lastEnd = cursor.end;
                    }
                    cursor.next();
                } else if (depth > 2500 /* CutOff.Depth */ ) takeFlatNode(start, endPos, localChildren, localPositions);
                else takeNode(start, endPos, localChildren, localPositions, localInRepeat, depth + 1);
            }
            if (localInRepeat >= 0 && lastGroup > 0 && lastGroup < localChildren.length) makeRepeatLeaf(localChildren, localPositions, start, lastGroup, start, lastEnd, localInRepeat, lookAheadAtStart, contextAtStart);
            localChildren.reverse();
            localPositions.reverse();
            if (localInRepeat > -1 && lastGroup > 0) {
                let make = makeBalanced(type, contextAtStart);
                node = $ed739beecf769914$var$balanceRange(type, localChildren, localPositions, 0, localChildren.length, 0, end - start, make, make);
            } else node = makeTree(type, localChildren, localPositions, end - start, lookAheadAtStart - end, contextAtStart);
        }
        children.push(node);
        positions.push(startPos);
    }
    function takeFlatNode(parentStart, minPos, children, positions) {
        let nodes = []; // Temporary, inverted array of leaf nodes found, with absolute positions
        let nodeCount = 0, stopAt = -1;
        while(cursor.pos > minPos){
            let { id: id, start: start, end: end, size: size } = cursor;
            if (size > 4) cursor.next();
            else if (stopAt > -1 && start < stopAt) break;
            else {
                if (stopAt < 0) stopAt = end - maxBufferLength;
                nodes.push(id, start, end);
                nodeCount++;
                cursor.next();
            }
        }
        if (nodeCount) {
            let buffer = new Uint16Array(nodeCount * 4);
            let start = nodes[nodes.length - 2];
            for(let i = nodes.length - 3, j = 0; i >= 0; i -= 3){
                buffer[j++] = nodes[i];
                buffer[j++] = nodes[i + 1] - start;
                buffer[j++] = nodes[i + 2] - start;
                buffer[j++] = j;
            }
            children.push(new $ed739beecf769914$export$33300581b70be371(buffer, nodes[2] - start, nodeSet));
            positions.push(start - parentStart);
        }
    }
    function makeBalanced(type, contextHash) {
        return (children, positions, length)=>{
            let lookAhead = 0, lastI = children.length - 1, last, lookAheadProp;
            if (lastI >= 0 && (last = children[lastI]) instanceof $ed739beecf769914$export$7fbedc92909ed28e) {
                if (!lastI && last.type == type && last.length == length) return last;
                if (lookAheadProp = last.prop($ed739beecf769914$export$b8034b9bc18acd90.lookAhead)) lookAhead = positions[lastI] + last.length + lookAheadProp;
            }
            return makeTree(type, children, positions, length, lookAhead, contextHash);
        };
    }
    function makeRepeatLeaf(children, positions, base, i, from, to, type, lookAhead, contextHash) {
        let localChildren = [], localPositions = [];
        while(children.length > i){
            localChildren.push(children.pop());
            localPositions.push(positions.pop() + base - from);
        }
        children.push(makeTree(nodeSet.types[type], localChildren, localPositions, to - from, lookAhead - to, contextHash));
        positions.push(from - base);
    }
    function makeTree(type, children, positions, length, lookAhead, contextHash, props) {
        if (contextHash) {
            let pair = [
                $ed739beecf769914$export$b8034b9bc18acd90.contextHash,
                contextHash
            ];
            props = props ? [
                pair
            ].concat(props) : [
                pair
            ];
        }
        if (lookAhead > 25) {
            let pair = [
                $ed739beecf769914$export$b8034b9bc18acd90.lookAhead,
                lookAhead
            ];
            props = props ? [
                pair
            ].concat(props) : [
                pair
            ];
        }
        return new $ed739beecf769914$export$7fbedc92909ed28e(type, children, positions, length, props);
    }
    function findBufferSize(maxSize, inRepeat) {
        // Scan through the buffer to find previous siblings that fit
        // together in a TreeBuffer, and don't contain any reused nodes
        // (which can't be stored in a buffer).
        // If `inRepeat` is > -1, ignore node boundaries of that type for
        // nesting, but make sure the end falls either at the start
        // (`maxSize`) or before such a node.
        let fork = cursor.fork();
        let size = 0, start = 0, skip = 0, minStart = fork.end - maxBufferLength;
        let result = {
            size: 0,
            start: 0,
            skip: 0
        };
        scan: for(let minPos = fork.pos - maxSize; fork.pos > minPos;){
            let nodeSize = fork.size;
            // Pretend nested repeat nodes of the same type don't exist
            if (fork.id == inRepeat && nodeSize >= 0) {
                // Except that we store the current state as a valid return
                // value.
                result.size = size;
                result.start = start;
                result.skip = skip;
                skip += 4;
                size += 4;
                fork.next();
                continue;
            }
            let startPos = fork.pos - nodeSize;
            if (nodeSize < 0 || startPos < minPos || fork.start < minStart) break;
            let localSkipped = fork.id >= minRepeatType ? 4 : 0;
            let nodeStart = fork.start;
            fork.next();
            while(fork.pos > startPos){
                if (fork.size < 0) {
                    if (fork.size == -3 /* SpecialRecord.ContextChange */  || fork.size == -4 /* SpecialRecord.LookAhead */ ) localSkipped += 4;
                    else break scan;
                } else if (fork.id >= minRepeatType) localSkipped += 4;
                fork.next();
            }
            start = nodeStart;
            size += nodeSize;
            skip += localSkipped;
        }
        if (inRepeat < 0 || size == maxSize) {
            result.size = size;
            result.start = start;
            result.skip = skip;
        }
        return result.size > 4 ? result : undefined;
    }
    function copyToBuffer(bufferStart, buffer, index) {
        let { id: id, start: start, end: end, size: size } = cursor;
        cursor.next();
        if (size >= 0 && id < minRepeatType) {
            let startIndex = index;
            if (size > 4) {
                let endPos = cursor.pos - (size - 4);
                while(cursor.pos > endPos)index = copyToBuffer(bufferStart, buffer, index);
            }
            buffer[--index] = startIndex;
            buffer[--index] = end - bufferStart;
            buffer[--index] = start - bufferStart;
            buffer[--index] = id;
        } else if (size == -3 /* SpecialRecord.ContextChange */ ) contextHash = id;
        else if (size == -4 /* SpecialRecord.LookAhead */ ) lookAhead = id;
        return index;
    }
    let children = [], positions = [];
    while(cursor.pos > 0)takeNode(data.start || 0, data.bufferStart || 0, children, positions, -1, 0);
    let length = (_a = data.length) !== null && _a !== void 0 ? _a : children.length ? positions[0] + children[0].length : 0;
    return new $ed739beecf769914$export$7fbedc92909ed28e(types[data.topID], children.reverse(), positions.reverse(), length);
}
const $ed739beecf769914$var$nodeSizeCache = new WeakMap;
function $ed739beecf769914$var$nodeSize(balanceType, node) {
    if (!balanceType.isAnonymous || node instanceof $ed739beecf769914$export$33300581b70be371 || node.type != balanceType) return 1;
    let size = $ed739beecf769914$var$nodeSizeCache.get(node);
    if (size == null) {
        size = 1;
        for (let child of node.children){
            if (child.type != balanceType || !(child instanceof $ed739beecf769914$export$7fbedc92909ed28e)) {
                size = 1;
                break;
            }
            size += $ed739beecf769914$var$nodeSize(balanceType, child);
        }
        $ed739beecf769914$var$nodeSizeCache.set(node, size);
    }
    return size;
}
function $ed739beecf769914$var$balanceRange(// The type the balanced tree's inner nodes.
balanceType, // The direct children and their positions
children, positions, // The index range in children/positions to use
from, to, // The start position of the nodes, relative to their parent.
start, // Length of the outer node
length, // Function to build the top node of the balanced tree
mkTop, // Function to build internal nodes for the balanced tree
mkTree) {
    let total = 0;
    for(let i = from; i < to; i++)total += $ed739beecf769914$var$nodeSize(balanceType, children[i]);
    let maxChild = Math.ceil(total * 1.5 / 8 /* Balance.BranchFactor */ );
    let localChildren = [], localPositions = [];
    function divide(children, positions, from, to, offset) {
        for(let i = from; i < to;){
            let groupFrom = i, groupStart = positions[i], groupSize = $ed739beecf769914$var$nodeSize(balanceType, children[i]);
            i++;
            for(; i < to; i++){
                let nextSize = $ed739beecf769914$var$nodeSize(balanceType, children[i]);
                if (groupSize + nextSize >= maxChild) break;
                groupSize += nextSize;
            }
            if (i == groupFrom + 1) {
                if (groupSize > maxChild) {
                    let only = children[groupFrom]; // Only trees can have a size > 1
                    divide(only.children, only.positions, 0, only.children.length, positions[groupFrom] + offset);
                    continue;
                }
                localChildren.push(children[groupFrom]);
            } else {
                let length = positions[i - 1] + children[i - 1].length - groupStart;
                localChildren.push($ed739beecf769914$var$balanceRange(balanceType, children, positions, groupFrom, i, groupStart, length, null, mkTree));
            }
            localPositions.push(groupStart + offset - start);
        }
    }
    divide(children, positions, from, to, 0);
    return (mkTop || mkTree)(localChildren, localPositions, length);
}
/**
Provides a way to associate values with pieces of trees. As long
as that part of the tree is reused, the associated values can be
retrieved from an updated tree.
*/ class $ed739beecf769914$export$7f13b5dc44c541ae {
    constructor(){
        this.map = new WeakMap();
    }
    setBuffer(buffer, index, value) {
        let inner = this.map.get(buffer);
        if (!inner) this.map.set(buffer, inner = new Map);
        inner.set(index, value);
    }
    getBuffer(buffer, index) {
        let inner = this.map.get(buffer);
        return inner && inner.get(index);
    }
    /**
    Set the value for this syntax node.
    */ set(node, value) {
        if (node instanceof $ed739beecf769914$var$BufferNode) this.setBuffer(node.context.buffer, node.index, value);
        else if (node instanceof $ed739beecf769914$var$TreeNode) this.map.set(node.tree, value);
    }
    /**
    Retrieve value for this syntax node, if it exists in the map.
    */ get(node) {
        return node instanceof $ed739beecf769914$var$BufferNode ? this.getBuffer(node.context.buffer, node.index) : node instanceof $ed739beecf769914$var$TreeNode ? this.map.get(node.tree) : undefined;
    }
    /**
    Set the value for the node that a cursor currently points to.
    */ cursorSet(cursor, value) {
        if (cursor.buffer) this.setBuffer(cursor.buffer.buffer, cursor.index, value);
        else this.map.set(cursor.tree, value);
    }
    /**
    Retrieve the value for the node that a cursor currently points
    to.
    */ cursorGet(cursor) {
        return cursor.buffer ? this.getBuffer(cursor.buffer.buffer, cursor.index) : this.map.get(cursor.tree);
    }
}
/**
Tree fragments are used during [incremental
parsing](#common.Parser.startParse) to track parts of old trees
that can be reused in a new parse. An array of fragments is used
to track regions of an old tree whose nodes might be reused in new
parses. Use the static
[`applyChanges`](#common.TreeFragment^applyChanges) method to
update fragments for document changes.
*/ class $ed739beecf769914$export$3ae2ede6dca97077 {
    /**
    Construct a tree fragment. You'll usually want to use
    [`addTree`](#common.TreeFragment^addTree) and
    [`applyChanges`](#common.TreeFragment^applyChanges) instead of
    calling this directly.
    */ constructor(/**
    The start of the unchanged range pointed to by this fragment.
    This refers to an offset in the _updated_ document (as opposed
    to the original tree).
    */ from, /**
    The end of the unchanged range.
    */ to, /**
    The tree that this fragment is based on.
    */ tree, /**
    The offset between the fragment's tree and the document that
    this fragment can be used against. Add this when going from
    document to tree positions, subtract it to go from tree to
    document positions.
    */ offset, openStart = false, openEnd = false){
        this.from = from;
        this.to = to;
        this.tree = tree;
        this.offset = offset;
        this.open = (openStart ? 1 /* Open.Start */  : 0) | (openEnd ? 2 /* Open.End */  : 0);
    }
    /**
    Whether the start of the fragment represents the start of a
    parse, or the end of a change. (In the second case, it may not
    be safe to reuse some nodes at the start, depending on the
    parsing algorithm.)
    */ get openStart() {
        return (this.open & 1 /* Open.Start */ ) > 0;
    }
    /**
    Whether the end of the fragment represents the end of a
    full-document parse, or the start of a change.
    */ get openEnd() {
        return (this.open & 2 /* Open.End */ ) > 0;
    }
    /**
    Create a set of fragments from a freshly parsed tree, or update
    an existing set of fragments by replacing the ones that overlap
    with a tree with content from the new tree. When `partial` is
    true, the parse is treated as incomplete, and the resulting
    fragment has [`openEnd`](#common.TreeFragment.openEnd) set to
    true.
    */ static addTree(tree, fragments = [], partial = false) {
        let result = [
            new $ed739beecf769914$export$3ae2ede6dca97077(0, tree.length, tree, 0, false, partial)
        ];
        for (let f of fragments)if (f.to > tree.length) result.push(f);
        return result;
    }
    /**
    Apply a set of edits to an array of fragments, removing or
    splitting fragments as necessary to remove edited ranges, and
    adjusting offsets for fragments that moved.
    */ static applyChanges(fragments, changes, minGap = 128) {
        if (!changes.length) return fragments;
        let result = [];
        let fI = 1, nextF = fragments.length ? fragments[0] : null;
        for(let cI = 0, pos = 0, off = 0;; cI++){
            let nextC = cI < changes.length ? changes[cI] : null;
            let nextPos = nextC ? nextC.fromA : 1e9;
            if (nextPos - pos >= minGap) while(nextF && nextF.from < nextPos){
                let cut = nextF;
                if (pos >= cut.from || nextPos <= cut.to || off) {
                    let fFrom = Math.max(cut.from, pos) - off, fTo = Math.min(cut.to, nextPos) - off;
                    cut = fFrom >= fTo ? null : new $ed739beecf769914$export$3ae2ede6dca97077(fFrom, fTo, cut.tree, cut.offset + off, cI > 0, !!nextC);
                }
                if (cut) result.push(cut);
                if (nextF.to > nextPos) break;
                nextF = fI < fragments.length ? fragments[fI++] : null;
            }
            if (!nextC) break;
            pos = nextC.toA;
            off = nextC.toA - nextC.toB;
        }
        return result;
    }
}
/**
A superclass that parsers should extend.
*/ class $ed739beecf769914$export$7acfa6ed01010e37 {
    /**
    Start a parse, returning a [partial parse](#common.PartialParse)
    object. [`fragments`](#common.TreeFragment) can be passed in to
    make the parse incremental.
    
    By default, the entire input is parsed. You can pass `ranges`,
    which should be a sorted array of non-empty, non-overlapping
    ranges, to parse only those ranges. The tree returned in that
    case will start at `ranges[0].from`.
    */ startParse(input, fragments, ranges) {
        if (typeof input == "string") input = new $ed739beecf769914$var$StringInput(input);
        ranges = !ranges ? [
            new $ed739beecf769914$var$Range(0, input.length)
        ] : ranges.length ? ranges.map((r)=>new $ed739beecf769914$var$Range(r.from, r.to)) : [
            new $ed739beecf769914$var$Range(0, 0)
        ];
        return this.createParse(input, fragments || [], ranges);
    }
    /**
    Run a full parse, returning the resulting tree.
    */ parse(input, fragments, ranges) {
        let parse = this.startParse(input, fragments, ranges);
        for(;;){
            let done = parse.advance();
            if (done) return done;
        }
    }
}
class $ed739beecf769914$var$StringInput {
    constructor(string){
        this.string = string;
    }
    get length() {
        return this.string.length;
    }
    chunk(from) {
        return this.string.slice(from);
    }
    get lineChunks() {
        return false;
    }
    read(from, to) {
        return this.string.slice(from, to);
    }
}
/**
Create a parse wrapper that, after the inner parse completes,
scans its tree for mixed language regions with the `nest`
function, runs the resulting [inner parses](#common.NestedParse),
and then [mounts](#common.NodeProp^mounted) their results onto the
tree.
*/ function $ed739beecf769914$export$5dcc455959c76221(nest) {
    return (parse, input, fragments, ranges)=>new $ed739beecf769914$var$MixedParse(parse, nest, input, fragments, ranges);
}
class $ed739beecf769914$var$InnerParse {
    constructor(parser, parse, overlay, bracketed, target, from){
        this.parser = parser;
        this.parse = parse;
        this.overlay = overlay;
        this.bracketed = bracketed;
        this.target = target;
        this.from = from;
    }
}
function $ed739beecf769914$var$checkRanges(ranges) {
    if (!ranges.length || ranges.some((r)=>r.from >= r.to)) throw new RangeError("Invalid inner parse ranges given: " + JSON.stringify(ranges));
}
class $ed739beecf769914$var$ActiveOverlay {
    constructor(parser, predicate, mounts, index, start, bracketed, target, prev){
        this.parser = parser;
        this.predicate = predicate;
        this.mounts = mounts;
        this.index = index;
        this.start = start;
        this.bracketed = bracketed;
        this.target = target;
        this.prev = prev;
        this.depth = 0;
        this.ranges = [];
    }
}
const $ed739beecf769914$var$stoppedInner = new $ed739beecf769914$export$b8034b9bc18acd90({
    perNode: true
});
class $ed739beecf769914$var$MixedParse {
    constructor(base, nest, input, fragments, ranges){
        this.nest = nest;
        this.input = input;
        this.fragments = fragments;
        this.ranges = ranges;
        this.inner = [];
        this.innerDone = 0;
        this.baseTree = null;
        this.stoppedAt = null;
        this.baseParse = base;
    }
    advance() {
        if (this.baseParse) {
            let done = this.baseParse.advance();
            if (!done) return null;
            this.baseParse = null;
            this.baseTree = done;
            this.startInner();
            if (this.stoppedAt != null) for (let inner of this.inner)inner.parse.stopAt(this.stoppedAt);
        }
        if (this.innerDone == this.inner.length) {
            let result = this.baseTree;
            if (this.stoppedAt != null) result = new $ed739beecf769914$export$7fbedc92909ed28e(result.type, result.children, result.positions, result.length, result.propValues.concat([
                [
                    $ed739beecf769914$var$stoppedInner,
                    this.stoppedAt
                ]
            ]));
            return result;
        }
        let inner = this.inner[this.innerDone], done = inner.parse.advance();
        if (done) {
            this.innerDone++;
            // This is a somewhat dodgy but super helpful hack where we
            // patch up nodes created by the inner parse (and thus
            // presumably not aliased anywhere else) to hold the information
            // about the inner parse.
            let props = Object.assign(Object.create(null), inner.target.props);
            props[$ed739beecf769914$export$b8034b9bc18acd90.mounted.id] = new $ed739beecf769914$export$358cdd8bd77577cc(done, inner.overlay, inner.parser, inner.bracketed);
            inner.target.props = props;
        }
        return null;
    }
    get parsedPos() {
        if (this.baseParse) return 0;
        let pos = this.input.length;
        for(let i = this.innerDone; i < this.inner.length; i++)if (this.inner[i].from < pos) pos = Math.min(pos, this.inner[i].parse.parsedPos);
        return pos;
    }
    stopAt(pos) {
        this.stoppedAt = pos;
        if (this.baseParse) this.baseParse.stopAt(pos);
        else for(let i = this.innerDone; i < this.inner.length; i++)this.inner[i].parse.stopAt(pos);
    }
    startInner() {
        let fragmentCursor = new $ed739beecf769914$var$FragmentCursor(this.fragments);
        let overlay = null;
        let covered = null;
        let cursor = new $ed739beecf769914$export$3ae4554f36e54a34(new $ed739beecf769914$var$TreeNode(this.baseTree, this.ranges[0].from, 0, null), $ed739beecf769914$export$b0e28367f55837aa.IncludeAnonymous | $ed739beecf769914$export$b0e28367f55837aa.IgnoreMounts);
        scan: for(let nest, isCovered;;){
            let enter = true, range;
            if (this.stoppedAt != null && cursor.from >= this.stoppedAt) enter = false;
            else if (fragmentCursor.hasNode(cursor)) {
                if (overlay) {
                    let match = overlay.mounts.find((m)=>m.frag.from <= cursor.from && m.frag.to >= cursor.to && m.mount.overlay);
                    if (match) for (let r of match.mount.overlay){
                        let from = r.from + match.pos, to = r.to + match.pos;
                        if (from >= cursor.from && to <= cursor.to && !overlay.ranges.some((r)=>r.from < to && r.to > from)) overlay.ranges.push({
                            from: from,
                            to: to
                        });
                    }
                }
                enter = false;
            } else if (covered && (isCovered = $ed739beecf769914$var$checkCover(covered.ranges, cursor.from, cursor.to))) enter = isCovered != 2 /* Cover.Full */ ;
            else if (!cursor.type.isAnonymous && (nest = this.nest(cursor, this.input)) && (cursor.from < cursor.to || !nest.overlay)) {
                if (!cursor.tree) {
                    $ed739beecf769914$var$materialize(cursor);
                    // materialize create one more level of nesting
                    // we need to add depth to active overlay for going backwards
                    if (overlay) overlay.depth++;
                    if (covered) covered.depth++;
                }
                let oldMounts = fragmentCursor.findMounts(cursor.from, nest.parser);
                if (typeof nest.overlay == "function") overlay = new $ed739beecf769914$var$ActiveOverlay(nest.parser, nest.overlay, oldMounts, this.inner.length, cursor.from, !!nest.bracketed, cursor.tree, overlay);
                else {
                    let ranges = $ed739beecf769914$var$punchRanges(this.ranges, nest.overlay || (cursor.from < cursor.to ? [
                        new $ed739beecf769914$var$Range(cursor.from, cursor.to)
                    ] : []));
                    if (ranges.length) $ed739beecf769914$var$checkRanges(ranges);
                    if (ranges.length || !nest.overlay) this.inner.push(new $ed739beecf769914$var$InnerParse(nest.parser, ranges.length ? nest.parser.startParse(this.input, $ed739beecf769914$var$enterFragments(oldMounts, ranges), ranges) : nest.parser.startParse(""), nest.overlay ? nest.overlay.map((r)=>new $ed739beecf769914$var$Range(r.from - cursor.from, r.to - cursor.from)) : null, !!nest.bracketed, cursor.tree, ranges.length ? ranges[0].from : cursor.from));
                    if (!nest.overlay) enter = false;
                    else if (ranges.length) covered = {
                        ranges: ranges,
                        depth: 0,
                        prev: covered
                    };
                }
            } else if (overlay && (range = overlay.predicate(cursor))) {
                if (range === true) range = new $ed739beecf769914$var$Range(cursor.from, cursor.to);
                if (range.from < range.to) {
                    let last = overlay.ranges.length - 1;
                    if (last >= 0 && overlay.ranges[last].to == range.from) overlay.ranges[last] = {
                        from: overlay.ranges[last].from,
                        to: range.to
                    };
                    else overlay.ranges.push(range);
                }
            }
            if (enter && cursor.firstChild()) {
                if (overlay) overlay.depth++;
                if (covered) covered.depth++;
            } else for(;;){
                if (cursor.nextSibling()) break;
                if (!cursor.parent()) break scan;
                if (overlay && !--overlay.depth) {
                    let ranges = $ed739beecf769914$var$punchRanges(this.ranges, overlay.ranges);
                    if (ranges.length) {
                        $ed739beecf769914$var$checkRanges(ranges);
                        this.inner.splice(overlay.index, 0, new $ed739beecf769914$var$InnerParse(overlay.parser, overlay.parser.startParse(this.input, $ed739beecf769914$var$enterFragments(overlay.mounts, ranges), ranges), overlay.ranges.map((r)=>new $ed739beecf769914$var$Range(r.from - overlay.start, r.to - overlay.start)), overlay.bracketed, overlay.target, ranges[0].from));
                    }
                    overlay = overlay.prev;
                }
                if (covered && !--covered.depth) covered = covered.prev;
            }
        }
    }
}
function $ed739beecf769914$var$checkCover(covered, from, to) {
    for (let range of covered){
        if (range.from >= to) break;
        if (range.to > from) return range.from <= from && range.to >= to ? 2 /* Cover.Full */  : 1 /* Cover.Partial */ ;
    }
    return 0 /* Cover.None */ ;
}
// Take a piece of buffer and convert it into a stand-alone
// TreeBuffer.
function $ed739beecf769914$var$sliceBuf(buf, startI, endI, nodes, positions, off) {
    if (startI < endI) {
        let from = buf.buffer[startI + 1];
        nodes.push(buf.slice(startI, endI, from));
        positions.push(from - off);
    }
}
// This function takes a node that's in a buffer, and converts it, and
// its parent buffer nodes, into a Tree. This is again acting on the
// assumption that the trees and buffers have been constructed by the
// parse that was ran via the mix parser, and thus aren't shared with
// any other code, making violations of the immutability safe.
function $ed739beecf769914$var$materialize(cursor) {
    let { node: node } = cursor, stack = [];
    let buffer = node.context.buffer;
    // Scan up to the nearest tree
    do {
        stack.push(cursor.index);
        cursor.parent();
    }while (!cursor.tree);
    // Find the index of the buffer in that tree
    let base = cursor.tree, i = base.children.indexOf(buffer);
    let buf = base.children[i], b = buf.buffer, newStack = [
        i
    ];
    // Split a level in the buffer, putting the nodes before and after
    // the child that contains `node` into new buffers.
    function split(startI, endI, type, innerOffset, length, stackPos) {
        let targetI = stack[stackPos];
        let children = [], positions = [];
        $ed739beecf769914$var$sliceBuf(buf, startI, targetI, children, positions, innerOffset);
        let from = b[targetI + 1], to = b[targetI + 2];
        newStack.push(children.length);
        let child = stackPos ? split(targetI + 4, b[targetI + 3], buf.set.types[b[targetI]], from, to - from, stackPos - 1) : node.toTree();
        children.push(child);
        positions.push(from - innerOffset);
        $ed739beecf769914$var$sliceBuf(buf, b[targetI + 3], endI, children, positions, innerOffset);
        return new $ed739beecf769914$export$7fbedc92909ed28e(type, children, positions, length);
    }
    base.children[i] = split(0, b.length, $ed739beecf769914$export$f06e977173f1857c.none, 0, buf.length, stack.length - 1);
    // Move the cursor back to the target node
    for (let index of newStack){
        let tree = cursor.tree.children[index], pos = cursor.tree.positions[index];
        cursor.yield(new $ed739beecf769914$var$TreeNode(tree, pos + cursor.from, index, cursor._tree));
    }
}
class $ed739beecf769914$var$StructureCursor {
    constructor(root, offset){
        this.offset = offset;
        this.done = false;
        this.cursor = root.cursor($ed739beecf769914$export$b0e28367f55837aa.IncludeAnonymous | $ed739beecf769914$export$b0e28367f55837aa.IgnoreMounts);
    }
    // Move to the first node (in pre-order) that starts at or after `pos`.
    moveTo(pos) {
        let { cursor: cursor } = this, p = pos - this.offset;
        while(!this.done && cursor.from < p){
            if (cursor.to >= pos && cursor.enter(p, 1, $ed739beecf769914$export$b0e28367f55837aa.IgnoreOverlays | $ed739beecf769914$export$b0e28367f55837aa.ExcludeBuffers)) ;
            else if (cursor.to <= pos) {
                if (!cursor.next(false)) this.done = true;
            } else break;
        }
    }
    hasNode(cursor) {
        this.moveTo(cursor.from);
        if (!this.done && this.cursor.from + this.offset == cursor.from && this.cursor.tree) for(let tree = this.cursor.tree;;){
            if (tree == cursor.tree) return true;
            if (tree.children.length && tree.positions[0] == 0 && tree.children[0] instanceof $ed739beecf769914$export$7fbedc92909ed28e) tree = tree.children[0];
            else break;
        }
        return false;
    }
}
class $ed739beecf769914$var$FragmentCursor {
    constructor(fragments){
        var _a;
        this.fragments = fragments;
        this.curTo = 0;
        this.fragI = 0;
        if (fragments.length) {
            let first = this.curFrag = fragments[0];
            this.curTo = (_a = first.tree.prop($ed739beecf769914$var$stoppedInner)) !== null && _a !== void 0 ? _a : first.to;
            this.inner = new $ed739beecf769914$var$StructureCursor(first.tree, -first.offset);
        } else this.curFrag = this.inner = null;
    }
    hasNode(node) {
        while(this.curFrag && node.from >= this.curTo)this.nextFrag();
        return this.curFrag && this.curFrag.from <= node.from && this.curTo >= node.to && this.inner.hasNode(node);
    }
    nextFrag() {
        var _a;
        this.fragI++;
        if (this.fragI == this.fragments.length) this.curFrag = this.inner = null;
        else {
            let frag = this.curFrag = this.fragments[this.fragI];
            this.curTo = (_a = frag.tree.prop($ed739beecf769914$var$stoppedInner)) !== null && _a !== void 0 ? _a : frag.to;
            this.inner = new $ed739beecf769914$var$StructureCursor(frag.tree, -frag.offset);
        }
    }
    findMounts(pos, parser) {
        var _a;
        let result = [];
        if (this.inner) {
            this.inner.cursor.moveTo(pos, 1);
            for(let pos = this.inner.cursor.node; pos; pos = pos.parent){
                let mount = (_a = pos.tree) === null || _a === void 0 ? void 0 : _a.prop($ed739beecf769914$export$b8034b9bc18acd90.mounted);
                if (mount && mount.parser == parser) for(let i = this.fragI; i < this.fragments.length; i++){
                    let frag = this.fragments[i];
                    if (frag.from >= pos.to) break;
                    if (frag.tree == this.curFrag.tree) result.push({
                        frag: frag,
                        pos: pos.from - frag.offset,
                        mount: mount
                    });
                }
            }
        }
        return result;
    }
}
function $ed739beecf769914$var$punchRanges(outer, ranges) {
    let copy = null, current = ranges;
    for(let i = 1, j = 0; i < outer.length; i++){
        let gapFrom = outer[i - 1].to, gapTo = outer[i].from;
        for(; j < current.length; j++){
            let r = current[j];
            if (r.from >= gapTo) break;
            if (r.to <= gapFrom) continue;
            if (!copy) current = copy = ranges.slice();
            if (r.from < gapFrom) {
                copy[j] = new $ed739beecf769914$var$Range(r.from, gapFrom);
                if (r.to > gapTo) copy.splice(j + 1, 0, new $ed739beecf769914$var$Range(gapTo, r.to));
            } else if (r.to > gapTo) copy[j--] = new $ed739beecf769914$var$Range(gapTo, r.to);
            else copy.splice(j--, 1);
        }
    }
    return current;
}
function $ed739beecf769914$var$findCoverChanges(a, b, from, to) {
    let iA = 0, iB = 0, inA = false, inB = false, pos = -1000000000;
    let result = [];
    for(;;){
        let nextA = iA == a.length ? 1e9 : inA ? a[iA].to : a[iA].from;
        let nextB = iB == b.length ? 1e9 : inB ? b[iB].to : b[iB].from;
        if (inA != inB) {
            let start = Math.max(pos, from), end = Math.min(nextA, nextB, to);
            if (start < end) result.push(new $ed739beecf769914$var$Range(start, end));
        }
        pos = Math.min(nextA, nextB);
        if (pos == 1e9) break;
        if (nextA == pos) {
            if (!inA) inA = true;
            else {
                inA = false;
                iA++;
            }
        }
        if (nextB == pos) {
            if (!inB) inB = true;
            else {
                inB = false;
                iB++;
            }
        }
    }
    return result;
}
// Given a number of fragments for the outer tree, and a set of ranges
// to parse, find fragments for inner trees mounted around those
// ranges, if any.
function $ed739beecf769914$var$enterFragments(mounts, ranges) {
    let result = [];
    for (let { pos: pos, mount: mount, frag: frag } of mounts){
        let startPos = pos + (mount.overlay ? mount.overlay[0].from : 0), endPos = startPos + mount.tree.length;
        let from = Math.max(frag.from, startPos), to = Math.min(frag.to, endPos);
        if (mount.overlay) {
            let overlay = mount.overlay.map((r)=>new $ed739beecf769914$var$Range(r.from + pos, r.to + pos));
            let changes = $ed739beecf769914$var$findCoverChanges(ranges, overlay, from, to);
            for(let i = 0, pos = from;; i++){
                let last = i == changes.length, end = last ? to : changes[i].from;
                if (end > pos) result.push(new $ed739beecf769914$export$3ae2ede6dca97077(pos, end, mount.tree, -startPos, frag.from >= pos || frag.openStart, frag.to <= end || frag.openEnd));
                if (last) break;
                pos = changes[i].to;
            }
        } else result.push(new $ed739beecf769914$export$3ae2ede6dca97077(from, to, mount.tree, -startPos, frag.from >= startPos || frag.openStart, frag.to <= endPos || frag.openEnd));
    }
    return result;
}





let $a1ec9d683d365521$var$nextTagID = 0;
/**
Highlighting tags are markers that denote a highlighting category.
They are [associated](#highlight.styleTags) with parts of a syntax
tree by a language mode, and then mapped to an actual CSS style by
a [highlighter](#highlight.Highlighter).

Because syntax tree node types and highlight styles have to be
able to talk the same language, CodeMirror uses a mostly _closed_
[vocabulary](#highlight.tags) of syntax tags (as opposed to
traditional open string-based systems, which make it hard for
highlighting themes to cover all the tokens produced by the
various languages).

It _is_ possible to [define](#highlight.Tag^define) your own
highlighting tags for system-internal use (where you control both
the language package and the highlighter), but such tags will not
be picked up by regular highlighters (though you can derive them
from standard tags to allow highlighters to fall back to those).
*/ class $a1ec9d683d365521$export$3288d34c523a1192 {
    /**
    @internal
    */ constructor(/**
    The optional name of the base tag @internal
    */ name, /**
    The set of this tag and all its parent tags, starting with
    this one itself and sorted in order of decreasing specificity.
    */ set, /**
    The base unmodified tag that this one is based on, if it's
    modified @internal
    */ base, /**
    The modifiers applied to this.base @internal
    */ modified){
        this.name = name;
        this.set = set;
        this.base = base;
        this.modified = modified;
        /**
        @internal
        */ this.id = $a1ec9d683d365521$var$nextTagID++;
    }
    toString() {
        let { name: name } = this;
        for (let mod of this.modified)if (mod.name) name = `${mod.name}(${name})`;
        return name;
    }
    static define(nameOrParent, parent) {
        let name = typeof nameOrParent == "string" ? nameOrParent : "?";
        if (nameOrParent instanceof $a1ec9d683d365521$export$3288d34c523a1192) parent = nameOrParent;
        if (parent === null || parent === void 0 ? void 0 : parent.base) throw new Error("Can not derive from a modified tag");
        let tag = new $a1ec9d683d365521$export$3288d34c523a1192(name, [], null, []);
        tag.set.push(tag);
        if (parent) for (let t of parent.set)tag.set.push(t);
        return tag;
    }
    /**
    Define a tag _modifier_, which is a function that, given a tag,
    will return a tag that is a subtag of the original. Applying the
    same modifier to a twice tag will return the same value (`m1(t1)
    == m1(t1)`) and applying multiple modifiers will, regardless or
    order, produce the same tag (`m1(m2(t1)) == m2(m1(t1))`).
    
    When multiple modifiers are applied to a given base tag, each
    smaller set of modifiers is registered as a parent, so that for
    example `m1(m2(m3(t1)))` is a subtype of `m1(m2(t1))`,
    `m1(m3(t1)`, and so on.
    */ static defineModifier(name) {
        let mod = new $a1ec9d683d365521$var$Modifier(name);
        return (tag)=>{
            if (tag.modified.indexOf(mod) > -1) return tag;
            return $a1ec9d683d365521$var$Modifier.get(tag.base || tag, tag.modified.concat(mod).sort((a, b)=>a.id - b.id));
        };
    }
}
let $a1ec9d683d365521$var$nextModifierID = 0;
class $a1ec9d683d365521$var$Modifier {
    constructor(name){
        this.name = name;
        this.instances = [];
        this.id = $a1ec9d683d365521$var$nextModifierID++;
    }
    static get(base, mods) {
        if (!mods.length) return base;
        let exists = mods[0].instances.find((t)=>t.base == base && $a1ec9d683d365521$var$sameArray(mods, t.modified));
        if (exists) return exists;
        let set = [], tag = new $a1ec9d683d365521$export$3288d34c523a1192(base.name, set, base, mods);
        for (let m of mods)m.instances.push(tag);
        let configs = $a1ec9d683d365521$var$powerSet(mods);
        for (let parent of base.set)if (!parent.modified.length) for (let config of configs)set.push($a1ec9d683d365521$var$Modifier.get(parent, config));
        return tag;
    }
}
function $a1ec9d683d365521$var$sameArray(a, b) {
    return a.length == b.length && a.every((x, i)=>x == b[i]);
}
function $a1ec9d683d365521$var$powerSet(array) {
    let sets = [
        []
    ];
    for(let i = 0; i < array.length; i++)for(let j = 0, e = sets.length; j < e; j++)sets.push(sets[j].concat(array[i]));
    return sets.sort((a, b)=>b.length - a.length);
}
/**
This function is used to add a set of tags to a language syntax
via [`NodeSet.extend`](#common.NodeSet.extend) or
[`LRParser.configure`](#lr.LRParser.configure).

The argument object maps node selectors to [highlighting
tags](#highlight.Tag) or arrays of tags.

Node selectors may hold one or more (space-separated) node paths.
Such a path can be a [node name](#common.NodeType.name), or
multiple node names (or `*` wildcards) separated by slash
characters, as in `"Block/Declaration/VariableName"`. Such a path
matches the final node but only if its direct parent nodes are the
other nodes mentioned. A `*` in such a path matches any parent,
but only a single level—wildcards that match multiple parents
aren't supported, both for efficiency reasons and because Lezer
trees make it rather hard to reason about what they would match.)

A path can be ended with `/...` to indicate that the tag assigned
to the node should also apply to all child nodes, even if they
match their own style (by default, only the innermost style is
used).

When a path ends in `!`, as in `Attribute!`, no further matching
happens for the node's child nodes, and the entire node gets the
given style.

In this notation, node names that contain `/`, `!`, `*`, or `...`
must be quoted as JSON strings.

For example:

```javascript
parser.configure({props: [
  styleTags({
    // Style Number and BigNumber nodes
    "Number BigNumber": tags.number,
    // Style Escape nodes whose parent is String
    "String/Escape": tags.escape,
    // Style anything inside Attributes nodes
    "Attributes!": tags.meta,
    // Add a style to all content inside Italic nodes
    "Italic/...": tags.emphasis,
    // Style InvalidString nodes as both `string` and `invalid`
    "InvalidString": [tags.string, tags.invalid],
    // Style the node named "/" as punctuation
    '"/"': tags.punctuation
  })
]})
```
*/ function $a1ec9d683d365521$export$c537e79bb7b94295(spec) {
    let byName = Object.create(null);
    for(let prop in spec){
        let tags = spec[prop];
        if (!Array.isArray(tags)) tags = [
            tags
        ];
        for (let part of prop.split(" "))if (part) {
            let pieces = [], mode = 2 /* Mode.Normal */ , rest = part;
            for(let pos = 0;;){
                if (rest == "..." && pos > 0 && pos + 3 == part.length) {
                    mode = 1 /* Mode.Inherit */ ;
                    break;
                }
                let m = /^"(?:[^"\\]|\\.)*?"|[^\/!]+/.exec(rest);
                if (!m) throw new RangeError("Invalid path: " + part);
                pieces.push(m[0] == "*" ? "" : m[0][0] == '"' ? JSON.parse(m[0]) : m[0]);
                pos += m[0].length;
                if (pos == part.length) break;
                let next = part[pos++];
                if (pos == part.length && next == "!") {
                    mode = 0 /* Mode.Opaque */ ;
                    break;
                }
                if (next != "/") throw new RangeError("Invalid path: " + part);
                rest = part.slice(pos);
            }
            let last = pieces.length - 1, inner = pieces[last];
            if (!inner) throw new RangeError("Invalid path: " + part);
            let rule = new $a1ec9d683d365521$var$Rule(tags, mode, last > 0 ? pieces.slice(0, last) : null);
            byName[inner] = rule.sort(byName[inner]);
        }
    }
    return $a1ec9d683d365521$var$ruleNodeProp.add(byName);
}
const $a1ec9d683d365521$var$ruleNodeProp = new (0, $ed739beecf769914$export$b8034b9bc18acd90)({
    combine (a, b) {
        let cur, root, take;
        while(a || b){
            if (!a || b && a.depth >= b.depth) {
                take = b;
                b = b.next;
            } else {
                take = a;
                a = a.next;
            }
            if (cur && cur.mode == take.mode && !take.context && !cur.context) continue;
            let copy = new $a1ec9d683d365521$var$Rule(take.tags, take.mode, take.context);
            if (cur) cur.next = copy;
            else root = copy;
            cur = copy;
        }
        return root;
    }
});
class $a1ec9d683d365521$var$Rule {
    constructor(tags, mode, context, next){
        this.tags = tags;
        this.mode = mode;
        this.context = context;
        this.next = next;
    }
    get opaque() {
        return this.mode == 0 /* Mode.Opaque */ ;
    }
    get inherit() {
        return this.mode == 1 /* Mode.Inherit */ ;
    }
    sort(other) {
        if (!other || other.depth < this.depth) {
            this.next = other;
            return this;
        }
        other.next = this.sort(other.next);
        return other;
    }
    get depth() {
        return this.context ? this.context.length : 0;
    }
}
$a1ec9d683d365521$var$Rule.empty = new $a1ec9d683d365521$var$Rule([], 2 /* Mode.Normal */ , null);
/**
Define a [highlighter](#highlight.Highlighter) from an array of
tag/class pairs. Classes associated with more specific tags will
take precedence.
*/ function $a1ec9d683d365521$export$b7f6332ce20f80fb(tags, options) {
    let map = Object.create(null);
    for (let style of tags){
        if (!Array.isArray(style.tag)) map[style.tag.id] = style.class;
        else for (let tag of style.tag)map[tag.id] = style.class;
    }
    let { scope: scope, all: all = null } = options || {};
    return {
        style: (tags)=>{
            let cls = all;
            for (let tag of tags)for (let sub of tag.set){
                let tagClass = map[sub.id];
                if (tagClass) {
                    cls = cls ? cls + " " + tagClass : tagClass;
                    break;
                }
            }
            return cls;
        },
        scope: scope
    };
}
function $a1ec9d683d365521$var$highlightTags(highlighters, tags) {
    let result = null;
    for (let highlighter of highlighters){
        let value = highlighter.style(tags);
        if (value) result = result ? result + " " + value : value;
    }
    return result;
}
/**
Highlight the given [tree](#common.Tree) with the given
[highlighter](#highlight.Highlighter). Often, the higher-level
[`highlightCode`](#highlight.highlightCode) function is easier to
use.
*/ function $a1ec9d683d365521$export$af82b3d076119fad(tree, highlighter, /**
Assign styling to a region of the text. Will be called, in order
of position, for any ranges where more than zero classes apply.
`classes` is a space separated string of CSS classes.
*/ putStyle, /**
The start of the range to highlight.
*/ from = 0, /**
The end of the range.
*/ to = tree.length) {
    let builder = new $a1ec9d683d365521$var$HighlightBuilder(from, Array.isArray(highlighter) ? highlighter : [
        highlighter
    ], putStyle);
    builder.highlightRange(tree.cursor(), from, to, "", builder.highlighters);
    builder.flush(to);
}
/**
Highlight the given tree with the given highlighter, calling
`putText` for every piece of text, either with a set of classes or
with the empty string when unstyled, and `putBreak` for every line
break.
*/ function $a1ec9d683d365521$export$e443a046766e80e8(code, tree, highlighter, putText, putBreak, from = 0, to = code.length) {
    let pos = from;
    function writeTo(p, classes) {
        if (p <= pos) return;
        for(let text = code.slice(pos, p), i = 0;;){
            let nextBreak = text.indexOf("\n", i);
            let upto = nextBreak < 0 ? text.length : nextBreak;
            if (upto > i) putText(text.slice(i, upto), classes);
            if (nextBreak < 0) break;
            putBreak();
            i = nextBreak + 1;
        }
        pos = p;
    }
    $a1ec9d683d365521$export$af82b3d076119fad(tree, highlighter, (from, to, classes)=>{
        writeTo(from, "");
        writeTo(to, classes);
    }, from, to);
    writeTo(to, "");
}
class $a1ec9d683d365521$var$HighlightBuilder {
    constructor(at, highlighters, span){
        this.at = at;
        this.highlighters = highlighters;
        this.span = span;
        this.class = "";
    }
    startSpan(at, cls) {
        if (cls != this.class) {
            this.flush(at);
            if (at > this.at) this.at = at;
            this.class = cls;
        }
    }
    flush(to) {
        if (to > this.at && this.class) this.span(this.at, to, this.class);
    }
    highlightRange(cursor, from, to, inheritedClass, highlighters) {
        let { type: type, from: start, to: end } = cursor;
        if (start >= to || end <= from) return;
        if (type.isTop) highlighters = this.highlighters.filter((h)=>!h.scope || h.scope(type));
        let cls = inheritedClass;
        let rule = $a1ec9d683d365521$export$1519d79cc79711ec(cursor) || $a1ec9d683d365521$var$Rule.empty;
        let tagCls = $a1ec9d683d365521$var$highlightTags(highlighters, rule.tags);
        if (tagCls) {
            if (cls) cls += " ";
            cls += tagCls;
            if (rule.mode == 1 /* Mode.Inherit */ ) inheritedClass += (inheritedClass ? " " : "") + tagCls;
        }
        this.startSpan(Math.max(from, start), cls);
        if (rule.opaque) return;
        let mounted = cursor.tree && cursor.tree.prop((0, $ed739beecf769914$export$b8034b9bc18acd90).mounted);
        if (mounted && mounted.overlay) {
            let inner = cursor.node.enter(mounted.overlay[0].from + start, 1);
            let innerHighlighters = this.highlighters.filter((h)=>!h.scope || h.scope(mounted.tree.type));
            let hasChild = cursor.firstChild();
            for(let i = 0, pos = start;; i++){
                let next = i < mounted.overlay.length ? mounted.overlay[i] : null;
                let nextPos = next ? next.from + start : end;
                let rangeFrom = Math.max(from, pos), rangeTo = Math.min(to, nextPos);
                if (rangeFrom < rangeTo && hasChild) while(cursor.from < rangeTo){
                    this.highlightRange(cursor, rangeFrom, rangeTo, inheritedClass, highlighters);
                    this.startSpan(Math.min(rangeTo, cursor.to), cls);
                    if (cursor.to >= nextPos || !cursor.nextSibling()) break;
                }
                if (!next || nextPos > to) break;
                pos = next.to + start;
                if (pos > from) {
                    this.highlightRange(inner.cursor(), Math.max(from, next.from + start), Math.min(to, pos), "", innerHighlighters);
                    this.startSpan(Math.min(to, pos), cls);
                }
            }
            if (hasChild) cursor.parent();
        } else if (cursor.firstChild()) {
            if (mounted) inheritedClass = "";
            do {
                if (cursor.to <= from) continue;
                if (cursor.from >= to) break;
                this.highlightRange(cursor, from, to, inheritedClass, highlighters);
                this.startSpan(Math.min(to, cursor.to), cls);
            }while (cursor.nextSibling());
            cursor.parent();
        }
    }
}
/**
Match a syntax node's [highlight rules](#highlight.styleTags). If
there's a match, return its set of tags, and whether it is
opaque (uses a `!`) or applies to all child nodes (`/...`).
*/ function $a1ec9d683d365521$export$1519d79cc79711ec(node) {
    let rule = node.type.prop($a1ec9d683d365521$var$ruleNodeProp);
    while(rule && rule.context && !node.matchContext(rule.context))rule = rule.next;
    return rule || null;
}
const $a1ec9d683d365521$var$t = $a1ec9d683d365521$export$3288d34c523a1192.define;
const $a1ec9d683d365521$var$comment = $a1ec9d683d365521$var$t(), $a1ec9d683d365521$var$name = $a1ec9d683d365521$var$t(), $a1ec9d683d365521$var$typeName = $a1ec9d683d365521$var$t($a1ec9d683d365521$var$name), $a1ec9d683d365521$var$propertyName = $a1ec9d683d365521$var$t($a1ec9d683d365521$var$name), $a1ec9d683d365521$var$literal = $a1ec9d683d365521$var$t(), $a1ec9d683d365521$var$string = $a1ec9d683d365521$var$t($a1ec9d683d365521$var$literal), $a1ec9d683d365521$var$number = $a1ec9d683d365521$var$t($a1ec9d683d365521$var$literal), $a1ec9d683d365521$var$content = $a1ec9d683d365521$var$t(), $a1ec9d683d365521$var$heading = $a1ec9d683d365521$var$t($a1ec9d683d365521$var$content), $a1ec9d683d365521$var$keyword = $a1ec9d683d365521$var$t(), $a1ec9d683d365521$var$operator = $a1ec9d683d365521$var$t(), $a1ec9d683d365521$var$punctuation = $a1ec9d683d365521$var$t(), $a1ec9d683d365521$var$bracket = $a1ec9d683d365521$var$t($a1ec9d683d365521$var$punctuation), $a1ec9d683d365521$var$meta = $a1ec9d683d365521$var$t();
/**
The default set of highlighting [tags](#highlight.Tag).

This collection is heavily biased towards programming languages,
and necessarily incomplete. A full ontology of syntactic
constructs would fill a stack of books, and be impractical to
write themes for. So try to make do with this set. If all else
fails, [open an
issue](https://github.com/codemirror/codemirror.next) to propose a
new tag, or [define](#highlight.Tag^define) a local custom tag for
your use case.

Note that it is not obligatory to always attach the most specific
tag possible to an element—if your grammar can't easily
distinguish a certain type of element (such as a local variable),
it is okay to style it as its more general variant (a variable).

For tags that extend some parent tag, the documentation links to
the parent.
*/ const $a1ec9d683d365521$export$8b7a896ae75accbf = {
    comment: /**
    A comment.
    */ $a1ec9d683d365521$var$comment,
    /**
    A line [comment](#highlight.tags.comment).
    */ lineComment: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$comment),
    /**
    A block [comment](#highlight.tags.comment).
    */ blockComment: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$comment),
    /**
    A documentation [comment](#highlight.tags.comment).
    */ docComment: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$comment),
    name: /**
    Any kind of identifier.
    */ $a1ec9d683d365521$var$name,
    /**
    The [name](#highlight.tags.name) of a variable.
    */ variableName: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$name),
    /**
    A type [name](#highlight.tags.name).
    */ typeName: $a1ec9d683d365521$var$typeName,
    /**
    A tag name (subtag of [`typeName`](#highlight.tags.typeName)).
    */ tagName: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$typeName),
    /**
    A property or field [name](#highlight.tags.name).
    */ propertyName: $a1ec9d683d365521$var$propertyName,
    /**
    An attribute name (subtag of [`propertyName`](#highlight.tags.propertyName)).
    */ attributeName: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$propertyName),
    /**
    The [name](#highlight.tags.name) of a class.
    */ className: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$name),
    /**
    A label [name](#highlight.tags.name).
    */ labelName: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$name),
    /**
    A namespace [name](#highlight.tags.name).
    */ namespace: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$name),
    /**
    The [name](#highlight.tags.name) of a macro.
    */ macroName: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$name),
    literal: /**
    A literal value.
    */ $a1ec9d683d365521$var$literal,
    string: /**
    A string [literal](#highlight.tags.literal).
    */ $a1ec9d683d365521$var$string,
    /**
    A documentation [string](#highlight.tags.string).
    */ docString: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$string),
    /**
    A character literal (subtag of [string](#highlight.tags.string)).
    */ character: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$string),
    /**
    An attribute value (subtag of [string](#highlight.tags.string)).
    */ attributeValue: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$string),
    number: /**
    A number [literal](#highlight.tags.literal).
    */ $a1ec9d683d365521$var$number,
    /**
    An integer [number](#highlight.tags.number) literal.
    */ integer: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$number),
    /**
    A floating-point [number](#highlight.tags.number) literal.
    */ float: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$number),
    /**
    A boolean [literal](#highlight.tags.literal).
    */ bool: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$literal),
    /**
    Regular expression [literal](#highlight.tags.literal).
    */ regexp: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$literal),
    /**
    An escape [literal](#highlight.tags.literal), for example a
    backslash escape in a string.
    */ escape: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$literal),
    /**
    A color [literal](#highlight.tags.literal).
    */ color: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$literal),
    /**
    A URL [literal](#highlight.tags.literal).
    */ url: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$literal),
    keyword: /**
    A language keyword.
    */ $a1ec9d683d365521$var$keyword,
    /**
    The [keyword](#highlight.tags.keyword) for the self or this
    object.
    */ self: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$keyword),
    /**
    The [keyword](#highlight.tags.keyword) for null.
    */ null: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$keyword),
    /**
    A [keyword](#highlight.tags.keyword) denoting some atomic value.
    */ atom: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$keyword),
    /**
    A [keyword](#highlight.tags.keyword) that represents a unit.
    */ unit: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$keyword),
    /**
    A modifier [keyword](#highlight.tags.keyword).
    */ modifier: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$keyword),
    /**
    A [keyword](#highlight.tags.keyword) that acts as an operator.
    */ operatorKeyword: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$keyword),
    /**
    A control-flow related [keyword](#highlight.tags.keyword).
    */ controlKeyword: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$keyword),
    /**
    A [keyword](#highlight.tags.keyword) that defines something.
    */ definitionKeyword: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$keyword),
    /**
    A [keyword](#highlight.tags.keyword) related to defining or
    interfacing with modules.
    */ moduleKeyword: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$keyword),
    operator: /**
    An operator.
    */ $a1ec9d683d365521$var$operator,
    /**
    An [operator](#highlight.tags.operator) that dereferences something.
    */ derefOperator: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$operator),
    /**
    Arithmetic-related [operator](#highlight.tags.operator).
    */ arithmeticOperator: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$operator),
    /**
    Logical [operator](#highlight.tags.operator).
    */ logicOperator: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$operator),
    /**
    Bit [operator](#highlight.tags.operator).
    */ bitwiseOperator: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$operator),
    /**
    Comparison [operator](#highlight.tags.operator).
    */ compareOperator: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$operator),
    /**
    [Operator](#highlight.tags.operator) that updates its operand.
    */ updateOperator: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$operator),
    /**
    [Operator](#highlight.tags.operator) that defines something.
    */ definitionOperator: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$operator),
    /**
    Type-related [operator](#highlight.tags.operator).
    */ typeOperator: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$operator),
    /**
    Control-flow [operator](#highlight.tags.operator).
    */ controlOperator: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$operator),
    punctuation: /**
    Program or markup punctuation.
    */ $a1ec9d683d365521$var$punctuation,
    /**
    [Punctuation](#highlight.tags.punctuation) that separates
    things.
    */ separator: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$punctuation),
    bracket: /**
    Bracket-style [punctuation](#highlight.tags.punctuation).
    */ $a1ec9d683d365521$var$bracket,
    /**
    Angle [brackets](#highlight.tags.bracket) (usually `<` and `>`
    tokens).
    */ angleBracket: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$bracket),
    /**
    Square [brackets](#highlight.tags.bracket) (usually `[` and `]`
    tokens).
    */ squareBracket: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$bracket),
    /**
    Parentheses (usually `(` and `)` tokens). Subtag of
    [bracket](#highlight.tags.bracket).
    */ paren: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$bracket),
    /**
    Braces (usually `{` and `}` tokens). Subtag of
    [bracket](#highlight.tags.bracket).
    */ brace: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$bracket),
    content: /**
    Content, for example plain text in XML or markup documents.
    */ $a1ec9d683d365521$var$content,
    heading: /**
    [Content](#highlight.tags.content) that represents a heading.
    */ $a1ec9d683d365521$var$heading,
    /**
    A level 1 [heading](#highlight.tags.heading).
    */ heading1: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$heading),
    /**
    A level 2 [heading](#highlight.tags.heading).
    */ heading2: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$heading),
    /**
    A level 3 [heading](#highlight.tags.heading).
    */ heading3: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$heading),
    /**
    A level 4 [heading](#highlight.tags.heading).
    */ heading4: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$heading),
    /**
    A level 5 [heading](#highlight.tags.heading).
    */ heading5: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$heading),
    /**
    A level 6 [heading](#highlight.tags.heading).
    */ heading6: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$heading),
    /**
    A prose [content](#highlight.tags.content) separator (such as a horizontal rule).
    */ contentSeparator: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$content),
    /**
    [Content](#highlight.tags.content) that represents a list.
    */ list: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$content),
    /**
    [Content](#highlight.tags.content) that represents a quote.
    */ quote: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$content),
    /**
    [Content](#highlight.tags.content) that is emphasized.
    */ emphasis: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$content),
    /**
    [Content](#highlight.tags.content) that is styled strong.
    */ strong: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$content),
    /**
    [Content](#highlight.tags.content) that is part of a link.
    */ link: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$content),
    /**
    [Content](#highlight.tags.content) that is styled as code or
    monospace.
    */ monospace: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$content),
    /**
    [Content](#highlight.tags.content) that has a strike-through
    style.
    */ strikethrough: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$content),
    /**
    Inserted text in a change-tracking format.
    */ inserted: $a1ec9d683d365521$var$t(),
    /**
    Deleted text.
    */ deleted: $a1ec9d683d365521$var$t(),
    /**
    Changed text.
    */ changed: $a1ec9d683d365521$var$t(),
    /**
    An invalid or unsyntactic element.
    */ invalid: $a1ec9d683d365521$var$t(),
    meta: /**
    Metadata or meta-instruction.
    */ $a1ec9d683d365521$var$meta,
    /**
    [Metadata](#highlight.tags.meta) that applies to the entire
    document.
    */ documentMeta: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$meta),
    /**
    [Metadata](#highlight.tags.meta) that annotates or adds
    attributes to a given syntactic element.
    */ annotation: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$meta),
    /**
    Processing instruction or preprocessor directive. Subtag of
    [meta](#highlight.tags.meta).
    */ processingInstruction: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$meta),
    /**
    [Modifier](#highlight.Tag^defineModifier) that indicates that a
    given element is being defined. Expected to be used with the
    various [name](#highlight.tags.name) tags.
    */ definition: $a1ec9d683d365521$export$3288d34c523a1192.defineModifier("definition"),
    /**
    [Modifier](#highlight.Tag^defineModifier) that indicates that
    something is constant. Mostly expected to be used with
    [variable names](#highlight.tags.variableName).
    */ constant: $a1ec9d683d365521$export$3288d34c523a1192.defineModifier("constant"),
    /**
    [Modifier](#highlight.Tag^defineModifier) used to indicate that
    a [variable](#highlight.tags.variableName) or [property
    name](#highlight.tags.propertyName) is being called or defined
    as a function.
    */ function: $a1ec9d683d365521$export$3288d34c523a1192.defineModifier("function"),
    /**
    [Modifier](#highlight.Tag^defineModifier) that can be applied to
    [names](#highlight.tags.name) to indicate that they belong to
    the language's standard environment.
    */ standard: $a1ec9d683d365521$export$3288d34c523a1192.defineModifier("standard"),
    /**
    [Modifier](#highlight.Tag^defineModifier) that indicates a given
    [names](#highlight.tags.name) is local to some scope.
    */ local: $a1ec9d683d365521$export$3288d34c523a1192.defineModifier("local"),
    /**
    A generic variant [modifier](#highlight.Tag^defineModifier) that
    can be used to tag language-specific alternative variants of
    some common tag. It is recommended for themes to define special
    forms of at least the [string](#highlight.tags.string) and
    [variable name](#highlight.tags.variableName) tags, since those
    come up a lot.
    */ special: $a1ec9d683d365521$export$3288d34c523a1192.defineModifier("special")
};
for(let name in $a1ec9d683d365521$export$8b7a896ae75accbf){
    let val = $a1ec9d683d365521$export$8b7a896ae75accbf[name];
    if (val instanceof $a1ec9d683d365521$export$3288d34c523a1192) val.name = name;
}
/**
This is a highlighter that adds stable, predictable classes to
tokens, for styling with external CSS.

The following tags are mapped to their name prefixed with `"tok-"`
(for example `"tok-comment"`):

* [`link`](#highlight.tags.link)
* [`heading`](#highlight.tags.heading)
* [`emphasis`](#highlight.tags.emphasis)
* [`strong`](#highlight.tags.strong)
* [`keyword`](#highlight.tags.keyword)
* [`atom`](#highlight.tags.atom)
* [`bool`](#highlight.tags.bool)
* [`url`](#highlight.tags.url)
* [`labelName`](#highlight.tags.labelName)
* [`inserted`](#highlight.tags.inserted)
* [`deleted`](#highlight.tags.deleted)
* [`literal`](#highlight.tags.literal)
* [`string`](#highlight.tags.string)
* [`number`](#highlight.tags.number)
* [`variableName`](#highlight.tags.variableName)
* [`typeName`](#highlight.tags.typeName)
* [`namespace`](#highlight.tags.namespace)
* [`className`](#highlight.tags.className)
* [`macroName`](#highlight.tags.macroName)
* [`propertyName`](#highlight.tags.propertyName)
* [`operator`](#highlight.tags.operator)
* [`comment`](#highlight.tags.comment)
* [`meta`](#highlight.tags.meta)
* [`punctuation`](#highlight.tags.punctuation)
* [`invalid`](#highlight.tags.invalid)

In addition, these mappings are provided:

* [`regexp`](#highlight.tags.regexp),
  [`escape`](#highlight.tags.escape), and
  [`special`](#highlight.tags.special)[`(string)`](#highlight.tags.string)
  are mapped to `"tok-string2"`
* [`special`](#highlight.tags.special)[`(variableName)`](#highlight.tags.variableName)
  to `"tok-variableName2"`
* [`local`](#highlight.tags.local)[`(variableName)`](#highlight.tags.variableName)
  to `"tok-variableName tok-local"`
* [`definition`](#highlight.tags.definition)[`(variableName)`](#highlight.tags.variableName)
  to `"tok-variableName tok-definition"`
* [`definition`](#highlight.tags.definition)[`(propertyName)`](#highlight.tags.propertyName)
  to `"tok-propertyName tok-definition"`
*/ const $a1ec9d683d365521$export$bf3ffb24fb17216c = $a1ec9d683d365521$export$b7f6332ce20f80fb([
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.link,
        class: "tok-link"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.heading,
        class: "tok-heading"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.emphasis,
        class: "tok-emphasis"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.strong,
        class: "tok-strong"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.keyword,
        class: "tok-keyword"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.atom,
        class: "tok-atom"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.bool,
        class: "tok-bool"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.url,
        class: "tok-url"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.labelName,
        class: "tok-labelName"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.inserted,
        class: "tok-inserted"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.deleted,
        class: "tok-deleted"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.literal,
        class: "tok-literal"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.string,
        class: "tok-string"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.number,
        class: "tok-number"
    },
    {
        tag: [
            $a1ec9d683d365521$export$8b7a896ae75accbf.regexp,
            $a1ec9d683d365521$export$8b7a896ae75accbf.escape,
            $a1ec9d683d365521$export$8b7a896ae75accbf.special($a1ec9d683d365521$export$8b7a896ae75accbf.string)
        ],
        class: "tok-string2"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.variableName,
        class: "tok-variableName"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.local($a1ec9d683d365521$export$8b7a896ae75accbf.variableName),
        class: "tok-variableName tok-local"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.definition($a1ec9d683d365521$export$8b7a896ae75accbf.variableName),
        class: "tok-variableName tok-definition"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.special($a1ec9d683d365521$export$8b7a896ae75accbf.variableName),
        class: "tok-variableName2"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.definition($a1ec9d683d365521$export$8b7a896ae75accbf.propertyName),
        class: "tok-propertyName tok-definition"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.typeName,
        class: "tok-typeName"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.namespace,
        class: "tok-namespace"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.className,
        class: "tok-className"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.macroName,
        class: "tok-macroName"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.propertyName,
        class: "tok-propertyName"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.operator,
        class: "tok-operator"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.comment,
        class: "tok-comment"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.meta,
        class: "tok-meta"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.invalid,
        class: "tok-invalid"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.punctuation,
        class: "tok-punctuation"
    }
]);



var $a97ccac5cf5f4f5d$var$_a;
/**
Node prop stored in a parser's top syntax node to provide the
facet that stores language-specific data for that language.
*/ const $a97ccac5cf5f4f5d$export$27a2e78097f753f7 = /*@__PURE__*/ new (0, $ed739beecf769914$export$b8034b9bc18acd90)();
/**
Helper function to define a facet (to be added to the top syntax
node(s) for a language via
[`languageDataProp`](https://codemirror.net/6/docs/ref/#language.languageDataProp)), that will be
used to associate language data with the language. You
probably only need this when subclassing
[`Language`](https://codemirror.net/6/docs/ref/#language.Language).
*/ function $a97ccac5cf5f4f5d$export$b57f683f43553b99(baseData) {
    return (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
        combine: baseData ? (values)=>values.concat(baseData) : undefined
    });
}
/**
Syntax node prop used to register sublanguages. Should be added to
the top level node type for the language.
*/ const $a97ccac5cf5f4f5d$export$4afc6f37514bbb67 = /*@__PURE__*/ new (0, $ed739beecf769914$export$b8034b9bc18acd90)();
/**
A language object manages parsing and per-language
[metadata](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt). Parse data is
managed as a [Lezer](https://lezer.codemirror.net) tree. The class
can be used directly, via the [`LRLanguage`](https://codemirror.net/6/docs/ref/#language.LRLanguage)
subclass for [Lezer](https://lezer.codemirror.net/) LR parsers, or
via the [`StreamLanguage`](https://codemirror.net/6/docs/ref/#language.StreamLanguage) subclass
for stream parsers.
*/ class $a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a {
    /**
    Construct a language object. If you need to invoke this
    directly, first define a data facet with
    [`defineLanguageFacet`](https://codemirror.net/6/docs/ref/#language.defineLanguageFacet), and then
    configure your parser to [attach](https://codemirror.net/6/docs/ref/#language.languageDataProp) it
    to the language's outer syntax node.
    */ constructor(/**
    The [language data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt) facet
    used for this language.
    */ data, parser, extraExtensions = [], /**
    A language name.
    */ name = ""){
        this.data = data;
        this.name = name;
        // Kludge to define EditorState.tree as a debugging helper,
        // without the EditorState package actually knowing about
        // languages and lezer trees.
        if (!(0, $6295c6875f57e3ee$export$afa855cbfaff27f2).prototype.hasOwnProperty("tree")) Object.defineProperty((0, $6295c6875f57e3ee$export$afa855cbfaff27f2).prototype, "tree", {
            get () {
                return $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1(this);
            }
        });
        this.parser = parser;
        this.extension = [
            $a97ccac5cf5f4f5d$export$789c912f57fe164c.of(this),
            (0, $6295c6875f57e3ee$export$afa855cbfaff27f2).languageData.of((state, pos, side)=>{
                let top = $a97ccac5cf5f4f5d$var$topNodeAt(state, pos, side), data = top.type.prop($a97ccac5cf5f4f5d$export$27a2e78097f753f7);
                if (!data) return [];
                let base = state.facet(data), sub = top.type.prop($a97ccac5cf5f4f5d$export$4afc6f37514bbb67);
                if (sub) {
                    let innerNode = top.resolve(pos - top.from, side);
                    for (let sublang of sub)if (sublang.test(innerNode, state)) {
                        let data = state.facet(sublang.facet);
                        return sublang.type == "replace" ? data : data.concat(base);
                    }
                }
                return base;
            })
        ].concat(extraExtensions);
    }
    /**
    Query whether this language is active at the given position.
    */ isActiveAt(state, pos, side = -1) {
        return $a97ccac5cf5f4f5d$var$topNodeAt(state, pos, side).type.prop($a97ccac5cf5f4f5d$export$27a2e78097f753f7) == this.data;
    }
    /**
    Find the document regions that were parsed using this language.
    The returned regions will _include_ any nested languages rooted
    in this language, when those exist.
    */ findRegions(state) {
        let lang = state.facet($a97ccac5cf5f4f5d$export$789c912f57fe164c);
        if ((lang === null || lang === void 0 ? void 0 : lang.data) == this.data) return [
            {
                from: 0,
                to: state.doc.length
            }
        ];
        if (!lang || !lang.allowsNesting) return [];
        let result = [];
        let explore = (tree, from)=>{
            if (tree.prop($a97ccac5cf5f4f5d$export$27a2e78097f753f7) == this.data) {
                result.push({
                    from: from,
                    to: from + tree.length
                });
                return;
            }
            let mount = tree.prop((0, $ed739beecf769914$export$b8034b9bc18acd90).mounted);
            if (mount) {
                if (mount.tree.prop($a97ccac5cf5f4f5d$export$27a2e78097f753f7) == this.data) {
                    if (mount.overlay) for (let r of mount.overlay)result.push({
                        from: r.from + from,
                        to: r.to + from
                    });
                    else result.push({
                        from: from,
                        to: from + tree.length
                    });
                    return;
                } else if (mount.overlay) {
                    let size = result.length;
                    explore(mount.tree, mount.overlay[0].from + from);
                    if (result.length > size) return;
                }
            }
            for(let i = 0; i < tree.children.length; i++){
                let ch = tree.children[i];
                if (ch instanceof (0, $ed739beecf769914$export$7fbedc92909ed28e)) explore(ch, tree.positions[i] + from);
            }
        };
        explore($a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1(state), 0);
        return result;
    }
    /**
    Indicates whether this language allows nested languages. The
    default implementation returns true.
    */ get allowsNesting() {
        return true;
    }
}
/**
@internal
*/ $a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a.setState = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
function $a97ccac5cf5f4f5d$var$topNodeAt(state, pos, side) {
    let topLang = state.facet($a97ccac5cf5f4f5d$export$789c912f57fe164c), tree = $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1(state).topNode;
    if (!topLang || topLang.allowsNesting) {
        for(let node = tree; node; node = node.enter(pos, side, (0, $ed739beecf769914$export$b0e28367f55837aa).ExcludeBuffers | (0, $ed739beecf769914$export$b0e28367f55837aa).EnterBracketed))if (node.type.isTop) tree = node;
    }
    return tree;
}
/**
A subclass of [`Language`](https://codemirror.net/6/docs/ref/#language.Language) for use with Lezer
[LR parsers](https://lezer.codemirror.net/docs/ref#lr.LRParser)
parsers.
*/ class $a97ccac5cf5f4f5d$export$b243968d9fb6db03 extends $a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a {
    constructor(data, parser, name){
        super(data, parser, [], name);
        this.parser = parser;
    }
    /**
    Define a language from a parser.
    */ static define(spec) {
        let data = $a97ccac5cf5f4f5d$export$b57f683f43553b99(spec.languageData);
        return new $a97ccac5cf5f4f5d$export$b243968d9fb6db03(data, spec.parser.configure({
            props: [
                $a97ccac5cf5f4f5d$export$27a2e78097f753f7.add((type)=>type.isTop ? data : undefined)
            ]
        }), spec.name);
    }
    /**
    Create a new instance of this language with a reconfigured
    version of its parser and optionally a new name.
    */ configure(options, name) {
        return new $a97ccac5cf5f4f5d$export$b243968d9fb6db03(this.data, this.parser.configure(options), name || this.name);
    }
    get allowsNesting() {
        return this.parser.hasWrappers();
    }
}
/**
Get the syntax tree for a state, which is the current (possibly
incomplete) parse tree of the active
[language](https://codemirror.net/6/docs/ref/#language.Language), or the empty tree if there is no
language available.
*/ function $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1(state) {
    let field = state.field($a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a.state, false);
    return field ? field.tree : (0, $ed739beecf769914$export$7fbedc92909ed28e).empty;
}
/**
Try to get a parse tree that spans at least up to `upto`. The
method will do at most `timeout` milliseconds of work to parse
up to that point if the tree isn't already available.
*/ function $a97ccac5cf5f4f5d$export$8694796f3a52e973(state, upto, timeout = 50) {
    var _a;
    let parse = (_a = state.field($a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a.state, false)) === null || _a === void 0 ? void 0 : _a.context;
    if (!parse) return null;
    let oldVieport = parse.viewport;
    parse.updateViewport({
        from: 0,
        to: upto
    });
    let result = parse.isDone(upto) || parse.work(timeout, upto) ? parse.tree : null;
    parse.updateViewport(oldVieport);
    return result;
}
/**
Queries whether there is a full syntax tree available up to the
given document position. If there isn't, the background parse
process _might_ still be working and update the tree further, but
there is no guarantee of that—the parser will [stop
working](https://codemirror.net/6/docs/ref/#language.syntaxParserRunning) when it has spent a
certain amount of time or has moved beyond the visible viewport.
Always returns false if no language has been enabled.
*/ function $a97ccac5cf5f4f5d$export$2c95b013b0941e86(state, upto = state.doc.length) {
    var _a;
    return ((_a = state.field($a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a.state, false)) === null || _a === void 0 ? void 0 : _a.context.isDone(upto)) || false;
}
/**
Move parsing forward, and update the editor state afterwards to
reflect the new tree. Will work for at most `timeout`
milliseconds. Returns true if the parser managed get to the given
position in that time.
*/ function $a97ccac5cf5f4f5d$export$b3bcb61c35026d72(view, upto = view.viewport.to, timeout = 100) {
    let success = $a97ccac5cf5f4f5d$export$8694796f3a52e973(view.state, upto, timeout);
    if (success != $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1(view.state)) view.dispatch({});
    return !!success;
}
/**
Tells you whether the language parser is planning to do more
parsing work (in a `requestIdleCallback` pseudo-thread) or has
stopped running, either because it parsed the entire document,
because it spent too much time and was cut off, or because there
is no language parser enabled.
*/ function $a97ccac5cf5f4f5d$export$23c0ee92d6189d3f(view) {
    var _a;
    return ((_a = view.plugin($a97ccac5cf5f4f5d$var$parseWorker)) === null || _a === void 0 ? void 0 : _a.isWorking()) || false;
}
/**
Lezer-style
[`Input`](https://lezer.codemirror.net/docs/ref#common.Input)
object for a [`Text`](https://codemirror.net/6/docs/ref/#state.Text) object.
*/ class $a97ccac5cf5f4f5d$export$78c262ab5af874ad {
    /**
    Create an input object for the given document.
    */ constructor(doc){
        this.doc = doc;
        this.cursorPos = 0;
        this.string = "";
        this.cursor = doc.iter();
    }
    get length() {
        return this.doc.length;
    }
    syncTo(pos) {
        this.string = this.cursor.next(pos - this.cursorPos).value;
        this.cursorPos = pos + this.string.length;
        return this.cursorPos - this.string.length;
    }
    chunk(pos) {
        this.syncTo(pos);
        return this.string;
    }
    get lineChunks() {
        return true;
    }
    read(from, to) {
        let stringStart = this.cursorPos - this.string.length;
        if (from < stringStart || to >= this.cursorPos) return this.doc.sliceString(from, to);
        else return this.string.slice(from - stringStart, to - stringStart);
    }
}
let $a97ccac5cf5f4f5d$var$currentContext = null;
/**
A parse context provided to parsers working on the editor content.
*/ class $a97ccac5cf5f4f5d$export$3fcb7c01ff2a41fa {
    constructor(parser, /**
    The current editor state.
    */ state, /**
    Tree fragments that can be reused by incremental re-parses.
    */ fragments = [], /**
    @internal
    */ tree, /**
    @internal
    */ treeLen, /**
    The current editor viewport (or some overapproximation
    thereof). Intended to be used for opportunistically avoiding
    work (in which case
    [`skipUntilInView`](https://codemirror.net/6/docs/ref/#language.ParseContext.skipUntilInView)
    should be called to make sure the parser is restarted when the
    skipped region becomes visible).
    */ viewport, /**
    @internal
    */ skipped, /**
    This is where skipping parsers can register a promise that,
    when resolved, will schedule a new parse. It is cleared when
    the parse worker picks up the promise. @internal
    */ scheduleOn){
        this.parser = parser;
        this.state = state;
        this.fragments = fragments;
        this.tree = tree;
        this.treeLen = treeLen;
        this.viewport = viewport;
        this.skipped = skipped;
        this.scheduleOn = scheduleOn;
        this.parse = null;
        /**
        @internal
        */ this.tempSkipped = [];
    }
    /**
    @internal
    */ static create(parser, state, viewport) {
        return new $a97ccac5cf5f4f5d$export$3fcb7c01ff2a41fa(parser, state, [], (0, $ed739beecf769914$export$7fbedc92909ed28e).empty, 0, viewport, [], null);
    }
    startParse() {
        return this.parser.startParse(new $a97ccac5cf5f4f5d$export$78c262ab5af874ad(this.state.doc), this.fragments);
    }
    /**
    @internal
    */ work(until, upto) {
        if (upto != null && upto >= this.state.doc.length) upto = undefined;
        if (this.tree != (0, $ed739beecf769914$export$7fbedc92909ed28e).empty && this.isDone(upto !== null && upto !== void 0 ? upto : this.state.doc.length)) {
            this.takeTree();
            return true;
        }
        return this.withContext(()=>{
            var _a;
            if (typeof until == "number") {
                let endTime = Date.now() + until;
                until = ()=>Date.now() > endTime;
            }
            if (!this.parse) this.parse = this.startParse();
            if (upto != null && (this.parse.stoppedAt == null || this.parse.stoppedAt > upto) && upto < this.state.doc.length) this.parse.stopAt(upto);
            for(;;){
                let done = this.parse.advance();
                if (done) {
                    this.fragments = this.withoutTempSkipped((0, $ed739beecf769914$export$3ae2ede6dca97077).addTree(done, this.fragments, this.parse.stoppedAt != null));
                    this.treeLen = (_a = this.parse.stoppedAt) !== null && _a !== void 0 ? _a : this.state.doc.length;
                    this.tree = done;
                    this.parse = null;
                    if (this.treeLen < (upto !== null && upto !== void 0 ? upto : this.state.doc.length)) this.parse = this.startParse();
                    else return true;
                }
                if (until()) return false;
            }
        });
    }
    /**
    @internal
    */ takeTree() {
        let pos, tree;
        if (this.parse && (pos = this.parse.parsedPos) >= this.treeLen) {
            if (this.parse.stoppedAt == null || this.parse.stoppedAt > pos) this.parse.stopAt(pos);
            this.withContext(()=>{
                while(!(tree = this.parse.advance()));
            });
            this.treeLen = pos;
            this.tree = tree;
            this.fragments = this.withoutTempSkipped((0, $ed739beecf769914$export$3ae2ede6dca97077).addTree(this.tree, this.fragments, true));
            this.parse = null;
        }
    }
    withContext(f) {
        let prev = $a97ccac5cf5f4f5d$var$currentContext;
        $a97ccac5cf5f4f5d$var$currentContext = this;
        try {
            return f();
        } finally{
            $a97ccac5cf5f4f5d$var$currentContext = prev;
        }
    }
    withoutTempSkipped(fragments) {
        for(let r; r = this.tempSkipped.pop();)fragments = $a97ccac5cf5f4f5d$var$cutFragments(fragments, r.from, r.to);
        return fragments;
    }
    /**
    @internal
    */ changes(changes, newState) {
        let { fragments: fragments, tree: tree, treeLen: treeLen, viewport: viewport, skipped: skipped } = this;
        this.takeTree();
        if (!changes.empty) {
            let ranges = [];
            changes.iterChangedRanges((fromA, toA, fromB, toB)=>ranges.push({
                    fromA: fromA,
                    toA: toA,
                    fromB: fromB,
                    toB: toB
                }));
            fragments = (0, $ed739beecf769914$export$3ae2ede6dca97077).applyChanges(fragments, ranges);
            tree = (0, $ed739beecf769914$export$7fbedc92909ed28e).empty;
            treeLen = 0;
            viewport = {
                from: changes.mapPos(viewport.from, -1),
                to: changes.mapPos(viewport.to, 1)
            };
            if (this.skipped.length) {
                skipped = [];
                for (let r of this.skipped){
                    let from = changes.mapPos(r.from, 1), to = changes.mapPos(r.to, -1);
                    if (from < to) skipped.push({
                        from: from,
                        to: to
                    });
                }
            }
        }
        return new $a97ccac5cf5f4f5d$export$3fcb7c01ff2a41fa(this.parser, newState, fragments, tree, treeLen, viewport, skipped, this.scheduleOn);
    }
    /**
    @internal
    */ updateViewport(viewport) {
        if (this.viewport.from == viewport.from && this.viewport.to == viewport.to) return false;
        this.viewport = viewport;
        let startLen = this.skipped.length;
        for(let i = 0; i < this.skipped.length; i++){
            let { from: from, to: to } = this.skipped[i];
            if (from < viewport.to && to > viewport.from) {
                this.fragments = $a97ccac5cf5f4f5d$var$cutFragments(this.fragments, from, to);
                this.skipped.splice(i--, 1);
            }
        }
        if (this.skipped.length >= startLen) return false;
        this.reset();
        return true;
    }
    /**
    @internal
    */ reset() {
        if (this.parse) {
            this.takeTree();
            this.parse = null;
        }
    }
    /**
    Notify the parse scheduler that the given region was skipped
    because it wasn't in view, and the parse should be restarted
    when it comes into view.
    */ skipUntilInView(from, to) {
        this.skipped.push({
            from: from,
            to: to
        });
    }
    /**
    Returns a parser intended to be used as placeholder when
    asynchronously loading a nested parser. It'll skip its input and
    mark it as not-really-parsed, so that the next update will parse
    it again.
    
    When `until` is given, a reparse will be scheduled when that
    promise resolves.
    */ static getSkippingParser(until) {
        return new class extends (0, $ed739beecf769914$export$7acfa6ed01010e37) {
            createParse(input, fragments, ranges) {
                let from = ranges[0].from, to = ranges[ranges.length - 1].to;
                let parser = {
                    parsedPos: from,
                    advance () {
                        let cx = $a97ccac5cf5f4f5d$var$currentContext;
                        if (cx) {
                            for (let r of ranges)cx.tempSkipped.push(r);
                            if (until) cx.scheduleOn = cx.scheduleOn ? Promise.all([
                                cx.scheduleOn,
                                until
                            ]) : until;
                        }
                        this.parsedPos = to;
                        return new (0, $ed739beecf769914$export$7fbedc92909ed28e)((0, $ed739beecf769914$export$f06e977173f1857c).none, [], [], to - from);
                    },
                    stoppedAt: null,
                    stopAt () {}
                };
                return parser;
            }
        };
    }
    /**
    @internal
    */ isDone(upto) {
        upto = Math.min(upto, this.state.doc.length);
        let frags = this.fragments;
        return this.treeLen >= upto && frags.length && frags[0].from == 0 && frags[0].to >= upto;
    }
    /**
    Get the context for the current parse, or `null` if no editor
    parse is in progress.
    */ static get() {
        return $a97ccac5cf5f4f5d$var$currentContext;
    }
}
function $a97ccac5cf5f4f5d$var$cutFragments(fragments, from, to) {
    return (0, $ed739beecf769914$export$3ae2ede6dca97077).applyChanges(fragments, [
        {
            fromA: from,
            toA: to,
            fromB: from,
            toB: to
        }
    ]);
}
class $a97ccac5cf5f4f5d$var$LanguageState {
    constructor(// A mutable parse state that is used to preserve work done during
    // the lifetime of a state when moving to the next state.
    context){
        this.context = context;
        this.tree = context.tree;
    }
    apply(tr) {
        if (!tr.docChanged && this.tree == this.context.tree) return this;
        let newCx = this.context.changes(tr.changes, tr.state);
        // If the previous parse wasn't done, go forward only up to its
        // end position or the end of the viewport, to avoid slowing down
        // state updates with parse work beyond the viewport.
        let upto = this.context.treeLen == tr.startState.doc.length ? undefined : Math.max(tr.changes.mapPos(this.context.treeLen), newCx.viewport.to);
        if (!newCx.work(20 /* Work.Apply */ , upto)) newCx.takeTree();
        return new $a97ccac5cf5f4f5d$var$LanguageState(newCx);
    }
    static init(state) {
        let vpTo = Math.min(3000 /* Work.InitViewport */ , state.doc.length);
        let parseState = $a97ccac5cf5f4f5d$export$3fcb7c01ff2a41fa.create(state.facet($a97ccac5cf5f4f5d$export$789c912f57fe164c).parser, state, {
            from: 0,
            to: vpTo
        });
        if (!parseState.work(20 /* Work.Apply */ , vpTo)) parseState.takeTree();
        return new $a97ccac5cf5f4f5d$var$LanguageState(parseState);
    }
}
$a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a.state = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$34381b1ce2130245).define({
    create: $a97ccac5cf5f4f5d$var$LanguageState.init,
    update (value, tr) {
        for (let e of tr.effects)if (e.is($a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a.setState)) return e.value;
        if (tr.startState.facet($a97ccac5cf5f4f5d$export$789c912f57fe164c) != tr.state.facet($a97ccac5cf5f4f5d$export$789c912f57fe164c)) return $a97ccac5cf5f4f5d$var$LanguageState.init(tr.state);
        return value.apply(tr);
    }
});
let $a97ccac5cf5f4f5d$var$requestIdle = (callback)=>{
    let timeout = setTimeout(()=>callback(), 500 /* Work.MaxPause */ );
    return ()=>clearTimeout(timeout);
};
if (typeof requestIdleCallback != "undefined") $a97ccac5cf5f4f5d$var$requestIdle = (callback)=>{
    let idle = -1, timeout = setTimeout(()=>{
        idle = requestIdleCallback(callback, {
            timeout: 400 /* Work.MinPause */ 
        });
    }, 100 /* Work.MinPause */ );
    return ()=>idle < 0 ? clearTimeout(timeout) : cancelIdleCallback(idle);
};
const $a97ccac5cf5f4f5d$var$isInputPending = typeof navigator != "undefined" && (($a97ccac5cf5f4f5d$var$_a = navigator.scheduling) === null || $a97ccac5cf5f4f5d$var$_a === void 0 ? void 0 : $a97ccac5cf5f4f5d$var$_a.isInputPending) ? ()=>navigator.scheduling.isInputPending() : null;
const $a97ccac5cf5f4f5d$var$parseWorker = /*@__PURE__*/ (0, $7beee9608540d2c3$export$44d5eccfd62adda7).fromClass(class ParseWorker {
    constructor(view){
        this.view = view;
        this.working = null;
        this.workScheduled = 0;
        // End of the current time chunk
        this.chunkEnd = -1;
        // Milliseconds of budget left for this chunk
        this.chunkBudget = -1;
        this.work = this.work.bind(this);
        this.scheduleWork();
    }
    update(update) {
        let cx = this.view.state.field($a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a.state).context;
        if (cx.updateViewport(update.view.viewport) || this.view.viewport.to > cx.treeLen) this.scheduleWork();
        if (update.docChanged || update.selectionSet) {
            if (this.view.hasFocus) this.chunkBudget += 50 /* Work.ChangeBonus */ ;
            this.scheduleWork();
        }
        this.checkAsyncSchedule(cx);
    }
    scheduleWork() {
        if (this.working) return;
        let { state: state } = this.view, field = state.field($a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a.state);
        if (field.tree != field.context.tree || !field.context.isDone(state.doc.length)) this.working = $a97ccac5cf5f4f5d$var$requestIdle(this.work);
    }
    work(deadline) {
        this.working = null;
        let now = Date.now();
        if (this.chunkEnd < now && (this.chunkEnd < 0 || this.view.hasFocus)) {
            this.chunkEnd = now + 30000 /* Work.ChunkTime */ ;
            this.chunkBudget = 3000 /* Work.ChunkBudget */ ;
        }
        if (this.chunkBudget <= 0) return; // No more budget
        let { state: state, viewport: { to: vpTo } } = this.view, field = state.field($a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a.state);
        if (field.tree == field.context.tree && field.context.isDone(vpTo + 100000 /* Work.MaxParseAhead */ )) return;
        let endTime = Date.now() + Math.min(this.chunkBudget, 100 /* Work.Slice */ , deadline && !$a97ccac5cf5f4f5d$var$isInputPending ? Math.max(25 /* Work.MinSlice */ , deadline.timeRemaining() - 5) : 1e9);
        let viewportFirst = field.context.treeLen < vpTo && state.doc.length > vpTo + 1000;
        let done = field.context.work(()=>{
            return $a97ccac5cf5f4f5d$var$isInputPending && $a97ccac5cf5f4f5d$var$isInputPending() || Date.now() > endTime;
        }, vpTo + (viewportFirst ? 0 : 100000 /* Work.MaxParseAhead */ ));
        this.chunkBudget -= Date.now() - now;
        if (done || this.chunkBudget <= 0) {
            field.context.takeTree();
            this.view.dispatch({
                effects: $a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a.setState.of(new $a97ccac5cf5f4f5d$var$LanguageState(field.context))
            });
        }
        if (this.chunkBudget > 0 && !(done && !viewportFirst)) this.scheduleWork();
        this.checkAsyncSchedule(field.context);
    }
    checkAsyncSchedule(cx) {
        if (cx.scheduleOn) {
            this.workScheduled++;
            cx.scheduleOn.then(()=>this.scheduleWork()).catch((err)=>(0, $7beee9608540d2c3$export$f86b2a1a2ce291b3)(this.view.state, err)).then(()=>this.workScheduled--);
            cx.scheduleOn = null;
        }
    }
    destroy() {
        if (this.working) this.working();
    }
    isWorking() {
        return !!(this.working || this.workScheduled > 0);
    }
}, {
    eventHandlers: {
        focus () {
            this.scheduleWork();
        }
    }
});
/**
The facet used to associate a language with an editor state. Used
by `Language` object's `extension` property (so you don't need to
manually wrap your languages in this). Can be used to access the
current language on a state.
*/ const $a97ccac5cf5f4f5d$export$789c912f57fe164c = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (languages) {
        return languages.length ? languages[0] : null;
    },
    enables: (language)=>[
            $a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a.state,
            $a97ccac5cf5f4f5d$var$parseWorker,
            (0, $7beee9608540d2c3$export$eece2fccabbb77c5).contentAttributes.compute([
                language
            ], (state)=>{
                let lang = state.facet(language);
                return lang && lang.name ? {
                    "data-language": lang.name
                } : {};
            })
        ]
});
/**
This class bundles a [language](https://codemirror.net/6/docs/ref/#language.Language) with an
optional set of supporting extensions. Language packages are
encouraged to export a function that optionally takes a
configuration object and returns a `LanguageSupport` instance, as
the main way for client code to use the package.
*/ class $a97ccac5cf5f4f5d$export$cbdefefa8a51dd3b {
    /**
    Create a language support object.
    */ constructor(/**
    The language object.
    */ language, /**
    An optional set of supporting extensions. When nesting a
    language in another language, the outer language is encouraged
    to include the supporting extensions for its inner languages
    in its own set of support extensions.
    */ support = []){
        this.language = language;
        this.support = support;
        this.extension = [
            language,
            support
        ];
    }
}
/**
Language descriptions are used to store metadata about languages
and to dynamically load them. Their main role is finding the
appropriate language for a filename or dynamically loading nested
parsers.
*/ class $a97ccac5cf5f4f5d$export$50ab82debf88f71 {
    constructor(/**
    The name of this language.
    */ name, /**
    Alternative names for the mode (lowercased, includes `this.name`).
    */ alias, /**
    File extensions associated with this language.
    */ extensions, /**
    Optional filename pattern that should be associated with this
    language.
    */ filename, loadFunc, /**
    If the language has been loaded, this will hold its value.
    */ support){
        this.name = name;
        this.alias = alias;
        this.extensions = extensions;
        this.filename = filename;
        this.loadFunc = loadFunc;
        this.support = support;
        this.loading = null;
    }
    /**
    Start loading the the language. Will return a promise that
    resolves to a [`LanguageSupport`](https://codemirror.net/6/docs/ref/#language.LanguageSupport)
    object when the language successfully loads.
    */ load() {
        return this.loading || (this.loading = this.loadFunc().then((support)=>this.support = support, (err)=>{
            this.loading = null;
            throw err;
        }));
    }
    /**
    Create a language description.
    */ static of(spec) {
        let { load: load, support: support } = spec;
        if (!load) {
            if (!support) throw new RangeError("Must pass either 'load' or 'support' to LanguageDescription.of");
            load = ()=>Promise.resolve(support);
        }
        return new $a97ccac5cf5f4f5d$export$50ab82debf88f71(spec.name, (spec.alias || []).concat(spec.name).map((s)=>s.toLowerCase()), spec.extensions || [], spec.filename, load, support);
    }
    /**
    Look for a language in the given array of descriptions that
    matches the filename. Will first match
    [`filename`](https://codemirror.net/6/docs/ref/#language.LanguageDescription.filename) patterns,
    and then [extensions](https://codemirror.net/6/docs/ref/#language.LanguageDescription.extensions),
    and return the first language that matches.
    */ static matchFilename(descs, filename) {
        for (let d of descs)if (d.filename && d.filename.test(filename)) return d;
        let ext = /\.([^.]+)$/.exec(filename);
        if (ext) {
            for (let d of descs)if (d.extensions.indexOf(ext[1]) > -1) return d;
        }
        return null;
    }
    /**
    Look for a language whose name or alias matches the the given
    name (case-insensitively). If `fuzzy` is true, and no direct
    matchs is found, this'll also search for a language whose name
    or alias occurs in the string (for names shorter than three
    characters, only when surrounded by non-word characters).
    */ static matchLanguageName(descs, name, fuzzy = true) {
        name = name.toLowerCase();
        for (let d of descs)if (d.alias.some((a)=>a == name)) return d;
        if (fuzzy) for (let d of descs)for (let a of d.alias){
            let found = name.indexOf(a);
            if (found > -1 && (a.length > 2 || !/\w/.test(name[found - 1]) && !/\w/.test(name[found + a.length]))) return d;
        }
        return null;
    }
}
/**
Facet that defines a way to provide a function that computes the
appropriate indentation depth, as a column number (see
[`indentString`](https://codemirror.net/6/docs/ref/#language.indentString)), at the start of a given
line. A return value of `null` indicates no indentation can be
determined, and the line should inherit the indentation of the one
above it. A return value of `undefined` defers to the next indent
service.
*/ const $a97ccac5cf5f4f5d$export$5952625dce50d1f3 = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
/**
Facet for overriding the unit by which indentation happens. Should
be a string consisting entirely of the same whitespace character.
When not set, this defaults to 2 spaces.
*/ const $a97ccac5cf5f4f5d$export$9e0d0c2ce4d3ceb5 = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine: (values)=>{
        if (!values.length) return "  ";
        let unit = values[0];
        if (!unit || /\S/.test(unit) || Array.from(unit).some((e)=>e != unit[0])) throw new Error("Invalid indent unit: " + JSON.stringify(values[0]));
        return unit;
    }
});
/**
Return the _column width_ of an indent unit in the state.
Determined by the [`indentUnit`](https://codemirror.net/6/docs/ref/#language.indentUnit)
facet, and [`tabSize`](https://codemirror.net/6/docs/ref/#state.EditorState^tabSize) when that
contains tabs.
*/ function $a97ccac5cf5f4f5d$export$ad3205d09311a797(state) {
    let unit = state.facet($a97ccac5cf5f4f5d$export$9e0d0c2ce4d3ceb5);
    return unit.charCodeAt(0) == 9 ? state.tabSize * unit.length : unit.length;
}
/**
Create an indentation string that covers columns 0 to `cols`.
Will use tabs for as much of the columns as possible when the
[`indentUnit`](https://codemirror.net/6/docs/ref/#language.indentUnit) facet contains
tabs.
*/ function $a97ccac5cf5f4f5d$export$db5a40e207b40576(state, cols) {
    let result = "", ts = state.tabSize, ch = state.facet($a97ccac5cf5f4f5d$export$9e0d0c2ce4d3ceb5)[0];
    if (ch == "\t") {
        while(cols >= ts){
            result += "\t";
            cols -= ts;
        }
        ch = " ";
    }
    for(let i = 0; i < cols; i++)result += ch;
    return result;
}
/**
Get the indentation, as a column number, at the given position.
Will first consult any [indent services](https://codemirror.net/6/docs/ref/#language.indentService)
that are registered, and if none of those return an indentation,
this will check the syntax tree for the [indent node
prop](https://codemirror.net/6/docs/ref/#language.indentNodeProp) and use that if found. Returns a
number when an indentation could be determined, and null
otherwise.
*/ function $a97ccac5cf5f4f5d$export$a2d3c9dbce6d2211(context, pos) {
    if (context instanceof (0, $6295c6875f57e3ee$export$afa855cbfaff27f2)) context = new $a97ccac5cf5f4f5d$export$eeab79349cc2f7c8(context);
    for (let service of context.state.facet($a97ccac5cf5f4f5d$export$5952625dce50d1f3)){
        let result = service(context, pos);
        if (result !== undefined) return result;
    }
    let tree = $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1(context.state);
    return tree.length >= pos ? $a97ccac5cf5f4f5d$var$syntaxIndentation(context, tree, pos) : null;
}
/**
Create a change set that auto-indents all lines touched by the
given document range.
*/ function $a97ccac5cf5f4f5d$export$2fc72a4ad8b85e40(state, from, to) {
    let updated = Object.create(null);
    let context = new $a97ccac5cf5f4f5d$export$eeab79349cc2f7c8(state, {
        overrideIndentation: (start)=>{
            var _a;
            return (_a = updated[start]) !== null && _a !== void 0 ? _a : -1;
        }
    });
    let changes = [];
    for(let pos = from; pos <= to;){
        let line = state.doc.lineAt(pos);
        pos = line.to + 1;
        let indent = $a97ccac5cf5f4f5d$export$a2d3c9dbce6d2211(context, line.from);
        if (indent == null) continue;
        if (!/\S/.test(line.text)) indent = 0;
        let cur = /^\s*/.exec(line.text)[0];
        let norm = $a97ccac5cf5f4f5d$export$db5a40e207b40576(state, indent);
        if (cur != norm) {
            updated[line.from] = indent;
            changes.push({
                from: line.from,
                to: line.from + cur.length,
                insert: norm
            });
        }
    }
    return state.changes(changes);
}
/**
Indentation contexts are used when calling [indentation
services](https://codemirror.net/6/docs/ref/#language.indentService). They provide helper utilities
useful in indentation logic, and can selectively override the
indentation reported for some lines.
*/ class $a97ccac5cf5f4f5d$export$eeab79349cc2f7c8 {
    /**
    Create an indent context.
    */ constructor(/**
    The editor state.
    */ state, /**
    @internal
    */ options = {}){
        this.state = state;
        this.options = options;
        this.unit = $a97ccac5cf5f4f5d$export$ad3205d09311a797(state);
    }
    /**
    Get a description of the line at the given position, taking
    [simulated line
    breaks](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
    into account. If there is such a break at `pos`, the `bias`
    argument determines whether the part of the line line before or
    after the break is used.
    */ lineAt(pos, bias = 1) {
        let line = this.state.doc.lineAt(pos);
        let { simulateBreak: simulateBreak, simulateDoubleBreak: simulateDoubleBreak } = this.options;
        if (simulateBreak != null && simulateBreak >= line.from && simulateBreak <= line.to) {
            if (simulateDoubleBreak && simulateBreak == pos) return {
                text: "",
                from: pos
            };
            else if (bias < 0 ? simulateBreak < pos : simulateBreak <= pos) return {
                text: line.text.slice(simulateBreak - line.from),
                from: simulateBreak
            };
            else return {
                text: line.text.slice(0, simulateBreak - line.from),
                from: line.from
            };
        }
        return line;
    }
    /**
    Get the text directly after `pos`, either the entire line
    or the next 100 characters, whichever is shorter.
    */ textAfterPos(pos, bias = 1) {
        if (this.options.simulateDoubleBreak && pos == this.options.simulateBreak) return "";
        let { text: text, from: from } = this.lineAt(pos, bias);
        return text.slice(pos - from, Math.min(text.length, pos + 100 - from));
    }
    /**
    Find the column for the given position.
    */ column(pos, bias = 1) {
        let { text: text, from: from } = this.lineAt(pos, bias);
        let result = this.countColumn(text, pos - from);
        let override = this.options.overrideIndentation ? this.options.overrideIndentation(from) : -1;
        if (override > -1) result += override - this.countColumn(text, text.search(/\S|$/));
        return result;
    }
    /**
    Find the column position (taking tabs into account) of the given
    position in the given string.
    */ countColumn(line, pos = line.length) {
        return (0, $6295c6875f57e3ee$export$20b4ab289374d0ac)(line, this.state.tabSize, pos);
    }
    /**
    Find the indentation column of the line at the given point.
    */ lineIndent(pos, bias = 1) {
        let { text: text, from: from } = this.lineAt(pos, bias);
        let override = this.options.overrideIndentation;
        if (override) {
            let overriden = override(from);
            if (overriden > -1) return overriden;
        }
        return this.countColumn(text, text.search(/\S|$/));
    }
    /**
    Returns the [simulated line
    break](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
    for this context, if any.
    */ get simulatedBreak() {
        return this.options.simulateBreak || null;
    }
}
/**
A syntax tree node prop used to associate indentation strategies
with node types. Such a strategy is a function from an indentation
context to a column number (see also
[`indentString`](https://codemirror.net/6/docs/ref/#language.indentString)) or null, where null
indicates that no definitive indentation can be determined.
*/ const $a97ccac5cf5f4f5d$export$72c7d4c52b3c6460 = /*@__PURE__*/ new (0, $ed739beecf769914$export$b8034b9bc18acd90)();
// Compute the indentation for a given position from the syntax tree.
function $a97ccac5cf5f4f5d$var$syntaxIndentation(cx, ast, pos) {
    let stack = ast.resolveStack(pos);
    let inner = ast.resolveInner(pos, -1).resolve(pos, 0).enterUnfinishedNodesBefore(pos);
    if (inner != stack.node) {
        let add = [];
        for(let cur = inner; cur && !(cur.from < stack.node.from || cur.to > stack.node.to || cur.from == stack.node.from && cur.type == stack.node.type); cur = cur.parent)add.push(cur);
        for(let i = add.length - 1; i >= 0; i--)stack = {
            node: add[i],
            next: stack
        };
    }
    return $a97ccac5cf5f4f5d$var$indentFor(stack, cx, pos);
}
function $a97ccac5cf5f4f5d$var$indentFor(stack, cx, pos) {
    for(let cur = stack; cur; cur = cur.next){
        let strategy = $a97ccac5cf5f4f5d$var$indentStrategy(cur.node);
        if (strategy) return strategy($a97ccac5cf5f4f5d$export$8aaeb0848a33f7c3.create(cx, pos, cur));
    }
    return 0;
}
function $a97ccac5cf5f4f5d$var$ignoreClosed(cx) {
    return cx.pos == cx.options.simulateBreak && cx.options.simulateDoubleBreak;
}
function $a97ccac5cf5f4f5d$var$indentStrategy(tree) {
    let strategy = tree.type.prop($a97ccac5cf5f4f5d$export$72c7d4c52b3c6460);
    if (strategy) return strategy;
    let first = tree.firstChild, close;
    if (first && (close = first.type.prop((0, $ed739beecf769914$export$b8034b9bc18acd90).closedBy))) {
        let last = tree.lastChild, closed = last && close.indexOf(last.name) > -1;
        return (cx)=>$a97ccac5cf5f4f5d$var$delimitedStrategy(cx, true, 1, undefined, closed && !$a97ccac5cf5f4f5d$var$ignoreClosed(cx) ? last.from : undefined);
    }
    return tree.parent == null ? $a97ccac5cf5f4f5d$var$topIndent : null;
}
function $a97ccac5cf5f4f5d$var$topIndent() {
    return 0;
}
/**
Objects of this type provide context information and helper
methods to indentation functions registered on syntax nodes.
*/ class $a97ccac5cf5f4f5d$export$8aaeb0848a33f7c3 extends $a97ccac5cf5f4f5d$export$eeab79349cc2f7c8 {
    constructor(base, /**
    The position at which indentation is being computed.
    */ pos, /**
    @internal
    */ context){
        super(base.state, base.options);
        this.base = base;
        this.pos = pos;
        this.context = context;
    }
    /**
    The syntax tree node to which the indentation strategy
    applies.
    */ get node() {
        return this.context.node;
    }
    /**
    @internal
    */ static create(base, pos, context) {
        return new $a97ccac5cf5f4f5d$export$8aaeb0848a33f7c3(base, pos, context);
    }
    /**
    Get the text directly after `this.pos`, either the entire line
    or the next 100 characters, whichever is shorter.
    */ get textAfter() {
        return this.textAfterPos(this.pos);
    }
    /**
    Get the indentation at the reference line for `this.node`, which
    is the line on which it starts, unless there is a node that is
    _not_ a parent of this node covering the start of that line. If
    so, the line at the start of that node is tried, again skipping
    on if it is covered by another such node.
    */ get baseIndent() {
        return this.baseIndentFor(this.node);
    }
    /**
    Get the indentation for the reference line of the given node
    (see [`baseIndent`](https://codemirror.net/6/docs/ref/#language.TreeIndentContext.baseIndent)).
    */ baseIndentFor(node) {
        let line = this.state.doc.lineAt(node.from);
        // Skip line starts that are covered by a sibling (or cousin, etc)
        for(;;){
            let atBreak = node.resolve(line.from);
            while(atBreak.parent && atBreak.parent.from == atBreak.from)atBreak = atBreak.parent;
            if ($a97ccac5cf5f4f5d$var$isParent(atBreak, node)) break;
            line = this.state.doc.lineAt(atBreak.from);
        }
        return this.lineIndent(line.from);
    }
    /**
    Continue looking for indentations in the node's parent nodes,
    and return the result of that.
    */ continue() {
        return $a97ccac5cf5f4f5d$var$indentFor(this.context.next, this.base, this.pos);
    }
}
function $a97ccac5cf5f4f5d$var$isParent(parent, of) {
    for(let cur = of; cur; cur = cur.parent)if (parent == cur) return true;
    return false;
}
// Check whether a delimited node is aligned (meaning there are
// non-skipped nodes on the same line as the opening delimiter). And
// if so, return the opening token.
function $a97ccac5cf5f4f5d$var$bracketedAligned(context) {
    let tree = context.node;
    let openToken = tree.childAfter(tree.from), last = tree.lastChild;
    if (!openToken) return null;
    let sim = context.options.simulateBreak;
    let openLine = context.state.doc.lineAt(openToken.from);
    let lineEnd = sim == null || sim <= openLine.from ? openLine.to : Math.min(openLine.to, sim);
    for(let pos = openToken.to;;){
        let next = tree.childAfter(pos);
        if (!next || next == last) return null;
        if (!next.type.isSkipped) {
            if (next.from >= lineEnd) return null;
            let space = /^ */.exec(openLine.text.slice(openToken.to - openLine.from))[0].length;
            return {
                from: openToken.from,
                to: openToken.to + space
            };
        }
        pos = next.to;
    }
}
/**
An indentation strategy for delimited (usually bracketed) nodes.
Will, by default, indent one unit more than the parent's base
indent unless the line starts with a closing token. When `align`
is true and there are non-skipped nodes on the node's opening
line, the content of the node will be aligned with the end of the
opening node, like this:

    foo(bar,
        baz)
*/ function $a97ccac5cf5f4f5d$export$60e82ea306899488({ closing: closing, align: align = true, units: units = 1 }) {
    return (context)=>$a97ccac5cf5f4f5d$var$delimitedStrategy(context, align, units, closing);
}
function $a97ccac5cf5f4f5d$var$delimitedStrategy(context, align, units, closing, closedAt) {
    let after = context.textAfter, space = after.match(/^\s*/)[0].length;
    let closed = closing && after.slice(space, space + closing.length) == closing || closedAt == context.pos + space;
    let aligned = align ? $a97ccac5cf5f4f5d$var$bracketedAligned(context) : null;
    if (aligned) return closed ? context.column(aligned.from) : context.column(aligned.to);
    return context.baseIndent + (closed ? 0 : context.unit * units);
}
/**
An indentation strategy that aligns a node's content to its base
indentation.
*/ const $a97ccac5cf5f4f5d$export$4764c629086182f2 = (context)=>context.baseIndent;
/**
Creates an indentation strategy that, by default, indents
continued lines one unit more than the node's base indentation.
You can provide `except` to prevent indentation of lines that
match a pattern (for example `/^else\b/` in `if`/`else`
constructs), and you can change the amount of units used with the
`units` option.
*/ function $a97ccac5cf5f4f5d$export$688ff433e7e7cc5c({ except: except, units: units = 1 } = {}) {
    return (context)=>{
        let matchExcept = except && except.test(context.textAfter);
        return context.baseIndent + (matchExcept ? 0 : units * context.unit);
    };
}
const $a97ccac5cf5f4f5d$var$DontIndentBeyond = 200;
/**
Enables reindentation on input. When a language defines an
`indentOnInput` field in its [language
data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt), which must hold a regular
expression, the line at the cursor will be reindented whenever new
text is typed and the input from the start of the line up to the
cursor matches that regexp.

To avoid unneccesary reindents, it is recommended to start the
regexp with `^` (usually followed by `\s*`), and end it with `$`.
For example, `/^\s*\}$/` will reindent when a closing brace is
added at the start of a line.
*/ function $a97ccac5cf5f4f5d$export$9bcaf6e2125ee117() {
    return (0, $6295c6875f57e3ee$export$afa855cbfaff27f2).transactionFilter.of((tr)=>{
        if (!tr.docChanged || !tr.isUserEvent("input.type") && !tr.isUserEvent("input.complete")) return tr;
        let rules = tr.startState.languageDataAt("indentOnInput", tr.startState.selection.main.head);
        if (!rules.length) return tr;
        let doc = tr.newDoc, { head: head } = tr.newSelection.main, line = doc.lineAt(head);
        if (head > line.from + $a97ccac5cf5f4f5d$var$DontIndentBeyond) return tr;
        let lineStart = doc.sliceString(line.from, head);
        if (!rules.some((r)=>r.test(lineStart))) return tr;
        let { state: state } = tr, last = -1, changes = [];
        for (let { head: head } of state.selection.ranges){
            let line = state.doc.lineAt(head);
            if (line.from == last) continue;
            last = line.from;
            let indent = $a97ccac5cf5f4f5d$export$a2d3c9dbce6d2211(state, line.from);
            if (indent == null) continue;
            let cur = /^\s*/.exec(line.text)[0];
            let norm = $a97ccac5cf5f4f5d$export$db5a40e207b40576(state, indent);
            if (cur != norm) changes.push({
                from: line.from,
                to: line.from + cur.length,
                insert: norm
            });
        }
        return changes.length ? [
            tr,
            {
                changes: changes,
                sequential: true
            }
        ] : tr;
    });
}
/**
A facet that registers a code folding service. When called with
the extent of a line, such a function should return a foldable
range that starts on that line (but continues beyond it), if one
can be found.
*/ const $a97ccac5cf5f4f5d$export$40014037e3ef64a = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
/**
This node prop is used to associate folding information with
syntax node types. Given a syntax node, it should check whether
that tree is foldable and return the range that can be collapsed
when it is.
*/ const $a97ccac5cf5f4f5d$export$9b075a85eb4377d8 = /*@__PURE__*/ new (0, $ed739beecf769914$export$b8034b9bc18acd90)();
/**
[Fold](https://codemirror.net/6/docs/ref/#language.foldNodeProp) function that folds everything but
the first and the last child of a syntax node. Useful for nodes
that start and end with delimiters.
*/ function $a97ccac5cf5f4f5d$export$48672beae16a681b(node) {
    let first = node.firstChild, last = node.lastChild;
    return first && first.to < last.from ? {
        from: first.to,
        to: last.type.isError ? node.to : last.from
    } : null;
}
function $a97ccac5cf5f4f5d$var$syntaxFolding(state, start, end) {
    let tree = $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1(state);
    if (tree.length < end) return null;
    let stack = tree.resolveStack(end, 1);
    let found = null;
    for(let iter = stack; iter; iter = iter.next){
        let cur = iter.node;
        if (cur.to <= end || cur.from > end) continue;
        if (found && cur.from < start) break;
        let prop = cur.type.prop($a97ccac5cf5f4f5d$export$9b075a85eb4377d8);
        if (prop && (cur.to < tree.length - 50 || tree.length == state.doc.length || !$a97ccac5cf5f4f5d$var$isUnfinished(cur))) {
            let value = prop(cur, state);
            if (value && value.from <= end && value.from >= start && value.to > end) found = value;
        }
    }
    return found;
}
function $a97ccac5cf5f4f5d$var$isUnfinished(node) {
    let ch = node.lastChild;
    return ch && ch.to == node.to && ch.type.isError;
}
/**
Check whether the given line is foldable. First asks any fold
services registered through
[`foldService`](https://codemirror.net/6/docs/ref/#language.foldService), and if none of them return
a result, tries to query the [fold node
prop](https://codemirror.net/6/docs/ref/#language.foldNodeProp) of syntax nodes that cover the end
of the line.
*/ function $a97ccac5cf5f4f5d$export$cbe8a3d55245b07d(state, lineStart, lineEnd) {
    for (let service of state.facet($a97ccac5cf5f4f5d$export$40014037e3ef64a)){
        let result = service(state, lineStart, lineEnd);
        if (result) return result;
    }
    return $a97ccac5cf5f4f5d$var$syntaxFolding(state, lineStart, lineEnd);
}
function $a97ccac5cf5f4f5d$var$mapRange(range, mapping) {
    let from = mapping.mapPos(range.from, 1), to = mapping.mapPos(range.to, -1);
    return from >= to ? undefined : {
        from: from,
        to: to
    };
}
/**
State effect that can be attached to a transaction to fold the
given range. (You probably only need this in exceptional
circumstances—usually you'll just want to let
[`foldCode`](https://codemirror.net/6/docs/ref/#language.foldCode) and the [fold
gutter](https://codemirror.net/6/docs/ref/#language.foldGutter) create the transactions.)
*/ const $a97ccac5cf5f4f5d$export$a123efe007ad265 = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define({
    map: $a97ccac5cf5f4f5d$var$mapRange
});
/**
State effect that unfolds the given range (if it was folded).
*/ const $a97ccac5cf5f4f5d$export$bf2507dc398fc1ab = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define({
    map: $a97ccac5cf5f4f5d$var$mapRange
});
function $a97ccac5cf5f4f5d$var$selectedLines(view) {
    let lines = [];
    for (let { head: head } of view.state.selection.ranges){
        if (lines.some((l)=>l.from <= head && l.to >= head)) continue;
        lines.push(view.lineBlockAt(head));
    }
    return lines;
}
/**
The state field that stores the folded ranges (as a [decoration
set](https://codemirror.net/6/docs/ref/#view.DecorationSet)). Can be passed to
[`EditorState.toJSON`](https://codemirror.net/6/docs/ref/#state.EditorState.toJSON) and
[`fromJSON`](https://codemirror.net/6/docs/ref/#state.EditorState^fromJSON) to serialize the fold
state.
*/ const $a97ccac5cf5f4f5d$export$6955fe1f7c578abb = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$34381b1ce2130245).define({
    create () {
        return (0, $7beee9608540d2c3$export$10e30b733df217ea).none;
    },
    update (folded, tr) {
        if (tr.isUserEvent("delete")) tr.changes.iterChangedRanges((fromA, toA)=>folded = $a97ccac5cf5f4f5d$var$clearTouchedFolds(folded, fromA, toA));
        folded = folded.map(tr.changes);
        for (let e of tr.effects){
            if (e.is($a97ccac5cf5f4f5d$export$a123efe007ad265) && !$a97ccac5cf5f4f5d$var$foldExists(folded, e.value.from, e.value.to)) {
                let { preparePlaceholder: preparePlaceholder } = tr.state.facet($a97ccac5cf5f4f5d$var$foldConfig);
                let widget = !preparePlaceholder ? $a97ccac5cf5f4f5d$var$foldWidget : (0, $7beee9608540d2c3$export$10e30b733df217ea).replace({
                    widget: new $a97ccac5cf5f4f5d$var$PreparedFoldWidget(preparePlaceholder(tr.state, e.value))
                });
                folded = folded.update({
                    add: [
                        widget.range(e.value.from, e.value.to)
                    ]
                });
            } else if (e.is($a97ccac5cf5f4f5d$export$bf2507dc398fc1ab)) folded = folded.update({
                filter: (from, to)=>e.value.from != from || e.value.to != to,
                filterFrom: e.value.from,
                filterTo: e.value.to
            });
        }
        // Clear folded ranges that cover the selection head
        if (tr.selection) folded = $a97ccac5cf5f4f5d$var$clearTouchedFolds(folded, tr.selection.main.head);
        return folded;
    },
    provide: (f)=>(0, $7beee9608540d2c3$export$eece2fccabbb77c5).decorations.from(f),
    toJSON (folded, state) {
        let ranges = [];
        folded.between(0, state.doc.length, (from, to)=>{
            ranges.push(from, to);
        });
        return ranges;
    },
    fromJSON (value) {
        if (!Array.isArray(value) || value.length % 2) throw new RangeError("Invalid JSON for fold state");
        let ranges = [];
        for(let i = 0; i < value.length;){
            let from = value[i++], to = value[i++];
            if (typeof from != "number" || typeof to != "number") throw new RangeError("Invalid JSON for fold state");
            ranges.push($a97ccac5cf5f4f5d$var$foldWidget.range(from, to));
        }
        return (0, $7beee9608540d2c3$export$10e30b733df217ea).set(ranges, true);
    }
});
function $a97ccac5cf5f4f5d$var$clearTouchedFolds(folded, from, to = from) {
    let touched = false;
    folded.between(from, to, (a, b)=>{
        if (a < to && b > from) touched = true;
    });
    return !touched ? folded : folded.update({
        filterFrom: from,
        filterTo: to,
        filter: (a, b)=>a >= to || b <= from
    });
}
/**
Get a [range set](https://codemirror.net/6/docs/ref/#state.RangeSet) containing the folded ranges
in the given state.
*/ function $a97ccac5cf5f4f5d$export$2b3c199812391e05(state) {
    return state.field($a97ccac5cf5f4f5d$export$6955fe1f7c578abb, false) || (0, $6295c6875f57e3ee$export$34cb5241245008dd).empty;
}
function $a97ccac5cf5f4f5d$var$findFold(state, from, to) {
    var _a;
    let found = null;
    (_a = state.field($a97ccac5cf5f4f5d$export$6955fe1f7c578abb, false)) === null || _a === void 0 || _a.between(from, to, (from, to)=>{
        if (!found || found.from > from) found = {
            from: from,
            to: to
        };
    });
    return found;
}
function $a97ccac5cf5f4f5d$var$foldExists(folded, from, to) {
    let found = false;
    folded.between(from, from, (a, b)=>{
        if (a == from && b == to) found = true;
    });
    return found;
}
function $a97ccac5cf5f4f5d$var$maybeEnable(state, other) {
    return state.field($a97ccac5cf5f4f5d$export$6955fe1f7c578abb, false) ? other : other.concat((0, $6295c6875f57e3ee$export$95000d4efaa4321f).appendConfig.of($a97ccac5cf5f4f5d$export$2c875b83a85d0f31()));
}
/**
Fold the lines that are selected, if possible.
*/ const $a97ccac5cf5f4f5d$export$52e96be2adbea02a = (view)=>{
    for (let line of $a97ccac5cf5f4f5d$var$selectedLines(view)){
        let range = $a97ccac5cf5f4f5d$export$cbe8a3d55245b07d(view.state, line.from, line.to);
        if (range) {
            view.dispatch({
                effects: $a97ccac5cf5f4f5d$var$maybeEnable(view.state, [
                    $a97ccac5cf5f4f5d$export$a123efe007ad265.of(range),
                    $a97ccac5cf5f4f5d$var$announceFold(view, range)
                ])
            });
            return true;
        }
    }
    return false;
};
/**
Unfold folded ranges on selected lines.
*/ const $a97ccac5cf5f4f5d$export$f4cd5e9f2c073861 = (view)=>{
    if (!view.state.field($a97ccac5cf5f4f5d$export$6955fe1f7c578abb, false)) return false;
    let effects = [];
    for (let line of $a97ccac5cf5f4f5d$var$selectedLines(view)){
        let folded = $a97ccac5cf5f4f5d$var$findFold(view.state, line.from, line.to);
        if (folded) effects.push($a97ccac5cf5f4f5d$export$bf2507dc398fc1ab.of(folded), $a97ccac5cf5f4f5d$var$announceFold(view, folded, false));
    }
    if (effects.length) view.dispatch({
        effects: effects
    });
    return effects.length > 0;
};
function $a97ccac5cf5f4f5d$var$announceFold(view, range, fold = true) {
    let lineFrom = view.state.doc.lineAt(range.from).number, lineTo = view.state.doc.lineAt(range.to).number;
    return (0, $7beee9608540d2c3$export$eece2fccabbb77c5).announce.of(`${view.state.phrase(fold ? "Folded lines" : "Unfolded lines")} ${lineFrom} ${view.state.phrase("to")} ${lineTo}.`);
}
/**
Fold all top-level foldable ranges. Note that, in most cases,
folding information will depend on the [syntax
tree](https://codemirror.net/6/docs/ref/#language.syntaxTree), and folding everything may not work
reliably when the document hasn't been fully parsed (either
because the editor state was only just initialized, or because the
document is so big that the parser decided not to parse it
entirely).
*/ const $a97ccac5cf5f4f5d$export$5396d9eaf1c0ba76 = (view)=>{
    let { state: state } = view, effects = [];
    for(let pos = 0; pos < state.doc.length;){
        let line = view.lineBlockAt(pos), range = $a97ccac5cf5f4f5d$export$cbe8a3d55245b07d(state, line.from, line.to);
        if (range) effects.push($a97ccac5cf5f4f5d$export$a123efe007ad265.of(range));
        pos = (range ? view.lineBlockAt(range.to) : line).to + 1;
    }
    if (effects.length) view.dispatch({
        effects: $a97ccac5cf5f4f5d$var$maybeEnable(view.state, effects)
    });
    return !!effects.length;
};
/**
Unfold all folded code.
*/ const $a97ccac5cf5f4f5d$export$5671b24df569b27d = (view)=>{
    let field = view.state.field($a97ccac5cf5f4f5d$export$6955fe1f7c578abb, false);
    if (!field || !field.size) return false;
    let effects = [];
    field.between(0, view.state.doc.length, (from, to)=>{
        effects.push($a97ccac5cf5f4f5d$export$bf2507dc398fc1ab.of({
            from: from,
            to: to
        }));
    });
    view.dispatch({
        effects: effects
    });
    return true;
};
// Find the foldable region containing the given line, if one exists
function $a97ccac5cf5f4f5d$var$foldableContainer(view, lineBlock) {
    // Look backwards through line blocks until we find a foldable region that
    // intersects with the line
    for(let line = lineBlock;;){
        let foldableRegion = $a97ccac5cf5f4f5d$export$cbe8a3d55245b07d(view.state, line.from, line.to);
        if (foldableRegion && foldableRegion.to > lineBlock.from) return foldableRegion;
        if (!line.from) return null;
        line = view.lineBlockAt(line.from - 1);
    }
}
/**
Toggle folding at cursors. Unfolds if there is an existing fold
starting in that line, tries to find a foldable range around it
otherwise.
*/ const $a97ccac5cf5f4f5d$export$b23e83f59d68c8f1 = (view)=>{
    let effects = [];
    for (let line of $a97ccac5cf5f4f5d$var$selectedLines(view)){
        let folded = $a97ccac5cf5f4f5d$var$findFold(view.state, line.from, line.to);
        if (folded) effects.push($a97ccac5cf5f4f5d$export$bf2507dc398fc1ab.of(folded), $a97ccac5cf5f4f5d$var$announceFold(view, folded, false));
        else {
            let foldRange = $a97ccac5cf5f4f5d$var$foldableContainer(view, line);
            if (foldRange) effects.push($a97ccac5cf5f4f5d$export$a123efe007ad265.of(foldRange), $a97ccac5cf5f4f5d$var$announceFold(view, foldRange));
        }
    }
    if (effects.length > 0) view.dispatch({
        effects: $a97ccac5cf5f4f5d$var$maybeEnable(view.state, effects)
    });
    return !!effects.length;
};
/**
Default fold-related key bindings.

 - Ctrl-Shift-[ (Cmd-Alt-[ on macOS): [`foldCode`](https://codemirror.net/6/docs/ref/#language.foldCode).
 - Ctrl-Shift-] (Cmd-Alt-] on macOS): [`unfoldCode`](https://codemirror.net/6/docs/ref/#language.unfoldCode).
 - Ctrl-Alt-[: [`foldAll`](https://codemirror.net/6/docs/ref/#language.foldAll).
 - Ctrl-Alt-]: [`unfoldAll`](https://codemirror.net/6/docs/ref/#language.unfoldAll).
*/ const $a97ccac5cf5f4f5d$export$39c52376a8936d67 = [
    {
        key: "Ctrl-Shift-[",
        mac: "Cmd-Alt-[",
        run: $a97ccac5cf5f4f5d$export$52e96be2adbea02a
    },
    {
        key: "Ctrl-Shift-]",
        mac: "Cmd-Alt-]",
        run: $a97ccac5cf5f4f5d$export$f4cd5e9f2c073861
    },
    {
        key: "Ctrl-Alt-[",
        run: $a97ccac5cf5f4f5d$export$5396d9eaf1c0ba76
    },
    {
        key: "Ctrl-Alt-]",
        run: $a97ccac5cf5f4f5d$export$5671b24df569b27d
    }
];
const $a97ccac5cf5f4f5d$var$defaultConfig = {
    placeholderDOM: null,
    preparePlaceholder: null,
    placeholderText: "\u2026"
};
const $a97ccac5cf5f4f5d$var$foldConfig = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (values) {
        return (0, $6295c6875f57e3ee$export$4e19c0b693794a7e)(values, $a97ccac5cf5f4f5d$var$defaultConfig);
    }
});
/**
Create an extension that configures code folding.
*/ function $a97ccac5cf5f4f5d$export$2c875b83a85d0f31(config) {
    let result = [
        $a97ccac5cf5f4f5d$export$6955fe1f7c578abb,
        $a97ccac5cf5f4f5d$var$baseTheme$1
    ];
    if (config) result.push($a97ccac5cf5f4f5d$var$foldConfig.of(config));
    return result;
}
function $a97ccac5cf5f4f5d$var$widgetToDOM(view, prepared) {
    let { state: state } = view, conf = state.facet($a97ccac5cf5f4f5d$var$foldConfig);
    let onclick = (event)=>{
        let line = view.lineBlockAt(view.posAtDOM(event.target));
        let folded = $a97ccac5cf5f4f5d$var$findFold(view.state, line.from, line.to);
        if (folded) view.dispatch({
            effects: $a97ccac5cf5f4f5d$export$bf2507dc398fc1ab.of(folded)
        });
        event.preventDefault();
    };
    if (conf.placeholderDOM) return conf.placeholderDOM(view, onclick, prepared);
    let element = document.createElement("span");
    element.textContent = conf.placeholderText;
    element.setAttribute("aria-label", state.phrase("folded code"));
    element.title = state.phrase("unfold");
    element.className = "cm-foldPlaceholder";
    element.onclick = onclick;
    return element;
}
const $a97ccac5cf5f4f5d$var$foldWidget = /*@__PURE__*/ (0, $7beee9608540d2c3$export$10e30b733df217ea).replace({
    widget: /*@__PURE__*/ new class extends (0, $7beee9608540d2c3$export$95cdd842edb044c5) {
        toDOM(view) {
            return $a97ccac5cf5f4f5d$var$widgetToDOM(view, null);
        }
    }
});
class $a97ccac5cf5f4f5d$var$PreparedFoldWidget extends (0, $7beee9608540d2c3$export$95cdd842edb044c5) {
    constructor(value){
        super();
        this.value = value;
    }
    eq(other) {
        return this.value == other.value;
    }
    toDOM(view) {
        return $a97ccac5cf5f4f5d$var$widgetToDOM(view, this.value);
    }
}
const $a97ccac5cf5f4f5d$var$foldGutterDefaults = {
    openText: "\u2304",
    closedText: "\u203A",
    markerDOM: null,
    domEventHandlers: {},
    foldingChanged: ()=>false
};
class $a97ccac5cf5f4f5d$var$FoldMarker extends (0, $7beee9608540d2c3$export$591ab4c909549043) {
    constructor(config, open){
        super();
        this.config = config;
        this.open = open;
    }
    eq(other) {
        return this.config == other.config && this.open == other.open;
    }
    toDOM(view) {
        if (this.config.markerDOM) return this.config.markerDOM(this.open);
        let span = document.createElement("span");
        span.textContent = this.open ? this.config.openText : this.config.closedText;
        span.title = view.state.phrase(this.open ? "Fold line" : "Unfold line");
        return span;
    }
}
/**
Create an extension that registers a fold gutter, which shows a
fold status indicator before foldable lines (which can be clicked
to fold or unfold the line).
*/ function $a97ccac5cf5f4f5d$export$c4dcf64f741b6228(config = {}) {
    let fullConfig = {
        ...$a97ccac5cf5f4f5d$var$foldGutterDefaults,
        ...config
    };
    let canFold = new $a97ccac5cf5f4f5d$var$FoldMarker(fullConfig, true), canUnfold = new $a97ccac5cf5f4f5d$var$FoldMarker(fullConfig, false);
    let markers = (0, $7beee9608540d2c3$export$44d5eccfd62adda7).fromClass(class {
        constructor(view){
            this.from = view.viewport.from;
            this.markers = this.buildMarkers(view);
        }
        update(update) {
            if (update.docChanged || update.viewportChanged || update.startState.facet($a97ccac5cf5f4f5d$export$789c912f57fe164c) != update.state.facet($a97ccac5cf5f4f5d$export$789c912f57fe164c) || update.startState.field($a97ccac5cf5f4f5d$export$6955fe1f7c578abb, false) != update.state.field($a97ccac5cf5f4f5d$export$6955fe1f7c578abb, false) || $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1(update.startState) != $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1(update.state) || fullConfig.foldingChanged(update)) this.markers = this.buildMarkers(update.view);
        }
        buildMarkers(view) {
            let builder = new (0, $6295c6875f57e3ee$export$89e09ce03c7e8594)();
            for (let line of view.viewportLineBlocks){
                let mark = $a97ccac5cf5f4f5d$var$findFold(view.state, line.from, line.to) ? canUnfold : $a97ccac5cf5f4f5d$export$cbe8a3d55245b07d(view.state, line.from, line.to) ? canFold : null;
                if (mark) builder.add(line.from, line.from, mark);
            }
            return builder.finish();
        }
    });
    let { domEventHandlers: domEventHandlers } = fullConfig;
    return [
        markers,
        (0, $7beee9608540d2c3$export$f2b922cb4a245974)({
            class: "cm-foldGutter",
            markers (view) {
                var _a;
                return ((_a = view.plugin(markers)) === null || _a === void 0 ? void 0 : _a.markers) || (0, $6295c6875f57e3ee$export$34cb5241245008dd).empty;
            },
            initialSpacer () {
                return new $a97ccac5cf5f4f5d$var$FoldMarker(fullConfig, false);
            },
            domEventHandlers: {
                ...domEventHandlers,
                click: (view, line, event)=>{
                    if (domEventHandlers.click && domEventHandlers.click(view, line, event)) return true;
                    let folded = $a97ccac5cf5f4f5d$var$findFold(view.state, line.from, line.to);
                    if (folded) {
                        view.dispatch({
                            effects: $a97ccac5cf5f4f5d$export$bf2507dc398fc1ab.of(folded)
                        });
                        return true;
                    }
                    let range = $a97ccac5cf5f4f5d$export$cbe8a3d55245b07d(view.state, line.from, line.to);
                    if (range) {
                        view.dispatch({
                            effects: $a97ccac5cf5f4f5d$export$a123efe007ad265.of(range)
                        });
                        return true;
                    }
                    return false;
                }
            }
        }),
        $a97ccac5cf5f4f5d$export$2c875b83a85d0f31()
    ];
}
const $a97ccac5cf5f4f5d$var$baseTheme$1 = /*@__PURE__*/ (0, $7beee9608540d2c3$export$eece2fccabbb77c5).baseTheme({
    ".cm-foldPlaceholder": {
        backgroundColor: "#eee",
        border: "1px solid #ddd",
        color: "#888",
        borderRadius: ".2em",
        margin: "0 1px",
        padding: "0 1px",
        cursor: "pointer"
    },
    ".cm-foldGutter span": {
        padding: "0 1px",
        cursor: "pointer"
    }
});
/**
A highlight style associates CSS styles with highlighting
[tags](https://lezer.codemirror.net/docs/ref#highlight.Tag).
*/ class $a97ccac5cf5f4f5d$export$4819f093bdd5b4a {
    constructor(/**
    The tag styles used to create this highlight style.
    */ specs, options){
        this.specs = specs;
        let modSpec;
        function def(spec) {
            let cls = (0, $afd7c6da9f842a17$export$b920c662d2efee20).newName();
            (modSpec || (modSpec = Object.create(null)))["." + cls] = spec;
            return cls;
        }
        const all = typeof options.all == "string" ? options.all : options.all ? def(options.all) : undefined;
        const scopeOpt = options.scope;
        this.scope = scopeOpt instanceof $a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a ? (type)=>type.prop($a97ccac5cf5f4f5d$export$27a2e78097f753f7) == scopeOpt.data : scopeOpt ? (type)=>type == scopeOpt : undefined;
        this.style = (0, $a1ec9d683d365521$export$b7f6332ce20f80fb)(specs.map((style)=>({
                tag: style.tag,
                class: style.class || def(Object.assign({}, style, {
                    tag: null
                }))
            })), {
            all: all
        }).style;
        this.module = modSpec ? new (0, $afd7c6da9f842a17$export$b920c662d2efee20)(modSpec) : null;
        this.themeType = options.themeType;
    }
    /**
    Create a highlighter style that associates the given styles to
    the given tags. The specs must be objects that hold a style tag
    or array of tags in their `tag` property, and either a single
    `class` property providing a static CSS class (for highlighter
    that rely on external styling), or a
    [`style-mod`](https://github.com/marijnh/style-mod#documentation)-style
    set of CSS properties (which define the styling for those tags).
    
    The CSS rules created for a highlighter will be emitted in the
    order of the spec's properties. That means that for elements that
    have multiple tags associated with them, styles defined further
    down in the list will have a higher CSS precedence than styles
    defined earlier.
    */ static define(specs, options) {
        return new $a97ccac5cf5f4f5d$export$4819f093bdd5b4a(specs, options || {});
    }
}
const $a97ccac5cf5f4f5d$var$highlighterFacet = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $a97ccac5cf5f4f5d$var$fallbackHighlighter = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (values) {
        return values.length ? [
            values[0]
        ] : null;
    }
});
function $a97ccac5cf5f4f5d$var$getHighlighters(state) {
    let main = state.facet($a97ccac5cf5f4f5d$var$highlighterFacet);
    return main.length ? main : state.facet($a97ccac5cf5f4f5d$var$fallbackHighlighter);
}
/**
Wrap a highlighter in an editor extension that uses it to apply
syntax highlighting to the editor content.

When multiple (non-fallback) styles are provided, the styling
applied is the union of the classes they emit.
*/ function $a97ccac5cf5f4f5d$export$ec1b956ff3a16361(highlighter, options) {
    let ext = [
        $a97ccac5cf5f4f5d$var$treeHighlighter
    ], themeType;
    if (highlighter instanceof $a97ccac5cf5f4f5d$export$4819f093bdd5b4a) {
        if (highlighter.module) ext.push((0, $7beee9608540d2c3$export$eece2fccabbb77c5).styleModule.of(highlighter.module));
        themeType = highlighter.themeType;
    }
    if (options === null || options === void 0 ? void 0 : options.fallback) ext.push($a97ccac5cf5f4f5d$var$fallbackHighlighter.of(highlighter));
    else if (themeType) ext.push($a97ccac5cf5f4f5d$var$highlighterFacet.computeN([
        (0, $7beee9608540d2c3$export$eece2fccabbb77c5).darkTheme
    ], (state)=>{
        return state.facet((0, $7beee9608540d2c3$export$eece2fccabbb77c5).darkTheme) == (themeType == "dark") ? [
            highlighter
        ] : [];
    }));
    else ext.push($a97ccac5cf5f4f5d$var$highlighterFacet.of(highlighter));
    return ext;
}
/**
Returns the CSS classes (if any) that the highlighters active in
the state would assign to the given style
[tags](https://lezer.codemirror.net/docs/ref#highlight.Tag) and
(optional) language
[scope](https://codemirror.net/6/docs/ref/#language.HighlightStyle^define^options.scope).
*/ function $a97ccac5cf5f4f5d$export$8ca2b052028e8782(state, tags, scope) {
    let highlighters = $a97ccac5cf5f4f5d$var$getHighlighters(state);
    let result = null;
    if (highlighters) {
        for (let highlighter of highlighters)if (!highlighter.scope || scope && highlighter.scope(scope)) {
            let cls = highlighter.style(tags);
            if (cls) result = result ? result + " " + cls : cls;
        }
    }
    return result;
}
class $a97ccac5cf5f4f5d$var$TreeHighlighter {
    constructor(view){
        this.markCache = Object.create(null);
        this.tree = $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1(view.state);
        this.decorations = this.buildDeco(view, $a97ccac5cf5f4f5d$var$getHighlighters(view.state));
        this.decoratedTo = view.viewport.to;
    }
    update(update) {
        let tree = $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1(update.state), highlighters = $a97ccac5cf5f4f5d$var$getHighlighters(update.state);
        let styleChange = highlighters != $a97ccac5cf5f4f5d$var$getHighlighters(update.startState);
        let { viewport: viewport } = update.view, decoratedToMapped = update.changes.mapPos(this.decoratedTo, 1);
        if (tree.length < viewport.to && !styleChange && tree.type == this.tree.type && decoratedToMapped >= viewport.to) {
            this.decorations = this.decorations.map(update.changes);
            this.decoratedTo = decoratedToMapped;
        } else if (tree != this.tree || update.viewportChanged || styleChange) {
            this.tree = tree;
            this.decorations = this.buildDeco(update.view, highlighters);
            this.decoratedTo = viewport.to;
        }
    }
    buildDeco(view, highlighters) {
        if (!highlighters || !this.tree.length) return (0, $7beee9608540d2c3$export$10e30b733df217ea).none;
        let builder = new (0, $6295c6875f57e3ee$export$89e09ce03c7e8594)();
        for (let { from: from, to: to } of view.visibleRanges)(0, $a1ec9d683d365521$export$af82b3d076119fad)(this.tree, highlighters, (from, to, style)=>{
            builder.add(from, to, this.markCache[style] || (this.markCache[style] = (0, $7beee9608540d2c3$export$10e30b733df217ea).mark({
                class: style
            })));
        }, from, to);
        return builder.finish();
    }
}
const $a97ccac5cf5f4f5d$var$treeHighlighter = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$b92464a736444411).high(/*@__PURE__*/ (0, $7beee9608540d2c3$export$44d5eccfd62adda7).fromClass($a97ccac5cf5f4f5d$var$TreeHighlighter, {
    decorations: (v)=>v.decorations
}));
/**
A default highlight style (works well with light themes).
*/ const $a97ccac5cf5f4f5d$export$bb02a6818dd48320 = /*@__PURE__*/ $a97ccac5cf5f4f5d$export$4819f093bdd5b4a.define([
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).meta,
        color: "#404740"
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).link,
        textDecoration: "underline"
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).heading,
        textDecoration: "underline",
        fontWeight: "bold"
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).emphasis,
        fontStyle: "italic"
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).strong,
        fontWeight: "bold"
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).strikethrough,
        textDecoration: "line-through"
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).keyword,
        color: "#708"
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).atom,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).bool,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).url,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).contentSeparator,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).labelName
        ],
        color: "#219"
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).literal,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).inserted
        ],
        color: "#164"
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).string,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).deleted
        ],
        color: "#a11"
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).regexp,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).escape,
            /*@__PURE__*/ (0, $a1ec9d683d365521$export$8b7a896ae75accbf).special((0, $a1ec9d683d365521$export$8b7a896ae75accbf).string)
        ],
        color: "#e40"
    },
    {
        tag: /*@__PURE__*/ (0, $a1ec9d683d365521$export$8b7a896ae75accbf).definition((0, $a1ec9d683d365521$export$8b7a896ae75accbf).variableName),
        color: "#00f"
    },
    {
        tag: /*@__PURE__*/ (0, $a1ec9d683d365521$export$8b7a896ae75accbf).local((0, $a1ec9d683d365521$export$8b7a896ae75accbf).variableName),
        color: "#30a"
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).typeName,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).namespace
        ],
        color: "#085"
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).className,
        color: "#167"
    },
    {
        tag: [
            /*@__PURE__*/ (0, $a1ec9d683d365521$export$8b7a896ae75accbf).special((0, $a1ec9d683d365521$export$8b7a896ae75accbf).variableName),
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).macroName
        ],
        color: "#256"
    },
    {
        tag: /*@__PURE__*/ (0, $a1ec9d683d365521$export$8b7a896ae75accbf).definition((0, $a1ec9d683d365521$export$8b7a896ae75accbf).propertyName),
        color: "#00c"
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).comment,
        color: "#940"
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).invalid,
        color: "#f00"
    }
]);
const $a97ccac5cf5f4f5d$var$baseTheme = /*@__PURE__*/ (0, $7beee9608540d2c3$export$eece2fccabbb77c5).baseTheme({
    "&.cm-focused .cm-matchingBracket": {
        backgroundColor: "#328c8252"
    },
    "&.cm-focused .cm-nonmatchingBracket": {
        backgroundColor: "#bb555544"
    }
});
const $a97ccac5cf5f4f5d$var$DefaultScanDist = 10000, $a97ccac5cf5f4f5d$var$DefaultBrackets = "()[]{}";
const $a97ccac5cf5f4f5d$var$bracketMatchingConfig = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        return (0, $6295c6875f57e3ee$export$4e19c0b693794a7e)(configs, {
            afterCursor: true,
            brackets: $a97ccac5cf5f4f5d$var$DefaultBrackets,
            maxScanDistance: $a97ccac5cf5f4f5d$var$DefaultScanDist,
            renderMatch: $a97ccac5cf5f4f5d$var$defaultRenderMatch
        });
    }
});
const $a97ccac5cf5f4f5d$var$matchingMark = /*@__PURE__*/ (0, $7beee9608540d2c3$export$10e30b733df217ea).mark({
    class: "cm-matchingBracket"
}), $a97ccac5cf5f4f5d$var$nonmatchingMark = /*@__PURE__*/ (0, $7beee9608540d2c3$export$10e30b733df217ea).mark({
    class: "cm-nonmatchingBracket"
});
function $a97ccac5cf5f4f5d$var$defaultRenderMatch(match) {
    let decorations = [];
    let mark = match.matched ? $a97ccac5cf5f4f5d$var$matchingMark : $a97ccac5cf5f4f5d$var$nonmatchingMark;
    decorations.push(mark.range(match.start.from, match.start.to));
    if (match.end) decorations.push(mark.range(match.end.from, match.end.to));
    return decorations;
}
function $a97ccac5cf5f4f5d$var$bracketDeco(state) {
    let decorations = [];
    let config = state.facet($a97ccac5cf5f4f5d$var$bracketMatchingConfig);
    for (let range of state.selection.ranges){
        if (!range.empty) continue;
        let match = $a97ccac5cf5f4f5d$export$3391942603e90cda(state, range.head, -1, config) || range.head > 0 && $a97ccac5cf5f4f5d$export$3391942603e90cda(state, range.head - 1, 1, config) || config.afterCursor && ($a97ccac5cf5f4f5d$export$3391942603e90cda(state, range.head, 1, config) || range.head < state.doc.length && $a97ccac5cf5f4f5d$export$3391942603e90cda(state, range.head + 1, -1, config));
        if (match) decorations = decorations.concat(config.renderMatch(match, state));
    }
    return (0, $7beee9608540d2c3$export$10e30b733df217ea).set(decorations, true);
}
const $a97ccac5cf5f4f5d$var$bracketMatcher = /*@__PURE__*/ (0, $7beee9608540d2c3$export$44d5eccfd62adda7).fromClass(class {
    constructor(view){
        this.paused = false;
        this.decorations = $a97ccac5cf5f4f5d$var$bracketDeco(view.state);
    }
    update(update) {
        if (update.docChanged || update.selectionSet || this.paused) {
            if (update.view.composing) {
                this.decorations = this.decorations.map(update.changes);
                this.paused = true;
            } else {
                this.decorations = $a97ccac5cf5f4f5d$var$bracketDeco(update.state);
                this.paused = false;
            }
        }
    }
}, {
    decorations: (v)=>v.decorations
});
const $a97ccac5cf5f4f5d$var$bracketMatchingUnique = [
    $a97ccac5cf5f4f5d$var$bracketMatcher,
    $a97ccac5cf5f4f5d$var$baseTheme
];
/**
Create an extension that enables bracket matching. Whenever the
cursor is next to a bracket, that bracket and the one it matches
are highlighted. Or, when no matching bracket is found, another
highlighting style is used to indicate this.
*/ function $a97ccac5cf5f4f5d$export$cef7edfd214be605(config = {}) {
    return [
        $a97ccac5cf5f4f5d$var$bracketMatchingConfig.of(config),
        $a97ccac5cf5f4f5d$var$bracketMatchingUnique
    ];
}
/**
When larger syntax nodes, such as HTML tags, are marked as
opening/closing, it can be a bit messy to treat the whole node as
a matchable bracket. This node prop allows you to define, for such
a node, a ‘handle’—the part of the node that is highlighted, and
that the cursor must be on to activate highlighting in the first
place.
*/ const $a97ccac5cf5f4f5d$export$ca7d74cd5b9f1011 = /*@__PURE__*/ new (0, $ed739beecf769914$export$b8034b9bc18acd90)();
function $a97ccac5cf5f4f5d$var$matchingNodes(node, dir, brackets) {
    let byProp = node.prop(dir < 0 ? (0, $ed739beecf769914$export$b8034b9bc18acd90).openedBy : (0, $ed739beecf769914$export$b8034b9bc18acd90).closedBy);
    if (byProp) return byProp;
    if (node.name.length == 1) {
        let index = brackets.indexOf(node.name);
        if (index > -1 && index % 2 == (dir < 0 ? 1 : 0)) return [
            brackets[index + dir]
        ];
    }
    return null;
}
function $a97ccac5cf5f4f5d$var$findHandle(node) {
    let hasHandle = node.type.prop($a97ccac5cf5f4f5d$export$ca7d74cd5b9f1011);
    return hasHandle ? hasHandle(node.node) : node;
}
/**
Find the matching bracket for the token at `pos`, scanning
direction `dir`. Only the `brackets` and `maxScanDistance`
properties are used from `config`, if given. Returns null if no
bracket was found at `pos`, or a match result otherwise.
*/ function $a97ccac5cf5f4f5d$export$3391942603e90cda(state, pos, dir, config = {}) {
    let maxScanDistance = config.maxScanDistance || $a97ccac5cf5f4f5d$var$DefaultScanDist, brackets = config.brackets || $a97ccac5cf5f4f5d$var$DefaultBrackets;
    let tree = $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1(state), node = tree.resolveInner(pos, dir);
    for(let cur = node; cur; cur = cur.parent){
        let matches = $a97ccac5cf5f4f5d$var$matchingNodes(cur.type, dir, brackets);
        if (matches && cur.from < cur.to) {
            let handle = $a97ccac5cf5f4f5d$var$findHandle(cur);
            if (handle && (dir > 0 ? pos >= handle.from && pos < handle.to : pos > handle.from && pos <= handle.to)) return $a97ccac5cf5f4f5d$var$matchMarkedBrackets(state, pos, dir, cur, handle, matches, brackets);
        }
    }
    return $a97ccac5cf5f4f5d$var$matchPlainBrackets(state, pos, dir, tree, node.type, maxScanDistance, brackets);
}
function $a97ccac5cf5f4f5d$var$matchMarkedBrackets(_state, _pos, dir, token, handle, matching, brackets) {
    let parent = token.parent, firstToken = {
        from: handle.from,
        to: handle.to
    };
    let depth = 0, cursor = parent === null || parent === void 0 ? void 0 : parent.cursor();
    if (cursor && (dir < 0 ? cursor.childBefore(token.from) : cursor.childAfter(token.to))) do if (dir < 0 ? cursor.to <= token.from : cursor.from >= token.to) {
        if (depth == 0 && matching.indexOf(cursor.type.name) > -1 && cursor.from < cursor.to) {
            let endHandle = $a97ccac5cf5f4f5d$var$findHandle(cursor);
            return {
                start: firstToken,
                end: endHandle ? {
                    from: endHandle.from,
                    to: endHandle.to
                } : undefined,
                matched: true
            };
        } else if ($a97ccac5cf5f4f5d$var$matchingNodes(cursor.type, dir, brackets)) depth++;
        else if ($a97ccac5cf5f4f5d$var$matchingNodes(cursor.type, -dir, brackets)) {
            if (depth == 0) {
                let endHandle = $a97ccac5cf5f4f5d$var$findHandle(cursor);
                return {
                    start: firstToken,
                    end: endHandle && endHandle.from < endHandle.to ? {
                        from: endHandle.from,
                        to: endHandle.to
                    } : undefined,
                    matched: false
                };
            }
            depth--;
        }
    }
    while (dir < 0 ? cursor.prevSibling() : cursor.nextSibling());
    return {
        start: firstToken,
        matched: false
    };
}
function $a97ccac5cf5f4f5d$var$matchPlainBrackets(state, pos, dir, tree, tokenType, maxScanDistance, brackets) {
    if (dir < 0 ? !pos : pos == state.doc.length) return null;
    let startCh = dir < 0 ? state.sliceDoc(pos - 1, pos) : state.sliceDoc(pos, pos + 1);
    let bracket = brackets.indexOf(startCh);
    if (bracket < 0 || bracket % 2 == 0 != dir > 0) return null;
    let startToken = {
        from: dir < 0 ? pos - 1 : pos,
        to: dir > 0 ? pos + 1 : pos
    };
    let iter = state.doc.iterRange(pos, dir > 0 ? state.doc.length : 0), depth = 0;
    for(let distance = 0; !iter.next().done && distance <= maxScanDistance;){
        let text = iter.value;
        if (dir < 0) distance += text.length;
        let basePos = pos + distance * dir;
        for(let pos = dir > 0 ? 0 : text.length - 1, end = dir > 0 ? text.length : -1; pos != end; pos += dir){
            let found = brackets.indexOf(text[pos]);
            if (found < 0 || tree.resolveInner(basePos + pos, 1).type != tokenType) continue;
            if (found % 2 == 0 == dir > 0) depth++;
            else if (depth == 1) return {
                start: startToken,
                end: {
                    from: basePos + pos,
                    to: basePos + pos + 1
                },
                matched: found >> 1 == bracket >> 1
            };
            else depth--;
        }
        if (dir > 0) distance += text.length;
    }
    return iter.done ? {
        start: startToken,
        matched: false
    } : null;
}
// Counts the column offset in a string, taking tabs into account.
// Used mostly to find indentation.
function $a97ccac5cf5f4f5d$var$countCol(string, end, tabSize, startIndex = 0, startValue = 0) {
    if (end == null) {
        end = string.search(/[^\s\u00a0]/);
        if (end == -1) end = string.length;
    }
    let n = startValue;
    for(let i = startIndex; i < end; i++)if (string.charCodeAt(i) == 9) n += tabSize - n % tabSize;
    else n++;
    return n;
}
/**
Encapsulates a single line of input. Given to stream syntax code,
which uses it to tokenize the content.
*/ class $a97ccac5cf5f4f5d$export$72a09304cc8c1940 {
    /**
    Create a stream.
    */ constructor(/**
    The line.
    */ string, tabSize, /**
    The current indent unit size.
    */ indentUnit, overrideIndent){
        this.string = string;
        this.tabSize = tabSize;
        this.indentUnit = indentUnit;
        this.overrideIndent = overrideIndent;
        /**
        The current position on the line.
        */ this.pos = 0;
        /**
        The start position of the current token.
        */ this.start = 0;
        this.lastColumnPos = 0;
        this.lastColumnValue = 0;
    }
    /**
    True if we are at the end of the line.
    */ eol() {
        return this.pos >= this.string.length;
    }
    /**
    True if we are at the start of the line.
    */ sol() {
        return this.pos == 0;
    }
    /**
    Get the next code unit after the current position, or undefined
    if we're at the end of the line.
    */ peek() {
        return this.string.charAt(this.pos) || undefined;
    }
    /**
    Read the next code unit and advance `this.pos`.
    */ next() {
        if (this.pos < this.string.length) return this.string.charAt(this.pos++);
    }
    /**
    Match the next character against the given string, regular
    expression, or predicate. Consume and return it if it matches.
    */ eat(match) {
        let ch = this.string.charAt(this.pos);
        let ok;
        if (typeof match == "string") ok = ch == match;
        else ok = ch && (match instanceof RegExp ? match.test(ch) : match(ch));
        if (ok) {
            ++this.pos;
            return ch;
        }
    }
    /**
    Continue matching characters that match the given string,
    regular expression, or predicate function. Return true if any
    characters were consumed.
    */ eatWhile(match) {
        let start = this.pos;
        while(this.eat(match));
        return this.pos > start;
    }
    /**
    Consume whitespace ahead of `this.pos`. Return true if any was
    found.
    */ eatSpace() {
        let start = this.pos;
        while(/[\s\u00a0]/.test(this.string.charAt(this.pos)))++this.pos;
        return this.pos > start;
    }
    /**
    Move to the end of the line.
    */ skipToEnd() {
        this.pos = this.string.length;
    }
    /**
    Move to directly before the given character, if found on the
    current line.
    */ skipTo(ch) {
        let found = this.string.indexOf(ch, this.pos);
        if (found > -1) {
            this.pos = found;
            return true;
        }
    }
    /**
    Move back `n` characters.
    */ backUp(n) {
        this.pos -= n;
    }
    /**
    Get the column position at `this.pos`.
    */ column() {
        if (this.lastColumnPos < this.start) {
            this.lastColumnValue = $a97ccac5cf5f4f5d$var$countCol(this.string, this.start, this.tabSize, this.lastColumnPos, this.lastColumnValue);
            this.lastColumnPos = this.start;
        }
        return this.lastColumnValue;
    }
    /**
    Get the indentation column of the current line.
    */ indentation() {
        var _a;
        return (_a = this.overrideIndent) !== null && _a !== void 0 ? _a : $a97ccac5cf5f4f5d$var$countCol(this.string, null, this.tabSize);
    }
    /**
    Match the input against the given string or regular expression
    (which should start with a `^`). Return true or the regexp match
    if it matches.
    
    Unless `consume` is set to `false`, this will move `this.pos`
    past the matched text.
    
    When matching a string `caseInsensitive` can be set to true to
    make the match case-insensitive.
    */ match(pattern, consume, caseInsensitive) {
        if (typeof pattern == "string") {
            let cased = (str)=>caseInsensitive ? str.toLowerCase() : str;
            let substr = this.string.substr(this.pos, pattern.length);
            if (cased(substr) == cased(pattern)) {
                if (consume !== false) this.pos += pattern.length;
                return true;
            } else return null;
        } else {
            let match = this.string.slice(this.pos).match(pattern);
            if (match && match.index > 0) return null;
            if (match && consume !== false) this.pos += match[0].length;
            return match;
        }
    }
    /**
    Get the current token.
    */ current() {
        return this.string.slice(this.start, this.pos);
    }
}
function $a97ccac5cf5f4f5d$var$fullParser(spec) {
    return {
        name: spec.name || "",
        token: spec.token,
        blankLine: spec.blankLine || (()=>{}),
        startState: spec.startState || (()=>true),
        copyState: spec.copyState || $a97ccac5cf5f4f5d$var$defaultCopyState,
        indent: spec.indent || (()=>null),
        languageData: spec.languageData || {},
        tokenTable: spec.tokenTable || $a97ccac5cf5f4f5d$var$noTokens,
        mergeTokens: spec.mergeTokens !== false
    };
}
function $a97ccac5cf5f4f5d$var$defaultCopyState(state) {
    if (typeof state != "object") return state;
    let newState = {};
    for(let prop in state){
        let val = state[prop];
        newState[prop] = val instanceof Array ? val.slice() : val;
    }
    return newState;
}
const $a97ccac5cf5f4f5d$var$IndentedFrom = /*@__PURE__*/ new WeakMap();
/**
A [language](https://codemirror.net/6/docs/ref/#language.Language) class based on a CodeMirror
5-style [streaming parser](https://codemirror.net/6/docs/ref/#language.StreamParser).
*/ class $a97ccac5cf5f4f5d$export$5ee3cc23916207d8 extends $a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a {
    constructor(parser){
        let data = $a97ccac5cf5f4f5d$export$b57f683f43553b99(parser.languageData);
        let p = $a97ccac5cf5f4f5d$var$fullParser(parser), self;
        let impl = new class extends (0, $ed739beecf769914$export$7acfa6ed01010e37) {
            createParse(input, fragments, ranges) {
                return new $a97ccac5cf5f4f5d$var$Parse(self, input, fragments, ranges);
            }
        };
        super(data, impl, [], parser.name);
        this.topNode = $a97ccac5cf5f4f5d$var$docID(data, this);
        self = this;
        this.streamParser = p;
        this.stateAfter = new (0, $ed739beecf769914$export$b8034b9bc18acd90)({
            perNode: true
        });
        this.tokenTable = parser.tokenTable ? new $a97ccac5cf5f4f5d$var$TokenTable(p.tokenTable) : $a97ccac5cf5f4f5d$var$defaultTokenTable;
    }
    /**
    Define a stream language.
    */ static define(spec) {
        return new $a97ccac5cf5f4f5d$export$5ee3cc23916207d8(spec);
    }
    /**
    @internal
    */ getIndent(cx) {
        let from = undefined;
        let { overrideIndentation: overrideIndentation } = cx.options;
        if (overrideIndentation) {
            from = $a97ccac5cf5f4f5d$var$IndentedFrom.get(cx.state);
            if (from != null && from < cx.pos - 1e4) from = undefined;
        }
        let start = $a97ccac5cf5f4f5d$var$findState(this, cx.node.tree, cx.node.from, cx.node.from, from !== null && from !== void 0 ? from : cx.pos), statePos, state;
        if (start) {
            state = start.state;
            statePos = start.pos + 1;
        } else {
            state = this.streamParser.startState(cx.unit);
            statePos = cx.node.from;
        }
        if (cx.pos - statePos > 10000 /* C.MaxIndentScanDist */ ) return null;
        while(statePos < cx.pos){
            let line = cx.state.doc.lineAt(statePos), end = Math.min(cx.pos, line.to);
            if (line.length) {
                let indentation = overrideIndentation ? overrideIndentation(line.from) : -1;
                let stream = new $a97ccac5cf5f4f5d$export$72a09304cc8c1940(line.text, cx.state.tabSize, cx.unit, indentation < 0 ? undefined : indentation);
                while(stream.pos < end - line.from)$a97ccac5cf5f4f5d$var$readToken(this.streamParser.token, stream, state);
            } else this.streamParser.blankLine(state, cx.unit);
            if (end == cx.pos) break;
            statePos = line.to + 1;
        }
        let line = cx.lineAt(cx.pos);
        if (overrideIndentation && from == null) $a97ccac5cf5f4f5d$var$IndentedFrom.set(cx.state, line.from);
        return this.streamParser.indent(state, /^\s*(.*)/.exec(line.text)[1], cx);
    }
    get allowsNesting() {
        return false;
    }
}
function $a97ccac5cf5f4f5d$var$findState(lang, tree, off, startPos, before) {
    let state = off >= startPos && off + tree.length <= before && tree.prop(lang.stateAfter);
    if (state) return {
        state: lang.streamParser.copyState(state),
        pos: off + tree.length
    };
    for(let i = tree.children.length - 1; i >= 0; i--){
        let child = tree.children[i], pos = off + tree.positions[i];
        let found = child instanceof (0, $ed739beecf769914$export$7fbedc92909ed28e) && pos < before && $a97ccac5cf5f4f5d$var$findState(lang, child, pos, startPos, before);
        if (found) return found;
    }
    return null;
}
function $a97ccac5cf5f4f5d$var$cutTree(lang, tree, from, to, inside) {
    if (inside && from <= 0 && to >= tree.length) return tree;
    if (!inside && from == 0 && tree.type == lang.topNode) inside = true;
    for(let i = tree.children.length - 1; i >= 0; i--){
        let pos = tree.positions[i], child = tree.children[i], inner;
        if (pos < to && child instanceof (0, $ed739beecf769914$export$7fbedc92909ed28e)) {
            if (!(inner = $a97ccac5cf5f4f5d$var$cutTree(lang, child, from - pos, to - pos, inside))) break;
            return !inside ? inner : new (0, $ed739beecf769914$export$7fbedc92909ed28e)(tree.type, tree.children.slice(0, i).concat(inner), tree.positions.slice(0, i + 1), pos + inner.length);
        }
    }
    return null;
}
function $a97ccac5cf5f4f5d$var$findStartInFragments(lang, fragments, startPos, endPos, editorState) {
    for (let f of fragments){
        let from = f.from + (f.openStart ? 25 : 0), to = f.to - (f.openEnd ? 25 : 0);
        let found = from <= startPos && to > startPos && $a97ccac5cf5f4f5d$var$findState(lang, f.tree, 0 - f.offset, startPos, to), tree;
        if (found && found.pos <= endPos && (tree = $a97ccac5cf5f4f5d$var$cutTree(lang, f.tree, startPos + f.offset, found.pos + f.offset, false))) return {
            state: found.state,
            tree: tree
        };
    }
    return {
        state: lang.streamParser.startState(editorState ? $a97ccac5cf5f4f5d$export$ad3205d09311a797(editorState) : 4),
        tree: (0, $ed739beecf769914$export$7fbedc92909ed28e).empty
    };
}
class $a97ccac5cf5f4f5d$var$Parse {
    constructor(lang, input, fragments, ranges){
        this.lang = lang;
        this.input = input;
        this.fragments = fragments;
        this.ranges = ranges;
        this.stoppedAt = null;
        this.chunks = [];
        this.chunkPos = [];
        this.chunk = [];
        this.chunkReused = undefined;
        this.rangeIndex = 0;
        this.to = ranges[ranges.length - 1].to;
        let context = $a97ccac5cf5f4f5d$export$3fcb7c01ff2a41fa.get(), from = ranges[0].from;
        let { state: state, tree: tree } = $a97ccac5cf5f4f5d$var$findStartInFragments(lang, fragments, from, this.to, context === null || context === void 0 ? void 0 : context.state);
        this.state = state;
        this.parsedPos = this.chunkStart = from + tree.length;
        for(let i = 0; i < tree.children.length; i++){
            this.chunks.push(tree.children[i]);
            this.chunkPos.push(tree.positions[i]);
        }
        if (context && this.parsedPos < context.viewport.from - 100000 /* C.MaxDistanceBeforeViewport */  && ranges.some((r)=>r.from <= context.viewport.from && r.to >= context.viewport.from)) {
            this.state = this.lang.streamParser.startState($a97ccac5cf5f4f5d$export$ad3205d09311a797(context.state));
            context.skipUntilInView(this.parsedPos, context.viewport.from);
            this.parsedPos = context.viewport.from;
        }
        this.moveRangeIndex();
    }
    advance() {
        let context = $a97ccac5cf5f4f5d$export$3fcb7c01ff2a41fa.get();
        let parseEnd = this.stoppedAt == null ? this.to : Math.min(this.to, this.stoppedAt);
        let end = Math.min(parseEnd, this.chunkStart + 512 /* C.ChunkSize */ );
        if (context) end = Math.min(end, context.viewport.to);
        while(this.parsedPos < end)this.parseLine(context);
        if (this.chunkStart < this.parsedPos) this.finishChunk();
        if (this.parsedPos >= parseEnd) return this.finish();
        if (context && this.parsedPos >= context.viewport.to) {
            context.skipUntilInView(this.parsedPos, parseEnd);
            return this.finish();
        }
        return null;
    }
    stopAt(pos) {
        this.stoppedAt = pos;
    }
    lineAfter(pos) {
        let chunk = this.input.chunk(pos);
        if (!this.input.lineChunks) {
            let eol = chunk.indexOf("\n");
            if (eol > -1) chunk = chunk.slice(0, eol);
        } else if (chunk == "\n") chunk = "";
        return pos + chunk.length <= this.to ? chunk : chunk.slice(0, this.to - pos);
    }
    nextLine() {
        let from = this.parsedPos, line = this.lineAfter(from), end = from + line.length;
        for(let index = this.rangeIndex;;){
            let rangeEnd = this.ranges[index].to;
            if (rangeEnd >= end) break;
            line = line.slice(0, rangeEnd - (end - line.length));
            index++;
            if (index == this.ranges.length) break;
            let rangeStart = this.ranges[index].from;
            let after = this.lineAfter(rangeStart);
            line += after;
            end = rangeStart + after.length;
        }
        return {
            line: line,
            end: end
        };
    }
    skipGapsTo(pos, offset, side) {
        for(;;){
            let end = this.ranges[this.rangeIndex].to, offPos = pos + offset;
            if (side > 0 ? end > offPos : end >= offPos) break;
            let start = this.ranges[++this.rangeIndex].from;
            offset += start - end;
        }
        return offset;
    }
    moveRangeIndex() {
        while(this.ranges[this.rangeIndex].to < this.parsedPos)this.rangeIndex++;
    }
    emitToken(id, from, to, offset) {
        let size = 4;
        if (this.ranges.length > 1) {
            offset = this.skipGapsTo(from, offset, 1);
            from += offset;
            let len0 = this.chunk.length;
            offset = this.skipGapsTo(to, offset, -1);
            to += offset;
            size += this.chunk.length - len0;
        }
        let last = this.chunk.length - 4;
        if (this.lang.streamParser.mergeTokens && size == 4 && last >= 0 && this.chunk[last] == id && this.chunk[last + 2] == from) this.chunk[last + 2] = to;
        else this.chunk.push(id, from, to, size);
        return offset;
    }
    parseLine(context) {
        let { line: line, end: end } = this.nextLine(), offset = 0, { streamParser: streamParser } = this.lang;
        let stream = new $a97ccac5cf5f4f5d$export$72a09304cc8c1940(line, context ? context.state.tabSize : 4, context ? $a97ccac5cf5f4f5d$export$ad3205d09311a797(context.state) : 2);
        if (stream.eol()) streamParser.blankLine(this.state, stream.indentUnit);
        else while(!stream.eol()){
            let token = $a97ccac5cf5f4f5d$var$readToken(streamParser.token, stream, this.state);
            if (token) offset = this.emitToken(this.lang.tokenTable.resolve(token), this.parsedPos + stream.start, this.parsedPos + stream.pos, offset);
            if (stream.start > 10000 /* C.MaxLineLength */ ) break;
        }
        this.parsedPos = end;
        this.moveRangeIndex();
        if (this.parsedPos < this.to) this.parsedPos++;
    }
    finishChunk() {
        let tree = (0, $ed739beecf769914$export$7fbedc92909ed28e).build({
            buffer: this.chunk,
            start: this.chunkStart,
            length: this.parsedPos - this.chunkStart,
            nodeSet: $a97ccac5cf5f4f5d$var$nodeSet,
            topID: 0,
            maxBufferLength: 512 /* C.ChunkSize */ ,
            reused: this.chunkReused
        });
        tree = new (0, $ed739beecf769914$export$7fbedc92909ed28e)(tree.type, tree.children, tree.positions, tree.length, [
            [
                this.lang.stateAfter,
                this.lang.streamParser.copyState(this.state)
            ]
        ]);
        this.chunks.push(tree);
        this.chunkPos.push(this.chunkStart - this.ranges[0].from);
        this.chunk = [];
        this.chunkReused = undefined;
        this.chunkStart = this.parsedPos;
    }
    finish() {
        return new (0, $ed739beecf769914$export$7fbedc92909ed28e)(this.lang.topNode, this.chunks, this.chunkPos, this.parsedPos - this.ranges[0].from).balance();
    }
}
function $a97ccac5cf5f4f5d$var$readToken(token, stream, state) {
    stream.start = stream.pos;
    for(let i = 0; i < 10; i++){
        let result = token(stream, state);
        if (stream.pos > stream.start) return result;
    }
    throw new Error("Stream parser failed to advance stream.");
}
const $a97ccac5cf5f4f5d$var$noTokens = /*@__PURE__*/ Object.create(null);
const $a97ccac5cf5f4f5d$var$typeArray = [
    (0, $ed739beecf769914$export$f06e977173f1857c).none
];
const $a97ccac5cf5f4f5d$var$nodeSet = /*@__PURE__*/ new (0, $ed739beecf769914$export$7fad5fb00d8de02c)($a97ccac5cf5f4f5d$var$typeArray);
const $a97ccac5cf5f4f5d$var$warned = [];
// Cache of node types by name and tags
const $a97ccac5cf5f4f5d$var$byTag = /*@__PURE__*/ Object.create(null);
const $a97ccac5cf5f4f5d$var$defaultTable = /*@__PURE__*/ Object.create(null);
for (let [legacyName, name] of [
    [
        "variable",
        "variableName"
    ],
    [
        "variable-2",
        "variableName.special"
    ],
    [
        "string-2",
        "string.special"
    ],
    [
        "def",
        "variableName.definition"
    ],
    [
        "tag",
        "tagName"
    ],
    [
        "attribute",
        "attributeName"
    ],
    [
        "type",
        "typeName"
    ],
    [
        "builtin",
        "variableName.standard"
    ],
    [
        "qualifier",
        "modifier"
    ],
    [
        "error",
        "invalid"
    ],
    [
        "header",
        "heading"
    ],
    [
        "property",
        "propertyName"
    ]
])$a97ccac5cf5f4f5d$var$defaultTable[legacyName] = /*@__PURE__*/ $a97ccac5cf5f4f5d$var$createTokenType($a97ccac5cf5f4f5d$var$noTokens, name);
class $a97ccac5cf5f4f5d$var$TokenTable {
    constructor(extra){
        this.extra = extra;
        this.table = Object.assign(Object.create(null), $a97ccac5cf5f4f5d$var$defaultTable);
    }
    resolve(tag) {
        return !tag ? 0 : this.table[tag] || (this.table[tag] = $a97ccac5cf5f4f5d$var$createTokenType(this.extra, tag));
    }
}
const $a97ccac5cf5f4f5d$var$defaultTokenTable = /*@__PURE__*/ new $a97ccac5cf5f4f5d$var$TokenTable($a97ccac5cf5f4f5d$var$noTokens);
function $a97ccac5cf5f4f5d$var$warnForPart(part, msg) {
    if ($a97ccac5cf5f4f5d$var$warned.indexOf(part) > -1) return;
    $a97ccac5cf5f4f5d$var$warned.push(part);
    console.warn(msg);
}
function $a97ccac5cf5f4f5d$var$createTokenType(extra, tagStr) {
    let tags$1 = [];
    for (let name of tagStr.split(" ")){
        let found = [];
        for (let part of name.split(".")){
            let value = extra[part] || (0, $a1ec9d683d365521$export$8b7a896ae75accbf)[part];
            if (!value) $a97ccac5cf5f4f5d$var$warnForPart(part, `Unknown highlighting tag ${part}`);
            else if (typeof value == "function") {
                if (!found.length) $a97ccac5cf5f4f5d$var$warnForPart(part, `Modifier ${part} used at start of tag`);
                else found = found.map(value);
            } else if (found.length) $a97ccac5cf5f4f5d$var$warnForPart(part, `Tag ${part} used as modifier`);
            else found = Array.isArray(value) ? value : [
                value
            ];
        }
        for (let tag of found)tags$1.push(tag);
    }
    if (!tags$1.length) return 0;
    let name = tagStr.replace(/ /g, "_"), key = name + " " + tags$1.map((t)=>t.id);
    let known = $a97ccac5cf5f4f5d$var$byTag[key];
    if (known) return known.id;
    let type = $a97ccac5cf5f4f5d$var$byTag[key] = (0, $ed739beecf769914$export$f06e977173f1857c).define({
        id: $a97ccac5cf5f4f5d$var$typeArray.length,
        name: name,
        props: [
            (0, $a1ec9d683d365521$export$c537e79bb7b94295)({
                [name]: tags$1
            })
        ]
    });
    $a97ccac5cf5f4f5d$var$typeArray.push(type);
    return type.id;
}
function $a97ccac5cf5f4f5d$var$docID(data, lang) {
    let type = (0, $ed739beecf769914$export$f06e977173f1857c).define({
        id: $a97ccac5cf5f4f5d$var$typeArray.length,
        name: "Document",
        props: [
            $a97ccac5cf5f4f5d$export$27a2e78097f753f7.add(()=>data),
            $a97ccac5cf5f4f5d$export$72c7d4c52b3c6460.add(()=>(cx)=>lang.getIndent(cx))
        ],
        top: true
    });
    $a97ccac5cf5f4f5d$var$typeArray.push(type);
    return type;
}
function $a97ccac5cf5f4f5d$var$buildForLine(line) {
    return line.length <= 4096 && /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\ufb50-\ufdff]/.test(line);
}
function $a97ccac5cf5f4f5d$var$textHasRTL(text) {
    for(let i = text.iter(); !i.next().done;)if ($a97ccac5cf5f4f5d$var$buildForLine(i.value)) return true;
    return false;
}
function $a97ccac5cf5f4f5d$var$changeAddsRTL(change) {
    let added = false;
    change.iterChanges((fA, tA, fB, tB, ins)=>{
        if (!added && $a97ccac5cf5f4f5d$var$textHasRTL(ins)) added = true;
    });
    return added;
}
const $a97ccac5cf5f4f5d$var$alwaysIsolate = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine: (values)=>values.some((x)=>x)
});
/**
Make sure nodes
[marked](https://lezer.codemirror.net/docs/ref/#common.NodeProp^isolate)
as isolating for bidirectional text are rendered in a way that
isolates them from the surrounding text.
*/ function $a97ccac5cf5f4f5d$export$9c455d2bd760f210(options = {}) {
    let extensions = [
        $a97ccac5cf5f4f5d$var$isolateMarks
    ];
    if (options.alwaysIsolate) extensions.push($a97ccac5cf5f4f5d$var$alwaysIsolate.of(true));
    return extensions;
}
const $a97ccac5cf5f4f5d$var$isolateMarks = /*@__PURE__*/ (0, $7beee9608540d2c3$export$44d5eccfd62adda7).fromClass(class {
    constructor(view){
        this.always = view.state.facet($a97ccac5cf5f4f5d$var$alwaysIsolate) || view.textDirection != (0, $7beee9608540d2c3$export$cacd6541cfeeb6c1).LTR || view.state.facet((0, $7beee9608540d2c3$export$eece2fccabbb77c5).perLineTextDirection);
        this.hasRTL = !this.always && $a97ccac5cf5f4f5d$var$textHasRTL(view.state.doc);
        this.tree = $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1(view.state);
        this.decorations = this.always || this.hasRTL ? $a97ccac5cf5f4f5d$var$buildDeco(view, this.tree, this.always) : (0, $7beee9608540d2c3$export$10e30b733df217ea).none;
    }
    update(update) {
        let always = update.state.facet($a97ccac5cf5f4f5d$var$alwaysIsolate) || update.view.textDirection != (0, $7beee9608540d2c3$export$cacd6541cfeeb6c1).LTR || update.state.facet((0, $7beee9608540d2c3$export$eece2fccabbb77c5).perLineTextDirection);
        if (!always && !this.hasRTL && $a97ccac5cf5f4f5d$var$changeAddsRTL(update.changes)) this.hasRTL = true;
        if (!always && !this.hasRTL) return;
        let tree = $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1(update.state);
        if (always != this.always || tree != this.tree || update.docChanged || update.viewportChanged) {
            this.tree = tree;
            this.always = always;
            this.decorations = $a97ccac5cf5f4f5d$var$buildDeco(update.view, tree, always);
        }
    }
}, {
    provide: (plugin)=>{
        function access(view) {
            var _a, _b;
            return (_b = (_a = view.plugin(plugin)) === null || _a === void 0 ? void 0 : _a.decorations) !== null && _b !== void 0 ? _b : (0, $7beee9608540d2c3$export$10e30b733df217ea).none;
        }
        return [
            (0, $7beee9608540d2c3$export$eece2fccabbb77c5).outerDecorations.of(access),
            (0, $6295c6875f57e3ee$export$b92464a736444411).lowest((0, $7beee9608540d2c3$export$eece2fccabbb77c5).bidiIsolatedRanges.of(access))
        ];
    }
});
function $a97ccac5cf5f4f5d$var$buildDeco(view, tree, always) {
    let deco = new (0, $6295c6875f57e3ee$export$89e09ce03c7e8594)();
    let ranges = view.visibleRanges;
    if (!always) ranges = $a97ccac5cf5f4f5d$var$clipRTLLines(ranges, view.state.doc);
    for (let { from: from, to: to } of ranges)tree.iterate({
        enter: (node)=>{
            let iso = node.type.prop((0, $ed739beecf769914$export$b8034b9bc18acd90).isolate);
            if (iso) deco.add(node.from, node.to, $a97ccac5cf5f4f5d$var$marks[iso]);
        },
        from: from,
        to: to
    });
    return deco.finish();
}
function $a97ccac5cf5f4f5d$var$clipRTLLines(ranges, doc) {
    let cur = doc.iter(), pos = 0, result = [], last = null;
    for (let { from: from, to: to } of ranges){
        if (last && last.to > from) {
            from = last.to;
            if (from >= to) continue;
        }
        if (pos + cur.value.length < from) {
            cur.next(from - (pos + cur.value.length));
            pos = from;
        }
        for(;;){
            let start = pos, end = pos + cur.value.length;
            if (!cur.lineBreak && $a97ccac5cf5f4f5d$var$buildForLine(cur.value)) {
                if (last && last.to > start - 10) last.to = Math.min(to, end);
                else result.push(last = {
                    from: start,
                    to: Math.min(to, end)
                });
            }
            if (end >= to) break;
            pos = end;
            cur.next();
        }
    }
    return result;
}
const $a97ccac5cf5f4f5d$var$marks = {
    rtl: /*@__PURE__*/ (0, $7beee9608540d2c3$export$10e30b733df217ea).mark({
        class: "cm-iso",
        inclusive: true,
        attributes: {
            dir: "rtl"
        },
        bidiIsolate: (0, $7beee9608540d2c3$export$cacd6541cfeeb6c1).RTL
    }),
    ltr: /*@__PURE__*/ (0, $7beee9608540d2c3$export$10e30b733df217ea).mark({
        class: "cm-iso",
        inclusive: true,
        attributes: {
            dir: "ltr"
        },
        bidiIsolate: (0, $7beee9608540d2c3$export$cacd6541cfeeb6c1).LTR
    }),
    auto: /*@__PURE__*/ (0, $7beee9608540d2c3$export$10e30b733df217ea).mark({
        class: "cm-iso",
        inclusive: true,
        attributes: {
            dir: "auto"
        },
        bidiIsolate: null
    })
};



/**
Comment or uncomment the current selection. Will use line comments
if available, otherwise falling back to block comments.
*/ const $032754016b6293d7$export$afbcdd0bff36c567 = (target)=>{
    let { state: state } = target, line = state.doc.lineAt(state.selection.main.from), config = $032754016b6293d7$var$getConfig(target.state, line.from);
    return config.line ? $032754016b6293d7$export$63a9abf96aaa3c5d(target) : config.block ? $032754016b6293d7$export$e88d9eff7cafcc34(target) : false;
};
function $032754016b6293d7$var$command(f, option) {
    return ({ state: state, dispatch: dispatch })=>{
        if (state.readOnly) return false;
        let tr = f(option, state);
        if (!tr) return false;
        dispatch(state.update(tr));
        return true;
    };
}
/**
Comment or uncomment the current selection using line comments.
The line comment syntax is taken from the
[`commentTokens`](https://codemirror.net/6/docs/ref/#commands.CommentTokens) [language
data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt).
*/ const $032754016b6293d7$export$63a9abf96aaa3c5d = /*@__PURE__*/ $032754016b6293d7$var$command($032754016b6293d7$var$changeLineComment, 0 /* CommentOption.Toggle */ );
/**
Comment the current selection using line comments.
*/ const $032754016b6293d7$export$5d080f5a78d4f5b3 = /*@__PURE__*/ $032754016b6293d7$var$command($032754016b6293d7$var$changeLineComment, 1 /* CommentOption.Comment */ );
/**
Uncomment the current selection using line comments.
*/ const $032754016b6293d7$export$5a43b8c36509b6fd = /*@__PURE__*/ $032754016b6293d7$var$command($032754016b6293d7$var$changeLineComment, 2 /* CommentOption.Uncomment */ );
/**
Comment or uncomment the current selection using block comments.
The block comment syntax is taken from the
[`commentTokens`](https://codemirror.net/6/docs/ref/#commands.CommentTokens) [language
data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt).
*/ const $032754016b6293d7$export$19d6fa84ce3a55ab = /*@__PURE__*/ $032754016b6293d7$var$command($032754016b6293d7$var$changeBlockComment, 0 /* CommentOption.Toggle */ );
/**
Comment the current selection using block comments.
*/ const $032754016b6293d7$export$f2ae215066c4835a = /*@__PURE__*/ $032754016b6293d7$var$command($032754016b6293d7$var$changeBlockComment, 1 /* CommentOption.Comment */ );
/**
Uncomment the current selection using block comments.
*/ const $032754016b6293d7$export$fddcfb23c3a05835 = /*@__PURE__*/ $032754016b6293d7$var$command($032754016b6293d7$var$changeBlockComment, 2 /* CommentOption.Uncomment */ );
/**
Comment or uncomment the lines around the current selection using
block comments.
*/ const $032754016b6293d7$export$e88d9eff7cafcc34 = /*@__PURE__*/ $032754016b6293d7$var$command((o, s)=>$032754016b6293d7$var$changeBlockComment(o, s, $032754016b6293d7$var$selectedLineRanges(s)), 0 /* CommentOption.Toggle */ );
function $032754016b6293d7$var$getConfig(state, pos) {
    let data = state.languageDataAt("commentTokens", pos, 1);
    return data.length ? data[0] : {};
}
const $032754016b6293d7$var$SearchMargin = 50;
/**
Determines if the given range is block-commented in the given
state.
*/ function $032754016b6293d7$var$findBlockComment(state, { open: open, close: close }, from, to) {
    let textBefore = state.sliceDoc(from - $032754016b6293d7$var$SearchMargin, from);
    let textAfter = state.sliceDoc(to, to + $032754016b6293d7$var$SearchMargin);
    let spaceBefore = /\s*$/.exec(textBefore)[0].length, spaceAfter = /^\s*/.exec(textAfter)[0].length;
    let beforeOff = textBefore.length - spaceBefore;
    if (textBefore.slice(beforeOff - open.length, beforeOff) == open && textAfter.slice(spaceAfter, spaceAfter + close.length) == close) return {
        open: {
            pos: from - spaceBefore,
            margin: spaceBefore && 1
        },
        close: {
            pos: to + spaceAfter,
            margin: spaceAfter && 1
        }
    };
    let startText, endText;
    if (to - from <= 2 * $032754016b6293d7$var$SearchMargin) startText = endText = state.sliceDoc(from, to);
    else {
        startText = state.sliceDoc(from, from + $032754016b6293d7$var$SearchMargin);
        endText = state.sliceDoc(to - $032754016b6293d7$var$SearchMargin, to);
    }
    let startSpace = /^\s*/.exec(startText)[0].length, endSpace = /\s*$/.exec(endText)[0].length;
    let endOff = endText.length - endSpace - close.length;
    if (startText.slice(startSpace, startSpace + open.length) == open && endText.slice(endOff, endOff + close.length) == close) return {
        open: {
            pos: from + startSpace + open.length,
            margin: /\s/.test(startText.charAt(startSpace + open.length)) ? 1 : 0
        },
        close: {
            pos: to - endSpace - close.length,
            margin: /\s/.test(endText.charAt(endOff - 1)) ? 1 : 0
        }
    };
    return null;
}
function $032754016b6293d7$var$selectedLineRanges(state) {
    let ranges = [];
    for (let r of state.selection.ranges){
        let fromLine = state.doc.lineAt(r.from);
        let toLine = r.to <= fromLine.to ? fromLine : state.doc.lineAt(r.to);
        if (toLine.from > fromLine.from && toLine.from == r.to) toLine = r.to == fromLine.to + 1 ? fromLine : state.doc.lineAt(r.to - 1);
        let last = ranges.length - 1;
        if (last >= 0 && ranges[last].to > fromLine.from) ranges[last].to = toLine.to;
        else ranges.push({
            from: fromLine.from + /^\s*/.exec(fromLine.text)[0].length,
            to: toLine.to
        });
    }
    return ranges;
}
// Performs toggle, comment and uncomment of block comments in
// languages that support them.
function $032754016b6293d7$var$changeBlockComment(option, state, ranges = state.selection.ranges) {
    let tokens = ranges.map((r)=>$032754016b6293d7$var$getConfig(state, r.from).block);
    if (!tokens.every((c)=>c)) return null;
    let comments = ranges.map((r, i)=>$032754016b6293d7$var$findBlockComment(state, tokens[i], r.from, r.to));
    if (option != 2 /* CommentOption.Uncomment */  && !comments.every((c)=>c)) return {
        changes: state.changes(ranges.map((range, i)=>{
            if (comments[i]) return [];
            return [
                {
                    from: range.from,
                    insert: tokens[i].open + " "
                },
                {
                    from: range.to,
                    insert: " " + tokens[i].close
                }
            ];
        }))
    };
    else if (option != 1 /* CommentOption.Comment */  && comments.some((c)=>c)) {
        let changes = [];
        for(let i = 0, comment; i < comments.length; i++)if (comment = comments[i]) {
            let token = tokens[i], { open: open, close: close } = comment;
            changes.push({
                from: open.pos - token.open.length,
                to: open.pos + open.margin
            }, {
                from: close.pos - close.margin,
                to: close.pos + token.close.length
            });
        }
        return {
            changes: changes
        };
    }
    return null;
}
// Performs toggle, comment and uncomment of line comments.
function $032754016b6293d7$var$changeLineComment(option, state, ranges = state.selection.ranges) {
    let lines = [];
    let prevLine = -1;
    ranges: for (let { from: from, to: to } of ranges){
        let startI = lines.length, minIndent = 1e9, token;
        for(let pos = from; pos <= to;){
            let line = state.doc.lineAt(pos);
            if (token == undefined) {
                token = $032754016b6293d7$var$getConfig(state, line.from).line;
                if (!token) continue ranges;
            }
            if (line.from > prevLine && (from == to || to > line.from)) {
                prevLine = line.from;
                let indent = /^\s*/.exec(line.text)[0].length;
                let empty = indent == line.length;
                let comment = line.text.slice(indent, indent + token.length) == token ? indent : -1;
                if (indent < line.text.length && indent < minIndent) minIndent = indent;
                lines.push({
                    line: line,
                    comment: comment,
                    token: token,
                    indent: indent,
                    empty: empty,
                    single: false
                });
            }
            pos = line.to + 1;
        }
        if (minIndent < 1e9) {
            for(let i = startI; i < lines.length; i++)if (lines[i].indent < lines[i].line.text.length) lines[i].indent = minIndent;
        }
        if (lines.length == startI + 1) lines[startI].single = true;
    }
    if (option != 2 /* CommentOption.Uncomment */  && lines.some((l)=>l.comment < 0 && (!l.empty || l.single))) {
        let changes = [];
        for (let { line: line, token: token, indent: indent, empty: empty, single: single } of lines)if (single || !empty) changes.push({
            from: line.from + indent,
            insert: token + " "
        });
        let changeSet = state.changes(changes);
        return {
            changes: changeSet,
            selection: state.selection.map(changeSet, 1)
        };
    } else if (option != 1 /* CommentOption.Comment */  && lines.some((l)=>l.comment >= 0)) {
        let changes = [];
        for (let { line: line, comment: comment, token: token } of lines)if (comment >= 0) {
            let from = line.from + comment, to = from + token.length;
            if (line.text[to - line.from] == " ") to++;
            changes.push({
                from: from,
                to: to
            });
        }
        return {
            changes: changes
        };
    }
    return null;
}
const $032754016b6293d7$var$fromHistory = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$9279461326b8700a).define();
/**
Transaction annotation that will prevent that transaction from
being combined with other transactions in the undo history. Given
`"before"`, it'll prevent merging with previous transactions. With
`"after"`, subsequent transactions won't be combined with this
one. With `"full"`, the transaction is isolated on both sides.
*/ const $032754016b6293d7$export$33e0bb25992f9954 = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$9279461326b8700a).define();
/**
This facet provides a way to register functions that, given a
transaction, provide a set of effects that the history should
store when inverting the transaction. This can be used to
integrate some kinds of effects in the history, so that they can
be undone (and redone again).
*/ const $032754016b6293d7$export$edb12867fb9b2023 = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $032754016b6293d7$var$historyConfig = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        return (0, $6295c6875f57e3ee$export$4e19c0b693794a7e)(configs, {
            minDepth: 100,
            newGroupDelay: 500,
            joinToEvent: (_t, isAdjacent)=>isAdjacent
        }, {
            minDepth: Math.max,
            newGroupDelay: Math.min,
            joinToEvent: (a, b)=>(tr, adj)=>a(tr, adj) || b(tr, adj)
        });
    }
});
const $032754016b6293d7$var$historyField_ = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$34381b1ce2130245).define({
    create () {
        return $032754016b6293d7$var$HistoryState.empty;
    },
    update (state, tr) {
        let config = tr.state.facet($032754016b6293d7$var$historyConfig);
        let fromHist = tr.annotation($032754016b6293d7$var$fromHistory);
        if (fromHist) {
            let item = $032754016b6293d7$var$HistEvent.fromTransaction(tr, fromHist.selection), from = fromHist.side;
            let other = from == 0 /* BranchName.Done */  ? state.undone : state.done;
            if (item) other = $032754016b6293d7$var$updateBranch(other, other.length, config.minDepth, item);
            else other = $032754016b6293d7$var$addSelection(other, tr.startState.selection);
            return new $032754016b6293d7$var$HistoryState(from == 0 /* BranchName.Done */  ? fromHist.rest : other, from == 0 /* BranchName.Done */  ? other : fromHist.rest);
        }
        let isolate = tr.annotation($032754016b6293d7$export$33e0bb25992f9954);
        if (isolate == "full" || isolate == "before") state = state.isolate();
        if (tr.annotation((0, $6295c6875f57e3ee$export$febc5573c75cefb0).addToHistory) === false) return !tr.changes.empty ? state.addMapping(tr.changes.desc) : state;
        let event = $032754016b6293d7$var$HistEvent.fromTransaction(tr);
        let time = tr.annotation((0, $6295c6875f57e3ee$export$febc5573c75cefb0).time), userEvent = tr.annotation((0, $6295c6875f57e3ee$export$febc5573c75cefb0).userEvent);
        if (event) state = state.addChanges(event, time, userEvent, config, tr);
        else if (tr.selection) state = state.addSelection(tr.startState.selection, time, userEvent, config.newGroupDelay);
        if (isolate == "full" || isolate == "after") state = state.isolate();
        return state;
    },
    toJSON (value) {
        return {
            done: value.done.map((e)=>e.toJSON()),
            undone: value.undone.map((e)=>e.toJSON())
        };
    },
    fromJSON (json) {
        return new $032754016b6293d7$var$HistoryState(json.done.map($032754016b6293d7$var$HistEvent.fromJSON), json.undone.map($032754016b6293d7$var$HistEvent.fromJSON));
    }
});
/**
Create a history extension with the given configuration.
*/ function $032754016b6293d7$export$55abd4691b317664(config = {}) {
    return [
        $032754016b6293d7$var$historyField_,
        $032754016b6293d7$var$historyConfig.of(config),
        (0, $7beee9608540d2c3$export$eece2fccabbb77c5).domEventHandlers({
            beforeinput (e, view) {
                let command = e.inputType == "historyUndo" ? $032754016b6293d7$export$21f930c44940fd98 : e.inputType == "historyRedo" ? $032754016b6293d7$export$1688e416fee0a49e : null;
                if (!command) return false;
                e.preventDefault();
                return command(view);
            }
        })
    ];
}
/**
The state field used to store the history data. Should probably
only be used when you want to
[serialize](https://codemirror.net/6/docs/ref/#state.EditorState.toJSON) or
[deserialize](https://codemirror.net/6/docs/ref/#state.EditorState^fromJSON) state objects in a way
that preserves history.
*/ const $032754016b6293d7$export$c00598b6ceeb3e9 = $032754016b6293d7$var$historyField_;
function $032754016b6293d7$var$cmd(side, selection) {
    return function({ state: state, dispatch: dispatch }) {
        if (!selection && state.readOnly) return false;
        let historyState = state.field($032754016b6293d7$var$historyField_, false);
        if (!historyState) return false;
        let tr = historyState.pop(side, state, selection);
        if (!tr) return false;
        dispatch(tr);
        return true;
    };
}
/**
Undo a single group of history events. Returns false if no group
was available.
*/ const $032754016b6293d7$export$21f930c44940fd98 = /*@__PURE__*/ $032754016b6293d7$var$cmd(0 /* BranchName.Done */ , false);
/**
Redo a group of history events. Returns false if no group was
available.
*/ const $032754016b6293d7$export$1688e416fee0a49e = /*@__PURE__*/ $032754016b6293d7$var$cmd(1 /* BranchName.Undone */ , false);
/**
Undo a change or selection change.
*/ const $032754016b6293d7$export$43103d47530fe49f = /*@__PURE__*/ $032754016b6293d7$var$cmd(0 /* BranchName.Done */ , true);
/**
Redo a change or selection change.
*/ const $032754016b6293d7$export$2d87af80f1777f20 = /*@__PURE__*/ $032754016b6293d7$var$cmd(1 /* BranchName.Undone */ , true);
function $032754016b6293d7$var$depth(side) {
    return function(state) {
        let histState = state.field($032754016b6293d7$var$historyField_, false);
        if (!histState) return 0;
        let branch = side == 0 /* BranchName.Done */  ? histState.done : histState.undone;
        return branch.length - (branch.length && !branch[0].changes ? 1 : 0);
    };
}
/**
The amount of undoable change events available in a given state.
*/ const $032754016b6293d7$export$f8a176c2b9a10bdb = /*@__PURE__*/ $032754016b6293d7$var$depth(0 /* BranchName.Done */ );
/**
The amount of redoable change events available in a given state.
*/ const $032754016b6293d7$export$3ffe6b288e7d941b = /*@__PURE__*/ $032754016b6293d7$var$depth(1 /* BranchName.Undone */ );
// History events store groups of changes or effects that need to be
// undone/redone together.
class $032754016b6293d7$var$HistEvent {
    constructor(// The changes in this event. Normal events hold at least one
    // change or effect. But it may be necessary to store selection
    // events before the first change, in which case a special type of
    // instance is created which doesn't hold any changes, with
    // changes == startSelection == undefined
    changes, // The effects associated with this event
    effects, // Accumulated mapping (from addToHistory==false) that should be
    // applied to events below this one.
    mapped, // The selection before this event
    startSelection, // Stores selection changes after this event, to be used for
    // selection undo/redo.
    selectionsAfter){
        this.changes = changes;
        this.effects = effects;
        this.mapped = mapped;
        this.startSelection = startSelection;
        this.selectionsAfter = selectionsAfter;
    }
    setSelAfter(after) {
        return new $032754016b6293d7$var$HistEvent(this.changes, this.effects, this.mapped, this.startSelection, after);
    }
    toJSON() {
        var _a, _b, _c;
        return {
            changes: (_a = this.changes) === null || _a === void 0 ? void 0 : _a.toJSON(),
            mapped: (_b = this.mapped) === null || _b === void 0 ? void 0 : _b.toJSON(),
            startSelection: (_c = this.startSelection) === null || _c === void 0 ? void 0 : _c.toJSON(),
            selectionsAfter: this.selectionsAfter.map((s)=>s.toJSON())
        };
    }
    static fromJSON(json) {
        return new $032754016b6293d7$var$HistEvent(json.changes && (0, $6295c6875f57e3ee$export$29d7fbdcb1f8b71c).fromJSON(json.changes), [], json.mapped && (0, $6295c6875f57e3ee$export$34b6a936f2bb06a2).fromJSON(json.mapped), json.startSelection && (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).fromJSON(json.startSelection), json.selectionsAfter.map((0, $6295c6875f57e3ee$export$3bb1bd44aee62999).fromJSON));
    }
    // This does not check `addToHistory` and such, it assumes the
    // transaction needs to be converted to an item. Returns null when
    // there are no changes or effects in the transaction.
    static fromTransaction(tr, selection) {
        let effects = $032754016b6293d7$var$none;
        for (let invert of tr.startState.facet($032754016b6293d7$export$edb12867fb9b2023)){
            let result = invert(tr);
            if (result.length) effects = effects.concat(result);
        }
        if (!effects.length && tr.changes.empty) return null;
        return new $032754016b6293d7$var$HistEvent(tr.changes.invert(tr.startState.doc), effects, undefined, selection || tr.startState.selection, $032754016b6293d7$var$none);
    }
    static selection(selections) {
        return new $032754016b6293d7$var$HistEvent(undefined, $032754016b6293d7$var$none, undefined, undefined, selections);
    }
}
function $032754016b6293d7$var$updateBranch(branch, to, maxLen, newEvent) {
    let start = to + 1 > maxLen + 20 ? to - maxLen - 1 : 0;
    let newBranch = branch.slice(start, to);
    newBranch.push(newEvent);
    return newBranch;
}
function $032754016b6293d7$var$isAdjacent(a, b) {
    let ranges = [], isAdjacent = false;
    a.iterChangedRanges((f, t)=>ranges.push(f, t));
    b.iterChangedRanges((_f, _t, f, t)=>{
        for(let i = 0; i < ranges.length;){
            let from = ranges[i++], to = ranges[i++];
            if (t >= from && f <= to) isAdjacent = true;
        }
    });
    return isAdjacent;
}
function $032754016b6293d7$var$eqSelectionShape(a, b) {
    return a.ranges.length == b.ranges.length && a.ranges.filter((r, i)=>r.empty != b.ranges[i].empty).length === 0;
}
function $032754016b6293d7$var$conc(a, b) {
    return !a.length ? b : !b.length ? a : a.concat(b);
}
const $032754016b6293d7$var$none = [];
const $032754016b6293d7$var$MaxSelectionsPerEvent = 200;
function $032754016b6293d7$var$addSelection(branch, selection) {
    if (!branch.length) return [
        $032754016b6293d7$var$HistEvent.selection([
            selection
        ])
    ];
    else {
        let lastEvent = branch[branch.length - 1];
        let sels = lastEvent.selectionsAfter.slice(Math.max(0, lastEvent.selectionsAfter.length - $032754016b6293d7$var$MaxSelectionsPerEvent));
        if (sels.length && sels[sels.length - 1].eq(selection)) return branch;
        sels.push(selection);
        return $032754016b6293d7$var$updateBranch(branch, branch.length - 1, 1e9, lastEvent.setSelAfter(sels));
    }
}
// Assumes the top item has one or more selectionAfter values
function $032754016b6293d7$var$popSelection(branch) {
    let last = branch[branch.length - 1];
    let newBranch = branch.slice();
    newBranch[branch.length - 1] = last.setSelAfter(last.selectionsAfter.slice(0, last.selectionsAfter.length - 1));
    return newBranch;
}
// Add a mapping to the top event in the given branch. If this maps
// away all the changes and effects in that item, drop it and
// propagate the mapping to the next item.
function $032754016b6293d7$var$addMappingToBranch(branch, mapping) {
    if (!branch.length) return branch;
    let length = branch.length, selections = $032754016b6293d7$var$none;
    while(length){
        let event = $032754016b6293d7$var$mapEvent(branch[length - 1], mapping, selections);
        if (event.changes && !event.changes.empty || event.effects.length) {
            let result = branch.slice(0, length);
            result[length - 1] = event;
            return result;
        } else {
            mapping = event.mapped;
            length--;
            selections = event.selectionsAfter;
        }
    }
    return selections.length ? [
        $032754016b6293d7$var$HistEvent.selection(selections)
    ] : $032754016b6293d7$var$none;
}
function $032754016b6293d7$var$mapEvent(event, mapping, extraSelections) {
    let selections = $032754016b6293d7$var$conc(event.selectionsAfter.length ? event.selectionsAfter.map((s)=>s.map(mapping)) : $032754016b6293d7$var$none, extraSelections);
    // Change-less events don't store mappings (they are always the last event in a branch)
    if (!event.changes) return $032754016b6293d7$var$HistEvent.selection(selections);
    let mappedChanges = event.changes.map(mapping), before = mapping.mapDesc(event.changes, true);
    let fullMapping = event.mapped ? event.mapped.composeDesc(before) : before;
    return new $032754016b6293d7$var$HistEvent(mappedChanges, (0, $6295c6875f57e3ee$export$95000d4efaa4321f).mapEffects(event.effects, mapping), fullMapping, event.startSelection.map(before), selections);
}
const $032754016b6293d7$var$joinableUserEvent = /^(input\.type|delete)($|\.)/;
class $032754016b6293d7$var$HistoryState {
    constructor(done, undone, prevTime = 0, prevUserEvent){
        this.done = done;
        this.undone = undone;
        this.prevTime = prevTime;
        this.prevUserEvent = prevUserEvent;
    }
    isolate() {
        return this.prevTime ? new $032754016b6293d7$var$HistoryState(this.done, this.undone) : this;
    }
    addChanges(event, time, userEvent, config, tr) {
        let done = this.done, lastEvent = done[done.length - 1];
        if (lastEvent && lastEvent.changes && !lastEvent.changes.empty && event.changes && (!userEvent || $032754016b6293d7$var$joinableUserEvent.test(userEvent)) && (!lastEvent.selectionsAfter.length && time - this.prevTime < config.newGroupDelay && config.joinToEvent(tr, $032754016b6293d7$var$isAdjacent(lastEvent.changes, event.changes)) || // For compose (but not compose.start) events, always join with previous event
        userEvent == "input.type.compose")) done = $032754016b6293d7$var$updateBranch(done, done.length - 1, config.minDepth, new $032754016b6293d7$var$HistEvent(event.changes.compose(lastEvent.changes), $032754016b6293d7$var$conc((0, $6295c6875f57e3ee$export$95000d4efaa4321f).mapEffects(event.effects, lastEvent.changes), lastEvent.effects), lastEvent.mapped, lastEvent.startSelection, $032754016b6293d7$var$none));
        else done = $032754016b6293d7$var$updateBranch(done, done.length, config.minDepth, event);
        return new $032754016b6293d7$var$HistoryState(done, $032754016b6293d7$var$none, time, userEvent);
    }
    addSelection(selection, time, userEvent, newGroupDelay) {
        let last = this.done.length ? this.done[this.done.length - 1].selectionsAfter : $032754016b6293d7$var$none;
        if (last.length > 0 && time - this.prevTime < newGroupDelay && userEvent == this.prevUserEvent && userEvent && /^select($|\.)/.test(userEvent) && $032754016b6293d7$var$eqSelectionShape(last[last.length - 1], selection)) return this;
        return new $032754016b6293d7$var$HistoryState($032754016b6293d7$var$addSelection(this.done, selection), this.undone, time, userEvent);
    }
    addMapping(mapping) {
        return new $032754016b6293d7$var$HistoryState($032754016b6293d7$var$addMappingToBranch(this.done, mapping), $032754016b6293d7$var$addMappingToBranch(this.undone, mapping), this.prevTime, this.prevUserEvent);
    }
    pop(side, state, onlySelection) {
        let branch = side == 0 /* BranchName.Done */  ? this.done : this.undone;
        if (branch.length == 0) return null;
        let event = branch[branch.length - 1], selection = event.selectionsAfter[0] || (event.startSelection ? event.startSelection.map(event.changes.invertedDesc, 1) : state.selection);
        if (onlySelection && event.selectionsAfter.length) return state.update({
            selection: event.selectionsAfter[event.selectionsAfter.length - 1],
            annotations: $032754016b6293d7$var$fromHistory.of({
                side: side,
                rest: $032754016b6293d7$var$popSelection(branch),
                selection: selection
            }),
            userEvent: side == 0 /* BranchName.Done */  ? "select.undo" : "select.redo",
            scrollIntoView: true
        });
        else if (!event.changes) return null;
        else {
            let rest = branch.length == 1 ? $032754016b6293d7$var$none : branch.slice(0, branch.length - 1);
            if (event.mapped) rest = $032754016b6293d7$var$addMappingToBranch(rest, event.mapped);
            return state.update({
                changes: event.changes,
                selection: event.startSelection,
                effects: event.effects,
                annotations: $032754016b6293d7$var$fromHistory.of({
                    side: side,
                    rest: rest,
                    selection: selection
                }),
                filter: false,
                userEvent: side == 0 /* BranchName.Done */  ? "undo" : "redo",
                scrollIntoView: true
            });
        }
    }
}
$032754016b6293d7$var$HistoryState.empty = /*@__PURE__*/ new $032754016b6293d7$var$HistoryState($032754016b6293d7$var$none, $032754016b6293d7$var$none);
/**
Default key bindings for the undo history.

- Mod-z: [`undo`](https://codemirror.net/6/docs/ref/#commands.undo).
- Mod-y (Mod-Shift-z on macOS) + Ctrl-Shift-z on Linux: [`redo`](https://codemirror.net/6/docs/ref/#commands.redo).
- Mod-u: [`undoSelection`](https://codemirror.net/6/docs/ref/#commands.undoSelection).
- Alt-u (Mod-Shift-u on macOS): [`redoSelection`](https://codemirror.net/6/docs/ref/#commands.redoSelection).
*/ const $032754016b6293d7$export$ab4a28cb63e8a670 = [
    {
        key: "Mod-z",
        run: $032754016b6293d7$export$21f930c44940fd98,
        preventDefault: true
    },
    {
        key: "Mod-y",
        mac: "Mod-Shift-z",
        run: $032754016b6293d7$export$1688e416fee0a49e,
        preventDefault: true
    },
    {
        linux: "Ctrl-Shift-z",
        run: $032754016b6293d7$export$1688e416fee0a49e,
        preventDefault: true
    },
    {
        key: "Mod-u",
        run: $032754016b6293d7$export$43103d47530fe49f,
        preventDefault: true
    },
    {
        key: "Alt-u",
        mac: "Mod-Shift-u",
        run: $032754016b6293d7$export$2d87af80f1777f20,
        preventDefault: true
    }
];
function $032754016b6293d7$var$updateSel(sel, by) {
    return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create(sel.ranges.map(by), sel.mainIndex);
}
function $032754016b6293d7$var$setSel(state, selection) {
    return state.update({
        selection: selection,
        scrollIntoView: true,
        userEvent: "select"
    });
}
function $032754016b6293d7$var$moveSel({ state: state, dispatch: dispatch }, how) {
    let selection = $032754016b6293d7$var$updateSel(state.selection, how);
    if (selection.eq(state.selection, true)) return false;
    dispatch($032754016b6293d7$var$setSel(state, selection));
    return true;
}
function $032754016b6293d7$var$rangeEnd(range, forward) {
    return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(forward ? range.to : range.from);
}
function $032754016b6293d7$var$cursorByChar(view, forward) {
    return $032754016b6293d7$var$moveSel(view, (range)=>range.empty ? view.moveByChar(range, forward) : $032754016b6293d7$var$rangeEnd(range, forward));
}
function $032754016b6293d7$var$ltrAtCursor(view) {
    return view.textDirectionAt(view.state.selection.main.head) == (0, $7beee9608540d2c3$export$cacd6541cfeeb6c1).LTR;
}
/**
Move the selection one character to the left (which is backward in
left-to-right text, forward in right-to-left text).
*/ const $032754016b6293d7$export$3447f2b737925430 = (view)=>$032754016b6293d7$var$cursorByChar(view, !$032754016b6293d7$var$ltrAtCursor(view));
/**
Move the selection one character to the right.
*/ const $032754016b6293d7$export$e45941411d098b = (view)=>$032754016b6293d7$var$cursorByChar(view, $032754016b6293d7$var$ltrAtCursor(view));
/**
Move the selection one character forward.
*/ const $032754016b6293d7$export$25b7809021291927 = (view)=>$032754016b6293d7$var$cursorByChar(view, true);
/**
Move the selection one character backward.
*/ const $032754016b6293d7$export$6ddc33d0aa7a1b65 = (view)=>$032754016b6293d7$var$cursorByChar(view, false);
function $032754016b6293d7$var$byCharLogical(state, range, forward) {
    let pos = range.head, line = state.doc.lineAt(pos);
    if (pos == (forward ? line.to : line.from)) pos = forward ? Math.min(state.doc.length, line.to + 1) : Math.max(0, line.from - 1);
    else pos = line.from + (0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(line.text, pos - line.from, forward);
    return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(pos, forward ? -1 : 1);
}
function $032754016b6293d7$var$moveByCharLogical(target, forward) {
    return $032754016b6293d7$var$moveSel(target, (range)=>range.empty ? $032754016b6293d7$var$byCharLogical(target.state, range, forward) : $032754016b6293d7$var$rangeEnd(range, forward));
}
/**
Move the selection one character forward, in logical
(non-text-direction-aware) string index order.
*/ const $032754016b6293d7$export$7ce32ef700b0ef27 = (target)=>$032754016b6293d7$var$moveByCharLogical(target, true);
/**
Move the selection one character backward, in logical string index
order.
*/ const $032754016b6293d7$export$a4c56edc7f7903df = (target)=>$032754016b6293d7$var$moveByCharLogical(target, false);
function $032754016b6293d7$var$cursorByGroup(view, forward) {
    return $032754016b6293d7$var$moveSel(view, (range)=>range.empty ? view.moveByGroup(range, forward) : $032754016b6293d7$var$rangeEnd(range, forward));
}
/**
Move the selection to the left across one group of word or
non-word (but also non-space) characters.
*/ const $032754016b6293d7$export$137fb1611fb38377 = (view)=>$032754016b6293d7$var$cursorByGroup(view, !$032754016b6293d7$var$ltrAtCursor(view));
/**
Move the selection one group to the right.
*/ const $032754016b6293d7$export$8fb2c619d55341b4 = (view)=>$032754016b6293d7$var$cursorByGroup(view, $032754016b6293d7$var$ltrAtCursor(view));
/**
Move the selection one group forward.
*/ const $032754016b6293d7$export$ce8d94762dbdebb8 = (view)=>$032754016b6293d7$var$cursorByGroup(view, true);
/**
Move the selection one group backward.
*/ const $032754016b6293d7$export$dd83d1d646f184d8 = (view)=>$032754016b6293d7$var$cursorByGroup(view, false);
function $032754016b6293d7$var$toGroupStart(view, pos, start) {
    let categorize = view.state.charCategorizer(pos);
    let cat = categorize(start), initial = cat != (0, $6295c6875f57e3ee$export$239a3d59567c1401).Space;
    return (next)=>{
        let nextCat = categorize(next);
        if (nextCat != (0, $6295c6875f57e3ee$export$239a3d59567c1401).Space) return initial && nextCat == cat;
        initial = false;
        return true;
    };
}
/**
Move the cursor one group forward in the default Windows style,
where it moves to the start of the next group.
*/ const $032754016b6293d7$export$c0e6054be0198e65 = (view)=>{
    return $032754016b6293d7$var$moveSel(view, (range)=>range.empty ? view.moveByChar(range, true, (start)=>$032754016b6293d7$var$toGroupStart(view, range.head, start)) : $032754016b6293d7$var$rangeEnd(range, true));
};
const $032754016b6293d7$var$segmenter = typeof Intl != "undefined" && Intl.Segmenter ? /*@__PURE__*/ new Intl.Segmenter(undefined, {
    granularity: "word"
}) : null;
function $032754016b6293d7$var$moveBySubword(view, range, forward) {
    let categorize = view.state.charCategorizer(range.from);
    let cat = (0, $6295c6875f57e3ee$export$239a3d59567c1401).Space, pos = range.from, steps = 0;
    let done = false, sawUpper = false, sawLower = false;
    let step = (next)=>{
        if (done) return false;
        pos += forward ? next.length : -next.length;
        let nextCat = categorize(next), ahead;
        if (nextCat == (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word && next.charCodeAt(0) < 128 && /[\W_]/.test(next)) nextCat = -1; // Treat word punctuation specially
        if (cat == (0, $6295c6875f57e3ee$export$239a3d59567c1401).Space) cat = nextCat;
        if (cat != nextCat) return false;
        if (cat == (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word) {
            if (next.toLowerCase() == next) {
                if (!forward && sawUpper) return false;
                sawLower = true;
            } else if (sawLower) {
                if (forward) return false;
                done = true;
            } else {
                if (sawUpper && forward && categorize(ahead = view.state.sliceDoc(pos, pos + 1)) == (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word && ahead.toLowerCase() == ahead) return false;
                sawUpper = true;
            }
        }
        steps++;
        return true;
    };
    let end = view.moveByChar(range, forward, (start)=>{
        step(start);
        return step;
    });
    if ($032754016b6293d7$var$segmenter && cat == (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word && end.from == range.from + steps * (forward ? 1 : -1)) {
        let from = Math.min(range.head, end.head), to = Math.max(range.head, end.head);
        let skipped = view.state.sliceDoc(from, to);
        if (skipped.length > 1 && /[\u4E00-\uffff]/.test(skipped)) {
            let segments = Array.from($032754016b6293d7$var$segmenter.segment(skipped));
            if (segments.length > 1) {
                if (forward) return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(range.head + segments[1].index, -1);
                return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(end.head + segments[segments.length - 1].index, 1);
            }
        }
    }
    return end;
}
function $032754016b6293d7$var$cursorBySubword(view, forward) {
    return $032754016b6293d7$var$moveSel(view, (range)=>range.empty ? $032754016b6293d7$var$moveBySubword(view, range, forward) : $032754016b6293d7$var$rangeEnd(range, forward));
}
/**
Move the selection one group or camel-case subword forward.
*/ const $032754016b6293d7$export$d969a5b0dca9c3e2 = (view)=>$032754016b6293d7$var$cursorBySubword(view, true);
/**
Move the selection one group or camel-case subword backward.
*/ const $032754016b6293d7$export$ade35f5607ad3d82 = (view)=>$032754016b6293d7$var$cursorBySubword(view, false);
function $032754016b6293d7$var$interestingNode(state, node, bracketProp) {
    if (node.type.prop(bracketProp)) return true;
    let len = node.to - node.from;
    return len && (len > 2 || /[^\s,.;:]/.test(state.sliceDoc(node.from, node.to))) || node.firstChild;
}
function $032754016b6293d7$var$moveBySyntax(state, start, forward) {
    let pos = (0, $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1)(state).resolveInner(start.head);
    let bracketProp = forward ? (0, $ed739beecf769914$export$b8034b9bc18acd90).closedBy : (0, $ed739beecf769914$export$b8034b9bc18acd90).openedBy;
    // Scan forward through child nodes to see if there's an interesting
    // node ahead.
    for(let at = start.head;;){
        let next = forward ? pos.childAfter(at) : pos.childBefore(at);
        if (!next) break;
        if ($032754016b6293d7$var$interestingNode(state, next, bracketProp)) pos = next;
        else at = forward ? next.to : next.from;
    }
    let bracket = pos.type.prop(bracketProp), match, newPos;
    if (bracket && (match = forward ? (0, $a97ccac5cf5f4f5d$export$3391942603e90cda)(state, pos.from, 1) : (0, $a97ccac5cf5f4f5d$export$3391942603e90cda)(state, pos.to, -1)) && match.matched) newPos = forward ? match.end.to : match.end.from;
    else newPos = forward ? pos.to : pos.from;
    return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(newPos, forward ? -1 : 1);
}
/**
Move the cursor over the next syntactic element to the left.
*/ const $032754016b6293d7$export$1e53c014543c10bb = (view)=>$032754016b6293d7$var$moveSel(view, (range)=>$032754016b6293d7$var$moveBySyntax(view.state, range, !$032754016b6293d7$var$ltrAtCursor(view)));
/**
Move the cursor over the next syntactic element to the right.
*/ const $032754016b6293d7$export$62c6dc33f5d01e39 = (view)=>$032754016b6293d7$var$moveSel(view, (range)=>$032754016b6293d7$var$moveBySyntax(view.state, range, $032754016b6293d7$var$ltrAtCursor(view)));
function $032754016b6293d7$var$cursorByLine(view, forward) {
    return $032754016b6293d7$var$moveSel(view, (range)=>{
        if (!range.empty) return $032754016b6293d7$var$rangeEnd(range, forward);
        let moved = view.moveVertically(range, forward);
        return moved.head != range.head ? moved : view.moveToLineBoundary(range, forward);
    });
}
/**
Move the selection one line up.
*/ const $032754016b6293d7$export$fe179dad0485d99d = (view)=>$032754016b6293d7$var$cursorByLine(view, false);
/**
Move the selection one line down.
*/ const $032754016b6293d7$export$75f9b75ffb1a9dc5 = (view)=>$032754016b6293d7$var$cursorByLine(view, true);
function $032754016b6293d7$var$pageInfo(view) {
    let selfScroll = view.scrollDOM.clientHeight < view.scrollDOM.scrollHeight - 2;
    let marginTop = 0, marginBottom = 0, height;
    if (selfScroll) {
        for (let source of view.state.facet((0, $7beee9608540d2c3$export$eece2fccabbb77c5).scrollMargins)){
            let margins = source(view);
            if (margins === null || margins === void 0 ? void 0 : margins.top) marginTop = Math.max(margins === null || margins === void 0 ? void 0 : margins.top, marginTop);
            if (margins === null || margins === void 0 ? void 0 : margins.bottom) marginBottom = Math.max(margins === null || margins === void 0 ? void 0 : margins.bottom, marginBottom);
        }
        height = view.scrollDOM.clientHeight - marginTop - marginBottom;
    } else height = (view.dom.ownerDocument.defaultView || window).innerHeight;
    return {
        marginTop: marginTop,
        marginBottom: marginBottom,
        selfScroll: selfScroll,
        height: Math.max(view.defaultLineHeight, height - 5)
    };
}
function $032754016b6293d7$var$cursorByPage(view, forward) {
    let page = $032754016b6293d7$var$pageInfo(view);
    let { state: state } = view, selection = $032754016b6293d7$var$updateSel(state.selection, (range)=>{
        return range.empty ? view.moveVertically(range, forward, page.height) : $032754016b6293d7$var$rangeEnd(range, forward);
    });
    if (selection.eq(state.selection)) return false;
    let effect;
    if (page.selfScroll) {
        let startPos = view.coordsAtPos(state.selection.main.head);
        let scrollRect = view.scrollDOM.getBoundingClientRect();
        let scrollTop = scrollRect.top + page.marginTop, scrollBottom = scrollRect.bottom - page.marginBottom;
        if (startPos && startPos.top > scrollTop && startPos.bottom < scrollBottom) effect = (0, $7beee9608540d2c3$export$eece2fccabbb77c5).scrollIntoView(selection.main.head, {
            y: "start",
            yMargin: startPos.top - scrollTop
        });
    }
    view.dispatch($032754016b6293d7$var$setSel(state, selection), {
        effects: effect
    });
    return true;
}
/**
Move the selection one page up.
*/ const $032754016b6293d7$export$546ec71a9f854193 = (view)=>$032754016b6293d7$var$cursorByPage(view, false);
/**
Move the selection one page down.
*/ const $032754016b6293d7$export$6e407c2072d437f4 = (view)=>$032754016b6293d7$var$cursorByPage(view, true);
function $032754016b6293d7$var$moveByLineBoundary(view, start, forward) {
    let line = view.lineBlockAt(start.head), moved = view.moveToLineBoundary(start, forward);
    if (moved.head == start.head && moved.head != (forward ? line.to : line.from)) moved = view.moveToLineBoundary(start, forward, false);
    if (!forward && moved.head == line.from && line.length) {
        let space = /^\s*/.exec(view.state.sliceDoc(line.from, Math.min(line.from + 100, line.to)))[0].length;
        if (space && start.head != line.from + space) moved = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(line.from + space);
    }
    return moved;
}
/**
Move the selection to the next line wrap point, or to the end of
the line if there isn't one left on this line.
*/ const $032754016b6293d7$export$b59ae3b25af6ea13 = (view)=>$032754016b6293d7$var$moveSel(view, (range)=>$032754016b6293d7$var$moveByLineBoundary(view, range, true));
/**
Move the selection to previous line wrap point, or failing that to
the start of the line. If the line is indented, and the cursor
isn't already at the end of the indentation, this will move to the
end of the indentation instead of the start of the line.
*/ const $032754016b6293d7$export$64939ebc49b03818 = (view)=>$032754016b6293d7$var$moveSel(view, (range)=>$032754016b6293d7$var$moveByLineBoundary(view, range, false));
/**
Move the selection one line wrap point to the left.
*/ const $032754016b6293d7$export$515c8c77cfbd2e73 = (view)=>$032754016b6293d7$var$moveSel(view, (range)=>$032754016b6293d7$var$moveByLineBoundary(view, range, !$032754016b6293d7$var$ltrAtCursor(view)));
/**
Move the selection one line wrap point to the right.
*/ const $032754016b6293d7$export$912e453a1e062a62 = (view)=>$032754016b6293d7$var$moveSel(view, (range)=>$032754016b6293d7$var$moveByLineBoundary(view, range, $032754016b6293d7$var$ltrAtCursor(view)));
/**
Move the selection to the start of the line.
*/ const $032754016b6293d7$export$9c7dea99650bd512 = (view)=>$032754016b6293d7$var$moveSel(view, (range)=>(0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(view.lineBlockAt(range.head).from, 1));
/**
Move the selection to the end of the line.
*/ const $032754016b6293d7$export$2a3cdaf3ab2dcbf2 = (view)=>$032754016b6293d7$var$moveSel(view, (range)=>(0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(view.lineBlockAt(range.head).to, -1));
function $032754016b6293d7$var$toMatchingBracket(state, dispatch, extend) {
    let found = false, selection = $032754016b6293d7$var$updateSel(state.selection, (range)=>{
        let matching = (0, $a97ccac5cf5f4f5d$export$3391942603e90cda)(state, range.head, -1) || (0, $a97ccac5cf5f4f5d$export$3391942603e90cda)(state, range.head, 1) || range.head > 0 && (0, $a97ccac5cf5f4f5d$export$3391942603e90cda)(state, range.head - 1, 1) || range.head < state.doc.length && (0, $a97ccac5cf5f4f5d$export$3391942603e90cda)(state, range.head + 1, -1);
        if (!matching || !matching.end) return range;
        found = true;
        let head = matching.start.from == range.head ? matching.end.to : matching.end.from;
        return extend ? (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(range.anchor, head) : (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(head);
    });
    if (!found) return false;
    dispatch($032754016b6293d7$var$setSel(state, selection));
    return true;
}
/**
Move the selection to the bracket matching the one it is currently
on, if any.
*/ const $032754016b6293d7$export$e5a7e1f2d38b1f6a = ({ state: state, dispatch: dispatch })=>$032754016b6293d7$var$toMatchingBracket(state, dispatch, false);
/**
Extend the selection to the bracket matching the one the selection
head is currently on, if any.
*/ const $032754016b6293d7$export$a56168b85007a381 = ({ state: state, dispatch: dispatch })=>$032754016b6293d7$var$toMatchingBracket(state, dispatch, true);
function $032754016b6293d7$var$extendSel(target, how) {
    let selection = $032754016b6293d7$var$updateSel(target.state.selection, (range)=>{
        let head = how(range);
        return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(range.anchor, head.head, head.goalColumn, head.bidiLevel || undefined, head.assoc);
    });
    if (selection.eq(target.state.selection)) return false;
    target.dispatch($032754016b6293d7$var$setSel(target.state, selection));
    return true;
}
function $032754016b6293d7$var$selectByChar(view, forward) {
    return $032754016b6293d7$var$extendSel(view, (range)=>view.moveByChar(range, forward));
}
/**
Move the selection head one character to the left, while leaving
the anchor in place.
*/ const $032754016b6293d7$export$639be832433387f = (view)=>$032754016b6293d7$var$selectByChar(view, !$032754016b6293d7$var$ltrAtCursor(view));
/**
Move the selection head one character to the right.
*/ const $032754016b6293d7$export$49e3d65796d89132 = (view)=>$032754016b6293d7$var$selectByChar(view, $032754016b6293d7$var$ltrAtCursor(view));
/**
Move the selection head one character forward.
*/ const $032754016b6293d7$export$6a18f0ec4e3aa4ba = (view)=>$032754016b6293d7$var$selectByChar(view, true);
/**
Move the selection head one character backward.
*/ const $032754016b6293d7$export$1132822fa6924c1d = (view)=>$032754016b6293d7$var$selectByChar(view, false);
/**
Move the selection head one character forward by logical
(non-direction aware) string index order.
*/ const $032754016b6293d7$export$74309692c7a8e2d9 = (target)=>$032754016b6293d7$var$extendSel(target, (range)=>$032754016b6293d7$var$byCharLogical(target.state, range, true));
/**
Move the selection head one character backward by logical string
index order.
*/ const $032754016b6293d7$export$2bfcd2df135aa168 = (target)=>$032754016b6293d7$var$extendSel(target, (range)=>$032754016b6293d7$var$byCharLogical(target.state, range, false));
function $032754016b6293d7$var$selectByGroup(view, forward) {
    return $032754016b6293d7$var$extendSel(view, (range)=>view.moveByGroup(range, forward));
}
/**
Move the selection head one [group](https://codemirror.net/6/docs/ref/#commands.cursorGroupLeft) to
the left.
*/ const $032754016b6293d7$export$ef839611b4c2ba40 = (view)=>$032754016b6293d7$var$selectByGroup(view, !$032754016b6293d7$var$ltrAtCursor(view));
/**
Move the selection head one group to the right.
*/ const $032754016b6293d7$export$5ebbb4cf65fe8a74 = (view)=>$032754016b6293d7$var$selectByGroup(view, $032754016b6293d7$var$ltrAtCursor(view));
/**
Move the selection head one group forward.
*/ const $032754016b6293d7$export$53ddb317471acf76 = (view)=>$032754016b6293d7$var$selectByGroup(view, true);
/**
Move the selection head one group backward.
*/ const $032754016b6293d7$export$65a2ce60964fa778 = (view)=>$032754016b6293d7$var$selectByGroup(view, false);
/**
Move the selection head one group forward in the default Windows
style, skipping to the start of the next group.
*/ const $032754016b6293d7$export$5ea626eef31f242e = (view)=>{
    return $032754016b6293d7$var$extendSel(view, (range)=>view.moveByChar(range, true, (start)=>$032754016b6293d7$var$toGroupStart(view, range.head, start)));
};
function $032754016b6293d7$var$selectBySubword(view, forward) {
    return $032754016b6293d7$var$extendSel(view, (range)=>$032754016b6293d7$var$moveBySubword(view, range, forward));
}
/**
Move the selection head one group or camel-case subword forward.
*/ const $032754016b6293d7$export$c4f4d945a8760145 = (view)=>$032754016b6293d7$var$selectBySubword(view, true);
/**
Move the selection head one group or subword backward.
*/ const $032754016b6293d7$export$3a6caa1f1abce2e2 = (view)=>$032754016b6293d7$var$selectBySubword(view, false);
/**
Move the selection head over the next syntactic element to the left.
*/ const $032754016b6293d7$export$67b15be4414061b5 = (view)=>$032754016b6293d7$var$extendSel(view, (range)=>$032754016b6293d7$var$moveBySyntax(view.state, range, !$032754016b6293d7$var$ltrAtCursor(view)));
/**
Move the selection head over the next syntactic element to the right.
*/ const $032754016b6293d7$export$74aa476df7791ce = (view)=>$032754016b6293d7$var$extendSel(view, (range)=>$032754016b6293d7$var$moveBySyntax(view.state, range, $032754016b6293d7$var$ltrAtCursor(view)));
function $032754016b6293d7$var$selectByLine(view, forward) {
    return $032754016b6293d7$var$extendSel(view, (range)=>view.moveVertically(range, forward));
}
/**
Move the selection head one line up.
*/ const $032754016b6293d7$export$92aa693a1ecd7061 = (view)=>$032754016b6293d7$var$selectByLine(view, false);
/**
Move the selection head one line down.
*/ const $032754016b6293d7$export$bf847527697a3040 = (view)=>$032754016b6293d7$var$selectByLine(view, true);
function $032754016b6293d7$var$selectByPage(view, forward) {
    return $032754016b6293d7$var$extendSel(view, (range)=>view.moveVertically(range, forward, $032754016b6293d7$var$pageInfo(view).height));
}
/**
Move the selection head one page up.
*/ const $032754016b6293d7$export$61eab34d4ff5cbaf = (view)=>$032754016b6293d7$var$selectByPage(view, false);
/**
Move the selection head one page down.
*/ const $032754016b6293d7$export$a4c186a0dadaf91c = (view)=>$032754016b6293d7$var$selectByPage(view, true);
/**
Move the selection head to the next line boundary.
*/ const $032754016b6293d7$export$df223d0097d57a86 = (view)=>$032754016b6293d7$var$extendSel(view, (range)=>$032754016b6293d7$var$moveByLineBoundary(view, range, true));
/**
Move the selection head to the previous line boundary.
*/ const $032754016b6293d7$export$643176ee603b8e87 = (view)=>$032754016b6293d7$var$extendSel(view, (range)=>$032754016b6293d7$var$moveByLineBoundary(view, range, false));
/**
Move the selection head one line boundary to the left.
*/ const $032754016b6293d7$export$769cc61da74090c5 = (view)=>$032754016b6293d7$var$extendSel(view, (range)=>$032754016b6293d7$var$moveByLineBoundary(view, range, !$032754016b6293d7$var$ltrAtCursor(view)));
/**
Move the selection head one line boundary to the right.
*/ const $032754016b6293d7$export$de427496204690a6 = (view)=>$032754016b6293d7$var$extendSel(view, (range)=>$032754016b6293d7$var$moveByLineBoundary(view, range, $032754016b6293d7$var$ltrAtCursor(view)));
/**
Move the selection head to the start of the line.
*/ const $032754016b6293d7$export$a0e1e86f753956a4 = (view)=>$032754016b6293d7$var$extendSel(view, (range)=>(0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(view.lineBlockAt(range.head).from));
/**
Move the selection head to the end of the line.
*/ const $032754016b6293d7$export$bd34a38d148e23af = (view)=>$032754016b6293d7$var$extendSel(view, (range)=>(0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(view.lineBlockAt(range.head).to));
/**
Move the selection to the start of the document.
*/ const $032754016b6293d7$export$ff7ed6e6e1cb317f = ({ state: state, dispatch: dispatch })=>{
    dispatch($032754016b6293d7$var$setSel(state, {
        anchor: 0
    }));
    return true;
};
/**
Move the selection to the end of the document.
*/ const $032754016b6293d7$export$b12ef1671b2836da = ({ state: state, dispatch: dispatch })=>{
    dispatch($032754016b6293d7$var$setSel(state, {
        anchor: state.doc.length
    }));
    return true;
};
/**
Move the selection head to the start of the document.
*/ const $032754016b6293d7$export$aa525ee829cc26b = ({ state: state, dispatch: dispatch })=>{
    dispatch($032754016b6293d7$var$setSel(state, {
        anchor: state.selection.main.anchor,
        head: 0
    }));
    return true;
};
/**
Move the selection head to the end of the document.
*/ const $032754016b6293d7$export$fff0131cdd9694fe = ({ state: state, dispatch: dispatch })=>{
    dispatch($032754016b6293d7$var$setSel(state, {
        anchor: state.selection.main.anchor,
        head: state.doc.length
    }));
    return true;
};
/**
Select the entire document.
*/ const $032754016b6293d7$export$90aca4adda6ff0f5 = ({ state: state, dispatch: dispatch })=>{
    dispatch(state.update({
        selection: {
            anchor: 0,
            head: state.doc.length
        },
        userEvent: "select"
    }));
    return true;
};
/**
Expand the selection to cover entire lines.
*/ const $032754016b6293d7$export$e41c12847640c21 = ({ state: state, dispatch: dispatch })=>{
    let ranges = $032754016b6293d7$var$selectedLineBlocks(state).map(({ from: from, to: to })=>(0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(from, Math.min(to + 1, state.doc.length)));
    dispatch(state.update({
        selection: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create(ranges),
        userEvent: "select"
    }));
    return true;
};
/**
Select the next syntactic construct that is larger than the
selection. Note that this will only work insofar as the language
[provider](https://codemirror.net/6/docs/ref/#language.language) you use builds up a full
syntax tree.
*/ const $032754016b6293d7$export$f38a48fa120d50ce = ({ state: state, dispatch: dispatch })=>{
    let selection = $032754016b6293d7$var$updateSel(state.selection, (range)=>{
        let tree = (0, $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1)(state), stack = tree.resolveStack(range.from, 1);
        if (range.empty) {
            let stackBefore = tree.resolveStack(range.from, -1);
            if (stackBefore.node.from >= stack.node.from && stackBefore.node.to <= stack.node.to) stack = stackBefore;
        }
        for(let cur = stack; cur; cur = cur.next){
            let { node: node } = cur;
            if ((node.from < range.from && node.to >= range.to || node.to > range.to && node.from <= range.from) && cur.next) return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(node.to, node.from);
        }
        return range;
    });
    if (selection.eq(state.selection)) return false;
    dispatch($032754016b6293d7$var$setSel(state, selection));
    return true;
};
function $032754016b6293d7$var$addCursorVertically(view, forward) {
    let { state: state } = view, sel = state.selection, ranges = state.selection.ranges.slice();
    for (let range of state.selection.ranges){
        let line = state.doc.lineAt(range.head);
        if (forward ? line.to < view.state.doc.length : line.from > 0) for(let cur = range;;){
            let next = view.moveVertically(cur, forward);
            if (next.head < line.from || next.head > line.to) {
                if (!ranges.some((r)=>r.head == next.head)) ranges.push(next);
                break;
            } else if (next.head == cur.head) break;
            else cur = next;
        }
    }
    if (ranges.length == sel.ranges.length) return false;
    view.dispatch($032754016b6293d7$var$setSel(state, (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create(ranges, ranges.length - 1)));
    return true;
}
/**
Expand the selection by adding a cursor above the heads of
currently selected ranges.
*/ const $032754016b6293d7$export$3054522ff62988dd = (view)=>$032754016b6293d7$var$addCursorVertically(view, false);
/**
Expand the selection by adding a cursor below the heads of
currently selected ranges.
*/ const $032754016b6293d7$export$83ff5bba776179f3 = (view)=>$032754016b6293d7$var$addCursorVertically(view, true);
/**
Simplify the current selection. When multiple ranges are selected,
reduce it to its main range. Otherwise, if the selection is
non-empty, convert it to a cursor selection.
*/ const $032754016b6293d7$export$2f90cebc0d40abf = ({ state: state, dispatch: dispatch })=>{
    let cur = state.selection, selection = null;
    if (cur.ranges.length > 1) selection = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create([
        cur.main
    ]);
    else if (!cur.main.empty) selection = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create([
        (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(cur.main.head)
    ]);
    if (!selection) return false;
    dispatch($032754016b6293d7$var$setSel(state, selection));
    return true;
};
function $032754016b6293d7$var$deleteBy(target, by) {
    if (target.state.readOnly) return false;
    let event = "delete.selection", { state: state } = target;
    let changes = state.changeByRange((range)=>{
        let { from: from, to: to } = range;
        if (from == to) {
            let towards = by(range);
            if (towards < from) {
                event = "delete.backward";
                towards = $032754016b6293d7$var$skipAtomic(target, towards, false);
            } else if (towards > from) {
                event = "delete.forward";
                towards = $032754016b6293d7$var$skipAtomic(target, towards, true);
            }
            from = Math.min(from, towards);
            to = Math.max(to, towards);
        } else {
            from = $032754016b6293d7$var$skipAtomic(target, from, false);
            to = $032754016b6293d7$var$skipAtomic(target, to, true);
        }
        return from == to ? {
            range: range
        } : {
            changes: {
                from: from,
                to: to
            },
            range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(from, from < range.head ? -1 : 1)
        };
    });
    if (changes.changes.empty) return false;
    target.dispatch(state.update(changes, {
        scrollIntoView: true,
        userEvent: event,
        effects: event == "delete.selection" ? (0, $7beee9608540d2c3$export$eece2fccabbb77c5).announce.of(state.phrase("Selection deleted")) : undefined
    }));
    return true;
}
function $032754016b6293d7$var$skipAtomic(target, pos, forward) {
    if (target instanceof (0, $7beee9608540d2c3$export$eece2fccabbb77c5)) for (let ranges of target.state.facet((0, $7beee9608540d2c3$export$eece2fccabbb77c5).atomicRanges).map((f)=>f(target)))ranges.between(pos, pos, (from, to)=>{
        if (from < pos && to > pos) pos = forward ? to : from;
    });
    return pos;
}
const $032754016b6293d7$var$deleteByChar = (target, forward, byIndentUnit)=>$032754016b6293d7$var$deleteBy(target, (range)=>{
        let pos = range.from, { state: state } = target, line = state.doc.lineAt(pos), before, targetPos;
        if (byIndentUnit && !forward && pos > line.from && pos < line.from + 200 && !/[^ \t]/.test(before = line.text.slice(0, pos - line.from))) {
            if (before[before.length - 1] == "\t") return pos - 1;
            let col = (0, $6295c6875f57e3ee$export$20b4ab289374d0ac)(before, state.tabSize), drop = col % (0, $a97ccac5cf5f4f5d$export$ad3205d09311a797)(state) || (0, $a97ccac5cf5f4f5d$export$ad3205d09311a797)(state);
            for(let i = 0; i < drop && before[before.length - 1 - i] == " "; i++)pos--;
            targetPos = pos;
        } else {
            targetPos = (0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(line.text, pos - line.from, forward, forward) + line.from;
            if (targetPos == pos && line.number != (forward ? state.doc.lines : 1)) targetPos += forward ? 1 : -1;
            else if (!forward && /[\ufe00-\ufe0f]/.test(line.text.slice(targetPos - line.from, pos - line.from))) targetPos = (0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(line.text, targetPos - line.from, false, false) + line.from;
        }
        return targetPos;
    });
/**
Delete the selection, or, for cursor selections, the character or
indentation unit before the cursor.
*/ const $032754016b6293d7$export$1e8a14efe7ca9a33 = (view)=>$032754016b6293d7$var$deleteByChar(view, false, true);
/**
Delete the selection or the character before the cursor. Does not
implement any extended behavior like deleting whole indentation
units in one go.
*/ const $032754016b6293d7$export$3365c1d7b1abe7df = (view)=>$032754016b6293d7$var$deleteByChar(view, false, false);
/**
Delete the selection or the character after the cursor.
*/ const $032754016b6293d7$export$d41683a0f042cb80 = (view)=>$032754016b6293d7$var$deleteByChar(view, true, false);
const $032754016b6293d7$var$deleteByGroup = (target, forward)=>$032754016b6293d7$var$deleteBy(target, (range)=>{
        let pos = range.head, { state: state } = target, line = state.doc.lineAt(pos);
        let categorize = state.charCategorizer(pos);
        for(let cat = null;;){
            if (pos == (forward ? line.to : line.from)) {
                if (pos == range.head && line.number != (forward ? state.doc.lines : 1)) pos += forward ? 1 : -1;
                break;
            }
            let next = (0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(line.text, pos - line.from, forward) + line.from;
            let nextChar = line.text.slice(Math.min(pos, next) - line.from, Math.max(pos, next) - line.from);
            let nextCat = categorize(nextChar);
            if (cat != null && nextCat != cat) break;
            if (nextChar != " " || pos != range.head) cat = nextCat;
            pos = next;
        }
        return pos;
    });
/**
Delete the selection or backward until the end of the next
[group](https://codemirror.net/6/docs/ref/#view.EditorView.moveByGroup), only skipping groups of
whitespace when they consist of a single space.
*/ const $032754016b6293d7$export$3072f591ab219e94 = (target)=>$032754016b6293d7$var$deleteByGroup(target, false);
/**
Delete the selection or forward until the end of the next group.
*/ const $032754016b6293d7$export$56a4e2ef21b58242 = (target)=>$032754016b6293d7$var$deleteByGroup(target, true);
/**
Variant of [`deleteGroupForward`](https://codemirror.net/6/docs/ref/#commands.deleteGroupForward)
that uses the Windows convention of also deleting the whitespace
after a word.
*/ const $032754016b6293d7$export$94136ce5bc6ca33e = (view)=>$032754016b6293d7$var$deleteBy(view, (range)=>view.moveByChar(range, true, (start)=>$032754016b6293d7$var$toGroupStart(view, range.head, start)).head);
/**
Delete the selection, or, if it is a cursor selection, delete to
the end of the line. If the cursor is directly at the end of the
line, delete the line break after it.
*/ const $032754016b6293d7$export$ae3820c4ce0e9c92 = (view)=>$032754016b6293d7$var$deleteBy(view, (range)=>{
        let lineEnd = view.lineBlockAt(range.head).to;
        return range.head < lineEnd ? lineEnd : Math.min(view.state.doc.length, range.head + 1);
    });
/**
Delete the selection, or, if it is a cursor selection, delete to
the start of the line. If the cursor is directly at the start of the
line, delete the line break before it.
*/ const $032754016b6293d7$export$dc80e21fb31e84a5 = (view)=>$032754016b6293d7$var$deleteBy(view, (range)=>{
        let lineStart = view.lineBlockAt(range.head).from;
        return range.head > lineStart ? lineStart : Math.max(0, range.head - 1);
    });
/**
Delete the selection, or, if it is a cursor selection, delete to
the start of the line or the next line wrap before the cursor.
*/ const $032754016b6293d7$export$d1072494cede984a = (view)=>$032754016b6293d7$var$deleteBy(view, (range)=>{
        let lineStart = view.moveToLineBoundary(range, false).head;
        return range.head > lineStart ? lineStart : Math.max(0, range.head - 1);
    });
/**
Delete the selection, or, if it is a cursor selection, delete to
the end of the line or the next line wrap after the cursor.
*/ const $032754016b6293d7$export$b87eb3a389c264a4 = (view)=>$032754016b6293d7$var$deleteBy(view, (range)=>{
        let lineStart = view.moveToLineBoundary(range, true).head;
        return range.head < lineStart ? lineStart : Math.min(view.state.doc.length, range.head + 1);
    });
/**
Delete all whitespace directly before a line end from the
document.
*/ const $032754016b6293d7$export$8acd3a9fe3872724 = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    let changes = [];
    for(let pos = 0, prev = "", iter = state.doc.iter();;){
        iter.next();
        if (iter.lineBreak || iter.done) {
            let trailing = prev.search(/\s+$/);
            if (trailing > -1) changes.push({
                from: pos - (prev.length - trailing),
                to: pos
            });
            if (iter.done) break;
            prev = "";
        } else prev = iter.value;
        pos += iter.value.length;
    }
    if (!changes.length) return false;
    dispatch(state.update({
        changes: changes,
        userEvent: "delete"
    }));
    return true;
};
/**
Replace each selection range with a line break, leaving the cursor
on the line before the break.
*/ const $032754016b6293d7$export$a258d4581e1d5d3c = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    let changes = state.changeByRange((range)=>{
        return {
            changes: {
                from: range.from,
                to: range.to,
                insert: (0, $6295c6875f57e3ee$export$5f1af8db9871e1d6).of([
                    "",
                    ""
                ])
            },
            range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(range.from)
        };
    });
    dispatch(state.update(changes, {
        scrollIntoView: true,
        userEvent: "input"
    }));
    return true;
};
/**
Flip the characters before and after the cursor(s).
*/ const $032754016b6293d7$export$55467a37288e4063 = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    let changes = state.changeByRange((range)=>{
        if (!range.empty || range.from == 0 || range.from == state.doc.length) return {
            range: range
        };
        let pos = range.from, line = state.doc.lineAt(pos);
        let from = pos == line.from ? pos - 1 : (0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(line.text, pos - line.from, false) + line.from;
        let to = pos == line.to ? pos + 1 : (0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(line.text, pos - line.from, true) + line.from;
        return {
            changes: {
                from: from,
                to: to,
                insert: state.doc.slice(pos, to).append(state.doc.slice(from, pos))
            },
            range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(to)
        };
    });
    if (changes.changes.empty) return false;
    dispatch(state.update(changes, {
        scrollIntoView: true,
        userEvent: "move.character"
    }));
    return true;
};
function $032754016b6293d7$var$selectedLineBlocks(state) {
    let blocks = [], upto = -1;
    for (let range of state.selection.ranges){
        let startLine = state.doc.lineAt(range.from), endLine = state.doc.lineAt(range.to);
        if (!range.empty && range.to == endLine.from) endLine = state.doc.lineAt(range.to - 1);
        if (upto >= startLine.number) {
            let prev = blocks[blocks.length - 1];
            prev.to = endLine.to;
            prev.ranges.push(range);
        } else blocks.push({
            from: startLine.from,
            to: endLine.to,
            ranges: [
                range
            ]
        });
        upto = endLine.number + 1;
    }
    return blocks;
}
function $032754016b6293d7$var$moveLine(state, dispatch, forward) {
    if (state.readOnly) return false;
    let changes = [], ranges = [];
    for (let block of $032754016b6293d7$var$selectedLineBlocks(state)){
        if (forward ? block.to == state.doc.length : block.from == 0) continue;
        let nextLine = state.doc.lineAt(forward ? block.to + 1 : block.from - 1);
        let size = nextLine.length + 1;
        if (forward) {
            changes.push({
                from: block.to,
                to: nextLine.to
            }, {
                from: block.from,
                insert: nextLine.text + state.lineBreak
            });
            for (let r of block.ranges)ranges.push((0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(Math.min(state.doc.length, r.anchor + size), Math.min(state.doc.length, r.head + size)));
        } else {
            changes.push({
                from: nextLine.from,
                to: block.from
            }, {
                from: block.to,
                insert: state.lineBreak + nextLine.text
            });
            for (let r of block.ranges)ranges.push((0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(r.anchor - size, r.head - size));
        }
    }
    if (!changes.length) return false;
    dispatch(state.update({
        changes: changes,
        scrollIntoView: true,
        selection: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create(ranges, state.selection.mainIndex),
        userEvent: "move.line"
    }));
    return true;
}
/**
Move the selected lines up one line.
*/ const $032754016b6293d7$export$c4eebaf75cfae23e = ({ state: state, dispatch: dispatch })=>$032754016b6293d7$var$moveLine(state, dispatch, false);
/**
Move the selected lines down one line.
*/ const $032754016b6293d7$export$ac19ae98a6fcd34c = ({ state: state, dispatch: dispatch })=>$032754016b6293d7$var$moveLine(state, dispatch, true);
function $032754016b6293d7$var$copyLine(state, dispatch, forward) {
    if (state.readOnly) return false;
    let changes = [];
    for (let block of $032754016b6293d7$var$selectedLineBlocks(state))if (forward) changes.push({
        from: block.from,
        insert: state.doc.slice(block.from, block.to) + state.lineBreak
    });
    else changes.push({
        from: block.to,
        insert: state.lineBreak + state.doc.slice(block.from, block.to)
    });
    let changeSet = state.changes(changes);
    dispatch(state.update({
        changes: changeSet,
        selection: state.selection.map(changeSet, forward ? 1 : -1),
        scrollIntoView: true,
        userEvent: "input.copyline"
    }));
    return true;
}
/**
Create a copy of the selected lines. Keep the selection in the top copy.
*/ const $032754016b6293d7$export$c3798d29213e527c = ({ state: state, dispatch: dispatch })=>$032754016b6293d7$var$copyLine(state, dispatch, false);
/**
Create a copy of the selected lines. Keep the selection in the bottom copy.
*/ const $032754016b6293d7$export$1ad385c375816d2f = ({ state: state, dispatch: dispatch })=>$032754016b6293d7$var$copyLine(state, dispatch, true);
/**
Delete selected lines.
*/ const $032754016b6293d7$export$aba0d4cd8923f1ae = (view)=>{
    if (view.state.readOnly) return false;
    let { state: state } = view, changes = state.changes($032754016b6293d7$var$selectedLineBlocks(state).map(({ from: from, to: to })=>{
        if (from > 0) from--;
        else if (to < state.doc.length) to++;
        return {
            from: from,
            to: to
        };
    }));
    let selection = $032754016b6293d7$var$updateSel(state.selection, (range)=>{
        let dist = undefined;
        if (view.lineWrapping) {
            let block = view.lineBlockAt(range.head), pos = view.coordsAtPos(range.head, range.assoc || 1);
            if (pos) dist = block.bottom + view.documentTop - pos.bottom + view.defaultLineHeight / 2;
        }
        return view.moveVertically(range, true, dist);
    }).map(changes);
    view.dispatch({
        changes: changes,
        selection: selection,
        scrollIntoView: true,
        userEvent: "delete.line"
    });
    return true;
};
/**
Replace the selection with a newline.
*/ const $032754016b6293d7$export$e7e1d174affeae8d = ({ state: state, dispatch: dispatch })=>{
    dispatch(state.update(state.replaceSelection(state.lineBreak), {
        scrollIntoView: true,
        userEvent: "input"
    }));
    return true;
};
/**
Replace the selection with a newline and the same amount of
indentation as the line above.
*/ const $032754016b6293d7$export$8dc33eb9291e07ef = ({ state: state, dispatch: dispatch })=>{
    dispatch(state.update(state.changeByRange((range)=>{
        let indent = /^\s*/.exec(state.doc.lineAt(range.from).text)[0];
        return {
            changes: {
                from: range.from,
                to: range.to,
                insert: state.lineBreak + indent
            },
            range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(range.from + indent.length + 1)
        };
    }), {
        scrollIntoView: true,
        userEvent: "input"
    }));
    return true;
};
function $032754016b6293d7$var$isBetweenBrackets(state, pos) {
    if (/\(\)|\[\]|\{\}/.test(state.sliceDoc(pos - 1, pos + 1))) return {
        from: pos,
        to: pos
    };
    let context = (0, $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1)(state).resolveInner(pos);
    let before = context.childBefore(pos), after = context.childAfter(pos), closedBy;
    if (before && after && before.to <= pos && after.from >= pos && (closedBy = before.type.prop((0, $ed739beecf769914$export$b8034b9bc18acd90).closedBy)) && closedBy.indexOf(after.name) > -1 && state.doc.lineAt(before.to).from == state.doc.lineAt(after.from).from && !/\S/.test(state.sliceDoc(before.to, after.from))) return {
        from: before.to,
        to: after.from
    };
    return null;
}
/**
Replace the selection with a newline and indent the newly created
line(s). If the current line consists only of whitespace, this
will also delete that whitespace. When the cursor is between
matching brackets, an additional newline will be inserted after
the cursor.
*/ const $032754016b6293d7$export$668310d2b1aa07d5 = /*@__PURE__*/ $032754016b6293d7$var$newlineAndIndent(false);
/**
Create a blank, indented line below the current line.
*/ const $032754016b6293d7$export$2ff1ccbcf65d0770 = /*@__PURE__*/ $032754016b6293d7$var$newlineAndIndent(true);
function $032754016b6293d7$var$newlineAndIndent(atEof) {
    return ({ state: state, dispatch: dispatch })=>{
        if (state.readOnly) return false;
        let changes = state.changeByRange((range)=>{
            let { from: from, to: to } = range, line = state.doc.lineAt(from);
            let explode = !atEof && from == to && $032754016b6293d7$var$isBetweenBrackets(state, from);
            if (atEof) from = to = (to <= line.to ? line : state.doc.lineAt(to)).to;
            let cx = new (0, $a97ccac5cf5f4f5d$export$eeab79349cc2f7c8)(state, {
                simulateBreak: from,
                simulateDoubleBreak: !!explode
            });
            let indent = (0, $a97ccac5cf5f4f5d$export$a2d3c9dbce6d2211)(cx, from);
            if (indent == null) indent = (0, $6295c6875f57e3ee$export$20b4ab289374d0ac)(/^\s*/.exec(state.doc.lineAt(from).text)[0], state.tabSize);
            while(to < line.to && /\s/.test(line.text[to - line.from]))to++;
            if (explode) ({ from: from, to: to } = explode);
            else if (from > line.from && from < line.from + 100 && !/\S/.test(line.text.slice(0, from))) from = line.from;
            let insert = [
                "",
                (0, $a97ccac5cf5f4f5d$export$db5a40e207b40576)(state, indent)
            ];
            if (explode) insert.push((0, $a97ccac5cf5f4f5d$export$db5a40e207b40576)(state, cx.lineIndent(line.from, -1)));
            return {
                changes: {
                    from: from,
                    to: to,
                    insert: (0, $6295c6875f57e3ee$export$5f1af8db9871e1d6).of(insert)
                },
                range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(from + 1 + insert[1].length)
            };
        });
        dispatch(state.update(changes, {
            scrollIntoView: true,
            userEvent: "input"
        }));
        return true;
    };
}
function $032754016b6293d7$var$changeBySelectedLine(state, f) {
    let atLine = -1;
    return state.changeByRange((range)=>{
        let changes = [];
        for(let pos = range.from; pos <= range.to;){
            let line = state.doc.lineAt(pos);
            if (line.number > atLine && (range.empty || range.to > line.from)) {
                f(line, changes, range);
                atLine = line.number;
            }
            pos = line.to + 1;
        }
        let changeSet = state.changes(changes);
        return {
            changes: changes,
            range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(changeSet.mapPos(range.anchor, 1), changeSet.mapPos(range.head, 1))
        };
    });
}
/**
Auto-indent the selected lines. This uses the [indentation service
facet](https://codemirror.net/6/docs/ref/#language.indentService) as source for auto-indent
information.
*/ const $032754016b6293d7$export$ffcf50534fec79c3 = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    let updated = Object.create(null);
    let context = new (0, $a97ccac5cf5f4f5d$export$eeab79349cc2f7c8)(state, {
        overrideIndentation: (start)=>{
            let found = updated[start];
            return found == null ? -1 : found;
        }
    });
    let changes = $032754016b6293d7$var$changeBySelectedLine(state, (line, changes, range)=>{
        let indent = (0, $a97ccac5cf5f4f5d$export$a2d3c9dbce6d2211)(context, line.from);
        if (indent == null) return;
        if (!/\S/.test(line.text)) indent = 0;
        let cur = /^\s*/.exec(line.text)[0];
        let norm = (0, $a97ccac5cf5f4f5d$export$db5a40e207b40576)(state, indent);
        if (cur != norm || range.from < line.from + cur.length) {
            updated[line.from] = indent;
            changes.push({
                from: line.from,
                to: line.from + cur.length,
                insert: norm
            });
        }
    });
    if (!changes.changes.empty) dispatch(state.update(changes, {
        userEvent: "indent"
    }));
    return true;
};
/**
Add a [unit](https://codemirror.net/6/docs/ref/#language.indentUnit) of indentation to all selected
lines.
*/ const $032754016b6293d7$export$a61bf6a946ffc826 = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    dispatch(state.update($032754016b6293d7$var$changeBySelectedLine(state, (line, changes)=>{
        changes.push({
            from: line.from,
            insert: state.facet((0, $a97ccac5cf5f4f5d$export$9e0d0c2ce4d3ceb5))
        });
    }), {
        userEvent: "input.indent"
    }));
    return true;
};
/**
Remove a [unit](https://codemirror.net/6/docs/ref/#language.indentUnit) of indentation from all
selected lines.
*/ const $032754016b6293d7$export$e4b902122bfe67ae = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    dispatch(state.update($032754016b6293d7$var$changeBySelectedLine(state, (line, changes)=>{
        let space = /^\s*/.exec(line.text)[0];
        if (!space) return;
        let col = (0, $6295c6875f57e3ee$export$20b4ab289374d0ac)(space, state.tabSize), keep = 0;
        let insert = (0, $a97ccac5cf5f4f5d$export$db5a40e207b40576)(state, Math.max(0, col - (0, $a97ccac5cf5f4f5d$export$ad3205d09311a797)(state)));
        while(keep < space.length && keep < insert.length && space.charCodeAt(keep) == insert.charCodeAt(keep))keep++;
        changes.push({
            from: line.from + keep,
            to: line.from + space.length,
            insert: insert.slice(keep)
        });
    }), {
        userEvent: "delete.dedent"
    }));
    return true;
};
/**
Enables or disables
[tab-focus mode](https://codemirror.net/6/docs/ref/#view.EditorView.setTabFocusMode). While on, this
prevents the editor's key bindings from capturing Tab or
Shift-Tab, making it possible for the user to move focus out of
the editor with the keyboard.
*/ const $032754016b6293d7$export$f118650570e71643 = (view)=>{
    view.setTabFocusMode();
    return true;
};
/**
Temporarily enables [tab-focus
mode](https://codemirror.net/6/docs/ref/#view.EditorView.setTabFocusMode) for two seconds or until
another key is pressed.
*/ const $032754016b6293d7$export$1f0650d3f23682c8 = (view)=>{
    view.setTabFocusMode(2000);
    return true;
};
/**
Insert a tab character at the cursor or, if something is selected,
use [`indentMore`](https://codemirror.net/6/docs/ref/#commands.indentMore) to indent the entire
selection.
*/ const $032754016b6293d7$export$89b2fa0b43bd10f8 = ({ state: state, dispatch: dispatch })=>{
    if (state.selection.ranges.some((r)=>!r.empty)) return $032754016b6293d7$export$a61bf6a946ffc826({
        state: state,
        dispatch: dispatch
    });
    dispatch(state.update(state.replaceSelection("\t"), {
        scrollIntoView: true,
        userEvent: "input"
    }));
    return true;
};
/**
Array of key bindings containing the Emacs-style bindings that are
available on macOS by default.

 - Ctrl-b: [`cursorCharLeft`](https://codemirror.net/6/docs/ref/#commands.cursorCharLeft) ([`selectCharLeft`](https://codemirror.net/6/docs/ref/#commands.selectCharLeft) with Shift)
 - Ctrl-f: [`cursorCharRight`](https://codemirror.net/6/docs/ref/#commands.cursorCharRight) ([`selectCharRight`](https://codemirror.net/6/docs/ref/#commands.selectCharRight) with Shift)
 - Ctrl-p: [`cursorLineUp`](https://codemirror.net/6/docs/ref/#commands.cursorLineUp) ([`selectLineUp`](https://codemirror.net/6/docs/ref/#commands.selectLineUp) with Shift)
 - Ctrl-n: [`cursorLineDown`](https://codemirror.net/6/docs/ref/#commands.cursorLineDown) ([`selectLineDown`](https://codemirror.net/6/docs/ref/#commands.selectLineDown) with Shift)
 - Ctrl-a: [`cursorLineStart`](https://codemirror.net/6/docs/ref/#commands.cursorLineStart) ([`selectLineStart`](https://codemirror.net/6/docs/ref/#commands.selectLineStart) with Shift)
 - Ctrl-e: [`cursorLineEnd`](https://codemirror.net/6/docs/ref/#commands.cursorLineEnd) ([`selectLineEnd`](https://codemirror.net/6/docs/ref/#commands.selectLineEnd) with Shift)
 - Ctrl-d: [`deleteCharForward`](https://codemirror.net/6/docs/ref/#commands.deleteCharForward)
 - Ctrl-h: [`deleteCharBackward`](https://codemirror.net/6/docs/ref/#commands.deleteCharBackward)
 - Ctrl-k: [`deleteToLineEnd`](https://codemirror.net/6/docs/ref/#commands.deleteToLineEnd)
 - Ctrl-Alt-h: [`deleteGroupBackward`](https://codemirror.net/6/docs/ref/#commands.deleteGroupBackward)
 - Ctrl-o: [`splitLine`](https://codemirror.net/6/docs/ref/#commands.splitLine)
 - Ctrl-t: [`transposeChars`](https://codemirror.net/6/docs/ref/#commands.transposeChars)
 - Ctrl-v: [`cursorPageDown`](https://codemirror.net/6/docs/ref/#commands.cursorPageDown)
 - Alt-v: [`cursorPageUp`](https://codemirror.net/6/docs/ref/#commands.cursorPageUp)
*/ const $032754016b6293d7$export$ef7c3246c722c48f = [
    {
        key: "Ctrl-b",
        run: $032754016b6293d7$export$3447f2b737925430,
        shift: $032754016b6293d7$export$639be832433387f,
        preventDefault: true
    },
    {
        key: "Ctrl-f",
        run: $032754016b6293d7$export$e45941411d098b,
        shift: $032754016b6293d7$export$49e3d65796d89132
    },
    {
        key: "Ctrl-p",
        run: $032754016b6293d7$export$fe179dad0485d99d,
        shift: $032754016b6293d7$export$92aa693a1ecd7061
    },
    {
        key: "Ctrl-n",
        run: $032754016b6293d7$export$75f9b75ffb1a9dc5,
        shift: $032754016b6293d7$export$bf847527697a3040
    },
    {
        key: "Ctrl-a",
        run: $032754016b6293d7$export$9c7dea99650bd512,
        shift: $032754016b6293d7$export$a0e1e86f753956a4
    },
    {
        key: "Ctrl-e",
        run: $032754016b6293d7$export$2a3cdaf3ab2dcbf2,
        shift: $032754016b6293d7$export$bd34a38d148e23af
    },
    {
        key: "Ctrl-d",
        run: $032754016b6293d7$export$d41683a0f042cb80
    },
    {
        key: "Ctrl-h",
        run: $032754016b6293d7$export$1e8a14efe7ca9a33
    },
    {
        key: "Ctrl-k",
        run: $032754016b6293d7$export$ae3820c4ce0e9c92
    },
    {
        key: "Ctrl-Alt-h",
        run: $032754016b6293d7$export$3072f591ab219e94
    },
    {
        key: "Ctrl-o",
        run: $032754016b6293d7$export$a258d4581e1d5d3c
    },
    {
        key: "Ctrl-t",
        run: $032754016b6293d7$export$55467a37288e4063
    },
    {
        key: "Ctrl-v",
        run: $032754016b6293d7$export$6e407c2072d437f4
    }
];
/**
An array of key bindings closely sticking to platform-standard or
widely used bindings. (This includes the bindings from
[`emacsStyleKeymap`](https://codemirror.net/6/docs/ref/#commands.emacsStyleKeymap), with their `key`
property changed to `mac`.)

 - ArrowLeft: [`cursorCharLeft`](https://codemirror.net/6/docs/ref/#commands.cursorCharLeft) ([`selectCharLeft`](https://codemirror.net/6/docs/ref/#commands.selectCharLeft) with Shift)
 - ArrowRight: [`cursorCharRight`](https://codemirror.net/6/docs/ref/#commands.cursorCharRight) ([`selectCharRight`](https://codemirror.net/6/docs/ref/#commands.selectCharRight) with Shift)
 - Ctrl-ArrowLeft (Alt-ArrowLeft on macOS): [`cursorGroupLeft`](https://codemirror.net/6/docs/ref/#commands.cursorGroupLeft) ([`selectGroupLeft`](https://codemirror.net/6/docs/ref/#commands.selectGroupLeft) with Shift)
 - Ctrl-ArrowRight (Alt-ArrowRight on macOS): [`cursorGroupRight`](https://codemirror.net/6/docs/ref/#commands.cursorGroupRight) ([`selectGroupRight`](https://codemirror.net/6/docs/ref/#commands.selectGroupRight) with Shift)
 - Cmd-ArrowLeft (on macOS): [`cursorLineStart`](https://codemirror.net/6/docs/ref/#commands.cursorLineStart) ([`selectLineStart`](https://codemirror.net/6/docs/ref/#commands.selectLineStart) with Shift)
 - Cmd-ArrowRight (on macOS): [`cursorLineEnd`](https://codemirror.net/6/docs/ref/#commands.cursorLineEnd) ([`selectLineEnd`](https://codemirror.net/6/docs/ref/#commands.selectLineEnd) with Shift)
 - ArrowUp: [`cursorLineUp`](https://codemirror.net/6/docs/ref/#commands.cursorLineUp) ([`selectLineUp`](https://codemirror.net/6/docs/ref/#commands.selectLineUp) with Shift)
 - ArrowDown: [`cursorLineDown`](https://codemirror.net/6/docs/ref/#commands.cursorLineDown) ([`selectLineDown`](https://codemirror.net/6/docs/ref/#commands.selectLineDown) with Shift)
 - Cmd-ArrowUp (on macOS): [`cursorDocStart`](https://codemirror.net/6/docs/ref/#commands.cursorDocStart) ([`selectDocStart`](https://codemirror.net/6/docs/ref/#commands.selectDocStart) with Shift)
 - Cmd-ArrowDown (on macOS): [`cursorDocEnd`](https://codemirror.net/6/docs/ref/#commands.cursorDocEnd) ([`selectDocEnd`](https://codemirror.net/6/docs/ref/#commands.selectDocEnd) with Shift)
 - Ctrl-ArrowUp (on macOS): [`cursorPageUp`](https://codemirror.net/6/docs/ref/#commands.cursorPageUp) ([`selectPageUp`](https://codemirror.net/6/docs/ref/#commands.selectPageUp) with Shift)
 - Ctrl-ArrowDown (on macOS): [`cursorPageDown`](https://codemirror.net/6/docs/ref/#commands.cursorPageDown) ([`selectPageDown`](https://codemirror.net/6/docs/ref/#commands.selectPageDown) with Shift)
 - PageUp: [`cursorPageUp`](https://codemirror.net/6/docs/ref/#commands.cursorPageUp) ([`selectPageUp`](https://codemirror.net/6/docs/ref/#commands.selectPageUp) with Shift)
 - PageDown: [`cursorPageDown`](https://codemirror.net/6/docs/ref/#commands.cursorPageDown) ([`selectPageDown`](https://codemirror.net/6/docs/ref/#commands.selectPageDown) with Shift)
 - Home: [`cursorLineBoundaryBackward`](https://codemirror.net/6/docs/ref/#commands.cursorLineBoundaryBackward) ([`selectLineBoundaryBackward`](https://codemirror.net/6/docs/ref/#commands.selectLineBoundaryBackward) with Shift)
 - End: [`cursorLineBoundaryForward`](https://codemirror.net/6/docs/ref/#commands.cursorLineBoundaryForward) ([`selectLineBoundaryForward`](https://codemirror.net/6/docs/ref/#commands.selectLineBoundaryForward) with Shift)
 - Ctrl-Home (Cmd-Home on macOS): [`cursorDocStart`](https://codemirror.net/6/docs/ref/#commands.cursorDocStart) ([`selectDocStart`](https://codemirror.net/6/docs/ref/#commands.selectDocStart) with Shift)
 - Ctrl-End (Cmd-Home on macOS): [`cursorDocEnd`](https://codemirror.net/6/docs/ref/#commands.cursorDocEnd) ([`selectDocEnd`](https://codemirror.net/6/docs/ref/#commands.selectDocEnd) with Shift)
 - Enter and Shift-Enter: [`insertNewlineAndIndent`](https://codemirror.net/6/docs/ref/#commands.insertNewlineAndIndent)
 - Ctrl-a (Cmd-a on macOS): [`selectAll`](https://codemirror.net/6/docs/ref/#commands.selectAll)
 - Backspace: [`deleteCharBackward`](https://codemirror.net/6/docs/ref/#commands.deleteCharBackward)
 - Delete: [`deleteCharForward`](https://codemirror.net/6/docs/ref/#commands.deleteCharForward)
 - Ctrl-Backspace (Alt-Backspace on macOS): [`deleteGroupBackward`](https://codemirror.net/6/docs/ref/#commands.deleteGroupBackward)
 - Ctrl-Delete (Alt-Delete on macOS): [`deleteGroupForward`](https://codemirror.net/6/docs/ref/#commands.deleteGroupForward)
 - Cmd-Backspace (macOS): [`deleteLineBoundaryBackward`](https://codemirror.net/6/docs/ref/#commands.deleteLineBoundaryBackward).
 - Cmd-Delete (macOS): [`deleteLineBoundaryForward`](https://codemirror.net/6/docs/ref/#commands.deleteLineBoundaryForward).
*/ const $032754016b6293d7$export$ae5dfd95be821a1c = /*@__PURE__*/ [
    {
        key: "ArrowLeft",
        run: $032754016b6293d7$export$3447f2b737925430,
        shift: $032754016b6293d7$export$639be832433387f,
        preventDefault: true
    },
    {
        key: "Mod-ArrowLeft",
        mac: "Alt-ArrowLeft",
        run: $032754016b6293d7$export$137fb1611fb38377,
        shift: $032754016b6293d7$export$ef839611b4c2ba40,
        preventDefault: true
    },
    {
        mac: "Cmd-ArrowLeft",
        run: $032754016b6293d7$export$515c8c77cfbd2e73,
        shift: $032754016b6293d7$export$769cc61da74090c5,
        preventDefault: true
    },
    {
        key: "ArrowRight",
        run: $032754016b6293d7$export$e45941411d098b,
        shift: $032754016b6293d7$export$49e3d65796d89132,
        preventDefault: true
    },
    {
        key: "Mod-ArrowRight",
        mac: "Alt-ArrowRight",
        run: $032754016b6293d7$export$8fb2c619d55341b4,
        shift: $032754016b6293d7$export$5ebbb4cf65fe8a74,
        preventDefault: true
    },
    {
        mac: "Cmd-ArrowRight",
        run: $032754016b6293d7$export$912e453a1e062a62,
        shift: $032754016b6293d7$export$de427496204690a6,
        preventDefault: true
    },
    {
        key: "ArrowUp",
        run: $032754016b6293d7$export$fe179dad0485d99d,
        shift: $032754016b6293d7$export$92aa693a1ecd7061,
        preventDefault: true
    },
    {
        mac: "Cmd-ArrowUp",
        run: $032754016b6293d7$export$ff7ed6e6e1cb317f,
        shift: $032754016b6293d7$export$aa525ee829cc26b
    },
    {
        mac: "Ctrl-ArrowUp",
        run: $032754016b6293d7$export$546ec71a9f854193,
        shift: $032754016b6293d7$export$61eab34d4ff5cbaf
    },
    {
        key: "ArrowDown",
        run: $032754016b6293d7$export$75f9b75ffb1a9dc5,
        shift: $032754016b6293d7$export$bf847527697a3040,
        preventDefault: true
    },
    {
        mac: "Cmd-ArrowDown",
        run: $032754016b6293d7$export$b12ef1671b2836da,
        shift: $032754016b6293d7$export$fff0131cdd9694fe
    },
    {
        mac: "Ctrl-ArrowDown",
        run: $032754016b6293d7$export$6e407c2072d437f4,
        shift: $032754016b6293d7$export$a4c186a0dadaf91c
    },
    {
        key: "PageUp",
        run: $032754016b6293d7$export$546ec71a9f854193,
        shift: $032754016b6293d7$export$61eab34d4ff5cbaf
    },
    {
        key: "PageDown",
        run: $032754016b6293d7$export$6e407c2072d437f4,
        shift: $032754016b6293d7$export$a4c186a0dadaf91c
    },
    {
        key: "Home",
        run: $032754016b6293d7$export$64939ebc49b03818,
        shift: $032754016b6293d7$export$643176ee603b8e87,
        preventDefault: true
    },
    {
        key: "Mod-Home",
        run: $032754016b6293d7$export$ff7ed6e6e1cb317f,
        shift: $032754016b6293d7$export$aa525ee829cc26b
    },
    {
        key: "End",
        run: $032754016b6293d7$export$b59ae3b25af6ea13,
        shift: $032754016b6293d7$export$df223d0097d57a86,
        preventDefault: true
    },
    {
        key: "Mod-End",
        run: $032754016b6293d7$export$b12ef1671b2836da,
        shift: $032754016b6293d7$export$fff0131cdd9694fe
    },
    {
        key: "Enter",
        run: $032754016b6293d7$export$668310d2b1aa07d5,
        shift: $032754016b6293d7$export$668310d2b1aa07d5
    },
    {
        key: "Mod-a",
        run: $032754016b6293d7$export$90aca4adda6ff0f5
    },
    {
        key: "Backspace",
        run: $032754016b6293d7$export$1e8a14efe7ca9a33,
        shift: $032754016b6293d7$export$1e8a14efe7ca9a33,
        preventDefault: true
    },
    {
        key: "Delete",
        run: $032754016b6293d7$export$d41683a0f042cb80,
        preventDefault: true
    },
    {
        key: "Mod-Backspace",
        mac: "Alt-Backspace",
        run: $032754016b6293d7$export$3072f591ab219e94,
        preventDefault: true
    },
    {
        key: "Mod-Delete",
        mac: "Alt-Delete",
        run: $032754016b6293d7$export$56a4e2ef21b58242,
        preventDefault: true
    },
    {
        mac: "Mod-Backspace",
        run: $032754016b6293d7$export$d1072494cede984a,
        preventDefault: true
    },
    {
        mac: "Mod-Delete",
        run: $032754016b6293d7$export$b87eb3a389c264a4,
        preventDefault: true
    }
].concat(/*@__PURE__*/ $032754016b6293d7$export$ef7c3246c722c48f.map((b)=>({
        mac: b.key,
        run: b.run,
        shift: b.shift
    })));
/**
The default keymap. Includes all bindings from
[`standardKeymap`](https://codemirror.net/6/docs/ref/#commands.standardKeymap) plus the following:

- Alt-ArrowLeft (Ctrl-ArrowLeft on macOS): [`cursorSyntaxLeft`](https://codemirror.net/6/docs/ref/#commands.cursorSyntaxLeft) ([`selectSyntaxLeft`](https://codemirror.net/6/docs/ref/#commands.selectSyntaxLeft) with Shift)
- Alt-ArrowRight (Ctrl-ArrowRight on macOS): [`cursorSyntaxRight`](https://codemirror.net/6/docs/ref/#commands.cursorSyntaxRight) ([`selectSyntaxRight`](https://codemirror.net/6/docs/ref/#commands.selectSyntaxRight) with Shift)
- Alt-ArrowUp: [`moveLineUp`](https://codemirror.net/6/docs/ref/#commands.moveLineUp)
- Alt-ArrowDown: [`moveLineDown`](https://codemirror.net/6/docs/ref/#commands.moveLineDown)
- Shift-Alt-ArrowUp: [`copyLineUp`](https://codemirror.net/6/docs/ref/#commands.copyLineUp)
- Shift-Alt-ArrowDown: [`copyLineDown`](https://codemirror.net/6/docs/ref/#commands.copyLineDown)
- Ctrl-Alt-ArrowUp (Cmd-Alt-ArrowUp on macOS): [`addCursorAbove`](https://codemirror.net/6/docs/ref/#commands.addCursorAbove).
- Ctrl-Alt-ArrowDown (Cmd-Alt-ArrowDown on macOS): [`addCursorBelow`](https://codemirror.net/6/docs/ref/#commands.addCursorBelow).
- Escape: [`simplifySelection`](https://codemirror.net/6/docs/ref/#commands.simplifySelection)
- Ctrl-Enter (Cmd-Enter on macOS): [`insertBlankLine`](https://codemirror.net/6/docs/ref/#commands.insertBlankLine)
- Alt-l (Ctrl-l on macOS): [`selectLine`](https://codemirror.net/6/docs/ref/#commands.selectLine)
- Ctrl-i (Cmd-i on macOS): [`selectParentSyntax`](https://codemirror.net/6/docs/ref/#commands.selectParentSyntax)
- Ctrl-[ (Cmd-[ on macOS): [`indentLess`](https://codemirror.net/6/docs/ref/#commands.indentLess)
- Ctrl-] (Cmd-] on macOS): [`indentMore`](https://codemirror.net/6/docs/ref/#commands.indentMore)
- Ctrl-Alt-\\ (Cmd-Alt-\\ on macOS): [`indentSelection`](https://codemirror.net/6/docs/ref/#commands.indentSelection)
- Shift-Ctrl-k (Shift-Cmd-k on macOS): [`deleteLine`](https://codemirror.net/6/docs/ref/#commands.deleteLine)
- Shift-Ctrl-\\ (Shift-Cmd-\\ on macOS): [`cursorMatchingBracket`](https://codemirror.net/6/docs/ref/#commands.cursorMatchingBracket)
- Ctrl-/ (Cmd-/ on macOS): [`toggleComment`](https://codemirror.net/6/docs/ref/#commands.toggleComment).
- Shift-Alt-a: [`toggleBlockComment`](https://codemirror.net/6/docs/ref/#commands.toggleBlockComment).
- Ctrl-m (Alt-Shift-m on macOS): [`toggleTabFocusMode`](https://codemirror.net/6/docs/ref/#commands.toggleTabFocusMode).
*/ const $032754016b6293d7$export$ab2e8d0ac5d2b69e = /*@__PURE__*/ [
    {
        key: "Alt-ArrowLeft",
        mac: "Ctrl-ArrowLeft",
        run: $032754016b6293d7$export$1e53c014543c10bb,
        shift: $032754016b6293d7$export$67b15be4414061b5
    },
    {
        key: "Alt-ArrowRight",
        mac: "Ctrl-ArrowRight",
        run: $032754016b6293d7$export$62c6dc33f5d01e39,
        shift: $032754016b6293d7$export$74aa476df7791ce
    },
    {
        key: "Alt-ArrowUp",
        run: $032754016b6293d7$export$c4eebaf75cfae23e
    },
    {
        key: "Shift-Alt-ArrowUp",
        run: $032754016b6293d7$export$c3798d29213e527c
    },
    {
        key: "Alt-ArrowDown",
        run: $032754016b6293d7$export$ac19ae98a6fcd34c
    },
    {
        key: "Shift-Alt-ArrowDown",
        run: $032754016b6293d7$export$1ad385c375816d2f
    },
    {
        key: "Mod-Alt-ArrowUp",
        run: $032754016b6293d7$export$3054522ff62988dd
    },
    {
        key: "Mod-Alt-ArrowDown",
        run: $032754016b6293d7$export$83ff5bba776179f3
    },
    {
        key: "Escape",
        run: $032754016b6293d7$export$2f90cebc0d40abf
    },
    {
        key: "Mod-Enter",
        run: $032754016b6293d7$export$2ff1ccbcf65d0770
    },
    {
        key: "Alt-l",
        mac: "Ctrl-l",
        run: $032754016b6293d7$export$e41c12847640c21
    },
    {
        key: "Mod-i",
        run: $032754016b6293d7$export$f38a48fa120d50ce,
        preventDefault: true
    },
    {
        key: "Mod-[",
        run: $032754016b6293d7$export$e4b902122bfe67ae
    },
    {
        key: "Mod-]",
        run: $032754016b6293d7$export$a61bf6a946ffc826
    },
    {
        key: "Mod-Alt-\\",
        run: $032754016b6293d7$export$ffcf50534fec79c3
    },
    {
        key: "Shift-Mod-k",
        run: $032754016b6293d7$export$aba0d4cd8923f1ae
    },
    {
        key: "Shift-Mod-\\",
        run: $032754016b6293d7$export$e5a7e1f2d38b1f6a
    },
    {
        key: "Mod-/",
        run: $032754016b6293d7$export$afbcdd0bff36c567
    },
    {
        key: "Alt-A",
        run: $032754016b6293d7$export$19d6fa84ce3a55ab
    },
    {
        key: "Ctrl-m",
        mac: "Shift-Alt-m",
        run: $032754016b6293d7$export$f118650570e71643
    }
].concat($032754016b6293d7$export$ae5dfd95be821a1c);
/**
A binding that binds Tab to [`indentMore`](https://codemirror.net/6/docs/ref/#commands.indentMore) and
Shift-Tab to [`indentLess`](https://codemirror.net/6/docs/ref/#commands.indentLess).
Please see the [Tab example](../../examples/tab/) before using
this.
*/ const $032754016b6293d7$export$893b77570f8af4da = {
    key: "Tab",
    run: $032754016b6293d7$export$a61bf6a946ffc826,
    shift: $032754016b6293d7$export$e4b902122bfe67ae
};








const $976a3faeb93466fd$var$basicNormalize = typeof String.prototype.normalize == "function" ? (x)=>x.normalize("NFKD") : (x)=>x;
/**
A search cursor provides an iterator over text matches in a
document.
*/ class $976a3faeb93466fd$export$4989b254f32490be {
    /**
    Create a text cursor. The query is the search string, `from` to
    `to` provides the region to search.
    
    When `normalize` is given, it will be called, on both the query
    string and the content it is matched against, before comparing.
    You can, for example, create a case-insensitive search by
    passing `s => s.toLowerCase()`.
    
    Text is always normalized with
    [`.normalize("NFKD")`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/normalize)
    (when supported).
    */ constructor(text, query, from = 0, to = text.length, normalize, test){
        this.test = test;
        /**
        The current match (only holds a meaningful value after
        [`next`](https://codemirror.net/6/docs/ref/#search.SearchCursor.next) has been called and when
        `done` is false).
        
        The `precise` flag will be set to false if the match starts or
        ends _inside_ a character that, when normalized, expands to
        multiple characters. It indicates that the `from`-`to` range
        covers content that isn't part of the actual match.
        */ this.value = {
            from: 0,
            to: 0,
            precise: false
        };
        /**
        Whether the end of the iterated region has been reached.
        */ this.done = false;
        this.matches = [];
        this.buffer = "";
        this.bufferPos = 0;
        this.iter = text.iterRange(from, to);
        this.bufferStart = from;
        this.normalize = normalize ? (x)=>normalize($976a3faeb93466fd$var$basicNormalize(x)) : $976a3faeb93466fd$var$basicNormalize;
        this.query = this.normalize(query);
    }
    peek() {
        if (this.bufferPos == this.buffer.length) {
            this.bufferStart += this.buffer.length;
            this.iter.next();
            if (this.iter.done) return -1;
            this.bufferPos = 0;
            this.buffer = this.iter.value;
        }
        return (0, $6295c6875f57e3ee$export$42977f40461e1360)(this.buffer, this.bufferPos);
    }
    /**
    Look for the next match. Updates the iterator's
    [`value`](https://codemirror.net/6/docs/ref/#search.SearchCursor.value) and
    [`done`](https://codemirror.net/6/docs/ref/#search.SearchCursor.done) properties. Should be called
    at least once before using the cursor.
    */ next() {
        while(this.matches.length)this.matches.pop();
        return this.nextOverlapping();
    }
    /**
    The `next` method will ignore matches that partially overlap a
    previous match. This method behaves like `next`, but includes
    such matches.
    */ nextOverlapping() {
        for(;;){
            let next = this.peek();
            if (next < 0) {
                this.done = true;
                return this;
            }
            let str = (0, $6295c6875f57e3ee$export$73bfc63873071f74)(next), start = this.bufferStart + this.bufferPos;
            this.bufferPos += (0, $6295c6875f57e3ee$export$a870abf234f6353c)(next);
            let norm = this.normalize(str);
            if (norm.length) for(let i = 0, pos = start, posPrecise = true;; i++){
                let code = norm.charCodeAt(i);
                let match = this.match(code, pos, posPrecise, this.bufferPos + this.bufferStart, i == norm.length - 1);
                if (match) {
                    this.value = match;
                    return this;
                }
                if (i == norm.length - 1) break;
                if (posPrecise && i < str.length && str.charCodeAt(i) == code) pos++;
                else posPrecise = false;
            }
        }
    }
    match(code, pos, posPrecise, end, endPrecise) {
        let match = null;
        for(let i = 0; i < this.matches.length;){
            let partial = this.matches[i], keep = false;
            if (this.query.charCodeAt(partial.index) == code) {
                if (partial.index == this.query.length - 1) match = {
                    from: partial.from,
                    to: end,
                    precise: endPrecise && partial.precise
                };
                else {
                    partial.index++;
                    keep = true;
                }
            }
            if (keep) i++;
            else this.matches.splice(i, 1);
        }
        if (this.query.charCodeAt(0) == code) {
            if (this.query.length == 1) match = {
                from: pos,
                to: end,
                precise: posPrecise && endPrecise
            };
            else this.matches.push({
                from: pos,
                index: 1,
                precise: posPrecise
            });
        }
        if (match && this.test && !this.test(match.from, match.to, this.buffer, this.bufferStart)) match = null;
        return match;
    }
}
if (typeof Symbol != "undefined") $976a3faeb93466fd$export$4989b254f32490be.prototype[Symbol.iterator] = function() {
    return this;
};
const $976a3faeb93466fd$var$empty = {
    from: -1,
    to: -1,
    match: /*@__PURE__*/ /.*/.exec(""),
    precise: true
};
const $976a3faeb93466fd$var$baseFlags = "gm" + (/x/.unicode == null ? "" : "u");
/**
This class is similar to [`SearchCursor`](https://codemirror.net/6/docs/ref/#search.SearchCursor)
but searches for a regular expression pattern instead of a plain
string.
*/ class $976a3faeb93466fd$export$234e2283eb9dcd35 {
    /**
    Create a cursor that will search the given range in the given
    document. `query` should be the raw pattern (as you'd pass it to
    `new RegExp`).
    */ constructor(text, query, options, from = 0, to = text.length){
        this.text = text;
        this.to = to;
        this.curLine = "";
        /**
        Set to `true` when the cursor has reached the end of the search
        range.
        */ this.done = false;
        /**
        Will contain an object with the extent of the match and the
        match object when [`next`](https://codemirror.net/6/docs/ref/#search.RegExpCursor.next)
        sucessfully finds a match. The `precise` flag is always true for
        this type of cursor, and only there to make sure this cursor is
        a subtype of `SearchCursor`.
        */ this.value = $976a3faeb93466fd$var$empty;
        if (/\\[sWDnr]|\n|\r|\[\^/.test(query)) return new $976a3faeb93466fd$var$MultilineRegExpCursor(text, query, options, from, to);
        this.re = new RegExp(query, $976a3faeb93466fd$var$baseFlags + ((options === null || options === void 0 ? void 0 : options.ignoreCase) ? "i" : ""));
        this.test = options === null || options === void 0 ? void 0 : options.test;
        this.iter = text.iter();
        let startLine = text.lineAt(from);
        this.curLineStart = startLine.from;
        this.matchPos = $976a3faeb93466fd$var$toCharEnd(text, from);
        this.getLine(this.curLineStart);
    }
    getLine(skip) {
        this.iter.next(skip);
        if (this.iter.lineBreak) this.curLine = "";
        else {
            this.curLine = this.iter.value;
            if (this.curLineStart + this.curLine.length > this.to) this.curLine = this.curLine.slice(0, this.to - this.curLineStart);
            this.iter.next();
        }
    }
    nextLine() {
        this.curLineStart = this.curLineStart + this.curLine.length + 1;
        if (this.curLineStart > this.to) this.curLine = "";
        else this.getLine(0);
    }
    /**
    Move to the next match, if there is one.
    */ next() {
        for(let off = this.matchPos - this.curLineStart;;){
            this.re.lastIndex = off;
            let match = this.matchPos <= this.to && this.re.exec(this.curLine);
            if (match) {
                let from = this.curLineStart + match.index, to = from + match[0].length;
                this.matchPos = $976a3faeb93466fd$var$toCharEnd(this.text, to + (from == to ? 1 : 0));
                if (from == this.curLineStart + this.curLine.length) this.nextLine();
                if ((from < to || from > this.value.to) && (!this.test || this.test(from, to, match))) {
                    this.value = {
                        from: from,
                        to: to,
                        precise: true,
                        match: match
                    };
                    return this;
                }
                off = this.matchPos - this.curLineStart;
            } else if (this.curLineStart + this.curLine.length < this.to) {
                this.nextLine();
                off = 0;
            } else {
                this.done = true;
                return this;
            }
        }
    }
}
const $976a3faeb93466fd$var$flattened = /*@__PURE__*/ new WeakMap();
// Reusable (partially) flattened document strings
class $976a3faeb93466fd$var$FlattenedDoc {
    constructor(from, text){
        this.from = from;
        this.text = text;
    }
    get to() {
        return this.from + this.text.length;
    }
    static get(doc, from, to) {
        let cached = $976a3faeb93466fd$var$flattened.get(doc);
        if (!cached || cached.from >= to || cached.to <= from) {
            let flat = new $976a3faeb93466fd$var$FlattenedDoc(from, doc.sliceString(from, to));
            $976a3faeb93466fd$var$flattened.set(doc, flat);
            return flat;
        }
        if (cached.from == from && cached.to == to) return cached;
        let { text: text, from: cachedFrom } = cached;
        if (cachedFrom > from) {
            text = doc.sliceString(from, cachedFrom) + text;
            cachedFrom = from;
        }
        if (cached.to < to) text += doc.sliceString(cached.to, to);
        $976a3faeb93466fd$var$flattened.set(doc, new $976a3faeb93466fd$var$FlattenedDoc(cachedFrom, text));
        return new $976a3faeb93466fd$var$FlattenedDoc(from, text.slice(from - cachedFrom, to - cachedFrom));
    }
}
class $976a3faeb93466fd$var$MultilineRegExpCursor {
    constructor(text, query, options, from, to){
        this.text = text;
        this.to = to;
        this.done = false;
        this.value = $976a3faeb93466fd$var$empty;
        this.matchPos = $976a3faeb93466fd$var$toCharEnd(text, from);
        this.re = new RegExp(query, $976a3faeb93466fd$var$baseFlags + ((options === null || options === void 0 ? void 0 : options.ignoreCase) ? "i" : ""));
        this.test = options === null || options === void 0 ? void 0 : options.test;
        this.flat = $976a3faeb93466fd$var$FlattenedDoc.get(text, from, this.chunkEnd(from + 5000 /* Chunk.Base */ ));
    }
    chunkEnd(pos) {
        return pos >= this.to ? this.to : this.text.lineAt(pos).to;
    }
    next() {
        for(;;){
            let off = this.re.lastIndex = this.matchPos - this.flat.from;
            let match = this.re.exec(this.flat.text);
            // Skip empty matches directly after the last match
            if (match && !match[0] && match.index == off) {
                this.re.lastIndex = off + 1;
                match = this.re.exec(this.flat.text);
            }
            if (match) {
                let from = this.flat.from + match.index, to = from + match[0].length;
                // If a match goes almost to the end of a noncomplete chunk, try
                // again, since it'll likely be able to match more
                if ((this.flat.to >= this.to || match.index + match[0].length <= this.flat.text.length - 10) && (!this.test || this.test(from, to, match))) {
                    this.value = {
                        from: from,
                        to: to,
                        precise: true,
                        match: match
                    };
                    this.matchPos = $976a3faeb93466fd$var$toCharEnd(this.text, to + (from == to ? 1 : 0));
                    return this;
                }
            }
            if (this.flat.to == this.to) {
                this.done = true;
                return this;
            }
            // Grow the flattened doc
            this.flat = $976a3faeb93466fd$var$FlattenedDoc.get(this.text, this.flat.from, this.chunkEnd(this.flat.from + this.flat.text.length * 2));
        }
    }
}
if (typeof Symbol != "undefined") $976a3faeb93466fd$export$234e2283eb9dcd35.prototype[Symbol.iterator] = $976a3faeb93466fd$var$MultilineRegExpCursor.prototype[Symbol.iterator] = function() {
    return this;
};
function $976a3faeb93466fd$var$validRegExp(source) {
    try {
        new RegExp(source, $976a3faeb93466fd$var$baseFlags);
        return true;
    } catch (_a) {
        return false;
    }
}
function $976a3faeb93466fd$var$toCharEnd(text, pos) {
    if (pos >= text.length) return pos;
    let line = text.lineAt(pos), next;
    while(pos < line.to && (next = line.text.charCodeAt(pos - line.from)) >= 0xDC00 && next < 0xE000)pos++;
    return pos;
}
/**
Command that shows a dialog asking the user for a line number, and
when a valid position is provided, moves the cursor to that line.

Supports line numbers, relative line offsets prefixed with `+` or
`-`, document percentages suffixed with `%`, and an optional
column position by adding `:` and a second number after the line
number.
*/ const $976a3faeb93466fd$export$5d5b784f9a618ec3 = (view)=>{
    let { state: state } = view;
    let line = String(state.doc.lineAt(view.state.selection.main.head).number);
    let { close: close, result: result } = (0, $7beee9608540d2c3$export$61e0a65f251cfdb3)(view, {
        label: state.phrase("Go to line"),
        input: {
            type: "text",
            name: "line",
            value: line
        },
        focus: true,
        submitLabel: state.phrase("go")
    });
    result.then((form)=>{
        let match = form && /^([+-])?(\d+)?(:\d+)?(%)?$/.exec(form.elements["line"].value);
        if (!match) {
            view.dispatch({
                effects: close
            });
            return;
        }
        let startLine = state.doc.lineAt(state.selection.main.head);
        let [, sign, ln, cl, percent] = match;
        let col = cl ? +cl.slice(1) : 0;
        let line = ln ? +ln : startLine.number;
        if (ln && percent) {
            let pc = line / 100;
            if (sign) pc = pc * (sign == "-" ? -1 : 1) + startLine.number / state.doc.lines;
            line = Math.round(state.doc.lines * pc);
        } else if (ln && sign) line = line * (sign == "-" ? -1 : 1) + startLine.number;
        let docLine = state.doc.line(Math.max(1, Math.min(state.doc.lines, line)));
        let selection = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(docLine.from + Math.max(0, Math.min(col, docLine.length)));
        view.dispatch({
            effects: [
                close,
                (0, $7beee9608540d2c3$export$eece2fccabbb77c5).scrollIntoView(selection.from, {
                    y: 'center'
                })
            ],
            selection: selection
        });
    });
    return true;
};
const $976a3faeb93466fd$var$defaultHighlightOptions = {
    highlightWordAroundCursor: false,
    minSelectionLength: 1,
    maxMatches: 100,
    wholeWords: false
};
const $976a3faeb93466fd$var$highlightConfig = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (options) {
        return (0, $6295c6875f57e3ee$export$4e19c0b693794a7e)(options, $976a3faeb93466fd$var$defaultHighlightOptions, {
            highlightWordAroundCursor: (a, b)=>a || b,
            minSelectionLength: Math.min,
            maxMatches: Math.min
        });
    }
});
/**
This extension highlights text that matches the selection. It uses
the `"cm-selectionMatch"` class for the highlighting. When
`highlightWordAroundCursor` is enabled, the word at the cursor
itself will be highlighted with `"cm-selectionMatch-main"`.
*/ function $976a3faeb93466fd$export$f14efe56171a2e02(options) {
    let ext = [
        $976a3faeb93466fd$var$defaultTheme,
        $976a3faeb93466fd$var$matchHighlighter
    ];
    if (options) ext.push($976a3faeb93466fd$var$highlightConfig.of(options));
    return ext;
}
const $976a3faeb93466fd$var$matchDeco = /*@__PURE__*/ (0, $7beee9608540d2c3$export$10e30b733df217ea).mark({
    class: "cm-selectionMatch"
});
const $976a3faeb93466fd$var$mainMatchDeco = /*@__PURE__*/ (0, $7beee9608540d2c3$export$10e30b733df217ea).mark({
    class: "cm-selectionMatch cm-selectionMatch-main"
});
// Whether the characters directly outside the given positions are non-word characters
function $976a3faeb93466fd$var$insideWordBoundaries(check, state, from, to) {
    return (from == 0 || check(state.sliceDoc(from - 1, from)) != (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word) && (to == state.doc.length || check(state.sliceDoc(to, to + 1)) != (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word);
}
// Whether the characters directly at the given positions are word characters
function $976a3faeb93466fd$var$insideWord(check, state, from, to) {
    return check(state.sliceDoc(from, from + 1)) == (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word && check(state.sliceDoc(to - 1, to)) == (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word;
}
const $976a3faeb93466fd$var$matchHighlighter = /*@__PURE__*/ (0, $7beee9608540d2c3$export$44d5eccfd62adda7).fromClass(class {
    constructor(view){
        this.decorations = this.getDeco(view);
    }
    update(update) {
        if (update.selectionSet || update.docChanged || update.viewportChanged) this.decorations = this.getDeco(update.view);
    }
    getDeco(view) {
        let conf = view.state.facet($976a3faeb93466fd$var$highlightConfig);
        let { state: state } = view, sel = state.selection;
        if (sel.ranges.length > 1) return (0, $7beee9608540d2c3$export$10e30b733df217ea).none;
        let range = sel.main, query, check = null;
        if (range.empty) {
            if (!conf.highlightWordAroundCursor) return (0, $7beee9608540d2c3$export$10e30b733df217ea).none;
            let word = state.wordAt(range.head);
            if (!word) return (0, $7beee9608540d2c3$export$10e30b733df217ea).none;
            check = state.charCategorizer(range.head);
            query = state.sliceDoc(word.from, word.to);
        } else {
            let len = range.to - range.from;
            if (len < conf.minSelectionLength || len > 200) return (0, $7beee9608540d2c3$export$10e30b733df217ea).none;
            if (conf.wholeWords) {
                query = state.sliceDoc(range.from, range.to); // TODO: allow and include leading/trailing space?
                check = state.charCategorizer(range.head);
                if (!($976a3faeb93466fd$var$insideWordBoundaries(check, state, range.from, range.to) && $976a3faeb93466fd$var$insideWord(check, state, range.from, range.to))) return (0, $7beee9608540d2c3$export$10e30b733df217ea).none;
            } else {
                query = state.sliceDoc(range.from, range.to);
                if (!query) return (0, $7beee9608540d2c3$export$10e30b733df217ea).none;
            }
        }
        let deco = [];
        for (let part of view.visibleRanges){
            let cursor = new $976a3faeb93466fd$export$4989b254f32490be(state.doc, query, part.from, part.to);
            while(!cursor.next().done){
                let { from: from, to: to } = cursor.value;
                if (!check || $976a3faeb93466fd$var$insideWordBoundaries(check, state, from, to)) {
                    if (range.empty && from <= range.from && to >= range.to) deco.push($976a3faeb93466fd$var$mainMatchDeco.range(from, to));
                    else if (from >= range.to || to <= range.from) deco.push($976a3faeb93466fd$var$matchDeco.range(from, to));
                    if (deco.length > conf.maxMatches) return (0, $7beee9608540d2c3$export$10e30b733df217ea).none;
                }
            }
        }
        return (0, $7beee9608540d2c3$export$10e30b733df217ea).set(deco);
    }
}, {
    decorations: (v)=>v.decorations
});
const $976a3faeb93466fd$var$defaultTheme = /*@__PURE__*/ (0, $7beee9608540d2c3$export$eece2fccabbb77c5).baseTheme({
    ".cm-selectionMatch": {
        backgroundColor: "#99ff7780"
    },
    ".cm-searchMatch .cm-selectionMatch": {
        backgroundColor: "transparent"
    }
});
// Select the words around the cursors.
const $976a3faeb93466fd$var$selectWord = ({ state: state, dispatch: dispatch })=>{
    let { selection: selection } = state;
    let newSel = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create(selection.ranges.map((range)=>state.wordAt(range.head) || (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(range.head)), selection.mainIndex);
    if (newSel.eq(selection)) return false;
    dispatch(state.update({
        selection: newSel
    }));
    return true;
};
// Find next occurrence of query relative to last cursor. Wrap around
// the document if there are no more matches.
function $976a3faeb93466fd$var$findNextOccurrence(state, query) {
    let { main: main, ranges: ranges } = state.selection;
    let word = state.wordAt(main.head), fullWord = word && word.from == main.from && word.to == main.to;
    for(let cycled = false, cursor = new $976a3faeb93466fd$export$4989b254f32490be(state.doc, query, ranges[ranges.length - 1].to);;){
        cursor.next();
        if (cursor.done) {
            if (cycled) return null;
            cursor = new $976a3faeb93466fd$export$4989b254f32490be(state.doc, query, 0, Math.max(0, ranges[ranges.length - 1].from - 1));
            cycled = true;
        } else {
            if (cycled && ranges.some((r)=>r.from == cursor.value.from)) continue;
            if (fullWord) {
                let word = state.wordAt(cursor.value.from);
                if (!word || word.from != cursor.value.from || word.to != cursor.value.to) continue;
            }
            return cursor.value;
        }
    }
}
/**
Select next occurrence of the current selection. Expand selection
to the surrounding word when the selection is empty.
*/ const $976a3faeb93466fd$export$dd0e64cebe05ee17 = ({ state: state, dispatch: dispatch })=>{
    let { ranges: ranges } = state.selection;
    if (ranges.some((sel)=>sel.from === sel.to)) return $976a3faeb93466fd$var$selectWord({
        state: state,
        dispatch: dispatch
    });
    let searchedText = state.sliceDoc(ranges[0].from, ranges[0].to);
    if (state.selection.ranges.some((r)=>state.sliceDoc(r.from, r.to) != searchedText)) return false;
    let range = $976a3faeb93466fd$var$findNextOccurrence(state, searchedText);
    if (!range) return false;
    dispatch(state.update({
        selection: state.selection.addRange((0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(range.from, range.to), false),
        effects: (0, $7beee9608540d2c3$export$eece2fccabbb77c5).scrollIntoView(range.to)
    }));
    return true;
};
const $976a3faeb93466fd$var$searchConfigFacet = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        return (0, $6295c6875f57e3ee$export$4e19c0b693794a7e)(configs, {
            top: false,
            caseSensitive: false,
            literal: false,
            regexp: false,
            wholeWord: false,
            createPanel: (view)=>new $976a3faeb93466fd$var$SearchPanel(view),
            scrollToMatch: (range)=>(0, $7beee9608540d2c3$export$eece2fccabbb77c5).scrollIntoView(range)
        });
    }
});
/**
Add search state to the editor configuration, and optionally
configure the search extension.
([`openSearchPanel`](https://codemirror.net/6/docs/ref/#search.openSearchPanel) will automatically
enable this if it isn't already on).
*/ function $976a3faeb93466fd$export$d76128d007d19019(config) {
    return config ? [
        $976a3faeb93466fd$var$searchConfigFacet.of(config),
        $976a3faeb93466fd$var$searchExtensions
    ] : $976a3faeb93466fd$var$searchExtensions;
}
/**
A search query. Part of the editor's search state.
*/ class $976a3faeb93466fd$export$4bc63ef50ec3954e {
    /**
    Create a query object.
    */ constructor(config){
        this.search = config.search;
        this.caseSensitive = !!config.caseSensitive;
        this.literal = !!config.literal;
        this.regexp = !!config.regexp;
        this.replace = config.replace || "";
        this.valid = !!this.search && (!this.regexp || $976a3faeb93466fd$var$validRegExp(this.search));
        this.unquoted = this.unquote(this.search);
        this.wholeWord = !!config.wholeWord;
        this.test = config.test;
    }
    /**
    @internal
    */ unquote(text) {
        return this.literal ? text : text.replace(/\\([nrt\\])/g, (_, ch)=>ch == "n" ? "\n" : ch == "r" ? "\r" : ch == "t" ? "\t" : "\\");
    }
    /**
    Compare this query to another query.
    */ eq(other) {
        return this.search == other.search && this.replace == other.replace && this.caseSensitive == other.caseSensitive && this.regexp == other.regexp && this.wholeWord == other.wholeWord && this.test == other.test;
    }
    /**
    @internal
    */ create() {
        return this.regexp ? new $976a3faeb93466fd$var$RegExpQuery(this) : new $976a3faeb93466fd$var$StringQuery(this);
    }
    /**
    Get a search cursor for this query, searching through the given
    range in the given state.
    */ getCursor(state, from = 0, to) {
        let st = state.doc ? state : (0, $6295c6875f57e3ee$export$afa855cbfaff27f2).create({
            doc: state
        });
        if (to == null) to = st.doc.length;
        return this.regexp ? $976a3faeb93466fd$var$regexpCursor(this, st, from, to) : $976a3faeb93466fd$var$stringCursor(this, st, from, to);
    }
}
class $976a3faeb93466fd$var$QueryType {
    constructor(spec){
        this.spec = spec;
    }
}
function $976a3faeb93466fd$var$wrapStringTest(test, state, inner) {
    return (from, to, buffer, bufferPos)=>{
        if (inner && !inner(from, to, buffer, bufferPos)) return false;
        let match = from >= bufferPos && to <= bufferPos + buffer.length ? buffer.slice(from - bufferPos, to - bufferPos) : state.doc.sliceString(from, to);
        return test(match, state, from, to);
    };
}
function $976a3faeb93466fd$var$stringCursor(spec, state, from, to) {
    let test;
    if (spec.wholeWord) test = $976a3faeb93466fd$var$stringWordTest(state.doc, state.charCategorizer(state.selection.main.head));
    if (spec.test) test = $976a3faeb93466fd$var$wrapStringTest(spec.test, state, test);
    return new $976a3faeb93466fd$export$4989b254f32490be(state.doc, spec.unquoted, from, to, spec.caseSensitive ? undefined : (x)=>x.toLowerCase(), test);
}
function $976a3faeb93466fd$var$stringWordTest(doc, categorizer) {
    return (from, to, buf, bufPos)=>{
        if (bufPos > from || bufPos + buf.length < to) {
            bufPos = Math.max(0, from - 2);
            buf = doc.sliceString(bufPos, Math.min(doc.length, to + 2));
        }
        return (categorizer($976a3faeb93466fd$var$charBefore(buf, from - bufPos)) != (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word || categorizer($976a3faeb93466fd$var$charAfter(buf, from - bufPos)) != (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word) && (categorizer($976a3faeb93466fd$var$charAfter(buf, to - bufPos)) != (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word || categorizer($976a3faeb93466fd$var$charBefore(buf, to - bufPos)) != (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word);
    };
}
class $976a3faeb93466fd$var$StringQuery extends $976a3faeb93466fd$var$QueryType {
    constructor(spec){
        super(spec);
    }
    nextMatch(state, curFrom, curTo) {
        let cursor = $976a3faeb93466fd$var$stringCursor(this.spec, state, curTo, state.doc.length).nextOverlapping();
        if (cursor.done) {
            let end = Math.min(state.doc.length, curFrom + this.spec.unquoted.length);
            cursor = $976a3faeb93466fd$var$stringCursor(this.spec, state, 0, end).nextOverlapping();
        }
        return cursor.done || cursor.value.from == curFrom && cursor.value.to == curTo ? null : cursor.value;
    }
    // Searching in reverse is, rather than implementing an inverted search
    // cursor, done by scanning chunk after chunk forward.
    prevMatchInRange(state, from, to) {
        for(let pos = to;;){
            let start = Math.max(from, pos - 10000 /* FindPrev.ChunkSize */  - this.spec.unquoted.length);
            let cursor = $976a3faeb93466fd$var$stringCursor(this.spec, state, start, pos), range = null;
            while(!cursor.nextOverlapping().done)range = cursor.value;
            if (range) return range;
            if (start == from) return null;
            pos -= 10000 /* FindPrev.ChunkSize */ ;
        }
    }
    prevMatch(state, curFrom, curTo) {
        let found = this.prevMatchInRange(state, 0, curFrom);
        if (!found) found = this.prevMatchInRange(state, Math.max(0, curTo - this.spec.unquoted.length), state.doc.length);
        return found && (found.from != curFrom || found.to != curTo) ? found : null;
    }
    getReplacement(_result) {
        return this.spec.unquote(this.spec.replace);
    }
    matchAll(state, limit) {
        let cursor = $976a3faeb93466fd$var$stringCursor(this.spec, state, 0, state.doc.length), ranges = [];
        while(!cursor.next().done){
            if (ranges.length >= limit) return null;
            ranges.push(cursor.value);
        }
        return ranges;
    }
    highlight(state, from, to, add) {
        let cursor = $976a3faeb93466fd$var$stringCursor(this.spec, state, Math.max(0, from - this.spec.unquoted.length), Math.min(to + this.spec.unquoted.length, state.doc.length));
        while(!cursor.next().done)add(cursor.value.from, cursor.value.to);
    }
}
function $976a3faeb93466fd$var$wrapRegexpTest(test, state, inner) {
    return (from, to, match)=>{
        return (!inner || inner(from, to, match)) && test(match[0], state, from, to);
    };
}
function $976a3faeb93466fd$var$regexpCursor(spec, state, from, to) {
    let test;
    if (spec.wholeWord) test = $976a3faeb93466fd$var$regexpWordTest(state.charCategorizer(state.selection.main.head));
    if (spec.test) test = $976a3faeb93466fd$var$wrapRegexpTest(spec.test, state, test);
    return new $976a3faeb93466fd$export$234e2283eb9dcd35(state.doc, spec.search, {
        ignoreCase: !spec.caseSensitive,
        test: test
    }, from, to);
}
function $976a3faeb93466fd$var$charBefore(str, index) {
    return str.slice((0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(str, index, false), index);
}
function $976a3faeb93466fd$var$charAfter(str, index) {
    return str.slice(index, (0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(str, index));
}
function $976a3faeb93466fd$var$regexpWordTest(categorizer) {
    return (_from, _to, match)=>!match[0].length || (categorizer($976a3faeb93466fd$var$charBefore(match.input, match.index)) != (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word || categorizer($976a3faeb93466fd$var$charAfter(match.input, match.index)) != (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word) && (categorizer($976a3faeb93466fd$var$charAfter(match.input, match.index + match[0].length)) != (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word || categorizer($976a3faeb93466fd$var$charBefore(match.input, match.index + match[0].length)) != (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word);
}
class $976a3faeb93466fd$var$RegExpQuery extends $976a3faeb93466fd$var$QueryType {
    nextMatch(state, curFrom, curTo) {
        let cursor = $976a3faeb93466fd$var$regexpCursor(this.spec, state, curTo, state.doc.length).next();
        if (cursor.done) cursor = $976a3faeb93466fd$var$regexpCursor(this.spec, state, 0, curFrom).next();
        return cursor.done ? null : cursor.value;
    }
    prevMatchInRange(state, from, to) {
        for(let size = 1;; size++){
            let start = Math.max(from, to - size * 10000 /* FindPrev.ChunkSize */ );
            let cursor = $976a3faeb93466fd$var$regexpCursor(this.spec, state, start, to), range = null;
            while(!cursor.next().done)range = cursor.value;
            if (range && (start == from || range.from > start + 10)) return range;
            if (start == from) return null;
        }
    }
    prevMatch(state, curFrom, curTo) {
        return this.prevMatchInRange(state, 0, curFrom) || this.prevMatchInRange(state, curTo, state.doc.length);
    }
    getReplacement(result) {
        return this.spec.unquote(this.spec.replace).replace(/\$([$&]|\d+)/g, (m, i)=>{
            if (i == "&") return result.match[0];
            if (i == "$") return "$";
            for(let l = i.length; l > 0; l--){
                let n = +i.slice(0, l);
                if (n > 0 && n < result.match.length) return result.match[n] + i.slice(l);
            }
            return m;
        });
    }
    matchAll(state, limit) {
        let cursor = $976a3faeb93466fd$var$regexpCursor(this.spec, state, 0, state.doc.length), ranges = [];
        while(!cursor.next().done){
            if (ranges.length >= limit) return null;
            ranges.push(cursor.value);
        }
        return ranges;
    }
    highlight(state, from, to, add) {
        let cursor = $976a3faeb93466fd$var$regexpCursor(this.spec, state, Math.max(0, from - 250 /* RegExp.HighlightMargin */ ), Math.min(to + 250 /* RegExp.HighlightMargin */ , state.doc.length));
        while(!cursor.next().done)add(cursor.value.from, cursor.value.to);
    }
}
/**
A state effect that updates the current search query. Note that
this only has an effect if the search state has been initialized
(by including [`search`](https://codemirror.net/6/docs/ref/#search.search) in your configuration or
by running [`openSearchPanel`](https://codemirror.net/6/docs/ref/#search.openSearchPanel) at least
once).
*/ const $976a3faeb93466fd$export$2cd1e14773f5e71b = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
const $976a3faeb93466fd$var$togglePanel = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
const $976a3faeb93466fd$var$searchState = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$34381b1ce2130245).define({
    create (state) {
        return new $976a3faeb93466fd$var$SearchState($976a3faeb93466fd$var$defaultQuery(state).create(), null);
    },
    update (value, tr) {
        for (let effect of tr.effects){
            if (effect.is($976a3faeb93466fd$export$2cd1e14773f5e71b)) value = new $976a3faeb93466fd$var$SearchState(effect.value.create(), value.panel);
            else if (effect.is($976a3faeb93466fd$var$togglePanel)) value = new $976a3faeb93466fd$var$SearchState(value.query, effect.value ? $976a3faeb93466fd$var$createSearchPanel : null);
        }
        return value;
    },
    provide: (f)=>(0, $7beee9608540d2c3$export$e89c3c9af31c1e3b).from(f, (val)=>val.panel)
});
/**
Get the current search query from an editor state.
*/ function $976a3faeb93466fd$export$1664b92369554829(state) {
    let curState = state.field($976a3faeb93466fd$var$searchState, false);
    return curState ? curState.query.spec : $976a3faeb93466fd$var$defaultQuery(state);
}
/**
Query whether the search panel is open in the given editor state.
*/ function $976a3faeb93466fd$export$453cecf1765eeb62(state) {
    var _a;
    return ((_a = state.field($976a3faeb93466fd$var$searchState, false)) === null || _a === void 0 ? void 0 : _a.panel) != null;
}
class $976a3faeb93466fd$var$SearchState {
    constructor(query, panel){
        this.query = query;
        this.panel = panel;
    }
}
const $976a3faeb93466fd$var$matchMark = /*@__PURE__*/ (0, $7beee9608540d2c3$export$10e30b733df217ea).mark({
    class: "cm-searchMatch"
}), $976a3faeb93466fd$var$selectedMatchMark = /*@__PURE__*/ (0, $7beee9608540d2c3$export$10e30b733df217ea).mark({
    class: "cm-searchMatch cm-searchMatch-selected"
});
const $976a3faeb93466fd$var$searchHighlighter = /*@__PURE__*/ (0, $7beee9608540d2c3$export$44d5eccfd62adda7).fromClass(class {
    constructor(view){
        this.view = view;
        this.decorations = this.highlight(view.state.field($976a3faeb93466fd$var$searchState));
    }
    update(update) {
        let state = update.state.field($976a3faeb93466fd$var$searchState);
        if (state != update.startState.field($976a3faeb93466fd$var$searchState) || update.docChanged || update.selectionSet || update.viewportChanged) this.decorations = this.highlight(state);
    }
    highlight({ query: query, panel: panel }) {
        if (!panel || !query.spec.valid) return (0, $7beee9608540d2c3$export$10e30b733df217ea).none;
        let { view: view } = this;
        let builder = new (0, $6295c6875f57e3ee$export$89e09ce03c7e8594)();
        for(let i = 0, ranges = view.visibleRanges, l = ranges.length; i < l; i++){
            let { from: from, to: to } = ranges[i];
            while(i < l - 1 && to > ranges[i + 1].from - 500 /* RegExp.HighlightMargin */ )to = ranges[++i].to;
            query.highlight(view.state, from, to, (from, to)=>{
                let selected = view.state.selection.ranges.some((r)=>r.from == from && r.to == to);
                builder.add(from, to, selected ? $976a3faeb93466fd$var$selectedMatchMark : $976a3faeb93466fd$var$matchMark);
            });
        }
        return builder.finish();
    }
}, {
    decorations: (v)=>v.decorations
});
function $976a3faeb93466fd$var$searchCommand(f) {
    return (view)=>{
        let state = view.state.field($976a3faeb93466fd$var$searchState, false);
        return state && state.query.spec.valid ? f(view, state) : $976a3faeb93466fd$export$8894af164d40b422(view);
    };
}
/**
Open the search panel if it isn't already open, and move the
selection to the first match after the current main selection.
Will wrap around to the start of the document when it reaches the
end.
*/ const $976a3faeb93466fd$export$ebdf538520f8717 = /*@__PURE__*/ $976a3faeb93466fd$var$searchCommand((view, { query: query })=>{
    let { to: to } = view.state.selection.main;
    let next = query.nextMatch(view.state, to, to);
    if (!next) return false;
    let selection = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).single(next.from, next.to);
    let config = view.state.facet($976a3faeb93466fd$var$searchConfigFacet);
    view.dispatch({
        selection: selection,
        effects: [
            $976a3faeb93466fd$var$announceMatch(view, next),
            config.scrollToMatch(selection.main, view)
        ],
        userEvent: "select.search"
    });
    $976a3faeb93466fd$var$selectSearchInput(view);
    return true;
});
/**
Move the selection to the previous instance of the search query,
before the current main selection. Will wrap past the start
of the document to start searching at the end again.
*/ const $976a3faeb93466fd$export$eef4841c27f82c55 = /*@__PURE__*/ $976a3faeb93466fd$var$searchCommand((view, { query: query })=>{
    let { state: state } = view, { from: from } = state.selection.main;
    let prev = query.prevMatch(state, from, from);
    if (!prev) return false;
    let selection = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).single(prev.from, prev.to);
    let config = view.state.facet($976a3faeb93466fd$var$searchConfigFacet);
    view.dispatch({
        selection: selection,
        effects: [
            $976a3faeb93466fd$var$announceMatch(view, prev),
            config.scrollToMatch(selection.main, view)
        ],
        userEvent: "select.search"
    });
    $976a3faeb93466fd$var$selectSearchInput(view);
    return true;
});
/**
Select all instances of the search query.
*/ const $976a3faeb93466fd$export$5d21cfc86ff1ce1d = /*@__PURE__*/ $976a3faeb93466fd$var$searchCommand((view, { query: query })=>{
    let ranges = query.matchAll(view.state, 1000);
    if (!ranges || !ranges.length) return false;
    view.dispatch({
        selection: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create(ranges.map((r)=>(0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(r.from, r.to))),
        userEvent: "select.search.matches"
    });
    return true;
});
/**
Select all instances of the currently selected text.
*/ const $976a3faeb93466fd$export$6f1c98d8556667b5 = ({ state: state, dispatch: dispatch })=>{
    let sel = state.selection;
    if (sel.ranges.length > 1 || sel.main.empty) return false;
    let { from: from, to: to } = sel.main;
    let ranges = [], main = 0;
    for(let cur = new $976a3faeb93466fd$export$4989b254f32490be(state.doc, state.sliceDoc(from, to)); !cur.next().done;){
        if (ranges.length > 1000) return false;
        if (cur.value.from == from) main = ranges.length;
        ranges.push((0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(cur.value.from, cur.value.to));
    }
    dispatch(state.update({
        selection: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create(ranges, main),
        userEvent: "select.search.matches"
    }));
    return true;
};
/**
Replace the current match of the search query.
*/ const $976a3faeb93466fd$export$f9afe47535eaf3d2 = /*@__PURE__*/ $976a3faeb93466fd$var$searchCommand((view, { query: query })=>{
    let { state: state } = view, { from: from, to: to } = state.selection.main;
    if (state.readOnly) return false;
    let match = query.nextMatch(state, from, from);
    if (!match) return false;
    let next = match;
    let changes = [], selection, replacement;
    let effects = [];
    if (!next.precise) next = query.nextMatch(state, next.from, next.to);
    else if (next.from == from && next.to == to) {
        replacement = state.toText(query.getReplacement(next));
        changes.push({
            from: next.from,
            to: next.to,
            insert: replacement
        });
        next = query.nextMatch(state, next.from, next.to);
        effects.push((0, $7beee9608540d2c3$export$eece2fccabbb77c5).announce.of(state.phrase("replaced match on line $", state.doc.lineAt(from).number) + "."));
    }
    let changeSet = view.state.changes(changes);
    if (next) {
        selection = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).single(next.from, next.to).map(changeSet);
        effects.push($976a3faeb93466fd$var$announceMatch(view, next));
        effects.push(state.facet($976a3faeb93466fd$var$searchConfigFacet).scrollToMatch(selection.main, view));
    }
    view.dispatch({
        changes: changeSet,
        selection: selection,
        effects: effects,
        userEvent: "input.replace"
    });
    return true;
});
/**
Replace all instances of the search query with the given
replacement.
*/ const $976a3faeb93466fd$export$b8b3234b4edfc4c2 = /*@__PURE__*/ $976a3faeb93466fd$var$searchCommand((view, { query: query })=>{
    if (view.state.readOnly) return false;
    let changes = [];
    for (let match of query.matchAll(view.state, 1e9)){
        let { from: from, to: to, precise: precise } = match;
        if (precise) changes.push({
            from: from,
            to: to,
            insert: query.getReplacement(match)
        });
    }
    if (!changes.length) return false;
    let announceText = view.state.phrase("replaced $ matches", changes.length) + ".";
    view.dispatch({
        changes: changes,
        effects: (0, $7beee9608540d2c3$export$eece2fccabbb77c5).announce.of(announceText),
        userEvent: "input.replace.all"
    });
    return true;
});
function $976a3faeb93466fd$var$createSearchPanel(view) {
    return view.state.facet($976a3faeb93466fd$var$searchConfigFacet).createPanel(view);
}
function $976a3faeb93466fd$var$defaultQuery(state, fallback) {
    var _a, _b, _c, _d, _e;
    let sel = state.selection.main;
    let selText = sel.empty || sel.to > sel.from + 100 ? "" : state.sliceDoc(sel.from, sel.to);
    if (fallback && !selText) return fallback;
    let config = state.facet($976a3faeb93466fd$var$searchConfigFacet);
    return new $976a3faeb93466fd$export$4bc63ef50ec3954e({
        search: ((_a = fallback === null || fallback === void 0 ? void 0 : fallback.literal) !== null && _a !== void 0 ? _a : config.literal) ? selText : selText.replace(/\n/g, "\\n"),
        caseSensitive: (_b = fallback === null || fallback === void 0 ? void 0 : fallback.caseSensitive) !== null && _b !== void 0 ? _b : config.caseSensitive,
        literal: (_c = fallback === null || fallback === void 0 ? void 0 : fallback.literal) !== null && _c !== void 0 ? _c : config.literal,
        regexp: (_d = fallback === null || fallback === void 0 ? void 0 : fallback.regexp) !== null && _d !== void 0 ? _d : config.regexp,
        wholeWord: (_e = fallback === null || fallback === void 0 ? void 0 : fallback.wholeWord) !== null && _e !== void 0 ? _e : config.wholeWord
    });
}
function $976a3faeb93466fd$var$getSearchInput(view) {
    let panel = (0, $7beee9608540d2c3$export$7361ed18ff57179e)(view, $976a3faeb93466fd$var$createSearchPanel);
    return panel && panel.dom.querySelector("[main-field]");
}
function $976a3faeb93466fd$var$selectSearchInput(view) {
    let input = $976a3faeb93466fd$var$getSearchInput(view);
    if (input && input == view.root.activeElement) input.select();
}
/**
Make sure the search panel is open and focused.
*/ const $976a3faeb93466fd$export$8894af164d40b422 = (view)=>{
    let state = view.state.field($976a3faeb93466fd$var$searchState, false);
    if (state && state.panel) {
        let searchInput = $976a3faeb93466fd$var$getSearchInput(view);
        if (searchInput && searchInput != view.root.activeElement) {
            let query = $976a3faeb93466fd$var$defaultQuery(view.state, state.query.spec);
            if (query.valid) view.dispatch({
                effects: $976a3faeb93466fd$export$2cd1e14773f5e71b.of(query)
            });
            searchInput.focus();
            searchInput.select();
        }
    } else view.dispatch({
        effects: [
            $976a3faeb93466fd$var$togglePanel.of(true),
            state ? $976a3faeb93466fd$export$2cd1e14773f5e71b.of($976a3faeb93466fd$var$defaultQuery(view.state, state.query.spec)) : (0, $6295c6875f57e3ee$export$95000d4efaa4321f).appendConfig.of($976a3faeb93466fd$var$searchExtensions)
        ]
    });
    return true;
};
/**
Close the search panel.
*/ const $976a3faeb93466fd$export$4c389f3929badbb8 = (view)=>{
    let state = view.state.field($976a3faeb93466fd$var$searchState, false);
    if (!state || !state.panel) return false;
    let panel = (0, $7beee9608540d2c3$export$7361ed18ff57179e)(view, $976a3faeb93466fd$var$createSearchPanel);
    if (panel && panel.dom.contains(view.root.activeElement)) view.focus();
    view.dispatch({
        effects: $976a3faeb93466fd$var$togglePanel.of(false)
    });
    return true;
};
/**
Default search-related key bindings.

 - Mod-f: [`openSearchPanel`](https://codemirror.net/6/docs/ref/#search.openSearchPanel)
 - F3, Mod-g: [`findNext`](https://codemirror.net/6/docs/ref/#search.findNext)
 - Shift-F3, Shift-Mod-g: [`findPrevious`](https://codemirror.net/6/docs/ref/#search.findPrevious)
 - Mod-Alt-g: [`gotoLine`](https://codemirror.net/6/docs/ref/#search.gotoLine)
 - Mod-d: [`selectNextOccurrence`](https://codemirror.net/6/docs/ref/#search.selectNextOccurrence)
*/ const $976a3faeb93466fd$export$2dba96787cbe0a4a = [
    {
        key: "Mod-f",
        run: $976a3faeb93466fd$export$8894af164d40b422,
        scope: "editor search-panel"
    },
    {
        key: "F3",
        run: $976a3faeb93466fd$export$ebdf538520f8717,
        shift: $976a3faeb93466fd$export$eef4841c27f82c55,
        scope: "editor search-panel",
        preventDefault: true
    },
    {
        key: "Mod-g",
        run: $976a3faeb93466fd$export$ebdf538520f8717,
        shift: $976a3faeb93466fd$export$eef4841c27f82c55,
        scope: "editor search-panel",
        preventDefault: true
    },
    {
        key: "Escape",
        run: $976a3faeb93466fd$export$4c389f3929badbb8,
        scope: "editor search-panel"
    },
    {
        key: "Mod-Shift-l",
        run: $976a3faeb93466fd$export$6f1c98d8556667b5
    },
    {
        key: "Mod-Alt-g",
        run: $976a3faeb93466fd$export$5d5b784f9a618ec3
    },
    {
        key: "Mod-d",
        run: $976a3faeb93466fd$export$dd0e64cebe05ee17,
        preventDefault: true
    }
];
class $976a3faeb93466fd$var$SearchPanel {
    constructor(view){
        this.view = view;
        let query = this.query = view.state.field($976a3faeb93466fd$var$searchState).query.spec;
        this.commit = this.commit.bind(this);
        this.searchField = (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("input", {
            value: query.search,
            placeholder: $976a3faeb93466fd$var$phrase(view, "Find"),
            "aria-label": $976a3faeb93466fd$var$phrase(view, "Find"),
            class: "cm-textfield",
            name: "search",
            form: "",
            "main-field": "true",
            onchange: this.commit,
            onkeyup: this.commit
        });
        this.replaceField = (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("input", {
            value: query.replace,
            placeholder: $976a3faeb93466fd$var$phrase(view, "Replace"),
            "aria-label": $976a3faeb93466fd$var$phrase(view, "Replace"),
            class: "cm-textfield",
            name: "replace",
            form: "",
            onchange: this.commit,
            onkeyup: this.commit
        });
        this.caseField = (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("input", {
            type: "checkbox",
            name: "case",
            form: "",
            checked: query.caseSensitive,
            onchange: this.commit
        });
        this.reField = (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("input", {
            type: "checkbox",
            name: "re",
            form: "",
            checked: query.regexp,
            onchange: this.commit
        });
        this.wordField = (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("input", {
            type: "checkbox",
            name: "word",
            form: "",
            checked: query.wholeWord,
            onchange: this.commit
        });
        function button(name, onclick, content) {
            return (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("button", {
                class: "cm-button",
                name: name,
                onclick: onclick,
                type: "button"
            }, content);
        }
        this.dom = (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("div", {
            onkeydown: (e)=>this.keydown(e),
            class: "cm-search"
        }, [
            this.searchField,
            button("next", ()=>$976a3faeb93466fd$export$ebdf538520f8717(view), [
                $976a3faeb93466fd$var$phrase(view, "next")
            ]),
            button("prev", ()=>$976a3faeb93466fd$export$eef4841c27f82c55(view), [
                $976a3faeb93466fd$var$phrase(view, "previous")
            ]),
            button("select", ()=>$976a3faeb93466fd$export$5d21cfc86ff1ce1d(view), [
                $976a3faeb93466fd$var$phrase(view, "all")
            ]),
            (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("label", null, [
                this.caseField,
                $976a3faeb93466fd$var$phrase(view, "match case")
            ]),
            (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("label", null, [
                this.reField,
                $976a3faeb93466fd$var$phrase(view, "regexp")
            ]),
            (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("label", null, [
                this.wordField,
                $976a3faeb93466fd$var$phrase(view, "by word")
            ]),
            ...view.state.readOnly ? [] : [
                (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("br"),
                this.replaceField,
                button("replace", ()=>$976a3faeb93466fd$export$f9afe47535eaf3d2(view), [
                    $976a3faeb93466fd$var$phrase(view, "replace")
                ]),
                button("replaceAll", ()=>$976a3faeb93466fd$export$b8b3234b4edfc4c2(view), [
                    $976a3faeb93466fd$var$phrase(view, "replace all")
                ])
            ],
            (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("button", {
                name: "close",
                onclick: ()=>$976a3faeb93466fd$export$4c389f3929badbb8(view),
                "aria-label": $976a3faeb93466fd$var$phrase(view, "close"),
                type: "button"
            }, [
                "\xd7"
            ])
        ]);
    }
    commit() {
        let query = new $976a3faeb93466fd$export$4bc63ef50ec3954e({
            search: this.searchField.value,
            caseSensitive: this.caseField.checked,
            regexp: this.reField.checked,
            wholeWord: this.wordField.checked,
            replace: this.replaceField.value
        });
        if (!query.eq(this.query)) {
            this.query = query;
            this.view.dispatch({
                effects: $976a3faeb93466fd$export$2cd1e14773f5e71b.of(query)
            });
        }
    }
    keydown(e) {
        if ((0, $7beee9608540d2c3$export$bce154f45536286e)(this.view, e, "search-panel")) e.preventDefault();
        else if (e.keyCode == 13 && e.target == this.searchField) {
            e.preventDefault();
            (e.shiftKey ? $976a3faeb93466fd$export$eef4841c27f82c55 : $976a3faeb93466fd$export$ebdf538520f8717)(this.view);
        } else if (e.keyCode == 13 && e.target == this.replaceField) {
            e.preventDefault();
            $976a3faeb93466fd$export$f9afe47535eaf3d2(this.view);
        }
    }
    update(update) {
        for (let tr of update.transactions)for (let effect of tr.effects)if (effect.is($976a3faeb93466fd$export$2cd1e14773f5e71b) && !effect.value.eq(this.query)) this.setQuery(effect.value);
    }
    setQuery(query) {
        this.query = query;
        this.searchField.value = query.search;
        this.replaceField.value = query.replace;
        this.caseField.checked = query.caseSensitive;
        this.reField.checked = query.regexp;
        this.wordField.checked = query.wholeWord;
    }
    mount() {
        this.searchField.select();
    }
    get pos() {
        return 80;
    }
    get top() {
        return this.view.state.facet($976a3faeb93466fd$var$searchConfigFacet).top;
    }
}
function $976a3faeb93466fd$var$phrase(view, phrase) {
    return view.state.phrase(phrase);
}
const $976a3faeb93466fd$var$AnnounceMargin = 30;
const $976a3faeb93466fd$var$Break = /[\s\.,:;?!]/;
function $976a3faeb93466fd$var$announceMatch(view, { from: from, to: to }) {
    let line = view.state.doc.lineAt(from), lineEnd = view.state.doc.lineAt(to).to;
    let start = Math.max(line.from, from - $976a3faeb93466fd$var$AnnounceMargin), end = Math.min(lineEnd, to + $976a3faeb93466fd$var$AnnounceMargin);
    let text = view.state.sliceDoc(start, end);
    if (start != line.from) {
        for(let i = 0; i < $976a3faeb93466fd$var$AnnounceMargin; i++)if (!$976a3faeb93466fd$var$Break.test(text[i + 1]) && $976a3faeb93466fd$var$Break.test(text[i])) {
            text = text.slice(i);
            break;
        }
    }
    if (end != lineEnd) {
        for(let i = text.length - 1; i > text.length - $976a3faeb93466fd$var$AnnounceMargin; i--)if (!$976a3faeb93466fd$var$Break.test(text[i - 1]) && $976a3faeb93466fd$var$Break.test(text[i])) {
            text = text.slice(0, i);
            break;
        }
    }
    return (0, $7beee9608540d2c3$export$eece2fccabbb77c5).announce.of(`${view.state.phrase("current match")}. ${text} ${view.state.phrase("on line")} ${line.number}.`);
}
const $976a3faeb93466fd$var$baseTheme = /*@__PURE__*/ (0, $7beee9608540d2c3$export$eece2fccabbb77c5).baseTheme({
    ".cm-panel.cm-search": {
        padding: "2px 6px 4px",
        position: "relative",
        "& [name=close]": {
            position: "absolute",
            top: "0",
            right: "4px",
            backgroundColor: "inherit",
            border: "none",
            font: "inherit",
            padding: 0,
            margin: 0
        },
        "& input, & button, & label": {
            margin: ".2em .6em .2em 0"
        },
        "& input[type=checkbox]": {
            marginRight: ".2em"
        },
        "& label": {
            fontSize: "80%",
            whiteSpace: "pre"
        }
    },
    "&light .cm-searchMatch": {
        backgroundColor: "#ffff0054"
    },
    "&dark .cm-searchMatch": {
        backgroundColor: "#00ffff8a"
    },
    "&light .cm-searchMatch-selected": {
        backgroundColor: "#ff6a0054"
    },
    "&dark .cm-searchMatch-selected": {
        backgroundColor: "#ff00ff8a"
    }
});
const $976a3faeb93466fd$var$searchExtensions = [
    $976a3faeb93466fd$var$searchState,
    /*@__PURE__*/ (0, $6295c6875f57e3ee$export$b92464a736444411).low($976a3faeb93466fd$var$searchHighlighter),
    $976a3faeb93466fd$var$baseTheme
];





/**
An instance of this is passed to completion source functions.
*/ class $7570a9a1a9679713$export$7b73e80391102dce {
    /**
    Create a new completion context. (Mostly useful for testing
    completion sources—in the editor, the extension will create
    these for you.)
    */ constructor(/**
    The editor state that the completion happens in.
    */ state, /**
    The position at which the completion is happening.
    */ pos, /**
    Indicates whether completion was activated explicitly, or
    implicitly by typing. The usual way to respond to this is to
    only return completions when either there is part of a
    completable entity before the cursor, or `explicit` is true.
    */ explicit, /**
    The editor view. May be undefined if the context was created
    in a situation where there is no such view available, such as
    in synchronous updates via
    [`CompletionResult.update`](https://codemirror.net/6/docs/ref/#autocomplete.CompletionResult.update)
    or when called by test code.
    */ view){
        this.state = state;
        this.pos = pos;
        this.explicit = explicit;
        this.view = view;
        /**
        @internal
        */ this.abortListeners = [];
        /**
        @internal
        */ this.abortOnDocChange = false;
    }
    /**
    Get the extent, content, and (if there is a token) type of the
    token before `this.pos`.
    */ tokenBefore(types) {
        let token = (0, $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1)(this.state).resolveInner(this.pos, -1);
        while(token && types.indexOf(token.name) < 0)token = token.parent;
        return token ? {
            from: token.from,
            to: this.pos,
            text: this.state.sliceDoc(token.from, this.pos),
            type: token.type
        } : null;
    }
    /**
    Get the match of the given expression directly before the
    cursor.
    */ matchBefore(expr) {
        let line = this.state.doc.lineAt(this.pos);
        let start = Math.max(line.from, this.pos - 250);
        let str = line.text.slice(start - line.from, this.pos - line.from);
        let found = str.search($7570a9a1a9679713$var$ensureAnchor(expr, false));
        return found < 0 ? null : {
            from: start + found,
            to: this.pos,
            text: str.slice(found)
        };
    }
    /**
    Yields true when the query has been aborted. Can be useful in
    asynchronous queries to avoid doing work that will be ignored.
    */ get aborted() {
        return this.abortListeners == null;
    }
    /**
    Allows you to register abort handlers, which will be called when
    the query is
    [aborted](https://codemirror.net/6/docs/ref/#autocomplete.CompletionContext.aborted).
    
    By default, running queries will not be aborted for regular
    typing or backspacing, on the assumption that they are likely to
    return a result with a
    [`validFor`](https://codemirror.net/6/docs/ref/#autocomplete.CompletionResult.validFor) field that
    allows the result to be used after all. Passing `onDocChange:
    true` will cause this query to be aborted for any document
    change.
    */ addEventListener(type, listener, options) {
        if (type == "abort" && this.abortListeners) {
            this.abortListeners.push(listener);
            if (options && options.onDocChange) this.abortOnDocChange = true;
        }
    }
}
function $7570a9a1a9679713$var$toSet(chars) {
    let flat = Object.keys(chars).join("");
    let words = /\w/.test(flat);
    if (words) flat = flat.replace(/\w/g, "");
    return `[${words ? "\\w" : ""}${flat.replace(/[^\w\s]/g, "\\$&")}]`;
}
function $7570a9a1a9679713$var$prefixMatch(options) {
    let first = Object.create(null), rest = Object.create(null);
    for (let { label: label } of options){
        first[label[0]] = true;
        for(let i = 1; i < label.length; i++)rest[label[i]] = true;
    }
    let source = $7570a9a1a9679713$var$toSet(first) + $7570a9a1a9679713$var$toSet(rest) + "*$";
    return [
        new RegExp("^" + source),
        new RegExp(source)
    ];
}
/**
Given a a fixed array of options, return an autocompleter that
completes them.
*/ function $7570a9a1a9679713$export$db0ee7d2648a0c4b(list) {
    let options = list.map((o)=>typeof o == "string" ? {
            label: o
        } : o);
    let [validFor, match] = options.every((o)=>/^\w+$/.test(o.label)) ? [
        /\w*$/,
        /\w+$/
    ] : $7570a9a1a9679713$var$prefixMatch(options);
    return (context)=>{
        let token = context.matchBefore(match);
        return token || context.explicit ? {
            from: token ? token.from : context.pos,
            options: options,
            validFor: validFor
        } : null;
    };
}
/**
Wrap the given completion source so that it will only fire when the
cursor is in a syntax node with one of the given names.
*/ function $7570a9a1a9679713$export$498fe7f50ed891b8(nodes, source) {
    return (context)=>{
        for(let pos = (0, $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1)(context.state).resolveInner(context.pos, -1); pos; pos = pos.parent){
            if (nodes.indexOf(pos.name) > -1) return source(context);
            if (pos.type.isTop) break;
        }
        return null;
    };
}
/**
Wrap the given completion source so that it will not fire when the
cursor is in a syntax node with one of the given names.
*/ function $7570a9a1a9679713$export$1dfdaeb1e91714c0(nodes, source) {
    return (context)=>{
        for(let pos = (0, $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1)(context.state).resolveInner(context.pos, -1); pos; pos = pos.parent){
            if (nodes.indexOf(pos.name) > -1) return null;
            if (pos.type.isTop) break;
        }
        return source(context);
    };
}
class $7570a9a1a9679713$var$Option {
    constructor(completion, source, match, score){
        this.completion = completion;
        this.source = source;
        this.match = match;
        this.score = score;
    }
}
function $7570a9a1a9679713$var$cur(state) {
    return state.selection.main.from;
}
// Make sure the given regexp has a $ at its end and, if `start` is
// true, a ^ at its start.
function $7570a9a1a9679713$var$ensureAnchor(expr, start) {
    var _a;
    let { source: source } = expr;
    let addStart = start && source[0] != "^", addEnd = source[source.length - 1] != "$";
    if (!addStart && !addEnd) return expr;
    return new RegExp(`${addStart ? "^" : ""}(?:${source})${addEnd ? "$" : ""}`, (_a = expr.flags) !== null && _a !== void 0 ? _a : expr.ignoreCase ? "i" : "");
}
/**
This annotation is added to transactions that are produced by
picking a completion.
*/ const $7570a9a1a9679713$export$6c84d44c1ceeb831 = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$9279461326b8700a).define();
/**
Helper function that returns a transaction spec which inserts a
completion's text in the main selection range, and any other
selection range that has the same text in front of it.
*/ function $7570a9a1a9679713$export$496ff43229d73eba(state, text, from, to) {
    let { main: main } = state.selection, fromOff = from - main.from, toOff = to - main.from;
    return {
        ...state.changeByRange((range)=>{
            if (range != main && from != to && state.sliceDoc(range.from + fromOff, range.from + toOff) != state.sliceDoc(from, to)) return {
                range: range
            };
            let lines = state.toText(text);
            return {
                changes: {
                    from: range.from + fromOff,
                    to: to == main.from ? range.to : range.from + toOff,
                    insert: lines
                },
                range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(range.from + fromOff + lines.length)
            };
        }),
        scrollIntoView: true,
        userEvent: "input.complete"
    };
}
const $7570a9a1a9679713$var$SourceCache = /*@__PURE__*/ new WeakMap();
function $7570a9a1a9679713$var$asSource(source) {
    if (!Array.isArray(source)) return source;
    let known = $7570a9a1a9679713$var$SourceCache.get(source);
    if (!known) $7570a9a1a9679713$var$SourceCache.set(source, known = $7570a9a1a9679713$export$db0ee7d2648a0c4b(source));
    return known;
}
const $7570a9a1a9679713$var$startCompletionEffect = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
const $7570a9a1a9679713$var$closeCompletionEffect = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
// A pattern matcher for fuzzy completion matching. Create an instance
// once for a pattern, and then use that to match any number of
// completions.
class $7570a9a1a9679713$var$FuzzyMatcher {
    constructor(pattern){
        this.pattern = pattern;
        this.chars = [];
        this.folded = [];
        // Buffers reused by calls to `match` to track matched character
        // positions.
        this.any = [];
        this.precise = [];
        this.byWord = [];
        this.score = 0;
        this.matched = [];
        for(let p = 0; p < pattern.length;){
            let char = (0, $6295c6875f57e3ee$export$42977f40461e1360)(pattern, p), size = (0, $6295c6875f57e3ee$export$a870abf234f6353c)(char);
            this.chars.push(char);
            let part = pattern.slice(p, p + size), upper = part.toUpperCase();
            this.folded.push((0, $6295c6875f57e3ee$export$42977f40461e1360)(upper == part ? part.toLowerCase() : upper, 0));
            p += size;
        }
        this.astral = pattern.length != this.chars.length;
    }
    ret(score, matched) {
        this.score = score;
        this.matched = matched;
        return this;
    }
    // Matches a given word (completion) against the pattern (input).
    // Will return a boolean indicating whether there was a match and,
    // on success, set `this.score` to the score, `this.matched` to an
    // array of `from, to` pairs indicating the matched parts of `word`.
    //
    // The score is a number that is more negative the worse the match
    // is. See `Penalty` above.
    match(word) {
        if (this.pattern.length == 0) return this.ret(-100 /* Penalty.NotFull */ , []);
        if (word.length < this.pattern.length) return null;
        let { chars: chars, folded: folded, any: any, precise: precise, byWord: byWord } = this;
        // For single-character queries, only match when they occur right
        // at the start
        if (chars.length == 1) {
            let first = (0, $6295c6875f57e3ee$export$42977f40461e1360)(word, 0), firstSize = (0, $6295c6875f57e3ee$export$a870abf234f6353c)(first);
            let score = firstSize == word.length ? 0 : -100 /* Penalty.NotFull */ ;
            if (first == chars[0]) ;
            else if (first == folded[0]) score += -200 /* Penalty.CaseFold */ ;
            else return null;
            return this.ret(score, [
                0,
                firstSize
            ]);
        }
        let direct = word.indexOf(this.pattern);
        if (direct == 0) return this.ret(word.length == this.pattern.length ? 0 : -100 /* Penalty.NotFull */ , [
            0,
            this.pattern.length
        ]);
        let len = chars.length, anyTo = 0;
        if (direct < 0) {
            for(let i = 0, e = Math.min(word.length, 200); i < e && anyTo < len;){
                let next = (0, $6295c6875f57e3ee$export$42977f40461e1360)(word, i);
                if (next == chars[anyTo] || next == folded[anyTo]) any[anyTo++] = i;
                i += (0, $6295c6875f57e3ee$export$a870abf234f6353c)(next);
            }
            // No match, exit immediately
            if (anyTo < len) return null;
        }
        // This tracks the extent of the precise (non-folded, not
        // necessarily adjacent) match
        let preciseTo = 0;
        // Tracks whether there is a match that hits only characters that
        // appear to be starting words. `byWordFolded` is set to true when
        // a case folded character is encountered in such a match
        let byWordTo = 0, byWordFolded = false;
        // If we've found a partial adjacent match, these track its state
        let adjacentTo = 0, adjacentStart = -1, adjacentEnd = -1;
        let hasLower = /[a-z]/.test(word), wordAdjacent = true;
        // Go over the option's text, scanning for the various kinds of matches
        for(let i = 0, e = Math.min(word.length, 200), prevType = 0 /* Tp.NonWord */ ; i < e && byWordTo < len;){
            let next = (0, $6295c6875f57e3ee$export$42977f40461e1360)(word, i);
            if (direct < 0) {
                if (preciseTo < len && next == chars[preciseTo]) precise[preciseTo++] = i;
                if (adjacentTo < len) {
                    if (next == chars[adjacentTo] || next == folded[adjacentTo]) {
                        if (adjacentTo == 0) adjacentStart = i;
                        adjacentEnd = i + 1;
                        adjacentTo++;
                    } else adjacentTo = 0;
                }
            }
            let ch, type = next < 0xff ? next >= 48 && next <= 57 || next >= 97 && next <= 122 ? 2 /* Tp.Lower */  : next >= 65 && next <= 90 ? 1 /* Tp.Upper */  : 0 /* Tp.NonWord */  : (ch = (0, $6295c6875f57e3ee$export$73bfc63873071f74)(next)) != ch.toLowerCase() ? 1 /* Tp.Upper */  : ch != ch.toUpperCase() ? 2 /* Tp.Lower */  : 0 /* Tp.NonWord */ ;
            if (!i || type == 1 /* Tp.Upper */  && hasLower || prevType == 0 /* Tp.NonWord */  && type != 0 /* Tp.NonWord */ ) {
                if (chars[byWordTo] == next || folded[byWordTo] == next && (byWordFolded = true)) byWord[byWordTo++] = i;
                else if (byWord.length) wordAdjacent = false;
            }
            prevType = type;
            i += (0, $6295c6875f57e3ee$export$a870abf234f6353c)(next);
        }
        if (byWordTo == len && byWord[0] == 0 && wordAdjacent) return this.result(-100 /* Penalty.ByWord */  + (byWordFolded ? -200 /* Penalty.CaseFold */  : 0), byWord, word);
        if (adjacentTo == len && adjacentStart == 0) return this.ret(-200 /* Penalty.CaseFold */  - word.length + (adjacentEnd == word.length ? 0 : -100 /* Penalty.NotFull */ ), [
            0,
            adjacentEnd
        ]);
        if (direct > -1) return this.ret(-700 /* Penalty.NotStart */  - word.length, [
            direct,
            direct + this.pattern.length
        ]);
        if (adjacentTo == len) return this.ret(-900 /* Penalty.NotStart */  - word.length, [
            adjacentStart,
            adjacentEnd
        ]);
        if (byWordTo == len) return this.result(-100 /* Penalty.ByWord */  + (byWordFolded ? -200 /* Penalty.CaseFold */  : 0) + -700 /* Penalty.NotStart */  + (wordAdjacent ? 0 : -1100 /* Penalty.Gap */ ), byWord, word);
        return chars.length == 2 ? null : this.result((any[0] ? -700 /* Penalty.NotStart */  : 0) + -200 /* Penalty.CaseFold */  + -1100 /* Penalty.Gap */ , any, word);
    }
    result(score, positions, word) {
        let result = [], i = 0;
        for (let pos of positions){
            let to = pos + (this.astral ? (0, $6295c6875f57e3ee$export$a870abf234f6353c)((0, $6295c6875f57e3ee$export$42977f40461e1360)(word, pos)) : 1);
            if (i && result[i - 1] == pos) result[i - 1] = to;
            else {
                result[i++] = pos;
                result[i++] = to;
            }
        }
        return this.ret(score - word.length, result);
    }
}
class $7570a9a1a9679713$var$StrictMatcher {
    constructor(pattern){
        this.pattern = pattern;
        this.matched = [];
        this.score = 0;
        this.folded = pattern.toLowerCase();
    }
    match(word) {
        if (word.length < this.pattern.length) return null;
        let start = word.slice(0, this.pattern.length);
        let match = start == this.pattern ? 0 : start.toLowerCase() == this.folded ? -200 /* Penalty.CaseFold */  : null;
        if (match == null) return null;
        this.matched = [
            0,
            start.length
        ];
        this.score = match + (word.length == this.pattern.length ? 0 : -100 /* Penalty.NotFull */ );
        return this;
    }
}
const $7570a9a1a9679713$var$completionConfig = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        return (0, $6295c6875f57e3ee$export$4e19c0b693794a7e)(configs, {
            activateOnTyping: true,
            activateOnCompletion: ()=>false,
            activateOnTypingDelay: 100,
            selectOnOpen: true,
            override: null,
            closeOnBlur: true,
            maxRenderedOptions: 100,
            defaultKeymap: true,
            tooltipClass: ()=>"",
            optionClass: ()=>"",
            aboveCursor: false,
            icons: true,
            addToOptions: [],
            positionInfo: $7570a9a1a9679713$var$defaultPositionInfo,
            filterStrict: false,
            compareCompletions: (a, b)=>(a.sortText || a.label).localeCompare(b.sortText || b.label),
            interactionDelay: 75,
            updateSyncTime: 100
        }, {
            defaultKeymap: (a, b)=>a && b,
            closeOnBlur: (a, b)=>a && b,
            icons: (a, b)=>a && b,
            tooltipClass: (a, b)=>(c)=>$7570a9a1a9679713$var$joinClass(a(c), b(c)),
            optionClass: (a, b)=>(c)=>$7570a9a1a9679713$var$joinClass(a(c), b(c)),
            addToOptions: (a, b)=>a.concat(b),
            filterStrict: (a, b)=>a || b
        });
    }
});
function $7570a9a1a9679713$var$joinClass(a, b) {
    return a ? b ? a + " " + b : a : b;
}
function $7570a9a1a9679713$var$defaultPositionInfo(view, list, option, info, space, tooltip) {
    let rtl = view.textDirection == (0, $7beee9608540d2c3$export$cacd6541cfeeb6c1).RTL, left = rtl, narrow = false;
    let side = "top", offset, maxWidth;
    let spaceLeft = list.left - space.left, spaceRight = space.right - list.right;
    let infoWidth = info.right - info.left, infoHeight = info.bottom - info.top;
    if (left && spaceLeft < Math.min(infoWidth, spaceRight)) left = false;
    else if (!left && spaceRight < Math.min(infoWidth, spaceLeft)) left = true;
    if (infoWidth <= (left ? spaceLeft : spaceRight)) {
        offset = Math.max(space.top, Math.min(option.top, space.bottom - infoHeight)) - list.top;
        maxWidth = Math.min(400 /* Info.Width */ , left ? spaceLeft : spaceRight);
    } else {
        narrow = true;
        maxWidth = Math.min(400 /* Info.Width */ , (rtl ? list.right : space.right - list.left) - 30 /* Info.Margin */ );
        let spaceBelow = space.bottom - list.bottom;
        if (spaceBelow >= infoHeight || spaceBelow > list.top) offset = option.bottom - list.top;
        else {
            side = "bottom";
            offset = list.bottom - option.top;
        }
    }
    let scaleY = (list.bottom - list.top) / tooltip.offsetHeight;
    let scaleX = (list.right - list.left) / tooltip.offsetWidth;
    return {
        style: `${side}: ${offset / scaleY}px; max-width: ${maxWidth / scaleX}px`,
        class: "cm-completionInfo-" + (narrow ? rtl ? "left-narrow" : "right-narrow" : left ? "left" : "right")
    };
}
const $7570a9a1a9679713$var$setSelectedEffect = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
function $7570a9a1a9679713$var$optionContent(config) {
    let content = config.addToOptions.slice();
    if (config.icons) content.push({
        render (completion) {
            let icon = document.createElement("div");
            icon.classList.add("cm-completionIcon");
            if (completion.type) icon.classList.add(...completion.type.split(/\s+/g).map((cls)=>"cm-completionIcon-" + cls));
            icon.setAttribute("aria-hidden", "true");
            return icon;
        },
        position: 20
    });
    content.push({
        render (completion, _s, _v, match) {
            let labelElt = document.createElement("span");
            labelElt.className = "cm-completionLabel";
            let label = completion.displayLabel || completion.label, off = 0;
            for(let j = 0; j < match.length;){
                let from = match[j++], to = match[j++];
                if (from > off) labelElt.appendChild(document.createTextNode(label.slice(off, from)));
                let span = labelElt.appendChild(document.createElement("span"));
                span.appendChild(document.createTextNode(label.slice(from, to)));
                span.className = "cm-completionMatchedText";
                off = to;
            }
            if (off < label.length) labelElt.appendChild(document.createTextNode(label.slice(off)));
            return labelElt;
        },
        position: 50
    }, {
        render (completion) {
            if (!completion.detail) return null;
            let detailElt = document.createElement("span");
            detailElt.className = "cm-completionDetail";
            detailElt.textContent = completion.detail;
            return detailElt;
        },
        position: 80
    });
    return content.sort((a, b)=>a.position - b.position).map((a)=>a.render);
}
function $7570a9a1a9679713$var$rangeAroundSelected(total, selected, max) {
    if (total <= max) return {
        from: 0,
        to: total
    };
    if (selected < 0) selected = 0;
    if (selected <= total >> 1) {
        let off = Math.floor(selected / max);
        return {
            from: off * max,
            to: (off + 1) * max
        };
    }
    let off = Math.ceil((total - selected) / max);
    return {
        from: total - off * max,
        to: total - (off - 1) * max
    };
}
class $7570a9a1a9679713$var$CompletionTooltip {
    constructor(view, stateField, applyCompletion){
        this.view = view;
        this.stateField = stateField;
        this.applyCompletion = applyCompletion;
        this.info = null;
        this.infoDestroy = null;
        this.placeInfoReq = {
            read: ()=>this.measureInfo(),
            write: (pos)=>this.placeInfo(pos),
            key: this
        };
        this.space = null;
        this.currentClass = "";
        let cState = view.state.field(stateField);
        let { options: options, selected: selected } = cState.open;
        let config = view.state.facet($7570a9a1a9679713$var$completionConfig);
        this.optionContent = $7570a9a1a9679713$var$optionContent(config);
        this.optionClass = config.optionClass;
        this.tooltipClass = config.tooltipClass;
        this.range = $7570a9a1a9679713$var$rangeAroundSelected(options.length, selected, config.maxRenderedOptions);
        this.dom = document.createElement("div");
        this.dom.className = "cm-tooltip-autocomplete";
        this.updateTooltipClass(view.state);
        this.dom.addEventListener("mousedown", (e)=>{
            let { options: options } = view.state.field(stateField).open;
            for(let dom = e.target, match; dom && dom != this.dom; dom = dom.parentNode)if (dom.nodeName == "LI" && (match = /-(\d+)$/.exec(dom.id)) && +match[1] < options.length) {
                this.applyCompletion(view, options[+match[1]]);
                e.preventDefault();
                return;
            }
            if (e.target == this.list) {
                let move = this.list.classList.contains("cm-completionListIncompleteTop") && e.clientY < this.list.firstChild.getBoundingClientRect().top ? this.range.from - 1 : this.list.classList.contains("cm-completionListIncompleteBottom") && e.clientY > this.list.lastChild.getBoundingClientRect().bottom ? this.range.to : null;
                if (move != null) {
                    view.dispatch({
                        effects: $7570a9a1a9679713$var$setSelectedEffect.of(move)
                    });
                    e.preventDefault();
                }
            }
        });
        this.dom.addEventListener("focusout", (e)=>{
            let state = view.state.field(this.stateField, false);
            if (state && state.tooltip && view.state.facet($7570a9a1a9679713$var$completionConfig).closeOnBlur && e.relatedTarget != view.contentDOM) view.dispatch({
                effects: $7570a9a1a9679713$var$closeCompletionEffect.of(null)
            });
        });
        this.showOptions(options, cState.id);
    }
    mount() {
        this.updateSel();
    }
    showOptions(options, id) {
        if (this.list) this.list.remove();
        this.list = this.dom.appendChild(this.createListBox(options, id, this.range));
        this.list.addEventListener("scroll", ()=>{
            if (this.info) this.view.requestMeasure(this.placeInfoReq);
        });
    }
    update(update) {
        var _a;
        let cState = update.state.field(this.stateField);
        let prevState = update.startState.field(this.stateField);
        this.updateTooltipClass(update.state);
        if (cState != prevState) {
            let { options: options, selected: selected, disabled: disabled } = cState.open;
            if (!prevState.open || prevState.open.options != options) {
                this.range = $7570a9a1a9679713$var$rangeAroundSelected(options.length, selected, update.state.facet($7570a9a1a9679713$var$completionConfig).maxRenderedOptions);
                this.showOptions(options, cState.id);
            }
            this.updateSel();
            if (disabled != ((_a = prevState.open) === null || _a === void 0 ? void 0 : _a.disabled)) this.dom.classList.toggle("cm-tooltip-autocomplete-disabled", !!disabled);
        }
    }
    updateTooltipClass(state) {
        let cls = this.tooltipClass(state);
        if (cls != this.currentClass) {
            for (let c of this.currentClass.split(" "))if (c) this.dom.classList.remove(c);
            for (let c of cls.split(" "))if (c) this.dom.classList.add(c);
            this.currentClass = cls;
        }
    }
    positioned(space) {
        this.space = space;
        if (this.info) this.view.requestMeasure(this.placeInfoReq);
    }
    updateSel() {
        let cState = this.view.state.field(this.stateField), open = cState.open;
        if (open.selected > -1 && open.selected < this.range.from || open.selected >= this.range.to) {
            this.range = $7570a9a1a9679713$var$rangeAroundSelected(open.options.length, open.selected, this.view.state.facet($7570a9a1a9679713$var$completionConfig).maxRenderedOptions);
            this.showOptions(open.options, cState.id);
        }
        let newSel = this.updateSelectedOption(open.selected);
        if (newSel) {
            this.destroyInfo();
            let { completion: completion } = open.options[open.selected];
            let { info: info } = completion;
            if (!info) return;
            let infoResult = typeof info === "string" ? document.createTextNode(info) : info(completion);
            if (!infoResult) return;
            if ("then" in infoResult) infoResult.then((obj)=>{
                if (obj && this.view.state.field(this.stateField, false) == cState) this.addInfoPane(obj, completion);
            }).catch((e)=>(0, $7beee9608540d2c3$export$f86b2a1a2ce291b3)(this.view.state, e, "completion info"));
            else {
                this.addInfoPane(infoResult, completion);
                newSel.setAttribute("aria-describedby", this.info.id);
            }
        }
    }
    addInfoPane(content, completion) {
        this.destroyInfo();
        let wrap = this.info = document.createElement("div");
        wrap.className = "cm-tooltip cm-completionInfo";
        wrap.id = "cm-completionInfo-" + Math.floor(Math.random() * 0xffff).toString(16);
        if (content.nodeType != null) {
            wrap.appendChild(content);
            this.infoDestroy = null;
        } else {
            let { dom: dom, destroy: destroy } = content;
            wrap.appendChild(dom);
            this.infoDestroy = destroy || null;
        }
        this.dom.appendChild(wrap);
        this.view.requestMeasure(this.placeInfoReq);
    }
    updateSelectedOption(selected) {
        let set = null;
        for(let opt = this.list.firstChild, i = this.range.from; opt; opt = opt.nextSibling, i++){
            if (opt.nodeName != "LI" || !opt.id) i--; // A section header
            else if (i == selected) {
                if (!opt.hasAttribute("aria-selected")) {
                    opt.setAttribute("aria-selected", "true");
                    set = opt;
                }
            } else if (opt.hasAttribute("aria-selected")) {
                opt.removeAttribute("aria-selected");
                opt.removeAttribute("aria-describedby");
            }
        }
        if (set) $7570a9a1a9679713$var$scrollIntoView(this.list, set);
        return set;
    }
    measureInfo() {
        let sel = this.dom.querySelector("[aria-selected]");
        if (!sel || !this.info) return null;
        let listRect = this.dom.getBoundingClientRect();
        let infoRect = this.info.getBoundingClientRect();
        let selRect = sel.getBoundingClientRect();
        let space = this.space;
        if (!space) {
            let docElt = this.dom.ownerDocument.documentElement;
            space = {
                left: 0,
                top: 0,
                right: docElt.clientWidth,
                bottom: docElt.clientHeight
            };
        }
        if (selRect.top > Math.min(space.bottom, listRect.bottom) - 10 || selRect.bottom < Math.max(space.top, listRect.top) + 10) return null;
        return this.view.state.facet($7570a9a1a9679713$var$completionConfig).positionInfo(this.view, listRect, selRect, infoRect, space, this.dom);
    }
    placeInfo(pos) {
        if (this.info) {
            if (pos) {
                if (pos.style) this.info.style.cssText = pos.style;
                this.info.className = "cm-tooltip cm-completionInfo " + (pos.class || "");
            } else this.info.style.cssText = "top: -1e6px";
        }
    }
    createListBox(options, id, range) {
        const ul = document.createElement("ul");
        ul.id = id;
        ul.setAttribute("role", "listbox");
        ul.setAttribute("aria-expanded", "true");
        ul.setAttribute("aria-label", this.view.state.phrase("Completions"));
        ul.addEventListener("mousedown", (e)=>{
            // Prevent focus change when clicking the scrollbar
            if (e.target == ul) e.preventDefault();
        });
        let curSection = null;
        for(let i = range.from; i < range.to; i++){
            let { completion: completion, match: match } = options[i], { section: section } = completion;
            if (section) {
                let name = typeof section == "string" ? section : section.name;
                if (name != curSection && (i > range.from || range.from == 0)) {
                    curSection = name;
                    if (typeof section != "string" && section.header) ul.appendChild(section.header(section));
                    else {
                        let header = ul.appendChild(document.createElement("completion-section"));
                        header.textContent = name;
                    }
                }
            }
            const li = ul.appendChild(document.createElement("li"));
            li.id = id + "-" + i;
            li.setAttribute("role", "option");
            let cls = this.optionClass(completion);
            if (cls) li.className = cls;
            for (let source of this.optionContent){
                let node = source(completion, this.view.state, this.view, match);
                if (node) li.appendChild(node);
            }
        }
        if (range.from) ul.classList.add("cm-completionListIncompleteTop");
        if (range.to < options.length) ul.classList.add("cm-completionListIncompleteBottom");
        return ul;
    }
    destroyInfo() {
        if (this.info) {
            if (this.infoDestroy) this.infoDestroy();
            this.info.remove();
            this.info = null;
        }
    }
    destroy() {
        this.destroyInfo();
    }
}
function $7570a9a1a9679713$var$completionTooltip(stateField, applyCompletion) {
    return (view)=>new $7570a9a1a9679713$var$CompletionTooltip(view, stateField, applyCompletion);
}
function $7570a9a1a9679713$var$scrollIntoView(container, element) {
    let parent = container.getBoundingClientRect();
    let self = element.getBoundingClientRect();
    let scaleY = parent.height / container.offsetHeight;
    if (self.top < parent.top) container.scrollTop -= (parent.top - self.top) / scaleY;
    else if (self.bottom > parent.bottom) container.scrollTop += (self.bottom - parent.bottom) / scaleY;
}
// Used to pick a preferred option when two options with the same
// label occur in the result.
function $7570a9a1a9679713$var$score(option) {
    return (option.boost || 0) * 100 + (option.apply ? 10 : 0) + (option.info ? 5 : 0) + (option.type ? 1 : 0);
}
function $7570a9a1a9679713$var$sortOptions(active, state) {
    let options = [];
    let sections = null, dynamicSectionScore = null;
    let addOption = (option)=>{
        options.push(option);
        let { section: section } = option.completion;
        if (section) {
            if (!sections) sections = [];
            let name = typeof section == "string" ? section : section.name;
            if (!sections.some((s)=>s.name == name)) sections.push(typeof section == "string" ? {
                name: name
            } : section);
        }
    };
    let conf = state.facet($7570a9a1a9679713$var$completionConfig);
    for (let a of active)if (a.hasResult()) {
        let getMatch = a.result.getMatch;
        if (a.result.filter === false) for (let option of a.result.options)addOption(new $7570a9a1a9679713$var$Option(option, a.source, getMatch ? getMatch(option) : [], 1e9 - options.length));
        else {
            let pattern = state.sliceDoc(a.from, a.to), match;
            let matcher = conf.filterStrict ? new $7570a9a1a9679713$var$StrictMatcher(pattern) : new $7570a9a1a9679713$var$FuzzyMatcher(pattern);
            for (let option of a.result.options)if (match = matcher.match(option.label)) {
                let matched = !option.displayLabel ? match.matched : getMatch ? getMatch(option, match.matched) : [];
                let score = match.score + (option.boost || 0);
                addOption(new $7570a9a1a9679713$var$Option(option, a.source, matched, score));
                if (typeof option.section == "object" && option.section.rank === "dynamic") {
                    let { name: name } = option.section;
                    if (!dynamicSectionScore) dynamicSectionScore = Object.create(null);
                    dynamicSectionScore[name] = Math.max(score, dynamicSectionScore[name] || -1000000000);
                }
            }
        }
    }
    if (sections) {
        let sectionOrder = Object.create(null), pos = 0;
        let cmp = (a, b)=>{
            return (a.rank === "dynamic" && b.rank === "dynamic" ? dynamicSectionScore[b.name] - dynamicSectionScore[a.name] : 0) || (typeof a.rank == "number" ? a.rank : 1e9) - (typeof b.rank == "number" ? b.rank : 1e9) || (a.name < b.name ? -1 : 1);
        };
        for (let s of sections.sort(cmp)){
            pos -= 1e5;
            sectionOrder[s.name] = pos;
        }
        for (let option of options){
            let { section: section } = option.completion;
            if (section) option.score += sectionOrder[typeof section == "string" ? section : section.name];
        }
    }
    let result = [], prev = null;
    let compare = conf.compareCompletions;
    for (let opt of options.sort((a, b)=>b.score - a.score || compare(a.completion, b.completion))){
        let cur = opt.completion;
        if (!prev || prev.label != cur.label || prev.detail != cur.detail || prev.type != null && cur.type != null && prev.type != cur.type || prev.apply != cur.apply || prev.boost != cur.boost) result.push(opt);
        else if ($7570a9a1a9679713$var$score(opt.completion) > $7570a9a1a9679713$var$score(prev)) result[result.length - 1] = opt;
        prev = opt.completion;
    }
    return result;
}
class $7570a9a1a9679713$var$CompletionDialog {
    constructor(options, attrs, tooltip, timestamp, selected, disabled){
        this.options = options;
        this.attrs = attrs;
        this.tooltip = tooltip;
        this.timestamp = timestamp;
        this.selected = selected;
        this.disabled = disabled;
    }
    setSelected(selected, id) {
        return selected == this.selected || selected >= this.options.length ? this : new $7570a9a1a9679713$var$CompletionDialog(this.options, $7570a9a1a9679713$var$makeAttrs(id, selected), this.tooltip, this.timestamp, selected, this.disabled);
    }
    static build(active, state, id, prev, conf, didSetActive) {
        if (prev && !didSetActive && active.some((s)=>s.isPending)) return prev.setDisabled();
        let options = $7570a9a1a9679713$var$sortOptions(active, state);
        if (!options.length) return prev && active.some((a)=>a.isPending) ? prev.setDisabled() : null;
        let selected = state.facet($7570a9a1a9679713$var$completionConfig).selectOnOpen ? 0 : -1;
        if (prev && prev.selected != selected && prev.selected != -1) {
            let selectedValue = prev.options[prev.selected].completion;
            for(let i = 0; i < options.length; i++)if (options[i].completion == selectedValue) {
                selected = i;
                break;
            }
        }
        return new $7570a9a1a9679713$var$CompletionDialog(options, $7570a9a1a9679713$var$makeAttrs(id, selected), {
            pos: active.reduce((a, b)=>b.hasResult() ? Math.min(a, b.from) : a, 1e8),
            create: $7570a9a1a9679713$var$createTooltip,
            above: conf.aboveCursor
        }, prev ? prev.timestamp : Date.now(), selected, false);
    }
    map(changes) {
        return new $7570a9a1a9679713$var$CompletionDialog(this.options, this.attrs, {
            ...this.tooltip,
            pos: changes.mapPos(this.tooltip.pos)
        }, this.timestamp, this.selected, this.disabled);
    }
    setDisabled() {
        return new $7570a9a1a9679713$var$CompletionDialog(this.options, this.attrs, this.tooltip, this.timestamp, this.selected, true);
    }
}
class $7570a9a1a9679713$var$CompletionState {
    constructor(active, id, open){
        this.active = active;
        this.id = id;
        this.open = open;
    }
    static start() {
        return new $7570a9a1a9679713$var$CompletionState($7570a9a1a9679713$var$none, "cm-ac-" + Math.floor(Math.random() * 2e6).toString(36), null);
    }
    update(tr) {
        let { state: state } = tr, conf = state.facet($7570a9a1a9679713$var$completionConfig);
        let sources = conf.override || state.languageDataAt("autocomplete", $7570a9a1a9679713$var$cur(state)).map($7570a9a1a9679713$var$asSource);
        let active = sources.map((source)=>{
            let value = this.active.find((s)=>s.source == source) || new $7570a9a1a9679713$var$ActiveSource(source, this.active.some((a)=>a.state != 0 /* State.Inactive */ ) ? 1 /* State.Pending */  : 0 /* State.Inactive */ );
            return value.update(tr, conf);
        });
        if (active.length == this.active.length && active.every((a, i)=>a == this.active[i])) active = this.active;
        let open = this.open, didSet = tr.effects.some((e)=>e.is($7570a9a1a9679713$var$setActiveEffect));
        if (open && tr.docChanged) open = open.map(tr.changes);
        if (tr.selection || active.some((a)=>a.hasResult() && tr.changes.touchesRange(a.from, a.to)) || !$7570a9a1a9679713$var$sameResults(active, this.active) || didSet) open = $7570a9a1a9679713$var$CompletionDialog.build(active, state, this.id, open, conf, didSet);
        else if (open && open.disabled && !active.some((a)=>a.isPending)) open = null;
        if (!open && active.every((a)=>!a.isPending) && active.some((a)=>a.hasResult())) active = active.map((a)=>a.hasResult() ? new $7570a9a1a9679713$var$ActiveSource(a.source, 0 /* State.Inactive */ ) : a);
        for (let effect of tr.effects)if (effect.is($7570a9a1a9679713$var$setSelectedEffect)) open = open && open.setSelected(effect.value, this.id);
        return active == this.active && open == this.open ? this : new $7570a9a1a9679713$var$CompletionState(active, this.id, open);
    }
    get tooltip() {
        return this.open ? this.open.tooltip : null;
    }
    get attrs() {
        return this.open ? this.open.attrs : this.active.length ? $7570a9a1a9679713$var$baseAttrs : $7570a9a1a9679713$var$noAttrs;
    }
}
function $7570a9a1a9679713$var$sameResults(a, b) {
    if (a == b) return true;
    for(let iA = 0, iB = 0;;){
        while(iA < a.length && !a[iA].hasResult())iA++;
        while(iB < b.length && !b[iB].hasResult())iB++;
        let endA = iA == a.length, endB = iB == b.length;
        if (endA || endB) return endA == endB;
        if (a[iA++].result != b[iB++].result) return false;
    }
}
const $7570a9a1a9679713$var$baseAttrs = {
    "aria-autocomplete": "list"
};
const $7570a9a1a9679713$var$noAttrs = {};
function $7570a9a1a9679713$var$makeAttrs(id, selected) {
    let result = {
        "aria-autocomplete": "list",
        "aria-haspopup": "listbox",
        "aria-controls": id
    };
    if (selected > -1) result["aria-activedescendant"] = id + "-" + selected;
    return result;
}
const $7570a9a1a9679713$var$none = [];
function $7570a9a1a9679713$var$getUpdateType(tr, conf) {
    if (tr.isUserEvent("input.complete")) {
        let completion = tr.annotation($7570a9a1a9679713$export$6c84d44c1ceeb831);
        if (completion && conf.activateOnCompletion(completion)) return 12 /* UpdateType.Reset */ ;
    }
    let typing = tr.isUserEvent("input.type");
    return typing && conf.activateOnTyping ? 5 /* UpdateType.Typing */  : typing ? 1 /* UpdateType.Typing */  : tr.isUserEvent("delete.backward") ? 2 /* UpdateType.Backspacing */  : tr.selection ? 8 /* UpdateType.Reset */  : tr.docChanged ? 16 /* UpdateType.ResetIfTouching */  : 0 /* UpdateType.None */ ;
}
class $7570a9a1a9679713$var$ActiveSource {
    constructor(source, state, explicit = false){
        this.source = source;
        this.state = state;
        this.explicit = explicit;
    }
    hasResult() {
        return false;
    }
    get isPending() {
        return this.state == 1 /* State.Pending */ ;
    }
    update(tr, conf) {
        let type = $7570a9a1a9679713$var$getUpdateType(tr, conf), value = this;
        if (type & 8 /* UpdateType.Reset */  || type & 16 /* UpdateType.ResetIfTouching */  && this.touches(tr)) value = new $7570a9a1a9679713$var$ActiveSource(value.source, 0 /* State.Inactive */ );
        if (type & 4 /* UpdateType.Activate */  && value.state == 0 /* State.Inactive */ ) value = new $7570a9a1a9679713$var$ActiveSource(this.source, 1 /* State.Pending */ );
        value = value.updateFor(tr, type);
        for (let effect of tr.effects){
            if (effect.is($7570a9a1a9679713$var$startCompletionEffect)) value = new $7570a9a1a9679713$var$ActiveSource(value.source, 1 /* State.Pending */ , effect.value);
            else if (effect.is($7570a9a1a9679713$var$closeCompletionEffect)) value = new $7570a9a1a9679713$var$ActiveSource(value.source, 0 /* State.Inactive */ );
            else if (effect.is($7570a9a1a9679713$var$setActiveEffect)) {
                for (let active of effect.value)if (active.source == value.source) value = active;
            }
        }
        return value;
    }
    updateFor(tr, type) {
        return this.map(tr.changes);
    }
    map(changes) {
        return this;
    }
    touches(tr) {
        return tr.changes.touchesRange($7570a9a1a9679713$var$cur(tr.state));
    }
}
class $7570a9a1a9679713$var$ActiveResult extends $7570a9a1a9679713$var$ActiveSource {
    constructor(source, explicit, limit, result, from, to){
        super(source, 3 /* State.Result */ , explicit);
        this.limit = limit;
        this.result = result;
        this.from = from;
        this.to = to;
    }
    hasResult() {
        return true;
    }
    updateFor(tr, type) {
        var _a;
        if (!(type & 3 /* UpdateType.SimpleInteraction */ )) return this.map(tr.changes);
        let result = this.result;
        if (result.map && !tr.changes.empty) result = result.map(result, tr.changes);
        let from = tr.changes.mapPos(this.from), to = tr.changes.mapPos(this.to, 1);
        let pos = $7570a9a1a9679713$var$cur(tr.state);
        if (pos > to || !result || type & 2 /* UpdateType.Backspacing */  && ($7570a9a1a9679713$var$cur(tr.startState) == this.from || pos < this.limit)) return new $7570a9a1a9679713$var$ActiveSource(this.source, type & 4 /* UpdateType.Activate */  ? 1 /* State.Pending */  : 0 /* State.Inactive */ );
        let limit = tr.changes.mapPos(this.limit);
        if ($7570a9a1a9679713$var$checkValid(result.validFor, tr.state, from, to)) return new $7570a9a1a9679713$var$ActiveResult(this.source, this.explicit, limit, result, from, to);
        if (result.update && (result = result.update(result, from, to, new $7570a9a1a9679713$export$7b73e80391102dce(tr.state, pos, false)))) return new $7570a9a1a9679713$var$ActiveResult(this.source, this.explicit, limit, result, result.from, (_a = result.to) !== null && _a !== void 0 ? _a : $7570a9a1a9679713$var$cur(tr.state));
        return new $7570a9a1a9679713$var$ActiveSource(this.source, 1 /* State.Pending */ , this.explicit);
    }
    map(mapping) {
        if (mapping.empty) return this;
        let result = this.result.map ? this.result.map(this.result, mapping) : this.result;
        if (!result) return new $7570a9a1a9679713$var$ActiveSource(this.source, 0 /* State.Inactive */ );
        return new $7570a9a1a9679713$var$ActiveResult(this.source, this.explicit, mapping.mapPos(this.limit), result, mapping.mapPos(this.from), mapping.mapPos(this.to, 1));
    }
    touches(tr) {
        return tr.changes.touchesRange(this.from, this.to);
    }
}
function $7570a9a1a9679713$var$checkValid(validFor, state, from, to) {
    if (!validFor) return false;
    let text = state.sliceDoc(from, to);
    return typeof validFor == "function" ? validFor(text, from, to, state) : $7570a9a1a9679713$var$ensureAnchor(validFor, true).test(text);
}
const $7570a9a1a9679713$var$setActiveEffect = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define({
    map (sources, mapping) {
        return sources.map((s)=>s.map(mapping));
    }
});
const $7570a9a1a9679713$var$completionState = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$34381b1ce2130245).define({
    create () {
        return $7570a9a1a9679713$var$CompletionState.start();
    },
    update (value, tr) {
        return value.update(tr);
    },
    provide: (f)=>[
            (0, $7beee9608540d2c3$export$dba11b50e1aa3c12).from(f, (val)=>val.tooltip),
            (0, $7beee9608540d2c3$export$eece2fccabbb77c5).contentAttributes.from(f, (state)=>state.attrs)
        ]
});
function $7570a9a1a9679713$var$applyCompletion(view, option) {
    const apply = option.completion.apply || option.completion.label;
    let result = view.state.field($7570a9a1a9679713$var$completionState).active.find((a)=>a.source == option.source);
    if (!(result instanceof $7570a9a1a9679713$var$ActiveResult)) return false;
    if (typeof apply == "string") view.dispatch({
        ...$7570a9a1a9679713$export$496ff43229d73eba(view.state, apply, result.from, result.to),
        annotations: $7570a9a1a9679713$export$6c84d44c1ceeb831.of(option.completion)
    });
    else apply(view, option.completion, result.from, result.to);
    return true;
}
const $7570a9a1a9679713$var$createTooltip = /*@__PURE__*/ $7570a9a1a9679713$var$completionTooltip($7570a9a1a9679713$var$completionState, $7570a9a1a9679713$var$applyCompletion);
/**
Returns a command that moves the completion selection forward or
backward by the given amount.
*/ function $7570a9a1a9679713$export$26f3a479ac65d653(forward, by = "option") {
    return (view)=>{
        let cState = view.state.field($7570a9a1a9679713$var$completionState, false);
        if (!cState || !cState.open || cState.open.disabled || Date.now() - cState.open.timestamp < view.state.facet($7570a9a1a9679713$var$completionConfig).interactionDelay) return false;
        let step = 1, tooltip;
        if (by == "page" && (tooltip = (0, $7beee9608540d2c3$export$46455b4476d4b8e1)(view, cState.open.tooltip))) step = Math.max(2, Math.floor(tooltip.dom.offsetHeight / tooltip.dom.querySelector("li").offsetHeight) - 1);
        let { length: length } = cState.open.options;
        let selected = cState.open.selected > -1 ? cState.open.selected + step * (forward ? 1 : -1) : forward ? 0 : length - 1;
        if (selected < 0) selected = by == "page" ? 0 : length - 1;
        else if (selected >= length) selected = by == "page" ? length - 1 : 0;
        view.dispatch({
            effects: $7570a9a1a9679713$var$setSelectedEffect.of(selected)
        });
        return true;
    };
}
/**
Accept the current completion.
*/ const $7570a9a1a9679713$export$537623a3380ccdae = (view)=>{
    let cState = view.state.field($7570a9a1a9679713$var$completionState, false);
    if (view.state.readOnly || !cState || !cState.open || cState.open.selected < 0 || cState.open.disabled || Date.now() - cState.open.timestamp < view.state.facet($7570a9a1a9679713$var$completionConfig).interactionDelay) return false;
    return $7570a9a1a9679713$var$applyCompletion(view, cState.open.options[cState.open.selected]);
};
/**
Explicitly start autocompletion.
*/ const $7570a9a1a9679713$export$8a36416d28f82fd5 = (view)=>{
    let cState = view.state.field($7570a9a1a9679713$var$completionState, false);
    if (!cState) return false;
    view.dispatch({
        effects: $7570a9a1a9679713$var$startCompletionEffect.of(true)
    });
    return true;
};
/**
Close the currently active completion.
*/ const $7570a9a1a9679713$export$bdc62126738c63ab = (view)=>{
    let cState = view.state.field($7570a9a1a9679713$var$completionState, false);
    if (!cState || !cState.active.some((a)=>a.state != 0 /* State.Inactive */ )) return false;
    view.dispatch({
        effects: $7570a9a1a9679713$var$closeCompletionEffect.of(null)
    });
    return true;
};
class $7570a9a1a9679713$var$RunningQuery {
    constructor(active, context){
        this.active = active;
        this.context = context;
        this.time = Date.now();
        this.updates = [];
        // Note that 'undefined' means 'not done yet', whereas 'null' means
        // 'query returned null'.
        this.done = undefined;
    }
}
const $7570a9a1a9679713$var$MaxUpdateCount = 50, $7570a9a1a9679713$var$MinAbortTime = 1000;
const $7570a9a1a9679713$var$completionPlugin = /*@__PURE__*/ (0, $7beee9608540d2c3$export$44d5eccfd62adda7).fromClass(class {
    constructor(view){
        this.view = view;
        this.debounceUpdate = -1;
        this.running = [];
        this.debounceAccept = -1;
        this.pendingStart = false;
        this.composing = 0 /* CompositionState.None */ ;
        for (let active of view.state.field($7570a9a1a9679713$var$completionState).active)if (active.isPending) this.startQuery(active);
    }
    update(update) {
        let cState = update.state.field($7570a9a1a9679713$var$completionState);
        let conf = update.state.facet($7570a9a1a9679713$var$completionConfig);
        if (!update.selectionSet && !update.docChanged && update.startState.field($7570a9a1a9679713$var$completionState) == cState) return;
        let doesReset = update.transactions.some((tr)=>{
            let type = $7570a9a1a9679713$var$getUpdateType(tr, conf);
            return type & 8 /* UpdateType.Reset */  || (tr.selection || tr.docChanged) && !(type & 3 /* UpdateType.SimpleInteraction */ );
        });
        for(let i = 0; i < this.running.length; i++){
            let query = this.running[i];
            if (doesReset || query.context.abortOnDocChange && update.docChanged || query.updates.length + update.transactions.length > $7570a9a1a9679713$var$MaxUpdateCount && Date.now() - query.time > $7570a9a1a9679713$var$MinAbortTime) {
                for (let handler of query.context.abortListeners)try {
                    handler();
                } catch (e) {
                    (0, $7beee9608540d2c3$export$f86b2a1a2ce291b3)(this.view.state, e);
                }
                query.context.abortListeners = null;
                this.running.splice(i--, 1);
            } else query.updates.push(...update.transactions);
        }
        if (this.debounceUpdate > -1) clearTimeout(this.debounceUpdate);
        if (update.transactions.some((tr)=>tr.effects.some((e)=>e.is($7570a9a1a9679713$var$startCompletionEffect)))) this.pendingStart = true;
        let delay = this.pendingStart ? 50 : conf.activateOnTypingDelay;
        this.debounceUpdate = cState.active.some((a)=>a.isPending && !this.running.some((q)=>q.active.source == a.source)) ? setTimeout(()=>this.startUpdate(), delay) : -1;
        if (this.composing != 0 /* CompositionState.None */ ) for (let tr of update.transactions){
            if (tr.isUserEvent("input.type")) this.composing = 2 /* CompositionState.Changed */ ;
            else if (this.composing == 2 /* CompositionState.Changed */  && tr.selection) this.composing = 3 /* CompositionState.ChangedAndMoved */ ;
        }
    }
    startUpdate() {
        this.debounceUpdate = -1;
        this.pendingStart = false;
        let { state: state } = this.view, cState = state.field($7570a9a1a9679713$var$completionState);
        for (let active of cState.active)if (active.isPending && !this.running.some((r)=>r.active.source == active.source)) this.startQuery(active);
        if (this.running.length && cState.open && cState.open.disabled) this.debounceAccept = setTimeout(()=>this.accept(), this.view.state.facet($7570a9a1a9679713$var$completionConfig).updateSyncTime);
    }
    startQuery(active) {
        let { state: state } = this.view, pos = $7570a9a1a9679713$var$cur(state);
        let context = new $7570a9a1a9679713$export$7b73e80391102dce(state, pos, active.explicit, this.view);
        let pending = new $7570a9a1a9679713$var$RunningQuery(active, context);
        this.running.push(pending);
        Promise.resolve(active.source(context)).then((result)=>{
            if (!pending.context.aborted) {
                pending.done = result || null;
                this.scheduleAccept();
            }
        }, (err)=>{
            this.view.dispatch({
                effects: $7570a9a1a9679713$var$closeCompletionEffect.of(null)
            });
            (0, $7beee9608540d2c3$export$f86b2a1a2ce291b3)(this.view.state, err);
        });
    }
    scheduleAccept() {
        if (this.running.every((q)=>q.done !== undefined)) this.accept();
        else if (this.debounceAccept < 0) this.debounceAccept = setTimeout(()=>this.accept(), this.view.state.facet($7570a9a1a9679713$var$completionConfig).updateSyncTime);
    }
    // For each finished query in this.running, try to create a result
    // or, if appropriate, restart the query.
    accept() {
        var _a;
        if (this.debounceAccept > -1) clearTimeout(this.debounceAccept);
        this.debounceAccept = -1;
        let updated = [];
        let conf = this.view.state.facet($7570a9a1a9679713$var$completionConfig), cState = this.view.state.field($7570a9a1a9679713$var$completionState);
        for(let i = 0; i < this.running.length; i++){
            let query = this.running[i];
            if (query.done === undefined) continue;
            this.running.splice(i--, 1);
            if (query.done) {
                let pos = $7570a9a1a9679713$var$cur(query.updates.length ? query.updates[0].startState : this.view.state);
                let limit = Math.min(pos, query.done.from + (query.active.explicit ? 0 : 1));
                let active = new $7570a9a1a9679713$var$ActiveResult(query.active.source, query.active.explicit, limit, query.done, query.done.from, (_a = query.done.to) !== null && _a !== void 0 ? _a : pos);
                // Replay the transactions that happened since the start of
                // the request and see if that preserves the result
                for (let tr of query.updates)active = active.update(tr, conf);
                if (active.hasResult()) {
                    updated.push(active);
                    continue;
                }
            }
            let current = cState.active.find((a)=>a.source == query.active.source);
            if (current && current.isPending) {
                if (query.done == null) {
                    // Explicitly failed. Should clear the pending status if it
                    // hasn't been re-set in the meantime.
                    let active = new $7570a9a1a9679713$var$ActiveSource(query.active.source, 0 /* State.Inactive */ );
                    for (let tr of query.updates)active = active.update(tr, conf);
                    if (!active.isPending) updated.push(active);
                } else // Cleared by subsequent transactions. Restart.
                this.startQuery(current);
            }
        }
        if (updated.length || cState.open && cState.open.disabled) this.view.dispatch({
            effects: $7570a9a1a9679713$var$setActiveEffect.of(updated)
        });
    }
}, {
    eventHandlers: {
        blur (event) {
            let state = this.view.state.field($7570a9a1a9679713$var$completionState, false);
            if (state && state.tooltip && this.view.state.facet($7570a9a1a9679713$var$completionConfig).closeOnBlur) {
                let dialog = state.open && (0, $7beee9608540d2c3$export$46455b4476d4b8e1)(this.view, state.open.tooltip);
                if (!dialog || !dialog.dom.contains(event.relatedTarget)) setTimeout(()=>this.view.dispatch({
                        effects: $7570a9a1a9679713$var$closeCompletionEffect.of(null)
                    }), 10);
            }
        },
        compositionstart () {
            this.composing = 1 /* CompositionState.Started */ ;
        },
        compositionend () {
            if (this.composing == 3 /* CompositionState.ChangedAndMoved */ ) // Safari fires compositionend events synchronously, possibly
            // from inside an update, so dispatch asynchronously to avoid reentrancy
            setTimeout(()=>this.view.dispatch({
                    effects: $7570a9a1a9679713$var$startCompletionEffect.of(false)
                }), 20);
            this.composing = 0 /* CompositionState.None */ ;
        }
    }
});
const $7570a9a1a9679713$var$windows = typeof navigator == "object" && /*@__PURE__*/ /Win/.test(navigator.platform);
const $7570a9a1a9679713$var$commitCharacters = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$b92464a736444411).highest(/*@__PURE__*/ (0, $7beee9608540d2c3$export$eece2fccabbb77c5).domEventHandlers({
    keydown (event, view) {
        let field = view.state.field($7570a9a1a9679713$var$completionState, false);
        if (!field || !field.open || field.open.disabled || field.open.selected < 0 || event.key.length > 1 || event.ctrlKey && !($7570a9a1a9679713$var$windows && event.altKey) || event.metaKey) return false;
        let option = field.open.options[field.open.selected];
        let result = field.active.find((a)=>a.source == option.source);
        let commitChars = option.completion.commitCharacters || result.result.commitCharacters;
        if (commitChars && commitChars.indexOf(event.key) > -1) $7570a9a1a9679713$var$applyCompletion(view, option);
        return false;
    }
}));
const $7570a9a1a9679713$var$baseTheme = /*@__PURE__*/ (0, $7beee9608540d2c3$export$eece2fccabbb77c5).baseTheme({
    ".cm-tooltip.cm-tooltip-autocomplete": {
        "& > ul": {
            fontFamily: "monospace",
            whiteSpace: "nowrap",
            overflow: "hidden auto",
            maxWidth_fallback: "700px",
            maxWidth: "min(700px, 95vw)",
            minWidth: "250px",
            maxHeight: "10em",
            height: "100%",
            listStyle: "none",
            margin: 0,
            padding: 0,
            "& > li, & > completion-section": {
                padding: "1px 3px",
                lineHeight: 1.2
            },
            "& > li": {
                overflowX: "hidden",
                textOverflow: "ellipsis",
                cursor: "pointer"
            },
            "& > completion-section": {
                display: "list-item",
                borderBottom: "1px solid silver",
                paddingLeft: "0.5em",
                opacity: 0.7
            }
        }
    },
    "&light .cm-tooltip-autocomplete ul li[aria-selected]": {
        background: "#17c",
        color: "white"
    },
    "&light .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
        background: "#777"
    },
    "&dark .cm-tooltip-autocomplete ul li[aria-selected]": {
        background: "#347",
        color: "white"
    },
    "&dark .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
        background: "#444"
    },
    ".cm-completionListIncompleteTop:before, .cm-completionListIncompleteBottom:after": {
        content: '"\xb7\xb7\xb7"',
        opacity: 0.5,
        display: "block",
        textAlign: "center",
        cursor: "pointer"
    },
    ".cm-tooltip.cm-completionInfo": {
        position: "absolute",
        padding: "3px 9px",
        width: "max-content",
        maxWidth: `${400 /* Info.Width */ }px`,
        boxSizing: "border-box",
        whiteSpace: "pre-line"
    },
    ".cm-completionInfo.cm-completionInfo-left": {
        right: "100%"
    },
    ".cm-completionInfo.cm-completionInfo-right": {
        left: "100%"
    },
    ".cm-completionInfo.cm-completionInfo-left-narrow": {
        right: `${30 /* Info.Margin */ }px`
    },
    ".cm-completionInfo.cm-completionInfo-right-narrow": {
        left: `${30 /* Info.Margin */ }px`
    },
    "&light .cm-snippetField": {
        backgroundColor: "#00000022"
    },
    "&dark .cm-snippetField": {
        backgroundColor: "#ffffff22"
    },
    ".cm-snippetFieldPosition": {
        verticalAlign: "text-top",
        width: 0,
        height: "1.15em",
        display: "inline-block",
        margin: "0 -0.7px -.7em",
        borderLeft: "1.4px dotted #888"
    },
    ".cm-completionMatchedText": {
        textDecoration: "underline"
    },
    ".cm-completionDetail": {
        marginLeft: "0.5em",
        fontStyle: "italic"
    },
    ".cm-completionIcon": {
        fontSize: "90%",
        width: ".8em",
        display: "inline-block",
        textAlign: "center",
        paddingRight: ".6em",
        opacity: "0.6",
        boxSizing: "content-box"
    },
    ".cm-completionIcon-function, .cm-completionIcon-method": {
        "&:after": {
            content: "'\u0192'"
        }
    },
    ".cm-completionIcon-class": {
        "&:after": {
            content: "'\u25CB'"
        }
    },
    ".cm-completionIcon-interface": {
        "&:after": {
            content: "'\u25CC'"
        }
    },
    ".cm-completionIcon-variable": {
        "&:after": {
            content: "'\uD835\uDC65'"
        }
    },
    ".cm-completionIcon-constant": {
        "&:after": {
            content: "'\uD835\uDC36'"
        }
    },
    ".cm-completionIcon-type": {
        "&:after": {
            content: "'\uD835\uDC61'"
        }
    },
    ".cm-completionIcon-enum": {
        "&:after": {
            content: "'\u222A'"
        }
    },
    ".cm-completionIcon-property": {
        "&:after": {
            content: "'\u25A1'"
        }
    },
    ".cm-completionIcon-keyword": {
        "&:after": {
            content: "'\uD83D\uDD11\uFE0E'"
        } // Disable emoji rendering
    },
    ".cm-completionIcon-namespace": {
        "&:after": {
            content: "'\u25A2'"
        }
    },
    ".cm-completionIcon-text": {
        "&:after": {
            content: "'abc'",
            fontSize: "50%",
            verticalAlign: "middle"
        }
    }
});
class $7570a9a1a9679713$var$FieldPos {
    constructor(field, line, from, to){
        this.field = field;
        this.line = line;
        this.from = from;
        this.to = to;
    }
}
class $7570a9a1a9679713$var$FieldRange {
    constructor(field, from, to){
        this.field = field;
        this.from = from;
        this.to = to;
    }
    map(changes) {
        let from = changes.mapPos(this.from, -1, (0, $6295c6875f57e3ee$export$39cf3280165f92aa).TrackDel);
        let to = changes.mapPos(this.to, 1, (0, $6295c6875f57e3ee$export$39cf3280165f92aa).TrackDel);
        return from == null || to == null ? null : new $7570a9a1a9679713$var$FieldRange(this.field, from, to);
    }
}
class $7570a9a1a9679713$var$Snippet {
    constructor(lines, fieldPositions){
        this.lines = lines;
        this.fieldPositions = fieldPositions;
    }
    instantiate(state, pos) {
        let text = [], lineStart = [
            pos
        ];
        let lineObj = state.doc.lineAt(pos), baseIndent = /^\s*/.exec(lineObj.text)[0];
        for (let line of this.lines){
            if (text.length) {
                let indent = baseIndent, tabs = /^\t*/.exec(line)[0].length;
                for(let i = 0; i < tabs; i++)indent += state.facet((0, $a97ccac5cf5f4f5d$export$9e0d0c2ce4d3ceb5));
                lineStart.push(pos + indent.length - tabs);
                line = indent + line.slice(tabs);
            }
            text.push(line);
            pos += line.length + 1;
        }
        let ranges = this.fieldPositions.map((pos)=>new $7570a9a1a9679713$var$FieldRange(pos.field, lineStart[pos.line] + pos.from, lineStart[pos.line] + pos.to));
        return {
            text: text,
            ranges: ranges
        };
    }
    static parse(template) {
        let fields = [];
        let lines = [], positions = [], m;
        for (let line of template.split(/\r\n?|\n/)){
            while(m = /[#$]\{(?:(\d+)(?::([^{}]*))?|((?:\\[{}]|[^{}])*))\}/.exec(line)){
                let seq = m[1] ? +m[1] : null, rawName = m[2] || m[3] || "", found = -1;
                // `${0}` is the cursor's final position, after every other tab stop.
                if (seq === 0) seq = 1e9;
                let name = rawName.replace(/\\[{}]/g, (m)=>m[1]);
                for(let i = 0; i < fields.length; i++)if (seq != null ? fields[i].seq == seq : name ? fields[i].name == name : false) found = i;
                if (found < 0) {
                    let i = 0;
                    while(i < fields.length && (seq == null || fields[i].seq != null && fields[i].seq < seq))i++;
                    fields.splice(i, 0, {
                        seq: seq,
                        name: name
                    });
                    found = i;
                    for (let pos of positions)if (pos.field >= found) pos.field++;
                }
                for (let pos of positions)if (pos.line == lines.length && pos.from > m.index) {
                    let snip = m[2] ? 3 + (m[1] || "").length : 2;
                    pos.from -= snip;
                    pos.to -= snip;
                }
                positions.push(new $7570a9a1a9679713$var$FieldPos(found, lines.length, m.index, m.index + name.length));
                line = line.slice(0, m.index) + rawName + line.slice(m.index + m[0].length);
            }
            line = line.replace(/\\([{}])/g, (_, brace, index)=>{
                for (let pos of positions)if (pos.line == lines.length && pos.from > index) {
                    pos.from--;
                    pos.to--;
                }
                return brace;
            });
            lines.push(line);
        }
        return new $7570a9a1a9679713$var$Snippet(lines, positions);
    }
}
let $7570a9a1a9679713$var$fieldMarker = /*@__PURE__*/ (0, $7beee9608540d2c3$export$10e30b733df217ea).widget({
    widget: /*@__PURE__*/ new class extends (0, $7beee9608540d2c3$export$95cdd842edb044c5) {
        toDOM() {
            let span = document.createElement("span");
            span.className = "cm-snippetFieldPosition";
            return span;
        }
        ignoreEvent() {
            return false;
        }
    }
});
let $7570a9a1a9679713$var$fieldRange = /*@__PURE__*/ (0, $7beee9608540d2c3$export$10e30b733df217ea).mark({
    class: "cm-snippetField"
});
class $7570a9a1a9679713$var$ActiveSnippet {
    constructor(ranges, active){
        this.ranges = ranges;
        this.active = active;
        this.deco = (0, $7beee9608540d2c3$export$10e30b733df217ea).set(ranges.map((r)=>(r.from == r.to ? $7570a9a1a9679713$var$fieldMarker : $7570a9a1a9679713$var$fieldRange).range(r.from, r.to)), true);
    }
    map(changes) {
        let ranges = [];
        for (let r of this.ranges){
            let mapped = r.map(changes);
            if (!mapped) return null;
            ranges.push(mapped);
        }
        return new $7570a9a1a9679713$var$ActiveSnippet(ranges, this.active);
    }
    selectionInsideField(sel) {
        return sel.ranges.every((range)=>this.ranges.some((r)=>r.field == this.active && r.from <= range.from && r.to >= range.to));
    }
}
const $7570a9a1a9679713$var$setActive = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define({
    map (value, changes) {
        return value && value.map(changes);
    }
});
const $7570a9a1a9679713$var$moveToField = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
const $7570a9a1a9679713$var$snippetState = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$34381b1ce2130245).define({
    create () {
        return null;
    },
    update (value, tr) {
        for (let effect of tr.effects){
            if (effect.is($7570a9a1a9679713$var$setActive)) return effect.value;
            if (effect.is($7570a9a1a9679713$var$moveToField) && value) return new $7570a9a1a9679713$var$ActiveSnippet(value.ranges, effect.value);
        }
        if (value && tr.docChanged) value = value.map(tr.changes);
        if (value && tr.selection && !value.selectionInsideField(tr.selection)) value = null;
        return value;
    },
    provide: (f)=>(0, $7beee9608540d2c3$export$eece2fccabbb77c5).decorations.from(f, (val)=>val ? val.deco : (0, $7beee9608540d2c3$export$10e30b733df217ea).none)
});
function $7570a9a1a9679713$var$fieldSelection(ranges, field) {
    return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create(ranges.filter((r)=>r.field == field).map((r)=>(0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(r.from, r.to)));
}
/**
Convert a snippet template to a function that can
[apply](https://codemirror.net/6/docs/ref/#autocomplete.Completion.apply) it. Snippets are written
using syntax like this:

    "for (let ${index} = 0; ${index} < ${end}; ${index}++) {\n\t${}\n}"

Each `${}` placeholder (you may also use `#{}`) indicates a field
that the user can fill in. Its name, if any, will be the default
content for the field.

When the snippet is activated by calling the returned function,
the code is inserted at the given position. Newlines in the
template are indented by the indentation of the start line, plus
one [indent unit](https://codemirror.net/6/docs/ref/#language.indentUnit) per tab character after
the newline.

On activation, (all instances of) the first field are selected.
The user can move between fields with Tab and Shift-Tab as long as
the fields are active. Moving to the last field or moving the
cursor out of the current field deactivates the fields.

The order of fields defaults to textual order, but you can add
numbers to placeholders (`${1}` or `${1:defaultText}`) to provide
a custom order. `${0}` is special—it is always the last stop, where
the cursor ends up after tabbing through the other fields.

To include a literal `{` or `}` in your template, put a backslash
in front of it. This will be removed and the brace will not be
interpreted as indicating a placeholder.
*/ function $7570a9a1a9679713$export$f77f1ac5bf251232(template) {
    let snippet = $7570a9a1a9679713$var$Snippet.parse(template);
    return (editor, completion, from, to)=>{
        let { text: text, ranges: ranges } = snippet.instantiate(editor.state, from);
        let { main: main } = editor.state.selection;
        let spec = {
            changes: {
                from: from,
                to: to == main.from ? main.to : to,
                insert: (0, $6295c6875f57e3ee$export$5f1af8db9871e1d6).of(text)
            },
            scrollIntoView: true,
            annotations: completion ? [
                $7570a9a1a9679713$export$6c84d44c1ceeb831.of(completion),
                (0, $6295c6875f57e3ee$export$febc5573c75cefb0).userEvent.of("input.complete")
            ] : undefined
        };
        if (ranges.length) spec.selection = $7570a9a1a9679713$var$fieldSelection(ranges, 0);
        if (ranges.some((r)=>r.field > 0)) {
            let active = new $7570a9a1a9679713$var$ActiveSnippet(ranges, 0);
            let effects = spec.effects = [
                $7570a9a1a9679713$var$setActive.of(active)
            ];
            if (editor.state.field($7570a9a1a9679713$var$snippetState, false) === undefined) effects.push((0, $6295c6875f57e3ee$export$95000d4efaa4321f).appendConfig.of([
                $7570a9a1a9679713$var$snippetState,
                $7570a9a1a9679713$var$addSnippetKeymap,
                $7570a9a1a9679713$var$snippetPointerHandler,
                $7570a9a1a9679713$var$baseTheme
            ]));
        }
        editor.dispatch(editor.state.update(spec));
    };
}
function $7570a9a1a9679713$var$moveField(dir) {
    return ({ state: state, dispatch: dispatch })=>{
        let active = state.field($7570a9a1a9679713$var$snippetState, false);
        if (!active || dir < 0 && active.active == 0) return false;
        let next = active.active + dir, last = dir > 0 && !active.ranges.some((r)=>r.field == next + dir);
        dispatch(state.update({
            selection: $7570a9a1a9679713$var$fieldSelection(active.ranges, next),
            effects: $7570a9a1a9679713$var$setActive.of(last ? null : new $7570a9a1a9679713$var$ActiveSnippet(active.ranges, next)),
            scrollIntoView: true
        }));
        return true;
    };
}
/**
A command that clears the active snippet, if any.
*/ const $7570a9a1a9679713$export$4d00dce2599b1df3 = ({ state: state, dispatch: dispatch })=>{
    let active = state.field($7570a9a1a9679713$var$snippetState, false);
    if (!active) return false;
    dispatch(state.update({
        effects: $7570a9a1a9679713$var$setActive.of(null)
    }));
    return true;
};
/**
Move to the next snippet field, if available.
*/ const $7570a9a1a9679713$export$d8da8fdad886df2f = /*@__PURE__*/ $7570a9a1a9679713$var$moveField(1);
/**
Move to the previous snippet field, if available.
*/ const $7570a9a1a9679713$export$8d02b23b64ec425c = /*@__PURE__*/ $7570a9a1a9679713$var$moveField(-1);
/**
Check if there is an active snippet with a next field for
`nextSnippetField` to move to.
*/ function $7570a9a1a9679713$export$9c250e449e4af222(state) {
    let active = state.field($7570a9a1a9679713$var$snippetState, false);
    return !!(active && active.ranges.some((r)=>r.field == active.active + 1));
}
/**
Returns true if there is an active snippet and a previous field
for `prevSnippetField` to move to.
*/ function $7570a9a1a9679713$export$ace2e22fa9996777(state) {
    let active = state.field($7570a9a1a9679713$var$snippetState, false);
    return !!(active && active.active > 0);
}
const $7570a9a1a9679713$var$defaultSnippetKeymap = [
    {
        key: "Tab",
        run: $7570a9a1a9679713$export$d8da8fdad886df2f,
        shift: $7570a9a1a9679713$export$8d02b23b64ec425c
    },
    {
        key: "Escape",
        run: $7570a9a1a9679713$export$4d00dce2599b1df3
    }
];
/**
A facet that can be used to configure the key bindings used by
snippets. The default binds Tab to
[`nextSnippetField`](https://codemirror.net/6/docs/ref/#autocomplete.nextSnippetField), Shift-Tab to
[`prevSnippetField`](https://codemirror.net/6/docs/ref/#autocomplete.prevSnippetField), and Escape
to [`clearSnippet`](https://codemirror.net/6/docs/ref/#autocomplete.clearSnippet).
*/ const $7570a9a1a9679713$export$1808c2f24fc99b36 = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (maps) {
        return maps.length ? maps[0] : $7570a9a1a9679713$var$defaultSnippetKeymap;
    }
});
const $7570a9a1a9679713$var$addSnippetKeymap = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$b92464a736444411).highest(/*@__PURE__*/ (0, $7beee9608540d2c3$export$5043418e2ef368d5).compute([
    $7570a9a1a9679713$export$1808c2f24fc99b36
], (state)=>state.facet($7570a9a1a9679713$export$1808c2f24fc99b36)));
/**
Create a completion from a snippet. Returns an object with the
properties from `completion`, plus an `apply` function that
applies the snippet.
*/ function $7570a9a1a9679713$export$975ef56e648d23ad(template, completion) {
    return {
        ...completion,
        apply: $7570a9a1a9679713$export$f77f1ac5bf251232(template)
    };
}
const $7570a9a1a9679713$var$snippetPointerHandler = /*@__PURE__*/ (0, $7beee9608540d2c3$export$eece2fccabbb77c5).domEventHandlers({
    mousedown (event, view) {
        let active = view.state.field($7570a9a1a9679713$var$snippetState, false), pos;
        if (!active || (pos = view.posAtCoords({
            x: event.clientX,
            y: event.clientY
        })) == null) return false;
        let match = active.ranges.find((r)=>r.from <= pos && r.to >= pos);
        if (!match || match.field == active.active) return false;
        view.dispatch({
            selection: $7570a9a1a9679713$var$fieldSelection(active.ranges, match.field),
            effects: $7570a9a1a9679713$var$setActive.of(active.ranges.some((r)=>r.field > match.field) ? new $7570a9a1a9679713$var$ActiveSnippet(active.ranges, match.field) : null),
            scrollIntoView: true
        });
        return true;
    }
});
function $7570a9a1a9679713$var$wordRE(wordChars) {
    let escaped = wordChars.replace(/[\]\-\\]/g, "\\$&");
    try {
        return new RegExp(`[\\p{Alphabetic}\\p{Number}_${escaped}]+`, "ug");
    } catch (_a) {
        return new RegExp(`[\w${escaped}]`, "g");
    }
}
function $7570a9a1a9679713$var$mapRE(re, f) {
    return new RegExp(f(re.source), re.unicode ? "u" : "");
}
const $7570a9a1a9679713$var$wordCaches = /*@__PURE__*/ Object.create(null);
function $7570a9a1a9679713$var$wordCache(wordChars) {
    return $7570a9a1a9679713$var$wordCaches[wordChars] || ($7570a9a1a9679713$var$wordCaches[wordChars] = new WeakMap);
}
function $7570a9a1a9679713$var$storeWords(doc, wordRE, result, seen, ignoreAt) {
    for(let lines = doc.iterLines(), pos = 0; !lines.next().done;){
        let { value: value } = lines, m;
        wordRE.lastIndex = 0;
        while(m = wordRE.exec(value))if (!seen[m[0]] && pos + m.index != ignoreAt) {
            result.push({
                type: "text",
                label: m[0]
            });
            seen[m[0]] = true;
            if (result.length >= 2000 /* C.MaxList */ ) return;
        }
        pos += value.length + 1;
    }
}
function $7570a9a1a9679713$var$collectWords(doc, cache, wordRE, to, ignoreAt) {
    let big = doc.length >= 1000 /* C.MinCacheLen */ ;
    let cached = big && cache.get(doc);
    if (cached) return cached;
    let result = [], seen = Object.create(null);
    if (doc.children) {
        let pos = 0;
        for (let ch of doc.children){
            if (ch.length >= 1000 /* C.MinCacheLen */ ) {
                for (let c of $7570a9a1a9679713$var$collectWords(ch, cache, wordRE, to - pos, ignoreAt - pos))if (!seen[c.label]) {
                    seen[c.label] = true;
                    result.push(c);
                }
            } else $7570a9a1a9679713$var$storeWords(ch, wordRE, result, seen, ignoreAt - pos);
            pos += ch.length + 1;
        }
    } else $7570a9a1a9679713$var$storeWords(doc, wordRE, result, seen, ignoreAt);
    if (big && result.length < 2000 /* C.MaxList */ ) cache.set(doc, result);
    return result;
}
/**
A completion source that will scan the document for words (using a
[character categorizer](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer)), and
return those as completions.
*/ const $7570a9a1a9679713$export$a018df98be431a1 = (context)=>{
    var _a;
    let wordChars = (_a = context.state.languageDataAt("wordChars", context.pos)[0]) !== null && _a !== void 0 ? _a : "";
    let re = $7570a9a1a9679713$var$wordRE(wordChars);
    let token = context.matchBefore($7570a9a1a9679713$var$mapRE(re, (s)=>s + "$"));
    if (!token && !context.explicit) return null;
    let from = token ? token.from : context.pos;
    let options = $7570a9a1a9679713$var$collectWords(context.state.doc, $7570a9a1a9679713$var$wordCache(wordChars), re, 50000 /* C.Range */ , from);
    return {
        from: from,
        options: options,
        validFor: $7570a9a1a9679713$var$mapRE(re, (s)=>"^" + s)
    };
};
const $7570a9a1a9679713$var$defaults = {
    brackets: [
        "(",
        "[",
        "{",
        "'",
        '"'
    ],
    before: ")]}:;>",
    stringPrefixes: []
};
const $7570a9a1a9679713$var$closeBracketEffect = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define({
    map (value, mapping) {
        let mapped = mapping.mapPos(value, -1, (0, $6295c6875f57e3ee$export$39cf3280165f92aa).TrackAfter);
        return mapped == null ? undefined : mapped;
    }
});
const $7570a9a1a9679713$var$closedBracket = /*@__PURE__*/ new class extends (0, $6295c6875f57e3ee$export$d60f08ed93a48611) {
};
$7570a9a1a9679713$var$closedBracket.startSide = 1;
$7570a9a1a9679713$var$closedBracket.endSide = -1;
const $7570a9a1a9679713$var$bracketState = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$34381b1ce2130245).define({
    create () {
        return (0, $6295c6875f57e3ee$export$34cb5241245008dd).empty;
    },
    update (value, tr) {
        value = value.map(tr.changes);
        if (tr.selection) {
            let line = tr.state.doc.lineAt(tr.selection.main.head);
            value = value.update({
                filter: (from)=>from >= line.from && from <= line.to
            });
        }
        for (let effect of tr.effects)if (effect.is($7570a9a1a9679713$var$closeBracketEffect)) value = value.update({
            add: [
                $7570a9a1a9679713$var$closedBracket.range(effect.value, effect.value + 1)
            ]
        });
        return value;
    }
});
/**
Extension to enable bracket-closing behavior. When a closeable
bracket is typed, its closing bracket is immediately inserted
after the cursor. When closing a bracket directly in front of a
closing bracket inserted by the extension, the cursor moves over
that bracket.
*/ function $7570a9a1a9679713$export$69e4e9d3300ff824() {
    return [
        $7570a9a1a9679713$var$inputHandler,
        $7570a9a1a9679713$var$bracketState
    ];
}
const $7570a9a1a9679713$var$definedClosing = "()[]{}<>\xab\xbb\xbb\xab\uFF3B\uFF3D\uFF5B\uFF5D";
function $7570a9a1a9679713$var$closing(ch) {
    for(let i = 0; i < $7570a9a1a9679713$var$definedClosing.length; i += 2)if ($7570a9a1a9679713$var$definedClosing.charCodeAt(i) == ch) return $7570a9a1a9679713$var$definedClosing.charAt(i + 1);
    return (0, $6295c6875f57e3ee$export$73bfc63873071f74)(ch < 128 ? ch : ch + 1);
}
function $7570a9a1a9679713$var$config(state, pos) {
    return state.languageDataAt("closeBrackets", pos)[0] || $7570a9a1a9679713$var$defaults;
}
const $7570a9a1a9679713$var$android = typeof navigator == "object" && /*@__PURE__*/ /Android\b/.test(navigator.userAgent);
const $7570a9a1a9679713$var$inputHandler = /*@__PURE__*/ (0, $7beee9608540d2c3$export$eece2fccabbb77c5).inputHandler.of((view, from, to, insert)=>{
    if (($7570a9a1a9679713$var$android ? view.composing : view.compositionStarted) || view.state.readOnly) return false;
    let sel = view.state.selection.main;
    if (insert.length > 2 || insert.length == 2 && (0, $6295c6875f57e3ee$export$a870abf234f6353c)((0, $6295c6875f57e3ee$export$42977f40461e1360)(insert, 0)) == 1 || from != sel.from || to != sel.to) return false;
    let tr = $7570a9a1a9679713$export$7ce1ae5219095222(view.state, insert);
    if (!tr) return false;
    view.dispatch(tr);
    return true;
});
/**
Command that implements deleting a pair of matching brackets when
the cursor is between them.
*/ const $7570a9a1a9679713$export$5339d701ea89967c = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    let conf = $7570a9a1a9679713$var$config(state, state.selection.main.head);
    let tokens = conf.brackets || $7570a9a1a9679713$var$defaults.brackets;
    let dont = null, changes = state.changeByRange((range)=>{
        if (range.empty) {
            let before = $7570a9a1a9679713$var$prevChar(state.doc, range.head);
            for (let token of tokens){
                if (token == before && $7570a9a1a9679713$var$nextChar(state.doc, range.head) == $7570a9a1a9679713$var$closing((0, $6295c6875f57e3ee$export$42977f40461e1360)(token, 0))) return {
                    changes: {
                        from: range.head - token.length,
                        to: range.head + token.length
                    },
                    range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(range.head - token.length)
                };
            }
        }
        return {
            range: dont = range
        };
    });
    if (!dont) dispatch(state.update(changes, {
        scrollIntoView: true,
        userEvent: "delete.backward"
    }));
    return !dont;
};
/**
Close-brackets related key bindings. Binds Backspace to
[`deleteBracketPair`](https://codemirror.net/6/docs/ref/#autocomplete.deleteBracketPair).
*/ const $7570a9a1a9679713$export$9477e95792b48f4a = [
    {
        key: "Backspace",
        run: $7570a9a1a9679713$export$5339d701ea89967c
    }
];
/**
Implements the extension's behavior on text insertion. If the
given string counts as a bracket in the language around the
selection, and replacing the selection with it requires custom
behavior (inserting a closing version or skipping past a
previously-closed bracket), this function returns a transaction
representing that custom behavior. (You only need this if you want
to programmatically insert brackets—the
[`closeBrackets`](https://codemirror.net/6/docs/ref/#autocomplete.closeBrackets) extension will
take care of running this for user input.)
*/ function $7570a9a1a9679713$export$7ce1ae5219095222(state, bracket) {
    let conf = $7570a9a1a9679713$var$config(state, state.selection.main.head);
    let tokens = conf.brackets || $7570a9a1a9679713$var$defaults.brackets;
    for (let tok of tokens){
        let closed = $7570a9a1a9679713$var$closing((0, $6295c6875f57e3ee$export$42977f40461e1360)(tok, 0));
        if (bracket == tok) return closed == tok ? $7570a9a1a9679713$var$handleSame(state, tok, tokens.indexOf(tok + tok + tok) > -1, conf) : $7570a9a1a9679713$var$handleOpen(state, tok, closed, conf.before || $7570a9a1a9679713$var$defaults.before);
        if (bracket == closed && $7570a9a1a9679713$var$closedBracketAt(state, state.selection.main.from)) return $7570a9a1a9679713$var$handleClose(state, tok, closed);
    }
    return null;
}
function $7570a9a1a9679713$var$closedBracketAt(state, pos) {
    let found = false;
    state.field($7570a9a1a9679713$var$bracketState).between(0, state.doc.length, (from)=>{
        if (from == pos) found = true;
    });
    return found;
}
function $7570a9a1a9679713$var$nextChar(doc, pos) {
    let next = doc.sliceString(pos, pos + 2);
    return next.slice(0, (0, $6295c6875f57e3ee$export$a870abf234f6353c)((0, $6295c6875f57e3ee$export$42977f40461e1360)(next, 0)));
}
function $7570a9a1a9679713$var$prevChar(doc, pos) {
    let prev = doc.sliceString(pos - 2, pos);
    return (0, $6295c6875f57e3ee$export$a870abf234f6353c)((0, $6295c6875f57e3ee$export$42977f40461e1360)(prev, 0)) == prev.length ? prev : prev.slice(1);
}
function $7570a9a1a9679713$var$handleOpen(state, open, close, closeBefore) {
    let dont = null, changes = state.changeByRange((range)=>{
        if (!range.empty) return {
            changes: [
                {
                    insert: open,
                    from: range.from
                },
                {
                    insert: close,
                    from: range.to
                }
            ],
            effects: $7570a9a1a9679713$var$closeBracketEffect.of(range.to + open.length),
            range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(range.anchor + open.length, range.head + open.length)
        };
        let next = $7570a9a1a9679713$var$nextChar(state.doc, range.head);
        if (!next || /\s/.test(next) || closeBefore.indexOf(next) > -1) return {
            changes: {
                insert: open + close,
                from: range.head
            },
            effects: $7570a9a1a9679713$var$closeBracketEffect.of(range.head + open.length),
            range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(range.head + open.length)
        };
        return {
            range: dont = range
        };
    });
    return dont ? null : state.update(changes, {
        scrollIntoView: true,
        userEvent: "input.type"
    });
}
function $7570a9a1a9679713$var$handleClose(state, _open, close) {
    let dont = null, changes = state.changeByRange((range)=>{
        if (range.empty && $7570a9a1a9679713$var$nextChar(state.doc, range.head) == close) return {
            changes: {
                from: range.head,
                to: range.head + close.length,
                insert: close
            },
            range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(range.head + close.length)
        };
        return dont = {
            range: range
        };
    });
    return dont ? null : state.update(changes, {
        scrollIntoView: true,
        userEvent: "input.type"
    });
}
// Handles cases where the open and close token are the same, and
// possibly triple quotes (as in `"""abc"""`-style quoting).
function $7570a9a1a9679713$var$handleSame(state, token, allowTriple, config) {
    let stringPrefixes = config.stringPrefixes || $7570a9a1a9679713$var$defaults.stringPrefixes;
    let dont = null, changes = state.changeByRange((range)=>{
        if (!range.empty) return {
            changes: [
                {
                    insert: token,
                    from: range.from
                },
                {
                    insert: token,
                    from: range.to
                }
            ],
            effects: $7570a9a1a9679713$var$closeBracketEffect.of(range.to + token.length),
            range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(range.anchor + token.length, range.head + token.length)
        };
        let pos = range.head, next = $7570a9a1a9679713$var$nextChar(state.doc, pos), start;
        if (next == token) {
            if ($7570a9a1a9679713$var$nodeStart(state, pos)) return {
                changes: {
                    insert: token + token,
                    from: pos
                },
                effects: $7570a9a1a9679713$var$closeBracketEffect.of(pos + token.length),
                range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(pos + token.length)
            };
            else if ($7570a9a1a9679713$var$closedBracketAt(state, pos)) {
                let isTriple = allowTriple && state.sliceDoc(pos, pos + token.length * 3) == token + token + token;
                let content = isTriple ? token + token + token : token;
                return {
                    changes: {
                        from: pos,
                        to: pos + content.length,
                        insert: content
                    },
                    range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(pos + content.length)
                };
            }
        } else if (allowTriple && state.sliceDoc(pos - 2 * token.length, pos) == token + token && (start = $7570a9a1a9679713$var$canStartStringAt(state, pos - 2 * token.length, stringPrefixes)) > -1 && $7570a9a1a9679713$var$nodeStart(state, start)) return {
            changes: {
                insert: token + token + token + token,
                from: pos
            },
            effects: $7570a9a1a9679713$var$closeBracketEffect.of(pos + token.length),
            range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(pos + token.length)
        };
        else if (state.charCategorizer(pos)(next) != (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word) {
            if ($7570a9a1a9679713$var$canStartStringAt(state, pos, stringPrefixes) > -1 && !$7570a9a1a9679713$var$probablyInString(state, pos, token, stringPrefixes)) return {
                changes: {
                    insert: token + token,
                    from: pos
                },
                effects: $7570a9a1a9679713$var$closeBracketEffect.of(pos + token.length),
                range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(pos + token.length)
            };
        }
        return {
            range: dont = range
        };
    });
    return dont ? null : state.update(changes, {
        scrollIntoView: true,
        userEvent: "input.type"
    });
}
function $7570a9a1a9679713$var$nodeStart(state, pos) {
    let tree = (0, $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1)(state).resolveInner(pos + 1);
    return tree.parent && tree.from == pos;
}
function $7570a9a1a9679713$var$probablyInString(state, pos, quoteToken, prefixes) {
    let node = (0, $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1)(state).resolveInner(pos, -1);
    let maxPrefix = prefixes.reduce((m, p)=>Math.max(m, p.length), 0);
    for(let i = 0; i < 5; i++){
        let start = state.sliceDoc(node.from, Math.min(node.to, node.from + quoteToken.length + maxPrefix));
        let quotePos = start.indexOf(quoteToken);
        if (!quotePos || quotePos > -1 && prefixes.indexOf(start.slice(0, quotePos)) > -1) {
            let first = node.firstChild;
            while(first && first.from == node.from && first.to - first.from > quoteToken.length + quotePos){
                if (state.sliceDoc(first.to - quoteToken.length, first.to) == quoteToken) return false;
                first = first.firstChild;
            }
            return true;
        }
        let parent = node.to == pos && node.parent;
        if (!parent) break;
        node = parent;
    }
    return false;
}
function $7570a9a1a9679713$var$canStartStringAt(state, pos, prefixes) {
    let charCat = state.charCategorizer(pos);
    if (charCat(state.sliceDoc(pos - 1, pos)) != (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word) return pos;
    for (let prefix of prefixes){
        let start = pos - prefix.length;
        if (state.sliceDoc(start, pos) == prefix && charCat(state.sliceDoc(start - 1, start)) != (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word) return start;
    }
    return -1;
}
/**
Returns an extension that enables autocompletion.
*/ function $7570a9a1a9679713$export$f95786d390465556(config = {}) {
    return [
        $7570a9a1a9679713$var$commitCharacters,
        $7570a9a1a9679713$var$completionState,
        $7570a9a1a9679713$var$completionConfig.of(config),
        $7570a9a1a9679713$var$completionPlugin,
        $7570a9a1a9679713$var$completionKeymapExt,
        $7570a9a1a9679713$var$baseTheme
    ];
}
/**
Basic keybindings for autocompletion.

 - Ctrl-Space (and Alt-\` or Alt-i on macOS): [`startCompletion`](https://codemirror.net/6/docs/ref/#autocomplete.startCompletion)
 - Escape: [`closeCompletion`](https://codemirror.net/6/docs/ref/#autocomplete.closeCompletion)
 - ArrowDown: [`moveCompletionSelection`](https://codemirror.net/6/docs/ref/#autocomplete.moveCompletionSelection)`(true)`
 - ArrowUp: [`moveCompletionSelection`](https://codemirror.net/6/docs/ref/#autocomplete.moveCompletionSelection)`(false)`
 - PageDown: [`moveCompletionSelection`](https://codemirror.net/6/docs/ref/#autocomplete.moveCompletionSelection)`(true, "page")`
 - PageUp: [`moveCompletionSelection`](https://codemirror.net/6/docs/ref/#autocomplete.moveCompletionSelection)`(false, "page")`
 - Enter: [`acceptCompletion`](https://codemirror.net/6/docs/ref/#autocomplete.acceptCompletion)
*/ const $7570a9a1a9679713$export$2a3d759d156afab4 = [
    {
        key: "Ctrl-Space",
        run: $7570a9a1a9679713$export$8a36416d28f82fd5
    },
    {
        mac: "Alt-`",
        run: $7570a9a1a9679713$export$8a36416d28f82fd5
    },
    {
        mac: "Alt-i",
        run: $7570a9a1a9679713$export$8a36416d28f82fd5
    },
    {
        key: "Escape",
        run: $7570a9a1a9679713$export$bdc62126738c63ab
    },
    {
        key: "ArrowDown",
        run: /*@__PURE__*/ $7570a9a1a9679713$export$26f3a479ac65d653(true)
    },
    {
        key: "ArrowUp",
        run: /*@__PURE__*/ $7570a9a1a9679713$export$26f3a479ac65d653(false)
    },
    {
        key: "PageDown",
        run: /*@__PURE__*/ $7570a9a1a9679713$export$26f3a479ac65d653(true, "page")
    },
    {
        key: "PageUp",
        run: /*@__PURE__*/ $7570a9a1a9679713$export$26f3a479ac65d653(false, "page")
    },
    {
        key: "Enter",
        run: $7570a9a1a9679713$export$537623a3380ccdae
    }
];
const $7570a9a1a9679713$var$completionKeymapExt = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$b92464a736444411).highest(/*@__PURE__*/ (0, $7beee9608540d2c3$export$5043418e2ef368d5).computeN([
    $7570a9a1a9679713$var$completionConfig
], (state)=>state.facet($7570a9a1a9679713$var$completionConfig).defaultKeymap ? [
        $7570a9a1a9679713$export$2a3d759d156afab4
    ] : []));
/**
Get the current completion status. When completions are available,
this will return `"active"`. When completions are pending (in the
process of being queried), this returns `"pending"`. Otherwise, it
returns `null`.
*/ function $7570a9a1a9679713$export$9eb35bf27959eae5(state) {
    let cState = state.field($7570a9a1a9679713$var$completionState, false);
    return cState && cState.active.some((a)=>a.isPending) ? "pending" : cState && cState.active.some((a)=>a.state != 0 /* State.Inactive */ ) ? "active" : null;
}
const $7570a9a1a9679713$var$completionArrayCache = /*@__PURE__*/ new WeakMap;
/**
Returns the available completions as an array.
*/ function $7570a9a1a9679713$export$dc0f5d77fb0cbbf5(state) {
    var _a;
    let open = (_a = state.field($7570a9a1a9679713$var$completionState, false)) === null || _a === void 0 ? void 0 : _a.open;
    if (!open || open.disabled) return [];
    let completions = $7570a9a1a9679713$var$completionArrayCache.get(open.options);
    if (!completions) $7570a9a1a9679713$var$completionArrayCache.set(open.options, completions = open.options.map((o)=>o.completion));
    return completions;
}
/**
Return the currently selected completion, if any.
*/ function $7570a9a1a9679713$export$8c322db2cd50d0f1(state) {
    var _a;
    let open = (_a = state.field($7570a9a1a9679713$var$completionState, false)) === null || _a === void 0 ? void 0 : _a.open;
    return open && !open.disabled && open.selected >= 0 ? open.options[open.selected].completion : null;
}
/**
Returns the currently selected position in the active completion
list, or null if no completions are active.
*/ function $7570a9a1a9679713$export$93d3d3265e08d270(state) {
    var _a;
    let open = (_a = state.field($7570a9a1a9679713$var$completionState, false)) === null || _a === void 0 ? void 0 : _a.open;
    return open && !open.disabled && open.selected >= 0 ? open.selected : null;
}
/**
Create an effect that can be attached to a transaction to change
the currently selected completion.
*/ function $7570a9a1a9679713$export$64a726c2de6175b8(index) {
    return $7570a9a1a9679713$var$setSelectedEffect.of(index);
}






class $1e126942d86629f6$var$SelectedDiagnostic {
    constructor(from, to, diagnostic){
        this.from = from;
        this.to = to;
        this.diagnostic = diagnostic;
    }
}
class $1e126942d86629f6$var$LintState {
    constructor(diagnostics, panel, selected){
        this.diagnostics = diagnostics;
        this.panel = panel;
        this.selected = selected;
    }
    static init(diagnostics, panel, state) {
        // Filter the list of diagnostics for which to create markers
        let diagnosticFilter = state.facet($1e126942d86629f6$var$lintConfig).markerFilter;
        if (diagnosticFilter) diagnostics = diagnosticFilter(diagnostics, state);
        let sorted = diagnostics.slice().sort((a, b)=>a.from - b.from || a.to - b.to);
        let deco = new (0, $6295c6875f57e3ee$export$89e09ce03c7e8594)(), active = [], pos = 0;
        let scan = state.doc.iter(), scanPos = 0, docLen = state.doc.length;
        for(let i = 0;;){
            let next = i == sorted.length ? null : sorted[i];
            if (!next && !active.length) break;
            let from, to;
            if (active.length) {
                from = pos;
                to = active.reduce((p, d)=>Math.min(p, d.to), next && next.from > from ? next.from : 1e8);
            } else {
                from = next.from;
                if (from > docLen) break;
                to = next.to;
                active.push(next);
                i++;
            }
            while(i < sorted.length){
                let next = sorted[i];
                if (next.from == from && (next.to > next.from || next.to == from)) {
                    active.push(next);
                    i++;
                    to = Math.min(next.to, to);
                } else {
                    to = Math.min(next.from, to);
                    break;
                }
            }
            to = Math.min(to, docLen);
            let widget = false;
            if (active.some((d)=>d.from == from && (d.to == to || to == docLen))) {
                widget = from == to;
                if (!widget && to - from < 10) {
                    let behind = from - (scanPos + scan.value.length);
                    if (behind > 0) {
                        scan.next(behind);
                        scanPos = from;
                    }
                    for(let check = from;;){
                        if (check >= to) {
                            widget = true;
                            break;
                        }
                        if (!scan.lineBreak && scanPos + scan.value.length > check) break;
                        check = scanPos + scan.value.length;
                        scanPos += scan.value.length;
                        scan.next();
                    }
                }
            }
            let sev = $1e126942d86629f6$var$maxSeverity(active);
            if (widget) deco.add(from, from, (0, $7beee9608540d2c3$export$10e30b733df217ea).widget({
                widget: new $1e126942d86629f6$var$DiagnosticWidget(sev),
                diagnostics: active.slice()
            }));
            else {
                let markClass = active.reduce((c, d)=>d.markClass ? c + " " + d.markClass : c, "");
                deco.add(from, to, (0, $7beee9608540d2c3$export$10e30b733df217ea).mark({
                    class: "cm-lintRange cm-lintRange-" + sev + markClass,
                    diagnostics: active.slice(),
                    inclusiveEnd: active.some((a)=>a.to > to)
                }));
            }
            pos = to;
            if (pos == docLen) break;
            for(let i = 0; i < active.length; i++)if (active[i].to <= pos) active.splice(i--, 1);
        }
        let set = deco.finish();
        return new $1e126942d86629f6$var$LintState(set, panel, $1e126942d86629f6$var$findDiagnostic(set));
    }
}
function $1e126942d86629f6$var$findDiagnostic(diagnostics, diagnostic = null, after = 0) {
    let found = null;
    diagnostics.between(after, 1e9, (from, to, { spec: spec })=>{
        if (diagnostic && spec.diagnostics.indexOf(diagnostic) < 0) return;
        if (!found) found = new $1e126942d86629f6$var$SelectedDiagnostic(from, to, diagnostic || spec.diagnostics[0]);
        else if (spec.diagnostics.indexOf(found.diagnostic) < 0) return false;
        else found = new $1e126942d86629f6$var$SelectedDiagnostic(found.from, to, found.diagnostic);
    });
    return found;
}
function $1e126942d86629f6$var$hideTooltip(tr, tooltip) {
    let from = tooltip.pos, to = tooltip.end || from;
    let result = tr.state.facet($1e126942d86629f6$var$lintConfig).hideOn(tr, from, to);
    if (result != null) return result;
    let line = tr.startState.doc.lineAt(tooltip.pos);
    return !!(tr.effects.some((e)=>e.is($1e126942d86629f6$export$9c7976977981c7bf)) || tr.changes.touchesRange(line.from, Math.max(line.to, to)));
}
function $1e126942d86629f6$var$maybeEnableLint(state, effects) {
    return state.field($1e126942d86629f6$var$lintState, false) ? effects : effects.concat((0, $6295c6875f57e3ee$export$95000d4efaa4321f).appendConfig.of($1e126942d86629f6$var$lintExtensions));
}
/**
Returns a transaction spec which updates the current set of
diagnostics, and enables the lint extension if if wasn't already
active.
*/ function $1e126942d86629f6$export$188c3c6ceeec4bb3(state, diagnostics) {
    return {
        effects: $1e126942d86629f6$var$maybeEnableLint(state, [
            $1e126942d86629f6$export$9c7976977981c7bf.of(diagnostics)
        ])
    };
}
/**
The state effect that updates the set of active diagnostics. Can
be useful when writing an extension that needs to track these.
*/ const $1e126942d86629f6$export$9c7976977981c7bf = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
const $1e126942d86629f6$var$togglePanel = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
const $1e126942d86629f6$var$movePanelSelection = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
const $1e126942d86629f6$var$lintState = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$34381b1ce2130245).define({
    create () {
        return new $1e126942d86629f6$var$LintState((0, $7beee9608540d2c3$export$10e30b733df217ea).none, null, null);
    },
    update (value, tr) {
        if (tr.docChanged && value.diagnostics.size) {
            let mapped = value.diagnostics.map(tr.changes), selected = null, panel = value.panel;
            if (value.selected) {
                let selPos = tr.changes.mapPos(value.selected.from, 1);
                selected = $1e126942d86629f6$var$findDiagnostic(mapped, value.selected.diagnostic, selPos) || $1e126942d86629f6$var$findDiagnostic(mapped, null, selPos);
            }
            if (!mapped.size && panel && tr.state.facet($1e126942d86629f6$var$lintConfig).autoPanel) panel = null;
            value = new $1e126942d86629f6$var$LintState(mapped, panel, selected);
        }
        for (let effect of tr.effects){
            if (effect.is($1e126942d86629f6$export$9c7976977981c7bf)) {
                let panel = !tr.state.facet($1e126942d86629f6$var$lintConfig).autoPanel ? value.panel : effect.value.length ? $1e126942d86629f6$var$LintPanel.open : null;
                value = $1e126942d86629f6$var$LintState.init(effect.value, panel, tr.state);
            } else if (effect.is($1e126942d86629f6$var$togglePanel)) value = new $1e126942d86629f6$var$LintState(value.diagnostics, effect.value ? $1e126942d86629f6$var$LintPanel.open : null, value.selected);
            else if (effect.is($1e126942d86629f6$var$movePanelSelection)) value = new $1e126942d86629f6$var$LintState(value.diagnostics, value.panel, effect.value);
        }
        return value;
    },
    provide: (f)=>[
            (0, $7beee9608540d2c3$export$e89c3c9af31c1e3b).from(f, (val)=>val.panel),
            (0, $7beee9608540d2c3$export$eece2fccabbb77c5).decorations.from(f, (s)=>s.diagnostics)
        ]
});
/**
Returns the number of active lint diagnostics in the given state.
*/ function $1e126942d86629f6$export$31ce51ade4a789ff(state) {
    let lint = state.field($1e126942d86629f6$var$lintState, false);
    return lint ? lint.diagnostics.size : 0;
}
const $1e126942d86629f6$var$activeMark = /*@__PURE__*/ (0, $7beee9608540d2c3$export$10e30b733df217ea).mark({
    class: "cm-lintRange cm-lintRange-active"
});
function $1e126942d86629f6$var$lintTooltip(view, pos, side) {
    let { diagnostics: diagnostics } = view.state.field($1e126942d86629f6$var$lintState);
    let found, start = -1, end = -1;
    diagnostics.between(pos - (side < 0 ? 1 : 0), pos + (side > 0 ? 1 : 0), (from, to, { spec: spec })=>{
        if (pos >= from && pos <= to && (from == to || (pos > from || side > 0) && (pos < to || side < 0))) {
            found = spec.diagnostics;
            start = from;
            end = to;
            return false;
        }
    });
    let diagnosticFilter = view.state.facet($1e126942d86629f6$var$lintConfig).tooltipFilter;
    if (found && diagnosticFilter) found = diagnosticFilter(found, view.state);
    if (!found) return null;
    return {
        pos: start,
        end: end,
        above: true,
        create () {
            return {
                dom: $1e126942d86629f6$var$diagnosticsTooltip(view, found)
            };
        }
    };
}
function $1e126942d86629f6$var$diagnosticsTooltip(view, diagnostics) {
    return (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("ul", {
        class: "cm-tooltip-lint"
    }, diagnostics.map((d)=>$1e126942d86629f6$var$renderDiagnostic(view, d, false)));
}
/**
Command to open and focus the lint panel.
*/ const $1e126942d86629f6$export$5c4e65c70e8c34a7 = (view)=>{
    let field = view.state.field($1e126942d86629f6$var$lintState, false);
    if (!field || !field.panel) view.dispatch({
        effects: $1e126942d86629f6$var$maybeEnableLint(view.state, [
            $1e126942d86629f6$var$togglePanel.of(true)
        ])
    });
    let panel = (0, $7beee9608540d2c3$export$7361ed18ff57179e)(view, $1e126942d86629f6$var$LintPanel.open);
    if (panel) panel.dom.querySelector(".cm-panel-lint ul").focus();
    return true;
};
/**
Command to close the lint panel, when open.
*/ const $1e126942d86629f6$export$2ee372c3e690e3c3 = (view)=>{
    let field = view.state.field($1e126942d86629f6$var$lintState, false);
    if (!field || !field.panel) return false;
    view.dispatch({
        effects: $1e126942d86629f6$var$togglePanel.of(false)
    });
    return true;
};
/**
Move the selection to the next diagnostic.
*/ const $1e126942d86629f6$export$79abb131646e1359 = (view)=>{
    let field = view.state.field($1e126942d86629f6$var$lintState, false);
    if (!field) return false;
    let sel = view.state.selection.main, next = $1e126942d86629f6$var$findDiagnostic(field.diagnostics, null, sel.to + 1);
    if (!next) {
        next = $1e126942d86629f6$var$findDiagnostic(field.diagnostics, null, 0);
        if (!next || next.from == sel.from && next.to == sel.to) return false;
    }
    view.dispatch({
        selection: {
            anchor: next.from,
            head: next.to
        },
        scrollIntoView: true
    });
    (0, $7beee9608540d2c3$export$a34e0ba9d4697396)(view, next.from, 1, {
        tooltip: $1e126942d86629f6$var$lintHover,
        until: (tr)=>tr.docChanged || tr.newSelection.main.head < next.from || tr.newSelection.main.head > next.to
    });
    return true;
};
/**
Move the selection to the previous diagnostic.
*/ const $1e126942d86629f6$export$f71c1dd1430b5cc1 = (view)=>{
    var _a;
    let { state: state } = view, field = state.field($1e126942d86629f6$var$lintState, false);
    if (!field) return false;
    let sel = state.selection.main;
    let prevFrom, prevTo, lastFrom, lastTo;
    field.diagnostics.between(0, state.doc.length, (from, to)=>{
        if (to < sel.to && (prevFrom == null || prevFrom < from)) {
            prevFrom = from;
            prevTo = to;
        }
        if (lastFrom == null || from > lastFrom) {
            lastFrom = from;
            lastTo = to;
        }
    });
    if (lastFrom == null || prevFrom == null && lastFrom == sel.from) return false;
    let from = prevFrom !== null && prevFrom !== void 0 ? prevFrom : lastFrom, to = (_a = prevTo !== null && prevTo !== void 0 ? prevTo : lastTo) !== null && _a !== void 0 ? _a : from;
    view.dispatch({
        selection: {
            anchor: from,
            head: to
        },
        scrollIntoView: true
    });
    (0, $7beee9608540d2c3$export$a34e0ba9d4697396)(view, from, 1, {
        tooltip: $1e126942d86629f6$var$lintHover,
        until: (tr)=>tr.docChanged || tr.newSelection.main.head < from || tr.newSelection.main.head > to
    });
    return true;
};
/**
A set of default key bindings for the lint functionality.

- Ctrl-Shift-m (Cmd-Shift-m on macOS): [`openLintPanel`](https://codemirror.net/6/docs/ref/#lint.openLintPanel)
- F8: [`nextDiagnostic`](https://codemirror.net/6/docs/ref/#lint.nextDiagnostic)
*/ const $1e126942d86629f6$export$a21d7a0cde3cbb60 = [
    {
        key: "Mod-Shift-m",
        run: $1e126942d86629f6$export$5c4e65c70e8c34a7,
        preventDefault: true
    },
    {
        key: "F8",
        run: $1e126942d86629f6$export$79abb131646e1359
    }
];
const $1e126942d86629f6$var$lintPlugin = /*@__PURE__*/ (0, $7beee9608540d2c3$export$44d5eccfd62adda7).fromClass(class {
    constructor(view){
        this.view = view;
        this.timeout = -1;
        this.set = true;
        let { delay: delay } = view.state.facet($1e126942d86629f6$var$lintConfig);
        this.lintTime = Date.now() + delay;
        this.run = this.run.bind(this);
        this.timeout = setTimeout(this.run, delay);
    }
    run() {
        clearTimeout(this.timeout);
        let now = Date.now();
        if (now < this.lintTime - 10) this.timeout = setTimeout(this.run, this.lintTime - now);
        else {
            this.set = false;
            let { state: state } = this.view, { sources: sources } = state.facet($1e126942d86629f6$var$lintConfig);
            if (sources.length) $1e126942d86629f6$var$batchResults(sources.map((s)=>Promise.resolve(s(this.view))), (annotations)=>{
                if (this.view.state.doc == state.doc) this.view.dispatch($1e126942d86629f6$export$188c3c6ceeec4bb3(this.view.state, annotations.reduce((a, b)=>a.concat(b))));
            }, (error)=>{
                (0, $7beee9608540d2c3$export$f86b2a1a2ce291b3)(this.view.state, error);
            });
        }
    }
    update(update) {
        let config = update.state.facet($1e126942d86629f6$var$lintConfig);
        if (update.docChanged || config != update.startState.facet($1e126942d86629f6$var$lintConfig) || config.needsRefresh && config.needsRefresh(update)) {
            this.lintTime = Date.now() + config.delay;
            if (!this.set) {
                this.set = true;
                this.timeout = setTimeout(this.run, config.delay);
            }
        }
    }
    force() {
        if (this.set) {
            this.lintTime = Date.now();
            this.run();
        }
    }
    destroy() {
        clearTimeout(this.timeout);
    }
});
function $1e126942d86629f6$var$batchResults(promises, sink, error) {
    let collected = [], timeout = -1;
    for (let p of promises)p.then((value)=>{
        collected.push(value);
        clearTimeout(timeout);
        if (collected.length == promises.length) sink(collected);
        else timeout = setTimeout(()=>sink(collected), 200);
    }, error);
}
const $1e126942d86629f6$var$lintConfig = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (input) {
        return {
            sources: input.map((i)=>i.source).filter((x)=>x != null),
            ...(0, $6295c6875f57e3ee$export$4e19c0b693794a7e)(input.map((i)=>i.config), {
                delay: 750,
                markerFilter: null,
                tooltipFilter: null,
                needsRefresh: null,
                hideOn: ()=>null
            }, {
                delay: Math.max,
                markerFilter: $1e126942d86629f6$var$combineFilter,
                tooltipFilter: $1e126942d86629f6$var$combineFilter,
                needsRefresh: (a, b)=>!a ? b : !b ? a : (u)=>a(u) || b(u),
                hideOn: (a, b)=>!a ? b : !b ? a : (t, x, y)=>a(t, x, y) || b(t, x, y),
                autoPanel: (a, b)=>a || b
            })
        };
    }
});
function $1e126942d86629f6$var$combineFilter(a, b) {
    return !a ? b : !b ? a : (d, s)=>b(a(d, s), s);
}
/**
Given a diagnostic source, this function returns an extension that
enables linting with that source. It will be called whenever the
editor is idle (after its content changed).

Note that settings given here will apply to all linters active in
the editor. If `null` is given as source, this only configures the
lint extension.
*/ function $1e126942d86629f6$export$8bb7ef7a8be4cb1c(source, config = {}) {
    return [
        $1e126942d86629f6$var$lintConfig.of({
            source: source,
            config: config
        }),
        $1e126942d86629f6$var$lintPlugin,
        $1e126942d86629f6$var$lintExtensions
    ];
}
/**
Forces any linters [configured](https://codemirror.net/6/docs/ref/#lint.linter) to run when the
editor is idle to run right away.
*/ function $1e126942d86629f6$export$e917f1893924e285(view) {
    let plugin = view.plugin($1e126942d86629f6$var$lintPlugin);
    if (plugin) plugin.force();
}
function $1e126942d86629f6$var$assignKeys(actions) {
    let assigned = [];
    if (actions) actions: for (let { name: name } of actions){
        for(let i = 0; i < name.length; i++){
            let ch = name[i];
            if (/[a-zA-Z]/.test(ch) && !assigned.some((c)=>c.toLowerCase() == ch.toLowerCase())) {
                assigned.push(ch);
                continue actions;
            }
        }
        assigned.push("");
    }
    return assigned;
}
function $1e126942d86629f6$var$renderDiagnostic(view, diagnostic, inPanel) {
    var _a;
    let keys = inPanel ? $1e126942d86629f6$var$assignKeys(diagnostic.actions) : [];
    return (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("li", {
        class: "cm-diagnostic cm-diagnostic-" + diagnostic.severity
    }, (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("span", {
        class: "cm-diagnosticText"
    }, diagnostic.renderMessage ? diagnostic.renderMessage(view) : diagnostic.message), (_a = diagnostic.actions) === null || _a === void 0 ? void 0 : _a.map((action, i)=>{
        let fired = false, click = (e)=>{
            e.preventDefault();
            if (fired) return;
            fired = true;
            let found = $1e126942d86629f6$var$findDiagnostic(view.state.field($1e126942d86629f6$var$lintState).diagnostics, diagnostic);
            if (found) action.apply(view, found.from, found.to);
        };
        let { name: name } = action, keyIndex = keys[i] ? name.indexOf(keys[i]) : -1;
        let nameElt = keyIndex < 0 ? name : [
            name.slice(0, keyIndex),
            (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("u", name.slice(keyIndex, keyIndex + 1)),
            name.slice(keyIndex + 1)
        ];
        let markClass = action.markClass ? " " + action.markClass : "";
        return (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("button", {
            type: "button",
            class: "cm-diagnosticAction" + markClass,
            onclick: click,
            onmousedown: click,
            "aria-label": ` Action: ${name}${keyIndex < 0 ? "" : ` (access key "${keys[i]})"`}.`
        }, nameElt);
    }), diagnostic.source && (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("div", {
        class: "cm-diagnosticSource"
    }, diagnostic.source));
}
class $1e126942d86629f6$var$DiagnosticWidget extends (0, $7beee9608540d2c3$export$95cdd842edb044c5) {
    constructor(sev){
        super();
        this.sev = sev;
    }
    eq(other) {
        return other.sev == this.sev;
    }
    toDOM() {
        return (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("span", {
            class: "cm-lintPoint cm-lintPoint-" + this.sev
        });
    }
}
class $1e126942d86629f6$var$PanelItem {
    constructor(view, diagnostic){
        this.diagnostic = diagnostic;
        this.id = "item_" + Math.floor(Math.random() * 0xffffffff).toString(16);
        this.dom = $1e126942d86629f6$var$renderDiagnostic(view, diagnostic, true);
        this.dom.id = this.id;
        this.dom.setAttribute("role", "option");
    }
}
class $1e126942d86629f6$var$LintPanel {
    constructor(view){
        this.view = view;
        this.items = [];
        let onkeydown = (event)=>{
            if (event.ctrlKey || event.altKey || event.metaKey) return;
            if (event.keyCode == 27) {
                $1e126942d86629f6$export$2ee372c3e690e3c3(this.view);
                this.view.focus();
            } else if (event.keyCode == 38 || event.keyCode == 33) this.moveSelection((this.selectedIndex - 1 + this.items.length) % this.items.length);
            else if (event.keyCode == 40 || event.keyCode == 34) this.moveSelection((this.selectedIndex + 1) % this.items.length);
            else if (event.keyCode == 36) this.moveSelection(0);
            else if (event.keyCode == 35) this.moveSelection(this.items.length - 1);
            else if (event.keyCode == 13) this.view.focus();
            else if (event.keyCode >= 65 && event.keyCode <= 90 && this.selectedIndex >= 0) {
                let { diagnostic: diagnostic } = this.items[this.selectedIndex], keys = $1e126942d86629f6$var$assignKeys(diagnostic.actions);
                for(let i = 0; i < keys.length; i++)if (keys[i].toUpperCase().charCodeAt(0) == event.keyCode) {
                    let found = $1e126942d86629f6$var$findDiagnostic(this.view.state.field($1e126942d86629f6$var$lintState).diagnostics, diagnostic);
                    if (found) diagnostic.actions[i].apply(view, found.from, found.to);
                }
            } else return;
            event.preventDefault();
        };
        let onclick = (event)=>{
            for(let i = 0; i < this.items.length; i++)if (this.items[i].dom.contains(event.target)) this.moveSelection(i);
        };
        this.list = (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("ul", {
            tabIndex: 0,
            role: "listbox",
            "aria-label": this.view.state.phrase("Diagnostics"),
            onkeydown: onkeydown,
            onclick: onclick
        });
        this.dom = (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("div", {
            class: "cm-panel-lint"
        }, this.list, (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("button", {
            type: "button",
            name: "close",
            "aria-label": this.view.state.phrase("close"),
            onclick: ()=>$1e126942d86629f6$export$2ee372c3e690e3c3(this.view)
        }, "\xd7"));
        this.update();
    }
    get selectedIndex() {
        let selected = this.view.state.field($1e126942d86629f6$var$lintState).selected;
        if (!selected) return -1;
        for(let i = 0; i < this.items.length; i++)if (this.items[i].diagnostic == selected.diagnostic) return i;
        return -1;
    }
    update() {
        let { diagnostics: diagnostics, selected: selected } = this.view.state.field($1e126942d86629f6$var$lintState);
        let i = 0, needsSync = false, newSelectedItem = null;
        let seen = new Set();
        diagnostics.between(0, this.view.state.doc.length, (_start, _end, { spec: spec })=>{
            for (let diagnostic of spec.diagnostics){
                if (seen.has(diagnostic)) continue;
                seen.add(diagnostic);
                let found = -1, item;
                for(let j = i; j < this.items.length; j++)if (this.items[j].diagnostic == diagnostic) {
                    found = j;
                    break;
                }
                if (found < 0) {
                    item = new $1e126942d86629f6$var$PanelItem(this.view, diagnostic);
                    this.items.splice(i, 0, item);
                    needsSync = true;
                } else {
                    item = this.items[found];
                    if (found > i) {
                        this.items.splice(i, found - i);
                        needsSync = true;
                    }
                }
                if (selected && item.diagnostic == selected.diagnostic) {
                    if (!item.dom.hasAttribute("aria-selected")) {
                        item.dom.setAttribute("aria-selected", "true");
                        newSelectedItem = item;
                    }
                } else if (item.dom.hasAttribute("aria-selected")) item.dom.removeAttribute("aria-selected");
                i++;
            }
        });
        while(i < this.items.length && !(this.items.length == 1 && this.items[0].diagnostic.from < 0)){
            needsSync = true;
            this.items.pop();
        }
        if (this.items.length == 0) {
            this.items.push(new $1e126942d86629f6$var$PanelItem(this.view, {
                from: -1,
                to: -1,
                severity: "info",
                message: this.view.state.phrase("No diagnostics")
            }));
            needsSync = true;
        }
        if (newSelectedItem) {
            this.list.setAttribute("aria-activedescendant", newSelectedItem.id);
            this.view.requestMeasure({
                key: this,
                read: ()=>({
                        sel: newSelectedItem.dom.getBoundingClientRect(),
                        panel: this.list.getBoundingClientRect()
                    }),
                write: ({ sel: sel, panel: panel })=>{
                    let scaleY = panel.height / this.list.offsetHeight;
                    if (sel.top < panel.top) this.list.scrollTop -= (panel.top - sel.top) / scaleY;
                    else if (sel.bottom > panel.bottom) this.list.scrollTop += (sel.bottom - panel.bottom) / scaleY;
                }
            });
        } else if (this.selectedIndex < 0) this.list.removeAttribute("aria-activedescendant");
        if (needsSync) this.sync();
    }
    sync() {
        let domPos = this.list.firstChild;
        function rm() {
            let prev = domPos;
            domPos = prev.nextSibling;
            prev.remove();
        }
        for (let item of this.items)if (item.dom.parentNode == this.list) {
            while(domPos != item.dom)rm();
            domPos = item.dom.nextSibling;
        } else this.list.insertBefore(item.dom, domPos);
        while(domPos)rm();
    }
    moveSelection(selectedIndex) {
        if (this.selectedIndex < 0) return;
        let field = this.view.state.field($1e126942d86629f6$var$lintState);
        let selection = $1e126942d86629f6$var$findDiagnostic(field.diagnostics, this.items[selectedIndex].diagnostic);
        if (!selection) return;
        this.view.dispatch({
            selection: {
                anchor: selection.from,
                head: selection.to
            },
            scrollIntoView: true,
            effects: $1e126942d86629f6$var$movePanelSelection.of(selection)
        });
    }
    static open(view) {
        return new $1e126942d86629f6$var$LintPanel(view);
    }
}
function $1e126942d86629f6$var$svg(content, attrs = `viewBox="0 0 40 40"`) {
    return `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" ${attrs}>${encodeURIComponent(content)}</svg>')`;
}
function $1e126942d86629f6$var$underline(color) {
    return $1e126942d86629f6$var$svg(`<path d="m0 2.5 l2 -1.5 l1 0 l2 1.5 l1 0" stroke="${color}" fill="none" stroke-width=".7"/>`, `width="6" height="3"`);
}
const $1e126942d86629f6$var$baseTheme = /*@__PURE__*/ (0, $7beee9608540d2c3$export$eece2fccabbb77c5).baseTheme({
    ".cm-diagnostic": {
        padding: "3px 6px 3px 8px",
        marginLeft: "-1px",
        display: "block",
        whiteSpace: "pre-wrap"
    },
    ".cm-diagnostic-error": {
        borderLeft: "5px solid #d11"
    },
    ".cm-diagnostic-warning": {
        borderLeft: "5px solid orange"
    },
    ".cm-diagnostic-info": {
        borderLeft: "5px solid #999"
    },
    ".cm-diagnostic-hint": {
        borderLeft: "5px solid #66d"
    },
    ".cm-diagnosticAction": {
        font: "inherit",
        border: "none",
        padding: "2px 4px",
        backgroundColor: "#444",
        color: "white",
        borderRadius: "3px",
        marginLeft: "8px",
        cursor: "pointer"
    },
    ".cm-diagnosticSource": {
        fontSize: "70%",
        opacity: .7
    },
    ".cm-lintRange": {
        backgroundPosition: "left bottom",
        backgroundRepeat: "repeat-x",
        paddingBottom: "0.7px"
    },
    ".cm-lintRange-error": {
        backgroundImage: /*@__PURE__*/ $1e126942d86629f6$var$underline("#f11")
    },
    ".cm-lintRange-warning": {
        backgroundImage: /*@__PURE__*/ $1e126942d86629f6$var$underline("orange")
    },
    ".cm-lintRange-info": {
        backgroundImage: /*@__PURE__*/ $1e126942d86629f6$var$underline("#999")
    },
    ".cm-lintRange-hint": {
        backgroundImage: /*@__PURE__*/ $1e126942d86629f6$var$underline("#66d")
    },
    ".cm-lintRange-active": {
        backgroundColor: "#ffdd9980"
    },
    ".cm-tooltip-lint": {
        padding: 0,
        margin: 0
    },
    ".cm-lintPoint": {
        position: "relative",
        "&:after": {
            content: '""',
            position: "absolute",
            bottom: 0,
            left: "-2px",
            borderLeft: "3px solid transparent",
            borderRight: "3px solid transparent",
            borderBottom: "4px solid #d11"
        }
    },
    ".cm-lintPoint-warning": {
        "&:after": {
            borderBottomColor: "orange"
        }
    },
    ".cm-lintPoint-info": {
        "&:after": {
            borderBottomColor: "#999"
        }
    },
    ".cm-lintPoint-hint": {
        "&:after": {
            borderBottomColor: "#66d"
        }
    },
    ".cm-panel.cm-panel-lint": {
        position: "relative",
        "& ul": {
            maxHeight: "100px",
            overflowY: "auto",
            "& [aria-selected]": {
                backgroundColor: "#ddd",
                "& u": {
                    textDecoration: "underline"
                }
            },
            "&:focus [aria-selected]": {
                background_fallback: "#bdf",
                backgroundColor: "Highlight",
                color_fallback: "white",
                color: "HighlightText"
            },
            "& u": {
                textDecoration: "none"
            },
            padding: 0,
            margin: 0
        },
        "& [name=close]": {
            position: "absolute",
            top: "0",
            right: "2px",
            background: "inherit",
            border: "none",
            font: "inherit",
            padding: 0,
            margin: 0
        }
    },
    "&dark .cm-lintRange-active": {
        backgroundColor: "#86714a80"
    },
    "&dark .cm-panel.cm-panel-lint ul": {
        "& [aria-selected]": {
            backgroundColor: "#2e343e"
        }
    }
});
function $1e126942d86629f6$var$severityWeight(sev) {
    return sev == "error" ? 4 : sev == "warning" ? 3 : sev == "info" ? 2 : 1;
}
function $1e126942d86629f6$var$maxSeverity(diagnostics) {
    let sev = "hint", weight = 1;
    for (let d of diagnostics){
        let w = $1e126942d86629f6$var$severityWeight(d.severity);
        if (w > weight) {
            weight = w;
            sev = d.severity;
        }
    }
    return sev;
}
class $1e126942d86629f6$var$LintGutterMarker extends (0, $7beee9608540d2c3$export$591ab4c909549043) {
    constructor(diagnostics){
        super();
        this.diagnostics = diagnostics;
        this.severity = $1e126942d86629f6$var$maxSeverity(diagnostics);
    }
    toDOM(view) {
        let elt = document.createElement("div");
        elt.className = "cm-lint-marker cm-lint-marker-" + this.severity;
        let diagnostics = this.diagnostics;
        let diagnosticsFilter = view.state.facet($1e126942d86629f6$var$lintGutterConfig).tooltipFilter;
        if (diagnosticsFilter) diagnostics = diagnosticsFilter(diagnostics, view.state);
        if (diagnostics.length) elt.onmouseover = ()=>$1e126942d86629f6$var$gutterMarkerMouseOver(view, elt, diagnostics);
        return elt;
    }
}
function $1e126942d86629f6$var$trackHoverOn(view, marker) {
    let mousemove = (event)=>{
        let rect = marker.getBoundingClientRect();
        if (event.clientX > rect.left - 10 /* Hover.Margin */  && event.clientX < rect.right + 10 /* Hover.Margin */  && event.clientY > rect.top - 10 /* Hover.Margin */  && event.clientY < rect.bottom + 10 /* Hover.Margin */ ) return;
        for(let target = event.target; target; target = target.parentNode){
            if (target.nodeType == 1 && target.classList.contains("cm-tooltip-lint")) return;
        }
        window.removeEventListener("mousemove", mousemove);
        if (view.state.field($1e126942d86629f6$var$lintGutterTooltip)) view.dispatch({
            effects: $1e126942d86629f6$var$setLintGutterTooltip.of(null)
        });
    };
    window.addEventListener("mousemove", mousemove);
}
function $1e126942d86629f6$var$gutterMarkerMouseOver(view, marker, diagnostics) {
    function hovered() {
        let line = view.elementAtHeight(marker.getBoundingClientRect().top + 5 - view.documentTop);
        const linePos = view.coordsAtPos(line.from);
        if (linePos) view.dispatch({
            effects: $1e126942d86629f6$var$setLintGutterTooltip.of({
                pos: line.from,
                above: false,
                clip: false,
                create () {
                    return {
                        dom: $1e126942d86629f6$var$diagnosticsTooltip(view, diagnostics),
                        getCoords: ()=>marker.getBoundingClientRect()
                    };
                }
            })
        });
        marker.onmouseout = marker.onmousemove = null;
        $1e126942d86629f6$var$trackHoverOn(view, marker);
    }
    let { hoverTime: hoverTime } = view.state.facet($1e126942d86629f6$var$lintGutterConfig);
    let hoverTimeout = setTimeout(hovered, hoverTime);
    marker.onmouseout = ()=>{
        clearTimeout(hoverTimeout);
        marker.onmouseout = marker.onmousemove = null;
    };
    marker.onmousemove = ()=>{
        clearTimeout(hoverTimeout);
        hoverTimeout = setTimeout(hovered, hoverTime);
    };
}
function $1e126942d86629f6$var$markersForDiagnostics(doc, diagnostics) {
    let byLine = Object.create(null);
    for (let diagnostic of diagnostics){
        let line = doc.lineAt(diagnostic.from);
        (byLine[line.from] || (byLine[line.from] = [])).push(diagnostic);
    }
    let markers = [];
    for(let line in byLine)markers.push(new $1e126942d86629f6$var$LintGutterMarker(byLine[line]).range(+line));
    return (0, $6295c6875f57e3ee$export$34cb5241245008dd).of(markers, true);
}
const $1e126942d86629f6$var$lintGutterExtension = /*@__PURE__*/ (0, $7beee9608540d2c3$export$f2b922cb4a245974)({
    class: "cm-gutter-lint",
    markers: (view)=>view.state.field($1e126942d86629f6$var$lintGutterMarkers),
    widgetMarker: (view, widget, block)=>{
        let diagnostics = [];
        view.state.field($1e126942d86629f6$var$lintGutterMarkers).between(block.from, block.to, (from, to, value)=>{
            if (from > block.from && from < block.to) diagnostics.push(...value.diagnostics);
        });
        return diagnostics.length ? new $1e126942d86629f6$var$LintGutterMarker(diagnostics) : null;
    }
});
const $1e126942d86629f6$var$lintGutterMarkers = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$34381b1ce2130245).define({
    create () {
        return (0, $6295c6875f57e3ee$export$34cb5241245008dd).empty;
    },
    update (markers, tr) {
        markers = markers.map(tr.changes);
        let diagnosticFilter = tr.state.facet($1e126942d86629f6$var$lintGutterConfig).markerFilter;
        for (let effect of tr.effects)if (effect.is($1e126942d86629f6$export$9c7976977981c7bf)) {
            let diagnostics = effect.value;
            if (diagnosticFilter) diagnostics = diagnosticFilter(diagnostics || [], tr.state);
            markers = $1e126942d86629f6$var$markersForDiagnostics(tr.state.doc, diagnostics.slice(0));
        }
        return markers;
    }
});
const $1e126942d86629f6$var$setLintGutterTooltip = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
const $1e126942d86629f6$var$lintGutterTooltip = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$34381b1ce2130245).define({
    create () {
        return null;
    },
    update (tooltip, tr) {
        if (tooltip && tr.docChanged) tooltip = $1e126942d86629f6$var$hideTooltip(tr, tooltip) ? null : {
            ...tooltip,
            pos: tr.changes.mapPos(tooltip.pos)
        };
        return tr.effects.reduce((t, e)=>e.is($1e126942d86629f6$var$setLintGutterTooltip) ? e.value : t, tooltip);
    },
    provide: (field)=>(0, $7beee9608540d2c3$export$dba11b50e1aa3c12).from(field)
});
const $1e126942d86629f6$var$lintGutterTheme = /*@__PURE__*/ (0, $7beee9608540d2c3$export$eece2fccabbb77c5).baseTheme({
    ".cm-gutter-lint": {
        width: "1.4em",
        "& .cm-gutterElement": {
            padding: ".2em"
        }
    },
    ".cm-lint-marker": {
        width: "1em",
        height: "1em"
    },
    ".cm-lint-marker-info": {
        content: /*@__PURE__*/ $1e126942d86629f6$var$svg(`<path fill="#aaf" stroke="#77e" stroke-width="6" stroke-linejoin="round" d="M5 5L35 5L35 35L5 35Z"/>`)
    },
    ".cm-lint-marker-warning": {
        content: /*@__PURE__*/ $1e126942d86629f6$var$svg(`<path fill="#fe8" stroke="#fd7" stroke-width="6" stroke-linejoin="round" d="M20 6L37 35L3 35Z"/>`)
    },
    ".cm-lint-marker-error": {
        content: /*@__PURE__*/ $1e126942d86629f6$var$svg(`<circle cx="20" cy="20" r="15" fill="#f87" stroke="#f43" stroke-width="6"/>`)
    }
});
const $1e126942d86629f6$var$lintHover = /*@__PURE__*/ (0, $7beee9608540d2c3$export$69f8d9e63c4aa884)($1e126942d86629f6$var$lintTooltip, {
    hideOn: $1e126942d86629f6$var$hideTooltip
});
const $1e126942d86629f6$var$lintExtensions = [
    $1e126942d86629f6$var$lintState,
    /*@__PURE__*/ (0, $7beee9608540d2c3$export$eece2fccabbb77c5).decorations.compute([
        $1e126942d86629f6$var$lintState
    ], (state)=>{
        let { selected: selected, panel: panel } = state.field($1e126942d86629f6$var$lintState);
        return !selected || !panel || selected.from == selected.to ? (0, $7beee9608540d2c3$export$10e30b733df217ea).none : (0, $7beee9608540d2c3$export$10e30b733df217ea).set([
            $1e126942d86629f6$var$activeMark.range(selected.from, selected.to)
        ]);
    }),
    $1e126942d86629f6$var$lintHover,
    $1e126942d86629f6$var$baseTheme
];
const $1e126942d86629f6$var$lintGutterConfig = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        return (0, $6295c6875f57e3ee$export$4e19c0b693794a7e)(configs, {
            hoverTime: 300 /* Hover.Time */ ,
            markerFilter: null,
            tooltipFilter: null
        });
    }
});
/**
Returns an extension that installs a gutter showing markers for
each line that has diagnostics, which can be hovered over to see
the diagnostics.
*/ function $1e126942d86629f6$export$3a68dabf7c007d32(config = {}) {
    return [
        $1e126942d86629f6$var$lintGutterConfig.of(config),
        $1e126942d86629f6$var$lintGutterMarkers,
        $1e126942d86629f6$var$lintGutterExtension,
        $1e126942d86629f6$var$lintGutterTheme,
        $1e126942d86629f6$var$lintGutterTooltip
    ];
}
/**
Iterate over the marked diagnostics for the given editor state,
calling `f` for each of them. Note that, if the document changed
since the diagnostics were created, the `Diagnostic` object will
hold the original outdated position, whereas the `to` and `from`
arguments hold the diagnostic's current position.
*/ function $1e126942d86629f6$export$7991d57589868fb2(state, f) {
    let lState = state.field($1e126942d86629f6$var$lintState, false);
    if (lState && lState.diagnostics.size) {
        let pending = [], pendingStart = [], lastEnd = -1;
        for(let iter = (0, $6295c6875f57e3ee$export$34cb5241245008dd).iter([
            lState.diagnostics
        ]);; iter.next()){
            for(let i = 0; i < pending.length; i++)if (!iter.value || iter.value.spec.diagnostics.indexOf(pending[i]) < 0) {
                f(pending[i], pendingStart[i], lastEnd);
                pending.splice(i, 1);
                pendingStart.splice(i--, 1);
            }
            if (!iter.value) break;
            for (let d of iter.value.spec.diagnostics)if (pending.indexOf(d) < 0) {
                pending.push(d);
                pendingStart.push(iter.from);
            }
            lastEnd = iter.to;
        }
    }
}


var $4eff9f346d033132$export$f4f2465c1e83499c = function basicSetup(options) {
    if (options === void 0) options = {};
    var _options = options, _options$crosshairCur = _options.crosshairCursor, initCrosshairCursor = _options$crosshairCur === void 0 ? false : _options$crosshairCur;
    var keymaps = [];
    if (options.closeBracketsKeymap !== false) keymaps = keymaps.concat((0, $7570a9a1a9679713$export$9477e95792b48f4a));
    if (options.defaultKeymap !== false) keymaps = keymaps.concat((0, $032754016b6293d7$export$ab2e8d0ac5d2b69e));
    if (options.searchKeymap !== false) keymaps = keymaps.concat((0, $976a3faeb93466fd$export$2dba96787cbe0a4a));
    if (options.historyKeymap !== false) keymaps = keymaps.concat((0, $032754016b6293d7$export$ab4a28cb63e8a670));
    if (options.foldKeymap !== false) keymaps = keymaps.concat((0, $a97ccac5cf5f4f5d$export$39c52376a8936d67));
    if (options.completionKeymap !== false) keymaps = keymaps.concat((0, $7570a9a1a9679713$export$2a3d759d156afab4));
    if (options.lintKeymap !== false) keymaps = keymaps.concat((0, $1e126942d86629f6$export$a21d7a0cde3cbb60));
    var extensions = [];
    if (options.lineNumbers !== false) extensions.push((0, $7beee9608540d2c3$export$1a8cf111682eaa7d)());
    if (options.highlightActiveLineGutter !== false) extensions.push((0, $7beee9608540d2c3$export$93b52f08bb2c759c)());
    if (options.highlightSpecialChars !== false) extensions.push((0, $7beee9608540d2c3$export$76dc0899547f659c)());
    if (options.history !== false) extensions.push((0, $032754016b6293d7$export$55abd4691b317664)());
    if (options.foldGutter !== false) extensions.push((0, $a97ccac5cf5f4f5d$export$c4dcf64f741b6228)());
    if (options.drawSelection !== false) extensions.push((0, $7beee9608540d2c3$export$17a3d0ab3687347d)());
    if (options.dropCursor !== false) extensions.push((0, $7beee9608540d2c3$export$b8e3092a3bfa2062)());
    if (options.allowMultipleSelections !== false) extensions.push((0, $6295c6875f57e3ee$export$afa855cbfaff27f2).allowMultipleSelections.of(true));
    if (options.indentOnInput !== false) extensions.push((0, $a97ccac5cf5f4f5d$export$9bcaf6e2125ee117)());
    if (options.syntaxHighlighting !== false) extensions.push((0, $a97ccac5cf5f4f5d$export$ec1b956ff3a16361)((0, $a97ccac5cf5f4f5d$export$bb02a6818dd48320), {
        fallback: true
    }));
    if (options.bracketMatching !== false) extensions.push((0, $a97ccac5cf5f4f5d$export$cef7edfd214be605)());
    if (options.closeBrackets !== false) extensions.push((0, $7570a9a1a9679713$export$69e4e9d3300ff824)());
    if (options.autocompletion !== false) extensions.push((0, $7570a9a1a9679713$export$f95786d390465556)());
    if (options.rectangularSelection !== false) extensions.push((0, $7beee9608540d2c3$export$dd482925db1aabd3)());
    if (initCrosshairCursor !== false) extensions.push((0, $7beee9608540d2c3$export$9b6525222ac3b7fb)());
    if (options.highlightActiveLine !== false) extensions.push((0, $7beee9608540d2c3$export$1a7e096bee9035c)());
    if (options.highlightSelectionMatches !== false) extensions.push((0, $976a3faeb93466fd$export$f14efe56171a2e02)());
    if (options.tabSize && typeof options.tabSize === 'number') extensions.push((0, $a97ccac5cf5f4f5d$export$9e0d0c2ce4d3ceb5).of(' '.repeat(options.tabSize)));
    return extensions.concat([
        (0, $7beee9608540d2c3$export$5043418e2ef368d5).of(keymaps.flat())
    ]).filter(Boolean);
};
var $4eff9f346d033132$export$def279f8e103ce59 = function minimalSetup(options) {
    if (options === void 0) options = {};
    var keymaps = [];
    if (options.defaultKeymap !== false) keymaps = keymaps.concat((0, $032754016b6293d7$export$ab2e8d0ac5d2b69e));
    if (options.historyKeymap !== false) keymaps = keymaps.concat((0, $032754016b6293d7$export$ab4a28cb63e8a670));
    var extensions = [];
    if (options.highlightSpecialChars !== false) extensions.push((0, $7beee9608540d2c3$export$76dc0899547f659c)());
    if (options.history !== false) extensions.push((0, $032754016b6293d7$export$55abd4691b317664)());
    if (options.drawSelection !== false) extensions.push((0, $7beee9608540d2c3$export$17a3d0ab3687347d)());
    if (options.syntaxHighlighting !== false) extensions.push((0, $a97ccac5cf5f4f5d$export$ec1b956ff3a16361)((0, $a97ccac5cf5f4f5d$export$bb02a6818dd48320), {
        fallback: true
    }));
    return extensions.concat([
        (0, $7beee9608540d2c3$export$5043418e2ef368d5).of(keymaps.flat())
    ]).filter(Boolean);
};






// Using https://github.com/one-dark/vscode-one-dark-theme/ as reference for the colors
const $467f030ca1673efa$var$chalky = "#e5c07b", $467f030ca1673efa$var$coral = "#e06c75", $467f030ca1673efa$var$cyan = "#56b6c2", $467f030ca1673efa$var$invalid = "#ffffff", $467f030ca1673efa$var$ivory = "#abb2bf", $467f030ca1673efa$var$stone = "#7d8799", $467f030ca1673efa$var$malibu = "#61afef", $467f030ca1673efa$var$sage = "#98c379", $467f030ca1673efa$var$whiskey = "#d19a66", $467f030ca1673efa$var$violet = "#c678dd", $467f030ca1673efa$var$darkBackground = "#21252b", $467f030ca1673efa$var$highlightBackground = "#2c313a", $467f030ca1673efa$var$background = "#282c34", $467f030ca1673efa$var$tooltipBackground = "#353a42", $467f030ca1673efa$var$selection = "#3E4451", $467f030ca1673efa$var$cursor = "#528bff";
/**
The colors used in the theme, as CSS color strings.
*/ const $467f030ca1673efa$export$35e9368ef982300f = {
    chalky: $467f030ca1673efa$var$chalky,
    coral: $467f030ca1673efa$var$coral,
    cyan: $467f030ca1673efa$var$cyan,
    invalid: $467f030ca1673efa$var$invalid,
    ivory: $467f030ca1673efa$var$ivory,
    stone: $467f030ca1673efa$var$stone,
    malibu: $467f030ca1673efa$var$malibu,
    sage: $467f030ca1673efa$var$sage,
    whiskey: $467f030ca1673efa$var$whiskey,
    violet: $467f030ca1673efa$var$violet,
    darkBackground: $467f030ca1673efa$var$darkBackground,
    highlightBackground: $467f030ca1673efa$var$highlightBackground,
    background: $467f030ca1673efa$var$background,
    tooltipBackground: $467f030ca1673efa$var$tooltipBackground,
    selection: $467f030ca1673efa$var$selection,
    cursor: $467f030ca1673efa$var$cursor
};
/**
The editor theme styles for One Dark.
*/ const $467f030ca1673efa$export$71837134942a888d = /*@__PURE__*/ (0, $7beee9608540d2c3$export$eece2fccabbb77c5).theme({
    "&": {
        color: $467f030ca1673efa$var$ivory,
        backgroundColor: $467f030ca1673efa$var$background
    },
    ".cm-content": {
        caretColor: $467f030ca1673efa$var$cursor
    },
    ".cm-cursor, .cm-dropCursor": {
        borderLeftColor: $467f030ca1673efa$var$cursor
    },
    "&.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground, .cm-selectionBackground, .cm-content ::selection": {
        backgroundColor: $467f030ca1673efa$var$selection
    },
    ".cm-panels": {
        backgroundColor: $467f030ca1673efa$var$darkBackground,
        color: $467f030ca1673efa$var$ivory
    },
    ".cm-panels.cm-panels-top": {
        borderBottom: "2px solid black"
    },
    ".cm-panels.cm-panels-bottom": {
        borderTop: "2px solid black"
    },
    ".cm-searchMatch": {
        backgroundColor: "#72a1ff59",
        outline: "1px solid #457dff"
    },
    ".cm-searchMatch.cm-searchMatch-selected": {
        backgroundColor: "#6199ff2f"
    },
    ".cm-activeLine": {
        backgroundColor: "#6699ff0b"
    },
    ".cm-selectionMatch": {
        backgroundColor: "#aafe661a"
    },
    "&.cm-focused .cm-matchingBracket, &.cm-focused .cm-nonmatchingBracket": {
        backgroundColor: "#bad0f847"
    },
    ".cm-gutters": {
        backgroundColor: $467f030ca1673efa$var$background,
        color: $467f030ca1673efa$var$stone,
        border: "none"
    },
    ".cm-activeLineGutter": {
        backgroundColor: $467f030ca1673efa$var$highlightBackground
    },
    ".cm-foldPlaceholder": {
        backgroundColor: "transparent",
        border: "none",
        color: "#ddd"
    },
    ".cm-tooltip": {
        border: "none",
        backgroundColor: $467f030ca1673efa$var$tooltipBackground
    },
    ".cm-tooltip .cm-tooltip-arrow:before": {
        borderTopColor: "transparent",
        borderBottomColor: "transparent"
    },
    ".cm-tooltip .cm-tooltip-arrow:after": {
        borderTopColor: $467f030ca1673efa$var$tooltipBackground,
        borderBottomColor: $467f030ca1673efa$var$tooltipBackground
    },
    ".cm-tooltip-autocomplete": {
        "& > ul > li[aria-selected]": {
            backgroundColor: $467f030ca1673efa$var$highlightBackground,
            color: $467f030ca1673efa$var$ivory
        }
    }
}, {
    dark: true
});
/**
The highlighting style for code in the One Dark theme.
*/ const $467f030ca1673efa$export$e74990644b6794ed = /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$4819f093bdd5b4a).define([
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).keyword,
        color: $467f030ca1673efa$var$violet
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).name,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).deleted,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).character,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).propertyName,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).macroName
        ],
        color: $467f030ca1673efa$var$coral
    },
    {
        tag: [
            /*@__PURE__*/ (0, $a1ec9d683d365521$export$8b7a896ae75accbf).function((0, $a1ec9d683d365521$export$8b7a896ae75accbf).variableName),
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).labelName
        ],
        color: $467f030ca1673efa$var$malibu
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).color,
            /*@__PURE__*/ (0, $a1ec9d683d365521$export$8b7a896ae75accbf).constant((0, $a1ec9d683d365521$export$8b7a896ae75accbf).name),
            /*@__PURE__*/ (0, $a1ec9d683d365521$export$8b7a896ae75accbf).standard((0, $a1ec9d683d365521$export$8b7a896ae75accbf).name)
        ],
        color: $467f030ca1673efa$var$whiskey
    },
    {
        tag: [
            /*@__PURE__*/ (0, $a1ec9d683d365521$export$8b7a896ae75accbf).definition((0, $a1ec9d683d365521$export$8b7a896ae75accbf).name),
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).separator
        ],
        color: $467f030ca1673efa$var$ivory
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).typeName,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).className,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).number,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).changed,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).annotation,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).modifier,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).self,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).namespace
        ],
        color: $467f030ca1673efa$var$chalky
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).operator,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).operatorKeyword,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).url,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).escape,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).regexp,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).link,
            /*@__PURE__*/ (0, $a1ec9d683d365521$export$8b7a896ae75accbf).special((0, $a1ec9d683d365521$export$8b7a896ae75accbf).string)
        ],
        color: $467f030ca1673efa$var$cyan
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).meta,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).comment
        ],
        color: $467f030ca1673efa$var$stone
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).strong,
        fontWeight: "bold"
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).emphasis,
        fontStyle: "italic"
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).strikethrough,
        textDecoration: "line-through"
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).link,
        color: $467f030ca1673efa$var$stone,
        textDecoration: "underline"
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).heading,
        fontWeight: "bold",
        color: $467f030ca1673efa$var$coral
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).atom,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).bool,
            /*@__PURE__*/ (0, $a1ec9d683d365521$export$8b7a896ae75accbf).special((0, $a1ec9d683d365521$export$8b7a896ae75accbf).variableName)
        ],
        color: $467f030ca1673efa$var$whiskey
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).processingInstruction,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).string,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).inserted
        ],
        color: $467f030ca1673efa$var$sage
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).invalid,
        color: $467f030ca1673efa$var$invalid
    }
]);
/**
Extension to enable the One Dark theme (both the editor theme and
the highlight style).
*/ const $467f030ca1673efa$export$97539a48bdf87cbf = [
    $467f030ca1673efa$export$71837134942a888d,
    /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$ec1b956ff3a16361)($467f030ca1673efa$export$e74990644b6794ed)
];




var $8a00d1f38586aebb$export$5c0bff399ffe03b = (0, $7beee9608540d2c3$export$eece2fccabbb77c5).theme({
    '&': {
        backgroundColor: '#fff'
    }
}, {
    dark: false
});


var $e1be4b6b4d37a0a2$export$8c6170ff4f7af97d = function getDefaultExtensions(optios) {
    if (optios === void 0) optios = {};
    var _optios = optios, _optios$indentWithTab = _optios.indentWithTab, defaultIndentWithTab = _optios$indentWithTab === void 0 ? true : _optios$indentWithTab, _optios$editable = _optios.editable, editable = _optios$editable === void 0 ? true : _optios$editable, _optios$readOnly = _optios.readOnly, readOnly = _optios$readOnly === void 0 ? false : _optios$readOnly, _optios$theme = _optios.theme, theme = _optios$theme === void 0 ? 'light' : _optios$theme, _optios$placeholder = _optios.placeholder, placeholderStr = _optios$placeholder === void 0 ? '' : _optios$placeholder, _optios$basicSetup = _optios.basicSetup, defaultBasicSetup = _optios$basicSetup === void 0 ? true : _optios$basicSetup;
    var getExtensions = [];
    if (defaultIndentWithTab) getExtensions.unshift((0, $7beee9608540d2c3$export$5043418e2ef368d5).of([
        (0, $032754016b6293d7$export$893b77570f8af4da)
    ]));
    if (defaultBasicSetup) {
        if (typeof defaultBasicSetup === 'boolean') getExtensions.unshift((0, $4eff9f346d033132$export$f4f2465c1e83499c)());
        else getExtensions.unshift((0, $4eff9f346d033132$export$f4f2465c1e83499c)(defaultBasicSetup));
    }
    if (placeholderStr) getExtensions.unshift((0, $7beee9608540d2c3$export$c7187bbd1a7a9244)(placeholderStr));
    switch(theme){
        case 'light':
            getExtensions.push((0, $8a00d1f38586aebb$export$5c0bff399ffe03b));
            break;
        case 'dark':
            getExtensions.push((0, $467f030ca1673efa$export$97539a48bdf87cbf));
            break;
        case 'none':
            break;
        default:
            getExtensions.push(theme);
            break;
    }
    if (editable === false) getExtensions.push((0, $7beee9608540d2c3$export$eece2fccabbb77c5).editable.of(false));
    if (readOnly) getExtensions.push((0, $6295c6875f57e3ee$export$afa855cbfaff27f2).readOnly.of(true));
    return [
        ...getExtensions
    ];
};


var $aa886e06174c9e1a$export$115663dc807a2e95 = (view)=>{
    return {
        line: view.state.doc.lineAt(view.state.selection.main.from),
        lineCount: view.state.doc.lines,
        lineBreak: view.state.lineBreak,
        length: view.state.doc.length,
        readOnly: view.state.readOnly,
        tabSize: view.state.tabSize,
        selection: view.state.selection,
        selectionAsSingle: view.state.selection.asSingle().main,
        ranges: view.state.selection.ranges,
        selectionCode: view.state.sliceDoc(view.state.selection.main.from, view.state.selection.main.to),
        selections: view.state.selection.ranges.map((r)=>view.state.sliceDoc(r.from, r.to)),
        selectedText: view.state.selection.ranges.some((r)=>!r.empty)
    };
};


// Setting / Unsetting timeouts for every keystroke was a significant overhead
// Inspired from https://github.com/iostreamer-X/timeout-latch
class $53f85d91c0d08bfd$export$2d12d9c467a84f85 {
    constructor(callback, timeoutMS){
        this.timeLeftMS = void 0;
        this.timeoutMS = void 0;
        this.isCancelled = false;
        this.isTimeExhausted = false;
        this.callbacks = [];
        this.timeLeftMS = timeoutMS;
        this.timeoutMS = timeoutMS;
        this.callbacks.push(callback);
    }
    tick() {
        if (!this.isCancelled && !this.isTimeExhausted) {
            this.timeLeftMS--;
            if (this.timeLeftMS <= 0) {
                this.isTimeExhausted = true;
                var callbacks = this.callbacks.slice();
                this.callbacks.length = 0;
                callbacks.forEach((callback)=>{
                    try {
                        callback();
                    } catch (error) {
                        console.error('TimeoutLatch callback error:', error);
                    }
                });
            }
        }
    }
    cancel() {
        this.isCancelled = true;
        this.callbacks.length = 0;
    }
    reset() {
        this.timeLeftMS = this.timeoutMS;
        this.isCancelled = false;
        this.isTimeExhausted = false;
    }
    get isDone() {
        return this.isCancelled || this.isTimeExhausted;
    }
}
class $53f85d91c0d08bfd$var$Scheduler {
    constructor(){
        this.interval = null;
        this.latches = new Set();
    }
    add(latch) {
        this.latches.add(latch);
        this.start();
    }
    remove(latch) {
        this.latches.delete(latch);
        if (this.latches.size === 0) this.stop();
    }
    start() {
        if (this.interval === null) this.interval = setInterval(()=>{
            this.latches.forEach((latch)=>{
                latch.tick();
                if (latch.isDone) this.remove(latch);
            });
        }, 1);
    }
    stop() {
        if (this.interval !== null) {
            clearInterval(this.interval);
            this.interval = null;
        }
    }
}
var $53f85d91c0d08bfd$var$globalScheduler = null;
var $53f85d91c0d08bfd$export$5cff7ac265db316a = ()=>{
    if (typeof window === 'undefined') return new $53f85d91c0d08bfd$var$Scheduler();
    if (!$53f85d91c0d08bfd$var$globalScheduler) $53f85d91c0d08bfd$var$globalScheduler = new $53f85d91c0d08bfd$var$Scheduler();
    return $53f85d91c0d08bfd$var$globalScheduler;
};


var $e7c12a755349ccc2$export$45aeca172c9785ae = (0, $6295c6875f57e3ee$export$9279461326b8700a).define();
var $e7c12a755349ccc2$var$TYPING_TIMOUT = 200; // ms
var $e7c12a755349ccc2$var$emptyExtensions = [];
function $e7c12a755349ccc2$export$6b2608dbc019b23d(props) {
    var value = props.value, selection = props.selection, onChange = props.onChange, onStatistics = props.onStatistics, onCreateEditor = props.onCreateEditor, onUpdate = props.onUpdate, _props$extensions = props.extensions, extensions = _props$extensions === void 0 ? $e7c12a755349ccc2$var$emptyExtensions : _props$extensions, autoFocus = props.autoFocus, _props$theme = props.theme, theme = _props$theme === void 0 ? 'light' : _props$theme, _props$height = props.height, height = _props$height === void 0 ? null : _props$height, _props$minHeight = props.minHeight, minHeight = _props$minHeight === void 0 ? null : _props$minHeight, _props$maxHeight = props.maxHeight, maxHeight = _props$maxHeight === void 0 ? null : _props$maxHeight, _props$width = props.width, width = _props$width === void 0 ? null : _props$width, _props$minWidth = props.minWidth, minWidth = _props$minWidth === void 0 ? null : _props$minWidth, _props$maxWidth = props.maxWidth, maxWidth = _props$maxWidth === void 0 ? null : _props$maxWidth, _props$placeholder = props.placeholder, placeholderStr = _props$placeholder === void 0 ? '' : _props$placeholder, _props$editable = props.editable, editable = _props$editable === void 0 ? true : _props$editable, _props$readOnly = props.readOnly, readOnly = _props$readOnly === void 0 ? false : _props$readOnly, _props$indentWithTab = props.indentWithTab, defaultIndentWithTab = _props$indentWithTab === void 0 ? true : _props$indentWithTab, _props$basicSetup = props.basicSetup, defaultBasicSetup = _props$basicSetup === void 0 ? true : _props$basicSetup, root = props.root, initialState = props.initialState;
    var _useState = (0, $acw62.useState)(), container = _useState[0], setContainer = _useState[1];
    var _useState2 = (0, $acw62.useState)(), view = _useState2[0], setView = _useState2[1];
    var _useState3 = (0, $acw62.useState)(), state = _useState3[0], setState = _useState3[1];
    var typingLatch = (0, $acw62.useState)(()=>({
            current: null
        }))[0];
    var pendingUpdate = (0, $acw62.useState)(()=>({
            current: null
        }))[0];
    var defaultThemeOption = (0, $7beee9608540d2c3$export$eece2fccabbb77c5).theme({
        '&': {
            height: height,
            minHeight: minHeight,
            maxHeight: maxHeight,
            width: width,
            minWidth: minWidth,
            maxWidth: maxWidth
        },
        '& .cm-scroller': {
            height: '100% !important'
        }
    });
    var updateListener = (0, $7beee9608540d2c3$export$eece2fccabbb77c5).updateListener.of((vu)=>{
        if (vu.docChanged && typeof onChange === 'function' && // Fix echoing of the remote changes:
        // If transaction is market as remote we don't have to call `onChange` handler again
        !vu.transactions.some((tr)=>tr.annotation($e7c12a755349ccc2$export$45aeca172c9785ae))) {
            if (typingLatch.current) typingLatch.current.reset();
            else {
                typingLatch.current = new (0, $53f85d91c0d08bfd$export$2d12d9c467a84f85)(()=>{
                    if (pendingUpdate.current) {
                        var forceUpdate = pendingUpdate.current;
                        pendingUpdate.current = null;
                        forceUpdate();
                    }
                    typingLatch.current = null;
                }, $e7c12a755349ccc2$var$TYPING_TIMOUT);
                (0, $53f85d91c0d08bfd$export$5cff7ac265db316a)().add(typingLatch.current);
            }
            var doc = vu.state.doc;
            var _value = doc.toString();
            onChange(_value, vu);
        }
        onStatistics && onStatistics((0, $aa886e06174c9e1a$export$115663dc807a2e95)(vu));
    });
    var defaultExtensions = (0, $e1be4b6b4d37a0a2$export$8c6170ff4f7af97d)({
        theme: theme,
        editable: editable,
        readOnly: readOnly,
        placeholder: placeholderStr,
        indentWithTab: defaultIndentWithTab,
        basicSetup: defaultBasicSetup
    });
    var getExtensions = [
        updateListener,
        defaultThemeOption,
        ...defaultExtensions
    ];
    if (onUpdate && typeof onUpdate === 'function') getExtensions.push((0, $7beee9608540d2c3$export$eece2fccabbb77c5).updateListener.of(onUpdate));
    getExtensions = getExtensions.concat(extensions);
    (0, $acw62.useLayoutEffect)(()=>{
        if (container && !state) {
            var config = {
                doc: value,
                selection: selection,
                extensions: getExtensions
            };
            var stateCurrent = initialState ? (0, $6295c6875f57e3ee$export$afa855cbfaff27f2).fromJSON(initialState.json, config, initialState.fields) : (0, $6295c6875f57e3ee$export$afa855cbfaff27f2).create(config);
            setState(stateCurrent);
            if (!view) {
                var viewCurrent = new (0, $7beee9608540d2c3$export$eece2fccabbb77c5)({
                    state: stateCurrent,
                    parent: container,
                    root: root
                });
                setView(viewCurrent);
                onCreateEditor && onCreateEditor(viewCurrent, stateCurrent);
            }
        }
        return ()=>{
            if (view) {
                setState(undefined);
                setView(undefined);
            }
        };
    }, [
        container,
        state
    ]);
    (0, $acw62.useEffect)(()=>{
        if (props.container) setContainer(props.container);
    }, [
        props.container
    ]);
    (0, $acw62.useEffect)(()=>()=>{
            if (view) {
                view.destroy();
                setView(undefined);
            }
            if (typingLatch.current) {
                typingLatch.current.cancel();
                typingLatch.current = null;
            }
        }, [
        view
    ]);
    (0, $acw62.useEffect)(()=>{
        if (autoFocus && view) view.focus();
    }, [
        autoFocus,
        view
    ]);
    (0, $acw62.useEffect)(()=>{
        if (view) view.dispatch({
            effects: (0, $6295c6875f57e3ee$export$95000d4efaa4321f).reconfigure.of(getExtensions)
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        theme,
        extensions,
        height,
        minHeight,
        maxHeight,
        width,
        minWidth,
        maxWidth,
        placeholderStr,
        editable,
        readOnly,
        defaultIndentWithTab,
        defaultBasicSetup,
        onChange,
        onUpdate
    ]);
    (0, $acw62.useEffect)(()=>{
        if (value === undefined) return;
        var currentValue = view ? view.state.doc.toString() : '';
        if (view && value !== currentValue) {
            var isTyping = typingLatch.current && !typingLatch.current.isDone;
            var forceUpdate = ()=>{
                if (view && value !== view.state.doc.toString()) view.dispatch({
                    changes: {
                        from: 0,
                        to: view.state.doc.toString().length,
                        insert: value || ''
                    },
                    annotations: [
                        $e7c12a755349ccc2$export$45aeca172c9785ae.of(true)
                    ]
                });
            };
            if (!isTyping) forceUpdate();
            else pendingUpdate.current = forceUpdate;
        }
    }, [
        value,
        view
    ]);
    return {
        state: state,
        setState: setState,
        view: view,
        setView: setView,
        container: container,
        setContainer: setContainer
    };
}



var $ayMG0 = parcelRequire("ayMG0");





var $269cb9ebbcb83755$var$_excluded = [
    "className",
    "value",
    "selection",
    "extensions",
    "onChange",
    "onStatistics",
    "onCreateEditor",
    "onUpdate",
    "autoFocus",
    "theme",
    "height",
    "minHeight",
    "maxHeight",
    "width",
    "minWidth",
    "maxWidth",
    "basicSetup",
    "placeholder",
    "indentWithTab",
    "editable",
    "readOnly",
    "root",
    "initialState"
];
var $269cb9ebbcb83755$var$ReactCodeMirror = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    var className = props.className, _props$value = props.value, value = _props$value === void 0 ? '' : _props$value, selection = props.selection, _props$extensions = props.extensions, extensions = _props$extensions === void 0 ? [] : _props$extensions, onChange = props.onChange, onStatistics = props.onStatistics, onCreateEditor = props.onCreateEditor, onUpdate = props.onUpdate, autoFocus = props.autoFocus, _props$theme = props.theme, theme = _props$theme === void 0 ? 'light' : _props$theme, height = props.height, minHeight = props.minHeight, maxHeight = props.maxHeight, width = props.width, minWidth = props.minWidth, maxWidth = props.maxWidth, basicSetup = props.basicSetup, placeholder = props.placeholder, indentWithTab = props.indentWithTab, editable = props.editable, readOnly = props.readOnly, root = props.root, initialState = props.initialState, other = (0, (/*@__PURE__*/$parcel$interopDefault($c05no)))(props, $269cb9ebbcb83755$var$_excluded);
    var editor = (0, $acw62.useRef)(null);
    var _useCodeMirror = (0, $e7c12a755349ccc2$export$6b2608dbc019b23d)({
        root: root,
        value: value,
        autoFocus: autoFocus,
        theme: theme,
        height: height,
        minHeight: minHeight,
        maxHeight: maxHeight,
        width: width,
        minWidth: minWidth,
        maxWidth: maxWidth,
        basicSetup: basicSetup,
        placeholder: placeholder,
        indentWithTab: indentWithTab,
        editable: editable,
        readOnly: readOnly,
        selection: selection,
        onChange: onChange,
        onStatistics: onStatistics,
        onCreateEditor: onCreateEditor,
        onUpdate: onUpdate,
        extensions: extensions,
        initialState: initialState
    }), state = _useCodeMirror.state, view = _useCodeMirror.view, container = _useCodeMirror.container, setContainer = _useCodeMirror.setContainer;
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            editor: editor.current,
            state: state,
            view: view
        }), [
        editor,
        container,
        state,
        view
    ]);
    var setEditorRef = (0, $acw62.useCallback)((el)=>{
        editor.current = el;
        setContainer(el);
    }, [
        setContainer
    ]);
    // check type of value
    if (typeof value !== 'string') throw new Error("value must be typeof string but got " + typeof value);
    var defaultClassNames = typeof theme === 'string' ? "cm-theme-" + theme : 'cm-theme';
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        ref: setEditorRef,
        className: "" + defaultClassNames + (className ? " " + className : '')
    }, other));
});
$269cb9ebbcb83755$var$ReactCodeMirror.displayName = 'CodeMirror';
var $269cb9ebbcb83755$export$2e2bcd8739ae039 = $269cb9ebbcb83755$var$ReactCodeMirror;



/**
A parse stack. These are used internally by the parser to track
parsing progress. They also provide some properties and methods
that external code such as a tokenizer can use to get information
about the parse state.
*/ class $96e8fc72168067c5$export$694e0d28c7ffc90c {
    /**
    @internal
    */ constructor(/**
    The parse that this stack is part of @internal
    */ p, /**
    Holds state, input pos, buffer index triplets for all but the
    top state @internal
    */ stack, /**
    The current parse state @internal
    */ state, // The position at which the next reduce should take place. This
    // can be less than `this.pos` when skipped expressions have been
    // added to the stack (which should be moved outside of the next
    // reduction)
    /**
    @internal
    */ reducePos, /**
    The input position up to which this stack has parsed.
    */ pos, /**
    The dynamic score of the stack, including dynamic precedence
    and error-recovery penalties
    @internal
    */ score, // The output buffer. Holds (type, start, end, size) quads
    // representing nodes created by the parser, where `size` is
    // amount of buffer array entries covered by this node.
    /**
    @internal
    */ buffer, // The base offset of the buffer. When stacks are split, the split
    // instance shared the buffer history with its parent up to
    // `bufferBase`, which is the absolute offset (including the
    // offset of previous splits) into the buffer at which this stack
    // starts writing.
    /**
    @internal
    */ bufferBase, /**
    @internal
    */ curContext, /**
    @internal
    */ lookAhead = 0, // A parent stack from which this was split off, if any. This is
    // set up so that it always points to a stack that has some
    // additional buffer content, never to a stack with an equal
    // `bufferBase`.
    /**
    @internal
    */ parent){
        this.p = p;
        this.stack = stack;
        this.state = state;
        this.reducePos = reducePos;
        this.pos = pos;
        this.score = score;
        this.buffer = buffer;
        this.bufferBase = bufferBase;
        this.curContext = curContext;
        this.lookAhead = lookAhead;
        this.parent = parent;
    }
    /**
    @internal
    */ toString() {
        return `[${this.stack.filter((_, i)=>i % 3 == 0).concat(this.state)}]@${this.pos}${this.score ? "!" + this.score : ""}`;
    }
    // Start an empty stack
    /**
    @internal
    */ static start(p, state, pos = 0) {
        let cx = p.parser.context;
        return new $96e8fc72168067c5$export$694e0d28c7ffc90c(p, [], state, pos, pos, 0, [], 0, cx ? new $96e8fc72168067c5$var$StackContext(cx, cx.start) : null, 0, null);
    }
    /**
    The stack's current [context](#lr.ContextTracker) value, if
    any. Its type will depend on the context tracker's type
    parameter, or it will be `null` if there is no context
    tracker.
    */ get context() {
        return this.curContext ? this.curContext.context : null;
    }
    // Push a state onto the stack, tracking its start position as well
    // as the buffer base at that point.
    /**
    @internal
    */ pushState(state, start) {
        this.stack.push(this.state, start, this.bufferBase + this.buffer.length);
        this.state = state;
    }
    // Apply a reduce action
    /**
    @internal
    */ reduce(action) {
        var _a;
        let depth = action >> 19 /* Action.ReduceDepthShift */ , type = action & 65535 /* Action.ValueMask */ ;
        let { parser: parser } = this.p;
        let lookaheadRecord = this.reducePos < this.pos - 25 /* Lookahead.Margin */  && this.setLookAhead(this.pos);
        let dPrec = parser.dynamicPrecedence(type);
        if (dPrec) this.score += dPrec;
        if (depth == 0) {
            this.pushState(parser.getGoto(this.state, type, true), this.reducePos);
            // Zero-depth reductions are a special case—they add stuff to
            // the stack without popping anything off.
            if (type < parser.minRepeatTerm) this.storeNode(type, this.reducePos, this.reducePos, lookaheadRecord ? 8 : 4, true);
            this.reduceContext(type, this.reducePos);
            return;
        }
        // Find the base index into `this.stack`, content after which will
        // be dropped. Note that with `StayFlag` reductions we need to
        // consume two extra frames (the dummy parent node for the skipped
        // expression and the state that we'll be staying in, which should
        // be moved to `this.state`).
        let base = this.stack.length - (depth - 1) * 3 - (action & 262144 /* Action.StayFlag */  ? 6 : 0);
        let start = base ? this.stack[base - 2] : this.p.ranges[0].from, size = this.reducePos - start;
        // This is a kludge to try and detect overly deep left-associative
        // trees, which will not increase the parse stack depth and thus
        // won't be caught by the regular stack-depth limit check.
        if (size >= 2000 /* Recover.MinBigReduction */  && !((_a = this.p.parser.nodeSet.types[type]) === null || _a === void 0 ? void 0 : _a.isAnonymous)) {
            if (start == this.p.lastBigReductionStart) {
                this.p.bigReductionCount++;
                this.p.lastBigReductionSize = size;
            } else if (this.p.lastBigReductionSize < size) {
                this.p.bigReductionCount = 1;
                this.p.lastBigReductionStart = start;
                this.p.lastBigReductionSize = size;
            }
        }
        let bufferBase = base ? this.stack[base - 1] : 0, count = this.bufferBase + this.buffer.length - bufferBase;
        // Store normal terms or `R -> R R` repeat reductions
        if (type < parser.minRepeatTerm || action & 131072 /* Action.RepeatFlag */ ) {
            let pos = parser.stateFlag(this.state, 1 /* StateFlag.Skipped */ ) ? this.pos : this.reducePos;
            this.storeNode(type, start, pos, count + 4, true);
        }
        if (action & 262144 /* Action.StayFlag */ ) this.state = this.stack[base];
        else {
            let baseStateID = this.stack[base - 3];
            this.state = parser.getGoto(baseStateID, type, true);
        }
        while(this.stack.length > base)this.stack.pop();
        this.reduceContext(type, start);
    }
    // Shift a value into the buffer
    /**
    @internal
    */ storeNode(term, start, end, size = 4, mustSink = false) {
        if (term == 0 /* Term.Err */  && (!this.stack.length || this.stack[this.stack.length - 1] < this.buffer.length + this.bufferBase)) {
            // Try to omit/merge adjacent error nodes
            let cur = this, top = this.buffer.length;
            if (top == 0 && cur.parent) {
                top = cur.bufferBase - cur.parent.bufferBase;
                cur = cur.parent;
            }
            if (top > 0 && cur.buffer[top - 4] == 0 /* Term.Err */  && cur.buffer[top - 1] > -1) {
                if (start == end) return;
                if (cur.buffer[top - 2] >= start) {
                    cur.buffer[top - 2] = end;
                    return;
                }
            }
        }
        if (!mustSink || this.pos == end) this.buffer.push(term, start, end, size);
        else {
            let index = this.buffer.length;
            if (index > 0 && (this.buffer[index - 4] != 0 /* Term.Err */  || this.buffer[index - 1] < 0)) {
                let mustMove = false;
                for(let scan = index; scan > 0 && this.buffer[scan - 2] > end; scan -= 4)if (this.buffer[scan - 1] >= 0) {
                    mustMove = true;
                    break;
                }
                if (mustMove) while(index > 0 && this.buffer[index - 2] > end){
                    // Move this record forward
                    this.buffer[index] = this.buffer[index - 4];
                    this.buffer[index + 1] = this.buffer[index - 3];
                    this.buffer[index + 2] = this.buffer[index - 2];
                    this.buffer[index + 3] = this.buffer[index - 1];
                    index -= 4;
                    if (size > 4) size -= 4;
                }
            }
            this.buffer[index] = term;
            this.buffer[index + 1] = start;
            this.buffer[index + 2] = end;
            this.buffer[index + 3] = size;
        }
    }
    // Apply a shift action
    /**
    @internal
    */ shift(action, type, start, end) {
        if (action & 131072 /* Action.GotoFlag */ ) this.pushState(action & 65535 /* Action.ValueMask */ , this.pos);
        else if ((action & 262144 /* Action.StayFlag */ ) == 0) {
            let nextState = action, { parser: parser } = this.p;
            if (end > this.pos || type <= parser.maxNode) {
                this.pos = end;
                if (!parser.stateFlag(nextState, 1 /* StateFlag.Skipped */ )) this.reducePos = end;
            }
            this.pushState(nextState, start);
            this.shiftContext(type, start);
            if (type <= parser.maxNode) this.buffer.push(type, start, end, 4);
        } else {
            this.pos = end;
            this.shiftContext(type, start);
            if (type <= this.p.parser.maxNode) this.buffer.push(type, start, end, 4);
        }
    }
    // Apply an action
    /**
    @internal
    */ apply(action, next, nextStart, nextEnd) {
        if (action & 65536 /* Action.ReduceFlag */ ) this.reduce(action);
        else this.shift(action, next, nextStart, nextEnd);
    }
    // Add a prebuilt (reused) node into the buffer.
    /**
    @internal
    */ useNode(value, next) {
        let index = this.p.reused.length - 1;
        if (index < 0 || this.p.reused[index] != value) {
            this.p.reused.push(value);
            index++;
        }
        let start = this.pos;
        this.reducePos = this.pos = start + value.length;
        this.pushState(next, start);
        this.buffer.push(index, start, this.reducePos, -1 /* size == -1 means this is a reused value */ );
        if (this.curContext) this.updateContext(this.curContext.tracker.reuse(this.curContext.context, value, this, this.p.stream.reset(this.pos - value.length)));
    }
    // Split the stack. Due to the buffer sharing and the fact
    // that `this.stack` tends to stay quite shallow, this isn't very
    // expensive.
    /**
    @internal
    */ split() {
        let parent = this;
        let off = parent.buffer.length;
        // Because the top of the buffer (after this.pos) may be mutated
        // to reorder reductions and skipped tokens, and shared buffers
        // should be immutable, this copies any outstanding skipped tokens
        // to the new buffer, and puts the base pointer before them.
        while(off > 0 && parent.buffer[off - 2] > parent.reducePos)off -= 4;
        let buffer = parent.buffer.slice(off), base = parent.bufferBase + off;
        // Make sure parent points to an actual parent with content, if there is such a parent.
        while(parent && base == parent.bufferBase)parent = parent.parent;
        return new $96e8fc72168067c5$export$694e0d28c7ffc90c(this.p, this.stack.slice(), this.state, this.reducePos, this.pos, this.score, buffer, base, this.curContext, this.lookAhead, parent);
    }
    // Try to recover from an error by 'deleting' (ignoring) one token.
    /**
    @internal
    */ recoverByDelete(next, nextEnd) {
        let isNode = next <= this.p.parser.maxNode;
        if (isNode) this.storeNode(next, this.pos, nextEnd, 4);
        this.storeNode(0 /* Term.Err */ , this.pos, nextEnd, isNode ? 8 : 4);
        this.pos = this.reducePos = nextEnd;
        this.score -= 190 /* Recover.Delete */ ;
    }
    /**
    Check if the given term would be able to be shifted (optionally
    after some reductions) on this stack. This can be useful for
    external tokenizers that want to make sure they only provide a
    given token when it applies.
    */ canShift(term) {
        for(let sim = new $96e8fc72168067c5$var$SimulatedStack(this);;){
            let action = this.p.parser.stateSlot(sim.state, 4 /* ParseState.DefaultReduce */ ) || this.p.parser.hasAction(sim.state, term);
            if (action == 0) return false;
            if ((action & 65536 /* Action.ReduceFlag */ ) == 0) return true;
            sim.reduce(action);
        }
    }
    // Apply up to Recover.MaxNext recovery actions that conceptually
    // inserts some missing token or rule.
    /**
    @internal
    */ recoverByInsert(next) {
        if (this.stack.length >= 300 /* Recover.MaxInsertStackDepth */ ) return [];
        let nextStates = this.p.parser.nextStates(this.state);
        if (nextStates.length > 8 || this.stack.length >= 120 /* Recover.DampenInsertStackDepth */ ) {
            let best = [];
            for(let i = 0, s; i < nextStates.length; i += 2)if ((s = nextStates[i + 1]) != this.state && this.p.parser.hasAction(s, next)) best.push(nextStates[i], s);
            if (this.stack.length < 120 /* Recover.DampenInsertStackDepth */ ) for(let i = 0; best.length < 8 && i < nextStates.length; i += 2){
                let s = nextStates[i + 1];
                if (!best.some((v, i)=>i & 1 && v == s)) best.push(nextStates[i], s);
            }
            nextStates = best;
        }
        let result = [];
        for(let i = 0; i < nextStates.length && result.length < 4 /* Recover.MaxNext */ ; i += 2){
            let s = nextStates[i + 1];
            if (s == this.state) continue;
            let stack = this.split();
            stack.pushState(s, this.pos);
            stack.storeNode(0 /* Term.Err */ , stack.pos, stack.pos, 4, true);
            stack.shiftContext(nextStates[i], this.pos);
            stack.reducePos = this.pos;
            stack.score -= 200 /* Recover.Insert */ ;
            result.push(stack);
        }
        return result;
    }
    // Force a reduce, if possible. Return false if that can't
    // be done.
    /**
    @internal
    */ forceReduce() {
        let { parser: parser } = this.p;
        let reduce = parser.stateSlot(this.state, 5 /* ParseState.ForcedReduce */ );
        if ((reduce & 65536 /* Action.ReduceFlag */ ) == 0) return false;
        if (!parser.validAction(this.state, reduce)) {
            let depth = reduce >> 19 /* Action.ReduceDepthShift */ , term = reduce & 65535 /* Action.ValueMask */ ;
            let target = this.stack.length - depth * 3;
            if (target < 0 || parser.getGoto(this.stack[target], term, false) < 0) {
                let backup = this.findForcedReduction();
                if (backup == null) return false;
                reduce = backup;
            }
            this.storeNode(0 /* Term.Err */ , this.pos, this.pos, 4, true);
            this.score -= 100 /* Recover.Reduce */ ;
        }
        this.reducePos = this.pos;
        this.reduce(reduce);
        return true;
    }
    /**
    Try to scan through the automaton to find some kind of reduction
    that can be applied. Used when the regular ForcedReduce field
    isn't a valid action. @internal
    */ findForcedReduction() {
        let { parser: parser } = this.p, seen = [];
        let explore = (state, depth)=>{
            if (seen.includes(state)) return;
            seen.push(state);
            return parser.allActions(state, (action)=>{
                if (action & 393216 /* Action.GotoFlag */ ) ;
                else if (action & 65536 /* Action.ReduceFlag */ ) {
                    let rDepth = (action >> 19 /* Action.ReduceDepthShift */ ) - depth;
                    if (rDepth > 1) {
                        let term = action & 65535 /* Action.ValueMask */ , target = this.stack.length - rDepth * 3;
                        if (target >= 0 && parser.getGoto(this.stack[target], term, false) >= 0) return rDepth << 19 /* Action.ReduceDepthShift */  | 65536 /* Action.ReduceFlag */  | term;
                    }
                } else {
                    let found = explore(action, depth + 1);
                    if (found != null) return found;
                }
            });
        };
        return explore(this.state, 0);
    }
    /**
    @internal
    */ forceAll() {
        while(!this.p.parser.stateFlag(this.state, 2 /* StateFlag.Accepting */ ))if (!this.forceReduce()) {
            this.storeNode(0 /* Term.Err */ , this.pos, this.pos, 4, true);
            break;
        }
        return this;
    }
    /**
    Check whether this state has no further actions (assumed to be a direct descendant of the
    top state, since any other states must be able to continue
    somehow). @internal
    */ get deadEnd() {
        if (this.stack.length != 3) return false;
        let { parser: parser } = this.p;
        return parser.data[parser.stateSlot(this.state, 1 /* ParseState.Actions */ )] == 65535 /* Seq.End */  && !parser.stateSlot(this.state, 4 /* ParseState.DefaultReduce */ );
    }
    /**
    Restart the stack (put it back in its start state). Only safe
    when this.stack.length == 3 (state is directly below the top
    state). @internal
    */ restart() {
        this.storeNode(0 /* Term.Err */ , this.pos, this.pos, 4, true);
        this.state = this.stack[0];
        this.stack.length = 0;
    }
    /**
    @internal
    */ sameState(other) {
        if (this.state != other.state || this.stack.length != other.stack.length) return false;
        for(let i = 0; i < this.stack.length; i += 3)if (this.stack[i] != other.stack[i]) return false;
        return true;
    }
    /**
    Get the parser used by this stack.
    */ get parser() {
        return this.p.parser;
    }
    /**
    Test whether a given dialect (by numeric ID, as exported from
    the terms file) is enabled.
    */ dialectEnabled(dialectID) {
        return this.p.parser.dialect.flags[dialectID];
    }
    shiftContext(term, start) {
        if (this.curContext) this.updateContext(this.curContext.tracker.shift(this.curContext.context, term, this, this.p.stream.reset(start)));
    }
    reduceContext(term, start) {
        if (this.curContext) this.updateContext(this.curContext.tracker.reduce(this.curContext.context, term, this, this.p.stream.reset(start)));
    }
    /**
    @internal
    */ emitContext() {
        let last = this.buffer.length - 1;
        if (last < 0 || this.buffer[last] != -3) this.buffer.push(this.curContext.hash, this.pos, this.pos, -3);
    }
    /**
    @internal
    */ emitLookAhead() {
        let last = this.buffer.length - 1;
        if (last < 0 || this.buffer[last] != -4) this.buffer.push(this.lookAhead, this.pos, this.pos, -4);
    }
    updateContext(context) {
        if (context != this.curContext.context) {
            let newCx = new $96e8fc72168067c5$var$StackContext(this.curContext.tracker, context);
            if (newCx.hash != this.curContext.hash) this.emitContext();
            this.curContext = newCx;
        }
    }
    /**
    @internal
    */ setLookAhead(lookAhead) {
        if (lookAhead <= this.lookAhead) return false;
        this.emitLookAhead();
        this.lookAhead = lookAhead;
        return true;
    }
    /**
    @internal
    */ close() {
        if (this.curContext && this.curContext.tracker.strict) this.emitContext();
        if (this.lookAhead > 0) this.emitLookAhead();
    }
}
class $96e8fc72168067c5$var$StackContext {
    constructor(tracker, context){
        this.tracker = tracker;
        this.context = context;
        this.hash = tracker.strict ? tracker.hash(context) : 0;
    }
}
// Used to cheaply run some reductions to scan ahead without mutating
// an entire stack
class $96e8fc72168067c5$var$SimulatedStack {
    constructor(start){
        this.start = start;
        this.state = start.state;
        this.stack = start.stack;
        this.base = this.stack.length;
    }
    reduce(action) {
        let term = action & 65535 /* Action.ValueMask */ , depth = action >> 19 /* Action.ReduceDepthShift */ ;
        if (depth == 0) {
            if (this.stack == this.start.stack) this.stack = this.stack.slice();
            this.stack.push(this.state, 0, 0);
            this.base += 3;
        } else this.base -= (depth - 1) * 3;
        let goto = this.start.p.parser.getGoto(this.stack[this.base - 3], term, true);
        this.state = goto;
    }
}
// This is given to `Tree.build` to build a buffer, and encapsulates
// the parent-stack-walking necessary to read the nodes.
class $96e8fc72168067c5$var$StackBufferCursor {
    constructor(stack, pos, index){
        this.stack = stack;
        this.pos = pos;
        this.index = index;
        this.buffer = stack.buffer;
        if (this.index == 0) this.maybeNext();
    }
    static create(stack, pos = stack.bufferBase + stack.buffer.length) {
        return new $96e8fc72168067c5$var$StackBufferCursor(stack, pos, pos - stack.bufferBase);
    }
    maybeNext() {
        let next = this.stack.parent;
        if (next != null) {
            this.index = this.stack.bufferBase - next.bufferBase;
            this.stack = next;
            this.buffer = next.buffer;
        }
    }
    get id() {
        return this.buffer[this.index - 4];
    }
    get start() {
        return this.buffer[this.index - 3];
    }
    get end() {
        return this.buffer[this.index - 2];
    }
    get size() {
        return this.buffer[this.index - 1];
    }
    next() {
        this.index -= 4;
        this.pos -= 4;
        if (this.index == 0) this.maybeNext();
    }
    fork() {
        return new $96e8fc72168067c5$var$StackBufferCursor(this.stack, this.pos, this.index);
    }
}
// See lezer-generator/src/encode.ts for comments about the encoding
// used here
function $96e8fc72168067c5$var$decodeArray(input, Type = Uint16Array) {
    if (typeof input != "string") return input;
    let array = null;
    for(let pos = 0, out = 0; pos < input.length;){
        let value = 0;
        for(;;){
            let next = input.charCodeAt(pos++), stop = false;
            if (next == 126 /* Encode.BigValCode */ ) {
                value = 65535 /* Encode.BigVal */ ;
                break;
            }
            if (next >= 92 /* Encode.Gap2 */ ) next--;
            if (next >= 34 /* Encode.Gap1 */ ) next--;
            let digit = next - 32 /* Encode.Start */ ;
            if (digit >= 46 /* Encode.Base */ ) {
                digit -= 46 /* Encode.Base */ ;
                stop = true;
            }
            value += digit;
            if (stop) break;
            value *= 46 /* Encode.Base */ ;
        }
        if (array) array[out++] = value;
        else array = new Type(value);
    }
    return array;
}
class $96e8fc72168067c5$var$CachedToken {
    constructor(){
        this.start = -1;
        this.value = -1;
        this.end = -1;
        this.extended = -1;
        this.lookAhead = 0;
        this.mask = 0;
        this.context = 0;
    }
}
const $96e8fc72168067c5$var$nullToken = new $96e8fc72168067c5$var$CachedToken;
/**
[Tokenizers](#lr.ExternalTokenizer) interact with the input
through this interface. It presents the input as a stream of
characters, tracking lookahead and hiding the complexity of
[ranges](#common.Parser.parse^ranges) from tokenizer code.
*/ class $96e8fc72168067c5$export$f22294a9362415e4 {
    /**
    @internal
    */ constructor(/**
    @internal
    */ input, /**
    @internal
    */ ranges){
        this.input = input;
        this.ranges = ranges;
        /**
        @internal
        */ this.chunk = "";
        /**
        @internal
        */ this.chunkOff = 0;
        /**
        Backup chunk
        */ this.chunk2 = "";
        this.chunk2Pos = 0;
        /**
        The character code of the next code unit in the input, or -1
        when the stream is at the end of the input.
        */ this.next = -1;
        /**
        @internal
        */ this.token = $96e8fc72168067c5$var$nullToken;
        this.rangeIndex = 0;
        this.pos = this.chunkPos = ranges[0].from;
        this.range = ranges[0];
        this.end = ranges[ranges.length - 1].to;
        this.readNext();
    }
    /**
    @internal
    */ resolveOffset(offset, assoc) {
        let range = this.range, index = this.rangeIndex;
        let pos = this.pos + offset;
        while(pos < range.from){
            if (!index) return null;
            let next = this.ranges[--index];
            pos -= range.from - next.to;
            range = next;
        }
        while(assoc < 0 ? pos > range.to : pos >= range.to){
            if (index == this.ranges.length - 1) return null;
            let next = this.ranges[++index];
            pos += next.from - range.to;
            range = next;
        }
        return pos;
    }
    /**
    @internal
    */ clipPos(pos) {
        if (pos >= this.range.from && pos < this.range.to) return pos;
        for (let range of this.ranges)if (range.to > pos) return Math.max(pos, range.from);
        return this.end;
    }
    /**
    Look at a code unit near the stream position. `.peek(0)` equals
    `.next`, `.peek(-1)` gives you the previous character, and so
    on.
    
    Note that looking around during tokenizing creates dependencies
    on potentially far-away content, which may reduce the
    effectiveness incremental parsing—when looking forward—or even
    cause invalid reparses when looking backward more than 25 code
    units, since the library does not track lookbehind.
    */ peek(offset) {
        let idx = this.chunkOff + offset, pos, result;
        if (idx >= 0 && idx < this.chunk.length) {
            pos = this.pos + offset;
            result = this.chunk.charCodeAt(idx);
        } else {
            let resolved = this.resolveOffset(offset, 1);
            if (resolved == null) return -1;
            pos = resolved;
            if (pos >= this.chunk2Pos && pos < this.chunk2Pos + this.chunk2.length) result = this.chunk2.charCodeAt(pos - this.chunk2Pos);
            else {
                let i = this.rangeIndex, range = this.range;
                while(range.to <= pos)range = this.ranges[++i];
                this.chunk2 = this.input.chunk(this.chunk2Pos = pos);
                if (pos + this.chunk2.length > range.to) this.chunk2 = this.chunk2.slice(0, range.to - pos);
                result = this.chunk2.charCodeAt(0);
            }
        }
        if (pos >= this.token.lookAhead) this.token.lookAhead = pos + 1;
        return result;
    }
    /**
    Accept a token. By default, the end of the token is set to the
    current stream position, but you can pass an offset (relative to
    the stream position) to change that.
    */ acceptToken(token, endOffset = 0) {
        let end = endOffset ? this.resolveOffset(endOffset, -1) : this.pos;
        if (end == null || end < this.token.start) throw new RangeError("Token end out of bounds");
        this.token.value = token;
        this.token.end = end;
    }
    /**
    Accept a token ending at a specific given position.
    */ acceptTokenTo(token, endPos) {
        this.token.value = token;
        this.token.end = endPos;
    }
    getChunk() {
        if (this.pos >= this.chunk2Pos && this.pos < this.chunk2Pos + this.chunk2.length) {
            let { chunk: chunk, chunkPos: chunkPos } = this;
            this.chunk = this.chunk2;
            this.chunkPos = this.chunk2Pos;
            this.chunk2 = chunk;
            this.chunk2Pos = chunkPos;
            this.chunkOff = this.pos - this.chunkPos;
        } else {
            this.chunk2 = this.chunk;
            this.chunk2Pos = this.chunkPos;
            let nextChunk = this.input.chunk(this.pos);
            let end = this.pos + nextChunk.length;
            this.chunk = end > this.range.to ? nextChunk.slice(0, this.range.to - this.pos) : nextChunk;
            this.chunkPos = this.pos;
            this.chunkOff = 0;
        }
    }
    readNext() {
        if (this.chunkOff >= this.chunk.length) {
            this.getChunk();
            if (this.chunkOff == this.chunk.length) return this.next = -1;
        }
        return this.next = this.chunk.charCodeAt(this.chunkOff);
    }
    /**
    Move the stream forward N (defaults to 1) code units. Returns
    the new value of [`next`](#lr.InputStream.next).
    */ advance(n = 1) {
        this.chunkOff += n;
        while(this.pos + n >= this.range.to){
            if (this.rangeIndex == this.ranges.length - 1) return this.setDone();
            n -= this.range.to - this.pos;
            this.range = this.ranges[++this.rangeIndex];
            this.pos = this.range.from;
        }
        this.pos += n;
        if (this.pos >= this.token.lookAhead) this.token.lookAhead = this.pos + 1;
        return this.readNext();
    }
    setDone() {
        this.pos = this.chunkPos = this.end;
        this.range = this.ranges[this.rangeIndex = this.ranges.length - 1];
        this.chunk = "";
        return this.next = -1;
    }
    /**
    @internal
    */ reset(pos, token) {
        if (token) {
            this.token = token;
            token.start = pos;
            token.lookAhead = pos + 1;
            token.value = token.extended = -1;
        } else this.token = $96e8fc72168067c5$var$nullToken;
        if (this.pos != pos) {
            this.pos = pos;
            if (pos == this.end) {
                this.setDone();
                return this;
            }
            while(pos < this.range.from)this.range = this.ranges[--this.rangeIndex];
            while(pos >= this.range.to)this.range = this.ranges[++this.rangeIndex];
            if (pos >= this.chunkPos && pos < this.chunkPos + this.chunk.length) this.chunkOff = pos - this.chunkPos;
            else {
                this.chunk = "";
                this.chunkOff = 0;
            }
            this.readNext();
        }
        return this;
    }
    /**
    @internal
    */ read(from, to) {
        if (from >= this.chunkPos && to <= this.chunkPos + this.chunk.length) return this.chunk.slice(from - this.chunkPos, to - this.chunkPos);
        if (from >= this.chunk2Pos && to <= this.chunk2Pos + this.chunk2.length) return this.chunk2.slice(from - this.chunk2Pos, to - this.chunk2Pos);
        if (from >= this.range.from && to <= this.range.to) return this.input.read(from, to);
        let result = "";
        for (let r of this.ranges){
            if (r.from >= to) break;
            if (r.to > from) result += this.input.read(Math.max(r.from, from), Math.min(r.to, to));
        }
        return result;
    }
}
/**
@internal
*/ class $96e8fc72168067c5$var$TokenGroup {
    constructor(data, id){
        this.data = data;
        this.id = id;
    }
    token(input, stack) {
        let { parser: parser } = stack.p;
        $96e8fc72168067c5$var$readToken(this.data, input, stack, this.id, parser.data, parser.tokenPrecTable);
    }
}
$96e8fc72168067c5$var$TokenGroup.prototype.contextual = $96e8fc72168067c5$var$TokenGroup.prototype.fallback = $96e8fc72168067c5$var$TokenGroup.prototype.extend = false;
/**
@hide
*/ class $96e8fc72168067c5$export$dbe55ed82366d5e9 {
    constructor(data, precTable, elseToken){
        this.precTable = precTable;
        this.elseToken = elseToken;
        this.data = typeof data == "string" ? $96e8fc72168067c5$var$decodeArray(data) : data;
    }
    token(input, stack) {
        let start = input.pos, skipped = 0;
        for(;;){
            let atEof = input.next < 0, nextPos = input.resolveOffset(1, 1);
            $96e8fc72168067c5$var$readToken(this.data, input, stack, 0, this.data, this.precTable);
            if (input.token.value > -1) break;
            if (this.elseToken == null) return;
            if (!atEof) skipped++;
            if (nextPos == null) break;
            input.reset(nextPos, input.token);
        }
        if (skipped) {
            input.reset(start, input.token);
            input.acceptToken(this.elseToken, skipped);
        }
    }
}
$96e8fc72168067c5$export$dbe55ed82366d5e9.prototype.contextual = $96e8fc72168067c5$var$TokenGroup.prototype.fallback = $96e8fc72168067c5$var$TokenGroup.prototype.extend = false;
/**
`@external tokens` declarations in the grammar should resolve to
an instance of this class.
*/ class $96e8fc72168067c5$export$6e56a42e94c6b2cb {
    /**
    Create a tokenizer. The first argument is the function that,
    given an input stream, scans for the types of tokens it
    recognizes at the stream's position, and calls
    [`acceptToken`](#lr.InputStream.acceptToken) when it finds
    one.
    */ constructor(/**
    @internal
    */ token, options = {}){
        this.token = token;
        this.contextual = !!options.contextual;
        this.fallback = !!options.fallback;
        this.extend = !!options.extend;
    }
}
// Tokenizer data is stored a big uint16 array containing, for each
// state:
//
//  - A group bitmask, indicating what token groups are reachable from
//    this state, so that paths that can only lead to tokens not in
//    any of the current groups can be cut off early.
//
//  - The position of the end of the state's sequence of accepting
//    tokens
//
//  - The number of outgoing edges for the state
//
//  - The accepting tokens, as (token id, group mask) pairs
//
//  - The outgoing edges, as (start character, end character, state
//    index) triples, with end character being exclusive
//
// This function interprets that data, running through a stream as
// long as new states with the a matching group mask can be reached,
// and updating `input.token` when it matches a token.
function $96e8fc72168067c5$var$readToken(data, input, stack, group, precTable, precOffset) {
    let state = 0, groupMask = 1 << group, { dialect: dialect } = stack.p.parser;
    scan: for(;;){
        if ((groupMask & data[state]) == 0) break;
        let accEnd = data[state + 1];
        // Check whether this state can lead to a token in the current group
        // Accept tokens in this state, possibly overwriting
        // lower-precedence / shorter tokens
        for(let i = state + 3; i < accEnd; i += 2)if ((data[i + 1] & groupMask) > 0) {
            let term = data[i];
            if (dialect.allows(term) && (input.token.value == -1 || input.token.value == term || $96e8fc72168067c5$var$overrides(term, input.token.value, precTable, precOffset))) {
                input.acceptToken(term);
                break;
            }
        }
        let next = input.next, low = 0, high = data[state + 2];
        // Special case for EOF
        if (input.next < 0 && high > low && data[accEnd + high * 3 - 3] == 65535 /* Seq.End */ ) {
            state = data[accEnd + high * 3 - 1];
            continue scan;
        }
        // Do a binary search on the state's edges
        for(; low < high;){
            let mid = low + high >> 1;
            let index = accEnd + mid + (mid << 1);
            let from = data[index], to = data[index + 1] || 0x10000;
            if (next < from) high = mid;
            else if (next >= to) low = mid + 1;
            else {
                state = data[index + 2];
                input.advance();
                continue scan;
            }
        }
        break;
    }
}
function $96e8fc72168067c5$var$findOffset(data, start, term) {
    for(let i = start, next; (next = data[i]) != 65535 /* Seq.End */ ; i++)if (next == term) return i - start;
    return -1;
}
function $96e8fc72168067c5$var$overrides(token, prev, tableData, tableOffset) {
    let iPrev = $96e8fc72168067c5$var$findOffset(tableData, tableOffset, prev);
    return iPrev < 0 || $96e8fc72168067c5$var$findOffset(tableData, tableOffset, token) < iPrev;
}
// Environment variable used to control console output
const $96e8fc72168067c5$var$verbose = false;
let $96e8fc72168067c5$var$stackIDs = null;
function $96e8fc72168067c5$var$cutAt(tree, pos, side) {
    let cursor = tree.cursor((0, $ed739beecf769914$export$b0e28367f55837aa).IncludeAnonymous);
    cursor.moveTo(pos);
    for(;;){
        if (!(side < 0 ? cursor.childBefore(pos) : cursor.childAfter(pos))) for(;;){
            if ((side < 0 ? cursor.to < pos : cursor.from > pos) && !cursor.type.isError) return side < 0 ? Math.max(0, Math.min(cursor.to - 1, pos - 25 /* Lookahead.Margin */ )) : Math.min(tree.length, Math.max(cursor.from + 1, pos + 25 /* Lookahead.Margin */ ));
            if (side < 0 ? cursor.prevSibling() : cursor.nextSibling()) break;
            if (!cursor.parent()) return side < 0 ? 0 : tree.length;
        }
    }
}
class $96e8fc72168067c5$var$FragmentCursor {
    constructor(fragments, nodeSet){
        this.fragments = fragments;
        this.nodeSet = nodeSet;
        this.i = 0;
        this.fragment = null;
        this.safeFrom = -1;
        this.safeTo = -1;
        this.trees = [];
        this.start = [];
        this.index = [];
        this.nextFragment();
    }
    nextFragment() {
        let fr = this.fragment = this.i == this.fragments.length ? null : this.fragments[this.i++];
        if (fr) {
            this.safeFrom = fr.openStart ? $96e8fc72168067c5$var$cutAt(fr.tree, fr.from + fr.offset, 1) - fr.offset : fr.from;
            this.safeTo = fr.openEnd ? $96e8fc72168067c5$var$cutAt(fr.tree, fr.to + fr.offset, -1) - fr.offset : fr.to;
            while(this.trees.length){
                this.trees.pop();
                this.start.pop();
                this.index.pop();
            }
            this.trees.push(fr.tree);
            this.start.push(-fr.offset);
            this.index.push(0);
            this.nextStart = this.safeFrom;
        } else this.nextStart = 1e9;
    }
    // `pos` must be >= any previously given `pos` for this cursor
    nodeAt(pos) {
        if (pos < this.nextStart) return null;
        while(this.fragment && this.safeTo <= pos)this.nextFragment();
        if (!this.fragment) return null;
        for(;;){
            let last = this.trees.length - 1;
            if (last < 0) {
                this.nextFragment();
                return null;
            }
            let top = this.trees[last], index = this.index[last];
            if (index == top.children.length) {
                this.trees.pop();
                this.start.pop();
                this.index.pop();
                continue;
            }
            let next = top.children[index];
            let start = this.start[last] + top.positions[index];
            if (start > pos) {
                this.nextStart = start;
                return null;
            }
            if (next instanceof (0, $ed739beecf769914$export$7fbedc92909ed28e)) {
                if (start == pos) {
                    if (start < this.safeFrom) return null;
                    let end = start + next.length;
                    if (end <= this.safeTo) {
                        let lookAhead = next.prop((0, $ed739beecf769914$export$b8034b9bc18acd90).lookAhead);
                        if (!lookAhead || end + lookAhead < this.fragment.to) return next;
                    }
                }
                this.index[last]++;
                if (start + next.length >= Math.max(this.safeFrom, pos)) {
                    this.trees.push(next);
                    this.start.push(start);
                    this.index.push(0);
                }
            } else {
                this.index[last]++;
                this.nextStart = start + next.length;
            }
        }
    }
}
class $96e8fc72168067c5$var$TokenCache {
    constructor(parser, stream){
        this.stream = stream;
        this.tokens = [];
        this.mainToken = null;
        this.actions = [];
        this.tokens = parser.tokenizers.map((_)=>new $96e8fc72168067c5$var$CachedToken);
    }
    getActions(stack) {
        let actionIndex = 0;
        let main = null;
        let { parser: parser } = stack.p, { tokenizers: tokenizers } = parser;
        let mask = parser.stateSlot(stack.state, 3 /* ParseState.TokenizerMask */ );
        let context = stack.curContext ? stack.curContext.hash : 0;
        let lookAhead = 0;
        for(let i = 0; i < tokenizers.length; i++){
            if ((1 << i & mask) == 0) continue;
            let tokenizer = tokenizers[i], token = this.tokens[i];
            if (main && !tokenizer.fallback) continue;
            if (tokenizer.contextual || token.start != stack.pos || token.mask != mask || token.context != context) {
                this.updateCachedToken(token, tokenizer, stack);
                token.mask = mask;
                token.context = context;
            }
            if (token.lookAhead > token.end + 25 /* Lookahead.Margin */ ) lookAhead = Math.max(token.lookAhead, lookAhead);
            if (token.value != 0 /* Term.Err */ ) {
                let startIndex = actionIndex;
                if (token.extended > -1) actionIndex = this.addActions(stack, token.extended, token.end, actionIndex);
                actionIndex = this.addActions(stack, token.value, token.end, actionIndex);
                if (!tokenizer.extend) {
                    main = token;
                    if (actionIndex > startIndex) break;
                }
            }
        }
        while(this.actions.length > actionIndex)this.actions.pop();
        if (lookAhead) stack.setLookAhead(lookAhead);
        if (!main && stack.pos == this.stream.end) {
            main = new $96e8fc72168067c5$var$CachedToken;
            main.value = stack.p.parser.eofTerm;
            main.start = main.end = stack.pos;
            actionIndex = this.addActions(stack, main.value, main.end, actionIndex);
        }
        this.mainToken = main;
        return this.actions;
    }
    getMainToken(stack) {
        if (this.mainToken) return this.mainToken;
        let main = new $96e8fc72168067c5$var$CachedToken, { pos: pos, p: p } = stack;
        main.start = pos;
        main.end = Math.min(pos + 1, p.stream.end);
        main.value = pos == p.stream.end ? p.parser.eofTerm : 0 /* Term.Err */ ;
        return main;
    }
    updateCachedToken(token, tokenizer, stack) {
        let start = this.stream.clipPos(stack.pos);
        tokenizer.token(this.stream.reset(start, token), stack);
        if (token.value > -1) {
            let { parser: parser } = stack.p;
            for(let i = 0; i < parser.specialized.length; i++)if (parser.specialized[i] == token.value) {
                let result = parser.specializers[i](this.stream.read(token.start, token.end), stack);
                if (result >= 0 && stack.p.parser.dialect.allows(result >> 1)) {
                    if ((result & 1) == 0 /* Specialize.Specialize */ ) token.value = result >> 1;
                    else token.extended = result >> 1;
                    break;
                }
            }
        } else {
            token.value = 0 /* Term.Err */ ;
            token.end = this.stream.clipPos(start + 1);
        }
    }
    putAction(action, token, end, index) {
        // Don't add duplicate actions
        for(let i = 0; i < index; i += 3)if (this.actions[i] == action) return index;
        this.actions[index++] = action;
        this.actions[index++] = token;
        this.actions[index++] = end;
        return index;
    }
    addActions(stack, token, end, index) {
        let { state: state } = stack, { parser: parser } = stack.p, { data: data } = parser;
        for(let set = 0; set < 2; set++)for(let i = parser.stateSlot(state, set ? 2 /* ParseState.Skip */  : 1 /* ParseState.Actions */ );; i += 3){
            if (data[i] == 65535 /* Seq.End */ ) {
                if (data[i + 1] == 1 /* Seq.Next */ ) i = $96e8fc72168067c5$var$pair(data, i + 2);
                else {
                    if (index == 0 && data[i + 1] == 2 /* Seq.Other */ ) index = this.putAction($96e8fc72168067c5$var$pair(data, i + 2), token, end, index);
                    break;
                }
            }
            if (data[i] == token) index = this.putAction($96e8fc72168067c5$var$pair(data, i + 1), token, end, index);
        }
        return index;
    }
}
class $96e8fc72168067c5$var$Parse {
    constructor(parser, input, fragments, ranges){
        this.parser = parser;
        this.input = input;
        this.ranges = ranges;
        this.recovering = 0;
        this.nextStackID = 0x2654; // ♔, ♕, ♖, ♗, ♘, ♙, ♠, ♡, ♢, ♣, ♤, ♥, ♦, ♧
        this.minStackPos = 0;
        this.reused = [];
        this.stoppedAt = null;
        this.lastBigReductionStart = -1;
        this.lastBigReductionSize = 0;
        this.bigReductionCount = 0;
        this.stream = new $96e8fc72168067c5$export$f22294a9362415e4(input, ranges);
        this.tokens = new $96e8fc72168067c5$var$TokenCache(parser, this.stream);
        this.topTerm = parser.top[1];
        let { from: from } = ranges[0];
        this.stacks = [
            $96e8fc72168067c5$export$694e0d28c7ffc90c.start(this, parser.top[0], from)
        ];
        this.fragments = fragments.length && this.stream.end - from > parser.bufferLength * 4 ? new $96e8fc72168067c5$var$FragmentCursor(fragments, parser.nodeSet) : null;
    }
    get parsedPos() {
        return this.minStackPos;
    }
    // Move the parser forward. This will process all parse stacks at
    // `this.pos` and try to advance them to a further position. If no
    // stack for such a position is found, it'll start error-recovery.
    //
    // When the parse is finished, this will return a syntax tree. When
    // not, it returns `null`.
    advance() {
        let stacks = this.stacks, pos = this.minStackPos;
        // This will hold stacks beyond `pos`.
        let newStacks = this.stacks = [];
        let stopped, stoppedTokens;
        // If a large amount of reductions happened with the same start
        // position, force the stack out of that production in order to
        // avoid creating a tree too deep to recurse through.
        // (This is an ugly kludge, because unfortunately there is no
        // straightforward, cheap way to check for this happening, due to
        // the history of reductions only being available in an
        // expensive-to-access format in the stack buffers.)
        if (this.bigReductionCount > 300 /* Rec.MaxLeftAssociativeReductionCount */  && stacks.length == 1) {
            let [s] = stacks;
            while(s.forceReduce() && s.stack.length && s.stack[s.stack.length - 2] >= this.lastBigReductionStart);
            this.bigReductionCount = this.lastBigReductionSize = 0;
        }
        // Keep advancing any stacks at `pos` until they either move
        // forward or can't be advanced. Gather stacks that can't be
        // advanced further in `stopped`.
        for(let i = 0; i < stacks.length; i++){
            let stack = stacks[i];
            for(;;){
                this.tokens.mainToken = null;
                if (stack.pos > pos) newStacks.push(stack);
                else if (this.advanceStack(stack, newStacks, stacks)) continue;
                else {
                    if (!stopped) {
                        stopped = [];
                        stoppedTokens = [];
                    }
                    stopped.push(stack);
                    let tok = this.tokens.getMainToken(stack);
                    stoppedTokens.push(tok.value, tok.end);
                }
                break;
            }
        }
        if (!newStacks.length) {
            let finished = stopped && $96e8fc72168067c5$var$findFinished(stopped);
            if (finished) {
                if ($96e8fc72168067c5$var$verbose) console.log("Finish with " + this.stackID(finished));
                return this.stackToTree(finished);
            }
            if (this.parser.strict) {
                if ($96e8fc72168067c5$var$verbose && stopped) console.log("Stuck with token " + (this.tokens.mainToken ? this.parser.getName(this.tokens.mainToken.value) : "none"));
                throw new SyntaxError("No parse at " + pos);
            }
            if (!this.recovering) this.recovering = 5 /* Rec.Distance */ ;
        }
        if (this.recovering && stopped) {
            let finished = this.stoppedAt != null && stopped[0].pos > this.stoppedAt ? stopped[0] : this.runRecovery(stopped, stoppedTokens, newStacks);
            if (finished) {
                if ($96e8fc72168067c5$var$verbose) console.log("Force-finish " + this.stackID(finished));
                return this.stackToTree(finished.forceAll());
            }
        }
        if (this.recovering) {
            let maxRemaining = this.recovering == 1 ? 1 : this.recovering * 3 /* Rec.MaxRemainingPerStep */ ;
            if (newStacks.length > maxRemaining) {
                newStacks.sort((a, b)=>b.score - a.score);
                while(newStacks.length > maxRemaining)newStacks.pop();
            }
            if (newStacks.some((s)=>s.reducePos > pos)) this.recovering--;
        } else if (newStacks.length > 1) {
            // Prune stacks that are in the same state, or that have been
            // running without splitting for a while, to avoid getting stuck
            // with multiple successful stacks running endlessly on.
            outer: for(let i = 0; i < newStacks.length - 1; i++){
                let stack = newStacks[i];
                for(let j = i + 1; j < newStacks.length; j++){
                    let other = newStacks[j];
                    if (stack.sameState(other) || stack.buffer.length > 500 /* Rec.MinBufferLengthPrune */  && other.buffer.length > 500 /* Rec.MinBufferLengthPrune */ ) {
                        if ((stack.score - other.score || stack.buffer.length - other.buffer.length) > 0) newStacks.splice(j--, 1);
                        else {
                            newStacks.splice(i--, 1);
                            continue outer;
                        }
                    }
                }
            }
            if (newStacks.length > 12 /* Rec.MaxStackCount */ ) {
                newStacks.sort((a, b)=>b.score - a.score);
                newStacks.splice(12 /* Rec.MaxStackCount */ , newStacks.length - 12 /* Rec.MaxStackCount */ );
            }
        }
        this.minStackPos = newStacks[0].pos;
        for(let i = 1; i < newStacks.length; i++)if (newStacks[i].pos < this.minStackPos) this.minStackPos = newStacks[i].pos;
        return null;
    }
    stopAt(pos) {
        if (this.stoppedAt != null && this.stoppedAt < pos) throw new RangeError("Can't move stoppedAt forward");
        this.stoppedAt = pos;
    }
    // Returns an updated version of the given stack, or null if the
    // stack can't advance normally. When `split` and `stacks` are
    // given, stacks split off by ambiguous operations will be pushed to
    // `split`, or added to `stacks` if they move `pos` forward.
    advanceStack(stack, stacks, split) {
        let start = stack.pos, { parser: parser } = this;
        let base = $96e8fc72168067c5$var$verbose ? this.stackID(stack) + " -> " : "";
        if (this.stoppedAt != null && start > this.stoppedAt) return stack.forceReduce() ? stack : null;
        if (this.fragments) {
            let strictCx = stack.curContext && stack.curContext.tracker.strict, cxHash = strictCx ? stack.curContext.hash : 0;
            for(let cached = this.fragments.nodeAt(start); cached;){
                let match = this.parser.nodeSet.types[cached.type.id] == cached.type ? parser.getGoto(stack.state, cached.type.id) : -1;
                if (match > -1 && cached.length && (!strictCx || (cached.prop((0, $ed739beecf769914$export$b8034b9bc18acd90).contextHash) || 0) == cxHash)) {
                    stack.useNode(cached, match);
                    if ($96e8fc72168067c5$var$verbose) console.log(base + this.stackID(stack) + ` (via reuse of ${parser.getName(cached.type.id)})`);
                    return true;
                }
                if (!(cached instanceof (0, $ed739beecf769914$export$7fbedc92909ed28e)) || cached.children.length == 0 || cached.positions[0] > 0) break;
                let inner = cached.children[0];
                if (inner instanceof (0, $ed739beecf769914$export$7fbedc92909ed28e) && cached.positions[0] == 0) cached = inner;
                else break;
            }
        }
        let defaultReduce = parser.stateSlot(stack.state, 4 /* ParseState.DefaultReduce */ );
        if (defaultReduce > 0) {
            stack.reduce(defaultReduce);
            if ($96e8fc72168067c5$var$verbose) console.log(base + this.stackID(stack) + ` (via always-reduce ${parser.getName(defaultReduce & 65535 /* Action.ValueMask */ )})`);
            return true;
        }
        if (stack.stack.length >= 8400 /* Rec.CutDepth */ ) {
            while(stack.stack.length > 6000 /* Rec.CutTo */  && stack.forceReduce());
        }
        let actions = this.tokens.getActions(stack);
        for(let i = 0; i < actions.length;){
            let action = actions[i++], term = actions[i++], end = actions[i++];
            let last = i == actions.length || !split;
            let localStack = last ? stack : stack.split();
            let main = this.tokens.mainToken;
            localStack.apply(action, term, main ? main.start : localStack.pos, end);
            if ($96e8fc72168067c5$var$verbose) console.log(base + this.stackID(localStack) + ` (via ${(action & 65536 /* Action.ReduceFlag */ ) == 0 ? "shift" : `reduce of ${parser.getName(action & 65535 /* Action.ValueMask */ )}`} for ${parser.getName(term)} @ ${start}${localStack == stack ? "" : ", split"})`);
            if (last) return true;
            else if (localStack.pos > start) stacks.push(localStack);
            else split.push(localStack);
        }
        return false;
    }
    // Advance a given stack forward as far as it will go. Returns the
    // (possibly updated) stack if it got stuck, or null if it moved
    // forward and was given to `pushStackDedup`.
    advanceFully(stack, newStacks) {
        let pos = stack.pos;
        for(;;){
            if (!this.advanceStack(stack, null, null)) return false;
            if (stack.pos > pos) {
                $96e8fc72168067c5$var$pushStackDedup(stack, newStacks);
                return true;
            }
        }
    }
    runRecovery(stacks, tokens, newStacks) {
        let finished = null, restarted = false;
        for(let i = 0; i < stacks.length; i++){
            let stack = stacks[i], token = tokens[i << 1], tokenEnd = tokens[(i << 1) + 1];
            let base = $96e8fc72168067c5$var$verbose ? this.stackID(stack) + " -> " : "";
            if (stack.deadEnd) {
                if (restarted) continue;
                restarted = true;
                stack.restart();
                if ($96e8fc72168067c5$var$verbose) console.log(base + this.stackID(stack) + " (restarted)");
                let done = this.advanceFully(stack, newStacks);
                if (done) continue;
            }
            let force = stack.split(), forceBase = base;
            for(let j = 0; j < 10 /* Rec.ForceReduceLimit */  && force.forceReduce(); j++){
                if ($96e8fc72168067c5$var$verbose) console.log(forceBase + this.stackID(force) + " (via force-reduce)");
                let done = this.advanceFully(force, newStacks);
                if (done) break;
                if ($96e8fc72168067c5$var$verbose) forceBase = this.stackID(force) + " -> ";
            }
            for (let insert of stack.recoverByInsert(token)){
                if ($96e8fc72168067c5$var$verbose) console.log(base + this.stackID(insert) + " (via recover-insert)");
                this.advanceFully(insert, newStacks);
            }
            if (this.stream.end > stack.pos) {
                if (tokenEnd == stack.pos) {
                    tokenEnd++;
                    token = 0 /* Term.Err */ ;
                }
                stack.recoverByDelete(token, tokenEnd);
                if ($96e8fc72168067c5$var$verbose) console.log(base + this.stackID(stack) + ` (via recover-delete ${this.parser.getName(token)})`);
                $96e8fc72168067c5$var$pushStackDedup(stack, newStacks);
            } else if (!finished || finished.score < stack.score) finished = stack;
        }
        return finished;
    }
    // Convert the stack's buffer to a syntax tree.
    stackToTree(stack) {
        stack.close();
        return (0, $ed739beecf769914$export$7fbedc92909ed28e).build({
            buffer: $96e8fc72168067c5$var$StackBufferCursor.create(stack),
            nodeSet: this.parser.nodeSet,
            topID: this.topTerm,
            maxBufferLength: this.parser.bufferLength,
            reused: this.reused,
            start: this.ranges[0].from,
            length: stack.pos - this.ranges[0].from,
            minRepeatType: this.parser.minRepeatTerm
        });
    }
    stackID(stack) {
        let id = ($96e8fc72168067c5$var$stackIDs || ($96e8fc72168067c5$var$stackIDs = new WeakMap)).get(stack);
        if (!id) $96e8fc72168067c5$var$stackIDs.set(stack, id = String.fromCodePoint(this.nextStackID++));
        return id + stack;
    }
}
function $96e8fc72168067c5$var$pushStackDedup(stack, newStacks) {
    for(let i = 0; i < newStacks.length; i++){
        let other = newStacks[i];
        if (other.pos == stack.pos && other.sameState(stack)) {
            if (newStacks[i].score < stack.score) newStacks[i] = stack;
            return;
        }
    }
    newStacks.push(stack);
}
class $96e8fc72168067c5$var$Dialect {
    constructor(source, flags, disabled){
        this.source = source;
        this.flags = flags;
        this.disabled = disabled;
    }
    allows(term) {
        return !this.disabled || this.disabled[term] == 0;
    }
}
const $96e8fc72168067c5$var$id = (x)=>x;
/**
Context trackers are used to track stateful context (such as
indentation in the Python grammar, or parent elements in the XML
grammar) needed by external tokenizers. You declare them in a
grammar file as `@context exportName from "module"`.

Context values should be immutable, and can be updated (replaced)
on shift or reduce actions.

The export used in a `@context` declaration should be of this
type.
*/ class $96e8fc72168067c5$export$88193367295cc46b {
    /**
    Define a context tracker.
    */ constructor(spec){
        this.start = spec.start;
        this.shift = spec.shift || $96e8fc72168067c5$var$id;
        this.reduce = spec.reduce || $96e8fc72168067c5$var$id;
        this.reuse = spec.reuse || $96e8fc72168067c5$var$id;
        this.hash = spec.hash || (()=>0);
        this.strict = spec.strict !== false;
    }
}
/**
Holds the parse tables for a given grammar, as generated by
`lezer-generator`, and provides [methods](#common.Parser) to parse
content with.
*/ class $96e8fc72168067c5$export$60c033f4cf02b410 extends (0, $ed739beecf769914$export$7acfa6ed01010e37) {
    /**
    @internal
    */ constructor(spec){
        super();
        /**
        @internal
        */ this.wrappers = [];
        if (spec.version != 14 /* File.Version */ ) throw new RangeError(`Parser version (${spec.version}) doesn't match runtime version (${14 /* File.Version */ })`);
        let nodeNames = spec.nodeNames.split(" ");
        this.minRepeatTerm = nodeNames.length;
        for(let i = 0; i < spec.repeatNodeCount; i++)nodeNames.push("");
        let topTerms = Object.keys(spec.topRules).map((r)=>spec.topRules[r][1]);
        let nodeProps = [];
        for(let i = 0; i < nodeNames.length; i++)nodeProps.push([]);
        function setProp(nodeID, prop, value) {
            nodeProps[nodeID].push([
                prop,
                prop.deserialize(String(value))
            ]);
        }
        if (spec.nodeProps) for (let propSpec of spec.nodeProps){
            let prop = propSpec[0];
            if (typeof prop == "string") prop = (0, $ed739beecf769914$export$b8034b9bc18acd90)[prop];
            for(let i = 1; i < propSpec.length;){
                let next = propSpec[i++];
                if (next >= 0) setProp(next, prop, propSpec[i++]);
                else {
                    let value = propSpec[i + -next];
                    for(let j = -next; j > 0; j--)setProp(propSpec[i++], prop, value);
                    i++;
                }
            }
        }
        this.nodeSet = new (0, $ed739beecf769914$export$7fad5fb00d8de02c)(nodeNames.map((name, i)=>(0, $ed739beecf769914$export$f06e977173f1857c).define({
                name: i >= this.minRepeatTerm ? undefined : name,
                id: i,
                props: nodeProps[i],
                top: topTerms.indexOf(i) > -1,
                error: i == 0,
                skipped: spec.skippedNodes && spec.skippedNodes.indexOf(i) > -1
            })));
        if (spec.propSources) this.nodeSet = this.nodeSet.extend(...spec.propSources);
        this.strict = false;
        this.bufferLength = (0, $ed739beecf769914$export$de305a849879ffa);
        let tokenArray = $96e8fc72168067c5$var$decodeArray(spec.tokenData);
        this.context = spec.context;
        this.specializerSpecs = spec.specialized || [];
        this.specialized = new Uint16Array(this.specializerSpecs.length);
        for(let i = 0; i < this.specializerSpecs.length; i++)this.specialized[i] = this.specializerSpecs[i].term;
        this.specializers = this.specializerSpecs.map($96e8fc72168067c5$var$getSpecializer);
        this.states = $96e8fc72168067c5$var$decodeArray(spec.states, Uint32Array);
        this.data = $96e8fc72168067c5$var$decodeArray(spec.stateData);
        this.goto = $96e8fc72168067c5$var$decodeArray(spec.goto);
        this.maxTerm = spec.maxTerm;
        this.tokenizers = spec.tokenizers.map((value)=>typeof value == "number" ? new $96e8fc72168067c5$var$TokenGroup(tokenArray, value) : value);
        this.topRules = spec.topRules;
        this.dialects = spec.dialects || {};
        this.dynamicPrecedences = spec.dynamicPrecedences || null;
        this.tokenPrecTable = spec.tokenPrec;
        this.termNames = spec.termNames || null;
        this.maxNode = this.nodeSet.types.length - 1;
        this.dialect = this.parseDialect();
        this.top = this.topRules[Object.keys(this.topRules)[0]];
    }
    createParse(input, fragments, ranges) {
        let parse = new $96e8fc72168067c5$var$Parse(this, input, fragments, ranges);
        for (let w of this.wrappers)parse = w(parse, input, fragments, ranges);
        return parse;
    }
    /**
    Get a goto table entry @internal
    */ getGoto(state, term, loose = false) {
        let table = this.goto;
        if (term >= table[0]) return -1;
        for(let pos = table[term + 1];;){
            let groupTag = table[pos++], last = groupTag & 1;
            let target = table[pos++];
            if (last && loose) return target;
            for(let end = pos + (groupTag >> 1); pos < end; pos++)if (table[pos] == state) return target;
            if (last) return -1;
        }
    }
    /**
    Check if this state has an action for a given terminal @internal
    */ hasAction(state, terminal) {
        let data = this.data;
        for(let set = 0; set < 2; set++)for(let i = this.stateSlot(state, set ? 2 /* ParseState.Skip */  : 1 /* ParseState.Actions */ ), next;; i += 3){
            if ((next = data[i]) == 65535 /* Seq.End */ ) {
                if (data[i + 1] == 1 /* Seq.Next */ ) next = data[i = $96e8fc72168067c5$var$pair(data, i + 2)];
                else if (data[i + 1] == 2 /* Seq.Other */ ) return $96e8fc72168067c5$var$pair(data, i + 2);
                else break;
            }
            if (next == terminal || next == 0 /* Term.Err */ ) return $96e8fc72168067c5$var$pair(data, i + 1);
        }
        return 0;
    }
    /**
    @internal
    */ stateSlot(state, slot) {
        return this.states[state * 6 /* ParseState.Size */  + slot];
    }
    /**
    @internal
    */ stateFlag(state, flag) {
        return (this.stateSlot(state, 0 /* ParseState.Flags */ ) & flag) > 0;
    }
    /**
    @internal
    */ validAction(state, action) {
        return !!this.allActions(state, (a)=>a == action ? true : null);
    }
    /**
    @internal
    */ allActions(state, action) {
        let deflt = this.stateSlot(state, 4 /* ParseState.DefaultReduce */ );
        let result = deflt ? action(deflt) : undefined;
        for(let i = this.stateSlot(state, 1 /* ParseState.Actions */ ); result == null; i += 3){
            if (this.data[i] == 65535 /* Seq.End */ ) {
                if (this.data[i + 1] == 1 /* Seq.Next */ ) i = $96e8fc72168067c5$var$pair(this.data, i + 2);
                else break;
            }
            result = action($96e8fc72168067c5$var$pair(this.data, i + 1));
        }
        return result;
    }
    /**
    Get the states that can follow this one through shift actions or
    goto jumps. @internal
    */ nextStates(state) {
        let result = [];
        for(let i = this.stateSlot(state, 1 /* ParseState.Actions */ );; i += 3){
            if (this.data[i] == 65535 /* Seq.End */ ) {
                if (this.data[i + 1] == 1 /* Seq.Next */ ) i = $96e8fc72168067c5$var$pair(this.data, i + 2);
                else break;
            }
            if ((this.data[i + 2] & 1) == 0) {
                let value = this.data[i + 1];
                if (!result.some((v, i)=>i & 1 && v == value)) result.push(this.data[i], value);
            }
        }
        return result;
    }
    /**
    Configure the parser. Returns a new parser instance that has the
    given settings modified. Settings not provided in `config` are
    kept from the original parser.
    */ configure(config) {
        // Hideous reflection-based kludge to make it easy to create a
        // slightly modified copy of a parser.
        let copy = Object.assign(Object.create($96e8fc72168067c5$export$60c033f4cf02b410.prototype), this);
        if (config.props) copy.nodeSet = this.nodeSet.extend(...config.props);
        if (config.top) {
            let info = this.topRules[config.top];
            if (!info) throw new RangeError(`Invalid top rule name ${config.top}`);
            copy.top = info;
        }
        if (config.tokenizers) copy.tokenizers = this.tokenizers.map((t)=>{
            let found = config.tokenizers.find((r)=>r.from == t);
            return found ? found.to : t;
        });
        if (config.specializers) {
            copy.specializers = this.specializers.slice();
            copy.specializerSpecs = this.specializerSpecs.map((s, i)=>{
                let found = config.specializers.find((r)=>r.from == s.external);
                if (!found) return s;
                let spec = Object.assign(Object.assign({}, s), {
                    external: found.to
                });
                copy.specializers[i] = $96e8fc72168067c5$var$getSpecializer(spec);
                return spec;
            });
        }
        if (config.contextTracker) copy.context = config.contextTracker;
        if (config.dialect) copy.dialect = this.parseDialect(config.dialect);
        if (config.strict != null) copy.strict = config.strict;
        if (config.wrap) copy.wrappers = copy.wrappers.concat(config.wrap);
        if (config.bufferLength != null) copy.bufferLength = config.bufferLength;
        return copy;
    }
    /**
    Tells you whether any [parse wrappers](#lr.ParserConfig.wrap)
    are registered for this parser.
    */ hasWrappers() {
        return this.wrappers.length > 0;
    }
    /**
    Returns the name associated with a given term. This will only
    work for all terms when the parser was generated with the
    `--names` option. By default, only the names of tagged terms are
    stored.
    */ getName(term) {
        return this.termNames ? this.termNames[term] : String(term <= this.maxNode && this.nodeSet.types[term].name || term);
    }
    /**
    The eof term id is always allocated directly after the node
    types. @internal
    */ get eofTerm() {
        return this.maxNode + 1;
    }
    /**
    The type of top node produced by the parser.
    */ get topNode() {
        return this.nodeSet.types[this.top[1]];
    }
    /**
    @internal
    */ dynamicPrecedence(term) {
        let prec = this.dynamicPrecedences;
        return prec == null ? 0 : prec[term] || 0;
    }
    /**
    @internal
    */ parseDialect(dialect) {
        let values = Object.keys(this.dialects), flags = values.map(()=>false);
        if (dialect) for (let part of dialect.split(" ")){
            let id = values.indexOf(part);
            if (id >= 0) flags[id] = true;
        }
        let disabled = null;
        for(let i = 0; i < values.length; i++)if (!flags[i]) for(let j = this.dialects[values[i]], id; (id = this.data[j++]) != 65535 /* Seq.End */ ;)(disabled || (disabled = new Uint8Array(this.maxTerm + 1)))[id] = 1;
        return new $96e8fc72168067c5$var$Dialect(dialect, flags, disabled);
    }
    /**
    Used by the output of the parser generator. Not available to
    user code. @hide
    */ static deserialize(spec) {
        return new $96e8fc72168067c5$export$60c033f4cf02b410(spec);
    }
}
function $96e8fc72168067c5$var$pair(data, off) {
    return data[off] | data[off + 1] << 16;
}
function $96e8fc72168067c5$var$findFinished(stacks) {
    let best = null;
    for (let stack of stacks){
        let stopped = stack.p.stoppedAt;
        if ((stack.pos == stack.p.stream.end || stopped != null && stack.pos > stopped) && stack.p.parser.stateFlag(stack.state, 2 /* StateFlag.Accepting */ ) && (!best || best.score < stack.score)) best = stack;
    }
    return best;
}
function $96e8fc72168067c5$var$getSpecializer(spec) {
    if (spec.external) {
        let mask = spec.extend ? 1 /* Specialize.Extend */  : 0 /* Specialize.Specialize */ ;
        return (value, stack)=>spec.external(value, stack) << 1 | mask;
    }
    return spec.get;
}




// This file was generated by lezer-generator. You probably shouldn't edit it.
const $07236028cbce11ab$var$scriptText = 55, $07236028cbce11ab$var$StartCloseScriptTag = 1, $07236028cbce11ab$var$styleText = 56, $07236028cbce11ab$var$StartCloseStyleTag = 2, $07236028cbce11ab$var$textareaText = 57, $07236028cbce11ab$var$StartCloseTextareaTag = 3, $07236028cbce11ab$var$EndTag = 4, $07236028cbce11ab$var$SelfClosingEndTag = 5, $07236028cbce11ab$var$StartTag = 6, $07236028cbce11ab$var$StartScriptTag = 7, $07236028cbce11ab$var$StartStyleTag = 8, $07236028cbce11ab$var$StartTextareaTag = 9, $07236028cbce11ab$var$StartSelfClosingTag = 10, $07236028cbce11ab$var$StartCloseTag = 11, $07236028cbce11ab$var$NoMatchStartCloseTag = 12, $07236028cbce11ab$var$MismatchedStartCloseTag = 13, $07236028cbce11ab$var$missingCloseTag = 58, $07236028cbce11ab$var$IncompleteTag = 14, $07236028cbce11ab$var$IncompleteCloseTag = 15, $07236028cbce11ab$var$commentContent$1 = 59, $07236028cbce11ab$var$Element = 21, $07236028cbce11ab$var$TagName = 23, $07236028cbce11ab$var$Attribute = 24, $07236028cbce11ab$var$AttributeName = 25, $07236028cbce11ab$var$AttributeValue = 27, $07236028cbce11ab$var$UnquotedAttributeValue = 28, $07236028cbce11ab$var$ScriptText = 29, $07236028cbce11ab$var$StyleText = 32, $07236028cbce11ab$var$TextareaText = 35, $07236028cbce11ab$var$OpenTag = 37, $07236028cbce11ab$var$CloseTag = 38, $07236028cbce11ab$var$Dialect_noMatch = 0, $07236028cbce11ab$var$Dialect_selfClosing = 1;
/* Hand-written tokenizers for HTML. */ const $07236028cbce11ab$var$selfClosers = {
    area: true,
    base: true,
    br: true,
    col: true,
    command: true,
    embed: true,
    frame: true,
    hr: true,
    img: true,
    input: true,
    keygen: true,
    link: true,
    meta: true,
    param: true,
    source: true,
    track: true,
    wbr: true,
    menuitem: true
};
const $07236028cbce11ab$var$implicitlyClosed = {
    dd: true,
    li: true,
    optgroup: true,
    option: true,
    p: true,
    rp: true,
    rt: true,
    tbody: true,
    td: true,
    tfoot: true,
    th: true,
    tr: true
};
const $07236028cbce11ab$var$closeOnOpen = {
    dd: {
        dd: true,
        dt: true
    },
    dt: {
        dd: true,
        dt: true
    },
    li: {
        li: true
    },
    option: {
        option: true,
        optgroup: true
    },
    optgroup: {
        optgroup: true
    },
    p: {
        address: true,
        article: true,
        aside: true,
        blockquote: true,
        dir: true,
        div: true,
        dl: true,
        fieldset: true,
        footer: true,
        form: true,
        h1: true,
        h2: true,
        h3: true,
        h4: true,
        h5: true,
        h6: true,
        header: true,
        hgroup: true,
        hr: true,
        menu: true,
        nav: true,
        ol: true,
        p: true,
        pre: true,
        section: true,
        table: true,
        ul: true
    },
    rp: {
        rp: true,
        rt: true
    },
    rt: {
        rp: true,
        rt: true
    },
    tbody: {
        tbody: true,
        tfoot: true
    },
    td: {
        td: true,
        th: true
    },
    tfoot: {
        tbody: true
    },
    th: {
        td: true,
        th: true
    },
    thead: {
        tbody: true,
        tfoot: true
    },
    tr: {
        tr: true
    }
};
function $07236028cbce11ab$var$nameChar(ch) {
    return ch == 45 || ch == 46 || ch == 58 || ch >= 65 && ch <= 90 || ch == 95 || ch >= 97 && ch <= 122 || ch >= 161;
}
let $07236028cbce11ab$var$cachedName = null, $07236028cbce11ab$var$cachedInput = null, $07236028cbce11ab$var$cachedPos = 0;
function $07236028cbce11ab$var$tagNameAfter(input, offset) {
    let pos = input.pos + offset;
    if ($07236028cbce11ab$var$cachedPos == pos && $07236028cbce11ab$var$cachedInput == input) return $07236028cbce11ab$var$cachedName;
    let next = input.peek(offset), name = "";
    for(;;){
        if (!$07236028cbce11ab$var$nameChar(next)) break;
        name += String.fromCharCode(next);
        next = input.peek(++offset);
    }
    // Undefined to signal there's a <? or <!, null for just missing
    $07236028cbce11ab$var$cachedInput = input;
    $07236028cbce11ab$var$cachedPos = pos;
    return $07236028cbce11ab$var$cachedName = name ? name.toLowerCase() : next == $07236028cbce11ab$var$question || next == $07236028cbce11ab$var$bang ? undefined : null;
}
const $07236028cbce11ab$var$lessThan = 60, $07236028cbce11ab$var$greaterThan = 62, $07236028cbce11ab$var$slash = 47, $07236028cbce11ab$var$question = 63, $07236028cbce11ab$var$bang = 33, $07236028cbce11ab$var$dash = 45;
function $07236028cbce11ab$var$ElementContext(name, parent) {
    this.name = name;
    this.parent = parent;
}
const $07236028cbce11ab$var$startTagTerms = [
    $07236028cbce11ab$var$StartTag,
    $07236028cbce11ab$var$StartSelfClosingTag,
    $07236028cbce11ab$var$StartScriptTag,
    $07236028cbce11ab$var$StartStyleTag,
    $07236028cbce11ab$var$StartTextareaTag
];
const $07236028cbce11ab$var$elementContext = new (0, $96e8fc72168067c5$export$88193367295cc46b)({
    start: null,
    shift (context, term, stack, input) {
        return $07236028cbce11ab$var$startTagTerms.indexOf(term) > -1 ? new $07236028cbce11ab$var$ElementContext($07236028cbce11ab$var$tagNameAfter(input, 1) || "", context) : context;
    },
    reduce (context, term) {
        return term == $07236028cbce11ab$var$Element && context ? context.parent : context;
    },
    reuse (context, node, stack, input) {
        let type = node.type.id;
        return type == $07236028cbce11ab$var$StartTag || type == $07236028cbce11ab$var$OpenTag ? new $07236028cbce11ab$var$ElementContext($07236028cbce11ab$var$tagNameAfter(input, 1) || "", context) : context;
    },
    strict: false
});
const $07236028cbce11ab$var$tagStart = new (0, $96e8fc72168067c5$export$6e56a42e94c6b2cb)((input, stack)=>{
    if (input.next != $07236028cbce11ab$var$lessThan) {
        // End of file, close any open tags
        if (input.next < 0 && stack.context) input.acceptToken($07236028cbce11ab$var$missingCloseTag);
        return;
    }
    input.advance();
    let close = input.next == $07236028cbce11ab$var$slash;
    if (close) input.advance();
    let name = $07236028cbce11ab$var$tagNameAfter(input, 0);
    if (name === undefined) return;
    if (!name) return input.acceptToken(close ? $07236028cbce11ab$var$IncompleteCloseTag : $07236028cbce11ab$var$IncompleteTag);
    let parent = stack.context ? stack.context.name : null;
    if (close) {
        if (name == parent) return input.acceptToken($07236028cbce11ab$var$StartCloseTag);
        if (parent && $07236028cbce11ab$var$implicitlyClosed[parent]) return input.acceptToken($07236028cbce11ab$var$missingCloseTag, -2);
        if (stack.dialectEnabled($07236028cbce11ab$var$Dialect_noMatch)) return input.acceptToken($07236028cbce11ab$var$NoMatchStartCloseTag);
        for(let cx = stack.context; cx; cx = cx.parent)if (cx.name == name) return;
        input.acceptToken($07236028cbce11ab$var$MismatchedStartCloseTag);
    } else {
        if (name == "script") return input.acceptToken($07236028cbce11ab$var$StartScriptTag);
        if (name == "style") return input.acceptToken($07236028cbce11ab$var$StartStyleTag);
        if (name == "textarea") return input.acceptToken($07236028cbce11ab$var$StartTextareaTag);
        if ($07236028cbce11ab$var$selfClosers.hasOwnProperty(name)) return input.acceptToken($07236028cbce11ab$var$StartSelfClosingTag);
        if (parent && $07236028cbce11ab$var$closeOnOpen[parent] && $07236028cbce11ab$var$closeOnOpen[parent][name]) input.acceptToken($07236028cbce11ab$var$missingCloseTag, -1);
        else input.acceptToken($07236028cbce11ab$var$StartTag);
    }
}, {
    contextual: true
});
const $07236028cbce11ab$var$commentContent = new (0, $96e8fc72168067c5$export$6e56a42e94c6b2cb)((input)=>{
    for(let dashes = 0, i = 0;; i++){
        if (input.next < 0) {
            if (i) input.acceptToken($07236028cbce11ab$var$commentContent$1);
            break;
        }
        if (input.next == $07236028cbce11ab$var$dash) dashes++;
        else if (input.next == $07236028cbce11ab$var$greaterThan && dashes >= 2) {
            if (i >= 3) input.acceptToken($07236028cbce11ab$var$commentContent$1, -2);
            break;
        } else dashes = 0;
        input.advance();
    }
});
function $07236028cbce11ab$var$inForeignElement(context) {
    for(; context; context = context.parent)if (context.name == "svg" || context.name == "math") return true;
    return false;
}
const $07236028cbce11ab$var$endTag = new (0, $96e8fc72168067c5$export$6e56a42e94c6b2cb)((input, stack)=>{
    if (input.next == $07236028cbce11ab$var$slash && input.peek(1) == $07236028cbce11ab$var$greaterThan) {
        let selfClosing = stack.dialectEnabled($07236028cbce11ab$var$Dialect_selfClosing) || $07236028cbce11ab$var$inForeignElement(stack.context);
        input.acceptToken(selfClosing ? $07236028cbce11ab$var$SelfClosingEndTag : $07236028cbce11ab$var$EndTag, 2);
    } else if (input.next == $07236028cbce11ab$var$greaterThan) input.acceptToken($07236028cbce11ab$var$EndTag, 1);
});
function $07236028cbce11ab$var$contentTokenizer(tag, textToken, endToken) {
    let lastState = 2 + tag.length;
    return new (0, $96e8fc72168067c5$export$6e56a42e94c6b2cb)((input)=>{
        // state means:
        // - 0 nothing matched
        // - 1 '<' matched
        // - 2 '</'
        // - 3-(1+tag.length) part of the tag matched
        // - lastState whole tag + possibly whitespace matched
        for(let state = 0, matchedLen = 0, i = 0;; i++){
            if (input.next < 0) {
                if (i) input.acceptToken(textToken);
                break;
            }
            if (state == 0 && input.next == $07236028cbce11ab$var$lessThan || state == 1 && input.next == $07236028cbce11ab$var$slash || state >= 2 && state < lastState && input.next == tag.charCodeAt(state - 2)) {
                state++;
                matchedLen++;
            } else if (state == lastState && input.next == $07236028cbce11ab$var$greaterThan) {
                if (i > matchedLen) input.acceptToken(textToken, -matchedLen);
                else input.acceptToken(endToken, -(matchedLen - 2));
                break;
            } else if ((input.next == 10 /* '\n' */  || input.next == 13 /* '\r' */ ) && i) {
                input.acceptToken(textToken, 1);
                break;
            } else state = matchedLen = 0;
            input.advance();
        }
    });
}
const $07236028cbce11ab$var$scriptTokens = $07236028cbce11ab$var$contentTokenizer("script", $07236028cbce11ab$var$scriptText, $07236028cbce11ab$var$StartCloseScriptTag);
const $07236028cbce11ab$var$styleTokens = $07236028cbce11ab$var$contentTokenizer("style", $07236028cbce11ab$var$styleText, $07236028cbce11ab$var$StartCloseStyleTag);
const $07236028cbce11ab$var$textareaTokens = $07236028cbce11ab$var$contentTokenizer("textarea", $07236028cbce11ab$var$textareaText, $07236028cbce11ab$var$StartCloseTextareaTag);
const $07236028cbce11ab$var$htmlHighlighting = (0, $a1ec9d683d365521$export$c537e79bb7b94295)({
    "Text RawText IncompleteTag IncompleteCloseTag": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).content,
    "StartTag StartCloseTag SelfClosingEndTag EndTag": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).angleBracket,
    TagName: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).tagName,
    "MismatchedCloseTag/TagName": [
        (0, $a1ec9d683d365521$export$8b7a896ae75accbf).tagName,
        (0, $a1ec9d683d365521$export$8b7a896ae75accbf).invalid
    ],
    AttributeName: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).attributeName,
    "AttributeValue UnquotedAttributeValue": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).attributeValue,
    Is: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).definitionOperator,
    "EntityReference CharacterReference": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).character,
    Comment: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).blockComment,
    ProcessingInst: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).processingInstruction,
    DoctypeDecl: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).documentMeta
});
// This file was generated by lezer-generator. You probably shouldn't edit it.
const $07236028cbce11ab$export$8f49e4af10703ce3 = (0, $96e8fc72168067c5$export$60c033f4cf02b410).deserialize({
    version: 14,
    states: ",xOVO!rOOO!ZQ#tO'#CrO!`Q#tO'#C{O!eQ#tO'#DOO!jQ#tO'#DRO!oQ#tO'#DTO!tOaO'#CqO#PObO'#CqO#[OdO'#CqO$kO!rO'#CqOOO`'#Cq'#CqO$rO$fO'#DUO$zQ#tO'#DWO%PQ#tO'#DXOOO`'#Dl'#DlOOO`'#DZ'#DZQVO!rOOO%UQ&rO,59^O%aQ&rO,59gO%lQ&rO,59jO%wQ&rO,59mO&SQ&rO,59oOOOa'#D_'#D_O&_OaO'#CyO&jOaO,59]OOOb'#D`'#D`O&rObO'#C|O&}ObO,59]OOOd'#Da'#DaO'VOdO'#DPO'bOdO,59]OOO`'#Db'#DbO'jO!rO,59]O'qQ#tO'#DSOOO`,59],59]OOOp'#Dc'#DcO'vO$fO,59pOOO`,59p,59pO(OQ#|O,59rO(TQ#|O,59sOOO`-E7X-E7XO(YQ&rO'#CtOOQW'#D['#D[O(hQ&rO1G.xOOOa1G.x1G.xOOO`1G/Z1G/ZO(sQ&rO1G/ROOOb1G/R1G/RO)OQ&rO1G/UOOOd1G/U1G/UO)ZQ&rO1G/XOOO`1G/X1G/XO)fQ&rO1G/ZOOOa-E7]-E7]O)qQ#tO'#CzOOO`1G.w1G.wOOOb-E7^-E7^O)vQ#tO'#C}OOOd-E7_-E7_O){Q#tO'#DQOOO`-E7`-E7`O*QQ#|O,59nOOOp-E7a-E7aOOO`1G/[1G/[OOO`1G/^1G/^OOO`1G/_1G/_O*VQ,UO,59`OOQW-E7Y-E7YOOOa7+$d7+$dOOO`7+$u7+$uOOOb7+$m7+$mOOOd7+$p7+$pOOO`7+$s7+$sO*bQ#|O,59fO*gQ#|O,59iO*lQ#|O,59lOOO`1G/Y1G/YO*qO7[O'#CwO+SOMhO'#CwOOQW1G.z1G.zOOO`1G/Q1G/QOOO`1G/T1G/TOOO`1G/W1G/WOOOO'#D]'#D]O+eO7[O,59cOOQW,59c,59cOOOO'#D^'#D^O+vOMhO,59cOOOO-E7Z-E7ZOOQW1G.}1G.}OOOO-E7[-E7[",
    stateData: ",c~O!_OS~OUSOVPOWQOXROYTO[]O][O^^O_^Oa^Ob^Oc^Od^Oy^O|_O!eZO~OgaO~OgbO~OgcO~OgdO~OgeO~O!XfOPmP![mP~O!YiOQpP![pP~O!ZlORsP![sP~OUSOVPOWQOXROYTOZqO[]O][O^^O_^Oa^Ob^Oc^Od^Oy^O!eZO~O![rO~P#gO!]sO!fuO~OgvO~OgwO~OS|OT}OiyO~OS!POT}OiyO~OS!ROT}OiyO~OS!TOT}OiyO~OS}OT}OiyO~O!XfOPmX![mX~OP!WO![!XO~O!YiOQpX![pX~OQ!ZO![!XO~O!ZlORsX![sX~OR!]O![!XO~O![!XO~P#gOg!_O~O!]sO!f!aO~OS!bO~OS!cO~Oj!dOShXThXihX~OS!fOT!gOiyO~OS!hOT!gOiyO~OS!iOT!gOiyO~OS!jOT!gOiyO~OS!gOT!gOiyO~Og!kO~Og!lO~Og!mO~OS!nO~Ol!qO!a!oO!c!pO~OS!rO~OS!sO~OS!tO~Ob!uOc!uOd!uO!a!wO!b!uO~Ob!xOc!xOd!xO!c!wO!d!xO~Ob!uOc!uOd!uO!a!{O!b!uO~Ob!xOc!xOd!xO!c!{O!d!xO~OT~cbd!ey|!e~",
    goto: "%q!aPPPPPPPPPPPPPPPPPPPPP!b!hP!nPP!zP!}#Q#T#Z#^#a#g#j#m#s#y!bP!b!bP$P$V$m$s$y%P%V%]%cPPPPPPPP%iX^OX`pXUOX`pezabcde{!O!Q!S!UR!q!dRhUR!XhXVOX`pRkVR!XkXWOX`pRnWR!XnXXOX`pQrXR!XpXYOX`pQ`ORx`Q{aQ!ObQ!QcQ!SdQ!UeZ!e{!O!Q!S!UQ!v!oR!z!vQ!y!pR!|!yQgUR!VgQjVR!YjQmWR![mQpXR!^pQtZR!`tS_O`ToXp",
    nodeNames: "\u26A0 StartCloseTag StartCloseTag StartCloseTag EndTag SelfClosingEndTag StartTag StartTag StartTag StartTag StartTag StartCloseTag StartCloseTag StartCloseTag IncompleteTag IncompleteCloseTag Document Text EntityReference CharacterReference InvalidEntity Element OpenTag TagName Attribute AttributeName Is AttributeValue UnquotedAttributeValue ScriptText CloseTag OpenTag StyleText CloseTag OpenTag TextareaText CloseTag OpenTag CloseTag SelfClosingTag Comment ProcessingInst MismatchedCloseTag CloseTag DoctypeDecl",
    maxTerm: 68,
    context: $07236028cbce11ab$var$elementContext,
    nodeProps: [
        [
            "closedBy",
            -10,
            1,
            2,
            3,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            "EndTag",
            6,
            "EndTag SelfClosingEndTag",
            -4,
            22,
            31,
            34,
            37,
            "CloseTag"
        ],
        [
            "openedBy",
            4,
            "StartTag StartCloseTag",
            5,
            "StartTag",
            -4,
            30,
            33,
            36,
            38,
            "OpenTag"
        ],
        [
            "group",
            -10,
            14,
            15,
            18,
            19,
            20,
            21,
            40,
            41,
            42,
            43,
            "Entity",
            17,
            "Entity TextContent",
            -3,
            29,
            32,
            35,
            "TextContent Entity"
        ],
        [
            "isolate",
            -11,
            22,
            30,
            31,
            33,
            34,
            36,
            37,
            38,
            39,
            42,
            43,
            "ltr",
            -3,
            27,
            28,
            40,
            ""
        ]
    ],
    propSources: [
        $07236028cbce11ab$var$htmlHighlighting
    ],
    skippedNodes: [
        0
    ],
    repeatNodeCount: 9,
    tokenData: "!<p!aR!YOX$qXY,QYZ,QZ[$q[]&X]^,Q^p$qpq,Qqr-_rs3_sv-_vw3}wxHYx}-_}!OH{!O!P-_!P!Q$q!Q![-_![!]Mz!]!^-_!^!_!$S!_!`!;x!`!a&X!a!c-_!c!}Mz!}#R-_#R#SMz#S#T1k#T#oMz#o#s-_#s$f$q$f%W-_%W%oMz%o%p-_%p&aMz&a&b-_&b1pMz1p4U-_4U4dMz4d4e-_4e$ISMz$IS$I`-_$I`$IbMz$Ib$Kh-_$Kh%#tMz%#t&/x-_&/x&EtMz&Et&FV-_&FV;'SMz;'S;:j!#|;:j;=`3X<%l?&r-_?&r?AhMz?Ah?BY$q?BY?MnMz?MnO$q!Z$|caPlW!b`!dpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr$qrs&}sv$qvw+Pwx(tx!^$q!^!_*V!_!a&X!a#S$q#S#T&X#T;'S$q;'S;=`+z<%lO$q!R&bXaP!b`!dpOr&Xrs&}sv&Xwx(tx!^&X!^!_*V!_;'S&X;'S;=`*y<%lO&Xq'UVaP!dpOv&}wx'kx!^&}!^!_(V!_;'S&};'S;=`(n<%lO&}P'pTaPOv'kw!^'k!_;'S'k;'S;=`(P<%lO'kP(SP;=`<%l'kp([S!dpOv(Vx;'S(V;'S;=`(h<%lO(Vp(kP;=`<%l(Vq(qP;=`<%l&}a({WaP!b`Or(trs'ksv(tw!^(t!^!_)e!_;'S(t;'S;=`*P<%lO(t`)jT!b`Or)esv)ew;'S)e;'S;=`)y<%lO)e`)|P;=`<%l)ea*SP;=`<%l(t!Q*^V!b`!dpOr*Vrs(Vsv*Vwx)ex;'S*V;'S;=`*s<%lO*V!Q*vP;=`<%l*V!R*|P;=`<%l&XW+UYlWOX+PZ[+P^p+Pqr+Psw+Px!^+P!a#S+P#T;'S+P;'S;=`+t<%lO+PW+wP;=`<%l+P!Z+}P;=`<%l$q!a,]`aP!b`!dp!_^OX&XXY,QYZ,QZ]&X]^,Q^p&Xpq,Qqr&Xrs&}sv&Xwx(tx!^&X!^!_*V!_;'S&X;'S;=`*y<%lO&X!_-ljiSaPlW!b`!dpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr-_rs&}sv-_vw/^wx(tx!P-_!P!Q$q!Q!^-_!^!_*V!_!a&X!a#S-_#S#T1k#T#s-_#s$f$q$f;'S-_;'S;=`3X<%l?Ah-_?Ah?BY$q?BY?Mn-_?MnO$q[/ebiSlWOX+PZ[+P^p+Pqr/^sw/^x!P/^!P!Q+P!Q!^/^!a#S/^#S#T0m#T#s/^#s$f+P$f;'S/^;'S;=`1e<%l?Ah/^?Ah?BY+P?BY?Mn/^?MnO+PS0rXiSqr0msw0mx!P0m!Q!^0m!a#s0m$f;'S0m;'S;=`1_<%l?Ah0m?BY?Mn0mS1bP;=`<%l0m[1hP;=`<%l/^!V1vciSaP!b`!dpOq&Xqr1krs&}sv1kvw0mwx(tx!P1k!P!Q&X!Q!^1k!^!_*V!_!a&X!a#s1k#s$f&X$f;'S1k;'S;=`3R<%l?Ah1k?Ah?BY&X?BY?Mn1k?MnO&X!V3UP;=`<%l1k!_3[P;=`<%l-_!Z3hV!ahaP!dpOv&}wx'kx!^&}!^!_(V!_;'S&};'S;=`(n<%lO&}!_4WiiSlWd!ROX5uXZ7SZ[5u[^7S^p5uqr8trs7Sst>]tw8twx7Sx!P8t!P!Q5u!Q!]8t!]!^/^!^!a7S!a#S8t#S#T;{#T#s8t#s$f5u$f;'S8t;'S;=`>V<%l?Ah8t?Ah?BY5u?BY?Mn8t?MnO5u!Z5zblWOX5uXZ7SZ[5u[^7S^p5uqr5urs7Sst+Ptw5uwx7Sx!]5u!]!^7w!^!a7S!a#S5u#S#T7S#T;'S5u;'S;=`8n<%lO5u!R7VVOp7Sqs7St!]7S!]!^7l!^;'S7S;'S;=`7q<%lO7S!R7qOb!R!R7tP;=`<%l7S!Z8OYlWb!ROX+PZ[+P^p+Pqr+Psw+Px!^+P!a#S+P#T;'S+P;'S;=`+t<%lO+P!Z8qP;=`<%l5u!_8{iiSlWOX5uXZ7SZ[5u[^7S^p5uqr8trs7Sst/^tw8twx7Sx!P8t!P!Q5u!Q!]8t!]!^:j!^!a7S!a#S8t#S#T;{#T#s8t#s$f5u$f;'S8t;'S;=`>V<%l?Ah8t?Ah?BY5u?BY?Mn8t?MnO5u!_:sbiSlWb!ROX+PZ[+P^p+Pqr/^sw/^x!P/^!P!Q+P!Q!^/^!a#S/^#S#T0m#T#s/^#s$f+P$f;'S/^;'S;=`1e<%l?Ah/^?Ah?BY+P?BY?Mn/^?MnO+P!V<QciSOp7Sqr;{rs7Sst0mtw;{wx7Sx!P;{!P!Q7S!Q!];{!]!^=]!^!a7S!a#s;{#s$f7S$f;'S;{;'S;=`>P<%l?Ah;{?Ah?BY7S?BY?Mn;{?MnO7S!V=dXiSb!Rqr0msw0mx!P0m!Q!^0m!a#s0m$f;'S0m;'S;=`1_<%l?Ah0m?BY?Mn0m!V>SP;=`<%l;{!_>YP;=`<%l8t!_>dhiSlWOX@OXZAYZ[@O[^AY^p@OqrBwrsAYswBwwxAYx!PBw!P!Q@O!Q!]Bw!]!^/^!^!aAY!a#SBw#S#TE{#T#sBw#s$f@O$f;'SBw;'S;=`HS<%l?AhBw?Ah?BY@O?BY?MnBw?MnO@O!Z@TalWOX@OXZAYZ[@O[^AY^p@Oqr@OrsAYsw@OwxAYx!]@O!]!^Az!^!aAY!a#S@O#S#TAY#T;'S@O;'S;=`Bq<%lO@O!RA]UOpAYq!]AY!]!^Ao!^;'SAY;'S;=`At<%lOAY!RAtOc!R!RAwP;=`<%lAY!ZBRYlWc!ROX+PZ[+P^p+Pqr+Psw+Px!^+P!a#S+P#T;'S+P;'S;=`+t<%lO+P!ZBtP;=`<%l@O!_COhiSlWOX@OXZAYZ[@O[^AY^p@OqrBwrsAYswBwwxAYx!PBw!P!Q@O!Q!]Bw!]!^Dj!^!aAY!a#SBw#S#TE{#T#sBw#s$f@O$f;'SBw;'S;=`HS<%l?AhBw?Ah?BY@O?BY?MnBw?MnO@O!_DsbiSlWc!ROX+PZ[+P^p+Pqr/^sw/^x!P/^!P!Q+P!Q!^/^!a#S/^#S#T0m#T#s/^#s$f+P$f;'S/^;'S;=`1e<%l?Ah/^?Ah?BY+P?BY?Mn/^?MnO+P!VFQbiSOpAYqrE{rsAYswE{wxAYx!PE{!P!QAY!Q!]E{!]!^GY!^!aAY!a#sE{#s$fAY$f;'SE{;'S;=`G|<%l?AhE{?Ah?BYAY?BY?MnE{?MnOAY!VGaXiSc!Rqr0msw0mx!P0m!Q!^0m!a#s0m$f;'S0m;'S;=`1_<%l?Ah0m?BY?Mn0m!VHPP;=`<%lE{!_HVP;=`<%lBw!ZHcW!cxaP!b`Or(trs'ksv(tw!^(t!^!_)e!_;'S(t;'S;=`*P<%lO(t!aIYliSaPlW!b`!dpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr-_rs&}sv-_vw/^wx(tx}-_}!OKQ!O!P-_!P!Q$q!Q!^-_!^!_*V!_!a&X!a#S-_#S#T1k#T#s-_#s$f$q$f;'S-_;'S;=`3X<%l?Ah-_?Ah?BY$q?BY?Mn-_?MnO$q!aK_kiSaPlW!b`!dpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr-_rs&}sv-_vw/^wx(tx!P-_!P!Q$q!Q!^-_!^!_*V!_!`&X!`!aMS!a#S-_#S#T1k#T#s-_#s$f$q$f;'S-_;'S;=`3X<%l?Ah-_?Ah?BY$q?BY?Mn-_?MnO$q!TM_XaP!b`!dp!fQOr&Xrs&}sv&Xwx(tx!^&X!^!_*V!_;'S&X;'S;=`*y<%lO&X!aNZ!ZiSgQaPlW!b`!dpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr-_rs&}sv-_vw/^wx(tx}-_}!OMz!O!PMz!P!Q$q!Q![Mz![!]Mz!]!^-_!^!_*V!_!a&X!a!c-_!c!}Mz!}#R-_#R#SMz#S#T1k#T#oMz#o#s-_#s$f$q$f$}-_$}%OMz%O%W-_%W%oMz%o%p-_%p&aMz&a&b-_&b1pMz1p4UMz4U4dMz4d4e-_4e$ISMz$IS$I`-_$I`$IbMz$Ib$Je-_$Je$JgMz$Jg$Kh-_$Kh%#tMz%#t&/x-_&/x&EtMz&Et&FV-_&FV;'SMz;'S;:j!#|;:j;=`3X<%l?&r-_?&r?AhMz?Ah?BY$q?BY?MnMz?MnO$q!a!$PP;=`<%lMz!R!$ZY!b`!dpOq*Vqr!$yrs(Vsv*Vwx)ex!a*V!a!b!4t!b;'S*V;'S;=`*s<%lO*V!R!%Q]!b`!dpOr*Vrs(Vsv*Vwx)ex}*V}!O!%y!O!f*V!f!g!']!g#W*V#W#X!0`#X;'S*V;'S;=`*s<%lO*V!R!&QX!b`!dpOr*Vrs(Vsv*Vwx)ex}*V}!O!&m!O;'S*V;'S;=`*s<%lO*V!R!&vV!b`!dp!ePOr*Vrs(Vsv*Vwx)ex;'S*V;'S;=`*s<%lO*V!R!'dX!b`!dpOr*Vrs(Vsv*Vwx)ex!q*V!q!r!(P!r;'S*V;'S;=`*s<%lO*V!R!(WX!b`!dpOr*Vrs(Vsv*Vwx)ex!e*V!e!f!(s!f;'S*V;'S;=`*s<%lO*V!R!(zX!b`!dpOr*Vrs(Vsv*Vwx)ex!v*V!v!w!)g!w;'S*V;'S;=`*s<%lO*V!R!)nX!b`!dpOr*Vrs(Vsv*Vwx)ex!{*V!{!|!*Z!|;'S*V;'S;=`*s<%lO*V!R!*bX!b`!dpOr*Vrs(Vsv*Vwx)ex!r*V!r!s!*}!s;'S*V;'S;=`*s<%lO*V!R!+UX!b`!dpOr*Vrs(Vsv*Vwx)ex!g*V!g!h!+q!h;'S*V;'S;=`*s<%lO*V!R!+xY!b`!dpOr!+qrs!,hsv!+qvw!-Swx!.[x!`!+q!`!a!/j!a;'S!+q;'S;=`!0Y<%lO!+qq!,mV!dpOv!,hvx!-Sx!`!,h!`!a!-q!a;'S!,h;'S;=`!.U<%lO!,hP!-VTO!`!-S!`!a!-f!a;'S!-S;'S;=`!-k<%lO!-SP!-kO|PP!-nP;=`<%l!-Sq!-xS!dp|POv(Vx;'S(V;'S;=`(h<%lO(Vq!.XP;=`<%l!,ha!.aX!b`Or!.[rs!-Ssv!.[vw!-Sw!`!.[!`!a!.|!a;'S!.[;'S;=`!/d<%lO!.[a!/TT!b`|POr)esv)ew;'S)e;'S;=`)y<%lO)ea!/gP;=`<%l!.[!R!/sV!b`!dp|POr*Vrs(Vsv*Vwx)ex;'S*V;'S;=`*s<%lO*V!R!0]P;=`<%l!+q!R!0gX!b`!dpOr*Vrs(Vsv*Vwx)ex#c*V#c#d!1S#d;'S*V;'S;=`*s<%lO*V!R!1ZX!b`!dpOr*Vrs(Vsv*Vwx)ex#V*V#V#W!1v#W;'S*V;'S;=`*s<%lO*V!R!1}X!b`!dpOr*Vrs(Vsv*Vwx)ex#h*V#h#i!2j#i;'S*V;'S;=`*s<%lO*V!R!2qX!b`!dpOr*Vrs(Vsv*Vwx)ex#m*V#m#n!3^#n;'S*V;'S;=`*s<%lO*V!R!3eX!b`!dpOr*Vrs(Vsv*Vwx)ex#d*V#d#e!4Q#e;'S*V;'S;=`*s<%lO*V!R!4XX!b`!dpOr*Vrs(Vsv*Vwx)ex#X*V#X#Y!+q#Y;'S*V;'S;=`*s<%lO*V!R!4{Y!b`!dpOr!4trs!5ksv!4tvw!6Vwx!8]x!a!4t!a!b!:]!b;'S!4t;'S;=`!;r<%lO!4tq!5pV!dpOv!5kvx!6Vx!a!5k!a!b!7W!b;'S!5k;'S;=`!8V<%lO!5kP!6YTO!a!6V!a!b!6i!b;'S!6V;'S;=`!7Q<%lO!6VP!6lTO!`!6V!`!a!6{!a;'S!6V;'S;=`!7Q<%lO!6VP!7QOyPP!7TP;=`<%l!6Vq!7]V!dpOv!5kvx!6Vx!`!5k!`!a!7r!a;'S!5k;'S;=`!8V<%lO!5kq!7yS!dpyPOv(Vx;'S(V;'S;=`(h<%lO(Vq!8YP;=`<%l!5ka!8bX!b`Or!8]rs!6Vsv!8]vw!6Vw!a!8]!a!b!8}!b;'S!8];'S;=`!:V<%lO!8]a!9SX!b`Or!8]rs!6Vsv!8]vw!6Vw!`!8]!`!a!9o!a;'S!8];'S;=`!:V<%lO!8]a!9vT!b`yPOr)esv)ew;'S)e;'S;=`)y<%lO)ea!:YP;=`<%l!8]!R!:dY!b`!dpOr!4trs!5ksv!4tvw!6Vwx!8]x!`!4t!`!a!;S!a;'S!4t;'S;=`!;r<%lO!4t!R!;]V!b`!dpyPOr*Vrs(Vsv*Vwx)ex;'S*V;'S;=`*s<%lO*V!R!;uP;=`<%l!4t!V!<TXjSaP!b`!dpOr&Xrs&}sv&Xwx(tx!^&X!^!_*V!_;'S&X;'S;=`*y<%lO&X",
    tokenizers: [
        $07236028cbce11ab$var$scriptTokens,
        $07236028cbce11ab$var$styleTokens,
        $07236028cbce11ab$var$textareaTokens,
        $07236028cbce11ab$var$endTag,
        $07236028cbce11ab$var$tagStart,
        $07236028cbce11ab$var$commentContent,
        0,
        1,
        2,
        3,
        4,
        5
    ],
    topRules: {
        "Document": [
            0,
            16
        ]
    },
    dialects: {
        noMatch: 0,
        selfClosing: 515
    },
    tokenPrec: 517
});
function $07236028cbce11ab$var$getAttrs(openTag, input) {
    let attrs = Object.create(null);
    for (let att of openTag.getChildren($07236028cbce11ab$var$Attribute)){
        let name = att.getChild($07236028cbce11ab$var$AttributeName), value = att.getChild($07236028cbce11ab$var$AttributeValue) || att.getChild($07236028cbce11ab$var$UnquotedAttributeValue);
        if (name) attrs[input.read(name.from, name.to)] = !value ? "" : value.type.id == $07236028cbce11ab$var$AttributeValue ? input.read(value.from + 1, value.to - 1) : input.read(value.from, value.to);
    }
    return attrs;
}
function $07236028cbce11ab$var$findTagName(openTag, input) {
    let tagNameNode = openTag.getChild($07236028cbce11ab$var$TagName);
    return tagNameNode ? input.read(tagNameNode.from, tagNameNode.to) : " ";
}
function $07236028cbce11ab$var$maybeNest(node, input, tags) {
    let attrs;
    for (let tag of tags){
        if (!tag.attrs || tag.attrs(attrs || (attrs = $07236028cbce11ab$var$getAttrs(node.node.parent.firstChild, input)))) return {
            parser: tag.parser,
            bracketed: true
        };
    }
    return null;
}
// tags?: {
//   tag: string,
//   attrs?: ({[attr: string]: string}) => boolean,
//   parser: Parser
// }[]
// attributes?: {
//   name: string,
//   tagName?: string,
//   parser: Parser
// }[]
function $07236028cbce11ab$export$3a6217e5968adf01(tags = [], attributes = []) {
    let script = [], style = [], textarea = [], other = [];
    for (let tag of tags){
        let array = tag.tag == "script" ? script : tag.tag == "style" ? style : tag.tag == "textarea" ? textarea : other;
        array.push(tag);
    }
    let attrs = attributes.length ? Object.create(null) : null;
    for (let attr of attributes)(attrs[attr.name] || (attrs[attr.name] = [])).push(attr);
    return (0, $ed739beecf769914$export$5dcc455959c76221)((node, input)=>{
        let id = node.type.id;
        if (id == $07236028cbce11ab$var$ScriptText) return $07236028cbce11ab$var$maybeNest(node, input, script);
        if (id == $07236028cbce11ab$var$StyleText) return $07236028cbce11ab$var$maybeNest(node, input, style);
        if (id == $07236028cbce11ab$var$TextareaText) return $07236028cbce11ab$var$maybeNest(node, input, textarea);
        if (id == $07236028cbce11ab$var$Element && other.length) {
            let n = node.node, open = n.firstChild, tagName = open && $07236028cbce11ab$var$findTagName(open, input), attrs;
            if (tagName) {
                for (let tag of other)if (tag.tag == tagName && (!tag.attrs || tag.attrs(attrs || (attrs = $07236028cbce11ab$var$getAttrs(open, input))))) {
                    let close = n.lastChild;
                    let to = close.type.id == $07236028cbce11ab$var$CloseTag ? close.from : n.to;
                    if (to > open.to) return {
                        parser: tag.parser,
                        overlay: [
                            {
                                from: open.to,
                                to: to
                            }
                        ]
                    };
                }
            }
        }
        if (attrs && id == $07236028cbce11ab$var$Attribute) {
            let n = node.node, nameNode;
            if (nameNode = n.firstChild) {
                let matches = attrs[input.read(nameNode.from, nameNode.to)];
                if (matches) for (let attr of matches){
                    if (attr.tagName && attr.tagName != $07236028cbce11ab$var$findTagName(n.parent, input)) continue;
                    let value = n.lastChild;
                    if (value.type.id == $07236028cbce11ab$var$AttributeValue) {
                        let from = value.from + 1;
                        let last = value.lastChild, to = value.to - (last && last.isError ? 0 : 1);
                        if (to > from) return {
                            parser: attr.parser,
                            overlay: [
                                {
                                    from: from,
                                    to: to
                                }
                            ],
                            bracketed: true
                        };
                    } else if (value.type.id == $07236028cbce11ab$var$UnquotedAttributeValue) return {
                        parser: attr.parser,
                        overlay: [
                            {
                                from: value.from,
                                to: value.to
                            }
                        ]
                    };
                }
            }
        }
        return null;
    });
}




// This file was generated by lezer-generator. You probably shouldn't edit it.
const $2479bc0bd5ea48bf$var$descendantOp = 135, $2479bc0bd5ea48bf$var$Unit = 1, $2479bc0bd5ea48bf$var$identifier = 136, $2479bc0bd5ea48bf$var$callee = 137, $2479bc0bd5ea48bf$var$VariableName = 2, $2479bc0bd5ea48bf$var$queryIdentifier = 138, $2479bc0bd5ea48bf$var$queryVariableName = 3, $2479bc0bd5ea48bf$var$QueryCallee = 4;
/* Hand-written tokenizers for CSS tokens that can't be
   expressed by Lezer's built-in tokenizer. */ const $2479bc0bd5ea48bf$var$space = [
    9,
    10,
    11,
    12,
    13,
    32,
    133,
    160,
    5760,
    8192,
    8193,
    8194,
    8195,
    8196,
    8197,
    8198,
    8199,
    8200,
    8201,
    8202,
    8232,
    8233,
    8239,
    8287,
    12288
];
const $2479bc0bd5ea48bf$var$colon = 58, $2479bc0bd5ea48bf$var$parenL = 40, $2479bc0bd5ea48bf$var$underscore = 95, $2479bc0bd5ea48bf$var$bracketL = 91, $2479bc0bd5ea48bf$var$dash = 45, $2479bc0bd5ea48bf$var$period = 46, $2479bc0bd5ea48bf$var$hash = 35, $2479bc0bd5ea48bf$var$percent = 37, $2479bc0bd5ea48bf$var$ampersand = 38, $2479bc0bd5ea48bf$var$backslash = 92, $2479bc0bd5ea48bf$var$newline = 10, $2479bc0bd5ea48bf$var$asterisk = 42;
function $2479bc0bd5ea48bf$var$isAlpha(ch) {
    return ch >= 65 && ch <= 90 || ch >= 97 && ch <= 122 || ch >= 161;
}
function $2479bc0bd5ea48bf$var$isDigit(ch) {
    return ch >= 48 && ch <= 57;
}
function $2479bc0bd5ea48bf$var$isHex(ch) {
    return $2479bc0bd5ea48bf$var$isDigit(ch) || ch >= 97 && ch <= 102 || ch >= 65 && ch <= 70;
}
const $2479bc0bd5ea48bf$var$identifierTokens = (id, varName, callee)=>(input, stack)=>{
        for(let inside = false, dashes = 0, i = 0;; i++){
            let { next: next } = input;
            if ($2479bc0bd5ea48bf$var$isAlpha(next) || next == $2479bc0bd5ea48bf$var$dash || next == $2479bc0bd5ea48bf$var$underscore || inside && $2479bc0bd5ea48bf$var$isDigit(next)) {
                if (!inside && (next != $2479bc0bd5ea48bf$var$dash || i > 0)) inside = true;
                if (dashes === i && next == $2479bc0bd5ea48bf$var$dash) dashes++;
                input.advance();
            } else if (next == $2479bc0bd5ea48bf$var$backslash && input.peek(1) != $2479bc0bd5ea48bf$var$newline) {
                input.advance();
                if ($2479bc0bd5ea48bf$var$isHex(input.next)) {
                    do input.advance();
                    while ($2479bc0bd5ea48bf$var$isHex(input.next));
                    if (input.next == 32) input.advance();
                } else if (input.next > -1) input.advance();
                inside = true;
            } else {
                if (inside) input.acceptToken(dashes == 2 && stack.canShift($2479bc0bd5ea48bf$var$VariableName) ? varName : next == $2479bc0bd5ea48bf$var$parenL ? callee : id);
                break;
            }
        }
    };
const $2479bc0bd5ea48bf$var$identifiers = new (0, $96e8fc72168067c5$export$6e56a42e94c6b2cb)($2479bc0bd5ea48bf$var$identifierTokens($2479bc0bd5ea48bf$var$identifier, $2479bc0bd5ea48bf$var$VariableName, $2479bc0bd5ea48bf$var$callee), {
    contextual: true
});
const $2479bc0bd5ea48bf$var$queryIdentifiers = new (0, $96e8fc72168067c5$export$6e56a42e94c6b2cb)($2479bc0bd5ea48bf$var$identifierTokens($2479bc0bd5ea48bf$var$queryIdentifier, $2479bc0bd5ea48bf$var$queryVariableName, $2479bc0bd5ea48bf$var$QueryCallee), {
    contextual: true
});
const $2479bc0bd5ea48bf$var$descendant = new (0, $96e8fc72168067c5$export$6e56a42e94c6b2cb)((input)=>{
    if ($2479bc0bd5ea48bf$var$space.includes(input.peek(-1))) {
        let { next: next } = input;
        if ($2479bc0bd5ea48bf$var$isAlpha(next) || next == $2479bc0bd5ea48bf$var$underscore || next == $2479bc0bd5ea48bf$var$hash || next == $2479bc0bd5ea48bf$var$period || next == $2479bc0bd5ea48bf$var$asterisk || next == $2479bc0bd5ea48bf$var$bracketL || next == $2479bc0bd5ea48bf$var$colon && $2479bc0bd5ea48bf$var$isAlpha(input.peek(1)) || next == $2479bc0bd5ea48bf$var$dash || next == $2479bc0bd5ea48bf$var$ampersand) input.acceptToken($2479bc0bd5ea48bf$var$descendantOp);
    }
});
const $2479bc0bd5ea48bf$var$unitToken = new (0, $96e8fc72168067c5$export$6e56a42e94c6b2cb)((input)=>{
    if (!$2479bc0bd5ea48bf$var$space.includes(input.peek(-1))) {
        let { next: next } = input;
        if (next == $2479bc0bd5ea48bf$var$percent) {
            input.advance();
            input.acceptToken($2479bc0bd5ea48bf$var$Unit);
        }
        if ($2479bc0bd5ea48bf$var$isAlpha(next)) {
            do input.advance();
            while ($2479bc0bd5ea48bf$var$isAlpha(input.next) || $2479bc0bd5ea48bf$var$isDigit(input.next));
            input.acceptToken($2479bc0bd5ea48bf$var$Unit);
        }
    }
});
const $2479bc0bd5ea48bf$var$cssHighlighting = (0, $a1ec9d683d365521$export$c537e79bb7b94295)({
    "AtKeyword import charset namespace keyframes media supports font-feature-values": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).definitionKeyword,
    "from to selector scope MatchFlag": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).keyword,
    NamespaceName: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).namespace,
    KeyframeName: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).labelName,
    KeyframeRangeName: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).operatorKeyword,
    TagName: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).tagName,
    ClassName: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).className,
    PseudoClassName: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).constant((0, $a1ec9d683d365521$export$8b7a896ae75accbf).className),
    IdName: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).labelName,
    "FeatureName PropertyName": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).propertyName,
    AttributeName: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).attributeName,
    NumberLiteral: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).number,
    KeywordQuery: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).keyword,
    UnaryQueryOp: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).operatorKeyword,
    "CallTag ValueName FontName": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).atom,
    VariableName: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).variableName,
    Callee: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).operatorKeyword,
    Unit: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).unit,
    "UniversalSelector NestingSelector": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).definitionOperator,
    "MatchOp CompareOp": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).compareOperator,
    "ChildOp SiblingOp, LogicOp": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).logicOperator,
    BinOp: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).arithmeticOperator,
    Important: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).modifier,
    Comment: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).blockComment,
    ColorLiteral: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).color,
    "ParenthesizedContent StringLiteral": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).string,
    ":": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).punctuation,
    "PseudoOp #": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).derefOperator,
    "; , |": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).separator,
    "( )": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).paren,
    "[ ]": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).squareBracket,
    "{ }": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).brace
});
// This file was generated by lezer-generator. You probably shouldn't edit it.
const $2479bc0bd5ea48bf$var$spec_callee = {
    __proto__: null,
    lang: 44,
    "nth-child": 44,
    "nth-last-child": 44,
    "nth-of-type": 44,
    "nth-last-of-type": 44,
    dir: 44,
    "host-context": 44,
    if: 90,
    url: 132,
    "url-prefix": 132,
    domain: 132,
    regexp: 132
};
const $2479bc0bd5ea48bf$var$spec_queryIdentifier = {
    __proto__: null,
    or: 104,
    and: 104,
    not: 112,
    only: 112,
    layer: 186
};
const $2479bc0bd5ea48bf$var$spec_QueryCallee = {
    __proto__: null,
    selector: 118,
    layer: 182
};
const $2479bc0bd5ea48bf$var$spec_AtKeyword = {
    __proto__: null,
    "@import": 178,
    "@media": 190,
    "@charset": 194,
    "@namespace": 198,
    "@keyframes": 204,
    "@supports": 216,
    "@scope": 220,
    "@font-feature-values": 226
};
const $2479bc0bd5ea48bf$var$spec_identifier = {
    __proto__: null,
    to: 223
};
const $2479bc0bd5ea48bf$export$8f49e4af10703ce3 = (0, $96e8fc72168067c5$export$60c033f4cf02b410).deserialize({
    version: 14,
    states: "IpQYQdOOO#}QdOOP$UO`OOO%OQaO'#CfOOQP'#Ce'#CeO%VQdO'#CgO%[Q`O'#CgO%aQaO'#FdO&XQdO'#CkO&xQaO'#CcO'SQdO'#CnO'_QdO'#DtO'dQdO'#DvO'oQdO'#D}O'oQdO'#EQOOQP'#Fd'#FdO)OQhO'#EsOOQS'#Fc'#FcOOQS'#Ev'#EvQYQdOOO)VQdO'#EWO*cQhO'#E^O)VQdO'#E`O*jQdO'#EbO*uQdO'#EeO)zQhO'#EkO*}QdO'#EmO+YQdO'#EpO+_QaO'#CfO+fQ`O'#ETO+kQ`O'#FnO+vQdO'#FnQOQ`OOP,QO&jO'#CaPOOO)CAR)CAROOQP'#Ci'#CiOOQP,59R,59RO%VQdO,59ROOQP'#Cm'#CmOOQP,59V,59VO&XQdO,59VO,]QdO,59YO'_QdO,5:`O'dQdO,5:bO'oQdO,5:iO'oQdO,5:kO'oQdO,5:lO'oQdO'#E}O,hQ`O,58}O,pQdO'#ESOOQS,58},58}OOQP'#Cq'#CqOOQO'#Dr'#DrOOQP,59Y,59YO,wQ`O,59YO,|Q`O,59YOOQP'#Du'#DuOOQP,5:`,5:`O-RQpO'#DwO-^QdO'#DxO-cQ`O'#DxO-hQpO,5:bO.RQaO,5:iO.iQaO,5:lOOQW'#D^'#D^O/eQhO'#DgO/xQhO,5;_O)zQhO'#DeO0VQ`O'#DkO0[QhO'#DnOOQW'#Fj'#FjOOQS,5;_,5;_O0aQ`O'#DhOOQS-E8t-E8tOOQ['#Cv'#CvO0fQdO'#CwO0|QdO'#C}O1dQdO'#DQO1zQ!pO'#DSO4TQ!jO,5:rOOQO'#DX'#DXO,|Q`O'#DWO4eQ!nO'#FgO6hQ`O'#DYO6mQ`O'#DoOOQ['#Fg'#FgO6rQhO'#FqO7QQ`O,5:xO7VQ!bO,5:zOOQS'#Ed'#EdO7_Q`O,5:|O7dQdO,5:|OOQO'#Eg'#EgO7lQ`O,5;PO7qQhO,5;VO'oQdO'#DjOOQS,5;X,5;XO0aQ`O,5;XO7yQdO,5;XOOQS'#FU'#FUO8RQdO'#ErO7QQ`O,5;[O8ZQdO,5:oO8kQdO'#FPO8xQ`O,5<YO8xQ`O,5<YPOOO'#Eu'#EuP9TO&jO,58{POOO,58{,58{OOQP1G.m1G.mOOQP1G.q1G.qOOQP1G.t1G.tO,wQ`O1G.tO,|Q`O1G.tOOQP1G/z1G/zO9`QpO1G/|O9hQaO1G0TO:OQaO1G0VO:fQaO1G0WO:|QaO,5;iOOQO-E8{-E8{OOQS1G.i1G.iO;WQ`O,5:nO;]QdO'#DsO;dQdO'#CuOOQO'#Dz'#DzOOQO,5:d,5:dO-^QdO,5:dOOQP1G/|1G/|O)VQdO1G/|O;kQ!jO'#D^O;yQ!bO,59yO<RQhO,5:ROOQO'#Fk'#FkO;|Q!bO,59}O<ZQhO'#FVO)zQhO,59{O)zQhO'#FVO=OQhO1G0yOOQS1G0y1G0yO=YQhO,5:PO>QQhO'#DlOOQW,5:V,5:VOOQW,5:Y,5:YOOQW,5:S,5:SO>[Q!fO'#FhOOQS'#Fh'#FhOOQS'#Ex'#ExO?lQdO,59cOOQ[,59c,59cO@SQdO,59iOOQ[,59i,59iO@jQdO,59lOOQ[,59l,59lOOQ[,59n,59nO)VQdO,59pOAQQhO'#EYOOQW'#EY'#EYOAlQ`O1G0^O4^QhO1G0^OOQ[,59r,59rO)zQhO'#D[OOQ[,59t,59tOAqQ#tO,5:ZOA|QhO'#FROBZQ`O,5<]OOQS1G0d1G0dOOQS1G0f1G0fOOQS1G0h1G0hOBfQ`O1G0hOBkQdO'#EhOOQS1G0k1G0kOOQS1G0q1G0qOBvQaO,5:UO7QQ`O1G0sOOQS1G0s1G0sO0aQ`O1G0sOOQS-E9S-E9SOOQS1G0v1G0vOB}Q!fO1G0ZOCeQ`O'#EVOOQO1G0Z1G0ZOOQO,5;k,5;kOCjQdO,5;kOOQO-E8}-E8}OCwQ`O1G1tPOOO-E8s-E8sPOOO1G.g1G.gOOQP7+$`7+$`OOQP7+%h7+%hO)VQdO7+%hOOQS1G0Y1G0YODSQaO'#FmOD^Q`O,5:_ODcQ!fO'#EwOEaQdO'#FfOEkQ`O,59aOOQO1G0O1G0OOEpQ!bO7+%hO)VQdO1G/eOE{QhO1G/iOOQW1G/m1G/mOOQW1G/g1G/gOF^QhO,5;qOOQW-E9T-E9TOOQS7+&e7+&eOGRQhO'#D^OGaQhO'#FlOGlQ`O'#FlOGqQ`O,5:WOOQS-E8v-E8vOOQ[1G.}1G.}OOQ[1G/T1G/TOOQ[1G/W1G/WOOQ[1G/[1G/[OGvQdO,5:tOOQS7+%x7+%xOG{Q`O7+%xOHQQhO'#D]OHYQ`O,59vO)zQhO,59vOOQ[1G/u1G/uOHbQ`O1G/uOHgQhO,5;mOOQO-E9P-E9POOQS7+&S7+&SOHuQbO'#DSOOQO'#Ej'#EjOITQ`O'#EiOOQO'#Ei'#EiOI`Q`O'#FSOIhQdO,5;SOOQS,5;S,5;SOOQ[1G/p1G/pOOQS7+&_7+&_O7QQ`O7+&_OIsQ!fO'#FOO)VQdO'#FOOJzQdO7+%uOOQO7+%u7+%uOOQO,5:q,5:qOOQO1G1V1G1VOK_Q!bO<<ISOKjQdO'#E|OKtQ`O,5<XOOQP1G/y1G/yOOQS-E8u-E8uOK|QdO'#E{OLWQ`O,5<QOOQ]1G.{1G.{OOQP<<IS<<ISOL`Q`O<<ISOLeQdO7+%POOQO'#D`'#D`OLlQ!bO7+%TOLtQhO'#EzOMRQ`O,5<WO)VQdO,5<WOOQW1G/r1G/rOOQO'#E['#E[OMZQ`O1G0`OOQS<<Id<<IdO)VQdO,59wOMzQhO1G/bOOQ[1G/b1G/bONRQ`O1G/bOOQW-E8w-E8wOOQ[7+%a7+%aOOQO,5;T,5;TOBnQdO'#FTOI`Q`O,5;nOOQS,5;n,5;nOOQS-E9Q-E9QOOQS1G0n1G0nOOQS<<Iy<<IyONZQ!fO,5;jOOQS-E8|-E8|OOQO<<Ia<<IaOOQPAN>nAN>nO! bQ`OAN>nO! gQaO,5;hOOQO-E8z-E8zO! qQdO,5;gOOQO-E8y-E8yOOQW<<Hk<<HkOOQW<<Ho<<HoO! {QhO<<HoO!!^QhO,5;fO!!iQ`O,5;fOOQO-E8x-E8xO!!nQdO1G1rOGvQdO'#FQO!!xQ`O7+%zOOQW7+%z7+%zO!#QQ!bO1G/cOOQ[7+$|7+$|O!#]QhO7+$|P!#dQ`O'#EyOOQO,5;o,5;oOOQO-E9R-E9ROOQS1G1Y1G1YOOQPG24YG24YO!#iQ`OAN>ZO)VQdO1G1QO!#nQ`O7+'^OOQO,5;l,5;lOOQO-E9O-E9OOOQW<<If<<IfOOQ[<<Hh<<HhPOQW,5;e,5;eOOQWG23uG23uO!#vQdO7+&l",
    stateData: "!$Z~O$QOS$RQQ~OWVO^_O`WOcYOdYOl`OmZOp[O!r]O!u^O!{dO#ReO#TfO#VgO#YhO#`iO#bjO#ekO#|RO$XTO~OQmOWVO^_O`WOcYOdYOl`OmZOp[O!r]O!u^O!{dO#ReO#TfO#VgO#YhO#`iO#bjO#ekO#|lO$XTO~O#z$bP~P!jO$RqO~O`YXcYXdYXmYXpYXsYX!aYX!rYX!uYX#{YX$X[X~OgYX~P$ZO#|sO~O$XuO~O$XuO`$WXc$WXd$WXm$WXp$WXs$WX!a$WX!r$WX!u$WX#{$WXg$WX~O#|vO~O`xOcyOdyOmzOp{O!r|O!u!OO#{}O~Os!RO!a!PO~P&^Of!XO#|!TO#}!UO~O#|!YO~OW!^O#|![O$X!]O~OWVO^_O`WOcYOdYOmZOp[O!r]O!u^O#|RO$XTO~OS!fOc!gOd!gOh!cOs!RO!Y!eO!]!jO$O!bO~On!iO~P(dOQ!tOh!mOp!nOs!oOu!wOw!wO}!uO!d!vO#|!lO#}!rO$]!pO~OS!fOc!gOd!gOh!cO!Y!eO!]!jO$O!bO~Os$eP~P)zOw!|O!d!vO#|!{O~Ow#OO#|#OO~Oh#ROs!RO#c#TO~O#|#VO~Oc!xX~P$ZOc#YO~On#ZO#z$bXr$bX~O#z$bXr$bX~P!jO$S#^O$T#^O$U#`O~Of#eO#|!TO#}!UO~Os!RO!a!PO~Or$bP~P!jOh#oO~Oh#pO~Oo!kX!o!kX$X!mX~O#|#qO~O$X#sO~Oo#tO!o#uO~O`xOcyOdyOmzOp{O~Os!qa!a!qa!r!qa!u!qa#{!qag!qa~P-pOs!ta!a!ta!r!ta!u!ta#{!tag!ta~P-pOS!fOc!gOd!gOh!cO!Y!eO!]!jO~OR#yOu#yOw#yO$O#vO$]!pO~P/POn$PO!U#|O!a#}O~P(dOh$RO~O$O$TO~Oh#RO~O`$WOc$WOg$ZOl$WOm$WOn$WO~P)VO`$WOc$WOl$WOm$WOn$WOo$]O~P)VO`$WOc$WOl$WOm$WOn$WOr$_O~P)VOP$`OSvXcvXdvXhvXnvXyvX!YvX!]vX!}vX#PvX$OvX!WvXQvX`vXgvXlvXmvXpvXsvXuvXwvX}vX!dvX#|vX#}vX$]vXovXrvX!avX#zvX$dvX!pvX~Oy$aO!}$bO#P$cOn$eP~P)zOh#pOS$ZXc$ZXd$ZXn$ZXy$ZX!Y$ZX!]$ZX!}$ZX#P$ZX$O$ZXQ$ZX`$ZXg$ZXl$ZXm$ZXp$ZXs$ZXu$ZXw$ZX}$ZX!d$ZX#|$ZX#}$ZX$]$ZXo$ZXr$ZX!a$ZX#z$ZX$d$ZX!p$ZX~Oh$gO~Oh$iO~O!U#|O!a$jOs$eXn$eX~Os!RO~On$mOy$aO~On$nO~Ow$oO!d!vO~Os$pO~Os!RO!U#|O~Os!RO#c$vO~O#|#VOs#fX~O$d$zOn!wa#z!war!wa~P)VOn#sX#z#sXr#sX~P!jOn#ZO#z$bar$ba~O$S#^O$T#^O$U%RO~Oo%TO!o%UO~Os!qi!a!qi!r!qi!u!qi#{!qig!qi~P-pOs!si!a!si!r!si!u!si#{!sig!si~P-pOs!ti!a!ti!r!ti!u!ti#{!tig!ti~P-pOs#qa!a#qa~P&^Or%VO~Og$aP~P'oOg$YP~P)VOc!SXg!QX!U!QX!W!SX~Oc%_O!W%`O~Og%aO!U#|O~O!U#|OS#yXc#yXd#yXh#yXn#yXs#yX!Y#yX!]#yX!a#yX$O#yX~On%eO!a#}O~P(dO!U#|OS!Xac!Xad!Xah!Xan!Xas!Xa!Y!Xa!]!Xa!a!Xa$O!Xag!Xa~O$O%fOg$`P~P/POy$aOQ$[X`$[Xc$[Xg$[Xh$[Xl$[Xm$[Xn$[Xp$[Xs$[Xu$[Xw$[X}$[X!d$[X#|$[X#}$[X$]$[Xo$[Xr$[X~O`$WOc$WOg%kOl$WOm$WOn$WO~P)VO`$WOc$WOl$WOm$WOn$WOo%lO~P)VO`$WOc$WOl$WOm$WOn$WOr%mO~P)VOh%oOS!|Xc!|Xd!|Xn!|X!Y!|X!]!|X$O!|X~On%pO~Og%uOw%vO!e%vO~Os#uX!a#uXn#uX~P)zO!a$jOs$ean$ea~On%yO~Or&QO#|%{O$]%zO~Og&RO~P&^Oy$aO!a&VO$d$zOn!wi#z!wir!wi~P)VO$c&YO~On#sa#z#sar#sa~P!jOn#ZO#z$bir$bi~O!a&]Og$aX~P&^Og&_O~Oy$aOQ#kXg#kXh#kXp#kXs#kXu#kXw#kX}#kX!a#kX!d#kX#|#kX#}#kX$]#kX~O!a&aOg$YX~P)VOg&cO~Oo&dOy$aO!p&eO~OR#yOu#yOw#yO$O&gO$]!pO~O!U#|OS#yac#yad#yah#yan#yas#ya!Y#ya!]#ya!a#ya$O#ya~Oc!SXg!QX!U!QX!a!QX~O!U#|O!a&iOg$`X~Oc&kO~Og&lO~O#|&mO~On&oO~Oc&pO!U#|O~Og&rOn&qO~Og&uO~O!U#|Os#ua!a#uan#ua~OP$`OsvX!avXgvX~O$]%zOs#]X!a#]X~Os!RO!a&wO~Or&{O#|%{O$]%zO~Oy$aOQ#rXh#rXn#rXp#rXs#rXu#rXw#rX}#rX!a#rX!d#rX#z#rX#|#rX#}#rX$]#rX$d#rXr#rX~O!a&VO$d$zOn!wq#z!wqr!wq~P)VOo'QOy$aO!p'RO~Og#pX!a#pX~P'oO!a&]Og$aa~Og#oX!a#oX~P)VO!a&aOg$Ya~Oo'QO~Og'WO~P)VOg'XO!W'YO~O$O%fOg#nX!a#nX~P/PO!a&iOg$`a~O`'_Og'aO~OS#mac#mad#mah#ma!Y#ma!]#ma$O#ma~Og'cO~PMcOg'cOn'dO~Oy$aOQ#rah#ran#rap#ras#rau#raw#ra}#ra!a#ra!d#ra#z#ra#|#ra#}#ra$]#ra$d#rar#ra~Oo'iO~Og#pa!a#pa~P&^Og#oa!a#oa~P)VOR#yOu#yOw#yO$O&gO$]%zO~O!U#|Og#na!a#na~Oc'kO~O!a&iOg$`i~P)VO`'_Og'oO~Oy$aOg!Pin!Pi~Og'pO~PMcOn'qO~Og'rO~O!a&iOg$`q~Og#nq!a#nq~P)VO$Q!e$R$]`$]y!u~",
    goto: "4h$fPPPPP$gP$jP$s%V$s%i%{P$sP&R$sPP&XPPP&_&i&iPPPPP&iPP&iP'VP&iP&i(Q&iP(n(q(w(w)Z(wP(wP(wP(w(wP)j(w)vP(w)yPP*m*s$s*y$s+P+P+V+ZPP$sP$s$sP+a,],j,q$jP,zP,}P$jP$jP$jP-T$jP-W-Z-^-e$jP$jPP$jP-j$jP-m-s.S.j.x/O/Y/`/f/l/r/|0S0Y0`0f0lPPPPPPPPPPP0r0{P1q1t2vP3O3x4R4U4XPP4_RrQ_aOPco!R#Z$}q_OP]^co|}!O!P!R#R#Z#o$}&]qSOP]^co|}!O!P!R#R#Z#o$}&]qUOP]^co|}!O!P!R#R#Z#o$}&]QtTR#auQwWR#bxQ!VYR#cyQ#c!XS$f!s!tR%S#e!V!wdf!m!n!o#Y#p#u$Y$[$^$a$y%U%Z%_&V&W&a&f&k&p'U'^'k's!U!wdf!m!n!o#Y#p#u$Y$[$^$a$y%U%Z%_&V&W&a&f&k&p'U'^'k'sU#y!c%`'YU%}$p&P&wR&v%|!V!sdf!m!n!o#Y#p#u$Y$[$^$a$y%U%Z%_&V&W&a&f&k&p'U'^'k'sR$h!uQ%s$gR&s%tq!h`ei!c!d!e!q#|#}$O$R$e$g$j%t&iQ#w!cQ%h$RQ&h%`Q'[&iR'j'YQ#UjQ$U!jQ$t#TR&T$vR$S!f!U!wdf!m!n!o#Y#p#u$Y$[$^$a$y%U%Z%_&V&W&a&f&k&p'U'^'k'sQ!|gR$o!}Q!WYR#dyQ#c!WR%S#dQ!ZZR#fzQ!_[R#g{T!^[{Q#r!]R%]#sQ!SXQ!i`Q#SjQ#m!QQ$P!dQ$l!yQ$r#QQ$u#UQ$x#XQ%e$OQ&S$tQ&y&OQ&|&TR'h&xSnP!RQ#]oQ$|#ZR&Z$}ZmPo!R#Z$}Q${#YQ&X$yR'P&WR$e!qQ&n%oR'm'_R!}gR#PhR$q#PS&O$p&PR'f&wV%|$p&P&wR#XkQ#_qR%Q#_QcOSoP!RU!kco$}R$}#ZQ%Z#pY&`%Z&f'U'^'sQ&f%_Q'U&aQ'^&kR's'kQ$Y!mQ$[!nQ$^!oV%j$Y$[$^Q%t$gR&t%tQ&j%gS']&j'lR'l'^Q&b%ZR'V&bQ&^%WR'T&^Q!QXR#l!QQ&W$yR'O&WQ#[nS%O#[%PR%P#]Q'`&nR'n'`Q$k!xR%x$kQ&P$pR&z&PQ&x&OR'g&xQ#WkR$w#WQ$O!dR%d$O_bOPco!R#Z$}^XOPco!R#Z$}Q!`]Q!a^Q#h|Q#i}Q#j!OQ#k!PQ$s#RQ%W#oR'S&]R%[#pQ!qdQ!zf[$V!m!n!o$Y$[$^Q$y#Yd%Y#p%Z%_&a&f&k'U'^'k'sQ%^#uQ%n$aS&U$y&WQ&[%UQ&}&VR'b&p]$X!m!n!o$Y$[$^Q!d`U!xe!q$eQ#QiQ#x!cS#{!d$OQ$Q!eQ%b#|Q%c#}Q%g$RS%r$g%tQ%w$jR'Z&iQ#z!cQ&h%`R'j'YR%i$RR%X#oQpPR#n!RQ!yeQ$d!qR%q$e",
    nodeNames: "\u26A0 Unit VariableName VariableName QueryCallee Comment StyleSheet RuleSet UniversalSelector TagSelector TagName NamespacedTagSelector NamespaceName TagName NestingSelector ClassSelector . ClassName PseudoClassSelector : :: PseudoClassName PseudoClassName ) ( ArgList ValueName ParenthesizedValue AtKeyword # ; ] [ BracketedValue } { BracedValue ColorLiteral NumberLiteral StringLiteral BinaryExpression BinOp CallExpression Callee IfExpression if ArgList IfBranch KeywordQuery FeatureQuery FeatureName BinaryQuery LogicOp ComparisonQuery CompareOp UnaryQuery UnaryQueryOp ParenthesizedQuery SelectorQuery selector ParenthesizedSelector CallQuery ArgList , PseudoQuery CallLiteral CallTag ParenthesizedContent PseudoClassName ArgList IdSelector IdName AttributeSelector AttributeName NamespacedAttribute NamespaceName AttributeName MatchOp MatchFlag ChildSelector ChildOp DescendantSelector SiblingSelector SiblingOp Block Declaration PropertyName Important ImportStatement import Layer layer LayerName layer MediaStatement media CharsetStatement charset NamespaceStatement namespace NamespaceName KeyframesStatement keyframes KeyframeName KeyframeList KeyframeSelector KeyframeRangeName SupportsStatement supports ScopeStatement scope to FontFeatureStatement font-feature-values FontName AtRule Styles",
    maxTerm: 159,
    nodeProps: [
        [
            "isolate",
            -2,
            5,
            39,
            ""
        ],
        [
            "openedBy",
            23,
            "(",
            31,
            "[",
            34,
            "{"
        ],
        [
            "closedBy",
            24,
            ")",
            32,
            "]",
            35,
            "}"
        ]
    ],
    propSources: [
        $2479bc0bd5ea48bf$var$cssHighlighting
    ],
    skippedNodes: [
        0,
        5,
        117
    ],
    repeatNodeCount: 17,
    tokenData: "K`~R!bOX%ZX^&R^p%Zpq&Rqr)ers)vst+jtu2Xuv%Zvw3Rwx3dxy5Ryz5dz{5i{|6S|}:u}!O;W!O!P;u!P!Q<^!Q![=V![!]>Q!]!^>|!^!_?_!_!`@Z!`!a@n!a!b%Z!b!cAo!c!k%Z!k!lC|!l!u%Z!u!vC|!v!}%Z!}#OD_#O#P%Z#P#QDp#Q#R2X#R#]%Z#]#^ER#^#g%Z#g#hC|#h#o%Z#o#pIf#p#qIw#q#rJ`#r#sJq#s#y%Z#y#z&R#z$f%Z$f$g&R$g#BY%Z#BY#BZ&R#BZ$IS%Z$IS$I_&R$I_$I|%Z$I|$JO&R$JO$JT%Z$JT$JU&R$JU$KV%Z$KV$KW&R$KW&FU%Z&FU&FV&R&FV;'S%Z;'S;=`KY<%lO%Z`%^SOy%jz;'S%j;'S;=`%{<%lO%j`%oS!e`Oy%jz;'S%j;'S;=`%{<%lO%j`&OP;=`<%l%j~&Wh$Q~OX%jX^'r^p%jpq'rqy%jz#y%j#y#z'r#z$f%j$f$g'r$g#BY%j#BY#BZ'r#BZ$IS%j$IS$I_'r$I_$I|%j$I|$JO'r$JO$JT%j$JT$JU'r$JU$KV%j$KV$KW'r$KW&FU%j&FU&FV'r&FV;'S%j;'S;=`%{<%lO%j~'yh$Q~!e`OX%jX^'r^p%jpq'rqy%jz#y%j#y#z'r#z$f%j$f$g'r$g#BY%j#BY#BZ'r#BZ$IS%j$IS$I_'r$I_$I|%j$I|$JO'r$JO$JT%j$JT$JU'r$JU$KV%j$KV$KW'r$KW&FU%j&FU&FV'r&FV;'S%j;'S;=`%{<%lO%jj)jS$dYOy%jz;'S%j;'S;=`%{<%lO%j~)yWOY)vZr)vrs*cs#O)v#O#P*h#P;'S)v;'S;=`+d<%lO)v~*hOw~~*kRO;'S)v;'S;=`*t;=`O)v~*wXOY)vZr)vrs*cs#O)v#O#P*h#P;'S)v;'S;=`+d;=`<%l)v<%lO)v~+gP;=`<%l)vj+oYmYOy%jz!Q%j!Q![,_![!c%j!c!i,_!i#T%j#T#Z,_#Z;'S%j;'S;=`%{<%lO%jj,dY!e`Oy%jz!Q%j!Q![-S![!c%j!c!i-S!i#T%j#T#Z-S#Z;'S%j;'S;=`%{<%lO%jj-XY!e`Oy%jz!Q%j!Q![-w![!c%j!c!i-w!i#T%j#T#Z-w#Z;'S%j;'S;=`%{<%lO%jj.OYuY!e`Oy%jz!Q%j!Q![.n![!c%j!c!i.n!i#T%j#T#Z.n#Z;'S%j;'S;=`%{<%lO%jj.uYuY!e`Oy%jz!Q%j!Q![/e![!c%j!c!i/e!i#T%j#T#Z/e#Z;'S%j;'S;=`%{<%lO%jj/jY!e`Oy%jz!Q%j!Q![0Y![!c%j!c!i0Y!i#T%j#T#Z0Y#Z;'S%j;'S;=`%{<%lO%jj0aYuY!e`Oy%jz!Q%j!Q![1P![!c%j!c!i1P!i#T%j#T#Z1P#Z;'S%j;'S;=`%{<%lO%jj1UY!e`Oy%jz!Q%j!Q![1t![!c%j!c!i1t!i#T%j#T#Z1t#Z;'S%j;'S;=`%{<%lO%jj1{SuY!e`Oy%jz;'S%j;'S;=`%{<%lO%jd2[UOy%jz!_%j!_!`2n!`;'S%j;'S;=`%{<%lO%jd2uS!oS!e`Oy%jz;'S%j;'S;=`%{<%lO%jb3WS^QOy%jz;'S%j;'S;=`%{<%lO%j~3gWOY3dZw3dwx*cx#O3d#O#P4P#P;'S3d;'S;=`4{<%lO3d~4SRO;'S3d;'S;=`4];=`O3d~4`XOY3dZw3dwx*cx#O3d#O#P4P#P;'S3d;'S;=`4{;=`<%l3d<%lO3d~5OP;=`<%l3dj5WShYOy%jz;'S%j;'S;=`%{<%lO%j~5iOg~n5pUWQyWOy%jz!_%j!_!`2n!`;'S%j;'S;=`%{<%lO%jj6ZWyW!uQOy%jz!O%j!O!P6s!P!Q%j!Q![9x![;'S%j;'S;=`%{<%lO%jj6xU!e`Oy%jz!Q%j!Q![7[![;'S%j;'S;=`%{<%lO%jj7cY!e`$]YOy%jz!Q%j!Q![7[![!g%j!g!h8R!h#X%j#X#Y8R#Y;'S%j;'S;=`%{<%lO%jj8WY!e`Oy%jz{%j{|8v|}%j}!O8v!O!Q%j!Q![9_![;'S%j;'S;=`%{<%lO%jj8{U!e`Oy%jz!Q%j!Q![9_![;'S%j;'S;=`%{<%lO%jj9fU!e`$]YOy%jz!Q%j!Q![9_![;'S%j;'S;=`%{<%lO%jj:P[!e`$]YOy%jz!O%j!O!P7[!P!Q%j!Q![9x![!g%j!g!h8R!h#X%j#X#Y8R#Y;'S%j;'S;=`%{<%lO%jj:zS!aYOy%jz;'S%j;'S;=`%{<%lO%jj;]WyWOy%jz!O%j!O!P6s!P!Q%j!Q![9x![;'S%j;'S;=`%{<%lO%jj;zU`YOy%jz!Q%j!Q![7[![;'S%j;'S;=`%{<%lO%j~<cTyWOy%jz{<r{;'S%j;'S;=`%{<%lO%j~<yS!e`$R~Oy%jz;'S%j;'S;=`%{<%lO%jj=[[$]YOy%jz!O%j!O!P7[!P!Q%j!Q![9x![!g%j!g!h8R!h#X%j#X#Y8R#Y;'S%j;'S;=`%{<%lO%jj>VUcYOy%jz![%j![!]>i!];'S%j;'S;=`%{<%lO%jj>pSdY!e`Oy%jz;'S%j;'S;=`%{<%lO%jj?RSnYOy%jz;'S%j;'S;=`%{<%lO%jh?dU!WWOy%jz!_%j!_!`?v!`;'S%j;'S;=`%{<%lO%jh?}S!WW!e`Oy%jz;'S%j;'S;=`%{<%lO%jl@bS!WW!oSOy%jz;'S%j;'S;=`%{<%lO%jj@uV!rQ!WWOy%jz!_%j!_!`?v!`!aA[!a;'S%j;'S;=`%{<%lO%jbAcS!rQ!e`Oy%jz;'S%j;'S;=`%{<%lO%jjArYOy%jz}%j}!OBb!O!c%j!c!}CP!}#T%j#T#oCP#o;'S%j;'S;=`%{<%lO%jjBgW!e`Oy%jz!c%j!c!}CP!}#T%j#T#oCP#o;'S%j;'S;=`%{<%lO%jjCW[lY!e`Oy%jz}%j}!OCP!O!Q%j!Q![CP![!c%j!c!}CP!}#T%j#T#oCP#o;'S%j;'S;=`%{<%lO%jhDRS!pWOy%jz;'S%j;'S;=`%{<%lO%jjDdSpYOy%jz;'S%j;'S;=`%{<%lO%jnDuSo^Oy%jz;'S%j;'S;=`%{<%lO%jjEWU!pWOy%jz#a%j#a#bEj#b;'S%j;'S;=`%{<%lO%jbEoU!e`Oy%jz#d%j#d#eFR#e;'S%j;'S;=`%{<%lO%jbFWU!e`Oy%jz#c%j#c#dFj#d;'S%j;'S;=`%{<%lO%jbFoU!e`Oy%jz#f%j#f#gGR#g;'S%j;'S;=`%{<%lO%jbGWU!e`Oy%jz#h%j#h#iGj#i;'S%j;'S;=`%{<%lO%jbGoU!e`Oy%jz#T%j#T#UHR#U;'S%j;'S;=`%{<%lO%jbHWU!e`Oy%jz#b%j#b#cHj#c;'S%j;'S;=`%{<%lO%jbHoU!e`Oy%jz#h%j#h#iIR#i;'S%j;'S;=`%{<%lO%jbIYS$cQ!e`Oy%jz;'S%j;'S;=`%{<%lO%jjIkSsYOy%jz;'S%j;'S;=`%{<%lO%jfI|U$XUOy%jz!_%j!_!`2n!`;'S%j;'S;=`%{<%lO%jjJeSrYOy%jz;'S%j;'S;=`%{<%lO%jfJvU!uQOy%jz!_%j!_!`2n!`;'S%j;'S;=`%{<%lO%j`K]P;=`<%l%Z",
    tokenizers: [
        $2479bc0bd5ea48bf$var$descendant,
        $2479bc0bd5ea48bf$var$unitToken,
        $2479bc0bd5ea48bf$var$identifiers,
        $2479bc0bd5ea48bf$var$queryIdentifiers,
        1,
        2,
        3,
        4,
        new (0, $96e8fc72168067c5$export$dbe55ed82366d5e9)("m~RRYZ[z{a~~g~aO$T~~dP!P!Qg~lO$U~~", 28, 142)
    ],
    topRules: {
        "StyleSheet": [
            0,
            6
        ],
        "Styles": [
            1,
            116
        ]
    },
    dynamicPrecedences: {
        "84": 1
    },
    specialized: [
        {
            term: 137,
            get: (value)=>$2479bc0bd5ea48bf$var$spec_callee[value] || -1
        },
        {
            term: 138,
            get: (value)=>$2479bc0bd5ea48bf$var$spec_queryIdentifier[value] || -1
        },
        {
            term: 4,
            get: (value)=>$2479bc0bd5ea48bf$var$spec_QueryCallee[value] || -1
        },
        {
            term: 28,
            get: (value)=>$2479bc0bd5ea48bf$var$spec_AtKeyword[value] || -1
        },
        {
            term: 136,
            get: (value)=>$2479bc0bd5ea48bf$var$spec_identifier[value] || -1
        }
    ],
    tokenPrec: 2256
});




let $83e81cc0276b0738$var$_properties = null;
function $83e81cc0276b0738$var$properties() {
    if (!$83e81cc0276b0738$var$_properties && typeof document == "object" && document.body) {
        let { style: style } = document.body, names = [], seen = new Set;
        for(let prop in style)if (prop != "cssText" && prop != "cssFloat") {
            if (typeof style[prop] == "string") {
                if (/[A-Z]/.test(prop)) prop = prop.replace(/[A-Z]/g, (ch)=>"-" + ch.toLowerCase());
                if (!seen.has(prop)) {
                    names.push(prop);
                    seen.add(prop);
                }
            }
        }
        $83e81cc0276b0738$var$_properties = names.sort().map((name)=>({
                type: "property",
                label: name,
                apply: name + ": "
            }));
    }
    return $83e81cc0276b0738$var$_properties || [];
}
const $83e81cc0276b0738$var$pseudoClasses = /*@__PURE__*/ [
    "active",
    "after",
    "any-link",
    "autofill",
    "backdrop",
    "before",
    "checked",
    "cue",
    "default",
    "defined",
    "disabled",
    "empty",
    "enabled",
    "file-selector-button",
    "first",
    "first-child",
    "first-letter",
    "first-line",
    "first-of-type",
    "focus",
    "focus-visible",
    "focus-within",
    "fullscreen",
    "has",
    "host",
    "host-context",
    "hover",
    "in-range",
    "indeterminate",
    "invalid",
    "is",
    "lang",
    "last-child",
    "last-of-type",
    "left",
    "link",
    "marker",
    "modal",
    "not",
    "nth-child",
    "nth-last-child",
    "nth-last-of-type",
    "nth-of-type",
    "only-child",
    "only-of-type",
    "optional",
    "out-of-range",
    "part",
    "placeholder",
    "placeholder-shown",
    "read-only",
    "read-write",
    "required",
    "right",
    "root",
    "scope",
    "selection",
    "slotted",
    "target",
    "target-text",
    "valid",
    "visited",
    "where"
].map((name)=>({
        type: "class",
        label: name
    }));
const $83e81cc0276b0738$var$values = /*@__PURE__*/ [
    "above",
    "absolute",
    "activeborder",
    "additive",
    "activecaption",
    "after-white-space",
    "ahead",
    "alias",
    "all",
    "all-scroll",
    "alphabetic",
    "alternate",
    "always",
    "antialiased",
    "appworkspace",
    "asterisks",
    "attr",
    "auto",
    "auto-flow",
    "avoid",
    "avoid-column",
    "avoid-page",
    "avoid-region",
    "axis-pan",
    "background",
    "backwards",
    "baseline",
    "below",
    "bidi-override",
    "blink",
    "block",
    "block-axis",
    "bold",
    "bolder",
    "border",
    "border-box",
    "both",
    "bottom",
    "break",
    "break-all",
    "break-word",
    "bullets",
    "button",
    "button-bevel",
    "buttonface",
    "buttonhighlight",
    "buttonshadow",
    "buttontext",
    "calc",
    "capitalize",
    "caps-lock-indicator",
    "caption",
    "captiontext",
    "caret",
    "cell",
    "center",
    "checkbox",
    "circle",
    "cjk-decimal",
    "clear",
    "clip",
    "close-quote",
    "col-resize",
    "collapse",
    "color",
    "color-burn",
    "color-dodge",
    "column",
    "column-reverse",
    "compact",
    "condensed",
    "contain",
    "content",
    "contents",
    "content-box",
    "context-menu",
    "continuous",
    "copy",
    "counter",
    "counters",
    "cover",
    "crop",
    "cross",
    "crosshair",
    "currentcolor",
    "cursive",
    "cyclic",
    "darken",
    "dashed",
    "decimal",
    "decimal-leading-zero",
    "default",
    "default-button",
    "dense",
    "destination-atop",
    "destination-in",
    "destination-out",
    "destination-over",
    "difference",
    "disc",
    "discard",
    "disclosure-closed",
    "disclosure-open",
    "document",
    "dot-dash",
    "dot-dot-dash",
    "dotted",
    "double",
    "down",
    "e-resize",
    "ease",
    "ease-in",
    "ease-in-out",
    "ease-out",
    "element",
    "ellipse",
    "ellipsis",
    "embed",
    "end",
    "ethiopic-abegede-gez",
    "ethiopic-halehame-aa-er",
    "ethiopic-halehame-gez",
    "ew-resize",
    "exclusion",
    "expanded",
    "extends",
    "extra-condensed",
    "extra-expanded",
    "fantasy",
    "fast",
    "fill",
    "fill-box",
    "fixed",
    "flat",
    "flex",
    "flex-end",
    "flex-start",
    "footnotes",
    "forwards",
    "from",
    "geometricPrecision",
    "graytext",
    "grid",
    "groove",
    "hand",
    "hard-light",
    "help",
    "hidden",
    "hide",
    "higher",
    "highlight",
    "highlighttext",
    "horizontal",
    "hsl",
    "hsla",
    "hue",
    "icon",
    "ignore",
    "inactiveborder",
    "inactivecaption",
    "inactivecaptiontext",
    "infinite",
    "infobackground",
    "infotext",
    "inherit",
    "initial",
    "inline",
    "inline-axis",
    "inline-block",
    "inline-flex",
    "inline-grid",
    "inline-table",
    "inset",
    "inside",
    "intrinsic",
    "invert",
    "italic",
    "justify",
    "keep-all",
    "landscape",
    "large",
    "larger",
    "left",
    "level",
    "lighter",
    "lighten",
    "line-through",
    "linear",
    "linear-gradient",
    "lines",
    "list-item",
    "listbox",
    "listitem",
    "local",
    "logical",
    "loud",
    "lower",
    "lower-hexadecimal",
    "lower-latin",
    "lower-norwegian",
    "lowercase",
    "ltr",
    "luminosity",
    "manipulation",
    "match",
    "matrix",
    "matrix3d",
    "medium",
    "menu",
    "menutext",
    "message-box",
    "middle",
    "min-intrinsic",
    "mix",
    "monospace",
    "move",
    "multiple",
    "multiple_mask_images",
    "multiply",
    "n-resize",
    "narrower",
    "ne-resize",
    "nesw-resize",
    "no-close-quote",
    "no-drop",
    "no-open-quote",
    "no-repeat",
    "none",
    "normal",
    "not-allowed",
    "nowrap",
    "ns-resize",
    "numbers",
    "numeric",
    "nw-resize",
    "nwse-resize",
    "oblique",
    "opacity",
    "open-quote",
    "optimizeLegibility",
    "optimizeSpeed",
    "outset",
    "outside",
    "outside-shape",
    "overlay",
    "overline",
    "padding",
    "padding-box",
    "painted",
    "page",
    "paused",
    "perspective",
    "pinch-zoom",
    "plus-darker",
    "plus-lighter",
    "pointer",
    "polygon",
    "portrait",
    "pre",
    "pre-line",
    "pre-wrap",
    "preserve-3d",
    "progress",
    "push-button",
    "radial-gradient",
    "radio",
    "read-only",
    "read-write",
    "read-write-plaintext-only",
    "rectangle",
    "region",
    "relative",
    "repeat",
    "repeating-linear-gradient",
    "repeating-radial-gradient",
    "repeat-x",
    "repeat-y",
    "reset",
    "reverse",
    "rgb",
    "rgba",
    "ridge",
    "right",
    "rotate",
    "rotate3d",
    "rotateX",
    "rotateY",
    "rotateZ",
    "round",
    "row",
    "row-resize",
    "row-reverse",
    "rtl",
    "run-in",
    "running",
    "s-resize",
    "sans-serif",
    "saturation",
    "scale",
    "scale3d",
    "scaleX",
    "scaleY",
    "scaleZ",
    "screen",
    "scroll",
    "scrollbar",
    "scroll-position",
    "se-resize",
    "self-start",
    "self-end",
    "semi-condensed",
    "semi-expanded",
    "separate",
    "serif",
    "show",
    "single",
    "skew",
    "skewX",
    "skewY",
    "skip-white-space",
    "slide",
    "slider-horizontal",
    "slider-vertical",
    "sliderthumb-horizontal",
    "sliderthumb-vertical",
    "slow",
    "small",
    "small-caps",
    "small-caption",
    "smaller",
    "soft-light",
    "solid",
    "source-atop",
    "source-in",
    "source-out",
    "source-over",
    "space",
    "space-around",
    "space-between",
    "space-evenly",
    "spell-out",
    "square",
    "start",
    "static",
    "status-bar",
    "stretch",
    "stroke",
    "stroke-box",
    "sub",
    "subpixel-antialiased",
    "svg_masks",
    "super",
    "sw-resize",
    "symbolic",
    "symbols",
    "system-ui",
    "table",
    "table-caption",
    "table-cell",
    "table-column",
    "table-column-group",
    "table-footer-group",
    "table-header-group",
    "table-row",
    "table-row-group",
    "text",
    "text-bottom",
    "text-top",
    "textarea",
    "textfield",
    "thick",
    "thin",
    "threeddarkshadow",
    "threedface",
    "threedhighlight",
    "threedlightshadow",
    "threedshadow",
    "to",
    "top",
    "transform",
    "translate",
    "translate3d",
    "translateX",
    "translateY",
    "translateZ",
    "transparent",
    "ultra-condensed",
    "ultra-expanded",
    "underline",
    "unidirectional-pan",
    "unset",
    "up",
    "upper-latin",
    "uppercase",
    "url",
    "var",
    "vertical",
    "vertical-text",
    "view-box",
    "visible",
    "visibleFill",
    "visiblePainted",
    "visibleStroke",
    "visual",
    "w-resize",
    "wait",
    "wave",
    "wider",
    "window",
    "windowframe",
    "windowtext",
    "words",
    "wrap",
    "wrap-reverse",
    "x-large",
    "x-small",
    "xor",
    "xx-large",
    "xx-small"
].map((name)=>({
        type: "keyword",
        label: name
    })).concat(/*@__PURE__*/ [
    "aliceblue",
    "antiquewhite",
    "aqua",
    "aquamarine",
    "azure",
    "beige",
    "bisque",
    "black",
    "blanchedalmond",
    "blue",
    "blueviolet",
    "brown",
    "burlywood",
    "cadetblue",
    "chartreuse",
    "chocolate",
    "coral",
    "cornflowerblue",
    "cornsilk",
    "crimson",
    "cyan",
    "darkblue",
    "darkcyan",
    "darkgoldenrod",
    "darkgray",
    "darkgreen",
    "darkkhaki",
    "darkmagenta",
    "darkolivegreen",
    "darkorange",
    "darkorchid",
    "darkred",
    "darksalmon",
    "darkseagreen",
    "darkslateblue",
    "darkslategray",
    "darkturquoise",
    "darkviolet",
    "deeppink",
    "deepskyblue",
    "dimgray",
    "dodgerblue",
    "firebrick",
    "floralwhite",
    "forestgreen",
    "fuchsia",
    "gainsboro",
    "ghostwhite",
    "gold",
    "goldenrod",
    "gray",
    "grey",
    "green",
    "greenyellow",
    "honeydew",
    "hotpink",
    "indianred",
    "indigo",
    "ivory",
    "khaki",
    "lavender",
    "lavenderblush",
    "lawngreen",
    "lemonchiffon",
    "lightblue",
    "lightcoral",
    "lightcyan",
    "lightgoldenrodyellow",
    "lightgray",
    "lightgreen",
    "lightpink",
    "lightsalmon",
    "lightseagreen",
    "lightskyblue",
    "lightslategray",
    "lightsteelblue",
    "lightyellow",
    "lime",
    "limegreen",
    "linen",
    "magenta",
    "maroon",
    "mediumaquamarine",
    "mediumblue",
    "mediumorchid",
    "mediumpurple",
    "mediumseagreen",
    "mediumslateblue",
    "mediumspringgreen",
    "mediumturquoise",
    "mediumvioletred",
    "midnightblue",
    "mintcream",
    "mistyrose",
    "moccasin",
    "navajowhite",
    "navy",
    "oldlace",
    "olive",
    "olivedrab",
    "orange",
    "orangered",
    "orchid",
    "palegoldenrod",
    "palegreen",
    "paleturquoise",
    "palevioletred",
    "papayawhip",
    "peachpuff",
    "peru",
    "pink",
    "plum",
    "powderblue",
    "purple",
    "rebeccapurple",
    "red",
    "rosybrown",
    "royalblue",
    "saddlebrown",
    "salmon",
    "sandybrown",
    "seagreen",
    "seashell",
    "sienna",
    "silver",
    "skyblue",
    "slateblue",
    "slategray",
    "snow",
    "springgreen",
    "steelblue",
    "tan",
    "teal",
    "thistle",
    "tomato",
    "turquoise",
    "violet",
    "wheat",
    "white",
    "whitesmoke",
    "yellow",
    "yellowgreen"
].map((name)=>({
        type: "constant",
        label: name
    })));
const $83e81cc0276b0738$var$tags = /*@__PURE__*/ [
    "a",
    "abbr",
    "address",
    "article",
    "aside",
    "b",
    "bdi",
    "bdo",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "figcaption",
    "figure",
    "footer",
    "form",
    "header",
    "hgroup",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "label",
    "legend",
    "li",
    "main",
    "meter",
    "nav",
    "ol",
    "output",
    "p",
    "pre",
    "ruby",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "template",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "tr",
    "u",
    "ul"
].map((name)=>({
        type: "type",
        label: name
    }));
const $83e81cc0276b0738$var$atRules = /*@__PURE__*/ [
    "@charset",
    "@color-profile",
    "@container",
    "@counter-style",
    "@font-face",
    "@font-feature-values",
    "@font-palette-values",
    "@import",
    "@keyframes",
    "@layer",
    "@media",
    "@namespace",
    "@page",
    "@position-try",
    "@property",
    "@scope",
    "@starting-style",
    "@supports",
    "@view-transition"
].map((label)=>({
        type: "keyword",
        label: label
    }));
const $83e81cc0276b0738$var$identifier = /^(\w[\w-]*|-\w[\w-]*|)$/, $83e81cc0276b0738$var$variable = /^-(-[\w-]*)?$/;
function $83e81cc0276b0738$var$isVarArg(node, doc) {
    var _a;
    if (node.name == "(" || node.type.isError) node = node.parent || node;
    if (node.name != "ArgList") return false;
    let callee = (_a = node.parent) === null || _a === void 0 ? void 0 : _a.firstChild;
    if ((callee === null || callee === void 0 ? void 0 : callee.name) != "Callee") return false;
    return doc.sliceString(callee.from, callee.to) == "var";
}
const $83e81cc0276b0738$var$VariablesByNode = /*@__PURE__*/ new (0, $ed739beecf769914$export$7f13b5dc44c541ae)();
const $83e81cc0276b0738$var$declSelector = [
    "Declaration"
];
function $83e81cc0276b0738$var$astTop(node) {
    for(let cur = node;;){
        if (cur.type.isTop) return cur;
        if (!(cur = cur.parent)) return node;
    }
}
function $83e81cc0276b0738$var$variableNames(doc, node, isVariable) {
    if (node.to - node.from > 4096) {
        let known = $83e81cc0276b0738$var$VariablesByNode.get(node);
        if (known) return known;
        let result = [], seen = new Set, cursor = node.cursor((0, $ed739beecf769914$export$b0e28367f55837aa).IncludeAnonymous);
        if (cursor.firstChild()) do {
            for (let option of $83e81cc0276b0738$var$variableNames(doc, cursor.node, isVariable))if (!seen.has(option.label)) {
                seen.add(option.label);
                result.push(option);
            }
        }while (cursor.nextSibling());
        $83e81cc0276b0738$var$VariablesByNode.set(node, result);
        return result;
    } else {
        let result = [], seen = new Set;
        node.cursor().iterate((node)=>{
            var _a;
            if (isVariable(node) && node.matchContext($83e81cc0276b0738$var$declSelector) && ((_a = node.node.nextSibling) === null || _a === void 0 ? void 0 : _a.name) == ":") {
                let name = doc.sliceString(node.from, node.to);
                if (!seen.has(name)) {
                    seen.add(name);
                    result.push({
                        label: name,
                        type: "variable"
                    });
                }
            }
        });
        return result;
    }
}
/**
Create a completion source for a CSS dialect, providing a
predicate for determining what kind of syntax node can act as a
completable variable. This is used by language modes like Sass and
Less to reuse this package's completion logic.
*/ const $83e81cc0276b0738$export$d81c1c660b46cb31 = (isVariable)=>(context)=>{
        let { state: state, pos: pos } = context, node = (0, $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1)(state).resolveInner(pos, -1);
        let isDash = node.type.isError && node.from == node.to - 1 && state.doc.sliceString(node.from, node.to) == "-";
        if (node.name == "PropertyName" || (isDash || node.name == "TagName") && /^(Block|Styles)$/.test(node.resolve(node.to).name)) return {
            from: node.from,
            options: $83e81cc0276b0738$var$properties(),
            validFor: $83e81cc0276b0738$var$identifier
        };
        if (node.name == "ValueName") return {
            from: node.from,
            options: $83e81cc0276b0738$var$values,
            validFor: $83e81cc0276b0738$var$identifier
        };
        if (node.name == "PseudoClassName") return {
            from: node.from,
            options: $83e81cc0276b0738$var$pseudoClasses,
            validFor: $83e81cc0276b0738$var$identifier
        };
        if (isVariable(node) || (context.explicit || isDash) && $83e81cc0276b0738$var$isVarArg(node, state.doc)) return {
            from: isVariable(node) || isDash ? node.from : pos,
            options: $83e81cc0276b0738$var$variableNames(state.doc, $83e81cc0276b0738$var$astTop(node), isVariable),
            validFor: $83e81cc0276b0738$var$variable
        };
        if (node.name == "TagName") {
            for(let { parent: parent } = node; parent; parent = parent.parent)if (parent.name == "Block") return {
                from: node.from,
                options: $83e81cc0276b0738$var$properties(),
                validFor: $83e81cc0276b0738$var$identifier
            };
            return {
                from: node.from,
                options: $83e81cc0276b0738$var$tags,
                validFor: $83e81cc0276b0738$var$identifier
            };
        }
        if (node.name == "AtKeyword") return {
            from: node.from,
            options: $83e81cc0276b0738$var$atRules,
            validFor: $83e81cc0276b0738$var$identifier
        };
        if (!context.explicit) return null;
        let above = node.resolve(pos), before = above.childBefore(pos);
        if (before && before.name == ":" && above.name == "PseudoClassSelector") return {
            from: pos,
            options: $83e81cc0276b0738$var$pseudoClasses,
            validFor: $83e81cc0276b0738$var$identifier
        };
        if (before && before.name == ":" && above.name == "Declaration" || above.name == "ArgList") return {
            from: pos,
            options: $83e81cc0276b0738$var$values,
            validFor: $83e81cc0276b0738$var$identifier
        };
        if (above.name == "Block" || above.name == "Styles") return {
            from: pos,
            options: $83e81cc0276b0738$var$properties(),
            validFor: $83e81cc0276b0738$var$identifier
        };
        return null;
    };
/**
CSS property, variable, and value keyword completion source.
*/ const $83e81cc0276b0738$export$62bc29ba0658e894 = /*@__PURE__*/ $83e81cc0276b0738$export$d81c1c660b46cb31((n)=>n.name == "VariableName");
/**
A language provider based on the [Lezer CSS
parser](https://github.com/lezer-parser/css), extended with
highlighting and indentation information.
*/ const $83e81cc0276b0738$export$93323d80d661fcda = /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$b243968d9fb6db03).define({
    name: "css",
    parser: /*@__PURE__*/ (0, $2479bc0bd5ea48bf$export$8f49e4af10703ce3).configure({
        props: [
            /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$72c7d4c52b3c6460).add({
                Declaration: /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$688ff433e7e7cc5c)()
            }),
            /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$9b075a85eb4377d8).add({
                "Block KeyframeList": (0, $a97ccac5cf5f4f5d$export$48672beae16a681b)
            })
        ]
    }),
    languageData: {
        commentTokens: {
            block: {
                open: "/*",
                close: "*/"
            }
        },
        indentOnInput: /^\s*\}$/,
        wordChars: "-"
    }
});
/**
Language support for CSS.
*/ function $83e81cc0276b0738$export$dbf350e5966cf602() {
    return new (0, $a97ccac5cf5f4f5d$export$cbdefefa8a51dd3b)($83e81cc0276b0738$export$93323d80d661fcda, $83e81cc0276b0738$export$93323d80d661fcda.data.of({
        autocomplete: $83e81cc0276b0738$export$62bc29ba0658e894
    }));
}




// This file was generated by lezer-generator. You probably shouldn't edit it.
const $44c7044f9afa5475$var$noSemi = 316, $44c7044f9afa5475$var$noSemiType = 317, $44c7044f9afa5475$var$incdec = 1, $44c7044f9afa5475$var$incdecPrefix = 2, $44c7044f9afa5475$var$questionDot = 3, $44c7044f9afa5475$var$JSXStartTag = 4, $44c7044f9afa5475$var$insertSemi = 318, $44c7044f9afa5475$var$spaces = 320, $44c7044f9afa5475$var$newline = 321, $44c7044f9afa5475$var$LineComment = 5, $44c7044f9afa5475$var$BlockComment = 6, $44c7044f9afa5475$var$Dialect_jsx = 0;
/* Hand-written tokenizers for JavaScript tokens that can't be
   expressed by lezer's built-in tokenizer. */ const $44c7044f9afa5475$var$space = [
    9,
    10,
    11,
    12,
    13,
    32,
    133,
    160,
    5760,
    8192,
    8193,
    8194,
    8195,
    8196,
    8197,
    8198,
    8199,
    8200,
    8201,
    8202,
    8232,
    8233,
    8239,
    8287,
    12288
];
const $44c7044f9afa5475$var$braceR = 125, $44c7044f9afa5475$var$semicolon = 59, $44c7044f9afa5475$var$slash = 47, $44c7044f9afa5475$var$star = 42, $44c7044f9afa5475$var$plus = 43, $44c7044f9afa5475$var$minus = 45, $44c7044f9afa5475$var$lt = 60, $44c7044f9afa5475$var$comma = 44, $44c7044f9afa5475$var$question = 63, $44c7044f9afa5475$var$dot = 46, $44c7044f9afa5475$var$bracketL = 91;
const $44c7044f9afa5475$var$trackNewline = new (0, $96e8fc72168067c5$export$88193367295cc46b)({
    start: false,
    shift (context, term) {
        return term == $44c7044f9afa5475$var$LineComment || term == $44c7044f9afa5475$var$BlockComment || term == $44c7044f9afa5475$var$spaces ? context : term == $44c7044f9afa5475$var$newline;
    },
    strict: false
});
const $44c7044f9afa5475$var$insertSemicolon = new (0, $96e8fc72168067c5$export$6e56a42e94c6b2cb)((input, stack)=>{
    let { next: next } = input;
    if (next == $44c7044f9afa5475$var$braceR || next == -1 || stack.context) input.acceptToken($44c7044f9afa5475$var$insertSemi);
}, {
    contextual: true,
    fallback: true
});
const $44c7044f9afa5475$var$noSemicolon = new (0, $96e8fc72168067c5$export$6e56a42e94c6b2cb)((input, stack)=>{
    let { next: next } = input, after;
    if ($44c7044f9afa5475$var$space.indexOf(next) > -1) return;
    if (next == $44c7044f9afa5475$var$slash && ((after = input.peek(1)) == $44c7044f9afa5475$var$slash || after == $44c7044f9afa5475$var$star)) return;
    if (next != $44c7044f9afa5475$var$braceR && next != $44c7044f9afa5475$var$semicolon && next != -1 && !stack.context) input.acceptToken($44c7044f9afa5475$var$noSemi);
}, {
    contextual: true
});
const $44c7044f9afa5475$var$noSemicolonType = new (0, $96e8fc72168067c5$export$6e56a42e94c6b2cb)((input, stack)=>{
    if (input.next == $44c7044f9afa5475$var$bracketL && !stack.context) input.acceptToken($44c7044f9afa5475$var$noSemiType);
}, {
    contextual: true
});
const $44c7044f9afa5475$var$operatorToken = new (0, $96e8fc72168067c5$export$6e56a42e94c6b2cb)((input, stack)=>{
    let { next: next } = input;
    if (next == $44c7044f9afa5475$var$plus || next == $44c7044f9afa5475$var$minus) {
        input.advance();
        if (next == input.next) {
            input.advance();
            let mayPostfix = !stack.context && stack.canShift($44c7044f9afa5475$var$incdec);
            input.acceptToken(mayPostfix ? $44c7044f9afa5475$var$incdec : $44c7044f9afa5475$var$incdecPrefix);
        }
    } else if (next == $44c7044f9afa5475$var$question && input.peek(1) == $44c7044f9afa5475$var$dot) {
        input.advance();
        input.advance();
        if (input.next < 48 || input.next > 57) input.acceptToken($44c7044f9afa5475$var$questionDot);
    }
}, {
    contextual: true
});
function $44c7044f9afa5475$var$identifierChar(ch, start) {
    return ch >= 65 && ch <= 90 || ch >= 97 && ch <= 122 || ch == 95 || ch >= 192 || !start && ch >= 48 && ch <= 57;
}
const $44c7044f9afa5475$var$jsx = new (0, $96e8fc72168067c5$export$6e56a42e94c6b2cb)((input, stack)=>{
    if (input.next != $44c7044f9afa5475$var$lt || !stack.dialectEnabled($44c7044f9afa5475$var$Dialect_jsx)) return;
    input.advance();
    if (input.next == $44c7044f9afa5475$var$slash) return;
    // Scan for an identifier followed by a comma or 'extends', don't
    // treat this as a start tag if present.
    let back = 0;
    while($44c7044f9afa5475$var$space.indexOf(input.next) > -1){
        input.advance();
        back++;
    }
    if ($44c7044f9afa5475$var$identifierChar(input.next, true)) {
        input.advance();
        back++;
        while($44c7044f9afa5475$var$identifierChar(input.next, false)){
            input.advance();
            back++;
        }
        while($44c7044f9afa5475$var$space.indexOf(input.next) > -1){
            input.advance();
            back++;
        }
        if (input.next == $44c7044f9afa5475$var$comma) return;
        for(let i = 0;; i++){
            if (i == 7) {
                if (!$44c7044f9afa5475$var$identifierChar(input.next, true)) return;
                break;
            }
            if (input.next != "extends".charCodeAt(i)) break;
            input.advance();
            back++;
        }
    }
    input.acceptToken($44c7044f9afa5475$var$JSXStartTag, -back);
});
const $44c7044f9afa5475$var$jsHighlight = (0, $a1ec9d683d365521$export$c537e79bb7b94295)({
    "get set async static": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).modifier,
    "for while do if else switch try catch finally return throw break continue default case defer": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).controlKeyword,
    "in of await yield void typeof delete instanceof as satisfies": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).operatorKeyword,
    "let var const using function class extends": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).definitionKeyword,
    "import export from": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).moduleKeyword,
    "with debugger new": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).keyword,
    TemplateString: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).special((0, $a1ec9d683d365521$export$8b7a896ae75accbf).string),
    super: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).atom,
    BooleanLiteral: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).bool,
    this: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).self,
    null: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).null,
    Star: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).modifier,
    VariableName: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).variableName,
    "CallExpression/VariableName TaggedTemplateExpression/VariableName": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).function((0, $a1ec9d683d365521$export$8b7a896ae75accbf).variableName),
    VariableDefinition: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).definition((0, $a1ec9d683d365521$export$8b7a896ae75accbf).variableName),
    Label: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).labelName,
    PropertyName: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).propertyName,
    PrivatePropertyName: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).special((0, $a1ec9d683d365521$export$8b7a896ae75accbf).propertyName),
    "CallExpression/MemberExpression/PropertyName": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).function((0, $a1ec9d683d365521$export$8b7a896ae75accbf).propertyName),
    "FunctionDeclaration/VariableDefinition": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).function((0, $a1ec9d683d365521$export$8b7a896ae75accbf).definition((0, $a1ec9d683d365521$export$8b7a896ae75accbf).variableName)),
    "ClassDeclaration/VariableDefinition": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).definition((0, $a1ec9d683d365521$export$8b7a896ae75accbf).className),
    "NewExpression/VariableName": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).className,
    PropertyDefinition: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).definition((0, $a1ec9d683d365521$export$8b7a896ae75accbf).propertyName),
    PrivatePropertyDefinition: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).definition((0, $a1ec9d683d365521$export$8b7a896ae75accbf).special((0, $a1ec9d683d365521$export$8b7a896ae75accbf).propertyName)),
    UpdateOp: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).updateOperator,
    "LineComment Hashbang": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).lineComment,
    BlockComment: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).blockComment,
    Number: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).number,
    String: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).string,
    Escape: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).escape,
    ArithOp: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).arithmeticOperator,
    LogicOp: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).logicOperator,
    BitOp: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).bitwiseOperator,
    CompareOp: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).compareOperator,
    RegExp: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).regexp,
    Equals: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).definitionOperator,
    Arrow: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).function((0, $a1ec9d683d365521$export$8b7a896ae75accbf).punctuation),
    ": Spread": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).punctuation,
    "( )": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).paren,
    "[ ]": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).squareBracket,
    "{ }": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).brace,
    "InterpolationStart InterpolationEnd": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).special((0, $a1ec9d683d365521$export$8b7a896ae75accbf).brace),
    ".": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).derefOperator,
    ", ;": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).separator,
    "@": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).meta,
    TypeName: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).typeName,
    TypeDefinition: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).definition((0, $a1ec9d683d365521$export$8b7a896ae75accbf).typeName),
    "type enum interface implements namespace module declare": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).definitionKeyword,
    "abstract global Privacy readonly override": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).modifier,
    "is keyof unique infer asserts": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).operatorKeyword,
    JSXAttributeValue: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).attributeValue,
    JSXText: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).content,
    "JSXStartTag JSXStartCloseTag JSXSelfCloseEndTag JSXEndTag": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).angleBracket,
    "JSXIdentifier JSXNameSpacedName": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).tagName,
    "JSXAttribute/JSXIdentifier JSXAttribute/JSXNameSpacedName": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).attributeName,
    "JSXBuiltin/JSXIdentifier": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).standard((0, $a1ec9d683d365521$export$8b7a896ae75accbf).tagName)
});
// This file was generated by lezer-generator. You probably shouldn't edit it.
const $44c7044f9afa5475$var$spec_identifier = {
    __proto__: null,
    export: 20,
    as: 25,
    from: 33,
    default: 36,
    async: 41,
    function: 42,
    in: 52,
    out: 55,
    const: 56,
    extends: 60,
    this: 64,
    true: 72,
    false: 72,
    null: 84,
    void: 88,
    typeof: 92,
    super: 108,
    new: 142,
    delete: 154,
    yield: 163,
    await: 167,
    class: 172,
    public: 235,
    private: 235,
    protected: 235,
    readonly: 237,
    instanceof: 256,
    satisfies: 259,
    import: 292,
    keyof: 349,
    unique: 353,
    infer: 359,
    asserts: 395,
    is: 397,
    abstract: 417,
    implements: 419,
    type: 421,
    let: 424,
    var: 426,
    using: 429,
    interface: 435,
    enum: 439,
    namespace: 445,
    module: 447,
    declare: 451,
    global: 455,
    defer: 471,
    for: 476,
    of: 485,
    while: 488,
    with: 492,
    do: 496,
    if: 500,
    else: 502,
    switch: 506,
    case: 512,
    try: 518,
    catch: 522,
    finally: 526,
    return: 530,
    throw: 534,
    break: 538,
    continue: 542,
    debugger: 546
};
const $44c7044f9afa5475$var$spec_word = {
    __proto__: null,
    async: 129,
    get: 131,
    set: 133,
    declare: 195,
    public: 197,
    private: 197,
    protected: 197,
    static: 199,
    abstract: 201,
    override: 203,
    readonly: 209,
    accessor: 211,
    new: 401
};
const $44c7044f9afa5475$var$spec_LessThan = {
    __proto__: null,
    "<": 193
};
const $44c7044f9afa5475$export$8f49e4af10703ce3 = (0, $96e8fc72168067c5$export$60c033f4cf02b410).deserialize({
    version: 14,
    states: "$F|Q%TQlOOO%[QlOOO'_QpOOP(lO`OOO*zQ!0MxO'#CiO+RO#tO'#CjO+aO&jO'#CjO+oO#@ItO'#DaO.QQlO'#DgO.bQlO'#DrO%[QlO'#DzO0fQlO'#ESOOQ!0Lf'#E['#E[O1PQ`O'#EXOOQO'#Ep'#EpOOQO'#Il'#IlO1XQ`O'#GsO1dQ`O'#EoO1iQ`O'#EoO3hQ!0MxO'#JrO6[Q!0MxO'#JsO6uQ`O'#F]O6zQ,UO'#FtOOQ!0Lf'#Ff'#FfO7VO7dO'#FfO9XQMhO'#F|O9`Q`O'#F{OOQ!0Lf'#Js'#JsOOQ!0Lb'#Jr'#JrO9eQ`O'#GwOOQ['#K_'#K_O9pQ`O'#IYO9uQ!0LrO'#IZOOQ['#J`'#J`OOQ['#I_'#I_Q`QlOOQ`QlOOO9}Q!L^O'#DvO:UQlO'#EOO:]QlO'#EQO9kQ`O'#GsO:dQMhO'#CoO:rQ`O'#EnO:}Q`O'#EyO;hQMhO'#FeO;xQ`O'#GsOOQO'#K`'#K`O;}Q`O'#K`O<]Q`O'#G{O<]Q`O'#G|O<]Q`O'#HOO9kQ`O'#HRO=SQ`O'#HUO>kQ`O'#CeO>{Q`O'#HcO?TQ`O'#HiO?TQ`O'#HkO`QlO'#HmO?TQ`O'#HoO?TQ`O'#HrO?YQ`O'#HxO?_Q!0LsO'#IOO%[QlO'#IQO?jQ!0LsO'#ISO?uQ!0LsO'#IUO9uQ!0LrO'#IWO@QQ!0MxO'#CiOASQpO'#DlQOQ`OOO%[QlO'#EQOAjQ`O'#ETO:dQMhO'#EnOAuQ`O'#EnOBQQ!bO'#FeOOQ['#Cg'#CgOOQ!0Lb'#Dq'#DqOOQ!0Lb'#Jv'#JvO%[QlO'#JvOOQO'#Jy'#JyOOQO'#Ih'#IhOCQQpO'#EgOOQ!0Lb'#Ef'#EfOOQ!0Lb'#J}'#J}OC|Q!0MSO'#EgODWQpO'#EWOOQO'#Jx'#JxODlQpO'#JyOEyQpO'#EWODWQpO'#EgPFWO&2DjO'#CbPOOO)CD})CD}OOOO'#I`'#I`OFcO#tO,59UOOQ!0Lh,59U,59UOOOO'#Ia'#IaOFqO&jO,59UOGPQ!L^O'#DcOOOO'#Ic'#IcOGWO#@ItO,59{OOQ!0Lf,59{,59{OGfQlO'#IdOGyQ`O'#JtOIxQ!fO'#JtO+}QlO'#JtOJPQ`O,5:ROJgQ`O'#EpOJtQ`O'#KTOKPQ`O'#KSOKPQ`O'#KSOKXQ`O,5;^OK^Q`O'#KROOQ!0Ln,5:^,5:^OKeQlO,5:^OMcQ!0MxO,5:fONSQ`O,5:nONmQ!0LrO'#KQONtQ`O'#KPO9eQ`O'#KPO! YQ`O'#KPO! bQ`O,5;]O! gQ`O'#KPO!#lQ!fO'#JsOOQ!0Lh'#Ci'#CiO%[QlO'#ESO!$[Q!fO,5:sOOQS'#Jz'#JzOOQO-E<j-E<jO9kQ`O,5=_O!$rQ`O,5=_O!$wQlO,5;ZO!&zQMhO'#EkO!(eQ`O,5;ZO!(jQlO'#DyO!(tQpO,5;dO!(|QpO,5;dO%[QlO,5;dOOQ['#FT'#FTOOQ['#FV'#FVO%[QlO,5;eO%[QlO,5;eO%[QlO,5;eO%[QlO,5;eO%[QlO,5;eO%[QlO,5;eO%[QlO,5;eO%[QlO,5;eO%[QlO,5;eO%[QlO,5;eOOQ['#FZ'#FZO!)[QlO,5;tOOQ!0Lf,5;y,5;yOOQ!0Lf,5;z,5;zOOQ!0Lf,5;|,5;|O%[QlO'#IpO!+_Q!0LrO,5<iO%[QlO,5;eO!&zQMhO,5;eO!+|QMhO,5;eO!-nQMhO'#E^O%[QlO,5;wOOQ!0Lf,5;{,5;{O!-uQ,UO'#FjO!.rQ,UO'#KXO!.^Q,UO'#KXO!.yQ,UO'#KXOOQO'#KX'#KXO!/_Q,UO,5<SOOOW,5<`,5<`O!/pQlO'#FvOOOW'#Io'#IoO7VO7dO,5<QO!/wQ,UO'#FxOOQ!0Lf,5<Q,5<QO!0hQ$IUO'#CyOOQ!0Lh'#C}'#C}O!0{O#@ItO'#DRO!1iQMjO,5<eO!1pQ`O,5<hO!3YQ(CWO'#GXO!3jQ`O'#GYO!3oQ`O'#GYO!5_Q(CWO'#G^O!6dQpO'#GbOOQO'#Gn'#GnO!,TQMhO'#GmOOQO'#Gp'#GpO!,TQMhO'#GoO!7VQ$IUO'#JlOOQ!0Lh'#Jl'#JlO!7aQ`O'#JkO!7oQ`O'#JjO!7wQ`O'#CuOOQ!0Lh'#C{'#C{O!8YQ`O'#C}OOQ!0Lh'#DV'#DVOOQ!0Lh'#DX'#DXO!8_Q`O,5<eO1SQ`O'#DZO!,TQMhO'#GPO!,TQMhO'#GRO!8gQ`O'#GTO!8lQ`O'#GUO!3oQ`O'#G[O!,TQMhO'#GaO<]Q`O'#JkO!8qQ`O'#EqO!9`Q`O,5<gOOQ!0Lb'#Cr'#CrO!9hQ`O'#ErO!:bQpO'#EsOOQ!0Lb'#KR'#KRO!:iQ!0LrO'#KaO9uQ!0LrO,5=cO`QlO,5>tOOQ['#Jh'#JhOOQ[,5>u,5>uOOQ[-E<]-E<]O!<hQ!0MxO,5:bO!:]QpO,5:`O!?RQ!0MxO,5:jO%[QlO,5:jO!AiQ!0MxO,5:lOOQO,5@z,5@zO!BYQMhO,5=_O!BhQ!0LrO'#JiO9`Q`O'#JiO!ByQ!0LrO,59ZO!CUQpO,59ZO!C^QMhO,59ZO:dQMhO,59ZO!CiQ`O,5;ZO!CqQ`O'#HbO!DVQ`O'#KdO%[QlO,5;}O!:]QpO,5<PO!D_Q`O,5=zO!DdQ`O,5=zO!DiQ`O,5=zO!DwQ`O,5=zO9uQ!0LrO,5=zO<]Q`O,5=jOOQO'#Cy'#CyO!EOQpO,5=gO!EWQMhO,5=hO!EcQ`O,5=jO!EhQ!bO,5=mO!EpQ`O'#K`O?YQ`O'#HWO9kQ`O'#HYO!EuQ`O'#HYO:dQMhO'#H[O!EzQ`O'#H[OOQ[,5=p,5=pO!FPQ`O'#H]O!FbQ`O'#CoO!FgQ`O,59PO!FqQ`O,59PO!HvQlO,59POOQ[,59P,59PO!IWQ!0LrO,59PO%[QlO,59PO!KcQlO'#HeOOQ['#Hf'#HfOOQ['#Hg'#HgO`QlO,5=}O!KyQ`O,5=}O`QlO,5>TO`QlO,5>VO!LOQ`O,5>XO`QlO,5>ZO!LTQ`O,5>^O!LYQlO,5>dOOQ[,5>j,5>jO%[QlO,5>jO9uQ!0LrO,5>lOOQ[,5>n,5>nO#!dQ`O,5>nOOQ[,5>p,5>pO#!dQ`O,5>pOOQ[,5>r,5>rO##QQpO'#D_O%[QlO'#JvO##sQpO'#JvO##}QpO'#DmO#$`QpO'#DmO#&qQlO'#DmO#&xQ`O'#JuO#'QQ`O,5:WO#'VQ`O'#EtO#'eQ`O'#KUO#'mQ`O,5;_O#'rQpO'#DmO#(PQpO'#EVOOQ!0Lf,5:o,5:oO%[QlO,5:oO#(WQ`O,5:oO?YQ`O,5;YO!CUQpO,5;YO!C^QMhO,5;YO:dQMhO,5;YO#(`Q`O,5@bO#(eQ07dO,5:sOOQO-E<f-E<fO#)kQ!0MSO,5;RODWQpO,5:rO#)uQpO,5:rODWQpO,5;RO!ByQ!0LrO,5:rOOQ!0Lb'#Ej'#EjOOQO,5;R,5;RO%[QlO,5;RO#*SQ!0LrO,5;RO#*_Q!0LrO,5;RO!CUQpO,5:rOOQO,5;X,5;XO#*mQ!0LrO,5;RPOOO'#I^'#I^P#+RO&2DjO,58|POOO,58|,58|OOOO-E<^-E<^OOQ!0Lh1G.p1G.pOOOO-E<_-E<_OOOO,59},59}O#+^Q!bO,59}OOOO-E<a-E<aOOQ!0Lf1G/g1G/gO#+cQ!fO,5?OO+}QlO,5?OOOQO,5?U,5?UO#+mQlO'#IdOOQO-E<b-E<bO#+zQ`O,5@`O#,SQ!fO,5@`O#,ZQ`O,5@nOOQ!0Lf1G/m1G/mO%[QlO,5@oO#,cQ`O'#IjOOQO-E<h-E<hO#,ZQ`O,5@nOOQ!0Lb1G0x1G0xOOQ!0Ln1G/x1G/xOOQ!0Ln1G0Y1G0YO%[QlO,5@lO#,wQ!0LrO,5@lO#-YQ!0LrO,5@lO#-aQ`O,5@kO9eQ`O,5@kO#-iQ`O,5@kO#-wQ`O'#ImO#-aQ`O,5@kOOQ!0Lb1G0w1G0wO!(tQpO,5:uO!)PQpO,5:uOOQS,5:w,5:wO#.iQdO,5:wO#.qQMhO1G2yO9kQ`O1G2yOOQ!0Lf1G0u1G0uO#/PQ!0MxO1G0uO#0UQ!0MvO,5;VOOQ!0Lh'#GW'#GWO#0rQ!0MzO'#JlO!$wQlO1G0uO#2}Q!fO'#JwO%[QlO'#JwO#3XQ`O,5:eOOQ!0Lh'#D_'#D_OOQ!0Lf1G1O1G1OO%[QlO1G1OOOQ!0Lf1G1f1G1fO#3^Q`O1G1OO#5rQ!0MxO1G1PO#5yQ!0MxO1G1PO#8aQ!0MxO1G1PO#8hQ!0MxO1G1PO#;OQ!0MxO1G1PO#=fQ!0MxO1G1PO#=mQ!0MxO1G1PO#=tQ!0MxO1G1PO#@[Q!0MxO1G1PO#@cQ!0MxO1G1PO#BpQ?MtO'#CiO#DkQ?MtO1G1`O#DrQ?MtO'#JsO#EVQ!0MxO,5?[OOQ!0Lb-E<n-E<nO#GdQ!0MxO1G1PO#HaQ!0MzO1G1POOQ!0Lf1G1P1G1PO#IdQMjO'#J|O#InQ`O,5:xO#IsQ!0MxO1G1cO#JgQ,UO,5<WO#JoQ,UO,5<XO#JwQ,UO'#FoO#K`Q`O'#FnOOQO'#KY'#KYOOQO'#In'#InO#KeQ,UO1G1nOOQ!0Lf1G1n1G1nOOOW1G1y1G1yO#KvQ?MtO'#JrO#LQQ`O,5<bO!)[QlO,5<bOOOW-E<m-E<mOOQ!0Lf1G1l1G1lO#LVQpO'#KXOOQ!0Lf,5<d,5<dO#L_QpO,5<dO#LdQMhO'#DTOOOO'#Ib'#IbO#LkO#@ItO,59mOOQ!0Lh,59m,59mO%[QlO1G2PO!8lQ`O'#IrO#LvQ`O,5<zOOQ!0Lh,5<w,5<wO!,TQMhO'#IuO#MdQMjO,5=XO!,TQMhO'#IwO#NVQMjO,5=ZO!&zQMhO,5=]OOQO1G2S1G2SO#NaQ!dO'#CrO#NtQ(CWO'#ErO$ |QpO'#GbO$!dQ!dO,5<sO$!kQ`O'#K[O9eQ`O'#K[O$!yQ`O,5<uO$#aQ!dO'#C{O!,TQMhO,5<tO$#kQ`O'#GZO$$PQ`O,5<tO$$UQ!dO'#GWO$$cQ!dO'#K]O$$mQ`O'#K]O!&zQMhO'#K]O$$rQ`O,5<xO$$wQlO'#JvO$%RQpO'#GcO#$`QpO'#GcO$%dQ`O'#GgO!3oQ`O'#GkO$%iQ!0LrO'#ItO$%tQpO,5<|OOQ!0Lp,5<|,5<|O$%{QpO'#GcO$&YQpO'#GdO$&kQpO'#GdO$&pQMjO,5=XO$'QQMjO,5=ZOOQ!0Lh,5=^,5=^O!,TQMhO,5@VO!,TQMhO,5@VO$'bQ`O'#IyO$'vQ`O,5@UO$(OQ`O,59aOOQ!0Lh,59i,59iO$(TQ`O,5@VO$)TQ$IYO,59uOOQ!0Lh'#Jp'#JpO$)vQMjO,5<kO$*iQMjO,5<mO@zQ`O,5<oOOQ!0Lh,5<p,5<pO$*sQ`O,5<vO$*xQMjO,5<{O$+YQ`O'#KPO!$wQlO1G2RO$+_Q`O1G2RO9eQ`O'#KSO9eQ`O'#EtO%[QlO'#EtO9eQ`O'#I{O$+dQ!0LrO,5@{OOQ[1G2}1G2}OOQ[1G4`1G4`OOQ!0Lf1G/|1G/|OOQ!0Lf1G/z1G/zO$-fQ!0MxO1G0UOOQ[1G2y1G2yO!&zQMhO1G2yO%[QlO1G2yO#.tQ`O1G2yO$/jQMhO'#EkOOQ!0Lb,5@T,5@TO$/wQ!0LrO,5@TOOQ[1G.u1G.uO!ByQ!0LrO1G.uO!CUQpO1G.uO!C^QMhO1G.uO$0YQ`O1G0uO$0_Q`O'#CiO$0jQ`O'#KeO$0rQ`O,5=|O$0wQ`O'#KeO$0|Q`O'#KeO$1[Q`O'#JRO$1jQ`O,5AOO$1rQ!fO1G1iOOQ!0Lf1G1k1G1kO9kQ`O1G3fO@zQ`O1G3fO$1yQ`O1G3fO$2OQ`O1G3fO!DiQ`O1G3fO9uQ!0LrO1G3fOOQ[1G3f1G3fO!EcQ`O1G3UO!&zQMhO1G3RO$2TQ`O1G3ROOQ[1G3S1G3SO!&zQMhO1G3SO$2YQ`O1G3SO$2bQpO'#HQOOQ[1G3U1G3UO!6_QpO'#I}O!EhQ!bO1G3XOOQ[1G3X1G3XOOQ[,5=r,5=rO$2jQMhO,5=tO9kQ`O,5=tO$%dQ`O,5=vO9`Q`O,5=vO!CUQpO,5=vO!C^QMhO,5=vO:dQMhO,5=vO$2xQ`O'#KcO$3TQ`O,5=wOOQ[1G.k1G.kO$3YQ!0LrO1G.kO@zQ`O1G.kO$3eQ`O1G.kO9uQ!0LrO1G.kO$5mQ!fO,5AQO$5zQ`O,5AQO9eQ`O,5AQO$6VQlO,5>PO$6^Q`O,5>POOQ[1G3i1G3iO`QlO1G3iOOQ[1G3o1G3oOOQ[1G3q1G3qO?TQ`O1G3sO$6cQlO1G3uO$:gQlO'#HtOOQ[1G3x1G3xO$:tQ`O'#HzO?YQ`O'#H|OOQ[1G4O1G4OO$:|QlO1G4OO9uQ!0LrO1G4UOOQ[1G4W1G4WOOQ!0Lb'#G_'#G_O9uQ!0LrO1G4YO9uQ!0LrO1G4[O$?TQ`O,5@bO!)[QlO,5;`O9eQ`O,5;`O?YQ`O,5:XO!)[QlO,5:XO!CUQpO,5:XO$?YQ?MtO,5:XOOQO,5;`,5;`O$?dQpO'#IeO$?zQ`O,5@aOOQ!0Lf1G/r1G/rO$@SQpO'#IkO$@^Q`O,5@pOOQ!0Lb1G0y1G0yO#$`QpO,5:XOOQO'#Ig'#IgO$@fQpO,5:qOOQ!0Ln,5:q,5:qO#(ZQ`O1G0ZOOQ!0Lf1G0Z1G0ZO%[QlO1G0ZOOQ!0Lf1G0t1G0tO?YQ`O1G0tO!CUQpO1G0tO!C^QMhO1G0tOOQ!0Lb1G5|1G5|O!ByQ!0LrO1G0^OOQO1G0m1G0mO%[QlO1G0mO$@mQ!0LrO1G0mO$@xQ!0LrO1G0mO!CUQpO1G0^ODWQpO1G0^O$AWQ!0LrO1G0mOOQO1G0^1G0^O$AlQ!0MxO1G0mPOOO-E<[-E<[POOO1G.h1G.hOOOO1G/i1G/iO$AvQ!bO,5<iO$BOQ!fO1G4jOOQO1G4p1G4pO%[QlO,5?OO$BYQ`O1G5zO$BbQ`O1G6YO$BjQ!fO1G6ZO9eQ`O,5?UO$BtQ!0MxO1G6WO%[QlO1G6WO$CUQ!0LrO1G6WO$CgQ`O1G6VO$CgQ`O1G6VO9eQ`O1G6VO$CoQ`O,5?XO9eQ`O,5?XOOQO,5?X,5?XO$DTQ`O,5?XO$+YQ`O,5?XOOQO-E<k-E<kOOQS1G0a1G0aOOQS1G0c1G0cO#.lQ`O1G0cOOQ[7+(e7+(eO!&zQMhO7+(eO%[QlO7+(eO$DcQ`O7+(eO$DnQMhO7+(eO$D|Q!0MzO,5=XO$GXQ!0MzO,5=ZO$IdQ!0MzO,5=XO$KuQ!0MzO,5=ZO$NWQ!0MzO,59uO%!]Q!0MzO,5<kO%$hQ!0MzO,5<mO%&sQ!0MzO,5<{OOQ!0Lf7+&a7+&aO%)UQ!0MxO7+&aO%)xQlO'#IfO%*VQ`O,5@cO%*_Q!fO,5@cOOQ!0Lf1G0P1G0PO%*iQ`O7+&jOOQ!0Lf7+&j7+&jO%*nQ?MtO,5:fO%[QlO7+&zO%*xQ?MtO,5:bO%+VQ?MtO,5:jO%+aQ?MtO,5:lO%+kQMhO'#IiO%+uQ`O,5@hOOQ!0Lh1G0d1G0dOOQO1G1r1G1rOOQO1G1s1G1sO%+}Q!jO,5<ZO!)[QlO,5<YOOQO-E<l-E<lOOQ!0Lf7+'Y7+'YOOOW7+'e7+'eOOOW1G1|1G1|O%,YQ`O1G1|OOQ!0Lf1G2O1G2OOOOO,59o,59oO%,_Q!dO,59oOOOO-E<`-E<`OOQ!0Lh1G/X1G/XO%,fQ!0MxO7+'kOOQ!0Lh,5?^,5?^O%-YQMhO1G2fP%-aQ`O'#IrPOQ!0Lh-E<p-E<pO%-}QMjO,5?aOOQ!0Lh-E<s-E<sO%.pQMjO,5?cOOQ!0Lh-E<u-E<uO%.zQ!dO1G2wO%/RQ!dO'#CrO%/iQMhO'#KSO$$wQlO'#JvOOQ!0Lh1G2_1G2_O%/sQ`O'#IqO%0[Q`O,5@vO%0[Q`O,5@vO%0dQ`O,5@vO%0oQ`O,5@vOOQO1G2a1G2aO%0}QMjO1G2`O$+YQ`O'#K[O!,TQMhO1G2`O%1_Q(CWO'#IsO%1lQ`O,5@wO!&zQMhO,5@wO%1tQ!dO,5@wOOQ!0Lh1G2d1G2dO%4UQ!fO'#CiO%4`Q`O,5=POOQ!0Lb,5<},5<}O%4hQpO,5<}OOQ!0Lb,5=O,5=OOCwQ`O,5<}O%4sQpO,5<}OOQ!0Lb,5=R,5=RO$+YQ`O,5=VOOQO,5?`,5?`OOQO-E<r-E<rOOQ!0Lp1G2h1G2hO#$`QpO,5<}O$$wQlO,5=PO%5RQ`O,5=OO%5^QpO,5=OO!,TQMhO'#IuO%6WQMjO1G2sO!,TQMhO'#IwO%6yQMjO1G2uO%7TQMjO1G5qO%7_QMjO1G5qOOQO,5?e,5?eOOQO-E<w-E<wOOQO1G.{1G.{O!,TQMhO1G5qO!,TQMhO1G5qO!:]QpO,59wO%[QlO,59wOOQ!0Lh,5<j,5<jO%7lQ`O1G2ZO!,TQMhO1G2bO%7qQ!0MxO7+'mOOQ!0Lf7+'m7+'mO!$wQlO7+'mO%8eQ`O,5;`OOQ!0Lb,5?g,5?gOOQ!0Lb-E<y-E<yO%8jQ!dO'#K^O#(ZQ`O7+(eO4UQ!fO7+(eO$DfQ`O7+(eO%8tQ!0MvO'#CiO%9XQ!0MvO,5=SO%9lQ`O,5=SO%9tQ`O,5=SOOQ!0Lb1G5o1G5oOOQ[7+$a7+$aO!ByQ!0LrO7+$aO!CUQpO7+$aO!$wQlO7+&aO%9yQ`O'#JQO%:bQ`O,5APOOQO1G3h1G3hO9kQ`O,5APO%:bQ`O,5APO%:jQ`O,5APOOQO,5?m,5?mOOQO-E=P-E=POOQ!0Lf7+'T7+'TO%:oQ`O7+)QO9uQ!0LrO7+)QO9kQ`O7+)QO@zQ`O7+)QO%:tQ`O7+)QOOQ[7+)Q7+)QOOQ[7+(p7+(pO%:yQ!0MvO7+(mO!&zQMhO7+(mO!E^Q`O7+(nOOQ[7+(n7+(nO!&zQMhO7+(nO%;TQ`O'#KbO%;`Q`O,5=lOOQO,5?i,5?iOOQO-E<{-E<{OOQ[7+(s7+(sO%<rQpO'#HZOOQ[1G3`1G3`O!&zQMhO1G3`O%[QlO1G3`O%<yQ`O1G3`O%=UQMhO1G3`O9uQ!0LrO1G3bO$%dQ`O1G3bO9`Q`O1G3bO!CUQpO1G3bO!C^QMhO1G3bO%=dQ`O'#JPO%=xQ`O,5@}O%>QQpO,5@}OOQ!0Lb1G3c1G3cOOQ[7+$V7+$VO@zQ`O7+$VO9uQ!0LrO7+$VO%>]Q`O7+$VO%[QlO1G6lO%[QlO1G6mO%>bQ!0LrO1G6lO%>lQlO1G3kO%>sQ`O1G3kO%>xQlO1G3kOOQ[7+)T7+)TO9uQ!0LrO7+)_O`QlO7+)aOOQ['#Kh'#KhOOQ['#JS'#JSO%?PQlO,5>`OOQ[,5>`,5>`O%[QlO'#HuO%?^Q`O'#HwOOQ[,5>f,5>fO9eQ`O,5>fOOQ[,5>h,5>hOOQ[7+)j7+)jOOQ[7+)p7+)pOOQ[7+)t7+)tOOQ[7+)v7+)vO%?cQpO1G5|O%?}Q?MtO1G0zO%@XQ`O1G0zOOQO1G/s1G/sO%@dQ?MtO1G/sO?YQ`O1G/sO!)[QlO'#DmOOQO,5?P,5?POOQO-E<c-E<cOOQO,5?V,5?VOOQO-E<i-E<iO!CUQpO1G/sOOQO-E<e-E<eOOQ!0Ln1G0]1G0]OOQ!0Lf7+%u7+%uO#(ZQ`O7+%uOOQ!0Lf7+&`7+&`O?YQ`O7+&`O!CUQpO7+&`OOQO7+%x7+%xO$AlQ!0MxO7+&XOOQO7+&X7+&XO%[QlO7+&XO%@nQ!0LrO7+&XO!ByQ!0LrO7+%xO!CUQpO7+%xO%@yQ!0LrO7+&XO%AXQ!0MxO7++rO%[QlO7++rO%AiQ`O7++qO%AiQ`O7++qOOQO1G4s1G4sO9eQ`O1G4sO%AqQ`O1G4sOOQS7+%}7+%}O#(ZQ`O<<LPO4UQ!fO<<LPO%BPQ`O<<LPOOQ[<<LP<<LPO!&zQMhO<<LPO%[QlO<<LPO%BXQ`O<<LPO%BdQ!0MzO,5?aO%DoQ!0MzO,5?cO%FzQ!0MzO1G2`O%I]Q!0MzO1G2sO%KhQ!0MzO1G2uO%MsQ!fO,5?QO%[QlO,5?QOOQO-E<d-E<dO%M}Q`O1G5}OOQ!0Lf<<JU<<JUO%NVQ?MtO1G0uO&!^Q?MtO1G1PO&!eQ?MtO1G1PO&$fQ?MtO1G1PO&$mQ?MtO1G1PO&&nQ?MtO1G1PO&(oQ?MtO1G1PO&(vQ?MtO1G1PO&(}Q?MtO1G1PO&+OQ?MtO1G1PO&+VQ?MtO1G1PO&+^Q!0MxO<<JfO&-UQ?MtO1G1PO&.RQ?MvO1G1PO&/UQ?MvO'#JlO&1[Q?MtO1G1cO&1iQ?MtO1G0UO&1sQMjO,5?TOOQO-E<g-E<gO!)[QlO'#FqOOQO'#KZ'#KZOOQO1G1u1G1uO&1}Q`O1G1tO&2SQ?MtO,5?[OOOW7+'h7+'hOOOO1G/Z1G/ZO&2^Q!dO1G4xOOQ!0Lh7+(Q7+(QP!&zQMhO,5?^O!,TQMhO7+(cO&2eQ`O,5?]O9eQ`O,5?]O$+YQ`O,5?]OOQO-E<o-E<oO&2sQ`O1G6bO&2sQ`O1G6bO&2{Q`O1G6bO&3WQMjO7+'zO&3hQ!dO,5?_O&3rQ`O,5?_O!&zQMhO,5?_OOQO-E<q-E<qO&3wQ!dO1G6cO&4RQ`O1G6cO&4ZQ`O1G2kO!&zQMhO1G2kOOQ!0Lb1G2i1G2iOOQ!0Lb1G2j1G2jO%4hQpO1G2iO!CUQpO1G2iOCwQ`O1G2iOOQ!0Lb1G2q1G2qO&4`QpO1G2iO&4nQ`O1G2kO$+YQ`O1G2jOCwQ`O1G2jO$$wQlO1G2kO&4vQ`O1G2jO&5jQMjO,5?aOOQ!0Lh-E<t-E<tO&6]QMjO,5?cOOQ!0Lh-E<v-E<vO!,TQMhO7++]O&6gQMjO7++]O&6qQMjO7++]OOQ!0Lh1G/c1G/cO&7OQ`O1G/cOOQ!0Lh7+'u7+'uO&7TQMjO7+'|O&7eQ!0MxO<<KXOOQ!0Lf<<KX<<KXO&8XQ`O1G0zO!&zQMhO'#IzO&8^Q`O,5@xO&:`Q!fO<<LPO!&zQMhO1G2nO&:gQ!0LrO1G2nOOQ[<<G{<<G{O!ByQ!0LrO<<G{O&:xQ!0MxO<<I{OOQ!0Lf<<I{<<I{OOQO,5?l,5?lO&;lQ`O,5?lO&;qQ`O,5?lOOQO-E=O-E=OO&<PQ`O1G6kO&<PQ`O1G6kO9kQ`O1G6kO@zQ`O<<LlOOQ[<<Ll<<LlO&<XQ`O<<LlO9uQ!0LrO<<LlO9kQ`O<<LlOOQ[<<LX<<LXO%:yQ!0MvO<<LXOOQ[<<LY<<LYO!E^Q`O<<LYO&<^QpO'#I|O&<iQ`O,5@|O!)[QlO,5@|OOQ[1G3W1G3WOOQO'#JO'#JOO9uQ!0LrO'#JOO&<qQpO,5=uOOQ[,5=u,5=uO&<xQpO'#EgO&=PQpO'#GeO&=UQ`O7+(zO&=ZQ`O7+(zOOQ[7+(z7+(zO!&zQMhO7+(zO%[QlO7+(zO&=cQ`O7+(zOOQ[7+(|7+(|O9uQ!0LrO7+(|O$%dQ`O7+(|O9`Q`O7+(|O!CUQpO7+(|O&=nQ`O,5?kOOQO-E<}-E<}OOQO'#H^'#H^O&=yQ`O1G6iO9uQ!0LrO<<GqOOQ[<<Gq<<GqO@zQ`O<<GqO&>RQ`O7+,WO&>WQ`O7+,XO%[QlO7+,WO%[QlO7+,XOOQ[7+)V7+)VO&>]Q`O7+)VO&>bQlO7+)VO&>iQ`O7+)VOOQ[<<Ly<<LyOOQ[<<L{<<L{OOQ[-E=Q-E=QOOQ[1G3z1G3zO&>nQ`O,5>aOOQ[,5>c,5>cO&>sQ`O1G4QO9eQ`O7+&fO!)[QlO7+&fOOQO7+%_7+%_O&>xQ?MtO1G6ZO?YQ`O7+%_OOQ!0Lf<<Ia<<IaOOQ!0Lf<<Iz<<IzO?YQ`O<<IzOOQO<<Is<<IsO$AlQ!0MxO<<IsO%[QlO<<IsOOQO<<Id<<IdO!ByQ!0LrO<<IdO&?SQ!0LrO<<IsO&?_Q!0MxO<= ^O&?oQ`O<= ]OOQO7+*_7+*_O9eQ`O7+*_OOQ[ANAkANAkO&?wQ!fOANAkO!&zQMhOANAkO#(ZQ`OANAkO4UQ!fOANAkO&@OQ`OANAkO%[QlOANAkO&@WQ!0MzO7+'zO&BiQ!0MzO,5?aO&DtQ!0MzO,5?cO&GPQ!0MzO7+'|O&IbQ!fO1G4lO&IlQ?MtO7+&aO&KpQ?MvO,5=XO&MwQ?MvO,5=ZO&NXQ?MvO,5=XO&NiQ?MvO,5=ZO&NyQ?MvO,59uO'#PQ?MvO,5<kO'%SQ?MvO,5<mO''hQ?MvO,5<{O')^Q?MtO7+'kO')kQ?MtO7+'mO')xQ`O,5<]OOQO7+'`7+'`OOQ!0Lh7+*d7+*dO')}QMjO<<K}OOQO1G4w1G4wO'*UQ`O1G4wO'*aQ`O1G4wO'*oQ`O7++|O'*oQ`O7++|O!&zQMhO1G4yO'*wQ!dO1G4yO'+RQ`O7++}O'+ZQ`O7+(VO'+fQ!dO7+(VOOQ!0Lb7+(T7+(TOOQ!0Lb7+(U7+(UO!CUQpO7+(TOCwQ`O7+(TO'+pQ`O7+(VO!&zQMhO7+(VO$+YQ`O7+(UO'+uQ`O7+(VOCwQ`O7+(UO'+}QMjO<<NwO!,TQMhO<<NwOOQ!0Lh7+$}7+$}O',XQ!dO,5?fOOQO-E<x-E<xO',cQ!0MvO7+(YO!&zQMhO7+(YOOQ[AN=gAN=gO9kQ`O1G5WOOQO1G5W1G5WO',sQ`O1G5WO',xQ`O7+,VO',xQ`O7+,VO9uQ!0LrOANBWO@zQ`OANBWOOQ[ANBWANBWO'-QQ`OANBWOOQ[ANAsANAsOOQ[ANAtANAtO'-VQ`O,5?hOOQO-E<z-E<zO'-bQ?MtO1G6hOOQO,5?j,5?jOOQO-E<|-E<|OOQ[1G3a1G3aO'-lQ`O,5=POOQ[<<Lf<<LfO!&zQMhO<<LfO&=UQ`O<<LfO'-qQ`O<<LfO%[QlO<<LfOOQ[<<Lh<<LhO9uQ!0LrO<<LhO$%dQ`O<<LhO9`Q`O<<LhO'-yQpO1G5VO'.UQ`O7+,TOOQ[AN=]AN=]O9uQ!0LrOAN=]OOQ[<= r<= rOOQ[<= s<= sO'.^Q`O<= rO'.cQ`O<= sOOQ[<<Lq<<LqO'.hQ`O<<LqO'.mQlO<<LqOOQ[1G3{1G3{O?YQ`O7+)lO'.tQ`O<<JQO'/PQ?MtO<<JQOOQO<<Hy<<HyOOQ!0LfAN?fAN?fOOQOAN?_AN?_O$AlQ!0MxOAN?_OOQOAN?OAN?OO%[QlOAN?_OOQO<<My<<MyOOQ[G27VG27VO!&zQMhOG27VO#(ZQ`OG27VO'/ZQ!fOG27VO4UQ!fOG27VO'/bQ`OG27VO'/jQ?MtO<<JfO'/wQ?MvO1G2`O'1mQ?MvO,5?aO'3pQ?MvO,5?cO'5sQ?MvO1G2sO'7vQ?MvO1G2uO'9yQ?MtO<<KXO':WQ?MtO<<I{OOQO1G1w1G1wO!,TQMhOANAiOOQO7+*c7+*cO':eQ`O7+*cO':pQ`O<= hO':xQ!dO7+*eOOQ!0Lb<<Kq<<KqO$+YQ`O<<KqOCwQ`O<<KqO';SQ`O<<KqO!&zQMhO<<KqOOQ!0Lb<<Ko<<KoO!CUQpO<<KoO';_Q!dO<<KqOOQ!0Lb<<Kp<<KpO';iQ`O<<KqO!&zQMhO<<KqO$+YQ`O<<KpO';nQMjOANDcO';xQ!0MvO<<KtOOQO7+*r7+*rO9kQ`O7+*rO'<YQ`O<= qOOQ[G27rG27rO9uQ!0LrOG27rO@zQ`OG27rO!)[QlO1G5SO'<bQ`O7+,SO'<jQ`O1G2kO&=UQ`OANBQOOQ[ANBQANBQO!&zQMhOANBQO'<oQ`OANBQOOQ[ANBSANBSO9uQ!0LrOANBSO$%dQ`OANBSOOQO'#H_'#H_OOQO7+*q7+*qOOQ[G22wG22wOOQ[ANE^ANE^OOQ[ANE_ANE_OOQ[ANB]ANB]O'<wQ`OANB]OOQ[<<MW<<MWO!)[QlOAN?lOOQOG24yG24yO$AlQ!0MxOG24yO#(ZQ`OLD,qOOQ[LD,qLD,qO!&zQMhOLD,qO'<|Q!fOLD,qO'=TQ?MvO7+'zO'>yQ?MvO,5?aO'@|Q?MvO,5?cO'CPQ?MvO7+'|O'DuQMjOG27TOOQO<<M}<<M}OOQ!0LbANA]ANA]O$+YQ`OANA]OCwQ`OANA]O'EVQ!dOANA]OOQ!0LbANAZANAZO'E^Q`OANA]O!&zQMhOANA]O'EiQ!dOANA]OOQ!0LbANA[ANA[OOQO<<N^<<N^OOQ[LD-^LD-^O9uQ!0LrOLD-^O'EsQ?MtO7+*nOOQO'#Gf'#GfOOQ[G27lG27lO&=UQ`OG27lO!&zQMhOG27lOOQ[G27nG27nO9uQ!0LrOG27nOOQ[G27wG27wO'E}Q?MtOG25WOOQOLD*eLD*eOOQ[!$(!]!$(!]O#(ZQ`O!$(!]O!&zQMhO!$(!]O'FXQ!0MzOG27TOOQ!0LbG26wG26wO$+YQ`OG26wO'HjQ`OG26wOCwQ`OG26wO'HuQ!dOG26wO!&zQMhOG26wOOQ[!$(!x!$(!xOOQ[LD-WLD-WO&=UQ`OLD-WOOQ[LD-YLD-YOOQ[!)9Ew!)9EwO#(ZQ`O!)9EwOOQ!0LbLD,cLD,cO$+YQ`OLD,cOCwQ`OLD,cO'H|Q`OLD,cO'IXQ!dOLD,cOOQ[!$(!r!$(!rOOQ[!.K;c!.K;cO'I`Q?MvOG27TOOQ!0Lb!$( }!$( }O$+YQ`O!$( }OCwQ`O!$( }O'KUQ`O!$( }OOQ!0Lb!)9Ei!)9EiO$+YQ`O!)9EiOCwQ`O!)9EiOOQ!0Lb!.K;T!.K;TO$+YQ`O!.K;TOOQ!0Lb!4/0o!4/0oO!)[QlO'#DzO1PQ`O'#EXO'KaQ!fO'#JrO'KhQ!L^O'#DvO'KoQlO'#EOO'KvQ!fO'#CiO'N^Q!fO'#CiO!)[QlO'#EQO'NnQlO,5;ZO!)[QlO,5;eO!)[QlO,5;eO!)[QlO,5;eO!)[QlO,5;eO!)[QlO,5;eO!)[QlO,5;eO!)[QlO,5;eO!)[QlO,5;eO!)[QlO,5;eO!)[QlO,5;eO!)[QlO'#IpO(!qQ`O,5<iO!)[QlO,5;eO(!yQMhO,5;eO($dQMhO,5;eO!)[QlO,5;wO!&zQMhO'#GmO(!yQMhO'#GmO!&zQMhO'#GoO(!yQMhO'#GoO1SQ`O'#DZO1SQ`O'#DZO!&zQMhO'#GPO(!yQMhO'#GPO!&zQMhO'#GRO(!yQMhO'#GRO!&zQMhO'#GaO(!yQMhO'#GaO!)[QlO,5:jO($kQpO'#D_O($uQpO'#JvO!)[QlO,5@oO'NnQlO1G0uO(%PQ?MtO'#CiO!)[QlO1G2PO!&zQMhO'#IuO(!yQMhO'#IuO!&zQMhO'#IwO(!yQMhO'#IwO(%ZQ!dO'#CrO!&zQMhO,5<tO(!yQMhO,5<tO'NnQlO1G2RO!)[QlO7+&zO!&zQMhO1G2`O(!yQMhO1G2`O!&zQMhO'#IuO(!yQMhO'#IuO!&zQMhO'#IwO(!yQMhO'#IwO!&zQMhO1G2bO(!yQMhO1G2bO'NnQlO7+'mO'NnQlO7+&aO!&zQMhOANAiO(!yQMhOANAiO(%nQ`O'#EoO(%sQ`O'#EoO(%{Q`O'#F]O(&QQ`O'#EyO(&VQ`O'#KTO(&bQ`O'#KRO(&mQ`O,5;ZO(&rQMjO,5<eO(&yQ`O'#GYO('OQ`O'#GYO('TQ`O,5<eO(']Q`O,5<gO('eQ`O,5;ZO('mQ?MtO1G1`O('tQ`O,5<tO('yQ`O,5<tO((OQ`O,5<vO((TQ`O,5<vO((YQ`O1G2RO((_Q`O1G0uO((dQMjO<<K}O((kQMjO<<K}O((rQMhO'#F|O9`Q`O'#F{OAuQ`O'#EnO!)[QlO,5;tO!3oQ`O'#GYO!3oQ`O'#GYO!3oQ`O'#G[O!3oQ`O'#G[O!,TQMhO7+(cO!,TQMhO7+(cO%.zQ!dO1G2wO%.zQ!dO1G2wO!&zQMhO,5=]O!&zQMhO,5=]",
    stateData: "()x~O'|OS'}OSTOS(ORQ~OPYOQYOSfOY!VOaqOdzOeyOl!POpkOrYOskOtkOzkO|YO!OYO!SWO!WkO!XkO!_XO!iuO!lZO!oYO!pYO!qYO!svO!uwO!xxO!|]O$W|O$niO%h}O%j!QO%l!OO%m!OO%n!OO%q!RO%s!SO%v!TO%w!TO%y!UO&W!WO&^!XO&`!YO&b!ZO&d![O&g!]O&m!^O&s!_O&u!`O&w!aO&y!bO&{!cO(TSO(VTO(YUO(aVO(o[O~OWtO~P`OPYOQYOSfOd!jOe!iOpkOrYOskOtkOzkO|YO!OYO!SWO!WkO!XkO!_!eO!iuO!lZO!oYO!pYO!qYO!svO!u!gO!x!hO$W!kO$niO(T!dO(VTO(YUO(aVO(o[O~Oa!wOs!nO!S!oO!b!yO!c!vO!d!vO!|<VO#T!pO#U!pO#V!xO#W!pO#X!pO#[!zO#]!zO(U!lO(VTO(YUO(e!mO(o!sO~O(O!{O~OP]XR]X[]Xa]Xj]Xr]X!Q]X!S]X!]]X!l]X!p]X#R]X#S]X#`]X#kfX#n]X#o]X#p]X#q]X#r]X#s]X#t]X#u]X#v]X#x]X#z]X#{]X$Q]X'z]X(a]X(r]X(y]X(z]X~O!g%RX~P(qO_!}O(V#PO(W!}O(X#PO~O_#QO(X#PO(Y#PO(Z#QO~Ox#SO!U#TO(b#TO(c#VO~OPYOQYOSfOd!jOe!iOpkOrYOskOtkOzkO|YO!OYO!SWO!WkO!XkO!_!eO!iuO!lZO!oYO!pYO!qYO!svO!u!gO!x!hO$W!kO$niO(T<ZO(VTO(YUO(aVO(o[O~O![#ZO!]#WO!Y(hP!Y(vP~P+}O!^#cO~P`OPYOQYOSfOd!jOe!iOrYOskOtkOzkO|YO!OYO!SWO!WkO!XkO!_!eO!iuO!lZO!oYO!pYO!qYO!svO!u!gO!x!hO$W!kO$niO(VTO(YUO(aVO(o[O~Op#mO![#iO!|]O#i#lO#j#iO(T<[O!k(sP~P.iO!l#oO(T#nO~O!x#sO!|]O%h#tO~O#k#uO~O!g#vO#k#uO~OP$[OR#zO[$cOj$ROr$aO!Q#yO!S#{O!]$_O!l#xO!p$[O#R$RO#n$OO#o$PO#p$PO#q$PO#r$QO#s$RO#t$RO#u$bO#v$SO#x$UO#z$WO#{$XO(aVO(r$YO(y#|O(z#}O~Oa(fX'z(fX'w(fX!k(fX!Y(fX!_(fX%i(fX!g(fX~P1qO#S$dO#`$eO$Q$eOP(gXR(gX[(gXj(gXr(gX!Q(gX!S(gX!](gX!l(gX!p(gX#R(gX#n(gX#o(gX#p(gX#q(gX#r(gX#s(gX#t(gX#u(gX#v(gX#x(gX#z(gX#{(gX(a(gX(r(gX(y(gX(z(gX!_(gX%i(gX~Oa(gX'z(gX'w(gX!Y(gX!k(gXv(gX!g(gX~P4UO#`$eO~O$]$hO$_$gO$f$mO~OSfO!_$nO$i$oO$k$qO~Oh%VOj%dOk%dOp%WOr%XOs$tOt$tOz%YO|%ZO!O%]O!S${O!_$|O!i%bO!l$xO#j%cO$W%`O$t%^O$v%_O$y%aO(T$sO(VTO(YUO(a$uO(y$}O(z%POg(^P~Ol%[O~P7eO!l%eO~O!S%hO!_%iO(T%gO~O!g%mO~Oa%nO'z%nO~O!Q%rO~P%[O(U!lO~P%[O%n%vO~P%[Oh%VO!l%eO(T%gO(U!lO~Oe%}O!l%eO(T%gO~Oj$RO~O!_&PO(T%gO(U!lO(VTO(YUO`)WP~O!Q&SO!l&RO%j&VO&T&WO~P;SO!x#sO~O%s&YO!S)SX!_)SX(T)SX~O(T&ZO~Ol!PO!u&`O%j!QO%l!OO%m!OO%n!OO%q!RO%s!SO%v!TO%w!TO~Od&eOe&dO!x&bO%h&cO%{&aO~P<bOd&hOeyOl!PO!_&gO!u&`O!xxO!|]O%h}O%l!OO%m!OO%n!OO%q!RO%s!SO%v!TO%w!TO%y!UO~Ob&kO#`&nO%j&iO(U!lO~P=gO!l&oO!u&sO~O!l#oO~O!_XO~Oa%nO'x&{O'z%nO~Oa%nO'x'OO'z%nO~Oa%nO'x'QO'z%nO~O'w]X!Y]Xv]X!k]X&[]X!_]X%i]X!g]X~P(qO!b'_O!c'WO!d'WO(U!lO(VTO(YUO~Os'UO!S'TO!['XO(e'SO!^(iP!^(xP~P@nOn'bO!_'`O(T%gO~Oe'gO!l%eO(T%gO~O!Q&SO!l&RO~Os!nO!S!oO!|<VO#T!pO#U!pO#W!pO#X!pO(U!lO(VTO(YUO(e!mO(o!sO~O!b'mO!c'lO!d'lO#V!pO#['nO#]'nO~PBYOa%nOh%VO!g#vO!l%eO'z%nO(r'pO~O!p'tO#`'rO~PChOs!nO!S!oO(VTO(YUO(e!mO(o!sO~O!_XOs(mX!S(mX!b(mX!c(mX!d(mX!|(mX#T(mX#U(mX#V(mX#W(mX#X(mX#[(mX#](mX(U(mX(V(mX(Y(mX(e(mX(o(mX~O!c'lO!d'lO(U!lO~PDWO(P'xO(Q'xO(R'zO~O_!}O(V'|O(W!}O(X'|O~O_#QO(X'|O(Y'|O(Z#QO~Ov(OO~P%[Ox#SO!U#TO(b#TO(c(RO~O![(TO!Y'WX!Y'^X!]'WX!]'^X~P+}O!](VO!Y(hX~OP$[OR#zO[$cOj$ROr$aO!Q#yO!S#{O!](VO!l#xO!p$[O#R$RO#n$OO#o$PO#p$PO#q$PO#r$QO#s$RO#t$RO#u$bO#v$SO#x$UO#z$WO#{$XO(aVO(r$YO(y#|O(z#}O~O!Y(hX~PHRO!Y([O~O!Y(uX!](uX!g(uX!k(uX(r(uX~O#`(uX#k#dX!^(uX~PJUO#`(]O!Y(wX!](wX~O!](^O!Y(vX~O!Y(aO~O#`$eO~PJUO!^(bO~P`OR#zO!Q#yO!S#{O!l#xO(aVOP!na[!naj!nar!na!]!na!p!na#R!na#n!na#o!na#p!na#q!na#r!na#s!na#t!na#u!na#v!na#x!na#z!na#{!na(r!na(y!na(z!na~Oa!na'z!na'w!na!Y!na!k!nav!na!_!na%i!na!g!na~PKlO!k(cO~O!g#vO#`(dO(r'pO!](tXa(tX'z(tX~O!k(tX~PNXO!S%hO!_%iO!|]O#i(iO#j(hO(T%gO~O!](jO!k(sX~O!k(lO~O!S%hO!_%iO#j(hO(T%gO~OP(gXR(gX[(gXj(gXr(gX!Q(gX!S(gX!](gX!l(gX!p(gX#R(gX#n(gX#o(gX#p(gX#q(gX#r(gX#s(gX#t(gX#u(gX#v(gX#x(gX#z(gX#{(gX(a(gX(r(gX(y(gX(z(gX~O!g#vO!k(gX~P! uOR(nO!Q(mO!l#xO#S$dO!|!{a!S!{a~O!x!{a%h!{a!_!{a#i!{a#j!{a(T!{a~P!#vO!x(rO~OPYOQYOSfOd!jOe!iOpkOrYOskOtkOzkO|YO!OYO!SWO!WkO!XkO!_XO!iuO!lZO!oYO!pYO!qYO!svO!u!gO!x!hO$W!kO$niO(T!dO(VTO(YUO(aVO(o[O~Oh%VOp%WOr%XOs$tOt$tOz%YO|%ZO!O<sO!S${O!_$|O!i>VO!l$xO#j<yO$W%`O$t<uO$v<wO$y%aO(T(vO(VTO(YUO(a$uO(y$}O(z%PO~O#k(xO~O![(zO!k(kP~P%[O(e(|O(o[O~O!S)OO!l#xO(e(|O(o[O~OP<UOQ<UOSfOd>ROe!iOpkOr<UOskOtkOzkO|<UO!O<UO!SWO!WkO!XkO!_!eO!i<XO!lZO!o<UO!p<UO!q<UO!s<YO!u<]O!x!hO$W!kO$n>PO(T)]O(VTO(YUO(aVO(o[O~O!]$_Oa$qa'z$qa'w$qa!k$qa!Y$qa!_$qa%i$qa!g$qa~Ol)dO~P!&zOh%VOp%WOr%XOs$tOt$tOz%YO|%ZO!O%]O!S${O!_$|O!i%bO!l$xO#j%cO$W%`O$t%^O$v%_O$y%aO(T(vO(VTO(YUO(a$uO(y$}O(z%PO~Og(pP~P!,TO!Q)iO!g)hO!_$^X$Z$^X$]$^X$_$^X$f$^X~O!g)hO!_({X$Z({X$]({X$_({X$f({X~O!Q)iO~P!.^O!Q)iO!_({X$Z({X$]({X$_({X$f({X~O!_)kO$Z)oO$])jO$_)jO$f)pO~O![)sO~P!)[O$]$hO$_$gO$f)wO~On$zX!Q$zX#S$zX'y$zX(y$zX(z$zX~OgmXg$zXnmX!]mX#`mX~P!0SOx)yO(b)zO(c)|O~On*VO!Q*OO'y*PO(y$}O(z%PO~Og)}O~P!1WOg*WO~Oh%VOr%XOs$tOt$tOz%YO|%ZO!O<sO!S*YO!_*ZO!i>VO!l$xO#j<yO$W%`O$t<uO$v<wO$y%aO(VTO(YUO(a$uO(y$}O(z%PO~Op*`O![*^O(T*XO!k)OP~P!1uO#k*aO~O!l*bO~Oh%VOp%WOr%XOs$tOt$tOz%YO|%ZO!O<sO!S${O!_$|O!i>VO!l$xO#j<yO$W%`O$t<uO$v<wO$y%aO(T*dO(VTO(YUO(a$uO(y$}O(z%PO~O![*gO!Y)PP~P!3tOr*sOs!nO!S*iO!b*qO!c*kO!d*kO!l*bO#[*rO%`*mO(U!lO(VTO(YUO(e!mO~O!^*pO~P!5iO#S$dOn(`X!Q(`X'y(`X(y(`X(z(`X!](`X#`(`X~Og(`X$O(`X~P!6kOn*xO#`*wOg(_X!](_X~O!]*yOg(^X~Oj%dOk%dOl%dO(T&ZOg(^P~Os*|O~Og)}O(T&ZO~O!l+SO~O(T(vO~Op+WO!S%hO![#iO!_%iO!|]O#i#lO#j#iO(T%gO!k(sP~O!g#vO#k+XO~O!S%hO![+ZO!](^O!_%iO(T%gO!Y(vP~Os'[O!S+]O![+[O(VTO(YUO(e(|O~O!^(xP~P!9|O!]+^Oa)TX'z)TX~OP$[OR#zO[$cOj$ROr$aO!Q#yO!S#{O!l#xO!p$[O#R$RO#n$OO#o$PO#p$PO#q$PO#r$QO#s$RO#t$RO#u$bO#v$SO#x$UO#z$WO#{$XO(aVO(r$YO(y#|O(z#}O~Oa!ja!]!ja'z!ja'w!ja!Y!ja!k!jav!ja!_!ja%i!ja!g!ja~P!:tOR#zO!Q#yO!S#{O!l#xO(aVOP!ra[!raj!rar!ra!]!ra!p!ra#R!ra#n!ra#o!ra#p!ra#q!ra#r!ra#s!ra#t!ra#u!ra#v!ra#x!ra#z!ra#{!ra(r!ra(y!ra(z!ra~Oa!ra'z!ra'w!ra!Y!ra!k!rav!ra!_!ra%i!ra!g!ra~P!=[OR#zO!Q#yO!S#{O!l#xO(aVOP!ta[!taj!tar!ta!]!ta!p!ta#R!ta#n!ta#o!ta#p!ta#q!ta#r!ta#s!ta#t!ta#u!ta#v!ta#x!ta#z!ta#{!ta(r!ta(y!ta(z!ta~Oa!ta'z!ta'w!ta!Y!ta!k!tav!ta!_!ta%i!ta!g!ta~P!?rOh%VOn+gO!_'`O%i+fO~O!g+iOa(]X!_(]X'z(]X!](]X~Oa%nO!_XO'z%nO~Oh%VO!l%eO~Oh%VO!l%eO(T%gO~O!g#vO#k(xO~Ob+tO%j+uO(T+qO(VTO(YUO!^)XP~O!]+vO`)WX~O[+zO~O`+{O~O!_&PO(T%gO(U!lO`)WP~O%j,OO~P;SOh%VO#`,SO~Oh%VOn,VO!_$|O~O!_,XO~O!Q,ZO!_XO~O%n%vO~O!x,`O~Oe,eO~Ob,fO(T#nO(VTO(YUO!^)VP~Oe%}O~O%j!QO(T&ZO~P=gO[,kO`,jO~OPYOQYOSfOdzOeyOpkOrYOskOtkOzkO|YO!OYO!SWO!WkO!XkO!iuO!lZO!oYO!pYO!qYO!svO!xxO!|]O$niO%h}O(VTO(YUO(aVO(o[O~O!_!eO!u!gO$W!kO(T!dO~P!FyO`,jOa%nO'z%nO~OPYOQYOSfOd!jOe!iOpkOrYOskOtkOzkO|YO!OYO!SWO!WkO!XkO!_!eO!iuO!lZO!oYO!pYO!qYO!svO!x!hO$W!kO$niO(T!dO(VTO(YUO(aVO(o[O~Oa,pOl!OO!uwO%l!OO%m!OO%n!OO~P!IcO!l&oO~O&^,vO~O!_,xO~O&o,zO&q,{OP&laQ&laS&laY&laa&lad&lae&lal&lap&lar&las&lat&laz&la|&la!O&la!S&la!W&la!X&la!_&la!i&la!l&la!o&la!p&la!q&la!s&la!u&la!x&la!|&la$W&la$n&la%h&la%j&la%l&la%m&la%n&la%q&la%s&la%v&la%w&la%y&la&W&la&^&la&`&la&b&la&d&la&g&la&m&la&s&la&u&la&w&la&y&la&{&la'w&la(T&la(V&la(Y&la(a&la(o&la!^&la&e&lab&la&j&la~O(T-QO~Oh!eX!]!RX!^!RX!g!RX!g!eX!l!eX#`!RX~O!]!eX!^!eX~P#!iO!g-VO#`-UOh(jX!]#hX!^#hX!g(jX!l(jX~O!](jX!^(jX~P##[Oh%VO!g-XO!l%eO!]!aX!^!aX~Os!nO!S!oO(VTO(YUO(e!mO~OP<UOQ<UOSfOd>ROe!iOpkOr<UOskOtkOzkO|<UO!O<UO!SWO!WkO!XkO!_!eO!i<XO!lZO!o<UO!p<UO!q<UO!s<YO!u<]O!x!hO$W!kO$n>PO(VTO(YUO(aVO(o[O~O(T=QO~P#$qO!]-]O!^(iX~O!^-_O~O!g-VO#`-UO!]#hX!^#hX~O!]-`O!^(xX~O!^-bO~O!c-cO!d-cO(U!lO~P#$`O!^-fO~P'_On-iO!_'`O~O!Y-nO~Os!{a!b!{a!c!{a!d!{a#T!{a#U!{a#V!{a#W!{a#X!{a#[!{a#]!{a(U!{a(V!{a(Y!{a(e!{a(o!{a~P!#vO!p-sO#`-qO~PChO!c-uO!d-uO(U!lO~PDWOa%nO#`-qO'z%nO~Oa%nO!g#vO#`-qO'z%nO~Oa%nO!g#vO!p-sO#`-qO'z%nO(r'pO~O(P'xO(Q'xO(R-zO~Ov-{O~O!Y'Wa!]'Wa~P!:tO![.PO!Y'WX!]'WX~P%[O!](VO!Y(ha~O!Y(ha~PHRO!](^O!Y(va~O!S%hO![.TO!_%iO(T%gO!Y'^X!]'^X~O#`.VO!](ta!k(taa(ta'z(ta~O!g#vO~P#,wO!](jO!k(sa~O!S%hO!_%iO#j.ZO(T%gO~Op.`O!S%hO![.]O!_%iO!|]O#i._O#j.]O(T%gO!]'aX!k'aX~OR.dO!l#xO~Oh%VOn.gO!_'`O%i.fO~Oa#ci!]#ci'z#ci'w#ci!Y#ci!k#civ#ci!_#ci%i#ci!g#ci~P!:tOn>]O!Q*OO'y*PO(y$}O(z%PO~O#k#_aa#_a#`#_a'z#_a!]#_a!k#_a!_#_a!Y#_a~P#/sO#k(`XP(`XR(`X[(`Xa(`Xj(`Xr(`X!S(`X!l(`X!p(`X#R(`X#n(`X#o(`X#p(`X#q(`X#r(`X#s(`X#t(`X#u(`X#v(`X#x(`X#z(`X#{(`X'z(`X(a(`X(r(`X!k(`X!Y(`X'w(`Xv(`X!_(`X%i(`X!g(`X~P!6kO!].tO!k(kX~P!:tO!k.wO~O!Y.yO~OP$[OR#zO!Q#yO!S#{O!l#xO!p$[O(aVO[#mia#mij#mir#mi!]#mi#R#mi#o#mi#p#mi#q#mi#r#mi#s#mi#t#mi#u#mi#v#mi#x#mi#z#mi#{#mi'z#mi(r#mi(y#mi(z#mi'w#mi!Y#mi!k#miv#mi!_#mi%i#mi!g#mi~O#n#mi~P#3cO#n$OO~P#3cOP$[OR#zOr$aO!Q#yO!S#{O!l#xO!p$[O#n$OO#o$PO#p$PO#q$PO(aVO[#mia#mij#mi!]#mi#R#mi#s#mi#t#mi#u#mi#v#mi#x#mi#z#mi#{#mi'z#mi(r#mi(y#mi(z#mi'w#mi!Y#mi!k#miv#mi!_#mi%i#mi!g#mi~O#r#mi~P#6QO#r$QO~P#6QOP$[OR#zO[$cOj$ROr$aO!Q#yO!S#{O!l#xO!p$[O#R$RO#n$OO#o$PO#p$PO#q$PO#r$QO#s$RO#t$RO#u$bO(aVOa#mi!]#mi#x#mi#z#mi#{#mi'z#mi(r#mi(y#mi(z#mi'w#mi!Y#mi!k#miv#mi!_#mi%i#mi!g#mi~O#v#mi~P#8oOP$[OR#zO[$cOj$ROr$aO!Q#yO!S#{O!l#xO!p$[O#R$RO#n$OO#o$PO#p$PO#q$PO#r$QO#s$RO#t$RO#u$bO#v$SO(aVO(z#}Oa#mi!]#mi#z#mi#{#mi'z#mi(r#mi(y#mi'w#mi!Y#mi!k#miv#mi!_#mi%i#mi!g#mi~O#x$UO~P#;VO#x#mi~P#;VO#v$SO~P#8oOP$[OR#zO[$cOj$ROr$aO!Q#yO!S#{O!l#xO!p$[O#R$RO#n$OO#o$PO#p$PO#q$PO#r$QO#s$RO#t$RO#u$bO#v$SO#x$UO(aVO(y#|O(z#}Oa#mi!]#mi#{#mi'z#mi(r#mi'w#mi!Y#mi!k#miv#mi!_#mi%i#mi!g#mi~O#z#mi~P#={O#z$WO~P#={OP]XR]X[]Xj]Xr]X!Q]X!S]X!l]X!p]X#R]X#S]X#`]X#kfX#n]X#o]X#p]X#q]X#r]X#s]X#t]X#u]X#v]X#x]X#z]X#{]X$Q]X(a]X(r]X(y]X(z]X!]]X!^]X~O$O]X~P#@jOP$[OR#zO[<mOj<bOr<kO!Q#yO!S#{O!l#xO!p$[O#R<bO#n<_O#o<`O#p<`O#q<`O#r<aO#s<bO#t<bO#u<lO#v<cO#x<eO#z<gO#{<hO(aVO(r$YO(y#|O(z#}O~O$O.{O~P#BwO#S$dO#`<nO$Q<nO$O(gX!^(gX~P! uOa'da!]'da'z'da'w'da!k'da!Y'dav'da!_'da%i'da!g'da~P!:tO[#mia#mij#mir#mi!]#mi#R#mi#r#mi#s#mi#t#mi#u#mi#v#mi#x#mi#z#mi#{#mi'z#mi(r#mi'w#mi!Y#mi!k#miv#mi!_#mi%i#mi!g#mi~OP$[OR#zO!Q#yO!S#{O!l#xO!p$[O#n$OO#o$PO#p$PO#q$PO(aVO(y#mi(z#mi~P#EyOn>]O!Q*OO'y*PO(y$}O(z%POP#miR#mi!S#mi!l#mi!p#mi#n#mi#o#mi#p#mi#q#mi(a#mi~P#EyO!]/POg(pX~P!1WOg/RO~Oa$Pi!]$Pi'z$Pi'w$Pi!Y$Pi!k$Piv$Pi!_$Pi%i$Pi!g$Pi~P!:tO$]/SO$_/SO~O$]/TO$_/TO~O!g)hO#`/UO!_$cX$Z$cX$]$cX$_$cX$f$cX~O![/VO~O!_)kO$Z/XO$])jO$_)jO$f/YO~O!]<iO!^(fX~P#BwO!^/ZO~O!g)hO$f({X~O$f/]O~Ov/^O~P!&zOx)yO(b)zO(c/aO~O!S/dO~O(y$}On%aa!Q%aa'y%aa(z%aa!]%aa#`%aa~Og%aa$O%aa~P#L{O(z%POn%ca!Q%ca'y%ca(y%ca!]%ca#`%ca~Og%ca$O%ca~P#MnO!]fX!gfX!kfX!k$zX(rfX~P!0SOp%WO![/mO!](^O(T/lO!Y(vP!Y)PP~P!1uOr*sO!b*qO!c*kO!d*kO!l*bO#[*rO%`*mO(U!lO(VTO(YUO~Os<}O!S/nO![+[O!^*pO(e<|O!^(xP~P$ [O!k/oO~P#/sO!]/pO!g#vO(r'pO!k)OX~O!k/uO~OnoX!QoX'yoX(yoX(zoX~O!g#vO!koX~P$#OOp/wO!S%hO![*^O!_%iO(T%gO!k)OP~O#k/xO~O!Y$zX!]$zX!g%RX~P!0SO!]/yO!Y)PX~P#/sO!g/{O~O!Y/}O~OpkO(T0OO~P.iOh%VOr0TO!g#vO!l%eO(r'pO~O!g+iO~Oa%nO!]0XO'z%nO~O!^0ZO~P!5iO!c0[O!d0[O(U!lO~P#$`Os!nO!S0]O(VTO(YUO(e!mO~O#[0_O~Og%aa!]%aa#`%aa$O%aa~P!1WOg%ca!]%ca#`%ca$O%ca~P!1WOj%dOk%dOl%dO(T&ZOg'mX!]'mX~O!]*yOg(^a~Og0hO~On0jO#`0iOg(_a!](_a~OR0kO!Q0kO!S0lO#S$dOn}a'y}a(y}a(z}a!]}a#`}a~Og}a$O}a~P$(cO!Q*OO'y*POn$sa(y$sa(z$sa!]$sa#`$sa~Og$sa$O$sa~P$)_O!Q*OO'y*POn$ua(y$ua(z$ua!]$ua#`$ua~Og$ua$O$ua~P$*QO#k0oO~Og%Ta!]%Ta#`%Ta$O%Ta~P!1WO!g#vO~O#k0rO~O!]+^Oa)Ta'z)Ta~OR#zO!Q#yO!S#{O!l#xO(aVOP!ri[!rij!rir!ri!]!ri!p!ri#R!ri#n!ri#o!ri#p!ri#q!ri#r!ri#s!ri#t!ri#u!ri#v!ri#x!ri#z!ri#{!ri(r!ri(y!ri(z!ri~Oa!ri'z!ri'w!ri!Y!ri!k!riv!ri!_!ri%i!ri!g!ri~P$+oOh%VOr%XOs$tOt$tOz%YO|%ZO!O<sO!S${O!_$|O!i>VO!l$xO#j<yO$W%`O$t<uO$v<wO$y%aO(VTO(YUO(a$uO(y$}O(z%PO~Op0{O%]0|O(T0zO~P$.VO!g+iOa(]a!_(]a'z(]a!](]a~O#k1SO~O[]X!]fX!^fX~O!]1TO!^)XX~O!^1VO~O[1WO~Ob1YO(T+qO(VTO(YUO~O!_&PO(T%gO`'uX!]'uX~O!]+vO`)Wa~O!k1]O~P!:tO[1`O~O`1aO~O#`1fO~On1iO!_$|O~O(e(|O!^)UP~Oh%VOn1rO!_1oO%i1qO~O[1|O!]1zO!^)VX~O!^1}O~O`2POa%nO'z%nO~O(T#nO(VTO(YUO~O#S$dO#`$eO$Q$eOP(gXR(gX[(gXr(gX!Q(gX!S(gX!](gX!l(gX!p(gX#R(gX#n(gX#o(gX#p(gX#q(gX#r(gX#s(gX#t(gX#u(gX#v(gX#x(gX#z(gX#{(gX(a(gX(r(gX(y(gX(z(gX~Oj2SO&[2TOa(gX~P$3pOj2SO#`$eO&[2TO~Oa2VO~P%[Oa2XO~O&e2[OP&ciQ&ciS&ciY&cia&cid&cie&cil&cip&cir&cis&cit&ciz&ci|&ci!O&ci!S&ci!W&ci!X&ci!_&ci!i&ci!l&ci!o&ci!p&ci!q&ci!s&ci!u&ci!x&ci!|&ci$W&ci$n&ci%h&ci%j&ci%l&ci%m&ci%n&ci%q&ci%s&ci%v&ci%w&ci%y&ci&W&ci&^&ci&`&ci&b&ci&d&ci&g&ci&m&ci&s&ci&u&ci&w&ci&y&ci&{&ci'w&ci(T&ci(V&ci(Y&ci(a&ci(o&ci!^&cib&ci&j&ci~Ob2bO!^2`O&j2aO~P`O!_XO!l2dO~O&q,{OP&liQ&liS&liY&lia&lid&lie&lil&lip&lir&lis&lit&liz&li|&li!O&li!S&li!W&li!X&li!_&li!i&li!l&li!o&li!p&li!q&li!s&li!u&li!x&li!|&li$W&li$n&li%h&li%j&li%l&li%m&li%n&li%q&li%s&li%v&li%w&li%y&li&W&li&^&li&`&li&b&li&d&li&g&li&m&li&s&li&u&li&w&li&y&li&{&li'w&li(T&li(V&li(Y&li(a&li(o&li!^&li&e&lib&li&j&li~O!Y2jO~O!]!aa!^!aa~P#BwOs!nO!S!oO![2pO(e!mO!]'XX!^'XX~P@nO!]-]O!^(ia~O!]'_X!^'_X~P!9|O!]-`O!^(xa~O!^2wO~P'_Oa%nO#`3QO'z%nO~Oa%nO!g#vO#`3QO'z%nO~Oa%nO!g#vO!p3UO#`3QO'z%nO(r'pO~Oa%nO'z%nO~P!:tO!]$_Ov$qa~O!Y'Wi!]'Wi~P!:tO!](VO!Y(hi~O!](^O!Y(vi~O!Y(wi!](wi~P!:tO!](ti!k(tia(ti'z(ti~P!:tO#`3WO!](ti!k(tia(ti'z(ti~O!](jO!k(si~O!S%hO!_%iO!|]O#i3]O#j3[O(T%gO~O!S%hO!_%iO#j3[O(T%gO~On3dO!_'`O%i3cO~Oh%VOn3dO!_'`O%i3cO~O#k%aaP%aaR%aa[%aaa%aaj%aar%aa!S%aa!l%aa!p%aa#R%aa#n%aa#o%aa#p%aa#q%aa#r%aa#s%aa#t%aa#u%aa#v%aa#x%aa#z%aa#{%aa'z%aa(a%aa(r%aa!k%aa!Y%aa'w%aav%aa!_%aa%i%aa!g%aa~P#L{O#k%caP%caR%ca[%caa%caj%car%ca!S%ca!l%ca!p%ca#R%ca#n%ca#o%ca#p%ca#q%ca#r%ca#s%ca#t%ca#u%ca#v%ca#x%ca#z%ca#{%ca'z%ca(a%ca(r%ca!k%ca!Y%ca'w%cav%ca!_%ca%i%ca!g%ca~P#MnO#k%aaP%aaR%aa[%aaa%aaj%aar%aa!S%aa!]%aa!l%aa!p%aa#R%aa#n%aa#o%aa#p%aa#q%aa#r%aa#s%aa#t%aa#u%aa#v%aa#x%aa#z%aa#{%aa'z%aa(a%aa(r%aa!k%aa!Y%aa'w%aa#`%aav%aa!_%aa%i%aa!g%aa~P#/sO#k%caP%caR%ca[%caa%caj%car%ca!S%ca!]%ca!l%ca!p%ca#R%ca#n%ca#o%ca#p%ca#q%ca#r%ca#s%ca#t%ca#u%ca#v%ca#x%ca#z%ca#{%ca'z%ca(a%ca(r%ca!k%ca!Y%ca'w%ca#`%cav%ca!_%ca%i%ca!g%ca~P#/sO#k}aP}a[}aa}aj}ar}a!l}a!p}a#R}a#n}a#o}a#p}a#q}a#r}a#s}a#t}a#u}a#v}a#x}a#z}a#{}a'z}a(a}a(r}a!k}a!Y}a'w}av}a!_}a%i}a!g}a~P$(cO#k$saP$saR$sa[$saa$saj$sar$sa!S$sa!l$sa!p$sa#R$sa#n$sa#o$sa#p$sa#q$sa#r$sa#s$sa#t$sa#u$sa#v$sa#x$sa#z$sa#{$sa'z$sa(a$sa(r$sa!k$sa!Y$sa'w$sav$sa!_$sa%i$sa!g$sa~P$)_O#k$uaP$uaR$ua[$uaa$uaj$uar$ua!S$ua!l$ua!p$ua#R$ua#n$ua#o$ua#p$ua#q$ua#r$ua#s$ua#t$ua#u$ua#v$ua#x$ua#z$ua#{$ua'z$ua(a$ua(r$ua!k$ua!Y$ua'w$uav$ua!_$ua%i$ua!g$ua~P$*QO#k%TaP%TaR%Ta[%Taa%Taj%Tar%Ta!S%Ta!]%Ta!l%Ta!p%Ta#R%Ta#n%Ta#o%Ta#p%Ta#q%Ta#r%Ta#s%Ta#t%Ta#u%Ta#v%Ta#x%Ta#z%Ta#{%Ta'z%Ta(a%Ta(r%Ta!k%Ta!Y%Ta'w%Ta#`%Tav%Ta!_%Ta%i%Ta!g%Ta~P#/sOa#cq!]#cq'z#cq'w#cq!Y#cq!k#cqv#cq!_#cq%i#cq!g#cq~P!:tO![3lO!]'YX!k'YX~P%[O!].tO!k(ka~O!].tO!k(ka~P!:tO!Y3oO~O$O!na!^!na~PKlO$O!ja!]!ja!^!ja~P#BwO$O!ra!^!ra~P!=[O$O!ta!^!ta~P!?rOg']X!]']X~P!,TO!]/POg(pa~OSfO!_4TO$d4UO~O!^4YO~Ov4ZO~P#/sOa$mq!]$mq'z$mq'w$mq!Y$mq!k$mqv$mq!_$mq%i$mq!g$mq~P!:tO!Y4]O~P!&zO!S4^O~O!Q*OO'y*PO(z%POn'ia(y'ia!]'ia#`'ia~Og'ia$O'ia~P%-fO!Q*OO'y*POn'ka(y'ka(z'ka!]'ka#`'ka~Og'ka$O'ka~P%.XO(r$YO~P#/sO!YfX!Y$zX!]fX!]$zX!g%RX#`fX~P!0SOp%WO(T=WO~P!1uOp4bO!S%hO![4aO!_%iO(T%gO!]'eX!k'eX~O!]/pO!k)Oa~O!]/pO!g#vO!k)Oa~O!]/pO!g#vO(r'pO!k)Oa~Og$|i!]$|i#`$|i$O$|i~P!1WO![4jO!Y'gX!]'gX~P!3tO!]/yO!Y)Pa~O!]/yO!Y)Pa~P#/sOP]XR]X[]Xj]Xr]X!Q]X!S]X!Y]X!]]X!l]X!p]X#R]X#S]X#`]X#kfX#n]X#o]X#p]X#q]X#r]X#s]X#t]X#u]X#v]X#x]X#z]X#{]X$Q]X(a]X(r]X(y]X(z]X~Oj%YX!g%YX~P%2OOj4oO!g#vO~Oh%VO!g#vO!l%eO~Oh%VOr4tO!l%eO(r'pO~Or4yO!g#vO(r'pO~Os!nO!S4zO(VTO(YUO(e!mO~O(y$}On%ai!Q%ai'y%ai(z%ai!]%ai#`%ai~Og%ai$O%ai~P%5oO(z%POn%ci!Q%ci'y%ci(y%ci!]%ci#`%ci~Og%ci$O%ci~P%6bOg(_i!](_i~P!1WO#`5QOg(_i!](_i~P!1WO!k5VO~Oa$oq!]$oq'z$oq'w$oq!Y$oq!k$oqv$oq!_$oq%i$oq!g$oq~P!:tO!Y5ZO~O!]5[O!_)QX~P#/sOa$zX!_$zX%^]X'z$zX!]$zX~P!0SO%^5_OaoX!_oX'zoX!]oX~P$#OOp5`O(T#nO~O%^5_O~Ob5fO%j5gO(T+qO(VTO(YUO!]'tX!^'tX~O!]1TO!^)Xa~O[5kO~O`5lO~O[5pO~Oa%nO'z%nO~P#/sO!]5uO#`5wO!^)UX~O!^5xO~Or6OOs!nO!S*iO!b!yO!c!vO!d!vO!|<VO#T!pO#U!pO#V!pO#W!pO#X!pO#[5}O#]!zO(U!lO(VTO(YUO(e!mO(o!sO~O!^5|O~P%;eOn6TO!_1oO%i6SO~Oh%VOn6TO!_1oO%i6SO~Ob6[O(T#nO(VTO(YUO!]'sX!^'sX~O!]1zO!^)Va~O(VTO(YUO(e6^O~O`6bO~Oj6eO&[6fO~PNXO!k6gO~P%[Oa6iO~Oa6iO~P%[Ob2bO!^6nO&j2aO~P`O!g6pO~O!g6rOh(ji!](ji!^(ji!g(ji!l(jir(ji(r(ji~O!]#hi!^#hi~P#BwO#`6sO!]#hi!^#hi~O!]!ai!^!ai~P#BwOa%nO#`6|O'z%nO~Oa%nO!g#vO#`6|O'z%nO~O!](tq!k(tqa(tq'z(tq~P!:tO!](jO!k(sq~O!S%hO!_%iO#j7TO(T%gO~O!_'`O%i7WO~On7[O!_'`O%i7WO~O#k'iaP'iaR'ia['iaa'iaj'iar'ia!S'ia!l'ia!p'ia#R'ia#n'ia#o'ia#p'ia#q'ia#r'ia#s'ia#t'ia#u'ia#v'ia#x'ia#z'ia#{'ia'z'ia(a'ia(r'ia!k'ia!Y'ia'w'iav'ia!_'ia%i'ia!g'ia~P%-fO#k'kaP'kaR'ka['kaa'kaj'kar'ka!S'ka!l'ka!p'ka#R'ka#n'ka#o'ka#p'ka#q'ka#r'ka#s'ka#t'ka#u'ka#v'ka#x'ka#z'ka#{'ka'z'ka(a'ka(r'ka!k'ka!Y'ka'w'kav'ka!_'ka%i'ka!g'ka~P%.XO#k$|iP$|iR$|i[$|ia$|ij$|ir$|i!S$|i!]$|i!l$|i!p$|i#R$|i#n$|i#o$|i#p$|i#q$|i#r$|i#s$|i#t$|i#u$|i#v$|i#x$|i#z$|i#{$|i'z$|i(a$|i(r$|i!k$|i!Y$|i'w$|i#`$|iv$|i!_$|i%i$|i!g$|i~P#/sO#k%aiP%aiR%ai[%aia%aij%air%ai!S%ai!l%ai!p%ai#R%ai#n%ai#o%ai#p%ai#q%ai#r%ai#s%ai#t%ai#u%ai#v%ai#x%ai#z%ai#{%ai'z%ai(a%ai(r%ai!k%ai!Y%ai'w%aiv%ai!_%ai%i%ai!g%ai~P%5oO#k%ciP%ciR%ci[%cia%cij%cir%ci!S%ci!l%ci!p%ci#R%ci#n%ci#o%ci#p%ci#q%ci#r%ci#s%ci#t%ci#u%ci#v%ci#x%ci#z%ci#{%ci'z%ci(a%ci(r%ci!k%ci!Y%ci'w%civ%ci!_%ci%i%ci!g%ci~P%6bO!]'Ya!k'Ya~P!:tO!].tO!k(ki~O$O#ci!]#ci!^#ci~P#BwOP$[OR#zO!Q#yO!S#{O!l#xO!p$[O(aVO[#mij#mir#mi#R#mi#o#mi#p#mi#q#mi#r#mi#s#mi#t#mi#u#mi#v#mi#x#mi#z#mi#{#mi$O#mi(r#mi(y#mi(z#mi!]#mi!^#mi~O#n#mi~P%NdO#n<_O~P%NdOP$[OR#zOr<kO!Q#yO!S#{O!l#xO!p$[O#n<_O#o<`O#p<`O#q<`O(aVO[#mij#mi#R#mi#s#mi#t#mi#u#mi#v#mi#x#mi#z#mi#{#mi$O#mi(r#mi(y#mi(z#mi!]#mi!^#mi~O#r#mi~P&!lO#r<aO~P&!lOP$[OR#zO[<mOj<bOr<kO!Q#yO!S#{O!l#xO!p$[O#R<bO#n<_O#o<`O#p<`O#q<`O#r<aO#s<bO#t<bO#u<lO(aVO#x#mi#z#mi#{#mi$O#mi(r#mi(y#mi(z#mi!]#mi!^#mi~O#v#mi~P&$tOP$[OR#zO[<mOj<bOr<kO!Q#yO!S#{O!l#xO!p$[O#R<bO#n<_O#o<`O#p<`O#q<`O#r<aO#s<bO#t<bO#u<lO#v<cO(aVO(z#}O#z#mi#{#mi$O#mi(r#mi(y#mi!]#mi!^#mi~O#x<eO~P&&uO#x#mi~P&&uO#v<cO~P&$tOP$[OR#zO[<mOj<bOr<kO!Q#yO!S#{O!l#xO!p$[O#R<bO#n<_O#o<`O#p<`O#q<`O#r<aO#s<bO#t<bO#u<lO#v<cO#x<eO(aVO(y#|O(z#}O#{#mi$O#mi(r#mi!]#mi!^#mi~O#z#mi~P&)UO#z<gO~P&)UOa#|y!]#|y'z#|y'w#|y!Y#|y!k#|yv#|y!_#|y%i#|y!g#|y~P!:tO[#mij#mir#mi#R#mi#r#mi#s#mi#t#mi#u#mi#v#mi#x#mi#z#mi#{#mi$O#mi(r#mi!]#mi!^#mi~OP$[OR#zO!Q#yO!S#{O!l#xO!p$[O#n<_O#o<`O#p<`O#q<`O(aVO(y#mi(z#mi~P&,QOn>^O!Q*OO'y*PO(y$}O(z%POP#miR#mi!S#mi!l#mi!p#mi#n#mi#o#mi#p#mi#q#mi(a#mi~P&,QO#S$dOP(`XR(`X[(`Xj(`Xn(`Xr(`X!Q(`X!S(`X!l(`X!p(`X#R(`X#n(`X#o(`X#p(`X#q(`X#r(`X#s(`X#t(`X#u(`X#v(`X#x(`X#z(`X#{(`X$O(`X'y(`X(a(`X(r(`X(y(`X(z(`X!](`X!^(`X~O$O$Pi!]$Pi!^$Pi~P#BwO$O!ri!^!ri~P$+oOg']a!]']a~P!1WO!^7nO~O!]'da!^'da~P#BwO!Y7oO~P#/sO!g#vO(r'pO!]'ea!k'ea~O!]/pO!k)Oi~O!]/pO!g#vO!k)Oi~Og$|q!]$|q#`$|q$O$|q~P!1WO!Y'ga!]'ga~P#/sO!g7vO~O!]/yO!Y)Pi~P#/sO!]/yO!Y)Pi~O!Y7yO~Oh%VOr8OO!l%eO(r'pO~Oj8QO!g#vO~Or8TO!g#vO(r'pO~O!Q*OO'y*PO(z%POn'ja(y'ja!]'ja#`'ja~Og'ja$O'ja~P&5RO!Q*OO'y*POn'la(y'la(z'la!]'la#`'la~Og'la$O'la~P&5tOg(_q!](_q~P!1WO#`8VOg(_q!](_q~P!1WO!Y8WO~Og%Oq!]%Oq#`%Oq$O%Oq~P!1WOa$oy!]$oy'z$oy'w$oy!Y$oy!k$oyv$oy!_$oy%i$oy!g$oy~P!:tO!g6rO~O!]5[O!_)Qa~O!_'`OP$TaR$Ta[$Taj$Tar$Ta!Q$Ta!S$Ta!]$Ta!l$Ta!p$Ta#R$Ta#n$Ta#o$Ta#p$Ta#q$Ta#r$Ta#s$Ta#t$Ta#u$Ta#v$Ta#x$Ta#z$Ta#{$Ta(a$Ta(r$Ta(y$Ta(z$Ta~O%i7WO~P&8fO%^8[Oa%[i!_%[i'z%[i!]%[i~Oa#cy!]#cy'z#cy'w#cy!Y#cy!k#cyv#cy!_#cy%i#cy!g#cy~P!:tO[8^O~Ob8`O(T+qO(VTO(YUO~O!]1TO!^)Xi~O`8dO~O(e(|O!]'pX!^'pX~O!]5uO!^)Ua~O!^8nO~P%;eO(o!sO~P$&YO#[8oO~O!_1oO~O!_1oO%i8qO~On8tO!_1oO%i8qO~O[8yO!]'sa!^'sa~O!]1zO!^)Vi~O!k8}O~O!k9OO~O!k9RO~O!k9RO~P%[Oa9TO~O!g9UO~O!k9VO~O!](wi!^(wi~P#BwOa%nO#`9_O'z%nO~O!](ty!k(tya(ty'z(ty~P!:tO!](jO!k(sy~O%i9bO~P&8fO!_'`O%i9bO~O#k$|qP$|qR$|q[$|qa$|qj$|qr$|q!S$|q!]$|q!l$|q!p$|q#R$|q#n$|q#o$|q#p$|q#q$|q#r$|q#s$|q#t$|q#u$|q#v$|q#x$|q#z$|q#{$|q'z$|q(a$|q(r$|q!k$|q!Y$|q'w$|q#`$|qv$|q!_$|q%i$|q!g$|q~P#/sO#k'jaP'jaR'ja['jaa'jaj'jar'ja!S'ja!l'ja!p'ja#R'ja#n'ja#o'ja#p'ja#q'ja#r'ja#s'ja#t'ja#u'ja#v'ja#x'ja#z'ja#{'ja'z'ja(a'ja(r'ja!k'ja!Y'ja'w'jav'ja!_'ja%i'ja!g'ja~P&5RO#k'laP'laR'la['laa'laj'lar'la!S'la!l'la!p'la#R'la#n'la#o'la#p'la#q'la#r'la#s'la#t'la#u'la#v'la#x'la#z'la#{'la'z'la(a'la(r'la!k'la!Y'la'w'lav'la!_'la%i'la!g'la~P&5tO#k%OqP%OqR%Oq[%Oqa%Oqj%Oqr%Oq!S%Oq!]%Oq!l%Oq!p%Oq#R%Oq#n%Oq#o%Oq#p%Oq#q%Oq#r%Oq#s%Oq#t%Oq#u%Oq#v%Oq#x%Oq#z%Oq#{%Oq'z%Oq(a%Oq(r%Oq!k%Oq!Y%Oq'w%Oq#`%Oqv%Oq!_%Oq%i%Oq!g%Oq~P#/sO!]'Yi!k'Yi~P!:tO$O#cq!]#cq!^#cq~P#BwO(y$}OP%aaR%aa[%aaj%aar%aa!S%aa!l%aa!p%aa#R%aa#n%aa#o%aa#p%aa#q%aa#r%aa#s%aa#t%aa#u%aa#v%aa#x%aa#z%aa#{%aa$O%aa(a%aa(r%aa!]%aa!^%aa~On%aa!Q%aa'y%aa(z%aa~P&IyO(z%POP%caR%ca[%caj%car%ca!S%ca!l%ca!p%ca#R%ca#n%ca#o%ca#p%ca#q%ca#r%ca#s%ca#t%ca#u%ca#v%ca#x%ca#z%ca#{%ca$O%ca(a%ca(r%ca!]%ca!^%ca~On%ca!Q%ca'y%ca(y%ca~P&LQOn>^O!Q*OO'y*PO(z%PO~P&IyOn>^O!Q*OO'y*PO(y$}O~P&LQOR0kO!Q0kO!S0lO#S$dOP}a[}aj}an}ar}a!l}a!p}a#R}a#n}a#o}a#p}a#q}a#r}a#s}a#t}a#u}a#v}a#x}a#z}a#{}a$O}a'y}a(a}a(r}a(y}a(z}a!]}a!^}a~O!Q*OO'y*POP$saR$sa[$saj$san$sar$sa!S$sa!l$sa!p$sa#R$sa#n$sa#o$sa#p$sa#q$sa#r$sa#s$sa#t$sa#u$sa#v$sa#x$sa#z$sa#{$sa$O$sa(a$sa(r$sa(y$sa(z$sa!]$sa!^$sa~O!Q*OO'y*POP$uaR$ua[$uaj$uan$uar$ua!S$ua!l$ua!p$ua#R$ua#n$ua#o$ua#p$ua#q$ua#r$ua#s$ua#t$ua#u$ua#v$ua#x$ua#z$ua#{$ua$O$ua(a$ua(r$ua(y$ua(z$ua!]$ua!^$ua~On>^O!Q*OO'y*PO(y$}O(z%PO~OP%TaR%Ta[%Taj%Tar%Ta!S%Ta!l%Ta!p%Ta#R%Ta#n%Ta#o%Ta#p%Ta#q%Ta#r%Ta#s%Ta#t%Ta#u%Ta#v%Ta#x%Ta#z%Ta#{%Ta$O%Ta(a%Ta(r%Ta!]%Ta!^%Ta~P''VO$O$mq!]$mq!^$mq~P#BwO$O$oq!]$oq!^$oq~P#BwO!^9oO~O$O9pO~P!1WO!g#vO!]'ei!k'ei~O!g#vO(r'pO!]'ei!k'ei~O!]/pO!k)Oq~O!Y'gi!]'gi~P#/sO!]/yO!Y)Pq~Or9wO!g#vO(r'pO~O[9yO!Y9xO~P#/sO!Y9xO~Oj:PO!g#vO~Og(_y!](_y~P!1WO!]'na!_'na~P#/sOa%[q!_%[q'z%[q!]%[q~P#/sO[:UO~O!]1TO!^)Xq~O`:YO~O#`:ZO!]'pa!^'pa~O!]5uO!^)Ui~P#BwO!S:]O~O!_1oO%i:`O~O(VTO(YUO(e:eO~O!]1zO!^)Vq~O!k:hO~O!k:iO~O!k:jO~O!k:jO~P%[O#`:mO!]#hy!^#hy~O!]#hy!^#hy~P#BwO%i:rO~P&8fO!_'`O%i:rO~O$O#|y!]#|y!^#|y~P#BwOP$|iR$|i[$|ij$|ir$|i!S$|i!l$|i!p$|i#R$|i#n$|i#o$|i#p$|i#q$|i#r$|i#s$|i#t$|i#u$|i#v$|i#x$|i#z$|i#{$|i$O$|i(a$|i(r$|i!]$|i!^$|i~P''VO!Q*OO'y*PO(z%POP'iaR'ia['iaj'ian'iar'ia!S'ia!l'ia!p'ia#R'ia#n'ia#o'ia#p'ia#q'ia#r'ia#s'ia#t'ia#u'ia#v'ia#x'ia#z'ia#{'ia$O'ia(a'ia(r'ia(y'ia!]'ia!^'ia~O!Q*OO'y*POP'kaR'ka['kaj'kan'kar'ka!S'ka!l'ka!p'ka#R'ka#n'ka#o'ka#p'ka#q'ka#r'ka#s'ka#t'ka#u'ka#v'ka#x'ka#z'ka#{'ka$O'ka(a'ka(r'ka(y'ka(z'ka!]'ka!^'ka~O(y$}OP%aiR%ai[%aij%ain%air%ai!Q%ai!S%ai!l%ai!p%ai#R%ai#n%ai#o%ai#p%ai#q%ai#r%ai#s%ai#t%ai#u%ai#v%ai#x%ai#z%ai#{%ai$O%ai'y%ai(a%ai(r%ai(z%ai!]%ai!^%ai~O(z%POP%ciR%ci[%cij%cin%cir%ci!Q%ci!S%ci!l%ci!p%ci#R%ci#n%ci#o%ci#p%ci#q%ci#r%ci#s%ci#t%ci#u%ci#v%ci#x%ci#z%ci#{%ci$O%ci'y%ci(a%ci(r%ci(y%ci!]%ci!^%ci~O$O$oy!]$oy!^$oy~P#BwO$O#cy!]#cy!^#cy~P#BwO!g#vO!]'eq!k'eq~O!]/pO!k)Oy~O!Y'gq!]'gq~P#/sOr:|O!g#vO(r'pO~O[;QO!Y;PO~P#/sO!Y;PO~Og(_!R!](_!R~P!1WOa%[y!_%[y'z%[y!]%[y~P#/sO!]1TO!^)Xy~O!]5uO!^)Uq~O(T;XO~O!_1oO%i;[O~O!k;_O~O%i;dO~P&8fOP$|qR$|q[$|qj$|qr$|q!S$|q!l$|q!p$|q#R$|q#n$|q#o$|q#p$|q#q$|q#r$|q#s$|q#t$|q#u$|q#v$|q#x$|q#z$|q#{$|q$O$|q(a$|q(r$|q!]$|q!^$|q~P''VO!Q*OO'y*PO(z%POP'jaR'ja['jaj'jan'jar'ja!S'ja!l'ja!p'ja#R'ja#n'ja#o'ja#p'ja#q'ja#r'ja#s'ja#t'ja#u'ja#v'ja#x'ja#z'ja#{'ja$O'ja(a'ja(r'ja(y'ja!]'ja!^'ja~O!Q*OO'y*POP'laR'la['laj'lan'lar'la!S'la!l'la!p'la#R'la#n'la#o'la#p'la#q'la#r'la#s'la#t'la#u'la#v'la#x'la#z'la#{'la$O'la(a'la(r'la(y'la(z'la!]'la!^'la~OP%OqR%Oq[%Oqj%Oqr%Oq!S%Oq!l%Oq!p%Oq#R%Oq#n%Oq#o%Oq#p%Oq#q%Oq#r%Oq#s%Oq#t%Oq#u%Oq#v%Oq#x%Oq#z%Oq#{%Oq$O%Oq(a%Oq(r%Oq!]%Oq!^%Oq~P''VOg%e!Z!]%e!Z#`%e!Z$O%e!Z~P!1WO!Y;hO~P#/sOr;iO!g#vO(r'pO~O[;kO!Y;hO~P#/sO!]'pq!^'pq~P#BwO!]#h!Z!^#h!Z~P#BwO#k%e!ZP%e!ZR%e!Z[%e!Za%e!Zj%e!Zr%e!Z!S%e!Z!]%e!Z!l%e!Z!p%e!Z#R%e!Z#n%e!Z#o%e!Z#p%e!Z#q%e!Z#r%e!Z#s%e!Z#t%e!Z#u%e!Z#v%e!Z#x%e!Z#z%e!Z#{%e!Z'z%e!Z(a%e!Z(r%e!Z!k%e!Z!Y%e!Z'w%e!Z#`%e!Zv%e!Z!_%e!Z%i%e!Z!g%e!Z~P#/sOr;tO!g#vO(r'pO~O!Y;uO~P#/sOr;|O!g#vO(r'pO~O!Y;}O~P#/sOP%e!ZR%e!Z[%e!Zj%e!Zr%e!Z!S%e!Z!l%e!Z!p%e!Z#R%e!Z#n%e!Z#o%e!Z#p%e!Z#q%e!Z#r%e!Z#s%e!Z#t%e!Z#u%e!Z#v%e!Z#x%e!Z#z%e!Z#{%e!Z$O%e!Z(a%e!Z(r%e!Z!]%e!Z!^%e!Z~P''VOr<QO!g#vO(r'pO~Ov(fX~P1qO!Q%rO~P!)[O(U!lO~P!)[O!YfX!]fX#`fX~P%2OOP]XR]X[]Xj]Xr]X!Q]X!S]X!]]X!]fX!l]X!p]X#R]X#S]X#`]X#`fX#kfX#n]X#o]X#p]X#q]X#r]X#s]X#t]X#u]X#v]X#x]X#z]X#{]X$Q]X(a]X(r]X(y]X(z]X~O!gfX!k]X!kfX(rfX~P'LTOP<UOQ<UOSfOd>ROe!iOpkOr<UOskOtkOzkO|<UO!O<UO!SWO!WkO!XkO!_XO!i<XO!lZO!o<UO!p<UO!q<UO!s<YO!u<]O!x!hO$W!kO$n>PO(T)]O(VTO(YUO(aVO(o[O~O!]<iO!^$qa~Oh%VOp%WOr%XOs$tOt$tOz%YO|%ZO!O<tO!S${O!_$|O!i>WO!l$xO#j<zO$W%`O$t<vO$v<xO$y%aO(T(vO(VTO(YUO(a$uO(y$}O(z%PO~Ol)dO~P(!yOr!eX(r!eX~P#!iOr(jX(r(jX~P##[O!^]X!^fX~P'LTO!YfX!Y$zX!]fX!]$zX#`fX~P!0SO#k<^O~O!g#vO#k<^O~O#`<nO~Oj<bO~O#`=OO!](wX!^(wX~O#`<nO!](uX!^(uX~O#k=PO~Og=RO~P!1WO#k=XO~O#k=YO~Og=RO(T&ZO~O!g#vO#k=ZO~O!g#vO#k=PO~O$O=[O~P#BwO#k=]O~O#k=^O~O#k=cO~O#k=dO~O#k=eO~O#k=fO~O$O=gO~P!1WO$O=hO~P!1WOl=sO~P7eOk#S#T#U#W#X#[#i#j#u$n$t$v$y%]%^%h%i%j%q%s%v%w%y%{~(OT#o!X'|(U#ps#n#qr!Q'}$]'}(T$_(e~",
    goto: "$9Y)]PPPPPP)^PP)aP)rP+W/]PPPP6mPP7TPP=QPPP@tPA^PA^PPPA^PCfPA^PA^PA^PCjPCoPD^PIWPPPI[PPPPI[L_PPPLeMVPI[PI[PP! eI[PPPI[PI[P!#lI[P!'S!(X!(bP!)U!)Y!)U!,gPPPPPPP!-W!(XPP!-h!/YP!2iI[I[!2n!5z!:h!:h!>gPPP!>oI[PPPPPPPPP!BOP!C]PPI[!DnPI[PI[I[I[I[I[PI[!FQP!I[P!LbP!Lf!Lp!Lt!LtP!IXP!Lx!LxP#!OP#!SI[PI[#!Y#%_CjA^PA^PA^A^P#&lA^A^#)OA^#+vA^#.SA^A^#.r#1W#1W#1]#1f#1W#1qPP#1WPA^#2ZA^#6YA^A^6mPPP#:_PPP#:x#:xP#:xP#;`#:xPP#;fP#;]P#;]#;y#;]#<e#<k#<n)aP#<q)aP#<z#<z#<zP)aP)aP)aP)aPP)aP#=Q#=TP#=T)aP#=XP#=[P)aP)aP)aP)aP)aP)a)aPP#=b#=h#=s#=y#>P#>V#>]#>k#>q#>{#?R#?]#?c#?s#?y#@k#@}#AT#AZ#Ai#BO#Cs#DR#DY#Et#FS#Gt#HS#HY#H`#Hf#Hp#Hv#H|#IW#Ij#IpPPPPPPPPPPP#IvPPPPPPP#Jk#Mx$ b$ i$ qPPP$']P$'f$*_$0x$0{$1O$1}$2Q$2X$2aP$2g$2jP$3W$3[$4S$5b$5g$5}PP$6S$6Y$6^$6a$6e$6i$7e$7|$8e$8i$8l$8o$8y$8|$9Q$9UR!|RoqOXst!Z#d%m&r&t&u&w,s,x2[2_Y!vQ'`-e1o5{Q%tvQ%|yQ&T|Q&j!VS'W!e-]Q'f!iS'l!r!yU*k$|*Z*oQ+o%}S+|&V&WQ,d&dQ-c'_Q-m'gQ-u'mQ0[*qQ1b,OQ1y,eR<{<Y%SdOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%m%t&R&k&n&r&t&u&w&{'T'b'r(T(V(](d(x(z)O)}*i+X+],p,s,x-i-q.P.V.t.{/n0]0l0r1S1r2S2T2V2X2[2_2a3Q3W3l4z6T6e6f6i6|8t9T9_S#q]<V!r)_$Z$n'X)s-U-X/V2p4T5w6s:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>SU+P%]<s<tQ+t&PQ,f&gQ,m&oQ0x+gQ0}+iQ1Y+uQ2R,kQ3`.gQ5`0|Q5f1TQ6[1zQ7Y3dQ8`5gR9e7['QkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%m%t&R&k&n&o&r&t&u&w&{'T'X'b'r(T(V(](d(x(z)O)s)}*i+X+]+g,p,s,x-U-X-i-q.P.V.g.t.{/V/n0]0l0r1S1r2S2T2V2X2[2_2a2p3Q3W3d3l4T4z5w6T6e6f6i6s6|7[8t9T9_:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>S!S!nQ!r!v!y!z$|'W'_'`'l'm'n*k*o*q*r-]-c-e-u0[0_1o5{5}%[$ti#v$b$c$d$x${%O%Q%^%_%c)y*R*T*V*Y*a*g*w*x+f+i,S,V.f/P/d/m/x/y/{0`0b0i0j0o1f1i1q3c4^4_4j4o5Q5[5_6S7W7v8Q8V8[8q9b9p9y:P:`:r;Q;[;d;k<l<m<o<p<q<r<u<v<w<x<y<z=S=T=U=V=X=Y=]=^=_=`=a=b=c=d=g=h>P>X>Y>]>^Q&X|Q'U!eS'[%i-`Q+t&PQ,P&WQ,f&gQ0n+SQ1Y+uQ1_+{Q2Q,jQ2R,kQ5f1TQ5o1aQ6[1zQ6_1|Q6`2PQ8`5gQ8c5lQ8|6bQ:X8dQ:f8yQ;V:YR<}*ZrnOXst!V!Z#d%m&i&r&t&u&w,s,x2[2_R,h&k&z^OPXYstuvwz!Z!`!g!j!o#S#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%m%t&R&k&n&o&r&t&u&w&{'T'b'r(V(](d(x(z)O)s)}*i+X+]+g,p,s,x-U-X-i-q.P.V.g.t.{/V/n0]0l0r1S1r2S2T2V2X2[2_2a2p3Q3W3d3l4T4z5w6T6e6f6i6s6|7[8t9T9_:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>R>S[#]WZ#W#Z'X(T!b%jm#h#i#l$x%e%h(^(h(i(j*Y*^*b+Z+[+^,o-V.T.Z.[.]._/m/p2d3[3]4a6r7TQ%wxQ%{yW&Q|&V&W,OQ&_!TQ'c!hQ'e!iQ(q#sS+n%|%}Q+r&PQ,_&bQ,c&dS-l'f'gQ.i(rQ1R+oQ1X+uQ1Z+vQ1^+zQ1t,`S1x,d,eQ2|-mQ5e1TQ5i1WQ5n1`Q6Z1yQ8_5gQ8b5kQ8f5pQ:T8^R;T:U!U$zi$d%O%Q%^%_%c*R*T*a*w*x/P/x0`0b0i0j0o4_5Q8V9p>P>X>Y!^%yy!i!u%{%|%}'V'e'f'g'k'u*j+n+o-Y-l-m-t0R0U1R2u2|3T4r4s4v7}9{Q+h%wQ,T&[Q,W&]Q,b&dQ.h(qQ1s,_U1w,c,d,eQ3e.iQ6U1tS6Y1x1yQ8x6Z#f>T#v$b$c$x${)y*V*Y*g+f+i,S,V.f/d/m/y/{1f1i1q3c4^4j4o5[5_6S7W7v8Q8[8q9b9y:P:`:r;Q;[;d;k<o<q<u<w<y=S=U=X=]=_=a=c=g>]>^o>U<l<m<p<r<v<x<z=T=V=Y=^=`=b=d=hW%Ti%V*y>PS&[!Q&iQ&]!RQ&^!SU*}%[%d=sR,R&Y%]%Si#v$b$c$d$x${%O%Q%^%_%c)y*R*T*V*Y*a*g*w*x+f+i,S,V.f/P/d/m/x/y/{0`0b0i0j0o1f1i1q3c4^4_4j4o5Q5[5_6S7W7v8Q8V8[8q9b9p9y:P:`:r;Q;[;d;k<l<m<o<p<q<r<u<v<w<x<y<z=S=T=U=V=X=Y=]=^=_=`=a=b=c=d=g=h>P>X>Y>]>^T)z$u){V+P%]<s<tW'[!e%i*Z-`S(}#y#zQ+c%rQ+y&SS.b(m(nQ1j,XQ5T0kR8i5u'QkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%m%t&R&k&n&o&r&t&u&w&{'T'X'b'r(T(V(](d(x(z)O)s)}*i+X+]+g,p,s,x-U-X-i-q.P.V.g.t.{/V/n0]0l0r1S1r2S2T2V2X2[2_2a2p3Q3W3d3l4T4z5w6T6e6f6i6s6|7[8t9T9_:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>S$i$^c#Y#e%q%s%u(S(Y(t(y)R)S)T)U)V)W)X)Y)Z)[)^)`)b)g)q+d+x-Z-x-}.S.U.s.v.z.|.}/O/b0p2k2n3O3V3k3p3q3r3s3t3u3v3w3x3y3z3{3|4P4Q4X5X5c6u6{7Q7a7b7k7l8k9X9]9g9m9n:o;W;`<W=vT#TV#U'RkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%m%t&R&k&n&o&r&t&u&w&{'T'X'b'r(T(V(](d(x(z)O)s)}*i+X+]+g,p,s,x-U-X-i-q.P.V.g.t.{/V/n0]0l0r1S1r2S2T2V2X2[2_2a2p3Q3W3d3l4T4z5w6T6e6f6i6s6|7[8t9T9_:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>SQ'Y!eR2q-]!W!nQ!e!r!v!y!z$|'W'_'`'l'm'n*Z*k*o*q*r-]-c-e-u0[0_1o5{5}R1l,ZnqOXst!Z#d%m&r&t&u&w,s,x2[2_Q&y!^Q'v!xS(s#u<^Q+l%zQ,]&_Q,^&aQ-j'dQ-w'oS.r(x=PS0q+X=ZQ1P+mQ1n,[Q2c,zQ2e,{Q2m-WQ2z-kQ2}-oS5Y0r=eQ5a1QS5d1S=fQ6t2oQ6x2{Q6}3SQ8]5bQ9Y6vQ9Z6yQ9^7OR:l9V$d$]c#Y#e%s%u(S(Y(t(y)R)S)T)U)V)W)X)Y)Z)[)^)`)b)g)q+d+x-Z-x-}.S.U.s.v.z.}/O/b0p2k2n3O3V3k3p3q3r3s3t3u3v3w3x3y3z3{3|4P4Q4X5X5c6u6{7Q7a7b7k7l8k9X9]9g9m9n:o;W;`<W=vS(o#p'iQ)P#zS+b%q.|S.c(n(pR3^.d'QkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%m%t&R&k&n&o&r&t&u&w&{'T'X'b'r(T(V(](d(x(z)O)s)}*i+X+]+g,p,s,x-U-X-i-q.P.V.g.t.{/V/n0]0l0r1S1r2S2T2V2X2[2_2a2p3Q3W3d3l4T4z5w6T6e6f6i6s6|7[8t9T9_:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>SS#q]<VQ&t!XQ&u!YQ&w![Q&x!]R2Z,vQ'a!hQ+e%wQ-h'cS.e(q+hQ2x-gW3b.h.i0w0yQ6w2yW7U3_3a3e5^U9a7V7X7ZU:q9c9d9fS;b:p:sQ;p;cR;x;qU!wQ'`-eT5y1o5{!Q_OXZ`st!V!Z#d#h%e%m&i&k&r&t&u&w(j,s,x.[2[2_]!pQ!r'`-e1o5{T#q]<V%^{OPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%m%t&R&k&n&o&r&t&u&w&{'T'b'r(T(V(](d(x(z)O)}*i+X+]+g,p,s,x-i-q.P.V.g.t.{/n0]0l0r1S1r2S2T2V2X2[2_2a3Q3W3d3l4z6T6e6f6i6|7[8t9T9_S(}#y#zS.b(m(n!s=l$Z$n'X)s-U-X/V2p4T5w6s:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>SU$fd)_,mS(p#p'iU*v%R(w4OU0m+O.n7gQ5^0xQ7V3`Q9d7YR:s9em!tQ!r!v!y!z'`'l'm'n-e-u1o5{5}Q't!uS(f#g2US-s'k'wQ/s*]Q0R*jQ3U-vQ4f/tQ4r0TQ4s0UQ4x0^Q7r4`S7}4t4vS8R4y4{Q9r7sQ9v7yQ9{8OQ:Q8TS:{9w9xS;g:|;PS;s;h;iS;{;t;uS<P;|;}R<S<QQ#wbQ's!uS(e#g2US(g#m+WQ+Y%fQ+j%xQ+p&OU-r'k't'wQ.W(fU/r*]*`/wQ0S*jQ0V*lQ1O+kQ1u,aS3R-s-vQ3Z.`S4e/s/tQ4n0PS4q0R0^Q4u0WQ6W1vQ7P3US7q4`4bQ7u4fU7|4r4x4{Q8P4wQ8v6XS9q7r7sQ9u7yQ9}8RQ:O8SQ:c8wQ:y9rS:z9v9xQ;S:QQ;^:dS;f:{;PS;r;g;hS;z;s;uS<O;{;}Q<R<PQ<T<SQ=o=jQ={=tR=|=uV!wQ'`-e%^aOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%m%t&R&k&n&o&r&t&u&w&{'T'b'r(T(V(](d(x(z)O)}*i+X+]+g,p,s,x-i-q.P.V.g.t.{/n0]0l0r1S1r2S2T2V2X2[2_2a3Q3W3d3l4z6T6e6f6i6|7[8t9T9_S#wz!j!r=i$Z$n'X)s-U-X/V2p4T5w6s:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>SR=o>R%^bOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%m%t&R&k&n&o&r&t&u&w&{'T'b'r(T(V(](d(x(z)O)}*i+X+]+g,p,s,x-i-q.P.V.g.t.{/n0]0l0r1S1r2S2T2V2X2[2_2a3Q3W3d3l4z6T6e6f6i6|7[8t9T9_Q%fj!^%xy!i!u%{%|%}'V'e'f'g'k'u*j+n+o-Y-l-m-t0R0U1R2u2|3T4r4s4v7}9{S&Oz!jQ+k%yQ,a&dW1v,b,c,d,eU6X1w1x1yS8w6Y6ZQ:d8x!r=j$Z$n'X)s-U-X/V2p4T5w6s:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>SQ=t>QR=u>R%QeOPXYstuvw!Z!`!g!o#S#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%m%t&R&k&n&r&t&u&w&{'T'b'r(V(](d(x(z)O)}*i+X+]+g,p,s,x-i-q.P.V.g.t.{/n0]0l0r1S1r2S2T2V2X2[2_2a3Q3W3d3l4z6T6e6f6i6|7[8t9T9_Y#bWZ#W#Z(T!b%jm#h#i#l$x%e%h(^(h(i(j*Y*^*b+Z+[+^,o-V.T.Z.[.]._/m/p2d3[3]4a6r7TQ,n&o!p=k$Z$n)s-U-X/V2p4T5w6s:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>SR=n'XU']!e%i*ZR2s-`%SdOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%m%t&R&k&n&r&t&u&w&{'T'b'r(T(V(](d(x(z)O)}*i+X+],p,s,x-i-q.P.V.t.{/n0]0l0r1S1r2S2T2V2X2[2_2a3Q3W3l4z6T6e6f6i6|8t9T9_!r)_$Z$n'X)s-U-X/V2p4T5w6s:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>SQ,m&oQ0x+gQ3`.gQ7Y3dR9e7[!b$Tc#Y%q(S(Y(t(y)Z)[)`)g+x-x-}.S.U.s.v/b0p3O3V3k3{5X5c6{7Q7a9]:o<W!P<d)^)q-Z.|2k2n3p3y3z4P4X6u7b7k7l8k9X9g9m9n;W;`=v!f$Vc#Y%q(S(Y(t(y)W)X)Z)[)`)g+x-x-}.S.U.s.v/b0p3O3V3k3{5X5c6{7Q7a9]:o<W!T<f)^)q-Z.|2k2n3p3v3w3y3z4P4X6u7b7k7l8k9X9g9m9n;W;`=v!^$Zc#Y%q(S(Y(t(y)`)g+x-x-}.S.U.s.v/b0p3O3V3k3{5X5c6{7Q7a9]:o<WQ4_/kz>S)^)q-Z.|2k2n3p4P4X6u7b7k7l8k9X9g9m9n;W;`=vQ>X>ZR>Y>['QkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%m%t&R&k&n&o&r&t&u&w&{'T'X'b'r(T(V(](d(x(z)O)s)}*i+X+]+g,p,s,x-U-X-i-q.P.V.g.t.{/V/n0]0l0r1S1r2S2T2V2X2[2_2a2p3Q3W3d3l4T4z5w6T6e6f6i6s6|7[8t9T9_:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>SS$oh$pR4U/U'XgOPWXYZhstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n$p%m%t&R&k&n&o&r&t&u&w&{'T'X'b'r(T(V(](d(x(z)O)s)}*i+X+]+g,p,s,x-U-X-i-q.P.V.g.t.{/U/V/n0]0l0r1S1r2S2T2V2X2[2_2a2p3Q3W3d3l4T4z5w6T6e6f6i6s6|7[8t9T9_:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>ST$kf$qQ$ifS)j$l)nR)v$qT$jf$qT)l$l)n'XhOPWXYZhstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n$p%m%t&R&k&n&o&r&t&u&w&{'T'X'b'r(T(V(](d(x(z)O)s)}*i+X+]+g,p,s,x-U-X-i-q.P.V.g.t.{/U/V/n0]0l0r1S1r2S2T2V2X2[2_2a2p3Q3W3d3l4T4z5w6T6e6f6i6s6|7[8t9T9_:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>ST$oh$pQ$rhR)u$p%^jOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%m%t&R&k&n&o&r&t&u&w&{'T'b'r(T(V(](d(x(z)O)}*i+X+]+g,p,s,x-i-q.P.V.g.t.{/n0]0l0r1S1r2S2T2V2X2[2_2a3Q3W3d3l4z6T6e6f6i6|7[8t9T9_!s>Q$Z$n'X)s-U-X/V2p4T5w6s:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>S#glOPXZst!Z!`!o#S#d#o#{$n%m&k&n&o&r&t&u&w&{'T'b)O)s*i+]+g,p,s,x-i.g/V/n0]0l1r2S2T2V2X2[2_2a3d4T4z6T6e6f6i7[8t9T!U%Ri$d%O%Q%^%_%c*R*T*a*w*x/P/x0`0b0i0j0o4_5Q8V9p>P>X>Y#f(w#v$b$c$x${)y*V*Y*g+f+i,S,V.f/d/m/y/{1f1i1q3c4^4j4o5[5_6S7W7v8Q8[8q9b9y:P:`:r;Q;[;d;k<o<q<u<w<y=S=U=X=]=_=a=c=g>]>^Q+T%aQ/c*Oo4O<l<m<p<r<v<x<z=T=V=Y=^=`=b=d=h!U$yi$d%O%Q%^%_%c*R*T*a*w*x/P/x0`0b0i0j0o4_5Q8V9p>P>X>YQ*c$zU*l$|*Z*oQ+U%bQ0W*m#f=q#v$b$c$x${)y*V*Y*g+f+i,S,V.f/d/m/y/{1f1i1q3c4^4j4o5[5_6S7W7v8Q8[8q9b9y:P:`:r;Q;[;d;k<o<q<u<w<y=S=U=X=]=_=a=c=g>]>^n=r<l<m<p<r<v<x<z=T=V=Y=^=`=b=d=hQ=w>TQ=x>UQ=y>VR=z>W!U%Ri$d%O%Q%^%_%c*R*T*a*w*x/P/x0`0b0i0j0o4_5Q8V9p>P>X>Y#f(w#v$b$c$x${)y*V*Y*g+f+i,S,V.f/d/m/y/{1f1i1q3c4^4j4o5[5_6S7W7v8Q8[8q9b9y:P:`:r;Q;[;d;k<o<q<u<w<y=S=U=X=]=_=a=c=g>]>^o4O<l<m<p<r<v<x<z=T=V=Y=^=`=b=d=hnoOXst!Z#d%m&r&t&u&w,s,x2[2_S*f${*YQ-R'OQ-S'QR4i/y%[%Si#v$b$c$d$x${%O%Q%^%_%c)y*R*T*V*Y*a*g*w*x+f+i,S,V.f/P/d/m/x/y/{0`0b0i0j0o1f1i1q3c4^4_4j4o5Q5[5_6S7W7v8Q8V8[8q9b9p9y:P:`:r;Q;[;d;k<l<m<o<p<q<r<u<v<w<x<y<z=S=T=U=V=X=Y=]=^=_=`=a=b=c=d=g=h>P>X>Y>]>^Q,U&]Q1h,WQ5s1gR8h5tV*n$|*Z*oU*n$|*Z*oT5z1o5{S0P*i/nQ4w0]T8S4z:]Q+j%xQ0V*lQ1O+kQ1u,aQ6W1vQ8v6XQ:c8wR;^:d!U%Oi$d%O%Q%^%_%c*R*T*a*w*x/P/x0`0b0i0j0o4_5Q8V9p>P>X>Yx*R$v)e*S*u+V/v0d0e4R4g5R5S5W7p8U:R:x=p=}>OS0`*t0a#f<o#v$b$c$x${)y*V*Y*g+f+i,S,V.f/d/m/y/{1f1i1q3c4^4j4o5[5_6S7W7v8Q8[8q9b9y:P:`:r;Q;[;d;k<o<q<u<w<y=S=U=X=]=_=a=c=g>]>^n<p<l<m<p<r<v<x<z=T=V=Y=^=`=b=d=h!d=S(u)c*[*e.j.m.q/_/k/|0v1e3h4[4h4l5r7]7`7w7z8X8Z9t9|:S:};R;e;j;v>Z>[`=T3}7c7f7j9h:t:w;yS=_.l3iT=`7e9k!U%Qi$d%O%Q%^%_%c*R*T*a*w*x/P/x0`0b0i0j0o4_5Q8V9p>P>X>Y|*T$v)e*U*t+V/g/v0d0e4R4g4|5R5S5W7p8U:R:x=p=}>OS0b*u0c#f<q#v$b$c$x${)y*V*Y*g+f+i,S,V.f/d/m/y/{1f1i1q3c4^4j4o5[5_6S7W7v8Q8[8q9b9y:P:`:r;Q;[;d;k<o<q<u<w<y=S=U=X=]=_=a=c=g>]>^n<r<l<m<p<r<v<x<z=T=V=Y=^=`=b=d=h!h=U(u)c*[*e.k.l.q/_/k/|0v1e3f3h4[4h4l5r7]7^7`7w7z8X8Z9t9|:S:};R;e;j;v>Z>[d=V3}7d7e7j9h9i:t:u:w;yS=a.m3jT=b7f9lrnOXst!V!Z#d%m&i&r&t&u&w,s,x2[2_Q&f!UR,p&ornOXst!V!Z#d%m&i&r&t&u&w,s,x2[2_R&f!UQ,Y&^R1d,RsnOXst!V!Z#d%m&i&r&t&u&w,s,x2[2_Q1p,_S6R1s1tU8p6P6Q6US:_8r8sS;Y:^:aQ;m;ZR;w;nQ&m!VR,i&iR6_1|R:f8yW&Q|&V&W,OR1Z+vQ&r!WR,s&sR,y&xT2],x2_R,}&yQ,|&yR2f,}Q'y!{R-y'ySsOtQ#dXT%ps#dQ#OTR'{#OQ#RUR'}#RQ){$uR/`){Q#UVR(Q#UQ#XWU(W#X(X.QQ(X#YR.Q(YQ-^'YR2r-^Q.u(yS3m.u3nR3n.vQ-e'`R2v-eY!rQ'`-e1o5{R'j!rQ/Q)eR4S/QU#_W%h*YU(_#_(`.RQ(`#`R.R(ZQ-a']R2t-at`OXst!V!Z#d%m&i&k&r&t&u&w,s,x2[2_S#hZ%eU#r`#h.[R.[(jQ(k#jQ.X(gW.a(k.X3X7RQ3X.YR7R3YQ)n$lR/W)nQ$phR)t$pQ$`cU)a$`-|<jQ-|<WR<j)qQ/q*]W4c/q4d7t9sU4d/r/s/tS7t4e4fR9s7u$e*Q$v(u)c)e*[*e*t*u+Q+R+V.l.m.o.p.q/_/g/i/k/v/|0d0e0v1e3f3g3h3}4R4[4g4h4l4|5O5R5S5W5r7]7^7_7`7e7f7h7i7j7p7w7z8U8X8Z9h9i9j9t9|:R:S:t:u:v:w:x:};R;e;j;v;y=p=}>O>Z>[Q/z*eU4k/z4m7xQ4m/|R7x4lS*o$|*ZR0Y*ox*S$v)e*t*u+V/v0d0e4R4g5R5S5W7p8U:R:x=p=}>O!d.j(u)c*[*e.l.m.q/_/k/|0v1e3h4[4h4l5r7]7`7w7z8X8Z9t9|:S:};R;e;j;v>Z>[U/h*S.j7ca7c3}7e7f7j9h:t:w;yQ0a*tQ3i.lU4}0a3i9kR9k7e|*U$v)e*t*u+V/g/v0d0e4R4g4|5R5S5W7p8U:R:x=p=}>O!h.k(u)c*[*e.l.m.q/_/k/|0v1e3f3h4[4h4l5r7]7^7`7w7z8X8Z9t9|:S:};R;e;j;v>Z>[U/j*U.k7de7d3}7e7f7j9h9i:t:u:w;yQ0c*uQ3j.mU5P0c3j9lR9l7fQ*z%UR0g*zQ5]0vR8Y5]Q+_%kR0u+_Q5v1jS8j5v:[R:[8kQ,[&_R1m,[Q5{1oR8m5{Q1{,fS6]1{8zR8z6_Q1U+rW5h1U5j8a:VQ5j1XQ8a5iR:V8bQ+w&QR1[+wQ2_,xR6m2_YrOXst#dQ&v!ZQ+a%mQ,r&rQ,t&tQ,u&uQ,w&wQ2Y,sS2],x2_R6l2[Q%opQ&z!_Q&}!aQ'P!bQ'R!cQ'q!uQ+`%lQ+l%zQ,Q&XQ,h&mQ-P&|W-p'k's't'wQ-w'oQ0X*nQ1P+mQ1c,PS2O,i,lQ2g-OQ2h-RQ2i-SQ2}-oW3P-r-s-v-xQ5a1QQ5m1_Q5q1eQ6V1uQ6a2QQ6k2ZU6z3O3R3UQ6}3SQ8]5bQ8e5oQ8g5rQ8l5zQ8u6WQ8{6`S9[6{7PQ9^7OQ:W8cQ:b8vQ:g8|Q:n9]Q;U:XQ;]:cQ;a:oQ;l;VR;o;^Q%zyQ'd!iQ'o!uU+m%{%|%}Q-W'VU-k'e'f'gS-o'k'uQ0Q*jS1Q+n+oQ2o-YS2{-l-mQ3S-tS4p0R0UQ5b1RQ6v2uQ6y2|Q7O3TU7{4r4s4vQ9z7}R;O9{S$wi>PR*{%VU%Ui%V>PR0f*yQ$viS(u#v+iS)c$b$cQ)e$dQ*[$xS*e${*YQ*t%OQ*u%QQ+Q%^Q+R%_Q+V%cQ.l<oQ.m<qQ.o<uQ.p<wQ.q<yQ/_)yQ/g*RQ/i*TQ/k*VQ/v*aS/|*g/mQ0d*wQ0e*xl0v+f,V.f1i1q3c6S7W8q9b:`:r;[;dQ1e,SQ3f=SQ3g=UQ3h=XS3}<l<mQ4R/PS4[/d4^Q4g/xQ4h/yQ4l/{Q4|0`Q5O0bQ5R0iQ5S0jQ5W0oQ5r1fQ7]=]Q7^=_Q7_=aQ7`=cQ7e<pQ7f<rQ7h<vQ7i<xQ7j<zQ7p4_Q7w4jQ7z4oQ8U5QQ8X5[Q8Z5_Q9h=YQ9i=TQ9j=VQ9t7vQ9|8QQ:R8VQ:S8[Q:t=^Q:u=`Q:v=bQ:w=dQ:x9pQ:}9yQ;R:PQ;e=gQ;j;QQ;v;kQ;y=hQ=p>PQ=}>XQ>O>YQ>Z>]R>[>^Q+O%]Q.n<sR7g<tnpOXst!Z#d%m&r&t&u&w,s,x2[2_Q!fPS#fZ#oQ&|!`W'h!o*i0]4zQ(P#SQ)Q#{Q)r$nS,l&k&nQ,q&oQ-O&{S-T'T/nQ-g'bQ.x)OQ/[)sQ0s+]Q0y+gQ2W,pQ2y-iQ3a.gQ4W/VQ5U0lQ6Q1rQ6c2SQ6d2TQ6h2VQ6j2XQ6o2aQ7Z3dQ7m4TQ8s6TQ9P6eQ9Q6fQ9S6iQ9f7[Q:a8tR:k9T#[cOPXZst!Z!`!o#d#o#{%m&k&n&o&r&t&u&w&{'T'b)O*i+]+g,p,s,x-i.g/n0]0l1r2S2T2V2X2[2_2a3d4z6T6e6f6i7[8t9TQ#YWQ#eYQ%quQ%svS%uw!gS(S#W(VQ(Y#ZQ(t#uQ(y#xQ)R$OQ)S$PQ)T$QQ)U$RQ)V$SQ)W$TQ)X$UQ)Y$VQ)Z$WQ)[$XQ)^$ZQ)`$_Q)b$aQ)g$eW)q$n)s/V4TQ+d%tQ+x&RS-Z'X2pQ-x'rS-}(T.PQ.S(]Q.U(dQ.s(xQ.v(zQ.z<UQ.|<XQ.}<YQ/O<]Q/b)}Q0p+XQ2k-UQ2n-XQ3O-qQ3V.VQ3k.tQ3p<^Q3q<_Q3r<`Q3s<aQ3t<bQ3u<cQ3v<dQ3w<eQ3x<fQ3y<gQ3z<hQ3{.{Q3|<kQ4P<nQ4Q<{Q4X<iQ5X0rQ5c1SQ6u=OQ6{3QQ7Q3WQ7a3lQ7b=PQ7k=RQ7l=ZQ8k5wQ9X6sQ9]6|Q9g=[Q9m=eQ9n=fQ:o9_Q;W:ZQ;`:mQ<W#SR=v>SR#[WR'Z!el!tQ!r!v!y!z'`'l'm'n-e-u1o5{5}S'V!e-]U*j$|*Z*oS-Y'W'_S0U*k*qQ0^*rQ2u-cQ4v0[R4{0_R({#xQ!fQT-d'`-e]!qQ!r'`-e1o5{Q#p]R'i<VR)f$dY!uQ'`-e1o5{Q'k!rS'u!v!yS'w!z5}S-t'l'mQ-v'nR3T-uT#kZ%eS#jZ%eS%km,oU(g#h#i#lS.Y(h(iQ.^(jQ0t+^Q3Y.ZU3Z.[.]._S7S3[3]R9`7Td#^W#W#Z%h(T(^*Y+Z.T/mr#gZm#h#i#l%e(h(i(j+^.Z.[.]._3[3]7TS*]$x*bQ/t*^Q2U,oQ2l-VQ4`/pQ6q2dQ7s4aQ9W6rT=m'X+[V#aW%h*YU#`W%h*YS(U#W(^U(Z#Z+Z/mS-['X+[T.O(T.TV'^!e%i*ZQ$lfR)x$qT)m$l)nR4V/UT*_$x*bT*h${*YQ0w+fQ1g,VQ3_.fQ5t1iQ6P1qQ7X3cQ8r6SQ9c7WQ:^8qQ:p9bQ;Z:`Q;c:rQ;n;[R;q;dnqOXst!Z#d%m&r&t&u&w,s,x2[2_Q&l!VR,h&itmOXst!U!V!Z#d%m&i&r&t&u&w,s,x2[2_R,o&oT%lm,oR1k,XR,g&gQ&U|S+}&V&WR1^,OR+s&PT&p!W&sT&q!W&sT2^,x2_",
    nodeNames: "\u26A0 ArithOp ArithOp ?. JSXStartTag LineComment BlockComment Script Hashbang ExportDeclaration export Star as VariableName String Escape from ; default FunctionDeclaration async function VariableDefinition > < TypeParamList in out const TypeDefinition extends ThisType this LiteralType ArithOp Number BooleanLiteral TemplateType InterpolationEnd Interpolation InterpolationStart NullType null VoidType void TypeofType typeof MemberExpression . PropertyName [ TemplateString Escape Interpolation super RegExp ] ArrayExpression Spread , } { ObjectExpression Property async get set PropertyDefinition Block : NewTarget new NewExpression ) ( ArgList UnaryExpression delete LogicOp BitOp YieldExpression yield AwaitExpression await ParenthesizedExpression ClassExpression class ClassBody MethodDeclaration Decorator @ MemberExpression PrivatePropertyName CallExpression TypeArgList CompareOp < declare Privacy static abstract override PrivatePropertyDefinition PropertyDeclaration readonly accessor Optional TypeAnnotation Equals StaticBlock FunctionExpression ArrowFunction ParamList ParamList ArrayPattern ObjectPattern PatternProperty Privacy readonly Arrow MemberExpression BinaryExpression ArithOp ArithOp ArithOp ArithOp BitOp CompareOp instanceof satisfies CompareOp BitOp BitOp BitOp LogicOp LogicOp ConditionalExpression LogicOp LogicOp AssignmentExpression UpdateOp PostfixExpression CallExpression InstantiationExpression TaggedTemplateExpression DynamicImport import ImportMeta JSXElement JSXSelfCloseEndTag JSXSelfClosingTag JSXIdentifier JSXBuiltin JSXIdentifier JSXNamespacedName JSXMemberExpression JSXSpreadAttribute JSXAttribute JSXAttributeValue JSXEscape JSXEndTag JSXOpenTag JSXFragmentTag JSXText JSXEscape JSXStartCloseTag JSXCloseTag PrefixCast < ArrowFunction TypeParamList SequenceExpression InstantiationExpression KeyofType keyof UniqueType unique ImportType InferredType infer TypeName ParenthesizedType FunctionSignature ParamList NewSignature IndexedType TupleType Label ArrayType ReadonlyType ObjectType MethodType PropertyType IndexSignature PropertyDefinition CallSignature TypePredicate asserts is NewSignature new UnionType LogicOp IntersectionType LogicOp ConditionalType ParameterizedType ClassDeclaration abstract implements type VariableDeclaration let var using TypeAliasDeclaration InterfaceDeclaration interface EnumDeclaration enum EnumBody NamespaceDeclaration namespace module AmbientDeclaration declare GlobalDeclaration global ClassDeclaration ClassBody AmbientFunctionDeclaration ExportGroup VariableName VariableName ImportDeclaration defer ImportGroup ForStatement for ForSpec ForInSpec ForOfSpec of WhileStatement while WithStatement with DoStatement do IfStatement if else SwitchStatement switch SwitchBody CaseLabel case DefaultLabel TryStatement try CatchClause catch FinallyClause finally ReturnStatement return ThrowStatement throw BreakStatement break ContinueStatement continue DebuggerStatement debugger LabeledStatement ExpressionStatement SingleExpression SingleClassItem",
    maxTerm: 380,
    context: $44c7044f9afa5475$var$trackNewline,
    nodeProps: [
        [
            "isolate",
            -8,
            5,
            6,
            14,
            37,
            39,
            51,
            53,
            55,
            ""
        ],
        [
            "group",
            -26,
            9,
            17,
            19,
            68,
            207,
            211,
            215,
            216,
            218,
            221,
            224,
            234,
            237,
            243,
            245,
            247,
            249,
            252,
            258,
            264,
            266,
            268,
            270,
            272,
            274,
            275,
            "Statement",
            -34,
            13,
            14,
            32,
            35,
            36,
            42,
            51,
            54,
            55,
            57,
            62,
            70,
            72,
            76,
            80,
            82,
            84,
            85,
            110,
            111,
            120,
            121,
            136,
            139,
            141,
            142,
            143,
            144,
            145,
            147,
            148,
            167,
            169,
            171,
            "Expression",
            -23,
            31,
            33,
            37,
            41,
            43,
            45,
            173,
            175,
            177,
            178,
            180,
            181,
            182,
            184,
            185,
            186,
            188,
            189,
            190,
            201,
            203,
            205,
            206,
            "Type",
            -3,
            88,
            103,
            109,
            "ClassItem"
        ],
        [
            "openedBy",
            23,
            "<",
            38,
            "InterpolationStart",
            56,
            "[",
            60,
            "{",
            73,
            "(",
            160,
            "JSXStartCloseTag"
        ],
        [
            "closedBy",
            -2,
            24,
            168,
            ">",
            40,
            "InterpolationEnd",
            50,
            "]",
            61,
            "}",
            74,
            ")",
            165,
            "JSXEndTag"
        ]
    ],
    propSources: [
        $44c7044f9afa5475$var$jsHighlight
    ],
    skippedNodes: [
        0,
        5,
        6,
        278
    ],
    repeatNodeCount: 37,
    tokenData: "$Fq07[R!bOX%ZXY+gYZ-yZ[+g[]%Z]^.c^p%Zpq+gqr/mrs3cst:_tuEruvJSvwLkwx! Yxy!'iyz!(sz{!)}{|!,q|}!.O}!O!,q!O!P!/Y!P!Q!9j!Q!R#:O!R![#<_![!]#I_!]!^#Jk!^!_#Ku!_!`$![!`!a$$v!a!b$*T!b!c$,r!c!}Er!}#O$-|#O#P$/W#P#Q$4o#Q#R$5y#R#SEr#S#T$7W#T#o$8b#o#p$<r#p#q$=h#q#r$>x#r#s$@U#s$f%Z$f$g+g$g#BYEr#BY#BZ$A`#BZ$ISEr$IS$I_$A`$I_$I|Er$I|$I}$Dk$I}$JO$Dk$JO$JTEr$JT$JU$A`$JU$KVEr$KV$KW$A`$KW&FUEr&FU&FV$A`&FV;'SEr;'S;=`I|<%l?HTEr?HT?HU$A`?HUOEr(n%d_$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z&j&hT$i&jO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c&j&zP;=`<%l&c'|'U]$i&j(Z!bOY&}YZ&cZw&}wx&cx!^&}!^!_'}!_#O&}#O#P&c#P#o&}#o#p'}#p;'S&};'S;=`(l<%lO&}!b(SU(Z!bOY'}Zw'}x#O'}#P;'S'};'S;=`(f<%lO'}!b(iP;=`<%l'}'|(oP;=`<%l&}'[(y]$i&j(WpOY(rYZ&cZr(rrs&cs!^(r!^!_)r!_#O(r#O#P&c#P#o(r#o#p)r#p;'S(r;'S;=`*a<%lO(rp)wU(WpOY)rZr)rs#O)r#P;'S)r;'S;=`*Z<%lO)rp*^P;=`<%l)r'[*dP;=`<%l(r#S*nX(Wp(Z!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g#S+^P;=`<%l*g(n+dP;=`<%l%Z07[+rq$i&j(Wp(Z!b'|0/lOX%ZXY+gYZ&cZ[+g[p%Zpq+gqr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p$f%Z$f$g+g$g#BY%Z#BY#BZ+g#BZ$IS%Z$IS$I_+g$I_$JT%Z$JT$JU+g$JU$KV%Z$KV$KW+g$KW&FU%Z&FU&FV+g&FV;'S%Z;'S;=`+a<%l?HT%Z?HT?HU+g?HUO%Z07[.ST(X#S$i&j'}0/lO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c07[.n_$i&j(Wp(Z!b'}0/lOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z)3p/x`$i&j!p),Q(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`0z!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW1V`#v(Ch$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`2X!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW2d_#v(Ch$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'At3l_(V':f$i&j(Z!bOY4kYZ5qZr4krs7nsw4kwx5qx!^4k!^!_8p!_#O4k#O#P5q#P#o4k#o#p8p#p;'S4k;'S;=`:X<%lO4k(^4r_$i&j(Z!bOY4kYZ5qZr4krs7nsw4kwx5qx!^4k!^!_8p!_#O4k#O#P5q#P#o4k#o#p8p#p;'S4k;'S;=`:X<%lO4k&z5vX$i&jOr5qrs6cs!^5q!^!_6y!_#o5q#o#p6y#p;'S5q;'S;=`7h<%lO5q&z6jT$d`$i&jO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c`6|TOr6yrs7]s;'S6y;'S;=`7b<%lO6y`7bO$d``7eP;=`<%l6y&z7kP;=`<%l5q(^7w]$d`$i&j(Z!bOY&}YZ&cZw&}wx&cx!^&}!^!_'}!_#O&}#O#P&c#P#o&}#o#p'}#p;'S&};'S;=`(l<%lO&}!r8uZ(Z!bOY8pYZ6yZr8prs9hsw8pwx6yx#O8p#O#P6y#P;'S8p;'S;=`:R<%lO8p!r9oU$d`(Z!bOY'}Zw'}x#O'}#P;'S'};'S;=`(f<%lO'}!r:UP;=`<%l8p(^:[P;=`<%l4k%9[:hh$i&j(Wp(Z!bOY%ZYZ&cZq%Zqr<Srs&}st%ZtuCruw%Zwx(rx!^%Z!^!_*g!_!c%Z!c!}Cr!}#O%Z#O#P&c#P#R%Z#R#SCr#S#T%Z#T#oCr#o#p*g#p$g%Z$g;'SCr;'S;=`El<%lOCr(r<__WS$i&j(Wp(Z!bOY<SYZ&cZr<Srs=^sw<Swx@nx!^<S!^!_Bm!_#O<S#O#P>`#P#o<S#o#pBm#p;'S<S;'S;=`Cl<%lO<S(Q=g]WS$i&j(Z!bOY=^YZ&cZw=^wx>`x!^=^!^!_?q!_#O=^#O#P>`#P#o=^#o#p?q#p;'S=^;'S;=`@h<%lO=^&n>gXWS$i&jOY>`YZ&cZ!^>`!^!_?S!_#o>`#o#p?S#p;'S>`;'S;=`?k<%lO>`S?XSWSOY?SZ;'S?S;'S;=`?e<%lO?SS?hP;=`<%l?S&n?nP;=`<%l>`!f?xWWS(Z!bOY?qZw?qwx?Sx#O?q#O#P?S#P;'S?q;'S;=`@b<%lO?q!f@eP;=`<%l?q(Q@kP;=`<%l=^'`@w]WS$i&j(WpOY@nYZ&cZr@nrs>`s!^@n!^!_Ap!_#O@n#O#P>`#P#o@n#o#pAp#p;'S@n;'S;=`Bg<%lO@ntAwWWS(WpOYApZrAprs?Ss#OAp#O#P?S#P;'SAp;'S;=`Ba<%lOAptBdP;=`<%lAp'`BjP;=`<%l@n#WBvYWS(Wp(Z!bOYBmZrBmrs?qswBmwxApx#OBm#O#P?S#P;'SBm;'S;=`Cf<%lOBm#WCiP;=`<%lBm(rCoP;=`<%l<S%9[C}i$i&j(o%1l(Wp(Z!bOY%ZYZ&cZr%Zrs&}st%ZtuCruw%Zwx(rx!Q%Z!Q![Cr![!^%Z!^!_*g!_!c%Z!c!}Cr!}#O%Z#O#P&c#P#R%Z#R#SCr#S#T%Z#T#oCr#o#p*g#p$g%Z$g;'SCr;'S;=`El<%lOCr%9[EoP;=`<%lCr07[FRk$i&j(Wp(Z!b$]#t(T,2j(e$I[OY%ZYZ&cZr%Zrs&}st%ZtuEruw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Er![!^%Z!^!_*g!_!c%Z!c!}Er!}#O%Z#O#P&c#P#R%Z#R#SEr#S#T%Z#T#oEr#o#p*g#p$g%Z$g;'SEr;'S;=`I|<%lOEr+dHRk$i&j(Wp(Z!b$]#tOY%ZYZ&cZr%Zrs&}st%ZtuGvuw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Gv![!^%Z!^!_*g!_!c%Z!c!}Gv!}#O%Z#O#P&c#P#R%Z#R#SGv#S#T%Z#T#oGv#o#p*g#p$g%Z$g;'SGv;'S;=`Iv<%lOGv+dIyP;=`<%lGv07[JPP;=`<%lEr(KWJ_`$i&j(Wp(Z!b#p(ChOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KWKl_$i&j$Q(Ch(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z,#xLva(z+JY$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sv%ZvwM{wx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KWNW`$i&j#z(Ch(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'At! c_(Y';W$i&j(WpOY!!bYZ!#hZr!!brs!#hsw!!bwx!$xx!^!!b!^!_!%z!_#O!!b#O#P!#h#P#o!!b#o#p!%z#p;'S!!b;'S;=`!'c<%lO!!b'l!!i_$i&j(WpOY!!bYZ!#hZr!!brs!#hsw!!bwx!$xx!^!!b!^!_!%z!_#O!!b#O#P!#h#P#o!!b#o#p!%z#p;'S!!b;'S;=`!'c<%lO!!b&z!#mX$i&jOw!#hwx6cx!^!#h!^!_!$Y!_#o!#h#o#p!$Y#p;'S!#h;'S;=`!$r<%lO!#h`!$]TOw!$Ywx7]x;'S!$Y;'S;=`!$l<%lO!$Y`!$oP;=`<%l!$Y&z!$uP;=`<%l!#h'l!%R]$d`$i&j(WpOY(rYZ&cZr(rrs&cs!^(r!^!_)r!_#O(r#O#P&c#P#o(r#o#p)r#p;'S(r;'S;=`*a<%lO(r!Q!&PZ(WpOY!%zYZ!$YZr!%zrs!$Ysw!%zwx!&rx#O!%z#O#P!$Y#P;'S!%z;'S;=`!']<%lO!%z!Q!&yU$d`(WpOY)rZr)rs#O)r#P;'S)r;'S;=`*Z<%lO)r!Q!'`P;=`<%l!%z'l!'fP;=`<%l!!b/5|!'t_!l/.^$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z#&U!)O_!k!Lf$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z-!n!*[b$i&j(Wp(Z!b(U%&f#q(ChOY%ZYZ&cZr%Zrs&}sw%Zwx(rxz%Zz{!+d{!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW!+o`$i&j(Wp(Z!b#n(ChOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z+;x!,|`$i&j(Wp(Z!br+4YOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z,$U!.Z_!]+Jf$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z07[!/ec$i&j(Wp(Z!b!Q.2^OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!0p!P!Q%Z!Q![!3Y![!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z#%|!0ya$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!2O!P!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z#%|!2Z_![!L^$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad!3eg$i&j(Wp(Z!bs'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![!3Y![!^%Z!^!_*g!_!g%Z!g!h!4|!h#O%Z#O#P&c#P#R%Z#R#S!3Y#S#X%Z#X#Y!4|#Y#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad!5Vg$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx{%Z{|!6n|}%Z}!O!6n!O!Q%Z!Q![!8S![!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S!8S#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad!6wc$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![!8S![!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S!8S#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad!8_c$i&j(Wp(Z!bs'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![!8S![!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S!8S#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z07[!9uf$i&j(Wp(Z!b#o(ChOY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcxz!;Zz{#-}{!P!;Z!P!Q#/d!Q!^!;Z!^!_#(i!_!`#7S!`!a#8i!a!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;Z?O!;fb$i&j(Wp(Z!b!X7`OY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcx!P!;Z!P!Q#&`!Q!^!;Z!^!_#(i!_!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;Z>^!<w`$i&j(Z!b!X7`OY!<nYZ&cZw!<nwx!=yx!P!<n!P!Q!Eq!Q!^!<n!^!_!Gr!_!}!<n!}#O!KS#O#P!Dy#P#o!<n#o#p!Gr#p;'S!<n;'S;=`!L]<%lO!<n<z!>Q^$i&j!X7`OY!=yYZ&cZ!P!=y!P!Q!>|!Q!^!=y!^!_!@c!_!}!=y!}#O!CW#O#P!Dy#P#o!=y#o#p!@c#p;'S!=y;'S;=`!Ek<%lO!=y<z!?Td$i&j!X7`O!^&c!_#W&c#W#X!>|#X#Z&c#Z#[!>|#[#]&c#]#^!>|#^#a&c#a#b!>|#b#g&c#g#h!>|#h#i&c#i#j!>|#j#k!>|#k#m&c#m#n!>|#n#o&c#p;'S&c;'S;=`&w<%lO&c7`!@hX!X7`OY!@cZ!P!@c!P!Q!AT!Q!}!@c!}#O!Ar#O#P!Bq#P;'S!@c;'S;=`!CQ<%lO!@c7`!AYW!X7`#W#X!AT#Z#[!AT#]#^!AT#a#b!AT#g#h!AT#i#j!AT#j#k!AT#m#n!AT7`!AuVOY!ArZ#O!Ar#O#P!B[#P#Q!@c#Q;'S!Ar;'S;=`!Bk<%lO!Ar7`!B_SOY!ArZ;'S!Ar;'S;=`!Bk<%lO!Ar7`!BnP;=`<%l!Ar7`!BtSOY!@cZ;'S!@c;'S;=`!CQ<%lO!@c7`!CTP;=`<%l!@c<z!C][$i&jOY!CWYZ&cZ!^!CW!^!_!Ar!_#O!CW#O#P!DR#P#Q!=y#Q#o!CW#o#p!Ar#p;'S!CW;'S;=`!Ds<%lO!CW<z!DWX$i&jOY!CWYZ&cZ!^!CW!^!_!Ar!_#o!CW#o#p!Ar#p;'S!CW;'S;=`!Ds<%lO!CW<z!DvP;=`<%l!CW<z!EOX$i&jOY!=yYZ&cZ!^!=y!^!_!@c!_#o!=y#o#p!@c#p;'S!=y;'S;=`!Ek<%lO!=y<z!EnP;=`<%l!=y>^!Ezl$i&j(Z!b!X7`OY&}YZ&cZw&}wx&cx!^&}!^!_'}!_#O&}#O#P&c#P#W&}#W#X!Eq#X#Z&}#Z#[!Eq#[#]&}#]#^!Eq#^#a&}#a#b!Eq#b#g&}#g#h!Eq#h#i&}#i#j!Eq#j#k!Eq#k#m&}#m#n!Eq#n#o&}#o#p'}#p;'S&};'S;=`(l<%lO&}8r!GyZ(Z!b!X7`OY!GrZw!Grwx!@cx!P!Gr!P!Q!Hl!Q!}!Gr!}#O!JU#O#P!Bq#P;'S!Gr;'S;=`!J|<%lO!Gr8r!Hse(Z!b!X7`OY'}Zw'}x#O'}#P#W'}#W#X!Hl#X#Z'}#Z#[!Hl#[#]'}#]#^!Hl#^#a'}#a#b!Hl#b#g'}#g#h!Hl#h#i'}#i#j!Hl#j#k!Hl#k#m'}#m#n!Hl#n;'S'};'S;=`(f<%lO'}8r!JZX(Z!bOY!JUZw!JUwx!Arx#O!JU#O#P!B[#P#Q!Gr#Q;'S!JU;'S;=`!Jv<%lO!JU8r!JyP;=`<%l!JU8r!KPP;=`<%l!Gr>^!KZ^$i&j(Z!bOY!KSYZ&cZw!KSwx!CWx!^!KS!^!_!JU!_#O!KS#O#P!DR#P#Q!<n#Q#o!KS#o#p!JU#p;'S!KS;'S;=`!LV<%lO!KS>^!LYP;=`<%l!KS>^!L`P;=`<%l!<n=l!Ll`$i&j(Wp!X7`OY!LcYZ&cZr!Lcrs!=ys!P!Lc!P!Q!Mn!Q!^!Lc!^!_# o!_!}!Lc!}#O#%P#O#P!Dy#P#o!Lc#o#p# o#p;'S!Lc;'S;=`#&Y<%lO!Lc=l!Mwl$i&j(Wp!X7`OY(rYZ&cZr(rrs&cs!^(r!^!_)r!_#O(r#O#P&c#P#W(r#W#X!Mn#X#Z(r#Z#[!Mn#[#](r#]#^!Mn#^#a(r#a#b!Mn#b#g(r#g#h!Mn#h#i(r#i#j!Mn#j#k!Mn#k#m(r#m#n!Mn#n#o(r#o#p)r#p;'S(r;'S;=`*a<%lO(r8Q# vZ(Wp!X7`OY# oZr# ors!@cs!P# o!P!Q#!i!Q!}# o!}#O#$R#O#P!Bq#P;'S# o;'S;=`#$y<%lO# o8Q#!pe(Wp!X7`OY)rZr)rs#O)r#P#W)r#W#X#!i#X#Z)r#Z#[#!i#[#])r#]#^#!i#^#a)r#a#b#!i#b#g)r#g#h#!i#h#i)r#i#j#!i#j#k#!i#k#m)r#m#n#!i#n;'S)r;'S;=`*Z<%lO)r8Q#$WX(WpOY#$RZr#$Rrs!Ars#O#$R#O#P!B[#P#Q# o#Q;'S#$R;'S;=`#$s<%lO#$R8Q#$vP;=`<%l#$R8Q#$|P;=`<%l# o=l#%W^$i&j(WpOY#%PYZ&cZr#%Prs!CWs!^#%P!^!_#$R!_#O#%P#O#P!DR#P#Q!Lc#Q#o#%P#o#p#$R#p;'S#%P;'S;=`#&S<%lO#%P=l#&VP;=`<%l#%P=l#&]P;=`<%l!Lc?O#&kn$i&j(Wp(Z!b!X7`OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#W%Z#W#X#&`#X#Z%Z#Z#[#&`#[#]%Z#]#^#&`#^#a%Z#a#b#&`#b#g%Z#g#h#&`#h#i%Z#i#j#&`#j#k#&`#k#m%Z#m#n#&`#n#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z9d#(r](Wp(Z!b!X7`OY#(iZr#(irs!Grsw#(iwx# ox!P#(i!P!Q#)k!Q!}#(i!}#O#+`#O#P!Bq#P;'S#(i;'S;=`#,`<%lO#(i9d#)th(Wp(Z!b!X7`OY*gZr*grs'}sw*gwx)rx#O*g#P#W*g#W#X#)k#X#Z*g#Z#[#)k#[#]*g#]#^#)k#^#a*g#a#b#)k#b#g*g#g#h#)k#h#i*g#i#j#)k#j#k#)k#k#m*g#m#n#)k#n;'S*g;'S;=`+Z<%lO*g9d#+gZ(Wp(Z!bOY#+`Zr#+`rs!JUsw#+`wx#$Rx#O#+`#O#P!B[#P#Q#(i#Q;'S#+`;'S;=`#,Y<%lO#+`9d#,]P;=`<%l#+`9d#,cP;=`<%l#(i?O#,o`$i&j(Wp(Z!bOY#,fYZ&cZr#,frs!KSsw#,fwx#%Px!^#,f!^!_#+`!_#O#,f#O#P!DR#P#Q!;Z#Q#o#,f#o#p#+`#p;'S#,f;'S;=`#-q<%lO#,f?O#-tP;=`<%l#,f?O#-zP;=`<%l!;Z07[#.[b$i&j(Wp(Z!b(O0/l!X7`OY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcx!P!;Z!P!Q#&`!Q!^!;Z!^!_#(i!_!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;Z07[#/o_$i&j(Wp(Z!bT0/lOY#/dYZ&cZr#/drs#0nsw#/dwx#4Ox!^#/d!^!_#5}!_#O#/d#O#P#1p#P#o#/d#o#p#5}#p;'S#/d;'S;=`#6|<%lO#/d06j#0w]$i&j(Z!bT0/lOY#0nYZ&cZw#0nwx#1px!^#0n!^!_#3R!_#O#0n#O#P#1p#P#o#0n#o#p#3R#p;'S#0n;'S;=`#3x<%lO#0n05W#1wX$i&jT0/lOY#1pYZ&cZ!^#1p!^!_#2d!_#o#1p#o#p#2d#p;'S#1p;'S;=`#2{<%lO#1p0/l#2iST0/lOY#2dZ;'S#2d;'S;=`#2u<%lO#2d0/l#2xP;=`<%l#2d05W#3OP;=`<%l#1p01O#3YW(Z!bT0/lOY#3RZw#3Rwx#2dx#O#3R#O#P#2d#P;'S#3R;'S;=`#3r<%lO#3R01O#3uP;=`<%l#3R06j#3{P;=`<%l#0n05x#4X]$i&j(WpT0/lOY#4OYZ&cZr#4Ors#1ps!^#4O!^!_#5Q!_#O#4O#O#P#1p#P#o#4O#o#p#5Q#p;'S#4O;'S;=`#5w<%lO#4O00^#5XW(WpT0/lOY#5QZr#5Qrs#2ds#O#5Q#O#P#2d#P;'S#5Q;'S;=`#5q<%lO#5Q00^#5tP;=`<%l#5Q05x#5zP;=`<%l#4O01p#6WY(Wp(Z!bT0/lOY#5}Zr#5}rs#3Rsw#5}wx#5Qx#O#5}#O#P#2d#P;'S#5};'S;=`#6v<%lO#5}01p#6yP;=`<%l#5}07[#7PP;=`<%l#/d)3h#7ab$i&j$Q(Ch(Wp(Z!b!X7`OY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcx!P!;Z!P!Q#&`!Q!^!;Z!^!_#(i!_!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;ZAt#8vb$Z#t$i&j(Wp(Z!b!X7`OY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcx!P!;Z!P!Q#&`!Q!^!;Z!^!_#(i!_!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;Z'Ad#:Zp$i&j(Wp(Z!bs'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!3Y!P!Q%Z!Q![#<_![!^%Z!^!_*g!_!g%Z!g!h!4|!h#O%Z#O#P&c#P#R%Z#R#S#<_#S#U%Z#U#V#?i#V#X%Z#X#Y!4|#Y#b%Z#b#c#>_#c#d#Bq#d#l%Z#l#m#Es#m#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#<jk$i&j(Wp(Z!bs'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!3Y!P!Q%Z!Q![#<_![!^%Z!^!_*g!_!g%Z!g!h!4|!h#O%Z#O#P&c#P#R%Z#R#S#<_#S#X%Z#X#Y!4|#Y#b%Z#b#c#>_#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#>j_$i&j(Wp(Z!bs'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#?rd$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!R#AQ!R!S#AQ!S!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#AQ#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#A]f$i&j(Wp(Z!bs'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!R#AQ!R!S#AQ!S!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#AQ#S#b%Z#b#c#>_#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#Bzc$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!Y#DV!Y!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#DV#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#Dbe$i&j(Wp(Z!bs'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!Y#DV!Y!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#DV#S#b%Z#b#c#>_#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#E|g$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![#Ge![!^%Z!^!_*g!_!c%Z!c!i#Ge!i#O%Z#O#P&c#P#R%Z#R#S#Ge#S#T%Z#T#Z#Ge#Z#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#Gpi$i&j(Wp(Z!bs'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![#Ge![!^%Z!^!_*g!_!c%Z!c!i#Ge!i#O%Z#O#P&c#P#R%Z#R#S#Ge#S#T%Z#T#Z#Ge#Z#b%Z#b#c#>_#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z*)x#Il_!g$b$i&j$O)Lv(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z)[#Jv_al$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z04f#LS^h#)`#R-<U(Wp(Z!b$n7`OY*gZr*grs'}sw*gwx)rx!P*g!P!Q#MO!Q!^*g!^!_#Mt!_!`$ f!`#O*g#P;'S*g;'S;=`+Z<%lO*g(n#MXX$k&j(Wp(Z!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g(El#M}Z#r(Ch(Wp(Z!bOY*gZr*grs'}sw*gwx)rx!_*g!_!`#Np!`#O*g#P;'S*g;'S;=`+Z<%lO*g(El#NyX$Q(Ch(Wp(Z!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g(El$ oX#s(Ch(Wp(Z!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g*)x$!ga#`*!Y$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`0z!`!a$#l!a#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(K[$#w_#k(Cl$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z*)x$%Vag!*r#s(Ch$f#|$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`$&[!`!a$'f!a#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$&g_#s(Ch$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$'qa#r(Ch$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`!a$(v!a#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$)R`#r(Ch$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(Kd$*`a(r(Ct$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!a%Z!a!b$+e!b#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$+p`$i&j#{(Ch(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#`$,}_!|$Ip$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z04f$.X_!S0,v$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(n$/]Z$i&jO!^$0O!^!_$0f!_#i$0O#i#j$0k#j#l$0O#l#m$2^#m#o$0O#o#p$0f#p;'S$0O;'S;=`$4i<%lO$0O(n$0VT_#S$i&jO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c#S$0kO_#S(n$0p[$i&jO!Q&c!Q![$1f![!^&c!_!c&c!c!i$1f!i#T&c#T#Z$1f#Z#o&c#o#p$3|#p;'S&c;'S;=`&w<%lO&c(n$1kZ$i&jO!Q&c!Q![$2^![!^&c!_!c&c!c!i$2^!i#T&c#T#Z$2^#Z#o&c#p;'S&c;'S;=`&w<%lO&c(n$2cZ$i&jO!Q&c!Q![$3U![!^&c!_!c&c!c!i$3U!i#T&c#T#Z$3U#Z#o&c#p;'S&c;'S;=`&w<%lO&c(n$3ZZ$i&jO!Q&c!Q![$0O![!^&c!_!c&c!c!i$0O!i#T&c#T#Z$0O#Z#o&c#p;'S&c;'S;=`&w<%lO&c#S$4PR!Q![$4Y!c!i$4Y#T#Z$4Y#S$4]S!Q![$4Y!c!i$4Y#T#Z$4Y#q#r$0f(n$4lP;=`<%l$0O#1[$4z_!Y#)l$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$6U`#x(Ch$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z+;p$7c_$i&j(Wp(Z!b(a+4QOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z07[$8qk$i&j(Wp(Z!b(T,2j$_#t(e$I[OY%ZYZ&cZr%Zrs&}st%Ztu$8buw%Zwx(rx}%Z}!O$:f!O!Q%Z!Q![$8b![!^%Z!^!_*g!_!c%Z!c!}$8b!}#O%Z#O#P&c#P#R%Z#R#S$8b#S#T%Z#T#o$8b#o#p*g#p$g%Z$g;'S$8b;'S;=`$<l<%lO$8b+d$:qk$i&j(Wp(Z!b$_#tOY%ZYZ&cZr%Zrs&}st%Ztu$:fuw%Zwx(rx}%Z}!O$:f!O!Q%Z!Q![$:f![!^%Z!^!_*g!_!c%Z!c!}$:f!}#O%Z#O#P&c#P#R%Z#R#S$:f#S#T%Z#T#o$:f#o#p*g#p$g%Z$g;'S$:f;'S;=`$<f<%lO$:f+d$<iP;=`<%l$:f07[$<oP;=`<%l$8b#Jf$<{X!_#Hb(Wp(Z!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g,#x$=sa(y+JY$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p#q$+e#q;'S%Z;'S;=`+a<%lO%Z)>v$?V_!^(CdvBr$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z?O$@a_!q7`$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z07[$Aq|$i&j(Wp(Z!b'|0/l$]#t(T,2j(e$I[OX%ZXY+gYZ&cZ[+g[p%Zpq+gqr%Zrs&}st%ZtuEruw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Er![!^%Z!^!_*g!_!c%Z!c!}Er!}#O%Z#O#P&c#P#R%Z#R#SEr#S#T%Z#T#oEr#o#p*g#p$f%Z$f$g+g$g#BYEr#BY#BZ$A`#BZ$ISEr$IS$I_$A`$I_$JTEr$JT$JU$A`$JU$KVEr$KV$KW$A`$KW&FUEr&FU&FV$A`&FV;'SEr;'S;=`I|<%l?HTEr?HT?HU$A`?HUOEr07[$D|k$i&j(Wp(Z!b'}0/l$]#t(T,2j(e$I[OY%ZYZ&cZr%Zrs&}st%ZtuEruw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Er![!^%Z!^!_*g!_!c%Z!c!}Er!}#O%Z#O#P&c#P#R%Z#R#SEr#S#T%Z#T#oEr#o#p*g#p$g%Z$g;'SEr;'S;=`I|<%lOEr",
    tokenizers: [
        $44c7044f9afa5475$var$noSemicolon,
        $44c7044f9afa5475$var$noSemicolonType,
        $44c7044f9afa5475$var$operatorToken,
        $44c7044f9afa5475$var$jsx,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        $44c7044f9afa5475$var$insertSemicolon,
        new (0, $96e8fc72168067c5$export$dbe55ed82366d5e9)("$S~RRtu[#O#Pg#S#T#|~_P#o#pb~gOx~~jVO#i!P#i#j!U#j#l!P#l#m!q#m;'S!P;'S;=`#v<%lO!P~!UO!U~~!XS!Q![!e!c!i!e#T#Z!e#o#p#Z~!hR!Q![!q!c!i!q#T#Z!q~!tR!Q![!}!c!i!}#T#Z!}~#QR!Q![!P!c!i!P#T#Z!P~#^R!Q![#g!c!i#g#T#Z#g~#jS!Q![#g!c!i#g#T#Z#g#q#r!P~#yP;=`<%l!P~$RO(c~~", 141, 340),
        new (0, $96e8fc72168067c5$export$dbe55ed82366d5e9)("j~RQYZXz{^~^O(Q~~aP!P!Qd~iO(R~~", 25, 323)
    ],
    topRules: {
        "Script": [
            0,
            7
        ],
        "SingleExpression": [
            1,
            276
        ],
        "SingleClassItem": [
            2,
            277
        ]
    },
    dialects: {
        jsx: 0,
        ts: 15175
    },
    dynamicPrecedences: {
        "80": 1,
        "82": 1,
        "94": 1,
        "169": 1,
        "199": 1
    },
    specialized: [
        {
            term: 327,
            get: (value)=>$44c7044f9afa5475$var$spec_identifier[value] || -1
        },
        {
            term: 343,
            get: (value)=>$44c7044f9afa5475$var$spec_word[value] || -1
        },
        {
            term: 95,
            get: (value)=>$44c7044f9afa5475$var$spec_LessThan[value] || -1
        }
    ],
    tokenPrec: 15201
});







/**
A collection of JavaScript-related
[snippets](https://codemirror.net/6/docs/ref/#autocomplete.snippet).
*/ const $03748e9436079709$export$c7c03ffcb9c131fc = [
    /*@__PURE__*/ (0, $7570a9a1a9679713$export$975ef56e648d23ad)("function ${name}(${params}) {\n\t${}\n}", {
        label: "function",
        detail: "definition",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $7570a9a1a9679713$export$975ef56e648d23ad)("for (let ${index} = 0; ${index} < ${bound}; ${index}++) {\n\t${}\n}", {
        label: "for",
        detail: "loop",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $7570a9a1a9679713$export$975ef56e648d23ad)("for (let ${name} of ${collection}) {\n\t${}\n}", {
        label: "for",
        detail: "of loop",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $7570a9a1a9679713$export$975ef56e648d23ad)("do {\n\t${}\n} while (${})", {
        label: "do",
        detail: "loop",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $7570a9a1a9679713$export$975ef56e648d23ad)("while (${}) {\n\t${}\n}", {
        label: "while",
        detail: "loop",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $7570a9a1a9679713$export$975ef56e648d23ad)("try {\n\t${}\n} catch (${error}) {\n\t${}\n}", {
        label: "try",
        detail: "/ catch block",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $7570a9a1a9679713$export$975ef56e648d23ad)("if (${}) {\n\t${}\n}", {
        label: "if",
        detail: "block",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $7570a9a1a9679713$export$975ef56e648d23ad)("if (${}) {\n\t${}\n} else {\n\t${}\n}", {
        label: "if",
        detail: "/ else block",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $7570a9a1a9679713$export$975ef56e648d23ad)("class ${name} {\n\tconstructor(${params}) {\n\t\t${}\n\t}\n}", {
        label: "class",
        detail: "definition",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $7570a9a1a9679713$export$975ef56e648d23ad)("import {${names}} from \"${module}\"\n${}", {
        label: "import",
        detail: "named",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $7570a9a1a9679713$export$975ef56e648d23ad)("import ${name} from \"${module}\"\n${}", {
        label: "import",
        detail: "default",
        type: "keyword"
    })
];
/**
A collection of snippet completions for TypeScript. Includes the
JavaScript [snippets](https://codemirror.net/6/docs/ref/#lang-javascript.snippets).
*/ const $03748e9436079709$export$4e97f270e7f6c0ba = /*@__PURE__*/ $03748e9436079709$export$c7c03ffcb9c131fc.concat([
    /*@__PURE__*/ (0, $7570a9a1a9679713$export$975ef56e648d23ad)("interface ${name} {\n\t${}\n}", {
        label: "interface",
        detail: "definition",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $7570a9a1a9679713$export$975ef56e648d23ad)("type ${name} = ${type}", {
        label: "type",
        detail: "definition",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $7570a9a1a9679713$export$975ef56e648d23ad)("enum ${name} {\n\t${}\n}", {
        label: "enum",
        detail: "definition",
        type: "keyword"
    })
]);
const $03748e9436079709$var$cache = /*@__PURE__*/ new (0, $ed739beecf769914$export$7f13b5dc44c541ae)();
const $03748e9436079709$var$ScopeNodes = /*@__PURE__*/ new Set([
    "Script",
    "Block",
    "FunctionExpression",
    "FunctionDeclaration",
    "ArrowFunction",
    "MethodDeclaration",
    "ForStatement"
]);
function $03748e9436079709$var$defID(type) {
    return (node, def)=>{
        let id = node.node.getChild("VariableDefinition");
        if (id) def(id, type);
        return true;
    };
}
const $03748e9436079709$var$functionContext = [
    "FunctionDeclaration"
];
const $03748e9436079709$var$gatherCompletions = {
    FunctionDeclaration: /*@__PURE__*/ $03748e9436079709$var$defID("function"),
    ClassDeclaration: /*@__PURE__*/ $03748e9436079709$var$defID("class"),
    ClassExpression: ()=>true,
    EnumDeclaration: /*@__PURE__*/ $03748e9436079709$var$defID("constant"),
    TypeAliasDeclaration: /*@__PURE__*/ $03748e9436079709$var$defID("type"),
    NamespaceDeclaration: /*@__PURE__*/ $03748e9436079709$var$defID("namespace"),
    VariableDefinition (node, def) {
        if (!node.matchContext($03748e9436079709$var$functionContext)) def(node, "variable");
    },
    TypeDefinition (node, def) {
        def(node, "type");
    },
    __proto__: null
};
function $03748e9436079709$var$getScope(doc, node) {
    let cached = $03748e9436079709$var$cache.get(node);
    if (cached) return cached;
    let completions = [], top = true;
    function def(node, type) {
        let name = doc.sliceString(node.from, node.to);
        completions.push({
            label: name,
            type: type
        });
    }
    node.cursor((0, $ed739beecf769914$export$b0e28367f55837aa).IncludeAnonymous).iterate((node)=>{
        if (top) top = false;
        else if (node.name) {
            let gather = $03748e9436079709$var$gatherCompletions[node.name];
            if (gather && gather(node, def) || $03748e9436079709$var$ScopeNodes.has(node.name)) return false;
        } else if (node.to - node.from > 8192) {
            // Allow caching for bigger internal nodes
            for (let c of $03748e9436079709$var$getScope(doc, node.node))completions.push(c);
            return false;
        }
    });
    $03748e9436079709$var$cache.set(node, completions);
    return completions;
}
const $03748e9436079709$var$Identifier = /^[\w$\xa1-\uffff][\w$\d\xa1-\uffff]*$/;
const $03748e9436079709$var$dontComplete = [
    "TemplateString",
    "String",
    "RegExp",
    "LineComment",
    "BlockComment",
    "VariableDefinition",
    "TypeDefinition",
    "Label",
    "PropertyDefinition",
    "PropertyName",
    "PrivatePropertyDefinition",
    "PrivatePropertyName",
    "JSXText",
    "JSXAttributeValue",
    "JSXOpenTag",
    "JSXCloseTag",
    "JSXSelfClosingTag",
    ".",
    "?."
];
/**
Completion source that looks up locally defined names in
JavaScript code.
*/ function $03748e9436079709$export$a2e0a5b87b9b861c(context) {
    let inner = (0, $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1)(context.state).resolveInner(context.pos, -1);
    if ($03748e9436079709$var$dontComplete.indexOf(inner.name) > -1) return null;
    let isWord = inner.name == "VariableName" || inner.to - inner.from < 20 && $03748e9436079709$var$Identifier.test(context.state.sliceDoc(inner.from, inner.to));
    if (!isWord && !context.explicit) return null;
    let options = [];
    for(let pos = inner; pos; pos = pos.parent)if ($03748e9436079709$var$ScopeNodes.has(pos.name)) options = options.concat($03748e9436079709$var$getScope(context.state.doc, pos));
    return {
        options: options,
        from: isWord ? inner.from : context.pos,
        validFor: $03748e9436079709$var$Identifier
    };
}
function $03748e9436079709$var$pathFor(read, member, name) {
    var _a;
    let path = [];
    for(;;){
        let obj = member.firstChild, prop;
        if ((obj === null || obj === void 0 ? void 0 : obj.name) == "VariableName") {
            path.push(read(obj));
            return {
                path: path.reverse(),
                name: name
            };
        } else if ((obj === null || obj === void 0 ? void 0 : obj.name) == "MemberExpression" && ((_a = prop = obj.lastChild) === null || _a === void 0 ? void 0 : _a.name) == "PropertyName") {
            path.push(read(prop));
            member = obj;
        } else return null;
    }
}
/**
Helper function for defining JavaScript completion sources. It
returns the completable name and object path for a completion
context, or null if no name/property completion should happen at
that position. For example, when completing after `a.b.c` it will
return `{path: ["a", "b"], name: "c"}`. When completing after `x`
it will return `{path: [], name: "x"}`. When not in a property or
name, it will return null if `context.explicit` is false, and
`{path: [], name: ""}` otherwise.
*/ function $03748e9436079709$export$744a796701708158(context) {
    let read = (node)=>context.state.doc.sliceString(node.from, node.to);
    let inner = (0, $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1)(context.state).resolveInner(context.pos, -1);
    if (inner.name == "PropertyName") return $03748e9436079709$var$pathFor(read, inner.parent, read(inner));
    else if ((inner.name == "." || inner.name == "?.") && inner.parent.name == "MemberExpression") return $03748e9436079709$var$pathFor(read, inner.parent, "");
    else if ($03748e9436079709$var$dontComplete.indexOf(inner.name) > -1) return null;
    else if (inner.name == "VariableName" || inner.to - inner.from < 20 && $03748e9436079709$var$Identifier.test(read(inner))) return {
        path: [],
        name: read(inner)
    };
    else if (inner.name == "MemberExpression") return $03748e9436079709$var$pathFor(read, inner, "");
    else return context.explicit ? {
        path: [],
        name: ""
    } : null;
}
function $03748e9436079709$var$enumeratePropertyCompletions(obj, top) {
    let originalObj = obj;
    let options = [], seen = new Set;
    for(let depth = 0;; depth++){
        for (let name of (Object.getOwnPropertyNames || Object.keys)(obj)){
            if (!/^[a-zA-Z_$\xaa-\uffdc][\w$\xaa-\uffdc]*$/.test(name) || seen.has(name)) continue;
            seen.add(name);
            let value;
            try {
                value = originalObj[name];
            } catch (_) {
                continue;
            }
            options.push({
                label: name,
                type: typeof value == "function" ? /^[A-Z]/.test(name) ? "class" : top ? "function" : "method" : top ? "variable" : "property",
                boost: -depth
            });
        }
        let next = Object.getPrototypeOf(obj);
        if (!next) return options;
        obj = next;
    }
}
/**
Defines a [completion source](https://codemirror.net/6/docs/ref/#autocomplete.CompletionSource) that
completes from the given scope object (for example `globalThis`).
Will enter properties of the object when completing properties on
a directly-named path.
*/ function $03748e9436079709$export$fc7787e70db1f2c3(scope) {
    let cache = new Map;
    return (context)=>{
        let path = $03748e9436079709$export$744a796701708158(context);
        if (!path) return null;
        let target = scope;
        for (let step of path.path){
            target = target[step];
            if (!target) return null;
        }
        let options = cache.get(target);
        if (!options) cache.set(target, options = $03748e9436079709$var$enumeratePropertyCompletions(target, !path.path.length));
        return {
            from: context.pos - path.name.length,
            options: options,
            validFor: $03748e9436079709$var$Identifier
        };
    };
}
/**
A language provider based on the [Lezer JavaScript
parser](https://github.com/lezer-parser/javascript), extended with
highlighting and indentation information.
*/ const $03748e9436079709$export$93859f94713968c6 = /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$b243968d9fb6db03).define({
    name: "javascript",
    parser: /*@__PURE__*/ (0, $44c7044f9afa5475$export$8f49e4af10703ce3).configure({
        props: [
            /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$72c7d4c52b3c6460).add({
                IfStatement: /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$688ff433e7e7cc5c)({
                    except: /^\s*({|else\b)/
                }),
                TryStatement: /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$688ff433e7e7cc5c)({
                    except: /^\s*({|catch\b|finally\b)/
                }),
                LabeledStatement: (0, $a97ccac5cf5f4f5d$export$4764c629086182f2),
                SwitchBody: (context)=>{
                    let after = context.textAfter, closed = /^\s*\}/.test(after), isCase = /^\s*(case|default)\b/.test(after);
                    return context.baseIndent + (closed ? 0 : isCase ? 1 : 2) * context.unit;
                },
                Block: /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$60e82ea306899488)({
                    closing: "}"
                }),
                ArrowFunction: (cx)=>cx.baseIndent + cx.unit,
                "TemplateString BlockComment": ()=>null,
                "Statement Property": /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$688ff433e7e7cc5c)({
                    except: /^\s*{/
                }),
                JSXElement (context) {
                    let closed = /^\s*<\//.test(context.textAfter);
                    return context.lineIndent(context.node.from) + (closed ? 0 : context.unit);
                },
                JSXEscape (context) {
                    let closed = /\s*\}/.test(context.textAfter);
                    return context.lineIndent(context.node.from) + (closed ? 0 : context.unit);
                },
                "JSXOpenTag JSXSelfClosingTag" (context) {
                    return context.column(context.node.from) + context.unit;
                }
            }),
            /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$9b075a85eb4377d8).add({
                "Block ClassBody SwitchBody EnumBody ObjectExpression ArrayExpression ObjectType": (0, $a97ccac5cf5f4f5d$export$48672beae16a681b),
                BlockComment (tree) {
                    return {
                        from: tree.from + 2,
                        to: tree.to - 2
                    };
                },
                JSXElement (tree) {
                    let open = tree.firstChild;
                    if (!open || open.name == "JSXSelfClosingTag") return null;
                    let close = tree.lastChild;
                    return {
                        from: open.to,
                        to: close.type.isError ? tree.to : close.from
                    };
                },
                "JSXSelfClosingTag JSXOpenTag" (tree) {
                    var _a;
                    let name = (_a = tree.firstChild) === null || _a === void 0 ? void 0 : _a.nextSibling, close = tree.lastChild;
                    if (!name || name.type.isError) return null;
                    return {
                        from: name.to,
                        to: close.type.isError ? tree.to : close.from
                    };
                }
            })
        ]
    }),
    languageData: {
        closeBrackets: {
            brackets: [
                "(",
                "[",
                "{",
                "'",
                '"',
                "`"
            ]
        },
        commentTokens: {
            line: "//",
            block: {
                open: "/*",
                close: "*/"
            }
        },
        indentOnInput: /^\s*(?:case |default:|\{|\}|<\/)$/,
        wordChars: "$"
    }
});
const $03748e9436079709$var$jsxSublanguage = {
    test: (node)=>/^JSX/.test(node.name),
    facet: /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$b57f683f43553b99)({
        commentTokens: {
            block: {
                open: "{/*",
                close: "*/}"
            }
        }
    })
};
/**
A language provider for TypeScript.
*/ const $03748e9436079709$export$5a3c1a94be83ebb = /*@__PURE__*/ $03748e9436079709$export$93859f94713968c6.configure({
    dialect: "ts"
}, "typescript");
/**
Language provider for JSX.
*/ const $03748e9436079709$export$cf3118f4eee6176c = /*@__PURE__*/ $03748e9436079709$export$93859f94713968c6.configure({
    dialect: "jsx",
    props: [
        /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$4afc6f37514bbb67).add((n)=>n.isTop ? [
                $03748e9436079709$var$jsxSublanguage
            ] : undefined)
    ]
});
/**
Language provider for JSX + TypeScript.
*/ const $03748e9436079709$export$5e6bf9a8e977a24e = /*@__PURE__*/ $03748e9436079709$export$93859f94713968c6.configure({
    dialect: "jsx ts",
    props: [
        /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$4afc6f37514bbb67).add((n)=>n.isTop ? [
                $03748e9436079709$var$jsxSublanguage
            ] : undefined)
    ]
}, "typescript");
let $03748e9436079709$var$kwCompletion = (name)=>({
        label: name,
        type: "keyword"
    });
const $03748e9436079709$var$keywords = /*@__PURE__*/ "break case const continue default delete export extends false finally in instanceof let new return static super switch this throw true typeof var yield".split(" ").map($03748e9436079709$var$kwCompletion);
const $03748e9436079709$var$typescriptKeywords = /*@__PURE__*/ $03748e9436079709$var$keywords.concat(/*@__PURE__*/ [
    "declare",
    "implements",
    "private",
    "protected",
    "public"
].map($03748e9436079709$var$kwCompletion));
/**
JavaScript support. Includes [snippet](https://codemirror.net/6/docs/ref/#lang-javascript.snippets)
and local variable completion.
*/ function $03748e9436079709$export$755219397dca4f08(config = {}) {
    let lang = config.jsx ? config.typescript ? $03748e9436079709$export$5e6bf9a8e977a24e : $03748e9436079709$export$cf3118f4eee6176c : config.typescript ? $03748e9436079709$export$5a3c1a94be83ebb : $03748e9436079709$export$93859f94713968c6;
    let completions = config.typescript ? $03748e9436079709$export$4e97f270e7f6c0ba.concat($03748e9436079709$var$typescriptKeywords) : $03748e9436079709$export$c7c03ffcb9c131fc.concat($03748e9436079709$var$keywords);
    return new (0, $a97ccac5cf5f4f5d$export$cbdefefa8a51dd3b)(lang, [
        $03748e9436079709$export$93859f94713968c6.data.of({
            autocomplete: (0, $7570a9a1a9679713$export$1dfdaeb1e91714c0)($03748e9436079709$var$dontComplete, (0, $7570a9a1a9679713$export$db0ee7d2648a0c4b)(completions))
        }),
        $03748e9436079709$export$93859f94713968c6.data.of({
            autocomplete: $03748e9436079709$export$a2e0a5b87b9b861c
        }),
        config.jsx ? $03748e9436079709$export$f1d931274ca0e1f1 : []
    ]);
}
function $03748e9436079709$var$findOpenTag(node) {
    for(;;){
        if (node.name == "JSXOpenTag" || node.name == "JSXSelfClosingTag" || node.name == "JSXFragmentTag") return node;
        if (node.name == "JSXEscape" || !node.parent) return null;
        node = node.parent;
    }
}
function $03748e9436079709$var$elementName(doc, tree, max = doc.length) {
    for(let ch = tree === null || tree === void 0 ? void 0 : tree.firstChild; ch; ch = ch.nextSibling){
        if (ch.name == "JSXIdentifier" || ch.name == "JSXBuiltin" || ch.name == "JSXNamespacedName" || ch.name == "JSXMemberExpression") return doc.sliceString(ch.from, Math.min(ch.to, max));
    }
    return "";
}
const $03748e9436079709$var$android = typeof navigator == "object" && /*@__PURE__*/ /Android\b/.test(navigator.userAgent);
/**
Extension that will automatically insert JSX close tags when a `>` or
`/` is typed.
*/ const $03748e9436079709$export$f1d931274ca0e1f1 = /*@__PURE__*/ (0, $7beee9608540d2c3$export$eece2fccabbb77c5).inputHandler.of((view, from, to, text, defaultInsert)=>{
    if (($03748e9436079709$var$android ? view.composing : view.compositionStarted) || view.state.readOnly || from != to || text != ">" && text != "/" || !$03748e9436079709$export$93859f94713968c6.isActiveAt(view.state, from, -1)) return false;
    let base = defaultInsert(), { state: state } = base;
    let closeTags = state.changeByRange((range)=>{
        var _a;
        let { head: head } = range, around = (0, $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1)(state).resolveInner(head - 1, -1), name;
        if (around.name == "JSXStartTag") around = around.parent;
        if (state.doc.sliceString(head - 1, head) != text || around.name == "JSXAttributeValue" && around.to > head) ;
        else if (text == ">" && around.name == "JSXFragmentTag") return {
            range: range,
            changes: {
                from: head,
                insert: `</>`
            }
        };
        else if (text == "/" && around.name == "JSXStartCloseTag") {
            let empty = around.parent, base = empty.parent;
            if (base && empty.from == head - 2 && ((name = $03748e9436079709$var$elementName(state.doc, base.firstChild, head)) || ((_a = base.firstChild) === null || _a === void 0 ? void 0 : _a.name) == "JSXFragmentTag")) {
                let insert = `${name}>`;
                return {
                    range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(head + insert.length, -1),
                    changes: {
                        from: head,
                        insert: insert
                    }
                };
            }
        } else if (text == ">") {
            let openTag = $03748e9436079709$var$findOpenTag(around);
            if (openTag && openTag.name == "JSXOpenTag" && !/^\/?>|^<\//.test(state.doc.sliceString(head, head + 2)) && (name = $03748e9436079709$var$elementName(state.doc, openTag, head))) return {
                range: range,
                changes: {
                    from: head,
                    insert: `</${name}>`
                }
            };
        }
        return {
            range: range
        };
    });
    if (closeTags.changes.empty) return false;
    view.dispatch([
        base,
        state.update(closeTags, {
            userEvent: "input.complete",
            scrollIntoView: true
        })
    ]);
    return true;
});
/**
Connects an [ESLint](https://eslint.org/) linter to CodeMirror's
[lint](https://codemirror.net/6/docs/ref/#lint) integration. `eslint` should be an instance of the
[`Linter`](https://eslint.org/docs/developer-guide/nodejs-api#linter)
class, and `config` an optional ESLint configuration. The return
value of this function can be passed to [`linter`](https://codemirror.net/6/docs/ref/#lint.linter)
to create a JavaScript linting extension.

Note that ESLint targets node, and is tricky to run in the
browser. The
[eslint-linter-browserify](https://github.com/UziTech/eslint-linter-browserify)
package may help with that (see
[example](https://github.com/UziTech/eslint-linter-browserify/blob/master/example/script.js)).
*/ function $03748e9436079709$export$5f7cd04a95ec53e6(eslint, config) {
    if (!config) {
        config = {
            parserOptions: {
                ecmaVersion: 2019,
                sourceType: "module"
            },
            env: {
                browser: true,
                node: true,
                es6: true,
                es2015: true,
                es2017: true,
                es2020: true
            },
            rules: {}
        };
        eslint.getRules().forEach((desc, name)=>{
            var _a;
            if ((_a = desc.meta.docs) === null || _a === void 0 ? void 0 : _a.recommended) config.rules[name] = 2;
        });
    }
    return (view)=>{
        let { state: state } = view, found = [];
        for (let { from: from, to: to } of $03748e9436079709$export$93859f94713968c6.findRegions(state)){
            let fromLine = state.doc.lineAt(from), offset = {
                line: fromLine.number - 1,
                col: from - fromLine.from,
                pos: from
            };
            for (let d of eslint.verify(state.sliceDoc(from, to), config))found.push($03748e9436079709$var$translateDiagnostic(d, state.doc, offset));
        }
        return found;
    };
}
function $03748e9436079709$var$mapPos(line, col, doc, offset) {
    return doc.line(line + offset.line).from + col + (line == 1 ? offset.col - 1 : -1);
}
function $03748e9436079709$var$translateDiagnostic(input, doc, offset) {
    let start = $03748e9436079709$var$mapPos(input.line, input.column, doc, offset);
    let result = {
        from: start,
        to: input.endLine != null && input.endColumn != 1 ? $03748e9436079709$var$mapPos(input.endLine, input.endColumn, doc, offset) : start,
        message: input.message,
        source: input.ruleId ? "eslint:" + input.ruleId : "eslint",
        severity: input.severity == 1 ? "warning" : "error"
    };
    if (input.fix) {
        let { range: range, text: text } = input.fix, from = range[0] + offset.pos - start, to = range[1] + offset.pos - start;
        result.actions = [
            {
                name: "fix",
                apply (view, start) {
                    view.dispatch({
                        changes: {
                            from: start + from,
                            to: start + to,
                            insert: text
                        },
                        scrollIntoView: true
                    });
                }
            }
        ];
    }
    return result;
}





const $b89c3ee08b45bae9$var$Targets = [
    "_blank",
    "_self",
    "_top",
    "_parent"
];
const $b89c3ee08b45bae9$var$Charsets = [
    "ascii",
    "utf-8",
    "utf-16",
    "latin1",
    "latin1"
];
const $b89c3ee08b45bae9$var$Methods = [
    "get",
    "post",
    "put",
    "delete"
];
const $b89c3ee08b45bae9$var$Encs = [
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
];
const $b89c3ee08b45bae9$var$Bool = [
    "true",
    "false"
];
const $b89c3ee08b45bae9$var$S = {}; // Empty tag spec
const $b89c3ee08b45bae9$var$Tags = {
    a: {
        attrs: {
            href: null,
            ping: null,
            type: null,
            media: null,
            target: $b89c3ee08b45bae9$var$Targets,
            hreflang: null
        }
    },
    abbr: $b89c3ee08b45bae9$var$S,
    address: $b89c3ee08b45bae9$var$S,
    area: {
        attrs: {
            alt: null,
            coords: null,
            href: null,
            target: null,
            ping: null,
            media: null,
            hreflang: null,
            type: null,
            shape: [
                "default",
                "rect",
                "circle",
                "poly"
            ]
        }
    },
    article: $b89c3ee08b45bae9$var$S,
    aside: $b89c3ee08b45bae9$var$S,
    audio: {
        attrs: {
            src: null,
            mediagroup: null,
            crossorigin: [
                "anonymous",
                "use-credentials"
            ],
            preload: [
                "none",
                "metadata",
                "auto"
            ],
            autoplay: [
                "autoplay"
            ],
            loop: [
                "loop"
            ],
            controls: [
                "controls"
            ]
        }
    },
    b: $b89c3ee08b45bae9$var$S,
    base: {
        attrs: {
            href: null,
            target: $b89c3ee08b45bae9$var$Targets
        }
    },
    bdi: $b89c3ee08b45bae9$var$S,
    bdo: $b89c3ee08b45bae9$var$S,
    blockquote: {
        attrs: {
            cite: null
        }
    },
    body: $b89c3ee08b45bae9$var$S,
    br: $b89c3ee08b45bae9$var$S,
    button: {
        attrs: {
            form: null,
            formaction: null,
            name: null,
            value: null,
            autofocus: [
                "autofocus"
            ],
            disabled: [
                "autofocus"
            ],
            formenctype: $b89c3ee08b45bae9$var$Encs,
            formmethod: $b89c3ee08b45bae9$var$Methods,
            formnovalidate: [
                "novalidate"
            ],
            formtarget: $b89c3ee08b45bae9$var$Targets,
            type: [
                "submit",
                "reset",
                "button"
            ]
        }
    },
    canvas: {
        attrs: {
            width: null,
            height: null
        }
    },
    caption: $b89c3ee08b45bae9$var$S,
    center: $b89c3ee08b45bae9$var$S,
    cite: $b89c3ee08b45bae9$var$S,
    code: $b89c3ee08b45bae9$var$S,
    col: {
        attrs: {
            span: null
        }
    },
    colgroup: {
        attrs: {
            span: null
        }
    },
    command: {
        attrs: {
            type: [
                "command",
                "checkbox",
                "radio"
            ],
            label: null,
            icon: null,
            radiogroup: null,
            command: null,
            title: null,
            disabled: [
                "disabled"
            ],
            checked: [
                "checked"
            ]
        }
    },
    data: {
        attrs: {
            value: null
        }
    },
    datagrid: {
        attrs: {
            disabled: [
                "disabled"
            ],
            multiple: [
                "multiple"
            ]
        }
    },
    datalist: {
        attrs: {
            data: null
        }
    },
    dd: $b89c3ee08b45bae9$var$S,
    del: {
        attrs: {
            cite: null,
            datetime: null
        }
    },
    details: {
        attrs: {
            open: [
                "open"
            ]
        }
    },
    dfn: $b89c3ee08b45bae9$var$S,
    div: $b89c3ee08b45bae9$var$S,
    dl: $b89c3ee08b45bae9$var$S,
    dt: $b89c3ee08b45bae9$var$S,
    em: $b89c3ee08b45bae9$var$S,
    embed: {
        attrs: {
            src: null,
            type: null,
            width: null,
            height: null
        }
    },
    eventsource: {
        attrs: {
            src: null
        }
    },
    fieldset: {
        attrs: {
            disabled: [
                "disabled"
            ],
            form: null,
            name: null
        }
    },
    figcaption: $b89c3ee08b45bae9$var$S,
    figure: $b89c3ee08b45bae9$var$S,
    footer: $b89c3ee08b45bae9$var$S,
    form: {
        attrs: {
            action: null,
            name: null,
            "accept-charset": $b89c3ee08b45bae9$var$Charsets,
            autocomplete: [
                "on",
                "off"
            ],
            enctype: $b89c3ee08b45bae9$var$Encs,
            method: $b89c3ee08b45bae9$var$Methods,
            novalidate: [
                "novalidate"
            ],
            target: $b89c3ee08b45bae9$var$Targets
        }
    },
    h1: $b89c3ee08b45bae9$var$S,
    h2: $b89c3ee08b45bae9$var$S,
    h3: $b89c3ee08b45bae9$var$S,
    h4: $b89c3ee08b45bae9$var$S,
    h5: $b89c3ee08b45bae9$var$S,
    h6: $b89c3ee08b45bae9$var$S,
    head: {
        children: [
            "title",
            "base",
            "link",
            "style",
            "meta",
            "script",
            "noscript",
            "command"
        ]
    },
    header: $b89c3ee08b45bae9$var$S,
    hgroup: $b89c3ee08b45bae9$var$S,
    hr: $b89c3ee08b45bae9$var$S,
    html: {
        attrs: {
            manifest: null
        }
    },
    i: $b89c3ee08b45bae9$var$S,
    iframe: {
        attrs: {
            src: null,
            srcdoc: null,
            name: null,
            width: null,
            height: null,
            sandbox: [
                "allow-top-navigation",
                "allow-same-origin",
                "allow-forms",
                "allow-scripts"
            ],
            seamless: [
                "seamless"
            ]
        }
    },
    img: {
        attrs: {
            alt: null,
            src: null,
            ismap: null,
            usemap: null,
            width: null,
            height: null,
            crossorigin: [
                "anonymous",
                "use-credentials"
            ]
        }
    },
    input: {
        attrs: {
            alt: null,
            dirname: null,
            form: null,
            formaction: null,
            height: null,
            list: null,
            max: null,
            maxlength: null,
            min: null,
            name: null,
            pattern: null,
            placeholder: null,
            size: null,
            src: null,
            step: null,
            value: null,
            width: null,
            accept: [
                "audio/*",
                "video/*",
                "image/*"
            ],
            autocomplete: [
                "on",
                "off"
            ],
            autofocus: [
                "autofocus"
            ],
            checked: [
                "checked"
            ],
            disabled: [
                "disabled"
            ],
            formenctype: $b89c3ee08b45bae9$var$Encs,
            formmethod: $b89c3ee08b45bae9$var$Methods,
            formnovalidate: [
                "novalidate"
            ],
            formtarget: $b89c3ee08b45bae9$var$Targets,
            multiple: [
                "multiple"
            ],
            readonly: [
                "readonly"
            ],
            required: [
                "required"
            ],
            type: [
                "hidden",
                "text",
                "search",
                "tel",
                "url",
                "email",
                "password",
                "datetime",
                "date",
                "month",
                "week",
                "time",
                "datetime-local",
                "number",
                "range",
                "color",
                "checkbox",
                "radio",
                "file",
                "submit",
                "image",
                "reset",
                "button"
            ]
        }
    },
    ins: {
        attrs: {
            cite: null,
            datetime: null
        }
    },
    kbd: $b89c3ee08b45bae9$var$S,
    keygen: {
        attrs: {
            challenge: null,
            form: null,
            name: null,
            autofocus: [
                "autofocus"
            ],
            disabled: [
                "disabled"
            ],
            keytype: [
                "RSA"
            ]
        }
    },
    label: {
        attrs: {
            for: null,
            form: null
        }
    },
    legend: $b89c3ee08b45bae9$var$S,
    li: {
        attrs: {
            value: null
        }
    },
    link: {
        attrs: {
            href: null,
            type: null,
            hreflang: null,
            media: null,
            sizes: [
                "all",
                "16x16",
                "16x16 32x32",
                "16x16 32x32 64x64"
            ]
        }
    },
    map: {
        attrs: {
            name: null
        }
    },
    mark: $b89c3ee08b45bae9$var$S,
    menu: {
        attrs: {
            label: null,
            type: [
                "list",
                "context",
                "toolbar"
            ]
        }
    },
    meta: {
        attrs: {
            content: null,
            charset: $b89c3ee08b45bae9$var$Charsets,
            name: [
                "viewport",
                "application-name",
                "author",
                "description",
                "generator",
                "keywords"
            ],
            "http-equiv": [
                "content-language",
                "content-type",
                "default-style",
                "refresh"
            ]
        }
    },
    meter: {
        attrs: {
            value: null,
            min: null,
            low: null,
            high: null,
            max: null,
            optimum: null
        }
    },
    nav: $b89c3ee08b45bae9$var$S,
    noscript: $b89c3ee08b45bae9$var$S,
    object: {
        attrs: {
            data: null,
            type: null,
            name: null,
            usemap: null,
            form: null,
            width: null,
            height: null,
            typemustmatch: [
                "typemustmatch"
            ]
        }
    },
    ol: {
        attrs: {
            reversed: [
                "reversed"
            ],
            start: null,
            type: [
                "1",
                "a",
                "A",
                "i",
                "I"
            ]
        },
        children: [
            "li",
            "script",
            "template",
            "ul",
            "ol"
        ]
    },
    optgroup: {
        attrs: {
            disabled: [
                "disabled"
            ],
            label: null
        }
    },
    option: {
        attrs: {
            disabled: [
                "disabled"
            ],
            label: null,
            selected: [
                "selected"
            ],
            value: null
        }
    },
    output: {
        attrs: {
            for: null,
            form: null,
            name: null
        }
    },
    p: $b89c3ee08b45bae9$var$S,
    param: {
        attrs: {
            name: null,
            value: null
        }
    },
    pre: $b89c3ee08b45bae9$var$S,
    progress: {
        attrs: {
            value: null,
            max: null
        }
    },
    q: {
        attrs: {
            cite: null
        }
    },
    rp: $b89c3ee08b45bae9$var$S,
    rt: $b89c3ee08b45bae9$var$S,
    ruby: $b89c3ee08b45bae9$var$S,
    samp: $b89c3ee08b45bae9$var$S,
    script: {
        attrs: {
            type: [
                "text/javascript"
            ],
            src: null,
            async: [
                "async"
            ],
            defer: [
                "defer"
            ],
            charset: $b89c3ee08b45bae9$var$Charsets
        }
    },
    section: $b89c3ee08b45bae9$var$S,
    select: {
        attrs: {
            form: null,
            name: null,
            size: null,
            autofocus: [
                "autofocus"
            ],
            disabled: [
                "disabled"
            ],
            multiple: [
                "multiple"
            ]
        }
    },
    slot: {
        attrs: {
            name: null
        }
    },
    small: $b89c3ee08b45bae9$var$S,
    source: {
        attrs: {
            src: null,
            type: null,
            media: null
        }
    },
    span: $b89c3ee08b45bae9$var$S,
    strong: $b89c3ee08b45bae9$var$S,
    style: {
        attrs: {
            type: [
                "text/css"
            ],
            media: null,
            scoped: null
        }
    },
    sub: $b89c3ee08b45bae9$var$S,
    summary: $b89c3ee08b45bae9$var$S,
    sup: $b89c3ee08b45bae9$var$S,
    table: $b89c3ee08b45bae9$var$S,
    tbody: $b89c3ee08b45bae9$var$S,
    td: {
        attrs: {
            colspan: null,
            rowspan: null,
            headers: null
        }
    },
    template: $b89c3ee08b45bae9$var$S,
    textarea: {
        attrs: {
            dirname: null,
            form: null,
            maxlength: null,
            name: null,
            placeholder: null,
            rows: null,
            cols: null,
            autofocus: [
                "autofocus"
            ],
            disabled: [
                "disabled"
            ],
            readonly: [
                "readonly"
            ],
            required: [
                "required"
            ],
            wrap: [
                "soft",
                "hard"
            ]
        }
    },
    tfoot: $b89c3ee08b45bae9$var$S,
    th: {
        attrs: {
            colspan: null,
            rowspan: null,
            headers: null,
            scope: [
                "row",
                "col",
                "rowgroup",
                "colgroup"
            ]
        }
    },
    thead: $b89c3ee08b45bae9$var$S,
    time: {
        attrs: {
            datetime: null
        }
    },
    title: $b89c3ee08b45bae9$var$S,
    tr: $b89c3ee08b45bae9$var$S,
    track: {
        attrs: {
            src: null,
            label: null,
            default: null,
            kind: [
                "subtitles",
                "captions",
                "descriptions",
                "chapters",
                "metadata"
            ],
            srclang: null
        }
    },
    ul: {
        children: [
            "li",
            "script",
            "template",
            "ul",
            "ol"
        ]
    },
    var: $b89c3ee08b45bae9$var$S,
    video: {
        attrs: {
            src: null,
            poster: null,
            width: null,
            height: null,
            crossorigin: [
                "anonymous",
                "use-credentials"
            ],
            preload: [
                "auto",
                "metadata",
                "none"
            ],
            autoplay: [
                "autoplay"
            ],
            mediagroup: [
                "movie"
            ],
            muted: [
                "muted"
            ],
            controls: [
                "controls"
            ]
        }
    },
    wbr: $b89c3ee08b45bae9$var$S
};
const $b89c3ee08b45bae9$var$GlobalAttrs = {
    accesskey: null,
    class: null,
    contenteditable: $b89c3ee08b45bae9$var$Bool,
    contextmenu: null,
    dir: [
        "ltr",
        "rtl",
        "auto"
    ],
    draggable: [
        "true",
        "false",
        "auto"
    ],
    dropzone: [
        "copy",
        "move",
        "link",
        "string:",
        "file:"
    ],
    hidden: [
        "hidden"
    ],
    id: null,
    inert: [
        "inert"
    ],
    itemid: null,
    itemprop: null,
    itemref: null,
    itemscope: [
        "itemscope"
    ],
    itemtype: null,
    lang: [
        "ar",
        "bn",
        "de",
        "en-GB",
        "en-US",
        "es",
        "fr",
        "hi",
        "id",
        "ja",
        "pa",
        "pt",
        "ru",
        "tr",
        "zh"
    ],
    spellcheck: $b89c3ee08b45bae9$var$Bool,
    autocorrect: $b89c3ee08b45bae9$var$Bool,
    autocapitalize: $b89c3ee08b45bae9$var$Bool,
    style: null,
    tabindex: null,
    title: null,
    translate: [
        "yes",
        "no"
    ],
    rel: [
        "stylesheet",
        "alternate",
        "author",
        "bookmark",
        "help",
        "license",
        "next",
        "nofollow",
        "noreferrer",
        "prefetch",
        "prev",
        "search",
        "tag"
    ],
    role: /*@__PURE__*/ "alert application article banner button cell checkbox complementary contentinfo dialog document feed figure form grid gridcell heading img list listbox listitem main navigation region row rowgroup search switch tab table tabpanel textbox timer".split(" "),
    "aria-activedescendant": null,
    "aria-atomic": $b89c3ee08b45bae9$var$Bool,
    "aria-autocomplete": [
        "inline",
        "list",
        "both",
        "none"
    ],
    "aria-busy": $b89c3ee08b45bae9$var$Bool,
    "aria-checked": [
        "true",
        "false",
        "mixed",
        "undefined"
    ],
    "aria-controls": null,
    "aria-describedby": null,
    "aria-disabled": $b89c3ee08b45bae9$var$Bool,
    "aria-dropeffect": null,
    "aria-expanded": [
        "true",
        "false",
        "undefined"
    ],
    "aria-flowto": null,
    "aria-grabbed": [
        "true",
        "false",
        "undefined"
    ],
    "aria-haspopup": $b89c3ee08b45bae9$var$Bool,
    "aria-hidden": $b89c3ee08b45bae9$var$Bool,
    "aria-invalid": [
        "true",
        "false",
        "grammar",
        "spelling"
    ],
    "aria-label": null,
    "aria-labelledby": null,
    "aria-level": null,
    "aria-live": [
        "off",
        "polite",
        "assertive"
    ],
    "aria-multiline": $b89c3ee08b45bae9$var$Bool,
    "aria-multiselectable": $b89c3ee08b45bae9$var$Bool,
    "aria-owns": null,
    "aria-posinset": null,
    "aria-pressed": [
        "true",
        "false",
        "mixed",
        "undefined"
    ],
    "aria-readonly": $b89c3ee08b45bae9$var$Bool,
    "aria-relevant": null,
    "aria-required": $b89c3ee08b45bae9$var$Bool,
    "aria-selected": [
        "true",
        "false",
        "undefined"
    ],
    "aria-setsize": null,
    "aria-sort": [
        "ascending",
        "descending",
        "none",
        "other"
    ],
    "aria-valuemax": null,
    "aria-valuemin": null,
    "aria-valuenow": null,
    "aria-valuetext": null
};
const $b89c3ee08b45bae9$var$eventAttributes = /*@__PURE__*/ "beforeunload copy cut dragstart dragover dragleave dragenter dragend drag paste focus blur change click load mousedown mouseenter mouseleave mouseup keydown keyup resize scroll unload".split(" ").map((n)=>"on" + n);
for (let a of $b89c3ee08b45bae9$var$eventAttributes)$b89c3ee08b45bae9$var$GlobalAttrs[a] = null;
class $b89c3ee08b45bae9$var$Schema {
    constructor(extraTags, extraAttrs){
        this.tags = {
            ...$b89c3ee08b45bae9$var$Tags,
            ...extraTags
        };
        this.globalAttrs = {
            ...$b89c3ee08b45bae9$var$GlobalAttrs,
            ...extraAttrs
        };
        this.allTags = Object.keys(this.tags);
        this.globalAttrNames = Object.keys(this.globalAttrs);
    }
}
$b89c3ee08b45bae9$var$Schema.default = /*@__PURE__*/ new $b89c3ee08b45bae9$var$Schema;
function $b89c3ee08b45bae9$var$elementName(doc, tree, max = doc.length) {
    if (!tree) return "";
    let tag = tree.firstChild;
    let name = tag && tag.getChild("TagName");
    return name ? doc.sliceString(name.from, Math.min(name.to, max)) : "";
}
function $b89c3ee08b45bae9$var$findParentElement(tree, skip = false) {
    for(; tree; tree = tree.parent)if (tree.name == "Element") {
        if (skip) skip = false;
        else return tree;
    }
    return null;
}
function $b89c3ee08b45bae9$var$allowedChildren(doc, tree, schema) {
    let parentInfo = schema.tags[$b89c3ee08b45bae9$var$elementName(doc, $b89c3ee08b45bae9$var$findParentElement(tree))];
    return (parentInfo === null || parentInfo === void 0 ? void 0 : parentInfo.children) || schema.allTags;
}
function $b89c3ee08b45bae9$var$openTags(doc, tree) {
    let open = [];
    for(let parent = $b89c3ee08b45bae9$var$findParentElement(tree); parent && !parent.type.isTop; parent = $b89c3ee08b45bae9$var$findParentElement(parent.parent)){
        let tagName = $b89c3ee08b45bae9$var$elementName(doc, parent);
        if (tagName && parent.lastChild.name == "CloseTag") break;
        if (tagName && open.indexOf(tagName) < 0 && (tree.name == "EndTag" || tree.from >= parent.firstChild.to)) open.push(tagName);
    }
    return open;
}
const $b89c3ee08b45bae9$var$identifier = /^[:\-\.\w\u00b7-\uffff]*$/;
function $b89c3ee08b45bae9$var$completeTag(state, schema, tree, from, to) {
    let end = /\s*>/.test(state.sliceDoc(to, to + 5)) ? "" : ">";
    let parent = $b89c3ee08b45bae9$var$findParentElement(tree, tree.name == "StartTag" || tree.name == "TagName");
    return {
        from: from,
        to: to,
        options: $b89c3ee08b45bae9$var$allowedChildren(state.doc, parent, schema).map((tagName)=>({
                label: tagName,
                type: "type"
            })).concat($b89c3ee08b45bae9$var$openTags(state.doc, tree).map((tag, i)=>({
                label: "/" + tag,
                apply: "/" + tag + end,
                type: "type",
                boost: 99 - i
            }))),
        validFor: /^\/?[:\-\.\w\u00b7-\uffff]*$/
    };
}
function $b89c3ee08b45bae9$var$completeCloseTag(state, tree, from, to) {
    let end = /\s*>/.test(state.sliceDoc(to, to + 5)) ? "" : ">";
    return {
        from: from,
        to: to,
        options: $b89c3ee08b45bae9$var$openTags(state.doc, tree).map((tag, i)=>({
                label: tag,
                apply: tag + end,
                type: "type",
                boost: 99 - i
            })),
        validFor: $b89c3ee08b45bae9$var$identifier
    };
}
function $b89c3ee08b45bae9$var$completeStartTag(state, schema, tree, pos) {
    let options = [], level = 0;
    for (let tagName of $b89c3ee08b45bae9$var$allowedChildren(state.doc, tree, schema))options.push({
        label: "<" + tagName,
        type: "type"
    });
    for (let open of $b89c3ee08b45bae9$var$openTags(state.doc, tree))options.push({
        label: "</" + open + ">",
        type: "type",
        boost: 99 - level++
    });
    return {
        from: pos,
        to: pos,
        options: options,
        validFor: /^<\/?[:\-\.\w\u00b7-\uffff]*$/
    };
}
function $b89c3ee08b45bae9$var$completeAttrName(state, schema, tree, from, to) {
    let elt = $b89c3ee08b45bae9$var$findParentElement(tree), info = elt ? schema.tags[$b89c3ee08b45bae9$var$elementName(state.doc, elt)] : null;
    let localAttrs = info && info.attrs ? Object.keys(info.attrs) : [];
    let names = info && info.globalAttrs === false ? localAttrs : localAttrs.length ? localAttrs.concat(schema.globalAttrNames) : schema.globalAttrNames;
    return {
        from: from,
        to: to,
        options: names.map((attrName)=>({
                label: attrName,
                type: "property"
            })),
        validFor: $b89c3ee08b45bae9$var$identifier
    };
}
function $b89c3ee08b45bae9$var$completeAttrValue(state, schema, tree, from, to) {
    var _a;
    let nameNode = (_a = tree.parent) === null || _a === void 0 ? void 0 : _a.getChild("AttributeName");
    let options = [], token = undefined;
    if (nameNode) {
        let attrName = state.sliceDoc(nameNode.from, nameNode.to);
        let attrs = schema.globalAttrs[attrName];
        if (!attrs) {
            let elt = $b89c3ee08b45bae9$var$findParentElement(tree), info = elt ? schema.tags[$b89c3ee08b45bae9$var$elementName(state.doc, elt)] : null;
            attrs = (info === null || info === void 0 ? void 0 : info.attrs) && info.attrs[attrName];
        }
        if (attrs) {
            let base = state.sliceDoc(from, to).toLowerCase(), quoteStart = '"', quoteEnd = '"';
            if (/^['"]/.test(base)) {
                token = base[0] == '"' ? /^[^"]*$/ : /^[^']*$/;
                quoteStart = "";
                quoteEnd = state.sliceDoc(to, to + 1) == base[0] ? "" : base[0];
                base = base.slice(1);
                from++;
            } else token = /^[^\s<>='"]*$/;
            for (let value of attrs)options.push({
                label: value,
                apply: quoteStart + value + quoteEnd,
                type: "constant"
            });
        }
    }
    return {
        from: from,
        to: to,
        options: options,
        validFor: token
    };
}
function $b89c3ee08b45bae9$var$htmlCompletionFor(schema, context) {
    let { state: state, pos: pos } = context, tree = (0, $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1)(state).resolveInner(pos, -1), around = tree.resolve(pos);
    for(let scan = pos, before; around == tree && (before = tree.childBefore(scan));){
        let last = before.lastChild;
        if (!last || !last.type.isError || last.from < last.to) break;
        around = tree = before;
        scan = last.from;
    }
    if (tree.name == "TagName") return tree.parent && /CloseTag$/.test(tree.parent.name) ? $b89c3ee08b45bae9$var$completeCloseTag(state, tree, tree.from, pos) : $b89c3ee08b45bae9$var$completeTag(state, schema, tree, tree.from, pos);
    else if (tree.name == "StartTag" || tree.name == "IncompleteTag") return $b89c3ee08b45bae9$var$completeTag(state, schema, tree, pos, pos);
    else if (tree.name == "StartCloseTag" || tree.name == "IncompleteCloseTag") return $b89c3ee08b45bae9$var$completeCloseTag(state, tree, pos, pos);
    else if (tree.name == "OpenTag" || tree.name == "SelfClosingTag" || tree.name == "AttributeName") return $b89c3ee08b45bae9$var$completeAttrName(state, schema, tree, tree.name == "AttributeName" ? tree.from : pos, pos);
    else if (tree.name == "Is" || tree.name == "AttributeValue" || tree.name == "UnquotedAttributeValue") return $b89c3ee08b45bae9$var$completeAttrValue(state, schema, tree, tree.name == "Is" ? pos : tree.from, pos);
    else if (context.explicit && (around.name == "Element" || around.name == "Text" || around.name == "Document")) return $b89c3ee08b45bae9$var$completeStartTag(state, schema, tree, pos);
    else return null;
}
/**
HTML tag completion. Opens and closes tags and attributes in a
context-aware way.
*/ function $b89c3ee08b45bae9$export$25345412b4ded248(context) {
    return $b89c3ee08b45bae9$var$htmlCompletionFor($b89c3ee08b45bae9$var$Schema.default, context);
}
/**
Create a completion source for HTML extended with additional tags
or attributes.
*/ function $b89c3ee08b45bae9$export$2bf1c75d01fadf84(config) {
    let { extraTags: extraTags, extraGlobalAttributes: extraAttrs } = config;
    let schema = extraAttrs || extraTags ? new $b89c3ee08b45bae9$var$Schema(extraTags, extraAttrs) : $b89c3ee08b45bae9$var$Schema.default;
    return (context)=>$b89c3ee08b45bae9$var$htmlCompletionFor(schema, context);
}
const $b89c3ee08b45bae9$var$jsonParser = /*@__PURE__*/ (0, $03748e9436079709$export$93859f94713968c6).parser.configure({
    top: "SingleExpression"
});
const $b89c3ee08b45bae9$var$defaultNesting = [
    {
        tag: "script",
        attrs: (attrs)=>attrs.type == "text/typescript" || attrs.lang == "ts",
        parser: (0, $03748e9436079709$export$5a3c1a94be83ebb).parser
    },
    {
        tag: "script",
        attrs: (attrs)=>attrs.type == "text/babel" || attrs.type == "text/jsx",
        parser: (0, $03748e9436079709$export$cf3118f4eee6176c).parser
    },
    {
        tag: "script",
        attrs: (attrs)=>attrs.type == "text/typescript-jsx",
        parser: (0, $03748e9436079709$export$5e6bf9a8e977a24e).parser
    },
    {
        tag: "script",
        attrs (attrs) {
            return /^(importmap|speculationrules|application\/(.+\+)?json)$/i.test(attrs.type);
        },
        parser: $b89c3ee08b45bae9$var$jsonParser
    },
    {
        tag: "script",
        attrs (attrs) {
            return !attrs.type || /^(?:text|application)\/(?:x-)?(?:java|ecma)script$|^module$|^$/i.test(attrs.type);
        },
        parser: (0, $03748e9436079709$export$93859f94713968c6).parser
    },
    {
        tag: "style",
        attrs (attrs) {
            return (!attrs.lang || attrs.lang == "css") && (!attrs.type || /^(text\/)?(x-)?(stylesheet|css)$/i.test(attrs.type));
        },
        parser: (0, $83e81cc0276b0738$export$93323d80d661fcda).parser
    }
];
const $b89c3ee08b45bae9$var$defaultAttrs = /*@__PURE__*/ [
    {
        name: "style",
        parser: /*@__PURE__*/ (0, $83e81cc0276b0738$export$93323d80d661fcda).parser.configure({
            top: "Styles"
        })
    }
].concat(/*@__PURE__*/ $b89c3ee08b45bae9$var$eventAttributes.map((name)=>({
        name: name,
        parser: (0, $03748e9436079709$export$93859f94713968c6).parser
    })));
const $b89c3ee08b45bae9$var$htmlPlain = /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$b243968d9fb6db03).define({
    name: "html",
    parser: /*@__PURE__*/ (0, $07236028cbce11ab$export$8f49e4af10703ce3).configure({
        props: [
            /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$72c7d4c52b3c6460).add({
                Element (context) {
                    let after = /^(\s*)(<\/)?/.exec(context.textAfter);
                    if (context.node.to <= context.pos + after[0].length) return context.continue();
                    return context.lineIndent(context.node.from) + (after[2] ? 0 : context.unit);
                },
                "OpenTag CloseTag SelfClosingTag" (context) {
                    return context.column(context.node.from) + context.unit;
                },
                Document (context) {
                    if (context.pos + /\s*/.exec(context.textAfter)[0].length < context.node.to) return context.continue();
                    let endElt = null, close;
                    for(let cur = context.node;;){
                        let last = cur.lastChild;
                        if (!last || last.name != "Element" || last.to != cur.to) break;
                        endElt = cur = last;
                    }
                    if (endElt && !((close = endElt.lastChild) && (close.name == "CloseTag" || close.name == "SelfClosingTag"))) return context.lineIndent(endElt.from) + context.unit;
                    return null;
                }
            }),
            /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$9b075a85eb4377d8).add({
                Element (node) {
                    let first = node.firstChild, last = node.lastChild;
                    if (!first || first.name != "OpenTag") return null;
                    return {
                        from: first.to,
                        to: last.name == "CloseTag" ? last.from : node.to
                    };
                }
            }),
            /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$ca7d74cd5b9f1011).add({
                "OpenTag CloseTag": (node)=>node.getChild("TagName")
            })
        ]
    }),
    languageData: {
        commentTokens: {
            block: {
                open: "<!--",
                close: "-->"
            }
        },
        indentOnInput: /^\s*<\/\w+\W$/,
        wordChars: "-_"
    }
});
/**
A language provider based on the [Lezer HTML
parser](https://github.com/lezer-parser/html), extended with the
JavaScript and CSS parsers to parse the content of `<script>` and
`<style>` tags.
*/ const $b89c3ee08b45bae9$export$76e66adcf103f9a2 = /*@__PURE__*/ $b89c3ee08b45bae9$var$htmlPlain.configure({
    wrap: /*@__PURE__*/ (0, $07236028cbce11ab$export$3a6217e5968adf01)($b89c3ee08b45bae9$var$defaultNesting, $b89c3ee08b45bae9$var$defaultAttrs)
});
/**
Language support for HTML, including
[`htmlCompletion`](https://codemirror.net/6/docs/ref/#lang-html.htmlCompletion) and JavaScript and
CSS support extensions.
*/ function $b89c3ee08b45bae9$export$c0bb0b647f701bb5(config = {}) {
    let dialect = "", wrap;
    if (config.matchClosingTags === false) dialect = "noMatch";
    if (config.selfClosingTags === true) dialect = (dialect ? dialect + " " : "") + "selfClosing";
    if (config.nestedLanguages && config.nestedLanguages.length || config.nestedAttributes && config.nestedAttributes.length) wrap = (0, $07236028cbce11ab$export$3a6217e5968adf01)((config.nestedLanguages || []).concat($b89c3ee08b45bae9$var$defaultNesting), (config.nestedAttributes || []).concat($b89c3ee08b45bae9$var$defaultAttrs));
    let lang = wrap ? $b89c3ee08b45bae9$var$htmlPlain.configure({
        wrap: wrap,
        dialect: dialect
    }) : dialect ? $b89c3ee08b45bae9$export$76e66adcf103f9a2.configure({
        dialect: dialect
    }) : $b89c3ee08b45bae9$export$76e66adcf103f9a2;
    return new (0, $a97ccac5cf5f4f5d$export$cbdefefa8a51dd3b)(lang, [
        $b89c3ee08b45bae9$export$76e66adcf103f9a2.data.of({
            autocomplete: $b89c3ee08b45bae9$export$2bf1c75d01fadf84(config)
        }),
        config.autoCloseTags !== false ? $b89c3ee08b45bae9$export$f1d931274ca0e1f1 : [],
        (0, $03748e9436079709$export$755219397dca4f08)().support,
        (0, $83e81cc0276b0738$export$dbf350e5966cf602)().support
    ]);
}
const $b89c3ee08b45bae9$var$selfClosers = /*@__PURE__*/ new Set(/*@__PURE__*/ "area base br col command embed frame hr img input keygen link meta param source track wbr menuitem".split(" "));
/**
Extension that will automatically insert close tags when a `>` or
`/` is typed.
*/ const $b89c3ee08b45bae9$export$f1d931274ca0e1f1 = /*@__PURE__*/ (0, $7beee9608540d2c3$export$eece2fccabbb77c5).inputHandler.of((view, from, to, text, insertTransaction)=>{
    if (view.composing || view.state.readOnly || from != to || text != ">" && text != "/" || !$b89c3ee08b45bae9$export$76e66adcf103f9a2.isActiveAt(view.state, from, -1)) return false;
    let base = insertTransaction(), { state: state } = base;
    let closeTags = state.changeByRange((range)=>{
        var _a, _b, _c;
        let didType = state.doc.sliceString(range.from - 1, range.to) == text;
        let { head: head } = range, after = (0, $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1)(state).resolveInner(head, -1), name;
        if (didType && text == ">" && after.name == "EndTag") {
            let tag = after.parent;
            if (((_b = (_a = tag.parent) === null || _a === void 0 ? void 0 : _a.lastChild) === null || _b === void 0 ? void 0 : _b.name) != "CloseTag" && (name = $b89c3ee08b45bae9$var$elementName(state.doc, tag.parent, head)) && !$b89c3ee08b45bae9$var$selfClosers.has(name)) {
                let to = head + (state.doc.sliceString(head, head + 1) === ">" ? 1 : 0);
                let insert = `</${name}>`;
                return {
                    range: range,
                    changes: {
                        from: head,
                        to: to,
                        insert: insert
                    }
                };
            }
        } else if (didType && text == "/" && after.name == "IncompleteCloseTag") {
            let tag = after.parent;
            if (after.from == head - 2 && ((_c = tag.lastChild) === null || _c === void 0 ? void 0 : _c.name) != "CloseTag" && (name = $b89c3ee08b45bae9$var$elementName(state.doc, tag, head)) && !$b89c3ee08b45bae9$var$selfClosers.has(name)) {
                let to = head + (state.doc.sliceString(head, head + 1) === ">" ? 1 : 0);
                let insert = `${name}>`;
                return {
                    range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(head + insert.length, -1),
                    changes: {
                        from: head,
                        to: to,
                        insert: insert
                    }
                };
            }
        }
        return {
            range: range
        };
    });
    if (closeTags.changes.empty) return false;
    view.dispatch([
        base,
        state.update(closeTags, {
            userEvent: "input.complete",
            scrollIntoView: true
        })
    ]);
    return true;
});



const $62499179f552ac9d$var$TAGS = [
    {
        label: "Negrito",
        tag: "strong",
        block: false
    },
    {
        label: "It\xe1lico",
        tag: "em",
        block: false
    },
    {
        label: "Link",
        tag: 'a href=""',
        block: false,
        extra: "link",
        closeAfter: "</a>"
    },
    {
        label: "H2",
        tag: "h2",
        block: true
    },
    {
        label: "H3",
        tag: "h3",
        block: true
    },
    {
        label: "P",
        tag: "p",
        block: true
    },
    {
        label: "UL",
        tag: "ul",
        block: true,
        closeAfter: "\n  <li></li>\n</ul>"
    },
    {
        label: "OL",
        tag: "ol",
        block: true,
        closeAfter: "\n  <li></li>\n</ol>"
    },
    {
        label: "LI",
        tag: "li",
        block: true
    },
    {
        label: "Imagem",
        tag: 'img src="" alt=""',
        selfClose: true
    },
    {
        label: "TABLE",
        tag: "table",
        block: true,
        closeAfter: "\n  <tbody>\n    <tr>\n      <td></td>\n    </tr>\n  </tbody>\n</table>"
    },
    {
        label: "TR",
        tag: "tr",
        block: true,
        closeAfter: "\n</tr>"
    },
    {
        label: "TH",
        tag: "th",
        block: true
    },
    {
        label: "TD",
        tag: "td",
        block: true
    }
];
function $62499179f552ac9d$var$cursorAnchor(from, open) {
    const attrMatch = open.match(/(?:href|src)\s*=\s*"([^"]*)"/);
    if (attrMatch?.index !== undefined) {
        const quoteStart = attrMatch.index + open.slice(attrMatch.index).indexOf('"');
        return from + quoteStart + 1;
    }
    return from + open.length;
}
function $62499179f552ac9d$export$2e2bcd8739ae039({ value: value, onChange: onChange, label: label }) {
    const id = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const viewRef = (0, $acw62.useRef)(null);
    const [showPreview, setShowPreview] = (0, $acw62.useState)(false);
    const onMount = (0, $acw62.useCallback)((view)=>{
        viewRef.current = view;
    }, []);
    const insertTag = (0, $acw62.useCallback)((tag, closeAfter, selfClose, extra)=>{
        const view = viewRef.current;
        if (!view) return;
        const { from: from, to: to } = view.state.selection.main;
        const selected = view.state.sliceDoc(from, to);
        const name = tag.split(" ")[0];
        const open = `<${tag}>`;
        const close = closeAfter ?? (selfClose ? "" : `</${name}>`);
        const replacement = selected ? `${open}${selected}${close}` : extra ? `${open}${extra}${close}` : `${open}${close}`;
        view.dispatch({
            changes: {
                from: from,
                to: to,
                insert: replacement
            },
            selection: {
                anchor: $62499179f552ac9d$var$cursorAnchor(from, open)
            }
        });
        view.focus();
    }, [
        viewRef
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center justify-between mb-1",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                        htmlFor: id,
                        className: "block text-sm font-medium text-gray-700",
                        children: label
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        type: "button",
                        onClick: ()=>setShowPreview(!showPreview),
                        className: "text-xs text-blue-600 hover:text-blue-800",
                        children: showPreview ? "Editar HTML" : "Pr\xe9-visualizar"
                    })
                ]
            }),
            showPreview ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "w-full border border-gray-300 rounded-md p-4 bg-white min-h-[200px] text-sm overflow-auto",
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: value
                }
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex flex-wrap gap-1 mb-1",
                        children: $62499179f552ac9d$var$TAGS.map((t)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                onClick: ()=>insertTag(t.tag, t.closeAfter, t.selfClose, t.extra),
                                className: "px-2 py-1 text-xs font-medium bg-gray-100 border border-gray-200 rounded hover:bg-gray-200 text-gray-700 whitespace-nowrap min-h-[32px]",
                                title: `<${t.tag}>`,
                                children: t.label
                            }, `${t.label}-${t.tag}`))
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "border border-gray-300 rounded-md overflow-hidden",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $269cb9ebbcb83755$export$2e2bcd8739ae039), {
                            value: value,
                            onChange: onChange,
                            extensions: [
                                (0, $b89c3ee08b45bae9$export$c0bb0b647f701bb5)(),
                                (0, $7beee9608540d2c3$export$eece2fccabbb77c5).lineWrapping
                            ],
                            onCreateEditor: onMount,
                            theme: "light",
                            height: "auto",
                            minHeight: "300px",
                            basicSetup: {
                                lineNumbers: true,
                                foldGutter: true,
                                bracketMatching: true,
                                closeBrackets: true,
                                indentOnInput: true,
                                highlightActiveLine: true
                            }
                        })
                    })
                ]
            })
        ]
    });
}


const $60cd466144a1b462$var$HERO_ICONS = {
    Truck: $392fe89eaa6d43ad$export$2e2bcd8739ae039,
    Wallet: $33b542e8915cec79$export$2e2bcd8739ae039,
    CreditCard: $1299b0a605d22052$export$2e2bcd8739ae039,
    Handshake: $199a795aa57ac65f$export$2e2bcd8739ae039,
    Wrench: $888d8be60abebd94$export$2e2bcd8739ae039,
    Building2: $224502d93617e0e1$export$2e2bcd8739ae039,
    Monitor: $f633c0fb63f4b508$export$2e2bcd8739ae039,
    Shield: $960b709ecb4ade55$export$2e2bcd8739ae039,
    Cpu: $e8859e855a5dc92a$export$2e2bcd8739ae039,
    Headset: $605221d737bd0cfe$export$2e2bcd8739ae039,
    RotateCcw: $c6e669e1fd7e7ff8$export$2e2bcd8739ae039,
    Package: $437c67a40c1b8279$export$2e2bcd8739ae039,
    Archive: $357b00fa120a5c4e$export$2e2bcd8739ae039,
    MapPin: $c978075baab28645$export$2e2bcd8739ae039,
    Phone: $970c5cdf933ea69e$export$2e2bcd8739ae039,
    Mail: $d6fe951f3901e9a6$export$2e2bcd8739ae039,
    Store: $3f17d085e2e0469d$export$2e2bcd8739ae039,
    HelpCircle: $d41f89c0dd165c13$export$2e2bcd8739ae039,
    FileText: $adb270212de20834$export$2e2bcd8739ae039,
    List: $ef166891ec0b7b3f$export$2e2bcd8739ae039,
    BarChart: $cd622ab0b3556c79$export$2e2bcd8739ae039,
    LayoutGrid: $c52b562f10363bcd$export$2e2bcd8739ae039,
    ListChecks: $131c05e6196e399a$export$2e2bcd8739ae039,
    ShoppingCart: $ee6f13a46cf9100a$export$2e2bcd8739ae039,
    Users: $c38b5b11d1e2b813$export$2e2bcd8739ae039,
    Settings: $da03c070d837b197$export$2e2bcd8739ae039,
    AlertCircle: $5415d98bde6b29f1$export$2e2bcd8739ae039,
    CheckCircle: $e3f86240925e7a9e$export$2e2bcd8739ae039,
    ArrowRight: $f9e50e5a44fb11e0$export$2e2bcd8739ae039,
    Info: $e52b122f04c04d7d$export$2e2bcd8739ae039,
    Search: $9ad14973a512851d$export$2e2bcd8739ae039,
    Star: $04b006b04b8c21eb$export$2e2bcd8739ae039,
    Globe: $9b51f4920eac1ba0$export$2e2bcd8739ae039,
    Lock: $e20ffdae2aa9b33f$export$2e2bcd8739ae039,
    Cookie: $f792549e0db201dc$export$2e2bcd8739ae039,
    Scale: $0811c1891b547863$export$2e2bcd8739ae039,
    BookOpen: $e1cfd183b457f6f1$export$2e2bcd8739ae039,
    Briefcase: $34c3e517ec92034a$export$2e2bcd8739ae039,
    ShieldCheck: $e325251f2797f6cf$export$2e2bcd8739ae039
};
const $60cd466144a1b462$var$HERO_ICON_NAMES = Object.keys($60cd466144a1b462$var$HERO_ICONS).sort();
function $60cd466144a1b462$var$coerceString(val, fallback = "") {
    if (typeof val === "string") return val;
    if (typeof val === "number" || typeof val === "boolean") return String(val);
    return fallback;
}
function $60cd466144a1b462$var$TextField({ label: label, value: value = "", onChange: onChange }) {
    const id = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                htmlFor: id,
                className: "block text-sm font-medium text-gray-700 mb-1",
                children: label
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                id: id,
                type: "text",
                value: value ?? "",
                onChange: (e)=>onChange(e.target.value),
                className: "w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            })
        ]
    });
}
function $60cd466144a1b462$var$TextareaField({ label: label, value: value = "", onChange: onChange, rows: rows = 3, monospace: monospace }) {
    const id = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                htmlFor: id,
                className: "block text-sm font-medium text-gray-700 mb-1",
                children: label
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                id: id,
                value: value ?? "",
                onChange: (e)=>onChange(e.target.value),
                rows: rows,
                className: `w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${monospace ? "font-mono text-sm" : "text-sm"}`
            })
        ]
    });
}
function $60cd466144a1b462$var$StringArrayEditor({ items: items, onChange: onChange, placeholder: placeholder = "Item" }) {
    const addItem = (0, $acw62.useCallback)(()=>{
        onChange([
            ...items,
            ""
        ]);
    }, [
        items,
        onChange
    ]);
    const removeItem = (0, $acw62.useCallback)((index)=>{
        onChange(items.filter((_, i)=>i !== index));
    }, [
        items,
        onChange
    ]);
    const updateItem = (0, $acw62.useCallback)((index, value)=>{
        onChange(items.map((item, i)=>i === index ? value : item));
    }, [
        items,
        onChange
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "space-y-2",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                className: "space-y-2",
                children: items.map((item, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                        className: "flex gap-2 items-start",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                type: "text",
                                value: item,
                                onChange: (e)=>updateItem(i, e.target.value),
                                className: "flex-1 px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500",
                                placeholder: placeholder
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                onClick: ()=>removeItem(i),
                                className: "mt-2 text-red-500 hover:text-red-700 shrink-0",
                                "aria-label": "Remover item",
                                title: "Remover item",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                    size: 16
                                })
                            })
                        ]
                    }, i))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                type: "button",
                onClick: addItem,
                className: "flex items-center gap-1 text-sm text-blue-600 hover:text-blue-800",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                        size: 14
                    }),
                    " Adicionar item"
                ]
            })
        ]
    });
}
function $60cd466144a1b462$var$ObjectArrayEditor({ items: items, onChange: onChange, fields: fields, defaultItem: defaultItem, itemLabel: itemLabel }) {
    const containerId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const [expandedIndex, setExpandedIndex] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const addItem = (0, $acw62.useCallback)(()=>{
        onChange([
            ...items,
            {
                ...defaultItem
            }
        ]);
    }, [
        items,
        onChange,
        defaultItem
    ]);
    const removeItem = (0, $acw62.useCallback)((index)=>{
        onChange(items.filter((_, i)=>i !== index));
    }, [
        items,
        onChange
    ]);
    const updateField = (0, $acw62.useCallback)((index, key, value)=>{
        onChange(items.map((item, i)=>i === index ? {
                ...item,
                [key]: value
            } : item));
    }, [
        items,
        onChange
    ]);
    const moveItem = (0, $acw62.useCallback)((index, direction)=>{
        const target = direction === "up" ? index - 1 : index + 1;
        if (target < 0 || target >= items.length) return;
        const copy = [
            ...items
        ];
        [copy[index], copy[target]] = [
            copy[target],
            copy[index]
        ];
        onChange(copy);
    }, [
        items,
        onChange
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "space-y-3",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                className: "space-y-3",
                children: items.map((item, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                        className: "p-3 border border-gray-200 rounded-md bg-gray-50",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "flex items-center gap-1 flex-1 min-w-0",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    type: "button",
                                    onClick: ()=>setExpandedIndex(expandedIndex === i ? null : i),
                                    className: "flex items-center gap-2 flex-1 text-left min-w-0",
                                    "aria-expanded": expandedIndex === i,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "shrink-0",
                                            children: expandedIndex === i ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b397e876e35a9277$export$2e2bcd8739ae039), {
                                                size: 14,
                                                className: "text-gray-400"
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                                size: 14,
                                                className: "text-gray-400"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "text-xs font-medium text-gray-500 truncate",
                                            children: [
                                                itemLabel || "Item",
                                                " ",
                                                i + 1,
                                                expandedIndex !== i && item.question ? ` \u{2014} ${String(item.question).substring(0, 60)}` : expandedIndex !== i && item.title ? ` \u{2014} ${String(item.title).substring(0, 60)}` : expandedIndex !== i && item.name ? ` \u{2014} ${String(item.name).substring(0, 60)}` : ""
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center gap-1 shrink-0",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>moveItem(i, "up"),
                                        disabled: i === 0,
                                        className: "p-1 text-gray-400 hover:text-gray-600 disabled:opacity-30 disabled:cursor-not-allowed",
                                        "aria-label": `Mover ${(itemLabel || "item").toLowerCase()} ${i + 1} para cima`,
                                        title: "Mover para cima",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f05f6a77fc593bc$export$2e2bcd8739ae039), {
                                            size: 14
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>moveItem(i, "down"),
                                        disabled: i === items.length - 1,
                                        className: "p-1 text-gray-400 hover:text-gray-600 disabled:opacity-30 disabled:cursor-not-allowed",
                                        "aria-label": `Mover ${(itemLabel || "item").toLowerCase()} ${i + 1} para baixo`,
                                        title: "Mover para baixo",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $008e11cf932a0927$export$2e2bcd8739ae039), {
                                            size: 14
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>removeItem(i),
                                        className: "text-red-500 hover:text-red-700",
                                        "aria-label": `Remover ${(itemLabel || "item").toLowerCase()} ${i + 1}`,
                                        title: "Remover",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                            size: 14
                                        })
                                    })
                                ]
                            }),
                            expandedIndex === i && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "px-3 pb-3 space-y-2",
                                children: fields.map((field)=>{
                                    const fieldId = `${containerId}-${i}-${field.key}`;
                                    if (field.type === "string_array") return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                className: "block text-xs font-medium text-gray-600 mb-0.5",
                                                children: field.label
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($60cd466144a1b462$var$StringArrayEditor, {
                                                items: Array.isArray(item[field.key]) ? item[field.key] : [],
                                                onChange: (v)=>updateField(i, field.key, v),
                                                placeholder: field.label
                                            })
                                        ]
                                    }, field.key);
                                    if (field.type === "html") return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pt-1",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                className: "block text-xs font-medium text-gray-600 mb-0.5",
                                                children: field.label
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $62499179f552ac9d$export$2e2bcd8739ae039), {
                                                value: $60cd466144a1b462$var$coerceString(item[field.key]),
                                                onChange: (v)=>updateField(i, field.key, v),
                                                label: ""
                                            })
                                        ]
                                    }, field.key);
                                    if (field.type === "boolean") return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center gap-2 pt-1",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                id: fieldId,
                                                type: "checkbox",
                                                checked: !!item[field.key],
                                                onChange: (e)=>updateField(i, field.key, e.target.checked),
                                                className: "rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                htmlFor: fieldId,
                                                className: "text-xs font-medium text-gray-600 cursor-pointer",
                                                children: field.label
                                            })
                                        ]
                                    }, field.key);
                                    return field.type === "textarea" ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                htmlFor: fieldId,
                                                className: "block text-xs font-medium text-gray-600 mb-0.5",
                                                children: field.label
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                id: fieldId,
                                                value: $60cd466144a1b462$var$coerceString(item[field.key]),
                                                onChange: (e)=>updateField(i, field.key, e.target.value),
                                                rows: 2,
                                                className: "w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                                            })
                                        ]
                                    }, field.key) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                htmlFor: fieldId,
                                                className: "block text-xs font-medium text-gray-600 mb-0.5",
                                                children: field.label
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                id: fieldId,
                                                type: "text",
                                                value: $60cd466144a1b462$var$coerceString(item[field.key]),
                                                onChange: (e)=>updateField(i, field.key, e.target.value),
                                                className: "w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                                            })
                                        ]
                                    }, field.key);
                                })
                            })
                        ]
                    }, i))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                type: "button",
                onClick: addItem,
                className: "flex items-center gap-1 text-sm text-blue-600 hover:text-blue-800",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                        size: 14
                    }),
                    " Adicionar item"
                ]
            })
        ]
    });
}
const $60cd466144a1b462$var$STORE_FIELDS = [
    {
        key: "name",
        label: "Nome",
        type: "text"
    },
    {
        key: "intro",
        label: "Introdu\xe7\xe3o",
        type: "text"
    },
    {
        key: "address",
        label: "Morada",
        type: "textarea"
    },
    {
        key: "phones",
        label: "Telefones",
        type: "string_array"
    },
    {
        key: "emails",
        label: "Emails",
        type: "string_array"
    },
    {
        key: "hours",
        label: "Hor\xe1rio",
        type: "string_array"
    }
];
function $60cd466144a1b462$export$2e2bcd8739ae039({ type: type, data: data, onChange: onChange }) {
    const setField = (0, $acw62.useCallback)((key, value)=>{
        onChange({
            ...data,
            [key]: value
        });
    }, [
        data,
        onChange
    ]);
    switch(type){
        case "hero":
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "space-y-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($60cd466144a1b462$var$TextField, {
                        label: "T\xedtulo",
                        value: $60cd466144a1b462$var$coerceString(data.heading),
                        onChange: (v)=>setField("heading", v)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($60cd466144a1b462$var$TextField, {
                        label: "Subt\xedtulo",
                        value: $60cd466144a1b462$var$coerceString(data.subtext),
                        onChange: (v)=>setField("subtext", v)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($60cd466144a1b462$var$TextField, {
                        label: "Atualizado em",
                        value: $60cd466144a1b462$var$coerceString(data.lastUpdated),
                        onChange: (v)=>setField("lastUpdated", v)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($60cd466144a1b462$var$TextField, {
                        label: "Imagem de banner (URL)",
                        value: $60cd466144a1b462$var$coerceString(data.image),
                        onChange: (v)=>setField("image", v)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($60cd466144a1b462$var$TextField, {
                        label: "Texto alternativo da imagem",
                        value: $60cd466144a1b462$var$coerceString(data.imageAlt),
                        onChange: (v)=>setField("imageAlt", v)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                className: "block text-sm font-medium text-gray-700 mb-1",
                                children: "\xcdcone"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "w-10 h-10 rounded-lg border border-gray-200 bg-gray-50 flex items-center justify-center shrink-0",
                                        children: (()=>{
                                            const IconComp = data.icon ? $60cd466144a1b462$var$HERO_ICONS[data.icon] : null;
                                            return IconComp ? /*#__PURE__*/ (0, $ayMG0.jsx)(IconComp, {
                                                size: 22,
                                                className: "text-primary"
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "text-gray-300 text-xs",
                                                children: "?"
                                            });
                                        })()
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                        value: $60cd466144a1b462$var$coerceString(data.icon),
                                        onChange: (e)=>setField("icon", e.target.value),
                                        className: "flex-1 px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                value: "",
                                                children: "Sem \xedcone"
                                            }),
                                            $60cd466144a1b462$var$HERO_ICON_NAMES.map((name)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: name,
                                                    children: name
                                                }, name))
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            });
        case "richtext":
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $62499179f552ac9d$export$2e2bcd8739ae039), {
                label: "HTML",
                value: $60cd466144a1b462$var$coerceString(data.html),
                onChange: (v)=>setField("html", v)
            });
        case "faq_list":
            return /*#__PURE__*/ (0, $ayMG0.jsx)($60cd466144a1b462$var$ObjectArrayEditor, {
                items: Array.isArray(data.items) ? data.items : [],
                onChange: (items)=>setField("items", items),
                fields: [
                    {
                        key: "question",
                        label: "Pergunta",
                        type: "text"
                    },
                    {
                        key: "answer",
                        label: "Resposta",
                        type: "html"
                    }
                ],
                defaultItem: {
                    question: "",
                    answer: ""
                },
                itemLabel: "Pergunta"
            });
        case "sections_list":
            return /*#__PURE__*/ (0, $ayMG0.jsx)($60cd466144a1b462$var$ObjectArrayEditor, {
                items: Array.isArray(data.items) ? data.items : [],
                onChange: (items)=>setField("items", items),
                fields: [
                    {
                        key: "title",
                        label: "T\xedtulo",
                        type: "text"
                    },
                    {
                        key: "body",
                        label: "Corpo",
                        type: "html"
                    }
                ],
                defaultItem: {
                    title: "",
                    body: ""
                },
                itemLabel: "Sec\xe7\xe3o"
            });
        case "stats_grid":
            return /*#__PURE__*/ (0, $ayMG0.jsx)($60cd466144a1b462$var$ObjectArrayEditor, {
                items: Array.isArray(data.items) ? data.items : [],
                onChange: (items)=>setField("items", items),
                fields: [
                    {
                        key: "label",
                        label: "R\xf3tulo",
                        type: "text"
                    },
                    {
                        key: "value",
                        label: "Valor",
                        type: "text"
                    }
                ],
                defaultItem: {
                    label: "",
                    value: ""
                },
                itemLabel: "Estat\xedstica"
            });
        case "contact_info":
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "space-y-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($60cd466144a1b462$var$TextField, {
                        label: "Telefone",
                        value: $60cd466144a1b462$var$coerceString(data.phone),
                        onChange: (v)=>setField("phone", v)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($60cd466144a1b462$var$TextField, {
                        label: "Nota do telefone",
                        value: $60cd466144a1b462$var$coerceString(data.phoneNote),
                        onChange: (v)=>setField("phoneNote", v)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($60cd466144a1b462$var$TextField, {
                        label: "Email",
                        value: $60cd466144a1b462$var$coerceString(data.email),
                        onChange: (v)=>setField("email", v)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($60cd466144a1b462$var$TextareaField, {
                        label: "Morada",
                        value: $60cd466144a1b462$var$coerceString(data.address),
                        onChange: (v)=>setField("address", v)
                    })
                ]
            });
        case "stores_list":
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "space-y-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($60cd466144a1b462$var$TextField, {
                        label: "Introdu\xe7\xe3o",
                        value: $60cd466144a1b462$var$coerceString(data.intro),
                        onChange: (v)=>setField("intro", v)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($60cd466144a1b462$var$TextField, {
                        label: "Nota de rodap\xe9",
                        value: $60cd466144a1b462$var$coerceString(data.footnote),
                        onChange: (v)=>setField("footnote", v)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($60cd466144a1b462$var$ObjectArrayEditor, {
                        items: Array.isArray(data.items) ? data.items : [],
                        onChange: (items)=>setField("items", items),
                        fields: $60cd466144a1b462$var$STORE_FIELDS,
                        defaultItem: {
                            name: "",
                            intro: "",
                            address: "",
                            phones: [],
                            emails: [],
                            hours: []
                        },
                        itemLabel: "Loja"
                    })
                ]
            });
        case "services_grid":
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "space-y-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($60cd466144a1b462$var$TextField, {
                        label: "T\xedtulo da sec\xe7\xe3o",
                        value: $60cd466144a1b462$var$coerceString(data.heading),
                        onChange: (v)=>setField("heading", v)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($60cd466144a1b462$var$ObjectArrayEditor, {
                        items: Array.isArray(data.items) ? data.items : [],
                        onChange: (items)=>setField("items", items),
                        fields: [
                            {
                                key: "title",
                                label: "T\xedtulo",
                                type: "text"
                            },
                            {
                                key: "description",
                                label: "Descri\xe7\xe3o",
                                type: "textarea"
                            },
                            {
                                key: "icon",
                                label: "\xcdcone",
                                type: "text"
                            }
                        ],
                        defaultItem: {
                            title: "",
                            description: "",
                            icon: ""
                        },
                        itemLabel: "Servi\xe7o"
                    })
                ]
            });
        case "payment_methods":
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "space-y-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($60cd466144a1b462$var$TextField, {
                        label: "Introdu\xe7\xe3o",
                        value: $60cd466144a1b462$var$coerceString(data.intro),
                        onChange: (v)=>setField("intro", v)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($60cd466144a1b462$var$ObjectArrayEditor, {
                        items: Array.isArray(data.items) ? data.items : [],
                        onChange: (items)=>setField("items", items),
                        fields: [
                            {
                                key: "title",
                                label: "Nome",
                                type: "text"
                            },
                            {
                                key: "html",
                                label: "Descri\xe7\xe3o (HTML)",
                                type: "html"
                            },
                            {
                                key: "soon",
                                label: "Em Breve",
                                type: "boolean"
                            }
                        ],
                        defaultItem: {
                            title: "",
                            html: "",
                            soon: false
                        },
                        itemLabel: "M\xe9todo"
                    })
                ]
            });
        case "bullet_list":
            return /*#__PURE__*/ (0, $ayMG0.jsx)($60cd466144a1b462$var$StringArrayEditor, {
                items: Array.isArray(data.items) ? data.items : [],
                onChange: (items)=>setField("items", items),
                placeholder: "Item da lista"
            });
        case "product_grid":
            {
                const categories = Array.isArray(data.categories) ? data.categories.filter((c)=>typeof c === "string") : [];
                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "space-y-3",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($60cd466144a1b462$var$TextField, {
                            label: "T\xedtulo da sec\xe7\xe3o",
                            value: $60cd466144a1b462$var$coerceString(data.heading),
                            onChange: (v)=>setField("heading", v)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($60cd466144a1b462$var$TextField, {
                            label: "Subt\xedtulo",
                            value: $60cd466144a1b462$var$coerceString(data.subtext),
                            onChange: (v)=>setField("subtext", v)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($60cd466144a1b462$var$TextField, {
                            label: "Marca (ex.: RAPTOR)",
                            value: $60cd466144a1b462$var$coerceString(data.brand),
                            onChange: (v)=>setField("brand", v)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($60cd466144a1b462$var$TextField, {
                            label: "Categorias (separadas por v\xedrgula)",
                            value: categories.join(", "),
                            onChange: (v)=>setField("categories", v.split(",").map((c)=>c.trim()).filter(Boolean))
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($60cd466144a1b462$var$TextField, {
                            label: "N\xba m\xe1ximo de m\xe1quinas",
                            value: data.limit === undefined || data.limit === null ? "" : String(data.limit),
                            onChange: (v)=>{
                                const n = Number(v);
                                setField("limit", v.trim() === "" || Number.isNaN(n) ? undefined : n);
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($60cd466144a1b462$var$TextField, {
                            label: "Link do bot\xe3o",
                            value: $60cd466144a1b462$var$coerceString(data.ctaHref),
                            onChange: (v)=>setField("ctaHref", v)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($60cd466144a1b462$var$TextField, {
                            label: "Texto do bot\xe3o",
                            value: $60cd466144a1b462$var$coerceString(data.ctaLabel),
                            onChange: (v)=>setField("ctaLabel", v)
                        })
                    ]
                });
            }
        case "hero_banner":
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "space-y-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($60cd466144a1b462$var$TextField, {
                        label: "Badge",
                        value: $60cd466144a1b462$var$coerceString(data.badge),
                        onChange: (v)=>setField("badge", v)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($60cd466144a1b462$var$TextField, {
                        label: "T\xedtulo",
                        value: $60cd466144a1b462$var$coerceString(data.heading),
                        onChange: (v)=>setField("heading", v)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($60cd466144a1b462$var$TextareaField, {
                        label: "Subt\xedtulo",
                        value: $60cd466144a1b462$var$coerceString(data.subtext),
                        onChange: (v)=>setField("subtext", v)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($60cd466144a1b462$var$TextField, {
                        label: "Imagem (URL)",
                        value: $60cd466144a1b462$var$coerceString(data.image),
                        onChange: (v)=>setField("image", v)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($60cd466144a1b462$var$TextField, {
                        label: "Texto alternativo da imagem",
                        value: $60cd466144a1b462$var$coerceString(data.imageAlt),
                        onChange: (v)=>setField("imageAlt", v)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($60cd466144a1b462$var$TextField, {
                        label: "Link do bot\xe3o",
                        value: $60cd466144a1b462$var$coerceString(data.ctaHref),
                        onChange: (v)=>setField("ctaHref", v)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($60cd466144a1b462$var$TextField, {
                        label: "Texto do bot\xe3o",
                        value: $60cd466144a1b462$var$coerceString(data.ctaLabel),
                        onChange: (v)=>setField("ctaLabel", v)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($60cd466144a1b462$var$TextField, {
                        label: "Nota de confian\xe7a",
                        value: $60cd466144a1b462$var$coerceString(data.trustNote),
                        onChange: (v)=>setField("trustNote", v)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($60cd466144a1b462$var$TextField, {
                        label: "Cor de destaque (orange|red|amber|emerald|cyan)",
                        value: $60cd466144a1b462$var$coerceString(data.accent),
                        onChange: (v)=>setField("accent", v)
                    })
                ]
            });
        case "callout":
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "space-y-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($60cd466144a1b462$var$TextField, {
                        label: "\xcdcone",
                        value: $60cd466144a1b462$var$coerceString(data.icon),
                        onChange: (v)=>setField("icon", v)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($60cd466144a1b462$var$TextField, {
                        label: "T\xedtulo",
                        value: $60cd466144a1b462$var$coerceString(data.heading),
                        onChange: (v)=>setField("heading", v)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $62499179f552ac9d$export$2e2bcd8739ae039), {
                        label: "Texto",
                        value: $60cd466144a1b462$var$coerceString(data.html),
                        onChange: (v)=>setField("html", v)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($60cd466144a1b462$var$TextField, {
                        label: "Cor de destaque (orange|red|amber|emerald|cyan)",
                        value: $60cd466144a1b462$var$coerceString(data.accent),
                        onChange: (v)=>setField("accent", v)
                    })
                ]
            });
        case "feature_cards":
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "space-y-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($60cd466144a1b462$var$TextField, {
                        label: "T\xedtulo da sec\xe7\xe3o",
                        value: $60cd466144a1b462$var$coerceString(data.heading),
                        onChange: (v)=>setField("heading", v)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($60cd466144a1b462$var$ObjectArrayEditor, {
                        items: Array.isArray(data.items) ? data.items : [],
                        onChange: (items)=>setField("items", items),
                        fields: [
                            {
                                key: "icon",
                                label: "\xcdcone",
                                type: "text"
                            },
                            {
                                key: "title",
                                label: "T\xedtulo",
                                type: "text"
                            },
                            {
                                key: "description",
                                label: "Descri\xe7\xe3o",
                                type: "textarea"
                            }
                        ],
                        defaultItem: {
                            icon: "",
                            title: "",
                            description: ""
                        },
                        itemLabel: "Cart\xe3o"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($60cd466144a1b462$var$TextField, {
                        label: "Cor de destaque (orange|red|amber|emerald|cyan)",
                        value: $60cd466144a1b462$var$coerceString(data.accent),
                        onChange: (v)=>setField("accent", v)
                    })
                ]
            });
        default:
            console.warn(`[SectionFieldEditor] Unknown section type: ${type}`);
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                className: "text-sm text-gray-500 italic",
                children: [
                    "Tipo de sec\xe7\xe3o desconhecido: ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("code", {
                        children: type
                    })
                ]
            });
    }
}


/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $095d7065507340b0$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m3 11 18-5v12L3 14v-3z",
            key: "n962bs"
        }
    ],
    [
        "path",
        {
            d: "M11.6 16.8a3 3 0 1 1-5.8-1.6",
            key: "1yl0tm"
        }
    ]
];
const $095d7065507340b0$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("megaphone", $095d7065507340b0$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.507.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $39c065d00fa604c6$export$3efd853dbb351e94 = [
    [
        "polyline",
        {
            points: "4 7 4 4 20 4 20 7",
            key: "1nosan"
        }
    ],
    [
        "line",
        {
            x1: "9",
            x2: "15",
            y1: "20",
            y2: "20",
            key: "swin9y"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "4",
            y2: "20",
            key: "1tx1rr"
        }
    ]
];
const $39c065d00fa604c6$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("type", $39c065d00fa604c6$export$3efd853dbb351e94);


const $114ba18d47d96a33$export$9c3e0a77c247e0c = [
    {
        type: "hero",
        label: "Cabe\xe7alho",
        description: "T\xedtulo principal da p\xe1gina com subt\xedtulo opcional",
        color: "bg-blue-100 text-blue-700",
        Icon: (0, $39c065d00fa604c6$export$2e2bcd8739ae039),
        createDefault: ()=>({
                heading: "",
                subtext: "",
                lastUpdated: "",
                image: "",
                imageAlt: ""
            })
    },
    {
        type: "richtext",
        label: "Texto Rico",
        description: "Bloco de HTML livre para conte\xfado formatado",
        color: "bg-gray-100 text-gray-700",
        Icon: (0, $adb270212de20834$export$2e2bcd8739ae039),
        createDefault: ()=>({
                html: ""
            })
    },
    {
        type: "faq_list",
        label: "FAQ",
        description: "Lista de perguntas e respostas",
        color: "bg-purple-100 text-purple-700",
        Icon: (0, $d41f89c0dd165c13$export$2e2bcd8739ae039),
        createDefault: ()=>({
                items: []
            })
    },
    {
        type: "sections_list",
        label: "Lista de Sec\xe7\xf5es",
        description: "Sec\xe7\xf5es com t\xedtulo e corpo de texto",
        color: "bg-green-100 text-green-700",
        Icon: (0, $ef166891ec0b7b3f$export$2e2bcd8739ae039),
        createDefault: ()=>({
                items: []
            })
    },
    {
        type: "stats_grid",
        label: "Grelha de Estat\xedsticas",
        description: "Conjunto de m\xe9tricas com r\xf3tulo e valor",
        color: "bg-orange-100 text-orange-700",
        Icon: (0, $cd622ab0b3556c79$export$2e2bcd8739ae039),
        createDefault: ()=>({
                items: []
            })
    },
    {
        type: "contact_info",
        label: "Contactos",
        description: "Informa\xe7\xf5es de contacto telefone, email e morada",
        color: "bg-teal-100 text-teal-700",
        Icon: (0, $970c5cdf933ea69e$export$2e2bcd8739ae039),
        createDefault: ()=>({
                phone: "",
                phoneNote: "",
                email: "",
                address: ""
            })
    },
    {
        type: "stores_list",
        label: "Lojas",
        description: "Lista de lojas com morada, hor\xe1rio e mapa",
        color: "bg-pink-100 text-pink-700",
        Icon: (0, $3f17d085e2e0469d$export$2e2bcd8739ae039),
        createDefault: ()=>({
                intro: "",
                footnote: "",
                items: []
            })
    },
    {
        type: "services_grid",
        label: "Grelha de Servi\xe7os",
        description: "Conjunto de servi\xe7os com t\xedtulo, descri\xe7\xe3o e \xedcone",
        color: "bg-indigo-100 text-indigo-700",
        Icon: (0, $c52b562f10363bcd$export$2e2bcd8739ae039),
        createDefault: ()=>({
                heading: "",
                items: []
            })
    },
    {
        type: "payment_methods",
        label: "M\xe9todos de Pagamento",
        description: "M\xe9todos de pagamento aceites",
        color: "bg-yellow-100 text-yellow-700",
        Icon: (0, $1299b0a605d22052$export$2e2bcd8739ae039),
        createDefault: ()=>({
                intro: "",
                items: []
            })
    },
    {
        type: "bullet_list",
        label: "Lista de T\xf3picos",
        description: "Lista simples de itens de texto",
        color: "bg-cyan-100 text-cyan-700",
        Icon: (0, $131c05e6196e399a$export$2e2bcd8739ae039),
        createDefault: ()=>({
                items: []
            })
    },
    {
        type: "product_grid",
        label: "Grelha de Produtos",
        description: "Listagem din\xe2mica de m\xe1quinas do cat\xe1logo (por marca/categoria)",
        color: "bg-amber-100 text-amber-700",
        Icon: (0, $f633c0fb63f4b508$export$2e2bcd8739ae039),
        createDefault: ()=>({
                heading: "",
                subtext: "",
                brand: "",
                categories: [
                    "computer-gaming"
                ],
                limit: 24,
                ctaHref: "",
                ctaLabel: ""
            })
    },
    {
        type: "hero_banner",
        label: "Banner Hero",
        description: "Banner de marca com imagem, badge, subt\xedtulo, CTA e nota de confian\xe7a",
        color: "bg-rose-100 text-rose-700",
        Icon: (0, $095d7065507340b0$export$2e2bcd8739ae039),
        createDefault: ()=>({
                badge: "",
                heading: "",
                subtext: "",
                image: "",
                imageAlt: "",
                ctaHref: "",
                ctaLabel: "",
                trustNote: "",
                accent: "orange"
            })
    },
    {
        type: "callout",
        label: "Destaque",
        description: "Cart\xe3o destacado com \xedcone, t\xedtulo e texto rico",
        color: "bg-emerald-100 text-emerald-700",
        Icon: (0, $e325251f2797f6cf$export$2e2bcd8739ae039),
        createDefault: ()=>({
                icon: "",
                heading: "",
                html: "",
                accent: "orange"
            })
    },
    {
        type: "feature_cards",
        label: "Cart\xf5es de Destaque",
        description: "Grelha de cart\xf5es com \xedcone, t\xedtulo e descri\xe7\xe3o",
        color: "bg-lime-100 text-lime-700",
        Icon: (0, $c52b562f10363bcd$export$2e2bcd8739ae039),
        createDefault: ()=>({
                heading: "",
                items: [],
                accent: "orange"
            })
    }
];
const $114ba18d47d96a33$export$1e5c4f2c7d35f342 = new Map($114ba18d47d96a33$export$9c3e0a77c247e0c.map((t)=>[
        t.type,
        t
    ]));


function $b2e6f160ae3cb6b3$var$getPreview(section) {
    switch(section.type){
        case "hero":
            return section.heading || "(sem t\xedtulo)";
        case "richtext":
            {
                const html = section.html || "";
                const stripped = html.replace(/<[^>]*>/g, "");
                return stripped.length > 60 ? stripped.substring(0, 60) + "..." : stripped || "(vazio)";
            }
        case "faq_list":
            {
                const items = Array.isArray(section.items) ? section.items : [];
                return `${items.length} ${items.length === 1 ? "pergunta" : "perguntas"}`;
            }
        case "sections_list":
            {
                const items = Array.isArray(section.items) ? section.items : [];
                return `${items.length} ${items.length === 1 ? "sec\xe7\xe3o" : "sec\xe7\xf5es"}`;
            }
        case "stats_grid":
            {
                const items = Array.isArray(section.items) ? section.items : [];
                return `${items.length} ${items.length === 1 ? "estat\xedstica" : "estat\xedsticas"}`;
            }
        case "contact_info":
            return section.email || section.phone || "(sem contactos)";
        case "stores_list":
            {
                const items = Array.isArray(section.items) ? section.items : [];
                return `${items.length} ${items.length === 1 ? "loja" : "lojas"}`;
            }
        case "services_grid":
            {
                const items = Array.isArray(section.items) ? section.items : [];
                return section.heading || `${items.length} ${items.length === 1 ? "servi\xe7o" : "servi\xe7os"}`;
            }
        case "payment_methods":
            {
                const items = Array.isArray(section.items) ? section.items : [];
                return `${items.length} ${items.length === 1 ? "m\xe9todo" : "m\xe9todos"}`;
            }
        case "bullet_list":
            {
                const items = Array.isArray(section.items) ? section.items : [];
                return `${items.length} ${items.length === 1 ? "item" : "itens"}`;
            }
        case "product_grid":
            {
                const brand = section.brand || "";
                const heading = section.heading || "";
                return heading || brand ? `${heading || "Grelha de produtos"}${brand ? ` \xb7 ${brand}` : ""}` : "Grelha de produtos (cat\xe1logo)";
            }
        case "hero_banner":
            return section.heading || section.badge || "Banner hero";
        case "callout":
            return section.heading || "Destaque";
        case "feature_cards":
            {
                const items = Array.isArray(section.items) ? section.items : [];
                return section.heading || `${items.length} ${items.length === 1 ? "cart\xe3o" : "cart\xf5es"}`;
            }
        default:
            console.warn(`[SectionCard] Unknown section type in preview: ${section.type}`);
            return JSON.stringify(section).substring(0, 60);
    }
}
function $b2e6f160ae3cb6b3$export$2e2bcd8739ae039({ section: section, index: index, total: total, onUpdate: onUpdate, onRemove: onRemove, onMoveUp: onMoveUp, onMoveDown: onMoveDown }) {
    const [expanded, setExpanded] = (0, $acw62.useState)(total === 1);
    const [confirmDelete, setConfirmDelete] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (!confirmDelete) return;
        const handleKey = (e)=>{
            if (e.key === "Escape") setConfirmDelete(false);
        };
        document.addEventListener("keydown", handleKey);
        return ()=>document.removeEventListener("keydown", handleKey);
    }, [
        confirmDelete
    ]);
    const typeInfo = (0, $114ba18d47d96a33$export$1e5c4f2c7d35f342).get(section.type);
    const typeLabel = typeInfo?.label || section.type;
    const typeColor = typeInfo?.color || "bg-gray-100 text-gray-700";
    const preview = $b2e6f160ae3cb6b3$var$getPreview(section);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "border border-gray-200 rounded-lg bg-white shadow-sm",
        onKeyDown: (e)=>{
            // Escape here cancels the inline delete confirm; it must not bubble to
            // the surrounding ModalScreen and close the whole editor.
            if (confirmDelete && e.key === "Escape") {
                e.stopPropagation();
                setConfirmDelete(false);
            }
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center gap-2 px-4 py-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        type: "button",
                        onClick: ()=>setExpanded(!expanded),
                        "aria-expanded": expanded,
                        "aria-controls": `section-body-${section._id}`,
                        className: "flex items-center gap-2 flex-1 text-left min-w-0",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "shrink-0",
                                children: expanded ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b397e876e35a9277$export$2e2bcd8739ae039), {
                                    size: 16,
                                    className: "text-gray-400"
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                    size: 16,
                                    className: "text-gray-400"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: `px-2 py-0.5 rounded text-xs font-medium shrink-0 ${typeColor}`,
                                children: typeLabel
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "text-sm text-gray-600 truncate min-w-0",
                                children: expanded ? typeLabel : preview
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-1 shrink-0",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                onClick: ()=>onMoveUp(section._id),
                                disabled: index === 0,
                                className: "p-1 text-gray-400 hover:text-gray-600 disabled:opacity-30 disabled:cursor-not-allowed",
                                "aria-label": "Mover sec\xe7\xe3o para cima",
                                title: "Mover para cima",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f05f6a77fc593bc$export$2e2bcd8739ae039), {
                                    size: 16
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                onClick: ()=>onMoveDown(section._id),
                                disabled: index === total - 1,
                                className: "p-1 text-gray-400 hover:text-gray-600 disabled:opacity-30 disabled:cursor-not-allowed",
                                "aria-label": "Mover sec\xe7\xe3o para baixo",
                                title: "Mover para baixo",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $008e11cf932a0927$export$2e2bcd8739ae039), {
                                    size: 16
                                })
                            }),
                            confirmDelete ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "flex items-center gap-1.5 text-xs bg-red-50 px-2 py-1 rounded-md",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "text-red-600",
                                        children: "Remover?"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>{
                                            onRemove(section._id);
                                            setConfirmDelete(false);
                                        },
                                        className: "text-red-700 font-medium hover:underline",
                                        children: "Sim"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>setConfirmDelete(false),
                                        className: "text-gray-500 hover:underline",
                                        children: "N\xe3o"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                onClick: ()=>setConfirmDelete(true),
                                className: "p-1 text-red-400 hover:text-red-600",
                                "aria-label": "Remover sec\xe7\xe3o",
                                title: "Remover sec\xe7\xe3o",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                    size: 16
                                })
                            })
                        ]
                    })
                ]
            }),
            expanded && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                id: `section-body-${section._id}`,
                className: "px-4 pb-4 border-t border-gray-100 pt-3",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $60cd466144a1b462$export$2e2bcd8739ae039), {
                    type: section.type,
                    data: section,
                    onChange: (data)=>onUpdate(section._id, data)
                })
            })
        ]
    });
}


function $7cc716dba0e7033d$export$567fc7097e064344() {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") return crypto.randomUUID();
    return `${Date.now()}-${Math.random().toString(36).substring(2, 11)}`;
}



function $c3569a9429bebb60$export$2e2bcd8739ae039({ sections: sections, onChange: onChange }) {
    const [showModal, setShowModal] = (0, $acw62.useState)(false);
    const modalRef = (0, $acw62.useRef)(null);
    const openButtonRef = (0, $acw62.useRef)(null);
    const closeModal = (0, $acw62.useCallback)(()=>{
        setShowModal(false);
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (showModal) return;
        openButtonRef.current?.focus();
    }, [
        showModal
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!showModal) return;
        const handleKeyDown = (e)=>{
            if (e.key === "Escape") {
                closeModal();
                return;
            }
            if (e.key !== "Tab" || !modalRef.current) return;
            const focusable = modalRef.current.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
            if (focusable.length === 0) return;
            const first = focusable[0];
            const last = focusable[focusable.length - 1];
            if (e.shiftKey && document.activeElement === first) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
                e.preventDefault();
                first.focus();
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        const scrollY = window.scrollY;
        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        const title = modalRef.current?.querySelector("#add-section-modal-title");
        title?.focus();
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
            document.body.style.overflow = prevOverflow || "";
            window.scrollTo(0, scrollY);
        };
    }, [
        showModal,
        closeModal
    ]);
    const handleAdd = (0, $acw62.useCallback)((type)=>{
        const info = (0, $114ba18d47d96a33$export$1e5c4f2c7d35f342).get(type);
        if (!info) return;
        setShowModal(false);
        const newSection = {
            _id: (0, $7cc716dba0e7033d$export$567fc7097e064344)(),
            type: type,
            ...info.createDefault()
        };
        onChange([
            ...sections,
            newSection
        ]);
    }, [
        sections,
        onChange
    ]);
    const handleUpdate = (0, $acw62.useCallback)((id, data)=>{
        if (!id) return;
        onChange(sections.map((s)=>s._id === id ? {
                ...s,
                ...data
            } : s));
    }, [
        sections,
        onChange
    ]);
    const handleRemove = (0, $acw62.useCallback)((id)=>{
        if (!id) return;
        onChange(sections.filter((s)=>s._id !== id));
    }, [
        sections,
        onChange
    ]);
    const handleMoveUp = (0, $acw62.useCallback)((id)=>{
        if (!id) return;
        const idx = sections.findIndex((s)=>s._id === id);
        if (idx === -1 || idx === 0) return;
        const copy = [
            ...sections
        ];
        [copy[idx - 1], copy[idx]] = [
            copy[idx],
            copy[idx - 1]
        ];
        onChange(copy);
    }, [
        sections,
        onChange
    ]);
    const handleMoveDown = (0, $acw62.useCallback)((id)=>{
        if (!id) return;
        const idx = sections.findIndex((s)=>s._id === id);
        if (idx === -1 || idx >= sections.length - 1) return;
        const copy = [
            ...sections
        ];
        [copy[idx], copy[idx + 1]] = [
            copy[idx + 1],
            copy[idx]
        ];
        onChange(copy);
    }, [
        sections,
        onChange
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "space-y-3",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                "aria-hidden": showModal || undefined,
                children: [
                    sections.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "text-sm text-gray-500 text-center py-6 bg-gray-50 rounded-lg border border-dashed border-gray-300",
                        children: "Nenhuma sec\xe7\xe3o definida. Clique no bot\xe3o abaixo para adicionar."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "space-y-2",
                        children: sections.map((section, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $b2e6f160ae3cb6b3$export$2e2bcd8739ae039), {
                                section: section,
                                index: index,
                                total: sections.length,
                                onUpdate: handleUpdate,
                                onRemove: handleRemove,
                                onMoveUp: handleMoveUp,
                                onMoveDown: handleMoveDown
                            }, section._id))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                ref: openButtonRef,
                type: "button",
                onClick: ()=>setShowModal(true),
                className: "w-full flex items-center justify-center gap-2 px-4 py-3 border-2 border-dashed border-gray-300 rounded-lg text-sm text-gray-500 hover:text-blue-600 hover:border-blue-400 transition",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                        size: 16
                    }),
                    " Adicionar Sec\xe7\xe3o"
                ]
            }),
            showModal && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "fixed inset-0 z-50 flex items-center justify-center bg-black/50",
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": "add-section-modal-title",
                onClick: closeModal,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    ref: modalRef,
                    className: "bg-white rounded-lg shadow-xl max-w-lg w-full mx-4 max-h-[80vh] flex flex-col",
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex items-center justify-between px-6 py-4 border-b",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    id: "add-section-modal-title",
                                    className: "text-lg font-medium text-gray-800",
                                    tabIndex: -1,
                                    children: "Adicionar Sec\xe7\xe3o"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    type: "button",
                                    onClick: closeModal,
                                    className: "p-1 text-gray-400 hover:text-gray-600",
                                    "aria-label": "Fechar",
                                    title: "Fechar",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                        size: 20
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "px-6 py-4 overflow-y-auto grid grid-cols-1 sm:grid-cols-2 gap-3",
                            children: (0, $114ba18d47d96a33$export$9c3e0a77c247e0c).map((info)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    type: "button",
                                    onClick: ()=>handleAdd(info.type),
                                    className: "flex flex-col items-center gap-2 p-4 border border-gray-200 rounded-lg hover:border-blue-400 hover:bg-blue-50 transition text-center",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "text-gray-600",
                                            "aria-hidden": "true",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)(info.Icon, {
                                                size: 20
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "font-medium text-sm text-gray-800",
                                            children: info.label
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "text-xs text-gray-500 leading-tight",
                                            children: info.description
                                        })
                                    ]
                                }, info.type))
                        })
                    ]
                })
            })
        ]
    });
}



const $e9c57bede7d2ead2$var$SLUG_REGEX = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
const $e9c57bede7d2ead2$var$CmsPageEditor = ({ page: page, onSave: onSave, setError: setError })=>{
    const [slug, setSlug] = (0, $acw62.useState)("");
    const [title, setTitle] = (0, $acw62.useState)("");
    const [seoTitle, setSeoTitle] = (0, $acw62.useState)("");
    const [seoDescription, setSeoDescription] = (0, $acw62.useState)("");
    const [sections, setSections] = (0, $acw62.useState)([]);
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [revalidating, setRevalidating] = (0, $acw62.useState)(false);
    const [revalidated, setRevalidated] = (0, $acw62.useState)(false);
    const [isDirty, setIsDirty] = (0, $acw62.useState)(false);
    const markDirty = (0, $acw62.useCallback)(()=>{
        if (!isDirty) setIsDirty(true);
    }, [
        isDirty
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!isDirty) return;
        const handler = (e)=>{
            e.preventDefault();
            e.returnValue = "";
        };
        window.addEventListener("beforeunload", handler);
        return ()=>window.removeEventListener("beforeunload", handler);
    }, [
        isDirty
    ]);
    (0, $acw62.useEffect)(()=>{
        setIsDirty(false);
        if (page) {
            setSlug(page.slug);
            setTitle(page.title || "");
            setSeoTitle(page.seo_title || "");
            setSeoDescription(page.seo_description || "");
            setSections(page.sections.map((s)=>({
                    _id: (0, $7cc716dba0e7033d$export$567fc7097e064344)(),
                    ...s
                })));
        } else {
            setSlug("");
            setTitle("");
            setSeoTitle("");
            setSeoDescription("");
            setSections([]);
        }
    }, [
        page?.slug
    ]);
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setError(null);
        const trimmedSlug = slug.trim();
        if (!trimmedSlug) {
            setError("O slug \xe9 obrigat\xf3rio.");
            return;
        }
        if (!$e9c57bede7d2ead2$var$SLUG_REGEX.test(trimmedSlug)) {
            setError("O slug s\xf3 pode conter letras min\xfasculas, n\xfameros e h\xedfens (ex: minha-pagina).");
            return;
        }
        const trimmedTitle = title.trim();
        if (!trimmedTitle) {
            setError("O t\xedtulo \xe9 obrigat\xf3rio.");
            return;
        }
        if (sections.length === 0) {
            setError("Adicione pelo menos uma sec\xe7\xe3o \xe0 p\xe1gina.");
            return;
        }
        for (const s of sections)if (!s.type) {
            setError("Todas as sec\xe7\xf5es precisam de um tipo definido.");
            return;
        }
        setSaving(true);
        try {
            const payload = {
                title: trimmedTitle,
                sections: sections.map(({ _id: _id, ...rest })=>rest)
            };
            const trimmedSeoTitle = seoTitle.trim();
            const trimmedSeoDesc = seoDescription.trim();
            if (trimmedSeoTitle) payload.seo_title = trimmedSeoTitle;
            if (trimmedSeoDesc) payload.seo_description = trimmedSeoDesc;
            const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).put(`${(0, $cd93687958c8007e$export$bfe19bc25132bb7c).CMS_ADMIN}/${trimmedSlug}`, payload);
            setIsDirty(false);
            onSave(res.data);
        } catch (e) {
            setError((0, $1dc90ddccfa14c0f$export$d6cf8ca521a17a2)(e, "Erro ao guardar p\xe1gina."));
        } finally{
            setSaving(false);
        }
    };
    const handleRevalidate = async ()=>{
        if (!page) return;
        setRevalidating(true);
        setRevalidated(false);
        setError(null);
        try {
            const res = await fetch("/api/internal/revalidate", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    tags: [
                        `page-${page.slug}`
                    ]
                })
            });
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            setRevalidated(true);
            setTimeout(()=>setRevalidated(false), 3000);
        } catch  {
            setError("Erro ao revalidar cache. Verifique se o site est\xe1 acess\xedvel.");
        } finally{
            setRevalidating(false);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
        onSubmit: handleSubmit,
        className: "space-y-6 p-6 max-w-3xl",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                        htmlFor: "cms-slug",
                        className: "block text-sm font-medium text-gray-700 mb-2",
                        children: "Slug *"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        id: "cms-slug",
                        type: "text",
                        value: slug,
                        onChange: (e)=>{
                            setSlug(e.target.value);
                            markDirty();
                        },
                        disabled: !!page,
                        required: true,
                        className: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100 disabled:text-gray-500",
                        placeholder: "nome-da-pagina"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "text-xs text-gray-500 mt-1",
                        children: "Identificador \xfanico da p\xe1gina (ex: termos, privacidade). Apenas letras min\xfasculas, n\xfameros e h\xedfens. N\xe3o pode ser alterado ap\xf3s cria\xe7\xe3o."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                        htmlFor: "cms-title",
                        className: "block text-sm font-medium text-gray-700 mb-2",
                        children: "T\xedtulo *"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        id: "cms-title",
                        type: "text",
                        value: title,
                        onChange: (e)=>{
                            setTitle(e.target.value);
                            markDirty();
                        },
                        required: true,
                        className: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500",
                        placeholder: "T\xedtulo da p\xe1gina"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                        htmlFor: "cms-seo-title",
                        className: "block text-sm font-medium text-gray-700 mb-2",
                        children: "SEO Title"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        id: "cms-seo-title",
                        type: "text",
                        value: seoTitle,
                        onChange: (e)=>{
                            setSeoTitle(e.target.value);
                            markDirty();
                        },
                        className: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500",
                        placeholder: "T\xedtulo SEO (opcional)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                        htmlFor: "cms-seo-desc",
                        className: "block text-sm font-medium text-gray-700 mb-2",
                        children: "SEO Description"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                        id: "cms-seo-desc",
                        value: seoDescription,
                        onChange: (e)=>{
                            setSeoDescription(e.target.value);
                            markDirty();
                        },
                        rows: 3,
                        className: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500",
                        placeholder: "Descri\xe7\xe3o SEO (opcional)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                        className: "block text-sm font-medium text-gray-700 mb-2",
                        children: "Sec\xe7\xf5es"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c3569a9429bebb60$export$2e2bcd8739ae039), {
                        sections: sections,
                        onChange: (v)=>{
                            setSections(v);
                            markDirty();
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "text-xs text-gray-500 mt-1",
                        children: "As sec\xe7\xf5es s\xe3o apresentadas por ordem. Use as setas para reordenar."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex gap-3 pt-4 border-t",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        type: "submit",
                        disabled: saving,
                        className: "flex-1 bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition",
                        children: saving ? "A guardar..." : page ? "Atualizar P\xe1gina" : "Criar P\xe1gina"
                    }),
                    page && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        type: "button",
                        onClick: handleRevalidate,
                        disabled: revalidating,
                        className: "px-4 py-2 rounded-md border border-gray-300 text-sm text-gray-600 hover:bg-gray-50 disabled:opacity-50 transition",
                        children: revalidating ? "A revalidar..." : revalidated ? "Cache limpo \u2713" : "Revalidar Cache"
                    })
                ]
            })
        ]
    });
};
var $e9c57bede7d2ead2$export$2e2bcd8739ae039 = $e9c57bede7d2ead2$var$CmsPageEditor;


const $3e8d5a5a452800c9$var$CmsAdminPage = ()=>{
    const { profile: profile, isAuthenticated: isAuthenticated } = (0, $b622ef53e38024e7$export$1d39dc5b47e56ff0)();
    const { setModalScreen: setModalScreen, setError: setError, setSuccess: setSuccess } = (0, $a55f2a94cd420149$export$c50e37a2f0a2b064)();
    const [userProfile, setUserProfile] = (0, $acw62.useState)(null);
    const [profileLoading, setProfileLoading] = (0, $acw62.useState)(true);
    const [pages, setPages] = (0, $acw62.useState)([]);
    const [pagesLoading, setPagesLoading] = (0, $acw62.useState)(false);
    // ── Multi-tenant selection (ADR-021) ─────────────────────────────────────
    // CMS pages are per-tenant; switching tenant refetches the list.
    const { tenants: tenants, selectedTenant: selectedTenant, selectTenant: selectTenant } = (0, $d3c233bd9ac99dda$export$d4c94cedb7152d21)();
    (0, $acw62.useEffect)(()=>{
        profile().then((p)=>{
            setUserProfile(p);
            setProfileLoading(false);
        }).catch(()=>setProfileLoading(false));
    }, [
        profile
    ]);
    const fetchPages = (0, $acw62.useCallback)(async ()=>{
        setPagesLoading(true);
        setError(null);
        try {
            const res = await (0, $bac44633733ff026$export$2e2bcd8739ae039).get((0, $cd93687958c8007e$export$bfe19bc25132bb7c).CMS_ADMIN);
            setPages(res.data.data || []);
        } catch (e) {
            setError((0, $1dc90ddccfa14c0f$export$d6cf8ca521a17a2)(e, "Erro ao carregar p\xe1ginas CMS."));
        } finally{
            setPagesLoading(false);
        }
    }, [
        setError
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!profileLoading && userProfile) fetchPages();
    }, [
        profileLoading,
        userProfile,
        fetchPages
    ]);
    const handlePageUpdated = (0, $acw62.useCallback)((page)=>{
        setPages((prev)=>{
            const idx = prev.findIndex((p)=>p.slug === page.slug);
            if (idx >= 0) {
                const next = [
                    ...prev
                ];
                next[idx] = page;
                return next;
            }
            return [
                page,
                ...prev
            ];
        });
        setSuccess(`P\xe1gina "${page.title}" atualizada com sucesso!`);
    }, [
        setSuccess
    ]);
    const handlePageDeleted = (0, $acw62.useCallback)((page)=>{
        setPages((prev)=>prev.filter((p)=>p.slug !== page.slug));
        setSuccess(`P\xe1gina "${page.title}" apagada com sucesso!`);
    }, [
        setSuccess
    ]);
    const openEditor = (0, $acw62.useCallback)((page)=>{
        setModalScreen({
            state: "big-view",
            title: page ? `Editar: ${page.slug}` : "Nova p\xe1gina CMS",
            childrenControlOverflow: true,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e9c57bede7d2ead2$export$2e2bcd8739ae039), {
                page: page,
                onSave: (saved)=>{
                    handlePageUpdated(saved);
                    setModalScreen(null);
                },
                setError: setError
            }),
            onClose: ()=>setModalScreen(null)
        });
    }, [
        setModalScreen,
        handlePageUpdated,
        setError
    ]);
    if (!isAuthenticated()) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$444b3ab0cb9aec40), {
        to: "/login",
        replace: true
    });
    if (profileLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex items-center justify-center p-12 text-gray-500",
        children: "A carregar..."
    });
    if (!userProfile?.isAdmin()) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$444b3ab0cb9aec40), {
        to: "/",
        replace: true
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "container mx-auto px-4 py-8",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "bg-white shadow rounded-lg p-6",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                    className: "text-2xl font-bold text-gray-800",
                                    children: "Gest\xe3o de Conte\xfados CMS"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "text-gray-500 text-sm mt-1",
                                    children: "Gerir p\xe1ginas de conte\xfado do site p\xfablico (eurosys.pt)."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>openEditor(),
                            className: "bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg font-medium transition",
                            children: "+ Nova P\xe1gina"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "mb-6 max-w-xs",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9e71da29c945043$export$2e2bcd8739ae039), {
                        tenants: tenants,
                        value: selectedTenant,
                        onChange: (t)=>{
                            selectTenant(t);
                            fetchPages();
                        }
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b03ff2b972a18f42$export$2e2bcd8739ae039), {
                    pages: pages,
                    loading: pagesLoading,
                    onEdit: openEditor,
                    onDelete: handlePageDeleted,
                    setError: setError
                })
            ]
        })
    });
};
var $3e8d5a5a452800c9$export$2e2bcd8739ae039 = $3e8d5a5a452800c9$var$CmsAdminPage;


const $cd93687958c8007e$var$API_BASE_URL = "";
const $cd93687958c8007e$export$bfe19bc25132bb7c = {
    API_BASE_URL: $cd93687958c8007e$var$API_BASE_URL,
    LOGIN: `${$cd93687958c8007e$var$API_BASE_URL}/auth/login`,
    PROFILE: `${$cd93687958c8007e$var$API_BASE_URL}/auth/profile`,
    MFA_VERIFY: `${$cd93687958c8007e$var$API_BASE_URL}/auth/mfa/verify`,
    MFA_RESEND_OTP: `${$cd93687958c8007e$var$API_BASE_URL}/auth/mfa/resend-otp`,
    MFA_STATUS: `${$cd93687958c8007e$var$API_BASE_URL}/auth/mfa/status`,
    MFA_ENROLL: `${$cd93687958c8007e$var$API_BASE_URL}/auth/mfa/enroll`,
    MFA_ENROLL_CONFIRM: `${$cd93687958c8007e$var$API_BASE_URL}/auth/mfa/enroll/confirm`,
    MFA_CONFIRM: `${$cd93687958c8007e$var$API_BASE_URL}/auth/mfa/confirm`,
    MFA_DISABLE: `${$cd93687958c8007e$var$API_BASE_URL}/auth/mfa/disable`,
    SETTINGS: `${$cd93687958c8007e$var$API_BASE_URL}/settings`,
    CATALOG: `${$cd93687958c8007e$var$API_BASE_URL}/catalog`,
    IMPORT: `${$cd93687958c8007e$var$API_BASE_URL}/compounds/_import`,
    COMPOUNDS: `${$cd93687958c8007e$var$API_BASE_URL}/compounds`,
    PRODUCTS: `${$cd93687958c8007e$var$API_BASE_URL}/products`,
    OFFERS: `${$cd93687958c8007e$var$API_BASE_URL}/offers`,
    ORDERS: `${$cd93687958c8007e$var$API_BASE_URL}/orders`,
    USERS: `${$cd93687958c8007e$var$API_BASE_URL}/users/`,
    NOTES: `${$cd93687958c8007e$var$API_BASE_URL}/notes`,
    MINISITE_CONFIG: `${$cd93687958c8007e$var$API_BASE_URL}/microsite/configuration`,
    HIGHLIGHTS: `${$cd93687958c8007e$var$API_BASE_URL}/highlights`,
    CATEGORIES: `${$cd93687958c8007e$var$API_BASE_URL}/categories`,
    OMS_ADMIN_ORDERS: `/oms/admin/orders`,
    OMS_PROPOSALS: `/oms/admin/orders`,
    PAYMENT_ATTEMPTS: `/payment/api/v1/payments`,
    SHIPPING_CARRIERS: `/shipping/api/v1/carriers`,
    SHIPPING_ZONES: `/shipping/api/v1/zones`,
    PAYMENT_PROVIDER_CONFIGS: `/payment/api/v1/providers/configs`,
    PAYMENT_ROUTES: `/payment/api/v1/routes`,
    OMS_DELIVERY_METHODS: `/oms/admin/delivery-methods`,
    CAMPAIGNS: `${$cd93687958c8007e$var$API_BASE_URL}/campaigns`,
    CMS_ADMIN: `/cms-admin/api/v1/pages`,
    NEWSLETTER_ADMIN: `/newsletter-admin/api/v1`,
    CATALOG_ADMIN: `/catalog-admin`
};
const $cd93687958c8007e$export$59d79bb5806aec95 = 1.23;
const $cd93687958c8007e$export$b6cd510719465167 = [
    [
        "placa_grafica",
        "Gpu",
        "Placa Gr\xe1fica"
    ],
    [
        "processador",
        "Cpu",
        "Processador"
    ],
    [
        "motherboard",
        "CircuitBoard",
        "Motherboard"
    ],
    [
        "memoria",
        "MemoryStick",
        "Memoria"
    ],
    [
        "ssd1",
        "HardDrive",
        "Storage 1"
    ],
    [
        "ssd2",
        "HardDrive",
        "Storage 2"
    ],
    [
        "cooler",
        "Fan",
        "Cooler"
    ],
    [
        "fans_1",
        "Fan",
        "Fan 1"
    ],
    [
        "fans_2",
        "Fan",
        "Fan 2"
    ],
    [
        "fans_3",
        "Fan",
        "Fan 3"
    ],
    [
        "caixa",
        "PcCase",
        "Caixa"
    ],
    [
        "fonte",
        "Power",
        "Fonte de Alimenta\xe7\xe3o"
    ],
    [
        "y_argb",
        "rainbow",
        "Y ARGB"
    ],
    [
        "y_pwr_fan",
        "Fan",
        "Y Power Fan"
    ],
    [
        "placa_wifi",
        "Wifi",
        "Placa Wifi"
    ],
    [
        "monitor",
        "Monitor",
        "Monitor"
    ],
    [
        "teclado",
        "Keyboard",
        "Teclado"
    ],
    [
        "rato",
        "Mouse",
        "Rato"
    ],
    [
        "sist__operativo",
        "Rocket",
        "Sistema Operativo"
    ],
    [
        "outros",
        "Other",
        "Outros"
    ]
];
function $cd93687958c8007e$export$96c53945a697e37(key) {
    const component = $cd93687958c8007e$export$b6cd510719465167.find((c)=>c[0] === key);
    return component ? component[2] : key;
}
const $cd93687958c8007e$var$App = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b622ef53e38024e7$export$87091915187a1a85), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a55f2a94cd420149$export$94811c40c55f3d65), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$9ba4e89fdfa1fc54), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $585f8bce88e531c1$export$3565eb3d00ca5a74), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$e7b0ac011bb776c6), {
                            path: "/oauth/callback",
                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ad8734dfcdf3d44$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$e7b0ac011bb776c6), {
                            path: "/reviews/:reviewId",
                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $50d6ea96af6e95ce$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$e7b0ac011bb776c6), {
                            path: "*",
                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a3d53d3a3becf406$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $585f8bce88e531c1$export$3565eb3d00ca5a74), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$e7b0ac011bb776c6), {
                                            path: "/login",
                                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $426e52f8305c025b$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$e7b0ac011bb776c6), {
                                            path: "/logout",
                                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $426e52f8305c025b$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$e7b0ac011bb776c6), {
                                            path: "/pc/:id",
                                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ccaa2522ab1042a6$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$e7b0ac011bb776c6), {
                                            path: "/comparar/:pcIds",
                                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7181e2acc0f2e919$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$e7b0ac011bb776c6), {
                                            path: "/offers",
                                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dad5fa862effa7ab$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$e7b0ac011bb776c6), {
                                            path: "/offers/:id",
                                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dad5fa862effa7ab$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$e7b0ac011bb776c6), {
                                            path: "/orders",
                                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8475c91e39555ea7$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$e7b0ac011bb776c6), {
                                            path: "/orders/:id",
                                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8475c91e39555ea7$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$e7b0ac011bb776c6), {
                                            path: "/catalog",
                                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $207fd09cab7d7eb8$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$e7b0ac011bb776c6), {
                                            path: "/catalog/import",
                                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $98525b551a56d1de$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$e7b0ac011bb776c6), {
                                            path: "/catalog/compound/:id",
                                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $52125b4485a7e10a$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$e7b0ac011bb776c6), {
                                            path: "/catalog/show_components_mismatched_prices",
                                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f2352b268a4165fb$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$e7b0ac011bb776c6), {
                                            path: "/catalog/show_components_out_of_stock",
                                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9eaf012e3d5a9bf1$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$e7b0ac011bb776c6), {
                                            path: "/settings",
                                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $97e9c2760dd1027f$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$e7b0ac011bb776c6), {
                                            path: "/minisite",
                                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $970f571137db010d$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$e7b0ac011bb776c6), {
                                            path: "/highlights",
                                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9eec85814b628b75$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$e7b0ac011bb776c6), {
                                            path: "/categories",
                                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b2e01565dad3fb01$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5e9e435a10d3c9d3$export$2e2bcd8739ae039), {})
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$e7b0ac011bb776c6), {
                                            path: "/users",
                                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3c985caf6fe449d7$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$e7b0ac011bb776c6), {
                                            path: "/admin/reviews",
                                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7dccff3eb6cbef5a$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$e7b0ac011bb776c6), {
                                            path: "/oms-orders",
                                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b3abea07440ed551$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$e7b0ac011bb776c6), {
                                            path: "/oms-orders/:orderId",
                                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b3abea07440ed551$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$e7b0ac011bb776c6), {
                                            path: "/oms-proposals",
                                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2bfc9d2123736d07$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$e7b0ac011bb776c6), {
                                            path: "/oms-proposals/:id",
                                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2bfc9d2123736d07$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$e7b0ac011bb776c6), {
                                            path: "/public-site",
                                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $15141d21a167b494$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$e7b0ac011bb776c6), {
                                            path: "/campaigns",
                                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $308104e624282612$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$e7b0ac011bb776c6), {
                                            path: "/campaigns/new",
                                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d4abd160bf87ee5$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$e7b0ac011bb776c6), {
                                            path: "/campaigns/:id",
                                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d4abd160bf87ee5$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$e7b0ac011bb776c6), {
                                            path: "/cms-admin",
                                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3e8d5a5a452800c9$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$e7b0ac011bb776c6), {
                                            path: "/",
                                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $26f70be055e85cab$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $585f8bce88e531c1$export$e7b0ac011bb776c6), {
                                            path: "*",
                                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f2c236c700eed7f6$export$2e2bcd8739ae039), {})
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};
var $cd93687958c8007e$export$2e2bcd8739ae039 = $cd93687958c8007e$var$App;




/* eslint-disable no-prototype-builtins */ var $b36292f2972695f1$var$g = typeof globalThis !== 'undefined' && globalThis || typeof self !== 'undefined' && self || // eslint-disable-next-line no-undef
typeof $parcel$global !== 'undefined' && $parcel$global || {};
var $b36292f2972695f1$var$support = {
    searchParams: 'URLSearchParams' in $b36292f2972695f1$var$g,
    iterable: 'Symbol' in $b36292f2972695f1$var$g && 'iterator' in Symbol,
    blob: 'FileReader' in $b36292f2972695f1$var$g && 'Blob' in $b36292f2972695f1$var$g && function() {
        try {
            new Blob();
            return true;
        } catch (e) {
            return false;
        }
    }(),
    formData: 'FormData' in $b36292f2972695f1$var$g,
    arrayBuffer: 'ArrayBuffer' in $b36292f2972695f1$var$g
};
function $b36292f2972695f1$var$isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj);
}
if ($b36292f2972695f1$var$support.arrayBuffer) {
    var $b36292f2972695f1$var$viewClasses = [
        '[object Int8Array]',
        '[object Uint8Array]',
        '[object Uint8ClampedArray]',
        '[object Int16Array]',
        '[object Uint16Array]',
        '[object Int32Array]',
        '[object Uint32Array]',
        '[object Float32Array]',
        '[object Float64Array]'
    ];
    var $b36292f2972695f1$var$isArrayBufferView = ArrayBuffer.isView || function(obj) {
        return obj && $b36292f2972695f1$var$viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
    };
}
function $b36292f2972695f1$var$normalizeName(name) {
    if (typeof name !== 'string') name = String(name);
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') throw new TypeError('Invalid character in header field name: "' + name + '"');
    return name.toLowerCase();
}
function $b36292f2972695f1$var$normalizeValue(value) {
    if (typeof value !== 'string') value = String(value);
    return value;
}
// Build a destructive iterator for the value list
function $b36292f2972695f1$var$iteratorFor(items) {
    var iterator = {
        next: function() {
            var value = items.shift();
            return {
                done: value === undefined,
                value: value
            };
        }
    };
    if ($b36292f2972695f1$var$support.iterable) iterator[Symbol.iterator] = function() {
        return iterator;
    };
    return iterator;
}
function $b36292f2972695f1$export$79b704688b15c0f4(headers) {
    this.map = {};
    if (headers instanceof $b36292f2972695f1$export$79b704688b15c0f4) headers.forEach(function(value, name) {
        this.append(name, value);
    }, this);
    else if (Array.isArray(headers)) headers.forEach(function(header) {
        if (header.length != 2) throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length);
        this.append(header[0], header[1]);
    }, this);
    else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
    }, this);
}
$b36292f2972695f1$export$79b704688b15c0f4.prototype.append = function(name, value) {
    name = $b36292f2972695f1$var$normalizeName(name);
    value = $b36292f2972695f1$var$normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
};
$b36292f2972695f1$export$79b704688b15c0f4.prototype['delete'] = function(name) {
    delete this.map[$b36292f2972695f1$var$normalizeName(name)];
};
$b36292f2972695f1$export$79b704688b15c0f4.prototype.get = function(name) {
    name = $b36292f2972695f1$var$normalizeName(name);
    return this.has(name) ? this.map[name] : null;
};
$b36292f2972695f1$export$79b704688b15c0f4.prototype.has = function(name) {
    return this.map.hasOwnProperty($b36292f2972695f1$var$normalizeName(name));
};
$b36292f2972695f1$export$79b704688b15c0f4.prototype.set = function(name, value) {
    this.map[$b36292f2972695f1$var$normalizeName(name)] = $b36292f2972695f1$var$normalizeValue(value);
};
$b36292f2972695f1$export$79b704688b15c0f4.prototype.forEach = function(callback, thisArg) {
    for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
};
$b36292f2972695f1$export$79b704688b15c0f4.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push(name);
    });
    return $b36292f2972695f1$var$iteratorFor(items);
};
$b36292f2972695f1$export$79b704688b15c0f4.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
        items.push(value);
    });
    return $b36292f2972695f1$var$iteratorFor(items);
};
$b36292f2972695f1$export$79b704688b15c0f4.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push([
            name,
            value
        ]);
    });
    return $b36292f2972695f1$var$iteratorFor(items);
};
if ($b36292f2972695f1$var$support.iterable) $b36292f2972695f1$export$79b704688b15c0f4.prototype[Symbol.iterator] = $b36292f2972695f1$export$79b704688b15c0f4.prototype.entries;
function $b36292f2972695f1$var$consumed(body) {
    if (body._noBody) return;
    if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
    body.bodyUsed = true;
}
function $b36292f2972695f1$var$fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
        reader.onload = function() {
            resolve(reader.result);
        };
        reader.onerror = function() {
            reject(reader.error);
        };
    });
}
function $b36292f2972695f1$var$readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = $b36292f2972695f1$var$fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
}
function $b36292f2972695f1$var$readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = $b36292f2972695f1$var$fileReaderReady(reader);
    var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
    var encoding = match ? match[1] : 'utf-8';
    reader.readAsText(blob, encoding);
    return promise;
}
function $b36292f2972695f1$var$readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);
    for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
    return chars.join('');
}
function $b36292f2972695f1$var$bufferClone(buf) {
    if (buf.slice) return buf.slice(0);
    else {
        var view = new Uint8Array(buf.byteLength);
        view.set(new Uint8Array(buf));
        return view.buffer;
    }
}
function $b36292f2972695f1$var$Body() {
    this.bodyUsed = false;
    this._initBody = function(body) {
        /*
      fetch-mock wraps the Response object in an ES6 Proxy to
      provide useful test harness features such as flush. However, on
      ES5 browsers without fetch or Proxy support pollyfills must be used;
      the proxy-pollyfill is unable to proxy an attribute unless it exists
      on the object before the Proxy is created. This change ensures
      Response.bodyUsed exists on the instance, while maintaining the
      semantic of setting Request.bodyUsed in the constructor before
      _initBody is called.
    */ // eslint-disable-next-line no-self-assign
        this.bodyUsed = this.bodyUsed;
        this._bodyInit = body;
        if (!body) {
            this._noBody = true;
            this._bodyText = '';
        } else if (typeof body === 'string') this._bodyText = body;
        else if ($b36292f2972695f1$var$support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
        else if ($b36292f2972695f1$var$support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
        else if ($b36292f2972695f1$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
        else if ($b36292f2972695f1$var$support.arrayBuffer && $b36292f2972695f1$var$support.blob && $b36292f2972695f1$var$isDataView(body)) {
            this._bodyArrayBuffer = $b36292f2972695f1$var$bufferClone(body.buffer);
            // IE 10-11 can't handle a DataView body.
            this._bodyInit = new Blob([
                this._bodyArrayBuffer
            ]);
        } else if ($b36292f2972695f1$var$support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || $b36292f2972695f1$var$isArrayBufferView(body))) this._bodyArrayBuffer = $b36292f2972695f1$var$bufferClone(body);
        else this._bodyText = body = Object.prototype.toString.call(body);
        if (!this.headers.get('content-type')) {
            if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
            else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
            else if ($b36292f2972695f1$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
    };
    if ($b36292f2972695f1$var$support.blob) this.blob = function() {
        var rejected = $b36292f2972695f1$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
            this._bodyArrayBuffer
        ]));
        else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
        else return Promise.resolve(new Blob([
            this._bodyText
        ]));
    };
    this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
            var isConsumed = $b36292f2972695f1$var$consumed(this);
            if (isConsumed) return isConsumed;
            else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
            else return Promise.resolve(this._bodyArrayBuffer);
        } else if ($b36292f2972695f1$var$support.blob) return this.blob().then($b36292f2972695f1$var$readBlobAsArrayBuffer);
        else throw new Error('could not read as ArrayBuffer');
    };
    this.text = function() {
        var rejected = $b36292f2972695f1$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return $b36292f2972695f1$var$readBlobAsText(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve($b36292f2972695f1$var$readArrayBufferAsText(this._bodyArrayBuffer));
        else if (this._bodyFormData) throw new Error('could not read FormData body as text');
        else return Promise.resolve(this._bodyText);
    };
    if ($b36292f2972695f1$var$support.formData) this.formData = function() {
        return this.text().then($b36292f2972695f1$var$decode);
    };
    this.json = function() {
        return this.text().then(JSON.parse);
    };
    return this;
}
// HTTP methods whose capitalization should be normalized
var $b36292f2972695f1$var$methods = [
    'CONNECT',
    'DELETE',
    'GET',
    'HEAD',
    'OPTIONS',
    'PATCH',
    'POST',
    'PUT',
    'TRACE'
];
function $b36292f2972695f1$var$normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return $b36292f2972695f1$var$methods.indexOf(upcased) > -1 ? upcased : method;
}
function $b36292f2972695f1$export$7fa6c5b6f8193917(input, options) {
    if (!(this instanceof $b36292f2972695f1$export$7fa6c5b6f8193917)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    options = options || {};
    var body = options.body;
    if (input instanceof $b36292f2972695f1$export$7fa6c5b6f8193917) {
        if (input.bodyUsed) throw new TypeError('Already read');
        this.url = input.url;
        this.credentials = input.credentials;
        if (!options.headers) this.headers = new $b36292f2972695f1$export$79b704688b15c0f4(input.headers);
        this.method = input.method;
        this.mode = input.mode;
        this.signal = input.signal;
        if (!body && input._bodyInit != null) {
            body = input._bodyInit;
            input.bodyUsed = true;
        }
    } else this.url = String(input);
    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) this.headers = new $b36292f2972695f1$export$79b704688b15c0f4(options.headers);
    this.method = $b36292f2972695f1$var$normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal || function() {
        if ('AbortController' in $b36292f2972695f1$var$g) {
            var ctrl = new AbortController();
            return ctrl.signal;
        }
    }();
    this.referrer = null;
    if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
    this._initBody(body);
    if (this.method === 'GET' || this.method === 'HEAD') {
        if (options.cache === 'no-store' || options.cache === 'no-cache') {
            // Search for a '_' parameter in the query string
            var reParamSearch = /([?&])_=[^&]*/;
            if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
            this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
            else {
                // Otherwise add a new '_' parameter to the end with the current time
                var reQueryString = /\?/;
                this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
            }
        }
    }
}
$b36292f2972695f1$export$7fa6c5b6f8193917.prototype.clone = function() {
    return new $b36292f2972695f1$export$7fa6c5b6f8193917(this, {
        body: this._bodyInit
    });
};
function $b36292f2972695f1$var$decode(body) {
    var form = new FormData();
    body.trim().split('&').forEach(function(bytes) {
        if (bytes) {
            var split = bytes.split('=');
            var name = split.shift().replace(/\+/g, ' ');
            var value = split.join('=').replace(/\+/g, ' ');
            form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
    });
    return form;
}
function $b36292f2972695f1$var$parseHeaders(rawHeaders) {
    var headers = new $b36292f2972695f1$export$79b704688b15c0f4();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
    // https://github.com/github/fetch/issues/748
    // https://github.com/zloirock/core-js/issues/751
    preProcessedHeaders.split('\r').map(function(header) {
        return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header;
    }).forEach(function(line) {
        var parts = line.split(':');
        var key = parts.shift().trim();
        if (key) {
            var value = parts.join(':').trim();
            try {
                headers.append(key, value);
            } catch (error) {
                console.warn('Response ' + error.message);
            }
        }
    });
    return headers;
}
$b36292f2972695f1$var$Body.call($b36292f2972695f1$export$7fa6c5b6f8193917.prototype);
function $b36292f2972695f1$export$9f633d56d7ec90d3(bodyInit, options) {
    if (!(this instanceof $b36292f2972695f1$export$9f633d56d7ec90d3)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    if (!options) options = {};
    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
    this.headers = new $b36292f2972695f1$export$79b704688b15c0f4(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
}
$b36292f2972695f1$var$Body.call($b36292f2972695f1$export$9f633d56d7ec90d3.prototype);
$b36292f2972695f1$export$9f633d56d7ec90d3.prototype.clone = function() {
    return new $b36292f2972695f1$export$9f633d56d7ec90d3(this._bodyInit, {
        status: this.status,
        statusText: this.statusText,
        headers: new $b36292f2972695f1$export$79b704688b15c0f4(this.headers),
        url: this.url
    });
};
$b36292f2972695f1$export$9f633d56d7ec90d3.error = function() {
    var response = new $b36292f2972695f1$export$9f633d56d7ec90d3(null, {
        status: 200,
        statusText: ''
    });
    response.ok = false;
    response.status = 0;
    response.type = 'error';
    return response;
};
var $b36292f2972695f1$var$redirectStatuses = [
    301,
    302,
    303,
    307,
    308
];
$b36292f2972695f1$export$9f633d56d7ec90d3.redirect = function(url, status) {
    if ($b36292f2972695f1$var$redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
    return new $b36292f2972695f1$export$9f633d56d7ec90d3(null, {
        status: status,
        headers: {
            location: url
        }
    });
};
var $b36292f2972695f1$export$fe58bcf938607f6a = $b36292f2972695f1$var$g.DOMException;
try {
    new $b36292f2972695f1$export$fe58bcf938607f6a();
} catch (err) {
    $b36292f2972695f1$export$fe58bcf938607f6a = function(message, name) {
        this.message = message;
        this.name = name;
        var error = Error(message);
        this.stack = error.stack;
    };
    $b36292f2972695f1$export$fe58bcf938607f6a.prototype = Object.create(Error.prototype);
    $b36292f2972695f1$export$fe58bcf938607f6a.prototype.constructor = $b36292f2972695f1$export$fe58bcf938607f6a;
}
function $b36292f2972695f1$export$e7aa7bc5c1b3cfb3(input, init) {
    return new Promise(function(resolve, reject) {
        var request = new $b36292f2972695f1$export$7fa6c5b6f8193917(input, init);
        if (request.signal && request.signal.aborted) return reject(new $b36292f2972695f1$export$fe58bcf938607f6a('Aborted', 'AbortError'));
        var xhr = new XMLHttpRequest();
        function abortXhr() {
            xhr.abort();
        }
        xhr.onload = function() {
            var options = {
                statusText: xhr.statusText,
                headers: $b36292f2972695f1$var$parseHeaders(xhr.getAllResponseHeaders() || '')
            };
            // This check if specifically for when a user fetches a file locally from the file system
            // Only if the status is out of a normal range
            if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
            else options.status = xhr.status;
            options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
            var body = 'response' in xhr ? xhr.response : xhr.responseText;
            setTimeout(function() {
                resolve(new $b36292f2972695f1$export$9f633d56d7ec90d3(body, options));
            }, 0);
        };
        xhr.onerror = function() {
            setTimeout(function() {
                reject(new TypeError('Network request failed'));
            }, 0);
        };
        xhr.ontimeout = function() {
            setTimeout(function() {
                reject(new TypeError('Network request timed out'));
            }, 0);
        };
        xhr.onabort = function() {
            setTimeout(function() {
                reject(new $b36292f2972695f1$export$fe58bcf938607f6a('Aborted', 'AbortError'));
            }, 0);
        };
        function fixUrl(url) {
            try {
                return url === '' && $b36292f2972695f1$var$g.location.href ? $b36292f2972695f1$var$g.location.href : url;
            } catch (e) {
                return url;
            }
        }
        xhr.open(request.method, fixUrl(request.url), true);
        if (request.credentials === 'include') xhr.withCredentials = true;
        else if (request.credentials === 'omit') xhr.withCredentials = false;
        if ('responseType' in xhr) {
            if ($b36292f2972695f1$var$support.blob) xhr.responseType = 'blob';
            else if ($b36292f2972695f1$var$support.arrayBuffer) xhr.responseType = 'arraybuffer';
        }
        if (init && typeof init.headers === 'object' && !(init.headers instanceof $b36292f2972695f1$export$79b704688b15c0f4 || $b36292f2972695f1$var$g.Headers && init.headers instanceof $b36292f2972695f1$var$g.Headers)) {
            var names = [];
            Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                names.push($b36292f2972695f1$var$normalizeName(name));
                xhr.setRequestHeader(name, $b36292f2972695f1$var$normalizeValue(init.headers[name]));
            });
            request.headers.forEach(function(value, name) {
                if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
            });
        } else request.headers.forEach(function(value, name) {
            xhr.setRequestHeader(name, value);
        });
        if (request.signal) {
            request.signal.addEventListener('abort', abortXhr);
            xhr.onreadystatechange = function() {
                // DONE (success or failure)
                if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
            };
        }
        xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    });
}
$b36292f2972695f1$export$e7aa7bc5c1b3cfb3.polyfill = true;
if (!$b36292f2972695f1$var$g.fetch) {
    $b36292f2972695f1$var$g.fetch = $b36292f2972695f1$export$e7aa7bc5c1b3cfb3;
    $b36292f2972695f1$var$g.Headers = $b36292f2972695f1$export$79b704688b15c0f4;
    $b36292f2972695f1$var$g.Request = $b36292f2972695f1$export$7fa6c5b6f8193917;
    $b36292f2972695f1$var$g.Response = $b36292f2972695f1$export$9f633d56d7ec90d3;
}


const $70fc9a727fa662ae$var$container = document.getElementById("root");
const $70fc9a727fa662ae$var$root = (0, $7e96a608cb33bf79$exports.createRoot)($70fc9a727fa662ae$var$container);
$70fc9a727fa662ae$var$root.render(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $cd93687958c8007e$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=app.8d601d0a.js.map
